/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1211);
	module.exports = __webpack_require__(1815);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(263);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Affix", {
	  enumerable: true,
	  get: function get() {
	    return _affix["default"];
	  }
	});
	Object.defineProperty(exports, "Anchor", {
	  enumerable: true,
	  get: function get() {
	    return _anchor["default"];
	  }
	});
	Object.defineProperty(exports, "AutoComplete", {
	  enumerable: true,
	  get: function get() {
	    return _autoComplete["default"];
	  }
	});
	Object.defineProperty(exports, "Alert", {
	  enumerable: true,
	  get: function get() {
	    return _alert["default"];
	  }
	});
	Object.defineProperty(exports, "Avatar", {
	  enumerable: true,
	  get: function get() {
	    return _avatar["default"];
	  }
	});
	Object.defineProperty(exports, "BackTop", {
	  enumerable: true,
	  get: function get() {
	    return _backTop["default"];
	  }
	});
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _badge["default"];
	  }
	});
	Object.defineProperty(exports, "Breadcrumb", {
	  enumerable: true,
	  get: function get() {
	    return _breadcrumb["default"];
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _button["default"];
	  }
	});
	Object.defineProperty(exports, "Calendar", {
	  enumerable: true,
	  get: function get() {
	    return _calendar["default"];
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _card["default"];
	  }
	});
	Object.defineProperty(exports, "Collapse", {
	  enumerable: true,
	  get: function get() {
	    return _collapse["default"];
	  }
	});
	Object.defineProperty(exports, "Carousel", {
	  enumerable: true,
	  get: function get() {
	    return _carousel["default"];
	  }
	});
	Object.defineProperty(exports, "Cascader", {
	  enumerable: true,
	  get: function get() {
	    return _cascader["default"];
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _checkbox["default"];
	  }
	});
	Object.defineProperty(exports, "Col", {
	  enumerable: true,
	  get: function get() {
	    return _col["default"];
	  }
	});
	Object.defineProperty(exports, "Comment", {
	  enumerable: true,
	  get: function get() {
	    return _comment["default"];
	  }
	});
	Object.defineProperty(exports, "ConfigProvider", {
	  enumerable: true,
	  get: function get() {
	    return _configProvider["default"];
	  }
	});
	Object.defineProperty(exports, "DatePicker", {
	  enumerable: true,
	  get: function get() {
	    return _datePicker["default"];
	  }
	});
	Object.defineProperty(exports, "Descriptions", {
	  enumerable: true,
	  get: function get() {
	    return _descriptions["default"];
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _divider["default"];
	  }
	});
	Object.defineProperty(exports, "Dropdown", {
	  enumerable: true,
	  get: function get() {
	    return _dropdown["default"];
	  }
	});
	Object.defineProperty(exports, "Drawer", {
	  enumerable: true,
	  get: function get() {
	    return _drawer["default"];
	  }
	});
	Object.defineProperty(exports, "Empty", {
	  enumerable: true,
	  get: function get() {
	    return _empty["default"];
	  }
	});
	Object.defineProperty(exports, "Form", {
	  enumerable: true,
	  get: function get() {
	    return _form["default"];
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _icon["default"];
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _input["default"];
	  }
	});
	Object.defineProperty(exports, "InputNumber", {
	  enumerable: true,
	  get: function get() {
	    return _inputNumber["default"];
	  }
	});
	Object.defineProperty(exports, "Layout", {
	  enumerable: true,
	  get: function get() {
	    return _layout["default"];
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _list["default"];
	  }
	});
	Object.defineProperty(exports, "LocaleProvider", {
	  enumerable: true,
	  get: function get() {
	    return _localeProvider["default"];
	  }
	});
	Object.defineProperty(exports, "message", {
	  enumerable: true,
	  get: function get() {
	    return _message["default"];
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _menu["default"];
	  }
	});
	Object.defineProperty(exports, "Mentions", {
	  enumerable: true,
	  get: function get() {
	    return _mentions["default"];
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _modal["default"];
	  }
	});
	Object.defineProperty(exports, "Statistic", {
	  enumerable: true,
	  get: function get() {
	    return _statistic["default"];
	  }
	});
	Object.defineProperty(exports, "notification", {
	  enumerable: true,
	  get: function get() {
	    return _notification["default"];
	  }
	});
	Object.defineProperty(exports, "PageHeader", {
	  enumerable: true,
	  get: function get() {
	    return _pageHeader["default"];
	  }
	});
	Object.defineProperty(exports, "Pagination", {
	  enumerable: true,
	  get: function get() {
	    return _pagination["default"];
	  }
	});
	Object.defineProperty(exports, "Popconfirm", {
	  enumerable: true,
	  get: function get() {
	    return _popconfirm["default"];
	  }
	});
	Object.defineProperty(exports, "Popover", {
	  enumerable: true,
	  get: function get() {
	    return _popover["default"];
	  }
	});
	Object.defineProperty(exports, "Progress", {
	  enumerable: true,
	  get: function get() {
	    return _progress["default"];
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _radio["default"];
	  }
	});
	Object.defineProperty(exports, "Rate", {
	  enumerable: true,
	  get: function get() {
	    return _rate["default"];
	  }
	});
	Object.defineProperty(exports, "Result", {
	  enumerable: true,
	  get: function get() {
	    return _result["default"];
	  }
	});
	Object.defineProperty(exports, "Row", {
	  enumerable: true,
	  get: function get() {
	    return _row["default"];
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _select["default"];
	  }
	});
	Object.defineProperty(exports, "Skeleton", {
	  enumerable: true,
	  get: function get() {
	    return _skeleton["default"];
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _slider["default"];
	  }
	});
	Object.defineProperty(exports, "Spin", {
	  enumerable: true,
	  get: function get() {
	    return _spin["default"];
	  }
	});
	Object.defineProperty(exports, "Steps", {
	  enumerable: true,
	  get: function get() {
	    return _steps["default"];
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _switch["default"];
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _table["default"];
	  }
	});
	Object.defineProperty(exports, "Transfer", {
	  enumerable: true,
	  get: function get() {
	    return _transfer["default"];
	  }
	});
	Object.defineProperty(exports, "Tree", {
	  enumerable: true,
	  get: function get() {
	    return _tree["default"];
	  }
	});
	Object.defineProperty(exports, "TreeSelect", {
	  enumerable: true,
	  get: function get() {
	    return _treeSelect["default"];
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _tabs["default"];
	  }
	});
	Object.defineProperty(exports, "Tag", {
	  enumerable: true,
	  get: function get() {
	    return _tag["default"];
	  }
	});
	Object.defineProperty(exports, "TimePicker", {
	  enumerable: true,
	  get: function get() {
	    return _timePicker["default"];
	  }
	});
	Object.defineProperty(exports, "Timeline", {
	  enumerable: true,
	  get: function get() {
	    return _timeline["default"];
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _tooltip["default"];
	  }
	});
	Object.defineProperty(exports, "Typography", {
	  enumerable: true,
	  get: function get() {
	    return _typography["default"];
	  }
	});
	Object.defineProperty(exports, "Mention", {
	  enumerable: true,
	  get: function get() {
	    return _mention["default"];
	  }
	});
	Object.defineProperty(exports, "Upload", {
	  enumerable: true,
	  get: function get() {
	    return _upload["default"];
	  }
	});
	Object.defineProperty(exports, "version", {
	  enumerable: true,
	  get: function get() {
	    return _version["default"];
	  }
	});
	
	var _affix = _interopRequireDefault(__webpack_require__(617));
	
	var _anchor = _interopRequireDefault(__webpack_require__(1234));
	
	var _autoComplete = _interopRequireDefault(__webpack_require__(1236));
	
	var _alert = _interopRequireDefault(__webpack_require__(1231));
	
	var _avatar = _interopRequireDefault(__webpack_require__(618));
	
	var _backTop = _interopRequireDefault(__webpack_require__(1237));
	
	var _badge = _interopRequireDefault(__webpack_require__(1239));
	
	var _breadcrumb = _interopRequireDefault(__webpack_require__(620));
	
	var _button = _interopRequireDefault(__webpack_require__(189));
	
	var _calendar = _interopRequireDefault(__webpack_require__(1245));
	
	var _card = _interopRequireDefault(__webpack_require__(1249));
	
	var _collapse = _interopRequireDefault(__webpack_require__(1255));
	
	var _carousel = _interopRequireDefault(__webpack_require__(1250));
	
	var _cascader = _interopRequireDefault(__webpack_require__(1251));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(226));
	
	var _col = _interopRequireDefault(__webpack_require__(623));
	
	var _comment = _interopRequireDefault(__webpack_require__(1256));
	
	var _configProvider = _interopRequireDefault(__webpack_require__(11));
	
	var _datePicker = _interopRequireDefault(__webpack_require__(1261));
	
	var _descriptions = _interopRequireDefault(__webpack_require__(1264));
	
	var _divider = _interopRequireDefault(__webpack_require__(1265));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(407));
	
	var _drawer = _interopRequireDefault(__webpack_require__(1266));
	
	var _empty = _interopRequireDefault(__webpack_require__(627));
	
	var _form = _interopRequireDefault(__webpack_require__(1272));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _input = _interopRequireDefault(__webpack_require__(319));
	
	var _inputNumber = _interopRequireDefault(__webpack_require__(1276));
	
	var _layout = _interopRequireDefault(__webpack_require__(1282));
	
	var _list = _interopRequireDefault(__webpack_require__(1284));
	
	var _localeProvider = _interopRequireDefault(__webpack_require__(636));
	
	var _message = _interopRequireDefault(__webpack_require__(1292));
	
	var _menu = _interopRequireDefault(__webpack_require__(410));
	
	var _mentions = _interopRequireDefault(__webpack_require__(1289));
	
	var _modal = _interopRequireDefault(__webpack_require__(1295));
	
	var _statistic = _interopRequireDefault(__webpack_require__(1319));
	
	var _notification = _interopRequireDefault(__webpack_require__(1296));
	
	var _pageHeader = _interopRequireDefault(__webpack_require__(1297));
	
	var _pagination = _interopRequireDefault(__webpack_require__(412));
	
	var _popconfirm = _interopRequireDefault(__webpack_require__(1300));
	
	var _popover = _interopRequireDefault(__webpack_require__(1301));
	
	var _progress = _interopRequireDefault(__webpack_require__(638));
	
	var _radio = _interopRequireDefault(__webpack_require__(320));
	
	var _rate = _interopRequireDefault(__webpack_require__(1307));
	
	var _result = _interopRequireDefault(__webpack_require__(1308));
	
	var _row = _interopRequireDefault(__webpack_require__(639));
	
	var _select = _interopRequireDefault(__webpack_require__(270));
	
	var _skeleton = _interopRequireDefault(__webpack_require__(1315));
	
	var _slider = _interopRequireDefault(__webpack_require__(1316));
	
	var _spin = _interopRequireDefault(__webpack_require__(321));
	
	var _steps = _interopRequireDefault(__webpack_require__(1321));
	
	var _switch = _interopRequireDefault(__webpack_require__(1322));
	
	var _table = _interopRequireDefault(__webpack_require__(1332));
	
	var _transfer = _interopRequireDefault(__webpack_require__(1340));
	
	var _tree = _interopRequireDefault(__webpack_require__(1346));
	
	var _treeSelect = _interopRequireDefault(__webpack_require__(1344));
	
	var _tabs = _interopRequireDefault(__webpack_require__(642));
	
	var _tag = _interopRequireDefault(__webpack_require__(643));
	
	var _timePicker = _interopRequireDefault(__webpack_require__(644));
	
	var _timeline = _interopRequireDefault(__webpack_require__(1337));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(165));
	
	var _typography = _interopRequireDefault(__webpack_require__(1352));
	
	var _mention = _interopRequireDefault(__webpack_require__(1288));
	
	var _upload = _interopRequireDefault(__webpack_require__(1356));
	
	var _version = _interopRequireDefault(__webpack_require__(1357));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/* @remove-on-es-build-begin */
	// this file is not used if use https://github.com/ant-design/babel-plugin-import
	var ENV = ("production");
	
	if (ENV !== 'production' && ENV !== 'test' && typeof console !== 'undefined' && console.warn && // eslint-disable-line no-console
	typeof window !== 'undefined') {
	  // eslint-disable-next-line no-console
	  console.warn('You are using a whole package of antd, ' + 'please use https://www.npmjs.com/package/babel-plugin-import to reduce app bundle size.');
	}
	/* @remove-on-es-build-end */

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var require;/* WEBPACK VAR INJECTION */(function(module) {//! moment.js
	//! version : 2.29.4
	//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
	//! license : MIT
	//! momentjs.com
	
	;(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    global.moment = factory()
	}(this, (function () { 'use strict';
	
	    var hookCallback;
	
	    function hooks() {
	        return hookCallback.apply(null, arguments);
	    }
	
	    // This is done to register the method called with moment()
	    // without creating circular dependencies.
	    function setHookCallback(callback) {
	        hookCallback = callback;
	    }
	
	    function isArray(input) {
	        return (
	            input instanceof Array ||
	            Object.prototype.toString.call(input) === '[object Array]'
	        );
	    }
	
	    function isObject(input) {
	        // IE8 will treat undefined and null as object if it wasn't for
	        // input != null
	        return (
	            input != null &&
	            Object.prototype.toString.call(input) === '[object Object]'
	        );
	    }
	
	    function hasOwnProp(a, b) {
	        return Object.prototype.hasOwnProperty.call(a, b);
	    }
	
	    function isObjectEmpty(obj) {
	        if (Object.getOwnPropertyNames) {
	            return Object.getOwnPropertyNames(obj).length === 0;
	        } else {
	            var k;
	            for (k in obj) {
	                if (hasOwnProp(obj, k)) {
	                    return false;
	                }
	            }
	            return true;
	        }
	    }
	
	    function isUndefined(input) {
	        return input === void 0;
	    }
	
	    function isNumber(input) {
	        return (
	            typeof input === 'number' ||
	            Object.prototype.toString.call(input) === '[object Number]'
	        );
	    }
	
	    function isDate(input) {
	        return (
	            input instanceof Date ||
	            Object.prototype.toString.call(input) === '[object Date]'
	        );
	    }
	
	    function map(arr, fn) {
	        var res = [],
	            i,
	            arrLen = arr.length;
	        for (i = 0; i < arrLen; ++i) {
	            res.push(fn(arr[i], i));
	        }
	        return res;
	    }
	
	    function extend(a, b) {
	        for (var i in b) {
	            if (hasOwnProp(b, i)) {
	                a[i] = b[i];
	            }
	        }
	
	        if (hasOwnProp(b, 'toString')) {
	            a.toString = b.toString;
	        }
	
	        if (hasOwnProp(b, 'valueOf')) {
	            a.valueOf = b.valueOf;
	        }
	
	        return a;
	    }
	
	    function createUTC(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, true).utc();
	    }
	
	    function defaultParsingFlags() {
	        // We need to deep clone this object.
	        return {
	            empty: false,
	            unusedTokens: [],
	            unusedInput: [],
	            overflow: -2,
	            charsLeftOver: 0,
	            nullInput: false,
	            invalidEra: null,
	            invalidMonth: null,
	            invalidFormat: false,
	            userInvalidated: false,
	            iso: false,
	            parsedDateParts: [],
	            era: null,
	            meridiem: null,
	            rfc2822: false,
	            weekdayMismatch: false,
	        };
	    }
	
	    function getParsingFlags(m) {
	        if (m._pf == null) {
	            m._pf = defaultParsingFlags();
	        }
	        return m._pf;
	    }
	
	    var some;
	    if (Array.prototype.some) {
	        some = Array.prototype.some;
	    } else {
	        some = function (fun) {
	            var t = Object(this),
	                len = t.length >>> 0,
	                i;
	
	            for (i = 0; i < len; i++) {
	                if (i in t && fun.call(this, t[i], i, t)) {
	                    return true;
	                }
	            }
	
	            return false;
	        };
	    }
	
	    function isValid(m) {
	        if (m._isValid == null) {
	            var flags = getParsingFlags(m),
	                parsedParts = some.call(flags.parsedDateParts, function (i) {
	                    return i != null;
	                }),
	                isNowValid =
	                    !isNaN(m._d.getTime()) &&
	                    flags.overflow < 0 &&
	                    !flags.empty &&
	                    !flags.invalidEra &&
	                    !flags.invalidMonth &&
	                    !flags.invalidWeekday &&
	                    !flags.weekdayMismatch &&
	                    !flags.nullInput &&
	                    !flags.invalidFormat &&
	                    !flags.userInvalidated &&
	                    (!flags.meridiem || (flags.meridiem && parsedParts));
	
	            if (m._strict) {
	                isNowValid =
	                    isNowValid &&
	                    flags.charsLeftOver === 0 &&
	                    flags.unusedTokens.length === 0 &&
	                    flags.bigHour === undefined;
	            }
	
	            if (Object.isFrozen == null || !Object.isFrozen(m)) {
	                m._isValid = isNowValid;
	            } else {
	                return isNowValid;
	            }
	        }
	        return m._isValid;
	    }
	
	    function createInvalid(flags) {
	        var m = createUTC(NaN);
	        if (flags != null) {
	            extend(getParsingFlags(m), flags);
	        } else {
	            getParsingFlags(m).userInvalidated = true;
	        }
	
	        return m;
	    }
	
	    // Plugins that add properties should also add the key here (null value),
	    // so we can properly clone ourselves.
	    var momentProperties = (hooks.momentProperties = []),
	        updateInProgress = false;
	
	    function copyConfig(to, from) {
	        var i,
	            prop,
	            val,
	            momentPropertiesLen = momentProperties.length;
	
	        if (!isUndefined(from._isAMomentObject)) {
	            to._isAMomentObject = from._isAMomentObject;
	        }
	        if (!isUndefined(from._i)) {
	            to._i = from._i;
	        }
	        if (!isUndefined(from._f)) {
	            to._f = from._f;
	        }
	        if (!isUndefined(from._l)) {
	            to._l = from._l;
	        }
	        if (!isUndefined(from._strict)) {
	            to._strict = from._strict;
	        }
	        if (!isUndefined(from._tzm)) {
	            to._tzm = from._tzm;
	        }
	        if (!isUndefined(from._isUTC)) {
	            to._isUTC = from._isUTC;
	        }
	        if (!isUndefined(from._offset)) {
	            to._offset = from._offset;
	        }
	        if (!isUndefined(from._pf)) {
	            to._pf = getParsingFlags(from);
	        }
	        if (!isUndefined(from._locale)) {
	            to._locale = from._locale;
	        }
	
	        if (momentPropertiesLen > 0) {
	            for (i = 0; i < momentPropertiesLen; i++) {
	                prop = momentProperties[i];
	                val = from[prop];
	                if (!isUndefined(val)) {
	                    to[prop] = val;
	                }
	            }
	        }
	
	        return to;
	    }
	
	    // Moment prototype object
	    function Moment(config) {
	        copyConfig(this, config);
	        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
	        if (!this.isValid()) {
	            this._d = new Date(NaN);
	        }
	        // Prevent infinite loop in case updateOffset creates new moment
	        // objects.
	        if (updateInProgress === false) {
	            updateInProgress = true;
	            hooks.updateOffset(this);
	            updateInProgress = false;
	        }
	    }
	
	    function isMoment(obj) {
	        return (
	            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
	        );
	    }
	
	    function warn(msg) {
	        if (
	            hooks.suppressDeprecationWarnings === false &&
	            typeof console !== 'undefined' &&
	            console.warn
	        ) {
	            console.warn('Deprecation warning: ' + msg);
	        }
	    }
	
	    function deprecate(msg, fn) {
	        var firstTime = true;
	
	        return extend(function () {
	            if (hooks.deprecationHandler != null) {
	                hooks.deprecationHandler(null, msg);
	            }
	            if (firstTime) {
	                var args = [],
	                    arg,
	                    i,
	                    key,
	                    argLen = arguments.length;
	                for (i = 0; i < argLen; i++) {
	                    arg = '';
	                    if (typeof arguments[i] === 'object') {
	                        arg += '\n[' + i + '] ';
	                        for (key in arguments[0]) {
	                            if (hasOwnProp(arguments[0], key)) {
	                                arg += key + ': ' + arguments[0][key] + ', ';
	                            }
	                        }
	                        arg = arg.slice(0, -2); // Remove trailing comma and space
	                    } else {
	                        arg = arguments[i];
	                    }
	                    args.push(arg);
	                }
	                warn(
	                    msg +
	                        '\nArguments: ' +
	                        Array.prototype.slice.call(args).join('') +
	                        '\n' +
	                        new Error().stack
	                );
	                firstTime = false;
	            }
	            return fn.apply(this, arguments);
	        }, fn);
	    }
	
	    var deprecations = {};
	
	    function deprecateSimple(name, msg) {
	        if (hooks.deprecationHandler != null) {
	            hooks.deprecationHandler(name, msg);
	        }
	        if (!deprecations[name]) {
	            warn(msg);
	            deprecations[name] = true;
	        }
	    }
	
	    hooks.suppressDeprecationWarnings = false;
	    hooks.deprecationHandler = null;
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    function set(config) {
	        var prop, i;
	        for (i in config) {
	            if (hasOwnProp(config, i)) {
	                prop = config[i];
	                if (isFunction(prop)) {
	                    this[i] = prop;
	                } else {
	                    this['_' + i] = prop;
	                }
	            }
	        }
	        this._config = config;
	        // Lenient ordinal parsing accepts just a number in addition to
	        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        this._dayOfMonthOrdinalParseLenient = new RegExp(
	            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
	                '|' +
	                /\d{1,2}/.source
	        );
	    }
	
	    function mergeConfigs(parentConfig, childConfig) {
	        var res = extend({}, parentConfig),
	            prop;
	        for (prop in childConfig) {
	            if (hasOwnProp(childConfig, prop)) {
	                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
	                    res[prop] = {};
	                    extend(res[prop], parentConfig[prop]);
	                    extend(res[prop], childConfig[prop]);
	                } else if (childConfig[prop] != null) {
	                    res[prop] = childConfig[prop];
	                } else {
	                    delete res[prop];
	                }
	            }
	        }
	        for (prop in parentConfig) {
	            if (
	                hasOwnProp(parentConfig, prop) &&
	                !hasOwnProp(childConfig, prop) &&
	                isObject(parentConfig[prop])
	            ) {
	                // make sure changes to properties don't modify parent config
	                res[prop] = extend({}, res[prop]);
	            }
	        }
	        return res;
	    }
	
	    function Locale(config) {
	        if (config != null) {
	            this.set(config);
	        }
	    }
	
	    var keys;
	
	    if (Object.keys) {
	        keys = Object.keys;
	    } else {
	        keys = function (obj) {
	            var i,
	                res = [];
	            for (i in obj) {
	                if (hasOwnProp(obj, i)) {
	                    res.push(i);
	                }
	            }
	            return res;
	        };
	    }
	
	    var defaultCalendar = {
	        sameDay: '[Today at] LT',
	        nextDay: '[Tomorrow at] LT',
	        nextWeek: 'dddd [at] LT',
	        lastDay: '[Yesterday at] LT',
	        lastWeek: '[Last] dddd [at] LT',
	        sameElse: 'L',
	    };
	
	    function calendar(key, mom, now) {
	        var output = this._calendar[key] || this._calendar['sameElse'];
	        return isFunction(output) ? output.call(mom, now) : output;
	    }
	
	    function zeroFill(number, targetLength, forceSign) {
	        var absNumber = '' + Math.abs(number),
	            zerosToFill = targetLength - absNumber.length,
	            sign = number >= 0;
	        return (
	            (sign ? (forceSign ? '+' : '') : '-') +
	            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
	            absNumber
	        );
	    }
	
	    var formattingTokens =
	            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
	        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
	        formatFunctions = {},
	        formatTokenFunctions = {};
	
	    // token:    'M'
	    // padded:   ['MM', 2]
	    // ordinal:  'Mo'
	    // callback: function () { this.month() + 1 }
	    function addFormatToken(token, padded, ordinal, callback) {
	        var func = callback;
	        if (typeof callback === 'string') {
	            func = function () {
	                return this[callback]();
	            };
	        }
	        if (token) {
	            formatTokenFunctions[token] = func;
	        }
	        if (padded) {
	            formatTokenFunctions[padded[0]] = function () {
	                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
	            };
	        }
	        if (ordinal) {
	            formatTokenFunctions[ordinal] = function () {
	                return this.localeData().ordinal(
	                    func.apply(this, arguments),
	                    token
	                );
	            };
	        }
	    }
	
	    function removeFormattingTokens(input) {
	        if (input.match(/\[[\s\S]/)) {
	            return input.replace(/^\[|\]$/g, '');
	        }
	        return input.replace(/\\/g, '');
	    }
	
	    function makeFormatFunction(format) {
	        var array = format.match(formattingTokens),
	            i,
	            length;
	
	        for (i = 0, length = array.length; i < length; i++) {
	            if (formatTokenFunctions[array[i]]) {
	                array[i] = formatTokenFunctions[array[i]];
	            } else {
	                array[i] = removeFormattingTokens(array[i]);
	            }
	        }
	
	        return function (mom) {
	            var output = '',
	                i;
	            for (i = 0; i < length; i++) {
	                output += isFunction(array[i])
	                    ? array[i].call(mom, format)
	                    : array[i];
	            }
	            return output;
	        };
	    }
	
	    // format date using native date object
	    function formatMoment(m, format) {
	        if (!m.isValid()) {
	            return m.localeData().invalidDate();
	        }
	
	        format = expandFormat(format, m.localeData());
	        formatFunctions[format] =
	            formatFunctions[format] || makeFormatFunction(format);
	
	        return formatFunctions[format](m);
	    }
	
	    function expandFormat(format, locale) {
	        var i = 5;
	
	        function replaceLongDateFormatTokens(input) {
	            return locale.longDateFormat(input) || input;
	        }
	
	        localFormattingTokens.lastIndex = 0;
	        while (i >= 0 && localFormattingTokens.test(format)) {
	            format = format.replace(
	                localFormattingTokens,
	                replaceLongDateFormatTokens
	            );
	            localFormattingTokens.lastIndex = 0;
	            i -= 1;
	        }
	
	        return format;
	    }
	
	    var defaultLongDateFormat = {
	        LTS: 'h:mm:ss A',
	        LT: 'h:mm A',
	        L: 'MM/DD/YYYY',
	        LL: 'MMMM D, YYYY',
	        LLL: 'MMMM D, YYYY h:mm A',
	        LLLL: 'dddd, MMMM D, YYYY h:mm A',
	    };
	
	    function longDateFormat(key) {
	        var format = this._longDateFormat[key],
	            formatUpper = this._longDateFormat[key.toUpperCase()];
	
	        if (format || !formatUpper) {
	            return format;
	        }
	
	        this._longDateFormat[key] = formatUpper
	            .match(formattingTokens)
	            .map(function (tok) {
	                if (
	                    tok === 'MMMM' ||
	                    tok === 'MM' ||
	                    tok === 'DD' ||
	                    tok === 'dddd'
	                ) {
	                    return tok.slice(1);
	                }
	                return tok;
	            })
	            .join('');
	
	        return this._longDateFormat[key];
	    }
	
	    var defaultInvalidDate = 'Invalid date';
	
	    function invalidDate() {
	        return this._invalidDate;
	    }
	
	    var defaultOrdinal = '%d',
	        defaultDayOfMonthOrdinalParse = /\d{1,2}/;
	
	    function ordinal(number) {
	        return this._ordinal.replace('%d', number);
	    }
	
	    var defaultRelativeTime = {
	        future: 'in %s',
	        past: '%s ago',
	        s: 'a few seconds',
	        ss: '%d seconds',
	        m: 'a minute',
	        mm: '%d minutes',
	        h: 'an hour',
	        hh: '%d hours',
	        d: 'a day',
	        dd: '%d days',
	        w: 'a week',
	        ww: '%d weeks',
	        M: 'a month',
	        MM: '%d months',
	        y: 'a year',
	        yy: '%d years',
	    };
	
	    function relativeTime(number, withoutSuffix, string, isFuture) {
	        var output = this._relativeTime[string];
	        return isFunction(output)
	            ? output(number, withoutSuffix, string, isFuture)
	            : output.replace(/%d/i, number);
	    }
	
	    function pastFuture(diff, output) {
	        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
	        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
	    }
	
	    var aliases = {};
	
	    function addUnitAlias(unit, shorthand) {
	        var lowerCase = unit.toLowerCase();
	        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
	    }
	
	    function normalizeUnits(units) {
	        return typeof units === 'string'
	            ? aliases[units] || aliases[units.toLowerCase()]
	            : undefined;
	    }
	
	    function normalizeObjectUnits(inputObject) {
	        var normalizedInput = {},
	            normalizedProp,
	            prop;
	
	        for (prop in inputObject) {
	            if (hasOwnProp(inputObject, prop)) {
	                normalizedProp = normalizeUnits(prop);
	                if (normalizedProp) {
	                    normalizedInput[normalizedProp] = inputObject[prop];
	                }
	            }
	        }
	
	        return normalizedInput;
	    }
	
	    var priorities = {};
	
	    function addUnitPriority(unit, priority) {
	        priorities[unit] = priority;
	    }
	
	    function getPrioritizedUnits(unitsObj) {
	        var units = [],
	            u;
	        for (u in unitsObj) {
	            if (hasOwnProp(unitsObj, u)) {
	                units.push({ unit: u, priority: priorities[u] });
	            }
	        }
	        units.sort(function (a, b) {
	            return a.priority - b.priority;
	        });
	        return units;
	    }
	
	    function isLeapYear(year) {
	        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
	    }
	
	    function absFloor(number) {
	        if (number < 0) {
	            // -0 -> 0
	            return Math.ceil(number) || 0;
	        } else {
	            return Math.floor(number);
	        }
	    }
	
	    function toInt(argumentForCoercion) {
	        var coercedNumber = +argumentForCoercion,
	            value = 0;
	
	        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
	            value = absFloor(coercedNumber);
	        }
	
	        return value;
	    }
	
	    function makeGetSet(unit, keepTime) {
	        return function (value) {
	            if (value != null) {
	                set$1(this, unit, value);
	                hooks.updateOffset(this, keepTime);
	                return this;
	            } else {
	                return get(this, unit);
	            }
	        };
	    }
	
	    function get(mom, unit) {
	        return mom.isValid()
	            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
	            : NaN;
	    }
	
	    function set$1(mom, unit, value) {
	        if (mom.isValid() && !isNaN(value)) {
	            if (
	                unit === 'FullYear' &&
	                isLeapYear(mom.year()) &&
	                mom.month() === 1 &&
	                mom.date() === 29
	            ) {
	                value = toInt(value);
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
	                    value,
	                    mom.month(),
	                    daysInMonth(value, mom.month())
	                );
	            } else {
	                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function stringGet(units) {
	        units = normalizeUnits(units);
	        if (isFunction(this[units])) {
	            return this[units]();
	        }
	        return this;
	    }
	
	    function stringSet(units, value) {
	        if (typeof units === 'object') {
	            units = normalizeObjectUnits(units);
	            var prioritized = getPrioritizedUnits(units),
	                i,
	                prioritizedLen = prioritized.length;
	            for (i = 0; i < prioritizedLen; i++) {
	                this[prioritized[i].unit](units[prioritized[i].unit]);
	            }
	        } else {
	            units = normalizeUnits(units);
	            if (isFunction(this[units])) {
	                return this[units](value);
	            }
	        }
	        return this;
	    }
	
	    var match1 = /\d/, //       0 - 9
	        match2 = /\d\d/, //      00 - 99
	        match3 = /\d{3}/, //     000 - 999
	        match4 = /\d{4}/, //    0000 - 9999
	        match6 = /[+-]?\d{6}/, // -999999 - 999999
	        match1to2 = /\d\d?/, //       0 - 99
	        match3to4 = /\d\d\d\d?/, //     999 - 9999
	        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
	        match1to3 = /\d{1,3}/, //       0 - 999
	        match1to4 = /\d{1,4}/, //       0 - 9999
	        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
	        matchUnsigned = /\d+/, //       0 - inf
	        matchSigned = /[+-]?\d+/, //    -inf - inf
	        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
	        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
	        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
	        // any word (or two) characters or numbers including two/three word month in arabic.
	        // includes scottish gaelic two word and hyphenated months
	        matchWord =
	            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
	        regexes;
	
	    regexes = {};
	
	    function addRegexToken(token, regex, strictRegex) {
	        regexes[token] = isFunction(regex)
	            ? regex
	            : function (isStrict, localeData) {
	                  return isStrict && strictRegex ? strictRegex : regex;
	              };
	    }
	
	    function getParseRegexForToken(token, config) {
	        if (!hasOwnProp(regexes, token)) {
	            return new RegExp(unescapeFormat(token));
	        }
	
	        return regexes[token](config._strict, config._locale);
	    }
	
	    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
	    function unescapeFormat(s) {
	        return regexEscape(
	            s
	                .replace('\\', '')
	                .replace(
	                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
	                    function (matched, p1, p2, p3, p4) {
	                        return p1 || p2 || p3 || p4;
	                    }
	                )
	        );
	    }
	
	    function regexEscape(s) {
	        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
	    }
	
	    var tokens = {};
	
	    function addParseToken(token, callback) {
	        var i,
	            func = callback,
	            tokenLen;
	        if (typeof token === 'string') {
	            token = [token];
	        }
	        if (isNumber(callback)) {
	            func = function (input, array) {
	                array[callback] = toInt(input);
	            };
	        }
	        tokenLen = token.length;
	        for (i = 0; i < tokenLen; i++) {
	            tokens[token[i]] = func;
	        }
	    }
	
	    function addWeekParseToken(token, callback) {
	        addParseToken(token, function (input, array, config, token) {
	            config._w = config._w || {};
	            callback(input, config._w, config, token);
	        });
	    }
	
	    function addTimeToArrayFromToken(token, input, config) {
	        if (input != null && hasOwnProp(tokens, token)) {
	            tokens[token](input, config._a, config, token);
	        }
	    }
	
	    var YEAR = 0,
	        MONTH = 1,
	        DATE = 2,
	        HOUR = 3,
	        MINUTE = 4,
	        SECOND = 5,
	        MILLISECOND = 6,
	        WEEK = 7,
	        WEEKDAY = 8;
	
	    function mod(n, x) {
	        return ((n % x) + x) % x;
	    }
	
	    var indexOf;
	
	    if (Array.prototype.indexOf) {
	        indexOf = Array.prototype.indexOf;
	    } else {
	        indexOf = function (o) {
	            // I know
	            var i;
	            for (i = 0; i < this.length; ++i) {
	                if (this[i] === o) {
	                    return i;
	                }
	            }
	            return -1;
	        };
	    }
	
	    function daysInMonth(year, month) {
	        if (isNaN(year) || isNaN(month)) {
	            return NaN;
	        }
	        var modMonth = mod(month, 12);
	        year += (month - modMonth) / 12;
	        return modMonth === 1
	            ? isLeapYear(year)
	                ? 29
	                : 28
	            : 31 - ((modMonth % 7) % 2);
	    }
	
	    // FORMATTING
	
	    addFormatToken('M', ['MM', 2], 'Mo', function () {
	        return this.month() + 1;
	    });
	
	    addFormatToken('MMM', 0, 0, function (format) {
	        return this.localeData().monthsShort(this, format);
	    });
	
	    addFormatToken('MMMM', 0, 0, function (format) {
	        return this.localeData().months(this, format);
	    });
	
	    // ALIASES
	
	    addUnitAlias('month', 'M');
	
	    // PRIORITY
	
	    addUnitPriority('month', 8);
	
	    // PARSING
	
	    addRegexToken('M', match1to2);
	    addRegexToken('MM', match1to2, match2);
	    addRegexToken('MMM', function (isStrict, locale) {
	        return locale.monthsShortRegex(isStrict);
	    });
	    addRegexToken('MMMM', function (isStrict, locale) {
	        return locale.monthsRegex(isStrict);
	    });
	
	    addParseToken(['M', 'MM'], function (input, array) {
	        array[MONTH] = toInt(input) - 1;
	    });
	
	    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
	        var month = config._locale.monthsParse(input, token, config._strict);
	        // if we didn't find a month name, mark the date as invalid.
	        if (month != null) {
	            array[MONTH] = month;
	        } else {
	            getParsingFlags(config).invalidMonth = input;
	        }
	    });
	
	    // LOCALES
	
	    var defaultLocaleMonths =
	            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	                '_'
	            ),
	        defaultLocaleMonthsShort =
	            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
	        defaultMonthsShortRegex = matchWord,
	        defaultMonthsRegex = matchWord;
	
	    function localeMonths(m, format) {
	        if (!m) {
	            return isArray(this._months)
	                ? this._months
	                : this._months['standalone'];
	        }
	        return isArray(this._months)
	            ? this._months[m.month()]
	            : this._months[
	                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
	                      ? 'format'
	                      : 'standalone'
	              ][m.month()];
	    }
	
	    function localeMonthsShort(m, format) {
	        if (!m) {
	            return isArray(this._monthsShort)
	                ? this._monthsShort
	                : this._monthsShort['standalone'];
	        }
	        return isArray(this._monthsShort)
	            ? this._monthsShort[m.month()]
	            : this._monthsShort[
	                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
	              ][m.month()];
	    }
	
	    function handleStrictParse(monthName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = monthName.toLocaleLowerCase();
	        if (!this._monthsParse) {
	            // this is not used
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	            for (i = 0; i < 12; ++i) {
	                mom = createUTC([2000, i]);
	                this._shortMonthsParse[i] = this.monthsShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'MMM') {
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._longMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._longMonthsParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortMonthsParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeMonthsParse(monthName, format, strict) {
	        var i, mom, regex;
	
	        if (this._monthsParseExact) {
	            return handleStrictParse.call(this, monthName, format, strict);
	        }
	
	        if (!this._monthsParse) {
	            this._monthsParse = [];
	            this._longMonthsParse = [];
	            this._shortMonthsParse = [];
	        }
	
	        // TODO: add sorting
	        // Sorting makes sure if one month (or abbr) is a prefix of another
	        // see sorting in computeMonthsParse
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            if (strict && !this._longMonthsParse[i]) {
	                this._longMonthsParse[i] = new RegExp(
	                    '^' + this.months(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	                this._shortMonthsParse[i] = new RegExp(
	                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
	                    'i'
	                );
	            }
	            if (!strict && !this._monthsParse[i]) {
	                regex =
	                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
	                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'MMMM' &&
	                this._longMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'MMM' &&
	                this._shortMonthsParse[i].test(monthName)
	            ) {
	                return i;
	            } else if (!strict && this._monthsParse[i].test(monthName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function setMonth(mom, value) {
	        var dayOfMonth;
	
	        if (!mom.isValid()) {
	            // No op
	            return mom;
	        }
	
	        if (typeof value === 'string') {
	            if (/^\d+$/.test(value)) {
	                value = toInt(value);
	            } else {
	                value = mom.localeData().monthsParse(value);
	                // TODO: Another silent failure?
	                if (!isNumber(value)) {
	                    return mom;
	                }
	            }
	        }
	
	        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
	        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
	        return mom;
	    }
	
	    function getSetMonth(value) {
	        if (value != null) {
	            setMonth(this, value);
	            hooks.updateOffset(this, true);
	            return this;
	        } else {
	            return get(this, 'Month');
	        }
	    }
	
	    function getDaysInMonth() {
	        return daysInMonth(this.year(), this.month());
	    }
	
	    function monthsShortRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsShortStrictRegex;
	            } else {
	                return this._monthsShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsShortRegex')) {
	                this._monthsShortRegex = defaultMonthsShortRegex;
	            }
	            return this._monthsShortStrictRegex && isStrict
	                ? this._monthsShortStrictRegex
	                : this._monthsShortRegex;
	        }
	    }
	
	    function monthsRegex(isStrict) {
	        if (this._monthsParseExact) {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                computeMonthsParse.call(this);
	            }
	            if (isStrict) {
	                return this._monthsStrictRegex;
	            } else {
	                return this._monthsRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_monthsRegex')) {
	                this._monthsRegex = defaultMonthsRegex;
	            }
	            return this._monthsStrictRegex && isStrict
	                ? this._monthsStrictRegex
	                : this._monthsRegex;
	        }
	    }
	
	    function computeMonthsParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom;
	        for (i = 0; i < 12; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, i]);
	            shortPieces.push(this.monthsShort(mom, ''));
	            longPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.months(mom, ''));
	            mixedPieces.push(this.monthsShort(mom, ''));
	        }
	        // Sorting makes sure if one month (or abbr) is a prefix of another it
	        // will match the longer piece.
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	        for (i = 0; i < 12; i++) {
	            shortPieces[i] = regexEscape(shortPieces[i]);
	            longPieces[i] = regexEscape(longPieces[i]);
	        }
	        for (i = 0; i < 24; i++) {
	            mixedPieces[i] = regexEscape(mixedPieces[i]);
	        }
	
	        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._monthsShortRegex = this._monthsRegex;
	        this._monthsStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._monthsShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken('Y', 0, 0, function () {
	        var y = this.year();
	        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
	    });
	
	    addFormatToken(0, ['YY', 2], 0, function () {
	        return this.year() % 100;
	    });
	
	    addFormatToken(0, ['YYYY', 4], 0, 'year');
	    addFormatToken(0, ['YYYYY', 5], 0, 'year');
	    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');
	
	    // ALIASES
	
	    addUnitAlias('year', 'y');
	
	    // PRIORITIES
	
	    addUnitPriority('year', 1);
	
	    // PARSING
	
	    addRegexToken('Y', matchSigned);
	    addRegexToken('YY', match1to2, match2);
	    addRegexToken('YYYY', match1to4, match4);
	    addRegexToken('YYYYY', match1to6, match6);
	    addRegexToken('YYYYYY', match1to6, match6);
	
	    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
	    addParseToken('YYYY', function (input, array) {
	        array[YEAR] =
	            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
	    });
	    addParseToken('YY', function (input, array) {
	        array[YEAR] = hooks.parseTwoDigitYear(input);
	    });
	    addParseToken('Y', function (input, array) {
	        array[YEAR] = parseInt(input, 10);
	    });
	
	    // HELPERS
	
	    function daysInYear(year) {
	        return isLeapYear(year) ? 366 : 365;
	    }
	
	    // HOOKS
	
	    hooks.parseTwoDigitYear = function (input) {
	        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
	    };
	
	    // MOMENTS
	
	    var getSetYear = makeGetSet('FullYear', true);
	
	    function getIsLeapYear() {
	        return isLeapYear(this.year());
	    }
	
	    function createDate(y, m, d, h, M, s, ms) {
	        // can't just apply() to create a date:
	        // https://stackoverflow.com/q/181348
	        var date;
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            date = new Date(y + 400, m, d, h, M, s, ms);
	            if (isFinite(date.getFullYear())) {
	                date.setFullYear(y);
	            }
	        } else {
	            date = new Date(y, m, d, h, M, s, ms);
	        }
	
	        return date;
	    }
	
	    function createUTCDate(y) {
	        var date, args;
	        // the Date.UTC function remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            args = Array.prototype.slice.call(arguments);
	            // preserve leap years using a full 400 year cycle, then reset
	            args[0] = y + 400;
	            date = new Date(Date.UTC.apply(null, args));
	            if (isFinite(date.getUTCFullYear())) {
	                date.setUTCFullYear(y);
	            }
	        } else {
	            date = new Date(Date.UTC.apply(null, arguments));
	        }
	
	        return date;
	    }
	
	    // start-of-first-week - start-of-year
	    function firstWeekOffset(year, dow, doy) {
	        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
	            fwd = 7 + dow - doy,
	            // first-week day local weekday -- which local weekday is fwd
	            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
	
	        return -fwdlw + fwd - 1;
	    }
	
	    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
	    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
	        var localWeekday = (7 + weekday - dow) % 7,
	            weekOffset = firstWeekOffset(year, dow, doy),
	            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
	            resYear,
	            resDayOfYear;
	
	        if (dayOfYear <= 0) {
	            resYear = year - 1;
	            resDayOfYear = daysInYear(resYear) + dayOfYear;
	        } else if (dayOfYear > daysInYear(year)) {
	            resYear = year + 1;
	            resDayOfYear = dayOfYear - daysInYear(year);
	        } else {
	            resYear = year;
	            resDayOfYear = dayOfYear;
	        }
	
	        return {
	            year: resYear,
	            dayOfYear: resDayOfYear,
	        };
	    }
	
	    function weekOfYear(mom, dow, doy) {
	        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
	            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
	            resWeek,
	            resYear;
	
	        if (week < 1) {
	            resYear = mom.year() - 1;
	            resWeek = week + weeksInYear(resYear, dow, doy);
	        } else if (week > weeksInYear(mom.year(), dow, doy)) {
	            resWeek = week - weeksInYear(mom.year(), dow, doy);
	            resYear = mom.year() + 1;
	        } else {
	            resYear = mom.year();
	            resWeek = week;
	        }
	
	        return {
	            week: resWeek,
	            year: resYear,
	        };
	    }
	
	    function weeksInYear(year, dow, doy) {
	        var weekOffset = firstWeekOffset(year, dow, doy),
	            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
	        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
	    }
	
	    // FORMATTING
	
	    addFormatToken('w', ['ww', 2], 'wo', 'week');
	    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');
	
	    // ALIASES
	
	    addUnitAlias('week', 'w');
	    addUnitAlias('isoWeek', 'W');
	
	    // PRIORITIES
	
	    addUnitPriority('week', 5);
	    addUnitPriority('isoWeek', 5);
	
	    // PARSING
	
	    addRegexToken('w', match1to2);
	    addRegexToken('ww', match1to2, match2);
	    addRegexToken('W', match1to2);
	    addRegexToken('WW', match1to2, match2);
	
	    addWeekParseToken(
	        ['w', 'ww', 'W', 'WW'],
	        function (input, week, config, token) {
	            week[token.substr(0, 1)] = toInt(input);
	        }
	    );
	
	    // HELPERS
	
	    // LOCALES
	
	    function localeWeek(mom) {
	        return weekOfYear(mom, this._week.dow, this._week.doy).week;
	    }
	
	    var defaultLocaleWeek = {
	        dow: 0, // Sunday is the first day of the week.
	        doy: 6, // The week that contains Jan 6th is the first week of the year.
	    };
	
	    function localeFirstDayOfWeek() {
	        return this._week.dow;
	    }
	
	    function localeFirstDayOfYear() {
	        return this._week.doy;
	    }
	
	    // MOMENTS
	
	    function getSetWeek(input) {
	        var week = this.localeData().week(this);
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    function getSetISOWeek(input) {
	        var week = weekOfYear(this, 1, 4).week;
	        return input == null ? week : this.add((input - week) * 7, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('d', 0, 'do', 'day');
	
	    addFormatToken('dd', 0, 0, function (format) {
	        return this.localeData().weekdaysMin(this, format);
	    });
	
	    addFormatToken('ddd', 0, 0, function (format) {
	        return this.localeData().weekdaysShort(this, format);
	    });
	
	    addFormatToken('dddd', 0, 0, function (format) {
	        return this.localeData().weekdays(this, format);
	    });
	
	    addFormatToken('e', 0, 0, 'weekday');
	    addFormatToken('E', 0, 0, 'isoWeekday');
	
	    // ALIASES
	
	    addUnitAlias('day', 'd');
	    addUnitAlias('weekday', 'e');
	    addUnitAlias('isoWeekday', 'E');
	
	    // PRIORITY
	    addUnitPriority('day', 11);
	    addUnitPriority('weekday', 11);
	    addUnitPriority('isoWeekday', 11);
	
	    // PARSING
	
	    addRegexToken('d', match1to2);
	    addRegexToken('e', match1to2);
	    addRegexToken('E', match1to2);
	    addRegexToken('dd', function (isStrict, locale) {
	        return locale.weekdaysMinRegex(isStrict);
	    });
	    addRegexToken('ddd', function (isStrict, locale) {
	        return locale.weekdaysShortRegex(isStrict);
	    });
	    addRegexToken('dddd', function (isStrict, locale) {
	        return locale.weekdaysRegex(isStrict);
	    });
	
	    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
	        var weekday = config._locale.weekdaysParse(input, token, config._strict);
	        // if we didn't get a weekday name, mark the date as invalid
	        if (weekday != null) {
	            week.d = weekday;
	        } else {
	            getParsingFlags(config).invalidWeekday = input;
	        }
	    });
	
	    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
	        week[token] = toInt(input);
	    });
	
	    // HELPERS
	
	    function parseWeekday(input, locale) {
	        if (typeof input !== 'string') {
	            return input;
	        }
	
	        if (!isNaN(input)) {
	            return parseInt(input, 10);
	        }
	
	        input = locale.weekdaysParse(input);
	        if (typeof input === 'number') {
	            return input;
	        }
	
	        return null;
	    }
	
	    function parseIsoWeekday(input, locale) {
	        if (typeof input === 'string') {
	            return locale.weekdaysParse(input) % 7 || 7;
	        }
	        return isNaN(input) ? null : input;
	    }
	
	    // LOCALES
	    function shiftWeekdays(ws, n) {
	        return ws.slice(n, 7).concat(ws.slice(0, n));
	    }
	
	    var defaultLocaleWeekdays =
	            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
	        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        defaultWeekdaysRegex = matchWord,
	        defaultWeekdaysShortRegex = matchWord,
	        defaultWeekdaysMinRegex = matchWord;
	
	    function localeWeekdays(m, format) {
	        var weekdays = isArray(this._weekdays)
	            ? this._weekdays
	            : this._weekdays[
	                  m && m !== true && this._weekdays.isFormat.test(format)
	                      ? 'format'
	                      : 'standalone'
	              ];
	        return m === true
	            ? shiftWeekdays(weekdays, this._week.dow)
	            : m
	            ? weekdays[m.day()]
	            : weekdays;
	    }
	
	    function localeWeekdaysShort(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
	            : m
	            ? this._weekdaysShort[m.day()]
	            : this._weekdaysShort;
	    }
	
	    function localeWeekdaysMin(m) {
	        return m === true
	            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
	            : m
	            ? this._weekdaysMin[m.day()]
	            : this._weekdaysMin;
	    }
	
	    function handleStrictParse$1(weekdayName, format, strict) {
	        var i,
	            ii,
	            mom,
	            llc = weekdayName.toLocaleLowerCase();
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._minWeekdaysParse = [];
	
	            for (i = 0; i < 7; ++i) {
	                mom = createUTC([2000, 1]).day(i);
	                this._minWeekdaysParse[i] = this.weekdaysMin(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._shortWeekdaysParse[i] = this.weekdaysShort(
	                    mom,
	                    ''
	                ).toLocaleLowerCase();
	                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
	            }
	        }
	
	        if (strict) {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        } else {
	            if (format === 'dddd') {
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else if (format === 'ddd') {
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            } else {
	                ii = indexOf.call(this._minWeekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._weekdaysParse, llc);
	                if (ii !== -1) {
	                    return ii;
	                }
	                ii = indexOf.call(this._shortWeekdaysParse, llc);
	                return ii !== -1 ? ii : null;
	            }
	        }
	    }
	
	    function localeWeekdaysParse(weekdayName, format, strict) {
	        var i, mom, regex;
	
	        if (this._weekdaysParseExact) {
	            return handleStrictParse$1.call(this, weekdayName, format, strict);
	        }
	
	        if (!this._weekdaysParse) {
	            this._weekdaysParse = [];
	            this._minWeekdaysParse = [];
	            this._shortWeekdaysParse = [];
	            this._fullWeekdaysParse = [];
	        }
	
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	
	            mom = createUTC([2000, 1]).day(i);
	            if (strict && !this._fullWeekdaysParse[i]) {
	                this._fullWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._shortWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	                this._minWeekdaysParse[i] = new RegExp(
	                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
	                    'i'
	                );
	            }
	            if (!this._weekdaysParse[i]) {
	                regex =
	                    '^' +
	                    this.weekdays(mom, '') +
	                    '|^' +
	                    this.weekdaysShort(mom, '') +
	                    '|^' +
	                    this.weekdaysMin(mom, '');
	                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
	            }
	            // test the regex
	            if (
	                strict &&
	                format === 'dddd' &&
	                this._fullWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'ddd' &&
	                this._shortWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (
	                strict &&
	                format === 'dd' &&
	                this._minWeekdaysParse[i].test(weekdayName)
	            ) {
	                return i;
	            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
	                return i;
	            }
	        }
	    }
	
	    // MOMENTS
	
	    function getSetDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
	        if (input != null) {
	            input = parseWeekday(input, this.localeData());
	            return this.add(input - day, 'd');
	        } else {
	            return day;
	        }
	    }
	
	    function getSetLocaleDayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
	        return input == null ? weekday : this.add(input - weekday, 'd');
	    }
	
	    function getSetISODayOfWeek(input) {
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	
	        // behaves the same as moment#day except
	        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
	        // as a setter, sunday should belong to the previous week.
	
	        if (input != null) {
	            var weekday = parseIsoWeekday(input, this.localeData());
	            return this.day(this.day() % 7 ? weekday : weekday - 7);
	        } else {
	            return this.day() || 7;
	        }
	    }
	
	    function weekdaysRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysStrictRegex;
	            } else {
	                return this._weekdaysRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                this._weekdaysRegex = defaultWeekdaysRegex;
	            }
	            return this._weekdaysStrictRegex && isStrict
	                ? this._weekdaysStrictRegex
	                : this._weekdaysRegex;
	        }
	    }
	
	    function weekdaysShortRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysShortStrictRegex;
	            } else {
	                return this._weekdaysShortRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
	                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
	            }
	            return this._weekdaysShortStrictRegex && isStrict
	                ? this._weekdaysShortStrictRegex
	                : this._weekdaysShortRegex;
	        }
	    }
	
	    function weekdaysMinRegex(isStrict) {
	        if (this._weekdaysParseExact) {
	            if (!hasOwnProp(this, '_weekdaysRegex')) {
	                computeWeekdaysParse.call(this);
	            }
	            if (isStrict) {
	                return this._weekdaysMinStrictRegex;
	            } else {
	                return this._weekdaysMinRegex;
	            }
	        } else {
	            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
	                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
	            }
	            return this._weekdaysMinStrictRegex && isStrict
	                ? this._weekdaysMinStrictRegex
	                : this._weekdaysMinRegex;
	        }
	    }
	
	    function computeWeekdaysParse() {
	        function cmpLenRev(a, b) {
	            return b.length - a.length;
	        }
	
	        var minPieces = [],
	            shortPieces = [],
	            longPieces = [],
	            mixedPieces = [],
	            i,
	            mom,
	            minp,
	            shortp,
	            longp;
	        for (i = 0; i < 7; i++) {
	            // make the regex if we don't have it already
	            mom = createUTC([2000, 1]).day(i);
	            minp = regexEscape(this.weekdaysMin(mom, ''));
	            shortp = regexEscape(this.weekdaysShort(mom, ''));
	            longp = regexEscape(this.weekdays(mom, ''));
	            minPieces.push(minp);
	            shortPieces.push(shortp);
	            longPieces.push(longp);
	            mixedPieces.push(minp);
	            mixedPieces.push(shortp);
	            mixedPieces.push(longp);
	        }
	        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
	        // will match the longer piece.
	        minPieces.sort(cmpLenRev);
	        shortPieces.sort(cmpLenRev);
	        longPieces.sort(cmpLenRev);
	        mixedPieces.sort(cmpLenRev);
	
	        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._weekdaysShortRegex = this._weekdaysRegex;
	        this._weekdaysMinRegex = this._weekdaysRegex;
	
	        this._weekdaysStrictRegex = new RegExp(
	            '^(' + longPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysShortStrictRegex = new RegExp(
	            '^(' + shortPieces.join('|') + ')',
	            'i'
	        );
	        this._weekdaysMinStrictRegex = new RegExp(
	            '^(' + minPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    function hFormat() {
	        return this.hours() % 12 || 12;
	    }
	
	    function kFormat() {
	        return this.hours() || 24;
	    }
	
	    addFormatToken('H', ['HH', 2], 0, 'hour');
	    addFormatToken('h', ['hh', 2], 0, hFormat);
	    addFormatToken('k', ['kk', 2], 0, kFormat);
	
	    addFormatToken('hmm', 0, 0, function () {
	        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('hmmss', 0, 0, function () {
	        return (
	            '' +
	            hFormat.apply(this) +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    addFormatToken('Hmm', 0, 0, function () {
	        return '' + this.hours() + zeroFill(this.minutes(), 2);
	    });
	
	    addFormatToken('Hmmss', 0, 0, function () {
	        return (
	            '' +
	            this.hours() +
	            zeroFill(this.minutes(), 2) +
	            zeroFill(this.seconds(), 2)
	        );
	    });
	
	    function meridiem(token, lowercase) {
	        addFormatToken(token, 0, 0, function () {
	            return this.localeData().meridiem(
	                this.hours(),
	                this.minutes(),
	                lowercase
	            );
	        });
	    }
	
	    meridiem('a', true);
	    meridiem('A', false);
	
	    // ALIASES
	
	    addUnitAlias('hour', 'h');
	
	    // PRIORITY
	    addUnitPriority('hour', 13);
	
	    // PARSING
	
	    function matchMeridiem(isStrict, locale) {
	        return locale._meridiemParse;
	    }
	
	    addRegexToken('a', matchMeridiem);
	    addRegexToken('A', matchMeridiem);
	    addRegexToken('H', match1to2);
	    addRegexToken('h', match1to2);
	    addRegexToken('k', match1to2);
	    addRegexToken('HH', match1to2, match2);
	    addRegexToken('hh', match1to2, match2);
	    addRegexToken('kk', match1to2, match2);
	
	    addRegexToken('hmm', match3to4);
	    addRegexToken('hmmss', match5to6);
	    addRegexToken('Hmm', match3to4);
	    addRegexToken('Hmmss', match5to6);
	
	    addParseToken(['H', 'HH'], HOUR);
	    addParseToken(['k', 'kk'], function (input, array, config) {
	        var kInput = toInt(input);
	        array[HOUR] = kInput === 24 ? 0 : kInput;
	    });
	    addParseToken(['a', 'A'], function (input, array, config) {
	        config._isPm = config._locale.isPM(input);
	        config._meridiem = input;
	    });
	    addParseToken(['h', 'hh'], function (input, array, config) {
	        array[HOUR] = toInt(input);
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	        getParsingFlags(config).bigHour = true;
	    });
	    addParseToken('Hmm', function (input, array, config) {
	        var pos = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos));
	        array[MINUTE] = toInt(input.substr(pos));
	    });
	    addParseToken('Hmmss', function (input, array, config) {
	        var pos1 = input.length - 4,
	            pos2 = input.length - 2;
	        array[HOUR] = toInt(input.substr(0, pos1));
	        array[MINUTE] = toInt(input.substr(pos1, 2));
	        array[SECOND] = toInt(input.substr(pos2));
	    });
	
	    // LOCALES
	
	    function localeIsPM(input) {
	        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
	        // Using charAt should be more compatible.
	        return (input + '').toLowerCase().charAt(0) === 'p';
	    }
	
	    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
	        // Setting the hour should keep the time, because the user explicitly
	        // specified which hour they want. So trying to maintain the same hour (in
	        // a new timezone) makes sense. Adding/subtracting hours does not follow
	        // this rule.
	        getSetHour = makeGetSet('Hours', true);
	
	    function localeMeridiem(hours, minutes, isLower) {
	        if (hours > 11) {
	            return isLower ? 'pm' : 'PM';
	        } else {
	            return isLower ? 'am' : 'AM';
	        }
	    }
	
	    var baseConfig = {
	        calendar: defaultCalendar,
	        longDateFormat: defaultLongDateFormat,
	        invalidDate: defaultInvalidDate,
	        ordinal: defaultOrdinal,
	        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
	        relativeTime: defaultRelativeTime,
	
	        months: defaultLocaleMonths,
	        monthsShort: defaultLocaleMonthsShort,
	
	        week: defaultLocaleWeek,
	
	        weekdays: defaultLocaleWeekdays,
	        weekdaysMin: defaultLocaleWeekdaysMin,
	        weekdaysShort: defaultLocaleWeekdaysShort,
	
	        meridiemParse: defaultLocaleMeridiemParse,
	    };
	
	    // internal storage for locale config files
	    var locales = {},
	        localeFamilies = {},
	        globalLocale;
	
	    function commonPrefix(arr1, arr2) {
	        var i,
	            minl = Math.min(arr1.length, arr2.length);
	        for (i = 0; i < minl; i += 1) {
	            if (arr1[i] !== arr2[i]) {
	                return i;
	            }
	        }
	        return minl;
	    }
	
	    function normalizeLocale(key) {
	        return key ? key.toLowerCase().replace('_', '-') : key;
	    }
	
	    // pick the locale from the array
	    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
	    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
	    function chooseLocale(names) {
	        var i = 0,
	            j,
	            next,
	            locale,
	            split;
	
	        while (i < names.length) {
	            split = normalizeLocale(names[i]).split('-');
	            j = split.length;
	            next = normalizeLocale(names[i + 1]);
	            next = next ? next.split('-') : null;
	            while (j > 0) {
	                locale = loadLocale(split.slice(0, j).join('-'));
	                if (locale) {
	                    return locale;
	                }
	                if (
	                    next &&
	                    next.length >= j &&
	                    commonPrefix(split, next) >= j - 1
	                ) {
	                    //the next array item is better than a shallower substring of this one
	                    break;
	                }
	                j--;
	            }
	            i++;
	        }
	        return globalLocale;
	    }
	
	    function isLocaleNameSane(name) {
	        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
	        return name.match('^[^/\\\\]*$') != null;
	    }
	
	    function loadLocale(name) {
	        var oldLocale = null,
	            aliasedRequire;
	        // TODO: Find a better way to register and load all the locales in Node
	        if (
	            locales[name] === undefined &&
	            typeof module !== 'undefined' &&
	            module &&
	            module.exports &&
	            isLocaleNameSane(name)
	        ) {
	            try {
	                oldLocale = globalLocale._abbr;
	                aliasedRequire = require;
	                __webpack_require__(2614)("./" + name);
	                getSetGlobalLocale(oldLocale);
	            } catch (e) {
	                // mark as not found to avoid repeating expensive file require call causing high CPU
	                // when trying to find en-US, en_US, en-us for every format call
	                locales[name] = null; // null means not found
	            }
	        }
	        return locales[name];
	    }
	
	    // This function will load locale and then set the global locale.  If
	    // no arguments are passed in, it will simply return the current global
	    // locale key.
	    function getSetGlobalLocale(key, values) {
	        var data;
	        if (key) {
	            if (isUndefined(values)) {
	                data = getLocale(key);
	            } else {
	                data = defineLocale(key, values);
	            }
	
	            if (data) {
	                // moment.duration._locale = moment._locale = data;
	                globalLocale = data;
	            } else {
	                if (typeof console !== 'undefined' && console.warn) {
	                    //warn user if arguments are passed but the locale could not be set
	                    console.warn(
	                        'Locale ' + key + ' not found. Did you forget to load it?'
	                    );
	                }
	            }
	        }
	
	        return globalLocale._abbr;
	    }
	
	    function defineLocale(name, config) {
	        if (config !== null) {
	            var locale,
	                parentConfig = baseConfig;
	            config.abbr = name;
	            if (locales[name] != null) {
	                deprecateSimple(
	                    'defineLocaleOverride',
	                    'use moment.updateLocale(localeName, config) to change ' +
	                        'an existing locale. moment.defineLocale(localeName, ' +
	                        'config) should only be used for creating a new locale ' +
	                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
	                );
	                parentConfig = locales[name]._config;
	            } else if (config.parentLocale != null) {
	                if (locales[config.parentLocale] != null) {
	                    parentConfig = locales[config.parentLocale]._config;
	                } else {
	                    locale = loadLocale(config.parentLocale);
	                    if (locale != null) {
	                        parentConfig = locale._config;
	                    } else {
	                        if (!localeFamilies[config.parentLocale]) {
	                            localeFamilies[config.parentLocale] = [];
	                        }
	                        localeFamilies[config.parentLocale].push({
	                            name: name,
	                            config: config,
	                        });
	                        return null;
	                    }
	                }
	            }
	            locales[name] = new Locale(mergeConfigs(parentConfig, config));
	
	            if (localeFamilies[name]) {
	                localeFamilies[name].forEach(function (x) {
	                    defineLocale(x.name, x.config);
	                });
	            }
	
	            // backwards compat for now: also set the locale
	            // make sure we set the locale AFTER all child locales have been
	            // created, so we won't end up with the child locale set.
	            getSetGlobalLocale(name);
	
	            return locales[name];
	        } else {
	            // useful for testing
	            delete locales[name];
	            return null;
	        }
	    }
	
	    function updateLocale(name, config) {
	        if (config != null) {
	            var locale,
	                tmpLocale,
	                parentConfig = baseConfig;
	
	            if (locales[name] != null && locales[name].parentLocale != null) {
	                // Update existing child locale in-place to avoid memory-leaks
	                locales[name].set(mergeConfigs(locales[name]._config, config));
	            } else {
	                // MERGE
	                tmpLocale = loadLocale(name);
	                if (tmpLocale != null) {
	                    parentConfig = tmpLocale._config;
	                }
	                config = mergeConfigs(parentConfig, config);
	                if (tmpLocale == null) {
	                    // updateLocale is called for creating a new locale
	                    // Set abbr so it will have a name (getters return
	                    // undefined otherwise).
	                    config.abbr = name;
	                }
	                locale = new Locale(config);
	                locale.parentLocale = locales[name];
	                locales[name] = locale;
	            }
	
	            // backwards compat for now: also set the locale
	            getSetGlobalLocale(name);
	        } else {
	            // pass null for config to unupdate, useful for tests
	            if (locales[name] != null) {
	                if (locales[name].parentLocale != null) {
	                    locales[name] = locales[name].parentLocale;
	                    if (name === getSetGlobalLocale()) {
	                        getSetGlobalLocale(name);
	                    }
	                } else if (locales[name] != null) {
	                    delete locales[name];
	                }
	            }
	        }
	        return locales[name];
	    }
	
	    // returns locale data
	    function getLocale(key) {
	        var locale;
	
	        if (key && key._locale && key._locale._abbr) {
	            key = key._locale._abbr;
	        }
	
	        if (!key) {
	            return globalLocale;
	        }
	
	        if (!isArray(key)) {
	            //short-circuit everything else
	            locale = loadLocale(key);
	            if (locale) {
	                return locale;
	            }
	            key = [key];
	        }
	
	        return chooseLocale(key);
	    }
	
	    function listLocales() {
	        return keys(locales);
	    }
	
	    function checkOverflow(m) {
	        var overflow,
	            a = m._a;
	
	        if (a && getParsingFlags(m).overflow === -2) {
	            overflow =
	                a[MONTH] < 0 || a[MONTH] > 11
	                    ? MONTH
	                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
	                    ? DATE
	                    : a[HOUR] < 0 ||
	                      a[HOUR] > 24 ||
	                      (a[HOUR] === 24 &&
	                          (a[MINUTE] !== 0 ||
	                              a[SECOND] !== 0 ||
	                              a[MILLISECOND] !== 0))
	                    ? HOUR
	                    : a[MINUTE] < 0 || a[MINUTE] > 59
	                    ? MINUTE
	                    : a[SECOND] < 0 || a[SECOND] > 59
	                    ? SECOND
	                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
	                    ? MILLISECOND
	                    : -1;
	
	            if (
	                getParsingFlags(m)._overflowDayOfYear &&
	                (overflow < YEAR || overflow > DATE)
	            ) {
	                overflow = DATE;
	            }
	            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
	                overflow = WEEK;
	            }
	            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
	                overflow = WEEKDAY;
	            }
	
	            getParsingFlags(m).overflow = overflow;
	        }
	
	        return m;
	    }
	
	    // iso 8601 regex
	    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
	    var extendedIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        basicIsoRegex =
	            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
	        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
	        isoDates = [
	            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
	            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
	            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
	            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
	            ['YYYY-DDD', /\d{4}-\d{3}/],
	            ['YYYY-MM', /\d{4}-\d\d/, false],
	            ['YYYYYYMMDD', /[+-]\d{10}/],
	            ['YYYYMMDD', /\d{8}/],
	            ['GGGG[W]WWE', /\d{4}W\d{3}/],
	            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
	            ['YYYYDDD', /\d{7}/],
	            ['YYYYMM', /\d{6}/, false],
	            ['YYYY', /\d{4}/, false],
	        ],
	        // iso time formats and regexes
	        isoTimes = [
	            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
	            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
	            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
	            ['HH:mm', /\d\d:\d\d/],
	            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
	            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
	            ['HHmmss', /\d\d\d\d\d\d/],
	            ['HHmm', /\d\d\d\d/],
	            ['HH', /\d\d/],
	        ],
	        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
	        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
	        rfc2822 =
	            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
	        obsOffsets = {
	            UT: 0,
	            GMT: 0,
	            EDT: -4 * 60,
	            EST: -5 * 60,
	            CDT: -5 * 60,
	            CST: -6 * 60,
	            MDT: -6 * 60,
	            MST: -7 * 60,
	            PDT: -7 * 60,
	            PST: -8 * 60,
	        };
	
	    // date from iso format
	    function configFromISO(config) {
	        var i,
	            l,
	            string = config._i,
	            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
	            allowTime,
	            dateFormat,
	            timeFormat,
	            tzFormat,
	            isoDatesLen = isoDates.length,
	            isoTimesLen = isoTimes.length;
	
	        if (match) {
	            getParsingFlags(config).iso = true;
	            for (i = 0, l = isoDatesLen; i < l; i++) {
	                if (isoDates[i][1].exec(match[1])) {
	                    dateFormat = isoDates[i][0];
	                    allowTime = isoDates[i][2] !== false;
	                    break;
	                }
	            }
	            if (dateFormat == null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[3]) {
	                for (i = 0, l = isoTimesLen; i < l; i++) {
	                    if (isoTimes[i][1].exec(match[3])) {
	                        // match[2] should be 'T' or space
	                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
	                        break;
	                    }
	                }
	                if (timeFormat == null) {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            if (!allowTime && timeFormat != null) {
	                config._isValid = false;
	                return;
	            }
	            if (match[4]) {
	                if (tzRegex.exec(match[4])) {
	                    tzFormat = 'Z';
	                } else {
	                    config._isValid = false;
	                    return;
	                }
	            }
	            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
	            configFromStringAndFormat(config);
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    function extractFromRFC2822Strings(
	        yearStr,
	        monthStr,
	        dayStr,
	        hourStr,
	        minuteStr,
	        secondStr
	    ) {
	        var result = [
	            untruncateYear(yearStr),
	            defaultLocaleMonthsShort.indexOf(monthStr),
	            parseInt(dayStr, 10),
	            parseInt(hourStr, 10),
	            parseInt(minuteStr, 10),
	        ];
	
	        if (secondStr) {
	            result.push(parseInt(secondStr, 10));
	        }
	
	        return result;
	    }
	
	    function untruncateYear(yearStr) {
	        var year = parseInt(yearStr, 10);
	        if (year <= 49) {
	            return 2000 + year;
	        } else if (year <= 999) {
	            return 1900 + year;
	        }
	        return year;
	    }
	
	    function preprocessRFC2822(s) {
	        // Remove comments and folding whitespace and replace multiple-spaces with a single space
	        return s
	            .replace(/\([^()]*\)|[\n\t]/g, ' ')
	            .replace(/(\s\s+)/g, ' ')
	            .replace(/^\s\s*/, '')
	            .replace(/\s\s*$/, '');
	    }
	
	    function checkWeekday(weekdayStr, parsedInput, config) {
	        if (weekdayStr) {
	            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
	            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
	                weekdayActual = new Date(
	                    parsedInput[0],
	                    parsedInput[1],
	                    parsedInput[2]
	                ).getDay();
	            if (weekdayProvided !== weekdayActual) {
	                getParsingFlags(config).weekdayMismatch = true;
	                config._isValid = false;
	                return false;
	            }
	        }
	        return true;
	    }
	
	    function calculateOffset(obsOffset, militaryOffset, numOffset) {
	        if (obsOffset) {
	            return obsOffsets[obsOffset];
	        } else if (militaryOffset) {
	            // the only allowed military tz is Z
	            return 0;
	        } else {
	            var hm = parseInt(numOffset, 10),
	                m = hm % 100,
	                h = (hm - m) / 100;
	            return h * 60 + m;
	        }
	    }
	
	    // date and time from ref 2822 format
	    function configFromRFC2822(config) {
	        var match = rfc2822.exec(preprocessRFC2822(config._i)),
	            parsedArray;
	        if (match) {
	            parsedArray = extractFromRFC2822Strings(
	                match[4],
	                match[3],
	                match[2],
	                match[5],
	                match[6],
	                match[7]
	            );
	            if (!checkWeekday(match[1], parsedArray, config)) {
	                return;
	            }
	
	            config._a = parsedArray;
	            config._tzm = calculateOffset(match[8], match[9], match[10]);
	
	            config._d = createUTCDate.apply(null, config._a);
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	
	            getParsingFlags(config).rfc2822 = true;
	        } else {
	            config._isValid = false;
	        }
	    }
	
	    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
	    function configFromString(config) {
	        var matched = aspNetJsonRegex.exec(config._i);
	        if (matched !== null) {
	            config._d = new Date(+matched[1]);
	            return;
	        }
	
	        configFromISO(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        configFromRFC2822(config);
	        if (config._isValid === false) {
	            delete config._isValid;
	        } else {
	            return;
	        }
	
	        if (config._strict) {
	            config._isValid = false;
	        } else {
	            // Final attempt, use Input Fallback
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    hooks.createFromInputFallback = deprecate(
	        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
	            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
	            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
	        function (config) {
	            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
	        }
	    );
	
	    // Pick the first defined of two or three arguments.
	    function defaults(a, b, c) {
	        if (a != null) {
	            return a;
	        }
	        if (b != null) {
	            return b;
	        }
	        return c;
	    }
	
	    function currentDateArray(config) {
	        // hooks is actually the exported moment object
	        var nowValue = new Date(hooks.now());
	        if (config._useUTC) {
	            return [
	                nowValue.getUTCFullYear(),
	                nowValue.getUTCMonth(),
	                nowValue.getUTCDate(),
	            ];
	        }
	        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
	    }
	
	    // convert an array to a date.
	    // the array should mirror the parameters below
	    // note: all values past the year are optional and will default to the lowest possible value.
	    // [year, month, day , hour, minute, second, millisecond]
	    function configFromArray(config) {
	        var i,
	            date,
	            input = [],
	            currentDate,
	            expectedWeekday,
	            yearToUse;
	
	        if (config._d) {
	            return;
	        }
	
	        currentDate = currentDateArray(config);
	
	        //compute day of the year from weeks and weekdays
	        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
	            dayOfYearFromWeekInfo(config);
	        }
	
	        //if the day of the year is set, figure out what it is
	        if (config._dayOfYear != null) {
	            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
	
	            if (
	                config._dayOfYear > daysInYear(yearToUse) ||
	                config._dayOfYear === 0
	            ) {
	                getParsingFlags(config)._overflowDayOfYear = true;
	            }
	
	            date = createUTCDate(yearToUse, 0, config._dayOfYear);
	            config._a[MONTH] = date.getUTCMonth();
	            config._a[DATE] = date.getUTCDate();
	        }
	
	        // Default to current date.
	        // * if no year, month, day of month are given, default to today
	        // * if day of month is given, default month and year
	        // * if month is given, default only year
	        // * if year is given, don't default anything
	        for (i = 0; i < 3 && config._a[i] == null; ++i) {
	            config._a[i] = input[i] = currentDate[i];
	        }
	
	        // Zero out whatever was not defaulted, including time
	        for (; i < 7; i++) {
	            config._a[i] = input[i] =
	                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
	        }
	
	        // Check for 24:00:00.000
	        if (
	            config._a[HOUR] === 24 &&
	            config._a[MINUTE] === 0 &&
	            config._a[SECOND] === 0 &&
	            config._a[MILLISECOND] === 0
	        ) {
	            config._nextDay = true;
	            config._a[HOUR] = 0;
	        }
	
	        config._d = (config._useUTC ? createUTCDate : createDate).apply(
	            null,
	            input
	        );
	        expectedWeekday = config._useUTC
	            ? config._d.getUTCDay()
	            : config._d.getDay();
	
	        // Apply timezone offset from input. The actual utcOffset can be changed
	        // with parseZone.
	        if (config._tzm != null) {
	            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
	        }
	
	        if (config._nextDay) {
	            config._a[HOUR] = 24;
	        }
	
	        // check for mismatching day of week
	        if (
	            config._w &&
	            typeof config._w.d !== 'undefined' &&
	            config._w.d !== expectedWeekday
	        ) {
	            getParsingFlags(config).weekdayMismatch = true;
	        }
	    }
	
	    function dayOfYearFromWeekInfo(config) {
	        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
	
	        w = config._w;
	        if (w.GG != null || w.W != null || w.E != null) {
	            dow = 1;
	            doy = 4;
	
	            // TODO: We need to take the current isoWeekYear, but that depends on
	            // how we interpret now (local, utc, fixed offset). So create
	            // a now version of current config (take local/utc/offset flags, and
	            // create now).
	            weekYear = defaults(
	                w.GG,
	                config._a[YEAR],
	                weekOfYear(createLocal(), 1, 4).year
	            );
	            week = defaults(w.W, 1);
	            weekday = defaults(w.E, 1);
	            if (weekday < 1 || weekday > 7) {
	                weekdayOverflow = true;
	            }
	        } else {
	            dow = config._locale._week.dow;
	            doy = config._locale._week.doy;
	
	            curWeek = weekOfYear(createLocal(), dow, doy);
	
	            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
	
	            // Default to current week.
	            week = defaults(w.w, curWeek.week);
	
	            if (w.d != null) {
	                // weekday -- low day numbers are considered next week
	                weekday = w.d;
	                if (weekday < 0 || weekday > 6) {
	                    weekdayOverflow = true;
	                }
	            } else if (w.e != null) {
	                // local weekday -- counting starts from beginning of week
	                weekday = w.e + dow;
	                if (w.e < 0 || w.e > 6) {
	                    weekdayOverflow = true;
	                }
	            } else {
	                // default to beginning of week
	                weekday = dow;
	            }
	        }
	        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
	            getParsingFlags(config)._overflowWeeks = true;
	        } else if (weekdayOverflow != null) {
	            getParsingFlags(config)._overflowWeekday = true;
	        } else {
	            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
	            config._a[YEAR] = temp.year;
	            config._dayOfYear = temp.dayOfYear;
	        }
	    }
	
	    // constant that refers to the ISO standard
	    hooks.ISO_8601 = function () {};
	
	    // constant that refers to the RFC 2822 form
	    hooks.RFC_2822 = function () {};
	
	    // date from string and format string
	    function configFromStringAndFormat(config) {
	        // TODO: Move this to another part of the creation flow to prevent circular deps
	        if (config._f === hooks.ISO_8601) {
	            configFromISO(config);
	            return;
	        }
	        if (config._f === hooks.RFC_2822) {
	            configFromRFC2822(config);
	            return;
	        }
	        config._a = [];
	        getParsingFlags(config).empty = true;
	
	        // This array is used to make a Date, either with `new Date` or `Date.UTC`
	        var string = '' + config._i,
	            i,
	            parsedInput,
	            tokens,
	            token,
	            skipped,
	            stringLength = string.length,
	            totalParsedInputLength = 0,
	            era,
	            tokenLen;
	
	        tokens =
	            expandFormat(config._f, config._locale).match(formattingTokens) || [];
	        tokenLen = tokens.length;
	        for (i = 0; i < tokenLen; i++) {
	            token = tokens[i];
	            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
	                [])[0];
	            if (parsedInput) {
	                skipped = string.substr(0, string.indexOf(parsedInput));
	                if (skipped.length > 0) {
	                    getParsingFlags(config).unusedInput.push(skipped);
	                }
	                string = string.slice(
	                    string.indexOf(parsedInput) + parsedInput.length
	                );
	                totalParsedInputLength += parsedInput.length;
	            }
	            // don't parse if it's not a known token
	            if (formatTokenFunctions[token]) {
	                if (parsedInput) {
	                    getParsingFlags(config).empty = false;
	                } else {
	                    getParsingFlags(config).unusedTokens.push(token);
	                }
	                addTimeToArrayFromToken(token, parsedInput, config);
	            } else if (config._strict && !parsedInput) {
	                getParsingFlags(config).unusedTokens.push(token);
	            }
	        }
	
	        // add remaining unparsed input length to the string
	        getParsingFlags(config).charsLeftOver =
	            stringLength - totalParsedInputLength;
	        if (string.length > 0) {
	            getParsingFlags(config).unusedInput.push(string);
	        }
	
	        // clear _12h flag if hour is <= 12
	        if (
	            config._a[HOUR] <= 12 &&
	            getParsingFlags(config).bigHour === true &&
	            config._a[HOUR] > 0
	        ) {
	            getParsingFlags(config).bigHour = undefined;
	        }
	
	        getParsingFlags(config).parsedDateParts = config._a.slice(0);
	        getParsingFlags(config).meridiem = config._meridiem;
	        // handle meridiem
	        config._a[HOUR] = meridiemFixWrap(
	            config._locale,
	            config._a[HOUR],
	            config._meridiem
	        );
	
	        // handle era
	        era = getParsingFlags(config).era;
	        if (era !== null) {
	            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
	        }
	
	        configFromArray(config);
	        checkOverflow(config);
	    }
	
	    function meridiemFixWrap(locale, hour, meridiem) {
	        var isPm;
	
	        if (meridiem == null) {
	            // nothing to do
	            return hour;
	        }
	        if (locale.meridiemHour != null) {
	            return locale.meridiemHour(hour, meridiem);
	        } else if (locale.isPM != null) {
	            // Fallback
	            isPm = locale.isPM(meridiem);
	            if (isPm && hour < 12) {
	                hour += 12;
	            }
	            if (!isPm && hour === 12) {
	                hour = 0;
	            }
	            return hour;
	        } else {
	            // this is not supposed to happen
	            return hour;
	        }
	    }
	
	    // date from string and array of format strings
	    function configFromStringAndArray(config) {
	        var tempConfig,
	            bestMoment,
	            scoreToBeat,
	            i,
	            currentScore,
	            validFormatFound,
	            bestFormatIsValid = false,
	            configfLen = config._f.length;
	
	        if (configfLen === 0) {
	            getParsingFlags(config).invalidFormat = true;
	            config._d = new Date(NaN);
	            return;
	        }
	
	        for (i = 0; i < configfLen; i++) {
	            currentScore = 0;
	            validFormatFound = false;
	            tempConfig = copyConfig({}, config);
	            if (config._useUTC != null) {
	                tempConfig._useUTC = config._useUTC;
	            }
	            tempConfig._f = config._f[i];
	            configFromStringAndFormat(tempConfig);
	
	            if (isValid(tempConfig)) {
	                validFormatFound = true;
	            }
	
	            // if there is any input that was not parsed add a penalty for that format
	            currentScore += getParsingFlags(tempConfig).charsLeftOver;
	
	            //or tokens
	            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
	
	            getParsingFlags(tempConfig).score = currentScore;
	
	            if (!bestFormatIsValid) {
	                if (
	                    scoreToBeat == null ||
	                    currentScore < scoreToBeat ||
	                    validFormatFound
	                ) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                    if (validFormatFound) {
	                        bestFormatIsValid = true;
	                    }
	                }
	            } else {
	                if (currentScore < scoreToBeat) {
	                    scoreToBeat = currentScore;
	                    bestMoment = tempConfig;
	                }
	            }
	        }
	
	        extend(config, bestMoment || tempConfig);
	    }
	
	    function configFromObject(config) {
	        if (config._d) {
	            return;
	        }
	
	        var i = normalizeObjectUnits(config._i),
	            dayOrDate = i.day === undefined ? i.date : i.day;
	        config._a = map(
	            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
	            function (obj) {
	                return obj && parseInt(obj, 10);
	            }
	        );
	
	        configFromArray(config);
	    }
	
	    function createFromConfig(config) {
	        var res = new Moment(checkOverflow(prepareConfig(config)));
	        if (res._nextDay) {
	            // Adding is smart enough around DST
	            res.add(1, 'd');
	            res._nextDay = undefined;
	        }
	
	        return res;
	    }
	
	    function prepareConfig(config) {
	        var input = config._i,
	            format = config._f;
	
	        config._locale = config._locale || getLocale(config._l);
	
	        if (input === null || (format === undefined && input === '')) {
	            return createInvalid({ nullInput: true });
	        }
	
	        if (typeof input === 'string') {
	            config._i = input = config._locale.preparse(input);
	        }
	
	        if (isMoment(input)) {
	            return new Moment(checkOverflow(input));
	        } else if (isDate(input)) {
	            config._d = input;
	        } else if (isArray(format)) {
	            configFromStringAndArray(config);
	        } else if (format) {
	            configFromStringAndFormat(config);
	        } else {
	            configFromInput(config);
	        }
	
	        if (!isValid(config)) {
	            config._d = null;
	        }
	
	        return config;
	    }
	
	    function configFromInput(config) {
	        var input = config._i;
	        if (isUndefined(input)) {
	            config._d = new Date(hooks.now());
	        } else if (isDate(input)) {
	            config._d = new Date(input.valueOf());
	        } else if (typeof input === 'string') {
	            configFromString(config);
	        } else if (isArray(input)) {
	            config._a = map(input.slice(0), function (obj) {
	                return parseInt(obj, 10);
	            });
	            configFromArray(config);
	        } else if (isObject(input)) {
	            configFromObject(config);
	        } else if (isNumber(input)) {
	            // from milliseconds
	            config._d = new Date(input);
	        } else {
	            hooks.createFromInputFallback(config);
	        }
	    }
	
	    function createLocalOrUTC(input, format, locale, strict, isUTC) {
	        var c = {};
	
	        if (format === true || format === false) {
	            strict = format;
	            format = undefined;
	        }
	
	        if (locale === true || locale === false) {
	            strict = locale;
	            locale = undefined;
	        }
	
	        if (
	            (isObject(input) && isObjectEmpty(input)) ||
	            (isArray(input) && input.length === 0)
	        ) {
	            input = undefined;
	        }
	        // object construction must be done this way.
	        // https://github.com/moment/moment/issues/1423
	        c._isAMomentObject = true;
	        c._useUTC = c._isUTC = isUTC;
	        c._l = locale;
	        c._i = input;
	        c._f = format;
	        c._strict = strict;
	
	        return createFromConfig(c);
	    }
	
	    function createLocal(input, format, locale, strict) {
	        return createLocalOrUTC(input, format, locale, strict, false);
	    }
	
	    var prototypeMin = deprecate(
	            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other < this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        ),
	        prototypeMax = deprecate(
	            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
	            function () {
	                var other = createLocal.apply(null, arguments);
	                if (this.isValid() && other.isValid()) {
	                    return other > this ? this : other;
	                } else {
	                    return createInvalid();
	                }
	            }
	        );
	
	    // Pick a moment m from moments so that m[fn](other) is true for all
	    // other. This relies on the function fn to be transitive.
	    //
	    // moments should either be an array of moment objects or an array, whose
	    // first element is an array of moment objects.
	    function pickBy(fn, moments) {
	        var res, i;
	        if (moments.length === 1 && isArray(moments[0])) {
	            moments = moments[0];
	        }
	        if (!moments.length) {
	            return createLocal();
	        }
	        res = moments[0];
	        for (i = 1; i < moments.length; ++i) {
	            if (!moments[i].isValid() || moments[i][fn](res)) {
	                res = moments[i];
	            }
	        }
	        return res;
	    }
	
	    // TODO: Use [].sort instead?
	    function min() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isBefore', args);
	    }
	
	    function max() {
	        var args = [].slice.call(arguments, 0);
	
	        return pickBy('isAfter', args);
	    }
	
	    var now = function () {
	        return Date.now ? Date.now() : +new Date();
	    };
	
	    var ordering = [
	        'year',
	        'quarter',
	        'month',
	        'week',
	        'day',
	        'hour',
	        'minute',
	        'second',
	        'millisecond',
	    ];
	
	    function isDurationValid(m) {
	        var key,
	            unitHasDecimal = false,
	            i,
	            orderLen = ordering.length;
	        for (key in m) {
	            if (
	                hasOwnProp(m, key) &&
	                !(
	                    indexOf.call(ordering, key) !== -1 &&
	                    (m[key] == null || !isNaN(m[key]))
	                )
	            ) {
	                return false;
	            }
	        }
	
	        for (i = 0; i < orderLen; ++i) {
	            if (m[ordering[i]]) {
	                if (unitHasDecimal) {
	                    return false; // only allow non-integers for smallest unit
	                }
	                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
	                    unitHasDecimal = true;
	                }
	            }
	        }
	
	        return true;
	    }
	
	    function isValid$1() {
	        return this._isValid;
	    }
	
	    function createInvalid$1() {
	        return createDuration(NaN);
	    }
	
	    function Duration(duration) {
	        var normalizedInput = normalizeObjectUnits(duration),
	            years = normalizedInput.year || 0,
	            quarters = normalizedInput.quarter || 0,
	            months = normalizedInput.month || 0,
	            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
	            days = normalizedInput.day || 0,
	            hours = normalizedInput.hour || 0,
	            minutes = normalizedInput.minute || 0,
	            seconds = normalizedInput.second || 0,
	            milliseconds = normalizedInput.millisecond || 0;
	
	        this._isValid = isDurationValid(normalizedInput);
	
	        // representation for dateAddRemove
	        this._milliseconds =
	            +milliseconds +
	            seconds * 1e3 + // 1000
	            minutes * 6e4 + // 1000 * 60
	            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
	        // Because of dateAddRemove treats 24 hours as different from a
	        // day when working around DST, we need to store them separately
	        this._days = +days + weeks * 7;
	        // It is impossible to translate months into days without knowing
	        // which months you are are talking about, so we have to store
	        // it separately.
	        this._months = +months + quarters * 3 + years * 12;
	
	        this._data = {};
	
	        this._locale = getLocale();
	
	        this._bubble();
	    }
	
	    function isDuration(obj) {
	        return obj instanceof Duration;
	    }
	
	    function absRound(number) {
	        if (number < 0) {
	            return Math.round(-1 * number) * -1;
	        } else {
	            return Math.round(number);
	        }
	    }
	
	    // compare two arrays, return the number of differences
	    function compareArrays(array1, array2, dontConvert) {
	        var len = Math.min(array1.length, array2.length),
	            lengthDiff = Math.abs(array1.length - array2.length),
	            diffs = 0,
	            i;
	        for (i = 0; i < len; i++) {
	            if (
	                (dontConvert && array1[i] !== array2[i]) ||
	                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
	            ) {
	                diffs++;
	            }
	        }
	        return diffs + lengthDiff;
	    }
	
	    // FORMATTING
	
	    function offset(token, separator) {
	        addFormatToken(token, 0, 0, function () {
	            var offset = this.utcOffset(),
	                sign = '+';
	            if (offset < 0) {
	                offset = -offset;
	                sign = '-';
	            }
	            return (
	                sign +
	                zeroFill(~~(offset / 60), 2) +
	                separator +
	                zeroFill(~~offset % 60, 2)
	            );
	        });
	    }
	
	    offset('Z', ':');
	    offset('ZZ', '');
	
	    // PARSING
	
	    addRegexToken('Z', matchShortOffset);
	    addRegexToken('ZZ', matchShortOffset);
	    addParseToken(['Z', 'ZZ'], function (input, array, config) {
	        config._useUTC = true;
	        config._tzm = offsetFromString(matchShortOffset, input);
	    });
	
	    // HELPERS
	
	    // timezone chunker
	    // '+10:00' > ['10',  '00']
	    // '-1530'  > ['-15', '30']
	    var chunkOffset = /([\+\-]|\d\d)/gi;
	
	    function offsetFromString(matcher, string) {
	        var matches = (string || '').match(matcher),
	            chunk,
	            parts,
	            minutes;
	
	        if (matches === null) {
	            return null;
	        }
	
	        chunk = matches[matches.length - 1] || [];
	        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
	        minutes = +(parts[1] * 60) + toInt(parts[2]);
	
	        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
	    }
	
	    // Return a moment from input, that is local/utc/zone equivalent to model.
	    function cloneWithOffset(input, model) {
	        var res, diff;
	        if (model._isUTC) {
	            res = model.clone();
	            diff =
	                (isMoment(input) || isDate(input)
	                    ? input.valueOf()
	                    : createLocal(input).valueOf()) - res.valueOf();
	            // Use low-level api, because this fn is low-level api.
	            res._d.setTime(res._d.valueOf() + diff);
	            hooks.updateOffset(res, false);
	            return res;
	        } else {
	            return createLocal(input).local();
	        }
	    }
	
	    function getDateOffset(m) {
	        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
	        // https://github.com/moment/moment/pull/1871
	        return -Math.round(m._d.getTimezoneOffset());
	    }
	
	    // HOOKS
	
	    // This function will be called whenever a moment is mutated.
	    // It is intended to keep the offset in sync with the timezone.
	    hooks.updateOffset = function () {};
	
	    // MOMENTS
	
	    // keepLocalTime = true means only change the timezone, without
	    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
	    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
	    // +0200, so we adjust the time as needed, to be valid.
	    //
	    // Keeping the time actually adds/subtracts (one hour)
	    // from the actual represented time. That is why we call updateOffset
	    // a second time. In case it wants us to change the offset again
	    // _changeInProgress == true case, then we have to adjust, because
	    // there is no such time in the given timezone.
	    function getSetOffset(input, keepLocalTime, keepMinutes) {
	        var offset = this._offset || 0,
	            localAdjust;
	        if (!this.isValid()) {
	            return input != null ? this : NaN;
	        }
	        if (input != null) {
	            if (typeof input === 'string') {
	                input = offsetFromString(matchShortOffset, input);
	                if (input === null) {
	                    return this;
	                }
	            } else if (Math.abs(input) < 16 && !keepMinutes) {
	                input = input * 60;
	            }
	            if (!this._isUTC && keepLocalTime) {
	                localAdjust = getDateOffset(this);
	            }
	            this._offset = input;
	            this._isUTC = true;
	            if (localAdjust != null) {
	                this.add(localAdjust, 'm');
	            }
	            if (offset !== input) {
	                if (!keepLocalTime || this._changeInProgress) {
	                    addSubtract(
	                        this,
	                        createDuration(input - offset, 'm'),
	                        1,
	                        false
	                    );
	                } else if (!this._changeInProgress) {
	                    this._changeInProgress = true;
	                    hooks.updateOffset(this, true);
	                    this._changeInProgress = null;
	                }
	            }
	            return this;
	        } else {
	            return this._isUTC ? offset : getDateOffset(this);
	        }
	    }
	
	    function getSetZone(input, keepLocalTime) {
	        if (input != null) {
	            if (typeof input !== 'string') {
	                input = -input;
	            }
	
	            this.utcOffset(input, keepLocalTime);
	
	            return this;
	        } else {
	            return -this.utcOffset();
	        }
	    }
	
	    function setOffsetToUTC(keepLocalTime) {
	        return this.utcOffset(0, keepLocalTime);
	    }
	
	    function setOffsetToLocal(keepLocalTime) {
	        if (this._isUTC) {
	            this.utcOffset(0, keepLocalTime);
	            this._isUTC = false;
	
	            if (keepLocalTime) {
	                this.subtract(getDateOffset(this), 'm');
	            }
	        }
	        return this;
	    }
	
	    function setOffsetToParsedOffset() {
	        if (this._tzm != null) {
	            this.utcOffset(this._tzm, false, true);
	        } else if (typeof this._i === 'string') {
	            var tZone = offsetFromString(matchOffset, this._i);
	            if (tZone != null) {
	                this.utcOffset(tZone);
	            } else {
	                this.utcOffset(0, true);
	            }
	        }
	        return this;
	    }
	
	    function hasAlignedHourOffset(input) {
	        if (!this.isValid()) {
	            return false;
	        }
	        input = input ? createLocal(input).utcOffset() : 0;
	
	        return (this.utcOffset() - input) % 60 === 0;
	    }
	
	    function isDaylightSavingTime() {
	        return (
	            this.utcOffset() > this.clone().month(0).utcOffset() ||
	            this.utcOffset() > this.clone().month(5).utcOffset()
	        );
	    }
	
	    function isDaylightSavingTimeShifted() {
	        if (!isUndefined(this._isDSTShifted)) {
	            return this._isDSTShifted;
	        }
	
	        var c = {},
	            other;
	
	        copyConfig(c, this);
	        c = prepareConfig(c);
	
	        if (c._a) {
	            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
	            this._isDSTShifted =
	                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
	        } else {
	            this._isDSTShifted = false;
	        }
	
	        return this._isDSTShifted;
	    }
	
	    function isLocal() {
	        return this.isValid() ? !this._isUTC : false;
	    }
	
	    function isUtcOffset() {
	        return this.isValid() ? this._isUTC : false;
	    }
	
	    function isUtc() {
	        return this.isValid() ? this._isUTC && this._offset === 0 : false;
	    }
	
	    // ASP.NET json date format regex
	    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
	        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
	        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
	        // and further modified to allow for strings containing both week and day
	        isoRegex =
	            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
	
	    function createDuration(input, key) {
	        var duration = input,
	            // matching against regexp is expensive, do it on demand
	            match = null,
	            sign,
	            ret,
	            diffRes;
	
	        if (isDuration(input)) {
	            duration = {
	                ms: input._milliseconds,
	                d: input._days,
	                M: input._months,
	            };
	        } else if (isNumber(input) || !isNaN(+input)) {
	            duration = {};
	            if (key) {
	                duration[key] = +input;
	            } else {
	                duration.milliseconds = +input;
	            }
	        } else if ((match = aspNetRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: 0,
	                d: toInt(match[DATE]) * sign,
	                h: toInt(match[HOUR]) * sign,
	                m: toInt(match[MINUTE]) * sign,
	                s: toInt(match[SECOND]) * sign,
	                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
	            };
	        } else if ((match = isoRegex.exec(input))) {
	            sign = match[1] === '-' ? -1 : 1;
	            duration = {
	                y: parseIso(match[2], sign),
	                M: parseIso(match[3], sign),
	                w: parseIso(match[4], sign),
	                d: parseIso(match[5], sign),
	                h: parseIso(match[6], sign),
	                m: parseIso(match[7], sign),
	                s: parseIso(match[8], sign),
	            };
	        } else if (duration == null) {
	            // checks for null or undefined
	            duration = {};
	        } else if (
	            typeof duration === 'object' &&
	            ('from' in duration || 'to' in duration)
	        ) {
	            diffRes = momentsDifference(
	                createLocal(duration.from),
	                createLocal(duration.to)
	            );
	
	            duration = {};
	            duration.ms = diffRes.milliseconds;
	            duration.M = diffRes.months;
	        }
	
	        ret = new Duration(duration);
	
	        if (isDuration(input) && hasOwnProp(input, '_locale')) {
	            ret._locale = input._locale;
	        }
	
	        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
	            ret._isValid = input._isValid;
	        }
	
	        return ret;
	    }
	
	    createDuration.fn = Duration.prototype;
	    createDuration.invalid = createInvalid$1;
	
	    function parseIso(inp, sign) {
	        // We'd normally use ~~inp for this, but unfortunately it also
	        // converts floats to ints.
	        // inp may be undefined, so careful calling replace on it.
	        var res = inp && parseFloat(inp.replace(',', '.'));
	        // apply sign while we're at it
	        return (isNaN(res) ? 0 : res) * sign;
	    }
	
	    function positiveMomentsDifference(base, other) {
	        var res = {};
	
	        res.months =
	            other.month() - base.month() + (other.year() - base.year()) * 12;
	        if (base.clone().add(res.months, 'M').isAfter(other)) {
	            --res.months;
	        }
	
	        res.milliseconds = +other - +base.clone().add(res.months, 'M');
	
	        return res;
	    }
	
	    function momentsDifference(base, other) {
	        var res;
	        if (!(base.isValid() && other.isValid())) {
	            return { milliseconds: 0, months: 0 };
	        }
	
	        other = cloneWithOffset(other, base);
	        if (base.isBefore(other)) {
	            res = positiveMomentsDifference(base, other);
	        } else {
	            res = positiveMomentsDifference(other, base);
	            res.milliseconds = -res.milliseconds;
	            res.months = -res.months;
	        }
	
	        return res;
	    }
	
	    // TODO: remove 'name' arg after deprecation is removed
	    function createAdder(direction, name) {
	        return function (val, period) {
	            var dur, tmp;
	            //invert the arguments, but complain about it
	            if (period !== null && !isNaN(+period)) {
	                deprecateSimple(
	                    name,
	                    'moment().' +
	                        name +
	                        '(period, number) is deprecated. Please use moment().' +
	                        name +
	                        '(number, period). ' +
	                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
	                );
	                tmp = val;
	                val = period;
	                period = tmp;
	            }
	
	            dur = createDuration(val, period);
	            addSubtract(this, dur, direction);
	            return this;
	        };
	    }
	
	    function addSubtract(mom, duration, isAdding, updateOffset) {
	        var milliseconds = duration._milliseconds,
	            days = absRound(duration._days),
	            months = absRound(duration._months);
	
	        if (!mom.isValid()) {
	            // No op
	            return;
	        }
	
	        updateOffset = updateOffset == null ? true : updateOffset;
	
	        if (months) {
	            setMonth(mom, get(mom, 'Month') + months * isAdding);
	        }
	        if (days) {
	            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
	        }
	        if (milliseconds) {
	            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
	        }
	        if (updateOffset) {
	            hooks.updateOffset(mom, days || months);
	        }
	    }
	
	    var add = createAdder(1, 'add'),
	        subtract = createAdder(-1, 'subtract');
	
	    function isString(input) {
	        return typeof input === 'string' || input instanceof String;
	    }
	
	    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
	    function isMomentInput(input) {
	        return (
	            isMoment(input) ||
	            isDate(input) ||
	            isString(input) ||
	            isNumber(input) ||
	            isNumberOrStringArray(input) ||
	            isMomentInputObject(input) ||
	            input === null ||
	            input === undefined
	        );
	    }
	
	    function isMomentInputObject(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'years',
	                'year',
	                'y',
	                'months',
	                'month',
	                'M',
	                'days',
	                'day',
	                'd',
	                'dates',
	                'date',
	                'D',
	                'hours',
	                'hour',
	                'h',
	                'minutes',
	                'minute',
	                'm',
	                'seconds',
	                'second',
	                's',
	                'milliseconds',
	                'millisecond',
	                'ms',
	            ],
	            i,
	            property,
	            propertyLen = properties.length;
	
	        for (i = 0; i < propertyLen; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function isNumberOrStringArray(input) {
	        var arrayTest = isArray(input),
	            dataTypeTest = false;
	        if (arrayTest) {
	            dataTypeTest =
	                input.filter(function (item) {
	                    return !isNumber(item) && isString(input);
	                }).length === 0;
	        }
	        return arrayTest && dataTypeTest;
	    }
	
	    function isCalendarSpec(input) {
	        var objectTest = isObject(input) && !isObjectEmpty(input),
	            propertyTest = false,
	            properties = [
	                'sameDay',
	                'nextDay',
	                'lastDay',
	                'nextWeek',
	                'lastWeek',
	                'sameElse',
	            ],
	            i,
	            property;
	
	        for (i = 0; i < properties.length; i += 1) {
	            property = properties[i];
	            propertyTest = propertyTest || hasOwnProp(input, property);
	        }
	
	        return objectTest && propertyTest;
	    }
	
	    function getCalendarFormat(myMoment, now) {
	        var diff = myMoment.diff(now, 'days', true);
	        return diff < -6
	            ? 'sameElse'
	            : diff < -1
	            ? 'lastWeek'
	            : diff < 0
	            ? 'lastDay'
	            : diff < 1
	            ? 'sameDay'
	            : diff < 2
	            ? 'nextDay'
	            : diff < 7
	            ? 'nextWeek'
	            : 'sameElse';
	    }
	
	    function calendar$1(time, formats) {
	        // Support for single parameter, formats only overload to the calendar function
	        if (arguments.length === 1) {
	            if (!arguments[0]) {
	                time = undefined;
	                formats = undefined;
	            } else if (isMomentInput(arguments[0])) {
	                time = arguments[0];
	                formats = undefined;
	            } else if (isCalendarSpec(arguments[0])) {
	                formats = arguments[0];
	                time = undefined;
	            }
	        }
	        // We want to compare the start of today, vs this.
	        // Getting start-of-today depends on whether we're local/utc/offset or not.
	        var now = time || createLocal(),
	            sod = cloneWithOffset(now, this).startOf('day'),
	            format = hooks.calendarFormat(this, sod) || 'sameElse',
	            output =
	                formats &&
	                (isFunction(formats[format])
	                    ? formats[format].call(this, now)
	                    : formats[format]);
	
	        return this.format(
	            output || this.localeData().calendar(format, this, createLocal(now))
	        );
	    }
	
	    function clone() {
	        return new Moment(this);
	    }
	
	    function isAfter(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() > localInput.valueOf();
	        } else {
	            return localInput.valueOf() < this.clone().startOf(units).valueOf();
	        }
	    }
	
	    function isBefore(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input);
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() < localInput.valueOf();
	        } else {
	            return this.clone().endOf(units).valueOf() < localInput.valueOf();
	        }
	    }
	
	    function isBetween(from, to, units, inclusivity) {
	        var localFrom = isMoment(from) ? from : createLocal(from),
	            localTo = isMoment(to) ? to : createLocal(to);
	        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
	            return false;
	        }
	        inclusivity = inclusivity || '()';
	        return (
	            (inclusivity[0] === '('
	                ? this.isAfter(localFrom, units)
	                : !this.isBefore(localFrom, units)) &&
	            (inclusivity[1] === ')'
	                ? this.isBefore(localTo, units)
	                : !this.isAfter(localTo, units))
	        );
	    }
	
	    function isSame(input, units) {
	        var localInput = isMoment(input) ? input : createLocal(input),
	            inputMs;
	        if (!(this.isValid() && localInput.isValid())) {
	            return false;
	        }
	        units = normalizeUnits(units) || 'millisecond';
	        if (units === 'millisecond') {
	            return this.valueOf() === localInput.valueOf();
	        } else {
	            inputMs = localInput.valueOf();
	            return (
	                this.clone().startOf(units).valueOf() <= inputMs &&
	                inputMs <= this.clone().endOf(units).valueOf()
	            );
	        }
	    }
	
	    function isSameOrAfter(input, units) {
	        return this.isSame(input, units) || this.isAfter(input, units);
	    }
	
	    function isSameOrBefore(input, units) {
	        return this.isSame(input, units) || this.isBefore(input, units);
	    }
	
	    function diff(input, units, asFloat) {
	        var that, zoneDelta, output;
	
	        if (!this.isValid()) {
	            return NaN;
	        }
	
	        that = cloneWithOffset(input, this);
	
	        if (!that.isValid()) {
	            return NaN;
	        }
	
	        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
	
	        units = normalizeUnits(units);
	
	        switch (units) {
	            case 'year':
	                output = monthDiff(this, that) / 12;
	                break;
	            case 'month':
	                output = monthDiff(this, that);
	                break;
	            case 'quarter':
	                output = monthDiff(this, that) / 3;
	                break;
	            case 'second':
	                output = (this - that) / 1e3;
	                break; // 1000
	            case 'minute':
	                output = (this - that) / 6e4;
	                break; // 1000 * 60
	            case 'hour':
	                output = (this - that) / 36e5;
	                break; // 1000 * 60 * 60
	            case 'day':
	                output = (this - that - zoneDelta) / 864e5;
	                break; // 1000 * 60 * 60 * 24, negate dst
	            case 'week':
	                output = (this - that - zoneDelta) / 6048e5;
	                break; // 1000 * 60 * 60 * 24 * 7, negate dst
	            default:
	                output = this - that;
	        }
	
	        return asFloat ? output : absFloor(output);
	    }
	
	    function monthDiff(a, b) {
	        if (a.date() < b.date()) {
	            // end-of-month calculations work correct when the start month has more
	            // days than the end month.
	            return -monthDiff(b, a);
	        }
	        // difference in months
	        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
	            // b is in (anchor - 1 month, anchor + 1 month)
	            anchor = a.clone().add(wholeMonthDiff, 'months'),
	            anchor2,
	            adjust;
	
	        if (b - anchor < 0) {
	            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor - anchor2);
	        } else {
	            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
	            // linear across the month
	            adjust = (b - anchor) / (anchor2 - anchor);
	        }
	
	        //check for negative zero, return zero if negative zero
	        return -(wholeMonthDiff + adjust) || 0;
	    }
	
	    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
	    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
	
	    function toString() {
	        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
	    }
	
	    function toISOString(keepOffset) {
	        if (!this.isValid()) {
	            return null;
	        }
	        var utc = keepOffset !== true,
	            m = utc ? this.clone().utc() : this;
	        if (m.year() < 0 || m.year() > 9999) {
	            return formatMoment(
	                m,
	                utc
	                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
	                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
	            );
	        }
	        if (isFunction(Date.prototype.toISOString)) {
	            // native implementation is ~50x faster, use it when we can
	            if (utc) {
	                return this.toDate().toISOString();
	            } else {
	                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
	                    .toISOString()
	                    .replace('Z', formatMoment(m, 'Z'));
	            }
	        }
	        return formatMoment(
	            m,
	            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
	        );
	    }
	
	    /**
	     * Return a human readable representation of a moment that can
	     * also be evaluated to get a new moment which is the same
	     *
	     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
	     */
	    function inspect() {
	        if (!this.isValid()) {
	            return 'moment.invalid(/* ' + this._i + ' */)';
	        }
	        var func = 'moment',
	            zone = '',
	            prefix,
	            year,
	            datetime,
	            suffix;
	        if (!this.isLocal()) {
	            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
	            zone = 'Z';
	        }
	        prefix = '[' + func + '("]';
	        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
	        datetime = '-MM-DD[T]HH:mm:ss.SSS';
	        suffix = zone + '[")]';
	
	        return this.format(prefix + year + datetime + suffix);
	    }
	
	    function format(inputString) {
	        if (!inputString) {
	            inputString = this.isUtc()
	                ? hooks.defaultFormatUtc
	                : hooks.defaultFormat;
	        }
	        var output = formatMoment(this, inputString);
	        return this.localeData().postformat(output);
	    }
	
	    function from(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ to: this, from: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function fromNow(withoutSuffix) {
	        return this.from(createLocal(), withoutSuffix);
	    }
	
	    function to(time, withoutSuffix) {
	        if (
	            this.isValid() &&
	            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
	        ) {
	            return createDuration({ from: this, to: time })
	                .locale(this.locale())
	                .humanize(!withoutSuffix);
	        } else {
	            return this.localeData().invalidDate();
	        }
	    }
	
	    function toNow(withoutSuffix) {
	        return this.to(createLocal(), withoutSuffix);
	    }
	
	    // If passed a locale key, it will set the locale for this
	    // instance.  Otherwise, it will return the locale configuration
	    // variables for this instance.
	    function locale(key) {
	        var newLocaleData;
	
	        if (key === undefined) {
	            return this._locale._abbr;
	        } else {
	            newLocaleData = getLocale(key);
	            if (newLocaleData != null) {
	                this._locale = newLocaleData;
	            }
	            return this;
	        }
	    }
	
	    var lang = deprecate(
	        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
	        function (key) {
	            if (key === undefined) {
	                return this.localeData();
	            } else {
	                return this.locale(key);
	            }
	        }
	    );
	
	    function localeData() {
	        return this._locale;
	    }
	
	    var MS_PER_SECOND = 1000,
	        MS_PER_MINUTE = 60 * MS_PER_SECOND,
	        MS_PER_HOUR = 60 * MS_PER_MINUTE,
	        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;
	
	    // actual modulo - handles negative numbers (for dates before 1970):
	    function mod$1(dividend, divisor) {
	        return ((dividend % divisor) + divisor) % divisor;
	    }
	
	    function localStartOfDate(y, m, d) {
	        // the date constructor remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return new Date(y, m, d).valueOf();
	        }
	    }
	
	    function utcStartOfDate(y, m, d) {
	        // Date.UTC remaps years 0-99 to 1900-1999
	        if (y < 100 && y >= 0) {
	            // preserve leap years using a full 400 year cycle, then reset
	            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
	        } else {
	            return Date.UTC(y, m, d);
	        }
	    }
	
	    function startOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year(), 0, 1);
	                break;
	            case 'quarter':
	                time = startOfDate(
	                    this.year(),
	                    this.month() - (this.month() % 3),
	                    1
	                );
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month(), 1);
	                break;
	            case 'week':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - this.weekday()
	                );
	                break;
	            case 'isoWeek':
	                time = startOfDate(
	                    this.year(),
	                    this.month(),
	                    this.date() - (this.isoWeekday() - 1)
	                );
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date());
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time -= mod$1(
	                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                    MS_PER_HOUR
	                );
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_MINUTE);
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time -= mod$1(time, MS_PER_SECOND);
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function endOf(units) {
	        var time, startOfDate;
	        units = normalizeUnits(units);
	        if (units === undefined || units === 'millisecond' || !this.isValid()) {
	            return this;
	        }
	
	        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
	
	        switch (units) {
	            case 'year':
	                time = startOfDate(this.year() + 1, 0, 1) - 1;
	                break;
	            case 'quarter':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month() - (this.month() % 3) + 3,
	                        1
	                    ) - 1;
	                break;
	            case 'month':
	                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
	                break;
	            case 'week':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - this.weekday() + 7
	                    ) - 1;
	                break;
	            case 'isoWeek':
	                time =
	                    startOfDate(
	                        this.year(),
	                        this.month(),
	                        this.date() - (this.isoWeekday() - 1) + 7
	                    ) - 1;
	                break;
	            case 'day':
	            case 'date':
	                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
	                break;
	            case 'hour':
	                time = this._d.valueOf();
	                time +=
	                    MS_PER_HOUR -
	                    mod$1(
	                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
	                        MS_PER_HOUR
	                    ) -
	                    1;
	                break;
	            case 'minute':
	                time = this._d.valueOf();
	                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
	                break;
	            case 'second':
	                time = this._d.valueOf();
	                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
	                break;
	        }
	
	        this._d.setTime(time);
	        hooks.updateOffset(this, true);
	        return this;
	    }
	
	    function valueOf() {
	        return this._d.valueOf() - (this._offset || 0) * 60000;
	    }
	
	    function unix() {
	        return Math.floor(this.valueOf() / 1000);
	    }
	
	    function toDate() {
	        return new Date(this.valueOf());
	    }
	
	    function toArray() {
	        var m = this;
	        return [
	            m.year(),
	            m.month(),
	            m.date(),
	            m.hour(),
	            m.minute(),
	            m.second(),
	            m.millisecond(),
	        ];
	    }
	
	    function toObject() {
	        var m = this;
	        return {
	            years: m.year(),
	            months: m.month(),
	            date: m.date(),
	            hours: m.hours(),
	            minutes: m.minutes(),
	            seconds: m.seconds(),
	            milliseconds: m.milliseconds(),
	        };
	    }
	
	    function toJSON() {
	        // new Date(NaN).toJSON() === null
	        return this.isValid() ? this.toISOString() : null;
	    }
	
	    function isValid$2() {
	        return isValid(this);
	    }
	
	    function parsingFlags() {
	        return extend({}, getParsingFlags(this));
	    }
	
	    function invalidAt() {
	        return getParsingFlags(this).overflow;
	    }
	
	    function creationData() {
	        return {
	            input: this._i,
	            format: this._f,
	            locale: this._locale,
	            isUTC: this._isUTC,
	            strict: this._strict,
	        };
	    }
	
	    addFormatToken('N', 0, 0, 'eraAbbr');
	    addFormatToken('NN', 0, 0, 'eraAbbr');
	    addFormatToken('NNN', 0, 0, 'eraAbbr');
	    addFormatToken('NNNN', 0, 0, 'eraName');
	    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
	
	    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
	    addFormatToken('y', ['yy', 2], 0, 'eraYear');
	    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
	    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
	
	    addRegexToken('N', matchEraAbbr);
	    addRegexToken('NN', matchEraAbbr);
	    addRegexToken('NNN', matchEraAbbr);
	    addRegexToken('NNNN', matchEraName);
	    addRegexToken('NNNNN', matchEraNarrow);
	
	    addParseToken(
	        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
	        function (input, array, config, token) {
	            var era = config._locale.erasParse(input, token, config._strict);
	            if (era) {
	                getParsingFlags(config).era = era;
	            } else {
	                getParsingFlags(config).invalidEra = input;
	            }
	        }
	    );
	
	    addRegexToken('y', matchUnsigned);
	    addRegexToken('yy', matchUnsigned);
	    addRegexToken('yyy', matchUnsigned);
	    addRegexToken('yyyy', matchUnsigned);
	    addRegexToken('yo', matchEraYearOrdinal);
	
	    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
	    addParseToken(['yo'], function (input, array, config, token) {
	        var match;
	        if (config._locale._eraYearOrdinalRegex) {
	            match = input.match(config._locale._eraYearOrdinalRegex);
	        }
	
	        if (config._locale.eraYearOrdinalParse) {
	            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
	        } else {
	            array[YEAR] = parseInt(input, 10);
	        }
	    });
	
	    function localeEras(m, format) {
	        var i,
	            l,
	            date,
	            eras = this._eras || getLocale('en')._eras;
	        for (i = 0, l = eras.length; i < l; ++i) {
	            switch (typeof eras[i].since) {
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].since).startOf('day');
	                    eras[i].since = date.valueOf();
	                    break;
	            }
	
	            switch (typeof eras[i].until) {
	                case 'undefined':
	                    eras[i].until = +Infinity;
	                    break;
	                case 'string':
	                    // truncate time
	                    date = hooks(eras[i].until).startOf('day').valueOf();
	                    eras[i].until = date.valueOf();
	                    break;
	            }
	        }
	        return eras;
	    }
	
	    function localeErasParse(eraName, format, strict) {
	        var i,
	            l,
	            eras = this.eras(),
	            name,
	            abbr,
	            narrow;
	        eraName = eraName.toUpperCase();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            name = eras[i].name.toUpperCase();
	            abbr = eras[i].abbr.toUpperCase();
	            narrow = eras[i].narrow.toUpperCase();
	
	            if (strict) {
	                switch (format) {
	                    case 'N':
	                    case 'NN':
	                    case 'NNN':
	                        if (abbr === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNN':
	                        if (name === eraName) {
	                            return eras[i];
	                        }
	                        break;
	
	                    case 'NNNNN':
	                        if (narrow === eraName) {
	                            return eras[i];
	                        }
	                        break;
	                }
	            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
	                return eras[i];
	            }
	        }
	    }
	
	    function localeErasConvertYear(era, year) {
	        var dir = era.since <= era.until ? +1 : -1;
	        if (year === undefined) {
	            return hooks(era.since).year();
	        } else {
	            return hooks(era.since).year() + (year - era.offset) * dir;
	        }
	    }
	
	    function getEraName() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].name;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].name;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraNarrow() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].narrow;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].narrow;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraAbbr() {
	        var i,
	            l,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (eras[i].since <= val && val <= eras[i].until) {
	                return eras[i].abbr;
	            }
	            if (eras[i].until <= val && val <= eras[i].since) {
	                return eras[i].abbr;
	            }
	        }
	
	        return '';
	    }
	
	    function getEraYear() {
	        var i,
	            l,
	            dir,
	            val,
	            eras = this.localeData().eras();
	        for (i = 0, l = eras.length; i < l; ++i) {
	            dir = eras[i].since <= eras[i].until ? +1 : -1;
	
	            // truncate time
	            val = this.clone().startOf('day').valueOf();
	
	            if (
	                (eras[i].since <= val && val <= eras[i].until) ||
	                (eras[i].until <= val && val <= eras[i].since)
	            ) {
	                return (
	                    (this.year() - hooks(eras[i].since).year()) * dir +
	                    eras[i].offset
	                );
	            }
	        }
	
	        return this.year();
	    }
	
	    function erasNameRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNameRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNameRegex : this._erasRegex;
	    }
	
	    function erasAbbrRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasAbbrRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasAbbrRegex : this._erasRegex;
	    }
	
	    function erasNarrowRegex(isStrict) {
	        if (!hasOwnProp(this, '_erasNarrowRegex')) {
	            computeErasParse.call(this);
	        }
	        return isStrict ? this._erasNarrowRegex : this._erasRegex;
	    }
	
	    function matchEraAbbr(isStrict, locale) {
	        return locale.erasAbbrRegex(isStrict);
	    }
	
	    function matchEraName(isStrict, locale) {
	        return locale.erasNameRegex(isStrict);
	    }
	
	    function matchEraNarrow(isStrict, locale) {
	        return locale.erasNarrowRegex(isStrict);
	    }
	
	    function matchEraYearOrdinal(isStrict, locale) {
	        return locale._eraYearOrdinalRegex || matchUnsigned;
	    }
	
	    function computeErasParse() {
	        var abbrPieces = [],
	            namePieces = [],
	            narrowPieces = [],
	            mixedPieces = [],
	            i,
	            l,
	            eras = this.eras();
	
	        for (i = 0, l = eras.length; i < l; ++i) {
	            namePieces.push(regexEscape(eras[i].name));
	            abbrPieces.push(regexEscape(eras[i].abbr));
	            narrowPieces.push(regexEscape(eras[i].narrow));
	
	            mixedPieces.push(regexEscape(eras[i].name));
	            mixedPieces.push(regexEscape(eras[i].abbr));
	            mixedPieces.push(regexEscape(eras[i].narrow));
	        }
	
	        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
	        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
	        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
	        this._erasNarrowRegex = new RegExp(
	            '^(' + narrowPieces.join('|') + ')',
	            'i'
	        );
	    }
	
	    // FORMATTING
	
	    addFormatToken(0, ['gg', 2], 0, function () {
	        return this.weekYear() % 100;
	    });
	
	    addFormatToken(0, ['GG', 2], 0, function () {
	        return this.isoWeekYear() % 100;
	    });
	
	    function addWeekYearFormatToken(token, getter) {
	        addFormatToken(0, [token, token.length], 0, getter);
	    }
	
	    addWeekYearFormatToken('gggg', 'weekYear');
	    addWeekYearFormatToken('ggggg', 'weekYear');
	    addWeekYearFormatToken('GGGG', 'isoWeekYear');
	    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
	
	    // ALIASES
	
	    addUnitAlias('weekYear', 'gg');
	    addUnitAlias('isoWeekYear', 'GG');
	
	    // PRIORITY
	
	    addUnitPriority('weekYear', 1);
	    addUnitPriority('isoWeekYear', 1);
	
	    // PARSING
	
	    addRegexToken('G', matchSigned);
	    addRegexToken('g', matchSigned);
	    addRegexToken('GG', match1to2, match2);
	    addRegexToken('gg', match1to2, match2);
	    addRegexToken('GGGG', match1to4, match4);
	    addRegexToken('gggg', match1to4, match4);
	    addRegexToken('GGGGG', match1to6, match6);
	    addRegexToken('ggggg', match1to6, match6);
	
	    addWeekParseToken(
	        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
	        function (input, week, config, token) {
	            week[token.substr(0, 2)] = toInt(input);
	        }
	    );
	
	    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
	        week[token] = hooks.parseTwoDigitYear(input);
	    });
	
	    // MOMENTS
	
	    function getSetWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.week(),
	            this.weekday(),
	            this.localeData()._week.dow,
	            this.localeData()._week.doy
	        );
	    }
	
	    function getSetISOWeekYear(input) {
	        return getSetWeekYearHelper.call(
	            this,
	            input,
	            this.isoWeek(),
	            this.isoWeekday(),
	            1,
	            4
	        );
	    }
	
	    function getISOWeeksInYear() {
	        return weeksInYear(this.year(), 1, 4);
	    }
	
	    function getISOWeeksInISOWeekYear() {
	        return weeksInYear(this.isoWeekYear(), 1, 4);
	    }
	
	    function getWeeksInYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getWeeksInWeekYear() {
	        var weekInfo = this.localeData()._week;
	        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
	    }
	
	    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
	        var weeksTarget;
	        if (input == null) {
	            return weekOfYear(this, dow, doy).year;
	        } else {
	            weeksTarget = weeksInYear(input, dow, doy);
	            if (week > weeksTarget) {
	                week = weeksTarget;
	            }
	            return setWeekAll.call(this, input, week, weekday, dow, doy);
	        }
	    }
	
	    function setWeekAll(weekYear, week, weekday, dow, doy) {
	        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
	            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
	
	        this.year(date.getUTCFullYear());
	        this.month(date.getUTCMonth());
	        this.date(date.getUTCDate());
	        return this;
	    }
	
	    // FORMATTING
	
	    addFormatToken('Q', 0, 'Qo', 'quarter');
	
	    // ALIASES
	
	    addUnitAlias('quarter', 'Q');
	
	    // PRIORITY
	
	    addUnitPriority('quarter', 7);
	
	    // PARSING
	
	    addRegexToken('Q', match1);
	    addParseToken('Q', function (input, array) {
	        array[MONTH] = (toInt(input) - 1) * 3;
	    });
	
	    // MOMENTS
	
	    function getSetQuarter(input) {
	        return input == null
	            ? Math.ceil((this.month() + 1) / 3)
	            : this.month((input - 1) * 3 + (this.month() % 3));
	    }
	
	    // FORMATTING
	
	    addFormatToken('D', ['DD', 2], 'Do', 'date');
	
	    // ALIASES
	
	    addUnitAlias('date', 'D');
	
	    // PRIORITY
	    addUnitPriority('date', 9);
	
	    // PARSING
	
	    addRegexToken('D', match1to2);
	    addRegexToken('DD', match1to2, match2);
	    addRegexToken('Do', function (isStrict, locale) {
	        // TODO: Remove "ordinalParse" fallback in next major release.
	        return isStrict
	            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
	            : locale._dayOfMonthOrdinalParseLenient;
	    });
	
	    addParseToken(['D', 'DD'], DATE);
	    addParseToken('Do', function (input, array) {
	        array[DATE] = toInt(input.match(match1to2)[0]);
	    });
	
	    // MOMENTS
	
	    var getSetDayOfMonth = makeGetSet('Date', true);
	
	    // FORMATTING
	
	    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');
	
	    // ALIASES
	
	    addUnitAlias('dayOfYear', 'DDD');
	
	    // PRIORITY
	    addUnitPriority('dayOfYear', 4);
	
	    // PARSING
	
	    addRegexToken('DDD', match1to3);
	    addRegexToken('DDDD', match3);
	    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
	        config._dayOfYear = toInt(input);
	    });
	
	    // HELPERS
	
	    // MOMENTS
	
	    function getSetDayOfYear(input) {
	        var dayOfYear =
	            Math.round(
	                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
	            ) + 1;
	        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
	    }
	
	    // FORMATTING
	
	    addFormatToken('m', ['mm', 2], 0, 'minute');
	
	    // ALIASES
	
	    addUnitAlias('minute', 'm');
	
	    // PRIORITY
	
	    addUnitPriority('minute', 14);
	
	    // PARSING
	
	    addRegexToken('m', match1to2);
	    addRegexToken('mm', match1to2, match2);
	    addParseToken(['m', 'mm'], MINUTE);
	
	    // MOMENTS
	
	    var getSetMinute = makeGetSet('Minutes', false);
	
	    // FORMATTING
	
	    addFormatToken('s', ['ss', 2], 0, 'second');
	
	    // ALIASES
	
	    addUnitAlias('second', 's');
	
	    // PRIORITY
	
	    addUnitPriority('second', 15);
	
	    // PARSING
	
	    addRegexToken('s', match1to2);
	    addRegexToken('ss', match1to2, match2);
	    addParseToken(['s', 'ss'], SECOND);
	
	    // MOMENTS
	
	    var getSetSecond = makeGetSet('Seconds', false);
	
	    // FORMATTING
	
	    addFormatToken('S', 0, 0, function () {
	        return ~~(this.millisecond() / 100);
	    });
	
	    addFormatToken(0, ['SS', 2], 0, function () {
	        return ~~(this.millisecond() / 10);
	    });
	
	    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
	    addFormatToken(0, ['SSSS', 4], 0, function () {
	        return this.millisecond() * 10;
	    });
	    addFormatToken(0, ['SSSSS', 5], 0, function () {
	        return this.millisecond() * 100;
	    });
	    addFormatToken(0, ['SSSSSS', 6], 0, function () {
	        return this.millisecond() * 1000;
	    });
	    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
	        return this.millisecond() * 10000;
	    });
	    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
	        return this.millisecond() * 100000;
	    });
	    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
	        return this.millisecond() * 1000000;
	    });
	
	    // ALIASES
	
	    addUnitAlias('millisecond', 'ms');
	
	    // PRIORITY
	
	    addUnitPriority('millisecond', 16);
	
	    // PARSING
	
	    addRegexToken('S', match1to3, match1);
	    addRegexToken('SS', match1to3, match2);
	    addRegexToken('SSS', match1to3, match3);
	
	    var token, getSetMillisecond;
	    for (token = 'SSSS'; token.length <= 9; token += 'S') {
	        addRegexToken(token, matchUnsigned);
	    }
	
	    function parseMs(input, array) {
	        array[MILLISECOND] = toInt(('0.' + input) * 1000);
	    }
	
	    for (token = 'S'; token.length <= 9; token += 'S') {
	        addParseToken(token, parseMs);
	    }
	
	    getSetMillisecond = makeGetSet('Milliseconds', false);
	
	    // FORMATTING
	
	    addFormatToken('z', 0, 0, 'zoneAbbr');
	    addFormatToken('zz', 0, 0, 'zoneName');
	
	    // MOMENTS
	
	    function getZoneAbbr() {
	        return this._isUTC ? 'UTC' : '';
	    }
	
	    function getZoneName() {
	        return this._isUTC ? 'Coordinated Universal Time' : '';
	    }
	
	    var proto = Moment.prototype;
	
	    proto.add = add;
	    proto.calendar = calendar$1;
	    proto.clone = clone;
	    proto.diff = diff;
	    proto.endOf = endOf;
	    proto.format = format;
	    proto.from = from;
	    proto.fromNow = fromNow;
	    proto.to = to;
	    proto.toNow = toNow;
	    proto.get = stringGet;
	    proto.invalidAt = invalidAt;
	    proto.isAfter = isAfter;
	    proto.isBefore = isBefore;
	    proto.isBetween = isBetween;
	    proto.isSame = isSame;
	    proto.isSameOrAfter = isSameOrAfter;
	    proto.isSameOrBefore = isSameOrBefore;
	    proto.isValid = isValid$2;
	    proto.lang = lang;
	    proto.locale = locale;
	    proto.localeData = localeData;
	    proto.max = prototypeMax;
	    proto.min = prototypeMin;
	    proto.parsingFlags = parsingFlags;
	    proto.set = stringSet;
	    proto.startOf = startOf;
	    proto.subtract = subtract;
	    proto.toArray = toArray;
	    proto.toObject = toObject;
	    proto.toDate = toDate;
	    proto.toISOString = toISOString;
	    proto.inspect = inspect;
	    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
	        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
	            return 'Moment<' + this.format() + '>';
	        };
	    }
	    proto.toJSON = toJSON;
	    proto.toString = toString;
	    proto.unix = unix;
	    proto.valueOf = valueOf;
	    proto.creationData = creationData;
	    proto.eraName = getEraName;
	    proto.eraNarrow = getEraNarrow;
	    proto.eraAbbr = getEraAbbr;
	    proto.eraYear = getEraYear;
	    proto.year = getSetYear;
	    proto.isLeapYear = getIsLeapYear;
	    proto.weekYear = getSetWeekYear;
	    proto.isoWeekYear = getSetISOWeekYear;
	    proto.quarter = proto.quarters = getSetQuarter;
	    proto.month = getSetMonth;
	    proto.daysInMonth = getDaysInMonth;
	    proto.week = proto.weeks = getSetWeek;
	    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
	    proto.weeksInYear = getWeeksInYear;
	    proto.weeksInWeekYear = getWeeksInWeekYear;
	    proto.isoWeeksInYear = getISOWeeksInYear;
	    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
	    proto.date = getSetDayOfMonth;
	    proto.day = proto.days = getSetDayOfWeek;
	    proto.weekday = getSetLocaleDayOfWeek;
	    proto.isoWeekday = getSetISODayOfWeek;
	    proto.dayOfYear = getSetDayOfYear;
	    proto.hour = proto.hours = getSetHour;
	    proto.minute = proto.minutes = getSetMinute;
	    proto.second = proto.seconds = getSetSecond;
	    proto.millisecond = proto.milliseconds = getSetMillisecond;
	    proto.utcOffset = getSetOffset;
	    proto.utc = setOffsetToUTC;
	    proto.local = setOffsetToLocal;
	    proto.parseZone = setOffsetToParsedOffset;
	    proto.hasAlignedHourOffset = hasAlignedHourOffset;
	    proto.isDST = isDaylightSavingTime;
	    proto.isLocal = isLocal;
	    proto.isUtcOffset = isUtcOffset;
	    proto.isUtc = isUtc;
	    proto.isUTC = isUtc;
	    proto.zoneAbbr = getZoneAbbr;
	    proto.zoneName = getZoneName;
	    proto.dates = deprecate(
	        'dates accessor is deprecated. Use date instead.',
	        getSetDayOfMonth
	    );
	    proto.months = deprecate(
	        'months accessor is deprecated. Use month instead',
	        getSetMonth
	    );
	    proto.years = deprecate(
	        'years accessor is deprecated. Use year instead',
	        getSetYear
	    );
	    proto.zone = deprecate(
	        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
	        getSetZone
	    );
	    proto.isDSTShifted = deprecate(
	        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
	        isDaylightSavingTimeShifted
	    );
	
	    function createUnix(input) {
	        return createLocal(input * 1000);
	    }
	
	    function createInZone() {
	        return createLocal.apply(null, arguments).parseZone();
	    }
	
	    function preParsePostFormat(string) {
	        return string;
	    }
	
	    var proto$1 = Locale.prototype;
	
	    proto$1.calendar = calendar;
	    proto$1.longDateFormat = longDateFormat;
	    proto$1.invalidDate = invalidDate;
	    proto$1.ordinal = ordinal;
	    proto$1.preparse = preParsePostFormat;
	    proto$1.postformat = preParsePostFormat;
	    proto$1.relativeTime = relativeTime;
	    proto$1.pastFuture = pastFuture;
	    proto$1.set = set;
	    proto$1.eras = localeEras;
	    proto$1.erasParse = localeErasParse;
	    proto$1.erasConvertYear = localeErasConvertYear;
	    proto$1.erasAbbrRegex = erasAbbrRegex;
	    proto$1.erasNameRegex = erasNameRegex;
	    proto$1.erasNarrowRegex = erasNarrowRegex;
	
	    proto$1.months = localeMonths;
	    proto$1.monthsShort = localeMonthsShort;
	    proto$1.monthsParse = localeMonthsParse;
	    proto$1.monthsRegex = monthsRegex;
	    proto$1.monthsShortRegex = monthsShortRegex;
	    proto$1.week = localeWeek;
	    proto$1.firstDayOfYear = localeFirstDayOfYear;
	    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
	
	    proto$1.weekdays = localeWeekdays;
	    proto$1.weekdaysMin = localeWeekdaysMin;
	    proto$1.weekdaysShort = localeWeekdaysShort;
	    proto$1.weekdaysParse = localeWeekdaysParse;
	
	    proto$1.weekdaysRegex = weekdaysRegex;
	    proto$1.weekdaysShortRegex = weekdaysShortRegex;
	    proto$1.weekdaysMinRegex = weekdaysMinRegex;
	
	    proto$1.isPM = localeIsPM;
	    proto$1.meridiem = localeMeridiem;
	
	    function get$1(format, index, field, setter) {
	        var locale = getLocale(),
	            utc = createUTC().set(setter, index);
	        return locale[field](utc, format);
	    }
	
	    function listMonthsImpl(format, index, field) {
	        if (isNumber(format)) {
	            index = format;
	            format = undefined;
	        }
	
	        format = format || '';
	
	        if (index != null) {
	            return get$1(format, index, field, 'month');
	        }
	
	        var i,
	            out = [];
	        for (i = 0; i < 12; i++) {
	            out[i] = get$1(format, i, field, 'month');
	        }
	        return out;
	    }
	
	    // ()
	    // (5)
	    // (fmt, 5)
	    // (fmt)
	    // (true)
	    // (true, 5)
	    // (true, fmt, 5)
	    // (true, fmt)
	    function listWeekdaysImpl(localeSorted, format, index, field) {
	        if (typeof localeSorted === 'boolean') {
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        } else {
	            format = localeSorted;
	            index = format;
	            localeSorted = false;
	
	            if (isNumber(format)) {
	                index = format;
	                format = undefined;
	            }
	
	            format = format || '';
	        }
	
	        var locale = getLocale(),
	            shift = localeSorted ? locale._week.dow : 0,
	            i,
	            out = [];
	
	        if (index != null) {
	            return get$1(format, (index + shift) % 7, field, 'day');
	        }
	
	        for (i = 0; i < 7; i++) {
	            out[i] = get$1(format, (i + shift) % 7, field, 'day');
	        }
	        return out;
	    }
	
	    function listMonths(format, index) {
	        return listMonthsImpl(format, index, 'months');
	    }
	
	    function listMonthsShort(format, index) {
	        return listMonthsImpl(format, index, 'monthsShort');
	    }
	
	    function listWeekdays(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
	    }
	
	    function listWeekdaysShort(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
	    }
	
	    function listWeekdaysMin(localeSorted, format, index) {
	        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
	    }
	
	    getSetGlobalLocale('en', {
	        eras: [
	            {
	                since: '0001-01-01',
	                until: +Infinity,
	                offset: 1,
	                name: 'Anno Domini',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: 'Before Christ',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    toInt((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    // Side effect imports
	
	    hooks.lang = deprecate(
	        'moment.lang is deprecated. Use moment.locale instead.',
	        getSetGlobalLocale
	    );
	    hooks.langData = deprecate(
	        'moment.langData is deprecated. Use moment.localeData instead.',
	        getLocale
	    );
	
	    var mathAbs = Math.abs;
	
	    function abs() {
	        var data = this._data;
	
	        this._milliseconds = mathAbs(this._milliseconds);
	        this._days = mathAbs(this._days);
	        this._months = mathAbs(this._months);
	
	        data.milliseconds = mathAbs(data.milliseconds);
	        data.seconds = mathAbs(data.seconds);
	        data.minutes = mathAbs(data.minutes);
	        data.hours = mathAbs(data.hours);
	        data.months = mathAbs(data.months);
	        data.years = mathAbs(data.years);
	
	        return this;
	    }
	
	    function addSubtract$1(duration, input, value, direction) {
	        var other = createDuration(input, value);
	
	        duration._milliseconds += direction * other._milliseconds;
	        duration._days += direction * other._days;
	        duration._months += direction * other._months;
	
	        return duration._bubble();
	    }
	
	    // supports only 2.0-style add(1, 's') or add(duration)
	    function add$1(input, value) {
	        return addSubtract$1(this, input, value, 1);
	    }
	
	    // supports only 2.0-style subtract(1, 's') or subtract(duration)
	    function subtract$1(input, value) {
	        return addSubtract$1(this, input, value, -1);
	    }
	
	    function absCeil(number) {
	        if (number < 0) {
	            return Math.floor(number);
	        } else {
	            return Math.ceil(number);
	        }
	    }
	
	    function bubble() {
	        var milliseconds = this._milliseconds,
	            days = this._days,
	            months = this._months,
	            data = this._data,
	            seconds,
	            minutes,
	            hours,
	            years,
	            monthsFromDays;
	
	        // if we have a mix of positive and negative values, bubble down first
	        // check: https://github.com/moment/moment/issues/2166
	        if (
	            !(
	                (milliseconds >= 0 && days >= 0 && months >= 0) ||
	                (milliseconds <= 0 && days <= 0 && months <= 0)
	            )
	        ) {
	            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
	            days = 0;
	            months = 0;
	        }
	
	        // The following code bubbles up values, see the tests for
	        // examples of what that means.
	        data.milliseconds = milliseconds % 1000;
	
	        seconds = absFloor(milliseconds / 1000);
	        data.seconds = seconds % 60;
	
	        minutes = absFloor(seconds / 60);
	        data.minutes = minutes % 60;
	
	        hours = absFloor(minutes / 60);
	        data.hours = hours % 24;
	
	        days += absFloor(hours / 24);
	
	        // convert days to months
	        monthsFromDays = absFloor(daysToMonths(days));
	        months += monthsFromDays;
	        days -= absCeil(monthsToDays(monthsFromDays));
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        data.days = days;
	        data.months = months;
	        data.years = years;
	
	        return this;
	    }
	
	    function daysToMonths(days) {
	        // 400 years have 146097 days (taking into account leap year rules)
	        // 400 years have 12 months === 4800
	        return (days * 4800) / 146097;
	    }
	
	    function monthsToDays(months) {
	        // the reverse of daysToMonths
	        return (months * 146097) / 4800;
	    }
	
	    function as(units) {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        var days,
	            months,
	            milliseconds = this._milliseconds;
	
	        units = normalizeUnits(units);
	
	        if (units === 'month' || units === 'quarter' || units === 'year') {
	            days = this._days + milliseconds / 864e5;
	            months = this._months + daysToMonths(days);
	            switch (units) {
	                case 'month':
	                    return months;
	                case 'quarter':
	                    return months / 3;
	                case 'year':
	                    return months / 12;
	            }
	        } else {
	            // handle milliseconds separately because of floating point math errors (issue #1867)
	            days = this._days + Math.round(monthsToDays(this._months));
	            switch (units) {
	                case 'week':
	                    return days / 7 + milliseconds / 6048e5;
	                case 'day':
	                    return days + milliseconds / 864e5;
	                case 'hour':
	                    return days * 24 + milliseconds / 36e5;
	                case 'minute':
	                    return days * 1440 + milliseconds / 6e4;
	                case 'second':
	                    return days * 86400 + milliseconds / 1000;
	                // Math.floor prevents floating point math errors here
	                case 'millisecond':
	                    return Math.floor(days * 864e5) + milliseconds;
	                default:
	                    throw new Error('Unknown unit ' + units);
	            }
	        }
	    }
	
	    // TODO: Use this.as('ms')?
	    function valueOf$1() {
	        if (!this.isValid()) {
	            return NaN;
	        }
	        return (
	            this._milliseconds +
	            this._days * 864e5 +
	            (this._months % 12) * 2592e6 +
	            toInt(this._months / 12) * 31536e6
	        );
	    }
	
	    function makeAs(alias) {
	        return function () {
	            return this.as(alias);
	        };
	    }
	
	    var asMilliseconds = makeAs('ms'),
	        asSeconds = makeAs('s'),
	        asMinutes = makeAs('m'),
	        asHours = makeAs('h'),
	        asDays = makeAs('d'),
	        asWeeks = makeAs('w'),
	        asMonths = makeAs('M'),
	        asQuarters = makeAs('Q'),
	        asYears = makeAs('y');
	
	    function clone$1() {
	        return createDuration(this);
	    }
	
	    function get$2(units) {
	        units = normalizeUnits(units);
	        return this.isValid() ? this[units + 's']() : NaN;
	    }
	
	    function makeGetter(name) {
	        return function () {
	            return this.isValid() ? this._data[name] : NaN;
	        };
	    }
	
	    var milliseconds = makeGetter('milliseconds'),
	        seconds = makeGetter('seconds'),
	        minutes = makeGetter('minutes'),
	        hours = makeGetter('hours'),
	        days = makeGetter('days'),
	        months = makeGetter('months'),
	        years = makeGetter('years');
	
	    function weeks() {
	        return absFloor(this.days() / 7);
	    }
	
	    var round = Math.round,
	        thresholds = {
	            ss: 44, // a few seconds to seconds
	            s: 45, // seconds to minute
	            m: 45, // minutes to hour
	            h: 22, // hours to day
	            d: 26, // days to month/week
	            w: null, // weeks to month
	            M: 11, // months to year
	        };
	
	    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
	    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
	        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
	    }
	
	    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
	        var duration = createDuration(posNegDuration).abs(),
	            seconds = round(duration.as('s')),
	            minutes = round(duration.as('m')),
	            hours = round(duration.as('h')),
	            days = round(duration.as('d')),
	            months = round(duration.as('M')),
	            weeks = round(duration.as('w')),
	            years = round(duration.as('y')),
	            a =
	                (seconds <= thresholds.ss && ['s', seconds]) ||
	                (seconds < thresholds.s && ['ss', seconds]) ||
	                (minutes <= 1 && ['m']) ||
	                (minutes < thresholds.m && ['mm', minutes]) ||
	                (hours <= 1 && ['h']) ||
	                (hours < thresholds.h && ['hh', hours]) ||
	                (days <= 1 && ['d']) ||
	                (days < thresholds.d && ['dd', days]);
	
	        if (thresholds.w != null) {
	            a =
	                a ||
	                (weeks <= 1 && ['w']) ||
	                (weeks < thresholds.w && ['ww', weeks]);
	        }
	        a = a ||
	            (months <= 1 && ['M']) ||
	            (months < thresholds.M && ['MM', months]) ||
	            (years <= 1 && ['y']) || ['yy', years];
	
	        a[2] = withoutSuffix;
	        a[3] = +posNegDuration > 0;
	        a[4] = locale;
	        return substituteTimeAgo.apply(null, a);
	    }
	
	    // This function allows you to set the rounding function for relative time strings
	    function getSetRelativeTimeRounding(roundingFunction) {
	        if (roundingFunction === undefined) {
	            return round;
	        }
	        if (typeof roundingFunction === 'function') {
	            round = roundingFunction;
	            return true;
	        }
	        return false;
	    }
	
	    // This function allows you to set a threshold for relative time strings
	    function getSetRelativeTimeThreshold(threshold, limit) {
	        if (thresholds[threshold] === undefined) {
	            return false;
	        }
	        if (limit === undefined) {
	            return thresholds[threshold];
	        }
	        thresholds[threshold] = limit;
	        if (threshold === 's') {
	            thresholds.ss = limit - 1;
	        }
	        return true;
	    }
	
	    function humanize(argWithSuffix, argThresholds) {
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var withSuffix = false,
	            th = thresholds,
	            locale,
	            output;
	
	        if (typeof argWithSuffix === 'object') {
	            argThresholds = argWithSuffix;
	            argWithSuffix = false;
	        }
	        if (typeof argWithSuffix === 'boolean') {
	            withSuffix = argWithSuffix;
	        }
	        if (typeof argThresholds === 'object') {
	            th = Object.assign({}, thresholds, argThresholds);
	            if (argThresholds.s != null && argThresholds.ss == null) {
	                th.ss = argThresholds.s - 1;
	            }
	        }
	
	        locale = this.localeData();
	        output = relativeTime$1(this, !withSuffix, th, locale);
	
	        if (withSuffix) {
	            output = locale.pastFuture(+this, output);
	        }
	
	        return locale.postformat(output);
	    }
	
	    var abs$1 = Math.abs;
	
	    function sign(x) {
	        return (x > 0) - (x < 0) || +x;
	    }
	
	    function toISOString$1() {
	        // for ISO strings we do not use the normal bubbling rules:
	        //  * milliseconds bubble up until they become hours
	        //  * days do not bubble at all
	        //  * months bubble up until they become years
	        // This is because there is no context-free conversion between hours and days
	        // (think of clock changes)
	        // and also not between days and months (28-31 days per month)
	        if (!this.isValid()) {
	            return this.localeData().invalidDate();
	        }
	
	        var seconds = abs$1(this._milliseconds) / 1000,
	            days = abs$1(this._days),
	            months = abs$1(this._months),
	            minutes,
	            hours,
	            years,
	            s,
	            total = this.asSeconds(),
	            totalSign,
	            ymSign,
	            daysSign,
	            hmsSign;
	
	        if (!total) {
	            // this is the same as C#'s (Noda) and python (isodate)...
	            // but not other JS (goog.date)
	            return 'P0D';
	        }
	
	        // 3600 seconds -> 60 minutes -> 1 hour
	        minutes = absFloor(seconds / 60);
	        hours = absFloor(minutes / 60);
	        seconds %= 60;
	        minutes %= 60;
	
	        // 12 months -> 1 year
	        years = absFloor(months / 12);
	        months %= 12;
	
	        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
	        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
	
	        totalSign = total < 0 ? '-' : '';
	        ymSign = sign(this._months) !== sign(total) ? '-' : '';
	        daysSign = sign(this._days) !== sign(total) ? '-' : '';
	        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
	
	        return (
	            totalSign +
	            'P' +
	            (years ? ymSign + years + 'Y' : '') +
	            (months ? ymSign + months + 'M' : '') +
	            (days ? daysSign + days + 'D' : '') +
	            (hours || minutes || seconds ? 'T' : '') +
	            (hours ? hmsSign + hours + 'H' : '') +
	            (minutes ? hmsSign + minutes + 'M' : '') +
	            (seconds ? hmsSign + s + 'S' : '')
	        );
	    }
	
	    var proto$2 = Duration.prototype;
	
	    proto$2.isValid = isValid$1;
	    proto$2.abs = abs;
	    proto$2.add = add$1;
	    proto$2.subtract = subtract$1;
	    proto$2.as = as;
	    proto$2.asMilliseconds = asMilliseconds;
	    proto$2.asSeconds = asSeconds;
	    proto$2.asMinutes = asMinutes;
	    proto$2.asHours = asHours;
	    proto$2.asDays = asDays;
	    proto$2.asWeeks = asWeeks;
	    proto$2.asMonths = asMonths;
	    proto$2.asQuarters = asQuarters;
	    proto$2.asYears = asYears;
	    proto$2.valueOf = valueOf$1;
	    proto$2._bubble = bubble;
	    proto$2.clone = clone$1;
	    proto$2.get = get$2;
	    proto$2.milliseconds = milliseconds;
	    proto$2.seconds = seconds;
	    proto$2.minutes = minutes;
	    proto$2.hours = hours;
	    proto$2.days = days;
	    proto$2.weeks = weeks;
	    proto$2.months = months;
	    proto$2.years = years;
	    proto$2.humanize = humanize;
	    proto$2.toISOString = toISOString$1;
	    proto$2.toString = toISOString$1;
	    proto$2.toJSON = toISOString$1;
	    proto$2.locale = locale;
	    proto$2.localeData = localeData;
	
	    proto$2.toIsoString = deprecate(
	        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
	        toISOString$1
	    );
	    proto$2.lang = lang;
	
	    // FORMATTING
	
	    addFormatToken('X', 0, 0, 'unix');
	    addFormatToken('x', 0, 0, 'valueOf');
	
	    // PARSING
	
	    addRegexToken('x', matchSigned);
	    addRegexToken('X', matchTimestamp);
	    addParseToken('X', function (input, array, config) {
	        config._d = new Date(parseFloat(input) * 1000);
	    });
	    addParseToken('x', function (input, array, config) {
	        config._d = new Date(toInt(input));
	    });
	
	    //! moment.js
	
	    hooks.version = '2.29.4';
	
	    setHookCallback(createLocal);
	
	    hooks.fn = proto;
	    hooks.min = min;
	    hooks.max = max;
	    hooks.now = now;
	    hooks.utc = createUTC;
	    hooks.unix = createUnix;
	    hooks.months = listMonths;
	    hooks.isDate = isDate;
	    hooks.locale = getSetGlobalLocale;
	    hooks.invalid = createInvalid;
	    hooks.duration = createDuration;
	    hooks.isMoment = isMoment;
	    hooks.weekdays = listWeekdays;
	    hooks.parseZone = createInZone;
	    hooks.localeData = getLocale;
	    hooks.isDuration = isDuration;
	    hooks.monthsShort = listMonthsShort;
	    hooks.weekdaysMin = listWeekdaysMin;
	    hooks.defineLocale = defineLocale;
	    hooks.updateLocale = updateLocale;
	    hooks.locales = listLocales;
	    hooks.weekdaysShort = listWeekdaysShort;
	    hooks.normalizeUnits = normalizeUnits;
	    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
	    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
	    hooks.calendarFormat = getCalendarFormat;
	    hooks.prototype = proto;
	
	    // currently HTML5 input type only supports 24-hour formats
	    hooks.HTML5_FMT = {
	        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
	        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
	        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
	        DATE: 'YYYY-MM-DD', // <input type="date" />
	        TIME: 'HH:mm', // <input type="time" />
	        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
	        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
	        WEEK: 'GGGG-[W]WW', // <input type="week" />
	        MONTH: 'YYYY-MM', // <input type="month" />
	    };
	
	    return hooks;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)(module)))

/***/ },
/* 4 */
/***/ function(module, exports) {

	/**
	 * @module zrender/core/util
	 */
	// 用于处理merge时无法遍历Date等对象的问题
	var BUILTIN_OBJECT = {
	  '[object Function]': 1,
	  '[object RegExp]': 1,
	  '[object Date]': 1,
	  '[object Error]': 1,
	  '[object CanvasGradient]': 1,
	  '[object CanvasPattern]': 1,
	  // For node-canvas
	  '[object Image]': 1,
	  '[object Canvas]': 1
	};
	var TYPED_ARRAY = {
	  '[object Int8Array]': 1,
	  '[object Uint8Array]': 1,
	  '[object Uint8ClampedArray]': 1,
	  '[object Int16Array]': 1,
	  '[object Uint16Array]': 1,
	  '[object Int32Array]': 1,
	  '[object Uint32Array]': 1,
	  '[object Float32Array]': 1,
	  '[object Float64Array]': 1
	};
	var objToString = Object.prototype.toString;
	var arrayProto = Array.prototype;
	var nativeForEach = arrayProto.forEach;
	var nativeFilter = arrayProto.filter;
	var nativeSlice = arrayProto.slice;
	var nativeMap = arrayProto.map;
	var nativeReduce = arrayProto.reduce; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  // Clear ctx instance for different environment
	  if (name === 'createCanvas') {
	    _ctx = null;
	  }
	
	  methods[name] = fn;
	}
	/**
	 * Those data types can be cloned:
	 *     Plain object, Array, TypedArray, number, string, null, undefined.
	 * Those data types will be assgined using the orginal data:
	 *     BUILTIN_OBJECT
	 * Instance of user defined class will be cloned to a plain object, without
	 * properties in prototype.
	 * Other data types is not supported (not sure what will happen).
	 *
	 * Caution: do not support clone Date, for performance consideration.
	 * (There might be a large number of date in `series.data`).
	 * So date should not be modified in and out of echarts.
	 *
	 * @param {*} source
	 * @return {*} new
	 */
	
	
	function clone(source) {
	  if (source == null || typeof source !== 'object') {
	    return source;
	  }
	
	  var result = source;
	  var typeStr = objToString.call(source);
	
	  if (typeStr === '[object Array]') {
	    if (!isPrimitive(source)) {
	      result = [];
	
	      for (var i = 0, len = source.length; i < len; i++) {
	        result[i] = clone(source[i]);
	      }
	    }
	  } else if (TYPED_ARRAY[typeStr]) {
	    if (!isPrimitive(source)) {
	      var Ctor = source.constructor;
	
	      if (source.constructor.from) {
	        result = Ctor.from(source);
	      } else {
	        result = new Ctor(source.length);
	
	        for (var i = 0, len = source.length; i < len; i++) {
	          result[i] = clone(source[i]);
	        }
	      }
	    }
	  } else if (!BUILTIN_OBJECT[typeStr] && !isPrimitive(source) && !isDom(source)) {
	    result = {};
	
	    for (var key in source) {
	      if (source.hasOwnProperty(key)) {
	        result[key] = clone(source[key]);
	      }
	    }
	  }
	
	  return result;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overwrite=false]
	 */
	
	
	function merge(target, source, overwrite) {
	  // We should escapse that source is string
	  // and enter for ... in ...
	  if (!isObject(source) || !isObject(target)) {
	    return overwrite ? clone(source) : target;
	  }
	
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      var targetProp = target[key];
	      var sourceProp = source[key];
	
	      if (isObject(sourceProp) && isObject(targetProp) && !isArray(sourceProp) && !isArray(targetProp) && !isDom(sourceProp) && !isDom(targetProp) && !isBuiltInObject(sourceProp) && !isBuiltInObject(targetProp) && !isPrimitive(sourceProp) && !isPrimitive(targetProp)) {
	        // 如果需要递归覆盖，就递归调用merge
	        merge(targetProp, sourceProp, overwrite);
	      } else if (overwrite || !(key in target)) {
	        // 否则只处理overwrite为true，或者在目标对象中没有此属性的情况
	        // NOTE，在 target[key] 不存在的时候也是直接覆盖
	        target[key] = clone(source[key], true);
	      }
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {Array} targetAndSources The first item is target, and the rests are source.
	 * @param {boolean} [overwrite=false]
	 * @return {*} target
	 */
	
	
	function mergeAll(targetAndSources, overwrite) {
	  var result = targetAndSources[0];
	
	  for (var i = 1, len = targetAndSources.length; i < len; i++) {
	    result = merge(result, targetAndSources[i], overwrite);
	  }
	
	  return result;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @memberOf module:zrender/core/util
	 */
	
	
	function extend(target, source) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	/**
	 * @param {*} target
	 * @param {*} source
	 * @param {boolean} [overlay=false]
	 * @memberOf module:zrender/core/util
	 */
	
	
	function defaults(target, source, overlay) {
	  for (var key in source) {
	    if (source.hasOwnProperty(key) && (overlay ? source[key] != null : target[key] == null)) {
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	var createCanvas = function () {
	  return methods.createCanvas();
	};
	
	methods.createCanvas = function () {
	  return document.createElement('canvas');
	}; // FIXME
	
	
	var _ctx;
	
	function getContext() {
	  if (!_ctx) {
	    // Use util.createCanvas instead of createCanvas
	    // because createCanvas may be overwritten in different environment
	    _ctx = createCanvas().getContext('2d');
	  }
	
	  return _ctx;
	}
	/**
	 * 查询数组中元素的index
	 * @memberOf module:zrender/core/util
	 */
	
	
	function indexOf(array, value) {
	  if (array) {
	    if (array.indexOf) {
	      return array.indexOf(value);
	    }
	
	    for (var i = 0, len = array.length; i < len; i++) {
	      if (array[i] === value) {
	        return i;
	      }
	    }
	  }
	
	  return -1;
	}
	/**
	 * 构造类继承关系
	 *
	 * @memberOf module:zrender/core/util
	 * @param {Function} clazz 源类
	 * @param {Function} baseClazz 基类
	 */
	
	
	function inherits(clazz, baseClazz) {
	  var clazzPrototype = clazz.prototype;
	
	  function F() {}
	
	  F.prototype = baseClazz.prototype;
	  clazz.prototype = new F();
	
	  for (var prop in clazzPrototype) {
	    if (clazzPrototype.hasOwnProperty(prop)) {
	      clazz.prototype[prop] = clazzPrototype[prop];
	    }
	  }
	
	  clazz.prototype.constructor = clazz;
	  clazz.superClass = baseClazz;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Object|Function} target
	 * @param {Object|Function} sorce
	 * @param {boolean} overlay
	 */
	
	
	function mixin(target, source, overlay) {
	  target = 'prototype' in target ? target.prototype : target;
	  source = 'prototype' in source ? source.prototype : source;
	  defaults(target, source, overlay);
	}
	/**
	 * Consider typed array.
	 * @param {Array|TypedArray} data
	 */
	
	
	function isArrayLike(data) {
	  if (!data) {
	    return;
	  }
	
	  if (typeof data === 'string') {
	    return false;
	  }
	
	  return typeof data.length === 'number';
	}
	/**
	 * 数组或对象遍历
	 * @memberOf module:zrender/core/util
	 * @param {Object|Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 */
	
	
	function each(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.forEach && obj.forEach === nativeForEach) {
	    obj.forEach(cb, context);
	  } else if (obj.length === +obj.length) {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      cb.call(context, obj[i], i, obj);
	    }
	  } else {
	    for (var key in obj) {
	      if (obj.hasOwnProperty(key)) {
	        cb.call(context, obj[key], key, obj);
	      }
	    }
	  }
	}
	/**
	 * 数组映射
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function map(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.map && obj.map === nativeMap) {
	    return obj.map(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      result.push(cb.call(context, obj[i], i, obj));
	    }
	
	    return result;
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {Object} [memo]
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function reduce(obj, cb, memo, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.reduce && obj.reduce === nativeReduce) {
	    return obj.reduce(cb, memo, context);
	  } else {
	    for (var i = 0, len = obj.length; i < len; i++) {
	      memo = cb.call(context, memo, obj[i], i, obj);
	    }
	
	    return memo;
	  }
	}
	/**
	 * 数组过滤
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {Array}
	 */
	
	
	function filter(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  if (obj.filter && obj.filter === nativeFilter) {
	    return obj.filter(cb, context);
	  } else {
	    var result = [];
	
	    for (var i = 0, len = obj.length; i < len; i++) {
	      if (cb.call(context, obj[i], i, obj)) {
	        result.push(obj[i]);
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * 数组项查找
	 * @memberOf module:zrender/core/util
	 * @param {Array} obj
	 * @param {Function} cb
	 * @param {*} [context]
	 * @return {*}
	 */
	
	
	function find(obj, cb, context) {
	  if (!(obj && cb)) {
	    return;
	  }
	
	  for (var i = 0, len = obj.length; i < len; i++) {
	    if (cb.call(context, obj[i], i, obj)) {
	      return obj[i];
	    }
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @param {*} context
	 * @return {Function}
	 */
	
	
	function bind(func, context) {
	  var args = nativeSlice.call(arguments, 2);
	  return function () {
	    return func.apply(context, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Function} func
	 * @return {Function}
	 */
	
	
	function curry(func) {
	  var args = nativeSlice.call(arguments, 1);
	  return function () {
	    return func.apply(this, args.concat(nativeSlice.call(arguments)));
	  };
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isArray(value) {
	  return objToString.call(value) === '[object Array]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isFunction(value) {
	  return typeof value === 'function';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isString(value) {
	  return objToString.call(value) === '[object String]';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isObject(value) {
	  // Avoid a V8 JIT bug in Chrome 19-20.
	  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
	  var type = typeof value;
	  return type === 'function' || !!value && type === 'object';
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isBuiltInObject(value) {
	  return !!BUILTIN_OBJECT[objToString.call(value)];
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isTypedArray(value) {
	  return !!TYPED_ARRAY[objToString.call(value)];
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function isDom(value) {
	  return typeof value === 'object' && typeof value.nodeType === 'number' && typeof value.ownerDocument === 'object';
	}
	/**
	 * Whether is exactly NaN. Notice isNaN('a') returns true.
	 * @param {*} value
	 * @return {boolean}
	 */
	
	
	function eqNaN(value) {
	  /* eslint-disable-next-line no-self-compare */
	  return value !== value;
	}
	/**
	 * If value1 is not null, then return value1, otherwise judget rest of values.
	 * Low performance.
	 * @memberOf module:zrender/core/util
	 * @return {*} Final value
	 */
	
	
	function retrieve(values) {
	  for (var i = 0, len = arguments.length; i < len; i++) {
	    if (arguments[i] != null) {
	      return arguments[i];
	    }
	  }
	}
	
	function retrieve2(value0, value1) {
	  return value0 != null ? value0 : value1;
	}
	
	function retrieve3(value0, value1, value2) {
	  return value0 != null ? value0 : value1 != null ? value1 : value2;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {Array} arr
	 * @param {number} startIndex
	 * @param {number} endIndex
	 * @return {Array}
	 */
	
	
	function slice() {
	  return Function.call.apply(nativeSlice, arguments);
	}
	/**
	 * Normalize css liked array configuration
	 * e.g.
	 *  3 => [3, 3, 3, 3]
	 *  [4, 2] => [4, 2, 4, 2]
	 *  [4, 3, 2] => [4, 3, 2, 3]
	 * @param {number|Array.<number>} val
	 * @return {Array.<number>}
	 */
	
	
	function normalizeCssArray(val) {
	  if (typeof val === 'number') {
	    return [val, val, val, val];
	  }
	
	  var len = val.length;
	
	  if (len === 2) {
	    // vertical | horizontal
	    return [val[0], val[1], val[0], val[1]];
	  } else if (len === 3) {
	    // top | horizontal | bottom
	    return [val[0], val[1], val[2], val[1]];
	  }
	
	  return val;
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {boolean} condition
	 * @param {string} message
	 */
	
	
	function assert(condition, message) {
	  if (!condition) {
	    throw new Error(message);
	  }
	}
	/**
	 * @memberOf module:zrender/core/util
	 * @param {string} str string to be trimed
	 * @return {string} trimed string
	 */
	
	
	function trim(str) {
	  if (str == null) {
	    return null;
	  } else if (typeof str.trim === 'function') {
	    return str.trim();
	  } else {
	    return str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '');
	  }
	}
	
	var primitiveKey = '__ec_primitive__';
	/**
	 * Set an object as primitive to be ignored traversing children in clone or merge
	 */
	
	function setAsPrimitive(obj) {
	  obj[primitiveKey] = true;
	}
	
	function isPrimitive(obj) {
	  return obj[primitiveKey];
	}
	/**
	 * @constructor
	 * @param {Object} obj Only apply `ownProperty`.
	 */
	
	
	function HashMap(obj) {
	  var isArr = isArray(obj); // Key should not be set on this, otherwise
	  // methods get/set/... may be overrided.
	
	  this.data = {};
	  var thisMap = this;
	  obj instanceof HashMap ? obj.each(visit) : obj && each(obj, visit);
	
	  function visit(value, key) {
	    isArr ? thisMap.set(value, key) : thisMap.set(key, value);
	  }
	}
	
	HashMap.prototype = {
	  constructor: HashMap,
	  // Do not provide `has` method to avoid defining what is `has`.
	  // (We usually treat `null` and `undefined` as the same, different
	  // from ES6 Map).
	  get: function (key) {
	    return this.data.hasOwnProperty(key) ? this.data[key] : null;
	  },
	  set: function (key, value) {
	    // Comparing with invocation chaining, `return value` is more commonly
	    // used in this case: `var someVal = map.set('a', genVal());`
	    return this.data[key] = value;
	  },
	  // Although util.each can be performed on this hashMap directly, user
	  // should not use the exposed keys, who are prefixed.
	  each: function (cb, context) {
	    context !== void 0 && (cb = bind(cb, context));
	    /* eslint-disable guard-for-in */
	
	    for (var key in this.data) {
	      this.data.hasOwnProperty(key) && cb(this.data[key], key);
	    }
	    /* eslint-enable guard-for-in */
	
	  },
	  // Do not use this method if performance sensitive.
	  removeKey: function (key) {
	    delete this.data[key];
	  }
	};
	
	function createHashMap(obj) {
	  return new HashMap(obj);
	}
	
	function concatArray(a, b) {
	  var newArray = new a.constructor(a.length + b.length);
	
	  for (var i = 0; i < a.length; i++) {
	    newArray[i] = a[i];
	  }
	
	  var offset = a.length;
	
	  for (i = 0; i < b.length; i++) {
	    newArray[i + offset] = b[i];
	  }
	
	  return newArray;
	}
	
	function noop() {}
	
	exports.$override = $override;
	exports.clone = clone;
	exports.merge = merge;
	exports.mergeAll = mergeAll;
	exports.extend = extend;
	exports.defaults = defaults;
	exports.createCanvas = createCanvas;
	exports.getContext = getContext;
	exports.indexOf = indexOf;
	exports.inherits = inherits;
	exports.mixin = mixin;
	exports.isArrayLike = isArrayLike;
	exports.each = each;
	exports.map = map;
	exports.reduce = reduce;
	exports.filter = filter;
	exports.find = find;
	exports.bind = bind;
	exports.curry = curry;
	exports.isArray = isArray;
	exports.isFunction = isFunction;
	exports.isString = isString;
	exports.isObject = isObject;
	exports.isBuiltInObject = isBuiltInObject;
	exports.isTypedArray = isTypedArray;
	exports.isDom = isDom;
	exports.eqNaN = eqNaN;
	exports.retrieve = retrieve;
	exports.retrieve2 = retrieve2;
	exports.retrieve3 = retrieve3;
	exports.slice = slice;
	exports.normalizeCssArray = normalizeCssArray;
	exports.assert = assert;
	exports.trim = trim;
	exports.setAsPrimitive = setAsPrimitive;
	exports.isPrimitive = isPrimitive;
	exports.createHashMap = createHashMap;
	exports.concatArray = concatArray;
	exports.noop = noop;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(130);
	
	var _interopRequireWildcard = __webpack_require__(399);
	
	exports.__esModule = true;
	
	var _Provider = _interopRequireWildcard(__webpack_require__(2850));
	
	exports.Provider = _Provider.default;
	exports.createProvider = _Provider.createProvider;
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(1149));
	
	exports.connectAdvanced = _connectAdvanced.default;
	
	var _connect = _interopRequireDefault(__webpack_require__(2851));
	
	exports.connect = _connect.default;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(2623)();
	}


/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(42);
	var core = __webpack_require__(117);
	var hide = __webpack_require__(97);
	var redefine = __webpack_require__(98);
	var ctx = __webpack_require__(118);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
	  var key, own, out, exp;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    // export native or passed
	    out = (own ? target : source)[key];
	    // bind timers to global for call from export context
	    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // extend global
	    if (target) redefine(target, key, out, type & $export.U);
	    // export
	    if (exports[key] != out) hide(exports, key, exp);
	    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	  }
	};
	global.core = core;
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createMemoryHistory = exports.hashHistory = exports.browserHistory = exports.applyRouterMiddleware = exports.formatPattern = exports.useRouterHistory = exports.match = exports.routerShape = exports.locationShape = exports.RouterContext = exports.createRoutes = exports.Route = exports.Redirect = exports.IndexRoute = exports.IndexRedirect = exports.withRouter = exports.IndexLink = exports.Link = exports.Router = undefined;
	
	var _RouteUtils = __webpack_require__(186);
	
	Object.defineProperty(exports, 'createRoutes', {
	  enumerable: true,
	  get: function get() {
	    return _RouteUtils.createRoutes;
	  }
	});
	
	var _PropTypes = __webpack_require__(590);
	
	Object.defineProperty(exports, 'locationShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.locationShape;
	  }
	});
	Object.defineProperty(exports, 'routerShape', {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes.routerShape;
	  }
	});
	
	var _PatternUtils = __webpack_require__(261);
	
	Object.defineProperty(exports, 'formatPattern', {
	  enumerable: true,
	  get: function get() {
	    return _PatternUtils.formatPattern;
	  }
	});
	
	var _Router2 = __webpack_require__(2866);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _Link2 = __webpack_require__(1156);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _IndexLink2 = __webpack_require__(2862);
	
	var _IndexLink3 = _interopRequireDefault(_IndexLink2);
	
	var _withRouter2 = __webpack_require__(2877);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	var _IndexRedirect2 = __webpack_require__(2863);
	
	var _IndexRedirect3 = _interopRequireDefault(_IndexRedirect2);
	
	var _IndexRoute2 = __webpack_require__(2864);
	
	var _IndexRoute3 = _interopRequireDefault(_IndexRoute2);
	
	var _Redirect2 = __webpack_require__(1158);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(2865);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _RouterContext2 = __webpack_require__(591);
	
	var _RouterContext3 = _interopRequireDefault(_RouterContext2);
	
	var _match2 = __webpack_require__(2875);
	
	var _match3 = _interopRequireDefault(_match2);
	
	var _useRouterHistory2 = __webpack_require__(1163);
	
	var _useRouterHistory3 = _interopRequireDefault(_useRouterHistory2);
	
	var _applyRouterMiddleware2 = __webpack_require__(2868);
	
	var _applyRouterMiddleware3 = _interopRequireDefault(_applyRouterMiddleware2);
	
	var _browserHistory2 = __webpack_require__(2869);
	
	var _browserHistory3 = _interopRequireDefault(_browserHistory2);
	
	var _hashHistory2 = __webpack_require__(2873);
	
	var _hashHistory3 = _interopRequireDefault(_hashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(1160);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Router = _Router3.default; /* components */
	
	exports.Link = _Link3.default;
	exports.IndexLink = _IndexLink3.default;
	exports.withRouter = _withRouter3.default;
	
	/* components (configuration) */
	
	exports.IndexRedirect = _IndexRedirect3.default;
	exports.IndexRoute = _IndexRoute3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	
	/* utils */
	
	exports.RouterContext = _RouterContext3.default;
	exports.match = _match3.default;
	exports.useRouterHistory = _useRouterHistory3.default;
	exports.applyRouterMiddleware = _applyRouterMiddleware3.default;
	
	/* histories */
	
	exports.browserHistory = _browserHistory3.default;
	exports.hashHistory = _hashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrender = __webpack_require__(397);
	
	var zrUtil = __webpack_require__(4);
	
	var colorTool = __webpack_require__(148);
	
	var env = __webpack_require__(73);
	
	var timsort = __webpack_require__(600);
	
	var Eventful = __webpack_require__(225);
	
	var GlobalModel = __webpack_require__(874);
	
	var ExtensionAPI = __webpack_require__(818);
	
	var CoordinateSystemManager = __webpack_require__(121);
	
	var OptionManager = __webpack_require__(2437);
	
	var backwardCompat = __webpack_require__(2445);
	
	var dataStack = __webpack_require__(2448);
	
	var ComponentModel = __webpack_require__(76);
	
	var SeriesModel = __webpack_require__(77);
	
	var ComponentView = __webpack_require__(362);
	
	var ChartView = __webpack_require__(141);
	
	var graphic = __webpack_require__(14);
	
	var modelUtil = __webpack_require__(29);
	
	var _throttle = __webpack_require__(181);
	
	var throttle = _throttle.throttle;
	
	var seriesColor = __webpack_require__(2457);
	
	var aria = __webpack_require__(2456);
	
	var loadingDefault = __webpack_require__(2436);
	
	var Scheduler = __webpack_require__(2451);
	
	var lightTheme = __webpack_require__(2453);
	
	var darkTheme = __webpack_require__(2452);
	
	__webpack_require__(842);
	
	var mapDataStorage = __webpack_require__(514);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var assert = zrUtil.assert;
	var each = zrUtil.each;
	var isFunction = zrUtil.isFunction;
	var isObject = zrUtil.isObject;
	var parseClassType = ComponentModel.parseClassType;
	var version = '4.9.0';
	var dependencies = {
	  zrender: '4.3.2'
	};
	var TEST_FRAME_REMAIN_TIME = 1;
	var PRIORITY_PROCESSOR_FILTER = 1000;
	var PRIORITY_PROCESSOR_SERIES_FILTER = 800;
	var PRIORITY_PROCESSOR_DATASTACK = 900;
	var PRIORITY_PROCESSOR_STATISTIC = 5000;
	var PRIORITY_VISUAL_LAYOUT = 1000;
	var PRIORITY_VISUAL_PROGRESSIVE_LAYOUT = 1100;
	var PRIORITY_VISUAL_GLOBAL = 2000;
	var PRIORITY_VISUAL_CHART = 3000;
	var PRIORITY_VISUAL_POST_CHART_LAYOUT = 3500;
	var PRIORITY_VISUAL_COMPONENT = 4000; // FIXME
	// necessary?
	
	var PRIORITY_VISUAL_BRUSH = 5000;
	var PRIORITY = {
	  PROCESSOR: {
	    FILTER: PRIORITY_PROCESSOR_FILTER,
	    SERIES_FILTER: PRIORITY_PROCESSOR_SERIES_FILTER,
	    STATISTIC: PRIORITY_PROCESSOR_STATISTIC
	  },
	  VISUAL: {
	    LAYOUT: PRIORITY_VISUAL_LAYOUT,
	    PROGRESSIVE_LAYOUT: PRIORITY_VISUAL_PROGRESSIVE_LAYOUT,
	    GLOBAL: PRIORITY_VISUAL_GLOBAL,
	    CHART: PRIORITY_VISUAL_CHART,
	    POST_CHART_LAYOUT: PRIORITY_VISUAL_POST_CHART_LAYOUT,
	    COMPONENT: PRIORITY_VISUAL_COMPONENT,
	    BRUSH: PRIORITY_VISUAL_BRUSH
	  }
	}; // Main process have three entries: `setOption`, `dispatchAction` and `resize`,
	// where they must not be invoked nestedly, except the only case: invoke
	// dispatchAction with updateMethod "none" in main process.
	// This flag is used to carry out this rule.
	// All events will be triggered out side main process (i.e. when !this[IN_MAIN_PROCESS]).
	
	var IN_MAIN_PROCESS = '__flagInMainProcess';
	var OPTION_UPDATED = '__optionUpdated';
	var ACTION_REG = /^[a-zA-Z0-9_]+$/;
	
	function createRegisterEventWithLowercaseName(method, ignoreDisposed) {
	  return function (eventName, handler, context) {
	    if (!ignoreDisposed && this._disposed) {
	      disposedWarning(this.id);
	      return;
	    } // Event name is all lowercase
	
	
	    eventName = eventName && eventName.toLowerCase();
	    Eventful.prototype[method].call(this, eventName, handler, context);
	  };
	}
	/**
	 * @module echarts~MessageCenter
	 */
	
	
	function MessageCenter() {
	  Eventful.call(this);
	}
	
	MessageCenter.prototype.on = createRegisterEventWithLowercaseName('on', true);
	MessageCenter.prototype.off = createRegisterEventWithLowercaseName('off', true);
	MessageCenter.prototype.one = createRegisterEventWithLowercaseName('one', true);
	zrUtil.mixin(MessageCenter, Eventful);
	/**
	 * @module echarts~ECharts
	 */
	
	function ECharts(dom, theme, opts) {
	  opts = opts || {}; // Get theme by name
	
	  if (typeof theme === 'string') {
	    theme = themeStorage[theme];
	  }
	  /**
	   * @type {string}
	   */
	
	
	  this.id;
	  /**
	   * Group id
	   * @type {string}
	   */
	
	  this.group;
	  /**
	   * @type {HTMLElement}
	   * @private
	   */
	
	  this._dom = dom;
	  var defaultRenderer = 'canvas';
	
	  /**
	   * @type {module:zrender/ZRender}
	   * @private
	   */
	  var zr = this._zr = zrender.init(dom, {
	    renderer: opts.renderer || defaultRenderer,
	    devicePixelRatio: opts.devicePixelRatio,
	    width: opts.width,
	    height: opts.height
	  });
	  /**
	   * Expect 60 fps.
	   * @type {Function}
	   * @private
	   */
	
	  this._throttledZrFlush = throttle(zrUtil.bind(zr.flush, zr), 17);
	  var theme = zrUtil.clone(theme);
	  theme && backwardCompat(theme, true);
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._theme = theme;
	  /**
	   * @type {Array.<module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Chart>}
	   * @private
	   */
	
	  this._chartsMap = {};
	  /**
	   * @type {Array.<module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsViews = [];
	  /**
	   * @type {Object.<string, module:echarts/view/Component>}
	   * @private
	   */
	
	  this._componentsMap = {};
	  /**
	   * @type {module:echarts/CoordinateSystem}
	   * @private
	   */
	
	  this._coordSysMgr = new CoordinateSystemManager();
	  /**
	   * @type {module:echarts/ExtensionAPI}
	   * @private
	   */
	
	  var api = this._api = createExtensionAPI(this); // Sort on demand
	
	  function prioritySortFunc(a, b) {
	    return a.__prio - b.__prio;
	  }
	
	  timsort(visualFuncs, prioritySortFunc);
	  timsort(dataProcessorFuncs, prioritySortFunc);
	  /**
	   * @type {module:echarts/stream/Scheduler}
	   */
	
	  this._scheduler = new Scheduler(this, api, dataProcessorFuncs, visualFuncs);
	  Eventful.call(this, this._ecEventProcessor = new EventProcessor());
	  /**
	   * @type {module:echarts~MessageCenter}
	   * @private
	   */
	
	  this._messageCenter = new MessageCenter(); // Init mouse events
	
	  this._initEvents(); // In case some people write `window.onresize = chart.resize`
	
	
	  this.resize = zrUtil.bind(this.resize, this); // Can't dispatch action during rendering procedure
	
	  this._pendingActions = [];
	  zr.animation.on('frame', this._onframe, this);
	  bindRenderedEvent(zr, this); // ECharts instance can be used as value.
	
	  zrUtil.setAsPrimitive(this);
	}
	
	var echartsProto = ECharts.prototype;
	
	echartsProto._onframe = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  var scheduler = this._scheduler; // Lazy update
	
	  if (this[OPTION_UPDATED]) {
	    var silent = this[OPTION_UPDATED].silent;
	    this[IN_MAIN_PROCESS] = true;
	    prepare(this);
	    updateMethods.update.call(this);
	    this[IN_MAIN_PROCESS] = false;
	    this[OPTION_UPDATED] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  } // Avoid do both lazy update and progress in one frame.
	  else if (scheduler.unfinished) {
	      // Stream progress.
	      var remainTime = TEST_FRAME_REMAIN_TIME;
	      var ecModel = this._model;
	      var api = this._api;
	      scheduler.unfinished = false;
	
	      do {
	        var startTime = +new Date();
	        scheduler.performSeriesTasks(ecModel); // Currently dataProcessorFuncs do not check threshold.
	
	        scheduler.performDataProcessorTasks(ecModel);
	        updateStreamModes(this, ecModel); // Do not update coordinate system here. Because that coord system update in
	        // each frame is not a good user experience. So we follow the rule that
	        // the extent of the coordinate system is determin in the first frame (the
	        // frame is executed immedietely after task reset.
	        // this._coordSysMgr.update(ecModel, api);
	        // console.log('--- ec frame visual ---', remainTime);
	
	        scheduler.performVisualTasks(ecModel);
	        renderSeries(this, this._model, api, 'remain');
	        remainTime -= +new Date() - startTime;
	      } while (remainTime > 0 && scheduler.unfinished); // Call flush explicitly for trigger finished event.
	
	
	      if (!scheduler.unfinished) {
	        this._zr.flush();
	      } // Else, zr flushing be ensue within the same frame,
	      // because zr flushing is after onframe event.
	
	    }
	};
	/**
	 * @return {HTMLElement}
	 */
	
	
	echartsProto.getDom = function () {
	  return this._dom;
	};
	/**
	 * @return {module:zrender~ZRender}
	 */
	
	
	echartsProto.getZr = function () {
	  return this._zr;
	};
	/**
	 * Usage:
	 * chart.setOption(option, notMerge, lazyUpdate);
	 * chart.setOption(option, {
	 *     notMerge: ...,
	 *     lazyUpdate: ...,
	 *     silent: ...
	 * });
	 *
	 * @param {Object} option
	 * @param {Object|boolean} [opts] opts or notMerge.
	 * @param {boolean} [opts.notMerge=false]
	 * @param {boolean} [opts.lazyUpdate=false] Useful when setOption frequently.
	 */
	
	
	echartsProto.setOption = function (option, notMerge, lazyUpdate) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var silent;
	
	  if (isObject(notMerge)) {
	    lazyUpdate = notMerge.lazyUpdate;
	    silent = notMerge.silent;
	    notMerge = notMerge.notMerge;
	  }
	
	  this[IN_MAIN_PROCESS] = true;
	
	  if (!this._model || notMerge) {
	    var optionManager = new OptionManager(this._api);
	    var theme = this._theme;
	    var ecModel = this._model = new GlobalModel();
	    ecModel.scheduler = this._scheduler;
	    ecModel.init(null, null, theme, optionManager);
	  }
	
	  this._model.setOption(option, optionPreprocessorFuncs);
	
	  if (lazyUpdate) {
	    this[OPTION_UPDATED] = {
	      silent: silent
	    };
	    this[IN_MAIN_PROCESS] = false;
	  } else {
	    prepare(this);
	    updateMethods.update.call(this); // Ensure zr refresh sychronously, and then pixel in canvas can be
	    // fetched after `setOption`.
	
	    this._zr.flush();
	
	    this[OPTION_UPDATED] = false;
	    this[IN_MAIN_PROCESS] = false;
	    flushPendingActions.call(this, silent);
	    triggerUpdatedEvent.call(this, silent);
	  }
	};
	/**
	 * @DEPRECATED
	 */
	
	
	echartsProto.setTheme = function () {
	  console.error('ECharts#setTheme() is DEPRECATED in ECharts 3.0');
	};
	/**
	 * @return {module:echarts/model/Global}
	 */
	
	
	echartsProto.getModel = function () {
	  return this._model;
	};
	/**
	 * @return {Object}
	 */
	
	
	echartsProto.getOption = function () {
	  return this._model && this._model.getOption();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getWidth = function () {
	  return this._zr.getWidth();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getHeight = function () {
	  return this._zr.getHeight();
	};
	/**
	 * @return {number}
	 */
	
	
	echartsProto.getDevicePixelRatio = function () {
	  return this._zr.painter.dpr || window.devicePixelRatio || 1;
	};
	/**
	 * Get canvas which has all thing rendered
	 * @param {Object} opts
	 * @param {string} [opts.backgroundColor]
	 * @return {string}
	 */
	
	
	echartsProto.getRenderedCanvas = function (opts) {
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  opts = opts || {};
	  opts.pixelRatio = opts.pixelRatio || 1;
	  opts.backgroundColor = opts.backgroundColor || this._model.get('backgroundColor');
	  var zr = this._zr; // var list = zr.storage.getDisplayList();
	  // Stop animations
	  // Never works before in init animation, so remove it.
	  // zrUtil.each(list, function (el) {
	  //     el.stopAnimation(true);
	  // });
	
	  return zr.painter.getRenderedCanvas(opts);
	};
	/**
	 * Get svg data url
	 * @return {string}
	 */
	
	
	echartsProto.getSvgDataURL = function () {
	  if (!env.svgSupported) {
	    return;
	  }
	
	  var zr = this._zr;
	  var list = zr.storage.getDisplayList(); // Stop animations
	
	  zrUtil.each(list, function (el) {
	    el.stopAnimation(true);
	  });
	  return zr.painter.toDataURL();
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 * @param {string} [opts.excludeComponents]
	 */
	
	
	echartsProto.getDataURL = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  opts = opts || {};
	  var excludeComponents = opts.excludeComponents;
	  var ecModel = this._model;
	  var excludesComponentViews = [];
	  var self = this;
	  each(excludeComponents, function (componentType) {
	    ecModel.eachComponent({
	      mainType: componentType
	    }, function (component) {
	      var view = self._componentsMap[component.__viewId];
	
	      if (!view.group.ignore) {
	        excludesComponentViews.push(view);
	        view.group.ignore = true;
	      }
	    });
	  });
	  var url = this._zr.painter.getType() === 'svg' ? this.getSvgDataURL() : this.getRenderedCanvas(opts).toDataURL('image/' + (opts && opts.type || 'png'));
	  each(excludesComponentViews, function (view) {
	    view.group.ignore = false;
	  });
	  return url;
	};
	/**
	 * @return {string}
	 * @param {Object} opts
	 * @param {string} [opts.type='png']
	 * @param {string} [opts.pixelRatio=1]
	 * @param {string} [opts.backgroundColor]
	 */
	
	
	echartsProto.getConnectedDataURL = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (!env.canvasSupported) {
	    return;
	  }
	
	  var isSvg = opts.type === 'svg';
	  var groupId = this.group;
	  var mathMin = Math.min;
	  var mathMax = Math.max;
	  var MAX_NUMBER = Infinity;
	
	  if (connectedGroups[groupId]) {
	    var left = MAX_NUMBER;
	    var top = MAX_NUMBER;
	    var right = -MAX_NUMBER;
	    var bottom = -MAX_NUMBER;
	    var canvasList = [];
	    var dpr = opts && opts.pixelRatio || 1;
	    zrUtil.each(instances, function (chart, id) {
	      if (chart.group === groupId) {
	        var canvas = isSvg ? chart.getZr().painter.getSvgDom().innerHTML : chart.getRenderedCanvas(zrUtil.clone(opts));
	        var boundingRect = chart.getDom().getBoundingClientRect();
	        left = mathMin(boundingRect.left, left);
	        top = mathMin(boundingRect.top, top);
	        right = mathMax(boundingRect.right, right);
	        bottom = mathMax(boundingRect.bottom, bottom);
	        canvasList.push({
	          dom: canvas,
	          left: boundingRect.left,
	          top: boundingRect.top
	        });
	      }
	    });
	    left *= dpr;
	    top *= dpr;
	    right *= dpr;
	    bottom *= dpr;
	    var width = right - left;
	    var height = bottom - top;
	    var targetCanvas = zrUtil.createCanvas();
	    var zr = zrender.init(targetCanvas, {
	      renderer: isSvg ? 'svg' : 'canvas'
	    });
	    zr.resize({
	      width: width,
	      height: height
	    });
	
	    if (isSvg) {
	      var content = '';
	      each(canvasList, function (item) {
	        var x = item.left - left;
	        var y = item.top - top;
	        content += '<g transform="translate(' + x + ',' + y + ')">' + item.dom + '</g>';
	      });
	      zr.painter.getSvgRoot().innerHTML = content;
	
	      if (opts.connectedBackgroundColor) {
	        zr.painter.setBackgroundColor(opts.connectedBackgroundColor);
	      }
	
	      zr.refreshImmediately();
	      return zr.painter.toDataURL();
	    } else {
	      // Background between the charts
	      if (opts.connectedBackgroundColor) {
	        zr.add(new graphic.Rect({
	          shape: {
	            x: 0,
	            y: 0,
	            width: width,
	            height: height
	          },
	          style: {
	            fill: opts.connectedBackgroundColor
	          }
	        }));
	      }
	
	      each(canvasList, function (item) {
	        var img = new graphic.Image({
	          style: {
	            x: item.left * dpr - left,
	            y: item.top * dpr - top,
	            image: item.dom
	          }
	        });
	        zr.add(img);
	      });
	      zr.refreshImmediately();
	      return targetCanvas.toDataURL('image/' + (opts && opts.type || 'png'));
	    }
	  } else {
	    return this.getDataURL(opts);
	  }
	};
	/**
	 * Convert from logical coordinate system to pixel coordinate system.
	 * See CoordinateSystem#convertToPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId, geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	
	echartsProto.convertToPixel = zrUtil.curry(doConvertPixel, 'convertToPixel');
	/**
	 * Convert from pixel coordinate system to logical coordinate system.
	 * See CoordinateSystem#convertFromPixel.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {Array|number} result
	 */
	
	echartsProto.convertFromPixel = zrUtil.curry(doConvertPixel, 'convertFromPixel');
	
	function doConvertPixel(methodName, finder, value) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var ecModel = this._model;
	
	  var coordSysList = this._coordSysMgr.getCoordinateSystems();
	
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	
	  for (var i = 0; i < coordSysList.length; i++) {
	    var coordSys = coordSysList[i];
	
	    if (coordSys[methodName] && (result = coordSys[methodName](ecModel, finder, value)) != null) {
	      return result;
	    }
	  }
	}
	/**
	 * Is the specified coordinate systems or components contain the given pixel point.
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            geoIndex / geoId / geoName,
	 *            bmapIndex / bmapId / bmapName,
	 *            xAxisIndex / xAxisId / xAxisName,
	 *            yAxisIndex / yAxisId / yAxisName,
	 *            gridIndex / gridId / gridName,
	 *            ... (can be extended)
	 *        }
	 * @param {Array|number} value
	 * @return {boolean} result
	 */
	
	
	echartsProto.containPixel = function (finder, value) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var ecModel = this._model;
	  var result;
	  finder = modelUtil.parseFinder(ecModel, finder);
	  zrUtil.each(finder, function (models, key) {
	    key.indexOf('Models') >= 0 && zrUtil.each(models, function (model) {
	      var coordSys = model.coordinateSystem;
	
	      if (coordSys && coordSys.containPoint) {
	        result |= !!coordSys.containPoint(value);
	      } else if (key === 'seriesModels') {
	        var view = this._chartsMap[model.__viewId];
	
	        if (view && view.containPoint) {
	          result |= view.containPoint(value, model);
	        } else {}
	      } else {}
	    }, this);
	  }, this);
	  return !!result;
	};
	/**
	 * Get visual from series or data.
	 * @param {string|Object} finder
	 *        If string, e.g., 'series', means {seriesIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex / seriesId / seriesName,
	 *            dataIndex / dataIndexInside
	 *        }
	 *        If dataIndex is not specified, series visual will be fetched,
	 *        but not data item visual.
	 *        If all of seriesIndex, seriesId, seriesName are not specified,
	 *        visual will be fetched from first series.
	 * @param {string} visualType 'color', 'symbol', 'symbolSize'
	 */
	
	
	echartsProto.getVisual = function (finder, visualType) {
	  var ecModel = this._model;
	  finder = modelUtil.parseFinder(ecModel, finder, {
	    defaultMainType: 'series'
	  });
	  var seriesModel = finder.seriesModel;
	  var data = seriesModel.getData();
	  var dataIndexInside = finder.hasOwnProperty('dataIndexInside') ? finder.dataIndexInside : finder.hasOwnProperty('dataIndex') ? data.indexOfRawIndex(finder.dataIndex) : null;
	  return dataIndexInside != null ? data.getItemVisual(dataIndexInside, visualType) : data.getVisual(visualType);
	};
	/**
	 * Get view of corresponding component model
	 * @param  {module:echarts/model/Component} componentModel
	 * @return {module:echarts/view/Component}
	 */
	
	
	echartsProto.getViewOfComponentModel = function (componentModel) {
	  return this._componentsMap[componentModel.__viewId];
	};
	/**
	 * Get view of corresponding series model
	 * @param  {module:echarts/model/Series} seriesModel
	 * @return {module:echarts/view/Chart}
	 */
	
	
	echartsProto.getViewOfSeriesModel = function (seriesModel) {
	  return this._chartsMap[seriesModel.__viewId];
	};
	
	var updateMethods = {
	  prepareAndUpdate: function (payload) {
	    prepare(this);
	    updateMethods.update.call(this, payload);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  update: function (payload) {
	    // console.profile && console.profile('update');
	    var ecModel = this._model;
	    var api = this._api;
	    var zr = this._zr;
	    var coordSysMgr = this._coordSysMgr;
	    var scheduler = this._scheduler; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    scheduler.restoreData(ecModel, payload);
	    scheduler.performSeriesTasks(ecModel); // TODO
	    // Save total ecModel here for undo/redo (after restoring data and before processing data).
	    // Undo (restoration of total ecModel) can be carried out in 'action' or outside API call.
	    // Create new coordinate system each update
	    // In LineView may save the old coordinate system and use it to get the orignal point
	
	    coordSysMgr.create(ecModel, api);
	    scheduler.performDataProcessorTasks(ecModel, payload); // Current stream render is not supported in data process. So we can update
	    // stream modes after data processing, where the filtered data is used to
	    // deteming whether use progressive rendering.
	
	    updateStreamModes(this, ecModel); // We update stream modes before coordinate system updated, then the modes info
	    // can be fetched when coord sys updating (consider the barGrid extent fix). But
	    // the drawback is the full coord info can not be fetched. Fortunately this full
	    // coord is not requied in stream mode updater currently.
	
	    coordSysMgr.update(ecModel, api);
	    clearColorPalette(ecModel);
	    scheduler.performVisualTasks(ecModel, payload);
	    render(this, ecModel, api, payload); // Set background
	
	    var backgroundColor = ecModel.get('backgroundColor') || 'transparent'; // In IE8
	
	    if (!env.canvasSupported) {
	      var colorArr = colorTool.parse(backgroundColor);
	      backgroundColor = colorTool.stringify(colorArr, 'rgb');
	
	      if (colorArr[3] === 0) {
	        backgroundColor = 'transparent';
	      }
	    } else {
	      zr.setBackgroundColor(backgroundColor);
	    }
	
	    performPostUpdateFuncs(ecModel, api); // console.profile && console.profileEnd('update');
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateTransform: function (payload) {
	    var ecModel = this._model;
	    var ecIns = this;
	    var api = this._api; // update before setOption
	
	    if (!ecModel) {
	      return;
	    } // ChartView.markUpdateMethod(payload, 'updateTransform');
	
	
	    var componentDirtyList = [];
	    ecModel.eachComponent(function (componentType, componentModel) {
	      var componentView = ecIns.getViewOfComponentModel(componentModel);
	
	      if (componentView && componentView.__alive) {
	        if (componentView.updateTransform) {
	          var result = componentView.updateTransform(componentModel, ecModel, api, payload);
	          result && result.update && componentDirtyList.push(componentView);
	        } else {
	          componentDirtyList.push(componentView);
	        }
	      }
	    });
	    var seriesDirtyMap = zrUtil.createHashMap();
	    ecModel.eachSeries(function (seriesModel) {
	      var chartView = ecIns._chartsMap[seriesModel.__viewId];
	
	      if (chartView.updateTransform) {
	        var result = chartView.updateTransform(seriesModel, ecModel, api, payload);
	        result && result.update && seriesDirtyMap.set(seriesModel.uid, 1);
	      } else {
	        seriesDirtyMap.set(seriesModel.uid, 1);
	      }
	    });
	    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
	
	    this._scheduler.performVisualTasks(ecModel, payload, {
	      setDirty: true,
	      dirtyMap: seriesDirtyMap
	    }); // Currently, not call render of components. Geo render cost a lot.
	    // renderComponents(ecIns, ecModel, api, payload, componentDirtyList);
	
	
	    renderSeries(ecIns, ecModel, api, payload, seriesDirtyMap);
	    performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateView: function (payload) {
	    var ecModel = this._model; // update before setOption
	
	    if (!ecModel) {
	      return;
	    }
	
	    ChartView.markUpdateMethod(payload, 'updateView');
	    clearColorPalette(ecModel); // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	
	    this._scheduler.performVisualTasks(ecModel, payload, {
	      setDirty: true
	    });
	
	    render(this, this._model, this._api, payload);
	    performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateVisual: function (payload) {
	    updateMethods.update.call(this, payload); // var ecModel = this._model;
	    // // update before setOption
	    // if (!ecModel) {
	    //     return;
	    // }
	    // ChartView.markUpdateMethod(payload, 'updateVisual');
	    // clearColorPalette(ecModel);
	    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // this._scheduler.performVisualTasks(ecModel, payload, {visualType: 'visual', setDirty: true});
	    // render(this, this._model, this._api, payload);
	    // performPostUpdateFuncs(ecModel, this._api);
	  },
	
	  /**
	   * @param {Object} payload
	   * @private
	   */
	  updateLayout: function (payload) {
	    updateMethods.update.call(this, payload); // var ecModel = this._model;
	    // // update before setOption
	    // if (!ecModel) {
	    //     return;
	    // }
	    // ChartView.markUpdateMethod(payload, 'updateLayout');
	    // // Keep pipe to the exist pipeline because it depends on the render task of the full pipeline.
	    // // this._scheduler.performVisualTasks(ecModel, payload, 'layout', true);
	    // this._scheduler.performVisualTasks(ecModel, payload, {setDirty: true});
	    // render(this, this._model, this._api, payload);
	    // performPostUpdateFuncs(ecModel, this._api);
	  }
	};
	
	function prepare(ecIns) {
	  var ecModel = ecIns._model;
	  var scheduler = ecIns._scheduler;
	  scheduler.restorePipelines(ecModel);
	  scheduler.prepareStageTasks();
	  prepareView(ecIns, 'component', ecModel, scheduler);
	  prepareView(ecIns, 'chart', ecModel, scheduler);
	  scheduler.plan();
	}
	/**
	 * @private
	 */
	
	
	function updateDirectly(ecIns, method, payload, mainType, subType) {
	  var ecModel = ecIns._model; // broadcast
	
	  if (!mainType) {
	    // FIXME
	    // Chart will not be update directly here, except set dirty.
	    // But there is no such scenario now.
	    each(ecIns._componentsViews.concat(ecIns._chartsViews), callView);
	    return;
	  }
	
	  var query = {};
	  query[mainType + 'Id'] = payload[mainType + 'Id'];
	  query[mainType + 'Index'] = payload[mainType + 'Index'];
	  query[mainType + 'Name'] = payload[mainType + 'Name'];
	  var condition = {
	    mainType: mainType,
	    query: query
	  };
	  subType && (condition.subType = subType); // subType may be '' by parseClassType;
	
	  var excludeSeriesId = payload.excludeSeriesId;
	
	  if (excludeSeriesId != null) {
	    excludeSeriesId = zrUtil.createHashMap(modelUtil.normalizeToArray(excludeSeriesId));
	  } // If dispatchAction before setOption, do nothing.
	
	
	  ecModel && ecModel.eachComponent(condition, function (model) {
	    if (!excludeSeriesId || excludeSeriesId.get(model.id) == null) {
	      callView(ecIns[mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId]);
	    }
	  }, ecIns);
	
	  function callView(view) {
	    view && view.__alive && view[method] && view[method](view.__model, ecModel, ecIns._api, payload);
	  }
	}
	/**
	 * Resize the chart
	 * @param {Object} opts
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @param {boolean} [opts.silent=false]
	 */
	
	
	echartsProto.resize = function (opts) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._zr.resize(opts);
	
	  var ecModel = this._model; // Resize loading effect
	
	  this._loadingFX && this._loadingFX.resize();
	
	  if (!ecModel) {
	    return;
	  }
	
	  var optionChanged = ecModel.resetOption('media');
	  var silent = opts && opts.silent;
	  this[IN_MAIN_PROCESS] = true;
	  optionChanged && prepare(this);
	  updateMethods.update.call(this);
	  this[IN_MAIN_PROCESS] = false;
	  flushPendingActions.call(this, silent);
	  triggerUpdatedEvent.call(this, silent);
	};
	
	function updateStreamModes(ecIns, ecModel) {
	  var chartsMap = ecIns._chartsMap;
	  var scheduler = ecIns._scheduler;
	  ecModel.eachSeries(function (seriesModel) {
	    scheduler.updateStreamModes(seriesModel, chartsMap[seriesModel.__viewId]);
	  });
	}
	/**
	 * Show loading effect
	 * @param  {string} [name='default']
	 * @param  {Object} [cfg]
	 */
	
	
	echartsProto.showLoading = function (name, cfg) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (isObject(name)) {
	    cfg = name;
	    name = '';
	  }
	
	  name = name || 'default';
	  this.hideLoading();
	
	  if (!loadingEffects[name]) {
	    return;
	  }
	
	  var el = loadingEffects[name](this._api, cfg);
	  var zr = this._zr;
	  this._loadingFX = el;
	  zr.add(el);
	};
	/**
	 * Hide loading effect
	 */
	
	
	echartsProto.hideLoading = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._loadingFX && this._zr.remove(this._loadingFX);
	  this._loadingFX = null;
	};
	/**
	 * @param {Object} eventObj
	 * @return {Object}
	 */
	
	
	echartsProto.makeActionFromEvent = function (eventObj) {
	  var payload = zrUtil.extend({}, eventObj);
	  payload.type = eventActionMap[eventObj.type];
	  return payload;
	};
	/**
	 * @pubilc
	 * @param {Object} payload
	 * @param {string} [payload.type] Action type
	 * @param {Object|boolean} [opt] If pass boolean, means opt.silent
	 * @param {boolean} [opt.silent=false] Whether trigger events.
	 * @param {boolean} [opt.flush=undefined]
	 *                  true: Flush immediately, and then pixel in canvas can be fetched
	 *                      immediately. Caution: it might affect performance.
	 *                  false: Not flush.
	 *                  undefined: Auto decide whether perform flush.
	 */
	
	
	echartsProto.dispatchAction = function (payload, opt) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  if (!isObject(opt)) {
	    opt = {
	      silent: !!opt
	    };
	  }
	
	  if (!actions[payload.type]) {
	    return;
	  } // Avoid dispatch action before setOption. Especially in `connect`.
	
	
	  if (!this._model) {
	    return;
	  } // May dispatchAction in rendering procedure
	
	
	  if (this[IN_MAIN_PROCESS]) {
	    this._pendingActions.push(payload);
	
	    return;
	  }
	
	  doDispatchAction.call(this, payload, opt.silent);
	
	  if (opt.flush) {
	    this._zr.flush(true);
	  } else if (opt.flush !== false && env.browser.weChat) {
	    // In WeChat embeded browser, `requestAnimationFrame` and `setInterval`
	    // hang when sliding page (on touch event), which cause that zr does not
	    // refresh util user interaction finished, which is not expected.
	    // But `dispatchAction` may be called too frequently when pan on touch
	    // screen, which impacts performance if do not throttle them.
	    this._throttledZrFlush();
	  }
	
	  flushPendingActions.call(this, opt.silent);
	  triggerUpdatedEvent.call(this, opt.silent);
	};
	
	function doDispatchAction(payload, silent) {
	  var payloadType = payload.type;
	  var escapeConnect = payload.escapeConnect;
	  var actionWrap = actions[payloadType];
	  var actionInfo = actionWrap.actionInfo;
	  var cptType = (actionInfo.update || 'update').split(':');
	  var updateMethod = cptType.pop();
	  cptType = cptType[0] != null && parseClassType(cptType[0]);
	  this[IN_MAIN_PROCESS] = true;
	  var payloads = [payload];
	  var batched = false; // Batch action
	
	  if (payload.batch) {
	    batched = true;
	    payloads = zrUtil.map(payload.batch, function (item) {
	      item = zrUtil.defaults(zrUtil.extend({}, item), payload);
	      item.batch = null;
	      return item;
	    });
	  }
	
	  var eventObjBatch = [];
	  var eventObj;
	  var isHighDown = payloadType === 'highlight' || payloadType === 'downplay';
	  each(payloads, function (batchItem) {
	    // Action can specify the event by return it.
	    eventObj = actionWrap.action(batchItem, this._model, this._api); // Emit event outside
	
	    eventObj = eventObj || zrUtil.extend({}, batchItem); // Convert type to eventType
	
	    eventObj.type = actionInfo.event || eventObj.type;
	    eventObjBatch.push(eventObj); // light update does not perform data process, layout and visual.
	
	    if (isHighDown) {
	      // method, payload, mainType, subType
	      updateDirectly(this, updateMethod, batchItem, 'series');
	    } else if (cptType) {
	      updateDirectly(this, updateMethod, batchItem, cptType.main, cptType.sub);
	    }
	  }, this);
	
	  if (updateMethod !== 'none' && !isHighDown && !cptType) {
	    // Still dirty
	    if (this[OPTION_UPDATED]) {
	      // FIXME Pass payload ?
	      prepare(this);
	      updateMethods.update.call(this, payload);
	      this[OPTION_UPDATED] = false;
	    } else {
	      updateMethods[updateMethod].call(this, payload);
	    }
	  } // Follow the rule of action batch
	
	
	  if (batched) {
	    eventObj = {
	      type: actionInfo.event || payloadType,
	      escapeConnect: escapeConnect,
	      batch: eventObjBatch
	    };
	  } else {
	    eventObj = eventObjBatch[0];
	  }
	
	  this[IN_MAIN_PROCESS] = false;
	  !silent && this._messageCenter.trigger(eventObj.type, eventObj);
	}
	
	function flushPendingActions(silent) {
	  var pendingActions = this._pendingActions;
	
	  while (pendingActions.length) {
	    var payload = pendingActions.shift();
	    doDispatchAction.call(this, payload, silent);
	  }
	}
	
	function triggerUpdatedEvent(silent) {
	  !silent && this.trigger('updated');
	}
	/**
	 * Event `rendered` is triggered when zr
	 * rendered. It is useful for realtime
	 * snapshot (reflect animation).
	 *
	 * Event `finished` is triggered when:
	 * (1) zrender rendering finished.
	 * (2) initial animation finished.
	 * (3) progressive rendering finished.
	 * (4) no pending action.
	 * (5) no delayed setOption needs to be processed.
	 */
	
	
	function bindRenderedEvent(zr, ecIns) {
	  zr.on('rendered', function () {
	    ecIns.trigger('rendered'); // The `finished` event should not be triggered repeatly,
	    // so it should only be triggered when rendering indeed happend
	    // in zrender. (Consider the case that dipatchAction is keep
	    // triggering when mouse move).
	
	    if ( // Although zr is dirty if initial animation is not finished
	    // and this checking is called on frame, we also check
	    // animation finished for robustness.
	    zr.animation.isFinished() && !ecIns[OPTION_UPDATED] && !ecIns._scheduler.unfinished && !ecIns._pendingActions.length) {
	      ecIns.trigger('finished');
	    }
	  });
	}
	/**
	 * @param {Object} params
	 * @param {number} params.seriesIndex
	 * @param {Array|TypedArray} params.data
	 */
	
	
	echartsProto.appendData = function (params) {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  var seriesIndex = params.seriesIndex;
	  var ecModel = this.getModel();
	  var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	  seriesModel.appendData(params); // Note: `appendData` does not support that update extent of coordinate
	  // system, util some scenario require that. In the expected usage of
	  // `appendData`, the initial extent of coordinate system should better
	  // be fixed by axis `min`/`max` setting or initial data, otherwise if
	  // the extent changed while `appendData`, the location of the painted
	  // graphic elements have to be changed, which make the usage of
	  // `appendData` meaningless.
	
	  this._scheduler.unfinished = true;
	};
	/**
	 * Register event
	 * @method
	 */
	
	
	echartsProto.on = createRegisterEventWithLowercaseName('on', false);
	echartsProto.off = createRegisterEventWithLowercaseName('off', false);
	echartsProto.one = createRegisterEventWithLowercaseName('one', false);
	/**
	 * Prepare view instances of charts and components
	 * @param  {module:echarts/model/Global} ecModel
	 * @private
	 */
	
	function prepareView(ecIns, type, ecModel, scheduler) {
	  var isComponent = type === 'component';
	  var viewList = isComponent ? ecIns._componentsViews : ecIns._chartsViews;
	  var viewMap = isComponent ? ecIns._componentsMap : ecIns._chartsMap;
	  var zr = ecIns._zr;
	  var api = ecIns._api;
	
	  for (var i = 0; i < viewList.length; i++) {
	    viewList[i].__alive = false;
	  }
	
	  isComponent ? ecModel.eachComponent(function (componentType, model) {
	    componentType !== 'series' && doPrepare(model);
	  }) : ecModel.eachSeries(doPrepare);
	
	  function doPrepare(model) {
	    // Consider: id same and type changed.
	    var viewId = '_ec_' + model.id + '_' + model.type;
	    var view = viewMap[viewId];
	
	    if (!view) {
	      var classType = parseClassType(model.type);
	      var Clazz = isComponent ? ComponentView.getClass(classType.main, classType.sub) : ChartView.getClass(classType.sub);
	      view = new Clazz();
	      view.init(ecModel, api);
	      viewMap[viewId] = view;
	      viewList.push(view);
	      zr.add(view.group);
	    }
	
	    model.__viewId = view.__id = viewId;
	    view.__alive = true;
	    view.__model = model;
	    view.group.__ecComponentInfo = {
	      mainType: model.mainType,
	      index: model.componentIndex
	    };
	    !isComponent && scheduler.prepareView(view, model, ecModel, api);
	  }
	
	  for (var i = 0; i < viewList.length;) {
	    var view = viewList[i];
	
	    if (!view.__alive) {
	      !isComponent && view.renderTask.dispose();
	      zr.remove(view.group);
	      view.dispose(ecModel, api);
	      viewList.splice(i, 1);
	      delete viewMap[view.__id];
	      view.__id = view.group.__ecComponentInfo = null;
	    } else {
	      i++;
	    }
	  }
	} // /**
	//  * Encode visual infomation from data after data processing
	//  *
	//  * @param {module:echarts/model/Global} ecModel
	//  * @param {object} layout
	//  * @param {boolean} [layoutFilter] `true`: only layout,
	//  *                                 `false`: only not layout,
	//  *                                 `null`/`undefined`: all.
	//  * @param {string} taskBaseTag
	//  * @private
	//  */
	// function startVisualEncoding(ecIns, ecModel, api, payload, layoutFilter) {
	//     each(visualFuncs, function (visual, index) {
	//         var isLayout = visual.isLayout;
	//         if (layoutFilter == null
	//             || (layoutFilter === false && !isLayout)
	//             || (layoutFilter === true && isLayout)
	//         ) {
	//             visual.func(ecModel, api, payload);
	//         }
	//     });
	// }
	
	
	function clearColorPalette(ecModel) {
	  ecModel.clearColorPalette();
	  ecModel.eachSeries(function (seriesModel) {
	    seriesModel.clearColorPalette();
	  });
	}
	
	function render(ecIns, ecModel, api, payload) {
	  renderComponents(ecIns, ecModel, api, payload);
	  each(ecIns._chartsViews, function (chart) {
	    chart.__alive = false;
	  });
	  renderSeries(ecIns, ecModel, api, payload); // Remove groups of unrendered charts
	
	  each(ecIns._chartsViews, function (chart) {
	    if (!chart.__alive) {
	      chart.remove(ecModel, api);
	    }
	  });
	}
	
	function renderComponents(ecIns, ecModel, api, payload, dirtyList) {
	  each(dirtyList || ecIns._componentsViews, function (componentView) {
	    var componentModel = componentView.__model;
	    componentView.render(componentModel, ecModel, api, payload);
	    updateZ(componentModel, componentView);
	  });
	}
	/**
	 * Render each chart and component
	 * @private
	 */
	
	
	function renderSeries(ecIns, ecModel, api, payload, dirtyMap) {
	  // Render all charts
	  var scheduler = ecIns._scheduler;
	  var unfinished;
	  ecModel.eachSeries(function (seriesModel) {
	    var chartView = ecIns._chartsMap[seriesModel.__viewId];
	    chartView.__alive = true;
	    var renderTask = chartView.renderTask;
	    scheduler.updatePayload(renderTask, payload);
	
	    if (dirtyMap && dirtyMap.get(seriesModel.uid)) {
	      renderTask.dirty();
	    }
	
	    unfinished |= renderTask.perform(scheduler.getPerformArgs(renderTask));
	    chartView.group.silent = !!seriesModel.get('silent');
	    updateZ(seriesModel, chartView);
	    updateBlend(seriesModel, chartView);
	  });
	  scheduler.unfinished |= unfinished; // If use hover layer
	
	  updateHoverLayerStatus(ecIns, ecModel); // Add aria
	
	  aria(ecIns._zr.dom, ecModel);
	}
	
	function performPostUpdateFuncs(ecModel, api) {
	  each(postUpdateFuncs, function (func) {
	    func(ecModel, api);
	  });
	}
	
	var MOUSE_EVENT_NAMES = ['click', 'dblclick', 'mouseover', 'mouseout', 'mousemove', 'mousedown', 'mouseup', 'globalout', 'contextmenu'];
	/**
	 * @private
	 */
	
	echartsProto._initEvents = function () {
	  each(MOUSE_EVENT_NAMES, function (eveName) {
	    var handler = function (e) {
	      var ecModel = this.getModel();
	      var el = e.target;
	      var params;
	      var isGlobalOut = eveName === 'globalout'; // no e.target when 'globalout'.
	
	      if (isGlobalOut) {
	        params = {};
	      } else if (el && el.dataIndex != null) {
	        var dataModel = el.dataModel || ecModel.getSeriesByIndex(el.seriesIndex);
	        params = dataModel && dataModel.getDataParams(el.dataIndex, el.dataType, el) || {};
	      } // If element has custom eventData of components
	      else if (el && el.eventData) {
	          params = zrUtil.extend({}, el.eventData);
	        } // Contract: if params prepared in mouse event,
	      // these properties must be specified:
	      // {
	      //    componentType: string (component main type)
	      //    componentIndex: number
	      // }
	      // Otherwise event query can not work.
	
	
	      if (params) {
	        var componentType = params.componentType;
	        var componentIndex = params.componentIndex; // Special handling for historic reason: when trigger by
	        // markLine/markPoint/markArea, the componentType is
	        // 'markLine'/'markPoint'/'markArea', but we should better
	        // enable them to be queried by seriesIndex, since their
	        // option is set in each series.
	
	        if (componentType === 'markLine' || componentType === 'markPoint' || componentType === 'markArea') {
	          componentType = 'series';
	          componentIndex = params.seriesIndex;
	        }
	
	        var model = componentType && componentIndex != null && ecModel.getComponent(componentType, componentIndex);
	        var view = model && this[model.mainType === 'series' ? '_chartsMap' : '_componentsMap'][model.__viewId];
	        params.event = e;
	        params.type = eveName;
	        this._ecEventProcessor.eventInfo = {
	          targetEl: el,
	          packedEvent: params,
	          model: model,
	          view: view
	        };
	        this.trigger(eveName, params);
	      }
	    }; // Consider that some component (like tooltip, brush, ...)
	    // register zr event handler, but user event handler might
	    // do anything, such as call `setOption` or `dispatchAction`,
	    // which probably update any of the content and probably
	    // cause problem if it is called previous other inner handlers.
	
	
	    handler.zrEventfulCallAtLast = true;
	
	    this._zr.on(eveName, handler, this);
	  }, this);
	  each(eventActionMap, function (actionType, eventType) {
	    this._messageCenter.on(eventType, function (event) {
	      this.trigger(eventType, event);
	    }, this);
	  }, this);
	};
	/**
	 * @return {boolean}
	 */
	
	
	echartsProto.isDisposed = function () {
	  return this._disposed;
	};
	/**
	 * Clear
	 */
	
	
	echartsProto.clear = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this.setOption({
	    series: []
	  }, true);
	};
	/**
	 * Dispose instance
	 */
	
	
	echartsProto.dispose = function () {
	  if (this._disposed) {
	    disposedWarning(this.id);
	    return;
	  }
	
	  this._disposed = true;
	  modelUtil.setAttribute(this.getDom(), DOM_ATTRIBUTE_KEY, '');
	  var api = this._api;
	  var ecModel = this._model;
	  each(this._componentsViews, function (component) {
	    component.dispose(ecModel, api);
	  });
	  each(this._chartsViews, function (chart) {
	    chart.dispose(ecModel, api);
	  }); // Dispose after all views disposed
	
	  this._zr.dispose();
	
	  delete instances[this.id];
	};
	
	zrUtil.mixin(ECharts, Eventful);
	
	function disposedWarning(id) {}
	
	function updateHoverLayerStatus(ecIns, ecModel) {
	  var zr = ecIns._zr;
	  var storage = zr.storage;
	  var elCount = 0;
	  storage.traverse(function (el) {
	    elCount++;
	  });
	
	  if (elCount > ecModel.get('hoverLayerThreshold') && !env.node) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.preventUsingHoverLayer) {
	        return;
	      }
	
	      var chartView = ecIns._chartsMap[seriesModel.__viewId];
	
	      if (chartView.__alive) {
	        chartView.group.traverse(function (el) {
	          // Don't switch back.
	          el.useHoverLayer = true;
	        });
	      }
	    });
	  }
	}
	/**
	 * Update chart progressive and blend.
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateBlend(seriesModel, chartView) {
	  var blendMode = seriesModel.get('blendMode') || null;
	  chartView.group.traverse(function (el) {
	    // FIXME marker and other components
	    if (!el.isGroup) {
	      // Only set if blendMode is changed. In case element is incremental and don't wan't to rerender.
	      if (el.style.blend !== blendMode) {
	        el.setStyle('blend', blendMode);
	      }
	    }
	
	    if (el.eachPendingDisplayable) {
	      el.eachPendingDisplayable(function (displayable) {
	        displayable.setStyle('blend', blendMode);
	      });
	    }
	  });
	}
	/**
	 * @param {module:echarts/model/Series|module:echarts/model/Component} model
	 * @param {module:echarts/view/Component|module:echarts/view/Chart} view
	 */
	
	
	function updateZ(model, view) {
	  var z = model.get('z');
	  var zlevel = model.get('zlevel'); // Set z and zlevel
	
	  view.group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	    }
	  });
	}
	
	function createExtensionAPI(ecInstance) {
	  var coordSysMgr = ecInstance._coordSysMgr;
	  return zrUtil.extend(new ExtensionAPI(ecInstance), {
	    // Inject methods
	    getCoordinateSystems: zrUtil.bind(coordSysMgr.getCoordinateSystems, coordSysMgr),
	    getComponentByElement: function (el) {
	      while (el) {
	        var modelInfo = el.__ecComponentInfo;
	
	        if (modelInfo != null) {
	          return ecInstance._model.getComponent(modelInfo.mainType, modelInfo.index);
	        }
	
	        el = el.parent;
	      }
	    }
	  });
	}
	/**
	 * @class
	 * Usage of query:
	 * `chart.on('click', query, handler);`
	 * The `query` can be:
	 * + The component type query string, only `mainType` or `mainType.subType`,
	 *   like: 'xAxis', 'series', 'xAxis.category' or 'series.line'.
	 * + The component query object, like:
	 *   `{seriesIndex: 2}`, `{seriesName: 'xx'}`, `{seriesId: 'some'}`,
	 *   `{xAxisIndex: 2}`, `{xAxisName: 'xx'}`, `{xAxisId: 'some'}`.
	 * + The data query object, like:
	 *   `{dataIndex: 123}`, `{dataType: 'link'}`, `{name: 'some'}`.
	 * + The other query object (cmponent customized query), like:
	 *   `{element: 'some'}` (only available in custom series).
	 *
	 * Caveat: If a prop in the `query` object is `null/undefined`, it is the
	 * same as there is no such prop in the `query` object.
	 */
	
	
	function EventProcessor() {
	  // These info required: targetEl, packedEvent, model, view
	  this.eventInfo;
	}
	
	EventProcessor.prototype = {
	  constructor: EventProcessor,
	  normalizeQuery: function (query) {
	    var cptQuery = {};
	    var dataQuery = {};
	    var otherQuery = {}; // `query` is `mainType` or `mainType.subType` of component.
	
	    if (zrUtil.isString(query)) {
	      var condCptType = parseClassType(query); // `.main` and `.sub` may be ''.
	
	      cptQuery.mainType = condCptType.main || null;
	      cptQuery.subType = condCptType.sub || null;
	    } // `query` is an object, convert to {mainType, index, name, id}.
	    else {
	        // `xxxIndex`, `xxxName`, `xxxId`, `name`, `dataIndex`, `dataType` is reserved,
	        // can not be used in `compomentModel.filterForExposedEvent`.
	        var suffixes = ['Index', 'Name', 'Id'];
	        var dataKeys = {
	          name: 1,
	          dataIndex: 1,
	          dataType: 1
	        };
	        zrUtil.each(query, function (val, key) {
	          var reserved = false;
	
	          for (var i = 0; i < suffixes.length; i++) {
	            var propSuffix = suffixes[i];
	            var suffixPos = key.lastIndexOf(propSuffix);
	
	            if (suffixPos > 0 && suffixPos === key.length - propSuffix.length) {
	              var mainType = key.slice(0, suffixPos); // Consider `dataIndex`.
	
	              if (mainType !== 'data') {
	                cptQuery.mainType = mainType;
	                cptQuery[propSuffix.toLowerCase()] = val;
	                reserved = true;
	              }
	            }
	          }
	
	          if (dataKeys.hasOwnProperty(key)) {
	            dataQuery[key] = val;
	            reserved = true;
	          }
	
	          if (!reserved) {
	            otherQuery[key] = val;
	          }
	        });
	      }
	
	    return {
	      cptQuery: cptQuery,
	      dataQuery: dataQuery,
	      otherQuery: otherQuery
	    };
	  },
	  filter: function (eventType, query, args) {
	    // They should be assigned before each trigger call.
	    var eventInfo = this.eventInfo;
	
	    if (!eventInfo) {
	      return true;
	    }
	
	    var targetEl = eventInfo.targetEl;
	    var packedEvent = eventInfo.packedEvent;
	    var model = eventInfo.model;
	    var view = eventInfo.view; // For event like 'globalout'.
	
	    if (!model || !view) {
	      return true;
	    }
	
	    var cptQuery = query.cptQuery;
	    var dataQuery = query.dataQuery;
	    return check(cptQuery, model, 'mainType') && check(cptQuery, model, 'subType') && check(cptQuery, model, 'index', 'componentIndex') && check(cptQuery, model, 'name') && check(cptQuery, model, 'id') && check(dataQuery, packedEvent, 'name') && check(dataQuery, packedEvent, 'dataIndex') && check(dataQuery, packedEvent, 'dataType') && (!view.filterForExposedEvent || view.filterForExposedEvent(eventType, query.otherQuery, targetEl, packedEvent));
	
	    function check(query, host, prop, propOnHost) {
	      return query[prop] == null || host[propOnHost || prop] === query[prop];
	    }
	  },
	  afterTrigger: function () {
	    // Make sure the eventInfo wont be used in next trigger.
	    this.eventInfo = null;
	  }
	};
	/**
	 * @type {Object} key: actionType.
	 * @inner
	 */
	
	var actions = {};
	/**
	 * Map eventType to actionType
	 * @type {Object}
	 */
	
	var eventActionMap = {};
	/**
	 * Data processor functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 * @inner
	 */
	
	var dataProcessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var optionPreprocessorFuncs = [];
	/**
	 * @type {Array.<Function>}
	 * @inner
	 */
	
	var postUpdateFuncs = [];
	/**
	 * Visual encoding functions of each stage
	 * @type {Array.<Object.<string, Function>>}
	 */
	
	var visualFuncs = [];
	/**
	 * Theme storage
	 * @type {Object.<key, Object>}
	 */
	
	var themeStorage = {};
	/**
	 * Loading effects
	 */
	
	var loadingEffects = {};
	var instances = {};
	var connectedGroups = {};
	var idBase = new Date() - 0;
	var groupIdBase = new Date() - 0;
	var DOM_ATTRIBUTE_KEY = '_echarts_instance_';
	
	function enableConnect(chart) {
	  var STATUS_PENDING = 0;
	  var STATUS_UPDATING = 1;
	  var STATUS_UPDATED = 2;
	  var STATUS_KEY = '__connectUpdateStatus';
	
	  function updateConnectedChartsStatus(charts, status) {
	    for (var i = 0; i < charts.length; i++) {
	      var otherChart = charts[i];
	      otherChart[STATUS_KEY] = status;
	    }
	  }
	
	  each(eventActionMap, function (actionType, eventType) {
	    chart._messageCenter.on(eventType, function (event) {
	      if (connectedGroups[chart.group] && chart[STATUS_KEY] !== STATUS_PENDING) {
	        if (event && event.escapeConnect) {
	          return;
	        }
	
	        var action = chart.makeActionFromEvent(event);
	        var otherCharts = [];
	        each(instances, function (otherChart) {
	          if (otherChart !== chart && otherChart.group === chart.group) {
	            otherCharts.push(otherChart);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_PENDING);
	        each(otherCharts, function (otherChart) {
	          if (otherChart[STATUS_KEY] !== STATUS_UPDATING) {
	            otherChart.dispatchAction(action);
	          }
	        });
	        updateConnectedChartsStatus(otherCharts, STATUS_UPDATED);
	      }
	    });
	  });
	}
	/**
	 * @param {HTMLElement} dom
	 * @param {Object} [theme]
	 * @param {Object} opts
	 * @param {number} [opts.devicePixelRatio] Use window.devicePixelRatio by default
	 * @param {string} [opts.renderer] Can choose 'canvas' or 'svg' to render the chart.
	 * @param {number} [opts.width] Use clientWidth of the input `dom` by default.
	 *                              Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Use clientHeight of the input `dom` by default.
	 *                               Can be 'auto' (the same as null/undefined)
	 */
	
	
	function init(dom, theme, opts) {
	  var existInstance = getInstanceByDom(dom);
	
	  if (existInstance) {
	    return existInstance;
	  }
	
	  var chart = new ECharts(dom, theme, opts);
	  chart.id = 'ec_' + idBase++;
	  instances[chart.id] = chart;
	  modelUtil.setAttribute(dom, DOM_ATTRIBUTE_KEY, chart.id);
	  enableConnect(chart);
	  return chart;
	}
	/**
	 * @return {string|Array.<module:echarts~ECharts>} groupId
	 */
	
	
	function connect(groupId) {
	  // Is array of charts
	  if (zrUtil.isArray(groupId)) {
	    var charts = groupId;
	    groupId = null; // If any chart has group
	
	    each(charts, function (chart) {
	      if (chart.group != null) {
	        groupId = chart.group;
	      }
	    });
	    groupId = groupId || 'g_' + groupIdBase++;
	    each(charts, function (chart) {
	      chart.group = groupId;
	    });
	  }
	
	  connectedGroups[groupId] = true;
	  return groupId;
	}
	/**
	 * @DEPRECATED
	 * @return {string} groupId
	 */
	
	
	function disConnect(groupId) {
	  connectedGroups[groupId] = false;
	}
	/**
	 * @return {string} groupId
	 */
	
	
	var disconnect = disConnect;
	/**
	 * Dispose a chart instance
	 * @param  {module:echarts~ECharts|HTMLDomElement|string} chart
	 */
	
	function dispose(chart) {
	  if (typeof chart === 'string') {
	    chart = instances[chart];
	  } else if (!(chart instanceof ECharts)) {
	    // Try to treat as dom
	    chart = getInstanceByDom(chart);
	  }
	
	  if (chart instanceof ECharts && !chart.isDisposed()) {
	    chart.dispose();
	  }
	}
	/**
	 * @param  {HTMLElement} dom
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceByDom(dom) {
	  return instances[modelUtil.getAttribute(dom, DOM_ATTRIBUTE_KEY)];
	}
	/**
	 * @param {string} key
	 * @return {echarts~ECharts}
	 */
	
	
	function getInstanceById(key) {
	  return instances[key];
	}
	/**
	 * Register theme
	 */
	
	
	function registerTheme(name, theme) {
	  themeStorage[name] = theme;
	}
	/**
	 * Register option preprocessor
	 * @param {Function} preprocessorFunc
	 */
	
	
	function registerPreprocessor(preprocessorFunc) {
	  optionPreprocessorFuncs.push(preprocessorFunc);
	}
	/**
	 * @param {number} [priority=1000]
	 * @param {Object|Function} processor
	 */
	
	
	function registerProcessor(priority, processor) {
	  normalizeRegister(dataProcessorFuncs, priority, processor, PRIORITY_PROCESSOR_FILTER);
	}
	/**
	 * Register postUpdater
	 * @param {Function} postUpdateFunc
	 */
	
	
	function registerPostUpdate(postUpdateFunc) {
	  postUpdateFuncs.push(postUpdateFunc);
	}
	/**
	 * Usage:
	 * registerAction('someAction', 'someEvent', function () { ... });
	 * registerAction('someAction', function () { ... });
	 * registerAction(
	 *     {type: 'someAction', event: 'someEvent', update: 'updateView'},
	 *     function () { ... }
	 * );
	 *
	 * @param {(string|Object)} actionInfo
	 * @param {string} actionInfo.type
	 * @param {string} [actionInfo.event]
	 * @param {string} [actionInfo.update]
	 * @param {string} [eventName]
	 * @param {Function} action
	 */
	
	
	function registerAction(actionInfo, eventName, action) {
	  if (typeof eventName === 'function') {
	    action = eventName;
	    eventName = '';
	  }
	
	  var actionType = isObject(actionInfo) ? actionInfo.type : [actionInfo, actionInfo = {
	    event: eventName
	  }][0]; // Event name is all lowercase
	
	  actionInfo.event = (actionInfo.event || actionType).toLowerCase();
	  eventName = actionInfo.event; // Validate action type and event name.
	
	  assert(ACTION_REG.test(actionType) && ACTION_REG.test(eventName));
	
	  if (!actions[actionType]) {
	    actions[actionType] = {
	      action: action,
	      actionInfo: actionInfo
	    };
	  }
	
	  eventActionMap[eventName] = actionType;
	}
	/**
	 * @param {string} type
	 * @param {*} CoordinateSystem
	 */
	
	
	function registerCoordinateSystem(type, CoordinateSystem) {
	  CoordinateSystemManager.register(type, CoordinateSystem);
	}
	/**
	 * Get dimensions of specified coordinate system.
	 * @param {string} type
	 * @return {Array.<string|Object>}
	 */
	
	
	function getCoordinateSystemDimensions(type) {
	  var coordSysCreator = CoordinateSystemManager.get(type);
	
	  if (coordSysCreator) {
	    return coordSysCreator.getDimensionsInfo ? coordSysCreator.getDimensionsInfo() : coordSysCreator.dimensions.slice();
	  }
	}
	/**
	 * Layout is a special stage of visual encoding
	 * Most visual encoding like color are common for different chart
	 * But each chart has it's own layout algorithm
	 *
	 * @param {number} [priority=1000]
	 * @param {Function} layoutTask
	 */
	
	
	function registerLayout(priority, layoutTask) {
	  normalizeRegister(visualFuncs, priority, layoutTask, PRIORITY_VISUAL_LAYOUT, 'layout');
	}
	/**
	 * @param {number} [priority=3000]
	 * @param {module:echarts/stream/Task} visualTask
	 */
	
	
	function registerVisual(priority, visualTask) {
	  normalizeRegister(visualFuncs, priority, visualTask, PRIORITY_VISUAL_CHART, 'visual');
	}
	/**
	 * @param {Object|Function} fn: {seriesType, createOnAllSeries, performRawSeries, reset}
	 */
	
	
	function normalizeRegister(targetList, priority, fn, defaultPriority, visualType) {
	  if (isFunction(priority) || isObject(priority)) {
	    fn = priority;
	    priority = defaultPriority;
	  }
	
	  var stageHandler = Scheduler.wrapStageHandler(fn, visualType);
	  stageHandler.__prio = priority;
	  stageHandler.__raw = fn;
	  targetList.push(stageHandler);
	  return stageHandler;
	}
	/**
	 * @param {string} name
	 */
	
	
	function registerLoading(name, loadingFx) {
	  loadingEffects[name] = loadingFx;
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentModel(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentModel;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendComponentView(opts
	/*, superClass*/
	) {
	  // var Clazz = ComponentView;
	  // if (superClass) {
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentView.getClass(classType.main, classType.sub, true);
	  // }
	  return ComponentView.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendSeriesModel(opts
	/*, superClass*/
	) {
	  // var Clazz = SeriesModel;
	  // if (superClass) {
	  //     superClass = 'series.' + superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ComponentModel.getClass(classType.main, classType.sub, true);
	  // }
	  return SeriesModel.extend(opts);
	}
	/**
	 * @param {Object} opts
	 * @param {string} [superClass]
	 */
	
	
	function extendChartView(opts
	/*, superClass*/
	) {
	  // var Clazz = ChartView;
	  // if (superClass) {
	  //     superClass = superClass.replace('series.', '');
	  //     var classType = parseClassType(superClass);
	  //     Clazz = ChartView.getClass(classType.main, true);
	  // }
	  return ChartView.extend(opts);
	}
	/**
	 * ZRender need a canvas context to do measureText.
	 * But in node environment canvas may be created by node-canvas.
	 * So we need to specify how to create a canvas instead of using document.createElement('canvas')
	 *
	 * Be careful of using it in the browser.
	 *
	 * @param {Function} creator
	 * @example
	 *     var Canvas = require('canvas');
	 *     var echarts = require('echarts');
	 *     echarts.setCanvasCreator(function () {
	 *         // Small size is enough.
	 *         return new Canvas(32, 32);
	 *     });
	 */
	
	
	function setCanvasCreator(creator) {
	  zrUtil.$override('createCanvas', creator);
	}
	/**
	 * @param {string} mapName
	 * @param {Array.<Object>|Object|string} geoJson
	 * @param {Object} [specialAreas]
	 *
	 * @example GeoJSON
	 *     $.get('USA.json', function (geoJson) {
	 *         echarts.registerMap('USA', geoJson);
	 *         // Or
	 *         echarts.registerMap('USA', {
	 *             geoJson: geoJson,
	 *             specialAreas: {}
	 *         })
	 *     });
	 *
	 *     $.get('airport.svg', function (svg) {
	 *         echarts.registerMap('airport', {
	 *             svg: svg
	 *         }
	 *     });
	 *
	 *     echarts.registerMap('eu', [
	 *         {svg: eu-topographic.svg},
	 *         {geoJSON: eu.json}
	 *     ])
	 */
	
	
	function registerMap(mapName, geoJson, specialAreas) {
	  mapDataStorage.registerMap(mapName, geoJson, specialAreas);
	}
	/**
	 * @param {string} mapName
	 * @return {Object}
	 */
	
	
	function getMap(mapName) {
	  // For backward compatibility, only return the first one.
	  var records = mapDataStorage.retrieveMap(mapName);
	  return records && records[0] && {
	    geoJson: records[0].geoJSON,
	    specialAreas: records[0].specialAreas
	  };
	}
	
	registerVisual(PRIORITY_VISUAL_GLOBAL, seriesColor);
	registerPreprocessor(backwardCompat);
	registerProcessor(PRIORITY_PROCESSOR_DATASTACK, dataStack);
	registerLoading('default', loadingDefault); // Default actions
	
	registerAction({
	  type: 'highlight',
	  event: 'highlight',
	  update: 'highlight'
	}, zrUtil.noop);
	registerAction({
	  type: 'downplay',
	  event: 'downplay',
	  update: 'downplay'
	}, zrUtil.noop); // Default theme
	
	registerTheme('light', lightTheme);
	registerTheme('dark', darkTheme); // For backward compatibility, where the namespace `dataTool` will
	// be mounted on `echarts` is the extension `dataTool` is imported.
	
	var dataTool = {};
	exports.version = version;
	exports.dependencies = dependencies;
	exports.PRIORITY = PRIORITY;
	exports.init = init;
	exports.connect = connect;
	exports.disConnect = disConnect;
	exports.disconnect = disconnect;
	exports.dispose = dispose;
	exports.getInstanceByDom = getInstanceByDom;
	exports.getInstanceById = getInstanceById;
	exports.registerTheme = registerTheme;
	exports.registerPreprocessor = registerPreprocessor;
	exports.registerProcessor = registerProcessor;
	exports.registerPostUpdate = registerPostUpdate;
	exports.registerAction = registerAction;
	exports.registerCoordinateSystem = registerCoordinateSystem;
	exports.getCoordinateSystemDimensions = getCoordinateSystemDimensions;
	exports.registerLayout = registerLayout;
	exports.registerVisual = registerVisual;
	exports.registerLoading = registerLoading;
	exports.extendComponentModel = extendComponentModel;
	exports.extendComponentView = extendComponentView;
	exports.extendSeriesModel = extendSeriesModel;
	exports.extendChartView = extendChartView;
	exports.setCanvasCreator = setCanvasCreator;
	exports.registerMap = registerMap;
	exports.getMap = getMap;
	exports.dataTool = dataTool;
	var ___ec_export = __webpack_require__(873);
	(function () {
	    for (var key in ___ec_export) {
	        if (___ec_export.hasOwnProperty(key)) {
	            exports[key] = ___ec_export[key];
	        }
	    }
	})();

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "ConfigConsumer", {
	  enumerable: true,
	  get: function get() {
	    return _context.ConfigConsumer;
	  }
	});
	exports["default"] = exports.configConsumerProps = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _localeProvider = _interopRequireWildcard(__webpack_require__(636));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _context = __webpack_require__(317);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var configConsumerProps = ['getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'autoInsertSpaceInButton', 'locale', 'pageHeader'];
	exports.configConsumerProps = configConsumerProps;
	
	var ConfigProvider = /*#__PURE__*/function (_React$Component) {
	  _inherits(ConfigProvider, _React$Component);
	
	  var _super = _createSuper(ConfigProvider);
	
	  function ConfigProvider() {
	    var _this;
	
	    _classCallCheck(this, ConfigProvider);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getPrefixCls = function (suffixCls, customizePrefixCls) {
	      var _this$props$prefixCls = _this.props.prefixCls,
	          prefixCls = _this$props$prefixCls === void 0 ? 'ant' : _this$props$prefixCls;
	      if (customizePrefixCls) return customizePrefixCls;
	      return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
	    };
	
	    _this.renderProvider = function (context, legacyLocale) {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          getPopupContainer = _this$props.getPopupContainer,
	          renderEmpty = _this$props.renderEmpty,
	          csp = _this$props.csp,
	          autoInsertSpaceInButton = _this$props.autoInsertSpaceInButton,
	          locale = _this$props.locale,
	          pageHeader = _this$props.pageHeader;
	
	      var config = _extends(_extends({}, context), {
	        getPrefixCls: _this.getPrefixCls,
	        csp: csp,
	        autoInsertSpaceInButton: autoInsertSpaceInButton
	      });
	
	      if (getPopupContainer) {
	        config.getPopupContainer = getPopupContainer;
	      }
	
	      if (renderEmpty) {
	        config.renderEmpty = renderEmpty;
	      }
	
	      if (pageHeader) {
	        config.pageHeader = pageHeader;
	      }
	
	      return /*#__PURE__*/React.createElement(_context.ConfigContext.Provider, {
	        value: config
	      }, /*#__PURE__*/React.createElement(_localeProvider["default"], {
	        locale: locale || legacyLocale,
	        _ANT_MARK__: _localeProvider.ANT_MARK
	      }, children));
	    };
	
	    return _this;
	  }
	
	  _createClass(ConfigProvider, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (_, __, legacyLocale) {
	        return /*#__PURE__*/React.createElement(_context.ConfigConsumer, null, function (context) {
	          return _this2.renderProvider(context, legacyLocale);
	        });
	      });
	    }
	  }]);
	
	  return ConfigProvider;
	}(React.Component);
	
	var _default = ConfigProvider;
	exports["default"] = _default;

/***/ },
/* 12 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.BackBtn = exports.goBack = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(1185);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var goBack = exports.goBack = function goBack() {
	  _reactRouter.browserHistory.go(-1);
	};
	
	var BackBtn = exports.BackBtn = function (_Component) {
	  _inherits(BackBtn, _Component);
	
	  function BackBtn(props) {
	    _classCallCheck(this, BackBtn);
	
	    var _this = _possibleConstructorReturn(this, (BackBtn.__proto__ || Object.getPrototypeOf(BackBtn)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BackBtn, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_antd.Button, { id: 'btnn', icon: 'left', shape: 'circle', style: { marginRight: 10 }, onClick: goBack });
	    }
	  }]);
	
	  return BackBtn;
	}(_react.Component);

/***/ },
/* 13 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 14 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var pathTool = __webpack_require__(1209);
	
	var colorTool = __webpack_require__(148);
	
	var matrix = __webpack_require__(86);
	
	var vector = __webpack_require__(55);
	
	var Path = __webpack_require__(67);
	
	var Transformable = __webpack_require__(396);
	
	var ZImage = __webpack_require__(267);
	
	exports.Image = ZImage;
	
	var Group = __webpack_require__(223);
	
	exports.Group = Group;
	
	var Text = __webpack_require__(224);
	
	exports.Text = Text;
	
	var Circle = __webpack_require__(1204);
	
	exports.Circle = Circle;
	
	var Sector = __webpack_require__(2992);
	
	exports.Sector = Sector;
	
	var Ring = __webpack_require__(2991);
	
	exports.Ring = Ring;
	
	var Polygon = __webpack_require__(1206);
	
	exports.Polygon = Polygon;
	
	var Polyline = __webpack_require__(1207);
	
	exports.Polyline = Polyline;
	
	var Rect = __webpack_require__(606);
	
	exports.Rect = Rect;
	
	var Line = __webpack_require__(1205);
	
	exports.Line = Line;
	
	var BezierCurve = __webpack_require__(2989);
	
	exports.BezierCurve = BezierCurve;
	
	var Arc = __webpack_require__(2988);
	
	exports.Arc = Arc;
	
	var CompoundPath = __webpack_require__(2984);
	
	exports.CompoundPath = CompoundPath;
	
	var LinearGradient = __webpack_require__(602);
	
	exports.LinearGradient = LinearGradient;
	
	var RadialGradient = __webpack_require__(2985);
	
	exports.RadialGradient = RadialGradient;
	
	var BoundingRect = __webpack_require__(60);
	
	exports.BoundingRect = BoundingRect;
	
	var IncrementalDisplayable = __webpack_require__(601);
	
	exports.IncrementalDisplayable = IncrementalDisplayable;
	
	var subPixelOptimizeUtil = __webpack_require__(605);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var mathMax = Math.max;
	var mathMin = Math.min;
	var EMPTY_OBJ = {};
	var Z2_EMPHASIS_LIFT = 1; // key: label model property nane, value: style property name.
	
	var CACHED_LABEL_STYLE_PROPERTIES = {
	  color: 'textFill',
	  textBorderColor: 'textStroke',
	  textBorderWidth: 'textStrokeWidth'
	};
	var EMPHASIS = 'emphasis';
	var NORMAL = 'normal'; // Reserve 0 as default.
	
	var _highlightNextDigit = 1;
	var _highlightKeyMap = {};
	var _customShapeMap = {};
	/**
	 * Extend shape with parameters
	 */
	
	function extendShape(opts) {
	  return Path.extend(opts);
	}
	/**
	 * Extend path
	 */
	
	
	function extendPath(pathData, opts) {
	  return pathTool.extendFromString(pathData, opts);
	}
	/**
	 * Register a user defined shape.
	 * The shape class can be fetched by `getShapeClass`
	 * This method will overwrite the registered shapes, including
	 * the registered built-in shapes, if using the same `name`.
	 * The shape can be used in `custom series` and
	 * `graphic component` by declaring `{type: name}`.
	 *
	 * @param {string} name
	 * @param {Object} ShapeClass Can be generated by `extendShape`.
	 */
	
	
	function registerShape(name, ShapeClass) {
	  _customShapeMap[name] = ShapeClass;
	}
	/**
	 * Find shape class registered by `registerShape`. Usually used in
	 * fetching user defined shape.
	 *
	 * [Caution]:
	 * (1) This method **MUST NOT be used inside echarts !!!**, unless it is prepared
	 * to use user registered shapes.
	 * Because the built-in shape (see `getBuiltInShape`) will be registered by
	 * `registerShape` by default. That enables users to get both built-in
	 * shapes as well as the shapes belonging to themsleves. But users can overwrite
	 * the built-in shapes by using names like 'circle', 'rect' via calling
	 * `registerShape`. So the echarts inner featrues should not fetch shapes from here
	 * in case that it is overwritten by users, except that some features, like
	 * `custom series`, `graphic component`, do it deliberately.
	 *
	 * (2) In the features like `custom series`, `graphic component`, the user input
	 * `{tpye: 'xxx'}` does not only specify shapes but also specify other graphic
	 * elements like `'group'`, `'text'`, `'image'` or event `'path'`. Those names
	 * are reserved names, that is, if some user register a shape named `'image'`,
	 * the shape will not be used. If we intending to add some more reserved names
	 * in feature, that might bring break changes (disable some existing user shape
	 * names). But that case probably rearly happen. So we dont make more mechanism
	 * to resolve this issue here.
	 *
	 * @param {string} name
	 * @return {Object} The shape class. If not found, return nothing.
	 */
	
	
	function getShapeClass(name) {
	  if (_customShapeMap.hasOwnProperty(name)) {
	    return _customShapeMap[name];
	  }
	}
	/**
	 * Create a path element from path data string
	 * @param {string} pathData
	 * @param {Object} opts
	 * @param {module:zrender/core/BoundingRect} rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makePath(pathData, opts, rect, layout) {
	  var path = pathTool.createFromString(pathData, opts);
	
	  if (rect) {
	    if (layout === 'center') {
	      rect = centerGraphic(rect, path.getBoundingRect());
	    }
	
	    resizePath(path, rect);
	  }
	
	  return path;
	}
	/**
	 * Create a image element from image url
	 * @param {string} imageUrl image url
	 * @param {Object} opts options
	 * @param {module:zrender/core/BoundingRect} rect constrain rect
	 * @param {string} [layout=cover] 'center' or 'cover'
	 */
	
	
	function makeImage(imageUrl, rect, layout) {
	  var path = new ZImage({
	    style: {
	      image: imageUrl,
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    onload: function (img) {
	      if (layout === 'center') {
	        var boundingRect = {
	          width: img.width,
	          height: img.height
	        };
	        path.setStyle(centerGraphic(rect, boundingRect));
	      }
	    }
	  });
	  return path;
	}
	/**
	 * Get position of centered element in bounding box.
	 *
	 * @param  {Object} rect         element local bounding box
	 * @param  {Object} boundingRect constraint bounding box
	 * @return {Object} element position containing x, y, width, and height
	 */
	
	
	function centerGraphic(rect, boundingRect) {
	  // Set rect to center, keep width / height ratio.
	  var aspect = boundingRect.width / boundingRect.height;
	  var width = rect.height * aspect;
	  var height;
	
	  if (width <= rect.width) {
	    height = rect.height;
	  } else {
	    width = rect.width;
	    height = width / aspect;
	  }
	
	  var cx = rect.x + rect.width / 2;
	  var cy = rect.y + rect.height / 2;
	  return {
	    x: cx - width / 2,
	    y: cy - height / 2,
	    width: width,
	    height: height
	  };
	}
	
	var mergePath = pathTool.mergePath;
	/**
	 * Resize a path to fit the rect
	 * @param {module:zrender/graphic/Path} path
	 * @param {Object} rect
	 */
	
	function resizePath(path, rect) {
	  if (!path.applyTransform) {
	    return;
	  }
	
	  var pathRect = path.getBoundingRect();
	  var m = pathRect.calculateTransform(rect);
	  path.applyTransform(m);
	}
	/**
	 * Sub pixel optimize line for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x1]
	 * @param {number} [param.shape.y1]
	 * @param {number} [param.shape.x2]
	 * @param {number} [param.shape.y2]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeLine(param) {
	  subPixelOptimizeUtil.subPixelOptimizeLine(param.shape, param.shape, param.style);
	  return param;
	}
	/**
	 * Sub pixel optimize rect for canvas
	 *
	 * @param {Object} param
	 * @param {Object} [param.shape]
	 * @param {number} [param.shape.x]
	 * @param {number} [param.shape.y]
	 * @param {number} [param.shape.width]
	 * @param {number} [param.shape.height]
	 * @param {Object} [param.style]
	 * @param {number} [param.style.lineWidth]
	 * @return {Object} Modified param
	 */
	
	
	function subPixelOptimizeRect(param) {
	  subPixelOptimizeUtil.subPixelOptimizeRect(param.shape, param.shape, param.style);
	  return param;
	}
	/**
	 * Sub pixel optimize for canvas
	 *
	 * @param {number} position Coordinate, such as x, y
	 * @param {number} lineWidth Should be nonnegative integer.
	 * @param {boolean=} positiveOrNegative Default false (negative).
	 * @return {number} Optimized position.
	 */
	
	
	var subPixelOptimize = subPixelOptimizeUtil.subPixelOptimize;
	
	function hasFillOrStroke(fillOrStroke) {
	  return fillOrStroke != null && fillOrStroke !== 'none';
	} // Most lifted color are duplicated.
	
	
	var liftedColorMap = zrUtil.createHashMap();
	var liftedColorCount = 0;
	
	function liftColor(color) {
	  if (typeof color !== 'string') {
	    return color;
	  }
	
	  var liftedColor = liftedColorMap.get(color);
	
	  if (!liftedColor) {
	    liftedColor = colorTool.lift(color, -0.1);
	
	    if (liftedColorCount < 10000) {
	      liftedColorMap.set(color, liftedColor);
	      liftedColorCount++;
	    }
	  }
	
	  return liftedColor;
	}
	
	function cacheElementStl(el) {
	  if (!el.__hoverStlDirty) {
	    return;
	  }
	
	  el.__hoverStlDirty = false;
	  var hoverStyle = el.__hoverStl;
	
	  if (!hoverStyle) {
	    el.__cachedNormalStl = el.__cachedNormalZ2 = null;
	    return;
	  }
	
	  var normalStyle = el.__cachedNormalStl = {};
	  el.__cachedNormalZ2 = el.z2;
	  var elStyle = el.style;
	
	  for (var name in hoverStyle) {
	    // See comment in `singleEnterEmphasis`.
	    if (hoverStyle[name] != null) {
	      normalStyle[name] = elStyle[name];
	    }
	  } // Always cache fill and stroke to normalStyle for lifting color.
	
	
	  normalStyle.fill = elStyle.fill;
	  normalStyle.stroke = elStyle.stroke;
	}
	
	function singleEnterEmphasis(el) {
	  var hoverStl = el.__hoverStl;
	
	  if (!hoverStl || el.__highlighted) {
	    return;
	  }
	
	  var zr = el.__zr;
	  var useHoverLayer = el.useHoverLayer && zr && zr.painter.type === 'canvas';
	  el.__highlighted = useHoverLayer ? 'layer' : 'plain';
	
	  if (el.isGroup || !zr && el.useHoverLayer) {
	    return;
	  }
	
	  var elTarget = el;
	  var targetStyle = el.style;
	
	  if (useHoverLayer) {
	    elTarget = zr.addHover(el);
	    targetStyle = elTarget.style;
	  }
	
	  rollbackDefaultTextStyle(targetStyle);
	
	  if (!useHoverLayer) {
	    cacheElementStl(elTarget);
	  } // styles can be:
	  // {
	  //    label: {
	  //        show: false,
	  //        position: 'outside',
	  //        fontSize: 18
	  //    },
	  //    emphasis: {
	  //        label: {
	  //            show: true
	  //        }
	  //    }
	  // },
	  // where properties of `emphasis` may not appear in `normal`. We previously use
	  // module:echarts/util/model#defaultEmphasis to merge `normal` to `emphasis`.
	  // But consider rich text and setOption in merge mode, it is impossible to cover
	  // all properties in merge. So we use merge mode when setting style here.
	  // But we choose the merge strategy that only properties that is not `null/undefined`.
	  // Because when making a textStyle (espacially rich text), it is not easy to distinguish
	  // `hasOwnProperty` and `null/undefined` in code, so we trade them as the same for simplicity.
	  // But this strategy brings a trouble that `null/undefined` can not be used to remove
	  // style any more in `emphasis`. Users can both set properties directly on normal and
	  // emphasis to avoid this issue, or we might support `'none'` for this case if required.
	
	
	  targetStyle.extendFrom(hoverStl);
	  setDefaultHoverFillStroke(targetStyle, hoverStl, 'fill');
	  setDefaultHoverFillStroke(targetStyle, hoverStl, 'stroke');
	  applyDefaultTextStyle(targetStyle);
	
	  if (!useHoverLayer) {
	    el.dirty(false);
	    el.z2 += Z2_EMPHASIS_LIFT;
	  }
	}
	
	function setDefaultHoverFillStroke(targetStyle, hoverStyle, prop) {
	  if (!hasFillOrStroke(hoverStyle[prop]) && hasFillOrStroke(targetStyle[prop])) {
	    targetStyle[prop] = liftColor(targetStyle[prop]);
	  }
	}
	
	function singleEnterNormal(el) {
	  var highlighted = el.__highlighted;
	
	  if (!highlighted) {
	    return;
	  }
	
	  el.__highlighted = false;
	
	  if (el.isGroup) {
	    return;
	  }
	
	  if (highlighted === 'layer') {
	    el.__zr && el.__zr.removeHover(el);
	  } else {
	    var style = el.style;
	    var normalStl = el.__cachedNormalStl;
	
	    if (normalStl) {
	      rollbackDefaultTextStyle(style);
	      el.setStyle(normalStl);
	      applyDefaultTextStyle(style);
	    } // `__cachedNormalZ2` will not be reset if calling `setElementHoverStyle`
	    // when `el` is on emphasis state. So here by comparing with 1, we try
	    // hard to make the bug case rare.
	
	
	    var normalZ2 = el.__cachedNormalZ2;
	
	    if (normalZ2 != null && el.z2 - normalZ2 === Z2_EMPHASIS_LIFT) {
	      el.z2 = normalZ2;
	    }
	  }
	}
	
	function traverseUpdate(el, updater, commonParam) {
	  // If root is group, also enter updater for `highDownOnUpdate`.
	  var fromState = NORMAL;
	  var toState = NORMAL;
	  var trigger; // See the rule of `highDownOnUpdate` on `graphic.setAsHighDownDispatcher`.
	
	  el.__highlighted && (fromState = EMPHASIS, trigger = true);
	  updater(el, commonParam);
	  el.__highlighted && (toState = EMPHASIS, trigger = true);
	  el.isGroup && el.traverse(function (child) {
	    !child.isGroup && updater(child, commonParam);
	  });
	  trigger && el.__highDownOnUpdate && el.__highDownOnUpdate(fromState, toState);
	}
	/**
	 * Set hover style (namely "emphasis style") of element, based on the current
	 * style of the given `el`.
	 * This method should be called after all of the normal styles have been adopted
	 * to the `el`. See the reason on `setHoverStyle`.
	 *
	 * @param {module:zrender/Element} el Should not be `zrender/container/Group`.
	 * @param {Object} [el.hoverStyle] Can be set on el or its descendants,
	 *        e.g., `el.hoverStyle = ...; graphic.setHoverStyle(el); `.
	 *        Often used when item group has a label element and it's hoverStyle is different.
	 * @param {Object|boolean} [hoverStl] The specified hover style.
	 *        If set as `false`, disable the hover style.
	 *        Similarly, The `el.hoverStyle` can alse be set
	 *        as `false` to disable the hover style.
	 *        Otherwise, use the default hover style if not provided.
	 */
	
	
	function setElementHoverStyle(el, hoverStl) {
	  // For performance consideration, it might be better to make the "hover style" only the
	  // difference properties from the "normal style", but not a entire copy of all styles.
	  hoverStl = el.__hoverStl = hoverStl !== false && (el.hoverStyle || hoverStl || {});
	  el.__hoverStlDirty = true; // FIXME
	  // It is not completely right to save "normal"/"emphasis" flag on elements.
	  // It probably should be saved on `data` of series. Consider the cases:
	  // (1) A highlighted elements are moved out of the view port and re-enter
	  // again by dataZoom.
	  // (2) call `setOption` and replace elements totally when they are highlighted.
	
	  if (el.__highlighted) {
	    // Consider the case:
	    // The styles of a highlighted `el` is being updated. The new "emphasis style"
	    // should be adapted to the `el`. Notice here new "normal styles" should have
	    // been set outside and the cached "normal style" is out of date.
	    el.__cachedNormalStl = null; // Do not clear `__cachedNormalZ2` here, because setting `z2` is not a constraint
	    // of this method. In most cases, `z2` is not set and hover style should be able
	    // to rollback. Of course, that would bring bug, but only in a rare case, see
	    // `doSingleLeaveHover` for details.
	
	    singleEnterNormal(el);
	    singleEnterEmphasis(el);
	  }
	}
	
	function onElementMouseOver(e) {
	  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
	  && !this.__highByOuter && traverseUpdate(this, singleEnterEmphasis);
	}
	
	function onElementMouseOut(e) {
	  !shouldSilent(this, e) // "emphasis" event highlight has higher priority than mouse highlight.
	  && !this.__highByOuter && traverseUpdate(this, singleEnterNormal);
	}
	
	function onElementEmphasisEvent(highlightDigit) {
	  this.__highByOuter |= 1 << (highlightDigit || 0);
	  traverseUpdate(this, singleEnterEmphasis);
	}
	
	function onElementNormalEvent(highlightDigit) {
	  !(this.__highByOuter &= ~(1 << (highlightDigit || 0))) && traverseUpdate(this, singleEnterNormal);
	}
	
	function shouldSilent(el, e) {
	  return el.__highDownSilentOnTouch && e.zrByTouch;
	}
	/**
	 * Set hover style (namely "emphasis style") of element,
	 * based on the current style of the given `el`.
	 *
	 * (1)
	 * **CONSTRAINTS** for this method:
	 * <A> This method MUST be called after all of the normal styles having been adopted
	 * to the `el`.
	 * <B> The input `hoverStyle` (that is, "emphasis style") MUST be the subset of the
	 * "normal style" having been set to the el.
	 * <C> `color` MUST be one of the "normal styles" (because color might be lifted as
	 * a default hover style).
	 *
	 * The reason: this method treat the current style of the `el` as the "normal style"
	 * and cache them when enter/update the "emphasis style". Consider the case: the `el`
	 * is in "emphasis" state and `setOption`/`dispatchAction` trigger the style updating
	 * logic, where the el should shift from the original emphasis style to the new
	 * "emphasis style" and should be able to "downplay" back to the new "normal style".
	 *
	 * Indeed, it is error-prone to make a interface has so many constraints, but I have
	 * not found a better solution yet to fit the backward compatibility, performance and
	 * the current programming style.
	 *
	 * (2)
	 * Call the method for a "root" element once. Do not call it for each descendants.
	 * If the descendants elemenets of a group has itself hover style different from the
	 * root group, we can simply mount the style on `el.hoverStyle` for them, but should
	 * not call this method for them.
	 *
	 * (3) These input parameters can be set directly on `el`:
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} [el.hoverStyle] See `graphic.setElementHoverStyle`.
	 * @param {boolean} [el.highDownSilentOnTouch=false] See `graphic.setAsHighDownDispatcher`.
	 * @param {Function} [el.highDownOnUpdate] See `graphic.setAsHighDownDispatcher`.
	 * @param {Object|boolean} [hoverStyle] See `graphic.setElementHoverStyle`.
	 */
	
	
	function setHoverStyle(el, hoverStyle) {
	  setAsHighDownDispatcher(el, true);
	  traverseUpdate(el, setElementHoverStyle, hoverStyle);
	}
	/**
	 * @param {module:zrender/Element} el
	 * @param {Function} [el.highDownOnUpdate] Called when state updated.
	 *        Since `setHoverStyle` has the constraint that it must be called after
	 *        all of the normal style updated, `highDownOnUpdate` is not needed to
	 *        trigger if both `fromState` and `toState` is 'normal', and needed to
	 *        trigger if both `fromState` and `toState` is 'emphasis', which enables
	 *        to sync outside style settings to "emphasis" state.
	 *        @this {string} This dispatcher `el`.
	 *        @param {string} fromState Can be "normal" or "emphasis".
	 *               `fromState` might equal to `toState`,
	 *               for example, when this method is called when `el` is
	 *               on "emphasis" state.
	 *        @param {string} toState Can be "normal" or "emphasis".
	 *
	 *        FIXME
	 *        CAUTION: Do not expose `highDownOnUpdate` outside echarts.
	 *        Because it is not a complete solution. The update
	 *        listener should not have been mount in element,
	 *        and the normal/emphasis state should not have
	 *        mantained on elements.
	 *
	 * @param {boolean} [el.highDownSilentOnTouch=false]
	 *        In touch device, mouseover event will be trigger on touchstart event
	 *        (see module:zrender/dom/HandlerProxy). By this mechanism, we can
	 *        conveniently use hoverStyle when tap on touch screen without additional
	 *        code for compatibility.
	 *        But if the chart/component has select feature, which usually also use
	 *        hoverStyle, there might be conflict between 'select-highlight' and
	 *        'hover-highlight' especially when roam is enabled (see geo for example).
	 *        In this case, `highDownSilentOnTouch` should be used to disable
	 *        hover-highlight on touch device.
	 * @param {boolean} [asDispatcher=true] If `false`, do not set as "highDownDispatcher".
	 */
	
	
	function setAsHighDownDispatcher(el, asDispatcher) {
	  var disable = asDispatcher === false; // Make `highDownSilentOnTouch` and `highDownOnUpdate` only work after
	  // `setAsHighDownDispatcher` called. Avoid it is modified by user unexpectedly.
	
	  el.__highDownSilentOnTouch = el.highDownSilentOnTouch;
	  el.__highDownOnUpdate = el.highDownOnUpdate; // Simple optimize, since this method might be
	  // called for each elements of a group in some cases.
	
	  if (!disable || el.__highDownDispatcher) {
	    var method = disable ? 'off' : 'on'; // Duplicated function will be auto-ignored, see Eventful.js.
	
	    el[method]('mouseover', onElementMouseOver)[method]('mouseout', onElementMouseOut); // Emphasis, normal can be triggered manually by API or other components like hover link.
	
	    el[method]('emphasis', onElementEmphasisEvent)[method]('normal', onElementNormalEvent); // Also keep previous record.
	
	    el.__highByOuter = el.__highByOuter || 0;
	    el.__highDownDispatcher = !disable;
	  }
	}
	/**
	 * @param {module:zrender/src/Element} el
	 * @return {boolean}
	 */
	
	
	function isHighDownDispatcher(el) {
	  return !!(el && el.__highDownDispatcher);
	}
	/**
	 * Support hightlight/downplay record on each elements.
	 * For the case: hover highlight/downplay (legend, visualMap, ...) and
	 * user triggerred hightlight/downplay should not conflict.
	 * Only all of the highlightDigit cleared, return to normal.
	 * @param {string} highlightKey
	 * @return {number} highlightDigit
	 */
	
	
	function getHighlightDigit(highlightKey) {
	  var highlightDigit = _highlightKeyMap[highlightKey];
	
	  if (highlightDigit == null && _highlightNextDigit <= 32) {
	    highlightDigit = _highlightKeyMap[highlightKey] = _highlightNextDigit++;
	  }
	
	  return highlightDigit;
	}
	/**
	 * See more info in `setTextStyleCommon`.
	 * @param {Object|module:zrender/graphic/Style} normalStyle
	 * @param {Object} emphasisStyle
	 * @param {module:echarts/model/Model} normalModel
	 * @param {module:echarts/model/Model} emphasisModel
	 * @param {Object} opt Check `opt` of `setTextStyleCommon` to find other props.
	 * @param {string|Function} [opt.defaultText]
	 * @param {module:echarts/model/Model} [opt.labelFetcher] Fetch text by
	 *      `opt.labelFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {number} [opt.labelDataIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {number} [opt.labelDimIndex] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {string} [opt.labelProp] Fetch text by
	 *      `opt.textFetcher.getFormattedLabel(opt.labelDataIndex, 'normal'/'emphasis', null, opt.labelDimIndex, opt.labelProp)`
	 * @param {Object} [normalSpecified]
	 * @param {Object} [emphasisSpecified]
	 */
	
	
	function setLabelStyle(normalStyle, emphasisStyle, normalModel, emphasisModel, opt, normalSpecified, emphasisSpecified) {
	  opt = opt || EMPTY_OBJ;
	  var labelFetcher = opt.labelFetcher;
	  var labelDataIndex = opt.labelDataIndex;
	  var labelDimIndex = opt.labelDimIndex;
	  var labelProp = opt.labelProp; // This scenario, `label.normal.show = true; label.emphasis.show = false`,
	  // is not supported util someone requests.
	
	  var showNormal = normalModel.getShallow('show');
	  var showEmphasis = emphasisModel.getShallow('show'); // Consider performance, only fetch label when necessary.
	  // If `normal.show` is `false` and `emphasis.show` is `true` and `emphasis.formatter` is not set,
	  // label should be displayed, where text is fetched by `normal.formatter` or `opt.defaultText`.
	
	  var baseText;
	
	  if (showNormal || showEmphasis) {
	    if (labelFetcher) {
	      baseText = labelFetcher.getFormattedLabel(labelDataIndex, 'normal', null, labelDimIndex, labelProp);
	    }
	
	    if (baseText == null) {
	      baseText = zrUtil.isFunction(opt.defaultText) ? opt.defaultText(labelDataIndex, opt) : opt.defaultText;
	    }
	  }
	
	  var normalStyleText = showNormal ? baseText : null;
	  var emphasisStyleText = showEmphasis ? zrUtil.retrieve2(labelFetcher ? labelFetcher.getFormattedLabel(labelDataIndex, 'emphasis', null, labelDimIndex, labelProp) : null, baseText) : null; // Optimize: If style.text is null, text will not be drawn.
	
	  if (normalStyleText != null || emphasisStyleText != null) {
	    // Always set `textStyle` even if `normalStyle.text` is null, because default
	    // values have to be set on `normalStyle`.
	    // If we set default values on `emphasisStyle`, consider case:
	    // Firstly, `setOption(... label: {normal: {text: null}, emphasis: {show: true}} ...);`
	    // Secondly, `setOption(... label: {noraml: {show: true, text: 'abc', color: 'red'} ...);`
	    // Then the 'red' will not work on emphasis.
	    setTextStyle(normalStyle, normalModel, normalSpecified, opt);
	    setTextStyle(emphasisStyle, emphasisModel, emphasisSpecified, opt, true);
	  }
	
	  normalStyle.text = normalStyleText;
	  emphasisStyle.text = emphasisStyleText;
	}
	/**
	 * Modify label style manually.
	 * Only works after `setLabelStyle` and `setElementHoverStyle` called.
	 *
	 * @param {module:zrender/src/Element} el
	 * @param {Object} [normalStyleProps] optional
	 * @param {Object} [emphasisStyleProps] optional
	 */
	
	
	function modifyLabelStyle(el, normalStyleProps, emphasisStyleProps) {
	  var elStyle = el.style;
	
	  if (normalStyleProps) {
	    rollbackDefaultTextStyle(elStyle);
	    el.setStyle(normalStyleProps);
	    applyDefaultTextStyle(elStyle);
	  }
	
	  elStyle = el.__hoverStl;
	
	  if (emphasisStyleProps && elStyle) {
	    rollbackDefaultTextStyle(elStyle);
	    zrUtil.extend(elStyle, emphasisStyleProps);
	    applyDefaultTextStyle(elStyle);
	  }
	}
	/**
	 * Set basic textStyle properties.
	 * See more info in `setTextStyleCommon`.
	 * @param {Object|module:zrender/graphic/Style} textStyle
	 * @param {module:echarts/model/Model} model
	 * @param {Object} [specifiedTextStyle] Can be overrided by settings in model.
	 * @param {Object} [opt] See `opt` of `setTextStyleCommon`.
	 * @param {boolean} [isEmphasis]
	 */
	
	
	function setTextStyle(textStyle, textStyleModel, specifiedTextStyle, opt, isEmphasis) {
	  setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis);
	  specifiedTextStyle && zrUtil.extend(textStyle, specifiedTextStyle); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	
	  return textStyle;
	}
	/**
	 * Set text option in the style.
	 * See more info in `setTextStyleCommon`.
	 * @deprecated
	 * @param {Object} textStyle
	 * @param {module:echarts/model/Model} labelModel
	 * @param {string|boolean} defaultColor Default text color.
	 *        If set as false, it will be processed as a emphasis style.
	 */
	
	
	function setText(textStyle, labelModel, defaultColor) {
	  var opt = {
	    isRectText: true
	  };
	  var isEmphasis;
	
	  if (defaultColor === false) {
	    isEmphasis = true;
	  } else {
	    // Support setting color as 'auto' to get visual color.
	    opt.autoColor = defaultColor;
	  }
	
	  setTextStyleCommon(textStyle, labelModel, opt, isEmphasis); // textStyle.host && textStyle.host.dirty && textStyle.host.dirty(false);
	}
	/**
	 * The uniform entry of set text style, that is, retrieve style definitions
	 * from `model` and set to `textStyle` object.
	 *
	 * Never in merge mode, but in overwrite mode, that is, all of the text style
	 * properties will be set. (Consider the states of normal and emphasis and
	 * default value can be adopted, merge would make the logic too complicated
	 * to manage.)
	 *
	 * The `textStyle` object can either be a plain object or an instance of
	 * `zrender/src/graphic/Style`, and either be the style of normal or emphasis.
	 * After this mothod called, the `textStyle` object can then be used in
	 * `el.setStyle(textStyle)` or `el.hoverStyle = textStyle`.
	 *
	 * Default value will be adopted and `insideRollbackOpt` will be created.
	 * See `applyDefaultTextStyle` `rollbackDefaultTextStyle` for more details.
	 *
	 * opt: {
	 *      disableBox: boolean, Whether diable drawing box of block (outer most).
	 *      isRectText: boolean,
	 *      autoColor: string, specify a color when color is 'auto',
	 *              for textFill, textStroke, textBackgroundColor, and textBorderColor.
	 *              If autoColor specified, it is used as default textFill.
	 *      useInsideStyle:
	 *              `true`: Use inside style (textFill, textStroke, textStrokeWidth)
	 *                  if `textFill` is not specified.
	 *              `false`: Do not use inside style.
	 *              `null/undefined`: use inside style if `isRectText` is true and
	 *                  `textFill` is not specified and textPosition contains `'inside'`.
	 *      forceRich: boolean
	 * }
	 */
	
	
	function setTextStyleCommon(textStyle, textStyleModel, opt, isEmphasis) {
	  // Consider there will be abnormal when merge hover style to normal style if given default value.
	  opt = opt || EMPTY_OBJ;
	
	  if (opt.isRectText) {
	    var textPosition;
	
	    if (opt.getTextPosition) {
	      textPosition = opt.getTextPosition(textStyleModel, isEmphasis);
	    } else {
	      textPosition = textStyleModel.getShallow('position') || (isEmphasis ? null : 'inside'); // 'outside' is not a valid zr textPostion value, but used
	      // in bar series, and magric type should be considered.
	
	      textPosition === 'outside' && (textPosition = 'top');
	    }
	
	    textStyle.textPosition = textPosition;
	    textStyle.textOffset = textStyleModel.getShallow('offset');
	    var labelRotate = textStyleModel.getShallow('rotate');
	    labelRotate != null && (labelRotate *= Math.PI / 180);
	    textStyle.textRotation = labelRotate;
	    textStyle.textDistance = zrUtil.retrieve2(textStyleModel.getShallow('distance'), isEmphasis ? null : 5);
	  }
	
	  var ecModel = textStyleModel.ecModel;
	  var globalTextStyle = ecModel && ecModel.option.textStyle; // Consider case:
	  // {
	  //     data: [{
	  //         value: 12,
	  //         label: {
	  //             rich: {
	  //                 // no 'a' here but using parent 'a'.
	  //             }
	  //         }
	  //     }],
	  //     rich: {
	  //         a: { ... }
	  //     }
	  // }
	
	  var richItemNames = getRichItemNames(textStyleModel);
	  var richResult;
	
	  if (richItemNames) {
	    richResult = {};
	
	    for (var name in richItemNames) {
	      if (richItemNames.hasOwnProperty(name)) {
	        // Cascade is supported in rich.
	        var richTextStyle = textStyleModel.getModel(['rich', name]); // In rich, never `disableBox`.
	        // FIXME: consider `label: {formatter: '{a|xx}', color: 'blue', rich: {a: {}}}`,
	        // the default color `'blue'` will not be adopted if no color declared in `rich`.
	        // That might confuses users. So probably we should put `textStyleModel` as the
	        // root ancestor of the `richTextStyle`. But that would be a break change.
	
	        setTokenTextStyle(richResult[name] = {}, richTextStyle, globalTextStyle, opt, isEmphasis);
	      }
	    }
	  }
	
	  textStyle.rich = richResult;
	  setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, true);
	
	  if (opt.forceRich && !opt.textStyle) {
	    opt.textStyle = {};
	  }
	
	  return textStyle;
	} // Consider case:
	// {
	//     data: [{
	//         value: 12,
	//         label: {
	//             rich: {
	//                 // no 'a' here but using parent 'a'.
	//             }
	//         }
	//     }],
	//     rich: {
	//         a: { ... }
	//     }
	// }
	
	
	function getRichItemNames(textStyleModel) {
	  // Use object to remove duplicated names.
	  var richItemNameMap;
	
	  while (textStyleModel && textStyleModel !== textStyleModel.ecModel) {
	    var rich = (textStyleModel.option || EMPTY_OBJ).rich;
	
	    if (rich) {
	      richItemNameMap = richItemNameMap || {};
	
	      for (var name in rich) {
	        if (rich.hasOwnProperty(name)) {
	          richItemNameMap[name] = 1;
	        }
	      }
	    }
	
	    textStyleModel = textStyleModel.parentModel;
	  }
	
	  return richItemNameMap;
	}
	
	function setTokenTextStyle(textStyle, textStyleModel, globalTextStyle, opt, isEmphasis, isBlock) {
	  // In merge mode, default value should not be given.
	  globalTextStyle = !isEmphasis && globalTextStyle || EMPTY_OBJ;
	  textStyle.textFill = getAutoColor(textStyleModel.getShallow('color'), opt) || globalTextStyle.color;
	  textStyle.textStroke = getAutoColor(textStyleModel.getShallow('textBorderColor'), opt) || globalTextStyle.textBorderColor;
	  textStyle.textStrokeWidth = zrUtil.retrieve2(textStyleModel.getShallow('textBorderWidth'), globalTextStyle.textBorderWidth);
	
	  if (!isEmphasis) {
	    if (isBlock) {
	      textStyle.insideRollbackOpt = opt;
	      applyDefaultTextStyle(textStyle);
	    } // Set default finally.
	
	
	    if (textStyle.textFill == null) {
	      textStyle.textFill = opt.autoColor;
	    }
	  } // Do not use `getFont` here, because merge should be supported, where
	  // part of these properties may be changed in emphasis style, and the
	  // others should remain their original value got from normal style.
	
	
	  textStyle.fontStyle = textStyleModel.getShallow('fontStyle') || globalTextStyle.fontStyle;
	  textStyle.fontWeight = textStyleModel.getShallow('fontWeight') || globalTextStyle.fontWeight;
	  textStyle.fontSize = textStyleModel.getShallow('fontSize') || globalTextStyle.fontSize;
	  textStyle.fontFamily = textStyleModel.getShallow('fontFamily') || globalTextStyle.fontFamily;
	  textStyle.textAlign = textStyleModel.getShallow('align');
	  textStyle.textVerticalAlign = textStyleModel.getShallow('verticalAlign') || textStyleModel.getShallow('baseline');
	  textStyle.textLineHeight = textStyleModel.getShallow('lineHeight');
	  textStyle.textWidth = textStyleModel.getShallow('width');
	  textStyle.textHeight = textStyleModel.getShallow('height');
	  textStyle.textTag = textStyleModel.getShallow('tag');
	
	  if (!isBlock || !opt.disableBox) {
	    textStyle.textBackgroundColor = getAutoColor(textStyleModel.getShallow('backgroundColor'), opt);
	    textStyle.textPadding = textStyleModel.getShallow('padding');
	    textStyle.textBorderColor = getAutoColor(textStyleModel.getShallow('borderColor'), opt);
	    textStyle.textBorderWidth = textStyleModel.getShallow('borderWidth');
	    textStyle.textBorderRadius = textStyleModel.getShallow('borderRadius');
	    textStyle.textBoxShadowColor = textStyleModel.getShallow('shadowColor');
	    textStyle.textBoxShadowBlur = textStyleModel.getShallow('shadowBlur');
	    textStyle.textBoxShadowOffsetX = textStyleModel.getShallow('shadowOffsetX');
	    textStyle.textBoxShadowOffsetY = textStyleModel.getShallow('shadowOffsetY');
	  }
	
	  textStyle.textShadowColor = textStyleModel.getShallow('textShadowColor') || globalTextStyle.textShadowColor;
	  textStyle.textShadowBlur = textStyleModel.getShallow('textShadowBlur') || globalTextStyle.textShadowBlur;
	  textStyle.textShadowOffsetX = textStyleModel.getShallow('textShadowOffsetX') || globalTextStyle.textShadowOffsetX;
	  textStyle.textShadowOffsetY = textStyleModel.getShallow('textShadowOffsetY') || globalTextStyle.textShadowOffsetY;
	}
	
	function getAutoColor(color, opt) {
	  return color !== 'auto' ? color : opt && opt.autoColor ? opt.autoColor : null;
	}
	/**
	 * Give some default value to the input `textStyle` object, based on the current settings
	 * in this `textStyle` object.
	 *
	 * The Scenario:
	 * when text position is `inside` and `textFill` is not specified, we show
	 * text border by default for better view. But it should be considered that text position
	 * might be changed when hovering or being emphasis, where the `insideRollback` is used to
	 * restore the style.
	 *
	 * Usage (& NOTICE):
	 * When a style object (eithor plain object or instance of `zrender/src/graphic/Style`) is
	 * about to be modified on its text related properties, `rollbackDefaultTextStyle` should
	 * be called before the modification and `applyDefaultTextStyle` should be called after that.
	 * (For the case that all of the text related properties is reset, like `setTextStyleCommon`
	 * does, `rollbackDefaultTextStyle` is not needed to be called).
	 */
	
	
	function applyDefaultTextStyle(textStyle) {
	  var textPosition = textStyle.textPosition;
	  var opt = textStyle.insideRollbackOpt;
	  var insideRollback;
	
	  if (opt && textStyle.textFill == null) {
	    var autoColor = opt.autoColor;
	    var isRectText = opt.isRectText;
	    var useInsideStyle = opt.useInsideStyle;
	    var useInsideStyleCache = useInsideStyle !== false && (useInsideStyle === true || isRectText && textPosition // textPosition can be [10, 30]
	    && typeof textPosition === 'string' && textPosition.indexOf('inside') >= 0);
	    var useAutoColorCache = !useInsideStyleCache && autoColor != null; // All of the props declared in `CACHED_LABEL_STYLE_PROPERTIES` are to be cached.
	
	    if (useInsideStyleCache || useAutoColorCache) {
	      insideRollback = {
	        textFill: textStyle.textFill,
	        textStroke: textStyle.textStroke,
	        textStrokeWidth: textStyle.textStrokeWidth
	      };
	    }
	
	    if (useInsideStyleCache) {
	      textStyle.textFill = '#fff'; // Consider text with #fff overflow its container.
	
	      if (textStyle.textStroke == null) {
	        textStyle.textStroke = autoColor;
	        textStyle.textStrokeWidth == null && (textStyle.textStrokeWidth = 2);
	      }
	    }
	
	    if (useAutoColorCache) {
	      textStyle.textFill = autoColor;
	    }
	  } // Always set `insideRollback`, so that the previous one can be cleared.
	
	
	  textStyle.insideRollback = insideRollback;
	}
	/**
	 * Consider the case: in a scatter,
	 * label: {
	 *     normal: {position: 'inside'},
	 *     emphasis: {position: 'top'}
	 * }
	 * In the normal state, the `textFill` will be set as '#fff' for pretty view (see
	 * `applyDefaultTextStyle`), but when switching to emphasis state, the `textFill`
	 * should be retured to 'autoColor', but not keep '#fff'.
	 */
	
	
	function rollbackDefaultTextStyle(style) {
	  var insideRollback = style.insideRollback;
	
	  if (insideRollback) {
	    // Reset all of the props in `CACHED_LABEL_STYLE_PROPERTIES`.
	    style.textFill = insideRollback.textFill;
	    style.textStroke = insideRollback.textStroke;
	    style.textStrokeWidth = insideRollback.textStrokeWidth;
	    style.insideRollback = null;
	  }
	}
	
	function getFont(opt, ecModel) {
	  var gTextStyleModel = ecModel && ecModel.getModel('textStyle');
	  return zrUtil.trim([// FIXME in node-canvas fontWeight is before fontStyle
	  opt.fontStyle || gTextStyleModel && gTextStyleModel.getShallow('fontStyle') || '', opt.fontWeight || gTextStyleModel && gTextStyleModel.getShallow('fontWeight') || '', (opt.fontSize || gTextStyleModel && gTextStyleModel.getShallow('fontSize') || 12) + 'px', opt.fontFamily || gTextStyleModel && gTextStyleModel.getShallow('fontFamily') || 'sans-serif'].join(' '));
	}
	
	function animateOrSetProps(isUpdate, el, props, animatableModel, dataIndex, cb) {
	  if (typeof dataIndex === 'function') {
	    cb = dataIndex;
	    dataIndex = null;
	  } // Do not check 'animation' property directly here. Consider this case:
	  // animation model is an `itemModel`, whose does not have `isAnimationEnabled`
	  // but its parent model (`seriesModel`) does.
	
	
	  var animationEnabled = animatableModel && animatableModel.isAnimationEnabled();
	
	  if (animationEnabled) {
	    var postfix = isUpdate ? 'Update' : '';
	    var duration = animatableModel.getShallow('animationDuration' + postfix);
	    var animationEasing = animatableModel.getShallow('animationEasing' + postfix);
	    var animationDelay = animatableModel.getShallow('animationDelay' + postfix);
	
	    if (typeof animationDelay === 'function') {
	      animationDelay = animationDelay(dataIndex, animatableModel.getAnimationDelayParams ? animatableModel.getAnimationDelayParams(el, dataIndex) : null);
	    }
	
	    if (typeof duration === 'function') {
	      duration = duration(dataIndex);
	    }
	
	    duration > 0 ? el.animateTo(props, duration, animationDelay || 0, animationEasing, cb, !!cb) : (el.stopAnimation(), el.attr(props), cb && cb());
	  } else {
	    el.stopAnimation();
	    el.attr(props);
	    cb && cb();
	  }
	}
	/**
	 * Update graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} [cb]
	 * @example
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, dataIndex, function () { console.log('Animation done!'); });
	 *     // Or
	 *     graphic.updateProps(el, {
	 *         position: [100, 100]
	 *     }, seriesModel, function () { console.log('Animation done!'); });
	 */
	
	
	function updateProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(true, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Init graphic element properties with or without animation according to the
	 * configuration in series.
	 *
	 * Caution: this method will stop previous animation.
	 * So do not use this method to one element twice before
	 * animation starts, unless you know what you are doing.
	 *
	 * @param {module:zrender/Element} el
	 * @param {Object} props
	 * @param {module:echarts/model/Model} [animatableModel]
	 * @param {number} [dataIndex]
	 * @param {Function} cb
	 */
	
	
	function initProps(el, props, animatableModel, dataIndex, cb) {
	  animateOrSetProps(false, el, props, animatableModel, dataIndex, cb);
	}
	/**
	 * Get transform matrix of target (param target),
	 * in coordinate of its ancestor (param ancestor)
	 *
	 * @param {module:zrender/mixin/Transformable} target
	 * @param {module:zrender/mixin/Transformable} [ancestor]
	 */
	
	
	function getTransform(target, ancestor) {
	  var mat = matrix.identity([]);
	
	  while (target && target !== ancestor) {
	    matrix.mul(mat, target.getLocalTransform(), mat);
	    target = target.parent;
	  }
	
	  return mat;
	}
	/**
	 * Apply transform to an vertex.
	 * @param {Array.<number>} target [x, y]
	 * @param {Array.<number>|TypedArray.<number>|Object} transform Can be:
	 *      + Transform matrix: like [1, 0, 0, 1, 0, 0]
	 *      + {position, rotation, scale}, the same as `zrender/Transformable`.
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {Array.<number>} [x, y]
	 */
	
	
	function applyTransform(target, transform, invert) {
	  if (transform && !zrUtil.isArrayLike(transform)) {
	    transform = Transformable.getLocalTransform(transform);
	  }
	
	  if (invert) {
	    transform = matrix.invert([], transform);
	  }
	
	  return vector.applyTransform([], target, transform);
	}
	/**
	 * @param {string} direction 'left' 'right' 'top' 'bottom'
	 * @param {Array.<number>} transform Transform matrix: like [1, 0, 0, 1, 0, 0]
	 * @param {boolean=} invert Whether use invert matrix.
	 * @return {string} Transformed direction. 'left' 'right' 'top' 'bottom'
	 */
	
	
	function transformDirection(direction, transform, invert) {
	  // Pick a base, ensure that transform result will not be (0, 0).
	  var hBase = transform[4] === 0 || transform[5] === 0 || transform[0] === 0 ? 1 : Math.abs(2 * transform[4] / transform[0]);
	  var vBase = transform[4] === 0 || transform[5] === 0 || transform[2] === 0 ? 1 : Math.abs(2 * transform[4] / transform[2]);
	  var vertex = [direction === 'left' ? -hBase : direction === 'right' ? hBase : 0, direction === 'top' ? -vBase : direction === 'bottom' ? vBase : 0];
	  vertex = applyTransform(vertex, transform, invert);
	  return Math.abs(vertex[0]) > Math.abs(vertex[1]) ? vertex[0] > 0 ? 'right' : 'left' : vertex[1] > 0 ? 'bottom' : 'top';
	}
	/**
	 * Apply group transition animation from g1 to g2.
	 * If no animatableModel, no animation.
	 */
	
	
	function groupTransition(g1, g2, animatableModel, cb) {
	  if (!g1 || !g2) {
	    return;
	  }
	
	  function getElMap(g) {
	    var elMap = {};
	    g.traverse(function (el) {
	      if (!el.isGroup && el.anid) {
	        elMap[el.anid] = el;
	      }
	    });
	    return elMap;
	  }
	
	  function getAnimatableProps(el) {
	    var obj = {
	      position: vector.clone(el.position),
	      rotation: el.rotation
	    };
	
	    if (el.shape) {
	      obj.shape = zrUtil.extend({}, el.shape);
	    }
	
	    return obj;
	  }
	
	  var elMap1 = getElMap(g1);
	  g2.traverse(function (el) {
	    if (!el.isGroup && el.anid) {
	      var oldEl = elMap1[el.anid];
	
	      if (oldEl) {
	        var newProp = getAnimatableProps(el);
	        el.attr(getAnimatableProps(oldEl));
	        updateProps(el, newProp, animatableModel, el.dataIndex);
	      } // else {
	      //     if (el.previousProps) {
	      //         graphic.updateProps
	      //     }
	      // }
	
	    }
	  });
	}
	/**
	 * @param {Array.<Array.<number>>} points Like: [[23, 44], [53, 66], ...]
	 * @param {Object} rect {x, y, width, height}
	 * @return {Array.<Array.<number>>} A new clipped points.
	 */
	
	
	function clipPointsByRect(points, rect) {
	  // FIXME: this way migth be incorrect when grpahic clipped by a corner.
	  // and when element have border.
	  return zrUtil.map(points, function (point) {
	    var x = point[0];
	    x = mathMax(x, rect.x);
	    x = mathMin(x, rect.x + rect.width);
	    var y = point[1];
	    y = mathMax(y, rect.y);
	    y = mathMin(y, rect.y + rect.height);
	    return [x, y];
	  });
	}
	/**
	 * @param {Object} targetRect {x, y, width, height}
	 * @param {Object} rect {x, y, width, height}
	 * @return {Object} A new clipped rect. If rect size are negative, return undefined.
	 */
	
	
	function clipRectByRect(targetRect, rect) {
	  var x = mathMax(targetRect.x, rect.x);
	  var x2 = mathMin(targetRect.x + targetRect.width, rect.x + rect.width);
	  var y = mathMax(targetRect.y, rect.y);
	  var y2 = mathMin(targetRect.y + targetRect.height, rect.y + rect.height); // If the total rect is cliped, nothing, including the border,
	  // should be painted. So return undefined.
	
	  if (x2 >= x && y2 >= y) {
	    return {
	      x: x,
	      y: y,
	      width: x2 - x,
	      height: y2 - y
	    };
	  }
	}
	/**
	 * @param {string} iconStr Support 'image://' or 'path://' or direct svg path.
	 * @param {Object} [opt] Properties of `module:zrender/Element`, except `style`.
	 * @param {Object} [rect] {x, y, width, height}
	 * @return {module:zrender/Element} Icon path or image element.
	 */
	
	
	function createIcon(iconStr, opt, rect) {
	  opt = zrUtil.extend({
	    rectHover: true
	  }, opt);
	  var style = opt.style = {
	    strokeNoScale: true
	  };
	  rect = rect || {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  };
	
	  if (iconStr) {
	    return iconStr.indexOf('image://') === 0 ? (style.image = iconStr.slice(8), zrUtil.defaults(style, rect), new ZImage(opt)) : makePath(iconStr.replace('path://', ''), opt, rect, 'center');
	  }
	}
	/**
	 * Return `true` if the given line (line `a`) and the given polygon
	 * are intersect.
	 * Note that we do not count colinear as intersect here because no
	 * requirement for that. We could do that if required in future.
	 *
	 * @param {number} a1x
	 * @param {number} a1y
	 * @param {number} a2x
	 * @param {number} a2y
	 * @param {Array.<Array.<number>>} points Points of the polygon.
	 * @return {boolean}
	 */
	
	
	function linePolygonIntersect(a1x, a1y, a2x, a2y, points) {
	  for (var i = 0, p2 = points[points.length - 1]; i < points.length; i++) {
	    var p = points[i];
	
	    if (lineLineIntersect(a1x, a1y, a2x, a2y, p[0], p[1], p2[0], p2[1])) {
	      return true;
	    }
	
	    p2 = p;
	  }
	}
	/**
	 * Return `true` if the given two lines (line `a` and line `b`)
	 * are intersect.
	 * Note that we do not count colinear as intersect here because no
	 * requirement for that. We could do that if required in future.
	 *
	 * @param {number} a1x
	 * @param {number} a1y
	 * @param {number} a2x
	 * @param {number} a2y
	 * @param {number} b1x
	 * @param {number} b1y
	 * @param {number} b2x
	 * @param {number} b2y
	 * @return {boolean}
	 */
	
	
	function lineLineIntersect(a1x, a1y, a2x, a2y, b1x, b1y, b2x, b2y) {
	  // let `vec_m` to be `vec_a2 - vec_a1` and `vec_n` to be `vec_b2 - vec_b1`.
	  var mx = a2x - a1x;
	  var my = a2y - a1y;
	  var nx = b2x - b1x;
	  var ny = b2y - b1y; // `vec_m` and `vec_n` are parallel iff
	  //     exising `k` such that `vec_m = k · vec_n`, equivalent to `vec_m X vec_n = 0`.
	
	  var nmCrossProduct = crossProduct2d(nx, ny, mx, my);
	
	  if (nearZero(nmCrossProduct)) {
	    return false;
	  } // `vec_m` and `vec_n` are intersect iff
	  //     existing `p` and `q` in [0, 1] such that `vec_a1 + p * vec_m = vec_b1 + q * vec_n`,
	  //     such that `q = ((vec_a1 - vec_b1) X vec_m) / (vec_n X vec_m)`
	  //           and `p = ((vec_a1 - vec_b1) X vec_n) / (vec_n X vec_m)`.
	
	
	  var b1a1x = a1x - b1x;
	  var b1a1y = a1y - b1y;
	  var q = crossProduct2d(b1a1x, b1a1y, mx, my) / nmCrossProduct;
	
	  if (q < 0 || q > 1) {
	    return false;
	  }
	
	  var p = crossProduct2d(b1a1x, b1a1y, nx, ny) / nmCrossProduct;
	
	  if (p < 0 || p > 1) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Cross product of 2-dimension vector.
	 */
	
	
	function crossProduct2d(x1, y1, x2, y2) {
	  return x1 * y2 - x2 * y1;
	}
	
	function nearZero(val) {
	  return val <= 1e-6 && val >= -1e-6;
	} // Register built-in shapes. These shapes might be overwirtten
	// by users, although we do not recommend that.
	
	
	registerShape('circle', Circle);
	registerShape('sector', Sector);
	registerShape('ring', Ring);
	registerShape('polygon', Polygon);
	registerShape('polyline', Polyline);
	registerShape('rect', Rect);
	registerShape('line', Line);
	registerShape('bezierCurve', BezierCurve);
	registerShape('arc', Arc);
	exports.Z2_EMPHASIS_LIFT = Z2_EMPHASIS_LIFT;
	exports.CACHED_LABEL_STYLE_PROPERTIES = CACHED_LABEL_STYLE_PROPERTIES;
	exports.extendShape = extendShape;
	exports.extendPath = extendPath;
	exports.registerShape = registerShape;
	exports.getShapeClass = getShapeClass;
	exports.makePath = makePath;
	exports.makeImage = makeImage;
	exports.mergePath = mergePath;
	exports.resizePath = resizePath;
	exports.subPixelOptimizeLine = subPixelOptimizeLine;
	exports.subPixelOptimizeRect = subPixelOptimizeRect;
	exports.subPixelOptimize = subPixelOptimize;
	exports.setElementHoverStyle = setElementHoverStyle;
	exports.setHoverStyle = setHoverStyle;
	exports.setAsHighDownDispatcher = setAsHighDownDispatcher;
	exports.isHighDownDispatcher = isHighDownDispatcher;
	exports.getHighlightDigit = getHighlightDigit;
	exports.setLabelStyle = setLabelStyle;
	exports.modifyLabelStyle = modifyLabelStyle;
	exports.setTextStyle = setTextStyle;
	exports.setText = setText;
	exports.getFont = getFont;
	exports.updateProps = updateProps;
	exports.initProps = initProps;
	exports.getTransform = getTransform;
	exports.applyTransform = applyTransform;
	exports.transformDirection = transformDirection;
	exports.groupTransition = groupTransition;
	exports.clipPointsByRect = clipPointsByRect;
	exports.clipRectByRect = clipRectByRect;
	exports.createIcon = createIcon;
	exports.linePolygonIntersect = linePolygonIntersect;
	exports.lineLineIntersect = lineLineIntersect;

/***/ },
/* 15 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	function componentWillMount() {
	  // Call this.constructor.gDSFP to support sub-classes.
	  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
	  if (state !== null && state !== undefined) {
	    this.setState(state);
	  }
	}
	
	function componentWillReceiveProps(nextProps) {
	  // Call this.constructor.gDSFP to support sub-classes.
	  // Use the setState() updater to ensure state isn't stale in certain edge cases.
	  function updater(prevState) {
	    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
	    return state !== null && state !== undefined ? state : null;
	  }
	  // Binding "this" is important for shallow renderer support.
	  this.setState(updater.bind(this));
	}
	
	function componentWillUpdate(nextProps, nextState) {
	  try {
	    var prevProps = this.props;
	    var prevState = this.state;
	    this.props = nextProps;
	    this.state = nextState;
	    this.__reactInternalSnapshotFlag = true;
	    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
	      prevProps,
	      prevState
	    );
	  } finally {
	    this.props = prevProps;
	    this.state = prevState;
	  }
	}
	
	// React may warn about cWM/cWRP/cWU methods being deprecated.
	// Add a flag to suppress these warnings for this special case.
	componentWillMount.__suppressDeprecationWarning = true;
	componentWillReceiveProps.__suppressDeprecationWarning = true;
	componentWillUpdate.__suppressDeprecationWarning = true;
	
	function polyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  }
	
	  if (
	    typeof Component.getDerivedStateFromProps !== 'function' &&
	    typeof prototype.getSnapshotBeforeUpdate !== 'function'
	  ) {
	    return Component;
	  }
	
	  // If new component APIs are defined, "unsafe" lifecycles won't be called.
	  // Error if any of these lifecycles are present,
	  // Because they would work differently between older and newer (16.3+) versions of React.
	  var foundWillMountName = null;
	  var foundWillReceivePropsName = null;
	  var foundWillUpdateName = null;
	  if (typeof prototype.componentWillMount === 'function') {
	    foundWillMountName = 'componentWillMount';
	  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
	    foundWillMountName = 'UNSAFE_componentWillMount';
	  }
	  if (typeof prototype.componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'componentWillReceiveProps';
	  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
	    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
	  }
	  if (typeof prototype.componentWillUpdate === 'function') {
	    foundWillUpdateName = 'componentWillUpdate';
	  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
	    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
	  }
	  if (
	    foundWillMountName !== null ||
	    foundWillReceivePropsName !== null ||
	    foundWillUpdateName !== null
	  ) {
	    var componentName = Component.displayName || Component.name;
	    var newApiName =
	      typeof Component.getDerivedStateFromProps === 'function'
	        ? 'getDerivedStateFromProps()'
	        : 'getSnapshotBeforeUpdate()';
	
	    throw Error(
	      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
	        componentName +
	        ' uses ' +
	        newApiName +
	        ' but also contains the following legacy lifecycles:' +
	        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
	        (foundWillReceivePropsName !== null
	          ? '\n  ' + foundWillReceivePropsName
	          : '') +
	        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
	        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
	        'https://fb.me/react-async-component-lifecycle-hooks'
	    );
	  }
	
	  // React <= 16.2 does not support static getDerivedStateFromProps.
	  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
	  // Newer versions of React will ignore these lifecycles if gDSFP exists.
	  if (typeof Component.getDerivedStateFromProps === 'function') {
	    prototype.componentWillMount = componentWillMount;
	    prototype.componentWillReceiveProps = componentWillReceiveProps;
	  }
	
	  // React <= 16.2 does not support getSnapshotBeforeUpdate.
	  // As a workaround, use cWU to invoke the new lifecycle.
	  // Newer versions of React will ignore that lifecycle if gSBU exists.
	  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
	    if (typeof prototype.componentDidUpdate !== 'function') {
	      throw new Error(
	        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
	      );
	    }
	
	    prototype.componentWillUpdate = componentWillUpdate;
	
	    var componentDidUpdate = prototype.componentDidUpdate;
	
	    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
	      prevProps,
	      prevState,
	      maybeSnapshot
	    ) {
	      // 16.3+ will not execute our will-update method;
	      // It will pass a snapshot value to did-update though.
	      // Older versions will require our polyfilled will-update value.
	      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
	      // Because for <= 15.x versions this might be a "prevContext" object.
	      // We also can't just check "__reactInternalSnapshot",
	      // Because get-snapshot might return a falsy value.
	      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
	      var snapshot = this.__reactInternalSnapshotFlag
	        ? this.__reactInternalSnapshot
	        : maybeSnapshot;
	
	      componentDidUpdate.call(this, prevProps, prevState, snapshot);
	    };
	  }
	
	  return Component;
	}
	
	exports.polyfill = polyfill;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(1834);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(1831);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(330);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(330);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 19 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setBackInfo = setBackInfo;
	exports.backInfo = backInfo;
	// 按模块的action, reducer整合体
	var BACK_INFO = 'BACK_INFO';
	
	function setBackInfo(params) {
	  return function (dispatch) {
	    return dispatch({
	      type: BACK_INFO,
	      data: params
	    });
	  };
	}
	
	function backInfo() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case BACK_INFO:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2018 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames() {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					if (arg.length) {
						var inner = classNames.apply(null, arg);
						if (inner) {
							classes.push(inner);
						}
					}
				} else if (argType === 'object') {
					if (arg.toString === Object.prototype.toString) {
						for (var key in arg) {
							if (hasOwn.call(arg, key) && arg[key]) {
								classes.push(key);
							}
						}
					} else {
						classes.push(arg.toString());
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(1830);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 22 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * utils
	 */
	
	var utils = {
	  /**
	   * 获取页面宽度
	   * @return {[type]} [description]
	   */
	  pageWidth: function pageWidth() {
	    return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	  },
	
	
	  /**
	   * 获取页面高度
	   * @return {[type]} [description]
	   */
	  pageHeight: function pageHeight() {
	    return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	  },
	
	
	  /**
	   * 格式化Table数据，行合并
	   * @param {*} data
	   * @param {*} key
	   */
	  formatTableData: function formatTableData(data, key) {
	    var groupData = [];
	    var rankData = [];
	    data.forEach(function (item) {
	      if (groupData[item[key]]) {
	        groupData[item[key]].push(item);
	      } else {
	        groupData[item[key]] = [item];
	      }
	    });
	    groupData.map(function (item) {
	      var rankItem = item || [];
	      item.forEach(function (item2, index) {
	        if (index === 0) {
	          item2.rowSpan = item.length;
	        } else {
	          item2.rowSpan = 0;
	        }
	        return item2;
	      });
	      rankData = rankData.concat(rankItem);
	
	      return item;
	    });
	    return rankData;
	  },
	
	  /**
	   * 根据参数名获取URL数据
	   * @param  {[type]} name [description]
	   * @param  {[type]} url  [description]
	   * @return {[type]}      [description]
	   */
	  getParameterByName: function getParameterByName(name, url) {
	    if (!url) url = window.location.href;
	    name = name.replace(/[[\]]/g, '\\$&');
	    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
	    var results = regex.exec(url);
	    if (!results) return null;
	    if (!results[2]) return '';
	    return decodeURIComponent(results[2].replace(/\+/g, ' '));
	  },
	
	
	  /**
	   * 获取图片的Base64格式
	   * @param  {[type]}   img      [description]
	   * @param  {Function} callback [description]
	   * @return {[type]}            [description]
	   */
	  getBase64: function getBase64(img, callback) {
	    var reader = new FileReader();
	    reader.addEventListener('load', function () {
	      return callback(reader.result);
	    });
	    reader.readAsDataURL(img);
	  },
	
	
	  /**
	   * 百分比转换
	   * @param  {[type]} num       [description]
	   * @param  {[type]} precision [description]
	   * @return {[type]}           [description]
	   */
	  percent: function percent(num, precision) {
	    if (!num || num === Infinity) return 0 + '%';
	    if (num > 1) num = 1;
	    precision = precision || 2;
	    precision = Math.pow(10, precision);
	    return Math.round(num * precision * 100) / precision + '%';
	  },
	
	
	  /**
	   * 格式化数字，格式化金额
	   * number：要格式化的数字
	   * decimals：保留几位小数
	   * decPoint：小数点符号
	   * thousandsSep：千分位符号
	   */
	  numberFormat: function numberFormat(number) {
	    var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2;
	    var decPoint = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '.';
	    var thousandsSep = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ',';
	
	    number = ('' + number).replace(/[^\d+-Ee]/g, '');
	    var n = !isFinite(+number) ? 0 : +number;
	    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals);
	    var sep = typeof thousandsSep === 'undefined' ? ',' : thousandsSep;
	    var dec = typeof decPoint === 'undefined' ? '.' : decPoint;
	    var s = '';
	    var toFixedFix = function toFixedFix(num, pre) {
	      var k = Math.pow(10, pre);
	      var k2 = '' + num * k;
	      if (num * k > 0) {
	        if (k2.indexOf('.') > 0) {
	          if (k2[k2.indexOf('.') + 1] >= 5) {
	            return '' + Math.ceil(num * k) / k;
	          }
	          return '' + Math.floor(num * k) / k;
	        }
	        return '' + Math.ceil(num * k) / k;
	      }
	      if (k2.indexOf('.') > 0) {
	        if (k2[k2.indexOf('.') + 1] >= 5) {
	          return '' + Math.floor(num * k) / k;
	        }
	        return '' + Math.ceil(num * k) / k;
	      }
	      return '' + Math.ceil(num * k) / k;
	    };
	    s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
	    var re = /(-?\d+)(\d{3})/;
	    while (re.test(s[0])) {
	      s[0] = s[0].replace(re, '$1' + sep + '$2');
	    }
	
	    // 追加小数点后0
	    if ((s[1] || '').length < prec) {
	      s[1] = s[1] || '';
	      s[1] += new Array(prec - s[1].length + 1).join('0');
	    }
	    return s.join(dec);
	  },
	  formatUrl: function formatUrl(api) {
	    var _document = document,
	        domain = _document.domain;
	
	    if (domain.indexOf('localhost') >= 0) {
	      domain = 'demo.oa.ychcapital.com';
	    }
	    return 'http://' + domain + api;
	  },
	  build: function build(url, params) {
	    // URL构建方法
	    var ps = [];
	    if (params) {
	      Object.keys(params).forEach(function (p) {
	        if (p) {
	          ps.push(p + '=' + encodeURIComponent(params[p]));
	        }
	      });
	    }
	    return url + (url.indexOf('?') === -1 ? '?' : '&') + ps.join('&');
	  }
	};
	
	exports.default = utils;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2794);


/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var allIcons = _interopRequireWildcard(__webpack_require__(1217));
	
	var _iconsReact = _interopRequireDefault(__webpack_require__(651));
	
	var _IconFont = _interopRequireDefault(__webpack_require__(1273));
	
	var _utils = __webpack_require__(1275);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _twoTonePrimaryColor = __webpack_require__(1274);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable camelcase */
	
	
	// Initial setting
	_iconsReact["default"].add.apply(_iconsReact["default"], _toConsumableArray(Object.keys(allIcons).map(function (key) {
	  return allIcons[key];
	})));
	
	(0, _twoTonePrimaryColor.setTwoToneColor)('#1890ff');
	var defaultTheme = 'outlined';
	var dangerousTheme;
	
	function unstable_ChangeThemeOfIconsDangerously(theme) {
	  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeThemeOfAllIconsDangerously', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
	  dangerousTheme = theme;
	}
	
	function unstable_ChangeDefaultThemeOfIcons(theme) {
	  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeDefaultThemeOfIcons', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
	  defaultTheme = theme;
	}
	
	var Icon = function Icon(props) {
	  var _classNames;
	
	  var className = props.className,
	      type = props.type,
	      Component = props.component,
	      viewBox = props.viewBox,
	      spin = props.spin,
	      rotate = props.rotate,
	      tabIndex = props.tabIndex,
	      onClick = props.onClick,
	      children = props.children,
	      theme = props.theme,
	      twoToneColor = props.twoToneColor,
	      restProps = __rest(props, ["className", "type", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children", "theme", "twoToneColor"]);
	
	  (0, _warning["default"])(Boolean(type || Component || children), 'Icon', 'Should have `type` prop or `component` prop or `children`.');
	  var classString = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "anticon", true), _defineProperty(_classNames, "anticon-".concat(type), Boolean(type)), _classNames), className);
	  var svgClassString = (0, _classnames["default"])(_defineProperty({}, "anticon-spin", !!spin || type === 'loading'));
	  var svgStyle = rotate ? {
	    msTransform: "rotate(".concat(rotate, "deg)"),
	    transform: "rotate(".concat(rotate, "deg)")
	  } : undefined;
	
	  var innerSvgProps = _extends(_extends({}, _utils.svgBaseProps), {
	    className: svgClassString,
	    style: svgStyle,
	    viewBox: viewBox
	  });
	
	  if (!viewBox) {
	    delete innerSvgProps.viewBox;
	  }
	
	  var renderInnerNode = function renderInnerNode() {
	    // component > children > type
	    if (Component) {
	      return /*#__PURE__*/React.createElement(Component, innerSvgProps, children);
	    }
	
	    if (children) {
	      (0, _warning["default"])(Boolean(viewBox) || React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children) && React.Children.only(children).type === 'use', 'Icon', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
	      return /*#__PURE__*/React.createElement("svg", _extends({}, innerSvgProps, {
	        viewBox: viewBox
	      }), children);
	    }
	
	    if (typeof type === 'string') {
	      var computedType = type;
	
	      if (theme) {
	        var themeInName = (0, _utils.getThemeFromTypeName)(type);
	        (0, _warning["default"])(!themeInName || theme === themeInName, 'Icon', "The icon name '".concat(type, "' already specify a theme '").concat(themeInName, "',") + " the 'theme' prop '".concat(theme, "' will be ignored."));
	      }
	
	      computedType = (0, _utils.withThemeSuffix)((0, _utils.removeTypeTheme)((0, _utils.alias)(computedType)), dangerousTheme || theme || defaultTheme);
	      return /*#__PURE__*/React.createElement(_iconsReact["default"], {
	        className: svgClassString,
	        type: computedType,
	        primaryColor: twoToneColor,
	        style: svgStyle
	      });
	    }
	  };
	
	  var iconTabIndex = tabIndex;
	
	  if (iconTabIndex === undefined && onClick) {
	    iconTabIndex = -1;
	  }
	
	  return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	    componentName: "Icon"
	  }, function (locale) {
	    return /*#__PURE__*/React.createElement("i", _extends({
	      "aria-label": type && "".concat(locale.icon, ": ").concat(type)
	    }, restProps, {
	      tabIndex: iconTabIndex,
	      onClick: onClick,
	      className: classString
	    }), renderInnerNode());
	  });
	};
	
	Icon.createFromIconfontCN = _IconFont["default"];
	Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
	Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
	var _default = Icon;
	exports["default"] = _default;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The method "quantile" was copied from "d3.js".
	* (See more details in the comment of the method below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var RADIAN_EPSILON = 1e-4;
	
	function _trim(str) {
	  return str.replace(/^\s+|\s+$/g, '');
	}
	/**
	 * Linear mapping a value from domain to range
	 * @memberOf module:echarts/util/number
	 * @param  {(number|Array.<number>)} val
	 * @param  {Array.<number>} domain Domain extent domain[0] can be bigger than domain[1]
	 * @param  {Array.<number>} range  Range extent range[0] can be bigger than range[1]
	 * @param  {boolean} clamp
	 * @return {(number|Array.<number>}
	 */
	
	
	function linearMap(val, domain, range, clamp) {
	  var subDomain = domain[1] - domain[0];
	  var subRange = range[1] - range[0];
	
	  if (subDomain === 0) {
	    return subRange === 0 ? range[0] : (range[0] + range[1]) / 2;
	  } // Avoid accuracy problem in edge, such as
	  // 146.39 - 62.83 === 83.55999999999999.
	  // See echarts/test/ut/spec/util/number.js#linearMap#accuracyError
	  // It is a little verbose for efficiency considering this method
	  // is a hotspot.
	
	
	  if (clamp) {
	    if (subDomain > 0) {
	      if (val <= domain[0]) {
	        return range[0];
	      } else if (val >= domain[1]) {
	        return range[1];
	      }
	    } else {
	      if (val >= domain[0]) {
	        return range[0];
	      } else if (val <= domain[1]) {
	        return range[1];
	      }
	    }
	  } else {
	    if (val === domain[0]) {
	      return range[0];
	    }
	
	    if (val === domain[1]) {
	      return range[1];
	    }
	  }
	
	  return (val - domain[0]) / subDomain * subRange + range[0];
	}
	/**
	 * Convert a percent string to absolute number.
	 * Returns NaN if percent is not a valid string or number
	 * @memberOf module:echarts/util/number
	 * @param {string|number} percent
	 * @param {number} all
	 * @return {number}
	 */
	
	
	function parsePercent(percent, all) {
	  switch (percent) {
	    case 'center':
	    case 'middle':
	      percent = '50%';
	      break;
	
	    case 'left':
	    case 'top':
	      percent = '0%';
	      break;
	
	    case 'right':
	    case 'bottom':
	      percent = '100%';
	      break;
	  }
	
	  if (typeof percent === 'string') {
	    if (_trim(percent).match(/%$/)) {
	      return parseFloat(percent) / 100 * all;
	    }
	
	    return parseFloat(percent);
	  }
	
	  return percent == null ? NaN : +percent;
	}
	/**
	 * (1) Fix rounding error of float numbers.
	 * (2) Support return string to avoid scientific notation like '3.5e-7'.
	 *
	 * @param {number} x
	 * @param {number} [precision]
	 * @param {boolean} [returnStr]
	 * @return {number|string}
	 */
	
	
	function round(x, precision, returnStr) {
	  if (precision == null) {
	    precision = 10;
	  } // Avoid range error
	
	
	  precision = Math.min(Math.max(0, precision), 20);
	  x = (+x).toFixed(precision);
	  return returnStr ? x : +x;
	}
	/**
	 * asc sort arr.
	 * The input arr will be modified.
	 *
	 * @param {Array} arr
	 * @return {Array} The input arr.
	 */
	
	
	function asc(arr) {
	  arr.sort(function (a, b) {
	    return a - b;
	  });
	  return arr;
	}
	/**
	 * Get precision
	 * @param {number} val
	 */
	
	
	function getPrecision(val) {
	  val = +val;
	
	  if (isNaN(val)) {
	    return 0;
	  } // It is much faster than methods converting number to string as follows
	  //      var tmp = val.toString();
	  //      return tmp.length - 1 - tmp.indexOf('.');
	  // especially when precision is low
	
	
	  var e = 1;
	  var count = 0;
	
	  while (Math.round(val * e) / e !== val) {
	    e *= 10;
	    count++;
	  }
	
	  return count;
	}
	/**
	 * @param {string|number} val
	 * @return {number}
	 */
	
	
	function getPrecisionSafe(val) {
	  var str = val.toString(); // Consider scientific notation: '3.4e-12' '3.4e+12'
	
	  var eIndex = str.indexOf('e');
	
	  if (eIndex > 0) {
	    var precision = +str.slice(eIndex + 1);
	    return precision < 0 ? -precision : 0;
	  } else {
	    var dotIndex = str.indexOf('.');
	    return dotIndex < 0 ? 0 : str.length - 1 - dotIndex;
	  }
	}
	/**
	 * Minimal dicernible data precisioin according to a single pixel.
	 *
	 * @param {Array.<number>} dataExtent
	 * @param {Array.<number>} pixelExtent
	 * @return {number} precision
	 */
	
	
	function getPixelPrecision(dataExtent, pixelExtent) {
	  var log = Math.log;
	  var LN10 = Math.LN10;
	  var dataQuantity = Math.floor(log(dataExtent[1] - dataExtent[0]) / LN10);
	  var sizeQuantity = Math.round(log(Math.abs(pixelExtent[1] - pixelExtent[0])) / LN10); // toFixed() digits argument must be between 0 and 20.
	
	  var precision = Math.min(Math.max(-dataQuantity + sizeQuantity, 0), 20);
	  return !isFinite(precision) ? 20 : precision;
	}
	/**
	 * Get a data of given precision, assuring the sum of percentages
	 * in valueList is 1.
	 * The largest remainer method is used.
	 * https://en.wikipedia.org/wiki/Largest_remainder_method
	 *
	 * @param {Array.<number>} valueList a list of all data
	 * @param {number} idx index of the data to be processed in valueList
	 * @param {number} precision integer number showing digits of precision
	 * @return {number} percent ranging from 0 to 100
	 */
	
	
	function getPercentWithPrecision(valueList, idx, precision) {
	  if (!valueList[idx]) {
	    return 0;
	  }
	
	  var sum = zrUtil.reduce(valueList, function (acc, val) {
	    return acc + (isNaN(val) ? 0 : val);
	  }, 0);
	
	  if (sum === 0) {
	    return 0;
	  }
	
	  var digits = Math.pow(10, precision);
	  var votesPerQuota = zrUtil.map(valueList, function (val) {
	    return (isNaN(val) ? 0 : val) / sum * digits * 100;
	  });
	  var targetSeats = digits * 100;
	  var seats = zrUtil.map(votesPerQuota, function (votes) {
	    // Assign automatic seats.
	    return Math.floor(votes);
	  });
	  var currentSum = zrUtil.reduce(seats, function (acc, val) {
	    return acc + val;
	  }, 0);
	  var remainder = zrUtil.map(votesPerQuota, function (votes, idx) {
	    return votes - seats[idx];
	  }); // Has remainding votes.
	
	  while (currentSum < targetSeats) {
	    // Find next largest remainder.
	    var max = Number.NEGATIVE_INFINITY;
	    var maxId = null;
	
	    for (var i = 0, len = remainder.length; i < len; ++i) {
	      if (remainder[i] > max) {
	        max = remainder[i];
	        maxId = i;
	      }
	    } // Add a vote to max remainder.
	
	
	    ++seats[maxId];
	    remainder[maxId] = 0;
	    ++currentSum;
	  }
	
	  return seats[idx] / digits;
	} // Number.MAX_SAFE_INTEGER, ie do not support.
	
	
	var MAX_SAFE_INTEGER = 9007199254740991;
	/**
	 * To 0 - 2 * PI, considering negative radian.
	 * @param {number} radian
	 * @return {number}
	 */
	
	function remRadian(radian) {
	  var pi2 = Math.PI * 2;
	  return (radian % pi2 + pi2) % pi2;
	}
	/**
	 * @param {type} radian
	 * @return {boolean}
	 */
	
	
	function isRadianAroundZero(val) {
	  return val > -RADIAN_EPSILON && val < RADIAN_EPSILON;
	}
	/* eslint-disable */
	
	
	var TIME_REG = /^(?:(\d{4})(?:[-\/](\d{1,2})(?:[-\/](\d{1,2})(?:[T ](\d{1,2})(?::(\d\d)(?::(\d\d)(?:[.,](\d+))?)?)?(Z|[\+\-]\d\d:?\d\d)?)?)?)?)?$/; // jshint ignore:line
	
	/* eslint-enable */
	
	/**
	 * @param {string|Date|number} value These values can be accepted:
	 *   + An instance of Date, represent a time in its own time zone.
	 *   + Or string in a subset of ISO 8601, only including:
	 *     + only year, month, date: '2012-03', '2012-03-01', '2012-03-01 05', '2012-03-01 05:06',
	 *     + separated with T or space: '2012-03-01T12:22:33.123', '2012-03-01 12:22:33.123',
	 *     + time zone: '2012-03-01T12:22:33Z', '2012-03-01T12:22:33+8000', '2012-03-01T12:22:33-05:00',
	 *     all of which will be treated as local time if time zone is not specified
	 *     (see <https://momentjs.com/>).
	 *   + Or other string format, including (all of which will be treated as loacal time):
	 *     '2012', '2012-3-1', '2012/3/1', '2012/03/01',
	 *     '2009/6/12 2:00', '2009/6/12 2:05:08', '2009/6/12 2:05:08.123'
	 *   + a timestamp, which represent a time in UTC.
	 * @return {Date} date
	 */
	
	function parseDate(value) {
	  if (value instanceof Date) {
	    return value;
	  } else if (typeof value === 'string') {
	    // Different browsers parse date in different way, so we parse it manually.
	    // Some other issues:
	    // new Date('1970-01-01') is UTC,
	    // new Date('1970/01/01') and new Date('1970-1-01') is local.
	    // See issue #3623
	    var match = TIME_REG.exec(value);
	
	    if (!match) {
	      // return Invalid Date.
	      return new Date(NaN);
	    } // Use local time when no timezone offset specifed.
	
	
	    if (!match[8]) {
	      // match[n] can only be string or undefined.
	      // But take care of '12' + 1 => '121'.
	      return new Date(+match[1], +(match[2] || 1) - 1, +match[3] || 1, +match[4] || 0, +(match[5] || 0), +match[6] || 0, +match[7] || 0);
	    } // Timezoneoffset of Javascript Date has considered DST (Daylight Saving Time,
	    // https://tc39.github.io/ecma262/#sec-daylight-saving-time-adjustment).
	    // For example, system timezone is set as "Time Zone: America/Toronto",
	    // then these code will get different result:
	    // `new Date(1478411999999).getTimezoneOffset();  // get 240`
	    // `new Date(1478412000000).getTimezoneOffset();  // get 300`
	    // So we should not use `new Date`, but use `Date.UTC`.
	    else {
	        var hour = +match[4] || 0;
	
	        if (match[8].toUpperCase() !== 'Z') {
	          hour -= match[8].slice(0, 3);
	        }
	
	        return new Date(Date.UTC(+match[1], +(match[2] || 1) - 1, +match[3] || 1, hour, +(match[5] || 0), +match[6] || 0, +match[7] || 0));
	      }
	  } else if (value == null) {
	    return new Date(NaN);
	  }
	
	  return new Date(Math.round(value));
	}
	/**
	 * Quantity of a number. e.g. 0.1, 1, 10, 100
	 *
	 * @param  {number} val
	 * @return {number}
	 */
	
	
	function quantity(val) {
	  return Math.pow(10, quantityExponent(val));
	}
	/**
	 * Exponent of the quantity of a number
	 * e.g., 1234 equals to 1.234*10^3, so quantityExponent(1234) is 3
	 *
	 * @param  {number} val non-negative value
	 * @return {number}
	 */
	
	
	function quantityExponent(val) {
	  if (val === 0) {
	    return 0;
	  }
	
	  var exp = Math.floor(Math.log(val) / Math.LN10);
	  /**
	   * exp is expected to be the rounded-down result of the base-10 log of val.
	   * But due to the precision loss with Math.log(val), we need to restore it
	   * using 10^exp to make sure we can get val back from exp. #11249
	   */
	
	  if (val / Math.pow(10, exp) >= 10) {
	    exp++;
	  }
	
	  return exp;
	}
	/**
	 * find a “nice” number approximately equal to x. Round the number if round = true,
	 * take ceiling if round = false. The primary observation is that the “nicest”
	 * numbers in decimal are 1, 2, and 5, and all power-of-ten multiples of these numbers.
	 *
	 * See "Nice Numbers for Graph Labels" of Graphic Gems.
	 *
	 * @param  {number} val Non-negative value.
	 * @param  {boolean} round
	 * @return {number}
	 */
	
	
	function nice(val, round) {
	  var exponent = quantityExponent(val);
	  var exp10 = Math.pow(10, exponent);
	  var f = val / exp10; // 1 <= f < 10
	
	  var nf;
	
	  if (round) {
	    if (f < 1.5) {
	      nf = 1;
	    } else if (f < 2.5) {
	      nf = 2;
	    } else if (f < 4) {
	      nf = 3;
	    } else if (f < 7) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  } else {
	    if (f < 1) {
	      nf = 1;
	    } else if (f < 2) {
	      nf = 2;
	    } else if (f < 3) {
	      nf = 3;
	    } else if (f < 5) {
	      nf = 5;
	    } else {
	      nf = 10;
	    }
	  }
	
	  val = nf * exp10; // Fix 3 * 0.1 === 0.30000000000000004 issue (see IEEE 754).
	  // 20 is the uppper bound of toFixed.
	
	  return exponent >= -20 ? +val.toFixed(exponent < 0 ? -exponent : 0) : val;
	}
	/**
	 * This code was copied from "d3.js"
	 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/arrays/quantile.js>.
	 * See the license statement at the head of this file.
	 * @param {Array.<number>} ascArr
	 */
	
	
	function quantile(ascArr, p) {
	  var H = (ascArr.length - 1) * p + 1;
	  var h = Math.floor(H);
	  var v = +ascArr[h - 1];
	  var e = H - h;
	  return e ? v + e * (ascArr[h] - v) : v;
	}
	/**
	 * Order intervals asc, and split them when overlap.
	 * expect(numberUtil.reformIntervals([
	 *     {interval: [18, 62], close: [1, 1]},
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [1, 1]},
	 *     {interval: [62, 150], close: [1, 1]},
	 *     {interval: [106, 150], close: [1, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ])).toEqual([
	 *     {interval: [-Infinity, -70], close: [0, 0]},
	 *     {interval: [-70, -26], close: [1, 1]},
	 *     {interval: [-26, 18], close: [0, 1]},
	 *     {interval: [18, 62], close: [0, 1]},
	 *     {interval: [62, 150], close: [0, 1]},
	 *     {interval: [150, Infinity], close: [0, 0]}
	 * ]);
	 * @param {Array.<Object>} list, where `close` mean open or close
	 *        of the interval, and Infinity can be used.
	 * @return {Array.<Object>} The origin list, which has been reformed.
	 */
	
	
	function reformIntervals(list) {
	  list.sort(function (a, b) {
	    return littleThan(a, b, 0) ? -1 : 1;
	  });
	  var curr = -Infinity;
	  var currClose = 1;
	
	  for (var i = 0; i < list.length;) {
	    var interval = list[i].interval;
	    var close = list[i].close;
	
	    for (var lg = 0; lg < 2; lg++) {
	      if (interval[lg] <= curr) {
	        interval[lg] = curr;
	        close[lg] = !lg ? 1 - currClose : 1;
	      }
	
	      curr = interval[lg];
	      currClose = close[lg];
	    }
	
	    if (interval[0] === interval[1] && close[0] * close[1] !== 1) {
	      list.splice(i, 1);
	    } else {
	      i++;
	    }
	  }
	
	  return list;
	
	  function littleThan(a, b, lg) {
	    return a.interval[lg] < b.interval[lg] || a.interval[lg] === b.interval[lg] && (a.close[lg] - b.close[lg] === (!lg ? 1 : -1) || !lg && littleThan(a, b, 1));
	  }
	}
	/**
	 * parseFloat NaNs numeric-cast false positives (null|true|false|"")
	 * ...but misinterprets leading-number strings, particularly hex literals ("0x...")
	 * subtraction forces infinities to NaN
	 *
	 * @param {*} v
	 * @return {boolean}
	 */
	
	
	function isNumeric(v) {
	  return v - parseFloat(v) >= 0;
	}
	
	exports.linearMap = linearMap;
	exports.parsePercent = parsePercent;
	exports.round = round;
	exports.asc = asc;
	exports.getPrecision = getPrecision;
	exports.getPrecisionSafe = getPrecisionSafe;
	exports.getPixelPrecision = getPixelPrecision;
	exports.getPercentWithPrecision = getPercentWithPrecision;
	exports.MAX_SAFE_INTEGER = MAX_SAFE_INTEGER;
	exports.remRadian = remRadian;
	exports.isRadianAroundZero = isRadianAroundZero;
	exports.parseDate = parseDate;
	exports.quantity = quantity;
	exports.quantityExponent = quantityExponent;
	exports.nice = nice;
	exports.quantile = quantile;
	exports.reformIntervals = reformIntervals;
	exports.isNumeric = isNumeric;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2935);


/***/ },
/* 27 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryFilePreview = exports.queryFileList = exports.queryDeleteAttachment = exports.querySaveAttachment = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var querySaveAttachment = exports.querySaveAttachment = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.post(_req.common.ATTCHMENT_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function querySaveAttachment(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryDeleteAttachment = exports.queryDeleteAttachment = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.common.ATTCHMENT_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryDeleteAttachment(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryFileList = exports.queryFileList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.common.FILE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryFileList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryFilePreview = exports.queryFilePreview = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(file, waterMark) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            _http2.default.html(_req.common.READONLINE, { uuid: file.uuid, waterMark: waterMark || '' });
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryFilePreview(_x4, _x5) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 28 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * 封装localStorage
	 * 增加对JSON对象的转换
	 * @return {[type]} [description]
	 */
	var localDb = {
	  /**
	   * 按key存贮数据value到localStorage
	   * @param {String} key   存贮数据的唯一标识
	   * @param {String, Object} value 所要存贮的数据
	   */
	  set: function set(key, value) {
	    if (!value) delete window.localStorage[key];else {
	      var val = (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" ? JSON.stringify(value) : value;
	      window.localStorage[key] = val;
	    }
	  },
	
	
	  /**
	   * 通过key从localStorage获取数据
	   * @param  {String} key  获取数据的可以标识
	   * @return {String, Object}  返回空，字符串或者对象
	   */
	  get: function get(key) {
	    var str = window.localStorage[key] || "";
	    return this.isJSONStr(str) ? JSON.parse(str) : str;
	  },
	
	
	  /**
	   * 判断是否是JSON string
	   * @param  {String}  str 所要验证的字符串
	   * @return {Boolean}   是否是JSON字符串
	   */
	  isJSONStr: function isJSONStr(str) {
	    return str.charAt(0) === "{" && str.charAt(str.length - 1) === "}" || str.charAt(0) === "[" && str.charAt(str.length - 1) === "]";
	  },
	
	
	  /**
	   * 清空localStorage
	   * @return 无返回NULL
	   */
	  clear: function clear() {
	    window.localStorage.clear();
	  }
	};
	
	exports.default = localDb;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var env = __webpack_require__(73);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var isArray = zrUtil.isArray;
	/**
	 * Make the name displayable. But we should
	 * make sure it is not duplicated with user
	 * specified name, so use '\0';
	 */
	
	var DUMMY_COMPONENT_NAME_PREFIX = 'series\0';
	/**
	 * If value is not array, then translate it to array.
	 * @param  {*} value
	 * @return {Array} [value] or value
	 */
	
	function normalizeToArray(value) {
	  return value instanceof Array ? value : value == null ? [] : [value];
	}
	/**
	 * Sync default option between normal and emphasis like `position` and `show`
	 * In case some one will write code like
	 *     label: {
	 *          show: false,
	 *          position: 'outside',
	 *          fontSize: 18
	 *     },
	 *     emphasis: {
	 *          label: { show: true }
	 *     }
	 * @param {Object} opt
	 * @param {string} key
	 * @param {Array.<string>} subOpts
	 */
	
	
	function defaultEmphasis(opt, key, subOpts) {
	  // Caution: performance sensitive.
	  if (opt) {
	    opt[key] = opt[key] || {};
	    opt.emphasis = opt.emphasis || {};
	    opt.emphasis[key] = opt.emphasis[key] || {}; // Default emphasis option from normal
	
	    for (var i = 0, len = subOpts.length; i < len; i++) {
	      var subOptName = subOpts[i];
	
	      if (!opt.emphasis[key].hasOwnProperty(subOptName) && opt[key].hasOwnProperty(subOptName)) {
	        opt.emphasis[key][subOptName] = opt[key][subOptName];
	      }
	    }
	  }
	}
	
	var TEXT_STYLE_OPTIONS = ['fontStyle', 'fontWeight', 'fontSize', 'fontFamily', 'rich', 'tag', 'color', 'textBorderColor', 'textBorderWidth', 'width', 'height', 'lineHeight', 'align', 'verticalAlign', 'baseline', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY', 'backgroundColor', 'borderColor', 'borderWidth', 'borderRadius', 'padding']; // modelUtil.LABEL_OPTIONS = modelUtil.TEXT_STYLE_OPTIONS.concat([
	//     'position', 'offset', 'rotate', 'origin', 'show', 'distance', 'formatter',
	//     'fontStyle', 'fontWeight', 'fontSize', 'fontFamily',
	//     // FIXME: deprecated, check and remove it.
	//     'textStyle'
	// ]);
	
	/**
	 * The method do not ensure performance.
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method retieves value from data.
	 * @param {string|number|Date|Array|Object} dataItem
	 * @return {number|string|Date|Array.<number|string|Date>}
	 */
	
	function getDataItemValue(dataItem) {
	  return isObject(dataItem) && !isArray(dataItem) && !(dataItem instanceof Date) ? dataItem.value : dataItem;
	}
	/**
	 * data could be [12, 2323, {value: 223}, [1221, 23], {value: [2, 23]}]
	 * This helper method determine if dataItem has extra option besides value
	 * @param {string|number|Date|Array|Object} dataItem
	 */
	
	
	function isDataItemOption(dataItem) {
	  return isObject(dataItem) && !(dataItem instanceof Array); // // markLine data can be array
	  // && !(dataItem[0] && isObject(dataItem[0]) && !(dataItem[0] instanceof Array));
	}
	/**
	 * Mapping to exists for merge.
	 *
	 * @public
	 * @param {Array.<Object>|Array.<module:echarts/model/Component>} exists
	 * @param {Object|Array.<Object>} newCptOptions
	 * @return {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          index of which is the same as exists.
	 */
	
	
	function mappingToExists(exists, newCptOptions) {
	  // Mapping by the order by original option (but not order of
	  // new option) in merge mode. Because we should ensure
	  // some specified index (like xAxisIndex) is consistent with
	  // original option, which is easy to understand, espatially in
	  // media query. And in most case, merge option is used to
	  // update partial option but not be expected to change order.
	  newCptOptions = (newCptOptions || []).slice();
	  var result = zrUtil.map(exists || [], function (obj, index) {
	    return {
	      exist: obj
	    };
	  }); // Mapping by id or name if specified.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    } // id has highest priority.
	
	
	    for (var i = 0; i < result.length; i++) {
	      if (!result[i].option // Consider name: two map to one.
	      && cptOption.id != null && result[i].exist.id === cptOption.id + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	
	    for (var i = 0; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Consider name: two map to one.
	      // Can not match when both ids exist but different.
	      && (exist.id == null || cptOption.id == null) && cptOption.name != null && !isIdInner(cptOption) && !isIdInner(exist) && exist.name === cptOption.name + '') {
	        result[i].option = cptOption;
	        newCptOptions[index] = null;
	        return;
	      }
	    }
	  }); // Otherwise mapping by index.
	
	  each(newCptOptions, function (cptOption, index) {
	    if (!isObject(cptOption)) {
	      return;
	    }
	
	    var i = 0;
	
	    for (; i < result.length; i++) {
	      var exist = result[i].exist;
	
	      if (!result[i].option // Existing model that already has id should be able to
	      // mapped to (because after mapping performed model may
	      // be assigned with a id, whish should not affect next
	      // mapping), except those has inner id.
	      && !isIdInner(exist) // Caution:
	      // Do not overwrite id. But name can be overwritten,
	      // because axis use name as 'show label text'.
	      // 'exist' always has id and name and we dont
	      // need to check it.
	      && cptOption.id == null) {
	        result[i].option = cptOption;
	        break;
	      }
	    }
	
	    if (i >= result.length) {
	      result.push({
	        option: cptOption
	      });
	    }
	  });
	  return result;
	}
	/**
	 * Make id and name for mapping result (result of mappingToExists)
	 * into `keyInfo` field.
	 *
	 * @public
	 * @param {Array.<Object>} Result, like [{exist: ..., option: ...}, {}],
	 *                          which order is the same as exists.
	 * @return {Array.<Object>} The input.
	 */
	
	
	function makeIdAndName(mapResult) {
	  // We use this id to hash component models and view instances
	  // in echarts. id can be specified by user, or auto generated.
	  // The id generation rule ensures new view instance are able
	  // to mapped to old instance when setOption are called in
	  // no-merge mode. So we generate model id by name and plus
	  // type in view id.
	  // name can be duplicated among components, which is convenient
	  // to specify multi components (like series) by one name.
	  // Ensure that each id is distinct.
	  var idMap = zrUtil.createHashMap();
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    existCpt && idMap.set(existCpt.id, item);
	  });
	  each(mapResult, function (item, index) {
	    var opt = item.option;
	    zrUtil.assert(!opt || opt.id == null || !idMap.get(opt.id) || idMap.get(opt.id) === item, 'id duplicates: ' + (opt && opt.id));
	    opt && opt.id != null && idMap.set(opt.id, item);
	    !item.keyInfo && (item.keyInfo = {});
	  }); // Make name and id.
	
	  each(mapResult, function (item, index) {
	    var existCpt = item.exist;
	    var opt = item.option;
	    var keyInfo = item.keyInfo;
	
	    if (!isObject(opt)) {
	      return;
	    } // name can be overwitten. Consider case: axis.name = '20km'.
	    // But id generated by name will not be changed, which affect
	    // only in that case: setOption with 'not merge mode' and view
	    // instance will be recreated, which can be accepted.
	
	
	    keyInfo.name = opt.name != null ? opt.name + '' : existCpt ? existCpt.name // Avoid diffferent series has the same name,
	    // because name may be used like in color pallet.
	    : DUMMY_COMPONENT_NAME_PREFIX + index;
	
	    if (existCpt) {
	      keyInfo.id = existCpt.id;
	    } else if (opt.id != null) {
	      keyInfo.id = opt.id + '';
	    } else {
	      // Consider this situatoin:
	      //  optionA: [{name: 'a'}, {name: 'a'}, {..}]
	      //  optionB [{..}, {name: 'a'}, {name: 'a'}]
	      // Series with the same name between optionA and optionB
	      // should be mapped.
	      var idNum = 0;
	
	      do {
	        keyInfo.id = '\0' + keyInfo.name + '\0' + idNum++;
	      } while (idMap.get(keyInfo.id));
	    }
	
	    idMap.set(keyInfo.id, item);
	  });
	}
	
	function isNameSpecified(componentModel) {
	  var name = componentModel.name; // Is specified when `indexOf` get -1 or > 0.
	
	  return !!(name && name.indexOf(DUMMY_COMPONENT_NAME_PREFIX));
	}
	/**
	 * @public
	 * @param {Object} cptOption
	 * @return {boolean}
	 */
	
	
	function isIdInner(cptOption) {
	  return isObject(cptOption) && cptOption.id && (cptOption.id + '').indexOf('\0_ec_\0') === 0;
	}
	/**
	 * A helper for removing duplicate items between batchA and batchB,
	 * and in themselves, and categorize by series.
	 *
	 * @param {Array.<Object>} batchA Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @param {Array.<Object>} batchB Like: [{seriesId: 2, dataIndex: [32, 4, 5]}, ...]
	 * @return {Array.<Array.<Object>, Array.<Object>>} result: [resultBatchA, resultBatchB]
	 */
	
	
	function compressBatches(batchA, batchB) {
	  var mapA = {};
	  var mapB = {};
	  makeMap(batchA || [], mapA);
	  makeMap(batchB || [], mapB, mapA);
	  return [mapToArray(mapA), mapToArray(mapB)];
	
	  function makeMap(sourceBatch, map, otherMap) {
	    for (var i = 0, len = sourceBatch.length; i < len; i++) {
	      var seriesId = sourceBatch[i].seriesId;
	      var dataIndices = normalizeToArray(sourceBatch[i].dataIndex);
	      var otherDataIndices = otherMap && otherMap[seriesId];
	
	      for (var j = 0, lenj = dataIndices.length; j < lenj; j++) {
	        var dataIndex = dataIndices[j];
	
	        if (otherDataIndices && otherDataIndices[dataIndex]) {
	          otherDataIndices[dataIndex] = null;
	        } else {
	          (map[seriesId] || (map[seriesId] = {}))[dataIndex] = 1;
	        }
	      }
	    }
	  }
	
	  function mapToArray(map, isData) {
	    var result = [];
	
	    for (var i in map) {
	      if (map.hasOwnProperty(i) && map[i] != null) {
	        if (isData) {
	          result.push(+i);
	        } else {
	          var dataIndices = mapToArray(map[i], true);
	          dataIndices.length && result.push({
	            seriesId: i,
	            dataIndex: dataIndices
	          });
	        }
	      }
	    }
	
	    return result;
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Object} payload Contains dataIndex (means rawIndex) / dataIndexInside / name
	 *                         each of which can be Array or primary type.
	 * @return {number|Array.<number>} dataIndex If not found, return undefined/null.
	 */
	
	
	function queryDataIndex(data, payload) {
	  if (payload.dataIndexInside != null) {
	    return payload.dataIndexInside;
	  } else if (payload.dataIndex != null) {
	    return zrUtil.isArray(payload.dataIndex) ? zrUtil.map(payload.dataIndex, function (value) {
	      return data.indexOfRawIndex(value);
	    }) : data.indexOfRawIndex(payload.dataIndex);
	  } else if (payload.name != null) {
	    return zrUtil.isArray(payload.name) ? zrUtil.map(payload.name, function (value) {
	      return data.indexOfName(value);
	    }) : data.indexOfName(payload.name);
	  }
	}
	/**
	 * Enable property storage to any host object.
	 * Notice: Serialization is not supported.
	 *
	 * For example:
	 * var inner = zrUitl.makeInner();
	 *
	 * function some1(hostObj) {
	 *      inner(hostObj).someProperty = 1212;
	 *      ...
	 * }
	 * function some2() {
	 *      var fields = inner(this);
	 *      fields.someProperty1 = 1212;
	 *      fields.someProperty2 = 'xx';
	 *      ...
	 * }
	 *
	 * @return {Function}
	 */
	
	
	function makeInner() {
	  // Consider different scope by es module import.
	  var key = '__\0ec_inner_' + innerUniqueIndex++ + '_' + Math.random().toFixed(5);
	  return function (hostObj) {
	    return hostObj[key] || (hostObj[key] = {});
	  };
	}
	
	var innerUniqueIndex = 0;
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {string|Object} finder
	 *        If string, e.g., 'geo', means {geoIndex: 0}.
	 *        If Object, could contain some of these properties below:
	 *        {
	 *            seriesIndex, seriesId, seriesName,
	 *            geoIndex, geoId, geoName,
	 *            bmapIndex, bmapId, bmapName,
	 *            xAxisIndex, xAxisId, xAxisName,
	 *            yAxisIndex, yAxisId, yAxisName,
	 *            gridIndex, gridId, gridName,
	 *            ... (can be extended)
	 *        }
	 *        Each properties can be number|string|Array.<number>|Array.<string>
	 *        For example, a finder could be
	 *        {
	 *            seriesIndex: 3,
	 *            geoId: ['aa', 'cc'],
	 *            gridName: ['xx', 'rr']
	 *        }
	 *        xxxIndex can be set as 'all' (means all xxx) or 'none' (means not specify)
	 *        If nothing or null/undefined specified, return nothing.
	 * @param {Object} [opt]
	 * @param {string} [opt.defaultMainType]
	 * @param {Array.<string>} [opt.includeMainTypes]
	 * @return {Object} result like:
	 *        {
	 *            seriesModels: [seriesModel1, seriesModel2],
	 *            seriesModel: seriesModel1, // The first model
	 *            geoModels: [geoModel1, geoModel2],
	 *            geoModel: geoModel1, // The first model
	 *            ...
	 *        }
	 */
	
	function parseFinder(ecModel, finder, opt) {
	  if (zrUtil.isString(finder)) {
	    var obj = {};
	    obj[finder + 'Index'] = 0;
	    finder = obj;
	  }
	
	  var defaultMainType = opt && opt.defaultMainType;
	
	  if (defaultMainType && !has(finder, defaultMainType + 'Index') && !has(finder, defaultMainType + 'Id') && !has(finder, defaultMainType + 'Name')) {
	    finder[defaultMainType + 'Index'] = 0;
	  }
	
	  var result = {};
	  each(finder, function (value, key) {
	    var value = finder[key]; // Exclude 'dataIndex' and other illgal keys.
	
	    if (key === 'dataIndex' || key === 'dataIndexInside') {
	      result[key] = value;
	      return;
	    }
	
	    var parsedKey = key.match(/^(\w+)(Index|Id|Name)$/) || [];
	    var mainType = parsedKey[1];
	    var queryType = (parsedKey[2] || '').toLowerCase();
	
	    if (!mainType || !queryType || value == null || queryType === 'index' && value === 'none' || opt && opt.includeMainTypes && zrUtil.indexOf(opt.includeMainTypes, mainType) < 0) {
	      return;
	    }
	
	    var queryParam = {
	      mainType: mainType
	    };
	
	    if (queryType !== 'index' || value !== 'all') {
	      queryParam[queryType] = value;
	    }
	
	    var models = ecModel.queryComponents(queryParam);
	    result[mainType + 'Models'] = models;
	    result[mainType + 'Model'] = models[0];
	  });
	  return result;
	}
	
	function has(obj, prop) {
	  return obj && obj.hasOwnProperty(prop);
	}
	
	function setAttribute(dom, key, value) {
	  dom.setAttribute ? dom.setAttribute(key, value) : dom[key] = value;
	}
	
	function getAttribute(dom, key) {
	  return dom.getAttribute ? dom.getAttribute(key) : dom[key];
	}
	
	function getTooltipRenderMode(renderModeOption) {
	  if (renderModeOption === 'auto') {
	    // Using html when `document` exists, use richText otherwise
	    return env.domSupported ? 'html' : 'richText';
	  } else {
	    return renderModeOption || 'html';
	  }
	}
	/**
	 * Group a list by key.
	 *
	 * @param {Array} array
	 * @param {Function} getKey
	 *        param {*} Array item
	 *        return {string} key
	 * @return {Object} Result
	 *        {Array}: keys,
	 *        {module:zrender/core/util/HashMap} buckets: {key -> Array}
	 */
	
	
	function groupData(array, getKey) {
	  var buckets = zrUtil.createHashMap();
	  var keys = [];
	  zrUtil.each(array, function (item) {
	    var key = getKey(item);
	    (buckets.get(key) || (keys.push(key), buckets.set(key, []))).push(item);
	  });
	  return {
	    keys: keys,
	    buckets: buckets
	  };
	}
	
	exports.normalizeToArray = normalizeToArray;
	exports.defaultEmphasis = defaultEmphasis;
	exports.TEXT_STYLE_OPTIONS = TEXT_STYLE_OPTIONS;
	exports.getDataItemValue = getDataItemValue;
	exports.isDataItemOption = isDataItemOption;
	exports.mappingToExists = mappingToExists;
	exports.makeIdAndName = makeIdAndName;
	exports.isNameSpecified = isNameSpecified;
	exports.isIdInner = isIdInner;
	exports.compressBatches = compressBatches;
	exports.queryDataIndex = queryDataIndex;
	exports.makeInner = makeInner;
	exports.parseFinder = parseFinder;
	exports.setAttribute = setAttribute;
	exports.getAttribute = getAttribute;
	exports.getTooltipRenderMode = getTooltipRenderMode;
	exports.groupData = groupData;

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryBudgetApportionInfo = exports.queryBudgetStatisticsMonth = exports.queryBudgetStatistics = exports.queryUpdateGroupRecord = exports.queryGroupRecordInfo = exports.queryDeleteGroupBook = exports.queryAddGroupRecord = exports.queryAddGroupBookList = exports.queryGroupRecordList = exports.queryTemplateImportBudgetGroupSet = exports.queryImportBudgetGroupSetInfo = exports.queryBatchImportBudgetGroupSet = exports.querySaveBudgetGroupSet = exports.queryBudgetGroupSetList = exports.querySaveBudgetGroup = exports.queryBudgetGroupInfo = exports.queryBudgetGroupSum = exports.queryBudgetGroupCandF = exports.queryDisableCapitalGroup = exports.queryEnableCapitalGroup = exports.queryDisableBudgetGroup = exports.queryEnableBudgetGroup = exports.queryBudgetGroupPerList = exports.queryBudgetGroupMy = exports.queryBudgetGroupList = exports.queryAnalysisProfitDetail = exports.queryAnalysisProfit = exports.queryAnalysisOperationalDetail = exports.queryAnalysisOperational = exports.queryAnalysisBudgets = exports.queryBudgetAnalysisBudgetMonth = exports.queryBudgetAnalysisBudget = exports.queryExportBudgetAnalysisExpenditure = exports.queryBudgetAnalysisExpenditure = exports.queryBudgetAnalysisFundsMonth = exports.queryBudgetAnalysisFunds = exports.queryExportBudgetAnalysisIncome = exports.queryBudgetAnalysisIncome = exports.queryBudgetAnalysis = exports.queryCallbackBudgetSet = exports.queryReturnBudgetSet = exports.queryNextBudgetSet = exports.queryDeleteBudgetSet = exports.querySaveBudgetSet = exports.queryBudgetSetInfo = exports.queryBudgetSetWorkflow = exports.querySetBudgetWatch = exports.querySetBudgetMy = exports.queryCallbackAdjustment = exports.queryReturnAdjustment = exports.queryNextAdjustment = exports.queryDeleteAdjustment = exports.queryDownloadGroupSetTemplate = exports.querySaveAdjustment = exports.queryAdjustmentInfo = exports.queryAdjustmentWorkflow = exports.queryBudgetAccount = exports.queryAdjustable = exports.queryAdjustBudgetWatch = exports.queryAdjustBudgetMy = exports.queryBudgetGroupAims = exports.querySetBudgetGroupAims = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	// 设置目标收入保存
	var querySetBudgetGroupAims = exports.querySetBudgetGroupAims = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.post(_req.finance.BUDGET_GROUP_SET_AIMS, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function querySetBudgetGroupAims(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	// 目标收入历史信息
	
	
	var queryBudgetGroupAims = exports.queryBudgetGroupAims = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_GET_AIMS, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryBudgetGroupAims(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	//* *******************预算调整*****************************
	
	
	var queryAdjustBudgetMy = exports.queryAdjustBudgetMy = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ADJUST_MY, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryAdjustBudgetMy(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryAdjustBudgetWatch = exports.queryAdjustBudgetWatch = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ADJUST_WATCH, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryAdjustBudgetWatch(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryAdjustable = exports.queryAdjustable = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ADJUSTABLE, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryAdjustable(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}(); // 可调整金额
	
	
	var queryBudgetAccount = exports.queryBudgetAccount = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ACCOUNT, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryBudgetAccount(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}(); // 余额明细
	
	
	var queryAdjustmentWorkflow = exports.queryAdjustmentWorkflow = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ADJUSTMENT_WORKFLOW));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryAdjustmentWorkflow() {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var queryAdjustmentInfo = exports.queryAdjustmentInfo = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ADJUSTMENT_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryAdjustmentInfo(_x7) {
	    return _ref8.apply(this, arguments);
	  };
	}(); // 编辑获得明细
	
	
	var querySaveAdjustment = exports.querySaveAdjustment = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.post(_req.finance.BUDGET_ADJUSTMENT_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function querySaveAdjustment(_x8) {
	    return _ref9.apply(this, arguments);
	  };
	}(); // 预算调整申请保存
	
	
	var queryDownloadGroupSetTemplate = exports.queryDownloadGroupSetTemplate = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10() {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            _http2.default.download(_req.finance.DOWNLOAD_GROUP_SET_TEMPLATE, {}, '预算设置模板.xlsx');
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryDownloadGroupSetTemplate() {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryDeleteAdjustment = exports.queryDeleteAdjustment = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.get(_req.finance.BUDGET_ADJUSTMENT_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryDeleteAdjustment(_x9) {
	    return _ref11.apply(this, arguments);
	  };
	}(); // 删除申请
	
	
	var queryNextAdjustment = exports.queryNextAdjustment = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.get(_req.finance.BUDGET_ADJUSTMENT_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryNextAdjustment(_x10) {
	    return _ref12.apply(this, arguments);
	  };
	}(); // 流程审核
	
	
	var queryReturnAdjustment = exports.queryReturnAdjustment = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.post(_req.finance.BUDGET_ADJUSTMENT_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryReturnAdjustment(_x11) {
	    return _ref13.apply(this, arguments);
	  };
	}(); // 流程打回
	
	
	var queryCallbackAdjustment = exports.queryCallbackAdjustment = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.finance.BUDGET_ADJUSTMENT_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryCallbackAdjustment(_x12) {
	    return _ref14.apply(this, arguments);
	  };
	}(); // 流程收回
	//* *******************预算设置*****************************
	
	
	var querySetBudgetMy = exports.querySetBudgetMy = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_SET_MY, params));
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function querySetBudgetMy(_x13) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var querySetBudgetWatch = exports.querySetBudgetWatch = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(params) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            return _context16.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_SET_WATCH, params));
	
	          case 1:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function querySetBudgetWatch(_x14) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var queryBudgetSetWorkflow = exports.queryBudgetSetWorkflow = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17() {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            return _context17.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_SET_WORKFLOW));
	
	          case 1:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, this);
	  }));
	
	  return function queryBudgetSetWorkflow() {
	    return _ref17.apply(this, arguments);
	  };
	}(); // 发起流程
	
	
	var queryBudgetSetInfo = exports.queryBudgetSetInfo = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(params) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            return _context18.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_SET_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, this);
	  }));
	
	  return function queryBudgetSetInfo(_x15) {
	    return _ref18.apply(this, arguments);
	  };
	}(); // 编辑获得明细
	
	
	var querySaveBudgetSet = exports.querySaveBudgetSet = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(params) {
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            return _context19.abrupt('return', _http2.default.post(_req.finance.BUDGET_SET_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context19.stop();
	        }
	      }
	    }, _callee19, this);
	  }));
	
	  return function querySaveBudgetSet(_x16) {
	    return _ref19.apply(this, arguments);
	  };
	}(); // 预算调整申请保存
	
	
	var queryDeleteBudgetSet = exports.queryDeleteBudgetSet = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(params) {
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            return _context20.abrupt('return', _http2.default.get(_req.finance.BUDGET_SET_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context20.stop();
	        }
	      }
	    }, _callee20, this);
	  }));
	
	  return function queryDeleteBudgetSet(_x17) {
	    return _ref20.apply(this, arguments);
	  };
	}(); // 删除申请
	
	
	var queryNextBudgetSet = exports.queryNextBudgetSet = function () {
	  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(params) {
	    return _regenerator2.default.wrap(function _callee21$(_context21) {
	      while (1) {
	        switch (_context21.prev = _context21.next) {
	          case 0:
	            return _context21.abrupt('return', _http2.default.get(_req.finance.BUDGET_SET_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context21.stop();
	        }
	      }
	    }, _callee21, this);
	  }));
	
	  return function queryNextBudgetSet(_x18) {
	    return _ref21.apply(this, arguments);
	  };
	}(); // 流程审核
	
	
	var queryReturnBudgetSet = exports.queryReturnBudgetSet = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(params) {
	    return _regenerator2.default.wrap(function _callee22$(_context22) {
	      while (1) {
	        switch (_context22.prev = _context22.next) {
	          case 0:
	            return _context22.abrupt('return', _http2.default.post(_req.finance.BUDGET_SET_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context22.stop();
	        }
	      }
	    }, _callee22, this);
	  }));
	
	  return function queryReturnBudgetSet(_x19) {
	    return _ref22.apply(this, arguments);
	  };
	}(); // 流程打回
	
	
	var queryCallbackBudgetSet = exports.queryCallbackBudgetSet = function () {
	  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(params) {
	    return _regenerator2.default.wrap(function _callee23$(_context23) {
	      while (1) {
	        switch (_context23.prev = _context23.next) {
	          case 0:
	            return _context23.abrupt('return', _http2.default.get(_req.finance.BUDGET_SET_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context23.stop();
	        }
	      }
	    }, _callee23, this);
	  }));
	
	  return function queryCallbackBudgetSet(_x20) {
	    return _ref23.apply(this, arguments);
	  };
	}(); // 流程收回
	
	//* *******************收支分析*****************************
	
	
	var queryBudgetAnalysis = exports.queryBudgetAnalysis = function () {
	  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(params) {
	    return _regenerator2.default.wrap(function _callee24$(_context24) {
	      while (1) {
	        switch (_context24.prev = _context24.next) {
	          case 0:
	            return _context24.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS, params));
	
	          case 1:
	          case 'end':
	            return _context24.stop();
	        }
	      }
	    }, _callee24, this);
	  }));
	
	  return function queryBudgetAnalysis(_x21) {
	    return _ref24.apply(this, arguments);
	  };
	}();
	
	var queryBudgetAnalysisIncome = exports.queryBudgetAnalysisIncome = function () {
	  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(params) {
	    return _regenerator2.default.wrap(function _callee25$(_context25) {
	      while (1) {
	        switch (_context25.prev = _context25.next) {
	          case 0:
	            return _context25.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS_INCOME, params));
	
	          case 1:
	          case 'end':
	            return _context25.stop();
	        }
	      }
	    }, _callee25, this);
	  }));
	
	  return function queryBudgetAnalysisIncome(_x22) {
	    return _ref25.apply(this, arguments);
	  };
	}(); // 收入分析明细
	
	var queryExportBudgetAnalysisIncome = exports.queryExportBudgetAnalysisIncome = function () {
	  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(params) {
	    return _regenerator2.default.wrap(function _callee26$(_context26) {
	      while (1) {
	        switch (_context26.prev = _context26.next) {
	          case 0:
	            return _context26.abrupt('return', _http2.default.download(_req.finance.BUDGET_GET_ANALYSIS_INCOME_EXPORT, params, '\u8D44\u91D1\u6D41\u6C34\u660E\u7EC6\u5BFC\u51FA' + (0, _moment2.default)().format('yyyyMMDDHHmmss') + '.xlsx'));
	
	          case 1:
	          case 'end':
	            return _context26.stop();
	        }
	      }
	    }, _callee26, this);
	  }));
	
	  return function queryExportBudgetAnalysisIncome(_x23) {
	    return _ref26.apply(this, arguments);
	  };
	}(); // 收入分析明细导出
	
	var queryBudgetAnalysisFunds = exports.queryBudgetAnalysisFunds = function () {
	  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(params) {
	    return _regenerator2.default.wrap(function _callee27$(_context27) {
	      while (1) {
	        switch (_context27.prev = _context27.next) {
	          case 0:
	            return _context27.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS_FUNDS, params));
	
	          case 1:
	          case 'end':
	            return _context27.stop();
	        }
	      }
	    }, _callee27, this);
	  }));
	
	  return function queryBudgetAnalysisFunds(_x24) {
	    return _ref27.apply(this, arguments);
	  };
	}(); // 财务数据分析
	
	var queryBudgetAnalysisFundsMonth = exports.queryBudgetAnalysisFundsMonth = function () {
	  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(params) {
	    return _regenerator2.default.wrap(function _callee28$(_context28) {
	      while (1) {
	        switch (_context28.prev = _context28.next) {
	          case 0:
	            return _context28.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS_FUNDS_MONTH, params));
	
	          case 1:
	          case 'end':
	            return _context28.stop();
	        }
	      }
	    }, _callee28, this);
	  }));
	
	  return function queryBudgetAnalysisFundsMonth(_x25) {
	    return _ref28.apply(this, arguments);
	  };
	}(); // 财务数据分析月份
	
	var queryBudgetAnalysisExpenditure = exports.queryBudgetAnalysisExpenditure = function () {
	  var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(params) {
	    return _regenerator2.default.wrap(function _callee29$(_context29) {
	      while (1) {
	        switch (_context29.prev = _context29.next) {
	          case 0:
	            return _context29.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS_EXPENDITURE, params));
	
	          case 1:
	          case 'end':
	            return _context29.stop();
	        }
	      }
	    }, _callee29, this);
	  }));
	
	  return function queryBudgetAnalysisExpenditure(_x26) {
	    return _ref29.apply(this, arguments);
	  };
	}(); // 支出分析明细
	
	
	var queryExportBudgetAnalysisExpenditure = exports.queryExportBudgetAnalysisExpenditure = function () {
	  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(params) {
	    return _regenerator2.default.wrap(function _callee30$(_context30) {
	      while (1) {
	        switch (_context30.prev = _context30.next) {
	          case 0:
	            return _context30.abrupt('return', _http2.default.download(_req.finance.BUDGET_GET_ANALYSIS_EXPENDITURE_EXPORT, params, '\u8D44\u91D1\u6D41\u6C34\u660E\u7EC6\u5BFC\u51FA' + (0, _moment2.default)().format('yyyyMMDDHHmmss') + '.xlsx'));
	
	          case 1:
	          case 'end':
	            return _context30.stop();
	        }
	      }
	    }, _callee30, this);
	  }));
	
	  return function queryExportBudgetAnalysisExpenditure(_x27) {
	    return _ref30.apply(this, arguments);
	  };
	}(); // 支出分析明细导出
	
	var queryBudgetAnalysisBudget = exports.queryBudgetAnalysisBudget = function () {
	  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(params) {
	    return _regenerator2.default.wrap(function _callee31$(_context31) {
	      while (1) {
	        switch (_context31.prev = _context31.next) {
	          case 0:
	            return _context31.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS_BUDGET, params));
	
	          case 1:
	          case 'end':
	            return _context31.stop();
	        }
	      }
	    }, _callee31, this);
	  }));
	
	  return function queryBudgetAnalysisBudget(_x28) {
	    return _ref31.apply(this, arguments);
	  };
	}(); // 财务数据分析
	
	var queryBudgetAnalysisBudgetMonth = exports.queryBudgetAnalysisBudgetMonth = function () {
	  var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(params) {
	    return _regenerator2.default.wrap(function _callee32$(_context32) {
	      while (1) {
	        switch (_context32.prev = _context32.next) {
	          case 0:
	            return _context32.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS_BUDGET_MONTH, params));
	
	          case 1:
	          case 'end':
	            return _context32.stop();
	        }
	      }
	    }, _callee32, this);
	  }));
	
	  return function queryBudgetAnalysisBudgetMonth(_x29) {
	    return _ref32.apply(this, arguments);
	  };
	}(); // 财务数据分析月份
	
	var queryAnalysisBudgets = exports.queryAnalysisBudgets = function () {
	  var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(params) {
	    return _regenerator2.default.wrap(function _callee33$(_context33) {
	      while (1) {
	        switch (_context33.prev = _context33.next) {
	          case 0:
	            return _context33.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS_BUDGETS, params));
	
	          case 1:
	          case 'end':
	            return _context33.stop();
	        }
	      }
	    }, _callee33, this);
	  }));
	
	  return function queryAnalysisBudgets(_x30) {
	    return _ref33.apply(this, arguments);
	  };
	}(); // 收入分析预算统计
	
	
	var queryAnalysisOperational = exports.queryAnalysisOperational = function () {
	  var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(params) {
	    return _regenerator2.default.wrap(function _callee34$(_context34) {
	      while (1) {
	        switch (_context34.prev = _context34.next) {
	          case 0:
	            return _context34.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS_OPERATIONAL, params));
	
	          case 1:
	          case 'end':
	            return _context34.stop();
	        }
	      }
	    }, _callee34, this);
	  }));
	
	  return function queryAnalysisOperational(_x31) {
	    return _ref34.apply(this, arguments);
	  };
	}(); // 收入分析运营报表
	
	
	var queryAnalysisOperationalDetail = exports.queryAnalysisOperationalDetail = function () {
	  var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(params) {
	    return _regenerator2.default.wrap(function _callee35$(_context35) {
	      while (1) {
	        switch (_context35.prev = _context35.next) {
	          case 0:
	            return _context35.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS_OPERATIONAL_DETAIL, params));
	
	          case 1:
	          case 'end':
	            return _context35.stop();
	        }
	      }
	    }, _callee35, this);
	  }));
	
	  return function queryAnalysisOperationalDetail(_x32) {
	    return _ref35.apply(this, arguments);
	  };
	}(); // 收入分析运营报表详情
	
	
	var queryAnalysisProfit = exports.queryAnalysisProfit = function () {
	  var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(params) {
	    return _regenerator2.default.wrap(function _callee36$(_context36) {
	      while (1) {
	        switch (_context36.prev = _context36.next) {
	          case 0:
	            return _context36.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS_PROFIT, params));
	
	          case 1:
	          case 'end':
	            return _context36.stop();
	        }
	      }
	    }, _callee36, this);
	  }));
	
	  return function queryAnalysisProfit(_x33) {
	    return _ref36.apply(this, arguments);
	  };
	}(); // 收入分析利润追踪
	
	
	var queryAnalysisProfitDetail = exports.queryAnalysisProfitDetail = function () {
	  var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(params) {
	    return _regenerator2.default.wrap(function _callee37$(_context37) {
	      while (1) {
	        switch (_context37.prev = _context37.next) {
	          case 0:
	            return _context37.abrupt('return', _http2.default.get(_req.finance.BUDGET_GET_ANALYSIS_PROFIT_DETAIL, params));
	
	          case 1:
	          case 'end':
	            return _context37.stop();
	        }
	      }
	    }, _callee37, this);
	  }));
	
	  return function queryAnalysisProfitDetail(_x34) {
	    return _ref37.apply(this, arguments);
	  };
	}(); // 收入分析利润追踪列表
	/* -------------------------------------预算------------------------------------*/
	/**
	 * 获取预算组列表
	 */
	
	
	var queryBudgetGroupList = exports.queryBudgetGroupList = function () {
	  var _ref38 = _asyncToGenerator(_regenerator2.default.mark(function _callee38(params) {
	    return _regenerator2.default.wrap(function _callee38$(_context38) {
	      while (1) {
	        switch (_context38.prev = _context38.next) {
	          case 0:
	            return _context38.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context38.stop();
	        }
	      }
	    }, _callee38, this);
	  }));
	
	  return function queryBudgetGroupList(_x35) {
	    return _ref38.apply(this, arguments);
	  };
	}();
	
	var queryBudgetGroupMy = exports.queryBudgetGroupMy = function () {
	  var _ref39 = _asyncToGenerator(_regenerator2.default.mark(function _callee39(params) {
	    return _regenerator2.default.wrap(function _callee39$(_context39) {
	      while (1) {
	        switch (_context39.prev = _context39.next) {
	          case 0:
	            return _context39.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_MY, params));
	
	          case 1:
	          case 'end':
	            return _context39.stop();
	        }
	      }
	    }, _callee39, this);
	  }));
	
	  return function queryBudgetGroupMy(_x36) {
	    return _ref39.apply(this, arguments);
	  };
	}();
	
	var queryBudgetGroupPerList = exports.queryBudgetGroupPerList = function () {
	  var _ref40 = _asyncToGenerator(_regenerator2.default.mark(function _callee40(params) {
	    return _regenerator2.default.wrap(function _callee40$(_context40) {
	      while (1) {
	        switch (_context40.prev = _context40.next) {
	          case 0:
	            return _context40.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_PER_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context40.stop();
	        }
	      }
	    }, _callee40, this);
	  }));
	
	  return function queryBudgetGroupPerList(_x37) {
	    return _ref40.apply(this, arguments);
	  };
	}();
	
	var queryEnableBudgetGroup = exports.queryEnableBudgetGroup = function () {
	  var _ref41 = _asyncToGenerator(_regenerator2.default.mark(function _callee41(uuid) {
	    return _regenerator2.default.wrap(function _callee41$(_context41) {
	      while (1) {
	        switch (_context41.prev = _context41.next) {
	          case 0:
	            return _context41.abrupt('return', _http2.default.get(_req.finance.BUDGET_GRUOP_ENABLE, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context41.stop();
	        }
	      }
	    }, _callee41, this);
	  }));
	
	  return function queryEnableBudgetGroup(_x38) {
	    return _ref41.apply(this, arguments);
	  };
	}();
	
	var queryDisableBudgetGroup = exports.queryDisableBudgetGroup = function () {
	  var _ref42 = _asyncToGenerator(_regenerator2.default.mark(function _callee42(uuid) {
	    return _regenerator2.default.wrap(function _callee42$(_context42) {
	      while (1) {
	        switch (_context42.prev = _context42.next) {
	          case 0:
	            return _context42.abrupt('return', _http2.default.get(_req.finance.BUDGET_GRUOP_DISABLE, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context42.stop();
	        }
	      }
	    }, _callee42, this);
	  }));
	
	  return function queryDisableBudgetGroup(_x39) {
	    return _ref42.apply(this, arguments);
	  };
	}();
	
	var queryEnableCapitalGroup = exports.queryEnableCapitalGroup = function () {
	  var _ref43 = _asyncToGenerator(_regenerator2.default.mark(function _callee43(uuid) {
	    return _regenerator2.default.wrap(function _callee43$(_context43) {
	      while (1) {
	        switch (_context43.prev = _context43.next) {
	          case 0:
	            return _context43.abrupt('return', _http2.default.get(_req.finance.CAPITAL_ENABLE, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context43.stop();
	        }
	      }
	    }, _callee43, this);
	  }));
	
	  return function queryEnableCapitalGroup(_x40) {
	    return _ref43.apply(this, arguments);
	  };
	}();
	
	var queryDisableCapitalGroup = exports.queryDisableCapitalGroup = function () {
	  var _ref44 = _asyncToGenerator(_regenerator2.default.mark(function _callee44(uuid) {
	    return _regenerator2.default.wrap(function _callee44$(_context44) {
	      while (1) {
	        switch (_context44.prev = _context44.next) {
	          case 0:
	            return _context44.abrupt('return', _http2.default.get(_req.finance.CAPITAL_DISABLE, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context44.stop();
	        }
	      }
	    }, _callee44, this);
	  }));
	
	  return function queryDisableCapitalGroup(_x41) {
	    return _ref44.apply(this, arguments);
	  };
	}();
	
	var queryBudgetGroupCandF = exports.queryBudgetGroupCandF = function () {
	  var _ref45 = _asyncToGenerator(_regenerator2.default.mark(function _callee45(params) {
	    return _regenerator2.default.wrap(function _callee45$(_context45) {
	      while (1) {
	        switch (_context45.prev = _context45.next) {
	          case 0:
	            return _context45.abrupt('return', _http2.default.get(_req.finance.BUDGET_GRUOP_GETCAF, params));
	
	          case 1:
	          case 'end':
	            return _context45.stop();
	        }
	      }
	    }, _callee45, this);
	  }));
	
	  return function queryBudgetGroupCandF(_x42) {
	    return _ref45.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取预算管理的总计
	 */
	
	
	var queryBudgetGroupSum = exports.queryBudgetGroupSum = function () {
	  var _ref46 = _asyncToGenerator(_regenerator2.default.mark(function _callee46(params) {
	    return _regenerator2.default.wrap(function _callee46$(_context46) {
	      while (1) {
	        switch (_context46.prev = _context46.next) {
	          case 0:
	            return _context46.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_SUM, params));
	
	          case 1:
	          case 'end':
	            return _context46.stop();
	        }
	      }
	    }, _callee46, this);
	  }));
	
	  return function queryBudgetGroupSum(_x43) {
	    return _ref46.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取预算组明细
	 */
	
	
	var queryBudgetGroupInfo = exports.queryBudgetGroupInfo = function () {
	  var _ref47 = _asyncToGenerator(_regenerator2.default.mark(function _callee47(uuid) {
	    return _regenerator2.default.wrap(function _callee47$(_context47) {
	      while (1) {
	        switch (_context47.prev = _context47.next) {
	          case 0:
	            return _context47.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_INFO, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context47.stop();
	        }
	      }
	    }, _callee47, this);
	  }));
	
	  return function queryBudgetGroupInfo(_x44) {
	    return _ref47.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算组保存
	 */
	
	
	var querySaveBudgetGroup = exports.querySaveBudgetGroup = function () {
	  var _ref48 = _asyncToGenerator(_regenerator2.default.mark(function _callee48(params) {
	    return _regenerator2.default.wrap(function _callee48$(_context48) {
	      while (1) {
	        switch (_context48.prev = _context48.next) {
	          case 0:
	            return _context48.abrupt('return', _http2.default.post(_req.finance.BUDGET_GROUP_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context48.stop();
	        }
	      }
	    }, _callee48, this);
	  }));
	
	  return function querySaveBudgetGroup(_x45) {
	    return _ref48.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算组设置列表
	 */
	
	
	var queryBudgetGroupSetList = exports.queryBudgetGroupSetList = function () {
	  var _ref49 = _asyncToGenerator(_regenerator2.default.mark(function _callee49(params) {
	    return _regenerator2.default.wrap(function _callee49$(_context49) {
	      while (1) {
	        switch (_context49.prev = _context49.next) {
	          case 0:
	            return _context49.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_SET_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context49.stop();
	        }
	      }
	    }, _callee49, this);
	  }));
	
	  return function queryBudgetGroupSetList(_x46) {
	    return _ref49.apply(this, arguments);
	  };
	}();
	
	/**
	 * 添加预算组设置
	 */
	
	
	var querySaveBudgetGroupSet = exports.querySaveBudgetGroupSet = function () {
	  var _ref50 = _asyncToGenerator(_regenerator2.default.mark(function _callee50() {
	    return _regenerator2.default.wrap(function _callee50$(_context50) {
	      while (1) {
	        switch (_context50.prev = _context50.next) {
	          case 0:
	            return _context50.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_SET_SAVE));
	
	          case 1:
	          case 'end':
	            return _context50.stop();
	        }
	      }
	    }, _callee50, this);
	  }));
	
	  return function querySaveBudgetGroupSet() {
	    return _ref50.apply(this, arguments);
	  };
	}();
	
	/**
	 * 按季节导入预算设置
	 */
	
	
	var queryBatchImportBudgetGroupSet = exports.queryBatchImportBudgetGroupSet = function () {
	  var _ref51 = _asyncToGenerator(_regenerator2.default.mark(function _callee51(params) {
	    return _regenerator2.default.wrap(function _callee51$(_context51) {
	      while (1) {
	        switch (_context51.prev = _context51.next) {
	          case 0:
	            return _context51.abrupt('return', _http2.default.post(_req.finance.BUDGET_GROUP_SET_BATCHIMPORT, params));
	
	          case 1:
	          case 'end':
	            return _context51.stop();
	        }
	      }
	    }, _callee51, this);
	  }));
	
	  return function queryBatchImportBudgetGroupSet(_x47) {
	    return _ref51.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算组设置明细
	 */
	
	
	var queryImportBudgetGroupSetInfo = exports.queryImportBudgetGroupSetInfo = function () {
	  var _ref52 = _asyncToGenerator(_regenerator2.default.mark(function _callee52(params) {
	    return _regenerator2.default.wrap(function _callee52$(_context52) {
	      while (1) {
	        switch (_context52.prev = _context52.next) {
	          case 0:
	            return _context52.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_SET_DETAIL, params));
	
	          case 1:
	          case 'end':
	            return _context52.stop();
	        }
	      }
	    }, _callee52, this);
	  }));
	
	  return function queryImportBudgetGroupSetInfo(_x48) {
	    return _ref52.apply(this, arguments);
	  };
	}();
	
	/**
	 * 模板下载
	 */
	
	
	var queryTemplateImportBudgetGroupSet = exports.queryTemplateImportBudgetGroupSet = function () {
	  var _ref53 = _asyncToGenerator(_regenerator2.default.mark(function _callee53() {
	    return _regenerator2.default.wrap(function _callee53$(_context53) {
	      while (1) {
	        switch (_context53.prev = _context53.next) {
	          case 0:
	            return _context53.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_SET_TEMPLATE));
	
	          case 1:
	          case 'end':
	            return _context53.stop();
	        }
	      }
	    }, _callee53, this);
	  }));
	
	  return function queryTemplateImportBudgetGroupSet() {
	    return _ref53.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算流水列表
	 */
	
	
	var queryGroupRecordList = exports.queryGroupRecordList = function () {
	  var _ref54 = _asyncToGenerator(_regenerator2.default.mark(function _callee54(params) {
	    return _regenerator2.default.wrap(function _callee54$(_context54) {
	      while (1) {
	        switch (_context54.prev = _context54.next) {
	          case 0:
	            return _context54.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_RECORD_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context54.stop();
	        }
	      }
	    }, _callee54, this);
	  }));
	
	  return function queryGroupRecordList(_x49) {
	    return _ref54.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算流水添加
	 */
	
	
	var queryAddGroupBookList = exports.queryAddGroupBookList = function () {
	  var _ref55 = _asyncToGenerator(_regenerator2.default.mark(function _callee55(params) {
	    return _regenerator2.default.wrap(function _callee55$(_context55) {
	      while (1) {
	        switch (_context55.prev = _context55.next) {
	          case 0:
	            return _context55.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_BOOK_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context55.stop();
	        }
	      }
	    }, _callee55, this);
	  }));
	
	  return function queryAddGroupBookList(_x50) {
	    return _ref55.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算流水添加
	 */
	
	
	var queryAddGroupRecord = exports.queryAddGroupRecord = function () {
	  var _ref56 = _asyncToGenerator(_regenerator2.default.mark(function _callee56(params) {
	    return _regenerator2.default.wrap(function _callee56$(_context56) {
	      while (1) {
	        switch (_context56.prev = _context56.next) {
	          case 0:
	            return _context56.abrupt('return', _http2.default.post(_req.finance.BUDGET_GROUP_RECORD_ADD, params));
	
	          case 1:
	          case 'end':
	            return _context56.stop();
	        }
	      }
	    }, _callee56, this);
	  }));
	
	  return function queryAddGroupRecord(_x51) {
	    return _ref56.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算流水删除
	 */
	
	
	var queryDeleteGroupBook = exports.queryDeleteGroupBook = function () {
	  var _ref57 = _asyncToGenerator(_regenerator2.default.mark(function _callee57(params) {
	    return _regenerator2.default.wrap(function _callee57$(_context57) {
	      while (1) {
	        switch (_context57.prev = _context57.next) {
	          case 0:
	            return _context57.abrupt('return', _http2.default.post(_req.finance.BUDGET_GROUP_RECORD_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context57.stop();
	        }
	      }
	    }, _callee57, this);
	  }));
	
	  return function queryDeleteGroupBook(_x52) {
	    return _ref57.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算流水明细
	 */
	
	
	var queryGroupRecordInfo = exports.queryGroupRecordInfo = function () {
	  var _ref58 = _asyncToGenerator(_regenerator2.default.mark(function _callee58(uuid) {
	    return _regenerator2.default.wrap(function _callee58$(_context58) {
	      while (1) {
	        switch (_context58.prev = _context58.next) {
	          case 0:
	            return _context58.abrupt('return', _http2.default.get(_req.finance.BUDGET_GROUP_RECORD_INFO, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context58.stop();
	        }
	      }
	    }, _callee58, this);
	  }));
	
	  return function queryGroupRecordInfo(_x53) {
	    return _ref58.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算记录修改
	 */
	
	
	var queryUpdateGroupRecord = exports.queryUpdateGroupRecord = function () {
	  var _ref59 = _asyncToGenerator(_regenerator2.default.mark(function _callee59(params) {
	    return _regenerator2.default.wrap(function _callee59$(_context59) {
	      while (1) {
	        switch (_context59.prev = _context59.next) {
	          case 0:
	            return _context59.abrupt('return', _http2.default.post(_req.finance.BUDGET_GROUP_RECORD_UPDATE, params));
	
	          case 1:
	          case 'end':
	            return _context59.stop();
	        }
	      }
	    }, _callee59, this);
	  }));
	
	  return function queryUpdateGroupRecord(_x54) {
	    return _ref59.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算流水统计
	 */
	
	
	var queryBudgetStatistics = exports.queryBudgetStatistics = function () {
	  var _ref60 = _asyncToGenerator(_regenerator2.default.mark(function _callee60(params) {
	    return _regenerator2.default.wrap(function _callee60$(_context60) {
	      while (1) {
	        switch (_context60.prev = _context60.next) {
	          case 0:
	            return _context60.abrupt('return', _http2.default.get(_req.finance.BUDGET_RECORD_STATIS, params));
	
	          case 1:
	          case 'end':
	            return _context60.stop();
	        }
	      }
	    }, _callee60, this);
	  }));
	
	  return function queryBudgetStatistics(_x55) {
	    return _ref60.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算流水统计按月
	 */
	
	
	var queryBudgetStatisticsMonth = exports.queryBudgetStatisticsMonth = function () {
	  var _ref61 = _asyncToGenerator(_regenerator2.default.mark(function _callee61(params) {
	    return _regenerator2.default.wrap(function _callee61$(_context61) {
	      while (1) {
	        switch (_context61.prev = _context61.next) {
	          case 0:
	            return _context61.abrupt('return', _http2.default.get(_req.finance.BUDGET_RECORD_STATIS_MONTH, params));
	
	          case 1:
	          case 'end':
	            return _context61.stop();
	        }
	      }
	    }, _callee61, this);
	  }));
	
	  return function queryBudgetStatisticsMonth(_x56) {
	    return _ref61.apply(this, arguments);
	  };
	}();
	
	/**
	 * 预算流水分摊明细
	 */
	
	
	var queryBudgetApportionInfo = exports.queryBudgetApportionInfo = function () {
	  var _ref62 = _asyncToGenerator(_regenerator2.default.mark(function _callee62(uuid) {
	    return _regenerator2.default.wrap(function _callee62$(_context62) {
	      while (1) {
	        switch (_context62.prev = _context62.next) {
	          case 0:
	            return _context62.abrupt('return', _http2.default.get(_req.finance.BUDGET_APPORTION_LIST, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context62.stop();
	        }
	      }
	    }, _callee62, this);
	  }));
	
	  return function queryBudgetApportionInfo(_x57) {
	    return _ref62.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 31 */
[3004, 45],
/* 32 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This file includes all remote apis.
	 */
	
	var baseUrl = ''; // BaseUrl
	
	var hr = exports.hr = {
	  //* *******************工资管理*****************************
	  CORE_HR_WAGE_LIST: baseUrl + '/api/bszb/hr/wage/org', // 获取组织列表
	  GET_WAGE_LIST: baseUrl + '/api/bszb/hr/wage/list', // 工资记录
	  GET_WAGE_MY: baseUrl + '/api/bszb/hr/wage/my', // 我的工资申请
	  GET_WAGE_CHECK: baseUrl + '/api/bszb/hr/wage/my/check', // 我的工资审核
	  GET_WAGE_RECORD_ORG: baseUrl + '/api/bszb/hr/wage/listByOrg', // 工资记录按单位
	  GET_WAGE_INFO: baseUrl + '/api/bszb/hr/wage/info', // 工资详情
	  WAGE_SAVE: baseUrl + '/api/bszb/hr/wage/save', // 工资保存
	  WAGE_DELETE: baseUrl + '/api/bszb/hr/wage/delete', // 工资删除
	  WAGE_NEXT: baseUrl + '/api/bszb/hr/wage/nextActivity', // 流程审核
	  WAGE_RETURN: baseUrl + '/api/bszb/hr/wage/returnActivity', // 工资流程打回
	  WAGE_CALLBACK: baseUrl + '/api/bszb/hr/wage/callbackActivity', // 工资流程收回
	  WAGE_WORKFLOW: baseUrl + '/api/bszb/hr/wage/workflow', // 工资流程申请流程
	  WAGE_IMPORT: baseUrl + '/api/bszb/hr/wage/import', // 工资明细导入
	  WAGE_STATIC_C_M: baseUrl + '/api/bszb/hr/wage/statisicByCompanyAndMonth', // 工资单月统计
	  WAGE_DETAIL_LIST: baseUrl + '/api/bszb/hr/wage/detail/list', // 工资明细详情
	  WAGE_DETAIL_INFO: baseUrl + '/api/bszb/hr/wage/detail/info', // 工资明细详情
	  WAGE_DETAIL_PERSONAL: baseUrl + '/api/bszb/hr/wage/detail/personal', // 工资条详情
	  WAGE_SEND_ALL: baseUrl + '/api/bszb/hr/wage/detail/sendAll', // 工资条全部发送
	  WAGE_SEND: baseUrl + '/api/bszb/hr/wage/detail/send', // 工资条发送
	  WAGE_BACK: baseUrl + '/api/bszb/hr/wage/detail/back', // 工资条回收
	  DOWNLOAD_WAGE_TEMPLATE: baseUrl + '/api/bszb/hr/wage/template', // 工资条回收
	  WAGE_BACK_ALL: baseUrl + '/api/bszb/hr/wage/detail/backAll', // 工资条全部回收
	  WAGE_STATISTIC: baseUrl + '/api/bszb/hr/wage/statistic', // 公司薪酬统计
	  //* *******************年终奖管理*****************************
	  GET_BONUS_LIST: baseUrl + '/api/bszb/hr/bonus/list', // 年终奖记录
	  GET_BONUS_MY: baseUrl + '/api/bszb/hr/bonus/my', // 我的年终奖申请
	  GET_BONUS_CHECK: baseUrl + '/api/bszb/hr/bonus/my/check', // 我的年终奖审核
	  GET_BONUS_RECORD_ORG: baseUrl + '/api/bszb/hr/bonus/listByOrg', // 年终奖记录按单位
	  GET_BONUS_INFO: baseUrl + '/api/bszb/hr/bonus/info', // 年终奖详情
	  BONUS_SAVE: baseUrl + '/api/bszb/hr/bonus/save', // 年终奖保存
	  BONUS_DELETE: baseUrl + '/api/bszb/hr/bonus/delete', // 年终奖保存
	  BONUS_NEXT: baseUrl + '/api/bszb/hr/bonus/nextActivity', // 流程审核
	  BONUS_RETURN: baseUrl + '/api/bszb/hr/bonus/returnActivity', // 年终奖流程打回
	  BONUS_CALLBACK: baseUrl + '/api/bszb/hr/bonus/callbackActivity', // 年终奖流程收回
	  BONUS_WORKFLOW: baseUrl + '/api/bszb/hr/bonus/workflow', // 年终奖流程申请流程
	  BONUS_IMPORT: baseUrl + '/api/bszb/hr/bonus/import', // 年终奖明细导入
	  BONUS_STATIC_C_M: baseUrl + '/api/bszb/hr/bonus/statisticByCompanyAndYear', // 年终奖单月统计
	  BONUS_DETAIL_LIST: baseUrl + '/api/bszb/hr/bonus/detail/list', // 年终奖明细详情
	  BONUS_DETAIL_INFO: baseUrl + '/api/bszb/hr/bonus/detail/info', // 年终奖明细详情
	  BONUS_SEND_ALL: baseUrl + '/api/bszb/hr/bonus/detail/sendAll', // 年终奖条全部发送
	  BONUS_SEND: baseUrl + '/api/bszb/hr/bonus/detail/send', // 年终奖条发送
	  BONUS_BACK: baseUrl + '/api/bszb/hr/bonus/detail/back', // 年终奖条回收
	  DOWNLOAD_BONUS_TEMPLATE: baseUrl + '/api/bszb/hr/bonus/template', // 工资条回收
	  BONUS_BACK_ALL: baseUrl + '/api/bszb/hr/bonus/detail/backAll', // 年终奖条全部回收
	
	  HR_WORKORG_SEARCH: baseUrl + '/api/bszb/hr/workOrg/search', // 业务部门列表,
	  HR_WORKORG_SAVE: baseUrl + '/api/bszb/hr/workOrg/save', // 保存业务部门列表,
	  HR_WORKORG_DELETE: baseUrl + '/api/bszb/hr/workOrg/delete', // 删除业务部门列表,
	  HR_WORKORG_LIST: baseUrl + '/api/bszb/hr/workOrg/list', // 业务部门列表,
	  HR_WORKORG_HR_LIST: baseUrl + '/api/bszb/hr/workOrg/hr/list', // 业务部门关联的人员
	  HR_WORKORG_HR_SAVE: baseUrl + '/api/bszb/hr/workOrg/hr/save', // 业务部门关联用户
	  HR_WORKORG_HR_DELETE: baseUrl + '/api/bszb/hr/workOrg/hr/delete', // 业务部门删除关联用户
	  HR_WORKORG_HR_DELETES: baseUrl + '/api/bszb/hr/workOrg/hr/deletes', // 业务部门删除关联用户
	
	  // 员工管理
	  HR_LIST: baseUrl + '/api/bszb/hr/list', // 人员列表
	  HR_INFO: baseUrl + '/api/bszb/hr/info', // 人员信息
	  HR_REGISTER: baseUrl + '/api/bszb/hr/register', // 注册账号
	  HR_SAVE: baseUrl + '/api/bszb/hr/save', // 保存帐号
	  HR_DISABLE: baseUrl + '/api/bszb/hr/disable', // 用户禁用
	  HR_ENABLE: baseUrl + '/api/bszb/hr/enable', // 用户启用
	  HR_RESET_PWD: baseUrl + '/api/bszb/hr/resetPwd', // 帐号重置密码
	  HR_EXPORT: baseUrl + '/api/bszb/hr/export', // 用户导出
	  HR_IMPORT: baseUrl + '/api/bszb/hr/import', // 用户导入
	  HR_DELETE: baseUrl + '/api/bszb/hr/delete', // 用户删除
	  DOWNLOAD_HR_TEMPLATE: baseUrl + '/api/bszb/hr/template' // 下载用户导入模板
	};
	
	var finance = exports.finance = {
	  /** 资金流水记录 */
	  INCOME_CUSTOM_RELATE: baseUrl + '/api/bszb/finance/books/income/custom/relate', // 资金关联客户
	  BUDGET_GROUP_SET_AIMS: baseUrl + '/api/bszb/finance/budget/group/set/aim/save', // 预算目标收入设置
	  BUDGET_GROUP_GET_AIMS: baseUrl + '/api/bszb/finance/budget/group/set/aim/info', // 获得预算目标收入
	
	  /** 预算调整 */
	  BUDGET_GET_ADJUST_MY: baseUrl + '/api/bszb/finance/budget/group/set/adjustment/my', // 我的预算添加流程
	  BUDGET_GET_ADJUST_WATCH: baseUrl + '/api/bszb/finance/budget/group/set/adjustment/list', // 预算添加流程列表
	  BUDGET_GET_ADJUSTABLE: baseUrl + '/api/bszb/finance/budget/group/set/adjustment/adjustable', // 预算调整可调整金额
	  BUDGET_GET_ACCOUNT: baseUrl + '/api/bszb/finance/budget/group/account/list', // 预算列表余额明细
	  BUDGET_GET_ADJUSTMENT_WORKFLOW: baseUrl + '/api/bszb/finance/budget/group/set/adjustment/workflow', // 预算发起流程显示
	  BUDGET_GET_ADJUSTMENT_INFO: baseUrl + '/api/bszb/finance/budget/group/set/adjustment/info', // 预算调整编辑获得明细
	  BUDGET_ADJUSTMENT_SAVE: baseUrl + '/api/bszb/finance/budget/group/set/adjustment/save', // 预算调整保存
	  BUDGET_ADJUSTMENT_DELETE: baseUrl + '/api/bszb/finance/budget/group/set/adjustment/delete', // 预算调整删除
	  BUDGET_ADJUSTMENT_NEXT: baseUrl + '/api/bszb/finance/budget/group/set/adjustment/nextActivity', // 预算调整流程审核
	  BUDGET_ADJUSTMENT_RETURN: baseUrl + '/api/bszb/finance/budget/group/set/adjustment/returnActivity', // 预算调整流程打回
	  BUDGET_ADJUSTMENT_CALLBACK: baseUrl + '/api/bszb/finance/budget/group/set/adjustment/callbackActivity', // 预算调整流程收回
	
	  /** 预算设置 */
	  BUDGET_GET_SET_MY: baseUrl + '/api/bszb/finance/budget/group/set/new/my', // 我的预算设置流程
	  BUDGET_GET_SET_WATCH: baseUrl + '/api/bszb/finance/budget/group/set/new/list', // 预设置流程列表
	  BUDGET_GET_SET_INFO: baseUrl + '/api/bszb/finance/budget/group/set/new/info', // 预算设置详情
	  BUDGET_SET_SAVE: baseUrl + '/api/bszb/finance/budget/group/set/new/save', // 预算设置保存
	  BUDGET_SET_DELETE: baseUrl + '/api/bszb/finance/budget/group/set/new/delete', // 预算设置删除
	  BUDGET_GET_SET_WORKFLOW: baseUrl + '/api/bszb/finance/budget/group/set/new/workflow', // 预算设置流程申请流程
	  BUDGET_SET_NEXT: baseUrl + '/api/bszb/finance/budget/group/set/new/nextActivity', // 流程审核
	  BUDGET_SET_RETURN: baseUrl + '/api/bszb/finance/budget/group/set/new/returnActivity', // 预算设置流程打回
	  BUDGET_SET_CALLBACK: baseUrl + '/api/bszb/finance/budget/group/set/new/callbackActivity', // 预算设置流程收回
	  DOWNLOAD_GROUP_SET_TEMPLATE: baseUrl + '/api/bszb/finance/budget/group/set/template', // 预算设置模板
	
	  /** 收支分析 */
	  BUDGET_GET_ANALYSIS: baseUrl + '/api/bszb/finance/budget/group/statistics/analysis', // 收支分析
	  BUDGET_GET_ANALYSIS_INCOME: baseUrl + '/api/bszb/finance/budget/group/statistics/analysis/income', // 收入分析明细
	  BUDGET_GET_ANALYSIS_INCOME_EXPORT: baseUrl + '/api/bszb/finance/budget/group/statistics/analysis/income/export', // 收入分析明细
	  BUDGET_GET_ANALYSIS_FUNDS: baseUrl + '/api/bszb/finance/budget/group/statistics/analysis/funds/type', // 财务数据分析
	  BUDGET_GET_ANALYSIS_FUNDS_MONTH: baseUrl + '/api/bszb/finance/budget/group/statistics/analysis/funds/month', // 财务数据分析月份
	
	  BUDGET_GET_ANALYSIS_EXPENDITURE: baseUrl + '/api/bszb/finance/budget/group/statistics/analysis/expenditure', // 支出分析明细
	  BUDGET_GET_ANALYSIS_BUDGET: baseUrl + '/api/bszb/finance/budget/group/statistics/analysis/budget/type', // 财务数据分析
	  BUDGET_GET_ANALYSIS_BUDGET_MONTH: baseUrl + '/api/bszb/finance/budget/group/statistics/analysis/budget/month', // 财务数据分析月份
	  BUDGET_GET_ANALYSIS_BUDGETS: baseUrl + '/api/bszb/finance/budget/group/statistics/record', // 收支分析预算统计
	  BUDGET_GET_ANALYSIS_OPERATIONAL: baseUrl + '/api/bszb/finance/budget/group/statistics/operational/report', // 收支分析运营报表
	  BUDGET_GET_ANALYSIS_OPERATIONAL_DETAIL: baseUrl + '/api/bszb/finance/budget/group/statistics/operational/report/detail', // 收支分析运营报表详情
	  BUDGET_GET_ANALYSIS_PROFIT: baseUrl + '/api/bszb/finance/budget/group/statistics/profit', // 收支分析利润追踪
	  BUDGET_GET_ANALYSIS_PROFIT_DETAIL: baseUrl + '/api/bszb/finance/budget/group/statistics/profit/detail', // 收支分析利润追踪列表
	  BUDGET_GET_ANALYSIS_EXPENDITURE_EXPORT: baseUrl + '/api/bszb/finance/budget/group/statistics/analysis/expenditure/export', // 导出
	  /* ----------------------财务管理----------------------------------------------------------------------------------*/
	  //* *******************资金管理*****************************
	  //* *****资金账号管理**********
	  FINANCE_BOOKS_LIST: baseUrl + '/api/bszb/finance/books/list', // 账号列表,
	  FINANCE_BOOKS_INFO: baseUrl + '/api/bszb/finance/books/info', // 账号明细,
	  FINANCE_BOOKS_SAVE: baseUrl + '/api/bszb/finance/books/save', // 账号保存,
	  FINANCE_BOOKS_EDIT: baseUrl + '/api/bszb/finance/books/edit', // 账号保存,
	  FINANCE_BOOKS_DELETE: baseUrl + '/api/bszb/finance/books/delete', // 账号删除
	  FINANCE_BOOKS_List_STATISTICS: baseUrl + '/api/bszb/finance/books/list/statistics', // 账号统计
	  FINANCE_BOOKS_STATISTICS: baseUrl + '/api/bszb/finance/books/statistics', // 账号统计
	  FINANCE_BOOKS_ORG: baseUrl + '/api/bszb/finance/books/all', // 有账号的公司列表,
	  FINANCE_BOOKS_ORG_LIST: baseUrl + '/api/bszb/finance/books/listByGroupUuids', // 有账号的公司列表(通过预算组选择)
	  FINANCE_BOOKS_CHECK_ERR: baseUrl + '/api/bszb/finance/books/checkAmountErr', // 检查账户余额统计,
	  //* *****资金流水管理**********
	  BOOKS_INCOME_LIST: baseUrl + '/api/bszb/finance/books/income/list', // 账号流水列表
	  BOOKS_INCOME_REMOVE_LIST: baseUrl + '/api/bszb/finance/books/income/remove/list', // 账号已删除流水列表
	  BOOKS_INCOME_INFO: baseUrl + '/api/bszb/finance/books/income/info', // 账号流水详情
	  BOOKS_INCOME_SAVE: baseUrl + '/api/bszb/finance/books/income/save', // 账号流水保存
	  BOOKS_INCOME_DELETE: baseUrl + '/api/bszb/finance/books/income/delete', // 账号流水删除
	  BOOKS_INCOME_DELETES: baseUrl + '/api/bszb/finance/books/income/deletes', // 账号流水删除(多选)
	  BOOKS_INCOME_IMPORT: baseUrl + '/api/bszb/finance/books/income/import', // 银行流水导入
	  BOOKS_INCOME_NON_BUSINESS: baseUrl + '/api/bszb/finance/books/income/nonBusiness', // 账号列表,
	
	  BOOKS_MANAUL_SAVE: baseUrl + '/api/bszb/finance/books/manual/save', // 实际流水记录保存
	  BOOKS_MANAUL_LIST: baseUrl + '/api/bszb/finance/books/manual/list', // 实际流水记录列表
	  BOOKS_MANAUL_DELETE: baseUrl + '/api/bszb/finance/books/manual/delete', // 实际流水记录删除
	  //* *****资金统计**************
	  FINANCE_INCOME_STATISTICS: baseUrl + '/api/bszb/finance/books/income/statistics', // 资金统计
	  FINANCE_OPERATIONAL_STATISTICS: baseUrl + '/api/bszb/finance/books/income/operational/report', // 资金运营统计
	  FINANCE_OPERATIONAL_STATISTICS_DETAIL: baseUrl + '/api/bszb/finance/books/income/operational/report/detail', // 资金运营统计按年统计
	  FINANCE_INCOME_PAY_STATISTICS: baseUrl + '/api/bszb/finance/books/income/pay/statistics', // 走账数据统计
	  FINANCE_BUDGET_EXPEND: baseUrl + '/api/bszb/finance/budget/type/list', // 预算类目列表
	  FINANCE_INCOME_DETAIL: baseUrl + '/api/bszb/finance/books/income/statistics/detail', // 资金统计
	
	  FINANCE_STATISTICS_BALANCE: baseUrl + '/api/bszb/finance/books/income/statistics/balance', // 帐号余额统计
	  FINANCE_STATISTICS_PRECIPITATION: baseUrl + '/api/bszb/finance/books/income/statistics/precipitation', // 客户沉淀金
	  FINANCE_STATISTICS_BUSINESS_INCOME: baseUrl + '/api/bszb/finance/books/income/statistics/business/income', // 业务收入支出
	  FINANCE_STATISTICS_BUSINESS_INCOME_DETAIL: baseUrl + '/api/bszb/finance/books/income/statistics/business/income/detail', // 业务收入明细
	  //* *******************资金帐号(现金帐,数字货币,股票)管理*****************************
	
	  //* *****资金统计**************
	
	  FUNDS_BOOK_LIST: baseUrl + '/api/bszb/finance/funds/book/list', // 账号列表,
	  FUNDS_BOOK_LIST_ALL: baseUrl + '/api/bszb/finance/funds/book/listAll', // 账号所有列表,
	  FUNDS_BOOK_INFO: baseUrl + '/api/bszb/finance/funds/book/info', // 账号明细,
	  FUNDS_BOOK_SAVE: baseUrl + '/api/bszb/finance/funds/book/save', // 账号保存,
	  FUNDS_BOOK_ENABLE: baseUrl + '/api/bszb/finance/funds/book/enable', // 账号启用,
	  FUNDS_BOOK_DISABLE: baseUrl + '/api/bszb/finance/funds/book/disable', // 账号禁用,
	  FUNDS_BOOK_DELETE: baseUrl + '/api/bszb/finance/funds/book/delete', // 账号删除
	  FUNDS_BOOK_STATISTICS: baseUrl + '/api/bszb/finance/funds/book/statistics', // 账号统计
	  //* *****资金流水管理**********
	  FUNDS_RECORD_LIST: baseUrl + '/api/bszb/finance/funds/record/list', // 账号流水列表,
	  FUNDS_RECORD_INFO: baseUrl + '/api/bszb/finance/funds/record/info', // 账号流水列表,
	  FUNDS_RECORD_SAVE: baseUrl + '/api/bszb/finance/funds/record/save', // 账号流水列表,
	  FUNDS_RECORD_RELATE: baseUrl + '/api/bszb/finance/funds/record/relate', // 帐号流水关联银行流水,
	  FUNDS_RECORD_IMPORT: baseUrl + '/api/bszb/finance/funds/record/import', // 银行流水导入,
	  FUNDS_RECORD_INCOME: baseUrl + '/api/bszb/finance/funds/record/income', // 未关联的资金记录,
	  DOWNLOAD_FUNDS_RECORD_TEMPLATE: baseUrl + 'api/bszb/finance/funds/record/template', // 资金帐号模板,
	
	  /* ----------------------budget-------------------------------------------------------------------------------*/
	  //* *****预算组管理****************
	  BUDGET_GROUP_SUM: baseUrl + '/api/bszb/finance/budget/group/statistics/sum', // 预算管理的总计
	  BUDGET_GROUP_LIST: baseUrl + '/api/bszb/finance/budget/group/list', // 预算组列表,
	  BUDGET_GROUP_PER_LIST: baseUrl + '/api/bszb/finance/budget/group/personalList', // 预算组列表,
	  BUDGET_GROUP_INFO: baseUrl + '/api/bszb/finance/budget/group/info', // 预算组明细,
	  BUDGET_GROUP_SAVE: baseUrl + '/api/bszb/finance/budget/group/save', // 预算组保存,
	  BUDGET_GROUP_MY: baseUrl + '/api/bszb/finance/budget/group/my/project', // 我的项目预算,
	
	  BUDGET_GROUP_SET_LIST: baseUrl + '/api/bszb/finance/budget/group/set/list', // 预算组设置列表,
	  BUDGET_GROUP_SET_SAVE: baseUrl + '/api/bszb/finance/budget/group/set/save', // 添加预算组设置,
	  BUDGET_GROUP_SET_BATCHIMPORT: baseUrl + '/api/bszb/finance/budget/group/set/batchImport', // 按季节导入预算设置,
	  BUDGET_GROUP_SET_DETAIL: baseUrl + '/api/bszb/finance/budget/group/set/detail', // 预算设置明细,
	  BUDGET_GROUP_SET_TEMPLATE: baseUrl + '/api/bszb/finance/budget/group/set/template', // 模板下载,
	
	  BUDGET_GROUP_RECORD_LIST: baseUrl + '/api/bszb/finance/budget/group/record/list', // 预算流水列表,
	  BUDGET_GROUP_BOOK_LIST: baseUrl + '/api/bszb/finance/budget/group/record/book/list', // 预算流水列表,
	  BUDGET_GROUP_RECORD_ADD: baseUrl + '/api/bszb/finance/budget/group/record/add', // 预算流水添加,
	  BUDGET_GROUP_RECORD_INFO: baseUrl + '/api/bszb/finance/budget/group/record/info', // 预算流水明细,
	  BUDGET_GROUP_RECORD_DELETE: baseUrl + '/api/bszb/finance/budget/group/record/delete', // 预算流水删除,
	  BUDGET_GROUP_RECORD_UPDATE: baseUrl + '/api/bszb/finance/budget/group/record/update', // 预算记录修改,
	
	  BUDGET_APPORTION_LIST: baseUrl + '/api/bszb/finance/budget/apportion/info', // 预算流水列表,
	  BUDGET_RECORD_STATIS_MONTH: baseUrl + '/api/bszb/finance/budget/group/statistics/record/month', // 预算流水统计按月
	  BUDGET_RECORD_STATIS: baseUrl + '/api/bszb/finance/budget/group/record/statistics', // 预算流水统计
	  FINANCE_EXPORT: baseUrl + '/api/bszb/finance/budget/group/statistics/analysis/income/export', // 导出
	
	  BUDGET_GRUOP_ENABLE: baseUrl + '/api/bszb/finance/budget/group/enable', // 预算组启用,
	  BUDGET_GRUOP_DISABLE: baseUrl + '/api/bszb/finance/budget/group/disable', // 预算组禁用,
	  BUDGET_GRUOP_GETCAF: baseUrl + '/api/bszb/finance/budget/group/currentAndFreeze', // 获取当前预算组的当前余额与冻结金额
	  CAPITAL_ENABLE: baseUrl + '/api/bszb/finance/books/enable', // 资金账户启用,
	  CAPITAL_DISABLE: baseUrl + '/api/bszb/finance/books/disable', // 资金账户禁用,
	
	  //* *******************报销*****************************
	  GET_RECOUP_LIST: baseUrl + '/api/bszb/finance/recoup/list', // 报销记录
	  GET_RECOUP_MY: baseUrl + '/api/bszb/finance/recoup/my', // 我的报销申请
	  GET_RECOUP_CHECK: baseUrl + '/api/bszb/finance/recoup/my/check', // 我的报销审核
	  GET_RECOUP_STATIC_ORG: baseUrl + '/api/bszb/finance/recoup/statisticByOrg', // 报销统计按单位
	  GET_RECOUP_STATIC_INCUBATOR: baseUrl + '/api/bszb/finance/recoup/statisticByIncubator', // 报销统计按孵化器
	  GET_RECOUP_RECORD_ORG: baseUrl + '/api/bszb/finance/recoup/listByOrg', // 报销记录按单位
	  GET_RECOUP_INFO: baseUrl + '/api/bszb/finance/recoup/info', // 报销详情
	  RECOUP_SAVE: baseUrl + '/api/bszb/finance/recoup/save', // 报销保存
	  RECOUP_DELETE: baseUrl + '/api/bszb/finance/recoup/delete', // 报销删除
	  RECOUP_NEXT: baseUrl + '/api/bszb/finance/recoup/nextActivity', // 流程审核
	  RECOUP_RETURN: baseUrl + '/api/bszb/finance/recoup/returnActivity', // 报销流程打回
	  RECOUP_CALLBACK: baseUrl + '/api/bszb/finance/recoup/callbackActivity', // 报销流程收回
	  RECOUP_WORKFLOW: baseUrl + '/api/bszb/finance/recoup/workflow', // 报销流程申请流程
	
	  //* *******************付款*****************************
	  GET_PAYMENT_LIST: baseUrl + '/api/bszb/finance/payment/list', // 付款记录
	  GET_PAYMENT_MY: baseUrl + '/api/bszb/finance/payment/my', // 我的付款申请
	  GET_PAYMENT_CHECK: baseUrl + '/api/bszb/finance/payment/my/check', // 我的付款审核
	  GET_PAYMENT_STATIC_ORG: baseUrl + '/api/bszb/finance/payment/statisticByOrg', // 付款统计按单位
	  GET_PAYMENT_STATIC_INCUBATOR: baseUrl + '/api/bszb/finance/payment/statisticByIncubator', // 付款统计按孵化器
	  GET_PAYMENT_RECORD_ORG: baseUrl + '/api/bszb/finance/payment/listByOrg', // 付款记录按单位
	  GET_PAYMENT_INFO: baseUrl + '/api/bszb/finance/payment/info', // 付款详情
	  PAYMENT_SAVE: baseUrl + '/api/bszb/finance/payment/save', // 付款保存
	  PAYMENT_DELETE: baseUrl + '/api/bszb/finance/payment/delete', // 付款保存
	  PAYMENT_NEXT: baseUrl + '/api/bszb/finance/payment/nextActivity', // 流程审核
	  PAYMENT_RETURN: baseUrl + '/api/bszb/finance/payment/returnActivity', // 付款流程打回
	  PAYMENT_CALLBACK: baseUrl + '/api/bszb/finance/payment/callbackActivity', // 付款流程收回
	  PAYMENT_WORKFLOW: baseUrl + '/api/bszb/finance/payment/workflow', // 付款流程申请流程
	  PAYMENT_INCOMEPART: baseUrl + '/api/bszb/finance/payment/listByIncomepart', // 付款方的付款记录
	
	  //* *******************借款*****************************
	  GET_LOAN_LIST: baseUrl + '/api/bszb/finance/loan/list', // 借款记录
	  GET_LOAN_MY: baseUrl + '/api/bszb/finance/loan/my', // 我的借款申请
	  GET_LOAN_CHECK: baseUrl + '/api/bszb/finance/loan/my/check', // 我的借款审核
	  GET_LOAN_STATIC_ORG: baseUrl + '/api/bszb/finance/loan/statisticByOrg', // 借款统计按单位
	  GET_LOAN_STATIC_INCUBATOR: baseUrl + '/api/bszb/finance/loan/statisticByIncubator', // 借款统计按孵化器
	  GET_LOAN_RECORD_ORG: baseUrl + '/api/bszb/finance/loan/listByOrg', // 借款记录按单位
	  GET_LOAN_INFO: baseUrl + '/api/bszb/finance/loan/info', // 借款详情
	  LOAN_SAVE: baseUrl + '/api/bszb/finance/loan/save', // 借款保存
	  LOAN_DELETE: baseUrl + '/api/bszb/finance/loan/delete', // 借款删除
	  LOAN_NEXT: baseUrl + '/api/bszb/finance/loan/nextActivity', // 流程审核
	  LOAN_RETURN: baseUrl + '/api/bszb/finance/loan/returnActivity', // 借款流程打回
	  LOAN_CALLBACK: baseUrl + '/api/bszb/finance/loan/callbackActivity', // 借款流程收回
	  LOAN_WORKFLOW: baseUrl + '/api/bszb/finance/loan/workflow', // 借款流程申请流程
	  GET_LOAN_WRITE_INFO: baseUrl + '/api/bszb/finance/loan/write/off/info', // 借款核销详情
	  LOAN_WRITE_SAVE: baseUrl + '/api/bszb/finance/loan/write/off/save', // 借款保存
	
	  //* *******************开票*****************************
	  GET_INVOICE_LIST: baseUrl + '/api/bszb/finance/invoice/list', // 开票记录
	  GET_INVOICE_MY: baseUrl + '/api/bszb/finance/invoice/my', // 我的开票申请
	  GET_INVOICE_CHECK: baseUrl + '/api/bszb/finance/invoice/my/check', // 我的开票审核
	  GET_INVOICE_STATIC_ORG: baseUrl + '/api/bszb/finance/invoice/statisticByOrg', // 开票统计按单位
	  GET_INVOICE_STATIC_INCUBATOR: baseUrl + '/api/bszb/finance/invoice/statisticByIncubator', // 开票统计按孵化器
	  GET_INVOICE_RECORD_ORG: baseUrl + '/api/bszb/finance/invoice/listByOrg', // 开票记录按单位
	  GET_INVOICE_INFO: baseUrl + '/api/bszb/finance/invoice/info', // 开票详情
	  FINANCE_INVOICE_SAVE: baseUrl + '/api/bszb/finance/invoice/save', // 开票保存
	  FINANCE_INVOICE_DELETE: baseUrl + '/api/bszb/finance/invoice/delete', // 开票删除
	  FINANCE_INVOICE_NEXT: baseUrl + '/api/bszb/finance/invoice/nextActivity', // 流程审核
	  FINANCE_INVOICE_RETURN: baseUrl + '/api/bszb/finance/invoice/returnActivity', // 开票流程打回
	  FINANCE_INVOICE_CALLBACK: baseUrl + '/api/bszb/finance/invoice/callbackActivity', // 开票流程收回
	  FINANCE_INVOICE_WORKFLOW: baseUrl + '/api/bszb/finance/invoice/workflow', // 开票流程申请流程
	  FINANCE_INVOICE_INVALID: baseUrl + '/api/bszb/finance/invoice/invalid', // 发票作废
	
	  //* *******************平台划款*****************************
	  GET_PLATFORM_TRANSFER_LIST: baseUrl + '/api/bszb/finance/platform/transfer/list', // 平台划款记录
	  GET_PLATFORM_TRANSFER_MY: baseUrl + '/api/bszb/finance/platform/transfer/my', // 我的平台划款申请
	  GET_PLATFORM_TRANSFER_CHECK: baseUrl + '/api/bszb/finance/platform/transfer/my/check', // 我的平台划款审核
	  GET_PLATFORM_TRANSFER_STATIC_ORG: baseUrl + '/api/bszb/finance/platform/transfer/statisticByOrg', // 平台划款统计按单位
	  GET_PLATFORM_TRANSFER_RECORD_ORG: baseUrl + '/api/bszb/finance/platform/transfer/listByOrg', // 平台划款记录按单位
	  GET_PLATFORM_TRANSFER_INFO: baseUrl + '/api/bszb/finance/platform/transfer/info', // 平台划款详情
	  PLATFORM_TRANSFER_SAVE: baseUrl + '/api/bszb/finance/platform/transfer/save', // 平台划款保存
	  PLATFORM_TRANSFER_DELETE: baseUrl + '/api/bszb/finance/platform/transfer/delete', // 平台划款删除
	  PLATFORM_TRANSFER_NEXT: baseUrl + '/api/bszb/finance/platform/transfer/nextActivity', // 流程审核
	  PLATFORM_TRANSFER_RETURN: baseUrl + '/api/bszb/finance/platform/transfer/returnActivity', // 平台划款流程打回
	  PLATFORM_TRANSFER_CALLBACK: baseUrl + '/api/bszb/finance/platform/transfer/callbackActivity', // 平台划款流程收回
	  PLATFORM_TRANSFER_WORKFLOW: baseUrl + '/api/bszb/finance/platform/transfer/workflow', // 平台划款流程申请流程
	
	  //* *******************分摊*****************************
	  GET_APPORTION_ORIGIN: baseUrl + '/api/bszb/finance/budget/apportion/origin', // 预算分摊来源
	  GET_APPORTION_LIST: baseUrl + '/api/bszb/finance/budget/apportion/list', // 分摊列表
	  GET_APPORTION_INFO: baseUrl + '/api/bszb/finance/budget/apportion/info', // 分摊列表
	  SAVE_APPORTION: baseUrl + '/api/bszb/finance/budget/apportion/save', // 分摊保存
	  SAVE_APPORTION_DETAIL: baseUrl + '/api/bszb/finance/budget/apportion/save/detail', // 分摊保存
	  APPORTION_DELETE_DETAIL: baseUrl + '/api/bszb/finance/budget/apportion/delete/detail', // 分摊方案明细删除
	  APPORTION_CHECK_DETAIL: baseUrl + '/api/bszb/finance/budget/apportion/detail/check', // 分摊方案明细审核
	  APPORTION_ISPUBLIC: baseUrl + '/api/bszb/finance/budget/apportion/isPublic', // 资金类型是否可以公摊
	  APPORTION_DELETE: baseUrl + '/api/bszb/finance/budget/apportion/delete', // 分摊方案删除
	  APPORTION_TONO: baseUrl + '/api/bszb/finance/budget/apportion/no', // 不分摊
	  APPORTION_TORESTORE: baseUrl + '/api/bszb/finance/budget/apportion/restore', // 恢复分摊
	
	  // ********************公司账户信息****************
	  GET_BOOKINFO_LIST: baseUrl + '/api/bszb/finance/bookInfo/list', // 公司账户信息列表
	  GET_BOOKINFO_INFO: baseUrl + '/api/bszb/finance/bookInfo/info', // 公司账户信息详情
	  SAVE_BOOKINFO: baseUrl + '/api/bszb/finance/bookInfo/save', // 保存公司账户信息
	  DELETE_BOOKINFO: baseUrl + '/api/bszb/finance/bookInfo/delete', // 删除公司账户信息
	  ABLE_BOOKINFO: baseUrl + '/api/bszb/finance/bookInfo/able', // 启用禁用公司账户信息
	
	  // ********************公司回单卡记录****************
	  GET_RECEIPT_LIST: baseUrl + '/api/bszb/finance/receipt/list', // 公司回单卡记录列表
	  GET_RECEIPT_INFO: baseUrl + '/api/bszb/finance/receipt/info', // 公司回单卡记录详情
	  SAVE_RECEIPT: baseUrl + '/api/bszb/finance/receipt/save', // 保存公司回单卡记录
	  DELETE_RECEIPT: baseUrl + '/api/bszb/finance/receipt/delete', // 删除公司回单卡记录
	  ABLE_RECEIPT: baseUrl + '/api/bszb/finance/receipt/able', // 启用禁用公司回单卡记录
	  IMPORT_RECEIPT: baseUrl + '/api/bszb/finance/receipt/import', // 导入公司回单卡记录
	  DOWNLOAD_RECEIPT_TEMPLATE: baseUrl + '/api/bszb/finance/receipt/template' // 导入公司回单卡记录
	};
	var xxcrm = exports.xxcrm = {
	  //* ***********************合同******************************
	  CONTRACT_LIST: baseUrl + '/api/contract/list', // 获取合同列表,
	  CONTRACT_LOG: baseUrl + '/api/contract/log/list', // 获取操作日志,
	  CONTRACT_SAVE: baseUrl + '/api/contract/save', // 添加合同,
	  CONTRACT_BATCHSAVE: baseUrl + '/api/contract/batchSave', // 批量添加合同,
	  CONTRACT_DELETE: baseUrl + '/api/contract/delete', // 删除合同,
	  CONTRACT_USE: baseUrl + '/api/contract/use', // 使用合同,
	  CONTRACT_ALLOT: baseUrl + '/api/contract/assignation', // 分配合同,
	  CONTRACT_TRANSFER: baseUrl + '/api/contract/transfer', // 转移合同,
	  CONTRACT_INVALID: baseUrl + '/api/contract/invalid', // 作废合同,
	  CONTRACT_LOST: baseUrl + '/api/contract/lost', // 遗失合同,
	  CONTRACT_RESTORE: baseUrl + '/api/contract/restore', // 恢复合同,
	  CONTRACT_RECYCLE: baseUrl + '/api/contract/recycle', // 回收合同,
	  CONTRACT_APPLY_SAVE: baseUrl + '/api/contract/apply/save', // 合同申请,
	  CONTRACT_APPLY_LIST: baseUrl + '/api/contract/apply/list', // 合同申请,
	  CONTRACT_APPLY_ALLOT: baseUrl + '/api/contract/apply/assignation', // 分配合同申请的合同,
	  CONTRACT_APPLY_MY: baseUrl + '/api/contract/apply/my', // 我的合同申请列表,
	  CONTRACT_TYPE: baseUrl + '/api/core/dict/contract/type/list', // 合同类型列表
	  CONTRACT_CHECK: baseUrl + '/api/contract/check', // 同意审核操作
	  CONTRACT_REFUSE: baseUrl + '/api/contract/refuse', // 拒绝审核操作
	  CONTRACT_EXPORT: baseUrl + '/api/contract/export', // 导出
	  CONTRACT_TRANSFER_CONFIRM: baseUrl + '/api/contract/transfer/confirm', // 确认合同转移
	  CONTRACT_TRANSFER_REFUSE: baseUrl + '/api/contract/transfer/refuse', // 拒绝合同转移
	  //* ********************客户查询****************************
	  CUSTOM_LIST: baseUrl + '/api/xxcrm/customer/list', // 客户查询
	  //* ********************客户保护****************************
	  CUSTOM_PROTECTION_LIST: baseUrl + '/api/custom/protection/list', // 保护的客户列表,
	  CUSTOM_PROTECTION_HISTORY: baseUrl + '/api/custom/protection/history', // 保护的客户列表,
	  CUSTOM_PROTECTION_SEARCH: baseUrl + '/api/custom/protection/search', // 保护客户查询,
	  CUSTOM_PROTECTION_SAVE: baseUrl + '/api/custom/protection/save', // 添加客户保护,
	  CUSTOM_PROTECTION_INFO: baseUrl + '/api/custom/protection/info', // 客户保护明细,
	  CUSTOM_PROTECTION_RENEWAL: baseUrl + '/api/custom/protection/renewal', // 续保,
	  CUSTOM_PROTECTION_CANCEL: baseUrl + '/api/custom/protection/cancel', // 取消续保,
	  ORDER_LIST: baseUrl + '/api/xxcrm/order/list', // 订单列表,
	  ORDER_INFO: baseUrl + '/api/xxcrm/order/info', // 订单明细,
	  //* *******************发票管理*****************************
	  INVOICE_LIST: baseUrl + '/api/xxcrm/invoice/list', // 发票列表,
	  INVOICE_SAVE: baseUrl + '/api/xxcrm/invoice/save', // 发票添加,
	  INVOICE_USE: baseUrl + '/api/xxcrm/invoice/use', // 发票使用,
	  INVOICE_RESTORE: baseUrl + '/api/xxcrm/invoice/restore', // 发票恢复,
	  INVOICE_INVALID: baseUrl + '/api/xxcrm/invoice/invalid', // 发票作废
	  INVOICE_RED: baseUrl + '/api/xxcrm/invoice/red', // 发票冲红,
	  INVOICE_EXPORT: baseUrl + '/api/xxcrm/invoice/export', // 发票导出,
	  INVOICE_DELETE: baseUrl + '/api/xxcrm/invoice/delete', // 发票删除,
	  INVOICE_USE_EDIT: baseUrl + '/api/xxcrm/invoice/useEdit'
	};
	// 项目管理
	var project = exports.project = {
	  GET_PROTECTION_LIST: baseUrl + '/api/bszb/project/info/list', // 项目列表
	  GET_PROTECTION_INFO: baseUrl + '/api/bszb/project/info/info', // 项目详情
	  AGREE_PROTECTION: baseUrl + '/api/bszb/project/info/agree', // 同意
	  REFUSE_PROTECTION: baseUrl + '/api/bszb/project/info/refuse' // 拒绝
	};
	var core = exports.core = {
	  /** 字典列表 */
	  DICT_INVOICE_TYPE: baseUrl + '/api/core/dict/invoice/type', // 合同详情
	  DICT_INVOICE_CONTENT: baseUrl + '/api/core/dict/invoice/content', // 获取开票内容
	  DICT_ICHAPTERAPP_TYPE: baseUrl + '/api/core/dict/administrative/ichapterapp/type', // 获取用章类别
	  DICT_GLOBAL_CONFIG: baseUrl + '/api/core/dict/global/config/type', // 系统配置选项
	  DICT_INDUSTRY_LIST: baseUrl + '/api/core/dict/industry/list', // 获取行业,
	  DICT_BUDGET_TYPE: baseUrl + '/api/core/dict/budget/type/budget', // 获取预算收入类别,
	  DICT_MATERIAL_DOCUMENT_TYPE: baseUrl + '/api/core/dict/administrative/material/document/type', // 资料类别
	
	  GET_DICT_LIST_TREE: baseUrl + '/api/core/dict/listTree', // 字典列表,
	  GET_DICT_INFO: baseUrl + '/api/core/dict/info', // 字典详情,
	  DELETE_DICT: baseUrl + '/api/core/dict/delete', // 删除字典,
	  SAVE_DICT: baseUrl + '/api/core/dict/save', // 保存字典,
	
	  GET_FUNCTION_LIST_TREE: baseUrl + '/api/core/function/listTree', // 菜单栏列表,
	  GET_FUNCTION_LIST_TREE_ENABLE: baseUrl + '/api/core/function/listTree/enable', // 菜单栏列表,
	  GET_MY_FUNCTION_LIST_TREE: baseUrl + '/api/core/function/myTree', // 菜单栏列表,
	  GET_FUNCTION_INFO: baseUrl + '/api/core/function/info', // 菜单栏详情,
	  DELETE_FUNCTION: baseUrl + '/api/core/function/delete', // 删除菜单栏,
	  SAVE_FUNCTION: baseUrl + '/api/core/function/save', // 保存菜单栏,
	  GET_ROLE_LIST_ALL: baseUrl + '/api/core/role/list/all', // 角色列表,
	  GET_ROLE_LIST: baseUrl + '/api/core/role/list', // 角色列表,
	  GET_ROLE_INFO: baseUrl + '/api/core/role/info', // 角色详情,
	  DELETE_ROLE: baseUrl + '/api/core/role/delete', // 删除角色,
	  SAVE_ROLE: baseUrl + '/api/core/role/save', // 保存角色,
	  SAVE_ROLE_FUNCTION: baseUrl + '/api/core/role/function/save', // 保存角色与菜单栏的关联,
	  SAVE_BY_ROLE_ACCOUNT_ROLE: baseUrl + '/api/core/account/role/saveByRole', // 保存角色与用户关联,
	  SAVE_BY_ACCOUNT_ACCOUNT_ROLE: baseUrl + '/api/core/account/role/saveByAccount', // 保存角色与用户关联,
	  GET_ACCOUNT_ROLE_ACCOUNTS: baseUrl + '/api/core/account/role/accounts', // 获取角色关联的用户
	  GET_ACCOUNT_ROLE_ROLES: baseUrl + '/api/core/account/role/roles', // 获取用户关联的角色,
	
	  SAVE_BY_ACCOUNT_ACCOUNT_ORG: baseUrl + '/api/core/account/org/saveByAccount', // 保存角色与用户关联,
	  GET_ACCOUNT_ORG_ORGS: baseUrl + '/api/core/account/org/orgs',
	
	  GET_ROLE_FUNCTION_FUNCTIONLIST: baseUrl + '/api/core/role/function/functionList', // 保存角色,
	  GET_ROLE_FUNCTION_ROLELIST: baseUrl + '/api/core/role/function/roleList', // 保存角色,
	
	  //* *******************组织加用户列表*****************************
	  ALL_USER_ORG_TREE: baseUrl + '/api/core/account/tree',
	
	  //* *******************用户管理*****************************
	  ACCOUNT_LIST: baseUrl + '/api/core/account/list', // 用户列表,
	  CORE_ACCOUNT_UPDATE_PWD: baseUrl + '/api/core/account/updatePwd', // 修改用户密码,
	  ROLE_LIST: baseUrl + '/api/core/account/role/list', // 用户列表,
	  ACCOUNT_INFO: baseUrl + '/api/core/account/info', // 获取登录人的信息,
	  USER_ORG_TREE: baseUrl + '/api/core/account/orgTree', // 用户列表,
	  CORE_ACCOUNT_SEARCH: baseUrl + '/api/core/account/search', // 用户列表根据用户名搜索,
	  GET_ADMIN_ACCOUNT_LIST: baseUrl + '/api/core/account/admin/list', // 用户列表（管理员)
	  GET_ADMIN_ACCOUNT_INFO: baseUrl + '/api/core/account/admin/info', // 用户列表（管理员)
	  SAVE_ACCOUNT: baseUrl + '/api/core/account/save', // 用户保存
	  //* *******************组织管理*****************************
	  CORE_ORG_LIST: baseUrl + '/api/core/org/list', // 组织列表,
	  ORG_LIST_ALL: baseUrl + '/api/core/org/list/all', // 所有组织列表,
	  XX_ORG_LIST: baseUrl + '/api/core/org/xianxing',
	  CORE_ORG_COMPANY_LIST: baseUrl + '/api/core/org/company/list', // 获取组织列表,
	  // 组织管理
	  CORE_ORG_TREE: baseUrl + '/api/core/org/tree', // 获取组织的树状列表
	  CORE_BY_ORG_TREE: baseUrl + '/api/core/org/treeByOrg', // 获取组织的树状列表
	  ORG_INFO: baseUrl + '/api/core/org/info', // 获取组织的详情
	  CORE_ORG_ENABLE_TREE: baseUrl + '/api/core/org/enable/tree', // 获取组织的启用树状列表
	  CORE_ORG_ADD: baseUrl + '/api/core/org/add', // 新增组织架构
	  CORE_ORG_UPDATE: baseUrl + '/api/core/org/update', // 更新组织
	  CORE_ORG_DELETE: baseUrl + '/api/core/org/delete', // 组织删除
	  CORE_ORG_DISABLE: baseUrl + '/api/core/org/disable', // 组织禁用
	  CORE_ORG_ENABLE: baseUrl + '/api/core/org/enable', // 组织启用
	  CORE_ORG_MOVE: baseUrl + '/api/core/org/move', // 组织移动
	  GET_CUISTOM_CATEGORY: baseUrl + '/api/core/dict/crm/custom/category', // 行业分类1
	  GET_CUISTOM_FIELD: baseUrl + '/api/core/dict/crm/custom/field', // 客户可以显示的字段
	
	  FINANCE_DICT_INCOME: baseUrl + '/api/core/dict/income/type/income', // 收入类别
	  FINANCE_DICT_EXPEND: baseUrl + '/api/core/dict/income/type/expenditure', // 支出类别
	
	  GET_GLOBAL_CONFIG_LIST: baseUrl + '/api/core/global/config/list', // 字典列表,
	  GET_GLOBAL_CONFIG_CONFIG: baseUrl + '/api/core/global/config/config', // 已经配置的字典选项,
	  GET_GLOBAL_CONFIG_INFO: baseUrl + '/api/core/global/config/info', // 字典详情,
	  DELETE_GLOBAL_CONFIG: baseUrl + '/api/core/global/config/delete', // 删除字典,
	  SAVE_GLOBAL_CONFIG: baseUrl + '/api/core/global/config/save', // 保存字典,
	
	  // ********************公司账户信息****************
	  GET_SERIALNUMBER_LIST: baseUrl + '/api/core/serialNumber/list', // 公司账户信息列表
	  GET_SERIALNUMBER_INFO: baseUrl + '/api/core/serialNumber/info', // 公司账户信息详情
	  SAVE_SERIALNUMBER: baseUrl + '/api/core/serialNumber/save', // 保存公司账户信息
	  DELETE_SERIALNUMBER: baseUrl + '/api/core/serialNumber/delete' // 删除公司账户信息
	};
	
	var administrative = exports.administrative = {
	  /* ----------------------material----------------------------------------------------------------------------------*/
	  //* *******************资料管理*****************************
	  MATERIAL_DIRECTORY_LIST: baseUrl + '/api/bszb/administrative/material/directory/list', // 资料目录列表
	  MATERIAL_DIRECTORY_INFO: baseUrl + '/api/bszb/administrative/material/directory/info', // 资料目录详情
	  MATERIAL_DIRECTORY_SAVE: baseUrl + '/api/bszb/administrative/material/directory/save', // 资料目录保存
	  MATERIAL_DIRECTORY_DELETE: baseUrl + '/api/bszb/administrative/material/directory/delete', // 资料目录删除
	
	  MATERIAL_DATABASE_LIST: baseUrl + '/api/bszb/administrative/material/database/list', // 资料库列表
	  MATERIAL_DATABASE_LIST_BR: baseUrl + '/api/bszb/administrative/material/database/listByReader', // 我可查阅的资料库列表
	  MATERIAL_DATABASE_LIST_BM: baseUrl + '/api/bszb/administrative/material/database/listByManager', // 我负责的资料库列表
	  MATERIAL_DATABASE_INFO: baseUrl + '/api/bszb/administrative/material/database/info', // 资料库详情
	  MATERIAL_DATABASE_SAVE: baseUrl + '/api/bszb/administrative/material/database/save', // 资料库保存
	  MATERIAL_DATABASE_DELETE: baseUrl + '/api/bszb/administrative/material/database/delete', // 资料库删除
	  MATERIAL_DATABASE_TYPE: baseUrl + '/api/bszb/administrative/material/database/type', // 资料库类型
	
	  MATERIAL_DOCUMENT_LIST: baseUrl + '/api/bszb/administrative/material/document/list', // 资料文档列表
	  MATERIAL_DOCUMENT_LIST_BR: baseUrl + '/api/bszb/administrative/material/document/listByReader', // 我可查阅的资料列表
	  MATERIAL_DOCUMENT_LIST_BM: baseUrl + '/api/bszb/administrative/material/document/listByManager', // 我负责的资料列表
	  MATERIAL_DOCUMENT_MY: baseUrl + '/api/bszb/administrative/material/document/my', // 我的资料文档列表
	  MATERIAL_DOCUMENT_INFO: baseUrl + '/api/bszb/administrative/material/document/info', // 资料文档详情
	  MATERIAL_DOCUMENT_SAVE: baseUrl + '/api/bszb/administrative/material/document/save', // 资料文档保存
	  MATERIAL_DOCUMENT_DELETE: baseUrl + '/api/bszb/administrative/material/document/delete', // 资料文档删除
	  MATERIAL_DOCUMENT_LOG: baseUrl + '/api/bszb/administrative/material/document/log', // 资料文档操作日志
	  //* *******************资料借用*****************************
	  GET_MATERIAL_BORROW_LIST: baseUrl + '/api/bszb/administrative/material/borrow/list', // 资料借用记录
	  GET_MATERIAL_BORROW_MY: baseUrl + '/api/bszb/administrative/material/borrow/my', // 我的资料借用申请
	  GET_MATERIAL_BORROW_CHECK: baseUrl + '/api/bszb/administrative/material/borrow/my/check', // 我的资料借用审核
	  GET_MATERIAL_BORROW_INFO: baseUrl + '/api/bszb/administrative/material/borrow/info', // 资料借用详情
	  MATERIAL_BORROW_SAVE: baseUrl + '/api/bszb/administrative/material/borrow/save', // 资料借用保存
	  MATERIAL_BORROW_DELETE: baseUrl + '/api/bszb/administrative/material/borrow/delete', // 资料借用删除
	  MATERIAL_BORROW_NEXT: baseUrl + '/api/bszb/administrative/material/borrow/nextActivity', // 流程审核
	  MATERIAL_BORROW_RETURN: baseUrl + '/api/bszb/administrative/material/borrow/returnActivity', // 资料借用流程打回
	  MATERIAL_BORROW_CALLBACK: baseUrl + '/api/bszb/administrative/material/borrow/callbackActivity', // 资料借用流程收回
	  MATERIAL_BORROW_WORKFLOW: baseUrl + '/api/bszb/administrative/material/borrow/workflow', // 资料借用流程申请流程
	  //* *******************资料归还*****************************
	  GET_MATERIAL_RETURN_LIST: baseUrl + '/api/bszb/administrative/material/return/list', // 资料归还记录
	  GET_MATERIAL_RETURN_LIST_TODO: baseUrl + '/api/bszb/administrative/material/return/list/todo', // 资料归还记录
	  GET_MATERIAL_RETURN_LIST_DONE: baseUrl + '/api/bszb/administrative/material/return/list/done', // 资料归还记录
	  GET_MATERIAL_RETURN_BR: baseUrl + '/api/bszb/administrative/material/return/my', // 我的资料归还
	  GET_MATERIAL_RETURN_BR_TODO: baseUrl + '/api/bszb/administrative/material/return/my/todo', // 我的资料待归还
	  GET_MATERIAL_RETURN_BR_DONE: baseUrl + '/api/bszb/administrative/material/return/my/done', // 我的资料已归还
	  GET_MATERIAL_RETURN_BM: baseUrl + '/api/bszb/administrative/material/return/listByManager', // 我管理的资料归还
	  GET_MATERIAL_RETURN_BM_TODO: baseUrl + '/api/bszb/administrative/material/return/listByManager/todo', // 我管理的资料待归还
	  GET_MATERIAL_RETURN_BM_DONE: baseUrl + '/api/bszb/administrative/material/return/listByManager/done', // 我管理的资料已归还
	  MATERIAL_RETURN_SAVE: baseUrl + '/api/bszb/administrative/material/return/save', // 资料归还保存
	
	  //* *******************资料续证*****************************
	  GET_MATERIAL_RENEWAL_MY: baseUrl + '/api/bszb/administrative/material/renewal/my', // 我的资料续证
	  GET_MATERIAL_RENEWAL_LIST: baseUrl + '/api/bszb/administrative/material/renewal/list', // 资料续证监控
	  GET_MATERIAL_RENEWAL_INFO: baseUrl + '/api/bszb/administrative/material/renewal/info', // 资料续证详情
	  MATERIAL_RENEWAL_SAVE: baseUrl + '/api/bszb/administrative/material/renewal/save', // 保存资料续证
	  MATERIAL_RENEWAL_DELETE: baseUrl + '/api/bszb/administrative/material/renewal/delete', // 资料续证删除
	  MATERIAL_RENEWAL_NEXT: baseUrl + '/api/bszb/administrative/material/renewal/nextActivity', // 流程审核
	  MATERIAL_RENEWAL_NEXT_UPLOAD: baseUrl + '/api/bszb/administrative/material/renewal/nextActivityUpload', // 资料续证上传相关附件
	  MATERIAL_RENEWAL_NEXT_SCAN: baseUrl + '/api/bszb/administrative/material/renewal/nextActivityScan', // 流程提交扫描件
	  MATERIAL_RENEWAL_NEXT_ARCHIVE: baseUrl + '/api/bszb/administrative/material/renewal/nextActivityArchive', // 流程行政归档
	  MATERIAL_RENEWAL_RETURN: baseUrl + '/api/bszb/administrative/material/renewal/returnActivity', // 资料续证流程打回
	  MATERIAL_RENEWAL_CALLBACK: baseUrl + '/api/bszb/administrative/material/renewal/callbackActivity', // 资料续证流程收回
	  MATERIAL_RENEWAL_WORKFLOW: baseUrl + '/api/bszb/administrative/material/renewal/workflow', // 资料续证流程申请流程
	  //* *******************用章*****************************
	  GET_SEAL_LIST: baseUrl + '/api/bszb/administrative/ichapterapp/list', // 用章记录
	  GET_SEAL_MY: baseUrl + '/api/bszb/administrative/ichapterapp/my', // 我的用章申请
	  GET_SEAL_CHECK: baseUrl + '/api/bszb/administrative/ichapterapp/my/check', // 我的用章审核
	  GET_SEAL_STATIC_ORG: baseUrl + '/api/bszb/administrative/ichapterapp/statisticByOrg', // 用章统计按单位
	  GET_SEAL_STATIC_INCUBATOR: baseUrl + '/api/bszb/administrative/ichapterapp/statisticByIncubator', // 用章统计按孵化器
	  GET_SEAL_RECORD_ORG: baseUrl + '/api/bszb/administrative/ichapterapp/listByOrg', // 用章记录按单位
	  GET_SEAL_INFO: baseUrl + '/api/bszb/administrative/ichapterapp/info', // 用章详情
	  SEAL_SAVE: baseUrl + '/api/bszb/administrative/ichapterapp/save', // 用章保存
	  SEAL_DELETE: baseUrl + '/api/bszb/administrative/ichapterapp/delete', // 用章删除
	  SEAL_NEXT: baseUrl + '/api/bszb/administrative/ichapterapp/nextActivity', // 流程审核
	  SEAL_NEXT_SCAN: baseUrl + '/api/bszb/administrative/ichapterapp/nextActivityScan', // 流程提交扫描件
	  SEAL_NEXT_ARCHIVE: baseUrl + '/api/bszb/administrative/ichapterapp/nextActivityArchive', // 流程行政归档
	  SEAL_RETURN: baseUrl + '/api/bszb/administrative/ichapterapp/returnActivity', // 用章流程打回
	  SEAL_CALLBACK: baseUrl + '/api/bszb/administrative/ichapterapp/callbackActivity', // 用章流程收回
	  SEAL_WORKFLOW: baseUrl + '/api/bszb/administrative/ichapterapp/workflow', // 用章流程申请流程
	
	  //* *******************采购*****************************
	  GET_PURCHASE_LIST: baseUrl + '/api/bszb/administrative/purchase/list', // 采购记录
	  GET_PURCHASE_MY: baseUrl + '/api/bszb/administrative/purchase/my', // 我的采购申请
	  GET_PURCHASE_CHECK: baseUrl + '/api/bszb/administrative/purchase/my/check', // 我的采购审核
	  GET_PURCHASE_STATIC_ORG: baseUrl + '/api/bszb/administrative/purchase/statisticByOrg', // 采购统计按单位
	  GET_PURCHASE_STATIC_INCUBATOR: baseUrl + '/api/bszb/administrative/purchase/statisticByIncubator', // 采购统计按孵化器
	  GET_PURCHASE_RECORD_ORG: baseUrl + '/api/bszb/administrative/purchase/listByOrg', // 采购记录按单位
	  GET_PURCHASE_INFO: baseUrl + '/api/bszb/administrative/purchase/info', // 采购详情
	  PURCHASE_SAVE: baseUrl + '/api/bszb/administrative/purchase/save', // 采购保存
	  PURCHASE_DELETE: baseUrl + '/api/bszb/administrative/purchase/delete', // 采购删除
	  PURCHASE_NEXT: baseUrl + '/api/bszb/administrative/purchase/nextActivity', // 流程审核
	  PURCHASE_TRANSFER: baseUrl + '/api/bszb/administrative/purchase/transfer', // 流程转移
	  PURCHASE_RETURN: baseUrl + '/api/bszb/administrative/purchase/returnActivity', // 采购流程打回
	  PURCHASE_CALLBACK: baseUrl + '/api/bszb/administrative/purchase/callbackActivity', // 采购流程收回
	  PURCHASE_WORKFLOW: baseUrl + '/api/bszb/administrative/purchase/workflow', // 采购流程申请流程
	
	  // ********************公告列表****************
	  GET_ANNOUNCEMENT_LIST: baseUrl + '/api/bszb/administrative/announcement/list', // 公告列表列表
	  GET_ANNOUNCEMENT_INFO: baseUrl + '/api/bszb/administrative/announcement/info', // 公告列表详情
	  SAVE_ANNOUNCEMENT: baseUrl + '/api/bszb/administrative/announcement/save', // 保存公告列表
	  DELETE_ANNOUNCEMENT: baseUrl + '/api/bszb/administrative/announcement/delete' // 删除公告列表
	};
	
	var workflow = exports.workflow = {
	  WORKFLOW_TEMPLATE_LIST: baseUrl + '/api/bszb/workflow/template/list', // 工作流模板列表
	  WORKFLOW_TEMPLATE_INFO: baseUrl + '/api/bszb/workflow/template/info', // 工作流模板详情
	  WORKFLOW_TEMPLATE_SAVE: baseUrl + '/api/bszb/workflow/template/save', // 工作流模板保存
	  WORKFLOW_TEMPLATE_DELETE: baseUrl + '/api/bszb/workflow/template/delete', // 工作流模板删除
	  GET_TASK_LIST: baseUrl + '/api/bszb/workflow/instance/message/todo', // 所有待办
	  GET_DONE_TASK_LIST: baseUrl + '/api/bszb/workflow/instance/message/done', // 所有已办
	  GET_PAYROLL: baseUrl + '/api/bszb/workflow/instance/message/payroll' // 工资单
	};
	
	var common = exports.common = {
	  LOGIN: baseUrl + '/api/core/account/login', // 登陆
	  UPLOAD: baseUrl + '/api/pub/attachment/uploads', // 上传附件
	  READONLINE: baseUrl + '/api/pub/attachment/readOnline', // 文件预览
	  CORE_ORG_CONFIG: baseUrl + '/api/pub/org/config/save', // 获取组织的树状列表
	  CORE_ORG_CONFIG_OPTIONS: baseUrl + '/api/pub/org/config/options', // 组织人员可配置选项
	  PUP_ORG_CONFIG_INFO: baseUrl + '/api/pub/org/config/info', // 组织人员可配置选项
	
	  // 评论模块
	  TALK_LIST: baseUrl + '/api/bszb/common/talk/list', // 评论列表
	  TALK_SAVE: baseUrl + '/api/bszb/common/talk/save', // 发布评论
	  /** 合同模块 */
	  BUSINESS_INFO: baseUrl + '/api/bszb/common/business/info', // 合同详情
	  BUSINESS_LOG: baseUrl + '/api/bszb/common/log/list', // 合同操作日志
	
	  /** 客户模块 */
	  CUSTOM_ACCOUNT_SAVE: baseUrl + '/api/bszb/common/custom/account/save', // 客户帐号信息保存
	  CUSTOM_SAVE: baseUrl + '/api/bszb/common/custom/save', // 客户帐号信息
	  /** 附件管理 */
	  ATTCHMENT_SAVE: baseUrl + '/api/pub/attachment/save', // 文件上传
	  ATTCHMENT_DELETE: baseUrl + '/api/pub/attachment/delete', // 文件删除
	  FILE_LIST: baseUrl + '/api/pub/attachment/list' // 文件列表
	};
	
	var crm = exports.crm = {
	  /* ----------------------客户模块----------------------------------------------------------------------------------*/
	  GET_CUSTOM_LIST: baseUrl + '/api/bszb/crm/custom/list', // 客户列表
	  GET_CUSTOM_INFO: baseUrl + '/api/bszb/crm/custom/info', // 客户详情
	  GET_CUSTOM_DEPARTMENT_DISTRIBUTION_LIST: baseUrl + '/api/bszb/crm/custom/department/distribution/list', // 分属部门分配情况
	  CUSTOM_DEPARTMENT_DISTRIBUTION_SAVE: baseUrl + '/api/bszb/crm/custom/department/distribution/save', // 保存分属部门分配情况
	  GET_DEPARTMENT_MY: baseUrl + '/api/bszb/crm/department/my', // 当前用户所在的分属部门详情
	  GET_CUSTOM_DEPARTMENT_LIST: baseUrl + '/api/bszb/crm/custom/department/list', // 分属客户列表
	  GET_CUSTOM_DEPARTMENT_INFO: baseUrl + '/api/bszb/crm/custom/department/info', // 分属客户详情
	  CUSTOM_SAVE: baseUrl + '/api/bszb/crm/custom/save', // 客户保存
	  CUSTOM_DEPARTMENT_SAVE: baseUrl + '/api/bszb/crm/custom/department/save', // 分属部门客户保存
	  GET_CUSTOM_PROTECTION_LIST: baseUrl + '/api/bszb/crm/custom/protection/list', // 客户保存列表
	  GET_CUSTOM_PROTECTION_MY_LIST: baseUrl + '/api/bszb/crm/custom/protection/my/list', // 个人客户保存列表
	  CUSTOM_PROTECTION_SAVE: baseUrl + '/api/bszb/crm/custom/protection/save', // 客户保护
	  CUSTOM_PROTECTION_DISTRIBUTION_SAVE: baseUrl + '/api/bszb/crm/custom/protection/distribution/save', // 客户保存分配
	  CUSTOM_PROTECTION_CANCEL: baseUrl + '/api/bszb/crm/custom/protection/cancel', // 取消客户保护
	  GET_CUSTOM_CONTACT_LIST: baseUrl + '/api/bszb/crm/custom/contact/list', // 客户联系记录列表
	  CUSTOM_CONTACT_SAVE: baseUrl + '/api/bszb/crm/custom/contact/save', // 联系记录保存
	  CUSTOM_CONTACT_VERIFY: baseUrl + '/api/bszb/crm/custom/contact/verify', // 联系记录保存
	  GET_CLUE_LIST: baseUrl + '/api/bszb/crm/clue/list', // 线索列表
	  CLUE_SAVE: baseUrl + '/api/bszb/crm/clue/save', // 线索保存
	  GET_CLUE_INFO: baseUrl + '/api/bszb/crm/clue/info', // 线索详情
	  CLUE_IMPORT: baseUrl + '/api/bszb/crm/clue/import', // 导入线索
	  DOWNLOAD_CLUE_TEMPLATE: baseUrl + '/api/bszb/crm/clue/template', // 模线索板下载
	  GET_DEPARTMENT_LIST: baseUrl + '/api/bszb/crm/department/list', // 分属部门列表
	  GET_DEPARTMENT_SAVE: baseUrl + '/api/bszb/crm/department/save', // 分属部门列表
	  DEPARTMENT_OPPORTUNITY_SAVE: baseUrl + '/api/bszb/crm/department/opportunity/save', // 分属部门的商机阶段设置
	  DEPARTMENT_OPPORTUNITY_INFO: baseUrl + '/api/bszb/crm/department/opportunity/info', // 分属部门的商机阶段设置详情
	  DEPARTMENT_PRODUCT_SAVE: baseUrl + '/api/bszb/crm/department/product/save', // 分属部门的产品设置
	  DEPARTMENT_PRODUCT_INFO: baseUrl + '/api/bszb/crm/department/product/info', // 分属部门的产品设置详情
	  DEPARTMENT_PROTECTION_SAVE: baseUrl + '/api/bszb/crm/department/protection/save', // 分属部门的客户保护设置保存
	  DEPARTMENT_PROTECTION_INFO: baseUrl + '/api/bszb/crm/department/protection/info', // 分属部门的客户保护设置保存
	  CUISTOM_VIEW_SAVE: baseUrl + '/api/bszb/crm/department/custom/view/save', // 分属部门的客户显示字段设置
	  GET_CUISTOM_VIEW: baseUrl + '/api/bszb/crm/department/custom/view/info', // 分属部门的客户显示字段设置明细
	
	  OPPORTUNITY_SAVE: baseUrl + '/api/bszb/crm/opportunity/save', // 商机保存
	  GET_OPPORTUNITY_LIST: baseUrl + '/api/bszb/crm/opportunity/my/list', // 商机列表
	  GET_OPPORTUNITY_INFO: baseUrl + '/api/bszb/crm/opportunity/info' // 商机列表
	};
	var incubator = exports.incubator = {
	  /** 基础管理 */
	  INCUBATOR_BASE_LIST: baseUrl + '/api/bszb/incubator/base/list', // 孵化器地址列表
	  INCUBATOR_BASE_INFO: baseUrl + '/api/bszb/incubator/base/info', // 孵化器地址详情
	  INCUBATOR_BASE_SAVE: baseUrl + '/api/bszb/incubator/base/save', // 孵化器地址编辑
	  INCUBATOR_BASE_INCOME: baseUrl + '/api/bszb/incubator/base/income/record', // 孵化器资金列表
	  INCUBATOR_BASE_REFUND_TODO: baseUrl + '/api/bszb/incubator/custom/finance/income/refund/todo', // 孵化器待退款资金列表
	
	  /** 文件关联 */
	  INCUBATOR_DATEBASE_SAVE: baseUrl + '/api/bszb/incubator/database/relate/save', // 文件关联
	  INCUBATOR_DATEBASE_DElETE: baseUrl + '/api/bszb/incubator/database/relate/delete', // 删除文件关联
	
	  /** 地址 */
	  INCUBATOR_ADDRESS_LIST: baseUrl + '/api/bszb/incubator/address/list', // 孵化器地址列表
	  INCUBATOR_ADDRESS_INFO: baseUrl + '/api/bszb/incubator/address/info', // 孵化器地址详情
	  INCUBATOR_ADDRESS_BATCH: baseUrl + '/api/bszb/incubator/address/batch', // 孵化器地址新增
	  INCUBATOR_ADDRESS_SAVE: baseUrl + '/api/bszb/incubator/address/save', // 孵化器地址编辑
	  INCUBATOR_ADDRESS_DELETE: baseUrl + '/api/bszb/incubator/address/delete', // 孵化器地址删除
	  INCUBATOR_ADDRESS_STATISTIC: baseUrl + '/api/bszb/incubator/address/statistic', // 孵化器地址统计
	  INCUBATOR_ADDRESS_COUNT: baseUrl + '/api/bszb/incubator/address/count', // 孵化器地址总数
	  ADDRESS_BUSINESS_LIST: baseUrl + '/api/bszb/incubator/address/business/list', // 地址使用情况
	  ADDRESS_BUSINESS_STATIS: baseUrl + '/api/bszb/incubator/address/business/statistics', // 合同使用情况统计
	  ADDRESS_BUSINESS_LIBERATE: baseUrl + '/api/bszb/incubator/address/liberate', // 地址释放
	
	  /** 工位 */
	  INCUBATOR_STATION_CONFIG: baseUrl + '/api/bszb/incubator/station/config/save', // 孵化器工位设置
	  INCUBATOR_STATION_ADD: baseUrl + '/api/bszb/incubator/station/add', // 新增工位
	  INCUBATOR_STATION_CONFIG_INFO: baseUrl + '/api/bszb/incubator/station/config/info', // 孵化器工位设置详情
	  INCUBATOR_STATION_SAVE: baseUrl + '/api/bszb/incubator/station/add', // 孵化器工位详情
	  INCUBATOR_STATION_LIST: baseUrl + '/api/bszb/incubator/station/list', // 孵化器工位列表
	  INCUBATOR_STATION_DELETE: baseUrl + '/api/bszb/incubator/station/delete', // 删减工位
	  INCUBATOR_STATION_ENABLE: baseUrl + '/api/bszb/incubator/station/enable', // 启用工位
	  INCUBATOR_STATION_DISABLE: baseUrl + '/api/bszb/incubator/station/disable', // 禁用工位
	  INCUBATOR_STATION_UNIT: baseUrl + '/api/bszb/incubator/station/unit', // 单价设置
	  INCUBATOR_STATION_RESET: baseUrl + '/api/bszb/incubator/station/reset', // 重置工位设置
	  INCUBATOR_STATION_COUNT: baseUrl + '/api/bszb/incubator/station/count', // 孵化器工位总数
	  INCUBATOR_STATION_STATISTIC: baseUrl + '/api/bszb/incubator/station/statistics', // 工位统计
	
	  /** 工位入驻 */
	  INCUBATOR_SETTLED_LIST: baseUrl + '/api/bszb/incubator/business/settled/list', // 孵化器工位入驻记录
	  INCUBATOR_SETTLED_MY: baseUrl + '/api/bszb/incubator/business/settled/my', // 我的孵化器工位入驻申请
	  INCUBATOR_SETTLED_MY_CHECK: baseUrl + '/api/bszb/incubator/business/settled/my/check', // 我的孵化器工位入驻审核
	  INCUBATOR_SETTLED_SAVE: baseUrl + '/api/bszb/incubator/business/settled/save', // 孵化器工位入驻保存
	  INCUBATOR_SETTLED_DELETE: baseUrl + '/api/bszb/incubator/business/settled/delete', // 孵化器工位入驻删除
	  INCUBATOR_SETTLED_INFO: baseUrl + '/api/bszb/incubator/business/settled/info', // 孵化器工位入驻详情
	  INCUBATOR_SETTLED_NEXT: baseUrl + '/api/bszb/incubator/business/settled/nextActivity', // 流程审核
	  INCUBATOR_SETTLED_NEXT_SCAN: baseUrl + '/api/bszb/incubator/business/settled/nextActivityScan', // 经办人提交文件扫描件
	  INCUBATOR_SETTLED_NEXT_ARCHIVE: baseUrl + '/api/bszb/incubator/business/settled/nextActivityArchive', // 行政文件归档
	  INCUBATOR_SETTLED_RETURN: baseUrl + '/api/bszb/incubator/business/settled/returnActivity', // 孵化器工位入驻流程打回
	  INCUBATOR_SETTLED_CALLBACK: baseUrl + '/api/bszb/incubator/business/settled/callbackActivity', // 收回孵化器工位入驻流程
	  INCUBATOR_SETTLED_WORKFLOW: baseUrl + '/api/bszb/incubator/business/settled/workflow', // 收回孵化器工位入驻流程
	  SETTLED_WORKFLOW: baseUrl + '/api/bszb/incubator/business/settled/discount', // 折扣清单
	  STATION_SETTLED_RELATE: baseUrl + '/api/bszb/incubator/business/settled/relate', // 手动入驻合同关联
	  RENEW_SETTLED_INFO: baseUrl + '/api/bszb/incubator/business/settled/renewStations', // 获取需要续签合同工位列表以及新续签合同的开始时间
	
	  /** 地址管理 */
	  INCUBATOR_OREGISTAPP_LISTBYINC: baseUrl + '/api/bszb/incubator/business/oregistapp/listByIncubator', // 孵化器注册地址列表
	  INCUBATOR_OREGISTAPP_LISTBYINC_EXPORT: baseUrl + '/api/bszb/incubator/business/oregistapp/listByIncubator/export', // 孵化器注册地址列表
	  INCU_BUSINESS_REMIND_OREGISTAPP: baseUrl + '/api/bszb/incubator/business/remind/oregistapp', // 地址提醒
	  INCU_BUSINESS_OVERDUE_OREGISTAPP: baseUrl + '/api/bszb/incubator/business/overdue/oregistapp', // 逾期地址
	
	  /** 地址入驻 */
	  INCUBATOR_OREGISTAPP_LIST: baseUrl + '/api/bszb/incubator/business/oregistapp/list', // 孵化器地址入驻记录
	  INCUBATOR_OREGISTAPP_MY: baseUrl + '/api/bszb/incubator/business/oregistapp/my', // 我的孵化器地址入驻申请
	  INCUBATOR_OREGISTAPP_MY_CHECK: baseUrl + '/api/bszb/incubator/business/oregistapp/my/check', // 我的孵化器地址入驻审核
	  INCUBATOR_OREGISTAPP_SAVE: baseUrl + '/api/bszb/incubator/business/oregistapp/save', // 孵化器地址入驻保存
	  INCUBATOR_OREGISTAPP_DELETE: baseUrl + '/api/bszb/incubator/business/oregistapp/delete', // 孵化器地址入驻删除
	  INCUBATOR_OREGISTAPP_INFO: baseUrl + '/api/bszb/incubator/business/oregistapp/info', // 孵化器地址入驻详情
	  INCUBATOR_OREGISTAPP_ISAPPLY: baseUrl + '/api/bszb/incubator/business/oregistapp/isApply', // 判断客户是否已经存在地址申请
	  INCUBATOR_OREGISTAPP_NEXT: baseUrl + '/api/bszb/incubator/business/oregistapp/nextActivity', // 流程审核
	  INCUBATOR_OREGISTAPP_RETURN: baseUrl + '/api/bszb/incubator/business/oregistapp/returnActivity', // 孵化器地址入驻流程打回
	  INCUBATOR_OREGISTAPP_CALLBACK: baseUrl + '/api/bszb/incubator/business/oregistapp/callbackActivity', // 收回孵化器地址入驻流程
	  INCUBATOR_OREGISTAPP_WORKFLOW: baseUrl + '/api/bszb/incubator/business/oregistapp/workflow', // 收回孵化器地址入驻流程
	  ADDRESS_OREGISTAPP_RELATE: baseUrl + '/api/bszb/incubator/business/oregistapp/relate', // 手动入驻合同关联
	  RENEW_OREGISTAPP_INFO: baseUrl + '/api/bszb/incubator/business/oregistapp/renewAddresses', // 获取需要续签合同地址列表以及新续签合同的开始时间
	
	  /** 地址迁出 */
	  INCUBATOR_OREGISTAPP_MOVE_OUT_LIST: baseUrl + '/api/bszb/incubator/business/oregistapp/move/out/list', // 孵化器地址迁出记录
	  INCUBATOR_OREGISTAPP_MOVE_OUT_MY: baseUrl + '/api/bszb/incubator/business/oregistapp/move/out/my', // 我的孵化器地址迁出申请
	  INCUBATOR_OREGISTAPP_MOVE_OUT_INFO: baseUrl + '/api/bszb/incubator/business/oregistapp/move/out/info', // 孵化器地址迁出详情
	  INCUBATOR_OREGISTAPP_MOVE_OUT_SAVE: baseUrl + '/api/bszb/incubator/business/oregistapp/move/out/save', // 孵化器地址迁出保存
	  INCUBATOR_OREGISTAPP_MOVE_OUT_NEXT: baseUrl + '/api/bszb/incubator/business/oregistapp/move/out/nextActivity', // 流程审核
	  INCUBATOR_OREGISTAPP_MOVE_OUT_RETURN: baseUrl + '/api/bszb/incubator/business/oregistapp/move/out/returnActivity', // 孵化器地址迁出流程打回
	  INCUBATOR_OREGISTAPP_MOVE_OUT_CALLBACK: baseUrl + '/api/bszb/incubator/business/oregistapp/move/out/callbackActivity', // 收回孵化器地址迁出流程
	  INCUBATOR_OREGISTAPP_MOVE_OUT_WORKFLOW: baseUrl + '/api/bszb/incubator/business/oregistapp/move/out/workflow', // 收回孵化器地址迁出流程
	
	  /** 客户 */
	  CUSTOM_LIST: baseUrl + '/api/bszb/incubator/custom/list', // 孵化器客户列表
	  CUSTOM_LIST_EXPORT: baseUrl + '/api/bszb/incubator/custom/list/export', // 孵化器客户列表导出
	  CUSTOM_INFO: baseUrl + '/api/bszb/incubator/custom/info', // 客户详情
	  CUSTOM_SETTLED: baseUrl + '/api/bszb/incubator/custom/settled', // 客户入驻工位
	  CUSTOM_SETTLED_SIGN: baseUrl + '/api/bszb/incubator/custom/business/settled/sign', // 孵化器客户的生效在签工位合同
	  CUSTOM_BUSINESS_SETTLED: baseUrl + '/api/bszb/incubator/custom/business/settled', // 孵化器客户的生效基础孵化合同
	  CUSTOM_BUSINESS_OREGISTAPP: baseUrl + '/api/bszb/incubator/custom/business/oregistapp', // 孵化器客户的生效地址合同
	  CUSTOM_PROJECT: baseUrl + '/api/bszb/incubator/custom/project', // 客户项目
	  CUSTOM_INCOME_UNCONFIRMED: baseUrl + '/api/bszb/incubator/custom/income/unconfirmed', // 客户未确认资金列表
	  CUSTOM_INCOME_LIST: baseUrl + '/api/bszb/incubator/custom/income/list', // 客户资金列表
	  CUSTOM_PAYABLE_TOBETURNS: baseUrl + '/api/bszb/incubator/custom/payable/toBeTurns', // 客户的待转结列表
	  CUSTOM_CAN_MOVEOUT: baseUrl + '/api/bszb/incubator/custom/canMoveOut', // 客户是否迁出
	  CUSTOM_MOVEOUT: baseUrl + '/api/bszb/incubator/custom/moveOut', // 客户迁出操作
	  CUSTOM_MOVEOUT_REMIND: baseUrl + '/api/bszb/incubator/custom/move/out/remind', // 客户45天内到期迁出提醒
	  CUSTOM_MOVEOUT_OVERDUE: baseUrl + '/api/bszb/incubator/custom/move/out/overdue', // 客户逾期迁出提醒
	  CUSTOM_FINANCING_STATUS: baseUrl + '/api/bszb/incubator/custom/financing/status', // 更改融资状态
	
	  /** 客户标签 */
	  CUSTOM_TAG_DEFAULT: baseUrl + '/api/bszb/incubator/custom/tag/default', // 默认标签
	  CUSTOM_TAG_SAVE: baseUrl + '/api/bszb/incubator/custom/tag/relate/save', // 标签关联
	
	  CUSTOM_PENDING: baseUrl + '/api/bszb/incubator/custom/business/payable/pending', // 待收款
	  CUSTOM_PENDING_EXPORT: baseUrl + '/api/bszb/incubator/custom/business/payable/pending/export', // 待收款导出
	  CUSTOM_PAID: baseUrl + '/api/bszb/incubator/custom/business/payable/paid', // 已收款  -- 全部/工位/地址
	  CUSTOM_PAID_DEPOSIT: baseUrl + '/api/bszb/incubator/custom/business/payable/paid/deposit', // 已收款 -- 在签押金
	  CUSTOM_PAID_LIQUIDATE: baseUrl + '/api/bszb/incubator/custom/business/payable/paid/liquidate', // 已收款 -- 违约金
	  CUSTOM_PAID_TURN: baseUrl + '/api/bszb/incubator/custom/business/payable/paid/turn', // 已收款 -- 已到期押金(已转结)
	  CUSTOM_PAID_TODO: baseUrl + '/api/bszb/incubator/custom/business/payable/paid/todo', // 已收款 -- 已到期押金(待处理)
	  CUSTOM_OBSOLETE: baseUrl + '/api/bszb/incubator/custom/business/payable/obsolete', // 作废款
	  CUSTOM_PENDINGREFUND: baseUrl + '/api/bszb/incubator/custom/business/payable/pendingRefund', // 待退款
	  CUSTOM_PENDINGREFUND_TODO: baseUrl + '/api/bszb/incubator/custom/business/payable/pendingRefund/todo', // 退款时待退款列表
	  CUSTOM_REFUND: baseUrl + '/api/bszb/incubator/custom/business/payable/refunded', // 已退款
	  CUSTOM_PAYABLE_DETAIL_STATIS: baseUrl + '/api/bszb/incubator/custom/business/payable/detail/statistics', // 付款约定明细统计
	  CUSTOM_PAYABLE_STATIS: baseUrl + '/api/bszb/incubator/custom/business/payable/statistics', // 付款约定统计
	
	  CUSTOM_SIGNING: baseUrl + '/api/bszb/incubator/custom/business/signing', // 在签合同
	  CUSTOM_ARCHIVING: baseUrl + '/api/bszb/incubator/custom/business/archiving', // 待归档合同
	  CUSTOM_ARCHIVIED: baseUrl + '/api/bszb/incubator/custom/business/archived', // 归档合同
	
	  /** 孵化器合同付款约定 */
	  INCU_PAYABLE_COLLECTION: baseUrl + '/api/bszb/incubator/business/payable/collection', // 催收款
	  INCU_PAYABLE_OVERDUE: baseUrl + '/api/bszb/incubator/business/payable/overdue', // 逾期款
	  INCU_PAYABLE_ABNORMAL: baseUrl + '/api/bszb/incubator/business/payable/abnormal', // 异常款
	  INCU_PAYABLE_PENDING: baseUrl + '/api/bszb/incubator/business/payable/pending', // 待收款
	  INCU_PAYABLE_PENDING_EXPORT: baseUrl + '/api/bszb/incubator/business/payable/pending/export', // 待收款导出
	  INCU_PAYABLE_PAID: baseUrl + '/api/bszb/incubator/business/payable/paid', // 已收款
	  PAYABLE_PAID_DEPOSIT: baseUrl + '/api/bszb/incubator/business/payable/paid/deposit', // 已收款 -- 在签押金
	  PAYABLE_PAID_LIQUIDATE: baseUrl + '/api/bszb/incubator/business/payable/paid/liquidate', // 已收款 -- 违约金
	  PAYABLE_PAID_TURN: baseUrl + '/api/bszb/incubator/business/payable/paid/turn', // 已收款 -- 已到期押金(已转结)
	  PAYABLE_PAID_TODO: baseUrl + '/api/bszb/incubator/business/payable/paid/todo', // 已收款 -- 已到期押金(待处理)
	  INCU_PAYABLE_OBSOLETE: baseUrl + '/api/bszb/incubator/business/payable/obsolete', // 作废款
	  INCU_PAYABLE_PENDINGREFUND: baseUrl + '/api/bszb/incubator/business/payable/pendingRefund', // 待退款
	  PAYABLE_PENDINGREFUND_REMIND: baseUrl + '/api/bszb/incubator/business/payable/pendingRefund/remind', // 待退款提醒
	  INCU_PAYABLE_REFUNDED: baseUrl + '/api/bszb/incubator/business/payable/refunded', // 已退款
	  INCU_PAYABLE_STATISTICS: baseUrl + '/api/bszb/incubator/business/payable/statistics', // 付款约定统计
	  INCU_PAYABLE_CONFIRM: baseUrl + '/api/bszb/incubator/business/payable/confirm', // 付款约定确认金额
	  INCU_PAYABLE_CANCEL: baseUrl + '/api/bszb/incubator/business/payable/cancel', // 付款约定取消金额
	  INCU_PAYABLE_DETAIL: baseUrl + '/api/bszb/incubator/business/payable/detail', // 付款约定详情
	  INCU_PAYABLE_REFUND: baseUrl + '/api/bszb/incubator/business/payable/refund', // 待处理押金退款处理
	  PAYABLE_DETAIL_STATISTICS: baseUrl + '/api/bszb/incubator/business/payable/detail/statistics', // 付款约定明细统计
	  PAYABLE_SLEEP_SAVE: baseUrl + '/api/bszb/incubator/business/payable/sleep/save', // 已到期押金休眠
	
	  /** 孵化器合同 */
	  INCU_INDEPOSIT_TURN: baseUrl + '/api/bszb/incubator/business/indeposit/turn/save', // 合同转结
	  INCU_BUSINESS_REMIND: baseUrl + '/api/bszb/incubator/business/remind', // 合同提醒
	  INCU_BUSINESS_OVERDUE: baseUrl + '/api/bszb/incubator/business/overdue', // 逾期合同
	  INCU_BUSINESS_SIGNING: baseUrl + '/api/bszb/incubator/business/signing', // 在签合同
	  INCU_BUSINESS_ARCHIVING: baseUrl + '/api/bszb/incubator/business/archiving', // 待归档合同
	  INCU_BUSINESS_ARCHIVED: baseUrl + '/api/bszb/incubator/business/archived', // 档合同
	  ARCHIVE_BUSINESS: baseUrl + '/api/bszb/incubator/business/archive', // 合同归档
	
	  /** 终止合同 */
	  TERMINATION_LIST: baseUrl + '/api/bszb/incubator/business/termination/list', // 终止合同列表
	  TERMINATION_MY: baseUrl + '/api/bszb/incubator/business/termination/my', // 我的终止合同申请列表
	  TERMINATION_INFO: baseUrl + '/api/bszb/incubator/business/termination/info', // 终止合同详情
	  TERMINATION_SAVE: baseUrl + '/api/bszb/incubator/business/termination/save', // 终止合同保存
	  TERMINATION_NEXT: baseUrl + '/api/bszb/incubator/business/termination/nextActivity', // 流程审核
	  TERMINATION_NEXT_SCAN: baseUrl + '/api/bszb/incubator/business/termination/nextActivityScan', // 经办人提交文件扫描件
	  TERMINATION_NEXT_ARCHIVE: baseUrl + '/api/bszb/incubator/business/termination/nextActivityArchive', // 行政文件归档
	  TERMINATION_RETURN: baseUrl + '/api/bszb/incubator/business/termination/returnActivity', // 合同终止流程打回
	  TERMINATION_CALLBACK: baseUrl + '/api/bszb/incubator/business/termination/callbackActivity', // 收回合同终止流程
	  TERMINATION_DELETE: baseUrl + '/api/bszb/incubator/business/termination/delete', // 终止合同删除
	  TERMINATION_WORKFLOW: baseUrl + ' /api/bszb/incubator/business/termination/workflow', // 终止合同流程
	
	  /** 处理退款 */
	  BACK_LIST: baseUrl + '/api/bszb/incubator/business/back/list', // 退款列表
	  BACK_MY: baseUrl + '/api/bszb/incubator/business/back/my', // 我的退款申请列表
	  BACK_INFO: baseUrl + '/api/bszb/incubator/business/back/info', // 退款详情
	  BACK_SAVE: baseUrl + '/api/bszb/incubator/business/back/save', // 退款保存
	  BACK_NEXT: baseUrl + '/api/bszb/incubator/business/back/nextActivity', // 流程审核
	  BACK_RETURN: baseUrl + '/api/bszb/incubator/business/back/returnActivity', // 合同终止流程打回
	  BACK_CALLBACK: baseUrl + '/api/bszb/incubator/business/back/callbackActivity', // 收回合同终止流程
	  BACK_DELETE: baseUrl + '/api/bszb/incubator/business/back/delete', // 退款删除
	  BACK_WORKFLOW: baseUrl + ' /api/bszb/incubator/business/back/workflow', // 退款流程
	
	  /** 错款退款申请 */
	  REFUND_LIST: baseUrl + '/api/bszb/incubator/refund/list', // 退款列表
	  REFUND_MY: baseUrl + '/api/bszb/incubator/refund/my', // 我的退款申请列表
	  REFUND_INFO: baseUrl + '/api/bszb/incubator/refund/info', // 退款详情
	  REFUND_SAVE: baseUrl + '/api/bszb/incubator/refund/save', // 退款保存
	  REFUND_NEXT: baseUrl + '/api/bszb/incubator/refund/nextActivity', // 流程审核
	  REFUND_RETURN: baseUrl + '/api/bszb/incubator/refund/returnActivity', // 合同终止流程打回
	  REFUND_CALLBACK: baseUrl + '/api/bszb/incubator/refund/callbackActivity', // 收回合同终止流程
	  REFUND_DELETE: baseUrl + '/api/bszb/incubator/refund/delete', // 退款删除
	  REFUND_WORKFLOW: baseUrl + ' /api/bszb/incubator/refund/workflow', // 退款流程
	
	  /** 开票 */
	
	  INVOICE_LIST: baseUrl + '/api/bszb/incubator/custom/invoice/list', // 开票合同列表
	  INVOICE_MY: baseUrl + '/api/bszb/incubator/custom/invoice/my', // 我的开票合同申请列表
	  INVOICE_INFO: baseUrl + '/api/bszb/incubator/custom/invoice/info', // 开票合同详情
	  INVOICE_SAVE: baseUrl + '/api/bszb/incubator/custom/invoice/save', // 开票合同保存
	  INVOICE_NEXT: baseUrl + '/api/bszb/incubator/custom/invoice/nextActivity', // 流程审核
	  INVOICE_RETURN: baseUrl + '/api/bszb/incubator/custom/invoice/returnActivity', // 合同开票流程打回
	  INVOICE_CALLBACK: baseUrl + '/api/bszb/incubator/custom/invoice/callbackActivity', // 收回合同开票流程
	  INVOICE_DELETE: baseUrl + '/api/bszb/incubator/custom/invoice/delete', // 开票合同删除
	  INVOICE_WORKFLOW: baseUrl + '/api/bszb/incubator/custom/invoice/workflow', // 开票合同流程
	  INVOICE_INVALID: baseUrl + '/api/bszb/incubator/custom/invoice/invalid', // 发票作废
	  INVOICE_INCU_AVAILABLE: baseUrl + '/api/bszb/incubator/custom/invoice/incubator/available', // 孵化器可开票金额
	  INVOICE_CUSTOM_AVAILABLE: baseUrl + '/api/bszb/incubator/custom/invoice/available', // 客户可开票金额
	  INVOICE_CUSTOM_DOING: baseUrl + '/api/bszb/incubator/custom/invoice/statistics/doing', // 审核中的开票金额
	  INVOICE_CUSTOM_TODO: baseUrl + '/api/bszb/incubator/custom/invoice/todo', // 待开票列表
	
	  /** 财务分析 */
	  AIMS_CONFIG: baseUrl + '/api/bszb/incubator/finance/aims/config', // 收入目标设置
	  FINANCE_INCOME: baseUrl + '/api/bszb/incubator/finance/income/aims', // 孵化器收入情况
	  FINANCE_EXPENDITURE: baseUrl + '/api/bszb/incubator/finance/expenditure/budget', // 孵化器首页支出情况
	  FINANCE_INVESTMENT: baseUrl + '/api/bszb/incubator/finance/investment', // 投资现金回报计算
	  FINANCE_BY_TYPE: baseUrl + '/api/bszb/incubator/finance/statisticsGroupByType', // 财务数据分析 -- 类目
	  FINANCE_BY_MONTH: baseUrl + '/api/bszb/incubator/finance/statisticsGroupByMonth', // 财务数据分析 -- 月份
	  FINANCE_RECORD: baseUrl + '/api/bszb/incubator/finance/record/list', // 财务数据分析 -- 明细
	  FINANCE_BUDGET_BY_TYPE: baseUrl + '/api/bszb/incubator/finance/statisticsGroupBudgetByType', // 预算财务数据分析 -- 类目
	  FINANCE_BUDGET_BY_MONTH: baseUrl + '/api/bszb/incubator/finance/statisticsGroupBudgetByMonth', // 预算财务数据分析 -- 月份
	  FINANCE_BUDGET_RECORD: baseUrl + '/api/bszb/incubator/finance/record/budget', // 预算财务数据分析 -- 明细
	  BUBESINESS_BY_TYPE: baseUrl + '/api/bszb/incubator/finance/unbusiness/statisticsGroupByType', // 非合同款收入 -- 类目
	  BUBESINESS_RECORD: baseUrl + '/api/bszb/incubator/finance/unbusiness/list', // 非合同款收入 -- 类目
	  PROFIT_CHART: baseUrl + '/api/bszb/incubator/finance/profit', // 利润跟踪 -- 图表
	  PROFIT_RECORD: baseUrl + '/api/bszb/incubator/finance/profit/detail', // 利润更新详情
	  FINANCE_EXPORT: baseUrl + '/api/bszb/incubator/finance/record/export', // 导出
	  RELATE_TODO: baseUrl + '/api/bszb/incubator/finance/income/relate/todo', // 孵化器待关联客户资金列表
	  RELATE_DONE: baseUrl + '/api/bszb/incubator/finance/income/relate/done', // 孵化器已关联客户资金列表
	  RELATE_NON: baseUrl + '/api/bszb/incubator/finance/income/relate/non', // 孵化器不关联客户资金列表
	  FINANCE_PAYABLE: baseUrl + '/api/bszb/incubator/finance/payable', // 资金匹配的账单列表
	  RELATE_SAVE: baseUrl + '/api/bszb/incubator/finance/income/relate/save', // 资金关联客户
	  RELATE_CANCEL: baseUrl + '/api/bszb/incubator/finance/income/relate/cancel' // 资金关联客户
	};
	
	var task = exports.task = {
	  /** 项目管理 */
	  PROJ_LIST: baseUrl + '/api/bszb/task/project/list', // 项目监控
	  PROJ_LAU_LIST: baseUrl + '/api/bszb/task/project/launch/list', // 我发起的项目列表
	  PROJ_RECEIVE_LIST: baseUrl + '/api/bszb/task/project/receive/list', // 我收到的项目列表
	  PROJ_SAVE: baseUrl + '/api/bszb/task/project/save', // 项目新增
	  PROJ_DELETE: baseUrl + '/api/bszb/task/project/delete', // 项目删除
	  PROJ_INFO: baseUrl + '/api/bszb/task/project/info', // 项目详情
	  PROJ_UPD_STATUS: baseUrl + '/api/bszb/task/project/updateStatus', // 项目状态修改
	  PROJ_TASK_LIST: baseUrl + '/api/bszb/task/project/task/list', // 项目任务列表
	  PROJ_FILES_LIST: baseUrl + '/api/bszb/task/project/file/list', // 项目文件列表
	  PROJ_FILES_SAVE: baseUrl + '/api/bszb/task/project/file/save', // 项目文件保存
	  PROJ_FILES_DELETE: baseUrl + '/api/bszb/task/project/file/delete', // 项目文件删除
	  PROJ_STAT_RATE: baseUrl + '/api/bszb/task/project/statistics/completion/rate', // 任务完成率统计
	
	  /** 项目目录管理 */
	  PROJ_DIR_LIST: baseUrl + '/api/bszb/task/directory/list', // 项目目录列表
	  PROJ_DIR_INFO: baseUrl + '/api/bszb/task/directory/info', // 项目目录详情
	  PROJ_DIR_SAVE: baseUrl + '/api/bszb/task/directory/save', // 项目目录保存
	  PROJ_DIR_DEL: baseUrl + '/api/bszb/task/directory/delete', // 项目目录删除
	
	  /** 任务管理 */
	  TASK_LIST: baseUrl + '/api/bszb/task/task/list', // 任务监控
	  TASK_SEARCH: baseUrl + '/api/bszb/task/task/search', // 任务高级搜索
	  TASK_LAU_LIST: baseUrl + '/api/bszb/task/task/launch/list', // 我发起的任务列表
	  TASK_RECEIVE_LIST: baseUrl + '/api/bszb/task/task/receive/list', // 我收到的任务列表
	  TASK_SEARCH_LIST: baseUrl + '/api/bszb/task/task/search', // 我收到的任务列表高级搜索
	  TASK_CHECK_LIST: baseUrl + '/api/bszb/task/task/check/list', // 待审核的任务列表监控
	  TASK_CHECK_MY: baseUrl + '/api/bszb/task/task/check/my', // 我的待审核的任务列表
	  TASK_SAVE: baseUrl + '/api/bszb/task/task/save', // 任务新增
	  TASK_COLLECT: baseUrl + '/api/bszb/task/task/collect', // 任务收藏
	  TASK_UNCOLLECT: baseUrl + '/api/bszb/task/task/uncollect', // 任务取消收藏
	  TASK_INFO: baseUrl + '/api/bszb/task/task/info', // 任务详情
	  TASK_FILES: baseUrl + '/api/bszb/task/task/files', // 任务附件
	  TASK_LOG: baseUrl + '/api/bszb/task/task/log', // 任务日志
	  TASK_COMPLETION: baseUrl + '/api/bszb/task/task/completion', // 任务完成
	  TASK_DISCARD: baseUrl + '/api/bszb/task/task/discard', // 任务废弃
	  TASK_DELETE: baseUrl + '/api/bszb/task/task/delete', // 任务删除
	
	  /** 任务审核 */
	  TASKCHECK_NEXT: baseUrl + '/api/bszb/task/task/nextActivity', // 任务审核
	  TASKCHECK_RETURN: baseUrl + '/api/bszb/task/task/returnActivity', // 任务退回
	  TASKCHECK_CALLBACK: baseUrl + '/api/bszb/task/task/callbackActivity', // 任务收回
	  TASKCHECK_WORKFLOW: baseUrl + '/api/bszb/task/task/workflow', // 任务审核流程
	
	  /** 标签管理 */
	  TAG_LIST: baseUrl + '/api/bszb/common/tag/list', // 标签列表
	  TAG_DEL: baseUrl + '/api/bszb/common/tag/delete', // 标签删除
	  TAG_RELATE_DEL: baseUrl + '/api/bszb/common/tag/relate/delete' // 标签关联删除
	};

/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryBusinessInfo = exports.queryBusinessList = exports.querySaveBusiness = exports.queryVerifyCustomContact = exports.querySaveCustomContact = exports.queryCustomContact = exports.queryDepartmentProtection = exports.querySaveDepartmentProtection = exports.querySaveCustomView = exports.queryCustomView = exports.queryCustomField = exports.queryDepartmentProduct = exports.querySaveDepartmentProduct = exports.queryDepartmentOpportunity = exports.querySaveDepartmentOpportunity = exports.querySaveDepartment = exports.queryDepartmentMy = exports.queryDepartmentList = exports.queryClueInfo = exports.queryImportClue = exports.querySaveClue = exports.queryClueList = exports.queryCancelCustomProtection = exports.querySaveCustomProtectionDistribution = exports.querySaveCustomProtection = exports.queryMyCustomProtectionList = exports.queryCustomProtectionList = exports.queryCustomDepartmentInfo = exports.queryCustomDepartmentList = exports.querySaveCustomDepartmentDistribution = exports.queryCustomDepartmentDistributionList = exports.queryDownloadClueTemplate = exports.queryCustomInfo = exports.queryCustomCategory = exports.querySaveDepartmentCustom = exports.querySaveCustom = exports.queryCustomList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 获取客户总表
	 */
	var queryCustomList = exports.queryCustomList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.crm.GET_CUSTOM_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryCustomList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 保存客户
	 * @param {} params
	 * @returns {}
	 */
	
	
	var querySaveCustom = exports.querySaveCustom = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.post(_req.crm.CUSTOM_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function querySaveCustom(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var querySaveDepartmentCustom = exports.querySaveDepartmentCustom = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.post(_req.crm.CUSTOM_DEPARTMENT_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function querySaveDepartmentCustom(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	/**
	 * 一级行业分类
	 * @returns {}
	 */
	
	
	var queryCustomCategory = exports.queryCustomCategory = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(category) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.core.GET_CUISTOM_CATEGORY, {
	              category: category || ''
	            }));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryCustomCategory(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取客户详情
	 * @param {} uuid
	 * @returns {}
	 */
	
	
	var queryCustomInfo = exports.queryCustomInfo = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(uuid) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.crm.GET_CUSTOM_INFO, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryCustomInfo(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	/**
	 * 线索模板下载
	 */
	
	
	var queryDownloadClueTemplate = exports.queryDownloadClueTemplate = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            _http2.default.download(_req.crm.DOWNLOAD_CLUE_TEMPLATE, {}, '线索模板.xlsx');
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryDownloadClueTemplate() {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	/**
	 * 客户的分属部门分配情况
	 * @param {} uuid
	 * @returns {}
	 */
	
	
	var queryCustomDepartmentDistributionList = exports.queryCustomDepartmentDistributionList = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(uuid) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.crm.GET_CUSTOM_DEPARTMENT_DISTRIBUTION_LIST, {
	              uuid: uuid
	            }));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryCustomDepartmentDistributionList(_x6) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	/**
	 * 保存客户的分属部门关联
	 * @param {} params
	 * @returns {}
	 */
	
	
	var querySaveCustomDepartmentDistribution = exports.querySaveCustomDepartmentDistribution = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.post(_req.crm.CUSTOM_DEPARTMENT_DISTRIBUTION_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function querySaveCustomDepartmentDistribution(_x7) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	/**
	 * 分属部门的客户列表
	 * @param {} params
	 * @returns {}
	 */
	
	
	var queryCustomDepartmentList = exports.queryCustomDepartmentList = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.crm.GET_CUSTOM_DEPARTMENT_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryCustomDepartmentList(_x8) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	/**
	 * 分属部门的客户详情
	 * @param {} params
	 * @returns {}
	 */
	
	
	var queryCustomDepartmentInfo = exports.queryCustomDepartmentInfo = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(uuid) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.crm.GET_CUSTOM_DEPARTMENT_INFO, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryCustomDepartmentInfo(_x9) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	/**
	 * 全部客户保护列表
	 * @param {} params
	 * @returns {}
	 */
	
	
	var queryCustomProtectionList = exports.queryCustomProtectionList = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.get(_req.crm.GET_CUSTOM_PROTECTION_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryCustomProtectionList(_x10) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	/**
	 * 个人客户保护列表
	 * @param {} params
	 * @returns {}
	 */
	
	
	var queryMyCustomProtectionList = exports.queryMyCustomProtectionList = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.get(_req.crm.GET_CUSTOM_PROTECTION_MY_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryMyCustomProtectionList(_x11) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	/**
	 * 客户保护
	 * @param {} params
	 * @returns {}
	 */
	
	
	var querySaveCustomProtection = exports.querySaveCustomProtection = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.post(_req.crm.CUSTOM_PROTECTION_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function querySaveCustomProtection(_x12) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	/**
	 * 客户保护分配
	 * @param {} params
	 * @returns {}
	 */
	
	
	var querySaveCustomProtectionDistribution = exports.querySaveCustomProtectionDistribution = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.post(_req.crm.CUSTOM_DEPARTMENT_DISTRIBUTION_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function querySaveCustomProtectionDistribution(_x13) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	/**
	 * 取消客户保护
	 * @param {} uuid
	 * @returns {}
	 */
	
	
	var queryCancelCustomProtection = exports.queryCancelCustomProtection = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt('return', _http2.default.get(_req.crm.CUSTOM_PROTECTION_CANCEL, params));
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function queryCancelCustomProtection(_x14) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var queryClueList = exports.queryClueList = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(params) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            return _context16.abrupt('return', _http2.default.get(_req.crm.GET_CLUE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function queryClueList(_x15) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var querySaveClue = exports.querySaveClue = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(params) {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            return _context17.abrupt('return', _http2.default.post(_req.crm.CLUE_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, this);
	  }));
	
	  return function querySaveClue(_x16) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	
	var queryImportClue = exports.queryImportClue = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(params) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            return _context18.abrupt('return', _http2.default.post(_req.crm.CLUE_IMPORT, params));
	
	          case 1:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, this);
	  }));
	
	  return function queryImportClue(_x17) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	
	var queryClueInfo = exports.queryClueInfo = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(params) {
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            return _context19.abrupt('return', _http2.default.get(_req.crm.GET_CLUE_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context19.stop();
	        }
	      }
	    }, _callee19, this);
	  }));
	
	  return function queryClueInfo(_x18) {
	    return _ref19.apply(this, arguments);
	  };
	}();
	
	var queryDepartmentList = exports.queryDepartmentList = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(params) {
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            return _context20.abrupt('return', _http2.default.get(_req.crm.GET_DEPARTMENT_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context20.stop();
	        }
	      }
	    }, _callee20, this);
	  }));
	
	  return function queryDepartmentList(_x19) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	var queryDepartmentMy = exports.queryDepartmentMy = function () {
	  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(params) {
	    return _regenerator2.default.wrap(function _callee21$(_context21) {
	      while (1) {
	        switch (_context21.prev = _context21.next) {
	          case 0:
	            return _context21.abrupt('return', _http2.default.get(_req.crm.GET_DEPARTMENT_MY, params));
	
	          case 1:
	          case 'end':
	            return _context21.stop();
	        }
	      }
	    }, _callee21, this);
	  }));
	
	  return function queryDepartmentMy(_x20) {
	    return _ref21.apply(this, arguments);
	  };
	}();
	
	var querySaveDepartment = exports.querySaveDepartment = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(params) {
	    return _regenerator2.default.wrap(function _callee22$(_context22) {
	      while (1) {
	        switch (_context22.prev = _context22.next) {
	          case 0:
	            return _context22.abrupt('return', _http2.default.post(_req.crm.GET_DEPARTMENT_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context22.stop();
	        }
	      }
	    }, _callee22, this);
	  }));
	
	  return function querySaveDepartment(_x21) {
	    return _ref22.apply(this, arguments);
	  };
	}();
	
	var querySaveDepartmentOpportunity = exports.querySaveDepartmentOpportunity = function () {
	  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(params) {
	    return _regenerator2.default.wrap(function _callee23$(_context23) {
	      while (1) {
	        switch (_context23.prev = _context23.next) {
	          case 0:
	            return _context23.abrupt('return', _http2.default.post(_req.crm.DEPARTMENT_OPPORTUNITY_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context23.stop();
	        }
	      }
	    }, _callee23, this);
	  }));
	
	  return function querySaveDepartmentOpportunity(_x22) {
	    return _ref23.apply(this, arguments);
	  };
	}();
	
	var queryDepartmentOpportunity = exports.queryDepartmentOpportunity = function () {
	  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(params) {
	    return _regenerator2.default.wrap(function _callee24$(_context24) {
	      while (1) {
	        switch (_context24.prev = _context24.next) {
	          case 0:
	            return _context24.abrupt('return', _http2.default.get(_req.crm.DEPARTMENT_OPPORTUNITY_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context24.stop();
	        }
	      }
	    }, _callee24, this);
	  }));
	
	  return function queryDepartmentOpportunity(_x23) {
	    return _ref24.apply(this, arguments);
	  };
	}();
	
	var querySaveDepartmentProduct = exports.querySaveDepartmentProduct = function () {
	  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(params) {
	    return _regenerator2.default.wrap(function _callee25$(_context25) {
	      while (1) {
	        switch (_context25.prev = _context25.next) {
	          case 0:
	            return _context25.abrupt('return', _http2.default.post(_req.crm.DEPARTMENT_PRODUCT_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context25.stop();
	        }
	      }
	    }, _callee25, this);
	  }));
	
	  return function querySaveDepartmentProduct(_x24) {
	    return _ref25.apply(this, arguments);
	  };
	}();
	
	var queryDepartmentProduct = exports.queryDepartmentProduct = function () {
	  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(params) {
	    return _regenerator2.default.wrap(function _callee26$(_context26) {
	      while (1) {
	        switch (_context26.prev = _context26.next) {
	          case 0:
	            return _context26.abrupt('return', _http2.default.get(_req.crm.DEPARTMENT_PRODUCT_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context26.stop();
	        }
	      }
	    }, _callee26, this);
	  }));
	
	  return function queryDepartmentProduct(_x25) {
	    return _ref26.apply(this, arguments);
	  };
	}();
	
	var queryCustomField = exports.queryCustomField = function () {
	  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(params) {
	    return _regenerator2.default.wrap(function _callee27$(_context27) {
	      while (1) {
	        switch (_context27.prev = _context27.next) {
	          case 0:
	            return _context27.abrupt('return', _http2.default.get(_req.core.GET_CUISTOM_FIELD, params));
	
	          case 1:
	          case 'end':
	            return _context27.stop();
	        }
	      }
	    }, _callee27, this);
	  }));
	
	  return function queryCustomField(_x26) {
	    return _ref27.apply(this, arguments);
	  };
	}();
	
	var queryCustomView = exports.queryCustomView = function () {
	  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(params) {
	    return _regenerator2.default.wrap(function _callee28$(_context28) {
	      while (1) {
	        switch (_context28.prev = _context28.next) {
	          case 0:
	            return _context28.abrupt('return', _http2.default.get(_req.crm.GET_CUISTOM_VIEW, params));
	
	          case 1:
	          case 'end':
	            return _context28.stop();
	        }
	      }
	    }, _callee28, this);
	  }));
	
	  return function queryCustomView(_x27) {
	    return _ref28.apply(this, arguments);
	  };
	}();
	
	var querySaveCustomView = exports.querySaveCustomView = function () {
	  var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(params) {
	    return _regenerator2.default.wrap(function _callee29$(_context29) {
	      while (1) {
	        switch (_context29.prev = _context29.next) {
	          case 0:
	            return _context29.abrupt('return', _http2.default.post(_req.crm.CUISTOM_VIEW_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context29.stop();
	        }
	      }
	    }, _callee29, this);
	  }));
	
	  return function querySaveCustomView(_x28) {
	    return _ref29.apply(this, arguments);
	  };
	}();
	
	var querySaveDepartmentProtection = exports.querySaveDepartmentProtection = function () {
	  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(params) {
	    return _regenerator2.default.wrap(function _callee30$(_context30) {
	      while (1) {
	        switch (_context30.prev = _context30.next) {
	          case 0:
	            return _context30.abrupt('return', _http2.default.post(_req.crm.DEPARTMENT_PROTECTION_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context30.stop();
	        }
	      }
	    }, _callee30, this);
	  }));
	
	  return function querySaveDepartmentProtection(_x29) {
	    return _ref30.apply(this, arguments);
	  };
	}();
	
	var queryDepartmentProtection = exports.queryDepartmentProtection = function () {
	  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(params) {
	    return _regenerator2.default.wrap(function _callee31$(_context31) {
	      while (1) {
	        switch (_context31.prev = _context31.next) {
	          case 0:
	            return _context31.abrupt('return', _http2.default.get(_req.crm.DEPARTMENT_PROTECTION_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context31.stop();
	        }
	      }
	    }, _callee31, this);
	  }));
	
	  return function queryDepartmentProtection(_x30) {
	    return _ref31.apply(this, arguments);
	  };
	}();
	
	var queryCustomContact = exports.queryCustomContact = function () {
	  var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(params) {
	    return _regenerator2.default.wrap(function _callee32$(_context32) {
	      while (1) {
	        switch (_context32.prev = _context32.next) {
	          case 0:
	            return _context32.abrupt('return', _http2.default.get(_req.crm.GET_CUSTOM_CONTACT_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context32.stop();
	        }
	      }
	    }, _callee32, this);
	  }));
	
	  return function queryCustomContact(_x31) {
	    return _ref32.apply(this, arguments);
	  };
	}();
	
	var querySaveCustomContact = exports.querySaveCustomContact = function () {
	  var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(params) {
	    return _regenerator2.default.wrap(function _callee33$(_context33) {
	      while (1) {
	        switch (_context33.prev = _context33.next) {
	          case 0:
	            return _context33.abrupt('return', _http2.default.post(_req.crm.CUSTOM_CONTACT_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context33.stop();
	        }
	      }
	    }, _callee33, this);
	  }));
	
	  return function querySaveCustomContact(_x32) {
	    return _ref33.apply(this, arguments);
	  };
	}();
	
	var queryVerifyCustomContact = exports.queryVerifyCustomContact = function () {
	  var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(params) {
	    return _regenerator2.default.wrap(function _callee34$(_context34) {
	      while (1) {
	        switch (_context34.prev = _context34.next) {
	          case 0:
	            return _context34.abrupt('return', _http2.default.post(_req.crm.CUSTOM_CONTACT_VERIFY, params));
	
	          case 1:
	          case 'end':
	            return _context34.stop();
	        }
	      }
	    }, _callee34, this);
	  }));
	
	  return function queryVerifyCustomContact(_x33) {
	    return _ref34.apply(this, arguments);
	  };
	}();
	
	var querySaveBusiness = exports.querySaveBusiness = function () {
	  var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(params) {
	    return _regenerator2.default.wrap(function _callee35$(_context35) {
	      while (1) {
	        switch (_context35.prev = _context35.next) {
	          case 0:
	            return _context35.abrupt('return', _http2.default.post(_req.crm.OPPORTUNITY_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context35.stop();
	        }
	      }
	    }, _callee35, this);
	  }));
	
	  return function querySaveBusiness(_x34) {
	    return _ref35.apply(this, arguments);
	  };
	}();
	
	var queryBusinessList = exports.queryBusinessList = function () {
	  var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(params) {
	    return _regenerator2.default.wrap(function _callee36$(_context36) {
	      while (1) {
	        switch (_context36.prev = _context36.next) {
	          case 0:
	            return _context36.abrupt('return', _http2.default.get(_req.crm.GET_OPPORTUNITY_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context36.stop();
	        }
	      }
	    }, _callee36, this);
	  }));
	
	  return function queryBusinessList(_x35) {
	    return _ref36.apply(this, arguments);
	  };
	}();
	
	var queryBusinessInfo = exports.queryBusinessInfo = function () {
	  var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(params) {
	    return _regenerator2.default.wrap(function _callee37$(_context37) {
	      while (1) {
	        switch (_context37.prev = _context37.next) {
	          case 0:
	            return _context37.abrupt('return', _http2.default.get(_req.crm.GET_OPPORTUNITY_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context37.stop();
	        }
	      }
	    }, _callee37, this);
	  }));
	
	  return function queryBusinessInfo(_x36) {
	    return _ref37.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Step = _antd.Steps.Step;
	
	var Process = function (_Component) {
	  _inherits(Process, _Component);
	
	  function Process(props) {
	    _classCallCheck(this, Process);
	
	    var _this = _possibleConstructorReturn(this, (Process.__proto__ || Object.getPrototypeOf(Process)).call(this, props));
	
	    _this.getLocation = function (activities, currentActivity) {
	      var location = -1;
	      activities.forEach(function (item, index) {
	        if (item.uuid === currentActivity.uuid) {
	          location = index;
	        }
	      });
	      return location;
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Process, [{
	    key: 'render',
	    value: function render() {
	      var instance = this.props.instance;
	      var status = instance.status;
	
	      var activities = instance.activities || [];
	      var currentActivity = instance.currentActivity || {};
	      var location = this.getLocation(activities, currentActivity);
	      if (status === 1) {
	        location = activities.length + 1;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Steps,
	          { size: 'small', current: location },
	          activities.map(function (item) {
	            return _react2.default.createElement(Step, { title: item.name, key: item.uuid, description: item.processorName });
	          }),
	          _react2.default.createElement(Step, { title: '\u6D41\u7A0B\u7ED3\u675F', key: 'over' })
	        )
	      );
	    }
	  }]);
	
	  return Process;
	}(_react.Component);
	
	exports.default = Process;

/***/ },
/* 35 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (1) The code `if (__DEV__) ...` can be removed by build tool.
	// (2) If intend to use `__DEV__`, this module should be imported. Use a global
	// variable `__DEV__` may cause that miss the declaration (see #6535), or the
	// declaration is behind of the using position (for example in `Model.extent`,
	// And tools like rollup can not analysis the dependency if not import).
	var dev; // In browser
	
	if (typeof window !== 'undefined') {
	  dev = window.__DEV__;
	} // In node
	else if (typeof global !== 'undefined') {
	    dev = global.__DEV__;
	  }
	
	if (typeof dev === 'undefined') {
	  dev = true;
	}
	
	var __DEV__ = dev;
	exports.__DEV__ = __DEV__;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 36 */
/***/ function(module, exports) {

	module.exports = "data:application/octet-stream;base64,Ly8gcmVtb3ZlZCBieSBleHRyYWN0LXRleHQtd2VicGFjay1wbHVnaW4="

/***/ },
/* 37 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "resetWarned", {
	  enumerable: true,
	  get: function get() {
	    return _warning.resetWarned;
	  }
	});
	exports["default"] = void 0;
	
	var _warning = _interopRequireWildcard(__webpack_require__(303));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var _default = function _default(valid, component, message) {
	  (0, _warning["default"])(valid, "[antd: ".concat(component, "] ").concat(message));
	};
	
	exports["default"] = _default;

/***/ },
/* 38 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	__webpack_require__(1186);
	
	var _interceptor = __webpack_require__(738);
	
	var _interceptor2 = _interopRequireDefault(_interceptor);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } } /**
	                                                                                                                                                           * fetch data
	                                                                                                                                                           * 可用 axios 代替
	                                                                                                                                                           */
	
	var Http = function Http() {
	  var _this = this;
	
	  _classCallCheck(this, Http);
	
	  this.get = function (url, params) {
	    // GET请求
	    url = params ? _this.build(url, params) : url;
	    return _this.request(url, {
	      method: 'GET'
	    });
	  };
	
	  this.post = function (url, body) {
	    // POST请求
	    var options = {
	      method: 'POST'
	    };
	    if (body) options.body = JSON.stringify(body);
	    return _this.request(url, options);
	  };
	
	  this.html = function (url, params) {
	    url = params ? _this.build(url, params) : url;
	    return _this.requestHtml(url, {
	      method: 'GET'
	    });
	  };
	
	  this.download = function (url, params, filename) {
	    url = params ? _this.build(url, params) : url;
	    return _this.requestBlod(url, {
	      method: 'GET'
	    }, filename);
	  };
	
	  this.request = function (url, options) {
	    // 根请求
	    options.headers = _this.defaultHeader();
	    options.credentials = 'include';
	    return fetch(url, options)
	    // .then(this.checkStatus)
	    .then(_interceptor2.default).then(function (response) {
	      return response.json();
	    });
	    // .catch(err => browserHistory.replace(`/login`))
	  };
	
	  this.requestHtml = function (url, options) {
	    // 根请求
	    options.headers = _this.defaultHeader();
	    options.credentials = 'include';
	    fetch(url, options)
	    // .then(this.checkStatus)
	    .then(_interceptor2.default).then(function (response) {
	      return response.text();
	    }).then(function (html) {
	      var win = window.open('about:blank', '_blank');
	      win.document.open();
	      win.document.write(html);
	      win.document.close();
	    });
	
	    // .catch(err => browserHistory.replace(`/login`))
	  };
	
	  this.requestBlod = function (url, options, filename) {
	    // 根请求
	    options.headers = _this.defaultHeader();
	    options.credentials = 'include';
	    fetch(url, options)
	    // .then(this.checkStatus)
	    .then(_interceptor2.default).then(function (response) {
	      return response.blob();
	    }).then(function (blob) {
	      console.log('blob:', blob);
	      if (window.navigator.msSaveOrOpenBlob) {
	        navigator.msSaveBlob(blob, filename); // 兼容ie10
	      } else {
	        var a = document.createElement('a');
	        document.body.appendChild(a); // 兼容火狐，将a标签添加到body当中
	        // 获取 blob 本地文件连接 (blob 为纯二进制对象，不能够直接保存到磁盘上)
	        a.href = window.URL.createObjectURL(blob);
	        a.download = filename;
	        a.target = '_blank'; // a标签增加target属性
	        a.click();
	        a.remove(); // 移除a标签
	        window.URL.revokeObjectURL(window.URL.createObjectURL(blob));
	      }
	    });
	
	    // .catch(err => browserHistory.replace(`/login`))
	  };
	
	  this.checkStatus = function (response) {
	    if (response.status >= 200 && response.status < 300) {
	      return response;
	    }
	
	    var error = new Error(response.statusText);
	    error.response = response;
	    throw error;
	  };
	
	  this.defaultHeader = function () {
	    // 默认头
	    return {
	      Accept: 'application/json',
	      'Content-Type': 'application/json',
	      Authorization: '' + _localDb2.default.get('token')
	    };
	  };
	
	  this.build = function (url, params) {
	    // URL构建方法
	    var ps = [];
	    if (params) {
	      Object.keys(params).forEach(function (p) {
	        if (p) {
	          ps.push(p + '=' + encodeURIComponent(params[p]));
	        }
	      });
	    }
	    return url + (url.indexOf('?') === -1 ? '?' : '&') + ps.join('&');
	  };
	};
	
	exports.default = new Http();

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 *  Copyright (c) 2014-2015, Facebook, Inc.
	 *  All rights reserved.
	 *
	 *  This source code is licensed under the BSD-style license found in the
	 *  LICENSE file in the root directory of this source tree. An additional grant
	 *  of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	(function (global, factory) {
	   true ? module.exports = factory() :
	  typeof define === 'function' && define.amd ? define(factory) :
	  global.Immutable = factory();
	}(this, function () { 'use strict';var SLICE$0 = Array.prototype.slice;
	
	  function createClass(ctor, superClass) {
	    if (superClass) {
	      ctor.prototype = Object.create(superClass.prototype);
	    }
	    ctor.prototype.constructor = ctor;
	  }
	
	  function Iterable(value) {
	      return isIterable(value) ? value : Seq(value);
	    }
	
	
	  createClass(KeyedIterable, Iterable);
	    function KeyedIterable(value) {
	      return isKeyed(value) ? value : KeyedSeq(value);
	    }
	
	
	  createClass(IndexedIterable, Iterable);
	    function IndexedIterable(value) {
	      return isIndexed(value) ? value : IndexedSeq(value);
	    }
	
	
	  createClass(SetIterable, Iterable);
	    function SetIterable(value) {
	      return isIterable(value) && !isAssociative(value) ? value : SetSeq(value);
	    }
	
	
	
	  function isIterable(maybeIterable) {
	    return !!(maybeIterable && maybeIterable[IS_ITERABLE_SENTINEL]);
	  }
	
	  function isKeyed(maybeKeyed) {
	    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
	  }
	
	  function isIndexed(maybeIndexed) {
	    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
	  }
	
	  function isAssociative(maybeAssociative) {
	    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
	  }
	
	  function isOrdered(maybeOrdered) {
	    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
	  }
	
	  Iterable.isIterable = isIterable;
	  Iterable.isKeyed = isKeyed;
	  Iterable.isIndexed = isIndexed;
	  Iterable.isAssociative = isAssociative;
	  Iterable.isOrdered = isOrdered;
	
	  Iterable.Keyed = KeyedIterable;
	  Iterable.Indexed = IndexedIterable;
	  Iterable.Set = SetIterable;
	
	
	  var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  // Used for setting prototype methods that IE8 chokes on.
	  var DELETE = 'delete';
	
	  // Constants describing the size of trie nodes.
	  var SHIFT = 5; // Resulted in best performance after ______?
	  var SIZE = 1 << SHIFT;
	  var MASK = SIZE - 1;
	
	  // A consistent shared value representing "not set" which equals nothing other
	  // than itself, and nothing that could be provided externally.
	  var NOT_SET = {};
	
	  // Boolean references, Rough equivalent of `bool &`.
	  var CHANGE_LENGTH = { value: false };
	  var DID_ALTER = { value: false };
	
	  function MakeRef(ref) {
	    ref.value = false;
	    return ref;
	  }
	
	  function SetRef(ref) {
	    ref && (ref.value = true);
	  }
	
	  // A function which returns a value representing an "owner" for transient writes
	  // to tries. The return value will only ever equal itself, and will not equal
	  // the return of any subsequent call of this function.
	  function OwnerID() {}
	
	  // http://jsperf.com/copy-array-inline
	  function arrCopy(arr, offset) {
	    offset = offset || 0;
	    var len = Math.max(0, arr.length - offset);
	    var newArr = new Array(len);
	    for (var ii = 0; ii < len; ii++) {
	      newArr[ii] = arr[ii + offset];
	    }
	    return newArr;
	  }
	
	  function ensureSize(iter) {
	    if (iter.size === undefined) {
	      iter.size = iter.__iterate(returnTrue);
	    }
	    return iter.size;
	  }
	
	  function wrapIndex(iter, index) {
	    // This implements "is array index" which the ECMAString spec defines as:
	    //
	    //     A String property name P is an array index if and only if
	    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
	    //     to 2^32−1.
	    //
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
	    if (typeof index !== 'number') {
	      var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
	      if ('' + uint32Index !== index || uint32Index === 4294967295) {
	        return NaN;
	      }
	      index = uint32Index;
	    }
	    return index < 0 ? ensureSize(iter) + index : index;
	  }
	
	  function returnTrue() {
	    return true;
	  }
	
	  function wholeSlice(begin, end, size) {
	    return (begin === 0 || (size !== undefined && begin <= -size)) &&
	      (end === undefined || (size !== undefined && end >= size));
	  }
	
	  function resolveBegin(begin, size) {
	    return resolveIndex(begin, size, 0);
	  }
	
	  function resolveEnd(end, size) {
	    return resolveIndex(end, size, size);
	  }
	
	  function resolveIndex(index, size, defaultIndex) {
	    return index === undefined ?
	      defaultIndex :
	      index < 0 ?
	        Math.max(0, size + index) :
	        size === undefined ?
	          index :
	          Math.min(size, index);
	  }
	
	  /* global Symbol */
	
	  var ITERATE_KEYS = 0;
	  var ITERATE_VALUES = 1;
	  var ITERATE_ENTRIES = 2;
	
	  var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator';
	
	  var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
	
	
	  function Iterator(next) {
	      this.next = next;
	    }
	
	    Iterator.prototype.toString = function() {
	      return '[Iterator]';
	    };
	
	
	  Iterator.KEYS = ITERATE_KEYS;
	  Iterator.VALUES = ITERATE_VALUES;
	  Iterator.ENTRIES = ITERATE_ENTRIES;
	
	  Iterator.prototype.inspect =
	  Iterator.prototype.toSource = function () { return this.toString(); }
	  Iterator.prototype[ITERATOR_SYMBOL] = function () {
	    return this;
	  };
	
	
	  function iteratorValue(type, k, v, iteratorResult) {
	    var value = type === 0 ? k : type === 1 ? v : [k, v];
	    iteratorResult ? (iteratorResult.value = value) : (iteratorResult = {
	      value: value, done: false
	    });
	    return iteratorResult;
	  }
	
	  function iteratorDone() {
	    return { value: undefined, done: true };
	  }
	
	  function hasIterator(maybeIterable) {
	    return !!getIteratorFn(maybeIterable);
	  }
	
	  function isIterator(maybeIterator) {
	    return maybeIterator && typeof maybeIterator.next === 'function';
	  }
	
	  function getIterator(iterable) {
	    var iteratorFn = getIteratorFn(iterable);
	    return iteratorFn && iteratorFn.call(iterable);
	  }
	
	  function getIteratorFn(iterable) {
	    var iteratorFn = iterable && (
	      (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL]) ||
	      iterable[FAUX_ITERATOR_SYMBOL]
	    );
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  function isArrayLike(value) {
	    return value && typeof value.length === 'number';
	  }
	
	  createClass(Seq, Iterable);
	    function Seq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        isIterable(value) ? value.toSeq() : seqFromValue(value);
	    }
	
	    Seq.of = function(/*...values*/) {
	      return Seq(arguments);
	    };
	
	    Seq.prototype.toSeq = function() {
	      return this;
	    };
	
	    Seq.prototype.toString = function() {
	      return this.__toString('Seq {', '}');
	    };
	
	    Seq.prototype.cacheResult = function() {
	      if (!this._cache && this.__iterateUncached) {
	        this._cache = this.entrySeq().toArray();
	        this.size = this._cache.length;
	      }
	      return this;
	    };
	
	    // abstract __iterateUncached(fn, reverse)
	
	    Seq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, true);
	    };
	
	    // abstract __iteratorUncached(type, reverse)
	
	    Seq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, true);
	    };
	
	
	
	  createClass(KeyedSeq, Seq);
	    function KeyedSeq(value) {
	      return value === null || value === undefined ?
	        emptySequence().toKeyedSeq() :
	        isIterable(value) ?
	          (isKeyed(value) ? value.toSeq() : value.fromEntrySeq()) :
	          keyedSeqFromValue(value);
	    }
	
	    KeyedSeq.prototype.toKeyedSeq = function() {
	      return this;
	    };
	
	
	
	  createClass(IndexedSeq, Seq);
	    function IndexedSeq(value) {
	      return value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value.toIndexedSeq();
	    }
	
	    IndexedSeq.of = function(/*...values*/) {
	      return IndexedSeq(arguments);
	    };
	
	    IndexedSeq.prototype.toIndexedSeq = function() {
	      return this;
	    };
	
	    IndexedSeq.prototype.toString = function() {
	      return this.__toString('Seq [', ']');
	    };
	
	    IndexedSeq.prototype.__iterate = function(fn, reverse) {
	      return seqIterate(this, fn, reverse, false);
	    };
	
	    IndexedSeq.prototype.__iterator = function(type, reverse) {
	      return seqIterator(this, type, reverse, false);
	    };
	
	
	
	  createClass(SetSeq, Seq);
	    function SetSeq(value) {
	      return (
	        value === null || value === undefined ? emptySequence() :
	        !isIterable(value) ? indexedSeqFromValue(value) :
	        isKeyed(value) ? value.entrySeq() : value
	      ).toSetSeq();
	    }
	
	    SetSeq.of = function(/*...values*/) {
	      return SetSeq(arguments);
	    };
	
	    SetSeq.prototype.toSetSeq = function() {
	      return this;
	    };
	
	
	
	  Seq.isSeq = isSeq;
	  Seq.Keyed = KeyedSeq;
	  Seq.Set = SetSeq;
	  Seq.Indexed = IndexedSeq;
	
	  var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
	
	  Seq.prototype[IS_SEQ_SENTINEL] = true;
	
	
	
	  createClass(ArraySeq, IndexedSeq);
	    function ArraySeq(array) {
	      this._array = array;
	      this.size = array.length;
	    }
	
	    ArraySeq.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
	    };
	
	    ArraySeq.prototype.__iterate = function(fn, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(array[reverse ? maxIndex - ii : ii], ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ArraySeq.prototype.__iterator = function(type, reverse) {
	      var array = this._array;
	      var maxIndex = array.length - 1;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, ii, array[reverse ? maxIndex - ii++ : ii++])}
	      );
	    };
	
	
	
	  createClass(ObjectSeq, KeyedSeq);
	    function ObjectSeq(object) {
	      var keys = Object.keys(object);
	      this._object = object;
	      this._keys = keys;
	      this.size = keys.length;
	    }
	
	    ObjectSeq.prototype.get = function(key, notSetValue) {
	      if (notSetValue !== undefined && !this.has(key)) {
	        return notSetValue;
	      }
	      return this._object[key];
	    };
	
	    ObjectSeq.prototype.has = function(key) {
	      return this._object.hasOwnProperty(key);
	    };
	
	    ObjectSeq.prototype.__iterate = function(fn, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        if (fn(object[key], key, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    ObjectSeq.prototype.__iterator = function(type, reverse) {
	      var object = this._object;
	      var keys = this._keys;
	      var maxIndex = keys.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var key = keys[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, key, object[key]);
	      });
	    };
	
	  ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(IterableSeq, IndexedSeq);
	    function IterableSeq(iterable) {
	      this._iterable = iterable;
	      this.size = iterable.length || iterable.size;
	    }
	
	    IterableSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      var iterations = 0;
	      if (isIterator(iterator)) {
	        var step;
	        while (!(step = iterator.next()).done) {
	          if (fn(step.value, iterations++, this) === false) {
	            break;
	          }
	        }
	      }
	      return iterations;
	    };
	
	    IterableSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterable = this._iterable;
	      var iterator = getIterator(iterable);
	      if (!isIterator(iterator)) {
	        return new Iterator(iteratorDone);
	      }
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step : iteratorValue(type, iterations++, step.value);
	      });
	    };
	
	
	
	  createClass(IteratorSeq, IndexedSeq);
	    function IteratorSeq(iterator) {
	      this._iterator = iterator;
	      this._iteratorCache = [];
	    }
	
	    IteratorSeq.prototype.__iterateUncached = function(fn, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      while (iterations < cache.length) {
	        if (fn(cache[iterations], iterations++, this) === false) {
	          return iterations;
	        }
	      }
	      var step;
	      while (!(step = iterator.next()).done) {
	        var val = step.value;
	        cache[iterations] = val;
	        if (fn(val, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	
	    IteratorSeq.prototype.__iteratorUncached = function(type, reverse) {
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = this._iterator;
	      var cache = this._iteratorCache;
	      var iterations = 0;
	      return new Iterator(function()  {
	        if (iterations >= cache.length) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          cache[iterations] = step.value;
	        }
	        return iteratorValue(type, iterations, cache[iterations++]);
	      });
	    };
	
	
	
	
	  // # pragma Helper functions
	
	  function isSeq(maybeSeq) {
	    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
	  }
	
	  var EMPTY_SEQ;
	
	  function emptySequence() {
	    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
	  }
	
	  function keyedSeqFromValue(value) {
	    var seq =
	      Array.isArray(value) ? new ArraySeq(value).fromEntrySeq() :
	      isIterator(value) ? new IteratorSeq(value).fromEntrySeq() :
	      hasIterator(value) ? new IterableSeq(value).fromEntrySeq() :
	      typeof value === 'object' ? new ObjectSeq(value) :
	      undefined;
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of [k, v] entries, '+
	        'or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function indexedSeqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value);
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function seqFromValue(value) {
	    var seq = maybeIndexedSeqFromValue(value) ||
	      (typeof value === 'object' && new ObjectSeq(value));
	    if (!seq) {
	      throw new TypeError(
	        'Expected Array or iterable object of values, or keyed object: ' + value
	      );
	    }
	    return seq;
	  }
	
	  function maybeIndexedSeqFromValue(value) {
	    return (
	      isArrayLike(value) ? new ArraySeq(value) :
	      isIterator(value) ? new IteratorSeq(value) :
	      hasIterator(value) ? new IterableSeq(value) :
	      undefined
	    );
	  }
	
	  function seqIterate(seq, fn, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        if (fn(entry[1], useKeys ? entry[0] : ii, seq) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    }
	    return seq.__iterateUncached(fn, reverse);
	  }
	
	  function seqIterator(seq, type, reverse, useKeys) {
	    var cache = seq._cache;
	    if (cache) {
	      var maxIndex = cache.length - 1;
	      var ii = 0;
	      return new Iterator(function()  {
	        var entry = cache[reverse ? maxIndex - ii : ii];
	        return ii++ > maxIndex ?
	          iteratorDone() :
	          iteratorValue(type, useKeys ? entry[0] : ii - 1, entry[1]);
	      });
	    }
	    return seq.__iteratorUncached(type, reverse);
	  }
	
	  function fromJS(json, converter) {
	    return converter ?
	      fromJSWith(converter, json, '', {'': json}) :
	      fromJSDefault(json);
	  }
	
	  function fromJSWith(converter, json, key, parentJSON) {
	    if (Array.isArray(json)) {
	      return converter.call(parentJSON, key, IndexedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    if (isPlainObj(json)) {
	      return converter.call(parentJSON, key, KeyedSeq(json).map(function(v, k)  {return fromJSWith(converter, v, k, json)}));
	    }
	    return json;
	  }
	
	  function fromJSDefault(json) {
	    if (Array.isArray(json)) {
	      return IndexedSeq(json).map(fromJSDefault).toList();
	    }
	    if (isPlainObj(json)) {
	      return KeyedSeq(json).map(fromJSDefault).toMap();
	    }
	    return json;
	  }
	
	  function isPlainObj(value) {
	    return value && (value.constructor === Object || value.constructor === undefined);
	  }
	
	  /**
	   * An extension of the "same-value" algorithm as [described for use by ES6 Map
	   * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
	   *
	   * NaN is considered the same as NaN, however -0 and 0 are considered the same
	   * value, which is different from the algorithm described by
	   * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
	   *
	   * This is extended further to allow Objects to describe the values they
	   * represent, by way of `valueOf` or `equals` (and `hashCode`).
	   *
	   * Note: because of this extension, the key equality of Immutable.Map and the
	   * value equality of Immutable.Set will differ from ES6 Map and Set.
	   *
	   * ### Defining custom values
	   *
	   * The easiest way to describe the value an object represents is by implementing
	   * `valueOf`. For example, `Date` represents a value by returning a unix
	   * timestamp for `valueOf`:
	   *
	   *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
	   *     var date2 = new Date(1234567890000);
	   *     date1.valueOf(); // 1234567890000
	   *     assert( date1 !== date2 );
	   *     assert( Immutable.is( date1, date2 ) );
	   *
	   * Note: overriding `valueOf` may have other implications if you use this object
	   * where JavaScript expects a primitive, such as implicit string coercion.
	   *
	   * For more complex types, especially collections, implementing `valueOf` may
	   * not be performant. An alternative is to implement `equals` and `hashCode`.
	   *
	   * `equals` takes another object, presumably of similar type, and returns true
	   * if the it is equal. Equality is symmetrical, so the same result should be
	   * returned if this and the argument are flipped.
	   *
	   *     assert( a.equals(b) === b.equals(a) );
	   *
	   * `hashCode` returns a 32bit integer number representing the object which will
	   * be used to determine how to store the value object in a Map or Set. You must
	   * provide both or neither methods, one must not exist without the other.
	   *
	   * Also, an important relationship between these methods must be upheld: if two
	   * values are equal, they *must* return the same hashCode. If the values are not
	   * equal, they might have the same hashCode; this is called a hash collision,
	   * and while undesirable for performance reasons, it is acceptable.
	   *
	   *     if (a.equals(b)) {
	   *       assert( a.hashCode() === b.hashCode() );
	   *     }
	   *
	   * All Immutable collections implement `equals` and `hashCode`.
	   *
	   */
	  function is(valueA, valueB) {
	    if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	      return true;
	    }
	    if (!valueA || !valueB) {
	      return false;
	    }
	    if (typeof valueA.valueOf === 'function' &&
	        typeof valueB.valueOf === 'function') {
	      valueA = valueA.valueOf();
	      valueB = valueB.valueOf();
	      if (valueA === valueB || (valueA !== valueA && valueB !== valueB)) {
	        return true;
	      }
	      if (!valueA || !valueB) {
	        return false;
	      }
	    }
	    if (typeof valueA.equals === 'function' &&
	        typeof valueB.equals === 'function' &&
	        valueA.equals(valueB)) {
	      return true;
	    }
	    return false;
	  }
	
	  function deepEqual(a, b) {
	    if (a === b) {
	      return true;
	    }
	
	    if (
	      !isIterable(b) ||
	      a.size !== undefined && b.size !== undefined && a.size !== b.size ||
	      a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash ||
	      isKeyed(a) !== isKeyed(b) ||
	      isIndexed(a) !== isIndexed(b) ||
	      isOrdered(a) !== isOrdered(b)
	    ) {
	      return false;
	    }
	
	    if (a.size === 0 && b.size === 0) {
	      return true;
	    }
	
	    var notAssociative = !isAssociative(a);
	
	    if (isOrdered(a)) {
	      var entries = a.entries();
	      return b.every(function(v, k)  {
	        var entry = entries.next().value;
	        return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
	      }) && entries.next().done;
	    }
	
	    var flipped = false;
	
	    if (a.size === undefined) {
	      if (b.size === undefined) {
	        if (typeof a.cacheResult === 'function') {
	          a.cacheResult();
	        }
	      } else {
	        flipped = true;
	        var _ = a;
	        a = b;
	        b = _;
	      }
	    }
	
	    var allEqual = true;
	    var bSize = b.__iterate(function(v, k)  {
	      if (notAssociative ? !a.has(v) :
	          flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
	        allEqual = false;
	        return false;
	      }
	    });
	
	    return allEqual && a.size === bSize;
	  }
	
	  createClass(Repeat, IndexedSeq);
	
	    function Repeat(value, times) {
	      if (!(this instanceof Repeat)) {
	        return new Repeat(value, times);
	      }
	      this._value = value;
	      this.size = times === undefined ? Infinity : Math.max(0, times);
	      if (this.size === 0) {
	        if (EMPTY_REPEAT) {
	          return EMPTY_REPEAT;
	        }
	        EMPTY_REPEAT = this;
	      }
	    }
	
	    Repeat.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Repeat []';
	      }
	      return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
	    };
	
	    Repeat.prototype.get = function(index, notSetValue) {
	      return this.has(index) ? this._value : notSetValue;
	    };
	
	    Repeat.prototype.includes = function(searchValue) {
	      return is(this._value, searchValue);
	    };
	
	    Repeat.prototype.slice = function(begin, end) {
	      var size = this.size;
	      return wholeSlice(begin, end, size) ? this :
	        new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
	    };
	
	    Repeat.prototype.reverse = function() {
	      return this;
	    };
	
	    Repeat.prototype.indexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return 0;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.lastIndexOf = function(searchValue) {
	      if (is(this._value, searchValue)) {
	        return this.size;
	      }
	      return -1;
	    };
	
	    Repeat.prototype.__iterate = function(fn, reverse) {
	      for (var ii = 0; ii < this.size; ii++) {
	        if (fn(this._value, ii, this) === false) {
	          return ii + 1;
	        }
	      }
	      return ii;
	    };
	
	    Repeat.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      var ii = 0;
	      return new Iterator(function() 
	        {return ii < this$0.size ? iteratorValue(type, ii++, this$0._value) : iteratorDone()}
	      );
	    };
	
	    Repeat.prototype.equals = function(other) {
	      return other instanceof Repeat ?
	        is(this._value, other._value) :
	        deepEqual(other);
	    };
	
	
	  var EMPTY_REPEAT;
	
	  function invariant(condition, error) {
	    if (!condition) throw new Error(error);
	  }
	
	  createClass(Range, IndexedSeq);
	
	    function Range(start, end, step) {
	      if (!(this instanceof Range)) {
	        return new Range(start, end, step);
	      }
	      invariant(step !== 0, 'Cannot step a Range by 0');
	      start = start || 0;
	      if (end === undefined) {
	        end = Infinity;
	      }
	      step = step === undefined ? 1 : Math.abs(step);
	      if (end < start) {
	        step = -step;
	      }
	      this._start = start;
	      this._end = end;
	      this._step = step;
	      this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
	      if (this.size === 0) {
	        if (EMPTY_RANGE) {
	          return EMPTY_RANGE;
	        }
	        EMPTY_RANGE = this;
	      }
	    }
	
	    Range.prototype.toString = function() {
	      if (this.size === 0) {
	        return 'Range []';
	      }
	      return 'Range [ ' +
	        this._start + '...' + this._end +
	        (this._step > 1 ? ' by ' + this._step : '') +
	      ' ]';
	    };
	
	    Range.prototype.get = function(index, notSetValue) {
	      return this.has(index) ?
	        this._start + wrapIndex(this, index) * this._step :
	        notSetValue;
	    };
	
	    Range.prototype.includes = function(searchValue) {
	      var possibleIndex = (searchValue - this._start) / this._step;
	      return possibleIndex >= 0 &&
	        possibleIndex < this.size &&
	        possibleIndex === Math.floor(possibleIndex);
	    };
	
	    Range.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      begin = resolveBegin(begin, this.size);
	      end = resolveEnd(end, this.size);
	      if (end <= begin) {
	        return new Range(0, 0);
	      }
	      return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
	    };
	
	    Range.prototype.indexOf = function(searchValue) {
	      var offsetValue = searchValue - this._start;
	      if (offsetValue % this._step === 0) {
	        var index = offsetValue / this._step;
	        if (index >= 0 && index < this.size) {
	          return index
	        }
	      }
	      return -1;
	    };
	
	    Range.prototype.lastIndexOf = function(searchValue) {
	      return this.indexOf(searchValue);
	    };
	
	    Range.prototype.__iterate = function(fn, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      for (var ii = 0; ii <= maxIndex; ii++) {
	        if (fn(value, ii, this) === false) {
	          return ii + 1;
	        }
	        value += reverse ? -step : step;
	      }
	      return ii;
	    };
	
	    Range.prototype.__iterator = function(type, reverse) {
	      var maxIndex = this.size - 1;
	      var step = this._step;
	      var value = reverse ? this._start + maxIndex * step : this._start;
	      var ii = 0;
	      return new Iterator(function()  {
	        var v = value;
	        value += reverse ? -step : step;
	        return ii > maxIndex ? iteratorDone() : iteratorValue(type, ii++, v);
	      });
	    };
	
	    Range.prototype.equals = function(other) {
	      return other instanceof Range ?
	        this._start === other._start &&
	        this._end === other._end &&
	        this._step === other._step :
	        deepEqual(this, other);
	    };
	
	
	  var EMPTY_RANGE;
	
	  createClass(Collection, Iterable);
	    function Collection() {
	      throw TypeError('Abstract');
	    }
	
	
	  createClass(KeyedCollection, Collection);function KeyedCollection() {}
	
	  createClass(IndexedCollection, Collection);function IndexedCollection() {}
	
	  createClass(SetCollection, Collection);function SetCollection() {}
	
	
	  Collection.Keyed = KeyedCollection;
	  Collection.Indexed = IndexedCollection;
	  Collection.Set = SetCollection;
	
	  var imul =
	    typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ?
	    Math.imul :
	    function imul(a, b) {
	      a = a | 0; // int
	      b = b | 0; // int
	      var c = a & 0xffff;
	      var d = b & 0xffff;
	      // Shift by 0 fixes the sign on the high part.
	      return (c * d) + ((((a >>> 16) * d + c * (b >>> 16)) << 16) >>> 0) | 0; // int
	    };
	
	  // v8 has an optimization for storing 31-bit signed numbers.
	  // Values which have either 00 or 11 as the high order bits qualify.
	  // This function drops the highest order bit in a signed number, maintaining
	  // the sign bit.
	  function smi(i32) {
	    return ((i32 >>> 1) & 0x40000000) | (i32 & 0xBFFFFFFF);
	  }
	
	  function hash(o) {
	    if (o === false || o === null || o === undefined) {
	      return 0;
	    }
	    if (typeof o.valueOf === 'function') {
	      o = o.valueOf();
	      if (o === false || o === null || o === undefined) {
	        return 0;
	      }
	    }
	    if (o === true) {
	      return 1;
	    }
	    var type = typeof o;
	    if (type === 'number') {
	      var h = o | 0;
	      if (h !== o) {
	        h ^= o * 0xFFFFFFFF;
	      }
	      while (o > 0xFFFFFFFF) {
	        o /= 0xFFFFFFFF;
	        h ^= o;
	      }
	      return smi(h);
	    }
	    if (type === 'string') {
	      return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
	    }
	    if (typeof o.hashCode === 'function') {
	      return o.hashCode();
	    }
	    if (type === 'object') {
	      return hashJSObj(o);
	    }
	    if (typeof o.toString === 'function') {
	      return hashString(o.toString());
	    }
	    throw new Error('Value type ' + type + ' cannot be hashed.');
	  }
	
	  function cachedHashString(string) {
	    var hash = stringHashCache[string];
	    if (hash === undefined) {
	      hash = hashString(string);
	      if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
	        STRING_HASH_CACHE_SIZE = 0;
	        stringHashCache = {};
	      }
	      STRING_HASH_CACHE_SIZE++;
	      stringHashCache[string] = hash;
	    }
	    return hash;
	  }
	
	  // http://jsperf.com/hashing-strings
	  function hashString(string) {
	    // This is the hash from JVM
	    // The hash code for a string is computed as
	    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
	    // where s[i] is the ith character of the string and n is the length of
	    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
	    // (exclusive) by dropping high bits.
	    var hash = 0;
	    for (var ii = 0; ii < string.length; ii++) {
	      hash = 31 * hash + string.charCodeAt(ii) | 0;
	    }
	    return smi(hash);
	  }
	
	  function hashJSObj(obj) {
	    var hash;
	    if (usingWeakMap) {
	      hash = weakMap.get(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = obj[UID_HASH_KEY];
	    if (hash !== undefined) {
	      return hash;
	    }
	
	    if (!canDefineProperty) {
	      hash = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
	      if (hash !== undefined) {
	        return hash;
	      }
	
	      hash = getIENodeHash(obj);
	      if (hash !== undefined) {
	        return hash;
	      }
	    }
	
	    hash = ++objHashUID;
	    if (objHashUID & 0x40000000) {
	      objHashUID = 0;
	    }
	
	    if (usingWeakMap) {
	      weakMap.set(obj, hash);
	    } else if (isExtensible !== undefined && isExtensible(obj) === false) {
	      throw new Error('Non-extensible objects are not allowed as keys.');
	    } else if (canDefineProperty) {
	      Object.defineProperty(obj, UID_HASH_KEY, {
	        'enumerable': false,
	        'configurable': false,
	        'writable': false,
	        'value': hash
	      });
	    } else if (obj.propertyIsEnumerable !== undefined &&
	               obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
	      // Since we can't define a non-enumerable property on the object
	      // we'll hijack one of the less-used non-enumerable properties to
	      // save our hash on it. Since this is a function it will not show up in
	      // `JSON.stringify` which is what we want.
	      obj.propertyIsEnumerable = function() {
	        return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
	      };
	      obj.propertyIsEnumerable[UID_HASH_KEY] = hash;
	    } else if (obj.nodeType !== undefined) {
	      // At this point we couldn't get the IE `uniqueID` to use as a hash
	      // and we couldn't use a non-enumerable property to exploit the
	      // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
	      // itself.
	      obj[UID_HASH_KEY] = hash;
	    } else {
	      throw new Error('Unable to set a non-enumerable property on object.');
	    }
	
	    return hash;
	  }
	
	  // Get references to ES5 object methods.
	  var isExtensible = Object.isExtensible;
	
	  // True if Object.defineProperty works as expected. IE8 fails this test.
	  var canDefineProperty = (function() {
	    try {
	      Object.defineProperty({}, '@', {});
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }());
	
	  // IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
	  // and avoid memory leaks from the IE cloneNode bug.
	  function getIENodeHash(node) {
	    if (node && node.nodeType > 0) {
	      switch (node.nodeType) {
	        case 1: // Element
	          return node.uniqueID;
	        case 9: // Document
	          return node.documentElement && node.documentElement.uniqueID;
	      }
	    }
	  }
	
	  // If possible, use a WeakMap.
	  var usingWeakMap = typeof WeakMap === 'function';
	  var weakMap;
	  if (usingWeakMap) {
	    weakMap = new WeakMap();
	  }
	
	  var objHashUID = 0;
	
	  var UID_HASH_KEY = '__immutablehash__';
	  if (typeof Symbol === 'function') {
	    UID_HASH_KEY = Symbol(UID_HASH_KEY);
	  }
	
	  var STRING_HASH_CACHE_MIN_STRLEN = 16;
	  var STRING_HASH_CACHE_MAX_SIZE = 255;
	  var STRING_HASH_CACHE_SIZE = 0;
	  var stringHashCache = {};
	
	  function assertNotInfinite(size) {
	    invariant(
	      size !== Infinity,
	      'Cannot perform this action with an infinite size.'
	    );
	  }
	
	  createClass(Map, KeyedCollection);
	
	    // @pragma Construction
	
	    function Map(value) {
	      return value === null || value === undefined ? emptyMap() :
	        isMap(value) && !isOrdered(value) ? value :
	        emptyMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    Map.prototype.toString = function() {
	      return this.__toString('Map {', '}');
	    };
	
	    // @pragma Access
	
	    Map.prototype.get = function(k, notSetValue) {
	      return this._root ?
	        this._root.get(0, undefined, k, notSetValue) :
	        notSetValue;
	    };
	
	    // @pragma Modification
	
	    Map.prototype.set = function(k, v) {
	      return updateMap(this, k, v);
	    };
	
	    Map.prototype.setIn = function(keyPath, v) {
	      return this.updateIn(keyPath, NOT_SET, function()  {return v});
	    };
	
	    Map.prototype.remove = function(k) {
	      return updateMap(this, k, NOT_SET);
	    };
	
	    Map.prototype.deleteIn = function(keyPath) {
	      return this.updateIn(keyPath, function()  {return NOT_SET});
	    };
	
	    Map.prototype.update = function(k, notSetValue, updater) {
	      return arguments.length === 1 ?
	        k(this) :
	        this.updateIn([k], notSetValue, updater);
	    };
	
	    Map.prototype.updateIn = function(keyPath, notSetValue, updater) {
	      if (!updater) {
	        updater = notSetValue;
	        notSetValue = undefined;
	      }
	      var updatedValue = updateInDeepMap(
	        this,
	        forceIterator(keyPath),
	        notSetValue,
	        updater
	      );
	      return updatedValue === NOT_SET ? undefined : updatedValue;
	    };
	
	    Map.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._root = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyMap();
	    };
	
	    // @pragma Composition
	
	    Map.prototype.merge = function(/*...iters*/) {
	      return mergeIntoMapWith(this, undefined, arguments);
	    };
	
	    Map.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, merger, iters);
	    };
	
	    Map.prototype.mergeIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.merge === 'function' ?
	          m.merge.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoMapWith(this, deepMerger, arguments);
	    };
	
	    Map.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoMapWith(this, deepMergerWith(merger), iters);
	    };
	
	    Map.prototype.mergeDeepIn = function(keyPath) {var iters = SLICE$0.call(arguments, 1);
	      return this.updateIn(
	        keyPath,
	        emptyMap(),
	        function(m ) {return typeof m.mergeDeep === 'function' ?
	          m.mergeDeep.apply(m, iters) :
	          iters[iters.length - 1]}
	      );
	    };
	
	    Map.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator));
	    };
	
	    Map.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedMap(sortFactory(this, comparator, mapper));
	    };
	
	    // @pragma Mutability
	
	    Map.prototype.withMutations = function(fn) {
	      var mutable = this.asMutable();
	      fn(mutable);
	      return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
	    };
	
	    Map.prototype.asMutable = function() {
	      return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
	    };
	
	    Map.prototype.asImmutable = function() {
	      return this.__ensureOwner();
	    };
	
	    Map.prototype.wasAltered = function() {
	      return this.__altered;
	    };
	
	    Map.prototype.__iterator = function(type, reverse) {
	      return new MapIterator(this, type, reverse);
	    };
	
	    Map.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      this._root && this._root.iterate(function(entry ) {
	        iterations++;
	        return fn(entry[1], entry[0], this$0);
	      }, reverse);
	      return iterations;
	    };
	
	    Map.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeMap(this.size, this._root, ownerID, this.__hash);
	    };
	
	
	  function isMap(maybeMap) {
	    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
	  }
	
	  Map.isMap = isMap;
	
	  var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
	
	  var MapPrototype = Map.prototype;
	  MapPrototype[IS_MAP_SENTINEL] = true;
	  MapPrototype[DELETE] = MapPrototype.remove;
	  MapPrototype.removeIn = MapPrototype.deleteIn;
	
	
	  // #pragma Trie Nodes
	
	
	
	    function ArrayMapNode(ownerID, entries) {
	      this.ownerID = ownerID;
	      this.entries = entries;
	    }
	
	    ArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    ArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && entries.length === 1) {
	        return; // undefined
	      }
	
	      if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) {
	        return createNodes(ownerID, entries, key, value);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new ArrayMapNode(ownerID, newEntries);
	    };
	
	
	
	
	    function BitmapIndexedNode(ownerID, bitmap, nodes) {
	      this.ownerID = ownerID;
	      this.bitmap = bitmap;
	      this.nodes = nodes;
	    }
	
	    BitmapIndexedNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var bit = (1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK));
	      var bitmap = this.bitmap;
	      return (bitmap & bit) === 0 ? notSetValue :
	        this.nodes[popCount(bitmap & (bit - 1))].get(shift + SHIFT, keyHash, key, notSetValue);
	    };
	
	    BitmapIndexedNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var bit = 1 << keyHashFrag;
	      var bitmap = this.bitmap;
	      var exists = (bitmap & bit) !== 0;
	
	      if (!exists && value === NOT_SET) {
	        return this;
	      }
	
	      var idx = popCount(bitmap & (bit - 1));
	      var nodes = this.nodes;
	      var node = exists ? nodes[idx] : undefined;
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	
	      if (newNode === node) {
	        return this;
	      }
	
	      if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) {
	        return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
	      }
	
	      if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) {
	        return nodes[idx ^ 1];
	      }
	
	      if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) {
	        return newNode;
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
	      var newNodes = exists ? newNode ?
	        setIn(nodes, idx, newNode, isEditable) :
	        spliceOut(nodes, idx, isEditable) :
	        spliceIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.bitmap = newBitmap;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
	    };
	
	
	
	
	    function HashArrayMapNode(ownerID, count, nodes) {
	      this.ownerID = ownerID;
	      this.count = count;
	      this.nodes = nodes;
	    }
	
	    HashArrayMapNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var node = this.nodes[idx];
	      return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
	    };
	
	    HashArrayMapNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	      var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	      var removed = value === NOT_SET;
	      var nodes = this.nodes;
	      var node = nodes[idx];
	
	      if (removed && !node) {
	        return this;
	      }
	
	      var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
	      if (newNode === node) {
	        return this;
	      }
	
	      var newCount = this.count;
	      if (!node) {
	        newCount++;
	      } else if (!newNode) {
	        newCount--;
	        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) {
	          return packNodes(ownerID, nodes, newCount, idx);
	        }
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newNodes = setIn(nodes, idx, newNode, isEditable);
	
	      if (isEditable) {
	        this.count = newCount;
	        this.nodes = newNodes;
	        return this;
	      }
	
	      return new HashArrayMapNode(ownerID, newCount, newNodes);
	    };
	
	
	
	
	    function HashCollisionNode(ownerID, keyHash, entries) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entries = entries;
	    }
	
	    HashCollisionNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      var entries = this.entries;
	      for (var ii = 0, len = entries.length; ii < len; ii++) {
	        if (is(key, entries[ii][0])) {
	          return entries[ii][1];
	        }
	      }
	      return notSetValue;
	    };
	
	    HashCollisionNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      if (keyHash === undefined) {
	        keyHash = hash(key);
	      }
	
	      var removed = value === NOT_SET;
	
	      if (keyHash !== this.keyHash) {
	        if (removed) {
	          return this;
	        }
	        SetRef(didAlter);
	        SetRef(didChangeSize);
	        return mergeIntoNode(this, ownerID, shift, keyHash, [key, value]);
	      }
	
	      var entries = this.entries;
	      var idx = 0;
	      for (var len = entries.length; idx < len; idx++) {
	        if (is(key, entries[idx][0])) {
	          break;
	        }
	      }
	      var exists = idx < len;
	
	      if (exists ? entries[idx][1] === value : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	      (removed || !exists) && SetRef(didChangeSize);
	
	      if (removed && len === 2) {
	        return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
	      }
	
	      var isEditable = ownerID && ownerID === this.ownerID;
	      var newEntries = isEditable ? entries : arrCopy(entries);
	
	      if (exists) {
	        if (removed) {
	          idx === len - 1 ? newEntries.pop() : (newEntries[idx] = newEntries.pop());
	        } else {
	          newEntries[idx] = [key, value];
	        }
	      } else {
	        newEntries.push([key, value]);
	      }
	
	      if (isEditable) {
	        this.entries = newEntries;
	        return this;
	      }
	
	      return new HashCollisionNode(ownerID, this.keyHash, newEntries);
	    };
	
	
	
	
	    function ValueNode(ownerID, keyHash, entry) {
	      this.ownerID = ownerID;
	      this.keyHash = keyHash;
	      this.entry = entry;
	    }
	
	    ValueNode.prototype.get = function(shift, keyHash, key, notSetValue) {
	      return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
	    };
	
	    ValueNode.prototype.update = function(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	      var removed = value === NOT_SET;
	      var keyMatch = is(key, this.entry[0]);
	      if (keyMatch ? value === this.entry[1] : removed) {
	        return this;
	      }
	
	      SetRef(didAlter);
	
	      if (removed) {
	        SetRef(didChangeSize);
	        return; // undefined
	      }
	
	      if (keyMatch) {
	        if (ownerID && ownerID === this.ownerID) {
	          this.entry[1] = value;
	          return this;
	        }
	        return new ValueNode(ownerID, this.keyHash, [key, value]);
	      }
	
	      SetRef(didChangeSize);
	      return mergeIntoNode(this, ownerID, shift, hash(key), [key, value]);
	    };
	
	
	
	  // #pragma Iterators
	
	  ArrayMapNode.prototype.iterate =
	  HashCollisionNode.prototype.iterate = function (fn, reverse) {
	    var entries = this.entries;
	    for (var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++) {
	      if (fn(entries[reverse ? maxIndex - ii : ii]) === false) {
	        return false;
	      }
	    }
	  }
	
	  BitmapIndexedNode.prototype.iterate =
	  HashArrayMapNode.prototype.iterate = function (fn, reverse) {
	    var nodes = this.nodes;
	    for (var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++) {
	      var node = nodes[reverse ? maxIndex - ii : ii];
	      if (node && node.iterate(fn, reverse) === false) {
	        return false;
	      }
	    }
	  }
	
	  ValueNode.prototype.iterate = function (fn, reverse) {
	    return fn(this.entry);
	  }
	
	  createClass(MapIterator, Iterator);
	
	    function MapIterator(map, type, reverse) {
	      this._type = type;
	      this._reverse = reverse;
	      this._stack = map._root && mapIteratorFrame(map._root);
	    }
	
	    MapIterator.prototype.next = function() {
	      var type = this._type;
	      var stack = this._stack;
	      while (stack) {
	        var node = stack.node;
	        var index = stack.index++;
	        var maxIndex;
	        if (node.entry) {
	          if (index === 0) {
	            return mapIteratorValue(type, node.entry);
	          }
	        } else if (node.entries) {
	          maxIndex = node.entries.length - 1;
	          if (index <= maxIndex) {
	            return mapIteratorValue(type, node.entries[this._reverse ? maxIndex - index : index]);
	          }
	        } else {
	          maxIndex = node.nodes.length - 1;
	          if (index <= maxIndex) {
	            var subNode = node.nodes[this._reverse ? maxIndex - index : index];
	            if (subNode) {
	              if (subNode.entry) {
	                return mapIteratorValue(type, subNode.entry);
	              }
	              stack = this._stack = mapIteratorFrame(subNode, stack);
	            }
	            continue;
	          }
	        }
	        stack = this._stack = this._stack.__prev;
	      }
	      return iteratorDone();
	    };
	
	
	  function mapIteratorValue(type, entry) {
	    return iteratorValue(type, entry[0], entry[1]);
	  }
	
	  function mapIteratorFrame(node, prev) {
	    return {
	      node: node,
	      index: 0,
	      __prev: prev
	    };
	  }
	
	  function makeMap(size, root, ownerID, hash) {
	    var map = Object.create(MapPrototype);
	    map.size = size;
	    map._root = root;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_MAP;
	  function emptyMap() {
	    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
	  }
	
	  function updateMap(map, k, v) {
	    var newRoot;
	    var newSize;
	    if (!map._root) {
	      if (v === NOT_SET) {
	        return map;
	      }
	      newSize = 1;
	      newRoot = new ArrayMapNode(map.__ownerID, [[k, v]]);
	    } else {
	      var didChangeSize = MakeRef(CHANGE_LENGTH);
	      var didAlter = MakeRef(DID_ALTER);
	      newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
	      if (!didAlter.value) {
	        return map;
	      }
	      newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
	    }
	    if (map.__ownerID) {
	      map.size = newSize;
	      map._root = newRoot;
	      map.__hash = undefined;
	      map.__altered = true;
	      return map;
	    }
	    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
	  }
	
	  function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
	    if (!node) {
	      if (value === NOT_SET) {
	        return node;
	      }
	      SetRef(didAlter);
	      SetRef(didChangeSize);
	      return new ValueNode(ownerID, keyHash, [key, value]);
	    }
	    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
	  }
	
	  function isLeafNode(node) {
	    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
	  }
	
	  function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
	    if (node.keyHash === keyHash) {
	      return new HashCollisionNode(ownerID, keyHash, [node.entry, entry]);
	    }
	
	    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
	    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
	
	    var newNode;
	    var nodes = idx1 === idx2 ?
	      [mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)] :
	      ((newNode = new ValueNode(ownerID, keyHash, entry)), idx1 < idx2 ? [node, newNode] : [newNode, node]);
	
	    return new BitmapIndexedNode(ownerID, (1 << idx1) | (1 << idx2), nodes);
	  }
	
	  function createNodes(ownerID, entries, key, value) {
	    if (!ownerID) {
	      ownerID = new OwnerID();
	    }
	    var node = new ValueNode(ownerID, hash(key), [key, value]);
	    for (var ii = 0; ii < entries.length; ii++) {
	      var entry = entries[ii];
	      node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
	    }
	    return node;
	  }
	
	  function packNodes(ownerID, nodes, count, excluding) {
	    var bitmap = 0;
	    var packedII = 0;
	    var packedNodes = new Array(count);
	    for (var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1) {
	      var node = nodes[ii];
	      if (node !== undefined && ii !== excluding) {
	        bitmap |= bit;
	        packedNodes[packedII++] = node;
	      }
	    }
	    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
	  }
	
	  function expandNodes(ownerID, nodes, bitmap, including, node) {
	    var count = 0;
	    var expandedNodes = new Array(SIZE);
	    for (var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1) {
	      expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
	    }
	    expandedNodes[including] = node;
	    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
	  }
	
	  function mergeIntoMapWith(map, merger, iterables) {
	    var iters = [];
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = KeyedIterable(value);
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    return mergeIntoCollectionWith(map, merger, iters);
	  }
	
	  function deepMerger(existing, value, key) {
	    return existing && existing.mergeDeep && isIterable(value) ?
	      existing.mergeDeep(value) :
	      is(existing, value) ? existing : value;
	  }
	
	  function deepMergerWith(merger) {
	    return function(existing, value, key)  {
	      if (existing && existing.mergeDeepWith && isIterable(value)) {
	        return existing.mergeDeepWith(merger, value);
	      }
	      var nextValue = merger(existing, value, key);
	      return is(existing, nextValue) ? existing : nextValue;
	    };
	  }
	
	  function mergeIntoCollectionWith(collection, merger, iters) {
	    iters = iters.filter(function(x ) {return x.size !== 0});
	    if (iters.length === 0) {
	      return collection;
	    }
	    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) {
	      return collection.constructor(iters[0]);
	    }
	    return collection.withMutations(function(collection ) {
	      var mergeIntoMap = merger ?
	        function(value, key)  {
	          collection.update(key, NOT_SET, function(existing )
	            {return existing === NOT_SET ? value : merger(existing, value, key)}
	          );
	        } :
	        function(value, key)  {
	          collection.set(key, value);
	        }
	      for (var ii = 0; ii < iters.length; ii++) {
	        iters[ii].forEach(mergeIntoMap);
	      }
	    });
	  }
	
	  function updateInDeepMap(existing, keyPathIter, notSetValue, updater) {
	    var isNotSet = existing === NOT_SET;
	    var step = keyPathIter.next();
	    if (step.done) {
	      var existingValue = isNotSet ? notSetValue : existing;
	      var newValue = updater(existingValue);
	      return newValue === existingValue ? existing : newValue;
	    }
	    invariant(
	      isNotSet || (existing && existing.set),
	      'invalid keyPath'
	    );
	    var key = step.value;
	    var nextExisting = isNotSet ? NOT_SET : existing.get(key, NOT_SET);
	    var nextUpdated = updateInDeepMap(
	      nextExisting,
	      keyPathIter,
	      notSetValue,
	      updater
	    );
	    return nextUpdated === nextExisting ? existing :
	      nextUpdated === NOT_SET ? existing.remove(key) :
	      (isNotSet ? emptyMap() : existing).set(key, nextUpdated);
	  }
	
	  function popCount(x) {
	    x = x - ((x >> 1) & 0x55555555);
	    x = (x & 0x33333333) + ((x >> 2) & 0x33333333);
	    x = (x + (x >> 4)) & 0x0f0f0f0f;
	    x = x + (x >> 8);
	    x = x + (x >> 16);
	    return x & 0x7f;
	  }
	
	  function setIn(array, idx, val, canEdit) {
	    var newArray = canEdit ? array : arrCopy(array);
	    newArray[idx] = val;
	    return newArray;
	  }
	
	  function spliceIn(array, idx, val, canEdit) {
	    var newLen = array.length + 1;
	    if (canEdit && idx + 1 === newLen) {
	      array[idx] = val;
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        newArray[ii] = val;
	        after = -1;
	      } else {
	        newArray[ii] = array[ii + after];
	      }
	    }
	    return newArray;
	  }
	
	  function spliceOut(array, idx, canEdit) {
	    var newLen = array.length - 1;
	    if (canEdit && idx === newLen) {
	      array.pop();
	      return array;
	    }
	    var newArray = new Array(newLen);
	    var after = 0;
	    for (var ii = 0; ii < newLen; ii++) {
	      if (ii === idx) {
	        after = 1;
	      }
	      newArray[ii] = array[ii + after];
	    }
	    return newArray;
	  }
	
	  var MAX_ARRAY_MAP_SIZE = SIZE / 4;
	  var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
	  var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
	
	  createClass(List, IndexedCollection);
	
	    // @pragma Construction
	
	    function List(value) {
	      var empty = emptyList();
	      if (value === null || value === undefined) {
	        return empty;
	      }
	      if (isList(value)) {
	        return value;
	      }
	      var iter = IndexedIterable(value);
	      var size = iter.size;
	      if (size === 0) {
	        return empty;
	      }
	      assertNotInfinite(size);
	      if (size > 0 && size < SIZE) {
	        return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
	      }
	      return empty.withMutations(function(list ) {
	        list.setSize(size);
	        iter.forEach(function(v, i)  {return list.set(i, v)});
	      });
	    }
	
	    List.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    List.prototype.toString = function() {
	      return this.__toString('List [', ']');
	    };
	
	    // @pragma Access
	
	    List.prototype.get = function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      if (index >= 0 && index < this.size) {
	        index += this._origin;
	        var node = listNodeFor(this, index);
	        return node && node.array[index & MASK];
	      }
	      return notSetValue;
	    };
	
	    // @pragma Modification
	
	    List.prototype.set = function(index, value) {
	      return updateList(this, index, value);
	    };
	
	    List.prototype.remove = function(index) {
	      return !this.has(index) ? this :
	        index === 0 ? this.shift() :
	        index === this.size - 1 ? this.pop() :
	        this.splice(index, 1);
	    };
	
	    List.prototype.insert = function(index, value) {
	      return this.splice(index, 0, value);
	    };
	
	    List.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = this._origin = this._capacity = 0;
	        this._level = SHIFT;
	        this._root = this._tail = null;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyList();
	    };
	
	    List.prototype.push = function(/*...values*/) {
	      var values = arguments;
	      var oldSize = this.size;
	      return this.withMutations(function(list ) {
	        setListBounds(list, 0, oldSize + values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(oldSize + ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.pop = function() {
	      return setListBounds(this, 0, -1);
	    };
	
	    List.prototype.unshift = function(/*...values*/) {
	      var values = arguments;
	      return this.withMutations(function(list ) {
	        setListBounds(list, -values.length);
	        for (var ii = 0; ii < values.length; ii++) {
	          list.set(ii, values[ii]);
	        }
	      });
	    };
	
	    List.prototype.shift = function() {
	      return setListBounds(this, 1);
	    };
	
	    // @pragma Composition
	
	    List.prototype.merge = function(/*...iters*/) {
	      return mergeIntoListWith(this, undefined, arguments);
	    };
	
	    List.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, merger, iters);
	    };
	
	    List.prototype.mergeDeep = function(/*...iters*/) {
	      return mergeIntoListWith(this, deepMerger, arguments);
	    };
	
	    List.prototype.mergeDeepWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return mergeIntoListWith(this, deepMergerWith(merger), iters);
	    };
	
	    List.prototype.setSize = function(size) {
	      return setListBounds(this, 0, size);
	    };
	
	    // @pragma Iteration
	
	    List.prototype.slice = function(begin, end) {
	      var size = this.size;
	      if (wholeSlice(begin, end, size)) {
	        return this;
	      }
	      return setListBounds(
	        this,
	        resolveBegin(begin, size),
	        resolveEnd(end, size)
	      );
	    };
	
	    List.prototype.__iterator = function(type, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      return new Iterator(function()  {
	        var value = values();
	        return value === DONE ?
	          iteratorDone() :
	          iteratorValue(type, index++, value);
	      });
	    };
	
	    List.prototype.__iterate = function(fn, reverse) {
	      var index = 0;
	      var values = iterateList(this, reverse);
	      var value;
	      while ((value = values()) !== DONE) {
	        if (fn(value, index++, this) === false) {
	          break;
	        }
	      }
	      return index;
	    };
	
	    List.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        return this;
	      }
	      return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
	    };
	
	
	  function isList(maybeList) {
	    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
	  }
	
	  List.isList = isList;
	
	  var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
	
	  var ListPrototype = List.prototype;
	  ListPrototype[IS_LIST_SENTINEL] = true;
	  ListPrototype[DELETE] = ListPrototype.remove;
	  ListPrototype.setIn = MapPrototype.setIn;
	  ListPrototype.deleteIn =
	  ListPrototype.removeIn = MapPrototype.removeIn;
	  ListPrototype.update = MapPrototype.update;
	  ListPrototype.updateIn = MapPrototype.updateIn;
	  ListPrototype.mergeIn = MapPrototype.mergeIn;
	  ListPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  ListPrototype.withMutations = MapPrototype.withMutations;
	  ListPrototype.asMutable = MapPrototype.asMutable;
	  ListPrototype.asImmutable = MapPrototype.asImmutable;
	  ListPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	
	    function VNode(array, ownerID) {
	      this.array = array;
	      this.ownerID = ownerID;
	    }
	
	    // TODO: seems like these methods are very similar
	
	    VNode.prototype.removeBefore = function(ownerID, level, index) {
	      if (index === level ? 1 << level : 0 || this.array.length === 0) {
	        return this;
	      }
	      var originIndex = (index >>> level) & MASK;
	      if (originIndex >= this.array.length) {
	        return new VNode([], ownerID);
	      }
	      var removingFirst = originIndex === 0;
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[originIndex];
	        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && removingFirst) {
	          return this;
	        }
	      }
	      if (removingFirst && !newChild) {
	        return this;
	      }
	      var editable = editableVNode(this, ownerID);
	      if (!removingFirst) {
	        for (var ii = 0; ii < originIndex; ii++) {
	          editable.array[ii] = undefined;
	        }
	      }
	      if (newChild) {
	        editable.array[originIndex] = newChild;
	      }
	      return editable;
	    };
	
	    VNode.prototype.removeAfter = function(ownerID, level, index) {
	      if (index === (level ? 1 << level : 0) || this.array.length === 0) {
	        return this;
	      }
	      var sizeIndex = ((index - 1) >>> level) & MASK;
	      if (sizeIndex >= this.array.length) {
	        return this;
	      }
	
	      var newChild;
	      if (level > 0) {
	        var oldChild = this.array[sizeIndex];
	        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
	        if (newChild === oldChild && sizeIndex === this.array.length - 1) {
	          return this;
	        }
	      }
	
	      var editable = editableVNode(this, ownerID);
	      editable.array.splice(sizeIndex + 1);
	      if (newChild) {
	        editable.array[sizeIndex] = newChild;
	      }
	      return editable;
	    };
	
	
	
	  var DONE = {};
	
	  function iterateList(list, reverse) {
	    var left = list._origin;
	    var right = list._capacity;
	    var tailPos = getTailOffset(right);
	    var tail = list._tail;
	
	    return iterateNodeOrLeaf(list._root, list._level, 0);
	
	    function iterateNodeOrLeaf(node, level, offset) {
	      return level === 0 ?
	        iterateLeaf(node, offset) :
	        iterateNode(node, level, offset);
	    }
	
	    function iterateLeaf(node, offset) {
	      var array = offset === tailPos ? tail && tail.array : node && node.array;
	      var from = offset > left ? 0 : left - offset;
	      var to = right - offset;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        if (from === to) {
	          return DONE;
	        }
	        var idx = reverse ? --to : from++;
	        return array && array[idx];
	      };
	    }
	
	    function iterateNode(node, level, offset) {
	      var values;
	      var array = node && node.array;
	      var from = offset > left ? 0 : (left - offset) >> level;
	      var to = ((right - offset) >> level) + 1;
	      if (to > SIZE) {
	        to = SIZE;
	      }
	      return function()  {
	        do {
	          if (values) {
	            var value = values();
	            if (value !== DONE) {
	              return value;
	            }
	            values = null;
	          }
	          if (from === to) {
	            return DONE;
	          }
	          var idx = reverse ? --to : from++;
	          values = iterateNodeOrLeaf(
	            array && array[idx], level - SHIFT, offset + (idx << level)
	          );
	        } while (true);
	      };
	    }
	  }
	
	  function makeList(origin, capacity, level, root, tail, ownerID, hash) {
	    var list = Object.create(ListPrototype);
	    list.size = capacity - origin;
	    list._origin = origin;
	    list._capacity = capacity;
	    list._level = level;
	    list._root = root;
	    list._tail = tail;
	    list.__ownerID = ownerID;
	    list.__hash = hash;
	    list.__altered = false;
	    return list;
	  }
	
	  var EMPTY_LIST;
	  function emptyList() {
	    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
	  }
	
	  function updateList(list, index, value) {
	    index = wrapIndex(list, index);
	
	    if (index !== index) {
	      return list;
	    }
	
	    if (index >= list.size || index < 0) {
	      return list.withMutations(function(list ) {
	        index < 0 ?
	          setListBounds(list, index).set(0, value) :
	          setListBounds(list, 0, index + 1).set(index, value)
	      });
	    }
	
	    index += list._origin;
	
	    var newTail = list._tail;
	    var newRoot = list._root;
	    var didAlter = MakeRef(DID_ALTER);
	    if (index >= getTailOffset(list._capacity)) {
	      newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
	    } else {
	      newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
	    }
	
	    if (!didAlter.value) {
	      return list;
	    }
	
	    if (list.__ownerID) {
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
	  }
	
	  function updateVNode(node, ownerID, level, index, value, didAlter) {
	    var idx = (index >>> level) & MASK;
	    var nodeHas = node && idx < node.array.length;
	    if (!nodeHas && value === undefined) {
	      return node;
	    }
	
	    var newNode;
	
	    if (level > 0) {
	      var lowerNode = node && node.array[idx];
	      var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
	      if (newLowerNode === lowerNode) {
	        return node;
	      }
	      newNode = editableVNode(node, ownerID);
	      newNode.array[idx] = newLowerNode;
	      return newNode;
	    }
	
	    if (nodeHas && node.array[idx] === value) {
	      return node;
	    }
	
	    SetRef(didAlter);
	
	    newNode = editableVNode(node, ownerID);
	    if (value === undefined && idx === newNode.array.length - 1) {
	      newNode.array.pop();
	    } else {
	      newNode.array[idx] = value;
	    }
	    return newNode;
	  }
	
	  function editableVNode(node, ownerID) {
	    if (ownerID && node && ownerID === node.ownerID) {
	      return node;
	    }
	    return new VNode(node ? node.array.slice() : [], ownerID);
	  }
	
	  function listNodeFor(list, rawIndex) {
	    if (rawIndex >= getTailOffset(list._capacity)) {
	      return list._tail;
	    }
	    if (rawIndex < 1 << (list._level + SHIFT)) {
	      var node = list._root;
	      var level = list._level;
	      while (node && level > 0) {
	        node = node.array[(rawIndex >>> level) & MASK];
	        level -= SHIFT;
	      }
	      return node;
	    }
	  }
	
	  function setListBounds(list, begin, end) {
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	    var owner = list.__ownerID || new OwnerID();
	    var oldOrigin = list._origin;
	    var oldCapacity = list._capacity;
	    var newOrigin = oldOrigin + begin;
	    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
	    if (newOrigin === oldOrigin && newCapacity === oldCapacity) {
	      return list;
	    }
	
	    // If it's going to end after it starts, it's empty.
	    if (newOrigin >= newCapacity) {
	      return list.clear();
	    }
	
	    var newLevel = list._level;
	    var newRoot = list._root;
	
	    // New origin might need creating a higher root.
	    var offsetShift = 0;
	    while (newOrigin + offsetShift < 0) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [undefined, newRoot] : [], owner);
	      newLevel += SHIFT;
	      offsetShift += 1 << newLevel;
	    }
	    if (offsetShift) {
	      newOrigin += offsetShift;
	      oldOrigin += offsetShift;
	      newCapacity += offsetShift;
	      oldCapacity += offsetShift;
	    }
	
	    var oldTailOffset = getTailOffset(oldCapacity);
	    var newTailOffset = getTailOffset(newCapacity);
	
	    // New size might need creating a higher root.
	    while (newTailOffset >= 1 << (newLevel + SHIFT)) {
	      newRoot = new VNode(newRoot && newRoot.array.length ? [newRoot] : [], owner);
	      newLevel += SHIFT;
	    }
	
	    // Locate or create the new tail.
	    var oldTail = list._tail;
	    var newTail = newTailOffset < oldTailOffset ?
	      listNodeFor(list, newCapacity - 1) :
	      newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
	
	    // Merge Tail into tree.
	    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
	      newRoot = editableVNode(newRoot, owner);
	      var node = newRoot;
	      for (var level = newLevel; level > SHIFT; level -= SHIFT) {
	        var idx = (oldTailOffset >>> level) & MASK;
	        node = node.array[idx] = editableVNode(node.array[idx], owner);
	      }
	      node.array[(oldTailOffset >>> SHIFT) & MASK] = oldTail;
	    }
	
	    // If the size has been reduced, there's a chance the tail needs to be trimmed.
	    if (newCapacity < oldCapacity) {
	      newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
	    }
	
	    // If the new origin is within the tail, then we do not need a root.
	    if (newOrigin >= newTailOffset) {
	      newOrigin -= newTailOffset;
	      newCapacity -= newTailOffset;
	      newLevel = SHIFT;
	      newRoot = null;
	      newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
	
	    // Otherwise, if the root has been trimmed, garbage collect.
	    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
	      offsetShift = 0;
	
	      // Identify the new top root node of the subtree of the old root.
	      while (newRoot) {
	        var beginIndex = (newOrigin >>> newLevel) & MASK;
	        if (beginIndex !== (newTailOffset >>> newLevel) & MASK) {
	          break;
	        }
	        if (beginIndex) {
	          offsetShift += (1 << newLevel) * beginIndex;
	        }
	        newLevel -= SHIFT;
	        newRoot = newRoot.array[beginIndex];
	      }
	
	      // Trim the new sides of the new root.
	      if (newRoot && newOrigin > oldOrigin) {
	        newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
	      }
	      if (newRoot && newTailOffset < oldTailOffset) {
	        newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
	      }
	      if (offsetShift) {
	        newOrigin -= offsetShift;
	        newCapacity -= offsetShift;
	      }
	    }
	
	    if (list.__ownerID) {
	      list.size = newCapacity - newOrigin;
	      list._origin = newOrigin;
	      list._capacity = newCapacity;
	      list._level = newLevel;
	      list._root = newRoot;
	      list._tail = newTail;
	      list.__hash = undefined;
	      list.__altered = true;
	      return list;
	    }
	    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
	  }
	
	  function mergeIntoListWith(list, merger, iterables) {
	    var iters = [];
	    var maxSize = 0;
	    for (var ii = 0; ii < iterables.length; ii++) {
	      var value = iterables[ii];
	      var iter = IndexedIterable(value);
	      if (iter.size > maxSize) {
	        maxSize = iter.size;
	      }
	      if (!isIterable(value)) {
	        iter = iter.map(function(v ) {return fromJS(v)});
	      }
	      iters.push(iter);
	    }
	    if (maxSize > list.size) {
	      list = list.setSize(maxSize);
	    }
	    return mergeIntoCollectionWith(list, merger, iters);
	  }
	
	  function getTailOffset(size) {
	    return size < SIZE ? 0 : (((size - 1) >>> SHIFT) << SHIFT);
	  }
	
	  createClass(OrderedMap, Map);
	
	    // @pragma Construction
	
	    function OrderedMap(value) {
	      return value === null || value === undefined ? emptyOrderedMap() :
	        isOrderedMap(value) ? value :
	        emptyOrderedMap().withMutations(function(map ) {
	          var iter = KeyedIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v, k)  {return map.set(k, v)});
	        });
	    }
	
	    OrderedMap.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedMap.prototype.toString = function() {
	      return this.__toString('OrderedMap {', '}');
	    };
	
	    // @pragma Access
	
	    OrderedMap.prototype.get = function(k, notSetValue) {
	      var index = this._map.get(k);
	      return index !== undefined ? this._list.get(index)[1] : notSetValue;
	    };
	
	    // @pragma Modification
	
	    OrderedMap.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._map.clear();
	        this._list.clear();
	        return this;
	      }
	      return emptyOrderedMap();
	    };
	
	    OrderedMap.prototype.set = function(k, v) {
	      return updateOrderedMap(this, k, v);
	    };
	
	    OrderedMap.prototype.remove = function(k) {
	      return updateOrderedMap(this, k, NOT_SET);
	    };
	
	    OrderedMap.prototype.wasAltered = function() {
	      return this._map.wasAltered() || this._list.wasAltered();
	    };
	
	    OrderedMap.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._list.__iterate(
	        function(entry ) {return entry && fn(entry[1], entry[0], this$0)},
	        reverse
	      );
	    };
	
	    OrderedMap.prototype.__iterator = function(type, reverse) {
	      return this._list.fromEntrySeq().__iterator(type, reverse);
	    };
	
	    OrderedMap.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      var newList = this._list.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        this._list = newList;
	        return this;
	      }
	      return makeOrderedMap(newMap, newList, ownerID, this.__hash);
	    };
	
	
	  function isOrderedMap(maybeOrderedMap) {
	    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
	  }
	
	  OrderedMap.isOrderedMap = isOrderedMap;
	
	  OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
	  OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
	
	
	
	  function makeOrderedMap(map, list, ownerID, hash) {
	    var omap = Object.create(OrderedMap.prototype);
	    omap.size = map ? map.size : 0;
	    omap._map = map;
	    omap._list = list;
	    omap.__ownerID = ownerID;
	    omap.__hash = hash;
	    return omap;
	  }
	
	  var EMPTY_ORDERED_MAP;
	  function emptyOrderedMap() {
	    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
	  }
	
	  function updateOrderedMap(omap, k, v) {
	    var map = omap._map;
	    var list = omap._list;
	    var i = map.get(k);
	    var has = i !== undefined;
	    var newMap;
	    var newList;
	    if (v === NOT_SET) { // removed
	      if (!has) {
	        return omap;
	      }
	      if (list.size >= SIZE && list.size >= map.size * 2) {
	        newList = list.filter(function(entry, idx)  {return entry !== undefined && i !== idx});
	        newMap = newList.toKeyedSeq().map(function(entry ) {return entry[0]}).flip().toMap();
	        if (omap.__ownerID) {
	          newMap.__ownerID = newList.__ownerID = omap.__ownerID;
	        }
	      } else {
	        newMap = map.remove(k);
	        newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
	      }
	    } else {
	      if (has) {
	        if (v === list.get(i)[1]) {
	          return omap;
	        }
	        newMap = map;
	        newList = list.set(i, [k, v]);
	      } else {
	        newMap = map.set(k, list.size);
	        newList = list.set(list.size, [k, v]);
	      }
	    }
	    if (omap.__ownerID) {
	      omap.size = newMap.size;
	      omap._map = newMap;
	      omap._list = newList;
	      omap.__hash = undefined;
	      return omap;
	    }
	    return makeOrderedMap(newMap, newList);
	  }
	
	  createClass(ToKeyedSequence, KeyedSeq);
	    function ToKeyedSequence(indexed, useKeys) {
	      this._iter = indexed;
	      this._useKeys = useKeys;
	      this.size = indexed.size;
	    }
	
	    ToKeyedSequence.prototype.get = function(key, notSetValue) {
	      return this._iter.get(key, notSetValue);
	    };
	
	    ToKeyedSequence.prototype.has = function(key) {
	      return this._iter.has(key);
	    };
	
	    ToKeyedSequence.prototype.valueSeq = function() {
	      return this._iter.valueSeq();
	    };
	
	    ToKeyedSequence.prototype.reverse = function() {var this$0 = this;
	      var reversedSequence = reverseFactory(this, true);
	      if (!this._useKeys) {
	        reversedSequence.valueSeq = function()  {return this$0._iter.toSeq().reverse()};
	      }
	      return reversedSequence;
	    };
	
	    ToKeyedSequence.prototype.map = function(mapper, context) {var this$0 = this;
	      var mappedSequence = mapFactory(this, mapper, context);
	      if (!this._useKeys) {
	        mappedSequence.valueSeq = function()  {return this$0._iter.toSeq().map(mapper, context)};
	      }
	      return mappedSequence;
	    };
	
	    ToKeyedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var ii;
	      return this._iter.__iterate(
	        this._useKeys ?
	          function(v, k)  {return fn(v, k, this$0)} :
	          ((ii = reverse ? resolveSize(this) : 0),
	            function(v ) {return fn(v, reverse ? --ii : ii++, this$0)}),
	        reverse
	      );
	    };
	
	    ToKeyedSequence.prototype.__iterator = function(type, reverse) {
	      if (this._useKeys) {
	        return this._iter.__iterator(type, reverse);
	      }
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var ii = reverse ? resolveSize(this) : 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, reverse ? --ii : ii++, step.value, step);
	      });
	    };
	
	  ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	  createClass(ToIndexedSequence, IndexedSeq);
	    function ToIndexedSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToIndexedSequence.prototype.includes = function(value) {
	      return this._iter.includes(value);
	    };
	
	    ToIndexedSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      return this._iter.__iterate(function(v ) {return fn(v, iterations++, this$0)}, reverse);
	    };
	
	    ToIndexedSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, iterations++, step.value, step)
	      });
	    };
	
	
	
	  createClass(ToSetSequence, SetSeq);
	    function ToSetSequence(iter) {
	      this._iter = iter;
	      this.size = iter.size;
	    }
	
	    ToSetSequence.prototype.has = function(key) {
	      return this._iter.includes(key);
	    };
	
	    ToSetSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(v ) {return fn(v, v, this$0)}, reverse);
	    };
	
	    ToSetSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        return step.done ? step :
	          iteratorValue(type, step.value, step.value, step);
	      });
	    };
	
	
	
	  createClass(FromEntriesSequence, KeyedSeq);
	    function FromEntriesSequence(entries) {
	      this._iter = entries;
	      this.size = entries.size;
	    }
	
	    FromEntriesSequence.prototype.entrySeq = function() {
	      return this._iter.toSeq();
	    };
	
	    FromEntriesSequence.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._iter.__iterate(function(entry ) {
	        // Check if entry exists first so array access doesn't throw for holes
	        // in the parent iteration.
	        if (entry) {
	          validateEntry(entry);
	          var indexedIterable = isIterable(entry);
	          return fn(
	            indexedIterable ? entry.get(1) : entry[1],
	            indexedIterable ? entry.get(0) : entry[0],
	            this$0
	          );
	        }
	      }, reverse);
	    };
	
	    FromEntriesSequence.prototype.__iterator = function(type, reverse) {
	      var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          // Check if entry exists first so array access doesn't throw for holes
	          // in the parent iteration.
	          if (entry) {
	            validateEntry(entry);
	            var indexedIterable = isIterable(entry);
	            return iteratorValue(
	              type,
	              indexedIterable ? entry.get(0) : entry[0],
	              indexedIterable ? entry.get(1) : entry[1],
	              step
	            );
	          }
	        }
	      });
	    };
	
	
	  ToIndexedSequence.prototype.cacheResult =
	  ToKeyedSequence.prototype.cacheResult =
	  ToSetSequence.prototype.cacheResult =
	  FromEntriesSequence.prototype.cacheResult =
	    cacheResultThrough;
	
	
	  function flipFactory(iterable) {
	    var flipSequence = makeSequence(iterable);
	    flipSequence._iter = iterable;
	    flipSequence.size = iterable.size;
	    flipSequence.flip = function()  {return iterable};
	    flipSequence.reverse = function () {
	      var reversedSequence = iterable.reverse.apply(this); // super.reverse()
	      reversedSequence.flip = function()  {return iterable.reverse()};
	      return reversedSequence;
	    };
	    flipSequence.has = function(key ) {return iterable.includes(key)};
	    flipSequence.includes = function(key ) {return iterable.has(key)};
	    flipSequence.cacheResult = cacheResultThrough;
	    flipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(k, v, this$0) !== false}, reverse);
	    }
	    flipSequence.__iteratorUncached = function(type, reverse) {
	      if (type === ITERATE_ENTRIES) {
	        var iterator = iterable.__iterator(type, reverse);
	        return new Iterator(function()  {
	          var step = iterator.next();
	          if (!step.done) {
	            var k = step.value[0];
	            step.value[0] = step.value[1];
	            step.value[1] = k;
	          }
	          return step;
	        });
	      }
	      return iterable.__iterator(
	        type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES,
	        reverse
	      );
	    }
	    return flipSequence;
	  }
	
	
	  function mapFactory(iterable, mapper, context) {
	    var mappedSequence = makeSequence(iterable);
	    mappedSequence.size = iterable.size;
	    mappedSequence.has = function(key ) {return iterable.has(key)};
	    mappedSequence.get = function(key, notSetValue)  {
	      var v = iterable.get(key, NOT_SET);
	      return v === NOT_SET ?
	        notSetValue :
	        mapper.call(context, v, key, iterable);
	    };
	    mappedSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(
	        function(v, k, c)  {return fn(mapper.call(context, v, k, c), k, this$0) !== false},
	        reverse
	      );
	    }
	    mappedSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      return new Iterator(function()  {
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var key = entry[0];
	        return iteratorValue(
	          type,
	          key,
	          mapper.call(context, entry[1], key, iterable),
	          step
	        );
	      });
	    }
	    return mappedSequence;
	  }
	
	
	  function reverseFactory(iterable, useKeys) {
	    var reversedSequence = makeSequence(iterable);
	    reversedSequence._iter = iterable;
	    reversedSequence.size = iterable.size;
	    reversedSequence.reverse = function()  {return iterable};
	    if (iterable.flip) {
	      reversedSequence.flip = function () {
	        var flipSequence = flipFactory(iterable);
	        flipSequence.reverse = function()  {return iterable.flip()};
	        return flipSequence;
	      };
	    }
	    reversedSequence.get = function(key, notSetValue) 
	      {return iterable.get(useKeys ? key : -1 - key, notSetValue)};
	    reversedSequence.has = function(key )
	      {return iterable.has(useKeys ? key : -1 - key)};
	    reversedSequence.includes = function(value ) {return iterable.includes(value)};
	    reversedSequence.cacheResult = cacheResultThrough;
	    reversedSequence.__iterate = function (fn, reverse) {var this$0 = this;
	      return iterable.__iterate(function(v, k)  {return fn(v, k, this$0)}, !reverse);
	    };
	    reversedSequence.__iterator =
	      function(type, reverse)  {return iterable.__iterator(type, !reverse)};
	    return reversedSequence;
	  }
	
	
	  function filterFactory(iterable, predicate, context, useKeys) {
	    var filterSequence = makeSequence(iterable);
	    if (useKeys) {
	      filterSequence.has = function(key ) {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && !!predicate.call(context, v, key, iterable);
	      };
	      filterSequence.get = function(key, notSetValue)  {
	        var v = iterable.get(key, NOT_SET);
	        return v !== NOT_SET && predicate.call(context, v, key, iterable) ?
	          v : notSetValue;
	      };
	    }
	    filterSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      }, reverse);
	      return iterations;
	    };
	    filterSequence.__iteratorUncached = function (type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (true) {
	          var step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	          var entry = step.value;
	          var key = entry[0];
	          var value = entry[1];
	          if (predicate.call(context, value, key, iterable)) {
	            return iteratorValue(type, useKeys ? key : iterations++, value, step);
	          }
	        }
	      });
	    }
	    return filterSequence;
	  }
	
	
	  function countByFactory(iterable, grouper, context) {
	    var groups = Map().asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        0,
	        function(a ) {return a + 1}
	      );
	    });
	    return groups.asImmutable();
	  }
	
	
	  function groupByFactory(iterable, grouper, context) {
	    var isKeyedIter = isKeyed(iterable);
	    var groups = (isOrdered(iterable) ? OrderedMap() : Map()).asMutable();
	    iterable.__iterate(function(v, k)  {
	      groups.update(
	        grouper.call(context, v, k, iterable),
	        function(a ) {return (a = a || [], a.push(isKeyedIter ? [k, v] : v), a)}
	      );
	    });
	    var coerce = iterableClass(iterable);
	    return groups.map(function(arr ) {return reify(iterable, coerce(arr))});
	  }
	
	
	  function sliceFactory(iterable, begin, end, useKeys) {
	    var originalSize = iterable.size;
	
	    // Sanitize begin & end using this shorthand for ToInt32(argument)
	    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
	    if (begin !== undefined) {
	      begin = begin | 0;
	    }
	    if (end !== undefined) {
	      end = end | 0;
	    }
	
	    if (wholeSlice(begin, end, originalSize)) {
	      return iterable;
	    }
	
	    var resolvedBegin = resolveBegin(begin, originalSize);
	    var resolvedEnd = resolveEnd(end, originalSize);
	
	    // begin or end will be NaN if they were provided as negative numbers and
	    // this iterable's size is unknown. In that case, cache first so there is
	    // a known size and these do not resolve to NaN.
	    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) {
	      return sliceFactory(iterable.toSeq().cacheResult(), begin, end, useKeys);
	    }
	
	    // Note: resolvedEnd is undefined when the original sequence's length is
	    // unknown and this slice did not supply an end and should contain all
	    // elements after resolvedBegin.
	    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
	    var resolvedSize = resolvedEnd - resolvedBegin;
	    var sliceSize;
	    if (resolvedSize === resolvedSize) {
	      sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
	    }
	
	    var sliceSeq = makeSequence(iterable);
	
	    // If iterable.size is undefined, the size of the realized sliceSeq is
	    // unknown at this point unless the number of items to slice is 0
	    sliceSeq.size = sliceSize === 0 ? sliceSize : iterable.size && sliceSize || undefined;
	
	    if (!useKeys && isSeq(iterable) && sliceSize >= 0) {
	      sliceSeq.get = function (index, notSetValue) {
	        index = wrapIndex(this, index);
	        return index >= 0 && index < sliceSize ?
	          iterable.get(index + resolvedBegin, notSetValue) :
	          notSetValue;
	      }
	    }
	
	    sliceSeq.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (sliceSize === 0) {
	        return 0;
	      }
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var skipped = 0;
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k)  {
	        if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0) !== false &&
	                 iterations !== sliceSize;
	        }
	      });
	      return iterations;
	    };
	
	    sliceSeq.__iteratorUncached = function(type, reverse) {
	      if (sliceSize !== 0 && reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      // Don't bother instantiating parent iterator if taking 0.
	      var iterator = sliceSize !== 0 && iterable.__iterator(type, reverse);
	      var skipped = 0;
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (skipped++ < resolvedBegin) {
	          iterator.next();
	        }
	        if (++iterations > sliceSize) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (useKeys || type === ITERATE_VALUES) {
	          return step;
	        } else if (type === ITERATE_KEYS) {
	          return iteratorValue(type, iterations - 1, undefined, step);
	        } else {
	          return iteratorValue(type, iterations - 1, step.value[1], step);
	        }
	      });
	    }
	
	    return sliceSeq;
	  }
	
	
	  function takeWhileFactory(iterable, predicate, context) {
	    var takeSequence = makeSequence(iterable);
	    takeSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c) 
	        {return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$0)}
	      );
	      return iterations;
	    };
	    takeSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var iterating = true;
	      return new Iterator(function()  {
	        if (!iterating) {
	          return iteratorDone();
	        }
	        var step = iterator.next();
	        if (step.done) {
	          return step;
	        }
	        var entry = step.value;
	        var k = entry[0];
	        var v = entry[1];
	        if (!predicate.call(context, v, k, this$0)) {
	          iterating = false;
	          return iteratorDone();
	        }
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return takeSequence;
	  }
	
	
	  function skipWhileFactory(iterable, predicate, context, useKeys) {
	    var skipSequence = makeSequence(iterable);
	    skipSequence.__iterateUncached = function (fn, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterate(fn, reverse);
	      }
	      var isSkipping = true;
	      var iterations = 0;
	      iterable.__iterate(function(v, k, c)  {
	        if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
	          iterations++;
	          return fn(v, useKeys ? k : iterations - 1, this$0);
	        }
	      });
	      return iterations;
	    };
	    skipSequence.__iteratorUncached = function(type, reverse) {var this$0 = this;
	      if (reverse) {
	        return this.cacheResult().__iterator(type, reverse);
	      }
	      var iterator = iterable.__iterator(ITERATE_ENTRIES, reverse);
	      var skipping = true;
	      var iterations = 0;
	      return new Iterator(function()  {
	        var step, k, v;
	        do {
	          step = iterator.next();
	          if (step.done) {
	            if (useKeys || type === ITERATE_VALUES) {
	              return step;
	            } else if (type === ITERATE_KEYS) {
	              return iteratorValue(type, iterations++, undefined, step);
	            } else {
	              return iteratorValue(type, iterations++, step.value[1], step);
	            }
	          }
	          var entry = step.value;
	          k = entry[0];
	          v = entry[1];
	          skipping && (skipping = predicate.call(context, v, k, this$0));
	        } while (skipping);
	        return type === ITERATE_ENTRIES ? step :
	          iteratorValue(type, k, v, step);
	      });
	    };
	    return skipSequence;
	  }
	
	
	  function concatFactory(iterable, values) {
	    var isKeyedIterable = isKeyed(iterable);
	    var iters = [iterable].concat(values).map(function(v ) {
	      if (!isIterable(v)) {
	        v = isKeyedIterable ?
	          keyedSeqFromValue(v) :
	          indexedSeqFromValue(Array.isArray(v) ? v : [v]);
	      } else if (isKeyedIterable) {
	        v = KeyedIterable(v);
	      }
	      return v;
	    }).filter(function(v ) {return v.size !== 0});
	
	    if (iters.length === 0) {
	      return iterable;
	    }
	
	    if (iters.length === 1) {
	      var singleton = iters[0];
	      if (singleton === iterable ||
	          isKeyedIterable && isKeyed(singleton) ||
	          isIndexed(iterable) && isIndexed(singleton)) {
	        return singleton;
	      }
	    }
	
	    var concatSeq = new ArraySeq(iters);
	    if (isKeyedIterable) {
	      concatSeq = concatSeq.toKeyedSeq();
	    } else if (!isIndexed(iterable)) {
	      concatSeq = concatSeq.toSetSeq();
	    }
	    concatSeq = concatSeq.flatten(true);
	    concatSeq.size = iters.reduce(
	      function(sum, seq)  {
	        if (sum !== undefined) {
	          var size = seq.size;
	          if (size !== undefined) {
	            return sum + size;
	          }
	        }
	      },
	      0
	    );
	    return concatSeq;
	  }
	
	
	  function flattenFactory(iterable, depth, useKeys) {
	    var flatSequence = makeSequence(iterable);
	    flatSequence.__iterateUncached = function(fn, reverse) {
	      var iterations = 0;
	      var stopped = false;
	      function flatDeep(iter, currentDepth) {var this$0 = this;
	        iter.__iterate(function(v, k)  {
	          if ((!depth || currentDepth < depth) && isIterable(v)) {
	            flatDeep(v, currentDepth + 1);
	          } else if (fn(v, useKeys ? k : iterations++, this$0) === false) {
	            stopped = true;
	          }
	          return !stopped;
	        }, reverse);
	      }
	      flatDeep(iterable, 0);
	      return iterations;
	    }
	    flatSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(type, reverse);
	      var stack = [];
	      var iterations = 0;
	      return new Iterator(function()  {
	        while (iterator) {
	          var step = iterator.next();
	          if (step.done !== false) {
	            iterator = stack.pop();
	            continue;
	          }
	          var v = step.value;
	          if (type === ITERATE_ENTRIES) {
	            v = v[1];
	          }
	          if ((!depth || stack.length < depth) && isIterable(v)) {
	            stack.push(iterator);
	            iterator = v.__iterator(type, reverse);
	          } else {
	            return useKeys ? step : iteratorValue(type, iterations++, v, step);
	          }
	        }
	        return iteratorDone();
	      });
	    }
	    return flatSequence;
	  }
	
	
	  function flatMapFactory(iterable, mapper, context) {
	    var coerce = iterableClass(iterable);
	    return iterable.toSeq().map(
	      function(v, k)  {return coerce(mapper.call(context, v, k, iterable))}
	    ).flatten(true);
	  }
	
	
	  function interposeFactory(iterable, separator) {
	    var interposedSequence = makeSequence(iterable);
	    interposedSequence.size = iterable.size && iterable.size * 2 -1;
	    interposedSequence.__iterateUncached = function(fn, reverse) {var this$0 = this;
	      var iterations = 0;
	      iterable.__iterate(function(v, k) 
	        {return (!iterations || fn(separator, iterations++, this$0) !== false) &&
	        fn(v, iterations++, this$0) !== false},
	        reverse
	      );
	      return iterations;
	    };
	    interposedSequence.__iteratorUncached = function(type, reverse) {
	      var iterator = iterable.__iterator(ITERATE_VALUES, reverse);
	      var iterations = 0;
	      var step;
	      return new Iterator(function()  {
	        if (!step || iterations % 2) {
	          step = iterator.next();
	          if (step.done) {
	            return step;
	          }
	        }
	        return iterations % 2 ?
	          iteratorValue(type, iterations++, separator) :
	          iteratorValue(type, iterations++, step.value, step);
	      });
	    };
	    return interposedSequence;
	  }
	
	
	  function sortFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    var isKeyedIterable = isKeyed(iterable);
	    var index = 0;
	    var entries = iterable.toSeq().map(
	      function(v, k)  {return [k, v, index++, mapper ? mapper(v, k, iterable) : v]}
	    ).toArray();
	    entries.sort(function(a, b)  {return comparator(a[3], b[3]) || a[2] - b[2]}).forEach(
	      isKeyedIterable ?
	      function(v, i)  { entries[i].length = 2; } :
	      function(v, i)  { entries[i] = v[1]; }
	    );
	    return isKeyedIterable ? KeyedSeq(entries) :
	      isIndexed(iterable) ? IndexedSeq(entries) :
	      SetSeq(entries);
	  }
	
	
	  function maxFactory(iterable, comparator, mapper) {
	    if (!comparator) {
	      comparator = defaultComparator;
	    }
	    if (mapper) {
	      var entry = iterable.toSeq()
	        .map(function(v, k)  {return [v, mapper(v, k, iterable)]})
	        .reduce(function(a, b)  {return maxCompare(comparator, a[1], b[1]) ? b : a});
	      return entry && entry[0];
	    } else {
	      return iterable.reduce(function(a, b)  {return maxCompare(comparator, a, b) ? b : a});
	    }
	  }
	
	  function maxCompare(comparator, a, b) {
	    var comp = comparator(b, a);
	    // b is considered the new max if the comparator declares them equal, but
	    // they are not equal and b is in fact a nullish value.
	    return (comp === 0 && b !== a && (b === undefined || b === null || b !== b)) || comp > 0;
	  }
	
	
	  function zipWithFactory(keyIter, zipper, iters) {
	    var zipSequence = makeSequence(keyIter);
	    zipSequence.size = new ArraySeq(iters).map(function(i ) {return i.size}).min();
	    // Note: this a generic base implementation of __iterate in terms of
	    // __iterator which may be more generically useful in the future.
	    zipSequence.__iterate = function(fn, reverse) {
	      /* generic:
	      var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        iterations++;
	        if (fn(step.value[1], step.value[0], this) === false) {
	          break;
	        }
	      }
	      return iterations;
	      */
	      // indexed:
	      var iterator = this.__iterator(ITERATE_VALUES, reverse);
	      var step;
	      var iterations = 0;
	      while (!(step = iterator.next()).done) {
	        if (fn(step.value, iterations++, this) === false) {
	          break;
	        }
	      }
	      return iterations;
	    };
	    zipSequence.__iteratorUncached = function(type, reverse) {
	      var iterators = iters.map(function(i )
	        {return (i = Iterable(i), getIterator(reverse ? i.reverse() : i))}
	      );
	      var iterations = 0;
	      var isDone = false;
	      return new Iterator(function()  {
	        var steps;
	        if (!isDone) {
	          steps = iterators.map(function(i ) {return i.next()});
	          isDone = steps.some(function(s ) {return s.done});
	        }
	        if (isDone) {
	          return iteratorDone();
	        }
	        return iteratorValue(
	          type,
	          iterations++,
	          zipper.apply(null, steps.map(function(s ) {return s.value}))
	        );
	      });
	    };
	    return zipSequence
	  }
	
	
	  // #pragma Helper Functions
	
	  function reify(iter, seq) {
	    return isSeq(iter) ? seq : iter.constructor(seq);
	  }
	
	  function validateEntry(entry) {
	    if (entry !== Object(entry)) {
	      throw new TypeError('Expected [K, V] tuple: ' + entry);
	    }
	  }
	
	  function resolveSize(iter) {
	    assertNotInfinite(iter.size);
	    return ensureSize(iter);
	  }
	
	  function iterableClass(iterable) {
	    return isKeyed(iterable) ? KeyedIterable :
	      isIndexed(iterable) ? IndexedIterable :
	      SetIterable;
	  }
	
	  function makeSequence(iterable) {
	    return Object.create(
	      (
	        isKeyed(iterable) ? KeyedSeq :
	        isIndexed(iterable) ? IndexedSeq :
	        SetSeq
	      ).prototype
	    );
	  }
	
	  function cacheResultThrough() {
	    if (this._iter.cacheResult) {
	      this._iter.cacheResult();
	      this.size = this._iter.size;
	      return this;
	    } else {
	      return Seq.prototype.cacheResult.call(this);
	    }
	  }
	
	  function defaultComparator(a, b) {
	    return a > b ? 1 : a < b ? -1 : 0;
	  }
	
	  function forceIterator(keyPath) {
	    var iter = getIterator(keyPath);
	    if (!iter) {
	      // Array might not be iterable in this environment, so we need a fallback
	      // to our wrapped type.
	      if (!isArrayLike(keyPath)) {
	        throw new TypeError('Expected iterable or array-like: ' + keyPath);
	      }
	      iter = getIterator(Iterable(keyPath));
	    }
	    return iter;
	  }
	
	  createClass(Record, KeyedCollection);
	
	    function Record(defaultValues, name) {
	      var hasInitialized;
	
	      var RecordType = function Record(values) {
	        if (values instanceof RecordType) {
	          return values;
	        }
	        if (!(this instanceof RecordType)) {
	          return new RecordType(values);
	        }
	        if (!hasInitialized) {
	          hasInitialized = true;
	          var keys = Object.keys(defaultValues);
	          setProps(RecordTypePrototype, keys);
	          RecordTypePrototype.size = keys.length;
	          RecordTypePrototype._name = name;
	          RecordTypePrototype._keys = keys;
	          RecordTypePrototype._defaultValues = defaultValues;
	        }
	        this._map = Map(values);
	      };
	
	      var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
	      RecordTypePrototype.constructor = RecordType;
	
	      return RecordType;
	    }
	
	    Record.prototype.toString = function() {
	      return this.__toString(recordName(this) + ' {', '}');
	    };
	
	    // @pragma Access
	
	    Record.prototype.has = function(k) {
	      return this._defaultValues.hasOwnProperty(k);
	    };
	
	    Record.prototype.get = function(k, notSetValue) {
	      if (!this.has(k)) {
	        return notSetValue;
	      }
	      var defaultVal = this._defaultValues[k];
	      return this._map ? this._map.get(k, defaultVal) : defaultVal;
	    };
	
	    // @pragma Modification
	
	    Record.prototype.clear = function() {
	      if (this.__ownerID) {
	        this._map && this._map.clear();
	        return this;
	      }
	      var RecordType = this.constructor;
	      return RecordType._empty || (RecordType._empty = makeRecord(this, emptyMap()));
	    };
	
	    Record.prototype.set = function(k, v) {
	      if (!this.has(k)) {
	        throw new Error('Cannot set unknown key "' + k + '" on ' + recordName(this));
	      }
	      var newMap = this._map && this._map.set(k, v);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.remove = function(k) {
	      if (!this.has(k)) {
	        return this;
	      }
	      var newMap = this._map && this._map.remove(k);
	      if (this.__ownerID || newMap === this._map) {
	        return this;
	      }
	      return makeRecord(this, newMap);
	    };
	
	    Record.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Record.prototype.__iterator = function(type, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterator(type, reverse);
	    };
	
	    Record.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return KeyedIterable(this._defaultValues).map(function(_, k)  {return this$0.get(k)}).__iterate(fn, reverse);
	    };
	
	    Record.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map && this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return makeRecord(this, newMap, ownerID);
	    };
	
	
	  var RecordPrototype = Record.prototype;
	  RecordPrototype[DELETE] = RecordPrototype.remove;
	  RecordPrototype.deleteIn =
	  RecordPrototype.removeIn = MapPrototype.removeIn;
	  RecordPrototype.merge = MapPrototype.merge;
	  RecordPrototype.mergeWith = MapPrototype.mergeWith;
	  RecordPrototype.mergeIn = MapPrototype.mergeIn;
	  RecordPrototype.mergeDeep = MapPrototype.mergeDeep;
	  RecordPrototype.mergeDeepWith = MapPrototype.mergeDeepWith;
	  RecordPrototype.mergeDeepIn = MapPrototype.mergeDeepIn;
	  RecordPrototype.setIn = MapPrototype.setIn;
	  RecordPrototype.update = MapPrototype.update;
	  RecordPrototype.updateIn = MapPrototype.updateIn;
	  RecordPrototype.withMutations = MapPrototype.withMutations;
	  RecordPrototype.asMutable = MapPrototype.asMutable;
	  RecordPrototype.asImmutable = MapPrototype.asImmutable;
	
	
	  function makeRecord(likeRecord, map, ownerID) {
	    var record = Object.create(Object.getPrototypeOf(likeRecord));
	    record._map = map;
	    record.__ownerID = ownerID;
	    return record;
	  }
	
	  function recordName(record) {
	    return record._name || record.constructor.name || 'Record';
	  }
	
	  function setProps(prototype, names) {
	    try {
	      names.forEach(setProp.bind(undefined, prototype));
	    } catch (error) {
	      // Object.defineProperty failed. Probably IE8.
	    }
	  }
	
	  function setProp(prototype, name) {
	    Object.defineProperty(prototype, name, {
	      get: function() {
	        return this.get(name);
	      },
	      set: function(value) {
	        invariant(this.__ownerID, 'Cannot set on an immutable record.');
	        this.set(name, value);
	      }
	    });
	  }
	
	  createClass(Set, SetCollection);
	
	    // @pragma Construction
	
	    function Set(value) {
	      return value === null || value === undefined ? emptySet() :
	        isSet(value) && !isOrdered(value) ? value :
	        emptySet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    Set.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Set.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    Set.prototype.toString = function() {
	      return this.__toString('Set {', '}');
	    };
	
	    // @pragma Access
	
	    Set.prototype.has = function(value) {
	      return this._map.has(value);
	    };
	
	    // @pragma Modification
	
	    Set.prototype.add = function(value) {
	      return updateSet(this, this._map.set(value, true));
	    };
	
	    Set.prototype.remove = function(value) {
	      return updateSet(this, this._map.remove(value));
	    };
	
	    Set.prototype.clear = function() {
	      return updateSet(this, this._map.clear());
	    };
	
	    // @pragma Composition
	
	    Set.prototype.union = function() {var iters = SLICE$0.call(arguments, 0);
	      iters = iters.filter(function(x ) {return x.size !== 0});
	      if (iters.length === 0) {
	        return this;
	      }
	      if (this.size === 0 && !this.__ownerID && iters.length === 1) {
	        return this.constructor(iters[0]);
	      }
	      return this.withMutations(function(set ) {
	        for (var ii = 0; ii < iters.length; ii++) {
	          SetIterable(iters[ii]).forEach(function(value ) {return set.add(value)});
	        }
	      });
	    };
	
	    Set.prototype.intersect = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (!iters.every(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.subtract = function() {var iters = SLICE$0.call(arguments, 0);
	      if (iters.length === 0) {
	        return this;
	      }
	      iters = iters.map(function(iter ) {return SetIterable(iter)});
	      var originalSet = this;
	      return this.withMutations(function(set ) {
	        originalSet.forEach(function(value ) {
	          if (iters.some(function(iter ) {return iter.includes(value)})) {
	            set.remove(value);
	          }
	        });
	      });
	    };
	
	    Set.prototype.merge = function() {
	      return this.union.apply(this, arguments);
	    };
	
	    Set.prototype.mergeWith = function(merger) {var iters = SLICE$0.call(arguments, 1);
	      return this.union.apply(this, iters);
	    };
	
	    Set.prototype.sort = function(comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator));
	    };
	
	    Set.prototype.sortBy = function(mapper, comparator) {
	      // Late binding
	      return OrderedSet(sortFactory(this, comparator, mapper));
	    };
	
	    Set.prototype.wasAltered = function() {
	      return this._map.wasAltered();
	    };
	
	    Set.prototype.__iterate = function(fn, reverse) {var this$0 = this;
	      return this._map.__iterate(function(_, k)  {return fn(k, k, this$0)}, reverse);
	    };
	
	    Set.prototype.__iterator = function(type, reverse) {
	      return this._map.map(function(_, k)  {return k}).__iterator(type, reverse);
	    };
	
	    Set.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      var newMap = this._map.__ensureOwner(ownerID);
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this._map = newMap;
	        return this;
	      }
	      return this.__make(newMap, ownerID);
	    };
	
	
	  function isSet(maybeSet) {
	    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
	  }
	
	  Set.isSet = isSet;
	
	  var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
	
	  var SetPrototype = Set.prototype;
	  SetPrototype[IS_SET_SENTINEL] = true;
	  SetPrototype[DELETE] = SetPrototype.remove;
	  SetPrototype.mergeDeep = SetPrototype.merge;
	  SetPrototype.mergeDeepWith = SetPrototype.mergeWith;
	  SetPrototype.withMutations = MapPrototype.withMutations;
	  SetPrototype.asMutable = MapPrototype.asMutable;
	  SetPrototype.asImmutable = MapPrototype.asImmutable;
	
	  SetPrototype.__empty = emptySet;
	  SetPrototype.__make = makeSet;
	
	  function updateSet(set, newMap) {
	    if (set.__ownerID) {
	      set.size = newMap.size;
	      set._map = newMap;
	      return set;
	    }
	    return newMap === set._map ? set :
	      newMap.size === 0 ? set.__empty() :
	      set.__make(newMap);
	  }
	
	  function makeSet(map, ownerID) {
	    var set = Object.create(SetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_SET;
	  function emptySet() {
	    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
	  }
	
	  createClass(OrderedSet, Set);
	
	    // @pragma Construction
	
	    function OrderedSet(value) {
	      return value === null || value === undefined ? emptyOrderedSet() :
	        isOrderedSet(value) ? value :
	        emptyOrderedSet().withMutations(function(set ) {
	          var iter = SetIterable(value);
	          assertNotInfinite(iter.size);
	          iter.forEach(function(v ) {return set.add(v)});
	        });
	    }
	
	    OrderedSet.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    OrderedSet.fromKeys = function(value) {
	      return this(KeyedIterable(value).keySeq());
	    };
	
	    OrderedSet.prototype.toString = function() {
	      return this.__toString('OrderedSet {', '}');
	    };
	
	
	  function isOrderedSet(maybeOrderedSet) {
	    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
	  }
	
	  OrderedSet.isOrderedSet = isOrderedSet;
	
	  var OrderedSetPrototype = OrderedSet.prototype;
	  OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
	
	  OrderedSetPrototype.__empty = emptyOrderedSet;
	  OrderedSetPrototype.__make = makeOrderedSet;
	
	  function makeOrderedSet(map, ownerID) {
	    var set = Object.create(OrderedSetPrototype);
	    set.size = map ? map.size : 0;
	    set._map = map;
	    set.__ownerID = ownerID;
	    return set;
	  }
	
	  var EMPTY_ORDERED_SET;
	  function emptyOrderedSet() {
	    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
	  }
	
	  createClass(Stack, IndexedCollection);
	
	    // @pragma Construction
	
	    function Stack(value) {
	      return value === null || value === undefined ? emptyStack() :
	        isStack(value) ? value :
	        emptyStack().unshiftAll(value);
	    }
	
	    Stack.of = function(/*...values*/) {
	      return this(arguments);
	    };
	
	    Stack.prototype.toString = function() {
	      return this.__toString('Stack [', ']');
	    };
	
	    // @pragma Access
	
	    Stack.prototype.get = function(index, notSetValue) {
	      var head = this._head;
	      index = wrapIndex(this, index);
	      while (head && index--) {
	        head = head.next;
	      }
	      return head ? head.value : notSetValue;
	    };
	
	    Stack.prototype.peek = function() {
	      return this._head && this._head.value;
	    };
	
	    // @pragma Modification
	
	    Stack.prototype.push = function(/*...values*/) {
	      if (arguments.length === 0) {
	        return this;
	      }
	      var newSize = this.size + arguments.length;
	      var head = this._head;
	      for (var ii = arguments.length - 1; ii >= 0; ii--) {
	        head = {
	          value: arguments[ii],
	          next: head
	        };
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pushAll = function(iter) {
	      iter = IndexedIterable(iter);
	      if (iter.size === 0) {
	        return this;
	      }
	      assertNotInfinite(iter.size);
	      var newSize = this.size;
	      var head = this._head;
	      iter.reverse().forEach(function(value ) {
	        newSize++;
	        head = {
	          value: value,
	          next: head
	        };
	      });
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    Stack.prototype.pop = function() {
	      return this.slice(1);
	    };
	
	    Stack.prototype.unshift = function(/*...values*/) {
	      return this.push.apply(this, arguments);
	    };
	
	    Stack.prototype.unshiftAll = function(iter) {
	      return this.pushAll(iter);
	    };
	
	    Stack.prototype.shift = function() {
	      return this.pop.apply(this, arguments);
	    };
	
	    Stack.prototype.clear = function() {
	      if (this.size === 0) {
	        return this;
	      }
	      if (this.__ownerID) {
	        this.size = 0;
	        this._head = undefined;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return emptyStack();
	    };
	
	    Stack.prototype.slice = function(begin, end) {
	      if (wholeSlice(begin, end, this.size)) {
	        return this;
	      }
	      var resolvedBegin = resolveBegin(begin, this.size);
	      var resolvedEnd = resolveEnd(end, this.size);
	      if (resolvedEnd !== this.size) {
	        // super.slice(begin, end);
	        return IndexedCollection.prototype.slice.call(this, begin, end);
	      }
	      var newSize = this.size - resolvedBegin;
	      var head = this._head;
	      while (resolvedBegin--) {
	        head = head.next;
	      }
	      if (this.__ownerID) {
	        this.size = newSize;
	        this._head = head;
	        this.__hash = undefined;
	        this.__altered = true;
	        return this;
	      }
	      return makeStack(newSize, head);
	    };
	
	    // @pragma Mutability
	
	    Stack.prototype.__ensureOwner = function(ownerID) {
	      if (ownerID === this.__ownerID) {
	        return this;
	      }
	      if (!ownerID) {
	        this.__ownerID = ownerID;
	        this.__altered = false;
	        return this;
	      }
	      return makeStack(this.size, this._head, ownerID, this.__hash);
	    };
	
	    // @pragma Iteration
	
	    Stack.prototype.__iterate = function(fn, reverse) {
	      if (reverse) {
	        return this.reverse().__iterate(fn);
	      }
	      var iterations = 0;
	      var node = this._head;
	      while (node) {
	        if (fn(node.value, iterations++, this) === false) {
	          break;
	        }
	        node = node.next;
	      }
	      return iterations;
	    };
	
	    Stack.prototype.__iterator = function(type, reverse) {
	      if (reverse) {
	        return this.reverse().__iterator(type);
	      }
	      var iterations = 0;
	      var node = this._head;
	      return new Iterator(function()  {
	        if (node) {
	          var value = node.value;
	          node = node.next;
	          return iteratorValue(type, iterations++, value);
	        }
	        return iteratorDone();
	      });
	    };
	
	
	  function isStack(maybeStack) {
	    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
	  }
	
	  Stack.isStack = isStack;
	
	  var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
	
	  var StackPrototype = Stack.prototype;
	  StackPrototype[IS_STACK_SENTINEL] = true;
	  StackPrototype.withMutations = MapPrototype.withMutations;
	  StackPrototype.asMutable = MapPrototype.asMutable;
	  StackPrototype.asImmutable = MapPrototype.asImmutable;
	  StackPrototype.wasAltered = MapPrototype.wasAltered;
	
	
	  function makeStack(size, head, ownerID, hash) {
	    var map = Object.create(StackPrototype);
	    map.size = size;
	    map._head = head;
	    map.__ownerID = ownerID;
	    map.__hash = hash;
	    map.__altered = false;
	    return map;
	  }
	
	  var EMPTY_STACK;
	  function emptyStack() {
	    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
	  }
	
	  /**
	   * Contributes additional methods to a constructor
	   */
	  function mixin(ctor, methods) {
	    var keyCopier = function(key ) { ctor.prototype[key] = methods[key]; };
	    Object.keys(methods).forEach(keyCopier);
	    Object.getOwnPropertySymbols &&
	      Object.getOwnPropertySymbols(methods).forEach(keyCopier);
	    return ctor;
	  }
	
	  Iterable.Iterator = Iterator;
	
	  mixin(Iterable, {
	
	    // ### Conversion to other types
	
	    toArray: function() {
	      assertNotInfinite(this.size);
	      var array = new Array(this.size || 0);
	      this.valueSeq().__iterate(function(v, i)  { array[i] = v; });
	      return array;
	    },
	
	    toIndexedSeq: function() {
	      return new ToIndexedSequence(this);
	    },
	
	    toJS: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJS === 'function' ? value.toJS() : value}
	      ).__toJS();
	    },
	
	    toJSON: function() {
	      return this.toSeq().map(
	        function(value ) {return value && typeof value.toJSON === 'function' ? value.toJSON() : value}
	      ).__toJS();
	    },
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, true);
	    },
	
	    toMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Map(this.toKeyedSeq());
	    },
	
	    toObject: function() {
	      assertNotInfinite(this.size);
	      var object = {};
	      this.__iterate(function(v, k)  { object[k] = v; });
	      return object;
	    },
	
	    toOrderedMap: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedMap(this.toKeyedSeq());
	    },
	
	    toOrderedSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSet: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Set(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toSetSeq: function() {
	      return new ToSetSequence(this);
	    },
	
	    toSeq: function() {
	      return isIndexed(this) ? this.toIndexedSeq() :
	        isKeyed(this) ? this.toKeyedSeq() :
	        this.toSetSeq();
	    },
	
	    toStack: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return Stack(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	    toList: function() {
	      // Use Late Binding here to solve the circular dependency.
	      return List(isKeyed(this) ? this.valueSeq() : this);
	    },
	
	
	    // ### Common JavaScript methods and properties
	
	    toString: function() {
	      return '[Iterable]';
	    },
	
	    __toString: function(head, tail) {
	      if (this.size === 0) {
	        return head + tail;
	      }
	      return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    concat: function() {var values = SLICE$0.call(arguments, 0);
	      return reify(this, concatFactory(this, values));
	    },
	
	    includes: function(searchValue) {
	      return this.some(function(value ) {return is(value, searchValue)});
	    },
	
	    entries: function() {
	      return this.__iterator(ITERATE_ENTRIES);
	    },
	
	    every: function(predicate, context) {
	      assertNotInfinite(this.size);
	      var returnValue = true;
	      this.__iterate(function(v, k, c)  {
	        if (!predicate.call(context, v, k, c)) {
	          returnValue = false;
	          return false;
	        }
	      });
	      return returnValue;
	    },
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, true));
	    },
	
	    find: function(predicate, context, notSetValue) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[1] : notSetValue;
	    },
	
	    findEntry: function(predicate, context) {
	      var found;
	      this.__iterate(function(v, k, c)  {
	        if (predicate.call(context, v, k, c)) {
	          found = [k, v];
	          return false;
	        }
	      });
	      return found;
	    },
	
	    findLastEntry: function(predicate, context) {
	      return this.toSeq().reverse().findEntry(predicate, context);
	    },
	
	    forEach: function(sideEffect, context) {
	      assertNotInfinite(this.size);
	      return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
	    },
	
	    join: function(separator) {
	      assertNotInfinite(this.size);
	      separator = separator !== undefined ? '' + separator : ',';
	      var joined = '';
	      var isFirst = true;
	      this.__iterate(function(v ) {
	        isFirst ? (isFirst = false) : (joined += separator);
	        joined += v !== null && v !== undefined ? v.toString() : '';
	      });
	      return joined;
	    },
	
	    keys: function() {
	      return this.__iterator(ITERATE_KEYS);
	    },
	
	    map: function(mapper, context) {
	      return reify(this, mapFactory(this, mapper, context));
	    },
	
	    reduce: function(reducer, initialReduction, context) {
	      assertNotInfinite(this.size);
	      var reduction;
	      var useFirst;
	      if (arguments.length < 2) {
	        useFirst = true;
	      } else {
	        reduction = initialReduction;
	      }
	      this.__iterate(function(v, k, c)  {
	        if (useFirst) {
	          useFirst = false;
	          reduction = v;
	        } else {
	          reduction = reducer.call(context, reduction, v, k, c);
	        }
	      });
	      return reduction;
	    },
	
	    reduceRight: function(reducer, initialReduction, context) {
	      var reversed = this.toKeyedSeq().reverse();
	      return reversed.reduce.apply(reversed, arguments);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, true));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, true));
	    },
	
	    some: function(predicate, context) {
	      return !this.every(not(predicate), context);
	    },
	
	    sort: function(comparator) {
	      return reify(this, sortFactory(this, comparator));
	    },
	
	    values: function() {
	      return this.__iterator(ITERATE_VALUES);
	    },
	
	
	    // ### More sequential methods
	
	    butLast: function() {
	      return this.slice(0, -1);
	    },
	
	    isEmpty: function() {
	      return this.size !== undefined ? this.size === 0 : !this.some(function()  {return true});
	    },
	
	    count: function(predicate, context) {
	      return ensureSize(
	        predicate ? this.toSeq().filter(predicate, context) : this
	      );
	    },
	
	    countBy: function(grouper, context) {
	      return countByFactory(this, grouper, context);
	    },
	
	    equals: function(other) {
	      return deepEqual(this, other);
	    },
	
	    entrySeq: function() {
	      var iterable = this;
	      if (iterable._cache) {
	        // We cache as an entries array, so we can just return the cache!
	        return new ArraySeq(iterable._cache);
	      }
	      var entriesSequence = iterable.toSeq().map(entryMapper).toIndexedSeq();
	      entriesSequence.fromEntrySeq = function()  {return iterable.toSeq()};
	      return entriesSequence;
	    },
	
	    filterNot: function(predicate, context) {
	      return this.filter(not(predicate), context);
	    },
	
	    findLast: function(predicate, context, notSetValue) {
	      return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
	    },
	
	    first: function() {
	      return this.find(returnTrue);
	    },
	
	    flatMap: function(mapper, context) {
	      return reify(this, flatMapFactory(this, mapper, context));
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, true));
	    },
	
	    fromEntrySeq: function() {
	      return new FromEntriesSequence(this);
	    },
	
	    get: function(searchKey, notSetValue) {
	      return this.find(function(_, key)  {return is(key, searchKey)}, undefined, notSetValue);
	    },
	
	    getIn: function(searchKeyPath, notSetValue) {
	      var nested = this;
	      // Note: in an ES6 environment, we would prefer:
	      // for (var key of searchKeyPath) {
	      var iter = forceIterator(searchKeyPath);
	      var step;
	      while (!(step = iter.next()).done) {
	        var key = step.value;
	        nested = nested && nested.get ? nested.get(key, NOT_SET) : NOT_SET;
	        if (nested === NOT_SET) {
	          return notSetValue;
	        }
	      }
	      return nested;
	    },
	
	    groupBy: function(grouper, context) {
	      return groupByFactory(this, grouper, context);
	    },
	
	    has: function(searchKey) {
	      return this.get(searchKey, NOT_SET) !== NOT_SET;
	    },
	
	    hasIn: function(searchKeyPath) {
	      return this.getIn(searchKeyPath, NOT_SET) !== NOT_SET;
	    },
	
	    isSubset: function(iter) {
	      iter = typeof iter.includes === 'function' ? iter : Iterable(iter);
	      return this.every(function(value ) {return iter.includes(value)});
	    },
	
	    isSuperset: function(iter) {
	      iter = typeof iter.isSubset === 'function' ? iter : Iterable(iter);
	      return iter.isSubset(this);
	    },
	
	    keySeq: function() {
	      return this.toSeq().map(keyMapper).toIndexedSeq();
	    },
	
	    last: function() {
	      return this.toSeq().reverse().first();
	    },
	
	    max: function(comparator) {
	      return maxFactory(this, comparator);
	    },
	
	    maxBy: function(mapper, comparator) {
	      return maxFactory(this, comparator, mapper);
	    },
	
	    min: function(comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
	    },
	
	    minBy: function(mapper, comparator) {
	      return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
	    },
	
	    rest: function() {
	      return this.slice(1);
	    },
	
	    skip: function(amount) {
	      return this.slice(Math.max(0, amount));
	    },
	
	    skipLast: function(amount) {
	      return reify(this, this.toSeq().reverse().skip(amount).reverse());
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, true));
	    },
	
	    skipUntil: function(predicate, context) {
	      return this.skipWhile(not(predicate), context);
	    },
	
	    sortBy: function(mapper, comparator) {
	      return reify(this, sortFactory(this, comparator, mapper));
	    },
	
	    take: function(amount) {
	      return this.slice(0, Math.max(0, amount));
	    },
	
	    takeLast: function(amount) {
	      return reify(this, this.toSeq().reverse().take(amount).reverse());
	    },
	
	    takeWhile: function(predicate, context) {
	      return reify(this, takeWhileFactory(this, predicate, context));
	    },
	
	    takeUntil: function(predicate, context) {
	      return this.takeWhile(not(predicate), context);
	    },
	
	    valueSeq: function() {
	      return this.toIndexedSeq();
	    },
	
	
	    // ### Hashable Object
	
	    hashCode: function() {
	      return this.__hash || (this.__hash = hashIterable(this));
	    }
	
	
	    // ### Internal
	
	    // abstract __iterate(fn, reverse)
	
	    // abstract __iterator(type, reverse)
	  });
	
	  // var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
	  // var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
	  // var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
	  // var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
	
	  var IterablePrototype = Iterable.prototype;
	  IterablePrototype[IS_ITERABLE_SENTINEL] = true;
	  IterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.values;
	  IterablePrototype.__toJS = IterablePrototype.toArray;
	  IterablePrototype.__toStringMapper = quoteString;
	  IterablePrototype.inspect =
	  IterablePrototype.toSource = function() { return this.toString(); };
	  IterablePrototype.chain = IterablePrototype.flatMap;
	  IterablePrototype.contains = IterablePrototype.includes;
	
	  // Temporary warning about using length
	  (function () {
	    try {
	      Object.defineProperty(IterablePrototype, 'length', {
	        get: function () {
	          if (!Iterable.noLengthWarning) {
	            var stack;
	            try {
	              throw new Error();
	            } catch (error) {
	              stack = error.stack;
	            }
	            if (stack.indexOf('_wrapObject') === -1) {
	              console && console.warn && console.warn(
	                'iterable.length has been deprecated, '+
	                'use iterable.size or iterable.count(). '+
	                'This warning will become a silent error in a future version. ' +
	                stack
	              );
	              return this.size;
	            }
	          }
	        }
	      });
	    } catch (e) {}
	  })();
	
	
	
	  mixin(KeyedIterable, {
	
	    // ### More sequential methods
	
	    flip: function() {
	      return reify(this, flipFactory(this));
	    },
	
	    findKey: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry && entry[0];
	    },
	
	    findLastKey: function(predicate, context) {
	      return this.toSeq().reverse().findKey(predicate, context);
	    },
	
	    keyOf: function(searchValue) {
	      return this.findKey(function(value ) {return is(value, searchValue)});
	    },
	
	    lastKeyOf: function(searchValue) {
	      return this.findLastKey(function(value ) {return is(value, searchValue)});
	    },
	
	    mapEntries: function(mapper, context) {var this$0 = this;
	      var iterations = 0;
	      return reify(this,
	        this.toSeq().map(
	          function(v, k)  {return mapper.call(context, [k, v], iterations++, this$0)}
	        ).fromEntrySeq()
	      );
	    },
	
	    mapKeys: function(mapper, context) {var this$0 = this;
	      return reify(this,
	        this.toSeq().flip().map(
	          function(k, v)  {return mapper.call(context, k, v, this$0)}
	        ).flip()
	      );
	    }
	
	  });
	
	  var KeyedIterablePrototype = KeyedIterable.prototype;
	  KeyedIterablePrototype[IS_KEYED_SENTINEL] = true;
	  KeyedIterablePrototype[ITERATOR_SYMBOL] = IterablePrototype.entries;
	  KeyedIterablePrototype.__toJS = IterablePrototype.toObject;
	  KeyedIterablePrototype.__toStringMapper = function(v, k)  {return JSON.stringify(k) + ': ' + quoteString(v)};
	
	
	
	  mixin(IndexedIterable, {
	
	    // ### Conversion to other types
	
	    toKeyedSeq: function() {
	      return new ToKeyedSequence(this, false);
	    },
	
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    filter: function(predicate, context) {
	      return reify(this, filterFactory(this, predicate, context, false));
	    },
	
	    findIndex: function(predicate, context) {
	      var entry = this.findEntry(predicate, context);
	      return entry ? entry[0] : -1;
	    },
	
	    indexOf: function(searchValue) {
	      var key = this.toKeyedSeq().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	    },
	
	    lastIndexOf: function(searchValue) {
	      var key = this.toKeyedSeq().reverse().keyOf(searchValue);
	      return key === undefined ? -1 : key;
	
	      // var index =
	      // return this.toSeq().reverse().indexOf(searchValue);
	    },
	
	    reverse: function() {
	      return reify(this, reverseFactory(this, false));
	    },
	
	    slice: function(begin, end) {
	      return reify(this, sliceFactory(this, begin, end, false));
	    },
	
	    splice: function(index, removeNum /*, ...values*/) {
	      var numArgs = arguments.length;
	      removeNum = Math.max(removeNum | 0, 0);
	      if (numArgs === 0 || (numArgs === 2 && !removeNum)) {
	        return this;
	      }
	      // If index is negative, it should resolve relative to the size of the
	      // collection. However size may be expensive to compute if not cached, so
	      // only call count() if the number is in fact negative.
	      index = resolveBegin(index, index < 0 ? this.count() : this.size);
	      var spliced = this.slice(0, index);
	      return reify(
	        this,
	        numArgs === 1 ?
	          spliced :
	          spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum))
	      );
	    },
	
	
	    // ### More collection methods
	
	    findLastIndex: function(predicate, context) {
	      var key = this.toKeyedSeq().findLastKey(predicate, context);
	      return key === undefined ? -1 : key;
	    },
	
	    first: function() {
	      return this.get(0);
	    },
	
	    flatten: function(depth) {
	      return reify(this, flattenFactory(this, depth, false));
	    },
	
	    get: function(index, notSetValue) {
	      index = wrapIndex(this, index);
	      return (index < 0 || (this.size === Infinity ||
	          (this.size !== undefined && index > this.size))) ?
	        notSetValue :
	        this.find(function(_, key)  {return key === index}, undefined, notSetValue);
	    },
	
	    has: function(index) {
	      index = wrapIndex(this, index);
	      return index >= 0 && (this.size !== undefined ?
	        this.size === Infinity || index < this.size :
	        this.indexOf(index) !== -1
	      );
	    },
	
	    interpose: function(separator) {
	      return reify(this, interposeFactory(this, separator));
	    },
	
	    interleave: function(/*...iterables*/) {
	      var iterables = [this].concat(arrCopy(arguments));
	      var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, iterables);
	      var interleaved = zipped.flatten(true);
	      if (zipped.size) {
	        interleaved.size = zipped.size * iterables.length;
	      }
	      return reify(this, interleaved);
	    },
	
	    last: function() {
	      return this.get(-1);
	    },
	
	    skipWhile: function(predicate, context) {
	      return reify(this, skipWhileFactory(this, predicate, context, false));
	    },
	
	    zip: function(/*, ...iterables */) {
	      var iterables = [this].concat(arrCopy(arguments));
	      return reify(this, zipWithFactory(this, defaultZipper, iterables));
	    },
	
	    zipWith: function(zipper/*, ...iterables */) {
	      var iterables = arrCopy(arguments);
	      iterables[0] = this;
	      return reify(this, zipWithFactory(this, zipper, iterables));
	    }
	
	  });
	
	  IndexedIterable.prototype[IS_INDEXED_SENTINEL] = true;
	  IndexedIterable.prototype[IS_ORDERED_SENTINEL] = true;
	
	
	
	  mixin(SetIterable, {
	
	    // ### ES6 Collection methods (ES6 Array and Map)
	
	    get: function(value, notSetValue) {
	      return this.has(value) ? value : notSetValue;
	    },
	
	    includes: function(value) {
	      return this.has(value);
	    },
	
	
	    // ### More sequential methods
	
	    keySeq: function() {
	      return this.valueSeq();
	    }
	
	  });
	
	  SetIterable.prototype.has = IterablePrototype.includes;
	
	
	  // Mixin subclasses
	
	  mixin(KeyedSeq, KeyedIterable.prototype);
	  mixin(IndexedSeq, IndexedIterable.prototype);
	  mixin(SetSeq, SetIterable.prototype);
	
	  mixin(KeyedCollection, KeyedIterable.prototype);
	  mixin(IndexedCollection, IndexedIterable.prototype);
	  mixin(SetCollection, SetIterable.prototype);
	
	
	  // #pragma Helper functions
	
	  function keyMapper(v, k) {
	    return k;
	  }
	
	  function entryMapper(v, k) {
	    return [k, v];
	  }
	
	  function not(predicate) {
	    return function() {
	      return !predicate.apply(this, arguments);
	    }
	  }
	
	  function neg(predicate) {
	    return function() {
	      return -predicate.apply(this, arguments);
	    }
	  }
	
	  function quoteString(value) {
	    return typeof value === 'string' ? JSON.stringify(value) : value;
	  }
	
	  function defaultZipper() {
	    return arrCopy(arguments);
	  }
	
	  function defaultNegComparator(a, b) {
	    return a < b ? 1 : a > b ? -1 : 0;
	  }
	
	  function hashIterable(iterable) {
	    if (iterable.size === Infinity) {
	      return 0;
	    }
	    var ordered = isOrdered(iterable);
	    var keyed = isKeyed(iterable);
	    var h = ordered ? 1 : 0;
	    var size = iterable.__iterate(
	      keyed ?
	        ordered ?
	          function(v, k)  { h = 31 * h + hashMerge(hash(v), hash(k)) | 0; } :
	          function(v, k)  { h = h + hashMerge(hash(v), hash(k)) | 0; } :
	        ordered ?
	          function(v ) { h = 31 * h + hash(v) | 0; } :
	          function(v ) { h = h + hash(v) | 0; }
	    );
	    return murmurHashOfSize(size, h);
	  }
	
	  function murmurHashOfSize(size, h) {
	    h = imul(h, 0xCC9E2D51);
	    h = imul(h << 15 | h >>> -15, 0x1B873593);
	    h = imul(h << 13 | h >>> -13, 5);
	    h = (h + 0xE6546B64 | 0) ^ size;
	    h = imul(h ^ h >>> 16, 0x85EBCA6B);
	    h = imul(h ^ h >>> 13, 0xC2B2AE35);
	    h = smi(h ^ h >>> 16);
	    return h;
	  }
	
	  function hashMerge(a, b) {
	    return a ^ b + 0x9E3779B9 + (a << 6) + (a >> 2) | 0; // int
	  }
	
	  var Immutable = {
	
	    Iterable: Iterable,
	
	    Seq: Seq,
	    Collection: Collection,
	    Map: Map,
	    OrderedMap: OrderedMap,
	    List: List,
	    Stack: Stack,
	    Set: Set,
	    OrderedSet: OrderedSet,
	
	    Record: Record,
	    Range: Range,
	    Repeat: Repeat,
	
	    is: is,
	    fromJS: fromJS
	
	  };
	
	  return Immutable;
	
	}));

/***/ },
/* 40 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function omit(obj, fields) {
	  var shallowCopy = (0, _extends3["default"])({}, obj);
	  for (var i = 0; i < fields.length; i++) {
	    var key = fields[i];
	    delete shallowCopy[key];
	  }
	  return shallowCopy;
	}
	
	exports["default"] = omit;
	module.exports = exports['default'];

/***/ },
/* 42 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 43 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(739);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 45 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var BoundingRect = __webpack_require__(60);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	var formatUtil = __webpack_require__(48);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Layout helpers for each component positioning
	var each = zrUtil.each;
	/**
	 * @public
	 */
	
	var LOCATION_PARAMS = ['left', 'right', 'top', 'bottom', 'width', 'height'];
	/**
	 * @public
	 */
	
	var HV_NAMES = [['width', 'left', 'right'], ['height', 'top', 'bottom']];
	
	function boxLayout(orient, group, gap, maxWidth, maxHeight) {
	  var x = 0;
	  var y = 0;
	
	  if (maxWidth == null) {
	    maxWidth = Infinity;
	  }
	
	  if (maxHeight == null) {
	    maxHeight = Infinity;
	  }
	
	  var currentLineMaxSize = 0;
	  group.eachChild(function (child, idx) {
	    var position = child.position;
	    var rect = child.getBoundingRect();
	    var nextChild = group.childAt(idx + 1);
	    var nextChildRect = nextChild && nextChild.getBoundingRect();
	    var nextX;
	    var nextY;
	
	    if (orient === 'horizontal') {
	      var moveX = rect.width + (nextChildRect ? -nextChildRect.x + rect.x : 0);
	      nextX = x + moveX; // Wrap when width exceeds maxWidth or meet a `newline` group
	      // FIXME compare before adding gap?
	
	      if (nextX > maxWidth || child.newline) {
	        x = 0;
	        nextX = moveX;
	        y += currentLineMaxSize + gap;
	        currentLineMaxSize = rect.height;
	      } else {
	        // FIXME: consider rect.y is not `0`?
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.height);
	      }
	    } else {
	      var moveY = rect.height + (nextChildRect ? -nextChildRect.y + rect.y : 0);
	      nextY = y + moveY; // Wrap when width exceeds maxHeight or meet a `newline` group
	
	      if (nextY > maxHeight || child.newline) {
	        x += currentLineMaxSize + gap;
	        y = 0;
	        nextY = moveY;
	        currentLineMaxSize = rect.width;
	      } else {
	        currentLineMaxSize = Math.max(currentLineMaxSize, rect.width);
	      }
	    }
	
	    if (child.newline) {
	      return;
	    }
	
	    position[0] = x;
	    position[1] = y;
	    orient === 'horizontal' ? x = nextX + gap : y = nextY + gap;
	  });
	}
	/**
	 * VBox or HBox layouting
	 * @param {string} orient
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	
	var box = boxLayout;
	/**
	 * VBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var vbox = zrUtil.curry(boxLayout, 'vertical');
	/**
	 * HBox layouting
	 * @param {module:zrender/container/Group} group
	 * @param {number} gap
	 * @param {number} [width=Infinity]
	 * @param {number} [height=Infinity]
	 */
	
	var hbox = zrUtil.curry(boxLayout, 'horizontal');
	/**
	 * If x or x2 is not specified or 'center' 'left' 'right',
	 * the width would be as long as possible.
	 * If y or y2 is not specified or 'middle' 'top' 'bottom',
	 * the height would be as long as possible.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.x]
	 * @param {number|string} [positionInfo.y]
	 * @param {number|string} [positionInfo.x2]
	 * @param {number|string} [positionInfo.y2]
	 * @param {Object} containerRect {width, height}
	 * @param {string|number} margin
	 * @return {Object} {width, height}
	 */
	
	function getAvailableSize(positionInfo, containerRect, margin) {
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var x = parsePercent(positionInfo.x, containerWidth);
	  var y = parsePercent(positionInfo.y, containerHeight);
	  var x2 = parsePercent(positionInfo.x2, containerWidth);
	  var y2 = parsePercent(positionInfo.y2, containerHeight);
	  (isNaN(x) || isNaN(parseFloat(positionInfo.x))) && (x = 0);
	  (isNaN(x2) || isNaN(parseFloat(positionInfo.x2))) && (x2 = containerWidth);
	  (isNaN(y) || isNaN(parseFloat(positionInfo.y))) && (y = 0);
	  (isNaN(y2) || isNaN(parseFloat(positionInfo.y2))) && (y2 = containerHeight);
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  return {
	    width: Math.max(x2 - x - margin[1] - margin[3], 0),
	    height: Math.max(y2 - y - margin[0] - margin[2], 0)
	  };
	}
	/**
	 * Parse position info.
	 *
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width]
	 * @param {number|string} [positionInfo.height]
	 * @param {number|string} [positionInfo.aspect] Aspect is width / height
	 * @param {Object} containerRect
	 * @param {string|number} [margin]
	 *
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	
	function getLayoutRect(positionInfo, containerRect, margin) {
	  margin = formatUtil.normalizeCssArray(margin || 0);
	  var containerWidth = containerRect.width;
	  var containerHeight = containerRect.height;
	  var left = parsePercent(positionInfo.left, containerWidth);
	  var top = parsePercent(positionInfo.top, containerHeight);
	  var right = parsePercent(positionInfo.right, containerWidth);
	  var bottom = parsePercent(positionInfo.bottom, containerHeight);
	  var width = parsePercent(positionInfo.width, containerWidth);
	  var height = parsePercent(positionInfo.height, containerHeight);
	  var verticalMargin = margin[2] + margin[0];
	  var horizontalMargin = margin[1] + margin[3];
	  var aspect = positionInfo.aspect; // If width is not specified, calculate width from left and right
	
	  if (isNaN(width)) {
	    width = containerWidth - right - horizontalMargin - left;
	  }
	
	  if (isNaN(height)) {
	    height = containerHeight - bottom - verticalMargin - top;
	  }
	
	  if (aspect != null) {
	    // If width and height are not given
	    // 1. Graph should not exceeds the container
	    // 2. Aspect must be keeped
	    // 3. Graph should take the space as more as possible
	    // FIXME
	    // Margin is not considered, because there is no case that both
	    // using margin and aspect so far.
	    if (isNaN(width) && isNaN(height)) {
	      if (aspect > containerWidth / containerHeight) {
	        width = containerWidth * 0.8;
	      } else {
	        height = containerHeight * 0.8;
	      }
	    } // Calculate width or height with given aspect
	
	
	    if (isNaN(width)) {
	      width = aspect * height;
	    }
	
	    if (isNaN(height)) {
	      height = width / aspect;
	    }
	  } // If left is not specified, calculate left from right and width
	
	
	  if (isNaN(left)) {
	    left = containerWidth - right - width - horizontalMargin;
	  }
	
	  if (isNaN(top)) {
	    top = containerHeight - bottom - height - verticalMargin;
	  } // Align left and top
	
	
	  switch (positionInfo.left || positionInfo.right) {
	    case 'center':
	      left = containerWidth / 2 - width / 2 - margin[3];
	      break;
	
	    case 'right':
	      left = containerWidth - width - horizontalMargin;
	      break;
	  }
	
	  switch (positionInfo.top || positionInfo.bottom) {
	    case 'middle':
	    case 'center':
	      top = containerHeight / 2 - height / 2 - margin[0];
	      break;
	
	    case 'bottom':
	      top = containerHeight - height - verticalMargin;
	      break;
	  } // If something is wrong and left, top, width, height are calculated as NaN
	
	
	  left = left || 0;
	  top = top || 0;
	
	  if (isNaN(width)) {
	    // Width may be NaN if only one value is given except width
	    width = containerWidth - horizontalMargin - left - (right || 0);
	  }
	
	  if (isNaN(height)) {
	    // Height may be NaN if only one value is given except height
	    height = containerHeight - verticalMargin - top - (bottom || 0);
	  }
	
	  var rect = new BoundingRect(left + margin[3], top + margin[0], width, height);
	  rect.margin = margin;
	  return rect;
	}
	/**
	 * Position a zr element in viewport
	 *  Group position is specified by either
	 *  {left, top}, {right, bottom}
	 *  If all properties exists, right and bottom will be igonred.
	 *
	 * Logic:
	 *     1. Scale (against origin point in parent coord)
	 *     2. Rotate (against origin point in parent coord)
	 *     3. Traslate (with el.position by this method)
	 * So this method only fixes the last step 'Traslate', which does not affect
	 * scaling and rotating.
	 *
	 * If be called repeatly with the same input el, the same result will be gotten.
	 *
	 * @param {module:zrender/Element} el Should have `getBoundingRect` method.
	 * @param {Object} positionInfo
	 * @param {number|string} [positionInfo.left]
	 * @param {number|string} [positionInfo.top]
	 * @param {number|string} [positionInfo.right]
	 * @param {number|string} [positionInfo.bottom]
	 * @param {number|string} [positionInfo.width] Only for opt.boundingModel: 'raw'
	 * @param {number|string} [positionInfo.height] Only for opt.boundingModel: 'raw'
	 * @param {Object} containerRect
	 * @param {string|number} margin
	 * @param {Object} [opt]
	 * @param {Array.<number>} [opt.hv=[1,1]] Only horizontal or only vertical.
	 * @param {Array.<number>} [opt.boundingMode='all']
	 *        Specify how to calculate boundingRect when locating.
	 *        'all': Position the boundingRect that is transformed and uioned
	 *               both itself and its descendants.
	 *               This mode simplies confine the elements in the bounding
	 *               of their container (e.g., using 'right: 0').
	 *        'raw': Position the boundingRect that is not transformed and only itself.
	 *               This mode is useful when you want a element can overflow its
	 *               container. (Consider a rotated circle needs to be located in a corner.)
	 *               In this mode positionInfo.width/height can only be number.
	 */
	
	
	function positionElement(el, positionInfo, containerRect, margin, opt) {
	  var h = !opt || !opt.hv || opt.hv[0];
	  var v = !opt || !opt.hv || opt.hv[1];
	  var boundingMode = opt && opt.boundingMode || 'all';
	
	  if (!h && !v) {
	    return;
	  }
	
	  var rect;
	
	  if (boundingMode === 'raw') {
	    rect = el.type === 'group' ? new BoundingRect(0, 0, +positionInfo.width || 0, +positionInfo.height || 0) : el.getBoundingRect();
	  } else {
	    rect = el.getBoundingRect();
	
	    if (el.needLocalTransform()) {
	      var transform = el.getLocalTransform(); // Notice: raw rect may be inner object of el,
	      // which should not be modified.
	
	      rect = rect.clone();
	      rect.applyTransform(transform);
	    }
	  } // The real width and height can not be specified but calculated by the given el.
	
	
	  positionInfo = getLayoutRect(zrUtil.defaults({
	    width: rect.width,
	    height: rect.height
	  }, positionInfo), containerRect, margin); // Because 'tranlate' is the last step in transform
	  // (see zrender/core/Transformable#getLocalTransform),
	  // we can just only modify el.position to get final result.
	
	  var elPos = el.position;
	  var dx = h ? positionInfo.x - rect.x : 0;
	  var dy = v ? positionInfo.y - rect.y : 0;
	  el.attr('position', boundingMode === 'raw' ? [dx, dy] : [elPos[0] + dx, elPos[1] + dy]);
	}
	/**
	 * @param {Object} option Contains some of the properties in HV_NAMES.
	 * @param {number} hvIdx 0: horizontal; 1: vertical.
	 */
	
	
	function sizeCalculable(option, hvIdx) {
	  return option[HV_NAMES[hvIdx][0]] != null || option[HV_NAMES[hvIdx][1]] != null && option[HV_NAMES[hvIdx][2]] != null;
	}
	/**
	 * Consider Case:
	 * When defulat option has {left: 0, width: 100}, and we set {right: 0}
	 * through setOption or media query, using normal zrUtil.merge will cause
	 * {right: 0} does not take effect.
	 *
	 * @example
	 * ComponentModel.extend({
	 *     init: function () {
	 *         ...
	 *         var inputPositionParams = layout.getLayoutParams(option);
	 *         this.mergeOption(inputPositionParams);
	 *     },
	 *     mergeOption: function (newOption) {
	 *         newOption && zrUtil.merge(thisOption, newOption, true);
	 *         layout.mergeLayoutParam(thisOption, newOption);
	 *     }
	 * });
	 *
	 * @param {Object} targetOption
	 * @param {Object} newOption
	 * @param {Object|string} [opt]
	 * @param {boolean|Array.<boolean>} [opt.ignoreSize=false] Used for the components
	 *  that width (or height) should not be calculated by left and right (or top and bottom).
	 */
	
	
	function mergeLayoutParam(targetOption, newOption, opt) {
	  !zrUtil.isObject(opt) && (opt = {});
	  var ignoreSize = opt.ignoreSize;
	  !zrUtil.isArray(ignoreSize) && (ignoreSize = [ignoreSize, ignoreSize]);
	  var hResult = merge(HV_NAMES[0], 0);
	  var vResult = merge(HV_NAMES[1], 1);
	  copy(HV_NAMES[0], targetOption, hResult);
	  copy(HV_NAMES[1], targetOption, vResult);
	
	  function merge(names, hvIdx) {
	    var newParams = {};
	    var newValueCount = 0;
	    var merged = {};
	    var mergedValueCount = 0;
	    var enoughParamNumber = 2;
	    each(names, function (name) {
	      merged[name] = targetOption[name];
	    });
	    each(names, function (name) {
	      // Consider case: newOption.width is null, which is
	      // set by user for removing width setting.
	      hasProp(newOption, name) && (newParams[name] = merged[name] = newOption[name]);
	      hasValue(newParams, name) && newValueCount++;
	      hasValue(merged, name) && mergedValueCount++;
	    });
	
	    if (ignoreSize[hvIdx]) {
	      // Only one of left/right is premitted to exist.
	      if (hasValue(newOption, names[1])) {
	        merged[names[2]] = null;
	      } else if (hasValue(newOption, names[2])) {
	        merged[names[1]] = null;
	      }
	
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // or targetOption: {right: ...} and newOption: {width: ...},
	    // There is no conflict when merged only has params count
	    // little than enoughParamNumber.
	
	
	    if (mergedValueCount === enoughParamNumber || !newValueCount) {
	      return merged;
	    } // Case: newOption: {width: ..., right: ...},
	    // Than we can make sure user only want those two, and ignore
	    // all origin params in targetOption.
	    else if (newValueCount >= enoughParamNumber) {
	        return newParams;
	      } else {
	        // Chose another param from targetOption by priority.
	        for (var i = 0; i < names.length; i++) {
	          var name = names[i];
	
	          if (!hasProp(newParams, name) && hasProp(targetOption, name)) {
	            newParams[name] = targetOption[name];
	            break;
	          }
	        }
	
	        return newParams;
	      }
	  }
	
	  function hasProp(obj, name) {
	    return obj.hasOwnProperty(name);
	  }
	
	  function hasValue(obj, name) {
	    return obj[name] != null && obj[name] !== 'auto';
	  }
	
	  function copy(names, target, source) {
	    each(names, function (name) {
	      target[name] = source[name];
	    });
	  }
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function getLayoutParams(source) {
	  return copyLayoutParams({}, source);
	}
	/**
	 * Retrieve 'left', 'right', 'top', 'bottom', 'width', 'height' from object.
	 * @param {Object} source
	 * @return {Object} Result contains those props.
	 */
	
	
	function copyLayoutParams(target, source) {
	  source && target && each(LOCATION_PARAMS, function (name) {
	    source.hasOwnProperty(name) && (target[name] = source[name]);
	  });
	  return target;
	}
	
	exports.LOCATION_PARAMS = LOCATION_PARAMS;
	exports.HV_NAMES = HV_NAMES;
	exports.box = box;
	exports.vbox = vbox;
	exports.hbox = hbox;
	exports.getAvailableSize = getAvailableSize;
	exports.getLayoutRect = getLayoutRect;
	exports.positionElement = positionElement;
	exports.sizeCalculable = sizeCalculable;
	exports.mergeLayoutParam = mergeLayoutParam;
	exports.getLayoutParams = getLayoutParams;
	exports.copyLayoutParams = copyLayoutParams;

/***/ },
/* 47 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var textContain = __webpack_require__(102);
	
	var numberUtil = __webpack_require__(25);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import Text from 'zrender/src/graphic/Text';
	
	/**
	 * add commas after every three numbers
	 * @param {string|number} x
	 * @return {string}
	 */
	function addCommas(x) {
	  if (isNaN(x)) {
	    return '-';
	  }
	
	  x = (x + '').split('.');
	  return x[0].replace(/(\d{1,3})(?=(?:\d{3})+(?!\d))/g, '$1,') + (x.length > 1 ? '.' + x[1] : '');
	}
	/**
	 * @param {string} str
	 * @param {boolean} [upperCaseFirst=false]
	 * @return {string} str
	 */
	
	
	function toCamelCase(str, upperCaseFirst) {
	  str = (str || '').toLowerCase().replace(/-(.)/g, function (match, group1) {
	    return group1.toUpperCase();
	  });
	
	  if (upperCaseFirst && str) {
	    str = str.charAt(0).toUpperCase() + str.slice(1);
	  }
	
	  return str;
	}
	
	var normalizeCssArray = zrUtil.normalizeCssArray;
	var replaceReg = /([&<>"'])/g;
	var replaceMap = {
	  '&': '&amp;',
	  '<': '&lt;',
	  '>': '&gt;',
	  '"': '&quot;',
	  '\'': '&#39;'
	};
	
	function encodeHTML(source) {
	  return source == null ? '' : (source + '').replace(replaceReg, function (str, c) {
	    return replaceMap[c];
	  });
	}
	
	var TPL_VAR_ALIAS = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
	
	var wrapVar = function (varName, seriesIdx) {
	  return '{' + varName + (seriesIdx == null ? '' : seriesIdx) + '}';
	};
	/**
	 * Template formatter
	 * @param {string} tpl
	 * @param {Array.<Object>|Object} paramsList
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTpl(tpl, paramsList, encode) {
	  if (!zrUtil.isArray(paramsList)) {
	    paramsList = [paramsList];
	  }
	
	  var seriesLen = paramsList.length;
	
	  if (!seriesLen) {
	    return '';
	  }
	
	  var $vars = paramsList[0].$vars || [];
	
	  for (var i = 0; i < $vars.length; i++) {
	    var alias = TPL_VAR_ALIAS[i];
	    tpl = tpl.replace(wrapVar(alias), wrapVar(alias, 0));
	  }
	
	  for (var seriesIdx = 0; seriesIdx < seriesLen; seriesIdx++) {
	    for (var k = 0; k < $vars.length; k++) {
	      var val = paramsList[seriesIdx][$vars[k]];
	      tpl = tpl.replace(wrapVar(TPL_VAR_ALIAS[k], seriesIdx), encode ? encodeHTML(val) : val);
	    }
	  }
	
	  return tpl;
	}
	/**
	 * simple Template formatter
	 *
	 * @param {string} tpl
	 * @param {Object} param
	 * @param {boolean} [encode=false]
	 * @return {string}
	 */
	
	
	function formatTplSimple(tpl, param, encode) {
	  zrUtil.each(param, function (value, key) {
	    tpl = tpl.replace('{' + key + '}', encode ? encodeHTML(value) : value);
	  });
	  return tpl;
	}
	/**
	 * @param {Object|string} [opt] If string, means color.
	 * @param {string} [opt.color]
	 * @param {string} [opt.extraCssText]
	 * @param {string} [opt.type='item'] 'item' or 'subItem'
	 * @param {string} [opt.renderMode='html'] render mode of tooltip, 'html' or 'richText'
	 * @param {string} [opt.markerId='X'] id name for marker. If only one marker is in a rich text, this can be omitted.
	 * @return {string}
	 */
	
	
	function getTooltipMarker(opt, extraCssText) {
	  opt = zrUtil.isString(opt) ? {
	    color: opt,
	    extraCssText: extraCssText
	  } : opt || {};
	  var color = opt.color;
	  var type = opt.type;
	  var extraCssText = opt.extraCssText;
	  var renderMode = opt.renderMode || 'html';
	  var markerId = opt.markerId || 'X';
	
	  if (!color) {
	    return '';
	  }
	
	  if (renderMode === 'html') {
	    return type === 'subItem' ? '<span style="display:inline-block;vertical-align:middle;margin-right:8px;margin-left:3px;' + 'border-radius:4px;width:4px;height:4px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>' : '<span style="display:inline-block;margin-right:5px;' + 'border-radius:10px;width:10px;height:10px;background-color:' + encodeHTML(color) + ';' + (extraCssText || '') + '"></span>';
	  } else {
	    // Space for rich element marker
	    return {
	      renderMode: renderMode,
	      content: '{marker' + markerId + '|}  ',
	      style: {
	        color: color
	      }
	    };
	  }
	}
	
	function pad(str, len) {
	  str += '';
	  return '0000'.substr(0, len - str.length) + str;
	}
	/**
	 * ISO Date format
	 * @param {string} tpl
	 * @param {number} value
	 * @param {boolean} [isUTC=false] Default in local time.
	 *           see `module:echarts/scale/Time`
	 *           and `module:echarts/util/number#parseDate`.
	 * @inner
	 */
	
	
	function formatTime(tpl, value, isUTC) {
	  if (tpl === 'week' || tpl === 'month' || tpl === 'quarter' || tpl === 'half-year' || tpl === 'year') {
	    tpl = 'MM-dd\nyyyy';
	  }
	
	  var date = numberUtil.parseDate(value);
	  var utc = isUTC ? 'UTC' : '';
	  var y = date['get' + utc + 'FullYear']();
	  var M = date['get' + utc + 'Month']() + 1;
	  var d = date['get' + utc + 'Date']();
	  var h = date['get' + utc + 'Hours']();
	  var m = date['get' + utc + 'Minutes']();
	  var s = date['get' + utc + 'Seconds']();
	  var S = date['get' + utc + 'Milliseconds']();
	  tpl = tpl.replace('MM', pad(M, 2)).replace('M', M).replace('yyyy', y).replace('yy', y % 100).replace('dd', pad(d, 2)).replace('d', d).replace('hh', pad(h, 2)).replace('h', h).replace('mm', pad(m, 2)).replace('m', m).replace('ss', pad(s, 2)).replace('s', s).replace('SSS', pad(S, 3));
	  return tpl;
	}
	/**
	 * Capital first
	 * @param {string} str
	 * @return {string}
	 */
	
	
	function capitalFirst(str) {
	  return str ? str.charAt(0).toUpperCase() + str.substr(1) : str;
	}
	
	var truncateText = textContain.truncateText;
	/**
	 * @public
	 * @param {Object} opt
	 * @param {string} opt.text
	 * @param {string} opt.font
	 * @param {string} [opt.textAlign='left']
	 * @param {string} [opt.textVerticalAlign='top']
	 * @param {Array.<number>} [opt.textPadding]
	 * @param {number} [opt.textLineHeight]
	 * @param {Object} [opt.rich]
	 * @param {Object} [opt.truncate]
	 * @return {Object} {x, y, width, height, lineHeight}
	 */
	
	function getTextBoundingRect(opt) {
	  return textContain.getBoundingRect(opt.text, opt.font, opt.textAlign, opt.textVerticalAlign, opt.textPadding, opt.textLineHeight, opt.rich, opt.truncate);
	}
	/**
	 * @deprecated
	 * the `textLineHeight` was added later.
	 * For backward compatiblility, put it as the last parameter.
	 * But deprecated this interface. Please use `getTextBoundingRect` instead.
	 */
	
	
	function getTextRect(text, font, textAlign, textVerticalAlign, textPadding, rich, truncate, textLineHeight) {
	  return textContain.getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate);
	}
	/**
	 * open new tab
	 * @param {string} link url
	 * @param {string} target blank or self
	 */
	
	
	function windowOpen(link, target) {
	  if (target === '_blank' || target === 'blank') {
	    var blank = window.open();
	    blank.opener = null;
	    blank.location = link;
	  } else {
	    window.open(link, target);
	  }
	}
	
	exports.addCommas = addCommas;
	exports.toCamelCase = toCamelCase;
	exports.normalizeCssArray = normalizeCssArray;
	exports.encodeHTML = encodeHTML;
	exports.formatTpl = formatTpl;
	exports.formatTplSimple = formatTplSimple;
	exports.getTooltipMarker = getTooltipMarker;
	exports.formatTime = formatTime;
	exports.capitalFirst = capitalFirst;
	exports.truncateText = truncateText;
	exports.getTextBoundingRect = getTextBoundingRect;
	exports.getTextRect = getTextRect;
	exports.windowOpen = windowOpen;

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(101);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryRenewalWorkflow = exports.queryCallbackRenewal = exports.queryReturnRenewal = exports.queryNextRenewalArchive = exports.queryNextRenewalScan = exports.queryNextRenewalUpload = exports.queryNextRenewal = exports.querySaveRenewal = exports.queryRenewalInfo = exports.queryRenewalList = exports.queryRenewalMyList = exports.querySaveMaterialReturn = exports.queryMaterialReturnListBMDone = exports.queryMaterialReturnListBMTodo = exports.queryMaterialReturnListBM = exports.queryMaterialReturnListBRDone = exports.queryMaterialReturnListBRTodo = exports.queryMaterialReturnListBR = exports.queryMaterialReturnListDone = exports.queryMaterialReturnListTodo = exports.queryMaterialReturnList = exports.queryMaterialBorrowWorkflow = exports.queryCallbackMaterialBorrow = exports.queryReturnMaterialBorrow = exports.queryNextMaterialBorrow = exports.queryDeleteMaterialBorrow = exports.querySaveMaterialBorrow = exports.queryMaterialBorrowInfo = exports.queryMyMaterialBorrowCheckList = exports.queryMaterialBorrowMyList = exports.queryMaterialBorrowList = exports.queryMaterialDocumentLog = exports.queryDeleteMaterialDocument = exports.querySaveMaterialDocument = exports.queryMaterialDocumentInfo = exports.queryMaterialDocumentMy = exports.queryMaterialDocumentListBM = exports.queryMaterialDocumentListBR = exports.queryMaterialDocumentList = exports.queryMaterialDocumentType = exports.queryMaterialDatabaseType = exports.queryMaterialDatabaseDelete = exports.queryMaterialDatabaseSave = exports.queryMaterialDatabaseInfo = exports.queryMaterialDatabaseListBM = exports.queryMaterialDatabaseListBR = exports.queryMaterialDatabaseList = exports.queryDeleteMaterialDirectory = exports.querySaveMaterialDirectory = exports.queryMaterialDirectoryInfo = exports.queryMaterialDirectoryList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	// 资料目录
	var queryMaterialDirectoryList = exports.queryMaterialDirectoryList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DIRECTORY_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryMaterialDirectoryList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDirectoryInfo = exports.queryMaterialDirectoryInfo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DIRECTORY_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryMaterialDirectoryInfo(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var querySaveMaterialDirectory = exports.querySaveMaterialDirectory = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.post(_req.administrative.MATERIAL_DIRECTORY_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function querySaveMaterialDirectory(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryDeleteMaterialDirectory = exports.queryDeleteMaterialDirectory = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DIRECTORY_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryDeleteMaterialDirectory(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	// 资料库
	
	
	var queryMaterialDatabaseList = exports.queryMaterialDatabaseList = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DATABASE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryMaterialDatabaseList(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDatabaseListBR = exports.queryMaterialDatabaseListBR = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DATABASE_LIST_BR, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryMaterialDatabaseListBR(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDatabaseListBM = exports.queryMaterialDatabaseListBM = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DATABASE_LIST_BM, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryMaterialDatabaseListBM(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDatabaseInfo = exports.queryMaterialDatabaseInfo = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DATABASE_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryMaterialDatabaseInfo(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDatabaseSave = exports.queryMaterialDatabaseSave = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.post(_req.administrative.MATERIAL_DATABASE_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryMaterialDatabaseSave(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDatabaseDelete = exports.queryMaterialDatabaseDelete = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DATABASE_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryMaterialDatabaseDelete(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDatabaseType = exports.queryMaterialDatabaseType = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DATABASE_TYPE, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryMaterialDatabaseType(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	// 资料文档
	
	
	var queryMaterialDocumentType = exports.queryMaterialDocumentType = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12() {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.get(_req.core.DICT_MATERIAL_DOCUMENT_TYPE));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryMaterialDocumentType() {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDocumentList = exports.queryMaterialDocumentList = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DOCUMENT_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryMaterialDocumentList(_x12) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDocumentListBR = exports.queryMaterialDocumentListBR = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DOCUMENT_LIST_BR, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryMaterialDocumentListBR(_x13) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDocumentListBM = exports.queryMaterialDocumentListBM = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DOCUMENT_LIST_BM, params));
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function queryMaterialDocumentListBM(_x14) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDocumentMy = exports.queryMaterialDocumentMy = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(params) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            return _context16.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DOCUMENT_MY, params));
	
	          case 1:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function queryMaterialDocumentMy(_x15) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDocumentInfo = exports.queryMaterialDocumentInfo = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(params) {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            return _context17.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DOCUMENT_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, this);
	  }));
	
	  return function queryMaterialDocumentInfo(_x16) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	
	var querySaveMaterialDocument = exports.querySaveMaterialDocument = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(params) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            return _context18.abrupt('return', _http2.default.post(_req.administrative.MATERIAL_DOCUMENT_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, this);
	  }));
	
	  return function querySaveMaterialDocument(_x17) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	
	var queryDeleteMaterialDocument = exports.queryDeleteMaterialDocument = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(params) {
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            return _context19.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DOCUMENT_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context19.stop();
	        }
	      }
	    }, _callee19, this);
	  }));
	
	  return function queryDeleteMaterialDocument(_x18) {
	    return _ref19.apply(this, arguments);
	  };
	}();
	
	var queryMaterialDocumentLog = exports.queryMaterialDocumentLog = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(params) {
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            return _context20.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_DOCUMENT_LOG, params));
	
	          case 1:
	          case 'end':
	            return _context20.stop();
	        }
	      }
	    }, _callee20, this);
	  }));
	
	  return function queryMaterialDocumentLog(_x19) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	// 资料借用
	
	
	var queryMaterialBorrowList = exports.queryMaterialBorrowList = function () {
	  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(params) {
	    return _regenerator2.default.wrap(function _callee21$(_context21) {
	      while (1) {
	        switch (_context21.prev = _context21.next) {
	          case 0:
	            return _context21.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_BORROW_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context21.stop();
	        }
	      }
	    }, _callee21, this);
	  }));
	
	  return function queryMaterialBorrowList(_x20) {
	    return _ref21.apply(this, arguments);
	  };
	}();
	
	var queryMaterialBorrowMyList = exports.queryMaterialBorrowMyList = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(params) {
	    return _regenerator2.default.wrap(function _callee22$(_context22) {
	      while (1) {
	        switch (_context22.prev = _context22.next) {
	          case 0:
	            return _context22.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_BORROW_MY, params));
	
	          case 1:
	          case 'end':
	            return _context22.stop();
	        }
	      }
	    }, _callee22, this);
	  }));
	
	  return function queryMaterialBorrowMyList(_x21) {
	    return _ref22.apply(this, arguments);
	  };
	}();
	
	var queryMyMaterialBorrowCheckList = exports.queryMyMaterialBorrowCheckList = function () {
	  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(params) {
	    return _regenerator2.default.wrap(function _callee23$(_context23) {
	      while (1) {
	        switch (_context23.prev = _context23.next) {
	          case 0:
	            return _context23.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_BORROW_CHECK, params));
	
	          case 1:
	          case 'end':
	            return _context23.stop();
	        }
	      }
	    }, _callee23, this);
	  }));
	
	  return function queryMyMaterialBorrowCheckList(_x22) {
	    return _ref23.apply(this, arguments);
	  };
	}();
	
	var queryMaterialBorrowInfo = exports.queryMaterialBorrowInfo = function () {
	  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(params) {
	    return _regenerator2.default.wrap(function _callee24$(_context24) {
	      while (1) {
	        switch (_context24.prev = _context24.next) {
	          case 0:
	            return _context24.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_BORROW_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context24.stop();
	        }
	      }
	    }, _callee24, this);
	  }));
	
	  return function queryMaterialBorrowInfo(_x23) {
	    return _ref24.apply(this, arguments);
	  };
	}();
	
	var querySaveMaterialBorrow = exports.querySaveMaterialBorrow = function () {
	  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(params) {
	    return _regenerator2.default.wrap(function _callee25$(_context25) {
	      while (1) {
	        switch (_context25.prev = _context25.next) {
	          case 0:
	            return _context25.abrupt('return', _http2.default.post(_req.administrative.MATERIAL_BORROW_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context25.stop();
	        }
	      }
	    }, _callee25, this);
	  }));
	
	  return function querySaveMaterialBorrow(_x24) {
	    return _ref25.apply(this, arguments);
	  };
	}();
	
	var queryDeleteMaterialBorrow = exports.queryDeleteMaterialBorrow = function () {
	  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(params) {
	    return _regenerator2.default.wrap(function _callee26$(_context26) {
	      while (1) {
	        switch (_context26.prev = _context26.next) {
	          case 0:
	            return _context26.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_BORROW_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context26.stop();
	        }
	      }
	    }, _callee26, this);
	  }));
	
	  return function queryDeleteMaterialBorrow(_x25) {
	    return _ref26.apply(this, arguments);
	  };
	}();
	
	var queryNextMaterialBorrow = exports.queryNextMaterialBorrow = function () {
	  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(params) {
	    return _regenerator2.default.wrap(function _callee27$(_context27) {
	      while (1) {
	        switch (_context27.prev = _context27.next) {
	          case 0:
	            return _context27.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_BORROW_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context27.stop();
	        }
	      }
	    }, _callee27, this);
	  }));
	
	  return function queryNextMaterialBorrow(_x26) {
	    return _ref27.apply(this, arguments);
	  };
	}();
	
	var queryReturnMaterialBorrow = exports.queryReturnMaterialBorrow = function () {
	  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(params) {
	    return _regenerator2.default.wrap(function _callee28$(_context28) {
	      while (1) {
	        switch (_context28.prev = _context28.next) {
	          case 0:
	            return _context28.abrupt('return', _http2.default.post(_req.administrative.MATERIAL_BORROW_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context28.stop();
	        }
	      }
	    }, _callee28, this);
	  }));
	
	  return function queryReturnMaterialBorrow(_x27) {
	    return _ref28.apply(this, arguments);
	  };
	}();
	
	var queryCallbackMaterialBorrow = exports.queryCallbackMaterialBorrow = function () {
	  var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(params) {
	    return _regenerator2.default.wrap(function _callee29$(_context29) {
	      while (1) {
	        switch (_context29.prev = _context29.next) {
	          case 0:
	            return _context29.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_BORROW_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context29.stop();
	        }
	      }
	    }, _callee29, this);
	  }));
	
	  return function queryCallbackMaterialBorrow(_x28) {
	    return _ref29.apply(this, arguments);
	  };
	}();
	
	var queryMaterialBorrowWorkflow = exports.queryMaterialBorrowWorkflow = function () {
	  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(params) {
	    return _regenerator2.default.wrap(function _callee30$(_context30) {
	      while (1) {
	        switch (_context30.prev = _context30.next) {
	          case 0:
	            return _context30.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_BORROW_WORKFLOW, params));
	
	          case 1:
	          case 'end':
	            return _context30.stop();
	        }
	      }
	    }, _callee30, this);
	  }));
	
	  return function queryMaterialBorrowWorkflow(_x29) {
	    return _ref30.apply(this, arguments);
	  };
	}();
	
	// 资料归还
	
	
	var queryMaterialReturnList = exports.queryMaterialReturnList = function () {
	  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(params) {
	    return _regenerator2.default.wrap(function _callee31$(_context31) {
	      while (1) {
	        switch (_context31.prev = _context31.next) {
	          case 0:
	            return _context31.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RETURN_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context31.stop();
	        }
	      }
	    }, _callee31, this);
	  }));
	
	  return function queryMaterialReturnList(_x30) {
	    return _ref31.apply(this, arguments);
	  };
	}();
	
	var queryMaterialReturnListTodo = exports.queryMaterialReturnListTodo = function () {
	  var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(params) {
	    return _regenerator2.default.wrap(function _callee32$(_context32) {
	      while (1) {
	        switch (_context32.prev = _context32.next) {
	          case 0:
	            return _context32.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RETURN_LIST_TODO, params));
	
	          case 1:
	          case 'end':
	            return _context32.stop();
	        }
	      }
	    }, _callee32, this);
	  }));
	
	  return function queryMaterialReturnListTodo(_x31) {
	    return _ref32.apply(this, arguments);
	  };
	}();
	
	var queryMaterialReturnListDone = exports.queryMaterialReturnListDone = function () {
	  var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(params) {
	    return _regenerator2.default.wrap(function _callee33$(_context33) {
	      while (1) {
	        switch (_context33.prev = _context33.next) {
	          case 0:
	            return _context33.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RETURN_LIST_DONE, params));
	
	          case 1:
	          case 'end':
	            return _context33.stop();
	        }
	      }
	    }, _callee33, this);
	  }));
	
	  return function queryMaterialReturnListDone(_x32) {
	    return _ref33.apply(this, arguments);
	  };
	}();
	
	var queryMaterialReturnListBR = exports.queryMaterialReturnListBR = function () {
	  var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(params) {
	    return _regenerator2.default.wrap(function _callee34$(_context34) {
	      while (1) {
	        switch (_context34.prev = _context34.next) {
	          case 0:
	            return _context34.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RETURN_BR, params));
	
	          case 1:
	          case 'end':
	            return _context34.stop();
	        }
	      }
	    }, _callee34, this);
	  }));
	
	  return function queryMaterialReturnListBR(_x33) {
	    return _ref34.apply(this, arguments);
	  };
	}();
	
	var queryMaterialReturnListBRTodo = exports.queryMaterialReturnListBRTodo = function () {
	  var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(params) {
	    return _regenerator2.default.wrap(function _callee35$(_context35) {
	      while (1) {
	        switch (_context35.prev = _context35.next) {
	          case 0:
	            return _context35.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RETURN_BR_TODO, params));
	
	          case 1:
	          case 'end':
	            return _context35.stop();
	        }
	      }
	    }, _callee35, this);
	  }));
	
	  return function queryMaterialReturnListBRTodo(_x34) {
	    return _ref35.apply(this, arguments);
	  };
	}();
	
	var queryMaterialReturnListBRDone = exports.queryMaterialReturnListBRDone = function () {
	  var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(params) {
	    return _regenerator2.default.wrap(function _callee36$(_context36) {
	      while (1) {
	        switch (_context36.prev = _context36.next) {
	          case 0:
	            return _context36.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RETURN_BR_DONE, params));
	
	          case 1:
	          case 'end':
	            return _context36.stop();
	        }
	      }
	    }, _callee36, this);
	  }));
	
	  return function queryMaterialReturnListBRDone(_x35) {
	    return _ref36.apply(this, arguments);
	  };
	}();
	
	var queryMaterialReturnListBM = exports.queryMaterialReturnListBM = function () {
	  var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(params) {
	    return _regenerator2.default.wrap(function _callee37$(_context37) {
	      while (1) {
	        switch (_context37.prev = _context37.next) {
	          case 0:
	            return _context37.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RETURN_BM, params));
	
	          case 1:
	          case 'end':
	            return _context37.stop();
	        }
	      }
	    }, _callee37, this);
	  }));
	
	  return function queryMaterialReturnListBM(_x36) {
	    return _ref37.apply(this, arguments);
	  };
	}();
	
	var queryMaterialReturnListBMTodo = exports.queryMaterialReturnListBMTodo = function () {
	  var _ref38 = _asyncToGenerator(_regenerator2.default.mark(function _callee38(params) {
	    return _regenerator2.default.wrap(function _callee38$(_context38) {
	      while (1) {
	        switch (_context38.prev = _context38.next) {
	          case 0:
	            return _context38.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RETURN_BM_TODO, params));
	
	          case 1:
	          case 'end':
	            return _context38.stop();
	        }
	      }
	    }, _callee38, this);
	  }));
	
	  return function queryMaterialReturnListBMTodo(_x37) {
	    return _ref38.apply(this, arguments);
	  };
	}();
	
	var queryMaterialReturnListBMDone = exports.queryMaterialReturnListBMDone = function () {
	  var _ref39 = _asyncToGenerator(_regenerator2.default.mark(function _callee39(params) {
	    return _regenerator2.default.wrap(function _callee39$(_context39) {
	      while (1) {
	        switch (_context39.prev = _context39.next) {
	          case 0:
	            return _context39.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RETURN_BM_DONE, params));
	
	          case 1:
	          case 'end':
	            return _context39.stop();
	        }
	      }
	    }, _callee39, this);
	  }));
	
	  return function queryMaterialReturnListBMDone(_x38) {
	    return _ref39.apply(this, arguments);
	  };
	}();
	
	var querySaveMaterialReturn = exports.querySaveMaterialReturn = function () {
	  var _ref40 = _asyncToGenerator(_regenerator2.default.mark(function _callee40(params) {
	    return _regenerator2.default.wrap(function _callee40$(_context40) {
	      while (1) {
	        switch (_context40.prev = _context40.next) {
	          case 0:
	            return _context40.abrupt('return', _http2.default.post(_req.administrative.MATERIAL_RETURN_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context40.stop();
	        }
	      }
	    }, _callee40, this);
	  }));
	
	  return function querySaveMaterialReturn(_x39) {
	    return _ref40.apply(this, arguments);
	  };
	}();
	
	var queryRenewalMyList = exports.queryRenewalMyList = function () {
	  var _ref41 = _asyncToGenerator(_regenerator2.default.mark(function _callee41() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee41$(_context41) {
	      while (1) {
	        switch (_context41.prev = _context41.next) {
	          case 0:
	            return _context41.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RENEWAL_MY, params));
	
	          case 1:
	          case 'end':
	            return _context41.stop();
	        }
	      }
	    }, _callee41, this);
	  }));
	
	  return function queryRenewalMyList() {
	    return _ref41.apply(this, arguments);
	  };
	}();
	
	var queryRenewalList = exports.queryRenewalList = function () {
	  var _ref42 = _asyncToGenerator(_regenerator2.default.mark(function _callee42() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee42$(_context42) {
	      while (1) {
	        switch (_context42.prev = _context42.next) {
	          case 0:
	            return _context42.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RENEWAL_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context42.stop();
	        }
	      }
	    }, _callee42, this);
	  }));
	
	  return function queryRenewalList() {
	    return _ref42.apply(this, arguments);
	  };
	}();
	
	var queryRenewalInfo = exports.queryRenewalInfo = function () {
	  var _ref43 = _asyncToGenerator(_regenerator2.default.mark(function _callee43() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee43$(_context43) {
	      while (1) {
	        switch (_context43.prev = _context43.next) {
	          case 0:
	            return _context43.abrupt('return', _http2.default.get(_req.administrative.GET_MATERIAL_RENEWAL_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context43.stop();
	        }
	      }
	    }, _callee43, this);
	  }));
	
	  return function queryRenewalInfo() {
	    return _ref43.apply(this, arguments);
	  };
	}();
	
	var querySaveRenewal = exports.querySaveRenewal = function () {
	  var _ref44 = _asyncToGenerator(_regenerator2.default.mark(function _callee44() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee44$(_context44) {
	      while (1) {
	        switch (_context44.prev = _context44.next) {
	          case 0:
	            return _context44.abrupt('return', _http2.default.post(_req.administrative.MATERIAL_RENEWAL_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context44.stop();
	        }
	      }
	    }, _callee44, this);
	  }));
	
	  return function querySaveRenewal() {
	    return _ref44.apply(this, arguments);
	  };
	}();
	
	var queryNextRenewal = exports.queryNextRenewal = function () {
	  var _ref45 = _asyncToGenerator(_regenerator2.default.mark(function _callee45() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    return _regenerator2.default.wrap(function _callee45$(_context45) {
	      while (1) {
	        switch (_context45.prev = _context45.next) {
	          case 0:
	            return _context45.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_RENEWAL_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context45.stop();
	        }
	      }
	    }, _callee45, this);
	  }));
	
	  return function queryNextRenewal() {
	    return _ref45.apply(this, arguments);
	  };
	}();
	
	var queryNextRenewalUpload = exports.queryNextRenewalUpload = function () {
	  var _ref46 = _asyncToGenerator(_regenerator2.default.mark(function _callee46(params) {
	    return _regenerator2.default.wrap(function _callee46$(_context46) {
	      while (1) {
	        switch (_context46.prev = _context46.next) {
	          case 0:
	            return _context46.abrupt('return', _http2.default.post(_req.administrative.MATERIAL_RENEWAL_NEXT_UPLOAD, params));
	
	          case 1:
	          case 'end':
	            return _context46.stop();
	        }
	      }
	    }, _callee46, this);
	  }));
	
	  return function queryNextRenewalUpload(_x45) {
	    return _ref46.apply(this, arguments);
	  };
	}();
	
	var queryNextRenewalScan = exports.queryNextRenewalScan = function () {
	  var _ref47 = _asyncToGenerator(_regenerator2.default.mark(function _callee47(params) {
	    return _regenerator2.default.wrap(function _callee47$(_context47) {
	      while (1) {
	        switch (_context47.prev = _context47.next) {
	          case 0:
	            return _context47.abrupt('return', _http2.default.post(_req.administrative.MATERIAL_RENEWAL_NEXT_SCAN, params));
	
	          case 1:
	          case 'end':
	            return _context47.stop();
	        }
	      }
	    }, _callee47, this);
	  }));
	
	  return function queryNextRenewalScan(_x46) {
	    return _ref47.apply(this, arguments);
	  };
	}();
	
	var queryNextRenewalArchive = exports.queryNextRenewalArchive = function () {
	  var _ref48 = _asyncToGenerator(_regenerator2.default.mark(function _callee48(params) {
	    return _regenerator2.default.wrap(function _callee48$(_context48) {
	      while (1) {
	        switch (_context48.prev = _context48.next) {
	          case 0:
	            return _context48.abrupt('return', _http2.default.post(_req.administrative.MATERIAL_RENEWAL_NEXT_ARCHIVE, params));
	
	          case 1:
	          case 'end':
	            return _context48.stop();
	        }
	      }
	    }, _callee48, this);
	  }));
	
	  return function queryNextRenewalArchive(_x47) {
	    return _ref48.apply(this, arguments);
	  };
	}();
	
	var queryReturnRenewal = exports.queryReturnRenewal = function () {
	  var _ref49 = _asyncToGenerator(_regenerator2.default.mark(function _callee49(params) {
	    return _regenerator2.default.wrap(function _callee49$(_context49) {
	      while (1) {
	        switch (_context49.prev = _context49.next) {
	          case 0:
	            return _context49.abrupt('return', _http2.default.post(_req.administrative.MATERIAL_RENEWAL_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context49.stop();
	        }
	      }
	    }, _callee49, this);
	  }));
	
	  return function queryReturnRenewal(_x48) {
	    return _ref49.apply(this, arguments);
	  };
	}();
	
	var queryCallbackRenewal = exports.queryCallbackRenewal = function () {
	  var _ref50 = _asyncToGenerator(_regenerator2.default.mark(function _callee50(params) {
	    return _regenerator2.default.wrap(function _callee50$(_context50) {
	      while (1) {
	        switch (_context50.prev = _context50.next) {
	          case 0:
	            return _context50.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_RENEWAL_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context50.stop();
	        }
	      }
	    }, _callee50, this);
	  }));
	
	  return function queryCallbackRenewal(_x49) {
	    return _ref50.apply(this, arguments);
	  };
	}();
	
	var queryRenewalWorkflow = exports.queryRenewalWorkflow = function () {
	  var _ref51 = _asyncToGenerator(_regenerator2.default.mark(function _callee51(params) {
	    return _regenerator2.default.wrap(function _callee51$(_context51) {
	      while (1) {
	        switch (_context51.prev = _context51.next) {
	          case 0:
	            return _context51.abrupt('return', _http2.default.get(_req.administrative.MATERIAL_RENEWAL_WORKFLOW, params));
	
	          case 1:
	          case 'end':
	            return _context51.stop();
	        }
	      }
	    }, _callee51, this);
	  }));
	
	  return function queryRenewalWorkflow(_x50) {
	    return _ref51.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* 资料模块api */

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Page);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Page.__proto__ || Object.getPrototypeOf(Page)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFold: true
	    }, _this.columns = function () {
	      return [{
	        title: "日期",
	        dataIndex: "date",
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            text ? _moment2.default.unix(text / 1000).format("YYYY-MM-DD HH:mm") : null
	          );
	        }
	      }, {
	        title: "操作内容",
	        dataIndex: "operating"
	      }, {
	        title: "处理意见",
	        dataIndex: "refuse"
	      }];
	    }, _this.handleFold = function (flag) {
	      _this.setState({
	        isFold: !!flag
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Page, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var dataSource = this.props.dataSource;
	      var isFold = this.state.isFold;
	
	      var list = [];
	      if (dataSource.length > 1) {
	        list = isFold ? [dataSource[0]] : dataSource;
	      } else {
	        list = dataSource;
	      }
	      var style = {
	        width: "60px",
	        height: "30px",
	        borderRadius: "999px",
	        textAlign: "center",
	        lineHeight: "26px",
	        fontSize: "16px",
	        marginRight: "10px",
	        marginTop: "12px",
	        color: "#999"
	      };
	      return _react2.default.createElement(
	        _antd.Row,
	        { type: "flex" },
	        dataSource.length > 1 ? _react2.default.createElement(
	          _antd.Col,
	          { style: style },
	          isFold ? _react2.default.createElement(
	            "div",
	            {
	              onClick: function onClick() {
	                return _this2.handleFold(false);
	              },
	              style: { cursor: "pointer" }
	            },
	            "\u5C55\u5F00",
	            _react2.default.createElement(_antd.Icon, { type: "right" })
	          ) : null,
	          !isFold ? _react2.default.createElement(
	            "div",
	            {
	              onClick: function onClick() {
	                return _this2.handleFold(true);
	              },
	              style: { cursor: "pointer" }
	            },
	            "\u6536\u8D77",
	            _react2.default.createElement(_antd.Icon, { type: "down" })
	          ) : null
	        ) : null,
	        _react2.default.createElement(
	          _antd.Col,
	          { style: { flex: 1 } },
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            rowKey: "uuid",
	            pagination: false,
	            dataSource: list
	          })
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var BlockTree = __webpack_require__(795);
	var ContentState = __webpack_require__(488);
	var EditorBidiService = __webpack_require__(2150);
	var Immutable = __webpack_require__(39);
	var SelectionState = __webpack_require__(244);
	
	var OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Stack = Immutable.Stack;
	
	
	var defaultRecord = {
	  allowUndo: true,
	  currentContent: null,
	  decorator: null,
	  directionMap: null,
	  forceSelection: false,
	  inCompositionMode: false,
	  inlineStyleOverride: null,
	  lastChangeType: null,
	  nativelyRenderedContent: null,
	  redoStack: Stack(),
	  selection: null,
	  treeMap: null,
	  undoStack: Stack()
	};
	
	var EditorStateRecord = Record(defaultRecord);
	
	var EditorState = function () {
	  EditorState.createEmpty = function createEmpty(decorator) {
	    return EditorState.createWithContent(ContentState.createFromText(''), decorator);
	  };
	
	  EditorState.createWithContent = function createWithContent(contentState, decorator) {
	    var firstKey = contentState.getBlockMap().first().getKey();
	    return EditorState.create({
	      currentContent: contentState,
	      undoStack: Stack(),
	      redoStack: Stack(),
	      decorator: decorator || null,
	      selection: SelectionState.createEmpty(firstKey)
	    });
	  };
	
	  EditorState.create = function create(config) {
	    var currentContent = config.currentContent,
	        decorator = config.decorator;
	
	    var recordConfig = _extends({}, config, {
	      treeMap: generateNewTreeMap(currentContent, decorator),
	      directionMap: EditorBidiService.getDirectionMap(currentContent)
	    });
	    return new EditorState(new EditorStateRecord(recordConfig));
	  };
	
	  EditorState.set = function set(editorState, put) {
	    var map = editorState.getImmutable().withMutations(function (state) {
	      var existingDecorator = state.get('decorator');
	      var decorator = existingDecorator;
	      if (put.decorator === null) {
	        decorator = null;
	      } else if (put.decorator) {
	        decorator = put.decorator;
	      }
	
	      var newContent = put.currentContent || editorState.getCurrentContent();
	
	      if (decorator !== existingDecorator) {
	        var treeMap = state.get('treeMap');
	        var newTreeMap;
	        if (decorator && existingDecorator) {
	          newTreeMap = regenerateTreeForNewDecorator(newContent, newContent.getBlockMap(), treeMap, decorator, existingDecorator);
	        } else {
	          newTreeMap = generateNewTreeMap(newContent, decorator);
	        }
	
	        state.merge({
	          decorator: decorator,
	          treeMap: newTreeMap,
	          nativelyRenderedContent: null
	        });
	        return;
	      }
	
	      var existingContent = editorState.getCurrentContent();
	      if (newContent !== existingContent) {
	        state.set('treeMap', regenerateTreeForNewBlocks(editorState, newContent.getBlockMap(), newContent.getEntityMap(), decorator));
	      }
	
	      state.merge(put);
	    });
	
	    return new EditorState(map);
	  };
	
	  EditorState.prototype.toJS = function toJS() {
	    return this.getImmutable().toJS();
	  };
	
	  EditorState.prototype.getAllowUndo = function getAllowUndo() {
	    return this.getImmutable().get('allowUndo');
	  };
	
	  EditorState.prototype.getCurrentContent = function getCurrentContent() {
	    return this.getImmutable().get('currentContent');
	  };
	
	  EditorState.prototype.getUndoStack = function getUndoStack() {
	    return this.getImmutable().get('undoStack');
	  };
	
	  EditorState.prototype.getRedoStack = function getRedoStack() {
	    return this.getImmutable().get('redoStack');
	  };
	
	  EditorState.prototype.getSelection = function getSelection() {
	    return this.getImmutable().get('selection');
	  };
	
	  EditorState.prototype.getDecorator = function getDecorator() {
	    return this.getImmutable().get('decorator');
	  };
	
	  EditorState.prototype.isInCompositionMode = function isInCompositionMode() {
	    return this.getImmutable().get('inCompositionMode');
	  };
	
	  EditorState.prototype.mustForceSelection = function mustForceSelection() {
	    return this.getImmutable().get('forceSelection');
	  };
	
	  EditorState.prototype.getNativelyRenderedContent = function getNativelyRenderedContent() {
	    return this.getImmutable().get('nativelyRenderedContent');
	  };
	
	  EditorState.prototype.getLastChangeType = function getLastChangeType() {
	    return this.getImmutable().get('lastChangeType');
	  };
	
	  /**
	   * While editing, the user may apply inline style commands with a collapsed
	   * cursor, intending to type text that adopts the specified style. In this
	   * case, we track the specified style as an "override" that takes precedence
	   * over the inline style of the text adjacent to the cursor.
	   *
	   * If null, there is no override in place.
	   */
	
	
	  EditorState.prototype.getInlineStyleOverride = function getInlineStyleOverride() {
	    return this.getImmutable().get('inlineStyleOverride');
	  };
	
	  EditorState.setInlineStyleOverride = function setInlineStyleOverride(editorState, inlineStyleOverride) {
	    return EditorState.set(editorState, { inlineStyleOverride: inlineStyleOverride });
	  };
	
	  /**
	   * Get the appropriate inline style for the editor state. If an
	   * override is in place, use it. Otherwise, the current style is
	   * based on the location of the selection state.
	   */
	
	
	  EditorState.prototype.getCurrentInlineStyle = function getCurrentInlineStyle() {
	    var override = this.getInlineStyleOverride();
	    if (override != null) {
	      return override;
	    }
	
	    var content = this.getCurrentContent();
	    var selection = this.getSelection();
	
	    if (selection.isCollapsed()) {
	      return getInlineStyleForCollapsedSelection(content, selection);
	    }
	
	    return getInlineStyleForNonCollapsedSelection(content, selection);
	  };
	
	  EditorState.prototype.getBlockTree = function getBlockTree(blockKey) {
	    return this.getImmutable().getIn(['treeMap', blockKey]);
	  };
	
	  EditorState.prototype.isSelectionAtStartOfContent = function isSelectionAtStartOfContent() {
	    var firstKey = this.getCurrentContent().getBlockMap().first().getKey();
	    return this.getSelection().hasEdgeWithin(firstKey, 0, 0);
	  };
	
	  EditorState.prototype.isSelectionAtEndOfContent = function isSelectionAtEndOfContent() {
	    var content = this.getCurrentContent();
	    var blockMap = content.getBlockMap();
	    var last = blockMap.last();
	    var end = last.getLength();
	    return this.getSelection().hasEdgeWithin(last.getKey(), end, end);
	  };
	
	  EditorState.prototype.getDirectionMap = function getDirectionMap() {
	    return this.getImmutable().get('directionMap');
	  };
	
	  /**
	   * Incorporate native DOM selection changes into the EditorState. This
	   * method can be used when we simply want to accept whatever the DOM
	   * has given us to represent selection, and we do not need to re-render
	   * the editor.
	   *
	   * To forcibly move the DOM selection, see `EditorState.forceSelection`.
	   */
	
	
	  EditorState.acceptSelection = function acceptSelection(editorState, selection) {
	    return updateSelection(editorState, selection, false);
	  };
	
	  /**
	   * At times, we need to force the DOM selection to be where we
	   * need it to be. This can occur when the anchor or focus nodes
	   * are non-text nodes, for instance. In this case, we want to trigger
	   * a re-render of the editor, which in turn forces selection into
	   * the correct place in the DOM. The `forceSelection` method
	   * accomplishes this.
	   *
	   * This method should be used in cases where you need to explicitly
	   * move the DOM selection from one place to another without a change
	   * in ContentState.
	   */
	
	
	  EditorState.forceSelection = function forceSelection(editorState, selection) {
	    if (!selection.getHasFocus()) {
	      selection = selection.set('hasFocus', true);
	    }
	    return updateSelection(editorState, selection, true);
	  };
	
	  /**
	   * Move selection to the end of the editor without forcing focus.
	   */
	
	
	  EditorState.moveSelectionToEnd = function moveSelectionToEnd(editorState) {
	    var content = editorState.getCurrentContent();
	    var lastBlock = content.getLastBlock();
	    var lastKey = lastBlock.getKey();
	    var length = lastBlock.getLength();
	
	    return EditorState.acceptSelection(editorState, new SelectionState({
	      anchorKey: lastKey,
	      anchorOffset: length,
	      focusKey: lastKey,
	      focusOffset: length,
	      isBackward: false
	    }));
	  };
	
	  /**
	   * Force focus to the end of the editor. This is useful in scenarios
	   * where we want to programmatically focus the input and it makes sense
	   * to allow the user to continue working seamlessly.
	   */
	
	
	  EditorState.moveFocusToEnd = function moveFocusToEnd(editorState) {
	    var afterSelectionMove = EditorState.moveSelectionToEnd(editorState);
	    return EditorState.forceSelection(afterSelectionMove, afterSelectionMove.getSelection());
	  };
	
	  /**
	   * Push the current ContentState onto the undo stack if it should be
	   * considered a boundary state, and set the provided ContentState as the
	   * new current content.
	   */
	
	
	  EditorState.push = function push(editorState, contentState, changeType) {
	    if (editorState.getCurrentContent() === contentState) {
	      return editorState;
	    }
	
	    var forceSelection = changeType !== 'insert-characters';
	    var directionMap = EditorBidiService.getDirectionMap(contentState, editorState.getDirectionMap());
	
	    if (!editorState.getAllowUndo()) {
	      return EditorState.set(editorState, {
	        currentContent: contentState,
	        directionMap: directionMap,
	        lastChangeType: changeType,
	        selection: contentState.getSelectionAfter(),
	        forceSelection: forceSelection,
	        inlineStyleOverride: null
	      });
	    }
	
	    var selection = editorState.getSelection();
	    var currentContent = editorState.getCurrentContent();
	    var undoStack = editorState.getUndoStack();
	    var newContent = contentState;
	
	    if (selection !== currentContent.getSelectionAfter() || mustBecomeBoundary(editorState, changeType)) {
	      undoStack = undoStack.push(currentContent);
	      newContent = newContent.set('selectionBefore', selection);
	    } else if (changeType === 'insert-characters' || changeType === 'backspace-character' || changeType === 'delete-character') {
	      // Preserve the previous selection.
	      newContent = newContent.set('selectionBefore', currentContent.getSelectionBefore());
	    }
	
	    var inlineStyleOverride = editorState.getInlineStyleOverride();
	
	    // Don't discard inline style overrides for the following change types:
	    var overrideChangeTypes = ['adjust-depth', 'change-block-type', 'split-block'];
	
	    if (overrideChangeTypes.indexOf(changeType) === -1) {
	      inlineStyleOverride = null;
	    }
	
	    var editorStateChanges = {
	      currentContent: newContent,
	      directionMap: directionMap,
	      undoStack: undoStack,
	      redoStack: Stack(),
	      lastChangeType: changeType,
	      selection: contentState.getSelectionAfter(),
	      forceSelection: forceSelection,
	      inlineStyleOverride: inlineStyleOverride
	    };
	
	    return EditorState.set(editorState, editorStateChanges);
	  };
	
	  /**
	   * Make the top ContentState in the undo stack the new current content and
	   * push the current content onto the redo stack.
	   */
	
	
	  EditorState.undo = function undo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var undoStack = editorState.getUndoStack();
	    var newCurrentContent = undoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: undoStack.shift(),
	      redoStack: editorState.getRedoStack().push(currentContent),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'undo',
	      nativelyRenderedContent: null,
	      selection: currentContent.getSelectionBefore()
	    });
	  };
	
	  /**
	   * Make the top ContentState in the redo stack the new current content and
	   * push the current content onto the undo stack.
	   */
	
	
	  EditorState.redo = function redo(editorState) {
	    if (!editorState.getAllowUndo()) {
	      return editorState;
	    }
	
	    var redoStack = editorState.getRedoStack();
	    var newCurrentContent = redoStack.peek();
	    if (!newCurrentContent) {
	      return editorState;
	    }
	
	    var currentContent = editorState.getCurrentContent();
	    var directionMap = EditorBidiService.getDirectionMap(newCurrentContent, editorState.getDirectionMap());
	
	    return EditorState.set(editorState, {
	      currentContent: newCurrentContent,
	      directionMap: directionMap,
	      undoStack: editorState.getUndoStack().push(currentContent),
	      redoStack: redoStack.shift(),
	      forceSelection: true,
	      inlineStyleOverride: null,
	      lastChangeType: 'redo',
	      nativelyRenderedContent: null,
	      selection: newCurrentContent.getSelectionAfter()
	    });
	  };
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  function EditorState(immutable) {
	    _classCallCheck(this, EditorState);
	
	    this._immutable = immutable;
	  }
	
	  /**
	   * Not for public consumption.
	   */
	
	
	  EditorState.prototype.getImmutable = function getImmutable() {
	    return this._immutable;
	  };
	
	  return EditorState;
	}();
	
	/**
	 * Set the supplied SelectionState as the new current selection, and set
	 * the `force` flag to trigger manual selection placement by the view.
	 */
	
	
	function updateSelection(editorState, selection, forceSelection) {
	  return EditorState.set(editorState, {
	    selection: selection,
	    forceSelection: forceSelection,
	    nativelyRenderedContent: null,
	    inlineStyleOverride: null
	  });
	}
	
	/**
	 * Regenerate the entire tree map for a given ContentState and decorator.
	 * Returns an OrderedMap that maps all available ContentBlock objects.
	 */
	function generateNewTreeMap(contentState, decorator) {
	  return contentState.getBlockMap().map(function (block) {
	    return BlockTree.generate(contentState, block, decorator);
	  }).toOrderedMap();
	}
	
	/**
	 * Regenerate tree map objects for all ContentBlocks that have changed
	 * between the current editorState and newContent. Returns an OrderedMap
	 * with only changed regenerated tree map objects.
	 */
	function regenerateTreeForNewBlocks(editorState, newBlockMap, newEntityMap, decorator) {
	  var contentState = editorState.getCurrentContent().set('entityMap', newEntityMap);
	  var prevBlockMap = contentState.getBlockMap();
	  var prevTreeMap = editorState.getImmutable().get('treeMap');
	  return prevTreeMap.merge(newBlockMap.toSeq().filter(function (block, key) {
	    return block !== prevBlockMap.get(key);
	  }).map(function (block) {
	    return BlockTree.generate(contentState, block, decorator);
	  }));
	}
	
	/**
	 * Generate tree map objects for a new decorator object, preserving any
	 * decorations that are unchanged from the previous decorator.
	 *
	 * Note that in order for this to perform optimally, decoration Lists for
	 * decorators should be preserved when possible to allow for direct immutable
	 * List comparison.
	 */
	function regenerateTreeForNewDecorator(content, blockMap, previousTreeMap, decorator, existingDecorator) {
	  return previousTreeMap.merge(blockMap.toSeq().filter(function (block) {
	    return decorator.getDecorations(block, content) !== existingDecorator.getDecorations(block, content);
	  }).map(function (block) {
	    return BlockTree.generate(content, block, decorator);
	  }));
	}
	
	/**
	 * Return whether a change should be considered a boundary state, given
	 * the previous change type. Allows us to discard potential boundary states
	 * during standard typing or deletion behavior.
	 */
	function mustBecomeBoundary(editorState, changeType) {
	  var lastChangeType = editorState.getLastChangeType();
	  return changeType !== lastChangeType || changeType !== 'insert-characters' && changeType !== 'backspace-character' && changeType !== 'delete-character';
	}
	
	function getInlineStyleForCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If the cursor is not at the start of the block, look backward to
	  // preserve the style of the preceding character.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // The caret is at position zero in this block. If the block has any
	  // text at all, use the style of the first character.
	  if (startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(0);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function getInlineStyleForNonCollapsedSelection(content, selection) {
	  var startKey = selection.getStartKey();
	  var startOffset = selection.getStartOffset();
	  var startBlock = content.getBlockForKey(startKey);
	
	  // If there is a character just inside the selection, use its style.
	  if (startOffset < startBlock.getLength()) {
	    return startBlock.getInlineStyleAt(startOffset);
	  }
	
	  // Check if the selection at the end of a non-empty block. Use the last
	  // style in the block.
	  if (startOffset > 0) {
	    return startBlock.getInlineStyleAt(startOffset - 1);
	  }
	
	  // Otherwise, look upward in the document to find the closest character.
	  return lookUpwardForInlineStyle(content, startKey);
	}
	
	function lookUpwardForInlineStyle(content, fromKey) {
	  var lastNonEmpty = content.getBlockMap().reverse().skipUntil(function (_, k) {
	    return k === fromKey;
	  }).skip(1).skipUntil(function (block, _) {
	    return block.getLength();
	  }).first();
	
	  if (lastNonEmpty) return lastNonEmpty.getInlineStyleAt(lastNonEmpty.getLength() - 1);
	  return OrderedSet();
	}
	
	module.exports = EditorState;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryConfigOrgInfo = exports.queryConfigOrgOp = exports.queryConfigOrg = exports.queryEnableOrg = exports.queryDisableOrg = exports.queryDeleteOrg = exports.queryUpdateOrg = exports.queryAddOrg = exports.queryMoveOrg = exports.queryOrgEnableTree = exports.queryByOrgTree = exports.queryOrgTree = exports.queryOrgInfo = exports.queryCompany = exports.queryAllCompany = exports.queryOrgCompanyList = exports.queryOrgAllList = exports.queryOrgList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var queryOrgList = exports.queryOrgList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.core.CORE_ORG_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryOrgList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 所有组织列表
	 */
	
	
	var queryOrgAllList = exports.queryOrgAllList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.core.ORG_LIST_ALL, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryOrgAllList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryOrgCompanyList = exports.queryOrgCompanyList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.core.CORE_ORG_COMPANY_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryOrgCompanyList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取公司
	 */
	
	
	var queryAllCompany = exports.queryAllCompany = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            params.type = 1;
	            return _context4.abrupt('return', _http2.default.get(_req.core.ORG_LIST_ALL, params));
	
	          case 2:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryAllCompany(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取公司
	 */
	
	
	var queryCompany = exports.queryCompany = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            params.type = 1;
	            return _context5.abrupt('return', _http2.default.get(_req.core.CORE_ORG_LIST, params));
	
	          case 2:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryCompany(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryOrgInfo = exports.queryOrgInfo = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.core.ORG_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryOrgInfo(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryOrgTree = exports.queryOrgTree = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.core.CORE_ORG_TREE));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryOrgTree() {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var queryByOrgTree = exports.queryByOrgTree = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.core.CORE_BY_ORG_TREE, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryByOrgTree(_x7) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryOrgEnableTree = exports.queryOrgEnableTree = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.core.CORE_ORG_ENABLE_TREE));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryOrgEnableTree() {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryMoveOrg = exports.queryMoveOrg = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.post(_req.core.CORE_ORG_MOVE, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryMoveOrg(_x8) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryAddOrg = exports.queryAddOrg = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.post(_req.core.CORE_ORG_ADD, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryAddOrg(_x9) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var queryUpdateOrg = exports.queryUpdateOrg = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.post(_req.core.CORE_ORG_UPDATE, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryUpdateOrg(_x10) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var queryDeleteOrg = exports.queryDeleteOrg = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.get(_req.core.CORE_ORG_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryDeleteOrg(_x11) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var queryDisableOrg = exports.queryDisableOrg = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.core.CORE_ORG_DISABLE, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryDisableOrg(_x12) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var queryEnableOrg = exports.queryEnableOrg = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt('return', _http2.default.get(_req.core.CORE_ORG_ENABLE, params));
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function queryEnableOrg(_x13) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var queryConfigOrg = exports.queryConfigOrg = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(params) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            return _context16.abrupt('return', _http2.default.post(_req.common.CORE_ORG_CONFIG, params));
	
	          case 1:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function queryConfigOrg(_x14) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var queryConfigOrgOp = exports.queryConfigOrgOp = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17() {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            return _context17.abrupt('return', _http2.default.get(_req.common.CORE_ORG_CONFIG_OPTIONS));
	
	          case 1:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, this);
	  }));
	
	  return function queryConfigOrgOp() {
	    return _ref17.apply(this, arguments);
	  };
	}();
	
	var queryConfigOrgInfo = exports.queryConfigOrgInfo = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(params) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            return _context18.abrupt('return', _http2.default.get(_req.common.PUP_ORG_CONFIG_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, this);
	  }));
	
	  return function queryConfigOrgInfo(_x15) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryAccountRoleRoles = exports.queryAccountOrgOrgs = exports.querySaveAccountOrg = exports.querySaveAccountRole = exports.querySaveAccount = exports.queryAdminAccountInfo = exports.queryAdminAccountList = exports.queryCoreAccountSearch = exports.queryUpdatePwd = exports.queryAccountInfo = exports.queryRoleList = exports.queryUserOrgTreeList = exports.queryAccountList = exports.queryOrgUserList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 用户列表
	 */
	var queryOrgUserList = exports.queryOrgUserList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.core.ALL_USER_ORG_TREE, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryOrgUserList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 用户列表
	 */
	
	
	var queryAccountList = exports.queryAccountList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.core.ACCOUNT_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryAccountList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	/**
	 * 所有组织列表
	 */
	
	
	var queryUserOrgTreeList = exports.queryUserOrgTreeList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.core.USER_ORG_TREE, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryUserOrgTreeList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	/**
	 * 角色列表
	 */
	
	
	var queryRoleList = exports.queryRoleList = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4() {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.core.ROLE_LIST));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryRoleList() {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取用户登录信息
	 */
	
	
	var queryAccountInfo = exports.queryAccountInfo = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5() {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.core.ACCOUNT_INFO));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryAccountInfo() {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryUpdatePwd = exports.queryUpdatePwd = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.post(_req.core.CORE_ACCOUNT_UPDATE_PWD, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryUpdatePwd(_x4) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	/**
	 * 用户列表
	 */
	
	
	var queryCoreAccountSearch = exports.queryCoreAccountSearch = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.core.CORE_ACCOUNT_SEARCH));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryCoreAccountSearch() {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var queryAdminAccountList = exports.queryAdminAccountList = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.core.GET_ADMIN_ACCOUNT_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryAdminAccountList(_x5) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryAdminAccountInfo = exports.queryAdminAccountInfo = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.core.GET_ADMIN_ACCOUNT_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryAdminAccountInfo(_x6) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var querySaveAccount = exports.querySaveAccount = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.post(_req.core.SAVE_ACCOUNT, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function querySaveAccount(_x7) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var querySaveAccountRole = exports.querySaveAccountRole = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.post(_req.core.SAVE_BY_ACCOUNT_ACCOUNT_ROLE, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function querySaveAccountRole(_x8) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var querySaveAccountOrg = exports.querySaveAccountOrg = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.post(_req.core.SAVE_BY_ACCOUNT_ACCOUNT_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function querySaveAccountOrg(_x9) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var queryAccountOrgOrgs = exports.queryAccountOrgOrgs = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.get(_req.core.GET_ACCOUNT_ORG_ORGS, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryAccountOrgOrgs(_x10) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var queryAccountRoleRoles = exports.queryAccountRoleRoles = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.core.GET_ACCOUNT_ROLE_ROLES, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryAccountRoleRoles(_x11) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 55 */
/***/ function(module, exports) {

	/* global Float32Array */
	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * 创建一个向量
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @return {Vector2}
	 */
	
	function create(x, y) {
	  var out = new ArrayCtor(2);
	
	  if (x == null) {
	    x = 0;
	  }
	
	  if (y == null) {
	    y = 0;
	  }
	
	  out[0] = x;
	  out[1] = y;
	  return out;
	}
	/**
	 * 复制向量数据
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function copy(out, v) {
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 克隆一个向量
	 * @param {Vector2} v
	 * @return {Vector2}
	 */
	
	
	function clone(v) {
	  var out = new ArrayCtor(2);
	  out[0] = v[0];
	  out[1] = v[1];
	  return out;
	}
	/**
	 * 设置向量的两个项
	 * @param {Vector2} out
	 * @param {number} a
	 * @param {number} b
	 * @return {Vector2} 结果
	 */
	
	
	function set(out, a, b) {
	  out[0] = a;
	  out[1] = b;
	  return out;
	}
	/**
	 * 向量相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function add(out, v1, v2) {
	  out[0] = v1[0] + v2[0];
	  out[1] = v1[1] + v2[1];
	  return out;
	}
	/**
	 * 向量缩放后相加
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} a
	 */
	
	
	function scaleAndAdd(out, v1, v2, a) {
	  out[0] = v1[0] + v2[0] * a;
	  out[1] = v1[1] + v2[1] * a;
	  return out;
	}
	/**
	 * 向量相减
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function sub(out, v1, v2) {
	  out[0] = v1[0] - v2[0];
	  out[1] = v1[1] - v2[1];
	  return out;
	}
	/**
	 * 向量长度
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	
	function len(v) {
	  return Math.sqrt(lenSquare(v));
	}
	
	var length = len; // jshint ignore:line
	
	/**
	 * 向量长度平方
	 * @param {Vector2} v
	 * @return {number}
	 */
	
	function lenSquare(v) {
	  return v[0] * v[0] + v[1] * v[1];
	}
	
	var lengthSquare = lenSquare;
	/**
	 * 向量乘法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	function mul(out, v1, v2) {
	  out[0] = v1[0] * v2[0];
	  out[1] = v1[1] * v2[1];
	  return out;
	}
	/**
	 * 向量除法
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 */
	
	
	function div(out, v1, v2) {
	  out[0] = v1[0] / v2[0];
	  out[1] = v1[1] / v2[1];
	  return out;
	}
	/**
	 * 向量点乘
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function dot(v1, v2) {
	  return v1[0] * v2[0] + v1[1] * v2[1];
	}
	/**
	 * 向量缩放
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {number} s
	 */
	
	
	function scale(out, v, s) {
	  out[0] = v[0] * s;
	  out[1] = v[1] * s;
	  return out;
	}
	/**
	 * 向量归一化
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	
	function normalize(out, v) {
	  var d = len(v);
	
	  if (d === 0) {
	    out[0] = 0;
	    out[1] = 0;
	  } else {
	    out[0] = v[0] / d;
	    out[1] = v[1] / d;
	  }
	
	  return out;
	}
	/**
	 * 计算向量间距离
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	
	function distance(v1, v2) {
	  return Math.sqrt((v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]));
	}
	
	var dist = distance;
	/**
	 * 向量距离平方
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @return {number}
	 */
	
	function distanceSquare(v1, v2) {
	  return (v1[0] - v2[0]) * (v1[0] - v2[0]) + (v1[1] - v2[1]) * (v1[1] - v2[1]);
	}
	
	var distSquare = distanceSquare;
	/**
	 * 求负向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 */
	
	function negate(out, v) {
	  out[0] = -v[0];
	  out[1] = -v[1];
	  return out;
	}
	/**
	 * 插值两个点
	 * @param {Vector2} out
	 * @param {Vector2} v1
	 * @param {Vector2} v2
	 * @param {number} t
	 */
	
	
	function lerp(out, v1, v2, t) {
	  out[0] = v1[0] + t * (v2[0] - v1[0]);
	  out[1] = v1[1] + t * (v2[1] - v1[1]);
	  return out;
	}
	/**
	 * 矩阵左乘向量
	 * @param {Vector2} out
	 * @param {Vector2} v
	 * @param {Vector2} m
	 */
	
	
	function applyTransform(out, v, m) {
	  var x = v[0];
	  var y = v[1];
	  out[0] = m[0] * x + m[2] * y + m[4];
	  out[1] = m[1] * x + m[3] * y + m[5];
	  return out;
	}
	/**
	 * 求两个向量最小值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function min(out, v1, v2) {
	  out[0] = Math.min(v1[0], v2[0]);
	  out[1] = Math.min(v1[1], v2[1]);
	  return out;
	}
	/**
	 * 求两个向量最大值
	 * @param  {Vector2} out
	 * @param  {Vector2} v1
	 * @param  {Vector2} v2
	 */
	
	
	function max(out, v1, v2) {
	  out[0] = Math.max(v1[0], v2[0]);
	  out[1] = Math.max(v1[1], v2[1]);
	  return out;
	}
	
	exports.create = create;
	exports.copy = copy;
	exports.clone = clone;
	exports.set = set;
	exports.add = add;
	exports.scaleAndAdd = scaleAndAdd;
	exports.sub = sub;
	exports.len = len;
	exports.length = length;
	exports.lenSquare = lenSquare;
	exports.lengthSquare = lengthSquare;
	exports.mul = mul;
	exports.div = div;
	exports.dot = dot;
	exports.scale = scale;
	exports.normalize = normalize;
	exports.distance = distance;
	exports.dist = dist;
	exports.distanceSquare = distanceSquare;
	exports.distSquare = distSquare;
	exports.negate = negate;
	exports.lerp = lerp;
	exports.applyTransform = applyTransform;
	exports.min = min;
	exports.max = max;

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.wrapFile = wrapFile;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _req = __webpack_require__(32);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * 文件上传
	 */
	var UploadFile = function (_Component) {
	  _inherits(UploadFile, _Component);
	
	  function UploadFile(props) {
	    _classCallCheck(this, UploadFile);
	
	    var _this = _possibleConstructorReturn(this, (UploadFile.__proto__ || Object.getPrototypeOf(UploadFile)).call(this, props));
	
	    _this.wrapFile = function (fileArr) {
	      var files = [];
	      if (fileArr && fileArr.length > 0) {
	        files = fileArr.map(function (file, index) {
	          return {
	            uid: file.uuid || index,
	            uuid: file.uuid || index,
	            name: file.name,
	            url: file.url,
	            status: 'done'
	          };
	        });
	      }
	      return files;
	    };
	
	    _this.handleBefore = function (info) {
	      var excelContentTypeArr = ['application/vnd.ms-excel', // .xls,.xlt,.xla
	      'application/wps-office.xls', // .xls(WPS)
	      'application/wps-office.xlsx', // .xlsx(WPS)
	      'application/vnd.ms-excel.addin.macroEnabled.12', // .xlam
	      'application/vnd.ms-excel.sheet.macroEnabled.12', // .xlsm
	      'application/vnd.ms-excel.template.macroEnabled.12', // .xltm
	      'application/vnd.ms-excel.sheet.binary.macroEnabled.12', // .xlsb
	      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
	      'application/vnd.openxmlformats-officedocument.spreadsheetml.template'];
	      var typeIndex = excelContentTypeArr.indexOf(info.type);
	      return new Promise(function (resolve, reject) {
	        if (typeIndex === -1) {
	          _antd.message.error('请上传excel格式的文件');
	          reject();
	        } else {
	          resolve();
	        }
	      });
	    };
	
	    _this.handleChange = function (info) {
	      if (info.error && info.error.status !== 200) {
	        return false;
	      }
	
	      var fileList = info.fileList;
	      // 1. Limit the number of uploaded files
	
	      var limit = _this.props.limit;
	
	      if (limit) {
	        fileList = fileList.reverse().slice(0, limit);
	      }
	
	      // 2. read from response and show file link
	      // 只拿最新的一个文件
	      fileList = fileList.map(function (file) {
	        if (file.response) {
	          // Component will show file.url as link
	          // file.response.data是一个数组
	          if (file.response.data && file.response.data.length > 0) {
	            file.url = file.response.data[0].url;
	            file.uuid = file.response.data[0].uuid;
	          } else {
	            _antd.message.error('上传失败，请重新上传');
	          }
	        }
	        return file;
	      });
	
	      // 3. filter successfully uploaded files according to response from server
	      fileList = fileList.filter(function (file) {
	        if (file.response) {
	          return file.response.statusCode === 200;
	        }
	        return true;
	      });
	
	      _this.setState({ fileList: fileList });
	      _this.props.onChange && _this.props.onChange(_this.formatFiles(fileList));
	      var handleUpload = _this.props.handleUpload;
	
	      if (typeof handleUpload === 'function') {
	        handleUpload(fileList);
	      }
	    };
	
	    _this.formatFiles = function (fileList) {
	      var files = [];
	      fileList.map(function (item, index) {
	        files[index] = {
	          uuid: item.uuid,
	          name: item.name,
	          url: item.url
	        };
	        return item;
	      });
	      return files;
	    };
	
	    _this.state = {
	      fileList: [],
	      style: {}
	    };
	    return _this;
	  }
	
	  _createClass(UploadFile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.value === 'reset') {
	        this.setState({ fileList: [] });
	        return;
	      }
	      if (this.props.value && this.props.value.length > 0 && this.state.fileList.length === 0) {
	        this.setState({ fileList: this.wrapFile(this.props.value) });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      if (props.value === 'reset') {
	        this.setState({ fileList: [] });
	        return;
	      }
	      var fileList = this.wrapFile(props.value);
	      var oldList = this.state.fileList;
	      if (oldList.length === 0 && fileList && fileList.length > 0) {
	        this.setState({ fileList: fileList });
	      }
	    }
	
	    /**
	     * 上传文件之前的钩子，参数为上传的文件，若返回 false 则停止上传。
	     * 支持返回一个 Promise 对象，Promise 对象 reject 时则停止上传，resolve 时开始上传。
	     * 注意：IE9 不支持该方法。
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          key = _props.key,
	          data = _props.data,
	          isExcel = _props.isExcel,
	          isPreview = _props.isPreview,
	          uploadType = _props.uploadType,
	          onRemove = _props.onRemove,
	          handleClick = _props.handleClick;
	
	      var action = uploadType ? _req.common.FILE_UPLOAD : _req.common.UPLOAD;
	      return _react2.default.createElement(
	        _antd.Upload,
	        {
	          key: key,
	          name: 'files',
	          data: data || {},
	          fileList: this.state.fileList,
	          beforeUpload: isExcel ? this.handleBefore : null,
	          action: '' + action,
	          headers: {
	            Authorization: '' + _localDb2.default.get('token')
	          },
	          onRemove: onRemove || null,
	          onChange: this.handleChange,
	          onPreview: isPreview ? function (file) {
	            return (0, _attachment.queryFilePreview)(file);
	          } : null
	        },
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            type: 'ghost',
	            onClick: handleClick // 同一个页面有多个upload,记录下标
	            , style: this.state.style,
	            disabled: this.props.disabled ? this.props.disabled : false
	          },
	          _react2.default.createElement(_antd.Icon, { type: 'upload' }),
	          ' \u70B9\u51FB\u4E0A\u4F20'
	        )
	      );
	    }
	  }]);
	
	  return UploadFile;
	}(_react.Component);
	
	exports.default = UploadFile;
	
	
	UploadFile.propTypes = {};
	
	/**
	 * 包装文件
	 * @param  {[type]} arr [description]
	 * @return {[type]}     [description]
	 */
	function wrapFile(fileArr) {
	  var files = [];
	  if (fileArr && fileArr.length > 0) {
	    files = fileArr.map(function (file, index) {
	      return {
	        uid: file.uuid || index,
	        name: file.name,
	        url: file.url,
	        status: 'done'
	      };
	    });
	  }
	  return files;
	}

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(739);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 58 */
[3047, 279, 206, 42],
/* 59 */
36,
/* 60 */
/***/ function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(55);
	
	var matrix = __webpack_require__(86);
	
	/**
	 * @module echarts/core/BoundingRect
	 */
	var v2ApplyTransform = vec2.applyTransform;
	var mathMin = Math.min;
	var mathMax = Math.max;
	/**
	 * @alias module:echarts/core/BoundingRect
	 */
	
	function BoundingRect(x, y, width, height) {
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	  /**
	   * @type {number}
	   */
	
	
	  this.x = x;
	  /**
	   * @type {number}
	   */
	
	  this.y = y;
	  /**
	   * @type {number}
	   */
	
	  this.width = width;
	  /**
	   * @type {number}
	   */
	
	  this.height = height;
	}
	
	BoundingRect.prototype = {
	  constructor: BoundingRect,
	
	  /**
	   * @param {module:echarts/core/BoundingRect} other
	   */
	  union: function (other) {
	    var x = mathMin(other.x, this.x);
	    var y = mathMin(other.y, this.y);
	    this.width = mathMax(other.x + other.width, this.x + this.width) - x;
	    this.height = mathMax(other.y + other.height, this.y + this.height) - y;
	    this.x = x;
	    this.y = y;
	  },
	
	  /**
	   * @param {Array.<number>} m
	   * @methods
	   */
	  applyTransform: function () {
	    var lt = [];
	    var rb = [];
	    var lb = [];
	    var rt = [];
	    return function (m) {
	      // In case usage like this
	      // el.getBoundingRect().applyTransform(el.transform)
	      // And element has no transform
	      if (!m) {
	        return;
	      }
	
	      lt[0] = lb[0] = this.x;
	      lt[1] = rt[1] = this.y;
	      rb[0] = rt[0] = this.x + this.width;
	      rb[1] = lb[1] = this.y + this.height;
	      v2ApplyTransform(lt, lt, m);
	      v2ApplyTransform(rb, rb, m);
	      v2ApplyTransform(lb, lb, m);
	      v2ApplyTransform(rt, rt, m);
	      this.x = mathMin(lt[0], rb[0], lb[0], rt[0]);
	      this.y = mathMin(lt[1], rb[1], lb[1], rt[1]);
	      var maxX = mathMax(lt[0], rb[0], lb[0], rt[0]);
	      var maxY = mathMax(lt[1], rb[1], lb[1], rt[1]);
	      this.width = maxX - this.x;
	      this.height = maxY - this.y;
	    };
	  }(),
	
	  /**
	   * Calculate matrix of transforming from self to target rect
	   * @param  {module:zrender/core/BoundingRect} b
	   * @return {Array.<number>}
	   */
	  calculateTransform: function (b) {
	    var a = this;
	    var sx = b.width / a.width;
	    var sy = b.height / a.height;
	    var m = matrix.create(); // 矩阵右乘
	
	    matrix.translate(m, m, [-a.x, -a.y]);
	    matrix.scale(m, m, [sx, sy]);
	    matrix.translate(m, m, [b.x, b.y]);
	    return m;
	  },
	
	  /**
	   * @param {(module:echarts/core/BoundingRect|Object)} b
	   * @return {boolean}
	   */
	  intersect: function (b) {
	    if (!b) {
	      return false;
	    }
	
	    if (!(b instanceof BoundingRect)) {
	      // Normalize negative width/height.
	      b = BoundingRect.create(b);
	    }
	
	    var a = this;
	    var ax0 = a.x;
	    var ax1 = a.x + a.width;
	    var ay0 = a.y;
	    var ay1 = a.y + a.height;
	    var bx0 = b.x;
	    var bx1 = b.x + b.width;
	    var by0 = b.y;
	    var by1 = b.y + b.height;
	    return !(ax1 < bx0 || bx1 < ax0 || ay1 < by0 || by1 < ay0);
	  },
	  contain: function (x, y) {
	    var rect = this;
	    return x >= rect.x && x <= rect.x + rect.width && y >= rect.y && y <= rect.y + rect.height;
	  },
	
	  /**
	   * @return {module:echarts/core/BoundingRect}
	   */
	  clone: function () {
	    return new BoundingRect(this.x, this.y, this.width, this.height);
	  },
	
	  /**
	   * Copy from another rect
	   */
	  copy: function (other) {
	    this.x = other.x;
	    this.y = other.y;
	    this.width = other.width;
	    this.height = other.height;
	  },
	  plain: function () {
	    return {
	      x: this.x,
	      y: this.y,
	      width: this.width,
	      height: this.height
	    };
	  }
	};
	/**
	 * @param {Object|module:zrender/core/BoundingRect} rect
	 * @param {number} rect.x
	 * @param {number} rect.y
	 * @param {number} rect.width
	 * @param {number} rect.height
	 * @return {module:zrender/core/BoundingRect}
	 */
	
	BoundingRect.create = function (rect) {
	  return new BoundingRect(rect.x, rect.y, rect.width, rect.height);
	};
	
	var _default = BoundingRect;
	module.exports = _default;

/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryFinanceStatisticsPrecipitation = exports.queryFinanceStatisticsBalance = exports.queryFinanceStatisticsBusinessIncomeDetail = exports.queryFinanceStatisticsBusinessIncome = exports.queryAbleBookInfo = exports.queryDeleteBookInfo = exports.querySaveBookInfo = exports.queryBookInfoInfo = exports.queryBookInfoList = exports.queryIncomeDetail = exports.queryBudgetExpend = exports.queryFinanceBooksOrgList = exports.queryFinanceBooksOrg = exports.queryFinanceBooksPayStatistics = exports.queryFinanceOperationalStatisticsDetail = exports.queryFinanceOperationalStatistics = exports.queryFinanceIncomeStatistics = exports.queryNonBusinessIncomeList = exports.queryDeleteBooksIncomes = exports.queryDeleteBooksIncome = exports.queryImportBooksIncome = exports.querySaveBooksIncome = exports.queryBooksIncomeInfo = exports.queryBooksIncomeRemoveList = exports.queryBooksIncomeList = exports.queryFinanceBooksStatistics = exports.queryFinanceBooksListStatistics = exports.queryCheckBooksErr = exports.queryDeleteFinanceBooks = exports.queryEditFinanceBooks = exports.querySaveFinanceBooks = exports.queryFinanceBooksInfo = exports.queryFinanceBooksList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/* -------------------------------------资金账号管理------------------------------------*/
	/**
	 * 获取账号列表
	 */
	var queryFinanceBooksList = exports.queryFinanceBooksList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.finance.FINANCE_BOOKS_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryFinanceBooksList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取账号明细
	 */
	
	
	var queryFinanceBooksInfo = exports.queryFinanceBooksInfo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(uuid) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.finance.FINANCE_BOOKS_INFO, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryFinanceBooksInfo(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	/**
	 * 添加账号
	 */
	
	
	var querySaveFinanceBooks = exports.querySaveFinanceBooks = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.post(_req.finance.FINANCE_BOOKS_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function querySaveFinanceBooks(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	/**
	 * 编辑账号
	 */
	
	
	var queryEditFinanceBooks = exports.queryEditFinanceBooks = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.post(_req.finance.FINANCE_BOOKS_EDIT, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryEditFinanceBooks(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	/**
	 * 删除账号
	 */
	
	
	var queryDeleteFinanceBooks = exports.queryDeleteFinanceBooks = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(uuid) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.finance.FINANCE_BOOKS_DELETE, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryDeleteFinanceBooks(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryCheckBooksErr = exports.queryCheckBooksErr = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6() {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.finance.FINANCE_BOOKS_CHECK_ERR, {}));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryCheckBooksErr() {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	/**
	 * 账号统计
	 */
	
	
	var queryFinanceBooksListStatistics = exports.queryFinanceBooksListStatistics = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.finance.FINANCE_BOOKS_List_STATISTICS, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryFinanceBooksListStatistics(_x6) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	/**
	 * 账号统计
	 */
	
	
	var queryFinanceBooksStatistics = exports.queryFinanceBooksStatistics = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.finance.FINANCE_BOOKS_STATISTICS, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryFinanceBooksStatistics(_x7) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	/* -------------------------------------资金流水记录管理------------------------------------*/
	
	// 流水记录列表
	
	
	var queryBooksIncomeList = exports.queryBooksIncomeList = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.finance.BOOKS_INCOME_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryBooksIncomeList(_x8) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	// 流水已删除记录列表
	
	
	var queryBooksIncomeRemoveList = exports.queryBooksIncomeRemoveList = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.finance.BOOKS_INCOME_REMOVE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryBooksIncomeRemoveList(_x9) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	// 流水详情
	
	
	var queryBooksIncomeInfo = exports.queryBooksIncomeInfo = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(uuid) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.get(_req.finance.BOOKS_INCOME_INFO, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryBooksIncomeInfo(_x10) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	// 流水记录保存
	
	
	var querySaveBooksIncome = exports.querySaveBooksIncome = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.post(_req.finance.BOOKS_INCOME_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function querySaveBooksIncome(_x11) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	// 流水记录导入
	
	
	var queryImportBooksIncome = exports.queryImportBooksIncome = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.post(_req.finance.BOOKS_INCOME_IMPORT, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryImportBooksIncome(_x12) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	// 流水记录删除
	
	
	var queryDeleteBooksIncome = exports.queryDeleteBooksIncome = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.finance.BOOKS_INCOME_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryDeleteBooksIncome(_x13) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	// 流水记录删除（多条）
	
	
	var queryDeleteBooksIncomes = exports.queryDeleteBooksIncomes = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt('return', _http2.default.get(_req.finance.BOOKS_INCOME_DELETES, params));
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function queryDeleteBooksIncomes(_x14) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	/**
	 * 非业务数据
	 * @param {} params
	 * @returns {}
	 */
	
	
	var queryNonBusinessIncomeList = exports.queryNonBusinessIncomeList = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(params) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            return _context16.abrupt('return', _http2.default.get(_req.finance.BOOKS_INCOME_NON_BUSINESS, params));
	
	          case 1:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function queryNonBusinessIncomeList(_x15) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	/**
	 * 资金统计
	 */
	
	
	var queryFinanceIncomeStatistics = exports.queryFinanceIncomeStatistics = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(params) {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            return _context17.abrupt('return', _http2.default.get(_req.finance.FINANCE_INCOME_STATISTICS, params));
	
	          case 1:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, this);
	  }));
	
	  return function queryFinanceIncomeStatistics(_x16) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	
	/**
	 * 资金运营统计
	 */
	
	
	var queryFinanceOperationalStatistics = exports.queryFinanceOperationalStatistics = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(params) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            return _context18.abrupt('return', _http2.default.get(_req.finance.FINANCE_OPERATIONAL_STATISTICS, params));
	
	          case 1:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, this);
	  }));
	
	  return function queryFinanceOperationalStatistics(_x17) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	
	/**
	 * 资金运营统计每年统计
	 */
	
	
	var queryFinanceOperationalStatisticsDetail = exports.queryFinanceOperationalStatisticsDetail = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(params) {
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            return _context19.abrupt('return', _http2.default.get(_req.finance.FINANCE_OPERATIONAL_STATISTICS_DETAIL, params));
	
	          case 1:
	          case 'end':
	            return _context19.stop();
	        }
	      }
	    }, _callee19, this);
	  }));
	
	  return function queryFinanceOperationalStatisticsDetail(_x18) {
	    return _ref19.apply(this, arguments);
	  };
	}();
	
	/**
	 * 走账数据统计
	 * @param {} params
	 * @returns {}
	 */
	
	
	var queryFinanceBooksPayStatistics = exports.queryFinanceBooksPayStatistics = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(params) {
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            return _context20.abrupt('return', _http2.default.get(_req.finance.FINANCE_INCOME_PAY_STATISTICS, params));
	
	          case 1:
	          case 'end':
	            return _context20.stop();
	        }
	      }
	    }, _callee20, this);
	  }));
	
	  return function queryFinanceBooksPayStatistics(_x19) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	/**
	 * 有账号的公司列表
	 */
	
	
	var queryFinanceBooksOrg = exports.queryFinanceBooksOrg = function () {
	  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(params) {
	    return _regenerator2.default.wrap(function _callee21$(_context21) {
	      while (1) {
	        switch (_context21.prev = _context21.next) {
	          case 0:
	            return _context21.abrupt('return', _http2.default.get(_req.finance.FINANCE_BOOKS_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context21.stop();
	        }
	      }
	    }, _callee21, this);
	  }));
	
	  return function queryFinanceBooksOrg(_x20) {
	    return _ref21.apply(this, arguments);
	  };
	}();
	
	/**
	 * 有账号的公司列表(通过预算组选择)
	 */
	
	
	var queryFinanceBooksOrgList = exports.queryFinanceBooksOrgList = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(params) {
	    return _regenerator2.default.wrap(function _callee22$(_context22) {
	      while (1) {
	        switch (_context22.prev = _context22.next) {
	          case 0:
	            return _context22.abrupt('return', _http2.default.get(_req.finance.FINANCE_BOOKS_ORG_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context22.stop();
	        }
	      }
	    }, _callee22, this);
	  }));
	
	  return function queryFinanceBooksOrgList(_x21) {
	    return _ref22.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取预算类目列表
	 */
	
	
	var queryBudgetExpend = exports.queryBudgetExpend = function () {
	  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(params) {
	    return _regenerator2.default.wrap(function _callee23$(_context23) {
	      while (1) {
	        switch (_context23.prev = _context23.next) {
	          case 0:
	            return _context23.abrupt('return', _http2.default.get(_req.finance.FINANCE_BUDGET_EXPEND, params));
	
	          case 1:
	          case 'end':
	            return _context23.stop();
	        }
	      }
	    }, _callee23, this);
	  }));
	
	  return function queryBudgetExpend(_x22) {
	    return _ref23.apply(this, arguments);
	  };
	}();
	
	/**
	 *
	 */
	
	
	var queryIncomeDetail = exports.queryIncomeDetail = function () {
	  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(params) {
	    return _regenerator2.default.wrap(function _callee24$(_context24) {
	      while (1) {
	        switch (_context24.prev = _context24.next) {
	          case 0:
	            return _context24.abrupt('return', _http2.default.get(_req.finance.FINANCE_INCOME_DETAIL, params));
	
	          case 1:
	          case 'end':
	            return _context24.stop();
	        }
	      }
	    }, _callee24, this);
	  }));
	
	  return function queryIncomeDetail(_x23) {
	    return _ref24.apply(this, arguments);
	  };
	}();
	
	var queryBookInfoList = exports.queryBookInfoList = function () {
	  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(params) {
	    return _regenerator2.default.wrap(function _callee25$(_context25) {
	      while (1) {
	        switch (_context25.prev = _context25.next) {
	          case 0:
	            return _context25.abrupt('return', _http2.default.get(_req.finance.GET_BOOKINFO_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context25.stop();
	        }
	      }
	    }, _callee25, this);
	  }));
	
	  return function queryBookInfoList(_x24) {
	    return _ref25.apply(this, arguments);
	  };
	}();
	
	var queryBookInfoInfo = exports.queryBookInfoInfo = function () {
	  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(params) {
	    return _regenerator2.default.wrap(function _callee26$(_context26) {
	      while (1) {
	        switch (_context26.prev = _context26.next) {
	          case 0:
	            return _context26.abrupt('return', _http2.default.get(_req.finance.GET_BOOKINFO_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context26.stop();
	        }
	      }
	    }, _callee26, this);
	  }));
	
	  return function queryBookInfoInfo(_x25) {
	    return _ref26.apply(this, arguments);
	  };
	}();
	
	var querySaveBookInfo = exports.querySaveBookInfo = function () {
	  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(params) {
	    return _regenerator2.default.wrap(function _callee27$(_context27) {
	      while (1) {
	        switch (_context27.prev = _context27.next) {
	          case 0:
	            return _context27.abrupt('return', _http2.default.post(_req.finance.SAVE_BOOKINFO, params));
	
	          case 1:
	          case 'end':
	            return _context27.stop();
	        }
	      }
	    }, _callee27, this);
	  }));
	
	  return function querySaveBookInfo(_x26) {
	    return _ref27.apply(this, arguments);
	  };
	}();
	
	var queryDeleteBookInfo = exports.queryDeleteBookInfo = function () {
	  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(params) {
	    return _regenerator2.default.wrap(function _callee28$(_context28) {
	      while (1) {
	        switch (_context28.prev = _context28.next) {
	          case 0:
	            return _context28.abrupt('return', _http2.default.get(_req.finance.DELETE_BOOKINFO, params));
	
	          case 1:
	          case 'end':
	            return _context28.stop();
	        }
	      }
	    }, _callee28, this);
	  }));
	
	  return function queryDeleteBookInfo(_x27) {
	    return _ref28.apply(this, arguments);
	  };
	}();
	
	var queryAbleBookInfo = exports.queryAbleBookInfo = function () {
	  var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(params) {
	    return _regenerator2.default.wrap(function _callee29$(_context29) {
	      while (1) {
	        switch (_context29.prev = _context29.next) {
	          case 0:
	            return _context29.abrupt('return', _http2.default.post(_req.finance.ABLE_BOOKINFO, params));
	
	          case 1:
	          case 'end':
	            return _context29.stop();
	        }
	      }
	    }, _callee29, this);
	  }));
	
	  return function queryAbleBookInfo(_x28) {
	    return _ref29.apply(this, arguments);
	  };
	}();
	
	/**
	 * 业务收入
	 */
	
	
	var queryFinanceStatisticsBusinessIncome = exports.queryFinanceStatisticsBusinessIncome = function () {
	  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(params) {
	    return _regenerator2.default.wrap(function _callee30$(_context30) {
	      while (1) {
	        switch (_context30.prev = _context30.next) {
	          case 0:
	            return _context30.abrupt('return', _http2.default.get(_req.finance.FINANCE_STATISTICS_BUSINESS_INCOME, params));
	
	          case 1:
	          case 'end':
	            return _context30.stop();
	        }
	      }
	    }, _callee30, this);
	  }));
	
	  return function queryFinanceStatisticsBusinessIncome(_x29) {
	    return _ref30.apply(this, arguments);
	  };
	}();
	
	/**
	 * 业务收入明细
	 * @param {} params
	 * @returns {}
	 */
	
	
	var queryFinanceStatisticsBusinessIncomeDetail = exports.queryFinanceStatisticsBusinessIncomeDetail = function () {
	  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(params) {
	    return _regenerator2.default.wrap(function _callee31$(_context31) {
	      while (1) {
	        switch (_context31.prev = _context31.next) {
	          case 0:
	            return _context31.abrupt('return', _http2.default.get(_req.finance.FINANCE_STATISTICS_BUSINESS_INCOME_DETAIL, params));
	
	          case 1:
	          case 'end':
	            return _context31.stop();
	        }
	      }
	    }, _callee31, this);
	  }));
	
	  return function queryFinanceStatisticsBusinessIncomeDetail(_x30) {
	    return _ref31.apply(this, arguments);
	  };
	}();
	
	/**
	 * 银行余额统计
	 */
	
	
	var queryFinanceStatisticsBalance = exports.queryFinanceStatisticsBalance = function () {
	  var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(params) {
	    return _regenerator2.default.wrap(function _callee32$(_context32) {
	      while (1) {
	        switch (_context32.prev = _context32.next) {
	          case 0:
	            return _context32.abrupt('return', _http2.default.get(_req.finance.FINANCE_STATISTICS_BALANCE, params));
	
	          case 1:
	          case 'end':
	            return _context32.stop();
	        }
	      }
	    }, _callee32, this);
	  }));
	
	  return function queryFinanceStatisticsBalance(_x31) {
	    return _ref32.apply(this, arguments);
	  };
	}();
	
	/**
	 * 客户沉淀资金
	 */
	
	
	var queryFinanceStatisticsPrecipitation = exports.queryFinanceStatisticsPrecipitation = function () {
	  var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(params) {
	    return _regenerator2.default.wrap(function _callee33$(_context33) {
	      while (1) {
	        switch (_context33.prev = _context33.next) {
	          case 0:
	            return _context33.abrupt('return', _http2.default.get(_req.finance.FINANCE_STATISTICS_PRECIPITATION, params));
	
	          case 1:
	          case 'end':
	            return _context33.stop();
	        }
	      }
	    }, _callee33, this);
	  }));
	
	  return function queryFinanceStatisticsPrecipitation(_x32) {
	    return _ref33.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* 财务模块api */

/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _DescriptionList = __webpack_require__(1498);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _Description = __webpack_require__(1497);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_DescriptionList2.default.Description = _Description2.default;
	exports.default = _DescriptionList2.default;

/***/ },
/* 63 */
[3042, 120],
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryBudgetType = exports.queryDictIncome = exports.queryDictExpend = exports.querySaveDict = exports.queryDeleteDict = exports.queryDictInfo = exports.queryDictListTree = exports.queryGlobalConfig = exports.queryIchapterappType = exports.queryInvoiceType = exports.queryInvoiceContent = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var queryInvoiceContent = exports.queryInvoiceContent = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.core.DICT_INVOICE_CONTENT, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryInvoiceContent(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryInvoiceType = exports.queryInvoiceType = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.core.DICT_INVOICE_TYPE, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryInvoiceType(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryIchapterappType = exports.queryIchapterappType = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.core.DICT_ICHAPTERAPP_TYPE, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryIchapterappType(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryGlobalConfig = exports.queryGlobalConfig = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.core.DICT_GLOBAL_CONFIG, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryGlobalConfig(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryDictListTree = exports.queryDictListTree = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.core.GET_DICT_LIST_TREE, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryDictListTree(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryDictInfo = exports.queryDictInfo = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.core.GET_DICT_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryDictInfo(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryDeleteDict = exports.queryDeleteDict = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.core.DELETE_DICT, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryDeleteDict(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var querySaveDict = exports.querySaveDict = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.post(_req.core.SAVE_DICT, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function querySaveDict(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取支出列表
	 */
	
	
	var queryDictExpend = exports.queryDictExpend = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9() {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.core.FINANCE_DICT_EXPEND));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryDictExpend() {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取收入列表
	 */
	
	
	var queryDictIncome = exports.queryDictIncome = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10() {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.core.FINANCE_DICT_INCOME));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryDictIncome() {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取预算收入列表
	 */
	
	
	var queryBudgetType = exports.queryBudgetType = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11() {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.get(_req.core.DICT_BUDGET_TYPE));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryBudgetType() {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 65 */
[3009, 43],
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryTagRelateDel = exports.queryTagDel = exports.queryTagList = exports.queryTaskCheckWorkflow = exports.queryCallbackTaskCheck = exports.queryReturnTaskCheck = exports.queryNextTaskCheck = exports.queryTaskDiscard = exports.queryTaskCompletion = exports.queryTaskLog = exports.queryTaskFiles = exports.queryTaskInfo = exports.querySetTaskUnCollect = exports.querySetTaskCollect = exports.queryDeleteTask = exports.querySaveTask = exports.queryTaskCheckMy = exports.queryTaskCheckList = exports.queryTaskSearchList = exports.queryTaskReceiveList = exports.queryTaskLauList = exports.queryTaskSearch = exports.queryTaskList = exports.queryDeleteProjDir = exports.querySaveProjDir = exports.queryProjDirInfo = exports.queryProjDirList = exports.queryProjStatRate = exports.queryDeleteProjFiles = exports.querySaveProjFiles = exports.queryProjFilesList = exports.queryProjTaskList = exports.queryProjUpdStatus = exports.queryProjInfo = exports.queryDeleteProj = exports.queryPostProjSave = exports.queryProjReceiveList = exports.queryProjLauList = exports.queryProjList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/** 项目管理 */
	// 项目列表
	var queryProjList = exports.queryProjList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.task.PROJ_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryProjList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	// 我发起的项目列表
	
	
	var queryProjLauList = exports.queryProjLauList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.task.PROJ_LAU_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryProjLauList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	// 我收到的项目列表
	
	
	var queryProjReceiveList = exports.queryProjReceiveList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.task.PROJ_RECEIVE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryProjReceiveList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	// 项目新增
	
	
	var queryPostProjSave = exports.queryPostProjSave = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.post(_req.task.PROJ_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryPostProjSave(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	// 项目删除
	
	
	var queryDeleteProj = exports.queryDeleteProj = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.task.PROJ_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryDeleteProj(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	// 项目详情
	
	
	var queryProjInfo = exports.queryProjInfo = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.task.PROJ_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryProjInfo(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	// 项目状态修改
	
	
	var queryProjUpdStatus = exports.queryProjUpdStatus = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.post(_req.task.PROJ_UPD_STATUS, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryProjUpdStatus(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	// 项目任务列表
	
	
	var queryProjTaskList = exports.queryProjTaskList = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.task.PROJ_TASK_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryProjTaskList(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	// 项目文件列表
	
	
	var queryProjFilesList = exports.queryProjFilesList = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.task.PROJ_FILES_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryProjFilesList(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	// 项目文件保存
	
	
	var querySaveProjFiles = exports.querySaveProjFiles = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.post(_req.task.PROJ_FILES_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function querySaveProjFiles(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	// 项目文件删除
	
	
	var queryDeleteProjFiles = exports.queryDeleteProjFiles = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.get(_req.task.PROJ_FILES_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryDeleteProjFiles(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	// 任务完成率统计
	
	
	var queryProjStatRate = exports.queryProjStatRate = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.get(_req.task.PROJ_STAT_RATE, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryProjStatRate(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	/** 项目目录管理 */
	// 项目目录列表
	
	
	var queryProjDirList = exports.queryProjDirList = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.get(_req.task.PROJ_DIR_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryProjDirList(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	// 项目目录详情
	
	
	var queryProjDirInfo = exports.queryProjDirInfo = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.task.PROJ_DIR_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryProjDirInfo(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	// 项目目录保存
	
	
	var querySaveProjDir = exports.querySaveProjDir = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt('return', _http2.default.post(_req.task.PROJ_DIR_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function querySaveProjDir(_x15) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	// 项目目录删除
	
	
	var queryDeleteProjDir = exports.queryDeleteProjDir = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(params) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            return _context16.abrupt('return', _http2.default.get(_req.task.PROJ_DIR_DEL, params));
	
	          case 1:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function queryDeleteProjDir(_x16) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	/** 任务管理 */
	// 任务监控
	
	
	var queryTaskList = exports.queryTaskList = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(params) {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            return _context17.abrupt('return', _http2.default.get(_req.task.TASK_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, this);
	  }));
	
	  return function queryTaskList(_x17) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	
	// 任务高级搜索
	
	
	var queryTaskSearch = exports.queryTaskSearch = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(params) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            return _context18.abrupt('return', _http2.default.get(_req.task.TASK_SEARCH, params));
	
	          case 1:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, this);
	  }));
	
	  return function queryTaskSearch(_x18) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	
	// 我发起的任务列表
	
	
	var queryTaskLauList = exports.queryTaskLauList = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(params) {
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            return _context19.abrupt('return', _http2.default.get(_req.task.TASK_LAU_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context19.stop();
	        }
	      }
	    }, _callee19, this);
	  }));
	
	  return function queryTaskLauList(_x19) {
	    return _ref19.apply(this, arguments);
	  };
	}();
	
	// 我收到的任务列表
	
	
	var queryTaskReceiveList = exports.queryTaskReceiveList = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(params) {
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            return _context20.abrupt('return', _http2.default.get(_req.task.TASK_RECEIVE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context20.stop();
	        }
	      }
	    }, _callee20, this);
	  }));
	
	  return function queryTaskReceiveList(_x20) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	// 我收到的任务列表高级搜索
	
	
	var queryTaskSearchList = exports.queryTaskSearchList = function () {
	  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(params) {
	    return _regenerator2.default.wrap(function _callee21$(_context21) {
	      while (1) {
	        switch (_context21.prev = _context21.next) {
	          case 0:
	            return _context21.abrupt('return', _http2.default.get(_req.task.TASK_SEARCH_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context21.stop();
	        }
	      }
	    }, _callee21, this);
	  }));
	
	  return function queryTaskSearchList(_x21) {
	    return _ref21.apply(this, arguments);
	  };
	}();
	
	// 待审核的任务列表监控
	
	
	var queryTaskCheckList = exports.queryTaskCheckList = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(params) {
	    return _regenerator2.default.wrap(function _callee22$(_context22) {
	      while (1) {
	        switch (_context22.prev = _context22.next) {
	          case 0:
	            return _context22.abrupt('return', _http2.default.get(_req.task.TASK_CHECK_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context22.stop();
	        }
	      }
	    }, _callee22, this);
	  }));
	
	  return function queryTaskCheckList(_x22) {
	    return _ref22.apply(this, arguments);
	  };
	}();
	
	// 我的待审核的任务列表
	
	
	var queryTaskCheckMy = exports.queryTaskCheckMy = function () {
	  var _ref23 = _asyncToGenerator(_regenerator2.default.mark(function _callee23(params) {
	    return _regenerator2.default.wrap(function _callee23$(_context23) {
	      while (1) {
	        switch (_context23.prev = _context23.next) {
	          case 0:
	            return _context23.abrupt('return', _http2.default.get(_req.task.TASK_CHECK_MY, params));
	
	          case 1:
	          case 'end':
	            return _context23.stop();
	        }
	      }
	    }, _callee23, this);
	  }));
	
	  return function queryTaskCheckMy(_x23) {
	    return _ref23.apply(this, arguments);
	  };
	}();
	
	// 任务新增
	
	
	var querySaveTask = exports.querySaveTask = function () {
	  var _ref24 = _asyncToGenerator(_regenerator2.default.mark(function _callee24(params) {
	    return _regenerator2.default.wrap(function _callee24$(_context24) {
	      while (1) {
	        switch (_context24.prev = _context24.next) {
	          case 0:
	            return _context24.abrupt('return', _http2.default.post(_req.task.TASK_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context24.stop();
	        }
	      }
	    }, _callee24, this);
	  }));
	
	  return function querySaveTask(_x24) {
	    return _ref24.apply(this, arguments);
	  };
	}();
	
	// 任务删除
	
	
	var queryDeleteTask = exports.queryDeleteTask = function () {
	  var _ref25 = _asyncToGenerator(_regenerator2.default.mark(function _callee25(params) {
	    return _regenerator2.default.wrap(function _callee25$(_context25) {
	      while (1) {
	        switch (_context25.prev = _context25.next) {
	          case 0:
	            return _context25.abrupt('return', _http2.default.get(_req.task.TASK_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context25.stop();
	        }
	      }
	    }, _callee25, this);
	  }));
	
	  return function queryDeleteTask(_x25) {
	    return _ref25.apply(this, arguments);
	  };
	}();
	
	// 任务收藏
	
	
	var querySetTaskCollect = exports.querySetTaskCollect = function () {
	  var _ref26 = _asyncToGenerator(_regenerator2.default.mark(function _callee26(params) {
	    return _regenerator2.default.wrap(function _callee26$(_context26) {
	      while (1) {
	        switch (_context26.prev = _context26.next) {
	          case 0:
	            return _context26.abrupt('return', _http2.default.get(_req.task.TASK_COLLECT, params));
	
	          case 1:
	          case 'end':
	            return _context26.stop();
	        }
	      }
	    }, _callee26, this);
	  }));
	
	  return function querySetTaskCollect(_x26) {
	    return _ref26.apply(this, arguments);
	  };
	}();
	
	// 任务取消收藏
	
	
	var querySetTaskUnCollect = exports.querySetTaskUnCollect = function () {
	  var _ref27 = _asyncToGenerator(_regenerator2.default.mark(function _callee27(params) {
	    return _regenerator2.default.wrap(function _callee27$(_context27) {
	      while (1) {
	        switch (_context27.prev = _context27.next) {
	          case 0:
	            return _context27.abrupt('return', _http2.default.get(_req.task.TASK_UNCOLLECT, params));
	
	          case 1:
	          case 'end':
	            return _context27.stop();
	        }
	      }
	    }, _callee27, this);
	  }));
	
	  return function querySetTaskUnCollect(_x27) {
	    return _ref27.apply(this, arguments);
	  };
	}();
	
	// 任务详情
	
	
	var queryTaskInfo = exports.queryTaskInfo = function () {
	  var _ref28 = _asyncToGenerator(_regenerator2.default.mark(function _callee28(params) {
	    return _regenerator2.default.wrap(function _callee28$(_context28) {
	      while (1) {
	        switch (_context28.prev = _context28.next) {
	          case 0:
	            return _context28.abrupt('return', _http2.default.get(_req.task.TASK_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context28.stop();
	        }
	      }
	    }, _callee28, this);
	  }));
	
	  return function queryTaskInfo(_x28) {
	    return _ref28.apply(this, arguments);
	  };
	}();
	
	// 任务附件
	
	
	var queryTaskFiles = exports.queryTaskFiles = function () {
	  var _ref29 = _asyncToGenerator(_regenerator2.default.mark(function _callee29(params) {
	    return _regenerator2.default.wrap(function _callee29$(_context29) {
	      while (1) {
	        switch (_context29.prev = _context29.next) {
	          case 0:
	            return _context29.abrupt('return', _http2.default.get(_req.task.TASK_FILES, params));
	
	          case 1:
	          case 'end':
	            return _context29.stop();
	        }
	      }
	    }, _callee29, this);
	  }));
	
	  return function queryTaskFiles(_x29) {
	    return _ref29.apply(this, arguments);
	  };
	}();
	
	// 任务日志
	
	
	var queryTaskLog = exports.queryTaskLog = function () {
	  var _ref30 = _asyncToGenerator(_regenerator2.default.mark(function _callee30(params) {
	    return _regenerator2.default.wrap(function _callee30$(_context30) {
	      while (1) {
	        switch (_context30.prev = _context30.next) {
	          case 0:
	            return _context30.abrupt('return', _http2.default.get(_req.task.TASK_LOG, params));
	
	          case 1:
	          case 'end':
	            return _context30.stop();
	        }
	      }
	    }, _callee30, this);
	  }));
	
	  return function queryTaskLog(_x30) {
	    return _ref30.apply(this, arguments);
	  };
	}();
	
	// 任务完成
	
	
	var queryTaskCompletion = exports.queryTaskCompletion = function () {
	  var _ref31 = _asyncToGenerator(_regenerator2.default.mark(function _callee31(params) {
	    return _regenerator2.default.wrap(function _callee31$(_context31) {
	      while (1) {
	        switch (_context31.prev = _context31.next) {
	          case 0:
	            return _context31.abrupt('return', _http2.default.post(_req.task.TASK_COMPLETION, params));
	
	          case 1:
	          case 'end':
	            return _context31.stop();
	        }
	      }
	    }, _callee31, this);
	  }));
	
	  return function queryTaskCompletion(_x31) {
	    return _ref31.apply(this, arguments);
	  };
	}();
	
	// 任务废弃
	
	
	var queryTaskDiscard = exports.queryTaskDiscard = function () {
	  var _ref32 = _asyncToGenerator(_regenerator2.default.mark(function _callee32(params) {
	    return _regenerator2.default.wrap(function _callee32$(_context32) {
	      while (1) {
	        switch (_context32.prev = _context32.next) {
	          case 0:
	            return _context32.abrupt('return', _http2.default.get(_req.task.TASK_DISCARD, params));
	
	          case 1:
	          case 'end':
	            return _context32.stop();
	        }
	      }
	    }, _callee32, this);
	  }));
	
	  return function queryTaskDiscard(_x32) {
	    return _ref32.apply(this, arguments);
	  };
	}();
	
	/** 任务审核流程 */
	
	
	var queryNextTaskCheck = exports.queryNextTaskCheck = function () {
	  var _ref33 = _asyncToGenerator(_regenerator2.default.mark(function _callee33(params) {
	    return _regenerator2.default.wrap(function _callee33$(_context33) {
	      while (1) {
	        switch (_context33.prev = _context33.next) {
	          case 0:
	            return _context33.abrupt('return', _http2.default.get(_req.task.TASKCHECK_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context33.stop();
	        }
	      }
	    }, _callee33, this);
	  }));
	
	  return function queryNextTaskCheck(_x33) {
	    return _ref33.apply(this, arguments);
	  };
	}();
	
	var queryReturnTaskCheck = exports.queryReturnTaskCheck = function () {
	  var _ref34 = _asyncToGenerator(_regenerator2.default.mark(function _callee34(params) {
	    return _regenerator2.default.wrap(function _callee34$(_context34) {
	      while (1) {
	        switch (_context34.prev = _context34.next) {
	          case 0:
	            return _context34.abrupt('return', _http2.default.post(_req.task.TASKCHECK_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context34.stop();
	        }
	      }
	    }, _callee34, this);
	  }));
	
	  return function queryReturnTaskCheck(_x34) {
	    return _ref34.apply(this, arguments);
	  };
	}();
	
	var queryCallbackTaskCheck = exports.queryCallbackTaskCheck = function () {
	  var _ref35 = _asyncToGenerator(_regenerator2.default.mark(function _callee35(params) {
	    return _regenerator2.default.wrap(function _callee35$(_context35) {
	      while (1) {
	        switch (_context35.prev = _context35.next) {
	          case 0:
	            return _context35.abrupt('return', _http2.default.get(_req.task.TASKCHECK_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context35.stop();
	        }
	      }
	    }, _callee35, this);
	  }));
	
	  return function queryCallbackTaskCheck(_x35) {
	    return _ref35.apply(this, arguments);
	  };
	}();
	
	var queryTaskCheckWorkflow = exports.queryTaskCheckWorkflow = function () {
	  var _ref36 = _asyncToGenerator(_regenerator2.default.mark(function _callee36(params) {
	    return _regenerator2.default.wrap(function _callee36$(_context36) {
	      while (1) {
	        switch (_context36.prev = _context36.next) {
	          case 0:
	            return _context36.abrupt('return', _http2.default.get(_req.task.TASKCHECK_WORKFLOW, params));
	
	          case 1:
	          case 'end':
	            return _context36.stop();
	        }
	      }
	    }, _callee36, this);
	  }));
	
	  return function queryTaskCheckWorkflow(_x36) {
	    return _ref36.apply(this, arguments);
	  };
	}();
	
	/** 标签管理 */
	// 标签列表
	
	
	var queryTagList = exports.queryTagList = function () {
	  var _ref37 = _asyncToGenerator(_regenerator2.default.mark(function _callee37(params) {
	    return _regenerator2.default.wrap(function _callee37$(_context37) {
	      while (1) {
	        switch (_context37.prev = _context37.next) {
	          case 0:
	            return _context37.abrupt('return', _http2.default.get(_req.task.TAG_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context37.stop();
	        }
	      }
	    }, _callee37, this);
	  }));
	
	  return function queryTagList(_x37) {
	    return _ref37.apply(this, arguments);
	  };
	}();
	
	// 标签删除
	
	
	var queryTagDel = exports.queryTagDel = function () {
	  var _ref38 = _asyncToGenerator(_regenerator2.default.mark(function _callee38(params) {
	    return _regenerator2.default.wrap(function _callee38$(_context38) {
	      while (1) {
	        switch (_context38.prev = _context38.next) {
	          case 0:
	            return _context38.abrupt('return', _http2.default.get(_req.task.TAG_DEL, params));
	
	          case 1:
	          case 'end':
	            return _context38.stop();
	        }
	      }
	    }, _callee38, this);
	  }));
	
	  return function queryTagDel(_x38) {
	    return _ref38.apply(this, arguments);
	  };
	}();
	
	// 标签关联删除
	
	
	var queryTagRelateDel = exports.queryTagRelateDel = function () {
	  var _ref39 = _asyncToGenerator(_regenerator2.default.mark(function _callee39(params) {
	    return _regenerator2.default.wrap(function _callee39$(_context39) {
	      while (1) {
	        switch (_context39.prev = _context39.next) {
	          case 0:
	            return _context39.abrupt('return', _http2.default.get(_req.task.TAG_RELATE_DEL, params));
	
	          case 1:
	          case 'end':
	            return _context39.stop();
	        }
	      }
	    }, _callee39, this);
	  }));
	
	  return function queryTagRelateDel(_x39) {
	    return _ref39.apply(this, arguments);
	  };
	}();
	
	var _req = __webpack_require__(32);
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);

	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(316);
	
	var zrUtil = __webpack_require__(4);
	
	var PathProxy = __webpack_require__(266);
	
	var pathContain = __webpack_require__(2979);
	
	var Pattern = __webpack_require__(1198);
	
	var getCanvasPattern = Pattern.prototype.getCanvasPattern;
	var abs = Math.abs;
	var pathProxyForDraw = new PathProxy(true);
	/**
	 * @alias module:zrender/graphic/Path
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	
	function Path(opts) {
	  Displayable.call(this, opts);
	  /**
	   * @type {module:zrender/core/PathProxy}
	   * @readOnly
	   */
	
	  this.path = null;
	}
	
	Path.prototype = {
	  constructor: Path,
	  type: 'path',
	  __dirtyPath: true,
	  strokeContainThreshold: 5,
	  // This item default to be false. But in map series in echarts,
	  // in order to improve performance, it should be set to true,
	  // so the shorty segment won't draw.
	  segmentIgnoreThreshold: 0,
	
	  /**
	   * See `module:zrender/src/graphic/helper/subPixelOptimize`.
	   * @type {boolean}
	   */
	  subPixelOptimize: false,
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var path = this.path || pathProxyForDraw;
	    var hasStroke = style.hasStroke();
	    var hasFill = style.hasFill();
	    var fill = style.fill;
	    var stroke = style.stroke;
	    var hasFillGradient = hasFill && !!fill.colorStops;
	    var hasStrokeGradient = hasStroke && !!stroke.colorStops;
	    var hasFillPattern = hasFill && !!fill.image;
	    var hasStrokePattern = hasStroke && !!stroke.image;
	    style.bind(ctx, this, prevEl);
	    this.setTransform(ctx);
	
	    if (this.__dirty) {
	      var rect; // Update gradient because bounding rect may changed
	
	      if (hasFillGradient) {
	        rect = rect || this.getBoundingRect();
	        this._fillGradient = style.getGradient(ctx, fill, rect);
	      }
	
	      if (hasStrokeGradient) {
	        rect = rect || this.getBoundingRect();
	        this._strokeGradient = style.getGradient(ctx, stroke, rect);
	      }
	    } // Use the gradient or pattern
	
	
	    if (hasFillGradient) {
	      // PENDING If may have affect the state
	      ctx.fillStyle = this._fillGradient;
	    } else if (hasFillPattern) {
	      ctx.fillStyle = getCanvasPattern.call(fill, ctx);
	    }
	
	    if (hasStrokeGradient) {
	      ctx.strokeStyle = this._strokeGradient;
	    } else if (hasStrokePattern) {
	      ctx.strokeStyle = getCanvasPattern.call(stroke, ctx);
	    }
	
	    var lineDash = style.lineDash;
	    var lineDashOffset = style.lineDashOffset;
	    var ctxLineDash = !!ctx.setLineDash; // Update path sx, sy
	
	    var scale = this.getGlobalScale();
	    path.setScale(scale[0], scale[1], this.segmentIgnoreThreshold); // Proxy context
	    // Rebuild path in following 2 cases
	    // 1. Path is dirty
	    // 2. Path needs javascript implemented lineDash stroking.
	    //    In this case, lineDash information will not be saved in PathProxy
	
	    if (this.__dirtyPath || lineDash && !ctxLineDash && hasStroke) {
	      path.beginPath(ctx); // Setting line dash before build path
	
	      if (lineDash && !ctxLineDash) {
	        path.setLineDash(lineDash);
	        path.setLineDashOffset(lineDashOffset);
	      }
	
	      this.buildPath(path, this.shape, false); // Clear path dirty flag
	
	      if (this.path) {
	        this.__dirtyPath = false;
	      }
	    } else {
	      // Replay path building
	      ctx.beginPath();
	      this.path.rebuildPath(ctx);
	    }
	
	    if (hasFill) {
	      if (style.fillOpacity != null) {
	        var originalGlobalAlpha = ctx.globalAlpha;
	        ctx.globalAlpha = style.fillOpacity * style.opacity;
	        path.fill(ctx);
	        ctx.globalAlpha = originalGlobalAlpha;
	      } else {
	        path.fill(ctx);
	      }
	    }
	
	    if (lineDash && ctxLineDash) {
	      ctx.setLineDash(lineDash);
	      ctx.lineDashOffset = lineDashOffset;
	    }
	
	    if (hasStroke) {
	      if (style.strokeOpacity != null) {
	        var originalGlobalAlpha = ctx.globalAlpha;
	        ctx.globalAlpha = style.strokeOpacity * style.opacity;
	        path.stroke(ctx);
	        ctx.globalAlpha = originalGlobalAlpha;
	      } else {
	        path.stroke(ctx);
	      }
	    }
	
	    if (lineDash && ctxLineDash) {
	      // PENDING
	      // Remove lineDash
	      ctx.setLineDash([]);
	    } // Draw rect text
	
	
	    if (style.text != null) {
	      // Only restore transform when needs draw text.
	      this.restoreTransform(ctx);
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  // When bundling path, some shape may decide if use moveTo to begin a new subpath or closePath
	  // Like in circle
	  buildPath: function (ctx, shapeCfg, inBundle) {},
	  createPathProxy: function () {
	    this.path = new PathProxy();
	  },
	  getBoundingRect: function () {
	    var rect = this._rect;
	    var style = this.style;
	    var needsUpdateRect = !rect;
	
	    if (needsUpdateRect) {
	      var path = this.path;
	
	      if (!path) {
	        // Create path on demand.
	        path = this.path = new PathProxy();
	      }
	
	      if (this.__dirtyPath) {
	        path.beginPath();
	        this.buildPath(path, this.shape, false);
	      }
	
	      rect = path.getBoundingRect();
	    }
	
	    this._rect = rect;
	
	    if (style.hasStroke()) {
	      // Needs update rect with stroke lineWidth when
	      // 1. Element changes scale or lineWidth
	      // 2. Shape is changed
	      var rectWithStroke = this._rectWithStroke || (this._rectWithStroke = rect.clone());
	
	      if (this.__dirty || needsUpdateRect) {
	        rectWithStroke.copy(rect); // FIXME Must after updateTransform
	
	        var w = style.lineWidth; // PENDING, Min line width is needed when line is horizontal or vertical
	
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Only add extra hover lineWidth when there are no fill
	
	        if (!style.hasFill()) {
	          w = Math.max(w, this.strokeContainThreshold || 4);
	        } // Consider line width
	        // Line scale can't be 0;
	
	
	        if (lineScale > 1e-10) {
	          rectWithStroke.width += w / lineScale;
	          rectWithStroke.height += w / lineScale;
	          rectWithStroke.x -= w / lineScale / 2;
	          rectWithStroke.y -= w / lineScale / 2;
	        }
	      } // Return rect with stroke
	
	
	      return rectWithStroke;
	    }
	
	    return rect;
	  },
	  contain: function (x, y) {
	    var localPos = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    var style = this.style;
	    x = localPos[0];
	    y = localPos[1];
	
	    if (rect.contain(x, y)) {
	      var pathData = this.path.data;
	
	      if (style.hasStroke()) {
	        var lineWidth = style.lineWidth;
	        var lineScale = style.strokeNoScale ? this.getLineScale() : 1; // Line scale can't be 0;
	
	        if (lineScale > 1e-10) {
	          // Only add extra hover lineWidth when there are no fill
	          if (!style.hasFill()) {
	            lineWidth = Math.max(lineWidth, this.strokeContainThreshold);
	          }
	
	          if (pathContain.containStroke(pathData, lineWidth / lineScale, x, y)) {
	            return true;
	          }
	        }
	      }
	
	      if (style.hasFill()) {
	        return pathContain.contain(pathData, x, y);
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @param  {boolean} dirtyPath
	   */
	  dirty: function (dirtyPath) {
	    if (dirtyPath == null) {
	      dirtyPath = true;
	    } // Only mark dirty, not mark clean
	
	
	    if (dirtyPath) {
	      this.__dirtyPath = dirtyPath;
	      this._rect = null;
	    }
	
	    this.__dirty = this.__dirtyText = true;
	    this.__zr && this.__zr.refresh(); // Used as a clipping path
	
	    if (this.__clipTarget) {
	      this.__clipTarget.dirty();
	    }
	  },
	
	  /**
	   * Alias for animate('shape')
	   * @param {boolean} loop
	   */
	  animateShape: function (loop) {
	    return this.animate('shape', loop);
	  },
	  // Overwrite attrKV
	  attrKV: function (key, value) {
	    // FIXME
	    if (key === 'shape') {
	      this.setShape(value);
	      this.__dirtyPath = true;
	      this._rect = null;
	    } else {
	      Displayable.prototype.attrKV.call(this, key, value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setShape: function (key, value) {
	    var shape = this.shape; // Path from string may not have shape
	
	    if (shape) {
	      if (zrUtil.isObject(key)) {
	        for (var name in key) {
	          if (key.hasOwnProperty(name)) {
	            shape[name] = key[name];
	          }
	        }
	      } else {
	        shape[key] = value;
	      }
	
	      this.dirty(true);
	    }
	
	    return this;
	  },
	  getLineScale: function () {
	    var m = this.transform; // Get the line scale.
	    // Determinant of `m` means how much the area is enlarged by the
	    // transformation. So its square root can be used as a scale factor
	    // for width.
	
	    return m && abs(m[0] - 1) > 1e-10 && abs(m[3] - 1) > 1e-10 ? Math.sqrt(abs(m[0] * m[3] - m[2] * m[1])) : 1;
	  }
	};
	/**
	 * 扩展一个 Path element, 比如星形，圆等。
	 * Extend a path element
	 * @param {Object} props
	 * @param {string} props.type Path type
	 * @param {Function} props.init Initialize
	 * @param {Function} props.buildPath Overwrite buildPath method
	 * @param {Object} [props.style] Extended default style config
	 * @param {Object} [props.shape] Extended default shape config
	 */
	
	Path.extend = function (defaults) {
	  var Sub = function (opts) {
	    Path.call(this, opts);
	
	    if (defaults.style) {
	      // Extend default style
	      this.style.extendFrom(defaults.style, false);
	    } // Extend default shape
	
	
	    var defaultShape = defaults.shape;
	
	    if (defaultShape) {
	      this.shape = this.shape || {};
	      var thisShape = this.shape;
	
	      for (var name in defaultShape) {
	        if (!thisShape.hasOwnProperty(name) && defaultShape.hasOwnProperty(name)) {
	          thisShape[name] = defaultShape[name];
	        }
	      }
	    }
	
	    defaults.init && defaults.init.call(this, opts);
	  };
	
	  zrUtil.inherits(Sub, Path); // FIXME 不能 extend position, rotation 等引用对象
	
	  for (var name in defaults) {
	    // Extending prototype values and methods
	    if (name !== 'style' && name !== 'shape') {
	      Sub.prototype[name] = defaults[name];
	    }
	  }
	
	  return Sub;
	};
	
	zrUtil.inherits(Path, Displayable);
	var _default = Path;
	module.exports = _default;

/***/ },
/* 68 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 69 */
[3026, 31, 766, 138, 65],
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var env = __webpack_require__(73);
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	
	var _clazz = __webpack_require__(161);
	
	var enableClassExtend = _clazz.enableClassExtend;
	var enableClassCheck = _clazz.enableClassCheck;
	
	var lineStyleMixin = __webpack_require__(2442);
	
	var areaStyleMixin = __webpack_require__(2439);
	
	var textStyleMixin = __webpack_require__(2443);
	
	var itemStyleMixin = __webpack_require__(2441);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/model/Model
	 */
	var mixin = zrUtil.mixin;
	var inner = makeInner();
	/**
	 * @alias module:echarts/model/Model
	 * @constructor
	 * @param {Object} [option]
	 * @param {module:echarts/model/Model} [parentModel]
	 * @param {module:echarts/model/Global} [ecModel]
	 */
	
	function Model(option, parentModel, ecModel) {
	  /**
	   * @type {module:echarts/model/Model}
	   * @readOnly
	   */
	  this.parentModel = parentModel;
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @type {Object}
	   * @protected
	   */
	
	  this.option = option; // Simple optimization
	  // if (this.init) {
	  //     if (arguments.length <= 4) {
	  //         this.init(option, parentModel, ecModel, extraOpt);
	  //     }
	  //     else {
	  //         this.init.apply(this, arguments);
	  //     }
	  // }
	}
	
	Model.prototype = {
	  constructor: Model,
	
	  /**
	   * Model 的初始化函数
	   * @param {Object} option
	   */
	  init: null,
	
	  /**
	   * 从新的 Option merge
	   */
	  mergeOption: function (option) {
	    zrUtil.merge(this.option, option, true);
	  },
	
	  /**
	   * @param {string|Array.<string>} path
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  get: function (path, ignoreParent) {
	    if (path == null) {
	      return this.option;
	    }
	
	    return doGet(this.option, this.parsePath(path), !ignoreParent && getParent(this, path));
	  },
	
	  /**
	   * @param {string} key
	   * @param {boolean} [ignoreParent=false]
	   * @return {*}
	   */
	  getShallow: function (key, ignoreParent) {
	    var option = this.option;
	    var val = option == null ? option : option[key];
	    var parentModel = !ignoreParent && getParent(this, key);
	
	    if (val == null && parentModel) {
	      val = parentModel.getShallow(key);
	    }
	
	    return val;
	  },
	
	  /**
	   * @param {string|Array.<string>} [path]
	   * @param {module:echarts/model/Model} [parentModel]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path, parentModel) {
	    var obj = path == null ? this.option : doGet(this.option, path = this.parsePath(path));
	    var thisParentModel;
	    parentModel = parentModel || (thisParentModel = getParent(this, path)) && thisParentModel.getModel(path);
	    return new Model(obj, parentModel, this.ecModel);
	  },
	
	  /**
	   * If model has option
	   */
	  isEmpty: function () {
	    return this.option == null;
	  },
	  restoreData: function () {},
	  // Pending
	  clone: function () {
	    var Ctor = this.constructor;
	    return new Ctor(zrUtil.clone(this.option));
	  },
	  setReadOnly: function (properties) {// clazzUtil.setReadOnly(this, properties);
	  },
	  // If path is null/undefined, return null/undefined.
	  parsePath: function (path) {
	    if (typeof path === 'string') {
	      path = path.split('.');
	    }
	
	    return path;
	  },
	
	  /**
	   * @param {Function} getParentMethod
	   *        param {Array.<string>|string} path
	   *        return {module:echarts/model/Model}
	   */
	  customizeGetParent: function (getParentMethod) {
	    inner(this).getParent = getParentMethod;
	  },
	  isAnimationEnabled: function () {
	    if (!env.node) {
	      if (this.option.animation != null) {
	        return !!this.option.animation;
	      } else if (this.parentModel) {
	        return this.parentModel.isAnimationEnabled();
	      }
	    }
	  }
	};
	
	function doGet(obj, pathArr, parentModel) {
	  for (var i = 0; i < pathArr.length; i++) {
	    // Ignore empty
	    if (!pathArr[i]) {
	      continue;
	    } // obj could be number/string/... (like 0)
	
	
	    obj = obj && typeof obj === 'object' ? obj[pathArr[i]] : null;
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  if (obj == null && parentModel) {
	    obj = parentModel.get(pathArr);
	  }
	
	  return obj;
	} // `path` can be null/undefined
	
	
	function getParent(model, path) {
	  var getParentMethod = inner(model).getParent;
	  return getParentMethod ? getParentMethod.call(model, path) : model.parentModel;
	} // Enable Model.extend.
	
	
	enableClassExtend(Model);
	enableClassCheck(Model);
	mixin(Model, lineStyleMixin);
	mixin(Model, areaStyleMixin);
	mixin(Model, textStyleMixin);
	mixin(Model, itemStyleMixin);
	var _default = Model;
	module.exports = _default;

/***/ },
/* 71 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * @ignore
	 * some key-codes definition and utils from closure-library
	 * @author yiminghe@gmail.com
	 */
	var KeyCode = {
	  /**
	   * MAC_ENTER
	   */
	  MAC_ENTER: 3,
	
	  /**
	   * BACKSPACE
	   */
	  BACKSPACE: 8,
	
	  /**
	   * TAB
	   */
	  TAB: 9,
	
	  /**
	   * NUMLOCK on FF/Safari Mac
	   */
	  NUM_CENTER: 12,
	
	  /**
	   * ENTER
	   */
	  ENTER: 13,
	
	  /**
	   * SHIFT
	   */
	  SHIFT: 16,
	
	  /**
	   * CTRL
	   */
	  CTRL: 17,
	
	  /**
	   * ALT
	   */
	  ALT: 18,
	
	  /**
	   * PAUSE
	   */
	  PAUSE: 19,
	
	  /**
	   * CAPS_LOCK
	   */
	  CAPS_LOCK: 20,
	
	  /**
	   * ESC
	   */
	  ESC: 27,
	
	  /**
	   * SPACE
	   */
	  SPACE: 32,
	
	  /**
	   * PAGE_UP
	   */
	  PAGE_UP: 33,
	
	  /**
	   * PAGE_DOWN
	   */
	  PAGE_DOWN: 34,
	
	  /**
	   * END
	   */
	  END: 35,
	
	  /**
	   * HOME
	   */
	  HOME: 36,
	
	  /**
	   * LEFT
	   */
	  LEFT: 37,
	
	  /**
	   * UP
	   */
	  UP: 38,
	
	  /**
	   * RIGHT
	   */
	  RIGHT: 39,
	
	  /**
	   * DOWN
	   */
	  DOWN: 40,
	
	  /**
	   * PRINT_SCREEN
	   */
	  PRINT_SCREEN: 44,
	
	  /**
	   * INSERT
	   */
	  INSERT: 45,
	
	  /**
	   * DELETE
	   */
	  DELETE: 46,
	
	  /**
	   * ZERO
	   */
	  ZERO: 48,
	
	  /**
	   * ONE
	   */
	  ONE: 49,
	
	  /**
	   * TWO
	   */
	  TWO: 50,
	
	  /**
	   * THREE
	   */
	  THREE: 51,
	
	  /**
	   * FOUR
	   */
	  FOUR: 52,
	
	  /**
	   * FIVE
	   */
	  FIVE: 53,
	
	  /**
	   * SIX
	   */
	  SIX: 54,
	
	  /**
	   * SEVEN
	   */
	  SEVEN: 55,
	
	  /**
	   * EIGHT
	   */
	  EIGHT: 56,
	
	  /**
	   * NINE
	   */
	  NINE: 57,
	
	  /**
	   * QUESTION_MARK
	   */
	  QUESTION_MARK: 63,
	
	  /**
	   * A
	   */
	  A: 65,
	
	  /**
	   * B
	   */
	  B: 66,
	
	  /**
	   * C
	   */
	  C: 67,
	
	  /**
	   * D
	   */
	  D: 68,
	
	  /**
	   * E
	   */
	  E: 69,
	
	  /**
	   * F
	   */
	  F: 70,
	
	  /**
	   * G
	   */
	  G: 71,
	
	  /**
	   * H
	   */
	  H: 72,
	
	  /**
	   * I
	   */
	  I: 73,
	
	  /**
	   * J
	   */
	  J: 74,
	
	  /**
	   * K
	   */
	  K: 75,
	
	  /**
	   * L
	   */
	  L: 76,
	
	  /**
	   * M
	   */
	  M: 77,
	
	  /**
	   * N
	   */
	  N: 78,
	
	  /**
	   * O
	   */
	  O: 79,
	
	  /**
	   * P
	   */
	  P: 80,
	
	  /**
	   * Q
	   */
	  Q: 81,
	
	  /**
	   * R
	   */
	  R: 82,
	
	  /**
	   * S
	   */
	  S: 83,
	
	  /**
	   * T
	   */
	  T: 84,
	
	  /**
	   * U
	   */
	  U: 85,
	
	  /**
	   * V
	   */
	  V: 86,
	
	  /**
	   * W
	   */
	  W: 87,
	
	  /**
	   * X
	   */
	  X: 88,
	
	  /**
	   * Y
	   */
	  Y: 89,
	
	  /**
	   * Z
	   */
	  Z: 90,
	
	  /**
	   * META
	   */
	  META: 91,
	
	  /**
	   * WIN_KEY_RIGHT
	   */
	  WIN_KEY_RIGHT: 92,
	
	  /**
	   * CONTEXT_MENU
	   */
	  CONTEXT_MENU: 93,
	
	  /**
	   * NUM_ZERO
	   */
	  NUM_ZERO: 96,
	
	  /**
	   * NUM_ONE
	   */
	  NUM_ONE: 97,
	
	  /**
	   * NUM_TWO
	   */
	  NUM_TWO: 98,
	
	  /**
	   * NUM_THREE
	   */
	  NUM_THREE: 99,
	
	  /**
	   * NUM_FOUR
	   */
	  NUM_FOUR: 100,
	
	  /**
	   * NUM_FIVE
	   */
	  NUM_FIVE: 101,
	
	  /**
	   * NUM_SIX
	   */
	  NUM_SIX: 102,
	
	  /**
	   * NUM_SEVEN
	   */
	  NUM_SEVEN: 103,
	
	  /**
	   * NUM_EIGHT
	   */
	  NUM_EIGHT: 104,
	
	  /**
	   * NUM_NINE
	   */
	  NUM_NINE: 105,
	
	  /**
	   * NUM_MULTIPLY
	   */
	  NUM_MULTIPLY: 106,
	
	  /**
	   * NUM_PLUS
	   */
	  NUM_PLUS: 107,
	
	  /**
	   * NUM_MINUS
	   */
	  NUM_MINUS: 109,
	
	  /**
	   * NUM_PERIOD
	   */
	  NUM_PERIOD: 110,
	
	  /**
	   * NUM_DIVISION
	   */
	  NUM_DIVISION: 111,
	
	  /**
	   * F1
	   */
	  F1: 112,
	
	  /**
	   * F2
	   */
	  F2: 113,
	
	  /**
	   * F3
	   */
	  F3: 114,
	
	  /**
	   * F4
	   */
	  F4: 115,
	
	  /**
	   * F5
	   */
	  F5: 116,
	
	  /**
	   * F6
	   */
	  F6: 117,
	
	  /**
	   * F7
	   */
	  F7: 118,
	
	  /**
	   * F8
	   */
	  F8: 119,
	
	  /**
	   * F9
	   */
	  F9: 120,
	
	  /**
	   * F10
	   */
	  F10: 121,
	
	  /**
	   * F11
	   */
	  F11: 122,
	
	  /**
	   * F12
	   */
	  F12: 123,
	
	  /**
	   * NUMLOCK
	   */
	  NUMLOCK: 144,
	
	  /**
	   * SEMICOLON
	   */
	  SEMICOLON: 186,
	
	  /**
	   * DASH
	   */
	  DASH: 189,
	
	  /**
	   * EQUALS
	   */
	  EQUALS: 187,
	
	  /**
	   * COMMA
	   */
	  COMMA: 188,
	
	  /**
	   * PERIOD
	   */
	  PERIOD: 190,
	
	  /**
	   * SLASH
	   */
	  SLASH: 191,
	
	  /**
	   * APOSTROPHE
	   */
	  APOSTROPHE: 192,
	
	  /**
	   * SINGLE_QUOTE
	   */
	  SINGLE_QUOTE: 222,
	
	  /**
	   * OPEN_SQUARE_BRACKET
	   */
	  OPEN_SQUARE_BRACKET: 219,
	
	  /**
	   * BACKSLASH
	   */
	  BACKSLASH: 220,
	
	  /**
	   * CLOSE_SQUARE_BRACKET
	   */
	  CLOSE_SQUARE_BRACKET: 221,
	
	  /**
	   * WIN_KEY
	   */
	  WIN_KEY: 224,
	
	  /**
	   * MAC_FF_META
	   */
	  MAC_FF_META: 224,
	
	  /**
	   * WIN_IME
	   */
	  WIN_IME: 229,
	  // ======================== Function ========================
	
	  /**
	   * whether text and modified key is entered at the same time.
	   */
	  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
	    var keyCode = e.keyCode;
	
	    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
	    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
	      return false;
	    } // The following keys are quite harmless, even in combination with
	    // CTRL, ALT or SHIFT.
	
	
	    switch (keyCode) {
	      case KeyCode.ALT:
	      case KeyCode.CAPS_LOCK:
	      case KeyCode.CONTEXT_MENU:
	      case KeyCode.CTRL:
	      case KeyCode.DOWN:
	      case KeyCode.END:
	      case KeyCode.ESC:
	      case KeyCode.HOME:
	      case KeyCode.INSERT:
	      case KeyCode.LEFT:
	      case KeyCode.MAC_FF_META:
	      case KeyCode.META:
	      case KeyCode.NUMLOCK:
	      case KeyCode.NUM_CENTER:
	      case KeyCode.PAGE_DOWN:
	      case KeyCode.PAGE_UP:
	      case KeyCode.PAUSE:
	      case KeyCode.PRINT_SCREEN:
	      case KeyCode.RIGHT:
	      case KeyCode.SHIFT:
	      case KeyCode.UP:
	      case KeyCode.WIN_KEY:
	      case KeyCode.WIN_KEY_RIGHT:
	        return false;
	
	      default:
	        return true;
	    }
	  },
	
	  /**
	   * whether character is entered.
	   */
	  isCharacterKey: function isCharacterKey(keyCode) {
	    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
	      return true;
	    }
	
	    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
	      return true;
	    }
	
	    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
	      return true;
	    } // Safari sends zero key code for non-latin characters.
	
	
	    if (window.navigator.userAgent.indexOf('WebKit') !== -1 && keyCode === 0) {
	      return true;
	    }
	
	    switch (keyCode) {
	      case KeyCode.SPACE:
	      case KeyCode.QUESTION_MARK:
	      case KeyCode.NUM_PLUS:
	      case KeyCode.NUM_MINUS:
	      case KeyCode.NUM_PERIOD:
	      case KeyCode.NUM_DIVISION:
	      case KeyCode.SEMICOLON:
	      case KeyCode.DASH:
	      case KeyCode.EQUALS:
	      case KeyCode.COMMA:
	      case KeyCode.PERIOD:
	      case KeyCode.SLASH:
	      case KeyCode.APOSTROPHE:
	      case KeyCode.SINGLE_QUOTE:
	      case KeyCode.OPEN_SQUARE_BRACKET:
	      case KeyCode.BACKSLASH:
	      case KeyCode.CLOSE_SQUARE_BRACKET:
	        return true;
	
	      default:
	        return false;
	    }
	  }
	};
	var _default = KeyCode;
	exports.default = _default;

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var DOMProperty = __webpack_require__(259);
	var ReactDOMComponentFlags = __webpack_require__(1131);
	
	var invariant = __webpack_require__(18);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 73 */
/***/ function(module, exports) {

	/**
	 * echarts设备环境识别
	 *
	 * @desc echarts基于Canvas，纯Javascript图表库，提供直观，生动，可交互，可个性化定制的数据统计图表。
	 * @author firede[firede@firede.us]
	 * @desc thanks zepto.
	 */
	
	/* global wx */
	var env = {};
	
	if (typeof wx === 'object' && typeof wx.getSystemInfoSync === 'function') {
	  // In Weixin Application
	  env = {
	    browser: {},
	    os: {},
	    node: false,
	    wxa: true,
	    // Weixin Application
	    canvasSupported: true,
	    svgSupported: false,
	    touchEventsSupported: true,
	    domSupported: false
	  };
	} else if (typeof document === 'undefined' && typeof self !== 'undefined') {
	  // In worker
	  env = {
	    browser: {},
	    os: {},
	    node: false,
	    worker: true,
	    canvasSupported: true,
	    domSupported: false
	  };
	} else if (typeof navigator === 'undefined') {
	  // In node
	  env = {
	    browser: {},
	    os: {},
	    node: true,
	    worker: false,
	    // Assume canvas is supported
	    canvasSupported: true,
	    svgSupported: true,
	    domSupported: false
	  };
	} else {
	  env = detect(navigator.userAgent);
	}
	
	var _default = env; // Zepto.js
	// (c) 2010-2013 Thomas Fuchs
	// Zepto.js may be freely distributed under the MIT license.
	
	function detect(ua) {
	  var os = {};
	  var browser = {}; // var webkit = ua.match(/Web[kK]it[\/]{0,1}([\d.]+)/);
	  // var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/);
	  // var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
	  // var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
	  // var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
	  // var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
	  // var touchpad = webos && ua.match(/TouchPad/);
	  // var kindle = ua.match(/Kindle\/([\d.]+)/);
	  // var silk = ua.match(/Silk\/([\d._]+)/);
	  // var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
	  // var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
	  // var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
	  // var playbook = ua.match(/PlayBook/);
	  // var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
	
	  var firefox = ua.match(/Firefox\/([\d.]+)/); // var safari = webkit && ua.match(/Mobile\//) && !chrome;
	  // var webview = ua.match(/(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/) && !chrome;
	
	  var ie = ua.match(/MSIE\s([\d.]+)/) // IE 11 Trident/7.0; rv:11.0
	  || ua.match(/Trident\/.+?rv:(([\d.]+))/);
	  var edge = ua.match(/Edge\/([\d.]+)/); // IE 12 and 12+
	
	  var weChat = /micromessenger/i.test(ua); // Todo: clean this up with a better OS/browser seperation:
	  // - discern (more) between multiple browsers on android
	  // - decide if kindle fire in silk mode is android or not
	  // - Firefox on Android doesn't specify the Android version
	  // - possibly devide in os, device and browser hashes
	  // if (browser.webkit = !!webkit) browser.version = webkit[1];
	  // if (android) os.android = true, os.version = android[2];
	  // if (iphone && !ipod) os.ios = os.iphone = true, os.version = iphone[2].replace(/_/g, '.');
	  // if (ipad) os.ios = os.ipad = true, os.version = ipad[2].replace(/_/g, '.');
	  // if (ipod) os.ios = os.ipod = true, os.version = ipod[3] ? ipod[3].replace(/_/g, '.') : null;
	  // if (webos) os.webos = true, os.version = webos[2];
	  // if (touchpad) os.touchpad = true;
	  // if (blackberry) os.blackberry = true, os.version = blackberry[2];
	  // if (bb10) os.bb10 = true, os.version = bb10[2];
	  // if (rimtabletos) os.rimtabletos = true, os.version = rimtabletos[2];
	  // if (playbook) browser.playbook = true;
	  // if (kindle) os.kindle = true, os.version = kindle[1];
	  // if (silk) browser.silk = true, browser.version = silk[1];
	  // if (!silk && os.android && ua.match(/Kindle Fire/)) browser.silk = true;
	  // if (chrome) browser.chrome = true, browser.version = chrome[1];
	
	  if (firefox) {
	    browser.firefox = true;
	    browser.version = firefox[1];
	  } // if (safari && (ua.match(/Safari/) || !!os.ios)) browser.safari = true;
	  // if (webview) browser.webview = true;
	
	
	  if (ie) {
	    browser.ie = true;
	    browser.version = ie[1];
	  }
	
	  if (edge) {
	    browser.edge = true;
	    browser.version = edge[1];
	  } // It is difficult to detect WeChat in Win Phone precisely, because ua can
	  // not be set on win phone. So we do not consider Win Phone.
	
	
	  if (weChat) {
	    browser.weChat = true;
	  } // os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
	  //     (firefox && ua.match(/Tablet/)) || (ie && !ua.match(/Phone/) && ua.match(/Touch/)));
	  // os.phone  = !!(!os.tablet && !os.ipod && (android || iphone || webos ||
	  //     (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
	  //     (firefox && ua.match(/Mobile/)) || (ie && ua.match(/Touch/))));
	
	
	  return {
	    browser: browser,
	    os: os,
	    node: false,
	    // 原生canvas支持，改极端点了
	    // canvasSupported : !(browser.ie && parseFloat(browser.version) < 9)
	    canvasSupported: !!document.createElement('canvas').getContext,
	    svgSupported: typeof SVGRect !== 'undefined',
	    // works on most browsers
	    // IE10/11 does not support touch event, and MS Edge supports them but not by
	    // default, so we dont check navigator.maxTouchPoints for them here.
	    touchEventsSupported: 'ontouchstart' in window && !browser.ie && !browser.edge,
	    // <http://caniuse.com/#search=pointer%20event>.
	    pointerEventsSupported: // (1) Firefox supports pointer but not by default, only MS browsers are reliable on pointer
	    // events currently. So we dont use that on other browsers unless tested sufficiently.
	    // For example, in iOS 13 Mobile Chromium 78, if the touching behavior starts page
	    // scroll, the `pointermove` event can not be fired any more. That will break some
	    // features like "pan horizontally to move something and pan vertically to page scroll".
	    // The horizontal pan probably be interrupted by the casually triggered page scroll.
	    // (2) Although IE 10 supports pointer event, it use old style and is different from the
	    // standard. So we exclude that. (IE 10 is hardly used on touch device)
	    'onpointerdown' in window && (browser.edge || browser.ie && browser.version >= 11),
	    // passiveSupported: detectPassiveSupport()
	    domSupported: typeof document !== 'undefined'
	  };
	} // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
	// function detectPassiveSupport() {
	//     // Test via a getter in the options object to see if the passive property is accessed
	//     var supportsPassive = false;
	//     try {
	//         var opts = Object.defineProperty({}, 'passive', {
	//             get: function() {
	//                 supportsPassive = true;
	//             }
	//         });
	//         window.addEventListener('testPassive', function() {}, opts);
	//     } catch (e) {
	//     }
	//     return supportsPassive;
	// }
	
	
	module.exports = _default;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.convertFieldsError = convertFieldsError;
	exports.format = format;
	exports.isEmptyValue = isEmptyValue;
	exports.isEmptyObject = isEmptyObject;
	exports.asyncMap = asyncMap;
	exports.complementError = complementError;
	exports.deepMerge = deepMerge;
	/* eslint no-console:0 */
	
	var formatRegExp = /%[sdj%]/g;
	
	var warning = exports.warning = function warning() {};
	
	// don't print warning message when in production env or node runtime
	if (false) {
	  exports.warning = warning = function warning(type, errors) {
	    if (typeof console !== 'undefined' && console.warn) {
	      if (errors.every(function (e) {
	        return typeof e === 'string';
	      })) {
	        console.warn(type, errors);
	      }
	    }
	  };
	}
	
	function convertFieldsError(errors) {
	  if (!errors || !errors.length) return null;
	  var fields = {};
	  errors.forEach(function (error) {
	    var field = error.field;
	    fields[field] = fields[field] || [];
	    fields[field].push(error);
	  });
	  return fields;
	}
	
	function format() {
	  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var i = 1;
	  var f = args[0];
	  var len = args.length;
	  if (typeof f === 'function') {
	    return f.apply(null, args.slice(1));
	  }
	  if (typeof f === 'string') {
	    var str = String(f).replace(formatRegExp, function (x) {
	      if (x === '%%') {
	        return '%';
	      }
	      if (i >= len) {
	        return x;
	      }
	      switch (x) {
	        case '%s':
	          return String(args[i++]);
	        case '%d':
	          return Number(args[i++]);
	        case '%j':
	          try {
	            return JSON.stringify(args[i++]);
	          } catch (_) {
	            return '[Circular]';
	          }
	          break;
	        default:
	          return x;
	      }
	    });
	    for (var arg = args[i]; i < len; arg = args[++i]) {
	      str += ' ' + arg;
	    }
	    return str;
	  }
	  return f;
	}
	
	function isNativeStringType(type) {
	  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
	}
	
	function isEmptyValue(value, type) {
	  if (value === undefined || value === null) {
	    return true;
	  }
	  if (type === 'array' && Array.isArray(value) && !value.length) {
	    return true;
	  }
	  if (isNativeStringType(type) && typeof value === 'string' && !value) {
	    return true;
	  }
	  return false;
	}
	
	function isEmptyObject(obj) {
	  return Object.keys(obj).length === 0;
	}
	
	function asyncParallelArray(arr, func, callback) {
	  var results = [];
	  var total = 0;
	  var arrLength = arr.length;
	
	  function count(errors) {
	    results.push.apply(results, errors);
	    total++;
	    if (total === arrLength) {
	      callback(results);
	    }
	  }
	
	  arr.forEach(function (a) {
	    func(a, count);
	  });
	}
	
	function asyncSerialArray(arr, func, callback) {
	  var index = 0;
	  var arrLength = arr.length;
	
	  function next(errors) {
	    if (errors && errors.length) {
	      callback(errors);
	      return;
	    }
	    var original = index;
	    index = index + 1;
	    if (original < arrLength) {
	      func(arr[original], next);
	    } else {
	      callback([]);
	    }
	  }
	
	  next([]);
	}
	
	function flattenObjArr(objArr) {
	  var ret = [];
	  Object.keys(objArr).forEach(function (k) {
	    ret.push.apply(ret, objArr[k]);
	  });
	  return ret;
	}
	
	function asyncMap(objArr, option, func, callback) {
	  if (option.first) {
	    var flattenArr = flattenObjArr(objArr);
	    return asyncSerialArray(flattenArr, func, callback);
	  }
	  var firstFields = option.firstFields || [];
	  if (firstFields === true) {
	    firstFields = Object.keys(objArr);
	  }
	  var objArrKeys = Object.keys(objArr);
	  var objArrLength = objArrKeys.length;
	  var total = 0;
	  var results = [];
	  var pending = new Promise(function (resolve, reject) {
	    var next = function next(errors) {
	      results.push.apply(results, errors);
	      total++;
	      if (total === objArrLength) {
	        callback(results);
	        return results.length ? reject({ errors: results, fields: convertFieldsError(results) }) : resolve();
	      }
	    };
	    objArrKeys.forEach(function (key) {
	      var arr = objArr[key];
	      if (firstFields.indexOf(key) !== -1) {
	        asyncSerialArray(arr, func, next);
	      } else {
	        asyncParallelArray(arr, func, next);
	      }
	    });
	  });
	  pending['catch'](function (e) {
	    return e;
	  });
	  return pending;
	}
	
	function complementError(rule) {
	  return function (oe) {
	    if (oe && oe.message) {
	      oe.field = oe.field || rule.fullField;
	      return oe;
	    }
	    return {
	      message: typeof oe === 'function' ? oe() : oe,
	      field: oe.field || rule.fullField
	    };
	  };
	}
	
	function deepMerge(target, source) {
	  if (source) {
	    for (var s in source) {
	      if (source.hasOwnProperty(s)) {
	        var value = source[s];
	        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _typeof(target[s]) === 'object') {
	          target[s] = _extends({}, target[s], value);
	        } else {
	          target[s] = value;
	        }
	      }
	    }
	  }
	  return target;
	}

/***/ },
/* 75 */
[3043, 136],
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Model = __webpack_require__(70);
	
	var componentUtil = __webpack_require__(297);
	
	var _clazz = __webpack_require__(161);
	
	var enableClassManagement = _clazz.enableClassManagement;
	var parseClassType = _clazz.parseClassType;
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	
	var layout = __webpack_require__(46);
	
	var boxLayoutMixin = __webpack_require__(2440);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Component model
	 *
	 * @module echarts/model/Component
	 */
	var inner = makeInner();
	/**
	 * @alias module:echarts/model/Component
	 * @constructor
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {module:echarts/model/Model} ecModel
	 */
	
	var ComponentModel = Model.extend({
	  type: 'component',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  id: '',
	
	  /**
	   * Because simplified concept is probably better, series.name (or component.name)
	   * has been having too many resposibilities:
	   * (1) Generating id (which requires name in option should not be modified).
	   * (2) As an index to mapping series when merging option or calling API (a name
	   * can refer to more then one components, which is convinient is some case).
	   * (3) Display.
	   * @readOnly
	   */
	  name: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  mainType: '',
	
	  /**
	   * @readOnly
	   * @type {string}
	   */
	  subType: '',
	
	  /**
	   * @readOnly
	   * @type {number}
	   */
	  componentIndex: 0,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * @type {module:echarts/model/Global}
	   * @readOnly
	   */
	  ecModel: null,
	
	  /**
	   * key: componentType
	   * value:  Component model list, can not be null.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @readOnly
	   */
	  dependentModels: [],
	
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  uid: null,
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  $constructor: function (option, parentModel, ecModel, extraOpt) {
	    Model.call(this, option, parentModel, ecModel, extraOpt);
	    this.uid = componentUtil.getUID('ec_cpt_model');
	  },
	  init: function (option, parentModel, ecModel, extraOpt) {
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? layout.getLayoutParams(option) : {};
	    var themeModel = ecModel.getTheme();
	    zrUtil.merge(option, themeModel.get(this.mainType));
	    zrUtil.merge(option, this.getDefaultOption());
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (option, extraOpt) {
	    zrUtil.merge(this.option, option, true);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      layout.mergeLayoutParam(this.option, option, layoutMode);
	    }
	  },
	  // Hooker after init or mergeOption
	  optionUpdated: function (newCptOption, isInit) {},
	  getDefaultOption: function () {
	    var fields = inner(this);
	
	    if (!fields.defaultOption) {
	      var optList = [];
	      var Class = this.constructor;
	
	      while (Class) {
	        var opt = Class.prototype.defaultOption;
	        opt && optList.push(opt);
	        Class = Class.superClass;
	      }
	
	      var defaultOption = {};
	
	      for (var i = optList.length - 1; i >= 0; i--) {
	        defaultOption = zrUtil.merge(defaultOption, optList[i], true);
	      }
	
	      fields.defaultOption = defaultOption;
	    }
	
	    return fields.defaultOption;
	  },
	  getReferringComponents: function (mainType) {
	    return this.ecModel.queryComponents({
	      mainType: mainType,
	      index: this.get(mainType + 'Index', true),
	      id: this.get(mainType + 'Id', true)
	    });
	  }
	}); // Reset ComponentModel.extend, add preConstruct.
	// clazzUtil.enableClassExtend(
	//     ComponentModel,
	//     function (option, parentModel, ecModel, extraOpt) {
	//         // Set dependentModels, componentIndex, name, id, mainType, subType.
	//         zrUtil.extend(this, extraOpt);
	//         this.uid = componentUtil.getUID('componentModel');
	//         // this.setReadOnly([
	//         //     'type', 'id', 'uid', 'name', 'mainType', 'subType',
	//         //     'dependentModels', 'componentIndex'
	//         // ]);
	//     }
	// );
	// Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	enableClassManagement(ComponentModel, {
	  registerWhenExtend: true
	});
	componentUtil.enableSubTypeDefaulter(ComponentModel); // Add capability of ComponentModel.topologicalTravel.
	
	componentUtil.enableTopologicalTravel(ComponentModel, getDependencies);
	
	function getDependencies(componentType) {
	  var deps = [];
	  zrUtil.each(ComponentModel.getClassesByMainType(componentType), function (Clazz) {
	    deps = deps.concat(Clazz.prototype.dependencies || []);
	  }); // Ensure main type.
	
	  deps = zrUtil.map(deps, function (type) {
	    return parseClassType(type).main;
	  }); // Hack dataset for convenience.
	
	  if (componentType !== 'dataset' && zrUtil.indexOf(deps, 'dataset') <= 0) {
	    deps.unshift('dataset');
	  }
	
	  return deps;
	}
	
	zrUtil.mixin(ComponentModel, boxLayoutMixin);
	var _default = ComponentModel;
	module.exports = _default;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(4);
	
	var env = __webpack_require__(73);
	
	var _format = __webpack_require__(48);
	
	var formatTime = _format.formatTime;
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	var getTooltipMarker = _format.getTooltipMarker;
	
	var modelUtil = __webpack_require__(29);
	
	var ComponentModel = __webpack_require__(76);
	
	var colorPaletteMixin = __webpack_require__(875);
	
	var dataFormatMixin = __webpack_require__(517);
	
	var _layout = __webpack_require__(46);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	var _task = __webpack_require__(518);
	
	var createTask = _task.createTask;
	
	var _sourceHelper = __webpack_require__(160);
	
	var prepareSource = _sourceHelper.prepareSource;
	var getSource = _sourceHelper.getSource;
	
	var _dataProvider = __webpack_require__(212);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = modelUtil.makeInner();
	var SeriesModel = ComponentModel.extend({
	  type: 'series.__base__',
	
	  /**
	   * @readOnly
	   */
	  seriesIndex: 0,
	  // coodinateSystem will be injected in the echarts/CoordinateSystem
	  coordinateSystem: null,
	
	  /**
	   * @type {Object}
	   * @protected
	   */
	  defaultOption: null,
	
	  /**
	   * legend visual provider to the legend component
	   * @type {Object}
	   */
	  // PENDING
	  legendVisualProvider: null,
	
	  /**
	   * Access path of color for visual
	   */
	  visualColorAccessPath: 'itemStyle.color',
	
	  /**
	   * Access path of borderColor for visual
	   */
	  visualBorderColorAccessPath: 'itemStyle.borderColor',
	
	  /**
	   * Support merge layout params.
	   * Only support 'box' now (left/right/top/bottom/width/height).
	   * @type {string|Object} Object can be {ignoreSize: true}
	   * @readOnly
	   */
	  layoutMode: null,
	  init: function (option, parentModel, ecModel, extraOpt) {
	    /**
	     * @type {number}
	     * @readOnly
	     */
	    this.seriesIndex = this.componentIndex;
	    this.dataTask = createTask({
	      count: dataTaskCount,
	      reset: dataTaskReset
	    });
	    this.dataTask.context = {
	      model: this
	    };
	    this.mergeDefaultAndTheme(option, ecModel);
	    prepareSource(this);
	    var data = this.getInitialData(option, ecModel);
	    wrapData(data, this);
	    this.dataTask.context.data = data;
	
	    /**
	     * @type {module:echarts/data/List|module:echarts/data/Tree|module:echarts/data/Graph}
	     * @private
	     */
	    inner(this).dataBeforeProcessed = data; // If we reverse the order (make data firstly, and then make
	    // dataBeforeProcessed by cloneShallow), cloneShallow will
	    // cause data.graph.data !== data when using
	    // module:echarts/data/Graph or module:echarts/data/Tree.
	    // See module:echarts/data/helper/linkList
	    // Theoretically, it is unreasonable to call `seriesModel.getData()` in the model
	    // init or merge stage, because the data can be restored. So we do not `restoreData`
	    // and `setData` here, which forbids calling `seriesModel.getData()` in this stage.
	    // Call `seriesModel.getRawData()` instead.
	    // this.restoreData();
	
	    autoSeriesName(this);
	  },
	
	  /**
	   * Util for merge default and theme to option
	   * @param  {Object} option
	   * @param  {module:echarts/model/Global} ecModel
	   */
	  mergeDefaultAndTheme: function (option, ecModel) {
	    var layoutMode = this.layoutMode;
	    var inputPositionParams = layoutMode ? getLayoutParams(option) : {}; // Backward compat: using subType on theme.
	    // But if name duplicate between series subType
	    // (for example: parallel) add component mainType,
	    // add suffix 'Series'.
	
	    var themeSubType = this.subType;
	
	    if (ComponentModel.hasClass(themeSubType)) {
	      themeSubType += 'Series';
	    }
	
	    zrUtil.merge(option, ecModel.getTheme().get(this.subType));
	    zrUtil.merge(option, this.getDefaultOption()); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option, 'label', ['show']);
	    this.fillDataTextStyle(option.data);
	
	    if (layoutMode) {
	      mergeLayoutParam(option, inputPositionParams, layoutMode);
	    }
	  },
	  mergeOption: function (newSeriesOption, ecModel) {
	    // this.settingTask.dirty();
	    newSeriesOption = zrUtil.merge(this.option, newSeriesOption, true);
	    this.fillDataTextStyle(newSeriesOption.data);
	    var layoutMode = this.layoutMode;
	
	    if (layoutMode) {
	      mergeLayoutParam(this.option, newSeriesOption, layoutMode);
	    }
	
	    prepareSource(this);
	    var data = this.getInitialData(newSeriesOption, ecModel);
	    wrapData(data, this);
	    this.dataTask.dirty();
	    this.dataTask.context.data = data;
	    inner(this).dataBeforeProcessed = data;
	    autoSeriesName(this);
	  },
	  fillDataTextStyle: function (data) {
	    // Default data label emphasis `show`
	    // FIXME Tree structure data ?
	    // FIXME Performance ?
	    if (data && !zrUtil.isTypedArray(data)) {
	      var props = ['show'];
	
	      for (var i = 0; i < data.length; i++) {
	        if (data[i] && data[i].label) {
	          modelUtil.defaultEmphasis(data[i], 'label', props);
	        }
	      }
	    }
	  },
	
	  /**
	   * Init a data structure from data related option in series
	   * Must be overwritten
	   */
	  getInitialData: function () {},
	
	  /**
	   * Append data to list
	   * @param {Object} params
	   * @param {Array|TypedArray} params.data
	   */
	  appendData: function (params) {
	    // FIXME ???
	    // (1) If data from dataset, forbidden append.
	    // (2) support append data of dataset.
	    var data = this.getRawData();
	    data.appendData(params.data);
	  },
	
	  /**
	   * Consider some method like `filter`, `map` need make new data,
	   * We should make sure that `seriesModel.getData()` get correct
	   * data in the stream procedure. So we fetch data from upstream
	   * each time `task.perform` called.
	   * @param {string} [dataType]
	   * @return {module:echarts/data/List}
	   */
	  getData: function (dataType) {
	    var task = getCurrentTask(this);
	
	    if (task) {
	      var data = task.context.data;
	      return dataType == null ? data : data.getLinkedData(dataType);
	    } else {
	      // When series is not alive (that may happen when click toolbox
	      // restore or setOption with not merge mode), series data may
	      // be still need to judge animation or something when graphic
	      // elements want to know whether fade out.
	      return inner(this).data;
	    }
	  },
	
	  /**
	   * @param {module:echarts/data/List} data
	   */
	  setData: function (data) {
	    var task = getCurrentTask(this);
	
	    if (task) {
	      var context = task.context; // Consider case: filter, data sample.
	
	      if (context.data !== data && task.modifyOutputEnd) {
	        task.setOutputEnd(data.count());
	      }
	
	      context.outputData = data; // Caution: setData should update context.data,
	      // Because getData may be called multiply in a
	      // single stage and expect to get the data just
	      // set. (For example, AxisProxy, x y both call
	      // getData and setDate sequentially).
	      // So the context.data should be fetched from
	      // upstream each time when a stage starts to be
	      // performed.
	
	      if (task !== this.dataTask) {
	        context.data = data;
	      }
	    }
	
	    inner(this).data = data;
	  },
	
	  /**
	   * @see {module:echarts/data/helper/sourceHelper#getSource}
	   * @return {module:echarts/data/Source} source
	   */
	  getSource: function () {
	    return getSource(this);
	  },
	
	  /**
	   * Get data before processed
	   * @return {module:echarts/data/List}
	   */
	  getRawData: function () {
	    return inner(this).dataBeforeProcessed;
	  },
	
	  /**
	   * Get base axis if has coordinate system and has axis.
	   * By default use coordSys.getBaseAxis();
	   * Can be overrided for some chart.
	   * @return {type} description
	   */
	  getBaseAxis: function () {
	    var coordSys = this.coordinateSystem;
	    return coordSys && coordSys.getBaseAxis && coordSys.getBaseAxis();
	  },
	  // FIXME
	
	  /**
	   * Default tooltip formatter
	   *
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   * @param {string} [renderMode='html'] valid values: 'html' and 'richText'.
	   *                                     'html' is used for rendering tooltip in extra DOM form, and the result
	   *                                     string is used as DOM HTML content.
	   *                                     'richText' is used for rendering tooltip in rich text form, for those where
	   *                                     DOM operation is not supported.
	   * @return {Object} formatted tooltip with `html` and `markers`
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var series = this;
	    renderMode = renderMode || 'html';
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    var isRichText = renderMode === 'richText';
	    var markers = {};
	    var markerId = 0;
	
	    function formatArrayValue(value) {
	      // ??? TODO refactor these logic.
	      // check: category-no-encode-has-axis-data in dataset.html
	      var vertially = zrUtil.reduce(value, function (vertially, val, idx) {
	        var dimItem = data.getDimensionInfo(idx);
	        return vertially |= dimItem && dimItem.tooltip !== false && dimItem.displayName != null;
	      }, 0);
	      var result = [];
	      tooltipDims.length ? zrUtil.each(tooltipDims, function (dim) {
	        setEachItem(retrieveRawValue(data, dataIndex, dim), dim);
	      }) // By default, all dims is used on tooltip.
	      : zrUtil.each(value, setEachItem);
	
	      function setEachItem(val, dim) {
	        var dimInfo = data.getDimensionInfo(dim); // If `dimInfo.tooltip` is not set, show tooltip.
	
	        if (!dimInfo || dimInfo.otherDims.tooltip === false) {
	          return;
	        }
	
	        var dimType = dimInfo.type;
	        var markName = 'sub' + series.seriesIndex + 'at' + markerId;
	        var dimHead = getTooltipMarker({
	          color: color,
	          type: 'subItem',
	          renderMode: renderMode,
	          markerId: markName
	        });
	        var dimHeadStr = typeof dimHead === 'string' ? dimHead : dimHead.content;
	        var valStr = (vertially ? dimHeadStr + encodeHTML(dimInfo.displayName || '-') + ': ' : '') + // FIXME should not format time for raw data?
	        encodeHTML(dimType === 'ordinal' ? val + '' : dimType === 'time' ? multipleSeries ? '' : formatTime('yyyy/MM/dd hh:mm:ss', val) : addCommas(val));
	        valStr && result.push(valStr);
	
	        if (isRichText) {
	          markers[markName] = color;
	          ++markerId;
	        }
	      }
	
	      var newLine = vertially ? isRichText ? '\n' : '<br/>' : '';
	      var content = newLine + result.join(newLine || ', ');
	      return {
	        renderMode: renderMode,
	        content: content,
	        style: markers
	      };
	    }
	
	    function formatSingleValue(val) {
	      // return encodeHTML(addCommas(val));
	      return {
	        renderMode: renderMode,
	        content: encodeHTML(addCommas(val)),
	        style: markers
	      };
	    }
	
	    var data = this.getData();
	    var tooltipDims = data.mapDimension('defaultedTooltip', true);
	    var tooltipDimLen = tooltipDims.length;
	    var value = this.getRawValue(dataIndex);
	    var isValueArr = zrUtil.isArray(value);
	    var color = data.getItemVisual(dataIndex, 'color');
	
	    if (zrUtil.isObject(color) && color.colorStops) {
	      color = (color.colorStops[0] || {}).color;
	    }
	
	    color = color || 'transparent'; // Complicated rule for pretty tooltip.
	
	    var formattedValue = tooltipDimLen > 1 || isValueArr && !tooltipDimLen ? formatArrayValue(value) : tooltipDimLen ? formatSingleValue(retrieveRawValue(data, dataIndex, tooltipDims[0])) : formatSingleValue(isValueArr ? value[0] : value);
	    var content = formattedValue.content;
	    var markName = series.seriesIndex + 'at' + markerId;
	    var colorEl = getTooltipMarker({
	      color: color,
	      type: 'item',
	      renderMode: renderMode,
	      markerId: markName
	    });
	    markers[markName] = color;
	    ++markerId;
	    var name = data.getName(dataIndex);
	    var seriesName = this.name;
	
	    if (!modelUtil.isNameSpecified(this)) {
	      seriesName = '';
	    }
	
	    seriesName = seriesName ? encodeHTML(seriesName) + (!multipleSeries ? newLine : ': ') : '';
	    var colorStr = typeof colorEl === 'string' ? colorEl : colorEl.content;
	    var html = !multipleSeries ? seriesName + colorStr + (name ? encodeHTML(name) + ': ' + content : content) : colorStr + seriesName + content;
	    return {
	      html: html,
	      markers: markers
	    };
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var animationEnabled = this.getShallow('animation');
	
	    if (animationEnabled) {
	      if (this.getData().count() > this.getShallow('animationThreshold')) {
	        animationEnabled = false;
	      }
	    }
	
	    return animationEnabled;
	  },
	  restoreData: function () {
	    this.dataTask.dirty();
	  },
	  getColorFromPalette: function (name, scope, requestColorNum) {
	    var ecModel = this.ecModel; // PENDING
	
	    var color = colorPaletteMixin.getColorFromPalette.call(this, name, scope, requestColorNum);
	
	    if (!color) {
	      color = ecModel.getColorFromPalette(name, scope, requestColorNum);
	    }
	
	    return color;
	  },
	
	  /**
	   * Use `data.mapDimension(coordDim, true)` instead.
	   * @deprecated
	   */
	  coordDimToDataDim: function (coordDim) {
	    return this.getRawData().mapDimension(coordDim, true);
	  },
	
	  /**
	   * Get progressive rendering count each step
	   * @return {number}
	   */
	  getProgressive: function () {
	    return this.get('progressive');
	  },
	
	  /**
	   * Get progressive rendering count each step
	   * @return {number}
	   */
	  getProgressiveThreshold: function () {
	    return this.get('progressiveThreshold');
	  },
	
	  /**
	   * Get data indices for show tooltip content. See tooltip.
	   * @abstract
	   * @param {Array.<string>|string} dim
	   * @param {Array.<number>} value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis
	   * @return {Object} {dataIndices, nestestValue}.
	   */
	  getAxisTooltipData: null,
	
	  /**
	   * See tooltip.
	   * @abstract
	   * @param {number} dataIndex
	   * @return {Array.<number>} Point of tooltip. null/undefined can be returned.
	   */
	  getTooltipPosition: null,
	
	  /**
	   * @see {module:echarts/stream/Scheduler}
	   */
	  pipeTask: null,
	
	  /**
	   * Convinient for override in extended class.
	   * @protected
	   * @type {Function}
	   */
	  preventIncremental: null,
	
	  /**
	   * @public
	   * @readOnly
	   * @type {Object}
	   */
	  pipelineContext: null
	});
	zrUtil.mixin(SeriesModel, dataFormatMixin);
	zrUtil.mixin(SeriesModel, colorPaletteMixin);
	/**
	 * MUST be called after `prepareSource` called
	 * Here we need to make auto series, especially for auto legend. But we
	 * do not modify series.name in option to avoid side effects.
	 */
	
	function autoSeriesName(seriesModel) {
	  // User specified name has higher priority, otherwise it may cause
	  // series can not be queried unexpectedly.
	  var name = seriesModel.name;
	
	  if (!modelUtil.isNameSpecified(seriesModel)) {
	    seriesModel.name = getSeriesAutoName(seriesModel) || name;
	  }
	}
	
	function getSeriesAutoName(seriesModel) {
	  var data = seriesModel.getRawData();
	  var dataDims = data.mapDimension('seriesName', true);
	  var nameArr = [];
	  zrUtil.each(dataDims, function (dataDim) {
	    var dimInfo = data.getDimensionInfo(dataDim);
	    dimInfo.displayName && nameArr.push(dimInfo.displayName);
	  });
	  return nameArr.join(' ');
	}
	
	function dataTaskCount(context) {
	  return context.model.getRawData().count();
	}
	
	function dataTaskReset(context) {
	  var seriesModel = context.model;
	  seriesModel.setData(seriesModel.getRawData().cloneShallow());
	  return dataTaskProgress;
	}
	
	function dataTaskProgress(param, context) {
	  // Avoid repead cloneShallow when data just created in reset.
	  if (context.outputData && param.end > context.outputData.count()) {
	    context.model.getRawData().cloneShallow(context.outputData);
	  }
	} // TODO refactor
	
	
	function wrapData(data, seriesModel) {
	  zrUtil.each(data.CHANGABLE_METHODS, function (methodName) {
	    data.wrapMethod(methodName, zrUtil.curry(onDataSelfChange, seriesModel));
	  });
	}
	
	function onDataSelfChange(seriesModel) {
	  var task = getCurrentTask(seriesModel);
	
	  if (task) {
	    // Consider case: filter, selectRange
	    task.setOutputEnd(this.count());
	  }
	}
	
	function getCurrentTask(seriesModel) {
	  var scheduler = (seriesModel.ecModel || {}).scheduler;
	  var pipeline = scheduler && scheduler.getPipeline(seriesModel.uid);
	
	  if (pipeline) {
	    // When pipline finished, the currrentTask keep the last
	    // task (renderTask).
	    var task = pipeline.currentTask;
	
	    if (task) {
	      var agentStubMap = task.agentStubMap;
	
	      if (agentStubMap) {
	        task = agentStubMap.get(seriesModel.uid);
	      }
	    }
	
	    return task;
	  }
	}
	
	var _default = SeriesModel;
	module.exports = _default;

/***/ },
/* 78 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.6.12' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 79 */
/***/ function(module, exports) {

	//
	
	module.exports = function shallowEqual(objA, objB, compare, compareContext) {
	  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
	
	  if (ret !== void 0) {
	    return !!ret;
	  }
	
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	
	  // Test for A's keys different from B.
	  for (var idx = 0; idx < keysA.length; idx++) {
	    var key = keysA[idx];
	
	    if (!bHasOwnProperty(key)) {
	      return false;
	    }
	
	    var valueA = objA[key];
	    var valueB = objB[key];
	
	    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
	
	    if (ret === false || (ret === void 0 && valueA !== valueB)) {
	      return false;
	    }
	  }
	
	  return true;
	};


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getExpendType = getExpendType;
	exports.expendType = expendType;
	
	var _dict = __webpack_require__(64);
	
	// 按模块的action, reducer整合体
	var EXPEND_TYPE = 'EXPEND_TYPE';
	
	function getExpendType() {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        type = _getState.expend_type;
	
	    if (type.length > 0) {
	      return dispatch({
	        type: EXPEND_TYPE,
	        data: type
	      });
	    }
	    return (0, _dict.queryDictExpend)().then(function (res) {
	      if (res.statusCode === 200) {
	        return dispatch({
	          type: EXPEND_TYPE,
	          data: res.data
	        });
	      }
	    });
	  };
	}
	
	function expendType() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case EXPEND_TYPE:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _default = _interopRequireDefault(__webpack_require__(1285));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var LocaleReceiver = /*#__PURE__*/function (_React$Component) {
	  _inherits(LocaleReceiver, _React$Component);
	
	  var _super = _createSuper(LocaleReceiver);
	
	  function LocaleReceiver() {
	    _classCallCheck(this, LocaleReceiver);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(LocaleReceiver, [{
	    key: "getLocale",
	    value: function getLocale() {
	      var _this$props = this.props,
	          componentName = _this$props.componentName,
	          defaultLocale = _this$props.defaultLocale;
	      var locale = defaultLocale || _default["default"][componentName || 'global'];
	      var antLocale = this.context.antLocale;
	      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
	      return _extends(_extends({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
	    }
	  }, {
	    key: "getLocaleCode",
	    value: function getLocaleCode() {
	      var antLocale = this.context.antLocale;
	      var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale
	
	      if (antLocale && antLocale.exist && !localeCode) {
	        return _default["default"].locale;
	      }
	
	      return localeCode;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children(this.getLocale(), this.getLocaleCode(), this.context.antLocale);
	    }
	  }]);
	
	  return LocaleReceiver;
	}(React.Component);
	
	exports["default"] = LocaleReceiver;
	LocaleReceiver.defaultProps = {
	  componentName: 'global'
	};
	LocaleReceiver.contextTypes = {
	  antLocale: PropTypes.object
	};

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _talk = __webpack_require__(1399);
	
	var _Editor = __webpack_require__(682);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _CommentItem = __webpack_require__(1511);
	
	var _CommentItem2 = _interopRequireDefault(_CommentItem);
	
	__webpack_require__(2957);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, App);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      comments: [],
	      submitting: false
	    }, _this.getTalkList = function () {
	      if (_this.itemUuid) {
	        (0, _talk.queryTalkList)({
	          itemUuid: _this.itemUuid
	        }).then(function (res) {
	          if (res.statusCode === 200) {
	            _this.setState({
	              comments: res.data
	            });
	          }
	        });
	      }
	    }, _this.postTalk = function (params) {
	      if (!params.content) {
	        _antd.message.warn('请输入评论内容');
	        return;
	      }
	      if (!params.replyUuid) {
	        _this.setState({
	          submitting: true
	        });
	      }
	      (0, _talk.querySaveTalk)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.getTalkList();
	          if (params.replyUuid) {
	            var submits = {};
	            submits[params.replyUuid] = false;
	          } else {
	            _this.reply.talk = {};
	            _this.setState({
	              submitting: false
	            });
	          }
	        }
	      });
	    }, _this.reply = {}, _this.handleSubmit = function (replyUuid) {
	      return function () {
	        _this.reply[replyUuid] = _this.reply[replyUuid] || {};
	        _this.postTalk({
	          itemUuid: _this.itemUuid,
	          content: _this.reply[replyUuid].content,
	          atUuids: _this.reply[replyUuid].atUuids,
	          type: _this.props.target.type
	        });
	      };
	    }, _this.handleSubmitReply = function (record) {
	      return function () {
	        _this.reply[record.uuid] = _this.reply[record.uuid] || {};
	        _this.postTalk({
	          itemUuid: _this.itemUuid,
	          content: _this.reply[record.uuid].content,
	          atUuids: _this.reply[record.uuid].atUuids,
	          type: _this.props.target.type,
	          replyUuid: record.uuid,
	          toName: record.fromName,
	          toUuid: record.fromUuid
	        });
	      };
	    }, _this.handleChange = function (uuid) {
	      return function (e) {
	        _this.reply[uuid] = _this.reply[uuid] || {};
	        _this.reply[uuid].content = e.target.value;
	      };
	    }, _this.handleMention = function (uuid) {
	      return function (e) {
	        _this.reply[uuid] = _this.reply[uuid] || {};
	        _this.reply[uuid].atUuids = e;
	      };
	    }, _this.handleReply = function (uuid) {
	      var comments = _this.state.comments;
	
	      _this.reply[uuid] = '';
	      _this.loopFindUuid(comments, uuid);
	      _this.setState({
	        comments: comments
	      });
	    }, _this.loopFindUuid = function (data, key) {
	      data.map(function (item) {
	        if (item.uuid === key) {
	          item.isReply = !item.isReply;
	        } else if (item.children) {
	          _this.loopFindUuid(item.children, key);
	        }
	        return item;
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(App, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.itemUuid = this.props.target.uuid;
	      this.getTalkList();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.itemUuid !== nextProps.target.uuid) {
	        this.itemUuid = nextProps.target.uuid;
	        this.getTalkList();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          comments = _state.comments,
	          submitting = _state.submitting;
	
	      var loopComments = function loopComments(data) {
	        return data.map(function (item) {
	          var parentProps = Object.assign({}, item, {
	            onSubmit: _this2.handleSubmitReply(item),
	            submitting: submitting,
	            onChange: _this2.handleChange(item.uuid),
	            onMention: _this2.handleMention(item.uuid),
	            isReply: item.isReply,
	            handleReply: _this2.handleReply
	          });
	          return _react2.default.createElement(_CommentItem2.default, Object.assign({}, parentProps, { key: item.uuid }));
	        });
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        { className: 'comment-list-box' },
	        _react2.default.createElement(_Editor2.default, {
	          onChange: this.handleChange('talk'),
	          onMention: this.handleMention('talk'),
	          onSubmit: this.handleSubmit('talk'),
	          submitting: submitting,
	          placeholder: '\u8F93\u5165\u8BC4\u8BBA'
	        }),
	        loopComments(comments)
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Modalshortfalls = function (_Component) {
	  _inherits(Modalshortfalls, _Component);
	
	  function Modalshortfalls(props) {
	    _classCallCheck(this, Modalshortfalls);
	
	    var _this = _possibleConstructorReturn(this, (Modalshortfalls.__proto__ || Object.getPrototypeOf(Modalshortfalls)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Modalshortfalls, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	      var _props = this.props,
	          visible = _props.visible,
	          hideModal = _props.hideModal;
	
	      data = data.split('\n');
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: _react2.default.createElement(
	            'p',
	            { style: { margin: '0' } },
	            _react2.default.createElement(_antd.Icon, { type: 'close-circle', style: { color: 'red', marginRight: '10px' } }),
	            '\u9884\u7B97\u4E0D\u8DB3\uFF01'
	          ),
	          visible: visible,
	          footer: null,
	          onCancel: hideModal,
	          width: '40%'
	        },
	        _react2.default.createElement(
	          'p',
	          { style: { fontSize: '14px' } },
	          '\u8BF7\u8054\u7CFB\u4EE5\u4E0B\u9884\u7B97\u7EC4\u8D1F\u8D23\u4EBA\u8C03\u6574\u9884\u7B97'
	        ),
	        _react2.default.createElement(
	          'ul',
	          null,
	          data ? data.map(function (item) {
	            return _react2.default.createElement(
	              'li',
	              { key: item },
	              item
	            );
	          }) : null
	        )
	      );
	    }
	  }]);
	
	  return Modalshortfalls;
	}(_react.Component);
	
	exports.default = Modalshortfalls;

/***/ },
/* 84 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 86 */
/***/ function(module, exports) {

	/**
	 * 3x2矩阵操作类
	 * @exports zrender/tool/matrix
	 */
	
	/* global Float32Array */
	var ArrayCtor = typeof Float32Array === 'undefined' ? Array : Float32Array;
	/**
	 * Create a identity matrix.
	 * @return {Float32Array|Array.<number>}
	 */
	
	function create() {
	  var out = new ArrayCtor(6);
	  identity(out);
	  return out;
	}
	/**
	 * 设置矩阵为单位矩阵
	 * @param {Float32Array|Array.<number>} out
	 */
	
	
	function identity(out) {
	  out[0] = 1;
	  out[1] = 0;
	  out[2] = 0;
	  out[3] = 1;
	  out[4] = 0;
	  out[5] = 0;
	  return out;
	}
	/**
	 * 复制矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m
	 */
	
	
	function copy(out, m) {
	  out[0] = m[0];
	  out[1] = m[1];
	  out[2] = m[2];
	  out[3] = m[3];
	  out[4] = m[4];
	  out[5] = m[5];
	  return out;
	}
	/**
	 * 矩阵相乘
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} m1
	 * @param {Float32Array|Array.<number>} m2
	 */
	
	
	function mul(out, m1, m2) {
	  // Consider matrix.mul(m, m2, m);
	  // where out is the same as m2.
	  // So use temp variable to escape error.
	  var out0 = m1[0] * m2[0] + m1[2] * m2[1];
	  var out1 = m1[1] * m2[0] + m1[3] * m2[1];
	  var out2 = m1[0] * m2[2] + m1[2] * m2[3];
	  var out3 = m1[1] * m2[2] + m1[3] * m2[3];
	  var out4 = m1[0] * m2[4] + m1[2] * m2[5] + m1[4];
	  var out5 = m1[1] * m2[4] + m1[3] * m2[5] + m1[5];
	  out[0] = out0;
	  out[1] = out1;
	  out[2] = out2;
	  out[3] = out3;
	  out[4] = out4;
	  out[5] = out5;
	  return out;
	}
	/**
	 * 平移变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function translate(out, a, v) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  out[4] = a[4] + v[0];
	  out[5] = a[5] + v[1];
	  return out;
	}
	/**
	 * 旋转变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {number} rad
	 */
	
	
	function rotate(out, a, rad) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var st = Math.sin(rad);
	  var ct = Math.cos(rad);
	  out[0] = aa * ct + ab * st;
	  out[1] = -aa * st + ab * ct;
	  out[2] = ac * ct + ad * st;
	  out[3] = -ac * st + ct * ad;
	  out[4] = ct * atx + st * aty;
	  out[5] = ct * aty - st * atx;
	  return out;
	}
	/**
	 * 缩放变换
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 * @param {Float32Array|Array.<number>} v
	 */
	
	
	function scale(out, a, v) {
	  var vx = v[0];
	  var vy = v[1];
	  out[0] = a[0] * vx;
	  out[1] = a[1] * vy;
	  out[2] = a[2] * vx;
	  out[3] = a[3] * vy;
	  out[4] = a[4] * vx;
	  out[5] = a[5] * vy;
	  return out;
	}
	/**
	 * 求逆矩阵
	 * @param {Float32Array|Array.<number>} out
	 * @param {Float32Array|Array.<number>} a
	 */
	
	
	function invert(out, a) {
	  var aa = a[0];
	  var ac = a[2];
	  var atx = a[4];
	  var ab = a[1];
	  var ad = a[3];
	  var aty = a[5];
	  var det = aa * ad - ab * ac;
	
	  if (!det) {
	    return null;
	  }
	
	  det = 1.0 / det;
	  out[0] = ad * det;
	  out[1] = -ab * det;
	  out[2] = -ac * det;
	  out[3] = aa * det;
	  out[4] = (ac * aty - ad * atx) * det;
	  out[5] = (ab * atx - aa * aty) * det;
	  return out;
	}
	/**
	 * Clone a new matrix.
	 * @param {Float32Array|Array.<number>} a
	 */
	
	
	function clone(a) {
	  var b = create();
	  copy(b, a);
	  return b;
	}
	
	exports.create = create;
	exports.identity = identity;
	exports.copy = copy;
	exports.mul = mul;
	exports.translate = translate;
	exports.rotate = rotate;
	exports.scale = scale;
	exports.invert = invert;
	exports.clone = clone;

/***/ },
/* 87 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.tupleNum = exports.tuple = void 0;
	
	// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
	var tuple = function tuple() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  return args;
	};
	
	exports.tuple = tuple;
	
	var tupleNum = function tupleNum() {
	  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  return args;
	};
	
	exports.tupleNum = tupleNum;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _required = __webpack_require__(656);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _whitespace = __webpack_require__(1382);
	
	var _whitespace2 = _interopRequireDefault(_whitespace);
	
	var _type = __webpack_require__(1381);
	
	var _type2 = _interopRequireDefault(_type);
	
	var _range = __webpack_require__(1380);
	
	var _range2 = _interopRequireDefault(_range);
	
	var _enum = __webpack_require__(1378);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(1379);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  required: _required2['default'],
	  whitespace: _whitespace2['default'],
	  type: _type2['default'],
	  range: _range2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default']
	};
	module.exports = exports['default'];

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryExportContract = exports.queryRefuseContract = exports.queryCheckContract = exports.queryAllotApplyContract = exports.queryApplyContractList = exports.querySaveApplyContract = exports.queryRecycleContract = exports.queryRestoreContract = exports.queryLostContract = exports.queryInvalidContract = exports.queryTransferContractRefuse = exports.queryTransferContractConfirm = exports.queryTransferContract = exports.queryAllotContract = exports.queryUseContract = exports.queryDeleteRole = exports.queryDeleteContract = exports.queryBatchSaveContract = exports.querySaveContract = exports.queryContractLog = exports.queryContractType = exports.queryContractList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 合同列表
	 */
	var queryContractList = exports.queryContractList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt("return", _http2.default.get(_req.xxcrm.CONTRACT_LIST, params));
	
	          case 1:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryContractList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取合同类型
	 */
	
	
	var queryContractType = exports.queryContractType = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt("return", _http2.default.get(_req.xxcrm.CONTRACT_TYPE));
	
	          case 1:
	          case "end":
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryContractType() {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取操作日志
	 */
	
	
	var queryContractLog = exports.queryContractLog = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(uuid) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt("return", _http2.default.get(_req.xxcrm.CONTRACT_LOG, { contractUuid: uuid }));
	
	          case 1:
	          case "end":
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryContractLog(_x2) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	/**
	 * 添加合同
	 */
	
	
	var querySaveContract = exports.querySaveContract = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_SAVE, params));
	
	          case 1:
	          case "end":
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function querySaveContract(_x3) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	/**
	 * 批量添加合同
	 */
	
	
	var queryBatchSaveContract = exports.queryBatchSaveContract = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_BATCHSAVE, params));
	
	          case 1:
	          case "end":
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryBatchSaveContract(_x4) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	/**
	 * 删除合同
	 */
	
	
	var queryDeleteContract = exports.queryDeleteContract = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(uuid) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt("return", _http2.default.get(_req.xxcrm.CONTRACT_DELETE, { uuids: uuid }));
	
	          case 1:
	          case "end":
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryDeleteContract(_x5) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	/**
	 * 角色删除
	 */
	
	
	var queryDeleteRole = exports.queryDeleteRole = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(uuid) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt("return", _http2.default.get(_req.xxcrm.CONTRACT_DELETE, { uuid: uuid }));
	
	          case 1:
	          case "end":
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryDeleteRole(_x6) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	/**
	 * 使用合同
	 */
	
	
	var queryUseContract = exports.queryUseContract = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_USE, params));
	
	          case 1:
	          case "end":
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryUseContract(_x7) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	/**
	 * 分配合同
	 */
	
	
	var queryAllotContract = exports.queryAllotContract = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_ALLOT, params));
	
	          case 1:
	          case "end":
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryAllotContract(_x8) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	/**
	 * 转移合同
	 */
	
	
	var queryTransferContract = exports.queryTransferContract = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_TRANSFER, params));
	
	          case 1:
	          case "end":
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryTransferContract(_x9) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	/**
	 * 转移合同确认
	 */
	
	var queryTransferContractConfirm = exports.queryTransferContractConfirm = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_TRANSFER_CONFIRM, params));
	
	          case 1:
	          case "end":
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryTransferContractConfirm(_x10) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	/**
	 * 转移合同拒绝
	 */
	
	
	var queryTransferContractRefuse = exports.queryTransferContractRefuse = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_TRANSFER_REFUSE, params));
	
	          case 1:
	          case "end":
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryTransferContractRefuse(_x11) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	/**
	 * 作废合同
	 */
	
	
	var queryInvalidContract = exports.queryInvalidContract = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_INVALID, params));
	
	          case 1:
	          case "end":
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryInvalidContract(_x12) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	/**
	 * 遗失合同
	 */
	
	
	var queryLostContract = exports.queryLostContract = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_LOST, params));
	
	          case 1:
	          case "end":
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryLostContract(_x13) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	/**
	 * 恢复合同
	 */
	
	
	var queryRestoreContract = exports.queryRestoreContract = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(uuids) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_RESTORE, { uuids: uuids }));
	
	          case 1:
	          case "end":
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function queryRestoreContract(_x14) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	/**
	 * 回收合同
	 */
	
	
	var queryRecycleContract = exports.queryRecycleContract = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(uuids) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            return _context16.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_RECYCLE, { uuids: uuids }));
	
	          case 1:
	          case "end":
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function queryRecycleContract(_x15) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	/**
	 * 合同申请
	 */
	
	
	var querySaveApplyContract = exports.querySaveApplyContract = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(params) {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            return _context17.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_APPLY_SAVE, params));
	
	          case 1:
	          case "end":
	            return _context17.stop();
	        }
	      }
	    }, _callee17, this);
	  }));
	
	  return function querySaveApplyContract(_x16) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	
	/**
	 * 合同申请列表
	 */
	
	
	var queryApplyContractList = exports.queryApplyContractList = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(params) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            return _context18.abrupt("return", _http2.default.get(_req.xxcrm.CONTRACT_APPLY_LIST, params));
	
	          case 1:
	          case "end":
	            return _context18.stop();
	        }
	      }
	    }, _callee18, this);
	  }));
	
	  return function queryApplyContractList(_x17) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	
	/**
	 * 分配合同申请的合同
	 */
	
	
	var queryAllotApplyContract = exports.queryAllotApplyContract = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(params) {
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            return _context19.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_APPLY_ALLOT, params));
	
	          case 1:
	          case "end":
	            return _context19.stop();
	        }
	      }
	    }, _callee19, this);
	  }));
	
	  return function queryAllotApplyContract(_x18) {
	    return _ref19.apply(this, arguments);
	  };
	}();
	
	/**
	 * 同意合同申请
	 */
	
	
	var queryCheckContract = exports.queryCheckContract = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(params) {
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            return _context20.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_CHECK, params));
	
	          case 1:
	          case "end":
	            return _context20.stop();
	        }
	      }
	    }, _callee20, this);
	  }));
	
	  return function queryCheckContract(_x19) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	/**
	 * 拒绝合同申请
	 */
	
	
	var queryRefuseContract = exports.queryRefuseContract = function () {
	  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(params) {
	    return _regenerator2.default.wrap(function _callee21$(_context21) {
	      while (1) {
	        switch (_context21.prev = _context21.next) {
	          case 0:
	            return _context21.abrupt("return", _http2.default.post(_req.xxcrm.CONTRACT_REFUSE, params));
	
	          case 1:
	          case "end":
	            return _context21.stop();
	        }
	      }
	    }, _callee21, this);
	  }));
	
	  return function queryRefuseContract(_x20) {
	    return _ref21.apply(this, arguments);
	  };
	}();
	
	/**
	 * 导出合同
	 */
	
	
	var queryExportContract = exports.queryExportContract = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22(params) {
	    return _regenerator2.default.wrap(function _callee22$(_context22) {
	      while (1) {
	        switch (_context22.prev = _context22.next) {
	          case 0:
	            _http2.default.download(_req.xxcrm.CONTRACT_EXPORT, params, '合同导出.xlsx');
	
	          case 1:
	          case "end":
	            return _context22.stop();
	        }
	      }
	    }, _callee22, this);
	  }));
	
	  return function queryExportContract(_x21) {
	    return _ref22.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var dateFormat = 'YYYY-MM-DD';
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.onChange = function (e) {
	      _this.props.onChange(e.target.value);
	    };
	
	    _this.onSearch = function (e) {
	      var data = _this.props.form.getFieldsValue();
	      var params = {};
	      var date = data.date;
	
	      if (date) {
	        params = {
	          beginDate: (0, _moment2.default)(date[0]).format('YYYY-MM-DD'),
	          endDate: (0, _moment2.default)(date[1]).format('YYYY-MM-DD')
	        };
	      }
	      params = Object.assign({}, params, {
	        condition: data.condition || ''
	      });
	      _this.props.onSearch(params);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'render',
	
	
	    // onReset = () => {
	    //   this.props.form.resetFields();
	    //   this.onSearch();
	    // };
	
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expense-search-form' },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: this.props.condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('date', {
	              initialValue: this.props.beginDate ? [(0, _moment2.default)(this.props.beginDate, dateFormat), (0, _moment2.default)(this.props.endDate, dateFormat)] : null
	            })(_react2.default.createElement(RangePicker, { format: dateFormat, allowClear: false }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: this.onSearch },
	              '\u641C\u7D22'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var Description = function Description(_ref) {
	  var term = _ref.term,
	      children = _ref.children,
	      _ref$col = _ref.col,
	      col = _ref$col === undefined ? 8 : _ref$col,
	      rest = _objectWithoutProperties(_ref, ["term", "children", "col"]);
	
	  return _react2.default.createElement(
	    _antd.Col,
	    { span: col },
	    _react2.default.createElement(
	      "span",
	      { className: "title" },
	      term,
	      "\uFF1A"
	    ),
	    _react2.default.createElement(
	      "span",
	      null,
	      children && children !== "0" ? children : ""
	    )
	  );
	};
	
	exports.default = Description;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftModifier
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(100);
	var ContentStateInlineStyle = __webpack_require__(2135);
	var DraftFeatureFlags = __webpack_require__(176);
	var Immutable = __webpack_require__(39);
	
	var applyEntityToContentState = __webpack_require__(2154);
	var getCharacterRemovalRange = __webpack_require__(2175);
	var getContentStateFragment = __webpack_require__(351);
	var insertFragmentIntoContentState = __webpack_require__(2180);
	var insertTextIntoContentState = __webpack_require__(2181);
	var invariant = __webpack_require__(18);
	var modifyBlockForContentState = __webpack_require__(2192);
	var removeEntitiesAtEdges = __webpack_require__(816);
	var removeRangeFromContentState = __webpack_require__(2194);
	var splitBlockInContentState = __webpack_require__(2196);
	
	var OrderedSet = Immutable.OrderedSet;
	
	/**
	 * `DraftModifier` provides a set of convenience methods that apply
	 * modifications to a `ContentState` object based on a target `SelectionState`.
	 *
	 * Any change to a `ContentState` should be decomposable into a series of
	 * transaction functions that apply the required changes and return output
	 * `ContentState` objects.
	 *
	 * These functions encapsulate some of the most common transaction sequences.
	 */
	
	var DraftModifier = {
	  replaceText: function replaceText(contentState, rangeToReplace, text, inlineStyle, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, rangeToReplace);
	    var withoutText = removeRangeFromContentState(withoutEntities, rangeToReplace);
	
	    var character = CharacterMetadata.create({
	      style: inlineStyle || OrderedSet(),
	      entity: entityKey || null
	    });
	
	    return insertTextIntoContentState(withoutText, withoutText.getSelectionAfter(), text, character);
	  },
	
	  insertText: function insertText(contentState, targetRange, text, inlineStyle, entityKey) {
	    !targetRange.isCollapsed() ?  false ? invariant(false, 'Target range must be collapsed for `insertText`.') : invariant(false) : void 0;
	    return DraftModifier.replaceText(contentState, targetRange, text, inlineStyle, entityKey);
	  },
	
	  moveText: function moveText(contentState, removalRange, targetRange) {
	    var movedFragment = getContentStateFragment(contentState, removalRange);
	
	    var afterRemoval = DraftModifier.removeRange(contentState, removalRange, 'backward');
	
	    return DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	  },
	
	  replaceWithFragment: function replaceWithFragment(contentState, targetRange, fragment) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, targetRange);
	    var withoutText = removeRangeFromContentState(withoutEntities, targetRange);
	
	    return insertFragmentIntoContentState(withoutText, withoutText.getSelectionAfter(), fragment);
	  },
	
	  removeRange: function removeRange(contentState, rangeToRemove, removalDirection) {
	    var startKey = void 0,
	        endKey = void 0,
	        startBlock = void 0,
	        endBlock = void 0;
	    if (rangeToRemove.getIsBackward()) {
	      rangeToRemove = rangeToRemove.merge({
	        anchorKey: rangeToRemove.getFocusKey(),
	        anchorOffset: rangeToRemove.getFocusOffset(),
	        focusKey: rangeToRemove.getAnchorKey(),
	        focusOffset: rangeToRemove.getAnchorOffset(),
	        isBackward: false
	      });
	    }
	    startKey = rangeToRemove.getAnchorKey();
	    endKey = rangeToRemove.getFocusKey();
	    startBlock = contentState.getBlockForKey(startKey);
	    endBlock = contentState.getBlockForKey(endKey);
	    var startOffset = rangeToRemove.getStartOffset();
	    var endOffset = rangeToRemove.getEndOffset();
	
	    var startEntityKey = startBlock.getEntityAt(startOffset);
	    var endEntityKey = endBlock.getEntityAt(endOffset - 1);
	
	    // Check whether the selection state overlaps with a single entity.
	    // If so, try to remove the appropriate substring of the entity text.
	    if (startKey === endKey) {
	      if (startEntityKey && startEntityKey === endEntityKey) {
	        var _adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
	        return removeRangeFromContentState(contentState, _adjustedRemovalRange);
	      }
	    }
	    var adjustedRemovalRange = rangeToRemove;
	    if (DraftFeatureFlags.draft_segmented_entities_behavior) {
	      // Adjust the selection to properly delete segemented and immutable
	      // entities
	      adjustedRemovalRange = getCharacterRemovalRange(contentState.getEntityMap(), startBlock, endBlock, rangeToRemove, removalDirection);
	    }
	
	    var withoutEntities = removeEntitiesAtEdges(contentState, adjustedRemovalRange);
	    return removeRangeFromContentState(withoutEntities, adjustedRemovalRange);
	  },
	
	  splitBlock: function splitBlock(contentState, selectionState) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    var withoutText = removeRangeFromContentState(withoutEntities, selectionState);
	
	    return splitBlockInContentState(withoutText, withoutText.getSelectionAfter());
	  },
	
	  applyInlineStyle: function applyInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.add(contentState, selectionState, inlineStyle);
	  },
	
	  removeInlineStyle: function removeInlineStyle(contentState, selectionState, inlineStyle) {
	    return ContentStateInlineStyle.remove(contentState, selectionState, inlineStyle);
	  },
	
	  setBlockType: function setBlockType(contentState, selectionState, blockType) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ type: blockType, depth: 0 });
	    });
	  },
	
	  setBlockData: function setBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: blockData });
	    });
	  },
	
	  mergeBlockData: function mergeBlockData(contentState, selectionState, blockData) {
	    return modifyBlockForContentState(contentState, selectionState, function (block) {
	      return block.merge({ data: block.getData().merge(blockData) });
	    });
	  },
	
	  applyEntity: function applyEntity(contentState, selectionState, entityKey) {
	    var withoutEntities = removeEntitiesAtEdges(contentState, selectionState);
	    return applyEntityToContentState(withoutEntities, selectionState, entityKey);
	  }
	};
	
	module.exports = DraftModifier;

/***/ },
/* 93 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var __DEV__ = ("production") !== 'production';
	
	var warning = function() {};
	
	if (__DEV__) {
	  var printWarning = function printWarning(format, args) {
	    var len = arguments.length;
	    args = new Array(len > 1 ? len - 1 : 0);
	    for (var key = 1; key < len; key++) {
	      args[key - 1] = arguments[key];
	    }
	    var argIndex = 0;
	    var message = 'Warning: ' +
	      format.replace(/%s/g, function() {
	        return args[argIndex++];
	      });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  }
	
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	          '`warning(condition, format, ...args)` requires a warning ' +
	          'message argument'
	      );
	    }
	    if (!condition) {
	      printWarning.apply(null, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var CompanySearch = function (_Component) {
	  _inherits(CompanySearch, _Component);
	
	  function CompanySearch(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, CompanySearch);
	
	    var _this = _possibleConstructorReturn(this, (CompanySearch.__proto__ || Object.getPrototypeOf(CompanySearch)).call(this, props));
	
	    _this.onSelect = function (e) {
	      _this.setState({
	        companyUuid: e
	      });
	    };
	
	    _this.handleSearch = function (value) {
	      _this.getOrgCompanyList(value);
	    };
	
	    _this.getOrgCompanyList = function (value) {
	      (0, _org.queryOrgCompanyList)({
	        condition: value || ''
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            companyList: res.data
	          });
	        }
	      });
	    };
	
	    _this.setDefaultOrgCompanyList = function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(value, uuid) {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return _this.getOrgCompanyList();
	
	              case 2:
	                (0, _org.queryOrgCompanyList)({
	                  condition: value || ''
	                }).then(function (res) {
	                  var companyList = _this.state.companyList;
	
	                  if (res.statusCode === 200 && res.data.length > 0) {
	                    var companyUuid = uuid || res.data[0].uuid;
	                    res.data.map(function (item) {
	                      companyList.every(function (it) {
	                        return item.uuid !== it.uuid;
	                      }) && companyList.push(item);
	                      return item;
	                    });
	                    _this.setState({
	                      companyList: companyList,
	                      companyUuid: companyUuid
	                    });
	                  }
	                });
	
	              case 3:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, _this2);
	      }));
	
	      return function (_x, _x2) {
	        return _ref.apply(this, arguments);
	      };
	    }();
	
	    _this.state = {
	      companyList: [],
	      companyUuid: ''
	    };
	    return _this;
	  }
	
	  _createClass(CompanySearch, [{
	    key: 'componentDidMount',
	    value: function () {
	      var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	        var _props, companyName, companyUuid;
	
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _props = this.props, companyName = _props.companyName, companyUuid = _props.companyUuid;
	
	                companyName ? this.setDefaultOrgCompanyList(companyName, companyUuid) : this.getOrgCompanyList();
	
	              case 2:
	              case 'end':
	                return _context2.stop();
	            }
	          }
	        }, _callee2, this);
	      }));
	
	      function componentDidMount() {
	        return _ref2.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.companyName !== this.props.companyName) {
	        var companyName = nextProps.companyName,
	            companyUuid = nextProps.companyUuid;
	
	        companyName ? this.setDefaultOrgCompanyList(companyName, companyUuid) : this.setState({
	          companyUuid: ''
	        });
	      }
	    }
	
	    // 正常公司列表
	
	
	    // 用于做默认值的公司列表
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var companyList = this.state.companyList;
	
	      return _react2.default.createElement(
	        _antd.Select,
	        {
	          onChange: this.props.onChange,
	          onSelect: this.onSelect,
	          showSearch: true,
	          filterOption: false,
	          onSearch: this.handleSearch,
	          value: this.state.companyUuid,
	          placeholder: '\u8BF7\u641C\u7D22\u516C\u53F8\u540D\u79F0'
	        },
	        companyList.map(function (item) {
	          return _react2.default.createElement(
	            Option,
	            { key: item.uuid, value: item.uuid },
	            item.name
	          );
	        })
	      );
	    }
	  }]);
	
	  return CompanySearch;
	}(_react.Component);
	
	exports.default = CompanySearch;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getCompanyList = getCompanyList;
	exports.companyList = companyList;
	
	var _org = __webpack_require__(53);
	
	// 按模块的action, reducer整合体
	var COMPANY_LIST = 'COMPANY_LIST';
	
	function getCompanyList() {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        list = _getState.company_list;
	
	    if (list.length > 0) {
	      return dispatch({
	        type: COMPANY_LIST,
	        data: list
	      });
	    }
	    return (0, _org.queryOrgCompanyList)({
	      type: 1
	    }).then(function (res) {
	      if (res.statusCode === 200) {
	        return dispatch({
	          type: COMPANY_LIST,
	          data: res.data
	        });
	      }
	    });
	  };
	}
	
	function companyList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case COMPANY_LIST:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 97 */
[3012, 69, 202, 65],
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(42);
	var hide = __webpack_require__(97);
	var has = __webpack_require__(104);
	var SRC = __webpack_require__(206)('src');
	var $toString = __webpack_require__(1931);
	var TO_STRING = 'toString';
	var TPL = ('' + $toString).split(TO_STRING);
	
	__webpack_require__(117).inspectSource = function (it) {
	  return $toString.call(it);
	};
	
	(module.exports = function (O, key, val, safe) {
	  var isFunction = typeof val == 'function';
	  if (isFunction) has(val, 'name') || hide(val, 'name', key);
	  if (O[key] === val) return;
	  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	  if (O === global) {
	    O[key] = val;
	  } else if (!safe) {
	    delete O[key];
	    hide(O, key, val);
	  } else if (O[key]) {
	    O[key] = val;
	  } else {
	    hide(O, key, val);
	  }
	// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	})(Function.prototype, TO_STRING, function toString() {
	  return typeof this == 'function' && this[SRC] || $toString.call(this);
	});


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var fails = __webpack_require__(43);
	var defined = __webpack_require__(136);
	var quot = /"/g;
	// B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	var createHTML = function (string, tag, attribute, value) {
	  var S = String(defined(string));
	  var p1 = '<' + tag;
	  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	  return p1 + '>' + S + '</' + tag + '>';
	};
	module.exports = function (NAME, exec) {
	  var O = {};
	  O[NAME] = exec(createHTML);
	  $export($export.P + $export.F * fails(function () {
	    var test = ''[NAME]('"');
	    return test !== test.toLowerCase() || test.split('"').length > 3;
	  }), 'String', O);
	};


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CharacterMetadata
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var _require = __webpack_require__(39),
	    Map = _require.Map,
	    OrderedSet = _require.OrderedSet,
	    Record = _require.Record;
	
	// Immutable.map is typed such that the value for every key in the map
	// must be the same type
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  style: EMPTY_SET,
	  entity: null
	};
	
	var CharacterMetadataRecord = Record(defaultRecord);
	
	var CharacterMetadata = function (_CharacterMetadataRec) {
	  _inherits(CharacterMetadata, _CharacterMetadataRec);
	
	  function CharacterMetadata() {
	    _classCallCheck(this, CharacterMetadata);
	
	    return _possibleConstructorReturn(this, _CharacterMetadataRec.apply(this, arguments));
	  }
	
	  CharacterMetadata.prototype.getStyle = function getStyle() {
	    return this.get('style');
	  };
	
	  CharacterMetadata.prototype.getEntity = function getEntity() {
	    return this.get('entity');
	  };
	
	  CharacterMetadata.prototype.hasStyle = function hasStyle(style) {
	    return this.getStyle().includes(style);
	  };
	
	  CharacterMetadata.applyStyle = function applyStyle(record, style) {
	    var withStyle = record.set('style', record.getStyle().add(style));
	    return CharacterMetadata.create(withStyle);
	  };
	
	  CharacterMetadata.removeStyle = function removeStyle(record, style) {
	    var withoutStyle = record.set('style', record.getStyle().remove(style));
	    return CharacterMetadata.create(withoutStyle);
	  };
	
	  CharacterMetadata.applyEntity = function applyEntity(record, entityKey) {
	    var withEntity = record.getEntity() === entityKey ? record : record.set('entity', entityKey);
	    return CharacterMetadata.create(withEntity);
	  };
	
	  /**
	   * Use this function instead of the `CharacterMetadata` constructor.
	   * Since most content generally uses only a very small number of
	   * style/entity permutations, we can reuse these objects as often as
	   * possible.
	   */
	
	
	  CharacterMetadata.create = function create(config) {
	    if (!config) {
	      return EMPTY;
	    }
	
	    var defaultConfig = {
	      style: EMPTY_SET,
	      entity: null
	    };
	
	    // Fill in unspecified properties, if necessary.
	    var configMap = Map(defaultConfig).merge(config);
	
	    var existing = pool.get(configMap);
	    if (existing) {
	      return existing;
	    }
	
	    var newCharacter = new CharacterMetadata(configMap);
	    pool = pool.set(configMap, newCharacter);
	    return newCharacter;
	  };
	
	  return CharacterMetadata;
	}(CharacterMetadataRecord);
	
	var EMPTY = new CharacterMetadata();
	var pool = Map([[Map(defaultRecord), EMPTY]]);
	
	CharacterMetadata.EMPTY = EMPTY;
	
	module.exports = CharacterMetadata;

/***/ },
/* 101 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	var BoundingRect = __webpack_require__(60);
	
	var imageHelper = __webpack_require__(604);
	
	var _util = __webpack_require__(4);
	
	var getContext = _util.getContext;
	var extend = _util.extend;
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var trim = _util.trim;
	var textWidthCache = {};
	var textWidthCacheCounter = 0;
	var TEXT_CACHE_MAX = 5000;
	var STYLE_REG = /\{([a-zA-Z0-9_]+)\|([^}]*)\}/g;
	var DEFAULT_FONT = '12px sans-serif'; // Avoid assign to an exported variable, for transforming to cjs.
	
	var methods = {};
	
	function $override(name, fn) {
	  methods[name] = fn;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {number} width
	 */
	
	
	function getWidth(text, font) {
	  font = font || DEFAULT_FONT;
	  var key = text + ':' + font;
	
	  if (textWidthCache[key]) {
	    return textWidthCache[key];
	  }
	
	  var textLines = (text + '').split('\n');
	  var width = 0;
	
	  for (var i = 0, l = textLines.length; i < l; i++) {
	    // textContain.measureText may be overrided in SVG or VML
	    width = Math.max(measureText(textLines[i], font).width, width);
	  }
	
	  if (textWidthCacheCounter > TEXT_CACHE_MAX) {
	    textWidthCacheCounter = 0;
	    textWidthCache = {};
	  }
	
	  textWidthCacheCounter++;
	  textWidthCache[key] = width;
	  return width;
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {string} [textAlign='left']
	 * @param {string} [textVerticalAlign='top']
	 * @param {Array.<number>} [textPadding]
	 * @param {Object} [rich]
	 * @param {Object} [truncate]
	 * @return {Object} {x, y, width, height, lineHeight}
	 */
	
	
	function getBoundingRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
	  return rich ? getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) : getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate);
	}
	
	function getPlainTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, truncate) {
	  var contentBlock = parsePlainText(text, font, textPadding, textLineHeight, truncate);
	  var outerWidth = getWidth(text, font);
	
	  if (textPadding) {
	    outerWidth += textPadding[1] + textPadding[3];
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  var rect = new BoundingRect(x, y, outerWidth, outerHeight);
	  rect.lineHeight = contentBlock.lineHeight;
	  return rect;
	}
	
	function getRichTextRect(text, font, textAlign, textVerticalAlign, textPadding, textLineHeight, rich, truncate) {
	  var contentBlock = parseRichText(text, {
	    rich: rich,
	    truncate: truncate,
	    font: font,
	    textAlign: textAlign,
	    textPadding: textPadding,
	    textLineHeight: textLineHeight
	  });
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var x = adjustTextX(0, outerWidth, textAlign);
	  var y = adjustTextY(0, outerHeight, textVerticalAlign);
	  return new BoundingRect(x, y, outerWidth, outerHeight);
	}
	/**
	 * @public
	 * @param {number} x
	 * @param {number} width
	 * @param {string} [textAlign='left']
	 * @return {number} Adjusted x.
	 */
	
	
	function adjustTextX(x, width, textAlign) {
	  // FIXME Right to left language
	  if (textAlign === 'right') {
	    x -= width;
	  } else if (textAlign === 'center') {
	    x -= width / 2;
	  }
	
	  return x;
	}
	/**
	 * @public
	 * @param {number} y
	 * @param {number} height
	 * @param {string} [textVerticalAlign='top']
	 * @return {number} Adjusted y.
	 */
	
	
	function adjustTextY(y, height, textVerticalAlign) {
	  if (textVerticalAlign === 'middle') {
	    y -= height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y -= height;
	  }
	
	  return y;
	}
	/**
	 * Follow same interface to `Displayable.prototype.calculateTextPosition`.
	 * @public
	 * @param {Obejct} [out] Prepared out object. If not input, auto created in the method.
	 * @param {module:zrender/graphic/Style} style where `textPosition` and `textDistance` are visited.
	 * @param {Object} rect {x, y, width, height} Rect of the host elment, according to which the text positioned.
	 * @return {Object} The input `out`. Set: {x, y, textAlign, textVerticalAlign}
	 */
	
	
	function calculateTextPosition(out, style, rect) {
	  var textPosition = style.textPosition;
	  var distance = style.textDistance;
	  var x = rect.x;
	  var y = rect.y;
	  distance = distance || 0;
	  var height = rect.height;
	  var width = rect.width;
	  var halfHeight = height / 2;
	  var textAlign = 'left';
	  var textVerticalAlign = 'top';
	
	  switch (textPosition) {
	    case 'left':
	      x -= distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'right':
	      x += distance + width;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'top':
	      x += width / 2;
	      y -= distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'bottom':
	      x += width / 2;
	      y += height + distance;
	      textAlign = 'center';
	      break;
	
	    case 'inside':
	      x += width / 2;
	      y += halfHeight;
	      textAlign = 'center';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideLeft':
	      x += distance;
	      y += halfHeight;
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideRight':
	      x += width - distance;
	      y += halfHeight;
	      textAlign = 'right';
	      textVerticalAlign = 'middle';
	      break;
	
	    case 'insideTop':
	      x += width / 2;
	      y += distance;
	      textAlign = 'center';
	      break;
	
	    case 'insideBottom':
	      x += width / 2;
	      y += height - distance;
	      textAlign = 'center';
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideTopLeft':
	      x += distance;
	      y += distance;
	      break;
	
	    case 'insideTopRight':
	      x += width - distance;
	      y += distance;
	      textAlign = 'right';
	      break;
	
	    case 'insideBottomLeft':
	      x += distance;
	      y += height - distance;
	      textVerticalAlign = 'bottom';
	      break;
	
	    case 'insideBottomRight':
	      x += width - distance;
	      y += height - distance;
	      textAlign = 'right';
	      textVerticalAlign = 'bottom';
	      break;
	  }
	
	  out = out || {};
	  out.x = x;
	  out.y = y;
	  out.textAlign = textAlign;
	  out.textVerticalAlign = textVerticalAlign;
	  return out;
	}
	/**
	 * To be removed. But still do not remove in case that some one has imported it.
	 * @deprecated
	 * @public
	 * @param {stirng} textPosition
	 * @param {Object} rect {x, y, width, height}
	 * @param {number} distance
	 * @return {Object} {x, y, textAlign, textVerticalAlign}
	 */
	
	
	function adjustTextPositionOnRect(textPosition, rect, distance) {
	  var dummyStyle = {
	    textPosition: textPosition,
	    textDistance: distance
	  };
	  return calculateTextPosition({}, dummyStyle, rect);
	}
	/**
	 * Show ellipsis if overflow.
	 *
	 * @public
	 * @param  {string} text
	 * @param  {string} containerWidth
	 * @param  {string} font
	 * @param  {number} [ellipsis='...']
	 * @param  {Object} [options]
	 * @param  {number} [options.maxIterations=3]
	 * @param  {number} [options.minChar=0] If truncate result are less
	 *                  then minChar, ellipsis will not show, which is
	 *                  better for user hint in some cases.
	 * @param  {number} [options.placeholder=''] When all truncated, use the placeholder.
	 * @return {string}
	 */
	
	
	function truncateText(text, containerWidth, font, ellipsis, options) {
	  if (!containerWidth) {
	    return '';
	  }
	
	  var textLines = (text + '').split('\n');
	  options = prepareTruncateOptions(containerWidth, font, ellipsis, options); // FIXME
	  // It is not appropriate that every line has '...' when truncate multiple lines.
	
	  for (var i = 0, len = textLines.length; i < len; i++) {
	    textLines[i] = truncateSingleLine(textLines[i], options);
	  }
	
	  return textLines.join('\n');
	}
	
	function prepareTruncateOptions(containerWidth, font, ellipsis, options) {
	  options = extend({}, options);
	  options.font = font;
	  var ellipsis = retrieve2(ellipsis, '...');
	  options.maxIterations = retrieve2(options.maxIterations, 2);
	  var minChar = options.minChar = retrieve2(options.minChar, 0); // FIXME
	  // Other languages?
	
	  options.cnCharWidth = getWidth('国', font); // FIXME
	  // Consider proportional font?
	
	  var ascCharWidth = options.ascCharWidth = getWidth('a', font);
	  options.placeholder = retrieve2(options.placeholder, ''); // Example 1: minChar: 3, text: 'asdfzxcv', truncate result: 'asdf', but not: 'a...'.
	  // Example 2: minChar: 3, text: '维度', truncate result: '维', but not: '...'.
	
	  var contentWidth = containerWidth = Math.max(0, containerWidth - 1); // Reserve some gap.
	
	  for (var i = 0; i < minChar && contentWidth >= ascCharWidth; i++) {
	    contentWidth -= ascCharWidth;
	  }
	
	  var ellipsisWidth = getWidth(ellipsis, font);
	
	  if (ellipsisWidth > contentWidth) {
	    ellipsis = '';
	    ellipsisWidth = 0;
	  }
	
	  contentWidth = containerWidth - ellipsisWidth;
	  options.ellipsis = ellipsis;
	  options.ellipsisWidth = ellipsisWidth;
	  options.contentWidth = contentWidth;
	  options.containerWidth = containerWidth;
	  return options;
	}
	
	function truncateSingleLine(textLine, options) {
	  var containerWidth = options.containerWidth;
	  var font = options.font;
	  var contentWidth = options.contentWidth;
	
	  if (!containerWidth) {
	    return '';
	  }
	
	  var lineWidth = getWidth(textLine, font);
	
	  if (lineWidth <= containerWidth) {
	    return textLine;
	  }
	
	  for (var j = 0;; j++) {
	    if (lineWidth <= contentWidth || j >= options.maxIterations) {
	      textLine += options.ellipsis;
	      break;
	    }
	
	    var subLength = j === 0 ? estimateLength(textLine, contentWidth, options.ascCharWidth, options.cnCharWidth) : lineWidth > 0 ? Math.floor(textLine.length * contentWidth / lineWidth) : 0;
	    textLine = textLine.substr(0, subLength);
	    lineWidth = getWidth(textLine, font);
	  }
	
	  if (textLine === '') {
	    textLine = options.placeholder;
	  }
	
	  return textLine;
	}
	
	function estimateLength(text, contentWidth, ascCharWidth, cnCharWidth) {
	  var width = 0;
	  var i = 0;
	
	  for (var len = text.length; i < len && width < contentWidth; i++) {
	    var charCode = text.charCodeAt(i);
	    width += 0 <= charCode && charCode <= 127 ? ascCharWidth : cnCharWidth;
	  }
	
	  return i;
	}
	/**
	 * @public
	 * @param {string} font
	 * @return {number} line height
	 */
	
	
	function getLineHeight(font) {
	  // FIXME A rough approach.
	  return getWidth('国', font);
	}
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @return {Object} width
	 */
	
	
	function measureText(text, font) {
	  return methods.measureText(text, font);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	methods.measureText = function (text, font) {
	  var ctx = getContext();
	  ctx.font = font || DEFAULT_FONT;
	  return ctx.measureText(text);
	};
	/**
	 * @public
	 * @param {string} text
	 * @param {string} font
	 * @param {Object} [truncate]
	 * @return {Object} block: {lineHeight, lines, height, outerHeight, canCacheByTextString}
	 *  Notice: for performance, do not calculate outerWidth util needed.
	 *  `canCacheByTextString` means the result `lines` is only determined by the input `text`.
	 *  Thus we can simply comparing the `input` text to determin whether the result changed,
	 *  without travel the result `lines`.
	 */
	
	
	function parsePlainText(text, font, padding, textLineHeight, truncate) {
	  text != null && (text += '');
	  var lineHeight = retrieve2(textLineHeight, getLineHeight(font));
	  var lines = text ? text.split('\n') : [];
	  var height = lines.length * lineHeight;
	  var outerHeight = height;
	  var canCacheByTextString = true;
	
	  if (padding) {
	    outerHeight += padding[0] + padding[2];
	  }
	
	  if (text && truncate) {
	    canCacheByTextString = false;
	    var truncOuterHeight = truncate.outerHeight;
	    var truncOuterWidth = truncate.outerWidth;
	
	    if (truncOuterHeight != null && outerHeight > truncOuterHeight) {
	      text = '';
	      lines = [];
	    } else if (truncOuterWidth != null) {
	      var options = prepareTruncateOptions(truncOuterWidth - (padding ? padding[1] + padding[3] : 0), font, truncate.ellipsis, {
	        minChar: truncate.minChar,
	        placeholder: truncate.placeholder
	      }); // FIXME
	      // It is not appropriate that every line has '...' when truncate multiple lines.
	
	      for (var i = 0, len = lines.length; i < len; i++) {
	        lines[i] = truncateSingleLine(lines[i], options);
	      }
	    }
	  }
	
	  return {
	    lines: lines,
	    height: height,
	    outerHeight: outerHeight,
	    lineHeight: lineHeight,
	    canCacheByTextString: canCacheByTextString
	  };
	}
	/**
	 * For example: 'some text {a|some text}other text{b|some text}xxx{c|}xxx'
	 * Also consider 'bbbb{a|xxx\nzzz}xxxx\naaaa'.
	 *
	 * @public
	 * @param {string} text
	 * @param {Object} style
	 * @return {Object} block
	 * {
	 *      width,
	 *      height,
	 *      lines: [{
	 *          lineHeight,
	 *          width,
	 *          tokens: [[{
	 *              styleName,
	 *              text,
	 *              width,      // include textPadding
	 *              height,     // include textPadding
	 *              textWidth, // pure text width
	 *              textHeight, // pure text height
	 *              lineHeihgt,
	 *              font,
	 *              textAlign,
	 *              textVerticalAlign
	 *          }], [...], ...]
	 *      }, ...]
	 * }
	 * If styleName is undefined, it is plain text.
	 */
	
	
	function parseRichText(text, style) {
	  var contentBlock = {
	    lines: [],
	    width: 0,
	    height: 0
	  };
	  text != null && (text += '');
	
	  if (!text) {
	    return contentBlock;
	  }
	
	  var lastIndex = STYLE_REG.lastIndex = 0;
	  var result;
	
	  while ((result = STYLE_REG.exec(text)) != null) {
	    var matchedIndex = result.index;
	
	    if (matchedIndex > lastIndex) {
	      pushTokens(contentBlock, text.substring(lastIndex, matchedIndex));
	    }
	
	    pushTokens(contentBlock, result[2], result[1]);
	    lastIndex = STYLE_REG.lastIndex;
	  }
	
	  if (lastIndex < text.length) {
	    pushTokens(contentBlock, text.substring(lastIndex, text.length));
	  }
	
	  var lines = contentBlock.lines;
	  var contentHeight = 0;
	  var contentWidth = 0; // For `textWidth: 100%`
	
	  var pendingList = [];
	  var stlPadding = style.textPadding;
	  var truncate = style.truncate;
	  var truncateWidth = truncate && truncate.outerWidth;
	  var truncateHeight = truncate && truncate.outerHeight;
	
	  if (stlPadding) {
	    truncateWidth != null && (truncateWidth -= stlPadding[1] + stlPadding[3]);
	    truncateHeight != null && (truncateHeight -= stlPadding[0] + stlPadding[2]);
	  } // Calculate layout info of tokens.
	
	
	  for (var i = 0; i < lines.length; i++) {
	    var line = lines[i];
	    var lineHeight = 0;
	    var lineWidth = 0;
	
	    for (var j = 0; j < line.tokens.length; j++) {
	      var token = line.tokens[j];
	      var tokenStyle = token.styleName && style.rich[token.styleName] || {}; // textPadding should not inherit from style.
	
	      var textPadding = token.textPadding = tokenStyle.textPadding; // textFont has been asigned to font by `normalizeStyle`.
	
	      var font = token.font = tokenStyle.font || style.font; // textHeight can be used when textVerticalAlign is specified in token.
	
	      var tokenHeight = token.textHeight = retrieve2( // textHeight should not be inherited, consider it can be specified
	      // as box height of the block.
	      tokenStyle.textHeight, getLineHeight(font));
	      textPadding && (tokenHeight += textPadding[0] + textPadding[2]);
	      token.height = tokenHeight;
	      token.lineHeight = retrieve3(tokenStyle.textLineHeight, style.textLineHeight, tokenHeight);
	      token.textAlign = tokenStyle && tokenStyle.textAlign || style.textAlign;
	      token.textVerticalAlign = tokenStyle && tokenStyle.textVerticalAlign || 'middle';
	
	      if (truncateHeight != null && contentHeight + token.lineHeight > truncateHeight) {
	        return {
	          lines: [],
	          width: 0,
	          height: 0
	        };
	      }
	
	      token.textWidth = getWidth(token.text, font);
	      var tokenWidth = tokenStyle.textWidth;
	      var tokenWidthNotSpecified = tokenWidth == null || tokenWidth === 'auto'; // Percent width, can be `100%`, can be used in drawing separate
	      // line when box width is needed to be auto.
	
	      if (typeof tokenWidth === 'string' && tokenWidth.charAt(tokenWidth.length - 1) === '%') {
	        token.percentWidth = tokenWidth;
	        pendingList.push(token);
	        tokenWidth = 0; // Do not truncate in this case, because there is no user case
	        // and it is too complicated.
	      } else {
	        if (tokenWidthNotSpecified) {
	          tokenWidth = token.textWidth; // FIXME: If image is not loaded and textWidth is not specified, calling
	          // `getBoundingRect()` will not get correct result.
	
	          var textBackgroundColor = tokenStyle.textBackgroundColor;
	          var bgImg = textBackgroundColor && textBackgroundColor.image; // Use cases:
	          // (1) If image is not loaded, it will be loaded at render phase and call
	          // `dirty()` and `textBackgroundColor.image` will be replaced with the loaded
	          // image, and then the right size will be calculated here at the next tick.
	          // See `graphic/helper/text.js`.
	          // (2) If image loaded, and `textBackgroundColor.image` is image src string,
	          // use `imageHelper.findExistImage` to find cached image.
	          // `imageHelper.findExistImage` will always be called here before
	          // `imageHelper.createOrUpdateImage` in `graphic/helper/text.js#renderRichText`
	          // which ensures that image will not be rendered before correct size calcualted.
	
	          if (bgImg) {
	            bgImg = imageHelper.findExistImage(bgImg);
	
	            if (imageHelper.isImageReady(bgImg)) {
	              tokenWidth = Math.max(tokenWidth, bgImg.width * tokenHeight / bgImg.height);
	            }
	          }
	        }
	
	        var paddingW = textPadding ? textPadding[1] + textPadding[3] : 0;
	        tokenWidth += paddingW;
	        var remianTruncWidth = truncateWidth != null ? truncateWidth - lineWidth : null;
	
	        if (remianTruncWidth != null && remianTruncWidth < tokenWidth) {
	          if (!tokenWidthNotSpecified || remianTruncWidth < paddingW) {
	            token.text = '';
	            token.textWidth = tokenWidth = 0;
	          } else {
	            token.text = truncateText(token.text, remianTruncWidth - paddingW, font, truncate.ellipsis, {
	              minChar: truncate.minChar
	            });
	            token.textWidth = getWidth(token.text, font);
	            tokenWidth = token.textWidth + paddingW;
	          }
	        }
	      }
	
	      lineWidth += token.width = tokenWidth;
	      tokenStyle && (lineHeight = Math.max(lineHeight, token.lineHeight));
	    }
	
	    line.width = lineWidth;
	    line.lineHeight = lineHeight;
	    contentHeight += lineHeight;
	    contentWidth = Math.max(contentWidth, lineWidth);
	  }
	
	  contentBlock.outerWidth = contentBlock.width = retrieve2(style.textWidth, contentWidth);
	  contentBlock.outerHeight = contentBlock.height = retrieve2(style.textHeight, contentHeight);
	
	  if (stlPadding) {
	    contentBlock.outerWidth += stlPadding[1] + stlPadding[3];
	    contentBlock.outerHeight += stlPadding[0] + stlPadding[2];
	  }
	
	  for (var i = 0; i < pendingList.length; i++) {
	    var token = pendingList[i];
	    var percentWidth = token.percentWidth; // Should not base on outerWidth, because token can not be placed out of padding.
	
	    token.width = parseInt(percentWidth, 10) / 100 * contentWidth;
	  }
	
	  return contentBlock;
	}
	
	function pushTokens(block, str, styleName) {
	  var isEmptyStr = str === '';
	  var strs = str.split('\n');
	  var lines = block.lines;
	
	  for (var i = 0; i < strs.length; i++) {
	    var text = strs[i];
	    var token = {
	      styleName: styleName,
	      text: text,
	      isLineHolder: !text && !isEmptyStr
	    }; // The first token should be appended to the last line.
	
	    if (!i) {
	      var tokens = (lines[lines.length - 1] || (lines[0] = {
	        tokens: []
	      })).tokens; // Consider cases:
	      // (1) ''.split('\n') => ['', '\n', ''], the '' at the first item
	      // (which is a placeholder) should be replaced by new token.
	      // (2) A image backage, where token likes {a|}.
	      // (3) A redundant '' will affect textAlign in line.
	      // (4) tokens with the same tplName should not be merged, because
	      // they should be displayed in different box (with border and padding).
	
	      var tokensLen = tokens.length;
	      tokensLen === 1 && tokens[0].isLineHolder ? tokens[0] = token : // Consider text is '', only insert when it is the "lineHolder" or
	      // "emptyStr". Otherwise a redundant '' will affect textAlign in line.
	      (text || !tokensLen || isEmptyStr) && tokens.push(token);
	    } // Other tokens always start a new line.
	    else {
	        // If there is '', insert it as a placeholder.
	        lines.push({
	          tokens: [token]
	        });
	      }
	  }
	}
	
	function makeFont(style) {
	  // FIXME in node-canvas fontWeight is before fontStyle
	  // Use `fontSize` `fontFamily` to check whether font properties are defined.
	  var font = (style.fontSize || style.fontFamily) && [style.fontStyle, style.fontWeight, (style.fontSize || 12) + 'px', // If font properties are defined, `fontFamily` should not be ignored.
	  style.fontFamily || 'sans-serif'].join(' ');
	  return font && trim(font) || style.textFont || style.font;
	}
	
	exports.DEFAULT_FONT = DEFAULT_FONT;
	exports.$override = $override;
	exports.getWidth = getWidth;
	exports.getBoundingRect = getBoundingRect;
	exports.adjustTextX = adjustTextX;
	exports.adjustTextY = adjustTextY;
	exports.calculateTextPosition = calculateTextPosition;
	exports.adjustTextPositionOnRect = adjustTextPositionOnRect;
	exports.truncateText = truncateText;
	exports.getLineHeight = getLineHeight;
	exports.measureText = measureText;
	exports.parsePlainText = parsePlainText;
	exports.parseRichText = parseRichText;
	exports.makeFont = makeFont;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _user = __webpack_require__(54);
	
	__webpack_require__(2958);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var FlowSearch = function (_Component) {
	  _inherits(FlowSearch, _Component);
	
	  function FlowSearch(props) {
	    _classCallCheck(this, FlowSearch);
	
	    var _this = _possibleConstructorReturn(this, (FlowSearch.__proto__ || Object.getPrototypeOf(FlowSearch)).call(this, props));
	
	    _this.getAccountList = function () {
	      (0, _user.queryAccountList)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            userList: res.data || []
	          });
	        } else {
	          _antd.message.err(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.onSearch = function () {
	      var data = _this.props.form.getFieldsValue();
	      var params = {};
	      var date = data.date;
	
	      if (date && date.length > 0) {
	        params = {
	          beginDate: (0, _moment2.default)(date[0]).format('YYYY-MM-DD'),
	          endDate: (0, _moment2.default)(date[1]).format('YYYY-MM-DD')
	        };
	      }
	      params = Object.assign({}, params, {
	        condition: data.condition || '',
	        createUser: data.createUser || '',
	        instanceStatus: data.instanceStatus || ''
	      });
	      _this.props.onSearch(params);
	    };
	
	    _this.state = {
	      userList: []
	    };
	    return _this;
	  }
	
	  _createClass(FlowSearch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAccountList();
	    }
	
	    // 用户列表
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          getFieldDecorator = _props.form.getFieldDecorator,
	          instanceStatus = _props.instanceStatus,
	          endDate = _props.endDate,
	          beginDate = _props.beginDate,
	          condition = _props.condition,
	          createUser = _props.createUser;
	      var userList = this.state.userList;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expense-search-form' },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u6A21\u7CCA\u641C\u7D22', labelCol: 6, wrapperCol: 18 },
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u516C\u53F8/\u7406\u7531/\u7533\u8BF7\u4EBA/\u7B49\u7B49' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u7533\u8BF7\u4EBA', labelCol: 6, wrapperCol: 18 },
	            getFieldDecorator('createUser', {
	              initialValue: createUser || undefined
	            })(_react2.default.createElement(
	              _antd.Select,
	              {
	                allowClear: true,
	                showSearch: true,
	                placeholder: '\u6839\u636E\u7533\u8BF7\u4EBA\u641C\u7D22',
	                style: { width: '150px' },
	                filterOption: function filterOption(input, option) {
	                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                }
	              },
	              userList ? userList.map(function (item) {
	                return _react2.default.createElement(
	                  _antd.Select.Option,
	                  { key: item.uuid, value: item.uuid },
	                  item.name
	                );
	              }) : null
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u72B6\u6001', labelCol: 6, wrapperCol: 18 },
	            getFieldDecorator('instanceStatus', {
	              initialValue: instanceStatus || undefined
	            })(_react2.default.createElement(
	              _antd.Select,
	              { allowClear: true, placeholder: '\u6839\u636E\u72B6\u6001\u641C\u7D22', style: { width: '150px' } },
	              _react2.default.createElement(
	                _antd.Select.Option,
	                { key: 0, value: 'NO' },
	                '\u5F85\u7F16\u8F91'
	              ),
	              _react2.default.createElement(
	                _antd.Select.Option,
	                { key: 0, value: 'REVIEWING' },
	                '\u5BA1\u6838\u4E2D'
	              ),
	              _react2.default.createElement(
	                _antd.Select.Option,
	                { key: 1, value: 'FINISHED' },
	                '\u5DF2\u5B8C\u6210'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u8D77\u6B62\u65E5\u671F', labelCol: 4, wrapperCol: 20 },
	            getFieldDecorator('date', {
	              initialValue: beginDate ? [(0, _moment2.default)(beginDate, 'YYYY-MM-DD'), (0, _moment2.default)(endDate, 'YYYY-MM-DD')] : null
	            })(_react2.default.createElement(RangePicker, { format: 'YYYY-MM-DD' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: this.onSearch },
	              '\u641C\u7D22'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FlowSearch;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(FlowSearch);

/***/ },
/* 104 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 105 */
[3028, 278, 202, 107, 138, 104, 766, 65],
/* 106 */
[3031, 104, 75, 478],
/* 107 */
[3041, 277, 136],
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentBlockNode
	 * @format
	 * 
	 *
	 * This file is a fork of ContentBlock adding support for nesting references by
	 * providing links to children, parent, prevSibling, and nextSibling.
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CharacterMetadata = __webpack_require__(100);
	var Immutable = __webpack_require__(39);
	
	var findRangesImmutable = __webpack_require__(284);
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  parent: null,
	  characterList: List(),
	  data: Map(),
	  depth: 0,
	  key: '',
	  text: '',
	  type: 'unstyled',
	  children: List(),
	  prevSibling: null,
	  nextSibling: null
	};
	
	var haveEqualStyle = function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	};
	
	var haveEqualEntity = function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	};
	
	var decorateCharacterList = function decorateCharacterList(config) {
	  if (!config) {
	    return config;
	  }
	
	  var characterList = config.characterList,
	      text = config.text;
	
	
	  if (text && !characterList) {
	    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
	  }
	
	  return config;
	};
	
	var ContentBlockNode = function (_Record) {
	  _inherits(ContentBlockNode, _Record);
	
	  function ContentBlockNode() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultRecord;
	
	    _classCallCheck(this, ContentBlockNode);
	
	    return _possibleConstructorReturn(this, _Record.call(this, decorateCharacterList(props)));
	  }
	
	  ContentBlockNode.prototype.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  ContentBlockNode.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  ContentBlockNode.prototype.getText = function getText() {
	    return this.get('text');
	  };
	
	  ContentBlockNode.prototype.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  ContentBlockNode.prototype.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  ContentBlockNode.prototype.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  ContentBlockNode.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  ContentBlockNode.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  ContentBlockNode.prototype.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  };
	
	  ContentBlockNode.prototype.getChildKeys = function getChildKeys() {
	    return this.get('children');
	  };
	
	  ContentBlockNode.prototype.getParentKey = function getParentKey() {
	    return this.get('parent');
	  };
	
	  ContentBlockNode.prototype.getPrevSiblingKey = function getPrevSiblingKey() {
	    return this.get('prevSibling');
	  };
	
	  ContentBlockNode.prototype.getNextSiblingKey = function getNextSiblingKey() {
	    return this.get('nextSibling');
	  };
	
	  ContentBlockNode.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  };
	
	  ContentBlockNode.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlockNode;
	}(Record(defaultRecord));
	
	module.exports = ContentBlockNode;

/***/ },
/* 109 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(4);
	
	var Model = __webpack_require__(70);
	
	var DataDiffer = __webpack_require__(211);
	
	var Source = __webpack_require__(292);
	
	var _dataProvider = __webpack_require__(212);
	
	var defaultDimValueGetters = _dataProvider.defaultDimValueGetters;
	var DefaultDataProvider = _dataProvider.DefaultDataProvider;
	
	var _dimensionHelper = __webpack_require__(293);
	
	var summarizeDimensions = _dimensionHelper.summarizeDimensions;
	
	var DataDimensionInfo = __webpack_require__(869);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float64Array, Int32Array, Uint32Array, Uint16Array */
	
	/**
	 * List for data storage
	 * @module echarts/data/List
	 */
	var isObject = zrUtil.isObject;
	var UNDEFINED = 'undefined';
	var INDEX_NOT_FOUND = -1; // Use prefix to avoid index to be the same as otherIdList[idx],
	// which will cause weird udpate animation.
	
	var ID_PREFIX = 'e\0\0';
	var dataCtors = {
	  'float': typeof Float64Array === UNDEFINED ? Array : Float64Array,
	  'int': typeof Int32Array === UNDEFINED ? Array : Int32Array,
	  // Ordinal data type can be string or int
	  'ordinal': Array,
	  'number': Array,
	  'time': Array
	}; // Caution: MUST not use `new CtorUint32Array(arr, 0, len)`, because the Ctor of array is
	// different from the Ctor of typed array.
	
	var CtorUint32Array = typeof Uint32Array === UNDEFINED ? Array : Uint32Array;
	var CtorInt32Array = typeof Int32Array === UNDEFINED ? Array : Int32Array;
	var CtorUint16Array = typeof Uint16Array === UNDEFINED ? Array : Uint16Array;
	
	function getIndicesCtor(list) {
	  // The possible max value in this._indicies is always this._rawCount despite of filtering.
	  return list._rawCount > 65535 ? CtorUint32Array : CtorUint16Array;
	}
	
	function cloneChunk(originalChunk) {
	  var Ctor = originalChunk.constructor; // Only shallow clone is enough when Array.
	
	  return Ctor === Array ? originalChunk.slice() : new Ctor(originalChunk);
	}
	
	var TRANSFERABLE_PROPERTIES = ['hasItemOption', '_nameList', '_idList', '_invertedIndicesMap', '_rawData', '_chunkSize', '_chunkCount', '_dimValueGetter', '_count', '_rawCount', '_nameDimIdx', '_idDimIdx'];
	var CLONE_PROPERTIES = ['_extent', '_approximateExtent', '_rawExtent'];
	
	function transferProperties(target, source) {
	  zrUtil.each(TRANSFERABLE_PROPERTIES.concat(source.__wrappedMethods || []), function (propName) {
	    if (source.hasOwnProperty(propName)) {
	      target[propName] = source[propName];
	    }
	  });
	  target.__wrappedMethods = source.__wrappedMethods;
	  zrUtil.each(CLONE_PROPERTIES, function (propName) {
	    target[propName] = zrUtil.clone(source[propName]);
	  });
	  target._calculationInfo = zrUtil.extend(source._calculationInfo);
	}
	/**
	 * @constructor
	 * @alias module:echarts/data/List
	 *
	 * @param {Array.<string|Object|module:data/DataDimensionInfo>} dimensions
	 *      For example, ['someDimName', {name: 'someDimName', type: 'someDimType'}, ...].
	 *      Dimensions should be concrete names like x, y, z, lng, lat, angle, radius
	 * @param {module:echarts/model/Model} hostModel
	 */
	
	
	var List = function (dimensions, hostModel) {
	  dimensions = dimensions || ['x', 'y'];
	  var dimensionInfos = {};
	  var dimensionNames = [];
	  var invertedIndicesMap = {};
	
	  for (var i = 0; i < dimensions.length; i++) {
	    // Use the original dimensions[i], where other flag props may exists.
	    var dimensionInfo = dimensions[i];
	
	    if (zrUtil.isString(dimensionInfo)) {
	      dimensionInfo = new DataDimensionInfo({
	        name: dimensionInfo
	      });
	    } else if (!(dimensionInfo instanceof DataDimensionInfo)) {
	      dimensionInfo = new DataDimensionInfo(dimensionInfo);
	    }
	
	    var dimensionName = dimensionInfo.name;
	    dimensionInfo.type = dimensionInfo.type || 'float';
	
	    if (!dimensionInfo.coordDim) {
	      dimensionInfo.coordDim = dimensionName;
	      dimensionInfo.coordDimIndex = 0;
	    }
	
	    dimensionInfo.otherDims = dimensionInfo.otherDims || {};
	    dimensionNames.push(dimensionName);
	    dimensionInfos[dimensionName] = dimensionInfo;
	    dimensionInfo.index = i;
	
	    if (dimensionInfo.createInvertedIndices) {
	      invertedIndicesMap[dimensionName] = [];
	    }
	  }
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	
	
	  this.dimensions = dimensionNames;
	  /**
	   * Infomation of each data dimension, like data type.
	   * @type {Object}
	   */
	
	  this._dimensionInfos = dimensionInfos;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.dataType;
	  /**
	   * Indices stores the indices of data subset after filtered.
	   * This data subset will be used in chart.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	
	  this._indices = null;
	  this._count = 0;
	  this._rawCount = 0;
	  /**
	   * Data storage
	   * @type {Object.<key, Array.<TypedArray|Array>>}
	   * @private
	   */
	
	  this._storage = {};
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._nameList = [];
	  /**
	   * @type {Array.<string>}
	   */
	
	  this._idList = [];
	  /**
	   * Models of data option is stored sparse for optimizing memory cost
	   * @type {Array.<module:echarts/model/Model>}
	   * @private
	   */
	
	  this._optionModels = [];
	  /**
	   * Global visual properties after visual coding
	   * @type {Object}
	   * @private
	   */
	
	  this._visual = {};
	  /**
	   * Globel layout properties.
	   * @type {Object}
	   * @private
	   */
	
	  this._layout = {};
	  /**
	   * Item visual properties after visual coding
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemVisuals = [];
	  /**
	   * Key: visual type, Value: boolean
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.hasItemVisual = {};
	  /**
	   * Item layout properties after layout
	   * @type {Array.<Object>}
	   * @private
	   */
	
	  this._itemLayouts = [];
	  /**
	   * Graphic elemnents
	   * @type {Array.<module:zrender/Element>}
	   * @private
	   */
	
	  this._graphicEls = [];
	  /**
	   * Max size of each chunk.
	   * @type {number}
	   * @private
	   */
	
	  this._chunkSize = 1e5;
	  /**
	   * @type {number}
	   * @private
	   */
	
	  this._chunkCount = 0;
	  /**
	   * @type {Array.<Array|Object>}
	   * @private
	   */
	
	  this._rawData;
	  /**
	   * Raw extent will not be cloned, but only transfered.
	   * It will not be calculated util needed.
	   * key: dim,
	   * value: {end: number, extent: Array.<number>}
	   * @type {Object}
	   * @private
	   */
	
	  this._rawExtent = {};
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._extent = {};
	  /**
	   * key: dim
	   * value: extent
	   * @type {Object}
	   * @private
	   */
	
	  this._approximateExtent = {};
	  /**
	   * Cache summary info for fast visit. See "dimensionHelper".
	   * @type {Object}
	   * @private
	   */
	
	  this._dimensionsSummary = summarizeDimensions(this);
	  /**
	   * @type {Object.<Array|TypedArray>}
	   * @private
	   */
	
	  this._invertedIndicesMap = invertedIndicesMap;
	  /**
	   * @type {Object}
	   * @private
	   */
	
	  this._calculationInfo = {};
	  /**
	   * User output info of this data.
	   * DO NOT use it in other places!
	   *
	   * When preparing user params for user callbacks, we have
	   * to clone these inner data structures to prevent users
	   * from modifying them to effect built-in logic. And for
	   * performance consideration we make this `userOutput` to
	   * avoid clone them too many times.
	   *
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.userOutput = this._dimensionsSummary.userOutput;
	};
	
	var listProto = List.prototype;
	listProto.type = 'list';
	/**
	 * If each data item has it's own option
	 * @type {boolean}
	 */
	
	listProto.hasItemOption = true;
	/**
	 * The meanings of the input parameter `dim`:
	 *
	 * + If dim is a number (e.g., `1`), it means the index of the dimension.
	 *   For example, `getDimension(0)` will return 'x' or 'lng' or 'radius'.
	 * + If dim is a number-like string (e.g., `"1"`):
	 *     + If there is the same concrete dim name defined in `this.dimensions`, it means that concrete name.
	 *     + If not, it will be converted to a number, which means the index of the dimension.
	 *        (why? because of the backward compatbility. We have been tolerating number-like string in
	 *        dimension setting, although now it seems that it is not a good idea.)
	 *     For example, `visualMap[i].dimension: "1"` is the same meaning as `visualMap[i].dimension: 1`,
	 *     if no dimension name is defined as `"1"`.
	 * + If dim is a not-number-like string, it means the concrete dim name.
	 *   For example, it can be be default name `"x"`, `"y"`, `"z"`, `"lng"`, `"lat"`, `"angle"`, `"radius"`,
	 *   or customized in `dimensions` property of option like `"age"`.
	 *
	 * Get dimension name
	 * @param {string|number} dim See above.
	 * @return {string} Concrete dim name.
	 */
	
	listProto.getDimension = function (dim) {
	  if (typeof dim === 'number' // If being a number-like string but not being defined a dimension name.
	  || !isNaN(dim) && !this._dimensionInfos.hasOwnProperty(dim)) {
	    dim = this.dimensions[dim];
	  }
	
	  return dim;
	};
	/**
	 * Get type and calculation info of particular dimension
	 * @param {string|number} dim
	 *        Dimension can be concrete names like x, y, z, lng, lat, angle, radius
	 *        Or a ordinal number. For example getDimensionInfo(0) will return 'x' or 'lng' or 'radius'
	 */
	
	
	listProto.getDimensionInfo = function (dim) {
	  // Do not clone, because there may be categories in dimInfo.
	  return this._dimensionInfos[this.getDimension(dim)];
	};
	/**
	 * @return {Array.<string>} concrete dimension name list on coord.
	 */
	
	
	listProto.getDimensionsOnCoord = function () {
	  return this._dimensionsSummary.dataDimsOnCoord.slice();
	};
	/**
	 * @param {string} coordDim
	 * @param {number} [idx] A coordDim may map to more than one data dim.
	 *        If idx is `true`, return a array of all mapped dims.
	 *        If idx is not specified, return the first dim not extra.
	 * @return {string|Array.<string>} concrete data dim.
	 *        If idx is number, and not found, return null/undefined.
	 *        If idx is `true`, and not found, return empty array (always return array).
	 */
	
	
	listProto.mapDimension = function (coordDim, idx) {
	  var dimensionsSummary = this._dimensionsSummary;
	
	  if (idx == null) {
	    return dimensionsSummary.encodeFirstDimNotExtra[coordDim];
	  }
	
	  var dims = dimensionsSummary.encode[coordDim];
	  return idx === true // always return array if idx is `true`
	  ? (dims || []).slice() : dims && dims[idx];
	};
	/**
	 * Initialize from data
	 * @param {Array.<Object|number|Array>} data source or data or data provider.
	 * @param {Array.<string>} [nameLIst] The name of a datum is used on data diff and
	 *        default label/tooltip.
	 *        A name can be specified in encode.itemName,
	 *        or dataItem.name (only for series option data),
	 *        or provided in nameList from outside.
	 * @param {Function} [dimValueGetter] (dataItem, dimName, dataIndex, dimIndex) => number
	 */
	
	
	listProto.initData = function (data, nameList, dimValueGetter) {
	  var notProvider = Source.isInstance(data) || zrUtil.isArrayLike(data);
	
	  if (notProvider) {
	    data = new DefaultDataProvider(data, this.dimensions.length);
	  }
	
	  this._rawData = data; // Clear
	
	  this._storage = {};
	  this._indices = null;
	  this._nameList = nameList || [];
	  this._idList = [];
	  this._nameRepeatCount = {};
	
	  if (!dimValueGetter) {
	    this.hasItemOption = false;
	  }
	  /**
	   * @readOnly
	   */
	
	
	  this.defaultDimValueGetter = defaultDimValueGetters[this._rawData.getSource().sourceFormat]; // Default dim value getter
	
	  this._dimValueGetter = dimValueGetter = dimValueGetter || this.defaultDimValueGetter;
	  this._dimValueGetterArrayRows = defaultDimValueGetters.arrayRows; // Reset raw extent.
	
	  this._rawExtent = {};
	
	  this._initDataFromProvider(0, data.count()); // If data has no item option.
	
	
	  if (data.pure) {
	    this.hasItemOption = false;
	  }
	};
	
	listProto.getProvider = function () {
	  return this._rawData;
	};
	/**
	 * Caution: Can be only called on raw data (before `this._indices` created).
	 */
	
	
	listProto.appendData = function (data) {
	  var rawData = this._rawData;
	  var start = this.count();
	  rawData.appendData(data);
	  var end = rawData.count();
	
	  if (!rawData.persistent) {
	    end += start;
	  }
	
	  this._initDataFromProvider(start, end);
	};
	/**
	 * Caution: Can be only called on raw data (before `this._indices` created).
	 * This method does not modify `rawData` (`dataProvider`), but only
	 * add values to storage.
	 *
	 * The final count will be increased by `Math.max(values.length, names.length)`.
	 *
	 * @param {Array.<Array.<*>>} values That is the SourceType: 'arrayRows', like
	 *        [
	 *            [12, 33, 44],
	 *            [NaN, 43, 1],
	 *            ['-', 'asdf', 0]
	 *        ]
	 *        Each item is exaclty cooresponding to a dimension.
	 * @param {Array.<string>} [names]
	 */
	
	
	listProto.appendValues = function (values, names) {
	  var chunkSize = this._chunkSize;
	  var storage = this._storage;
	  var dimensions = this.dimensions;
	  var dimLen = dimensions.length;
	  var rawExtent = this._rawExtent;
	  var start = this.count();
	  var end = start + Math.max(values.length, names ? names.length : 0);
	  var originalChunkCount = this._chunkCount;
	
	  for (var i = 0; i < dimLen; i++) {
	    var dim = dimensions[i];
	
	    if (!rawExtent[dim]) {
	      rawExtent[dim] = getInitialExtent();
	    }
	
	    if (!storage[dim]) {
	      storage[dim] = [];
	    }
	
	    prepareChunks(storage, this._dimensionInfos[dim], chunkSize, originalChunkCount, end);
	    this._chunkCount = storage[dim].length;
	  }
	
	  var emptyDataItem = new Array(dimLen);
	
	  for (var idx = start; idx < end; idx++) {
	    var sourceIdx = idx - start;
	    var chunkIndex = Math.floor(idx / chunkSize);
	    var chunkOffset = idx % chunkSize; // Store the data by dimensions
	
	    for (var k = 0; k < dimLen; k++) {
	      var dim = dimensions[k];
	
	      var val = this._dimValueGetterArrayRows(values[sourceIdx] || emptyDataItem, dim, sourceIdx, k);
	
	      storage[dim][chunkIndex][chunkOffset] = val;
	      var dimRawExtent = rawExtent[dim];
	      val < dimRawExtent[0] && (dimRawExtent[0] = val);
	      val > dimRawExtent[1] && (dimRawExtent[1] = val);
	    }
	
	    if (names) {
	      this._nameList[idx] = names[sourceIdx];
	    }
	  }
	
	  this._rawCount = this._count = end; // Reset data extent
	
	  this._extent = {};
	  prepareInvertedIndex(this);
	};
	
	listProto._initDataFromProvider = function (start, end) {
	  // Optimize.
	  if (start >= end) {
	    return;
	  }
	
	  var chunkSize = this._chunkSize;
	  var rawData = this._rawData;
	  var storage = this._storage;
	  var dimensions = this.dimensions;
	  var dimLen = dimensions.length;
	  var dimensionInfoMap = this._dimensionInfos;
	  var nameList = this._nameList;
	  var idList = this._idList;
	  var rawExtent = this._rawExtent;
	  var nameRepeatCount = this._nameRepeatCount = {};
	  var nameDimIdx;
	  var originalChunkCount = this._chunkCount;
	
	  for (var i = 0; i < dimLen; i++) {
	    var dim = dimensions[i];
	
	    if (!rawExtent[dim]) {
	      rawExtent[dim] = getInitialExtent();
	    }
	
	    var dimInfo = dimensionInfoMap[dim];
	
	    if (dimInfo.otherDims.itemName === 0) {
	      nameDimIdx = this._nameDimIdx = i;
	    }
	
	    if (dimInfo.otherDims.itemId === 0) {
	      this._idDimIdx = i;
	    }
	
	    if (!storage[dim]) {
	      storage[dim] = [];
	    }
	
	    prepareChunks(storage, dimInfo, chunkSize, originalChunkCount, end);
	    this._chunkCount = storage[dim].length;
	  }
	
	  var dataItem = new Array(dimLen);
	
	  for (var idx = start; idx < end; idx++) {
	    // NOTICE: Try not to write things into dataItem
	    dataItem = rawData.getItem(idx, dataItem); // Each data item is value
	    // [1, 2]
	    // 2
	    // Bar chart, line chart which uses category axis
	    // only gives the 'y' value. 'x' value is the indices of category
	    // Use a tempValue to normalize the value to be a (x, y) value
	
	    var chunkIndex = Math.floor(idx / chunkSize);
	    var chunkOffset = idx % chunkSize; // Store the data by dimensions
	
	    for (var k = 0; k < dimLen; k++) {
	      var dim = dimensions[k];
	      var dimStorage = storage[dim][chunkIndex]; // PENDING NULL is empty or zero
	
	      var val = this._dimValueGetter(dataItem, dim, idx, k);
	
	      dimStorage[chunkOffset] = val;
	      var dimRawExtent = rawExtent[dim];
	      val < dimRawExtent[0] && (dimRawExtent[0] = val);
	      val > dimRawExtent[1] && (dimRawExtent[1] = val);
	    } // ??? FIXME not check by pure but sourceFormat?
	    // TODO refactor these logic.
	
	
	    if (!rawData.pure) {
	      var name = nameList[idx];
	
	      if (dataItem && name == null) {
	        // If dataItem is {name: ...}, it has highest priority.
	        // That is appropriate for many common cases.
	        if (dataItem.name != null) {
	          // There is no other place to persistent dataItem.name,
	          // so save it to nameList.
	          nameList[idx] = name = dataItem.name;
	        } else if (nameDimIdx != null) {
	          var nameDim = dimensions[nameDimIdx];
	          var nameDimChunk = storage[nameDim][chunkIndex];
	
	          if (nameDimChunk) {
	            name = nameDimChunk[chunkOffset];
	            var ordinalMeta = dimensionInfoMap[nameDim].ordinalMeta;
	
	            if (ordinalMeta && ordinalMeta.categories.length) {
	              name = ordinalMeta.categories[name];
	            }
	          }
	        }
	      } // Try using the id in option
	      // id or name is used on dynamical data, mapping old and new items.
	
	
	      var id = dataItem == null ? null : dataItem.id;
	
	      if (id == null && name != null) {
	        // Use name as id and add counter to avoid same name
	        nameRepeatCount[name] = nameRepeatCount[name] || 0;
	        id = name;
	
	        if (nameRepeatCount[name] > 0) {
	          id += '__ec__' + nameRepeatCount[name];
	        }
	
	        nameRepeatCount[name]++;
	      }
	
	      id != null && (idList[idx] = id);
	    }
	  }
	
	  if (!rawData.persistent && rawData.clean) {
	    // Clean unused data if data source is typed array.
	    rawData.clean();
	  }
	
	  this._rawCount = this._count = end; // Reset data extent
	
	  this._extent = {};
	  prepareInvertedIndex(this);
	};
	
	function prepareChunks(storage, dimInfo, chunkSize, chunkCount, end) {
	  var DataCtor = dataCtors[dimInfo.type];
	  var lastChunkIndex = chunkCount - 1;
	  var dim = dimInfo.name;
	  var resizeChunkArray = storage[dim][lastChunkIndex];
	
	  if (resizeChunkArray && resizeChunkArray.length < chunkSize) {
	    var newStore = new DataCtor(Math.min(end - lastChunkIndex * chunkSize, chunkSize)); // The cost of the copy is probably inconsiderable
	    // within the initial chunkSize.
	
	    for (var j = 0; j < resizeChunkArray.length; j++) {
	      newStore[j] = resizeChunkArray[j];
	    }
	
	    storage[dim][lastChunkIndex] = newStore;
	  } // Create new chunks.
	
	
	  for (var k = chunkCount * chunkSize; k < end; k += chunkSize) {
	    storage[dim].push(new DataCtor(Math.min(end - k, chunkSize)));
	  }
	}
	
	function prepareInvertedIndex(list) {
	  var invertedIndicesMap = list._invertedIndicesMap;
	  zrUtil.each(invertedIndicesMap, function (invertedIndices, dim) {
	    var dimInfo = list._dimensionInfos[dim]; // Currently, only dimensions that has ordinalMeta can create inverted indices.
	
	    var ordinalMeta = dimInfo.ordinalMeta;
	
	    if (ordinalMeta) {
	      invertedIndices = invertedIndicesMap[dim] = new CtorInt32Array(ordinalMeta.categories.length); // The default value of TypedArray is 0. To avoid miss
	      // mapping to 0, we should set it as INDEX_NOT_FOUND.
	
	      for (var i = 0; i < invertedIndices.length; i++) {
	        invertedIndices[i] = INDEX_NOT_FOUND;
	      }
	
	      for (var i = 0; i < list._count; i++) {
	        // Only support the case that all values are distinct.
	        invertedIndices[list.get(dim, i)] = i;
	      }
	    }
	  });
	}
	
	function getRawValueFromStore(list, dimIndex, rawIndex) {
	  var val;
	
	  if (dimIndex != null) {
	    var chunkSize = list._chunkSize;
	    var chunkIndex = Math.floor(rawIndex / chunkSize);
	    var chunkOffset = rawIndex % chunkSize;
	    var dim = list.dimensions[dimIndex];
	    var chunk = list._storage[dim][chunkIndex];
	
	    if (chunk) {
	      val = chunk[chunkOffset];
	      var ordinalMeta = list._dimensionInfos[dim].ordinalMeta;
	
	      if (ordinalMeta && ordinalMeta.categories.length) {
	        val = ordinalMeta.categories[val];
	      }
	    }
	  }
	
	  return val;
	}
	/**
	 * @return {number}
	 */
	
	
	listProto.count = function () {
	  return this._count;
	};
	
	listProto.getIndices = function () {
	  var newIndices;
	  var indices = this._indices;
	
	  if (indices) {
	    var Ctor = indices.constructor;
	    var thisCount = this._count; // `new Array(a, b, c)` is different from `new Uint32Array(a, b, c)`.
	
	    if (Ctor === Array) {
	      newIndices = new Ctor(thisCount);
	
	      for (var i = 0; i < thisCount; i++) {
	        newIndices[i] = indices[i];
	      }
	    } else {
	      newIndices = new Ctor(indices.buffer, 0, thisCount);
	    }
	  } else {
	    var Ctor = getIndicesCtor(this);
	    var newIndices = new Ctor(this.count());
	
	    for (var i = 0; i < newIndices.length; i++) {
	      newIndices[i] = i;
	    }
	  }
	
	  return newIndices;
	};
	/**
	 * Get value. Return NaN if idx is out of range.
	 * @param {string} dim Dim must be concrete name.
	 * @param {number} idx
	 * @param {boolean} stack
	 * @return {number}
	 */
	
	
	listProto.get = function (dim, idx
	/*, stack */
	) {
	  if (!(idx >= 0 && idx < this._count)) {
	    return NaN;
	  }
	
	  var storage = this._storage;
	
	  if (!storage[dim]) {
	    // TODO Warn ?
	    return NaN;
	  }
	
	  idx = this.getRawIndex(idx);
	  var chunkIndex = Math.floor(idx / this._chunkSize);
	  var chunkOffset = idx % this._chunkSize;
	  var chunkStore = storage[dim][chunkIndex];
	  var value = chunkStore[chunkOffset]; // FIXME ordinal data type is not stackable
	  // if (stack) {
	  //     var dimensionInfo = this._dimensionInfos[dim];
	  //     if (dimensionInfo && dimensionInfo.stackable) {
	  //         var stackedOn = this.stackedOn;
	  //         while (stackedOn) {
	  //             // Get no stacked data of stacked on
	  //             var stackedValue = stackedOn.get(dim, idx);
	  //             // Considering positive stack, negative stack and empty data
	  //             if ((value >= 0 && stackedValue > 0)  // Positive stack
	  //                 || (value <= 0 && stackedValue < 0) // Negative stack
	  //             ) {
	  //                 value += stackedValue;
	  //             }
	  //             stackedOn = stackedOn.stackedOn;
	  //         }
	  //     }
	  // }
	
	  return value;
	};
	/**
	 * @param {string} dim concrete dim
	 * @param {number} rawIndex
	 * @return {number|string}
	 */
	
	
	listProto.getByRawIndex = function (dim, rawIdx) {
	  if (!(rawIdx >= 0 && rawIdx < this._rawCount)) {
	    return NaN;
	  }
	
	  var dimStore = this._storage[dim];
	
	  if (!dimStore) {
	    // TODO Warn ?
	    return NaN;
	  }
	
	  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
	  var chunkOffset = rawIdx % this._chunkSize;
	  var chunkStore = dimStore[chunkIndex];
	  return chunkStore[chunkOffset];
	};
	/**
	 * FIXME Use `get` on chrome maybe slow(in filterSelf and selectRange).
	 * Hack a much simpler _getFast
	 * @private
	 */
	
	
	listProto._getFast = function (dim, rawIdx) {
	  var chunkIndex = Math.floor(rawIdx / this._chunkSize);
	  var chunkOffset = rawIdx % this._chunkSize;
	  var chunkStore = this._storage[dim][chunkIndex];
	  return chunkStore[chunkOffset];
	};
	/**
	 * Get value for multi dimensions.
	 * @param {Array.<string>} [dimensions] If ignored, using all dimensions.
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getValues = function (dimensions, idx
	/*, stack */
	) {
	  var values = [];
	
	  if (!zrUtil.isArray(dimensions)) {
	    // stack = idx;
	    idx = dimensions;
	    dimensions = this.dimensions;
	  }
	
	  for (var i = 0, len = dimensions.length; i < len; i++) {
	    values.push(this.get(dimensions[i], idx
	    /*, stack */
	    ));
	  }
	
	  return values;
	};
	/**
	 * If value is NaN. Inlcuding '-'
	 * Only check the coord dimensions.
	 * @param {string} dim
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.hasValue = function (idx) {
	  var dataDimsOnCoord = this._dimensionsSummary.dataDimsOnCoord;
	
	  for (var i = 0, len = dataDimsOnCoord.length; i < len; i++) {
	    // Ordinal type originally can be string or number.
	    // But when an ordinal type is used on coord, it can
	    // not be string but only number. So we can also use isNaN.
	    if (isNaN(this.get(dataDimsOnCoord[i], idx))) {
	      return false;
	    }
	  }
	
	  return true;
	};
	/**
	 * Get extent of data in one dimension
	 * @param {string} dim
	 * @param {boolean} stack
	 */
	
	
	listProto.getDataExtent = function (dim
	/*, stack */
	) {
	  // Make sure use concrete dim as cache name.
	  dim = this.getDimension(dim);
	  var dimData = this._storage[dim];
	  var initialExtent = getInitialExtent(); // stack = !!((stack || false) && this.getCalculationInfo(dim));
	
	  if (!dimData) {
	    return initialExtent;
	  } // Make more strict checkings to ensure hitting cache.
	
	
	  var currEnd = this.count(); // var cacheName = [dim, !!stack].join('_');
	  // var cacheName = dim;
	  // Consider the most cases when using data zoom, `getDataExtent`
	  // happened before filtering. We cache raw extent, which is not
	  // necessary to be cleared and recalculated when restore data.
	
	  var useRaw = !this._indices; // && !stack;
	
	  var dimExtent;
	
	  if (useRaw) {
	    return this._rawExtent[dim].slice();
	  }
	
	  dimExtent = this._extent[dim];
	
	  if (dimExtent) {
	    return dimExtent.slice();
	  }
	
	  dimExtent = initialExtent;
	  var min = dimExtent[0];
	  var max = dimExtent[1];
	
	  for (var i = 0; i < currEnd; i++) {
	    // var value = stack ? this.get(dim, i, true) : this._getFast(dim, this.getRawIndex(i));
	    var value = this._getFast(dim, this.getRawIndex(i));
	
	    value < min && (min = value);
	    value > max && (max = value);
	  }
	
	  dimExtent = [min, max];
	  this._extent[dim] = dimExtent;
	  return dimExtent;
	};
	/**
	 * Optimize for the scenario that data is filtered by a given extent.
	 * Consider that if data amount is more than hundreds of thousand,
	 * extent calculation will cost more than 10ms and the cache will
	 * be erased because of the filtering.
	 */
	
	
	listProto.getApproximateExtent = function (dim
	/*, stack */
	) {
	  dim = this.getDimension(dim);
	  return this._approximateExtent[dim] || this.getDataExtent(dim
	  /*, stack */
	  );
	};
	
	listProto.setApproximateExtent = function (extent, dim
	/*, stack */
	) {
	  dim = this.getDimension(dim);
	  this._approximateExtent[dim] = extent.slice();
	};
	/**
	 * @param {string} key
	 * @return {*}
	 */
	
	
	listProto.getCalculationInfo = function (key) {
	  return this._calculationInfo[key];
	};
	/**
	 * @param {string|Object} key or k-v object
	 * @param {*} [value]
	 */
	
	
	listProto.setCalculationInfo = function (key, value) {
	  isObject(key) ? zrUtil.extend(this._calculationInfo, key) : this._calculationInfo[key] = value;
	};
	/**
	 * Get sum of data in one dimension
	 * @param {string} dim
	 */
	
	
	listProto.getSum = function (dim
	/*, stack */
	) {
	  var dimData = this._storage[dim];
	  var sum = 0;
	
	  if (dimData) {
	    for (var i = 0, len = this.count(); i < len; i++) {
	      var value = this.get(dim, i
	      /*, stack */
	      );
	
	      if (!isNaN(value)) {
	        sum += value;
	      }
	    }
	  }
	
	  return sum;
	};
	/**
	 * Get median of data in one dimension
	 * @param {string} dim
	 */
	
	
	listProto.getMedian = function (dim
	/*, stack */
	) {
	  var dimDataArray = []; // map all data of one dimension
	
	  this.each(dim, function (val, idx) {
	    if (!isNaN(val)) {
	      dimDataArray.push(val);
	    }
	  }); // TODO
	  // Use quick select?
	  // immutability & sort
	
	  var sortedDimDataArray = [].concat(dimDataArray).sort(function (a, b) {
	    return a - b;
	  });
	  var len = this.count(); // calculate median
	
	  return len === 0 ? 0 : len % 2 === 1 ? sortedDimDataArray[(len - 1) / 2] : (sortedDimDataArray[len / 2] + sortedDimDataArray[len / 2 - 1]) / 2;
	}; // /**
	//  * Retreive the index with given value
	//  * @param {string} dim Concrete dimension.
	//  * @param {number} value
	//  * @return {number}
	//  */
	// Currently incorrect: should return dataIndex but not rawIndex.
	// Do not fix it until this method is to be used somewhere.
	// FIXME Precision of float value
	// listProto.indexOf = function (dim, value) {
	//     var storage = this._storage;
	//     var dimData = storage[dim];
	//     var chunkSize = this._chunkSize;
	//     if (dimData) {
	//         for (var i = 0, len = this.count(); i < len; i++) {
	//             var chunkIndex = Math.floor(i / chunkSize);
	//             var chunkOffset = i % chunkSize;
	//             if (dimData[chunkIndex][chunkOffset] === value) {
	//                 return i;
	//             }
	//         }
	//     }
	//     return -1;
	// };
	
	/**
	 * Only support the dimension which inverted index created.
	 * Do not support other cases until required.
	 * @param {string} concrete dim
	 * @param {number|string} value
	 * @return {number} rawIndex
	 */
	
	
	listProto.rawIndexOf = function (dim, value) {
	  var invertedIndices = dim && this._invertedIndicesMap[dim];
	  var rawIndex = invertedIndices[value];
	
	  if (rawIndex == null || isNaN(rawIndex)) {
	    return INDEX_NOT_FOUND;
	  }
	
	  return rawIndex;
	};
	/**
	 * Retreive the index with given name
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfName = function (name) {
	  for (var i = 0, len = this.count(); i < len; i++) {
	    if (this.getName(i) === name) {
	      return i;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index with given raw data index
	 * @param {number} idx
	 * @param {number} name
	 * @return {number}
	 */
	
	
	listProto.indexOfRawIndex = function (rawIndex) {
	  if (rawIndex >= this._rawCount || rawIndex < 0) {
	    return -1;
	  }
	
	  if (!this._indices) {
	    return rawIndex;
	  } // Indices are ascending
	
	
	  var indices = this._indices; // If rawIndex === dataIndex
	
	  var rawDataIndex = indices[rawIndex];
	
	  if (rawDataIndex != null && rawDataIndex < this._count && rawDataIndex === rawIndex) {
	    return rawIndex;
	  }
	
	  var left = 0;
	  var right = this._count - 1;
	
	  while (left <= right) {
	    var mid = (left + right) / 2 | 0;
	
	    if (indices[mid] < rawIndex) {
	      left = mid + 1;
	    } else if (indices[mid] > rawIndex) {
	      right = mid - 1;
	    } else {
	      return mid;
	    }
	  }
	
	  return -1;
	};
	/**
	 * Retreive the index of nearest value
	 * @param {string} dim
	 * @param {number} value
	 * @param {number} [maxDistance=Infinity]
	 * @return {Array.<number>} If and only if multiple indices has
	 *        the same value, they are put to the result.
	 */
	
	
	listProto.indicesOfNearest = function (dim, value, maxDistance) {
	  var storage = this._storage;
	  var dimData = storage[dim];
	  var nearestIndices = [];
	
	  if (!dimData) {
	    return nearestIndices;
	  }
	
	  if (maxDistance == null) {
	    maxDistance = Infinity;
	  }
	
	  var minDist = Infinity;
	  var minDiff = -1;
	  var nearestIndicesLen = 0; // Check the test case of `test/ut/spec/data/List.js`.
	
	  for (var i = 0, len = this.count(); i < len; i++) {
	    var diff = value - this.get(dim, i);
	    var dist = Math.abs(diff);
	
	    if (dist <= maxDistance) {
	      // When the `value` is at the middle of `this.get(dim, i)` and `this.get(dim, i+1)`,
	      // we'd better not push both of them to `nearestIndices`, otherwise it is easy to
	      // get more than one item in `nearestIndices` (more specifically, in `tooltip`).
	      // So we chose the one that `diff >= 0` in this csae.
	      // But if `this.get(dim, i)` and `this.get(dim, j)` get the same value, both of them
	      // should be push to `nearestIndices`.
	      if (dist < minDist || dist === minDist && diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        nearestIndicesLen = 0;
	      }
	
	      if (diff === minDiff) {
	        nearestIndices[nearestIndicesLen++] = i;
	      }
	    }
	  }
	
	  nearestIndices.length = nearestIndicesLen;
	  return nearestIndices;
	};
	/**
	 * Get raw data index
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawIndex = getRawIndexWithoutIndices;
	
	function getRawIndexWithoutIndices(idx) {
	  return idx;
	}
	
	function getRawIndexWithIndices(idx) {
	  if (idx < this._count && idx >= 0) {
	    return this._indices[idx];
	  }
	
	  return -1;
	}
	/**
	 * Get raw data item
	 * @param {number} idx
	 * @return {number}
	 */
	
	
	listProto.getRawDataItem = function (idx) {
	  if (!this._rawData.persistent) {
	    var val = [];
	
	    for (var i = 0; i < this.dimensions.length; i++) {
	      var dim = this.dimensions[i];
	      val.push(this.get(dim, idx));
	    }
	
	    return val;
	  } else {
	    return this._rawData.getItem(this.getRawIndex(idx));
	  }
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getName = function (idx) {
	  var rawIndex = this.getRawIndex(idx);
	  return this._nameList[rawIndex] || getRawValueFromStore(this, this._nameDimIdx, rawIndex) || '';
	};
	/**
	 * @param {number} idx
	 * @param {boolean} [notDefaultIdx=false]
	 * @return {string}
	 */
	
	
	listProto.getId = function (idx) {
	  return getId(this, this.getRawIndex(idx));
	};
	
	function getId(list, rawIndex) {
	  var id = list._idList[rawIndex];
	
	  if (id == null) {
	    id = getRawValueFromStore(list, list._idDimIdx, rawIndex);
	  }
	
	  if (id == null) {
	    // FIXME Check the usage in graph, should not use prefix.
	    id = ID_PREFIX + rawIndex;
	  }
	
	  return id;
	}
	
	function normalizeDimensions(dimensions) {
	  if (!zrUtil.isArray(dimensions)) {
	    dimensions = [dimensions];
	  }
	
	  return dimensions;
	}
	
	function validateDimensions(list, dims) {
	  for (var i = 0; i < dims.length; i++) {
	    // stroage may be empty when no data, so use
	    // dimensionInfos to check.
	    if (!list._dimensionInfos[dims[i]]) {
	      console.error('Unkown dimension ' + dims[i]);
	    }
	  }
	}
	/**
	 * Data iteration
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {*} [context=this]
	 *
	 * @example
	 *  list.each('x', function (x, idx) {});
	 *  list.each(['x', 'y'], function (x, y, idx) {});
	 *  list.each(function (idx) {})
	 */
	
	
	listProto.each = function (dims, cb, context, contextCompat) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  if (typeof dims === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dims;
	    dims = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  dims = zrUtil.map(normalizeDimensions(dims), this.getDimension, this);
	  var dimSize = dims.length;
	
	  for (var i = 0; i < this.count(); i++) {
	    // Simple optimization
	    switch (dimSize) {
	      case 0:
	        cb.call(context, i);
	        break;
	
	      case 1:
	        cb.call(context, this.get(dims[0], i), i);
	        break;
	
	      case 2:
	        cb.call(context, this.get(dims[0], i), this.get(dims[1], i), i);
	        break;
	
	      default:
	        var k = 0;
	        var value = [];
	
	        for (; k < dimSize; k++) {
	          value[k] = this.get(dims[k], i);
	        } // Index
	
	
	        value[k] = i;
	        cb.apply(context, value);
	    }
	  }
	};
	/**
	 * Data filter
	 * @param {string|Array.<string>}
	 * @param {Function} cb
	 * @param {*} [context=this]
	 */
	
	
	listProto.filterSelf = function (dimensions, cb, context, contextCompat) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  if (typeof dimensions === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dimensions;
	    dimensions = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var count = this.count();
	  var Ctor = getIndicesCtor(this);
	  var newIndices = new Ctor(count);
	  var value = [];
	  var dimSize = dimensions.length;
	  var offset = 0;
	  var dim0 = dimensions[0];
	
	  for (var i = 0; i < count; i++) {
	    var keep;
	    var rawIdx = this.getRawIndex(i); // Simple optimization
	
	    if (dimSize === 0) {
	      keep = cb.call(context, i);
	    } else if (dimSize === 1) {
	      var val = this._getFast(dim0, rawIdx);
	
	      keep = cb.call(context, val, i);
	    } else {
	      for (var k = 0; k < dimSize; k++) {
	        value[k] = this._getFast(dim0, rawIdx);
	      }
	
	      value[k] = i;
	      keep = cb.apply(context, value);
	    }
	
	    if (keep) {
	      newIndices[offset++] = rawIdx;
	    }
	  } // Set indices after filtered.
	
	
	  if (offset < count) {
	    this._indices = newIndices;
	  }
	
	  this._count = offset; // Reset data extent
	
	  this._extent = {};
	  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return this;
	};
	/**
	 * Select data in range. (For optimization of filter)
	 * (Manually inline code, support 5 million data filtering in data zoom.)
	 */
	
	
	listProto.selectRange = function (range) {
	  'use strict';
	
	  if (!this._count) {
	    return;
	  }
	
	  var dimensions = [];
	
	  for (var dim in range) {
	    if (range.hasOwnProperty(dim)) {
	      dimensions.push(dim);
	    }
	  }
	
	  var dimSize = dimensions.length;
	
	  if (!dimSize) {
	    return;
	  }
	
	  var originalCount = this.count();
	  var Ctor = getIndicesCtor(this);
	  var newIndices = new Ctor(originalCount);
	  var offset = 0;
	  var dim0 = dimensions[0];
	  var min = range[dim0][0];
	  var max = range[dim0][1];
	  var quickFinished = false;
	
	  if (!this._indices) {
	    // Extreme optimization for common case. About 2x faster in chrome.
	    var idx = 0;
	
	    if (dimSize === 1) {
	      var dimStorage = this._storage[dimensions[0]];
	
	      for (var k = 0; k < this._chunkCount; k++) {
	        var chunkStorage = dimStorage[k];
	        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
	
	        for (var i = 0; i < len; i++) {
	          var val = chunkStorage[i]; // NaN will not be filtered. Consider the case, in line chart, empty
	          // value indicates the line should be broken. But for the case like
	          // scatter plot, a data item with empty value will not be rendered,
	          // but the axis extent may be effected if some other dim of the data
	          // item has value. Fortunately it is not a significant negative effect.
	
	          if (val >= min && val <= max || isNaN(val)) {
	            newIndices[offset++] = idx;
	          }
	
	          idx++;
	        }
	      }
	
	      quickFinished = true;
	    } else if (dimSize === 2) {
	      var dimStorage = this._storage[dim0];
	      var dimStorage2 = this._storage[dimensions[1]];
	      var min2 = range[dimensions[1]][0];
	      var max2 = range[dimensions[1]][1];
	
	      for (var k = 0; k < this._chunkCount; k++) {
	        var chunkStorage = dimStorage[k];
	        var chunkStorage2 = dimStorage2[k];
	        var len = Math.min(this._count - k * this._chunkSize, this._chunkSize);
	
	        for (var i = 0; i < len; i++) {
	          var val = chunkStorage[i];
	          var val2 = chunkStorage2[i]; // Do not filter NaN, see comment above.
	
	          if ((val >= min && val <= max || isNaN(val)) && (val2 >= min2 && val2 <= max2 || isNaN(val2))) {
	            newIndices[offset++] = idx;
	          }
	
	          idx++;
	        }
	      }
	
	      quickFinished = true;
	    }
	  }
	
	  if (!quickFinished) {
	    if (dimSize === 1) {
	      for (var i = 0; i < originalCount; i++) {
	        var rawIndex = this.getRawIndex(i);
	
	        var val = this._getFast(dim0, rawIndex); // Do not filter NaN, see comment above.
	
	
	        if (val >= min && val <= max || isNaN(val)) {
	          newIndices[offset++] = rawIndex;
	        }
	      }
	    } else {
	      for (var i = 0; i < originalCount; i++) {
	        var keep = true;
	        var rawIndex = this.getRawIndex(i);
	
	        for (var k = 0; k < dimSize; k++) {
	          var dimk = dimensions[k];
	
	          var val = this._getFast(dim, rawIndex); // Do not filter NaN, see comment above.
	
	
	          if (val < range[dimk][0] || val > range[dimk][1]) {
	            keep = false;
	          }
	        }
	
	        if (keep) {
	          newIndices[offset++] = this.getRawIndex(i);
	        }
	      }
	    }
	  } // Set indices after filtered.
	
	
	  if (offset < originalCount) {
	    this._indices = newIndices;
	  }
	
	  this._count = offset; // Reset data extent
	
	  this._extent = {};
	  this.getRawIndex = this._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return this;
	};
	/**
	 * Data mapping to a plain array
	 * @param {string|Array.<string>} [dimensions]
	 * @param {Function} cb
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.mapArray = function (dimensions, cb, context, contextCompat) {
	  'use strict';
	
	  if (typeof dimensions === 'function') {
	    contextCompat = context;
	    context = cb;
	    cb = dimensions;
	    dimensions = [];
	  } // contextCompat just for compat echarts3
	
	
	  context = context || contextCompat || this;
	  var result = [];
	  this.each(dimensions, function () {
	    result.push(cb && cb.apply(this, arguments));
	  }, context);
	  return result;
	}; // Data in excludeDimensions is copied, otherwise transfered.
	
	
	function cloneListForMapAndSample(original, excludeDimensions) {
	  var allDimensions = original.dimensions;
	  var list = new List(zrUtil.map(allDimensions, original.getDimensionInfo, original), original.hostModel); // FIXME If needs stackedOn, value may already been stacked
	
	  transferProperties(list, original);
	  var storage = list._storage = {};
	  var originalStorage = original._storage; // Init storage
	
	  for (var i = 0; i < allDimensions.length; i++) {
	    var dim = allDimensions[i];
	
	    if (originalStorage[dim]) {
	      // Notice that we do not reset invertedIndicesMap here, becuase
	      // there is no scenario of mapping or sampling ordinal dimension.
	      if (zrUtil.indexOf(excludeDimensions, dim) >= 0) {
	        storage[dim] = cloneDimStore(originalStorage[dim]);
	        list._rawExtent[dim] = getInitialExtent();
	        list._extent[dim] = null;
	      } else {
	        // Direct reference for other dimensions
	        storage[dim] = originalStorage[dim];
	      }
	    }
	  }
	
	  return list;
	}
	
	function cloneDimStore(originalDimStore) {
	  var newDimStore = new Array(originalDimStore.length);
	
	  for (var j = 0; j < originalDimStore.length; j++) {
	    newDimStore[j] = cloneChunk(originalDimStore[j]);
	  }
	
	  return newDimStore;
	}
	
	function getInitialExtent() {
	  return [Infinity, -Infinity];
	}
	/**
	 * Data mapping to a new List with given dimensions
	 * @param {string|Array.<string>} dimensions
	 * @param {Function} cb
	 * @param {*} [context=this]
	 * @return {Array}
	 */
	
	
	listProto.map = function (dimensions, cb, context, contextCompat) {
	  'use strict'; // contextCompat just for compat echarts3
	
	  context = context || contextCompat || this;
	  dimensions = zrUtil.map(normalizeDimensions(dimensions), this.getDimension, this);
	  var list = cloneListForMapAndSample(this, dimensions); // Following properties are all immutable.
	  // So we can reference to the same value
	
	  list._indices = this._indices;
	  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  var storage = list._storage;
	  var tmpRetValue = [];
	  var chunkSize = this._chunkSize;
	  var dimSize = dimensions.length;
	  var dataCount = this.count();
	  var values = [];
	  var rawExtent = list._rawExtent;
	
	  for (var dataIndex = 0; dataIndex < dataCount; dataIndex++) {
	    for (var dimIndex = 0; dimIndex < dimSize; dimIndex++) {
	      values[dimIndex] = this.get(dimensions[dimIndex], dataIndex
	      /*, stack */
	      );
	    }
	
	    values[dimSize] = dataIndex;
	    var retValue = cb && cb.apply(context, values);
	
	    if (retValue != null) {
	      // a number or string (in oridinal dimension)?
	      if (typeof retValue !== 'object') {
	        tmpRetValue[0] = retValue;
	        retValue = tmpRetValue;
	      }
	
	      var rawIndex = this.getRawIndex(dataIndex);
	      var chunkIndex = Math.floor(rawIndex / chunkSize);
	      var chunkOffset = rawIndex % chunkSize;
	
	      for (var i = 0; i < retValue.length; i++) {
	        var dim = dimensions[i];
	        var val = retValue[i];
	        var rawExtentOnDim = rawExtent[dim];
	        var dimStore = storage[dim];
	
	        if (dimStore) {
	          dimStore[chunkIndex][chunkOffset] = val;
	        }
	
	        if (val < rawExtentOnDim[0]) {
	          rawExtentOnDim[0] = val;
	        }
	
	        if (val > rawExtentOnDim[1]) {
	          rawExtentOnDim[1] = val;
	        }
	      }
	    }
	  }
	
	  return list;
	};
	/**
	 * Large data down sampling on given dimension
	 * @param {string} dimension
	 * @param {number} rate
	 * @param {Function} sampleValue
	 * @param {Function} sampleIndex Sample index for name and id
	 */
	
	
	listProto.downSample = function (dimension, rate, sampleValue, sampleIndex) {
	  var list = cloneListForMapAndSample(this, [dimension]);
	  var targetStorage = list._storage;
	  var frameValues = [];
	  var frameSize = Math.floor(1 / rate);
	  var dimStore = targetStorage[dimension];
	  var len = this.count();
	  var chunkSize = this._chunkSize;
	  var rawExtentOnDim = list._rawExtent[dimension];
	  var newIndices = new (getIndicesCtor(this))(len);
	  var offset = 0;
	
	  for (var i = 0; i < len; i += frameSize) {
	    // Last frame
	    if (frameSize > len - i) {
	      frameSize = len - i;
	      frameValues.length = frameSize;
	    }
	
	    for (var k = 0; k < frameSize; k++) {
	      var dataIdx = this.getRawIndex(i + k);
	      var originalChunkIndex = Math.floor(dataIdx / chunkSize);
	      var originalChunkOffset = dataIdx % chunkSize;
	      frameValues[k] = dimStore[originalChunkIndex][originalChunkOffset];
	    }
	
	    var value = sampleValue(frameValues);
	    var sampleFrameIdx = this.getRawIndex(Math.min(i + sampleIndex(frameValues, value) || 0, len - 1));
	    var sampleChunkIndex = Math.floor(sampleFrameIdx / chunkSize);
	    var sampleChunkOffset = sampleFrameIdx % chunkSize; // Only write value on the filtered data
	
	    dimStore[sampleChunkIndex][sampleChunkOffset] = value;
	
	    if (value < rawExtentOnDim[0]) {
	      rawExtentOnDim[0] = value;
	    }
	
	    if (value > rawExtentOnDim[1]) {
	      rawExtentOnDim[1] = value;
	    }
	
	    newIndices[offset++] = sampleFrameIdx;
	  }
	
	  list._count = offset;
	  list._indices = newIndices;
	  list.getRawIndex = getRawIndexWithIndices;
	  return list;
	};
	/**
	 * Get model of one data item.
	 *
	 * @param {number} idx
	 */
	// FIXME Model proxy ?
	
	
	listProto.getItemModel = function (idx) {
	  var hostModel = this.hostModel;
	  return new Model(this.getRawDataItem(idx), hostModel, hostModel && hostModel.ecModel);
	};
	/**
	 * Create a data differ
	 * @param {module:echarts/data/List} otherList
	 * @return {module:echarts/data/DataDiffer}
	 */
	
	
	listProto.diff = function (otherList) {
	  var thisList = this;
	  return new DataDiffer(otherList ? otherList.getIndices() : [], this.getIndices(), function (idx) {
	    return getId(otherList, idx);
	  }, function (idx) {
	    return getId(thisList, idx);
	  });
	};
	/**
	 * Get visual property.
	 * @param {string} key
	 */
	
	
	listProto.getVisual = function (key) {
	  var visual = this._visual;
	  return visual && visual[key];
	};
	/**
	 * Set visual property
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setVisual('color', color);
	 *  setVisual({
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setVisual = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setVisual(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._visual = this._visual || {};
	  this._visual[key] = val;
	};
	/**
	 * Set layout property.
	 * @param {string|Object} key
	 * @param {*} [val]
	 */
	
	
	listProto.setLayout = function (key, val) {
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        this.setLayout(name, key[name]);
	      }
	    }
	
	    return;
	  }
	
	  this._layout[key] = val;
	};
	/**
	 * Get layout property.
	 * @param  {string} key.
	 * @return {*}
	 */
	
	
	listProto.getLayout = function (key) {
	  return this._layout[key];
	};
	/**
	 * Get layout of single data item
	 * @param {number} idx
	 */
	
	
	listProto.getItemLayout = function (idx) {
	  return this._itemLayouts[idx];
	};
	/**
	 * Set layout of single data item
	 * @param {number} idx
	 * @param {Object} layout
	 * @param {boolean=} [merge=false]
	 */
	
	
	listProto.setItemLayout = function (idx, layout, merge) {
	  this._itemLayouts[idx] = merge ? zrUtil.extend(this._itemLayouts[idx] || {}, layout) : layout;
	};
	/**
	 * Clear all layout of single data item
	 */
	
	
	listProto.clearItemLayouts = function () {
	  this._itemLayouts.length = 0;
	};
	/**
	 * Get visual property of single data item
	 * @param {number} idx
	 * @param {string} key
	 * @param {boolean} [ignoreParent=false]
	 */
	
	
	listProto.getItemVisual = function (idx, key, ignoreParent) {
	  var itemVisual = this._itemVisuals[idx];
	  var val = itemVisual && itemVisual[key];
	
	  if (val == null && !ignoreParent) {
	    // Use global visual property
	    return this.getVisual(key);
	  }
	
	  return val;
	};
	/**
	 * Set visual property of single data item
	 *
	 * @param {number} idx
	 * @param {string|Object} key
	 * @param {*} [value]
	 *
	 * @example
	 *  setItemVisual(0, 'color', color);
	 *  setItemVisual(0, {
	 *      'color': color
	 *  });
	 */
	
	
	listProto.setItemVisual = function (idx, key, value) {
	  var itemVisual = this._itemVisuals[idx] || {};
	  var hasItemVisual = this.hasItemVisual;
	  this._itemVisuals[idx] = itemVisual;
	
	  if (isObject(key)) {
	    for (var name in key) {
	      if (key.hasOwnProperty(name)) {
	        itemVisual[name] = key[name];
	        hasItemVisual[name] = true;
	      }
	    }
	
	    return;
	  }
	
	  itemVisual[key] = value;
	  hasItemVisual[key] = true;
	};
	/**
	 * Clear itemVisuals and list visual.
	 */
	
	
	listProto.clearAllVisual = function () {
	  this._visual = {};
	  this._itemVisuals = [];
	  this.hasItemVisual = {};
	};
	
	var setItemDataAndSeriesIndex = function (child) {
	  child.seriesIndex = this.seriesIndex;
	  child.dataIndex = this.dataIndex;
	  child.dataType = this.dataType;
	};
	/**
	 * Set graphic element relative to data. It can be set as null
	 * @param {number} idx
	 * @param {module:zrender/Element} [el]
	 */
	
	
	listProto.setItemGraphicEl = function (idx, el) {
	  var hostModel = this.hostModel;
	
	  if (el) {
	    // Add data index and series index for indexing the data by element
	    // Useful in tooltip
	    el.dataIndex = idx;
	    el.dataType = this.dataType;
	    el.seriesIndex = hostModel && hostModel.seriesIndex;
	
	    if (el.type === 'group') {
	      el.traverse(setItemDataAndSeriesIndex, el);
	    }
	  }
	
	  this._graphicEls[idx] = el;
	};
	/**
	 * @param {number} idx
	 * @return {module:zrender/Element}
	 */
	
	
	listProto.getItemGraphicEl = function (idx) {
	  return this._graphicEls[idx];
	};
	/**
	 * @param {Function} cb
	 * @param {*} context
	 */
	
	
	listProto.eachItemGraphicEl = function (cb, context) {
	  zrUtil.each(this._graphicEls, function (el, idx) {
	    if (el) {
	      cb && cb.call(context, el, idx);
	    }
	  });
	};
	/**
	 * Shallow clone a new list except visual and layout properties, and graph elements.
	 * New list only change the indices.
	 */
	
	
	listProto.cloneShallow = function (list) {
	  if (!list) {
	    var dimensionInfoList = zrUtil.map(this.dimensions, this.getDimensionInfo, this);
	    list = new List(dimensionInfoList, this.hostModel);
	  } // FIXME
	
	
	  list._storage = this._storage;
	  transferProperties(list, this); // Clone will not change the data extent and indices
	
	  if (this._indices) {
	    var Ctor = this._indices.constructor;
	    list._indices = new Ctor(this._indices);
	  } else {
	    list._indices = null;
	  }
	
	  list.getRawIndex = list._indices ? getRawIndexWithIndices : getRawIndexWithoutIndices;
	  return list;
	};
	/**
	 * Wrap some method to add more feature
	 * @param {string} methodName
	 * @param {Function} injectFunction
	 */
	
	
	listProto.wrapMethod = function (methodName, injectFunction) {
	  var originalMethod = this[methodName];
	
	  if (typeof originalMethod !== 'function') {
	    return;
	  }
	
	  this.__wrappedMethods = this.__wrappedMethods || [];
	
	  this.__wrappedMethods.push(methodName);
	
	  this[methodName] = function () {
	    var res = originalMethod.apply(this, arguments);
	    return injectFunction.apply(this, [res].concat(zrUtil.slice(arguments)));
	  };
	}; // Methods that create a new list based on this list should be listed here.
	// Notice that those method should `RETURN` the new list.
	
	
	listProto.TRANSFERABLE_METHODS = ['cloneShallow', 'downSample', 'map']; // Methods that change indices of this list should be listed here.
	
	listProto.CHANGABLE_METHODS = ['filterSelf', 'selectRange'];
	var _default = List;
	module.exports = _default;

/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var BoundingRect = __webpack_require__(60);
	
	var _text = __webpack_require__(102);
	
	var calculateTextPosition = _text.calculateTextPosition;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Symbol factory
	
	/**
	 * Triangle shape
	 * @inner
	 */
	var Triangle = graphic.extendShape({
	  type: 'triangle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy + height);
	    path.lineTo(cx - width, cy + height);
	    path.closePath();
	  }
	});
	/**
	 * Diamond shape
	 * @inner
	 */
	
	var Diamond = graphic.extendShape({
	  type: 'diamond',
	  shape: {
	    cx: 0,
	    cy: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var cx = shape.cx;
	    var cy = shape.cy;
	    var width = shape.width / 2;
	    var height = shape.height / 2;
	    path.moveTo(cx, cy - height);
	    path.lineTo(cx + width, cy);
	    path.lineTo(cx, cy + height);
	    path.lineTo(cx - width, cy);
	    path.closePath();
	  }
	});
	/**
	 * Pin shape
	 * @inner
	 */
	
	var Pin = graphic.extendShape({
	  type: 'pin',
	  shape: {
	    // x, y on the cusp
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (path, shape) {
	    var x = shape.x;
	    var y = shape.y;
	    var w = shape.width / 5 * 3; // Height must be larger than width
	
	    var h = Math.max(w, shape.height);
	    var r = w / 2; // Dist on y with tangent point and circle center
	
	    var dy = r * r / (h - r);
	    var cy = y - h + r + dy;
	    var angle = Math.asin(dy / r); // Dist on x with tangent point and circle center
	
	    var dx = Math.cos(angle) * r;
	    var tanX = Math.sin(angle);
	    var tanY = Math.cos(angle);
	    var cpLen = r * 0.6;
	    var cpLen2 = r * 0.7;
	    path.moveTo(x - dx, cy + dy);
	    path.arc(x, cy, r, Math.PI - angle, Math.PI * 2 + angle);
	    path.bezierCurveTo(x + dx - tanX * cpLen, cy + dy + tanY * cpLen, x, y - cpLen2, x, y);
	    path.bezierCurveTo(x, y - cpLen2, x - dx + tanX * cpLen, cy + dy + tanY * cpLen, x - dx, cy + dy);
	    path.closePath();
	  }
	});
	/**
	 * Arrow shape
	 * @inner
	 */
	
	var Arrow = graphic.extendShape({
	  type: 'arrow',
	  shape: {
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var height = shape.height;
	    var width = shape.width;
	    var x = shape.x;
	    var y = shape.y;
	    var dx = width / 3 * 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(x + dx, y + height);
	    ctx.lineTo(x, y + height / 4 * 3);
	    ctx.lineTo(x - dx, y + height);
	    ctx.lineTo(x, y);
	    ctx.closePath();
	  }
	});
	/**
	 * Map of path contructors
	 * @type {Object.<string, module:zrender/graphic/Path>}
	 */
	
	var symbolCtors = {
	  line: graphic.Line,
	  rect: graphic.Rect,
	  roundRect: graphic.Rect,
	  square: graphic.Rect,
	  circle: graphic.Circle,
	  diamond: Diamond,
	  pin: Pin,
	  arrow: Arrow,
	  triangle: Triangle
	};
	var symbolShapeMakers = {
	  line: function (x, y, w, h, shape) {
	    // FIXME
	    shape.x1 = x;
	    shape.y1 = y + h / 2;
	    shape.x2 = x + w;
	    shape.y2 = y + h / 2;
	  },
	  rect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	  },
	  roundRect: function (x, y, w, h, shape) {
	    shape.x = x;
	    shape.y = y;
	    shape.width = w;
	    shape.height = h;
	    shape.r = Math.min(w, h) / 4;
	  },
	  square: function (x, y, w, h, shape) {
	    var size = Math.min(w, h);
	    shape.x = x;
	    shape.y = y;
	    shape.width = size;
	    shape.height = size;
	  },
	  circle: function (x, y, w, h, shape) {
	    // Put circle in the center of square
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.r = Math.min(w, h) / 2;
	  },
	  diamond: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  pin: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  arrow: function (x, y, w, h, shape) {
	    shape.x = x + w / 2;
	    shape.y = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  },
	  triangle: function (x, y, w, h, shape) {
	    shape.cx = x + w / 2;
	    shape.cy = y + h / 2;
	    shape.width = w;
	    shape.height = h;
	  }
	};
	var symbolBuildProxies = {};
	zrUtil.each(symbolCtors, function (Ctor, name) {
	  symbolBuildProxies[name] = new Ctor();
	});
	var SymbolClz = graphic.extendShape({
	  type: 'symbol',
	  shape: {
	    symbolType: '',
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  calculateTextPosition: function (out, style, rect) {
	    var res = calculateTextPosition(out, style, rect);
	    var shape = this.shape;
	
	    if (shape && shape.symbolType === 'pin' && style.textPosition === 'inside') {
	      res.y = rect.y + rect.height * 0.4;
	    }
	
	    return res;
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    var symbolType = shape.symbolType;
	
	    if (symbolType !== 'none') {
	      var proxySymbol = symbolBuildProxies[symbolType];
	
	      if (!proxySymbol) {
	        // Default rect
	        symbolType = 'rect';
	        proxySymbol = symbolBuildProxies[symbolType];
	      }
	
	      symbolShapeMakers[symbolType](shape.x, shape.y, shape.width, shape.height, proxySymbol.shape);
	      proxySymbol.buildPath(ctx, proxySymbol.shape, inBundle);
	    }
	  }
	}); // Provide setColor helper method to avoid determine if set the fill or stroke outside
	
	function symbolPathSetColor(color, innerColor) {
	  if (this.type !== 'image') {
	    var symbolStyle = this.style;
	    var symbolShape = this.shape;
	
	    if (symbolShape && symbolShape.symbolType === 'line') {
	      symbolStyle.stroke = color;
	    } else if (this.__isEmptyBrush) {
	      symbolStyle.stroke = color;
	      symbolStyle.fill = innerColor || '#fff';
	    } else {
	      // FIXME 判断图形默认是填充还是描边，使用 onlyStroke ?
	      symbolStyle.fill && (symbolStyle.fill = color);
	      symbolStyle.stroke && (symbolStyle.stroke = color);
	    }
	
	    this.dirty(false);
	  }
	}
	/**
	 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	 * @param {string} symbolType
	 * @param {number} x
	 * @param {number} y
	 * @param {number} w
	 * @param {number} h
	 * @param {string} color
	 * @param {boolean} [keepAspect=false] whether to keep the ratio of w/h,
	 *                            for path and image only.
	 */
	
	
	function createSymbol(symbolType, x, y, w, h, color, keepAspect) {
	  // TODO Support image object, DynamicImage.
	  var isEmpty = symbolType.indexOf('empty') === 0;
	
	  if (isEmpty) {
	    symbolType = symbolType.substr(5, 1).toLowerCase() + symbolType.substr(6);
	  }
	
	  var symbolPath;
	
	  if (symbolType.indexOf('image://') === 0) {
	    symbolPath = graphic.makeImage(symbolType.slice(8), new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else if (symbolType.indexOf('path://') === 0) {
	    symbolPath = graphic.makePath(symbolType.slice(7), {}, new BoundingRect(x, y, w, h), keepAspect ? 'center' : 'cover');
	  } else {
	    symbolPath = new SymbolClz({
	      shape: {
	        symbolType: symbolType,
	        x: x,
	        y: y,
	        width: w,
	        height: h
	      }
	    });
	  }
	
	  symbolPath.__isEmptyBrush = isEmpty;
	  symbolPath.setColor = symbolPathSetColor;
	  symbolPath.setColor(color);
	  return symbolPath;
	}
	
	exports.createSymbol = createSymbol;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _unsafeLifecyclesPolyfill = __webpack_require__(384);
	
	var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);
	
	var _ChildrenUtils = __webpack_require__(2638);
	
	var _AnimateChild = __webpack_require__(2636);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _animate = __webpack_require__(1070);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  (0, _inherits3['default'])(Animate, _React$Component);
	
	  // eslint-disable-line
	
	  function Animate(props) {
	    (0, _classCallCheck3['default'])(this, Animate);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, (0, _defineProperty3['default'])({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = (0, _extends3['default'])({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.propTypes = {
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  component: _propTypes2['default'].any,
	  componentProps: _propTypes2['default'].object,
	  animation: _propTypes2['default'].object,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  transitionEnter: _propTypes2['default'].bool,
	  transitionAppear: _propTypes2['default'].bool,
	  exclusive: _propTypes2['default'].bool,
	  transitionLeave: _propTypes2['default'].bool,
	  onEnd: _propTypes2['default'].func,
	  onEnter: _propTypes2['default'].func,
	  onLeave: _propTypes2['default'].func,
	  onAppear: _propTypes2['default'].func,
	  showProp: _propTypes2['default'].string,
	  children: _propTypes2['default'].node
	};
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else if (type === 'appear') {
	      if (_animate2['default'].allowAppearCallback(props)) {
	        props.onAppear(key);
	        props.onEnd(key, true);
	      }
	    } else if (_animate2['default'].allowEnterCallback(props)) {
	      props.onEnter(key);
	      props.onEnd(key, true);
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_animate2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = (0, _unsafeLifecyclesPolyfill2['default'])(Animate);
	module.exports = exports['default'];

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = toArray;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function toArray(children) {
	  var ret = [];
	
	  _react.default.Children.forEach(children, function (child) {
	    if (child === undefined || child === null) {
	      return;
	    }
	
	    if (Array.isArray(child)) {
	      ret = ret.concat(toArray(child));
	    } else if ((0, _reactIs.isFragment)(child) && child.props) {
	      ret = ret.concat(toArray(child.props.children));
	    } else {
	      ret.push(child);
	    }
	  });
	
	  return ret;
	}

/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryDownloadBonusTemplate = exports.queryBackBonus = exports.queryBackAllBonus = exports.querySendBonus = exports.querySendAllBonus = exports.queryBonusDetailInfo = exports.queryBonusDetailList = exports.queryBonusStaticComMonth = exports.queryBonusWorkflow = exports.queryCallbackBonus = exports.queryReturnBonus = exports.queryNextBonus = exports.queryDeleteBonus = exports.querySaveBonus = exports.queryImportBonus = exports.queryBonusInfo = exports.queryBonusOrgRecord = exports.queryMyBonusCheckList = exports.queryBonusMyList = exports.bonus = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 年终奖
	 */
	var bonus = exports.bonus = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt("return", _http2.default.get(_req.hr.GET_BONUS_LIST, params));
	
	          case 1:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function bonus(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryBonusMyList = exports.queryBonusMyList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt("return", _http2.default.get(_req.hr.GET_BONUS_MY, params));
	
	          case 1:
	          case "end":
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryBonusMyList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryMyBonusCheckList = exports.queryMyBonusCheckList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt("return", _http2.default.get(_req.hr.GET_BONUS_CHECK, params));
	
	          case 1:
	          case "end":
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryMyBonusCheckList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryBonusOrgRecord = exports.queryBonusOrgRecord = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt("return", _http2.default.get(_req.hr.GET_BONUS_RECORD_ORG, params));
	
	          case 1:
	          case "end":
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryBonusOrgRecord(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryBonusInfo = exports.queryBonusInfo = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt("return", _http2.default.get(_req.hr.GET_BONUS_INFO, params));
	
	          case 1:
	          case "end":
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryBonusInfo(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryImportBonus = exports.queryImportBonus = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt("return", _http2.default.post(_req.hr.BONUS_IMPORT, params));
	
	          case 1:
	          case "end":
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryImportBonus(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var querySaveBonus = exports.querySaveBonus = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt("return", _http2.default.post(_req.hr.BONUS_SAVE, params));
	
	          case 1:
	          case "end":
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function querySaveBonus(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var queryDeleteBonus = exports.queryDeleteBonus = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt("return", _http2.default.get(_req.hr.BONUS_DELETE, params));
	
	          case 1:
	          case "end":
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryDeleteBonus(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryNextBonus = exports.queryNextBonus = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt("return", _http2.default.get(_req.hr.BONUS_NEXT, params));
	
	          case 1:
	          case "end":
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryNextBonus(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryReturnBonus = exports.queryReturnBonus = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt("return", _http2.default.post(_req.hr.BONUS_RETURN, params));
	
	          case 1:
	          case "end":
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryReturnBonus(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryCallbackBonus = exports.queryCallbackBonus = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt("return", _http2.default.get(_req.hr.BONUS_CALLBACK, params));
	
	          case 1:
	          case "end":
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryCallbackBonus(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var queryBonusWorkflow = exports.queryBonusWorkflow = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt("return", _http2.default.get(_req.hr.BONUS_WORKFLOW, params));
	
	          case 1:
	          case "end":
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryBonusWorkflow(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var queryBonusStaticComMonth = exports.queryBonusStaticComMonth = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt("return", _http2.default.get(_req.hr.BONUS_STATIC_C_M, params));
	
	          case 1:
	          case "end":
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryBonusStaticComMonth(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var queryBonusDetailList = exports.queryBonusDetailList = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt("return", _http2.default.get(_req.hr.BONUS_DETAIL_LIST, params));
	
	          case 1:
	          case "end":
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryBonusDetailList(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var queryBonusDetailInfo = exports.queryBonusDetailInfo = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt("return", _http2.default.get(_req.hr.BONUS_DETAIL_INFO, params));
	
	          case 1:
	          case "end":
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function queryBonusDetailInfo(_x15) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var querySendAllBonus = exports.querySendAllBonus = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(params) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            return _context16.abrupt("return", _http2.default.get(_req.hr.BONUS_SEND_ALL, params));
	
	          case 1:
	          case "end":
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function querySendAllBonus(_x16) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var querySendBonus = exports.querySendBonus = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(params) {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            return _context17.abrupt("return", _http2.default.get(_req.hr.BONUS_SEND, params));
	
	          case 1:
	          case "end":
	            return _context17.stop();
	        }
	      }
	    }, _callee17, this);
	  }));
	
	  return function querySendBonus(_x17) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	
	var queryBackAllBonus = exports.queryBackAllBonus = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(params) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            return _context18.abrupt("return", _http2.default.get(_req.hr.BONUS_BACK_ALL, params));
	
	          case 1:
	          case "end":
	            return _context18.stop();
	        }
	      }
	    }, _callee18, this);
	  }));
	
	  return function queryBackAllBonus(_x18) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	
	var queryBackBonus = exports.queryBackBonus = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(params) {
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            return _context19.abrupt("return", _http2.default.get(_req.hr.BONUS_BACK, params));
	
	          case 1:
	          case "end":
	            return _context19.stop();
	        }
	      }
	    }, _callee19, this);
	  }));
	
	  return function queryBackBonus(_x19) {
	    return _ref19.apply(this, arguments);
	  };
	}();
	
	var queryDownloadBonusTemplate = exports.queryDownloadBonusTemplate = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20() {
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            _http2.default.download(_req.hr.DOWNLOAD_BONUS_TEMPLATE, {}, '年终奖导入模板.xlsx');
	
	          case 1:
	          case "end":
	            return _context20.stop();
	        }
	      }
	    }, _callee20, this);
	  }));
	
	  return function queryDownloadBonusTemplate() {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryDownloadWageTemplate = exports.queryBackWage = exports.queryBackAllWage = exports.querySendWage = exports.querySendAllWage = exports.queryWageDetailInfo = exports.queryWageDetailList = exports.queryWageStaticComMonth = exports.queryWageWorkflow = exports.queryCallbackWage = exports.queryReturnWage = exports.queryNextWage = exports.queryDeleteWage = exports.querySaveWage = exports.queryImportWage = exports.queryWageInfo = exports.queryWageOrgRecord = exports.queryMyWageCheckList = exports.queryWageMyList = exports.queryWageList = exports.queryWageStatistic = exports.queryHrWageList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var queryHrWageList = exports.queryHrWageList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.hr.CORE_HR_WAGE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryHrWageList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 工资
	 */
	
	
	var queryWageStatistic = exports.queryWageStatistic = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.hr.WAGE_STATISTIC, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryWageStatistic(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryWageList = exports.queryWageList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.hr.GET_WAGE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryWageList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryWageMyList = exports.queryWageMyList = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.hr.GET_WAGE_MY, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryWageMyList(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryMyWageCheckList = exports.queryMyWageCheckList = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.hr.GET_WAGE_CHECK, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryMyWageCheckList(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryWageOrgRecord = exports.queryWageOrgRecord = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.hr.GET_WAGE_RECORD_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryWageOrgRecord(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryWageInfo = exports.queryWageInfo = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.hr.GET_WAGE_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryWageInfo(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var queryImportWage = exports.queryImportWage = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.post(_req.hr.WAGE_IMPORT, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryImportWage(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var querySaveWage = exports.querySaveWage = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.post(_req.hr.WAGE_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function querySaveWage(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryDeleteWage = exports.queryDeleteWage = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.hr.WAGE_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryDeleteWage(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryNextWage = exports.queryNextWage = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.get(_req.hr.WAGE_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryNextWage(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var queryReturnWage = exports.queryReturnWage = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.post(_req.hr.WAGE_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryReturnWage(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var queryCallbackWage = exports.queryCallbackWage = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.get(_req.hr.WAGE_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryCallbackWage(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var queryWageWorkflow = exports.queryWageWorkflow = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.hr.WAGE_WORKFLOW, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryWageWorkflow(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var queryWageStaticComMonth = exports.queryWageStaticComMonth = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt('return', _http2.default.get(_req.hr.WAGE_STATIC_C_M, params));
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function queryWageStaticComMonth(_x15) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var queryWageDetailList = exports.queryWageDetailList = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(params) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            return _context16.abrupt('return', _http2.default.get(_req.hr.WAGE_DETAIL_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function queryWageDetailList(_x16) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var queryWageDetailInfo = exports.queryWageDetailInfo = function () {
	  var _ref17 = _asyncToGenerator(_regenerator2.default.mark(function _callee17(params) {
	    return _regenerator2.default.wrap(function _callee17$(_context17) {
	      while (1) {
	        switch (_context17.prev = _context17.next) {
	          case 0:
	            return _context17.abrupt('return', _http2.default.get(_req.hr.WAGE_DETAIL_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context17.stop();
	        }
	      }
	    }, _callee17, this);
	  }));
	
	  return function queryWageDetailInfo(_x17) {
	    return _ref17.apply(this, arguments);
	  };
	}();
	
	var querySendAllWage = exports.querySendAllWage = function () {
	  var _ref18 = _asyncToGenerator(_regenerator2.default.mark(function _callee18(params) {
	    return _regenerator2.default.wrap(function _callee18$(_context18) {
	      while (1) {
	        switch (_context18.prev = _context18.next) {
	          case 0:
	            return _context18.abrupt('return', _http2.default.get(_req.hr.WAGE_SEND_ALL, params));
	
	          case 1:
	          case 'end':
	            return _context18.stop();
	        }
	      }
	    }, _callee18, this);
	  }));
	
	  return function querySendAllWage(_x18) {
	    return _ref18.apply(this, arguments);
	  };
	}();
	
	var querySendWage = exports.querySendWage = function () {
	  var _ref19 = _asyncToGenerator(_regenerator2.default.mark(function _callee19(params) {
	    return _regenerator2.default.wrap(function _callee19$(_context19) {
	      while (1) {
	        switch (_context19.prev = _context19.next) {
	          case 0:
	            return _context19.abrupt('return', _http2.default.get(_req.hr.WAGE_SEND, params));
	
	          case 1:
	          case 'end':
	            return _context19.stop();
	        }
	      }
	    }, _callee19, this);
	  }));
	
	  return function querySendWage(_x19) {
	    return _ref19.apply(this, arguments);
	  };
	}();
	
	var queryBackAllWage = exports.queryBackAllWage = function () {
	  var _ref20 = _asyncToGenerator(_regenerator2.default.mark(function _callee20(params) {
	    return _regenerator2.default.wrap(function _callee20$(_context20) {
	      while (1) {
	        switch (_context20.prev = _context20.next) {
	          case 0:
	            return _context20.abrupt('return', _http2.default.get(_req.hr.WAGE_BACK_ALL, params));
	
	          case 1:
	          case 'end':
	            return _context20.stop();
	        }
	      }
	    }, _callee20, this);
	  }));
	
	  return function queryBackAllWage(_x20) {
	    return _ref20.apply(this, arguments);
	  };
	}();
	
	var queryBackWage = exports.queryBackWage = function () {
	  var _ref21 = _asyncToGenerator(_regenerator2.default.mark(function _callee21(params) {
	    return _regenerator2.default.wrap(function _callee21$(_context21) {
	      while (1) {
	        switch (_context21.prev = _context21.next) {
	          case 0:
	            return _context21.abrupt('return', _http2.default.get(_req.hr.WAGE_BACK, params));
	
	          case 1:
	          case 'end':
	            return _context21.stop();
	        }
	      }
	    }, _callee21, this);
	  }));
	
	  return function queryBackWage(_x21) {
	    return _ref21.apply(this, arguments);
	  };
	}();
	
	var queryDownloadWageTemplate = exports.queryDownloadWageTemplate = function () {
	  var _ref22 = _asyncToGenerator(_regenerator2.default.mark(function _callee22() {
	    return _regenerator2.default.wrap(function _callee22$(_context22) {
	      while (1) {
	        switch (_context22.prev = _context22.next) {
	          case 0:
	            _http2.default.download(_req.hr.DOWNLOAD_WAGE_TEMPLATE, {}, '工资导入模板.xlsx');
	
	          case 1:
	          case 'end':
	            return _context22.stop();
	        }
	      }
	    }, _callee22, this);
	  }));
	
	  return function queryDownloadWageTemplate() {
	    return _ref22.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 115 */
[3047, 454, 334, 170],
/* 116 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 117 */
78,
/* 118 */
[3008, 84],
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var fails = __webpack_require__(43);
	
	module.exports = function (method, arg) {
	  return !!method && fails(function () {
	    // eslint-disable-next-line no-useless-call
	    arg ? method.call(null, function () { /* empty */ }, 1) : method.call(null);
	  });
	};


/***/ },
/* 120 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var coordinateSystemCreators = {};
	
	function CoordinateSystemManager() {
	  this._coordinateSystems = [];
	}
	
	CoordinateSystemManager.prototype = {
	  constructor: CoordinateSystemManager,
	  create: function (ecModel, api) {
	    var coordinateSystems = [];
	    zrUtil.each(coordinateSystemCreators, function (creater, type) {
	      var list = creater.create(ecModel, api);
	      coordinateSystems = coordinateSystems.concat(list || []);
	    });
	    this._coordinateSystems = coordinateSystems;
	  },
	  update: function (ecModel, api) {
	    zrUtil.each(this._coordinateSystems, function (coordSys) {
	      coordSys.update && coordSys.update(ecModel, api);
	    });
	  },
	  getCoordinateSystems: function () {
	    return this._coordinateSystems.slice();
	  }
	};
	
	CoordinateSystemManager.register = function (type, coordinateSystemCreator) {
	  coordinateSystemCreators[type] = coordinateSystemCreator;
	};
	
	CoordinateSystemManager.get = function (type) {
	  return coordinateSystemCreators[type];
	};
	
	var _default = CoordinateSystemManager;
	module.exports = _default;

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(4);
	
	var OrdinalScale = __webpack_require__(2449);
	
	var IntervalScale = __webpack_require__(360);
	
	var Scale = __webpack_require__(361);
	
	var numberUtil = __webpack_require__(25);
	
	var _barGrid = __webpack_require__(359);
	
	var prepareLayoutBarSeries = _barGrid.prepareLayoutBarSeries;
	var makeColumnLayout = _barGrid.makeColumnLayout;
	var retrieveColumnLayout = _barGrid.retrieveColumnLayout;
	
	var BoundingRect = __webpack_require__(60);
	
	__webpack_require__(2450);
	
	__webpack_require__(876);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Get axis scale extent before niced.
	 * Item of returned array can only be number (including Infinity and NaN).
	 */
	function getScaleExtent(scale, model) {
	  var scaleType = scale.type;
	  var min = model.getMin();
	  var max = model.getMax();
	  var originalExtent = scale.getExtent();
	  var axisDataLen;
	  var boundaryGap;
	  var span;
	
	  if (scaleType === 'ordinal') {
	    axisDataLen = model.getCategories().length;
	  } else {
	    boundaryGap = model.get('boundaryGap');
	
	    if (!zrUtil.isArray(boundaryGap)) {
	      boundaryGap = [boundaryGap || 0, boundaryGap || 0];
	    }
	
	    if (typeof boundaryGap[0] === 'boolean') {
	      boundaryGap = [0, 0];
	    }
	
	    boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], 1);
	    boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], 1);
	    span = originalExtent[1] - originalExtent[0] || Math.abs(originalExtent[0]);
	  } // Notice: When min/max is not set (that is, when there are null/undefined,
	  // which is the most common case), these cases should be ensured:
	  // (1) For 'ordinal', show all axis.data.
	  // (2) For others:
	  //      + `boundaryGap` is applied (if min/max set, boundaryGap is
	  //      disabled).
	  //      + If `needCrossZero`, min/max should be zero, otherwise, min/max should
	  //      be the result that originalExtent enlarged by boundaryGap.
	  // (3) If no data, it should be ensured that `scale.setBlank` is set.
	  // FIXME
	  // (1) When min/max is 'dataMin' or 'dataMax', should boundaryGap be able to used?
	  // (2) When `needCrossZero` and all data is positive/negative, should it be ensured
	  // that the results processed by boundaryGap are positive/negative?
	
	
	  if (min === 'dataMin') {
	    min = originalExtent[0];
	  } else if (typeof min === 'function') {
	    min = min({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  if (max === 'dataMax') {
	    max = originalExtent[1];
	  } else if (typeof max === 'function') {
	    max = max({
	      min: originalExtent[0],
	      max: originalExtent[1]
	    });
	  }
	
	  var fixMin = min != null;
	  var fixMax = max != null;
	
	  if (min == null) {
	    min = scaleType === 'ordinal' ? axisDataLen ? 0 : NaN : originalExtent[0] - boundaryGap[0] * span;
	  }
	
	  if (max == null) {
	    max = scaleType === 'ordinal' ? axisDataLen ? axisDataLen - 1 : NaN : originalExtent[1] + boundaryGap[1] * span;
	  }
	
	  (min == null || !isFinite(min)) && (min = NaN);
	  (max == null || !isFinite(max)) && (max = NaN);
	  scale.setBlank(zrUtil.eqNaN(min) || zrUtil.eqNaN(max) || scaleType === 'ordinal' && !scale.getOrdinalMeta().categories.length); // Evaluate if axis needs cross zero
	
	  if (model.getNeedCrossZero()) {
	    // Axis is over zero and min is not set
	    if (min > 0 && max > 0 && !fixMin) {
	      min = 0;
	    } // Axis is under zero and max is not set
	
	
	    if (min < 0 && max < 0 && !fixMax) {
	      max = 0;
	    }
	  } // If bars are placed on a base axis of type time or interval account for axis boundary overflow and current axis
	  // is base axis
	  // FIXME
	  // (1) Consider support value axis, where below zero and axis `onZero` should be handled properly.
	  // (2) Refactor the logic with `barGrid`. Is it not need to `makeBarWidthAndOffsetInfo` twice with different extent?
	  //     Should not depend on series type `bar`?
	  // (3) Fix that might overlap when using dataZoom.
	  // (4) Consider other chart types using `barGrid`?
	  // See #6728, #4862, `test/bar-overflow-time-plot.html`
	
	
	  var ecModel = model.ecModel;
	
	  if (ecModel && scaleType === 'time'
	  /*|| scaleType === 'interval' */
	  ) {
	    var barSeriesModels = prepareLayoutBarSeries('bar', ecModel);
	    var isBaseAxisAndHasBarSeries;
	    zrUtil.each(barSeriesModels, function (seriesModel) {
	      isBaseAxisAndHasBarSeries |= seriesModel.getBaseAxis() === model.axis;
	    });
	
	    if (isBaseAxisAndHasBarSeries) {
	      // Calculate placement of bars on axis
	      var barWidthAndOffset = makeColumnLayout(barSeriesModels); // Adjust axis min and max to account for overflow
	
	      var adjustedScale = adjustScaleForOverflow(min, max, model, barWidthAndOffset);
	      min = adjustedScale.min;
	      max = adjustedScale.max;
	    }
	  }
	
	  return {
	    extent: [min, max],
	    // "fix" means "fixed", the value should not be
	    // changed in the subsequent steps.
	    fixMin: fixMin,
	    fixMax: fixMax
	  };
	}
	
	function adjustScaleForOverflow(min, max, model, barWidthAndOffset) {
	  // Get Axis Length
	  var axisExtent = model.axis.getExtent();
	  var axisLength = axisExtent[1] - axisExtent[0]; // Get bars on current base axis and calculate min and max overflow
	
	  var barsOnCurrentAxis = retrieveColumnLayout(barWidthAndOffset, model.axis);
	
	  if (barsOnCurrentAxis === undefined) {
	    return {
	      min: min,
	      max: max
	    };
	  }
	
	  var minOverflow = Infinity;
	  zrUtil.each(barsOnCurrentAxis, function (item) {
	    minOverflow = Math.min(item.offset, minOverflow);
	  });
	  var maxOverflow = -Infinity;
	  zrUtil.each(barsOnCurrentAxis, function (item) {
	    maxOverflow = Math.max(item.offset + item.width, maxOverflow);
	  });
	  minOverflow = Math.abs(minOverflow);
	  maxOverflow = Math.abs(maxOverflow);
	  var totalOverFlow = minOverflow + maxOverflow; // Calulate required buffer based on old range and overflow
	
	  var oldRange = max - min;
	  var oldRangePercentOfNew = 1 - (minOverflow + maxOverflow) / axisLength;
	  var overflowBuffer = oldRange / oldRangePercentOfNew - oldRange;
	  max += overflowBuffer * (maxOverflow / totalOverFlow);
	  min -= overflowBuffer * (minOverflow / totalOverFlow);
	  return {
	    min: min,
	    max: max
	  };
	}
	
	function niceScaleExtent(scale, model) {
	  var extentInfo = getScaleExtent(scale, model);
	  var extent = extentInfo.extent;
	  var splitNumber = model.get('splitNumber');
	
	  if (scale.type === 'log') {
	    scale.base = model.get('logBase');
	  }
	
	  var scaleType = scale.type;
	  scale.setExtent(extent[0], extent[1]);
	  scale.niceExtent({
	    splitNumber: splitNumber,
	    fixMin: extentInfo.fixMin,
	    fixMax: extentInfo.fixMax,
	    minInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('minInterval') : null,
	    maxInterval: scaleType === 'interval' || scaleType === 'time' ? model.get('maxInterval') : null
	  }); // If some one specified the min, max. And the default calculated interval
	  // is not good enough. He can specify the interval. It is often appeared
	  // in angle axis with angle 0 - 360. Interval calculated in interval scale is hard
	  // to be 60.
	  // FIXME
	
	  var interval = model.get('interval');
	
	  if (interval != null) {
	    scale.setInterval && scale.setInterval(interval);
	  }
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @param {string} [axisType] Default retrieve from model.type
	 * @return {module:echarts/scale/*}
	 */
	
	
	function createScaleByModel(model, axisType) {
	  axisType = axisType || model.get('type');
	
	  if (axisType) {
	    switch (axisType) {
	      // Buildin scale
	      case 'category':
	        return new OrdinalScale(model.getOrdinalMeta ? model.getOrdinalMeta() : model.getCategories(), [Infinity, -Infinity]);
	
	      case 'value':
	        return new IntervalScale();
	      // Extended scale, like time and log
	
	      default:
	        return (Scale.getClass(axisType) || IntervalScale).create(model);
	    }
	  }
	}
	/**
	 * Check if the axis corss 0
	 */
	
	
	function ifAxisCrossZero(axis) {
	  var dataExtent = axis.scale.getExtent();
	  var min = dataExtent[0];
	  var max = dataExtent[1];
	  return !(min > 0 && max > 0 || min < 0 && max < 0);
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @return {Function} Label formatter function.
	 *         param: {number} tickValue,
	 *         param: {number} idx, the index in all ticks.
	 *                         If category axis, this param is not requied.
	 *         return: {string} label string.
	 */
	
	
	function makeLabelFormatter(axis) {
	  var labelFormatter = axis.getLabelModel().get('formatter');
	  var categoryTickStart = axis.type === 'category' ? axis.scale.getExtent()[0] : null;
	
	  if (typeof labelFormatter === 'string') {
	    labelFormatter = function (tpl) {
	      return function (val) {
	        // For category axis, get raw value; for numeric axis,
	        // get foramtted label like '1,333,444'.
	        val = axis.scale.getLabel(val);
	        return tpl.replace('{value}', val != null ? val : '');
	      };
	    }(labelFormatter); // Consider empty array
	
	
	    return labelFormatter;
	  } else if (typeof labelFormatter === 'function') {
	    return function (tickValue, idx) {
	      // The original intention of `idx` is "the index of the tick in all ticks".
	      // But the previous implementation of category axis do not consider the
	      // `axisLabel.interval`, which cause that, for example, the `interval` is
	      // `1`, then the ticks "name5", "name7", "name9" are displayed, where the
	      // corresponding `idx` are `0`, `2`, `4`, but not `0`, `1`, `2`. So we keep
	      // the definition here for back compatibility.
	      if (categoryTickStart != null) {
	        idx = tickValue - categoryTickStart;
	      }
	
	      return labelFormatter(getAxisRawValue(axis, tickValue), idx);
	    };
	  } else {
	    return function (tick) {
	      return axis.scale.getLabel(tick);
	    };
	  }
	}
	
	function getAxisRawValue(axis, value) {
	  // In category axis with data zoom, tick is not the original
	  // index of axis.data. So tick should not be exposed to user
	  // in category axis.
	  return axis.type === 'category' ? axis.scale.getLabel(value) : value;
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @return {module:zrender/core/BoundingRect} Be null/undefined if no labels.
	 */
	
	
	function estimateLabelUnionRect(axis) {
	  var axisModel = axis.model;
	  var scale = axis.scale;
	
	  if (!axisModel.get('axisLabel.show') || scale.isBlank()) {
	    return;
	  }
	
	  var isCategory = axis.type === 'category';
	  var realNumberScaleTicks;
	  var tickCount;
	  var categoryScaleExtent = scale.getExtent(); // Optimize for large category data, avoid call `getTicks()`.
	
	  if (isCategory) {
	    tickCount = scale.count();
	  } else {
	    realNumberScaleTicks = scale.getTicks();
	    tickCount = realNumberScaleTicks.length;
	  }
	
	  var axisLabelModel = axis.getLabelModel();
	  var labelFormatter = makeLabelFormatter(axis);
	  var rect;
	  var step = 1; // Simple optimization for large amount of labels
	
	  if (tickCount > 40) {
	    step = Math.ceil(tickCount / 40);
	  }
	
	  for (var i = 0; i < tickCount; i += step) {
	    var tickValue = realNumberScaleTicks ? realNumberScaleTicks[i] : categoryScaleExtent[0] + i;
	    var label = labelFormatter(tickValue);
	    var unrotatedSingleRect = axisLabelModel.getTextRect(label);
	    var singleRect = rotateTextRect(unrotatedSingleRect, axisLabelModel.get('rotate') || 0);
	    rect ? rect.union(singleRect) : rect = singleRect;
	  }
	
	  return rect;
	}
	
	function rotateTextRect(textRect, rotate) {
	  var rotateRadians = rotate * Math.PI / 180;
	  var boundingBox = textRect.plain();
	  var beforeWidth = boundingBox.width;
	  var beforeHeight = boundingBox.height;
	  var afterWidth = beforeWidth * Math.abs(Math.cos(rotateRadians)) + Math.abs(beforeHeight * Math.sin(rotateRadians));
	  var afterHeight = beforeWidth * Math.abs(Math.sin(rotateRadians)) + Math.abs(beforeHeight * Math.cos(rotateRadians));
	  var rotatedRect = new BoundingRect(boundingBox.x, boundingBox.y, afterWidth, afterHeight);
	  return rotatedRect;
	}
	/**
	 * @param {module:echarts/src/model/Model} model axisLabelModel or axisTickModel
	 * @return {number|String} Can be null|'auto'|number|function
	 */
	
	
	function getOptionCategoryInterval(model) {
	  var interval = model.get('interval');
	  return interval == null ? 'auto' : interval;
	}
	/**
	 * Set `categoryInterval` as 0 implicitly indicates that
	 * show all labels reguardless of overlap.
	 * @param {Object} axis axisModel.axis
	 * @return {boolean}
	 */
	
	
	function shouldShowAllLabels(axis) {
	  return axis.type === 'category' && getOptionCategoryInterval(axis.getLabelModel()) === 0;
	}
	
	exports.getScaleExtent = getScaleExtent;
	exports.niceScaleExtent = niceScaleExtent;
	exports.createScaleByModel = createScaleByModel;
	exports.ifAxisCrossZero = ifAxisCrossZero;
	exports.makeLabelFormatter = makeLabelFormatter;
	exports.getAxisRawValue = getAxisRawValue;
	exports.estimateLabelUnionRect = estimateLabelUnionRect;
	exports.getOptionCategoryInterval = getOptionCategoryInterval;
	exports.shouldShowAllLabels = shouldShowAllLabels;

/***/ },
/* 123 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var nullthrows = function nullthrows(x) {
	  if (x != null) {
	    return x;
	  }
	  throw new Error("Got unexpected null or undefined");
	};
	
	module.exports = nullthrows;

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(916);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 125 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 126 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(2619)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _implementation = __webpack_require__(1214);
	
	var _implementation2 = _interopRequireDefault(_implementation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _react2.default.createContext || _implementation2.default;
	module.exports = exports['default'];

/***/ },
/* 130 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryDeleteCustomBill = exports.queryCustomRelationBill = exports.queryCustomBillInfo = exports.querySaveCustomBill = exports.queryCustomBillList = exports.querySaveCompanyCustom = exports.queryCompanyCustomList = exports.querySaveCustomCompany = exports.queryCustomCompany = exports.queryDeleteCustom = exports.queryCustomInfo = exports.querySaveCustom = exports.queryCustomList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 获取客户总表
	 */
	var queryCustomList = exports.queryCustomList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt("return", _http2.default.get(_req.crm.GET_CUSTOM_LIST, params));
	
	          case 1:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryCustomList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 保存客户信息
	 */
	
	
	var querySaveCustom = exports.querySaveCustom = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt("return", _http2.default.post(_req.crm.SAVE_CUSTOM, params));
	
	          case 1:
	          case "end":
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function querySaveCustom(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	/**
	 * 客户明细
	 */
	
	
	var queryCustomInfo = exports.queryCustomInfo = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(uuid) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt("return", _http2.default.get(_req.crm.GET_CUSTOM_INFO, { uuid: uuid }));
	
	          case 1:
	          case "end":
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryCustomInfo(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	/**
	 * 删除客户信息
	 */
	
	
	var queryDeleteCustom = exports.queryDeleteCustom = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(uuid) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt("return", _http2.default.get(_req.crm.DEL_CUSTOM, { uuid: uuid }));
	
	          case 1:
	          case "end":
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryDeleteCustom(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取客户的公司列表
	 */
	
	
	var queryCustomCompany = exports.queryCustomCompany = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt("return", _http2.default.get(_req.crm.GET_CUSTOM_COMPANY, params));
	
	          case 1:
	          case "end":
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryCustomCompany(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	/**
	 * 组织设置明细
	 */
	
	
	var querySaveCustomCompany = exports.querySaveCustomCompany = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(parms) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt("return", _http2.default.post(_req.crm.SAVE_CUSTOM_COMPANY, parms));
	
	          case 1:
	          case "end":
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function querySaveCustomCompany(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取公司的客户列表
	 */
	
	
	var queryCompanyCustomList = exports.queryCompanyCustomList = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt("return", _http2.default.get(_req.crm.GET_COMPANY_CUSTOM, params));
	
	          case 1:
	          case "end":
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryCompanyCustomList(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	/**
	 * 添加客户公司
	 */
	
	
	var querySaveCompanyCustom = exports.querySaveCompanyCustom = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt("return", _http2.default.post(_req.crm.SAVE_COMPANY_CUSTOM, params));
	
	          case 1:
	          case "end":
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function querySaveCompanyCustom(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取客户的资金列表
	 */
	
	
	var queryCustomBillList = exports.queryCustomBillList = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt("return", _http2.default.get(_req.crm.GET_CUSTOM_BILL_LIST, params));
	
	          case 1:
	          case "end":
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryCustomBillList(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	/**
	 * 保存客户资金
	 */
	
	
	var querySaveCustomBill = exports.querySaveCustomBill = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt("return", _http2.default.post(_req.crm.SAVE_CUSTOM_BILL, params));
	
	          case 1:
	          case "end":
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function querySaveCustomBill(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取客户资金明细
	 */
	
	
	var queryCustomBillInfo = exports.queryCustomBillInfo = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(uuid) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt("return", _http2.default.get(_req.crm.GET_CUSTOM_BILL_INFO, { billUuid: uuid }));
	
	          case 1:
	          case "end":
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryCustomBillInfo(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	/**
	 * 客户资金关联
	 */
	
	
	var queryCustomRelationBill = exports.queryCustomRelationBill = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt("return", _http2.default.post(_req.crm.CUSTOM_RELATIONBILL, params));
	
	          case 1:
	          case "end":
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryCustomRelationBill(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	/**
	 * 删除客户资金
	 */
	
	
	var queryDeleteCustomBill = exports.queryDeleteCustomBill = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(uuid) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt("return", _http2.default.get(_req.crm.DEL_CUSTOM, { uuid: uuid }));
	
	          case 1:
	          case "end":
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryDeleteCustomBill(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryPaymentIncomepart = exports.queryPaymentWorkflow = exports.queryCallbackPayment = exports.queryReturnPayment = exports.queryNextPayment = exports.queryDeletePayment = exports.querySavePayment = exports.queryPaymentInfo = exports.queryPaymentOrgRecord = exports.queryPaymentIncubatorStatic = exports.queryPaymentOrgStatic = exports.queryMyPaymentCheckList = exports.queryPaymentMyList = exports.queryPaymentList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 付款
	 */
	var queryPaymentList = exports.queryPaymentList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.finance.GET_PAYMENT_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryPaymentList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryPaymentMyList = exports.queryPaymentMyList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.finance.GET_PAYMENT_MY, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryPaymentMyList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryMyPaymentCheckList = exports.queryMyPaymentCheckList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.finance.GET_PAYMENT_CHECK, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryMyPaymentCheckList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryPaymentOrgStatic = exports.queryPaymentOrgStatic = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.finance.GET_PAYMENT_STATIC_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryPaymentOrgStatic(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryPaymentIncubatorStatic = exports.queryPaymentIncubatorStatic = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.finance.GET_PAYMENT_STATIC_INCUBATOR, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryPaymentIncubatorStatic(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryPaymentOrgRecord = exports.queryPaymentOrgRecord = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.finance.GET_PAYMENT_RECORD_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryPaymentOrgRecord(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryPaymentInfo = exports.queryPaymentInfo = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.finance.GET_PAYMENT_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryPaymentInfo(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var querySavePayment = exports.querySavePayment = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.post(_req.finance.PAYMENT_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function querySavePayment(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryDeletePayment = exports.queryDeletePayment = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.finance.PAYMENT_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryDeletePayment(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryNextPayment = exports.queryNextPayment = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.finance.PAYMENT_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryNextPayment(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryReturnPayment = exports.queryReturnPayment = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.post(_req.finance.PAYMENT_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryReturnPayment(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var queryCallbackPayment = exports.queryCallbackPayment = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.get(_req.finance.PAYMENT_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryCallbackPayment(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var queryPaymentWorkflow = exports.queryPaymentWorkflow = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.get(_req.finance.PAYMENT_WORKFLOW, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryPaymentWorkflow(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var queryPaymentIncomepart = exports.queryPaymentIncomepart = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.finance.PAYMENT_INCOMEPART, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryPaymentIncomepart(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryRecoupWorkflow = exports.queryCallbackRecoup = exports.queryReturnRecoup = exports.queryNextRecoup = exports.queryDeleteRecoup = exports.querySaveRecoup = exports.queryRecoupInfo = exports.queryRecoupOrgRecord = exports.queryRecoupIncubatorStatic = exports.queryRecoupOrgStatic = exports.queryMyRecoupCheckList = exports.queryRecoupMyList = exports.queryRecoupList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 报销
	 */
	var queryRecoupList = exports.queryRecoupList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.finance.GET_RECOUP_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryRecoupList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryRecoupMyList = exports.queryRecoupMyList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.finance.GET_RECOUP_MY, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryRecoupMyList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryMyRecoupCheckList = exports.queryMyRecoupCheckList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.finance.GET_RECOUP_CHECK, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryMyRecoupCheckList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryRecoupOrgStatic = exports.queryRecoupOrgStatic = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.finance.GET_RECOUP_STATIC_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryRecoupOrgStatic(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryRecoupIncubatorStatic = exports.queryRecoupIncubatorStatic = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.finance.GET_RECOUP_STATIC_INCUBATOR, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryRecoupIncubatorStatic(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryRecoupOrgRecord = exports.queryRecoupOrgRecord = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.finance.GET_RECOUP_RECORD_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryRecoupOrgRecord(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryRecoupInfo = exports.queryRecoupInfo = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.finance.GET_RECOUP_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryRecoupInfo(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var querySaveRecoup = exports.querySaveRecoup = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.post(_req.finance.RECOUP_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function querySaveRecoup(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryDeleteRecoup = exports.queryDeleteRecoup = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.finance.RECOUP_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryDeleteRecoup(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryNextRecoup = exports.queryNextRecoup = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.finance.RECOUP_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryNextRecoup(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryReturnRecoup = exports.queryReturnRecoup = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.post(_req.finance.RECOUP_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryReturnRecoup(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var queryCallbackRecoup = exports.queryCallbackRecoup = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.get(_req.finance.RECOUP_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryCallbackRecoup(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var queryRecoupWorkflow = exports.queryRecoupWorkflow = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.get(_req.finance.RECOUP_WORKFLOW, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryRecoupWorkflow(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _HOCWorkflow = __webpack_require__(326);
	
	var _HOCWorkflow2 = _interopRequireDefault(_HOCWorkflow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Opration = function (_Component) {
	  _inherits(Opration, _Component);
	
	  function Opration(props) {
	    _classCallCheck(this, Opration);
	
	    var _this = _possibleConstructorReturn(this, (Opration.__proto__ || Object.getPrototypeOf(Opration)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Opration, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            icon: 'check',
	            type: 'primary',
	            style: { marginRight: 10 },
	            onClick: function onClick() {
	              return _this2.props.doTask('next');
	            },
	            loading: this.props.isLoading || false
	          },
	          '\u901A\u8FC7'
	        )
	      );
	    }
	  }]);
	
	  return Opration;
	}(_react.Component);
	
	exports.default = (0, _HOCWorkflow2.default)(Opration);

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	// 0 -> Array#forEach
	// 1 -> Array#map
	// 2 -> Array#filter
	// 3 -> Array#some
	// 4 -> Array#every
	// 5 -> Array#find
	// 6 -> Array#findIndex
	var ctx = __webpack_require__(118);
	var IObject = __webpack_require__(277);
	var toObject = __webpack_require__(75);
	var toLength = __webpack_require__(63);
	var asc = __webpack_require__(462);
	module.exports = function (TYPE, $create) {
	  var IS_MAP = TYPE == 1;
	  var IS_FILTER = TYPE == 2;
	  var IS_SOME = TYPE == 3;
	  var IS_EVERY = TYPE == 4;
	  var IS_FIND_INDEX = TYPE == 6;
	  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
	  var create = $create || asc;
	  return function ($this, callbackfn, that) {
	    var O = toObject($this);
	    var self = IObject(O);
	    var f = ctx(callbackfn, that, 3);
	    var length = toLength(self.length);
	    var index = 0;
	    var result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined;
	    var val, res;
	    for (;length > index; index++) if (NO_HOLES || index in self) {
	      val = self[index];
	      res = f(val, index, O);
	      if (TYPE) {
	        if (IS_MAP) result[index] = res;   // map
	        else if (res) switch (TYPE) {
	          case 3: return true;             // some
	          case 5: return val;              // find
	          case 6: return index;            // findIndex
	          case 2: result.push(val);        // filter
	        } else if (IS_EVERY) return false; // every
	      }
	    }
	    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	  };
	};


/***/ },
/* 136 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 137 */
[3034, 7, 117, 43],
/* 138 */
[3044, 45],
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	var factory = __webpack_require__(793);
	
	if (typeof React === 'undefined') {
	  throw Error(
	    'create-react-class could not find the React object. If you are using script tags, ' +
	      'make sure that React is being loaded before create-react-class.'
	  );
	}
	
	// Hack to grab NoopUpdateQueue from isomorphic React
	var ReactNoopUpdateQueue = new React.Component().updater;
	
	module.exports = factory(
	  React.Component,
	  React.isValidElement,
	  ReactNoopUpdateQueue
	);


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	var isString = _util.isString;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Note that it is too complicated to support 3d stack by value
	 * (have to create two-dimension inverted index), so in 3d case
	 * we just support that stacked by index.
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Array.<string|Object>} dimensionInfoList The same as the input of <module:echarts/data/List>.
	 *        The input dimensionInfoList will be modified.
	 * @param {Object} [opt]
	 * @param {boolean} [opt.stackedCoordDimension=''] Specify a coord dimension if needed.
	 * @param {boolean} [opt.byIndex=false]
	 * @return {Object} calculationInfo
	 * {
	 *     stackedDimension: string
	 *     stackedByDimension: string
	 *     isStackedByIndex: boolean
	 *     stackedOverDimension: string
	 *     stackResultDimension: string
	 * }
	 */
	function enableDataStack(seriesModel, dimensionInfoList, opt) {
	  opt = opt || {};
	  var byIndex = opt.byIndex;
	  var stackedCoordDimension = opt.stackedCoordDimension; // Compatibal: when `stack` is set as '', do not stack.
	
	  var mayStack = !!(seriesModel && seriesModel.get('stack'));
	  var stackedByDimInfo;
	  var stackedDimInfo;
	  var stackResultDimension;
	  var stackedOverDimension;
	  each(dimensionInfoList, function (dimensionInfo, index) {
	    if (isString(dimensionInfo)) {
	      dimensionInfoList[index] = dimensionInfo = {
	        name: dimensionInfo
	      };
	    }
	
	    if (mayStack && !dimensionInfo.isExtraCoord) {
	      // Find the first ordinal dimension as the stackedByDimInfo.
	      if (!byIndex && !stackedByDimInfo && dimensionInfo.ordinalMeta) {
	        stackedByDimInfo = dimensionInfo;
	      } // Find the first stackable dimension as the stackedDimInfo.
	
	
	      if (!stackedDimInfo && dimensionInfo.type !== 'ordinal' && dimensionInfo.type !== 'time' && (!stackedCoordDimension || stackedCoordDimension === dimensionInfo.coordDim)) {
	        stackedDimInfo = dimensionInfo;
	      }
	    }
	  });
	
	  if (stackedDimInfo && !byIndex && !stackedByDimInfo) {
	    // Compatible with previous design, value axis (time axis) only stack by index.
	    // It may make sense if the user provides elaborately constructed data.
	    byIndex = true;
	  } // Add stack dimension, they can be both calculated by coordinate system in `unionExtent`.
	  // That put stack logic in List is for using conveniently in echarts extensions, but it
	  // might not be a good way.
	
	
	  if (stackedDimInfo) {
	    // Use a weird name that not duplicated with other names.
	    stackResultDimension = '__\0ecstackresult';
	    stackedOverDimension = '__\0ecstackedover'; // Create inverted index to fast query index by value.
	
	    if (stackedByDimInfo) {
	      stackedByDimInfo.createInvertedIndices = true;
	    }
	
	    var stackedDimCoordDim = stackedDimInfo.coordDim;
	    var stackedDimType = stackedDimInfo.type;
	    var stackedDimCoordIndex = 0;
	    each(dimensionInfoList, function (dimensionInfo) {
	      if (dimensionInfo.coordDim === stackedDimCoordDim) {
	        stackedDimCoordIndex++;
	      }
	    });
	    dimensionInfoList.push({
	      name: stackResultDimension,
	      coordDim: stackedDimCoordDim,
	      coordDimIndex: stackedDimCoordIndex,
	      type: stackedDimType,
	      isExtraCoord: true,
	      isCalculationCoord: true
	    });
	    stackedDimCoordIndex++;
	    dimensionInfoList.push({
	      name: stackedOverDimension,
	      // This dimension contains stack base (generally, 0), so do not set it as
	      // `stackedDimCoordDim` to avoid extent calculation, consider log scale.
	      coordDim: stackedOverDimension,
	      coordDimIndex: stackedDimCoordIndex,
	      type: stackedDimType,
	      isExtraCoord: true,
	      isCalculationCoord: true
	    });
	  }
	
	  return {
	    stackedDimension: stackedDimInfo && stackedDimInfo.name,
	    stackedByDimension: stackedByDimInfo && stackedByDimInfo.name,
	    isStackedByIndex: byIndex,
	    stackedOverDimension: stackedOverDimension,
	    stackResultDimension: stackResultDimension
	  };
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {string} stackedDim
	 */
	
	
	function isDimensionStacked(data, stackedDim
	/*, stackedByDim*/
	) {
	  // Each single series only maps to one pair of axis. So we do not need to
	  // check stackByDim, whatever stacked by a dimension or stacked by index.
	  return !!stackedDim && stackedDim === data.getCalculationInfo('stackedDimension'); // && (
	  //     stackedByDim != null
	  //         ? stackedByDim === data.getCalculationInfo('stackedByDimension')
	  //         : data.getCalculationInfo('isStackedByIndex')
	  // );
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {string} targetDim
	 * @param {string} [stackedByDim] If not input this parameter, check whether
	 *                                stacked by index.
	 * @return {string} dimension
	 */
	
	
	function getStackedDimension(data, targetDim) {
	  return isDimensionStacked(data, targetDim) ? data.getCalculationInfo('stackResultDimension') : targetDim;
	}
	
	exports.enableDataStack = enableDataStack;
	exports.isDimensionStacked = isDimensionStacked;
	exports.getStackedDimension = getStackedDimension;

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	
	var Group = __webpack_require__(223);
	
	var componentUtil = __webpack_require__(297);
	
	var clazzUtil = __webpack_require__(161);
	
	var modelUtil = __webpack_require__(29);
	
	var graphicUtil = __webpack_require__(14);
	
	var _task = __webpack_require__(518);
	
	var createTask = _task.createTask;
	
	var createRenderPlanner = __webpack_require__(246);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = modelUtil.makeInner();
	var renderPlanner = createRenderPlanner();
	
	function Chart() {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewChart');
	  this.renderTask = createTask({
	    plan: renderTaskPlan,
	    reset: renderTaskReset
	  });
	  this.renderTask.context = {
	    view: this
	  };
	}
	
	Chart.prototype = {
	  type: 'chart',
	
	  /**
	   * Init the chart.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {},
	
	  /**
	   * Render the chart.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  render: function (seriesModel, ecModel, api, payload) {},
	
	  /**
	   * Highlight series or specified data item.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  highlight: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'emphasis');
	  },
	
	  /**
	   * Downplay series or specified data item.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  downplay: function (seriesModel, ecModel, api, payload) {
	    toggleHighlight(seriesModel.getData(), payload, 'normal');
	  },
	
	  /**
	   * Remove self.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  remove: function (ecModel, api) {
	    this.group.removeAll();
	  },
	
	  /**
	   * Dispose self.
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  dispose: function () {},
	
	  /**
	   * Rendering preparation in progressive mode.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  incrementalPrepareRender: null,
	
	  /**
	   * Render in progressive mode.
	   * @param  {Object} params See taskParams in `stream/task.js`
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   */
	  incrementalRender: null,
	
	  /**
	   * Update transform directly.
	   * @param  {module:echarts/model/Series} seriesModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @param  {Object} payload
	   * @return {Object} {update: true}
	   */
	  updateTransform: null,
	
	  /**
	   * The view contains the given point.
	   * @interface
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  // containPoint: function () {}
	
	  /**
	   * @param {string} eventType
	   * @param {Object} query
	   * @param {module:zrender/Element} targetEl
	   * @param {Object} packedEvent
	   * @return {boolen} Pass only when return `true`.
	   */
	  filterForExposedEvent: null
	};
	var chartProto = Chart.prototype;
	
	chartProto.updateView = chartProto.updateLayout = chartProto.updateVisual = function (seriesModel, ecModel, api, payload) {
	  this.render(seriesModel, ecModel, api, payload);
	};
	/**
	 * Set state of single element
	 * @param {module:zrender/Element} el
	 * @param {string} state 'normal'|'emphasis'
	 * @param {number} highlightDigit
	 */
	
	
	function elSetState(el, state, highlightDigit) {
	  if (el) {
	    el.trigger(state, highlightDigit);
	
	    if (el.isGroup // Simple optimize.
	    && !graphicUtil.isHighDownDispatcher(el)) {
	      for (var i = 0, len = el.childCount(); i < len; i++) {
	        elSetState(el.childAt(i), state, highlightDigit);
	      }
	    }
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Object} payload
	 * @param {string} state 'normal'|'emphasis'
	 */
	
	
	function toggleHighlight(data, payload, state) {
	  var dataIndex = modelUtil.queryDataIndex(data, payload);
	  var highlightDigit = payload && payload.highlightKey != null ? graphicUtil.getHighlightDigit(payload.highlightKey) : null;
	
	  if (dataIndex != null) {
	    each(modelUtil.normalizeToArray(dataIndex), function (dataIdx) {
	      elSetState(data.getItemGraphicEl(dataIdx), state, highlightDigit);
	    });
	  } else {
	    data.eachItemGraphicEl(function (el) {
	      elSetState(el, state, highlightDigit);
	    });
	  }
	} // Enable Chart.extend.
	
	
	clazzUtil.enableClassExtend(Chart, ['dispose']); // Add capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Chart, {
	  registerWhenExtend: true
	});
	
	Chart.markUpdateMethod = function (payload, methodName) {
	  inner(payload).updateMethod = methodName;
	};
	
	function renderTaskPlan(context) {
	  return renderPlanner(context.model);
	}
	
	function renderTaskReset(context) {
	  var seriesModel = context.model;
	  var ecModel = context.ecModel;
	  var api = context.api;
	  var payload = context.payload; // ???! remove updateView updateVisual
	
	  var progressiveRender = seriesModel.pipelineContext.progressiveRender;
	  var view = context.view;
	  var updateMethod = payload && inner(payload).updateMethod;
	  var methodName = progressiveRender ? 'incrementalPrepareRender' : updateMethod && view[updateMethod] ? updateMethod // `appendData` is also supported when data amount
	  // is less than progressive threshold.
	  : 'render';
	
	  if (methodName !== 'render') {
	    view[methodName](seriesModel, ecModel, api, payload);
	  }
	
	  return progressMethodMap[methodName];
	}
	
	var progressMethodMap = {
	  incrementalPrepareRender: {
	    progress: function (params, context) {
	      context.view.incrementalRender(params, context.model, context.ecModel, context.api, context.payload);
	    }
	  },
	  render: {
	    // Put view.render in `progress` to support appendData. But in this case
	    // view.render should not be called in reset, otherwise it will be called
	    // twise. Use `forceFirstProgress` to make sure that view.render is called
	    // in any cases.
	    forceFirstProgress: true,
	    progress: function (params, context) {
	      context.view.render(context.model, context.ecModel, context.api, context.payload);
	    }
	  }
	};
	var _default = Chart;
	module.exports = _default;

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var UserAgentData = __webpack_require__(2466);
	var VersionRange = __webpack_require__(2467);
	
	var mapObject = __webpack_require__(2480);
	var memoizeStringOnly = __webpack_require__(890);
	
	/**
	 * Checks to see whether `name` and `version` satisfy `query`.
	 *
	 * @param {string} name Name of the browser, device, engine or platform
	 * @param {?string} version Version of the browser, engine or platform
	 * @param {string} query Query of form "Name [range expression]"
	 * @param {?function} normalizer Optional pre-processor for range expression
	 * @return {boolean}
	 */
	function compare(name, version, query, normalizer) {
	  // check for exact match with no version
	  if (name === query) {
	    return true;
	  }
	
	  // check for non-matching names
	  if (!query.startsWith(name)) {
	    return false;
	  }
	
	  // full comparison with version
	  var range = query.slice(name.length);
	  if (version) {
	    range = normalizer ? normalizer(range) : range;
	    return VersionRange.contains(range, version);
	  }
	
	  return false;
	}
	
	/**
	 * Normalizes `version` by stripping any "NT" prefix, but only on the Windows
	 * platform.
	 *
	 * Mimics the stripping performed by the `UserAgentWindowsPlatform` PHP class.
	 *
	 * @param {string} version
	 * @return {string}
	 */
	function normalizePlatformVersion(version) {
	  if (UserAgentData.platformName === 'Windows') {
	    return version.replace(/^\s*NT/, '');
	  }
	
	  return version;
	}
	
	/**
	 * Provides client-side access to the authoritative PHP-generated User Agent
	 * information supplied by the server.
	 */
	var UserAgent = {
	  /**
	   * Check if the User Agent browser matches `query`.
	   *
	   * `query` should be a string like "Chrome" or "Chrome > 33".
	   *
	   * Valid browser names include:
	   *
	   * - ACCESS NetFront
	   * - AOL
	   * - Amazon Silk
	   * - Android
	   * - BlackBerry
	   * - BlackBerry PlayBook
	   * - Chrome
	   * - Chrome for iOS
	   * - Chrome frame
	   * - Facebook PHP SDK
	   * - Facebook for iOS
	   * - Firefox
	   * - IE
	   * - IE Mobile
	   * - Mobile Safari
	   * - Motorola Internet Browser
	   * - Nokia
	   * - Openwave Mobile Browser
	   * - Opera
	   * - Opera Mini
	   * - Opera Mobile
	   * - Safari
	   * - UIWebView
	   * - Unknown
	   * - webOS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `BrowserDetector` class and
	   * related classes in the same file (see calls to `new UserAgentBrowser` here:
	   * https://fburl.com/50728104).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isBrowser: function isBrowser(query) {
	    return compare(UserAgentData.browserName, UserAgentData.browserFullVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent browser uses a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isBrowserArchitecture: function isBrowserArchitecture(query) {
	    return compare(UserAgentData.browserArchitecture, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent device matches `query`.
	   *
	   * `query` should be a string like "iPhone" or "iPad".
	   *
	   * Valid device names include:
	   *
	   * - Kindle
	   * - Kindle Fire
	   * - Unknown
	   * - iPad
	   * - iPhone
	   * - iPod
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `DeviceDetector` class and
	   * related classes in the same file (see calls to `new UserAgentDevice` here:
	   * https://fburl.com/50728332).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name"
	   * @return {boolean}
	   */
	  isDevice: function isDevice(query) {
	    return compare(UserAgentData.deviceName, null, query);
	  },
	
	
	  /**
	   * Check if the User Agent rendering engine matches `query`.
	   *
	   * `query` should be a string like "WebKit" or "WebKit >= 537".
	   *
	   * Valid engine names include:
	   *
	   * - Gecko
	   * - Presto
	   * - Trident
	   * - WebKit
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `RenderingEngineDetector`
	   * class related classes in the same file (see calls to `new
	   * UserAgentRenderingEngine` here: https://fburl.com/50728617).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isEngine: function isEngine(query) {
	    return compare(UserAgentData.engineName, UserAgentData.engineVersion, query);
	  },
	
	
	  /**
	   * Check if the User Agent platform matches `query`.
	   *
	   * `query` should be a string like "Windows" or "iOS 5 - 6".
	   *
	   * Valid platform names include:
	   *
	   * - Android
	   * - BlackBerry OS
	   * - Java ME
	   * - Linux
	   * - Mac OS X
	   * - Mac OS X Calendar
	   * - Mac OS X Internet Account
	   * - Symbian
	   * - SymbianOS
	   * - Windows
	   * - Windows Mobile
	   * - Windows Phone
	   * - iOS
	   * - iOS Facebook Integration Account
	   * - iOS Facebook Social Sharing UI
	   * - webOS
	   * - Chrome OS
	   * - etc...
	   *
	   * An authoritative list can be found in the PHP `PlatformDetector` class and
	   * related classes in the same file (see calls to `new UserAgentPlatform`
	   * here: https://fburl.com/50729226).
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "Name [range expression]"
	   * @return {boolean}
	   */
	  isPlatform: function isPlatform(query) {
	    return compare(UserAgentData.platformName, UserAgentData.platformFullVersion, query, normalizePlatformVersion);
	  },
	
	
	  /**
	   * Check if the User Agent platform is a 32 or 64 bit architecture.
	   *
	   * @note Function results are memoized
	   *
	   * @param {string} query Query of the form "32" or "64".
	   * @return {boolean}
	   */
	  isPlatformArchitecture: function isPlatformArchitecture(query) {
	    return compare(UserAgentData.platformArchitecture, null, query);
	  }
	};
	
	module.exports = mapObject(UserAgent, memoizeStringOnly);

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = exports.connect = exports.Provider = undefined;
	
	var _Provider2 = __webpack_require__(2610);
	
	var _Provider3 = _interopRequireDefault(_Provider2);
	
	var _connect2 = __webpack_require__(2611);
	
	var _connect3 = _interopRequireDefault(_connect2);
	
	var _create2 = __webpack_require__(2612);
	
	var _create3 = _interopRequireDefault(_create2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider3.default;
	exports.connect = _connect3.default;
	exports.create = _create3.default;

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.findPopupContainer = findPopupContainer;
	exports.toTitle = toTitle;
	exports.toArray = toArray;
	exports.createRef = createRef;
	exports.flatToHierarchy = flatToHierarchy;
	exports.resetAriaId = resetAriaId;
	exports.generateAriaId = generateAriaId;
	exports.isLabelInValue = isLabelInValue;
	exports.parseSimpleTreeData = parseSimpleTreeData;
	exports.isPosRelated = isPosRelated;
	exports.cleanEntity = cleanEntity;
	exports.getFilterTree = getFilterTree;
	exports.formatInternalValue = formatInternalValue;
	exports.getLabel = getLabel;
	exports.formatSelectorValue = formatSelectorValue;
	exports.convertDataToTree = convertDataToTree;
	exports.convertTreeToEntities = convertTreeToEntities;
	exports.getHalfCheckedKeys = getHalfCheckedKeys;
	exports.conductCheck = exports.UNSELECTABLE_ATTRIBUTE = exports.UNSELECTABLE_STYLE = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(94));
	
	var _util = __webpack_require__(302);
	
	var _toArray = _interopRequireDefault(__webpack_require__(112));
	
	var _class = __webpack_require__(2777);
	
	var _strategies = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var warnDeprecatedLabel = false; // =================== DOM =====================
	
	function findPopupContainer(node, prefixClass) {
	  var current = node;
	
	  while (current) {
	    if ((0, _class.hasClass)(current, prefixClass)) {
	      return current;
	    }
	
	    current = current.parentNode;
	  }
	
	  return null;
	} // =================== MISC ====================
	
	
	function toTitle(title) {
	  if (typeof title === 'string') {
	    return title;
	  }
	
	  return null;
	}
	
	function toArray(data) {
	  if (data === undefined || data === null) return [];
	  return Array.isArray(data) ? data : [data];
	} // Shallow copy of React 16.3 createRef api
	
	
	function createRef() {
	  var func = function setRef(node) {
	    func.current = node;
	  };
	
	  return func;
	} // =============== Legacy ===============
	
	
	var UNSELECTABLE_STYLE = {
	  userSelect: 'none',
	  WebkitUserSelect: 'none'
	};
	exports.UNSELECTABLE_STYLE = UNSELECTABLE_STYLE;
	var UNSELECTABLE_ATTRIBUTE = {
	  unselectable: 'unselectable'
	};
	/**
	 * Convert position list to hierarchy structure.
	 * This is little hack since use '-' to split the position.
	 */
	
	exports.UNSELECTABLE_ATTRIBUTE = UNSELECTABLE_ATTRIBUTE;
	
	function flatToHierarchy(positionList) {
	  if (!positionList.length) {
	    return [];
	  }
	
	  var entrances = {}; // Prepare the position map
	
	  var posMap = {};
	  var parsedList = positionList.slice().map(function (entity) {
	    var clone = _objectSpread({}, entity, {
	      fields: entity.pos.split('-')
	    });
	
	    delete clone.children;
	    return clone;
	  });
	  parsedList.forEach(function (entity) {
	    posMap[entity.pos] = entity;
	  });
	  parsedList.sort(function (a, b) {
	    return a.fields.length - b.fields.length;
	  }); // Create the hierarchy
	
	  parsedList.forEach(function (entity) {
	    var parentPos = entity.fields.slice(0, -1).join('-');
	    var parentEntity = posMap[parentPos];
	
	    if (!parentEntity) {
	      entrances[entity.pos] = entity;
	    } else {
	      parentEntity.children = parentEntity.children || [];
	      parentEntity.children.push(entity);
	    } // Some time position list provide `key`, we don't need it
	
	
	    delete entity.key;
	    delete entity.fields;
	  });
	  return Object.keys(entrances).map(function (key) {
	    return entrances[key];
	  });
	} // =============== Accessibility ===============
	
	
	var ariaId = 0;
	
	function resetAriaId() {
	  ariaId = 0;
	}
	
	function generateAriaId(prefix) {
	  ariaId += 1;
	  return "".concat(prefix, "_").concat(ariaId);
	}
	
	function isLabelInValue(props) {
	  var treeCheckable = props.treeCheckable,
	      treeCheckStrictly = props.treeCheckStrictly,
	      labelInValue = props.labelInValue;
	
	  if (treeCheckable && treeCheckStrictly) {
	    return true;
	  }
	
	  return labelInValue || false;
	} // =================== Tree ====================
	
	
	function parseSimpleTreeData(treeData, _ref) {
	  var id = _ref.id,
	      pId = _ref.pId,
	      rootPId = _ref.rootPId;
	  var keyNodes = {};
	  var rootNodeList = []; // Fill in the map
	
	  var nodeList = treeData.map(function (node) {
	    var clone = _objectSpread({}, node);
	
	    var key = clone[id];
	    keyNodes[key] = clone;
	    clone.key = clone.key || key;
	    return clone;
	  }); // Connect tree
	
	  nodeList.forEach(function (node) {
	    var parentKey = node[pId];
	    var parent = keyNodes[parentKey]; // Fill parent
	
	    if (parent) {
	      parent.children = parent.children || [];
	      parent.children.push(node);
	    } // Fill root tree node
	
	
	    if (parentKey === rootPId || !parent && rootPId === null) {
	      rootNodeList.push(node);
	    }
	  });
	  return rootNodeList;
	}
	/**
	 * Detect if position has relation.
	 * e.g. 1-2 related with 1-2-3
	 * e.g. 1-3-2 related with 1
	 * e.g. 1-2 not related with 1-21
	 */
	
	
	function isPosRelated(pos1, pos2) {
	  var fields1 = pos1.split('-');
	  var fields2 = pos2.split('-');
	  var minLen = Math.min(fields1.length, fields2.length);
	
	  for (var i = 0; i < minLen; i += 1) {
	    if (fields1[i] !== fields2[i]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	/**
	 * This function is only used on treeNode check (none treeCheckStrictly but has searchInput).
	 * We convert entity to { node, pos, children } format.
	 * This is legacy bug but we still need to do with it.
	 * @param entity
	 */
	
	
	function cleanEntity(_ref2) {
	  var node = _ref2.node,
	      pos = _ref2.pos,
	      children = _ref2.children;
	  var instance = {
	    node: node,
	    pos: pos
	  };
	
	  if (children) {
	    instance.children = children.map(cleanEntity);
	  }
	
	  return instance;
	}
	/**
	 * Get a filtered TreeNode list by provided treeNodes.
	 * [Legacy] Since `Tree` use `key` as map but `key` will changed by React,
	 * we have to convert `treeNodes > data > treeNodes` to keep the key.
	 * Such performance hungry!
	 *
	 * We pass `Component` as argument is to fix eslint issue.
	 */
	
	
	function getFilterTree(treeNodes, searchValue, filterFunc, valueEntities, Component) {
	  if (!searchValue) {
	    return null;
	  }
	
	  function mapFilteredNodeToData(node) {
	    if (!node) return null;
	    var match = false;
	
	    if (filterFunc(searchValue, node)) {
	      match = true;
	    }
	
	    var children = (0, _toArray["default"])(node.props.children).map(mapFilteredNodeToData).filter(function (n) {
	      return n;
	    });
	
	    if (children.length || match) {
	      return _react["default"].createElement(Component, _extends({}, node.props, {
	        key: valueEntities[node.props.value].key
	      }), children);
	    }
	
	    return null;
	  }
	
	  return treeNodes.map(mapFilteredNodeToData).filter(function (node) {
	    return node;
	  });
	} // =================== Value ===================
	
	/**
	 * Convert value to array format to make logic simplify.
	 */
	
	
	function formatInternalValue(value, props) {
	  var valueList = toArray(value); // Parse label in value
	
	  if (isLabelInValue(props)) {
	    return valueList.map(function (val) {
	      if (typeof val !== 'object' || !val) {
	        return {
	          value: '',
	          label: ''
	        };
	      }
	
	      return val;
	    });
	  }
	
	  return valueList.map(function (val) {
	    return {
	      value: val
	    };
	  });
	}
	
	function getLabel(wrappedValue, entity, treeNodeLabelProp) {
	  if (wrappedValue.label) {
	    return wrappedValue.label;
	  }
	
	  if (entity && entity.node.props) {
	    return entity.node.props[treeNodeLabelProp];
	  } // Since value without entity will be in missValueList.
	  // This code will never reached, but we still need this in case.
	
	
	  return wrappedValue.value;
	}
	/**
	 * Convert internal state `valueList` to user needed value list.
	 * This will return an array list. You need check if is not multiple when return.
	 *
	 * `allCheckedNodes` is used for `treeCheckStrictly`
	 */
	
	
	function formatSelectorValue(valueList, props, valueEntities) {
	  var treeNodeLabelProp = props.treeNodeLabelProp,
	      treeCheckable = props.treeCheckable,
	      treeCheckStrictly = props.treeCheckStrictly,
	      showCheckedStrategy = props.showCheckedStrategy; // Will hide some value if `showCheckedStrategy` is set
	
	  if (treeCheckable && !treeCheckStrictly) {
	    var values = {};
	    valueList.forEach(function (wrappedValue) {
	      values[wrappedValue.value] = wrappedValue;
	    });
	    var hierarchyList = flatToHierarchy(valueList.map(function (_ref3) {
	      var value = _ref3.value;
	      return valueEntities[value];
	    }));
	
	    if (showCheckedStrategy === _strategies.SHOW_PARENT) {
	      // Only get the parent checked value
	      return hierarchyList.map(function (_ref4) {
	        var value = _ref4.node.props.value;
	        return {
	          label: getLabel(values[value], valueEntities[value], treeNodeLabelProp),
	          value: value
	        };
	      });
	    }
	
	    if (showCheckedStrategy === _strategies.SHOW_CHILD) {
	      // Only get the children checked value
	      var targetValueList = []; // Find the leaf children
	
	      var traverse = function traverse(_ref5) {
	        var value = _ref5.node.props.value,
	            children = _ref5.children;
	
	        if (!children || children.length === 0) {
	          targetValueList.push({
	            label: getLabel(values[value], valueEntities[value], treeNodeLabelProp),
	            value: value
	          });
	          return;
	        }
	
	        children.forEach(function (entity) {
	          traverse(entity);
	        });
	      };
	
	      hierarchyList.forEach(function (entity) {
	        traverse(entity);
	      });
	      return targetValueList;
	    }
	  }
	
	  return valueList.map(function (wrappedValue) {
	    return {
	      label: getLabel(wrappedValue, valueEntities[wrappedValue.value], treeNodeLabelProp),
	      value: wrappedValue.value
	    };
	  });
	}
	/**
	 * Use `rc-tree` convertDataToTree to convert treeData to TreeNodes.
	 * This will change the label to title value
	 */
	
	
	function processProps(props) {
	  var title = props.title,
	      label = props.label,
	      key = props.key,
	      value = props.value;
	
	  var cloneProps = _objectSpread({}, props); // Warning user not to use deprecated label prop.
	
	
	  if (label && !title) {
	    if (!warnDeprecatedLabel) {
	      (0, _warning["default"])(false, "'label' in treeData is deprecated. Please use 'title' instead.");
	      warnDeprecatedLabel = true;
	    }
	
	    cloneProps.title = label;
	  }
	
	  if (!key) {
	    cloneProps.key = value;
	  }
	
	  return cloneProps;
	}
	
	function convertDataToTree(treeData) {
	  return (0, _util.convertDataToTree)(treeData, {
	    processProps: processProps
	  });
	}
	/**
	 * Use `rc-tree` convertTreeToEntities for entities calculation.
	 * We have additional entities of `valueEntities`
	 */
	
	
	function initWrapper(wrapper) {
	  return _objectSpread({}, wrapper, {
	    valueEntities: {}
	  });
	}
	
	function processEntity(entity, wrapper) {
	  var value = entity.node.props.value;
	  entity.value = value; // This should be empty, or will get error message.
	
	  var currentEntity = wrapper.valueEntities[value];
	
	  if (currentEntity) {
	    (0, _warning["default"])(false, "Conflict! value of node '".concat(entity.key, "' (").concat(value, ") has already used by node '").concat(currentEntity.key, "'."));
	  }
	
	  wrapper.valueEntities[value] = entity;
	}
	
	function convertTreeToEntities(treeNodes) {
	  return (0, _util.convertTreeToEntities)(treeNodes, {
	    initWrapper: initWrapper,
	    processEntity: processEntity
	  });
	}
	/**
	 * https://github.com/ant-design/ant-design/issues/13328
	 * We need calculate the half check key when searchValue is set.
	 */
	// TODO: This logic may better move to rc-tree
	
	
	function getHalfCheckedKeys(valueList, valueEntities) {
	  var values = {}; // Fill checked keys
	
	  valueList.forEach(function (_ref6) {
	    var value = _ref6.value;
	    values[value] = false;
	  }); // Fill half checked keys
	
	  valueList.forEach(function (_ref7) {
	    var value = _ref7.value;
	    var current = valueEntities[value];
	
	    while (current && current.parent) {
	      var parentValue = current.parent.value;
	      if (parentValue in values) break;
	      values[parentValue] = true;
	      current = current.parent;
	    }
	  }); // Get half keys
	
	  return Object.keys(values).filter(function (value) {
	    return values[value];
	  }).map(function (value) {
	    return valueEntities[value].key;
	  });
	}
	
	var conductCheck = _util.conductCheck;
	exports.conductCheck = conductCheck;

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addEventListenerWrap;
	
	var _addDomEventListener = _interopRequireDefault(__webpack_require__(1223));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function addEventListenerWrap(target, eventType, cb, option) {
	  /* eslint camelcase: 2 */
	  var callback = _reactDom.default.unstable_batchedUpdates ? function run(e) {
	    _reactDom.default.unstable_batchedUpdates(cb, e);
	  } : cb;
	  return (0, _addDomEventListener.default)(target, eventType, callback, option);
	}

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47),
	    _assign = __webpack_require__(40);
	
	var CallbackQueue = __webpack_require__(1129);
	var PooledClass = __webpack_require__(221);
	var ReactFeatureFlags = __webpack_require__(1134);
	var ReactReconciler = __webpack_require__(260);
	var Transaction = __webpack_require__(387);
	
	var invariant = __webpack_require__(18);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var Eventful = __webpack_require__(225);
	
	exports.Dispatcher = Eventful;
	
	var env = __webpack_require__(73);
	
	var _dom = __webpack_require__(1196);
	
	var isCanvasEl = _dom.isCanvasEl;
	var transformCoordWithViewport = _dom.transformCoordWithViewport;
	
	/**
	 * Utilities for mouse or touch events.
	 */
	var isDomLevel2 = typeof window !== 'undefined' && !!window.addEventListener;
	var MOUSE_EVENT_REG = /^(?:mouse|pointer|contextmenu|drag|drop)|click/;
	var _calcOut = [];
	/**
	 * Get the `zrX` and `zrY`, which are relative to the top-left of
	 * the input `el`.
	 * CSS transform (2D & 3D) is supported.
	 *
	 * The strategy to fetch the coords:
	 * + If `calculate` is not set as `true`, users of this method should
	 * ensure that `el` is the same or the same size & location as `e.target`.
	 * Otherwise the result coords are probably not expected. Because we
	 * firstly try to get coords from e.offsetX/e.offsetY.
	 * + If `calculate` is set as `true`, the input `el` can be any element
	 * and we force to calculate the coords based on `el`.
	 * + The input `el` should be positionable (not position:static).
	 *
	 * The force `calculate` can be used in case like:
	 * When mousemove event triggered on ec tooltip, `e.target` is not `el`(zr painter.dom).
	 *
	 * @param {HTMLElement} el DOM element.
	 * @param {Event} e Mouse event or touch event.
	 * @param {Object} out Get `out.zrX` and `out.zrY` as the result.
	 * @param {boolean} [calculate=false] Whether to force calculate
	 *        the coordinates but not use ones provided by browser.
	 */
	
	function clientToLocal(el, e, out, calculate) {
	  out = out || {}; // According to the W3C Working Draft, offsetX and offsetY should be relative
	  // to the padding edge of the target element. The only browser using this convention
	  // is IE. Webkit uses the border edge, Opera uses the content edge, and FireFox does
	  // not support the properties.
	  // (see http://www.jacklmoore.com/notes/mouse-position/)
	  // In zr painter.dom, padding edge equals to border edge.
	
	  if (calculate || !env.canvasSupported) {
	    calculateZrXY(el, e, out);
	  } // Caution: In FireFox, layerX/layerY Mouse position relative to the closest positioned
	  // ancestor element, so we should make sure el is positioned (e.g., not position:static).
	  // BTW1, Webkit don't return the same results as FF in non-simple cases (like add
	  // zoom-factor, overflow / opacity layers, transforms ...)
	  // BTW2, (ev.offsetY || ev.pageY - $(ev.target).offset().top) is not correct in preserve-3d.
	  // <https://bugs.jquery.com/ticket/8523#comment:14>
	  // BTW3, In ff, offsetX/offsetY is always 0.
	  else if (env.browser.firefox && e.layerX != null && e.layerX !== e.offsetX) {
	      out.zrX = e.layerX;
	      out.zrY = e.layerY;
	    } // For IE6+, chrome, safari, opera. (When will ff support offsetX?)
	    else if (e.offsetX != null) {
	        out.zrX = e.offsetX;
	        out.zrY = e.offsetY;
	      } // For some other device, e.g., IOS safari.
	      else {
	          calculateZrXY(el, e, out);
	        }
	
	  return out;
	}
	
	function calculateZrXY(el, e, out) {
	  // BlackBerry 5, iOS 3 (original iPhone) don't have getBoundingRect.
	  if (env.domSupported && el.getBoundingClientRect) {
	    var ex = e.clientX;
	    var ey = e.clientY;
	
	    if (isCanvasEl(el)) {
	      // Original approach, which do not support CSS transform.
	      // marker can not be locationed in a canvas container
	      // (getBoundingClientRect is always 0). We do not support
	      // that input a pre-created canvas to zr while using css
	      // transform in iOS.
	      var box = el.getBoundingClientRect();
	      out.zrX = ex - box.left;
	      out.zrY = ey - box.top;
	      return;
	    } else {
	      if (transformCoordWithViewport(_calcOut, el, ex, ey)) {
	        out.zrX = _calcOut[0];
	        out.zrY = _calcOut[1];
	        return;
	      }
	    }
	  }
	
	  out.zrX = out.zrY = 0;
	}
	/**
	 * Find native event compat for legency IE.
	 * Should be called at the begining of a native event listener.
	 *
	 * @param {Event} [e] Mouse event or touch event or pointer event.
	 *        For lagency IE, we use `window.event` is used.
	 * @return {Event} The native event.
	 */
	
	
	function getNativeEvent(e) {
	  return e || window.event;
	}
	/**
	 * Normalize the coordinates of the input event.
	 *
	 * Get the `e.zrX` and `e.zrY`, which are relative to the top-left of
	 * the input `el`.
	 * Get `e.zrDelta` if using mouse wheel.
	 * Get `e.which`, see the comment inside this function.
	 *
	 * Do not calculate repeatly if `zrX` and `zrY` already exist.
	 *
	 * Notice: see comments in `clientToLocal`. check the relationship
	 * between the result coords and the parameters `el` and `calculate`.
	 *
	 * @param {HTMLElement} el DOM element.
	 * @param {Event} [e] See `getNativeEvent`.
	 * @param {boolean} [calculate=false] Whether to force calculate
	 *        the coordinates but not use ones provided by browser.
	 * @return {UIEvent} The normalized native UIEvent.
	 */
	
	
	function normalizeEvent(el, e, calculate) {
	  e = getNativeEvent(e);
	
	  if (e.zrX != null) {
	    return e;
	  }
	
	  var eventType = e.type;
	  var isTouch = eventType && eventType.indexOf('touch') >= 0;
	
	  if (!isTouch) {
	    clientToLocal(el, e, e, calculate);
	    e.zrDelta = e.wheelDelta ? e.wheelDelta / 120 : -(e.detail || 0) / 3;
	  } else {
	    var touch = eventType !== 'touchend' ? e.targetTouches[0] : e.changedTouches[0];
	    touch && clientToLocal(el, touch, e, calculate);
	  } // Add which for click: 1 === left; 2 === middle; 3 === right; otherwise: 0;
	  // See jQuery: https://github.com/jquery/jquery/blob/master/src/event.js
	  // If e.which has been defined, it may be readonly,
	  // see: https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/which
	
	
	  var button = e.button;
	
	  if (e.which == null && button !== undefined && MOUSE_EVENT_REG.test(e.type)) {
	    e.which = button & 1 ? 1 : button & 2 ? 3 : button & 4 ? 2 : 0;
	  } // [Caution]: `e.which` from browser is not always reliable. For example,
	  // when press left button and `mousemove (pointermove)` in Edge, the `e.which`
	  // is 65536 and the `e.button` is -1. But the `mouseup (pointerup)` and
	  // `mousedown (pointerdown)` is the same as Chrome does.
	
	
	  return e;
	}
	/**
	 * @param {HTMLElement} el
	 * @param {string} name
	 * @param {Function} handler
	 * @param {Object|boolean} opt If boolean, means `opt.capture`
	 * @param {boolean} [opt.capture=false]
	 * @param {boolean} [opt.passive=false]
	 */
	
	
	function addEventListener(el, name, handler, opt) {
	  if (isDomLevel2) {
	    // Reproduct the console warning:
	    // [Violation] Added non-passive event listener to a scroll-blocking <some> event.
	    // Consider marking event handler as 'passive' to make the page more responsive.
	    // Just set console log level: verbose in chrome dev tool.
	    // then the warning log will be printed when addEventListener called.
	    // See https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md
	    // We have not yet found a neat way to using passive. Because in zrender the dom event
	    // listener delegate all of the upper events of element. Some of those events need
	    // to prevent default. For example, the feature `preventDefaultMouseMove` of echarts.
	    // Before passive can be adopted, these issues should be considered:
	    // (1) Whether and how a zrender user specifies an event listener passive. And by default,
	    // passive or not.
	    // (2) How to tread that some zrender event listener is passive, and some is not. If
	    // we use other way but not preventDefault of mousewheel and touchmove, browser
	    // compatibility should be handled.
	    // var opts = (env.passiveSupported && name === 'mousewheel')
	    //     ? {passive: true}
	    //     // By default, the third param of el.addEventListener is `capture: false`.
	    //     : void 0;
	    // el.addEventListener(name, handler /* , opts */);
	    el.addEventListener(name, handler, opt);
	  } else {
	    // For simplicity, do not implement `setCapture` for IE9-.
	    el.attachEvent('on' + name, handler);
	  }
	}
	/**
	 * Parameter are the same as `addEventListener`.
	 *
	 * Notice that if a listener is registered twice, one with capture and one without,
	 * remove each one separately. Removal of a capturing listener does not affect a
	 * non-capturing version of the same listener, and vice versa.
	 */
	
	
	function removeEventListener(el, name, handler, opt) {
	  if (isDomLevel2) {
	    el.removeEventListener(name, handler, opt);
	  } else {
	    el.detachEvent('on' + name, handler);
	  }
	}
	/**
	 * preventDefault and stopPropagation.
	 * Notice: do not use this method in zrender. It can only be
	 * used by upper applications if necessary.
	 *
	 * @param {Event} e A mouse or touch event.
	 */
	
	
	var stop = isDomLevel2 ? function (e) {
	  e.preventDefault();
	  e.stopPropagation();
	  e.cancelBubble = true;
	} : function (e) {
	  e.returnValue = false;
	  e.cancelBubble = true;
	};
	/**
	 * This method only works for mouseup and mousedown. The functionality is restricted
	 * for fault tolerance, See the `e.which` compatibility above.
	 *
	 * @param {MouseEvent} e
	 * @return {boolean}
	 */
	
	function isMiddleOrRightButtonOnMouseUpDown(e) {
	  return e.which === 2 || e.which === 3;
	}
	/**
	 * To be removed.
	 * @deprecated
	 */
	
	
	function notLeftMouse(e) {
	  // If e.which is undefined, considered as left mouse event.
	  return e.which > 1;
	} // For backward compatibility
	
	
	exports.clientToLocal = clientToLocal;
	exports.getNativeEvent = getNativeEvent;
	exports.normalizeEvent = normalizeEvent;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.stop = stop;
	exports.isMiddleOrRightButtonOnMouseUpDown = isMiddleOrRightButtonOnMouseUpDown;
	exports.notLeftMouse = notLeftMouse;

/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(1195);
	
	var kCSSColorTable = {
	  'transparent': [0, 0, 0, 0],
	  'aliceblue': [240, 248, 255, 1],
	  'antiquewhite': [250, 235, 215, 1],
	  'aqua': [0, 255, 255, 1],
	  'aquamarine': [127, 255, 212, 1],
	  'azure': [240, 255, 255, 1],
	  'beige': [245, 245, 220, 1],
	  'bisque': [255, 228, 196, 1],
	  'black': [0, 0, 0, 1],
	  'blanchedalmond': [255, 235, 205, 1],
	  'blue': [0, 0, 255, 1],
	  'blueviolet': [138, 43, 226, 1],
	  'brown': [165, 42, 42, 1],
	  'burlywood': [222, 184, 135, 1],
	  'cadetblue': [95, 158, 160, 1],
	  'chartreuse': [127, 255, 0, 1],
	  'chocolate': [210, 105, 30, 1],
	  'coral': [255, 127, 80, 1],
	  'cornflowerblue': [100, 149, 237, 1],
	  'cornsilk': [255, 248, 220, 1],
	  'crimson': [220, 20, 60, 1],
	  'cyan': [0, 255, 255, 1],
	  'darkblue': [0, 0, 139, 1],
	  'darkcyan': [0, 139, 139, 1],
	  'darkgoldenrod': [184, 134, 11, 1],
	  'darkgray': [169, 169, 169, 1],
	  'darkgreen': [0, 100, 0, 1],
	  'darkgrey': [169, 169, 169, 1],
	  'darkkhaki': [189, 183, 107, 1],
	  'darkmagenta': [139, 0, 139, 1],
	  'darkolivegreen': [85, 107, 47, 1],
	  'darkorange': [255, 140, 0, 1],
	  'darkorchid': [153, 50, 204, 1],
	  'darkred': [139, 0, 0, 1],
	  'darksalmon': [233, 150, 122, 1],
	  'darkseagreen': [143, 188, 143, 1],
	  'darkslateblue': [72, 61, 139, 1],
	  'darkslategray': [47, 79, 79, 1],
	  'darkslategrey': [47, 79, 79, 1],
	  'darkturquoise': [0, 206, 209, 1],
	  'darkviolet': [148, 0, 211, 1],
	  'deeppink': [255, 20, 147, 1],
	  'deepskyblue': [0, 191, 255, 1],
	  'dimgray': [105, 105, 105, 1],
	  'dimgrey': [105, 105, 105, 1],
	  'dodgerblue': [30, 144, 255, 1],
	  'firebrick': [178, 34, 34, 1],
	  'floralwhite': [255, 250, 240, 1],
	  'forestgreen': [34, 139, 34, 1],
	  'fuchsia': [255, 0, 255, 1],
	  'gainsboro': [220, 220, 220, 1],
	  'ghostwhite': [248, 248, 255, 1],
	  'gold': [255, 215, 0, 1],
	  'goldenrod': [218, 165, 32, 1],
	  'gray': [128, 128, 128, 1],
	  'green': [0, 128, 0, 1],
	  'greenyellow': [173, 255, 47, 1],
	  'grey': [128, 128, 128, 1],
	  'honeydew': [240, 255, 240, 1],
	  'hotpink': [255, 105, 180, 1],
	  'indianred': [205, 92, 92, 1],
	  'indigo': [75, 0, 130, 1],
	  'ivory': [255, 255, 240, 1],
	  'khaki': [240, 230, 140, 1],
	  'lavender': [230, 230, 250, 1],
	  'lavenderblush': [255, 240, 245, 1],
	  'lawngreen': [124, 252, 0, 1],
	  'lemonchiffon': [255, 250, 205, 1],
	  'lightblue': [173, 216, 230, 1],
	  'lightcoral': [240, 128, 128, 1],
	  'lightcyan': [224, 255, 255, 1],
	  'lightgoldenrodyellow': [250, 250, 210, 1],
	  'lightgray': [211, 211, 211, 1],
	  'lightgreen': [144, 238, 144, 1],
	  'lightgrey': [211, 211, 211, 1],
	  'lightpink': [255, 182, 193, 1],
	  'lightsalmon': [255, 160, 122, 1],
	  'lightseagreen': [32, 178, 170, 1],
	  'lightskyblue': [135, 206, 250, 1],
	  'lightslategray': [119, 136, 153, 1],
	  'lightslategrey': [119, 136, 153, 1],
	  'lightsteelblue': [176, 196, 222, 1],
	  'lightyellow': [255, 255, 224, 1],
	  'lime': [0, 255, 0, 1],
	  'limegreen': [50, 205, 50, 1],
	  'linen': [250, 240, 230, 1],
	  'magenta': [255, 0, 255, 1],
	  'maroon': [128, 0, 0, 1],
	  'mediumaquamarine': [102, 205, 170, 1],
	  'mediumblue': [0, 0, 205, 1],
	  'mediumorchid': [186, 85, 211, 1],
	  'mediumpurple': [147, 112, 219, 1],
	  'mediumseagreen': [60, 179, 113, 1],
	  'mediumslateblue': [123, 104, 238, 1],
	  'mediumspringgreen': [0, 250, 154, 1],
	  'mediumturquoise': [72, 209, 204, 1],
	  'mediumvioletred': [199, 21, 133, 1],
	  'midnightblue': [25, 25, 112, 1],
	  'mintcream': [245, 255, 250, 1],
	  'mistyrose': [255, 228, 225, 1],
	  'moccasin': [255, 228, 181, 1],
	  'navajowhite': [255, 222, 173, 1],
	  'navy': [0, 0, 128, 1],
	  'oldlace': [253, 245, 230, 1],
	  'olive': [128, 128, 0, 1],
	  'olivedrab': [107, 142, 35, 1],
	  'orange': [255, 165, 0, 1],
	  'orangered': [255, 69, 0, 1],
	  'orchid': [218, 112, 214, 1],
	  'palegoldenrod': [238, 232, 170, 1],
	  'palegreen': [152, 251, 152, 1],
	  'paleturquoise': [175, 238, 238, 1],
	  'palevioletred': [219, 112, 147, 1],
	  'papayawhip': [255, 239, 213, 1],
	  'peachpuff': [255, 218, 185, 1],
	  'peru': [205, 133, 63, 1],
	  'pink': [255, 192, 203, 1],
	  'plum': [221, 160, 221, 1],
	  'powderblue': [176, 224, 230, 1],
	  'purple': [128, 0, 128, 1],
	  'red': [255, 0, 0, 1],
	  'rosybrown': [188, 143, 143, 1],
	  'royalblue': [65, 105, 225, 1],
	  'saddlebrown': [139, 69, 19, 1],
	  'salmon': [250, 128, 114, 1],
	  'sandybrown': [244, 164, 96, 1],
	  'seagreen': [46, 139, 87, 1],
	  'seashell': [255, 245, 238, 1],
	  'sienna': [160, 82, 45, 1],
	  'silver': [192, 192, 192, 1],
	  'skyblue': [135, 206, 235, 1],
	  'slateblue': [106, 90, 205, 1],
	  'slategray': [112, 128, 144, 1],
	  'slategrey': [112, 128, 144, 1],
	  'snow': [255, 250, 250, 1],
	  'springgreen': [0, 255, 127, 1],
	  'steelblue': [70, 130, 180, 1],
	  'tan': [210, 180, 140, 1],
	  'teal': [0, 128, 128, 1],
	  'thistle': [216, 191, 216, 1],
	  'tomato': [255, 99, 71, 1],
	  'turquoise': [64, 224, 208, 1],
	  'violet': [238, 130, 238, 1],
	  'wheat': [245, 222, 179, 1],
	  'white': [255, 255, 255, 1],
	  'whitesmoke': [245, 245, 245, 1],
	  'yellow': [255, 255, 0, 1],
	  'yellowgreen': [154, 205, 50, 1]
	};
	
	function clampCssByte(i) {
	  // Clamp to integer 0 .. 255.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 255 ? 255 : i;
	}
	
	function clampCssAngle(i) {
	  // Clamp to integer 0 .. 360.
	  i = Math.round(i); // Seems to be what Chrome does (vs truncation).
	
	  return i < 0 ? 0 : i > 360 ? 360 : i;
	}
	
	function clampCssFloat(f) {
	  // Clamp to float 0.0 .. 1.0.
	  return f < 0 ? 0 : f > 1 ? 1 : f;
	}
	
	function parseCssInt(str) {
	  // int or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssByte(parseFloat(str) / 100 * 255);
	  }
	
	  return clampCssByte(parseInt(str, 10));
	}
	
	function parseCssFloat(str) {
	  // float or percentage.
	  if (str.length && str.charAt(str.length - 1) === '%') {
	    return clampCssFloat(parseFloat(str) / 100);
	  }
	
	  return clampCssFloat(parseFloat(str));
	}
	
	function cssHueToRgb(m1, m2, h) {
	  if (h < 0) {
	    h += 1;
	  } else if (h > 1) {
	    h -= 1;
	  }
	
	  if (h * 6 < 1) {
	    return m1 + (m2 - m1) * h * 6;
	  }
	
	  if (h * 2 < 1) {
	    return m2;
	  }
	
	  if (h * 3 < 2) {
	    return m1 + (m2 - m1) * (2 / 3 - h) * 6;
	  }
	
	  return m1;
	}
	
	function lerpNumber(a, b, p) {
	  return a + (b - a) * p;
	}
	
	function setRgba(out, r, g, b, a) {
	  out[0] = r;
	  out[1] = g;
	  out[2] = b;
	  out[3] = a;
	  return out;
	}
	
	function copyRgba(out, a) {
	  out[0] = a[0];
	  out[1] = a[1];
	  out[2] = a[2];
	  out[3] = a[3];
	  return out;
	}
	
	var colorCache = new LRU(20);
	var lastRemovedArr = null;
	
	function putToCache(colorStr, rgbaArr) {
	  // Reuse removed array
	  if (lastRemovedArr) {
	    copyRgba(lastRemovedArr, rgbaArr);
	  }
	
	  lastRemovedArr = colorCache.put(colorStr, lastRemovedArr || rgbaArr.slice());
	}
	/**
	 * @param {string} colorStr
	 * @param {Array.<number>} out
	 * @return {Array.<number>}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function parse(colorStr, rgbaArr) {
	  if (!colorStr) {
	    return;
	  }
	
	  rgbaArr = rgbaArr || [];
	  var cached = colorCache.get(colorStr);
	
	  if (cached) {
	    return copyRgba(rgbaArr, cached);
	  } // colorStr may be not string
	
	
	  colorStr = colorStr + ''; // Remove all whitespace, not compliant, but should just be more accepting.
	
	  var str = colorStr.replace(/ /g, '').toLowerCase(); // Color keywords (and transparent) lookup.
	
	  if (str in kCSSColorTable) {
	    copyRgba(rgbaArr, kCSSColorTable[str]);
	    putToCache(colorStr, rgbaArr);
	    return rgbaArr;
	  } // #abc and #abc123 syntax.
	
	
	  if (str.charAt(0) === '#') {
	    if (str.length === 4) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xfff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xf00) >> 4 | (iv & 0xf00) >> 8, iv & 0xf0 | (iv & 0xf0) >> 4, iv & 0xf | (iv & 0xf) << 4, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    } else if (str.length === 7) {
	      var iv = parseInt(str.substr(1), 16); // TODO(deanm): Stricter parsing.
	
	      if (!(iv >= 0 && iv <= 0xffffff)) {
	        setRgba(rgbaArr, 0, 0, 0, 1);
	        return; // Covers NaN.
	      }
	
	      setRgba(rgbaArr, (iv & 0xff0000) >> 16, (iv & 0xff00) >> 8, iv & 0xff, 1);
	      putToCache(colorStr, rgbaArr);
	      return rgbaArr;
	    }
	
	    return;
	  }
	
	  var op = str.indexOf('(');
	  var ep = str.indexOf(')');
	
	  if (op !== -1 && ep + 1 === str.length) {
	    var fname = str.substr(0, op);
	    var params = str.substr(op + 1, ep - (op + 1)).split(',');
	    var alpha = 1; // To allow case fallthrough.
	
	    switch (fname) {
	      case 'rgba':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        alpha = parseCssFloat(params.pop());
	      // jshint ignore:line
	      // Fall through.
	
	      case 'rgb':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        setRgba(rgbaArr, parseCssInt(params[0]), parseCssInt(params[1]), parseCssInt(params[2]), alpha);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsla':
	        if (params.length !== 4) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        params[3] = parseCssFloat(params[3]);
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      case 'hsl':
	        if (params.length !== 3) {
	          setRgba(rgbaArr, 0, 0, 0, 1);
	          return;
	        }
	
	        hsla2rgba(params, rgbaArr);
	        putToCache(colorStr, rgbaArr);
	        return rgbaArr;
	
	      default:
	        return;
	    }
	  }
	
	  setRgba(rgbaArr, 0, 0, 0, 1);
	  return;
	}
	/**
	 * @param {Array.<number>} hsla
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} rgba
	 */
	
	
	function hsla2rgba(hsla, rgba) {
	  var h = (parseFloat(hsla[0]) % 360 + 360) % 360 / 360; // 0 .. 1
	  // NOTE(deanm): According to the CSS spec s/l should only be
	  // percentages, but we don't bother and let float or percentage.
	
	  var s = parseCssFloat(hsla[1]);
	  var l = parseCssFloat(hsla[2]);
	  var m2 = l <= 0.5 ? l * (s + 1) : l + s - l * s;
	  var m1 = l * 2 - m2;
	  rgba = rgba || [];
	  setRgba(rgba, clampCssByte(cssHueToRgb(m1, m2, h + 1 / 3) * 255), clampCssByte(cssHueToRgb(m1, m2, h) * 255), clampCssByte(cssHueToRgb(m1, m2, h - 1 / 3) * 255), 1);
	
	  if (hsla.length === 4) {
	    rgba[3] = hsla[3];
	  }
	
	  return rgba;
	}
	/**
	 * @param {Array.<number>} rgba
	 * @return {Array.<number>} hsla
	 */
	
	
	function rgba2hsla(rgba) {
	  if (!rgba) {
	    return;
	  } // RGB from 0 to 255
	
	
	  var R = rgba[0] / 255;
	  var G = rgba[1] / 255;
	  var B = rgba[2] / 255;
	  var vMin = Math.min(R, G, B); // Min. value of RGB
	
	  var vMax = Math.max(R, G, B); // Max. value of RGB
	
	  var delta = vMax - vMin; // Delta RGB value
	
	  var L = (vMax + vMin) / 2;
	  var H;
	  var S; // HSL results from 0 to 1
	
	  if (delta === 0) {
	    H = 0;
	    S = 0;
	  } else {
	    if (L < 0.5) {
	      S = delta / (vMax + vMin);
	    } else {
	      S = delta / (2 - vMax - vMin);
	    }
	
	    var deltaR = ((vMax - R) / 6 + delta / 2) / delta;
	    var deltaG = ((vMax - G) / 6 + delta / 2) / delta;
	    var deltaB = ((vMax - B) / 6 + delta / 2) / delta;
	
	    if (R === vMax) {
	      H = deltaB - deltaG;
	    } else if (G === vMax) {
	      H = 1 / 3 + deltaR - deltaB;
	    } else if (B === vMax) {
	      H = 2 / 3 + deltaG - deltaR;
	    }
	
	    if (H < 0) {
	      H += 1;
	    }
	
	    if (H > 1) {
	      H -= 1;
	    }
	  }
	
	  var hsla = [H * 360, S, L];
	
	  if (rgba[3] != null) {
	    hsla.push(rgba[3]);
	  }
	
	  return hsla;
	}
	/**
	 * @param {string} color
	 * @param {number} level
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function lift(color, level) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    for (var i = 0; i < 3; i++) {
	      if (level < 0) {
	        colorArr[i] = colorArr[i] * (1 - level) | 0;
	      } else {
	        colorArr[i] = (255 - colorArr[i]) * level + colorArr[i] | 0;
	      }
	
	      if (colorArr[i] > 255) {
	        colorArr[i] = 255;
	      } else if (color[i] < 0) {
	        colorArr[i] = 0;
	      }
	    }
	
	    return stringify(colorArr, colorArr.length === 4 ? 'rgba' : 'rgb');
	  }
	}
	/**
	 * @param {string} color
	 * @return {string}
	 * @memberOf module:zrender/util/color
	 */
	
	
	function toHex(color) {
	  var colorArr = parse(color);
	
	  if (colorArr) {
	    return ((1 << 24) + (colorArr[0] << 16) + (colorArr[1] << 8) + +colorArr[2]).toString(16).slice(1);
	  }
	}
	/**
	 * Map value to color. Faster than lerp methods because color is represented by rgba array.
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<Array.<number>>} colors List of rgba color array
	 * @param {Array.<number>} [out] Mapped gba color array
	 * @return {Array.<number>} will be null/undefined if input illegal.
	 */
	
	
	function fastLerp(normalizedValue, colors, out) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  out = out || [];
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = colors[leftIndex];
	  var rightColor = colors[rightIndex];
	  var dv = value - leftIndex;
	  out[0] = clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv));
	  out[1] = clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv));
	  out[2] = clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv));
	  out[3] = clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv));
	  return out;
	}
	/**
	 * @deprecated
	 */
	
	
	var fastMapToColor = fastLerp;
	/**
	 * @param {number} normalizedValue A float between 0 and 1.
	 * @param {Array.<string>} colors Color list.
	 * @param {boolean=} fullOutput Default false.
	 * @return {(string|Object)} Result color. If fullOutput,
	 *                           return {color: ..., leftIndex: ..., rightIndex: ..., value: ...},
	 * @memberOf module:zrender/util/color
	 */
	
	function lerp(normalizedValue, colors, fullOutput) {
	  if (!(colors && colors.length) || !(normalizedValue >= 0 && normalizedValue <= 1)) {
	    return;
	  }
	
	  var value = normalizedValue * (colors.length - 1);
	  var leftIndex = Math.floor(value);
	  var rightIndex = Math.ceil(value);
	  var leftColor = parse(colors[leftIndex]);
	  var rightColor = parse(colors[rightIndex]);
	  var dv = value - leftIndex;
	  var color = stringify([clampCssByte(lerpNumber(leftColor[0], rightColor[0], dv)), clampCssByte(lerpNumber(leftColor[1], rightColor[1], dv)), clampCssByte(lerpNumber(leftColor[2], rightColor[2], dv)), clampCssFloat(lerpNumber(leftColor[3], rightColor[3], dv))], 'rgba');
	  return fullOutput ? {
	    color: color,
	    leftIndex: leftIndex,
	    rightIndex: rightIndex,
	    value: value
	  } : color;
	}
	/**
	 * @deprecated
	 */
	
	
	var mapToColor = lerp;
	/**
	 * @param {string} color
	 * @param {number=} h 0 ~ 360, ignore when null.
	 * @param {number=} s 0 ~ 1, ignore when null.
	 * @param {number=} l 0 ~ 1, ignore when null.
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	function modifyHSL(color, h, s, l) {
	  color = parse(color);
	
	  if (color) {
	    color = rgba2hsla(color);
	    h != null && (color[0] = clampCssAngle(h));
	    s != null && (color[1] = parseCssFloat(s));
	    l != null && (color[2] = parseCssFloat(l));
	    return stringify(hsla2rgba(color), 'rgba');
	  }
	}
	/**
	 * @param {string} color
	 * @param {number=} alpha 0 ~ 1
	 * @return {string} Color string in rgba format.
	 * @memberOf module:zrender/util/color
	 */
	
	
	function modifyAlpha(color, alpha) {
	  color = parse(color);
	
	  if (color && alpha != null) {
	    color[3] = clampCssFloat(alpha);
	    return stringify(color, 'rgba');
	  }
	}
	/**
	 * @param {Array.<number>} arrColor like [12,33,44,0.4]
	 * @param {string} type 'rgba', 'hsva', ...
	 * @return {string} Result color. (If input illegal, return undefined).
	 */
	
	
	function stringify(arrColor, type) {
	  if (!arrColor || !arrColor.length) {
	    return;
	  }
	
	  var colorStr = arrColor[0] + ',' + arrColor[1] + ',' + arrColor[2];
	
	  if (type === 'rgba' || type === 'hsva' || type === 'hsla') {
	    colorStr += ',' + arrColor[3];
	  }
	
	  return type + '(' + colorStr + ')';
	}
	
	exports.parse = parse;
	exports.lift = lift;
	exports.toHex = toHex;
	exports.fastLerp = fastLerp;
	exports.fastMapToColor = fastMapToColor;
	exports.lerp = lerp;
	exports.mapToColor = mapToColor;
	exports.modifyHSL = modifyHSL;
	exports.modifyAlpha = modifyAlpha;
	exports.stringify = stringify;

/***/ },
/* 149 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = interopDefault;
	
	// https://github.com/moment/moment/issues/3650
	// since we are using ts 3.5.1, it should be safe to remove.
	function interopDefault(m) {
	  return m["default"] || m;
	}

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.querySealWorkflow = exports.queryCallbackSeal = exports.queryReturnSeal = exports.queryNextSealArchive = exports.queryNextSealScan = exports.queryNextSeal = exports.queryDeleteSeal = exports.querySaveSeal = exports.querySealInfo = exports.querySealOrgRecord = exports.querySealIncubatorStatic = exports.querySealOrgStatic = exports.queryMySealCheckList = exports.querySealMyList = exports.querySealList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 用章
	 */
	var querySealList = exports.querySealList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.administrative.GET_SEAL_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function querySealList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var querySealMyList = exports.querySealMyList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.administrative.GET_SEAL_MY, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function querySealMyList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryMySealCheckList = exports.queryMySealCheckList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.administrative.GET_SEAL_CHECK, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryMySealCheckList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var querySealOrgStatic = exports.querySealOrgStatic = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.administrative.GET_SEAL_STATIC_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function querySealOrgStatic(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var querySealIncubatorStatic = exports.querySealIncubatorStatic = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.administrative.GET_SEAL_STATIC_INCUBATOR, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function querySealIncubatorStatic(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var querySealOrgRecord = exports.querySealOrgRecord = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.administrative.GET_SEAL_RECORD_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function querySealOrgRecord(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var querySealInfo = exports.querySealInfo = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.administrative.GET_SEAL_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function querySealInfo(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var querySaveSeal = exports.querySaveSeal = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.post(_req.administrative.SEAL_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function querySaveSeal(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryDeleteSeal = exports.queryDeleteSeal = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.administrative.SEAL_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryDeleteSeal(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryNextSeal = exports.queryNextSeal = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.administrative.SEAL_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryNextSeal(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryNextSealScan = exports.queryNextSealScan = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.post(_req.administrative.SEAL_NEXT_SCAN, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryNextSealScan(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var queryNextSealArchive = exports.queryNextSealArchive = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.post(_req.administrative.SEAL_NEXT_ARCHIVE, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryNextSealArchive(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var queryReturnSeal = exports.queryReturnSeal = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.post(_req.administrative.SEAL_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryReturnSeal(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var queryCallbackSeal = exports.queryCallbackSeal = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.administrative.SEAL_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryCallbackSeal(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var querySealWorkflow = exports.querySealWorkflow = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt('return', _http2.default.get(_req.administrative.SEAL_WORKFLOW, params));
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function querySealWorkflow(_x15) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.querySaveWriteInvoice = exports.queryInvoiceWriteInfo = exports.queryInvoiceInvalid = exports.queryInvoiceWorkflow = exports.queryCallbackInvoice = exports.queryReturnInvoice = exports.queryNextInvoice = exports.queryDeleteInvoice = exports.querySaveInvoice = exports.queryInvoiceInfo = exports.queryInvoiceOrgRecord = exports.queryInvoiceIncubatorStatic = exports.queryInvoiceOrgStatic = exports.queryMyInvoiceCheckList = exports.queryInvoiceMyList = exports.queryInvoiceList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 开票
	 */
	var queryInvoiceList = exports.queryInvoiceList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.finance.GET_INVOICE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryInvoiceList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryInvoiceMyList = exports.queryInvoiceMyList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.finance.GET_INVOICE_MY, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryInvoiceMyList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryMyInvoiceCheckList = exports.queryMyInvoiceCheckList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.finance.GET_INVOICE_CHECK, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryMyInvoiceCheckList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryInvoiceOrgStatic = exports.queryInvoiceOrgStatic = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.finance.GET_INVOICE_STATIC_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryInvoiceOrgStatic(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryInvoiceIncubatorStatic = exports.queryInvoiceIncubatorStatic = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.finance.GET_INVOICE_STATIC_INCUBATOR, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryInvoiceIncubatorStatic(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryInvoiceOrgRecord = exports.queryInvoiceOrgRecord = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.finance.GET_INVOICE_RECORD_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryInvoiceOrgRecord(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryInvoiceInfo = exports.queryInvoiceInfo = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.finance.GET_INVOICE_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryInvoiceInfo(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var querySaveInvoice = exports.querySaveInvoice = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.post(_req.finance.FINANCE_INVOICE_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function querySaveInvoice(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryDeleteInvoice = exports.queryDeleteInvoice = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.finance.FINANCE_INVOICE_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryDeleteInvoice(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryNextInvoice = exports.queryNextInvoice = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', params.uuid ? _http2.default.post(_req.finance.FINANCE_INVOICE_NEXT, params) : _http2.default.get(_req.finance.FINANCE_INVOICE_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryNextInvoice(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryReturnInvoice = exports.queryReturnInvoice = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.post(_req.finance.FINANCE_INVOICE_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryReturnInvoice(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var queryCallbackInvoice = exports.queryCallbackInvoice = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.get(_req.finance.FINANCE_INVOICE_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryCallbackInvoice(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var queryInvoiceWorkflow = exports.queryInvoiceWorkflow = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.get(_req.finance.FINANCE_INVOICE_WORKFLOW, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryInvoiceWorkflow(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var queryInvoiceInvalid = exports.queryInvoiceInvalid = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.post(_req.finance.FINANCE_INVOICE_INVALID, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryInvoiceInvalid(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var queryInvoiceWriteInfo = exports.queryInvoiceWriteInfo = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt('return', _http2.default.get(_req.finance.GET_INVOICE_WRITE_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function queryInvoiceWriteInfo(_x15) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var querySaveWriteInvoice = exports.querySaveWriteInvoice = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(params) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            return _context16.abrupt('return', _http2.default.post(_req.finance.INVOICE_WRITE_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function querySaveWriteInvoice(_x16) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.querySaveWriteLoan = exports.queryLoanWriteInfo = exports.queryLoanWorkflow = exports.queryCallbackLoan = exports.queryReturnLoan = exports.queryNextLoan = exports.queryDeleteLoan = exports.querySaveLoan = exports.queryLoanInfo = exports.queryLoanOrgRecord = exports.queryLoanIncubatorStatic = exports.queryLoanOrgStatic = exports.queryMyLoanCheckList = exports.queryLoanMyList = exports.queryLoanList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 借款
	 */
	var queryLoanList = exports.queryLoanList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.finance.GET_LOAN_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryLoanList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryLoanMyList = exports.queryLoanMyList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.finance.GET_LOAN_MY, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryLoanMyList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryMyLoanCheckList = exports.queryMyLoanCheckList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.finance.GET_LOAN_CHECK, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryMyLoanCheckList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryLoanOrgStatic = exports.queryLoanOrgStatic = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.finance.GET_LOAN_STATIC_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryLoanOrgStatic(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryLoanIncubatorStatic = exports.queryLoanIncubatorStatic = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.finance.GET_LOAN_STATIC_INCUBATOR, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryLoanIncubatorStatic(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryLoanOrgRecord = exports.queryLoanOrgRecord = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.finance.GET_LOAN_RECORD_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryLoanOrgRecord(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryLoanInfo = exports.queryLoanInfo = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.finance.GET_LOAN_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryLoanInfo(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var querySaveLoan = exports.querySaveLoan = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.post(_req.finance.LOAN_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function querySaveLoan(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryDeleteLoan = exports.queryDeleteLoan = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.finance.LOAN_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryDeleteLoan(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryNextLoan = exports.queryNextLoan = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.finance.LOAN_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryNextLoan(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryReturnLoan = exports.queryReturnLoan = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.post(_req.finance.LOAN_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryReturnLoan(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var queryCallbackLoan = exports.queryCallbackLoan = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.get(_req.finance.LOAN_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryCallbackLoan(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var queryLoanWorkflow = exports.queryLoanWorkflow = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.get(_req.finance.LOAN_WORKFLOW, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryLoanWorkflow(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var queryLoanWriteInfo = exports.queryLoanWriteInfo = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.finance.GET_LOAN_WRITE_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryLoanWriteInfo(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var querySaveWriteLoan = exports.querySaveWriteLoan = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt('return', _http2.default.post(_req.finance.LOAN_WRITE_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function querySaveWriteLoan(_x15) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var dateFormat = 'YYYY-MM-DD';
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.onChange = function (e) {
	      _this.props.onChange(e.target.value);
	    };
	
	    _this.onSearch = function () {
	      var data = _this.props.form.getFieldsValue();
	      var params = {};
	      var date = data.date;
	
	      if (date) {
	        params = {
	          beginDate: (0, _moment2.default)(date[0]).format('YYYY-MM-DD'),
	          endDate: (0, _moment2.default)(date[1]).format('YYYY-MM-DD')
	        };
	      }
	      params = Object.assign({}, params, {
	        condition: data.condition || ''
	      });
	      _this.props.onSearch(params);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expense-search-form' },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: this.props.condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('date', {
	              initialValue: this.props.beginDate ? [(0, _moment2.default)(this.props.beginDate, dateFormat), (0, _moment2.default)(this.props.endDate, dateFormat)] : null
	            })(_react2.default.createElement(RangePicker, { format: dateFormat, allowClear: false }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: this.onSearch },
	              '\u641C\u7D22'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var YearPicker = function (_Component) {
	  _inherits(YearPicker, _Component);
	
	  function YearPicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, YearPicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = YearPicker.__proto__ || Object.getPrototypeOf(YearPicker)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (value) {
	      _this.props.onChange(value);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(YearPicker, [{
	    key: "render",
	    value: function render() {
	      var currentYear = _moment2.default.unix(new Date().getTime() / 1000).format("YYYY");
	      var years = [];
	      for (var i = -1; i < 4; i++) {
	        years.push(currentYear - i);
	      }
	      return _react2.default.createElement(
	        _antd.Select,
	        {
	          onChange: this.handleChange,
	          style: Object.assign({}, this.props.style),
	          defaultValue: this.props.value || this.props.defaultValue,
	          placeholder: "\u8BF7\u9009\u62E9\u5E74\u4EFD"
	        },
	        years.map(function (item) {
	          return _react2.default.createElement(
	            _antd.Select.Option,
	            { key: item },
	            item
	          );
	        })
	      );
	    }
	  }]);
	
	  return YearPicker;
	}(_react.Component);
	
	exports.default = YearPicker;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(170);
	var core = __webpack_require__(78);
	var ctx = __webpack_require__(446);
	var hide = __webpack_require__(237);
	var has = __webpack_require__(194);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	var Map = __webpack_require__(788);
	var $export = __webpack_require__(7);
	var shared = __webpack_require__(279)('metadata');
	var store = shared.store || (shared.store = new (__webpack_require__(792))());
	
	var getOrCreateMetadataMap = function (target, targetKey, create) {
	  var targetMetadata = store.get(target);
	  if (!targetMetadata) {
	    if (!create) return undefined;
	    store.set(target, targetMetadata = new Map());
	  }
	  var keyMetadata = targetMetadata.get(targetKey);
	  if (!keyMetadata) {
	    if (!create) return undefined;
	    targetMetadata.set(targetKey, keyMetadata = new Map());
	  } return keyMetadata;
	};
	var ordinaryHasOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	};
	var ordinaryGetOwnMetadata = function (MetadataKey, O, P) {
	  var metadataMap = getOrCreateMetadataMap(O, P, false);
	  return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	};
	var ordinaryDefineOwnMetadata = function (MetadataKey, MetadataValue, O, P) {
	  getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	};
	var ordinaryOwnMetadataKeys = function (target, targetKey) {
	  var metadataMap = getOrCreateMetadataMap(target, targetKey, false);
	  var keys = [];
	  if (metadataMap) metadataMap.forEach(function (_, key) { keys.push(key); });
	  return keys;
	};
	var toMetaKey = function (it) {
	  return it === undefined || typeof it == 'symbol' ? it : String(it);
	};
	var exp = function (O) {
	  $export($export.S, 'Reflect', O);
	};
	
	module.exports = {
	  store: store,
	  map: getOrCreateMetadataMap,
	  has: ordinaryHasOwnMetadata,
	  get: ordinaryGetOwnMetadata,
	  set: ordinaryDefineOwnMetadata,
	  keys: ordinaryOwnMetadataKeys,
	  key: toMetaKey,
	  exp: exp
	};


/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	if (__webpack_require__(65)) {
	  var LIBRARY = __webpack_require__(173);
	  var global = __webpack_require__(42);
	  var fails = __webpack_require__(43);
	  var $export = __webpack_require__(7);
	  var $typed = __webpack_require__(348);
	  var $buffer = __webpack_require__(483);
	  var ctx = __webpack_require__(118);
	  var anInstance = __webpack_require__(197);
	  var propertyDesc = __webpack_require__(202);
	  var hide = __webpack_require__(97);
	  var redefineAll = __webpack_require__(203);
	  var toInteger = __webpack_require__(120);
	  var toLength = __webpack_require__(63);
	  var toIndex = __webpack_require__(786);
	  var toAbsoluteIndex = __webpack_require__(205);
	  var toPrimitive = __webpack_require__(138);
	  var has = __webpack_require__(104);
	  var classof = __webpack_require__(240);
	  var isObject = __webpack_require__(45);
	  var toObject = __webpack_require__(75);
	  var isArrayIter = __webpack_require__(469);
	  var create = __webpack_require__(199);
	  var getPrototypeOf = __webpack_require__(106);
	  var gOPN = __webpack_require__(200).f;
	  var getIterFn = __webpack_require__(485);
	  var uid = __webpack_require__(206);
	  var wks = __webpack_require__(58);
	  var createArrayMethod = __webpack_require__(135);
	  var createArrayIncludes = __webpack_require__(336);
	  var speciesConstructor = __webpack_require__(280);
	  var ArrayIterators = __webpack_require__(486);
	  var Iterators = __webpack_require__(241);
	  var $iterDetect = __webpack_require__(341);
	  var setSpecies = __webpack_require__(204);
	  var arrayFill = __webpack_require__(461);
	  var arrayCopyWithin = __webpack_require__(758);
	  var $DP = __webpack_require__(69);
	  var $GOPD = __webpack_require__(105);
	  var dP = $DP.f;
	  var gOPD = $GOPD.f;
	  var RangeError = global.RangeError;
	  var TypeError = global.TypeError;
	  var Uint8Array = global.Uint8Array;
	  var ARRAY_BUFFER = 'ArrayBuffer';
	  var SHARED_BUFFER = 'Shared' + ARRAY_BUFFER;
	  var BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT';
	  var PROTOTYPE = 'prototype';
	  var ArrayProto = Array[PROTOTYPE];
	  var $ArrayBuffer = $buffer.ArrayBuffer;
	  var $DataView = $buffer.DataView;
	  var arrayForEach = createArrayMethod(0);
	  var arrayFilter = createArrayMethod(2);
	  var arraySome = createArrayMethod(3);
	  var arrayEvery = createArrayMethod(4);
	  var arrayFind = createArrayMethod(5);
	  var arrayFindIndex = createArrayMethod(6);
	  var arrayIncludes = createArrayIncludes(true);
	  var arrayIndexOf = createArrayIncludes(false);
	  var arrayValues = ArrayIterators.values;
	  var arrayKeys = ArrayIterators.keys;
	  var arrayEntries = ArrayIterators.entries;
	  var arrayLastIndexOf = ArrayProto.lastIndexOf;
	  var arrayReduce = ArrayProto.reduce;
	  var arrayReduceRight = ArrayProto.reduceRight;
	  var arrayJoin = ArrayProto.join;
	  var arraySort = ArrayProto.sort;
	  var arraySlice = ArrayProto.slice;
	  var arrayToString = ArrayProto.toString;
	  var arrayToLocaleString = ArrayProto.toLocaleString;
	  var ITERATOR = wks('iterator');
	  var TAG = wks('toStringTag');
	  var TYPED_CONSTRUCTOR = uid('typed_constructor');
	  var DEF_CONSTRUCTOR = uid('def_constructor');
	  var ALL_CONSTRUCTORS = $typed.CONSTR;
	  var TYPED_ARRAY = $typed.TYPED;
	  var VIEW = $typed.VIEW;
	  var WRONG_LENGTH = 'Wrong length!';
	
	  var $map = createArrayMethod(1, function (O, length) {
	    return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	  });
	
	  var LITTLE_ENDIAN = fails(function () {
	    // eslint-disable-next-line no-undef
	    return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	  });
	
	  var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	    new Uint8Array(1).set({});
	  });
	
	  var toOffset = function (it, BYTES) {
	    var offset = toInteger(it);
	    if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	    return offset;
	  };
	
	  var validate = function (it) {
	    if (isObject(it) && TYPED_ARRAY in it) return it;
	    throw TypeError(it + ' is not a typed array!');
	  };
	
	  var allocate = function (C, length) {
	    if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	      throw TypeError('It is not a typed array constructor!');
	    } return new C(length);
	  };
	
	  var speciesFromList = function (O, list) {
	    return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	  };
	
	  var fromList = function (C, list) {
	    var index = 0;
	    var length = list.length;
	    var result = allocate(C, length);
	    while (length > index) result[index] = list[index++];
	    return result;
	  };
	
	  var addGetter = function (it, key, internal) {
	    dP(it, key, { get: function () { return this._d[internal]; } });
	  };
	
	  var $from = function from(source /* , mapfn, thisArg */) {
	    var O = toObject(source);
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var iterFn = getIterFn(O);
	    var i, length, values, result, step, iterator;
	    if (iterFn != undefined && !isArrayIter(iterFn)) {
	      for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	        values.push(step.value);
	      } O = values;
	    }
	    if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	    for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	      result[i] = mapping ? mapfn(O[i], i) : O[i];
	    }
	    return result;
	  };
	
	  var $of = function of(/* ...items */) {
	    var index = 0;
	    var length = arguments.length;
	    var result = allocate(this, length);
	    while (length > index) result[index] = arguments[index++];
	    return result;
	  };
	
	  // iOS Safari 6.x fails here
	  var TO_LOCALE_BUG = !!Uint8Array && fails(function () { arrayToLocaleString.call(new Uint8Array(1)); });
	
	  var $toLocaleString = function toLocaleString() {
	    return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	  };
	
	  var proto = {
	    copyWithin: function copyWithin(target, start /* , end */) {
	      return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	    },
	    every: function every(callbackfn /* , thisArg */) {
	      return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    fill: function fill(value /* , start, end */) { // eslint-disable-line no-unused-vars
	      return arrayFill.apply(validate(this), arguments);
	    },
	    filter: function filter(callbackfn /* , thisArg */) {
	      return speciesFromList(this, arrayFilter(validate(this), callbackfn,
	        arguments.length > 1 ? arguments[1] : undefined));
	    },
	    find: function find(predicate /* , thisArg */) {
	      return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    findIndex: function findIndex(predicate /* , thisArg */) {
	      return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    forEach: function forEach(callbackfn /* , thisArg */) {
	      arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    indexOf: function indexOf(searchElement /* , fromIndex */) {
	      return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    includes: function includes(searchElement /* , fromIndex */) {
	      return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    join: function join(separator) { // eslint-disable-line no-unused-vars
	      return arrayJoin.apply(validate(this), arguments);
	    },
	    lastIndexOf: function lastIndexOf(searchElement /* , fromIndex */) { // eslint-disable-line no-unused-vars
	      return arrayLastIndexOf.apply(validate(this), arguments);
	    },
	    map: function map(mapfn /* , thisArg */) {
	      return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    reduce: function reduce(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduce.apply(validate(this), arguments);
	    },
	    reduceRight: function reduceRight(callbackfn /* , initialValue */) { // eslint-disable-line no-unused-vars
	      return arrayReduceRight.apply(validate(this), arguments);
	    },
	    reverse: function reverse() {
	      var that = this;
	      var length = validate(that).length;
	      var middle = Math.floor(length / 2);
	      var index = 0;
	      var value;
	      while (index < middle) {
	        value = that[index];
	        that[index++] = that[--length];
	        that[length] = value;
	      } return that;
	    },
	    some: function some(callbackfn /* , thisArg */) {
	      return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	    },
	    sort: function sort(comparefn) {
	      return arraySort.call(validate(this), comparefn);
	    },
	    subarray: function subarray(begin, end) {
	      var O = validate(this);
	      var length = O.length;
	      var $begin = toAbsoluteIndex(begin, length);
	      return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(
	        O.buffer,
	        O.byteOffset + $begin * O.BYTES_PER_ELEMENT,
	        toLength((end === undefined ? length : toAbsoluteIndex(end, length)) - $begin)
	      );
	    }
	  };
	
	  var $slice = function slice(start, end) {
	    return speciesFromList(this, arraySlice.call(validate(this), start, end));
	  };
	
	  var $set = function set(arrayLike /* , offset */) {
	    validate(this);
	    var offset = toOffset(arguments[1], 1);
	    var length = this.length;
	    var src = toObject(arrayLike);
	    var len = toLength(src.length);
	    var index = 0;
	    if (len + offset > length) throw RangeError(WRONG_LENGTH);
	    while (index < len) this[offset + index] = src[index++];
	  };
	
	  var $iterators = {
	    entries: function entries() {
	      return arrayEntries.call(validate(this));
	    },
	    keys: function keys() {
	      return arrayKeys.call(validate(this));
	    },
	    values: function values() {
	      return arrayValues.call(validate(this));
	    }
	  };
	
	  var isTAIndex = function (target, key) {
	    return isObject(target)
	      && target[TYPED_ARRAY]
	      && typeof key != 'symbol'
	      && key in target
	      && String(+key) == String(key);
	  };
	  var $getDesc = function getOwnPropertyDescriptor(target, key) {
	    return isTAIndex(target, key = toPrimitive(key, true))
	      ? propertyDesc(2, target[key])
	      : gOPD(target, key);
	  };
	  var $setDesc = function defineProperty(target, key, desc) {
	    if (isTAIndex(target, key = toPrimitive(key, true))
	      && isObject(desc)
	      && has(desc, 'value')
	      && !has(desc, 'get')
	      && !has(desc, 'set')
	      // TODO: add validation descriptor w/o calling accessors
	      && !desc.configurable
	      && (!has(desc, 'writable') || desc.writable)
	      && (!has(desc, 'enumerable') || desc.enumerable)
	    ) {
	      target[key] = desc.value;
	      return target;
	    } return dP(target, key, desc);
	  };
	
	  if (!ALL_CONSTRUCTORS) {
	    $GOPD.f = $getDesc;
	    $DP.f = $setDesc;
	  }
	
	  $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	    getOwnPropertyDescriptor: $getDesc,
	    defineProperty: $setDesc
	  });
	
	  if (fails(function () { arrayToString.call({}); })) {
	    arrayToString = arrayToLocaleString = function toString() {
	      return arrayJoin.call(this);
	    };
	  }
	
	  var $TypedArrayPrototype$ = redefineAll({}, proto);
	  redefineAll($TypedArrayPrototype$, $iterators);
	  hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	  redefineAll($TypedArrayPrototype$, {
	    slice: $slice,
	    set: $set,
	    constructor: function () { /* noop */ },
	    toString: arrayToString,
	    toLocaleString: $toLocaleString
	  });
	  addGetter($TypedArrayPrototype$, 'buffer', 'b');
	  addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	  addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	  addGetter($TypedArrayPrototype$, 'length', 'e');
	  dP($TypedArrayPrototype$, TAG, {
	    get: function () { return this[TYPED_ARRAY]; }
	  });
	
	  // eslint-disable-next-line max-statements
	  module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	    CLAMPED = !!CLAMPED;
	    var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array';
	    var GETTER = 'get' + KEY;
	    var SETTER = 'set' + KEY;
	    var TypedArray = global[NAME];
	    var Base = TypedArray || {};
	    var TAC = TypedArray && getPrototypeOf(TypedArray);
	    var FORCED = !TypedArray || !$typed.ABV;
	    var O = {};
	    var TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	    var getter = function (that, index) {
	      var data = that._d;
	      return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	    };
	    var setter = function (that, index, value) {
	      var data = that._d;
	      if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	      data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	    };
	    var addElement = function (that, index) {
	      dP(that, index, {
	        get: function () {
	          return getter(this, index);
	        },
	        set: function (value) {
	          return setter(this, index, value);
	        },
	        enumerable: true
	      });
	    };
	    if (FORCED) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME, '_d');
	        var index = 0;
	        var offset = 0;
	        var buffer, byteLength, length, klass;
	        if (!isObject(data)) {
	          length = toIndex(data);
	          byteLength = length * BYTES;
	          buffer = new $ArrayBuffer(byteLength);
	        } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          buffer = data;
	          offset = toOffset($offset, BYTES);
	          var $len = data.byteLength;
	          if ($length === undefined) {
	            if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	            byteLength = $len - offset;
	            if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	          } else {
	            byteLength = toLength($length) * BYTES;
	            if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	          }
	          length = byteLength / BYTES;
	        } else if (TYPED_ARRAY in data) {
	          return fromList(TypedArray, data);
	        } else {
	          return $from.call(TypedArray, data);
	        }
	        hide(that, '_d', {
	          b: buffer,
	          o: offset,
	          l: byteLength,
	          e: length,
	          v: new $DataView(buffer)
	        });
	        while (index < length) addElement(that, index++);
	      });
	      TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	      hide(TypedArrayPrototype, 'constructor', TypedArray);
	    } else if (!fails(function () {
	      TypedArray(1);
	    }) || !fails(function () {
	      new TypedArray(-1); // eslint-disable-line no-new
	    }) || !$iterDetect(function (iter) {
	      new TypedArray(); // eslint-disable-line no-new
	      new TypedArray(null); // eslint-disable-line no-new
	      new TypedArray(1.5); // eslint-disable-line no-new
	      new TypedArray(iter); // eslint-disable-line no-new
	    }, true)) {
	      TypedArray = wrapper(function (that, data, $offset, $length) {
	        anInstance(that, TypedArray, NAME);
	        var klass;
	        // `ws` module bug, temporarily remove validation length for Uint8Array
	        // https://github.com/websockets/ws/pull/645
	        if (!isObject(data)) return new Base(toIndex(data));
	        if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	          return $length !== undefined
	            ? new Base(data, toOffset($offset, BYTES), $length)
	            : $offset !== undefined
	              ? new Base(data, toOffset($offset, BYTES))
	              : new Base(data);
	        }
	        if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	        return $from.call(TypedArray, data);
	      });
	      arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	        if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	      });
	      TypedArray[PROTOTYPE] = TypedArrayPrototype;
	      if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	    }
	    var $nativeIterator = TypedArrayPrototype[ITERATOR];
	    var CORRECT_ITER_NAME = !!$nativeIterator
	      && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined);
	    var $iterator = $iterators.values;
	    hide(TypedArray, TYPED_CONSTRUCTOR, true);
	    hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	    hide(TypedArrayPrototype, VIEW, true);
	    hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	    if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	      dP(TypedArrayPrototype, TAG, {
	        get: function () { return NAME; }
	      });
	    }
	
	    O[NAME] = TypedArray;
	
	    $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	    $export($export.S, NAME, {
	      BYTES_PER_ELEMENT: BYTES
	    });
	
	    $export($export.S + $export.F * fails(function () { Base.of.call(TypedArray, 1); }), NAME, {
	      from: $from,
	      of: $of
	    });
	
	    if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	    $export($export.P, NAME, proto);
	
	    setSpecies(NAME);
	
	    $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	    $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	    if (!LIBRARY && TypedArrayPrototype.toString != arrayToString) TypedArrayPrototype.toString = arrayToString;
	
	    $export($export.P + $export.F * fails(function () {
	      new TypedArray(1).slice();
	    }), NAME, { slice: $slice });
	
	    $export($export.P + $export.F * (fails(function () {
	      return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	    }) || !fails(function () {
	      TypedArrayPrototype.toLocaleString.call([1, 2]);
	    })), NAME, { toLocaleString: $toLocaleString });
	
	    Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	    if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	  };
	} else module.exports = function () { /* empty */ };


/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule generateRandomKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var seenKeys = {};
	var MULTIPLIER = Math.pow(2, 24);
	
	function generateRandomKey() {
	  var key = void 0;
	  while (key === undefined || seenKeys.hasOwnProperty(key) || !isNaN(+key)) {
	    key = Math.floor(Math.random() * MULTIPLIER).toString(32);
	  }
	  seenKeys[key] = true;
	  return key;
	}
	
	module.exports = generateRandomKey;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var List = __webpack_require__(109);
	
	var createDimensions = __webpack_require__(251);
	
	var _sourceType = __webpack_require__(294);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	
	var _dimensionHelper = __webpack_require__(293);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var _model = __webpack_require__(29);
	
	var getDataItemValue = _model.getDataItemValue;
	
	var CoordinateSystem = __webpack_require__(121);
	
	var _referHelper = __webpack_require__(2444);
	
	var getCoordSysInfoBySeries = _referHelper.getCoordSysInfoBySeries;
	
	var Source = __webpack_require__(292);
	
	var _dataStackHelper = __webpack_require__(140);
	
	var enableDataStack = _dataStackHelper.enableDataStack;
	
	var _sourceHelper = __webpack_require__(160);
	
	var makeSeriesEncodeForAxisCoordSys = _sourceHelper.makeSeriesEncodeForAxisCoordSys;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/data/Source|Array} source Or raw data.
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Object} [opt]
	 * @param {string} [opt.generateCoord]
	 * @param {boolean} [opt.useEncodeDefaulter]
	 */
	function createListFromArray(source, seriesModel, opt) {
	  opt = opt || {};
	
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  var coordSysName = seriesModel.get('coordinateSystem');
	  var registeredCoordSys = CoordinateSystem.get(coordSysName);
	  var coordSysInfo = getCoordSysInfoBySeries(seriesModel);
	  var coordSysDimDefs;
	
	  if (coordSysInfo) {
	    coordSysDimDefs = zrUtil.map(coordSysInfo.coordSysDims, function (dim) {
	      var dimInfo = {
	        name: dim
	      };
	      var axisModel = coordSysInfo.axisMap.get(dim);
	
	      if (axisModel) {
	        var axisType = axisModel.get('type');
	        dimInfo.type = getDimensionTypeByAxis(axisType); // dimInfo.stackable = isStackable(axisType);
	      }
	
	      return dimInfo;
	    });
	  }
	
	  if (!coordSysDimDefs) {
	    // Get dimensions from registered coordinate system
	    coordSysDimDefs = registeredCoordSys && (registeredCoordSys.getDimensionsInfo ? registeredCoordSys.getDimensionsInfo() : registeredCoordSys.dimensions.slice()) || ['x', 'y'];
	  }
	
	  var dimInfoList = createDimensions(source, {
	    coordDimensions: coordSysDimDefs,
	    generateCoord: opt.generateCoord,
	    encodeDefaulter: opt.useEncodeDefaulter ? zrUtil.curry(makeSeriesEncodeForAxisCoordSys, coordSysDimDefs, seriesModel) : null
	  });
	  var firstCategoryDimIndex;
	  var hasNameEncode;
	  coordSysInfo && zrUtil.each(dimInfoList, function (dimInfo, dimIndex) {
	    var coordDim = dimInfo.coordDim;
	    var categoryAxisModel = coordSysInfo.categoryAxisMap.get(coordDim);
	
	    if (categoryAxisModel) {
	      if (firstCategoryDimIndex == null) {
	        firstCategoryDimIndex = dimIndex;
	      }
	
	      dimInfo.ordinalMeta = categoryAxisModel.getOrdinalMeta();
	    }
	
	    if (dimInfo.otherDims.itemName != null) {
	      hasNameEncode = true;
	    }
	  });
	
	  if (!hasNameEncode && firstCategoryDimIndex != null) {
	    dimInfoList[firstCategoryDimIndex].otherDims.itemName = 0;
	  }
	
	  var stackCalculationInfo = enableDataStack(seriesModel, dimInfoList);
	  var list = new List(dimInfoList, seriesModel);
	  list.setCalculationInfo(stackCalculationInfo);
	  var dimValueGetter = firstCategoryDimIndex != null && isNeedCompleteOrdinalData(source) ? function (itemOpt, dimName, dataIndex, dimIndex) {
	    // Use dataIndex as ordinal value in categoryAxis
	    return dimIndex === firstCategoryDimIndex ? dataIndex : this.defaultDimValueGetter(itemOpt, dimName, dataIndex, dimIndex);
	  } : null;
	  list.hasItemOption = false;
	  list.initData(source, null, dimValueGetter);
	  return list;
	}
	
	function isNeedCompleteOrdinalData(source) {
	  if (source.sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    var sampleItem = firstDataNotNull(source.data || []);
	    return sampleItem != null && !zrUtil.isArray(getDataItemValue(sampleItem));
	  }
	}
	
	function firstDataNotNull(data) {
	  var i = 0;
	
	  while (i < data.length && data[i] == null) {
	    i++;
	  }
	
	  return data[i];
	}
	
	var _default = createListFromArray;
	module.exports = _default;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	var getDataItemValue = _model.getDataItemValue;
	
	var _util = __webpack_require__(4);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	var map = _util.map;
	var isArray = _util.isArray;
	var isString = _util.isString;
	var isObject = _util.isObject;
	var isTypedArray = _util.isTypedArray;
	var isArrayLike = _util.isArrayLike;
	var extend = _util.extend;
	var assert = _util.assert;
	
	var Source = __webpack_require__(292);
	
	var _sourceType = __webpack_require__(294);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
	var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
	var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
	var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SERIES_LAYOUT_BY_ROW = _sourceType.SERIES_LAYOUT_BY_ROW;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// The result of `guessOrdinal`.
	var BE_ORDINAL = {
	  Must: 1,
	  // Encounter string but not '-' and not number-like.
	  Might: 2,
	  // Encounter string but number-like.
	  Not: 3 // Other cases
	
	};
	var inner = makeInner();
	/**
	 * @see {module:echarts/data/Source}
	 * @param {module:echarts/component/dataset/DatasetModel} datasetModel
	 * @return {string} sourceFormat
	 */
	
	function detectSourceFormat(datasetModel) {
	  var data = datasetModel.option.source;
	  var sourceFormat = SOURCE_FORMAT_UNKNOWN;
	
	  if (isTypedArray(data)) {
	    sourceFormat = SOURCE_FORMAT_TYPED_ARRAY;
	  } else if (isArray(data)) {
	    // FIXME Whether tolerate null in top level array?
	    if (data.length === 0) {
	      sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	    }
	
	    for (var i = 0, len = data.length; i < len; i++) {
	      var item = data[i];
	
	      if (item == null) {
	        continue;
	      } else if (isArray(item)) {
	        sourceFormat = SOURCE_FORMAT_ARRAY_ROWS;
	        break;
	      } else if (isObject(item)) {
	        sourceFormat = SOURCE_FORMAT_OBJECT_ROWS;
	        break;
	      }
	    }
	  } else if (isObject(data)) {
	    for (var key in data) {
	      if (data.hasOwnProperty(key) && isArrayLike(data[key])) {
	        sourceFormat = SOURCE_FORMAT_KEYED_COLUMNS;
	        break;
	      }
	    }
	  } else if (data != null) {
	    throw new Error('Invalid data');
	  }
	
	  inner(datasetModel).sourceFormat = sourceFormat;
	}
	/**
	 * [Scenarios]:
	 * (1) Provide source data directly:
	 *     series: {
	 *         encode: {...},
	 *         dimensions: [...]
	 *         seriesLayoutBy: 'row',
	 *         data: [[...]]
	 *     }
	 * (2) Refer to datasetModel.
	 *     series: [{
	 *         encode: {...}
	 *         // Ignore datasetIndex means `datasetIndex: 0`
	 *         // and the dimensions defination in dataset is used
	 *     }, {
	 *         encode: {...},
	 *         seriesLayoutBy: 'column',
	 *         datasetIndex: 1
	 *     }]
	 *
	 * Get data from series itself or datset.
	 * @return {module:echarts/data/Source} source
	 */
	
	
	function getSource(seriesModel) {
	  return inner(seriesModel).source;
	}
	/**
	 * MUST be called before mergeOption of all series.
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function resetSourceDefaulter(ecModel) {
	  // `datasetMap` is used to make default encode.
	  inner(ecModel).datasetMap = createHashMap();
	}
	/**
	 * [Caution]:
	 * MUST be called after series option merged and
	 * before "series.getInitailData()" called.
	 *
	 * [The rule of making default encode]:
	 * Category axis (if exists) alway map to the first dimension.
	 * Each other axis occupies a subsequent dimension.
	 *
	 * [Why make default encode]:
	 * Simplify the typing of encode in option, avoiding the case like that:
	 * series: [{encode: {x: 0, y: 1}}, {encode: {x: 0, y: 2}}, {encode: {x: 0, y: 3}}],
	 * where the "y" have to be manually typed as "1, 2, 3, ...".
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 */
	
	
	function prepareSource(seriesModel) {
	  var seriesOption = seriesModel.option;
	  var data = seriesOption.data;
	  var sourceFormat = isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL;
	  var fromDataset = false;
	  var seriesLayoutBy = seriesOption.seriesLayoutBy;
	  var sourceHeader = seriesOption.sourceHeader;
	  var dimensionsDefine = seriesOption.dimensions;
	  var datasetModel = getDatasetModel(seriesModel);
	
	  if (datasetModel) {
	    var datasetOption = datasetModel.option;
	    data = datasetOption.source;
	    sourceFormat = inner(datasetModel).sourceFormat;
	    fromDataset = true; // These settings from series has higher priority.
	
	    seriesLayoutBy = seriesLayoutBy || datasetOption.seriesLayoutBy;
	    sourceHeader == null && (sourceHeader = datasetOption.sourceHeader);
	    dimensionsDefine = dimensionsDefine || datasetOption.dimensions;
	  }
	
	  var completeResult = completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine);
	  inner(seriesModel).source = new Source({
	    data: data,
	    fromDataset: fromDataset,
	    seriesLayoutBy: seriesLayoutBy,
	    sourceFormat: sourceFormat,
	    dimensionsDefine: completeResult.dimensionsDefine,
	    startIndex: completeResult.startIndex,
	    dimensionsDetectCount: completeResult.dimensionsDetectCount,
	    // Note: dataset option does not have `encode`.
	    encodeDefine: seriesOption.encode
	  });
	} // return {startIndex, dimensionsDefine, dimensionsCount}
	
	
	function completeBySourceData(data, sourceFormat, seriesLayoutBy, sourceHeader, dimensionsDefine) {
	  if (!data) {
	    return {
	      dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine)
	    };
	  }
	
	  var dimensionsDetectCount;
	  var startIndex;
	
	  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	    // Rule: Most of the first line are string: it is header.
	    // Caution: consider a line with 5 string and 1 number,
	    // it still can not be sure it is a head, because the
	    // 5 string may be 5 values of category columns.
	    if (sourceHeader === 'auto' || sourceHeader == null) {
	      arrayRowsTravelFirst(function (val) {
	        // '-' is regarded as null/undefined.
	        if (val != null && val !== '-') {
	          if (isString(val)) {
	            startIndex == null && (startIndex = 1);
	          } else {
	            startIndex = 0;
	          }
	        } // 10 is an experience number, avoid long loop.
	
	      }, seriesLayoutBy, data, 10);
	    } else {
	      startIndex = sourceHeader ? 1 : 0;
	    }
	
	    if (!dimensionsDefine && startIndex === 1) {
	      dimensionsDefine = [];
	      arrayRowsTravelFirst(function (val, index) {
	        dimensionsDefine[index] = val != null ? val : '';
	      }, seriesLayoutBy, data);
	    }
	
	    dimensionsDetectCount = dimensionsDefine ? dimensionsDefine.length : seriesLayoutBy === SERIES_LAYOUT_BY_ROW ? data.length : data[0] ? data[0].length : null;
	  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	    if (!dimensionsDefine) {
	      dimensionsDefine = objectRowsCollectDimensions(data);
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    if (!dimensionsDefine) {
	      dimensionsDefine = [];
	      each(data, function (colArr, key) {
	        dimensionsDefine.push(key);
	      });
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    var value0 = getDataItemValue(data[0]);
	    dimensionsDetectCount = isArray(value0) && value0.length || 1;
	  } else if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {}
	
	  return {
	    startIndex: startIndex,
	    dimensionsDefine: normalizeDimensionsDefine(dimensionsDefine),
	    dimensionsDetectCount: dimensionsDetectCount
	  };
	} // Consider dimensions defined like ['A', 'price', 'B', 'price', 'C', 'price'],
	// which is reasonable. But dimension name is duplicated.
	// Returns undefined or an array contains only object without null/undefiend or string.
	
	
	function normalizeDimensionsDefine(dimensionsDefine) {
	  if (!dimensionsDefine) {
	    // The meaning of null/undefined is different from empty array.
	    return;
	  }
	
	  var nameMap = createHashMap();
	  return map(dimensionsDefine, function (item, index) {
	    item = extend({}, isObject(item) ? item : {
	      name: item
	    }); // User can set null in dimensions.
	    // We dont auto specify name, othewise a given name may
	    // cause it be refered unexpectedly.
	
	    if (item.name == null) {
	      return item;
	    } // Also consider number form like 2012.
	
	
	    item.name += ''; // User may also specify displayName.
	    // displayName will always exists except user not
	    // specified or dim name is not specified or detected.
	    // (A auto generated dim name will not be used as
	    // displayName).
	
	    if (item.displayName == null) {
	      item.displayName = item.name;
	    }
	
	    var exist = nameMap.get(item.name);
	
	    if (!exist) {
	      nameMap.set(item.name, {
	        count: 1
	      });
	    } else {
	      item.name += '-' + exist.count++;
	    }
	
	    return item;
	  });
	}
	
	function arrayRowsTravelFirst(cb, seriesLayoutBy, data, maxLoop) {
	  maxLoop == null && (maxLoop = Infinity);
	
	  if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      cb(data[i] ? data[i][0] : null, i);
	    }
	  } else {
	    var value0 = data[0] || [];
	
	    for (var i = 0; i < value0.length && i < maxLoop; i++) {
	      cb(value0[i], i);
	    }
	  }
	}
	
	function objectRowsCollectDimensions(data) {
	  var firstIndex = 0;
	  var obj;
	
	  while (firstIndex < data.length && !(obj = data[firstIndex++])) {} // jshint ignore: line
	
	
	  if (obj) {
	    var dimensions = [];
	    each(obj, function (value, key) {
	      dimensions.push(key);
	    });
	    return dimensions;
	  }
	}
	/**
	 * [The strategy of the arrengment of data dimensions for dataset]:
	 * "value way": all axes are non-category axes. So series one by one take
	 *     several (the number is coordSysDims.length) dimensions from dataset.
	 *     The result of data arrengment of data dimensions like:
	 *     | ser0_x | ser0_y | ser1_x | ser1_y | ser2_x | ser2_y |
	 * "category way": at least one axis is category axis. So the the first data
	 *     dimension is always mapped to the first category axis and shared by
	 *     all of the series. The other data dimensions are taken by series like
	 *     "value way" does.
	 *     The result of data arrengment of data dimensions like:
	 *     | ser_shared_x | ser0_y | ser1_y | ser2_y |
	 *
	 * @param {Array.<Object|string>} coordDimensions [{name: <string>, type: <string>, dimsDef: <Array>}, ...]
	 * @param {module:model/Series} seriesModel
	 * @param {module:data/Source} source
	 * @return {Object} encode Never be `null/undefined`.
	 */
	
	
	function makeSeriesEncodeForAxisCoordSys(coordDimensions, seriesModel, source) {
	  var encode = {};
	  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
	
	  if (!datasetModel || !coordDimensions) {
	    return encode;
	  }
	
	  var encodeItemName = [];
	  var encodeSeriesName = [];
	  var ecModel = seriesModel.ecModel;
	  var datasetMap = inner(ecModel).datasetMap;
	  var key = datasetModel.uid + '_' + source.seriesLayoutBy;
	  var baseCategoryDimIndex;
	  var categoryWayValueDimStart;
	  coordDimensions = coordDimensions.slice();
	  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
	    !isObject(coordDimInfo) && (coordDimensions[coordDimIdx] = {
	      name: coordDimInfo
	    });
	
	    if (coordDimInfo.type === 'ordinal' && baseCategoryDimIndex == null) {
	      baseCategoryDimIndex = coordDimIdx;
	      categoryWayValueDimStart = getDataDimCountOnCoordDim(coordDimensions[coordDimIdx]);
	    }
	
	    encode[coordDimInfo.name] = [];
	  });
	  var datasetRecord = datasetMap.get(key) || datasetMap.set(key, {
	    categoryWayDim: categoryWayValueDimStart,
	    valueWayDim: 0
	  }); // TODO
	  // Auto detect first time axis and do arrangement.
	
	  each(coordDimensions, function (coordDimInfo, coordDimIdx) {
	    var coordDimName = coordDimInfo.name;
	    var count = getDataDimCountOnCoordDim(coordDimInfo); // In value way.
	
	    if (baseCategoryDimIndex == null) {
	      var start = datasetRecord.valueWayDim;
	      pushDim(encode[coordDimName], start, count);
	      pushDim(encodeSeriesName, start, count);
	      datasetRecord.valueWayDim += count; // ??? TODO give a better default series name rule?
	      // especially when encode x y specified.
	      // consider: when mutiple series share one dimension
	      // category axis, series name should better use
	      // the other dimsion name. On the other hand, use
	      // both dimensions name.
	    } // In category way, the first category axis.
	    else if (baseCategoryDimIndex === coordDimIdx) {
	        pushDim(encode[coordDimName], 0, count);
	        pushDim(encodeItemName, 0, count);
	      } // In category way, the other axis.
	      else {
	          var start = datasetRecord.categoryWayDim;
	          pushDim(encode[coordDimName], start, count);
	          pushDim(encodeSeriesName, start, count);
	          datasetRecord.categoryWayDim += count;
	        }
	  });
	
	  function pushDim(dimIdxArr, idxFrom, idxCount) {
	    for (var i = 0; i < idxCount; i++) {
	      dimIdxArr.push(idxFrom + i);
	    }
	  }
	
	  function getDataDimCountOnCoordDim(coordDimInfo) {
	    var dimsDef = coordDimInfo.dimsDef;
	    return dimsDef ? dimsDef.length : 1;
	  }
	
	  encodeItemName.length && (encode.itemName = encodeItemName);
	  encodeSeriesName.length && (encode.seriesName = encodeSeriesName);
	  return encode;
	}
	/**
	 * Work for data like [{name: ..., value: ...}, ...].
	 *
	 * @param {module:model/Series} seriesModel
	 * @param {module:data/Source} source
	 * @return {Object} encode Never be `null/undefined`.
	 */
	
	
	function makeSeriesEncodeForNameBased(seriesModel, source, dimCount) {
	  var encode = {};
	  var datasetModel = getDatasetModel(seriesModel); // Currently only make default when using dataset, util more reqirements occur.
	
	  if (!datasetModel) {
	    return encode;
	  }
	
	  var sourceFormat = source.sourceFormat;
	  var dimensionsDefine = source.dimensionsDefine;
	  var potentialNameDimIndex;
	
	  if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS || sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    each(dimensionsDefine, function (dim, idx) {
	      if ((isObject(dim) ? dim.name : dim) === 'name') {
	        potentialNameDimIndex = idx;
	      }
	    });
	  } // idxResult: {v, n}.
	
	
	  var idxResult = function () {
	    var idxRes0 = {};
	    var idxRes1 = {};
	    var guessRecords = []; // 5 is an experience value.
	
	    for (var i = 0, len = Math.min(5, dimCount); i < len; i++) {
	      var guessResult = doGuessOrdinal(source.data, sourceFormat, source.seriesLayoutBy, dimensionsDefine, source.startIndex, i);
	      guessRecords.push(guessResult);
	      var isPureNumber = guessResult === BE_ORDINAL.Not; // [Strategy of idxRes0]: find the first BE_ORDINAL.Not as the value dim,
	      // and then find a name dim with the priority:
	      // "BE_ORDINAL.Might|BE_ORDINAL.Must" > "other dim" > "the value dim itself".
	
	      if (isPureNumber && idxRes0.v == null && i !== potentialNameDimIndex) {
	        idxRes0.v = i;
	      }
	
	      if (idxRes0.n == null || idxRes0.n === idxRes0.v || !isPureNumber && guessRecords[idxRes0.n] === BE_ORDINAL.Not) {
	        idxRes0.n = i;
	      }
	
	      if (fulfilled(idxRes0) && guessRecords[idxRes0.n] !== BE_ORDINAL.Not) {
	        return idxRes0;
	      } // [Strategy of idxRes1]: if idxRes0 not satisfied (that is, no BE_ORDINAL.Not),
	      // find the first BE_ORDINAL.Might as the value dim,
	      // and then find a name dim with the priority:
	      // "other dim" > "the value dim itself".
	      // That is for backward compat: number-like (e.g., `'3'`, `'55'`) can be
	      // treated as number.
	
	
	      if (!isPureNumber) {
	        if (guessResult === BE_ORDINAL.Might && idxRes1.v == null && i !== potentialNameDimIndex) {
	          idxRes1.v = i;
	        }
	
	        if (idxRes1.n == null || idxRes1.n === idxRes1.v) {
	          idxRes1.n = i;
	        }
	      }
	    }
	
	    function fulfilled(idxResult) {
	      return idxResult.v != null && idxResult.n != null;
	    }
	
	    return fulfilled(idxRes0) ? idxRes0 : fulfilled(idxRes1) ? idxRes1 : null;
	  }();
	
	  if (idxResult) {
	    encode.value = idxResult.v; // `potentialNameDimIndex` has highest priority.
	
	    var nameDimIndex = potentialNameDimIndex != null ? potentialNameDimIndex : idxResult.n; // By default, label use itemName in charts.
	    // So we dont set encodeLabel here.
	
	    encode.itemName = [nameDimIndex];
	    encode.seriesName = [nameDimIndex];
	  }
	
	  return encode;
	}
	/**
	 * If return null/undefined, indicate that should not use datasetModel.
	 */
	
	
	function getDatasetModel(seriesModel) {
	  var option = seriesModel.option; // Caution: consider the scenario:
	  // A dataset is declared and a series is not expected to use the dataset,
	  // and at the beginning `setOption({series: { noData })` (just prepare other
	  // option but no data), then `setOption({series: {data: [...]}); In this case,
	  // the user should set an empty array to avoid that dataset is used by default.
	
	  var thisData = option.data;
	
	  if (!thisData) {
	    return seriesModel.ecModel.getComponent('dataset', option.datasetIndex || 0);
	  }
	}
	/**
	 * The rule should not be complex, otherwise user might not
	 * be able to known where the data is wrong.
	 * The code is ugly, but how to make it neat?
	 *
	 * @param {module:echars/data/Source} source
	 * @param {number} dimIndex
	 * @return {BE_ORDINAL} guess result.
	 */
	
	
	function guessOrdinal(source, dimIndex) {
	  return doGuessOrdinal(source.data, source.sourceFormat, source.seriesLayoutBy, source.dimensionsDefine, source.startIndex, dimIndex);
	} // dimIndex may be overflow source data.
	// return {BE_ORDINAL}
	
	
	function doGuessOrdinal(data, sourceFormat, seriesLayoutBy, dimensionsDefine, startIndex, dimIndex) {
	  var result; // Experience value.
	
	  var maxLoop = 5;
	
	  if (isTypedArray(data)) {
	    return BE_ORDINAL.Not;
	  } // When sourceType is 'objectRows' or 'keyedColumns', dimensionsDefine
	  // always exists in source.
	
	
	  var dimName;
	  var dimType;
	
	  if (dimensionsDefine) {
	    var dimDefItem = dimensionsDefine[dimIndex];
	
	    if (isObject(dimDefItem)) {
	      dimName = dimDefItem.name;
	      dimType = dimDefItem.type;
	    } else if (isString(dimDefItem)) {
	      dimName = dimDefItem;
	    }
	  }
	
	  if (dimType != null) {
	    return dimType === 'ordinal' ? BE_ORDINAL.Must : BE_ORDINAL.Not;
	  }
	
	  if (sourceFormat === SOURCE_FORMAT_ARRAY_ROWS) {
	    if (seriesLayoutBy === SERIES_LAYOUT_BY_ROW) {
	      var sample = data[dimIndex];
	
	      for (var i = 0; i < (sample || []).length && i < maxLoop; i++) {
	        if ((result = detectValue(sample[startIndex + i])) != null) {
	          return result;
	        }
	      }
	    } else {
	      for (var i = 0; i < data.length && i < maxLoop; i++) {
	        var row = data[startIndex + i];
	
	        if (row && (result = detectValue(row[dimIndex])) != null) {
	          return result;
	        }
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_OBJECT_ROWS) {
	    if (!dimName) {
	      return BE_ORDINAL.Not;
	    }
	
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      var item = data[i];
	
	      if (item && (result = detectValue(item[dimName])) != null) {
	        return result;
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS) {
	    if (!dimName) {
	      return BE_ORDINAL.Not;
	    }
	
	    var sample = data[dimName];
	
	    if (!sample || isTypedArray(sample)) {
	      return BE_ORDINAL.Not;
	    }
	
	    for (var i = 0; i < sample.length && i < maxLoop; i++) {
	      if ((result = detectValue(sample[i])) != null) {
	        return result;
	      }
	    }
	  } else if (sourceFormat === SOURCE_FORMAT_ORIGINAL) {
	    for (var i = 0; i < data.length && i < maxLoop; i++) {
	      var item = data[i];
	      var val = getDataItemValue(item);
	
	      if (!isArray(val)) {
	        return BE_ORDINAL.Not;
	      }
	
	      if ((result = detectValue(val[dimIndex])) != null) {
	        return result;
	      }
	    }
	  }
	
	  function detectValue(val) {
	    var beStr = isString(val); // Consider usage convenience, '1', '2' will be treated as "number".
	    // `isFinit('')` get `true`.
	
	    if (val != null && isFinite(val) && val !== '') {
	      return beStr ? BE_ORDINAL.Might : BE_ORDINAL.Not;
	    } else if (beStr && val !== '-') {
	      return BE_ORDINAL.Must;
	    }
	  }
	
	  return BE_ORDINAL.Not;
	}
	
	exports.BE_ORDINAL = BE_ORDINAL;
	exports.detectSourceFormat = detectSourceFormat;
	exports.getSource = getSource;
	exports.resetSourceDefaulter = resetSourceDefaulter;
	exports.prepareSource = prepareSource;
	exports.makeSeriesEncodeForAxisCoordSys = makeSeriesEncodeForAxisCoordSys;
	exports.makeSeriesEncodeForNameBased = makeSeriesEncodeForNameBased;
	exports.guessOrdinal = guessOrdinal;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TYPE_DELIMITER = '.';
	var IS_CONTAINER = '___EC__COMPONENT__CONTAINER___';
	/**
	 * Notice, parseClassType('') should returns {main: '', sub: ''}
	 * @public
	 */
	
	function parseClassType(componentType) {
	  var ret = {
	    main: '',
	    sub: ''
	  };
	
	  if (componentType) {
	    componentType = componentType.split(TYPE_DELIMITER);
	    ret.main = componentType[0] || '';
	    ret.sub = componentType[1] || '';
	  }
	
	  return ret;
	}
	/**
	 * @public
	 */
	
	
	function checkClassType(componentType) {
	  zrUtil.assert(/^[a-zA-Z0-9_]+([.][a-zA-Z0-9_]+)?$/.test(componentType), 'componentType "' + componentType + '" illegal');
	}
	/**
	 * @public
	 */
	
	
	function enableClassExtend(RootClass, mandatoryMethods) {
	  RootClass.$constructor = RootClass;
	
	  RootClass.extend = function (proto) {
	    var superClass = this;
	
	    var ExtendedClass = function () {
	      if (!proto.$constructor) {
	        superClass.apply(this, arguments);
	      } else {
	        proto.$constructor.apply(this, arguments);
	      }
	    };
	
	    zrUtil.extend(ExtendedClass.prototype, proto);
	    ExtendedClass.extend = this.extend;
	    ExtendedClass.superCall = superCall;
	    ExtendedClass.superApply = superApply;
	    zrUtil.inherits(ExtendedClass, this);
	    ExtendedClass.superClass = superClass;
	    return ExtendedClass;
	  };
	}
	
	var classBase = 0;
	/**
	 * Can not use instanceof, consider different scope by
	 * cross domain or es module import in ec extensions.
	 * Mount a method "isInstance()" to Clz.
	 */
	
	function enableClassCheck(Clz) {
	  var classAttr = ['__\0is_clz', classBase++, Math.random().toFixed(3)].join('_');
	  Clz.prototype[classAttr] = true;
	
	  Clz.isInstance = function (obj) {
	    return !!(obj && obj[classAttr]);
	  };
	} // superCall should have class info, which can not be fetch from 'this'.
	// Consider this case:
	// class A has method f,
	// class B inherits class A, overrides method f, f call superApply('f'),
	// class C inherits class B, do not overrides method f,
	// then when method of class C is called, dead loop occured.
	
	
	function superCall(context, methodName) {
	  var args = zrUtil.slice(arguments, 2);
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	
	function superApply(context, methodName, args) {
	  return this.superClass.prototype[methodName].apply(context, args);
	}
	/**
	 * @param {Object} entity
	 * @param {Object} options
	 * @param {boolean} [options.registerWhenExtend]
	 * @public
	 */
	
	
	function enableClassManagement(entity, options) {
	  options = options || {};
	  /**
	   * Component model classes
	   * key: componentType,
	   * value:
	   *     componentClass, when componentType is 'xxx'
	   *     or Object.<subKey, componentClass>, when componentType is 'xxx.yy'
	   * @type {Object}
	   */
	
	  var storage = {};
	
	  entity.registerClass = function (Clazz, componentType) {
	    if (componentType) {
	      checkClassType(componentType);
	      componentType = parseClassType(componentType);
	
	      if (!componentType.sub) {
	        storage[componentType.main] = Clazz;
	      } else if (componentType.sub !== IS_CONTAINER) {
	        var container = makeContainer(componentType);
	        container[componentType.sub] = Clazz;
	      }
	    }
	
	    return Clazz;
	  };
	
	  entity.getClass = function (componentMainType, subType, throwWhenNotFound) {
	    var Clazz = storage[componentMainType];
	
	    if (Clazz && Clazz[IS_CONTAINER]) {
	      Clazz = subType ? Clazz[subType] : null;
	    }
	
	    if (throwWhenNotFound && !Clazz) {
	      throw new Error(!subType ? componentMainType + '.' + 'type should be specified.' : 'Component ' + componentMainType + '.' + (subType || '') + ' not exists. Load it first.');
	    }
	
	    return Clazz;
	  };
	
	  entity.getClassesByMainType = function (componentType) {
	    componentType = parseClassType(componentType);
	    var result = [];
	    var obj = storage[componentType.main];
	
	    if (obj && obj[IS_CONTAINER]) {
	      zrUtil.each(obj, function (o, type) {
	        type !== IS_CONTAINER && result.push(o);
	      });
	    } else {
	      result.push(obj);
	    }
	
	    return result;
	  };
	
	  entity.hasClass = function (componentType) {
	    // Just consider componentType.main.
	    componentType = parseClassType(componentType);
	    return !!storage[componentType.main];
	  };
	  /**
	   * @return {Array.<string>} Like ['aa', 'bb'], but can not be ['aa.xx']
	   */
	
	
	  entity.getAllClassMainTypes = function () {
	    var types = [];
	    zrUtil.each(storage, function (obj, type) {
	      types.push(type);
	    });
	    return types;
	  };
	  /**
	   * If a main type is container and has sub types
	   * @param  {string}  mainType
	   * @return {boolean}
	   */
	
	
	  entity.hasSubTypes = function (componentType) {
	    componentType = parseClassType(componentType);
	    var obj = storage[componentType.main];
	    return obj && obj[IS_CONTAINER];
	  };
	
	  entity.parseClassType = parseClassType;
	
	  function makeContainer(componentType) {
	    var container = storage[componentType.main];
	
	    if (!container || !container[IS_CONTAINER]) {
	      container = storage[componentType.main] = {};
	      container[IS_CONTAINER] = true;
	    }
	
	    return container;
	  }
	
	  if (options.registerWhenExtend) {
	    var originalExtend = entity.extend;
	
	    if (originalExtend) {
	      entity.extend = function (proto) {
	        var ExtendedClass = originalExtend.call(this, proto);
	        return entity.registerClass(ExtendedClass, proto.type);
	      };
	    }
	  }
	
	  return entity;
	}
	/**
	 * @param {string|Array.<string>} properties
	 */
	
	
	function setReadOnly(obj, properties) {// FIXME It seems broken in IE8 simulation of IE11
	  // if (!zrUtil.isArray(properties)) {
	  //     properties = properties != null ? [properties] : [];
	  // }
	  // zrUtil.each(properties, function (prop) {
	  //     var value = obj[prop];
	  //     Object.defineProperty
	  //         && Object.defineProperty(obj, prop, {
	  //             value: value, writable: false
	  //         });
	  //     zrUtil.isArray(obj[prop])
	  //         && Object.freeze
	  //         && Object.freeze(obj[prop]);
	  // });
	}
	
	exports.parseClassType = parseClassType;
	exports.enableClassExtend = enableClassExtend;
	exports.enableClassCheck = enableClassCheck;
	exports.enableClassManagement = enableClassManagement;
	exports.setReadOnly = setReadOnly;

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getTodayTime = getTodayTime;
	exports.getTitleString = getTitleString;
	exports.getTodayTimeStr = getTodayTimeStr;
	exports.getMonthName = getMonthName;
	exports.syncTime = syncTime;
	exports.getTimeConfig = getTimeConfig;
	exports.isTimeValidByConfig = isTimeValidByConfig;
	exports.isTimeValid = isTimeValid;
	exports.isAllowedDate = isAllowedDate;
	exports.formatDate = formatDate;
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var defaultDisabledTime = {
	  disabledHours: function disabledHours() {
	    return [];
	  },
	  disabledMinutes: function disabledMinutes() {
	    return [];
	  },
	  disabledSeconds: function disabledSeconds() {
	    return [];
	  }
	};
	
	function getTodayTime(value) {
	  var today = (0, _moment2['default'])();
	  today.locale(value.locale()).utcOffset(value.utcOffset());
	  return today;
	}
	
	function getTitleString(value) {
	  return value.format('LL');
	}
	
	function getTodayTimeStr(value) {
	  var today = getTodayTime(value);
	  return getTitleString(today);
	}
	
	function getMonthName(month) {
	  var locale = month.locale();
	  var localeData = month.localeData();
	  return localeData[locale === 'zh-cn' ? 'months' : 'monthsShort'](month);
	}
	
	function syncTime(from, to) {
	  if (!_moment2['default'].isMoment(from) || !_moment2['default'].isMoment(to)) return;
	  to.hour(from.hour());
	  to.minute(from.minute());
	  to.second(from.second());
	  to.millisecond(from.millisecond());
	}
	
	function getTimeConfig(value, disabledTime) {
	  var disabledTimeConfig = disabledTime ? disabledTime(value) : {};
	  disabledTimeConfig = (0, _extends3['default'])({}, defaultDisabledTime, disabledTimeConfig);
	  return disabledTimeConfig;
	}
	
	function isTimeValidByConfig(value, disabledTimeConfig) {
	  var invalidTime = false;
	  if (value) {
	    var hour = value.hour();
	    var minutes = value.minute();
	    var seconds = value.second();
	    var disabledHours = disabledTimeConfig.disabledHours();
	    if (disabledHours.indexOf(hour) === -1) {
	      var disabledMinutes = disabledTimeConfig.disabledMinutes(hour);
	      if (disabledMinutes.indexOf(minutes) === -1) {
	        var disabledSeconds = disabledTimeConfig.disabledSeconds(hour, minutes);
	        invalidTime = disabledSeconds.indexOf(seconds) !== -1;
	      } else {
	        invalidTime = true;
	      }
	    } else {
	      invalidTime = true;
	    }
	  }
	  return !invalidTime;
	}
	
	function isTimeValid(value, disabledTime) {
	  var disabledTimeConfig = getTimeConfig(value, disabledTime);
	  return isTimeValidByConfig(value, disabledTimeConfig);
	}
	
	function isAllowedDate(value, disabledDate, disabledTime) {
	  if (disabledDate) {
	    if (disabledDate(value)) {
	      return false;
	    }
	  }
	  if (disabledTime) {
	    if (!isTimeValid(value, disabledTime)) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function formatDate(value, format) {
	  if (!value) {
	    return '';
	  }
	
	  if (Array.isArray(format)) {
	    format = format[0];
	  }
	
	  return value.format(format);
	}

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var PooledClass = __webpack_require__(221);
	
	var emptyFunction = __webpack_require__(101);
	var warning = __webpack_require__(49);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 164 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _rcTooltip = _interopRequireDefault(__webpack_require__(2751));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _placements = _interopRequireDefault(__webpack_require__(1338));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var splitObject = function splitObject(obj, keys) {
	  var picked = {};
	
	  var omitted = _extends({}, obj);
	
	  keys.forEach(function (key) {
	    if (obj && key in obj) {
	      picked[key] = obj[key];
	      delete omitted[key];
	    }
	  });
	  return {
	    picked: picked,
	    omitted: omitted
	  };
	}; // Fix Tooltip won't hide at disabled button
	// mouse events don't trigger at disabled button in Chrome
	// https://github.com/react-component/tooltip/issues/18
	
	
	function getDisabledCompatibleChildren(element) {
	  var elementType = element.type;
	
	  if ((elementType.__ANT_BUTTON === true || elementType.__ANT_SWITCH === true || elementType.__ANT_CHECKBOX === true || element.type === 'button') && element.props.disabled) {
	    // Pick some layout related style properties up to span
	    // Prevent layout bugs like https://github.com/ant-design/ant-design/issues/5254
	    var _splitObject = splitObject(element.props.style, ['position', 'left', 'right', 'top', 'bottom', 'float', 'display', 'zIndex']),
	        picked = _splitObject.picked,
	        omitted = _splitObject.omitted;
	
	    var spanStyle = _extends(_extends({
	      display: 'inline-block'
	    }, picked), {
	      cursor: 'not-allowed',
	      width: element.props.block ? '100%' : null
	    });
	
	    var buttonStyle = _extends(_extends({}, omitted), {
	      pointerEvents: 'none'
	    });
	
	    var child = /*#__PURE__*/React.cloneElement(element, {
	      style: buttonStyle,
	      className: null
	    });
	    return /*#__PURE__*/React.createElement("span", {
	      style: spanStyle,
	      className: element.props.className
	    }, child);
	  }
	
	  return element;
	}
	
	var Tooltip = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tooltip, _React$Component);
	
	  var _super = _createSuper(Tooltip);
	
	  function Tooltip(props) {
	    var _this;
	
	    _classCallCheck(this, Tooltip);
	
	    _this = _super.call(this, props);
	
	    _this.onVisibleChange = function (visible) {
	      var onVisibleChange = _this.props.onVisibleChange;
	
	      if (!('visible' in _this.props)) {
	        _this.setState({
	          visible: _this.isNoTitle() ? false : visible
	        });
	      }
	
	      if (onVisibleChange && !_this.isNoTitle()) {
	        onVisibleChange(visible);
	      }
	    };
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    }; // 动态设置动画点
	
	
	    _this.onPopupAlign = function (domNode, align) {
	      var placements = _this.getPlacements(); // 当前返回的位置
	
	
	      var placement = Object.keys(placements).filter(function (key) {
	        return placements[key].points[0] === align.points[0] && placements[key].points[1] === align.points[1];
	      })[0];
	
	      if (!placement) {
	        return;
	      } // 根据当前坐标设置动画点
	
	
	      var rect = domNode.getBoundingClientRect();
	      var transformOrigin = {
	        top: '50%',
	        left: '50%'
	      };
	
	      if (placement.indexOf('top') >= 0 || placement.indexOf('Bottom') >= 0) {
	        transformOrigin.top = "".concat(rect.height - align.offset[1], "px");
	      } else if (placement.indexOf('Top') >= 0 || placement.indexOf('bottom') >= 0) {
	        transformOrigin.top = "".concat(-align.offset[1], "px");
	      }
	
	      if (placement.indexOf('left') >= 0 || placement.indexOf('Right') >= 0) {
	        transformOrigin.left = "".concat(rect.width - align.offset[0], "px");
	      } else if (placement.indexOf('right') >= 0 || placement.indexOf('Left') >= 0) {
	        transformOrigin.left = "".concat(-align.offset[0], "px");
	      }
	
	      domNode.style.transformOrigin = "".concat(transformOrigin.left, " ").concat(transformOrigin.top);
	    };
	
	    _this.renderTooltip = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          openClassName = props.openClassName,
	          getPopupContainer = props.getPopupContainer,
	          getTooltipContainer = props.getTooltipContainer;
	      var children = props.children;
	      var prefixCls = getPrefixCls('tooltip', customizePrefixCls);
	      var visible = state.visible; // Hide tooltip when there is no title
	
	      if (!('visible' in props) && _this.isNoTitle()) {
	        visible = false;
	      }
	
	      var child = getDisabledCompatibleChildren( /*#__PURE__*/React.isValidElement(children) ? children : /*#__PURE__*/React.createElement("span", null, children));
	      var childProps = child.props;
	      var childCls = (0, _classnames["default"])(childProps.className, _defineProperty({}, openClassName || "".concat(prefixCls, "-open"), true));
	      return /*#__PURE__*/React.createElement(_rcTooltip["default"], _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
	        ref: _this.saveTooltip,
	        builtinPlacements: _this.getPlacements(),
	        overlay: _this.getOverlay(),
	        visible: visible,
	        onVisibleChange: _this.onVisibleChange,
	        onPopupAlign: _this.onPopupAlign
	      }), visible ? /*#__PURE__*/React.cloneElement(child, {
	        className: childCls
	      }) : child);
	    };
	
	    _this.state = {
	      visible: !!props.visible || !!props.defaultVisible
	    };
	    return _this;
	  }
	
	  _createClass(Tooltip, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "getPlacements",
	    value: function getPlacements() {
	      var _this$props = this.props,
	          builtinPlacements = _this$props.builtinPlacements,
	          arrowPointAtCenter = _this$props.arrowPointAtCenter,
	          autoAdjustOverflow = _this$props.autoAdjustOverflow;
	      return builtinPlacements || (0, _placements["default"])({
	        arrowPointAtCenter: arrowPointAtCenter,
	        verticalArrowShift: 8,
	        autoAdjustOverflow: autoAdjustOverflow
	      });
	    }
	  }, {
	    key: "isNoTitle",
	    value: function isNoTitle() {
	      var _this$props2 = this.props,
	          title = _this$props2.title,
	          overlay = _this$props2.overlay;
	      return !title && !overlay && title !== 0; // overlay for old version compatibility
	    }
	  }, {
	    key: "getOverlay",
	    value: function getOverlay() {
	      var _this$props3 = this.props,
	          title = _this$props3.title,
	          overlay = _this$props3.overlay;
	
	      if (title === 0) {
	        return title;
	      }
	
	      return overlay || title || '';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTooltip);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Tooltip;
	}(React.Component);
	
	Tooltip.defaultProps = {
	  placement: 'top',
	  transitionName: 'zoom-big-fast',
	  mouseEnterDelay: 0.1,
	  mouseLeaveDelay: 0.1,
	  arrowPointAtCenter: false,
	  autoAdjustOverflow: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Tooltip);
	var _default = Tooltip;
	exports["default"] = _default;

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryApportionToRestore = exports.queryApportionToNo = exports.queryDeleteApportion = exports.queryApportionIsPublic = exports.queryCheckApportionDetail = exports.queryDeleteApportionDetail = exports.querySaveApportionDetail = exports.querySaveApportion = exports.queryApportionInfo = exports.queryApportionList = exports.queryApportionOrigin = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 分摊
	 */
	var queryApportionOrigin = exports.queryApportionOrigin = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt("return", _http2.default.get(_req.finance.GET_APPORTION_ORIGIN, params));
	
	          case 1:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryApportionOrigin(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryApportionList = exports.queryApportionList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt("return", _http2.default.get(_req.finance.GET_APPORTION_LIST, params));
	
	          case 1:
	          case "end":
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryApportionList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryApportionInfo = exports.queryApportionInfo = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt("return", _http2.default.get(_req.finance.GET_APPORTION_INFO, params));
	
	          case 1:
	          case "end":
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryApportionInfo(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var querySaveApportion = exports.querySaveApportion = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt("return", _http2.default.post(_req.finance.SAVE_APPORTION, params));
	
	          case 1:
	          case "end":
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function querySaveApportion(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var querySaveApportionDetail = exports.querySaveApportionDetail = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(uuid, params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt("return", _http2.default.post(_req.finance.SAVE_APPORTION_DETAIL + "/" + uuid, params));
	
	          case 1:
	          case "end":
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function querySaveApportionDetail(_x5, _x6) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryDeleteApportionDetail = exports.queryDeleteApportionDetail = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt("return", _http2.default.post(_req.finance.APPORTION_DELETE_DETAIL, params));
	
	          case 1:
	          case "end":
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryDeleteApportionDetail(_x7) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryCheckApportionDetail = exports.queryCheckApportionDetail = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt("return", _http2.default.get(_req.finance.APPORTION_CHECK_DETAIL, params));
	
	          case 1:
	          case "end":
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryCheckApportionDetail(_x8) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var queryApportionIsPublic = exports.queryApportionIsPublic = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt("return", _http2.default.get(_req.finance.APPORTION_ISPUBLIC, params));
	
	          case 1:
	          case "end":
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryApportionIsPublic(_x9) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryDeleteApportion = exports.queryDeleteApportion = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt("return", _http2.default.get(_req.finance.APPORTION_DELETE, params));
	
	          case 1:
	          case "end":
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryDeleteApportion(_x10) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryApportionToNo = exports.queryApportionToNo = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt("return", _http2.default.get(_req.finance.APPORTION_TONO, params));
	
	          case 1:
	          case "end":
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryApportionToNo(_x11) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryApportionToRestore = exports.queryApportionToRestore = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt("return", _http2.default.get(_req.finance.APPORTION_TORESTORE, params));
	
	          case 1:
	          case "end":
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryApportionToRestore(_x12) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryDownloadHrTemplate = exports.queryImportHr = exports.queryExportHr = exports.queryResetHr = exports.queryEnableHr = exports.queryDeleteHr = exports.queryDisableHr = exports.querySaveHr = exports.queryRegisterHr = exports.queryHrInfo = exports.queryHrList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var queryHrList = exports.queryHrList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.hr.HR_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryHrList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryHrInfo = exports.queryHrInfo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.hr.HR_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryHrInfo(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryRegisterHr = exports.queryRegisterHr = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.post(_req.hr.HR_REGISTER, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryRegisterHr(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var querySaveHr = exports.querySaveHr = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.post(_req.hr.HR_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function querySaveHr(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryDisableHr = exports.queryDisableHr = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.hr.HR_DISABLE, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryDisableHr(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryDeleteHr = exports.queryDeleteHr = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.hr.HR_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryDeleteHr(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryEnableHr = exports.queryEnableHr = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.hr.HR_ENABLE, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryEnableHr(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var queryResetHr = exports.queryResetHr = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.hr.HR_RESET_PWD, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryResetHr(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryExportHr = exports.queryExportHr = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _http2.default.download(_req.hr.HR_EXPORT, params, '用户资料导出.xlsx');
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryExportHr(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryImportHr = exports.queryImportHr = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.post(_req.hr.HR_IMPORT, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryImportHr(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryDownloadHrTemplate = exports.queryDownloadHrTemplate = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11() {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            _http2.default.download(_req.hr.DOWNLOAD_HR_TEMPLATE, {}, '员工导入模板.xlsx');
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryDownloadHrTemplate() {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _dict = __webpack_require__(64);
	
	// 按模块的action, reducer整合体
	/**
	 * 获取支出类别
	 */
	var pType = [{ value: '1[1,2]_', key: '一、经营性现金流入', color: 'green' }, { value: '11_', key: '(一)日常现金流入' }, { value: '12_', key: '(二)非日常现金流入' }, { value: '13_', key: '二、筹资性现金流入', color: 'green' }, { value: '14_', key: '三、投资性现金流入', color: 'green' }, { value: '1__', key: '现金流入合计', color: 'red' }, { value: '2[1,2]_', key: '四、经营性现金流出', color: 'green' }, { value: '21_', key: '(一)日常现金流出' }, { value: '22_', key: '(二)非日常现金流出' }, { value: '23_', key: '五、投资性现金流出', color: 'green' }, { value: '2__', key: '现金流出合计', color: 'red' }, { value: '1[1,2]_-2[1,2]_', key: '经营性现金净流（总）', color: 'red' }, {
	  value: '[210,211,212,21e,21w,216]',
	  key: '人力资源成本',
	  color: 'red',
	  children: [210, 211, 212, '21e', '21w', 216]
	}, { value: '11_-21_', key: '经营性现金净流（日常）', color: 'red' }, { value: '12_-22_', key: '经营性现金净流（非日常）', color: 'red' }, { value: '1[3,4]_-23_', key: '非经营性现金净流', color: 'red' }, { value: '1__-2__', key: '每月现金流情况（含投资款）', color: 'red' }, { value: 'payCurrents', key: '走账总计', color: 'red', notTo: true }, { value: 'current', key: '银行实时余额', color: 'red', notTo: true }, {
	  value: 'financeCurrentMap',
	  key: '截止理财余额 ',
	  color: 'red',
	  notTo: true
	}, { value: 'financeCurrent', key: '可用资金总余额', color: 'red', notTo: true }];
	
	var loadDictExpend = function loadDictExpend() {
	  return new Promise(function (resolve, reject) {
	    (0, _dict.queryDictExpend)().then(function (res) {
	      if (res.statusCode === 200) {
	        resolve(res.data);
	      }
	    });
	  });
	};
	
	/**
	 * 获取收入类别
	 */
	var loadDictIncome = function loadDictIncome() {
	  return new Promise(function (resolve, reject) {
	    (0, _dict.queryDictIncome)().then(function (res) {
	      if (res.statusCode === 200) {
	        resolve(res.data);
	      }
	    });
	  });
	};
	
	var setItem = function setItem(item, key) {
	  if (!item.children) {
	    item.children = [];
	  }
	  if (item.children.indexOf(key) < 0) {
	    item.children.push(key);
	  }
	};
	
	var getAllType = function getAllType(pTypes, typeArr) {
	  var indexArr = [];
	
	  var _typeArr = _slicedToArray(typeArr, 2),
	      income = _typeArr[0],
	      expend = _typeArr[1];
	
	  var reg11 = /^11.$/;
	  var reg12 = /^12.$/;
	  var reg13 = /^13.$/;
	  var reg14 = /^14.$/;
	  var reg21 = /^21.$/;
	  var reg22 = /^22.$/;
	  var reg23 = /^23.$/;
	  var reg24 = /^24.$/;
	  var parentValue = '';
	  var type = pTypes;
	  var no = 1;
	  income.map(function (item, index) {
	    item.index = no++;
	    if (reg11.test(item.value)) {
	      parentValue = '11_';
	    } else if (reg12.test(item.value)) {
	      parentValue = '12_';
	    } else if (reg13.test(item.value)) {
	      parentValue = '13_';
	    } else if (reg14.test(item.value)) {
	      parentValue = '14_';
	    }
	    type = type.map(function (item2, index2) {
	      if (item2.value === parentValue) {
	        setItem(item2, item.value);
	      } else if ((parentValue === '11_' || parentValue === '12_') && item2.value === '1[1,2]_') {
	        setItem(item2, item.value);
	      } else if ((parentValue === '11_' || parentValue === '12_') && item2.value === '1[1,2]_-2[1,2]_') {
	        setItem(item2, item.value);
	      } else if ((parentValue === '13_' || parentValue === '14_') && item2.value === '1[3,4]_-23_') {
	        setItem(item2, item.value);
	      } else if (item2.value === '11_-21_' && parentValue === '11_') {
	        setItem(item2, item.value);
	      } else if (item2.value === '12_-22_' && parentValue === '12_') {
	        setItem(item2, item.value);
	      } else if (item2.value === '1__' || item2.value === '1__-2__') {
	        setItem(item2, item.value);
	      }
	      return item2;
	    });
	    return income;
	  });
	  expend.forEach(function (item, index) {
	    item.index = no++;
	    var flag = ['210', '211', '212', '21e', '21w', '216'];
	    if (flag.includes(item.value)) {
	      indexArr.push(item.index);
	    }
	    if (reg21.test(item.value)) {
	      parentValue = '21_';
	    } else if (reg22.test(item.value)) {
	      parentValue = '22_';
	    } else if (reg23.test(item.value)) {
	      parentValue = '23_';
	    } else if (reg24.test(item.value)) {
	      parentValue = '24_';
	    }
	    type = type.map(function (item2, index2) {
	      if (item2.value === parentValue) {
	        setItem(item2, item.value);
	      } else if ((parentValue === '21_' || parentValue === '22_') && item2.value === '2[1,2]_') {
	        setItem(item2, item.value);
	      } else if ((parentValue === '21_' || parentValue === '22_') && item2.value === '1[1,2]_-2[1,2]_') {
	        setItem(item2, item.value);
	      } else if (parentValue === '23_' && item2.value === '1[3,4]_-23_') {
	        setItem(item2, item.value);
	      } else if (item2.value === '11_-21_' && parentValue === '21_') {
	        setItem(item2, item.value);
	      } else if (item2.value === '12_-22_' && parentValue === '22_') {
	        setItem(item2, item.value);
	      } else if (item2.value === '2__' || item2.value === '1__-2__') {
	        setItem(item2, item.value);
	      }
	      return item2;
	    });
	  });
	  type = type.concat(expend).concat(income);
	  type.map(function (item) {
	    if (item.value === '[210,211,212,21e,21w,216]') {
	      item.indexArr = indexArr;
	    }
	    return item;
	  });
	  return type;
	};
	
	var getIncomeExpendType = function getIncomeExpendType() {
	  return Promise.all([loadDictIncome(), loadDictExpend()]).then(function (res) {
	    var type = getAllType(pType, res);
	    return new Promise(function (resolve, reject) {
	      resolve(type);
	    });
	  });
	};
	exports.default = getIncomeExpendType;

/***/ },
/* 169 */
[3009, 236],
/* 170 */
42,
/* 171 */
[3026, 193, 747, 456, 169],
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.31 Array.prototype[@@unscopables]
	var UNSCOPABLES = __webpack_require__(58)('unscopables');
	var ArrayProto = Array.prototype;
	if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(97)(ArrayProto, UNSCOPABLES, {});
	module.exports = function (key) {
	  ArrayProto[UNSCOPABLES][key] = true;
	};


/***/ },
/* 173 */
/***/ function(module, exports) {

	module.exports = false;


/***/ },
/* 174 */
[3023, 206, 45, 104, 69, 43],
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule Draft
	 * @format
	 * 
	 */
	
	'use strict';
	
	var AtomicBlockUtils = __webpack_require__(2133);
	var BlockMapBuilder = __webpack_require__(282);
	var CharacterMetadata = __webpack_require__(100);
	var CompositeDraftDecorator = __webpack_require__(2134);
	var ContentBlock = __webpack_require__(208);
	var ContentState = __webpack_require__(488);
	var DefaultDraftBlockRenderMap = __webpack_require__(489);
	var DefaultDraftInlineStyle = __webpack_require__(796);
	var DraftEditor = __webpack_require__(2136);
	var DraftEditorBlock = __webpack_require__(797);
	var DraftEntity = __webpack_require__(350);
	var DraftModifier = __webpack_require__(92);
	var DraftEntityInstance = __webpack_require__(798);
	var EditorState = __webpack_require__(52);
	var KeyBindingUtil = __webpack_require__(490);
	var RichTextEditorUtil = __webpack_require__(801);
	var SelectionState = __webpack_require__(244);
	
	var convertFromDraftStateToRaw = __webpack_require__(2155);
	var convertFromHTMLToContentBlocks = __webpack_require__(802);
	var convertFromRawToDraftState = __webpack_require__(2156);
	var generateRandomKey = __webpack_require__(158);
	var getDefaultKeyBinding = __webpack_require__(803);
	var getVisibleSelectionRect = __webpack_require__(2179);
	
	var DraftPublic = {
	  Editor: DraftEditor,
	  EditorBlock: DraftEditorBlock,
	  EditorState: EditorState,
	
	  CompositeDecorator: CompositeDraftDecorator,
	  Entity: DraftEntity,
	  EntityInstance: DraftEntityInstance,
	
	  BlockMapBuilder: BlockMapBuilder,
	  CharacterMetadata: CharacterMetadata,
	  ContentBlock: ContentBlock,
	  ContentState: ContentState,
	  SelectionState: SelectionState,
	
	  AtomicBlockUtils: AtomicBlockUtils,
	  KeyBindingUtil: KeyBindingUtil,
	  Modifier: DraftModifier,
	  RichUtils: RichTextEditorUtil,
	
	  DefaultDraftBlockRenderMap: DefaultDraftBlockRenderMap,
	  DefaultDraftInlineStyle: DefaultDraftInlineStyle,
	
	  convertFromHTML: convertFromHTMLToContentBlocks,
	  convertFromRaw: convertFromRawToDraftState,
	  convertToRaw: convertFromDraftStateToRaw,
	  genKey: generateRandomKey,
	  getDefaultKeyBinding: getDefaultKeyBinding,
	  getVisibleSelectionRect: getVisibleSelectionRect
	};
	
	module.exports = DraftPublic;

/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftFeatureFlags
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(2146);
	
	module.exports = DraftFeatureFlags;

/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var retrieve = _util.retrieve;
	var defaults = _util.defaults;
	var extend = _util.extend;
	var each = _util.each;
	
	var formatUtil = __webpack_require__(48);
	
	var graphic = __webpack_require__(14);
	
	var Model = __webpack_require__(70);
	
	var _number = __webpack_require__(25);
	
	var isRadianAroundZero = _number.isRadianAroundZero;
	var remRadian = _number.remRadian;
	
	var _symbol = __webpack_require__(110);
	
	var createSymbol = _symbol.createSymbol;
	
	var matrixUtil = __webpack_require__(86);
	
	var _vector = __webpack_require__(55);
	
	var v2ApplyTransform = _vector.applyTransform;
	
	var _axisHelper = __webpack_require__(122);
	
	var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	/**
	 * A final axis is translated and rotated from a "standard axis".
	 * So opt.position and opt.rotation is required.
	 *
	 * A standard axis is and axis from [0, 0] to [0, axisExtent[1]],
	 * for example: (0, 0) ------------> (0, 50)
	 *
	 * nameDirection or tickDirection or labelDirection is 1 means tick
	 * or label is below the standard axis, whereas is -1 means above
	 * the standard axis. labelOffset means offset between label and axis,
	 * which is useful when 'onZero', where axisLabel is in the grid and
	 * label in outside grid.
	 *
	 * Tips: like always,
	 * positive rotation represents anticlockwise, and negative rotation
	 * represents clockwise.
	 * The direction of position coordinate is the same as the direction
	 * of screen coordinate.
	 *
	 * Do not need to consider axis 'inverse', which is auto processed by
	 * axis extent.
	 *
	 * @param {module:zrender/container/Group} group
	 * @param {Object} axisModel
	 * @param {Object} opt Standard axis parameters.
	 * @param {Array.<number>} opt.position [x, y]
	 * @param {number} opt.rotation by radian
	 * @param {number} [opt.nameDirection=1] 1 or -1 Used when nameLocation is 'middle' or 'center'.
	 * @param {number} [opt.tickDirection=1] 1 or -1
	 * @param {number} [opt.labelDirection=1] 1 or -1
	 * @param {number} [opt.labelOffset=0] Usefull when onZero.
	 * @param {string} [opt.axisLabelShow] default get from axisModel.
	 * @param {string} [opt.axisName] default get from axisModel.
	 * @param {number} [opt.axisNameAvailableWidth]
	 * @param {number} [opt.labelRotate] by degree, default get from axisModel.
	 * @param {number} [opt.strokeContainThreshold] Default label interval when label
	 * @param {number} [opt.nameTruncateMaxWidth]
	 */
	
	var AxisBuilder = function (axisModel, opt) {
	  /**
	   * @readOnly
	   */
	  this.opt = opt;
	  /**
	   * @readOnly
	   */
	
	  this.axisModel = axisModel; // Default value
	
	  defaults(opt, {
	    labelOffset: 0,
	    nameDirection: 1,
	    tickDirection: 1,
	    labelDirection: 1,
	    silent: true
	  });
	  /**
	   * @readOnly
	   */
	
	  this.group = new graphic.Group(); // FIXME Not use a seperate text group?
	
	  var dumbGroup = new graphic.Group({
	    position: opt.position.slice(),
	    rotation: opt.rotation
	  }); // this.group.add(dumbGroup);
	  // this._dumbGroup = dumbGroup;
	
	  dumbGroup.updateTransform();
	  this._transform = dumbGroup.transform;
	  this._dumbGroup = dumbGroup;
	};
	
	AxisBuilder.prototype = {
	  constructor: AxisBuilder,
	  hasBuilder: function (name) {
	    return !!builders[name];
	  },
	  add: function (name) {
	    builders[name].call(this);
	  },
	  getGroup: function () {
	    return this.group;
	  }
	};
	var builders = {
	  /**
	   * @private
	   */
	  axisLine: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	
	    if (!axisModel.get('axisLine.show')) {
	      return;
	    }
	
	    var extent = this.axisModel.axis.getExtent();
	    var matrix = this._transform;
	    var pt1 = [extent[0], 0];
	    var pt2 = [extent[1], 0];
	
	    if (matrix) {
	      v2ApplyTransform(pt1, pt1, matrix);
	      v2ApplyTransform(pt2, pt2, matrix);
	    }
	
	    var lineStyle = extend({
	      lineCap: 'round'
	    }, axisModel.getModel('axisLine.lineStyle').getLineStyle());
	    this.group.add(new graphic.Line({
	      // Id for animation
	      anid: 'line',
	      subPixelOptimize: true,
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: lineStyle,
	      strokeContainThreshold: opt.strokeContainThreshold || 5,
	      silent: true,
	      z2: 1
	    }));
	    var arrows = axisModel.get('axisLine.symbol');
	    var arrowSize = axisModel.get('axisLine.symbolSize');
	    var arrowOffset = axisModel.get('axisLine.symbolOffset') || 0;
	
	    if (typeof arrowOffset === 'number') {
	      arrowOffset = [arrowOffset, arrowOffset];
	    }
	
	    if (arrows != null) {
	      if (typeof arrows === 'string') {
	        // Use the same arrow for start and end point
	        arrows = [arrows, arrows];
	      }
	
	      if (typeof arrowSize === 'string' || typeof arrowSize === 'number') {
	        // Use the same size for width and height
	        arrowSize = [arrowSize, arrowSize];
	      }
	
	      var symbolWidth = arrowSize[0];
	      var symbolHeight = arrowSize[1];
	      each([{
	        rotate: opt.rotation + Math.PI / 2,
	        offset: arrowOffset[0],
	        r: 0
	      }, {
	        rotate: opt.rotation - Math.PI / 2,
	        offset: arrowOffset[1],
	        r: Math.sqrt((pt1[0] - pt2[0]) * (pt1[0] - pt2[0]) + (pt1[1] - pt2[1]) * (pt1[1] - pt2[1]))
	      }], function (point, index) {
	        if (arrows[index] !== 'none' && arrows[index] != null) {
	          var symbol = createSymbol(arrows[index], -symbolWidth / 2, -symbolHeight / 2, symbolWidth, symbolHeight, lineStyle.stroke, true); // Calculate arrow position with offset
	
	          var r = point.r + point.offset;
	          var pos = [pt1[0] + r * Math.cos(opt.rotation), pt1[1] - r * Math.sin(opt.rotation)];
	          symbol.attr({
	            rotation: point.rotate,
	            position: pos,
	            silent: true,
	            z2: 11
	          });
	          this.group.add(symbol);
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  axisTickLabel: function () {
	    var axisModel = this.axisModel;
	    var opt = this.opt;
	    var ticksEls = buildAxisMajorTicks(this, axisModel, opt);
	    var labelEls = buildAxisLabel(this, axisModel, opt);
	    fixMinMaxLabelShow(axisModel, labelEls, ticksEls);
	    buildAxisMinorTicks(this, axisModel, opt);
	  },
	
	  /**
	   * @private
	   */
	  axisName: function () {
	    var opt = this.opt;
	    var axisModel = this.axisModel;
	    var name = retrieve(opt.axisName, axisModel.get('name'));
	
	    if (!name) {
	      return;
	    }
	
	    var nameLocation = axisModel.get('nameLocation');
	    var nameDirection = opt.nameDirection;
	    var textStyleModel = axisModel.getModel('nameTextStyle');
	    var gap = axisModel.get('nameGap') || 0;
	    var extent = this.axisModel.axis.getExtent();
	    var gapSignal = extent[0] > extent[1] ? -1 : 1;
	    var pos = [nameLocation === 'start' ? extent[0] - gapSignal * gap : nameLocation === 'end' ? extent[1] + gapSignal * gap : (extent[0] + extent[1]) / 2, // 'middle'
	    // Reuse labelOffset.
	    isNameLocationCenter(nameLocation) ? opt.labelOffset + nameDirection * gap : 0];
	    var labelLayout;
	    var nameRotation = axisModel.get('nameRotate');
	
	    if (nameRotation != null) {
	      nameRotation = nameRotation * PI / 180; // To radian.
	    }
	
	    var axisNameAvailableWidth;
	
	    if (isNameLocationCenter(nameLocation)) {
	      labelLayout = innerTextLayout(opt.rotation, nameRotation != null ? nameRotation : opt.rotation, // Adapt to axis.
	      nameDirection);
	    } else {
	      labelLayout = endTextLayout(opt, nameLocation, nameRotation || 0, extent);
	      axisNameAvailableWidth = opt.axisNameAvailableWidth;
	
	      if (axisNameAvailableWidth != null) {
	        axisNameAvailableWidth = Math.abs(axisNameAvailableWidth / Math.sin(labelLayout.rotation));
	        !isFinite(axisNameAvailableWidth) && (axisNameAvailableWidth = null);
	      }
	    }
	
	    var textFont = textStyleModel.getFont();
	    var truncateOpt = axisModel.get('nameTruncate', true) || {};
	    var ellipsis = truncateOpt.ellipsis;
	    var maxWidth = retrieve(opt.nameTruncateMaxWidth, truncateOpt.maxWidth, axisNameAvailableWidth); // FIXME
	    // truncate rich text? (consider performance)
	
	    var truncatedText = ellipsis != null && maxWidth != null ? formatUtil.truncateText(name, maxWidth, textFont, ellipsis, {
	      minChar: 2,
	      placeholder: truncateOpt.placeholder
	    }) : name;
	    var tooltipOpt = axisModel.get('tooltip', true);
	    var mainType = axisModel.mainType;
	    var formatterParams = {
	      componentType: mainType,
	      name: name,
	      $vars: ['name']
	    };
	    formatterParams[mainType + 'Index'] = axisModel.componentIndex;
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'name',
	      __fullText: name,
	      __truncatedText: truncatedText,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: isLabelSilent(axisModel),
	      z2: 1,
	      tooltip: tooltipOpt && tooltipOpt.show ? extend({
	        content: name,
	        formatter: function () {
	          return name;
	        },
	        formatterParams: formatterParams
	      }, tooltipOpt) : null
	    });
	    graphic.setTextStyle(textEl.style, textStyleModel, {
	      text: truncatedText,
	      textFont: textFont,
	      textFill: textStyleModel.getTextColor() || axisModel.get('axisLine.lineStyle.color'),
	      textAlign: textStyleModel.get('align') || labelLayout.textAlign,
	      textVerticalAlign: textStyleModel.get('verticalAlign') || labelLayout.textVerticalAlign
	    });
	
	    if (axisModel.get('triggerEvent')) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisName';
	      textEl.eventData.name = name;
	    } // FIXME
	
	
	    this._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    this.group.add(textEl);
	    textEl.decomposeTransform();
	  }
	};
	
	var makeAxisEventDataBase = AxisBuilder.makeAxisEventDataBase = function (axisModel) {
	  var eventData = {
	    componentType: axisModel.mainType,
	    componentIndex: axisModel.componentIndex
	  };
	  eventData[axisModel.mainType + 'Index'] = axisModel.componentIndex;
	  return eventData;
	};
	/**
	 * @public
	 * @static
	 * @param {Object} opt
	 * @param {number} axisRotation in radian
	 * @param {number} textRotation in radian
	 * @param {number} direction
	 * @return {Object} {
	 *  rotation, // according to axis
	 *  textAlign,
	 *  textVerticalAlign
	 * }
	 */
	
	
	var innerTextLayout = AxisBuilder.innerTextLayout = function (axisRotation, textRotation, direction) {
	  var rotationDiff = remRadian(textRotation - axisRotation);
	  var textAlign;
	  var textVerticalAlign;
	
	  if (isRadianAroundZero(rotationDiff)) {
	    // Label is parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI)) {
	    // Label is inverse parallel with axis line.
	    textVerticalAlign = direction > 0 ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff > 0 && rotationDiff < PI) {
	      textAlign = direction > 0 ? 'right' : 'left';
	    } else {
	      textAlign = direction > 0 ? 'left' : 'right';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	};
	
	function endTextLayout(opt, textPosition, textRotate, extent) {
	  var rotationDiff = remRadian(textRotate - opt.rotation);
	  var textAlign;
	  var textVerticalAlign;
	  var inverse = extent[0] > extent[1];
	  var onLeft = textPosition === 'start' && !inverse || textPosition !== 'start' && inverse;
	
	  if (isRadianAroundZero(rotationDiff - PI / 2)) {
	    textVerticalAlign = onLeft ? 'bottom' : 'top';
	    textAlign = 'center';
	  } else if (isRadianAroundZero(rotationDiff - PI * 1.5)) {
	    textVerticalAlign = onLeft ? 'top' : 'bottom';
	    textAlign = 'center';
	  } else {
	    textVerticalAlign = 'middle';
	
	    if (rotationDiff < PI * 1.5 && rotationDiff > PI / 2) {
	      textAlign = onLeft ? 'left' : 'right';
	    } else {
	      textAlign = onLeft ? 'right' : 'left';
	    }
	  }
	
	  return {
	    rotation: rotationDiff,
	    textAlign: textAlign,
	    textVerticalAlign: textVerticalAlign
	  };
	}
	
	var isLabelSilent = AxisBuilder.isLabelSilent = function (axisModel) {
	  var tooltipOpt = axisModel.get('tooltip');
	  return axisModel.get('silent') // Consider mouse cursor, add these restrictions.
	  || !(axisModel.get('triggerEvent') || tooltipOpt && tooltipOpt.show);
	};
	
	function fixMinMaxLabelShow(axisModel, labelEls, tickEls) {
	  if (shouldShowAllLabels(axisModel.axis)) {
	    return;
	  } // If min or max are user set, we need to check
	  // If the tick on min(max) are overlap on their neighbour tick
	  // If they are overlapped, we need to hide the min(max) tick label
	
	
	  var showMinLabel = axisModel.get('axisLabel.showMinLabel');
	  var showMaxLabel = axisModel.get('axisLabel.showMaxLabel'); // FIXME
	  // Have not consider onBand yet, where tick els is more than label els.
	
	  labelEls = labelEls || [];
	  tickEls = tickEls || [];
	  var firstLabel = labelEls[0];
	  var nextLabel = labelEls[1];
	  var lastLabel = labelEls[labelEls.length - 1];
	  var prevLabel = labelEls[labelEls.length - 2];
	  var firstTick = tickEls[0];
	  var nextTick = tickEls[1];
	  var lastTick = tickEls[tickEls.length - 1];
	  var prevTick = tickEls[tickEls.length - 2];
	
	  if (showMinLabel === false) {
	    ignoreEl(firstLabel);
	    ignoreEl(firstTick);
	  } else if (isTwoLabelOverlapped(firstLabel, nextLabel)) {
	    if (showMinLabel) {
	      ignoreEl(nextLabel);
	      ignoreEl(nextTick);
	    } else {
	      ignoreEl(firstLabel);
	      ignoreEl(firstTick);
	    }
	  }
	
	  if (showMaxLabel === false) {
	    ignoreEl(lastLabel);
	    ignoreEl(lastTick);
	  } else if (isTwoLabelOverlapped(prevLabel, lastLabel)) {
	    if (showMaxLabel) {
	      ignoreEl(prevLabel);
	      ignoreEl(prevTick);
	    } else {
	      ignoreEl(lastLabel);
	      ignoreEl(lastTick);
	    }
	  }
	}
	
	function ignoreEl(el) {
	  el && (el.ignore = true);
	}
	
	function isTwoLabelOverlapped(current, next, labelLayout) {
	  // current and next has the same rotation.
	  var firstRect = current && current.getBoundingRect().clone();
	  var nextRect = next && next.getBoundingRect().clone();
	
	  if (!firstRect || !nextRect) {
	    return;
	  } // When checking intersect of two rotated labels, we use mRotationBack
	  // to avoid that boundingRect is enlarge when using `boundingRect.applyTransform`.
	
	
	  var mRotationBack = matrixUtil.identity([]);
	  matrixUtil.rotate(mRotationBack, mRotationBack, -current.rotation);
	  firstRect.applyTransform(matrixUtil.mul([], mRotationBack, current.getLocalTransform()));
	  nextRect.applyTransform(matrixUtil.mul([], mRotationBack, next.getLocalTransform()));
	  return firstRect.intersect(nextRect);
	}
	
	function isNameLocationCenter(nameLocation) {
	  return nameLocation === 'middle' || nameLocation === 'center';
	}
	
	function createTicks(ticksCoords, tickTransform, tickEndCoord, tickLineStyle, aniid) {
	  var tickEls = [];
	  var pt1 = [];
	  var pt2 = [];
	
	  for (var i = 0; i < ticksCoords.length; i++) {
	    var tickCoord = ticksCoords[i].coord;
	    pt1[0] = tickCoord;
	    pt1[1] = 0;
	    pt2[0] = tickCoord;
	    pt2[1] = tickEndCoord;
	
	    if (tickTransform) {
	      v2ApplyTransform(pt1, pt1, tickTransform);
	      v2ApplyTransform(pt2, pt2, tickTransform);
	    } // Tick line, Not use group transform to have better line draw
	
	
	    var tickEl = new graphic.Line({
	      // Id for animation
	      anid: aniid + '_' + ticksCoords[i].tickValue,
	      subPixelOptimize: true,
	      shape: {
	        x1: pt1[0],
	        y1: pt1[1],
	        x2: pt2[0],
	        y2: pt2[1]
	      },
	      style: tickLineStyle,
	      z2: 2,
	      silent: true
	    });
	    tickEls.push(tickEl);
	  }
	
	  return tickEls;
	}
	
	function buildAxisMajorTicks(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var tickModel = axisModel.getModel('axisTick');
	
	  if (!tickModel.get('show') || axis.scale.isBlank()) {
	    return;
	  }
	
	  var lineStyleModel = tickModel.getModel('lineStyle');
	  var tickEndCoord = opt.tickDirection * tickModel.get('length');
	  var ticksCoords = axis.getTicksCoords();
	  var ticksEls = createTicks(ticksCoords, axisBuilder._transform, tickEndCoord, defaults(lineStyleModel.getLineStyle(), {
	    stroke: axisModel.get('axisLine.lineStyle.color')
	  }), 'ticks');
	
	  for (var i = 0; i < ticksEls.length; i++) {
	    axisBuilder.group.add(ticksEls[i]);
	  }
	
	  return ticksEls;
	}
	
	function buildAxisMinorTicks(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var minorTickModel = axisModel.getModel('minorTick');
	
	  if (!minorTickModel.get('show') || axis.scale.isBlank()) {
	    return;
	  }
	
	  var minorTicksCoords = axis.getMinorTicksCoords();
	
	  if (!minorTicksCoords.length) {
	    return;
	  }
	
	  var lineStyleModel = minorTickModel.getModel('lineStyle');
	  var tickEndCoord = opt.tickDirection * minorTickModel.get('length');
	  var minorTickLineStyle = defaults(lineStyleModel.getLineStyle(), defaults(axisModel.getModel('axisTick').getLineStyle(), {
	    stroke: axisModel.get('axisLine.lineStyle.color')
	  }));
	
	  for (var i = 0; i < minorTicksCoords.length; i++) {
	    var minorTicksEls = createTicks(minorTicksCoords[i], axisBuilder._transform, tickEndCoord, minorTickLineStyle, 'minorticks_' + i);
	
	    for (var k = 0; k < minorTicksEls.length; k++) {
	      axisBuilder.group.add(minorTicksEls[k]);
	    }
	  }
	}
	
	function buildAxisLabel(axisBuilder, axisModel, opt) {
	  var axis = axisModel.axis;
	  var show = retrieve(opt.axisLabelShow, axisModel.get('axisLabel.show'));
	
	  if (!show || axis.scale.isBlank()) {
	    return;
	  }
	
	  var labelModel = axisModel.getModel('axisLabel');
	  var labelMargin = labelModel.get('margin');
	  var labels = axis.getViewLabels(); // Special label rotate.
	
	  var labelRotation = (retrieve(opt.labelRotate, labelModel.get('rotate')) || 0) * PI / 180;
	  var labelLayout = innerTextLayout(opt.rotation, labelRotation, opt.labelDirection);
	  var rawCategoryData = axisModel.getCategories && axisModel.getCategories(true);
	  var labelEls = [];
	  var silent = isLabelSilent(axisModel);
	  var triggerEvent = axisModel.get('triggerEvent');
	  each(labels, function (labelItem, index) {
	    var tickValue = labelItem.tickValue;
	    var formattedLabel = labelItem.formattedLabel;
	    var rawLabel = labelItem.rawLabel;
	    var itemLabelModel = labelModel;
	
	    if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
	      itemLabelModel = new Model(rawCategoryData[tickValue].textStyle, labelModel, axisModel.ecModel);
	    }
	
	    var textColor = itemLabelModel.getTextColor() || axisModel.get('axisLine.lineStyle.color');
	    var tickCoord = axis.dataToCoord(tickValue);
	    var pos = [tickCoord, opt.labelOffset + opt.labelDirection * labelMargin];
	    var textEl = new graphic.Text({
	      // Id for animation
	      anid: 'label_' + tickValue,
	      position: pos,
	      rotation: labelLayout.rotation,
	      silent: silent,
	      z2: 10
	    });
	    graphic.setTextStyle(textEl.style, itemLabelModel, {
	      text: formattedLabel,
	      textAlign: itemLabelModel.getShallow('align', true) || labelLayout.textAlign,
	      textVerticalAlign: itemLabelModel.getShallow('verticalAlign', true) || itemLabelModel.getShallow('baseline', true) || labelLayout.textVerticalAlign,
	      textFill: typeof textColor === 'function' ? textColor( // (1) In category axis with data zoom, tick is not the original
	      // index of axis.data. So tick should not be exposed to user
	      // in category axis.
	      // (2) Compatible with previous version, which always use formatted label as
	      // input. But in interval scale the formatted label is like '223,445', which
	      // maked user repalce ','. So we modify it to return original val but remain
	      // it as 'string' to avoid error in replacing.
	      axis.type === 'category' ? rawLabel : axis.type === 'value' ? tickValue + '' : tickValue, index) : textColor
	    }); // Pack data for mouse event
	
	    if (triggerEvent) {
	      textEl.eventData = makeAxisEventDataBase(axisModel);
	      textEl.eventData.targetType = 'axisLabel';
	      textEl.eventData.value = rawLabel;
	    } // FIXME
	
	
	    axisBuilder._dumbGroup.add(textEl);
	
	    textEl.updateTransform();
	    labelEls.push(textEl);
	    axisBuilder.group.add(textEl);
	    textEl.decomposeTransform();
	  });
	  return labelEls;
	}
	
	var _default = AxisBuilder;
	module.exports = _default;

/***/ },
/* 178 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var features = {};
	
	function register(name, ctor) {
	  features[name] = ctor;
	}
	
	function get(name) {
	  return features[name];
	}
	
	exports.register = register;
	exports.get = get;

/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	var map = _util.map;
	
	var _number = __webpack_require__(25);
	
	var linearMap = _number.linearMap;
	var getPixelPrecision = _number.getPixelPrecision;
	var round = _number.round;
	
	var _axisTickLabelBuilder = __webpack_require__(2396);
	
	var createAxisTicks = _axisTickLabelBuilder.createAxisTicks;
	var createAxisLabels = _axisTickLabelBuilder.createAxisLabels;
	var calculateCategoryInterval = _axisTickLabelBuilder.calculateCategoryInterval;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NORMALIZED_EXTENT = [0, 1];
	/**
	 * Base class of Axis.
	 * @constructor
	 */
	
	var Axis = function (dim, scale, extent) {
	  /**
	   * Axis dimension. Such as 'x', 'y', 'z', 'angle', 'radius'.
	   * @type {string}
	   */
	  this.dim = dim;
	  /**
	   * Axis scale
	   * @type {module:echarts/coord/scale/*}
	   */
	
	  this.scale = scale;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  this._extent = extent || [0, 0];
	  /**
	   * @type {boolean}
	   */
	
	  this.inverse = false;
	  /**
	   * Usually true when axis has a ordinal scale
	   * @type {boolean}
	   */
	
	  this.onBand = false;
	};
	
	Axis.prototype = {
	  constructor: Axis,
	
	  /**
	   * If axis extent contain given coord
	   * @param {number} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var extent = this._extent;
	    var min = Math.min(extent[0], extent[1]);
	    var max = Math.max(extent[0], extent[1]);
	    return coord >= min && coord <= max;
	  },
	
	  /**
	   * If axis extent contain given data
	   * @param {number} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.scale.contain(data);
	  },
	
	  /**
	   * Get coord extent.
	   * @return {Array.<number>}
	   */
	  getExtent: function () {
	    return this._extent.slice();
	  },
	
	  /**
	   * Get precision used for formatting
	   * @param {Array.<number>} [dataExtent]
	   * @return {number}
	   */
	  getPixelPrecision: function (dataExtent) {
	    return getPixelPrecision(dataExtent || this.scale.getExtent(), this._extent);
	  },
	
	  /**
	   * Set coord extent
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var extent = this._extent;
	    extent[0] = start;
	    extent[1] = end;
	  },
	
	  /**
	   * Convert data to coord. Data is the rank if it has an ordinal scale
	   * @param {number} data
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  dataToCoord: function (data, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	    data = scale.normalize(data);
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    return linearMap(data, NORMALIZED_EXTENT, extent, clamp);
	  },
	
	  /**
	   * Convert coord to data. Data is the rank if it has an ordinal scale
	   * @param {number} coord
	   * @param  {boolean} clamp
	   * @return {number}
	   */
	  coordToData: function (coord, clamp) {
	    var extent = this._extent;
	    var scale = this.scale;
	
	    if (this.onBand && scale.type === 'ordinal') {
	      extent = extent.slice();
	      fixExtentWithBands(extent, scale.count());
	    }
	
	    var t = linearMap(coord, extent, NORMALIZED_EXTENT, clamp);
	    return this.scale.scale(t);
	  },
	
	  /**
	   * Convert pixel point to data in axis
	   * @param {Array.<number>} point
	   * @param  {boolean} clamp
	   * @return {number} data
	   */
	  pointToData: function (point, clamp) {// Should be implemented in derived class if necessary.
	  },
	
	  /**
	   * Different from `zrUtil.map(axis.getTicks(), axis.dataToCoord, axis)`,
	   * `axis.getTicksCoords` considers `onBand`, which is used by
	   * `boundaryGap:true` of category axis and splitLine and splitArea.
	   * @param {Object} [opt]
	   * @param {Model} [opt.tickModel=axis.model.getModel('axisTick')]
	   * @param {boolean} [opt.clamp] If `true`, the first and the last
	   *        tick must be at the axis end points. Otherwise, clip ticks
	   *        that outside the axis extent.
	   * @return {Array.<Object>} [{
	   *     coord: ...,
	   *     tickValue: ...
	   * }, ...]
	   */
	  getTicksCoords: function (opt) {
	    opt = opt || {};
	    var tickModel = opt.tickModel || this.getTickModel();
	    var result = createAxisTicks(this, tickModel);
	    var ticks = result.ticks;
	    var ticksCoords = map(ticks, function (tickValue) {
	      return {
	        coord: this.dataToCoord(tickValue),
	        tickValue: tickValue
	      };
	    }, this);
	    var alignWithLabel = tickModel.get('alignWithLabel');
	    fixOnBandTicksCoords(this, ticksCoords, alignWithLabel, opt.clamp);
	    return ticksCoords;
	  },
	
	  /**
	   * @return {Array.<Array.<Object>>} [{ coord: ..., tickValue: ...}]
	   */
	  getMinorTicksCoords: function () {
	    if (this.scale.type === 'ordinal') {
	      // Category axis doesn't support minor ticks
	      return [];
	    }
	
	    var minorTickModel = this.model.getModel('minorTick');
	    var splitNumber = minorTickModel.get('splitNumber'); // Protection.
	
	    if (!(splitNumber > 0 && splitNumber < 100)) {
	      splitNumber = 5;
	    }
	
	    var minorTicks = this.scale.getMinorTicks(splitNumber);
	    var minorTicksCoords = map(minorTicks, function (minorTicksGroup) {
	      return map(minorTicksGroup, function (minorTick) {
	        return {
	          coord: this.dataToCoord(minorTick),
	          tickValue: minorTick
	        };
	      }, this);
	    }, this);
	    return minorTicksCoords;
	  },
	
	  /**
	   * @return {Array.<Object>} [{
	   *     formattedLabel: string,
	   *     rawLabel: axis.scale.getLabel(tickValue)
	   *     tickValue: number
	   * }, ...]
	   */
	  getViewLabels: function () {
	    return createAxisLabels(this).labels;
	  },
	
	  /**
	   * @return {module:echarts/coord/model/Model}
	   */
	  getLabelModel: function () {
	    return this.model.getModel('axisLabel');
	  },
	
	  /**
	   * Notice here we only get the default tick model. For splitLine
	   * or splitArea, we should pass the splitLineModel or splitAreaModel
	   * manually when calling `getTicksCoords`.
	   * In GL, this method may be overrided to:
	   * `axisModel.getModel('axisTick', grid3DModel.getModel('axisTick'));`
	   * @return {module:echarts/coord/model/Model}
	   */
	  getTickModel: function () {
	    return this.model.getModel('axisTick');
	  },
	
	  /**
	   * Get width of band
	   * @return {number}
	   */
	  getBandWidth: function () {
	    var axisExtent = this._extent;
	    var dataExtent = this.scale.getExtent();
	    var len = dataExtent[1] - dataExtent[0] + (this.onBand ? 1 : 0); // Fix #2728, avoid NaN when only one data.
	
	    len === 0 && (len = 1);
	    var size = Math.abs(axisExtent[1] - axisExtent[0]);
	    return Math.abs(size) / len;
	  },
	
	  /**
	   * @abstract
	   * @return {boolean} Is horizontal
	   */
	  isHorizontal: null,
	
	  /**
	   * @abstract
	   * @return {number} Get axis rotate, by degree.
	   */
	  getRotate: null,
	
	  /**
	   * Only be called in category axis.
	   * Can be overrided, consider other axes like in 3D.
	   * @return {number} Auto interval for cateogry axis tick and label
	   */
	  calculateCategoryInterval: function () {
	    return calculateCategoryInterval(this);
	  }
	};
	
	function fixExtentWithBands(extent, nTick) {
	  var size = extent[1] - extent[0];
	  var len = nTick;
	  var margin = size / len / 2;
	  extent[0] += margin;
	  extent[1] -= margin;
	} // If axis has labels [1, 2, 3, 4]. Bands on the axis are
	// |---1---|---2---|---3---|---4---|.
	// So the displayed ticks and splitLine/splitArea should between
	// each data item, otherwise cause misleading (e.g., split tow bars
	// of a single data item when there are two bar series).
	// Also consider if tickCategoryInterval > 0 and onBand, ticks and
	// splitLine/spliteArea should layout appropriately corresponding
	// to displayed labels. (So we should not use `getBandWidth` in this
	// case).
	
	
	function fixOnBandTicksCoords(axis, ticksCoords, alignWithLabel, clamp) {
	  var ticksLen = ticksCoords.length;
	
	  if (!axis.onBand || alignWithLabel || !ticksLen) {
	    return;
	  }
	
	  var axisExtent = axis.getExtent();
	  var last;
	  var diffSize;
	
	  if (ticksLen === 1) {
	    ticksCoords[0].coord = axisExtent[0];
	    last = ticksCoords[1] = {
	      coord: axisExtent[0]
	    };
	  } else {
	    var crossLen = ticksCoords[ticksLen - 1].tickValue - ticksCoords[0].tickValue;
	    var shift = (ticksCoords[ticksLen - 1].coord - ticksCoords[0].coord) / crossLen;
	    each(ticksCoords, function (ticksItem) {
	      ticksItem.coord -= shift / 2;
	    });
	    var dataExtent = axis.scale.getExtent();
	    diffSize = 1 + dataExtent[1] - ticksCoords[ticksLen - 1].tickValue;
	    last = {
	      coord: ticksCoords[ticksLen - 1].coord + shift * diffSize
	    };
	    ticksCoords.push(last);
	  }
	
	  var inverse = axisExtent[0] > axisExtent[1]; // Handling clamp.
	
	  if (littleThan(ticksCoords[0].coord, axisExtent[0])) {
	    clamp ? ticksCoords[0].coord = axisExtent[0] : ticksCoords.shift();
	  }
	
	  if (clamp && littleThan(axisExtent[0], ticksCoords[0].coord)) {
	    ticksCoords.unshift({
	      coord: axisExtent[0]
	    });
	  }
	
	  if (littleThan(axisExtent[1], last.coord)) {
	    clamp ? last.coord = axisExtent[1] : ticksCoords.pop();
	  }
	
	  if (clamp && littleThan(last.coord, axisExtent[1])) {
	    ticksCoords.push({
	      coord: axisExtent[1]
	    });
	  }
	
	  function littleThan(a, b) {
	    // Avoid rounding error cause calculated tick coord different with extent.
	    // It may cause an extra unecessary tick added.
	    a = round(a);
	    b = round(b);
	    return inverse ? a > b : a < b;
	  }
	}
	
	var _default = Axis;
	module.exports = _default;

/***/ },
/* 180 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Language: (Simplified) Chinese.
	 */
	var _default = {
	  legend: {
	    selector: {
	      all: '全选',
	      inverse: '反选'
	    }
	  },
	  toolbox: {
	    brush: {
	      title: {
	        rect: '矩形选择',
	        polygon: '圈选',
	        lineX: '横向选择',
	        lineY: '纵向选择',
	        keep: '保持选择',
	        clear: '清除选择'
	      }
	    },
	    dataView: {
	      title: '数据视图',
	      lang: ['数据视图', '关闭', '刷新']
	    },
	    dataZoom: {
	      title: {
	        zoom: '区域缩放',
	        back: '区域缩放还原'
	      }
	    },
	    magicType: {
	      title: {
	        line: '切换为折线图',
	        bar: '切换为柱状图',
	        stack: '切换为堆叠',
	        tiled: '切换为平铺'
	      }
	    },
	    restore: {
	      title: '还原'
	    },
	    saveAsImage: {
	      title: '保存为图片',
	      lang: ['右键另存为图片']
	    }
	  },
	  series: {
	    typeNames: {
	      pie: '饼图',
	      bar: '柱状图',
	      line: '折线图',
	      scatter: '散点图',
	      effectScatter: '涟漪散点图',
	      radar: '雷达图',
	      tree: '树图',
	      treemap: '矩形树图',
	      boxplot: '箱型图',
	      candlestick: 'K线图',
	      k: 'K线图',
	      heatmap: '热力图',
	      map: '地图',
	      parallel: '平行坐标图',
	      lines: '线图',
	      graph: '关系图',
	      sankey: '桑基图',
	      funnel: '漏斗图',
	      gauge: '仪表盘图',
	      pictorialBar: '象形柱图',
	      themeRiver: '主题河流图',
	      sunburst: '旭日图'
	    }
	  },
	  aria: {
	    general: {
	      withTitle: '这是一个关于“{title}”的图表。',
	      withoutTitle: '这是一个图表，'
	    },
	    series: {
	      single: {
	        prefix: '',
	        withName: '图表类型是{seriesType}，表示{seriesName}。',
	        withoutName: '图表类型是{seriesType}。'
	      },
	      multiple: {
	        prefix: '它由{seriesCount}个图表系列组成。',
	        withName: '第{seriesId}个系列是一个表示{seriesName}的{seriesType}，',
	        withoutName: '第{seriesId}个系列是一个{seriesType}，',
	        separator: {
	          middle: '；',
	          end: '。'
	        }
	      }
	    },
	    data: {
	      allData: '其数据是——',
	      partialData: '其中，前{displayCnt}项是——',
	      withName: '{name}的数据是{value}',
	      withoutName: '{value}',
	      separator: {
	        middle: '，',
	        end: ''
	      }
	    }
	  }
	};
	module.exports = _default;

/***/ },
/* 181 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ORIGIN_METHOD = '\0__throttleOriginMethod';
	var RATE = '\0__throttleRate';
	var THROTTLE_TYPE = '\0__throttleType';
	/**
	 * @public
	 * @param {(Function)} fn
	 * @param {number} [delay=0] Unit: ms.
	 * @param {boolean} [debounce=false]
	 *        true: If call interval less than `delay`, only the last call works.
	 *        false: If call interval less than `delay, call works on fixed rate.
	 * @return {(Function)} throttled fn.
	 */
	
	function throttle(fn, delay, debounce) {
	  var currCall;
	  var lastCall = 0;
	  var lastExec = 0;
	  var timer = null;
	  var diff;
	  var scope;
	  var args;
	  var debounceNextCall;
	  delay = delay || 0;
	
	  function exec() {
	    lastExec = new Date().getTime();
	    timer = null;
	    fn.apply(scope, args || []);
	  }
	
	  var cb = function () {
	    currCall = new Date().getTime();
	    scope = this;
	    args = arguments;
	    var thisDelay = debounceNextCall || delay;
	    var thisDebounce = debounceNextCall || debounce;
	    debounceNextCall = null;
	    diff = currCall - (thisDebounce ? lastCall : lastExec) - thisDelay;
	    clearTimeout(timer); // Here we should make sure that: the `exec` SHOULD NOT be called later
	    // than a new call of `cb`, that is, preserving the command order. Consider
	    // calculating "scale rate" when roaming as an example. When a call of `cb`
	    // happens, either the `exec` is called dierectly, or the call is delayed.
	    // But the delayed call should never be later than next call of `cb`. Under
	    // this assurance, we can simply update view state each time `dispatchAction`
	    // triggered by user roaming, but not need to add extra code to avoid the
	    // state being "rolled-back".
	
	    if (thisDebounce) {
	      timer = setTimeout(exec, thisDelay);
	    } else {
	      if (diff >= 0) {
	        exec();
	      } else {
	        timer = setTimeout(exec, -diff);
	      }
	    }
	
	    lastCall = currCall;
	  };
	  /**
	   * Clear throttle.
	   * @public
	   */
	
	
	  cb.clear = function () {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  };
	  /**
	   * Enable debounce once.
	   */
	
	
	  cb.debounceNextCall = function (debounceDelay) {
	    debounceNextCall = debounceDelay;
	  };
	
	  return cb;
	}
	/**
	 * Create throttle method or update throttle rate.
	 *
	 * @example
	 * ComponentView.prototype.render = function () {
	 *     ...
	 *     throttle.createOrUpdate(
	 *         this,
	 *         '_dispatchAction',
	 *         this.model.get('throttle'),
	 *         'fixRate'
	 *     );
	 * };
	 * ComponentView.prototype.remove = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 * ComponentView.prototype.dispose = function () {
	 *     throttle.clear(this, '_dispatchAction');
	 * };
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 * @param {number} [rate]
	 * @param {string} [throttleType='fixRate'] 'fixRate' or 'debounce'
	 * @return {Function} throttled function.
	 */
	
	
	function createOrUpdate(obj, fnAttr, rate, throttleType) {
	  var fn = obj[fnAttr];
	
	  if (!fn) {
	    return;
	  }
	
	  var originFn = fn[ORIGIN_METHOD] || fn;
	  var lastThrottleType = fn[THROTTLE_TYPE];
	  var lastRate = fn[RATE];
	
	  if (lastRate !== rate || lastThrottleType !== throttleType) {
	    if (rate == null || !throttleType) {
	      return obj[fnAttr] = originFn;
	    }
	
	    fn = obj[fnAttr] = throttle(originFn, rate, throttleType === 'debounce');
	    fn[ORIGIN_METHOD] = originFn;
	    fn[THROTTLE_TYPE] = throttleType;
	    fn[RATE] = rate;
	  }
	
	  return fn;
	}
	/**
	 * Clear throttle. Example see throttle.createOrUpdate.
	 *
	 * @public
	 * @param {Object} obj
	 * @param {string} fnAttr
	 */
	
	
	function clear(obj, fnAttr) {
	  var fn = obj[fnAttr];
	
	  if (fn && fn[ORIGIN_METHOD]) {
	    obj[fnAttr] = fn[ORIGIN_METHOD];
	  }
	}
	
	exports.throttle = throttle;
	exports.createOrUpdate = createOrUpdate;
	exports.clear = clear;

/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.getQueryStringValueFromPath = exports.stripQueryStringValueFromPath = exports.addQueryStringValueToPath = undefined;
	
	var _warning = __webpack_require__(216);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var addQueryStringValueToPath = exports.addQueryStringValueToPath = function addQueryStringValueToPath(path, key, value) {
	  var _parsePath = parsePath(path),
	      pathname = _parsePath.pathname,
	      search = _parsePath.search,
	      hash = _parsePath.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search + (search.indexOf('?') === -1 ? '?' : '&') + key + '=' + value,
	    hash: hash
	  });
	};
	
	var stripQueryStringValueFromPath = exports.stripQueryStringValueFromPath = function stripQueryStringValueFromPath(path, key) {
	  var _parsePath2 = parsePath(path),
	      pathname = _parsePath2.pathname,
	      search = _parsePath2.search,
	      hash = _parsePath2.hash;
	
	  return createPath({
	    pathname: pathname,
	    search: search.replace(new RegExp('([?&])' + key + '=[a-zA-Z0-9]+(&?)'), function (match, prefix, suffix) {
	      return prefix === '?' ? prefix : suffix;
	    }),
	    hash: hash
	  });
	};
	
	var getQueryStringValueFromPath = exports.getQueryStringValueFromPath = function getQueryStringValueFromPath(path, key) {
	  var _parsePath3 = parsePath(path),
	      search = _parsePath3.search;
	
	  var match = search.match(new RegExp('[?&]' + key + '=([a-zA-Z0-9]+)'));
	  return match && match[1];
	};
	
	var extractPath = function extractPath(string) {
	  var match = string.match(/^(https?:)?\/\/[^\/]*/);
	  return match == null ? string : string.substring(match[0].length);
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = extractPath(path);
	  var search = '';
	  var hash = '';
	
	   false ? (0, _warning2.default)(path === pathname, 'A path must be pathname + search + hash only, not a full URL like "%s"', path) : void 0;
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substring(hashIndex);
	    pathname = pathname.substring(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substring(searchIndex);
	    pathname = pathname.substring(0, searchIndex);
	  }
	
	  if (pathname === '') pathname = '/';
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  if (location == null || typeof location === 'string') return location;
	
	  var basename = location.basename,
	      pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	  var path = (basename || '') + pathname;
	
	  if (search && search !== '?') path += search;
	
	  if (hash) path += hash;
	
	  return path;
	};

/***/ },
/* 183 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 184 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _contains = __webpack_require__(383);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(145);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _ContainerRender = __webpack_require__(567);
	
	var _ContainerRender2 = _interopRequireDefault(_ContainerRender);
	
	var _Portal = __webpack_require__(569);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _utils = __webpack_require__(1120);
	
	var _Popup = __webpack_require__(2768);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument() {
	  return window.document;
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
	
	var IS_REACT_16 = !!_reactDom.createPortal;
	
	var contextTypes = {
	  rcTrigger: _propTypes2['default'].shape({
	    onPopupMouseDown: _propTypes2['default'].func
	  })
	};
	
	var Trigger = function (_React$Component) {
	  (0, _inherits3['default'])(Trigger, _React$Component);
	
	  function Trigger(props) {
	    (0, _classCallCheck3['default'])(this, Trigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	
	    _this.state = {
	      prevPopupVisible: popupVisible,
	      popupVisible: popupVisible
	    };
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	    return _this;
	  }
	
	  Trigger.prototype.getChildContext = function getChildContext() {
	    return {
	      rcTrigger: {
	        onPopupMouseDown: this.onPopupMouseDown
	      }
	    };
	  };
	
	  Trigger.prototype.componentDidMount = function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  };
	
	  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    };
	    if (!IS_REACT_16) {
	      this.renderComponent(null, triggerAfterPopupVisibleChange);
	    }
	
	    // We must listen to `mousedown` or `touchstart`, edge case:
	    // https://github.com/ant-design/ant-design/issues/5804
	    // https://github.com/react-component/calendar/issues/250
	    // https://github.com/react-component/trigger/issues/50
	    if (state.popupVisible) {
	      var currentDocument = void 0;
	      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
	        currentDocument = props.getDocument();
	        this.clickOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'mousedown', this.onDocumentClick);
	      }
	      // always hide on mobile
	      if (!this.touchOutsideHandler) {
	        currentDocument = currentDocument || props.getDocument();
	        this.touchOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'touchstart', this.onDocumentClick);
	      }
	      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
	      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
	        currentDocument = currentDocument || props.getDocument();
	        this.contextMenuOutsideHandler1 = (0, _addEventListener2['default'])(currentDocument, 'scroll', this.onContextMenuClose);
	      }
	      // close popup when trigger type contains 'onContextMenu' and window is blur.
	      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
	        this.contextMenuOutsideHandler2 = (0, _addEventListener2['default'])(window, 'blur', this.onContextMenuClose);
	      }
	      return;
	    }
	
	    this.clearOutsideHandler();
	  };
	
	  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearDelayTimer();
	    this.clearOutsideHandler();
	    clearTimeout(this.mouseDownTimeout);
	  };
	
	  Trigger.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var popupVisible = _ref.popupVisible;
	
	    var newState = {};
	
	    if (popupVisible !== undefined && prevState.popupVisible !== popupVisible) {
	      newState.popupVisible = popupVisible;
	      newState.prevPopupVisible = prevState.popupVisible;
	    }
	
	    return newState;
	  };
	
	  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
	    // for test
	    if (this._component && this._component.getPopupDomNode) {
	      return this._component.getPopupDomNode();
	    }
	    return null;
	  };
	
	  Trigger.prototype.getPopupAlign = function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  };
	
	  /**
	   * @param popupVisible    Show or not the popup element
	   * @param event           SyntheticEvent, used for `pointAlign`
	   */
	  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
	    var alignPoint = this.props.alignPoint;
	    var prevPopupVisible = this.state.popupVisible;
	
	
	    this.clearDelayTimer();
	
	    if (prevPopupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({ popupVisible: popupVisible, prevPopupVisible: prevPopupVisible });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	
	    // Always record the point position since mouseEnterDelay will delay the show
	    if (alignPoint && event) {
	      this.setPoint(event);
	    }
	  };
	
	  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible, point);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible, event);
	    }
	  };
	
	  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  };
	
	  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	    }
	
	    if (this.contextMenuOutsideHandler1) {
	      this.contextMenuOutsideHandler1.remove();
	      this.contextMenuOutsideHandler1 = null;
	    }
	
	    if (this.contextMenuOutsideHandler2) {
	      this.contextMenuOutsideHandler2.remove();
	      this.contextMenuOutsideHandler2 = null;
	    }
	
	    if (this.touchOutsideHandler) {
	      this.touchOutsideHandler.remove();
	      this.touchOutsideHandler = null;
	    }
	  };
	
	  Trigger.prototype.createTwoChains = function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  };
	
	  Trigger.prototype.isClickToShow = function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
	    var _props2 = this.props,
	        action = _props2.action,
	        showAction = _props2.showAction;
	
	    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
	  };
	
	  Trigger.prototype.isClickToHide = function isClickToHide() {
	    var _props3 = this.props,
	        action = _props3.action,
	        hideAction = _props3.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
	    var _props4 = this.props,
	        action = _props4.action,
	        showAction = _props4.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  };
	
	  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
	    var _props5 = this.props,
	        action = _props5.action,
	        hideAction = _props5.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  };
	
	  Trigger.prototype.isFocusToShow = function isFocusToShow() {
	    var _props6 = this.props,
	        action = _props6.action,
	        showAction = _props6.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  };
	
	  Trigger.prototype.isBlurToHide = function isBlurToHide() {
	    var _props7 = this.props,
	        action = _props7.action,
	        hideAction = _props7.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  };
	
	  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
	    if (this.state.popupVisible && this._component && this._component.alignInstance) {
	      this._component.alignInstance.forceAlign();
	    }
	  };
	
	  Trigger.prototype.fireEvents = function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  };
	
	  Trigger.prototype.close = function close() {
	    this.setPopupVisible(false);
	  };
	
	  Trigger.prototype.render = function render() {
	    var _this3 = this;
	
	    var popupVisible = this.state.popupVisible;
	    var _props8 = this.props,
	        children = _props8.children,
	        forceRender = _props8.forceRender,
	        alignPoint = _props8.alignPoint,
	        className = _props8.className;
	
	    var child = _react2['default'].Children.only(children);
	    var newChildProps = { key: 'trigger' };
	
	    if (this.isContextMenuToShow()) {
	      newChildProps.onContextMenu = this.onContextMenu;
	    } else {
	      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
	    }
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	      if (alignPoint) {
	        newChildProps.onMouseMove = this.onMouseMove;
	      }
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    var childrenClassName = (0, _classnames2['default'])(child && child.props && child.props.className, className);
	    if (childrenClassName) {
	      newChildProps.className = childrenClassName;
	    }
	    var trigger = _react2['default'].cloneElement(child, newChildProps);
	
	    if (!IS_REACT_16) {
	      return _react2['default'].createElement(
	        _ContainerRender2['default'],
	        {
	          parent: this,
	          visible: popupVisible,
	          autoMount: false,
	          forceRender: forceRender,
	          getComponent: this.getComponent,
	          getContainer: this.getContainer
	        },
	        function (_ref2) {
	          var renderComponent = _ref2.renderComponent;
	
	          _this3.renderComponent = renderComponent;
	          return trigger;
	        }
	      );
	    }
	
	    var portal = void 0;
	    // prevent unmounting after it's rendered
	    if (popupVisible || this._component || forceRender) {
	      portal = _react2['default'].createElement(
	        _Portal2['default'],
	        { key: 'portal', getContainer: this.getContainer, didUpdate: this.handlePortalUpdate },
	        this.getComponent()
	      );
	    }
	
	    return [trigger, portal];
	  };
	
	  return Trigger;
	}(_react2['default'].Component);
	
	Trigger.propTypes = {
	  children: _propTypes2['default'].any,
	  action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  showAction: _propTypes2['default'].any,
	  hideAction: _propTypes2['default'].any,
	  getPopupClassNameFromAlign: _propTypes2['default'].any,
	  onPopupVisibleChange: _propTypes2['default'].func,
	  afterPopupVisibleChange: _propTypes2['default'].func,
	  popup: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  popupStyle: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  popupPlacement: _propTypes2['default'].string,
	  builtinPlacements: _propTypes2['default'].object,
	  popupTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  popupAnimation: _propTypes2['default'].any,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  zIndex: _propTypes2['default'].number,
	  focusDelay: _propTypes2['default'].number,
	  blurDelay: _propTypes2['default'].number,
	  getPopupContainer: _propTypes2['default'].func,
	  getDocument: _propTypes2['default'].func,
	  forceRender: _propTypes2['default'].bool,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  mask: _propTypes2['default'].bool,
	  maskClosable: _propTypes2['default'].bool,
	  onPopupAlign: _propTypes2['default'].func,
	  popupAlign: _propTypes2['default'].object,
	  popupVisible: _propTypes2['default'].bool,
	  defaultPopupVisible: _propTypes2['default'].bool,
	  maskTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  maskAnimation: _propTypes2['default'].string,
	  stretch: _propTypes2['default'].string,
	  alignPoint: _propTypes2['default'].bool // Maybe we can support user pass position in the future
	};
	Trigger.contextTypes = contextTypes;
	Trigger.childContextTypes = contextTypes;
	Trigger.defaultProps = {
	  prefixCls: 'rc-trigger-popup',
	  getPopupClassNameFromAlign: returnEmptyString,
	  getDocument: returnDocument,
	  onPopupVisibleChange: noop,
	  afterPopupVisibleChange: noop,
	  onPopupAlign: noop,
	  popupClassName: '',
	  mouseEnterDelay: 0,
	  mouseLeaveDelay: 0.1,
	  focusDelay: 0,
	  blurDelay: 0.15,
	  popupStyle: {},
	  destroyPopupOnHide: false,
	  popupAlign: {},
	  defaultPopupVisible: false,
	  mask: false,
	  maskClosable: true,
	  action: [],
	  showAction: [],
	  hideAction: []
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.onMouseEnter = function (e) {
	    var mouseEnterDelay = _this4.props.mouseEnterDelay;
	
	    _this4.fireEvents('onMouseEnter', e);
	    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
	  };
	
	  this.onMouseMove = function (e) {
	    _this4.fireEvents('onMouseMove', e);
	    _this4.setPoint(e);
	  };
	
	  this.onMouseLeave = function (e) {
	    _this4.fireEvents('onMouseLeave', e);
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onPopupMouseEnter = function () {
	    _this4.clearDelayTimer();
	  };
	
	  this.onPopupMouseLeave = function (e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && (0, _contains2['default'])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onFocus = function (e) {
	    _this4.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    _this4.clearDelayTimer();
	    if (_this4.isFocusToShow()) {
	      _this4.focusTime = Date.now();
	      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
	    }
	  };
	
	  this.onMouseDown = function (e) {
	    _this4.fireEvents('onMouseDown', e);
	    _this4.preClickTime = Date.now();
	  };
	
	  this.onTouchStart = function (e) {
	    _this4.fireEvents('onTouchStart', e);
	    _this4.preTouchTime = Date.now();
	  };
	
	  this.onBlur = function (e) {
	    _this4.fireEvents('onBlur', e);
	    _this4.clearDelayTimer();
	    if (_this4.isBlurToHide()) {
	      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
	    }
	  };
	
	  this.onContextMenu = function (e) {
	    e.preventDefault();
	    _this4.fireEvents('onContextMenu', e);
	    _this4.setPopupVisible(true, e);
	  };
	
	  this.onContextMenuClose = function () {
	    if (_this4.isContextMenuToShow()) {
	      _this4.close();
	    }
	  };
	
	  this.onClick = function (event) {
	    _this4.fireEvents('onClick', event);
	    // focus will trigger click
	    if (_this4.focusTime) {
	      var preTime = void 0;
	      if (_this4.preClickTime && _this4.preTouchTime) {
	        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
	      } else if (_this4.preClickTime) {
	        preTime = _this4.preClickTime;
	      } else if (_this4.preTouchTime) {
	        preTime = _this4.preTouchTime;
	      }
	      if (Math.abs(preTime - _this4.focusTime) < 20) {
	        return;
	      }
	      _this4.focusTime = 0;
	    }
	    _this4.preClickTime = 0;
	    _this4.preTouchTime = 0;
	
	    // Only prevent default when all the action is click.
	    // https://github.com/ant-design/ant-design/issues/17043
	    // https://github.com/ant-design/ant-design/issues/17291
	    if (_this4.isClickToShow() && (_this4.isClickToHide() || _this4.isBlurToHide()) && event && event.preventDefault) {
	      event.preventDefault();
	    }
	    var nextVisible = !_this4.state.popupVisible;
	    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
	      _this4.setPopupVisible(!_this4.state.popupVisible, event);
	    }
	  };
	
	  this.onPopupMouseDown = function () {
	    var _context$rcTrigger = _this4.context.rcTrigger,
	        rcTrigger = _context$rcTrigger === undefined ? {} : _context$rcTrigger;
	
	    _this4.hasPopupMouseDown = true;
	
	    clearTimeout(_this4.mouseDownTimeout);
	    _this4.mouseDownTimeout = setTimeout(function () {
	      _this4.hasPopupMouseDown = false;
	    }, 0);
	
	    if (rcTrigger.onPopupMouseDown) {
	      rcTrigger.onPopupMouseDown.apply(rcTrigger, arguments);
	    }
	  };
	
	  this.onDocumentClick = function (event) {
	    if (_this4.props.mask && !_this4.props.maskClosable) {
	      return;
	    }
	
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(_this4);
	    if (!(0, _contains2['default'])(root, target) && !_this4.hasPopupMouseDown) {
	      _this4.close();
	    }
	  };
	
	  this.getRootDomNode = function () {
	    return (0, _reactDom.findDOMNode)(_this4);
	  };
	
	  this.getPopupClassNameFromAlign = function (align) {
	    var className = [];
	    var _props9 = _this4.props,
	        popupPlacement = _props9.popupPlacement,
	        builtinPlacements = _props9.builtinPlacements,
	        prefixCls = _props9.prefixCls,
	        alignPoint = _props9.alignPoint,
	        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
	    }
	    if (getPopupClassNameFromAlign) {
	      className.push(getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  };
	
	  this.getComponent = function () {
	    var _props10 = _this4.props,
	        prefixCls = _props10.prefixCls,
	        destroyPopupOnHide = _props10.destroyPopupOnHide,
	        popupClassName = _props10.popupClassName,
	        action = _props10.action,
	        onPopupAlign = _props10.onPopupAlign,
	        popupAnimation = _props10.popupAnimation,
	        popupTransitionName = _props10.popupTransitionName,
	        popupStyle = _props10.popupStyle,
	        mask = _props10.mask,
	        maskAnimation = _props10.maskAnimation,
	        maskTransitionName = _props10.maskTransitionName,
	        zIndex = _props10.zIndex,
	        popup = _props10.popup,
	        stretch = _props10.stretch,
	        alignPoint = _props10.alignPoint;
	    var _state = _this4.state,
	        popupVisible = _state.popupVisible,
	        point = _state.point;
	
	
	    var align = _this4.getPopupAlign();
	
	    var mouseProps = {};
	    if (_this4.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
	    }
	    if (_this4.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
	    }
	
	    mouseProps.onMouseDown = _this4.onPopupMouseDown;
	    mouseProps.onTouchStart = _this4.onPopupMouseDown;
	
	    return _react2['default'].createElement(
	      _Popup2['default'],
	      (0, _extends3['default'])({
	        prefixCls: prefixCls,
	        destroyPopupOnHide: destroyPopupOnHide,
	        visible: popupVisible,
	        point: alignPoint && point,
	        className: popupClassName,
	        action: action,
	        align: align,
	        onAlign: onPopupAlign,
	        animation: popupAnimation,
	        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
	      }, mouseProps, {
	        stretch: stretch,
	        getRootDomNode: _this4.getRootDomNode,
	        style: popupStyle,
	        mask: mask,
	        zIndex: zIndex,
	        transitionName: popupTransitionName,
	        maskAnimation: maskAnimation,
	        maskTransitionName: maskTransitionName,
	        ref: _this4.savePopup
	      }),
	      typeof popup === 'function' ? popup() : popup
	    );
	  };
	
	  this.getContainer = function () {
	    var props = _this4.props;
	
	    var popupContainer = document.createElement('div');
	    // Make sure default popup container will never cause scrollbar appearing
	    // https://github.com/react-component/trigger/issues/41
	    popupContainer.style.position = 'absolute';
	    popupContainer.style.top = '0';
	    popupContainer.style.left = '0';
	    popupContainer.style.width = '100%';
	    var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(_this4)) : props.getDocument().body;
	    mountNode.appendChild(popupContainer);
	    return popupContainer;
	  };
	
	  this.setPoint = function (point) {
	    var alignPoint = _this4.props.alignPoint;
	
	    if (!alignPoint || !point) return;
	
	    _this4.setState({
	      point: {
	        pageX: point.pageX,
	        pageY: point.pageY
	      }
	    });
	  };
	
	  this.handlePortalUpdate = function () {
	    if (_this4.state.prevPopupVisible !== _this4.state.popupVisible) {
	      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
	    }
	  };
	
	  this.savePopup = function (node) {
	    _this4._component = node;
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Trigger);
	
	exports['default'] = Trigger;
	module.exports = exports['default'];

/***/ },
/* 186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.isReactChildren = isReactChildren;
	exports.createRouteFromReactElement = createRouteFromReactElement;
	exports.createRoutesFromReactChildren = createRoutesFromReactChildren;
	exports.createRoutes = createRoutes;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isValidChild(object) {
	  return object == null || _react2.default.isValidElement(object);
	}
	
	function isReactChildren(object) {
	  return isValidChild(object) || Array.isArray(object) && object.every(isValidChild);
	}
	
	function createRoute(defaultProps, props) {
	  return _extends({}, defaultProps, props);
	}
	
	function createRouteFromReactElement(element) {
	  var type = element.type;
	  var route = createRoute(type.defaultProps, element.props);
	
	  if (route.children) {
	    var childRoutes = createRoutesFromReactChildren(route.children, route);
	
	    if (childRoutes.length) route.childRoutes = childRoutes;
	
	    delete route.children;
	  }
	
	  return route;
	}
	
	/**
	 * Creates and returns a routes object from the given ReactChildren. JSX
	 * provides a convenient way to visualize how routes in the hierarchy are
	 * nested.
	 *
	 *   import { Route, createRoutesFromReactChildren } from 'react-router'
	 *
	 *   const routes = createRoutesFromReactChildren(
	 *     <Route component={App}>
	 *       <Route path="home" component={Dashboard}/>
	 *       <Route path="news" component={NewsFeed}/>
	 *     </Route>
	 *   )
	 *
	 * Note: This method is automatically used when you provide <Route> children
	 * to a <Router> component.
	 */
	function createRoutesFromReactChildren(children, parentRoute) {
	  var routes = [];
	
	  _react2.default.Children.forEach(children, function (element) {
	    if (_react2.default.isValidElement(element)) {
	      // Component classes may have a static create* method.
	      if (element.type.createRouteFromReactElement) {
	        var route = element.type.createRouteFromReactElement(element, parentRoute);
	
	        if (route) routes.push(route);
	      } else {
	        routes.push(createRouteFromReactElement(element));
	      }
	    }
	  });
	
	  return routes;
	}
	
	/**
	 * Creates and returns an array of routes from the given object which
	 * may be a JSX route, a plain object route, or an array of either.
	 */
	function createRoutes(routes) {
	  if (isReactChildren(routes)) {
	    routes = createRoutesFromReactChildren(routes);
	  } else if (routes && !Array.isArray(routes)) {
	    routes = [routes];
	  }
	
	  return routes;
	}

/***/ },
/* 187 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 188 */
/***/ function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(55);
	
	var v2Create = _vector.create;
	var v2DistSquare = _vector.distSquare;
	
	/**
	 * 曲线辅助模块
	 * @module zrender/core/curve
	 * @author pissang(https://www.github.com/pissang)
	 */
	var mathPow = Math.pow;
	var mathSqrt = Math.sqrt;
	var EPSILON = 1e-8;
	var EPSILON_NUMERIC = 1e-4;
	var THREE_SQRT = mathSqrt(3);
	var ONE_THIRD = 1 / 3; // 临时变量
	
	var _v0 = v2Create();
	
	var _v1 = v2Create();
	
	var _v2 = v2Create();
	
	function isAroundZero(val) {
	  return val > -EPSILON && val < EPSILON;
	}
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * 计算三次贝塞尔值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return onet * onet * (onet * p0 + 3 * t * p1) + t * t * (t * p3 + 3 * onet * p2);
	}
	/**
	 * 计算三次贝塞尔导数值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function cubicDerivativeAt(p0, p1, p2, p3, t) {
	  var onet = 1 - t;
	  return 3 * (((p1 - p0) * onet + 2 * (p2 - p1) * t) * onet + (p3 - p2) * t * t);
	}
	/**
	 * 计算三次贝塞尔方程根，使用盛金公式
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} val
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function cubicRootAt(p0, p1, p2, p3, val, roots) {
	  // Evaluate roots of cubic functions
	  var a = p3 + 3 * (p1 - p2) - p0;
	  var b = 3 * (p2 - p1 * 2 + p0);
	  var c = 3 * (p1 - p0);
	  var d = p0 - val;
	  var A = b * b - 3 * a * c;
	  var B = b * c - 9 * a * d;
	  var C = c * c - 3 * b * d;
	  var n = 0;
	
	  if (isAroundZero(A) && isAroundZero(B)) {
	    if (isAroundZero(b)) {
	      roots[0] = 0;
	    } else {
	      var t1 = -c / b; //t1, t2, t3, b is not zero
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = B * B - 4 * A * C;
	
	    if (isAroundZero(disc)) {
	      var K = B / A;
	      var t1 = -b / a + K; // t1, a is not zero
	
	      var t2 = -K / 2; // t2, t3
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var Y1 = A * b + 1.5 * a * (-B + discSqrt);
	      var Y2 = A * b + 1.5 * a * (-B - discSqrt);
	
	      if (Y1 < 0) {
	        Y1 = -mathPow(-Y1, ONE_THIRD);
	      } else {
	        Y1 = mathPow(Y1, ONE_THIRD);
	      }
	
	      if (Y2 < 0) {
	        Y2 = -mathPow(-Y2, ONE_THIRD);
	      } else {
	        Y2 = mathPow(Y2, ONE_THIRD);
	      }
	
	      var t1 = (-b - (Y1 + Y2)) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else {
	      var T = (2 * A * b - 3 * a * B) / (2 * mathSqrt(A * A * A));
	      var theta = Math.acos(T) / 3;
	      var ASqrt = mathSqrt(A);
	      var tmp = Math.cos(theta);
	      var t1 = (-b - 2 * ASqrt * tmp) / (3 * a);
	      var t2 = (-b + ASqrt * (tmp + THREE_SQRT * Math.sin(theta))) / (3 * a);
	      var t3 = (-b + ASqrt * (tmp - THREE_SQRT * Math.sin(theta))) / (3 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	
	      if (t3 >= 0 && t3 <= 1) {
	        roots[n++] = t3;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算三次贝塞尔方程极限值的位置
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {Array.<number>} extrema
	 * @return {number} 有效数目
	 */
	
	
	function cubicExtrema(p0, p1, p2, p3, extrema) {
	  var b = 6 * p2 - 12 * p1 + 6 * p0;
	  var a = 9 * p1 + 3 * p3 - 3 * p0 - 9 * p2;
	  var c = 3 * p1 - 3 * p0;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      extrema[0] = -b / (2 * a);
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        extrema[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        extrema[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 细分三次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function cubicSubdivide(p0, p1, p2, p3, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p23 = (p3 - p2) * t + p2;
	  var p012 = (p12 - p01) * t + p01;
	  var p123 = (p23 - p12) * t + p12;
	  var p0123 = (p123 - p012) * t + p012; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012;
	  out[3] = p0123; // Seg1
	
	  out[4] = p0123;
	  out[5] = p123;
	  out[6] = p23;
	  out[7] = p3;
	}
	/**
	 * 投射点到三次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} [out] 投射点
	 * @return {number}
	 */
	
	
	function cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  var prev;
	  var next;
	  var d1;
	  var d2;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = cubicAt(x0, x1, x2, x3, _t);
	    _v1[1] = cubicAt(y0, y1, y2, y3, _t);
	    d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    prev = t - interval;
	    next = t + interval; // t - interval
	
	    _v1[0] = cubicAt(x0, x1, x2, x3, prev);
	    _v1[1] = cubicAt(y0, y1, y2, y3, prev);
	    d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = cubicAt(x0, x1, x2, x3, next);
	      _v2[1] = cubicAt(y0, y1, y2, y3, next);
	      d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = cubicAt(x0, x1, x2, x3, t);
	    out[1] = cubicAt(y0, y1, y2, y3, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	/**
	 * 计算二次方贝塞尔值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticAt(p0, p1, p2, t) {
	  var onet = 1 - t;
	  return onet * (onet * p0 + 2 * t * p1) + t * t * p2;
	}
	/**
	 * 计算二次方贝塞尔导数值
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @return {number}
	 */
	
	
	function quadraticDerivativeAt(p0, p1, p2, t) {
	  return 2 * ((1 - t) * (p1 - p0) + t * (p2 - p1));
	}
	/**
	 * 计算二次方贝塞尔方程根
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} roots
	 * @return {number} 有效根数目
	 */
	
	
	function quadraticRootAt(p0, p1, p2, val, roots) {
	  var a = p0 - 2 * p1 + p2;
	  var b = 2 * (p1 - p0);
	  var c = p0 - val;
	  var n = 0;
	
	  if (isAroundZero(a)) {
	    if (isNotAroundZero(b)) {
	      var t1 = -c / b;
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    }
	  } else {
	    var disc = b * b - 4 * a * c;
	
	    if (isAroundZero(disc)) {
	      var t1 = -b / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	    } else if (disc > 0) {
	      var discSqrt = mathSqrt(disc);
	      var t1 = (-b + discSqrt) / (2 * a);
	      var t2 = (-b - discSqrt) / (2 * a);
	
	      if (t1 >= 0 && t1 <= 1) {
	        roots[n++] = t1;
	      }
	
	      if (t2 >= 0 && t2 <= 1) {
	        roots[n++] = t2;
	      }
	    }
	  }
	
	  return n;
	}
	/**
	 * 计算二次贝塞尔方程极限值
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @return {number}
	 */
	
	
	function quadraticExtremum(p0, p1, p2) {
	  var divider = p0 + p2 - 2 * p1;
	
	  if (divider === 0) {
	    // p1 is center of p0 and p2
	    return 0.5;
	  } else {
	    return (p0 - p1) / divider;
	  }
	}
	/**
	 * 细分二次贝塞尔曲线
	 * @memberOf module:zrender/core/curve
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} t
	 * @param  {Array.<number>} out
	 */
	
	
	function quadraticSubdivide(p0, p1, p2, t, out) {
	  var p01 = (p1 - p0) * t + p0;
	  var p12 = (p2 - p1) * t + p1;
	  var p012 = (p12 - p01) * t + p01; // Seg0
	
	  out[0] = p0;
	  out[1] = p01;
	  out[2] = p012; // Seg1
	
	  out[3] = p012;
	  out[4] = p12;
	  out[5] = p2;
	}
	/**
	 * 投射点到二次贝塞尔曲线上，返回投射距离。
	 * 投射点有可能会有一个或者多个，这里只返回其中距离最短的一个。
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x
	 * @param {number} y
	 * @param {Array.<number>} out 投射点
	 * @return {number}
	 */
	
	
	function quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, out) {
	  // http://pomax.github.io/bezierinfo/#projections
	  var t;
	  var interval = 0.005;
	  var d = Infinity;
	  _v0[0] = x;
	  _v0[1] = y; // 先粗略估计一下可能的最小距离的 t 值
	  // PENDING
	
	  for (var _t = 0; _t < 1; _t += 0.05) {
	    _v1[0] = quadraticAt(x0, x1, x2, _t);
	    _v1[1] = quadraticAt(y0, y1, y2, _t);
	    var d1 = v2DistSquare(_v0, _v1);
	
	    if (d1 < d) {
	      t = _t;
	      d = d1;
	    }
	  }
	
	  d = Infinity; // At most 32 iteration
	
	  for (var i = 0; i < 32; i++) {
	    if (interval < EPSILON_NUMERIC) {
	      break;
	    }
	
	    var prev = t - interval;
	    var next = t + interval; // t - interval
	
	    _v1[0] = quadraticAt(x0, x1, x2, prev);
	    _v1[1] = quadraticAt(y0, y1, y2, prev);
	    var d1 = v2DistSquare(_v1, _v0);
	
	    if (prev >= 0 && d1 < d) {
	      t = prev;
	      d = d1;
	    } else {
	      // t + interval
	      _v2[0] = quadraticAt(x0, x1, x2, next);
	      _v2[1] = quadraticAt(y0, y1, y2, next);
	      var d2 = v2DistSquare(_v2, _v0);
	
	      if (next <= 1 && d2 < d) {
	        t = next;
	        d = d2;
	      } else {
	        interval *= 0.5;
	      }
	    }
	  } // t
	
	
	  if (out) {
	    out[0] = quadraticAt(x0, x1, x2, t);
	    out[1] = quadraticAt(y0, y1, y2, t);
	  } // console.log(interval, i);
	
	
	  return mathSqrt(d);
	}
	
	exports.cubicAt = cubicAt;
	exports.cubicDerivativeAt = cubicDerivativeAt;
	exports.cubicRootAt = cubicRootAt;
	exports.cubicExtrema = cubicExtrema;
	exports.cubicSubdivide = cubicSubdivide;
	exports.cubicProjectPoint = cubicProjectPoint;
	exports.quadraticAt = quadraticAt;
	exports.quadraticDerivativeAt = quadraticDerivativeAt;
	exports.quadraticRootAt = quadraticRootAt;
	exports.quadraticExtremum = quadraticExtremum;
	exports.quadraticSubdivide = quadraticSubdivide;
	exports.quadraticProjectPoint = quadraticProjectPoint;

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _button = _interopRequireDefault(__webpack_require__(1243));
	
	var _buttonGroup = _interopRequireDefault(__webpack_require__(1242));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_button["default"].Group = _buttonGroup["default"];
	var _default = _button["default"];
	exports["default"] = _default;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryDownloadFundRecordTemplate = exports.queryFundsRecordIncome = exports.querySaveFundsRecordRelate = exports.queryImportFundsRecord = exports.querySaveFundsRecord = exports.queryFundsRecordInfo = exports.queryFundsRecordList = exports.queryStatisticsFundsBook = exports.queryDeleteFundsBook = exports.queryDisableFundsBook = exports.queryEnableFundsBook = exports.querySaveFundsBook = exports.queryFundsBookInfo = exports.queryFundsBookAllList = exports.queryFundsBookList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 获取资金帐号列表
	 */
	var queryFundsBookList = exports.queryFundsBookList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.finance.FUNDS_BOOK_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryFundsBookList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取全部资金帐号列表
	 * @param {} params
	 * @returns {}
	 */
	
	
	var queryFundsBookAllList = exports.queryFundsBookAllList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.finance.FUNDS_BOOK_LIST_ALL, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryFundsBookAllList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取资金帐号明细
	 * @param {} uuid
	 * @returns {}
	 */
	
	
	var queryFundsBookInfo = exports.queryFundsBookInfo = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(uuid) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.finance.FUNDS_BOOK_INFO, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryFundsBookInfo(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	/**
	 * 保存资金帐号
	 * @param {} params
	 * @returns {}
	 */
	
	
	var querySaveFundsBook = exports.querySaveFundsBook = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.post(_req.finance.FUNDS_BOOK_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function querySaveFundsBook(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	/**
	 * 启用资金账户
	 * @param {} uuid
	 * @returns {}
	 */
	
	
	var queryEnableFundsBook = exports.queryEnableFundsBook = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(uuid) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.finance.FUNDS_BOOK_ENABLE, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryEnableFundsBook(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	/**
	 * 禁用资金帐户
	 * @param {} uuid
	 * @returns {}
	 */
	
	
	var queryDisableFundsBook = exports.queryDisableFundsBook = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(uuid) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.finance.FUNDS_BOOK_DISABLE, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryDisableFundsBook(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	/**
	 * 删除资金帐号
	 * @param {} uuid
	 * @returns {}
	 */
	
	
	var queryDeleteFundsBook = exports.queryDeleteFundsBook = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(uuid) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.finance.FUNDS_BOOK_DELETE, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryDeleteFundsBook(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	/**
	 * 资金帐号统计
	 * @param {} uuid
	 * @returns {}
	 */
	
	
	var queryStatisticsFundsBook = exports.queryStatisticsFundsBook = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(uuid) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.finance.FUNDS_BOOK_STATISTICS, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryStatisticsFundsBook(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取资金帐号流水
	 * @param {} params
	 * @returns {}
	 */
	
	
	var queryFundsRecordList = exports.queryFundsRecordList = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.finance.FUNDS_RECORD_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryFundsRecordList(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取资金帐号流水明细
	 * @param {} uuid
	 * @returns {}
	 */
	
	
	var queryFundsRecordInfo = exports.queryFundsRecordInfo = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(uuid) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.finance.FUNDS_RECORD_INFO, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryFundsRecordInfo(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	/**
	 * 保存资金帐号流水
	 * @param {} params
	 * @returns {}
	 */
	
	
	var querySaveFundsRecord = exports.querySaveFundsRecord = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.post(_req.finance.FUNDS_RECORD_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function querySaveFundsRecord(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	/**
	 * 资金帐号流水导入
	 * @param {} params
	 * @returns {}
	 */
	
	
	var queryImportFundsRecord = exports.queryImportFundsRecord = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.post(_req.finance.FUNDS_RECORD_IMPORT, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryImportFundsRecord(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	/**
	 * 资金记录关联银行流水
	 * @param {} params
	 * @returns {}
	 */
	
	
	var querySaveFundsRecordRelate = exports.querySaveFundsRecordRelate = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.post(_req.finance.FUNDS_RECORD_RELATE, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function querySaveFundsRecordRelate(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	/**
	 * 未关联的资金记录
	 * @param {} params
	 * @returns {}
	 */
	
	
	var queryFundsRecordIncome = exports.queryFundsRecordIncome = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.finance.FUNDS_RECORD_INCOME, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryFundsRecordIncome(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var queryDownloadFundRecordTemplate = exports.queryDownloadFundRecordTemplate = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15() {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            _http2.default.download(_req.finance.DOWNLOAD_FUNDS_RECORD_TEMPLATE, {}, '资金帐号模板.xls');
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function queryDownloadFundRecordTemplate() {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryHrListByWorkOrg = exports.queryDeletesWorkOrgHr = exports.queryDeleteWorkOrgHr = exports.querySaveWorkOrgHr = exports.queryDeleteWorkOrg = exports.queryAddWorkOrg = exports.queryWorkOrgList = exports.queryWorkOrg = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var queryWorkOrg = exports.queryWorkOrg = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.hr.HR_WORKORG_SEARCH, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryWorkOrg(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryWorkOrgList = exports.queryWorkOrgList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.hr.HR_WORKORG_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryWorkOrgList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryAddWorkOrg = exports.queryAddWorkOrg = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.post(_req.hr.HR_WORKORG_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryAddWorkOrg(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryDeleteWorkOrg = exports.queryDeleteWorkOrg = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.hr.HR_WORKORG_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryDeleteWorkOrg(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var querySaveWorkOrgHr = exports.querySaveWorkOrgHr = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.post(_req.hr.HR_WORKORG_HR_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function querySaveWorkOrgHr(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryDeleteWorkOrgHr = exports.queryDeleteWorkOrgHr = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.hr.HR_WORKORG_HR_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryDeleteWorkOrgHr(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryDeletesWorkOrgHr = exports.queryDeletesWorkOrgHr = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.hr.HR_WORKORG_HR_DELETES, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryDeletesWorkOrgHr(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var queryHrListByWorkOrg = exports.queryHrListByWorkOrg = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.hr.HR_WORKORG_HR_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryHrListByWorkOrg(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.wrapFile = wrapFile;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(2960);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _req = __webpack_require__(32);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * 与UploadFile功能一致，但样式更适合在列表内
	 */
	var UploadFile = function (_Component) {
	  _inherits(UploadFile, _Component);
	
	  function UploadFile(props) {
	    _classCallCheck(this, UploadFile);
	
	    var _this = _possibleConstructorReturn(this, (UploadFile.__proto__ || Object.getPrototypeOf(UploadFile)).call(this, props));
	
	    _this.wrapFile = function (fileArr) {
	      var files = [];
	      if (fileArr && fileArr.length > 0) {
	        files = fileArr.map(function (file, index) {
	          return {
	            uid: file.uuid || index,
	            uuid: file.uuid || index,
	            name: file.name,
	            url: file.url,
	            status: 'done'
	          };
	        });
	      }
	      return files;
	    };
	
	    _this.handleBefore = function (info) {
	      var excelContentTypeArr = ['application/vnd.ms-excel', // .xls,.xlt,.xla
	      'application/vnd.ms-excel.addin.macroEnabled.12', // .xlam
	      'application/vnd.ms-excel.sheet.macroEnabled.12', // .xlsm
	      'application/vnd.ms-excel.template.macroEnabled.12', // .xltm
	      'application/vnd.ms-excel.sheet.binary.macroEnabled.12', // .xlsb
	      'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
	      'application/vnd.openxmlformats-officedocument.spreadsheetml.template'];
	      var typeIndex = excelContentTypeArr.indexOf(info.type);
	      return new Promise(function (resolve, reject) {
	        if (typeIndex === -1) {
	          _antd.message.error('请上传excel格式的文件');
	          reject();
	        } else {
	          resolve();
	        }
	      });
	    };
	
	    _this.handleChange = function (info) {
	      if (info.error && info.error.status !== 200) {
	        return false;
	      }
	
	      var fileList = info.fileList;
	      // 1. Limit the number of uploaded files
	
	      var limit = _this.props.limit;
	
	      if (limit) {
	        fileList = fileList.reverse().slice(0, limit);
	      }
	
	      // 2. read from response and show file link
	      // 只拿最新的一个文件
	      fileList = fileList.map(function (file) {
	        if (file.response) {
	          // Component will show file.url as link
	          // file.response.data是一个数组
	          if (file.response.data && file.response.data.length > 0) {
	            file.url = file.response.data[0].url;
	            file.uuid = file.response.data[0].uuid;
	          } else {
	            _antd.message.error('上传失败，请重新上传');
	          }
	        }
	        return file;
	      });
	
	      // 3. filter successfully uploaded files according to response from server
	      fileList = fileList.filter(function (file) {
	        if (file.response) {
	          return file.response.statusCode === 200;
	        }
	        return true;
	      });
	
	      _this.setState({ fileList: fileList });
	      _this.props.onChange(_this.formatFiles(fileList));
	      var handleUpload = _this.props.handleUpload;
	
	      if (typeof handleUpload === 'function') {
	        handleUpload(fileList);
	      }
	    };
	
	    _this.formatFiles = function (fileList) {
	      var files = [];
	      fileList.map(function (item, index) {
	        files[index] = {
	          uuid: item.uuid,
	          name: item.name,
	          url: item.url
	        };
	        return item;
	      });
	      return files;
	    };
	
	    _this.state = {
	      fileList: []
	    };
	    return _this;
	  }
	
	  _createClass(UploadFile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.value && this.props.value.length > 0 && this.state.fileList.length === 0) {
	        this.setState({ fileList: this.wrapFile(this.props.value) });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      var fileList = this.wrapFile(props.value);
	      var oldList = this.state.fileList;
	      if (oldList.length === 0 && fileList && fileList.length > 0) {
	        this.setState({ fileList: fileList });
	      }
	    }
	
	    /**
	     * 上传文件之前的钩子，参数为上传的文件，若返回 false 则停止上传。
	     * 支持返回一个 Promise 对象，Promise 对象 reject 时则停止上传，resolve 时开始上传。
	     * 注意：IE9 不支持该方法。
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          isExcel = _props.isExcel,
	          isPreview = _props.isPreview,
	          onRemove = _props.onRemove,
	          handleClick = _props.handleClick;
	
	      return _react2.default.createElement(
	        _antd.Upload,
	        {
	          name: 'files',
	          data: data || {},
	          fileList: this.state.fileList,
	          action: '' + _req.common.UPLOAD,
	          headers: {
	            Authorization: '' + _localDb2.default.get('token')
	          },
	          beforeUpload: isExcel ? this.handleBefore : null,
	          onPreview: isPreview ? function (file) {
	            return (0, _attachment.queryFilePreview)(file);
	          } : null,
	          onChange: this.handleChange,
	          onRemove: onRemove || null,
	          className: 'has-error Upload',
	          style: { height: '60px' }
	        },
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            type: 'ghost',
	            onClick: handleClick // 同一个页面有多个upload,记录下标
	            , disabled: this.props.disabled ? this.props.disabled : false
	          },
	          _react2.default.createElement(_antd.Icon, { type: 'upload' })
	        )
	      );
	    }
	  }]);
	
	  return UploadFile;
	}(_react.Component);
	
	exports.default = UploadFile;
	
	
	UploadFile.propTypes = {};
	
	/**
	 * 包装文件
	 * @param  {[type]} arr [description]
	 * @return {[type]}     [description]
	 */
	function wrapFile(fileArr) {
	  var files = [];
	  if (fileArr && fileArr.length > 0) {
	    files = fileArr.map(function (file, index) {
	      return {
	        uid: file.uuid || index,
	        name: file.name,
	        url: file.url,
	        status: 'done'
	      };
	    });
	  }
	  return files;
	}

/***/ },
/* 193 */
[3004, 195],
/* 194 */
104,
/* 195 */
45,
/* 196 */
[3041, 748, 447],
/* 197 */
/***/ function(module, exports) {

	module.exports = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(118);
	var call = __webpack_require__(769);
	var isArrayIter = __webpack_require__(469);
	var anObject = __webpack_require__(31);
	var toLength = __webpack_require__(63);
	var getIterFn = __webpack_require__(485);
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
	  var f = ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = call(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;


/***/ },
/* 199 */
[3025, 31, 775, 465, 478, 464, 467],
/* 200 */
[3030, 777, 465],
/* 201 */
[3033, 777, 465],
/* 202 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var redefine = __webpack_require__(98);
	module.exports = function (target, src, safe) {
	  for (var key in src) redefine(target, key, src[key], safe);
	  return target;
	};


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(42);
	var dP = __webpack_require__(69);
	var DESCRIPTORS = __webpack_require__(65);
	var SPECIES = __webpack_require__(58)('species');
	
	module.exports = function (KEY) {
	  var C = global[KEY];
	  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};


/***/ },
/* 205 */
[3040, 120],
/* 206 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(45);
	module.exports = function (it, TYPE) {
	  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
	  return it;
	};


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CharacterMetadata = __webpack_require__(100);
	var Immutable = __webpack_require__(39);
	
	var findRangesImmutable = __webpack_require__(284);
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedSet = Immutable.OrderedSet,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var EMPTY_SET = OrderedSet();
	
	var defaultRecord = {
	  key: '',
	  type: 'unstyled',
	  text: '',
	  characterList: List(),
	  depth: 0,
	  data: Map()
	};
	
	var ContentBlockRecord = Record(defaultRecord);
	
	var decorateCharacterList = function decorateCharacterList(config) {
	  if (!config) {
	    return config;
	  }
	
	  var characterList = config.characterList,
	      text = config.text;
	
	
	  if (text && !characterList) {
	    config.characterList = List(Repeat(CharacterMetadata.EMPTY, text.length));
	  }
	
	  return config;
	};
	
	var ContentBlock = function (_ContentBlockRecord) {
	  _inherits(ContentBlock, _ContentBlockRecord);
	
	  function ContentBlock(config) {
	    _classCallCheck(this, ContentBlock);
	
	    return _possibleConstructorReturn(this, _ContentBlockRecord.call(this, decorateCharacterList(config)));
	  }
	
	  ContentBlock.prototype.getKey = function getKey() {
	    return this.get('key');
	  };
	
	  ContentBlock.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  ContentBlock.prototype.getText = function getText() {
	    return this.get('text');
	  };
	
	  ContentBlock.prototype.getCharacterList = function getCharacterList() {
	    return this.get('characterList');
	  };
	
	  ContentBlock.prototype.getLength = function getLength() {
	    return this.getText().length;
	  };
	
	  ContentBlock.prototype.getDepth = function getDepth() {
	    return this.get('depth');
	  };
	
	  ContentBlock.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  ContentBlock.prototype.getInlineStyleAt = function getInlineStyleAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getStyle() : EMPTY_SET;
	  };
	
	  ContentBlock.prototype.getEntityAt = function getEntityAt(offset) {
	    var character = this.getCharacterList().get(offset);
	    return character ? character.getEntity() : null;
	  };
	
	  /**
	   * Execute a callback for every contiguous range of styles within the block.
	   */
	
	
	  ContentBlock.prototype.findStyleRanges = function findStyleRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualStyle, filterFn, callback);
	  };
	
	  /**
	   * Execute a callback for every contiguous range of entities within the block.
	   */
	
	
	  ContentBlock.prototype.findEntityRanges = function findEntityRanges(filterFn, callback) {
	    findRangesImmutable(this.getCharacterList(), haveEqualEntity, filterFn, callback);
	  };
	
	  return ContentBlock;
	}(ContentBlockRecord);
	
	function haveEqualStyle(charA, charB) {
	  return charA.getStyle() === charB.getStyle();
	}
	
	function haveEqualEntity(charA, charB) {
	  return charA.getEntity() === charB.getEntity();
	}
	
	module.exports = ContentBlock;

/***/ },
/* 209 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function retrieveTargetInfo(payload, validPayloadTypes, seriesModel) {
	  if (payload && zrUtil.indexOf(validPayloadTypes, payload.type) >= 0) {
	    var root = seriesModel.getData().tree.root;
	    var targetNode = payload.targetNode;
	
	    if (typeof targetNode === 'string') {
	      targetNode = root.getNodeById(targetNode);
	    }
	
	    if (targetNode && root.contains(targetNode)) {
	      return {
	        node: targetNode
	      };
	    }
	
	    var targetNodeId = payload.targetNodeId;
	
	    if (targetNodeId != null && (targetNode = root.getNodeById(targetNodeId))) {
	      return {
	        node: targetNode
	      };
	    }
	  }
	} // Not includes the given node at the last item.
	
	
	function getPathToRoot(node) {
	  var path = [];
	
	  while (node) {
	    node = node.parentNode;
	    node && path.push(node);
	  }
	
	  return path.reverse();
	}
	
	function aboveViewRoot(viewRoot, node) {
	  var viewPath = getPathToRoot(viewRoot);
	  return zrUtil.indexOf(viewPath, node) >= 0;
	} // From root to the input node (the input node will be included).
	
	
	function wrapTreePathInfo(node, seriesModel) {
	  var treePathInfo = [];
	
	  while (node) {
	    var nodeDataIndex = node.dataIndex;
	    treePathInfo.push({
	      name: node.name,
	      dataIndex: nodeDataIndex,
	      value: seriesModel.getRawValue(nodeDataIndex)
	    });
	    node = node.parentNode;
	  }
	
	  treePathInfo.reverse();
	  return treePathInfo;
	}
	
	exports.retrieveTargetInfo = retrieveTargetInfo;
	exports.getPathToRoot = getPathToRoot;
	exports.aboveViewRoot = aboveViewRoot;
	exports.wrapTreePathInfo = wrapTreePathInfo;

/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(10);
	
	var axisPointerModelHelper = __webpack_require__(354);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Base class of AxisView.
	 */
	var AxisView = echarts.extendComponentView({
	  type: 'axis',
	
	  /**
	   * @private
	   */
	  _axisPointer: null,
	
	  /**
	   * @protected
	   * @type {string}
	   */
	  axisPointerClass: null,
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    // FIXME
	    // This process should proformed after coordinate systems updated
	    // (axis scale updated), and should be performed each time update.
	    // So put it here temporarily, although it is not appropriate to
	    // put a model-writing procedure in `view`.
	    this.axisPointerClass && axisPointerModelHelper.fixValue(axisModel);
	    AxisView.superApply(this, 'render', arguments);
	    updateAxisPointer(this, axisModel, ecModel, api, payload, true);
	  },
	
	  /**
	   * Action handler.
	   * @public
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/model/Global} ecModel
	   * @param {module:echarts/ExtensionAPI} api
	   * @param {Object} payload
	   */
	  updateAxisPointer: function (axisModel, ecModel, api, payload, force) {
	    updateAxisPointer(this, axisModel, ecModel, api, payload, false);
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    var axisPointer = this._axisPointer;
	    axisPointer && axisPointer.remove(api);
	    AxisView.superApply(this, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    disposeAxisPointer(this, api);
	    AxisView.superApply(this, 'dispose', arguments);
	  }
	});
	
	function updateAxisPointer(axisView, axisModel, ecModel, api, payload, forceRender) {
	  var Clazz = AxisView.getAxisPointerClass(axisView.axisPointerClass);
	
	  if (!Clazz) {
	    return;
	  }
	
	  var axisPointerModel = axisPointerModelHelper.getAxisPointerModel(axisModel);
	  axisPointerModel ? (axisView._axisPointer || (axisView._axisPointer = new Clazz())).render(axisModel, axisPointerModel, api, forceRender) : disposeAxisPointer(axisView, api);
	}
	
	function disposeAxisPointer(axisView, ecModel, api) {
	  var axisPointer = axisView._axisPointer;
	  axisPointer && axisPointer.dispose(ecModel, api);
	  axisView._axisPointer = null;
	}
	
	var axisPointerClazz = [];
	
	AxisView.registerAxisPointerClass = function (type, clazz) {
	  axisPointerClazz[type] = clazz;
	};
	
	AxisView.getAxisPointerClass = function (type) {
	  return type && axisPointerClazz[type];
	};
	
	var _default = AxisView;
	module.exports = _default;

/***/ },
/* 211 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function defaultKeyGetter(item) {
	  return item;
	}
	/**
	 * @param {Array} oldArr
	 * @param {Array} newArr
	 * @param {Function} oldKeyGetter
	 * @param {Function} newKeyGetter
	 * @param {Object} [context] Can be visited by this.context in callback.
	 */
	
	
	function DataDiffer(oldArr, newArr, oldKeyGetter, newKeyGetter, context) {
	  this._old = oldArr;
	  this._new = newArr;
	  this._oldKeyGetter = oldKeyGetter || defaultKeyGetter;
	  this._newKeyGetter = newKeyGetter || defaultKeyGetter;
	  this.context = context;
	}
	
	DataDiffer.prototype = {
	  constructor: DataDiffer,
	
	  /**
	   * Callback function when add a data
	   */
	  add: function (func) {
	    this._add = func;
	    return this;
	  },
	
	  /**
	   * Callback function when update a data
	   */
	  update: function (func) {
	    this._update = func;
	    return this;
	  },
	
	  /**
	   * Callback function when remove a data
	   */
	  remove: function (func) {
	    this._remove = func;
	    return this;
	  },
	  execute: function () {
	    var oldArr = this._old;
	    var newArr = this._new;
	    var oldDataIndexMap = {};
	    var newDataIndexMap = {};
	    var oldDataKeyArr = [];
	    var newDataKeyArr = [];
	    var i;
	    initIndexMap(oldArr, oldDataIndexMap, oldDataKeyArr, '_oldKeyGetter', this);
	    initIndexMap(newArr, newDataIndexMap, newDataKeyArr, '_newKeyGetter', this);
	
	    for (i = 0; i < oldArr.length; i++) {
	      var key = oldDataKeyArr[i];
	      var idx = newDataIndexMap[key]; // idx can never be empty array here. see 'set null' logic below.
	
	      if (idx != null) {
	        // Consider there is duplicate key (for example, use dataItem.name as key).
	        // We should make sure every item in newArr and oldArr can be visited.
	        var len = idx.length;
	
	        if (len) {
	          len === 1 && (newDataIndexMap[key] = null);
	          idx = idx.shift();
	        } else {
	          newDataIndexMap[key] = null;
	        }
	
	        this._update && this._update(idx, i);
	      } else {
	        this._remove && this._remove(i);
	      }
	    }
	
	    for (var i = 0; i < newDataKeyArr.length; i++) {
	      var key = newDataKeyArr[i];
	
	      if (newDataIndexMap.hasOwnProperty(key)) {
	        var idx = newDataIndexMap[key];
	
	        if (idx == null) {
	          continue;
	        } // idx can never be empty array here. see 'set null' logic above.
	
	
	        if (!idx.length) {
	          this._add && this._add(idx);
	        } else {
	          for (var j = 0, len = idx.length; j < len; j++) {
	            this._add && this._add(idx[j]);
	          }
	        }
	      }
	    }
	  }
	};
	
	function initIndexMap(arr, map, keyArr, keyGetterName, dataDiffer) {
	  for (var i = 0; i < arr.length; i++) {
	    // Add prefix to avoid conflict with Object.prototype.
	    var key = '_ec_' + dataDiffer[keyGetterName](arr[i], i);
	    var existence = map[key];
	
	    if (existence == null) {
	      keyArr.push(key);
	      map[key] = i;
	    } else {
	      if (!existence.length) {
	        map[key] = existence = [existence];
	      }
	
	      existence.push(i);
	    }
	  }
	}
	
	var _default = DataDiffer;
	module.exports = _default;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(4);
	
	var isTypedArray = _util.isTypedArray;
	var extend = _util.extend;
	var assert = _util.assert;
	var each = _util.each;
	var isObject = _util.isObject;
	
	var _model = __webpack_require__(29);
	
	var getDataItemValue = _model.getDataItemValue;
	var isDataItemOption = _model.isDataItemOption;
	
	var _number = __webpack_require__(25);
	
	var parseDate = _number.parseDate;
	
	var Source = __webpack_require__(292);
	
	var _sourceType = __webpack_require__(294);
	
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SOURCE_FORMAT_ARRAY_ROWS = _sourceType.SOURCE_FORMAT_ARRAY_ROWS;
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SOURCE_FORMAT_OBJECT_ROWS = _sourceType.SOURCE_FORMAT_OBJECT_ROWS;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO
	// ??? refactor? check the outer usage of data provider.
	// merge with defaultDimValueGetter?
	
	/**
	 * If normal array used, mutable chunk size is supported.
	 * If typed array used, chunk size must be fixed.
	 */
	function DefaultDataProvider(source, dimSize) {
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  this._source = source;
	  var data = this._data = source.data;
	  var sourceFormat = source.sourceFormat; // Typed array. TODO IE10+?
	
	  if (sourceFormat === SOURCE_FORMAT_TYPED_ARRAY) {
	    this._offset = 0;
	    this._dimSize = dimSize;
	    this._data = data;
	  }
	
	  var methods = providerMethods[sourceFormat === SOURCE_FORMAT_ARRAY_ROWS ? sourceFormat + '_' + source.seriesLayoutBy : sourceFormat];
	  extend(this, methods);
	}
	
	var providerProto = DefaultDataProvider.prototype; // If data is pure without style configuration
	
	providerProto.pure = false; // If data is persistent and will not be released after use.
	
	providerProto.persistent = true; // ???! FIXME legacy data provider do not has method getSource
	
	providerProto.getSource = function () {
	  return this._source;
	};
	
	var providerMethods = {
	  'arrayRows_column': {
	    pure: true,
	    count: function () {
	      return Math.max(0, this._data.length - this._source.startIndex);
	    },
	    getItem: function (idx) {
	      return this._data[idx + this._source.startIndex];
	    },
	    appendData: appendDataSimply
	  },
	  'arrayRows_row': {
	    pure: true,
	    count: function () {
	      var row = this._data[0];
	      return row ? Math.max(0, row.length - this._source.startIndex) : 0;
	    },
	    getItem: function (idx) {
	      idx += this._source.startIndex;
	      var item = [];
	      var data = this._data;
	
	      for (var i = 0; i < data.length; i++) {
	        var row = data[i];
	        item.push(row ? row[idx] : null);
	      }
	
	      return item;
	    },
	    appendData: function () {
	      throw new Error('Do not support appendData when set seriesLayoutBy: "row".');
	    }
	  },
	  'objectRows': {
	    pure: true,
	    count: countSimply,
	    getItem: getItemSimply,
	    appendData: appendDataSimply
	  },
	  'keyedColumns': {
	    pure: true,
	    count: function () {
	      var dimName = this._source.dimensionsDefine[0].name;
	      var col = this._data[dimName];
	      return col ? col.length : 0;
	    },
	    getItem: function (idx) {
	      var item = [];
	      var dims = this._source.dimensionsDefine;
	
	      for (var i = 0; i < dims.length; i++) {
	        var col = this._data[dims[i].name];
	        item.push(col ? col[idx] : null);
	      }
	
	      return item;
	    },
	    appendData: function (newData) {
	      var data = this._data;
	      each(newData, function (newCol, key) {
	        var oldCol = data[key] || (data[key] = []);
	
	        for (var i = 0; i < (newCol || []).length; i++) {
	          oldCol.push(newCol[i]);
	        }
	      });
	    }
	  },
	  'original': {
	    count: countSimply,
	    getItem: getItemSimply,
	    appendData: appendDataSimply
	  },
	  'typedArray': {
	    persistent: false,
	    pure: true,
	    count: function () {
	      return this._data ? this._data.length / this._dimSize : 0;
	    },
	    getItem: function (idx, out) {
	      idx = idx - this._offset;
	      out = out || [];
	      var offset = this._dimSize * idx;
	
	      for (var i = 0; i < this._dimSize; i++) {
	        out[i] = this._data[offset + i];
	      }
	
	      return out;
	    },
	    appendData: function (newData) {
	      this._data = newData;
	    },
	    // Clean self if data is already used.
	    clean: function () {
	      // PENDING
	      this._offset += this.count();
	      this._data = null;
	    }
	  }
	};
	
	function countSimply() {
	  return this._data.length;
	}
	
	function getItemSimply(idx) {
	  return this._data[idx];
	}
	
	function appendDataSimply(newData) {
	  for (var i = 0; i < newData.length; i++) {
	    this._data.push(newData[i]);
	  }
	}
	
	var rawValueGetters = {
	  arrayRows: getRawValueSimply,
	  objectRows: function (dataItem, dataIndex, dimIndex, dimName) {
	    return dimIndex != null ? dataItem[dimName] : dataItem;
	  },
	  keyedColumns: getRawValueSimply,
	  original: function (dataItem, dataIndex, dimIndex, dimName) {
	    // FIXME
	    // In some case (markpoint in geo (geo-map.html)), dataItem
	    // is {coord: [...]}
	    var value = getDataItemValue(dataItem);
	    return dimIndex == null || !(value instanceof Array) ? value : value[dimIndex];
	  },
	  typedArray: getRawValueSimply
	};
	
	function getRawValueSimply(dataItem, dataIndex, dimIndex, dimName) {
	  return dimIndex != null ? dataItem[dimIndex] : dataItem;
	}
	
	var defaultDimValueGetters = {
	  arrayRows: getDimValueSimply,
	  objectRows: function (dataItem, dimName, dataIndex, dimIndex) {
	    return converDataValue(dataItem[dimName], this._dimensionInfos[dimName]);
	  },
	  keyedColumns: getDimValueSimply,
	  original: function (dataItem, dimName, dataIndex, dimIndex) {
	    // Performance sensitive, do not use modelUtil.getDataItemValue.
	    // If dataItem is an plain object with no value field, the var `value`
	    // will be assigned with the object, but it will be tread correctly
	    // in the `convertDataValue`.
	    var value = dataItem && (dataItem.value == null ? dataItem : dataItem.value); // If any dataItem is like { value: 10 }
	
	    if (!this._rawData.pure && isDataItemOption(dataItem)) {
	      this.hasItemOption = true;
	    }
	
	    return converDataValue(value instanceof Array ? value[dimIndex] // If value is a single number or something else not array.
	    : value, this._dimensionInfos[dimName]);
	  },
	  typedArray: function (dataItem, dimName, dataIndex, dimIndex) {
	    return dataItem[dimIndex];
	  }
	};
	
	function getDimValueSimply(dataItem, dimName, dataIndex, dimIndex) {
	  return converDataValue(dataItem[dimIndex], this._dimensionInfos[dimName]);
	}
	/**
	 * This helper method convert value in data.
	 * @param {string|number|Date} value
	 * @param {Object|string} [dimInfo] If string (like 'x'), dimType defaults 'number'.
	 *        If "dimInfo.ordinalParseAndSave", ordinal value can be parsed.
	 */
	
	
	function converDataValue(value, dimInfo) {
	  // Performance sensitive.
	  var dimType = dimInfo && dimInfo.type;
	
	  if (dimType === 'ordinal') {
	    // If given value is a category string
	    var ordinalMeta = dimInfo && dimInfo.ordinalMeta;
	    return ordinalMeta ? ordinalMeta.parseAndCollect(value) : value;
	  }
	
	  if (dimType === 'time' // spead up when using timestamp
	  && typeof value !== 'number' && value != null && value !== '-') {
	    value = +parseDate(value);
	  } // dimType defaults 'number'.
	  // If dimType is not ordinal and value is null or undefined or NaN or '-',
	  // parse to NaN.
	
	
	  return value == null || value === '' ? NaN // If string (like '-'), using '+' parse to NaN
	  // If object, also parse to NaN
	  : +value;
	} // ??? FIXME can these logic be more neat: getRawValue, getRawDataItem,
	// Consider persistent.
	// Caution: why use raw value to display on label or tooltip?
	// A reason is to avoid format. For example time value we do not know
	// how to format is expected. More over, if stack is used, calculated
	// value may be 0.91000000001, which have brings trouble to display.
	// TODO: consider how to treat null/undefined/NaN when display?
	
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @param {string|number} [dim] dimName or dimIndex
	 * @return {Array.<number>|string|number} can be null/undefined.
	 */
	
	
	function retrieveRawValue(data, dataIndex, dim) {
	  if (!data) {
	    return;
	  } // Consider data may be not persistent.
	
	
	  var dataItem = data.getRawDataItem(dataIndex);
	
	  if (dataItem == null) {
	    return;
	  }
	
	  var sourceFormat = data.getProvider().getSource().sourceFormat;
	  var dimName;
	  var dimIndex;
	  var dimInfo = data.getDimensionInfo(dim);
	
	  if (dimInfo) {
	    dimName = dimInfo.name;
	    dimIndex = dimInfo.index;
	  }
	
	  return rawValueGetters[sourceFormat](dataItem, dataIndex, dimIndex, dimName);
	}
	/**
	 * Compatible with some cases (in pie, map) like:
	 * data: [{name: 'xx', value: 5, selected: true}, ...]
	 * where only sourceFormat is 'original' and 'objectRows' supported.
	 *
	 * ??? TODO
	 * Supported detail options in data item when using 'arrayRows'.
	 *
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @param {string} attr like 'selected'
	 */
	
	
	function retrieveRawAttr(data, dataIndex, attr) {
	  if (!data) {
	    return;
	  }
	
	  var sourceFormat = data.getProvider().getSource().sourceFormat;
	
	  if (sourceFormat !== SOURCE_FORMAT_ORIGINAL && sourceFormat !== SOURCE_FORMAT_OBJECT_ROWS) {
	    return;
	  }
	
	  var dataItem = data.getRawDataItem(dataIndex);
	
	  if (sourceFormat === SOURCE_FORMAT_ORIGINAL && !isObject(dataItem)) {
	    dataItem = null;
	  }
	
	  if (dataItem) {
	    return dataItem[attr];
	  }
	}
	
	exports.DefaultDataProvider = DefaultDataProvider;
	exports.defaultDimValueGetters = defaultDimValueGetters;
	exports.retrieveRawValue = retrieveRawValue;
	exports.retrieveRawAttr = retrieveRawAttr;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var zrColor = __webpack_require__(148);
	
	var _number = __webpack_require__(25);
	
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var CATEGORY_DEFAULT_VISUAL_INDEX = -1;
	/**
	 * @param {Object} option
	 * @param {string} [option.type] See visualHandlers.
	 * @param {string} [option.mappingMethod] 'linear' or 'piecewise' or 'category' or 'fixed'
	 * @param {Array.<number>=} [option.dataExtent] [minExtent, maxExtent],
	 *                                              required when mappingMethod is 'linear'
	 * @param {Array.<Object>=} [option.pieceList] [
	 *                                             {value: someValue},
	 *                                             {interval: [min1, max1], visual: {...}},
	 *                                             {interval: [min2, max2]}
	 *                                             ],
	 *                                            required when mappingMethod is 'piecewise'.
	 *                                            Visual for only each piece can be specified.
	 * @param {Array.<string|Object>=} [option.categories] ['cate1', 'cate2']
	 *                                            required when mappingMethod is 'category'.
	 *                                            If no option.categories, categories is set
	 *                                            as [0, 1, 2, ...].
	 * @param {boolean} [option.loop=false] Whether loop mapping when mappingMethod is 'category'.
	 * @param {(Array|Object|*)} [option.visual]  Visual data.
	 *                                            when mappingMethod is 'category',
	 *                                            visual data can be array or object
	 *                                            (like: {cate1: '#222', none: '#fff'})
	 *                                            or primary types (which represents
	 *                                            default category visual), otherwise visual
	 *                                            can be array or primary (which will be
	 *                                            normalized to array).
	 *
	 */
	
	var VisualMapping = function (option) {
	  var mappingMethod = option.mappingMethod;
	  var visualType = option.type;
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	
	  var thisOption = this.option = zrUtil.clone(option);
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.type = visualType;
	  /**
	   * @readOnly
	   * @type {string}
	   */
	
	  this.mappingMethod = mappingMethod;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._normalizeData = normalizers[mappingMethod];
	  var visualHandler = visualHandlers[visualType];
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.applyVisual = visualHandler.applyVisual;
	  /**
	   * @public
	   * @type {Function}
	   */
	
	  this.getColorMapper = visualHandler.getColorMapper;
	  /**
	   * @private
	   * @type {Function}
	   */
	
	  this._doMap = visualHandler._doMap[mappingMethod];
	
	  if (mappingMethod === 'piecewise') {
	    normalizeVisualRange(thisOption);
	    preprocessForPiecewise(thisOption);
	  } else if (mappingMethod === 'category') {
	    thisOption.categories ? preprocessForSpecifiedCategory(thisOption) // categories is ordinal when thisOption.categories not specified,
	    // which need no more preprocess except normalize visual.
	    : normalizeVisualRange(thisOption, true);
	  } else {
	    // mappingMethod === 'linear' or 'fixed'
	    zrUtil.assert(mappingMethod !== 'linear' || thisOption.dataExtent);
	    normalizeVisualRange(thisOption);
	  }
	};
	
	VisualMapping.prototype = {
	  constructor: VisualMapping,
	  mapValueToVisual: function (value) {
	    var normalized = this._normalizeData(value);
	
	    return this._doMap(normalized, value);
	  },
	  getNormalizer: function () {
	    return zrUtil.bind(this._normalizeData, this);
	  }
	};
	var visualHandlers = VisualMapping.visualHandlers = {
	  color: {
	    applyVisual: makeApplyVisual('color'),
	
	    /**
	     * Create a mapper function
	     * @return {Function}
	     */
	    getColorMapper: function () {
	      var thisOption = this.option;
	      return zrUtil.bind(thisOption.mappingMethod === 'category' ? function (value, isNormalized) {
	        !isNormalized && (value = this._normalizeData(value));
	        return doMapCategory.call(this, value);
	      } : function (value, isNormalized, out) {
	        // If output rgb array
	        // which will be much faster and useful in pixel manipulation
	        var returnRGBArray = !!out;
	        !isNormalized && (value = this._normalizeData(value));
	        out = zrColor.fastLerp(value, thisOption.parsedVisual, out);
	        return returnRGBArray ? out : zrColor.stringify(out, 'rgba');
	      }, this);
	    },
	    _doMap: {
	      linear: function (normalized) {
	        return zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	      },
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = zrColor.stringify(zrColor.fastLerp(normalized, this.option.parsedVisual), 'rgba');
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  colorHue: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, value);
	  }),
	  colorSaturation: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, value);
	  }),
	  colorLightness: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyHSL(color, null, null, value);
	  }),
	  colorAlpha: makePartialColorVisualHandler(function (color, value) {
	    return zrColor.modifyAlpha(color, value);
	  }),
	  opacity: {
	    applyVisual: makeApplyVisual('opacity'),
	    _doMap: makeDoMap([0, 1])
	  },
	  liftZ: {
	    applyVisual: makeApplyVisual('liftZ'),
	    _doMap: {
	      linear: doMapFixed,
	      category: doMapFixed,
	      piecewise: doMapFixed,
	      fixed: doMapFixed
	    }
	  },
	  symbol: {
	    applyVisual: function (value, getter, setter) {
	      var symbolCfg = this.mapValueToVisual(value);
	
	      if (zrUtil.isString(symbolCfg)) {
	        setter('symbol', symbolCfg);
	      } else if (isObject(symbolCfg)) {
	        for (var name in symbolCfg) {
	          if (symbolCfg.hasOwnProperty(name)) {
	            setter(name, symbolCfg[name]);
	          }
	        }
	      }
	    },
	    _doMap: {
	      linear: doMapToArray,
	      category: doMapCategory,
	      piecewise: function (normalized, value) {
	        var result = getSpecifiedVisual.call(this, value);
	
	        if (result == null) {
	          result = doMapToArray.call(this, normalized);
	        }
	
	        return result;
	      },
	      fixed: doMapFixed
	    }
	  },
	  symbolSize: {
	    applyVisual: makeApplyVisual('symbolSize'),
	    _doMap: makeDoMap([0, 1])
	  }
	};
	
	function preprocessForPiecewise(thisOption) {
	  var pieceList = thisOption.pieceList;
	  thisOption.hasSpecialVisual = false;
	  zrUtil.each(pieceList, function (piece, index) {
	    piece.originIndex = index; // piece.visual is "result visual value" but not
	    // a visual range, so it does not need to be normalized.
	
	    if (piece.visual != null) {
	      thisOption.hasSpecialVisual = true;
	    }
	  });
	}
	
	function preprocessForSpecifiedCategory(thisOption) {
	  // Hash categories.
	  var categories = thisOption.categories;
	  var visual = thisOption.visual;
	  var categoryMap = thisOption.categoryMap = {};
	  each(categories, function (cate, index) {
	    categoryMap[cate] = index;
	  }); // Process visual map input.
	
	  if (!zrUtil.isArray(visual)) {
	    var visualArr = [];
	
	    if (zrUtil.isObject(visual)) {
	      each(visual, function (v, cate) {
	        var index = categoryMap[cate];
	        visualArr[index != null ? index : CATEGORY_DEFAULT_VISUAL_INDEX] = v;
	      });
	    } else {
	      // Is primary type, represents default visual.
	      visualArr[CATEGORY_DEFAULT_VISUAL_INDEX] = visual;
	    }
	
	    visual = setVisualToOption(thisOption, visualArr);
	  } // Remove categories that has no visual,
	  // then we can mapping them to CATEGORY_DEFAULT_VISUAL_INDEX.
	
	
	  for (var i = categories.length - 1; i >= 0; i--) {
	    if (visual[i] == null) {
	      delete categoryMap[categories[i]];
	      categories.pop();
	    }
	  }
	}
	
	function normalizeVisualRange(thisOption, isCategory) {
	  var visual = thisOption.visual;
	  var visualArr = [];
	
	  if (zrUtil.isObject(visual)) {
	    each(visual, function (v) {
	      visualArr.push(v);
	    });
	  } else if (visual != null) {
	    visualArr.push(visual);
	  }
	
	  var doNotNeedPair = {
	    color: 1,
	    symbol: 1
	  };
	
	  if (!isCategory && visualArr.length === 1 && !doNotNeedPair.hasOwnProperty(thisOption.type)) {
	    // Do not care visualArr.length === 0, which is illegal.
	    visualArr[1] = visualArr[0];
	  }
	
	  setVisualToOption(thisOption, visualArr);
	}
	
	function makePartialColorVisualHandler(applyValue) {
	  return {
	    applyVisual: function (value, getter, setter) {
	      value = this.mapValueToVisual(value); // Must not be array value
	
	      setter('color', applyValue(getter('color'), value));
	    },
	    _doMap: makeDoMap([0, 1])
	  };
	}
	
	function doMapToArray(normalized) {
	  var visual = this.option.visual;
	  return visual[Math.round(linearMap(normalized, [0, 1], [0, visual.length - 1], true))] || {};
	}
	
	function makeApplyVisual(visualType) {
	  return function (value, getter, setter) {
	    setter(visualType, this.mapValueToVisual(value));
	  };
	}
	
	function doMapCategory(normalized) {
	  var visual = this.option.visual;
	  return visual[this.option.loop && normalized !== CATEGORY_DEFAULT_VISUAL_INDEX ? normalized % visual.length : normalized];
	}
	
	function doMapFixed() {
	  return this.option.visual[0];
	}
	
	function makeDoMap(sourceExtent) {
	  return {
	    linear: function (normalized) {
	      return linearMap(normalized, sourceExtent, this.option.visual, true);
	    },
	    category: doMapCategory,
	    piecewise: function (normalized, value) {
	      var result = getSpecifiedVisual.call(this, value);
	
	      if (result == null) {
	        result = linearMap(normalized, sourceExtent, this.option.visual, true);
	      }
	
	      return result;
	    },
	    fixed: doMapFixed
	  };
	}
	
	function getSpecifiedVisual(value) {
	  var thisOption = this.option;
	  var pieceList = thisOption.pieceList;
	
	  if (thisOption.hasSpecialVisual) {
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList);
	    var piece = pieceList[pieceIndex];
	
	    if (piece && piece.visual) {
	      return piece.visual[this.type];
	    }
	  }
	}
	
	function setVisualToOption(thisOption, visualArr) {
	  thisOption.visual = visualArr;
	
	  if (thisOption.type === 'color') {
	    thisOption.parsedVisual = zrUtil.map(visualArr, function (item) {
	      return zrColor.parse(item);
	    });
	  }
	
	  return visualArr;
	}
	/**
	 * Normalizers by mapping methods.
	 */
	
	
	var normalizers = {
	  linear: function (value) {
	    return linearMap(value, this.option.dataExtent, [0, 1], true);
	  },
	  piecewise: function (value) {
	    var pieceList = this.option.pieceList;
	    var pieceIndex = VisualMapping.findPieceIndex(value, pieceList, true);
	
	    if (pieceIndex != null) {
	      return linearMap(pieceIndex, [0, pieceList.length - 1], [0, 1], true);
	    }
	  },
	  category: function (value) {
	    var index = this.option.categories ? this.option.categoryMap[value] : value; // ordinal
	
	    return index == null ? CATEGORY_DEFAULT_VISUAL_INDEX : index;
	  },
	  fixed: zrUtil.noop
	};
	/**
	 * List available visual types.
	 *
	 * @public
	 * @return {Array.<string>}
	 */
	
	VisualMapping.listVisualTypes = function () {
	  var visualTypes = [];
	  zrUtil.each(visualHandlers, function (handler, key) {
	    visualTypes.push(key);
	  });
	  return visualTypes;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.addVisualHandler = function (name, handler) {
	  visualHandlers[name] = handler;
	};
	/**
	 * @public
	 */
	
	
	VisualMapping.isValidType = function (visualType) {
	  return visualHandlers.hasOwnProperty(visualType);
	};
	/**
	 * Convinent method.
	 * Visual can be Object or Array or primary type.
	 *
	 * @public
	 */
	
	
	VisualMapping.eachVisual = function (visual, callback, context) {
	  if (zrUtil.isObject(visual)) {
	    zrUtil.each(visual, callback, context);
	  } else {
	    callback.call(context, visual);
	  }
	};
	
	VisualMapping.mapVisual = function (visual, callback, context) {
	  var isPrimary;
	  var newVisual = zrUtil.isArray(visual) ? [] : zrUtil.isObject(visual) ? {} : (isPrimary = true, null);
	  VisualMapping.eachVisual(visual, function (v, key) {
	    var newVal = callback.call(context, v, key);
	    isPrimary ? newVisual = newVal : newVisual[key] = newVal;
	  });
	  return newVisual;
	};
	/**
	 * @public
	 * @param {Object} obj
	 * @return {Object} new object containers visual values.
	 *                 If no visuals, return null.
	 */
	
	
	VisualMapping.retrieveVisuals = function (obj) {
	  var ret = {};
	  var hasVisual;
	  obj && each(visualHandlers, function (h, visualType) {
	    if (obj.hasOwnProperty(visualType)) {
	      ret[visualType] = obj[visualType];
	      hasVisual = true;
	    }
	  });
	  return hasVisual ? ret : null;
	};
	/**
	 * Give order to visual types, considering colorSaturation, colorAlpha depends on color.
	 *
	 * @public
	 * @param {(Object|Array)} visualTypes If Object, like: {color: ..., colorSaturation: ...}
	 *                                     IF Array, like: ['color', 'symbol', 'colorSaturation']
	 * @return {Array.<string>} Sorted visual types.
	 */
	
	
	VisualMapping.prepareVisualTypes = function (visualTypes) {
	  if (isObject(visualTypes)) {
	    var types = [];
	    each(visualTypes, function (item, type) {
	      types.push(type);
	    });
	    visualTypes = types;
	  } else if (zrUtil.isArray(visualTypes)) {
	    visualTypes = visualTypes.slice();
	  } else {
	    return [];
	  }
	
	  visualTypes.sort(function (type1, type2) {
	    // color should be front of colorSaturation, colorAlpha, ...
	    // symbol and symbolSize do not matter.
	    return type2 === 'color' && type1 !== 'color' && type1.indexOf('color') === 0 ? 1 : -1;
	  });
	  return visualTypes;
	};
	/**
	 * 'color', 'colorSaturation', 'colorAlpha', ... are depends on 'color'.
	 * Other visuals are only depends on themself.
	 *
	 * @public
	 * @param {string} visualType1
	 * @param {string} visualType2
	 * @return {boolean}
	 */
	
	
	VisualMapping.dependsOn = function (visualType1, visualType2) {
	  return visualType2 === 'color' ? !!(visualType1 && visualType1.indexOf(visualType2) === 0) : visualType1 === visualType2;
	};
	/**
	 * @param {number} value
	 * @param {Array.<Object>} pieceList [{value: ..., interval: [min, max]}, ...]
	 *                         Always from small to big.
	 * @param {boolean} [findClosestWhenOutside=false]
	 * @return {number} index
	 */
	
	
	VisualMapping.findPieceIndex = function (value, pieceList, findClosestWhenOutside) {
	  var possibleI;
	  var abs = Infinity; // value has the higher priority.
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var pieceValue = pieceList[i].value;
	
	    if (pieceValue != null) {
	      if (pieceValue === value // FIXME
	      // It is supposed to compare value according to value type of dimension,
	      // but currently value type can exactly be string or number.
	      // Compromise for numeric-like string (like '12'), especially
	      // in the case that visualMap.categories is ['22', '33'].
	      || typeof pieceValue === 'string' && pieceValue === value + '') {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(pieceValue, i);
	    }
	  }
	
	  for (var i = 0, len = pieceList.length; i < len; i++) {
	    var piece = pieceList[i];
	    var interval = piece.interval;
	    var close = piece.close;
	
	    if (interval) {
	      if (interval[0] === -Infinity) {
	        if (littleThan(close[1], value, interval[1])) {
	          return i;
	        }
	      } else if (interval[1] === Infinity) {
	        if (littleThan(close[0], interval[0], value)) {
	          return i;
	        }
	      } else if (littleThan(close[0], interval[0], value) && littleThan(close[1], value, interval[1])) {
	        return i;
	      }
	
	      findClosestWhenOutside && updatePossible(interval[0], i);
	      findClosestWhenOutside && updatePossible(interval[1], i);
	    }
	  }
	
	  if (findClosestWhenOutside) {
	    return value === Infinity ? pieceList.length - 1 : value === -Infinity ? 0 : possibleI;
	  }
	
	  function updatePossible(val, index) {
	    var newAbs = Math.abs(val - value);
	
	    if (newAbs < abs) {
	      abs = newAbs;
	      possibleI = index;
	    }
	  }
	};
	
	function littleThan(close, a, b) {
	  return close ? a <= b : a < b;
	}
	
	var _default = VisualMapping;
	module.exports = _default;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var isFunction = _util.isFunction;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType, defaultSymbolType, legendSymbol) {
	  // Encoding visual for all series include which is filtered for legend drawing
	  return {
	    seriesType: seriesType,
	    // For legend.
	    performRawSeries: true,
	    reset: function (seriesModel, ecModel, api) {
	      var data = seriesModel.getData();
	      var symbolType = seriesModel.get('symbol');
	      var symbolSize = seriesModel.get('symbolSize');
	      var keepAspect = seriesModel.get('symbolKeepAspect');
	      var symbolRotate = seriesModel.get('symbolRotate');
	      var hasSymbolTypeCallback = isFunction(symbolType);
	      var hasSymbolSizeCallback = isFunction(symbolSize);
	      var hasSymbolRotateCallback = isFunction(symbolRotate);
	      var hasCallback = hasSymbolTypeCallback || hasSymbolSizeCallback || hasSymbolRotateCallback;
	      var seriesSymbol = !hasSymbolTypeCallback && symbolType ? symbolType : defaultSymbolType;
	      var seriesSymbolSize = !hasSymbolSizeCallback ? symbolSize : null;
	      var seriesSymbolRotate = !hasSymbolRotateCallback ? seriesSymbolRotate : null;
	      data.setVisual({
	        legendSymbol: legendSymbol || seriesSymbol,
	        // If seting callback functions on `symbol` or `symbolSize`, for simplicity and avoiding
	        // to bring trouble, we do not pick a reuslt from one of its calling on data item here,
	        // but just use the default value. Callback on `symbol` or `symbolSize` is convenient in
	        // some cases but generally it is not recommanded.
	        symbol: seriesSymbol,
	        symbolSize: seriesSymbolSize,
	        symbolKeepAspect: keepAspect,
	        symbolRotate: symbolRotate
	      }); // Only visible series has each data be visual encoded
	
	      if (ecModel.isSeriesFiltered(seriesModel)) {
	        return;
	      }
	
	      function dataEach(data, idx) {
	        if (hasCallback) {
	          var rawValue = seriesModel.getRawValue(idx);
	          var params = seriesModel.getDataParams(idx);
	          hasSymbolTypeCallback && data.setItemVisual(idx, 'symbol', symbolType(rawValue, params));
	          hasSymbolSizeCallback && data.setItemVisual(idx, 'symbolSize', symbolSize(rawValue, params));
	          hasSymbolRotateCallback && data.setItemVisual(idx, 'symbolRotate', symbolRotate(rawValue, params));
	        }
	
	        if (data.hasItemOption) {
	          var itemModel = data.getItemModel(idx);
	          var itemSymbolType = itemModel.getShallow('symbol', true);
	          var itemSymbolSize = itemModel.getShallow('symbolSize', true);
	          var itemSymbolRotate = itemModel.getShallow('symbolRotate', true);
	          var itemSymbolKeepAspect = itemModel.getShallow('symbolKeepAspect', true); // If has item symbol
	
	          if (itemSymbolType != null) {
	            data.setItemVisual(idx, 'symbol', itemSymbolType);
	          }
	
	          if (itemSymbolSize != null) {
	            // PENDING Transform symbolSize ?
	            data.setItemVisual(idx, 'symbolSize', itemSymbolSize);
	          }
	
	          if (itemSymbolRotate != null) {
	            data.setItemVisual(idx, 'symbolRotate', itemSymbolRotate);
	          }
	
	          if (itemSymbolKeepAspect != null) {
	            data.setItemVisual(idx, 'symbolKeepAspect', itemSymbolKeepAspect);
	          }
	        }
	      }
	
	      return {
	        dataEach: data.hasItemOption || hasCallback ? dataEach : null
	      };
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * Unicode-enabled replacesments for basic String functions.
	 *
	 * All the functions in this module assume that the input string is a valid
	 * UTF-16 encoding of a Unicode sequence. If it's not the case, the behavior
	 * will be undefined.
	 *
	 * WARNING: Since this module is typechecks-enforced, you may find new bugs
	 * when replacing normal String functions with ones provided here.
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(18);
	
	// These two ranges are consecutive so anything in [HIGH_START, LOW_END] is a
	// surrogate code unit.
	var SURROGATE_HIGH_START = 0xD800;
	var SURROGATE_HIGH_END = 0xDBFF;
	var SURROGATE_LOW_START = 0xDC00;
	var SURROGATE_LOW_END = 0xDFFF;
	var SURROGATE_UNITS_REGEX = /[\uD800-\uDFFF]/;
	
	/**
	 * @param {number} codeUnit   A Unicode code-unit, in range [0, 0x10FFFF]
	 * @return {boolean}          Whether code-unit is in a surrogate (hi/low) range
	 */
	function isCodeUnitInSurrogateRange(codeUnit) {
	  return SURROGATE_HIGH_START <= codeUnit && codeUnit <= SURROGATE_LOW_END;
	}
	
	/**
	 * Returns whether the two characters starting at `index` form a surrogate pair.
	 * For example, given the string s = "\uD83D\uDE0A", (s, 0) returns true and
	 * (s, 1) returns false.
	 *
	 * @param {string} str
	 * @param {number} index
	 * @return {boolean}
	 */
	function isSurrogatePair(str, index) {
	  !(0 <= index && index < str.length) ?  false ? invariant(false, 'isSurrogatePair: Invalid index %s for string length %s.', index, str.length) : invariant(false) : void 0;
	  if (index + 1 === str.length) {
	    return false;
	  }
	  var first = str.charCodeAt(index);
	  var second = str.charCodeAt(index + 1);
	  return SURROGATE_HIGH_START <= first && first <= SURROGATE_HIGH_END && SURROGATE_LOW_START <= second && second <= SURROGATE_LOW_END;
	}
	
	/**
	 * @param {string} str  Non-empty string
	 * @return {boolean}    True if the input includes any surrogate code units
	 */
	function hasSurrogateUnit(str) {
	  return SURROGATE_UNITS_REGEX.test(str);
	}
	
	/**
	 * Return the length of the original Unicode character at given position in the
	 * String by looking into the UTF-16 code unit; that is equal to 1 for any
	 * non-surrogate characters in BMP ([U+0000..U+D7FF] and [U+E000, U+FFFF]); and
	 * returns 2 for the hi/low surrogates ([U+D800..U+DFFF]), which are in fact
	 * representing non-BMP characters ([U+10000..U+10FFFF]).
	 *
	 * Examples:
	 * - '\u0020' => 1
	 * - '\u3020' => 1
	 * - '\uD835' => 2
	 * - '\uD835\uDDEF' => 2
	 * - '\uDDEF' => 2
	 *
	 * @param {string} str  Non-empty string
	 * @param {number} pos  Position in the string to look for one code unit
	 * @return {number}      Number 1 or 2
	 */
	function getUTF16Length(str, pos) {
	  return 1 + isCodeUnitInSurrogateRange(str.charCodeAt(pos));
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#length
	 *
	 * @param {string} str  Valid Unicode string
	 * @return {number}     The number of Unicode characters in the string
	 */
	function strlen(str) {
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.length;
	  }
	
	  var len = 0;
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    len++;
	  }
	  return len;
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substr()
	 *
	 * @param {string} str      Valid Unicode string
	 * @param {number} start    Location in Unicode sequence to begin extracting
	 * @param {?number} length  The number of Unicode characters to extract
	 *                          (default: to the end of the string)
	 * @return {string}         Extracted sub-string
	 */
	function substr(str, start, length) {
	  start = start || 0;
	  length = length === undefined ? Infinity : length || 0;
	
	  // Call the native functions if there's no surrogate char
	  if (!hasSurrogateUnit(str)) {
	    return str.substr(start, length);
	  }
	
	  // Obvious cases
	  var size = str.length;
	  if (size <= 0 || start > size || length <= 0) {
	    return '';
	  }
	
	  // Find the actual starting position
	  var posA = 0;
	  if (start > 0) {
	    for (; start > 0 && posA < size; start--) {
	      posA += getUTF16Length(str, posA);
	    }
	    if (posA >= size) {
	      return '';
	    }
	  } else if (start < 0) {
	    for (posA = size; start < 0 && 0 < posA; start++) {
	      posA -= getUTF16Length(str, posA - 1);
	    }
	    if (posA < 0) {
	      posA = 0;
	    }
	  }
	
	  // Find the actual ending position
	  var posB = size;
	  if (length < size) {
	    for (posB = posA; length > 0 && posB < size; length--) {
	      posB += getUTF16Length(str, posB);
	    }
	  }
	
	  return str.substring(posA, posB);
	}
	
	/**
	 * Fully Unicode-enabled replacement for String#substring()
	 *
	 * @param {string} str    Valid Unicode string
	 * @param {number} start  Location in Unicode sequence to begin extracting
	 * @param {?number} end   Location in Unicode sequence to end extracting
	 *                        (default: end of the string)
	 * @return {string}       Extracted sub-string
	 */
	function substring(str, start, end) {
	  start = start || 0;
	  end = end === undefined ? Infinity : end || 0;
	
	  if (start < 0) {
	    start = 0;
	  }
	  if (end < 0) {
	    end = 0;
	  }
	
	  var length = Math.abs(end - start);
	  start = start < end ? start : end;
	  return substr(str, start, length);
	}
	
	/**
	 * Get a list of Unicode code-points from a String
	 *
	 * @param {string} str        Valid Unicode string
	 * @return {array<number>}    A list of code-points in [0..0x10FFFF]
	 */
	function getCodePoints(str) {
	  var codePoints = [];
	  for (var pos = 0; pos < str.length; pos += getUTF16Length(str, pos)) {
	    codePoints.push(str.codePointAt(pos));
	  }
	  return codePoints;
	}
	
	var UnicodeUtils = {
	  getCodePoints: getCodePoints,
	  getUTF16Length: getUTF16Length,
	  hasSurrogateUnit: hasSurrogateUnit,
	  isCodeUnitInSurrogateRange: isCodeUnitInSurrogateRange,
	  isSurrogatePair: isSurrogatePair,
	  strlen: strlen,
	  substring: substring,
	  substr: substr
	};
	
	module.exports = UnicodeUtils;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(255),
	    getRawTag = __webpack_require__(2544),
	    objectToString = __webpack_require__(2572);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(2515),
	    getValue = __webpack_require__(2546);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "SubMenu", {
	  enumerable: true,
	  get: function get() {
	    return _SubMenu.default;
	  }
	});
	Object.defineProperty(exports, "Item", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	Object.defineProperty(exports, "MenuItem", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	Object.defineProperty(exports, "MenuItemGroup", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItemGroup.default;
	  }
	});
	Object.defineProperty(exports, "ItemGroup", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItemGroup.default;
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	exports.default = void 0;
	
	var _Menu = _interopRequireDefault(__webpack_require__(2704));
	
	var _SubMenu = _interopRequireDefault(__webpack_require__(1092));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(2705));
	
	var _MenuItemGroup = _interopRequireDefault(__webpack_require__(2706));
	
	var _Divider = _interopRequireDefault(__webpack_require__(2703));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _Menu.default;
	exports.default = _default;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	exports.toArray = toArray;
	exports.getActiveIndex = getActiveIndex;
	exports.getActiveKey = getActiveKey;
	exports.setTransform = setTransform;
	exports.isTransform3dSupported = isTransform3dSupported;
	exports.setTransition = setTransition;
	exports.getTransformPropValue = getTransformPropValue;
	exports.isVertical = isVertical;
	exports.getTransformByIndex = getTransformByIndex;
	exports.getMarginStyle = getMarginStyle;
	exports.getStyle = getStyle;
	exports.setPxStyle = setPxStyle;
	exports.getDataAttr = getDataAttr;
	exports.getLeft = getLeft;
	exports.getTop = getTop;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArray(children) {
	  // allow [c,[a,b]]
	  var c = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    if (child) {
	      c.push(child);
	    }
	  });
	  return c;
	}
	
	function getActiveIndex(children, activeKey) {
	  var c = toArray(children);
	  for (var i = 0; i < c.length; i++) {
	    if (c[i].key === activeKey) {
	      return i;
	    }
	  }
	  return -1;
	}
	
	function getActiveKey(children, index) {
	  var c = toArray(children);
	  return c[index].key;
	}
	
	function setTransform(style, v) {
	  style.transform = v;
	  style.webkitTransform = v;
	  style.mozTransform = v;
	}
	
	function isTransform3dSupported(style) {
	  return ('transform' in style || 'webkitTransform' in style || 'MozTransform' in style) && window.atob;
	}
	
	function setTransition(style, v) {
	  style.transition = v;
	  style.webkitTransition = v;
	  style.MozTransition = v;
	}
	
	function getTransformPropValue(v) {
	  return {
	    transform: v,
	    WebkitTransform: v,
	    MozTransform: v
	  };
	}
	
	function isVertical(tabBarPosition) {
	  return tabBarPosition === 'left' || tabBarPosition === 'right';
	}
	
	function getTransformByIndex(index, tabBarPosition) {
	  var direction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'ltr';
	
	  var translate = isVertical(tabBarPosition) ? 'translateY' : 'translateX';
	
	  if (!isVertical(tabBarPosition) && direction === 'rtl') {
	    return translate + '(' + index * 100 + '%) translateZ(0)';
	  }
	  return translate + '(' + -index * 100 + '%) translateZ(0)';
	}
	
	function getMarginStyle(index, tabBarPosition) {
	  var marginDirection = isVertical(tabBarPosition) ? 'marginTop' : 'marginLeft';
	  return (0, _defineProperty3['default'])({}, marginDirection, -index * 100 + '%');
	}
	
	function getStyle(el, property) {
	  return +window.getComputedStyle(el).getPropertyValue(property).replace('px', '');
	}
	
	function setPxStyle(el, value, vertical) {
	  value = vertical ? '0px, ' + value + 'px, 0px' : value + 'px, 0px, 0px';
	  setTransform(el.style, 'translate3d(' + value + ')');
	}
	
	function getDataAttr(props) {
	  return Object.keys(props).reduce(function (prev, key) {
	    if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
	      prev[key] = props[key];
	    }
	    return prev;
	  }, {});
	}
	
	function toNum(style, property) {
	  return +style.getPropertyValue(property).replace('px', '');
	}
	
	function getTypeValue(start, current, end, tabNode, wrapperNode) {
	  var total = getStyle(wrapperNode, 'padding-' + start);
	  if (!tabNode || !tabNode.parentNode) {
	    return total;
	  }
	
	  var childNodes = tabNode.parentNode.childNodes;
	
	  Array.prototype.some.call(childNodes, function (node) {
	    var style = window.getComputedStyle(node);
	
	    if (node !== tabNode) {
	      total += toNum(style, 'margin-' + start);
	      total += node[current];
	      total += toNum(style, 'margin-' + end);
	
	      if (style.boxSizing === 'content-box') {
	        total += toNum(style, 'border-' + start + '-width') + toNum(style, 'border-' + end + '-width');
	      }
	      return false;
	    }
	
	    // We need count current node margin
	    // ref: https://github.com/react-component/tabs/pull/139#issuecomment-431005262
	    total += toNum(style, 'margin-' + start);
	
	    return true;
	  });
	
	  return total;
	}
	
	function getLeft(tabNode, wrapperNode) {
	  return getTypeValue('left', 'offsetWidth', 'right', tabNode, wrapperNode);
	}
	
	function getTop(tabNode, wrapperNode) {
	  return getTypeValue('top', 'offsetHeight', 'bottom', tabNode, wrapperNode);
	}

/***/ },
/* 221 */
[3064, 47],
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(2844);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(4);
	
	var Element = __webpack_require__(1187);
	
	var BoundingRect = __webpack_require__(60);
	
	/**
	 * Group是一个容器，可以插入子节点，Group的变换也会被应用到子节点上
	 * @module zrender/graphic/Group
	 * @example
	 *     var Group = require('zrender/container/Group');
	 *     var Circle = require('zrender/graphic/shape/Circle');
	 *     var g = new Group();
	 *     g.position[0] = 100;
	 *     g.position[1] = 100;
	 *     g.add(new Circle({
	 *         style: {
	 *             x: 100,
	 *             y: 100,
	 *             r: 20,
	 *         }
	 *     }));
	 *     zr.add(g);
	 */
	
	/**
	 * @alias module:zrender/graphic/Group
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @extends module:zrender/mixin/Eventful
	 */
	var Group = function (opts) {
	  opts = opts || {};
	  Element.call(this, opts);
	
	  for (var key in opts) {
	    if (opts.hasOwnProperty(key)) {
	      this[key] = opts[key];
	    }
	  }
	
	  this._children = [];
	  this.__storage = null;
	  this.__dirty = true;
	};
	
	Group.prototype = {
	  constructor: Group,
	  isGroup: true,
	
	  /**
	   * @type {string}
	   */
	  type: 'group',
	
	  /**
	   * 所有子孙元素是否响应鼠标事件
	   * @name module:/zrender/container/Group#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * @return {Array.<module:zrender/Element>}
	   */
	  children: function () {
	    return this._children.slice();
	  },
	
	  /**
	   * 获取指定 index 的儿子节点
	   * @param  {number} idx
	   * @return {module:zrender/Element}
	   */
	  childAt: function (idx) {
	    return this._children[idx];
	  },
	
	  /**
	   * 获取指定名字的儿子节点
	   * @param  {string} name
	   * @return {module:zrender/Element}
	   */
	  childOfName: function (name) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      if (children[i].name === name) {
	        return children[i];
	      }
	    }
	  },
	
	  /**
	   * @return {number}
	   */
	  childCount: function () {
	    return this._children.length;
	  },
	
	  /**
	   * 添加子节点到最后
	   * @param {module:zrender/Element} child
	   */
	  add: function (child) {
	    if (child && child !== this && child.parent !== this) {
	      this._children.push(child);
	
	      this._doAdd(child);
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加子节点在 nextSibling 之前
	   * @param {module:zrender/Element} child
	   * @param {module:zrender/Element} nextSibling
	   */
	  addBefore: function (child, nextSibling) {
	    if (child && child !== this && child.parent !== this && nextSibling && nextSibling.parent === this) {
	      var children = this._children;
	      var idx = children.indexOf(nextSibling);
	
	      if (idx >= 0) {
	        children.splice(idx, 0, child);
	
	        this._doAdd(child);
	      }
	    }
	
	    return this;
	  },
	  _doAdd: function (child) {
	    if (child.parent) {
	      child.parent.remove(child);
	    }
	
	    child.parent = this;
	    var storage = this.__storage;
	    var zr = this.__zr;
	
	    if (storage && storage !== child.__storage) {
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	  },
	
	  /**
	   * 移除子节点
	   * @param {module:zrender/Element} child
	   */
	  remove: function (child) {
	    var zr = this.__zr;
	    var storage = this.__storage;
	    var children = this._children;
	    var idx = zrUtil.indexOf(children, child);
	
	    if (idx < 0) {
	      return this;
	    }
	
	    children.splice(idx, 1);
	    child.parent = null;
	
	    if (storage) {
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	
	    zr && zr.refresh();
	    return this;
	  },
	
	  /**
	   * 移除所有子节点
	   */
	  removeAll: function () {
	    var children = this._children;
	    var storage = this.__storage;
	    var child;
	    var i;
	
	    for (i = 0; i < children.length; i++) {
	      child = children[i];
	
	      if (storage) {
	        storage.delFromStorage(child);
	
	        if (child instanceof Group) {
	          child.delChildrenFromStorage(storage);
	        }
	      }
	
	      child.parent = null;
	    }
	
	    children.length = 0;
	    return this;
	  },
	
	  /**
	   * 遍历所有子节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  eachChild: function (cb, context) {
	    var children = this._children;
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	      cb.call(context, child, i);
	    }
	
	    return this;
	  },
	
	  /**
	   * 深度优先遍历所有子孙节点
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      cb.call(context, child);
	
	      if (child.type === 'group') {
	        child.traverse(cb, context);
	      }
	    }
	
	    return this;
	  },
	  addChildrenToStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.addToStorage(child);
	
	      if (child instanceof Group) {
	        child.addChildrenToStorage(storage);
	      }
	    }
	  },
	  delChildrenFromStorage: function (storage) {
	    for (var i = 0; i < this._children.length; i++) {
	      var child = this._children[i];
	      storage.delFromStorage(child);
	
	      if (child instanceof Group) {
	        child.delChildrenFromStorage(storage);
	      }
	    }
	  },
	  dirty: function () {
	    this.__dirty = true;
	    this.__zr && this.__zr.refresh();
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function (includeChildren) {
	    // TODO Caching
	    var rect = null;
	    var tmpRect = new BoundingRect(0, 0, 0, 0);
	    var children = includeChildren || this._children;
	    var tmpMat = [];
	
	    for (var i = 0; i < children.length; i++) {
	      var child = children[i];
	
	      if (child.ignore || child.invisible) {
	        continue;
	      }
	
	      var childRect = child.getBoundingRect();
	      var transform = child.getLocalTransform(tmpMat); // TODO
	      // The boundingRect cacluated by transforming original
	      // rect may be bigger than the actual bundingRect when rotation
	      // is used. (Consider a circle rotated aginst its center, where
	      // the actual boundingRect should be the same as that not be
	      // rotated.) But we can not find better approach to calculate
	      // actual boundingRect yet, considering performance.
	
	      if (transform) {
	        tmpRect.copy(childRect);
	        tmpRect.applyTransform(transform);
	        rect = rect || tmpRect.clone();
	        rect.union(tmpRect);
	      } else {
	        rect = rect || childRect.clone();
	        rect.union(childRect);
	      }
	    }
	
	    return rect || tmpRect;
	  }
	};
	zrUtil.inherits(Group, Element);
	var _default = Group;
	module.exports = _default;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(316);
	
	var zrUtil = __webpack_require__(4);
	
	var textContain = __webpack_require__(102);
	
	var textHelper = __webpack_require__(395);
	
	var _constant = __webpack_require__(394);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	
	/**
	 * @alias zrender/graphic/Text
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	var Text = function (opts) {
	  // jshint ignore:line
	  Displayable.call(this, opts);
	};
	
	Text.prototype = {
	  constructor: Text,
	  type: 'text',
	  brush: function (ctx, prevEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true); // Use props with prefix 'text'.
	
	    style.fill = style.stroke = style.shadowBlur = style.shadowColor = style.shadowOffsetX = style.shadowOffsetY = null;
	    var text = style.text; // Convert to string
	
	    text != null && (text += ''); // Do not apply style.bind in Text node. Because the real bind job
	    // is in textHelper.renderText, and performance of text render should
	    // be considered.
	    // style.bind(ctx, this, prevEl);
	
	    if (!textHelper.needDrawText(text, style)) {
	      // The current el.style is not applied
	      // and should not be used as cache.
	      ctx.__attrCachedBy = ContextCachedBy.NONE;
	      return;
	    }
	
	    this.setTransform(ctx);
	    textHelper.renderText(this, ctx, text, style, null, prevEl);
	    this.restoreTransform(ctx);
	  },
	  getBoundingRect: function () {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	
	    if (!this._rect) {
	      var text = style.text;
	      text != null ? text += '' : text = '';
	      var rect = textContain.getBoundingRect(style.text + '', style.font, style.textAlign, style.textVerticalAlign, style.textPadding, style.textLineHeight, style.rich);
	      rect.x += style.x || 0;
	      rect.y += style.y || 0;
	
	      if (textHelper.getStroke(style.textStroke, style.textStrokeWidth)) {
	        var w = style.textStrokeWidth;
	        rect.x -= w / 2;
	        rect.y -= w / 2;
	        rect.width += w;
	        rect.height += w;
	      }
	
	      this._rect = rect;
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(Text, Displayable);
	var _default = Text;
	module.exports = _default;

/***/ },
/* 225 */
/***/ function(module, exports) {

	/**
	 * Event Mixin
	 * @module zrender/mixin/Eventful
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         pissang (https://www.github.com/pissang)
	 */
	var arrySlice = Array.prototype.slice;
	/**
	 * Event dispatcher.
	 *
	 * @alias module:zrender/mixin/Eventful
	 * @constructor
	 * @param {Object} [eventProcessor] The object eventProcessor is the scope when
	 *        `eventProcessor.xxx` called.
	 * @param {Function} [eventProcessor.normalizeQuery]
	 *        param: {string|Object} Raw query.
	 *        return: {string|Object} Normalized query.
	 * @param {Function} [eventProcessor.filter] Event will be dispatched only
	 *        if it returns `true`.
	 *        param: {string} eventType
	 *        param: {string|Object} query
	 *        return: {boolean}
	 * @param {Function} [eventProcessor.afterTrigger] Called after all handlers called.
	 *        param: {string} eventType
	 */
	
	var Eventful = function (eventProcessor) {
	  this._$handlers = {};
	  this._$eventProcessor = eventProcessor;
	};
	
	Eventful.prototype = {
	  constructor: Eventful,
	
	  /**
	   * The handler can only be triggered once, then removed.
	   *
	   * @param {string} event The event name.
	   * @param {string|Object} [query] Condition used on event filter.
	   * @param {Function} handler The event handler.
	   * @param {Object} context
	   */
	  one: function (event, query, handler, context) {
	    return on(this, event, query, handler, context, true);
	  },
	
	  /**
	   * Bind a handler.
	   *
	   * @param {string} event The event name.
	   * @param {string|Object} [query] Condition used on event filter.
	   * @param {Function} handler The event handler.
	   * @param {Object} [context]
	   */
	  on: function (event, query, handler, context) {
	    return on(this, event, query, handler, context, false);
	  },
	
	  /**
	   * Whether any handler has bound.
	   *
	   * @param  {string}  event
	   * @return {boolean}
	   */
	  isSilent: function (event) {
	    var _h = this._$handlers;
	    return !_h[event] || !_h[event].length;
	  },
	
	  /**
	   * Unbind a event.
	   *
	   * @param {string} [event] The event name.
	   *        If no `event` input, "off" all listeners.
	   * @param {Function} [handler] The event handler.
	   *        If no `handler` input, "off" all listeners of the `event`.
	   */
	  off: function (event, handler) {
	    var _h = this._$handlers;
	
	    if (!event) {
	      this._$handlers = {};
	      return this;
	    }
	
	    if (handler) {
	      if (_h[event]) {
	        var newList = [];
	
	        for (var i = 0, l = _h[event].length; i < l; i++) {
	          if (_h[event][i].h !== handler) {
	            newList.push(_h[event][i]);
	          }
	        }
	
	        _h[event] = newList;
	      }
	
	      if (_h[event] && _h[event].length === 0) {
	        delete _h[event];
	      }
	    } else {
	      delete _h[event];
	    }
	
	    return this;
	  },
	
	  /**
	   * Dispatch a event.
	   *
	   * @param {string} type The event name.
	   */
	  trigger: function (type) {
	    var _h = this._$handlers[type];
	    var eventProcessor = this._$eventProcessor;
	
	    if (_h) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 3) {
	        args = arrySlice.call(args, 1);
	      }
	
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        var hItem = _h[i];
	
	        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
	          i++;
	          continue;
	        } // Optimize advise from backbone
	
	
	        switch (argLen) {
	          case 1:
	            hItem.h.call(hItem.ctx);
	            break;
	
	          case 2:
	            hItem.h.call(hItem.ctx, args[1]);
	            break;
	
	          case 3:
	            hItem.h.call(hItem.ctx, args[1], args[2]);
	            break;
	
	          default:
	            // have more than 2 given arguments
	            hItem.h.apply(hItem.ctx, args);
	            break;
	        }
	
	        if (hItem.one) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
	    return this;
	  },
	
	  /**
	   * Dispatch a event with context, which is specified at the last parameter.
	   *
	   * @param {string} type The event name.
	   */
	  triggerWithContext: function (type) {
	    var _h = this._$handlers[type];
	    var eventProcessor = this._$eventProcessor;
	
	    if (_h) {
	      var args = arguments;
	      var argLen = args.length;
	
	      if (argLen > 4) {
	        args = arrySlice.call(args, 1, args.length - 1);
	      }
	
	      var ctx = args[args.length - 1];
	      var len = _h.length;
	
	      for (var i = 0; i < len;) {
	        var hItem = _h[i];
	
	        if (eventProcessor && eventProcessor.filter && hItem.query != null && !eventProcessor.filter(type, hItem.query)) {
	          i++;
	          continue;
	        } // Optimize advise from backbone
	
	
	        switch (argLen) {
	          case 1:
	            hItem.h.call(ctx);
	            break;
	
	          case 2:
	            hItem.h.call(ctx, args[1]);
	            break;
	
	          case 3:
	            hItem.h.call(ctx, args[1], args[2]);
	            break;
	
	          default:
	            // have more than 2 given arguments
	            hItem.h.apply(ctx, args);
	            break;
	        }
	
	        if (hItem.one) {
	          _h.splice(i, 1);
	
	          len--;
	        } else {
	          i++;
	        }
	      }
	    }
	
	    eventProcessor && eventProcessor.afterTrigger && eventProcessor.afterTrigger(type);
	    return this;
	  }
	};
	
	function normalizeQuery(host, query) {
	  var eventProcessor = host._$eventProcessor;
	
	  if (query != null && eventProcessor && eventProcessor.normalizeQuery) {
	    query = eventProcessor.normalizeQuery(query);
	  }
	
	  return query;
	}
	
	function on(eventful, event, query, handler, context, isOnce) {
	  var _h = eventful._$handlers;
	
	  if (typeof query === 'function') {
	    context = handler;
	    handler = query;
	    query = null;
	  }
	
	  if (!handler || !event) {
	    return eventful;
	  }
	
	  query = normalizeQuery(eventful, query);
	
	  if (!_h[event]) {
	    _h[event] = [];
	  }
	
	  for (var i = 0; i < _h[event].length; i++) {
	    if (_h[event][i].h === handler) {
	      return eventful;
	    }
	  }
	
	  var wrap = {
	    h: handler,
	    one: isOnce,
	    query: query,
	    ctx: context || eventful,
	    // FIXME
	    // Do not publish this feature util it is proved that it makes sense.
	    callAtLast: handler.zrEventfulCallAtLast
	  };
	  var lastIndex = _h[event].length - 1;
	  var lastWrap = _h[event][lastIndex];
	  lastWrap && lastWrap.callAtLast ? _h[event].splice(lastIndex, 0, wrap) : _h[event].push(wrap);
	  return eventful;
	} // ----------------------
	// The events in zrender
	// ----------------------
	
	/**
	 * @event module:zrender/mixin/Eventful#onclick
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseout
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousemove
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousewheel
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmousedown
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#onmouseup
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrag
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragstart
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragend
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragenter
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragleave
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondragover
	 * @type {Function}
	 * @default null
	 */
	
	/**
	 * @event module:zrender/mixin/Eventful#ondrop
	 * @type {Function}
	 * @default null
	 */
	
	
	var _default = Eventful;
	module.exports = _default;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(622));
	
	var _Group = _interopRequireDefault(__webpack_require__(1252));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_Checkbox["default"].Group = _Group["default"];
	var _default = _Checkbox["default"];
	exports["default"] = _default;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(1096));
	
	var _en_US2 = _interopRequireDefault(__webpack_require__(405));
	
	var _en_US3 = _interopRequireDefault(__webpack_require__(415));
	
	var _en_US4 = _interopRequireDefault(__webpack_require__(621));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = {
	  locale: 'en',
	  Pagination: _en_US["default"],
	  DatePicker: _en_US2["default"],
	  TimePicker: _en_US3["default"],
	  Calendar: _en_US4["default"],
	  global: {
	    placeholder: 'Please select'
	  },
	  Table: {
	    filterTitle: 'Filter menu',
	    filterConfirm: 'OK',
	    filterReset: 'Reset',
	    selectAll: 'Select current page',
	    selectInvert: 'Invert current page',
	    sortTitle: 'Sort',
	    expand: 'Expand row',
	    collapse: 'Collapse row'
	  },
	  Modal: {
	    okText: 'OK',
	    cancelText: 'Cancel',
	    justOkText: 'OK'
	  },
	  Popconfirm: {
	    okText: 'OK',
	    cancelText: 'Cancel'
	  },
	  Transfer: {
	    titles: ['', ''],
	    searchPlaceholder: 'Search here',
	    itemUnit: 'item',
	    itemsUnit: 'items'
	  },
	  Upload: {
	    uploading: 'Uploading...',
	    removeFile: 'Remove file',
	    uploadError: 'Upload error',
	    previewFile: 'Preview file',
	    downloadFile: 'Download file'
	  },
	  Empty: {
	    description: 'No Data'
	  },
	  Icon: {
	    icon: 'icon'
	  },
	  Text: {
	    edit: 'Edit',
	    copy: 'Copy',
	    copied: 'Copied',
	    expand: 'Expand'
	  },
	  PageHeader: {
	    back: 'Back'
	  }
	};
	exports["default"] = _default;

/***/ },
/* 228 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var scrollbarVerticalSize;
	var scrollbarHorizontalSize; // Measure scrollbar width for padding body during modal show/hide
	
	var scrollbarMeasure = {
	  position: 'absolute',
	  top: '-9999px',
	  width: '50px',
	  height: '50px'
	}; // This const is used for colgroup.col internal props. And should not provides to user.
	
	exports.INTERNAL_COL_DEFINE = 'RC_TABLE_INTERNAL_COL_DEFINE';
	
	function measureScrollbar(_ref) {
	  var _ref$direction = _ref.direction,
	      direction = _ref$direction === void 0 ? 'vertical' : _ref$direction,
	      prefixCls = _ref.prefixCls;
	
	  if (typeof document === 'undefined' || typeof window === 'undefined') {
	    return 0;
	  }
	
	  var isVertical = direction === 'vertical';
	
	  if (isVertical && scrollbarVerticalSize) {
	    return scrollbarVerticalSize;
	  }
	
	  if (!isVertical && scrollbarHorizontalSize) {
	    return scrollbarHorizontalSize;
	  }
	
	  var scrollDiv = document.createElement('div');
	  Object.keys(scrollbarMeasure).forEach(function (scrollProp) {
	    scrollDiv.style[scrollProp] = scrollbarMeasure[scrollProp];
	  }); // apply hide scrollbar className ahead
	
	  scrollDiv.className = "".concat(prefixCls, "-hide-scrollbar scroll-div-append-to-body"); // Append related overflow style
	
	  if (isVertical) {
	    scrollDiv.style.overflowY = 'scroll';
	  } else {
	    scrollDiv.style.overflowX = 'scroll';
	  }
	
	  document.body.appendChild(scrollDiv);
	  var size = 0;
	
	  if (isVertical) {
	    size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	    scrollbarVerticalSize = size;
	  } else {
	    size = scrollDiv.offsetHeight - scrollDiv.clientHeight;
	    scrollbarHorizontalSize = size;
	  }
	
	  document.body.removeChild(scrollDiv);
	  return size;
	}
	
	exports.measureScrollbar = measureScrollbar;
	
	function debounce(func, wait, immediate) {
	  var timeout;
	
	  function debounceFunc() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var context = this; // https://fb.me/react-event-pooling
	
	    if (args[0] && args[0].persist) {
	      args[0].persist();
	    }
	
	    var later = function later() {
	      timeout = null;
	
	      if (!immediate) {
	        func.apply(context, args);
	      }
	    };
	
	    var callNow = immediate && !timeout;
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	
	    if (callNow) {
	      func.apply(context, args);
	    }
	  }
	
	  debounceFunc.cancel = function cancel() {
	    if (timeout) {
	      clearTimeout(timeout);
	      timeout = null;
	    }
	  };
	
	  return debounceFunc;
	}
	
	exports.debounce = debounce;
	
	function remove(array, item) {
	  var index = array.indexOf(item);
	  var front = array.slice(0, index);
	  var last = array.slice(index + 1, array.length);
	  return front.concat(last);
	}
	
	exports.remove = remove;
	/**
	 * Returns only data- and aria- key/value pairs
	 * @param {object} props
	 */
	
	function getDataAndAriaProps(props) {
	  return Object.keys(props).reduce(function (memo, key) {
	    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-') {
	      memo[key] = props[key];
	    }
	
	    return memo;
	  }, {});
	}
	
	exports.getDataAndAriaProps = getDataAndAriaProps;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.querySaveWritePurchase = exports.queryPurchaseWriteInfo = exports.queryPurchaseWorkflow = exports.queryCallbackPurchase = exports.queryReturnPurchase = exports.queryTransferPurchase = exports.queryNextPurchase = exports.queryDeletePurchase = exports.querySavePurchase = exports.queryPurchaseInfo = exports.queryPurchaseOrgRecord = exports.queryPurchaseIncubatorStatic = exports.queryPurchaseOrgStatic = exports.queryMyPurchaseCheckList = exports.queryPurchaseMyList = exports.queryPurchaseList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 采购
	 */
	var queryPurchaseList = exports.queryPurchaseList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.administrative.GET_PURCHASE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryPurchaseList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryPurchaseMyList = exports.queryPurchaseMyList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.administrative.GET_PURCHASE_MY, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryPurchaseMyList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryMyPurchaseCheckList = exports.queryMyPurchaseCheckList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.administrative.GET_PURCHASE_CHECK, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryMyPurchaseCheckList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryPurchaseOrgStatic = exports.queryPurchaseOrgStatic = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.administrative.GET_PURCHASE_STATIC_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryPurchaseOrgStatic(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryPurchaseIncubatorStatic = exports.queryPurchaseIncubatorStatic = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.administrative.GET_PURCHASE_STATIC_INCUBATOR, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryPurchaseIncubatorStatic(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryPurchaseOrgRecord = exports.queryPurchaseOrgRecord = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.administrative.GET_PURCHASE_RECORD_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryPurchaseOrgRecord(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryPurchaseInfo = exports.queryPurchaseInfo = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.administrative.GET_PURCHASE_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryPurchaseInfo(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var querySavePurchase = exports.querySavePurchase = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.post(_req.administrative.PURCHASE_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function querySavePurchase(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryDeletePurchase = exports.queryDeletePurchase = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.administrative.PURCHASE_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryDeletePurchase(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryNextPurchase = exports.queryNextPurchase = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.administrative.PURCHASE_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryNextPurchase(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryTransferPurchase = exports.queryTransferPurchase = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.post(_req.administrative.PURCHASE_TRANSFER, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryTransferPurchase(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var queryReturnPurchase = exports.queryReturnPurchase = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.post(_req.administrative.PURCHASE_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryReturnPurchase(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var queryCallbackPurchase = exports.queryCallbackPurchase = function () {
	  var _ref13 = _asyncToGenerator(_regenerator2.default.mark(function _callee13(params) {
	    return _regenerator2.default.wrap(function _callee13$(_context13) {
	      while (1) {
	        switch (_context13.prev = _context13.next) {
	          case 0:
	            return _context13.abrupt('return', _http2.default.get(_req.administrative.PURCHASE_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context13.stop();
	        }
	      }
	    }, _callee13, this);
	  }));
	
	  return function queryCallbackPurchase(_x13) {
	    return _ref13.apply(this, arguments);
	  };
	}();
	
	var queryPurchaseWorkflow = exports.queryPurchaseWorkflow = function () {
	  var _ref14 = _asyncToGenerator(_regenerator2.default.mark(function _callee14(params) {
	    return _regenerator2.default.wrap(function _callee14$(_context14) {
	      while (1) {
	        switch (_context14.prev = _context14.next) {
	          case 0:
	            return _context14.abrupt('return', _http2.default.get(_req.administrative.PURCHASE_WORKFLOW, params));
	
	          case 1:
	          case 'end':
	            return _context14.stop();
	        }
	      }
	    }, _callee14, this);
	  }));
	
	  return function queryPurchaseWorkflow(_x14) {
	    return _ref14.apply(this, arguments);
	  };
	}();
	
	var queryPurchaseWriteInfo = exports.queryPurchaseWriteInfo = function () {
	  var _ref15 = _asyncToGenerator(_regenerator2.default.mark(function _callee15(params) {
	    return _regenerator2.default.wrap(function _callee15$(_context15) {
	      while (1) {
	        switch (_context15.prev = _context15.next) {
	          case 0:
	            return _context15.abrupt('return', _http2.default.get(_req.administrative.GET_PURCHASE_WRITE_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context15.stop();
	        }
	      }
	    }, _callee15, this);
	  }));
	
	  return function queryPurchaseWriteInfo(_x15) {
	    return _ref15.apply(this, arguments);
	  };
	}();
	
	var querySaveWritePurchase = exports.querySaveWritePurchase = function () {
	  var _ref16 = _asyncToGenerator(_regenerator2.default.mark(function _callee16(params) {
	    return _regenerator2.default.wrap(function _callee16$(_context16) {
	      while (1) {
	        switch (_context16.prev = _context16.next) {
	          case 0:
	            return _context16.abrupt('return', _http2.default.post(_req.administrative.PURCHASE_WRITE_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context16.stop();
	        }
	      }
	    }, _callee16, this);
	  }));
	
	  return function querySaveWritePurchase(_x16) {
	    return _ref16.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryPlatformTransferWorkflow = exports.queryCallbackPlatformTransfer = exports.queryReturnPlatformTransfer = exports.queryNextPlatformTransfer = exports.queryDeletePlatformTransfer = exports.querySavePlatformTransfer = exports.queryPlatformTransferInfo = exports.queryPlatformTransferOrgRecord = exports.queryPlatformTransferOrgStatic = exports.queryMyPlatformTransferCheckList = exports.queryPlatformTransferMyList = exports.queryPlatformTransferList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 平台划款
	 */
	var queryPlatformTransferList = exports.queryPlatformTransferList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.finance.GET_PLATFORM_TRANSFER_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryPlatformTransferList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryPlatformTransferMyList = exports.queryPlatformTransferMyList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.finance.GET_PLATFORM_TRANSFER_MY, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryPlatformTransferMyList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryMyPlatformTransferCheckList = exports.queryMyPlatformTransferCheckList = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.finance.GET_PLATFORM_TRANSFER_CHECK, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryMyPlatformTransferCheckList(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryPlatformTransferOrgStatic = exports.queryPlatformTransferOrgStatic = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.finance.GET_PLATFORM_TRANSFER_STATIC_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryPlatformTransferOrgStatic(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryPlatformTransferOrgRecord = exports.queryPlatformTransferOrgRecord = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.finance.GET_PLATFORM_TRANSFER_RECORD_ORG, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryPlatformTransferOrgRecord(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryPlatformTransferInfo = exports.queryPlatformTransferInfo = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.finance.GET_PLATFORM_TRANSFER_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryPlatformTransferInfo(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var querySavePlatformTransfer = exports.querySavePlatformTransfer = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.post(_req.finance.PLATFORM_TRANSFER_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function querySavePlatformTransfer(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var queryDeletePlatformTransfer = exports.queryDeletePlatformTransfer = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.finance.PLATFORM_TRANSFER_DELETE, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryDeletePlatformTransfer(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryNextPlatformTransfer = exports.queryNextPlatformTransfer = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.finance.PLATFORM_TRANSFER_NEXT, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryNextPlatformTransfer(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryReturnPlatformTransfer = exports.queryReturnPlatformTransfer = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.post(_req.finance.PLATFORM_TRANSFER_RETURN, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryReturnPlatformTransfer(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var queryCallbackPlatformTransfer = exports.queryCallbackPlatformTransfer = function () {
	  var _ref11 = _asyncToGenerator(_regenerator2.default.mark(function _callee11(params) {
	    return _regenerator2.default.wrap(function _callee11$(_context11) {
	      while (1) {
	        switch (_context11.prev = _context11.next) {
	          case 0:
	            return _context11.abrupt('return', _http2.default.get(_req.finance.PLATFORM_TRANSFER_CALLBACK, params));
	
	          case 1:
	          case 'end':
	            return _context11.stop();
	        }
	      }
	    }, _callee11, this);
	  }));
	
	  return function queryCallbackPlatformTransfer(_x11) {
	    return _ref11.apply(this, arguments);
	  };
	}();
	
	var queryPlatformTransferWorkflow = exports.queryPlatformTransferWorkflow = function () {
	  var _ref12 = _asyncToGenerator(_regenerator2.default.mark(function _callee12(params) {
	    return _regenerator2.default.wrap(function _callee12$(_context12) {
	      while (1) {
	        switch (_context12.prev = _context12.next) {
	          case 0:
	            return _context12.abrupt('return', _http2.default.get(_req.finance.PLATFORM_TRANSFER_WORKFLOW, params));
	
	          case 1:
	          case 'end':
	            return _context12.stop();
	        }
	      }
	    }, _callee12, this);
	  }));
	
	  return function queryPlatformTransferWorkflow(_x12) {
	    return _ref12.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryIndustryList = exports.queryCancelProtection = exports.queryProtectionRenewal = exports.queryProtectionInfo = exports.querySaveProtection = exports.queryProtectionSearch = exports.queryProtectionHistoryList = exports.queryProtectionList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 保护的客户列表
	 */
	var queryProtectionList = exports.queryProtectionList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.xxcrm.CUSTOM_PROTECTION_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryProtectionList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 保护的客户历史列表
	 */
	
	
	var queryProtectionHistoryList = exports.queryProtectionHistoryList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.xxcrm.CUSTOM_PROTECTION_HISTORY, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryProtectionHistoryList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	/**
	 * 保护客户查询
	 */
	
	
	var queryProtectionSearch = exports.queryProtectionSearch = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(name) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.xxcrm.CUSTOM_PROTECTION_SEARCH, { name: name }));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryProtectionSearch(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	/**
	 * 添加客户保护
	 */
	
	
	var querySaveProtection = exports.querySaveProtection = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.post(_req.xxcrm.CUSTOM_PROTECTION_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function querySaveProtection(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	/**
	 * 客户明细
	 */
	
	
	var queryProtectionInfo = exports.queryProtectionInfo = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(uuid) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.xxcrm.CUSTOM_PROTECTION_INFO, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryProtectionInfo(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	/**
	 * 续保
	 */
	
	
	var queryProtectionRenewal = exports.queryProtectionRenewal = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(uuid) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.xxcrm.CUSTOM_PROTECTION_RENEWAL, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryProtectionRenewal(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	/**
	 * 取消续保
	 */
	
	
	var queryCancelProtection = exports.queryCancelProtection = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(uuid) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.get(_req.xxcrm.CUSTOM_PROTECTION_CANCEL, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryCancelProtection(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取行业列表
	 */
	
	
	var queryIndustryList = exports.queryIndustryList = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8() {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.core.DICT_INDUSTRY_LIST));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryIndustryList() {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAccountSearch = getAccountSearch;
	exports.coreAccountSearch = coreAccountSearch;
	
	var _user = __webpack_require__(54);
	
	// 按模块的action, reducer整合体
	var CORE_ACCOUNT_SEARCH = 'CORE_ACCOUNT_SEARCH'; // 全部用户
	function getAccountSearch() {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        search = _getState.core_account_search;
	
	    if (search.length > 0) {
	      return dispatch({
	        type: CORE_ACCOUNT_SEARCH,
	        data: search
	      });
	    }
	    return (0, _user.queryCoreAccountSearch)().then(function (res) {
	      if (res.statusCode === 200) {
	        return dispatch({
	          type: CORE_ACCOUNT_SEARCH,
	          data: res.data
	        });
	      }
	    });
	  };
	}
	
	function coreAccountSearch() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case CORE_ACCOUNT_SEARCH:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveIncomeInfo = saveIncomeInfo;
	exports.incomeInfo = incomeInfo;
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 按模块的action, reducer整合体
	var INCOME_INFO = 'INCOME_INFO';
	
	function saveIncomeInfo(params) {
	  return function (dispatch) {
	    _localDb2.default.set(INCOME_INFO, params);
	    return dispatch({
	      type: INCOME_INFO,
	      data: params
	    });
	  };
	}
	
	// Reducer
	function incomeInfo() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case INCOME_INFO:
	      return action.data;
	    default:
	      return _localDb2.default.get(INCOME_INFO);
	  }
	}

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getWorkOrgList = getWorkOrgList;
	exports.workOrgList = workOrgList;
	
	var _workOrg = __webpack_require__(191);
	
	// 按模块的action, reducer整合体
	var WORK_ORG_LIST = 'WORK_ORG_LIST';
	
	function getWorkOrgList(params) {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        list = _getState.work_org_list;
	
	    if (list.length > 0) {
	      return dispatch({
	        type: WORK_ORG_LIST,
	        data: list
	      });
	    }
	    return (0, _workOrg.queryWorkOrg)(params).then(function (res) {
	      if (res.statusCode === 200) {
	        return dispatch({
	          type: WORK_ORG_LIST,
	          data: res.data
	        });
	      }
	    });
	  };
	}
	
	function workOrgList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case WORK_ORG_LIST:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 *  big.js v5.2.2
	 *  A small, fast, easy-to-use library for arbitrary-precision decimal arithmetic.
	 *  Copyright (c) 2018 Michael Mclaughlin <M8ch88l@gmail.com>
	 *  https://github.com/MikeMcl/big.js/LICENCE
	 */
	;(function (GLOBAL) {
	  'use strict';
	  var Big,
	
	
	/************************************** EDITABLE DEFAULTS *****************************************/
	
	
	    // The default values below must be integers within the stated ranges.
	
	    /*
	     * The maximum number of decimal places (DP) of the results of operations involving division:
	     * div and sqrt, and pow with negative exponents.
	     */
	    DP = 20,          // 0 to MAX_DP
	
	    /*
	     * The rounding mode (RM) used when rounding to the above decimal places.
	     *
	     *  0  Towards zero (i.e. truncate, no rounding).       (ROUND_DOWN)
	     *  1  To nearest neighbour. If equidistant, round up.  (ROUND_HALF_UP)
	     *  2  To nearest neighbour. If equidistant, to even.   (ROUND_HALF_EVEN)
	     *  3  Away from zero.                                  (ROUND_UP)
	     */
	    RM = 1,             // 0, 1, 2 or 3
	
	    // The maximum value of DP and Big.DP.
	    MAX_DP = 1E6,       // 0 to 1000000
	
	    // The maximum magnitude of the exponent argument to the pow method.
	    MAX_POWER = 1E6,    // 1 to 1000000
	
	    /*
	     * The negative exponent (NE) at and beneath which toString returns exponential notation.
	     * (JavaScript numbers: -7)
	     * -1000000 is the minimum recommended exponent value of a Big.
	     */
	    NE = -7,            // 0 to -1000000
	
	    /*
	     * The positive exponent (PE) at and above which toString returns exponential notation.
	     * (JavaScript numbers: 21)
	     * 1000000 is the maximum recommended exponent value of a Big.
	     * (This limit is not enforced or checked.)
	     */
	    PE = 21,            // 0 to 1000000
	
	
	/**************************************************************************************************/
	
	
	    // Error messages.
	    NAME = '[big.js] ',
	    INVALID = NAME + 'Invalid ',
	    INVALID_DP = INVALID + 'decimal places',
	    INVALID_RM = INVALID + 'rounding mode',
	    DIV_BY_ZERO = NAME + 'Division by zero',
	
	    // The shared prototype object.
	    P = {},
	    UNDEFINED = void 0,
	    NUMERIC = /^-?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i;
	
	
	  /*
	   * Create and return a Big constructor.
	   *
	   */
	  function _Big_() {
	
	    /*
	     * The Big constructor and exported function.
	     * Create and return a new instance of a Big number object.
	     *
	     * n {number|string|Big} A numeric value.
	     */
	    function Big(n) {
	      var x = this;
	
	      // Enable constructor usage without new.
	      if (!(x instanceof Big)) return n === UNDEFINED ? _Big_() : new Big(n);
	
	      // Duplicate.
	      if (n instanceof Big) {
	        x.s = n.s;
	        x.e = n.e;
	        x.c = n.c.slice();
	      } else {
	        parse(x, n);
	      }
	
	      /*
	       * Retain a reference to this Big constructor, and shadow Big.prototype.constructor which
	       * points to Object.
	       */
	      x.constructor = Big;
	    }
	
	    Big.prototype = P;
	    Big.DP = DP;
	    Big.RM = RM;
	    Big.NE = NE;
	    Big.PE = PE;
	    Big.version = '5.2.2';
	
	    return Big;
	  }
	
	
	  /*
	   * Parse the number or string value passed to a Big constructor.
	   *
	   * x {Big} A Big number instance.
	   * n {number|string} A numeric value.
	   */
	  function parse(x, n) {
	    var e, i, nl;
	
	    // Minus zero?
	    if (n === 0 && 1 / n < 0) n = '-0';
	    else if (!NUMERIC.test(n += '')) throw Error(INVALID + 'number');
	
	    // Determine sign.
	    x.s = n.charAt(0) == '-' ? (n = n.slice(1), -1) : 1;
	
	    // Decimal point?
	    if ((e = n.indexOf('.')) > -1) n = n.replace('.', '');
	
	    // Exponential form?
	    if ((i = n.search(/e/i)) > 0) {
	
	      // Determine exponent.
	      if (e < 0) e = i;
	      e += +n.slice(i + 1);
	      n = n.substring(0, i);
	    } else if (e < 0) {
	
	      // Integer.
	      e = n.length;
	    }
	
	    nl = n.length;
	
	    // Determine leading zeros.
	    for (i = 0; i < nl && n.charAt(i) == '0';) ++i;
	
	    if (i == nl) {
	
	      // Zero.
	      x.c = [x.e = 0];
	    } else {
	
	      // Determine trailing zeros.
	      for (; nl > 0 && n.charAt(--nl) == '0';);
	      x.e = e - i - 1;
	      x.c = [];
	
	      // Convert string to array of digits without leading/trailing zeros.
	      for (e = 0; i <= nl;) x.c[e++] = +n.charAt(i++);
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Round Big x to a maximum of dp decimal places using rounding mode rm.
	   * Called by stringify, P.div, P.round and P.sqrt.
	   *
	   * x {Big} The Big to round.
	   * dp {number} Integer, 0 to MAX_DP inclusive.
	   * rm {number} 0, 1, 2 or 3 (DOWN, HALF_UP, HALF_EVEN, UP)
	   * [more] {boolean} Whether the result of division was truncated.
	   */
	  function round(x, dp, rm, more) {
	    var xc = x.c,
	      i = x.e + dp + 1;
	
	    if (i < xc.length) {
	      if (rm === 1) {
	
	        // xc[i] is the digit after the digit that may be rounded up.
	        more = xc[i] >= 5;
	      } else if (rm === 2) {
	        more = xc[i] > 5 || xc[i] == 5 &&
	          (more || i < 0 || xc[i + 1] !== UNDEFINED || xc[i - 1] & 1);
	      } else if (rm === 3) {
	        more = more || !!xc[0];
	      } else {
	        more = false;
	        if (rm !== 0) throw Error(INVALID_RM);
	      }
	
	      if (i < 1) {
	        xc.length = 1;
	
	        if (more) {
	
	          // 1, 0.1, 0.01, 0.001, 0.0001 etc.
	          x.e = -dp;
	          xc[0] = 1;
	        } else {
	
	          // Zero.
	          xc[0] = x.e = 0;
	        }
	      } else {
	
	        // Remove any digits after the required decimal places.
	        xc.length = i--;
	
	        // Round up?
	        if (more) {
	
	          // Rounding up may mean the previous digit has to be rounded up.
	          for (; ++xc[i] > 9;) {
	            xc[i] = 0;
	            if (!i--) {
	              ++x.e;
	              xc.unshift(1);
	            }
	          }
	        }
	
	        // Remove trailing zeros.
	        for (i = xc.length; !xc[--i];) xc.pop();
	      }
	    } else if (rm < 0 || rm > 3 || rm !== ~~rm) {
	      throw Error(INVALID_RM);
	    }
	
	    return x;
	  }
	
	
	  /*
	   * Return a string representing the value of Big x in normal or exponential notation.
	   * Handles P.toExponential, P.toFixed, P.toJSON, P.toPrecision, P.toString and P.valueOf.
	   *
	   * x {Big}
	   * id? {number} Caller id.
	   *         1 toExponential
	   *         2 toFixed
	   *         3 toPrecision
	   *         4 valueOf
	   * n? {number|undefined} Caller's argument.
	   * k? {number|undefined}
	   */
	  function stringify(x, id, n, k) {
	    var e, s,
	      Big = x.constructor,
	      z = !x.c[0];
	
	    if (n !== UNDEFINED) {
	      if (n !== ~~n || n < (id == 3) || n > MAX_DP) {
	        throw Error(id == 3 ? INVALID + 'precision' : INVALID_DP);
	      }
	
	      x = new Big(x);
	
	      // The index of the digit that may be rounded up.
	      n = k - x.e;
	
	      // Round?
	      if (x.c.length > ++k) round(x, n, Big.RM);
	
	      // toFixed: recalculate k as x.e may have changed if value rounded up.
	      if (id == 2) k = x.e + n + 1;
	
	      // Append zeros?
	      for (; x.c.length < k;) x.c.push(0);
	    }
	
	    e = x.e;
	    s = x.c.join('');
	    n = s.length;
	
	    // Exponential notation?
	    if (id != 2 && (id == 1 || id == 3 && k <= e || e <= Big.NE || e >= Big.PE)) {
	      s = s.charAt(0) + (n > 1 ? '.' + s.slice(1) : '') + (e < 0 ? 'e' : 'e+') + e;
	
	    // Normal notation.
	    } else if (e < 0) {
	      for (; ++e;) s = '0' + s;
	      s = '0.' + s;
	    } else if (e > 0) {
	      if (++e > n) for (e -= n; e--;) s += '0';
	      else if (e < n) s = s.slice(0, e) + '.' + s.slice(e);
	    } else if (n > 1) {
	      s = s.charAt(0) + '.' + s.slice(1);
	    }
	
	    return x.s < 0 && (!z || id == 4) ? '-' + s : s;
	  }
	
	
	  // Prototype/instance methods
	
	
	  /*
	   * Return a new Big whose value is the absolute value of this Big.
	   */
	  P.abs = function () {
	    var x = new this.constructor(this);
	    x.s = 1;
	    return x;
	  };
	
	
	  /*
	   * Return 1 if the value of this Big is greater than the value of Big y,
	   *       -1 if the value of this Big is less than the value of Big y, or
	   *        0 if they have the same value.
	  */
	  P.cmp = function (y) {
	    var isneg,
	      x = this,
	      xc = x.c,
	      yc = (y = new x.constructor(y)).c,
	      i = x.s,
	      j = y.s,
	      k = x.e,
	      l = y.e;
	
	    // Either zero?
	    if (!xc[0] || !yc[0]) return !xc[0] ? !yc[0] ? 0 : -j : i;
	
	    // Signs differ?
	    if (i != j) return i;
	
	    isneg = i < 0;
	
	    // Compare exponents.
	    if (k != l) return k > l ^ isneg ? 1 : -1;
	
	    j = (k = xc.length) < (l = yc.length) ? k : l;
	
	    // Compare digit by digit.
	    for (i = -1; ++i < j;) {
	      if (xc[i] != yc[i]) return xc[i] > yc[i] ^ isneg ? 1 : -1;
	    }
	
	    // Compare lengths.
	    return k == l ? 0 : k > l ^ isneg ? 1 : -1;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big divided by the value of Big y, rounded,
	   * if necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
	   */
	  P.div = function (y) {
	    var x = this,
	      Big = x.constructor,
	      a = x.c,                  // dividend
	      b = (y = new Big(y)).c,   // divisor
	      k = x.s == y.s ? 1 : -1,
	      dp = Big.DP;
	
	    if (dp !== ~~dp || dp < 0 || dp > MAX_DP) throw Error(INVALID_DP);
	
	    // Divisor is zero?
	    if (!b[0]) throw Error(DIV_BY_ZERO);
	
	    // Dividend is 0? Return +-0.
	    if (!a[0]) return new Big(k * 0);
	
	    var bl, bt, n, cmp, ri,
	      bz = b.slice(),
	      ai = bl = b.length,
	      al = a.length,
	      r = a.slice(0, bl),   // remainder
	      rl = r.length,
	      q = y,                // quotient
	      qc = q.c = [],
	      qi = 0,
	      d = dp + (q.e = x.e - y.e) + 1;    // number of digits of the result
	
	    q.s = k;
	    k = d < 0 ? 0 : d;
	
	    // Create version of divisor with leading zero.
	    bz.unshift(0);
	
	    // Add zeros to make remainder as long as divisor.
	    for (; rl++ < bl;) r.push(0);
	
	    do {
	
	      // n is how many times the divisor goes into current remainder.
	      for (n = 0; n < 10; n++) {
	
	        // Compare divisor and remainder.
	        if (bl != (rl = r.length)) {
	          cmp = bl > rl ? 1 : -1;
	        } else {
	          for (ri = -1, cmp = 0; ++ri < bl;) {
	            if (b[ri] != r[ri]) {
	              cmp = b[ri] > r[ri] ? 1 : -1;
	              break;
	            }
	          }
	        }
	
	        // If divisor < remainder, subtract divisor from remainder.
	        if (cmp < 0) {
	
	          // Remainder can't be more than 1 digit longer than divisor.
	          // Equalise lengths using divisor with extra leading zero?
	          for (bt = rl == bl ? b : bz; rl;) {
	            if (r[--rl] < bt[rl]) {
	              ri = rl;
	              for (; ri && !r[--ri];) r[ri] = 9;
	              --r[ri];
	              r[rl] += 10;
	            }
	            r[rl] -= bt[rl];
	          }
	
	          for (; !r[0];) r.shift();
	        } else {
	          break;
	        }
	      }
	
	      // Add the digit n to the result array.
	      qc[qi++] = cmp ? n : ++n;
	
	      // Update the remainder.
	      if (r[0] && cmp) r[rl] = a[ai] || 0;
	      else r = [a[ai]];
	
	    } while ((ai++ < al || r[0] !== UNDEFINED) && k--);
	
	    // Leading zero? Do not remove if result is simply zero (qi == 1).
	    if (!qc[0] && qi != 1) {
	
	      // There can't be more than one zero.
	      qc.shift();
	      q.e--;
	    }
	
	    // Round?
	    if (qi > d) round(q, dp, Big.RM, r[0] !== UNDEFINED);
	
	    return q;
	  };
	
	
	  /*
	   * Return true if the value of this Big is equal to the value of Big y, otherwise return false.
	   */
	  P.eq = function (y) {
	    return !this.cmp(y);
	  };
	
	
	  /*
	   * Return true if the value of this Big is greater than the value of Big y, otherwise return
	   * false.
	   */
	  P.gt = function (y) {
	    return this.cmp(y) > 0;
	  };
	
	
	  /*
	   * Return true if the value of this Big is greater than or equal to the value of Big y, otherwise
	   * return false.
	   */
	  P.gte = function (y) {
	    return this.cmp(y) > -1;
	  };
	
	
	  /*
	   * Return true if the value of this Big is less than the value of Big y, otherwise return false.
	   */
	  P.lt = function (y) {
	    return this.cmp(y) < 0;
	  };
	
	
	  /*
	   * Return true if the value of this Big is less than or equal to the value of Big y, otherwise
	   * return false.
	   */
	  P.lte = function (y) {
	    return this.cmp(y) < 1;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big minus the value of Big y.
	   */
	  P.minus = P.sub = function (y) {
	    var i, j, t, xlty,
	      x = this,
	      Big = x.constructor,
	      a = x.s,
	      b = (y = new Big(y)).s;
	
	    // Signs differ?
	    if (a != b) {
	      y.s = -b;
	      return x.plus(y);
	    }
	
	    var xc = x.c.slice(),
	      xe = x.e,
	      yc = y.c,
	      ye = y.e;
	
	    // Either zero?
	    if (!xc[0] || !yc[0]) {
	
	      // y is non-zero? x is non-zero? Or both are zero.
	      return yc[0] ? (y.s = -b, y) : new Big(xc[0] ? x : 0);
	    }
	
	    // Determine which is the bigger number. Prepend zeros to equalise exponents.
	    if (a = xe - ye) {
	
	      if (xlty = a < 0) {
	        a = -a;
	        t = xc;
	      } else {
	        ye = xe;
	        t = yc;
	      }
	
	      t.reverse();
	      for (b = a; b--;) t.push(0);
	      t.reverse();
	    } else {
	
	      // Exponents equal. Check digit by digit.
	      j = ((xlty = xc.length < yc.length) ? xc : yc).length;
	
	      for (a = b = 0; b < j; b++) {
	        if (xc[b] != yc[b]) {
	          xlty = xc[b] < yc[b];
	          break;
	        }
	      }
	    }
	
	    // x < y? Point xc to the array of the bigger number.
	    if (xlty) {
	      t = xc;
	      xc = yc;
	      yc = t;
	      y.s = -y.s;
	    }
	
	    /*
	     * Append zeros to xc if shorter. No need to add zeros to yc if shorter as subtraction only
	     * needs to start at yc.length.
	     */
	    if ((b = (j = yc.length) - (i = xc.length)) > 0) for (; b--;) xc[i++] = 0;
	
	    // Subtract yc from xc.
	    for (b = i; j > a;) {
	      if (xc[--j] < yc[j]) {
	        for (i = j; i && !xc[--i];) xc[i] = 9;
	        --xc[i];
	        xc[j] += 10;
	      }
	
	      xc[j] -= yc[j];
	    }
	
	    // Remove trailing zeros.
	    for (; xc[--b] === 0;) xc.pop();
	
	    // Remove leading zeros and adjust exponent accordingly.
	    for (; xc[0] === 0;) {
	      xc.shift();
	      --ye;
	    }
	
	    if (!xc[0]) {
	
	      // n - n = +0
	      y.s = 1;
	
	      // Result must be zero.
	      xc = [ye = 0];
	    }
	
	    y.c = xc;
	    y.e = ye;
	
	    return y;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big modulo the value of Big y.
	   */
	  P.mod = function (y) {
	    var ygtx,
	      x = this,
	      Big = x.constructor,
	      a = x.s,
	      b = (y = new Big(y)).s;
	
	    if (!y.c[0]) throw Error(DIV_BY_ZERO);
	
	    x.s = y.s = 1;
	    ygtx = y.cmp(x) == 1;
	    x.s = a;
	    y.s = b;
	
	    if (ygtx) return new Big(x);
	
	    a = Big.DP;
	    b = Big.RM;
	    Big.DP = Big.RM = 0;
	    x = x.div(y);
	    Big.DP = a;
	    Big.RM = b;
	
	    return this.minus(x.times(y));
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big plus the value of Big y.
	   */
	  P.plus = P.add = function (y) {
	    var t,
	      x = this,
	      Big = x.constructor,
	      a = x.s,
	      b = (y = new Big(y)).s;
	
	    // Signs differ?
	    if (a != b) {
	      y.s = -b;
	      return x.minus(y);
	    }
	
	    var xe = x.e,
	      xc = x.c,
	      ye = y.e,
	      yc = y.c;
	
	    // Either zero? y is non-zero? x is non-zero? Or both are zero.
	    if (!xc[0] || !yc[0]) return yc[0] ? y : new Big(xc[0] ? x : a * 0);
	
	    xc = xc.slice();
	
	    // Prepend zeros to equalise exponents.
	    // Note: reverse faster than unshifts.
	    if (a = xe - ye) {
	      if (a > 0) {
	        ye = xe;
	        t = yc;
	      } else {
	        a = -a;
	        t = xc;
	      }
	
	      t.reverse();
	      for (; a--;) t.push(0);
	      t.reverse();
	    }
	
	    // Point xc to the longer array.
	    if (xc.length - yc.length < 0) {
	      t = yc;
	      yc = xc;
	      xc = t;
	    }
	
	    a = yc.length;
	
	    // Only start adding at yc.length - 1 as the further digits of xc can be left as they are.
	    for (b = 0; a; xc[a] %= 10) b = (xc[--a] = xc[a] + yc[a] + b) / 10 | 0;
	
	    // No need to check for zero, as +x + +y != 0 && -x + -y != 0
	
	    if (b) {
	      xc.unshift(b);
	      ++ye;
	    }
	
	    // Remove trailing zeros.
	    for (a = xc.length; xc[--a] === 0;) xc.pop();
	
	    y.c = xc;
	    y.e = ye;
	
	    return y;
	  };
	
	
	  /*
	   * Return a Big whose value is the value of this Big raised to the power n.
	   * If n is negative, round to a maximum of Big.DP decimal places using rounding
	   * mode Big.RM.
	   *
	   * n {number} Integer, -MAX_POWER to MAX_POWER inclusive.
	   */
	  P.pow = function (n) {
	    var x = this,
	      one = new x.constructor(1),
	      y = one,
	      isneg = n < 0;
	
	    if (n !== ~~n || n < -MAX_POWER || n > MAX_POWER) throw Error(INVALID + 'exponent');
	    if (isneg) n = -n;
	
	    for (;;) {
	      if (n & 1) y = y.times(x);
	      n >>= 1;
	      if (!n) break;
	      x = x.times(x);
	    }
	
	    return isneg ? one.div(y) : y;
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big rounded using rounding mode rm
	   * to a maximum of dp decimal places, or, if dp is negative, to an integer which is a
	   * multiple of 10**-dp.
	   * If dp is not specified, round to 0 decimal places.
	   * If rm is not specified, use Big.RM.
	   *
	   * dp? {number} Integer, -MAX_DP to MAX_DP inclusive.
	   * rm? 0, 1, 2 or 3 (ROUND_DOWN, ROUND_HALF_UP, ROUND_HALF_EVEN, ROUND_UP)
	   */
	  P.round = function (dp, rm) {
	    var Big = this.constructor;
	    if (dp === UNDEFINED) dp = 0;
	    else if (dp !== ~~dp || dp < -MAX_DP || dp > MAX_DP) throw Error(INVALID_DP);
	    return round(new Big(this), dp, rm === UNDEFINED ? Big.RM : rm);
	  };
	
	
	  /*
	   * Return a new Big whose value is the square root of the value of this Big, rounded, if
	   * necessary, to a maximum of Big.DP decimal places using rounding mode Big.RM.
	   */
	  P.sqrt = function () {
	    var r, c, t,
	      x = this,
	      Big = x.constructor,
	      s = x.s,
	      e = x.e,
	      half = new Big(0.5);
	
	    // Zero?
	    if (!x.c[0]) return new Big(x);
	
	    // Negative?
	    if (s < 0) throw Error(NAME + 'No square root');
	
	    // Estimate.
	    s = Math.sqrt(x + '');
	
	    // Math.sqrt underflow/overflow?
	    // Re-estimate: pass x coefficient to Math.sqrt as integer, then adjust the result exponent.
	    if (s === 0 || s === 1 / 0) {
	      c = x.c.join('');
	      if (!(c.length + e & 1)) c += '0';
	      s = Math.sqrt(c);
	      e = ((e + 1) / 2 | 0) - (e < 0 || e & 1);
	      r = new Big((s == 1 / 0 ? '1e' : (s = s.toExponential()).slice(0, s.indexOf('e') + 1)) + e);
	    } else {
	      r = new Big(s);
	    }
	
	    e = r.e + (Big.DP += 4);
	
	    // Newton-Raphson iteration.
	    do {
	      t = r;
	      r = half.times(t.plus(x.div(t)));
	    } while (t.c.slice(0, e).join('') !== r.c.slice(0, e).join(''));
	
	    return round(r, Big.DP -= 4, Big.RM);
	  };
	
	
	  /*
	   * Return a new Big whose value is the value of this Big times the value of Big y.
	   */
	  P.times = P.mul = function (y) {
	    var c,
	      x = this,
	      Big = x.constructor,
	      xc = x.c,
	      yc = (y = new Big(y)).c,
	      a = xc.length,
	      b = yc.length,
	      i = x.e,
	      j = y.e;
	
	    // Determine sign of result.
	    y.s = x.s == y.s ? 1 : -1;
	
	    // Return signed 0 if either 0.
	    if (!xc[0] || !yc[0]) return new Big(y.s * 0);
	
	    // Initialise exponent of result as x.e + y.e.
	    y.e = i + j;
	
	    // If array xc has fewer digits than yc, swap xc and yc, and lengths.
	    if (a < b) {
	      c = xc;
	      xc = yc;
	      yc = c;
	      j = a;
	      a = b;
	      b = j;
	    }
	
	    // Initialise coefficient array of result with zeros.
	    for (c = new Array(j = a + b); j--;) c[j] = 0;
	
	    // Multiply.
	
	    // i is initially xc.length.
	    for (i = b; i--;) {
	      b = 0;
	
	      // a is yc.length.
	      for (j = a + i; j > i;) {
	
	        // Current sum of products at this digit position, plus carry.
	        b = c[j] + yc[i] * xc[j - i - 1] + b;
	        c[j--] = b % 10;
	
	        // carry
	        b = b / 10 | 0;
	      }
	
	      c[j] = (c[j] + b) % 10;
	    }
	
	    // Increment result exponent if there is a final carry, otherwise remove leading zero.
	    if (b) ++y.e;
	    else c.shift();
	
	    // Remove trailing zeros.
	    for (i = c.length; !c[--i];) c.pop();
	    y.c = c;
	
	    return y;
	  };
	
	
	  /*
	   * Return a string representing the value of this Big in exponential notation to dp fixed decimal
	   * places and rounded using Big.RM.
	   *
	   * dp? {number} Integer, 0 to MAX_DP inclusive.
	   */
	  P.toExponential = function (dp) {
	    return stringify(this, 1, dp, dp);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big in normal notation to dp fixed decimal
	   * places and rounded using Big.RM.
	   *
	   * dp? {number} Integer, 0 to MAX_DP inclusive.
	   *
	   * (-0).toFixed(0) is '0', but (-0.1).toFixed(0) is '-0'.
	   * (-0).toFixed(1) is '0.0', but (-0.01).toFixed(1) is '-0.0'.
	   */
	  P.toFixed = function (dp) {
	    return stringify(this, 2, dp, this.e + dp);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big rounded to sd significant digits using
	   * Big.RM. Use exponential notation if sd is less than the number of digits necessary to represent
	   * the integer part of the value in normal notation.
	   *
	   * sd {number} Integer, 1 to MAX_DP inclusive.
	   */
	  P.toPrecision = function (sd) {
	    return stringify(this, 3, sd, sd - 1);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big.
	   * Return exponential notation if this Big has a positive exponent equal to or greater than
	   * Big.PE, or a negative exponent equal to or less than Big.NE.
	   * Omit the sign for negative zero.
	   */
	  P.toString = function () {
	    return stringify(this);
	  };
	
	
	  /*
	   * Return a string representing the value of this Big.
	   * Return exponential notation if this Big has a positive exponent equal to or greater than
	   * Big.PE, or a negative exponent equal to or less than Big.NE.
	   * Include the sign for negative zero.
	   */
	  P.valueOf = P.toJSON = function () {
	    return stringify(this, 4);
	  };
	
	
	  // Export
	
	
	  Big = _Big_();
	
	  Big['default'] = Big.Big = Big;
	
	  //AMD.
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () { return Big; }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	
	  // Node and other CommonJS-like environments that support module.exports.
	  } else if (typeof module !== 'undefined' && module.exports) {
	    module.exports = Big;
	
	  //Browser.
	  } else {
	    GLOBAL.Big = Big;
	  }
	})(this);


/***/ },
/* 236 */
43,
/* 237 */
[3012, 171, 275, 169],
/* 238 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 239 */
[3043, 447],
/* 240 */
[3006, 116, 58],
/* 241 */
238,
/* 242 */
[3036, 69, 104, 58],
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var defined = __webpack_require__(136);
	var fails = __webpack_require__(43);
	var spaces = __webpack_require__(481);
	var space = '[' + spaces + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');
	
	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = fails(function () {
	    return !!spaces[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  $export($export.P + $export.F * FORCE, 'String', exp);
	};
	
	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};
	
	module.exports = exporter;


/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SelectionState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(39);
	
	var Record = Immutable.Record;
	
	
	var defaultRecord = {
	  anchorKey: '',
	  anchorOffset: 0,
	  focusKey: '',
	  focusOffset: 0,
	  isBackward: false,
	  hasFocus: false
	};
	
	var SelectionStateRecord = Record(defaultRecord);
	
	var SelectionState = function (_SelectionStateRecord) {
	  _inherits(SelectionState, _SelectionStateRecord);
	
	  function SelectionState() {
	    _classCallCheck(this, SelectionState);
	
	    return _possibleConstructorReturn(this, _SelectionStateRecord.apply(this, arguments));
	  }
	
	  SelectionState.prototype.serialize = function serialize() {
	    return 'Anchor: ' + this.getAnchorKey() + ':' + this.getAnchorOffset() + ', ' + 'Focus: ' + this.getFocusKey() + ':' + this.getFocusOffset() + ', ' + 'Is Backward: ' + String(this.getIsBackward()) + ', ' + 'Has Focus: ' + String(this.getHasFocus());
	  };
	
	  SelectionState.prototype.getAnchorKey = function getAnchorKey() {
	    return this.get('anchorKey');
	  };
	
	  SelectionState.prototype.getAnchorOffset = function getAnchorOffset() {
	    return this.get('anchorOffset');
	  };
	
	  SelectionState.prototype.getFocusKey = function getFocusKey() {
	    return this.get('focusKey');
	  };
	
	  SelectionState.prototype.getFocusOffset = function getFocusOffset() {
	    return this.get('focusOffset');
	  };
	
	  SelectionState.prototype.getIsBackward = function getIsBackward() {
	    return this.get('isBackward');
	  };
	
	  SelectionState.prototype.getHasFocus = function getHasFocus() {
	    return this.get('hasFocus');
	  };
	
	  /**
	   * Return whether the specified range overlaps with an edge of the
	   * SelectionState.
	   */
	
	
	  SelectionState.prototype.hasEdgeWithin = function hasEdgeWithin(blockKey, start, end) {
	    var anchorKey = this.getAnchorKey();
	    var focusKey = this.getFocusKey();
	
	    if (anchorKey === focusKey && anchorKey === blockKey) {
	      var selectionStart = this.getStartOffset();
	      var selectionEnd = this.getEndOffset();
	      return start <= selectionEnd && selectionStart <= end;
	    }
	
	    if (blockKey !== anchorKey && blockKey !== focusKey) {
	      return false;
	    }
	
	    var offsetToCheck = blockKey === anchorKey ? this.getAnchorOffset() : this.getFocusOffset();
	
	    return start <= offsetToCheck && end >= offsetToCheck;
	  };
	
	  SelectionState.prototype.isCollapsed = function isCollapsed() {
	    return this.getAnchorKey() === this.getFocusKey() && this.getAnchorOffset() === this.getFocusOffset();
	  };
	
	  SelectionState.prototype.getStartKey = function getStartKey() {
	    return this.getIsBackward() ? this.getFocusKey() : this.getAnchorKey();
	  };
	
	  SelectionState.prototype.getStartOffset = function getStartOffset() {
	    return this.getIsBackward() ? this.getFocusOffset() : this.getAnchorOffset();
	  };
	
	  SelectionState.prototype.getEndKey = function getEndKey() {
	    return this.getIsBackward() ? this.getAnchorKey() : this.getFocusKey();
	  };
	
	  SelectionState.prototype.getEndOffset = function getEndOffset() {
	    return this.getIsBackward() ? this.getAnchorOffset() : this.getFocusOffset();
	  };
	
	  SelectionState.createEmpty = function createEmpty(key) {
	    return new SelectionState({
	      anchorKey: key,
	      anchorOffset: 0,
	      focusKey: key,
	      focusOffset: 0,
	      isBackward: false,
	      hasFocus: false
	    });
	  };
	
	  return SelectionState;
	}(SelectionStateRecord);
	
	module.exports = SelectionState;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createDimensions = __webpack_require__(251);
	
	var List = __webpack_require__(109);
	
	var _util = __webpack_require__(4);
	
	var extend = _util.extend;
	var isArray = _util.isArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [Usage]:
	 * (1)
	 * createListSimply(seriesModel, ['value']);
	 * (2)
	 * createListSimply(seriesModel, {
	 *     coordDimensions: ['value'],
	 *     dimensionsCount: 5
	 * });
	 *
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {Object|Array.<string|Object>} opt opt or coordDimensions
	 *        The options in opt, see `echarts/data/helper/createDimensions`
	 * @param {Array.<string>} [nameList]
	 * @return {module:echarts/data/List}
	 */
	function _default(seriesModel, opt, nameList) {
	  opt = isArray(opt) && {
	    coordDimensions: opt
	  } || extend({}, opt);
	  var source = seriesModel.getSource();
	  var dimensionsInfo = createDimensions(source, opt);
	  var list = new List(dimensionsInfo, seriesModel);
	  list.initData(source, nameList);
	  return list;
	}
	
	module.exports = _default;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @return {string} If large mode changed, return string 'reset';
	 */
	function _default() {
	  var inner = makeInner();
	  return function (seriesModel) {
	    var fields = inner(seriesModel);
	    var pipelineContext = seriesModel.pipelineContext;
	    var originalLarge = fields.large;
	    var originalProgressive = fields.progressiveRender; // FIXME: if the planner works on a filtered series, `pipelineContext` does not
	    // exists. See #11611 . Probably we need to modify this structure, see the comment
	    // on `performRawSeries` in `Schedular.js`.
	
	    var large = fields.large = pipelineContext && pipelineContext.large;
	    var progressive = fields.progressiveRender = pipelineContext && pipelineContext.progressiveRender;
	    return !!(originalLarge ^ large || originalProgressive ^ progressive) && 'reset';
	  };
	}
	
	module.exports = _default;

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var env = __webpack_require__(73);
	
	var modelUtil = __webpack_require__(29);
	
	var helper = __webpack_require__(503);
	
	var AxisProxy = __webpack_require__(2334);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var eachAxisDim = helper.eachAxisDim;
	var DataZoomModel = echarts.extendComponentModel({
	  type: 'dataZoom',
	  dependencies: ['xAxis', 'yAxis', 'zAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    z: 4,
	    // Higher than normal component (z: 2).
	    orient: null,
	    // Default auto by axisIndex. Possible value: 'horizontal', 'vertical'.
	    xAxisIndex: null,
	    // Default the first horizontal category axis.
	    yAxisIndex: null,
	    // Default the first vertical category axis.
	    filterMode: 'filter',
	    // Possible values: 'filter' or 'empty' or 'weakFilter'.
	    // 'filter': data items which are out of window will be removed. This option is
	    //          applicable when filtering outliers. For each data item, it will be
	    //          filtered if one of the relevant dimensions is out of the window.
	    // 'weakFilter': data items which are out of window will be removed. This option
	    //          is applicable when filtering outliers. For each data item, it will be
	    //          filtered only if all  of the relevant dimensions are out of the same
	    //          side of the window.
	    // 'empty': data items which are out of window will be set to empty.
	    //          This option is applicable when user should not neglect
	    //          that there are some data items out of window.
	    // 'none': Do not filter.
	    // Taking line chart as an example, line will be broken in
	    // the filtered points when filterModel is set to 'empty', but
	    // be connected when set to 'filter'.
	    throttle: null,
	    // Dispatch action by the fixed rate, avoid frequency.
	    // default 100. Do not throttle when use null/undefined.
	    // If animation === true and animationDurationUpdate > 0,
	    // default value is 100, otherwise 20.
	    start: 0,
	    // Start percent. 0 ~ 100
	    end: 100,
	    // End percent. 0 ~ 100
	    startValue: null,
	    // Start value. If startValue specified, start is ignored.
	    endValue: null,
	    // End value. If endValue specified, end is ignored.
	    minSpan: null,
	    // 0 ~ 100
	    maxSpan: null,
	    // 0 ~ 100
	    minValueSpan: null,
	    // The range of dataZoom can not be smaller than that.
	    maxValueSpan: null,
	    // The range of dataZoom can not be larger than that.
	    rangeMode: null // Array, can be 'value' or 'percent'.
	
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * key like x_0, y_1
	     * @private
	     * @type {Object}
	     */
	    this._dataIntervalByAxis = {};
	    /**
	     * @private
	     */
	
	    this._dataInfo = {};
	    /**
	     * key like x_0, y_1
	     * @private
	     */
	
	    this._axisProxies = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * @private
	     */
	
	    this._autoThrottle = true;
	    /**
	     * It is `[rangeModeForMin, rangeModeForMax]`.
	     * The optional values for `rangeMode`:
	     * + `'value'` mode: the axis extent will always be determined by
	     *     `dataZoom.startValue` and `dataZoom.endValue`, despite
	     *     how data like and how `axis.min` and `axis.max` are.
	     * + `'percent'` mode: `100` represents 100% of the `[dMin, dMax]`,
	     *     where `dMin` is `axis.min` if `axis.min` specified, otherwise `data.extent[0]`,
	     *     and `dMax` is `axis.max` if `axis.max` specified, otherwise `data.extent[1]`.
	     *     Axis extent will be determined by the result of the percent of `[dMin, dMax]`.
	     *
	     * For example, when users are using dynamic data (update data periodically via `setOption`),
	     * if in `'value`' mode, the window will be kept in a fixed value range despite how
	     * data are appended, while if in `'percent'` mode, whe window range will be changed alone with
	     * the appended data (suppose `axis.min` and `axis.max` are not specified).
	     *
	     * @private
	     */
	
	    this._rangePropMode = ['percent', 'percent'];
	    var inputRawOption = retrieveRawOption(option);
	    /**
	     * Suppose a "main process" start at the point that model prepared (that is,
	     * model initialized or merged or method called in `action`).
	     * We should keep the `main process` idempotent, that is, given a set of values
	     * on `option`, we get the same result.
	     *
	     * But sometimes, values on `option` will be updated for providing users
	     * a "final calculated value" (`dataZoomProcessor` will do that). Those value
	     * should not be the base/input of the `main process`.
	     *
	     * So in that case we should save and keep the input of the `main process`
	     * separately, called `settledOption`.
	     *
	     * For example, consider the case:
	     * (Step_1) brush zoom the grid by `toolbox.dataZoom`,
	     *     where the original input `option.startValue`, `option.endValue` are earsed by
	     *     calculated value.
	     * (Step)2) click the legend to hide and show a series,
	     *     where the new range is calculated by the earsed `startValue` and `endValue`,
	     *     which brings incorrect result.
	     *
	     * @readOnly
	     */
	
	    this.settledOption = inputRawOption;
	    this.mergeDefaultAndTheme(option, ecModel);
	    this.doInit(inputRawOption);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var inputRawOption = retrieveRawOption(newOption); //FIX #2591
	
	    zrUtil.merge(this.option, newOption, true);
	    zrUtil.merge(this.settledOption, inputRawOption, true);
	    this.doInit(inputRawOption);
	  },
	
	  /**
	   * @protected
	   */
	  doInit: function (inputRawOption) {
	    var thisOption = this.option; // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    this._setDefaultThrottle(inputRawOption);
	
	    updateRangeUse(this, inputRawOption);
	    var settledOption = this.settledOption;
	    each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	      // start/end has higher priority over startValue/endValue if they
	      // both set, but we should make chart.setOption({endValue: 1000})
	      // effective, rather than chart.setOption({endValue: 1000, end: null}).
	      if (this._rangePropMode[index] === 'value') {
	        thisOption[names[0]] = settledOption[names[0]] = null;
	      } // Otherwise do nothing and use the merge result.
	
	    }, this);
	    this.textStyleModel = this.getModel('textStyle');
	
	    this._resetTarget();
	
	    this._giveAxisProxies();
	  },
	
	  /**
	   * @private
	   */
	  _giveAxisProxies: function () {
	    var axisProxies = this._axisProxies;
	    this.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel, ecModel) {
	      var axisModel = this.dependentModels[dimNames.axis][axisIndex]; // If exists, share axisProxy with other dataZoomModels.
	
	      var axisProxy = axisModel.__dzAxisProxy || ( // Use the first dataZoomModel as the main model of axisProxy.
	      axisModel.__dzAxisProxy = new AxisProxy(dimNames.name, axisIndex, this, ecModel)); // FIXME
	      // dispose __dzAxisProxy
	
	      axisProxies[dimNames.name + '_' + axisIndex] = axisProxy;
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetTarget: function () {
	    var thisOption = this.option;
	
	    var autoMode = this._judgeAutoMode();
	
	    eachAxisDim(function (dimNames) {
	      var axisIndexName = dimNames.axisIndex;
	      thisOption[axisIndexName] = modelUtil.normalizeToArray(thisOption[axisIndexName]);
	    }, this);
	
	    if (autoMode === 'axisIndex') {
	      this._autoSetAxisIndex();
	    } else if (autoMode === 'orient') {
	      this._autoSetOrient();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _judgeAutoMode: function () {
	    // Auto set only works for setOption at the first time.
	    // The following is user's reponsibility. So using merged
	    // option is OK.
	    var thisOption = this.option;
	    var hasIndexSpecified = false;
	    eachAxisDim(function (dimNames) {
	      // When user set axisIndex as a empty array, we think that user specify axisIndex
	      // but do not want use auto mode. Because empty array may be encountered when
	      // some error occured.
	      if (thisOption[dimNames.axisIndex] != null) {
	        hasIndexSpecified = true;
	      }
	    }, this);
	    var orient = thisOption.orient;
	
	    if (orient == null && hasIndexSpecified) {
	      return 'orient';
	    } else if (!hasIndexSpecified) {
	      if (orient == null) {
	        thisOption.orient = 'horizontal';
	      }
	
	      return 'axisIndex';
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetAxisIndex: function () {
	    var autoAxisIndex = true;
	    var orient = this.get('orient', true);
	    var thisOption = this.option;
	    var dependentModels = this.dependentModels;
	
	    if (autoAxisIndex) {
	      // Find axis that parallel to dataZoom as default.
	      var dimName = orient === 'vertical' ? 'y' : 'x';
	
	      if (dependentModels[dimName + 'Axis'].length) {
	        thisOption[dimName + 'AxisIndex'] = [0];
	        autoAxisIndex = false;
	      } else {
	        each(dependentModels.singleAxis, function (singleAxisModel) {
	          if (autoAxisIndex && singleAxisModel.get('orient', true) === orient) {
	            thisOption.singleAxisIndex = [singleAxisModel.componentIndex];
	            autoAxisIndex = false;
	          }
	        });
	      }
	    }
	
	    if (autoAxisIndex) {
	      // Find the first category axis as default. (consider polar)
	      eachAxisDim(function (dimNames) {
	        if (!autoAxisIndex) {
	          return;
	        }
	
	        var axisIndices = [];
	        var axisModels = this.dependentModels[dimNames.axis];
	
	        if (axisModels.length && !axisIndices.length) {
	          for (var i = 0, len = axisModels.length; i < len; i++) {
	            if (axisModels[i].get('type') === 'category') {
	              axisIndices.push(i);
	            }
	          }
	        }
	
	        thisOption[dimNames.axisIndex] = axisIndices;
	
	        if (axisIndices.length) {
	          autoAxisIndex = false;
	        }
	      }, this);
	    }
	
	    if (autoAxisIndex) {
	      // FIXME
	      // 这里是兼容ec2的写法（没指定xAxisIndex和yAxisIndex时把scatter和双数值轴折柱纳入dataZoom控制），
	      // 但是实际是否需要Grid.js#getScaleByOption来判断（考虑time，log等axis type）？
	      // If both dataZoom.xAxisIndex and dataZoom.yAxisIndex is not specified,
	      // dataZoom component auto adopts series that reference to
	      // both xAxis and yAxis which type is 'value'.
	      this.ecModel.eachSeries(function (seriesModel) {
	        if (this._isSeriesHasAllAxesTypeOf(seriesModel, 'value')) {
	          eachAxisDim(function (dimNames) {
	            var axisIndices = thisOption[dimNames.axisIndex];
	            var axisIndex = seriesModel.get(dimNames.axisIndex);
	            var axisId = seriesModel.get(dimNames.axisId);
	            var axisModel = seriesModel.ecModel.queryComponents({
	              mainType: dimNames.axis,
	              index: axisIndex,
	              id: axisId
	            })[0];
	            axisIndex = axisModel.componentIndex;
	
	            if (zrUtil.indexOf(axisIndices, axisIndex) < 0) {
	              axisIndices.push(axisIndex);
	            }
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _autoSetOrient: function () {
	    var dim; // Find the first axis
	
	    this.eachTargetAxis(function (dimNames) {
	      !dim && (dim = dimNames.name);
	    }, this);
	    this.option.orient = dim === 'y' ? 'vertical' : 'horizontal';
	  },
	
	  /**
	   * @private
	   */
	  _isSeriesHasAllAxesTypeOf: function (seriesModel, axisType) {
	    // FIXME
	    // 需要series的xAxisIndex和yAxisIndex都首先自动设置上。
	    // 例如series.type === scatter时。
	    var is = true;
	    eachAxisDim(function (dimNames) {
	      var seriesAxisIndex = seriesModel.get(dimNames.axisIndex);
	      var axisModel = this.dependentModels[dimNames.axis][seriesAxisIndex];
	
	      if (!axisModel || axisModel.get('type') !== axisType) {
	        is = false;
	      }
	    }, this);
	    return is;
	  },
	
	  /**
	   * @private
	   */
	  _setDefaultThrottle: function (inputRawOption) {
	    // When first time user set throttle, auto throttle ends.
	    if (inputRawOption.hasOwnProperty('throttle')) {
	      this._autoThrottle = false;
	    }
	
	    if (this._autoThrottle) {
	      var globalOption = this.ecModel.option;
	      this.option.throttle = globalOption.animation && globalOption.animationDurationUpdate > 0 ? 100 : 20;
	    }
	  },
	
	  /**
	   * @public
	   */
	  getFirstTargetAxisModel: function () {
	    var firstAxisModel;
	    eachAxisDim(function (dimNames) {
	      if (firstAxisModel == null) {
	        var indices = this.get(dimNames.axisIndex);
	
	        if (indices.length) {
	          firstAxisModel = this.dependentModels[dimNames.axis][indices[0]];
	        }
	      }
	    }, this);
	    return firstAxisModel;
	  },
	
	  /**
	   * @public
	   * @param {Function} callback param: axisModel, dimNames, axisIndex, dataZoomModel, ecModel
	   */
	  eachTargetAxis: function (callback, context) {
	    var ecModel = this.ecModel;
	    eachAxisDim(function (dimNames) {
	      each(this.get(dimNames.axisIndex), function (axisIndex) {
	        callback.call(context, dimNames, axisIndex, this, ecModel);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/component/dataZoom/AxisProxy} If not found, return null/undefined.
	   */
	  getAxisProxy: function (dimName, axisIndex) {
	    return this._axisProxies[dimName + '_' + axisIndex];
	  },
	
	  /**
	   * @param {string} dimName
	   * @param {number} axisIndex
	   * @return {module:echarts/model/Model} If not found, return null/undefined.
	   */
	  getAxisModel: function (dimName, axisIndex) {
	    var axisProxy = this.getAxisProxy(dimName, axisIndex);
	    return axisProxy && axisProxy.getAxisModel();
	  },
	
	  /**
	   * If not specified, set to undefined.
	   *
	   * @public
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  setRawRange: function (opt) {
	    var thisOption = this.option;
	    var settledOption = this.settledOption;
	    each([['start', 'startValue'], ['end', 'endValue']], function (names) {
	      // Consider the pair <start, startValue>:
	      // If one has value and the other one is `null/undefined`, we both set them
	      // to `settledOption`. This strategy enables the feature to clear the original
	      // value in `settledOption` to `null/undefined`.
	      // But if both of them are `null/undefined`, we do not set them to `settledOption`
	      // and keep `settledOption` with the original value. This strategy enables users to
	      // only set <end or endValue> but not set <start or startValue> when calling
	      // `dispatchAction`.
	      // The pair <end, endValue> is treated in the same way.
	      if (opt[names[0]] != null || opt[names[1]] != null) {
	        thisOption[names[0]] = settledOption[names[0]] = opt[names[0]];
	        thisOption[names[1]] = settledOption[names[1]] = opt[names[1]];
	      }
	    }, this);
	    updateRangeUse(this, opt);
	  },
	
	  /**
	   * @public
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  setCalculatedRange: function (opt) {
	    var option = this.option;
	    each(['start', 'startValue', 'end', 'endValue'], function (name) {
	      option[name] = opt[name];
	    });
	  },
	
	  /**
	   * @public
	   * @return {Array.<number>} [startPercent, endPercent]
	   */
	  getPercentRange: function () {
	    var axisProxy = this.findRepresentativeAxisProxy();
	
	    if (axisProxy) {
	      return axisProxy.getDataPercentWindow();
	    }
	  },
	
	  /**
	   * @public
	   * For example, chart.getModel().getComponent('dataZoom').getValueRange('y', 0);
	   *
	   * @param {string} [axisDimName]
	   * @param {number} [axisIndex]
	   * @return {Array.<number>} [startValue, endValue] value can only be '-' or finite number.
	   */
	  getValueRange: function (axisDimName, axisIndex) {
	    if (axisDimName == null && axisIndex == null) {
	      var axisProxy = this.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        return axisProxy.getDataValueWindow();
	      }
	    } else {
	      return this.getAxisProxy(axisDimName, axisIndex).getDataValueWindow();
	    }
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/model/Model} [axisModel] If axisModel given, find axisProxy
	   *      corresponding to the axisModel
	   * @return {module:echarts/component/dataZoom/AxisProxy}
	   */
	  findRepresentativeAxisProxy: function (axisModel) {
	    if (axisModel) {
	      return axisModel.__dzAxisProxy;
	    } // Find the first hosted axisProxy
	
	
	    var axisProxies = this._axisProxies;
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    } // If no hosted axis find not hosted axisProxy.
	    // Consider this case: dataZoomModel1 and dataZoomModel2 control the same axis,
	    // and the option.start or option.end settings are different. The percentRange
	    // should follow axisProxy.
	    // (We encounter this problem in toolbox data zoom.)
	
	
	    for (var key in axisProxies) {
	      if (axisProxies.hasOwnProperty(key) && !axisProxies[key].hostedBy(this)) {
	        return axisProxies[key];
	      }
	    }
	  },
	
	  /**
	   * @return {Array.<string>}
	   */
	  getRangePropMode: function () {
	    return this._rangePropMode.slice();
	  }
	});
	/**
	 * Retrieve the those raw params from option, which will be cached separately.
	 * becasue they will be overwritten by normalized/calculated values in the main
	 * process.
	 */
	
	function retrieveRawOption(option) {
	  var ret = {};
	  each(['start', 'end', 'startValue', 'endValue', 'throttle'], function (name) {
	    option.hasOwnProperty(name) && (ret[name] = option[name]);
	  });
	  return ret;
	}
	
	function updateRangeUse(dataZoomModel, inputRawOption) {
	  var rangePropMode = dataZoomModel._rangePropMode;
	  var rangeModeInOption = dataZoomModel.get('rangeMode');
	  each([['start', 'startValue'], ['end', 'endValue']], function (names, index) {
	    var percentSpecified = inputRawOption[names[0]] != null;
	    var valueSpecified = inputRawOption[names[1]] != null;
	
	    if (percentSpecified && !valueSpecified) {
	      rangePropMode[index] = 'percent';
	    } else if (!percentSpecified && valueSpecified) {
	      rangePropMode[index] = 'value';
	    } else if (rangeModeInOption) {
	      rangePropMode[index] = rangeModeInOption[index];
	    } else if (percentSpecified) {
	      // percentSpecified && valueSpecified
	      rangePropMode[index] = 'percent';
	    } // else remain its original setting.
	
	  });
	}
	
	var _default = DataZoomModel;
	module.exports = _default;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentView = __webpack_require__(362);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = ComponentView.extend({
	  type: 'dataZoom',
	  render: function (dataZoomModel, ecModel, api, payload) {
	    this.dataZoomModel = dataZoomModel;
	    this.ecModel = ecModel;
	    this.api = api;
	  },
	
	  /**
	   * Find the first target coordinate system.
	   *
	   * @protected
	   * @return {Object} {
	   *                   grid: [
	   *                       {model: coord0, axisModels: [axis1, axis3], coordIndex: 1},
	   *                       {model: coord1, axisModels: [axis0, axis2], coordIndex: 0},
	   *                       ...
	   *                   ],  // cartesians must not be null/undefined.
	   *                   polar: [
	   *                       {model: coord0, axisModels: [axis4], coordIndex: 0},
	   *                       ...
	   *                   ],  // polars must not be null/undefined.
	   *                   singleAxis: [
	   *                       {model: coord0, axisModels: [], coordIndex: 0}
	   *                   ]
	   */
	  getTargetCoordInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var ecModel = this.ecModel;
	    var coordSysLists = {};
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var axisModel = ecModel.getComponent(dimNames.axis, axisIndex);
	
	      if (axisModel) {
	        var coordModel = axisModel.getCoordSysModel();
	        coordModel && save(coordModel, axisModel, coordSysLists[coordModel.mainType] || (coordSysLists[coordModel.mainType] = []), coordModel.componentIndex);
	      }
	    }, this);
	
	    function save(coordModel, axisModel, store, coordIndex) {
	      var item;
	
	      for (var i = 0; i < store.length; i++) {
	        if (store[i].model === coordModel) {
	          item = store[i];
	          break;
	        }
	      }
	
	      if (!item) {
	        store.push(item = {
	          model: coordModel,
	          axisModels: [],
	          coordIndex: coordIndex
	        });
	      }
	
	      item.axisModels.push(axisModel);
	    }
	
	    return coordSysLists;
	  }
	});
	
	module.exports = _default;

/***/ },
/* 249 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Calculate slider move result.
	 * Usage:
	 * (1) If both handle0 and handle1 are needed to be moved, set minSpan the same as
	 * maxSpan and the same as `Math.abs(handleEnd[1] - handleEnds[0])`.
	 * (2) If handle0 is forbidden to cross handle1, set minSpan as `0`.
	 *
	 * @param {number} delta Move length.
	 * @param {Array.<number>} handleEnds handleEnds[0] can be bigger then handleEnds[1].
	 *              handleEnds will be modified in this method.
	 * @param {Array.<number>} extent handleEnds is restricted by extent.
	 *              extent[0] should less or equals than extent[1].
	 * @param {number|string} handleIndex Can be 'all', means that both move the two handleEnds.
	 * @param {number} [minSpan] The range of dataZoom can not be smaller than that.
	 *              If not set, handle0 and cross handle1. If set as a non-negative
	 *              number (including `0`), handles will push each other when reaching
	 *              the minSpan.
	 * @param {number} [maxSpan] The range of dataZoom can not be larger than that.
	 * @return {Array.<number>} The input handleEnds.
	 */
	function _default(delta, handleEnds, extent, handleIndex, minSpan, maxSpan) {
	  delta = delta || 0;
	  var extentSpan = extent[1] - extent[0]; // Notice maxSpan and minSpan can be null/undefined.
	
	  if (minSpan != null) {
	    minSpan = restrict(minSpan, [0, extentSpan]);
	  }
	
	  if (maxSpan != null) {
	    maxSpan = Math.max(maxSpan, minSpan != null ? minSpan : 0);
	  }
	
	  if (handleIndex === 'all') {
	    var handleSpan = Math.abs(handleEnds[1] - handleEnds[0]);
	    handleSpan = restrict(handleSpan, [0, extentSpan]);
	    minSpan = maxSpan = restrict(handleSpan, [minSpan, maxSpan]);
	    handleIndex = 0;
	  }
	
	  handleEnds[0] = restrict(handleEnds[0], extent);
	  handleEnds[1] = restrict(handleEnds[1], extent);
	  var originalDistSign = getSpanSign(handleEnds, handleIndex);
	  handleEnds[handleIndex] += delta; // Restrict in extent.
	
	  var extentMinSpan = minSpan || 0;
	  var realExtent = extent.slice();
	  originalDistSign.sign < 0 ? realExtent[0] += extentMinSpan : realExtent[1] -= extentMinSpan;
	  handleEnds[handleIndex] = restrict(handleEnds[handleIndex], realExtent); // Expand span.
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (minSpan != null && (currDistSign.sign !== originalDistSign.sign || currDistSign.span < minSpan)) {
	    // If minSpan exists, 'cross' is forbidden.
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + originalDistSign.sign * minSpan;
	  } // Shrink span.
	
	
	  var currDistSign = getSpanSign(handleEnds, handleIndex);
	
	  if (maxSpan != null && currDistSign.span > maxSpan) {
	    handleEnds[1 - handleIndex] = handleEnds[handleIndex] + currDistSign.sign * maxSpan;
	  }
	
	  return handleEnds;
	}
	
	function getSpanSign(handleEnds, handleIndex) {
	  var dist = handleEnds[handleIndex] - handleEnds[1 - handleIndex]; // If `handleEnds[0] === handleEnds[1]`, always believe that handleEnd[0]
	  // is at left of handleEnds[1] for non-cross case.
	
	  return {
	    span: Math.abs(dist),
	    sign: dist > 0 ? -1 : dist < 0 ? 1 : handleIndex ? -1 : 1
	  };
	}
	
	function restrict(value, extend) {
	  return Math.min(extend[1] != null ? extend[1] : Infinity, Math.max(extend[0] != null ? extend[0] : -Infinity, value));
	}
	
	module.exports = _default;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import * as axisHelper from './axisHelper';
	var _default = {
	  /**
	   * @param {boolean} origin
	   * @return {number|string} min value or 'dataMin' or null/undefined (means auto) or NaN
	   */
	  getMin: function (origin) {
	    var option = this.option;
	    var min = !origin && option.rangeStart != null ? option.rangeStart : option.min;
	
	    if (this.axis && min != null && min !== 'dataMin' && typeof min !== 'function' && !zrUtil.eqNaN(min)) {
	      min = this.axis.scale.parse(min);
	    }
	
	    return min;
	  },
	
	  /**
	   * @param {boolean} origin
	   * @return {number|string} max value or 'dataMax' or null/undefined (means auto) or NaN
	   */
	  getMax: function (origin) {
	    var option = this.option;
	    var max = !origin && option.rangeEnd != null ? option.rangeEnd : option.max;
	
	    if (this.axis && max != null && max !== 'dataMax' && typeof max !== 'function' && !zrUtil.eqNaN(max)) {
	      max = this.axis.scale.parse(max);
	    }
	
	    return max;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  getNeedCrossZero: function () {
	    var option = this.option;
	    return option.rangeStart != null || option.rangeEnd != null ? false : !option.scale;
	  },
	
	  /**
	   * Should be implemented by each axis model if necessary.
	   * @return {module:echarts/model/Component} coordinate system model
	   */
	  getCoordSysModel: zrUtil.noop,
	
	  /**
	   * @param {number} rangeStart Can only be finite number or null/undefined or NaN.
	   * @param {number} rangeEnd Can only be finite number or null/undefined or NaN.
	   */
	  setRange: function (rangeStart, rangeEnd) {
	    this.option.rangeStart = rangeStart;
	    this.option.rangeEnd = rangeEnd;
	  },
	
	  /**
	   * Reset range
	   */
	  resetRange: function () {
	    // rangeStart and rangeEnd is readonly.
	    this.option.rangeStart = this.option.rangeEnd = null;
	  }
	};
	module.exports = _default;

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var completeDimensions = __webpack_require__(871);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Substitute `completeDimensions`.
	 * `completeDimensions` is to be deprecated.
	 */
	
	/**
	 * @param {module:echarts/data/Source|module:echarts/data/List} source or data.
	 * @param {Object|Array} [opt]
	 * @param {Array.<string|Object>} [opt.coordDimensions=[]]
	 * @param {number} [opt.dimensionsCount]
	 * @param {string} [opt.generateCoord]
	 * @param {string} [opt.generateCoordCount]
	 * @param {Array.<string|Object>} [opt.dimensionsDefine=source.dimensionsDefine] Overwrite source define.
	 * @param {Object|HashMap} [opt.encodeDefine=source.encodeDefine] Overwrite source define.
	 * @param {Function} [opt.encodeDefaulter] Make default encode if user not specified.
	 * @return {Array.<Object>} dimensionsInfo
	 */
	function _default(source, opt) {
	  opt = opt || {};
	  return completeDimensions(opt.coordDimensions || [], source, {
	    dimsDef: opt.dimensionsDefine || source.dimensionsDefine,
	    encodeDef: opt.encodeDefine || source.encodeDefine,
	    dimCount: opt.dimensionsCount,
	    encodeDefaulter: opt.encodeDefaulter,
	    generateCoord: opt.generateCoord,
	    generateCoordCount: opt.generateCoordCount
	  });
	}
	
	module.exports = _default;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Parse shadow style
	// TODO Only shallow path support
	function _default(properties) {
	  // Normalize
	  for (var i = 0; i < properties.length; i++) {
	    if (!properties[i][1]) {
	      properties[i][1] = properties[i][0];
	    }
	  }
	
	  return function (model, excludes, includes) {
	    var style = {};
	
	    for (var i = 0; i < properties.length; i++) {
	      var propName = properties[i][1];
	
	      if (excludes && zrUtil.indexOf(excludes, propName) >= 0 || includes && zrUtil.indexOf(includes, propName) < 0) {
	        continue;
	      }
	
	      var val = model.getShallow(propName);
	
	      if (val != null) {
	        style[properties[i][0]] = val;
	      }
	    }
	
	    return style;
	  };
	}
	
	module.exports = _default;

/***/ },
/* 253 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * This function is used to mark string literals representing CSS class names
	 * so that they can be transformed statically. This allows for modularization
	 * and minification of CSS class names.
	 *
	 * In static_upstream, this function is actually implemented, but it should
	 * eventually be replaced with something more descriptive, and the transform
	 * that is used in the main stack should be ported for use elsewhere.
	 *
	 * @param string|object className to modularize, or an object of key/values.
	 *                      In the object case, the values are conditions that
	 *                      determine if the className keys should be included.
	 * @param [string ...]  Variable list of classNames in the string case.
	 * @return string       Renderable space-separated CSS className.
	 */
	function cx(classNames) {
	  if (typeof classNames == 'object') {
	    return Object.keys(classNames).filter(function (className) {
	      return classNames[className];
	    }).map(replace).join(' ');
	  }
	  return Array.prototype.map.call(arguments, replace).join(' ');
	}
	
	function replace(str) {
	  return str.replace(/\//g, '-');
	}
	
	module.exports = cx;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.statesAreEqual = exports.createLocation = exports.createQuery = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _warning = __webpack_require__(216);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(182);
	
	var _Actions = __webpack_require__(367);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createQuery = exports.createQuery = function createQuery(props) {
	  return _extends(Object.create(null), props);
	};
	
	var createLocation = exports.createLocation = function createLocation() {
	  var input = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/';
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _Actions.POP;
	  var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  var object = typeof input === 'string' ? (0, _PathUtils.parsePath)(input) : input;
	
	   false ? (0, _warning2.default)(!object.path, 'Location descriptor objects should have a `pathname`, not a `path`.') : void 0;
	
	  var pathname = object.pathname || '/';
	  var search = object.search || '';
	  var hash = object.hash || '';
	  var state = object.state;
	
	  return {
	    pathname: pathname,
	    search: search,
	    hash: hash,
	    state: state,
	    action: action,
	    key: key
	  };
	};
	
	var isDate = function isDate(object) {
	  return Object.prototype.toString.call(object) === '[object Date]';
	};
	
	var statesAreEqual = exports.statesAreEqual = function statesAreEqual(a, b) {
	  if (a === b) return true;
	
	  var typeofA = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var typeofB = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (typeofA !== typeofB) return false;
	
	  !(typeofA !== 'function') ?  false ? (0, _invariant2.default)(false, 'You must not store functions in location state') : (0, _invariant2.default)(false) : void 0;
	
	  // Not the same object, but same type.
	  if (typeofA === 'object') {
	    !!(isDate(a) && isDate(b)) ?  false ? (0, _invariant2.default)(false, 'You must not store Date objects in location state') : (0, _invariant2.default)(false) : void 0;
	
	    if (!Array.isArray(a)) {
	      var keysofA = Object.keys(a);
	      var keysofB = Object.keys(b);
	      return keysofA.length === keysofB.length && keysofA.every(function (key) {
	        return statesAreEqual(a[key], b[key]);
	      });
	    }
	
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return statesAreEqual(item, b[index]);
	    });
	  }
	
	  // All other serializable types (string, number, boolean)
	  // should be strict equal.
	  return false;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.key === b.key &&
	  // a.action === b.action && // Different action !== location change.
	  a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && statesAreEqual(a.state, b.state);
	};

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(124);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 256 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.noop = noop;
	exports.getKeyFromChildrenIndex = getKeyFromChildrenIndex;
	exports.getMenuIdFromSubMenuEventKey = getMenuIdFromSubMenuEventKey;
	exports.loopMenuItem = loopMenuItem;
	exports.loopMenuItemRecursively = loopMenuItemRecursively;
	exports.isMobileDevice = exports.setStyle = exports.getWidth = exports.menuAllProps = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _isMobile = _interopRequireDefault(__webpack_require__(2708));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function noop() {}
	
	function getKeyFromChildrenIndex(child, menuEventKey, index) {
	  var prefix = menuEventKey || '';
	  return child.key || "".concat(prefix, "item_").concat(index);
	}
	
	function getMenuIdFromSubMenuEventKey(eventKey) {
	  return "".concat(eventKey, "-menu-");
	}
	
	function loopMenuItem(children, cb) {
	  var index = -1;
	  React.Children.forEach(children, function (c) {
	    index += 1;
	
	    if (c && c.type && c.type.isMenuItemGroup) {
	      React.Children.forEach(c.props.children, function (c2) {
	        index += 1;
	        cb(c2, index);
	      });
	    } else {
	      cb(c, index);
	    }
	  });
	}
	
	function loopMenuItemRecursively(children, keys, ret) {
	  /* istanbul ignore if */
	  if (!children || ret.find) {
	    return;
	  }
	
	  React.Children.forEach(children, function (c) {
	    if (c) {
	      var construct = c.type;
	
	      if (!construct || !(construct.isSubMenu || construct.isMenuItem || construct.isMenuItemGroup)) {
	        return;
	      }
	
	      if (keys.indexOf(c.key) !== -1) {
	        ret.find = true;
	      } else if (c.props.children) {
	        loopMenuItemRecursively(c.props.children, keys, ret);
	      }
	    }
	  });
	}
	
	var menuAllProps = ['defaultSelectedKeys', 'selectedKeys', 'defaultOpenKeys', 'openKeys', 'mode', 'getPopupContainer', 'onSelect', 'onDeselect', 'onDestroy', 'openTransitionName', 'openAnimation', 'subMenuOpenDelay', 'subMenuCloseDelay', 'forceSubMenuRender', 'triggerSubMenuAction', 'level', 'selectable', 'multiple', 'onOpenChange', 'visible', 'focusable', 'defaultActiveFirst', 'prefixCls', 'inlineIndent', 'parentMenu', 'title', 'rootPrefixCls', 'eventKey', 'active', 'onItemHover', 'onTitleMouseEnter', 'onTitleMouseLeave', 'onTitleClick', 'popupAlign', 'popupOffset', 'isOpen', 'renderMenuItem', 'manualRef', 'subMenuKey', 'disabled', 'index', 'isSelected', 'store', 'activeKey', 'builtinPlacements', 'overflowedIndicator', 'motion', // the following keys found need to be removed from test regression
	'attribute', 'value', 'popupClassName', 'inlineCollapsed', 'menu', 'theme', 'itemIcon', 'expandIcon']; // ref: https://github.com/ant-design/ant-design/issues/14007
	// ref: https://bugs.chromium.org/p/chromium/issues/detail?id=360889
	// getBoundingClientRect return the full precision value, which is
	// not the same behavior as on chrome. Set the precision to 6 to
	// unify their behavior
	
	exports.menuAllProps = menuAllProps;
	
	var getWidth = function getWidth(elem) {
	  var width = elem && typeof elem.getBoundingClientRect === 'function' && elem.getBoundingClientRect().width;
	
	  if (width) {
	    width = +width.toFixed(6);
	  }
	
	  return width || 0;
	};
	
	exports.getWidth = getWidth;
	
	var setStyle = function setStyle(elem, styleProperty, value) {
	  if (elem && _typeof(elem.style) === 'object') {
	    elem.style[styleProperty] = value;
	  }
	};
	
	exports.setStyle = setStyle;
	
	var isMobileDevice = function isMobileDevice() {
	  return _isMobile.default.any;
	};
	
	exports.isMobileDevice = isMobileDevice;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(572);
	var setInnerHTML = __webpack_require__(389);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(580);
	var setTextContent = __webpack_require__(1147);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var invariant = __webpack_require__(18);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(2817);
	var ReactInstrumentation = __webpack_require__(128);
	
	var warning = __webpack_require__(49);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compilePattern = compilePattern;
	exports.matchPattern = matchPattern;
	exports.getParamNames = getParamNames;
	exports.getParams = getParams;
	exports.formatPattern = formatPattern;
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function escapeRegExp(string) {
	  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}
	
	function _compilePattern(pattern) {
	  var regexpSource = '';
	  var paramNames = [];
	  var tokens = [];
	
	  var match = void 0,
	      lastIndex = 0,
	      matcher = /:([a-zA-Z_$][a-zA-Z0-9_$]*)|\*\*|\*|\(|\)|\\\(|\\\)/g;
	  while (match = matcher.exec(pattern)) {
	    if (match.index !== lastIndex) {
	      tokens.push(pattern.slice(lastIndex, match.index));
	      regexpSource += escapeRegExp(pattern.slice(lastIndex, match.index));
	    }
	
	    if (match[1]) {
	      regexpSource += '([^/]+)';
	      paramNames.push(match[1]);
	    } else if (match[0] === '**') {
	      regexpSource += '(.*)';
	      paramNames.push('splat');
	    } else if (match[0] === '*') {
	      regexpSource += '(.*?)';
	      paramNames.push('splat');
	    } else if (match[0] === '(') {
	      regexpSource += '(?:';
	    } else if (match[0] === ')') {
	      regexpSource += ')?';
	    } else if (match[0] === '\\(') {
	      regexpSource += '\\(';
	    } else if (match[0] === '\\)') {
	      regexpSource += '\\)';
	    }
	
	    tokens.push(match[0]);
	
	    lastIndex = matcher.lastIndex;
	  }
	
	  if (lastIndex !== pattern.length) {
	    tokens.push(pattern.slice(lastIndex, pattern.length));
	    regexpSource += escapeRegExp(pattern.slice(lastIndex, pattern.length));
	  }
	
	  return {
	    pattern: pattern,
	    regexpSource: regexpSource,
	    paramNames: paramNames,
	    tokens: tokens
	  };
	}
	
	var CompiledPatternsCache = Object.create(null);
	
	function compilePattern(pattern) {
	  if (!CompiledPatternsCache[pattern]) CompiledPatternsCache[pattern] = _compilePattern(pattern);
	
	  return CompiledPatternsCache[pattern];
	}
	
	/**
	 * Attempts to match a pattern on the given pathname. Patterns may use
	 * the following special characters:
	 *
	 * - :paramName     Matches a URL segment up to the next /, ?, or #. The
	 *                  captured string is considered a "param"
	 * - ()             Wraps a segment of the URL that is optional
	 * - *              Consumes (non-greedy) all characters up to the next
	 *                  character in the pattern, or to the end of the URL if
	 *                  there is none
	 * - **             Consumes (greedy) all characters up to the next character
	 *                  in the pattern, or to the end of the URL if there is none
	 *
	 *  The function calls callback(error, matched) when finished.
	 * The return value is an object with the following properties:
	 *
	 * - remainingPathname
	 * - paramNames
	 * - paramValues
	 */
	function matchPattern(pattern, pathname) {
	  // Ensure pattern starts with leading slash for consistency with pathname.
	  if (pattern.charAt(0) !== '/') {
	    pattern = '/' + pattern;
	  }
	
	  var _compilePattern2 = compilePattern(pattern),
	      regexpSource = _compilePattern2.regexpSource,
	      paramNames = _compilePattern2.paramNames,
	      tokens = _compilePattern2.tokens;
	
	  if (pattern.charAt(pattern.length - 1) !== '/') {
	    regexpSource += '/?'; // Allow optional path separator at end.
	  }
	
	  // Special-case patterns like '*' for catch-all routes.
	  if (tokens[tokens.length - 1] === '*') {
	    regexpSource += '$';
	  }
	
	  var match = pathname.match(new RegExp('^' + regexpSource, 'i'));
	  if (match == null) {
	    return null;
	  }
	
	  var matchedPath = match[0];
	  var remainingPathname = pathname.substr(matchedPath.length);
	
	  if (remainingPathname) {
	    // Require that the match ends at a path separator, if we didn't match
	    // the full path, so any remaining pathname is a new path segment.
	    if (matchedPath.charAt(matchedPath.length - 1) !== '/') {
	      return null;
	    }
	
	    // If there is a remaining pathname, treat the path separator as part of
	    // the remaining pathname for properly continuing the match.
	    remainingPathname = '/' + remainingPathname;
	  }
	
	  return {
	    remainingPathname: remainingPathname,
	    paramNames: paramNames,
	    paramValues: match.slice(1).map(function (v) {
	      return v && decodeURIComponent(v);
	    })
	  };
	}
	
	function getParamNames(pattern) {
	  return compilePattern(pattern).paramNames;
	}
	
	function getParams(pattern, pathname) {
	  var match = matchPattern(pattern, pathname);
	  if (!match) {
	    return null;
	  }
	
	  var paramNames = match.paramNames,
	      paramValues = match.paramValues;
	
	  var params = {};
	
	  paramNames.forEach(function (paramName, index) {
	    params[paramName] = paramValues[index];
	  });
	
	  return params;
	}
	
	/**
	 * Returns a version of the given pattern with params interpolated. Throws
	 * if there is a dynamic segment of the pattern for which there is no param.
	 */
	function formatPattern(pattern, params) {
	  params = params || {};
	
	  var _compilePattern3 = compilePattern(pattern),
	      tokens = _compilePattern3.tokens;
	
	  var parenCount = 0,
	      pathname = '',
	      splatIndex = 0,
	      parenHistory = [];
	
	  var token = void 0,
	      paramName = void 0,
	      paramValue = void 0;
	  for (var i = 0, len = tokens.length; i < len; ++i) {
	    token = tokens[i];
	
	    if (token === '*' || token === '**') {
	      paramValue = Array.isArray(params.splat) ? params.splat[splatIndex++] : params.splat;
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing splat #%s for path "%s"', splatIndex, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue != null) pathname += encodeURI(paramValue);
	    } else if (token === '(') {
	      parenHistory[parenCount] = '';
	      parenCount += 1;
	    } else if (token === ')') {
	      var parenText = parenHistory.pop();
	      parenCount -= 1;
	
	      if (parenCount) parenHistory[parenCount - 1] += parenText;else pathname += parenText;
	    } else if (token === '\\(') {
	      pathname += '(';
	    } else if (token === '\\)') {
	      pathname += ')';
	    } else if (token.charAt(0) === ':') {
	      paramName = token.substring(1);
	      paramValue = params[paramName];
	
	      !(paramValue != null || parenCount > 0) ?  false ? (0, _invariant2.default)(false, 'Missing "%s" parameter for path "%s"', paramName, pattern) : (0, _invariant2.default)(false) : void 0;
	
	      if (paramValue == null) {
	        if (parenCount) {
	          parenHistory[parenCount - 1] = '';
	
	          var curTokenIdx = tokens.indexOf(token);
	          var tokensSubset = tokens.slice(curTokenIdx, tokens.length);
	          var nextParenIdx = -1;
	
	          for (var _i = 0; _i < tokensSubset.length; _i++) {
	            if (tokensSubset[_i] == ')') {
	              nextParenIdx = _i;
	              break;
	            }
	          }
	
	          !(nextParenIdx > 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren at segment "%s"', pattern, tokensSubset.join('')) : (0, _invariant2.default)(false) : void 0;
	
	          // jump to ending paren
	          i = curTokenIdx + nextParenIdx - 1;
	        }
	      } else if (parenCount) parenHistory[parenCount - 1] += encodeURIComponent(paramValue);else pathname += encodeURIComponent(paramValue);
	    } else {
	      if (parenCount) parenHistory[parenCount - 1] += token;else pathname += token;
	    }
	  }
	
	  !(parenCount <= 0) ?  false ? (0, _invariant2.default)(false, 'Path "%s" is missing end paren', pattern) : (0, _invariant2.default)(false) : void 0;
	
	  return pathname.replace(/\/+/g, '/');
	}

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = routerWarning;
	exports._resetWarned = _resetWarned;
	
	var _warning = __webpack_require__(2878);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {};
	
	function routerWarning(falseToWarn, message) {
	  // Only issue deprecation warnings once.
	  if (message.indexOf('deprecated') !== -1) {
	    if (warned[message]) {
	      return;
	    }
	
	    warned[message] = true;
	  }
	
	  message = '[react-router] ' + message;
	
	  for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	    args[_key - 2] = arguments[_key];
	  }
	
	  _warning2.default.apply(undefined, [falseToWarn, message].concat(args));
	}
	
	function _resetWarned() {
	  warned = {};
	}

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var ReactBaseClasses = __webpack_require__(1164);
	var ReactChildren = __webpack_require__(2889);
	var ReactDOMFactories = __webpack_require__(2890);
	var ReactElement = __webpack_require__(264);
	var ReactPropTypes = __webpack_require__(2891);
	var ReactVersion = __webpack_require__(2892);
	
	var createReactClass = __webpack_require__(2893);
	var onlyChild = __webpack_require__(2897);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var ReactCurrentOwner = __webpack_require__(164);
	
	var warning = __webpack_require__(49);
	var canDefineProperty = __webpack_require__(1168);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(1166);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 265 */
36,
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(188);
	
	var vec2 = __webpack_require__(55);
	
	var bbox = __webpack_require__(314);
	
	var BoundingRect = __webpack_require__(60);
	
	var _config = __webpack_require__(392);
	
	var dpr = _config.devicePixelRatio;
	
	/**
	 * Path 代理，可以在`buildPath`中用于替代`ctx`, 会保存每个path操作的命令到pathCommands属性中
	 * 可以用于 isInsidePath 判断以及获取boundingRect
	 *
	 * @module zrender/core/PathProxy
	 * @author Yi Shen (http://www.github.com/pissang)
	 */
	// TODO getTotalLength, getPointAtLength
	
	/* global Float32Array */
	var CMD = {
	  M: 1,
	  L: 2,
	  C: 3,
	  Q: 4,
	  A: 5,
	  Z: 6,
	  // Rect
	  R: 7
	}; // var CMD_MEM_SIZE = {
	//     M: 3,
	//     L: 3,
	//     C: 7,
	//     Q: 5,
	//     A: 9,
	//     R: 5,
	//     Z: 1
	// };
	
	var min = [];
	var max = [];
	var min2 = [];
	var max2 = [];
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathCos = Math.cos;
	var mathSin = Math.sin;
	var mathSqrt = Math.sqrt;
	var mathAbs = Math.abs;
	var hasTypedArray = typeof Float32Array !== 'undefined';
	/**
	 * @alias module:zrender/core/PathProxy
	 * @constructor
	 */
	
	var PathProxy = function (notSaveData) {
	  this._saveData = !(notSaveData || false);
	
	  if (this._saveData) {
	    /**
	     * Path data. Stored as flat array
	     * @type {Array.<Object>}
	     */
	    this.data = [];
	  }
	
	  this._ctx = null;
	};
	/**
	 * 快速计算Path包围盒（并不是最小包围盒）
	 * @return {Object}
	 */
	
	
	PathProxy.prototype = {
	  constructor: PathProxy,
	  _xi: 0,
	  _yi: 0,
	  _x0: 0,
	  _y0: 0,
	  // Unit x, Unit y. Provide for avoiding drawing that too short line segment
	  _ux: 0,
	  _uy: 0,
	  _len: 0,
	  _lineDash: null,
	  _dashOffset: 0,
	  _dashIdx: 0,
	  _dashSum: 0,
	
	  /**
	   * @readOnly
	   */
	  setScale: function (sx, sy, segmentIgnoreThreshold) {
	    // Compat. Previously there is no segmentIgnoreThreshold.
	    segmentIgnoreThreshold = segmentIgnoreThreshold || 0;
	    this._ux = mathAbs(segmentIgnoreThreshold / dpr / sx) || 0;
	    this._uy = mathAbs(segmentIgnoreThreshold / dpr / sy) || 0;
	  },
	  getContext: function () {
	    return this._ctx;
	  },
	
	  /**
	   * @param  {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  beginPath: function (ctx) {
	    this._ctx = ctx;
	    ctx && ctx.beginPath();
	    ctx && (this.dpr = ctx.dpr); // Reset
	
	    if (this._saveData) {
	      this._len = 0;
	    }
	
	    if (this._lineDash) {
	      this._lineDash = null;
	      this._dashOffset = 0;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  moveTo: function (x, y) {
	    this.addData(CMD.M, x, y);
	    this._ctx && this._ctx.moveTo(x, y); // x0, y0, xi, yi 是记录在 _dashedXXXXTo 方法中使用
	    // xi, yi 记录当前点, x0, y0 在 closePath 的时候回到起始点。
	    // 有可能在 beginPath 之后直接调用 lineTo，这时候 x0, y0 需要
	    // 在 lineTo 方法中记录，这里先不考虑这种情况，dashed line 也只在 IE10- 中不支持
	
	    this._x0 = x;
	    this._y0 = y;
	    this._xi = x;
	    this._yi = y;
	    return this;
	  },
	
	  /**
	   * @param  {number} x
	   * @param  {number} y
	   * @return {module:zrender/core/PathProxy}
	   */
	  lineTo: function (x, y) {
	    var exceedUnit = mathAbs(x - this._xi) > this._ux || mathAbs(y - this._yi) > this._uy // Force draw the first segment
	    || this._len < 5;
	    this.addData(CMD.L, x, y);
	
	    if (this._ctx && exceedUnit) {
	      this._needsDash() ? this._dashedLineTo(x, y) : this._ctx.lineTo(x, y);
	    }
	
	    if (exceedUnit) {
	      this._xi = x;
	      this._yi = y;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @param  {number} x3
	   * @param  {number} y3
	   * @return {module:zrender/core/PathProxy}
	   */
	  bezierCurveTo: function (x1, y1, x2, y2, x3, y3) {
	    this.addData(CMD.C, x1, y1, x2, y2, x3, y3);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedBezierTo(x1, y1, x2, y2, x3, y3) : this._ctx.bezierCurveTo(x1, y1, x2, y2, x3, y3);
	    }
	
	    this._xi = x3;
	    this._yi = y3;
	    return this;
	  },
	
	  /**
	   * @param  {number} x1
	   * @param  {number} y1
	   * @param  {number} x2
	   * @param  {number} y2
	   * @return {module:zrender/core/PathProxy}
	   */
	  quadraticCurveTo: function (x1, y1, x2, y2) {
	    this.addData(CMD.Q, x1, y1, x2, y2);
	
	    if (this._ctx) {
	      this._needsDash() ? this._dashedQuadraticTo(x1, y1, x2, y2) : this._ctx.quadraticCurveTo(x1, y1, x2, y2);
	    }
	
	    this._xi = x2;
	    this._yi = y2;
	    return this;
	  },
	
	  /**
	   * @param  {number} cx
	   * @param  {number} cy
	   * @param  {number} r
	   * @param  {number} startAngle
	   * @param  {number} endAngle
	   * @param  {boolean} anticlockwise
	   * @return {module:zrender/core/PathProxy}
	   */
	  arc: function (cx, cy, r, startAngle, endAngle, anticlockwise) {
	    this.addData(CMD.A, cx, cy, r, r, startAngle, endAngle - startAngle, 0, anticlockwise ? 0 : 1);
	    this._ctx && this._ctx.arc(cx, cy, r, startAngle, endAngle, anticlockwise);
	    this._xi = mathCos(endAngle) * r + cx;
	    this._yi = mathSin(endAngle) * r + cy;
	    return this;
	  },
	  // TODO
	  arcTo: function (x1, y1, x2, y2, radius) {
	    if (this._ctx) {
	      this._ctx.arcTo(x1, y1, x2, y2, radius);
	    }
	
	    return this;
	  },
	  // TODO
	  rect: function (x, y, w, h) {
	    this._ctx && this._ctx.rect(x, y, w, h);
	    this.addData(CMD.R, x, y, w, h);
	    return this;
	  },
	
	  /**
	   * @return {module:zrender/core/PathProxy}
	   */
	  closePath: function () {
	    this.addData(CMD.Z);
	    var ctx = this._ctx;
	    var x0 = this._x0;
	    var y0 = this._y0;
	
	    if (ctx) {
	      this._needsDash() && this._dashedLineTo(x0, y0);
	      ctx.closePath();
	    }
	
	    this._xi = x0;
	    this._yi = y0;
	    return this;
	  },
	
	  /**
	   * Context 从外部传入，因为有可能是 rebuildPath 完之后再 fill。
	   * stroke 同样
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  fill: function (ctx) {
	    ctx && ctx.fill();
	    this.toStatic();
	  },
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   * @return {module:zrender/core/PathProxy}
	   */
	  stroke: function (ctx) {
	    ctx && ctx.stroke();
	    this.toStatic();
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDash: function (lineDash) {
	    if (lineDash instanceof Array) {
	      this._lineDash = lineDash;
	      this._dashIdx = 0;
	      var lineDashSum = 0;
	
	      for (var i = 0; i < lineDash.length; i++) {
	        lineDashSum += lineDash[i];
	      }
	
	      this._dashSum = lineDashSum;
	    }
	
	    return this;
	  },
	
	  /**
	   * 必须在其它绘制命令前调用
	   * Must be invoked before all other path drawing methods
	   * @return {module:zrender/core/PathProxy}
	   */
	  setLineDashOffset: function (offset) {
	    this._dashOffset = offset;
	    return this;
	  },
	
	  /**
	   *
	   * @return {boolean}
	   */
	  len: function () {
	    return this._len;
	  },
	
	  /**
	   * 直接设置 Path 数据
	   */
	  setData: function (data) {
	    var len = data.length;
	
	    if (!(this.data && this.data.length === len) && hasTypedArray) {
	      this.data = new Float32Array(len);
	    }
	
	    for (var i = 0; i < len; i++) {
	      this.data[i] = data[i];
	    }
	
	    this._len = len;
	  },
	
	  /**
	   * 添加子路径
	   * @param {module:zrender/core/PathProxy|Array.<module:zrender/core/PathProxy>} path
	   */
	  appendPath: function (path) {
	    if (!(path instanceof Array)) {
	      path = [path];
	    }
	
	    var len = path.length;
	    var appendSize = 0;
	    var offset = this._len;
	
	    for (var i = 0; i < len; i++) {
	      appendSize += path[i].len();
	    }
	
	    if (hasTypedArray && this.data instanceof Float32Array) {
	      this.data = new Float32Array(offset + appendSize);
	    }
	
	    for (var i = 0; i < len; i++) {
	      var appendPathData = path[i].data;
	
	      for (var k = 0; k < appendPathData.length; k++) {
	        this.data[offset++] = appendPathData[k];
	      }
	    }
	
	    this._len = offset;
	  },
	
	  /**
	   * 填充 Path 数据。
	   * 尽量复用而不申明新的数组。大部分图形重绘的指令数据长度都是不变的。
	   */
	  addData: function (cmd) {
	    if (!this._saveData) {
	      return;
	    }
	
	    var data = this.data;
	
	    if (this._len + arguments.length > data.length) {
	      // 因为之前的数组已经转换成静态的 Float32Array
	      // 所以不够用时需要扩展一个新的动态数组
	      this._expandData();
	
	      data = this.data;
	    }
	
	    for (var i = 0; i < arguments.length; i++) {
	      data[this._len++] = arguments[i];
	    }
	
	    this._prevCmd = cmd;
	  },
	  _expandData: function () {
	    // Only if data is Float32Array
	    if (!(this.data instanceof Array)) {
	      var newData = [];
	
	      for (var i = 0; i < this._len; i++) {
	        newData[i] = this.data[i];
	      }
	
	      this.data = newData;
	    }
	  },
	
	  /**
	   * If needs js implemented dashed line
	   * @return {boolean}
	   * @private
	   */
	  _needsDash: function () {
	    return this._lineDash;
	  },
	  _dashedLineTo: function (x1, y1) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var dx = x1 - x0;
	    var dy = y1 - y0;
	    var dist = mathSqrt(dx * dx + dy * dy);
	    var x = x0;
	    var y = y0;
	    var dash;
	    var nDash = lineDash.length;
	    var idx;
	    dx /= dist;
	    dy /= dist;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum;
	    x -= offset * dx;
	    y -= offset * dy;
	
	    while (dx > 0 && x <= x1 || dx < 0 && x >= x1 || dx === 0 && (dy > 0 && y <= y1 || dy < 0 && y >= y1)) {
	      idx = this._dashIdx;
	      dash = lineDash[idx];
	      x += dx * dash;
	      y += dy * dash;
	      this._dashIdx = (idx + 1) % nDash; // Skip positive offset
	
	      if (dx > 0 && x < x0 || dx < 0 && x > x0 || dy > 0 && y < y0 || dy < 0 && y > y0) {
	        continue;
	      }
	
	      ctx[idx % 2 ? 'moveTo' : 'lineTo'](dx >= 0 ? mathMin(x, x1) : mathMax(x, x1), dy >= 0 ? mathMin(y, y1) : mathMax(y, y1));
	    } // Offset for next lineTo
	
	
	    dx = x - x1;
	    dy = y - y1;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  // Not accurate dashed line to
	  _dashedBezierTo: function (x1, y1, x2, y2, x3, y3) {
	    var dashSum = this._dashSum;
	    var offset = this._dashOffset;
	    var lineDash = this._lineDash;
	    var ctx = this._ctx;
	    var x0 = this._xi;
	    var y0 = this._yi;
	    var t;
	    var dx;
	    var dy;
	    var cubicAt = curve.cubicAt;
	    var bezierLen = 0;
	    var idx = this._dashIdx;
	    var nDash = lineDash.length;
	    var x;
	    var y;
	    var tmpLen = 0;
	
	    if (offset < 0) {
	      // Convert to positive offset
	      offset = dashSum + offset;
	    }
	
	    offset %= dashSum; // Bezier approx length
	
	    for (t = 0; t < 1; t += 0.1) {
	      dx = cubicAt(x0, x1, x2, x3, t + 0.1) - cubicAt(x0, x1, x2, x3, t);
	      dy = cubicAt(y0, y1, y2, y3, t + 0.1) - cubicAt(y0, y1, y2, y3, t);
	      bezierLen += mathSqrt(dx * dx + dy * dy);
	    } // Find idx after add offset
	
	
	    for (; idx < nDash; idx++) {
	      tmpLen += lineDash[idx];
	
	      if (tmpLen > offset) {
	        break;
	      }
	    }
	
	    t = (tmpLen - offset) / bezierLen;
	
	    while (t <= 1) {
	      x = cubicAt(x0, x1, x2, x3, t);
	      y = cubicAt(y0, y1, y2, y3, t); // Use line to approximate dashed bezier
	      // Bad result if dash is long
	
	      idx % 2 ? ctx.moveTo(x, y) : ctx.lineTo(x, y);
	      t += lineDash[idx] / bezierLen;
	      idx = (idx + 1) % nDash;
	    } // Finish the last segment and calculate the new offset
	
	
	    idx % 2 !== 0 && ctx.lineTo(x3, y3);
	    dx = x3 - x;
	    dy = y3 - y;
	    this._dashOffset = -mathSqrt(dx * dx + dy * dy);
	  },
	  _dashedQuadraticTo: function (x1, y1, x2, y2) {
	    // Convert quadratic to cubic using degree elevation
	    var x3 = x2;
	    var y3 = y2;
	    x2 = (x2 + 2 * x1) / 3;
	    y2 = (y2 + 2 * y1) / 3;
	    x1 = (this._xi + 2 * x1) / 3;
	    y1 = (this._yi + 2 * y1) / 3;
	
	    this._dashedBezierTo(x1, y1, x2, y2, x3, y3);
	  },
	
	  /**
	   * 转成静态的 Float32Array 减少堆内存占用
	   * Convert dynamic array to static Float32Array
	   */
	  toStatic: function () {
	    var data = this.data;
	
	    if (data instanceof Array) {
	      data.length = this._len;
	
	      if (hasTypedArray) {
	        this.data = new Float32Array(data);
	      }
	    }
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    min[0] = min[1] = min2[0] = min2[1] = Number.MAX_VALUE;
	    max[0] = max[1] = max2[0] = max2[1] = -Number.MAX_VALUE;
	    var data = this.data;
	    var xi = 0;
	    var yi = 0;
	    var x0 = 0;
	    var y0 = 0;
	
	    for (var i = 0; i < data.length;) {
	      var cmd = data[i++];
	
	      if (i === 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = data[i];
	        yi = data[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	          // 在 closePath 的时候使用
	          x0 = data[i++];
	          y0 = data[i++];
	          xi = x0;
	          yi = y0;
	          min2[0] = x0;
	          min2[1] = y0;
	          max2[0] = x0;
	          max2[1] = y0;
	          break;
	
	        case CMD.L:
	          bbox.fromLine(xi, yi, data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.C:
	          bbox.fromCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.Q:
	          bbox.fromQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], min2, max2);
	          xi = data[i++];
	          yi = data[i++];
	          break;
	
	        case CMD.A:
	          // TODO Arc 判断的开销比较大
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++];
	          var endAngle = data[i++] + startAngle; // TODO Arc 旋转
	
	          i += 1;
	          var anticlockwise = 1 - data[i++];
	
	          if (i === 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(startAngle) * rx + cx;
	            y0 = mathSin(startAngle) * ry + cy;
	          }
	
	          bbox.fromArc(cx, cy, rx, ry, startAngle, endAngle, anticlockwise, min2, max2);
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = data[i++];
	          y0 = yi = data[i++];
	          var width = data[i++];
	          var height = data[i++]; // Use fromLine
	
	          bbox.fromLine(x0, y0, x0 + width, y0 + height, min2, max2);
	          break;
	
	        case CMD.Z:
	          xi = x0;
	          yi = y0;
	          break;
	      } // Union
	
	
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * Rebuild path from current data
	   * Rebuild path will not consider javascript implemented line dash.
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  rebuildPath: function (ctx) {
	    var d = this.data;
	    var x0;
	    var y0;
	    var xi;
	    var yi;
	    var x;
	    var y;
	    var ux = this._ux;
	    var uy = this._uy;
	    var len = this._len;
	
	    for (var i = 0; i < len;) {
	      var cmd = d[i++];
	
	      if (i === 1) {
	        // 如果第一个命令是 L, C, Q
	        // 则 previous point 同绘制命令的第一个 point
	        //
	        // 第一个命令为 Arc 的情况下会在后面特殊处理
	        xi = d[i];
	        yi = d[i + 1];
	        x0 = xi;
	        y0 = yi;
	      }
	
	      switch (cmd) {
	        case CMD.M:
	          x0 = xi = d[i++];
	          y0 = yi = d[i++];
	          ctx.moveTo(xi, yi);
	          break;
	
	        case CMD.L:
	          x = d[i++];
	          y = d[i++]; // Not draw too small seg between
	
	          if (mathAbs(x - xi) > ux || mathAbs(y - yi) > uy || i === len - 1) {
	            ctx.lineTo(x, y);
	            xi = x;
	            yi = y;
	          }
	
	          break;
	
	        case CMD.C:
	          ctx.bezierCurveTo(d[i++], d[i++], d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.Q:
	          ctx.quadraticCurveTo(d[i++], d[i++], d[i++], d[i++]);
	          xi = d[i - 2];
	          yi = d[i - 1];
	          break;
	
	        case CMD.A:
	          var cx = d[i++];
	          var cy = d[i++];
	          var rx = d[i++];
	          var ry = d[i++];
	          var theta = d[i++];
	          var dTheta = d[i++];
	          var psi = d[i++];
	          var fs = d[i++];
	          var r = rx > ry ? rx : ry;
	          var scaleX = rx > ry ? 1 : rx / ry;
	          var scaleY = rx > ry ? ry / rx : 1;
	          var isEllipse = Math.abs(rx - ry) > 1e-3;
	          var endAngle = theta + dTheta;
	
	          if (isEllipse) {
	            ctx.translate(cx, cy);
	            ctx.rotate(psi);
	            ctx.scale(scaleX, scaleY);
	            ctx.arc(0, 0, r, theta, endAngle, 1 - fs);
	            ctx.scale(1 / scaleX, 1 / scaleY);
	            ctx.rotate(-psi);
	            ctx.translate(-cx, -cy);
	          } else {
	            ctx.arc(cx, cy, r, theta, endAngle, 1 - fs);
	          }
	
	          if (i === 1) {
	            // 直接使用 arc 命令
	            // 第一个命令起点还未定义
	            x0 = mathCos(theta) * rx + cx;
	            y0 = mathSin(theta) * ry + cy;
	          }
	
	          xi = mathCos(endAngle) * rx + cx;
	          yi = mathSin(endAngle) * ry + cy;
	          break;
	
	        case CMD.R:
	          x0 = xi = d[i];
	          y0 = yi = d[i + 1];
	          ctx.rect(d[i++], d[i++], d[i++], d[i++]);
	          break;
	
	        case CMD.Z:
	          ctx.closePath();
	          xi = x0;
	          yi = y0;
	      }
	    }
	  }
	};
	PathProxy.CMD = CMD;
	var _default = PathProxy;
	module.exports = _default;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	var Displayable = __webpack_require__(316);
	
	var BoundingRect = __webpack_require__(60);
	
	var zrUtil = __webpack_require__(4);
	
	var imageHelper = __webpack_require__(604);
	
	/**
	 * @alias zrender/graphic/Image
	 * @extends module:zrender/graphic/Displayable
	 * @constructor
	 * @param {Object} opts
	 */
	function ZImage(opts) {
	  Displayable.call(this, opts);
	}
	
	ZImage.prototype = {
	  constructor: ZImage,
	  type: 'image',
	  brush: function (ctx, prevEl) {
	    var style = this.style;
	    var src = style.image; // Must bind each time
	
	    style.bind(ctx, this, prevEl);
	    var image = this._image = imageHelper.createOrUpdateImage(src, this._image, this, this.onload);
	
	    if (!image || !imageHelper.isImageReady(image)) {
	      return;
	    } // 图片已经加载完成
	    // if (image.nodeName.toUpperCase() == 'IMG') {
	    //     if (!image.complete) {
	    //         return;
	    //     }
	    // }
	    // Else is canvas
	
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var width = style.width;
	    var height = style.height;
	    var aspect = image.width / image.height;
	
	    if (width == null && height != null) {
	      // Keep image/height ratio
	      width = height * aspect;
	    } else if (height == null && width != null) {
	      height = width / aspect;
	    } else if (width == null && height == null) {
	      width = image.width;
	      height = image.height;
	    } // 设置transform
	
	
	    this.setTransform(ctx);
	
	    if (style.sWidth && style.sHeight) {
	      var sx = style.sx || 0;
	      var sy = style.sy || 0;
	      ctx.drawImage(image, sx, sy, style.sWidth, style.sHeight, x, y, width, height);
	    } else if (style.sx && style.sy) {
	      var sx = style.sx;
	      var sy = style.sy;
	      var sWidth = width - sx;
	      var sHeight = height - sy;
	      ctx.drawImage(image, sx, sy, sWidth, sHeight, x, y, width, height);
	    } else {
	      ctx.drawImage(image, x, y, width, height);
	    } // Draw rect text
	
	
	    if (style.text != null) {
	      // Only restore transform when needs draw text.
	      this.restoreTransform(ctx);
	      this.drawRectText(ctx, this.getBoundingRect());
	    }
	  },
	  getBoundingRect: function () {
	    var style = this.style;
	
	    if (!this._rect) {
	      this._rect = new BoundingRect(style.x || 0, style.y || 0, style.width || 0, style.height || 0);
	    }
	
	    return this._rect;
	  }
	};
	zrUtil.inherits(ZImage, Displayable);
	var _default = ZImage;
	module.exports = _default;

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = wrapperRaf;
	
	var _raf = _interopRequireDefault(__webpack_require__(127));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var id = 0;
	var ids = {}; // Support call raf with delay specified frame
	
	function wrapperRaf(callback) {
	  var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var myId = id++;
	  var restFrames = delayFrames;
	
	  function internalCallback() {
	    restFrames -= 1;
	
	    if (restFrames <= 0) {
	      callback();
	      delete ids[myId];
	    } else {
	      ids[myId] = (0, _raf["default"])(internalCallback);
	    }
	  }
	
	  ids[myId] = (0, _raf["default"])(internalCallback);
	  return myId;
	}
	
	wrapperRaf.cancel = function cancel(pid) {
	  if (pid === undefined) return;
	
	  _raf["default"].cancel(ids[pid]);
	
	  delete ids[pid];
	};
	
	wrapperRaf.ids = ids; // export this for test usage

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fixControlledValue = fixControlledValue;
	exports.resolveOnChange = resolveOnChange;
	exports.getInputClassName = getInputClassName;
	exports["default"] = exports.InputSizes = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _type = __webpack_require__(87);
	
	var _ClearableLabeledInput = _interopRequireWildcard(__webpack_require__(633));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InputSizes = (0, _type.tuple)('small', 'default', 'large');
	exports.InputSizes = InputSizes;
	
	function fixControlledValue(value) {
	  if (typeof value === 'undefined' || value === null) {
	    return '';
	  }
	
	  return value;
	}
	
	function resolveOnChange(target, e, onChange) {
	  if (onChange) {
	    var event = e;
	
	    if (e.type === 'click') {
	      // click clear icon
	      event = Object.create(e);
	      event.target = target;
	      event.currentTarget = target;
	      var originalInputValue = target.value; // change target ref value cause e.target.value should be '' when clear input
	
	      target.value = '';
	      onChange(event); // reset target ref value
	
	      target.value = originalInputValue;
	      return;
	    }
	
	    onChange(event);
	  }
	}
	
	function getInputClassName(prefixCls, size, disabled) {
	  var _classNames;
	
	  return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
	}
	
	var Input = /*#__PURE__*/function (_React$Component) {
	  _inherits(Input, _React$Component);
	
	  var _super = _createSuper(Input);
	
	  function Input(props) {
	    var _this;
	
	    _classCallCheck(this, Input);
	
	    _this = _super.call(this, props);
	
	    _this.saveClearableInput = function (input) {
	      _this.clearableInput = input;
	    };
	
	    _this.saveInput = function (input) {
	      _this.input = input;
	    };
	
	    _this.handleReset = function (e) {
	      _this.setValue('', function () {
	        _this.focus();
	      });
	
	      resolveOnChange(_this.input, e, _this.props.onChange);
	    };
	
	    _this.renderInput = function (prefixCls) {
	      var _this$props = _this.props,
	          className = _this$props.className,
	          addonBefore = _this$props.addonBefore,
	          addonAfter = _this$props.addonAfter,
	          size = _this$props.size,
	          disabled = _this$props.disabled; // Fix https://fb.me/react-unknown-prop
	
	      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'allowClear', // Input elements must be either controlled or uncontrolled,
	      // specify either the value prop, or the defaultValue prop, but not both.
	      'defaultValue', 'size', 'inputType']);
	      return /*#__PURE__*/React.createElement("input", _extends({}, otherProps, {
	        onChange: _this.handleChange,
	        onKeyDown: _this.handleKeyDown,
	        className: (0, _classnames["default"])(getInputClassName(prefixCls, size, disabled), _defineProperty({}, className, className && !addonBefore && !addonAfter)),
	        ref: _this.saveInput
	      }));
	    };
	
	    _this.clearPasswordValueAttribute = function () {
	      // https://github.com/ant-design/ant-design/issues/20541
	      _this.removePasswordTimeout = setTimeout(function () {
	        if (_this.input && _this.input.getAttribute('type') === 'password' && _this.input.hasAttribute('value')) {
	          _this.input.removeAttribute('value');
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setValue(e.target.value, _this.clearPasswordValueAttribute);
	
	      resolveOnChange(_this.input, e, _this.props.onChange);
	    };
	
	    _this.handleKeyDown = function (e) {
	      var _this$props2 = _this.props,
	          onPressEnter = _this$props2.onPressEnter,
	          onKeyDown = _this$props2.onKeyDown;
	
	      if (e.keyCode === 13 && onPressEnter) {
	        onPressEnter(e);
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	    };
	
	    _this.renderComponent = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var value = _this.state.value;
	      var customizePrefixCls = _this.props.prefixCls;
	      var prefixCls = getPrefixCls('input', customizePrefixCls);
	      return /*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        inputType: "input",
	        value: fixControlledValue(value),
	        element: _this.renderInput(prefixCls),
	        handleReset: _this.handleReset,
	        ref: _this.saveClearableInput
	      }));
	    };
	
	    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(Input, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.clearPasswordValueAttribute();
	    } // Since polyfill `getSnapshotBeforeUpdate` need work with `componentDidUpdate`.
	    // We keep an empty function here.
	
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {}
	  }, {
	    key: "getSnapshotBeforeUpdate",
	    value: function getSnapshotBeforeUpdate(prevProps) {
	      if ((0, _ClearableLabeledInput.hasPrefixSuffix)(prevProps) !== (0, _ClearableLabeledInput.hasPrefixSuffix)(this.props)) {
	        (0, _warning["default"])(this.input !== document.activeElement, 'Input', "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ");
	      }
	
	      return null;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.removePasswordTimeout) {
	        clearTimeout(this.removePasswordTimeout);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "select",
	    value: function select() {
	      this.input.select();
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, callback) {
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        }, callback);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Input;
	}(React.Component);
	
	Input.defaultProps = {
	  type: 'text'
	};
	Input.propTypes = {
	  type: PropTypes.string,
	  id: PropTypes.string,
	  size: PropTypes.oneOf(InputSizes),
	  maxLength: PropTypes.number,
	  disabled: PropTypes.bool,
	  value: PropTypes.any,
	  defaultValue: PropTypes.any,
	  className: PropTypes.string,
	  addonBefore: PropTypes.node,
	  addonAfter: PropTypes.node,
	  prefixCls: PropTypes.string,
	  onPressEnter: PropTypes.func,
	  onKeyDown: PropTypes.func,
	  onKeyUp: PropTypes.func,
	  onFocus: PropTypes.func,
	  onBlur: PropTypes.func,
	  prefix: PropTypes.node,
	  suffix: PropTypes.node,
	  allowClear: PropTypes.bool
	};
	(0, _reactLifecyclesCompat.polyfill)(Input);
	var _default = Input;
	exports["default"] = _default;

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSelect = _interopRequireWildcard(__webpack_require__(1102));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _type = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SelectSizes = (0, _type.tuple)('default', 'large', 'small');
	var ModeOptions = (0, _type.tuple)('default', 'multiple', 'tags', 'combobox', 'SECRET_COMBOBOX_MODE_DO_NOT_USE');
	var SelectPropTypes = {
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  size: PropTypes.oneOf(SelectSizes),
	  notFoundContent: PropTypes.any,
	  showSearch: PropTypes.bool,
	  optionLabelProp: PropTypes.string,
	  transitionName: PropTypes.string,
	  choiceTransitionName: PropTypes.string,
	  id: PropTypes.string
	};
	
	var Select = /*#__PURE__*/function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  var _super = _createSuper(Select);
	
	  function Select(props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _super.call(this, props);
	
	    _this.saveSelect = function (node) {
	      _this.rcSelect = node;
	    };
	
	    _this.renderSelect = function (_ref) {
	      var _classNames;
	
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          _a$className = _a.className,
	          className = _a$className === void 0 ? '' : _a$className,
	          size = _a.size,
	          mode = _a.mode,
	          getPopupContainer = _a.getPopupContainer,
	          removeIcon = _a.removeIcon,
	          clearIcon = _a.clearIcon,
	          menuItemSelectedIcon = _a.menuItemSelectedIcon,
	          showArrow = _a.showArrow,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "mode", "getPopupContainer", "removeIcon", "clearIcon", "menuItemSelectedIcon", "showArrow"]);
	
	      var rest = (0, _omit["default"])(restProps, ['inputIcon']);
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-show-arrow"), showArrow), _classNames), className);
	      var optionLabelProp = _this.props.optionLabelProp;
	
	      if (_this.isCombobox()) {
	        // children 带 dom 结构时，无法填入输入框
	        optionLabelProp = optionLabelProp || 'value';
	      }
	
	      var modeConfig = {
	        multiple: mode === 'multiple',
	        tags: mode === 'tags',
	        combobox: _this.isCombobox()
	      };
	      var finalRemoveIcon = removeIcon && ( /*#__PURE__*/React.isValidElement(removeIcon) ? /*#__PURE__*/React.cloneElement(removeIcon, {
	        className: (0, _classnames["default"])(removeIcon.props.className, "".concat(prefixCls, "-remove-icon"))
	      }) : removeIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        className: "".concat(prefixCls, "-remove-icon")
	      });
	      var finalClearIcon = clearIcon && ( /*#__PURE__*/React.isValidElement(clearIcon) ? /*#__PURE__*/React.cloneElement(clearIcon, {
	        className: (0, _classnames["default"])(clearIcon.props.className, "".concat(prefixCls, "-clear-icon"))
	      }) : clearIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-clear-icon")
	      });
	      var finalMenuItemSelectedIcon = menuItemSelectedIcon && ( /*#__PURE__*/React.isValidElement(menuItemSelectedIcon) ? /*#__PURE__*/React.cloneElement(menuItemSelectedIcon, {
	        className: (0, _classnames["default"])(menuItemSelectedIcon.props.className, "".concat(prefixCls, "-selected-icon"))
	      }) : menuItemSelectedIcon) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "check",
	        className: "".concat(prefixCls, "-selected-icon")
	      });
	      return /*#__PURE__*/React.createElement(_rcSelect["default"], _extends({
	        inputIcon: _this.renderSuffixIcon(prefixCls),
	        removeIcon: finalRemoveIcon,
	        clearIcon: finalClearIcon,
	        menuItemSelectedIcon: finalMenuItemSelectedIcon,
	        showArrow: showArrow
	      }, rest, modeConfig, {
	        prefixCls: prefixCls,
	        className: cls,
	        optionLabelProp: optionLabelProp || 'children',
	        notFoundContent: _this.getNotFoundContent(renderEmpty),
	        getPopupContainer: getPopupContainer || getContextPopupContainer,
	        ref: _this.saveSelect
	      }));
	    };
	
	    (0, _warning["default"])(props.mode !== 'combobox', 'Select', 'The combobox mode is deprecated, ' + 'it will be removed in next major version, ' + 'please use AutoComplete instead');
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "getNotFoundContent",
	    value: function getNotFoundContent(renderEmpty) {
	      var notFoundContent = this.props.notFoundContent;
	
	      if (notFoundContent !== undefined) {
	        return notFoundContent;
	      }
	
	      if (this.isCombobox()) {
	        return null;
	      }
	
	      return renderEmpty('Select');
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcSelect.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSelect.blur();
	    }
	  }, {
	    key: "isCombobox",
	    value: function isCombobox() {
	      var mode = this.props.mode;
	      return mode === 'combobox' || mode === Select.SECRET_COMBOBOX_MODE_DO_NOT_USE;
	    }
	  }, {
	    key: "renderSuffixIcon",
	    value: function renderSuffixIcon(prefixCls) {
	      var _this$props = this.props,
	          loading = _this$props.loading,
	          suffixIcon = _this$props.suffixIcon;
	
	      if (suffixIcon) {
	        return /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	          className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-arrow-icon"))
	        }) : suffixIcon;
	      }
	
	      if (loading) {
	        return /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "loading"
	        });
	      }
	
	      return /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: "".concat(prefixCls, "-arrow-icon")
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSelect);
	    }
	  }]);
	
	  return Select;
	}(React.Component);
	
	exports["default"] = Select;
	Select.Option = _rcSelect.Option;
	Select.OptGroup = _rcSelect.OptGroup;
	Select.SECRET_COMBOBOX_MODE_DO_NOT_USE = 'SECRET_COMBOBOX_MODE_DO_NOT_USE';
	Select.defaultProps = {
	  showSearch: false,
	  transitionName: 'slide-up',
	  choiceTransitionName: 'zoom'
	};
	Select.propTypes = SelectPropTypes;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryDownloadReceiptTemplate = exports.queryImportReceipt = exports.queryAbleReceipt = exports.queryDeleteReceipt = exports.querySaveReceipt = exports.queryReceiptInfo = exports.queryReceiptList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var queryReceiptList = exports.queryReceiptList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.finance.GET_RECEIPT_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryReceiptList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryReceiptInfo = exports.queryReceiptInfo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.finance.GET_RECEIPT_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryReceiptInfo(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var querySaveReceipt = exports.querySaveReceipt = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.post(_req.finance.SAVE_RECEIPT, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function querySaveReceipt(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryDeleteReceipt = exports.queryDeleteReceipt = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.finance.DELETE_RECEIPT, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryDeleteReceipt(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryAbleReceipt = exports.queryAbleReceipt = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.post(_req.finance.ABLE_RECEIPT, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryAbleReceipt(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryImportReceipt = exports.queryImportReceipt = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.post(_req.finance.IMPORT_RECEIPT, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryImportReceipt(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var queryDownloadReceiptTemplate = exports.queryDownloadReceiptTemplate = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7() {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            _http2.default.download(_req.finance.DOWNLOAD_RECEIPT_TEMPLATE, {}, '公司回单卡记录-模板.xlsx');
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryDownloadReceiptTemplate() {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryDoneTaskList = exports.queryTaskList = exports.queryDeleteWorkflowTemplate = exports.querySaveWorkflowTemplate = exports.queryWorkflowTemplateInfo = exports.queryWorkflowTemplateList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 获取工作流模板列表
	 * @param {} params
	 * @returns {}
	 */
	var queryWorkflowTemplateList = exports.queryWorkflowTemplateList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.workflow.WORKFLOW_TEMPLATE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryWorkflowTemplateList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取工作流模板详情
	 * @param {} uuid
	 * @returns {}
	 */
	
	
	var queryWorkflowTemplateInfo = exports.queryWorkflowTemplateInfo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(uuid) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.workflow.WORKFLOW_TEMPLATE_INFO, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryWorkflowTemplateInfo(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	/**
	 * 保存工作流模板
	 * @param {} params
	 * @returns {}
	 */
	
	
	var querySaveWorkflowTemplate = exports.querySaveWorkflowTemplate = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.post(_req.workflow.WORKFLOW_TEMPLATE_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function querySaveWorkflowTemplate(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	/**
	 * 删除工作流模板
	 * @param {} uuid
	 * @returns {}
	 */
	
	
	var queryDeleteWorkflowTemplate = exports.queryDeleteWorkflowTemplate = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(uuid) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.workflow.WORKFLOW_TEMPLATE_DELETE, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryDeleteWorkflowTemplate(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取个人任务列表
	 */
	
	
	var queryTaskList = exports.queryTaskList = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.workflow.GET_TASK_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryTaskList(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var queryDoneTaskList = exports.queryDoneTaskList = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.get(_req.workflow.GET_DONE_TASK_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryDoneTaskList(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* 工作流模块api */

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _core_account_search = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.onChange = function (value, options) {
	      _this.setState({
	        value: value
	      });
	      _this.props.onChange(value, options);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch((0, _core_account_search.getAccountSearch)());
	      this.setState({
	        value: this.props.value
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.props.value !== nextProps.value && this.setState({ value: nextProps.value });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var value = this.state.value;
	      var _props = this.props,
	          options = _props.options,
	          name = _props.name;
	
	      return _react2.default.createElement(
	        _antd.Select,
	        {
	          showSearch: true,
	          mode: this.props.isMultiple || '',
	          value: value,
	          onChange: this.onChange,
	          placeholder: '\u4EBA\u5458',
	          optionFilterProp: 'children',
	          filterOption: function filterOption(input, option) {
	            return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	          }
	        },
	        value && name && !options.some(function (item) {
	          return item.uuid === value;
	        }) ? _react2.default.createElement(
	          Option,
	          { key: value, disabled: true },
	          name,
	          '(\u5DF2\u7981\u7528)'
	        ) : null,
	        options.map(function (item) {
	          return _react2.default.createElement(
	            Option,
	            { key: item.uuid },
	            item.name
	          );
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    options: state.core_account_search
	  };
	})(Index);

/***/ },
/* 274 */
[3033, 753, 448],
/* 275 */
202,
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.2.5.3 get RegExp.prototype.flags
	var anObject = __webpack_require__(31);
	module.exports = function () {
	  var that = anObject(this);
	  var result = '';
	  if (that.global) result += 'g';
	  if (that.ignoreCase) result += 'i';
	  if (that.multiline) result += 'm';
	  if (that.unicode) result += 'u';
	  if (that.sticky) result += 'y';
	  return result;
	};


/***/ },
/* 277 */
[3015, 116],
/* 278 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 279 */
[3038, 117, 42, 173],
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)
	var anObject = __webpack_require__(31);
	var aFunction = __webpack_require__(84);
	var SPECIES = __webpack_require__(58)('species');
	module.exports = function (O, D) {
	  var C = anObject(O).constructor;
	  var S;
	  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	};


/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(2131);

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockMapBuilder
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(39);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var BlockMapBuilder = {
	  createFromArray: function createFromArray(blocks) {
	    return OrderedMap(blocks.map(function (block) {
	      return [block.getKey(), block];
	    }));
	  }
	};
	
	module.exports = BlockMapBuilder;

/***/ },
/* 283 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftOffsetKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var KEY_DELIMITER = '-';
	
	var DraftOffsetKey = {
	  encode: function encode(blockKey, decoratorKey, leafKey) {
	    return blockKey + KEY_DELIMITER + decoratorKey + KEY_DELIMITER + leafKey;
	  },
	
	  decode: function decode(offsetKey) {
	    var _offsetKey$split = offsetKey.split(KEY_DELIMITER),
	        blockKey = _offsetKey$split[0],
	        decoratorKey = _offsetKey$split[1],
	        leafKey = _offsetKey$split[2];
	
	    return {
	      blockKey: blockKey,
	      decoratorKey: parseInt(decoratorKey, 10),
	      leafKey: parseInt(leafKey, 10)
	    };
	  }
	};
	
	module.exports = DraftOffsetKey;

/***/ },
/* 284 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findRangesImmutable
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Search through an array to find contiguous stretches of elements that
	 * match a specified filter function.
	 *
	 * When ranges are found, execute a specified `found` function to supply
	 * the values to the caller.
	 */
	function findRangesImmutable(haystack, areEqualFn, filterFn, foundFn) {
	  if (!haystack.size) {
	    return;
	  }
	
	  var cursor = 0;
	
	  haystack.reduce(function (value, nextValue, nextIndex) {
	    if (!areEqualFn(value, nextValue)) {
	      if (filterFn(value)) {
	        foundFn(cursor, nextIndex);
	      }
	      cursor = nextIndex;
	    }
	    return nextValue;
	  });
	
	  filterFn(haystack.last()) && foundFn(cursor, haystack.count());
	}
	
	module.exports = findRangesImmutable;

/***/ },
/* 285 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isEventHandled
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Utility method for determining whether or not the value returned
	 * from a handler indicates that it was handled.
	 */
	function isEventHandled(value) {
	  return value === 'handled' || value === true;
	}
	
	module.exports = isEventHandled;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeTextWithStrategy
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(92);
	
	/**
	 * For a collapsed selection state, remove text based on the specified strategy.
	 * If the selection state is not collapsed, remove the entire selected range.
	 */
	function removeTextWithStrategy(editorState, strategy, direction) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var target = selection;
	  if (selection.isCollapsed()) {
	    if (direction === 'forward') {
	      if (editorState.isSelectionAtEndOfContent()) {
	        return content;
	      }
	    } else if (editorState.isSelectionAtStartOfContent()) {
	      return content;
	    }
	
	    target = strategy(editorState);
	    if (target === selection) {
	      return content;
	    }
	  }
	  return DraftModifier.removeRange(content, target, direction);
	}
	
	module.exports = removeTextWithStrategy;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var SymbolClz = __webpack_require__(352);
	
	var _util = __webpack_require__(4);
	
	var isObject = _util.isObject;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/SymbolDraw
	 */
	
	/**
	 * @constructor
	 * @alias module:echarts/chart/helper/SymbolDraw
	 * @param {module:zrender/graphic/Group} [symbolCtor]
	 */
	function SymbolDraw(symbolCtor) {
	  this.group = new graphic.Group();
	  this._symbolCtor = symbolCtor || SymbolClz;
	}
	
	var symbolDrawProto = SymbolDraw.prototype;
	
	function symbolNeedsDraw(data, point, idx, opt) {
	  return point && !isNaN(point[0]) && !isNaN(point[1]) && !(opt.isIgnore && opt.isIgnore(idx)) // We do not set clipShape on group, because it will cut part of
	  // the symbol element shape. We use the same clip shape here as
	  // the line clip.
	  && !(opt.clipShape && !opt.clipShape.contain(point[0], point[1])) && data.getItemVisual(idx, 'symbol') !== 'none';
	}
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} [opt] Or isIgnore
	 * @param {Function} [opt.isIgnore]
	 * @param {Object} [opt.clipShape]
	 */
	
	
	symbolDrawProto.updateData = function (data, opt) {
	  opt = normalizeUpdateOpt(opt);
	  var group = this.group;
	  var seriesModel = data.hostModel;
	  var oldData = this._data;
	  var SymbolCtor = this._symbolCtor;
	  var seriesScope = makeSeriesScope(data); // There is no oldLineData only when first rendering or switching from
	  // stream mode to normal mode, where previous elements should be removed.
	
	  if (!oldData) {
	    group.removeAll();
	  }
	
	  data.diff(oldData).add(function (newIdx) {
	    var point = data.getItemLayout(newIdx);
	
	    if (symbolNeedsDraw(data, point, newIdx, opt)) {
	      var symbolEl = new SymbolCtor(data, newIdx, seriesScope);
	      symbolEl.attr('position', point);
	      data.setItemGraphicEl(newIdx, symbolEl);
	      group.add(symbolEl);
	    }
	  }).update(function (newIdx, oldIdx) {
	    var symbolEl = oldData.getItemGraphicEl(oldIdx);
	    var point = data.getItemLayout(newIdx);
	
	    if (!symbolNeedsDraw(data, point, newIdx, opt)) {
	      group.remove(symbolEl);
	      return;
	    }
	
	    if (!symbolEl) {
	      symbolEl = new SymbolCtor(data, newIdx);
	      symbolEl.attr('position', point);
	    } else {
	      symbolEl.updateData(data, newIdx, seriesScope);
	      graphic.updateProps(symbolEl, {
	        position: point
	      }, seriesModel);
	    } // Add back
	
	
	    group.add(symbolEl);
	    data.setItemGraphicEl(newIdx, symbolEl);
	  }).remove(function (oldIdx) {
	    var el = oldData.getItemGraphicEl(oldIdx);
	    el && el.fadeOut(function () {
	      group.remove(el);
	    });
	  }).execute();
	  this._data = data;
	};
	
	symbolDrawProto.isPersistent = function () {
	  return true;
	};
	
	symbolDrawProto.updateLayout = function () {
	  var data = this._data;
	
	  if (data) {
	    // Not use animation
	    data.eachItemGraphicEl(function (el, idx) {
	      var point = data.getItemLayout(idx);
	      el.attr('position', point);
	    });
	  }
	};
	
	symbolDrawProto.incrementalPrepareUpdate = function (data) {
	  this._seriesScope = makeSeriesScope(data);
	  this._data = null;
	  this.group.removeAll();
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} [opt] Or isIgnore
	 * @param {Function} [opt.isIgnore]
	 * @param {Object} [opt.clipShape]
	 */
	
	
	symbolDrawProto.incrementalUpdate = function (taskParams, data, opt) {
	  opt = normalizeUpdateOpt(opt);
	
	  function updateIncrementalAndHover(el) {
	    if (!el.isGroup) {
	      el.incremental = el.useHoverLayer = true;
	    }
	  }
	
	  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	    var point = data.getItemLayout(idx);
	
	    if (symbolNeedsDraw(data, point, idx, opt)) {
	      var el = new this._symbolCtor(data, idx, this._seriesScope);
	      el.traverse(updateIncrementalAndHover);
	      el.attr('position', point);
	      this.group.add(el);
	      data.setItemGraphicEl(idx, el);
	    }
	  }
	};
	
	function normalizeUpdateOpt(opt) {
	  if (opt != null && !isObject(opt)) {
	    opt = {
	      isIgnore: opt
	    };
	  }
	
	  return opt || {};
	}
	
	symbolDrawProto.remove = function (enableAnimation) {
	  var group = this.group;
	  var data = this._data; // Incremental model do not have this._data.
	
	  if (data && enableAnimation) {
	    data.eachItemGraphicEl(function (el) {
	      el.fadeOut(function () {
	        group.remove(el);
	      });
	    });
	  } else {
	    group.removeAll();
	  }
	};
	
	function makeSeriesScope(data) {
	  var seriesModel = data.hostModel;
	  return {
	    itemStyle: seriesModel.getModel('itemStyle').getItemStyle(['color']),
	    hoverItemStyle: seriesModel.getModel('emphasis.itemStyle').getItemStyle(),
	    symbolRotate: seriesModel.get('symbolRotate'),
	    symbolOffset: seriesModel.get('symbolOffset'),
	    hoverAnimation: seriesModel.get('hoverAnimation'),
	    labelModel: seriesModel.getModel('label'),
	    hoverLabelModel: seriesModel.getModel('emphasis.label'),
	    cursorStyle: seriesModel.get('cursor')
	  };
	}
	
	var _default = SymbolDraw;
	module.exports = _default;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var _number = __webpack_require__(25);
	
	var round = _number.round;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function createGridClipPath(cartesian, hasAnimation, seriesModel) {
	  var rect = cartesian.getArea();
	  var isHorizontal = cartesian.getBaseAxis().isHorizontal();
	  var x = rect.x;
	  var y = rect.y;
	  var width = rect.width;
	  var height = rect.height;
	  var lineWidth = seriesModel.get('lineStyle.width') || 2; // Expand the clip path a bit to avoid the border is clipped and looks thinner
	
	  x -= lineWidth / 2;
	  y -= lineWidth / 2;
	  width += lineWidth;
	  height += lineWidth; // fix: https://github.com/apache/incubator-echarts/issues/11369
	
	  x = Math.floor(x);
	  width = Math.round(width);
	  var clipPath = new graphic.Rect({
	    shape: {
	      x: x,
	      y: y,
	      width: width,
	      height: height
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape[isHorizontal ? 'width' : 'height'] = 0;
	    graphic.initProps(clipPath, {
	      shape: {
	        width: width,
	        height: height
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createPolarClipPath(polar, hasAnimation, seriesModel) {
	  var sectorArea = polar.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
	
	  var clipPath = new graphic.Sector({
	    shape: {
	      cx: round(polar.cx, 1),
	      cy: round(polar.cy, 1),
	      r0: round(sectorArea.r0, 1),
	      r: round(sectorArea.r, 1),
	      startAngle: sectorArea.startAngle,
	      endAngle: sectorArea.endAngle,
	      clockwise: sectorArea.clockwise
	    }
	  });
	
	  if (hasAnimation) {
	    clipPath.shape.endAngle = sectorArea.startAngle;
	    graphic.initProps(clipPath, {
	      shape: {
	        endAngle: sectorArea.endAngle
	      }
	    }, seriesModel);
	  }
	
	  return clipPath;
	}
	
	function createClipPath(coordSys, hasAnimation, seriesModel) {
	  if (!coordSys) {
	    return null;
	  } else if (coordSys.type === 'polar') {
	    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
	  } else if (coordSys.type === 'cartesian2d') {
	    return createGridClipPath(coordSys, hasAnimation, seriesModel);
	  }
	
	  return null;
	}
	
	exports.createGridClipPath = createGridClipPath;
	exports.createPolarClipPath = createPolarClipPath;
	exports.createClipPath = createClipPath;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var axisPointerModelHelper = __webpack_require__(354);
	
	var axisTrigger = __webpack_require__(2324);
	
	__webpack_require__(2320);
	
	__webpack_require__(2321);
	
	__webpack_require__(835);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// CartesianAxisPointer is not supposed to be required here. But consider
	// echarts.simple.js and online build tooltip, which only require gridSimple,
	// CartesianAxisPointer should be able to required somewhere.
	echarts.registerPreprocessor(function (option) {
	  // Always has a global axisPointerModel for default setting.
	  if (option) {
	    (!option.axisPointer || option.axisPointer.length === 0) && (option.axisPointer = {});
	    var link = option.axisPointer.link; // Normalize to array to avoid object mergin. But if link
	    // is not set, remain null/undefined, otherwise it will
	    // override existent link setting.
	
	    if (link && !zrUtil.isArray(link)) {
	      option.axisPointer.link = [link];
	    }
	  }
	}); // This process should proformed after coordinate systems created
	// and series data processed. So put it on statistic processing stage.
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, function (ecModel, api) {
	  // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	  // allAxesInfo should be updated when setOption performed.
	  ecModel.getComponent('axisPointer').coordSysAxesInfo = axisPointerModelHelper.collect(ecModel, api);
	}); // Broadcast to all views.
	
	echarts.registerAction({
	  type: 'updateAxisPointer',
	  event: 'updateAxisPointer',
	  update: ':updateAxisPointer'
	}, axisTrigger);

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	__webpack_require__(512);
	
	__webpack_require__(2313);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Grid view
	echarts.extendComponentView({
	  type: 'grid',
	  render: function (gridModel, ecModel) {
	    this.group.removeAll();
	
	    if (gridModel.get('show')) {
	      this.group.add(new graphic.Rect({
	        shape: gridModel.coordinateSystem.getRect(),
	        style: zrUtil.defaults({
	          fill: gridModel.get('backgroundColor')
	        }, gridModel.getItemStyle()),
	        silent: true,
	        z2: -1
	      }));
	    }
	  }
	});
	echarts.registerPreprocessor(function (option) {
	  // Only create grid when need
	  if (option.xAxis && option.yAxis && !option.grid) {
	    option.grid = {};
	  }
	});

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Eventful = __webpack_require__(225);
	
	var eventTool = __webpack_require__(147);
	
	var interactionMutex = __webpack_require__(846);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @alias module:echarts/component/helper/RoamController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	function RoamController(zr) {
	  /**
	   * @type {Function}
	   */
	  this.pointerChecker;
	  /**
	   * @type {module:zrender}
	   */
	
	  this._zr = zr;
	  /**
	   * @type {Object}
	   */
	
	  this._opt = {}; // Avoid two roamController bind the same handler
	
	  var bind = zrUtil.bind;
	  var mousedownHandler = bind(mousedown, this);
	  var mousemoveHandler = bind(mousemove, this);
	  var mouseupHandler = bind(mouseup, this);
	  var mousewheelHandler = bind(mousewheel, this);
	  var pinchHandler = bind(pinch, this);
	  Eventful.call(this);
	  /**
	   * @param {Function} pointerChecker
	   *                   input: x, y
	   *                   output: boolean
	   */
	
	  this.setPointerChecker = function (pointerChecker) {
	    this.pointerChecker = pointerChecker;
	  };
	  /**
	   * Notice: only enable needed types. For example, if 'zoom'
	   * is not needed, 'zoom' should not be enabled, otherwise
	   * default mousewheel behaviour (scroll page) will be disabled.
	   *
	   * @param  {boolean|string} [controlType=true] Specify the control type,
	   *                          which can be null/undefined or true/false
	   *                          or 'pan/move' or 'zoom'/'scale'
	   * @param {Object} [opt]
	   * @param {Object} [opt.zoomOnMouseWheel=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.moveOnMouseMove=true] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.moveOnMouseWheel=false] The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	   * @param {Object} [opt.preventDefaultMouseMove=true] When pan.
	   */
	
	
	  this.enable = function (controlType, opt) {
	    // Disable previous first
	    this.disable();
	    this._opt = zrUtil.defaults(zrUtil.clone(opt) || {}, {
	      zoomOnMouseWheel: true,
	      moveOnMouseMove: true,
	      // By default, wheel do not trigger move.
	      moveOnMouseWheel: false,
	      preventDefaultMouseMove: true
	    });
	
	    if (controlType == null) {
	      controlType = true;
	    }
	
	    if (controlType === true || controlType === 'move' || controlType === 'pan') {
	      zr.on('mousedown', mousedownHandler);
	      zr.on('mousemove', mousemoveHandler);
	      zr.on('mouseup', mouseupHandler);
	    }
	
	    if (controlType === true || controlType === 'scale' || controlType === 'zoom') {
	      zr.on('mousewheel', mousewheelHandler);
	      zr.on('pinch', pinchHandler);
	    }
	  };
	
	  this.disable = function () {
	    zr.off('mousedown', mousedownHandler);
	    zr.off('mousemove', mousemoveHandler);
	    zr.off('mouseup', mouseupHandler);
	    zr.off('mousewheel', mousewheelHandler);
	    zr.off('pinch', pinchHandler);
	  };
	
	  this.dispose = this.disable;
	
	  this.isDragging = function () {
	    return this._dragging;
	  };
	
	  this.isPinching = function () {
	    return this._pinching;
	  };
	}
	
	zrUtil.mixin(RoamController, Eventful);
	
	function mousedown(e) {
	  if (eventTool.isMiddleOrRightButtonOnMouseUpDown(e) || e.target && e.target.draggable) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY; // Only check on mosedown, but not mousemove.
	  // Mouse can be out of target when mouse moving.
	
	  if (this.pointerChecker && this.pointerChecker(e, x, y)) {
	    this._x = x;
	    this._y = y;
	    this._dragging = true;
	  }
	}
	
	function mousemove(e) {
	  if (!this._dragging || !isAvailableBehavior('moveOnMouseMove', e, this._opt) || e.gestureEvent === 'pinch' || interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var x = e.offsetX;
	  var y = e.offsetY;
	  var oldX = this._x;
	  var oldY = this._y;
	  var dx = x - oldX;
	  var dy = y - oldY;
	  this._x = x;
	  this._y = y;
	  this._opt.preventDefaultMouseMove && eventTool.stop(e.event);
	  trigger(this, 'pan', 'moveOnMouseMove', e, {
	    dx: dx,
	    dy: dy,
	    oldX: oldX,
	    oldY: oldY,
	    newX: x,
	    newY: y
	  });
	}
	
	function mouseup(e) {
	  if (!eventTool.isMiddleOrRightButtonOnMouseUpDown(e)) {
	    this._dragging = false;
	  }
	}
	
	function mousewheel(e) {
	  var shouldZoom = isAvailableBehavior('zoomOnMouseWheel', e, this._opt);
	  var shouldMove = isAvailableBehavior('moveOnMouseWheel', e, this._opt);
	  var wheelDelta = e.wheelDelta;
	  var absWheelDeltaDelta = Math.abs(wheelDelta);
	  var originX = e.offsetX;
	  var originY = e.offsetY; // wheelDelta maybe -0 in chrome mac.
	
	  if (wheelDelta === 0 || !shouldZoom && !shouldMove) {
	    return;
	  } // If both `shouldZoom` and `shouldMove` is true, trigger
	  // their event both, and the final behavior is determined
	  // by event listener themselves.
	
	
	  if (shouldZoom) {
	    // Convenience:
	    // Mac and VM Windows on Mac: scroll up: zoom out.
	    // Windows: scroll up: zoom in.
	    // FIXME: Should do more test in different environment.
	    // wheelDelta is too complicated in difference nvironment
	    // (https://developer.mozilla.org/en-US/docs/Web/Events/mousewheel),
	    // although it has been normallized by zrender.
	    // wheelDelta of mouse wheel is bigger than touch pad.
	    var factor = absWheelDeltaDelta > 3 ? 1.4 : absWheelDeltaDelta > 1 ? 1.2 : 1.1;
	    var scale = wheelDelta > 0 ? factor : 1 / factor;
	    checkPointerAndTrigger(this, 'zoom', 'zoomOnMouseWheel', e, {
	      scale: scale,
	      originX: originX,
	      originY: originY
	    });
	  }
	
	  if (shouldMove) {
	    // FIXME: Should do more test in different environment.
	    var absDelta = Math.abs(wheelDelta); // wheelDelta of mouse wheel is bigger than touch pad.
	
	    var scrollDelta = (wheelDelta > 0 ? 1 : -1) * (absDelta > 3 ? 0.4 : absDelta > 1 ? 0.15 : 0.05);
	    checkPointerAndTrigger(this, 'scrollMove', 'moveOnMouseWheel', e, {
	      scrollDelta: scrollDelta,
	      originX: originX,
	      originY: originY
	    });
	  }
	}
	
	function pinch(e) {
	  if (interactionMutex.isTaken(this._zr, 'globalPan')) {
	    return;
	  }
	
	  var scale = e.pinchScale > 1 ? 1.1 : 1 / 1.1;
	  checkPointerAndTrigger(this, 'zoom', null, e, {
	    scale: scale,
	    originX: e.pinchX,
	    originY: e.pinchY
	  });
	}
	
	function checkPointerAndTrigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	  if (controller.pointerChecker && controller.pointerChecker(e, contollerEvent.originX, contollerEvent.originY)) {
	    // When mouse is out of roamController rect,
	    // default befavoius should not be be disabled, otherwise
	    // page sliding is disabled, contrary to expectation.
	    eventTool.stop(e.event);
	    trigger(controller, eventName, behaviorToCheck, e, contollerEvent);
	  }
	}
	
	function trigger(controller, eventName, behaviorToCheck, e, contollerEvent) {
	  // Also provide behavior checker for event listener, for some case that
	  // multiple components share one listener.
	  contollerEvent.isAvailableBehavior = zrUtil.bind(isAvailableBehavior, null, behaviorToCheck, e);
	  controller.trigger(eventName, contollerEvent);
	} // settings: {
	//     zoomOnMouseWheel
	//     moveOnMouseMove
	//     moveOnMouseWheel
	// }
	// The value can be: true / false / 'shift' / 'ctrl' / 'alt'.
	
	
	function isAvailableBehavior(behaviorToCheck, e, settings) {
	  var setting = settings[behaviorToCheck];
	  return !behaviorToCheck || setting && (!zrUtil.isString(setting) || e.event[setting + 'Key']);
	}
	
	var _default = RoamController;
	module.exports = _default;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var createHashMap = _util.createHashMap;
	var isTypedArray = _util.isTypedArray;
	
	var _clazz = __webpack_require__(161);
	
	var enableClassCheck = _clazz.enableClassCheck;
	
	var _sourceType = __webpack_require__(294);
	
	var SOURCE_FORMAT_ORIGINAL = _sourceType.SOURCE_FORMAT_ORIGINAL;
	var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
	var SOURCE_FORMAT_UNKNOWN = _sourceType.SOURCE_FORMAT_UNKNOWN;
	var SOURCE_FORMAT_TYPED_ARRAY = _sourceType.SOURCE_FORMAT_TYPED_ARRAY;
	var SOURCE_FORMAT_KEYED_COLUMNS = _sourceType.SOURCE_FORMAT_KEYED_COLUMNS;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [sourceFormat]
	 *
	 * + "original":
	 * This format is only used in series.data, where
	 * itemStyle can be specified in data item.
	 *
	 * + "arrayRows":
	 * [
	 *     ['product', 'score', 'amount'],
	 *     ['Matcha Latte', 89.3, 95.8],
	 *     ['Milk Tea', 92.1, 89.4],
	 *     ['Cheese Cocoa', 94.4, 91.2],
	 *     ['Walnut Brownie', 85.4, 76.9]
	 * ]
	 *
	 * + "objectRows":
	 * [
	 *     {product: 'Matcha Latte', score: 89.3, amount: 95.8},
	 *     {product: 'Milk Tea', score: 92.1, amount: 89.4},
	 *     {product: 'Cheese Cocoa', score: 94.4, amount: 91.2},
	 *     {product: 'Walnut Brownie', score: 85.4, amount: 76.9}
	 * ]
	 *
	 * + "keyedColumns":
	 * {
	 *     'product': ['Matcha Latte', 'Milk Tea', 'Cheese Cocoa', 'Walnut Brownie'],
	 *     'count': [823, 235, 1042, 988],
	 *     'score': [95.8, 81.4, 91.2, 76.9]
	 * }
	 *
	 * + "typedArray"
	 *
	 * + "unknown"
	 */
	
	/**
	 * @constructor
	 * @param {Object} fields
	 * @param {string} fields.sourceFormat
	 * @param {Array|Object} fields.fromDataset
	 * @param {Array|Object} [fields.data]
	 * @param {string} [seriesLayoutBy='column']
	 * @param {Array.<Object|string>} [dimensionsDefine]
	 * @param {Objet|HashMap} [encodeDefine]
	 * @param {number} [startIndex=0]
	 * @param {number} [dimensionsDetectCount]
	 */
	function Source(fields) {
	  /**
	   * @type {boolean}
	   */
	  this.fromDataset = fields.fromDataset;
	  /**
	   * Not null/undefined.
	   * @type {Array|Object}
	   */
	
	  this.data = fields.data || (fields.sourceFormat === SOURCE_FORMAT_KEYED_COLUMNS ? {} : []);
	  /**
	   * See also "detectSourceFormat".
	   * Not null/undefined.
	   * @type {string}
	   */
	
	  this.sourceFormat = fields.sourceFormat || SOURCE_FORMAT_UNKNOWN;
	  /**
	   * 'row' or 'column'
	   * Not null/undefined.
	   * @type {string} seriesLayoutBy
	   */
	
	  this.seriesLayoutBy = fields.seriesLayoutBy || SERIES_LAYOUT_BY_COLUMN;
	  /**
	   * dimensions definition in option.
	   * can be null/undefined.
	   * @type {Array.<Object|string>}
	   */
	
	  this.dimensionsDefine = fields.dimensionsDefine;
	  /**
	   * encode definition in option.
	   * can be null/undefined.
	   * @type {Objet|HashMap}
	   */
	
	  this.encodeDefine = fields.encodeDefine && createHashMap(fields.encodeDefine);
	  /**
	   * Not null/undefined, uint.
	   * @type {number}
	   */
	
	  this.startIndex = fields.startIndex || 0;
	  /**
	   * Can be null/undefined (when unknown), uint.
	   * @type {number}
	   */
	
	  this.dimensionsDetectCount = fields.dimensionsDetectCount;
	}
	/**
	 * Wrap original series data for some compatibility cases.
	 */
	
	
	Source.seriesDataToSource = function (data) {
	  return new Source({
	    data: data,
	    sourceFormat: isTypedArray(data) ? SOURCE_FORMAT_TYPED_ARRAY : SOURCE_FORMAT_ORIGINAL,
	    fromDataset: false
	  });
	};
	
	enableClassCheck(Source);
	var _default = Source;
	module.exports = _default;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	var assert = _util.assert;
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var OTHER_DIMENSIONS = createHashMap(['tooltip', 'label', 'itemName', 'itemId', 'seriesName']);
	
	function summarizeDimensions(data) {
	  var summary = {};
	  var encode = summary.encode = {};
	  var notExtraCoordDimMap = createHashMap();
	  var defaultedLabel = [];
	  var defaultedTooltip = []; // See the comment of `List.js#userOutput`.
	
	  var userOutput = summary.userOutput = {
	    dimensionNames: data.dimensions.slice(),
	    encode: {}
	  };
	  each(data.dimensions, function (dimName) {
	    var dimItem = data.getDimensionInfo(dimName);
	    var coordDim = dimItem.coordDim;
	
	    if (coordDim) {
	      var coordDimIndex = dimItem.coordDimIndex;
	      getOrCreateEncodeArr(encode, coordDim)[coordDimIndex] = dimName;
	
	      if (!dimItem.isExtraCoord) {
	        notExtraCoordDimMap.set(coordDim, 1); // Use the last coord dim (and label friendly) as default label,
	        // because when dataset is used, it is hard to guess which dimension
	        // can be value dimension. If both show x, y on label is not look good,
	        // and conventionally y axis is focused more.
	
	        if (mayLabelDimType(dimItem.type)) {
	          defaultedLabel[0] = dimName;
	        } // User output encode do not contain generated coords.
	        // And it only has index. User can use index to retrieve value from the raw item array.
	
	
	        getOrCreateEncodeArr(userOutput.encode, coordDim)[coordDimIndex] = dimItem.index;
	      }
	
	      if (dimItem.defaultTooltip) {
	        defaultedTooltip.push(dimName);
	      }
	    }
	
	    OTHER_DIMENSIONS.each(function (v, otherDim) {
	      var encodeArr = getOrCreateEncodeArr(encode, otherDim);
	      var dimIndex = dimItem.otherDims[otherDim];
	
	      if (dimIndex != null && dimIndex !== false) {
	        encodeArr[dimIndex] = dimItem.name;
	      }
	    });
	  });
	  var dataDimsOnCoord = [];
	  var encodeFirstDimNotExtra = {};
	  notExtraCoordDimMap.each(function (v, coordDim) {
	    var dimArr = encode[coordDim]; // ??? FIXME extra coord should not be set in dataDimsOnCoord.
	    // But should fix the case that radar axes: simplify the logic
	    // of `completeDimension`, remove `extraPrefix`.
	
	    encodeFirstDimNotExtra[coordDim] = dimArr[0]; // Not necessary to remove duplicate, because a data
	    // dim canot on more than one coordDim.
	
	    dataDimsOnCoord = dataDimsOnCoord.concat(dimArr);
	  });
	  summary.dataDimsOnCoord = dataDimsOnCoord;
	  summary.encodeFirstDimNotExtra = encodeFirstDimNotExtra;
	  var encodeLabel = encode.label; // FIXME `encode.label` is not recommanded, because formatter can not be set
	  // in this way. Use label.formatter instead. May be remove this approach someday.
	
	  if (encodeLabel && encodeLabel.length) {
	    defaultedLabel = encodeLabel.slice();
	  }
	
	  var encodeTooltip = encode.tooltip;
	
	  if (encodeTooltip && encodeTooltip.length) {
	    defaultedTooltip = encodeTooltip.slice();
	  } else if (!defaultedTooltip.length) {
	    defaultedTooltip = defaultedLabel.slice();
	  }
	
	  encode.defaultedLabel = defaultedLabel;
	  encode.defaultedTooltip = defaultedTooltip;
	  return summary;
	}
	
	function getOrCreateEncodeArr(encode, dim) {
	  if (!encode.hasOwnProperty(dim)) {
	    encode[dim] = [];
	  }
	
	  return encode[dim];
	}
	
	function getDimensionTypeByAxis(axisType) {
	  return axisType === 'category' ? 'ordinal' : axisType === 'time' ? 'time' : 'float';
	}
	
	function mayLabelDimType(dimType) {
	  // In most cases, ordinal and time do not suitable for label.
	  // Ordinal info can be displayed on axis. Time is too long.
	  return !(dimType === 'ordinal' || dimType === 'time');
	} // function findTheLastDimMayLabel(data) {
	//     // Get last value dim
	//     var dimensions = data.dimensions.slice();
	//     var valueType;
	//     var valueDim;
	//     while (dimensions.length && (
	//         valueDim = dimensions.pop(),
	//         valueType = data.getDimensionInfo(valueDim).type,
	//         valueType === 'ordinal' || valueType === 'time'
	//     )) {} // jshint ignore:line
	//     return valueDim;
	// }
	
	
	exports.OTHER_DIMENSIONS = OTHER_DIMENSIONS;
	exports.summarizeDimensions = summarizeDimensions;
	exports.getDimensionTypeByAxis = getDimensionTypeByAxis;

/***/ },
/* 294 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Avoid typo.
	var SOURCE_FORMAT_ORIGINAL = 'original';
	var SOURCE_FORMAT_ARRAY_ROWS = 'arrayRows';
	var SOURCE_FORMAT_OBJECT_ROWS = 'objectRows';
	var SOURCE_FORMAT_KEYED_COLUMNS = 'keyedColumns';
	var SOURCE_FORMAT_UNKNOWN = 'unknown'; // ??? CHANGE A NAME
	
	var SOURCE_FORMAT_TYPED_ARRAY = 'typedArray';
	var SERIES_LAYOUT_BY_COLUMN = 'column';
	var SERIES_LAYOUT_BY_ROW = 'row';
	exports.SOURCE_FORMAT_ORIGINAL = SOURCE_FORMAT_ORIGINAL;
	exports.SOURCE_FORMAT_ARRAY_ROWS = SOURCE_FORMAT_ARRAY_ROWS;
	exports.SOURCE_FORMAT_OBJECT_ROWS = SOURCE_FORMAT_OBJECT_ROWS;
	exports.SOURCE_FORMAT_KEYED_COLUMNS = SOURCE_FORMAT_KEYED_COLUMNS;
	exports.SOURCE_FORMAT_UNKNOWN = SOURCE_FORMAT_UNKNOWN;
	exports.SOURCE_FORMAT_TYPED_ARRAY = SOURCE_FORMAT_TYPED_ARRAY;
	exports.SERIES_LAYOUT_BY_COLUMN = SERIES_LAYOUT_BY_COLUMN;
	exports.SERIES_LAYOUT_BY_ROW = SERIES_LAYOUT_BY_ROW;

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var map = _util.map;
	
	var createRenderPlanner = __webpack_require__(246);
	
	var _dataStackHelper = __webpack_require__(140);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    plan: createRenderPlanner(),
	    reset: function (seriesModel) {
	      var data = seriesModel.getData();
	      var coordSys = seriesModel.coordinateSystem;
	      var pipelineContext = seriesModel.pipelineContext;
	      var isLargeRender = pipelineContext.large;
	
	      if (!coordSys) {
	        return;
	      }
	
	      var dims = map(coordSys.dimensions, function (dim) {
	        return data.mapDimension(dim);
	      }).slice(0, 2);
	      var dimLen = dims.length;
	      var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	      if (isDimensionStacked(data, dims[0]
	      /*, dims[1]*/
	      )) {
	        dims[0] = stackResultDim;
	      }
	
	      if (isDimensionStacked(data, dims[1]
	      /*, dims[0]*/
	      )) {
	        dims[1] = stackResultDim;
	      }
	
	      function progress(params, data) {
	        var segCount = params.end - params.start;
	        var points = isLargeRender && new Float32Array(segCount * dimLen);
	
	        for (var i = params.start, offset = 0, tmpIn = [], tmpOut = []; i < params.end; i++) {
	          var point;
	
	          if (dimLen === 1) {
	            var x = data.get(dims[0], i);
	            point = !isNaN(x) && coordSys.dataToPoint(x, null, tmpOut);
	          } else {
	            var x = tmpIn[0] = data.get(dims[0], i);
	            var y = tmpIn[1] = data.get(dims[1], i); // Also {Array.<number>}, not undefined to avoid if...else... statement
	
	            point = !isNaN(x) && !isNaN(y) && coordSys.dataToPoint(tmpIn, null, tmpOut);
	          }
	
	          if (isLargeRender) {
	            points[offset++] = point ? point[0] : NaN;
	            points[offset++] = point ? point[1] : NaN;
	          } else {
	            data.setItemLayout(i, point && point.slice() || [NaN, NaN]);
	          }
	        }
	
	        isLargeRender && data.setLayout('symbolPoints', points);
	      }
	
	      return dimLen && {
	        progress: progress
	      };
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 296 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    reset: function (seriesModel, ecModel) {
	      var legendModels = ecModel.findComponents({
	        mainType: 'legend'
	      });
	
	      if (!legendModels || !legendModels.length) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      data.filterSelf(function (idx) {
	        var name = data.getName(idx); // If in any legend component the status is not selected.
	
	        for (var i = 0; i < legendModels.length; i++) {
	          if (!legendModels[i].isSelected(name)) {
	            return false;
	          }
	        }
	
	        return true;
	      });
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var _clazz = __webpack_require__(161);
	
	var parseClassType = _clazz.parseClassType;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var base = 0;
	/**
	 * @public
	 * @param {string} type
	 * @return {string}
	 */
	
	function getUID(type) {
	  // Considering the case of crossing js context,
	  // use Math.random to make id as unique as possible.
	  return [type || '', base++, Math.random().toFixed(5)].join('_');
	}
	/**
	 * @inner
	 */
	
	
	function enableSubTypeDefaulter(entity) {
	  var subTypeDefaulters = {};
	
	  entity.registerSubTypeDefaulter = function (componentType, defaulter) {
	    componentType = parseClassType(componentType);
	    subTypeDefaulters[componentType.main] = defaulter;
	  };
	
	  entity.determineSubType = function (componentType, option) {
	    var type = option.type;
	
	    if (!type) {
	      var componentTypeMain = parseClassType(componentType).main;
	
	      if (entity.hasSubTypes(componentType) && subTypeDefaulters[componentTypeMain]) {
	        type = subTypeDefaulters[componentTypeMain](option);
	      }
	    }
	
	    return type;
	  };
	
	  return entity;
	}
	/**
	 * Topological travel on Activity Network (Activity On Vertices).
	 * Dependencies is defined in Model.prototype.dependencies, like ['xAxis', 'yAxis'].
	 *
	 * If 'xAxis' or 'yAxis' is absent in componentTypeList, just ignore it in topology.
	 *
	 * If there is circle dependencey, Error will be thrown.
	 *
	 */
	
	
	function enableTopologicalTravel(entity, dependencyGetter) {
	  /**
	   * @public
	   * @param {Array.<string>} targetNameList Target Component type list.
	   *                                           Can be ['aa', 'bb', 'aa.xx']
	   * @param {Array.<string>} fullNameList By which we can build dependency graph.
	   * @param {Function} callback Params: componentType, dependencies.
	   * @param {Object} context Scope of callback.
	   */
	  entity.topologicalTravel = function (targetNameList, fullNameList, callback, context) {
	    if (!targetNameList.length) {
	      return;
	    }
	
	    var result = makeDepndencyGraph(fullNameList);
	    var graph = result.graph;
	    var stack = result.noEntryList;
	    var targetNameSet = {};
	    zrUtil.each(targetNameList, function (name) {
	      targetNameSet[name] = true;
	    });
	
	    while (stack.length) {
	      var currComponentType = stack.pop();
	      var currVertex = graph[currComponentType];
	      var isInTargetNameSet = !!targetNameSet[currComponentType];
	
	      if (isInTargetNameSet) {
	        callback.call(context, currComponentType, currVertex.originalDeps.slice());
	        delete targetNameSet[currComponentType];
	      }
	
	      zrUtil.each(currVertex.successor, isInTargetNameSet ? removeEdgeAndAdd : removeEdge);
	    }
	
	    zrUtil.each(targetNameSet, function () {
	      throw new Error('Circle dependency may exists');
	    });
	
	    function removeEdge(succComponentType) {
	      graph[succComponentType].entryCount--;
	
	      if (graph[succComponentType].entryCount === 0) {
	        stack.push(succComponentType);
	      }
	    } // Consider this case: legend depends on series, and we call
	    // chart.setOption({series: [...]}), where only series is in option.
	    // If we do not have 'removeEdgeAndAdd', legendModel.mergeOption will
	    // not be called, but only sereis.mergeOption is called. Thus legend
	    // have no chance to update its local record about series (like which
	    // name of series is available in legend).
	
	
	    function removeEdgeAndAdd(succComponentType) {
	      targetNameSet[succComponentType] = true;
	      removeEdge(succComponentType);
	    }
	  };
	  /**
	   * DepndencyGraph: {Object}
	   * key: conponentType,
	   * value: {
	   *     successor: [conponentTypes...],
	   *     originalDeps: [conponentTypes...],
	   *     entryCount: {number}
	   * }
	   */
	
	
	  function makeDepndencyGraph(fullNameList) {
	    var graph = {};
	    var noEntryList = [];
	    zrUtil.each(fullNameList, function (name) {
	      var thisItem = createDependencyGraphItem(graph, name);
	      var originalDeps = thisItem.originalDeps = dependencyGetter(name);
	      var availableDeps = getAvailableDependencies(originalDeps, fullNameList);
	      thisItem.entryCount = availableDeps.length;
	
	      if (thisItem.entryCount === 0) {
	        noEntryList.push(name);
	      }
	
	      zrUtil.each(availableDeps, function (dependentName) {
	        if (zrUtil.indexOf(thisItem.predecessor, dependentName) < 0) {
	          thisItem.predecessor.push(dependentName);
	        }
	
	        var thatItem = createDependencyGraphItem(graph, dependentName);
	
	        if (zrUtil.indexOf(thatItem.successor, dependentName) < 0) {
	          thatItem.successor.push(name);
	        }
	      });
	    });
	    return {
	      graph: graph,
	      noEntryList: noEntryList
	    };
	  }
	
	  function createDependencyGraphItem(graph, name) {
	    if (!graph[name]) {
	      graph[name] = {
	        predecessor: [],
	        successor: []
	      };
	    }
	
	    return graph[name];
	  }
	
	  function getAvailableDependencies(originalDeps, fullNameList) {
	    var availableDeps = [];
	    zrUtil.each(originalDeps, function (dep) {
	      zrUtil.indexOf(fullNameList, dep) >= 0 && availableDeps.push(dep);
	    });
	    return availableDeps;
	  }
	}
	
	exports.getUID = getUID;
	exports.enableSubTypeDefaulter = enableSubTypeDefaulter;
	exports.enableTopologicalTravel = enableTopologicalTravel;

/***/ },
/* 298 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * LegendVisualProvider is an bridge that pick encoded color from data and
	 * provide to the legend component.
	 * @param {Function} getDataWithEncodedVisual Function to get data after filtered. It stores all the encoding info
	 * @param {Function} getRawData Function to get raw data before filtered.
	 */
	function LegendVisualProvider(getDataWithEncodedVisual, getRawData) {
	  this.getAllNames = function () {
	    var rawData = getRawData(); // We find the name from the raw data. In case it's filtered by the legend component.
	    // Normally, the name can be found in rawData, but can't be found in filtered data will display as gray.
	
	    return rawData.mapArray(rawData.getName);
	  };
	
	  this.containName = function (name) {
	    var rawData = getRawData();
	    return rawData.indexOfName(name) >= 0;
	  };
	
	  this.indexOfName = function (name) {
	    // Only get data when necessary.
	    // Because LegendVisualProvider constructor may be new in the stage that data is not prepared yet.
	    // Invoking Series#getData immediately will throw an error.
	    var dataWithEncodedVisual = getDataWithEncodedVisual();
	    return dataWithEncodedVisual.indexOfName(name);
	  };
	
	  this.getItemVisual = function (dataIndex, key) {
	    // Get encoded visual properties from final filtered data.
	    var dataWithEncodedVisual = getDataWithEncodedVisual();
	    return dataWithEncodedVisual.getItemVisual(dataIndex, key);
	  };
	}
	
	var _default = LegendVisualProvider;
	module.exports = _default;

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(380);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(126),
	    now = __webpack_require__(2598),
	    toNumber = __webpack_require__(929);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        timeWaiting = wait - timeSinceLastCall;
	
	    return maxing
	      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
	      : timeWaiting;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        clearTimeout(timerId);
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	module.exports = debounce;


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(546),
	    isLength = __webpack_require__(547);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warnOnlyTreeNode = warnOnlyTreeNode;
	exports.arrDel = arrDel;
	exports.arrAdd = arrAdd;
	exports.posToArr = posToArr;
	exports.getPosition = getPosition;
	exports.isTreeNode = isTreeNode;
	exports.getNodeChildren = getNodeChildren;
	exports.isCheckDisabled = isCheckDisabled;
	exports.traverseTreeNodes = traverseTreeNodes;
	exports.mapChildren = mapChildren;
	exports.getDragNodesKeys = getDragNodesKeys;
	exports.calcDropPosition = calcDropPosition;
	exports.calcSelectedKeys = calcSelectedKeys;
	exports.convertDataToTree = convertDataToTree;
	exports.convertTreeToEntities = convertTreeToEntities;
	exports.parseCheckedKeys = parseCheckedKeys;
	exports.conductCheck = conductCheck;
	exports.conductExpandParent = conductExpandParent;
	exports.getDataAndAria = getDataAndAria;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _toArray = _interopRequireDefault(__webpack_require__(112));
	
	var _warning = _interopRequireDefault(__webpack_require__(94));
	
	var _TreeNode = _interopRequireDefault(__webpack_require__(1117));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	var DRAG_SIDE_RANGE = 0.25;
	var DRAG_MIN_GAP = 2;
	var onlyTreeNodeWarned = false;
	
	function warnOnlyTreeNode() {
	  if (onlyTreeNodeWarned) return;
	  onlyTreeNodeWarned = true;
	  (0, _warning.default)(false, 'Tree only accept TreeNode as children.');
	}
	
	function arrDel(list, value) {
	  var clone = list.slice();
	  var index = clone.indexOf(value);
	
	  if (index >= 0) {
	    clone.splice(index, 1);
	  }
	
	  return clone;
	}
	
	function arrAdd(list, value) {
	  var clone = list.slice();
	
	  if (clone.indexOf(value) === -1) {
	    clone.push(value);
	  }
	
	  return clone;
	}
	
	function posToArr(pos) {
	  return pos.split('-');
	}
	
	function getPosition(level, index) {
	  return "".concat(level, "-").concat(index);
	}
	
	function isTreeNode(node) {
	  return node && node.type && node.type.isTreeNode;
	}
	
	function getNodeChildren(children) {
	  return (0, _toArray.default)(children).filter(isTreeNode);
	}
	
	function isCheckDisabled(node) {
	  var _ref = node.props || {},
	      disabled = _ref.disabled,
	      disableCheckbox = _ref.disableCheckbox,
	      checkable = _ref.checkable;
	
	  return !!(disabled || disableCheckbox) || checkable === false;
	}
	
	function traverseTreeNodes(treeNodes, callback) {
	  function processNode(node, index, parent) {
	    var children = node ? node.props.children : treeNodes;
	    var pos = node ? getPosition(parent.pos, index) : 0; // Filter children
	
	    var childList = getNodeChildren(children); // Process node if is not root
	
	    if (node) {
	      var data = {
	        node: node,
	        index: index,
	        pos: pos,
	        key: node.key || pos,
	        parentPos: parent.node ? parent.pos : null
	      };
	      callback(data);
	    } // Process children node
	
	
	    _react.Children.forEach(childList, function (subNode, subIndex) {
	      processNode(subNode, subIndex, {
	        node: node,
	        pos: pos
	      });
	    });
	  }
	
	  processNode(null);
	}
	/**
	 * Use `rc-util` `toArray` to get the children list which keeps the key.
	 * And return single node if children is only one(This can avoid `key` missing check).
	 */
	
	
	function mapChildren(children, func) {
	  var list = (0, _toArray.default)(children).map(func);
	
	  if (list.length === 1) {
	    return list[0];
	  }
	
	  return list;
	}
	
	function getDragNodesKeys(treeNodes, node) {
	  var _node$props = node.props,
	      eventKey = _node$props.eventKey,
	      pos = _node$props.pos;
	  var dragNodesKeys = [];
	  traverseTreeNodes(treeNodes, function (_ref2) {
	    var key = _ref2.key;
	    dragNodesKeys.push(key);
	  });
	  dragNodesKeys.push(eventKey || pos);
	  return dragNodesKeys;
	} // Only used when drag, not affect SSR.
	
	
	function calcDropPosition(event, treeNode) {
	  var clientY = event.clientY;
	
	  var _treeNode$selectHandl = treeNode.selectHandle.getBoundingClientRect(),
	      top = _treeNode$selectHandl.top,
	      bottom = _treeNode$selectHandl.bottom,
	      height = _treeNode$selectHandl.height;
	
	  var des = Math.max(height * DRAG_SIDE_RANGE, DRAG_MIN_GAP);
	
	  if (clientY <= top + des) {
	    return -1;
	  }
	
	  if (clientY >= bottom - des) {
	    return 1;
	  }
	
	  return 0;
	}
	/**
	 * Return selectedKeys according with multiple prop
	 * @param selectedKeys
	 * @param props
	 * @returns [string]
	 */
	
	
	function calcSelectedKeys(selectedKeys, props) {
	  if (!selectedKeys) return undefined;
	  var multiple = props.multiple;
	
	  if (multiple) {
	    return selectedKeys.slice();
	  }
	
	  if (selectedKeys.length) {
	    return [selectedKeys[0]];
	  }
	
	  return selectedKeys;
	}
	/**
	 * Since React internal will convert key to string,
	 * we need do this to avoid `checkStrictly` use number match
	 */
	
	
	function keyListToString(keyList) {
	  if (!keyList) return keyList;
	  return keyList.map(function (key) {
	    return String(key);
	  });
	}
	
	var internalProcessProps = function internalProcessProps(props) {
	  return props;
	};
	
	function convertDataToTree(treeData, processor) {
	  if (!treeData) return [];
	
	  var _ref3 = processor || {},
	      _ref3$processProps = _ref3.processProps,
	      processProps = _ref3$processProps === void 0 ? internalProcessProps : _ref3$processProps;
	
	  var list = Array.isArray(treeData) ? treeData : [treeData];
	  return list.map(function (_ref4) {
	    var children = _ref4.children,
	        props = _objectWithoutProperties(_ref4, ["children"]);
	
	    var childrenNodes = convertDataToTree(children, processor);
	    return _react.default.createElement(_TreeNode.default, Object.assign({}, processProps(props)), childrenNodes);
	  });
	}
	/**
	 * Calculate treeNodes entities. `processTreeEntity` is used for `rc-tree-select`
	 * @param treeNodes
	 * @param processTreeEntity  User can customize the entity
	 */
	
	
	function convertTreeToEntities(treeNodes) {
	  var _ref5 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      initWrapper = _ref5.initWrapper,
	      processEntity = _ref5.processEntity,
	      onProcessFinished = _ref5.onProcessFinished;
	
	  var posEntities = {};
	  var keyEntities = {};
	  var wrapper = {
	    posEntities: posEntities,
	    keyEntities: keyEntities
	  };
	
	  if (initWrapper) {
	    wrapper = initWrapper(wrapper) || wrapper;
	  }
	
	  traverseTreeNodes(treeNodes, function (item) {
	    var node = item.node,
	        index = item.index,
	        pos = item.pos,
	        key = item.key,
	        parentPos = item.parentPos;
	    var entity = {
	      node: node,
	      index: index,
	      key: key,
	      pos: pos
	    };
	    posEntities[pos] = entity;
	    keyEntities[key] = entity; // Fill children
	
	    entity.parent = posEntities[parentPos];
	
	    if (entity.parent) {
	      entity.parent.children = entity.parent.children || [];
	      entity.parent.children.push(entity);
	    }
	
	    if (processEntity) {
	      processEntity(entity, wrapper);
	    }
	  });
	
	  if (onProcessFinished) {
	    onProcessFinished(wrapper);
	  }
	
	  return wrapper;
	}
	/**
	 * Parse `checkedKeys` to { checkedKeys, halfCheckedKeys } style
	 */
	
	
	function parseCheckedKeys(keys) {
	  if (!keys) {
	    return null;
	  } // Convert keys to object format
	
	
	  var keyProps;
	
	  if (Array.isArray(keys)) {
	    // [Legacy] Follow the api doc
	    keyProps = {
	      checkedKeys: keys,
	      halfCheckedKeys: undefined
	    };
	  } else if (_typeof(keys) === 'object') {
	    keyProps = {
	      checkedKeys: keys.checked || undefined,
	      halfCheckedKeys: keys.halfChecked || undefined
	    };
	  } else {
	    (0, _warning.default)(false, '`checkedKeys` is not an array or an object');
	    return null;
	  }
	
	  keyProps.checkedKeys = keyListToString(keyProps.checkedKeys);
	  keyProps.halfCheckedKeys = keyListToString(keyProps.halfCheckedKeys);
	  return keyProps;
	}
	/**
	 * Conduct check state by the keyList. It will conduct up & from the provided key.
	 * If the conduct path reach the disabled or already checked / unchecked node will stop conduct.
	 */
	
	
	function conductCheck(
	/** list of keys */
	keyList,
	/** is check the node or not */
	isCheck,
	/** parsed by `convertTreeToEntities` function in Tree */
	keyEntities) {
	  var checkStatus = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var checkedKeys = {};
	  var halfCheckedKeys = {}; // Record the key has some child checked (include child half checked)
	
	  (checkStatus.checkedKeys || []).forEach(function (key) {
	    checkedKeys[key] = true;
	  });
	  (checkStatus.halfCheckedKeys || []).forEach(function (key) {
	    halfCheckedKeys[key] = true;
	  }); // Conduct up
	
	  function conductUp(key) {
	    if (checkedKeys[key] === isCheck) return;
	    var entity = keyEntities[key];
	    if (!entity) return;
	    var children = entity.children,
	        parent = entity.parent,
	        node = entity.node;
	    if (isCheckDisabled(node)) return; // Check child node checked status
	
	    var everyChildChecked = true;
	    var someChildChecked = false; // Child checked or half checked
	
	    (children || []).filter(function (child) {
	      return !isCheckDisabled(child.node);
	    }).forEach(function (_ref6) {
	      var childKey = _ref6.key;
	      var childChecked = checkedKeys[childKey];
	      var childHalfChecked = halfCheckedKeys[childKey];
	      if (childChecked || childHalfChecked) someChildChecked = true;
	      if (!childChecked) everyChildChecked = false;
	    }); // Update checked status
	
	    if (isCheck) {
	      checkedKeys[key] = everyChildChecked;
	    } else {
	      checkedKeys[key] = false;
	    }
	
	    halfCheckedKeys[key] = someChildChecked;
	
	    if (parent) {
	      conductUp(parent.key);
	    }
	  } // Conduct down
	
	
	  function conductDown(key) {
	    if (checkedKeys[key] === isCheck) return;
	    var entity = keyEntities[key];
	    if (!entity) return;
	    var children = entity.children,
	        node = entity.node;
	    if (isCheckDisabled(node)) return;
	    checkedKeys[key] = isCheck;
	    (children || []).forEach(function (child) {
	      conductDown(child.key);
	    });
	  }
	
	  function conduct(key) {
	    var entity = keyEntities[key];
	
	    if (!entity) {
	      (0, _warning.default)(false, "'".concat(key, "' does not exist in the tree."));
	      return;
	    }
	
	    var children = entity.children,
	        parent = entity.parent,
	        node = entity.node;
	    checkedKeys[key] = isCheck;
	    if (isCheckDisabled(node)) return; // Conduct down
	
	    (children || []).filter(function (child) {
	      return !isCheckDisabled(child.node);
	    }).forEach(function (child) {
	      conductDown(child.key);
	    }); // Conduct up
	
	    if (parent) {
	      conductUp(parent.key);
	    }
	  }
	
	  (keyList || []).forEach(function (key) {
	    conduct(key);
	  });
	  var checkedKeyList = [];
	  var halfCheckedKeyList = []; // Fill checked list
	
	  Object.keys(checkedKeys).forEach(function (key) {
	    if (checkedKeys[key]) {
	      checkedKeyList.push(key);
	    }
	  }); // Fill half checked list
	
	  Object.keys(halfCheckedKeys).forEach(function (key) {
	    if (!checkedKeys[key] && halfCheckedKeys[key]) {
	      halfCheckedKeyList.push(key);
	    }
	  });
	  return {
	    checkedKeys: checkedKeyList,
	    halfCheckedKeys: halfCheckedKeyList
	  };
	}
	/**
	 * If user use `autoExpandParent` we should get the list of parent node
	 * @param keyList
	 * @param keyEntities
	 */
	
	
	function conductExpandParent(keyList, keyEntities) {
	  var expandedKeys = {};
	
	  function conductUp(key) {
	    if (expandedKeys[key]) return;
	    var entity = keyEntities[key];
	    if (!entity) return;
	    expandedKeys[key] = true;
	    var parent = entity.parent,
	        node = entity.node;
	    if (node.props && node.props.disabled) return;
	
	    if (parent) {
	      conductUp(parent.key);
	    }
	  }
	
	  (keyList || []).forEach(function (key) {
	    conductUp(key);
	  });
	  return Object.keys(expandedKeys);
	}
	/**
	 * Returns only the data- and aria- key/value pairs
	 */
	
	
	function getDataAndAria(props) {
	  return Object.keys(props).reduce(function (prev, key) {
	    if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-') {
	      prev[key] = props[key];
	    }
	
	    return prev;
	  }, {});
	}

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.warning = warning;
	exports.note = note;
	exports.resetWarned = resetWarned;
	exports.call = call;
	exports.warningOnce = warningOnce;
	exports.noteOnce = noteOnce;
	exports.default = void 0;
	
	/* eslint-disable no-console */
	var warned = {};
	
	function warning(valid, message) {
	  // Support uglify
	  if (false) {
	    console.error("Warning: ".concat(message));
	  }
	}
	
	function note(valid, message) {
	  // Support uglify
	  if (false) {
	    console.warn("Note: ".concat(message));
	  }
	}
	
	function resetWarned() {
	  warned = {};
	}
	
	function call(method, valid, message) {
	  if (!valid && !warned[message]) {
	    method(false, message);
	    warned[message] = true;
	  }
	}
	
	function warningOnce(valid, message) {
	  call(warning, valid, message);
	}
	
	function noteOnce(valid, message) {
	  call(note, valid, message);
	}
	
	var _default = warningOnce;
	/* eslint-enable */
	
	exports.default = _default;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var EventPluginRegistry = __webpack_require__(573);
	var EventPluginUtils = __webpack_require__(574);
	var ReactErrorUtils = __webpack_require__(578);
	
	var accumulateInto = __webpack_require__(1140);
	var forEachAccumulated = __webpack_require__(1141);
	var invariant = __webpack_require__(18);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(304);
	var EventPluginUtils = __webpack_require__(574);
	
	var accumulateInto = __webpack_require__(1140);
	var forEachAccumulated = __webpack_require__(1141);
	var warning = __webpack_require__(49);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 306 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(163);
	
	var getEventTarget = __webpack_require__(583);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* global window, document, Blob */
	
	
	var propTypes = {
	  table: _propTypes2.default.string.isRequired,
	  filename: _propTypes2.default.string.isRequired,
	  sheet: _propTypes2.default.string.isRequired,
	  id: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  buttonText: _propTypes2.default.string
	};
	
	var defaultProps = {
	  id: 'button-download-as-xls',
	  className: 'button-download',
	  buttonText: 'Download'
	};
	
	var ReactHTMLTableToExcel = function (_Component) {
	  _inherits(ReactHTMLTableToExcel, _Component);
	
	  function ReactHTMLTableToExcel(props) {
	    _classCallCheck(this, ReactHTMLTableToExcel);
	
	    var _this = _possibleConstructorReturn(this, (ReactHTMLTableToExcel.__proto__ || Object.getPrototypeOf(ReactHTMLTableToExcel)).call(this, props));
	
	    _this.handleDownload = _this.handleDownload.bind(_this);
	    return _this;
	  }
	
	  _createClass(ReactHTMLTableToExcel, [{
	    key: 'handleDownload',
	    value: function handleDownload() {
	      if (!document) {
	        if (false) {
	          console.error('Failed to access document object');
	        }
	
	        return null;
	      }
	
	      if (document.getElementById(this.props.table).nodeType !== 1) {
	        if (false) {
	          console.error('Provided table property is not html table element');
	        }
	
	        return null;
	      }
	
	      var table = document.getElementById(this.props.table).outerHTML;
	      var sheet = String(this.props.sheet);
	      var filename = String(this.props.filename) + '.xls';
	
	      var uri = 'data:application/vnd.ms-excel;base64,';
	      var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-mic' + 'rosoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta cha' + 'rset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:Exce' + 'lWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/>' + '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></' + 'xml><![endif]--></head><body>{table}</body></html>';
	
	      var context = {
	        worksheet: sheet || 'Worksheet',
	        table: table
	      };
	
	      // If IE11
	      if (window.navigator.msSaveOrOpenBlob) {
	        var fileData = ['' + ('<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-mic' + 'rosoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta cha' + 'rset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:Exce' + 'lWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/>' + '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></' + 'xml><![endif]--></head><body>') + table + '</body></html>'];
	        var blobObject = new Blob(fileData);
	        document.getElementById('react-html-table-to-excel').click()(function () {
	          window.navigator.msSaveOrOpenBlob(blobObject, filename);
	        });
	
	        return true;
	      }
	
	      var element = window.document.createElement('a');
	      element.href = uri + ReactHTMLTableToExcel.base64(ReactHTMLTableToExcel.format(template, context));
	      element.download = filename;
	      document.body.appendChild(element);
	      element.click();
	      document.body.removeChild(element);
	
	      return true;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'button',
	        {
	          id: this.props.id,
	          className: this.props.className,
	          type: 'button',
	          onClick: this.handleDownload
	        },
	        this.props.buttonText
	      );
	    }
	  }], [{
	    key: 'base64',
	    value: function base64(s) {
	      return window.btoa(unescape(encodeURIComponent(s)));
	    }
	  }, {
	    key: 'format',
	    value: function format(s, c) {
	      return s.replace(/{(\w+)}/g, function (m, p) {
	        return c[p];
	      });
	    }
	  }]);
	
	  return ReactHTMLTableToExcel;
	}(_react.Component);
	
	ReactHTMLTableToExcel.propTypes = propTypes;
	ReactHTMLTableToExcel.defaultProps = defaultProps;
	
	exports.default = ReactHTMLTableToExcel;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shouldPureComponentUpdate;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _shallowEqual = __webpack_require__(2849);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function shouldPureComponentUpdate(nextProps, nextState) {
	  return !(0, _shallowEqual2['default'])(this.props, nextProps) || !(0, _shallowEqual2['default'])(this.state, nextState);
	}
	
	module.exports = exports['default'];

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.routes = exports.route = exports.components = exports.component = exports.history = undefined;
	exports.falsy = falsy;
	
	var _propTypes = __webpack_require__(6);
	
	function falsy(props, propName, componentName) {
	  if (props[propName]) return new Error('<' + componentName + '> should not have a "' + propName + '" prop');
	}
	
	var history = exports.history = (0, _propTypes.shape)({
	  listen: _propTypes.func.isRequired,
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired
	});
	
	var component = exports.component = _propTypes.elementType;
	var components = exports.components = (0, _propTypes.oneOfType)([component, _propTypes.object]);
	var route = exports.route = (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.element]);
	var routes = exports.routes = (0, _propTypes.oneOfType)([route, (0, _propTypes.arrayOf)(route)]);

/***/ },
/* 311 */
47,
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(1179);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(2934);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(2933);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(2932);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(1178);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(1180);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 313 */
36,
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var vec2 = __webpack_require__(55);
	
	var curve = __webpack_require__(188);
	
	/**
	 * @author Yi Shen(https://github.com/pissang)
	 */
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI2 = Math.PI * 2;
	var start = vec2.create();
	var end = vec2.create();
	var extremity = vec2.create();
	/**
	 * 从顶点数组中计算出最小包围盒，写入`min`和`max`中
	 * @module zrender/core/bbox
	 * @param {Array<Object>} points 顶点数组
	 * @param {number} min
	 * @param {number} max
	 */
	
	function fromPoints(points, min, max) {
	  if (points.length === 0) {
	    return;
	  }
	
	  var p = points[0];
	  var left = p[0];
	  var right = p[0];
	  var top = p[1];
	  var bottom = p[1];
	  var i;
	
	  for (i = 1; i < points.length; i++) {
	    p = points[i];
	    left = mathMin(left, p[0]);
	    right = mathMax(right, p[0]);
	    top = mathMin(top, p[1]);
	    bottom = mathMax(bottom, p[1]);
	  }
	
	  min[0] = left;
	  min[1] = top;
	  max[0] = right;
	  max[1] = bottom;
	}
	/**
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromLine(x0, y0, x1, y1, min, max) {
	  min[0] = mathMin(x0, x1);
	  min[1] = mathMin(y0, y1);
	  max[0] = mathMax(x0, x1);
	  max[1] = mathMax(y0, y1);
	}
	
	var xDim = [];
	var yDim = [];
	/**
	 * 从三阶贝塞尔曲线(p0, p1, p2, p3)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {number} x3
	 * @param {number} y3
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	function fromCubic(x0, y0, x1, y1, x2, y2, x3, y3, min, max) {
	  var cubicExtrema = curve.cubicExtrema;
	  var cubicAt = curve.cubicAt;
	  var i;
	  var n = cubicExtrema(x0, x1, x2, x3, xDim);
	  min[0] = Infinity;
	  min[1] = Infinity;
	  max[0] = -Infinity;
	  max[1] = -Infinity;
	
	  for (i = 0; i < n; i++) {
	    var x = cubicAt(x0, x1, x2, x3, xDim[i]);
	    min[0] = mathMin(x, min[0]);
	    max[0] = mathMax(x, max[0]);
	  }
	
	  n = cubicExtrema(y0, y1, y2, y3, yDim);
	
	  for (i = 0; i < n; i++) {
	    var y = cubicAt(y0, y1, y2, y3, yDim[i]);
	    min[1] = mathMin(y, min[1]);
	    max[1] = mathMax(y, max[1]);
	  }
	
	  min[0] = mathMin(x0, min[0]);
	  max[0] = mathMax(x0, max[0]);
	  min[0] = mathMin(x3, min[0]);
	  max[0] = mathMax(x3, max[0]);
	  min[1] = mathMin(y0, min[1]);
	  max[1] = mathMax(y0, max[1]);
	  min[1] = mathMin(y3, min[1]);
	  max[1] = mathMax(y3, max[1]);
	}
	/**
	 * 从二阶贝塞尔曲线(p0, p1, p2)中计算出最小包围盒，写入`min`和`max`中
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x0
	 * @param {number} y0
	 * @param {number} x1
	 * @param {number} y1
	 * @param {number} x2
	 * @param {number} y2
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromQuadratic(x0, y0, x1, y1, x2, y2, min, max) {
	  var quadraticExtremum = curve.quadraticExtremum;
	  var quadraticAt = curve.quadraticAt; // Find extremities, where derivative in x dim or y dim is zero
	
	  var tx = mathMax(mathMin(quadraticExtremum(x0, x1, x2), 1), 0);
	  var ty = mathMax(mathMin(quadraticExtremum(y0, y1, y2), 1), 0);
	  var x = quadraticAt(x0, x1, x2, tx);
	  var y = quadraticAt(y0, y1, y2, ty);
	  min[0] = mathMin(x0, x2, x);
	  min[1] = mathMin(y0, y2, y);
	  max[0] = mathMax(x0, x2, x);
	  max[1] = mathMax(y0, y2, y);
	}
	/**
	 * 从圆弧中计算出最小包围盒，写入`min`和`max`中
	 * @method
	 * @memberOf module:zrender/core/bbox
	 * @param {number} x
	 * @param {number} y
	 * @param {number} rx
	 * @param {number} ry
	 * @param {number} startAngle
	 * @param {number} endAngle
	 * @param {number} anticlockwise
	 * @param {Array.<number>} min
	 * @param {Array.<number>} max
	 */
	
	
	function fromArc(x, y, rx, ry, startAngle, endAngle, anticlockwise, min, max) {
	  var vec2Min = vec2.min;
	  var vec2Max = vec2.max;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff % PI2 < 1e-4 && diff > 1e-4) {
	    // Is a circle
	    min[0] = x - rx;
	    min[1] = y - ry;
	    max[0] = x + rx;
	    max[1] = y + ry;
	    return;
	  }
	
	  start[0] = mathCos(startAngle) * rx + x;
	  start[1] = mathSin(startAngle) * ry + y;
	  end[0] = mathCos(endAngle) * rx + x;
	  end[1] = mathSin(endAngle) * ry + y;
	  vec2Min(min, start, end);
	  vec2Max(max, start, end); // Thresh to [0, Math.PI * 2]
	
	  startAngle = startAngle % PI2;
	
	  if (startAngle < 0) {
	    startAngle = startAngle + PI2;
	  }
	
	  endAngle = endAngle % PI2;
	
	  if (endAngle < 0) {
	    endAngle = endAngle + PI2;
	  }
	
	  if (startAngle > endAngle && !anticlockwise) {
	    endAngle += PI2;
	  } else if (startAngle < endAngle && anticlockwise) {
	    startAngle += PI2;
	  }
	
	  if (anticlockwise) {
	    var tmp = endAngle;
	    endAngle = startAngle;
	    startAngle = tmp;
	  } // var number = 0;
	  // var step = (anticlockwise ? -Math.PI : Math.PI) / 2;
	
	
	  for (var angle = 0; angle < endAngle; angle += Math.PI / 2) {
	    if (angle > startAngle) {
	      extremity[0] = mathCos(angle) * rx + x;
	      extremity[1] = mathSin(angle) * ry + y;
	      vec2Min(min, extremity, min);
	      vec2Max(max, extremity, max);
	    }
	  }
	}
	
	exports.fromPoints = fromPoints;
	exports.fromLine = fromLine;
	exports.fromCubic = fromCubic;
	exports.fromQuadratic = fromQuadratic;
	exports.fromArc = fromArc;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(392);
	
	var debugMode = _config.debugMode;
	
	var logError = function () {};
	
	if (debugMode === 1) {
	  logError = console.error;
	}
	
	var _default = logError;
	module.exports = _default;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(4);
	
	var Style = __webpack_require__(603);
	
	var Element = __webpack_require__(1187);
	
	var RectText = __webpack_require__(1203);
	
	/**
	 * Base class of all displayable graphic objects
	 * @module zrender/graphic/Displayable
	 */
	
	/**
	 * @alias module:zrender/graphic/Displayable
	 * @extends module:zrender/Element
	 * @extends module:zrender/graphic/mixin/RectText
	 */
	function Displayable(opts) {
	  opts = opts || {};
	  Element.call(this, opts); // Extend properties
	
	  for (var name in opts) {
	    if (opts.hasOwnProperty(name) && name !== 'style') {
	      this[name] = opts[name];
	    }
	  }
	  /**
	   * @type {module:zrender/graphic/Style}
	   */
	
	
	  this.style = new Style(opts.style, this);
	  this._rect = null; // Shapes for cascade clipping.
	  // Can only be `null`/`undefined` or an non-empty array, MUST NOT be an empty array.
	  // because it is easy to only using null to check whether clipPaths changed.
	
	  this.__clipPaths = null; // FIXME Stateful must be mixined after style is setted
	  // Stateful.call(this, opts);
	}
	
	Displayable.prototype = {
	  constructor: Displayable,
	  type: 'displayable',
	
	  /**
	   * Dirty flag. From which painter will determine if this displayable object needs brush.
	   * @name module:zrender/graphic/Displayable#__dirty
	   * @type {boolean}
	   */
	  __dirty: true,
	
	  /**
	   * Whether the displayable object is visible. when it is true, the displayable object
	   * is not drawn, but the mouse event can still trigger the object.
	   * @name module:/zrender/graphic/Displayable#invisible
	   * @type {boolean}
	   * @default false
	   */
	  invisible: false,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z: 0,
	
	  /**
	   * @name module:/zrender/graphic/Displayable#z
	   * @type {number}
	   * @default 0
	   */
	  z2: 0,
	
	  /**
	   * The z level determines the displayable object can be drawn in which layer canvas.
	   * @name module:/zrender/graphic/Displayable#zlevel
	   * @type {number}
	   * @default 0
	   */
	  zlevel: 0,
	
	  /**
	   * Whether it can be dragged.
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  draggable: false,
	
	  /**
	   * Whether is it dragging.
	   * @name module:/zrender/graphic/Displayable#draggable
	   * @type {boolean}
	   * @default false
	   */
	  dragging: false,
	
	  /**
	   * Whether to respond to mouse events.
	   * @name module:/zrender/graphic/Displayable#silent
	   * @type {boolean}
	   * @default false
	   */
	  silent: false,
	
	  /**
	   * If enable culling
	   * @type {boolean}
	   * @default false
	   */
	  culling: false,
	
	  /**
	   * Mouse cursor when hovered
	   * @name module:/zrender/graphic/Displayable#cursor
	   * @type {string}
	   */
	  cursor: 'pointer',
	
	  /**
	   * If hover area is bounding rect
	   * @name module:/zrender/graphic/Displayable#rectHover
	   * @type {string}
	   */
	  rectHover: false,
	
	  /**
	   * Render the element progressively when the value >= 0,
	   * usefull for large data.
	   * @type {boolean}
	   */
	  progressive: false,
	
	  /**
	   * @type {boolean}
	   */
	  incremental: false,
	
	  /**
	   * Scale ratio for global scale.
	   * @type {boolean}
	   */
	  globalScaleRatio: 1,
	  beforeBrush: function (ctx) {},
	  afterBrush: function (ctx) {},
	
	  /**
	   * Graphic drawing method.
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  // Interface
	  brush: function (ctx, prevEl) {},
	
	  /**
	   * Get the minimum bounding box.
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // Interface
	  getBoundingRect: function () {},
	
	  /**
	   * If displayable element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  contain: function (x, y) {
	    return this.rectContain(x, y);
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {
	    cb.call(context, this);
	  },
	
	  /**
	   * If bounding rect of element contain coord x, y
	   * @param  {number} x
	   * @param  {number} y
	   * @return {boolean}
	   */
	  rectContain: function (x, y) {
	    var coord = this.transformCoordToLocal(x, y);
	    var rect = this.getBoundingRect();
	    return rect.contain(coord[0], coord[1]);
	  },
	
	  /**
	   * Mark displayable element dirty and refresh next frame
	   */
	  dirty: function () {
	    this.__dirty = this.__dirtyText = true;
	    this._rect = null;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * If displayable object binded any event
	   * @return {boolean}
	   */
	  // TODO, events bound by bind
	  // isSilent: function () {
	  //     return !(
	  //         this.hoverable || this.draggable
	  //         || this.onmousemove || this.onmouseover || this.onmouseout
	  //         || this.onmousedown || this.onmouseup || this.onclick
	  //         || this.ondragenter || this.ondragover || this.ondragleave
	  //         || this.ondrop
	  //     );
	  // },
	
	  /**
	   * Alias for animate('style')
	   * @param {boolean} loop
	   */
	  animateStyle: function (loop) {
	    return this.animate('style', loop);
	  },
	  attrKV: function (key, value) {
	    if (key !== 'style') {
	      Element.prototype.attrKV.call(this, key, value);
	    } else {
	      this.style.set(value);
	    }
	  },
	
	  /**
	   * @param {Object|string} key
	   * @param {*} value
	   */
	  setStyle: function (key, value) {
	    this.style.set(key, value);
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * Use given style object
	   * @param  {Object} obj
	   */
	  useStyle: function (obj) {
	    this.style = new Style(obj, this);
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * The string value of `textPosition` needs to be calculated to a real postion.
	   * For example, `'inside'` is calculated to `[rect.width/2, rect.height/2]`
	   * by default. See `contain/text.js#calculateTextPosition` for more details.
	   * But some coutom shapes like "pin", "flag" have center that is not exactly
	   * `[width/2, height/2]`. So we provide this hook to customize the calculation
	   * for those shapes. It will be called if the `style.textPosition` is a string.
	   * @param {Obejct} [out] Prepared out object. If not provided, this method should
	   *        be responsible for creating one.
	   * @param {module:zrender/graphic/Style} style
	   * @param {Object} rect {x, y, width, height}
	   * @return {Obejct} out The same as the input out.
	   *         {
	   *             x: number. mandatory.
	   *             y: number. mandatory.
	   *             textAlign: string. optional. use style.textAlign by default.
	   *             textVerticalAlign: string. optional. use style.textVerticalAlign by default.
	   *         }
	   */
	  calculateTextPosition: null
	};
	zrUtil.inherits(Displayable, Element);
	zrUtil.mixin(Displayable, RectText); // zrUtil.mixin(Displayable, Stateful);
	
	var _default = Displayable;
	module.exports = _default;

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withConfigConsumer = withConfigConsumer;
	exports.ConfigConsumer = exports.ConfigContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(129));
	
	var _renderEmpty = _interopRequireDefault(__webpack_require__(1257));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var ConfigContext = (0, _createReactContext["default"])({
	  // We provide a default function for Context without provider
	  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
	    if (customizePrefixCls) return customizePrefixCls;
	    return "ant-".concat(suffixCls);
	  },
	  renderEmpty: _renderEmpty["default"]
	});
	exports.ConfigContext = ConfigContext;
	var ConfigConsumer = ConfigContext.Consumer;
	exports.ConfigConsumer = ConfigConsumer;
	
	function withConfigConsumer(config) {
	  return function withConfigConsumerFunc(Component) {
	    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
	    var SFC = function SFC(props) {
	      return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (configProps) {
	        var basicPrefixCls = config.prefixCls;
	        var getPrefixCls = configProps.getPrefixCls;
	        var customizePrefixCls = props.prefixCls;
	        var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
	        return /*#__PURE__*/React.createElement(Component, _extends({}, configProps, props, {
	          prefixCls: prefixCls
	        }));
	      });
	    };
	
	    var cons = Component.constructor;
	    var name = cons && cons.displayName || Component.name || 'Component';
	    SFC.displayName = "withConfigConsumer(".concat(name, ")");
	    return SFC;
	  };
	}

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Row", {
	  enumerable: true,
	  get: function get() {
	    return _row["default"];
	  }
	});
	Object.defineProperty(exports, "Col", {
	  enumerable: true,
	  get: function get() {
	    return _col["default"];
	  }
	});
	
	var _row = _interopRequireDefault(__webpack_require__(632));
	
	var _col = _interopRequireDefault(__webpack_require__(631));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Input = _interopRequireDefault(__webpack_require__(269));
	
	var _Group = _interopRequireDefault(__webpack_require__(1277));
	
	var _Search = _interopRequireDefault(__webpack_require__(1280));
	
	var _TextArea = _interopRequireDefault(__webpack_require__(634));
	
	var _Password = _interopRequireDefault(__webpack_require__(1278));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_Input["default"].Group = _Group["default"];
	_Input["default"].Search = _Search["default"];
	_Input["default"].TextArea = _TextArea["default"];
	_Input["default"].Password = _Password["default"];
	var _default = _Input["default"];
	exports["default"] = _default;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Group", {
	  enumerable: true,
	  get: function get() {
	    return _group["default"];
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _radioButton["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _radio = _interopRequireDefault(__webpack_require__(414));
	
	var _group = _interopRequireDefault(__webpack_require__(1305));
	
	var _radioButton = _interopRequireDefault(__webpack_require__(1306));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_radio["default"].Button = _radioButton["default"];
	_radio["default"].Group = _group["default"];
	var _default = _radio["default"];
	exports["default"] = _default;

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _debounce = _interopRequireDefault(__webpack_require__(300));
	
	var _configProvider = __webpack_require__(11);
	
	var _type = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SpinSizes = (0, _type.tuple)('small', 'default', 'large'); // Render indicator
	
	var defaultIndicator = null;
	
	function renderIndicator(prefixCls, props) {
	  var indicator = props.indicator;
	  var dotClassName = "".concat(prefixCls, "-dot"); // should not be render default indicator when indicator value is null
	
	  if (indicator === null) {
	    return null;
	  }
	
	  if ( /*#__PURE__*/React.isValidElement(indicator)) {
	    return /*#__PURE__*/React.cloneElement(indicator, {
	      className: (0, _classnames["default"])(indicator.props.className, dotClassName)
	    });
	  }
	
	  if ( /*#__PURE__*/React.isValidElement(defaultIndicator)) {
	    return /*#__PURE__*/React.cloneElement(defaultIndicator, {
	      className: (0, _classnames["default"])(defaultIndicator.props.className, dotClassName)
	    });
	  }
	
	  return /*#__PURE__*/React.createElement("span", {
	    className: (0, _classnames["default"])(dotClassName, "".concat(prefixCls, "-dot-spin"))
	  }, /*#__PURE__*/React.createElement("i", {
	    className: "".concat(prefixCls, "-dot-item")
	  }), /*#__PURE__*/React.createElement("i", {
	    className: "".concat(prefixCls, "-dot-item")
	  }), /*#__PURE__*/React.createElement("i", {
	    className: "".concat(prefixCls, "-dot-item")
	  }), /*#__PURE__*/React.createElement("i", {
	    className: "".concat(prefixCls, "-dot-item")
	  }));
	}
	
	function shouldDelay(spinning, delay) {
	  return !!spinning && !!delay && !isNaN(Number(delay));
	}
	
	var Spin = /*#__PURE__*/function (_React$Component) {
	  _inherits(Spin, _React$Component);
	
	  var _super = _createSuper(Spin);
	
	  function Spin(props) {
	    var _this;
	
	    _classCallCheck(this, Spin);
	
	    _this = _super.call(this, props);
	
	    _this.debouncifyUpdateSpinning = function (props) {
	      var _ref = props || _this.props,
	          delay = _ref.delay;
	
	      if (delay) {
	        _this.cancelExistingSpin();
	
	        _this.updateSpinning = (0, _debounce["default"])(_this.originalUpdateSpinning, delay);
	      }
	    };
	
	    _this.updateSpinning = function () {
	      var spinning = _this.props.spinning;
	      var currentSpinning = _this.state.spinning;
	
	      if (currentSpinning !== spinning) {
	        _this.setState({
	          spinning: spinning
	        });
	      }
	    };
	
	    _this.renderSpin = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          size = _a.size,
	          tip = _a.tip,
	          wrapperClassName = _a.wrapperClassName,
	          style = _a.style,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "tip", "wrapperClassName", "style"]);
	
	      var spinning = _this.state.spinning;
	      var prefixCls = getPrefixCls('spin', customizePrefixCls);
	      var spinClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-spinning"), spinning), _defineProperty(_classNames, "".concat(prefixCls, "-show-text"), !!tip), _classNames), className); // fix https://fb.me/react-unknown-prop
	
	      var divProps = (0, _omit["default"])(restProps, ['spinning', 'delay', 'indicator']);
	      var spinElement = /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	        style: style,
	        className: spinClassName
	      }), renderIndicator(prefixCls, _this.props), tip ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-text")
	      }, tip) : null);
	
	      if (_this.isNestedPattern()) {
	        var containerClassName = (0, _classnames["default"])("".concat(prefixCls, "-container"), _defineProperty({}, "".concat(prefixCls, "-blur"), spinning));
	        return /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-nested-loading"), wrapperClassName)
	        }), spinning && /*#__PURE__*/React.createElement("div", {
	          key: "loading"
	        }, spinElement), /*#__PURE__*/React.createElement("div", {
	          className: containerClassName,
	          key: "container"
	        }, _this.props.children));
	      }
	
	      return spinElement;
	    };
	
	    var spinning = props.spinning,
	        delay = props.delay;
	    var shouldBeDelayed = shouldDelay(spinning, delay);
	    _this.state = {
	      spinning: spinning && !shouldBeDelayed
	    };
	    _this.originalUpdateSpinning = _this.updateSpinning;
	
	    _this.debouncifyUpdateSpinning(props);
	
	    return _this;
	  }
	
	  _createClass(Spin, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateSpinning();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.debouncifyUpdateSpinning();
	      this.updateSpinning();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.cancelExistingSpin();
	    }
	  }, {
	    key: "cancelExistingSpin",
	    value: function cancelExistingSpin() {
	      var updateSpinning = this.updateSpinning;
	
	      if (updateSpinning && updateSpinning.cancel) {
	        updateSpinning.cancel();
	      }
	    }
	  }, {
	    key: "isNestedPattern",
	    value: function isNestedPattern() {
	      return !!(this.props && this.props.children);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSpin);
	    }
	  }], [{
	    key: "setDefaultIndicator",
	    value: function setDefaultIndicator(indicator) {
	      defaultIndicator = indicator;
	    }
	  }]);
	
	  return Spin;
	}(React.Component);
	
	Spin.defaultProps = {
	  spinning: true,
	  size: 'default',
	  wrapperClassName: ''
	};
	Spin.propTypes = {
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  spinning: PropTypes.bool,
	  size: PropTypes.oneOf(SpinSizes),
	  wrapperClassName: PropTypes.string,
	  indicator: PropTypes.element
	};
	var _default = Spin;
	exports["default"] = _default;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryDeleteAnnouncement = exports.querySaveAnnouncement = exports.queryAnnouncementInfo = exports.queryAnnouncementList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var queryAnnouncementList = exports.queryAnnouncementList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.administrative.GET_ANNOUNCEMENT_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryAnnouncementList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryAnnouncementInfo = exports.queryAnnouncementInfo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.administrative.GET_ANNOUNCEMENT_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryAnnouncementInfo(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var querySaveAnnouncement = exports.querySaveAnnouncement = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.post(_req.administrative.SAVE_ANNOUNCEMENT, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function querySaveAnnouncement(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryDeleteAnnouncement = exports.queryDeleteAnnouncement = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.administrative.DELETE_ANNOUNCEMENT, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryDeleteAnnouncement(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryRoleFunctionRoleList = exports.queryRoleFunctionFunctionList = exports.queryAccountRoleAccounts = exports.querySaveRoleUserByRole = exports.querySaveRoleFunc = exports.querySaveRole = exports.queryDeleteRole = exports.queryRoleInfo = exports.queryAllRoleList = exports.queryRoleList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var queryRoleList = exports.queryRoleList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.core.GET_ROLE_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryRoleList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryAllRoleList = exports.queryAllRoleList = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.core.GET_ROLE_LIST_ALL, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryAllRoleList(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryRoleInfo = exports.queryRoleInfo = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.core.GET_ROLE_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryRoleInfo(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryDeleteRole = exports.queryDeleteRole = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.core.DELETE_ROLE, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryDeleteRole(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var querySaveRole = exports.querySaveRole = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.post(_req.core.SAVE_ROLE, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function querySaveRole(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var querySaveRoleFunc = exports.querySaveRoleFunc = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.post(_req.core.SAVE_ROLE_FUNCTION, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function querySaveRoleFunc(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var querySaveRoleUserByRole = exports.querySaveRoleUserByRole = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(params) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt('return', _http2.default.post(_req.core.SAVE_BY_ROLE_ACCOUNT_ROLE, params));
	
	          case 1:
	          case 'end':
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function querySaveRoleUserByRole(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	var queryAccountRoleAccounts = exports.queryAccountRoleAccounts = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(params) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt('return', _http2.default.get(_req.core.GET_ACCOUNT_ROLE_ACCOUNTS, params));
	
	          case 1:
	          case 'end':
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryAccountRoleAccounts(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	var queryRoleFunctionFunctionList = exports.queryRoleFunctionFunctionList = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            return _context9.abrupt('return', _http2.default.get(_req.core.GET_ROLE_FUNCTION_FUNCTIONLIST, params));
	
	          case 1:
	          case 'end':
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryRoleFunctionFunctionList(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	var queryRoleFunctionRoleList = exports.queryRoleFunctionRoleList = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10(params) {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt('return', _http2.default.get(_req.core.GET_ROLE_FUNCTION_ROLELIST, params));
	
	          case 1:
	          case 'end':
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryRoleFunctionRoleList(_x10) {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function (e) {
	      e.preventDefault();
	      var data = _this.props.form.getFieldsValue();
	      _this.props.search(data);
	    };
	
	    _this.onChange = function (value) {
	      _this.props.onChange(value);
	    };
	
	    _this.loadOrg = function () {
	      var params = {};
	      params.uuid = '19F83BB0108B4255AA38D457E3FFF223';
	      (0, _org.queryOrgList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var options = [];
	          res.data.map(function (item) {
	            var optionItem = {};
	            optionItem.label = item.name;
	            optionItem.value = item.uuid;
	            optionItem.key = item.uuid;
	            options.push(optionItem);
	            return options;
	          });
	          _this.setState({
	            treeData: options
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.onLoadData = function (treeNode) {
	      var arr = [];
	      var key = treeNode.props.eventKey;
	      var params = {};
	      params.uuid = key.split('-')[key.split('-').length - 1];
	      return new Promise(function (resolve) {
	        (0, _org.queryOrgList)(params).then(function (res) {
	          if (res.statusCode === 200) {
	            res.data.map(function (item) {
	              var optionItem = {};
	              optionItem.label = item.name;
	              optionItem.value = item.uuid;
	              optionItem.key = key + '-' + item.uuid;
	              arr.push(optionItem);
	              return arr;
	            });
	            var treeData = [].concat(_toConsumableArray(_this.state.treeData));
	            var loop = function loop(data) {
	              data.forEach(function (item) {
	                if (key.indexOf(item.key) === 0) {
	                  if (item.children) {
	                    resolve();
	                    loop(item.children);
	                  } else if (item.key === key) {
	                    if (arr.length > 0) {
	                      item.children = arr;
	                      _this.setState({ treeData: treeData }, function () {
	                        resolve();
	                      });
	                    } else if (arr.length === 0) {
	                      item.isLeaf = true;
	                      _this.setState({ treeData: treeData }, function () {
	                        resolve();
	                      });
	                    } else {
	                      resolve();
	                    }
	                  }
	                }
	              });
	            };
	            loop(treeData);
	          }
	        });
	      });
	    };
	
	    _this.state = {
	      treeData: [],
	      orgUuid: ''
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadOrg();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.orgUuid !== this.props.orgUuid) {
	        this.setState({
	          orgUuid: nextProps.orgUuid
	        });
	      }
	    }
	
	    /**
	     *获取组织列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_antd.TreeSelect, {
	        treeData: this.state.treeData,
	        loadData: this.onLoadData,
	        dropdownStyle: {
	          maxHeight: '500px',
	          overflowY: 'scroll',
	          width: '200px'
	        },
	        onSelect: this.onChange,
	        dropdownMatchSelectWidth: false,
	        value: this.state.orgUuid,
	        placeholder: this.props.placeholder
	      });
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create()(Index));

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _user = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.onChange = function (value, selectedOptions) {
	      _this.props.onChange(value, selectedOptions);
	    };
	
	    _this.loadUsers = function () {
	      (0, _user.queryAccountList)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ users: res.data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      users: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadUsers();
	    }
	
	    /**
	     * 获取用户列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var users = this.state.users;
	      var _props = this.props,
	          form = _props.form,
	          field = _props.field,
	          ItemLayout = _props.ItemLayout,
	          data = _props.data;
	
	
	      return _react2.default.createElement(
	        FormItem,
	        Object.assign({ label: field.fieldName }, ItemLayout),
	        form.getFieldDecorator(field.field, {
	          rules: [{ required: field.isRequire, message: '\u8BF7\u9009\u62E9' + field.fieldName + '!' }],
	          initialValue: data ? data[field.field] : ''
	        })(_react2.default.createElement(
	          _antd.Select,
	          {
	            filterOption: function filterOption(input, option) {
	              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	            },
	            onChange: this.onChange
	          },
	          users.map(function (item, index) {
	            return _react2.default.createElement(
	              Option,
	              { key: item.uuid, value: item.uuid },
	              item.name
	            );
	          })
	        ))
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _BackBtn = __webpack_require__(12);
	
	var _ModalReject = __webpack_require__(1514);
	
	var _ModalReject2 = _interopRequireDefault(_ModalReject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	exports.default = function (WrappedComponent) {
	  return function (_Component) {
	    _inherits(WorkflowOp, _Component);
	
	    function WorkflowOp(props) {
	      _classCallCheck(this, WorkflowOp);
	
	      var _this = _possibleConstructorReturn(this, (WorkflowOp.__proto__ || Object.getPrototypeOf(WorkflowOp)).call(this, props));
	
	      _this.handleRejectVisible = function (flag) {
	        _this.setState({
	          rejectVisible: !!flag
	        });
	      };
	
	      _this.handleNext = function () {
	        _this.props.doTask('next');
	      };
	
	      _this.isAuditor = function (activities, currentUser) {
	        return activities.some(function (item, index) {
	          return (_this.userUuid === item.processor || item.processor.indexOf(_this.userUuid) !== -1) && activities[index + 1] && currentUser && currentUser.uuid === activities[index + 1].uuid;
	        });
	      };
	
	      _this.handleReturn = function (params) {
	        _this.props.doTask('return', params);
	        _this.handleRejectVisible(false);
	      };
	
	      _this.changeButton = function () {
	        var _this$props = _this.props,
	            data = _this$props.data,
	            doTask = _this$props.doTask;
	        var _data$instance = data.instance,
	            instance = _data$instance === undefined ? {} : _data$instance;
	        var _instance$preActivity = instance.preActivity,
	            preActivity = _instance$preActivity === undefined ? {} : _instance$preActivity,
	            _instance$activities = instance.activities,
	            activities = _instance$activities === undefined ? [] : _instance$activities,
	            _instance$currentActi = instance.currentActivity,
	            currentUser = _instance$currentActi === undefined ? {} : _instance$currentActi;
	
	        // 报销status:(0,流程进行中；1,流程结束；2.废弃)
	        // activities:status:(0,未开始；1,正在进行；2.结束)
	
	        // 审核开关(会签情况)
	
	        var examineFlag = currentUser && currentUser.messages && currentUser.messages.some(function (item) {
	          return item.processor === _this.userUuid && item.isDone === 0 && item.status === 0;
	        });
	
	        // 当前会签环节是否有收回
	        var callbackFlag = currentUser && currentUser.messages && currentUser.messages.some(function (item) {
	          return item.processor === _this.userUuid && item.isDone === 1 && item.status === 0;
	        });
	
	        if (instance.status !== 0) {
	          return null;
	        }
	        if (currentUser && currentUser.processor && currentUser.processor === _this.userUuid || examineFlag) {
	          // 当前流程审核人打开
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                icon: 'arrow-left',
	                style: { marginRight: 10 },
	                onClick: function onClick() {
	                  return _this.handleRejectVisible(true);
	                }
	              },
	              '\u9000\u56DE'
	            ),
	            _react2.default.createElement(WrappedComponent, _this.props),
	            preActivity && preActivity.processor === _this.userUuid || data.createUser === _this.userUuid && activities[0] && activities[0].status !== 2 ? _react2.default.createElement(
	              _antd.Button,
	              {
	                icon: 'arrow-left',
	                style: { marginRight: 10 },
	                onClick: function onClick() {
	                  return doTask('callback');
	                }
	              },
	              '\u6536\u56DE'
	            ) : null
	          );
	        }
	        if (data.createUser === _this.userUuid && activities[0] && activities[0].status !== 2 || _this.isAuditor(activities, currentUser) || callbackFlag) {
	          // 申请人打开
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                icon: 'arrow-left',
	                style: { marginRight: 10 },
	                onClick: function onClick() {
	                  return doTask('callback');
	                }
	              },
	              '\u6536\u56DE'
	            )
	          );
	        }
	        return null;
	      };
	
	      _this.state = {
	        rejectVisible: false
	      };
	      return _this;
	    }
	
	    _createClass(WorkflowOp, [{
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	        this.userUuid = _localDb2.default.get('userUuid');
	      }
	
	      // 通过按钮，不同流程有不同的特殊操作
	
	
	      // 判断流程中的用户是否有收回按钮
	
	    }, {
	      key: 'render',
	      value: function render() {
	        var rejectVisible = this.state.rejectVisible;
	
	        return _react2.default.createElement(
	          'div',
	          { className: 'form-open' },
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: '16px' } },
	            _react2.default.createElement(_BackBtn.BackBtn, null),
	            this.changeButton()
	          ),
	          _react2.default.createElement(_ModalReject2.default, {
	            visible: rejectVisible,
	            handleOk: this.handleReturn,
	            handleCancel: this.handleRejectVisible
	          })
	        );
	      }
	    }]);
	
	    return WorkflowOp;
	  }(_react.Component);
	};

/***/ },
/* 327 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setBackInfoStandby = setBackInfoStandby;
	exports.backInfoStandby = backInfoStandby;
	// 按模块的action, reducer整合体
	var BACK_INFO_STANDBY = 'BACK_INFO_STANDBY';
	
	function setBackInfoStandby(params) {
	  return function (dispatch) {
	    return dispatch({
	      type: BACK_INFO_STANDBY,
	      data: params
	    });
	  };
	}
	
	function backInfoStandby() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case BACK_INFO_STANDBY:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 328 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * utils
	 */
	
	var base = {
	  /**
	   * 银行列表
	   */
	  bank: [{ key: '1', name: '先行工商银行' }, { key: '2', name: '先行杭州银行' }, { key: '3', name: '先行建设银行' }, { key: '4', name: '杭州联合银行' }, { key: '5', name: '点实浦发银行' }, { key: '6', name: '商美工商银行' }, { key: '7', name: '朋广招商银行' }, { key: '8', name: '企点工商银行' }, { key: '9', name: '农业银行' }, { key: '10', name: '工商银行' }, { key: '11', name: '建设银行' }, { key: '12', name: '帮腾招商银行' }, { key: '13', name: '招商银行' }, { key: '14', name: '先行支付宝' }, { key: '15', name: '点实支付宝' }, { key: '16', name: '朋广支付宝' }, { key: '17', name: '帮腾支付宝' }],
	
	  /**
	   * 申请类别
	   */
	  submitType: [{ key: '1', name: '提前开票' }, { key: '2', name: '到账开票' }],
	
	  /**
	   * 收款方式
	   */
	  collectWay: [{ key: '1', name: '汇款' }, { key: '2', name: '现金' }],
	
	  bookType: [{ key: '1', name: '支付宝' }, { key: '2', name: '农业银行' }, { key: '3', name: '工商银行(趣得)' }, { key: '4', name: '建设银行' }, { key: '5', name: '易宝' }, { key: '6', name: '招商银行' }, { key: '7', name: '杭州银行' }, { key: '8', name: '邮政银行' }, { key: '9', name: '工商银行(新华)' }, { key: '10', name: '微信' }, { key: '11', name: '连连支付/通联/贝宝' }, { key: '12', name: '联合银行' }, { key: '13', name: '旧版支付宝' }, { key: '14', name: '泰隆银行' }, { key: '15', name: '工商银行2(趣得)' }, { key: '16', name: '建设银行2' }],
	
	  /**
	   * 客户文件
	   */
	  attachmentType: [{ key: '1', name: '法人身份证' }, { key: '2', name: '消防安全责任书' }, { key: '3', name: '营业执照' }, { key: '4', name: '资产负债表（实缴注册资本低于300万元凭证）' }, { key: '5', name: '特殊费用申请审批表' }, { key: '6', name: '工位分布图' }, { key: '7', name: '企业租赁合同' }, { key: '8', name: '房产证' }, { key: '9', name: '工位注册委托书' }, { key: '10', name: '基础孵化服务协议' }, { key: '11', name: '无偿使用证明' }, { key: '12', name: '平面图' }, { key: '16', name: '三方租赁合同' }, { key: '17', name: '营业执照（物业主体供地址注册使用）' }, { key: '18', name: '房租协议、合同' }, { key: '19', name: '补充说明、申请报告' }, { key: '20', name: '解除协议合同' }, { key: '-1', name: '错误文件' }],
	
	  /** 投资回报类型 */
	  investmentType: {
	    investmentInit: '投资款',
	    current: '现金余额',
	    inOrOut: '往来款',
	    depositInOrOut: '保证金',
	    longInvestment: '长期股权投资',
	    equityTransfer: '股权转让支出',
	    financial: '理财款',
	    fixed: '固定资产',
	    decoration: '装修',
	    sum: '总计'
	  },
	
	  model: [{ key: '1', name: '入驻费米孵化器' }, { key: '2', name: '入驻极讯孵化器' }, { key: '3', name: '入驻创盒孵化器' }, { key: '4', name: '入驻麦鲜孵化器' }, { key: '5', name: '入驻远方极客孵化器' }, { key: '6', name: '参加科创王牌活动' }, { key: '7', name: '参加寻找掌门人活动' }, { key: '8', name: '技术孵化' }, { key: '9', name: '财务代理' }, { key: '10', name: '知识产权' }, { key: '12', name: '入驻一源极客孵化器' }, { key: '13', name: '入驻点雇极客孵化器' }, { key: '14', name: '入驻致客孵化器' }, { key: '15', name: '入驻嵊州科创孵化器' }, { key: '17', name: '入驻永客孵化器' }]
	};
	
	exports.default = base;

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1887), __esModule: true };

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(741);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(1835);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 331 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 332 */
278,
/* 333 */
[3034, 155, 78, 236],
/* 334 */
206,
/* 335 */
[3060, 1908, 749],
/* 336 */
[3005, 107, 63, 205],
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(42);
	var $export = __webpack_require__(7);
	var redefine = __webpack_require__(98);
	var redefineAll = __webpack_require__(203);
	var meta = __webpack_require__(174);
	var forOf = __webpack_require__(198);
	var anInstance = __webpack_require__(197);
	var isObject = __webpack_require__(45);
	var fails = __webpack_require__(43);
	var $iterDetect = __webpack_require__(341);
	var setToStringTag = __webpack_require__(242);
	var inheritIfRequired = __webpack_require__(468);
	
	module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	  var Base = global[NAME];
	  var C = Base;
	  var ADDER = IS_MAP ? 'set' : 'add';
	  var proto = C && C.prototype;
	  var O = {};
	  var fixMethod = function (KEY) {
	    var fn = proto[KEY];
	    redefine(proto, KEY,
	      KEY == 'delete' ? function (a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'has' ? function has(a) {
	        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'get' ? function get(a) {
	        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
	        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
	    );
	  };
	  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	    new C().entries().next();
	  }))) {
	    // create collection constructor
	    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	    redefineAll(C.prototype, methods);
	    meta.NEED = true;
	  } else {
	    var instance = new C();
	    // early implementations not supports chaining
	    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
	    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
	    // most early implementations doesn't supports iterables, most modern - not close it correctly
	    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
	    // for early implementations -0 and +0 not the same
	    var BUGGY_ZERO = !IS_WEAK && fails(function () {
	      // V8 ~ Chromium 42- fails only with 5+ elements
	      var $instance = new C();
	      var index = 5;
	      while (index--) $instance[ADDER](index, index);
	      return !$instance.has(-0);
	    });
	    if (!ACCEPT_ITERABLES) {
	      C = wrapper(function (target, iterable) {
	        anInstance(target, C, NAME);
	        var that = inheritIfRequired(new Base(), target, C);
	        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        return that;
	      });
	      C.prototype = proto;
	      proto.constructor = C;
	    }
	    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	      fixMethod('delete');
	      fixMethod('has');
	      IS_MAP && fixMethod('get');
	    }
	    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	    // weak collections should not contains .clear method
	    if (IS_WEAK && proto.clear) delete proto.clear;
	  }
	
	  setToStringTag(C, NAME);
	
	  O[NAME] = C;
	  $export($export.G + $export.W + $export.F * (C != Base), O);
	
	  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	  return C;
	};


/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(789);
	var redefine = __webpack_require__(98);
	var hide = __webpack_require__(97);
	var fails = __webpack_require__(43);
	var defined = __webpack_require__(136);
	var wks = __webpack_require__(58);
	var regexpExec = __webpack_require__(476);
	
	var SPECIES = wks('species');
	
	var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
	  // #replace needs built-in support for named groups.
	  // #match works fine because it just return the exec results, even if it has
	  // a "grops" property.
	  var re = /./;
	  re.exec = function () {
	    var result = [];
	    result.groups = { a: '7' };
	    return result;
	  };
	  return ''.replace(re, '$<a>') !== '7';
	});
	
	var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = (function () {
	  // Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
	  var re = /(?:)/;
	  var originalExec = re.exec;
	  re.exec = function () { return originalExec.apply(this, arguments); };
	  var result = 'ab'.split(re);
	  return result.length === 2 && result[0] === 'a' && result[1] === 'b';
	})();
	
	module.exports = function (KEY, length, exec) {
	  var SYMBOL = wks(KEY);
	
	  var DELEGATES_TO_SYMBOL = !fails(function () {
	    // String methods call symbol-named RegEp methods
	    var O = {};
	    O[SYMBOL] = function () { return 7; };
	    return ''[KEY](O) != 7;
	  });
	
	  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL ? !fails(function () {
	    // Symbol-named RegExp methods call .exec
	    var execCalled = false;
	    var re = /a/;
	    re.exec = function () { execCalled = true; return null; };
	    if (KEY === 'split') {
	      // RegExp[@@split] doesn't call the regex's exec method, but first creates
	      // a new one. We need to return the patched regex when creating the new one.
	      re.constructor = {};
	      re.constructor[SPECIES] = function () { return re; };
	    }
	    re[SYMBOL]('');
	    return !execCalled;
	  }) : undefined;
	
	  if (
	    !DELEGATES_TO_SYMBOL ||
	    !DELEGATES_TO_EXEC ||
	    (KEY === 'replace' && !REPLACE_SUPPORTS_NAMED_GROUPS) ||
	    (KEY === 'split' && !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC)
	  ) {
	    var nativeRegExpMethod = /./[SYMBOL];
	    var fns = exec(
	      defined,
	      SYMBOL,
	      ''[KEY],
	      function maybeCallNative(nativeMethod, regexp, str, arg2, forceStringMethod) {
	        if (regexp.exec === regexpExec) {
	          if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
	            // The native String method already delegates to @@method (this
	            // polyfilled function), leasing to infinite recursion.
	            // We avoid it by directly calling the native @@method method.
	            return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
	          }
	          return { done: true, value: nativeMethod.call(str, regexp, arg2) };
	        }
	        return { done: false };
	      }
	    );
	    var strfn = fns[0];
	    var rxfn = fns[1];
	
	    redefine(String.prototype, KEY, strfn);
	    hide(RegExp.prototype, SYMBOL, length == 2
	      // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	      // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	      ? function (string, arg) { return rxfn.call(string, this, arg); }
	      // 21.2.5.6 RegExp.prototype[@@match](string)
	      // 21.2.5.9 RegExp.prototype[@@search](string)
	      : function (string) { return rxfn.call(string, this); }
	    );
	  }
	};


/***/ },
/* 339 */
[3017, 116],
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.8 IsRegExp(argument)
	var isObject = __webpack_require__(45);
	var cof = __webpack_require__(116);
	var MATCH = __webpack_require__(58)('match');
	module.exports = function (it) {
	  var isRegExp;
	  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	};


/***/ },
/* 341 */
[3022, 58],
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// Forced replacement prototype accessors methods
	module.exports = __webpack_require__(173) || !__webpack_require__(43)(function () {
	  var K = Math.random();
	  // In FF throws only define methods
	  // eslint-disable-next-line no-undef, no-useless-call
	  __defineSetter__.call(null, K, function () { /* empty */ });
	  delete __webpack_require__(42)[K];
	});


/***/ },
/* 343 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var classof = __webpack_require__(240);
	var builtinExec = RegExp.prototype.exec;
	
	 // `RegExpExec` abstract operation
	// https://tc39.github.io/ecma262/#sec-regexpexec
	module.exports = function (R, S) {
	  var exec = R.exec;
	  if (typeof exec === 'function') {
	    var result = exec.call(R, S);
	    if (typeof result !== 'object') {
	      throw new TypeError('RegExp exec method returned something other than an Object or null');
	    }
	    return result;
	  }
	  if (classof(R) !== 'RegExp') {
	    throw new TypeError('RegExp#exec called on incompatible receiver');
	  }
	  return builtinExec.call(R, S);
	};


/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(7);
	var aFunction = __webpack_require__(84);
	var ctx = __webpack_require__(118);
	var forOf = __webpack_require__(198);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { from: function from(source /* , mapFn, thisArg */) {
	    var mapFn = arguments[1];
	    var mapping, A, n, cb;
	    aFunction(this);
	    mapping = mapFn !== undefined;
	    if (mapping) aFunction(mapFn);
	    if (source == undefined) return new this();
	    A = [];
	    if (mapping) {
	      n = 0;
	      cb = ctx(mapFn, arguments[2], 2);
	      forOf(source, false, function (nextItem) {
	        A.push(cb(nextItem, n++));
	      });
	    } else {
	      forOf(source, false, A.push, A);
	    }
	    return new this(A);
	  } });
	};


/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-setmap-offrom/
	var $export = __webpack_require__(7);
	
	module.exports = function (COLLECTION) {
	  $export($export.S, COLLECTION, { of: function of() {
	    var length = arguments.length;
	    var A = new Array(length);
	    while (length--) A[length] = arguments[length];
	    return new this(A);
	  } });
	};


/***/ },
/* 347 */
[3039, 120, 136],
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(42);
	var hide = __webpack_require__(97);
	var uid = __webpack_require__(206);
	var TYPED = uid('typed_array');
	var VIEW = uid('view');
	var ABV = !!(global.ArrayBuffer && global.DataView);
	var CONSTR = ABV;
	var i = 0;
	var l = 9;
	var Typed;
	
	var TypedArrayConstructors = (
	  'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'
	).split(',');
	
	while (i < l) {
	  if (Typed = global[TypedArrayConstructors[i++]]) {
	    hide(Typed.prototype, TYPED, true);
	    hide(Typed.prototype, VIEW, true);
	  } else CONSTR = false;
	}
	
	module.exports = {
	  ABV: ABV,
	  CONSTR: CONSTR,
	  TYPED: TYPED,
	  VIEW: VIEW
	};


/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(42);
	var navigator = global.navigator;
	
	module.exports = navigator && navigator.userAgent || '';


/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntity
	 * @format
	 * 
	 */
	
	var DraftEntityInstance = __webpack_require__(798);
	var Immutable = __webpack_require__(39);
	
	var invariant = __webpack_require__(18);
	
	var Map = Immutable.Map;
	
	
	var instances = Map();
	var instanceKey = 0;
	
	/**
	 * Temporary utility for generating the warnings
	 */
	function logWarning(oldMethodCall, newMethodCall) {
	  console.warn('WARNING: ' + oldMethodCall + ' will be deprecated soon!\nPlease use "' + newMethodCall + '" instead.');
	}
	
	/**
	 * A "document entity" is an object containing metadata associated with a
	 * piece of text in a ContentBlock.
	 *
	 * For example, a `link` entity might include a `uri` property. When a
	 * ContentBlock is rendered in the browser, text that refers to that link
	 * entity may be rendered as an anchor, with the `uri` as the href value.
	 *
	 * In a ContentBlock, every position in the text may correspond to zero
	 * or one entities. This correspondence is tracked using a key string,
	 * generated via DraftEntity.create() and used to obtain entity metadata
	 * via DraftEntity.get().
	 */
	var DraftEntity = {
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.getLastCreatedEntityKey' instead.
	   * ---
	   * Get the random key string from whatever entity was last created.
	   * We need this to support the new API, as part of transitioning to put Entity
	   * storage in contentState.
	   */
	  getLastCreatedEntityKey: function getLastCreatedEntityKey() {
	    logWarning('DraftEntity.getLastCreatedEntityKey', 'contentState.getLastCreatedEntityKey');
	    return DraftEntity.__getLastCreatedEntityKey();
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.createEntity' instead.
	   * ---
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  create: function create(type, mutability, data) {
	    logWarning('DraftEntity.create', 'contentState.createEntity');
	    return DraftEntity.__create(type, mutability, data);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.addEntity' instead.
	   * ---
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  add: function add(instance) {
	    logWarning('DraftEntity.add', 'contentState.addEntity');
	    return DraftEntity.__add(instance);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.getEntity' instead.
	   * ---
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  get: function get(key) {
	    logWarning('DraftEntity.get', 'contentState.getEntity');
	    return DraftEntity.__get(key);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.mergeEntityData' instead.
	   * ---
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  mergeData: function mergeData(key, toMerge) {
	    logWarning('DraftEntity.mergeData', 'contentState.mergeEntityData');
	    return DraftEntity.__mergeData(key, toMerge);
	  },
	
	  /**
	   * WARNING: This method will be deprecated soon!
	   * Please use 'contentState.replaceEntityData' instead.
	   * ---
	   * Completely replace the data for a given instance.
	   */
	  replaceData: function replaceData(key, newData) {
	    logWarning('DraftEntity.replaceData', 'contentState.replaceEntityData');
	    return DraftEntity.__replaceData(key, newData);
	  },
	
	  // ***********************************WARNING******************************
	  // --- the above public API will be deprecated in the next version of Draft!
	  // The methods below this line are private - don't call them directly.
	
	  /**
	   * Get the random key string from whatever entity was last created.
	   * We need this to support the new API, as part of transitioning to put Entity
	   * storage in contentState.
	   */
	  __getLastCreatedEntityKey: function __getLastCreatedEntityKey() {
	    return '' + instanceKey;
	  },
	
	  /**
	   * Create a DraftEntityInstance and store it for later retrieval.
	   *
	   * A random key string will be generated and returned. This key may
	   * be used to track the entity's usage in a ContentBlock, and for
	   * retrieving data about the entity at render time.
	   */
	  __create: function __create(type, mutability, data) {
	    return DraftEntity.__add(new DraftEntityInstance({ type: type, mutability: mutability, data: data || {} }));
	  },
	
	  /**
	   * Add an existing DraftEntityInstance to the DraftEntity map. This is
	   * useful when restoring instances from the server.
	   */
	  __add: function __add(instance) {
	    var key = '' + ++instanceKey;
	    instances = instances.set(key, instance);
	    return key;
	  },
	
	  /**
	   * Retrieve the entity corresponding to the supplied key string.
	   */
	  __get: function __get(key) {
	    var instance = instances.get(key);
	    !!!instance ?  false ? invariant(false, 'Unknown DraftEntity key: %s.', key) : invariant(false) : void 0;
	    return instance;
	  },
	
	  /**
	   * Entity instances are immutable. If you need to update the data for an
	   * instance, this method will merge your data updates and return a new
	   * instance.
	   */
	  __mergeData: function __mergeData(key, toMerge) {
	    var instance = DraftEntity.__get(key);
	    var newData = _extends({}, instance.getData(), toMerge);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  },
	
	  /**
	   * Completely replace the data for a given instance.
	   */
	  __replaceData: function __replaceData(key, newData) {
	    var instance = DraftEntity.__get(key);
	    var newInstance = instance.set('data', newData);
	    instances = instances.set(key, newInstance);
	    return newInstance;
	  }
	};
	
	module.exports = DraftEntity;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getContentStateFragment
	 * @format
	 * 
	 */
	
	'use strict';
	
	var randomizeBlockMapKeys = __webpack_require__(815);
	var removeEntitiesAtEdges = __webpack_require__(816);
	
	var getContentStateFragment = function getContentStateFragment(contentState, selectionState) {
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  // Edge entities should be stripped to ensure that we don't preserve
	  // invalid partial entities when the fragment is reused. We do, however,
	  // preserve entities that are entirely within the selection range.
	  var contentWithoutEdgeEntities = removeEntitiesAtEdges(contentState, selectionState);
	
	  var blockMap = contentWithoutEdgeEntities.getBlockMap();
	  var blockKeys = blockMap.keySeq();
	  var startIndex = blockKeys.indexOf(startKey);
	  var endIndex = blockKeys.indexOf(endKey) + 1;
	
	  return randomizeBlockMapKeys(blockMap.slice(startIndex, endIndex).map(function (block, blockKey) {
	    var text = block.getText();
	    var chars = block.getCharacterList();
	
	    if (startKey === endKey) {
	      return block.merge({
	        text: text.slice(startOffset, endOffset),
	        characterList: chars.slice(startOffset, endOffset)
	      });
	    }
	
	    if (blockKey === startKey) {
	      return block.merge({
	        text: text.slice(startOffset),
	        characterList: chars.slice(startOffset)
	      });
	    }
	
	    if (blockKey === endKey) {
	      return block.merge({
	        text: text.slice(0, endOffset),
	        characterList: chars.slice(0, endOffset)
	      });
	    }
	
	    return block;
	  }));
	};
	
	module.exports = getContentStateFragment;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var _symbol = __webpack_require__(110);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(14);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	var _labelHelper = __webpack_require__(499);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Symbol
	 */
	
	/**
	 * @constructor
	 * @alias {module:echarts/chart/helper/Symbol}
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	function SymbolClz(data, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.updateData(data, idx, seriesScope);
	}
	
	var symbolProto = SymbolClz.prototype;
	/**
	 * @public
	 * @static
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @return {Array.<number>} [width, height]
	 */
	
	var getSymbolSize = SymbolClz.getSymbolSize = function (data, idx) {
	  var symbolSize = data.getItemVisual(idx, 'symbolSize');
	  return symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	};
	
	function getScale(symbolSize) {
	  return [symbolSize[0] / 2, symbolSize[1] / 2];
	}
	
	function driftSymbol(dx, dy) {
	  this.parent.drift(dx, dy);
	}
	
	symbolProto._createSymbol = function (symbolType, data, idx, symbolSize, keepAspect) {
	  // Remove paths created before
	  this.removeAll();
	  var color = data.getItemVisual(idx, 'color'); // var symbolPath = createSymbol(
	  //     symbolType, -0.5, -0.5, 1, 1, color
	  // );
	  // If width/height are set too small (e.g., set to 1) on ios10
	  // and macOS Sierra, a circle stroke become a rect, no matter what
	  // the scale is set. So we set width/height as 2. See #4150.
	
	  var symbolPath = createSymbol(symbolType, -1, -1, 2, 2, color, keepAspect);
	  symbolPath.attr({
	    z2: 100,
	    culling: true,
	    scale: getScale(symbolSize)
	  }); // Rewrite drift method
	
	  symbolPath.drift = driftSymbol;
	  this._symbolType = symbolType;
	  this.add(symbolPath);
	};
	/**
	 * Stop animation
	 * @param {boolean} toLastFrame
	 */
	
	
	symbolProto.stopSymbolAnimation = function (toLastFrame) {
	  this.childAt(0).stopAnimation(toLastFrame);
	};
	/**
	 * FIXME:
	 * Caution: This method breaks the encapsulation of this module,
	 * but it indeed brings convenience. So do not use the method
	 * unless you detailedly know all the implements of `Symbol`,
	 * especially animation.
	 *
	 * Get symbol path element.
	 */
	
	
	symbolProto.getSymbolPath = function () {
	  return this.childAt(0);
	};
	/**
	 * Get scale(aka, current symbol size).
	 * Including the change caused by animation
	 */
	
	
	symbolProto.getScale = function () {
	  return this.childAt(0).scale;
	};
	/**
	 * Highlight symbol
	 */
	
	
	symbolProto.highlight = function () {
	  this.childAt(0).trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	symbolProto.downplay = function () {
	  this.childAt(0).trigger('normal');
	};
	/**
	 * @param {number} zlevel
	 * @param {number} z
	 */
	
	
	symbolProto.setZ = function (zlevel, z) {
	  var symbolPath = this.childAt(0);
	  symbolPath.zlevel = zlevel;
	  symbolPath.z = z;
	};
	
	symbolProto.setDraggable = function (draggable) {
	  var symbolPath = this.childAt(0);
	  symbolPath.draggable = draggable;
	  symbolPath.cursor = draggable ? 'move' : symbolPath.cursor;
	};
	/**
	 * Update symbol properties
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Object} [seriesScope]
	 * @param {Object} [seriesScope.itemStyle]
	 * @param {Object} [seriesScope.hoverItemStyle]
	 * @param {Object} [seriesScope.symbolRotate]
	 * @param {Object} [seriesScope.symbolOffset]
	 * @param {module:echarts/model/Model} [seriesScope.labelModel]
	 * @param {module:echarts/model/Model} [seriesScope.hoverLabelModel]
	 * @param {boolean} [seriesScope.hoverAnimation]
	 * @param {Object} [seriesScope.cursorStyle]
	 * @param {module:echarts/model/Model} [seriesScope.itemModel]
	 * @param {string} [seriesScope.symbolInnerColor]
	 * @param {Object} [seriesScope.fadeIn=false]
	 */
	
	
	symbolProto.updateData = function (data, idx, seriesScope) {
	  this.silent = false;
	  var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	  var seriesModel = data.hostModel;
	  var symbolSize = getSymbolSize(data, idx);
	  var isInit = symbolType !== this._symbolType;
	
	  if (isInit) {
	    var keepAspect = data.getItemVisual(idx, 'symbolKeepAspect');
	
	    this._createSymbol(symbolType, data, idx, symbolSize, keepAspect);
	  } else {
	    var symbolPath = this.childAt(0);
	    symbolPath.silent = false;
	    graphic.updateProps(symbolPath, {
	      scale: getScale(symbolSize)
	    }, seriesModel, idx);
	  }
	
	  this._updateCommon(data, idx, symbolSize, seriesScope);
	
	  if (isInit) {
	    var symbolPath = this.childAt(0);
	    var fadeIn = seriesScope && seriesScope.fadeIn;
	    var target = {
	      scale: symbolPath.scale.slice()
	    };
	    fadeIn && (target.style = {
	      opacity: symbolPath.style.opacity
	    });
	    symbolPath.scale = [0, 0];
	    fadeIn && (symbolPath.style.opacity = 0);
	    graphic.initProps(symbolPath, target, seriesModel, idx);
	  }
	
	  this._seriesModel = seriesModel;
	}; // Update common properties
	
	
	var normalStyleAccessPath = ['itemStyle'];
	var emphasisStyleAccessPath = ['emphasis', 'itemStyle'];
	var normalLabelAccessPath = ['label'];
	var emphasisLabelAccessPath = ['emphasis', 'label'];
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @param {Array.<number>} symbolSize
	 * @param {Object} [seriesScope]
	 */
	
	symbolProto._updateCommon = function (data, idx, symbolSize, seriesScope) {
	  var symbolPath = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var color = data.getItemVisual(idx, 'color'); // Reset style
	
	  if (symbolPath.type !== 'image') {
	    symbolPath.useStyle({
	      strokeNoScale: true
	    });
	  } else {
	    symbolPath.setStyle({
	      opacity: 1,
	      shadowBlur: null,
	      shadowOffsetX: null,
	      shadowOffsetY: null,
	      shadowColor: null
	    });
	  }
	
	  var itemStyle = seriesScope && seriesScope.itemStyle;
	  var hoverItemStyle = seriesScope && seriesScope.hoverItemStyle;
	  var symbolOffset = seriesScope && seriesScope.symbolOffset;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel;
	  var hoverAnimation = seriesScope && seriesScope.hoverAnimation;
	  var cursorStyle = seriesScope && seriesScope.cursorStyle;
	
	  if (!seriesScope || data.hasItemOption) {
	    var itemModel = seriesScope && seriesScope.itemModel ? seriesScope.itemModel : data.getItemModel(idx); // Color must be excluded.
	    // Because symbol provide setColor individually to set fill and stroke
	
	    itemStyle = itemModel.getModel(normalStyleAccessPath).getItemStyle(['color']);
	    hoverItemStyle = itemModel.getModel(emphasisStyleAccessPath).getItemStyle();
	    symbolOffset = itemModel.getShallow('symbolOffset');
	    labelModel = itemModel.getModel(normalLabelAccessPath);
	    hoverLabelModel = itemModel.getModel(emphasisLabelAccessPath);
	    hoverAnimation = itemModel.getShallow('hoverAnimation');
	    cursorStyle = itemModel.getShallow('cursor');
	  } else {
	    hoverItemStyle = zrUtil.extend({}, hoverItemStyle);
	  }
	
	  var elStyle = symbolPath.style;
	  var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
	  symbolPath.attr('rotation', (symbolRotate || 0) * Math.PI / 180 || 0);
	
	  if (symbolOffset) {
	    symbolPath.attr('position', [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])]);
	  }
	
	  cursorStyle && symbolPath.attr('cursor', cursorStyle); // PENDING setColor before setStyle!!!
	
	  symbolPath.setColor(color, seriesScope && seriesScope.symbolInnerColor);
	  symbolPath.setStyle(itemStyle);
	  var opacity = data.getItemVisual(idx, 'opacity');
	
	  if (opacity != null) {
	    elStyle.opacity = opacity;
	  }
	
	  var liftZ = data.getItemVisual(idx, 'liftZ');
	  var z2Origin = symbolPath.__z2Origin;
	
	  if (liftZ != null) {
	    if (z2Origin == null) {
	      symbolPath.__z2Origin = symbolPath.z2;
	      symbolPath.z2 += liftZ;
	    }
	  } else if (z2Origin != null) {
	    symbolPath.z2 = z2Origin;
	    symbolPath.__z2Origin = null;
	  }
	
	  var useNameLabel = seriesScope && seriesScope.useNameLabel;
	  graphic.setLabelStyle(elStyle, hoverItemStyle, labelModel, hoverLabelModel, {
	    labelFetcher: seriesModel,
	    labelDataIndex: idx,
	    defaultText: getLabelDefaultText,
	    isRectText: true,
	    autoColor: color
	  }); // Do not execute util needed.
	
	  function getLabelDefaultText(idx, opt) {
	    return useNameLabel ? data.getName(idx) : getDefaultLabel(data, idx);
	  }
	
	  symbolPath.__symbolOriginalScale = getScale(symbolSize);
	  symbolPath.hoverStyle = hoverItemStyle;
	  symbolPath.highDownOnUpdate = hoverAnimation && seriesModel.isAnimationEnabled() ? highDownOnUpdate : null;
	  graphic.setHoverStyle(symbolPath);
	};
	
	function highDownOnUpdate(fromState, toState) {
	  // Do not support this hover animation util some scenario required.
	  // Animation can only be supported in hover layer when using `el.incremetal`.
	  if (this.incremental || this.useHoverLayer) {
	    return;
	  }
	
	  if (toState === 'emphasis') {
	    var scale = this.__symbolOriginalScale;
	    var ratio = scale[1] / scale[0];
	    var emphasisOpt = {
	      scale: [Math.max(scale[0] * 1.1, scale[0] + 3), Math.max(scale[1] * 1.1, scale[1] + 3 * ratio)]
	    }; // FIXME
	    // modify it after support stop specified animation.
	    // toState === fromState
	    //     ? (this.stopAnimation(), this.attr(emphasisOpt))
	
	    this.animateTo(emphasisOpt, 400, 'elasticOut');
	  } else if (toState === 'normal') {
	    this.animateTo({
	      scale: this.__symbolOriginalScale
	    }, 400, 'elasticOut');
	  }
	}
	/**
	 * @param {Function} cb
	 * @param {Object} [opt]
	 * @param {Object} [opt.keepLabel=true]
	 */
	
	
	symbolProto.fadeOut = function (cb, opt) {
	  var symbolPath = this.childAt(0); // Avoid mistaken hover when fading out
	
	  this.silent = symbolPath.silent = true; // Not show text when animating
	
	  !(opt && opt.keepLabel) && (symbolPath.style.text = null);
	  graphic.updateProps(symbolPath, {
	    style: {
	      opacity: 0
	    },
	    scale: [0, 0]
	  }, this._seriesModel, this.dataIndex, cb);
	};
	
	zrUtil.inherits(SymbolClz, graphic.Group);
	var _default = SymbolClz;
	module.exports = _default;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var KEY_DELIMITER = '-->';
	/**
	 * params handler
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @returns {*}
	 */
	
	var getAutoCurvenessParams = function (seriesModel) {
	  return seriesModel.get('autoCurveness') || null;
	};
	/**
	 * Generate a list of edge curvatures, 20 is the default
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param {number} appendLength
	 * @return  20 => [0, -0.2, 0.2, -0.4, 0.4, -0.6, 0.6, -0.8, 0.8, -1, 1, -1.2, 1.2, -1.4, 1.4, -1.6, 1.6, -1.8, 1.8, -2]
	 */
	
	
	var createCurveness = function (seriesModel, appendLength) {
	  var autoCurvenessParmas = getAutoCurvenessParams(seriesModel);
	  var length = 20;
	  var curvenessList = []; // handler the function set
	
	  if (typeof autoCurvenessParmas === 'number') {
	    length = autoCurvenessParmas;
	  } else if (zrUtil.isArray(autoCurvenessParmas)) {
	    seriesModel.__curvenessList = autoCurvenessParmas;
	    return;
	  } // append length
	
	
	  if (appendLength > length) {
	    length = appendLength;
	  } // make sure the length is even
	
	
	  var len = length % 2 ? length + 2 : length + 3;
	  curvenessList = [];
	
	  for (var i = 0; i < len; i++) {
	    curvenessList.push((i % 2 ? i + 1 : i) / 10 * (i % 2 ? -1 : 1));
	  }
	
	  seriesModel.__curvenessList = curvenessList;
	};
	/**
	 * Create different cache key data in the positive and negative directions, in order to set the curvature later
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @returns {string} key
	 */
	
	
	var getKeyOfEdges = function (n1, n2, seriesModel) {
	  var source = [n1.id, n1.dataIndex].join('.');
	  var target = [n2.id, n2.dataIndex].join('.');
	  return [seriesModel.uid, source, target].join(KEY_DELIMITER);
	};
	/**
	 * get opposite key
	 * @param {string} key
	 * @returns {string}
	 */
	
	
	var getOppositeKey = function (key) {
	  var keys = key.split(KEY_DELIMITER);
	  return [keys[0], keys[2], keys[1]].join(KEY_DELIMITER);
	};
	/**
	 * get edgeMap with key
	 * @param edge
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 */
	
	
	var getEdgeFromMap = function (edge, seriesModel) {
	  var key = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
	  return seriesModel.__edgeMap[key];
	};
	/**
	 * calculate all cases total length
	 * @param edge
	 * @param seriesModel
	 * @returns {number}
	 */
	
	
	var getTotalLengthBetweenNodes = function (edge, seriesModel) {
	  var len = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node1, edge.node2, seriesModel), seriesModel);
	  var lenV = getEdgeMapLengthWithKey(getKeyOfEdges(edge.node2, edge.node1, seriesModel), seriesModel);
	  return len + lenV;
	};
	/**
	 *
	 * @param key
	 */
	
	
	var getEdgeMapLengthWithKey = function (key, seriesModel) {
	  var edgeMap = seriesModel.__edgeMap;
	  return edgeMap[key] ? edgeMap[key].length : 0;
	};
	/**
	 * Count the number of edges between the same two points, used to obtain the curvature table and the parity of the edge
	 * @see /graph/GraphSeries.js@getInitialData
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 */
	
	
	function initCurvenessList(seriesModel) {
	  if (!getAutoCurvenessParams(seriesModel)) {
	    return;
	  }
	
	  seriesModel.__curvenessList = [];
	  seriesModel.__edgeMap = {}; // calc the array of curveness List
	
	  createCurveness(seriesModel);
	}
	/**
	 * set edgeMap with key
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param {number} index
	 */
	
	
	function createEdgeMapForCurveness(n1, n2, seriesModel, index) {
	  if (!getAutoCurvenessParams(seriesModel)) {
	    return;
	  }
	
	  var key = getKeyOfEdges(n1, n2, seriesModel);
	  var edgeMap = seriesModel.__edgeMap;
	  var oppositeEdges = edgeMap[getOppositeKey(key)]; // set direction
	
	  if (edgeMap[key] && !oppositeEdges) {
	    edgeMap[key].isForward = true;
	  } else if (oppositeEdges && edgeMap[key]) {
	    oppositeEdges.isForward = true;
	    edgeMap[key].isForward = false;
	  }
	
	  edgeMap[key] = edgeMap[key] || [];
	  edgeMap[key].push(index);
	}
	/**
	 * get curvature for edge
	 * @param edge
	 * @param {module:echarts/model/SeriesModel} seriesModel
	 * @param index
	 */
	
	
	function getCurvenessForEdge(edge, seriesModel, index, needReverse) {
	  var autoCurvenessParams = getAutoCurvenessParams(seriesModel);
	  var isArrayParam = zrUtil.isArray(autoCurvenessParams);
	
	  if (!autoCurvenessParams) {
	    return null;
	  }
	
	  var edgeArray = getEdgeFromMap(edge, seriesModel);
	
	  if (!edgeArray) {
	    return null;
	  }
	
	  var edgeIndex = -1;
	
	  for (var i = 0; i < edgeArray.length; i++) {
	    if (edgeArray[i] === index) {
	      edgeIndex = i;
	      break;
	    }
	  } // if totalLen is Longer createCurveness
	
	
	  var totalLen = getTotalLengthBetweenNodes(edge, seriesModel);
	  createCurveness(seriesModel, totalLen);
	  edge.lineStyle = edge.lineStyle || {}; // if is opposite edge, must set curvenss to opposite number
	
	  var curKey = getKeyOfEdges(edge.node1, edge.node2, seriesModel);
	  var curvenessList = seriesModel.__curvenessList; // if pass array no need parity
	
	  var parityCorrection = isArrayParam ? 0 : totalLen % 2 ? 0 : 1;
	
	  if (!edgeArray.isForward) {
	    // the opposite edge show outside
	    var oppositeKey = getOppositeKey(curKey);
	    var len = getEdgeMapLengthWithKey(oppositeKey, seriesModel);
	    var resValue = curvenessList[edgeIndex + len + parityCorrection]; // isNeedReverse, simple, force type need reverse the curveness in the junction of the forword and the opposite
	
	    if (needReverse) {
	      // set as array may make the parity handle with the len of opposite
	      if (isArrayParam) {
	        if (autoCurvenessParams && autoCurvenessParams[0] === 0) {
	          return (len + parityCorrection) % 2 ? resValue : -resValue;
	        } else {
	          return ((len % 2 ? 0 : 1) + parityCorrection) % 2 ? resValue : -resValue;
	        }
	      } else {
	        return (len + parityCorrection) % 2 ? resValue : -resValue;
	      }
	    } else {
	      return curvenessList[edgeIndex + len + parityCorrection];
	    }
	  } else {
	    return curvenessList[parityCorrection + edgeIndex];
	  }
	}
	
	exports.initCurvenessList = initCurvenessList;
	exports.createEdgeMapForCurveness = createEdgeMapForCurveness;
	exports.getCurvenessForEdge = getCurvenessForEdge;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Model = __webpack_require__(70);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var curry = zrUtil.curry; // Build axisPointerModel, mergin tooltip.axisPointer model for each axis.
	// allAxesInfo should be updated when setOption performed.
	
	function collect(ecModel, api) {
	  var result = {
	    /**
	     * key: makeKey(axis.model)
	     * value: {
	     *      axis,
	     *      coordSys,
	     *      axisPointerModel,
	     *      triggerTooltip,
	     *      involveSeries,
	     *      snap,
	     *      seriesModels,
	     *      seriesDataCount
	     * }
	     */
	    axesInfo: {},
	    seriesInvolved: false,
	
	    /**
	     * key: makeKey(coordSys.model)
	     * value: Object: key makeKey(axis.model), value: axisInfo
	     */
	    coordSysAxesInfo: {},
	    coordSysMap: {}
	  };
	  collectAxesInfo(result, ecModel, api); // Check seriesInvolved for performance, in case too many series in some chart.
	
	  result.seriesInvolved && collectSeriesInfo(result, ecModel);
	  return result;
	}
	
	function collectAxesInfo(result, ecModel, api) {
	  var globalTooltipModel = ecModel.getComponent('tooltip');
	  var globalAxisPointerModel = ecModel.getComponent('axisPointer'); // links can only be set on global.
	
	  var linksOption = globalAxisPointerModel.get('link', true) || [];
	  var linkGroups = []; // Collect axes info.
	
	  each(api.getCoordinateSystems(), function (coordSys) {
	    // Some coordinate system do not support axes, like geo.
	    if (!coordSys.axisPointerEnabled) {
	      return;
	    }
	
	    var coordSysKey = makeKey(coordSys.model);
	    var axesInfoInCoordSys = result.coordSysAxesInfo[coordSysKey] = {};
	    result.coordSysMap[coordSysKey] = coordSys; // Set tooltip (like 'cross') is a convienent way to show axisPointer
	    // for user. So we enable seting tooltip on coordSys model.
	
	    var coordSysModel = coordSys.model;
	    var baseTooltipModel = coordSysModel.getModel('tooltip', globalTooltipModel);
	    each(coordSys.getAxes(), curry(saveTooltipAxisInfo, false, null)); // If axis tooltip used, choose tooltip axis for each coordSys.
	    // Notice this case: coordSys is `grid` but not `cartesian2D` here.
	
	    if (coordSys.getTooltipAxes && globalTooltipModel // If tooltip.showContent is set as false, tooltip will not
	    // show but axisPointer will show as normal.
	    && baseTooltipModel.get('show')) {
	      // Compatible with previous logic. But series.tooltip.trigger: 'axis'
	      // or series.data[n].tooltip.trigger: 'axis' are not support any more.
	      var triggerAxis = baseTooltipModel.get('trigger') === 'axis';
	      var cross = baseTooltipModel.get('axisPointer.type') === 'cross';
	      var tooltipAxes = coordSys.getTooltipAxes(baseTooltipModel.get('axisPointer.axis'));
	
	      if (triggerAxis || cross) {
	        each(tooltipAxes.baseAxes, curry(saveTooltipAxisInfo, cross ? 'cross' : true, triggerAxis));
	      }
	
	      if (cross) {
	        each(tooltipAxes.otherAxes, curry(saveTooltipAxisInfo, 'cross', false));
	      }
	    } // fromTooltip: true | false | 'cross'
	    // triggerTooltip: true | false | null
	
	
	    function saveTooltipAxisInfo(fromTooltip, triggerTooltip, axis) {
	      var axisPointerModel = axis.model.getModel('axisPointer', globalAxisPointerModel);
	      var axisPointerShow = axisPointerModel.get('show');
	
	      if (!axisPointerShow || axisPointerShow === 'auto' && !fromTooltip && !isHandleTrigger(axisPointerModel)) {
	        return;
	      }
	
	      if (triggerTooltip == null) {
	        triggerTooltip = axisPointerModel.get('triggerTooltip');
	      }
	
	      axisPointerModel = fromTooltip ? makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) : axisPointerModel;
	      var snap = axisPointerModel.get('snap');
	      var key = makeKey(axis.model);
	      var involveSeries = triggerTooltip || snap || axis.type === 'category'; // If result.axesInfo[key] exist, override it (tooltip has higher priority).
	
	      var axisInfo = result.axesInfo[key] = {
	        key: key,
	        axis: axis,
	        coordSys: coordSys,
	        axisPointerModel: axisPointerModel,
	        triggerTooltip: triggerTooltip,
	        involveSeries: involveSeries,
	        snap: snap,
	        useHandle: isHandleTrigger(axisPointerModel),
	        seriesModels: []
	      };
	      axesInfoInCoordSys[key] = axisInfo;
	      result.seriesInvolved |= involveSeries;
	      var groupIndex = getLinkGroupIndex(linksOption, axis);
	
	      if (groupIndex != null) {
	        var linkGroup = linkGroups[groupIndex] || (linkGroups[groupIndex] = {
	          axesInfo: {}
	        });
	        linkGroup.axesInfo[key] = axisInfo;
	        linkGroup.mapper = linksOption[groupIndex].mapper;
	        axisInfo.linkGroup = linkGroup;
	      }
	    }
	  });
	}
	
	function makeAxisPointerModel(axis, baseTooltipModel, globalAxisPointerModel, ecModel, fromTooltip, triggerTooltip) {
	  var tooltipAxisPointerModel = baseTooltipModel.getModel('axisPointer');
	  var volatileOption = {};
	  each(['type', 'snap', 'lineStyle', 'shadowStyle', 'label', 'animation', 'animationDurationUpdate', 'animationEasingUpdate', 'z'], function (field) {
	    volatileOption[field] = zrUtil.clone(tooltipAxisPointerModel.get(field));
	  }); // category axis do not auto snap, otherwise some tick that do not
	  // has value can not be hovered. value/time/log axis default snap if
	  // triggered from tooltip and trigger tooltip.
	
	  volatileOption.snap = axis.type !== 'category' && !!triggerTooltip; // Compatibel with previous behavior, tooltip axis do not show label by default.
	  // Only these properties can be overrided from tooltip to axisPointer.
	
	  if (tooltipAxisPointerModel.get('type') === 'cross') {
	    volatileOption.type = 'line';
	  }
	
	  var labelOption = volatileOption.label || (volatileOption.label = {}); // Follow the convention, do not show label when triggered by tooltip by default.
	
	  labelOption.show == null && (labelOption.show = false);
	
	  if (fromTooltip === 'cross') {
	    // When 'cross', both axes show labels.
	    var tooltipAxisPointerLabelShow = tooltipAxisPointerModel.get('label.show');
	    labelOption.show = tooltipAxisPointerLabelShow != null ? tooltipAxisPointerLabelShow : true; // If triggerTooltip, this is a base axis, which should better not use cross style
	    // (cross style is dashed by default)
	
	    if (!triggerTooltip) {
	      var crossStyle = volatileOption.lineStyle = tooltipAxisPointerModel.get('crossStyle');
	      crossStyle && zrUtil.defaults(labelOption, crossStyle.textStyle);
	    }
	  }
	
	  return axis.model.getModel('axisPointer', new Model(volatileOption, globalAxisPointerModel, ecModel));
	}
	
	function collectSeriesInfo(result, ecModel) {
	  // Prepare data for axis trigger
	  ecModel.eachSeries(function (seriesModel) {
	    // Notice this case: this coordSys is `cartesian2D` but not `grid`.
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesTooltipTrigger = seriesModel.get('tooltip.trigger', true);
	    var seriesTooltipShow = seriesModel.get('tooltip.show', true);
	
	    if (!coordSys || seriesTooltipTrigger === 'none' || seriesTooltipTrigger === false || seriesTooltipTrigger === 'item' || seriesTooltipShow === false || seriesModel.get('axisPointer.show', true) === false) {
	      return;
	    }
	
	    each(result.coordSysAxesInfo[makeKey(coordSys.model)], function (axisInfo) {
	      var axis = axisInfo.axis;
	
	      if (coordSys.getAxis(axis.dim) === axis) {
	        axisInfo.seriesModels.push(seriesModel);
	        axisInfo.seriesDataCount == null && (axisInfo.seriesDataCount = 0);
	        axisInfo.seriesDataCount += seriesModel.getData().count();
	      }
	    });
	  }, this);
	}
	/**
	 * For example:
	 * {
	 *     axisPointer: {
	 *         links: [{
	 *             xAxisIndex: [2, 4],
	 *             yAxisIndex: 'all'
	 *         }, {
	 *             xAxisId: ['a5', 'a7'],
	 *             xAxisName: 'xxx'
	 *         }]
	 *     }
	 * }
	 */
	
	
	function getLinkGroupIndex(linksOption, axis) {
	  var axisModel = axis.model;
	  var dim = axis.dim;
	
	  for (var i = 0; i < linksOption.length; i++) {
	    var linkOption = linksOption[i] || {};
	
	    if (checkPropInLink(linkOption[dim + 'AxisId'], axisModel.id) || checkPropInLink(linkOption[dim + 'AxisIndex'], axisModel.componentIndex) || checkPropInLink(linkOption[dim + 'AxisName'], axisModel.name)) {
	      return i;
	    }
	  }
	}
	
	function checkPropInLink(linkPropValue, axisPropValue) {
	  return linkPropValue === 'all' || zrUtil.isArray(linkPropValue) && zrUtil.indexOf(linkPropValue, axisPropValue) >= 0 || linkPropValue === axisPropValue;
	}
	
	function fixValue(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	
	  if (!axisInfo) {
	    return;
	  }
	
	  var axisPointerModel = axisInfo.axisPointerModel;
	  var scale = axisInfo.axis.scale;
	  var option = axisPointerModel.option;
	  var status = axisPointerModel.get('status');
	  var value = axisPointerModel.get('value'); // Parse init value for category and time axis.
	
	  if (value != null) {
	    value = scale.parse(value);
	  }
	
	  var useHandle = isHandleTrigger(axisPointerModel); // If `handle` used, `axisPointer` will always be displayed, so value
	  // and status should be initialized.
	
	  if (status == null) {
	    option.status = useHandle ? 'show' : 'hide';
	  }
	
	  var extent = scale.getExtent().slice();
	  extent[0] > extent[1] && extent.reverse();
	
	  if ( // Pick a value on axis when initializing.
	  value == null // If both `handle` and `dataZoom` are used, value may be out of axis extent,
	  // where we should re-pick a value to keep `handle` displaying normally.
	  || value > extent[1]) {
	    // Make handle displayed on the end of the axis when init, which looks better.
	    value = extent[1];
	  }
	
	  if (value < extent[0]) {
	    value = extent[0];
	  }
	
	  option.value = value;
	
	  if (useHandle) {
	    option.status = axisInfo.axis.scale.isBlank() ? 'hide' : 'show';
	  }
	}
	
	function getAxisInfo(axisModel) {
	  var coordSysAxesInfo = (axisModel.ecModel.getComponent('axisPointer') || {}).coordSysAxesInfo;
	  return coordSysAxesInfo && coordSysAxesInfo.axesInfo[makeKey(axisModel)];
	}
	
	function getAxisPointerModel(axisModel) {
	  var axisInfo = getAxisInfo(axisModel);
	  return axisInfo && axisInfo.axisPointerModel;
	}
	
	function isHandleTrigger(axisPointerModel) {
	  return !!axisPointerModel.get('handle.show');
	}
	/**
	 * @param {module:echarts/model/Model} model
	 * @return {string} unique key
	 */
	
	
	function makeKey(model) {
	  return model.type + '||' + model.id;
	}
	
	exports.collect = collect;
	exports.fixValue = fixValue;
	exports.getAxisInfo = getAxisInfo;
	exports.getAxisPointerModel = getAxisPointerModel;
	exports.makeKey = makeKey;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var textContain = __webpack_require__(102);
	
	var formatUtil = __webpack_require__(48);
	
	var matrix = __webpack_require__(86);
	
	var axisHelper = __webpack_require__(122);
	
	var AxisBuilder = __webpack_require__(177);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/model/Model} axisPointerModel
	 */
	function buildElStyle(axisPointerModel) {
	  var axisPointerType = axisPointerModel.get('type');
	  var styleModel = axisPointerModel.getModel(axisPointerType + 'Style');
	  var style;
	
	  if (axisPointerType === 'line') {
	    style = styleModel.getLineStyle();
	    style.fill = null;
	  } else if (axisPointerType === 'shadow') {
	    style = styleModel.getAreaStyle();
	    style.stroke = null;
	  }
	
	  return style;
	}
	/**
	 * @param {Function} labelPos {align, verticalAlign, position}
	 */
	
	
	function buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos) {
	  var value = axisPointerModel.get('value');
	  var text = getValueLabel(value, axisModel.axis, axisModel.ecModel, axisPointerModel.get('seriesDataIndices'), {
	    precision: axisPointerModel.get('label.precision'),
	    formatter: axisPointerModel.get('label.formatter')
	  });
	  var labelModel = axisPointerModel.getModel('label');
	  var paddings = formatUtil.normalizeCssArray(labelModel.get('padding') || 0);
	  var font = labelModel.getFont();
	  var textRect = textContain.getBoundingRect(text, font);
	  var position = labelPos.position;
	  var width = textRect.width + paddings[1] + paddings[3];
	  var height = textRect.height + paddings[0] + paddings[2]; // Adjust by align.
	
	  var align = labelPos.align;
	  align === 'right' && (position[0] -= width);
	  align === 'center' && (position[0] -= width / 2);
	  var verticalAlign = labelPos.verticalAlign;
	  verticalAlign === 'bottom' && (position[1] -= height);
	  verticalAlign === 'middle' && (position[1] -= height / 2); // Not overflow ec container
	
	  confineInContainer(position, width, height, api);
	  var bgColor = labelModel.get('backgroundColor');
	
	  if (!bgColor || bgColor === 'auto') {
	    bgColor = axisModel.get('axisLine.lineStyle.color');
	  }
	
	  elOption.label = {
	    shape: {
	      x: 0,
	      y: 0,
	      width: width,
	      height: height,
	      r: labelModel.get('borderRadius')
	    },
	    position: position.slice(),
	    // TODO: rich
	    style: {
	      text: text,
	      textFont: font,
	      textFill: labelModel.getTextColor(),
	      textPosition: 'inside',
	      textPadding: paddings,
	      fill: bgColor,
	      stroke: labelModel.get('borderColor') || 'transparent',
	      lineWidth: labelModel.get('borderWidth') || 0,
	      shadowBlur: labelModel.get('shadowBlur'),
	      shadowColor: labelModel.get('shadowColor'),
	      shadowOffsetX: labelModel.get('shadowOffsetX'),
	      shadowOffsetY: labelModel.get('shadowOffsetY')
	    },
	    // Lable should be over axisPointer.
	    z2: 10
	  };
	} // Do not overflow ec container
	
	
	function confineInContainer(position, width, height, api) {
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  position[0] = Math.min(position[0] + width, viewWidth) - width;
	  position[1] = Math.min(position[1] + height, viewHeight) - height;
	  position[0] = Math.max(position[0], 0);
	  position[1] = Math.max(position[1], 0);
	}
	/**
	 * @param {number} value
	 * @param {module:echarts/coord/Axis} axis
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} opt
	 * @param {Array.<Object>} seriesDataIndices
	 * @param {number|string} opt.precision 'auto' or a number
	 * @param {string|Function} opt.formatter label formatter
	 */
	
	
	function getValueLabel(value, axis, ecModel, seriesDataIndices, opt) {
	  value = axis.scale.parse(value);
	  var text = axis.scale.getLabel( // If `precision` is set, width can be fixed (like '12.00500'), which
	  // helps to debounce when when moving label.
	  value, {
	    precision: opt.precision
	  });
	  var formatter = opt.formatter;
	
	  if (formatter) {
	    var params = {
	      value: axisHelper.getAxisRawValue(axis, value),
	      axisDimension: axis.dim,
	      axisIndex: axis.index,
	      seriesData: []
	    };
	    zrUtil.each(seriesDataIndices, function (idxItem) {
	      var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	      var dataIndex = idxItem.dataIndexInside;
	      var dataParams = series && series.getDataParams(dataIndex);
	      dataParams && params.seriesData.push(dataParams);
	    });
	
	    if (zrUtil.isString(formatter)) {
	      text = formatter.replace('{value}', text);
	    } else if (zrUtil.isFunction(formatter)) {
	      text = formatter(params);
	    }
	  }
	
	  return text;
	}
	/**
	 * @param {module:echarts/coord/Axis} axis
	 * @param {number} value
	 * @param {Object} layoutInfo {
	 *  rotation, position, labelOffset, labelDirection, labelMargin
	 * }
	 */
	
	
	function getTransformedPosition(axis, value, layoutInfo) {
	  var transform = matrix.create();
	  matrix.rotate(transform, transform, layoutInfo.rotation);
	  matrix.translate(transform, transform, layoutInfo.position);
	  return graphic.applyTransform([axis.dataToCoord(value), (layoutInfo.labelOffset || 0) + (layoutInfo.labelDirection || 1) * (layoutInfo.labelMargin || 0)], transform);
	}
	
	function buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api) {
	  var textLayout = AxisBuilder.innerTextLayout(layoutInfo.rotation, 0, layoutInfo.labelDirection);
	  layoutInfo.labelMargin = axisPointerModel.get('label.margin');
	  buildLabelElOption(elOption, axisModel, axisPointerModel, api, {
	    position: getTransformedPosition(axisModel.axis, value, layoutInfo),
	    align: textLayout.textAlign,
	    verticalAlign: textLayout.textVerticalAlign
	  });
	}
	/**
	 * @param {Array.<number>} p1
	 * @param {Array.<number>} p2
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeLineShape(p1, p2, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x1: p1[xDimIndex],
	    y1: p1[1 - xDimIndex],
	    x2: p2[xDimIndex],
	    y2: p2[1 - xDimIndex]
	  };
	}
	/**
	 * @param {Array.<number>} xy
	 * @param {Array.<number>} wh
	 * @param {number} [xDimIndex=0] or 1
	 */
	
	
	function makeRectShape(xy, wh, xDimIndex) {
	  xDimIndex = xDimIndex || 0;
	  return {
	    x: xy[xDimIndex],
	    y: xy[1 - xDimIndex],
	    width: wh[xDimIndex],
	    height: wh[1 - xDimIndex]
	  };
	}
	
	function makeSectorShape(cx, cy, r0, r, startAngle, endAngle) {
	  return {
	    cx: cx,
	    cy: cy,
	    r0: r0,
	    r: r,
	    startAngle: startAngle,
	    endAngle: endAngle,
	    clockwise: true
	  };
	}
	
	exports.buildElStyle = buildElStyle;
	exports.buildLabelElOption = buildLabelElOption;
	exports.getValueLabel = getValueLabel;
	exports.getTransformedPosition = getTransformedPosition;
	exports.buildCartesianSingleLabelElOption = buildCartesianSingleLabelElOption;
	exports.makeLineShape = makeLineShape;
	exports.makeRectShape = makeRectShape;
	exports.makeSectorShape = makeSectorShape;

/***/ },
/* 356 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var IRRELEVANT_EXCLUDES = {
	  'axisPointer': 1,
	  'tooltip': 1,
	  'brush': 1
	};
	/**
	 * Avoid that: mouse click on a elements that is over geo or graph,
	 * but roam is triggered.
	 */
	
	function onIrrelevantElement(e, api, targetCoordSysModel) {
	  var model = api.getComponentByElement(e.topTarget); // If model is axisModel, it works only if it is injected with coordinateSystem.
	
	  var coordSys = model && model.coordinateSystem;
	  return model && model !== targetCoordSysModel && !IRRELEVANT_EXCLUDES[model.mainType] && coordSys && coordSys.model !== targetCoordSysModel;
	}
	
	exports.onIrrelevantElement = onIrrelevantElement;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var axisDefault = __webpack_require__(862);
	
	var ComponentModel = __webpack_require__(76);
	
	var _layout = __webpack_require__(46);
	
	var getLayoutParams = _layout.getLayoutParams;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	var OrdinalMeta = __webpack_require__(870);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME axisType is fixed ?
	var AXIS_TYPES = ['value', 'category', 'time', 'log'];
	/**
	 * Generate sub axis model class
	 * @param {string} axisName 'x' 'y' 'radius' 'angle' 'parallel'
	 * @param {module:echarts/model/Component} BaseAxisModelClass
	 * @param {Function} axisTypeDefaulter
	 * @param {Object} [extraDefaultOption]
	 */
	
	function _default(axisName, BaseAxisModelClass, axisTypeDefaulter, extraDefaultOption) {
	  zrUtil.each(AXIS_TYPES, function (axisType) {
	    BaseAxisModelClass.extend({
	      /**
	       * @readOnly
	       */
	      type: axisName + 'Axis.' + axisType,
	      mergeDefaultAndTheme: function (option, ecModel) {
	        var layoutMode = this.layoutMode;
	        var inputPositionParams = layoutMode ? getLayoutParams(option) : {};
	        var themeModel = ecModel.getTheme();
	        zrUtil.merge(option, themeModel.get(axisType + 'Axis'));
	        zrUtil.merge(option, this.getDefaultOption());
	        option.type = axisTypeDefaulter(axisName, option);
	
	        if (layoutMode) {
	          mergeLayoutParam(option, inputPositionParams, layoutMode);
	        }
	      },
	
	      /**
	       * @override
	       */
	      optionUpdated: function () {
	        var thisOption = this.option;
	
	        if (thisOption.type === 'category') {
	          this.__ordinalMeta = OrdinalMeta.createByAxisModel(this);
	        }
	      },
	
	      /**
	       * Should not be called before all of 'getInitailData' finished.
	       * Because categories are collected during initializing data.
	       */
	      getCategories: function (rawData) {
	        var option = this.option; // FIXME
	        // warning if called before all of 'getInitailData' finished.
	
	        if (option.type === 'category') {
	          if (rawData) {
	            return option.data;
	          }
	
	          return this.__ordinalMeta.categories;
	        }
	      },
	      getOrdinalMeta: function () {
	        return this.__ordinalMeta;
	      },
	      defaultOption: zrUtil.mergeAll([{}, axisDefault[axisType + 'Axis'], extraDefaultOption], true)
	    });
	  });
	  ComponentModel.registerSubTypeDefaulter(axisName + 'Axis', zrUtil.curry(axisTypeDefaulter, axisName));
	}
	
	module.exports = _default;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	
	var mapDataStorage = __webpack_require__(514);
	
	var geoJSONLoader = __webpack_require__(2411);
	
	var geoSVGLoader = __webpack_require__(2412);
	
	var BoundingRect = __webpack_require__(60);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var loaders = {
	  geoJSON: geoJSONLoader,
	  svg: geoSVGLoader
	};
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} nameMap
	   * @param {string} nameProperty
	   * @return {Object} source {regions, regionsMap, nameCoordMap, boundingRect}
	   */
	  load: function (mapName, nameMap, nameProperty) {
	    var regions = [];
	    var regionsMap = createHashMap();
	    var nameCoordMap = createHashMap();
	    var boundingRect;
	    var mapRecords = retrieveMap(mapName);
	    each(mapRecords, function (record) {
	      var singleSource = loaders[record.type].load(mapName, record, nameProperty);
	      each(singleSource.regions, function (region) {
	        var regionName = region.name; // Try use the alias in geoNameMap
	
	        if (nameMap && nameMap.hasOwnProperty(regionName)) {
	          region = region.cloneShallow(regionName = nameMap[regionName]);
	        }
	
	        regions.push(region);
	        regionsMap.set(regionName, region);
	        nameCoordMap.set(regionName, region.center);
	      });
	      var rect = singleSource.boundingRect;
	
	      if (rect) {
	        boundingRect ? boundingRect.union(rect) : boundingRect = rect.clone();
	      }
	    });
	    return {
	      regions: regions,
	      regionsMap: regionsMap,
	      nameCoordMap: nameCoordMap,
	      // FIXME Always return new ?
	      boundingRect: boundingRect || new BoundingRect(0, 0, 0, 0)
	    };
	  },
	
	  /**
	   * @param {string} mapName
	   * @param {string} hostKey For cache.
	   * @return {Array.<module:zrender/Element>} Roots.
	   */
	  makeGraphic: makeInvoker('makeGraphic'),
	
	  /**
	   * @param {string} mapName
	   * @param {string} hostKey For cache.
	   */
	  removeGraphic: makeInvoker('removeGraphic')
	};
	
	function makeInvoker(methodName) {
	  return function (mapName, hostKey) {
	    var mapRecords = retrieveMap(mapName);
	    var results = [];
	    each(mapRecords, function (record) {
	      var method = loaders[record.type][methodName];
	      method && results.push(method(mapName, record, hostKey));
	    });
	    return results;
	  };
	}
	
	function mapNotExistsError(mapName) {}
	
	function retrieveMap(mapName) {
	  var mapRecords = mapDataStorage.retrieveMap(mapName) || [];
	  return mapRecords;
	}
	
	module.exports = _default;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	var _dataStackHelper = __webpack_require__(140);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	var createRenderPlanner = __webpack_require__(246);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var STACK_PREFIX = '__ec_stack_';
	var LARGE_BAR_MIN_WIDTH = 0.5;
	var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
	
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || STACK_PREFIX + seriesModel.seriesIndex;
	}
	
	function getAxisKey(axis) {
	  return axis.dim + axis.index;
	}
	/**
	 * @param {Object} opt
	 * @param {module:echarts/coord/Axis} opt.axis Only support category axis currently.
	 * @param {number} opt.count Positive interger.
	 * @param {number} [opt.barWidth]
	 * @param {number} [opt.barMaxWidth]
	 * @param {number} [opt.barMinWidth]
	 * @param {number} [opt.barGap]
	 * @param {number} [opt.barCategoryGap]
	 * @return {Object} {width, offset, offsetCenter} If axis.type is not 'category', return undefined.
	 */
	
	
	function getLayoutOnAxis(opt) {
	  var params = [];
	  var baseAxis = opt.axis;
	  var axisKey = 'axis0';
	
	  if (baseAxis.type !== 'category') {
	    return;
	  }
	
	  var bandWidth = baseAxis.getBandWidth();
	
	  for (var i = 0; i < opt.count || 0; i++) {
	    params.push(zrUtil.defaults({
	      bandWidth: bandWidth,
	      axisKey: axisKey,
	      stackId: STACK_PREFIX + i
	    }, opt));
	  }
	
	  var widthAndOffsets = doCalBarWidthAndOffset(params);
	  var result = [];
	
	  for (var i = 0; i < opt.count; i++) {
	    var item = widthAndOffsets[axisKey][STACK_PREFIX + i];
	    item.offsetCenter = item.offset + item.width / 2;
	    result.push(item);
	  }
	
	  return result;
	}
	
	function prepareLayoutBarSeries(seriesType, ecModel) {
	  var seriesModels = [];
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for cartesian2d only
	    if (isOnCartesian(seriesModel) && !isInLargeMode(seriesModel)) {
	      seriesModels.push(seriesModel);
	    }
	  });
	  return seriesModels;
	}
	/**
	 * Map from (baseAxis.dim + '_' + baseAxis.index) to min gap of two adjacent
	 * values.
	 * This works for time axes, value axes, and log axes.
	 * For a single time axis, return value is in the form like
	 * {'x_0': [1000000]}.
	 * The value of 1000000 is in milliseconds.
	 */
	
	
	function getValueAxesMinGaps(barSeries) {
	  /**
	   * Map from axis.index to values.
	   * For a single time axis, axisValues is in the form like
	   * {'x_0': [1495555200000, 1495641600000, 1495728000000]}.
	   * Items in axisValues[x], e.g. 1495555200000, are time values of all
	   * series.
	   */
	  var axisValues = {};
	  zrUtil.each(barSeries, function (seriesModel) {
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	
	    if (baseAxis.type !== 'time' && baseAxis.type !== 'value') {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var key = baseAxis.dim + '_' + baseAxis.index;
	    var dim = data.mapDimension(baseAxis.dim);
	
	    for (var i = 0, cnt = data.count(); i < cnt; ++i) {
	      var value = data.get(dim, i);
	
	      if (!axisValues[key]) {
	        // No previous data for the axis
	        axisValues[key] = [value];
	      } else {
	        // No value in previous series
	        axisValues[key].push(value);
	      } // Ignore duplicated time values in the same axis
	
	    }
	  });
	  var axisMinGaps = [];
	
	  for (var key in axisValues) {
	    if (axisValues.hasOwnProperty(key)) {
	      var valuesInAxis = axisValues[key];
	
	      if (valuesInAxis) {
	        // Sort axis values into ascending order to calculate gaps
	        valuesInAxis.sort(function (a, b) {
	          return a - b;
	        });
	        var min = null;
	
	        for (var j = 1; j < valuesInAxis.length; ++j) {
	          var delta = valuesInAxis[j] - valuesInAxis[j - 1];
	
	          if (delta > 0) {
	            // Ignore 0 delta because they are of the same axis value
	            min = min === null ? delta : Math.min(min, delta);
	          }
	        } // Set to null if only have one data
	
	
	        axisMinGaps[key] = min;
	      }
	    }
	  }
	
	  return axisMinGaps;
	}
	
	function makeColumnLayout(barSeries) {
	  var axisMinGaps = getValueAxesMinGaps(barSeries);
	  var seriesInfoList = [];
	  zrUtil.each(barSeries, function (seriesModel) {
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth;
	
	    if (baseAxis.type === 'category') {
	      bandWidth = baseAxis.getBandWidth();
	    } else if (baseAxis.type === 'value' || baseAxis.type === 'time') {
	      var key = baseAxis.dim + '_' + baseAxis.index;
	      var minGap = axisMinGaps[key];
	      var extentSpan = Math.abs(axisExtent[1] - axisExtent[0]);
	      var scale = baseAxis.scale.getExtent();
	      var scaleSpan = Math.abs(scale[1] - scale[0]);
	      bandWidth = minGap ? extentSpan / scaleSpan * minGap : extentSpan; // When there is only one data value
	    } else {
	      var data = seriesModel.getData();
	      bandWidth = Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    }
	
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barMinWidth = parsePercent( // barMinWidth by default is 1 in cartesian. Because in value axis,
	    // the auto-calculated bar width might be less than 1.
	    seriesModel.get('barMinWidth') || 1, bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	    seriesInfoList.push({
	      bandWidth: bandWidth,
	      barWidth: barWidth,
	      barMaxWidth: barMaxWidth,
	      barMinWidth: barMinWidth,
	      barGap: barGap,
	      barCategoryGap: barCategoryGap,
	      axisKey: getAxisKey(baseAxis),
	      stackId: getSeriesStackId(seriesModel)
	    });
	  });
	  return doCalBarWidthAndOffset(seriesInfoList);
	}
	
	function doCalBarWidthAndOffset(seriesInfoList) {
	  // Columns info on each category axis. Key is cartesian name
	  var columnsMap = {};
	  zrUtil.each(seriesInfoList, function (seriesInfo, idx) {
	    var axisKey = seriesInfo.axisKey;
	    var bandWidth = seriesInfo.bandWidth;
	    var columnsOnAxis = columnsMap[axisKey] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[axisKey] = columnsOnAxis;
	    var stackId = seriesInfo.stackId;
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    }; // Caution: In a single coordinate system, these barGrid attributes
	    // will be shared by series. Consider that they have default values,
	    // only the attributes set on the last series will work.
	    // Do not change this fact unless there will be a break change.
	
	    var barWidth = seriesInfo.barWidth;
	
	    if (barWidth && !stacks[stackId].width) {
	      // See #6312, do not restrict width.
	      stacks[stackId].width = barWidth;
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    var barMaxWidth = seriesInfo.barMaxWidth;
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    var barMinWidth = seriesInfo.barMinWidth;
	    barMinWidth && (stacks[stackId].minWidth = barMinWidth);
	    var barGap = seriesInfo.barGap;
	    barGap != null && (columnsOnAxis.gap = barGap);
	    var barCategoryGap = seriesInfo.barCategoryGap;
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column) {
	      var maxWidth = column.maxWidth;
	      var minWidth = column.minWidth;
	
	      if (!column.width) {
	        var finalWidth = autoWidth;
	
	        if (maxWidth && maxWidth < finalWidth) {
	          finalWidth = Math.min(maxWidth, remainedWidth);
	        } // `minWidth` has higher priority. `minWidth` decide that wheter the
	        // bar is able to be visible. So `minWidth` should not be restricted
	        // by `maxWidth` or `remainedWidth` (which is from `bandWidth`). In
	        // the extreme cases for `value` axis, bars are allowed to overlap
	        // with each other if `minWidth` specified.
	
	
	        if (minWidth && minWidth > finalWidth) {
	          finalWidth = minWidth;
	        }
	
	        if (finalWidth !== autoWidth) {
	          column.width = finalWidth;
	          remainedWidth -= finalWidth + barGapPercent * finalWidth;
	          autoWidthCount--;
	        }
	      } else {
	        // `barMinWidth/barMaxWidth` has higher priority than `barWidth`, as
	        // CSS does. Becuase barWidth can be a percent value, where
	        // `barMaxWidth` can be used to restrict the final width.
	        var finalWidth = column.width;
	
	        if (maxWidth) {
	          finalWidth = Math.min(finalWidth, maxWidth);
	        } // `minWidth` has higher priority, as described above
	
	
	        if (minWidth) {
	          finalWidth = Math.max(finalWidth, minWidth);
	        }
	
	        column.width = finalWidth;
	        remainedWidth -= finalWidth + barGapPercent * finalWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        bandWidth: bandWidth,
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	/**
	 * @param {Object} barWidthAndOffset The result of makeColumnLayout
	 * @param {module:echarts/coord/Axis} axis
	 * @param {module:echarts/model/Series} [seriesModel] If not provided, return all.
	 * @return {Object} {stackId: {offset, width}} or {offset, width} if seriesModel provided.
	 */
	
	
	function retrieveColumnLayout(barWidthAndOffset, axis, seriesModel) {
	  if (barWidthAndOffset && axis) {
	    var result = barWidthAndOffset[getAxisKey(axis)];
	
	    if (result != null && seriesModel != null) {
	      result = result[getSeriesStackId(seriesModel)];
	    }
	
	    return result;
	  }
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function layout(seriesType, ecModel) {
	  var seriesModels = prepareLayoutBarSeries(seriesType, ecModel);
	  var barWidthAndOffset = makeColumnLayout(seriesModels);
	  var lastStackCoords = {};
	  var lastStackCoordsOrigin = {};
	  zrUtil.each(seriesModels, function (seriesModel) {
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[getAxisKey(baseAxis)][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = cartesian.getOtherAxis(baseAxis);
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    lastStackCoordsOrigin[stackId] = lastStackCoordsOrigin[stackId] || []; // Fix #4243
	
	    data.setLayout({
	      bandWidth: columnLayoutInfo.bandWidth,
	      offset: columnOffset,
	      size: columnWidth
	    });
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var stacked = isDimensionStacked(data, valueDim
	    /*, baseDim*/
	    );
	    var isValueAxisH = valueAxis.isHorizontal();
	    var valueAxisStart = getValueAxisStart(baseAxis, valueAxis, stacked);
	
	    for (var idx = 0, len = data.count(); idx < len; idx++) {
	      var value = data.get(valueDim, idx);
	      var baseValue = data.get(baseDim, idx);
	      var sign = value >= 0 ? 'p' : 'n';
	      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
	      // stackResultDimension directly.
	
	      if (stacked) {
	        // Only ordinal axis can be stacked.
	        if (!lastStackCoords[stackId][baseValue]) {
	          lastStackCoords[stackId][baseValue] = {
	            p: valueAxisStart,
	            // Positive stack
	            n: valueAxisStart // Negative stack
	
	          };
	        } // Should also consider #4243
	
	
	        baseCoord = lastStackCoords[stackId][baseValue][sign];
	      }
	
	      var x;
	      var y;
	      var width;
	      var height;
	
	      if (isValueAxisH) {
	        var coord = cartesian.dataToPoint([value, baseValue]);
	        x = baseCoord;
	        y = coord[1] + columnOffset;
	        width = coord[0] - valueAxisStart;
	        height = columnWidth;
	
	        if (Math.abs(width) < barMinHeight) {
	          width = (width < 0 ? -1 : 1) * barMinHeight;
	        } // Ignore stack from NaN value
	
	
	        if (!isNaN(width)) {
	          stacked && (lastStackCoords[stackId][baseValue][sign] += width);
	        }
	      } else {
	        var coord = cartesian.dataToPoint([baseValue, value]);
	        x = coord[0] + columnOffset;
	        y = baseCoord;
	        width = columnWidth;
	        height = coord[1] - valueAxisStart;
	
	        if (Math.abs(height) < barMinHeight) {
	          // Include zero to has a positive bar
	          height = (height <= 0 ? -1 : 1) * barMinHeight;
	        } // Ignore stack from NaN value
	
	
	        if (!isNaN(height)) {
	          stacked && (lastStackCoords[stackId][baseValue][sign] += height);
	        }
	      }
	
	      data.setItemLayout(idx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      });
	    }
	  }, this);
	} // TODO: Do not support stack in large mode yet.
	
	
	var largeLayout = {
	  seriesType: 'bar',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    if (!isOnCartesian(seriesModel) || !isInLargeMode(seriesModel)) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var cartesian = seriesModel.coordinateSystem;
	    var coordLayout = cartesian.grid.getRect();
	    var baseAxis = cartesian.getBaseAxis();
	    var valueAxis = cartesian.getOtherAxis(baseAxis);
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var valueAxisHorizontal = valueAxis.isHorizontal();
	    var valueDimIdx = valueAxisHorizontal ? 0 : 1;
	    var barWidth = retrieveColumnLayout(makeColumnLayout([seriesModel]), baseAxis, seriesModel).width;
	
	    if (!(barWidth > LARGE_BAR_MIN_WIDTH)) {
	      // jshint ignore:line
	      barWidth = LARGE_BAR_MIN_WIDTH;
	    }
	
	    return {
	      progress: progress
	    };
	
	    function progress(params, data) {
	      var count = params.count;
	      var largePoints = new LargeArr(count * 2);
	      var largeBackgroundPoints = new LargeArr(count * 2);
	      var largeDataIndices = new LargeArr(count);
	      var dataIndex;
	      var coord = [];
	      var valuePair = [];
	      var pointsOffset = 0;
	      var idxOffset = 0;
	
	      while ((dataIndex = params.next()) != null) {
	        valuePair[valueDimIdx] = data.get(valueDim, dataIndex);
	        valuePair[1 - valueDimIdx] = data.get(baseDim, dataIndex);
	        coord = cartesian.dataToPoint(valuePair, null, coord); // Data index might not be in order, depends on `progressiveChunkMode`.
	
	        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coordLayout.x + coordLayout.width : coord[0];
	        largePoints[pointsOffset++] = coord[0];
	        largeBackgroundPoints[pointsOffset] = valueAxisHorizontal ? coord[1] : coordLayout.y + coordLayout.height;
	        largePoints[pointsOffset++] = coord[1];
	        largeDataIndices[idxOffset++] = dataIndex;
	      }
	
	      data.setLayout({
	        largePoints: largePoints,
	        largeDataIndices: largeDataIndices,
	        largeBackgroundPoints: largeBackgroundPoints,
	        barWidth: barWidth,
	        valueAxisStart: getValueAxisStart(baseAxis, valueAxis, false),
	        backgroundStart: valueAxisHorizontal ? coordLayout.x : coordLayout.y,
	        valueAxisHorizontal: valueAxisHorizontal
	      });
	    }
	  }
	};
	
	function isOnCartesian(seriesModel) {
	  return seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'cartesian2d';
	}
	
	function isInLargeMode(seriesModel) {
	  return seriesModel.pipelineContext && seriesModel.pipelineContext.large;
	} // See cases in `test/bar-start.html` and `#7412`, `#8747`.
	
	
	function getValueAxisStart(baseAxis, valueAxis, stacked) {
	  return valueAxis.toGlobalCoord(valueAxis.dataToCoord(valueAxis.type === 'log' ? 1 : 0));
	}
	
	exports.getLayoutOnAxis = getLayoutOnAxis;
	exports.prepareLayoutBarSeries = prepareLayoutBarSeries;
	exports.makeColumnLayout = makeColumnLayout;
	exports.retrieveColumnLayout = retrieveColumnLayout;
	exports.layout = layout;
	exports.largeLayout = largeLayout;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var numberUtil = __webpack_require__(25);
	
	var formatUtil = __webpack_require__(48);
	
	var Scale = __webpack_require__(361);
	
	var helper = __webpack_require__(877);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Interval scale
	 * @module echarts/scale/Interval
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @alias module:echarts/coord/scale/Interval
	 * @constructor
	 */
	
	var IntervalScale = Scale.extend({
	  type: 'interval',
	  _interval: 0,
	  _intervalPrecision: 2,
	  setExtent: function (start, end) {
	    var thisExtent = this._extent; //start,end may be a Number like '25',so...
	
	    if (!isNaN(start)) {
	      thisExtent[0] = parseFloat(start);
	    }
	
	    if (!isNaN(end)) {
	      thisExtent[1] = parseFloat(end);
	    }
	  },
	  unionExtent: function (other) {
	    var extent = this._extent;
	    other[0] < extent[0] && (extent[0] = other[0]);
	    other[1] > extent[1] && (extent[1] = other[1]); // unionExtent may called by it's sub classes
	
	    IntervalScale.prototype.setExtent.call(this, extent[0], extent[1]);
	  },
	
	  /**
	   * Get interval
	   */
	  getInterval: function () {
	    return this._interval;
	  },
	
	  /**
	   * Set interval
	   */
	  setInterval: function (interval) {
	    this._interval = interval; // Dropped auto calculated niceExtent and use user setted extent
	    // We assume user wan't to set both interval, min, max to get a better result
	
	    this._niceExtent = this._extent.slice();
	    this._intervalPrecision = helper.getIntervalPrecision(interval);
	  },
	
	  /**
	   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
	   * @return {Array.<number>}
	   */
	  getTicks: function (expandToNicedExtent) {
	    var interval = this._interval;
	    var extent = this._extent;
	    var niceTickExtent = this._niceExtent;
	    var intervalPrecision = this._intervalPrecision;
	    var ticks = []; // If interval is 0, return [];
	
	    if (!interval) {
	      return ticks;
	    } // Consider this case: using dataZoom toolbox, zoom and zoom.
	
	
	    var safeLimit = 10000;
	
	    if (extent[0] < niceTickExtent[0]) {
	      if (expandToNicedExtent) {
	        ticks.push(roundNumber(niceTickExtent[0] - interval, intervalPrecision));
	      } else {
	        ticks.push(extent[0]);
	      }
	    }
	
	    var tick = niceTickExtent[0];
	
	    while (tick <= niceTickExtent[1]) {
	      ticks.push(tick); // Avoid rounding error
	
	      tick = roundNumber(tick + interval, intervalPrecision);
	
	      if (tick === ticks[ticks.length - 1]) {
	        // Consider out of safe float point, e.g.,
	        // -3711126.9907707 + 2e-10 === -3711126.9907707
	        break;
	      }
	
	      if (ticks.length > safeLimit) {
	        return [];
	      }
	    } // Consider this case: the last item of ticks is smaller
	    // than niceTickExtent[1] and niceTickExtent[1] === extent[1].
	
	
	    var lastNiceTick = ticks.length ? ticks[ticks.length - 1] : niceTickExtent[1];
	
	    if (extent[1] > lastNiceTick) {
	      if (expandToNicedExtent) {
	        ticks.push(roundNumber(lastNiceTick + interval, intervalPrecision));
	      } else {
	        ticks.push(extent[1]);
	      }
	    }
	
	    return ticks;
	  },
	
	  /**
	   * @param {number} [splitNumber=5]
	   * @return {Array.<Array.<number>>}
	   */
	  getMinorTicks: function (splitNumber) {
	    var ticks = this.getTicks(true);
	    var minorTicks = [];
	    var extent = this.getExtent();
	
	    for (var i = 1; i < ticks.length; i++) {
	      var nextTick = ticks[i];
	      var prevTick = ticks[i - 1];
	      var count = 0;
	      var minorTicksGroup = [];
	      var interval = nextTick - prevTick;
	      var minorInterval = interval / splitNumber;
	
	      while (count < splitNumber - 1) {
	        var minorTick = numberUtil.round(prevTick + (count + 1) * minorInterval); // For the first and last interval. The count may be less than splitNumber.
	
	        if (minorTick > extent[0] && minorTick < extent[1]) {
	          minorTicksGroup.push(minorTick);
	        }
	
	        count++;
	      }
	
	      minorTicks.push(minorTicksGroup);
	    }
	
	    return minorTicks;
	  },
	
	  /**
	   * @param {number} data
	   * @param {Object} [opt]
	   * @param {number|string} [opt.precision] If 'auto', use nice presision.
	   * @param {boolean} [opt.pad] returns 1.50 but not 1.5 if precision is 2.
	   * @return {string}
	   */
	  getLabel: function (data, opt) {
	    if (data == null) {
	      return '';
	    }
	
	    var precision = opt && opt.precision;
	
	    if (precision == null) {
	      precision = numberUtil.getPrecisionSafe(data) || 0;
	    } else if (precision === 'auto') {
	      // Should be more precise then tick.
	      precision = this._intervalPrecision;
	    } // (1) If `precision` is set, 12.005 should be display as '12.00500'.
	    // (2) Use roundNumber (toFixed) to avoid scientific notation like '3.5e-7'.
	
	
	    data = roundNumber(data, precision, true);
	    return formatUtil.addCommas(data);
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   *
	   * @param {number} [splitNumber = 5] Desired number of ticks
	   * @param {number} [minInterval]
	   * @param {number} [maxInterval]
	   */
	  niceTicks: function (splitNumber, minInterval, maxInterval) {
	    splitNumber = splitNumber || 5;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (!isFinite(span)) {
	      return;
	    } // User may set axis min 0 and data are all negative
	    // FIXME If it needs to reverse ?
	
	
	    if (span < 0) {
	      span = -span;
	      extent.reverse();
	    }
	
	    var result = helper.intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval);
	    this._intervalPrecision = result.intervalPrecision;
	    this._interval = result.interval;
	    this._niceExtent = result.niceTickExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @param {Object} opt
	   * @param {number} [opt.splitNumber = 5] Given approx tick number
	   * @param {boolean} [opt.fixMin=false]
	   * @param {boolean} [opt.fixMax=false]
	   * @param {boolean} [opt.minInterval]
	   * @param {boolean} [opt.maxInterval]
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      if (extent[0] !== 0) {
	        // Expand extent
	        var expandSize = extent[0]; // In the fowllowing case
	        //      Axis has been fixed max 100
	        //      Plus data are all 100 and axis extent are [100, 100].
	        // Extend to the both side will cause expanded max is larger than fixed max.
	        // So only expand to the smaller side.
	
	        if (!opt.fixMax) {
	          extent[1] += expandSize / 2;
	          extent[0] -= expandSize / 2;
	        } else {
	          extent[0] -= expandSize / 2;
	        }
	      } else {
	        extent[1] = 1;
	      }
	    }
	
	    var span = extent[1] - extent[0]; // If there are no data and extent are [Infinity, -Infinity]
	
	    if (!isFinite(span)) {
	      extent[0] = 0;
	      extent[1] = 1;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = roundNumber(Math.floor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = roundNumber(Math.ceil(extent[1] / interval) * interval);
	    }
	  }
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	IntervalScale.create = function () {
	  return new IntervalScale();
	};
	
	var _default = IntervalScale;
	module.exports = _default;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var clazzUtil = __webpack_require__(161);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * // Scale class management
	 * @module echarts/scale/Scale
	 */
	
	/**
	 * @param {Object} [setting]
	 */
	function Scale(setting) {
	  this._setting = setting || {};
	  /**
	   * Extent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._extent = [Infinity, -Infinity];
	  /**
	   * Step is calculated in adjustExtent
	   * @type {Array.<number>}
	   * @protected
	   */
	
	  this._interval = 0;
	  this.init && this.init.apply(this, arguments);
	}
	/**
	 * Parse input val to valid inner number.
	 * @param {*} val
	 * @return {number}
	 */
	
	
	Scale.prototype.parse = function (val) {
	  // Notice: This would be a trap here, If the implementation
	  // of this method depends on extent, and this method is used
	  // before extent set (like in dataZoom), it would be wrong.
	  // Nevertheless, parse does not depend on extent generally.
	  return val;
	};
	
	Scale.prototype.getSetting = function (name) {
	  return this._setting[name];
	};
	
	Scale.prototype.contain = function (val) {
	  var extent = this._extent;
	  return val >= extent[0] && val <= extent[1];
	};
	/**
	 * Normalize value to linear [0, 1], return 0.5 if extent span is 0
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.normalize = function (val) {
	  var extent = this._extent;
	
	  if (extent[1] === extent[0]) {
	    return 0.5;
	  }
	
	  return (val - extent[0]) / (extent[1] - extent[0]);
	};
	/**
	 * Scale normalized value
	 * @param {number} val
	 * @return {number}
	 */
	
	
	Scale.prototype.scale = function (val) {
	  var extent = this._extent;
	  return val * (extent[1] - extent[0]) + extent[0];
	};
	/**
	 * Set extent from data
	 * @param {Array.<number>} other
	 */
	
	
	Scale.prototype.unionExtent = function (other) {
	  var extent = this._extent;
	  other[0] < extent[0] && (extent[0] = other[0]);
	  other[1] > extent[1] && (extent[1] = other[1]); // not setExtent because in log axis it may transformed to power
	  // this.setExtent(extent[0], extent[1]);
	};
	/**
	 * Set extent from data
	 * @param {module:echarts/data/List} data
	 * @param {string} dim
	 */
	
	
	Scale.prototype.unionExtentFromData = function (data, dim) {
	  this.unionExtent(data.getApproximateExtent(dim));
	};
	/**
	 * Get extent
	 * @return {Array.<number>}
	 */
	
	
	Scale.prototype.getExtent = function () {
	  return this._extent.slice();
	};
	/**
	 * Set extent
	 * @param {number} start
	 * @param {number} end
	 */
	
	
	Scale.prototype.setExtent = function (start, end) {
	  var thisExtent = this._extent;
	
	  if (!isNaN(start)) {
	    thisExtent[0] = start;
	  }
	
	  if (!isNaN(end)) {
	    thisExtent[1] = end;
	  }
	};
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	
	
	Scale.prototype.isBlank = function () {
	  return this._isBlank;
	},
	/**
	 * When axis extent depends on data and no data exists,
	 * axis ticks should not be drawn, which is named 'blank'.
	 */
	Scale.prototype.setBlank = function (isBlank) {
	  this._isBlank = isBlank;
	};
	/**
	 * @abstract
	 * @param {*} tick
	 * @return {string} label of the tick.
	 */
	
	Scale.prototype.getLabel = null;
	clazzUtil.enableClassExtend(Scale);
	clazzUtil.enableClassManagement(Scale, {
	  registerWhenExtend: true
	});
	var _default = Scale;
	module.exports = _default;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Group = __webpack_require__(223);
	
	var componentUtil = __webpack_require__(297);
	
	var clazzUtil = __webpack_require__(161);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var Component = function () {
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	  this.group = new Group();
	  /**
	   * @type {string}
	   * @readOnly
	   */
	
	  this.uid = componentUtil.getUID('viewComponent');
	};
	
	Component.prototype = {
	  constructor: Component,
	  init: function (ecModel, api) {},
	  render: function (componentModel, ecModel, api, payload) {},
	  dispose: function () {},
	
	  /**
	   * @param {string} eventType
	   * @param {Object} query
	   * @param {module:zrender/Element} targetEl
	   * @param {Object} packedEvent
	   * @return {boolen} Pass only when return `true`.
	   */
	  filterForExposedEvent: null
	};
	var componentProto = Component.prototype;
	
	componentProto.updateView = componentProto.updateLayout = componentProto.updateVisual = function (seriesModel, ecModel, api, payload) {// Do nothing;
	}; // Enable Component.extend.
	
	
	clazzUtil.enableClassExtend(Component); // Enable capability of registerClass, getClass, hasClass, registerSubTypeDefaulter and so on.
	
	clazzUtil.enableClassManagement(Component, {
	  registerWhenExtend: true
	});
	var _default = Component;
	module.exports = _default;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var createHashMap = _util.createHashMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Pick color from palette for each data item.
	// Applicable for charts that require applying color palette
	// in data level (like pie, funnel, chord).
	function _default(seriesType) {
	  return {
	    getTargetSeries: function (ecModel) {
	      // Pie and funnel may use diferrent scope
	      var paletteScope = {};
	      var seiresModelMap = createHashMap();
	      ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	        seriesModel.__paletteScope = paletteScope;
	        seiresModelMap.set(seriesModel.uid, seriesModel);
	      });
	      return seiresModelMap;
	    },
	    reset: function (seriesModel, ecModel) {
	      var dataAll = seriesModel.getRawData();
	      var idxMap = {};
	      var data = seriesModel.getData();
	      data.each(function (idx) {
	        var rawIdx = data.getRawIndex(idx);
	        idxMap[rawIdx] = idx;
	      });
	      dataAll.each(function (rawIdx) {
	        var filteredIdx = idxMap[rawIdx]; // If series.itemStyle.normal.color is a function. itemVisual may be encoded
	
	        var singleDataColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'color', true);
	        var singleDataBorderColor = filteredIdx != null && data.getItemVisual(filteredIdx, 'borderColor', true);
	        var itemModel;
	
	        if (!singleDataColor || !singleDataBorderColor) {
	          // FIXME Performance
	          itemModel = dataAll.getItemModel(rawIdx);
	        }
	
	        if (!singleDataColor) {
	          var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(dataAll.getName(rawIdx) || rawIdx + '', seriesModel.__paletteScope, dataAll.count()); // Data is not filtered
	
	          if (filteredIdx != null) {
	            data.setItemVisual(filteredIdx, 'color', color);
	          }
	        }
	
	        if (!singleDataBorderColor) {
	          var borderColor = itemModel.get('itemStyle.borderColor'); // Data is not filtered
	
	          if (filteredIdx != null) {
	            data.setItemVisual(filteredIdx, 'borderColor', borderColor);
	          }
	        }
	      });
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var VisualMapping = __webpack_require__(213);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual solution, for consistent option specification.
	 */
	var each = zrUtil.each;
	
	function hasKeys(obj) {
	  if (obj) {
	    for (var name in obj) {
	      if (obj.hasOwnProperty(name)) {
	        return true;
	      }
	    }
	  }
	}
	/**
	 * @param {Object} option
	 * @param {Array.<string>} stateList
	 * @param {Function} [supplementVisualOption]
	 * @return {Object} visualMappings <state, <visualType, module:echarts/visual/VisualMapping>>
	 */
	
	
	function createVisualMappings(option, stateList, supplementVisualOption) {
	  var visualMappings = {};
	  each(stateList, function (state) {
	    var mappings = visualMappings[state] = createMappings();
	    each(option[state], function (visualData, visualType) {
	      if (!VisualMapping.isValidType(visualType)) {
	        return;
	      }
	
	      var mappingOption = {
	        type: visualType,
	        visual: visualData
	      };
	      supplementVisualOption && supplementVisualOption(mappingOption, state);
	      mappings[visualType] = new VisualMapping(mappingOption); // Prepare a alpha for opacity, for some case that opacity
	      // is not supported, such as rendering using gradient color.
	
	      if (visualType === 'opacity') {
	        mappingOption = zrUtil.clone(mappingOption);
	        mappingOption.type = 'colorAlpha';
	        mappings.__hidden.__alphaForOpacity = new VisualMapping(mappingOption);
	      }
	    });
	  });
	  return visualMappings;
	
	  function createMappings() {
	    var Creater = function () {}; // Make sure hidden fields will not be visited by
	    // object iteration (with hasOwnProperty checking).
	
	
	    Creater.prototype.__hidden = Creater.prototype;
	    var obj = new Creater();
	    return obj;
	  }
	}
	/**
	 * @param {Object} thisOption
	 * @param {Object} newOption
	 * @param {Array.<string>} keys
	 */
	
	
	function replaceVisualOption(thisOption, newOption, keys) {
	  // Visual attributes merge is not supported, otherwise it
	  // brings overcomplicated merge logic. See #2853. So if
	  // newOption has anyone of these keys, all of these keys
	  // will be reset. Otherwise, all keys remain.
	  var has;
	  zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      has = true;
	    }
	  });
	  has && zrUtil.each(keys, function (key) {
	    if (newOption.hasOwnProperty(key) && hasKeys(newOption[key])) {
	      thisOption[key] = zrUtil.clone(newOption[key]);
	    } else {
	      delete thisOption[key];
	    }
	  });
	}
	/**
	 * @param {Array.<string>} stateList
	 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	 * @param {module:echarts/data/List} list
	 * @param {Function} getValueState param: valueOrIndex, return: state.
	 * @param {object} [scope] Scope for getValueState
	 * @param {string} [dimension] Concrete dimension, if used.
	 */
	// ???! handle brush?
	
	
	function applyVisual(stateList, visualMappings, data, getValueState, scope, dimension) {
	  var visualTypesMap = {};
	  zrUtil.each(stateList, function (state) {
	    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	    visualTypesMap[state] = visualTypes;
	  });
	  var dataIndex;
	
	  function getVisual(key) {
	    return data.getItemVisual(dataIndex, key);
	  }
	
	  function setVisual(key, value) {
	    data.setItemVisual(dataIndex, key, value);
	  }
	
	  if (dimension == null) {
	    data.each(eachItem);
	  } else {
	    data.each([dimension], eachItem);
	  }
	
	  function eachItem(valueOrIndex, index) {
	    dataIndex = dimension == null ? valueOrIndex : index;
	    var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	
	    if (rawDataItem && rawDataItem.visualMap === false) {
	      return;
	    }
	
	    var valueState = getValueState.call(scope, valueOrIndex);
	    var mappings = visualMappings[valueState];
	    var visualTypes = visualTypesMap[valueState];
	
	    for (var i = 0, len = visualTypes.length; i < len; i++) {
	      var type = visualTypes[i];
	      mappings[type] && mappings[type].applyVisual(valueOrIndex, getVisual, setVisual);
	    }
	  }
	}
	/**
	 * @param {module:echarts/data/List} data
	 * @param {Array.<string>} stateList
	 * @param {Object} visualMappings <state, Object.<visualType, module:echarts/visual/VisualMapping>>
	 * @param {Function} getValueState param: valueOrIndex, return: state.
	 * @param {number} [dim] dimension or dimension index.
	 */
	
	
	function incrementalApplyVisual(stateList, visualMappings, getValueState, dim) {
	  var visualTypesMap = {};
	  zrUtil.each(stateList, function (state) {
	    var visualTypes = VisualMapping.prepareVisualTypes(visualMappings[state]);
	    visualTypesMap[state] = visualTypes;
	  });
	
	  function progress(params, data) {
	    if (dim != null) {
	      dim = data.getDimension(dim);
	    }
	
	    function getVisual(key) {
	      return data.getItemVisual(dataIndex, key);
	    }
	
	    function setVisual(key, value) {
	      data.setItemVisual(dataIndex, key, value);
	    }
	
	    var dataIndex;
	
	    while ((dataIndex = params.next()) != null) {
	      var rawDataItem = data.getRawDataItem(dataIndex); // Consider performance
	
	      if (rawDataItem && rawDataItem.visualMap === false) {
	        continue;
	      }
	
	      var value = dim != null ? data.get(dim, dataIndex, true) : dataIndex;
	      var valueState = getValueState(value);
	      var mappings = visualMappings[valueState];
	      var visualTypes = visualTypesMap[valueState];
	
	      for (var i = 0, len = visualTypes.length; i < len; i++) {
	        var type = visualTypes[i];
	        mappings[type] && mappings[type].applyVisual(value, getVisual, setVisual);
	      }
	    }
	  }
	
	  return {
	    progress: progress
	  };
	}
	
	exports.createVisualMappings = createVisualMappings;
	exports.replaceVisualOption = replaceVisualOption;
	exports.applyVisual = applyVisual;
	exports.incrementalApplyVisual = incrementalApplyVisual;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(2478);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 366 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 367 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	/**
	 * Indicates that navigation was caused by a call to history.push.
	 */
	var PUSH = exports.PUSH = 'PUSH';
	
	/**
	 * Indicates that navigation was caused by a call to history.replace.
	 */
	var REPLACE = exports.REPLACE = 'REPLACE';
	
	/**
	 * Indicates that navigation was caused by some other action such
	 * as using a browser's back/forward buttons and/or manually manipulating
	 * the URL in a browser's location bar. This is the default.
	 *
	 * See https://developer.mozilla.org/en-US/docs/Web/API/WindowEventHandlers/onpopstate
	 * for more information.
	 */
	var POP = exports.POP = 'POP';

/***/ },
/* 368 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopstateOnHashchange = exports.supportsPopstateOnHashchange = function supportsPopstateOnHashchange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 369 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(2558),
	    listCacheDelete = __webpack_require__(2559),
	    listCacheGet = __webpack_require__(2560),
	    listCacheHas = __webpack_require__(2561),
	    listCacheSet = __webpack_require__(2562);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(256);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(914);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(2555);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 374 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  var type = typeof value;
	  length = length == null ? MAX_SAFE_INTEGER : length;
	
	  return !!length &&
	    (type == 'number' ||
	      (type != 'symbol' && reIsUint.test(value))) &&
	        (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(218);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 376 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 377 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(2511),
	    isObjectLike = __webpack_require__(183);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(217),
	    getPrototype = __webpack_require__(917),
	    isObjectLike = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(217),
	    isObjectLike = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(899),
	    baseKeys = __webpack_require__(2517),
	    isArrayLike = __webpack_require__(301);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.commonMixinWrapper = exports.defaultProp = exports.propType = undefined;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _en_US = __webpack_require__(1080);
	
	var _en_US2 = _interopRequireDefault(_en_US);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	var propType = exports.propType = {
	  className: _propTypes2['default'].string,
	  locale: _propTypes2['default'].object,
	  style: _propTypes2['default'].object,
	  visible: _propTypes2['default'].bool,
	  onSelect: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  onChange: _propTypes2['default'].func,
	  onOk: _propTypes2['default'].func
	};
	
	var defaultProp = exports.defaultProp = {
	  locale: _en_US2['default'],
	  style: {},
	  visible: true,
	  prefixCls: 'rc-calendar',
	  className: '',
	  onSelect: noop,
	  onChange: noop,
	  onClear: noop,
	  renderFooter: function renderFooter() {
	    return null;
	  },
	  renderSidebar: function renderSidebar() {
	    return null;
	  }
	};
	
	var commonMixinWrapper = exports.commonMixinWrapper = function commonMixinWrapper(ComposeComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_ComposeComponent) {
	    (0, _inherits3['default'])(_class, _ComposeComponent);
	
	    function _class() {
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3['default'])(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.getFormat = function () {
	        var format = _this.props.format;
	        var _this$props = _this.props,
	            locale = _this$props.locale,
	            timePicker = _this$props.timePicker;
	
	        if (!format) {
	          if (timePicker) {
	            format = locale.dateTimeFormat;
	          } else {
	            format = locale.dateFormat;
	          }
	        }
	        return format;
	      }, _this.focus = function () {
	        if (_this.focusElement) {
	          _this.focusElement.focus();
	        } else if (_this.rootInstance) {
	          _this.rootInstance.focus();
	        }
	      }, _this.saveFocusElement = function (focusElement) {
	        _this.focusElement = focusElement;
	      }, _this.saveRoot = function (root) {
	        _this.rootInstance = root;
	      }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	    }
	
	    _class.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	      return this.props.visible || nextProps.visible;
	    };
	
	    return _class;
	  }(ComposeComponent), _class.displayName = 'CommonMixinWrapper', _class.defaultProps = ComposeComponent.defaultProps, _class.getDerivedStateFromProps = ComposeComponent.getDerivedStateFromProps, _temp2;
	};

/***/ },
/* 383 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = contains;
	
	function contains(root, n) {
	  var node = n;
	
	  while (node) {
	    if (node === root) {
	      return true;
	    }
	
	    node = node.parentNode;
	  }
	
	  return false;
	}

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
	  var prototype = Component.prototype;
	
	  if (!prototype || !prototype.isReactComponent) {
	    throw new Error('Can only polyfill class components');
	  } // only handle componentWillReceiveProps
	
	
	  if (typeof prototype.componentWillReceiveProps !== 'function') {
	    return Component;
	  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
	  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler
	
	
	  if (!_react.default.Profiler) {
	    return Component;
	  } // Here polyfill get started
	
	
	  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
	  delete prototype.componentWillReceiveProps;
	  return Component;
	};
	
	var _default = unsafeLifecyclesPolyfill;
	exports.default = _default;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var EventPluginRegistry = __webpack_require__(573);
	var ReactEventEmitterMixin = __webpack_require__(2809);
	var ViewportMetrics = __webpack_require__(1139);
	
	var getVendorPrefixedEventName = __webpack_require__(2841);
	var isEventSupported = __webpack_require__(584);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(307);
	var ViewportMetrics = __webpack_require__(1139);
	
	var getEventModifierState = __webpack_require__(582);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var invariant = __webpack_require__(18);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 388 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(93);
	var DOMNamespaces = __webpack_require__(572);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(580);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
	  var onDemandSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
	      onDemandSlides.push(slideIndex);
	    }
	  }
	
	  return onDemandSlides;
	}; // return list of slides that need to be present
	
	
	exports.getOnDemandLazySlides = getOnDemandLazySlides;
	
	var getRequiredLazySlides = function getRequiredLazySlides(spec) {
	  var requiredSlides = [];
	  var startIndex = lazyStartIndex(spec);
	  var endIndex = lazyEndIndex(spec);
	
	  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
	    requiredSlides.push(slideIndex);
	  }
	
	  return requiredSlides;
	}; // startIndex that needs to be present
	
	
	exports.getRequiredLazySlides = getRequiredLazySlides;
	
	var lazyStartIndex = function lazyStartIndex(spec) {
	  return spec.currentSlide - lazySlidesOnLeft(spec);
	};
	
	exports.lazyStartIndex = lazyStartIndex;
	
	var lazyEndIndex = function lazyEndIndex(spec) {
	  return spec.currentSlide + lazySlidesOnRight(spec);
	};
	
	exports.lazyEndIndex = lazyEndIndex;
	
	var lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
	  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
	};
	
	exports.lazySlidesOnLeft = lazySlidesOnLeft;
	
	var lazySlidesOnRight = function lazySlidesOnRight(spec) {
	  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
	}; // get width of an element
	
	
	exports.lazySlidesOnRight = lazySlidesOnRight;
	
	var getWidth = function getWidth(elem) {
	  return elem && elem.offsetWidth || 0;
	};
	
	exports.getWidth = getWidth;
	
	var getHeight = function getHeight(elem) {
	  return elem && elem.offsetHeight || 0;
	};
	
	exports.getHeight = getHeight;
	
	var getSwipeDirection = function getSwipeDirection(touchObject) {
	  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var xDist, yDist, r, swipeAngle;
	  xDist = touchObject.startX - touchObject.curX;
	  yDist = touchObject.startY - touchObject.curY;
	  r = Math.atan2(yDist, xDist);
	  swipeAngle = Math.round(r * 180 / Math.PI);
	
	  if (swipeAngle < 0) {
	    swipeAngle = 360 - Math.abs(swipeAngle);
	  }
	
	  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
	    return "left";
	  }
	
	  if (swipeAngle >= 135 && swipeAngle <= 225) {
	    return "right";
	  }
	
	  if (verticalSwiping === true) {
	    if (swipeAngle >= 35 && swipeAngle <= 135) {
	      return "up";
	    } else {
	      return "down";
	    }
	  }
	
	  return "vertical";
	}; // whether or not we can go next
	
	
	exports.getSwipeDirection = getSwipeDirection;
	
	var canGoNext = function canGoNext(spec) {
	  var canGo = true;
	
	  if (!spec.infinite) {
	    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
	      canGo = false;
	    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
	      canGo = false;
	    }
	  }
	
	  return canGo;
	}; // given an object and a list of keys, return new object with given keys
	
	
	exports.canGoNext = canGoNext;
	
	var extractObject = function extractObject(spec, keys) {
	  var newObject = {};
	  keys.forEach(function (key) {
	    return newObject[key] = spec[key];
	  });
	  return newObject;
	}; // get initialized state
	
	
	exports.extractObject = extractObject;
	
	var initializedState = function initializedState(spec) {
	  // spec also contains listRef, trackRef
	  var slideCount = _react["default"].Children.count(spec.children);
	
	  var listWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.listRef)));
	  var trackWidth = Math.ceil(getWidth(_reactDom["default"].findDOMNode(spec.trackRef)));
	  var slideWidth;
	
	  if (!spec.vertical) {
	    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
	
	    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
	      centerPaddingAdj *= listWidth / 100;
	    }
	
	    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
	  } else {
	    slideWidth = listWidth;
	  }
	
	  var slideHeight = _reactDom["default"].findDOMNode(spec.listRef) && getHeight(_reactDom["default"].findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
	  var listHeight = slideHeight * spec.slidesToShow;
	  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
	
	  if (spec.rtl && spec.currentSlide === undefined) {
	    currentSlide = slideCount - 1 - spec.initialSlide;
	  }
	
	  var lazyLoadedList = spec.lazyLoadedList || [];
	  var slidesToLoad = getOnDemandLazySlides({
	    currentSlide: currentSlide,
	    lazyLoadedList: lazyLoadedList
	  }, spec);
	  lazyLoadedList.concat(slidesToLoad);
	  var state = {
	    slideCount: slideCount,
	    slideWidth: slideWidth,
	    listWidth: listWidth,
	    trackWidth: trackWidth,
	    currentSlide: currentSlide,
	    slideHeight: slideHeight,
	    listHeight: listHeight,
	    lazyLoadedList: lazyLoadedList
	  };
	
	  if (spec.autoplaying === null && spec.autoplay) {
	    state["autoplaying"] = "playing";
	  }
	
	  return state;
	};
	
	exports.initializedState = initializedState;
	
	var slideHandler = function slideHandler(spec) {
	  var waitForAnimate = spec.waitForAnimate,
	      animating = spec.animating,
	      fade = spec.fade,
	      infinite = spec.infinite,
	      index = spec.index,
	      slideCount = spec.slideCount,
	      lazyLoadedList = spec.lazyLoadedList,
	      lazyLoad = spec.lazyLoad,
	      currentSlide = spec.currentSlide,
	      centerMode = spec.centerMode,
	      slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      useCSS = spec.useCSS;
	  if (waitForAnimate && animating) return {};
	  var animationSlide = index,
	      finalSlide,
	      animationLeft,
	      finalLeft;
	  var state = {},
	      nextState = {};
	
	  if (fade) {
	    if (!infinite && (index < 0 || index >= slideCount)) return {};
	
	    if (index < 0) {
	      animationSlide = index + slideCount;
	    } else if (index >= slideCount) {
	      animationSlide = index - slideCount;
	    }
	
	    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
	      lazyLoadedList.push(animationSlide);
	    }
	
	    state = {
	      animating: true,
	      currentSlide: animationSlide,
	      lazyLoadedList: lazyLoadedList
	    };
	    nextState = {
	      animating: false
	    };
	  } else {
	    finalSlide = animationSlide;
	
	    if (animationSlide < 0) {
	      finalSlide = animationSlide + slideCount;
	      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
	    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
	      animationSlide = finalSlide = currentSlide;
	    } else if (centerMode && animationSlide >= slideCount) {
	      animationSlide = infinite ? slideCount : slideCount - 1;
	      finalSlide = infinite ? 0 : slideCount - 1;
	    } else if (animationSlide >= slideCount) {
	      finalSlide = animationSlide - slideCount;
	      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
	    }
	
	    animationLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: animationSlide
	    }));
	    finalLeft = getTrackLeft(_objectSpread({}, spec, {
	      slideIndex: finalSlide
	    }));
	
	    if (!infinite) {
	      if (animationLeft === finalLeft) animationSlide = finalSlide;
	      animationLeft = finalLeft;
	    }
	
	    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_objectSpread({}, spec, {
	      currentSlide: animationSlide
	    })));
	
	    if (!useCSS) {
	      state = {
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	    } else {
	      state = {
	        animating: true,
	        currentSlide: finalSlide,
	        trackStyle: getTrackAnimateCSS(_objectSpread({}, spec, {
	          left: animationLeft
	        })),
	        lazyLoadedList: lazyLoadedList
	      };
	      nextState = {
	        animating: false,
	        currentSlide: finalSlide,
	        trackStyle: getTrackCSS(_objectSpread({}, spec, {
	          left: finalLeft
	        })),
	        swipeLeft: null
	      };
	    }
	  }
	
	  return {
	    state: state,
	    nextState: nextState
	  };
	};
	
	exports.slideHandler = slideHandler;
	
	var changeSlide = function changeSlide(spec, options) {
	  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
	  var slidesToScroll = spec.slidesToScroll,
	      slidesToShow = spec.slidesToShow,
	      slideCount = spec.slideCount,
	      currentSlide = spec.currentSlide,
	      lazyLoad = spec.lazyLoad,
	      infinite = spec.infinite;
	  unevenOffset = slideCount % slidesToScroll !== 0;
	  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;
	
	  if (options.message === "previous") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
	    targetSlide = currentSlide - slideOffset;
	
	    if (lazyLoad && !infinite) {
	      previousInt = currentSlide - slideOffset;
	      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
	    }
	  } else if (options.message === "next") {
	    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
	    targetSlide = currentSlide + slideOffset;
	
	    if (lazyLoad && !infinite) {
	      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
	    }
	  } else if (options.message === "dots") {
	    // Click on dots
	    targetSlide = options.index * options.slidesToScroll;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  } else if (options.message === "children") {
	    // Click on the slides
	    targetSlide = options.index;
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	
	    if (infinite) {
	      var direction = siblingDirection(_objectSpread({}, spec, {
	        targetSlide: targetSlide
	      }));
	
	      if (targetSlide > options.currentSlide && direction === "left") {
	        targetSlide = targetSlide - slideCount;
	      } else if (targetSlide < options.currentSlide && direction === "right") {
	        targetSlide = targetSlide + slideCount;
	      }
	    }
	  } else if (options.message === "index") {
	    targetSlide = Number(options.index);
	
	    if (targetSlide === options.currentSlide) {
	      return null;
	    }
	  }
	
	  return targetSlide;
	};
	
	exports.changeSlide = changeSlide;
	
	var keyHandler = function keyHandler(e, accessibility, rtl) {
	  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
	  if (e.keyCode === 37) return rtl ? "next" : "previous";
	  if (e.keyCode === 39) return rtl ? "previous" : "next";
	  return "";
	};
	
	exports.keyHandler = keyHandler;
	
	var swipeStart = function swipeStart(e, swipe, draggable) {
	  e.target.tagName === "IMG" && e.preventDefault();
	  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
	  return {
	    dragging: true,
	    touchObject: {
	      startX: e.touches ? e.touches[0].pageX : e.clientX,
	      startY: e.touches ? e.touches[0].pageY : e.clientY,
	      curX: e.touches ? e.touches[0].pageX : e.clientX,
	      curY: e.touches ? e.touches[0].pageY : e.clientY
	    }
	  };
	};
	
	exports.swipeStart = swipeStart;
	
	var swipeMove = function swipeMove(e, spec) {
	  // spec also contains, trackRef and slideIndex
	  var scrolling = spec.scrolling,
	      animating = spec.animating,
	      vertical = spec.vertical,
	      swipeToSlide = spec.swipeToSlide,
	      verticalSwiping = spec.verticalSwiping,
	      rtl = spec.rtl,
	      currentSlide = spec.currentSlide,
	      edgeFriction = spec.edgeFriction,
	      edgeDragged = spec.edgeDragged,
	      onEdge = spec.onEdge,
	      swiped = spec.swiped,
	      swiping = spec.swiping,
	      slideCount = spec.slideCount,
	      slidesToScroll = spec.slidesToScroll,
	      infinite = spec.infinite,
	      touchObject = spec.touchObject,
	      swipeEvent = spec.swipeEvent,
	      listHeight = spec.listHeight,
	      listWidth = spec.listWidth;
	  if (scrolling) return;
	  if (animating) return e.preventDefault();
	  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
	  var swipeLeft,
	      state = {};
	  var curLeft = getTrackLeft(spec);
	  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
	  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
	  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
	  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
	
	  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
	    return {
	      scrolling: true
	    };
	  }
	
	  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
	  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
	  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;
	  var dotCount = Math.ceil(slideCount / slidesToScroll);
	  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
	  var touchSwipeLength = touchObject.swipeLength;
	
	  if (!infinite) {
	    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
	      touchSwipeLength = touchObject.swipeLength * edgeFriction;
	
	      if (edgeDragged === false && onEdge) {
	        onEdge(swipeDirection);
	        state["edgeDragged"] = true;
	      }
	    }
	  }
	
	  if (!swiped && swipeEvent) {
	    swipeEvent(swipeDirection);
	    state["swiped"] = true;
	  }
	
	  if (!vertical) {
	    if (!rtl) {
	      swipeLeft = curLeft + touchSwipeLength * positionOffset;
	    } else {
	      swipeLeft = curLeft - touchSwipeLength * positionOffset;
	    }
	  } else {
	    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
	  }
	
	  if (verticalSwiping) {
	    swipeLeft = curLeft + touchSwipeLength * positionOffset;
	  }
	
	  state = _objectSpread({}, state, {
	    touchObject: touchObject,
	    swipeLeft: swipeLeft,
	    trackStyle: getTrackCSS(_objectSpread({}, spec, {
	      left: swipeLeft
	    }))
	  });
	
	  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > 10) {
	    state["swiping"] = true;
	    e.preventDefault();
	  }
	
	  return state;
	};
	
	exports.swipeMove = swipeMove;
	
	var swipeEnd = function swipeEnd(e, spec) {
	  var dragging = spec.dragging,
	      swipe = spec.swipe,
	      touchObject = spec.touchObject,
	      listWidth = spec.listWidth,
	      touchThreshold = spec.touchThreshold,
	      verticalSwiping = spec.verticalSwiping,
	      listHeight = spec.listHeight,
	      currentSlide = spec.currentSlide,
	      swipeToSlide = spec.swipeToSlide,
	      scrolling = spec.scrolling,
	      onSwipe = spec.onSwipe;
	
	  if (!dragging) {
	    if (swipe) e.preventDefault();
	    return {};
	  }
	
	  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
	  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping); // reset the state of touch related state variables.
	
	  var state = {
	    dragging: false,
	    edgeDragged: false,
	    scrolling: false,
	    swiping: false,
	    swiped: false,
	    swipeLeft: null,
	    touchObject: {}
	  };
	
	  if (scrolling) {
	    return state;
	  }
	
	  if (!touchObject.swipeLength) {
	    return state;
	  }
	
	  if (touchObject.swipeLength > minSwipe) {
	    e.preventDefault();
	
	    if (onSwipe) {
	      onSwipe(swipeDirection);
	    }
	
	    var slideCount, newSlide;
	
	    switch (swipeDirection) {
	      case "left":
	      case "up":
	        newSlide = currentSlide + getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 0;
	        break;
	
	      case "right":
	      case "down":
	        newSlide = currentSlide - getSlideCount(spec);
	        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
	        state["currentDirection"] = 1;
	        break;
	
	      default:
	        slideCount = currentSlide;
	    }
	
	    state["triggerSlideHandler"] = slideCount;
	  } else {
	    // Adjust the track back to it's original position.
	    var currentLeft = getTrackLeft(spec);
	    state["trackStyle"] = getTrackAnimateCSS(_objectSpread({}, spec, {
	      left: currentLeft
	    }));
	  }
	
	  return state;
	};
	
	exports.swipeEnd = swipeEnd;
	
	var getNavigableIndexes = function getNavigableIndexes(spec) {
	  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
	  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
	  var indexes = [];
	
	  while (breakpoint < max) {
	    indexes.push(breakpoint);
	    breakpoint = counter + spec.slidesToScroll;
	    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
	  }
	
	  return indexes;
	};
	
	exports.getNavigableIndexes = getNavigableIndexes;
	
	var checkNavigable = function checkNavigable(spec, index) {
	  var navigables = getNavigableIndexes(spec);
	  var prevNavigable = 0;
	
	  if (index > navigables[navigables.length - 1]) {
	    index = navigables[navigables.length - 1];
	  } else {
	    for (var n in navigables) {
	      if (index < navigables[n]) {
	        index = prevNavigable;
	        break;
	      }
	
	      prevNavigable = navigables[n];
	    }
	  }
	
	  return index;
	};
	
	exports.checkNavigable = checkNavigable;
	
	var getSlideCount = function getSlideCount(spec) {
	  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
	
	  if (spec.swipeToSlide) {
	    var swipedSlide;
	
	    var slickList = _reactDom["default"].findDOMNode(spec.listRef);
	
	    var slides = slickList.querySelectorAll(".slick-slide");
	    Array.from(slides).every(function (slide) {
	      if (!spec.vertical) {
	        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      } else {
	        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
	          swipedSlide = slide;
	          return false;
	        }
	      }
	
	      return true;
	    });
	
	    if (!swipedSlide) {
	      return 0;
	    }
	
	    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
	    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
	    return slidesTraversed;
	  } else {
	    return spec.slidesToScroll;
	  }
	};
	
	exports.getSlideCount = getSlideCount;
	
	var checkSpecKeys = function checkSpecKeys(spec, keysArray) {
	  return keysArray.reduce(function (value, key) {
	    return value && spec.hasOwnProperty(key);
	  }, true) ? null : console.error("Keys Missing:", spec);
	};
	
	exports.checkSpecKeys = checkSpecKeys;
	
	var getTrackCSS = function getTrackCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
	  var trackWidth, trackHeight;
	  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
	
	  if (!spec.vertical) {
	    trackWidth = getTotalSlides(spec) * spec.slideWidth;
	  } else {
	    trackHeight = trackChildren * spec.slideHeight;
	  }
	
	  var style = {
	    opacity: 1,
	    transition: "",
	    WebkitTransition: ""
	  };
	
	  if (spec.useTransform) {
	    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
	    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
	    style = _objectSpread({}, style, {
	      WebkitTransform: WebkitTransform,
	      transform: transform,
	      msTransform: msTransform
	    });
	  } else {
	    if (spec.vertical) {
	      style["top"] = spec.left;
	    } else {
	      style["left"] = spec.left;
	    }
	  }
	
	  if (spec.fade) style = {
	    opacity: 1
	  };
	  if (trackWidth) style.width = trackWidth;
	  if (trackHeight) style.height = trackHeight; // Fallback for IE8
	
	  if (window && !window.addEventListener && window.attachEvent) {
	    if (!spec.vertical) {
	      style.marginLeft = spec.left + "px";
	    } else {
	      style.marginTop = spec.left + "px";
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackCSS = getTrackCSS;
	
	var getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
	  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
	  var style = getTrackCSS(spec); // useCSS is true by default so it can be undefined
	
	  if (spec.useTransform) {
	    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
	    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
	  } else {
	    if (spec.vertical) {
	      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
	    } else {
	      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
	    }
	  }
	
	  return style;
	};
	
	exports.getTrackAnimateCSS = getTrackAnimateCSS;
	
	var getTrackLeft = function getTrackLeft(spec) {
	  if (spec.unslick) {
	    return 0;
	  }
	
	  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);
	  var slideIndex = spec.slideIndex,
	      trackRef = spec.trackRef,
	      infinite = spec.infinite,
	      centerMode = spec.centerMode,
	      slideCount = spec.slideCount,
	      slidesToShow = spec.slidesToShow,
	      slidesToScroll = spec.slidesToScroll,
	      slideWidth = spec.slideWidth,
	      listWidth = spec.listWidth,
	      variableWidth = spec.variableWidth,
	      slideHeight = spec.slideHeight,
	      fade = spec.fade,
	      vertical = spec.vertical;
	  var slideOffset = 0;
	  var targetLeft;
	  var targetSlide;
	  var verticalOffset = 0;
	
	  if (fade || spec.slideCount === 1) {
	    return 0;
	  }
	
	  var slidesToOffset = 0;
	
	  if (infinite) {
	    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
	    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
	
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
	    } // shift current slide to center of the frame
	
	
	    if (centerMode) {
	      slidesToOffset += parseInt(slidesToShow / 2);
	    }
	  } else {
	    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
	      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
	    }
	
	    if (centerMode) {
	      slidesToOffset = parseInt(slidesToShow / 2);
	    }
	  }
	
	  slideOffset = slidesToOffset * slideWidth;
	  verticalOffset = slidesToOffset * slideHeight;
	
	  if (!vertical) {
	    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
	  } else {
	    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
	  }
	
	  if (variableWidth === true) {
	    var targetSlideIndex;
	
	    var trackElem = _reactDom["default"].findDOMNode(trackRef);
	
	    targetSlideIndex = slideIndex + getPreClones(spec);
	    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
	    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
	
	    if (centerMode === true) {
	      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
	      targetSlide = trackElem && trackElem.children[targetSlideIndex];
	      targetLeft = 0;
	
	      for (var slide = 0; slide < targetSlideIndex; slide++) {
	        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
	      }
	
	      targetLeft -= parseInt(spec.centerPadding);
	      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
	    }
	  }
	
	  return targetLeft;
	};
	
	exports.getTrackLeft = getTrackLeft;
	
	var getPreClones = function getPreClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  if (spec.variableWidth) {
	    return spec.slideCount;
	  }
	
	  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
	};
	
	exports.getPreClones = getPreClones;
	
	var getPostClones = function getPostClones(spec) {
	  if (spec.unslick || !spec.infinite) {
	    return 0;
	  }
	
	  return spec.slideCount;
	};
	
	exports.getPostClones = getPostClones;
	
	var getTotalSlides = function getTotalSlides(spec) {
	  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
	};
	
	exports.getTotalSlides = getTotalSlides;
	
	var siblingDirection = function siblingDirection(spec) {
	  if (spec.targetSlide > spec.currentSlide) {
	    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
	      return "left";
	    }
	
	    return "right";
	  } else {
	    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
	      return "right";
	    }
	
	    return "left";
	  }
	};
	
	exports.siblingDirection = siblingDirection;
	
	var slidesOnRight = function slidesOnRight(_ref) {
	  var slidesToShow = _ref.slidesToShow,
	      centerMode = _ref.centerMode,
	      rtl = _ref.rtl,
	      centerPadding = _ref.centerPadding;
	
	  // returns no of slides on the right of active slide
	  if (centerMode) {
	    var right = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) right += 1;
	    if (rtl && slidesToShow % 2 === 0) right += 1;
	    return right;
	  }
	
	  if (rtl) {
	    return 0;
	  }
	
	  return slidesToShow - 1;
	};
	
	exports.slidesOnRight = slidesOnRight;
	
	var slidesOnLeft = function slidesOnLeft(_ref2) {
	  var slidesToShow = _ref2.slidesToShow,
	      centerMode = _ref2.centerMode,
	      rtl = _ref2.rtl,
	      centerPadding = _ref2.centerPadding;
	
	  // returns no of slides on the left of active slide
	  if (centerMode) {
	    var left = (slidesToShow - 1) / 2 + 1;
	    if (parseInt(centerPadding) > 0) left += 1;
	    if (!rtl && slidesToShow % 2 === 0) left += 1;
	    return left;
	  }
	
	  if (rtl) {
	    return slidesToShow - 1;
	  }
	
	  return 0;
	};
	
	exports.slidesOnLeft = slidesOnLeft;
	
	var canUseDOM = function canUseDOM() {
	  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
	};
	
	exports.canUseDOM = canUseDOM;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
	     true ? module.exports = factory() :
	    typeof define === 'function' && define.amd ? define(factory) :
	    (global.ResizeObserver = factory());
	}(this, (function () { 'use strict';
	
	    /**
	     * A collection of shims that provide minimal functionality of the ES6 collections.
	     *
	     * These implementations are not meant to be used outside of the ResizeObserver
	     * modules as they cover only a limited range of use cases.
	     */
	    /* eslint-disable require-jsdoc, valid-jsdoc */
	    var MapShim = (function () {
	        if (typeof Map !== 'undefined') {
	            return Map;
	        }
	        /**
	         * Returns index in provided array that matches the specified key.
	         *
	         * @param {Array<Array>} arr
	         * @param {*} key
	         * @returns {number}
	         */
	        function getIndex(arr, key) {
	            var result = -1;
	            arr.some(function (entry, index) {
	                if (entry[0] === key) {
	                    result = index;
	                    return true;
	                }
	                return false;
	            });
	            return result;
	        }
	        return /** @class */ (function () {
	            function class_1() {
	                this.__entries__ = [];
	            }
	            Object.defineProperty(class_1.prototype, "size", {
	                /**
	                 * @returns {boolean}
	                 */
	                get: function () {
	                    return this.__entries__.length;
	                },
	                enumerable: true,
	                configurable: true
	            });
	            /**
	             * @param {*} key
	             * @returns {*}
	             */
	            class_1.prototype.get = function (key) {
	                var index = getIndex(this.__entries__, key);
	                var entry = this.__entries__[index];
	                return entry && entry[1];
	            };
	            /**
	             * @param {*} key
	             * @param {*} value
	             * @returns {void}
	             */
	            class_1.prototype.set = function (key, value) {
	                var index = getIndex(this.__entries__, key);
	                if (~index) {
	                    this.__entries__[index][1] = value;
	                }
	                else {
	                    this.__entries__.push([key, value]);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.delete = function (key) {
	                var entries = this.__entries__;
	                var index = getIndex(entries, key);
	                if (~index) {
	                    entries.splice(index, 1);
	                }
	            };
	            /**
	             * @param {*} key
	             * @returns {void}
	             */
	            class_1.prototype.has = function (key) {
	                return !!~getIndex(this.__entries__, key);
	            };
	            /**
	             * @returns {void}
	             */
	            class_1.prototype.clear = function () {
	                this.__entries__.splice(0);
	            };
	            /**
	             * @param {Function} callback
	             * @param {*} [ctx=null]
	             * @returns {void}
	             */
	            class_1.prototype.forEach = function (callback, ctx) {
	                if (ctx === void 0) { ctx = null; }
	                for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
	                    var entry = _a[_i];
	                    callback.call(ctx, entry[1], entry[0]);
	                }
	            };
	            return class_1;
	        }());
	    })();
	
	    /**
	     * Detects whether window and document objects are available in current environment.
	     */
	    var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;
	
	    // Returns global object of a current environment.
	    var global$1 = (function () {
	        if (typeof global !== 'undefined' && global.Math === Math) {
	            return global;
	        }
	        if (typeof self !== 'undefined' && self.Math === Math) {
	            return self;
	        }
	        if (typeof window !== 'undefined' && window.Math === Math) {
	            return window;
	        }
	        // eslint-disable-next-line no-new-func
	        return Function('return this')();
	    })();
	
	    /**
	     * A shim for the requestAnimationFrame which falls back to the setTimeout if
	     * first one is not supported.
	     *
	     * @returns {number} Requests' identifier.
	     */
	    var requestAnimationFrame$1 = (function () {
	        if (typeof requestAnimationFrame === 'function') {
	            // It's required to use a bounded function because IE sometimes throws
	            // an "Invalid calling object" error if rAF is invoked without the global
	            // object on the left hand side.
	            return requestAnimationFrame.bind(global$1);
	        }
	        return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
	    })();
	
	    // Defines minimum timeout before adding a trailing call.
	    var trailingTimeout = 2;
	    /**
	     * Creates a wrapper function which ensures that provided callback will be
	     * invoked only once during the specified delay period.
	     *
	     * @param {Function} callback - Function to be invoked after the delay period.
	     * @param {number} delay - Delay after which to invoke callback.
	     * @returns {Function}
	     */
	    function throttle (callback, delay) {
	        var leadingCall = false, trailingCall = false, lastCallTime = 0;
	        /**
	         * Invokes the original callback function and schedules new invocation if
	         * the "proxy" was called during current request.
	         *
	         * @returns {void}
	         */
	        function resolvePending() {
	            if (leadingCall) {
	                leadingCall = false;
	                callback();
	            }
	            if (trailingCall) {
	                proxy();
	            }
	        }
	        /**
	         * Callback invoked after the specified delay. It will further postpone
	         * invocation of the original function delegating it to the
	         * requestAnimationFrame.
	         *
	         * @returns {void}
	         */
	        function timeoutCallback() {
	            requestAnimationFrame$1(resolvePending);
	        }
	        /**
	         * Schedules invocation of the original function.
	         *
	         * @returns {void}
	         */
	        function proxy() {
	            var timeStamp = Date.now();
	            if (leadingCall) {
	                // Reject immediately following calls.
	                if (timeStamp - lastCallTime < trailingTimeout) {
	                    return;
	                }
	                // Schedule new call to be in invoked when the pending one is resolved.
	                // This is important for "transitions" which never actually start
	                // immediately so there is a chance that we might miss one if change
	                // happens amids the pending invocation.
	                trailingCall = true;
	            }
	            else {
	                leadingCall = true;
	                trailingCall = false;
	                setTimeout(timeoutCallback, delay);
	            }
	            lastCallTime = timeStamp;
	        }
	        return proxy;
	    }
	
	    // Minimum delay before invoking the update of observers.
	    var REFRESH_DELAY = 20;
	    // A list of substrings of CSS properties used to find transition events that
	    // might affect dimensions of observed elements.
	    var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
	    // Check if MutationObserver is available.
	    var mutationObserverSupported = typeof MutationObserver !== 'undefined';
	    /**
	     * Singleton controller class which handles updates of ResizeObserver instances.
	     */
	    var ResizeObserverController = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserverController.
	         *
	         * @private
	         */
	        function ResizeObserverController() {
	            /**
	             * Indicates whether DOM listeners have been added.
	             *
	             * @private {boolean}
	             */
	            this.connected_ = false;
	            /**
	             * Tells that controller has subscribed for Mutation Events.
	             *
	             * @private {boolean}
	             */
	            this.mutationEventsAdded_ = false;
	            /**
	             * Keeps reference to the instance of MutationObserver.
	             *
	             * @private {MutationObserver}
	             */
	            this.mutationsObserver_ = null;
	            /**
	             * A list of connected observers.
	             *
	             * @private {Array<ResizeObserverSPI>}
	             */
	            this.observers_ = [];
	            this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
	            this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
	        }
	        /**
	         * Adds observer to observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be added.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.addObserver = function (observer) {
	            if (!~this.observers_.indexOf(observer)) {
	                this.observers_.push(observer);
	            }
	            // Add listeners if they haven't been added yet.
	            if (!this.connected_) {
	                this.connect_();
	            }
	        };
	        /**
	         * Removes observer from observers list.
	         *
	         * @param {ResizeObserverSPI} observer - Observer to be removed.
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.removeObserver = function (observer) {
	            var observers = this.observers_;
	            var index = observers.indexOf(observer);
	            // Remove observer if it's present in registry.
	            if (~index) {
	                observers.splice(index, 1);
	            }
	            // Remove listeners if controller has no connected observers.
	            if (!observers.length && this.connected_) {
	                this.disconnect_();
	            }
	        };
	        /**
	         * Invokes the update of observers. It will continue running updates insofar
	         * it detects changes.
	         *
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.refresh = function () {
	            var changesDetected = this.updateObservers_();
	            // Continue running updates if changes have been detected as there might
	            // be future ones caused by CSS transitions.
	            if (changesDetected) {
	                this.refresh();
	            }
	        };
	        /**
	         * Updates every observer from observers list and notifies them of queued
	         * entries.
	         *
	         * @private
	         * @returns {boolean} Returns "true" if any observer has detected changes in
	         *      dimensions of it's elements.
	         */
	        ResizeObserverController.prototype.updateObservers_ = function () {
	            // Collect observers that have active observations.
	            var activeObservers = this.observers_.filter(function (observer) {
	                return observer.gatherActive(), observer.hasActive();
	            });
	            // Deliver notifications in a separate cycle in order to avoid any
	            // collisions between observers, e.g. when multiple instances of
	            // ResizeObserver are tracking the same element and the callback of one
	            // of them changes content dimensions of the observed target. Sometimes
	            // this may result in notifications being blocked for the rest of observers.
	            activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
	            return activeObservers.length > 0;
	        };
	        /**
	         * Initializes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.connect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already added.
	            if (!isBrowser || this.connected_) {
	                return;
	            }
	            // Subscription to the "Transitionend" event is used as a workaround for
	            // delayed transitions. This way it's possible to capture at least the
	            // final state of an element.
	            document.addEventListener('transitionend', this.onTransitionEnd_);
	            window.addEventListener('resize', this.refresh);
	            if (mutationObserverSupported) {
	                this.mutationsObserver_ = new MutationObserver(this.refresh);
	                this.mutationsObserver_.observe(document, {
	                    attributes: true,
	                    childList: true,
	                    characterData: true,
	                    subtree: true
	                });
	            }
	            else {
	                document.addEventListener('DOMSubtreeModified', this.refresh);
	                this.mutationEventsAdded_ = true;
	            }
	            this.connected_ = true;
	        };
	        /**
	         * Removes DOM listeners.
	         *
	         * @private
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.disconnect_ = function () {
	            // Do nothing if running in a non-browser environment or if listeners
	            // have been already removed.
	            if (!isBrowser || !this.connected_) {
	                return;
	            }
	            document.removeEventListener('transitionend', this.onTransitionEnd_);
	            window.removeEventListener('resize', this.refresh);
	            if (this.mutationsObserver_) {
	                this.mutationsObserver_.disconnect();
	            }
	            if (this.mutationEventsAdded_) {
	                document.removeEventListener('DOMSubtreeModified', this.refresh);
	            }
	            this.mutationsObserver_ = null;
	            this.mutationEventsAdded_ = false;
	            this.connected_ = false;
	        };
	        /**
	         * "Transitionend" event handler.
	         *
	         * @private
	         * @param {TransitionEvent} event
	         * @returns {void}
	         */
	        ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
	            var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
	            // Detect whether transition may affect dimensions of an element.
	            var isReflowProperty = transitionKeys.some(function (key) {
	                return !!~propertyName.indexOf(key);
	            });
	            if (isReflowProperty) {
	                this.refresh();
	            }
	        };
	        /**
	         * Returns instance of the ResizeObserverController.
	         *
	         * @returns {ResizeObserverController}
	         */
	        ResizeObserverController.getInstance = function () {
	            if (!this.instance_) {
	                this.instance_ = new ResizeObserverController();
	            }
	            return this.instance_;
	        };
	        /**
	         * Holds reference to the controller's instance.
	         *
	         * @private {ResizeObserverController}
	         */
	        ResizeObserverController.instance_ = null;
	        return ResizeObserverController;
	    }());
	
	    /**
	     * Defines non-writable/enumerable properties of the provided target object.
	     *
	     * @param {Object} target - Object for which to define properties.
	     * @param {Object} props - Properties to be defined.
	     * @returns {Object} Target object.
	     */
	    var defineConfigurable = (function (target, props) {
	        for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
	            var key = _a[_i];
	            Object.defineProperty(target, key, {
	                value: props[key],
	                enumerable: false,
	                writable: false,
	                configurable: true
	            });
	        }
	        return target;
	    });
	
	    /**
	     * Returns the global object associated with provided element.
	     *
	     * @param {Object} target
	     * @returns {Object}
	     */
	    var getWindowOf = (function (target) {
	        // Assume that the element is an instance of Node, which means that it
	        // has the "ownerDocument" property from which we can retrieve a
	        // corresponding global object.
	        var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
	        // Return the local global object if it's not possible extract one from
	        // provided element.
	        return ownerGlobal || global$1;
	    });
	
	    // Placeholder of an empty content rectangle.
	    var emptyRect = createRectInit(0, 0, 0, 0);
	    /**
	     * Converts provided string to a number.
	     *
	     * @param {number|string} value
	     * @returns {number}
	     */
	    function toFloat(value) {
	        return parseFloat(value) || 0;
	    }
	    /**
	     * Extracts borders size from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @param {...string} positions - Borders positions (top, right, ...)
	     * @returns {number}
	     */
	    function getBordersSize(styles) {
	        var positions = [];
	        for (var _i = 1; _i < arguments.length; _i++) {
	            positions[_i - 1] = arguments[_i];
	        }
	        return positions.reduce(function (size, position) {
	            var value = styles['border-' + position + '-width'];
	            return size + toFloat(value);
	        }, 0);
	    }
	    /**
	     * Extracts paddings sizes from provided styles.
	     *
	     * @param {CSSStyleDeclaration} styles
	     * @returns {Object} Paddings box.
	     */
	    function getPaddings(styles) {
	        var positions = ['top', 'right', 'bottom', 'left'];
	        var paddings = {};
	        for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
	            var position = positions_1[_i];
	            var value = styles['padding-' + position];
	            paddings[position] = toFloat(value);
	        }
	        return paddings;
	    }
	    /**
	     * Calculates content rectangle of provided SVG element.
	     *
	     * @param {SVGGraphicsElement} target - Element content rectangle of which needs
	     *      to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getSVGContentRect(target) {
	        var bbox = target.getBBox();
	        return createRectInit(0, 0, bbox.width, bbox.height);
	    }
	    /**
	     * Calculates content rectangle of provided HTMLElement.
	     *
	     * @param {HTMLElement} target - Element for which to calculate the content rectangle.
	     * @returns {DOMRectInit}
	     */
	    function getHTMLElementContentRect(target) {
	        // Client width & height properties can't be
	        // used exclusively as they provide rounded values.
	        var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
	        // By this condition we can catch all non-replaced inline, hidden and
	        // detached elements. Though elements with width & height properties less
	        // than 0.5 will be discarded as well.
	        //
	        // Without it we would need to implement separate methods for each of
	        // those cases and it's not possible to perform a precise and performance
	        // effective test for hidden elements. E.g. even jQuery's ':visible' filter
	        // gives wrong results for elements with width & height less than 0.5.
	        if (!clientWidth && !clientHeight) {
	            return emptyRect;
	        }
	        var styles = getWindowOf(target).getComputedStyle(target);
	        var paddings = getPaddings(styles);
	        var horizPad = paddings.left + paddings.right;
	        var vertPad = paddings.top + paddings.bottom;
	        // Computed styles of width & height are being used because they are the
	        // only dimensions available to JS that contain non-rounded values. It could
	        // be possible to utilize the getBoundingClientRect if only it's data wasn't
	        // affected by CSS transformations let alone paddings, borders and scroll bars.
	        var width = toFloat(styles.width), height = toFloat(styles.height);
	        // Width & height include paddings and borders when the 'border-box' box
	        // model is applied (except for IE).
	        if (styles.boxSizing === 'border-box') {
	            // Following conditions are required to handle Internet Explorer which
	            // doesn't include paddings and borders to computed CSS dimensions.
	            //
	            // We can say that if CSS dimensions + paddings are equal to the "client"
	            // properties then it's either IE, and thus we don't need to subtract
	            // anything, or an element merely doesn't have paddings/borders styles.
	            if (Math.round(width + horizPad) !== clientWidth) {
	                width -= getBordersSize(styles, 'left', 'right') + horizPad;
	            }
	            if (Math.round(height + vertPad) !== clientHeight) {
	                height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
	            }
	        }
	        // Following steps can't be applied to the document's root element as its
	        // client[Width/Height] properties represent viewport area of the window.
	        // Besides, it's as well not necessary as the <html> itself neither has
	        // rendered scroll bars nor it can be clipped.
	        if (!isDocumentElement(target)) {
	            // In some browsers (only in Firefox, actually) CSS width & height
	            // include scroll bars size which can be removed at this step as scroll
	            // bars are the only difference between rounded dimensions + paddings
	            // and "client" properties, though that is not always true in Chrome.
	            var vertScrollbar = Math.round(width + horizPad) - clientWidth;
	            var horizScrollbar = Math.round(height + vertPad) - clientHeight;
	            // Chrome has a rather weird rounding of "client" properties.
	            // E.g. for an element with content width of 314.2px it sometimes gives
	            // the client width of 315px and for the width of 314.7px it may give
	            // 314px. And it doesn't happen all the time. So just ignore this delta
	            // as a non-relevant.
	            if (Math.abs(vertScrollbar) !== 1) {
	                width -= vertScrollbar;
	            }
	            if (Math.abs(horizScrollbar) !== 1) {
	                height -= horizScrollbar;
	            }
	        }
	        return createRectInit(paddings.left, paddings.top, width, height);
	    }
	    /**
	     * Checks whether provided element is an instance of the SVGGraphicsElement.
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    var isSVGGraphicsElement = (function () {
	        // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
	        // interface.
	        if (typeof SVGGraphicsElement !== 'undefined') {
	            return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
	        }
	        // If it's so, then check that element is at least an instance of the
	        // SVGElement and that it has the "getBBox" method.
	        // eslint-disable-next-line no-extra-parens
	        return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
	            typeof target.getBBox === 'function'); };
	    })();
	    /**
	     * Checks whether provided element is a document element (<html>).
	     *
	     * @param {Element} target - Element to be checked.
	     * @returns {boolean}
	     */
	    function isDocumentElement(target) {
	        return target === getWindowOf(target).document.documentElement;
	    }
	    /**
	     * Calculates an appropriate content rectangle for provided html or svg element.
	     *
	     * @param {Element} target - Element content rectangle of which needs to be calculated.
	     * @returns {DOMRectInit}
	     */
	    function getContentRect(target) {
	        if (!isBrowser) {
	            return emptyRect;
	        }
	        if (isSVGGraphicsElement(target)) {
	            return getSVGContentRect(target);
	        }
	        return getHTMLElementContentRect(target);
	    }
	    /**
	     * Creates rectangle with an interface of the DOMRectReadOnly.
	     * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
	     *
	     * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
	     * @returns {DOMRectReadOnly}
	     */
	    function createReadOnlyRect(_a) {
	        var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
	        // If DOMRectReadOnly is available use it as a prototype for the rectangle.
	        var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
	        var rect = Object.create(Constr.prototype);
	        // Rectangle's properties are not writable and non-enumerable.
	        defineConfigurable(rect, {
	            x: x, y: y, width: width, height: height,
	            top: y,
	            right: x + width,
	            bottom: height + y,
	            left: x
	        });
	        return rect;
	    }
	    /**
	     * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
	     * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
	     *
	     * @param {number} x - X coordinate.
	     * @param {number} y - Y coordinate.
	     * @param {number} width - Rectangle's width.
	     * @param {number} height - Rectangle's height.
	     * @returns {DOMRectInit}
	     */
	    function createRectInit(x, y, width, height) {
	        return { x: x, y: y, width: width, height: height };
	    }
	
	    /**
	     * Class that is responsible for computations of the content rectangle of
	     * provided DOM element and for keeping track of it's changes.
	     */
	    var ResizeObservation = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObservation.
	         *
	         * @param {Element} target - Element to be observed.
	         */
	        function ResizeObservation(target) {
	            /**
	             * Broadcasted width of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastWidth = 0;
	            /**
	             * Broadcasted height of content rectangle.
	             *
	             * @type {number}
	             */
	            this.broadcastHeight = 0;
	            /**
	             * Reference to the last observed content rectangle.
	             *
	             * @private {DOMRectInit}
	             */
	            this.contentRect_ = createRectInit(0, 0, 0, 0);
	            this.target = target;
	        }
	        /**
	         * Updates content rectangle and tells whether it's width or height properties
	         * have changed since the last broadcast.
	         *
	         * @returns {boolean}
	         */
	        ResizeObservation.prototype.isActive = function () {
	            var rect = getContentRect(this.target);
	            this.contentRect_ = rect;
	            return (rect.width !== this.broadcastWidth ||
	                rect.height !== this.broadcastHeight);
	        };
	        /**
	         * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
	         * from the corresponding properties of the last observed content rectangle.
	         *
	         * @returns {DOMRectInit} Last observed content rectangle.
	         */
	        ResizeObservation.prototype.broadcastRect = function () {
	            var rect = this.contentRect_;
	            this.broadcastWidth = rect.width;
	            this.broadcastHeight = rect.height;
	            return rect;
	        };
	        return ResizeObservation;
	    }());
	
	    var ResizeObserverEntry = /** @class */ (function () {
	        /**
	         * Creates an instance of ResizeObserverEntry.
	         *
	         * @param {Element} target - Element that is being observed.
	         * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
	         */
	        function ResizeObserverEntry(target, rectInit) {
	            var contentRect = createReadOnlyRect(rectInit);
	            // According to the specification following properties are not writable
	            // and are also not enumerable in the native implementation.
	            //
	            // Property accessors are not being used as they'd require to define a
	            // private WeakMap storage which may cause memory leaks in browsers that
	            // don't support this type of collections.
	            defineConfigurable(this, { target: target, contentRect: contentRect });
	        }
	        return ResizeObserverEntry;
	    }());
	
	    var ResizeObserverSPI = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback function that is invoked
	         *      when one of the observed elements changes it's content dimensions.
	         * @param {ResizeObserverController} controller - Controller instance which
	         *      is responsible for the updates of observer.
	         * @param {ResizeObserver} callbackCtx - Reference to the public
	         *      ResizeObserver instance which will be passed to callback function.
	         */
	        function ResizeObserverSPI(callback, controller, callbackCtx) {
	            /**
	             * Collection of resize observations that have detected changes in dimensions
	             * of elements.
	             *
	             * @private {Array<ResizeObservation>}
	             */
	            this.activeObservations_ = [];
	            /**
	             * Registry of the ResizeObservation instances.
	             *
	             * @private {Map<Element, ResizeObservation>}
	             */
	            this.observations_ = new MapShim();
	            if (typeof callback !== 'function') {
	                throw new TypeError('The callback provided as parameter 1 is not a function.');
	            }
	            this.callback_ = callback;
	            this.controller_ = controller;
	            this.callbackCtx_ = callbackCtx;
	        }
	        /**
	         * Starts observing provided element.
	         *
	         * @param {Element} target - Element to be observed.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.observe = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is already being observed.
	            if (observations.has(target)) {
	                return;
	            }
	            observations.set(target, new ResizeObservation(target));
	            this.controller_.addObserver(this);
	            // Force the update of observations.
	            this.controller_.refresh();
	        };
	        /**
	         * Stops observing provided element.
	         *
	         * @param {Element} target - Element to stop observing.
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.unobserve = function (target) {
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            // Do nothing if current environment doesn't have the Element interface.
	            if (typeof Element === 'undefined' || !(Element instanceof Object)) {
	                return;
	            }
	            if (!(target instanceof getWindowOf(target).Element)) {
	                throw new TypeError('parameter 1 is not of type "Element".');
	            }
	            var observations = this.observations_;
	            // Do nothing if element is not being observed.
	            if (!observations.has(target)) {
	                return;
	            }
	            observations.delete(target);
	            if (!observations.size) {
	                this.controller_.removeObserver(this);
	            }
	        };
	        /**
	         * Stops observing all elements.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.disconnect = function () {
	            this.clearActive();
	            this.observations_.clear();
	            this.controller_.removeObserver(this);
	        };
	        /**
	         * Collects observation instances the associated element of which has changed
	         * it's content rectangle.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.gatherActive = function () {
	            var _this = this;
	            this.clearActive();
	            this.observations_.forEach(function (observation) {
	                if (observation.isActive()) {
	                    _this.activeObservations_.push(observation);
	                }
	            });
	        };
	        /**
	         * Invokes initial callback function with a list of ResizeObserverEntry
	         * instances collected from active resize observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.broadcastActive = function () {
	            // Do nothing if observer doesn't have active observations.
	            if (!this.hasActive()) {
	                return;
	            }
	            var ctx = this.callbackCtx_;
	            // Create ResizeObserverEntry instance for every active observation.
	            var entries = this.activeObservations_.map(function (observation) {
	                return new ResizeObserverEntry(observation.target, observation.broadcastRect());
	            });
	            this.callback_.call(ctx, entries, ctx);
	            this.clearActive();
	        };
	        /**
	         * Clears the collection of active observations.
	         *
	         * @returns {void}
	         */
	        ResizeObserverSPI.prototype.clearActive = function () {
	            this.activeObservations_.splice(0);
	        };
	        /**
	         * Tells whether observer has active observations.
	         *
	         * @returns {boolean}
	         */
	        ResizeObserverSPI.prototype.hasActive = function () {
	            return this.activeObservations_.length > 0;
	        };
	        return ResizeObserverSPI;
	    }());
	
	    // Registry of internal observers. If WeakMap is not available use current shim
	    // for the Map collection as it has all required methods and because WeakMap
	    // can't be fully polyfilled anyway.
	    var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
	    /**
	     * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
	     * exposing only those methods and properties that are defined in the spec.
	     */
	    var ResizeObserver = /** @class */ (function () {
	        /**
	         * Creates a new instance of ResizeObserver.
	         *
	         * @param {ResizeObserverCallback} callback - Callback that is invoked when
	         *      dimensions of the observed elements change.
	         */
	        function ResizeObserver(callback) {
	            if (!(this instanceof ResizeObserver)) {
	                throw new TypeError('Cannot call a class as a function.');
	            }
	            if (!arguments.length) {
	                throw new TypeError('1 argument required, but only 0 present.');
	            }
	            var controller = ResizeObserverController.getInstance();
	            var observer = new ResizeObserverSPI(callback, controller, this);
	            observers.set(this, observer);
	        }
	        return ResizeObserver;
	    }());
	    // Expose public methods of ResizeObserver.
	    [
	        'observe',
	        'unobserve',
	        'disconnect'
	    ].forEach(function (method) {
	        ResizeObserver.prototype[method] = function () {
	            var _a;
	            return (_a = observers.get(this))[method].apply(_a, arguments);
	        };
	    });
	
	    var index = (function () {
	        // Export existing implementation if available.
	        if (typeof global$1.ResizeObserver !== 'undefined') {
	            return global$1.ResizeObserver;
	        }
	        return ResizeObserver;
	    })();
	
	    return index;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 392 */
/***/ function(module, exports) {

	var dpr = 1; // If in browser environment
	
	if (typeof window !== 'undefined') {
	  dpr = Math.max(window.devicePixelRatio || 1, 1);
	}
	/**
	 * config默认配置项
	 * @exports zrender/config
	 * @author Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 */
	
	/**
	 * Debug log mode:
	 * 0: Do nothing, for release.
	 * 1: console.error, for debug.
	 */
	
	
	var debugMode = 0; // retina 屏幕优化
	
	var devicePixelRatio = dpr;
	exports.debugMode = debugMode;
	exports.devicePixelRatio = devicePixelRatio;

/***/ },
/* 393 */
/***/ function(module, exports) {

	/**
	 * @param {Array.<Object>} colorStops
	 */
	var Gradient = function (colorStops) {
	  this.colorStops = colorStops || [];
	};
	
	Gradient.prototype = {
	  constructor: Gradient,
	  addColorStop: function (offset, color) {
	    this.colorStops.push({
	      offset: offset,
	      color: color
	    });
	  }
	};
	var _default = Gradient;
	module.exports = _default;

/***/ },
/* 394 */
/***/ function(module, exports) {

	var ContextCachedBy = {
	  NONE: 0,
	  STYLE_BIND: 1,
	  PLAIN_TEXT: 2
	}; // Avoid confused with 0/false.
	
	var WILL_BE_RESTORED = 9;
	exports.ContextCachedBy = ContextCachedBy;
	exports.WILL_BE_RESTORED = WILL_BE_RESTORED;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(4);
	
	var retrieve2 = _util.retrieve2;
	var retrieve3 = _util.retrieve3;
	var each = _util.each;
	var normalizeCssArray = _util.normalizeCssArray;
	var isString = _util.isString;
	var isObject = _util.isObject;
	
	var textContain = __webpack_require__(102);
	
	var roundRectHelper = __webpack_require__(1202);
	
	var imageHelper = __webpack_require__(604);
	
	var fixShadow = __webpack_require__(1200);
	
	var _constant = __webpack_require__(394);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
	var DEFAULT_FONT = textContain.DEFAULT_FONT; // TODO: Have not support 'start', 'end' yet.
	
	var VALID_TEXT_ALIGN = {
	  left: 1,
	  right: 1,
	  center: 1
	};
	var VALID_TEXT_VERTICAL_ALIGN = {
	  top: 1,
	  bottom: 1,
	  middle: 1
	}; // Different from `STYLE_COMMON_PROPS` of `graphic/Style`,
	// the default value of shadowColor is `'transparent'`.
	
	var SHADOW_STYLE_COMMON_PROPS = [['textShadowBlur', 'shadowBlur', 0], ['textShadowOffsetX', 'shadowOffsetX', 0], ['textShadowOffsetY', 'shadowOffsetY', 0], ['textShadowColor', 'shadowColor', 'transparent']];
	var _tmpTextPositionResult = {};
	var _tmpBoxPositionResult = {};
	/**
	 * @param {module:zrender/graphic/Style} style
	 * @return {module:zrender/graphic/Style} The input style.
	 */
	
	function normalizeTextStyle(style) {
	  normalizeStyle(style);
	  each(style.rich, normalizeStyle);
	  return style;
	}
	
	function normalizeStyle(style) {
	  if (style) {
	    style.font = textContain.makeFont(style);
	    var textAlign = style.textAlign;
	    textAlign === 'middle' && (textAlign = 'center');
	    style.textAlign = textAlign == null || VALID_TEXT_ALIGN[textAlign] ? textAlign : 'left'; // Compatible with textBaseline.
	
	    var textVerticalAlign = style.textVerticalAlign || style.textBaseline;
	    textVerticalAlign === 'center' && (textVerticalAlign = 'middle');
	    style.textVerticalAlign = textVerticalAlign == null || VALID_TEXT_VERTICAL_ALIGN[textVerticalAlign] ? textVerticalAlign : 'top';
	    var textPadding = style.textPadding;
	
	    if (textPadding) {
	      style.textPadding = normalizeCssArray(style.textPadding);
	    }
	  }
	}
	/**
	 * @param {CanvasRenderingContext2D} ctx
	 * @param {string} text
	 * @param {module:zrender/graphic/Style} style
	 * @param {Object|boolean} [rect] {x, y, width, height}
	 *                  If set false, rect text is not used.
	 * @param {Element|module:zrender/graphic/helper/constant.WILL_BE_RESTORED} [prevEl] For ctx prop cache.
	 */
	
	
	function renderText(hostEl, ctx, text, style, rect, prevEl) {
	  style.rich ? renderRichText(hostEl, ctx, text, style, rect, prevEl) : renderPlainText(hostEl, ctx, text, style, rect, prevEl);
	} // Avoid setting to ctx according to prevEl if possible for
	// performance in scenarios of large amount text.
	
	
	function renderPlainText(hostEl, ctx, text, style, rect, prevEl) {
	  'use strict';
	
	  var needDrawBg = needDrawBackground(style);
	  var prevStyle;
	  var checkCache = false;
	  var cachedByMe = ctx.__attrCachedBy === ContextCachedBy.PLAIN_TEXT; // Only take and check cache for `Text` el, but not RectText.
	
	  if (prevEl !== WILL_BE_RESTORED) {
	    if (prevEl) {
	      prevStyle = prevEl.style;
	      checkCache = !needDrawBg && cachedByMe && prevStyle;
	    } // Prevent from using cache in `Style::bind`, because of the case:
	    // ctx property is modified by other properties than `Style::bind`
	    // used, and Style::bind is called next.
	
	
	    ctx.__attrCachedBy = needDrawBg ? ContextCachedBy.NONE : ContextCachedBy.PLAIN_TEXT;
	  } // Since this will be restored, prevent from using these props to check cache in the next
	  // entering of this method. But do not need to clear other cache like `Style::bind`.
	  else if (cachedByMe) {
	      ctx.__attrCachedBy = ContextCachedBy.NONE;
	    }
	
	  var styleFont = style.font || DEFAULT_FONT; // PENDING
	  // Only `Text` el set `font` and keep it (`RectText` will restore). So theoretically
	  // we can make font cache on ctx, which can cache for text el that are discontinuous.
	  // But layer save/restore needed to be considered.
	  // if (styleFont !== ctx.__fontCache) {
	  //     ctx.font = styleFont;
	  //     if (prevEl !== WILL_BE_RESTORED) {
	  //         ctx.__fontCache = styleFont;
	  //     }
	  // }
	
	  if (!checkCache || styleFont !== (prevStyle.font || DEFAULT_FONT)) {
	    ctx.font = styleFont;
	  } // Use the final font from context-2d, because the final
	  // font might not be the style.font when it is illegal.
	  // But get `ctx.font` might be time consuming.
	
	
	  var computedFont = hostEl.__computedFont;
	
	  if (hostEl.__styleFont !== styleFont) {
	    hostEl.__styleFont = styleFont;
	    computedFont = hostEl.__computedFont = ctx.font;
	  }
	
	  var textPadding = style.textPadding;
	  var textLineHeight = style.textLineHeight;
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirtyText) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var textLines = contentBlock.lines;
	  var lineHeight = contentBlock.lineHeight;
	  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign || 'left';
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var textX = baseX;
	  var textY = boxY;
	
	  if (needDrawBg || textPadding) {
	    // Consider performance, do not call getTextWidth util necessary.
	    var textWidth = textContain.getWidth(text, computedFont);
	    var outerWidth = textWidth;
	    textPadding && (outerWidth += textPadding[1] + textPadding[3]);
	    var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	    needDrawBg && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	    if (textPadding) {
	      textX = getTextXForPadding(baseX, textAlign, textPadding);
	      textY += textPadding[0];
	    }
	  } // Always set textAlign and textBase line, because it is difficute to calculate
	  // textAlign from prevEl, and we dont sure whether textAlign will be reset if
	  // font set happened.
	
	
	  ctx.textAlign = textAlign; // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  ctx.textBaseline = 'middle'; // Set text opacity
	
	  ctx.globalAlpha = style.opacity || 1; // Always set shadowBlur and shadowOffset to avoid leak from displayable.
	
	  for (var i = 0; i < SHADOW_STYLE_COMMON_PROPS.length; i++) {
	    var propItem = SHADOW_STYLE_COMMON_PROPS[i];
	    var styleProp = propItem[0];
	    var ctxProp = propItem[1];
	    var val = style[styleProp];
	
	    if (!checkCache || val !== prevStyle[styleProp]) {
	      ctx[ctxProp] = fixShadow(ctx, ctxProp, val || propItem[2]);
	    }
	  } // `textBaseline` is set as 'middle'.
	
	
	  textY += lineHeight / 2;
	  var textStrokeWidth = style.textStrokeWidth;
	  var textStrokeWidthPrev = checkCache ? prevStyle.textStrokeWidth : null;
	  var strokeWidthChanged = !checkCache || textStrokeWidth !== textStrokeWidthPrev;
	  var strokeChanged = !checkCache || strokeWidthChanged || style.textStroke !== prevStyle.textStroke;
	  var textStroke = getStroke(style.textStroke, textStrokeWidth);
	  var textFill = getFill(style.textFill);
	
	  if (textStroke) {
	    if (strokeWidthChanged) {
	      ctx.lineWidth = textStrokeWidth;
	    }
	
	    if (strokeChanged) {
	      ctx.strokeStyle = textStroke;
	    }
	  }
	
	  if (textFill) {
	    if (!checkCache || style.textFill !== prevStyle.textFill) {
	      ctx.fillStyle = textFill;
	    }
	  } // Optimize simply, in most cases only one line exists.
	
	
	  if (textLines.length === 1) {
	    // Fill after stroke so the outline will not cover the main part.
	    textStroke && ctx.strokeText(textLines[0], textX, textY);
	    textFill && ctx.fillText(textLines[0], textX, textY);
	  } else {
	    for (var i = 0; i < textLines.length; i++) {
	      // Fill after stroke so the outline will not cover the main part.
	      textStroke && ctx.strokeText(textLines[i], textX, textY);
	      textFill && ctx.fillText(textLines[i], textX, textY);
	      textY += lineHeight;
	    }
	  }
	}
	
	function renderRichText(hostEl, ctx, text, style, rect, prevEl) {
	  // Do not do cache for rich text because of the complexity.
	  // But `RectText` this will be restored, do not need to clear other cache like `Style::bind`.
	  if (prevEl !== WILL_BE_RESTORED) {
	    ctx.__attrCachedBy = ContextCachedBy.NONE;
	  }
	
	  var contentBlock = hostEl.__textCotentBlock;
	
	  if (!contentBlock || hostEl.__dirtyText) {
	    contentBlock = hostEl.__textCotentBlock = textContain.parseRichText(text, style);
	  }
	
	  drawRichText(hostEl, ctx, contentBlock, style, rect);
	}
	
	function drawRichText(hostEl, ctx, contentBlock, style, rect) {
	  var contentWidth = contentBlock.width;
	  var outerWidth = contentBlock.outerWidth;
	  var outerHeight = contentBlock.outerHeight;
	  var textPadding = style.textPadding;
	  var boxPos = getBoxPosition(_tmpBoxPositionResult, hostEl, style, rect);
	  var baseX = boxPos.baseX;
	  var baseY = boxPos.baseY;
	  var textAlign = boxPos.textAlign;
	  var textVerticalAlign = boxPos.textVerticalAlign; // Origin of textRotation should be the base point of text drawing.
	
	  applyTextRotation(ctx, style, rect, baseX, baseY);
	  var boxX = textContain.adjustTextX(baseX, outerWidth, textAlign);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var xLeft = boxX;
	  var lineTop = boxY;
	
	  if (textPadding) {
	    xLeft += textPadding[3];
	    lineTop += textPadding[0];
	  }
	
	  var xRight = xLeft + contentWidth;
	  needDrawBackground(style) && drawBackground(hostEl, ctx, style, boxX, boxY, outerWidth, outerHeight);
	
	  for (var i = 0; i < contentBlock.lines.length; i++) {
	    var line = contentBlock.lines[i];
	    var tokens = line.tokens;
	    var tokenCount = tokens.length;
	    var lineHeight = line.lineHeight;
	    var usedWidth = line.width;
	    var leftIndex = 0;
	    var lineXLeft = xLeft;
	    var lineXRight = xRight;
	    var rightIndex = tokenCount - 1;
	    var token;
	
	    while (leftIndex < tokenCount && (token = tokens[leftIndex], !token.textAlign || token.textAlign === 'left')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft, 'left');
	      usedWidth -= token.width;
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    while (rightIndex >= 0 && (token = tokens[rightIndex], token.textAlign === 'right')) {
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXRight, 'right');
	      usedWidth -= token.width;
	      lineXRight -= token.width;
	      rightIndex--;
	    } // The other tokens are placed as textAlign 'center' if there is enough space.
	
	
	    lineXLeft += (contentWidth - (lineXLeft - xLeft) - (xRight - lineXRight) - usedWidth) / 2;
	
	    while (leftIndex <= rightIndex) {
	      token = tokens[leftIndex]; // Consider width specified by user, use 'center' rather than 'left'.
	
	      placeToken(hostEl, ctx, token, style, lineHeight, lineTop, lineXLeft + token.width / 2, 'center');
	      lineXLeft += token.width;
	      leftIndex++;
	    }
	
	    lineTop += lineHeight;
	  }
	}
	
	function applyTextRotation(ctx, style, rect, x, y) {
	  // textRotation only apply in RectText.
	  if (rect && style.textRotation) {
	    var origin = style.textOrigin;
	
	    if (origin === 'center') {
	      x = rect.width / 2 + rect.x;
	      y = rect.height / 2 + rect.y;
	    } else if (origin) {
	      x = origin[0] + rect.x;
	      y = origin[1] + rect.y;
	    }
	
	    ctx.translate(x, y); // Positive: anticlockwise
	
	    ctx.rotate(-style.textRotation);
	    ctx.translate(-x, -y);
	  }
	}
	
	function placeToken(hostEl, ctx, token, style, lineHeight, lineTop, x, textAlign) {
	  var tokenStyle = style.rich[token.styleName] || {};
	  tokenStyle.text = token.text; // 'ctx.textBaseline' is always set as 'middle', for sake of
	  // the bias of "Microsoft YaHei".
	
	  var textVerticalAlign = token.textVerticalAlign;
	  var y = lineTop + lineHeight / 2;
	
	  if (textVerticalAlign === 'top') {
	    y = lineTop + token.height / 2;
	  } else if (textVerticalAlign === 'bottom') {
	    y = lineTop + lineHeight - token.height / 2;
	  }
	
	  !token.isLineHolder && needDrawBackground(tokenStyle) && drawBackground(hostEl, ctx, tokenStyle, textAlign === 'right' ? x - token.width : textAlign === 'center' ? x - token.width / 2 : x, y - token.height / 2, token.width, token.height);
	  var textPadding = token.textPadding;
	
	  if (textPadding) {
	    x = getTextXForPadding(x, textAlign, textPadding);
	    y -= token.height / 2 - textPadding[2] - token.textHeight / 2;
	  }
	
	  setCtx(ctx, 'shadowBlur', retrieve3(tokenStyle.textShadowBlur, style.textShadowBlur, 0));
	  setCtx(ctx, 'shadowColor', tokenStyle.textShadowColor || style.textShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', retrieve3(tokenStyle.textShadowOffsetX, style.textShadowOffsetX, 0));
	  setCtx(ctx, 'shadowOffsetY', retrieve3(tokenStyle.textShadowOffsetY, style.textShadowOffsetY, 0));
	  setCtx(ctx, 'textAlign', textAlign); // Force baseline to be "middle". Otherwise, if using "top", the
	  // text will offset downward a little bit in font "Microsoft YaHei".
	
	  setCtx(ctx, 'textBaseline', 'middle');
	  setCtx(ctx, 'font', token.font || DEFAULT_FONT);
	  var textStroke = getStroke(tokenStyle.textStroke || style.textStroke, textStrokeWidth);
	  var textFill = getFill(tokenStyle.textFill || style.textFill);
	  var textStrokeWidth = retrieve2(tokenStyle.textStrokeWidth, style.textStrokeWidth); // Fill after stroke so the outline will not cover the main part.
	
	  if (textStroke) {
	    setCtx(ctx, 'lineWidth', textStrokeWidth);
	    setCtx(ctx, 'strokeStyle', textStroke);
	    ctx.strokeText(token.text, x, y);
	  }
	
	  if (textFill) {
	    setCtx(ctx, 'fillStyle', textFill);
	    ctx.fillText(token.text, x, y);
	  }
	}
	
	function needDrawBackground(style) {
	  return !!(style.textBackgroundColor || style.textBorderWidth && style.textBorderColor);
	} // style: {textBackgroundColor, textBorderWidth, textBorderColor, textBorderRadius, text}
	// shape: {x, y, width, height}
	
	
	function drawBackground(hostEl, ctx, style, x, y, width, height) {
	  var textBackgroundColor = style.textBackgroundColor;
	  var textBorderWidth = style.textBorderWidth;
	  var textBorderColor = style.textBorderColor;
	  var isPlainBg = isString(textBackgroundColor);
	  setCtx(ctx, 'shadowBlur', style.textBoxShadowBlur || 0);
	  setCtx(ctx, 'shadowColor', style.textBoxShadowColor || 'transparent');
	  setCtx(ctx, 'shadowOffsetX', style.textBoxShadowOffsetX || 0);
	  setCtx(ctx, 'shadowOffsetY', style.textBoxShadowOffsetY || 0);
	
	  if (isPlainBg || textBorderWidth && textBorderColor) {
	    ctx.beginPath();
	    var textBorderRadius = style.textBorderRadius;
	
	    if (!textBorderRadius) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, {
	        x: x,
	        y: y,
	        width: width,
	        height: height,
	        r: textBorderRadius
	      });
	    }
	
	    ctx.closePath();
	  }
	
	  if (isPlainBg) {
	    setCtx(ctx, 'fillStyle', textBackgroundColor);
	
	    if (style.fillOpacity != null) {
	      var originalGlobalAlpha = ctx.globalAlpha;
	      ctx.globalAlpha = style.fillOpacity * style.opacity;
	      ctx.fill();
	      ctx.globalAlpha = originalGlobalAlpha;
	    } else {
	      ctx.fill();
	    }
	  } else if (isObject(textBackgroundColor)) {
	    var image = textBackgroundColor.image;
	    image = imageHelper.createOrUpdateImage(image, null, hostEl, onBgImageLoaded, textBackgroundColor);
	
	    if (image && imageHelper.isImageReady(image)) {
	      ctx.drawImage(image, x, y, width, height);
	    }
	  }
	
	  if (textBorderWidth && textBorderColor) {
	    setCtx(ctx, 'lineWidth', textBorderWidth);
	    setCtx(ctx, 'strokeStyle', textBorderColor);
	
	    if (style.strokeOpacity != null) {
	      var originalGlobalAlpha = ctx.globalAlpha;
	      ctx.globalAlpha = style.strokeOpacity * style.opacity;
	      ctx.stroke();
	      ctx.globalAlpha = originalGlobalAlpha;
	    } else {
	      ctx.stroke();
	    }
	  }
	}
	
	function onBgImageLoaded(image, textBackgroundColor) {
	  // Replace image, so that `contain/text.js#parseRichText`
	  // will get correct result in next tick.
	  textBackgroundColor.image = image;
	}
	
	function getBoxPosition(out, hostEl, style, rect) {
	  var baseX = style.x || 0;
	  var baseY = style.y || 0;
	  var textAlign = style.textAlign;
	  var textVerticalAlign = style.textVerticalAlign; // Text position represented by coord
	
	  if (rect) {
	    var textPosition = style.textPosition;
	
	    if (textPosition instanceof Array) {
	      // Percent
	      baseX = rect.x + parsePercent(textPosition[0], rect.width);
	      baseY = rect.y + parsePercent(textPosition[1], rect.height);
	    } else {
	      var res = hostEl && hostEl.calculateTextPosition ? hostEl.calculateTextPosition(_tmpTextPositionResult, style, rect) : textContain.calculateTextPosition(_tmpTextPositionResult, style, rect);
	      baseX = res.x;
	      baseY = res.y; // Default align and baseline when has textPosition
	
	      textAlign = textAlign || res.textAlign;
	      textVerticalAlign = textVerticalAlign || res.textVerticalAlign;
	    } // textOffset is only support in RectText, otherwise
	    // we have to adjust boundingRect for textOffset.
	
	
	    var textOffset = style.textOffset;
	
	    if (textOffset) {
	      baseX += textOffset[0];
	      baseY += textOffset[1];
	    }
	  }
	
	  out = out || {};
	  out.baseX = baseX;
	  out.baseY = baseY;
	  out.textAlign = textAlign;
	  out.textVerticalAlign = textVerticalAlign;
	  return out;
	}
	
	function setCtx(ctx, prop, value) {
	  ctx[prop] = fixShadow(ctx, prop, value);
	  return ctx[prop];
	}
	/**
	 * @param {string} [stroke] If specified, do not check style.textStroke.
	 * @param {string} [lineWidth] If specified, do not check style.textStroke.
	 * @param {number} style
	 */
	
	
	function getStroke(stroke, lineWidth) {
	  return stroke == null || lineWidth <= 0 || stroke === 'transparent' || stroke === 'none' ? null // TODO pattern and gradient?
	  : stroke.image || stroke.colorStops ? '#000' : stroke;
	}
	
	function getFill(fill) {
	  return fill == null || fill === 'none' ? null // TODO pattern and gradient?
	  : fill.image || fill.colorStops ? '#000' : fill;
	}
	
	function parsePercent(value, maxValue) {
	  if (typeof value === 'string') {
	    if (value.lastIndexOf('%') >= 0) {
	      return parseFloat(value) / 100 * maxValue;
	    }
	
	    return parseFloat(value);
	  }
	
	  return value;
	}
	
	function getTextXForPadding(x, textAlign, textPadding) {
	  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
	}
	/**
	 * @param {string} text
	 * @param {module:zrender/Style} style
	 * @return {boolean}
	 */
	
	
	function needDrawText(text, style) {
	  return text != null && (text || style.textBackgroundColor || style.textBorderWidth && style.textBorderColor || style.textPadding);
	}
	
	exports.normalizeTextStyle = normalizeTextStyle;
	exports.renderText = renderText;
	exports.getBoxPosition = getBoxPosition;
	exports.getStroke = getStroke;
	exports.getFill = getFill;
	exports.parsePercent = parsePercent;
	exports.needDrawText = needDrawText;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	var matrix = __webpack_require__(86);
	
	var vector = __webpack_require__(55);
	
	/**
	 * 提供变换扩展
	 * @module zrender/mixin/Transformable
	 * @author pissang (https://www.github.com/pissang)
	 */
	var mIdentity = matrix.identity;
	var EPSILON = 5e-5;
	
	function isNotAroundZero(val) {
	  return val > EPSILON || val < -EPSILON;
	}
	/**
	 * @alias module:zrender/mixin/Transformable
	 * @constructor
	 */
	
	
	var Transformable = function (opts) {
	  opts = opts || {}; // If there are no given position, rotation, scale
	
	  if (!opts.position) {
	    /**
	     * 平移
	     * @type {Array.<number>}
	     * @default [0, 0]
	     */
	    this.position = [0, 0];
	  }
	
	  if (opts.rotation == null) {
	    /**
	     * 旋转
	     * @type {Array.<number>}
	     * @default 0
	     */
	    this.rotation = 0;
	  }
	
	  if (!opts.scale) {
	    /**
	     * 缩放
	     * @type {Array.<number>}
	     * @default [1, 1]
	     */
	    this.scale = [1, 1];
	  }
	  /**
	   * 旋转和缩放的原点
	   * @type {Array.<number>}
	   * @default null
	   */
	
	
	  this.origin = this.origin || null;
	};
	
	var transformableProto = Transformable.prototype;
	transformableProto.transform = null;
	/**
	 * 判断是否需要有坐标变换
	 * 如果有坐标变换, 则从position, rotation, scale以及父节点的transform计算出自身的transform矩阵
	 */
	
	transformableProto.needLocalTransform = function () {
	  return isNotAroundZero(this.rotation) || isNotAroundZero(this.position[0]) || isNotAroundZero(this.position[1]) || isNotAroundZero(this.scale[0] - 1) || isNotAroundZero(this.scale[1] - 1);
	};
	
	var scaleTmp = [];
	
	transformableProto.updateTransform = function () {
	  var parent = this.parent;
	  var parentHasTransform = parent && parent.transform;
	  var needLocalTransform = this.needLocalTransform();
	  var m = this.transform;
	
	  if (!(needLocalTransform || parentHasTransform)) {
	    m && mIdentity(m);
	    return;
	  }
	
	  m = m || matrix.create();
	
	  if (needLocalTransform) {
	    this.getLocalTransform(m);
	  } else {
	    mIdentity(m);
	  } // 应用父节点变换
	
	
	  if (parentHasTransform) {
	    if (needLocalTransform) {
	      matrix.mul(m, parent.transform, m);
	    } else {
	      matrix.copy(m, parent.transform);
	    }
	  } // 保存这个变换矩阵
	
	
	  this.transform = m;
	  var globalScaleRatio = this.globalScaleRatio;
	
	  if (globalScaleRatio != null && globalScaleRatio !== 1) {
	    this.getGlobalScale(scaleTmp);
	    var relX = scaleTmp[0] < 0 ? -1 : 1;
	    var relY = scaleTmp[1] < 0 ? -1 : 1;
	    var sx = ((scaleTmp[0] - relX) * globalScaleRatio + relX) / scaleTmp[0] || 0;
	    var sy = ((scaleTmp[1] - relY) * globalScaleRatio + relY) / scaleTmp[1] || 0;
	    m[0] *= sx;
	    m[1] *= sx;
	    m[2] *= sy;
	    m[3] *= sy;
	  }
	
	  this.invTransform = this.invTransform || matrix.create();
	  matrix.invert(this.invTransform, m);
	};
	
	transformableProto.getLocalTransform = function (m) {
	  return Transformable.getLocalTransform(this, m);
	};
	/**
	 * 将自己的transform应用到context上
	 * @param {CanvasRenderingContext2D} ctx
	 */
	
	
	transformableProto.setTransform = function (ctx) {
	  var m = this.transform;
	  var dpr = ctx.dpr || 1;
	
	  if (m) {
	    ctx.setTransform(dpr * m[0], dpr * m[1], dpr * m[2], dpr * m[3], dpr * m[4], dpr * m[5]);
	  } else {
	    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	  }
	};
	
	transformableProto.restoreTransform = function (ctx) {
	  var dpr = ctx.dpr || 1;
	  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
	};
	
	var tmpTransform = [];
	var originTransform = matrix.create();
	
	transformableProto.setLocalTransform = function (m) {
	  if (!m) {
	    // TODO return or set identity?
	    return;
	  }
	
	  var sx = m[0] * m[0] + m[1] * m[1];
	  var sy = m[2] * m[2] + m[3] * m[3];
	  var position = this.position;
	  var scale = this.scale;
	
	  if (isNotAroundZero(sx - 1)) {
	    sx = Math.sqrt(sx);
	  }
	
	  if (isNotAroundZero(sy - 1)) {
	    sy = Math.sqrt(sy);
	  }
	
	  if (m[0] < 0) {
	    sx = -sx;
	  }
	
	  if (m[3] < 0) {
	    sy = -sy;
	  }
	
	  position[0] = m[4];
	  position[1] = m[5];
	  scale[0] = sx;
	  scale[1] = sy;
	  this.rotation = Math.atan2(-m[1] / sy, m[0] / sx);
	};
	/**
	 * 分解`transform`矩阵到`position`, `rotation`, `scale`
	 */
	
	
	transformableProto.decomposeTransform = function () {
	  if (!this.transform) {
	    return;
	  }
	
	  var parent = this.parent;
	  var m = this.transform;
	
	  if (parent && parent.transform) {
	    // Get local transform and decompose them to position, scale, rotation
	    matrix.mul(tmpTransform, parent.invTransform, m);
	    m = tmpTransform;
	  }
	
	  var origin = this.origin;
	
	  if (origin && (origin[0] || origin[1])) {
	    originTransform[4] = origin[0];
	    originTransform[5] = origin[1];
	    matrix.mul(tmpTransform, m, originTransform);
	    tmpTransform[4] -= origin[0];
	    tmpTransform[5] -= origin[1];
	    m = tmpTransform;
	  }
	
	  this.setLocalTransform(m);
	};
	/**
	 * Get global scale
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.getGlobalScale = function (out) {
	  var m = this.transform;
	  out = out || [];
	
	  if (!m) {
	    out[0] = 1;
	    out[1] = 1;
	    return out;
	  }
	
	  out[0] = Math.sqrt(m[0] * m[0] + m[1] * m[1]);
	  out[1] = Math.sqrt(m[2] * m[2] + m[3] * m[3]);
	
	  if (m[0] < 0) {
	    out[0] = -out[0];
	  }
	
	  if (m[3] < 0) {
	    out[1] = -out[1];
	  }
	
	  return out;
	};
	/**
	 * 变换坐标位置到 shape 的局部坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToLocal = function (x, y) {
	  var v2 = [x, y];
	  var invTransform = this.invTransform;
	
	  if (invTransform) {
	    vector.applyTransform(v2, v2, invTransform);
	  }
	
	  return v2;
	};
	/**
	 * 变换局部坐标位置到全局坐标空间
	 * @method
	 * @param {number} x
	 * @param {number} y
	 * @return {Array.<number>}
	 */
	
	
	transformableProto.transformCoordToGlobal = function (x, y) {
	  var v2 = [x, y];
	  var transform = this.transform;
	
	  if (transform) {
	    vector.applyTransform(v2, v2, transform);
	  }
	
	  return v2;
	};
	/**
	 * @static
	 * @param {Object} target
	 * @param {Array.<number>} target.origin
	 * @param {number} target.rotation
	 * @param {Array.<number>} target.position
	 * @param {Array.<number>} [m]
	 */
	
	
	Transformable.getLocalTransform = function (target, m) {
	  m = m || [];
	  mIdentity(m);
	  var origin = target.origin;
	  var scale = target.scale || [1, 1];
	  var rotation = target.rotation || 0;
	  var position = target.position || [0, 0];
	
	  if (origin) {
	    // Translate to origin
	    m[4] -= origin[0];
	    m[5] -= origin[1];
	  }
	
	  matrix.scale(m, m, scale);
	
	  if (rotation) {
	    matrix.rotate(m, m, rotation);
	  }
	
	  if (origin) {
	    // Translate back from origin
	    m[4] += origin[0];
	    m[5] += origin[1];
	  }
	
	  m[4] += position[0];
	  m[5] += position[1];
	  return m;
	};
	
	var _default = Transformable;
	module.exports = _default;

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(1197);
	
	var env = __webpack_require__(73);
	
	var zrUtil = __webpack_require__(4);
	
	var Handler = __webpack_require__(2970);
	
	var Storage = __webpack_require__(2973);
	
	var Painter = __webpack_require__(2972);
	
	var Animation = __webpack_require__(2974);
	
	var HandlerProxy = __webpack_require__(2983);
	
	/*!
	* ZRender, a high performance 2d drawing library.
	*
	* Copyright (c) 2013, Baidu Inc.
	* All rights reserved.
	*
	* LICENSE
	* https://github.com/ecomfe/zrender/blob/master/LICENSE.txt
	*/
	var useVML = !env.canvasSupported;
	var painterCtors = {
	  canvas: Painter
	};
	var instances = {}; // ZRender实例map索引
	
	/**
	 * @type {string}
	 */
	
	var version = '4.3.2';
	/**
	 * Initializing a zrender instance
	 * @param {HTMLElement} dom
	 * @param {Object} [opts]
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	 * @return {module:zrender/ZRender}
	 */
	
	function init(dom, opts) {
	  var zr = new ZRender(guid(), dom, opts);
	  instances[zr.id] = zr;
	  return zr;
	}
	/**
	 * Dispose zrender instance
	 * @param {module:zrender/ZRender} zr
	 */
	
	
	function dispose(zr) {
	  if (zr) {
	    zr.dispose();
	  } else {
	    for (var key in instances) {
	      if (instances.hasOwnProperty(key)) {
	        instances[key].dispose();
	      }
	    }
	
	    instances = {};
	  }
	
	  return this;
	}
	/**
	 * Get zrender instance by id
	 * @param {string} id zrender instance id
	 * @return {module:zrender/ZRender}
	 */
	
	
	function getInstance(id) {
	  return instances[id];
	}
	
	function registerPainter(name, Ctor) {
	  painterCtors[name] = Ctor;
	}
	
	function delInstance(id) {
	  delete instances[id];
	}
	/**
	 * @module zrender/ZRender
	 */
	
	/**
	 * @constructor
	 * @alias module:zrender/ZRender
	 * @param {string} id
	 * @param {HTMLElement} dom
	 * @param {Object} opts
	 * @param {string} [opts.renderer='canvas'] 'canvas' or 'svg'
	 * @param {number} [opts.devicePixelRatio]
	 * @param {number} [opts.width] Can be 'auto' (the same as null/undefined)
	 * @param {number} [opts.height] Can be 'auto' (the same as null/undefined)
	 */
	
	
	var ZRender = function (id, dom, opts) {
	  opts = opts || {};
	  /**
	   * @type {HTMLDomElement}
	   */
	
	  this.dom = dom;
	  /**
	   * @type {string}
	   */
	
	  this.id = id;
	  var self = this;
	  var storage = new Storage();
	  var rendererType = opts.renderer; // TODO WebGL
	
	  if (useVML) {
	    if (!painterCtors.vml) {
	      throw new Error('You need to require \'zrender/vml/vml\' to support IE8');
	    }
	
	    rendererType = 'vml';
	  } else if (!rendererType || !painterCtors[rendererType]) {
	    rendererType = 'canvas';
	  }
	
	  var painter = new painterCtors[rendererType](dom, storage, opts, id);
	  this.storage = storage;
	  this.painter = painter;
	  var handerProxy = !env.node && !env.worker ? new HandlerProxy(painter.getViewportRoot(), painter.root) : null;
	  this.handler = new Handler(storage, painter, handerProxy, painter.root);
	  /**
	   * @type {module:zrender/animation/Animation}
	   */
	
	  this.animation = new Animation({
	    stage: {
	      update: zrUtil.bind(this.flush, this)
	    }
	  });
	  this.animation.start();
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._needsRefresh; // 修改 storage.delFromStorage, 每次删除元素之前删除动画
	  // FIXME 有点ugly
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	    el && el.removeSelfFromZr(self);
	  };
	
	  storage.addToStorage = function (el) {
	    oldAddToStorage.call(storage, el);
	    el.addSelfToZr(self);
	  };
	};
	
	ZRender.prototype = {
	  constructor: ZRender,
	
	  /**
	   * 获取实例唯一标识
	   * @return {string}
	   */
	  getId: function () {
	    return this.id;
	  },
	
	  /**
	   * 添加元素
	   * @param  {module:zrender/Element} el
	   */
	  add: function (el) {
	    this.storage.addRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * 删除元素
	   * @param  {module:zrender/Element} el
	   */
	  remove: function (el) {
	    this.storage.delRoot(el);
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Change configuration of layer
	   * @param {string} zLevel
	   * @param {Object} config
	   * @param {string} [config.clearColor=0] Clear color
	   * @param {string} [config.motionBlur=false] If enable motion blur
	   * @param {number} [config.lastFrameAlpha=0.7] Motion blur factor. Larger value cause longer trailer
	  */
	  configLayer: function (zLevel, config) {
	    if (this.painter.configLayer) {
	      this.painter.configLayer(zLevel, config);
	    }
	
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Set background color
	   * @param {string} backgroundColor
	   */
	  setBackgroundColor: function (backgroundColor) {
	    if (this.painter.setBackgroundColor) {
	      this.painter.setBackgroundColor(backgroundColor);
	    }
	
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Repaint the canvas immediately
	   */
	  refreshImmediately: function () {
	    // var start = new Date();
	    // Clear needsRefresh ahead to avoid something wrong happens in refresh
	    // Or it will cause zrender refreshes again and again.
	    this._needsRefresh = this._needsRefreshHover = false;
	    this.painter.refresh(); // Avoid trigger zr.refresh in Element#beforeUpdate hook
	
	    this._needsRefresh = this._needsRefreshHover = false; // var end = new Date();
	    // var log = document.getElementById('log');
	    // if (log) {
	    //     log.innerHTML = log.innerHTML + '<br>' + (end - start);
	    // }
	  },
	
	  /**
	   * Mark and repaint the canvas in the next frame of browser
	   */
	  refresh: function () {
	    this._needsRefresh = true;
	  },
	
	  /**
	   * Perform all refresh
	   */
	  flush: function () {
	    var triggerRendered;
	
	    if (this._needsRefresh) {
	      triggerRendered = true;
	      this.refreshImmediately();
	    }
	
	    if (this._needsRefreshHover) {
	      triggerRendered = true;
	      this.refreshHoverImmediately();
	    }
	
	    triggerRendered && this.trigger('rendered');
	  },
	
	  /**
	   * Add element to hover layer
	   * @param  {module:zrender/Element} el
	   * @param {Object} style
	   */
	  addHover: function (el, style) {
	    if (this.painter.addHover) {
	      var elMirror = this.painter.addHover(el, style);
	      this.refreshHover();
	      return elMirror;
	    }
	  },
	
	  /**
	   * Add element from hover layer
	   * @param  {module:zrender/Element} el
	   */
	  removeHover: function (el) {
	    if (this.painter.removeHover) {
	      this.painter.removeHover(el);
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Clear all hover elements in hover layer
	   * @param  {module:zrender/Element} el
	   */
	  clearHover: function () {
	    if (this.painter.clearHover) {
	      this.painter.clearHover();
	      this.refreshHover();
	    }
	  },
	
	  /**
	   * Refresh hover in next frame
	   */
	  refreshHover: function () {
	    this._needsRefreshHover = true;
	  },
	
	  /**
	   * Refresh hover immediately
	   */
	  refreshHoverImmediately: function () {
	    this._needsRefreshHover = false;
	    this.painter.refreshHover && this.painter.refreshHover();
	  },
	
	  /**
	   * Resize the canvas.
	   * Should be invoked when container size is changed
	   * @param {Object} [opts]
	   * @param {number|string} [opts.width] Can be 'auto' (the same as null/undefined)
	   * @param {number|string} [opts.height] Can be 'auto' (the same as null/undefined)
	   */
	  resize: function (opts) {
	    opts = opts || {};
	    this.painter.resize(opts.width, opts.height);
	    this.handler.resize();
	  },
	
	  /**
	   * Stop and clear all animation immediately
	   */
	  clearAnimation: function () {
	    this.animation.clear();
	  },
	
	  /**
	   * Get container width
	   */
	  getWidth: function () {
	    return this.painter.getWidth();
	  },
	
	  /**
	   * Get container height
	   */
	  getHeight: function () {
	    return this.painter.getHeight();
	  },
	
	  /**
	   * Export the canvas as Base64 URL
	   * @param {string} type
	   * @param {string} [backgroundColor='#fff']
	   * @return {string} Base64 URL
	   */
	  // toDataURL: function(type, backgroundColor) {
	  //     return this.painter.getRenderedCanvas({
	  //         backgroundColor: backgroundColor
	  //     }).toDataURL(type);
	  // },
	
	  /**
	   * Converting a path to image.
	   * It has much better performance of drawing image rather than drawing a vector path.
	   * @param {module:zrender/graphic/Path} e
	   * @param {number} width
	   * @param {number} height
	   */
	  pathToImage: function (e, dpr) {
	    return this.painter.pathToImage(e, dpr);
	  },
	
	  /**
	   * Set default cursor
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    this.handler.setCursorStyle(cursorStyle);
	  },
	
	  /**
	   * Find hovered element
	   * @param {number} x
	   * @param {number} y
	   * @return {Object} {target, topTarget}
	   */
	  findHover: function (x, y) {
	    return this.handler.findHover(x, y);
	  },
	
	  /**
	   * Bind event
	   *
	   * @param {string} eventName Event name
	   * @param {Function} eventHandler Handler function
	   * @param {Object} [context] Context object
	   */
	  on: function (eventName, eventHandler, context) {
	    this.handler.on(eventName, eventHandler, context);
	  },
	
	  /**
	   * Unbind event
	   * @param {string} eventName Event name
	   * @param {Function} [eventHandler] Handler function
	   */
	  off: function (eventName, eventHandler) {
	    this.handler.off(eventName, eventHandler);
	  },
	
	  /**
	   * Trigger event manually
	   *
	   * @param {string} eventName Event name
	   * @param {event=} event Event object
	   */
	  trigger: function (eventName, event) {
	    this.handler.trigger(eventName, event);
	  },
	
	  /**
	   * Clear all objects and the canvas.
	   */
	  clear: function () {
	    this.storage.delRoot();
	    this.painter.clear();
	  },
	
	  /**
	   * Dispose self.
	   */
	  dispose: function () {
	    this.animation.stop();
	    this.clear();
	    this.storage.dispose();
	    this.painter.dispose();
	    this.handler.dispose();
	    this.animation = this.storage = this.painter = this.handler = null;
	    delInstance(this.id);
	  }
	};
	exports.version = version;
	exports.init = init;
	exports.dispose = dispose;
	exports.getInstance = getInstance;
	exports.registerPainter = registerPainter;

/***/ },
/* 398 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(1220)["default"];
	
	function _getRequireWildcardCache(nodeInterop) {
	  if (typeof WeakMap !== "function") return null;
	  var cacheBabelInterop = new WeakMap();
	  var cacheNodeInterop = new WeakMap();
	  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
	    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
	  })(nodeInterop);
	}
	
	function _interopRequireWildcard(obj, nodeInterop) {
	  if (!nodeInterop && obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache(nodeInterop);
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 400 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 401 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getScroll;
	
	function getScroll(target, top) {
	  if (typeof window === 'undefined') {
	    return 0;
	  }
	
	  var prop = top ? 'pageYOffset' : 'pageXOffset';
	  var method = top ? 'scrollTop' : 'scrollLeft';
	  var isWindow = target === window;
	  var ret = isWindow ? target[prop] : target[method]; // ie6,7,8 standard mode
	
	  if (isWindow && typeof ret !== 'number') {
	    ret = document.documentElement[method];
	  }
	
	  return ret;
	}

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = scrollTo;
	
	var _raf = _interopRequireDefault(__webpack_require__(127));
	
	var _getScroll = _interopRequireDefault(__webpack_require__(401));
	
	var _easings = __webpack_require__(1224);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function scrollTo(y) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$getContainer = options.getContainer,
	      getContainer = _options$getContainer === void 0 ? function () {
	    return window;
	  } : _options$getContainer,
	      callback = options.callback,
	      _options$duration = options.duration,
	      duration = _options$duration === void 0 ? 450 : _options$duration;
	  var container = getContainer();
	  var scrollTop = (0, _getScroll["default"])(container, true);
	  var startTime = Date.now();
	
	  var frameFunc = function frameFunc() {
	    var timestamp = Date.now();
	    var time = timestamp - startTime;
	    var nextScrollTop = (0, _easings.easeInOutCubic)(time > duration ? duration : time, scrollTop, y, duration);
	
	    if (container === window) {
	      window.scrollTo(window.pageXOffset, nextScrollTop);
	    } else {
	      container.scrollTop = nextScrollTop;
	    }
	
	    if (time < duration) {
	      (0, _raf["default"])(frameFunc);
	    } else if (typeof callback === 'function') {
	      callback();
	    }
	  };
	
	  (0, _raf["default"])(frameFunc);
	}

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(71));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/**
	 * Wrap of sub component which need use as Button capacity (like Icon component).
	 * This helps accessibility reader to tread as a interactive button to operation.
	 */
	
	
	var inlineStyle = {
	  border: 0,
	  background: 'transparent',
	  padding: 0,
	  lineHeight: 'inherit',
	  display: 'inline-block'
	};
	
	var TransButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(TransButton, _React$Component);
	
	  var _super = _createSuper(TransButton);
	
	  function TransButton() {
	    var _this;
	
	    _classCallCheck(this, TransButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (event) {
	      var keyCode = event.keyCode;
	
	      if (keyCode === _KeyCode["default"].ENTER) {
	        event.preventDefault();
	      }
	    };
	
	    _this.onKeyUp = function (event) {
	      var keyCode = event.keyCode;
	      var onClick = _this.props.onClick;
	
	      if (keyCode === _KeyCode["default"].ENTER && onClick) {
	        onClick();
	      }
	    };
	
	    _this.setRef = function (btn) {
	      _this.div = btn;
	    };
	
	    return _this;
	  }
	
	  _createClass(TransButton, [{
	    key: "focus",
	    value: function focus() {
	      if (this.div) {
	        this.div.focus();
	      }
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      if (this.div) {
	        this.div.blur();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          style = _a.style,
	          noStyle = _a.noStyle,
	          restProps = __rest(_a, ["style", "noStyle"]);
	
	      return /*#__PURE__*/React.createElement("div", _extends({
	        role: "button",
	        tabIndex: 0,
	        ref: this.setRef
	      }, restProps, {
	        onKeyDown: this.onKeyDown,
	        onKeyUp: this.onKeyUp,
	        style: _extends(_extends({}, !noStyle ? inlineStyle : null), style)
	      }));
	    }
	  }]);
	
	  return TransButton;
	}(React.Component);
	
	var _default = TransButton;
	exports["default"] = _default;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(23);
	
	var _Event = _interopRequireDefault(__webpack_require__(794));
	
	var _raf = _interopRequireDefault(__webpack_require__(268));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var styleForPesudo; // Where el is the DOM element you'd like to test for visibility
	
	function isHidden(element) {
	  if (false) {
	    return false;
	  }
	
	  return !element || element.offsetParent === null;
	}
	
	function isNotGrey(color) {
	  // eslint-disable-next-line no-useless-escape
	  var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);
	
	  if (match && match[1] && match[2] && match[3]) {
	    return !(match[1] === match[2] && match[2] === match[3]);
	  }
	
	  return true;
	}
	
	var Wave = /*#__PURE__*/function (_React$Component) {
	  _inherits(Wave, _React$Component);
	
	  var _super = _createSuper(Wave);
	
	  function Wave() {
	    var _this;
	
	    _classCallCheck(this, Wave);
	
	    _this = _super.apply(this, arguments);
	    _this.animationStart = false;
	    _this.destroy = false;
	
	    _this.onClick = function (node, waveColor) {
	      if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
	        return;
	      }
	
	      var insertExtraNode = _this.props.insertExtraNode;
	      _this.extraNode = document.createElement('div');
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          extraNode = _assertThisInitialize.extraNode;
	
	      extraNode.className = 'ant-click-animating-node';
	
	      var attributeName = _this.getAttributeName();
	
	      node.setAttribute(attributeName, 'true'); // Not white or transparnt or grey
	
	      styleForPesudo = styleForPesudo || document.createElement('style');
	
	      if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
	      waveColor !== 'transparent') {
	        // Add nonce if CSP exist
	        if (_this.csp && _this.csp.nonce) {
	          styleForPesudo.nonce = _this.csp.nonce;
	        }
	
	        extraNode.style.borderColor = waveColor;
	        styleForPesudo.innerHTML = "\n      [ant-click-animating-without-extra-node='true']::after, .ant-click-animating-node {\n        --antd-wave-shadow-color: ".concat(waveColor, ";\n      }");
	
	        if (!document.body.contains(styleForPesudo)) {
	          document.body.appendChild(styleForPesudo);
	        }
	      }
	
	      if (insertExtraNode) {
	        node.appendChild(extraNode);
	      }
	
	      _Event["default"].addStartEventListener(node, _this.onTransitionStart);
	
	      _Event["default"].addEndEventListener(node, _this.onTransitionEnd);
	    };
	
	    _this.onTransitionStart = function (e) {
	      if (_this.destroy) return;
	      var node = (0, _reactDom.findDOMNode)(_assertThisInitialized(_this));
	
	      if (!e || e.target !== node) {
	        return;
	      }
	
	      if (!_this.animationStart) {
	        _this.resetEffect(node);
	      }
	    };
	
	    _this.onTransitionEnd = function (e) {
	      if (!e || e.animationName !== 'fadeEffect') {
	        return;
	      }
	
	      _this.resetEffect(e.target);
	    };
	
	    _this.bindAnimationEvent = function (node) {
	      if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
	        return;
	      }
	
	      var onClick = function onClick(e) {
	        // Fix radio button click twice
	        if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
	          return;
	        }
	
	        _this.resetEffect(node); // Get wave color from target
	
	
	        var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
	        getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
	        _this.clickWaveTimeoutId = window.setTimeout(function () {
	          return _this.onClick(node, waveColor);
	        }, 0);
	
	        _raf["default"].cancel(_this.animationStartId);
	
	        _this.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.
	
	        _this.animationStartId = (0, _raf["default"])(function () {
	          _this.animationStart = false;
	        }, 10);
	      };
	
	      node.addEventListener('click', onClick, true);
	      return {
	        cancel: function cancel() {
	          node.removeEventListener('click', onClick, true);
	        }
	      };
	    };
	
	    _this.renderWave = function (_ref) {
	      var csp = _ref.csp;
	      var children = _this.props.children;
	      _this.csp = csp;
	      return children;
	    };
	
	    return _this;
	  }
	
	  _createClass(Wave, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var node = (0, _reactDom.findDOMNode)(this);
	
	      if (!node || node.nodeType !== 1) {
	        return;
	      }
	
	      this.instance = this.bindAnimationEvent(node);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.instance) {
	        this.instance.cancel();
	      }
	
	      if (this.clickWaveTimeoutId) {
	        clearTimeout(this.clickWaveTimeoutId);
	      }
	
	      this.destroy = true;
	    }
	  }, {
	    key: "getAttributeName",
	    value: function getAttributeName() {
	      var insertExtraNode = this.props.insertExtraNode;
	      return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
	    }
	  }, {
	    key: "resetEffect",
	    value: function resetEffect(node) {
	      if (!node || node === this.extraNode || !(node instanceof Element)) {
	        return;
	      }
	
	      var insertExtraNode = this.props.insertExtraNode;
	      var attributeName = this.getAttributeName();
	      node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466
	
	      if (styleForPesudo) {
	        styleForPesudo.innerHTML = '';
	      }
	
	      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
	        node.removeChild(this.extraNode);
	      }
	
	      _Event["default"].removeStartEventListener(node, this.onTransitionStart);
	
	      _Event["default"].removeEndEventListener(node, this.onTransitionEnd);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWave);
	    }
	  }]);
	
	  return Wave;
	}(React.Component);
	
	exports["default"] = Wave;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(1080));
	
	var _en_US2 = _interopRequireDefault(__webpack_require__(415));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// Merge into a locale object
	var locale = {
	  lang: _extends({
	    placeholder: 'Select date',
	    rangePlaceholder: ['Start date', 'End date']
	  }, _en_US["default"]),
	  timePickerLocale: _extends({}, _en_US2["default"])
	}; // All settings at:
	// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
	
	var _default = locale;
	exports["default"] = _default;

/***/ },
/* 406 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcDropdown = _interopRequireDefault(__webpack_require__(2668));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _type = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Placements = (0, _type.tuple)('topLeft', 'topCenter', 'topRight', 'bottomLeft', 'bottomCenter', 'bottomRight');
	
	var Dropdown = /*#__PURE__*/function (_React$Component) {
	  _inherits(Dropdown, _React$Component);
	
	  var _super = _createSuper(Dropdown);
	
	  function Dropdown() {
	    var _this;
	
	    _classCallCheck(this, Dropdown);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderOverlay = function (prefixCls) {
	      // rc-dropdown already can process the function of overlay, but we have check logic here.
	      // So we need render the element to check and pass back to rc-dropdown.
	      var overlay = _this.props.overlay;
	      var overlayNode;
	
	      if (typeof overlay === 'function') {
	        overlayNode = overlay();
	      } else {
	        overlayNode = overlay;
	      }
	
	      overlayNode = React.Children.only(overlayNode);
	      var overlayProps = overlayNode.props; // Warning if use other mode
	
	      (0, _warning["default"])(!overlayProps.mode || overlayProps.mode === 'vertical', 'Dropdown', "mode=\"".concat(overlayProps.mode, "\" is not supported for Dropdown's Menu.")); // menu cannot be selectable in dropdown defaultly
	      // menu should be focusable in dropdown defaultly
	
	      var _overlayProps$selecta = overlayProps.selectable,
	          selectable = _overlayProps$selecta === void 0 ? false : _overlayProps$selecta,
	          _overlayProps$focusab = overlayProps.focusable,
	          focusable = _overlayProps$focusab === void 0 ? true : _overlayProps$focusab;
	      var expandIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-menu-submenu-arrow")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right",
	        className: "".concat(prefixCls, "-menu-submenu-arrow-icon")
	      }));
	      var fixedModeOverlay = typeof overlayNode.type === 'string' ? overlay : /*#__PURE__*/React.cloneElement(overlayNode, {
	        mode: 'vertical',
	        selectable: selectable,
	        focusable: focusable,
	        expandIcon: expandIcon
	      });
	      return fixedModeOverlay;
	    };
	
	    _this.renderDropDown = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          children = _this$props.children,
	          trigger = _this$props.trigger,
	          disabled = _this$props.disabled,
	          getPopupContainer = _this$props.getPopupContainer;
	      var prefixCls = getPrefixCls('dropdown', customizePrefixCls);
	      var child = React.Children.only(children);
	      var dropdownTrigger = /*#__PURE__*/React.cloneElement(child, {
	        className: (0, _classnames["default"])(child.props.className, "".concat(prefixCls, "-trigger")),
	        disabled: disabled
	      });
	      var triggerActions = disabled ? [] : trigger;
	      var alignPoint;
	
	      if (triggerActions && triggerActions.indexOf('contextMenu') !== -1) {
	        alignPoint = true;
	      }
	
	      return /*#__PURE__*/React.createElement(_rcDropdown["default"], _extends({
	        alignPoint: alignPoint
	      }, _this.props, {
	        prefixCls: prefixCls,
	        getPopupContainer: getPopupContainer || getContextPopupContainer,
	        transitionName: _this.getTransitionName(),
	        trigger: triggerActions,
	        overlay: function overlay() {
	          return _this.renderOverlay(prefixCls);
	        }
	      }), dropdownTrigger);
	    };
	
	    return _this;
	  }
	
	  _createClass(Dropdown, [{
	    key: "getTransitionName",
	    value: function getTransitionName() {
	      var _this$props2 = this.props,
	          _this$props2$placemen = _this$props2.placement,
	          placement = _this$props2$placemen === void 0 ? '' : _this$props2$placemen,
	          transitionName = _this$props2.transitionName;
	
	      if (transitionName !== undefined) {
	        return transitionName;
	      }
	
	      if (placement.indexOf('top') >= 0) {
	        return 'slide-down';
	      }
	
	      return 'slide-up';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderDropDown);
	    }
	  }]);
	
	  return Dropdown;
	}(React.Component);
	
	exports["default"] = Dropdown;
	Dropdown.defaultProps = {
	  mouseEnterDelay: 0.15,
	  mouseLeaveDelay: 0.1,
	  placement: 'bottomLeft'
	};

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _dropdown = _interopRequireDefault(__webpack_require__(406));
	
	var _dropdownButton = _interopRequireDefault(__webpack_require__(1267));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_dropdown["default"].Button = _dropdownButton["default"];
	var _default = _dropdown["default"];
	exports["default"] = _default;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.SiderContext = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(129));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _layout = __webpack_require__(635);
	
	var _configProvider = __webpack_require__(11);
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _isNumeric = _interopRequireDefault(__webpack_require__(1225));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	// TODO: Will be removed in antd 4.0 because we will no longer support ie9
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
	}
	
	var dimensionMaxMap = {
	  xs: '479.98px',
	  sm: '575.98px',
	  md: '767.98px',
	  lg: '991.98px',
	  xl: '1199.98px',
	  xxl: '1599.98px'
	};
	var SiderContext = (0, _createReactContext["default"])({});
	exports.SiderContext = SiderContext;
	
	var generateId = function () {
	  var i = 0;
	  return function () {
	    var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    i += 1;
	    return "".concat(prefix).concat(i);
	  };
	}();
	
	var InternalSider = /*#__PURE__*/function (_React$Component) {
	  _inherits(InternalSider, _React$Component);
	
	  var _super = _createSuper(InternalSider);
	
	  function InternalSider(props) {
	    var _this;
	
	    _classCallCheck(this, InternalSider);
	
	    _this = _super.call(this, props);
	
	    _this.responsiveHandler = function (mql) {
	      _this.setState({
	        below: mql.matches
	      });
	
	      var onBreakpoint = _this.props.onBreakpoint;
	
	      if (onBreakpoint) {
	        onBreakpoint(mql.matches);
	      }
	
	      if (_this.state.collapsed !== mql.matches) {
	        _this.setCollapsed(mql.matches, 'responsive');
	      }
	    };
	
	    _this.setCollapsed = function (collapsed, type) {
	      if (!('collapsed' in _this.props)) {
	        _this.setState({
	          collapsed: collapsed
	        });
	      }
	
	      var onCollapse = _this.props.onCollapse;
	
	      if (onCollapse) {
	        onCollapse(collapsed, type);
	      }
	    };
	
	    _this.toggle = function () {
	      var collapsed = !_this.state.collapsed;
	
	      _this.setCollapsed(collapsed, 'clickTrigger');
	    };
	
	    _this.belowShowChange = function () {
	      _this.setState(function (_ref) {
	        var belowShow = _ref.belowShow;
	        return {
	          belowShow: !belowShow
	        };
	      });
	    };
	
	    _this.renderSider = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          theme = _a.theme,
	          collapsible = _a.collapsible,
	          reverseArrow = _a.reverseArrow,
	          trigger = _a.trigger,
	          style = _a.style,
	          width = _a.width,
	          collapsedWidth = _a.collapsedWidth,
	          zeroWidthTriggerStyle = _a.zeroWidthTriggerStyle,
	          others = __rest(_a, ["prefixCls", "className", "theme", "collapsible", "reverseArrow", "trigger", "style", "width", "collapsedWidth", "zeroWidthTriggerStyle"]);
	
	      var prefixCls = getPrefixCls('layout-sider', customizePrefixCls);
	      var divProps = (0, _omit["default"])(others, ['collapsed', 'defaultCollapsed', 'onCollapse', 'breakpoint', 'onBreakpoint', 'siderHook', 'zeroWidthTriggerStyle']);
	      var rawWidth = _this.state.collapsed ? collapsedWidth : width; // use "px" as fallback unit for width
	
	      var siderWidth = (0, _isNumeric["default"])(rawWidth) ? "".concat(rawWidth, "px") : String(rawWidth); // special trigger when collapsedWidth == 0
	
	      var zeroWidthTrigger = parseFloat(String(collapsedWidth || 0)) === 0 ? /*#__PURE__*/React.createElement("span", {
	        onClick: _this.toggle,
	        className: "".concat(prefixCls, "-zero-width-trigger ").concat(prefixCls, "-zero-width-trigger-").concat(reverseArrow ? 'right' : 'left'),
	        style: zeroWidthTriggerStyle
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "bars"
	      })) : null;
	      var iconObj = {
	        expanded: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "right"
	        }) : /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "left"
	        }),
	        collapsed: reverseArrow ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "left"
	        }) : /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "right"
	        })
	      };
	      var status = _this.state.collapsed ? 'collapsed' : 'expanded';
	      var defaultTrigger = iconObj[status];
	      var triggerDom = trigger !== null ? zeroWidthTrigger || /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-trigger"),
	        onClick: _this.toggle,
	        style: {
	          width: siderWidth
	        }
	      }, trigger || defaultTrigger) : null;
	
	      var divStyle = _extends(_extends({}, style), {
	        flex: "0 0 ".concat(siderWidth),
	        maxWidth: siderWidth,
	        minWidth: siderWidth,
	        width: siderWidth
	      });
	
	      var siderCls = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(theme), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-collapsed"), !!_this.state.collapsed), _defineProperty(_classNames, "".concat(prefixCls, "-has-trigger"), collapsible && trigger !== null && !zeroWidthTrigger), _defineProperty(_classNames, "".concat(prefixCls, "-below"), !!_this.state.below), _defineProperty(_classNames, "".concat(prefixCls, "-zero-width"), parseFloat(siderWidth) === 0), _classNames));
	      return /*#__PURE__*/React.createElement("aside", _extends({
	        className: siderCls
	      }, divProps, {
	        style: divStyle
	      }), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-children")
	      }, _this.props.children), collapsible || _this.state.below && zeroWidthTrigger ? triggerDom : null);
	    };
	
	    _this.uniqueId = generateId('ant-sider-');
	    var matchMedia;
	
	    if (typeof window !== 'undefined') {
	      matchMedia = window.matchMedia;
	    }
	
	    if (matchMedia && props.breakpoint && props.breakpoint in dimensionMaxMap) {
	      _this.mql = matchMedia("(max-width: ".concat(dimensionMaxMap[props.breakpoint], ")"));
	    }
	
	    var collapsed;
	
	    if ('collapsed' in props) {
	      collapsed = props.collapsed;
	    } else {
	      collapsed = props.defaultCollapsed;
	    }
	
	    _this.state = {
	      collapsed: collapsed,
	      below: false
	    };
	    return _this;
	  }
	
	  _createClass(InternalSider, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.mql) {
	        this.mql.addListener(this.responsiveHandler);
	        this.responsiveHandler(this.mql);
	      }
	
	      if (this.props.siderHook) {
	        this.props.siderHook.addSider(this.uniqueId);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.mql) {
	        this.mql.removeListener(this.responsiveHandler);
	      }
	
	      if (this.props.siderHook) {
	        this.props.siderHook.removeSider(this.uniqueId);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var collapsed = this.state.collapsed;
	      var collapsedWidth = this.props.collapsedWidth;
	      return /*#__PURE__*/React.createElement(SiderContext.Provider, {
	        value: {
	          siderCollapsed: collapsed,
	          collapsedWidth: collapsedWidth
	        }
	      }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSider));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('collapsed' in nextProps) {
	        return {
	          collapsed: nextProps.collapsed
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return InternalSider;
	}(React.Component);
	
	InternalSider.defaultProps = {
	  collapsible: false,
	  defaultCollapsed: false,
	  reverseArrow: false,
	  width: 200,
	  collapsedWidth: 80,
	  style: {},
	  theme: 'dark'
	};
	(0, _reactLifecyclesCompat.polyfill)(InternalSider); // eslint-disable-next-line react/prefer-stateless-function
	
	var Sider = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Sider, _React$Component2);
	
	  var _super2 = _createSuper(Sider);
	
	  function Sider() {
	    _classCallCheck(this, Sider);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Sider, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return /*#__PURE__*/React.createElement(_layout.LayoutContext.Consumer, null, function (context) {
	        return /*#__PURE__*/React.createElement(InternalSider, _extends({}, context, _this2.props));
	      });
	    }
	  }]);
	
	  return Sider;
	}(React.Component);
	
	exports["default"] = Sider;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var MenuContext = (0, _createReactContext["default"])({
	  inlineCollapsed: false
	});
	var _default = MenuContext;
	exports["default"] = _default;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcMenu = _interopRequireWildcard(__webpack_require__(219));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _SubMenu = _interopRequireDefault(__webpack_require__(1291));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(1290));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _Sider = __webpack_require__(408);
	
	var _raf = _interopRequireDefault(__webpack_require__(268));
	
	var _motion = _interopRequireDefault(__webpack_require__(613));
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(409));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var InternalMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(InternalMenu, _React$Component);
	
	  var _super = _createSuper(InternalMenu);
	
	  function InternalMenu(props) {
	    var _this;
	
	    _classCallCheck(this, InternalMenu);
	
	    _this = _super.call(this, props); // Restore vertical mode when menu is collapsed responsively when mounted
	    // https://github.com/ant-design/ant-design/issues/13104
	    // TODO: not a perfect solution, looking a new way to avoid setting switchingModeFromInline in this situation
	
	    _this.handleMouseEnter = function (e) {
	      _this.restoreModeVerticalFromInline();
	
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter(e);
	      }
	    };
	
	    _this.handleTransitionEnd = function (e) {
	      // when inlineCollapsed menu width animation finished
	      // https://github.com/ant-design/ant-design/issues/12864
	      var widthCollapsed = e.propertyName === 'width' && e.target === e.currentTarget; // Fix SVGElement e.target.className.indexOf is not a function
	      // https://github.com/ant-design/ant-design/issues/15699
	
	      var className = e.target.className; // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during an animation.
	
	      var classNameValue = Object.prototype.toString.call(className) === '[object SVGAnimatedString]' ? className.animVal : className; // Fix for <Menu style={{ width: '100%' }} />, the width transition won't trigger when menu is collapsed
	      // https://github.com/ant-design/ant-design-pro/issues/2783
	
	      var iconScaled = e.propertyName === 'font-size' && classNameValue.indexOf('anticon') >= 0;
	
	      if (widthCollapsed || iconScaled) {
	        _this.restoreModeVerticalFromInline();
	      }
	    };
	
	    _this.handleClick = function (e) {
	      _this.handleOpenChange([]);
	
	      var onClick = _this.props.onClick;
	
	      if (onClick) {
	        onClick(e);
	      }
	    };
	
	    _this.handleOpenChange = function (openKeys) {
	      _this.setOpenKeys(openKeys);
	
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(openKeys);
	      }
	    };
	
	    _this.renderMenu = function (_ref) {
	      var getPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          theme = _this$props.theme,
	          collapsedWidth = _this$props.collapsedWidth;
	      var passProps = (0, _omit["default"])(_this.props, ['collapsedWidth', 'siderCollapsed']);
	
	      var menuMode = _this.getRealMenuMode();
	
	      var menuOpenMotion = _this.getOpenMotionProps(menuMode);
	
	      var prefixCls = getPrefixCls('menu', customizePrefixCls);
	      var menuClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-").concat(theme), _defineProperty({}, "".concat(prefixCls, "-inline-collapsed"), _this.getInlineCollapsed()));
	
	      var menuProps = _extends({
	        openKeys: _this.state.openKeys,
	        onOpenChange: _this.handleOpenChange,
	        className: menuClassName,
	        mode: menuMode
	      }, menuOpenMotion);
	
	      if (menuMode !== 'inline') {
	        // closing vertical popup submenu after click it
	        menuProps.onClick = _this.handleClick;
	      } // https://github.com/ant-design/ant-design/issues/8587
	
	
	      var hideMenu = _this.getInlineCollapsed() && (collapsedWidth === 0 || collapsedWidth === '0' || collapsedWidth === '0px');
	
	      if (hideMenu) {
	        menuProps.openKeys = [];
	      }
	
	      return /*#__PURE__*/React.createElement(_rcMenu["default"], _extends({
	        getPopupContainer: getPopupContainer
	      }, passProps, menuProps, {
	        prefixCls: prefixCls,
	        onTransitionEnd: _this.handleTransitionEnd,
	        onMouseEnter: _this.handleMouseEnter
	      }));
	    };
	
	    (0, _warning["default"])(!('onOpen' in props || 'onClose' in props), 'Menu', '`onOpen` and `onClose` are removed, please use `onOpenChange` instead, ' + 'see: https://u.ant.design/menu-on-open-change.');
	    (0, _warning["default"])(!('inlineCollapsed' in props && props.mode !== 'inline'), 'Menu', '`inlineCollapsed` should only be used when `mode` is inline.');
	    (0, _warning["default"])(!(props.siderCollapsed !== undefined && 'inlineCollapsed' in props), 'Menu', '`inlineCollapsed` not control Menu under Sider. Should set `collapsed` on Sider instead.');
	    var openKeys;
	
	    if ('openKeys' in props) {
	      openKeys = props.openKeys;
	    } else if ('defaultOpenKeys' in props) {
	      openKeys = props.defaultOpenKeys;
	    }
	
	    _this.state = {
	      openKeys: openKeys || [],
	      switchingModeFromInline: false,
	      inlineOpenKeys: [],
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(InternalMenu, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.mountRafId);
	    }
	  }, {
	    key: "setOpenKeys",
	    value: function setOpenKeys(openKeys) {
	      if (!('openKeys' in this.props)) {
	        this.setState({
	          openKeys: openKeys
	        });
	      }
	    }
	  }, {
	    key: "getRealMenuMode",
	    value: function getRealMenuMode() {
	      var inlineCollapsed = this.getInlineCollapsed();
	
	      if (this.state.switchingModeFromInline && inlineCollapsed) {
	        return 'inline';
	      }
	
	      var mode = this.props.mode;
	      return inlineCollapsed ? 'vertical' : mode;
	    }
	  }, {
	    key: "getInlineCollapsed",
	    value: function getInlineCollapsed() {
	      var inlineCollapsed = this.props.inlineCollapsed;
	
	      if (this.props.siderCollapsed !== undefined) {
	        return this.props.siderCollapsed;
	      }
	
	      return inlineCollapsed;
	    }
	  }, {
	    key: "getOpenMotionProps",
	    value: function getOpenMotionProps(menuMode) {
	      var _this$props2 = this.props,
	          openTransitionName = _this$props2.openTransitionName,
	          openAnimation = _this$props2.openAnimation,
	          motion = _this$props2.motion; // Provides by user
	
	      if (motion) {
	        return {
	          motion: motion
	        };
	      }
	
	      if (openAnimation) {
	        (0, _warning["default"])(typeof openAnimation === 'string', 'Menu', '`openAnimation` do not support object. Please use `motion` instead.');
	        return {
	          openAnimation: openAnimation
	        };
	      }
	
	      if (openTransitionName) {
	        return {
	          openTransitionName: openTransitionName
	        };
	      } // Default logic
	
	
	      if (menuMode === 'horizontal') {
	        return {
	          motion: {
	            motionName: 'slide-up'
	          }
	        };
	      }
	
	      if (menuMode === 'inline') {
	        return {
	          motion: _motion["default"]
	        };
	      } // When mode switch from inline
	      // submenu should hide without animation
	
	
	      return {
	        motion: {
	          motionName: this.state.switchingModeFromInline ? '' : 'zoom-big'
	        }
	      };
	    }
	  }, {
	    key: "restoreModeVerticalFromInline",
	    value: function restoreModeVerticalFromInline() {
	      var switchingModeFromInline = this.state.switchingModeFromInline;
	
	      if (switchingModeFromInline) {
	        this.setState({
	          switchingModeFromInline: false
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_MenuContext["default"].Provider, {
	        value: {
	          inlineCollapsed: this.getInlineCollapsed() || false,
	          antdMenuTheme: this.props.theme
	        }
	      }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMenu));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevProps = prevState.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	
	      if (prevProps.mode === 'inline' && nextProps.mode !== 'inline') {
	        newState.switchingModeFromInline = true;
	      }
	
	      if ('openKeys' in nextProps) {
	        newState.openKeys = nextProps.openKeys;
	      } else {
	        // [Legacy] Old code will return after `openKeys` changed.
	        // Not sure the reason, we should keep this logic still.
	        if (nextProps.inlineCollapsed && !prevProps.inlineCollapsed || nextProps.siderCollapsed && !prevProps.siderCollapsed) {
	          newState.switchingModeFromInline = true;
	          newState.inlineOpenKeys = prevState.openKeys;
	          newState.openKeys = [];
	        }
	
	        if (!nextProps.inlineCollapsed && prevProps.inlineCollapsed || !nextProps.siderCollapsed && prevProps.siderCollapsed) {
	          newState.openKeys = prevState.inlineOpenKeys;
	          newState.inlineOpenKeys = [];
	        }
	      }
	
	      return newState;
	    }
	  }]);
	
	  return InternalMenu;
	}(React.Component);
	
	InternalMenu.defaultProps = {
	  className: '',
	  theme: 'light',
	  focusable: false
	};
	(0, _reactLifecyclesCompat.polyfill)(InternalMenu); // We should keep this as ref-able
	
	var Menu = /*#__PURE__*/function (_React$Component2) {
	  _inherits(Menu, _React$Component2);
	
	  var _super2 = _createSuper(Menu);
	
	  function Menu() {
	    _classCallCheck(this, Menu);
	
	    return _super2.apply(this, arguments);
	  }
	
	  _createClass(Menu, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return /*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, function (context) {
	        return /*#__PURE__*/React.createElement(InternalMenu, _extends({}, _this2.props, context));
	      });
	    }
	  }]);
	
	  return Menu;
	}(React.Component);
	
	exports["default"] = Menu;
	Menu.Divider = _rcMenu.Divider;
	Menu.Item = _MenuItem["default"];
	Menu.SubMenu = _SubMenu["default"];
	Menu.ItemGroup = _rcMenu.ItemGroup;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.changeConfirmLocale = changeConfirmLocale;
	exports.getConfirmLocale = getConfirmLocale;
	
	var _default = _interopRequireDefault(__webpack_require__(227));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var runtimeLocale = _extends({}, _default["default"].Modal);
	
	function changeConfirmLocale(newLocale) {
	  if (newLocale) {
	    runtimeLocale = _extends(_extends({}, runtimeLocale), newLocale);
	  } else {
	    runtimeLocale = _extends({}, _default["default"].Modal);
	  }
	}
	
	function getConfirmLocale() {
	  return runtimeLocale;
	}

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Pagination = _interopRequireDefault(__webpack_require__(1299));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _Pagination["default"];
	exports["default"] = _default;

/***/ },
/* 413 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.validProgress = validProgress;
	
	// eslint-disable-next-line import/prefer-default-export
	function validProgress(progress) {
	  if (!progress || progress < 0) {
	    return 0;
	  }
	
	  if (progress > 100) {
	    return 100;
	  }
	
	  return progress;
	}

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcCheckbox = _interopRequireDefault(__webpack_require__(1083));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(79));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Radio = /*#__PURE__*/function (_React$Component) {
	  _inherits(Radio, _React$Component);
	
	  var _super = _createSuper(Radio);
	
	  function Radio() {
	    var _this;
	
	    _classCallCheck(this, Radio);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveCheckbox = function (node) {
	      _this.rcCheckbox = node;
	    };
	
	    _this.onChange = function (e) {
	      if (_this.props.onChange) {
	        _this.props.onChange(e);
	      }
	
	      if (_this.context.radioGroup && _this.context.radioGroup.onChange) {
	        _this.context.radioGroup.onChange(e);
	      }
	    };
	
	    _this.renderRadio = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          context = _assertThisInitialize.context;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          children = props.children,
	          style = props.style,
	          restProps = __rest(props, ["prefixCls", "className", "children", "style"]);
	
	      var radioGroup = context.radioGroup;
	      var prefixCls = getPrefixCls('radio', customizePrefixCls);
	
	      var radioProps = _extends({}, restProps);
	
	      if (radioGroup) {
	        radioProps.name = radioGroup.name;
	        radioProps.onChange = _this.onChange;
	        radioProps.checked = props.value === radioGroup.value;
	        radioProps.disabled = props.disabled || radioGroup.disabled;
	      }
	
	      var wrapperClassString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), radioProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), radioProps.disabled), _classNames));
	      return (
	        /*#__PURE__*/
	        // eslint-disable-next-line jsx-a11y/label-has-associated-control
	        React.createElement("label", {
	          className: wrapperClassString,
	          style: style,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave
	        }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], _extends({}, radioProps, {
	          prefixCls: prefixCls,
	          ref: _this.saveCheckbox
	        })), children !== undefined ? /*#__PURE__*/React.createElement("span", null, children) : null)
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Radio, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.radioGroup, nextContext.radioGroup);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcCheckbox.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcCheckbox.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadio);
	    }
	  }]);
	
	  return Radio;
	}(React.Component);
	
	exports["default"] = Radio;
	Radio.defaultProps = {
	  type: 'radio'
	};
	Radio.contextTypes = {
	  radioGroup: PropTypes.any
	};

/***/ },
/* 415 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var locale = {
	  placeholder: 'Select time'
	};
	var _default = locale;
	exports["default"] = _default;

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _toArray = _interopRequireDefault(__webpack_require__(112));
	
	var _findDOMNode = _interopRequireDefault(__webpack_require__(568));
	
	var _copyToClipboard = _interopRequireDefault(__webpack_require__(1875));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(417));
	
	var _configProvider = __webpack_require__(11);
	
	var _context = __webpack_require__(317);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _transButton = _interopRequireDefault(__webpack_require__(403));
	
	var _raf = _interopRequireDefault(__webpack_require__(268));
	
	var _styleChecker = _interopRequireDefault(__webpack_require__(616));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(165));
	
	var _Typography = _interopRequireDefault(__webpack_require__(648));
	
	var _Editable = _interopRequireDefault(__webpack_require__(1348));
	
	var _util = _interopRequireDefault(__webpack_require__(1353));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var isLineClampSupport = (0, _styleChecker["default"])('webkitLineClamp');
	var isTextOverflowSupport = (0, _styleChecker["default"])('textOverflow');
	
	function wrapperDecorations(_ref, content) {
	  var mark = _ref.mark,
	      code = _ref.code,
	      underline = _ref.underline,
	      del = _ref["delete"],
	      strong = _ref.strong;
	  var currentContent = content;
	
	  function wrap(needed, tag) {
	    if (!needed) return;
	    currentContent = /*#__PURE__*/React.createElement(tag, {}, currentContent);
	  }
	
	  wrap(strong, 'strong');
	  wrap(underline, 'u');
	  wrap(del, 'del');
	  wrap(code, 'code');
	  wrap(mark, 'mark');
	  return currentContent;
	}
	
	var ELLIPSIS_STR = '...';
	
	var Base = /*#__PURE__*/function (_React$Component) {
	  _inherits(Base, _React$Component);
	
	  var _super = _createSuper(Base);
	
	  function Base() {
	    var _this;
	
	    _classCallCheck(this, Base);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      edit: false,
	      copied: false,
	      ellipsisText: '',
	      ellipsisContent: null,
	      isEllipsis: false,
	      expanded: false,
	      clientRendered: false
	    }; // =============== Expend ===============
	
	    _this.onExpandClick = function () {
	      var _this$getEllipsis = _this.getEllipsis(),
	          onExpand = _this$getEllipsis.onExpand;
	
	      _this.setState({
	        expanded: true
	      });
	
	      if (onExpand) {
	        onExpand();
	      }
	    }; // ================ Edit ================
	
	
	    _this.onEditClick = function () {
	      _this.triggerEdit(true);
	    };
	
	    _this.onEditChange = function (value) {
	      var _this$getEditable = _this.getEditable(),
	          onChange = _this$getEditable.onChange;
	
	      if (onChange) {
	        onChange(value);
	      }
	
	      _this.triggerEdit(false);
	    };
	
	    _this.onEditCancel = function () {
	      _this.triggerEdit(false);
	    }; // ================ Copy ================
	
	
	    _this.onCopyClick = function () {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          copyable = _this$props.copyable;
	
	      var copyConfig = _extends({}, _typeof(copyable) === 'object' ? copyable : null);
	
	      if (copyConfig.text === undefined) {
	        copyConfig.text = String(children);
	      }
	
	      (0, _copyToClipboard["default"])(copyConfig.text || '');
	
	      _this.setState({
	        copied: true
	      }, function () {
	        if (copyConfig.onCopy) {
	          copyConfig.onCopy();
	        }
	
	        _this.copyId = window.setTimeout(function () {
	          _this.setState({
	            copied: false
	          });
	        }, 3000);
	      });
	    };
	
	    _this.setContentRef = function (node) {
	      _this.content = node;
	    };
	
	    _this.setEditRef = function (node) {
	      _this.editIcon = node;
	    };
	
	    _this.triggerEdit = function (edit) {
	      var _this$getEditable2 = _this.getEditable(),
	          onStart = _this$getEditable2.onStart;
	
	      if (edit && onStart) {
	        onStart();
	      }
	
	      _this.setState({
	        edit: edit
	      }, function () {
	        if (!edit && _this.editIcon) {
	          _this.editIcon.focus();
	        }
	      });
	    }; // ============== Ellipsis ==============
	
	
	    _this.resizeOnNextFrame = function () {
	      _raf["default"].cancel(_this.rafId);
	
	      _this.rafId = (0, _raf["default"])(function () {
	        // Do not bind `syncEllipsis`. It need for test usage on prototype
	        _this.syncEllipsis();
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(Base, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setState({
	        clientRendered: true
	      });
	      this.resizeOnNextFrame();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var children = this.props.children;
	      var ellipsis = this.getEllipsis();
	      var prevEllipsis = this.getEllipsis(prevProps);
	
	      if (children !== prevProps.children || ellipsis.rows !== prevEllipsis.rows) {
	        this.resizeOnNextFrame();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.clearTimeout(this.copyId);
	
	      _raf["default"].cancel(this.rafId);
	    }
	  }, {
	    key: "getEditable",
	    value: function getEditable(props) {
	      var edit = this.state.edit;
	
	      var _ref2 = props || this.props,
	          editable = _ref2.editable;
	
	      if (!editable) return {
	        editing: edit
	      };
	      return _extends({
	        editing: edit
	      }, _typeof(editable) === 'object' ? editable : null);
	    }
	  }, {
	    key: "getEllipsis",
	    value: function getEllipsis(props) {
	      var _ref3 = props || this.props,
	          ellipsis = _ref3.ellipsis;
	
	      if (!ellipsis) return {};
	      return _extends({
	        rows: 1,
	        expandable: false
	      }, _typeof(ellipsis) === 'object' ? ellipsis : null);
	    }
	  }, {
	    key: "canUseCSSEllipsis",
	    value: function canUseCSSEllipsis() {
	      var clientRendered = this.state.clientRendered;
	      var _this$props2 = this.props,
	          editable = _this$props2.editable,
	          copyable = _this$props2.copyable;
	
	      var _this$getEllipsis2 = this.getEllipsis(),
	          rows = _this$getEllipsis2.rows,
	          expandable = _this$getEllipsis2.expandable; // Can't use css ellipsis since we need to provide the place for button
	
	
	      if (editable || copyable || expandable || !clientRendered) {
	        return false;
	      }
	
	      if (rows === 1) {
	        return isTextOverflowSupport;
	      }
	
	      return isLineClampSupport;
	    }
	  }, {
	    key: "syncEllipsis",
	    value: function syncEllipsis() {
	      var _this$state = this.state,
	          ellipsisText = _this$state.ellipsisText,
	          isEllipsis = _this$state.isEllipsis,
	          expanded = _this$state.expanded;
	
	      var _this$getEllipsis3 = this.getEllipsis(),
	          rows = _this$getEllipsis3.rows;
	
	      var children = this.props.children;
	      if (!rows || rows < 0 || !this.content || expanded) return; // Do not measure if css already support ellipsis
	
	      if (this.canUseCSSEllipsis()) return;
	      (0, _warning["default"])((0, _toArray["default"])(children).every(function (child) {
	        return typeof child === 'string';
	      }), 'Typography', '`ellipsis` should use string as children only.');
	
	      var _measure = (0, _util["default"])((0, _findDOMNode["default"])(this.content), rows, children, this.renderOperations(true), ELLIPSIS_STR),
	          content = _measure.content,
	          text = _measure.text,
	          ellipsis = _measure.ellipsis;
	
	      if (ellipsisText !== text || isEllipsis !== ellipsis) {
	        this.setState({
	          ellipsisText: text,
	          ellipsisContent: content,
	          isEllipsis: ellipsis
	        });
	      }
	    }
	  }, {
	    key: "renderExpand",
	    value: function renderExpand(forceRender) {
	      var _this$getEllipsis4 = this.getEllipsis(),
	          expandable = _this$getEllipsis4.expandable;
	
	      var prefixCls = this.props.prefixCls;
	      var _this$state2 = this.state,
	          expanded = _this$state2.expanded,
	          isEllipsis = _this$state2.isEllipsis;
	      if (!expandable) return null; // force render expand icon for measure usage or it will cause dead loop
	
	      if (!forceRender && (expanded || !isEllipsis)) return null;
	      return /*#__PURE__*/React.createElement("a", {
	        key: "expand",
	        className: "".concat(prefixCls, "-expand"),
	        onClick: this.onExpandClick,
	        "aria-label": this.expandStr
	      }, this.expandStr);
	    }
	  }, {
	    key: "renderEdit",
	    value: function renderEdit() {
	      var _this$props3 = this.props,
	          editable = _this$props3.editable,
	          prefixCls = _this$props3.prefixCls;
	      if (!editable) return;
	      return /*#__PURE__*/React.createElement(_tooltip["default"], {
	        key: "edit",
	        title: this.editStr
	      }, /*#__PURE__*/React.createElement(_transButton["default"], {
	        ref: this.setEditRef,
	        className: "".concat(prefixCls, "-edit"),
	        onClick: this.onEditClick,
	        "aria-label": this.editStr
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        role: "button",
	        type: "edit"
	      })));
	    }
	  }, {
	    key: "renderCopy",
	    value: function renderCopy() {
	      var copied = this.state.copied;
	      var _this$props4 = this.props,
	          copyable = _this$props4.copyable,
	          prefixCls = _this$props4.prefixCls;
	      if (!copyable) return;
	      var title = copied ? this.copiedStr : this.copyStr;
	      return /*#__PURE__*/React.createElement(_tooltip["default"], {
	        key: "copy",
	        title: title
	      }, /*#__PURE__*/React.createElement(_transButton["default"], {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-copy"), copied && "".concat(prefixCls, "-copy-success")),
	        onClick: this.onCopyClick,
	        "aria-label": title
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        role: "button",
	        type: copied ? 'check' : 'copy'
	      })));
	    }
	  }, {
	    key: "renderEditInput",
	    value: function renderEditInput() {
	      var _this$props5 = this.props,
	          children = _this$props5.children,
	          prefixCls = _this$props5.prefixCls,
	          className = _this$props5.className,
	          style = _this$props5.style;
	      return /*#__PURE__*/React.createElement(_Editable["default"], {
	        value: typeof children === 'string' ? children : '',
	        onSave: this.onEditChange,
	        onCancel: this.onEditCancel,
	        prefixCls: prefixCls,
	        className: className,
	        style: style
	      });
	    }
	  }, {
	    key: "renderOperations",
	    value: function renderOperations(forceRenderExpanded) {
	      return [this.renderExpand(forceRenderExpanded), this.renderEdit(), this.renderCopy()].filter(function (node) {
	        return node;
	      });
	    }
	  }, {
	    key: "renderContent",
	    value: function renderContent() {
	      var _this2 = this;
	
	      var _this$state3 = this.state,
	          ellipsisContent = _this$state3.ellipsisContent,
	          isEllipsis = _this$state3.isEllipsis,
	          expanded = _this$state3.expanded;
	
	      var _a = this.props,
	          component = _a.component,
	          children = _a.children,
	          className = _a.className,
	          prefixCls = _a.prefixCls,
	          type = _a.type,
	          disabled = _a.disabled,
	          style = _a.style,
	          restProps = __rest(_a, ["component", "children", "className", "prefixCls", "type", "disabled", "style"]);
	
	      var _this$getEllipsis5 = this.getEllipsis(),
	          rows = _this$getEllipsis5.rows;
	
	      var textProps = (0, _omit["default"])(restProps, ['prefixCls', 'editable', 'copyable', 'ellipsis', 'mark', 'underline', 'mark', 'code', 'delete', 'underline', 'strong'].concat(_toConsumableArray(_configProvider.configConsumerProps)));
	      var cssEllipsis = this.canUseCSSEllipsis();
	      var cssTextOverflow = rows === 1 && cssEllipsis;
	      var cssLineClamp = rows && rows > 1 && cssEllipsis;
	      var textNode = children;
	      var ariaLabel = null; // Only use js ellipsis when css ellipsis not support
	
	      if (rows && isEllipsis && !expanded && !cssEllipsis) {
	        ariaLabel = String(children); // We move full content to outer element to avoid repeat read the content by accessibility
	
	        textNode = /*#__PURE__*/React.createElement("span", {
	          title: String(children),
	          "aria-hidden": "true"
	        }, ellipsisContent, ELLIPSIS_STR);
	      }
	
	      textNode = wrapperDecorations(this.props, textNode);
	      return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Text"
	      }, function (_ref4) {
	        var _classNames;
	
	        var edit = _ref4.edit,
	            copyStr = _ref4.copy,
	            copied = _ref4.copied,
	            expand = _ref4.expand;
	        _this2.editStr = edit;
	        _this2.copyStr = copyStr;
	        _this2.copiedStr = copied;
	        _this2.expandStr = expand;
	        return /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	          onResize: _this2.resizeOnNextFrame,
	          disabled: !rows
	        }, /*#__PURE__*/React.createElement(_Typography["default"], _extends({
	          className: (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis"), rows), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis-single-line"), cssTextOverflow), _defineProperty(_classNames, "".concat(prefixCls, "-ellipsis-multiple-line"), cssLineClamp), _classNames)),
	          style: _extends(_extends({}, style), {
	            WebkitLineClamp: cssLineClamp ? rows : null
	          }),
	          component: component,
	          ref: _this2.setContentRef,
	          "aria-label": ariaLabel
	        }, textProps), textNode, _this2.renderOperations()));
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$getEditable3 = this.getEditable(),
	          editing = _this$getEditable3.editing;
	
	      if (editing) {
	        return this.renderEditInput();
	      }
	
	      return this.renderContent();
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var children = nextProps.children,
	          editable = nextProps.editable;
	      (0, _warning["default"])(!editable || typeof children === 'string', 'Typography', 'When `editable` is enabled, the `children` should use string.');
	      return {};
	    }
	  }]);
	
	  return Base;
	}(React.Component);
	
	Base.defaultProps = {
	  children: ''
	};
	(0, _reactLifecyclesCompat.polyfill)(Base);
	
	var _default = (0, _context.withConfigConsumer)({
	  prefixCls: 'typography'
	})(Base);
	
	exports["default"] = _default;

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var findDOMNode_1 = __importDefault(__webpack_require__(568));
	
	var toArray_1 = __importDefault(__webpack_require__(112));
	
	var warning_1 = __importDefault(__webpack_require__(303));
	
	var ref_1 = __webpack_require__(2778);
	
	var resize_observer_polyfill_1 = __importDefault(__webpack_require__(391));
	
	var util_1 = __webpack_require__(1360);
	
	var INTERNAL_PREFIX_KEY = 'rc-observer-key'; // Still need to be compatible with React 15, we use class component here
	
	var ReactResizeObserver =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(ReactResizeObserver, _React$Component);
	
	  function ReactResizeObserver() {
	    var _this;
	
	    _classCallCheck(this, ReactResizeObserver);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactResizeObserver).apply(this, arguments));
	    _this.resizeObserver = null;
	    _this.childNode = null;
	    _this.currentElement = null;
	    _this.state = {
	      width: 0,
	      height: 0
	    };
	
	    _this.onResize = function (entries) {
	      var onResize = _this.props.onResize;
	      var target = entries[0].target;
	
	      var _target$getBoundingCl = target.getBoundingClientRect(),
	          width = _target$getBoundingCl.width,
	          height = _target$getBoundingCl.height;
	      /**
	       * Resize observer trigger when content size changed.
	       * In most case we just care about element size,
	       * let's use `boundary` instead of `contentRect` here to avoid shaking.
	       */
	
	
	      var fixedWidth = Math.floor(width);
	      var fixedHeight = Math.floor(height);
	
	      if (_this.state.width !== fixedWidth || _this.state.height !== fixedHeight) {
	        var size = {
	          width: fixedWidth,
	          height: fixedHeight
	        };
	
	        _this.setState(size);
	
	        if (onResize) {
	          onResize(size);
	        }
	      }
	    };
	
	    _this.setChildNode = function (node) {
	      _this.childNode = node;
	    };
	
	    return _this;
	  }
	
	  _createClass(ReactResizeObserver, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.onComponentUpdated();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.onComponentUpdated();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.destroyObserver();
	    }
	  }, {
	    key: "onComponentUpdated",
	    value: function onComponentUpdated() {
	      var disabled = this.props.disabled; // Unregister if disabled
	
	      if (disabled) {
	        this.destroyObserver();
	        return;
	      } // Unregister if element changed
	
	
	      var element = findDOMNode_1.default(this.childNode || this);
	      var elementChanged = element !== this.currentElement;
	
	      if (elementChanged) {
	        this.destroyObserver();
	        this.currentElement = element;
	      }
	
	      if (!this.resizeObserver && element) {
	        this.resizeObserver = new resize_observer_polyfill_1.default(this.onResize);
	        this.resizeObserver.observe(element);
	      }
	    }
	  }, {
	    key: "destroyObserver",
	    value: function destroyObserver() {
	      if (this.resizeObserver) {
	        this.resizeObserver.disconnect();
	        this.resizeObserver = null;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var children = this.props.children;
	      var childNodes = toArray_1.default(children);
	
	      if (childNodes.length > 1) {
	        warning_1.default(false, 'Find more than one child node with `children` in ResizeObserver. Will only observe first one.');
	      } else if (childNodes.length === 0) {
	        warning_1.default(false, '`children` of ResizeObserver is empty. Nothing is in observe.');
	        return null;
	      }
	
	      var childNode = childNodes[0];
	
	      if (React.isValidElement(childNode) && util_1.supportRef(childNode)) {
	        var ref = childNode.ref;
	        childNodes[0] = React.cloneElement(childNode, {
	          ref: ref_1.composeRef(ref, this.setChildNode)
	        });
	      }
	
	      return childNodes.length === 1 ? childNodes[0] : childNodes.map(function (node, index) {
	        if (!React.isValidElement(node) || 'key' in node && node.key !== null) {
	          return node;
	        }
	
	        return React.cloneElement(node, {
	          key: "".concat(INTERNAL_PREFIX_KEY, "-").concat(index)
	        });
	      });
	    }
	  }]);
	
	  return ReactResizeObserver;
	}(React.Component);
	
	ReactResizeObserver.displayName = 'ResizeObserver';
	exports.default = ReactResizeObserver;

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.arrayTreeFilter = factory());
	}(this, (function () { 'use strict';
	
	function arrayTreeFilter(data, filterFn, options) {
	    options = options || {};
	    options.childrenKeyName = options.childrenKeyName || "children";
	    var children = data || [];
	    var result = [];
	    var level = 0;
	    do {
	        var foundItem = children.filter(function (item) {
	            return filterFn(item, level);
	        })[0];
	        if (!foundItem) {
	            break;
	        }
	        result.push(foundItem);
	        children = foundItem[options.childrenKeyName] || [];
	        level += 1;
	    } while (children.length > 0);
	    return result;
	}
	
	return arrayTreeFilter;
	
	})));


/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.querySaveFunction = exports.queryDeleteFunction = exports.queryFunctionInfo = exports.queryMyFunctionListTree = exports.queryFunctionListTreeEnable = exports.queryFunctionListTree = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var queryFunctionListTree = exports.queryFunctionListTree = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.core.GET_FUNCTION_LIST_TREE, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryFunctionListTree(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryFunctionListTreeEnable = exports.queryFunctionListTreeEnable = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.core.GET_FUNCTION_LIST_TREE_ENABLE, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryFunctionListTreeEnable(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryMyFunctionListTree = exports.queryMyFunctionListTree = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.core.GET_MY_FUNCTION_LIST_TREE, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryMyFunctionListTree(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryFunctionInfo = exports.queryFunctionInfo = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.core.GET_FUNCTION_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryFunctionInfo(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var queryDeleteFunction = exports.queryDeleteFunction = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.get(_req.core.DELETE_FUNCTION, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryDeleteFunction(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var querySaveFunction = exports.querySaveFunction = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(params) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt('return', _http2.default.post(_req.core.SAVE_FUNCTION, params));
	
	          case 1:
	          case 'end':
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function querySaveFunction(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryDeleteSerialNumber = exports.querySaveSerialNumber = exports.querySerialNumberInfo = exports.querySerialNumberList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var querySerialNumberList = exports.querySerialNumberList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.core.GET_SERIALNUMBER_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function querySerialNumberList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var querySerialNumberInfo = exports.querySerialNumberInfo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.core.GET_SERIALNUMBER_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function querySerialNumberInfo(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var querySaveSerialNumber = exports.querySaveSerialNumber = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.post(_req.core.SAVE_SERIALNUMBER, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function querySaveSerialNumber(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryDeleteSerialNumber = exports.queryDeleteSerialNumber = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.core.DELETE_SERIALNUMBER, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryDeleteSerialNumber(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryPayRoll = exports.queryWageDetailPersonal = exports.queryExample = exports.queryLogin = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 登陆
	 */
	var queryLogin = exports.queryLogin = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(user) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt("return", _http2.default.post(_req.common.LOGIN, user));
	
	          case 1:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryLogin(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryExample = exports.queryExample = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2() {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt("return", [0, 1, 2]);
	
	          case 1:
	          case "end":
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryExample() {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryWageDetailPersonal = exports.queryWageDetailPersonal = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt("return", _http2.default.get(_req.hr.WAGE_DETAIL_PERSONAL, params));
	
	          case 1:
	          case "end":
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryWageDetailPersonal(_x2) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryPayRoll = exports.queryPayRoll = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt("return", _http2.default.get(_req.workflow.GET_PAYROLL, params));
	
	          case 1:
	          case "end":
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryPayRoll(_x3) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryXxOrg = exports.queryExportInvoice = exports.queryRestoreInvoice = exports.queryRedInvoice = exports.queryInvalidInvoice = exports.queryDeleteInvoice = exports.querySaveInvoice = exports.queryUseInvoiceEdit = exports.queryUseInvoice = exports.queryInvoiceList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 获取发票列表
	 */
	var queryInvoiceList = exports.queryInvoiceList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt("return", _http2.default.get(_req.xxcrm.INVOICE_LIST, params));
	
	          case 1:
	          case "end":
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryInvoiceList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 发票使用
	 */
	
	
	var queryUseInvoice = exports.queryUseInvoice = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt("return", _http2.default.post(_req.xxcrm.INVOICE_USE, params));
	
	          case 1:
	          case "end":
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryUseInvoice(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryUseInvoiceEdit = exports.queryUseInvoiceEdit = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt("return", _http2.default.post(_req.xxcrm.INVOICE_USE_EDIT, params));
	
	          case 1:
	          case "end":
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryUseInvoiceEdit(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	/**
	 * 添加发票
	 */
	
	
	var querySaveInvoice = exports.querySaveInvoice = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt("return", _http2.default.post(_req.xxcrm.INVOICE_SAVE, params));
	
	          case 1:
	          case "end":
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function querySaveInvoice(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	/**
	 * 删除发票
	 */
	
	
	var queryDeleteInvoice = exports.queryDeleteInvoice = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(uuids) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt("return", _http2.default.get(_req.xxcrm.INVOICE_DELETE, { uuids: uuids }));
	
	          case 1:
	          case "end":
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function queryDeleteInvoice(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	/**
	 * 作废发票
	 */
	
	
	var queryInvalidInvoice = exports.queryInvalidInvoice = function () {
	  var _ref6 = _asyncToGenerator(_regenerator2.default.mark(function _callee6(uuids) {
	    return _regenerator2.default.wrap(function _callee6$(_context6) {
	      while (1) {
	        switch (_context6.prev = _context6.next) {
	          case 0:
	            return _context6.abrupt("return", _http2.default.get(_req.xxcrm.INVOICE_INVALID, { uuids: uuids }));
	
	          case 1:
	          case "end":
	            return _context6.stop();
	        }
	      }
	    }, _callee6, this);
	  }));
	
	  return function queryInvalidInvoice(_x6) {
	    return _ref6.apply(this, arguments);
	  };
	}();
	
	/**
	 * 冲红发票
	 */
	
	
	var queryRedInvoice = exports.queryRedInvoice = function () {
	  var _ref7 = _asyncToGenerator(_regenerator2.default.mark(function _callee7(uuids) {
	    return _regenerator2.default.wrap(function _callee7$(_context7) {
	      while (1) {
	        switch (_context7.prev = _context7.next) {
	          case 0:
	            return _context7.abrupt("return", _http2.default.get(_req.xxcrm.INVOICE_RED, { uuids: uuids }));
	
	          case 1:
	          case "end":
	            return _context7.stop();
	        }
	      }
	    }, _callee7, this);
	  }));
	
	  return function queryRedInvoice(_x7) {
	    return _ref7.apply(this, arguments);
	  };
	}();
	
	/**
	 * 恢复发票
	 */
	
	
	var queryRestoreInvoice = exports.queryRestoreInvoice = function () {
	  var _ref8 = _asyncToGenerator(_regenerator2.default.mark(function _callee8(uuids) {
	    return _regenerator2.default.wrap(function _callee8$(_context8) {
	      while (1) {
	        switch (_context8.prev = _context8.next) {
	          case 0:
	            return _context8.abrupt("return", _http2.default.get(_req.xxcrm.INVOICE_RESTORE, { uuids: uuids }));
	
	          case 1:
	          case "end":
	            return _context8.stop();
	        }
	      }
	    }, _callee8, this);
	  }));
	
	  return function queryRestoreInvoice(_x8) {
	    return _ref8.apply(this, arguments);
	  };
	}();
	
	/**
	 * 导出发票
	 */
	
	
	var queryExportInvoice = exports.queryExportInvoice = function () {
	  var _ref9 = _asyncToGenerator(_regenerator2.default.mark(function _callee9(params) {
	    return _regenerator2.default.wrap(function _callee9$(_context9) {
	      while (1) {
	        switch (_context9.prev = _context9.next) {
	          case 0:
	            _http2.default.download(_req.xxcrm.INVOICE_EXPORT, params, '发票导出.xlsx');
	
	          case 1:
	          case "end":
	            return _context9.stop();
	        }
	      }
	    }, _callee9, this);
	  }));
	
	  return function queryExportInvoice(_x9) {
	    return _ref9.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取公司列表
	 */
	
	
	var queryXxOrg = exports.queryXxOrg = function () {
	  var _ref10 = _asyncToGenerator(_regenerator2.default.mark(function _callee10() {
	    return _regenerator2.default.wrap(function _callee10$(_context10) {
	      while (1) {
	        switch (_context10.prev = _context10.next) {
	          case 0:
	            return _context10.abrupt("return", _http2.default.get(_req.core.XX_ORG_LIST));
	
	          case 1:
	          case "end":
	            return _context10.stop();
	        }
	      }
	    }, _callee10, this);
	  }));
	
	  return function queryXxOrg() {
	    return _ref10.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The invoice api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.queryCustom = exports.queryOrderInfo = exports.queryOrderList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	/**
	 * 订单列表
	 */
	var queryOrderList = exports.queryOrderList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.xxcrm.ORDER_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryOrderList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	/**
	 * 获取订单详情
	 */
	
	
	var queryOrderInfo = exports.queryOrderInfo = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(uuid) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.xxcrm.ORDER_INFO, { uuid: uuid }));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryOrderInfo(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	/**
	 * 客户查询
	 */
	
	
	var queryCustom = exports.queryCustom = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.xxcrm.CUSTOM_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryCustom(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The order api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Manage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manage.__proto__ || Object.getPrototypeOf(Manage)).call.apply(_ref, [this].concat(args))), _this), _this.handleOk = function () {
	      var data = _this.props.data || {};
	      _this.props.form.validateFields(function (err, values) {
	        var params = {};
	        params.uuid = data.uuid;
	        params.returnNumber = values.actualNumber;
	        params.returnDate = values.actualDate.format('YYYY-MM-DD');
	        if (!err) {
	          _this.props.handleOk(params);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Manage, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          visible = _props.visible,
	          handleCancel = _props.handleCancel,
	          getFieldDecorator = _props.form.getFieldDecorator;
	
	      var data = this.props.data || {};
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u8D44\u6599\u501F\u8FD8',
	          width: '50%',
	          visible: visible,
	          onOk: this.handleOk,
	          onCancel: function onCancel() {
	            return handleCancel(false);
	          }
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8D44\u6599\u7F16\u53F7' }, formItemLayout),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  data.no
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8D44\u6599\u501F\u7528\u65F6\u95F4' }, formItemLayout),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  data.createTime ? (0, _moment2.default)(data.createTime).format('YYYY-MM-DD') : null
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8D44\u6599\u5F52\u5C5E' }, formItemLayout),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  data.company
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u9884\u8BA1\u5F52\u8FD8\u65F6\u95F4' }, formItemLayout),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  data.expectReturnDate ? (0, _moment2.default)(data.expectReturnDate).format('YYYY-MM-DD') : null
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u501F\u7528\u6570\u91CF' }, formItemLayout),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  data.number
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5B9E\u9645\u5F52\u8FD8\u65F6\u95F4' }, formItemLayout),
	                getFieldDecorator('actualDate', {
	                  rules: [{ required: true, message: '请选择实际归还时间' }]
	                })(_react2.default.createElement(_antd.DatePicker, null))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F52\u8FD8\u6570\u91CF' }, formItemLayout),
	                getFieldDecorator('actualNumber', {
	                  rules: [{ required: true, message: '请填写要归还数量' }]
	                })(_react2.default.createElement(_antd.InputNumber, { min: 1, max: data.number || 0 }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '资料文件名称',
	        dataIndex: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.document.name
	          );
	        }
	      }, {
	        title: '资料归属公司',
	        dataIndex: 'company'
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '约定归还时间',
	        dataIndex: 'expectReturnDate',
	        key: 'expectReturnDate',
	        render: function render(text) {
	          var day = 0;
	          if (_this.props.type === 'todo') {
	            day = Math.floor((Date.now() - text) / 86400000);
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : '',
	            day > 0 ? _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '(\u903E\u671F',
	              day,
	              '\u5929)'
	            ) : '',
	            day < 0 ? _react2.default.createElement(
	              'span',
	              null,
	              '(\u5269\u4F59',
	              day,
	              '\u5929)'
	            ) : ''
	          );
	        }
	      }, {
	        title: '实际归还时间',
	        dataIndex: 'returnDate',
	        key: 'returnDate',
	        render: function render(text, record) {
	          var day = 0;
	          if (record.expectReturnDate && text) {
	            day = Math.floor((text - record.expectReturnDate) / 86400000);
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : '',
	            day > 0 ? _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '(\u903E\u671F',
	              day,
	              '\u5929)'
	            ) : '',
	            day < 0 ? _react2.default.createElement(
	              'span',
	              null,
	              '(\u63D0\u524D',
	              day,
	              '\u5929)'
	            ) : ''
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            record.borrowUuid ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/administrative/material/borrow_manage/open/' + record.borrowUuid },
	              '\u67E5\u770B\u6D41\u7A0B'
	            ) : null,
	            record.borrowUuid && _this.props.type === 'todo' && _this.props.type2 !== 'mine' ? _react2.default.createElement(_antd.Divider, { type: 'vertical' }) : null,
	            _this.props.type === 'todo' && _this.props.type2 !== 'mine' ? _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.props.showModalReturn(record);
	                } },
	              '\u8D44\u6599\u501F\u8FD8'
	            ) : null
	          );
	        }
	      }];
	
	      if (_this.props.type === 'todo') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'returnDate';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Table, {
	          onChange: this.handleChange,
	          columns: this.columns(),
	          pagination: pagination,
	          dataSource: list,
	          rowKey: 'uuid'
	        })
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TagsInput = function (_Component) {
	  _inherits(TagsInput, _Component);
	
	  function TagsInput(props) {
	    _classCallCheck(this, TagsInput);
	
	    var _this = _possibleConstructorReturn(this, (TagsInput.__proto__ || Object.getPrototypeOf(TagsInput)).call(this, props));
	
	    _this.handleClose = function (removedTag) {
	      var tags = _this.props.tags.filter(function (tag) {
	        return tag.uid !== removedTag.uid;
	      });
	      _this.props.handleSetTags(tags);
	    };
	
	    _this.showInput = function () {
	      _this.setState({ inputVisible: true }, function () {
	        return _this.input.focus();
	      });
	    };
	
	    _this.handleInputChange = function (e) {
	      _this.setState({ inputValue: e.target.value });
	    };
	
	    _this.handleInputConfirm = function () {
	      var inputValue = _this.state.inputValue;
	      var tags = _this.props.tags;
	
	      if (inputValue && tags.indexOf(inputValue) === -1) {
	        tags = [].concat(_toConsumableArray(tags), [{ name: inputValue, uid: Date.now() }]);
	        _this.props.handleSetTags(tags);
	      }
	      _this.setState({
	        inputVisible: false,
	        inputValue: ''
	      });
	    };
	
	    _this.state = {
	      inputVisible: false,
	      inputValue: ''
	    };
	    return _this;
	  }
	
	  _createClass(TagsInput, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          inputVisible = _state.inputVisible,
	          inputValue = _state.inputValue;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.tags.map(function (item) {
	          var isLongTag = item.name.length > 20;
	          var tagElem = _react2.default.createElement(
	            _antd.Tag,
	            { key: item.uuid || item.uid, closable: true, onClose: function onClose() {
	                return _this2.handleClose(item);
	              } },
	            isLongTag ? item.name.slice(0, 20) + '...' : item.name
	          );
	          return isLongTag ? _react2.default.createElement(
	            _antd.Tooltip,
	            { title: item.name, key: item.uuid || item.uid },
	            tagElem
	          ) : tagElem;
	        }),
	        inputVisible && _react2.default.createElement(_antd.Input, {
	          ref: function ref(input) {
	            _this2.input = input;
	          },
	          type: 'text',
	          size: 'small',
	          style: { width: 78 },
	          value: inputValue,
	          onChange: this.handleInputChange,
	          onBlur: this.handleInputConfirm,
	          onPressEnter: this.handleInputConfirm
	        }),
	        !inputVisible && _react2.default.createElement(
	          _antd.Tag,
	          { onClick: this.showInput, style: { background: '#fff', borderStyle: 'dashed' } },
	          _react2.default.createElement(_antd.Icon, { type: 'plus' }),
	          ' New Tag'
	        )
	      );
	    }
	  }]);
	
	  return TagsInput;
	}(_react.Component);
	
	exports.default = TagsInput;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _big = __webpack_require__(235);
	
	var _big2 = _interopRequireDefault(_big);
	
	__webpack_require__(596);
	
	var _chooseGroup = __webpack_require__(1510);
	
	var _chooseGroup2 = _interopRequireDefault(_chooseGroup);
	
	var _SelectApportionObj = __webpack_require__(678);
	
	var _SelectApportionObj2 = _interopRequireDefault(_SelectApportionObj);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RadioButton = _antd.Radio.Button;
	var RadioGroup = _antd.Radio.Group;
	
	var ModalApportion = function (_Component) {
	  _inherits(ModalApportion, _Component);
	
	  function ModalApportion(props) {
	    _classCallCheck(this, ModalApportion);
	
	    var _this = _possibleConstructorReturn(this, (ModalApportion.__proto__ || Object.getPrototypeOf(ModalApportion)).call(this, props));
	
	    _this.content = function () {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          '\u975E\u516C\u644A\uFF1A\u6309\u3010\u9884\u7B97\u5206\u644A\u3011\u6263\u9664\u9884\u7B97\u4F59\u989D\u548C\u5206\u644A\u9884\u7B97'
	        )
	      );
	    };
	
	    _this.approLabel = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u5206\u644A\u7C7B\u578B',
	        _react2.default.createElement(
	          _antd.Popover,
	          { placement: 'topLeft', content: _this.content() },
	          _react2.default.createElement(_antd.Icon, { type: 'question-circle', style: { color: '1890FF' } })
	        )
	      );
	    };
	
	    _this.handleChange = function (params) {
	      _this.details = params;
	      if (params.length > 0) {
	        _this.setState({
	          count: _this.getCountSum(params),
	          minus: _this.getMinus(params),
	          avg: _this.getAvg(params)
	        });
	      } else {
	        _this.setState({
	          count: '-',
	          minus: '',
	          avg: '-'
	        });
	      }
	    };
	
	    _this.getCountSum = function (data) {
	      var countSum = data.reduce(function (prev, curr) {
	        return prev + curr.count;
	      }, 0);
	      return countSum;
	    };
	
	    _this.getAvg = function (params) {
	      var _this$props = _this.props,
	          dataItem = _this$props.dataItem,
	          dataInfo = _this$props.dataInfo;
	
	      var price = dataItem.price || dataInfo.price || 0;
	      return new _big2.default(price || 0).div(new _big2.default(_this.getCountSum(params) || 1)).toFixed(2);
	    };
	
	    _this.getMinus = function (params) {
	      var _this$props2 = _this.props,
	          dataItem = _this$props2.dataItem,
	          dataInfo = _this$props2.dataInfo;
	
	      var price = dataItem.price || dataInfo.price || 0;
	      var sum = params.reduce(function (prev, curr) {
	        return prev.plus(new _big2.default(curr.price || 0));
	      }, new _big2.default(0));
	      var minus = (new _big2.default(sum) - new _big2.default(price || 0)).toFixed(2);
	      return minus;
	    };
	
	    _this.groupChange = function (params) {
	      _this.setState(Object.assign({}, params));
	    };
	
	    _this.findTypeName = function (type) {
	      var typeName = '';
	      _this.props.expendType.forEach(function (item) {
	        if (type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.handleType = function (e) {
	      _this.setState({
	        type: e.target.value
	      });
	    };
	
	    _this.handleSubmit = function () {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = values;
	          params.details = _this.details;
	          params.groupName = _this.state.groupName;
	          params.groupUuid = _this.state.groupUuid;
	
	          _this.props.onOk(params);
	        }
	      });
	    };
	
	    _this.state = {
	      groupName: '',
	      count: '',
	      minus: 0,
	      avg: 0
	    };
	    return _this;
	  }
	
	  _createClass(ModalApportion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.details = [];
	      var apportion = this.props.dataItem.apportion || {};
	      this.handleChange(apportion.details || this.details);
	      this.setState({
	        type: apportion.type
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          dataInfo = _props.dataInfo,
	          visible = _props.visible,
	          dataItem = _props.dataItem;
	      var isPublic = this.props.isPublic;
	      var _state = this.state,
	          count = _state.count,
	          minus = _state.minus,
	          avg = _state.avg,
	          type = _state.type;
	
	      var apportion = dataItem.apportion || {};
	      var formItemLayout = {
	        labelCol: { span: 7 },
	        wrapperCol: { span: 17 }
	      };
	      var formItemLayout2 = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var details = apportion.details || this.details;
	      if (apportion.type === 1 || apportion.type === 2) {
	        isPublic = true;
	      }
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          width: 900,
	          title: '\u8BBE\u7F6E\u5206\u644A\u65B9\u6848',
	          visible: visible,
	          onCancel: function onCancel() {
	            return _this2.props.onCancel(false);
	          },
	          onOk: this.handleSubmit
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modalApportion' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: this.approLabel() }, formItemLayout),
	                getFieldDecorator('type', {
	                  rules: [{ required: true, message: '请设置分摊类型!' }],
	                  initialValue: apportion.type === 0 || apportion.type === 1 ? '' + apportion.type : '0'
	                })(_react2.default.createElement(
	                  RadioGroup,
	                  { onChange: this.handleType },
	                  _react2.default.createElement(
	                    RadioButton,
	                    { value: '0' },
	                    '\u975E\u516C\u644A'
	                  ),
	                  isPublic ? _react2.default.createElement(
	                    RadioButton,
	                    { value: '1' },
	                    '\u5355\u6B21\u516C\u644A'
	                  ) : null,
	                  isPublic ? _react2.default.createElement(
	                    RadioButton,
	                    { value: '2' },
	                    '\u591A\u6B21\u516C\u644A'
	                  ) : null
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 6 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7C7B\u578B' }, formItemLayout),
	                this.findTypeName(dataItem.type || dataInfo.type)
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u91D1\u989D' }, formItemLayout),
	                dataItem.price || dataInfo.price
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u4EBA\u5747\u91D1\u989D' }, formItemLayout2),
	                avg
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 6 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u4EBA\u6570' }, formItemLayout2),
	                count
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u91D1\u989D' }, formItemLayout),
	                dataInfo.price,
	                new _big2.default(minus || 0).eq(new _big2.default(0)) ? null : _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red', marginLeft: '8px' } },
	                  '\u5DEE\u989D',
	                  minus,
	                  '\u5143'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_antd.Divider, null),
	          +type === 1 || +type === 2 ? _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                FormItem,
	                {
	                  label: '\u9884\u7B97\u6765\u6E90',
	                  labelCol: { span: 5 },
	                  wrapperCol: { span: 14 },
	                  style: { paddingRight: '10px' }
	                },
	                getFieldDecorator('groupUuid', {
	                  rules: [{ required: true, message: '请选择预算来源!' }]
	                })(_react2.default.createElement(_chooseGroup2.default, {
	                  mode: '',
	                  onChange: this.groupChange,
	                  defaultValue: apportion.groupUuid
	                }))
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            +type === 2 ? null : _react2.default.createElement(_SelectApportionObj2.default, {
	              price: dataInfo.price || 0,
	              onChange: this.handleChange,
	              dataItem: dataItem,
	              choosedArr: details
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalApportion;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(_antd.Form.create()(ModalApportion));

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _big = __webpack_require__(235);
	
	var _big2 = _interopRequireDefault(_big);
	
	__webpack_require__(596);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var type = ['全部人员', '部门', '项目'];
	var apportionType = ['非公摊', '单次公摊', '多次公摊'];
	
	var ModalApportion = function (_Component) {
	  _inherits(ModalApportion, _Component);
	
	  function ModalApportion(props) {
	    _classCallCheck(this, ModalApportion);
	
	    var _this = _possibleConstructorReturn(this, (ModalApportion.__proto__ || Object.getPrototypeOf(ModalApportion)).call(this, props));
	
	    _this.findTypeName = function (value) {
	      var typeName = '';
	      _this.props.expendType.forEach(function (item) {
	        if (value === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '分摊对象',
	        dataIndex: 'originName',
	        width: 100
	      }, {
	        title: '类型',
	        dataIndex: 'originType',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            type[text]
	          );
	        },
	        width: 100
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        width: 160,
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            record.isEditable ? _react2.default.createElement(_antd.Input, { value: text, onChange: function onChange() {
	                return _this.handlePriceChange(record);
	              } }) : _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	        }
	      }];
	    };
	
	    _this.handleChange = function (params) {
	      _this.details = params;
	      if (params.length > 0) {
	        _this.setState({
	          count: _this.getCountSum(params),
	          avg: _this.getAvg(params)
	        });
	      } else {
	        _this.setState({
	          count: '-',
	          avg: '-'
	        });
	      }
	    };
	
	    _this.getCountSum = function (data) {
	      var countSum = data.reduce(function (prev, curr) {
	        return prev + curr.count;
	      }, 0);
	      return countSum;
	    };
	
	    _this.getAvg = function (params) {
	      var _this$props = _this.props,
	          dataItem = _this$props.dataItem,
	          dataInfo = _this$props.dataInfo;
	
	      var price = dataItem.price || dataInfo.price;
	      return new _big2.default(price || 0).div(new _big2.default(_this.getCountSum(params))).toFixed(2);
	    };
	
	    _this.state = {
	      count: '',
	      visible: _this.props.visible,
	      avg: 0
	    };
	    return _this;
	  }
	
	  _createClass(ModalApportion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var apportion = this.props.dataItem.apportion || {};
	      this.handleChange(apportion.details || []);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var apportion = nextProps.dataItem.apportion || {};
	      this.handleChange(apportion.details || []);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          dataInfo = _props.dataInfo,
	          dataItem = _props.dataItem;
	      var _state = this.state,
	          count = _state.count,
	          visible = _state.visible,
	          avg = _state.avg;
	
	      var apportion = dataItem.apportion || {};
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 18 }
	      };
	      var formItemLayout2 = {
	        labelCol: { span: 2 },
	        wrapperCol: { span: 22 }
	      };
	      var details = apportion.details || [];
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          width: 900,
	          title: '\u67E5\u770B\u5206\u644A\u65B9\u6848',
	          visible: visible,
	          footer: false,
	          onCancel: function onCancel() {
	            return _this2.props.onCancel(false);
	          }
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modalApportion' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u7C7B\u578B' }, formItemLayout),
	                apportionType[apportion.type]
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7C7B\u578B' }, formItemLayout),
	                this.findTypeName(dataItem.type || dataInfo.type)
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u91D1\u989D' }, formItemLayout),
	                dataItem.price || dataInfo.price
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u4EBA\u6570' }, formItemLayout),
	                count
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u4EBA\u5747\u91D1\u989D' }, formItemLayout),
	                avg
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u91D1\u989D' }, formItemLayout),
	                dataItem.price
	              )
	            )
	          ),
	          _react2.default.createElement(_antd.Divider, null),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              +apportion.type === 1 || +apportion.type === 2 ? _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u9884\u7B97\u6765\u6E90' }, formItemLayout),
	                apportion.groupName || ''
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u9884\u7B97\u5206\u644A' }, formItemLayout2),
	                _react2.default.createElement(_antd.Table, {
	                  bordered: true,
	                  rowKey: 'originUuid',
	                  columns: this.columns(),
	                  dataSource: details,
	                  scroll: { y: 260 },
	                  pagination: false,
	                  size: 'small'
	                })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalApportion;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(_antd.Form.create()(ModalApportion));

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _provinces = __webpack_require__(894);
	
	var _provinces2 = _interopRequireDefault(_provinces);
	
	var _cities = __webpack_require__(2490);
	
	var _cities2 = _interopRequireDefault(_cities);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// import areas from "china-division/dist/areas.json"
	
	// areas.forEach(area => {
	//   const matchCity = cities.filter(city => city.code === area.cityCode)[0]
	//   if (matchCity) {
	//     matchCity.children = matchCity.children || []
	//     matchCity.children.push({
	//       label: area.name,
	//       value: area.code
	//     })
	//   }
	// })
	
	_cities2.default.forEach(function (city) {
	  var matchProvince = _provinces2.default.filter(function (province) {
	    return province.code === city.provinceCode;
	  })[0];
	  if (matchProvince) {
	    matchProvince.children = matchProvince.children || [];
	    matchProvince.children.push({
	      label: city.name,
	      value: city.code
	      // children: city.children
	    });
	  }
	});
	
	var options = _provinces2.default.map(function (province) {
	  return {
	    label: province.name,
	    value: province.code,
	    children: province.children
	  };
	});
	
	exports.default = options;

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _echarts = __webpack_require__(817);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Series = function (_React$Component) {
	  _inherits(Series, _React$Component);
	
	  function Series() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Series);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Series.__proto__ || Object.getPrototypeOf(Series)).call.apply(_ref, [this].concat(args))), _this), _this.drawChart = function (params) {
	      var legend = params.legend,
	          title = params.title,
	          xAxisData = params.xAxisData,
	          series = params.series;
	
	      _this.myChart.setOption({
	        title: {
	          text: title
	        },
	        tooltip: {
	          trigger: "axis"
	        },
	        legend: {
	          data: legend
	        },
	        xAxis: {
	          data: xAxisData
	        },
	        yAxis: {},
	        series: series,
	        dataZoom: [{
	          type: "slider",
	          show: true
	        }]
	      });
	      _this.myChart.resize();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Series, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.myChart = _echarts2.default.init(document.getElementById("echarts"));
	      this.drawChart(this.props);
	      window.addEventListener("resize", function () {
	        _this2.myChart.resize();
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.drawChart(nextProps);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", { id: "echarts", style: { width: "100%", height: 600 } });
	    }
	  }]);
	
	  return Series;
	}(_react2.default.Component);
	
	exports.default = Series;

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DescDoc = function (_Component) {
	  _inherits(DescDoc, _Component);
	
	  function DescDoc(props) {
	    _classCallCheck(this, DescDoc);
	
	    var _this = _possibleConstructorReturn(this, (DescDoc.__proto__ || Object.getPrototypeOf(DescDoc)).call(this, props));
	
	    _this.getDocumentList = function () {
	      var params = {
	        condition: '用款申请_关于预算来源如何选择_desc'
	      };
	      (0, _material.queryMaterialDocumentListBR)(params).then(function (res) {
	        if (res.statusCode === 200 && res.data.length > 0) {
	          _this.setState({
	            descFile: res.data[0].files[0]
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      descFile: {}
	    };
	    return _this;
	  }
	
	  _createClass(DescDoc, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getDocumentList();
	    }
	
	    // 获取说明性文件
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var descFile = this.state.descFile;
	
	      return _react2.default.createElement(
	        'span',
	        { key: descFile.url },
	        _react2.default.createElement(
	          'a',
	          { onClick: function onClick() {
	              return (0, _attachment.queryFilePreview)(descFile);
	            } },
	          _react2.default.createElement(_antd.Icon, { type: 'question-circle' })
	        )
	      );
	    }
	  }]);
	
	  return DescDoc;
	}(_react.Component);
	
	exports.default = DescDoc;

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DescDoc = function (_Component) {
	  _inherits(DescDoc, _Component);
	
	  function DescDoc(props) {
	    _classCallCheck(this, DescDoc);
	
	    var _this = _possibleConstructorReturn(this, (DescDoc.__proto__ || Object.getPrototypeOf(DescDoc)).call(this, props));
	
	    _this.getDocumentList = function () {
	      var params = {
	        condition: '费用类型_帮实_desc'
	      };
	      (0, _material.queryMaterialDocumentListBR)(params).then(function (res) {
	        if (res.statusCode === 200 && res.data.length > 0) {
	          _this.setState({
	            descFile: res.data[0].files[0]
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      descFile: {}
	    };
	    return _this;
	  }
	
	  _createClass(DescDoc, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getDocumentList();
	    }
	
	    // 获取说明性文件
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var descFile = this.state.descFile;
	
	      return _react2.default.createElement(
	        'span',
	        { key: descFile.url },
	        _react2.default.createElement(
	          'a',
	          { onClick: function onClick() {
	              return (0, _attachment.queryFilePreview)(descFile);
	            } },
	          _react2.default.createElement(_antd.Icon, { type: 'question-circle' })
	        )
	      );
	    }
	  }]);
	
	  return DescDoc;
	}(_react.Component);
	
	exports.default = DescDoc;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _task = __webpack_require__(66);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableProj = function (_Component) {
	  _inherits(TableProj, _Component);
	
	  function TableProj() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, TableProj);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TableProj.__proto__ || Object.getPrototypeOf(TableProj)).call.apply(_ref, [this].concat(args))), _this), _this.getProjUpdStatus = function (uuid, status) {
	      (0, _task.queryProjUpdStatus)({
	        uuid: uuid,
	        status: status
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    }, _this.columns = function () {
	      var _this$props = _this.props,
	          type = _this$props.type,
	          type2 = _this$props.type2;
	
	      var config = [
	      // {
	      //   title: "",
	      //   dataIndex: "isFocus",
	      //   width: "30px",
	      //   render: (text, record) => {
	      //     return (
	      //       <span style={{ fontSize: "16px" }} onClick={this.props.isFocusOn}>
	      //         <Icon
	      //           type="heart"
	      //           theme={text === 1 ? "filled" : "outlined"}
	      //           style={{ color: text === 1 ? "#FF3333" : "#555555" }}
	      //         />
	      //       </span>
	      //     );
	      //   }
	      // },
	      {
	        title: '项目标题',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          if (type === 'receive') {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/task/project_detail/' + record.uuid },
	              text
	            );
	          }
	          if (type === 'launch') {
	            if (type2 === 'finish') {
	              return _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/task/project_detail_finish/' + record.uuid },
	                text
	              );
	            }
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/task/project_detail_manage/' + record.uuid },
	              text
	            );
	          }
	        }
	      }, {
	        title: '任务分类',
	        dataIndex: 'type',
	        key: 'type',
	        render: function render(text, record) {
	          switch (text) {
	            case 0:
	              return '绩效考核';
	            case 1:
	              return '政府申报';
	            case 2:
	              return '日常任务';
	            default:
	          }
	        }
	      }, {
	        title: '业务部门/标签',
	        dataIndex: 'workorgName',
	        key: 'workorgName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              text
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              record.tags.map(function (item) {
	                return _react2.default.createElement(
	                  'span',
	                  {
	                    style: {
	                      border: '1px solid #D3D3D3',
	                      borderRadius: '5%',
	                      marginRight: '5px'
	                    },
	                    key: item
	                  },
	                  item
	                );
	              })
	            )
	          );
	        }
	      }, {
	        title: '任务数',
	        dataIndex: 'taskNum',
	        key: 'taskNum'
	      }, {
	        title: '完成数',
	        dataIndex: 'taskCompletions',
	        key: 'taskCompletions'
	      }, {
	        title: '截止时间',
	        dataIndex: 'endDate',
	        key: 'endDate',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'updateDate',
	        key: 'updateDate',
	        render: function render(text, record) {
	          var day = 0;
	          if (record.updateDate && record.endDate) {
	            day = Math.floor((record.updateDate - record.endDate) / 86400000);
	          }
	
	          var element = day > 0 ? _react2.default.createElement(
	            'span',
	            { style: { color: 'red', marginLeft: '10px' } },
	            '\u903E\u671F',
	            day,
	            '\u5929'
	          ) : _react2.default.createElement(
	            'span',
	            { style: { color: 'green', marginLeft: '10px' } },
	            '\u63D0\u524D',
	            Math.abs(day),
	            '\u5929'
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm:ss') : '',
	            day ? element : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'fettle',
	        render: function render(text, record) {
	          if (record.status === 1) {
	            switch (record.fettle) {
	              case 1:
	                return _react2.default.createElement(_antd.Badge, { color: 'red', text: '\u5DF2\u903E\u671F' });
	              case 2:
	                return _react2.default.createElement(_antd.Badge, { color: 'blue', text: '\u8FDB\u884C\u4E2D' });
	              case 3:
	                return _react2.default.createElement(_antd.Badge, { color: 'yellow', text: '\u672A\u5F00\u59CB' });
	              default:
	            }
	          } else if (record.status === 2) {
	            switch (record.fettle) {
	              case 1:
	                return _react2.default.createElement(_antd.Badge, { color: 'red', text: '\u672A\u5B8C\u6210' });
	              case 2:
	                return _react2.default.createElement(_antd.Badge, { color: 'green', text: '\u5DF2\u5B8C\u6210' });
	              case 3:
	                return _react2.default.createElement(_antd.Badge, { color: 'gray', text: '\u5DF2\u5E9F\u5F03' });
	              default:
	            }
	          } else if (record.status === 0) {
	            return _react2.default.createElement(_antd.Badge, { color: 'yellow', text: '\u5F85\u7F16\u8F91' });
	          }
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        key: 'done',
	        render: function render(text, record) {
	          switch (record.status) {
	            case 0:
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return _this.toPageEdit(record);
	                    } },
	                  '\u7F16\u8F91'
	                )
	              );
	            case 1:
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return _this.toPageEdit(record);
	                    } },
	                  '\u7F16\u8F91'
	                ),
	                _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                _react2.default.createElement(
	                  _antd.Popconfirm,
	                  {
	                    placement: 'leftTop',
	                    title: '\u786E\u5B9A\u7ED3\u675F\u9879\u76EE\u5417\uFF1F',
	                    onConfirm: function onConfirm() {
	                      return _this.handleEndProj(record.uuid);
	                    },
	                    okText: '\u786E\u5B9A',
	                    cancelText: '\u53D6\u6D88'
	                  },
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    '\u7ED3\u675F'
	                  )
	                ),
	                _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                _react2.default.createElement(
	                  _antd.Popconfirm,
	                  {
	                    placement: 'leftTop',
	                    title: '\u786E\u5B9A\u5E9F\u5F03\u9879\u76EE\u5417\uFF1F',
	                    onConfirm: function onConfirm() {
	                      return _this.handleDisProj(record.uuid);
	                    },
	                    okText: '\u786E\u5B9A',
	                    cancelText: '\u53D6\u6D88'
	                  },
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    '\u5E9F\u5F03'
	                  )
	                )
	              );
	            case 2:
	              return _react2.default.createElement('div', null);
	            default:
	          }
	        }
	      }];
	      if (_this.props.type === 'receive' || _this.props.type2 === 'finish') {
	        config = config.filter(function (item) {
	          return item.key !== 'done';
	        });
	      }
	      if (_this.props.type2 !== 'finish') {
	        config = config.filter(function (item) {
	          return item.key !== 'updateDate';
	        });
	      }
	      return config;
	    }, _this.toPageEdit = function (record) {
	      _this.props.router.push('/task/project_edit/' + record.uuid);
	    }, _this.handleEndProj = function (uuid) {
	      _this.getProjUpdStatus(uuid, 2);
	    }, _this.handleDisProj = function (uuid) {
	      _this.getProjUpdStatus(uuid, 3);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(TableProj, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          pagination = _props.pagination,
	          isLoading = _props.isLoading;
	
	      return _react2.default.createElement(_antd.Table, {
	        size: 'small',
	        rowKey: 'uuid',
	        dataSource: data,
	        loading: isLoading,
	        pagination: pagination,
	        columns: this.columns(),
	        onChange: this.props.onChange
	      });
	    }
	  }]);
	
	  return TableProj;
	}(_react.Component);
	
	exports.default = TableProj;

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _task = __webpack_require__(66);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableTask = function (_Component) {
	  _inherits(TableTask, _Component);
	
	  function TableTask(props) {
	    _classCallCheck(this, TableTask);
	
	    var _this = _possibleConstructorReturn(this, (TableTask.__proto__ || Object.getPrototypeOf(TableTask)).call(this, props));
	
	    _this.getProjUpdStatus = function (uuid, status) {
	      (0, _task.queryProjUpdStatus)({
	        uuid: uuid,
	        status: status
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.setTaskCollect = function (record) {
	      var data = _this.state.data;
	
	      (0, _task.querySetTaskCollect)({ uuid: record.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          record.collectFlag = true;
	          _this.setState({ data: data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.setTaskUnCollect = function (record) {
	      var data = _this.state.data;
	
	
	      (0, _task.querySetTaskUnCollect)({ uuid: record.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          record.collectFlag = false;
	          _this.setState({ data: data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      var config = [{
	        title: '',
	        dataIndex: 'collectFlag',
	        width: 30,
	        render: function render(text, record) {
	          if (text) {
	            return _react2.default.createElement(_antd.Icon, {
	              type: 'heart',
	              style: {
	                color: 'red'
	              },
	              theme: 'filled',
	              onClick: function onClick() {
	                return _this.setTaskUnCollect(record);
	              }
	            });
	          }
	          return _react2.default.createElement(_antd.Icon, { type: 'heart', theme: 'outlined', onClick: function onClick() {
	              return _this.setTaskCollect(record);
	            } });
	        }
	      }, {
	        title: '任务标题',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/task/task_detail/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '任务分类',
	        dataIndex: 'type',
	        key: 'type',
	        render: function render(text, record) {
	          switch (text) {
	            case 0:
	              return '绩效考核';
	            case 1:
	              return '政府申报';
	            case 2:
	              return '日常任务';
	            default:
	          }
	        }
	      }, {
	        title: '业务部门/标签/项目',
	        dataIndex: 'workorgName',
	        key: 'workorgName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              text
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              record.tags.map(function (item) {
	                return _react2.default.createElement(
	                  'span',
	                  {
	                    key: item,
	                    style: {
	                      border: '1px solid #D3D3D3',
	                      borderRadius: '5%',
	                      marginRight: '5px'
	                    }
	                  },
	                  item
	                );
	              })
	            ),
	            _this.props.type === 'receive' ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/task/project_detail/' + record.projectUuid },
	              record.projectName
	            ) : _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/task/project_detail_manage/' + record.projectUuid },
	              record.projectName
	            )
	          );
	        }
	      }, {
	        title: '相关人员',
	        dataIndex: 'executives',
	        key: 'executives',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#D8D1CF' } },
	                '\u6267'
	              ),
	              record.executives.map(function (item) {
	                return _react2.default.createElement(
	                  'span',
	                  { key: item.uuid, style: { paddingLeft: '5px', paddingRight: '5px' } },
	                  item.userName
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#D8D1CF' } },
	                '\u534F'
	              ),
	              record.assistants.map(function (item) {
	                return _react2.default.createElement(
	                  'span',
	                  { key: item.uuid, style: { paddingLeft: '5px', paddingRight: '5px' } },
	                  item.userName
	                );
	              })
	            )
	          );
	        }
	      }, {
	        title: '截止时间',
	        dataIndex: 'endDate',
	        key: 'endDate',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'completionDate',
	        key: 'completionDate',
	        render: function render(text, record) {
	          var day = 0;
	          if (record.completionDate && record.endDate) {
	            day = Math.floor((record.completionDate - record.endDate) / 86400000);
	          }
	
	          var element = day > 0 ? _react2.default.createElement(
	            'span',
	            { style: { color: 'red', marginLeft: '10px' } },
	            '\u903E\u671F',
	            day,
	            '\u5929'
	          ) : _react2.default.createElement(
	            'span',
	            { style: { color: 'green', marginLeft: '10px' } },
	            '\u63D0\u524D',
	            Math.abs(day),
	            '\u5929'
	          );
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm:ss') : '',
	            day ? element : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          if (record.status === 1) {
	            switch (record.fettle) {
	              case 1:
	                return _react2.default.createElement(_antd.Badge, { color: 'red', text: '\u5DF2\u903E\u671F' });
	              case 2:
	                return _react2.default.createElement(_antd.Badge, { color: 'blue', text: '\u8FDB\u884C\u4E2D' });
	              case 3:
	                return _react2.default.createElement(_antd.Badge, { color: 'yellow', text: '\u672A\u5F00\u59CB' });
	              default:
	            }
	          } else if (record.status === 2) {
	            switch (record.fettle) {
	              case 1:
	                return _react2.default.createElement(_antd.Badge, { color: 'red', text: '\u672A\u5B8C\u6210' });
	              case 2:
	                return _react2.default.createElement(_antd.Badge, { color: 'green', text: '\u5DF2\u5B8C\u6210' });
	              case 3:
	                return _react2.default.createElement(_antd.Badge, { color: 'gray', text: '\u5DF2\u5E9F\u5F03' });
	              default:
	            }
	          } else if (record.status === 0) {
	            return _react2.default.createElement(_antd.Badge, { color: 'yellow', text: '\u5F85\u7F16\u8F91' });
	          }
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        key: 'done',
	        render: function render(text, record) {
	          switch (record.status) {
	            case 0:
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return _this.toPageEdit(record);
	                    } },
	                  '\u7F16\u8F91'
	                )
	              );
	            case 1:
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return _this.toPageEdit(record);
	                    } },
	                  '\u7F16\u8F91'
	                ),
	                _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                _react2.default.createElement(
	                  _antd.Popconfirm,
	                  {
	                    placement: 'leftTop',
	                    title: '\u786E\u5B9A\u5E9F\u5F03\u4EFB\u52A1\u5417\uFF1F',
	                    onConfirm: function onConfirm() {
	                      return _this.handleDisTask(record.uuid);
	                    },
	                    okText: '\u786E\u5B9A',
	                    cancelText: '\u53D6\u6D88'
	                  },
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    '\u5E9F\u5F03'
	                  )
	                )
	              );
	            case 2:
	              return _react2.default.createElement('div', null);
	            default:
	          }
	        }
	      }];
	      if (_this.props.type === 'receive' || _this.props.type2 === 'finish') {
	        config = config.filter(function (item) {
	          return item.key !== 'done';
	        });
	      }
	      if (_this.props.type2 !== 'finish') {
	        config = config.filter(function (item) {
	          return item.key !== 'completionDate';
	        });
	      }
	      return config;
	    };
	
	    _this.toPageEdit = function (record) {
	      if (record.projectUuid) {
	        _this.props.router.push({
	          pathname: '/task/project_task_edit/' + record.uuid,
	          query: {
	            projectUuid: record.projectUuid,
	            projectName: record.projectName,
	            directoryUuid: record.directoryUuid,
	            directoryName: record.directoryName
	          }
	        });
	      } else {
	        _this.props.router.push('/task/task_edit/' + record.uuid);
	      }
	    };
	
	    _this.handleDisTask = function (uuid) {
	      (0, _task.queryTaskDiscard)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      data: []
	    };
	    return _this;
	  }
	
	  _createClass(TableTask, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ data: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var data = nextProps.data;
	
	      if (data !== this.props.data) {
	        this.setState({ data: data });
	      }
	    }
	
	    // 废弃任务
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.state.data;
	      var _props = this.props,
	          pagination = _props.pagination,
	          isLoading = _props.isLoading;
	
	      return _react2.default.createElement(_antd.Table, {
	        size: 'small',
	        rowKey: 'uuid',
	        dataSource: data,
	        loading: isLoading,
	        pagination: pagination,
	        columns: this.columns(),
	        onChange: this.props.onChange
	      });
	    }
	  }]);
	
	  return TableTask;
	}(_react.Component);
	
	exports.default = TableTask;

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getContractType = getContractType;
	exports.contractType = contractType;
	
	var _contract = __webpack_require__(89);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 按模块的action, reducer整合体
	var CONTRACT_TYPE = 'CONTRACT_TYPE';
	
	function getContractType() {
	  return function (dispatch) {
	    return (0, _contract.queryContractType)().then(function (res) {
	      if (res.statusCode === 200) {
	        _localDb2.default.set(CONTRACT_TYPE, res.data);
	        return dispatch({
	          type: CONTRACT_TYPE,
	          data: res.data
	        });
	      }
	    });
	  };
	}
	
	// Reducer
	function contractType() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case CONTRACT_TYPE:
	      return action.data;
	    default:
	      return _localDb2.default.get(CONTRACT_TYPE);
	  }
	}

/***/ },
/* 436 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAdjustData = getAdjustData;
	exports.adjustData = adjustData;
	var ADJUST_DATA = 'ADJUST_DATA';
	
	function getAdjustData(data) {
	  return function (dispatch) {
	    dispatch({
	      type: ADJUST_DATA,
	      data: Object.assign({}, data)
	    });
	  };
	}
	
	function adjustData() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case ADJUST_DATA:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getIncomeType = getIncomeType;
	exports.incomeType = incomeType;
	
	var _dict = __webpack_require__(64);
	
	// 按模块的action, reducer整合体
	var INCOME_TYPE = 'INCOME_TYPE';
	
	function getIncomeType() {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        type = _getState.income_type;
	
	    if (type.length > 0) {
	      return dispatch({
	        type: INCOME_TYPE,
	        data: type
	      });
	    }
	    return (0, _dict.queryDictIncome)().then(function (res) {
	      if (res.statusCode === 200) {
	        return dispatch({
	          type: INCOME_TYPE,
	          data: res.data
	        });
	      }
	    });
	  };
	}
	
	function incomeType() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case INCOME_TYPE:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getindustryList = getindustryList;
	exports.industryList = industryList;
	
	var _protect = __webpack_require__(231);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 按模块的action, reducer整合体
	var INDUSTRY_LIST = 'INDUSTRY_LIST';
	
	function getindustryList() {
	  return function (dispatch) {
	    return (0, _protect.queryIndustryList)().then(function (res) {
	      if (res.statusCode === 200) {
	        _localDb2.default.set(INDUSTRY_LIST, res.data);
	        return dispatch({
	          type: INDUSTRY_LIST,
	          data: res.data
	        });
	      }
	    });
	  };
	}
	
	// Reducer
	function industryList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case INDUSTRY_LIST:
	      return action.data;
	    default:
	      return _localDb2.default.get(INDUSTRY_LIST);
	  }
	}

/***/ },
/* 439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.GET_MENU = undefined;
	exports.getMenu = getMenu;
	exports.menu = menu;
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _function = __webpack_require__(419);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 按模块的action, reducer整合体
	var GET_MENU = exports.GET_MENU = 'GET_MENU';
	
	// Action
	function getMenu() {
	  return function (dispatch) {
	    (0, _function.queryMyFunctionListTree)().then(function (res) {
	      _localDb2.default.set('menu', res.data);
	      dispatch({
	        type: GET_MENU,
	        data: res.data
	      });
	    });
	  };
	}
	
	// Reducer
	function menu() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case GET_MENU:
	      return action.data;
	    default:
	      return _localDb2.default.get('menu');
	  }
	}

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getStaffList = getStaffList;
	exports.staffList = staffList;
	
	var _hr = __webpack_require__(167);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 按模块的action, reducer整合体
	var GET_STAFF_LIST = 'GET_STAFF_LIST';
	
	// Action
	function getStaffList(payload) {
	  var current = payload.current ? payload.current : 1;
	  var start = current;
	  return function (dispatch) {
	    (0, _hr.queryHrList)(Object.assign({}, payload, {
	      start: start
	    })).then(function (res) {
	      if (res.statusCode === 200) {
	        _localDb2.default.set(GET_STAFF_LIST, res.data);
	        return dispatch({
	          type: GET_STAFF_LIST,
	          data: {
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              current: current,
	              pageSize: 15
	            }
	          }
	        });
	      }
	    });
	  };
	}
	
	// Reducer
	function staffList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [{
	    list: [],
	    pagination: {}
	  }];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case GET_STAFF_LIST:
	      return action.data || [];
	    default:
	      return state;
	  }
	}

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setUser = setUser;
	exports.cleanUser = cleanUser;
	exports.user = user;
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _user = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 按模块的action, reducer整合体
	var SET_USER = 'SET_USER';
	var LOGIN_SUCCESS = 'LOGIN_SUCCESS';
	
	// Action
	function setUser() {
	  return function (dispatch) {
	    return (0, _user.queryAccountInfo)().then(function (req) {
	      _localDb2.default.set('user', req.data);
	      return {
	        type: SET_USER,
	        user: req.data
	      };
	    });
	  };
	}
	
	function cleanUser() {
	  return {
	    type: SET_USER,
	    user: {}
	  };
	}
	
	// Reducer
	function user() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case SET_USER:
	      return action.user;
	    case LOGIN_SUCCESS:
	      return action.data;
	    default:
	      return _localDb2.default.get('user');
	  }
	}

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1878), __esModule: true };

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(1827);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	try {
	  var index = __webpack_require__(744);
	} catch (err) {
	  var index = __webpack_require__(744);
	}
	
	/**
	 * Whitespace regexp.
	 */
	
	var re = /\s+/;
	
	/**
	 * toString reference.
	 */
	
	var toString = Object.prototype.toString;
	
	/**
	 * Wrap `el` in a `ClassList`.
	 *
	 * @param {Element} el
	 * @return {ClassList}
	 * @api public
	 */
	
	module.exports = function(el){
	  return new ClassList(el);
	};
	
	/**
	 * Initialize a new ClassList for `el`.
	 *
	 * @param {Element} el
	 * @api private
	 */
	
	function ClassList(el) {
	  if (!el || !el.nodeType) {
	    throw new Error('A DOM element reference is required');
	  }
	  this.el = el;
	  this.list = el.classList;
	}
	
	/**
	 * Add class `name` if not already present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.add = function(name){
	  // classList
	  if (this.list) {
	    this.list.add(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (!~i) arr.push(name);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove class `name` when present, or
	 * pass a regular expression to remove
	 * any which match.
	 *
	 * @param {String|RegExp} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.remove = function(name){
	  if ('[object RegExp]' == toString.call(name)) {
	    return this.removeMatching(name);
	  }
	
	  // classList
	  if (this.list) {
	    this.list.remove(name);
	    return this;
	  }
	
	  // fallback
	  var arr = this.array();
	  var i = index(arr, name);
	  if (~i) arr.splice(i, 1);
	  this.el.className = arr.join(' ');
	  return this;
	};
	
	/**
	 * Remove all classes matching `re`.
	 *
	 * @param {RegExp} re
	 * @return {ClassList}
	 * @api private
	 */
	
	ClassList.prototype.removeMatching = function(re){
	  var arr = this.array();
	  for (var i = 0; i < arr.length; i++) {
	    if (re.test(arr[i])) {
	      this.remove(arr[i]);
	    }
	  }
	  return this;
	};
	
	/**
	 * Toggle class `name`, can force state via `force`.
	 *
	 * For browsers that support classList, but do not support `force` yet,
	 * the mistake will be detected and corrected.
	 *
	 * @param {String} name
	 * @param {Boolean} force
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.toggle = function(name, force){
	  // classList
	  if (this.list) {
	    if ("undefined" !== typeof force) {
	      if (force !== this.list.toggle(name, force)) {
	        this.list.toggle(name); // toggle again to correct
	      }
	    } else {
	      this.list.toggle(name);
	    }
	    return this;
	  }
	
	  // fallback
	  if ("undefined" !== typeof force) {
	    if (!force) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  } else {
	    if (this.has(name)) {
	      this.remove(name);
	    } else {
	      this.add(name);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return an array of classes.
	 *
	 * @return {Array}
	 * @api public
	 */
	
	ClassList.prototype.array = function(){
	  var className = this.el.getAttribute('class') || '';
	  var str = className.replace(/^\s+|\s+$/g, '');
	  var arr = str.split(re);
	  if ('' === arr[0]) arr.shift();
	  return arr;
	};
	
	/**
	 * Check if class `name` is present.
	 *
	 * @param {String} name
	 * @return {ClassList}
	 * @api public
	 */
	
	ClassList.prototype.has =
	ClassList.prototype.contains = function(name){
	  return this.list
	    ? this.list.contains(name)
	    : !! ~index(this.array(), name);
	};


/***/ },
/* 445 */
116,
/* 446 */
[3008, 1891],
/* 447 */
136,
/* 448 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 449 */
[3025, 193, 1906, 448, 453, 746, 1896],
/* 450 */
[3028, 332, 275, 196, 456, 194, 747, 169],
/* 451 */
343,
/* 452 */
[3036, 171, 194, 115],
/* 453 */
[3037, 454, 334],
/* 454 */
[3038, 78, 170, 331],
/* 455 */
120,
/* 456 */
[3044, 195],
/* 457 */
[3045, 170, 78, 331, 458, 171],
/* 458 */
[3046, 115],
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1913);
	var global = __webpack_require__(170);
	var hide = __webpack_require__(237);
	var Iterators = __webpack_require__(238);
	var TO_STRING_TAG = __webpack_require__(115)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var at = __webpack_require__(347)(true);
	
	 // `AdvanceStringIndex` abstract operation
	// https://tc39.github.io/ecma262/#sec-advancestringindex
	module.exports = function (S, index, unicode) {
	  return index + (unicode ? at(S, index).length : 1);
	};


/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	'use strict';
	var toObject = __webpack_require__(75);
	var toAbsoluteIndex = __webpack_require__(205);
	var toLength = __webpack_require__(63);
	module.exports = function fill(value /* , start = 0, end = @length */) {
	  var O = toObject(this);
	  var length = toLength(O.length);
	  var aLen = arguments.length;
	  var index = toAbsoluteIndex(aLen > 1 ? arguments[1] : undefined, length);
	  var end = aLen > 2 ? arguments[2] : undefined;
	  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
	  while (endPos > index) O[index++] = value;
	  return O;
	};


/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	// 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	var speciesConstructor = __webpack_require__(1927);
	
	module.exports = function (original, length) {
	  return new (speciesConstructor(original))(length);
	};


/***/ },
/* 463 */
[3007, 69, 202],
/* 464 */
[3010, 45, 42],
/* 465 */
448,
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	var MATCH = __webpack_require__(58)('match');
	module.exports = function (KEY) {
	  var re = /./;
	  try {
	    '/./'[KEY](re);
	  } catch (e) {
	    try {
	      re[MATCH] = false;
	      return !'/./'[KEY](re);
	    } catch (f) { /* empty */ }
	  } return true;
	};


/***/ },
/* 467 */
[3013, 42],
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(45);
	var setPrototypeOf = __webpack_require__(477).set;
	module.exports = function (that, target, C) {
	  var S = target.constructor;
	  var P;
	  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	    setPrototypeOf(that, P);
	  } return that;
	};


/***/ },
/* 469 */
[3016, 241, 58],
/* 470 */
[3020, 199, 202, 242, 97, 58],
/* 471 */
[3021, 173, 7, 98, 97, 241, 470, 242, 106, 58],
/* 472 */
/***/ function(module, exports) {

	// 20.2.2.14 Math.expm1(x)
	var $expm1 = Math.expm1;
	module.exports = (!$expm1
	  // Old FF bug
	  || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	  // Tor Browser bug
	  || $expm1(-2e-17) != -2e-17
	) ? function expm1(x) {
	  return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	} : $expm1;


/***/ },
/* 473 */
/***/ function(module, exports) {

	// 20.2.2.28 Math.sign(x)
	module.exports = Math.sign || function sign(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	};


/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(42);
	var macrotask = __webpack_require__(482).set;
	var Observer = global.MutationObserver || global.WebKitMutationObserver;
	var process = global.process;
	var Promise = global.Promise;
	var isNode = __webpack_require__(116)(process) == 'process';
	
	module.exports = function () {
	  var head, last, notify;
	
	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };
	
	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise && Promise.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(global, flush);
	    };
	  }
	
	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};


/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 25.4.1.5 NewPromiseCapability(C)
	var aFunction = __webpack_require__(84);
	
	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = aFunction(resolve);
	  this.reject = aFunction(reject);
	}
	
	module.exports.f = function (C) {
	  return new PromiseCapability(C);
	};


/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var regexpFlags = __webpack_require__(276);
	
	var nativeExec = RegExp.prototype.exec;
	// This always refers to the native implementation, because the
	// String#replace polyfill uses ./fix-regexp-well-known-symbol-logic.js,
	// which loads this file before patching the method.
	var nativeReplace = String.prototype.replace;
	
	var patchedExec = nativeExec;
	
	var LAST_INDEX = 'lastIndex';
	
	var UPDATES_LAST_INDEX_WRONG = (function () {
	  var re1 = /a/,
	      re2 = /b*/g;
	  nativeExec.call(re1, 'a');
	  nativeExec.call(re2, 'a');
	  return re1[LAST_INDEX] !== 0 || re2[LAST_INDEX] !== 0;
	})();
	
	// nonparticipating capturing group, copied from es5-shim's String#split patch.
	var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;
	
	var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED;
	
	if (PATCH) {
	  patchedExec = function exec(str) {
	    var re = this;
	    var lastIndex, reCopy, match, i;
	
	    if (NPCG_INCLUDED) {
	      reCopy = new RegExp('^' + re.source + '$(?!\\s)', regexpFlags.call(re));
	    }
	    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re[LAST_INDEX];
	
	    match = nativeExec.call(re, str);
	
	    if (UPDATES_LAST_INDEX_WRONG && match) {
	      re[LAST_INDEX] = re.global ? match.index + match[0].length : lastIndex;
	    }
	    if (NPCG_INCLUDED && match && match.length > 1) {
	      // Fix browsers whose `exec` methods don't consistently return `undefined`
	      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
	      // eslint-disable-next-line no-loop-func
	      nativeReplace.call(match[0], reCopy, function () {
	        for (i = 1; i < arguments.length - 2; i++) {
	          if (arguments[i] === undefined) match[i] = undefined;
	        }
	      });
	    }
	
	    return match;
	  };
	}
	
	module.exports = patchedExec;


/***/ },
/* 477 */
[3035, 45, 31, 118, 105],
/* 478 */
[3037, 279, 206],
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	// helper for String#{startsWith, endsWith, includes}
	var isRegExp = __webpack_require__(340);
	var defined = __webpack_require__(136);
	
	module.exports = function (that, searchString, NAME) {
	  if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	  return String(defined(that));
	};


/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var toInteger = __webpack_require__(120);
	var defined = __webpack_require__(136);
	
	module.exports = function repeat(count) {
	  var str = String(defined(this));
	  var res = '';
	  var n = toInteger(count);
	  if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	  for (;n > 0; (n >>>= 1) && (str += str)) if (n & 1) res += str;
	  return res;
	};


/***/ },
/* 481 */
/***/ function(module, exports) {

	module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	var ctx = __webpack_require__(118);
	var invoke = __webpack_require__(767);
	var html = __webpack_require__(467);
	var cel = __webpack_require__(464);
	var global = __webpack_require__(42);
	var process = global.process;
	var setTask = global.setImmediate;
	var clearTask = global.clearImmediate;
	var MessageChannel = global.MessageChannel;
	var Dispatch = global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (__webpack_require__(116)(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	    defer = function (id) {
	      global.postMessage(id + '', '*');
	    };
	    global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in cel('script')) {
	    defer = function (id) {
	      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	        html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(ctx(run, id, 1), 0);
	    };
	  }
	}
	module.exports = {
	  set: setTask,
	  clear: clearTask
	};


/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(42);
	var DESCRIPTORS = __webpack_require__(65);
	var LIBRARY = __webpack_require__(173);
	var $typed = __webpack_require__(348);
	var hide = __webpack_require__(97);
	var redefineAll = __webpack_require__(203);
	var fails = __webpack_require__(43);
	var anInstance = __webpack_require__(197);
	var toInteger = __webpack_require__(120);
	var toLength = __webpack_require__(63);
	var toIndex = __webpack_require__(786);
	var gOPN = __webpack_require__(200).f;
	var dP = __webpack_require__(69).f;
	var arrayFill = __webpack_require__(461);
	var setToStringTag = __webpack_require__(242);
	var ARRAY_BUFFER = 'ArrayBuffer';
	var DATA_VIEW = 'DataView';
	var PROTOTYPE = 'prototype';
	var WRONG_LENGTH = 'Wrong length!';
	var WRONG_INDEX = 'Wrong index!';
	var $ArrayBuffer = global[ARRAY_BUFFER];
	var $DataView = global[DATA_VIEW];
	var Math = global.Math;
	var RangeError = global.RangeError;
	// eslint-disable-next-line no-shadow-restricted-names
	var Infinity = global.Infinity;
	var BaseBuffer = $ArrayBuffer;
	var abs = Math.abs;
	var pow = Math.pow;
	var floor = Math.floor;
	var log = Math.log;
	var LN2 = Math.LN2;
	var BUFFER = 'buffer';
	var BYTE_LENGTH = 'byteLength';
	var BYTE_OFFSET = 'byteOffset';
	var $BUFFER = DESCRIPTORS ? '_b' : BUFFER;
	var $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH;
	var $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	// IEEE754 conversions based on https://github.com/feross/ieee754
	function packIEEE754(value, mLen, nBytes) {
	  var buffer = new Array(nBytes);
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0;
	  var i = 0;
	  var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
	  var e, m, c;
	  value = abs(value);
	  // eslint-disable-next-line no-self-compare
	  if (value != value || value === Infinity) {
	    // eslint-disable-next-line no-self-compare
	    m = value != value ? 1 : 0;
	    e = eMax;
	  } else {
	    e = floor(log(value) / LN2);
	    if (value * (c = pow(2, -e)) < 1) {
	      e--;
	      c *= 2;
	    }
	    if (e + eBias >= 1) {
	      value += rt / c;
	    } else {
	      value += rt * pow(2, 1 - eBias);
	    }
	    if (value * c >= 2) {
	      e++;
	      c /= 2;
	    }
	    if (e + eBias >= eMax) {
	      m = 0;
	      e = eMax;
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * pow(2, mLen);
	      e = e + eBias;
	    } else {
	      m = value * pow(2, eBias - 1) * pow(2, mLen);
	      e = 0;
	    }
	  }
	  for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8);
	  e = e << mLen | m;
	  eLen += mLen;
	  for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8);
	  buffer[--i] |= s * 128;
	  return buffer;
	}
	function unpackIEEE754(buffer, mLen, nBytes) {
	  var eLen = nBytes * 8 - mLen - 1;
	  var eMax = (1 << eLen) - 1;
	  var eBias = eMax >> 1;
	  var nBits = eLen - 7;
	  var i = nBytes - 1;
	  var s = buffer[i--];
	  var e = s & 127;
	  var m;
	  s >>= 7;
	  for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8);
	  m = e & (1 << -nBits) - 1;
	  e >>= -nBits;
	  nBits += mLen;
	  for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8);
	  if (e === 0) {
	    e = 1 - eBias;
	  } else if (e === eMax) {
	    return m ? NaN : s ? -Infinity : Infinity;
	  } else {
	    m = m + pow(2, mLen);
	    e = e - eBias;
	  } return (s ? -1 : 1) * m * pow(2, e - mLen);
	}
	
	function unpackI32(bytes) {
	  return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	}
	function packI8(it) {
	  return [it & 0xff];
	}
	function packI16(it) {
	  return [it & 0xff, it >> 8 & 0xff];
	}
	function packI32(it) {
	  return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	}
	function packF64(it) {
	  return packIEEE754(it, 52, 8);
	}
	function packF32(it) {
	  return packIEEE754(it, 23, 4);
	}
	
	function addGetter(C, key, internal) {
	  dP(C[PROTOTYPE], key, { get: function () { return this[internal]; } });
	}
	
	function get(view, bytes, index, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = store.slice(start, start + bytes);
	  return isLittleEndian ? pack : pack.reverse();
	}
	function set(view, bytes, index, conversion, value, isLittleEndian) {
	  var numIndex = +index;
	  var intIndex = toIndex(numIndex);
	  if (intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	  var store = view[$BUFFER]._b;
	  var start = intIndex + view[$OFFSET];
	  var pack = conversion(+value);
	  for (var i = 0; i < bytes; i++) store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	}
	
	if (!$typed.ABV) {
	  $ArrayBuffer = function ArrayBuffer(length) {
	    anInstance(this, $ArrayBuffer, ARRAY_BUFFER);
	    var byteLength = toIndex(length);
	    this._b = arrayFill.call(new Array(byteLength), 0);
	    this[$LENGTH] = byteLength;
	  };
	
	  $DataView = function DataView(buffer, byteOffset, byteLength) {
	    anInstance(this, $DataView, DATA_VIEW);
	    anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	    var bufferLength = buffer[$LENGTH];
	    var offset = toInteger(byteOffset);
	    if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	    byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	    if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	    this[$BUFFER] = buffer;
	    this[$OFFSET] = offset;
	    this[$LENGTH] = byteLength;
	  };
	
	  if (DESCRIPTORS) {
	    addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	    addGetter($DataView, BUFFER, '_b');
	    addGetter($DataView, BYTE_LENGTH, '_l');
	    addGetter($DataView, BYTE_OFFSET, '_o');
	  }
	
	  redefineAll($DataView[PROTOTYPE], {
	    getInt8: function getInt8(byteOffset) {
	      return get(this, 1, byteOffset)[0] << 24 >> 24;
	    },
	    getUint8: function getUint8(byteOffset) {
	      return get(this, 1, byteOffset)[0];
	    },
	    getInt16: function getInt16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	    },
	    getUint16: function getUint16(byteOffset /* , littleEndian */) {
	      var bytes = get(this, 2, byteOffset, arguments[1]);
	      return bytes[1] << 8 | bytes[0];
	    },
	    getInt32: function getInt32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1]));
	    },
	    getUint32: function getUint32(byteOffset /* , littleEndian */) {
	      return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	    },
	    getFloat32: function getFloat32(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	    },
	    getFloat64: function getFloat64(byteOffset /* , littleEndian */) {
	      return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	    },
	    setInt8: function setInt8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      set(this, 1, byteOffset, packI8, value);
	    },
	    setInt16: function setInt16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setUint16: function setUint16(byteOffset, value /* , littleEndian */) {
	      set(this, 2, byteOffset, packI16, value, arguments[2]);
	    },
	    setInt32: function setInt32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setUint32: function setUint32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packI32, value, arguments[2]);
	    },
	    setFloat32: function setFloat32(byteOffset, value /* , littleEndian */) {
	      set(this, 4, byteOffset, packF32, value, arguments[2]);
	    },
	    setFloat64: function setFloat64(byteOffset, value /* , littleEndian */) {
	      set(this, 8, byteOffset, packF64, value, arguments[2]);
	    }
	  });
	} else {
	  if (!fails(function () {
	    $ArrayBuffer(1);
	  }) || !fails(function () {
	    new $ArrayBuffer(-1); // eslint-disable-line no-new
	  }) || fails(function () {
	    new $ArrayBuffer(); // eslint-disable-line no-new
	    new $ArrayBuffer(1.5); // eslint-disable-line no-new
	    new $ArrayBuffer(NaN); // eslint-disable-line no-new
	    return $ArrayBuffer.name != ARRAY_BUFFER;
	  })) {
	    $ArrayBuffer = function ArrayBuffer(length) {
	      anInstance(this, $ArrayBuffer);
	      return new BaseBuffer(toIndex(length));
	    };
	    var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	    for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	      if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	    }
	    if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	  }
	  // iOS Safari 7.x bug
	  var view = new $DataView(new $ArrayBuffer(2));
	  var $setInt8 = $DataView[PROTOTYPE].setInt8;
	  view.setInt8(0, 2147483648);
	  view.setInt8(1, 2147483649);
	  if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	    setInt8: function setInt8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    },
	    setUint8: function setUint8(byteOffset, value) {
	      $setInt8.call(this, byteOffset, value << 24 >> 24);
	    }
	  }, true);
	}
	setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	setToStringTag($DataView, DATA_VIEW);
	hide($DataView[PROTOTYPE], $typed.VIEW, true);
	exports[ARRAY_BUFFER] = $ArrayBuffer;
	exports[DATA_VIEW] = $DataView;


/***/ },
/* 484 */
[3045, 42, 117, 173, 787, 69],
/* 485 */
[3048, 240, 58, 241, 117],
/* 486 */
[3050, 172, 770, 241, 107, 471],
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof2 = __webpack_require__(330);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _Event = __webpack_require__(794);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	var _componentClasses = __webpack_require__(444);
	
	var _componentClasses2 = _interopRequireDefault(_componentClasses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : (0, _typeof3['default'])(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	  var nodeClasses = (0, _componentClasses2['default'])(node);
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    nodeClasses.remove(className);
	    nodeClasses.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  nodeClasses.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    nodeClasses.add(activeClassName);
	    if (active) {
	      setTimeout(active, 0);
	    }
	    fixBrowserByTimeout(node);
	    // 30ms for firefox
	  }, 30);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BlockMapBuilder = __webpack_require__(282);
	var CharacterMetadata = __webpack_require__(100);
	var ContentBlock = __webpack_require__(208);
	var ContentBlockNode = __webpack_require__(108);
	var DraftEntity = __webpack_require__(350);
	var DraftFeatureFlags = __webpack_require__(176);
	var Immutable = __webpack_require__(39);
	var SelectionState = __webpack_require__(244);
	
	var generateRandomKey = __webpack_require__(158);
	var sanitizeDraftText = __webpack_require__(494);
	
	var List = Immutable.List,
	    Record = Immutable.Record,
	    Repeat = Immutable.Repeat;
	
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var defaultRecord = {
	  entityMap: null,
	  blockMap: null,
	  selectionBefore: null,
	  selectionAfter: null
	};
	
	var ContentBlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var ContentStateRecord = Record(defaultRecord);
	
	var ContentState = function (_ContentStateRecord) {
	  _inherits(ContentState, _ContentStateRecord);
	
	  function ContentState() {
	    _classCallCheck(this, ContentState);
	
	    return _possibleConstructorReturn(this, _ContentStateRecord.apply(this, arguments));
	  }
	
	  ContentState.prototype.getEntityMap = function getEntityMap() {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity;
	  };
	
	  ContentState.prototype.getBlockMap = function getBlockMap() {
	    return this.get('blockMap');
	  };
	
	  ContentState.prototype.getSelectionBefore = function getSelectionBefore() {
	    return this.get('selectionBefore');
	  };
	
	  ContentState.prototype.getSelectionAfter = function getSelectionAfter() {
	    return this.get('selectionAfter');
	  };
	
	  ContentState.prototype.getBlockForKey = function getBlockForKey(key) {
	    var block = this.getBlockMap().get(key);
	    return block;
	  };
	
	  ContentState.prototype.getKeyBefore = function getKeyBefore(key) {
	    return this.getBlockMap().reverse().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getKeyAfter = function getKeyAfter(key) {
	    return this.getBlockMap().keySeq().skipUntil(function (v) {
	      return v === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockAfter = function getBlockAfter(key) {
	    return this.getBlockMap().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlockBefore = function getBlockBefore(key) {
	    return this.getBlockMap().reverse().skipUntil(function (_, k) {
	      return k === key;
	    }).skip(1).first();
	  };
	
	  ContentState.prototype.getBlocksAsArray = function getBlocksAsArray() {
	    return this.getBlockMap().toArray();
	  };
	
	  ContentState.prototype.getFirstBlock = function getFirstBlock() {
	    return this.getBlockMap().first();
	  };
	
	  ContentState.prototype.getLastBlock = function getLastBlock() {
	    return this.getBlockMap().last();
	  };
	
	  ContentState.prototype.getPlainText = function getPlainText(delimiter) {
	    return this.getBlockMap().map(function (block) {
	      return block ? block.getText() : '';
	    }).join(delimiter || '\n');
	  };
	
	  ContentState.prototype.getLastCreatedEntityKey = function getLastCreatedEntityKey() {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity.__getLastCreatedEntityKey();
	  };
	
	  ContentState.prototype.hasText = function hasText() {
	    var blockMap = this.getBlockMap();
	    return blockMap.size > 1 || blockMap.first().getLength() > 0;
	  };
	
	  ContentState.prototype.createEntity = function createEntity(type, mutability, data) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__create(type, mutability, data);
	    return this;
	  };
	
	  ContentState.prototype.mergeEntityData = function mergeEntityData(key, toMerge) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__mergeData(key, toMerge);
	    return this;
	  };
	
	  ContentState.prototype.replaceEntityData = function replaceEntityData(key, newData) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__replaceData(key, newData);
	    return this;
	  };
	
	  ContentState.prototype.addEntity = function addEntity(instance) {
	    // TODO: update this when we fully remove DraftEntity
	    DraftEntity.__add(instance);
	    return this;
	  };
	
	  ContentState.prototype.getEntity = function getEntity(key) {
	    // TODO: update this when we fully remove DraftEntity
	    return DraftEntity.__get(key);
	  };
	
	  ContentState.createFromBlockArray = function createFromBlockArray(
	  // TODO: update flow type when we completely deprecate the old entity API
	  blocks, entityMap) {
	    // TODO: remove this when we completely deprecate the old entity API
	    var theBlocks = Array.isArray(blocks) ? blocks : blocks.contentBlocks;
	    var blockMap = BlockMapBuilder.createFromArray(theBlocks);
	    var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
	    return new ContentState({
	      blockMap: blockMap,
	      entityMap: entityMap || DraftEntity,
	      selectionBefore: selectionState,
	      selectionAfter: selectionState
	    });
	  };
	
	  ContentState.createFromText = function createFromText(text) {
	    var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : /\r\n?|\n/g;
	
	    var strings = text.split(delimiter);
	    var blocks = strings.map(function (block) {
	      block = sanitizeDraftText(block);
	      return new ContentBlockNodeRecord({
	        key: generateRandomKey(),
	        text: block,
	        type: 'unstyled',
	        characterList: List(Repeat(CharacterMetadata.EMPTY, block.length))
	      });
	    });
	    return ContentState.createFromBlockArray(blocks);
	  };
	
	  return ContentState;
	}(ContentStateRecord);
	
	module.exports = ContentState;

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftBlockRenderMap
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _require = __webpack_require__(39),
	    Map = _require.Map;
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(253);
	
	var UL_WRAP = React.createElement('ul', { className: cx('public/DraftStyleDefault/ul') });
	var OL_WRAP = React.createElement('ol', { className: cx('public/DraftStyleDefault/ol') });
	var PRE_WRAP = React.createElement('pre', { className: cx('public/DraftStyleDefault/pre') });
	
	var DefaultDraftBlockRenderMap = Map({
	  'header-one': {
	    element: 'h1'
	  },
	  'header-two': {
	    element: 'h2'
	  },
	  'header-three': {
	    element: 'h3'
	  },
	  'header-four': {
	    element: 'h4'
	  },
	  'header-five': {
	    element: 'h5'
	  },
	  'header-six': {
	    element: 'h6'
	  },
	  'unordered-list-item': {
	    element: 'li',
	    wrapper: UL_WRAP
	  },
	  'ordered-list-item': {
	    element: 'li',
	    wrapper: OL_WRAP
	  },
	  blockquote: {
	    element: 'blockquote'
	  },
	  atomic: {
	    element: 'figure'
	  },
	  'code-block': {
	    element: 'pre',
	    wrapper: PRE_WRAP
	  },
	  unstyled: {
	    element: 'div',
	    aliasedElements: ['p']
	  }
	});
	
	module.exports = DefaultDraftBlockRenderMap;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule KeyBindingUtil
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(142);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	
	var KeyBindingUtil = {
	  /**
	   * Check whether the ctrlKey modifier is *not* being used in conjunction with
	   * the altKey modifier. If they are combined, the result is an `altGraph`
	   * key modifier, which should not be handled by this set of key bindings.
	   */
	  isCtrlKeyCommand: function isCtrlKeyCommand(e) {
	    return !!e.ctrlKey && !e.altKey;
	  },
	
	  isOptionKeyCommand: function isOptionKeyCommand(e) {
	    return isOSX && e.altKey;
	  },
	
	  hasCommandModifier: function hasCommandModifier(e) {
	    return isOSX ? !!e.metaKey && !e.altKey : KeyBindingUtil.isCtrlKeyCommand(e);
	  }
	};
	
	module.exports = KeyBindingUtil;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule findAncestorOffsetKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getSelectionOffsetKeyForNode = __webpack_require__(809);
	
	/**
	 * Get the key from the node's nearest offset-aware ancestor.
	 */
	function findAncestorOffsetKey(node) {
	  var searchNode = node;
	  while (searchNode && searchNode !== document.documentElement) {
	    var key = getSelectionOffsetKeyForNode(searchNode);
	    if (key != null) {
	      return key;
	    }
	    searchNode = searchNode.parentNode;
	  }
	  return null;
	}
	
	module.exports = findAncestorOffsetKey;

/***/ },
/* 492 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getEntityKeyForSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Return the entity key that should be used when inserting text for the
	 * specified target selection, only if the entity is `MUTABLE`. `IMMUTABLE`
	 * and `SEGMENTED` entities should not be used for insertion behavior.
	 */
	function getEntityKeyForSelection(contentState, targetSelection) {
	  var entityKey;
	
	  if (targetSelection.isCollapsed()) {
	    var key = targetSelection.getAnchorKey();
	    var offset = targetSelection.getAnchorOffset();
	    if (offset > 0) {
	      entityKey = contentState.getBlockForKey(key).getEntityAt(offset - 1);
	      if (entityKey !== contentState.getBlockForKey(key).getEntityAt(offset)) {
	        return null;
	      }
	      return filterKey(contentState.getEntityMap(), entityKey);
	    }
	    return null;
	  }
	
	  var startKey = targetSelection.getStartKey();
	  var startOffset = targetSelection.getStartOffset();
	  var startBlock = contentState.getBlockForKey(startKey);
	
	  entityKey = startOffset === startBlock.getLength() ? null : startBlock.getEntityAt(startOffset);
	
	  return filterKey(contentState.getEntityMap(), entityKey);
	}
	
	/**
	 * Determine whether an entity key corresponds to a `MUTABLE` entity. If so,
	 * return it. If not, return null.
	 */
	function filterKey(entityMap, entityKey) {
	  if (entityKey) {
	    var entity = entityMap.__get(entityKey);
	    return entity.getMutability() === 'MUTABLE' ? entityKey : null;
	  }
	  return null;
	}
	
	module.exports = getEntityKeyForSelection;

/***/ },
/* 493 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionBackward
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` backward within
	 * the selected block. If the selection will go beyond the start of the block,
	 * move focus to the end of the previous block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionBackward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var content = editorState.getCurrentContent();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	
	  var focusKey = key;
	  var focusOffset = 0;
	
	  if (maxDistance > offset) {
	    var keyBefore = content.getKeyBefore(key);
	    if (keyBefore == null) {
	      focusKey = key;
	    } else {
	      focusKey = keyBefore;
	      var blockBefore = content.getBlockForKey(keyBefore);
	      focusOffset = blockBefore.getText().length;
	    }
	  } else {
	    focusOffset = offset - maxDistance;
	  }
	
	  return selection.merge({
	    focusKey: focusKey,
	    focusOffset: focusOffset,
	    isBackward: true
	  });
	}
	
	module.exports = moveSelectionBackward;

/***/ },
/* 494 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule sanitizeDraftText
	 * @format
	 * 
	 */
	
	'use strict';
	
	var REGEX_BLOCK_DELIMITER = new RegExp('\r', 'g');
	
	function sanitizeDraftText(input) {
	  return input.replace(REGEX_BLOCK_DELIMITER, '');
	}
	
	module.exports = sanitizeDraftText;

/***/ },
/* 495 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/coord/View} view
	 * @param {Object} payload
	 * @param {Object} [zoomLimit]
	 */
	function updateCenterAndZoom(view, payload, zoomLimit) {
	  var previousZoom = view.getZoom();
	  var center = view.getCenter();
	  var zoom = payload.zoom;
	  var point = view.dataToPoint(center);
	
	  if (payload.dx != null && payload.dy != null) {
	    point[0] -= payload.dx;
	    point[1] -= payload.dy;
	    var center = view.pointToData(point);
	    view.setCenter(center);
	  }
	
	  if (zoom != null) {
	    if (zoomLimit) {
	      var zoomMin = zoomLimit.min || 0;
	      var zoomMax = zoomLimit.max || Infinity;
	      zoom = Math.max(Math.min(previousZoom * zoom, zoomMax), zoomMin) / previousZoom;
	    } // Zoom on given point(originX, originY)
	
	
	    view.scale[0] *= zoom;
	    view.scale[1] *= zoom;
	    var position = view.position;
	    var fixX = (payload.originX - position[0]) * (zoom - 1);
	    var fixY = (payload.originY - position[1]) * (zoom - 1);
	    position[0] -= fixX;
	    position[1] -= fixY;
	    view.updateTransform(); // Get the new center
	
	    var center = view.pointToData(point);
	    view.setCenter(center);
	    view.setZoom(zoom * previousZoom);
	  }
	
	  return {
	    center: view.getCenter(),
	    zoom: view.getZoom()
	  };
	}
	
	exports.updateCenterAndZoom = updateCenterAndZoom;

/***/ },
/* 496 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getNodeGlobalScale(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys.type !== 'view') {
	    return 1;
	  }
	
	  var nodeScaleRatio = seriesModel.option.nodeScaleRatio;
	  var groupScale = coordSys.scale;
	  var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
	
	  var roamZoom = coordSys.getZoom();
	  var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	  return nodeScale / groupZoom;
	}
	
	function getSymbolSize(node) {
	  var symbolSize = node.getVisual('symbolSize');
	
	  if (symbolSize instanceof Array) {
	    symbolSize = (symbolSize[0] + symbolSize[1]) / 2;
	  }
	
	  return +symbolSize;
	}
	
	exports.getNodeGlobalScale = getNodeGlobalScale;
	exports.getSymbolSize = getSymbolSize;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var vector = __webpack_require__(55);
	
	var symbolUtil = __webpack_require__(110);
	
	var LinePath = __webpack_require__(2248);
	
	var graphic = __webpack_require__(14);
	
	var _number = __webpack_require__(25);
	
	var round = _number.round;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	var SYMBOL_CATEGORIES = ['fromSymbol', 'toSymbol'];
	
	function makeSymbolTypeKey(symbolCategory) {
	  return '_' + symbolCategory + 'Type';
	}
	/**
	 * @inner
	 */
	
	
	function createSymbol(name, lineData, idx) {
	  var symbolType = lineData.getItemVisual(idx, name);
	
	  if (!symbolType || symbolType === 'none') {
	    return;
	  }
	
	  var color = lineData.getItemVisual(idx, 'color');
	  var symbolSize = lineData.getItemVisual(idx, name + 'Size');
	  var symbolRotate = lineData.getItemVisual(idx, name + 'Rotate');
	
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [symbolSize, symbolSize];
	  }
	
	  var symbolPath = symbolUtil.createSymbol(symbolType, -symbolSize[0] / 2, -symbolSize[1] / 2, symbolSize[0], symbolSize[1], color); // rotate by default if symbolRotate is not specified or NaN
	
	  symbolPath.__specifiedRotation = symbolRotate == null || isNaN(symbolRotate) ? void 0 : +symbolRotate * Math.PI / 180 || 0;
	  symbolPath.name = name;
	  return symbolPath;
	}
	
	function createLine(points) {
	  var line = new LinePath({
	    name: 'line',
	    subPixelOptimize: true
	  });
	  setLinePoints(line.shape, points);
	  return line;
	}
	
	function setLinePoints(targetShape, points) {
	  targetShape.x1 = points[0][0];
	  targetShape.y1 = points[0][1];
	  targetShape.x2 = points[1][0];
	  targetShape.y2 = points[1][1];
	  targetShape.percent = 1;
	  var cp1 = points[2];
	
	  if (cp1) {
	    targetShape.cpx1 = cp1[0];
	    targetShape.cpy1 = cp1[1];
	  } else {
	    targetShape.cpx1 = NaN;
	    targetShape.cpy1 = NaN;
	  }
	}
	
	function updateSymbolAndLabelBeforeLineUpdate() {
	  var lineGroup = this;
	  var symbolFrom = lineGroup.childOfName('fromSymbol');
	  var symbolTo = lineGroup.childOfName('toSymbol');
	  var label = lineGroup.childOfName('label'); // Quick reject
	
	  if (!symbolFrom && !symbolTo && label.ignore) {
	    return;
	  }
	
	  var invScale = 1;
	  var parentNode = this.parent;
	
	  while (parentNode) {
	    if (parentNode.scale) {
	      invScale /= parentNode.scale[0];
	    }
	
	    parentNode = parentNode.parent;
	  }
	
	  var line = lineGroup.childOfName('line'); // If line not changed
	  // FIXME Parent scale changed
	
	  if (!this.__dirty && !line.__dirty) {
	    return;
	  }
	
	  var percent = line.shape.percent;
	  var fromPos = line.pointAt(0);
	  var toPos = line.pointAt(percent);
	  var d = vector.sub([], toPos, fromPos);
	  vector.normalize(d, d);
	
	  if (symbolFrom) {
	    symbolFrom.attr('position', fromPos); // Fix #12388
	    // when symbol is set to be 'arrow' in markLine,
	    // symbolRotate value will be ignored, and compulsively use tangent angle.
	    // rotate by default if symbol rotation is not specified
	
	    var specifiedRotation = symbolFrom.__specifiedRotation;
	
	    if (specifiedRotation == null) {
	      var tangent = line.tangentAt(0);
	      symbolFrom.attr('rotation', Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    } else {
	      symbolFrom.attr('rotation', specifiedRotation);
	    }
	
	    symbolFrom.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (symbolTo) {
	    symbolTo.attr('position', toPos); // Fix #12388
	    // when symbol is set to be 'arrow' in markLine,
	    // symbolRotate value will be ignored, and compulsively use tangent angle.
	    // rotate by default if symbol rotation is not specified
	
	    var specifiedRotation = symbolTo.__specifiedRotation;
	
	    if (specifiedRotation == null) {
	      var tangent = line.tangentAt(1);
	      symbolTo.attr('rotation', -Math.PI / 2 - Math.atan2(tangent[1], tangent[0]));
	    } else {
	      symbolTo.attr('rotation', specifiedRotation);
	    }
	
	    symbolTo.attr('scale', [invScale * percent, invScale * percent]);
	  }
	
	  if (!label.ignore) {
	    label.attr('position', toPos);
	    var textPosition;
	    var textAlign;
	    var textVerticalAlign;
	    var textOrigin;
	    var distance = label.__labelDistance;
	    var distanceX = distance[0] * invScale;
	    var distanceY = distance[1] * invScale;
	    var halfPercent = percent / 2;
	    var tangent = line.tangentAt(halfPercent);
	    var n = [tangent[1], -tangent[0]];
	    var cp = line.pointAt(halfPercent);
	
	    if (n[1] > 0) {
	      n[0] = -n[0];
	      n[1] = -n[1];
	    }
	
	    var dir = tangent[0] < 0 ? -1 : 1;
	
	    if (label.__position !== 'start' && label.__position !== 'end') {
	      var rotation = -Math.atan2(tangent[1], tangent[0]);
	
	      if (toPos[0] < fromPos[0]) {
	        rotation = Math.PI + rotation;
	      }
	
	      label.attr('rotation', rotation);
	    }
	
	    var dy;
	
	    switch (label.__position) {
	      case 'insideStartTop':
	      case 'insideMiddleTop':
	      case 'insideEndTop':
	      case 'middle':
	        dy = -distanceY;
	        textVerticalAlign = 'bottom';
	        break;
	
	      case 'insideStartBottom':
	      case 'insideMiddleBottom':
	      case 'insideEndBottom':
	        dy = distanceY;
	        textVerticalAlign = 'top';
	        break;
	
	      default:
	        dy = 0;
	        textVerticalAlign = 'middle';
	    }
	
	    switch (label.__position) {
	      case 'end':
	        textPosition = [d[0] * distanceX + toPos[0], d[1] * distanceY + toPos[1]];
	        textAlign = d[0] > 0.8 ? 'left' : d[0] < -0.8 ? 'right' : 'center';
	        textVerticalAlign = d[1] > 0.8 ? 'top' : d[1] < -0.8 ? 'bottom' : 'middle';
	        break;
	
	      case 'start':
	        textPosition = [-d[0] * distanceX + fromPos[0], -d[1] * distanceY + fromPos[1]];
	        textAlign = d[0] > 0.8 ? 'right' : d[0] < -0.8 ? 'left' : 'center';
	        textVerticalAlign = d[1] > 0.8 ? 'bottom' : d[1] < -0.8 ? 'top' : 'middle';
	        break;
	
	      case 'insideStartTop':
	      case 'insideStart':
	      case 'insideStartBottom':
	        textPosition = [distanceX * dir + fromPos[0], fromPos[1] + dy];
	        textAlign = tangent[0] < 0 ? 'right' : 'left';
	        textOrigin = [-distanceX * dir, -dy];
	        break;
	
	      case 'insideMiddleTop':
	      case 'insideMiddle':
	      case 'insideMiddleBottom':
	      case 'middle':
	        textPosition = [cp[0], cp[1] + dy];
	        textAlign = 'center';
	        textOrigin = [0, -dy];
	        break;
	
	      case 'insideEndTop':
	      case 'insideEnd':
	      case 'insideEndBottom':
	        textPosition = [-distanceX * dir + toPos[0], toPos[1] + dy];
	        textAlign = tangent[0] >= 0 ? 'right' : 'left';
	        textOrigin = [distanceX * dir, -dy];
	        break;
	    }
	
	    label.attr({
	      style: {
	        // Use the user specified text align and baseline first
	        textVerticalAlign: label.__verticalAlign || textVerticalAlign,
	        textAlign: label.__textAlign || textAlign
	      },
	      position: textPosition,
	      scale: [invScale, invScale],
	      origin: textOrigin
	    });
	  }
	}
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	
	
	function Line(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createLine(lineData, idx, seriesScope);
	}
	
	var lineProto = Line.prototype; // Update symbol position and rotation
	
	lineProto.beforeUpdate = updateSymbolAndLabelBeforeLineUpdate;
	
	lineProto._createLine = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var linePoints = lineData.getItemLayout(idx);
	  var line = createLine(linePoints);
	  line.shape.percent = 0;
	  graphic.initProps(line, {
	    shape: {
	      percent: 1
	    }
	  }, seriesModel, idx);
	  this.add(line);
	  var label = new graphic.Text({
	    name: 'label',
	    // FIXME
	    // Temporary solution for `focusNodeAdjacency`.
	    // line label do not use the opacity of lineStyle.
	    lineLabelOriginalOpacity: 1
	  });
	  this.add(label);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = createSymbol(symbolCategory, lineData, idx); // symbols must added after line to make sure
	    // it will be updated after line#update.
	    // Or symbol position and rotation update in line#beforeUpdate will be one frame slow
	
	    this.add(symbol);
	    this[makeSymbolTypeKey(symbolCategory)] = lineData.getItemVisual(idx, symbolCategory);
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var linePoints = lineData.getItemLayout(idx);
	  var target = {
	    shape: {}
	  };
	  setLinePoints(target.shape, linePoints);
	  graphic.updateProps(line, target, seriesModel, idx);
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbolType = lineData.getItemVisual(idx, symbolCategory);
	    var key = makeSymbolTypeKey(symbolCategory); // Symbol changed
	
	    if (this[key] !== symbolType) {
	      this.remove(this.childOfName(symbolCategory));
	      var symbol = createSymbol(symbolCategory, lineData, idx);
	      this.add(symbol);
	    }
	
	    this[key] = symbolType;
	  }, this);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	lineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childOfName('line');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	  var labelModel = seriesScope && seriesScope.labelModel;
	  var hoverLabelModel = seriesScope && seriesScope.hoverLabelModel; // Optimization for large dataset
	
	  if (!seriesScope || lineData.hasItemOption) {
	    var itemModel = lineData.getItemModel(idx);
	    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	    labelModel = itemModel.getModel('label');
	    hoverLabelModel = itemModel.getModel('emphasis.label');
	  }
	
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var visualOpacity = zrUtil.retrieve3(lineData.getItemVisual(idx, 'opacity'), lineStyle.opacity, 1);
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor,
	    opacity: visualOpacity
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle; // Update symbol
	
	  zrUtil.each(SYMBOL_CATEGORIES, function (symbolCategory) {
	    var symbol = this.childOfName(symbolCategory);
	
	    if (symbol) {
	      symbol.setColor(visualColor);
	      symbol.setStyle({
	        opacity: visualOpacity
	      });
	    }
	  }, this);
	  var showLabel = labelModel.getShallow('show');
	  var hoverShowLabel = hoverLabelModel.getShallow('show');
	  var label = this.childOfName('label');
	  var defaultLabelColor;
	  var baseText; // FIXME: the logic below probably should be merged to `graphic.setLabelStyle`.
	
	  if (showLabel || hoverShowLabel) {
	    defaultLabelColor = visualColor || '#000';
	    baseText = seriesModel.getFormattedLabel(idx, 'normal', lineData.dataType);
	
	    if (baseText == null) {
	      var rawVal = seriesModel.getRawValue(idx);
	      baseText = rawVal == null ? lineData.getName(idx) : isFinite(rawVal) ? round(rawVal) : rawVal;
	    }
	  }
	
	  var normalText = showLabel ? baseText : null;
	  var emphasisText = hoverShowLabel ? zrUtil.retrieve2(seriesModel.getFormattedLabel(idx, 'emphasis', lineData.dataType), baseText) : null;
	  var labelStyle = label.style; // Always set `textStyle` even if `normalStyle.text` is null, because default
	  // values have to be set on `normalStyle`.
	
	  if (normalText != null || emphasisText != null) {
	    graphic.setTextStyle(label.style, labelModel, {
	      text: normalText
	    }, {
	      autoColor: defaultLabelColor
	    });
	    label.__textAlign = labelStyle.textAlign;
	    label.__verticalAlign = labelStyle.textVerticalAlign; // 'start', 'middle', 'end'
	
	    label.__position = labelModel.get('position') || 'middle';
	    var distance = labelModel.get('distance');
	
	    if (!zrUtil.isArray(distance)) {
	      distance = [distance, distance];
	    }
	
	    label.__labelDistance = distance;
	  }
	
	  if (emphasisText != null) {
	    // Only these properties supported in this emphasis style here.
	    label.hoverStyle = {
	      text: emphasisText,
	      textFill: hoverLabelModel.getTextColor(true),
	      // For merging hover style to normal style, do not use
	      // `hoverLabelModel.getFont()` here.
	      fontStyle: hoverLabelModel.getShallow('fontStyle'),
	      fontWeight: hoverLabelModel.getShallow('fontWeight'),
	      fontSize: hoverLabelModel.getShallow('fontSize'),
	      fontFamily: hoverLabelModel.getShallow('fontFamily')
	    };
	  } else {
	    label.hoverStyle = {
	      text: null
	    };
	  }
	
	  label.ignore = !showLabel && !hoverShowLabel;
	  graphic.setHoverStyle(this);
	};
	
	lineProto.highlight = function () {
	  this.trigger('emphasis');
	};
	
	lineProto.downplay = function () {
	  this.trigger('normal');
	};
	
	lineProto.updateLayout = function (lineData, idx) {
	  this.setLinePoints(lineData.getItemLayout(idx));
	};
	
	lineProto.setLinePoints = function (points) {
	  var linePath = this.childOfName('line');
	  setLinePoints(linePath.shape, points);
	  linePath.dirty();
	};
	
	zrUtil.inherits(Line, graphic.Group);
	var _default = Line;
	module.exports = _default;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var LineGroup = __webpack_require__(497);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/LineDraw
	 */
	// import IncrementalDisplayable from 'zrender/src/graphic/IncrementalDisplayable';
	
	/**
	 * @alias module:echarts/component/marker/LineDraw
	 * @constructor
	 */
	function LineDraw(ctor) {
	  this._ctor = ctor || LineGroup;
	  this.group = new graphic.Group();
	}
	
	var lineDrawProto = LineDraw.prototype;
	
	lineDrawProto.isPersistent = function () {
	  return true;
	};
	/**
	 * @param {module:echarts/data/List} lineData
	 */
	
	
	lineDrawProto.updateData = function (lineData) {
	  var lineDraw = this;
	  var group = lineDraw.group;
	  var oldLineData = lineDraw._lineData;
	  lineDraw._lineData = lineData; // There is no oldLineData only when first rendering or switching from
	  // stream mode to normal mode, where previous elements should be removed.
	
	  if (!oldLineData) {
	    group.removeAll();
	  }
	
	  var seriesScope = makeSeriesScope(lineData);
	  lineData.diff(oldLineData).add(function (idx) {
	    doAdd(lineDraw, lineData, idx, seriesScope);
	  }).update(function (newIdx, oldIdx) {
	    doUpdate(lineDraw, oldLineData, lineData, oldIdx, newIdx, seriesScope);
	  }).remove(function (idx) {
	    group.remove(oldLineData.getItemGraphicEl(idx));
	  }).execute();
	};
	
	function doAdd(lineDraw, lineData, idx, seriesScope) {
	  var itemLayout = lineData.getItemLayout(idx);
	
	  if (!lineNeedsDraw(itemLayout)) {
	    return;
	  }
	
	  var el = new lineDraw._ctor(lineData, idx, seriesScope);
	  lineData.setItemGraphicEl(idx, el);
	  lineDraw.group.add(el);
	}
	
	function doUpdate(lineDraw, oldLineData, newLineData, oldIdx, newIdx, seriesScope) {
	  var itemEl = oldLineData.getItemGraphicEl(oldIdx);
	
	  if (!lineNeedsDraw(newLineData.getItemLayout(newIdx))) {
	    lineDraw.group.remove(itemEl);
	    return;
	  }
	
	  if (!itemEl) {
	    itemEl = new lineDraw._ctor(newLineData, newIdx, seriesScope);
	  } else {
	    itemEl.updateData(newLineData, newIdx, seriesScope);
	  }
	
	  newLineData.setItemGraphicEl(newIdx, itemEl);
	  lineDraw.group.add(itemEl);
	}
	
	lineDrawProto.updateLayout = function () {
	  var lineData = this._lineData; // Do not support update layout in incremental mode.
	
	  if (!lineData) {
	    return;
	  }
	
	  lineData.eachItemGraphicEl(function (el, idx) {
	    el.updateLayout(lineData, idx);
	  }, this);
	};
	
	lineDrawProto.incrementalPrepareUpdate = function (lineData) {
	  this._seriesScope = makeSeriesScope(lineData);
	  this._lineData = null;
	  this.group.removeAll();
	};
	
	function isEffectObject(el) {
	  return el.animators && el.animators.length > 0;
	}
	
	lineDrawProto.incrementalUpdate = function (taskParams, lineData) {
	  function updateIncrementalAndHover(el) {
	    if (!el.isGroup && !isEffectObject(el)) {
	      el.incremental = el.useHoverLayer = true;
	    }
	  }
	
	  for (var idx = taskParams.start; idx < taskParams.end; idx++) {
	    var itemLayout = lineData.getItemLayout(idx);
	
	    if (lineNeedsDraw(itemLayout)) {
	      var el = new this._ctor(lineData, idx, this._seriesScope);
	      el.traverse(updateIncrementalAndHover);
	      this.group.add(el);
	      lineData.setItemGraphicEl(idx, el);
	    }
	  }
	};
	
	function makeSeriesScope(lineData) {
	  var hostModel = lineData.hostModel;
	  return {
	    lineStyle: hostModel.getModel('lineStyle').getLineStyle(),
	    hoverLineStyle: hostModel.getModel('emphasis.lineStyle').getLineStyle(),
	    labelModel: hostModel.getModel('label'),
	    hoverLabelModel: hostModel.getModel('emphasis.label')
	  };
	}
	
	lineDrawProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	lineDrawProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	function isPointNaN(pt) {
	  return isNaN(pt[0]) || isNaN(pt[1]);
	}
	
	function lineNeedsDraw(pts) {
	  return !isPointNaN(pts[0]) && !isPointNaN(pts[1]);
	}
	
	var _default = LineDraw;
	module.exports = _default;

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataProvider = __webpack_require__(212);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/data/List} data
	 * @param {number} dataIndex
	 * @return {string} label string. Not null/undefined
	 */
	function getDefaultLabel(data, dataIndex) {
	  var labelDims = data.mapDimension('defaultedLabel', true);
	  var len = labelDims.length; // Simple optimization (in lots of cases, label dims length is 1)
	
	  if (len === 1) {
	    return retrieveRawValue(data, dataIndex, labelDims[0]);
	  } else if (len) {
	    var vals = [];
	
	    for (var i = 0; i < labelDims.length; i++) {
	      var val = retrieveRawValue(data, dataIndex, labelDims[i]);
	      vals.push(val);
	    }
	
	    return vals.join(' ');
	  }
	}
	
	exports.getDefaultLabel = getDefaultLabel;

/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var clazzUtil = __webpack_require__(161);
	
	var graphic = __webpack_require__(14);
	
	var axisPointerModelHelper = __webpack_require__(354);
	
	var eventTool = __webpack_require__(147);
	
	var throttleUtil = __webpack_require__(181);
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var clone = zrUtil.clone;
	var bind = zrUtil.bind;
	/**
	 * Base axis pointer class in 2D.
	 * Implemenents {module:echarts/component/axis/IAxisPointer}.
	 */
	
	function BaseAxisPointer() {}
	
	BaseAxisPointer.prototype = {
	  /**
	   * @private
	   */
	  _group: null,
	
	  /**
	   * @private
	   */
	  _lastGraphicKey: null,
	
	  /**
	   * @private
	   */
	  _handle: null,
	
	  /**
	   * @private
	   */
	  _dragging: false,
	
	  /**
	   * @private
	   */
	  _lastValue: null,
	
	  /**
	   * @private
	   */
	  _lastStatus: null,
	
	  /**
	   * @private
	   */
	  _payloadInfo: null,
	
	  /**
	   * In px, arbitrary value. Do not set too small,
	   * no animation is ok for most cases.
	   * @protected
	   */
	  animationThreshold: 15,
	
	  /**
	   * @implement
	   */
	  render: function (axisModel, axisPointerModel, api, forceRender) {
	    var value = axisPointerModel.get('value');
	    var status = axisPointerModel.get('status'); // Bind them to `this`, not in closure, otherwise they will not
	    // be replaced when user calling setOption in not merge mode.
	
	    this._axisModel = axisModel;
	    this._axisPointerModel = axisPointerModel;
	    this._api = api; // Optimize: `render` will be called repeatly during mouse move.
	    // So it is power consuming if performing `render` each time,
	    // especially on mobile device.
	
	    if (!forceRender && this._lastValue === value && this._lastStatus === status) {
	      return;
	    }
	
	    this._lastValue = value;
	    this._lastStatus = status;
	    var group = this._group;
	    var handle = this._handle;
	
	    if (!status || status === 'hide') {
	      // Do not clear here, for animation better.
	      group && group.hide();
	      handle && handle.hide();
	      return;
	    }
	
	    group && group.show();
	    handle && handle.show(); // Otherwise status is 'show'
	
	    var elOption = {};
	    this.makeElOption(elOption, value, axisModel, axisPointerModel, api); // Enable change axis pointer type.
	
	    var graphicKey = elOption.graphicKey;
	
	    if (graphicKey !== this._lastGraphicKey) {
	      this.clear(api);
	    }
	
	    this._lastGraphicKey = graphicKey;
	    var moveAnimation = this._moveAnimation = this.determineAnimation(axisModel, axisPointerModel);
	
	    if (!group) {
	      group = this._group = new graphic.Group();
	      this.createPointerEl(group, elOption, axisModel, axisPointerModel);
	      this.createLabelEl(group, elOption, axisModel, axisPointerModel);
	      api.getZr().add(group);
	    } else {
	      var doUpdateProps = zrUtil.curry(updateProps, axisPointerModel, moveAnimation);
	      this.updatePointerEl(group, elOption, doUpdateProps, axisPointerModel);
	      this.updateLabelEl(group, elOption, doUpdateProps, axisPointerModel);
	    }
	
	    updateMandatoryProps(group, axisPointerModel, true);
	
	    this._renderHandle(value);
	  },
	
	  /**
	   * @implement
	   */
	  remove: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @implement
	   */
	  dispose: function (api) {
	    this.clear(api);
	  },
	
	  /**
	   * @protected
	   */
	  determineAnimation: function (axisModel, axisPointerModel) {
	    var animation = axisPointerModel.get('animation');
	    var axis = axisModel.axis;
	    var isCategoryAxis = axis.type === 'category';
	    var useSnap = axisPointerModel.get('snap'); // Value axis without snap always do not snap.
	
	    if (!useSnap && !isCategoryAxis) {
	      return false;
	    }
	
	    if (animation === 'auto' || animation == null) {
	      var animationThreshold = this.animationThreshold;
	
	      if (isCategoryAxis && axis.getBandWidth() > animationThreshold) {
	        return true;
	      } // It is important to auto animation when snap used. Consider if there is
	      // a dataZoom, animation will be disabled when too many points exist, while
	      // it will be enabled for better visual effect when little points exist.
	
	
	      if (useSnap) {
	        var seriesDataCount = axisPointerModelHelper.getAxisInfo(axisModel).seriesDataCount;
	        var axisExtent = axis.getExtent(); // Approximate band width
	
	        return Math.abs(axisExtent[0] - axisExtent[1]) / seriesDataCount > animationThreshold;
	      }
	
	      return false;
	    }
	
	    return animation === true;
	  },
	
	  /**
	   * add {pointer, label, graphicKey} to elOption
	   * @protected
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {// Shoule be implemenented by sub-class.
	  },
	
	  /**
	   * @protected
	   */
	  createPointerEl: function (group, elOption, axisModel, axisPointerModel) {
	    var pointerOption = elOption.pointer;
	
	    if (pointerOption) {
	      var pointerEl = inner(group).pointerEl = new graphic[pointerOption.type](clone(elOption.pointer));
	      group.add(pointerEl);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  createLabelEl: function (group, elOption, axisModel, axisPointerModel) {
	    if (elOption.label) {
	      var labelEl = inner(group).labelEl = new graphic.Rect(clone(elOption.label));
	      group.add(labelEl);
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updatePointerEl: function (group, elOption, updateProps) {
	    var pointerEl = inner(group).pointerEl;
	
	    if (pointerEl && elOption.pointer) {
	      pointerEl.setStyle(elOption.pointer.style);
	      updateProps(pointerEl, {
	        shape: elOption.pointer.shape
	      });
	    }
	  },
	
	  /**
	   * @protected
	   */
	  updateLabelEl: function (group, elOption, updateProps, axisPointerModel) {
	    var labelEl = inner(group).labelEl;
	
	    if (labelEl) {
	      labelEl.setStyle(elOption.label.style);
	      updateProps(labelEl, {
	        // Consider text length change in vertical axis, animation should
	        // be used on shape, otherwise the effect will be weird.
	        shape: elOption.label.shape,
	        position: elOption.label.position
	      });
	      updateLabelShowHide(labelEl, axisPointerModel);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderHandle: function (value) {
	    if (this._dragging || !this.updateHandleTransform) {
	      return;
	    }
	
	    var axisPointerModel = this._axisPointerModel;
	
	    var zr = this._api.getZr();
	
	    var handle = this._handle;
	    var handleModel = axisPointerModel.getModel('handle');
	    var status = axisPointerModel.get('status');
	
	    if (!handleModel.get('show') || !status || status === 'hide') {
	      handle && zr.remove(handle);
	      this._handle = null;
	      return;
	    }
	
	    var isInit;
	
	    if (!this._handle) {
	      isInit = true;
	      handle = this._handle = graphic.createIcon(handleModel.get('icon'), {
	        cursor: 'move',
	        draggable: true,
	        onmousemove: function (e) {
	          // Fot mobile devicem, prevent screen slider on the button.
	          eventTool.stop(e.event);
	        },
	        onmousedown: bind(this._onHandleDragMove, this, 0, 0),
	        drift: bind(this._onHandleDragMove, this),
	        ondragend: bind(this._onHandleDragEnd, this)
	      });
	      zr.add(handle);
	    }
	
	    updateMandatoryProps(handle, axisPointerModel, false); // update style
	
	    var includeStyles = ['color', 'borderColor', 'borderWidth', 'opacity', 'shadowColor', 'shadowBlur', 'shadowOffsetX', 'shadowOffsetY'];
	    handle.setStyle(handleModel.getItemStyle(null, includeStyles)); // update position
	
	    var handleSize = handleModel.get('size');
	
	    if (!zrUtil.isArray(handleSize)) {
	      handleSize = [handleSize, handleSize];
	    }
	
	    handle.attr('scale', [handleSize[0] / 2, handleSize[1] / 2]);
	    throttleUtil.createOrUpdate(this, '_doDispatchAxisPointer', handleModel.get('throttle') || 0, 'fixRate');
	
	    this._moveHandleToValue(value, isInit);
	  },
	
	  /**
	   * @private
	   */
	  _moveHandleToValue: function (value, isInit) {
	    updateProps(this._axisPointerModel, !isInit && this._moveAnimation, this._handle, getHandleTransProps(this.getHandleTransform(value, this._axisModel, this._axisPointerModel)));
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragMove: function (dx, dy) {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    this._dragging = true; // Persistent for throttle.
	
	    var trans = this.updateHandleTransform(getHandleTransProps(handle), [dx, dy], this._axisModel, this._axisPointerModel);
	    this._payloadInfo = trans;
	    handle.stopAnimation();
	    handle.attr(getHandleTransProps(trans));
	    inner(handle).lastProp = null;
	
	    this._doDispatchAxisPointer();
	  },
	
	  /**
	   * Throttled method.
	   * @private
	   */
	  _doDispatchAxisPointer: function () {
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var payloadInfo = this._payloadInfo;
	    var axisModel = this._axisModel;
	
	    this._api.dispatchAction({
	      type: 'updateAxisPointer',
	      x: payloadInfo.cursorPoint[0],
	      y: payloadInfo.cursorPoint[1],
	      tooltipOption: payloadInfo.tooltipOption,
	      axesInfo: [{
	        axisDim: axisModel.axis.dim,
	        axisIndex: axisModel.componentIndex
	      }]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _onHandleDragEnd: function (moveAnimation) {
	    this._dragging = false;
	    var handle = this._handle;
	
	    if (!handle) {
	      return;
	    }
	
	    var value = this._axisPointerModel.get('value'); // Consider snap or categroy axis, handle may be not consistent with
	    // axisPointer. So move handle to align the exact value position when
	    // drag ended.
	
	
	    this._moveHandleToValue(value); // For the effect: tooltip will be shown when finger holding on handle
	    // button, and will be hidden after finger left handle button.
	
	
	    this._api.dispatchAction({
	      type: 'hideTip'
	    });
	  },
	
	  /**
	   * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {number} value
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0}
	   */
	  getHandleTransform: null,
	
	  /**
	   * * Should be implemenented by sub-class if support `handle`.
	   * @protected
	   * @param {Object} transform {position, rotation}
	   * @param {Array.<number>} delta [dx, dy]
	   * @param {module:echarts/model/Model} axisModel
	   * @param {module:echarts/model/Model} axisPointerModel
	   * @return {Object} {position: [x, y], rotation: 0, cursorPoint: [x, y]}
	   */
	  updateHandleTransform: null,
	
	  /**
	   * @private
	   */
	  clear: function (api) {
	    this._lastValue = null;
	    this._lastStatus = null;
	    var zr = api.getZr();
	    var group = this._group;
	    var handle = this._handle;
	
	    if (zr && group) {
	      this._lastGraphicKey = null;
	      group && zr.remove(group);
	      handle && zr.remove(handle);
	      this._group = null;
	      this._handle = null;
	      this._payloadInfo = null;
	    }
	  },
	
	  /**
	   * @protected
	   */
	  doClear: function () {// Implemented by sub-class if necessary.
	  },
	
	  /**
	   * @protected
	   * @param {Array.<number>} xy
	   * @param {Array.<number>} wh
	   * @param {number} [xDimIndex=0] or 1
	   */
	  buildLabel: function (xy, wh, xDimIndex) {
	    xDimIndex = xDimIndex || 0;
	    return {
	      x: xy[xDimIndex],
	      y: xy[1 - xDimIndex],
	      width: wh[xDimIndex],
	      height: wh[1 - xDimIndex]
	    };
	  }
	};
	BaseAxisPointer.prototype.constructor = BaseAxisPointer;
	
	function updateProps(animationModel, moveAnimation, el, props) {
	  // Animation optimize.
	  if (!propsEqual(inner(el).lastProp, props)) {
	    inner(el).lastProp = props;
	    moveAnimation ? graphic.updateProps(el, props, animationModel) : (el.stopAnimation(), el.attr(props));
	  }
	}
	
	function propsEqual(lastProps, newProps) {
	  if (zrUtil.isObject(lastProps) && zrUtil.isObject(newProps)) {
	    var equals = true;
	    zrUtil.each(newProps, function (item, key) {
	      equals = equals && propsEqual(lastProps[key], item);
	    });
	    return !!equals;
	  } else {
	    return lastProps === newProps;
	  }
	}
	
	function updateLabelShowHide(labelEl, axisPointerModel) {
	  labelEl[axisPointerModel.get('label.show') ? 'show' : 'hide']();
	}
	
	function getHandleTransProps(trans) {
	  return {
	    position: trans.position.slice(),
	    rotation: trans.rotation || 0
	  };
	}
	
	function updateMandatoryProps(group, axisPointerModel, silent) {
	  var z = axisPointerModel.get('z');
	  var zlevel = axisPointerModel.get('zlevel');
	  group && group.traverse(function (el) {
	    if (el.type !== 'group') {
	      z != null && (el.z = z);
	      zlevel != null && (el.zlevel = zlevel);
	      el.silent = silent;
	    }
	  });
	}
	
	clazzUtil.enableClassExtend(BaseAxisPointer);
	var _default = BaseAxisPointer;
	module.exports = _default;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var helper = __webpack_require__(503);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction('dataZoom', function (payload, ecModel) {
	  var linkedNodesFinder = helper.createLinkedNodesFinder(zrUtil.bind(ecModel.eachComponent, ecModel, 'dataZoom'), helper.eachAxisDim, function (model, dimNames) {
	    return model.get(dimNames.axisIndex);
	  });
	  var effectedModels = [];
	  ecModel.eachComponent({
	    mainType: 'dataZoom',
	    query: payload
	  }, function (model, index) {
	    effectedModels.push.apply(effectedModels, linkedNodesFinder(model).nodes);
	  });
	  zrUtil.each(effectedModels, function (dataZoomModel, index) {
	    dataZoomModel.setRawRange({
	      start: payload.start,
	      end: payload.end,
	      startValue: payload.startValue,
	      endValue: payload.endValue
	    });
	  });
	});

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var _util = __webpack_require__(4);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerProcessor({
	  // `dataZoomProcessor` will only be performed in needed series. Consider if
	  // there is a line series and a pie series, it is better not to update the
	  // line series if only pie series is needed to be updated.
	  getTargetSeries: function (ecModel) {
	    var seriesModelMap = createHashMap();
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        var axisProxy = dataZoomModel.getAxisProxy(dimNames.name, axisIndex);
	        each(axisProxy.getTargetSeriesModels(), function (seriesModel) {
	          seriesModelMap.set(seriesModel.uid, seriesModel);
	        });
	      });
	    });
	    return seriesModelMap;
	  },
	  modifyOutputEnd: true,
	  // Consider appendData, where filter should be performed. Because data process is
	  // in block mode currently, it is not need to worry about that the overallProgress
	  // execute every frame.
	  overallReset: function (ecModel, api) {
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      // We calculate window and reset axis here but not in model
	      // init stage and not after action dispatch handler, because
	      // reset should be called after seriesData.restoreData.
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).reset(dataZoomModel, api);
	      }); // Caution: data zoom filtering is order sensitive when using
	      // percent range and no min/max/scale set on axis.
	      // For example, we have dataZoom definition:
	      // [
	      //      {xAxisIndex: 0, start: 30, end: 70},
	      //      {yAxisIndex: 0, start: 20, end: 80}
	      // ]
	      // In this case, [20, 80] of y-dataZoom should be based on data
	      // that have filtered by x-dataZoom using range of [30, 70],
	      // but should not be based on full raw data. Thus sliding
	      // x-dataZoom will change both ranges of xAxis and yAxis,
	      // while sliding y-dataZoom will only change the range of yAxis.
	      // So we should filter x-axis after reset x-axis immediately,
	      // and then reset y-axis and filter y-axis.
	
	      dataZoomModel.eachTargetAxis(function (dimNames, axisIndex, dataZoomModel) {
	        dataZoomModel.getAxisProxy(dimNames.name, axisIndex).filterData(dataZoomModel, api);
	      });
	    });
	    ecModel.eachComponent('dataZoom', function (dataZoomModel) {
	      // Fullfill all of the range props so that user
	      // is able to get them from chart.getOption().
	      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	      var percentRange = axisProxy.getDataPercentWindow();
	      var valueRange = axisProxy.getDataValueWindow();
	      dataZoomModel.setCalculatedRange({
	        start: percentRange[0],
	        end: percentRange[1],
	        startValue: valueRange[0],
	        endValue: valueRange[1]
	      });
	    });
	  }
	});

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var formatUtil = __webpack_require__(48);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AXIS_DIMS = ['x', 'y', 'z', 'radius', 'angle', 'single']; // Supported coords.
	
	var COORDS = ['cartesian2d', 'polar', 'singleAxis'];
	/**
	 * @param {string} coordType
	 * @return {boolean}
	 */
	
	function isCoordSupported(coordType) {
	  return zrUtil.indexOf(COORDS, coordType) >= 0;
	}
	/**
	 * Create "each" method to iterate names.
	 *
	 * @pubilc
	 * @param  {Array.<string>} names
	 * @param  {Array.<string>=} attrs
	 * @return {Function}
	 */
	
	
	function createNameEach(names, attrs) {
	  names = names.slice();
	  var capitalNames = zrUtil.map(names, formatUtil.capitalFirst);
	  attrs = (attrs || []).slice();
	  var capitalAttrs = zrUtil.map(attrs, formatUtil.capitalFirst);
	  return function (callback, context) {
	    zrUtil.each(names, function (name, index) {
	      var nameObj = {
	        name: name,
	        capital: capitalNames[index]
	      };
	
	      for (var j = 0; j < attrs.length; j++) {
	        nameObj[attrs[j]] = name + capitalAttrs[j];
	      }
	
	      callback.call(context, nameObj);
	    });
	  };
	}
	/**
	 * Iterate each dimension name.
	 *
	 * @public
	 * @param {Function} callback The parameter is like:
	 *                            {
	 *                                name: 'angle',
	 *                                capital: 'Angle',
	 *                                axis: 'angleAxis',
	 *                                axisIndex: 'angleAixs',
	 *                                index: 'angleIndex'
	 *                            }
	 * @param {Object} context
	 */
	
	
	var eachAxisDim = createNameEach(AXIS_DIMS, ['axisIndex', 'axis', 'index', 'id']);
	/**
	 * If tow dataZoomModels has the same axis controlled, we say that they are 'linked'.
	 * dataZoomModels and 'links' make up one or more graphics.
	 * This function finds the graphic where the source dataZoomModel is in.
	 *
	 * @public
	 * @param {Function} forEachNode Node iterator.
	 * @param {Function} forEachEdgeType edgeType iterator
	 * @param {Function} edgeIdGetter Giving node and edgeType, return an array of edge id.
	 * @return {Function} Input: sourceNode, Output: Like {nodes: [], dims: {}}
	 */
	
	function createLinkedNodesFinder(forEachNode, forEachEdgeType, edgeIdGetter) {
	  return function (sourceNode) {
	    var result = {
	      nodes: [],
	      records: {} // key: edgeType.name, value: Object (key: edge id, value: boolean).
	
	    };
	    forEachEdgeType(function (edgeType) {
	      result.records[edgeType.name] = {};
	    });
	
	    if (!sourceNode) {
	      return result;
	    }
	
	    absorb(sourceNode, result);
	    var existsLink;
	
	    do {
	      existsLink = false;
	      forEachNode(processSingleNode);
	    } while (existsLink);
	
	    function processSingleNode(node) {
	      if (!isNodeAbsorded(node, result) && isLinked(node, result)) {
	        absorb(node, result);
	        existsLink = true;
	      }
	    }
	
	    return result;
	  };
	
	  function isNodeAbsorded(node, result) {
	    return zrUtil.indexOf(result.nodes, node) >= 0;
	  }
	
	  function isLinked(node, result) {
	    var hasLink = false;
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] && (hasLink = true);
	      });
	    });
	    return hasLink;
	  }
	
	  function absorb(node, result) {
	    result.nodes.push(node);
	    forEachEdgeType(function (edgeType) {
	      zrUtil.each(edgeIdGetter(node, edgeType) || [], function (edgeId) {
	        result.records[edgeType.name][edgeId] = true;
	      });
	    });
	  }
	}
	
	exports.isCoordSupported = isCoordSupported;
	exports.createNameEach = createNameEach;
	exports.eachAxisDim = eachAxisDim;
	exports.createLinkedNodesFinder = createLinkedNodesFinder;

/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(76);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('dataZoom', function () {
	  // Default 'slider' when no type specified.
	  return 'slider';
	});

/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(4);
	
	var Eventful = __webpack_require__(225);
	
	var graphic = __webpack_require__(14);
	
	var interactionMutex = __webpack_require__(846);
	
	var DataDiffer = __webpack_require__(211);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var map = zrUtil.map;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathPow = Math.pow;
	var COVER_Z = 10000;
	var UNSELECT_THRESHOLD = 6;
	var MIN_RESIZE_LINE_WIDTH = 6;
	var MUTEX_RESOURCE_KEY = 'globalPan';
	var DIRECTION_MAP = {
	  w: [0, 0],
	  e: [0, 1],
	  n: [1, 0],
	  s: [1, 1]
	};
	var CURSOR_MAP = {
	  w: 'ew',
	  e: 'ew',
	  n: 'ns',
	  s: 'ns',
	  ne: 'nesw',
	  sw: 'nesw',
	  nw: 'nwse',
	  se: 'nwse'
	};
	var DEFAULT_BRUSH_OPT = {
	  brushStyle: {
	    lineWidth: 2,
	    stroke: 'rgba(0,0,0,0.3)',
	    fill: 'rgba(0,0,0,0.1)'
	  },
	  transformable: true,
	  brushMode: 'single',
	  removeOnClick: false
	};
	var baseUID = 0;
	/**
	 * @alias module:echarts/component/helper/BrushController
	 * @constructor
	 * @mixin {module:zrender/mixin/Eventful}
	 * @event module:echarts/component/helper/BrushController#brush
	 *        params:
	 *            areas: Array.<Array>, coord relates to container group,
	 *                                    If no container specified, to global.
	 *            opt {
	 *                isEnd: boolean,
	 *                removeOnClick: boolean
	 *            }
	 *
	 * @param {module:zrender/zrender~ZRender} zr
	 */
	
	function BrushController(zr) {
	  Eventful.call(this);
	  /**
	   * @type {module:zrender/zrender~ZRender}
	   * @private
	   */
	
	  this._zr = zr;
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = new graphic.Group();
	  /**
	   * Only for drawing (after enabledBrush).
	   *     'line', 'rect', 'polygon' or false
	   *     If passing false/null/undefined, disable brush.
	   *     If passing 'auto', determined by panel.defaultBrushType
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * Only for drawing (after enabledBrush).
	   *
	   * @private
	   * @type {Object}
	   */
	
	  this._brushOption;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._panels;
	  /**
	   * @private
	   * @type {Array.<nubmer>}
	   */
	
	  this._track = [];
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._dragging;
	  /**
	   * @private
	   * @type {Array}
	   */
	
	  this._covers = [];
	  /**
	   * @private
	   * @type {moudule:zrender/container/Group}
	   */
	
	  this._creatingCover;
	  /**
	   * `true` means global panel
	   * @private
	   * @type {module:zrender/container/Group|boolean}
	   */
	
	  this._creatingPanel;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._enableGlobalPan;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  /**
	   * @private
	   * @type {string}
	   */
	  this._uid = 'brushController_' + baseUID++;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._handlers = {};
	  each(pointerHandlers, function (handler, eventName) {
	    this._handlers[eventName] = zrUtil.bind(handler, this);
	  }, this);
	}
	
	BrushController.prototype = {
	  constructor: BrushController,
	
	  /**
	   * If set to null/undefined/false, select disabled.
	   * @param {Object} brushOption
	   * @param {string|boolean} brushOption.brushType 'line', 'rect', 'polygon' or false
	   *                          If passing false/null/undefined, disable brush.
	   *                          If passing 'auto', determined by panel.defaultBrushType.
	   *                              ('auto' can not be used in global panel)
	   * @param {number} [brushOption.brushMode='single'] 'single' or 'multiple'
	   * @param {boolean} [brushOption.transformable=true]
	   * @param {boolean} [brushOption.removeOnClick=false]
	   * @param {Object} [brushOption.brushStyle]
	   * @param {number} [brushOption.brushStyle.width]
	   * @param {number} [brushOption.brushStyle.lineWidth]
	   * @param {string} [brushOption.brushStyle.stroke]
	   * @param {string} [brushOption.brushStyle.fill]
	   * @param {number} [brushOption.z]
	   */
	  enableBrush: function (brushOption) {
	    this._brushType && doDisableBrush(this);
	    brushOption.brushType && doEnableBrush(this, brushOption);
	    return this;
	  },
	
	  /**
	   * @param {Array.<Object>} panelOpts If not pass, it is global brush.
	   *        Each items: {
	   *            panelId, // mandatory.
	   *            clipPath, // mandatory. function.
	   *            isTargetByCursor, // mandatory. function.
	   *            defaultBrushType, // optional, only used when brushType is 'auto'.
	   *            getLinearBrushOtherExtent, // optional. function.
	   *        }
	   */
	  setPanels: function (panelOpts) {
	    if (panelOpts && panelOpts.length) {
	      var panels = this._panels = {};
	      zrUtil.each(panelOpts, function (panelOpts) {
	        panels[panelOpts.panelId] = zrUtil.clone(panelOpts);
	      });
	    } else {
	      this._panels = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * @param {Object} [opt]
	   * @return {boolean} [opt.enableGlobalPan=false]
	   */
	  mount: function (opt) {
	    opt = opt || {};
	    this._enableGlobalPan = opt.enableGlobalPan;
	    var thisGroup = this.group;
	
	    this._zr.add(thisGroup);
	
	    thisGroup.attr({
	      position: opt.position || [0, 0],
	      rotation: opt.rotation || 0,
	      scale: opt.scale || [1, 1]
	    });
	    this._transform = thisGroup.getLocalTransform();
	    return this;
	  },
	  eachCover: function (cb, context) {
	    each(this._covers, cb, context);
	  },
	
	  /**
	   * Update covers.
	   * @param {Array.<Object>} brushOptionList Like:
	   *        [
	   *            {id: 'xx', brushType: 'line', range: [23, 44], brushStyle, transformable},
	   *            {id: 'yy', brushType: 'rect', range: [[23, 44], [23, 54]]},
	   *            ...
	   *        ]
	   *        `brushType` is required in each cover info. (can not be 'auto')
	   *        `id` is not mandatory.
	   *        `brushStyle`, `transformable` is not mandatory, use DEFAULT_BRUSH_OPT by default.
	   *        If brushOptionList is null/undefined, all covers removed.
	   */
	  updateCovers: function (brushOptionList) {
	    brushOptionList = zrUtil.map(brushOptionList, function (brushOption) {
	      return zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	    });
	    var tmpIdPrefix = '\0-brush-index-';
	    var oldCovers = this._covers;
	    var newCovers = this._covers = [];
	    var controller = this;
	    var creatingCover = this._creatingCover;
	    new DataDiffer(oldCovers, brushOptionList, oldGetKey, getKey).add(addOrUpdate).update(addOrUpdate).remove(remove).execute();
	    return this;
	
	    function getKey(brushOption, index) {
	      return (brushOption.id != null ? brushOption.id : tmpIdPrefix + index) + '-' + brushOption.brushType;
	    }
	
	    function oldGetKey(cover, index) {
	      return getKey(cover.__brushOption, index);
	    }
	
	    function addOrUpdate(newIndex, oldIndex) {
	      var newBrushOption = brushOptionList[newIndex]; // Consider setOption in event listener of brushSelect,
	      // where updating cover when creating should be forbiden.
	
	      if (oldIndex != null && oldCovers[oldIndex] === creatingCover) {
	        newCovers[newIndex] = oldCovers[oldIndex];
	      } else {
	        var cover = newCovers[newIndex] = oldIndex != null ? (oldCovers[oldIndex].__brushOption = newBrushOption, oldCovers[oldIndex]) : endCreating(controller, createCover(controller, newBrushOption));
	        updateCoverAfterCreation(controller, cover);
	      }
	    }
	
	    function remove(oldIndex) {
	      if (oldCovers[oldIndex] !== creatingCover) {
	        controller.group.remove(oldCovers[oldIndex]);
	      }
	    }
	  },
	  unmount: function () {
	    this.enableBrush(false); // container may 'removeAll' outside.
	
	    clearCovers(this);
	
	    this._zr.remove(this.group);
	
	    return this;
	  },
	  dispose: function () {
	    this.unmount();
	    this.off();
	  }
	};
	zrUtil.mixin(BrushController, Eventful);
	
	function doEnableBrush(controller, brushOption) {
	  var zr = controller._zr; // Consider roam, which takes globalPan too.
	
	  if (!controller._enableGlobalPan) {
	    interactionMutex.take(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  }
	
	  mountHandlers(zr, controller._handlers);
	  controller._brushType = brushOption.brushType;
	  controller._brushOption = zrUtil.merge(zrUtil.clone(DEFAULT_BRUSH_OPT), brushOption, true);
	}
	
	function doDisableBrush(controller) {
	  var zr = controller._zr;
	  interactionMutex.release(zr, MUTEX_RESOURCE_KEY, controller._uid);
	  unmountHandlers(zr, controller._handlers);
	  controller._brushType = controller._brushOption = null;
	}
	
	function mountHandlers(zr, handlers) {
	  each(handlers, function (handler, eventName) {
	    zr.on(eventName, handler);
	  });
	}
	
	function unmountHandlers(zr, handlers) {
	  each(handlers, function (handler, eventName) {
	    zr.off(eventName, handler);
	  });
	}
	
	function createCover(controller, brushOption) {
	  var cover = coverRenderers[brushOption.brushType].createCover(controller, brushOption);
	  cover.__brushOption = brushOption;
	  updateZ(cover, brushOption);
	  controller.group.add(cover);
	  return cover;
	}
	
	function endCreating(controller, creatingCover) {
	  var coverRenderer = getCoverRenderer(creatingCover);
	
	  if (coverRenderer.endCreating) {
	    coverRenderer.endCreating(controller, creatingCover);
	    updateZ(creatingCover, creatingCover.__brushOption);
	  }
	
	  return creatingCover;
	}
	
	function updateCoverShape(controller, cover) {
	  var brushOption = cover.__brushOption;
	  getCoverRenderer(cover).updateCoverShape(controller, cover, brushOption.range, brushOption);
	}
	
	function updateZ(cover, brushOption) {
	  var z = brushOption.z;
	  z == null && (z = COVER_Z);
	  cover.traverse(function (el) {
	    el.z = z;
	    el.z2 = z; // Consider in given container.
	  });
	}
	
	function updateCoverAfterCreation(controller, cover) {
	  getCoverRenderer(cover).updateCommon(controller, cover);
	  updateCoverShape(controller, cover);
	}
	
	function getCoverRenderer(cover) {
	  return coverRenderers[cover.__brushOption.brushType];
	} // return target panel or `true` (means global panel)
	
	
	function getPanelByPoint(controller, e, localCursorPoint) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panel;
	  var transform = controller._transform;
	  each(panels, function (pn) {
	    pn.isTargetByCursor(e, localCursorPoint, transform) && (panel = pn);
	  });
	  return panel;
	} // Return a panel or true
	
	
	function getPanelByCover(controller, cover) {
	  var panels = controller._panels;
	
	  if (!panels) {
	    return true; // Global panel
	  }
	
	  var panelId = cover.__brushOption.panelId; // User may give cover without coord sys info,
	  // which is then treated as global panel.
	
	  return panelId != null ? panels[panelId] : true;
	}
	
	function clearCovers(controller) {
	  var covers = controller._covers;
	  var originalLength = covers.length;
	  each(covers, function (cover) {
	    controller.group.remove(cover);
	  }, controller);
	  covers.length = 0;
	  return !!originalLength;
	}
	
	function trigger(controller, opt) {
	  var areas = map(controller._covers, function (cover) {
	    var brushOption = cover.__brushOption;
	    var range = zrUtil.clone(brushOption.range);
	    return {
	      brushType: brushOption.brushType,
	      panelId: brushOption.panelId,
	      range: range
	    };
	  });
	  controller.trigger('brush', areas, {
	    isEnd: !!opt.isEnd,
	    removeOnClick: !!opt.removeOnClick
	  });
	}
	
	function shouldShowCover(controller) {
	  var track = controller._track;
	
	  if (!track.length) {
	    return false;
	  }
	
	  var p2 = track[track.length - 1];
	  var p1 = track[0];
	  var dx = p2[0] - p1[0];
	  var dy = p2[1] - p1[1];
	  var dist = mathPow(dx * dx + dy * dy, 0.5);
	  return dist > UNSELECT_THRESHOLD;
	}
	
	function getTrackEnds(track) {
	  var tail = track.length - 1;
	  tail < 0 && (tail = 0);
	  return [track[0], track[tail]];
	}
	
	function createBaseRectCover(doDrift, controller, brushOption, edgeNames) {
	  var cover = new graphic.Group();
	  cover.add(new graphic.Rect({
	    name: 'main',
	    style: makeStyle(brushOption),
	    silent: true,
	    draggable: true,
	    cursor: 'move',
	    drift: curry(doDrift, controller, cover, 'nswe'),
	    ondragend: curry(trigger, controller, {
	      isEnd: true
	    })
	  }));
	  each(edgeNames, function (name) {
	    cover.add(new graphic.Rect({
	      name: name,
	      style: {
	        opacity: 0
	      },
	      draggable: true,
	      silent: true,
	      invisible: true,
	      drift: curry(doDrift, controller, cover, name),
	      ondragend: curry(trigger, controller, {
	        isEnd: true
	      })
	    }));
	  });
	  return cover;
	}
	
	function updateBaseRect(controller, cover, localRange, brushOption) {
	  var lineWidth = brushOption.brushStyle.lineWidth || 0;
	  var handleSize = mathMax(lineWidth, MIN_RESIZE_LINE_WIDTH);
	  var x = localRange[0][0];
	  var y = localRange[1][0];
	  var xa = x - lineWidth / 2;
	  var ya = y - lineWidth / 2;
	  var x2 = localRange[0][1];
	  var y2 = localRange[1][1];
	  var x2a = x2 - handleSize + lineWidth / 2;
	  var y2a = y2 - handleSize + lineWidth / 2;
	  var width = x2 - x;
	  var height = y2 - y;
	  var widtha = width + lineWidth;
	  var heighta = height + lineWidth;
	  updateRectShape(controller, cover, 'main', x, y, width, height);
	
	  if (brushOption.transformable) {
	    updateRectShape(controller, cover, 'w', xa, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'e', x2a, ya, handleSize, heighta);
	    updateRectShape(controller, cover, 'n', xa, ya, widtha, handleSize);
	    updateRectShape(controller, cover, 's', xa, y2a, widtha, handleSize);
	    updateRectShape(controller, cover, 'nw', xa, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'ne', x2a, ya, handleSize, handleSize);
	    updateRectShape(controller, cover, 'sw', xa, y2a, handleSize, handleSize);
	    updateRectShape(controller, cover, 'se', x2a, y2a, handleSize, handleSize);
	  }
	}
	
	function updateCommon(controller, cover) {
	  var brushOption = cover.__brushOption;
	  var transformable = brushOption.transformable;
	  var mainEl = cover.childAt(0);
	  mainEl.useStyle(makeStyle(brushOption));
	  mainEl.attr({
	    silent: !transformable,
	    cursor: transformable ? 'move' : 'default'
	  });
	  each(['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw'], function (name) {
	    var el = cover.childOfName(name);
	    var globalDir = getGlobalDirection(controller, name);
	    el && el.attr({
	      silent: !transformable,
	      invisible: !transformable,
	      cursor: transformable ? CURSOR_MAP[globalDir] + '-resize' : null
	    });
	  });
	}
	
	function updateRectShape(controller, cover, name, x, y, w, h) {
	  var el = cover.childOfName(name);
	  el && el.setShape(pointsToRect(clipByPanel(controller, cover, [[x, y], [x + w, y + h]])));
	}
	
	function makeStyle(brushOption) {
	  return zrUtil.defaults({
	    strokeNoScale: true
	  }, brushOption.brushStyle);
	}
	
	function formatRectRange(x, y, x2, y2) {
	  var min = [mathMin(x, x2), mathMin(y, y2)];
	  var max = [mathMax(x, x2), mathMax(y, y2)];
	  return [[min[0], max[0]], // x range
	  [min[1], max[1]] // y range
	  ];
	}
	
	function getTransform(controller) {
	  return graphic.getTransform(controller.group);
	}
	
	function getGlobalDirection(controller, localDirection) {
	  if (localDirection.length > 1) {
	    localDirection = localDirection.split('');
	    var globalDir = [getGlobalDirection(controller, localDirection[0]), getGlobalDirection(controller, localDirection[1])];
	    (globalDir[0] === 'e' || globalDir[0] === 'w') && globalDir.reverse();
	    return globalDir.join('');
	  } else {
	    var map = {
	      w: 'left',
	      e: 'right',
	      n: 'top',
	      s: 'bottom'
	    };
	    var inverseMap = {
	      left: 'w',
	      right: 'e',
	      top: 'n',
	      bottom: 's'
	    };
	    var globalDir = graphic.transformDirection(map[localDirection], getTransform(controller));
	    return inverseMap[globalDir];
	  }
	}
	
	function driftRect(toRectRange, fromRectRange, controller, cover, name, dx, dy, e) {
	  var brushOption = cover.__brushOption;
	  var rectRange = toRectRange(brushOption.range);
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(name.split(''), function (namePart) {
	    var ind = DIRECTION_MAP[namePart];
	    rectRange[ind[0]][ind[1]] += localDelta[ind[0]];
	  });
	  brushOption.range = fromRectRange(formatRectRange(rectRange[0][0], rectRange[1][0], rectRange[0][1], rectRange[1][1]));
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function driftPolygon(controller, cover, dx, dy, e) {
	  var range = cover.__brushOption.range;
	  var localDelta = toLocalDelta(controller, dx, dy);
	  each(range, function (point) {
	    point[0] += localDelta[0];
	    point[1] += localDelta[1];
	  });
	  updateCoverAfterCreation(controller, cover);
	  trigger(controller, {
	    isEnd: false
	  });
	}
	
	function toLocalDelta(controller, dx, dy) {
	  var thisGroup = controller.group;
	  var localD = thisGroup.transformCoordToLocal(dx, dy);
	  var localZero = thisGroup.transformCoordToLocal(0, 0);
	  return [localD[0] - localZero[0], localD[1] - localZero[1]];
	}
	
	function clipByPanel(controller, cover, data) {
	  var panel = getPanelByCover(controller, cover);
	  return panel && panel !== true ? panel.clipPath(data, controller._transform) : zrUtil.clone(data);
	}
	
	function pointsToRect(points) {
	  var xmin = mathMin(points[0][0], points[1][0]);
	  var ymin = mathMin(points[0][1], points[1][1]);
	  var xmax = mathMax(points[0][0], points[1][0]);
	  var ymax = mathMax(points[0][1], points[1][1]);
	  return {
	    x: xmin,
	    y: ymin,
	    width: xmax - xmin,
	    height: ymax - ymin
	  };
	}
	
	function resetCursor(controller, e, localCursorPoint) {
	  if ( // Check active
	  !controller._brushType // resetCursor should be always called when mouse is in zr area,
	  // but not called when mouse is out of zr area to avoid bad influence
	  // if `mousemove`, `mouseup` are triggered from `document` event.
	  || isOutsideZrArea(controller, e)) {
	    return;
	  }
	
	  var zr = controller._zr;
	  var covers = controller._covers;
	  var currPanel = getPanelByPoint(controller, e, localCursorPoint); // Check whether in covers.
	
	  if (!controller._dragging) {
	    for (var i = 0; i < covers.length; i++) {
	      var brushOption = covers[i].__brushOption;
	
	      if (currPanel && (currPanel === true || brushOption.panelId === currPanel.panelId) && coverRenderers[brushOption.brushType].contain(covers[i], localCursorPoint[0], localCursorPoint[1])) {
	        // Use cursor style set on cover.
	        return;
	      }
	    }
	  }
	
	  currPanel && zr.setCursorStyle('crosshair');
	}
	
	function preventDefault(e) {
	  var rawE = e.event;
	  rawE.preventDefault && rawE.preventDefault();
	}
	
	function mainShapeContain(cover, x, y) {
	  return cover.childOfName('main').contain(x, y);
	}
	
	function updateCoverByMouse(controller, e, localCursorPoint, isEnd) {
	  var creatingCover = controller._creatingCover;
	  var panel = controller._creatingPanel;
	  var thisBrushOption = controller._brushOption;
	  var eventParams;
	
	  controller._track.push(localCursorPoint.slice());
	
	  if (shouldShowCover(controller) || creatingCover) {
	    if (panel && !creatingCover) {
	      thisBrushOption.brushMode === 'single' && clearCovers(controller);
	      var brushOption = zrUtil.clone(thisBrushOption);
	      brushOption.brushType = determineBrushType(brushOption.brushType, panel);
	      brushOption.panelId = panel === true ? null : panel.panelId;
	      creatingCover = controller._creatingCover = createCover(controller, brushOption);
	
	      controller._covers.push(creatingCover);
	    }
	
	    if (creatingCover) {
	      var coverRenderer = coverRenderers[determineBrushType(controller._brushType, panel)];
	      var coverBrushOption = creatingCover.__brushOption;
	      coverBrushOption.range = coverRenderer.getCreatingRange(clipByPanel(controller, creatingCover, controller._track));
	
	      if (isEnd) {
	        endCreating(controller, creatingCover);
	        coverRenderer.updateCommon(controller, creatingCover);
	      }
	
	      updateCoverShape(controller, creatingCover);
	      eventParams = {
	        isEnd: isEnd
	      };
	    }
	  } else if (isEnd && thisBrushOption.brushMode === 'single' && thisBrushOption.removeOnClick) {
	    // Help user to remove covers easily, only by a tiny drag, in 'single' mode.
	    // But a single click do not clear covers, because user may have casual
	    // clicks (for example, click on other component and do not expect covers
	    // disappear).
	    // Only some cover removed, trigger action, but not every click trigger action.
	    if (getPanelByPoint(controller, e, localCursorPoint) && clearCovers(controller)) {
	      eventParams = {
	        isEnd: isEnd,
	        removeOnClick: true
	      };
	    }
	  }
	
	  return eventParams;
	}
	
	function determineBrushType(brushType, panel) {
	  if (brushType === 'auto') {
	    return panel.defaultBrushType;
	  }
	
	  return brushType;
	}
	
	var pointerHandlers = {
	  mousedown: function (e) {
	    if (this._dragging) {
	      // In case some browser do not support globalOut,
	      // and release mose out side the browser.
	      handleDragEnd(this, e);
	    } else if (!e.target || !e.target.draggable) {
	      preventDefault(e);
	      var localCursorPoint = this.group.transformCoordToLocal(e.offsetX, e.offsetY);
	      this._creatingCover = null;
	      var panel = this._creatingPanel = getPanelByPoint(this, e, localCursorPoint);
	
	      if (panel) {
	        this._dragging = true;
	        this._track = [localCursorPoint.slice()];
	      }
	    }
	  },
	  mousemove: function (e) {
	    var x = e.offsetX;
	    var y = e.offsetY;
	    var localCursorPoint = this.group.transformCoordToLocal(x, y);
	    resetCursor(this, e, localCursorPoint);
	
	    if (this._dragging) {
	      preventDefault(e);
	      var eventParams = updateCoverByMouse(this, e, localCursorPoint, false);
	      eventParams && trigger(this, eventParams);
	    }
	  },
	  mouseup: function (e) {
	    handleDragEnd(this, e);
	  }
	};
	
	function handleDragEnd(controller, e) {
	  if (controller._dragging) {
	    preventDefault(e);
	    var x = e.offsetX;
	    var y = e.offsetY;
	    var localCursorPoint = controller.group.transformCoordToLocal(x, y);
	    var eventParams = updateCoverByMouse(controller, e, localCursorPoint, true);
	    controller._dragging = false;
	    controller._track = [];
	    controller._creatingCover = null; // trigger event shoule be at final, after procedure will be nested.
	
	    eventParams && trigger(controller, eventParams);
	  }
	}
	
	function isOutsideZrArea(controller, x, y) {
	  var zr = controller._zr;
	  return x < 0 || x > zr.getWidth() || y < 0 || y > zr.getHeight();
	}
	/**
	 * key: brushType
	 * @type {Object}
	 */
	
	
	var coverRenderers = {
	  lineX: getLineRenderer(0),
	  lineY: getLineRenderer(1),
	  rect: {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        return range;
	      }, function (range) {
	        return range;
	      }), controller, brushOption, ['w', 'e', 'n', 's', 'se', 'sw', 'ne', 'nw']);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      return formatRectRange(ends[1][0], ends[1][1], ends[0][0], ends[0][1]);
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      updateBaseRect(controller, cover, localRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  },
	  polygon: {
	    createCover: function (controller, brushOption) {
	      var cover = new graphic.Group(); // Do not use graphic.Polygon because graphic.Polyline do not close the
	      // border of the shape when drawing, which is a better experience for user.
	
	      cover.add(new graphic.Polyline({
	        name: 'main',
	        style: makeStyle(brushOption),
	        silent: true
	      }));
	      return cover;
	    },
	    getCreatingRange: function (localTrack) {
	      return localTrack;
	    },
	    endCreating: function (controller, cover) {
	      cover.remove(cover.childAt(0)); // Use graphic.Polygon close the shape.
	
	      cover.add(new graphic.Polygon({
	        name: 'main',
	        draggable: true,
	        drift: curry(driftPolygon, controller, cover),
	        ondragend: curry(trigger, controller, {
	          isEnd: true
	        })
	      }));
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      cover.childAt(0).setShape({
	        points: clipByPanel(controller, cover, localRange)
	      });
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  }
	};
	
	function getLineRenderer(xyIndex) {
	  return {
	    createCover: function (controller, brushOption) {
	      return createBaseRectCover(curry(driftRect, function (range) {
	        var rectRange = [range, [0, 100]];
	        xyIndex && rectRange.reverse();
	        return rectRange;
	      }, function (rectRange) {
	        return rectRange[xyIndex];
	      }), controller, brushOption, [['w', 'e'], ['n', 's']][xyIndex]);
	    },
	    getCreatingRange: function (localTrack) {
	      var ends = getTrackEnds(localTrack);
	      var min = mathMin(ends[0][xyIndex], ends[1][xyIndex]);
	      var max = mathMax(ends[0][xyIndex], ends[1][xyIndex]);
	      return [min, max];
	    },
	    updateCoverShape: function (controller, cover, localRange, brushOption) {
	      var otherExtent; // If brushWidth not specified, fit the panel.
	
	      var panel = getPanelByCover(controller, cover);
	
	      if (panel !== true && panel.getLinearBrushOtherExtent) {
	        otherExtent = panel.getLinearBrushOtherExtent(xyIndex, controller._transform);
	      } else {
	        var zr = controller._zr;
	        otherExtent = [0, [zr.getWidth(), zr.getHeight()][1 - xyIndex]];
	      }
	
	      var rectRange = [localRange, otherExtent];
	      xyIndex && rectRange.reverse();
	      updateBaseRect(controller, cover, rectRange, brushOption);
	    },
	    updateCommon: updateCommon,
	    contain: mainShapeContain
	  };
	}
	
	var _default = BrushController;
	module.exports = _default;

/***/ },
/* 506 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 */
	function updateViewOnPan(controllerHost, dx, dy) {
	  var target = controllerHost.target;
	  var pos = target.position;
	  pos[0] += dx;
	  pos[1] += dy;
	  target.dirty();
	}
	/**
	 * For geo and graph.
	 *
	 * @param {Object} controllerHost
	 * @param {module:zrender/Element} controllerHost.target
	 * @param {number} controllerHost.zoom
	 * @param {number} controllerHost.zoomLimit like: {min: 1, max: 2}
	 */
	
	
	function updateViewOnZoom(controllerHost, zoomDelta, zoomX, zoomY) {
	  var target = controllerHost.target;
	  var zoomLimit = controllerHost.zoomLimit;
	  var pos = target.position;
	  var scale = target.scale;
	  var newZoom = controllerHost.zoom = controllerHost.zoom || 1;
	  newZoom *= zoomDelta;
	
	  if (zoomLimit) {
	    var zoomMin = zoomLimit.min || 0;
	    var zoomMax = zoomLimit.max || Infinity;
	    newZoom = Math.max(Math.min(zoomMax, newZoom), zoomMin);
	  }
	
	  var zoomScale = newZoom / controllerHost.zoom;
	  controllerHost.zoom = newZoom; // Keep the mouse center when scaling
	
	  pos[0] -= (zoomX - pos[0]) * (zoomScale - 1);
	  pos[1] -= (zoomY - pos[1]) * (zoomScale - 1);
	  scale[0] *= zoomScale;
	  scale[1] *= zoomScale;
	  target.dirty();
	}
	
	exports.updateViewOnPan = updateViewOnPan;
	exports.updateViewOnZoom = updateViewOnZoom;

/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Data selectable mixin for chart series.
	 * To eanble data select, option of series must have `selectedMode`.
	 * And each data item will use `selected` to toggle itself selected status
	 */
	var _default = {
	  /**
	   * @param {Array.<Object>} targetList [{name, value, selected}, ...]
	   *        If targetList is an array, it should like [{name: ..., value: ...}, ...].
	   *        If targetList is a "List", it must have coordDim: 'value' dimension and name.
	   */
	  updateSelectedMap: function (targetList) {
	    this._targetList = zrUtil.isArray(targetList) ? targetList.slice() : [];
	    this._selectTargetMap = zrUtil.reduce(targetList || [], function (targetMap, target) {
	      targetMap.set(target.name, target);
	      return targetMap;
	    }, zrUtil.createHashMap());
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  // PENGING If selectedMode is null ?
	  select: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      this._selectTargetMap.each(function (target) {
	        target.selected = false;
	      });
	    }
	
	    target && (target.selected = true);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  unSelect: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name); // var selectedMode = this.get('selectedMode');
	    // selectedMode !== 'single' && target && (target.selected = false);
	
	    target && (target.selected = false);
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  toggleSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	
	    if (target != null) {
	      this[target.selected ? 'unSelect' : 'select'](name, id);
	      return target.selected;
	    }
	  },
	
	  /**
	   * Either name or id should be passed as input here.
	   * If both of them are defined, id is used.
	   *
	   * @param {string|undefined} name name of data
	   * @param {number|undefined} id dataIndex of data
	   */
	  isSelected: function (name, id) {
	    var target = id != null ? this._targetList[id] : this._selectTargetMap.get(name);
	    return target && target.selected;
	  }
	};
	module.exports = _default;

/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var env = __webpack_require__(73);
	
	var modelUtil = __webpack_require__(29);
	
	var formatUtil = __webpack_require__(48);
	
	var dataFormatMixin = __webpack_require__(517);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var addCommas = formatUtil.addCommas;
	var encodeHTML = formatUtil.encodeHTML;
	
	function fillLabel(opt) {
	  modelUtil.defaultEmphasis(opt, 'label', ['show']);
	}
	
	var MarkerModel = echarts.extendComponentModel({
	  type: 'marker',
	  dependencies: ['series', 'grid', 'polar', 'geo'],
	
	  /**
	   * @overrite
	   */
	  init: function (option, parentModel, ecModel) {
	    this.mergeDefaultAndTheme(option, ecModel);
	
	    this._mergeOption(option, ecModel, false, true);
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isAnimationEnabled: function () {
	    if (env.node) {
	      return false;
	    }
	
	    var hostSeries = this.__hostSeries;
	    return this.getShallow('animation') && hostSeries && hostSeries.isAnimationEnabled();
	  },
	
	  /**
	   * @overrite
	   */
	  mergeOption: function (newOpt, ecModel) {
	    this._mergeOption(newOpt, ecModel, false, false);
	  },
	  _mergeOption: function (newOpt, ecModel, createdBySelf, isInit) {
	    var MarkerModel = this.constructor;
	    var modelPropName = this.mainType + 'Model';
	
	    if (!createdBySelf) {
	      ecModel.eachSeries(function (seriesModel) {
	        var markerOpt = seriesModel.get(this.mainType, true);
	        var markerModel = seriesModel[modelPropName];
	
	        if (!markerOpt || !markerOpt.data) {
	          seriesModel[modelPropName] = null;
	          return;
	        }
	
	        if (!markerModel) {
	          if (isInit) {
	            // Default label emphasis `position` and `show`
	            fillLabel(markerOpt);
	          }
	
	          zrUtil.each(markerOpt.data, function (item) {
	            // FIXME Overwrite fillLabel method ?
	            if (item instanceof Array) {
	              fillLabel(item[0]);
	              fillLabel(item[1]);
	            } else {
	              fillLabel(item);
	            }
	          });
	          markerModel = new MarkerModel(markerOpt, this, ecModel);
	          zrUtil.extend(markerModel, {
	            mainType: this.mainType,
	            // Use the same series index and name
	            seriesIndex: seriesModel.seriesIndex,
	            name: seriesModel.name,
	            createdBySelf: true
	          });
	          markerModel.__hostSeries = seriesModel;
	        } else {
	          markerModel._mergeOption(markerOpt, ecModel, true);
	        }
	
	        seriesModel[modelPropName] = markerModel;
	      }, this);
	    }
	  },
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? zrUtil.map(value, addCommas).join(', ') : addCommas(value);
	    var name = data.getName(dataIndex);
	    var html = encodeHTML(this.name);
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	
	    if (value != null || name) {
	      html += newLine;
	    }
	
	    if (name) {
	      html += encodeHTML(name);
	
	      if (value != null) {
	        html += ' : ';
	      }
	    }
	
	    if (value != null) {
	      html += encodeHTML(formattedValue);
	    }
	
	    return html;
	  },
	  getData: function () {
	    return this._data;
	  },
	  setData: function (data) {
	    this._data = data;
	  }
	});
	zrUtil.mixin(MarkerModel, dataFormatMixin);
	var _default = MarkerModel;
	module.exports = _default;

/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'marker',
	  init: function () {
	    /**
	     * Markline grouped by series
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this.markerGroupMap = zrUtil.createHashMap();
	  },
	  render: function (markerModel, ecModel, api) {
	    var markerGroupMap = this.markerGroupMap;
	    markerGroupMap.each(function (item) {
	      item.__keep = false;
	    });
	    var markerModelKey = this.type + 'Model';
	    ecModel.eachSeries(function (seriesModel) {
	      var markerModel = seriesModel[markerModelKey];
	      markerModel && this.renderSeries(seriesModel, markerModel, ecModel, api);
	    }, this);
	    markerGroupMap.each(function (item) {
	      !item.__keep && this.group.remove(item.group);
	    }, this);
	  },
	  renderSeries: function () {}
	});
	
	module.exports = _default;

/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var numberUtil = __webpack_require__(25);
	
	var _dataStackHelper = __webpack_require__(140);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var indexOf = zrUtil.indexOf;
	
	function hasXOrY(item) {
	  return !(isNaN(parseFloat(item.x)) && isNaN(parseFloat(item.y)));
	}
	
	function hasXAndY(item) {
	  return !isNaN(parseFloat(item.x)) && !isNaN(parseFloat(item.y));
	} // Make it simple, do not visit all stacked value to count precision.
	// function getPrecision(data, valueAxisDim, dataIndex) {
	//     var precision = -1;
	//     var stackedDim = data.mapDimension(valueAxisDim);
	//     do {
	//         precision = Math.max(
	//             numberUtil.getPrecision(data.get(stackedDim, dataIndex)),
	//             precision
	//         );
	//         var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
	//         if (stackedOnSeries) {
	//             var byValue = data.get(data.getCalculationInfo('stackedByDimension'), dataIndex);
	//             data = stackedOnSeries.getData();
	//             dataIndex = data.indexOf(data.getCalculationInfo('stackedByDimension'), byValue);
	//             stackedDim = data.getCalculationInfo('stackedDimension');
	//         }
	//         else {
	//             data = null;
	//         }
	//     } while (data);
	//     return precision;
	// }
	
	
	function markerTypeCalculatorWithExtent(mlType, data, otherDataDim, targetDataDim, otherCoordIndex, targetCoordIndex) {
	  var coordArr = [];
	  var stacked = isDimensionStacked(data, targetDataDim
	  /*, otherDataDim*/
	  );
	  var calcDataDim = stacked ? data.getCalculationInfo('stackResultDimension') : targetDataDim;
	  var value = numCalculate(data, calcDataDim, mlType);
	  var dataIndex = data.indicesOfNearest(calcDataDim, value)[0];
	  coordArr[otherCoordIndex] = data.get(otherDataDim, dataIndex);
	  coordArr[targetCoordIndex] = data.get(calcDataDim, dataIndex);
	  var coordArrValue = data.get(targetDataDim, dataIndex); // Make it simple, do not visit all stacked value to count precision.
	
	  var precision = numberUtil.getPrecision(data.get(targetDataDim, dataIndex));
	  precision = Math.min(precision, 20);
	
	  if (precision >= 0) {
	    coordArr[targetCoordIndex] = +coordArr[targetCoordIndex].toFixed(precision);
	  }
	
	  return [coordArr, coordArrValue];
	}
	
	var curry = zrUtil.curry; // TODO Specified percent
	
	var markerTypeCalculator = {
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  min: curry(markerTypeCalculatorWithExtent, 'min'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  max: curry(markerTypeCalculatorWithExtent, 'max'),
	
	  /**
	   * @method
	   * @param {module:echarts/data/List} data
	   * @param {string} baseAxisDim
	   * @param {string} valueAxisDim
	   */
	  average: curry(markerTypeCalculatorWithExtent, 'average')
	};
	/**
	 * Transform markPoint data item to format used in List by do the following
	 * 1. Calculate statistic like `max`, `min`, `average`
	 * 2. Convert `item.xAxis`, `item.yAxis` to `item.coord` array
	 * @param  {module:echarts/model/Series} seriesModel
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {Object}
	 */
	
	function dataTransform(seriesModel, item) {
	  var data = seriesModel.getData();
	  var coordSys = seriesModel.coordinateSystem; // 1. If not specify the position with pixel directly
	  // 2. If `coord` is not a data array. Which uses `xAxis`,
	  // `yAxis` to specify the coord on each dimension
	  // parseFloat first because item.x and item.y can be percent string like '20%'
	
	  if (item && !hasXAndY(item) && !zrUtil.isArray(item.coord) && coordSys) {
	    var dims = coordSys.dimensions;
	    var axisInfo = getAxisInfo(item, data, coordSys, seriesModel); // Clone the option
	    // Transform the properties xAxis, yAxis, radiusAxis, angleAxis, geoCoord to value
	
	    item = zrUtil.clone(item);
	
	    if (item.type && markerTypeCalculator[item.type] && axisInfo.baseAxis && axisInfo.valueAxis) {
	      var otherCoordIndex = indexOf(dims, axisInfo.baseAxis.dim);
	      var targetCoordIndex = indexOf(dims, axisInfo.valueAxis.dim);
	      var coordInfo = markerTypeCalculator[item.type](data, axisInfo.baseDataDim, axisInfo.valueDataDim, otherCoordIndex, targetCoordIndex);
	      item.coord = coordInfo[0]; // Force to use the value of calculated value.
	      // let item use the value without stack.
	
	      item.value = coordInfo[1];
	    } else {
	      // FIXME Only has one of xAxis and yAxis.
	      var coord = [item.xAxis != null ? item.xAxis : item.radiusAxis, item.yAxis != null ? item.yAxis : item.angleAxis]; // Each coord support max, min, average
	
	      for (var i = 0; i < 2; i++) {
	        if (markerTypeCalculator[coord[i]]) {
	          coord[i] = numCalculate(data, data.mapDimension(dims[i]), coord[i]);
	        }
	      }
	
	      item.coord = coord;
	    }
	  }
	
	  return item;
	}
	
	function getAxisInfo(item, data, coordSys, seriesModel) {
	  var ret = {};
	
	  if (item.valueIndex != null || item.valueDim != null) {
	    ret.valueDataDim = item.valueIndex != null ? data.getDimension(item.valueIndex) : item.valueDim;
	    ret.valueAxis = coordSys.getAxis(dataDimToCoordDim(seriesModel, ret.valueDataDim));
	    ret.baseAxis = coordSys.getOtherAxis(ret.valueAxis);
	    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	  } else {
	    ret.baseAxis = seriesModel.getBaseAxis();
	    ret.valueAxis = coordSys.getOtherAxis(ret.baseAxis);
	    ret.baseDataDim = data.mapDimension(ret.baseAxis.dim);
	    ret.valueDataDim = data.mapDimension(ret.valueAxis.dim);
	  }
	
	  return ret;
	}
	
	function dataDimToCoordDim(seriesModel, dataDim) {
	  var data = seriesModel.getData();
	  var dimensions = data.dimensions;
	  dataDim = data.getDimension(dataDim);
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimItem = data.getDimensionInfo(dimensions[i]);
	
	    if (dimItem.name === dataDim) {
	      return dimItem.coordDim;
	    }
	  }
	}
	/**
	 * Filter data which is out of coordinateSystem range
	 * [dataFilter description]
	 * @param  {module:echarts/coord/*} [coordSys]
	 * @param  {Object} item
	 * @return {boolean}
	 */
	
	
	function dataFilter(coordSys, item) {
	  // Alwalys return true if there is no coordSys
	  return coordSys && coordSys.containData && item.coord && !hasXOrY(item) ? coordSys.containData(item.coord) : true;
	}
	
	function dimValueGetter(item, dimName, dataIndex, dimIndex) {
	  // x, y, radius, angle
	  if (dimIndex < 2) {
	    return item.coord && item.coord[dimIndex];
	  }
	
	  return item.value;
	}
	
	function numCalculate(data, valueDataDim, type) {
	  if (type === 'average') {
	    var sum = 0;
	    var count = 0;
	    data.each(valueDataDim, function (val, idx) {
	      if (!isNaN(val)) {
	        sum += val;
	        count++;
	      }
	    });
	    return sum / count;
	  } else if (type === 'median') {
	    return data.getMedian(valueDataDim);
	  } else {
	    // max & min
	    return data.getDataExtent(valueDataDim, true)[type === 'max' ? 1 : 0];
	  }
	}
	
	exports.dataTransform = dataTransform;
	exports.getAxisInfo = getAxisInfo;
	exports.dataFilter = dataFilter;
	exports.dimValueGetter = dimValueGetter;
	exports.numCalculate = numCalculate;

/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var vector = __webpack_require__(55);
	
	var matrix = __webpack_require__(86);
	
	var BoundingRect = __webpack_require__(60);
	
	var Transformable = __webpack_require__(396);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Simple view coordinate system
	 * Mapping given x, y to transformd view x, y
	 */
	var v2ApplyTransform = vector.applyTransform; // Dummy transform node
	
	function TransformDummy() {
	  Transformable.call(this);
	}
	
	zrUtil.mixin(TransformDummy, Transformable);
	
	function View(name) {
	  /**
	   * @type {string}
	   */
	  this.name = name;
	  /**
	   * @type {Object}
	   */
	
	  this.zoomLimit;
	  Transformable.call(this);
	  this._roamTransformable = new TransformDummy();
	  this._rawTransformable = new TransformDummy();
	  this._center;
	  this._zoom;
	}
	
	View.prototype = {
	  constructor: View,
	  type: 'view',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Set bounding rect
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  // PENDING to getRect
	  setBoundingRect: function (x, y, width, height) {
	    this._rect = new BoundingRect(x, y, width, height);
	    return this._rect;
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  // PENDING to getRect
	  getBoundingRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  setViewRect: function (x, y, width, height) {
	    this.transformTo(x, y, width, height);
	    this._viewRect = new BoundingRect(x, y, width, height);
	  },
	
	  /**
	   * Transformed to particular position and size
	   * @param {number} x
	   * @param {number} y
	   * @param {number} width
	   * @param {number} height
	   */
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var rawTransform = this._rawTransformable;
	    rawTransform.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    rawTransform.decomposeTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * Set center of view
	   * @param {Array.<number>} [centerCoord]
	   */
	  setCenter: function (centerCoord) {
	    if (!centerCoord) {
	      return;
	    }
	
	    this._center = centerCoord;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * @param {number} zoom
	   */
	  setZoom: function (zoom) {
	    zoom = zoom || 1;
	    var zoomLimit = this.zoomLimit;
	
	    if (zoomLimit) {
	      if (zoomLimit.max != null) {
	        zoom = Math.min(zoomLimit.max, zoom);
	      }
	
	      if (zoomLimit.min != null) {
	        zoom = Math.max(zoomLimit.min, zoom);
	      }
	    }
	
	    this._zoom = zoom;
	
	    this._updateCenterAndZoom();
	  },
	
	  /**
	   * Get default center without roam
	   */
	  getDefaultCenter: function () {
	    // Rect before any transform
	    var rawRect = this.getBoundingRect();
	    var cx = rawRect.x + rawRect.width / 2;
	    var cy = rawRect.y + rawRect.height / 2;
	    return [cx, cy];
	  },
	  getCenter: function () {
	    return this._center || this.getDefaultCenter();
	  },
	  getZoom: function () {
	    return this._zoom || 1;
	  },
	
	  /**
	   * @return {Array.<number}
	   */
	  getRoamTransform: function () {
	    return this._roamTransformable.getLocalTransform();
	  },
	
	  /**
	   * Remove roam
	   */
	  _updateCenterAndZoom: function () {
	    // Must update after view transform updated
	    var rawTransformMatrix = this._rawTransformable.getLocalTransform();
	
	    var roamTransform = this._roamTransformable;
	    var defaultCenter = this.getDefaultCenter();
	    var center = this.getCenter();
	    var zoom = this.getZoom();
	    center = vector.applyTransform([], center, rawTransformMatrix);
	    defaultCenter = vector.applyTransform([], defaultCenter, rawTransformMatrix);
	    roamTransform.origin = center;
	    roamTransform.position = [defaultCenter[0] - center[0], defaultCenter[1] - center[1]];
	    roamTransform.scale = [zoom, zoom];
	
	    this._updateTransform();
	  },
	
	  /**
	   * Update transform from roam and mapLocation
	   * @private
	   */
	  _updateTransform: function () {
	    var roamTransformable = this._roamTransformable;
	    var rawTransformable = this._rawTransformable;
	    rawTransformable.parent = roamTransformable;
	    roamTransformable.updateTransform();
	    rawTransformable.updateTransform();
	    matrix.copy(this.transform || (this.transform = []), rawTransformable.transform || matrix.create());
	    this._rawTransform = rawTransformable.getLocalTransform();
	    this.invTransform = this.invTransform || [];
	    matrix.invert(this.invTransform, this.transform);
	    this.decomposeTransform();
	  },
	  getTransformInfo: function () {
	    var roamTransform = this._roamTransformable.transform;
	    var rawTransformable = this._rawTransformable;
	    return {
	      roamTransform: roamTransform ? zrUtil.slice(roamTransform) : matrix.create(),
	      rawScale: zrUtil.slice(rawTransformable.scale),
	      rawPosition: zrUtil.slice(rawTransformable.position)
	    };
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRect: function () {
	    return this._viewRect;
	  },
	
	  /**
	   * Get view rect after roam transform
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getViewRectAfterRoam: function () {
	    var rect = this.getBoundingRect().clone();
	    rect.applyTransform(this.transform);
	    return rect;
	  },
	
	  /**
	   * Convert a single (lon, lat) data item to (x, y) point.
	   * @param {Array.<number>} data
	   * @param {boolean} noRoam
	   * @param {Array.<number>} [out]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, noRoam, out) {
	    var transform = noRoam ? this._rawTransform : this.transform;
	    out = out || [];
	    return transform ? v2ApplyTransform(out, data, transform) : vector.copy(out, data);
	  },
	
	  /**
	   * Convert a (x, y) point to (lon, lat) data
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var invTransform = this.invTransform;
	    return invTransform ? v2ApplyTransform([], point, invTransform) : [point[0], point[1]];
	  },
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * @implements
	   * see {module:echarts/CoodinateSystem}
	   */
	  containPoint: function (point) {
	    return this.getViewRectAfterRoam().contain(point[0], point[1]);
	  }
	  /**
	   * @return {number}
	   */
	  // getScalarScale: function () {
	  //     // Use determinant square root of transform to mutiply scalar
	  //     var m = this.transform;
	  //     var det = Math.sqrt(Math.abs(m[0] * m[3] - m[2] * m[1]));
	  //     return det;
	  // }
	
	};
	zrUtil.mixin(View, Transformable);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var seriesModel = finder.seriesModel;
	  var coordSys = seriesModel ? seriesModel.coordinateSystem : null; // e.g., graph.
	
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = View;
	module.exports = _default;

/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(4);
	
	var isObject = _util.isObject;
	var each = _util.each;
	var map = _util.map;
	var indexOf = _util.indexOf;
	var retrieve = _util.retrieve;
	
	var _layout = __webpack_require__(46);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _axisHelper = __webpack_require__(122);
	
	var createScaleByModel = _axisHelper.createScaleByModel;
	var ifAxisCrossZero = _axisHelper.ifAxisCrossZero;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	var estimateLabelUnionRect = _axisHelper.estimateLabelUnionRect;
	
	var Cartesian2D = __webpack_require__(2402);
	
	var Axis2D = __webpack_require__(2400);
	
	var CoordinateSystem = __webpack_require__(121);
	
	var _dataStackHelper = __webpack_require__(140);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	__webpack_require__(2403);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Grid is a region which contains at most 4 cartesian systems
	 *
	 * TODO Default cartesian
	 */
	// Depends on GridModel, AxisModel, which performs preprocess.
	
	/**
	 * Check if the axis is used in the specified grid
	 * @inner
	 */
	function isAxisUsedInTheGrid(axisModel, gridModel, ecModel) {
	  return axisModel.getCoordSysModel() === gridModel;
	}
	
	function Grid(gridModel, ecModel, api) {
	  /**
	   * @type {Object.<string, module:echarts/coord/cartesian/Cartesian2D>}
	   * @private
	   */
	  this._coordsMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Cartesian>}
	   * @private
	   */
	
	  this._coordsList = [];
	  /**
	   * @type {Object.<string, Array.<module:echarts/coord/cartesian/Axis2D>>}
	   * @private
	   */
	
	  this._axesMap = {};
	  /**
	   * @type {Array.<module:echarts/coord/cartesian/Axis2D>}
	   * @private
	   */
	
	  this._axesList = [];
	
	  this._initCartesian(gridModel, ecModel, api);
	
	  this.model = gridModel;
	}
	
	var gridProto = Grid.prototype;
	gridProto.type = 'grid';
	gridProto.axisPointerEnabled = true;
	
	gridProto.getRect = function () {
	  return this._rect;
	};
	
	gridProto.update = function (ecModel, api) {
	  var axesMap = this._axesMap;
	
	  this._updateScale(ecModel, this.model);
	
	  each(axesMap.x, function (xAxis) {
	    niceScaleExtent(xAxis.scale, xAxis.model);
	  });
	  each(axesMap.y, function (yAxis) {
	    niceScaleExtent(yAxis.scale, yAxis.model);
	  }); // Key: axisDim_axisIndex, value: boolean, whether onZero target.
	
	  var onZeroRecords = {};
	  each(axesMap.x, function (xAxis) {
	    fixAxisOnZero(axesMap, 'y', xAxis, onZeroRecords);
	  });
	  each(axesMap.y, function (yAxis) {
	    fixAxisOnZero(axesMap, 'x', yAxis, onZeroRecords);
	  }); // Resize again if containLabel is enabled
	  // FIXME It may cause getting wrong grid size in data processing stage
	
	  this.resize(this.model, api);
	};
	
	function fixAxisOnZero(axesMap, otherAxisDim, axis, onZeroRecords) {
	  axis.getAxesOnZeroOf = function () {
	    // TODO: onZero of multiple axes.
	    return otherAxisOnZeroOf ? [otherAxisOnZeroOf] : [];
	  }; // onZero can not be enabled in these two situations:
	  // 1. When any other axis is a category axis.
	  // 2. When no axis is cross 0 point.
	
	
	  var otherAxes = axesMap[otherAxisDim];
	  var otherAxisOnZeroOf;
	  var axisModel = axis.model;
	  var onZero = axisModel.get('axisLine.onZero');
	  var onZeroAxisIndex = axisModel.get('axisLine.onZeroAxisIndex');
	
	  if (!onZero) {
	    return;
	  } // If target axis is specified.
	
	
	  if (onZeroAxisIndex != null) {
	    if (canOnZeroToAxis(otherAxes[onZeroAxisIndex])) {
	      otherAxisOnZeroOf = otherAxes[onZeroAxisIndex];
	    }
	  } else {
	    // Find the first available other axis.
	    for (var idx in otherAxes) {
	      if (otherAxes.hasOwnProperty(idx) && canOnZeroToAxis(otherAxes[idx]) // Consider that two Y axes on one value axis,
	      // if both onZero, the two Y axes overlap.
	      && !onZeroRecords[getOnZeroRecordKey(otherAxes[idx])]) {
	        otherAxisOnZeroOf = otherAxes[idx];
	        break;
	      }
	    }
	  }
	
	  if (otherAxisOnZeroOf) {
	    onZeroRecords[getOnZeroRecordKey(otherAxisOnZeroOf)] = true;
	  }
	
	  function getOnZeroRecordKey(axis) {
	    return axis.dim + '_' + axis.index;
	  }
	}
	
	function canOnZeroToAxis(axis) {
	  return axis && axis.type !== 'category' && axis.type !== 'time' && ifAxisCrossZero(axis);
	}
	/**
	 * Resize the grid
	 * @param {module:echarts/coord/cartesian/GridModel} gridModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	gridProto.resize = function (gridModel, api, ignoreContainLabel) {
	  var gridRect = getLayoutRect(gridModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	  this._rect = gridRect;
	  var axesList = this._axesList;
	  adjustAxes(); // Minus label size
	
	  if (!ignoreContainLabel && gridModel.get('containLabel')) {
	    each(axesList, function (axis) {
	      if (!axis.model.get('axisLabel.inside')) {
	        var labelUnionRect = estimateLabelUnionRect(axis);
	
	        if (labelUnionRect) {
	          var dim = axis.isHorizontal() ? 'height' : 'width';
	          var margin = axis.model.get('axisLabel.margin');
	          gridRect[dim] -= labelUnionRect[dim] + margin;
	
	          if (axis.position === 'top') {
	            gridRect.y += labelUnionRect.height + margin;
	          } else if (axis.position === 'left') {
	            gridRect.x += labelUnionRect.width + margin;
	          }
	        }
	      }
	    });
	    adjustAxes();
	  }
	
	  function adjustAxes() {
	    each(axesList, function (axis) {
	      var isHorizontal = axis.isHorizontal();
	      var extent = isHorizontal ? [0, gridRect.width] : [0, gridRect.height];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(extent[idx], extent[1 - idx]);
	      updateAxisTransform(axis, isHorizontal ? gridRect.x : gridRect.y);
	    });
	  }
	};
	/**
	 * @param {string} axisType
	 * @param {number} [axisIndex]
	 */
	
	
	gridProto.getAxis = function (axisType, axisIndex) {
	  var axesMapOnDim = this._axesMap[axisType];
	
	  if (axesMapOnDim != null) {
	    if (axisIndex == null) {
	      // Find first axis
	      for (var name in axesMapOnDim) {
	        if (axesMapOnDim.hasOwnProperty(name)) {
	          return axesMapOnDim[name];
	        }
	      }
	    }
	
	    return axesMapOnDim[axisIndex];
	  }
	};
	/**
	 * @return {Array.<module:echarts/coord/Axis>}
	 */
	
	
	gridProto.getAxes = function () {
	  return this._axesList.slice();
	};
	/**
	 * Usage:
	 *      grid.getCartesian(xAxisIndex, yAxisIndex);
	 *      grid.getCartesian(xAxisIndex);
	 *      grid.getCartesian(null, yAxisIndex);
	 *      grid.getCartesian({xAxisIndex: ..., yAxisIndex: ...});
	 *
	 * @param {number|Object} [xAxisIndex]
	 * @param {number} [yAxisIndex]
	 */
	
	
	gridProto.getCartesian = function (xAxisIndex, yAxisIndex) {
	  if (xAxisIndex != null && yAxisIndex != null) {
	    var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	    return this._coordsMap[key];
	  }
	
	  if (isObject(xAxisIndex)) {
	    yAxisIndex = xAxisIndex.yAxisIndex;
	    xAxisIndex = xAxisIndex.xAxisIndex;
	  } // When only xAxisIndex or yAxisIndex given, find its first cartesian.
	
	
	  for (var i = 0, coordList = this._coordsList; i < coordList.length; i++) {
	    if (coordList[i].getAxis('x').index === xAxisIndex || coordList[i].getAxis('y').index === yAxisIndex) {
	      return coordList[i];
	    }
	  }
	};
	
	gridProto.getCartesians = function () {
	  return this._coordsList.slice();
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertToPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.dataToPoint(value) : target.axis ? target.axis.toGlobalCoord(target.axis.dataToCoord(value)) : null;
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.convertFromPixel = function (ecModel, finder, value) {
	  var target = this._findConvertTarget(ecModel, finder);
	
	  return target.cartesian ? target.cartesian.pointToData(value) : target.axis ? target.axis.coordToData(target.axis.toLocalCoord(value)) : null;
	};
	/**
	 * @inner
	 */
	
	
	gridProto._findConvertTarget = function (ecModel, finder) {
	  var seriesModel = finder.seriesModel;
	  var xAxisModel = finder.xAxisModel || seriesModel && seriesModel.getReferringComponents('xAxis')[0];
	  var yAxisModel = finder.yAxisModel || seriesModel && seriesModel.getReferringComponents('yAxis')[0];
	  var gridModel = finder.gridModel;
	  var coordsList = this._coordsList;
	  var cartesian;
	  var axis;
	
	  if (seriesModel) {
	    cartesian = seriesModel.coordinateSystem;
	    indexOf(coordsList, cartesian) < 0 && (cartesian = null);
	  } else if (xAxisModel && yAxisModel) {
	    cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  } else if (xAxisModel) {
	    axis = this.getAxis('x', xAxisModel.componentIndex);
	  } else if (yAxisModel) {
	    axis = this.getAxis('y', yAxisModel.componentIndex);
	  } // Lowest priority.
	  else if (gridModel) {
	      var grid = gridModel.coordinateSystem;
	
	      if (grid === this) {
	        cartesian = this._coordsList[0];
	      }
	    }
	
	  return {
	    cartesian: cartesian,
	    axis: axis
	  };
	};
	/**
	 * @implements
	 * see {module:echarts/CoodinateSystem}
	 */
	
	
	gridProto.containPoint = function (point) {
	  var coord = this._coordsList[0];
	
	  if (coord) {
	    return coord.containPoint(point);
	  }
	};
	/**
	 * Initialize cartesian coordinate systems
	 * @private
	 */
	
	
	gridProto._initCartesian = function (gridModel, ecModel, api) {
	  var axisPositionUsed = {
	    left: false,
	    right: false,
	    top: false,
	    bottom: false
	  };
	  var axesMap = {
	    x: {},
	    y: {}
	  };
	  var axesCount = {
	    x: 0,
	    y: 0
	  }; /// Create axis
	
	  ecModel.eachComponent('xAxis', createAxisCreator('x'), this);
	  ecModel.eachComponent('yAxis', createAxisCreator('y'), this);
	
	  if (!axesCount.x || !axesCount.y) {
	    // Roll back when there no either x or y axis
	    this._axesMap = {};
	    this._axesList = [];
	    return;
	  }
	
	  this._axesMap = axesMap; /// Create cartesian2d
	
	  each(axesMap.x, function (xAxis, xAxisIndex) {
	    each(axesMap.y, function (yAxis, yAxisIndex) {
	      var key = 'x' + xAxisIndex + 'y' + yAxisIndex;
	      var cartesian = new Cartesian2D(key);
	      cartesian.grid = this;
	      cartesian.model = gridModel;
	      this._coordsMap[key] = cartesian;
	
	      this._coordsList.push(cartesian);
	
	      cartesian.addAxis(xAxis);
	      cartesian.addAxis(yAxis);
	    }, this);
	  }, this);
	
	  function createAxisCreator(axisType) {
	    return function (axisModel, idx) {
	      if (!isAxisUsedInTheGrid(axisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var axisPosition = axisModel.get('position');
	
	      if (axisType === 'x') {
	        // Fix position
	        if (axisPosition !== 'top' && axisPosition !== 'bottom') {
	          // Default bottom of X
	          axisPosition = axisPositionUsed.bottom ? 'top' : 'bottom';
	        }
	      } else {
	        // Fix position
	        if (axisPosition !== 'left' && axisPosition !== 'right') {
	          // Default left of Y
	          axisPosition = axisPositionUsed.left ? 'right' : 'left';
	        }
	      }
	
	      axisPositionUsed[axisPosition] = true;
	      var axis = new Axis2D(axisType, createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisPosition);
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse'); // Inject axis into axisModel
	
	      axisModel.axis = axis; // Inject axisModel into axis
	
	      axis.model = axisModel; // Inject grid info axis
	
	      axis.grid = this; // Index of axis, can be used as key
	
	      axis.index = idx;
	
	      this._axesList.push(axis);
	
	      axesMap[axisType][idx] = axis;
	      axesCount[axisType]++;
	    };
	  }
	};
	/**
	 * Update cartesian properties from series
	 * @param  {module:echarts/model/Option} option
	 * @private
	 */
	
	
	gridProto._updateScale = function (ecModel, gridModel) {
	  // Reset scale
	  each(this._axesList, function (axis) {
	    axis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (isCartesian2D(seriesModel)) {
	      var axesModels = findAxesModels(seriesModel, ecModel);
	      var xAxisModel = axesModels[0];
	      var yAxisModel = axesModels[1];
	
	      if (!isAxisUsedInTheGrid(xAxisModel, gridModel, ecModel) || !isAxisUsedInTheGrid(yAxisModel, gridModel, ecModel)) {
	        return;
	      }
	
	      var cartesian = this.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	      var data = seriesModel.getData();
	      var xAxis = cartesian.getAxis('x');
	      var yAxis = cartesian.getAxis('y');
	
	      if (data.type === 'list') {
	        unionExtent(data, xAxis, seriesModel);
	        unionExtent(data, yAxis, seriesModel);
	      }
	    }
	  }, this);
	
	  function unionExtent(data, axis, seriesModel) {
	    each(data.mapDimension(axis.dim, true), function (dim) {
	      axis.scale.unionExtentFromData( // For example, the extent of the orginal dimension
	      // is [0.1, 0.5], the extent of the `stackResultDimension`
	      // is [7, 9], the final extent should not include [0.1, 0.5].
	      data, getStackedDimension(data, dim));
	    });
	  }
	};
	/**
	 * @param {string} [dim] 'x' or 'y' or 'auto' or null/undefined
	 * @return {Object} {baseAxes: [], otherAxes: []}
	 */
	
	
	gridProto.getTooltipAxes = function (dim) {
	  var baseAxes = [];
	  var otherAxes = [];
	  each(this.getCartesians(), function (cartesian) {
	    var baseAxis = dim != null && dim !== 'auto' ? cartesian.getAxis(dim) : cartesian.getBaseAxis();
	    var otherAxis = cartesian.getOtherAxis(baseAxis);
	    indexOf(baseAxes, baseAxis) < 0 && baseAxes.push(baseAxis);
	    indexOf(otherAxes, otherAxis) < 0 && otherAxes.push(otherAxis);
	  });
	  return {
	    baseAxes: baseAxes,
	    otherAxes: otherAxes
	  };
	};
	/**
	 * @inner
	 */
	
	
	function updateAxisTransform(axis, coordBase) {
	  var axisExtent = axis.getExtent();
	  var axisExtentSum = axisExtent[0] + axisExtent[1]; // Fast transform
	
	  axis.toGlobalCoord = axis.dim === 'x' ? function (coord) {
	    return coord + coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	  axis.toLocalCoord = axis.dim === 'x' ? function (coord) {
	    return coord - coordBase;
	  } : function (coord) {
	    return axisExtentSum - coord + coordBase;
	  };
	}
	
	var axesTypes = ['xAxis', 'yAxis'];
	/**
	 * @inner
	 */
	
	function findAxesModels(seriesModel, ecModel) {
	  return map(axesTypes, function (axisType) {
	    var axisModel = seriesModel.getReferringComponents(axisType)[0];
	    return axisModel;
	  });
	}
	/**
	 * @inner
	 */
	
	
	function isCartesian2D(seriesModel) {
	  return seriesModel.get('coordinateSystem') === 'cartesian2d';
	}
	
	Grid.create = function (ecModel, api) {
	  var grids = [];
	  ecModel.eachComponent('grid', function (gridModel, idx) {
	    var grid = new Grid(gridModel, ecModel, api);
	    grid.name = 'grid_' + idx; // dataSampling requires axis extent, so resize
	    // should be performed in create stage.
	
	    grid.resize(gridModel, api, true);
	    gridModel.coordinateSystem = grid;
	    grids.push(grid);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (!isCartesian2D(seriesModel)) {
	      return;
	    }
	
	    var axesModels = findAxesModels(seriesModel, ecModel);
	    var xAxisModel = axesModels[0];
	    var yAxisModel = axesModels[1];
	    var gridModel = xAxisModel.getCoordSysModel();
	    var grid = gridModel.coordinateSystem;
	    seriesModel.coordinateSystem = grid.getCartesian(xAxisModel.componentIndex, yAxisModel.componentIndex);
	  });
	  return grids;
	}; // For deciding which dimensions to use when creating list data
	
	
	Grid.dimensions = Grid.prototype.dimensions = Cartesian2D.prototype.dimensions;
	CoordinateSystem.register('cartesian2d', Grid);
	var _default = Grid;
	module.exports = _default;

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var Geo = __webpack_require__(2405);
	
	var layout = __webpack_require__(46);
	
	var numberUtil = __webpack_require__(25);
	
	var geoSourceManager = __webpack_require__(358);
	
	var mapDataStorage = __webpack_require__(514);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Resize method bound to the geo
	 * @param {module:echarts/coord/geo/GeoModel|module:echarts/chart/map/MapModel} geoModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizeGeo(geoModel, api) {
	  var boundingCoords = geoModel.get('boundingCoords');
	
	  if (boundingCoords != null) {
	    var leftTop = boundingCoords[0];
	    var rightBottom = boundingCoords[1];
	
	    if (isNaN(leftTop[0]) || isNaN(leftTop[1]) || isNaN(rightBottom[0]) || isNaN(rightBottom[1])) {} else {
	      this.setBoundingRect(leftTop[0], leftTop[1], rightBottom[0] - leftTop[0], rightBottom[1] - leftTop[1]);
	    }
	  }
	
	  var rect = this.getBoundingRect();
	  var boxLayoutOption;
	  var center = geoModel.get('layoutCenter');
	  var size = geoModel.get('layoutSize');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var aspect = rect.width / rect.height * this.aspectScale;
	  var useCenterAndSize = false;
	
	  if (center && size) {
	    center = [numberUtil.parsePercent(center[0], viewWidth), numberUtil.parsePercent(center[1], viewHeight)];
	    size = numberUtil.parsePercent(size, Math.min(viewWidth, viewHeight));
	
	    if (!isNaN(center[0]) && !isNaN(center[1]) && !isNaN(size)) {
	      useCenterAndSize = true;
	    } else {}
	  }
	
	  var viewRect;
	
	  if (useCenterAndSize) {
	    var viewRect = {};
	
	    if (aspect > 1) {
	      // Width is same with size
	      viewRect.width = size;
	      viewRect.height = size / aspect;
	    } else {
	      viewRect.height = size;
	      viewRect.width = size * aspect;
	    }
	
	    viewRect.y = center[1] - viewRect.height / 2;
	    viewRect.x = center[0] - viewRect.width / 2;
	  } else {
	    // Use left/top/width/height
	    boxLayoutOption = geoModel.getBoxLayoutParams(); // 0.75 rate
	
	    boxLayoutOption.aspect = aspect;
	    viewRect = layout.getLayoutRect(boxLayoutOption, {
	      width: viewWidth,
	      height: viewHeight
	    });
	  }
	
	  this.setViewRect(viewRect.x, viewRect.y, viewRect.width, viewRect.height);
	  this.setCenter(geoModel.get('center'));
	  this.setZoom(geoModel.get('zoom'));
	}
	/**
	 * @param {module:echarts/coord/Geo} geo
	 * @param {module:echarts/model/Model} model
	 * @inner
	 */
	
	
	function setGeoCoords(geo, model) {
	  zrUtil.each(model.get('geoCoord'), function (geoCoord, name) {
	    geo.addGeoCoord(name, geoCoord);
	  });
	}
	
	var geoCreator = {
	  // For deciding which dimensions to use when creating list data
	  dimensions: Geo.prototype.dimensions,
	  create: function (ecModel, api) {
	    var geoList = []; // FIXME Create each time may be slow
	
	    ecModel.eachComponent('geo', function (geoModel, idx) {
	      var name = geoModel.get('map');
	      var aspectScale = geoModel.get('aspectScale');
	      var invertLongitute = true;
	      var mapRecords = mapDataStorage.retrieveMap(name);
	
	      if (mapRecords && mapRecords[0] && mapRecords[0].type === 'svg') {
	        aspectScale == null && (aspectScale = 1);
	        invertLongitute = false;
	      } else {
	        aspectScale == null && (aspectScale = 0.75);
	      }
	
	      var geo = new Geo(name + idx, name, geoModel.get('nameMap'), invertLongitute);
	      geo.aspectScale = aspectScale;
	      geo.zoomLimit = geoModel.get('scaleLimit');
	      geoList.push(geo);
	      setGeoCoords(geo, geoModel);
	      geoModel.coordinateSystem = geo;
	      geo.model = geoModel; // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.resize(geoModel, api);
	    });
	    ecModel.eachSeries(function (seriesModel) {
	      var coordSys = seriesModel.get('coordinateSystem');
	
	      if (coordSys === 'geo') {
	        var geoIndex = seriesModel.get('geoIndex') || 0;
	        seriesModel.coordinateSystem = geoList[geoIndex];
	      }
	    }); // If has map series
	
	    var mapModelGroupBySeries = {};
	    ecModel.eachSeriesByType('map', function (seriesModel) {
	      if (!seriesModel.getHostGeoModel()) {
	        var mapType = seriesModel.getMapType();
	        mapModelGroupBySeries[mapType] = mapModelGroupBySeries[mapType] || [];
	        mapModelGroupBySeries[mapType].push(seriesModel);
	      }
	    });
	    zrUtil.each(mapModelGroupBySeries, function (mapSeries, mapType) {
	      var nameMapList = zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('nameMap');
	      });
	      var geo = new Geo(mapType, mapType, zrUtil.mergeAll(nameMapList));
	      geo.zoomLimit = zrUtil.retrieve.apply(null, zrUtil.map(mapSeries, function (singleMapSeries) {
	        return singleMapSeries.get('scaleLimit');
	      }));
	      geoList.push(geo); // Inject resize method
	
	      geo.resize = resizeGeo;
	      geo.aspectScale = mapSeries[0].get('aspectScale');
	      geo.resize(mapSeries[0], api);
	      zrUtil.each(mapSeries, function (singleMapSeries) {
	        singleMapSeries.coordinateSystem = geo;
	        setGeoCoords(geo, singleMapSeries);
	      });
	    });
	    return geoList;
	  },
	
	  /**
	   * Fill given regions array
	   * @param  {Array.<Object>} originRegionArr
	   * @param  {string} mapName
	   * @param  {Object} [nameMap]
	   * @return {Array}
	   */
	  getFilledRegions: function (originRegionArr, mapName, nameMap) {
	    // Not use the original
	    var regionsArr = (originRegionArr || []).slice();
	    var dataNameMap = zrUtil.createHashMap();
	
	    for (var i = 0; i < regionsArr.length; i++) {
	      dataNameMap.set(regionsArr[i].name, regionsArr[i]);
	    }
	
	    var source = geoSourceManager.load(mapName, nameMap);
	    zrUtil.each(source.regions, function (region) {
	      var name = region.name;
	      !dataNameMap.get(name) && regionsArr.push({
	        name: name
	      });
	    });
	    return regionsArr;
	  }
	};
	echarts.registerCoordinateSystem('geo', geoCreator);
	var _default = geoCreator;
	module.exports = _default;

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(4);
	
	var createHashMap = _util.createHashMap;
	var isString = _util.isString;
	var isArray = _util.isArray;
	var each = _util.each;
	var assert = _util.assert;
	
	var _parseSVG = __webpack_require__(1208);
	
	var parseXML = _parseSVG.parseXML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var storage = createHashMap(); // For minimize the code size of common echarts package,
	// do not put too much logic in this module.
	
	var _default = {
	  // The format of record: see `echarts.registerMap`.
	  // Compatible with previous `echarts.registerMap`.
	  registerMap: function (mapName, rawGeoJson, rawSpecialAreas) {
	    var records;
	
	    if (isArray(rawGeoJson)) {
	      records = rawGeoJson;
	    } else if (rawGeoJson.svg) {
	      records = [{
	        type: 'svg',
	        source: rawGeoJson.svg,
	        specialAreas: rawGeoJson.specialAreas
	      }];
	    } else {
	      // Backward compatibility.
	      if (rawGeoJson.geoJson && !rawGeoJson.features) {
	        rawSpecialAreas = rawGeoJson.specialAreas;
	        rawGeoJson = rawGeoJson.geoJson;
	      }
	
	      records = [{
	        type: 'geoJSON',
	        source: rawGeoJson,
	        specialAreas: rawSpecialAreas
	      }];
	    }
	
	    each(records, function (record) {
	      var type = record.type;
	      type === 'geoJson' && (type = record.type = 'geoJSON');
	      var parse = parsers[type];
	      parse(record);
	    });
	    return storage.set(mapName, records);
	  },
	  retrieveMap: function (mapName) {
	    return storage.get(mapName);
	  }
	};
	var parsers = {
	  geoJSON: function (record) {
	    var source = record.source;
	    record.geoJSON = !isString(source) ? source : typeof JSON !== 'undefined' && JSON.parse ? JSON.parse(source) : new Function('return (' + source + ');')();
	  },
	  // Only perform parse to XML object here, which might be time
	  // consiming for large SVG.
	  // Although convert XML to zrender element is also time consiming,
	  // if we do it here, the clone of zrender elements has to be
	  // required. So we do it once for each geo instance, util real
	  // performance issues call for optimizing it.
	  svg: function (record) {
	    record.svgXML = parseXML(record.source);
	  }
	};
	module.exports = _default;

/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(4);
	
	var Polar = __webpack_require__(2421);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	var _axisHelper = __webpack_require__(122);
	
	var createScaleByModel = _axisHelper.createScaleByModel;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(121);
	
	var _dataStackHelper = __webpack_require__(140);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	__webpack_require__(2422);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Axis scale
	
	/**
	 * Resize method bound to the polar
	 * @param {module:echarts/coord/polar/PolarModel} polarModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function resizePolar(polar, polarModel, api) {
	  var center = polarModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  polar.cx = parsePercent(center[0], width);
	  polar.cy = parsePercent(center[1], height);
	  var radiusAxis = polar.getRadiusAxis();
	  var size = Math.min(width, height) / 2;
	  var radius = polarModel.get('radius');
	
	  if (radius == null) {
	    radius = [0, '100%'];
	  } else if (!zrUtil.isArray(radius)) {
	    // r0 = 0
	    radius = [0, radius];
	  }
	
	  radius = [parsePercent(radius[0], size), parsePercent(radius[1], size)];
	  radiusAxis.inverse ? radiusAxis.setExtent(radius[1], radius[0]) : radiusAxis.setExtent(radius[0], radius[1]);
	}
	/**
	 * Update polar
	 */
	
	
	function updatePolarScale(ecModel, api) {
	  var polar = this;
	  var angleAxis = polar.getAngleAxis();
	  var radiusAxis = polar.getRadiusAxis(); // Reset scale
	
	  angleAxis.scale.setExtent(Infinity, -Infinity);
	  radiusAxis.scale.setExtent(Infinity, -Infinity);
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.coordinateSystem === polar) {
	      var data = seriesModel.getData();
	      zrUtil.each(data.mapDimension('radius', true), function (dim) {
	        radiusAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
	      });
	      zrUtil.each(data.mapDimension('angle', true), function (dim) {
	        angleAxis.scale.unionExtentFromData(data, getStackedDimension(data, dim));
	      });
	    }
	  });
	  niceScaleExtent(angleAxis.scale, angleAxis.model);
	  niceScaleExtent(radiusAxis.scale, radiusAxis.model); // Fix extent of category angle axis
	
	  if (angleAxis.type === 'category' && !angleAxis.onBand) {
	    var extent = angleAxis.getExtent();
	    var diff = 360 / angleAxis.scale.count();
	    angleAxis.inverse ? extent[1] += diff : extent[1] -= diff;
	    angleAxis.setExtent(extent[0], extent[1]);
	  }
	}
	/**
	 * Set common axis properties
	 * @param {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	 * @param {module:echarts/coord/polar/AxisModel}
	 * @inner
	 */
	
	
	function setAxis(axis, axisModel) {
	  axis.type = axisModel.get('type');
	  axis.scale = createScaleByModel(axisModel);
	  axis.onBand = axisModel.get('boundaryGap') && axis.type === 'category';
	  axis.inverse = axisModel.get('inverse');
	
	  if (axisModel.mainType === 'angleAxis') {
	    axis.inverse ^= axisModel.get('clockwise');
	    var startAngle = axisModel.get('startAngle');
	    axis.setExtent(startAngle, startAngle + (axis.inverse ? -360 : 360));
	  } // Inject axis instance
	
	
	  axisModel.axis = axis;
	  axis.model = axisModel;
	}
	
	var polarCreator = {
	  dimensions: Polar.prototype.dimensions,
	  create: function (ecModel, api) {
	    var polarList = [];
	    ecModel.eachComponent('polar', function (polarModel, idx) {
	      var polar = new Polar(idx); // Inject resize and update method
	
	      polar.update = updatePolarScale;
	      var radiusAxis = polar.getRadiusAxis();
	      var angleAxis = polar.getAngleAxis();
	      var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	      var angleAxisModel = polarModel.findAxisModel('angleAxis');
	      setAxis(radiusAxis, radiusAxisModel);
	      setAxis(angleAxis, angleAxisModel);
	      resizePolar(polar, polarModel, api);
	      polarList.push(polar);
	      polarModel.coordinateSystem = polar;
	      polar.model = polarModel;
	    }); // Inject coordinateSystem to series
	
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.get('coordinateSystem') === 'polar') {
	        var polarModel = ecModel.queryComponents({
	          mainType: 'polar',
	          index: seriesModel.get('polarIndex'),
	          id: seriesModel.get('polarId')
	        })[0];
	        seriesModel.coordinateSystem = polarModel.coordinateSystem;
	      }
	    });
	    return polarList;
	  }
	};
	CoordinateSystem.register('polar', polarCreator);

/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var linkList = __webpack_require__(872);
	
	var List = __webpack_require__(109);
	
	var createDimensions = __webpack_require__(251);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Tree data structure
	 *
	 * @module echarts/data/Tree
	 */
	
	/**
	 * @constructor module:echarts/data/Tree~TreeNode
	 * @param {string} name
	 * @param {module:echarts/data/Tree} hostTree
	 */
	var TreeNode = function (name, hostTree) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * Depth of node
	   *
	   * @type {number}
	   * @readOnly
	   */
	
	  this.depth = 0;
	  /**
	   * Height of the subtree rooted at this node.
	   * @type {number}
	   * @readOnly
	   */
	
	  this.height = 0;
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	
	  this.parentNode = null;
	  /**
	   * Reference to list item.
	   * Do not persistent dataIndex outside,
	   * besause it may be changed by list.
	   * If dataIndex -1,
	   * this node is logical deleted (filtered) in list.
	   *
	   * @type {Object}
	   * @readOnly
	   */
	
	  this.dataIndex = -1;
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @readOnly
	   */
	
	  this.children = [];
	  /**
	   * @type {Array.<module:echarts/data/Tree~TreeNode>}
	   * @pubilc
	   */
	
	  this.viewChildren = [];
	  /**
	   * @type {moduel:echarts/data/Tree}
	   * @readOnly
	   */
	
	  this.hostTree = hostTree;
	};
	
	TreeNode.prototype = {
	  constructor: TreeNode,
	
	  /**
	   * The node is removed.
	   * @return {boolean} is removed.
	   */
	  isRemoved: function () {
	    return this.dataIndex < 0;
	  },
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb If in preorder and return false,
	   *                      its subtree will not be visited.
	   * @param {Object} [context]
	   */
	  eachNode: function (options, cb, context) {
	    if (typeof options === 'function') {
	      context = cb;
	      cb = options;
	      options = null;
	    }
	
	    options = options || {};
	
	    if (zrUtil.isString(options)) {
	      options = {
	        order: options
	      };
	    }
	
	    var order = options.order || 'preorder';
	    var children = this[options.attr || 'children'];
	    var suppressVisitSub;
	    order === 'preorder' && (suppressVisitSub = cb.call(context, this));
	
	    for (var i = 0; !suppressVisitSub && i < children.length; i++) {
	      children[i].eachNode(options, cb, context);
	    }
	
	    order === 'postorder' && cb.call(context, this);
	  },
	
	  /**
	   * Update depth and height of this subtree.
	   *
	   * @param  {number} depth
	   */
	  updateDepthAndHeight: function (depth) {
	    var height = 0;
	    this.depth = depth;
	
	    for (var i = 0; i < this.children.length; i++) {
	      var child = this.children[i];
	      child.updateDepthAndHeight(depth + 1);
	
	      if (child.height > height) {
	        height = child.height;
	      }
	    }
	
	    this.height = height + 1;
	  },
	
	  /**
	   * @param  {string} id
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeById: function (id) {
	    if (this.getId() === id) {
	      return this;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].getNodeById(id);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~TreeNode} node
	   * @return {boolean}
	   */
	  contains: function (node) {
	    if (node === this) {
	      return true;
	    }
	
	    for (var i = 0, children = this.children, len = children.length; i < len; i++) {
	      var res = children[i].contains(node);
	
	      if (res) {
	        return res;
	      }
	    }
	  },
	
	  /**
	   * @param {boolean} includeSelf Default false.
	   * @return {Array.<module:echarts/data/Tree~TreeNode>} order: [root, child, grandchild, ...]
	   */
	  getAncestors: function (includeSelf) {
	    var ancestors = [];
	    var node = includeSelf ? this : this.parentNode;
	
	    while (node) {
	      ancestors.push(node);
	      node = node.parentNode;
	    }
	
	    ancestors.reverse();
	    return ancestors;
	  },
	
	  /**
	   * @param {string|Array=} [dimension='value'] Default 'value'. can be 0, 1, 2, 3
	   * @return {number} Value.
	   */
	  getValue: function (dimension) {
	    var data = this.hostTree.data;
	    return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	  },
	
	  /**
	   * @param {Object} layout
	   * @param {boolean=} [merge=false]
	   */
	  setLayout: function (layout, merge) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemLayout(this.dataIndex, layout, merge);
	  },
	
	  /**
	   * @return {Object} layout
	   */
	  getLayout: function () {
	    return this.hostTree.data.getItemLayout(this.dataIndex);
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var hostTree = this.hostTree;
	    var itemModel = hostTree.data.getItemModel(this.dataIndex);
	    return itemModel.getModel(path);
	  },
	
	  /**
	   * @example
	   *  setItemVisual('color', color);
	   *  setItemVisual({
	   *      'color': color
	   *  });
	   */
	  setVisual: function (key, value) {
	    this.dataIndex >= 0 && this.hostTree.data.setItemVisual(this.dataIndex, key, value);
	  },
	
	  /**
	   * Get item visual
	   */
	  getVisual: function (key, ignoreParent) {
	    return this.hostTree.data.getItemVisual(this.dataIndex, key, ignoreParent);
	  },
	
	  /**
	   * @public
	   * @return {number}
	   */
	  getRawIndex: function () {
	    return this.hostTree.data.getRawIndex(this.dataIndex);
	  },
	
	  /**
	   * @public
	   * @return {string}
	   */
	  getId: function () {
	    return this.hostTree.data.getId(this.dataIndex);
	  },
	
	  /**
	   * if this is an ancestor of another node
	   *
	   * @public
	   * @param {TreeNode} node another node
	   * @return {boolean} if is ancestor
	   */
	  isAncestorOf: function (node) {
	    var parent = node.parentNode;
	
	    while (parent) {
	      if (parent === this) {
	        return true;
	      }
	
	      parent = parent.parentNode;
	    }
	
	    return false;
	  },
	
	  /**
	   * if this is an descendant of another node
	   *
	   * @public
	   * @param {TreeNode} node another node
	   * @return {boolean} if is descendant
	   */
	  isDescendantOf: function (node) {
	    return node !== this && node.isAncestorOf(this);
	  }
	};
	/**
	 * @constructor
	 * @alias module:echarts/data/Tree
	 * @param {module:echarts/model/Model} hostModel
	 */
	
	function Tree(hostModel) {
	  /**
	   * @type {module:echarts/data/Tree~TreeNode}
	   * @readOnly
	   */
	  this.root;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * Index of each item is the same as the raw index of coresponding list item.
	   * @private
	   * @type {Array.<module:echarts/data/Tree~TreeNode}
	   */
	
	  this._nodes = [];
	  /**
	   * @private
	   * @readOnly
	   * @type {module:echarts/model/Model}
	   */
	
	  this.hostModel = hostModel;
	}
	
	Tree.prototype = {
	  constructor: Tree,
	  type: 'tree',
	
	  /**
	   * Travel this subtree (include this node).
	   * Usage:
	   *    node.eachNode(function () { ... }); // preorder
	   *    node.eachNode('preorder', function () { ... }); // preorder
	   *    node.eachNode('postorder', function () { ... }); // postorder
	   *    node.eachNode(
	   *        {order: 'postorder', attr: 'viewChildren'},
	   *        function () { ... }
	   *    ); // postorder
	   *
	   * @param {(Object|string)} options If string, means order.
	   * @param {string=} options.order 'preorder' or 'postorder'
	   * @param {string=} options.attr 'children' or 'viewChildren'
	   * @param {Function} cb
	   * @param {Object}   [context]
	   */
	  eachNode: function (options, cb, context) {
	    this.root.eachNode(options, cb, context);
	  },
	
	  /**
	   * @param {number} dataIndex
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByDataIndex: function (dataIndex) {
	    var rawIndex = this.data.getRawIndex(dataIndex);
	    return this._nodes[rawIndex];
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/data/Tree~TreeNode}
	   */
	  getNodeByName: function (name) {
	    return this.root.getNodeByName(name);
	  },
	
	  /**
	   * Update item available by list,
	   * when list has been performed options like 'filterSelf' or 'map'.
	   */
	  update: function () {
	    var data = this.data;
	    var nodes = this._nodes;
	
	    for (var i = 0, len = nodes.length; i < len; i++) {
	      nodes[i].dataIndex = -1;
	    }
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      nodes[data.getRawIndex(i)].dataIndex = i;
	    }
	  },
	
	  /**
	   * Clear all layouts
	   */
	  clearLayouts: function () {
	    this.data.clearItemLayouts();
	  }
	};
	/**
	 * data node format:
	 * {
	 *     name: ...
	 *     value: ...
	 *     children: [
	 *         {
	 *             name: ...
	 *             value: ...
	 *             children: ...
	 *         },
	 *         ...
	 *     ]
	 * }
	 *
	 * @static
	 * @param {Object} dataRoot Root node.
	 * @param {module:echarts/model/Model} hostModel
	 * @return module:echarts/data/Tree
	 */
	
	Tree.createTree = function (dataRoot, hostModel, beforeLink) {
	  var tree = new Tree(hostModel);
	  var listData = [];
	  var dimMax = 1;
	  buildHierarchy(dataRoot);
	
	  function buildHierarchy(dataNode, parentNode) {
	    var value = dataNode.value;
	    dimMax = Math.max(dimMax, zrUtil.isArray(value) ? value.length : 1);
	    listData.push(dataNode);
	    var node = new TreeNode(dataNode.name, tree);
	    parentNode ? addChild(node, parentNode) : tree.root = node;
	
	    tree._nodes.push(node);
	
	    var children = dataNode.children;
	
	    if (children) {
	      for (var i = 0; i < children.length; i++) {
	        buildHierarchy(children[i], node);
	      }
	    }
	  }
	
	  tree.root.updateDepthAndHeight(0);
	  var dimensionsInfo = createDimensions(listData, {
	    coordDimensions: ['value'],
	    dimensionsCount: dimMax
	  });
	  var list = new List(dimensionsInfo, hostModel);
	  list.initData(listData);
	  beforeLink && beforeLink(list);
	  linkList({
	    mainData: list,
	    struct: tree,
	    structAttr: 'tree'
	  });
	  tree.update();
	  return tree;
	};
	/**
	 * It is needed to consider the mess of 'list', 'hostModel' when creating a TreeNote,
	 * so this function is not ready and not necessary to be public.
	 *
	 * @param {(module:echarts/data/Tree~TreeNode|Object)} child
	 */
	
	
	function addChild(child, node) {
	  var children = node.children;
	
	  if (child.parentNode === node) {
	    return;
	  }
	
	  children.push(child);
	  child.parentNode = node;
	}
	
	var _default = Tree;
	module.exports = _default;

/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataProvider = __webpack_require__(212);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	var _format = __webpack_require__(48);
	
	var getTooltipMarker = _format.getTooltipMarker;
	var formatTpl = _format.formatTpl;
	
	var _model = __webpack_require__(29);
	
	var getTooltipRenderMode = _model.getTooltipRenderMode;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DIMENSION_LABEL_REG = /\{@(.+?)\}/g; // PENDING A little ugly
	
	var _default = {
	  /**
	   * Get params for formatter
	   * @param {number} dataIndex
	   * @param {string} [dataType]
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex, dataType) {
	    var data = this.getData(dataType);
	    var rawValue = this.getRawValue(dataIndex, dataType);
	    var rawDataIndex = data.getRawIndex(dataIndex);
	    var name = data.getName(dataIndex);
	    var itemOpt = data.getRawDataItem(dataIndex);
	    var color = data.getItemVisual(dataIndex, 'color');
	    var borderColor = data.getItemVisual(dataIndex, 'borderColor');
	    var tooltipModel = this.ecModel.getComponent('tooltip');
	    var renderModeOption = tooltipModel && tooltipModel.get('renderMode');
	    var renderMode = getTooltipRenderMode(renderModeOption);
	    var mainType = this.mainType;
	    var isSeries = mainType === 'series';
	    var userOutput = data.userOutput;
	    return {
	      componentType: mainType,
	      componentSubType: this.subType,
	      componentIndex: this.componentIndex,
	      seriesType: isSeries ? this.subType : null,
	      seriesIndex: this.seriesIndex,
	      seriesId: isSeries ? this.id : null,
	      seriesName: isSeries ? this.name : null,
	      name: name,
	      dataIndex: rawDataIndex,
	      data: itemOpt,
	      dataType: dataType,
	      value: rawValue,
	      color: color,
	      borderColor: borderColor,
	      dimensionNames: userOutput ? userOutput.dimensionNames : null,
	      encode: userOutput ? userOutput.encode : null,
	      marker: getTooltipMarker({
	        color: color,
	        renderMode: renderMode
	      }),
	      // Param name list for mapping `a`, `b`, `c`, `d`, `e`
	      $vars: ['seriesName', 'name', 'value']
	    };
	  },
	
	  /**
	   * Format label
	   * @param {number} dataIndex
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @param {string} [dataType]
	   * @param {number} [dimIndex] Only used in some chart that
	   *        use formatter in different dimensions, like radar.
	   * @param {string} [labelProp='label']
	   * @return {string} If not formatter, return null/undefined
	   */
	  getFormattedLabel: function (dataIndex, status, dataType, dimIndex, labelProp) {
	    status = status || 'normal';
	    var data = this.getData(dataType);
	    var itemModel = data.getItemModel(dataIndex);
	    var params = this.getDataParams(dataIndex, dataType);
	
	    if (dimIndex != null && params.value instanceof Array) {
	      params.value = params.value[dimIndex];
	    }
	
	    var formatter = itemModel.get(status === 'normal' ? [labelProp || 'label', 'formatter'] : [status, labelProp || 'label', 'formatter']);
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      params.dimensionIndex = dimIndex;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      var str = formatTpl(formatter, params); // Support 'aaa{@[3]}bbb{@product}ccc'.
	      // Do not support '}' in dim name util have to.
	
	      return str.replace(DIMENSION_LABEL_REG, function (origin, dim) {
	        var len = dim.length;
	
	        if (dim.charAt(0) === '[' && dim.charAt(len - 1) === ']') {
	          dim = +dim.slice(1, len - 1); // Also: '[]' => 0
	        }
	
	        return retrieveRawValue(data, dataIndex, dim);
	      });
	    }
	  },
	
	  /**
	   * Get raw value in option
	   * @param {number} idx
	   * @param {string} [dataType]
	   * @return {Array|number|string}
	   */
	  getRawValue: function (idx, dataType) {
	    return retrieveRawValue(this.getData(dataType), idx);
	  },
	
	  /**
	   * Should be implemented.
	   * @param {number} dataIndex
	   * @param {boolean} [multipleSeries=false]
	   * @param {number} [dataType]
	   * @return {string} tooltip string
	   */
	  formatTooltip: function () {// Empty function
	  }
	};
	module.exports = _default;

/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var assert = _util.assert;
	var isArray = _util.isArray;
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} define
	 * @return See the return of `createTask`.
	 */
	function createTask(define) {
	  return new Task(define);
	}
	/**
	 * @constructor
	 * @param {Object} define
	 * @param {Function} define.reset Custom reset
	 * @param {Function} [define.plan] Returns 'reset' indicate reset immediately.
	 * @param {Function} [define.count] count is used to determin data task.
	 * @param {Function} [define.onDirty] count is used to determin data task.
	 */
	
	
	function Task(define) {
	  define = define || {};
	  this._reset = define.reset;
	  this._plan = define.plan;
	  this._count = define.count;
	  this._onDirty = define.onDirty;
	  this._dirty = true; // Context must be specified implicitly, to
	  // avoid miss update context when model changed.
	
	  this.context;
	}
	
	var taskProto = Task.prototype;
	/**
	 * @param {Object} performArgs
	 * @param {number} [performArgs.step] Specified step.
	 * @param {number} [performArgs.skip] Skip customer perform call.
	 * @param {number} [performArgs.modBy] Sampling window size.
	 * @param {number} [performArgs.modDataCount] Sampling count.
	 */
	
	taskProto.perform = function (performArgs) {
	  var upTask = this._upstream;
	  var skip = performArgs && performArgs.skip; // TODO some refactor.
	  // Pull data. Must pull data each time, because context.data
	  // may be updated by Series.setData.
	
	  if (this._dirty && upTask) {
	    var context = this.context;
	    context.data = context.outputData = upTask.context.outputData;
	  }
	
	  if (this.__pipeline) {
	    this.__pipeline.currentTask = this;
	  }
	
	  var planResult;
	
	  if (this._plan && !skip) {
	    planResult = this._plan(this.context);
	  } // Support sharding by mod, which changes the render sequence and makes the rendered graphic
	  // elements uniformed distributed when progress, especially when moving or zooming.
	
	
	  var lastModBy = normalizeModBy(this._modBy);
	  var lastModDataCount = this._modDataCount || 0;
	  var modBy = normalizeModBy(performArgs && performArgs.modBy);
	  var modDataCount = performArgs && performArgs.modDataCount || 0;
	
	  if (lastModBy !== modBy || lastModDataCount !== modDataCount) {
	    planResult = 'reset';
	  }
	
	  function normalizeModBy(val) {
	    !(val >= 1) && (val = 1); // jshint ignore:line
	
	    return val;
	  }
	
	  var forceFirstProgress;
	
	  if (this._dirty || planResult === 'reset') {
	    this._dirty = false;
	    forceFirstProgress = reset(this, skip);
	  }
	
	  this._modBy = modBy;
	  this._modDataCount = modDataCount;
	  var step = performArgs && performArgs.step;
	
	  if (upTask) {
	    this._dueEnd = upTask._outputDueEnd;
	  } // DataTask or overallTask
	  else {
	      this._dueEnd = this._count ? this._count(this.context) : Infinity;
	    } // Note: Stubs, that its host overall task let it has progress, has progress.
	  // If no progress, pass index from upstream to downstream each time plan called.
	
	
	  if (this._progress) {
	    var start = this._dueIndex;
	    var end = Math.min(step != null ? this._dueIndex + step : Infinity, this._dueEnd);
	
	    if (!skip && (forceFirstProgress || start < end)) {
	      var progress = this._progress;
	
	      if (isArray(progress)) {
	        for (var i = 0; i < progress.length; i++) {
	          doProgress(this, progress[i], start, end, modBy, modDataCount);
	        }
	      } else {
	        doProgress(this, progress, start, end, modBy, modDataCount);
	      }
	    }
	
	    this._dueIndex = end; // If no `outputDueEnd`, assume that output data and
	    // input data is the same, so use `dueIndex` as `outputDueEnd`.
	
	    var outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : end;
	    this._outputDueEnd = outputDueEnd;
	  } else {
	    // (1) Some overall task has no progress.
	    // (2) Stubs, that its host overall task do not let it has progress, has no progress.
	    // This should always be performed so it can be passed to downstream.
	    this._dueIndex = this._outputDueEnd = this._settedOutputEnd != null ? this._settedOutputEnd : this._dueEnd;
	  }
	
	  return this.unfinished();
	};
	
	var iterator = function () {
	  var end;
	  var current;
	  var modBy;
	  var modDataCount;
	  var winCount;
	  var it = {
	    reset: function (s, e, sStep, sCount) {
	      current = s;
	      end = e;
	      modBy = sStep;
	      modDataCount = sCount;
	      winCount = Math.ceil(modDataCount / modBy);
	      it.next = modBy > 1 && modDataCount > 0 ? modNext : sequentialNext;
	    }
	  };
	  return it;
	
	  function sequentialNext() {
	    return current < end ? current++ : null;
	  }
	
	  function modNext() {
	    var dataIndex = current % winCount * modBy + Math.ceil(current / winCount);
	    var result = current >= end ? null : dataIndex < modDataCount ? dataIndex // If modDataCount is smaller than data.count() (consider `appendData` case),
	    // Use normal linear rendering mode.
	    : current;
	    current++;
	    return result;
	  }
	}();
	
	taskProto.dirty = function () {
	  this._dirty = true;
	  this._onDirty && this._onDirty(this.context);
	};
	
	function doProgress(taskIns, progress, start, end, modBy, modDataCount) {
	  iterator.reset(start, end, modBy, modDataCount);
	  taskIns._callingProgress = progress;
	
	  taskIns._callingProgress({
	    start: start,
	    end: end,
	    count: end - start,
	    next: iterator.next
	  }, taskIns.context);
	}
	
	function reset(taskIns, skip) {
	  taskIns._dueIndex = taskIns._outputDueEnd = taskIns._dueEnd = 0;
	  taskIns._settedOutputEnd = null;
	  var progress;
	  var forceFirstProgress;
	
	  if (!skip && taskIns._reset) {
	    progress = taskIns._reset(taskIns.context);
	
	    if (progress && progress.progress) {
	      forceFirstProgress = progress.forceFirstProgress;
	      progress = progress.progress;
	    } // To simplify no progress checking, array must has item.
	
	
	    if (isArray(progress) && !progress.length) {
	      progress = null;
	    }
	  }
	
	  taskIns._progress = progress;
	  taskIns._modBy = taskIns._modDataCount = null;
	  var downstream = taskIns._downstream;
	  downstream && downstream.dirty();
	  return forceFirstProgress;
	}
	/**
	 * @return {boolean}
	 */
	
	
	taskProto.unfinished = function () {
	  return this._progress && this._dueIndex < this._dueEnd;
	};
	/**
	 * @param {Object} downTask The downstream task.
	 * @return {Object} The downstream task.
	 */
	
	
	taskProto.pipe = function (downTask) {
	  // If already downstream, do not dirty downTask.
	  if (this._downstream !== downTask || this._dirty) {
	    this._downstream = downTask;
	    downTask._upstream = this;
	    downTask.dirty();
	  }
	};
	
	taskProto.dispose = function () {
	  if (this._disposed) {
	    return;
	  }
	
	  this._upstream && (this._upstream._downstream = null);
	  this._downstream && (this._downstream._upstream = null);
	  this._dirty = false;
	  this._disposed = true;
	};
	
	taskProto.getUpstream = function () {
	  return this._upstream;
	};
	
	taskProto.getDownstream = function () {
	  return this._downstream;
	};
	
	taskProto.setOutputEnd = function (end) {
	  // This only happend in dataTask, dataZoom, map, currently.
	  // where dataZoom do not set end each time, but only set
	  // when reset. So we should record the setted end, in case
	  // that the stub of dataZoom perform again and earse the
	  // setted end by upstream.
	  this._outputDueEnd = this._settedOutputEnd = end;
	}; ///////////////////////////////////////////////////////////
	// For stream debug (Should be commented out after used!)
	// Usage: printTask(this, 'begin');
	// Usage: printTask(this, null, {someExtraProp});
	// function printTask(task, prefix, extra) {
	//     window.ecTaskUID == null && (window.ecTaskUID = 0);
	//     task.uidDebug == null && (task.uidDebug = `task_${window.ecTaskUID++}`);
	//     task.agent && task.agent.uidDebug == null && (task.agent.uidDebug = `task_${window.ecTaskUID++}`);
	//     var props = [];
	//     if (task.__pipeline) {
	//         var val = `${task.__idxInPipeline}/${task.__pipeline.tail.__idxInPipeline} ${task.agent ? '(stub)' : ''}`;
	//         props.push({text: 'idx', value: val});
	//     } else {
	//         var stubCount = 0;
	//         task.agentStubMap.each(() => stubCount++);
	//         props.push({text: 'idx', value: `overall (stubs: ${stubCount})`});
	//     }
	//     props.push({text: 'uid', value: task.uidDebug});
	//     if (task.__pipeline) {
	//         props.push({text: 'pid', value: task.__pipeline.id});
	//         task.agent && props.push(
	//             {text: 'stubFor', value: task.agent.uidDebug}
	//         );
	//     }
	//     props.push(
	//         {text: 'dirty', value: task._dirty},
	//         {text: 'dueIndex', value: task._dueIndex},
	//         {text: 'dueEnd', value: task._dueEnd},
	//         {text: 'outputDueEnd', value: task._outputDueEnd}
	//     );
	//     if (extra) {
	//         Object.keys(extra).forEach(key => {
	//             props.push({text: key, value: extra[key]});
	//         });
	//     }
	//     var args = ['color: blue'];
	//     var msg = `%c[${prefix || 'T'}] %c` + props.map(item => (
	//         args.push('color: black', 'color: red'),
	//         `${item.text}: %c${item.value}`
	//     )).join('%c, ');
	//     console.log.apply(console, [msg].concat(args));
	//     // console.log(this);
	// }
	
	
	exports.createTask = createTask;

/***/ },
/* 519 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	module.exports = {
	  BACKSPACE: 8,
	  TAB: 9,
	  RETURN: 13,
	  ALT: 18,
	  ESC: 27,
	  SPACE: 32,
	  PAGE_UP: 33,
	  PAGE_DOWN: 34,
	  END: 35,
	  HOME: 36,
	  LEFT: 37,
	  UP: 38,
	  RIGHT: 39,
	  DOWN: 40,
	  DELETE: 46,
	  COMMA: 188,
	  PERIOD: 190,
	  A: 65,
	  Z: 90,
	  ZERO: 48,
	  NUMPAD_0: 96,
	  NUMPAD_9: 105
	};

/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var getStyleProperty = __webpack_require__(2474);
	
	/**
	 * @param {DOMNode} element [description]
	 * @param {string} name Overflow style property name.
	 * @return {boolean} True if the supplied ndoe is scrollable.
	 */
	function _isNodeScrollable(element, name) {
	  var overflow = Style.get(element, name);
	  return overflow === 'auto' || overflow === 'scroll';
	}
	
	/**
	 * Utilities for querying and mutating style properties.
	 */
	var Style = {
	  /**
	   * Gets the style property for the supplied node. This will return either the
	   * computed style, if available, or the declared style.
	   *
	   * @param {DOMNode} node
	   * @param {string} name Style property name.
	   * @return {?string} Style property value.
	   */
	  get: getStyleProperty,
	
	  /**
	   * Determines the nearest ancestor of a node that is scrollable.
	   *
	   * NOTE: This can be expensive if used repeatedly or on a node nested deeply.
	   *
	   * @param {?DOMNode} node Node from which to start searching.
	   * @return {?DOMWindow|DOMElement} Scroll parent of the supplied node.
	   */
	  getScrollParent: function getScrollParent(node) {
	    if (!node) {
	      return null;
	    }
	    var ownerDocument = node.ownerDocument;
	    while (node && node !== ownerDocument.body) {
	      if (_isNodeScrollable(node, 'overflow') || _isNodeScrollable(node, 'overflowY') || _isNodeScrollable(node, 'overflowX')) {
	        return node;
	      }
	      node = node.parentNode;
	    }
	    return ownerDocument.defaultView || ownerDocument.parentWindow;
	  }
	
	};
	
	module.exports = Style;

/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Constants to represent text directionality
	 *
	 * Also defines a *global* direciton, to be used in bidi algorithms as a
	 * default fallback direciton, when no better direction is found or provided.
	 *
	 * NOTE: Use `setGlobalDir()`, or update `initGlobalDir()`, to set the initial
	 *       global direction value based on the application.
	 *
	 * Part of the implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(18);
	
	var NEUTRAL = 'NEUTRAL'; // No strong direction
	var LTR = 'LTR'; // Left-to-Right direction
	var RTL = 'RTL'; // Right-to-Left direction
	
	var globalDir = null;
	
	// == Helpers ==
	
	/**
	 * Check if a directionality value is a Strong one
	 */
	function isStrong(dir) {
	  return dir === LTR || dir === RTL;
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property.
	 */
	function getHTMLDir(dir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === LTR ? 'ltr' : 'rtl';
	}
	
	/**
	 * Get string value to be used for `dir` HTML attribute or `direction` CSS
	 * property, but returns null if `dir` has same value as `otherDir`.
	 * `null`.
	 */
	function getHTMLDirIfDifferent(dir, otherDir) {
	  !isStrong(dir) ?  false ? invariant(false, '`dir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  !isStrong(otherDir) ?  false ? invariant(false, '`otherDir` must be a strong direction to be converted to HTML Direction') : invariant(false) : void 0;
	  return dir === otherDir ? null : getHTMLDir(dir);
	}
	
	// == Global Direction ==
	
	/**
	 * Set the global direction.
	 */
	function setGlobalDir(dir) {
	  globalDir = dir;
	}
	
	/**
	 * Initialize the global direction
	 */
	function initGlobalDir() {
	  setGlobalDir(LTR);
	}
	
	/**
	 * Get the global direction
	 */
	function getGlobalDir() {
	  if (!globalDir) {
	    this.initGlobalDir();
	  }
	  !globalDir ?  false ? invariant(false, 'Global direction not set.') : invariant(false) : void 0;
	  return globalDir;
	}
	
	var UnicodeBidiDirection = {
	  // Values
	  NEUTRAL: NEUTRAL,
	  LTR: LTR,
	  RTL: RTL,
	  // Helpers
	  isStrong: isStrong,
	  getHTMLDir: getHTMLDir,
	  getHTMLDirIfDifferent: getHTMLDirIfDifferent,
	  // Global Direction
	  setGlobalDir: setGlobalDir,
	  initGlobalDir: initGlobalDir,
	  getGlobalDir: getGlobalDir
	};
	
	module.exports = UnicodeBidiDirection;

/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var getDocumentScrollElement = __webpack_require__(2470);
	var getUnboundedScrollPosition = __webpack_require__(888);
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are bounded. This means that if the scroll position is
	 * negative or exceeds the element boundaries (which is possible using inertial
	 * scrolling), you will get zero or the maximum scroll position, respectively.
	 *
	 * If you need the unbound scroll position, use `getUnboundedScrollPosition`.
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	function getScrollPosition(scrollable) {
	  var documentScrollElement = getDocumentScrollElement(scrollable.ownerDocument || scrollable.document);
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    scrollable = documentScrollElement;
	  }
	  var scrollPosition = getUnboundedScrollPosition(scrollable);
	
	  var viewport = scrollable === documentScrollElement ? scrollable.ownerDocument.documentElement : scrollable;
	
	  var xMax = scrollable.scrollWidth - viewport.clientWidth;
	  var yMax = scrollable.scrollHeight - viewport.clientHeight;
	
	  scrollPosition.x = Math.max(0, Math.min(scrollPosition.x, xMax));
	  scrollPosition.y = Math.max(0, Math.min(scrollPosition.y, yMax));
	
	  return scrollPosition;
	}
	
	module.exports = getScrollPosition;

/***/ },
/* 524 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.go = exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getUserConfirmation = exports.getCurrentLocation = undefined;
	
	var _LocationUtils = __webpack_require__(254);
	
	var _DOMUtils = __webpack_require__(368);
	
	var _DOMStateStorage = __webpack_require__(891);
	
	var _PathUtils = __webpack_require__(182);
	
	var _ExecutionEnvironment = __webpack_require__(526);
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var needsHashchangeListener = _ExecutionEnvironment.canUseDOM && !(0, _DOMUtils.supportsPopstateOnHashchange)();
	
	var _createLocation = function _createLocation(historyState) {
	  var key = historyState && historyState.key;
	
	  return (0, _LocationUtils.createLocation)({
	    pathname: window.location.pathname,
	    search: window.location.search,
	    hash: window.location.hash,
	    state: key ? (0, _DOMStateStorage.readState)(key) : undefined
	  }, undefined, key);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  var historyState = void 0;
	  try {
	    historyState = window.history.state || {};
	  } catch (error) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    historyState = {};
	  }
	
	  return _createLocation(historyState);
	};
	
	var getUserConfirmation = exports.getUserConfirmation = function getUserConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	var startListener = exports.startListener = function startListener(listener) {
	  var handlePopState = function handlePopState(event) {
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) // Ignore extraneous popstate events in WebKit
	      return;
	    listener(_createLocation(event.state));
	  };
	
	  (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	  var handleUnpoppedHashChange = function handleUnpoppedHashChange() {
	    return listener(getCurrentLocation());
	  };
	
	  if (needsHashchangeListener) {
	    (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	  }
	
	  return function () {
	    (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	    if (needsHashchangeListener) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleUnpoppedHashChange);
	    }
	  };
	};
	
	var updateLocation = function updateLocation(location, updateState) {
	  var state = location.state,
	      key = location.key;
	
	
	  if (state !== undefined) (0, _DOMStateStorage.saveState)(key, state);
	
	  updateState({ key: key }, (0, _PathUtils.createPath)(location));
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.pushState(state, null, path);
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  return updateLocation(location, function (state, path) {
	    return window.history.replaceState(state, null, path);
	  });
	};
	
	var go = exports.go = function go(n) {
	  if (n) window.history.go(n);
	};

/***/ },
/* 526 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(2483);
	
	var _PathUtils = __webpack_require__(182);
	
	var _runTransitionHook = __webpack_require__(528);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _Actions = __webpack_require__(367);
	
	var _LocationUtils = __webpack_require__(254);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createHistory = function createHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getCurrentLocation = options.getCurrentLocation,
	      getUserConfirmation = options.getUserConfirmation,
	      pushLocation = options.pushLocation,
	      replaceLocation = options.replaceLocation,
	      go = options.go,
	      keyLength = options.keyLength;
	
	
	  var currentLocation = void 0;
	  var pendingLocation = void 0;
	  var beforeListeners = [];
	  var listeners = [];
	  var allKeys = [];
	
	  var getCurrentIndex = function getCurrentIndex() {
	    if (pendingLocation && pendingLocation.action === _Actions.POP) return allKeys.indexOf(pendingLocation.key);
	
	    if (currentLocation) return allKeys.indexOf(currentLocation.key);
	
	    return -1;
	  };
	
	  var updateLocation = function updateLocation(nextLocation) {
	    var currentIndex = getCurrentIndex();
	
	    currentLocation = nextLocation;
	
	    if (currentLocation.action === _Actions.PUSH) {
	      allKeys = [].concat(allKeys.slice(0, currentIndex + 1), [currentLocation.key]);
	    } else if (currentLocation.action === _Actions.REPLACE) {
	      allKeys[currentIndex] = currentLocation.key;
	    }
	
	    listeners.forEach(function (listener) {
	      return listener(currentLocation);
	    });
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    beforeListeners.push(listener);
	
	    return function () {
	      return beforeListeners = beforeListeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var listen = function listen(listener) {
	    listeners.push(listener);
	
	    return function () {
	      return listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, callback) {
	    (0, _AsyncUtils.loopAsync)(beforeListeners.length, function (index, next, done) {
	      (0, _runTransitionHook2.default)(beforeListeners[index], location, function (result) {
	        return result != null ? done(result) : next();
	      });
	    }, function (message) {
	      if (getUserConfirmation && typeof message === 'string') {
	        getUserConfirmation(message, function (ok) {
	          return callback(ok !== false);
	        });
	      } else {
	        callback(message !== false);
	      }
	    });
	  };
	
	  var transitionTo = function transitionTo(nextLocation) {
	    if (currentLocation && (0, _LocationUtils.locationsAreEqual)(currentLocation, nextLocation) || pendingLocation && (0, _LocationUtils.locationsAreEqual)(pendingLocation, nextLocation)) return; // Nothing to do
	
	    pendingLocation = nextLocation;
	
	    confirmTransitionTo(nextLocation, function (ok) {
	      if (pendingLocation !== nextLocation) return; // Transition was interrupted during confirmation
	
	      pendingLocation = null;
	
	      if (ok) {
	        // Treat PUSH to same path like REPLACE to be consistent with browsers
	        if (nextLocation.action === _Actions.PUSH) {
	          var prevPath = (0, _PathUtils.createPath)(currentLocation);
	          var nextPath = (0, _PathUtils.createPath)(nextLocation);
	
	          if (nextPath === prevPath && (0, _LocationUtils.statesAreEqual)(currentLocation.state, nextLocation.state)) nextLocation.action = _Actions.REPLACE;
	        }
	
	        if (nextLocation.action === _Actions.POP) {
	          updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.PUSH) {
	          if (pushLocation(nextLocation) !== false) updateLocation(nextLocation);
	        } else if (nextLocation.action === _Actions.REPLACE) {
	          if (replaceLocation(nextLocation) !== false) updateLocation(nextLocation);
	        }
	      } else if (currentLocation && nextLocation.action === _Actions.POP) {
	        var prevIndex = allKeys.indexOf(currentLocation.key);
	        var nextIndex = allKeys.indexOf(nextLocation.key);
	
	        if (prevIndex !== -1 && nextIndex !== -1) go(prevIndex - nextIndex); // Restore the URL
	      }
	    });
	  };
	
	  var push = function push(input) {
	    return transitionTo(createLocation(input, _Actions.PUSH));
	  };
	
	  var replace = function replace(input) {
	    return transitionTo(createLocation(input, _Actions.REPLACE));
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength || 6);
	  };
	
	  var createHref = function createHref(location) {
	    return (0, _PathUtils.createPath)(location);
	  };
	
	  var createLocation = function createLocation(location, action) {
	    var key = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : createKey();
	    return (0, _LocationUtils.createLocation)(location, action, key);
	  };
	
	  return {
	    getCurrentLocation: getCurrentLocation,
	    listenBefore: listenBefore,
	    listen: listen,
	    transitionTo: transitionTo,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    createKey: createKey,
	    createPath: _PathUtils.createPath,
	    createHref: createHref,
	    createLocation: createLocation
	  };
	};
	
	exports.default = createHistory;

/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(216);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var runTransitionHook = function runTransitionHook(hook, location, callback) {
	  var result = hook(location, callback);
	
	  if (hook.length < 2) {
	    // Assume the hook runs synchronously and automatically
	    // call the callback with the return value.
	    callback(result);
	  } else {
	     false ? (0, _warning2.default)(result === undefined, 'You should not "return" in a transition hook with a callback argument; ' + 'call the callback instead') : void 0;
	  }
	};
	
	exports.default = runTransitionHook;

/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(222);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(218),
	    root = __webpack_require__(124);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(2563),
	    mapCacheDelete = __webpack_require__(2564),
	    mapCacheGet = __webpack_require__(2565),
	    mapCacheHas = __webpack_require__(2566),
	    mapCacheSet = __webpack_require__(2567);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(531),
	    setCacheAdd = __webpack_require__(2574),
	    setCacheHas = __webpack_require__(2575);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(370),
	    stackClear = __webpack_require__(2578),
	    stackDelete = __webpack_require__(2579),
	    stackGet = __webpack_require__(2580),
	    stackHas = __webpack_require__(2581),
	    stackSet = __webpack_require__(2582);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 534 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(2519),
	    baseMatchesProperty = __webpack_require__(2520),
	    identity = __webpack_require__(377),
	    isArray = __webpack_require__(125),
	    property = __webpack_require__(2601);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(377),
	    overRest = __webpack_require__(2573),
	    setToString = __webpack_require__(2576);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 537 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(125),
	    isKey = __webpack_require__(540),
	    stringToPath = __webpack_require__(2584),
	    toString = __webpack_require__(550);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 539 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsZWJ = '\\u200d';
	
	/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	/**
	 * Checks if `string` contains Unicode symbols.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	 */
	function hasUnicode(string) {
	  return reHasUnicode.test(string);
	}
	
	module.exports = hasUnicode;


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(125),
	    isSymbol = __webpack_require__(380);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 541 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	var asciiSize = __webpack_require__(2502),
	    hasUnicode = __webpack_require__(539),
	    unicodeSize = __webpack_require__(2586);
	
	/**
	 * Gets the number of symbols in `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the string size.
	 */
	function stringSize(string) {
	  return hasUnicode(string)
	    ? unicodeSize(string)
	    : asciiSize(string);
	}
	
	module.exports = stringSize;


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(906);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 544 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(301),
	    isObjectLike = __webpack_require__(183);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(124),
	    stubFalse = __webpack_require__(2603);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)(module)))

/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(217),
	    isObject = __webpack_require__(126);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 547 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(2516),
	    baseUnary = __webpack_require__(910),
	    nodeUtil = __webpack_require__(2571);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	var toFinite = __webpack_require__(2605);
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	module.exports = toInteger;


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(909);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (China) [zh-cn]
	//! author : suupic : https://github.com/suupic
	//! author : Zeno Zeng : https://github.com/zenozeng
	//! author : uu109 : https://github.com/uu109
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhCn = moment.defineLocale('zh-cn', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日Ah点mm分',
	            LLLL: 'YYYY年M月D日ddddAh点mm分',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            } else {
	                // '中午'
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[下]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            lastDay: '[昨天]LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[上]dddLT';
	                } else {
	                    return '[本]dddLT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '周';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s后',
	            past: '%s前',
	            s: '几秒',
	            ss: '%d 秒',
	            m: '1 分钟',
	            mm: '%d 分钟',
	            h: '1 小时',
	            hh: '%d 小时',
	            d: '1 天',
	            dd: '%d 天',
	            w: '1 周',
	            ww: '%d 周',
	            M: '1 个月',
	            MM: '%d 个月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return zhCn;
	
	})));


/***/ },
/* 552 */
/***/ function(module, exports) {

	function clamp(val, min, max) {
	  return Math.min(Math.max(val, min), max);
	}
	
	module.exports = clamp;

/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MotionPropTypes = undefined;
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.genCSSMotion = genCSSMotion;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _findDOMNode = __webpack_require__(568);
	
	var _findDOMNode2 = _interopRequireDefault(_findDOMNode);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _raf = __webpack_require__(127);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _motion = __webpack_require__(1071);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var STATUS_NONE = 'none'; /* eslint-disable react/default-props-match-prop-types, react/no-multi-comp */
	
	var STATUS_APPEAR = 'appear';
	var STATUS_ENTER = 'enter';
	var STATUS_LEAVE = 'leave';
	
	var MotionPropTypes = exports.MotionPropTypes = {
	  eventProps: _propTypes2['default'].object, // Internal usage. Only pass by CSSMotionList
	  visible: _propTypes2['default'].bool,
	  children: _propTypes2['default'].func,
	  motionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  motionAppear: _propTypes2['default'].bool,
	  motionEnter: _propTypes2['default'].bool,
	  motionLeave: _propTypes2['default'].bool,
	  motionLeaveImmediately: _propTypes2['default'].bool, // Trigger leave motion immediately
	  motionDeadline: _propTypes2['default'].number,
	  removeOnLeave: _propTypes2['default'].bool,
	  leavedClassName: _propTypes2['default'].string,
	  onAppearStart: _propTypes2['default'].func,
	  onAppearActive: _propTypes2['default'].func,
	  onAppearEnd: _propTypes2['default'].func,
	  onEnterStart: _propTypes2['default'].func,
	  onEnterActive: _propTypes2['default'].func,
	  onEnterEnd: _propTypes2['default'].func,
	  onLeaveStart: _propTypes2['default'].func,
	  onLeaveActive: _propTypes2['default'].func,
	  onLeaveEnd: _propTypes2['default'].func
	};
	
	/**
	 * `transitionSupport` is used for none transition test case.
	 * Default we use browser transition event support check.
	 */
	function genCSSMotion(config) {
	  var transitionSupport = config;
	  var forwardRef = !!_react2['default'].forwardRef;
	
	  if (typeof config === 'object') {
	    transitionSupport = config.transitionSupport;
	    forwardRef = 'forwardRef' in config ? config.forwardRef : forwardRef;
	  }
	
	  function isSupportTransition(props) {
	    return !!(props.motionName && transitionSupport);
	  }
	
	  var CSSMotion = function (_React$Component) {
	    (0, _inherits3['default'])(CSSMotion, _React$Component);
	
	    function CSSMotion() {
	      (0, _classCallCheck3['default'])(this, CSSMotion);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, (CSSMotion.__proto__ || Object.getPrototypeOf(CSSMotion)).call(this));
	
	      _this.onDomUpdate = function () {
	        var _this$state = _this.state,
	            status = _this$state.status,
	            newStatus = _this$state.newStatus;
	        var _this$props = _this.props,
	            onAppearStart = _this$props.onAppearStart,
	            onEnterStart = _this$props.onEnterStart,
	            onLeaveStart = _this$props.onLeaveStart,
	            onAppearActive = _this$props.onAppearActive,
	            onEnterActive = _this$props.onEnterActive,
	            onLeaveActive = _this$props.onLeaveActive,
	            motionAppear = _this$props.motionAppear,
	            motionEnter = _this$props.motionEnter,
	            motionLeave = _this$props.motionLeave;
	
	
	        if (!isSupportTransition(_this.props)) {
	          return;
	        }
	
	        // Event injection
	        var $ele = _this.getElement();
	        if (_this.$cacheEle !== $ele) {
	          _this.removeEventListener(_this.$cacheEle);
	          _this.addEventListener($ele);
	          _this.$cacheEle = $ele;
	        }
	
	        // Init status
	        if (newStatus && status === STATUS_APPEAR && motionAppear) {
	          _this.updateStatus(onAppearStart, null, null, function () {
	            _this.updateActiveStatus(onAppearActive, STATUS_APPEAR);
	          });
	        } else if (newStatus && status === STATUS_ENTER && motionEnter) {
	          _this.updateStatus(onEnterStart, null, null, function () {
	            _this.updateActiveStatus(onEnterActive, STATUS_ENTER);
	          });
	        } else if (newStatus && status === STATUS_LEAVE && motionLeave) {
	          _this.updateStatus(onLeaveStart, null, null, function () {
	            _this.updateActiveStatus(onLeaveActive, STATUS_LEAVE);
	          });
	        }
	      };
	
	      _this.onMotionEnd = function (event) {
	        var _this$state2 = _this.state,
	            status = _this$state2.status,
	            statusActive = _this$state2.statusActive;
	        var _this$props2 = _this.props,
	            onAppearEnd = _this$props2.onAppearEnd,
	            onEnterEnd = _this$props2.onEnterEnd,
	            onLeaveEnd = _this$props2.onLeaveEnd;
	
	        if (status === STATUS_APPEAR && statusActive) {
	          _this.updateStatus(onAppearEnd, { status: STATUS_NONE }, event);
	        } else if (status === STATUS_ENTER && statusActive) {
	          _this.updateStatus(onEnterEnd, { status: STATUS_NONE }, event);
	        } else if (status === STATUS_LEAVE && statusActive) {
	          _this.updateStatus(onLeaveEnd, { status: STATUS_NONE }, event);
	        }
	      };
	
	      _this.setNodeRef = function (node) {
	        var internalRef = _this.props.internalRef;
	
	        _this.node = node;
	
	        if (typeof internalRef === 'function') {
	          internalRef(node);
	        } else if (internalRef && 'current' in internalRef) {
	          internalRef.current = node;
	        }
	      };
	
	      _this.getElement = function () {
	        try {
	          return (0, _findDOMNode2['default'])(_this.node || _this);
	        } catch (e) {
	          /**
	           * Fallback to cache element.
	           * This is only happen when `motionDeadline` trigger but element removed.
	           */
	          return _this.$cacheEle;
	        }
	      };
	
	      _this.addEventListener = function ($ele) {
	        if (!$ele) return;
	
	        $ele.addEventListener(_motion.transitionEndName, _this.onMotionEnd);
	        $ele.addEventListener(_motion.animationEndName, _this.onMotionEnd);
	      };
	
	      _this.removeEventListener = function ($ele) {
	        if (!$ele) return;
	
	        $ele.removeEventListener(_motion.transitionEndName, _this.onMotionEnd);
	        $ele.removeEventListener(_motion.animationEndName, _this.onMotionEnd);
	      };
	
	      _this.updateStatus = function (styleFunc, additionalState, event, callback) {
	        var statusStyle = styleFunc ? styleFunc(_this.getElement(), event) : null;
	
	        if (statusStyle === false || _this._destroyed) return;
	
	        var nextStep = void 0;
	        if (callback) {
	          nextStep = function nextStep() {
	            _this.nextFrame(callback);
	          };
	        }
	
	        _this.setState((0, _extends3['default'])({
	          statusStyle: typeof statusStyle === 'object' ? statusStyle : null,
	          newStatus: false
	        }, additionalState), nextStep); // Trigger before next frame & after `componentDidMount`
	      };
	
	      _this.updateActiveStatus = function (styleFunc, currentStatus) {
	        // `setState` use `postMessage` to trigger at the end of frame.
	        // Let's use requestAnimationFrame to update new state in next frame.
	        _this.nextFrame(function () {
	          var status = _this.state.status;
	
	          if (status !== currentStatus) return;
	
	          var motionDeadline = _this.props.motionDeadline;
	
	
	          _this.updateStatus(styleFunc, { statusActive: true });
	
	          if (motionDeadline > 0) {
	            setTimeout(function () {
	              _this.onMotionEnd({
	                deadline: true
	              });
	            }, motionDeadline);
	          }
	        });
	      };
	
	      _this.nextFrame = function (func) {
	        _this.cancelNextFrame();
	        _this.raf = (0, _raf2['default'])(func);
	      };
	
	      _this.cancelNextFrame = function () {
	        if (_this.raf) {
	          _raf2['default'].cancel(_this.raf);
	          _this.raf = null;
	        }
	      };
	
	      _this.state = {
	        status: STATUS_NONE,
	        statusActive: false,
	        newStatus: false,
	        statusStyle: null
	      };
	      _this.$cacheEle = null;
	      _this.node = null;
	      _this.raf = null;
	      return _this;
	    }
	
	    (0, _createClass3['default'])(CSSMotion, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.onDomUpdate();
	      }
	    }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	        this.onDomUpdate();
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        this._destroyed = true;
	        this.removeEventListener(this.$cacheEle);
	        this.cancelNextFrame();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classNames;
	
	        var _state = this.state,
	            status = _state.status,
	            statusActive = _state.statusActive,
	            statusStyle = _state.statusStyle;
	        var _props = this.props,
	            children = _props.children,
	            motionName = _props.motionName,
	            visible = _props.visible,
	            removeOnLeave = _props.removeOnLeave,
	            leavedClassName = _props.leavedClassName,
	            eventProps = _props.eventProps;
	
	
	        if (!children) return null;
	
	        if (status === STATUS_NONE || !isSupportTransition(this.props)) {
	          if (visible) {
	            return children((0, _extends3['default'])({}, eventProps), this.setNodeRef);
	          } else if (!removeOnLeave) {
	            return children((0, _extends3['default'])({}, eventProps, { className: leavedClassName }), this.setNodeRef);
	          }
	
	          return null;
	        }
	
	        return children((0, _extends3['default'])({}, eventProps, {
	          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, (0, _motion.getTransitionName)(motionName, status), status !== STATUS_NONE), (0, _defineProperty3['default'])(_classNames, (0, _motion.getTransitionName)(motionName, status + '-active'), status !== STATUS_NONE && statusActive), (0, _defineProperty3['default'])(_classNames, motionName, typeof motionName === 'string'), _classNames)),
	          style: statusStyle
	        }), this.setNodeRef);
	      }
	    }], [{
	      key: 'getDerivedStateFromProps',
	      value: function getDerivedStateFromProps(props, _ref) {
	        var prevProps = _ref.prevProps,
	            prevStatus = _ref.status;
	
	        if (!isSupportTransition(props)) return {};
	
	        var visible = props.visible,
	            motionAppear = props.motionAppear,
	            motionEnter = props.motionEnter,
	            motionLeave = props.motionLeave,
	            motionLeaveImmediately = props.motionLeaveImmediately;
	
	        var newState = {
	          prevProps: props
	        };
	
	        // Clean up status if prop set to false
	        if (prevStatus === STATUS_APPEAR && !motionAppear || prevStatus === STATUS_ENTER && !motionEnter || prevStatus === STATUS_LEAVE && !motionLeave) {
	          newState.status = STATUS_NONE;
	          newState.statusActive = false;
	          newState.newStatus = false;
	        }
	
	        // Appear
	        if (!prevProps && visible && motionAppear) {
	          newState.status = STATUS_APPEAR;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        // Enter
	        if (prevProps && !prevProps.visible && visible && motionEnter) {
	          newState.status = STATUS_ENTER;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        // Leave
	        if (prevProps && prevProps.visible && !visible && motionLeave || !prevProps && motionLeaveImmediately && !visible && motionLeave) {
	          newState.status = STATUS_LEAVE;
	          newState.statusActive = false;
	          newState.newStatus = true;
	        }
	
	        return newState;
	      }
	    }]);
	    return CSSMotion;
	  }(_react2['default'].Component);
	
	  CSSMotion.propTypes = (0, _extends3['default'])({}, MotionPropTypes, {
	
	    internalRef: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].func])
	  });
	  CSSMotion.defaultProps = {
	    visible: true,
	    motionEnter: true,
	    motionAppear: true,
	    motionLeave: true,
	    removeOnLeave: true
	  };
	
	
	  (0, _reactLifecyclesCompat.polyfill)(CSSMotion);
	
	  if (!forwardRef) {
	    return CSSMotion;
	  }
	
	  return _react2['default'].forwardRef(function (props, ref) {
	    return _react2['default'].createElement(CSSMotion, (0, _extends3['default'])({ internalRef: ref }, props));
	  });
	}
	
	exports['default'] = genCSSMotion(_motion.supportTransition);

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _createChainedFunction = __webpack_require__(570);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _KeyCode = __webpack_require__(71);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _placements = __webpack_require__(2649);
	
	var _placements2 = _interopRequireDefault(_placements);
	
	var _rcTrigger = __webpack_require__(185);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function refFn(field, component) {
	  this[field] = component;
	}
	
	var Picker = function (_React$Component) {
	  (0, _inherits3['default'])(Picker, _React$Component);
	
	  function Picker(props) {
	    (0, _classCallCheck3['default'])(this, Picker);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var open = void 0;
	    if ('open' in props) {
	      open = props.open;
	    } else {
	      open = props.defaultOpen;
	    }
	    var value = props.value || props.defaultValue;
	    _this.saveCalendarRef = refFn.bind(_this, 'calendarInstance');
	
	    _this.state = {
	      open: open,
	      value: value
	    };
	    return _this;
	  }
	
	  Picker.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
	    if (!prevState.open && this.state.open) {
	      // setTimeout is for making sure saveCalendarRef happen before focusCalendar
	      this.focusTimeout = setTimeout(this.focusCalendar, 0, this);
	    }
	  };
	
	  Picker.prototype.componentWillUnmount = function componentWillUnmount() {
	    clearTimeout(this.focusTimeout);
	  };
	
	  Picker.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
	    var newState = {};
	    var value = nextProps.value,
	        open = nextProps.open;
	
	    if ('value' in nextProps) {
	      newState.value = value;
	    }
	    if (open !== undefined) {
	      newState.open = open;
	    }
	    return newState;
	  };
	
	  Picker.prototype.render = function render() {
	    var props = this.props;
	    var prefixCls = props.prefixCls,
	        placement = props.placement,
	        style = props.style,
	        getCalendarContainer = props.getCalendarContainer,
	        align = props.align,
	        animation = props.animation,
	        disabled = props.disabled,
	        dropdownClassName = props.dropdownClassName,
	        transitionName = props.transitionName,
	        children = props.children;
	
	    var state = this.state;
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      {
	        popup: this.getCalendarElement(),
	        popupAlign: align,
	        builtinPlacements: _placements2['default'],
	        popupPlacement: placement,
	        action: disabled && !state.open ? [] : ['click'],
	        destroyPopupOnHide: true,
	        getPopupContainer: getCalendarContainer,
	        popupStyle: style,
	        popupAnimation: animation,
	        popupTransitionName: transitionName,
	        popupVisible: state.open,
	        onPopupVisibleChange: this.onVisibleChange,
	        prefixCls: prefixCls,
	        popupClassName: dropdownClassName
	      },
	      _react2['default'].cloneElement(children(state, props), { onKeyDown: this.onKeyDown })
	    );
	  };
	
	  return Picker;
	}(_react2['default'].Component);
	
	Picker.propTypes = {
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].string]),
	  disabled: _propTypes2['default'].bool,
	  transitionName: _propTypes2['default'].string,
	  onChange: _propTypes2['default'].func,
	  onOpenChange: _propTypes2['default'].func,
	  children: _propTypes2['default'].func,
	  getCalendarContainer: _propTypes2['default'].func,
	  calendar: _propTypes2['default'].element,
	  style: _propTypes2['default'].object,
	  open: _propTypes2['default'].bool,
	  defaultOpen: _propTypes2['default'].bool,
	  prefixCls: _propTypes2['default'].string,
	  placement: _propTypes2['default'].any,
	  value: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
	  defaultValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].array]),
	  align: _propTypes2['default'].object,
	  dateRender: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func
	};
	Picker.defaultProps = {
	  prefixCls: 'rc-calendar-picker',
	  style: {},
	  align: {},
	  placement: 'bottomLeft',
	  defaultOpen: false,
	  onChange: noop,
	  onOpenChange: noop,
	  onBlur: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onCalendarKeyDown = function (event) {
	    if (event.keyCode === _KeyCode2['default'].ESC) {
	      event.stopPropagation();
	      _this2.close(_this2.focus);
	    }
	  };
	
	  this.onCalendarSelect = function (value) {
	    var cause = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var props = _this2.props;
	    if (!('value' in props)) {
	      _this2.setState({
	        value: value
	      });
	    }
	    if (cause.source === 'keyboard' || cause.source === 'dateInputSelect' || !props.calendar.props.timePicker && cause.source !== 'dateInput' || cause.source === 'todayButton') {
	      _this2.close(_this2.focus);
	    }
	    props.onChange(value);
	  };
	
	  this.onKeyDown = function (event) {
	    if (!_this2.state.open && (event.keyCode === _KeyCode2['default'].DOWN || event.keyCode === _KeyCode2['default'].ENTER)) {
	      _this2.open();
	      event.preventDefault();
	    }
	  };
	
	  this.onCalendarOk = function () {
	    _this2.close(_this2.focus);
	  };
	
	  this.onCalendarClear = function () {
	    _this2.close(_this2.focus);
	  };
	
	  this.onCalendarBlur = function () {
	    _this2.setOpen(false);
	  };
	
	  this.onVisibleChange = function (open) {
	    _this2.setOpen(open);
	  };
	
	  this.getCalendarElement = function () {
	    var props = _this2.props;
	    var state = _this2.state;
	    var calendarProps = props.calendar.props;
	    var value = state.value;
	
	    var defaultValue = value;
	    var extraProps = {
	      ref: _this2.saveCalendarRef,
	      defaultValue: defaultValue || calendarProps.defaultValue,
	      selectedValue: value,
	      onKeyDown: _this2.onCalendarKeyDown,
	      onOk: (0, _createChainedFunction2['default'])(calendarProps.onOk, _this2.onCalendarOk),
	      onSelect: (0, _createChainedFunction2['default'])(calendarProps.onSelect, _this2.onCalendarSelect),
	      onClear: (0, _createChainedFunction2['default'])(calendarProps.onClear, _this2.onCalendarClear),
	      onBlur: (0, _createChainedFunction2['default'])(calendarProps.onBlur, _this2.onCalendarBlur)
	    };
	
	    return _react2['default'].cloneElement(props.calendar, extraProps);
	  };
	
	  this.setOpen = function (open, callback) {
	    var onOpenChange = _this2.props.onOpenChange;
	
	    if (_this2.state.open !== open) {
	      if (!('open' in _this2.props)) {
	        _this2.setState({
	          open: open
	        }, callback);
	      }
	      onOpenChange(open);
	    }
	  };
	
	  this.open = function (callback) {
	    _this2.setOpen(true, callback);
	  };
	
	  this.close = function (callback) {
	    _this2.setOpen(false, callback);
	  };
	
	  this.focus = function () {
	    if (!_this2.state.open) {
	      _reactDom2['default'].findDOMNode(_this2).focus();
	    }
	  };
	
	  this.focusCalendar = function () {
	    if (_this2.state.open && !!_this2.calendarInstance) {
	      _this2.calendarInstance.focus();
	    }
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Picker);
	
	exports['default'] = Picker;
	module.exports = exports['default'];

/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mapSelf = __webpack_require__(1122);
	
	var _mapSelf2 = _interopRequireDefault(_mapSelf);
	
	var _MonthPanel = __webpack_require__(2648);
	
	var _MonthPanel2 = _interopRequireDefault(_MonthPanel);
	
	var _YearPanel = __webpack_require__(2651);
	
	var _YearPanel2 = _interopRequireDefault(_YearPanel);
	
	var _DecadePanel = __webpack_require__(2645);
	
	var _DecadePanel2 = _interopRequireDefault(_DecadePanel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function goMonth(direction) {
	  var next = this.props.value.clone();
	  next.add(direction, 'months');
	  this.props.onValueChange(next);
	}
	
	function goYear(direction) {
	  var next = this.props.value.clone();
	  next.add(direction, 'years');
	  this.props.onValueChange(next);
	}
	
	function showIf(condition, el) {
	  return condition ? el : null;
	}
	
	var CalendarHeader = function (_React$Component) {
	  (0, _inherits3['default'])(CalendarHeader, _React$Component);
	
	  function CalendarHeader(props) {
	    (0, _classCallCheck3['default'])(this, CalendarHeader);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.nextMonth = goMonth.bind(_this, 1);
	    _this.previousMonth = goMonth.bind(_this, -1);
	    _this.nextYear = goYear.bind(_this, 1);
	    _this.previousYear = goYear.bind(_this, -1);
	
	    _this.state = { yearPanelReferer: null };
	    return _this;
	  }
	
	  CalendarHeader.prototype.render = function render() {
	    var _this2 = this;
	
	    var props = this.props;
	    var prefixCls = props.prefixCls,
	        locale = props.locale,
	        mode = props.mode,
	        value = props.value,
	        showTimePicker = props.showTimePicker,
	        enableNext = props.enableNext,
	        enablePrev = props.enablePrev,
	        disabledMonth = props.disabledMonth,
	        renderFooter = props.renderFooter;
	
	
	    var panel = null;
	    if (mode === 'month') {
	      panel = _react2['default'].createElement(_MonthPanel2['default'], {
	        locale: locale,
	        value: value,
	        rootPrefixCls: prefixCls,
	        onSelect: this.onMonthSelect,
	        onYearPanelShow: function onYearPanelShow() {
	          return _this2.showYearPanel('month');
	        },
	        disabledDate: disabledMonth,
	        cellRender: props.monthCellRender,
	        contentRender: props.monthCellContentRender,
	        renderFooter: renderFooter,
	        changeYear: this.changeYear
	      });
	    }
	    if (mode === 'year') {
	      panel = _react2['default'].createElement(_YearPanel2['default'], {
	        locale: locale,
	        defaultValue: value,
	        rootPrefixCls: prefixCls,
	        onSelect: this.onYearSelect,
	        onDecadePanelShow: this.showDecadePanel,
	        renderFooter: renderFooter
	      });
	    }
	    if (mode === 'decade') {
	      panel = _react2['default'].createElement(_DecadePanel2['default'], {
	        locale: locale,
	        defaultValue: value,
	        rootPrefixCls: prefixCls,
	        onSelect: this.onDecadeSelect,
	        renderFooter: renderFooter
	      });
	    }
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-header' },
	      _react2['default'].createElement(
	        'div',
	        { style: { position: 'relative' } },
	        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
	          className: prefixCls + '-prev-year-btn',
	          role: 'button',
	          onClick: this.previousYear,
	          title: locale.previousYear
	        })),
	        showIf(enablePrev && !showTimePicker, _react2['default'].createElement('a', {
	          className: prefixCls + '-prev-month-btn',
	          role: 'button',
	          onClick: this.previousMonth,
	          title: locale.previousMonth
	        })),
	        this.monthYearElement(showTimePicker),
	        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
	          className: prefixCls + '-next-month-btn',
	          onClick: this.nextMonth,
	          title: locale.nextMonth
	        })),
	        showIf(enableNext && !showTimePicker, _react2['default'].createElement('a', {
	          className: prefixCls + '-next-year-btn',
	          onClick: this.nextYear,
	          title: locale.nextYear
	        }))
	      ),
	      panel
	    );
	  };
	
	  return CalendarHeader;
	}(_react2['default'].Component);
	
	CalendarHeader.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  value: _propTypes2['default'].object,
	  onValueChange: _propTypes2['default'].func,
	  showTimePicker: _propTypes2['default'].bool,
	  onPanelChange: _propTypes2['default'].func,
	  locale: _propTypes2['default'].object,
	  enablePrev: _propTypes2['default'].any,
	  enableNext: _propTypes2['default'].any,
	  disabledMonth: _propTypes2['default'].func,
	  renderFooter: _propTypes2['default'].func,
	  onMonthSelect: _propTypes2['default'].func
	};
	CalendarHeader.defaultProps = {
	  enableNext: 1,
	  enablePrev: 1,
	  onPanelChange: function onPanelChange() {},
	  onValueChange: function onValueChange() {}
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onMonthSelect = function (value) {
	    _this3.props.onPanelChange(value, 'date');
	    if (_this3.props.onMonthSelect) {
	      _this3.props.onMonthSelect(value);
	    } else {
	      _this3.props.onValueChange(value);
	    }
	  };
	
	  this.onYearSelect = function (value) {
	    var referer = _this3.state.yearPanelReferer;
	    _this3.setState({ yearPanelReferer: null });
	    _this3.props.onPanelChange(value, referer);
	    _this3.props.onValueChange(value);
	  };
	
	  this.onDecadeSelect = function (value) {
	    _this3.props.onPanelChange(value, 'year');
	    _this3.props.onValueChange(value);
	  };
	
	  this.changeYear = function (direction) {
	    if (direction > 0) {
	      _this3.nextYear();
	    } else {
	      _this3.previousYear();
	    }
	  };
	
	  this.monthYearElement = function (showTimePicker) {
	    var props = _this3.props;
	    var prefixCls = props.prefixCls;
	    var locale = props.locale;
	    var value = props.value;
	    var localeData = value.localeData();
	    var monthBeforeYear = locale.monthBeforeYear;
	    var selectClassName = prefixCls + '-' + (monthBeforeYear ? 'my-select' : 'ym-select');
	    var timeClassName = showTimePicker ? ' ' + prefixCls + '-time-status' : '';
	    var year = _react2['default'].createElement(
	      'a',
	      {
	        className: prefixCls + '-year-select' + timeClassName,
	        role: 'button',
	        onClick: showTimePicker ? null : function () {
	          return _this3.showYearPanel('date');
	        },
	        title: showTimePicker ? null : locale.yearSelect
	      },
	      value.format(locale.yearFormat)
	    );
	    var month = _react2['default'].createElement(
	      'a',
	      {
	        className: prefixCls + '-month-select' + timeClassName,
	        role: 'button',
	        onClick: showTimePicker ? null : _this3.showMonthPanel,
	        title: showTimePicker ? null : locale.monthSelect
	      },
	      locale.monthFormat ? value.format(locale.monthFormat) : localeData.monthsShort(value)
	    );
	    var day = void 0;
	    if (showTimePicker) {
	      day = _react2['default'].createElement(
	        'a',
	        {
	          className: prefixCls + '-day-select' + timeClassName,
	          role: 'button'
	        },
	        value.format(locale.dayFormat)
	      );
	    }
	    var my = [];
	    if (monthBeforeYear) {
	      my = [month, day, year];
	    } else {
	      my = [year, month, day];
	    }
	    return _react2['default'].createElement(
	      'span',
	      { className: selectClassName },
	      (0, _mapSelf2['default'])(my)
	    );
	  };
	
	  this.showMonthPanel = function () {
	    // null means that users' interaction doesn't change value
	    _this3.props.onPanelChange(null, 'month');
	  };
	
	  this.showYearPanel = function (referer) {
	    _this3.setState({ yearPanelReferer: referer });
	    _this3.props.onPanelChange(null, 'year');
	  };
	
	  this.showDecadePanel = function () {
	    _this3.props.onPanelChange(null, 'decade');
	  };
	};
	
	exports['default'] = CalendarHeader;
	module.exports = exports['default'];

/***/ },
/* 556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateTHead = __webpack_require__(2644);
	
	var _DateTHead2 = _interopRequireDefault(_DateTHead);
	
	var _DateTBody = __webpack_require__(2643);
	
	var _DateTBody2 = _interopRequireDefault(_DateTBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DateTable = function (_React$Component) {
	  (0, _inherits3['default'])(DateTable, _React$Component);
	
	  function DateTable() {
	    (0, _classCallCheck3['default'])(this, DateTable);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DateTable.prototype.render = function render() {
	    var props = this.props;
	    var prefixCls = props.prefixCls;
	    return _react2['default'].createElement(
	      'table',
	      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
	      _react2['default'].createElement(_DateTHead2['default'], props),
	      _react2['default'].createElement(_DateTBody2['default'], props)
	    );
	  };
	
	  return DateTable;
	}(_react2['default'].Component);
	
	exports['default'] = DateTable;
	module.exports = exports['default'];

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.calendarMixinWrapper = exports.calendarMixinDefaultProps = exports.calendarMixinPropTypes = undefined;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.getNowByCurrentStateValue = getNowByCurrentStateValue;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function getNowByCurrentStateValue(value) {
	  var ret = void 0;
	  if (value) {
	    ret = (0, _index.getTodayTime)(value);
	  } else {
	    ret = (0, _moment2['default'])();
	  }
	  return ret;
	}
	
	var calendarMixinPropTypes = exports.calendarMixinPropTypes = {
	  value: _propTypes2['default'].object,
	  defaultValue: _propTypes2['default'].object,
	  onKeyDown: _propTypes2['default'].func
	};
	
	var calendarMixinDefaultProps = exports.calendarMixinDefaultProps = {
	  onKeyDown: noop
	};
	
	var calendarMixinWrapper = exports.calendarMixinWrapper = function calendarMixinWrapper(ComposeComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_ComposeComponent) {
	    (0, _inherits3['default'])(_class, _ComposeComponent);
	
	    function _class() {
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3['default'])(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _ComposeComponent.call.apply(_ComposeComponent, [this].concat(args))), _this), _this.onSelect = function (value, cause) {
	        if (value) {
	          _this.setValue(value);
	        }
	        _this.setSelectedValue(value, cause);
	      }, _this.renderRoot = function (newProps) {
	        var _className;
	
	        var props = _this.props;
	        var prefixCls = props.prefixCls;
	
	        var className = (_className = {}, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[props.className] = !!props.className, _className[newProps.className] = !!newProps.className, _className);
	
	        return _react2['default'].createElement(
	          'div',
	          {
	            ref: _this.saveRoot,
	            className: '' + (0, _classnames2['default'])(className),
	            style: _this.props.style,
	            tabIndex: '0',
	            onKeyDown: _this.onKeyDown,
	            onBlur: _this.onBlur
	          },
	          newProps.children
	        );
	      }, _this.setSelectedValue = function (selectedValue, cause) {
	        // if (this.isAllowedDate(selectedValue)) {
	        if (!('selectedValue' in _this.props)) {
	          _this.setState({
	            selectedValue: selectedValue
	          });
	        }
	        if (_this.props.onSelect) {
	          _this.props.onSelect(selectedValue, cause);
	        }
	        // }
	      }, _this.setValue = function (value) {
	        var originalValue = _this.state.value;
	        if (!('value' in _this.props)) {
	          _this.setState({
	            value: value
	          });
	        }
	        if (originalValue && value && !originalValue.isSame(value) || !originalValue && value || originalValue && !value) {
	          _this.props.onChange(value);
	        }
	      }, _this.isAllowedDate = function (value) {
	        var disabledDate = _this.props.disabledDate;
	        var disabledTime = _this.props.disabledTime;
	        return (0, _index.isAllowedDate)(value, disabledDate, disabledTime);
	      }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	    }
	
	    _class.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, prevState) {
	      // Use origin function if provided
	      if (ComposeComponent.getDerivedStateFromProps) {
	        return ComposeComponent.getDerivedStateFromProps(nextProps, prevState);
	      }
	
	      var value = nextProps.value,
	          selectedValue = nextProps.selectedValue;
	
	      var newState = {};
	
	      if ('value' in nextProps) {
	        newState.value = value || nextProps.defaultValue || getNowByCurrentStateValue(prevState.value);
	      }
	      if ('selectedValue' in nextProps) {
	        newState.selectedValue = selectedValue;
	      }
	
	      return newState;
	    };
	
	    return _class;
	  }(ComposeComponent), _class.displayName = 'CalendarMixinWrapper', _class.defaultProps = ComposeComponent.defaultProps, _temp2;
	};

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	exports['default'] = exportContent;
	
	var _draftJs = __webpack_require__(175);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function encodeContent(text) {
	  return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join('<br > \n');
	}
	
	var MentionGenerator = function () {
	  function MentionGenerator(contentState, options) {
	    (0, _classCallCheck3['default'])(this, MentionGenerator);
	
	    this.contentState = contentState;
	    this.options = options;
	  }
	
	  MentionGenerator.prototype.generate = function generate() {
	    var contentRaw = (0, _draftJs.convertToRaw)(this.contentState);
	    return this.processContent(contentRaw);
	  };
	
	  MentionGenerator.prototype.processContent = function processContent(contentRaw) {
	    var blocks = contentRaw.blocks;
	    var encode = this.options.encode;
	
	    return blocks.map(function (block) {
	      return encode ? encodeContent(block.text) : block.text;
	    }).join(encode ? '<br />\n' : '\n');
	  };
	
	  return MentionGenerator;
	}();
	
	function exportContent(contentState) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  return new MentionGenerator(contentState, options).generate();
	}
	module.exports = exports['default'];

/***/ },
/* 559 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = getSearchWord;
	function getWord(text, position) {
	  var str = String(text);
	  /* eslint no-bitwise:0 */
	  var pos = Number(position) >>> 0;
	
	  // Search for the word's beginning and end.
	  var left = str.slice(0, pos + 1).search(/\S+$/);
	  var right = str.slice(pos).search(/\s/);
	
	  if (right < 0) {
	    return {
	      word: str.slice(left),
	      begin: left,
	      end: str.length
	    };
	  }
	
	  // Return the word, using the located bounds to extract it from the string.
	  return {
	    word: str.slice(left, right + pos),
	    begin: left,
	    end: right + pos
	  };
	}
	
	function getSearchWord(editorState, selection) {
	  var anchorKey = selection.getAnchorKey();
	  var anchorOffset = selection.getAnchorOffset() - 1;
	  var currentContent = editorState.getCurrentContent();
	  var currentBlock = currentContent.getBlockForKey(anchorKey);
	  if (currentBlock) {
	    var blockText = currentBlock.getText();
	    return getWord(blockText, anchorOffset);
	  }
	  return '';
	}
	module.exports = exports['default'];

/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.argumentContainer = argumentContainer;
	exports.identity = identity;
	exports.flattenArray = flattenArray;
	exports.treeTraverse = treeTraverse;
	exports.flattenFields = flattenFields;
	exports.normalizeValidateRules = normalizeValidateRules;
	exports.getValidateTriggers = getValidateTriggers;
	exports.getValueFromEvent = getValueFromEvent;
	exports.getErrorStrs = getErrorStrs;
	exports.getParams = getParams;
	exports.isEmptyObject = isEmptyObject;
	exports.hasRules = hasRules;
	exports.startsWith = startsWith;
	exports.supportRef = supportRef;
	
	var _hoistNonReactStatics = __webpack_require__(529);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _warning = __webpack_require__(94);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _reactIs = __webpack_require__(222);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
	}
	
	function argumentContainer(Container, WrappedComponent) {
	  /* eslint no-param-reassign:0 */
	  Container.displayName = 'Form(' + getDisplayName(WrappedComponent) + ')';
	  Container.WrappedComponent = WrappedComponent;
	  return (0, _hoistNonReactStatics2['default'])(Container, WrappedComponent);
	}
	
	function identity(obj) {
	  return obj;
	}
	
	function flattenArray(arr) {
	  return Array.prototype.concat.apply([], arr);
	}
	
	function treeTraverse() {
	  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var tree = arguments[1];
	  var isLeafNode = arguments[2];
	  var errorMessage = arguments[3];
	  var callback = arguments[4];
	
	  if (isLeafNode(path, tree)) {
	    callback(path, tree);
	  } else if (tree === undefined || tree === null) {
	    // Do nothing
	  } else if (Array.isArray(tree)) {
	    tree.forEach(function (subTree, index) {
	      return treeTraverse(path + '[' + index + ']', subTree, isLeafNode, errorMessage, callback);
	    });
	  } else {
	    // It's object and not a leaf node
	    if (typeof tree !== 'object') {
	      (0, _warning2['default'])(false, errorMessage);
	      return;
	    }
	    Object.keys(tree).forEach(function (subTreeKey) {
	      var subTree = tree[subTreeKey];
	      treeTraverse('' + path + (path ? '.' : '') + subTreeKey, subTree, isLeafNode, errorMessage, callback);
	    });
	  }
	}
	
	function flattenFields(maybeNestedFields, isLeafNode, errorMessage) {
	  var fields = {};
	  treeTraverse(undefined, maybeNestedFields, isLeafNode, errorMessage, function (path, node) {
	    fields[path] = node;
	  });
	  return fields;
	}
	
	function normalizeValidateRules(validate, rules, validateTrigger) {
	  var validateRules = validate.map(function (item) {
	    var newItem = (0, _extends3['default'])({}, item, {
	      trigger: item.trigger || []
	    });
	    if (typeof newItem.trigger === 'string') {
	      newItem.trigger = [newItem.trigger];
	    }
	    return newItem;
	  });
	  if (rules) {
	    validateRules.push({
	      trigger: validateTrigger ? [].concat(validateTrigger) : [],
	      rules: rules
	    });
	  }
	  return validateRules;
	}
	
	function getValidateTriggers(validateRules) {
	  return validateRules.filter(function (item) {
	    return !!item.rules && item.rules.length;
	  }).map(function (item) {
	    return item.trigger;
	  }).reduce(function (pre, curr) {
	    return pre.concat(curr);
	  }, []);
	}
	
	function getValueFromEvent(e) {
	  // To support custom element
	  if (!e || !e.target) {
	    return e;
	  }
	  var target = e.target;
	
	  return target.type === 'checkbox' ? target.checked : target.value;
	}
	
	function getErrorStrs(errors) {
	  if (errors) {
	    return errors.map(function (e) {
	      if (e && e.message) {
	        return e.message;
	      }
	      return e;
	    });
	  }
	  return errors;
	}
	
	function getParams(ns, opt, cb) {
	  var names = ns;
	  var options = opt;
	  var callback = cb;
	  if (cb === undefined) {
	    if (typeof names === 'function') {
	      callback = names;
	      options = {};
	      names = undefined;
	    } else if (Array.isArray(names)) {
	      if (typeof options === 'function') {
	        callback = options;
	        options = {};
	      } else {
	        options = options || {};
	      }
	    } else {
	      callback = options;
	      options = names || {};
	      names = undefined;
	    }
	  }
	  return {
	    names: names,
	    options: options,
	    callback: callback
	  };
	}
	
	function isEmptyObject(obj) {
	  return Object.keys(obj).length === 0;
	}
	
	function hasRules(validate) {
	  if (validate) {
	    return validate.some(function (item) {
	      return item.rules && item.rules.length;
	    });
	  }
	  return false;
	}
	
	function startsWith(str, prefix) {
	  return str.lastIndexOf(prefix, 0) === 0;
	}
	
	function supportRef(nodeOrComponent) {
	  var type = (0, _reactIs.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
	
	  // Function component node
	  if (typeof type === 'function' && !(type.prototype && type.prototype.render)) {
	    return false;
	  }
	
	  // Class component
	  if (typeof nodeOrComponent === 'function' && !(nodeOrComponent.prototype && nodeOrComponent.prototype.render)) {
	    return false;
	  }
	
	  return true;
	}

/***/ },
/* 561 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toTitle = toTitle;
	exports.getValuePropValue = getValuePropValue;
	exports.getPropValue = getPropValue;
	exports.isMultiple = isMultiple;
	exports.isCombobox = isCombobox;
	exports.isMultipleOrTags = isMultipleOrTags;
	exports.isMultipleOrTagsOrCombobox = isMultipleOrTagsOrCombobox;
	exports.isSingleMode = isSingleMode;
	exports.toArray = toArray;
	exports.getMapKey = getMapKey;
	exports.preventDefaultEvent = preventDefaultEvent;
	exports.findIndexInValueBySingleValue = findIndexInValueBySingleValue;
	exports.getLabelFromPropsValue = getLabelFromPropsValue;
	exports.getSelectKeys = getSelectKeys;
	exports.findFirstMenuItem = findFirstMenuItem;
	exports.includesSeparators = includesSeparators;
	exports.splitBySeparators = splitBySeparators;
	exports.defaultFilterFn = defaultFilterFn;
	exports.validateOptionValue = validateOptionValue;
	exports.saveRef = saveRef;
	exports.generateUUID = generateUUID;
	exports.UNSELECTABLE_ATTRIBUTE = exports.UNSELECTABLE_STYLE = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function toTitle(title) {
	  if (typeof title === 'string') {
	    return title;
	  }
	
	  return '';
	}
	
	function getValuePropValue(child) {
	  if (!child) {
	    return null;
	  }
	
	  var props = child.props;
	
	  if ('value' in props) {
	    return props.value;
	  }
	
	  if (child.key) {
	    return child.key;
	  }
	
	  if (child.type && child.type.isSelectOptGroup && props.label) {
	    return props.label;
	  }
	
	  throw new Error("Need at least a key or a value or a label (only for OptGroup) for ".concat(child));
	}
	
	function getPropValue(child, prop) {
	  if (prop === 'value') {
	    return getValuePropValue(child);
	  }
	
	  return child.props[prop];
	}
	
	function isMultiple(props) {
	  return props.multiple;
	}
	
	function isCombobox(props) {
	  return props.combobox;
	}
	
	function isMultipleOrTags(props) {
	  return props.multiple || props.tags;
	}
	
	function isMultipleOrTagsOrCombobox(props) {
	  return isMultipleOrTags(props) || isCombobox(props);
	}
	
	function isSingleMode(props) {
	  return !isMultipleOrTagsOrCombobox(props);
	}
	
	function toArray(value) {
	  var ret = value;
	
	  if (value === undefined) {
	    ret = [];
	  } else if (!Array.isArray(value)) {
	    ret = [value];
	  }
	
	  return ret;
	}
	
	function getMapKey(value) {
	  return "".concat(typeof value, "-").concat(value);
	}
	
	function preventDefaultEvent(e) {
	  e.preventDefault();
	}
	
	function findIndexInValueBySingleValue(value, singleValue) {
	  var index = -1;
	
	  if (value) {
	    for (var i = 0; i < value.length; i++) {
	      if (value[i] === singleValue) {
	        index = i;
	        break;
	      }
	    }
	  }
	
	  return index;
	}
	
	function getLabelFromPropsValue(value, key) {
	  var label;
	  value = toArray(value);
	
	  if (value) {
	    // tslint:disable-next-line:prefer-for-of
	    for (var i = 0; i < value.length; i++) {
	      if (value[i].key === key) {
	        label = value[i].label;
	        break;
	      }
	    }
	  }
	
	  return label;
	}
	
	function getSelectKeys(menuItems, value) {
	  if (value === null || value === undefined) {
	    return [];
	  }
	
	  var selectedKeys = [];
	
	  _react["default"].Children.forEach(menuItems, function (item) {
	    var type = item.type;
	
	    if (type.isMenuItemGroup) {
	      selectedKeys = selectedKeys.concat(getSelectKeys(item.props.children, value));
	    } else {
	      var itemValue = getValuePropValue(item);
	      var itemKey = item.key;
	
	      if (findIndexInValueBySingleValue(value, itemValue) !== -1 && itemKey) {
	        selectedKeys.push(itemKey);
	      }
	    }
	  });
	
	  return selectedKeys;
	}
	
	var UNSELECTABLE_STYLE = {
	  userSelect: 'none',
	  WebkitUserSelect: 'none'
	};
	exports.UNSELECTABLE_STYLE = UNSELECTABLE_STYLE;
	var UNSELECTABLE_ATTRIBUTE = {
	  unselectable: 'on'
	};
	exports.UNSELECTABLE_ATTRIBUTE = UNSELECTABLE_ATTRIBUTE;
	
	function findFirstMenuItem(children) {
	  // tslint:disable-next-line:prefer-for-of
	  for (var i = 0; i < children.length; i++) {
	    var child = children[i];
	
	    if (child.type.isMenuItemGroup) {
	      var found = findFirstMenuItem(child.props.children);
	
	      if (found) {
	        return found;
	      }
	    } else if (!child.props.disabled) {
	      return child;
	    }
	  }
	
	  return null;
	}
	
	function includesSeparators(str, separators) {
	  // tslint:disable-next-line:prefer-for-of
	  for (var i = 0; i < separators.length; ++i) {
	    if (str.lastIndexOf(separators[i]) > 0) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function splitBySeparators(str, separators) {
	  var reg = new RegExp("[".concat(separators.join(), "]"));
	  return str.split(reg).filter(function (token) {
	    return token;
	  });
	}
	
	function defaultFilterFn(input, child) {
	  if (child.props.disabled) {
	    return false;
	  }
	
	  var value = toArray(getPropValue(child, this.props.optionFilterProp)).join('');
	  return value.toLowerCase().indexOf(input.toLowerCase()) > -1;
	}
	
	function validateOptionValue(value, props) {
	  if (isSingleMode(props) || isMultiple(props)) {
	    return;
	  }
	
	  if (typeof value !== 'string') {
	    throw new Error("Invalid `value` of type `".concat(typeof value, "` supplied to Option, ") + "expected `string` when `tags/combobox` is `true`.");
	  }
	}
	
	function saveRef(instance, name) {
	  return function (node) {
	    instance[name] = node;
	  };
	}
	
	function generateUUID() {
	  if (false) {
	    return 'test-uuid';
	  }
	
	  var d = new Date().getTime();
	  var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
	    // tslint:disable-next-line:no-bitwise
	    var r = (d + Math.random() * 16) % 16 | 0;
	    d = Math.floor(d / 16); // tslint:disable-next-line:no-bitwise
	
	    return (c === 'x' ? r : r & 0x7 | 0x8).toString(16);
	  });
	  return uuid;
	}

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(443);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.isEventFromHandle = isEventFromHandle;
	exports.isValueOutOfRange = isValueOutOfRange;
	exports.isNotTouchEvent = isNotTouchEvent;
	exports.getClosestPoint = getClosestPoint;
	exports.getPrecision = getPrecision;
	exports.getMousePosition = getMousePosition;
	exports.getTouchPosition = getTouchPosition;
	exports.getHandleCenterPosition = getHandleCenterPosition;
	exports.ensureValueInRange = ensureValueInRange;
	exports.ensureValuePrecision = ensureValuePrecision;
	exports.pauseEvent = pauseEvent;
	exports.calculateNextValue = calculateNextValue;
	exports.getKeyboardValueMutator = getKeyboardValueMutator;
	
	var _reactDom = __webpack_require__(23);
	
	var _KeyCode = __webpack_require__(71);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isEventFromHandle(e, handles) {
	  try {
	    return Object.keys(handles).some(function (key) {
	      return e.target === (0, _reactDom.findDOMNode)(handles[key]);
	    });
	  } catch (error) {
	    return false;
	  }
	}
	
	function isValueOutOfRange(value, _ref) {
	  var min = _ref.min,
	      max = _ref.max;
	
	  return value < min || value > max;
	}
	
	function isNotTouchEvent(e) {
	  return e.touches.length > 1 || e.type.toLowerCase() === 'touchend' && e.touches.length > 0;
	}
	
	function getClosestPoint(val, _ref2) {
	  var marks = _ref2.marks,
	      step = _ref2.step,
	      min = _ref2.min,
	      max = _ref2.max;
	
	  var points = Object.keys(marks).map(parseFloat);
	  if (step !== null) {
	    var maxSteps = Math.floor((max - min) / step);
	    var steps = Math.min((val - min) / step, maxSteps);
	    var closestStep = Math.round(steps) * step + min;
	    points.push(closestStep);
	  }
	  var diffs = points.map(function (point) {
	    return Math.abs(val - point);
	  });
	  return points[diffs.indexOf(Math.min.apply(Math, (0, _toConsumableArray3['default'])(diffs)))];
	}
	
	function getPrecision(step) {
	  var stepString = step.toString();
	  var precision = 0;
	  if (stepString.indexOf('.') >= 0) {
	    precision = stepString.length - stepString.indexOf('.') - 1;
	  }
	  return precision;
	}
	
	function getMousePosition(vertical, e) {
	  return vertical ? e.clientY : e.pageX;
	}
	
	function getTouchPosition(vertical, e) {
	  return vertical ? e.touches[0].clientY : e.touches[0].pageX;
	}
	
	function getHandleCenterPosition(vertical, handle) {
	  var coords = handle.getBoundingClientRect();
	  return vertical ? coords.top + coords.height * 0.5 : window.pageXOffset + coords.left + coords.width * 0.5;
	}
	
	function ensureValueInRange(val, _ref3) {
	  var max = _ref3.max,
	      min = _ref3.min;
	
	  if (val <= min) {
	    return min;
	  }
	  if (val >= max) {
	    return max;
	  }
	  return val;
	}
	
	function ensureValuePrecision(val, props) {
	  var step = props.step;
	
	  var closestPoint = isFinite(getClosestPoint(val, props)) ? getClosestPoint(val, props) : 0; // eslint-disable-line
	  return step === null ? closestPoint : parseFloat(closestPoint.toFixed(getPrecision(step)));
	}
	
	function pauseEvent(e) {
	  e.stopPropagation();
	  e.preventDefault();
	}
	
	function calculateNextValue(func, value, props) {
	  var operations = {
	    increase: function increase(a, b) {
	      return a + b;
	    },
	    decrease: function decrease(a, b) {
	      return a - b;
	    }
	  };
	
	  var indexToGet = operations[func](Object.keys(props.marks).indexOf(JSON.stringify(value)), 1);
	  var keyToGet = Object.keys(props.marks)[indexToGet];
	
	  if (props.step) {
	    return operations[func](value, props.step);
	  } else if (!!Object.keys(props.marks).length && !!props.marks[keyToGet]) {
	    return props.marks[keyToGet];
	  }
	  return value;
	}
	
	function getKeyboardValueMutator(e, vertical, reverse) {
	  var increase = 'increase';
	  var decrease = 'decrease';
	  var method = increase;
	  switch (e.keyCode) {
	    case _KeyCode2['default'].UP:
	      method = vertical && reverse ? decrease : increase;break;
	    case _KeyCode2['default'].RIGHT:
	      method = !vertical && reverse ? decrease : increase;break;
	    case _KeyCode2['default'].DOWN:
	      method = vertical && reverse ? increase : decrease;break;
	    case _KeyCode2['default'].LEFT:
	      method = !vertical && reverse ? increase : decrease;break;
	
	    case _KeyCode2['default'].END:
	      return function (value, props) {
	        return props.max;
	      };
	    case _KeyCode2['default'].HOME:
	      return function (value, props) {
	        return props.min;
	      };
	    case _KeyCode2['default'].PAGE_UP:
	      return function (value, props) {
	        return value + props.step * 2;
	      };
	    case _KeyCode2['default'].PAGE_DOWN:
	      return function (value, props) {
	        return value - props.step * 2;
	      };
	
	    default:
	      return undefined;
	  }
	  return function (value, props) {
	    return calculateNextValue(method, value, props);
	  };
	}

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.popupContextTypes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _rcTree = _interopRequireDefault(__webpack_require__(566));
	
	var _util = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var popupContextTypes = {
	  onPopupKeyDown: _propTypes["default"].func.isRequired,
	  onTreeNodeSelect: _propTypes["default"].func.isRequired,
	  onTreeNodeCheck: _propTypes["default"].func.isRequired
	};
	exports.popupContextTypes = popupContextTypes;
	
	var BasePopup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(BasePopup, _React$Component);
	
	  function BasePopup(props) {
	    var _this;
	
	    _classCallCheck(this, BasePopup);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(BasePopup).call(this));
	
	    _defineProperty(_assertThisInitialized(_this), "onTreeExpand", function (expandedKeyList) {
	      var _this$props = _this.props,
	          treeExpandedKeys = _this$props.treeExpandedKeys,
	          onTreeExpand = _this$props.onTreeExpand,
	          onTreeExpanded = _this$props.onTreeExpanded; // Set uncontrolled state
	
	      if (!treeExpandedKeys) {
	        _this.setState({
	          expandedKeyList: expandedKeyList
	        }, onTreeExpanded);
	      }
	
	      if (onTreeExpand) {
	        onTreeExpand(expandedKeyList);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onLoad", function (loadedKeys) {
	      _this.setState({
	        loadedKeys: loadedKeys
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getTree", function () {
	      return _this.treeRef.current;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getLoadData", function () {
	      var _this$props2 = _this.props,
	          loadData = _this$props2.loadData,
	          upperSearchValue = _this$props2.upperSearchValue;
	      if (upperSearchValue) return null;
	      return loadData;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "filterTreeNode", function (treeNode) {
	      var _this$props3 = _this.props,
	          upperSearchValue = _this$props3.upperSearchValue,
	          treeNodeFilterProp = _this$props3.treeNodeFilterProp;
	      var filterVal = treeNode.props[treeNodeFilterProp];
	
	      if (typeof filterVal === 'string') {
	        return upperSearchValue && filterVal.toUpperCase().indexOf(upperSearchValue) !== -1;
	      }
	
	      return false;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderNotFound", function () {
	      var _this$props4 = _this.props,
	          prefixCls = _this$props4.prefixCls,
	          notFoundContent = _this$props4.notFoundContent;
	      return _react["default"].createElement("span", {
	        className: "".concat(prefixCls, "-not-found")
	      }, notFoundContent);
	    });
	
	    var treeDefaultExpandAll = props.treeDefaultExpandAll,
	        treeDefaultExpandedKeys = props.treeDefaultExpandedKeys,
	        keyEntities = props.keyEntities; // TODO: make `expandedKeyList` control
	
	    var _expandedKeyList = treeDefaultExpandedKeys;
	
	    if (treeDefaultExpandAll) {
	      _expandedKeyList = Object.keys(keyEntities);
	    }
	
	    _this.state = {
	      keyList: [],
	      expandedKeyList: _expandedKeyList,
	      // Cache `expandedKeyList` when tree is in filter. This is used in `getDerivedStateFromProps`
	      cachedExpandedKeyList: [],
	      // eslint-disable-line react/no-unused-state
	      loadedKeys: []
	    };
	    _this.treeRef = (0, _util.createRef)();
	    return _this;
	  }
	
	  _createClass(BasePopup, [{
	    key: "render",
	    value: function render() {
	      var _this$state = this.state,
	          keyList = _this$state.keyList,
	          expandedKeyList = _this$state.expandedKeyList,
	          loadedKeys = _this$state.loadedKeys;
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          treeNodes = _this$props5.treeNodes,
	          filteredTreeNodes = _this$props5.filteredTreeNodes,
	          treeIcon = _this$props5.treeIcon,
	          treeLine = _this$props5.treeLine,
	          treeCheckable = _this$props5.treeCheckable,
	          treeCheckStrictly = _this$props5.treeCheckStrictly,
	          multiple = _this$props5.multiple,
	          ariaId = _this$props5.ariaId,
	          renderSearch = _this$props5.renderSearch,
	          switcherIcon = _this$props5.switcherIcon,
	          searchHalfCheckedKeys = _this$props5.searchHalfCheckedKeys;
	      var _this$context$rcTreeS = this.context.rcTreeSelect,
	          onPopupKeyDown = _this$context$rcTreeS.onPopupKeyDown,
	          onTreeNodeSelect = _this$context$rcTreeS.onTreeNodeSelect,
	          onTreeNodeCheck = _this$context$rcTreeS.onTreeNodeCheck;
	      var loadData = this.getLoadData();
	      var treeProps = {};
	
	      if (treeCheckable) {
	        treeProps.checkedKeys = keyList;
	      } else {
	        treeProps.selectedKeys = keyList;
	      }
	
	      var $notFound;
	      var $treeNodes;
	
	      if (filteredTreeNodes) {
	        if (filteredTreeNodes.length) {
	          treeProps.checkStrictly = true;
	          $treeNodes = filteredTreeNodes; // Fill halfCheckedKeys
	
	          if (treeCheckable && !treeCheckStrictly) {
	            treeProps.checkedKeys = {
	              checked: keyList,
	              halfChecked: searchHalfCheckedKeys
	            };
	          }
	        } else {
	          $notFound = this.renderNotFound();
	        }
	      } else if (!treeNodes || !treeNodes.length) {
	        $notFound = this.renderNotFound();
	      } else {
	        $treeNodes = treeNodes;
	      }
	
	      var $tree;
	
	      if ($notFound) {
	        $tree = $notFound;
	      } else {
	        $tree = _react["default"].createElement(_rcTree["default"], _extends({
	          ref: this.treeRef,
	          prefixCls: "".concat(prefixCls, "-tree"),
	          showIcon: treeIcon,
	          showLine: treeLine,
	          selectable: !treeCheckable,
	          checkable: treeCheckable,
	          checkStrictly: treeCheckStrictly,
	          multiple: multiple,
	          loadData: loadData,
	          loadedKeys: loadedKeys,
	          expandedKeys: expandedKeyList,
	          filterTreeNode: this.filterTreeNode,
	          onSelect: onTreeNodeSelect,
	          onCheck: onTreeNodeCheck,
	          onExpand: this.onTreeExpand,
	          onLoad: this.onLoad,
	          switcherIcon: switcherIcon
	        }, treeProps), $treeNodes);
	      }
	
	      return _react["default"].createElement("div", {
	        role: "listbox",
	        id: ariaId,
	        onKeyDown: onPopupKeyDown,
	        tabIndex: -1
	      }, renderSearch ? renderSearch() : null, $tree);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var _ref = prevState || {},
	          _ref$prevProps = _ref.prevProps,
	          prevProps = _ref$prevProps === void 0 ? {} : _ref$prevProps,
	          loadedKeys = _ref.loadedKeys,
	          expandedKeyList = _ref.expandedKeyList,
	          cachedExpandedKeyList = _ref.cachedExpandedKeyList;
	
	      var valueList = nextProps.valueList,
	          valueEntities = nextProps.valueEntities,
	          keyEntities = nextProps.keyEntities,
	          treeExpandedKeys = nextProps.treeExpandedKeys,
	          filteredTreeNodes = nextProps.filteredTreeNodes,
	          upperSearchValue = nextProps.upperSearchValue;
	      var newState = {
	        prevProps: nextProps
	      }; // Check value update
	
	      if (valueList !== prevProps.valueList) {
	        newState.keyList = valueList.map(function (_ref2) {
	          var value = _ref2.value;
	          return valueEntities[value];
	        }).filter(function (entity) {
	          return entity;
	        }).map(function (_ref3) {
	          var key = _ref3.key;
	          return key;
	        });
	      } // Show all when tree is in filter mode
	
	
	      if (!treeExpandedKeys && filteredTreeNodes && filteredTreeNodes.length && filteredTreeNodes !== prevProps.filteredTreeNodes) {
	        newState.expandedKeyList = Object.keys(keyEntities);
	      } // Cache `expandedKeyList` when filter set
	
	
	      if (upperSearchValue && !prevProps.upperSearchValue) {
	        newState.cachedExpandedKeyList = expandedKeyList;
	      } else if (!upperSearchValue && prevProps.upperSearchValue && !treeExpandedKeys) {
	        newState.expandedKeyList = cachedExpandedKeyList || [];
	        newState.cachedExpandedKeyList = [];
	      } // Use expandedKeys if provided
	
	
	      if (prevProps.treeExpandedKeys !== treeExpandedKeys) {
	        newState.expandedKeyList = treeExpandedKeys;
	      } // Clean loadedKeys if key not exist in keyEntities anymore
	
	
	      if (nextProps.loadData) {
	        newState.loadedKeys = loadedKeys.filter(function (key) {
	          return key in keyEntities;
	        });
	      }
	
	      return newState;
	    }
	  }]);
	
	  return BasePopup;
	}(_react["default"].Component);
	
	_defineProperty(BasePopup, "propTypes", {
	  prefixCls: _propTypes["default"].string,
	  upperSearchValue: _propTypes["default"].string,
	  valueList: _propTypes["default"].array,
	  searchHalfCheckedKeys: _propTypes["default"].array,
	  valueEntities: _propTypes["default"].object,
	  keyEntities: _propTypes["default"].object,
	  treeIcon: _propTypes["default"].bool,
	  treeLine: _propTypes["default"].bool,
	  treeNodeFilterProp: _propTypes["default"].string,
	  treeCheckable: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].node]),
	  treeCheckStrictly: _propTypes["default"].bool,
	  treeDefaultExpandAll: _propTypes["default"].bool,
	  treeDefaultExpandedKeys: _propTypes["default"].array,
	  treeExpandedKeys: _propTypes["default"].array,
	  loadData: _propTypes["default"].func,
	  multiple: _propTypes["default"].bool,
	  onTreeExpand: _propTypes["default"].func,
	  treeNodes: _propTypes["default"].node,
	  filteredTreeNodes: _propTypes["default"].node,
	  notFoundContent: _propTypes["default"].node,
	  ariaId: _propTypes["default"].string,
	  switcherIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
	  // HOC
	  renderSearch: _propTypes["default"].func,
	  onTreeExpanded: _propTypes["default"].func
	});
	
	_defineProperty(BasePopup, "contextTypes", {
	  rcTreeSelect: _propTypes["default"].shape(_objectSpread({}, popupContextTypes))
	});
	
	(0, _reactLifecyclesCompat.polyfill)(BasePopup);
	var _default = BasePopup;
	exports["default"] = _default;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = _default;
	exports.selectorContextTypes = exports.selectorPropTypes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _util = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var selectorPropTypes = {
	  prefixCls: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  style: _propTypes["default"].object,
	  open: _propTypes["default"].bool,
	  selectorValueList: _propTypes["default"].array,
	  allowClear: _propTypes["default"].bool,
	  showArrow: _propTypes["default"].bool,
	  onClick: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  onFocus: _propTypes["default"].func,
	  removeSelected: _propTypes["default"].func,
	  // Pass by component
	  ariaId: _propTypes["default"].string,
	  inputIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
	  clearIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func])
	};
	exports.selectorPropTypes = selectorPropTypes;
	var selectorContextTypes = {
	  onSelectorFocus: _propTypes["default"].func.isRequired,
	  onSelectorBlur: _propTypes["default"].func.isRequired,
	  onSelectorKeyDown: _propTypes["default"].func.isRequired,
	  onSelectorClear: _propTypes["default"].func.isRequired
	};
	exports.selectorContextTypes = selectorContextTypes;
	
	function _default(modeName) {
	  var BaseSelector =
	  /*#__PURE__*/
	  function (_React$Component) {
	    _inherits(BaseSelector, _React$Component);
	
	    function BaseSelector() {
	      var _this;
	
	      _classCallCheck(this, BaseSelector);
	
	      _this = _possibleConstructorReturn(this, _getPrototypeOf(BaseSelector).call(this));
	
	      _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
	        var _this$props = _this.props,
	            onFocus = _this$props.onFocus,
	            focused = _this$props.focused;
	        var onSelectorFocus = _this.context.rcTreeSelect.onSelectorFocus;
	
	        if (!focused) {
	          onSelectorFocus();
	        }
	
	        if (onFocus) {
	          onFocus.apply(void 0, arguments);
	        }
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
	        var onBlur = _this.props.onBlur;
	        var onSelectorBlur = _this.context.rcTreeSelect.onSelectorBlur; // TODO: Not trigger when is inner component get focused
	
	        onSelectorBlur();
	
	        if (onBlur) {
	          onBlur.apply(void 0, arguments);
	        }
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "focus", function () {
	        _this.domRef.current.focus();
	      });
	
	      _defineProperty(_assertThisInitialized(_this), "blur", function () {
	        _this.domRef.current.focus();
	      });
	
	      _this.domRef = (0, _util.createRef)();
	      return _this;
	    }
	
	    _createClass(BaseSelector, [{
	      key: "renderClear",
	      value: function renderClear() {
	        var _this$props2 = this.props,
	            prefixCls = _this$props2.prefixCls,
	            allowClear = _this$props2.allowClear,
	            selectorValueList = _this$props2.selectorValueList,
	            clearIcon = _this$props2.clearIcon;
	        var onSelectorClear = this.context.rcTreeSelect.onSelectorClear;
	
	        if (!allowClear || !selectorValueList.length || !selectorValueList[0].value) {
	          return null;
	        }
	
	        return _react["default"].createElement("span", {
	          key: "clear",
	          className: "".concat(prefixCls, "-selection__clear"),
	          onClick: onSelectorClear
	        }, typeof clearIcon === 'function' ? _react["default"].createElement(clearIcon, _objectSpread({}, this.props)) : clearIcon);
	      }
	    }, {
	      key: "renderArrow",
	      value: function renderArrow() {
	        var _this$props3 = this.props,
	            prefixCls = _this$props3.prefixCls,
	            showArrow = _this$props3.showArrow,
	            inputIcon = _this$props3.inputIcon;
	
	        if (!showArrow) {
	          return null;
	        }
	
	        return _react["default"].createElement("span", {
	          key: "arrow",
	          className: "".concat(prefixCls, "-arrow"),
	          style: {
	            outline: 'none'
	          }
	        }, typeof inputIcon === 'function' ? _react["default"].createElement(inputIcon, _objectSpread({}, this.props)) : inputIcon);
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var _classNames;
	
	        var _this$props4 = this.props,
	            prefixCls = _this$props4.prefixCls,
	            className = _this$props4.className,
	            style = _this$props4.style,
	            open = _this$props4.open,
	            focused = _this$props4.focused,
	            disabled = _this$props4.disabled,
	            allowClear = _this$props4.allowClear,
	            onClick = _this$props4.onClick,
	            ariaId = _this$props4.ariaId,
	            renderSelection = _this$props4.renderSelection,
	            renderPlaceholder = _this$props4.renderPlaceholder,
	            tabIndex = _this$props4.tabIndex;
	        var onSelectorKeyDown = this.context.rcTreeSelect.onSelectorKeyDown;
	        var myTabIndex = tabIndex;
	
	        if (disabled) {
	          myTabIndex = null;
	        }
	
	        return _react["default"].createElement("span", {
	          style: style,
	          onClick: onClick,
	          className: (0, _classnames["default"])(className, prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-open"), open), _defineProperty(_classNames, "".concat(prefixCls, "-focused"), open || focused), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-enabled"), !disabled), _defineProperty(_classNames, "".concat(prefixCls, "-allow-clear"), allowClear), _classNames)),
	          ref: this.domRef,
	          role: "combobox",
	          "aria-expanded": open,
	          "aria-owns": open ? ariaId : undefined,
	          "aria-controls": open ? ariaId : undefined,
	          "aria-haspopup": "listbox",
	          "aria-disabled": disabled,
	          tabIndex: myTabIndex,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          onKeyDown: onSelectorKeyDown
	        }, _react["default"].createElement("span", {
	          key: "selection",
	          className: (0, _classnames["default"])("".concat(prefixCls, "-selection"), "".concat(prefixCls, "-selection--").concat(modeName))
	        }, renderSelection(), this.renderClear(), this.renderArrow(), renderPlaceholder && renderPlaceholder()));
	      }
	    }]);
	
	    return BaseSelector;
	  }(_react["default"].Component);
	
	  _defineProperty(BaseSelector, "propTypes", _objectSpread({}, selectorPropTypes, {
	    // Pass by HOC
	    renderSelection: _propTypes["default"].func.isRequired,
	    renderPlaceholder: _propTypes["default"].func,
	    tabIndex: _propTypes["default"].number
	  }));
	
	  _defineProperty(BaseSelector, "contextTypes", {
	    rcTreeSelect: _propTypes["default"].shape(_objectSpread({}, selectorContextTypes))
	  });
	
	  _defineProperty(BaseSelector, "defaultProps", {
	    tabIndex: 0
	  });
	
	  (0, _reactLifecyclesCompat.polyfill)(BaseSelector);
	  return BaseSelector;
	}

/***/ },
/* 565 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SHOW_CHILD = exports.SHOW_PARENT = exports.SHOW_ALL = void 0;
	var SHOW_ALL = 'SHOW_ALL';
	exports.SHOW_ALL = SHOW_ALL;
	var SHOW_PARENT = 'SHOW_PARENT';
	exports.SHOW_PARENT = SHOW_PARENT;
	var SHOW_CHILD = 'SHOW_CHILD';
	exports.SHOW_CHILD = SHOW_CHILD;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "TreeNode", {
	  enumerable: true,
	  get: function get() {
	    return _TreeNode.default;
	  }
	});
	exports.default = void 0;
	
	var _Tree = _interopRequireDefault(__webpack_require__(2767));
	
	var _TreeNode = _interopRequireDefault(__webpack_require__(1117));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Tree = _Tree.default;
	Tree.TreeNode = _TreeNode.default;
	var _default = Tree;
	exports.default = _default;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ContainerRender = /*#__PURE__*/function (_React$Component) {
	  _inherits(ContainerRender, _React$Component);
	
	  var _super = _createSuper(ContainerRender);
	
	  function ContainerRender() {
	    var _this;
	
	    _classCallCheck(this, ContainerRender);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _this.removeContainer = function () {
	      if (_this.container) {
	        _reactDom.default.unmountComponentAtNode(_this.container);
	
	        _this.container.parentNode.removeChild(_this.container);
	
	        _this.container = null;
	      }
	    };
	
	    _this.renderComponent = function (props, ready) {
	      var _this$props = _this.props,
	          visible = _this$props.visible,
	          getComponent = _this$props.getComponent,
	          forceRender = _this$props.forceRender,
	          getContainer = _this$props.getContainer,
	          parent = _this$props.parent;
	
	      if (visible || parent._component || forceRender) {
	        if (!_this.container) {
	          _this.container = getContainer();
	        }
	
	        _reactDom.default.unstable_renderSubtreeIntoContainer(parent, getComponent(props), _this.container, function callback() {
	          if (ready) {
	            ready.call(this);
	          }
	        });
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(ContainerRender, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.props.autoMount) {
	        this.renderComponent();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.props.autoDestroy) {
	        this.removeContainer();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children({
	        renderComponent: this.renderComponent,
	        removeContainer: this.removeContainer
	      });
	    }
	  }]);
	
	  return ContainerRender;
	}(_react.default.Component);
	
	exports.default = ContainerRender;
	ContainerRender.propTypes = {
	  autoMount: _propTypes.default.bool,
	  autoDestroy: _propTypes.default.bool,
	  visible: _propTypes.default.bool,
	  forceRender: _propTypes.default.bool,
	  parent: _propTypes.default.any,
	  getComponent: _propTypes.default.func.isRequired,
	  getContainer: _propTypes.default.func.isRequired,
	  children: _propTypes.default.func.isRequired
	};
	ContainerRender.defaultProps = {
	  autoMount: true,
	  autoDestroy: true,
	  forceRender: false
	};

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = findDOMNode;
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Return if a node is a DOM node. Else will return by `findDOMNode`
	 */
	function findDOMNode(node) {
	  if (node instanceof HTMLElement) {
	    return node;
	  }
	
	  return _reactDom.default.findDOMNode(node);
	}

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Portal = /*#__PURE__*/function (_React$Component) {
	  _inherits(Portal, _React$Component);
	
	  var _super = _createSuper(Portal);
	
	  function Portal() {
	    _classCallCheck(this, Portal);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Portal, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.createContainer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var didUpdate = this.props.didUpdate;
	
	      if (didUpdate) {
	        didUpdate(prevProps);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.removeContainer();
	    }
	  }, {
	    key: "createContainer",
	    value: function createContainer() {
	      this._container = this.props.getContainer();
	      this.forceUpdate();
	    }
	  }, {
	    key: "removeContainer",
	    value: function removeContainer() {
	      if (this._container) {
	        this._container.parentNode.removeChild(this._container);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (this._container) {
	        return _reactDom.default.createPortal(this.props.children, this._container);
	      }
	
	      return null;
	    }
	  }]);
	
	  return Portal;
	}(_react.default.Component);
	
	exports.default = Portal;
	Portal.propTypes = {
	  getContainer: _propTypes.default.func.isRequired,
	  children: _propTypes.default.node.isRequired,
	  didUpdate: _propTypes.default.func
	};

/***/ },
/* 570 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainedFunction;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  var args = [].slice.call(arguments, 0);
	
	  if (args.length === 1) {
	    return args[0];
	  }
	
	  return function chainedFunction() {
	    for (var i = 0; i < args.length; i++) {
	      if (args[i] && args[i].apply) {
	        args[i].apply(this, arguments);
	      }
	    }
	  };
	}

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(258);
	var Danger = __webpack_require__(2786);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactInstrumentation = __webpack_require__(128);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(580);
	var setInnerHTML = __webpack_require__(389);
	var setTextContent = __webpack_require__(1147);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 572 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactErrorUtils = __webpack_require__(578);
	
	var invariant = __webpack_require__(18);
	var warning = __webpack_require__(49);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 575 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactPropTypesSecret = __webpack_require__(2815);
	var propTypesFactory = __webpack_require__(1066);
	
	var React = __webpack_require__(263);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(18);
	var warning = __webpack_require__(49);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var invariant = __webpack_require__(18);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactCurrentOwner = __webpack_require__(164);
	var ReactInstanceMap = __webpack_require__(306);
	var ReactInstrumentation = __webpack_require__(128);
	var ReactUpdates = __webpack_require__(146);
	
	var invariant = __webpack_require__(18);
	var warning = __webpack_require__(49);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 580 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 581 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 582 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 583 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 584 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(93);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 585 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var emptyFunction = __webpack_require__(101);
	var warning = __webpack_require__(49);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 587 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = warning;
	
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	
	
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	
	}

/***/ },
/* 588 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.loopAsync = loopAsync;
	exports.mapAsync = mapAsync;
	function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var sync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  function done() {
	    isDone = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = [].concat(Array.prototype.slice.call(arguments));
	      return;
	    }
	
	    callback.apply(this, arguments);
	  }
	
	  function next() {
	    if (isDone) {
	      return;
	    }
	
	    hasNext = true;
	    if (sync) {
	      // Iterate instead of recursing if possible.
	      return;
	    }
	
	    sync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work.call(this, currentTurn++, next, done);
	    }
	
	    sync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(this, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  }
	
	  next();
	}
	
	function mapAsync(array, work, callback) {
	  var length = array.length;
	  var values = [];
	
	  if (length === 0) return callback(null, values);
	
	  var isDone = false,
	      doneCount = 0;
	
	  function done(index, error, value) {
	    if (isDone) return;
	
	    if (error) {
	      isDone = true;
	      callback(error);
	    } else {
	      values[index] = value;
	
	      isDone = ++doneCount === length;
	
	      if (isDone) callback(null, values);
	    }
	  }
	
	  array.forEach(function (item, index) {
	    work(item, index, function (error, value) {
	      done(index, error, value);
	    });
	  });
	}

/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ContextProvider = ContextProvider;
	exports.ContextSubscriber = ContextSubscriber;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Works around issues with context updates failing to propagate.
	// Caveat: the context value is expected to never change its identity.
	// https://github.com/facebook/react/issues/2517
	// https://github.com/reactjs/react-router/issues/470
	
	var contextProviderShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  eventIndex: _propTypes2.default.number.isRequired
	});
	
	function makeContextName(name) {
	  return '@@contextSubscriber/' + name;
	}
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	function ContextProvider(name) {
	  var _childContextTypes, _config;
	
	  var contextName = makeContextName(name);
	  var listenersKey = contextName + '/listeners';
	  var eventIndexKey = contextName + '/eventIndex';
	  var subscribeKey = contextName + '/subscribe';
	
	  var config = (_config = {
	    childContextTypes: (_childContextTypes = {}, _childContextTypes[contextName] = contextProviderShape.isRequired, _childContextTypes),
	
	    getChildContext: function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextName] = {
	        eventIndex: this[eventIndexKey],
	        subscribe: this[subscribeKey]
	      }, _ref;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	    componentWillMount: function componentWillMount() {
	      this[listenersKey] = [];
	      this[eventIndexKey] = 0;
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      this[eventIndexKey]++;
	    },
	    componentDidUpdate: function componentDidUpdate() {
	      var _this = this;
	
	      this[listenersKey].forEach(function (listener) {
	        return listener(_this[eventIndexKey]);
	      });
	    }
	  }, _config[subscribeKey] = function (listener) {
	    var _this2 = this;
	
	    // No need to immediately call listener here.
	    this[listenersKey].push(listener);
	
	    return function () {
	      _this2[listenersKey] = _this2[listenersKey].filter(function (item) {
	        return item !== listener;
	      });
	    };
	  }, _config);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillMount = config.componentWillMount;
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillMount;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}
	
	function ContextSubscriber(name) {
	  var _contextTypes, _config2;
	
	  var contextName = makeContextName(name);
	  var lastRenderedEventIndexKey = contextName + '/lastRenderedEventIndex';
	  var handleContextUpdateKey = contextName + '/handleContextUpdate';
	  var unsubscribeKey = contextName + '/unsubscribe';
	
	  var config = (_config2 = {
	    contextTypes: (_contextTypes = {}, _contextTypes[contextName] = contextProviderShape, _contextTypes),
	
	    getInitialState: function getInitialState() {
	      var _ref2;
	
	      if (!this.context[contextName]) {
	        return {};
	      }
	
	      return _ref2 = {}, _ref2[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _ref2;
	    },
	    componentDidMount: function componentDidMount() {
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this[unsubscribeKey] = this.context[contextName].subscribe(this[handleContextUpdateKey]);
	    },
	
	
	    // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	    componentWillReceiveProps: function componentWillReceiveProps() {
	      var _setState;
	
	      if (!this.context[contextName]) {
	        return;
	      }
	
	      this.setState((_setState = {}, _setState[lastRenderedEventIndexKey] = this.context[contextName].eventIndex, _setState));
	    },
	    componentWillUnmount: function componentWillUnmount() {
	      if (!this[unsubscribeKey]) {
	        return;
	      }
	
	      this[unsubscribeKey]();
	      this[unsubscribeKey] = null;
	    }
	  }, _config2[handleContextUpdateKey] = function (eventIndex) {
	    if (eventIndex !== this.state[lastRenderedEventIndexKey]) {
	      var _setState2;
	
	      this.setState((_setState2 = {}, _setState2[lastRenderedEventIndexKey] = eventIndex, _setState2));
	    }
	  }, _config2);
	
	  if (prefixUnsafeLifecycleMethods) {
	    config.UNSAFE_componentWillReceiveProps = config.componentWillReceiveProps;
	    delete config.componentWillReceiveProps;
	  }
	  return config;
	}

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationShape = exports.routerShape = undefined;
	
	var _propTypes = __webpack_require__(6);
	
	var routerShape = exports.routerShape = (0, _propTypes.shape)({
	  push: _propTypes.func.isRequired,
	  replace: _propTypes.func.isRequired,
	  go: _propTypes.func.isRequired,
	  goBack: _propTypes.func.isRequired,
	  goForward: _propTypes.func.isRequired,
	  setRouteLeaveHook: _propTypes.func.isRequired,
	  isActive: _propTypes.func.isRequired
	});
	
	var locationShape = exports.locationShape = (0, _propTypes.shape)({
	  pathname: _propTypes.string.isRequired,
	  search: _propTypes.string.isRequired,
	  state: _propTypes.object,
	  action: _propTypes.string.isRequired,
	  key: _propTypes.string
	});

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactIs = __webpack_require__(222);
	
	var _createReactClass = __webpack_require__(139);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(6);
	
	var _getRouteParams = __webpack_require__(2872);
	
	var _getRouteParams2 = _interopRequireDefault(_getRouteParams);
	
	var _ContextUtils = __webpack_require__(589);
	
	var _RouteUtils = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <RouterContext> renders the component tree for a given router state
	 * and sets the history object and the current location in context.
	 */
	var RouterContext = (0, _createReactClass2.default)({
	  displayName: 'RouterContext',
	
	  mixins: [(0, _ContextUtils.ContextProvider)('router')],
	
	  propTypes: {
	    router: _propTypes.object.isRequired,
	    location: _propTypes.object.isRequired,
	    routes: _propTypes.array.isRequired,
	    params: _propTypes.object.isRequired,
	    components: _propTypes.array.isRequired,
	    createElement: _propTypes.func.isRequired
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      createElement: _react2.default.createElement
	    };
	  },
	
	
	  childContextTypes: {
	    router: _propTypes.object.isRequired
	  },
	
	  getChildContext: function getChildContext() {
	    return {
	      router: this.props.router
	    };
	  },
	  createElement: function createElement(component, props) {
	    return component == null ? null : this.props.createElement(component, props);
	  },
	  render: function render() {
	    var _this = this;
	
	    var _props = this.props,
	        location = _props.location,
	        routes = _props.routes,
	        params = _props.params,
	        components = _props.components,
	        router = _props.router;
	
	    var element = null;
	
	    if (components) {
	      element = components.reduceRight(function (element, components, index) {
	        if (components == null) return element; // Don't create new children; use the grandchildren.
	
	        var route = routes[index];
	        var routeParams = (0, _getRouteParams2.default)(route, params);
	        var props = {
	          location: location,
	          params: params,
	          route: route,
	          router: router,
	          routeParams: routeParams,
	          routes: routes
	        };
	
	        if ((0, _RouteUtils.isReactChildren)(element)) {
	          props.children = element;
	        } else if (element) {
	          for (var prop in element) {
	            if (Object.prototype.hasOwnProperty.call(element, prop)) props[prop] = element[prop];
	          }
	        }
	
	        // Handle components is object for { [name]: component } but not valid element
	        // type of react, such as React.memo, React.lazy and so on.
	        if ((typeof components === 'undefined' ? 'undefined' : _typeof(components)) === 'object' && !(0, _reactIs.isValidElementType)(components)) {
	          var elements = {};
	
	          for (var key in components) {
	            if (Object.prototype.hasOwnProperty.call(components, key)) {
	              // Pass through the key as a prop to createElement to allow
	              // custom createElement functions to know which named component
	              // they're rendering, for e.g. matching up to fetched data.
	              elements[key] = _this.createElement(components[key], _extends({
	                key: key }, props));
	            }
	          }
	
	          return elements;
	        }
	
	        return _this.createElement(components, props);
	      }, element);
	    }
	
	    !(element === null || element === false || _react2.default.isValidElement(element)) ?  false ? (0, _invariant2.default)(false, 'The root route must render a single element') : (0, _invariant2.default)(false) : void 0;
	
	    return element;
	  }
	});
	
	exports.default = RouterContext;
	module.exports = exports['default'];

/***/ },
/* 592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _keys = __webpack_require__(329);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _JSONArrow = __webpack_require__(1173);
	
	var _JSONArrow2 = _interopRequireDefault(_JSONArrow);
	
	var _getCollectionEntries = __webpack_require__(2921);
	
	var _getCollectionEntries2 = _interopRequireDefault(_getCollectionEntries);
	
	var _JSONNode = __webpack_require__(1174);
	
	var _JSONNode2 = _interopRequireDefault(_JSONNode);
	
	var _ItemRange = __webpack_require__(2915);
	
	var _ItemRange2 = _interopRequireDefault(_ItemRange);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Renders nested values (eg. objects, arrays, lists, etc.)
	 */
	
	function renderChildNodes(props, from, to) {
	  var nodeType = props.nodeType,
	      data = props.data,
	      collectionLimit = props.collectionLimit,
	      circularCache = props.circularCache,
	      keyPath = props.keyPath,
	      postprocessValue = props.postprocessValue,
	      sortObjectKeys = props.sortObjectKeys;
	
	  var childNodes = [];
	
	  (0, _getCollectionEntries2['default'])(nodeType, data, sortObjectKeys, collectionLimit, from, to).forEach(function (entry) {
	    if (entry.to) {
	      childNodes.push(_react2['default'].createElement(_ItemRange2['default'], (0, _extends3['default'])({}, props, {
	        key: 'ItemRange--' + entry.from + '-' + entry.to,
	        from: entry.from,
	        to: entry.to,
	        renderChildNodes: renderChildNodes
	      })));
	    } else {
	      var key = entry.key,
	          value = entry.value;
	
	      var isCircular = circularCache.indexOf(value) !== -1;
	
	      var node = _react2['default'].createElement(_JSONNode2['default'], (0, _extends3['default'])({}, props, { postprocessValue: postprocessValue, collectionLimit: collectionLimit }, {
	        key: 'Node--' + key,
	        keyPath: [key].concat(keyPath),
	        value: postprocessValue(value),
	        circularCache: [].concat(circularCache, [value]),
	        isCircular: isCircular,
	        hideRoot: false
	      }));
	
	      if (node !== false) {
	        childNodes.push(node);
	      }
	    }
	  });
	
	  return childNodes;
	}
	
	function getStateFromProps(props) {
	  // calculate individual node expansion if necessary
	  var expanded = props.shouldExpandNode && !props.isCircular ? props.shouldExpandNode(props.keyPath, props.data, props.level) : false;
	  return {
	    expanded: expanded
	  };
	}
	
	var JSONNestedNode = function (_React$Component) {
	  (0, _inherits3['default'])(JSONNestedNode, _React$Component);
	
	  function JSONNestedNode(props) {
	    (0, _classCallCheck3['default'])(this, JSONNestedNode);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.handleClick = function () {
	      if (_this.props.expandable) {
	        _this.setState({ expanded: !_this.state.expanded });
	      }
	    };
	
	    _this.state = getStateFromProps(props);
	    return _this;
	  }
	
	  JSONNestedNode.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextState = getStateFromProps(nextProps);
	    if (getStateFromProps(this.props).expanded !== nextState.expanded) {
	      this.setState(nextState);
	    }
	  };
	
	  JSONNestedNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
	    var _this2 = this;
	
	    return !!(0, _keys2['default'])(nextProps).find(function (key) {
	      return key !== 'circularCache' && (key === 'keyPath' ? nextProps[key].join('/') !== _this2.props[key].join('/') : nextProps[key] !== _this2.props[key]);
	    }) || nextState.expanded !== this.state.expanded;
	  };
	
	  JSONNestedNode.prototype.render = function render() {
	    var _props = this.props,
	        getItemString = _props.getItemString,
	        nodeTypeIndicator = _props.nodeTypeIndicator,
	        nodeType = _props.nodeType,
	        data = _props.data,
	        hideRoot = _props.hideRoot,
	        createItemString = _props.createItemString,
	        styling = _props.styling,
	        collectionLimit = _props.collectionLimit,
	        keyPath = _props.keyPath,
	        labelRenderer = _props.labelRenderer,
	        expandable = _props.expandable;
	    var expanded = this.state.expanded;
	
	    var renderedChildren = expanded || hideRoot && this.props.level === 0 ? renderChildNodes((0, _extends3['default'])({}, this.props, { level: this.props.level + 1 })) : null;
	
	    var itemType = _react2['default'].createElement(
	      'span',
	      styling('nestedNodeItemType', expanded),
	      nodeTypeIndicator
	    );
	    var renderedItemString = getItemString(nodeType, data, itemType, createItemString(data, collectionLimit));
	    var stylingArgs = [keyPath, nodeType, expanded, expandable];
	
	    return hideRoot ? _react2['default'].createElement(
	      'li',
	      styling.apply(undefined, ['rootNode'].concat(stylingArgs)),
	      _react2['default'].createElement(
	        'ul',
	        styling.apply(undefined, ['rootNodeChildren'].concat(stylingArgs)),
	        renderedChildren
	      )
	    ) : _react2['default'].createElement(
	      'li',
	      styling.apply(undefined, ['nestedNode'].concat(stylingArgs)),
	      expandable && _react2['default'].createElement(_JSONArrow2['default'], {
	        styling: styling,
	        nodeType: nodeType,
	        expanded: expanded,
	        onClick: this.handleClick
	      }),
	      _react2['default'].createElement(
	        'label',
	        (0, _extends3['default'])({}, styling.apply(undefined, [['label', 'nestedNodeLabel']].concat(stylingArgs)), {
	          onClick: this.handleClick
	        }),
	        labelRenderer.apply(undefined, stylingArgs)
	      ),
	      _react2['default'].createElement(
	        'span',
	        (0, _extends3['default'])({}, styling.apply(undefined, ['nestedNodeItemString'].concat(stylingArgs)), {
	          onClick: this.handleClick
	        }),
	        renderedItemString
	      ),
	      _react2['default'].createElement(
	        'ul',
	        styling.apply(undefined, ['nestedNodeChildren'].concat(stylingArgs)),
	        renderedChildren
	      )
	    );
	  };
	
	  return JSONNestedNode;
	}(_react2['default'].Component);
	
	JSONNestedNode.propTypes = {
	  getItemString: _propTypes2['default'].func.isRequired,
	  nodeTypeIndicator: _propTypes2['default'].any,
	  nodeType: _propTypes2['default'].string.isRequired,
	  data: _propTypes2['default'].any,
	  hideRoot: _propTypes2['default'].bool.isRequired,
	  createItemString: _propTypes2['default'].func.isRequired,
	  styling: _propTypes2['default'].func.isRequired,
	  collectionLimit: _propTypes2['default'].number,
	  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
	  labelRenderer: _propTypes2['default'].func.isRequired,
	  shouldExpandNode: _propTypes2['default'].func,
	  level: _propTypes2['default'].number.isRequired,
	  sortObjectKeys: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].bool]),
	  isCircular: _propTypes2['default'].bool,
	  expandable: _propTypes2['default'].bool
	};
	JSONNestedNode.defaultProps = {
	  data: [],
	  circularCache: [],
	  level: 0,
	  expandable: true
	};
	exports['default'] = JSONNestedNode;

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "instrument", {
	  enumerable: true,
	  get: function get() {
	    return _reduxDevtoolsInstrument["default"];
	  }
	});
	Object.defineProperty(exports, "ActionCreators", {
	  enumerable: true,
	  get: function get() {
	    return _reduxDevtoolsInstrument.ActionCreators;
	  }
	});
	Object.defineProperty(exports, "ActionTypes", {
	  enumerable: true,
	  get: function get() {
	    return _reduxDevtoolsInstrument.ActionTypes;
	  }
	});
	Object.defineProperty(exports, "PerformAction", {
	  enumerable: true,
	  get: function get() {
	    return _reduxDevtoolsInstrument.PerformAction;
	  }
	});
	Object.defineProperty(exports, "LiftedAction", {
	  enumerable: true,
	  get: function get() {
	    return _reduxDevtoolsInstrument.LiftedAction;
	  }
	});
	Object.defineProperty(exports, "LiftedState", {
	  enumerable: true,
	  get: function get() {
	    return _reduxDevtoolsInstrument.LiftedState;
	  }
	});
	Object.defineProperty(exports, "persistState", {
	  enumerable: true,
	  get: function get() {
	    return _persistState["default"];
	  }
	});
	Object.defineProperty(exports, "createDevTools", {
	  enumerable: true,
	  get: function get() {
	    return _createDevTools["default"];
	  }
	});
	Object.defineProperty(exports, "Monitor", {
	  enumerable: true,
	  get: function get() {
	    return _createDevTools.Monitor;
	  }
	});
	
	var _reduxDevtoolsInstrument = _interopRequireWildcard(__webpack_require__(1171));
	
	var _persistState = _interopRequireDefault(__webpack_require__(2927));
	
	var _createDevTools = _interopRequireWildcard(__webpack_require__(2926));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQVFBOztBQUNBIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IHtcbiAgZGVmYXVsdCBhcyBpbnN0cnVtZW50LFxuICBBY3Rpb25DcmVhdG9ycyxcbiAgQWN0aW9uVHlwZXMsXG4gIFBlcmZvcm1BY3Rpb24sXG4gIExpZnRlZEFjdGlvbixcbiAgTGlmdGVkU3RhdGUsXG59IGZyb20gJ3JlZHV4LWRldnRvb2xzLWluc3RydW1lbnQnO1xuZXhwb3J0IHsgZGVmYXVsdCBhcyBwZXJzaXN0U3RhdGUgfSBmcm9tICcuL3BlcnNpc3RTdGF0ZSc7XG5leHBvcnQgeyBkZWZhdWx0IGFzIGNyZWF0ZURldlRvb2xzLCBNb25pdG9yIH0gZnJvbSAnLi9jcmVhdGVEZXZUb29scyc7XG4iXX0=

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(184)))

/***/ },
/* 595 */
36,
/* 596 */
36,
/* 597 */
36,
/* 598 */
36,
/* 599 */
36,
/* 600 */
/***/ function(module, exports) {

	// https://github.com/mziccard/node-timsort
	var DEFAULT_MIN_MERGE = 32;
	var DEFAULT_MIN_GALLOPING = 7;
	var DEFAULT_TMP_STORAGE_LENGTH = 256;
	
	function minRunLength(n) {
	  var r = 0;
	
	  while (n >= DEFAULT_MIN_MERGE) {
	    r |= n & 1;
	    n >>= 1;
	  }
	
	  return n + r;
	}
	
	function makeAscendingRun(array, lo, hi, compare) {
	  var runHi = lo + 1;
	
	  if (runHi === hi) {
	    return 1;
	  }
	
	  if (compare(array[runHi++], array[lo]) < 0) {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) < 0) {
	      runHi++;
	    }
	
	    reverseRun(array, lo, runHi);
	  } else {
	    while (runHi < hi && compare(array[runHi], array[runHi - 1]) >= 0) {
	      runHi++;
	    }
	  }
	
	  return runHi - lo;
	}
	
	function reverseRun(array, lo, hi) {
	  hi--;
	
	  while (lo < hi) {
	    var t = array[lo];
	    array[lo++] = array[hi];
	    array[hi--] = t;
	  }
	}
	
	function binaryInsertionSort(array, lo, hi, start, compare) {
	  if (start === lo) {
	    start++;
	  }
	
	  for (; start < hi; start++) {
	    var pivot = array[start];
	    var left = lo;
	    var right = start;
	    var mid;
	
	    while (left < right) {
	      mid = left + right >>> 1;
	
	      if (compare(pivot, array[mid]) < 0) {
	        right = mid;
	      } else {
	        left = mid + 1;
	      }
	    }
	
	    var n = start - left;
	
	    switch (n) {
	      case 3:
	        array[left + 3] = array[left + 2];
	
	      case 2:
	        array[left + 2] = array[left + 1];
	
	      case 1:
	        array[left + 1] = array[left];
	        break;
	
	      default:
	        while (n > 0) {
	          array[left + n] = array[left + n - 1];
	          n--;
	        }
	
	    }
	
	    array[left] = pivot;
	  }
	}
	
	function gallopLeft(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) > 0) {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) > 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  } else {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) <= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) > 0) {
	      lastOffset = m + 1;
	    } else {
	      offset = m;
	    }
	  }
	
	  return offset;
	}
	
	function gallopRight(value, array, start, length, hint, compare) {
	  var lastOffset = 0;
	  var maxOffset = 0;
	  var offset = 1;
	
	  if (compare(value, array[start + hint]) < 0) {
	    maxOffset = hint + 1;
	
	    while (offset < maxOffset && compare(value, array[start + hint - offset]) < 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    var tmp = lastOffset;
	    lastOffset = hint - offset;
	    offset = hint - tmp;
	  } else {
	    maxOffset = length - hint;
	
	    while (offset < maxOffset && compare(value, array[start + hint + offset]) >= 0) {
	      lastOffset = offset;
	      offset = (offset << 1) + 1;
	
	      if (offset <= 0) {
	        offset = maxOffset;
	      }
	    }
	
	    if (offset > maxOffset) {
	      offset = maxOffset;
	    }
	
	    lastOffset += hint;
	    offset += hint;
	  }
	
	  lastOffset++;
	
	  while (lastOffset < offset) {
	    var m = lastOffset + (offset - lastOffset >>> 1);
	
	    if (compare(value, array[start + m]) < 0) {
	      offset = m;
	    } else {
	      lastOffset = m + 1;
	    }
	  }
	
	  return offset;
	}
	
	function TimSort(array, compare) {
	  var minGallop = DEFAULT_MIN_GALLOPING;
	  var length = 0;
	  var tmpStorageLength = DEFAULT_TMP_STORAGE_LENGTH;
	  var stackLength = 0;
	  var runStart;
	  var runLength;
	  var stackSize = 0;
	  length = array.length;
	
	  if (length < 2 * DEFAULT_TMP_STORAGE_LENGTH) {
	    tmpStorageLength = length >>> 1;
	  }
	
	  var tmp = [];
	  stackLength = length < 120 ? 5 : length < 1542 ? 10 : length < 119151 ? 19 : 40;
	  runStart = [];
	  runLength = [];
	
	  function pushRun(_runStart, _runLength) {
	    runStart[stackSize] = _runStart;
	    runLength[stackSize] = _runLength;
	    stackSize += 1;
	  }
	
	  function mergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n >= 1 && runLength[n - 1] <= runLength[n] + runLength[n + 1] || n >= 2 && runLength[n - 2] <= runLength[n] + runLength[n - 1]) {
	        if (runLength[n - 1] < runLength[n + 1]) {
	          n--;
	        }
	      } else if (runLength[n] > runLength[n + 1]) {
	        break;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function forceMergeRuns() {
	    while (stackSize > 1) {
	      var n = stackSize - 2;
	
	      if (n > 0 && runLength[n - 1] < runLength[n + 1]) {
	        n--;
	      }
	
	      mergeAt(n);
	    }
	  }
	
	  function mergeAt(i) {
	    var start1 = runStart[i];
	    var length1 = runLength[i];
	    var start2 = runStart[i + 1];
	    var length2 = runLength[i + 1];
	    runLength[i] = length1 + length2;
	
	    if (i === stackSize - 3) {
	      runStart[i + 1] = runStart[i + 2];
	      runLength[i + 1] = runLength[i + 2];
	    }
	
	    stackSize--;
	    var k = gallopRight(array[start2], array, start1, length1, 0, compare);
	    start1 += k;
	    length1 -= k;
	
	    if (length1 === 0) {
	      return;
	    }
	
	    length2 = gallopLeft(array[start1 + length1 - 1], array, start2, length2, length2 - 1, compare);
	
	    if (length2 === 0) {
	      return;
	    }
	
	    if (length1 <= length2) {
	      mergeLow(start1, length1, start2, length2);
	    } else {
	      mergeHigh(start1, length1, start2, length2);
	    }
	  }
	
	  function mergeLow(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length1; i++) {
	      tmp[i] = array[start1 + i];
	    }
	
	    var cursor1 = 0;
	    var cursor2 = start2;
	    var dest = start1;
	    array[dest++] = array[cursor2++];
	
	    if (--length2 === 0) {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	
	      return;
	    }
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	      return;
	    }
	
	    var _minGallop = minGallop;
	    var count1;
	    var count2;
	    var exit;
	
	    while (1) {
	      count1 = 0;
	      count2 = 0;
	      exit = false;
	
	      do {
	        if (compare(array[cursor2], tmp[cursor1]) < 0) {
	          array[dest++] = array[cursor2++];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest++] = tmp[cursor1++];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = gallopRight(array[cursor2], tmp, cursor1, length1, 0, compare);
	
	        if (count1 !== 0) {
	          for (i = 0; i < count1; i++) {
	            array[dest + i] = tmp[cursor1 + i];
	          }
	
	          dest += count1;
	          cursor1 += count1;
	          length1 -= count1;
	
	          if (length1 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = array[cursor2++];
	
	        if (--length2 === 0) {
	          exit = true;
	          break;
	        }
	
	        count2 = gallopLeft(tmp[cursor1], array, cursor2, length2, 0, compare);
	
	        if (count2 !== 0) {
	          for (i = 0; i < count2; i++) {
	            array[dest + i] = array[cursor2 + i];
	          }
	
	          dest += count2;
	          cursor2 += count2;
	          length2 -= count2;
	
	          if (length2 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest++] = tmp[cursor1++];
	
	        if (--length1 === 1) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	    minGallop < 1 && (minGallop = 1);
	
	    if (length1 === 1) {
	      for (i = 0; i < length2; i++) {
	        array[dest + i] = array[cursor2 + i];
	      }
	
	      array[dest + length2] = tmp[cursor1];
	    } else if (length1 === 0) {
	      throw new Error(); // throw new Error('mergeLow preconditions were not respected');
	    } else {
	      for (i = 0; i < length1; i++) {
	        array[dest + i] = tmp[cursor1 + i];
	      }
	    }
	  }
	
	  function mergeHigh(start1, length1, start2, length2) {
	    var i = 0;
	
	    for (i = 0; i < length2; i++) {
	      tmp[i] = array[start2 + i];
	    }
	
	    var cursor1 = start1 + length1 - 1;
	    var cursor2 = length2 - 1;
	    var dest = start2 + length2 - 1;
	    var customCursor = 0;
	    var customDest = 0;
	    array[dest--] = array[cursor1--];
	
	    if (--length1 === 0) {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	
	      return;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	      return;
	    }
	
	    var _minGallop = minGallop;
	
	    while (true) {
	      var count1 = 0;
	      var count2 = 0;
	      var exit = false;
	
	      do {
	        if (compare(tmp[cursor2], array[cursor1]) < 0) {
	          array[dest--] = array[cursor1--];
	          count1++;
	          count2 = 0;
	
	          if (--length1 === 0) {
	            exit = true;
	            break;
	          }
	        } else {
	          array[dest--] = tmp[cursor2--];
	          count2++;
	          count1 = 0;
	
	          if (--length2 === 1) {
	            exit = true;
	            break;
	          }
	        }
	      } while ((count1 | count2) < _minGallop);
	
	      if (exit) {
	        break;
	      }
	
	      do {
	        count1 = length1 - gallopRight(tmp[cursor2], array, start1, length1, length1 - 1, compare);
	
	        if (count1 !== 0) {
	          dest -= count1;
	          cursor1 -= count1;
	          length1 -= count1;
	          customDest = dest + 1;
	          customCursor = cursor1 + 1;
	
	          for (i = count1 - 1; i >= 0; i--) {
	            array[customDest + i] = array[customCursor + i];
	          }
	
	          if (length1 === 0) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = tmp[cursor2--];
	
	        if (--length2 === 1) {
	          exit = true;
	          break;
	        }
	
	        count2 = length2 - gallopLeft(array[cursor1], tmp, 0, length2, length2 - 1, compare);
	
	        if (count2 !== 0) {
	          dest -= count2;
	          cursor2 -= count2;
	          length2 -= count2;
	          customDest = dest + 1;
	          customCursor = cursor2 + 1;
	
	          for (i = 0; i < count2; i++) {
	            array[customDest + i] = tmp[customCursor + i];
	          }
	
	          if (length2 <= 1) {
	            exit = true;
	            break;
	          }
	        }
	
	        array[dest--] = array[cursor1--];
	
	        if (--length1 === 0) {
	          exit = true;
	          break;
	        }
	
	        _minGallop--;
	      } while (count1 >= DEFAULT_MIN_GALLOPING || count2 >= DEFAULT_MIN_GALLOPING);
	
	      if (exit) {
	        break;
	      }
	
	      if (_minGallop < 0) {
	        _minGallop = 0;
	      }
	
	      _minGallop += 2;
	    }
	
	    minGallop = _minGallop;
	
	    if (minGallop < 1) {
	      minGallop = 1;
	    }
	
	    if (length2 === 1) {
	      dest -= length1;
	      cursor1 -= length1;
	      customDest = dest + 1;
	      customCursor = cursor1 + 1;
	
	      for (i = length1 - 1; i >= 0; i--) {
	        array[customDest + i] = array[customCursor + i];
	      }
	
	      array[dest] = tmp[cursor2];
	    } else if (length2 === 0) {
	      throw new Error(); // throw new Error('mergeHigh preconditions were not respected');
	    } else {
	      customCursor = dest - (length2 - 1);
	
	      for (i = 0; i < length2; i++) {
	        array[customCursor + i] = tmp[i];
	      }
	    }
	  }
	
	  this.mergeRuns = mergeRuns;
	  this.forceMergeRuns = forceMergeRuns;
	  this.pushRun = pushRun;
	}
	
	function sort(array, compare, lo, hi) {
	  if (!lo) {
	    lo = 0;
	  }
	
	  if (!hi) {
	    hi = array.length;
	  }
	
	  var remaining = hi - lo;
	
	  if (remaining < 2) {
	    return;
	  }
	
	  var runLength = 0;
	
	  if (remaining < DEFAULT_MIN_MERGE) {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	    binaryInsertionSort(array, lo, hi, lo + runLength, compare);
	    return;
	  }
	
	  var ts = new TimSort(array, compare);
	  var minRun = minRunLength(remaining);
	
	  do {
	    runLength = makeAscendingRun(array, lo, hi, compare);
	
	    if (runLength < minRun) {
	      var force = remaining;
	
	      if (force > minRun) {
	        force = minRun;
	      }
	
	      binaryInsertionSort(array, lo, lo + force, lo + runLength, compare);
	      runLength = force;
	    }
	
	    ts.pushRun(lo, runLength);
	    ts.mergeRuns();
	    remaining -= runLength;
	    lo += runLength;
	  } while (remaining !== 0);
	
	  ts.forceMergeRuns();
	}
	
	module.exports = sort;

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(4);
	
	var inherits = _util.inherits;
	
	var Displayble = __webpack_require__(316);
	
	var BoundingRect = __webpack_require__(60);
	
	/**
	 * Displayable for incremental rendering. It will be rendered in a separate layer
	 * IncrementalDisplay have two main methods. `clearDisplayables` and `addDisplayables`
	 * addDisplayables will render the added displayables incremetally.
	 *
	 * It use a not clearFlag to tell the painter don't clear the layer if it's the first element.
	 */
	// TODO Style override ?
	function IncrementalDisplayble(opts) {
	  Displayble.call(this, opts);
	  this._displayables = [];
	  this._temporaryDisplayables = [];
	  this._cursor = 0;
	  this.notClear = true;
	}
	
	IncrementalDisplayble.prototype.incremental = true;
	
	IncrementalDisplayble.prototype.clearDisplaybles = function () {
	  this._displayables = [];
	  this._temporaryDisplayables = [];
	  this._cursor = 0;
	  this.dirty();
	  this.notClear = false;
	};
	
	IncrementalDisplayble.prototype.addDisplayable = function (displayable, notPersistent) {
	  if (notPersistent) {
	    this._temporaryDisplayables.push(displayable);
	  } else {
	    this._displayables.push(displayable);
	  }
	
	  this.dirty();
	};
	
	IncrementalDisplayble.prototype.addDisplayables = function (displayables, notPersistent) {
	  notPersistent = notPersistent || false;
	
	  for (var i = 0; i < displayables.length; i++) {
	    this.addDisplayable(displayables[i], notPersistent);
	  }
	};
	
	IncrementalDisplayble.prototype.eachPendingDisplayable = function (cb) {
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    cb && cb(this._displayables[i]);
	  }
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    cb && cb(this._temporaryDisplayables[i]);
	  }
	};
	
	IncrementalDisplayble.prototype.update = function () {
	  this.updateTransform();
	
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    var displayable = this._displayables[i]; // PENDING
	
	    displayable.parent = this;
	    displayable.update();
	    displayable.parent = null;
	  }
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    var displayable = this._temporaryDisplayables[i]; // PENDING
	
	    displayable.parent = this;
	    displayable.update();
	    displayable.parent = null;
	  }
	};
	
	IncrementalDisplayble.prototype.brush = function (ctx, prevEl) {
	  // Render persistant displayables.
	  for (var i = this._cursor; i < this._displayables.length; i++) {
	    var displayable = this._displayables[i];
	    displayable.beforeBrush && displayable.beforeBrush(ctx);
	    displayable.brush(ctx, i === this._cursor ? null : this._displayables[i - 1]);
	    displayable.afterBrush && displayable.afterBrush(ctx);
	  }
	
	  this._cursor = i; // Render temporary displayables.
	
	  for (var i = 0; i < this._temporaryDisplayables.length; i++) {
	    var displayable = this._temporaryDisplayables[i];
	    displayable.beforeBrush && displayable.beforeBrush(ctx);
	    displayable.brush(ctx, i === 0 ? null : this._temporaryDisplayables[i - 1]);
	    displayable.afterBrush && displayable.afterBrush(ctx);
	  }
	
	  this._temporaryDisplayables = [];
	  this.notClear = true;
	};
	
	var m = [];
	
	IncrementalDisplayble.prototype.getBoundingRect = function () {
	  if (!this._rect) {
	    var rect = new BoundingRect(Infinity, Infinity, -Infinity, -Infinity);
	
	    for (var i = 0; i < this._displayables.length; i++) {
	      var displayable = this._displayables[i];
	      var childRect = displayable.getBoundingRect().clone();
	
	      if (displayable.needLocalTransform()) {
	        childRect.applyTransform(displayable.getLocalTransform(m));
	      }
	
	      rect.union(childRect);
	    }
	
	    this._rect = rect;
	  }
	
	  return this._rect;
	};
	
	IncrementalDisplayble.prototype.contain = function (x, y) {
	  var localPos = this.transformCoordToLocal(x, y);
	  var rect = this.getBoundingRect();
	
	  if (rect.contain(localPos[0], localPos[1])) {
	    for (var i = 0; i < this._displayables.length; i++) {
	      var displayable = this._displayables[i];
	
	      if (displayable.contain(x, y)) {
	        return true;
	      }
	    }
	  }
	
	  return false;
	};
	
	inherits(IncrementalDisplayble, Displayble);
	var _default = IncrementalDisplayble;
	module.exports = _default;

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(4);
	
	var Gradient = __webpack_require__(393);
	
	/**
	 * x, y, x2, y2 are all percent from 0 to 1
	 * @param {number} [x=0]
	 * @param {number} [y=0]
	 * @param {number} [x2=1]
	 * @param {number} [y2=0]
	 * @param {Array.<Object>} colorStops
	 * @param {boolean} [globalCoord=false]
	 */
	var LinearGradient = function (x, y, x2, y2, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'linear', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0 : x;
	  this.y = y == null ? 0 : y;
	  this.x2 = x2 == null ? 1 : x2;
	  this.y2 = y2 == null ? 0 : y2; // Can be cloned
	
	  this.type = 'linear'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	LinearGradient.prototype = {
	  constructor: LinearGradient
	};
	zrUtil.inherits(LinearGradient, Gradient);
	var _default = LinearGradient;
	module.exports = _default;

/***/ },
/* 603 */
/***/ function(module, exports, __webpack_require__) {

	var fixShadow = __webpack_require__(1200);
	
	var _constant = __webpack_require__(394);
	
	var ContextCachedBy = _constant.ContextCachedBy;
	var STYLE_COMMON_PROPS = [['shadowBlur', 0], ['shadowOffsetX', 0], ['shadowOffsetY', 0], ['shadowColor', '#000'], ['lineCap', 'butt'], ['lineJoin', 'miter'], ['miterLimit', 10]]; // var SHADOW_PROPS = STYLE_COMMON_PROPS.slice(0, 4);
	// var LINE_PROPS = STYLE_COMMON_PROPS.slice(4);
	
	var Style = function (opts) {
	  this.extendFrom(opts, false);
	};
	
	function createLinearGradient(ctx, obj, rect) {
	  var x = obj.x == null ? 0 : obj.x;
	  var x2 = obj.x2 == null ? 1 : obj.x2;
	  var y = obj.y == null ? 0 : obj.y;
	  var y2 = obj.y2 == null ? 0 : obj.y2;
	
	  if (!obj.global) {
	    x = x * rect.width + rect.x;
	    x2 = x2 * rect.width + rect.x;
	    y = y * rect.height + rect.y;
	    y2 = y2 * rect.height + rect.y;
	  } // Fix NaN when rect is Infinity
	
	
	  x = isNaN(x) ? 0 : x;
	  x2 = isNaN(x2) ? 1 : x2;
	  y = isNaN(y) ? 0 : y;
	  y2 = isNaN(y2) ? 0 : y2;
	  var canvasGradient = ctx.createLinearGradient(x, y, x2, y2);
	  return canvasGradient;
	}
	
	function createRadialGradient(ctx, obj, rect) {
	  var width = rect.width;
	  var height = rect.height;
	  var min = Math.min(width, height);
	  var x = obj.x == null ? 0.5 : obj.x;
	  var y = obj.y == null ? 0.5 : obj.y;
	  var r = obj.r == null ? 0.5 : obj.r;
	
	  if (!obj.global) {
	    x = x * width + rect.x;
	    y = y * height + rect.y;
	    r = r * min;
	  }
	
	  var canvasGradient = ctx.createRadialGradient(x, y, 0, x, y, r);
	  return canvasGradient;
	}
	
	Style.prototype = {
	  constructor: Style,
	
	  /**
	   * @type {string}
	   */
	  fill: '#000',
	
	  /**
	   * @type {string}
	   */
	  stroke: null,
	
	  /**
	   * @type {number}
	   */
	  opacity: 1,
	
	  /**
	   * @type {number}
	   */
	  fillOpacity: null,
	
	  /**
	   * @type {number}
	   */
	  strokeOpacity: null,
	
	  /**
	   * `true` is not supported.
	   * `false`/`null`/`undefined` are the same.
	   * `false` is used to remove lineDash in some
	   * case that `null`/`undefined` can not be set.
	   * (e.g., emphasis.lineStyle in echarts)
	   * @type {Array.<number>|boolean}
	   */
	  lineDash: null,
	
	  /**
	   * @type {number}
	   */
	  lineDashOffset: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  shadowOffsetY: 0,
	
	  /**
	   * @type {number}
	   */
	  lineWidth: 1,
	
	  /**
	   * If stroke ignore scale
	   * @type {Boolean}
	   */
	  strokeNoScale: false,
	  // Bounding rect text configuration
	  // Not affected by element transform
	
	  /**
	   * @type {string}
	   */
	  text: null,
	
	  /**
	   * If `fontSize` or `fontFamily` exists, `font` will be reset by
	   * `fontSize`, `fontStyle`, `fontWeight`, `fontFamily`.
	   * So do not visit it directly in upper application (like echarts),
	   * but use `contain/text#makeFont` instead.
	   * @type {string}
	   */
	  font: null,
	
	  /**
	   * The same as font. Use font please.
	   * @deprecated
	   * @type {string}
	   */
	  textFont: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontStyle: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontWeight: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * Should be 12 but not '12px'.
	   * @type {number}
	   */
	  fontSize: null,
	
	  /**
	   * It helps merging respectively, rather than parsing an entire font string.
	   * @type {string}
	   */
	  fontFamily: null,
	
	  /**
	   * Reserved for special functinality, like 'hr'.
	   * @type {string}
	   */
	  textTag: null,
	
	  /**
	   * @type {string}
	   */
	  textFill: '#000',
	
	  /**
	   * @type {string}
	   */
	  textStroke: null,
	
	  /**
	   * @type {number}
	   */
	  textWidth: null,
	
	  /**
	   * Only for textBackground.
	   * @type {number}
	   */
	  textHeight: null,
	
	  /**
	   * textStroke may be set as some color as a default
	   * value in upper applicaion, where the default value
	   * of textStrokeWidth should be 0 to make sure that
	   * user can choose to do not use text stroke.
	   * @type {number}
	   */
	  textStrokeWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textLineHeight: null,
	
	  /**
	   * 'inside', 'left', 'right', 'top', 'bottom'
	   * [x, y]
	   * Based on x, y of rect.
	   * @type {string|Array.<number>}
	   * @default 'inside'
	   */
	  textPosition: 'inside',
	
	  /**
	   * If not specified, use the boundingRect of a `displayable`.
	   * @type {Object}
	   */
	  textRect: null,
	
	  /**
	   * [x, y]
	   * @type {Array.<number>}
	   */
	  textOffset: null,
	
	  /**
	   * @type {string}
	   */
	  textAlign: null,
	
	  /**
	   * @type {string}
	   */
	  textVerticalAlign: null,
	
	  /**
	   * @type {number}
	   */
	  textDistance: 5,
	
	  /**
	   * @type {string}
	   */
	  textShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textShadowOffsetY: 0,
	
	  /**
	   * @type {string}
	   */
	  textBoxShadowColor: 'transparent',
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowBlur: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetX: 0,
	
	  /**
	   * @type {number}
	   */
	  textBoxShadowOffsetY: 0,
	
	  /**
	   * Whether transform text.
	   * Only available in Path and Image element,
	   * where the text is called as `RectText`.
	   * @type {boolean}
	   */
	  transformText: false,
	
	  /**
	   * Text rotate around position of Path or Image.
	   * The origin of the rotation can be specified by `textOrigin`.
	   * Only available in Path and Image element,
	   * where the text is called as `RectText`.
	   */
	  textRotation: 0,
	
	  /**
	   * Text origin of text rotation.
	   * Useful in the case like label rotation of circular symbol.
	   * Only available in Path and Image element, where the text is called
	   * as `RectText` and the element is called as "host element".
	   * The value can be:
	   * + If specified as a coordinate like `[10, 40]`, it is the `[x, y]`
	   * base on the left-top corner of the rect of its host element.
	   * + If specified as a string `center`, it is the center of the rect of
	   * its host element.
	   * + By default, this origin is the `textPosition`.
	   * @type {string|Array.<number>}
	   */
	  textOrigin: null,
	
	  /**
	   * @type {string}
	   */
	  textBackgroundColor: null,
	
	  /**
	   * @type {string}
	   */
	  textBorderColor: null,
	
	  /**
	   * @type {number}
	   */
	  textBorderWidth: 0,
	
	  /**
	   * @type {number}
	   */
	  textBorderRadius: 0,
	
	  /**
	   * Can be `2` or `[2, 4]` or `[2, 3, 4, 5]`
	   * @type {number|Array.<number>}
	   */
	  textPadding: null,
	
	  /**
	   * Text styles for rich text.
	   * @type {Object}
	   */
	  rich: null,
	
	  /**
	   * {outerWidth, outerHeight, ellipsis, placeholder}
	   * @type {Object}
	   */
	  truncate: null,
	
	  /**
	   * https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	   * @type {string}
	   */
	  blend: null,
	
	  /**
	   * @param {CanvasRenderingContext2D} ctx
	   */
	  bind: function (ctx, el, prevEl) {
	    var style = this;
	    var prevStyle = prevEl && prevEl.style; // If no prevStyle, it means first draw.
	    // Only apply cache if the last time cachced by this function.
	
	    var notCheckCache = !prevStyle || ctx.__attrCachedBy !== ContextCachedBy.STYLE_BIND;
	    ctx.__attrCachedBy = ContextCachedBy.STYLE_BIND;
	
	    for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	      var prop = STYLE_COMMON_PROPS[i];
	      var styleName = prop[0];
	
	      if (notCheckCache || style[styleName] !== prevStyle[styleName]) {
	        // FIXME Invalid property value will cause style leak from previous element.
	        ctx[styleName] = fixShadow(ctx, styleName, style[styleName] || prop[1]);
	      }
	    }
	
	    if (notCheckCache || style.fill !== prevStyle.fill) {
	      ctx.fillStyle = style.fill;
	    }
	
	    if (notCheckCache || style.stroke !== prevStyle.stroke) {
	      ctx.strokeStyle = style.stroke;
	    }
	
	    if (notCheckCache || style.opacity !== prevStyle.opacity) {
	      ctx.globalAlpha = style.opacity == null ? 1 : style.opacity;
	    }
	
	    if (notCheckCache || style.blend !== prevStyle.blend) {
	      ctx.globalCompositeOperation = style.blend || 'source-over';
	    }
	
	    if (this.hasStroke()) {
	      var lineWidth = style.lineWidth;
	      ctx.lineWidth = lineWidth / (this.strokeNoScale && el && el.getLineScale ? el.getLineScale() : 1);
	    }
	  },
	  hasFill: function () {
	    var fill = this.fill;
	    return fill != null && fill !== 'none';
	  },
	  hasStroke: function () {
	    var stroke = this.stroke;
	    return stroke != null && stroke !== 'none' && this.lineWidth > 0;
	  },
	
	  /**
	   * Extend from other style
	   * @param {zrender/graphic/Style} otherStyle
	   * @param {boolean} overwrite true: overwrirte any way.
	   *                            false: overwrite only when !target.hasOwnProperty
	   *                            others: overwrite when property is not null/undefined.
	   */
	  extendFrom: function (otherStyle, overwrite) {
	    if (otherStyle) {
	      for (var name in otherStyle) {
	        if (otherStyle.hasOwnProperty(name) && (overwrite === true || (overwrite === false ? !this.hasOwnProperty(name) : otherStyle[name] != null))) {
	          this[name] = otherStyle[name];
	        }
	      }
	    }
	  },
	
	  /**
	   * Batch setting style with a given object
	   * @param {Object|string} obj
	   * @param {*} [obj]
	   */
	  set: function (obj, value) {
	    if (typeof obj === 'string') {
	      this[obj] = value;
	    } else {
	      this.extendFrom(obj, true);
	    }
	  },
	
	  /**
	   * Clone
	   * @return {zrender/graphic/Style} [description]
	   */
	  clone: function () {
	    var newStyle = new this.constructor();
	    newStyle.extendFrom(this, true);
	    return newStyle;
	  },
	  getGradient: function (ctx, obj, rect) {
	    var method = obj.type === 'radial' ? createRadialGradient : createLinearGradient;
	    var canvasGradient = method(ctx, obj, rect);
	    var colorStops = obj.colorStops;
	
	    for (var i = 0; i < colorStops.length; i++) {
	      canvasGradient.addColorStop(colorStops[i].offset, colorStops[i].color);
	    }
	
	    return canvasGradient;
	  }
	};
	var styleProto = Style.prototype;
	
	for (var i = 0; i < STYLE_COMMON_PROPS.length; i++) {
	  var prop = STYLE_COMMON_PROPS[i];
	
	  if (!(prop[0] in styleProto)) {
	    styleProto[prop[0]] = prop[1];
	  }
	} // Provide for others
	
	
	Style.getGradient = styleProto.getGradient;
	var _default = Style;
	module.exports = _default;

/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	var LRU = __webpack_require__(1195);
	
	var globalImageCache = new LRU(50);
	/**
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	function findExistImage(newImageOrSrc) {
	  if (typeof newImageOrSrc === 'string') {
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    return cachedImgObj && cachedImgObj.image;
	  } else {
	    return newImageOrSrc;
	  }
	}
	/**
	 * Caution: User should cache loaded images, but not just count on LRU.
	 * Consider if required images more than LRU size, will dead loop occur?
	 *
	 * @param {string|HTMLImageElement|HTMLCanvasElement|Canvas} newImageOrSrc
	 * @param {HTMLImageElement|HTMLCanvasElement|Canvas} image Existent image.
	 * @param {module:zrender/Element} [hostEl] For calling `dirty`.
	 * @param {Function} [cb] params: (image, cbPayload)
	 * @param {Object} [cbPayload] Payload on cb calling.
	 * @return {HTMLImageElement|HTMLCanvasElement|Canvas} image
	 */
	
	
	function createOrUpdateImage(newImageOrSrc, image, hostEl, cb, cbPayload) {
	  if (!newImageOrSrc) {
	    return image;
	  } else if (typeof newImageOrSrc === 'string') {
	    // Image should not be loaded repeatly.
	    if (image && image.__zrImageSrc === newImageOrSrc || !hostEl) {
	      return image;
	    } // Only when there is no existent image or existent image src
	    // is different, this method is responsible for load.
	
	
	    var cachedImgObj = globalImageCache.get(newImageOrSrc);
	    var pendingWrap = {
	      hostEl: hostEl,
	      cb: cb,
	      cbPayload: cbPayload
	    };
	
	    if (cachedImgObj) {
	      image = cachedImgObj.image;
	      !isImageReady(image) && cachedImgObj.pending.push(pendingWrap);
	    } else {
	      image = new Image();
	      image.onload = image.onerror = imageOnLoad;
	      globalImageCache.put(newImageOrSrc, image.__cachedImgObj = {
	        image: image,
	        pending: [pendingWrap]
	      });
	      image.src = image.__zrImageSrc = newImageOrSrc;
	    }
	
	    return image;
	  } // newImageOrSrc is an HTMLImageElement or HTMLCanvasElement or Canvas
	  else {
	      return newImageOrSrc;
	    }
	}
	
	function imageOnLoad() {
	  var cachedImgObj = this.__cachedImgObj;
	  this.onload = this.onerror = this.__cachedImgObj = null;
	
	  for (var i = 0; i < cachedImgObj.pending.length; i++) {
	    var pendingWrap = cachedImgObj.pending[i];
	    var cb = pendingWrap.cb;
	    cb && cb(this, pendingWrap.cbPayload);
	    pendingWrap.hostEl.dirty();
	  }
	
	  cachedImgObj.pending.length = 0;
	}
	
	function isImageReady(image) {
	  return image && image.width && image.height;
	}
	
	exports.findExistImage = findExistImage;
	exports.createOrUpdateImage = createOrUpdateImage;
	exports.isImageReady = isImageReady;

/***/ },
/* 605 */
/***/ function(module, exports) {

	/**
	 * Sub-pixel optimize for canvas rendering, prevent from blur
	 * when rendering a thin vertical/horizontal line.
	 */
	var round = Math.round;
	/**
	 * Sub pixel optimize line for canvas
	 *
	 * @param {Object} outputShape The modification will be performed on `outputShape`.
	 *                 `outputShape` and `inputShape` can be the same object.
	 *                 `outputShape` object can be used repeatly, because all of
	 *                 the `x1`, `x2`, `y1`, `y2` will be assigned in this method.
	 * @param {Object} [inputShape]
	 * @param {number} [inputShape.x1]
	 * @param {number} [inputShape.y1]
	 * @param {number} [inputShape.x2]
	 * @param {number} [inputShape.y2]
	 * @param {Object} [style]
	 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
	 */
	
	function subPixelOptimizeLine(outputShape, inputShape, style) {
	  if (!inputShape) {
	    return;
	  }
	
	  var x1 = inputShape.x1;
	  var x2 = inputShape.x2;
	  var y1 = inputShape.y1;
	  var y2 = inputShape.y2;
	  outputShape.x1 = x1;
	  outputShape.x2 = x2;
	  outputShape.y1 = y1;
	  outputShape.y2 = y2;
	  var lineWidth = style && style.lineWidth;
	
	  if (!lineWidth) {
	    return;
	  }
	
	  if (round(x1 * 2) === round(x2 * 2)) {
	    outputShape.x1 = outputShape.x2 = subPixelOptimize(x1, lineWidth, true);
	  }
	
	  if (round(y1 * 2) === round(y2 * 2)) {
	    outputShape.y1 = outputShape.y2 = subPixelOptimize(y1, lineWidth, true);
	  }
	}
	/**
	 * Sub pixel optimize rect for canvas
	 *
	 * @param {Object} outputShape The modification will be performed on `outputShape`.
	 *                 `outputShape` and `inputShape` can be the same object.
	 *                 `outputShape` object can be used repeatly, because all of
	 *                 the `x`, `y`, `width`, `height` will be assigned in this method.
	 * @param {Object} [inputShape]
	 * @param {number} [inputShape.x]
	 * @param {number} [inputShape.y]
	 * @param {number} [inputShape.width]
	 * @param {number} [inputShape.height]
	 * @param {Object} [style]
	 * @param {number} [style.lineWidth] If `null`/`undefined`/`0`, do not optimize.
	 */
	
	
	function subPixelOptimizeRect(outputShape, inputShape, style) {
	  if (!inputShape) {
	    return;
	  }
	
	  var originX = inputShape.x;
	  var originY = inputShape.y;
	  var originWidth = inputShape.width;
	  var originHeight = inputShape.height;
	  outputShape.x = originX;
	  outputShape.y = originY;
	  outputShape.width = originWidth;
	  outputShape.height = originHeight;
	  var lineWidth = style && style.lineWidth;
	
	  if (!lineWidth) {
	    return;
	  }
	
	  outputShape.x = subPixelOptimize(originX, lineWidth, true);
	  outputShape.y = subPixelOptimize(originY, lineWidth, true);
	  outputShape.width = Math.max(subPixelOptimize(originX + originWidth, lineWidth, false) - outputShape.x, originWidth === 0 ? 0 : 1);
	  outputShape.height = Math.max(subPixelOptimize(originY + originHeight, lineWidth, false) - outputShape.y, originHeight === 0 ? 0 : 1);
	}
	/**
	 * Sub pixel optimize for canvas
	 *
	 * @param {number} position Coordinate, such as x, y
	 * @param {number} lineWidth If `null`/`undefined`/`0`, do not optimize.
	 * @param {boolean=} positiveOrNegative Default false (negative).
	 * @return {number} Optimized position.
	 */
	
	
	function subPixelOptimize(position, lineWidth, positiveOrNegative) {
	  if (!lineWidth) {
	    return position;
	  } // Assure that (position + lineWidth / 2) is near integer edge,
	  // otherwise line will be fuzzy in canvas.
	
	
	  var doubledPosition = round(position * 2);
	  return (doubledPosition + round(lineWidth)) % 2 === 0 ? doubledPosition / 2 : (doubledPosition + (positiveOrNegative ? 1 : -1)) / 2;
	}
	
	exports.subPixelOptimizeLine = subPixelOptimizeLine;
	exports.subPixelOptimizeRect = subPixelOptimizeRect;
	exports.subPixelOptimize = subPixelOptimize;

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	var roundRectHelper = __webpack_require__(1202);
	
	var _subPixelOptimize = __webpack_require__(605);
	
	var subPixelOptimizeRect = _subPixelOptimize.subPixelOptimizeRect;
	
	/**
	 * 矩形
	 * @module zrender/graphic/shape/Rect
	 */
	// Avoid create repeatly.
	var subPixelOptimizeOutputShape = {};
	
	var _default = Path.extend({
	  type: 'rect',
	  shape: {
	    // 左上、右上、右下、左下角的半径依次为r1、r2、r3、r4
	    // r缩写为1         相当于 [1, 1, 1, 1]
	    // r缩写为[1]       相当于 [1, 1, 1, 1]
	    // r缩写为[1, 2]    相当于 [1, 2, 1, 2]
	    // r缩写为[1, 2, 3] 相当于 [1, 2, 3, 2]
	    r: 0,
	    x: 0,
	    y: 0,
	    width: 0,
	    height: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x;
	    var y;
	    var width;
	    var height;
	
	    if (this.subPixelOptimize) {
	      subPixelOptimizeRect(subPixelOptimizeOutputShape, shape, this.style);
	      x = subPixelOptimizeOutputShape.x;
	      y = subPixelOptimizeOutputShape.y;
	      width = subPixelOptimizeOutputShape.width;
	      height = subPixelOptimizeOutputShape.height;
	      subPixelOptimizeOutputShape.r = shape.r;
	      shape = subPixelOptimizeOutputShape;
	    } else {
	      x = shape.x;
	      y = shape.y;
	      width = shape.width;
	      height = shape.height;
	    }
	
	    if (!shape.r) {
	      ctx.rect(x, y, width, height);
	    } else {
	      roundRectHelper.buildPath(ctx, shape);
	    }
	
	    ctx.closePath();
	    return;
	  }
	});
	
	module.exports = _default;

/***/ },
/* 607 */
/***/ function(module, exports) {

	var svgURI = 'http://www.w3.org/2000/svg';
	
	function createElement(name) {
	  return document.createElementNS(svgURI, name);
	}
	
	exports.createElement = createElement;

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(607);
	
	var createElement = _core.createElement;
	
	var PathProxy = __webpack_require__(266);
	
	var BoundingRect = __webpack_require__(60);
	
	var matrix = __webpack_require__(86);
	
	var textContain = __webpack_require__(102);
	
	var textHelper = __webpack_require__(395);
	
	var Text = __webpack_require__(224);
	
	// TODO
	// 1. shadow
	// 2. Image: sx, sy, sw, sh
	var CMD = PathProxy.CMD;
	var arrayJoin = Array.prototype.join;
	var NONE = 'none';
	var mathRound = Math.round;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	var PI2 = Math.PI * 2;
	var degree = 180 / PI;
	var EPSILON = 1e-4;
	
	function round4(val) {
	  return mathRound(val * 1e4) / 1e4;
	}
	
	function isAroundZero(val) {
	  return val < EPSILON && val > -EPSILON;
	}
	
	function pathHasFill(style, isText) {
	  var fill = isText ? style.textFill : style.fill;
	  return fill != null && fill !== NONE;
	}
	
	function pathHasStroke(style, isText) {
	  var stroke = isText ? style.textStroke : style.stroke;
	  return stroke != null && stroke !== NONE;
	}
	
	function setTransform(svgEl, m) {
	  if (m) {
	    attr(svgEl, 'transform', 'matrix(' + arrayJoin.call(m, ',') + ')');
	  }
	}
	
	function attr(el, key, val) {
	  if (!val || val.type !== 'linear' && val.type !== 'radial') {
	    // Don't set attribute for gradient, since it need new dom nodes
	    el.setAttribute(key, val);
	  }
	}
	
	function attrXLink(el, key, val) {
	  el.setAttributeNS('http://www.w3.org/1999/xlink', key, val);
	}
	
	function bindStyle(svgEl, style, isText, el) {
	  if (pathHasFill(style, isText)) {
	    var fill = isText ? style.textFill : style.fill;
	    fill = fill === 'transparent' ? NONE : fill;
	    attr(svgEl, 'fill', fill);
	    attr(svgEl, 'fill-opacity', style.fillOpacity != null ? style.fillOpacity * style.opacity : style.opacity);
	  } else {
	    attr(svgEl, 'fill', NONE);
	  }
	
	  if (pathHasStroke(style, isText)) {
	    var stroke = isText ? style.textStroke : style.stroke;
	    stroke = stroke === 'transparent' ? NONE : stroke;
	    attr(svgEl, 'stroke', stroke);
	    var strokeWidth = isText ? style.textStrokeWidth : style.lineWidth;
	    var strokeScale = !isText && style.strokeNoScale ? el.getLineScale() : 1;
	    attr(svgEl, 'stroke-width', strokeWidth / strokeScale); // stroke then fill for text; fill then stroke for others
	
	    attr(svgEl, 'paint-order', isText ? 'stroke' : 'fill');
	    attr(svgEl, 'stroke-opacity', style.strokeOpacity != null ? style.strokeOpacity : style.opacity);
	    var lineDash = style.lineDash;
	
	    if (lineDash) {
	      attr(svgEl, 'stroke-dasharray', style.lineDash.join(','));
	      attr(svgEl, 'stroke-dashoffset', mathRound(style.lineDashOffset || 0));
	    } else {
	      attr(svgEl, 'stroke-dasharray', '');
	    } // PENDING
	
	
	    style.lineCap && attr(svgEl, 'stroke-linecap', style.lineCap);
	    style.lineJoin && attr(svgEl, 'stroke-linejoin', style.lineJoin);
	    style.miterLimit && attr(svgEl, 'stroke-miterlimit', style.miterLimit);
	  } else {
	    attr(svgEl, 'stroke', NONE);
	  }
	}
	/***************************************************
	 * PATH
	 **************************************************/
	
	
	function pathDataToString(path) {
	  var str = [];
	  var data = path.data;
	  var dataLength = path.len();
	
	  for (var i = 0; i < dataLength;) {
	    var cmd = data[i++];
	    var cmdStr = '';
	    var nData = 0;
	
	    switch (cmd) {
	      case CMD.M:
	        cmdStr = 'M';
	        nData = 2;
	        break;
	
	      case CMD.L:
	        cmdStr = 'L';
	        nData = 2;
	        break;
	
	      case CMD.Q:
	        cmdStr = 'Q';
	        nData = 4;
	        break;
	
	      case CMD.C:
	        cmdStr = 'C';
	        nData = 6;
	        break;
	
	      case CMD.A:
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++];
	        var psi = data[i++];
	        var clockwise = data[i++];
	        var dThetaPositive = Math.abs(dTheta);
	        var isCircle = isAroundZero(dThetaPositive - PI2) || (clockwise ? dTheta >= PI2 : -dTheta >= PI2); // Mapping to 0~2PI
	
	        var unifiedTheta = dTheta > 0 ? dTheta % PI2 : dTheta % PI2 + PI2;
	        var large = false;
	
	        if (isCircle) {
	          large = true;
	        } else if (isAroundZero(dThetaPositive)) {
	          large = false;
	        } else {
	          large = unifiedTheta >= PI === !!clockwise;
	        }
	
	        var x0 = round4(cx + rx * mathCos(theta));
	        var y0 = round4(cy + ry * mathSin(theta)); // It will not draw if start point and end point are exactly the same
	        // We need to shift the end point with a small value
	        // FIXME A better way to draw circle ?
	
	        if (isCircle) {
	          if (clockwise) {
	            dTheta = PI2 - 1e-4;
	          } else {
	            dTheta = -PI2 + 1e-4;
	          }
	
	          large = true;
	
	          if (i === 9) {
	            // Move to (x0, y0) only when CMD.A comes at the
	            // first position of a shape.
	            // For instance, when drawing a ring, CMD.A comes
	            // after CMD.M, so it's unnecessary to move to
	            // (x0, y0).
	            str.push('M', x0, y0);
	          }
	        }
	
	        var x = round4(cx + rx * mathCos(theta + dTheta));
	        var y = round4(cy + ry * mathSin(theta + dTheta)); // FIXME Ellipse
	
	        str.push('A', round4(rx), round4(ry), mathRound(psi * degree), +large, +clockwise, x, y);
	        break;
	
	      case CMD.Z:
	        cmdStr = 'Z';
	        break;
	
	      case CMD.R:
	        var x = round4(data[i++]);
	        var y = round4(data[i++]);
	        var w = round4(data[i++]);
	        var h = round4(data[i++]);
	        str.push('M', x, y, 'L', x + w, y, 'L', x + w, y + h, 'L', x, y + h, 'L', x, y);
	        break;
	    }
	
	    cmdStr && str.push(cmdStr);
	
	    for (var j = 0; j < nData; j++) {
	      // PENDING With scale
	      str.push(round4(data[i++]));
	    }
	  }
	
	  return str.join(' ');
	}
	
	var svgPath = {};
	
	svgPath.brush = function (el) {
	  var style = el.style;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('path');
	    el.__svgEl = svgEl;
	  }
	
	  if (!el.path) {
	    el.createPathProxy();
	  }
	
	  var path = el.path;
	
	  if (el.__dirtyPath) {
	    path.beginPath();
	    path.subPixelOptimize = false;
	    el.buildPath(path, el.shape);
	    el.__dirtyPath = false;
	    var pathStr = pathDataToString(path);
	
	    if (pathStr.indexOf('NaN') < 0) {
	      // Ignore illegal path, which may happen such in out-of-range
	      // data in Calendar series.
	      attr(svgEl, 'd', pathStr);
	    }
	  }
	
	  bindStyle(svgEl, style, false, el);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  } else {
	    removeOldTextNode(el);
	  }
	};
	/***************************************************
	 * IMAGE
	 **************************************************/
	
	
	var svgImage = {};
	
	svgImage.brush = function (el) {
	  var style = el.style;
	  var image = style.image;
	
	  if (image instanceof HTMLImageElement) {
	    var src = image.src;
	    image = src;
	  }
	
	  if (!image) {
	    return;
	  }
	
	  var x = style.x || 0;
	  var y = style.y || 0;
	  var dw = style.width;
	  var dh = style.height;
	  var svgEl = el.__svgEl;
	
	  if (!svgEl) {
	    svgEl = createElement('image');
	    el.__svgEl = svgEl;
	  }
	
	  if (image !== el.__imageSrc) {
	    attrXLink(svgEl, 'href', image); // Caching image src
	
	    el.__imageSrc = image;
	  }
	
	  attr(svgEl, 'width', dw);
	  attr(svgEl, 'height', dh);
	  attr(svgEl, 'x', x);
	  attr(svgEl, 'y', y);
	  setTransform(svgEl, el.transform);
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, el.getBoundingRect());
	  } else {
	    removeOldTextNode(el);
	  }
	};
	/***************************************************
	 * TEXT
	 **************************************************/
	
	
	var svgText = {};
	
	var _tmpTextHostRect = new BoundingRect();
	
	var _tmpTextBoxPos = {};
	var _tmpTextTransform = [];
	var TEXT_ALIGN_TO_ANCHRO = {
	  left: 'start',
	  right: 'end',
	  center: 'middle',
	  middle: 'middle'
	};
	/**
	 * @param {module:zrender/Element} el
	 * @param {Object|boolean} [hostRect] {x, y, width, height}
	 *        If set false, rect text is not used.
	 */
	
	var svgTextDrawRectText = function (el, hostRect) {
	  var style = el.style;
	  var elTransform = el.transform;
	  var needTransformTextByHostEl = el instanceof Text || style.transformText;
	  el.__dirty && textHelper.normalizeTextStyle(style, true);
	  var text = style.text; // Convert to string
	
	  text != null && (text += '');
	
	  if (!textHelper.needDrawText(text, style)) {
	    return;
	  } // render empty text for svg if no text but need draw text.
	
	
	  text == null && (text = ''); // Follow the setting in the canvas renderer, if not transform the
	  // text, transform the hostRect, by which the text is located.
	
	  if (!needTransformTextByHostEl && elTransform) {
	    _tmpTextHostRect.copy(hostRect);
	
	    _tmpTextHostRect.applyTransform(elTransform);
	
	    hostRect = _tmpTextHostRect;
	  }
	
	  var textSvgEl = el.__textSvgEl;
	
	  if (!textSvgEl) {
	    textSvgEl = createElement('text');
	    el.__textSvgEl = textSvgEl;
	  } // style.font has been normalized by `normalizeTextStyle`.
	
	
	  var textSvgElStyle = textSvgEl.style;
	  var font = style.font || textContain.DEFAULT_FONT;
	  var computedFont = textSvgEl.__computedFont;
	
	  if (font !== textSvgEl.__styleFont) {
	    textSvgElStyle.font = textSvgEl.__styleFont = font; // The computedFont might not be the orginal font if it is illegal font.
	
	    computedFont = textSvgEl.__computedFont = textSvgElStyle.font;
	  }
	
	  var textPadding = style.textPadding;
	  var textLineHeight = style.textLineHeight;
	  var contentBlock = el.__textCotentBlock;
	
	  if (!contentBlock || el.__dirtyText) {
	    contentBlock = el.__textCotentBlock = textContain.parsePlainText(text, computedFont, textPadding, textLineHeight, style.truncate);
	  }
	
	  var outerHeight = contentBlock.outerHeight;
	  var lineHeight = contentBlock.lineHeight;
	  textHelper.getBoxPosition(_tmpTextBoxPos, el, style, hostRect);
	  var baseX = _tmpTextBoxPos.baseX;
	  var baseY = _tmpTextBoxPos.baseY;
	  var textAlign = _tmpTextBoxPos.textAlign || 'left';
	  var textVerticalAlign = _tmpTextBoxPos.textVerticalAlign;
	  setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY);
	  var boxY = textContain.adjustTextY(baseY, outerHeight, textVerticalAlign);
	  var textX = baseX;
	  var textY = boxY; // TODO needDrawBg
	
	  if (textPadding) {
	    textX = getTextXForPadding(baseX, textAlign, textPadding);
	    textY += textPadding[0];
	  } // `textBaseline` is set as 'middle'.
	
	
	  textY += lineHeight / 2;
	  bindStyle(textSvgEl, style, true, el); // FIXME
	  // Add a <style> to reset all of the text font as inherit?
	  // otherwise the outer <style> may set the unexpected style.
	  // Font may affect position of each tspan elements
	
	  var canCacheByTextString = contentBlock.canCacheByTextString;
	  var tspanList = el.__tspanList || (el.__tspanList = []);
	  var tspanOriginLen = tspanList.length; // Optimize for most cases, just compare text string to determine change.
	
	  if (canCacheByTextString && el.__canCacheByTextString && el.__text === text) {
	    if (el.__dirtyText && tspanOriginLen) {
	      for (var idx = 0; idx < tspanOriginLen; ++idx) {
	        updateTextLocation(tspanList[idx], textAlign, textX, textY + idx * lineHeight);
	      }
	    }
	  } else {
	    el.__text = text;
	    el.__canCacheByTextString = canCacheByTextString;
	    var textLines = contentBlock.lines;
	    var nTextLines = textLines.length;
	    var idx = 0;
	
	    for (; idx < nTextLines; idx++) {
	      // Using cached tspan elements
	      var tspan = tspanList[idx];
	      var singleLineText = textLines[idx];
	
	      if (!tspan) {
	        tspan = tspanList[idx] = createElement('tspan');
	        textSvgEl.appendChild(tspan);
	        tspan.appendChild(document.createTextNode(singleLineText));
	      } else if (tspan.__zrText !== singleLineText) {
	        tspan.innerHTML = '';
	        tspan.appendChild(document.createTextNode(singleLineText));
	      }
	
	      updateTextLocation(tspan, textAlign, textX, textY + idx * lineHeight);
	    } // Remove unused tspan elements
	
	
	    if (tspanOriginLen > nTextLines) {
	      for (; idx < tspanOriginLen; idx++) {
	        textSvgEl.removeChild(tspanList[idx]);
	      }
	
	      tspanList.length = nTextLines;
	    }
	  }
	};
	
	function setTextTransform(textSvgEl, needTransformTextByHostEl, elTransform, style, hostRect, baseX, baseY) {
	  matrix.identity(_tmpTextTransform);
	
	  if (needTransformTextByHostEl && elTransform) {
	    matrix.copy(_tmpTextTransform, elTransform);
	  } // textRotation only apply in RectText.
	
	
	  var textRotation = style.textRotation;
	
	  if (hostRect && textRotation) {
	    var origin = style.textOrigin;
	
	    if (origin === 'center') {
	      baseX = hostRect.width / 2 + hostRect.x;
	      baseY = hostRect.height / 2 + hostRect.y;
	    } else if (origin) {
	      baseX = origin[0] + hostRect.x;
	      baseY = origin[1] + hostRect.y;
	    }
	
	    _tmpTextTransform[4] -= baseX;
	    _tmpTextTransform[5] -= baseY; // Positive: anticlockwise
	
	    matrix.rotate(_tmpTextTransform, _tmpTextTransform, textRotation);
	    _tmpTextTransform[4] += baseX;
	    _tmpTextTransform[5] += baseY;
	  } // See the definition in `Style.js#textOrigin`, the default
	  // origin is from the result of `getBoxPosition`.
	
	
	  setTransform(textSvgEl, _tmpTextTransform);
	} // FIXME merge the same code with `helper/text.js#getTextXForPadding`;
	
	
	function getTextXForPadding(x, textAlign, textPadding) {
	  return textAlign === 'right' ? x - textPadding[1] : textAlign === 'center' ? x + textPadding[3] / 2 - textPadding[1] / 2 : x + textPadding[3];
	}
	
	function updateTextLocation(tspan, textAlign, x, y) {
	  // Consider different font display differently in vertial align, we always
	  // set vertialAlign as 'middle', and use 'y' to locate text vertically.
	  attr(tspan, 'dominant-baseline', 'middle');
	  attr(tspan, 'text-anchor', TEXT_ALIGN_TO_ANCHRO[textAlign]);
	  attr(tspan, 'x', x);
	  attr(tspan, 'y', y);
	}
	
	function removeOldTextNode(el) {
	  if (el && el.__textSvgEl) {
	    // textSvgEl may has no parentNode if el has been removed temporary.
	    if (el.__textSvgEl.parentNode) {
	      el.__textSvgEl.parentNode.removeChild(el.__textSvgEl);
	    }
	
	    el.__textSvgEl = null;
	    el.__tspanList = [];
	    el.__text = null;
	  }
	}
	
	svgText.drawRectText = svgTextDrawRectText;
	
	svgText.brush = function (el) {
	  var style = el.style;
	
	  if (style.text != null) {
	    svgTextDrawRectText(el, false);
	  } else {
	    removeOldTextNode(el);
	  }
	};
	
	exports.path = svgPath;
	exports.image = svgImage;
	exports.text = svgText;

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(607);
	
	var createElement = _core.createElement;
	
	var zrUtil = __webpack_require__(4);
	
	var Path = __webpack_require__(67);
	
	var ZImage = __webpack_require__(267);
	
	var ZText = __webpack_require__(224);
	
	var _graphic = __webpack_require__(608);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * @file Manages elements that can be defined in <defs> in SVG,
	 *       e.g., gradients, clip path, etc.
	 * @author Zhang Wenli
	 */
	var MARK_UNUSED = '0';
	var MARK_USED = '1';
	/**
	 * Manages elements that can be defined in <defs> in SVG,
	 * e.g., gradients, clip path, etc.
	 *
	 * @class
	 * @param {number}          zrId      zrender instance id
	 * @param {SVGElement}      svgRoot   root of SVG document
	 * @param {string|string[]} tagNames  possible tag names
	 * @param {string}          markLabel label name to make if the element
	 *                                    is used
	 */
	
	function Definable(zrId, svgRoot, tagNames, markLabel, domName) {
	  this._zrId = zrId;
	  this._svgRoot = svgRoot;
	  this._tagNames = typeof tagNames === 'string' ? [tagNames] : tagNames;
	  this._markLabel = markLabel;
	  this._domName = domName || '_dom';
	  this.nextId = 0;
	}
	
	Definable.prototype.createElement = createElement;
	/**
	 * Get the <defs> tag for svgRoot; optionally creates one if not exists.
	 *
	 * @param {boolean} isForceCreating if need to create when not exists
	 * @return {SVGDefsElement} SVG <defs> element, null if it doesn't
	 * exist and isForceCreating is false
	 */
	
	Definable.prototype.getDefs = function (isForceCreating) {
	  var svgRoot = this._svgRoot;
	
	  var defs = this._svgRoot.getElementsByTagName('defs');
	
	  if (defs.length === 0) {
	    // Not exist
	    if (isForceCreating) {
	      defs = svgRoot.insertBefore(this.createElement('defs'), // Create new tag
	      svgRoot.firstChild // Insert in the front of svg
	      );
	
	      if (!defs.contains) {
	        // IE doesn't support contains method
	        defs.contains = function (el) {
	          var children = defs.children;
	
	          if (!children) {
	            return false;
	          }
	
	          for (var i = children.length - 1; i >= 0; --i) {
	            if (children[i] === el) {
	              return true;
	            }
	          }
	
	          return false;
	        };
	      }
	
	      return defs;
	    } else {
	      return null;
	    }
	  } else {
	    return defs[0];
	  }
	};
	/**
	 * Update DOM element if necessary.
	 *
	 * @param {Object|string} element style element. e.g., for gradient,
	 *                                it may be '#ccc' or {type: 'linear', ...}
	 * @param {Function|undefined} onUpdate update callback
	 */
	
	
	Definable.prototype.update = function (element, onUpdate) {
	  if (!element) {
	    return;
	  }
	
	  var defs = this.getDefs(false);
	
	  if (element[this._domName] && defs.contains(element[this._domName])) {
	    // Update DOM
	    if (typeof onUpdate === 'function') {
	      onUpdate(element);
	    }
	  } else {
	    // No previous dom, create new
	    var dom = this.add(element);
	
	    if (dom) {
	      element[this._domName] = dom;
	    }
	  }
	};
	/**
	 * Add gradient dom to defs
	 *
	 * @param {SVGElement} dom DOM to be added to <defs>
	 */
	
	
	Definable.prototype.addDom = function (dom) {
	  var defs = this.getDefs(true);
	  defs.appendChild(dom);
	};
	/**
	 * Remove DOM of a given element.
	 *
	 * @param {SVGElement} element element to remove dom
	 */
	
	
	Definable.prototype.removeDom = function (element) {
	  var defs = this.getDefs(false);
	
	  if (defs && element[this._domName]) {
	    defs.removeChild(element[this._domName]);
	    element[this._domName] = null;
	  }
	};
	/**
	 * Get DOMs of this element.
	 *
	 * @return {HTMLDomElement} doms of this defineable elements in <defs>
	 */
	
	
	Definable.prototype.getDoms = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // No dom when defs is not defined
	    return [];
	  }
	
	  var doms = [];
	  zrUtil.each(this._tagNames, function (tagName) {
	    var tags = defs.getElementsByTagName(tagName); // Note that tags is HTMLCollection, which is array-like
	    // rather than real array.
	    // So `doms.concat(tags)` add tags as one object.
	
	    doms = doms.concat([].slice.call(tags));
	  });
	  return doms;
	};
	/**
	 * Mark DOMs to be unused before painting, and clear unused ones at the end
	 * of the painting.
	 */
	
	
	Definable.prototype.markAllUnused = function () {
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    dom[that._markLabel] = MARK_UNUSED;
	  });
	};
	/**
	 * Mark a single DOM to be used.
	 *
	 * @param {SVGElement} dom DOM to mark
	 */
	
	
	Definable.prototype.markUsed = function (dom) {
	  if (dom) {
	    dom[this._markLabel] = MARK_USED;
	  }
	};
	/**
	 * Remove unused DOMs defined in <defs>
	 */
	
	
	Definable.prototype.removeUnused = function () {
	  var defs = this.getDefs(false);
	
	  if (!defs) {
	    // Nothing to remove
	    return;
	  }
	
	  var doms = this.getDoms();
	  var that = this;
	  zrUtil.each(doms, function (dom) {
	    if (dom[that._markLabel] !== MARK_USED) {
	      // Remove gradient
	      defs.removeChild(dom);
	    }
	  });
	};
	/**
	 * Get SVG proxy.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {Path|Image|Text} svg proxy of given element
	 */
	
	
	Definable.prototype.getSvgProxy = function (displayable) {
	  if (displayable instanceof Path) {
	    return svgPath;
	  } else if (displayable instanceof ZImage) {
	    return svgImage;
	  } else if (displayable instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	};
	/**
	 * Get text SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element of text
	 */
	
	
	Definable.prototype.getTextSvgElement = function (displayable) {
	  return displayable.__textSvgEl;
	};
	/**
	 * Get SVG element.
	 *
	 * @param {Displayable} displayable displayable element
	 * @return {SVGElement} SVG element
	 */
	
	
	Definable.prototype.getSvgElement = function (displayable) {
	  return displayable.__svgEl;
	};
	
	var _default = Definable;
	module.exports = _default;

/***/ },
/* 610 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(1219);
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inheritsLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PresetColorTypes = void 0;
	
	var _type = __webpack_require__(87);
	
	// eslint-disable-next-line import/prefer-default-export
	var PresetColorTypes = (0, _type.tuple)('pink', 'red', 'yellow', 'orange', 'cyan', 'green', 'blue', 'purple', 'geekblue', 'magenta', 'volcano', 'gold', 'lime');
	exports.PresetColorTypes = PresetColorTypes;

/***/ },
/* 612 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = getDataOrAriaProps;
	
	function getDataOrAriaProps(props) {
	  return Object.keys(props).reduce(function (prev, key) {
	    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') && key.substr(0, 7) !== 'data-__') {
	      prev[key] = props[key];
	    }
	
	    return prev;
	  }, {});
	}

/***/ },
/* 613 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	// ================== Collapse Motion ==================
	var getCollapsedHeight = function getCollapsedHeight() {
	  return {
	    height: 0,
	    opacity: 0
	  };
	};
	
	var getRealHeight = function getRealHeight(node) {
	  return {
	    height: node.scrollHeight,
	    opacity: 1
	  };
	};
	
	var getCurrentHeight = function getCurrentHeight(node) {
	  return {
	    height: node.offsetHeight
	  };
	};
	
	var collapseMotion = {
	  motionName: 'ant-motion-collapse',
	  onAppearStart: getCollapsedHeight,
	  onEnterStart: getCollapsedHeight,
	  onAppearActive: getRealHeight,
	  onEnterActive: getRealHeight,
	  onLeaveStart: getCurrentHeight,
	  onLeaveActive: getCollapsedHeight
	};
	var _default = collapseMotion;
	exports["default"] = _default;

/***/ },
/* 614 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.cloneElement = cloneElement;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	// eslint-disable-next-line import/prefer-default-export
	function cloneElement(element) {
	  if (! /*#__PURE__*/React.isValidElement(element)) return element;
	
	  for (var _len = arguments.length, restArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    restArgs[_key - 1] = arguments[_key];
	  }
	
	  return React.cloneElement.apply(React, [element].concat(restArgs));
	}

/***/ },
/* 615 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.responsiveMap = exports.responsiveArray = void 0;
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	var enquire; // TODO: Will be removed in antd 4.0 because we will no longer support ie9
	
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill; // eslint-disable-next-line global-require
	
	  enquire = __webpack_require__(880);
	}
	
	var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
	exports.responsiveArray = responsiveArray;
	var responsiveMap = {
	  xs: '(max-width: 575px)',
	  sm: '(min-width: 576px)',
	  md: '(min-width: 768px)',
	  lg: '(min-width: 992px)',
	  xl: '(min-width: 1200px)',
	  xxl: '(min-width: 1600px)'
	};
	exports.responsiveMap = responsiveMap;
	var subscribers = [];
	var subUid = -1;
	var screens = {};
	var responsiveObserve = {
	  dispatch: function dispatch(pointMap) {
	    screens = pointMap;
	
	    if (subscribers.length < 1) {
	      return false;
	    }
	
	    subscribers.forEach(function (item) {
	      item.func(screens);
	    });
	    return true;
	  },
	  subscribe: function subscribe(func) {
	    if (subscribers.length === 0) {
	      this.register();
	    }
	
	    var token = (++subUid).toString();
	    subscribers.push({
	      token: token,
	      func: func
	    });
	    func(screens);
	    return token;
	  },
	  unsubscribe: function unsubscribe(token) {
	    subscribers = subscribers.filter(function (item) {
	      return item.token !== token;
	    });
	
	    if (subscribers.length === 0) {
	      this.unregister();
	    }
	  },
	  unregister: function unregister() {
	    Object.keys(responsiveMap).map(function (screen) {
	      return enquire.unregister(responsiveMap[screen]);
	    });
	  },
	  register: function register() {
	    var _this = this;
	
	    Object.keys(responsiveMap).map(function (screen) {
	      return enquire.register(responsiveMap[screen], {
	        match: function match() {
	          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, true));
	
	          _this.dispatch(pointMap);
	        },
	        unmatch: function unmatch() {
	          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, false));
	
	          _this.dispatch(pointMap);
	        },
	        // Keep a empty destory to avoid triggering unmatch when unregister
	        destroy: function destroy() {}
	      });
	    });
	  }
	};
	var _default = responsiveObserve;
	exports["default"] = _default;

/***/ },
/* 616 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.isFlexSupported = void 0;
	
	var isStyleSupport = function isStyleSupport(styleName) {
	  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
	    var documentElement = window.document.documentElement;
	    return styleNameList.some(function (name) {
	      return name in documentElement.style;
	    });
	  }
	
	  return false;
	};
	
	var isFlexSupported = isStyleSupport(['flex', 'webkitFlex', 'Flex', 'msFlex']);
	exports.isFlexSupported = isFlexSupported;
	var _default = isStyleSupport;
	exports["default"] = _default;

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(417));
	
	var _configProvider = __webpack_require__(11);
	
	var _throttleByAnimationFrame = __webpack_require__(1228);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _utils = __webpack_require__(1230);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var __decorate = void 0 && (void 0).__decorate || function (decorators, target, key, desc) {
	  var c = arguments.length,
	      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
	      d;
	  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
	    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
	  }
	  return c > 3 && r && Object.defineProperty(target, key, r), r;
	};
	
	function getDefaultTarget() {
	  return typeof window !== 'undefined' ? window : null;
	}
	
	var AffixStatus;
	
	(function (AffixStatus) {
	  AffixStatus[AffixStatus["None"] = 0] = "None";
	  AffixStatus[AffixStatus["Prepare"] = 1] = "Prepare";
	})(AffixStatus || (AffixStatus = {}));
	
	var Affix = /*#__PURE__*/function (_React$Component) {
	  _inherits(Affix, _React$Component);
	
	  var _super = _createSuper(Affix);
	
	  function Affix() {
	    var _this;
	
	    _classCallCheck(this, Affix);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      status: AffixStatus.None,
	      lastAffix: false,
	      prevTarget: null
	    };
	
	    _this.getOffsetTop = function () {
	      var _this$props = _this.props,
	          offset = _this$props.offset,
	          offsetBottom = _this$props.offsetBottom;
	      var offsetTop = _this.props.offsetTop;
	
	      if (typeof offsetTop === 'undefined') {
	        offsetTop = offset;
	        (0, _warning["default"])(typeof offset === 'undefined', 'Affix', '`offset` is deprecated. Please use `offsetTop` instead.');
	      }
	
	      if (offsetBottom === undefined && offsetTop === undefined) {
	        offsetTop = 0;
	      }
	
	      return offsetTop;
	    };
	
	    _this.getOffsetBottom = function () {
	      return _this.props.offsetBottom;
	    };
	
	    _this.savePlaceholderNode = function (node) {
	      _this.placeholderNode = node;
	    };
	
	    _this.saveFixedNode = function (node) {
	      _this.fixedNode = node;
	    }; // =================== Measure ===================
	
	
	    _this.measure = function () {
	      var _this$state = _this.state,
	          status = _this$state.status,
	          lastAffix = _this$state.lastAffix;
	      var _this$props2 = _this.props,
	          target = _this$props2.target,
	          onChange = _this$props2.onChange;
	
	      if (status !== AffixStatus.Prepare || !_this.fixedNode || !_this.placeholderNode || !target) {
	        return;
	      }
	
	      var offsetTop = _this.getOffsetTop();
	
	      var offsetBottom = _this.getOffsetBottom();
	
	      var targetNode = target();
	
	      if (!targetNode) {
	        return;
	      }
	
	      var newState = {
	        status: AffixStatus.None
	      };
	      var targetRect = (0, _utils.getTargetRect)(targetNode);
	      var placeholderReact = (0, _utils.getTargetRect)(_this.placeholderNode);
	      var fixedTop = (0, _utils.getFixedTop)(placeholderReact, targetRect, offsetTop);
	      var fixedBottom = (0, _utils.getFixedBottom)(placeholderReact, targetRect, offsetBottom);
	
	      if (fixedTop !== undefined) {
	        newState.affixStyle = {
	          position: 'fixed',
	          top: fixedTop,
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	        newState.placeholderStyle = {
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	      } else if (fixedBottom !== undefined) {
	        newState.affixStyle = {
	          position: 'fixed',
	          bottom: fixedBottom,
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	        newState.placeholderStyle = {
	          width: placeholderReact.width,
	          height: placeholderReact.height
	        };
	      }
	
	      newState.lastAffix = !!newState.affixStyle;
	
	      if (onChange && lastAffix !== newState.lastAffix) {
	        onChange(newState.lastAffix);
	      }
	
	      _this.setState(newState);
	    }; // @ts-ignore TS6133
	
	
	    _this.prepareMeasure = function () {
	      // event param is used before. Keep compatible ts define here.
	      _this.setState({
	        status: AffixStatus.Prepare,
	        affixStyle: undefined,
	        placeholderStyle: undefined
	      }); // Test if `updatePosition` called
	
	
	      if (false) {
	        var onTestUpdatePosition = _this.props.onTestUpdatePosition;
	
	        if (onTestUpdatePosition) {
	          onTestUpdatePosition();
	        }
	      }
	    }; // =================== Render ===================
	
	
	    _this.renderAffix = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$state2 = _this.state,
	          affixStyle = _this$state2.affixStyle,
	          placeholderStyle = _this$state2.placeholderStyle;
	      var _this$props3 = _this.props,
	          prefixCls = _this$props3.prefixCls,
	          children = _this$props3.children;
	      var className = (0, _classnames["default"])(_defineProperty({}, getPrefixCls('affix', prefixCls), affixStyle));
	      var props = (0, _omit["default"])(_this.props, ['prefixCls', 'offsetTop', 'offsetBottom', 'target', 'onChange']); // Omit this since `onTestUpdatePosition` only works on test.
	
	      if (false) {
	        props = (0, _omit["default"])(props, ['onTestUpdatePosition']);
	      }
	
	      return /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	        onResize: function onResize() {
	          _this.updatePosition();
	        }
	      }, /*#__PURE__*/React.createElement("div", _extends({}, props, {
	        ref: _this.savePlaceholderNode
	      }), affixStyle && /*#__PURE__*/React.createElement("div", {
	        style: placeholderStyle,
	        "aria-hidden": "true"
	      }), /*#__PURE__*/React.createElement("div", {
	        className: className,
	        ref: _this.saveFixedNode,
	        style: affixStyle
	      }, /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	        onResize: function onResize() {
	          _this.updatePosition();
	        }
	      }, children))));
	    };
	
	    return _this;
	  } // Event handler
	
	
	  _createClass(Affix, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var target = this.props.target;
	
	      if (target) {
	        // [Legacy] Wait for parent component ref has its value.
	        // We should use target as directly element instead of function which makes element check hard.
	        this.timeout = setTimeout(function () {
	          (0, _utils.addObserveTarget)(target(), _this2); // Mock Event object.
	
	          _this2.updatePosition();
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var prevTarget = this.state.prevTarget;
	      var target = this.props.target;
	      var newTarget = null;
	
	      if (target) {
	        newTarget = target() || null;
	      }
	
	      if (prevTarget !== newTarget) {
	        (0, _utils.removeObserveTarget)(this);
	
	        if (newTarget) {
	          (0, _utils.addObserveTarget)(newTarget, this); // Mock Event object.
	
	          this.updatePosition();
	        }
	
	        this.setState({
	          prevTarget: newTarget
	        });
	      }
	
	      if (prevProps.offsetTop !== this.props.offsetTop || prevProps.offsetBottom !== this.props.offsetBottom) {
	        this.updatePosition();
	      }
	
	      this.measure();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	      (0, _utils.removeObserveTarget)(this);
	      this.updatePosition.cancel(); // https://github.com/ant-design/ant-design/issues/22683
	
	      this.lazyUpdatePosition.cancel();
	    } // Handle realign logic
	
	  }, {
	    key: "updatePosition",
	    value: function updatePosition() {
	      this.prepareMeasure();
	    }
	  }, {
	    key: "lazyUpdatePosition",
	    value: function lazyUpdatePosition() {
	      var target = this.props.target;
	      var affixStyle = this.state.affixStyle; // Check position change before measure to make Safari smooth
	
	      if (target && affixStyle) {
	        var offsetTop = this.getOffsetTop();
	        var offsetBottom = this.getOffsetBottom();
	        var targetNode = target();
	
	        if (targetNode && this.placeholderNode) {
	          var targetRect = (0, _utils.getTargetRect)(targetNode);
	          var placeholderReact = (0, _utils.getTargetRect)(this.placeholderNode);
	          var fixedTop = (0, _utils.getFixedTop)(placeholderReact, targetRect, offsetTop);
	          var fixedBottom = (0, _utils.getFixedBottom)(placeholderReact, targetRect, offsetBottom);
	
	          if (fixedTop !== undefined && affixStyle.top === fixedTop || fixedBottom !== undefined && affixStyle.bottom === fixedBottom) {
	            return;
	          }
	        }
	      } // Directly call prepare measure since it's already throttled.
	
	
	      this.prepareMeasure();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAffix);
	    }
	  }]);
	
	  return Affix;
	}(React.Component);
	
	Affix.defaultProps = {
	  target: getDefaultTarget
	};
	
	__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Affix.prototype, "updatePosition", null);
	
	__decorate([(0, _throttleByAnimationFrame.throttleByAnimationFrameDecorator)()], Affix.prototype, "lazyUpdatePosition", null);
	
	(0, _reactLifecyclesCompat.polyfill)(Affix);
	var _default = Affix;
	exports["default"] = _default;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Avatar = /*#__PURE__*/function (_React$Component) {
	  _inherits(Avatar, _React$Component);
	
	  var _super = _createSuper(Avatar);
	
	  function Avatar() {
	    var _this;
	
	    _classCallCheck(this, Avatar);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      scale: 1,
	      mounted: false,
	      isImgExist: true
	    };
	
	    _this.setScale = function () {
	      if (!_this.avatarChildren || !_this.avatarNode) {
	        return;
	      }
	
	      var childrenWidth = _this.avatarChildren.offsetWidth; // offsetWidth avoid affecting be transform scale
	
	      var nodeWidth = _this.avatarNode.offsetWidth; // denominator is 0 is no meaning
	
	      if (childrenWidth === 0 || nodeWidth === 0 || _this.lastChildrenWidth === childrenWidth && _this.lastNodeWidth === nodeWidth) {
	        return;
	      }
	
	      _this.lastChildrenWidth = childrenWidth;
	      _this.lastNodeWidth = nodeWidth; // add 4px gap for each side to get better performance
	
	      _this.setState({
	        scale: nodeWidth - 8 < childrenWidth ? (nodeWidth - 8) / childrenWidth : 1
	      });
	    };
	
	    _this.handleImgLoadError = function () {
	      var onError = _this.props.onError;
	      var errorFlag = onError ? onError() : undefined;
	
	      if (errorFlag !== false) {
	        _this.setState({
	          isImgExist: false
	        });
	      }
	    };
	
	    _this.renderAvatar = function (_ref) {
	      var _classNames, _classNames2;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          shape = _a.shape,
	          size = _a.size,
	          src = _a.src,
	          srcSet = _a.srcSet,
	          icon = _a.icon,
	          className = _a.className,
	          alt = _a.alt,
	          others = __rest(_a, ["prefixCls", "shape", "size", "src", "srcSet", "icon", "className", "alt"]);
	
	      var _this$state = _this.state,
	          isImgExist = _this$state.isImgExist,
	          scale = _this$state.scale,
	          mounted = _this$state.mounted;
	      var prefixCls = getPrefixCls('avatar', customizePrefixCls);
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames));
	      var classString = (0, _classnames["default"])(prefixCls, className, sizeCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames2, "".concat(prefixCls, "-image"), src && isImgExist), _defineProperty(_classNames2, "".concat(prefixCls, "-icon"), icon), _classNames2));
	      var sizeStyle = typeof size === 'number' ? {
	        width: size,
	        height: size,
	        lineHeight: "".concat(size, "px"),
	        fontSize: icon ? size / 2 : 18
	      } : {};
	      var children = _this.props.children;
	
	      if (src && isImgExist) {
	        children = /*#__PURE__*/React.createElement("img", {
	          src: src,
	          srcSet: srcSet,
	          onError: _this.handleImgLoadError,
	          alt: alt
	        });
	      } else if (icon) {
	        if (typeof icon === 'string') {
	          children = /*#__PURE__*/React.createElement(_icon["default"], {
	            type: icon
	          });
	        } else {
	          children = icon;
	        }
	      } else {
	        var childrenNode = _this.avatarChildren;
	
	        if (childrenNode || scale !== 1) {
	          var transformString = "scale(".concat(scale, ") translateX(-50%)");
	          var childrenStyle = {
	            msTransform: transformString,
	            WebkitTransform: transformString,
	            transform: transformString
	          };
	          var sizeChildrenStyle = typeof size === 'number' ? {
	            lineHeight: "".concat(size, "px")
	          } : {};
	          children = /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-string"),
	            ref: function ref(node) {
	              return _this.avatarChildren = node;
	            },
	            style: _extends(_extends({}, sizeChildrenStyle), childrenStyle)
	          }, children);
	        } else {
	          var _childrenStyle = {};
	
	          if (!mounted) {
	            _childrenStyle.opacity = 0;
	          }
	
	          children = /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-string"),
	            style: {
	              opacity: 0
	            },
	            ref: function ref(node) {
	              return _this.avatarChildren = node;
	            }
	          }, children);
	        }
	      }
	
	      return /*#__PURE__*/React.createElement("span", _extends({}, others, {
	        style: _extends(_extends({}, sizeStyle), others.style),
	        className: classString,
	        ref: function ref(node) {
	          return _this.avatarNode = node;
	        }
	      }), children);
	    };
	
	    return _this;
	  }
	
	  _createClass(Avatar, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setScale();
	      this.setState({
	        mounted: true
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      this.setScale();
	
	      if (prevProps.src !== this.props.src) {
	        this.setState({
	          isImgExist: true,
	          scale: 1
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAvatar);
	    }
	  }]);
	
	  return Avatar;
	}(React.Component);
	
	exports["default"] = Avatar;
	Avatar.defaultProps = {
	  shape: 'circle',
	  size: 'default'
	};

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(406));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var BreadcrumbItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(BreadcrumbItem, _React$Component);
	
	  var _super = _createSuper(BreadcrumbItem);
	
	  function BreadcrumbItem() {
	    var _this;
	
	    _classCallCheck(this, BreadcrumbItem);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderBreadcrumbItem = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          separator = _a.separator,
	          children = _a.children,
	          restProps = __rest(_a, ["prefixCls", "separator", "children"]);
	
	      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
	      var link;
	
	      if ('href' in _this.props) {
	        link = /*#__PURE__*/React.createElement("a", _extends({
	          className: "".concat(prefixCls, "-link")
	        }, (0, _omit["default"])(restProps, ['overlay'])), children);
	      } else {
	        link = /*#__PURE__*/React.createElement("span", _extends({
	          className: "".concat(prefixCls, "-link")
	        }, (0, _omit["default"])(restProps, ['overlay'])), children);
	      } // wrap to dropDown
	
	
	      link = _this.renderBreadcrumbNode(link, prefixCls);
	
	      if (children) {
	        return /*#__PURE__*/React.createElement("span", null, link, separator && separator !== '' && /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-separator")
	        }, separator));
	      }
	
	      return null;
	    };
	    /**
	     * if overlay is have
	     * Wrap a DropDown
	     */
	
	
	    _this.renderBreadcrumbNode = function (breadcrumbItem, prefixCls) {
	      var overlay = _this.props.overlay;
	
	      if (overlay) {
	        return /*#__PURE__*/React.createElement(_dropdown["default"], {
	          overlay: overlay,
	          placement: "bottomCenter"
	        }, /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-overlay-link")
	        }, breadcrumbItem, /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "down"
	        })));
	      }
	
	      return breadcrumbItem;
	    };
	
	    return _this;
	  }
	
	  _createClass(BreadcrumbItem, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumbItem);
	    }
	  }]);
	
	  return BreadcrumbItem;
	}(React.Component);
	
	exports["default"] = BreadcrumbItem;
	BreadcrumbItem.__ANT_BREADCRUMB_ITEM = true;
	BreadcrumbItem.defaultProps = {
	  separator: '/'
	};
	BreadcrumbItem.propTypes = {
	  prefixCls: PropTypes.string,
	  separator: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	  href: PropTypes.string
	};

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Breadcrumb = _interopRequireDefault(__webpack_require__(1240));
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(619));
	
	var _BreadcrumbSeparator = _interopRequireDefault(__webpack_require__(1241));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_Breadcrumb["default"].Item = _BreadcrumbItem["default"];
	_Breadcrumb["default"].Separator = _BreadcrumbSeparator["default"];
	var _default = _Breadcrumb["default"];
	exports["default"] = _default;

/***/ },
/* 621 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _en_US = _interopRequireDefault(__webpack_require__(405));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _en_US["default"];
	exports["default"] = _default;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _rcCheckbox = _interopRequireDefault(__webpack_require__(1083));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(79));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Checkbox = /*#__PURE__*/function (_React$Component) {
	  _inherits(Checkbox, _React$Component);
	
	  var _super = _createSuper(Checkbox);
	
	  function Checkbox() {
	    var _this;
	
	    _classCallCheck(this, Checkbox);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveCheckbox = function (node) {
	      _this.rcCheckbox = node;
	    };
	
	    _this.renderCheckbox = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          context = _assertThisInitialize.context;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          children = props.children,
	          indeterminate = props.indeterminate,
	          style = props.style,
	          onMouseEnter = props.onMouseEnter,
	          onMouseLeave = props.onMouseLeave,
	          restProps = __rest(props, ["prefixCls", "className", "children", "indeterminate", "style", "onMouseEnter", "onMouseLeave"]);
	
	      var checkboxGroup = context.checkboxGroup;
	      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
	
	      var checkboxProps = _extends({}, restProps);
	
	      if (checkboxGroup) {
	        checkboxProps.onChange = function () {
	          if (restProps.onChange) {
	            restProps.onChange.apply(restProps, arguments);
	          }
	
	          checkboxGroup.toggleOption({
	            label: children,
	            value: props.value
	          });
	        };
	
	        checkboxProps.name = checkboxGroup.name;
	        checkboxProps.checked = checkboxGroup.value.indexOf(props.value) !== -1;
	        checkboxProps.disabled = props.disabled || checkboxGroup.disabled;
	      }
	
	      var classString = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-wrapper"), true), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-checked"), checkboxProps.checked), _defineProperty(_classNames, "".concat(prefixCls, "-wrapper-disabled"), checkboxProps.disabled), _classNames));
	      var checkboxClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-indeterminate"), indeterminate));
	      return (
	        /*#__PURE__*/
	        // eslint-disable-next-line jsx-a11y/label-has-associated-control
	        React.createElement("label", {
	          className: classString,
	          style: style,
	          onMouseEnter: onMouseEnter,
	          onMouseLeave: onMouseLeave
	        }, /*#__PURE__*/React.createElement(_rcCheckbox["default"], _extends({}, checkboxProps, {
	          prefixCls: prefixCls,
	          className: checkboxClass,
	          ref: _this.saveCheckbox
	        })), children !== undefined && /*#__PURE__*/React.createElement("span", null, children))
	      );
	    };
	
	    return _this;
	  }
	
	  _createClass(Checkbox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var value = this.props.value;
	
	      var _ref2 = this.context || {},
	          _ref2$checkboxGroup = _ref2.checkboxGroup,
	          checkboxGroup = _ref2$checkboxGroup === void 0 ? {} : _ref2$checkboxGroup;
	
	      if (checkboxGroup.registerValue) {
	        checkboxGroup.registerValue(value);
	      }
	
	      (0, _warning["default"])('checked' in this.props || (this.context || {}).checkboxGroup || !('value' in this.props), 'Checkbox', '`value` is not validate prop, do you mean `checked`?');
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState) || !(0, _shallowequal["default"])(this.context.checkboxGroup, nextContext.checkboxGroup);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_ref3) {
	      var prevValue = _ref3.value;
	      var value = this.props.value;
	
	      var _ref4 = this.context || {},
	          _ref4$checkboxGroup = _ref4.checkboxGroup,
	          checkboxGroup = _ref4$checkboxGroup === void 0 ? {} : _ref4$checkboxGroup;
	
	      if (value !== prevValue && checkboxGroup.registerValue && checkboxGroup.cancelValue) {
	        checkboxGroup.cancelValue(prevValue);
	        checkboxGroup.registerValue(value);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var value = this.props.value;
	
	      var _ref5 = this.context || {},
	          _ref5$checkboxGroup = _ref5.checkboxGroup,
	          checkboxGroup = _ref5$checkboxGroup === void 0 ? {} : _ref5$checkboxGroup;
	
	      if (checkboxGroup.cancelValue) {
	        checkboxGroup.cancelValue(value);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcCheckbox.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcCheckbox.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckbox);
	    }
	  }]);
	
	  return Checkbox;
	}(React.Component);
	
	Checkbox.__ANT_CHECKBOX = true;
	Checkbox.defaultProps = {
	  indeterminate: false
	};
	Checkbox.contextTypes = {
	  checkboxGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(Checkbox);
	var _default = Checkbox;
	exports["default"] = _default;

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _grid = __webpack_require__(318);
	
	var _default = _grid.Col;
	exports["default"] = _default;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = InputIcon;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function InputIcon(props) {
	  var _classNames;
	
	  var suffixIcon = props.suffixIcon,
	      prefixCls = props.prefixCls;
	  return suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	    className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames, "".concat(prefixCls, "-picker-icon"), true), _classNames))
	  }) : /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-picker-icon")
	  }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "calendar",
	    className: "".concat(prefixCls, "-picker-icon")
	  });
	}

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _zh_CN = _interopRequireDefault(__webpack_require__(2647));
	
	var _zh_CN2 = _interopRequireDefault(__webpack_require__(645));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var locale = {
	  lang: _extends({
	    placeholder: '请选择日期',
	    rangePlaceholder: ['开始日期', '结束日期']
	  }, _zh_CN["default"]),
	  timePickerLocale: _extends({}, _zh_CN2["default"])
	}; // should add whitespace between char in Button
	
	locale.lang.ok = '确 定'; // All settings at:
	// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json
	
	var _default = locale;
	exports["default"] = _default;

/***/ },
/* 626 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatDate = formatDate;
	
	// eslint-disable-next-line import/prefer-default-export
	function formatDate(value, format) {
	  if (!value) {
	    return '';
	  }
	
	  if (Array.isArray(format)) {
	    format = format[0];
	  }
	
	  return value.format(format);
	}

/***/ },
/* 627 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _empty = _interopRequireDefault(__webpack_require__(1268));
	
	var _simple = _interopRequireDefault(__webpack_require__(1269));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var defaultEmptyImg = /*#__PURE__*/React.createElement(_empty["default"], null);
	var simpleEmptyImg = /*#__PURE__*/React.createElement(_simple["default"], null);
	
	var Empty = function Empty(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	    var getPrefixCls = _ref.getPrefixCls;
	
	    var className = props.className,
	        customizePrefixCls = props.prefixCls,
	        _props$image = props.image,
	        image = _props$image === void 0 ? defaultEmptyImg : _props$image,
	        description = props.description,
	        children = props.children,
	        imageStyle = props.imageStyle,
	        restProps = __rest(props, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);
	
	    return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	      componentName: "Empty"
	    }, function (locale) {
	      var prefixCls = getPrefixCls('empty', customizePrefixCls);
	      var des = typeof description !== 'undefined' ? description : locale.description;
	      var alt = typeof des === 'string' ? des : 'empty';
	      var imageNode = null;
	
	      if (typeof image === 'string') {
	        imageNode = /*#__PURE__*/React.createElement("img", {
	          alt: alt,
	          src: image
	        });
	      } else {
	        imageNode = image;
	      }
	
	      return /*#__PURE__*/React.createElement("div", _extends({
	        className: (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), className)
	      }, restProps), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-image"),
	        style: imageStyle
	      }, imageNode), des && /*#__PURE__*/React.createElement("p", {
	        className: "".concat(prefixCls, "-description")
	      }, des), children && /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer")
	      }, children));
	    });
	  });
	};
	
	Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
	Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
	var _default = Empty;
	exports["default"] = _default;

/***/ },
/* 628 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.FIELD_DATA_PROP = exports.FIELD_META_PROP = void 0;
	var FIELD_META_PROP = 'data-__meta';
	exports.FIELD_META_PROP = FIELD_META_PROP;
	var FIELD_DATA_PROP = 'data-__field';
	exports.FIELD_DATA_PROP = FIELD_DATA_PROP;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var FormContext = (0, _createReactContext["default"])({
	  labelAlign: 'right',
	  vertical: false
	});
	var _default = FormContext;
	exports["default"] = _default;

/***/ },
/* 630 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var RowContext = (0, _createReactContext["default"])({});
	var _default = RowContext;
	exports["default"] = _default;

/***/ },
/* 631 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _RowContext = _interopRequireDefault(__webpack_require__(630));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var objectOrNumber = PropTypes.oneOfType([PropTypes.object, PropTypes.number]);
	
	var Col = /*#__PURE__*/function (_React$Component) {
	  _inherits(Col, _React$Component);
	
	  var _super = _createSuper(Col);
	
	  function Col() {
	    var _this;
	
	    _classCallCheck(this, Col);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderCol = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          span = props.span,
	          order = props.order,
	          offset = props.offset,
	          push = props.push,
	          pull = props.pull,
	          className = props.className,
	          children = props.children,
	          others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children"]);
	
	      var prefixCls = getPrefixCls('col', customizePrefixCls);
	      var sizeClassObj = {};
	      ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
	        var _extends2;
	
	        var sizeProps = {};
	        var propSize = props[size];
	
	        if (typeof propSize === 'number') {
	          sizeProps.span = propSize;
	        } else if (_typeof(propSize) === 'object') {
	          sizeProps = propSize || {};
	        }
	
	        delete others[size];
	        sizeClassObj = _extends(_extends({}, sizeClassObj), (_extends2 = {}, _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _extends2));
	      });
	      var classes = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), _defineProperty(_classNames, "".concat(prefixCls, "-order-").concat(order), order), _defineProperty(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), _defineProperty(_classNames, "".concat(prefixCls, "-push-").concat(push), push), _defineProperty(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
	      return /*#__PURE__*/React.createElement(_RowContext["default"].Consumer, null, function (_ref2) {
	        var gutter = _ref2.gutter;
	        var style = others.style;
	
	        if (gutter) {
	          style = _extends(_extends(_extends({}, gutter[0] > 0 ? {
	            paddingLeft: gutter[0] / 2,
	            paddingRight: gutter[0] / 2
	          } : {}), gutter[1] > 0 ? {
	            paddingTop: gutter[1] / 2,
	            paddingBottom: gutter[1] / 2
	          } : {}), style);
	        }
	
	        return /*#__PURE__*/React.createElement("div", _extends({}, others, {
	          style: style,
	          className: classes
	        }), children);
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(Col, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCol);
	    }
	  }]);
	
	  return Col;
	}(React.Component);
	
	exports["default"] = Col;
	Col.propTypes = {
	  span: PropTypes.number,
	  order: PropTypes.number,
	  offset: PropTypes.number,
	  push: PropTypes.number,
	  pull: PropTypes.number,
	  className: PropTypes.string,
	  children: PropTypes.node,
	  xs: objectOrNumber,
	  sm: objectOrNumber,
	  md: objectOrNumber,
	  lg: objectOrNumber,
	  xl: objectOrNumber,
	  xxl: objectOrNumber
	};

/***/ },
/* 632 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _configProvider = __webpack_require__(11);
	
	var _RowContext = _interopRequireDefault(__webpack_require__(630));
	
	var _type = __webpack_require__(87);
	
	var _responsiveObserve = _interopRequireWildcard(__webpack_require__(615));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var RowAligns = (0, _type.tuple)('top', 'middle', 'bottom', 'stretch');
	var RowJustify = (0, _type.tuple)('start', 'end', 'center', 'space-around', 'space-between');
	
	var Row = /*#__PURE__*/function (_React$Component) {
	  _inherits(Row, _React$Component);
	
	  var _super = _createSuper(Row);
	
	  function Row() {
	    var _this;
	
	    _classCallCheck(this, Row);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      screens: {}
	    };
	
	    _this.renderRow = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          justify = _a.justify,
	          align = _a.align,
	          className = _a.className,
	          style = _a.style,
	          children = _a.children,
	          others = __rest(_a, ["prefixCls", "type", "justify", "align", "className", "style", "children"]);
	
	      var prefixCls = getPrefixCls('row', customizePrefixCls);
	
	      var gutter = _this.getGutter();
	
	      var classes = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, !type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(justify), type && justify), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(align), type && align), _classNames), className);
	
	      var rowStyle = _extends(_extends(_extends({}, gutter[0] > 0 ? {
	        marginLeft: gutter[0] / -2,
	        marginRight: gutter[0] / -2
	      } : {}), gutter[1] > 0 ? {
	        marginTop: gutter[1] / -2,
	        marginBottom: gutter[1] / -2
	      } : {}), style);
	
	      var otherProps = _extends({}, others);
	
	      delete otherProps.gutter;
	      return /*#__PURE__*/React.createElement(_RowContext["default"].Provider, {
	        value: {
	          gutter: gutter
	        }
	      }, /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
	        className: classes,
	        style: rowStyle
	      }), children));
	    };
	
	    return _this;
	  }
	
	  _createClass(Row, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.token = _responsiveObserve["default"].subscribe(function (screens) {
	        var gutter = _this2.props.gutter;
	
	        if (_typeof(gutter) === 'object' || Array.isArray(gutter) && (_typeof(gutter[0]) === 'object' || _typeof(gutter[1]) === 'object')) {
	          _this2.setState({
	            screens: screens
	          });
	        }
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _responsiveObserve["default"].unsubscribe(this.token);
	    }
	  }, {
	    key: "getGutter",
	    value: function getGutter() {
	      var results = [0, 0];
	      var gutter = this.props.gutter;
	      var screens = this.state.screens;
	      var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
	      normalizedGutter.forEach(function (g, index) {
	        if (_typeof(g) === 'object') {
	          for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
	            var breakpoint = _responsiveObserve.responsiveArray[i];
	
	            if (screens[breakpoint] && g[breakpoint] !== undefined) {
	              results[index] = g[breakpoint];
	              break;
	            }
	          }
	        } else {
	          results[index] = g || 0;
	        }
	      });
	      return results;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRow);
	    }
	  }]);
	
	  return Row;
	}(React.Component);
	
	exports["default"] = Row;
	Row.defaultProps = {
	  gutter: 0
	};
	Row.propTypes = {
	  type: PropTypes.oneOf(['flex']),
	  align: PropTypes.oneOf(RowAligns),
	  justify: PropTypes.oneOf(RowJustify),
	  className: PropTypes.string,
	  children: PropTypes.node,
	  gutter: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
	  prefixCls: PropTypes.string
	};

/***/ },
/* 633 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasPrefixSuffix = hasPrefixSuffix;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _type = __webpack_require__(87);
	
	var _Input = __webpack_require__(269);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ClearableInputType = (0, _type.tuple)('text', 'input');
	
	function hasPrefixSuffix(props) {
	  return !!(props.prefix || props.suffix || props.allowClear);
	}
	
	var ClearableLabeledInput = /*#__PURE__*/function (_React$Component) {
	  _inherits(ClearableLabeledInput, _React$Component);
	
	  var _super = _createSuper(ClearableLabeledInput);
	
	  function ClearableLabeledInput() {
	    _classCallCheck(this, ClearableLabeledInput);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ClearableLabeledInput, [{
	    key: "renderClearIcon",
	    value: function renderClearIcon(prefixCls) {
	      var _this$props = this.props,
	          allowClear = _this$props.allowClear,
	          value = _this$props.value,
	          disabled = _this$props.disabled,
	          readOnly = _this$props.readOnly,
	          inputType = _this$props.inputType,
	          handleReset = _this$props.handleReset;
	
	      if (!allowClear || disabled || readOnly || value === undefined || value === null || value === '') {
	        return null;
	      }
	
	      var className = inputType === ClearableInputType[0] ? "".concat(prefixCls, "-textarea-clear-icon") : "".concat(prefixCls, "-clear-icon");
	      return /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        onClick: handleReset,
	        className: className,
	        role: "button"
	      });
	    }
	  }, {
	    key: "renderSuffix",
	    value: function renderSuffix(prefixCls) {
	      var _this$props2 = this.props,
	          suffix = _this$props2.suffix,
	          allowClear = _this$props2.allowClear;
	
	      if (suffix || allowClear) {
	        return /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-suffix")
	        }, this.renderClearIcon(prefixCls), suffix);
	      }
	
	      return null;
	    }
	  }, {
	    key: "renderLabeledIcon",
	    value: function renderLabeledIcon(prefixCls, element) {
	      var _classNames;
	
	      var props = this.props;
	      var suffix = this.renderSuffix(prefixCls);
	
	      if (!hasPrefixSuffix(props)) {
	        return /*#__PURE__*/React.cloneElement(element, {
	          value: props.value
	        });
	      }
	
	      var prefix = props.prefix ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-prefix")
	      }, props.prefix) : null;
	      var affixWrapperCls = (0, _classnames["default"])(props.className, "".concat(prefixCls, "-affix-wrapper"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-input-with-clear-btn"), props.suffix && props.allowClear && this.props.value), _classNames));
	      return /*#__PURE__*/React.createElement("span", {
	        className: affixWrapperCls,
	        style: props.style
	      }, prefix, /*#__PURE__*/React.cloneElement(element, {
	        style: null,
	        value: props.value,
	        className: (0, _Input.getInputClassName)(prefixCls, props.size, props.disabled)
	      }), suffix);
	    }
	  }, {
	    key: "renderInputWithLabel",
	    value: function renderInputWithLabel(prefixCls, labeledElement) {
	      var _classNames3;
	
	      var _this$props3 = this.props,
	          addonBefore = _this$props3.addonBefore,
	          addonAfter = _this$props3.addonAfter,
	          style = _this$props3.style,
	          size = _this$props3.size,
	          className = _this$props3.className; // Not wrap when there is not addons
	
	      if (!addonBefore && !addonAfter) {
	        return labeledElement;
	      }
	
	      var wrapperClassName = "".concat(prefixCls, "-group");
	      var addonClassName = "".concat(wrapperClassName, "-addon");
	      var addonBeforeNode = addonBefore ? /*#__PURE__*/React.createElement("span", {
	        className: addonClassName
	      }, addonBefore) : null;
	      var addonAfterNode = addonAfter ? /*#__PURE__*/React.createElement("span", {
	        className: addonClassName
	      }, addonAfter) : null;
	      var mergedWrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), _defineProperty({}, wrapperClassName, addonBefore || addonAfter));
	      var mergedGroupClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-group-wrapper"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-sm"), size === 'small'), _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-lg"), size === 'large'), _classNames3)); // Need another wrapper for changing display:table to display:inline-block
	      // and put style prop in wrapper
	
	      return /*#__PURE__*/React.createElement("span", {
	        className: mergedGroupClassName,
	        style: style
	      }, /*#__PURE__*/React.createElement("span", {
	        className: mergedWrapperClassName
	      }, addonBeforeNode, /*#__PURE__*/React.cloneElement(labeledElement, {
	        style: null
	      }), addonAfterNode));
	    }
	  }, {
	    key: "renderTextAreaWithClearIcon",
	    value: function renderTextAreaWithClearIcon(prefixCls, element) {
	      var _this$props4 = this.props,
	          value = _this$props4.value,
	          allowClear = _this$props4.allowClear,
	          className = _this$props4.className,
	          style = _this$props4.style;
	
	      if (!allowClear) {
	        return /*#__PURE__*/React.cloneElement(element, {
	          value: value
	        });
	      }
	
	      var affixWrapperCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"));
	      return /*#__PURE__*/React.createElement("span", {
	        className: affixWrapperCls,
	        style: style
	      }, /*#__PURE__*/React.cloneElement(element, {
	        style: null,
	        value: value
	      }), this.renderClearIcon(prefixCls));
	    }
	  }, {
	    key: "renderClearableLabeledInput",
	    value: function renderClearableLabeledInput() {
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          inputType = _this$props5.inputType,
	          element = _this$props5.element;
	
	      if (inputType === ClearableInputType[0]) {
	        return this.renderTextAreaWithClearIcon(prefixCls, element);
	      }
	
	      return this.renderInputWithLabel(prefixCls, this.renderLabeledIcon(prefixCls, element));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderClearableLabeledInput();
	    }
	  }]);
	
	  return ClearableLabeledInput;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(ClearableLabeledInput);
	var _default = ClearableLabeledInput;
	exports["default"] = _default;

/***/ },
/* 634 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _ClearableLabeledInput = _interopRequireDefault(__webpack_require__(633));
	
	var _ResizableTextArea = _interopRequireDefault(__webpack_require__(1279));
	
	var _configProvider = __webpack_require__(11);
	
	var _Input = __webpack_require__(269);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var TextArea = /*#__PURE__*/function (_React$Component) {
	  _inherits(TextArea, _React$Component);
	
	  var _super = _createSuper(TextArea);
	
	  function TextArea(props) {
	    var _this;
	
	    _classCallCheck(this, TextArea);
	
	    _this = _super.call(this, props);
	
	    _this.saveTextArea = function (resizableTextArea) {
	      _this.resizableTextArea = resizableTextArea;
	    };
	
	    _this.saveClearableInput = function (clearableInput) {
	      _this.clearableInput = clearableInput;
	    };
	
	    _this.handleChange = function (e) {
	      _this.setValue(e.target.value, function () {
	        _this.resizableTextArea.resizeTextarea();
	      });
	
	      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
	    };
	
	    _this.handleKeyDown = function (e) {
	      var _this$props = _this.props,
	          onPressEnter = _this$props.onPressEnter,
	          onKeyDown = _this$props.onKeyDown;
	
	      if (e.keyCode === 13 && onPressEnter) {
	        onPressEnter(e);
	      }
	
	      if (onKeyDown) {
	        onKeyDown(e);
	      }
	    };
	
	    _this.handleReset = function (e) {
	      _this.setValue('', function () {
	        _this.resizableTextArea.renderTextArea();
	
	        _this.focus();
	      });
	
	      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
	    };
	
	    _this.renderTextArea = function (prefixCls) {
	      return /*#__PURE__*/React.createElement(_ResizableTextArea["default"], _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        onKeyDown: _this.handleKeyDown,
	        onChange: _this.handleChange,
	        ref: _this.saveTextArea
	      }));
	    };
	
	    _this.renderComponent = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var value = _this.state.value;
	      var customizePrefixCls = _this.props.prefixCls;
	      var prefixCls = getPrefixCls('input', customizePrefixCls);
	      return /*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        inputType: "text",
	        value: (0, _Input.fixControlledValue)(value),
	        element: _this.renderTextArea(prefixCls),
	        handleReset: _this.handleReset,
	        ref: _this.saveClearableInput
	      }));
	    };
	
	    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(TextArea, [{
	    key: "setValue",
	    value: function setValue(value, callback) {
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        }, callback);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.resizableTextArea.textArea.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.resizableTextArea.textArea.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return TextArea;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(TextArea);
	var _default = TextArea;
	exports["default"] = _default;

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.LayoutContext = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(129));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var LayoutContext = (0, _createReactContext["default"])({
	  siderHook: {
	    addSider: function addSider() {
	      return null;
	    },
	    removeSider: function removeSider() {
	      return null;
	    }
	  }
	});
	exports.LayoutContext = LayoutContext;
	
	function generator(_ref) {
	  var suffixCls = _ref.suffixCls,
	      tagName = _ref.tagName,
	      displayName = _ref.displayName;
	  return function (BasicComponent) {
	    var _a;
	
	    return _a = /*#__PURE__*/function (_React$Component) {
	      _inherits(Adapter, _React$Component);
	
	      var _super = _createSuper(Adapter);
	
	      function Adapter() {
	        var _this;
	
	        _classCallCheck(this, Adapter);
	
	        _this = _super.apply(this, arguments);
	
	        _this.renderComponent = function (_ref2) {
	          var getPrefixCls = _ref2.getPrefixCls;
	          var customizePrefixCls = _this.props.prefixCls;
	          var prefixCls = getPrefixCls(suffixCls, customizePrefixCls);
	          return /*#__PURE__*/React.createElement(BasicComponent, _extends({
	            prefixCls: prefixCls,
	            tagName: tagName
	          }, _this.props));
	        };
	
	        return _this;
	      }
	
	      _createClass(Adapter, [{
	        key: "render",
	        value: function render() {
	          return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
	        }
	      }]);
	
	      return Adapter;
	    }(React.Component), _a.displayName = displayName, _a;
	  };
	}
	
	var Basic = function Basic(props) {
	  var prefixCls = props.prefixCls,
	      className = props.className,
	      children = props.children,
	      tagName = props.tagName,
	      others = __rest(props, ["prefixCls", "className", "children", "tagName"]);
	
	  var classString = (0, _classnames["default"])(className, prefixCls);
	  return /*#__PURE__*/React.createElement(tagName, _extends({
	    className: classString
	  }, others), children);
	};
	
	var BasicLayout = /*#__PURE__*/function (_React$Component2) {
	  _inherits(BasicLayout, _React$Component2);
	
	  var _super2 = _createSuper(BasicLayout);
	
	  function BasicLayout() {
	    var _this2;
	
	    _classCallCheck(this, BasicLayout);
	
	    _this2 = _super2.apply(this, arguments);
	    _this2.state = {
	      siders: []
	    };
	    return _this2;
	  }
	
	  _createClass(BasicLayout, [{
	    key: "getSiderHook",
	    value: function getSiderHook() {
	      var _this3 = this;
	
	      return {
	        addSider: function addSider(id) {
	          _this3.setState(function (state) {
	            return {
	              siders: [].concat(_toConsumableArray(state.siders), [id])
	            };
	          });
	        },
	        removeSider: function removeSider(id) {
	          _this3.setState(function (state) {
	            return {
	              siders: state.siders.filter(function (currentId) {
	                return currentId !== id;
	              })
	            };
	          });
	        }
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          prefixCls = _a.prefixCls,
	          className = _a.className,
	          children = _a.children,
	          hasSider = _a.hasSider,
	          Tag = _a.tagName,
	          others = __rest(_a, ["prefixCls", "className", "children", "hasSider", "tagName"]);
	
	      var classString = (0, _classnames["default"])(className, prefixCls, _defineProperty({}, "".concat(prefixCls, "-has-sider"), typeof hasSider === 'boolean' ? hasSider : this.state.siders.length > 0));
	      return /*#__PURE__*/React.createElement(LayoutContext.Provider, {
	        value: {
	          siderHook: this.getSiderHook()
	        }
	      }, /*#__PURE__*/React.createElement(Tag, _extends({
	        className: classString
	      }, others), children));
	    }
	  }]);
	
	  return BasicLayout;
	}(React.Component);
	
	var Layout = generator({
	  suffixCls: 'layout',
	  tagName: 'section',
	  displayName: 'Layout'
	})(BasicLayout);
	var Header = generator({
	  suffixCls: 'layout-header',
	  tagName: 'header',
	  displayName: 'Header'
	})(Basic);
	var Footer = generator({
	  suffixCls: 'layout-footer',
	  tagName: 'footer',
	  displayName: 'Footer'
	})(Basic);
	var Content = generator({
	  suffixCls: 'layout-content',
	  tagName: 'main',
	  displayName: 'Content'
	})(Basic);
	Layout.Header = Header;
	Layout.Footer = Footer;
	Layout.Content = Content;
	var _default = Layout;
	exports["default"] = _default;

/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ANT_MARK = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var moment = _interopRequireWildcard(__webpack_require__(3));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(149));
	
	var _locale = __webpack_require__(411);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ANT_MARK = 'internalMark';
	exports.ANT_MARK = ANT_MARK;
	
	function setMomentLocale(locale) {
	  if (locale && locale.locale) {
	    (0, _interopDefault["default"])(moment).locale(locale.locale);
	  } else {
	    (0, _interopDefault["default"])(moment).locale('en');
	  }
	}
	
	var LocaleProvider = /*#__PURE__*/function (_React$Component) {
	  _inherits(LocaleProvider, _React$Component);
	
	  var _super = _createSuper(LocaleProvider);
	
	  function LocaleProvider(props) {
	    var _this;
	
	    _classCallCheck(this, LocaleProvider);
	
	    _this = _super.call(this, props);
	    setMomentLocale(props.locale);
	    (0, _locale.changeConfirmLocale)(props.locale && props.locale.Modal);
	    (0, _warning["default"])(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
	    return _this;
	  }
	
	  _createClass(LocaleProvider, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        antLocale: _extends(_extends({}, this.props.locale), {
	          exist: true
	        })
	      };
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var locale = this.props.locale;
	
	      if (prevProps.locale !== locale) {
	        setMomentLocale(locale);
	        (0, _locale.changeConfirmLocale)(locale && locale.Modal);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      (0, _locale.changeConfirmLocale)();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return LocaleProvider;
	}(React.Component);
	
	exports["default"] = LocaleProvider;
	LocaleProvider.propTypes = {
	  locale: PropTypes.object
	};
	LocaleProvider.defaultProps = {
	  locale: {}
	};
	LocaleProvider.childContextTypes = {
	  antLocale: PropTypes.object
	};

/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.destroyFns = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcDialog = _interopRequireDefault(__webpack_require__(2661));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(145));
	
	var _locale = __webpack_require__(411);
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _button = _interopRequireDefault(__webpack_require__(189));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var mousePosition;
	var destroyFns = []; // ref: https://github.com/ant-design/ant-design/issues/15795
	
	exports.destroyFns = destroyFns;
	
	var getClickPosition = function getClickPosition(e) {
	  mousePosition = {
	    x: e.pageX,
	    y: e.pageY
	  }; // 100ms 内发生过点击事件，则从点击位置动画展示
	  // 否则直接 zoom 展示
	  // 这样可以兼容非点击方式展开
	
	  setTimeout(function () {
	    return mousePosition = null;
	  }, 100);
	}; // 只有点击事件支持从鼠标位置动画展开
	
	
	if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	  (0, _addEventListener["default"])(document.documentElement, 'click', getClickPosition);
	}
	
	var Modal = /*#__PURE__*/function (_React$Component) {
	  _inherits(Modal, _React$Component);
	
	  var _super = _createSuper(Modal);
	
	  function Modal() {
	    var _this;
	
	    _classCallCheck(this, Modal);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleCancel = function (e) {
	      var onCancel = _this.props.onCancel;
	
	      if (onCancel) {
	        onCancel(e);
	      }
	    };
	
	    _this.handleOk = function (e) {
	      var onOk = _this.props.onOk;
	
	      if (onOk) {
	        onOk(e);
	      }
	    };
	
	    _this.renderFooter = function (locale) {
	      var _this$props = _this.props,
	          okText = _this$props.okText,
	          okType = _this$props.okType,
	          cancelText = _this$props.cancelText,
	          confirmLoading = _this$props.confirmLoading;
	      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_button["default"], _extends({
	        onClick: _this.handleCancel
	      }, _this.props.cancelButtonProps), cancelText || locale.cancelText), /*#__PURE__*/React.createElement(_button["default"], _extends({
	        type: okType,
	        loading: confirmLoading,
	        onClick: _this.handleOk
	      }, _this.props.okButtonProps), okText || locale.okText));
	    };
	
	    _this.renderModal = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          footer = _a.footer,
	          visible = _a.visible,
	          wrapClassName = _a.wrapClassName,
	          centered = _a.centered,
	          getContainer = _a.getContainer,
	          closeIcon = _a.closeIcon,
	          restProps = __rest(_a, ["prefixCls", "footer", "visible", "wrapClassName", "centered", "getContainer", "closeIcon"]);
	
	      var prefixCls = getPrefixCls('modal', customizePrefixCls);
	      var defaultFooter = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Modal",
	        defaultLocale: (0, _locale.getConfirmLocale)()
	      }, _this.renderFooter);
	      var closeIconToRender = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-close-x")
	      }, closeIcon || /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-close-icon"),
	        type: "close"
	      }));
	      return /*#__PURE__*/React.createElement(_rcDialog["default"], _extends({}, restProps, {
	        getContainer: getContainer === undefined ? getContextPopupContainer : getContainer,
	        prefixCls: prefixCls,
	        wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-centered"), !!centered), wrapClassName),
	        footer: footer === undefined ? defaultFooter : footer,
	        visible: visible,
	        mousePosition: mousePosition,
	        onClose: _this.handleCancel,
	        closeIcon: closeIconToRender
	      }));
	    };
	
	    return _this;
	  }
	
	  _createClass(Modal, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderModal);
	    }
	  }]);
	
	  return Modal;
	}(React.Component);
	
	exports["default"] = Modal;
	Modal.defaultProps = {
	  width: 520,
	  transitionName: 'zoom',
	  maskTransitionName: 'fade',
	  confirmLoading: false,
	  visible: false,
	  okType: 'primary'
	};
	Modal.propTypes = {
	  prefixCls: PropTypes.string,
	  onOk: PropTypes.func,
	  onCancel: PropTypes.func,
	  okText: PropTypes.node,
	  cancelText: PropTypes.node,
	  centered: PropTypes.bool,
	  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	  confirmLoading: PropTypes.bool,
	  visible: PropTypes.bool,
	  footer: PropTypes.node,
	  title: PropTypes.node,
	  closable: PropTypes.bool,
	  closeIcon: PropTypes.node
	};

/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _progress = _interopRequireDefault(__webpack_require__(1304));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _progress["default"];
	exports["default"] = _default;

/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _grid = __webpack_require__(318);
	
	var _default = _grid.Row;
	exports["default"] = _default;

/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _context = __webpack_require__(317);
	
	var _Number = _interopRequireDefault(__webpack_require__(1318));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Statistic = function Statistic(props) {
	  var prefixCls = props.prefixCls,
	      className = props.className,
	      style = props.style,
	      valueStyle = props.valueStyle,
	      _props$value = props.value,
	      value = _props$value === void 0 ? 0 : _props$value,
	      title = props.title,
	      valueRender = props.valueRender,
	      prefix = props.prefix,
	      suffix = props.suffix;
	  var valueNode = /*#__PURE__*/React.createElement(_Number["default"], _extends({}, props, {
	    value: value
	  }));
	
	  if (valueRender) {
	    valueNode = valueRender(valueNode);
	  }
	
	  return /*#__PURE__*/React.createElement("div", {
	    className: (0, _classnames["default"])(prefixCls, className),
	    style: style
	  }, title && /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-title")
	  }, title), /*#__PURE__*/React.createElement("div", {
	    style: valueStyle,
	    className: "".concat(prefixCls, "-content")
	  }, prefix && /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-content-prefix")
	  }, prefix), valueNode, suffix && /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-content-suffix")
	  }, suffix)));
	};
	
	Statistic.defaultProps = {
	  decimalSeparator: '.',
	  groupSeparator: ','
	};
	var WrapperStatistic = (0, _context.withConfigConsumer)({
	  prefixCls: 'statistic'
	})(Statistic);
	var _default = WrapperStatistic;
	exports["default"] = _default;

/***/ },
/* 641 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.flatArray = flatArray;
	exports.treeMap = treeMap;
	exports.flatFilter = flatFilter;
	exports.normalizeColumns = normalizeColumns;
	exports.generateValueMaps = generateValueMaps;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function flatArray() {
	  var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var childrenName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'children';
	  var result = [];
	
	  var loop = function loop(array) {
	    array.forEach(function (item) {
	      if (item[childrenName]) {
	        var newItem = _extends({}, item);
	
	        delete newItem[childrenName];
	        result.push(newItem);
	
	        if (item[childrenName].length > 0) {
	          loop(item[childrenName]);
	        }
	      } else {
	        result.push(item);
	      }
	    });
	  };
	
	  loop(data);
	  return result;
	}
	
	function treeMap(tree, mapper) {
	  var childrenName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'children';
	  return tree.map(function (node, index) {
	    var extra = {};
	
	    if (node[childrenName]) {
	      extra[childrenName] = treeMap(node[childrenName], mapper, childrenName);
	    }
	
	    return _extends(_extends({}, mapper(node, index)), extra);
	  });
	}
	
	function flatFilter(tree, callback) {
	  return tree.reduce(function (acc, node) {
	    if (callback(node)) {
	      acc.push(node);
	    }
	
	    if (node.children) {
	      var children = flatFilter(node.children, callback);
	      acc.push.apply(acc, _toConsumableArray(children));
	    }
	
	    return acc;
	  }, []);
	}
	
	function normalizeColumns(elements) {
	  var columns = [];
	  React.Children.forEach(elements, function (element) {
	    if (! /*#__PURE__*/React.isValidElement(element)) {
	      return;
	    }
	
	    var column = _extends({}, element.props);
	
	    if (element.key) {
	      column.key = element.key;
	    }
	
	    if (element.type && element.type.__ANT_TABLE_COLUMN_GROUP) {
	      column.children = normalizeColumns(column.children);
	    }
	
	    columns.push(column);
	  });
	  return columns;
	}
	
	function generateValueMaps(items) {
	  var maps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (items || []).forEach(function (_ref) {
	    var value = _ref.value,
	        children = _ref.children;
	    maps[value.toString()] = value;
	    generateValueMaps(children, maps);
	  });
	  return maps;
	}

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var _rcTabs = _interopRequireWildcard(__webpack_require__(2743));
	
	var _TabContent = _interopRequireDefault(__webpack_require__(1107));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _TabBar = _interopRequireDefault(__webpack_require__(1333));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _styleChecker = __webpack_require__(616);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Tabs = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tabs, _React$Component);
	
	  var _super = _createSuper(Tabs);
	
	  function Tabs() {
	    var _this;
	
	    _classCallCheck(this, Tabs);
	
	    _this = _super.apply(this, arguments);
	
	    _this.removeTab = function (targetKey, e) {
	      e.stopPropagation();
	
	      if (!targetKey) {
	        return;
	      }
	
	      var onEdit = _this.props.onEdit;
	
	      if (onEdit) {
	        onEdit(targetKey, 'remove');
	      }
	    };
	
	    _this.handleChange = function (activeKey) {
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(activeKey);
	      }
	    };
	
	    _this.createNewTab = function (targetKey) {
	      var onEdit = _this.props.onEdit;
	
	      if (onEdit) {
	        onEdit(targetKey, 'add');
	      }
	    };
	
	    _this.renderTabs = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          size = _this$props.size,
	          _this$props$type = _this$props.type,
	          type = _this$props$type === void 0 ? 'line' : _this$props$type,
	          tabPosition = _this$props.tabPosition,
	          children = _this$props.children,
	          _this$props$animated = _this$props.animated,
	          animated = _this$props$animated === void 0 ? true : _this$props$animated,
	          hideAdd = _this$props.hideAdd;
	      var tabBarExtraContent = _this.props.tabBarExtraContent;
	      var tabPaneAnimated = _typeof(animated) === 'object' ? animated.tabPane : animated; // card tabs should not have animation
	
	      if (type !== 'line') {
	        tabPaneAnimated = 'animated' in _this.props ? tabPaneAnimated : false;
	      }
	
	      (0, _warning["default"])(!(type.indexOf('card') >= 0 && (size === 'small' || size === 'large')), 'Tabs', "`type=card|editable-card` doesn't have small or large size, it's by design.");
	      var prefixCls = getPrefixCls('tabs', customizePrefixCls);
	      var cls = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), tabPosition === 'left' || tabPosition === 'right'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card"), type.indexOf('card') >= 0), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), true), _defineProperty(_classNames, "".concat(prefixCls, "-no-animation"), !tabPaneAnimated), _classNames)); // only card type tabs can be added and closed
	
	      var childrenWithClose = [];
	
	      if (type === 'editable-card') {
	        childrenWithClose = [];
	        React.Children.forEach(children, function (child, index) {
	          if (! /*#__PURE__*/React.isValidElement(child)) return child;
	          var closable = child.props.closable;
	          closable = typeof closable === 'undefined' ? true : closable;
	          var closeIcon = closable ? /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "close",
	            className: "".concat(prefixCls, "-close-x"),
	            onClick: function onClick(e) {
	              return _this.removeTab(child.key, e);
	            }
	          }) : null;
	          childrenWithClose.push( /*#__PURE__*/React.cloneElement(child, {
	            tab: /*#__PURE__*/React.createElement("div", {
	              className: closable ? undefined : "".concat(prefixCls, "-tab-unclosable")
	            }, child.props.tab, closeIcon),
	            key: child.key || index
	          }));
	        }); // Add new tab handler
	
	        if (!hideAdd) {
	          tabBarExtraContent = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_icon["default"], {
	            type: "plus",
	            className: "".concat(prefixCls, "-new-tab"),
	            onClick: _this.createNewTab
	          }), tabBarExtraContent);
	        }
	      }
	
	      tabBarExtraContent = tabBarExtraContent ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-extra-content")
	      }, tabBarExtraContent) : null;
	
	      var tabBarProps = __rest(_this.props, []);
	
	      var contentCls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-content"), type.indexOf('card') >= 0 && "".concat(prefixCls, "-card-content"));
	      return /*#__PURE__*/React.createElement(_rcTabs["default"], _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        className: cls,
	        tabBarPosition: tabPosition,
	        renderTabBar: function renderTabBar() {
	          return /*#__PURE__*/React.createElement(_TabBar["default"], _extends({}, (0, _omit["default"])(tabBarProps, ['className']), {
	            tabBarExtraContent: tabBarExtraContent
	          }));
	        },
	        renderTabContent: function renderTabContent() {
	          return /*#__PURE__*/React.createElement(_TabContent["default"], {
	            className: contentCls,
	            animated: tabPaneAnimated,
	            animatedWithMargin: true
	          });
	        },
	        onChange: _this.handleChange
	      }), childrenWithClose.length > 0 ? childrenWithClose : children);
	    };
	
	    return _this;
	  }
	
	  _createClass(Tabs, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var NO_FLEX = ' no-flex';
	      var tabNode = ReactDOM.findDOMNode(this);
	
	      if (tabNode && !_styleChecker.isFlexSupported && tabNode.className.indexOf(NO_FLEX) === -1) {
	        tabNode.className += NO_FLEX;
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTabs);
	    }
	  }]);
	
	  return Tabs;
	}(React.Component);
	
	exports["default"] = Tabs;
	Tabs.TabPane = _rcTabs.TabPane;
	Tabs.defaultProps = {
	  hideAdd: false,
	  tabPosition: 'top'
	};

/***/ },
/* 643 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _CheckableTag = _interopRequireDefault(__webpack_require__(1334));
	
	var _configProvider = __webpack_require__(11);
	
	var _colors = __webpack_require__(611);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _wave = _interopRequireDefault(__webpack_require__(404));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var PresetColorRegex = new RegExp("^(".concat(_colors.PresetColorTypes.join('|'), ")(-inverse)?$"));
	
	var Tag = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tag, _React$Component);
	
	  var _super = _createSuper(Tag);
	
	  function Tag(props) {
	    var _this;
	
	    _classCallCheck(this, Tag);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      visible: true
	    };
	
	    _this.handleIconClick = function (e) {
	      e.stopPropagation();
	
	      _this.setVisible(false, e);
	    };
	
	    _this.renderTag = function (configProps) {
	      var _a = _this.props,
	          children = _a.children,
	          otherProps = __rest(_a, ["children"]);
	
	      var isNeedWave = 'onClick' in otherProps || children && children.type === 'a';
	      var tagProps = (0, _omit["default"])(otherProps, ['onClose', 'afterClose', 'color', 'visible', 'closable', 'prefixCls']);
	      return isNeedWave ? /*#__PURE__*/React.createElement(_wave["default"], null, /*#__PURE__*/React.createElement("span", _extends({}, tagProps, {
	        className: _this.getTagClassName(configProps),
	        style: _this.getTagStyle()
	      }), children, _this.renderCloseIcon())) : /*#__PURE__*/React.createElement("span", _extends({}, tagProps, {
	        className: _this.getTagClassName(configProps),
	        style: _this.getTagStyle()
	      }), children, _this.renderCloseIcon());
	    };
	
	    (0, _warning["default"])(!('afterClose' in props), 'Tag', "'afterClose' will be deprecated, please use 'onClose', we will remove this in the next version.");
	    return _this;
	  }
	
	  _createClass(Tag, [{
	    key: "getTagStyle",
	    value: function getTagStyle() {
	      var _this$props = this.props,
	          color = _this$props.color,
	          style = _this$props.style;
	      var isPresetColor = this.isPresetColor();
	      return _extends({
	        backgroundColor: color && !isPresetColor ? color : undefined
	      }, style);
	    }
	  }, {
	    key: "getTagClassName",
	    value: function getTagClassName(_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          color = _this$props2.color;
	      var visible = this.state.visible;
	      var isPresetColor = this.isPresetColor();
	      var prefixCls = getPrefixCls('tag', customizePrefixCls);
	      return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(color), isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-has-color"), color && !isPresetColor), _defineProperty(_classNames, "".concat(prefixCls, "-hidden"), !visible), _classNames), className);
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible, e) {
	      var _this$props3 = this.props,
	          onClose = _this$props3.onClose,
	          afterClose = _this$props3.afterClose;
	
	      if (onClose) {
	        onClose(e);
	      }
	
	      if (afterClose && !onClose) {
	        // next version remove.
	        afterClose();
	      }
	
	      if (e.defaultPrevented) {
	        return;
	      }
	
	      if (!('visible' in this.props)) {
	        this.setState({
	          visible: visible
	        });
	      }
	    }
	  }, {
	    key: "isPresetColor",
	    value: function isPresetColor() {
	      var color = this.props.color;
	
	      if (!color) {
	        return false;
	      }
	
	      return PresetColorRegex.test(color);
	    }
	  }, {
	    key: "renderCloseIcon",
	    value: function renderCloseIcon() {
	      var closable = this.props.closable;
	      return closable ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        onClick: this.handleIconClick
	      }) : null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTag);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Tag;
	}(React.Component);
	
	Tag.CheckableTag = _CheckableTag["default"];
	Tag.defaultProps = {
	  closable: false
	};
	(0, _reactLifecyclesCompat.polyfill)(Tag);
	var _default = Tag;
	exports["default"] = _default;

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.generateShowHourMinuteSecond = generateShowHourMinuteSecond;
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var moment = _interopRequireWildcard(__webpack_require__(3));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _TimePicker = _interopRequireDefault(__webpack_require__(2747));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _configProvider = __webpack_require__(11);
	
	var _en_US = _interopRequireDefault(__webpack_require__(415));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(149));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function generateShowHourMinuteSecond(format) {
	  // Ref: http://momentjs.com/docs/#/parsing/string-format/
	  return {
	    showHour: format.indexOf('H') > -1 || format.indexOf('h') > -1 || format.indexOf('k') > -1,
	    showMinute: format.indexOf('m') > -1,
	    showSecond: format.indexOf('s') > -1
	  };
	}
	
	var TimePicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(TimePicker, _React$Component);
	
	  var _super = _createSuper(TimePicker);
	
	  function TimePicker(props) {
	    var _this;
	
	    _classCallCheck(this, TimePicker);
	
	    _this = _super.call(this, props);
	
	    _this.getDefaultLocale = function () {
	      var defaultLocale = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	      return defaultLocale;
	    };
	
	    _this.handleOpenClose = function (_ref) {
	      var open = _ref.open;
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.saveTimePicker = function (timePickerRef) {
	      _this.timePickerRef = timePickerRef;
	    };
	
	    _this.handleChange = function (value) {
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          _this$props$format = _this$props.format,
	          format = _this$props$format === void 0 ? 'HH:mm:ss' : _this$props$format;
	
	      if (onChange) {
	        onChange(value, value && value.format(format) || '');
	      }
	    };
	
	    _this.renderTimePicker = function (locale) {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	        var getContextPopupContainer = _ref2.getPopupContainer,
	            getPrefixCls = _ref2.getPrefixCls;
	
	        var _a = _this.props,
	            getPopupContainer = _a.getPopupContainer,
	            customizePrefixCls = _a.prefixCls,
	            className = _a.className,
	            addon = _a.addon,
	            placeholder = _a.placeholder,
	            props = __rest(_a, ["getPopupContainer", "prefixCls", "className", "addon", "placeholder"]);
	
	        var size = props.size;
	        var pickerProps = (0, _omit["default"])(props, ['defaultValue', 'suffixIcon', 'allowEmpty', 'allowClear']);
	
	        var format = _this.getDefaultFormat();
	
	        var prefixCls = getPrefixCls('time-picker', customizePrefixCls);
	        var pickerClassName = (0, _classnames["default"])(className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
	
	        var pickerAddon = function pickerAddon(panel) {
	          return addon ? /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-panel-addon")
	          }, addon(panel)) : null;
	        };
	
	        return /*#__PURE__*/React.createElement(_TimePicker["default"], _extends({}, generateShowHourMinuteSecond(format), pickerProps, {
	          allowEmpty: _this.getAllowClear(),
	          prefixCls: prefixCls,
	          getPopupContainer: getPopupContainer || getContextPopupContainer,
	          ref: _this.saveTimePicker,
	          format: format,
	          className: pickerClassName,
	          value: _this.state.value,
	          placeholder: placeholder === undefined ? locale.placeholder : placeholder,
	          onChange: _this.handleChange,
	          onOpen: _this.handleOpenClose,
	          onClose: _this.handleOpenClose,
	          addon: pickerAddon,
	          inputIcon: _this.renderInputIcon(prefixCls),
	          clearIcon: _this.renderClearIcon(prefixCls)
	        }));
	      });
	    };
	
	    var value = props.value || props.defaultValue;
	
	    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of TimePicker must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/time-picker-value');
	    }
	
	    _this.state = {
	      value: value
	    };
	    (0, _warning["default"])(!('allowEmpty' in props), 'TimePicker', '`allowEmpty` is deprecated. Please use `allowClear` instead.');
	    return _this;
	  }
	
	  _createClass(TimePicker, [{
	    key: "getDefaultFormat",
	    value: function getDefaultFormat() {
	      var _this$props2 = this.props,
	          format = _this$props2.format,
	          use12Hours = _this$props2.use12Hours;
	
	      if (format) {
	        return format;
	      }
	
	      if (use12Hours) {
	        return 'h:mm:ss a';
	      }
	
	      return 'HH:mm:ss';
	    }
	  }, {
	    key: "getAllowClear",
	    value: function getAllowClear() {
	      var _this$props3 = this.props,
	          allowClear = _this$props3.allowClear,
	          allowEmpty = _this$props3.allowEmpty;
	
	      if ('allowClear' in this.props) {
	        return allowClear;
	      }
	
	      return allowEmpty;
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.timePickerRef.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.timePickerRef.blur();
	    }
	  }, {
	    key: "renderInputIcon",
	    value: function renderInputIcon(prefixCls) {
	      var suffixIcon = this.props.suffixIcon;
	      var clockIcon = suffixIcon && /*#__PURE__*/React.isValidElement(suffixIcon) && /*#__PURE__*/React.cloneElement(suffixIcon, {
	        className: (0, _classnames["default"])(suffixIcon.props.className, "".concat(prefixCls, "-clock-icon"))
	      }) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "clock-circle",
	        className: "".concat(prefixCls, "-clock-icon")
	      });
	      return /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-icon")
	      }, clockIcon);
	    }
	  }, {
	    key: "renderClearIcon",
	    value: function renderClearIcon(prefixCls) {
	      var clearIcon = this.props.clearIcon;
	      var clearIconPrefixCls = "".concat(prefixCls, "-clear");
	
	      if (clearIcon && /*#__PURE__*/React.isValidElement(clearIcon)) {
	        return /*#__PURE__*/React.cloneElement(clearIcon, {
	          className: (0, _classnames["default"])(clearIcon.props.className, clearIconPrefixCls)
	        });
	      }
	
	      return /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        className: clearIconPrefixCls,
	        theme: "filled"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "TimePicker",
	        defaultLocale: this.getDefaultLocale()
	      }, this.renderTimePicker);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return TimePicker;
	}(React.Component);
	
	TimePicker.defaultProps = {
	  align: {
	    offset: [0, -2]
	  },
	  disabledHours: undefined,
	  disabledMinutes: undefined,
	  disabledSeconds: undefined,
	  hideDisabledOptions: false,
	  placement: 'bottomLeft',
	  transitionName: 'slide-up',
	  focusOnOpen: true
	};
	(0, _reactLifecyclesCompat.polyfill)(TimePicker);
	var _default = TimePicker;
	exports["default"] = _default;

/***/ },
/* 645 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var locale = {
	  placeholder: '请选择时间'
	};
	var _default = locale;
	exports["default"] = _default;

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _input = _interopRequireDefault(__webpack_require__(319));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Search = /*#__PURE__*/function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  var _super = _createSuper(Search);
	
	  function Search() {
	    var _this;
	
	    _classCallCheck(this, Search);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleChange = function (e) {
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(e);
	      }
	    };
	
	    _this.handleClear = function (e) {
	      e.preventDefault();
	      var _this$props = _this.props,
	          handleClear = _this$props.handleClear,
	          disabled = _this$props.disabled;
	
	      if (!disabled && handleClear) {
	        handleClear(e);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          placeholder = _this$props2.placeholder,
	          value = _this$props2.value,
	          prefixCls = _this$props2.prefixCls,
	          disabled = _this$props2.disabled;
	      var icon = value && value.length > 0 ? /*#__PURE__*/React.createElement("a", {
	        href: "#",
	        className: "".concat(prefixCls, "-action"),
	        onClick: this.handleClear
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled"
	      })) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-action")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "search"
	      }));
	      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_input["default"], {
	        placeholder: placeholder,
	        className: prefixCls,
	        value: value,
	        onChange: this.handleChange,
	        disabled: disabled
	      }), icon);
	    }
	  }]);
	
	  return Search;
	}(React.Component);
	
	exports["default"] = Search;
	Search.defaultProps = {
	  placeholder: ''
	};

/***/ },
/* 647 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcTree = _interopRequireWildcard(__webpack_require__(566));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _DirectoryTree = _interopRequireDefault(__webpack_require__(1345));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	var _motion = _interopRequireDefault(__webpack_require__(613));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Tree = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tree, _React$Component);
	
	  var _super = _createSuper(Tree);
	
	  function Tree() {
	    var _this;
	
	    _classCallCheck(this, Tree);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSwitcherIcon = function (prefixCls, switcherIcon, _ref) {
	      var isLeaf = _ref.isLeaf,
	          expanded = _ref.expanded,
	          loading = _ref.loading;
	      var showLine = _this.props.showLine;
	
	      if (loading) {
	        return /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "loading",
	          className: "".concat(prefixCls, "-switcher-loading-icon")
	        });
	      }
	
	      if (isLeaf) {
	        return showLine ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "file",
	          className: "".concat(prefixCls, "-switcher-line-icon")
	        }) : null;
	      }
	
	      var switcherCls = "".concat(prefixCls, "-switcher-icon");
	
	      if (switcherIcon) {
	        return /*#__PURE__*/React.cloneElement(switcherIcon, {
	          className: (0, _classnames["default"])(switcherIcon.props.className || '', switcherCls)
	        });
	      }
	
	      return showLine ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: expanded ? 'minus-square' : 'plus-square',
	        className: "".concat(prefixCls, "-switcher-line-icon"),
	        theme: "outlined"
	      }) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "caret-down",
	        className: switcherCls,
	        theme: "filled"
	      });
	    };
	
	    _this.setTreeRef = function (node) {
	      _this.tree = node;
	    };
	
	    _this.renderTree = function (_ref2) {
	      var _classNames;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          showIcon = props.showIcon,
	          _switcherIcon = props.switcherIcon,
	          blockNode = props.blockNode,
	          children = props.children;
	      var checkable = props.checkable;
	      var prefixCls = getPrefixCls('tree', customizePrefixCls);
	      return /*#__PURE__*/React.createElement(_rcTree["default"], _extends({
	        ref: _this.setTreeRef
	      }, props, {
	        prefixCls: prefixCls,
	        className: (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-icon-hide"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-block-node"), blockNode), _classNames)),
	        checkable: checkable ? /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-checkbox-inner")
	        }) : checkable,
	        switcherIcon: function switcherIcon(nodeProps) {
	          return _this.renderSwitcherIcon(prefixCls, _switcherIcon, nodeProps);
	        }
	      }), children);
	    };
	
	    return _this;
	  }
	
	  _createClass(Tree, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTree);
	    }
	  }]);
	
	  return Tree;
	}(React.Component);
	
	exports["default"] = Tree;
	Tree.TreeNode = _rcTree.TreeNode;
	Tree.DirectoryTree = _DirectoryTree["default"];
	Tree.defaultProps = {
	  checkable: false,
	  showIcon: false,
	  motion: _extends(_extends({}, _motion["default"]), {
	    motionAppear: false
	  }),
	  blockNode: false
	};

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _ref2 = __webpack_require__(1227);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Typography = function Typography(_a, ref) {
	  var customizePrefixCls = _a.prefixCls,
	      _a$component = _a.component,
	      component = _a$component === void 0 ? 'article' : _a$component,
	      className = _a.className,
	      ariaLabel = _a['aria-label'],
	      setContentRef = _a.setContentRef,
	      children = _a.children,
	      restProps = __rest(_a, ["prefixCls", "component", "className", 'aria-label', "setContentRef", "children"]);
	
	  var mergedRef = ref;
	
	  if (setContentRef) {
	    (0, _warning["default"])(false, 'Typography', '`setContentRef` is deprecated. Please use `ref` instead.');
	    mergedRef = (0, _ref2.composeRef)(ref, setContentRef);
	  }
	
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	    var getPrefixCls = _ref.getPrefixCls;
	    var Component = component;
	    var prefixCls = getPrefixCls('typography', customizePrefixCls);
	    return /*#__PURE__*/React.createElement(Component, _extends({
	      className: (0, _classnames["default"])(prefixCls, className),
	      "aria-label": ariaLabel,
	      ref: mergedRef
	    }, restProps), children);
	  });
	};
	
	var RefTypography;
	
	if (React.forwardRef) {
	  RefTypography = /*#__PURE__*/React.forwardRef(Typography);
	  RefTypography.displayName = 'Typography';
	} else {
	  var TypographyWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(TypographyWrapper, _React$Component);
	
	    var _super = _createSuper(TypographyWrapper);
	
	    function TypographyWrapper() {
	      var _this;
	
	      _classCallCheck(this, TypographyWrapper);
	
	      _this = _super.apply(this, arguments);
	      _this.state = {};
	      return _this;
	    }
	
	    _createClass(TypographyWrapper, [{
	      key: "render",
	      value: function render() {
	        return /*#__PURE__*/React.createElement(Typography, this.props);
	      }
	    }]);
	
	    return TypographyWrapper;
	  }(React.Component);
	
	  RefTypography = TypographyWrapper;
	} // es default export should use const instead of let
	
	
	var ExportTypography = RefTypography;
	var _default = ExportTypography;
	exports["default"] = _default;

/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _rcUpload = _interopRequireDefault(__webpack_require__(2774));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _uniqBy = _interopRequireDefault(__webpack_require__(2608));
	
	var _findIndex = _interopRequireDefault(__webpack_require__(2590));
	
	var _UploadList = _interopRequireDefault(__webpack_require__(1355));
	
	var _utils = __webpack_require__(650);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _default2 = _interopRequireDefault(__webpack_require__(227));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Upload = /*#__PURE__*/function (_React$Component) {
	  _inherits(Upload, _React$Component);
	
	  var _super = _createSuper(Upload);
	
	  function Upload(props) {
	    var _this;
	
	    _classCallCheck(this, Upload);
	
	    _this = _super.call(this, props);
	
	    _this.saveUpload = function (node) {
	      _this.upload = node;
	    };
	
	    _this.onStart = function (file) {
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.fileToObject)(file);
	      targetItem.status = 'uploading';
	      var nextFileList = fileList.concat();
	      var fileIndex = (0, _findIndex["default"])(nextFileList, function (_ref) {
	        var uid = _ref.uid;
	        return uid === targetItem.uid;
	      });
	
	      if (fileIndex === -1) {
	        nextFileList.push(targetItem);
	      } else {
	        nextFileList[fileIndex] = targetItem;
	      }
	
	      _this.onChange({
	        file: targetItem,
	        fileList: nextFileList
	      }); // fix ie progress
	
	
	      if (!window.File || ({"NODE_ENV":"production","PUBLIC_URL":""}).TEST_IE) {
	        _this.autoUpdateProgress(0, targetItem);
	      }
	    };
	
	    _this.onSuccess = function (response, file, xhr) {
	      _this.clearProgressTimer();
	
	      try {
	        if (typeof response === 'string') {
	          response = JSON.parse(response);
	        }
	      } catch (e) {
	        /* do nothing */
	      }
	
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.status = 'done';
	      targetItem.response = response;
	      targetItem.xhr = xhr;
	
	      _this.onChange({
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.onProgress = function (e, file) {
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.percent = e.percent;
	
	      _this.onChange({
	        event: e,
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.onError = function (error, response, file) {
	      _this.clearProgressTimer();
	
	      var fileList = _this.state.fileList;
	      var targetItem = (0, _utils.getFileItem)(file, fileList); // removed
	
	      if (!targetItem) {
	        return;
	      }
	
	      targetItem.error = error;
	      targetItem.response = response;
	      targetItem.status = 'error';
	
	      _this.onChange({
	        file: _extends({}, targetItem),
	        fileList: fileList
	      });
	    };
	
	    _this.handleRemove = function (file) {
	      var onRemove = _this.props.onRemove;
	      var fileList = _this.state.fileList;
	      Promise.resolve(typeof onRemove === 'function' ? onRemove(file) : onRemove).then(function (ret) {
	        // Prevent removing file
	        if (ret === false) {
	          return;
	        }
	
	        var removedFileList = (0, _utils.removeFileItem)(file, fileList);
	
	        if (removedFileList) {
	          file.status = 'removed'; // eslint-disable-line
	
	          if (_this.upload) {
	            _this.upload.abort(file);
	          }
	
	          _this.onChange({
	            file: file,
	            fileList: removedFileList
	          });
	        }
	      });
	    };
	
	    _this.onChange = function (info) {
	      if (!('fileList' in _this.props)) {
	        _this.setState({
	          fileList: info.fileList
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(info);
	      }
	    };
	
	    _this.onFileDrop = function (e) {
	      _this.setState({
	        dragState: e.type
	      });
	    };
	
	    _this.beforeUpload = function (file, fileList) {
	      var beforeUpload = _this.props.beforeUpload;
	      var stateFileList = _this.state.fileList;
	
	      if (!beforeUpload) {
	        return true;
	      }
	
	      var result = beforeUpload(file, fileList);
	
	      if (result === false) {
	        _this.onChange({
	          file: file,
	          fileList: (0, _uniqBy["default"])(stateFileList.concat(fileList.map(_utils.fileToObject)), function (item) {
	            return item.uid;
	          })
	        });
	
	        return false;
	      }
	
	      if (result && result.then) {
	        return result;
	      }
	
	      return true;
	    };
	
	    _this.renderUploadList = function (locale) {
	      var _this$props = _this.props,
	          showUploadList = _this$props.showUploadList,
	          listType = _this$props.listType,
	          onPreview = _this$props.onPreview,
	          onDownload = _this$props.onDownload,
	          previewFile = _this$props.previewFile,
	          disabled = _this$props.disabled,
	          propLocale = _this$props.locale;
	      var showRemoveIcon = showUploadList.showRemoveIcon,
	          showPreviewIcon = showUploadList.showPreviewIcon,
	          showDownloadIcon = showUploadList.showDownloadIcon;
	      var fileList = _this.state.fileList;
	      return /*#__PURE__*/React.createElement(_UploadList["default"], {
	        listType: listType,
	        items: fileList,
	        previewFile: previewFile,
	        onPreview: onPreview,
	        onDownload: onDownload,
	        onRemove: _this.handleRemove,
	        showRemoveIcon: !disabled && showRemoveIcon,
	        showPreviewIcon: showPreviewIcon,
	        showDownloadIcon: showDownloadIcon,
	        locale: _extends(_extends({}, locale), propLocale)
	      });
	    };
	
	    _this.renderUpload = function (_ref2) {
	      var _classNames2;
	
	      var getPrefixCls = _ref2.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          showUploadList = _this$props2.showUploadList,
	          listType = _this$props2.listType,
	          type = _this$props2.type,
	          disabled = _this$props2.disabled,
	          children = _this$props2.children,
	          style = _this$props2.style;
	      var _this$state = _this.state,
	          fileList = _this$state.fileList,
	          dragState = _this$state.dragState;
	      var prefixCls = getPrefixCls('upload', customizePrefixCls);
	
	      var rcUploadProps = _extends(_extends({
	        onStart: _this.onStart,
	        onError: _this.onError,
	        onProgress: _this.onProgress,
	        onSuccess: _this.onSuccess
	      }, _this.props), {
	        prefixCls: prefixCls,
	        beforeUpload: _this.beforeUpload
	      });
	
	      delete rcUploadProps.className;
	      delete rcUploadProps.style; // Remove id to avoid open by label when trigger is hidden
	      // !children: https://github.com/ant-design/ant-design/issues/14298
	      // disabled: https://github.com/ant-design/ant-design/issues/16478
	      //           https://github.com/ant-design/ant-design/issues/24197
	
	      if (!children || disabled) {
	        delete rcUploadProps.id;
	      }
	
	      var uploadList = showUploadList ? /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Upload",
	        defaultLocale: _default2["default"].Upload
	      }, _this.renderUploadList) : null;
	
	      if (type === 'drag') {
	        var _classNames;
	
	        var dragCls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-drag"), true), _defineProperty(_classNames, "".concat(prefixCls, "-drag-uploading"), fileList.some(function (file) {
	          return file.status === 'uploading';
	        })), _defineProperty(_classNames, "".concat(prefixCls, "-drag-hover"), dragState === 'dragover'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames), className);
	        return /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
	          className: dragCls,
	          onDrop: _this.onFileDrop,
	          onDragOver: _this.onFileDrop,
	          onDragLeave: _this.onFileDrop,
	          style: style
	        }, /*#__PURE__*/React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
	          ref: _this.saveUpload,
	          className: "".concat(prefixCls, "-btn")
	        }), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-drag-container")
	        }, children))), uploadList);
	      }
	
	      var uploadButtonCls = (0, _classnames["default"])(prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-select"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-select-").concat(listType), true), _defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _classNames2));
	      var uploadButton = /*#__PURE__*/React.createElement("div", {
	        className: uploadButtonCls,
	        style: children ? undefined : {
	          display: 'none'
	        }
	      }, /*#__PURE__*/React.createElement(_rcUpload["default"], _extends({}, rcUploadProps, {
	        ref: _this.saveUpload
	      })));
	
	      if (listType === 'picture-card') {
	        return /*#__PURE__*/React.createElement("span", {
	          className: (0, _classnames["default"])(className, "".concat(prefixCls, "-picture-card-wrapper"))
	        }, uploadList, uploadButton);
	      }
	
	      return /*#__PURE__*/React.createElement("span", {
	        className: className
	      }, uploadButton, uploadList);
	    };
	
	    _this.state = {
	      fileList: props.fileList || props.defaultFileList || [],
	      dragState: 'drop'
	    };
	    (0, _warning["default"])('fileList' in props || !('value' in props), 'Upload', '`value` is not validate prop, do you mean `fileList`?');
	    return _this;
	  }
	
	  _createClass(Upload, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearProgressTimer();
	    }
	  }, {
	    key: "clearProgressTimer",
	    value: function clearProgressTimer() {
	      clearInterval(this.progressTimer);
	    }
	  }, {
	    key: "autoUpdateProgress",
	    value: function autoUpdateProgress(_, file) {
	      var _this2 = this;
	
	      var getPercent = (0, _utils.genPercentAdd)();
	      var curPercent = 0;
	      this.clearProgressTimer();
	      this.progressTimer = setInterval(function () {
	        curPercent = getPercent(curPercent);
	
	        _this2.onProgress({
	          percent: curPercent * 100
	        }, file);
	      }, 200);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderUpload);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('fileList' in nextProps) {
	        return {
	          fileList: nextProps.fileList || []
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Upload;
	}(React.Component);
	
	Upload.defaultProps = {
	  type: 'select',
	  multiple: false,
	  action: '',
	  data: {},
	  accept: '',
	  beforeUpload: _utils.T,
	  showUploadList: true,
	  listType: 'text',
	  className: '',
	  disabled: false,
	  supportServerRender: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Upload);
	var _default = Upload;
	exports["default"] = _default;

/***/ },
/* 650 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.T = T;
	exports.fileToObject = fileToObject;
	exports.genPercentAdd = genPercentAdd;
	exports.getFileItem = getFileItem;
	exports.removeFileItem = removeFileItem;
	exports.previewImage = previewImage;
	exports.isImageUrl = void 0;
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function T() {
	  return true;
	} // Fix IE file.status problem
	// via coping a new Object
	
	
	function fileToObject(file) {
	  return _extends(_extends({}, file), {
	    lastModified: file.lastModified,
	    lastModifiedDate: file.lastModifiedDate,
	    name: file.name,
	    size: file.size,
	    type: file.type,
	    uid: file.uid,
	    percent: 0,
	    originFileObj: file
	  });
	}
	/**
	 * 生成Progress percent: 0.1 -> 0.98
	 *   - for ie
	 */
	
	
	function genPercentAdd() {
	  var k = 0.1;
	  var i = 0.01;
	  var end = 0.98;
	  return function (s) {
	    var start = s;
	
	    if (start >= end) {
	      return start;
	    }
	
	    start += k;
	    k -= i;
	
	    if (k < 0.001) {
	      k = 0.001;
	    }
	
	    return start;
	  };
	}
	
	function getFileItem(file, fileList) {
	  var matchKey = file.uid !== undefined ? 'uid' : 'name';
	  return fileList.filter(function (item) {
	    return item[matchKey] === file[matchKey];
	  })[0];
	}
	
	function removeFileItem(file, fileList) {
	  var matchKey = file.uid !== undefined ? 'uid' : 'name';
	  var removed = fileList.filter(function (item) {
	    return item[matchKey] !== file[matchKey];
	  });
	
	  if (removed.length === fileList.length) {
	    return null;
	  }
	
	  return removed;
	} // ==================== Default Image Preview ====================
	
	
	var extname = function extname() {
	  var url = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var temp = url.split('/');
	  var filename = temp[temp.length - 1];
	  var filenameWithoutSuffix = filename.split(/#|\?/)[0];
	  return (/\.[^./\\]*$/.exec(filenameWithoutSuffix) || [''])[0];
	};
	
	var isImageFileType = function isImageFileType(type) {
	  return !!type && type.indexOf('image/') === 0;
	};
	
	var isImageUrl = function isImageUrl(file) {
	  if (isImageFileType(file.type)) {
	    return true;
	  }
	
	  var url = file.thumbUrl || file.url;
	  var extension = extname(url);
	
	  if (/^data:image\//.test(url) || /(webp|svg|png|gif|jpg|jpeg|jfif|bmp|dpg|ico)$/i.test(extension)) {
	    return true;
	  }
	
	  if (/^data:/.test(url)) {
	    // other file types of base64
	    return false;
	  }
	
	  if (extension) {
	    // other file types which have extension
	    return false;
	  }
	
	  return true;
	};
	
	exports.isImageUrl = isImageUrl;
	var MEASURE_SIZE = 200;
	
	function previewImage(file) {
	  return new Promise(function (resolve) {
	    if (!isImageFileType(file.type)) {
	      resolve('');
	      return;
	    }
	
	    var canvas = document.createElement('canvas');
	    canvas.width = MEASURE_SIZE;
	    canvas.height = MEASURE_SIZE;
	    canvas.style.cssText = "position: fixed; left: 0; top: 0; width: ".concat(MEASURE_SIZE, "px; height: ").concat(MEASURE_SIZE, "px; z-index: 9999; display: none;");
	    document.body.appendChild(canvas);
	    var ctx = canvas.getContext('2d');
	    var img = new Image();
	
	    img.onload = function () {
	      var width = img.width,
	          height = img.height;
	      var drawWidth = MEASURE_SIZE;
	      var drawHeight = MEASURE_SIZE;
	      var offsetX = 0;
	      var offsetY = 0;
	
	      if (width < height) {
	        drawHeight = height * (MEASURE_SIZE / width);
	        offsetY = -(drawHeight - drawWidth) / 2;
	      } else {
	        drawWidth = width * (MEASURE_SIZE / height);
	        offsetX = -(drawWidth - drawHeight) / 2;
	      }
	
	      ctx.drawImage(img, offsetX, offsetY, drawWidth, drawHeight);
	      var dataURL = canvas.toDataURL();
	      document.body.removeChild(canvas);
	      resolve(dataURL);
	    };
	
	    img.src = window.URL.createObjectURL(file);
	  });
	}

/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Icon = __webpack_require__(1358);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Icon)['default'];
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var PropTypes = __importStar(__webpack_require__(6));
	
	var mini_store_1 = __webpack_require__(143);
	
	var classnames_1 = __importDefault(__webpack_require__(9));
	
	var ColGroup_1 = __importDefault(__webpack_require__(1364));
	
	var TableHeader_1 = __importDefault(__webpack_require__(1372));
	
	var TableRow_1 = __importDefault(__webpack_require__(655));
	
	var ExpandableRow_1 = __importDefault(__webpack_require__(1367));
	
	var BaseTable = /*#__PURE__*/function (_React$Component) {
	  _inherits(BaseTable, _React$Component);
	
	  var _super = _createSuper(BaseTable);
	
	  function BaseTable() {
	    var _this;
	
	    _classCallCheck(this, BaseTable);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleRowHover = function (isHover, key) {
	      _this.props.store.setState({
	        currentHoverKey: isHover ? key : null
	      });
	    };
	
	    _this.renderRows = function (renderData, indent) {
	      var ancestorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	      var table = _this.context.table;
	      var columnManager = table.columnManager,
	          components = table.components;
	      var _table$props = table.props,
	          prefixCls = _table$props.prefixCls,
	          childrenColumnName = _table$props.childrenColumnName,
	          rowClassName = _table$props.rowClassName,
	          rowRef = _table$props.rowRef,
	          onRowClick = _table$props.onRowClick,
	          onRowDoubleClick = _table$props.onRowDoubleClick,
	          onRowContextMenu = _table$props.onRowContextMenu,
	          onRowMouseEnter = _table$props.onRowMouseEnter,
	          onRowMouseLeave = _table$props.onRowMouseLeave,
	          onRow = _table$props.onRow;
	      var _this$props = _this.props,
	          getRowKey = _this$props.getRowKey,
	          fixed = _this$props.fixed,
	          expander = _this$props.expander,
	          isAnyColumnsFixed = _this$props.isAnyColumnsFixed;
	      var rows = [];
	
	      var _loop = function _loop(i) {
	        var record = renderData[i];
	        var key = getRowKey(record, i);
	        var className = typeof rowClassName === 'string' ? rowClassName : rowClassName(record, i, indent);
	        var onHoverProps = {};
	
	        if (columnManager.isAnyColumnsFixed()) {
	          onHoverProps.onHover = _this.handleRowHover;
	        }
	
	        var leafColumns = void 0;
	
	        if (fixed === 'left') {
	          leafColumns = columnManager.leftLeafColumns();
	        } else if (fixed === 'right') {
	          leafColumns = columnManager.rightLeafColumns();
	        } else {
	          leafColumns = _this.getColumns(columnManager.leafColumns());
	        }
	
	        var rowPrefixCls = "".concat(prefixCls, "-row");
	        var row = React.createElement(ExpandableRow_1.default, Object.assign({}, expander.props, {
	          fixed: fixed,
	          index: i,
	          prefixCls: rowPrefixCls,
	          record: record,
	          key: key,
	          rowKey: key,
	          onRowClick: onRowClick,
	          needIndentSpaced: expander.needIndentSpaced,
	          onExpandedChange: expander.handleExpandChange
	        }), function (expandableRow) {
	          return React.createElement(TableRow_1.default, Object.assign({
	            fixed: fixed,
	            indent: indent,
	            className: className,
	            record: record,
	            index: i,
	            prefixCls: rowPrefixCls,
	            childrenColumnName: childrenColumnName,
	            columns: leafColumns,
	            onRow: onRow,
	            onRowDoubleClick: onRowDoubleClick,
	            onRowContextMenu: onRowContextMenu,
	            onRowMouseEnter: onRowMouseEnter,
	            onRowMouseLeave: onRowMouseLeave
	          }, onHoverProps, {
	            rowKey: key,
	            ancestorKeys: ancestorKeys,
	            ref: rowRef(record, i, indent),
	            components: components,
	            isAnyColumnsFixed: isAnyColumnsFixed
	          }, expandableRow));
	        });
	        rows.push(row);
	        expander.renderRows(_this.renderRows, rows, record, i, indent, fixed, key, ancestorKeys);
	      };
	
	      for (var i = 0; i < renderData.length; i += 1) {
	        _loop(i);
	      }
	
	      return rows;
	    };
	
	    return _this;
	  }
	
	  _createClass(BaseTable, [{
	    key: "getColumns",
	    value: function getColumns(cols) {
	      var _this$props2 = this.props,
	          _this$props2$columns = _this$props2.columns,
	          columns = _this$props2$columns === void 0 ? [] : _this$props2$columns,
	          fixed = _this$props2.fixed;
	      var table = this.context.table;
	      var prefixCls = table.props.prefixCls;
	      return (cols || columns).map(function (column) {
	        return _objectSpread({}, column, {
	          className: !!column.fixed && !fixed ? classnames_1.default("".concat(prefixCls, "-fixed-columns-in-body"), column.className) : column.className
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var table = this.context.table;
	      var components = table.components;
	      var _table$props2 = table.props,
	          prefixCls = _table$props2.prefixCls,
	          scroll = _table$props2.scroll,
	          data = _table$props2.data,
	          getBodyWrapper = _table$props2.getBodyWrapper;
	      var _this$props3 = this.props,
	          expander = _this$props3.expander,
	          tableClassName = _this$props3.tableClassName,
	          hasHead = _this$props3.hasHead,
	          hasBody = _this$props3.hasBody,
	          fixed = _this$props3.fixed,
	          isAnyColumnsFixed = _this$props3.isAnyColumnsFixed;
	      var tableStyle = {};
	
	      if (!fixed && scroll.x) {
	        // 当有固定列时，width auto 会导致 body table 的宽度撑不开，从而固定列无法对齐
	        // 详情见：https://github.com/ant-design/ant-design/issues/22160
	        var tableWidthScrollX = isAnyColumnsFixed ? 'max-content' : 'auto'; // not set width, then use content fixed width
	
	        tableStyle.width = scroll.x === true ? tableWidthScrollX : scroll.x;
	      }
	
	      var Table = hasBody ? components.table : 'table';
	      var BodyWrapper = components.body.wrapper;
	      var body;
	
	      if (hasBody) {
	        body = React.createElement(BodyWrapper, {
	          className: "".concat(prefixCls, "-tbody")
	        }, this.renderRows(data, 0));
	
	        if (getBodyWrapper) {
	          body = getBodyWrapper(body);
	        }
	      }
	
	      var columns = this.getColumns();
	      return React.createElement(Table, {
	        className: tableClassName,
	        style: tableStyle,
	        key: "table"
	      }, React.createElement(ColGroup_1.default, {
	        columns: columns,
	        fixed: fixed
	      }), hasHead && React.createElement(TableHeader_1.default, {
	        expander: expander,
	        columns: columns,
	        fixed: fixed
	      }), body);
	    }
	  }]);
	
	  return BaseTable;
	}(React.Component);
	
	BaseTable.contextTypes = {
	  table: PropTypes.any
	};
	exports.default = mini_store_1.connect()(BaseTable);

/***/ },
/* 653 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var Column = function Column() {
	  return null;
	};
	
	exports.default = Column;

/***/ },
/* 654 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var ColumnGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(ColumnGroup, _React$Component);
	
	  var _super = _createSuper(ColumnGroup);
	
	  function ColumnGroup() {
	    _classCallCheck(this, ColumnGroup);
	
	    return _super.apply(this, arguments);
	  }
	
	  return ColumnGroup;
	}(React.Component);
	
	exports.default = ColumnGroup;
	ColumnGroup.isTableColumnGroup = true;

/***/ },
/* 655 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var react_dom_1 = __importDefault(__webpack_require__(23));
	
	var warning_1 = __importDefault(__webpack_require__(303));
	
	var mini_store_1 = __webpack_require__(143);
	
	var react_lifecycles_compat_1 = __webpack_require__(15);
	
	var classnames_1 = __importDefault(__webpack_require__(9));
	
	var TableCell_1 = __importDefault(__webpack_require__(1371));
	
	var TableRow = /*#__PURE__*/function (_React$Component) {
	  _inherits(TableRow, _React$Component);
	
	  var _super = _createSuper(TableRow);
	
	  function TableRow() {
	    var _this;
	
	    _classCallCheck(this, TableRow);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {};
	
	    _this.onTriggerEvent = function (rowPropFunc, legacyFunc, additionalFunc) {
	      var _this$props = _this.props,
	          record = _this$props.record,
	          index = _this$props.index;
	      return function () {
	        // Additional function like trigger `this.onHover` to handle self logic
	        if (additionalFunc) {
	          additionalFunc();
	        } // [Legacy] Some legacy function like `onRowClick`.
	
	
	        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        var event = args[0];
	
	        if (legacyFunc) {
	          legacyFunc(record, index, event);
	        } // Pass to the function from `onRow`
	
	
	        if (rowPropFunc) {
	          rowPropFunc.apply(void 0, args);
	        }
	      };
	    };
	
	    _this.onMouseEnter = function () {
	      var _this$props2 = _this.props,
	          onHover = _this$props2.onHover,
	          rowKey = _this$props2.rowKey;
	      onHover(true, rowKey);
	    };
	
	    _this.onMouseLeave = function () {
	      var _this$props3 = _this.props,
	          onHover = _this$props3.onHover,
	          rowKey = _this$props3.rowKey;
	      onHover(false, rowKey);
	    };
	
	    return _this;
	  }
	
	  _createClass(TableRow, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.state.shouldRender) {
	        this.saveRowRef();
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return !!(this.props.visible || nextProps.visible);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.state.shouldRender && !this.rowRef) {
	        this.saveRowRef();
	      }
	    }
	  }, {
	    key: "setExpandedRowHeight",
	    value: function setExpandedRowHeight() {
	      var _this$props4 = this.props,
	          store = _this$props4.store,
	          rowKey = _this$props4.rowKey;
	
	      var _store$getState = store.getState(),
	          expandedRowsHeight = _store$getState.expandedRowsHeight;
	
	      var _this$rowRef$getBound = this.rowRef.getBoundingClientRect(),
	          height = _this$rowRef$getBound.height;
	
	      expandedRowsHeight = _objectSpread({}, expandedRowsHeight, _defineProperty({}, rowKey, height));
	      store.setState({
	        expandedRowsHeight: expandedRowsHeight
	      });
	    }
	  }, {
	    key: "setRowHeight",
	    value: function setRowHeight() {
	      var _this$props5 = this.props,
	          store = _this$props5.store,
	          rowKey = _this$props5.rowKey;
	
	      var _store$getState2 = store.getState(),
	          fixedColumnsBodyRowsHeight = _store$getState2.fixedColumnsBodyRowsHeight;
	
	      var _this$rowRef$getBound2 = this.rowRef.getBoundingClientRect(),
	          height = _this$rowRef$getBound2.height;
	
	      store.setState({
	        fixedColumnsBodyRowsHeight: _objectSpread({}, fixedColumnsBodyRowsHeight, _defineProperty({}, rowKey, height))
	      });
	    }
	  }, {
	    key: "getStyle",
	    value: function getStyle() {
	      var _this$props6 = this.props,
	          height = _this$props6.height,
	          visible = _this$props6.visible;
	
	      if (height && height !== this.style.height) {
	        this.style = _objectSpread({}, this.style, {
	          height: height
	        });
	      }
	
	      if (!visible && !this.style.display) {
	        this.style = _objectSpread({}, this.style, {
	          display: 'none'
	        });
	      }
	
	      return this.style;
	    }
	  }, {
	    key: "saveRowRef",
	    value: function saveRowRef() {
	      this.rowRef = react_dom_1.default.findDOMNode(this);
	      var _this$props7 = this.props,
	          isAnyColumnsFixed = _this$props7.isAnyColumnsFixed,
	          fixed = _this$props7.fixed,
	          expandedRow = _this$props7.expandedRow,
	          ancestorKeys = _this$props7.ancestorKeys;
	
	      if (!isAnyColumnsFixed || !this.rowRef) {
	        return;
	      }
	
	      if (!fixed && expandedRow) {
	        this.setExpandedRowHeight();
	      }
	
	      if (!fixed && ancestorKeys.length >= 0) {
	        this.setRowHeight();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!this.state.shouldRender) {
	        return null;
	      }
	
	      var _this$props8 = this.props,
	          prefixCls = _this$props8.prefixCls,
	          columns = _this$props8.columns,
	          record = _this$props8.record,
	          rowKey = _this$props8.rowKey,
	          index = _this$props8.index,
	          onRow = _this$props8.onRow,
	          indent = _this$props8.indent,
	          indentSize = _this$props8.indentSize,
	          hovered = _this$props8.hovered,
	          height = _this$props8.height,
	          visible = _this$props8.visible,
	          components = _this$props8.components,
	          hasExpandIcon = _this$props8.hasExpandIcon,
	          renderExpandIcon = _this$props8.renderExpandIcon,
	          renderExpandIconCell = _this$props8.renderExpandIconCell,
	          onRowClick = _this$props8.onRowClick,
	          onRowDoubleClick = _this$props8.onRowDoubleClick,
	          onRowMouseEnter = _this$props8.onRowMouseEnter,
	          onRowMouseLeave = _this$props8.onRowMouseLeave,
	          onRowContextMenu = _this$props8.onRowContextMenu;
	      var BodyRow = components.body.row;
	      var BodyCell = components.body.cell;
	      var className = this.props.className;
	
	      if (hovered) {
	        className += " ".concat(prefixCls, "-hover");
	      }
	
	      var cells = [];
	      renderExpandIconCell(cells);
	
	      for (var i = 0; i < columns.length; i += 1) {
	        var column = columns[i];
	        warning_1.default(column.onCellClick === undefined, 'column[onCellClick] is deprecated, please use column[onCell] instead.');
	        cells.push(React.createElement(TableCell_1.default, {
	          prefixCls: prefixCls,
	          record: record,
	          indentSize: indentSize,
	          indent: indent,
	          index: index,
	          column: column,
	          key: column.key || column.dataIndex,
	          expandIcon: hasExpandIcon(i) && renderExpandIcon(),
	          component: BodyCell
	        }));
	      }
	
	      var _ref = onRow(record, index) || {},
	          customClassName = _ref.className,
	          customStyle = _ref.style,
	          rowProps = _objectWithoutProperties(_ref, ["className", "style"]);
	
	      var style = {
	        height: height
	      };
	
	      if (!visible) {
	        style.display = 'none';
	      }
	
	      style = _objectSpread({}, style, {}, customStyle);
	      var rowClassName = classnames_1.default(prefixCls, className, "".concat(prefixCls, "-level-").concat(indent), customClassName);
	      return React.createElement(BodyRow, Object.assign({}, rowProps, {
	        onClick: this.onTriggerEvent(rowProps.onClick, onRowClick),
	        onDoubleClick: this.onTriggerEvent(rowProps.onDoubleClick, onRowDoubleClick),
	        onMouseEnter: this.onTriggerEvent(rowProps.onMouseEnter, onRowMouseEnter, this.onMouseEnter),
	        onMouseLeave: this.onTriggerEvent(rowProps.onMouseLeave, onRowMouseLeave, this.onMouseLeave),
	        onContextMenu: this.onTriggerEvent(rowProps.onContextMenu, onRowContextMenu),
	        className: rowClassName,
	        style: style,
	        "data-row-key": rowKey
	      }), cells);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (prevState.visible || !prevState.visible && nextProps.visible) {
	        return {
	          shouldRender: true,
	          visible: nextProps.visible
	        };
	      }
	
	      return {
	        visible: nextProps.visible
	      };
	    }
	  }]);
	
	  return TableRow;
	}(React.Component);
	
	TableRow.defaultProps = {
	  onRow: function onRow() {},
	  onHover: function onHover() {},
	  hasExpandIcon: function hasExpandIcon() {},
	  renderExpandIcon: function renderExpandIcon() {},
	  renderExpandIconCell: function renderExpandIconCell() {}
	};
	
	function getRowHeight(state, props) {
	  var expandedRowsHeight = state.expandedRowsHeight,
	      fixedColumnsBodyRowsHeight = state.fixedColumnsBodyRowsHeight;
	  var fixed = props.fixed,
	      rowKey = props.rowKey;
	
	  if (!fixed) {
	    return null;
	  }
	
	  if (expandedRowsHeight[rowKey]) {
	    return expandedRowsHeight[rowKey];
	  }
	
	  if (fixedColumnsBodyRowsHeight[rowKey]) {
	    return fixedColumnsBodyRowsHeight[rowKey];
	  }
	
	  return null;
	}
	
	react_lifecycles_compat_1.polyfill(TableRow);
	exports.default = mini_store_1.connect(function (state, props) {
	  var currentHoverKey = state.currentHoverKey,
	      _state$expandedRowKey = state.expandedRowKeys,
	      expandedRowKeys = _state$expandedRowKey === void 0 ? [] : _state$expandedRowKey;
	  var rowKey = props.rowKey,
	      ancestorKeys = props.ancestorKeys;
	  var visible = ancestorKeys.length === 0 || ancestorKeys.every(function (k) {
	    return expandedRowKeys.includes(k);
	  });
	  return {
	    visible: visible,
	    hovered: currentHoverKey === rowKey,
	    height: getRowHeight(state, props)
	  };
	})(TableRow);

/***/ },
/* 656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _util = __webpack_require__(74);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating required fields.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function required(rule, value, source, errors, options, type) {
	  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
	    errors.push(util.format(options.messages.required, rule.fullField));
	  }
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.querySaveGlobalConfig = exports.queryDeleteGlobalConfig = exports.queryGlobalConfigInfo = exports.queryGlobalConfigConfig = exports.queryGlobalConfigList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var queryGlobalConfigList = exports.queryGlobalConfigList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.core.GET_GLOBAL_CONFIG_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryGlobalConfigList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var queryGlobalConfigConfig = exports.queryGlobalConfigConfig = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.get(_req.core.GET_GLOBAL_CONFIG_CONFIG, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function queryGlobalConfigConfig(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var queryGlobalConfigInfo = exports.queryGlobalConfigInfo = function () {
	  var _ref3 = _asyncToGenerator(_regenerator2.default.mark(function _callee3(params) {
	    return _regenerator2.default.wrap(function _callee3$(_context3) {
	      while (1) {
	        switch (_context3.prev = _context3.next) {
	          case 0:
	            return _context3.abrupt('return', _http2.default.get(_req.core.GET_GLOBAL_CONFIG_INFO, params));
	
	          case 1:
	          case 'end':
	            return _context3.stop();
	        }
	      }
	    }, _callee3, this);
	  }));
	
	  return function queryGlobalConfigInfo(_x3) {
	    return _ref3.apply(this, arguments);
	  };
	}();
	
	var queryDeleteGlobalConfig = exports.queryDeleteGlobalConfig = function () {
	  var _ref4 = _asyncToGenerator(_regenerator2.default.mark(function _callee4(params) {
	    return _regenerator2.default.wrap(function _callee4$(_context4) {
	      while (1) {
	        switch (_context4.prev = _context4.next) {
	          case 0:
	            return _context4.abrupt('return', _http2.default.get(_req.core.DELETE_GLOBAL_CONFIG, params));
	
	          case 1:
	          case 'end':
	            return _context4.stop();
	        }
	      }
	    }, _callee4, this);
	  }));
	
	  return function queryDeleteGlobalConfig(_x4) {
	    return _ref4.apply(this, arguments);
	  };
	}();
	
	var querySaveGlobalConfig = exports.querySaveGlobalConfig = function () {
	  var _ref5 = _asyncToGenerator(_regenerator2.default.mark(function _callee5(params) {
	    return _regenerator2.default.wrap(function _callee5$(_context5) {
	      while (1) {
	        switch (_context5.prev = _context5.next) {
	          case 0:
	            return _context5.abrupt('return', _http2.default.post(_req.core.SAVE_GLOBAL_CONFIG, params));
	
	          case 1:
	          case 'end':
	            return _context5.stop();
	        }
	      }
	    }, _callee5, this);
	  }));
	
	  return function querySaveGlobalConfig(_x5) {
	    return _ref5.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _announcement = __webpack_require__(322);
	
	var _BackBtn = __webpack_require__(12);
	
	var _FormBase = __webpack_require__(1405);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageAdd = function (_Component) {
	  _inherits(PageAdd, _Component);
	
	  function PageAdd(props) {
	    _classCallCheck(this, PageAdd);
	
	    var _this = _possibleConstructorReturn(this, (PageAdd.__proto__ || Object.getPrototypeOf(PageAdd)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      item.uuid = _this.props.params.uuid;
	      (0, _announcement.querySaveAnnouncement)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageAdd, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	
	    /**
	     * 提交报销
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, {
	          data: this.state.dataInfo,
	          goBack: _BackBtn.goBack,
	          handSubmit: this.handSubmit,
	          dataInfo: dataInfo
	        })
	      );
	    }
	  }]);
	
	  return PageAdd;
	}(_react.Component);
	
	exports.default = PageAdd;

/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _user = __webpack_require__(54);
	
	var _TagsInput = __webpack_require__(426);
	
	var _TagsInput2 = _interopRequireDefault(_TagsInput);
	
	var _orgStructure = __webpack_require__(683);
	
	var _orgStructure2 = _interopRequireDefault(_orgStructure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.getAccountList = function () {
	      (0, _user.queryAccountList)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            userList: res.data
	          });
	        }
	      });
	    };
	
	    _this.submit = function () {
	      var data = _this.props.data;
	      var _this$state = _this.state,
	          viewTypes = _this$state.viewTypes,
	          views = _this$state.views,
	          types = _this$state.types;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = {};
	          data && data.uuid && (params.uuid = data.uuid);
	          params.name = values.name;
	          params.types = types;
	          params.viewTypes = viewTypes;
	          params.views = views;
	          params.remark = values.remark;
	          params.managerUuid = values.managerUuid;
	          params.manager = values.manager;
	
	          params.viewUsers = _this.dealView(values.viewUsers);
	          _this.props.onOk(params);
	          _this.props.form.resetFields();
	          // this.setState({
	          //   viewTypes: [],
	          //   types: this.props.data.types ? this.props.data.types : []
	          // });
	        }
	      });
	    };
	
	    _this.onCancel = function () {
	      _this.props.form.resetFields();
	      _this.props.onCancel();
	      _this.setState({
	        viewTypes: [],
	        types: _this.props.data.types ? _this.props.data.types : []
	      });
	    };
	
	    _this.checkedChange = function (list) {
	      _this.setState({
	        viewTypes: list
	      });
	    };
	
	    _this.handleSetTags = function (types) {
	      _this.setState({ types: types });
	    };
	
	    _this.handleManageChange = function (value, option) {
	      _this.props.form.setFieldsValue({ manager: option.props.children });
	    };
	
	    _this.setViews = function (views) {
	      _this.setState({ views: views });
	    };
	
	    _this.showDrawer = function () {
	      _this.setState({
	        DrawerVisible: true
	      });
	    };
	
	    _this.closeDrawer = function () {
	      _this.setState({
	        DrawerVisible: false
	      });
	    };
	
	    _this.dealView = function (users) {
	      var params = [];
	      var usersAll = _this.state.userList;
	      for (var i = 0; i < usersAll.length; i++) {
	        for (var j = 0; j < users.length; j++) {
	          if (usersAll[i].uuid === users[j]) {
	            params.push(usersAll[i]);
	          }
	        }
	      }
	      return params;
	    };
	
	    _this.state = {
	      viewTypes: [],
	      userList: [],
	      checkedList: [{ label: '全部', value: 0 }, { label: '本公司人员', value: 1 }, { label: '其他', value: 2 }],
	      views: [],
	      types: [],
	      DrawerVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props$data = this.props.data,
	          views = _props$data.views,
	          types = _props$data.types,
	          viewTypes = _props$data.viewTypes;
	
	      this.getAccountList();
	      types && types.map(function (item) {
	        item.uid = item.uuid;
	        return item;
	      });
	      this.setState({
	        views: views || [],
	        types: types || [],
	        viewTypes: viewTypes || []
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _nextProps$data = nextProps.data,
	          views = _nextProps$data.views,
	          types = _nextProps$data.types,
	          viewTypes = _nextProps$data.viewTypes;
	
	      if (nextProps.data !== this.props.data) {
	        types && types.map(function (item) {
	          item.uid = item.uuid;
	          return item;
	        });
	        this.setState({
	          views: views || [],
	          types: types || [],
	          viewTypes: viewTypes || []
	        });
	      }
	    }
	
	    // 提交
	
	
	    // 关闭
	
	
	    // 查看权限改变
	
	
	    // 设置资料库类型
	
	
	    /* --------------- 其他权限详情---------------------------*/
	
	  }, {
	    key: 'render',
	
	
	    /* --------------- 其他权限详情结束------------------------*/
	
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          visible = _props.visible,
	          form = _props.form,
	          accountInfo = _props.accountInfo;
	      var getFieldDecorator = form.getFieldDecorator;
	      var _state = this.state,
	          userList = _state.userList,
	          checkedList = _state.checkedList,
	          viewTypes = _state.viewTypes,
	          DrawerVisible = _state.DrawerVisible,
	          views = _state.views,
	          types = _state.types;
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	      getFieldDecorator('manager', {
	        initialValue: data.uuid ? data.manager : accountInfo.userName
	      });
	
	      var viewUsersUuids = (data.viewUsers || []).filter(function (item) {
	        return item;
	      }).map(function (item) {
	        return item.uuid;
	      });
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: data.uuid ? '编辑资料库' : '创建资料库',
	          visible: visible,
	          onOk: this.submit,
	          onCancel: this.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u8D44\u6599\u5E93\u540D\u79F0' }, formItemLayout),
	            getFieldDecorator('name', {
	              rules: [{ required: true, message: '请输入资料库名字' }],
	              initialValue: data.name
	            })(_react2.default.createElement(_antd.Input, null))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u8D44\u6599\u7C7B\u578B' }, formItemLayout),
	            _react2.default.createElement(_TagsInput2.default, { tags: types, handleSetTags: this.handleSetTags })
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u9ED8\u8BA4\u67E5\u9605\u6743\u9650' }, formItemLayout, { style: { marginBottom: '0' } }),
	            getFieldDecorator('viewTypes', {
	              rules: [{ required: true, message: '请选择查阅类型' }],
	              initialValue: data.viewTypes
	            })(_react2.default.createElement(_antd.Checkbox.Group, { options: checkedList, onChange: this.checkedChange })),
	            viewTypes.some(function (item) {
	              return +item === 2;
	            }) ? _react2.default.createElement(
	              'a',
	              { onClick: this.showDrawer, style: { whiteSpace: 'nowrap' } },
	              '\u5176\u4ED6\u6743\u9650\u8BE6\u60C5'
	            ) : null
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u63CF\u8FF0' }, formItemLayout, { style: { marginTop: '24px' } }),
	            getFieldDecorator('remark', {
	              initialValue: data.remark
	            })(_react2.default.createElement(_antd.Input.TextArea, {
	              type: 'textarea',
	              autosize: { minRows: 3, maxRows: 9 },
	              placeholder: '\u8D44\u6599\u5E93\u4ECB\u7ECD',
	              maxLength: 1000
	            })),
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '12px', color: '#999' } },
	              '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	            )
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u8D44\u6599\u5E93\u7BA1\u7406\u5458' }, formItemLayout),
	            getFieldDecorator('managerUuid', {
	              rules: [{ required: true, message: '请选择资料库管理员' }],
	              initialValue: data.uuid ? data.managerUuid : this.props.accountInfo.userUuid
	            })(_react2.default.createElement(
	              _antd.Select,
	              {
	                onChange: this.handleManageChange,
	                showSearch: true,
	                filterOption: function filterOption(input, option) {
	                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                }
	              },
	              userList.map(function (item) {
	                return _react2.default.createElement(
	                  _antd.Select.Option,
	                  { key: item.uuid, value: item.uuid },
	                  item.name
	                );
	              })
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u53EF\u4EE5\u67E5\u770B\u4EBA\u5458' }, formItemLayout),
	            getFieldDecorator('viewUsers', {
	              initialValue: viewUsersUuids
	            })(_react2.default.createElement(
	              _antd.Select,
	              {
	                mode: 'multiple',
	                filterOption: function filterOption(input, option) {
	                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                }
	              },
	              userList.map(function (item) {
	                return _react2.default.createElement(
	                  _antd.Select.Option,
	                  { key: item.uuid, value: item.uuid },
	                  item.name
	                );
	              })
	            ))
	          )
	        ),
	        DrawerVisible ? _react2.default.createElement(_orgStructure2.default, {
	          onClose: this.closeDrawer,
	          visible: DrawerVisible,
	          views: views,
	          setViews: this.setViews
	        }) : null
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(IndexModal));

/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var SelectOrg = function (_Component) {
	  _inherits(SelectOrg, _Component);
	
	  function SelectOrg(props) {
	    _classCallCheck(this, SelectOrg);
	
	    var _this = _possibleConstructorReturn(this, (SelectOrg.__proto__ || Object.getPrototypeOf(SelectOrg)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(SelectOrg, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps() {}
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        _antd.Select,
	        {
	          onChange: this.props.onChange,
	          style: { width: "100%" },
	          placeholder: "\u8D44\u6599\u5E93\u9009\u62E9",
	          value: this.props.value
	        },
	        this.props.data.map(function (item) {
	          return _react2.default.createElement(
	            _antd.Select.Option,
	            { value: item.uuid, key: item.uuid },
	            item.name
	          );
	        })
	      );
	    }
	  }]);
	
	  return SelectOrg;
	}(_react.Component);
	
	exports.default = SelectOrg;

/***/ },
/* 661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableOrg = function (_Component) {
	  _inherits(TableOrg, _Component);
	
	  function TableOrg(props) {
	    _classCallCheck(this, TableOrg);
	
	    var _this = _possibleConstructorReturn(this, (TableOrg.__proto__ || Object.getPrototypeOf(TableOrg)).call(this, props));
	
	    _this.delDocument = function (uuid) {
	      _this.props.handleDel(uuid);
	    };
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '文件编号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/administrative/material/info/' + record.uuid },
	            _react2.default.createElement(
	              _antd.Popover,
	              { content: record.no },
	              _react2.default.createElement(
	                'p',
	                {
	                  style: {
	                    width: '170px',
	                    margin: '0',
	                    overflow: 'hidden',
	                    whiteSpace: 'nowrap',
	                    textOverflow: 'ellipsis'
	                  }
	                },
	                record.no
	              )
	            )
	          );
	        }
	      }, {
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text) {
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: text },
	            _react2.default.createElement(
	              'p',
	              {
	                style: {
	                  width: '180px',
	                  margin: '0',
	                  overflow: 'hidden',
	                  whiteSpace: 'nowrap',
	                  textOverflow: 'ellipsis'
	                }
	              },
	              text
	            )
	          );
	        }
	      }, {
	        title: '文件类型',
	        dataIndex: 'type',
	        key: 'type'
	      }, {
	        title: '文件有效期',
	        dataIndex: 'beginDate',
	        key: 'beginDate',
	        render: function render(text, record) {
	          var endDate = '';
	          var beginDate = '';
	          endDate = record.endDate ? (0, _moment2.default)(record.endDate).format('YYYY-MM-DD') : '永久';
	          beginDate = record.beginDate ? (0, _moment2.default)(record.beginDate).format('YYYY-MM-DD') : '';
	          return _react2.default.createElement(
	            'span',
	            null,
	            beginDate,
	            '\u81F3',
	            endDate
	          );
	        }
	      }, {
	        title: '管理员',
	        dataIndex: 'manager',
	        key: 'manager'
	      }, {
	        title: '总量/库存',
	        dataIndex: 'amount',
	        key: 'amount',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.amount,
	            '/',
	            record.number || 0
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        key: 'status',
	        render: function render(text) {
	          switch (text) {
	            case 1:
	              return '有效';
	            case 2:
	              return '失效';
	            default:
	          }
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        key: 'done',
	        render: function render(text, record) {
	          var _this$props = _this.props,
	              databaseUuid = _this$props.databaseUuid,
	              databaseName = _this$props.databaseName,
	              directoryUuid = _this$props.directoryUuid;
	
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: '/administrative/material/add/' + record.uuid,
	                  query: {
	                    databaseUuid: databaseUuid,
	                    directoryUuid: directoryUuid,
	                    databaseName: databaseName
	                  }
	                }
	              },
	              '\u7F16\u8F91'
	            ),
	            _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	            _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                title: '\u786E\u5B9A\u8981\u5220\u9664\u8BE5\u6587\u4EF6\u5417?(\u5220\u9664\u540E\u65E0\u6CD5\u518D\u627E\u56DE)',
	                onConfirm: function onConfirm() {
	                  return _this.delDocument(record.uuid);
	                },
	                okText: '\u662F',
	                cancelText: '\u5426'
	              },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                null,
	                '\u5220\u9664'
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(TableOrg, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          documentList = _props.documentList,
	          pagination = _props.pagination,
	          isLoading = _props.isLoading;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Table, {
	          tableLayout: 'inline',
	          loading: isLoading,
	          onChange: this.handleChange,
	          columns: this.columns(),
	          dataSource: documentList,
	          pagination: pagination,
	          rowKey: 'uuid'
	        })
	      );
	    }
	  }]);
	
	  return TableOrg;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(TableOrg);

/***/ },
/* 662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	var _ModalDirAdd = __webpack_require__(1412);
	
	var _ModalDirAdd2 = _interopRequireDefault(_ModalDirAdd);
	
	__webpack_require__(2948);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.Tree.TreeNode;
	var confirm = _antd.Modal.confirm;
	
	var TreeOrg = function (_Component) {
	  _inherits(TreeOrg, _Component);
	
	  function TreeOrg(props) {
	    _classCallCheck(this, TreeOrg);
	
	    var _this2 = _possibleConstructorReturn(this, (TreeOrg.__proto__ || Object.getPrototypeOf(TreeOrg)).call(this, props));
	
	    _this2.getDirectoryInfo = function (uuid) {
	      (0, _material.queryMaterialDirectoryInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.directoryInfo = res.data;
	          _this2.setState({
	            directoryInfo: res.data || []
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.setAllExpandKeys = function (list) {
	      var expandedKeys = [];
	      list.map(function (item) {
	        if (item.children.length > 0) {
	          expandedKeys.push(item.uuid);
	          expandedKeys = expandedKeys.concat(_this2.setAllExpandKeys(item.children));
	        }
	        return item;
	      });
	      return expandedKeys;
	    };
	
	    _this2.onExpand = function (expandedKeys) {
	      _this2.setState({
	        expandedKeys: expandedKeys
	      });
	    };
	
	    _this2.onSelect = function (selectedKeys, e) {
	      _this2.setState({
	        selectedKeys: selectedKeys
	      });
	      _this2.props.onSelect({
	        uuid: e.selected ? e.node.props.dataRef.uuid : '',
	        name: e.selected ? e.node.props.dataRef.name : ''
	      });
	    };
	
	    _this2.onDrop = function (info) {
	      var _this2$props = _this2.props,
	          database = _this2$props.database,
	          databaseUuid = _this2$props.databaseUuid;
	
	      var dropPos = info.node.props.pos.split('-');
	      var dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
	      (0, _material.queryMaterialDirectoryInfo)({ uuid: info.node.props.dataRef.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          var directoryInfo = res.data;
	          var params = {};
	          params.uuid = info.dragNode.props.dataRef.uuid;
	          params.name = info.dragNode.props.dataRef.name;
	          params.database = database;
	          params.databaseUuid = databaseUuid;
	          if (dropPosition === -1) {
	            params.parentUuid = directoryInfo.parentUuid;
	          } else {
	            params.parentUuid = directoryInfo.uuid;
	          }
	          _this2.directoryAddSubmit(params);
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.hideModalDirAdd = function (flag) {
	      _this2.setState({
	        dirAddVisible: !!flag
	      });
	    };
	
	    _this2.addTopDirectory = function (e) {
	      e.stopPropagation();
	      _this2.setState({ isAddType: true }, function () {
	        _this2.hideModalDirAdd(true);
	      });
	    };
	
	    _this2.addDirectory = function (item, e) {
	      e.stopPropagation();
	      _this2.getDirectoryInfo(item.uuid);
	      _this2.setState({ isAddType: true }, function () {
	        _this2.hideModalDirAdd(true);
	      });
	    };
	
	    _this2.editDirectory = function (item, e) {
	      e.stopPropagation();
	      _this2.getDirectoryInfo(item.uuid);
	      _this2.setState({ isAddType: false }, function () {
	        _this2.hideModalDirAdd(true);
	      });
	    };
	
	    _this2.directoryAddSubmit = function (params) {
	      (0, _material.querySaveMaterialDirectory)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this2.props.getDirectoryList();
	          _this2.hideModalDirAdd();
	          _this2.setState({ directoryInfo: null });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.showDelDirectory = function (item, e) {
	      e.stopPropagation();
	      var _this = _this2;
	      confirm({
	        title: '确定删除该资料目录?',
	        onOk: function onOk() {
	          _this.directoryDeleteSubmit(item);
	        }
	      });
	    };
	
	    _this2.directoryDeleteSubmit = function (item) {
	      var _this2$props2 = _this2.props,
	          databaseUuid = _this2$props2.databaseUuid,
	          database = _this2$props2.database;
	
	      var params = {};
	      item && (params.uuid = item.uuid);
	      params.databaseUuid = databaseUuid;
	      params.database = database;
	      item && (0, _material.queryDeleteMaterialDirectory)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this2.props.getDirectoryList();
	          _this2.setState({ directoryInfo: null });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.titleItem = function (item) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'treeTitle' },
	        item.name,
	        _react2.default.createElement(
	          'span',
	          { className: 'treeButton' },
	          _react2.default.createElement(_antd.Icon, {
	            type: 'edit',
	            onClick: function onClick(e) {
	              return _this2.editDirectory(item, e);
	            },
	            style: { paddingRight: '5px' }
	          }),
	          _react2.default.createElement(_antd.Icon, {
	            type: 'plus-circle',
	            onClick: function onClick(e) {
	              return _this2.addDirectory(item, e);
	            },
	            style: { paddingRight: '5px' }
	          }),
	          _react2.default.createElement(_antd.Icon, { type: 'minus-circle', onClick: function onClick(e) {
	              return _this2.showDelDirectory(item, e);
	            } })
	        )
	      );
	    };
	
	    _this2.renderTreeNodes = function (data) {
	      return data.map(function (item) {
	        if (item.children) {
	          return _react2.default.createElement(
	            TreeNode,
	            { title: _this2.titleItem(item), key: item.uuid, dataRef: item },
	            _this2.renderTreeNodes(item.children)
	          );
	        }
	        return _react2.default.createElement(TreeNode, Object.assign({ title: _this2.titleItem(item), key: item.uuid }, item));
	      });
	    };
	
	    _this2.state = {
	      list: [],
	      selectedKeys: [],
	      expandedKeys: [],
	      isAddType: true,
	      directoryInfo: null
	    };
	    return _this2;
	  }
	
	  _createClass(TreeOrg, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var list = this.props.data;
	      var directoryUuid = this.props.directoryUuid;
	
	      this.setState({ list: list, selectedKeys: [directoryUuid] });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var list = nextProps.data;
	      var directoryUuid = nextProps.directoryUuid;
	
	      if (list !== this.props.data) {
	        this.setState({
	          list: list,
	          expandedKeys: this.setAllExpandKeys(list),
	          directoryInfo: null
	        });
	      }
	
	      if (directoryUuid !== this.props.directoryUuid) {
	        this.setState({
	          selectedKeys: [directoryUuid]
	        });
	      }
	    }
	
	    // 资料目录详情
	
	
	    // 遍历展开所有节点（nice demand）
	
	
	    /** ------------------新增/编辑/删除资料目录-------------------------------------------*/
	    // 弹窗开关
	
	
	    // 新增的弹窗
	
	
	    // 编辑的弹窗
	
	
	    // 新增/编辑提交
	
	
	    // 删除
	
	    /**-----------------------------------------------------------------------------*/
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          list = _state.list,
	          isAddType = _state.isAddType,
	          dirAddVisible = _state.dirAddVisible,
	          directoryInfo = _state.directoryInfo,
	          selectedKeys = _state.selectedKeys,
	          expandedKeys = _state.expandedKeys;
	      var _props = this.props,
	          database = _props.database,
	          databaseUuid = _props.databaseUuid;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        {
	          style: { padding: '10px', height: '100%' },
	          bodyStyle: { padding: '0', height: '100%' }
	        },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'end' },
	          _react2.default.createElement(_antd.Icon, { type: 'plus-circle', onClick: this.addTopDirectory, style: { paddingRight: '5px' } })
	        ),
	        _react2.default.createElement(
	          _antd.Tree,
	          {
	            showLine: true,
	            draggable: true,
	            onDrop: this.onDrop,
	            onSelect: this.onSelect,
	            selectedKeys: selectedKeys,
	            onExpand: this.onExpand,
	            expandedKeys: expandedKeys
	          },
	          this.renderTreeNodes(list || [])
	        ),
	        _react2.default.createElement(_ModalDirAdd2.default, {
	          visible: dirAddVisible,
	          onOk: this.directoryAddSubmit,
	          onCancel: function onCancel() {
	            return _this3.hideModalDirAdd(false);
	          },
	          database: database,
	          data: directoryInfo || {},
	          isAddType: isAddType,
	          databaseUuid: databaseUuid
	        })
	      );
	    }
	  }]);
	
	  return TreeOrg;
	}(_react.Component);
	
	exports.default = TreeOrg;

/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _material = __webpack_require__(50);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BackBtn = __webpack_require__(12);
	
	var _ModalFileList = __webpack_require__(1414);
	
	var _ModalFileList2 = _interopRequireDefault(_ModalFileList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.handleFileVisible = function (flag) {
	      _this.setState({
	        fileVisible: !!flag
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.getMaterialDocumentListBR();
	    };
	
	    _this.handleSearch = function (condition) {
	      _this.condition = { condition: condition };
	      _this.pagination = {
	        limit: 10,
	        start: 1
	      };
	      _this.current = 1;
	      _this.getMaterialDocumentListBR();
	    };
	
	    _this.onSelectChange = function (selectedRowKeys, selectedRows) {
	      _this.setState({
	        selectedRowKeys: selectedRowKeys,
	        documentInfo: selectedRows[0]
	      });
	    };
	
	    _this.getMaterialDocumentListBR = function () {
	      var params = Object.assign({}, _this.pagination, _this.condition);
	      _this.setState({
	        isLoading: true
	      });
	      (0, _material.queryMaterialDocumentListBR)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            documentListBR: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 10,
	                current: _this.current
	              }
	            },
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.documentChange = function (e) {
	      var documentListBR = _this.state.documentListBR;
	
	      var documentInfo = documentListBR.filter(function (item) {
	        return item.uuid === e;
	      });
	      _this.setState({
	        documentInfo: documentInfo[0]
	      });
	      return e;
	    };
	
	    _this.submit = function (e) {
	      var data = _this.props.data;
	      var selectedRowKeys = _this.state.selectedRowKeys;
	
	      if (e) {
	        e.preventDefault();
	      }
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          var params = _this.props.form.getFieldsValue();
	          data.uuid && (params.uuid = data.uuid);
	          params.expectReturnDate && (params.expectReturnDate = params.expectReturnDate.format('YYYY-MM-DD'));
	          params.documentUuid = selectedRowKeys[0];
	          _this.props.handSubmit(params);
	        }
	      });
	    };
	
	    _this.handleTypeChange = function (e) {
	      _this.setState({
	        type: e.target.value
	      });
	    };
	
	    _this.state = {
	      type: 0,
	      selectedRowKeys: [],
	      documentListBR: [],
	      documentInfo: {},
	      fileVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      data && data.document && data.document.name && (this.condition = { condition: data.document.name });
	      this.getMaterialDocumentListBR();
	      this.setState({
	        type: +data.type || 0,
	        selectedRowKeys: [data.document ? data.document.uuid : ''],
	        documentInfo: data.document
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var data = nextProps.data;
	
	      if (data && data.uuid !== this.props.data.uuid) {
	        data && data.document && data.document.name && (this.condition = { condition: data.document.name });
	
	        this.setState({
	          type: data.type,
	          selectedRowKeys: [data.document ? data.document.uuid : ''],
	          documentInfo: data.document
	        });
	      }
	    }
	
	    /* ------------------------------------------资料弹窗----------------------------------------------------*/
	    // 弹窗开关
	
	
	    // 分页跳转
	
	
	    // 选中
	
	
	    // 获取资料列表
	
	
	    // 设置资料详情
	
	
	    /* ------------------------------------------资料弹窗结束-------------------------------------------------*/
	
	    // 详情
	
	
	    // 借用资料类型
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          data = _props.data,
	          accountInfo = _props.accountInfo,
	          isSubmitting = _props.isSubmitting;
	      var _state = this.state,
	          type = _state.type,
	          isLoading = _state.isLoading,
	          documentListBR = _state.documentListBR,
	          documentInfo = _state.documentInfo,
	          fileVisible = _state.fileVisible,
	          selectedRowKeys = _state.selectedRowKeys;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var parentProps = {
	        isLoading: isLoading,
	        selectedRowKeys: selectedRowKeys,
	        dataSource: documentListBR,
	        onChange: this.handleTableChange,
	        handleSearch: this.handleSearch,
	        onSelectChange: this.onSelectChange
	      };
	      var formItemLayout2 = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 8 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: this.submit,
	              loading: isSubmitting
	            },
	            '\u53D1\u8D77\u7533\u8BF7'
	          ),
	          data.uuid ? _react2.default.createElement(
	            _antd.Button,
	            { icon: 'delete', style: { marginRight: 10 }, onClick: this.props.handleDelete },
	            '\u5220\u9664'
	          ) : null
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u501F\u7528\u8D44\u6599' }, formItemLayout2),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return _this2.handleFileVisible(true);
	                    } },
	                  '\u8D44\u6599\u5217\u8868'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u501F\u7528\u7C7B\u578B' }, formItemLayout2),
	                getFieldDecorator('type', {
	                  rules: [{ required: true, message: '请选择借用类型' }],
	                  initialValue: +data.type || 0
	                })(_react2.default.createElement(
	                  _antd.Radio.Group,
	                  { onChange: this.handleTypeChange },
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 0 },
	                    '\u7EB8\u8D28\u539F\u4EF6'
	                  ),
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 1 },
	                    '\u7535\u5B50\u7248'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              type === 0 ? _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7EA6\u5B9A\u5F52\u8FD8' }, formItemLayout2),
	                getFieldDecorator('expectReturnDate', {
	                  rules: [{ required: true, message: '请选择约定归还日期' }],
	                  initialValue: (0, _moment2.default)(data.expectReturnDate) || null
	                })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	              ) : _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8D44\u6599\u6C34\u5370' }, formItemLayout2),
	                getFieldDecorator('waterMark', {
	                  rules: [{ required: true, message: '请填写资料水印' }],
	                  initialValue: data.waterMark || null
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              type === 0 ? _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u501F\u7528\u6570\u91CF' }, formItemLayout2),
	                getFieldDecorator('number', {
	                  rules: [{ required: true, message: '请填写借用数量' }],
	                  initialValue: data.number || null
	                })(_react2.default.createElement(_antd.InputNumber, {
	                  min: 1,
	                  style: { width: '100%' },
	                  max: documentInfo ? documentInfo.number : 0
	                }))
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u7533\u8BF7\u8BF4\u660E', labelCol: { span: 2 }, wrapperCol: { span: 16 } },
	              getFieldDecorator('reason', {
	                rules: [{ required: true, message: '请填写申请说明' }],
	                initialValue: data.reason || null
	              })(_react2.default.createElement(_antd.Input.TextArea, {
	                placeholder: '\u7533\u8BF7\u8BF4\u660E',
	                type: 'textarea',
	                autosize: { minRows: 3, maxRows: 9 },
	                maxLength: 1000
	              })),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '12px', color: '#999' } },
	                '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7533\u8BF7\u4EBA\u5458' }, formItemLayout2),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  data.createUserName || accountInfo.userName
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7533\u8BF7\u65F6\u95F4' }, formItemLayout2),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  (0, _moment2.default)(data.createTime || Date.now()).format('YYYY-MM-DD')
	                )
	              )
	            )
	          )
	        ),
	        fileVisible ? _react2.default.createElement(_ModalFileList2.default, Object.assign({}, parentProps, {
	          visible: fileVisible,
	          condition: this.condition ? this.condition.condition : '',
	          handleCancel: function handleCancel() {
	            return _this2.handleFileVisible(false);
	          }
	        })) : null
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(BaseForm));

/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '资料文件名称',
	        dataIndex: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.document.name
	          );
	        }
	      }, {
	        title: '资料归属公司',
	        dataIndex: 'company',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.document.company
	          );
	        }
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5BA1\u6838\u4E2D'
	            );
	          }
	          if (record.status === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u7F16\u8F91'
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/administrative/material/borrow_manage/open/' + record.uuid },
	            '\u67E5\u770B\u6D41\u7A0B'
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Table, {
	          loading: this.props.loading,
	          onChange: this.handleChange,
	          columns: this.columns(),
	          pagination: pagination,
	          dataSource: list,
	          rowKey: 'uuid'
	        })
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	__webpack_require__(595);
	
	var _attachment = __webpack_require__(27);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _UploadFileTable = __webpack_require__(192);
	
	var _UploadFileTable2 = _interopRequireDefault(_UploadFileTable);
	
	var _BackBtn = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(8);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var TextArea = _antd.Input.TextArea;
	var Option = _antd.Select.Option;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handSubmit = _this$props.handSubmit,
	          data = _this$props.data;
	      var _this$state = _this.state,
	          chapters = _this$state.chapters,
	          renewalFiles = _this$state.renewalFiles;
	
	      var params = Object.assign({}, data, _this.props.form.getFieldsValue());
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          chapters.map(function (item) {
	            item.companyUuid = values['companyUuid' + item.id];
	            item.company = values['company' + item.id];
	            item.seal = values['seal' + item.id];
	            item.type = values['type' + item.id];
	
	            delete params['companyUuid' + item.id];
	            delete params['company' + item.id];
	            delete params['seal' + item.id];
	            delete params['type' + item.id];
	            return item;
	          });
	          renewalFiles.map(function (item) {
	            item.name = values['name' + item.id];
	            item.files = values['files' + item.id];
	            delete params['name' + item.id];
	            delete params['files' + item.id];
	            return item;
	          });
	          params.chapters = chapters;
	          params.renewalFiles = renewalFiles;
	          handSubmit(params);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              });
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.handleCompanyChange = function (id, value, option) {
	      _this.props.form.setFieldsValue(_defineProperty({}, 'company' + id, option ? option.props.children : ''));
	    };
	
	    _this.start = function (e) {
	      _this.submit(e, null, 'start');
	    };
	
	    _this.addChapters = function () {
	      var _this$state2 = _this.state,
	          chapters = _this$state2.chapters,
	          chaptersCount = _this$state2.chaptersCount;
	
	      chapters.push({ id: chaptersCount });
	      _this.setState({
	        chapters: chapters,
	        chaptersCount: chaptersCount + 1
	      });
	    };
	
	    _this.deleteChapters = function (id) {
	      var chapters = _this.state.chapters;
	
	      _this.setState({
	        chapters: chapters.filter(function (item) {
	          return item.id !== id;
	        })
	      });
	    };
	
	    _this.addEffects = function () {
	      var _this$state3 = _this.state,
	          renewalFiles = _this$state3.renewalFiles,
	          renewalFilesCount = _this$state3.renewalFilesCount;
	
	      renewalFiles.push({ id: renewalFilesCount });
	      _this.setState({
	        renewalFiles: renewalFiles,
	        renewalFilesCount: renewalFilesCount + 1
	      });
	    };
	
	    _this.deleteEffects = function (id) {
	      var renewalFiles = _this.state.renewalFiles;
	
	      _this.setState({
	        renewalFiles: renewalFiles.filter(function (item) {
	          return item.id !== id;
	        })
	      });
	    };
	
	    _this.chaptersColumns = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var chapters = _this.state.chapters;
	
	      var arr = [{
	        title: '*用章公司',
	        dataIndex: 'companyUuid',
	        key: 'companyUuid',
	        width: '35%',
	        render: function render(text, record) {
	          getFieldDecorator('company' + record.id, {
	            initialValue: record.company
	          });
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('companyUuid' + record.id, {
	              rules: [{ required: true, message: '请选择用章公司' }],
	              initialValue: record.companyUuid
	            })(_react2.default.createElement(_companySearch2.default, Object.assign({
	              companyName: record.company,
	              companyUuid: record.companyUuid,
	              onChange: function onChange(value, option) {
	                return _this.handleCompanyChange(record.id, value, option);
	              }
	            }, _this.props)))
	          );
	        }
	      }, {
	        title: '*用章类型',
	        dataIndex: 'type',
	        key: 'type',
	        width: '30%',
	        render: function render(text, record) {
	          var defaultType = void 0;
	          switch (text) {
	            case 0:
	              defaultType = '0';
	              break;
	            case 1:
	              defaultType = '1';
	              break;
	            case 2:
	              defaultType = '2';
	              break;
	            default:
	              break;
	          }
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('type' + record.id, {
	              rules: [{ required: true, message: '请选择用章类型' }],
	              initialValue: defaultType
	            })(_react2.default.createElement(
	              _antd.Select,
	              { placeholder: '\u8BF7\u9009\u62E9\u7528\u7AE0\u7C7B\u578B' },
	              _react2.default.createElement(
	                Option,
	                { key: '0' },
	                '\u516C\u7AE0'
	              ),
	              _react2.default.createElement(
	                Option,
	                { key: '1' },
	                '\u5408\u540C\u7AE0'
	              ),
	              _react2.default.createElement(
	                Option,
	                { key: '2' },
	                '\u6CD5\u4EBA\u7AE0'
	              )
	            ))
	          );
	        }
	      }, {
	        title: '是否外借',
	        dataIndex: 'seal',
	        key: 'seal',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('seal' + record.id, {
	              rules: [{ required: true, message: '请选择是否外借' }],
	              initialValue: record.seal ? '' + record.seal : '0'
	            })(_react2.default.createElement(
	              _antd.Select,
	              null,
	              _react2.default.createElement(
	                Option,
	                { key: '0' },
	                '\u5426'
	              ),
	              _react2.default.createElement(
	                Option,
	                { key: '1' },
	                '\u662F'
	              )
	            ))
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        key: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            { style: { margin: 0, height: '45px' } },
	            chapters && chapters.length > 1 ? _react2.default.createElement(
	              _reactRouter.Link,
	              { onClick: function onClick() {
	                  return _this.deleteChapters(record.id);
	                } },
	              '\u5220\u9664'
	            ) : null
	          );
	        }
	      }];
	
	      if (!chapters || chapters.length === 1) {
	        arr.pop();
	      }
	      return arr;
	    };
	
	    _this.renewalFilesColumns = function () {
	      var _this$props$form = _this.props.form,
	          getFieldDecorator = _this$props$form.getFieldDecorator,
	          getFieldValue = _this$props$form.getFieldValue;
	      var renewalFiles = _this.state.renewalFiles;
	
	
	      var arr = [{
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name',
	        width: '18%',
	        render: function render(text, record) {
	          var filesArr = getFieldValue('files' + record.id) || [];
	          var defaultName = filesArr[0] ? filesArr[0].name : '';
	          var index = defaultName.indexOf('.');
	          defaultName = defaultName.slice(0, index);
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('name' + record.id, {
	              rules: [{ required: true, message: '请填写文件名称' }],
	              initialValue: record.name || defaultName || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u6587\u4EF6\u540D\u79F0' }))
	          );
	        }
	      }, {
	        title: '*附件',
	        dataIndex: 'files',
	        key: 'files',
	        width: '22%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('files' + record.id, {
	              rules: [{ required: true, message: '请上传附件' }],
	              initialValue: record.files || []
	            })(_react2.default.createElement(_UploadFileTable2.default, {
	              type: 'ghost',
	              fileList: record.file,
	              isPreview: true,
	              onRemove: _this.fileRemove
	            }))
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        key: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            { style: { margin: 0, height: '45px' } },
	            renewalFiles && renewalFiles.length > 1 ? _react2.default.createElement(
	              _reactRouter.Link,
	              { onClick: function onClick() {
	                  return _this.deleteEffects(record.id);
	                } },
	              '\u5220\u9664'
	            ) : null
	          );
	        }
	      }];
	      if (!renewalFiles || renewalFiles.length <= 1) {
	        arr.pop();
	      }
	      return arr;
	    };
	
	    _this.state = {
	      chapters: [{ id: 0 }],
	      renewalFiles: [{ id: 0 }],
	      chaptersCount: 1,
	      renewalFilesCount: 1,
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      if (data.chapters && data.chapters.length) {
	        data.chapters.map(function (item) {
	          item.id = item.uuid;
	          return 1;
	        });
	        this.setState({
	          chapters: data.chapters,
	          chaptersCount: data.chapters.length
	        });
	      }
	      if (data.renewalFiles && data.renewalFiles.length) {
	        data.renewalFiles.map(function (item) {
	          item.id = item.uuid;
	          return 1;
	        });
	        this.setState({
	          renewalFiles: data.renewalFiles,
	          renewalFilesCount: data.renewalFiles.length
	        });
	      }
	    }
	
	    // 提交
	
	
	    /**
	     *文件删除
	     */
	
	
	    // 公司变化，记录公司名称
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _state = this.state,
	          chapters = _state.chapters,
	          renewalFiles = _state.renewalFiles;
	      var _props = this.props,
	          isSubmitting = _props.isSubmitting,
	          data = _props.data;
	
	      var formItemLayout = {
	        labelCol: {
	          xs: { span: 24 },
	          sm: { span: 3 }
	        },
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 18 },
	          md: { span: 18 }
	        }
	      };
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: this.start,
	              loading: isSubmitting
	            },
	            '\u4FDD\u5B58\u7533\u8BF7'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { bordered: false, style: { width: '100%' } },
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({}, formItemLayout, { label: '\u7EED\u8BC1\u8D44\u6599\u540D\u79F0' }),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/administrative/material/info/' + data.documentUuid },
	              data.documentName
	            )
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({}, formItemLayout, { label: '\u65B0\u8D44\u6599\u540D\u79F0' }),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/administrative/material/info/' + data.newDocumentUuid },
	              data.newDocumentName
	            )
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({}, formItemLayout, { label: '\u7528\u7AE0\u7C7B\u522B' }),
	            getFieldDecorator('chapters')(_react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_antd.Table, {
	                columns: this.chaptersColumns(),
	                dataSource: chapters,
	                pagination: false,
	                rowKey: 'id',
	                rowClassName: 'tabRow'
	              }),
	              _react2.default.createElement(
	                _antd.Button,
	                { onClick: this.addChapters, style: { width: '100%', borderStyle: 'dashed' } },
	                '+\u6DFB\u52A0\u7528\u7AE0'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({}, formItemLayout, { label: '\u7533\u8BF7\u9644\u4EF6' }),
	            getFieldDecorator('renewalFiles')(_react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_antd.Table, {
	                columns: this.renewalFilesColumns(),
	                dataSource: renewalFiles,
	                pagination: false,
	                rowKey: 'id',
	                rowClassName: 'tabRow'
	              }),
	              _react2.default.createElement(
	                _antd.Button,
	                { onClick: this.addEffects, style: { width: '100%', borderStyle: 'dashed' } },
	                '+\u6DFB\u52A0\u9644\u4EF6'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({}, formItemLayout, { label: '\u7533\u8BF7\u8BF4\u660E' }),
	            getFieldDecorator('reason', {
	              rules: [{ required: true, message: '请填写申请说明' }],
	              initialValue: data.reason || null
	            })(_react2.default.createElement(TextArea, { style: { minHeight: 32 }, rows: 4, placeholder: '\u8BF7\u586B\u5199\u7533\u8BF7\u8BF4\u660E' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u7533\u8BF7\u4EBA' }, formItemLayout),
	            getFieldDecorator('crName')(_react2.default.createElement(
	              'span',
	              null,
	              this.props.accountInfo.userName
	            ))
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	BaseForm.propTypes = {
	  data: _propTypes2.default.object.isRequired,
	  handSubmit: _propTypes2.default.func.isRequired
	};
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(BaseForm));

/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        width: '3%',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '流水编号',
	        dataIndex: 'no',
	        width: '10%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/administrative/material/renewal/open/' + record.uuid },
	            text || '查看'
	          );
	        }
	      }, {
	        title: '资料名称',
	        dataIndex: 'documentName',
	        width: '10%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/administrative/material/info/' + record.documentUuid },
	            text || '查看'
	          );
	        }
	      }, {
	        title: '申请人',
	        width: '8%',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        width: '10%',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        width: '15%',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        width: '15%',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        width: '8%',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5BA1\u6838\u4E2D'
	            );
	          }
	          if (record.status === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u7F16\u8F91'
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(_antd.Table, {
	        loading: this.props.loading,
	        columns: this.columns(),
	        dataSource: list,
	        pagination: pagination,
	        rowKey: 'uuid',
	        onChange: this.handleChange
	      });
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(595);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _attachment = __webpack_require__(27);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _BackBtn = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var TextArea = _antd.Input.TextArea;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handSubmit = _this$props.handSubmit,
	          data = _this$props.data;
	      var goodsList = _this.state.goodsList;
	
	      var params = Object.assign({}, data, _this.props.form.getFieldsValue());
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          goodsList.map(function (item) {
	            item.name = values['name' + item.id];
	            item.unit = values['unit' + item.id];
	            item.model = values['model' + item.id];
	            item.count = values['count' + item.id];
	
	            delete params['name' + item.id];
	            delete params['unit' + item.id];
	            delete params['model' + item.id];
	            delete params['count' + item.id];
	            return item;
	          });
	          params.details = goodsList;
	          params.expectedDate = params.expectedDate.valueOf();
	          handSubmit(params);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              });
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.start = function (e) {
	      _this.submit(e, null, 'start');
	    };
	
	    _this.addGoods = function () {
	      var _this$state = _this.state,
	          goodsList = _this$state.goodsList,
	          goodsCount = _this$state.goodsCount;
	
	      goodsList.push({ id: goodsCount });
	      _this.setState({
	        goodsList: goodsList,
	        goodsCount: goodsCount + 1
	      });
	    };
	
	    _this.deleteGoods = function (id) {
	      var goodsList = _this.state.goodsList;
	
	      _this.setState({ goodsList: goodsList.filter(function (item) {
	          return item.id !== id;
	        }) }, function () {
	        _this.getGoodsSum();
	      });
	    };
	
	    _this.getGoodsSum = function () {
	      var goodsList = _this.state.goodsList;
	
	      var sum = 0;
	      goodsList.map(function (item) {
	        item.subtotal && (sum += item.subtotal);
	        return item;
	      });
	      _this.setState({
	        goodsSum: sum
	      });
	    };
	
	    _this.getGoodsSubtotal = function (id) {
	      var goodsList = _this.state.goodsList;
	
	      goodsList.map(function (item) {
	        if (item.id === id) {
	          item.unit && item.count ? item.subtotal = item.unit * item.count : item.subtotal = 0;
	        }
	
	        return item;
	      });
	      _this.setState({
	        goodsList: goodsList
	      }, _this.getGoodsSum());
	    };
	
	    _this.handleChangeGoodsUnit = function (id, value) {
	      var goodsList = _this.state.goodsList;
	
	      goodsList.map(function (item) {
	        if (item.id === id) {
	          item.unit = value;
	        }
	        return item;
	      });
	      _this.setState({ goodsList: goodsList }, _this.getGoodsSubtotal(id));
	      return value;
	    };
	
	    _this.handleChangeGoodsNum = function (id, value) {
	      var goodsList = _this.state.goodsList;
	
	      goodsList.map(function (item) {
	        if (item.id === id) {
	          item.count = value;
	        }
	        return item;
	      });
	      _this.setState({ goodsList: goodsList }, _this.getGoodsSubtotal(id));
	      return value;
	    };
	
	    _this.goodsColumns = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var goodsList = _this.state.goodsList;
	
	
	      var arr = [{
	        title: '*采购物品',
	        dataIndex: 'name',
	        key: 'name',
	        width: '18%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('name' + record.id, {
	              rules: [{ required: true, message: '请填写采购物品' }],
	              initialValue: record.name || undefined
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u586B\u5199\u91C7\u8D2D\u7269\u54C1' }))
	          );
	        }
	      }, {
	        title: '型号',
	        dataIndex: 'model',
	        key: 'model',
	        width: '18%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('model' + record.id, {
	              initialValue: record.model || undefined
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u586B\u5199\u7269\u54C1\u578B\u53F7' }))
	          );
	        }
	      }, {
	        title: '*单价(元)',
	        dataIndex: 'unit',
	        key: 'unit',
	        width: '18%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('unit' + record.id, {
	              rules: [{ required: true, message: '请填写单价' }],
	              initialValue: record.unit || undefined,
	              getValueFromEvent: function getValueFromEvent(value) {
	                return _this.handleChangeGoodsUnit(record.id, value);
	              }
	            })(_react2.default.createElement(_antd.InputNumber, { placeholder: '\u8BF7\u586B\u5199\u7269\u54C1\u5355\u4EF7', style: { width: '100%' } }))
	          );
	        }
	      }, {
	        title: '*数量',
	        dataIndex: 'count',
	        key: 'count',
	        width: '18%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('count' + record.id, {
	              rules: [{ required: true, message: '请填写数量' }],
	              initialValue: record.count || undefined,
	              getValueFromEvent: function getValueFromEvent(value) {
	                return _this.handleChangeGoodsNum(record.id, value);
	              }
	            })(_react2.default.createElement(_antd.InputNumber, { style: { width: '100%' } }))
	          );
	        }
	      }, {
	        title: '小计(元)',
	        dataIndex: 'subtotal',
	        key: 'subtotal',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'div',
	            { style: { margin: 0, height: '40px' } },
	            _util2.default.numberFormat(text)
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        key: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            { style: { margin: 0, height: '40px' } },
	            goodsList && goodsList.length > 1 ? _react2.default.createElement(
	              _reactRouter.Link,
	              { onClick: function onClick() {
	                  return _this.deleteGoods(record.id);
	                } },
	              '\u5220\u9664'
	            ) : null
	          );
	        }
	      }];
	      if (!goodsList || goodsList.length <= 1) {
	        arr.pop();
	      }
	      return arr;
	    };
	
	    _this.state = {
	      goodsList: [{ id: 0 }],
	      goodsCount: 1,
	      goodsSum: '',
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      data.details && data.details.length && data.details.map(function (item) {
	        item.id = item.uuid;
	        item.unit && item.count ? item.subtotal = item.unit * item.count : item.subtotal = 0;
	        return item;
	      });
	
	      data.details && data.details.length && this.setState({
	        goodsList: data.details,
	        goodsCount: data.details.length,
	        goodsSum: data.price
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var data = nextProps.data;
	
	      data.details && data.details.length && this.setState({
	        goodsList: data.details,
	        goodsCount: data.details.length
	      });
	    }
	
	    /**
	     *文件删除
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _state = this.state,
	          goodsList = _state.goodsList,
	          goodsSum = _state.goodsSum;
	      var _props = this.props,
	          isSubmitting = _props.isSubmitting,
	          data = _props.data;
	
	
	      var formItemLayout = {
	        labelCol: {
	          xs: { span: 24 },
	          sm: { span: 3 }
	        },
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 18 },
	          md: { span: 18 }
	        }
	      };
	      var formItemLayout2 = {
	        labelCol: {
	          xs: { span: 24 },
	          sm: { span: 3 }
	        },
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 6 },
	          md: { span: 6 }
	        }
	      };
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { style: { marginTop: 8 } },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' }, className: 'aaab' },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: this.start,
	              loading: isSubmitting
	            },
	            '\u53D1\u8D77\u7533\u8BF7'
	          ),
	          data.uuid ? _react2.default.createElement(
	            _antd.Button,
	            { icon: 'delete', style: { marginRight: 10 }, onClick: this.props.handleDelete },
	            '\u5220\u9664'
	          ) : null
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { bordered: false, style: { width: '100%' } },
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u4EA4\u4ED8\u65F6\u95F4' }, formItemLayout2),
	            getFieldDecorator('expectedDate', {
	              rules: [{ required: true, message: '请选择期望交付时间' }],
	              initialValue: data.expectedDate ? (0, _moment2.default)(data.expectedDate) : null
	            })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({}, formItemLayout, { label: '\u91C7\u8D2D\u7269\u54C1' }),
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_antd.Table, {
	                columns: this.goodsColumns(),
	                dataSource: goodsList,
	                pagination: false,
	                rowKey: 'id',
	                rowClassName: 'tabRow'
	              }),
	              _react2.default.createElement(
	                _antd.Button,
	                { onClick: this.addGoods, style: { width: '100%', borderStyle: 'dashed' } },
	                '+\u6DFB\u52A0\u7269\u54C1'
	              ),
	              _react2.default.createElement(
	                _antd.Row,
	                { type: 'flex' },
	                _react2.default.createElement(
	                  _antd.Col,
	                  null,
	                  '\u91C7\u8D2D\u91D1\u989D\u603B\u8BA1\uFF1A'
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  null,
	                  _util2.default.numberFormat(goodsSum),
	                  '\u5143'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u7533\u8BF7\u9644\u4EF6' }, formItemLayout2),
	            getFieldDecorator('files', {
	              initialValue: data.files
	            })(_react2.default.createElement(_UploadFile2.default, { type: 'ghost', fileList: data.file, isPreview: true, onRemove: this.fileRemove }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({}, formItemLayout, { label: '\u7533\u8BF7\u8BF4\u660E' }),
	            getFieldDecorator('reason', {
	              rules: [{ required: true, message: '请填写申请说明' }],
	              initialValue: data.reason
	            })(_react2.default.createElement(TextArea, { style: { minHeight: 32 }, rows: 4 }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u7533\u8BF7\u4EBA' }, formItemLayout),
	            getFieldDecorator('crName', {
	              initialValue: data.createUserName
	            })(_react2.default.createElement(
	              'span',
	              null,
	              this.props.accountInfo.userName
	            ))
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(BaseForm));

/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '采购单号',
	        dataIndex: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/administrative/purchase_manage/open/' + record.uuid },
	            text || '查看'
	          );
	        }
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5BA1\u6838\u4E2D'
	            );
	          }
	          if (record.status === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u7F16\u8F91'
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(_antd.Table, {
	        rowKey: 'uuid',
	        dataSource: list,
	        pagination: pagination,
	        columns: this.columns(),
	        loading: this.props.loading,
	        onChange: this.handleChange
	      });
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	__webpack_require__(595);
	
	var _dict = __webpack_require__(64);
	
	var _attachment = __webpack_require__(27);
	
	var _material = __webpack_require__(50);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _UploadFileTable = __webpack_require__(192);
	
	var _UploadFileTable2 = _interopRequireDefault(_UploadFileTable);
	
	var _BackBtn = __webpack_require__(12);
	
	var _reactRouter = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var TextArea = _antd.Input.TextArea;
	var Option = _antd.Select.Option;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handSubmit = _this$props.handSubmit,
	          data = _this$props.data;
	      var _this$state = _this.state,
	          chaptersList = _this$state.chaptersList,
	          effectsList = _this$state.effectsList;
	
	      var params = Object.assign({}, data, _this.props.form.getFieldsValue());
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          chaptersList.map(function (item) {
	            item.companyUuid = values['companyUuid' + item.id];
	            item.company = values['company' + item.id];
	            item.seal = values['seal' + item.id];
	            item.type = values['type' + item.id];
	
	            delete params['companyUuid' + item.id];
	            delete params['company' + item.id];
	            delete params['seal' + item.id];
	            delete params['type' + item.id];
	            return item;
	          });
	          effectsList.map(function (item) {
	            item.name = values['name' + item.id];
	            item.files = values['files' + item.id];
	            item.price = values['price' + item.id];
	            item.count = values['count' + item.id];
	            item.isReturn = values['isReturn' + item.id];
	
	            delete params['name' + item.id];
	            delete params['files' + item.id];
	            delete params['price' + item.id];
	            delete params['count' + item.id];
	            delete params['isReturn' + item.id];
	            return item;
	          });
	          params.chapters = chaptersList;
	          params.effects = effectsList;
	          handSubmit(params);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              });
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.handleCompanyChange = function (id, value, option) {
	      _this.props.form.setFieldsValue(_defineProperty({}, 'company' + id, option ? option.props.children : ''));
	    };
	
	    _this.getDocumentList = function () {
	      var params = {
	        condition: '事件类型_帮实_desc'
	      };
	      (0, _material.queryMaterialDocumentListBR)(params).then(function (res) {
	        if (res.statusCode === 200 && res.data.length > 0) {
	          _this.setState({
	            descFile: res.data[0].files[0]
	          });
	        }
	      });
	    };
	
	    _this.start = function (e) {
	      _this.submit(e, null, 'start');
	    };
	
	    _this.handleIsReturn = function () {
	      _this.setState({
	        isReturnVisible: true
	      });
	    };
	
	    _this.handleIsReturnOk = function () {
	      var _this$state2 = _this.state,
	          effectsList = _this$state2.effectsList,
	          isReturnRow = _this$state2.isReturnRow;
	
	      _this.props.form.validateFields(['returnCount' + isReturnRow.id, 'returnExpectedDate' + isReturnRow.id], function (err, values) {
	        if (!err) {
	          var returnCount = values['returnCount' + isReturnRow.id];
	          var returnExpectedDate = values['returnExpectedDate' + isReturnRow.id];
	          effectsList.map(function (item) {
	            if (item.id === isReturnRow.id) {
	              item.returnCount = returnCount;
	              item.returnExpectedDate = returnExpectedDate;
	            }
	            return item;
	          });
	          _this.setState({
	            isReturnVisible: false,
	            effectsList: effectsList
	          });
	        }
	      });
	    };
	
	    _this.handleIsReturnCancel = function () {
	      _this.setState({
	        isReturnVisible: false
	      });
	    };
	
	    _this.addChapters = function () {
	      var _this$state3 = _this.state,
	          chaptersList = _this$state3.chaptersList,
	          chaptersCount = _this$state3.chaptersCount;
	
	      chaptersList.push({ id: chaptersCount });
	      _this.setState({
	        chaptersList: chaptersList,
	        chaptersCount: chaptersCount + 1
	      });
	    };
	
	    _this.deleteChapters = function (id) {
	      var chaptersList = _this.state.chaptersList;
	
	      _this.setState({
	        chaptersList: chaptersList.filter(function (item) {
	          return item.id !== id;
	        })
	      });
	    };
	
	    _this.addEffects = function () {
	      var _this$state4 = _this.state,
	          effectsList = _this$state4.effectsList,
	          effectsCount = _this$state4.effectsCount;
	
	      effectsList.push({ id: effectsCount });
	      _this.setState({
	        effectsList: effectsList,
	        effectsCount: effectsCount + 1
	      });
	    };
	
	    _this.deleteEffects = function (id) {
	      var effectsList = _this.state.effectsList;
	
	      _this.setState({
	        effectsList: effectsList.filter(function (item) {
	          return item.id !== id;
	        })
	      });
	    };
	
	    _this.isReturnChange = function (record, e) {
	      var effectsList = _this.state.effectsList;
	      var isReturnRow = _this.state.isReturnRow;
	
	      if (e === '1') {
	        _this.setState({
	          isReturnRow: record
	        });
	        _this.handleIsReturn();
	      } else {
	        isReturnRow = {};
	        effectsList.map(function (item) {
	          if (item.id === record.id) {
	            delete item.returnCount;
	            delete item.returnExpectedDate;
	          }
	          return item;
	        });
	
	        _this.setState({
	          effectsList: effectsList,
	          isReturnRow: isReturnRow
	        });
	      }
	      return e;
	    };
	
	    _this.isReturnTrue = function (record) {
	      _this.setState({
	        isReturnRow: record
	      });
	      _this.handleIsReturn();
	    };
	
	    _this.chaptersColumns = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var chaptersList = _this.state.chaptersList;
	
	      var arr = [{
	        title: '*用章公司',
	        dataIndex: 'companyUuid',
	        key: 'companyUuid',
	        width: '35%',
	        render: function render(text, record) {
	          getFieldDecorator('company' + record.id, {
	            initialValue: record.company
	          });
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('companyUuid' + record.id, {
	              rules: [{ required: true, message: '请选择用章公司' }],
	              initialValue: record.companyUuid
	            })(_react2.default.createElement(_companySearch2.default, Object.assign({
	              companyName: record.company,
	              companyUuid: record.companyUuid,
	              onChange: function onChange(value, option) {
	                return _this.handleCompanyChange(record.id, value, option);
	              }
	            }, _this.props)))
	          );
	        }
	      }, {
	        title: '*用章类型',
	        dataIndex: 'type',
	        key: 'type',
	        width: '30%',
	        render: function render(text, record) {
	          var defaultType = void 0;
	          switch (text) {
	            case 0:
	              defaultType = '0';
	              break;
	            case 1:
	              defaultType = '1';
	              break;
	            case 2:
	              defaultType = '2';
	              break;
	            default:
	              break;
	          }
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('type' + record.id, {
	              rules: [{ required: true, message: '请选择用章类型' }],
	              initialValue: defaultType
	            })(_react2.default.createElement(
	              _antd.Select,
	              { placeholder: '\u8BF7\u9009\u62E9\u7528\u7AE0\u7C7B\u578B' },
	              _react2.default.createElement(
	                Option,
	                { key: '0' },
	                '\u516C\u7AE0'
	              ),
	              _react2.default.createElement(
	                Option,
	                { key: '1' },
	                '\u5408\u540C\u7AE0'
	              ),
	              _react2.default.createElement(
	                Option,
	                { key: '2' },
	                '\u6CD5\u4EBA\u7AE0'
	              )
	            ))
	          );
	        }
	      }, {
	        title: '是否外借',
	        dataIndex: 'seal',
	        key: 'seal',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('seal' + record.id, {
	              rules: [{ required: true, message: '请选择是否外借' }],
	              initialValue: record.seal ? '' + record.seal : '0'
	            })(_react2.default.createElement(
	              _antd.Select,
	              null,
	              _react2.default.createElement(
	                Option,
	                { key: '0' },
	                '\u5426'
	              ),
	              _react2.default.createElement(
	                Option,
	                { key: '1' },
	                '\u662F'
	              )
	            ))
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        key: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            { style: { margin: 0, height: '45px' } },
	            chaptersList && chaptersList.length > 1 ? _react2.default.createElement(
	              _reactRouter.Link,
	              { onClick: function onClick() {
	                  return _this.deleteChapters(record.id);
	                } },
	              '\u5220\u9664'
	            ) : null
	          );
	        }
	      }];
	
	      if (!chaptersList || chaptersList.length === 1) {
	        arr.pop();
	      }
	      return arr;
	    };
	
	    _this.effectsColumns = function () {
	      var _this$props$form = _this.props.form,
	          getFieldDecorator = _this$props$form.getFieldDecorator,
	          getFieldValue = _this$props$form.getFieldValue;
	      var effectsList = _this.state.effectsList;
	
	
	      var arr = [{
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name',
	        width: '18%',
	        render: function render(text, record) {
	          var filesArr = getFieldValue('files' + record.id) || [];
	          var defaultName = filesArr[0] ? filesArr[0].name : '';
	          var index = defaultName.indexOf('.');
	          defaultName = defaultName.slice(0, index);
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('name' + record.id, {
	              rules: [{ required: true, message: '请填写文件名称' }],
	              initialValue: record.name || defaultName || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u6587\u4EF6\u540D\u79F0' }))
	          );
	        }
	      }, {
	        title: '*附件',
	        dataIndex: 'files',
	        key: 'files',
	        width: '22%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('files' + record.id, {
	              rules: [{ required: true, message: '请上传附件' }],
	              initialValue: record.files || []
	            })(_react2.default.createElement(_UploadFileTable2.default, {
	              type: 'ghost',
	              fileList: record.file,
	              isPreview: true,
	              onRemove: _this.fileRemove
	            }))
	          );
	        }
	      }, {
	        title: '涉及金额',
	        dataIndex: 'price',
	        key: 'price',
	        width: '18%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('price' + record.id, {
	              initialValue: record.price || null
	            })(_react2.default.createElement(_antd.InputNumber, { placeholder: '\u53EF\u586B\u5199\u6D89\u53CA\u91D1\u989D', style: { width: '100%' } }))
	          );
	        }
	      }, {
	        title: '*数量',
	        dataIndex: 'count',
	        key: 'count',
	        width: '15%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('count' + record.id, {
	              rules: [{ required: true, message: '请填写数量' }],
	              initialValue: record.count || null
	            })(_react2.default.createElement(_antd.InputNumber, { placeholder: '\u8BF7\u586B\u5199\u6570\u91CF', style: { width: '100%' } }))
	          );
	        }
	      }, {
	        title: '*是否归还',
	        dataIndex: 'isReturn',
	        key: 'isReturn',
	        width: '18%',
	        render: function render(text, record) {
	          var returnRender = record.returnCount && record.returnExpectedDate ? _react2.default.createElement(
	            'span',
	            { style: { paddingLeft: '5px', whiteSpace: 'nowrap' } },
	            record.returnCount,
	            '\u4EFD\uFF0C',
	            _moment2.default.unix(record.returnExpectedDate / 1000).format('YYYY-MM-DD')
	          ) : _react2.default.createElement(
	            _reactRouter.Link,
	            {
	              style: { paddingLeft: '5px', whiteSpace: 'nowrap' },
	              onClick: function onClick() {
	                return _this.isReturnTrue(record);
	              }
	            },
	            '\u8BF7\u586B\u5199\u5F52\u8FD8\u4FE1\u606F'
	          );
	          return _react2.default.createElement(
	            'div',
	            { style: { margin: 0, height: '60px' } },
	            _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '36px' } },
	              getFieldDecorator('isReturn' + record.id, {
	                rules: [{ required: true, message: '请选择是否归还' }],
	                initialValue: record.isReturn ? '' + record.isReturn : '0'
	              })(_react2.default.createElement(
	                _antd.Select,
	                { onSelect: function onSelect(e) {
	                    return _this.isReturnChange(record, e);
	                  } },
	                _react2.default.createElement(
	                  Option,
	                  { key: '0' },
	                  '\u5426'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { key: '1' },
	                  '\u662F'
	                )
	              ))
	            ),
	            getFieldValue('isReturn' + record.id) === '1' ? returnRender : null
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        key: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            { style: { margin: 0, height: '45px' } },
	            effectsList && effectsList.length > 1 ? _react2.default.createElement(
	              _reactRouter.Link,
	              { onClick: function onClick() {
	                  return _this.deleteEffects(record.id);
	                } },
	              '\u5220\u9664'
	            ) : null
	          );
	        }
	      }];
	      if (!effectsList || effectsList.length <= 1) {
	        arr.pop();
	      }
	      return arr;
	    };
	
	    _this.descTitle = function () {
	      var descFile = _this.state.descFile;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u4E8B\u4EF6\u7C7B\u578B',
	        _react2.default.createElement(
	          'a',
	          { onClick: function onClick() {
	              return (0, _attachment.queryFilePreview)(descFile);
	            } },
	          _react2.default.createElement(_antd.Icon, { type: 'question-circle' })
	        )
	      );
	    };
	
	    _this.state = {
	      ichapterappType: [],
	      chaptersList: [{ id: 0 }],
	      effectsList: [{ id: 0 }],
	      chaptersCount: 1,
	      effectsCount: 1,
	      isReturnRow: {},
	      isReturnVisible: false,
	      descFile: {},
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var data = this.props.data;
	
	      this.getDocumentList();
	      if (data.chapters && data.chapters.length) {
	        data.chapters.map(function (item) {
	          item.id = item.uuid;
	          return 1;
	        });
	        this.setState({
	          chaptersList: data.chapters,
	          chaptersCount: data.chapters.length
	        });
	      }
	      if (data.effects && data.effects.length) {
	        data.effects.map(function (item) {
	          item.id = item.uuid;
	          return 1;
	        });
	        this.setState({
	          effectsList: data.effects,
	          effectsCount: data.effects.length
	        });
	      }
	      (0, _dict.queryIchapterappType)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            ichapterappType: res.data
	          });
	        }
	      });
	    }
	
	    // 提交
	
	
	    /**
	     *文件删除
	     */
	
	
	    // 公司变化，记录公司名称
	
	
	    // 获取说明性文件
	
	
	    // 说明性title
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _state = this.state,
	          isReturnVisible = _state.isReturnVisible,
	          chaptersList = _state.chaptersList,
	          effectsList = _state.effectsList,
	          isReturnRow = _state.isReturnRow;
	      var _props = this.props,
	          isSubmitting = _props.isSubmitting,
	          data = _props.data;
	
	      var formItemLayout = {
	        labelCol: {
	          xs: { span: 24 },
	          sm: { span: 3 }
	        },
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 18 },
	          md: { span: 18 }
	        }
	      };
	
	      var formItemLayout2 = {
	        labelCol: {
	          xs: { span: 24 },
	          sm: { span: 6 }
	        },
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 15 },
	          md: { span: 15 }
	        }
	      };
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: this.start,
	              loading: isSubmitting
	            },
	            '\u53D1\u8D77\u7533\u8BF7'
	          ),
	          data.uuid ? _react2.default.createElement(
	            _antd.Button,
	            { icon: 'delete', style: { marginRight: 10 }, onClick: this.props.handleDelete },
	            '\u5220\u9664'
	          ) : null
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { bordered: false, style: { width: '100%' } },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: this.descTitle() }, formItemLayout2),
	                getFieldDecorator('type', {
	                  rules: [{ required: true, message: '请选择用章事件类型' }],
	                  initialValue: data.type || data.type === 0 ? '' + data.type : undefined
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { placeholder: '\u8BF7\u9009\u62E9\u7528\u7AE0\u4E8B\u4EF6\u7C7B\u578B' },
	                  this.state.ichapterappType.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.value, value: item.value },
	                      item.key
	                    );
	                  })
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5BF9\u65B9\u516C\u53F8' }, formItemLayout2),
	                getFieldDecorator('otherCompany', {
	                  initialValue: data.otherCompany || null
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5BF9\u65B9\u516C\u53F8\u540D\u79F0' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({}, formItemLayout, { label: '\u7528\u7AE0\u7C7B\u522B' }),
	            getFieldDecorator('chapters')(_react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_antd.Table, {
	                columns: this.chaptersColumns(),
	                dataSource: chaptersList,
	                pagination: false,
	                rowKey: 'id',
	                rowClassName: 'tabRow'
	              }),
	              _react2.default.createElement(
	                _antd.Button,
	                { onClick: this.addChapters, style: { width: '100%', borderStyle: 'dashed' } },
	                '+\u6DFB\u52A0\u7528\u7AE0'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({}, formItemLayout, { label: '\u7533\u8BF7\u9644\u4EF6' }),
	            getFieldDecorator('effects')(_react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_antd.Table, {
	                columns: this.effectsColumns(),
	                dataSource: effectsList,
	                pagination: false,
	                rowKey: 'id',
	                rowClassName: 'tabRow'
	              }),
	              _react2.default.createElement(
	                _antd.Button,
	                { onClick: this.addEffects, style: { width: '100%', borderStyle: 'dashed' } },
	                '+\u6DFB\u52A0\u9644\u4EF6'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({}, formItemLayout, { label: '\u7533\u8BF7\u8BF4\u660E' }),
	            getFieldDecorator('reason', {
	              rules: [{ required: true, message: '请填写申请说明' }],
	              initialValue: data.reason || null
	            })(_react2.default.createElement(TextArea, { style: { minHeight: 32 }, rows: 4, placeholder: '\u8BF7\u586B\u5199\u7533\u8BF7\u8BF4\u660E' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u7533\u8BF7\u4EBA' }, formItemLayout),
	            getFieldDecorator('crName')(_react2.default.createElement(
	              'span',
	              null,
	              this.props.accountInfo.userName
	            ))
	          )
	        ),
	        isReturnVisible ? _react2.default.createElement(
	          _antd.Modal,
	          {
	            title: '\u5F52\u8FD8\u8BE6\u7EC6',
	            visible: isReturnVisible,
	            onOk: this.handleIsReturnOk,
	            onCancel: this.handleIsReturnCancel
	          },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout2, { label: '\u5F52\u8FD8\u6570\u91CF' }),
	              getFieldDecorator('returnCount' + isReturnRow.id, {
	                rules: [{ required: true, message: '请选择归还数量' }],
	                initialValue: isReturnRow.returnCount || null
	              })(_react2.default.createElement(_antd.InputNumber, { style: { width: '60%' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout2, { label: '\u5F52\u8FD8\u65F6\u95F4' }),
	              getFieldDecorator('returnExpectedDate' + isReturnRow.id, {
	                rules: [{ required: true, message: '请选择归还时间' }],
	                initialValue: isReturnRow.returnExpectedDate ? (0, _moment2.default)(isReturnRow.returnExpectedDate, 'YYYY/MM/DD') : null
	              })(_react2.default.createElement(_antd.DatePicker, null))
	            )
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(BaseForm));

/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        width: '3%',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '流水编号',
	        dataIndex: 'no',
	        width: '10%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/administrative/s_manage/open/' + record.uuid },
	            text || '查看'
	          );
	        }
	      }, {
	        title: '用章公司',
	        dataIndex: 'companys',
	        key: 'companys',
	        width: '10%',
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price',
	        width: '5%',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        width: '8%',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        width: '10%',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        width: '15%',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        width: '15%',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        width: '8%',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5BA1\u6838\u4E2D'
	            );
	          }
	          if (record.status === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u7F16\u8F91'
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(_antd.Table, {
	        loading: this.props.loading,
	        columns: this.columns(),
	        dataSource: list,
	        pagination: pagination,
	        rowKey: 'uuid',
	        onChange: this.handleChange
	      });
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _TableRecordByOrg = __webpack_require__(1454);
	
	var _TableRecordByOrg2 = _interopRequireDefault(_TableRecordByOrg);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleDrawer = function (org) {
	      _this.setState({
	        org: org
	      });
	      _this.handleVisible(true);
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: "公司名称",
	        dataIndex: "company",
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            "a",
	            { onClick: function onClick() {
	                return _this.handleDrawer(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: "用章次数",
	        dataIndex: "count"
	      }, {
	        title: "用章总金额",
	        dataIndex: "sum"
	      }, {
	        title: "用章进行中",
	        dataIndex: "doing",
	        key: "doing"
	      }, {
	        title: "用章已完成",
	        dataIndex: "done",
	        key: "done"
	      }];
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource,
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          _state$dataSource = _state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination,
	          visible = _state.visible,
	          org = _state.org;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: list,
	          pagination: pagination,
	          rowKey: "companyUuid"
	        }),
	        visible ? _react2.default.createElement(_TableRecordByOrg2.default, { org: org, handleVisible: this.handleVisible }) : null
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = Manage;

/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _serialNumber = __webpack_require__(420);
	
	var _BackBtn = __webpack_require__(12);
	
	var _FormBase = __webpack_require__(1467);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageAdd = function (_Component) {
	  _inherits(PageAdd, _Component);
	
	  function PageAdd(props) {
	    _classCallCheck(this, PageAdd);
	
	    var _this = _possibleConstructorReturn(this, (PageAdd.__proto__ || Object.getPrototypeOf(PageAdd)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      item.unid = _this.props.params.unid || _this.state.dataInfo.unid;
	      (0, _serialNumber.querySaveSerialNumber)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          (0, _BackBtn.goBack)();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageAdd, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	
	    /**
	     * 提交报销
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, { data: this.state.dataInfo, handSubmit: this.handSubmit, dataInfo: dataInfo })
	      );
	    }
	  }]);
	
	  return PageAdd;
	}(_react.Component);
	
	exports.default = PageAdd;

/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _workflow = __webpack_require__(272);
	
	var _BaseForm = __webpack_require__(1479);
	
	var _BaseForm2 = _interopRequireDefault(_BaseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Add = function (_Component) {
	  _inherits(Add, _Component);
	
	  function Add(props) {
	    _classCallCheck(this, Add);
	
	    var _this = _possibleConstructorReturn(this, (Add.__proto__ || Object.getPrototypeOf(Add)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      var context = _this;
	      (0, _workflow.querySaveWorkflowTemplate)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('保存成功');
	          context.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      data: {}
	    };
	    return _this;
	  }
	
	  _createClass(Add, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	
	      return _react2.default.createElement(_BaseForm2.default, {
	        ref: function ref(form) {
	          _this2.form = form;
	        },
	        handSubmit: this.handSubmit,
	        data: data
	      });
	    }
	  }]);
	
	  return Add;
	}(_react.Component);
	
	exports.default = Add;

/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _org = __webpack_require__(53);
	
	var _dict = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MyContainer = function MyContainer(WrappedComponent) {
	  return function (_Component) {
	    _inherits(_class2, _Component);
	
	    function _class2(props) {
	      _classCallCheck(this, _class2);
	
	      var _this = _possibleConstructorReturn(this, (_class2.__proto__ || Object.getPrototypeOf(_class2)).call(this, props));
	
	      _this.loadExpendType = function () {
	        (0, _dict.queryDictExpend)().then(function (res) {
	          if (res.statusCode === 200) {
	            _this.setState({
	              expendType: res.data
	            });
	          }
	        });
	      };
	
	      _this.getOrgCompanyList = function () {
	        (0, _org.queryOrgCompanyList)({
	          type: 1
	        }).then(function (res) {
	          _this.setState({
	            company: res.data
	          });
	        });
	      };
	
	      _this.state = {
	        expendType: [],
	        company: []
	      };
	      return _this;
	    }
	
	    _createClass(_class2, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        this.loadExpendType();
	        this.getOrgCompanyList();
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var props = Object.assign({}, this.props, {
	          expendType: this.state.expendType,
	          company: this.state.company
	        });
	        return _react2.default.createElement(WrappedComponent, props);
	      }
	    }]);
	
	    return _class2;
	  }(_react.Component);
	};
	
	exports.default = MyContainer;

/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	__webpack_require__(2954);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var StandardFormRow = function StandardFormRow(_ref) {
	  var title = _ref.title,
	      children = _ref.children,
	      last = _ref.last,
	      block = _ref.block,
	      grid = _ref.grid,
	      rest = _objectWithoutProperties(_ref, ["title", "children", "last", "block", "grid"]);
	
	  var cls = (0, _classnames2.default)("standardFormRow", {
	    standardFormRowBlock: block,
	    standardFormRowLast: last,
	    standardFormRowGrid: grid
	  });
	
	  return _react2.default.createElement(
	    "div",
	    Object.assign({ className: cls }, rest),
	    title && _react2.default.createElement(
	      "div",
	      { className: "label" },
	      _react2.default.createElement(
	        "span",
	        null,
	        title
	      )
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "content" },
	      children
	    )
	  );
	};
	
	exports.default = StandardFormRow;

/***/ },
/* 676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(2955);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CheckableTag = _antd.Tag.CheckableTag;
	
	
	var TagSelectOption = function TagSelectOption(_ref) {
	  var children = _ref.children,
	      checked = _ref.checked,
	      _onChange = _ref.onChange,
	      value = _ref.value;
	  return _react2.default.createElement(
	    CheckableTag,
	    { checked: checked, key: value, onChange: function onChange(state) {
	        return _onChange(value, state);
	      } },
	    children
	  );
	};
	
	TagSelectOption.isTagSelectOption = true;
	
	var TagSelect = function (_Component) {
	  _inherits(TagSelect, _Component);
	
	  function TagSelect(props) {
	    _classCallCheck(this, TagSelect);
	
	    var _this = _possibleConstructorReturn(this, (TagSelect.__proto__ || Object.getPrototypeOf(TagSelect)).call(this, props));
	
	    _this.onChange = function (value) {
	      // multiple:多选、单选
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          multiple = _this$props.multiple;
	
	      if (multiple) {
	        _this.setState({ value: value });
	        if (onChange) {
	          onChange(value);
	        }
	      } else {
	        var choosed = value.length > 1 ? [value[1]] : value;
	        _this.setState({ value: choosed });
	        if (onChange) {
	          onChange(choosed);
	        }
	      }
	    };
	
	    _this.onSelectAll = function (checked) {
	      var checkedTags = [];
	      if (checked) {
	        checkedTags = _this.getAllTags();
	      }
	      _this.onChange(checkedTags);
	    };
	
	    _this.getAllTags = function () {
	      var children = _this.props.children;
	
	      children = _react2.default.Children.toArray(children);
	      var checkedTags = children.filter(function (child) {
	        return _this.isTagSelectOption(child);
	      }).map(function (child) {
	        return child.props.value;
	      });
	      return checkedTags || [];
	    };
	
	    _this.handleTagChange = function (value, checked) {
	      var StateValue = _this.state.value;
	
	      var checkedTags = [].concat(_toConsumableArray(StateValue));
	
	      var index = checkedTags.indexOf(value);
	      if (checked && index === -1) {
	        checkedTags.push(value);
	      } else if (!checked && index > -1) {
	        checkedTags.splice(index, 1);
	      }
	      _this.onChange(checkedTags);
	    };
	
	    _this.handleExpand = function () {
	      var expand = _this.state.expand;
	
	      _this.setState({
	        expand: !expand
	      });
	    };
	
	    _this.isTagSelectOption = function (node) {
	      return node && node.type && (node.type.isTagSelectOption || node.type.displayName === 'TagSelectOption');
	    };
	
	    _this.state = {
	      expand: false,
	      value: props.value || props.defaultValue || []
	    };
	    return _this;
	  }
	
	  _createClass(TagSelect, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          value = _state.value,
	          expand = _state.expand;
	      var _props = this.props,
	          children = _props.children,
	          hideCheckAll = _props.hideCheckAll,
	          className = _props.className,
	          style = _props.style,
	          expandable = _props.expandable,
	          actionsText = _props.actionsText;
	
	      var checkedAll = this.getAllTags().length === value.length;
	
	      var _ref2 = actionsText === null ? {} : actionsText,
	          _ref2$expandText = _ref2.expandText,
	          expandText = _ref2$expandText === undefined ? 'Expand' : _ref2$expandText,
	          _ref2$collapseText = _ref2.collapseText,
	          collapseText = _ref2$collapseText === undefined ? 'Collapse' : _ref2$collapseText,
	          _ref2$selectAllText = _ref2.selectAllText,
	          selectAllText = _ref2$selectAllText === undefined ? 'All' : _ref2$selectAllText;
	
	      var cls = (0, _classnames2.default)('tagSelect', className, {
	        hasExpandTag: expandable,
	        expanded: expand
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: cls, style: style },
	        hideCheckAll ? null : _react2.default.createElement(
	          CheckableTag,
	          { checked: checkedAll, key: 'tag-select-__all__', onChange: this.onSelectAll },
	          selectAllText
	        ),
	        value && _react2.default.Children.map(children, function (child) {
	          if (_this2.isTagSelectOption(child)) {
	            return _react2.default.cloneElement(child, {
	              key: 'tag-select-' + child.props.value,
	              value: child.props.value,
	              checked: value.indexOf(child.props.value) > -1,
	              onChange: _this2.handleTagChange
	            });
	          }
	          return child;
	        }),
	        expandable && _react2.default.createElement(
	          'a',
	          { className: 'trigger', onClick: this.handleExpand },
	          expand ? collapseText : expandText,
	          ' ',
	          _react2.default.createElement(_antd.Icon, { type: expand ? 'up' : 'down' })
	        )
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return { value: nextProps.value || [] };
	      }
	      return null;
	    }
	  }]);
	
	  return TagSelect;
	}(_react.Component);
	
	TagSelect.defaultProps = {
	  hideCheckAll: false,
	  actionsText: {
	    expandText: 'Expand',
	    collapseText: 'Collapse',
	    selectAllText: 'All'
	  }
	};
	
	
	TagSelect.Option = TagSelectOption;
	
	exports.default = TagSelect;

/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _big = __webpack_require__(235);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _SelectApportionObj = __webpack_require__(678);
	
	var _SelectApportionObj2 = _interopRequireDefault(_SelectApportionObj);
	
	__webpack_require__(596);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var type = ['非公摊', '单次公摊', '多次公摊'];
	
	var ModalApportion = function (_Component) {
	  _inherits(ModalApportion, _Component);
	
	  function ModalApportion(props) {
	    _classCallCheck(this, ModalApportion);
	
	    var _this = _possibleConstructorReturn(this, (ModalApportion.__proto__ || Object.getPrototypeOf(ModalApportion)).call(this, props));
	
	    _this.handleChange = function (params) {
	      _this.details = params;
	      if (params && params.length > 0) {
	        _this.setState({
	          count: _this.getCountSum(params),
	          minus: _this.getMinus(params),
	          avg: _this.getAvg(params)
	        });
	      } else {
	        _this.setState({
	          count: '-',
	          minus: '',
	          avg: '-'
	        });
	      }
	    };
	
	    _this.getCountSum = function (data) {
	      var countSum = data.reduce(function (prev, curr) {
	        return prev + curr.count;
	      }, 0);
	      return countSum;
	    };
	
	    _this.getAvg = function (params) {
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          price = _this$props$form$getF.price;
	
	      return new _big2.default(price || 0).div(new _big2.default(_this.getCountSum(params))).toFixed(2);
	    };
	
	    _this.getMinus = function (params) {
	      var _this$props$form$getF2 = _this.props.form.getFieldsValue(),
	          price = _this$props$form$getF2.price;
	
	      var sum = params.reduce(function (prev, curr) {
	        return prev.plus(new _big2.default(curr.price || 0));
	      }, new _big2.default(0));
	      var minus = (new _big2.default(sum) - new _big2.default(price || 0)).toFixed(2);
	      return minus;
	    };
	
	    _this.findTypeName = function (value) {
	      var typeName = '';
	      _this.props.expendType.forEach(function (item) {
	        if (value === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.handleSubmit = function () {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = values;
	          params.details = _this.details;
	          _this.props.onOk(params);
	        }
	      });
	    };
	
	    _this.state = {
	      count: '0',
	      minus: 0,
	      avg: 0
	    };
	    return _this;
	  }
	
	  _createClass(ModalApportion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          dataInfo = _props.dataInfo,
	          visible = _props.visible,
	          dataItem = _props.dataItem;
	      var _state = this.state,
	          count = _state.count,
	          minus = _state.minus,
	          avg = _state.avg;
	
	      var _props$form$getFields = this.props.form.getFieldsValue(),
	          price = _props$form$getFields.price;
	
	      var apportion = dataItem.apportion || {};
	      var formItemLayout = {
	        labelCol: { span: 7 },
	        wrapperCol: { span: 17 }
	      };
	      var details = apportion.details || [];
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          width: 900,
	          title: '\u8BBE\u7F6E\u5206\u644A\u65B9\u6848',
	          visible: visible,
	          onCancel: function onCancel() {
	            return _this2.props.onCancel(false);
	          },
	          onOk: this.handleSubmit
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modalApportion' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u91D1\u989D' }, formItemLayout),
	                getFieldDecorator('price', {
	                  rules: [{ required: true, message: '请设置分摊金额!' }]
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u7C7B\u578B' }, formItemLayout),
	                type[apportion.type]
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u9884\u7B97\u79D1\u76EE' }, formItemLayout),
	                this.findTypeName(dataItem.type)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u4EBA\u6570' }, formItemLayout),
	                count
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 9, push: 1 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u4EBA\u5747\u91D1\u989D' }, formItemLayout),
	                avg
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u91D1\u989D' }, formItemLayout),
	                dataInfo.price,
	                new _big2.default(minus || 0).eq(new _big2.default(0)) ? null : _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red', marginLeft: '8px' } },
	                  '\u5DEE\u989D',
	                  minus,
	                  '\u5143'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_antd.Divider, null),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(_SelectApportionObj2.default, {
	              price: price || 0,
	              onChange: this.handleChange,
	              dataItem: dataItem,
	              choosedArr: details
	            })
	          ),
	          _react2.default.createElement(_antd.Divider, null),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u5206\u644A\u8BF4\u660E', labelCol: { span: 2 }, wrapperCol: { span: 22 } },
	                getFieldDecorator('remark', {})(_react2.default.createElement(_antd.Input.TextArea, { placeholder: '\u5907\u6CE8', type: 'textarea', maxLength: 1000 })),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '12px', color: '#999' } },
	                  '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalApportion;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalApportion);

/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _big = __webpack_require__(235);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _TableEdit = __webpack_require__(1507);
	
	var _TableEdit2 = _interopRequireDefault(_TableEdit);
	
	var _SelectShow = __webpack_require__(1506);
	
	var _SelectShow2 = _interopRequireDefault(_SelectShow);
	
	__webpack_require__(597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalApportion = function (_Component) {
	  _inherits(ModalApportion, _Component);
	
	  function ModalApportion(props) {
	    _classCallCheck(this, ModalApportion);
	
	    var _this = _possibleConstructorReturn(this, (ModalApportion.__proto__ || Object.getPrototypeOf(ModalApportion)).call(this, props));
	
	    _this.formatData = function (data) {
	      var apportion = [];
	      data.forEach(function (item) {
	        apportion.push({
	          originName: item.title,
	          originUuid: item.value,
	          originType: item.type,
	          count: item.count,
	          price: _this.getPrice(data, item)
	        });
	      });
	      return apportion;
	    };
	
	    _this.formatData2 = function (data) {
	      var apportion = [];
	      data.forEach(function (item) {
	        apportion.push({
	          originName: item.originName,
	          originUuid: item.originUuid,
	          originType: item.originType,
	          count: item.count,
	          price: _this.getPrice(data, item)
	        });
	      });
	      return apportion;
	    };
	
	    _this.setChoooseArr = function () {
	      var apportion = _this.state.apportion;
	
	      var choosedArr = [];
	      apportion.forEach(function (item) {
	        choosedArr.push(item.originUuid);
	      });
	    };
	
	    _this.getCountSum = function (data) {
	      var countSum = data.reduce(function (prev, curr) {
	        return prev + curr.count;
	      }, 0);
	      return countSum;
	    };
	
	    _this.getPrice = function (data, item) {
	      var countSum = new _big2.default(_this.getCountSum(data) || 1);
	      var count = new _big2.default(item.count || 1);
	      var price = new _big2.default(_this.props.price || 0);
	      return price.div(countSum).times(count).toFixed(2);
	    };
	
	    _this.handleChange = function (data) {
	      var apportion = _this.formatData(data);
	      _this.resetApportion(apportion);
	    };
	
	    _this.handleDelete = function (data) {
	      var apportion = _this.formatData2(data);
	      _this.resetApportion(apportion);
	    };
	
	    _this.resetApportion = function (apportion) {
	      _this.setState({
	        apportion: apportion
	      });
	      _this.props.onChange(apportion);
	    };
	
	    _this.state = {
	      apportion: []
	    };
	    return _this;
	  }
	
	  _createClass(ModalApportion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        apportion: this.props.choosedArr
	      });
	    }
	
	    // 用于删除重新计算
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var apportion = this.state.apportion;
	
	      var choosedArr = apportion.map(function (item) {
	        return item.originUuid;
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'selectApportion' },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 11 },
	            _react2.default.createElement(_SelectShow2.default, { onChange: this.handleChange, choosedArr: choosedArr })
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 13 },
	            _react2.default.createElement(_TableEdit2.default, {
	              data: apportion,
	              onDelete: this.handleDelete,
	              resetApportion: this.resetApportion,
	              onHandlePriceChange: this.handlePriceChange,
	              setChoooseArr: this.setChoooseArr
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalApportion;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalApportion);

/***/ },
/* 679 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Series = function (_React$Component) {
	  _inherits(Series, _React$Component);
	
	  function Series() {
	    _classCallCheck(this, Series);
	
	    return _possibleConstructorReturn(this, (Series.__proto__ || Object.getPrototypeOf(Series)).apply(this, arguments));
	  }
	
	  _createClass(Series, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      var title = this.props.title;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "h4",
	          { style: { color: "#000", fontWeight: "bold", fontSize: "16px" } },
	          title
	        ),
	        _react2.default.createElement(_antd.Empty, { image: _antd.Empty.PRESENTED_IMAGE_SIMPLE })
	      );
	    }
	  }]);
	
	  return Series;
	}(_react2.default.Component);
	
	exports.default = Series;

/***/ },
/* 680 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Pie = __webpack_require__(1508);
	
	var _Pie2 = _interopRequireDefault(_Pie);
	
	var _Empty = __webpack_require__(679);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Series = function (_React$Component) {
	  _inherits(Series, _React$Component);
	
	  function Series() {
	    _classCallCheck(this, Series);
	
	    return _possibleConstructorReturn(this, (Series.__proto__ || Object.getPrototypeOf(Series)).apply(this, arguments));
	  }
	
	  _createClass(Series, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      var _props$data = this.props.data,
	          seriesData = _props$data.seriesData,
	          title = _props$data.title;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        seriesData.length > 0 ? _react2.default.createElement(_Pie2.default, this.props) : _react2.default.createElement(_Empty2.default, { title: title })
	      );
	    }
	  }]);
	
	  return Series;
	}(_react2.default.Component);
	
	exports.default = Series;

/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Rank = __webpack_require__(1509);
	
	var _Rank2 = _interopRequireDefault(_Rank);
	
	var _Empty = __webpack_require__(679);
	
	var _Empty2 = _interopRequireDefault(_Empty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Series = function (_React$Component) {
	  _inherits(Series, _React$Component);
	
	  function Series() {
	    _classCallCheck(this, Series);
	
	    return _possibleConstructorReturn(this, (Series.__proto__ || Object.getPrototypeOf(Series)).apply(this, arguments));
	  }
	
	  _createClass(Series, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          title = _props.title;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        data.length > 0 ? _react2.default.createElement(_Rank2.default, this.props) : _react2.default.createElement(_Empty2.default, { title: title })
	      );
	    }
	  }]);
	
	  return Series;
	}(_react2.default.Component);
	
	exports.default = Series;

/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _core_account_search = __webpack_require__(232);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */
	
	
	var TextArea = _antd.Input.TextArea;
	
	var Eidtor = function (_Component) {
	  _inherits(Eidtor, _Component);
	
	  function Eidtor() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Eidtor);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Eidtor.__proto__ || Object.getPrototypeOf(Eidtor)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      content: '',
	      atUuids: []
	    }, _this.handleMention = function (e) {
	      _this.setState({
	        atUuids: e
	      });
	      _this.props.onMention(e);
	    }, _this.handleChange = function (e) {
	      var value = e.target.value;
	
	      if (value && value.length > 210) {
	        value = value.substring(0, 210);
	      }
	      _this.setState({
	        content: value
	      });
	      _this.props.onChange(e);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Eidtor, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch((0, _core_account_search.getAccountSearch)());
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.submitting !== nextProps.submitting && nextProps.submitting === false) {
	        this.setState({
	          content: '',
	          atUuids: []
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onSubmit = _props.onSubmit,
	          submitting = _props.submitting,
	          placeholder = _props.placeholder,
	          options = _props.options;
	      var _state = this.state,
	          atUuids = _state.atUuids,
	          content = _state.content;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form.Item,
	          { style: { marginBottom: '10px' } },
	          _react2.default.createElement(TextArea, {
	            autosize: { minRows: 2, maxRows: 6 },
	            onChange: this.handleChange,
	            placeholder: placeholder,
	            value: content
	          }),
	          _react2.default.createElement(
	            'span',
	            { style: { fontSize: '12px', color: '#999' } },
	            '*\u6700\u591A\u53EF\u8F93\u5165200\u5B57'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_antd.Col, { span: 12 }),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              _antd.Form.Item,
	              { style: { textAlign: 'right', marginBottom: '10px' } },
	              _react2.default.createElement(
	                _antd.Button,
	                { htmlType: 'submit', loading: submitting, onClick: onSubmit, type: 'primary' },
	                '\u8BC4\u8BBA'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Eidtor;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    options: state.core_account_search
	  };
	})(Eidtor);

/***/ },
/* 683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _user = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.Tree.TreeNode;
	
	var DrawerOther = function (_Component) {
	  _inherits(DrawerOther, _Component);
	
	  function DrawerOther(props) {
	    _classCallCheck(this, DrawerOther);
	
	    var _this = _possibleConstructorReturn(this, (DrawerOther.__proto__ || Object.getPrototypeOf(DrawerOther)).call(this, props));
	
	    _this.getParentKey = function (key, tree, grandKeys) {
	      var parentKey = void 0;
	      var grandKey = grandKeys || [];
	      tree.map(function (item) {
	        if (item.children) {
	          if (item.children.some(function (it) {
	            return it.uuid === key;
	          })) {
	            grandKey.push(item.uuid);
	            parentKey = grandKey;
	          } else if (_this.getParentKey(key, item.children)) {
	            grandKey.push(item.uuid);
	            parentKey = _this.getParentKey(key, item.children, grandKey);
	          }
	        }
	        return item;
	      });
	      return parentKey;
	    };
	
	    _this.onCheck = function (checkedKey, e) {
	      var dataRef = e.node.props.dataRef;
	      var _this$state = _this.state,
	          checkedKeys = _this$state.checkedKeys,
	          checkedObjs = _this$state.checkedObjs;
	
	      if (e.checked) {
	        checkedKeys.push(dataRef.uuid);
	        checkedObjs.push({
	          uuid: dataRef.uuid,
	          name: dataRef.name
	        });
	      } else {
	        checkedKeys = checkedKeys.filter(function (item) {
	          return item !== dataRef.uuid;
	        });
	        checkedObjs = checkedObjs.filter(function (item) {
	          return item.uuid !== dataRef.uuid;
	        });
	      }
	      _this.setState({
	        checkedKeys: checkedKeys,
	        checkedObjs: checkedObjs
	      });
	      _this.props.setViews(checkedObjs);
	    };
	
	    _this.onExpand = function (Key, e) {
	      var dataRef = e.node.props.dataRef;
	      var expandKeys = _this.state.expandKeys;
	
	
	      if (e.expanded) {
	        expandKeys.push(dataRef.uuid);
	      } else {
	        expandKeys = expandKeys.filter(function (item) {
	          return item !== dataRef.uuid;
	        });
	      }
	      _this.setState({
	        expandKeys: Key
	      });
	    };
	
	    _this.renderTreeNodes = function (data) {
	      return data.map(function (item) {
	        if (item.children) {
	          return _react2.default.createElement(
	            TreeNode,
	            { title: item.name, key: item.uuid, dataRef: item },
	            _this.renderTreeNodes(item.children)
	          );
	        }
	        return _react2.default.createElement(TreeNode, Object.assign({ title: item.name, key: item.uuid }, item, { dataRef: item }));
	      });
	    };
	
	    _this.state = {
	      orglist: [],
	      expandKeys: [],
	      checkedObjs: [],
	      checkedKeys: []
	    };
	    return _this;
	  }
	
	  _createClass(DrawerOther, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var checkedKeys = [];
	      var expandKeys = [];
	      var checkedObjs = [];
	      var views = this.props.views;
	
	      (0, _user.queryOrgUserList)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            orglist: res.data
	          });
	
	          views && views.map(function (item) {
	            checkedKeys.push(item.uuid);
	            checkedObjs.push({
	              uuid: item.uuid,
	              name: item.name
	            });
	            expandKeys = expandKeys.concat(_this2.getParentKey(item.uuid, res.data));
	            return item;
	          });
	          expandKeys = expandKeys.filter(function (item, i, self) {
	            return item && self.indexOf(item) === i;
	          });
	          _this2.setState({
	            checkedKeys: checkedKeys,
	            checkedObjs: checkedObjs,
	            expandKeys: expandKeys
	          });
	        }
	      });
	    }
	
	    // 找到该目录的所有父级目录（及以上）
	
	
	    // 复选框选中
	
	
	    // 展开
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var orglist = this.state.orglist;
	      var _state = this.state,
	          checkedKeys = _state.checkedKeys,
	          expandKeys = _state.expandKeys;
	
	      return _react2.default.createElement(
	        _antd.Drawer,
	        {
	          title: '\u5176\u4ED6\u67E5\u770B\u6743\u9650',
	          placement: 'right',
	          closable: false,
	          getContainer: false,
	          onClose: this.props.onClose,
	          visible: this.props.visible,
	          width: '30%'
	        },
	        _react2.default.createElement(
	          _antd.Tree,
	          {
	            key: Date.now(),
	            onExpand: this.onExpand,
	            expandedKeys: expandKeys,
	            checkable: true,
	            checkStrictly: true,
	            onCheck: this.onCheck,
	            checkedKeys: checkedKeys,
	            autoExpandParent: false
	          },
	          this.renderTreeNodes(orglist || [])
	        )
	      );
	    }
	  }]);
	
	  return DrawerOther;
	}(_react.Component);
	
	exports.default = DrawerOther;

/***/ },
/* 684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 根据时间及关键字搜索
	
	var RadioButton = _antd.Radio.Button;
	var RadioGroup = _antd.Radio.Group;
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var FormItem = _antd.Form.Item;
	var dateFormat = 'YYYY-MM-DD';
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.onChange1 = function (e) {
	      var setFieldsValue = _this.props.form.setFieldsValue;
	      var value = e.target.value;
	
	      if (value === '0') {
	        setFieldsValue({
	          range: [null, null]
	        });
	      } else if (value === '1') {
	        var start = (0, _moment2.default)().startOf('month');
	        var end = (0, _moment2.default)().endOf('month');
	        setFieldsValue({
	          range: [start, end]
	        });
	      } else if (value === '2') {
	        var _start = (0, _moment2.default)().startOf('year');
	        var _end = (0, _moment2.default)().endOf('year');
	        setFieldsValue({
	          range: [_start, _end]
	        });
	      }
	    };
	
	    _this.onChange2 = function () {
	      var setFieldsValue = _this.props.form.setFieldsValue;
	
	      setFieldsValue({ type: undefined });
	    };
	
	    _this.onSearch = function () {
	      var value = _this.props.form.getFieldsValue();
	      var params = {};
	      if (value.range) {
	        params.beginDate = value.range[0] ? (0, _moment2.default)(value.range[0]).format('YYYY-MM-DD') : '';
	        params.endDate = value.range[1] ? (0, _moment2.default)(value.range[1]).format('YYYY-MM-DD') : '';
	      }
	      _this.props.onChange(Object.assign({}, params, {
	        condition: value.condition || ''
	      }));
	    };
	
	    _this.onReset = function () {
	      _this.props.form.resetFields();
	      _this.props.onChange({});
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { style: { textAlign: 'right' }, layout: 'inline' },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('type')(_react2.default.createElement(
	            RadioGroup,
	            { onChange: this.onChange1 },
	            _react2.default.createElement(
	              RadioButton,
	              { value: '0' },
	              '\u5168\u90E8'
	            ),
	            _react2.default.createElement(
	              RadioButton,
	              { value: '1' },
	              '\u672C\u6708'
	            ),
	            _react2.default.createElement(
	              RadioButton,
	              { value: '2' },
	              '\u672C\u5E74'
	            )
	          ))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('range', {
	            initialValue: this.props.beginDate ? [(0, _moment2.default)(this.props.beginDate, dateFormat), (0, _moment2.default)(this.props.endDate, dateFormat)] : null
	          })(_react2.default.createElement(RangePicker, { style: { marginLeft: '-10px' }, onChange: this.onChange2 }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('condition', {
	            initialValue: this.props.condition || null
	          })(_react2.default.createElement(_antd.Input, { style: { marginLeft: '8px' }, placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', style: { marginLeft: '8px' }, onClick: this.onSearch },
	            '\u641C\u7D22'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { style: { marginLeft: '8px', marginRight: '-16px' }, onClick: this.onReset },
	            '\u91CD\u7F6E'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 仅根据时间搜索
	
	var RadioButton = _antd.Radio.Button;
	var RadioGroup = _antd.Radio.Group;
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var FormItem = _antd.Form.Item;
	
	var currentYear = _moment2.default.unix(new Date().getTime() / 1000).format('YYYY');
	var yearStartDate = currentYear + '-01-01';
	var yearEndDate = currentYear + '-12-31';
	var monthStartDate = (0, _moment2.default)((0, _moment2.default)().startOf('month')).format('YYYY-MM-DD');
	var monthEndDate = (0, _moment2.default)((0, _moment2.default)().endOf('month')).format('YYYY-MM-DD');
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.init = function () {
	      var setFieldsValue = _this.props.form.setFieldsValue;
	      var _this$props$defaultVa = _this.props.defaultValue,
	          defaultValue = _this$props$defaultVa === undefined ? {} : _this$props$defaultVa;
	      var beginDate = defaultValue.beginDate,
	          endDate = defaultValue.endDate;
	
	      if (beginDate && endDate) {
	        _this.setTypeByRange(beginDate, endDate);
	        setFieldsValue({
	          range: [(0, _moment2.default)(beginDate, 'YYYY-MM-DD'), (0, _moment2.default)(endDate, 'YYYY-MM-DD')]
	        });
	      }
	    };
	
	    _this.onChangeType = function (e) {
	      var _this$props$form = _this.props.form,
	          setFieldsValue = _this$props$form.setFieldsValue,
	          resetFields = _this$props$form.resetFields;
	      var value = e.target.value;
	
	      var start = void 0;
	      var end = void 0;
	      if (value === '0') {
	        resetFields('range');
	        _this.props.onChange({
	          beginDate: '',
	          endDate: ''
	        });
	        return;
	      }
	      if (value === '1') {
	        start = (0, _moment2.default)().startOf('month');
	        end = (0, _moment2.default)().endOf('month');
	      } else if (value === '2') {
	        start = (0, _moment2.default)().startOf('year');
	        end = (0, _moment2.default)().endOf('year');
	      }
	      setFieldsValue({
	        range: [start, end]
	      });
	      _this.props.onChange({
	        beginDate: (0, _moment2.default)(start).format('YYYY-MM-DD'),
	        endDate: (0, _moment2.default)(end).format('YYYY-MM-DD')
	      });
	    };
	
	    _this.onChangeRange = function (value) {
	      var beginDate = value[0] ? (0, _moment2.default)(value[0]).format('YYYY-MM-DD') : '';
	      var endDate = value[1] ? (0, _moment2.default)(value[1]).format('YYYY-MM-DD') : '';
	      _this.setTypeByRange(beginDate, endDate);
	      _this.props.onChange({
	        beginDate: beginDate,
	        endDate: endDate
	      });
	    };
	
	    _this.setTypeByRange = function (beginDate, endDate) {
	      var setFieldsValue = _this.props.form.setFieldsValue;
	
	      if (beginDate === yearStartDate && endDate === yearEndDate) {
	        setFieldsValue({ type: '2' });
	      } else if (beginDate === monthStartDate && endDate === monthEndDate) {
	        setFieldsValue({ type: '1' });
	      } else {
	        setFieldsValue({ type: undefined });
	      }
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.init();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { style: { textAlign: 'right' }, layout: 'inline' },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('type')(_react2.default.createElement(
	            RadioGroup,
	            { onChange: this.onChangeType },
	            _react2.default.createElement(
	              RadioButton,
	              { value: '0' },
	              '\u5168\u90E8'
	            ),
	            _react2.default.createElement(
	              RadioButton,
	              { value: '1' },
	              '\u672C\u6708'
	            ),
	            _react2.default.createElement(
	              RadioButton,
	              { value: '2' },
	              '\u672C\u5E74'
	            )
	          ))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('range')(_react2.default.createElement(RangePicker, { style: { marginLeft: '8px' }, onChange: this.onChangeRange }))
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(2959);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var StatisticCard = function StatisticCard(_ref) {
	  var data = _ref.data;
	  return _react2.default.createElement(
	    'div',
	    { className: 'statistic-wrapper' },
	    data.map(function (item, index) {
	      return _react2.default.createElement(
	        'div',
	        { className: 'statistic-item', key: item.value },
	        _react2.default.createElement(
	          'div',
	          { className: 'flex' },
	          _react2.default.createElement(_antd.Statistic, { title: item.title, value: item.value }),
	          index < data.length - 1 ? _react2.default.createElement(_antd.Divider, { type: 'verticle', style: { height: '60px' } }) : null
	        )
	      );
	    })
	  );
	}; /**
	    * @file: 统计数据展示组件
	    */
	
	exports.default = StatisticCard;

/***/ },
/* 687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _crm = __webpack_require__(33);
	
	var _FormCustom = __webpack_require__(1526);
	
	var _FormCustom2 = _interopRequireDefault(_FormCustom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.handleAdd = function (params) {
	      (0, _crm.querySaveCustom)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = { data: {} };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ data: nextProps.data });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormCustom2.default, {
	          ref: function ref(form) {
	            _this2.form = form;
	          },
	          handleSubmit: this.handleAdd,
	          data: data
	        })
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { organization: state.organization };
	})(BaseForm);

/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	
	var SelectCustom = function (_Component) {
	  _inherits(SelectCustom, _Component);
	
	  function SelectCustom(props) {
	    _classCallCheck(this, SelectCustom);
	
	    var _this = _possibleConstructorReturn(this, (SelectCustom.__proto__ || Object.getPrototypeOf(SelectCustom)).call(this, props));
	
	    _this.state = {
	      data: []
	    };
	
	    _this.getData = function () {
	      _this.props.loaddata({
	        condition: _this.condition || ''
	      }).then(function (res) {
	        _this.setState({
	          data: res
	        });
	      });
	    };
	
	    _this.handleSearch = function (value) {
	      _this.condition = value;
	      _this.getData();
	    };
	
	    _this.handleChange = function () {};
	
	    _this.lastFetchId = 0;
	    return _this;
	  }
	
	  _createClass(SelectCustom, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.state.data;
	      var _props = this.props,
	          getFieldDecorator = _props.form.getFieldDecorator,
	          ItemLayout = _props.ItemLayout;
	
	      var options = data.map(function (d) {
	        return _react2.default.createElement(
	          Option,
	          { key: d.uuid },
	          d.name
	        );
	      });
	      return _react2.default.createElement(
	        FormItem,
	        Object.assign({ label: '\u5BA2\u6237\u540D\u79F0' }, ItemLayout),
	        getFieldDecorator('customUuid', {
	          rules: [{ required: true, message: '请选择客户!' }]
	        })(_react2.default.createElement(
	          _antd.Select,
	          {
	            showSearch: true,
	            placeholder: this.props.placeholder,
	            style: this.props.style,
	            defaultActiveFirstOption: false,
	            showArrow: false,
	            filterOption: false,
	            onSearch: this.handleSearch,
	            onChange: this.handleChange,
	            notFoundContent: null
	          },
	          options
	        ))
	      );
	    }
	  }]);
	
	  return SelectCustom;
	}(_react.Component);
	
	exports.default = SelectCustom;

/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _BackBtn = __webpack_require__(12);
	
	var _crm = __webpack_require__(33);
	
	var _ConfigItem = __webpack_require__(1530);
	
	var _ConfigItem2 = _interopRequireDefault(_ConfigItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var FormCustom = function (_Component) {
	  _inherits(FormCustom, _Component);
	
	  function FormCustom(props) {
	    _classCallCheck(this, FormCustom);
	
	    var _this = _possibleConstructorReturn(this, (FormCustom.__proto__ || Object.getPrototypeOf(FormCustom)).call(this, props));
	
	    _this.getMyDepartment = function () {
	      (0, _crm.queryDepartmentMy)().then(function (res) {
	        if (res.statusCode === 200) {
	          var uuid = res.data.uuid;
	
	          _this.departmentUuid = uuid;
	          _this.getMyCustomView(uuid);
	        }
	      });
	    };
	
	    _this.getMyCustomView = function (uuid) {
	      (0, _crm.queryCustomView)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            fields: res.data
	          });
	        }
	      });
	    };
	
	    _this.submit = function (e) {
	      e.preventDefault();
	      var handleSubmit = _this.props.handleSubmit;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          // delete values.category
	          handleSubmit(values);
	        }
	      });
	    };
	
	    _this.state = {
	      fields: []
	    };
	    return _this;
	  }
	
	  _createClass(FormCustom, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.getMyDepartment();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var fields = this.state.fields;
	      var data = this.props.data;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      getFieldDecorator('province', { initialValue: data ? data.province : '' });
	      getFieldDecorator('city', { initialValue: data ? data.city : '' });
	      getFieldDecorator('category1', {
	        initialValue: data ? data.category1 : ''
	      });
	      getFieldDecorator('category2', {
	        initialValue: data ? data.category2 : ''
	      });
	      getFieldDecorator('orderName', {
	        initialValue: data ? data.orderName : ''
	      });
	      getFieldDecorator('recommendName', {
	        initialValue: data ? data.recommendName : ''
	      });
	      getFieldDecorator('managerName', {
	        initialValue: data ? data.managerName : ''
	      });
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15, marginTop: '-45px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u57FA\u672C\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            { gutter: 25 },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u5BA2\u6237\u540D\u79F0' },
	                getFieldDecorator('name', {
	                  rules: [{ required: true, message: '\u8BF7\u8F93\u5165\u5BA2\u6237\u540D\u79F0' }],
	                  initialValue: data.name
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            fields.map(function (item) {
	              return _react2.default.createElement(_ConfigItem2.default, Object.assign({ key: item.field, field: item }, _this2.props));
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24, style: { marginBottom: 15, textAlign: 'right' } },
	            _react2.default.createElement(
	              _antd.Button,
	              { style: { marginRight: 10 }, type: 'primary', htmlType: 'submit' },
	              '\u786E\u5B9A'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { onClick: _BackBtn.goBack },
	              '\u53D6\u6D88'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormCustom;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(FormCustom);

/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _BackBtn = __webpack_require__(12);
	
	var _crm = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      e.preventDefault();
	      var handleSubmit = _this.props.handleSubmit;
	      var config = _this.state.config;
	
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          var params = {
	            uuid: _this.props.params.uuid,
	            config: config
	          };
	          handleSubmit(params);
	        }
	      });
	    };
	
	    _this.getData = function () {
	      (0, _crm.queryDepartmentOpportunity)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        res.data.map(function (item, index) {
	          item.key = index;
	          return item;
	        });
	        _this.setState({
	          config: res.data
	        });
	      });
	    };
	
	    _this.addConfig = function () {
	      var config = _this.state.config;
	
	      var key = config[config.length - 1].key + 1;
	      _this.setState({
	        config: [].concat(_toConsumableArray(config), [{ key: key }])
	      });
	    };
	
	    _this.subConfig = function (key) {
	      var config = _this.state.config;
	
	      var configArr = config.filter(function (item) {
	        return item.key !== key;
	      });
	      _this.setState({
	        config: configArr
	      });
	    };
	
	    _this.handleChange = function (type, index) {
	      return function (e) {
	        var config = _this.state.config;
	
	        config[index][type] = e.target.value;
	        _this.setState({
	          config: config
	        });
	      };
	    };
	
	    _this.state = {
	      config: [{ key: 0 }]
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var config = this.state.config;
	
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        { title: '\u9636\u6BB5\u8BBE\u7F6E' },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.submit, className: '' },
	          config.map(function (item, index) {
	            return _react2.default.createElement(
	              _antd.Row,
	              { key: item.key },
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 6 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u9636\u6BB5\u540D\u79F0' }, ItemLayout),
	                  getFieldDecorator('name' + item.key, {
	                    rules: [{ required: true, message: '请填写阶段名称!' }],
	                    initialValue: item.name
	                  })(_react2.default.createElement(_antd.Input, { onChange: _this2.handleChange('name', index) }))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 7 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u9636\u6BB5\u767E\u5206\u53F7' }, ItemLayout),
	                  getFieldDecorator('percentage' + item.key, {
	                    rules: [{ required: true, message: '请填写阶段百分号!' }],
	                    initialValue: item.percentage
	                  })(_react2.default.createElement(_antd.Input, { onChange: _this2.handleChange('percentage', index), addonAfter: '%' }))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 6 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u6392\u5E8F' }, ItemLayout),
	                  getFieldDecorator('index' + item.key, {
	                    rules: [{ required: true, message: '请填写排序!' }],
	                    initialValue: item.index
	                  })(_react2.default.createElement(_antd.Input, { onChange: _this2.handleChange('index', index) }))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 5 },
	                _react2.default.createElement(
	                  FormItem,
	                  { style: { textAlign: 'right' } },
	                  config.length - 1 === index ? _react2.default.createElement(
	                    _antd.Button,
	                    { type: 'primary', onClick: _this2.addConfig, style: { marginRight: 10 } },
	                    '+'
	                  ) : null,
	                  config.length === 1 ? null : _react2.default.createElement(
	                    _antd.Button,
	                    { onClick: function onClick() {
	                        return _this2.subConfig(item.key);
	                      } },
	                    '-'
	                  )
	                )
	              )
	            );
	          }),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: 15, textAlign: 'right' } },
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginRight: 10 }, type: 'primary', htmlType: 'submit' },
	                '\u786E\u5B9A'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { onClick: _BackBtn.goBack },
	                '\u53D6\u6D88'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _attachment = __webpack_require__(27);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.handleBpClick = function (index) {
	      _this.setState({
	        bpIndex: index
	      });
	    };
	
	    _this.handlePlanClick = function (index) {
	      _this.setState({
	        planIndex: index
	      });
	    };
	
	    _this.handleBp = function (fileList) {
	      var _this$state = _this.state,
	          bpIndex = _this$state.bpIndex,
	          bpFile = _this$state.bpFile;
	
	      bpFile[bpIndex] = fileList;
	      _this.setState({ bpFile: bpFile });
	    };
	
	    _this.handlePlan = function (fileList) {
	      var _this$state2 = _this.state,
	          planIndex = _this$state2.planIndex,
	          planFile = _this$state2.planFile;
	
	      planFile[planIndex] = fileList;
	      _this.setState({ planFile: planFile });
	    };
	
	    _this.addPro = function () {
	      var project = _this.state.project;
	
	      project.push({});
	      _this.setState({
	        project: project
	      });
	    };
	
	    _this.formatFile = function (fileList) {
	      var file = [];
	      fileList.map(function (item) {
	        var fileItem = {};
	        fileItem.uuid = item.uuid;
	        fileItem.url = item.url;
	        fileItem.size = item.size;
	        fileItem.name = item.name;
	        fileItem.suffix = item.name.split('.')[1];
	        file.push(fileItem);
	        return item;
	      });
	      return file;
	    };
	
	    _this.fixFileArr = function (file) {
	      var fileArr = [];
	      var fileItem = {};
	      if (file) {
	        fileItem.uid = file.uuid;
	        fileItem.name = file.name;
	        fileItem.status = 'done';
	        fileItem.url = file.url;
	        fileArr.push(fileItem);
	      }
	      return fileArr;
	    };
	
	    _this.fixBpFileArr = function (fileArr) {
	      if (fileArr && fileArr.length > 0) {
	        var files = fileArr.map(function (file, index) {
	          return {
	            uid: file.file_id || index,
	            name: file.name,
	            url: file.url,
	            status: 'done'
	          };
	        });
	        fileArr = files;
	      }
	      return fileArr;
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handSubmit = _this.props.handSubmit;
	      var _this$state3 = _this.state,
	          project = _this$state3.project,
	          bpFile = _this$state3.bpFile,
	          planFile = _this$state3.planFile;
	
	      var projects = [];
	      var context = _this;
	      var projectsInfo = _this.props.form.getFieldsValue();
	      project.map(function (item, index) {
	        var projectItem = {};
	        projectItem.finance = {};
	        var plan = {};
	        projectItem.name = projectsInfo['proName' + index];
	        projectItem.type = projectsInfo['proType' + index];
	
	        if (bpFile[index]) {
	          projectItem.dpFile = context.formatFile(bpFile[index]);
	          projectItem.dpFileUuids = [];
	          bpFile[index].map(function (item1) {
	            projectItem.dpFileUuids.push(item1.uuid);
	            return projectItem.dpFileUuids;
	          });
	        }
	
	        projectItem.finance = {};
	        projectItem.finance.money = projectsInfo['financMoney' + index];
	        projectItem.finance.org = projectsInfo['financOrg' + index];
	        projectItem.finance.type = +projectsInfo['financType' + index];
	        projectItem.finance.date = projectsInfo['financDate' + index]._d.getTime();
	        if (planFile[index]) {
	          plan = context.formatFile(planFile[index])[0];
	          projectItem.finance.planFileUuid = planFile[index][0].uuid;
	        }
	        projectItem.finance.plan = plan;
	        if (bpFile[index]) {
	          projects.push(projectItem);
	        }
	        return projects;
	      });
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handSubmit(projects);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function () {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.state = {
	      project: [{}],
	      bpFile: [],
	      bpIndex: 0,
	      planIndex: 0,
	      planFile: [],
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        project: this.props.data
	      });
	    }
	
	    /**
	     *文件删除
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var project = this.state.project;
	
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15, marginTop: '-45px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: {
	              background: '#fff',
	              height: '50px',
	              marginBottom: '15px',
	              color: 'rgba(0,0,0,0.85)',
	              fontSize: '14px',
	              lineHeight: '50px',
	              paddingLeft: '24px'
	            }
	          },
	          '\u9879\u76EE\u4FE1\u606F'
	        ),
	        project.map(function (item, index) {
	          var finance = item.finance || {};
	          var bpFile = _this2.fixBpFileArr(item.dpFiles);
	          var plan = _this2.fixFileArr(finance.planFile);
	          return _react2.default.createElement(
	            _antd.Card,
	            { key: item.uuid },
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 10 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u9879\u76EE\u540D\u79F0' }, ItemLayout),
	                  getFieldDecorator('proName' + index, {
	                    rules: [{ required: true, message: '项目名称!' }],
	                    initialValue: item.name || ''
	                  })(_react2.default.createElement(_antd.Input, { placeholder: '\u9879\u76EE\u540D\u79F0' }))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 10 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u9879\u76EE\u7C7B\u522B' }, ItemLayout),
	                  getFieldDecorator('proType' + index, {
	                    rules: [{ required: true, message: '请选择组织!' }],
	                    initialValue: item.type ? '' + item.type : '1'
	                  })(_react2.default.createElement(
	                    _antd.Select,
	                    { size: 'large' },
	                    _react2.default.createElement(
	                      Option,
	                      { key: '1', value: '1' },
	                      '\u516C\u53F8'
	                    ),
	                    _react2.default.createElement(
	                      Option,
	                      { key: '0', value: '2' },
	                      '\u4E2A\u4EBA'
	                    )
	                  ))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 10, className: 'redStar' },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u9879\u76EEBP' }, ItemLayout, { className: 'redStar' }),
	                  _react2.default.createElement(_UploadFile2.default, {
	                    type: 'ghost',
	                    handleUpload: _this2.handleBp,
	                    fileList: bpFile,
	                    handleClick: function handleClick() {
	                      return _this2.handleBpClick(index);
	                    },
	                    onRemove: _this2.fileRemove
	                  })
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 10 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u83B7\u5F97\u878D\u8D44\u91D1\u989D' }, ItemLayout),
	                  getFieldDecorator('financMoney' + index, {
	                    rules: [{ required: true, message: '请输入融资金额!' }],
	                    initialValue: finance.money || ''
	                  })(_react2.default.createElement(_antd.Input, { placeholder: '\u83B7\u5F97\u878D\u8D44\u91D1\u989D' }))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 10 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u6295\u8D44\u673A\u6784' }, ItemLayout),
	                  getFieldDecorator('financOrg' + index, {
	                    initialValue: finance.org || ''
	                  })(_react2.default.createElement(_antd.Input, { placeholder: '\u6295\u8D44\u673A\u6784' }))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 10 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u83B7\u5F97\u878D\u8D44\u9636\u6BB5' }, ItemLayout),
	                  getFieldDecorator('financType' + index, {
	                    rules: [{ required: true, message: '请选择融资阶段!' }],
	                    initialValue: finance.type ? '' + finance.type : ''
	                  })(_react2.default.createElement(
	                    _antd.Select,
	                    { size: 'large' },
	                    _react2.default.createElement(
	                      Option,
	                      { key: '0', value: '0' },
	                      '\u79CD\u5B50'
	                    ),
	                    _react2.default.createElement(
	                      Option,
	                      { key: '1', value: '1' },
	                      '\u5929\u4F7F'
	                    ),
	                    _react2.default.createElement(
	                      Option,
	                      { key: '2', value: '2' },
	                      'pre-A'
	                    ),
	                    _react2.default.createElement(
	                      Option,
	                      { key: '3', value: '3' },
	                      'A\u8F6E'
	                    ),
	                    _react2.default.createElement(
	                      Option,
	                      { key: '4', value: '4' },
	                      'B\u8F6E'
	                    )
	                  ))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 10 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u83B7\u53D6\u878D\u8D44\u65F6\u95F4' }, ItemLayout),
	                  getFieldDecorator('financDate' + index, {
	                    rules: [{ required: true, message: '请输入手机号!' }],
	                    initialValue: finance.date ? (0, _moment2.default)(finance.date) : null
	                  })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 10, className: 'redStar' },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u540E\u7EED\u878D\u8D44\u8BA1\u5212' }, ItemLayout),
	                  _react2.default.createElement(_UploadFile2.default, {
	                    type: 'ghost',
	                    handleUpload: _this2.handlePlan,
	                    fileList: plan,
	                    handleClick: function handleClick() {
	                      return _this2.handlePlanClick(index);
	                    },
	                    onRemove: _this2.fileRemove
	                  })
	                )
	              )
	            )
	          );
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15, width: '100%', border: '1px dashed #aaa' } },
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'plus',
	              style: {
	                margin: '0 auto',
	                display: 'block',
	                border: 'none',
	                background: 'none'
	              },
	              onClick: this.addPro
	            },
	            '\u6DFB\u52A0'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15 } },
	          _react2.default.createElement(
	            _antd.Button,
	            { icon: 'save', style: { marginRight: 10 }, htmlType: 'submit', type: 'primary' },
	            '\u5B8C\u6210'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { icon: 'save', style: { marginRight: 10 }, htmlType: 'submit' },
	            '\u6682\u5B58'
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { organization: state.organization };
	})(_antd.Form.create({ wrappedComponentRef: true })(BaseForm));

/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _custom = __webpack_require__(131);
	
	var _FormEdit = __webpack_require__(1557);
	
	var _FormEdit2 = _interopRequireDefault(_FormEdit);
	
	var _FormProEdit = __webpack_require__(691);
	
	var _FormProEdit2 = _interopRequireDefault(_FormProEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit(props) {
	    _classCallCheck(this, Edit);
	
	    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));
	
	    _this.saveBase = function (custom) {
	      _this.setState({
	        custom: custom,
	        page: 2
	      });
	    };
	
	    _this.handSubmit = function (projects) {
	      var context = _this;
	      var _this$state = _this.state,
	          custom = _this$state.custom,
	          customInfo = _this$state.customInfo;
	
	      if (customInfo.uuid) {
	        custom.uuid = customInfo.uuid;
	      }
	      custom.projects = projects;
	      (0, _custom.querySaveCustom)(custom).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('保存成功');
	          context.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.changePage = function (page) {
	      _this.setState({
	        page: page
	      });
	    };
	
	    _this.state = {
	      customInfo: {},
	      page: 1,
	      custom: {}
	    };
	    return _this;
	  }
	
	  _createClass(Edit, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          customInfo = _state.customInfo,
	          page = _state.page;
	
	      var style1 = {};
	      var style2 = {};
	      if (page === 1) {
	        style1.backgroundColor = '#108ee9';
	        style1.color = '#fff';
	      } else {
	        style2.backgroundColor = '#108ee9';
	        style2.color = '#fff';
	      }
	      var projects = customInfo.projects ? customInfo.projects : [{}];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'custom-step' },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: style1 },
	              '1'
	            ),
	            '\u57FA\u672C\u4FE1\u606F'
	          ),
	          _react2.default.createElement('div', { className: 'border' }),
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: style2 },
	              '2'
	            ),
	            '\u9879\u76EE\u4FE1\u606F'
	          )
	        ),
	        page === 1 ? _react2.default.createElement(_FormEdit2.default, { data: customInfo, changePage: this.changePage, saveBase: this.saveBase }) : _react2.default.createElement(_FormProEdit2.default, { data: projects, changePage: this.changePage, handSubmit: this.handSubmit })
	      );
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	exports.default = Edit;

/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _apportion = __webpack_require__(166);
	
	var _FormBase = __webpack_require__(1569);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      (0, _apportion.querySaveApportion)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	
	    /**
	     * 提交报销
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, { data: this.state.dataInfo, handSubmit: this.handSubmit, dataInfo: dataInfo })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _finance = __webpack_require__(61);
	
	var _BackBtn = __webpack_require__(12);
	
	var _FormBase = __webpack_require__(1573);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageAdd = function (_Component) {
	  _inherits(PageAdd, _Component);
	
	  function PageAdd(props) {
	    _classCallCheck(this, PageAdd);
	
	    var _this = _possibleConstructorReturn(this, (PageAdd.__proto__ || Object.getPrototypeOf(PageAdd)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      item.uuid = _this.props.params.uuid;
	      (0, _finance.querySaveBookInfo)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageAdd, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	
	    /**
	     * 提交报销
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, {
	          data: this.state.dataInfo,
	          goBack: _BackBtn.goBack,
	          handSubmit: this.handSubmit,
	          dataInfo: dataInfo
	        })
	      );
	    }
	  }]);
	
	  return PageAdd;
	}(_react.Component);
	
	exports.default = PageAdd;

/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _finance = __webpack_require__(61);
	
	var _budget = __webpack_require__(30);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _BackBtn = __webpack_require__(12);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	var Description = _DescriptionList2.default.Description;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.setData = function () {
	      var uuid = _this.props.params.uuid;
	
	      var instance = {};
	
	      // 判断是发起还是编辑
	
	      if (uuid !== 'initiate') {
	        // 编辑
	        (0, _budget.queryAdjustmentInfo)({
	          uuid: uuid
	        }).then(function (res) {
	          if (res.statusCode === 200) {
	            res.data.init = res.data.budget;
	            res.data.wfUuid = res.data.uuid;
	            res.data.details.map(function (item) {
	              item.id = item.uuid;
	              return 1;
	            });
	
	            _this.setState({
	              data: res.data,
	              content: res.data.details,
	              isInitiate: false,
	              year: res.data.year
	            }, function () {
	              _this.setSumInit();
	            });
	          }
	        });
	      } else {
	        // 发起
	        var adjustData = _this.props.adjust_data;
	
	        adjustData.groupUuid = adjustData.uuid;
	        adjustData.groupName = adjustData.name;
	
	        _this.setState({
	          data: adjustData,
	          isInitiate: true,
	          year: _this.props.params.year
	        });
	      }
	
	      // 发起的流程跟踪
	      (0, _budget.queryAdjustmentWorkflow)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState(function () {
	            instance.activities = res.data;
	            return {
	              instance: instance
	            };
	          });
	        }
	      });
	    };
	
	    _this.getAdjustable = function (id, params) {
	      var content = _this.state.content;
	
	      (0, _budget.queryAdjustable)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          content.map(function (item) {
	            if (item.id === id) {
	              item.adjustable = res.data.adjustable;
	            }
	
	            return 1;
	          });
	          _this.setState({
	            content: content
	          });
	        }
	      });
	    };
	
	    _this.changeExpendType = function (id, e) {
	      var month = _this.props.form.getFieldValue('month' + id);
	      month && _this.getAdjustable(id, {
	        groupUuid: _this.state.data.groupUuid,
	        type: e,
	        yearMonth: _this.props.params.year + '-' + month
	      });
	      return e;
	    };
	
	    _this.changeMonth = function (id, e) {
	      var params = {};
	      var type = _this.props.form.getFieldValue('expendType' + id);
	      params.groupUuid = _this.state.data.groupUuid;
	      params.type = type;
	      params.yearMonth = _this.props.params.year + '-' + e;
	      _this.getAdjustable(id, params);
	      return e;
	    };
	
	    _this.changeAdjustType = function (id, e) {
	      _this.setSumInit(id, 'type', e);
	      return e;
	    };
	
	    _this.changeMoney = function (id, e) {
	      _this.setSumInit(id, 'money', e);
	
	      // 编辑情况下 避免可调整金额缺失
	      var isInitiate = _this.state.isInitiate;
	
	      var month = _this.props.form.getFieldValue('month' + id);
	      var type = _this.props.form.getFieldValue('expendType' + id);
	      !isInitiate && _this.getAdjustable(id, {
	        groupUuid: _this.state.data.groupUuid,
	        type: type,
	        yearMonth: _this.props.params.year + '-' + month
	      });
	      return e;
	    };
	
	    _this.setSumInit = function (id, it, e) {
	      var content = _this.state.content;
	
	      var adjustInit = 0;
	      var values = _this.props.form.getFieldsValue();
	      content.map(function (item) {
	        (item.target || item.target === 0) && (item.target = +values['adjustType' + item.id]);
	        var adjustment = +values['money' + item.id];
	
	        if (item.id === id) {
	          if (it === 'money') {
	            adjustment = +e;
	          } else if (it === 'type') {
	            item.target = +e;
	          }
	        }
	
	        if (item.target === 0) {
	          adjustment && (adjustInit -= adjustment);
	        } else if (item.target === 1) {
	          adjustment && (adjustInit += adjustment);
	        }
	
	        return 1;
	      });
	
	      _this.setState({
	        adjustInit: adjustInit,
	        content: content
	      });
	    };
	
	    _this.submit = function (e) {
	      var _this$state = _this.state,
	          data = _this$state.data,
	          content = _this$state.content;
	
	      var params = {};
	
	      if (e) {
	        e.preventDefault();
	      }
	
	      // 整理details数据
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var newContent = JSON.parse(JSON.stringify(content));
	          newContent.map(function (item) {
	            item.type = values['expendType' + item.id];
	            item.month = values['month' + item.id];
	            item.target = +values['adjustType' + item.id];
	            item.adjustment = +values['money' + item.id];
	            item.reason = values['reson' + item.id];
	            delete item.adjustable;
	            delete item.id;
	            return item;
	          });
	
	          // 设置params数据
	          data.wfUuid && (params.uuid = data.wfUuid);
	          params.groupUuid = data.groupUuid;
	          params.groupName = data.groupName;
	          params.year = _this.props.params.year;
	          params.details = newContent;
	
	          (0, _budget.querySaveAdjustment)(params).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success('' + res.message, 2.5);
	              _this.props.router.push({
	                pathname: '/finance/budget/adjust_manage_mine'
	              });
	            } else {
	              _antd.message.error('' + res.message, 2.5);
	            }
	          });
	        }
	      });
	    };
	
	    _this.handleDelete = function () {
	      var data = _this.state.data;
	
	      (0, _budget.queryDeleteAdjustment)({
	        uuid: data.wfUuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	        }
	      });
	
	      _reactRouter.browserHistory.go(-1);
	    };
	
	    _this.handleAdd = function () {
	      var content = _this.state.content;
	
	      content.push({ id: new Date().getTime() });
	      _this.setState({
	        content: content
	      });
	    };
	
	    _this.handleSub = function (index) {
	      var content = _this.state.content;
	
	      content.splice(index, 1);
	      _this.setState({
	        content: content
	      });
	      _this.setSumInit();
	    };
	
	    _this.adjustItem = function (item, index) {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var _this$state2 = _this.state,
	          content = _this$state2.content,
	          expendType = _this$state2.expendType,
	          monthList = _this$state2.monthList,
	          adjustList = _this$state2.adjustList;
	
	      return item ? _react2.default.createElement(
	        _antd.Row,
	        { gutter: 25, key: item.id },
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 4 },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('expendType' + item.id, {
	              rules: [{ required: true, message: '请选择费用科目' }],
	              getValueFromEvent: function getValueFromEvent(e) {
	                return _this.changeExpendType(item.id, e);
	              },
	              initialValue: item.type
	            })(_react2.default.createElement(
	              _antd.Select,
	              { placeholder: '\u8BF7\u9009\u62E9\u8D39\u7528\u79D1\u76EE', showSearch: true },
	              expendType.map(function (item1) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item1.value },
	                  item1.key
	                );
	              })
	            ))
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 4 },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('month' + item.id, {
	              rules: [{ required: true, message: '请选择科目月份' }],
	              getValueFromEvent: function getValueFromEvent(e) {
	                return _this.changeMonth(item.id, e);
	              },
	              initialValue: item.month
	            })(_react2.default.createElement(
	              _antd.Select,
	              { placeholder: '\u8BF7\u9009\u62E9\u79D1\u76EE\u6708\u4EFD', showSearch: true },
	              monthList.map(function (item1) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item1.value },
	                  item1.key
	                );
	              })
	            ))
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 4 },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('adjustType' + item.id, {
	              rules: [{ required: true, message: '请选择调整类型' }],
	              getValueFromEvent: function getValueFromEvent(e) {
	                return _this.changeAdjustType(item.id, e);
	              },
	              initialValue: item.target || item.target === 0 ? '' + item.target : null
	            })(_react2.default.createElement(
	              _antd.Select,
	              { placeholder: '\u8BF7\u9009\u62E9\u8C03\u6574\u7C7B\u578B', showSearch: true },
	              adjustList.map(function (item1) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item1.value },
	                  item1.key
	                );
	              })
	            ))
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 4 },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('money' + item.id, {
	              rules: [{ required: true, message: '填写调整金额' }],
	              getValueFromEvent: function getValueFromEvent(e) {
	                return _this.changeMoney(item.id, e);
	              },
	              initialValue: item.adjustment
	            })(_react2.default.createElement(_antd.InputNumber, {
	              placeholder: item.target === 0 && (item.adjustable || item.adjustable === 0) ? '\u53EF\u8C03\u6574\u9884\u7B97' + item.adjustable + '\u5143' : '请填写调整金额',
	              min: 0,
	              max: item.target === 0 && (item.adjustable || item.adjustable === 0) ? item.adjustable : Infinity,
	              style: { width: '100%' }
	            }))
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 4 },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('reson' + item.id, {
	              rules: [{ required: true, message: '填写调整原因' }],
	              initialValue: item.reason
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u586B\u5199\u8C03\u6574\u539F\u56E0' }))
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 4 },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            content.length < 2 ? null : _react2.default.createElement(
	              _antd.Button,
	              { onClick: function onClick() {
	                  return _this.handleSub(index);
	                } },
	              '\u5220\u9664'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 24 },
	          index === content.length - 1 ? _react2.default.createElement(
	            _antd.Button,
	            { onClick: _this.handleAdd, style: { borderStyle: 'dashed', width: '89%' } },
	            '+\u65B0\u589E'
	          ) : null
	        )
	      ) : null;
	    };
	
	    _this.state = {
	      content: [{ id: new Date().getTime() }],
	      data: {},
	      instance: {},
	      isInitiate: true,
	      expendType: [],
	      monthList: [],
	      adjustList: [],
	      adjustInit: 0,
	      year: ''
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setData();
	
	      // 设置支出类别
	      (0, _finance.queryBudgetExpend)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            expendType: res.data
	          });
	        }
	      });
	
	      // 设置月份数组
	      var monthList = [{ key: '一月', value: '01', disFlag: false }, { key: '二月', value: '02', disFlag: false }, { key: '三月', value: '03', disFlag: false }, { key: '四月', value: '04', disFlag: false }, { key: '五月', value: '05', disFlag: false }, { key: '六月', value: '06', disFlag: false }, { key: '七月', value: '07', disFlag: false }, { key: '八月', value: '08', disFlag: false }, { key: '九月', value: '09', disFlag: false }, { key: '十月', value: '10', disFlag: false }, { key: '十一月', value: '11', disFlag: false }, { key: '十二月', value: '12', disFlag: false }];
	
	      // 设置调整类型
	      var adjustList = [{ key: '增加', value: 1 }, { key: '减少', value: 0 }];
	
	      // 设置可调整月份
	      var year = this.props.params.year;
	
	      var currentYear = _moment2.default.unix(new Date().getTime() / 1000).format('YYYY');
	      var currentMonth = _moment2.default.unix(new Date().getTime() / 1000).format('MM');
	
	      if (currentYear === year) {
	        monthList.map(function (item) {
	          if (item.value < currentMonth) {
	            item.disFlag = true;
	          }
	          return 1;
	        });
	      } else if (year < currentYear) {
	        monthList.map(function (item) {
	          item.disFlag = true;
	          return 1;
	        });
	      }
	
	      this.setState(function () {
	        return {
	          monthList: monthList,
	          adjustList: adjustList
	        };
	      });
	    }
	
	    // 获取调整组数据
	
	
	    // 获取可调整金额
	
	
	    // 费用类型改变
	
	
	    // 根据月份得到可调整金额
	
	
	    // 预算类型（增加或减少）改变
	
	
	    // 预算调整金额改变
	
	
	    // 生成调整后的总额
	
	
	    // 提交
	
	
	    // 删除申请
	
	
	    // 明细新增
	
	
	    // 明细删除
	
	
	    // 明细调整组件
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          content = _state.content,
	          data = _state.data,
	          isInitiate = _state.isInitiate,
	          adjustInit = _state.adjustInit,
	          instance = _state.instance,
	          year = _state.year;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { height: '50px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            { ghost: true, className: 'btnn', onClick: this.submit },
	            '\u63D0\u4EA4'
	          ),
	          isInitiate ? null : _react2.default.createElement(
	            _antd.Button,
	            { className: 'btnn', onClick: this.handleDelete, ghost: true },
	            '\u5220\u9664'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u9884\u7B97\u4FE1\u606F' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u7EC4' },
	              data.groupName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u603B\u989D' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _index2.default.numberFormat(+data.init),
	                adjustInit && (data.init || data.init === 0) ? _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red' } },
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: '#505659' } },
	                    '( '
	                  ),
	                  '\u8C03\u6574\u540E\uFF1A',
	                  _index2.default.numberFormat(adjustInit + +data.init),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: '#505659' } },
	                    ' )'
	                  )
	                ) : ''
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u76EE\u6807\u6536\u5165' },
	              _index2.default.numberFormat(+data.aims)
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u5E74\u5EA6' },
	              year
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u4F59\u989D' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _index2.default.numberFormat(+data.current),
	                data.freeze ? _react2.default.createElement(
	                  'span',
	                  { style: { color: '#BCBCBC' } },
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: '#505659' } },
	                    '( '
	                  ),
	                  '\u51BB\u7ED3',
	                  _index2.default.numberFormat(+data.freeze),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: '#505659' } },
	                    ' )'
	                  )
	                ) : ''
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5B9E\u9645\u6536\u5165' },
	              _index2.default.numberFormat(+data.income)
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center', padding: '30px 0' } },
	            '\u9884\u7B97\u8C03\u6574\u660E\u7EC6'
	          ),
	          content.map(function (item, index) {
	            return _this3.adjustItem(item, index);
	          })
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              isInitiate ? null : _react2.default.createElement(_ProcessHistory2.default, { dataSource: data.histories })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    adjust_data: state.adjust_data
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(BaseForm));

/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.toPage = function (record) {
	      _this.props.router.push({
	        pathname: '/finance/budget/' + record.uuid + '/' + record.year + '/adjust/info'
	      });
	    };
	
	    _this.columns = function () {
	      var pagination = _this.props.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      return [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '流水编号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { onClick: function onClick() {
	                return _this.toPage(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: '预算组名称',
	        dataIndex: 'groupName',
	        key: 'groupName'
	      }, {
	        title: '预算年度',
	        dataIndex: 'year',
	        key: 'year'
	      }, {
	        title: '预算调整金额',
	        dataIndex: 'adjustment',
	        key: 'adjustment',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text || '-'
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text || '-'
	          );
	        }
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : '-'
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'long',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var todoElement = record.instance ? _react2.default.createElement(
	            'span',
	            null,
	            '\u5BA1\u6838\u4E2D'
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u7F16\u8F91'
	          );
	          return instance.status === 1 ? _react2.default.createElement(
	            'span',
	            { style: { color: 'red' } },
	            '\u5DF2\u5B8C\u6210'
	          ) : todoElement;
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          loading = _props.loading,
	          _props$dataSource = _props.dataSource,
	          list = _props$dataSource.list,
	          pagination = _props$dataSource.pagination;
	
	      return _react2.default.createElement(_antd.Table, {
	        columns: this.columns(),
	        dataSource: list,
	        pagination: pagination,
	        rowKey: 'uuid',
	        loading: loading,
	        onChange: this.handleChange
	      });
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _budget = __webpack_require__(30);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _dict = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadBudgetExpendType = function () {
	      (0, _dict.queryDictExpend)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            expendType: res.data
	          });
	        }
	      });
	    };
	
	    _this.loadDictIncome = function () {
	      (0, _dict.queryDictIncome)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            incomeType: res.data
	          });
	        }
	      });
	    };
	
	    _this.getBudgetGroupAims = function (params) {
	      (0, _budget.queryBudgetGroupAims)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          if (res.data) {
	            _this.setState({
	              sumAimData: res.data
	            });
	          }
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.findTypes = function (typesArr) {
	      var incomeType = _this.state.incomeType;
	
	      var sameItem = incomeType.filter(function (item) {
	        return typesArr.indexOf(item.value) !== -1;
	      });
	      var str = '';
	      sameItem.map(function (item) {
	        str += item.key + ',';
	        return item;
	      });
	      str = str.slice(0, -1);
	      return str;
	    };
	
	    _this.columns = function () {
	      var config = [];
	      var _this$state = _this.state,
	          data = _this$state.data,
	          busCosLen = _this$state.busCosLen,
	          busPoolLen = _this$state.busPoolLen,
	          fixedLen = _this$state.fixedLen,
	          laborLen = _this$state.laborLen;
	
	      for (var i = 1; i <= 12; i++) {
	        var item = {};
	        var key = i < 10 ? '0' + i : '' + i;
	        item.title = i < 10 ? '0' + i : '' + i;
	        item.dataIndex = key;
	        item.key = key;
	        item.width = 100;
	        item.render = function (text) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	          return _react2.default.createElement(
	            'span',
	            null,
	            money === '0.00' ? '' : money
	          );
	        };
	        config.push(item);
	      }
	      config.unshift({
	        title: '合计',
	        dataIndex: 'sum',
	        key: 'sum',
	        width: 150,
	        render: function render(text) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	          return _react2.default.createElement(
	            'span',
	            null,
	            money === '0.00' ? '' : money
	          );
	        }
	      });
	      config.unshift({
	        title: '费用科目',
	        dataIndex: 'type',
	        key: 'type',
	        width: 150,
	        render: function render(text, record, index) {
	          var obj = {
	            children: _react2.default.createElement(
	              'span',
	              null,
	              _this.matchType(text)
	            ),
	            props: {}
	          };
	          if (index === data.length - 1) {
	            obj.props.colSpan = 0;
	          }
	          return obj;
	        }
	      });
	      config.unshift({
	        title: '二级科目',
	        dataIndex: 'sub',
	        key: 'sub',
	        width: 150,
	        render: function render(text, record, index) {
	          var sub = '';
	          if (record.flag === 1) {
	            sub = '人力成本';
	          } else if (record.flag === 2) {
	            sub = '业务成本';
	          } else if (record.flag === 3) {
	            sub = '固定公摊';
	          } else if (record.flag === 4) {
	            sub = '业务公摊';
	          } else if (record.flag === 5) {
	            sub = '合计';
	          }
	          var obj = {
	            children: _react2.default.createElement(
	              'span',
	              null,
	              sub
	            ),
	            props: {}
	          };
	          if (laborLen !== 0 && index === 0) {
	            obj.props.rowSpan = laborLen; // 合并业务公摊
	          } else if (index > 0 && index < laborLen) {
	            obj.props.rowSpan = 0;
	          } else if (busCosLen !== 0 && index === laborLen) {
	            obj.props.rowSpan = busCosLen; // 合并业务成本
	          } else if (index > laborLen && index < laborLen + busCosLen) {
	            obj.props.rowSpan = 0;
	          } else if (fixedLen !== 0 && index === laborLen + busCosLen) {
	            obj.props.rowSpan = fixedLen; // 合并固定公摊
	          } else if (busCosLen !== 0 && index > laborLen + busCosLen && index < laborLen + busCosLen + fixedLen) {
	            obj.props.rowSpan = 0;
	          } else if (busPoolLen !== 0 && index === fixedLen + busCosLen + laborLen) {
	            obj.props.rowSpan = busPoolLen;
	          } else if (index > busPoolLen + busCosLen + laborLen && index < busPoolLen + busCosLen + fixedLen + laborLen) {
	            obj.props.rowSpan = 0;
	          } else {
	            obj.props.colSpan = 2;
	          }
	          return obj;
	        }
	      });
	      config.unshift({
	        title: '一级科目',
	        dataIndex: 'main',
	        key: 'main',
	        width: 150,
	        render: function render(text, record, index) {
	          var obj = {
	            children: _react2.default.createElement(
	              'span',
	              null,
	              '\u8FD0\u8425\u6210\u672C'
	            ),
	            props: {}
	          };
	          if (index === 0) {
	            obj.props.rowSpan = data.length;
	          } else {
	            obj.props.rowSpan = 0;
	          }
	          return obj;
	        }
	      });
	      return config;
	    };
	
	    _this.matchType = function (value) {
	      var type = void 0;
	      _this.state.expendType.map(function (item) {
	        if (item.value === value) {
	          type = item.key;
	          return item;
	        }
	        return type;
	      });
	      return type;
	    };
	
	    _this.state = {
	      data: [],
	      groupName: '',
	      year: '',
	      sumAimData: {},
	      expendType: [],
	      incomeType: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.loadBudgetExpendType();
	      this.loadDictIncome();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var detail = nextProps.data.detail || {
	        BUSINESS_COSTS: [],
	        BUSINESS_POOL: [],
	        FIXED_POOL: [],
	        LABOR_COSTS: [],
	        SUM: {
	          SUM: 0,
	          flag: 5,
	          sum: 0
	        }
	      };
	      this.setState({
	        isLoading: true
	      });
	      var data = [];
	      data = data.concat(detail.LABOR_COSTS);
	      data = data.concat(detail.BUSINESS_COSTS);
	      data = data.concat(detail.FIXED_POOL);
	      data = data.concat(detail.BUSINESS_POOL);
	
	      detail.SUM.flag = 5;
	      if (data.length > 0) {
	        data = data.concat(detail.SUM);
	      }
	      this.setState({
	        sum: detail.SUM.SUM,
	        data: data,
	        isLoading: false,
	        groupName: nextProps.data.groupName,
	        year: nextProps.data.year,
	        busCosLen: detail.BUSINESS_COSTS.length,
	        busPoolLen: detail.BUSINESS_POOL.length,
	        fixedLen: detail.FIXED_POOL.length,
	        laborLen: detail.LABOR_COSTS.length
	      });
	
	      this.getBudgetGroupAims({
	        groupUuid: nextProps.data.groupUuid,
	        year: nextProps.data.year
	      });
	    }
	
	    // 获得支出资金类型
	
	
	    // 获得收入资金类型
	
	
	    // 获得目标收入
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          data = _state.data,
	          sum = _state.sum,
	          groupName = _state.groupName,
	          year = _state.year,
	          sumAimData = _state.sumAimData;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u9884\u7B97\u90E8\u95E8\uFF1A'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                groupName
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u9884\u7B97\u5468\u671F\uFF1A'
	              ),
	              year ? _react2.default.createElement(
	                'span',
	                null,
	                year,
	                '\u5E74'
	              ) : null
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u9884\u7B97\u603B\u989D\uFF1A'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _util2.default.numberFormat(sum, 2, '.', ','),
	                '\u5143'
	              )
	            )
	          )
	        ),
	        sumAimData.sumAim ? _react2.default.createElement(
	          _antd.Card,
	          {
	            title: '\u76EE\u6807\u6536\u5165\uFF1A' + _util2.default.numberFormat(sumAimData.sumAim),
	            style: { marginTop: '20px' }
	          },
	          sumAimData.aims.length ? _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            sumAimData.aims.map(function (item) {
	              return _react2.default.createElement(
	                Description,
	                { term: function term() {
	                    return _this2.findTypes(item.types);
	                  }, key: item.uuid },
	                _util2.default.numberFormat(item.aim, 2, '.', ',')
	              );
	            })
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u6682\u65E0\u5177\u4F53\u7C7B\u76EE\u76EE\u6807\u6536\u5165'
	          )
	        ) : null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_antd.Table, {
	            rowKey: function rowKey(record) {
	              return record.index;
	            },
	            columns: this.columns(),
	            dataSource: data,
	            pagination: false,
	            loading: isLoading,
	            style: { marginTop: '20px' },
	            bordered: true,
	            size: 'small',
	            scroll: { x: 1800, y: _util2.default.pageHeight() - 120 }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.toPage = function (record) {
	      _this.props.router.push({
	        pathname: '/finance/budget/' + record.uuid + '/set_manage/detail'
	      });
	    };
	
	    _this.columns = function () {
	      var pagination = _this.props.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      return [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '流水编号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { onClick: function onClick() {
	                return _this.toPage(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: '预算组名称',
	        dataIndex: 'groupName',
	        key: 'groupName'
	      }, {
	        title: '预算年度',
	        dataIndex: 'year',
	        key: 'year'
	      }, {
	        title: '预算总额',
	        dataIndex: 'budget',
	        key: 'budget'
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text || '-'
	          );
	        }
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : '暂无数据'
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'long',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var element = record.instance ? _react2.default.createElement(
	            'span',
	            null,
	            '\u5BA1\u6838\u4E2D'
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u7F16\u8F91'
	          );
	          return instance.status === 1 ? _react2.default.createElement(
	            'span',
	            { style: { color: 'red' } },
	            '\u5DF2\u5B8C\u6210'
	          ) : element;
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$dataSource = _props.dataSource,
	          list = _props$dataSource.list,
	          pagination = _props$dataSource.pagination,
	          loading = _props.loading;
	
	      return _react2.default.createElement(_antd.Table, {
	        columns: this.columns(),
	        dataSource: list,
	        pagination: pagination,
	        rowKey: 'uuid',
	        loading: loading,
	        onChange: this.handleChange
	      });
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _finance = __webpack_require__(61);
	
	var _dict = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadioGroup = _antd.Radio.Group;
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var DetailModal = function (_Component) {
	  _inherits(DetailModal, _Component);
	
	  function DetailModal(props) {
	    _classCallCheck(this, DetailModal);
	
	    var _this = _possibleConstructorReturn(this, (DetailModal.__proto__ || Object.getPrototypeOf(DetailModal)).call(this, props));
	
	    _this.loadInfo = function (uuid) {
	      (0, _finance.queryBooksIncomeInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ content: res.data });
	          if (res.data.target === 0) {
	            _this.loadDictExpend();
	          } else if (res.data.target === 1) {
	            _this.loadDictIncome();
	          }
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadDictExpend = function () {
	      (0, _dict.queryDictExpend)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            type: res.data
	          });
	        }
	      });
	    };
	
	    _this.loadDictIncome = function () {
	      (0, _dict.queryDictIncome)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            type: res.data
	          });
	        }
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var income = _this.props.form.getFieldsValue();
	      var obj = {};
	      obj.uuid = _this.props.uuid;
	      obj.ignoreFlag = income.ignoreFlag;
	      obj.type = income.type;
	      obj.remark = income.remark;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          (0, _finance.querySaveBooksIncome)(obj).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              _this.props.handleSubmit(obj);
	            } else {
	              _antd.message.error(res.message);
	            }
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      content: {},
	      isComLeader: false,
	      type: [],
	      readOnly: false
	    };
	    return _this;
	  }
	
	  _createClass(DetailModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var uuid = this.props.uuid;
	      var readOnly = this.props.readOnly;
	
	      if (readOnly) {
	        this.setState({
	          readOnly: true
	        });
	      }
	      var role = this.props.account_info.roles;
	      if (uuid) {
	        this.loadInfo(uuid);
	      }
	      var isComLeader = role.some(function (item) {
	        return item.sign === '[ComLeader]';
	      });
	      this.setState({
	        isComLeader: isComLeader
	      });
	    }
	
	    /**
	     * 获取收入类别
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	      var _state = this.state,
	          content = _state.content,
	          isComLeader = _state.isComLeader,
	          readOnly = _state.readOnly;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u6536\u652F\u8BB0\u5F55', visible: true, onCancel: this.props.cancel, onOk: this.submit },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'horizontal' },
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u8D44\u91D1\u65B9\u5411' }, formItemLayout),
	            getFieldDecorator('target', {
	              rules: [{ required: true, message: '请选择资金流向' }],
	              initialValue: '' + content.target
	            })(_react2.default.createElement(
	              RadioGroup,
	              { disabled: true },
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: '1' },
	                '\u6536\u5165'
	              ),
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: '0' },
	                '\u652F\u51FA'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u6536\u652F\u7C7B\u578B' }, formItemLayout),
	            getFieldDecorator('type', {
	              rules: [{ required: true, message: '请选择收支类型' }],
	              initialValue: content.type
	            })(_react2.default.createElement(
	              _antd.Select,
	              { style: { fontSize: '14px' }, disabled: readOnly },
	              this.state.type.map(function (item) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item.value, value: item.value },
	                  item.key
	                );
	              })
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u91D1\u989D' }, formItemLayout),
	            getFieldDecorator('money', {
	              rules: [{ required: true, message: '请输入初始资金' }],
	              initialValue: content.target === '0' ? content.paymoney : content.money
	            })(_react2.default.createElement(_antd.Input, { disabled: true, addonAfter: '\u5143', type: 'number' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u6536\u652F\u65E5\u671F' }, formItemLayout),
	            getFieldDecorator('date', {
	              rules: [{ required: true, message: '请选择发生日期' }],
	              initialValue: content.date ? _moment2.default.unix(content.date / 1000) : (0, _moment2.default)()
	            })(_react2.default.createElement(_antd.DatePicker, { disabled: true }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u6458\u8981' }, formItemLayout),
	            getFieldDecorator('remark', {
	              initialValue: content.remark
	            })(_react2.default.createElement(_antd.Input, { type: 'textarea', rows: 4, disabled: readOnly }))
	          ),
	          isComLeader ? _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u8D44\u91D1\u5FFD\u7565' }, formItemLayout),
	            getFieldDecorator('ignoreFlag', {
	              initialValue: content.ignoreFlag
	            })(_react2.default.createElement(
	              RadioGroup,
	              null,
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: 0, disabled: readOnly },
	                '\u4E0D\u5FFD\u7565'
	              ),
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: 1, disabled: readOnly },
	                '\u975E\u4E1A\u52A1\u6570\u636E'
	              ),
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: 2, disabled: readOnly },
	                '\u8D70\u8D26\u6570\u636E'
	              )
	            ))
	          ) : ''
	        )
	      );
	    }
	  }]);
	
	  return DetailModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { account_info: state.account_info };
	})(_antd.Form.create({ wrappedComponentRef: true })(DetailModal));

/***/ },
/* 700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _apportion = __webpack_require__(166);
	
	var _attachment = __webpack_require__(27);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _ModalApportion = __webpack_require__(427);
	
	var _ModalApportion2 = _interopRequireDefault(_ModalApportion);
	
	var _BackBtn = __webpack_require__(12);
	
	var _budget = __webpack_require__(30);
	
	var _showDescDoc = __webpack_require__(432);
	
	var _showDescDoc2 = _interopRequireDefault(_showDescDoc);
	
	var _showBudgetDescDoc = __webpack_require__(431);
	
	var _showBudgetDescDoc2 = _interopRequireDefault(_showBudgetDescDoc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	var RadioButton = _antd.Radio.Button;
	var RadioGroup = _antd.Radio.Group;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.getBudgetGroup = function () {
	      (0, _budget.queryBudgetGroupMy)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            group: res.data
	          });
	        }
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handSubmit = _this$props.handSubmit,
	          data = _this$props.data;
	
	      var expenses = Object.assign({}, data, _this.props.form.getFieldsValue());
	      if (_this.apportion) {
	        expenses.apportion = _this.apportion;
	      }
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handSubmit(expenses);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function () {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.handleCompanyChange = function (value, option) {
	      _this.props.form.setFieldsValue({
	        company: option.props.children
	      });
	    };
	
	    _this.start = function (e) {
	      _this.submit(e, null, 'start');
	    };
	
	    _this.getBudgetGroupCandF = function (value) {
	      (0, _budget.queryBudgetGroupCandF)({
	        userUuid: _this.props.accountInfo.userUuid,
	        type: value
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            groupTip: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.apportionIsPublic = function (value) {
	      (0, _apportion.queryApportionIsPublic)({
	        type: value
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            isPublic: res.data.isPublic
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleTypeChange = function (value, option) {
	      _this.getBudgetGroupCandF(value);
	      _this.apportionIsPublic(value);
	      _this.props.form.setFieldsValue({
	        typeName: option.props.children
	      });
	    };
	
	    _this.handleBugetChange = function () {
	      var data = _this.props.form.getFieldsValue();
	      if (data.type && data.price) {
	        _this.setState({
	          dataInfo: data
	        });
	        _this.handleVisible(true);
	      } else {
	        _antd.message.info('请先将报销类型和报销金额填写完整！');
	      }
	    };
	
	    _this.handleRadioChange = function (e) {
	      _this.setState({
	        isRadio: e.target.value
	      });
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handleOk = function (params) {
	      _this.apportion = params;
	      _this.handleVisible(false);
	    };
	
	    _this.descTitle = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u62A5\u9500\u7C7B\u578B',
	        _react2.default.createElement(_showDescDoc2.default, null)
	      );
	    };
	
	    _this.descBudgetTitle = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u9884\u7B97\u6765\u6E90',
	        _react2.default.createElement(_showBudgetDescDoc2.default, null)
	      );
	    };
	
	    _this.state = {
	      isRadio: '0',
	      visible: false,
	      isPublic: false,
	      dataInfo: {},
	      groupTip: {},
	      delFiles: [],
	      group: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      data.uuid && this.getBudgetGroupCandF(data.type);
	      this.getBudgetGroup();
	    }
	
	    /**
	     *文件删除
	     */
	
	
	    // 用款类型说明性title
	
	
	    // 预算来源说明性title
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          expendType = _props.expendType,
	          isSubmitting = _props.isSubmitting;
	      var _state = this.state,
	          visible = _state.visible,
	          dataInfo = _state.dataInfo,
	          group = _state.group,
	          groupTip = _state.groupTip,
	          isPublic = _state.isPublic,
	          isRadio = _state.isRadio;
	
	      var dataItem = this.props.data;
	      getFieldDecorator('company', { initialValue: dataItem.company });
	      getFieldDecorator('typeName');
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: this.start,
	              loading: isSubmitting
	            },
	            '\u53D1\u8D77\u7533\u8BF7'
	          ),
	          dataItem.uuid ? _react2.default.createElement(
	            _antd.Button,
	            { icon: 'delete', style: { marginRight: 10 }, onClick: this.props.handleDelete },
	            '\u5220\u9664'
	          ) : null
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10, style: { position: 'relative' } },
	              _react2.default.createElement(
	                _antd.Row,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: this.descTitle() }, ItemLayout, { style: { position: 'relative' } }),
	                  getFieldDecorator('type', {
	                    rules: [{ required: true, message: '请选择报销类型' }],
	                    initialValue: dataItem.type
	                  })(_react2.default.createElement(
	                    _antd.Select,
	                    {
	                      showSearch: true,
	                      onChange: this.handleTypeChange,
	                      filterOption: function filterOption(input, option) {
	                        return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                      }
	                    },
	                    expendType.map(function (item) {
	                      return _react2.default.createElement(
	                        Option,
	                        { key: item.value },
	                        item.key
	                      );
	                    })
	                  ))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Row,
	                { style: { position: 'absolute', top: '35px', width: '100%' } },
	                _react2.default.createElement(_antd.Col, { span: 8 }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  isRadio === '0' && groupTip.groupName ? _react2.default.createElement(
	                    'span',
	                    { style: { color: 'red' } },
	                    '\u8BE5\u8D39\u7528\u7C7B\u578B:',
	                    groupTip.groupName,
	                    '\u53EF\u7528\u4F59\u989D',
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      groupTip.current || 0
	                    ),
	                    '\u5143',
	                    groupTip.freeze ? _react2.default.createElement(
	                      'span',
	                      null,
	                      ', \u51BB\u7ED3',
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        groupTip.freeze || 0
	                      )
	                    ) : null
	                  ) : null
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u62A5\u9500\u91D1\u989D' }, ItemLayout),
	                getFieldDecorator('price', {
	                  rules: [{ required: true, message: '请输入报销金额!' }],
	                  initialValue: dataItem.price
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u62A5\u9500\u91D1\u989D', addonAfter: '\u5143', type: 'number' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: this.descBudgetTitle() }, ItemLayout),
	                getFieldDecorator('budgetType', {
	                  rules: [{ required: true, message: '请输入报销金额!' }],
	                  initialValue: dataItem.budgetType ? '1' : '0'
	                })(_react2.default.createElement(
	                  RadioGroup,
	                  { onChange: this.handleRadioChange },
	                  _react2.default.createElement(
	                    RadioButton,
	                    { value: '0' },
	                    '\u672C\u90E8\u95E8\u9884\u7B97'
	                  ),
	                  _react2.default.createElement(
	                    RadioButton,
	                    { value: '1', onClick: this.handleBugetChange },
	                    '\u8DE8\u90E8\u95E8\u9884\u7B97'
	                  ),
	                  group.map(function (item) {
	                    return _react2.default.createElement(
	                      RadioButton,
	                      { value: item.value, key: item.value },
	                      item.name
	                    );
	                  })
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u62A5\u9500\u516C\u53F8' }, ItemLayout),
	                getFieldDecorator('companyUuid', {
	                  rules: [{ required: true, message: '请选择报销公司' }],
	                  initialValue: dataItem.companyUuid
	                })(_react2.default.createElement(_companySearch2.default, Object.assign({
	                  companyName: dataItem.company,
	                  companyUuid: dataItem.companyUuid,
	                  onChange: this.handleCompanyChange
	                }, this.props)))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u62A5\u9500\u8BF4\u660E', labelCol: { span: 4 }, wrapperCol: { span: 18 } },
	                getFieldDecorator('reason', {
	                  initialValue: dataItem.reason
	                })(_react2.default.createElement(_antd.Input.TextArea, {
	                  placeholder: '\u5907\u6CE8',
	                  type: 'textarea',
	                  autosize: { minRows: 3, maxRows: 9 },
	                  maxLength: 1000
	                })),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '12px', color: '#999' } },
	                  '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u62A5\u9500\u51ED\u8BC1' }, ItemLayout),
	                getFieldDecorator('files', {
	                  rules: [{ required: true, message: '请上传报销凭证' }],
	                  initialValue: dataItem.files || []
	                })(_react2.default.createElement(_UploadFile2.default, {
	                  type: 'ghost',
	                  fileList: dataItem.file,
	                  onRemove: this.fileRemove,
	                  isPreview: true
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7533\u8BF7\u4EBA' }, ItemLayout),
	                getFieldDecorator('crName', {
	                  initialValue: dataItem.createUserName
	                })(_react2.default.createElement(
	                  'span',
	                  null,
	                  this.props.accountInfo.userName
	                ))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_ModalApportion2.default, {
	          onCancel: this.handleVisible,
	          dataInfo: dataInfo,
	          dataItem: dataItem,
	          isPublic: isPublic,
	          visible: visible,
	          onOk: this.handleOk,
	          company: this.props.company,
	          expendType: this.props.expendType
	        })
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list,
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(BaseForm));

/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '报销单号',
	        dataIndex: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/e_manage/open/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '报销公司',
	        dataIndex: 'company',
	        key: 'company'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5BA1\u6838\u4E2D'
	            );
	          }
	          if (record.status === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u7F16\u8F91'
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(_antd.Table, {
	        rowKey: 'uuid',
	        columns: this.columns(),
	        loading: this.props.loading,
	        dataSource: list,
	        pagination: pagination,
	        onChange: this.handleChange
	      });
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _TableRecordByOrg = __webpack_require__(1631);
	
	var _TableRecordByOrg2 = _interopRequireDefault(_TableRecordByOrg);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleDrawer = function (org) {
	      _this.setState({
	        org: org
	      });
	      _this.handleVisible(true);
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: "公司名称",
	        dataIndex: "company",
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            "a",
	            { onClick: function onClick() {
	                return _this.handleDrawer(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: "报销次数",
	        dataIndex: "count"
	      }, {
	        title: "报销总金额",
	        dataIndex: "sum"
	      }, {
	        title: "报销进行中",
	        dataIndex: "doing",
	        key: "doing"
	      }, {
	        title: "报销已完成",
	        dataIndex: "done",
	        key: "done"
	      }];
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource,
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          _state$dataSource = _state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination,
	          visible = _state.visible,
	          org = _state.org;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: list,
	          pagination: pagination,
	          rowKey: "companyUuid"
	        }),
	        visible ? _react2.default.createElement(_TableRecordByOrg2.default, { org: org, handleVisible: this.handleVisible }) : null
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = Manage;

/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _dict = __webpack_require__(64);
	
	var _attachment = __webpack_require__(27);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.getInvoiceType = function () {
	      (0, _dict.queryInvoiceType)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            invoiceType: res.data
	          });
	        }
	      });
	    };
	
	    _this.getInvoiceContent = function () {
	      (0, _dict.queryInvoiceContent)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            invoiceContent: res.data
	          });
	        }
	      });
	    };
	
	    _this.start = function (e) {
	      _this.submit(e, null, 'start');
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handSubmit = _this$props.handSubmit,
	          data = _this$props.data;
	
	      var params = Object.assign({}, data, _this.props.form.getFieldsValue());
	      params.link = params.links;
	      delete params.links;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handSubmit(params);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function () {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.handleCompanyChange = function (value, option) {
	      _this.props.form.setFieldsValue({
	        income: option.props.children
	      });
	    };
	
	    _this.handleTypeChange = function (e) {
	      _this.type = e;
	      _this.setState({
	        type: e
	      });
	    };
	
	    _this.state = {
	      type: props.data.type || '0',
	      invoiceType: [],
	      invoiceContent: [],
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getInvoiceType();
	      this.getInvoiceContent();
	    }
	
	    /**
	     *文件删除
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataItem = this.props.data;
	      var isSubmitting = this.props.isSubmitting;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _state = this.state,
	          type = _state.type,
	          invoiceType = _state.invoiceType,
	          invoiceContent = _state.invoiceContent;
	
	      getFieldDecorator('income', { initialValue: dataItem.income });
	      var ItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 16 }
	      };
	      var ItemLayout2 = {
	        labelCol: { span: 3 },
	        wrapperCol: { span: 20 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: this.start,
	              loading: isSubmitting
	            },
	            '\u53D1\u8D77\u7533\u8BF7'
	          ),
	          dataItem.uuid ? _react2.default.createElement(
	            _antd.Button,
	            { icon: 'delete', style: { marginRight: 10 }, onClick: this.props.handleDelete },
	            '\u5220\u9664'
	          ) : null
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u5F00\u7968\u7533\u8BF7' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F00\u7968\u7C7B\u578B' }, ItemLayout),
	                getFieldDecorator('type', {
	                  rules: [{ required: true, message: '请选择开票类型!' }],
	                  initialValue: dataItem.uuid ? dataItem.type : '0'
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { onChange: this.handleTypeChange },
	                  invoiceType.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.value },
	                      item.key
	                    );
	                  })
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5165\u8D26\u516C\u53F8' }, ItemLayout),
	                getFieldDecorator('incomeUuid', {
	                  rules: [{ required: true, message: '请选择入账公司' }],
	                  initialValue: dataItem ? dataItem.incomeUuid : null
	                })(_react2.default.createElement(_companySearch2.default, Object.assign({
	                  onChange: this.handleCompanyChange,
	                  companyName: dataItem ? dataItem.income : null,
	                  companyUuid: dataItem ? dataItem.incomeUuid : null
	                }, this.props)))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8D2D\u8D27\u516C\u53F8' }, ItemLayout),
	                getFieldDecorator('company', {
	                  rules: [{ required: true, message: '请输入购货公司' }],
	                  initialValue: dataItem ? dataItem.company : null
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              type === '0' || type === '1' ? _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7' }, ItemLayout),
	                getFieldDecorator('idCode', {
	                  rules: [{ required: true, message: '请输入纳税人识别号!' }],
	                  initialValue: dataItem ? dataItem.idCode : null
	                })(_react2.default.createElement(_antd.Input, null))
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F00\u7968\u5185\u5BB9' }, ItemLayout),
	                getFieldDecorator('content', {
	                  rules: [{ required: true, message: '请输入开票内容!' }],
	                  initialValue: dataItem ? dataItem.content : ''
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  null,
	                  invoiceContent.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.value },
	                      item.key
	                    );
	                  })
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              type === '0' ? _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5730\u5740\u53CA\u7535\u8BDD' }, ItemLayout),
	                getFieldDecorator('links', {
	                  rules: [{ required: true, message: '请输入地址及电话!' }],
	                  initialValue: dataItem ? dataItem.link : null
	                })(_react2.default.createElement(_antd.Input, null))
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F00\u7968\u91D1\u989D' }, ItemLayout),
	                getFieldDecorator('price', {
	                  rules: [{
	                    required: true,
	                    message: '请输入开票金额!'
	                  }],
	                  initialValue: dataItem ? dataItem.price : ''
	                })(_react2.default.createElement(_antd.InputNumber, { style: { width: '100%' } }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              type === '0' ? _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F00\u6237\u884C\u53CA\u5E10\u53F7' }, ItemLayout),
	                getFieldDecorator('bankCode', {
	                  rules: [{ required: true, message: '请输入开户行及帐号!' }],
	                  initialValue: dataItem ? dataItem.bankCode : null
	                })(_react2.default.createElement(_antd.Input, null))
	              ) : null
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u7533\u8BF7\u9644\u4EF6', labelCol: { span: 3 }, wrapperCol: { span: 5 } },
	                getFieldDecorator('files', {
	                  initialValue: dataItem ? dataItem.files : null
	                })(_react2.default.createElement(_UploadFile2.default, {
	                  type: 'ghost',
	                  fileList: dataItem.file,
	                  style: { width: '60%' },
	                  onRemove: this.fileRemove,
	                  isPreview: true
	                }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F00\u7968\u8BF4\u660E' }, ItemLayout2),
	                getFieldDecorator('reason', {
	                  rules: [{ required: true, message: '请输入开票说明!' }],
	                  initialValue: dataItem ? dataItem.reason : ''
	                })(_react2.default.createElement(_antd.Input.TextArea, {
	                  placeholder: '\u8BF7\u8F93\u5165\u672C\u6B21\u7533\u8BF7\u5F00\u7968\u7684\u8BF4\u660E',
	                  type: 'textarea',
	                  autosize: { minRows: 3, maxRows: 9 },
	                  maxLength: 1000
	                })),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '12px', color: '#999' } },
	                  '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F00\u7968\u5907\u6CE8' }, ItemLayout2),
	                getFieldDecorator('remark', {
	                  initialValue: dataItem ? dataItem.remark : ''
	                })(_react2.default.createElement(_antd.Input.TextArea, {
	                  placeholder: '\u8BF7\u8F93\u5165\u5728\u53D1\u7968\u4E0A\u663E\u793A\u7684\u5F00\u7968\u5907\u6CE8\u4FE1\u606F',
	                  type: 'textarea',
	                  autosize: { minRows: 3, maxRows: 9 },
	                  maxLength: 1000
	                })),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '12px', color: '#999' } },
	                  '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    incuInfo: state.incubator_base
	  };
	})(_antd.Form.create({})(BaseForm));

/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(36);
	
	var _ModalInvalid = __webpack_require__(1640);
	
	var _ModalInvalid2 = _interopRequireDefault(_ModalInvalid);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.showModalInvalid = function (data) {
	      _this.setState({
	        modalInvalidVisible: true,
	        data: data
	      });
	    };
	
	    _this.cancelModalInvalid = function () {
	      _this.setState({
	        modalInvalidVisible: false
	      });
	    };
	
	    _this.submitInvalid = function (value, data) {
	      var params = {
	        uuids: [data.uuid],
	        reason: value.reason
	      };
	      _this.props.invoiceInvalid(params);
	      _this.cancelModalInvalid();
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '开票单号',
	        dataIndex: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/i_manage/open/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '开票公司',
	        dataIndex: 'company',
	        key: 'company'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          switch (record.status) {
	            case 0:
	              return _react2.default.createElement(
	                'span',
	                null,
	                '\u5BA1\u6838\u4E2D'
	              );
	            case 1:
	              if (record.invalid) {
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  '\u5DF2\u4F5C\u5E9F'
	                );
	              }
	              return _react2.default.createElement(
	                'span',
	                { style: { color: 'red' } },
	                '\u5DF2\u5B8C\u6210'
	              );
	
	            default:
	              return _react2.default.createElement(
	                'span',
	                null,
	                '\u5F85\u7F16\u8F91'
	              );
	          }
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            record.status === 1 && !record.invalid && _this.props.type !== 'mine' ? _react2.default.createElement(
	              _reactRouter.Link,
	              { onClick: function onClick() {
	                  return _this.showModalInvalid(record);
	                } },
	              '\u53D1\u7968\u4F5C\u5E9F'
	            ) : null,
	            record.invalid ? _react2.default.createElement(
	              _antd.Popover,
	              { content: record.invalidReason },
	              _react2.default.createElement(
	                'a',
	                null,
	                '\u4F5C\u5E9F\u539F\u56E0'
	              )
	            ) : null
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource,
	      modalInvalidVisible: false,
	      data: {}
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	
	    // table分页跳转
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          _state$dataSource = _state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination,
	          modalInvalidVisible = _state.modalInvalidVisible,
	          data = _state.data;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          dataSource: list,
	          pagination: pagination,
	          columns: this.columns(),
	          loading: this.props.loading,
	          onChange: this.handleChange
	        }),
	        modalInvalidVisible ? _react2.default.createElement(_ModalInvalid2.default, Object.assign({
	          data: data,
	          visible: modalInvalidVisible,
	          onCancel: this.cancelModalInvalid,
	          onOk: this.submitInvalid
	        }, this.props)) : null
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _TableRecordByOrg = __webpack_require__(1649);
	
	var _TableRecordByOrg2 = _interopRequireDefault(_TableRecordByOrg);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleDrawer = function (org) {
	      _this.setState({
	        org: org
	      });
	      _this.handleVisible(true);
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: "公司名称",
	        dataIndex: "company",
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            "a",
	            { onClick: function onClick() {
	                return _this.handleDrawer(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: "开票次数",
	        dataIndex: "count"
	      }, {
	        title: "开票总金额",
	        dataIndex: "sum"
	      }, {
	        title: "开票进行中",
	        dataIndex: "doing",
	        key: "doing"
	      }, {
	        title: "开票已完成",
	        dataIndex: "done",
	        key: "done"
	      }];
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource,
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          _state$dataSource = _state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination,
	          visible = _state.visible,
	          org = _state.org;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: list,
	          pagination: pagination,
	          rowKey: "companyUuid"
	        }),
	        visible ? _react2.default.createElement(_TableRecordByOrg2.default, { org: org, handleVisible: this.handleVisible }) : null
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = Manage;

/***/ },
/* 706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _apportion = __webpack_require__(166);
	
	var _attachment = __webpack_require__(27);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _ModalApportion = __webpack_require__(427);
	
	var _ModalApportion2 = _interopRequireDefault(_ModalApportion);
	
	var _BackBtn = __webpack_require__(12);
	
	var _budget = __webpack_require__(30);
	
	var _showBudgetDescDoc = __webpack_require__(431);
	
	var _showBudgetDescDoc2 = _interopRequireDefault(_showBudgetDescDoc);
	
	var _showDescDoc = __webpack_require__(432);
	
	var _showDescDoc2 = _interopRequireDefault(_showDescDoc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	var RadioButton = _antd.Radio.Button;
	var RadioGroup = _antd.Radio.Group;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.getBudgetGroup = function () {
	      (0, _budget.queryBudgetGroupMy)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            group: res.data
	          });
	        }
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handSubmit = _this$props.handSubmit,
	          data = _this$props.data;
	
	      var expenses = Object.assign({}, data, _this.props.form.getFieldsValue());
	      if (_this.apportion) {
	        expenses.apportion = _this.apportion;
	      }
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handSubmit(expenses);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function () {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.handleCompanyChange = function (value, option) {
	      _this.props.form.setFieldsValue({
	        company: option.props.children
	      });
	    };
	
	    _this.start = function (e) {
	      _this.submit(e, null, 'start');
	    };
	
	    _this.getBudgetGroupCandF = function (value) {
	      (0, _budget.queryBudgetGroupCandF)({
	        userUuid: _this.props.accountInfo.userUuid,
	        type: value
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            groupTip: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.apportionIsPublic = function (value) {
	      (0, _apportion.queryApportionIsPublic)({
	        type: value
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            isPublic: res.data.isPublic
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleTypeChange = function (value, option) {
	      _this.getBudgetGroupCandF(value);
	      _this.apportionIsPublic(value);
	      _this.props.form.setFieldsValue({
	        typeName: option.props.children
	      });
	    };
	
	    _this.handleBugetChange = function () {
	      var data = _this.props.form.getFieldsValue();
	      if (data.type && data.price) {
	        _this.setState({
	          dataInfo: data
	        });
	        _this.handleVisible(true);
	      } else {
	        _antd.message.info('请先将借款类型和借款金额填写完整！');
	      }
	    };
	
	    _this.handleRadioChange = function (e) {
	      _this.setState({
	        isRadio: e.target.value
	      });
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handleOk = function (params) {
	      _this.apportion = params;
	      _this.handleVisible(false);
	    };
	
	    _this.descTitle = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u501F\u6B3E\u7C7B\u578B',
	        _react2.default.createElement(_showDescDoc2.default, null)
	      );
	    };
	
	    _this.descBudgetTitle = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u9884\u7B97\u6765\u6E90',
	        _react2.default.createElement(_showBudgetDescDoc2.default, null)
	      );
	    };
	
	    _this.state = {
	      isPublic: false,
	      isRadio: '0',
	      dataInfo: {},
	      visible: false,
	      group: [],
	      groupTip: {},
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      data.uuid && this.getBudgetGroupCandF(data.type);
	      this.getBudgetGroup();
	    }
	
	    /**
	     *文件删除
	     */
	
	
	    // 用款类型说明性title
	
	
	    // 预算来源说明性title
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      getFieldDecorator('company');
	      getFieldDecorator('typeName');
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      var ItemLayout2 = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 18 }
	      };
	      var _props = this.props,
	          expendType = _props.expendType,
	          isSubmitting = _props.isSubmitting;
	      var _state = this.state,
	          visible = _state.visible,
	          dataInfo = _state.dataInfo,
	          group = _state.group,
	          groupTip = _state.groupTip,
	          isPublic = _state.isPublic,
	          isRadio = _state.isRadio;
	
	      var dataItem = this.props.data;
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: this.start,
	              loading: isSubmitting
	            },
	            '\u53D1\u8D77\u7533\u8BF7'
	          ),
	          dataItem.uuid ? _react2.default.createElement(
	            _antd.Button,
	            { icon: 'delete', style: { marginRight: 10 }, onClick: this.props.handleDelete },
	            '\u5220\u9664'
	          ) : null
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10, style: { position: 'relative' } },
	              _react2.default.createElement(
	                _antd.Row,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: this.descTitle() }, ItemLayout),
	                  getFieldDecorator('type', {
	                    rules: [{ required: true, message: '请选择借款类型' }],
	                    initialValue: dataItem.type
	                  })(_react2.default.createElement(
	                    _antd.Select,
	                    {
	                      showSearch: true,
	                      onChange: this.handleTypeChange,
	                      filterOption: function filterOption(input, option) {
	                        return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                      }
	                    },
	                    expendType.map(function (item) {
	                      return _react2.default.createElement(
	                        Option,
	                        { key: item.value },
	                        item.key
	                      );
	                    })
	                  ))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Row,
	                { style: { position: 'absolute', top: '35px', width: '100%' } },
	                _react2.default.createElement(_antd.Col, { span: 8 }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  isRadio === '0' && groupTip.groupName ? _react2.default.createElement(
	                    'span',
	                    { style: { color: 'red' } },
	                    '\u8BE5\u8D39\u7528\u7C7B\u578B:',
	                    groupTip.groupName,
	                    '\u53EF\u7528\u4F59\u989D',
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      groupTip.current || 0
	                    ),
	                    '\u5143',
	                    groupTip.freeze ? _react2.default.createElement(
	                      'span',
	                      null,
	                      ', \u51BB\u7ED3',
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        groupTip.freeze || 0
	                      )
	                    ) : null
	                  ) : null
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u501F\u6B3E\u91D1\u989D' }, ItemLayout),
	                getFieldDecorator('price', {
	                  rules: [{ required: true, message: '请输入借款金额!' }],
	                  initialValue: dataItem.price
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u501F\u6B3E\u91D1\u989D', addonAfter: '\u5143', type: 'number' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u501F\u6B3E\u516C\u53F8' }, ItemLayout2),
	                getFieldDecorator('companyUuid', {
	                  rules: [{ required: true, message: '请选择借款公司' }],
	                  initialValue: dataItem.companyUuid
	                })(_react2.default.createElement(_companySearch2.default, Object.assign({
	                  companyName: dataItem.company,
	                  companyUuid: dataItem.companyUuid,
	                  onChange: this.handleCompanyChange
	                }, this.props)))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: this.descBudgetTitle() }, ItemLayout2),
	                getFieldDecorator('budgetType', {
	                  rules: [{ required: true, message: '请选择来源' }],
	                  initialValue: dataItem.budgetType ? '1' : '0'
	                })(_react2.default.createElement(
	                  RadioGroup,
	                  { onChange: this.handleRadioChange },
	                  _react2.default.createElement(
	                    RadioButton,
	                    { value: '0' },
	                    '\u672C\u90E8\u95E8\u9884\u7B97'
	                  ),
	                  _react2.default.createElement(
	                    RadioButton,
	                    { value: '1', onClick: this.handleBugetChange },
	                    '\u8DE8\u90E8\u95E8\u9884\u7B97'
	                  ),
	                  group.map(function (item) {
	                    return _react2.default.createElement(
	                      RadioButton,
	                      { value: item.value, key: item.value },
	                      item.name
	                    );
	                  })
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u501F\u6B3E\u7406\u7531' }, ItemLayout2),
	                getFieldDecorator('reason', {
	                  rules: [{ required: true, message: '请填写借款理由' }],
	                  initialValue: dataItem.reason
	                })(_react2.default.createElement(_antd.Input.TextArea, {
	                  type: 'textarea',
	                  autosize: { minRows: 3, maxRows: 9 },
	                  maxLength: 1000
	                })),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '12px', color: '#999' } },
	                  '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u9644\u4EF6' }, ItemLayout),
	                getFieldDecorator('files', {
	                  initialValue: dataItem.files
	                })(_react2.default.createElement(_UploadFile2.default, {
	                  type: 'ghost',
	                  fileList: dataItem.file,
	                  isPreview: true,
	                  onRemove: this.fileRemove
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7533\u8BF7\u4EBA' }, ItemLayout),
	                getFieldDecorator('crName', {
	                  initialValue: dataItem.createUserName
	                })(_react2.default.createElement(
	                  'span',
	                  null,
	                  this.props.accountInfo.userName
	                ))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_ModalApportion2.default, {
	          onCancel: this.handleVisible,
	          dataInfo: dataInfo,
	          dataItem: dataItem,
	          isPublic: isPublic,
	          visible: visible,
	          onOk: this.handleOk,
	          company: this.props.company,
	          expendType: this.props.expendType
	        })
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list,
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(BaseForm));

/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _TableRecordByOrg = __webpack_require__(1663);
	
	var _TableRecordByOrg2 = _interopRequireDefault(_TableRecordByOrg);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleDrawer = function (org) {
	      _this.setState({
	        org: org
	      });
	      _this.handleVisible(true);
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: "公司名称",
	        dataIndex: "company",
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            "a",
	            { onClick: function onClick() {
	                return _this.handleDrawer(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: "借款次数",
	        dataIndex: "count"
	      }, {
	        title: "借款总金额",
	        dataIndex: "sum"
	      }, {
	        title: "借款进行中",
	        dataIndex: "doing",
	        key: "doing"
	      }, {
	        title: "借款已完成",
	        dataIndex: "done",
	        key: "done"
	      }];
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource,
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          _state$dataSource = _state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination,
	          visible = _state.visible,
	          org = _state.org;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: list,
	          pagination: pagination,
	          rowKey: "companyUuid"
	        }),
	        visible ? _react2.default.createElement(_TableRecordByOrg2.default, { org: org, handleVisible: this.handleVisible }) : null
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = Manage;

/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _apportion = __webpack_require__(166);
	
	var _attachment = __webpack_require__(27);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _ModalApportion = __webpack_require__(427);
	
	var _ModalApportion2 = _interopRequireDefault(_ModalApportion);
	
	var _BackBtn = __webpack_require__(12);
	
	var _budget = __webpack_require__(30);
	
	var _showBudgetDescDoc = __webpack_require__(431);
	
	var _showBudgetDescDoc2 = _interopRequireDefault(_showBudgetDescDoc);
	
	var _showDescDoc = __webpack_require__(432);
	
	var _showDescDoc2 = _interopRequireDefault(_showDescDoc);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	var RadioButton = _antd.Radio.Button;
	var RadioGroup = _antd.Radio.Group;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.getBudgetGroup = function () {
	      (0, _budget.queryBudgetGroupMy)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            group: res.data
	          });
	        }
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handSubmit = _this$props.handSubmit,
	          data = _this$props.data;
	
	      var expenses = Object.assign({}, data, _this.props.form.getFieldsValue());
	      if (_this.apportion) {
	        expenses.apportion = _this.apportion;
	      }
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handSubmit(expenses);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function (res) {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.handleCompanyChange = function (value, option) {
	      _this.props.form.setFieldsValue({
	        company: option.props.children
	      });
	    };
	
	    _this.start = function (e) {
	      _this.submit(e, null, 'start');
	    };
	
	    _this.getBudgetGroupCandF = function (value) {
	      (0, _budget.queryBudgetGroupCandF)({
	        userUuid: _this.props.accountInfo.userUuid,
	        type: value
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            groupTip: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.apportionIsPublic = function (value) {
	      (0, _apportion.queryApportionIsPublic)({
	        type: value
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            isPublic: res.data.isPublic
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleTypeChange = function (value, option) {
	      _this.getBudgetGroupCandF(value);
	      _this.apportionIsPublic(value);
	      _this.props.form.setFieldsValue({
	        typeName: option.props.children
	      });
	    };
	
	    _this.handleBugetChange = function (e) {
	      var data = _this.props.form.getFieldsValue();
	      if (data.type && data.price) {
	        _this.setState({
	          dataInfo: data
	        });
	        _this.handleVisible(true);
	      } else {
	        _antd.message.info('请先将付款类型和付款金额填写完整！');
	      }
	    };
	
	    _this.handleRadioChange = function (e) {
	      _this.setState({
	        isRadio: e.target.value
	      });
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handleOk = function (params) {
	      _this.apportion = params;
	      _this.handleVisible(false);
	    };
	
	    _this.descTitle = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u4ED8\u6B3E\u7C7B\u578B',
	        _react2.default.createElement(_showDescDoc2.default, null)
	      );
	    };
	
	    _this.descBudgetTitle = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u9884\u7B97\u6765\u6E90',
	        _react2.default.createElement(_showBudgetDescDoc2.default, null)
	      );
	    };
	
	    _this.state = {
	      isPublic: false,
	      isRadio: '0',
	      dataInfo: {},
	      visible: false,
	      group: [],
	      groupTip: {},
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      data.uuid && this.getBudgetGroupCandF(data.type);
	      this.getBudgetGroup();
	    }
	
	    /**
	     *文件删除
	     */
	
	
	    // 用款类型说明性title
	
	
	    // 预算来源说明性title
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      getFieldDecorator('company');
	      getFieldDecorator('typeName');
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      var ItemLayout2 = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 18 }
	      };
	      var _props = this.props,
	          expendType = _props.expendType,
	          isSubmitting = _props.isSubmitting;
	      var _state = this.state,
	          visible = _state.visible,
	          dataInfo = _state.dataInfo,
	          group = _state.group,
	          groupTip = _state.groupTip,
	          isPublic = _state.isPublic,
	          isRadio = _state.isRadio;
	
	      var dataItem = this.props.data;
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: this.start,
	              loading: isSubmitting
	            },
	            '\u53D1\u8D77\u7533\u8BF7'
	          ),
	          dataItem.uuid ? _react2.default.createElement(
	            _antd.Button,
	            { icon: 'delete', style: { marginRight: 10 }, onClick: this.props.handleDelete },
	            '\u5220\u9664'
	          ) : null
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10, style: { position: 'relative' } },
	              _react2.default.createElement(
	                _antd.Row,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: this.descTitle() }, ItemLayout),
	                  getFieldDecorator('type', {
	                    rules: [{ required: true, message: '请选择付款类型' }],
	                    initialValue: dataItem.type
	                  })(_react2.default.createElement(
	                    _antd.Select,
	                    {
	                      showSearch: true,
	                      onChange: this.handleTypeChange,
	                      filterOption: function filterOption(input, option) {
	                        return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                      }
	                    },
	                    expendType.map(function (item) {
	                      return _react2.default.createElement(
	                        Option,
	                        { key: item.value },
	                        item.key
	                      );
	                    })
	                  ))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Row,
	                { style: { position: 'absolute', top: '35px', width: '100%' } },
	                _react2.default.createElement(_antd.Col, { span: 8 }),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  isRadio === '0' && groupTip.groupName ? _react2.default.createElement(
	                    'span',
	                    { style: { color: 'red' } },
	                    '\u8BE5\u8D39\u7528\u7C7B\u578B:',
	                    groupTip.groupName,
	                    '\u53EF\u7528\u4F59\u989D',
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      groupTip.current || 0
	                    ),
	                    '\u5143',
	                    groupTip.freeze ? _react2.default.createElement(
	                      'span',
	                      null,
	                      ', \u51BB\u7ED3',
	                      _react2.default.createElement(
	                        'span',
	                        null,
	                        groupTip.freeze || 0
	                      )
	                    ) : null
	                  ) : null
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4ED8\u6B3E\u91D1\u989D' }, ItemLayout),
	                getFieldDecorator('price', {
	                  rules: [{ required: true, message: '请输入付款金额!' }],
	                  initialValue: dataItem.price
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u4ED8\u6B3E\u91D1\u989D', addonAfter: '\u5143', type: 'number' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: this.descBudgetTitle() }, ItemLayout2),
	                getFieldDecorator('budgetType', {
	                  rules: [{ required: true, message: '请输入付款金额!' }],
	                  initialValue: dataItem.budgetType ? '1' : '0'
	                })(_react2.default.createElement(
	                  RadioGroup,
	                  { onChange: this.handleRadioChange },
	                  _react2.default.createElement(
	                    RadioButton,
	                    { value: '0' },
	                    '\u672C\u90E8\u95E8\u9884\u7B97'
	                  ),
	                  _react2.default.createElement(
	                    RadioButton,
	                    { value: '1', onClick: this.handleBugetChange },
	                    '\u8DE8\u90E8\u95E8\u9884\u7B97'
	                  ),
	                  group.map(function (item) {
	                    return _react2.default.createElement(
	                      RadioButton,
	                      { value: item.value, key: item.value },
	                      item.name
	                    );
	                  })
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4ED8\u6B3E\u516C\u53F8' }, ItemLayout2),
	                getFieldDecorator('companyUuid', {
	                  rules: [{ required: true, message: '请选择付款公司' }],
	                  initialValue: dataItem.companyUuid
	                })(_react2.default.createElement(_companySearch2.default, Object.assign({
	                  companyName: dataItem.company,
	                  companyUuid: dataItem.companyUuid,
	                  onChange: this.handleCompanyChange
	                }, this.props)))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6536\u6B3E\u65B9' }, ItemLayout2),
	                getFieldDecorator('incomepart', {
	                  rules: [{ required: true, message: '请填写收款方' }],
	                  initialValue: dataItem.incomepart
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6536\u6B3E\u65B9\u8D26\u6237' }, ItemLayout2),
	                getFieldDecorator('account', {
	                  rules: [{ required: true, message: '请填写收款方账户' }],
	                  initialValue: dataItem.account
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6536\u6B3E\u65B9\u5F00\u6237\u884C' }, ItemLayout2),
	                getFieldDecorator('bank', {
	                  rules: [{ required: true, message: '请填写收款方开户行' }],
	                  initialValue: dataItem.bank
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4ED8\u6B3E\u8BF4\u660E' }, ItemLayout2),
	                getFieldDecorator('reason', {
	                  initialValue: dataItem.reason
	                })(_react2.default.createElement(_antd.Input.TextArea, {
	                  placeholder: '\u5907\u6CE8',
	                  type: 'textarea',
	                  autosize: { minRows: 3, maxRows: 9 },
	                  maxLength: 1000
	                })),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '12px', color: '#999' } },
	                  '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4ED8\u6B3E\u51ED\u8BC1' }, ItemLayout),
	                getFieldDecorator('files', {
	                  rules: [{ required: true, message: '请上传付款凭证' }],
	                  initialValue: dataItem.files
	                })(_react2.default.createElement(_UploadFile2.default, {
	                  type: 'ghost',
	                  fileList: dataItem.file,
	                  isPreview: true,
	                  onRemove: this.fileRemove
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7533\u8BF7\u4EBA' }, ItemLayout),
	                getFieldDecorator('crName', {
	                  initialValue: dataItem.createUserName
	                })(_react2.default.createElement(
	                  'span',
	                  null,
	                  this.props.accountInfo.userName
	                ))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_ModalApportion2.default, {
	          onCancel: this.handleVisible,
	          dataInfo: dataInfo,
	          dataItem: dataItem,
	          isPublic: isPublic,
	          visible: visible,
	          onOk: this.handleOk,
	          company: this.props.company,
	          expendType: this.props.expendType
	        })
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list,
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(BaseForm));

/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '流水编号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/p_manage/open/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '付款公司',
	        dataIndex: 'company',
	        key: 'company'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5BA1\u6838\u4E2D'
	            );
	          }
	          if (record.status === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u7F16\u8F91'
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(_antd.Table, {
	        columns: this.columns(),
	        dataSource: list,
	        pagination: pagination,
	        loading: this.props.loading,
	        rowKey: 'uuid',
	        onChange: this.handleChange
	      });
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 710 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _TableRecordByOrg = __webpack_require__(1675);
	
	var _TableRecordByOrg2 = _interopRequireDefault(_TableRecordByOrg);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleDrawer = function (org) {
	      _this.setState({
	        org: org
	      });
	      _this.handleVisible(true);
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: "公司名称",
	        dataIndex: "company",
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            "a",
	            { onClick: function onClick() {
	                return _this.handleDrawer(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: "付款次数",
	        dataIndex: "count"
	      }, {
	        title: "付款总金额",
	        dataIndex: "sum"
	      }, {
	        title: "付款进行中",
	        dataIndex: "doing",
	        key: "doing"
	      }, {
	        title: "付款已完成",
	        dataIndex: "done",
	        key: "done"
	      }];
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource,
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _state = this.state,
	          _state$dataSource = _state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination,
	          visible = _state.visible,
	          org = _state.org;
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: list,
	          pagination: pagination,
	          rowKey: "companyUuid"
	        }),
	        visible ? _react2.default.createElement(_TableRecordByOrg2.default, { org: org, handleVisible: this.handleVisible }) : null
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = Manage;

/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _attachment = __webpack_require__(27);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handSubmit = _this$props.handSubmit,
	          data = _this$props.data;
	
	      var expenses = Object.assign({}, data, _this.props.form.getFieldsValue());
	      if (_this.apportion) {
	        expenses.apportion = _this.apportion;
	      }
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handSubmit(expenses);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function (res) {
	                console.log(res.message);
	              });
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.start = function (e) {
	      _this.submit(e, null, 'start');
	    };
	
	    _this.state = {
	      transferType: [{
	        uuid: '0',
	        name: '自营佣金'
	      }, {
	        uuid: '1',
	        name: '商家活动费'
	      }, {
	        uuid: '2',
	        name: '其他'
	      }],
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	
	    /**
	     *文件删除
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var isSubmiting = this.props.isSubmiting;
	      var transferType = this.state.transferType;
	
	      var dataItem = this.props.data;
	      var ItemLayout = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 12 }
	      };
	      var ItemLayout2 = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_antd.Button, { icon: 'left', shape: 'circle', style: { marginRight: 10 }, onClick: _BackBtn.goBack }),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: this.start,
	              loading: isSubmiting
	            },
	            '\u53D1\u8D77\u7533\u8BF7'
	          ),
	          dataItem.uuid ? _react2.default.createElement(
	            _antd.Button,
	            { icon: 'delete', style: { marginRight: 10 }, onClick: this.props.handleDelete },
	            '\u5220\u9664'
	          ) : null
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5212\u6B3E\u7C7B\u578B' }, ItemLayout, { style: { position: 'relative' } }),
	                getFieldDecorator('type', {
	                  rules: [{ required: true, message: '请选择划款类型' }],
	                  initialValue: '' + (dataItem.type ? dataItem.type : '')
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { onChange: this.handleTypeChange },
	                  transferType.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.uuid },
	                      item.name
	                    );
	                  })
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5212\u6B3E\u8BF4\u660E' }, ItemLayout),
	                getFieldDecorator('reason', {
	                  initialValue: dataItem.reason
	                })(_react2.default.createElement(_antd.Input.TextArea, {
	                  placeholder: '\u5907\u6CE8',
	                  type: 'textarea',
	                  autosize: { minRows: 3, maxRows: 9 }
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5212\u6B3E\u9644\u4EF6' }, ItemLayout2),
	                getFieldDecorator('files', {
	                  rules: [{ required: true, message: '请上传划款附件' }],
	                  initialValue: dataItem.files || []
	                })(_react2.default.createElement(_UploadFile2.default, {
	                  type: 'ghost',
	                  fileList: dataItem.file,
	                  onRemove: this.fileRemove,
	                  isPreview: true
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7533\u8BF7\u4EBA' }, ItemLayout),
	                getFieldDecorator('crName', {
	                  initialValue: dataItem.createUserName
	                })(_react2.default.createElement(
	                  'span',
	                  null,
	                  this.props.accountInfo.userName
	                ))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(BaseForm));

/***/ },
/* 712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableApply = function (_Component) {
	  _inherits(TableApply, _Component);
	
	  function TableApply(props) {
	    _classCallCheck(this, TableApply);
	
	    var _this = _possibleConstructorReturn(this, (TableApply.__proto__ || Object.getPrototypeOf(TableApply)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '申请单号',
	        dataIndex: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/pt_manage/open/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5BA1\u6838\u4E2D'
	            );
	          }
	          if (record.status === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u7F16\u8F91'
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  _createClass(TableApply, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(_antd.Table, {
	        columns: this.columns(),
	        dataSource: list,
	        pagination: pagination,
	        rowKey: 'uuid',
	        onChange: this.handleChange
	      });
	    }
	  }]);
	
	  return TableApply;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(TableApply);

/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _BackBtn = __webpack_require__(12);
	
	var _receipt = __webpack_require__(271);
	
	var _FormBase = __webpack_require__(1683);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageAdd = function (_Component) {
	  _inherits(PageAdd, _Component);
	
	  function PageAdd(props) {
	    _classCallCheck(this, PageAdd);
	
	    var _this = _possibleConstructorReturn(this, (PageAdd.__proto__ || Object.getPrototypeOf(PageAdd)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      item.uuid = _this.props.params.uuid;
	      (0, _receipt.querySaveReceipt)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageAdd, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	
	    /**
	     * 提交报销
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, {
	          data: this.state.dataInfo,
	          goBack: _BackBtn.goBack,
	          handSubmit: this.handSubmit,
	          dataInfo: dataInfo
	        })
	      );
	    }
	  }]);
	
	  return PageAdd;
	}(_react.Component);
	
	exports.default = PageAdd;

/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _workflow = __webpack_require__(272);
	
	var _getLink = __webpack_require__(715);
	
	var _getLink2 = _interopRequireDefault(_getLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.handleChange = function (pagination) {
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.loadData = function () {
	      (0, _workflow.queryTaskList)(Object.assign({
	        start: _this.current
	      }, _this.condition)).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataSource: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                current: _this.current,
	                pageSize: 15
	              }
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.current = 1;
	          _this.condition = values;
	          _this.loadData();
	        }
	      });
	    };
	
	    _this.handleFormReset = function (e) {
	      e.preventDefault();
	      _this.condition = '';
	      _this.props.form.resetFields();
	      _this.loadData();
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        {
	          layout: 'inline',
	          onSubmit: _this.handleSubmit
	          // style={{
	          //   display: "flex",
	          //   justifyContent: "flex-end"
	          // }}
	        },
	        _react2.default.createElement(
	          FormItem,
	          { label: '\u641C\u7D22\u6761\u4EF6' },
	          getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit', style: { marginLeft: 16 } },
	            '\u67E5\u8BE2'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { style: { marginLeft: 8 }, onClick: _this.handleFormReset },
	            '\u91CD\u7F6E'
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '时间',
	        dataIndex: 'cdate',
	        key: 'cdate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm')
	          );
	        }
	      }, {
	        title: '应用',
	        dataIndex: 'instanceName',
	        render: function render(text) {
	          return text || '\u7CFB\u7EDF\u63D0\u9192';
	        }
	      }, {
	        title: '标题',
	        dataIndex: 'title',
	        render: function render(text, record) {
	          return (0, _getLink2.default)(record);
	        }
	      }];
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.current = 1;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableListForm', style: { marginBottom: '16px' } },
	          this.renderSearchForm()
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: list,
	          pagination: pagination,
	          onChange: this.handleChange
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getLink = function getLink(record) {
	  var com = null;
	  var label = record.title || '查看';
	  switch (record.itemType) {
	    case 'BszbRecoup':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/finance/e_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbPayment':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/finance/p_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbLoan':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/finance/l_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbInvoice':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/finance/i_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbPurchasebase':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/administrative/purchase_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbIchapterapp':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/administrative/s_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbBudgetSetAdjustment':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/finance/budget/' + record.itemUuid + '/yyyy/adjust/info' },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbBudgetSetNew':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/finance/budget/' + record.itemUuid + '/set_manage/detail' },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbWage':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/hr/w_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbBonus':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/hr/b_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbFuhuaqiSettled':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/incubator/setteled_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbFuhuaqiOregistapp':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/incubator/oregistapp_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbFuhuaqiOregistappMoveOut':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/incubator/oregistappMoveOut_manage/moveOut/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbTermination':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/incubator/termination_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbBack':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/incubator/back_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbIncubRefund':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/incubator/refund_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbCustomInvoice':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/incubator/invoice_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbMaterialBorrowapp':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/administrative/material/borrow_manage/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbTaskTask':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/task/task_check_detail/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbMaterialDocument':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/administrative/material/info/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    case 'BszbMaterialRenewal':
	      com = _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/administrative/material/renewal/open/' + record.itemUuid },
	        _react2.default.createElement(
	          _antd.Popover,
	          { content: label },
	          _react2.default.createElement(
	            'p',
	            {
	              style: {
	                width: '600px',
	                margin: 0,
	                overflow: 'hidden',
	                whiteSpace: 'nowrap',
	                textOverflow: 'ellipsis'
	              }
	            },
	            label
	          )
	        )
	      );
	      break;
	    default:
	      com = _react2.default.createElement(
	        _antd.Popover,
	        { content: label },
	        _react2.default.createElement(
	          'p',
	          {
	            style: {
	              width: '600px',
	              overflow: 'hidden',
	              textOverflow: 'ellipsis',
	              whiteSpace: 'nowrap'
	            }
	          },
	          label
	        )
	      );
	      break;
	  }
	  return com;
	};
	exports.default = getLink;

/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var dateFormat = 'YYYY-MM-DD';
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.onChange = function (e) {
	      _this.props.onChange(e.target.value);
	    };
	
	    _this.onSearch = function (e) {
	      var data = _this.props.form.getFieldsValue();
	      var params = {};
	      var date = data.date;
	
	      if (date) {
	        params = {
	          beginDate: (0, _moment2.default)(date[0]).format('YYYY-MM-DD'),
	          endDate: (0, _moment2.default)(date[1]).format('YYYY-MM-DD')
	        };
	      }
	      params = Object.assign({}, params, {
	        condition: data.condition || ''
	      });
	      _this.props.onSearch(params);
	    };
	
	    _this.onReset = function () {
	      _this.props.form.resetFields();
	      _this.onSearch();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expense-search-form' },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: this.props.condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('date', {
	              initialValue: this.props.beginDate ? [(0, _moment2.default)(this.props.beginDate, dateFormat), (0, _moment2.default)(this.props.endDate, dateFormat)] : null
	            })(_react2.default.createElement(RangePicker, { format: dateFormat }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: this.onSearch },
	              '\u641C\u7D22'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { style: { marginLeft: '8px', marginRight: '-16px' }, onClick: this.onReset },
	              '\u91CD\u7F6E'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _attachment = __webpack_require__(27);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _YearPicker = __webpack_require__(154);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _BackBtn = __webpack_require__(12);
	
	var _org = __webpack_require__(53);
	
	var _bonus = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.getOrgCompanyList = function () {
	      (0, _org.queryOrgCompanyList)().then(function (res) {});
	    };
	
	    _this.getPrice = function (params) {
	      var values = Object.assign({}, _this.props.form.getFieldsValue(), params);
	      (0, _bonus.queryBonusStaticComMonth)({
	        year: values.year,
	        companyUuid: values.companyUuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.props.form.setFieldsValue({
	            price: res.data.netPay
	          });
	        }
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var dataItem = _this.props.data;
	      var handSubmit = _this.props.handSubmit;
	
	      var params = Object.assign({}, dataItem, _this.props.form.getFieldsValue());
	      var date = params.date;
	
	      if (date) {
	        params.year = (0, _moment2.default)(date).format('YYYY');
	      }
	      delete params.date;
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handSubmit(params);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function (res) {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.handleCompanyChange = function (value, option) {
	      _this.props.form.setFieldsValue({
	        company: option.props.children
	      });
	      _this.getPrice({ companyUuid: value });
	    };
	
	    _this.handleYearChange = function (value) {
	      _this.getPrice({ year: value });
	    };
	
	    _this.state = {
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getOrgCompanyList();
	    }
	
	    /**
	     *文件删除
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var isSubmitting = this.props.isSubmitting;
	
	      var dataItem = this.props.data;
	      getFieldDecorator('company', { initialValue: dataItem.company });
	      getFieldDecorator('typeName');
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              htmlType: 'submit',
	              loading: isSubmitting
	            },
	            '\u53D1\u8D77\u7533\u8BF7'
	          ),
	          dataItem.uuid ? _react2.default.createElement(
	            _antd.Button,
	            { icon: 'delete', style: { marginRight: 10 }, onClick: this.props.handleDelete },
	            '\u5220\u9664'
	          ) : null
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u53D1\u653E\u5E74\u5EA6' }, ItemLayout),
	                getFieldDecorator('year', {
	                  initialValue: dataItem.year
	                })(_react2.default.createElement(_YearPicker2.default, { defaultValue: dataItem.year, onChange: this.handleYearChange }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u53D1\u653E\u516C\u53F8' }, ItemLayout),
	                getFieldDecorator('companyUuid', {
	                  rules: [{ required: true, message: '请选择发放公司' }],
	                  initialValue: dataItem.companyUuid
	                })(_react2.default.createElement(_companySearch2.default, Object.assign({
	                  companyName: dataItem.company,
	                  companyUuid: dataItem.companyUuid,
	                  onChange: this.handleCompanyChange
	                }, this.props)))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5E74\u7EC8\u5956\u91D1\u989D' }, ItemLayout),
	                getFieldDecorator('price', {
	                  rules: [{ required: true, message: '请输入年终奖金额!' }],
	                  initialValue: dataItem.price
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5E74\u7EC8\u5956\u91D1\u989D', addonAfter: '\u5143', type: 'number', disabled: true }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u5E74\u7EC8\u5956\u8BF4\u660E', labelCol: { span: 4 }, wrapperCol: { span: 18 } },
	                getFieldDecorator('reason', {
	                  initialValue: dataItem.reason
	                })(_react2.default.createElement(_antd.Input.TextArea, {
	                  placeholder: '\u5907\u6CE8',
	                  type: 'textarea',
	                  autosize: { minRows: 3, maxRows: 9 },
	                  maxLength: 1000
	                })),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '12px', color: '#999' } },
	                  '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5E74\u7EC8\u5956\u9644\u4EF6' }, ItemLayout),
	                getFieldDecorator('files', {
	                  rules: [{ required: true, message: '请上传年终奖附件' }],
	                  initialValue: dataItem.files || []
	                })(_react2.default.createElement(_UploadFile2.default, {
	                  type: 'ghost',
	                  fileList: dataItem.file,
	                  isPreview: true,
	                  onRemove: this.fileRemove
	                }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(BaseForm);

/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(598);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '流水编号',
	        dataIndex: 'no',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/hr/b_manage/open/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '年终奖公司',
	        dataIndex: 'company',
	        key: 'company'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5F85\u5BA1\u6838'
	            );
	          }
	          if (record.status === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u53D1\u8D77'
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/hr/b_manage/open/' + record.uuid },
	            '\u67E5\u770B'
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(_antd.Table, {
	        rowKey: 'uuid',
	        dataSource: list,
	        pagination: pagination,
	        columns: this.columns(),
	        loading: this.props.loading,
	        onChange: this.handleChange
	      });
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.Tree.TreeNode;
	var Search = _antd.Input.Search;
	
	
	var gData = [];
	var dataList = [];
	
	var generateList = function generateList(data) {
	  for (var i = 0; i < data.length; i++) {
	    var node = data[i];
	    var uuid = node.uuid;
	
	    dataList.push({ uuid: uuid, name: node.name });
	    if (node.children) {
	      generateList(node.children, node.key);
	    }
	  }
	};
	
	var getParentKey = function getParentKey(key, tree, grandKeys) {
	  var parentKey = void 0;
	  var grandKey = grandKeys || [];
	  for (var i = 0; i < tree.length; i++) {
	    var node = tree[i];
	    if (node.children) {
	      if (node.children.some(function (item) {
	        return item.uuid === key;
	      })) {
	        grandKey.push(node.uuid);
	        parentKey = grandKey;
	      } else if (getParentKey(key, node.children)) {
	        grandKey.push(node.uuid);
	        parentKey = getParentKey(key, node.children, grandKey);
	      }
	    }
	  }
	  return parentKey;
	};
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getOrgEnableTree = function () {
	      (0, _org.queryOrgEnableTree)().then(function (res) {
	        if (res.statusCode === 200) {
	          generateList(res.data);
	          _this.setState({
	            gData: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.moveOrg = function (params) {
	      (0, _org.queryMoveOrg)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.getOrgEnableTree();
	        }
	      });
	    };
	
	    _this.onDragEnter = function (info) {
	      //
	      // expandedKeys 需要受控时设置
	      // this.setState({
	      //   expandedKeys: info.expandedKeys,
	      // });
	    };
	
	    _this.handleSelect = function (a, b, c) {
	      _this.props.handleChange(a);
	    };
	
	    _this.onDrop = function (info) {
	      var dropKey = info.node.props.eventKey;
	      var dragKey = info.dragNode.props.eventKey;
	      var dropPos = info.node.props.pos.split('-');
	      var dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
	
	      var loop = function loop(data, key, callback) {
	        data.forEach(function (item, index, arr) {
	          if (item.uuid === key) {
	            return callback(item, index, arr);
	          }
	          if (item.children) {
	            return loop(item.children, key, callback);
	          }
	        });
	      };
	      var gData1 = _this.state.gData;
	
	      var data = [].concat(_toConsumableArray(gData1));
	
	      // Find dragObject
	      var dragObj = void 0;
	      loop(data, dragKey, function (item, index, arr) {
	        arr.splice(index, 1);
	        dragObj = item;
	      });
	
	      if (!info.dropToGap) {
	        // Drop on the content
	        loop(data, dropKey, function (item) {
	          item.children = item.children || [];
	          // where to insert 示例添加到尾部，可以是随意位置
	          item.children.push(dragObj);
	        });
	      } else if ((info.node.props.children || []).length > 0 && // Has children
	      info.node.props.expanded && // Is expanded
	      dropPosition === 1 // On the bottom gap
	      ) {
	          loop(data, dropKey, function (item) {
	            item.children = item.children || [];
	            // where to insert 示例添加到尾部，可以是随意位置
	            item.children.unshift(dragObj);
	          });
	        } else {
	        var ar = void 0;
	        var i = void 0;
	        loop(data, dropKey, function (item, index, arr) {
	          ar = arr;
	          i = index;
	        });
	        if (dropPosition === -1) {
	          ar.splice(i, 0, dragObj);
	        } else {
	          ar.splice(i + 1, 0, dragObj);
	        }
	      }
	      /* this.moveOrg({
	      sourceUuid: info.dragNodesKeys[0],
	      descUuid: info.node.props.eventKey
	      }) */
	      _this.setState({
	        gData: data
	      });
	    };
	
	    _this.handleVisible = function (flag) {};
	
	    _this.handleAdd = function () {
	      _this.handleVisible(true);
	    };
	
	    _this.onChange = function (e) {
	      var gData1 = _this.state.gData;
	
	      var value = e;
	      var parentKeys = dataList.map(function (item) {
	        if (item.name.indexOf(value) > -1) {
	          var parentKey = getParentKey(item.uuid, gData1);
	          return parentKey ? parentKey.join('*') : null;
	        }
	        return null;
	      }).filter(function (item, i, self) {
	        return item && self.indexOf(item) === i;
	      });
	      var arr = [];
	      parentKeys.map(function (item) {
	        arr = arr.concat(item.split('*'));
	        return item;
	      });
	      var expandedKeys = arr.filter(function (item, i, self) {
	        return item && self.indexOf(item) === i;
	      });
	      _this.setState({
	        searchValue: value,
	        expandedKeys: expandedKeys
	      });
	    };
	
	    _this.onExpand = function (expandedKeys) {
	      _this.setState({
	        expandedKeys: expandedKeys
	      });
	    };
	
	    _this.state = {
	      gData: gData,
	      searchValue: '',
	      expandedKeys: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getOrgEnableTree();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          searchValue = _state.searchValue,
	          expandedKeys = _state.expandedKeys;
	
	      var menu = _react2.default.createElement(
	        _antd.Menu,
	        null,
	        _react2.default.createElement(
	          _antd.Menu.Item,
	          null,
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', rel: 'noopener noreferrer', href: 'http://www.alipay.com/' },
	            '1st menu item'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Menu.Item,
	          null,
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', rel: 'noopener noreferrer', href: 'http://www.taobao.com/' },
	            '2nd menu item'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Menu.Item,
	          null,
	          _react2.default.createElement(
	            'a',
	            { target: '_blank', rel: 'noopener noreferrer', href: 'http://www.tmall.com/' },
	            '3rd menu item'
	          )
	        )
	      );
	      var loop = function loop(data) {
	        return data.map(function (item) {
	          var index = item.name.indexOf(searchValue);
	          var beforeStr = item.name.substr(0, index);
	          var afterStr = item.name.substr(index + searchValue.length);
	          var title = index > -1 ? _react2.default.createElement(
	            'span',
	            null,
	            beforeStr,
	            _react2.default.createElement(
	              'span',
	              { style: { color: '#f50' } },
	              searchValue
	            ),
	            afterStr
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            item.name
	          );
	          if (item.children) {
	            return _react2.default.createElement(
	              TreeNode,
	              { key: item.uuid, title: title },
	              loop(item.children)
	            );
	          }
	          return _react2.default.createElement(TreeNode, { key: item.uuid, title: title });
	        });
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'end', style: { marginBottom: '16px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(Search, { placeholder: '\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22', onSearch: this.onChange, style: { width: 200 } })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'orgTree' },
	          _react2.default.createElement(
	            _antd.Tree,
	            {
	              defaultExpandAll: true,
	              onExpand: this.onExpand,
	              className: 'draggable-tree',
	              draggable: true,
	              blockNode: true,
	              onDragEnter: this.onDragEnter,
	              onDrop: this.onDrop,
	              showLine: true,
	              onSelect: this.handleSelect,
	              expandedKeys: expandedKeys
	            },
	            loop(this.state.gData)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _hr = __webpack_require__(167);
	
	var _FormStaff = __webpack_require__(1712);
	
	var _FormStaff2 = _interopRequireDefault(_FormStaff);
	
	var _ModalImport = __webpack_require__(1714);
	
	var _ModalImport2 = _interopRequireDefault(_ModalImport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Search = _antd.Input.Search;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getHr = function () {
	      _this.props.getHr();
	    };
	
	    _this.importHr = function (params) {
	      (0, _hr.queryImportHr)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            tips: res.data
	          });
	          _this.handleImportVisible(false);
	          _this.handleTipVisible(true);
	          _this.getHr();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.saveHr = function (params) {
	      (0, _hr.querySaveHr)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handleVisible(false);
	          _this.getHr();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deleteHr = function (uuid) {
	      (0, _hr.queryDeleteHr)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handleVisible(false);
	          _this.getHr();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.registerHr = function (params) {
	      (0, _hr.queryRegisterHr)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handleVisible(false);
	          _this.getHr();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.disableHr = function (uuid) {
	      (0, _hr.queryDisableHr)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handleVisible(false);
	          _this.getHr();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.resetHr = function (uuid) {
	      (0, _hr.queryResetHr)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handleVisible(false);
	          _this.getHr();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.enableHr = function (uuid) {
	      (0, _hr.queryEnableHr)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handleVisible(false);
	          _this.getHr();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      var noEdit = _this.props.noEdit;
	
	      return [{
	        title: '姓名',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          return noEdit ? _react2.default.createElement(
	            'span',
	            null,
	            text
	          ) : _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.handleAdd(record);
	              } },
	            record.name
	          );
	        }
	      }, {
	        title: '公司部门',
	        dataIndex: 'comName',
	        key: 'comName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.comName,
	            record.deptName
	          );
	        }
	      }, {
	        title: '岗位',
	        dataIndex: 'post',
	        key: 'post'
	      }, {
	        title: '手机号码',
	        key: 'mobile',
	        dataIndex: 'mobile'
	      }, {
	        title: '状态',
	        key: 'status',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 0 ? _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u7981\u7528'
	            ) : _react2.default.createElement(
	              'span',
	              { style: { color: 'green' } },
	              '\u5DF2\u542F\u7528'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handleImportVisible = function (flag) {
	      _this.setState({
	        importVisible: !!flag
	      });
	    };
	
	    _this.handleTipVisible = function (flag) {
	      _this.setState({
	        tipVisible: !!flag
	      });
	    };
	
	    _this.handleAdd = function (detail) {
	      _this.uuid = detail.uuid;
	      _this.setState({
	        detail: detail
	      });
	      _this.handleVisible(true);
	    };
	
	    _this.onClose = function () {
	      _this.handleVisible(false);
	    };
	
	    _this.handleSearch = function (value) {
	      if (_this.condition !== value) {
	        _this.condition = value;
	        _this.props.handleSearch(value);
	      }
	    };
	
	    _this.onTableChange = function (pagination) {
	      _this.current = pagination.current;
	      _this.getHr();
	    };
	
	    _this.state = {
	      visible: false,
	      importVisible: false,
	      detail: {},
	      tips: {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.current = 1;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          _props$data = _props.data,
	          list = _props$data.list,
	          pagination = _props$data.pagination,
	          noEdit = _props.noEdit;
	      var _state = this.state,
	          visible = _state.visible,
	          importVisible = _state.importVisible,
	          detail = _state.detail,
	          tips = _state.tips,
	          tipVisible = _state.tipVisible;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'componentStaff' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: noEdit ? 'end' : 'space-between' },
	          noEdit ? null : _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                icon: 'plus',
	                style: { marginBottom: 15, marginRight: 8 },
	                onClick: function onClick() {
	                  return _this2.handleAdd({});
	                }
	              },
	              '\u65B0\u589E'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                icon: 'import',
	                style: { marginBottom: 15, marginRight: 8 },
	                onClick: function onClick() {
	                  return _this2.handleImportVisible(true);
	                }
	              },
	              '\u5BFC\u5165'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                icon: 'export',
	                style: { marginBottom: 15, marginRight: 8 },
	                onClick: function onClick() {
	                  return _this2.props.exportHr();
	                }
	              },
	              '\u5BFC\u51FA'
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: 15 } },
	            this.props.type === 'hr' ? _react2.default.createElement(
	              _antd.Select,
	              {
	                placeholder: '\u4EBA\u5458\u5206\u7C7B',
	                style: { width: '200px' },
	                onChange: this.props.ChangeStatus,
	                defaultValue: '1'
	              },
	              _react2.default.createElement(
	                _antd.Select.Option,
	                { value: '2' },
	                '\u5168\u90E8\u4EBA\u5458'
	              ),
	              _react2.default.createElement(
	                _antd.Select.Option,
	                { value: '0' },
	                '\u5DF2\u7981\u7528\u4EBA\u5458'
	              ),
	              _react2.default.createElement(
	                _antd.Select.Option,
	                { value: '1' },
	                '\u5DF2\u542F\u7528\u4EBA\u5458'
	              )
	            ) : null,
	            _react2.default.createElement(Search, {
	              placeholder: '\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22',
	              onSearch: function onSearch(value) {
	                return _this2.handleSearch(value);
	              },
	              style: { width: 200, marginLeft: '15px' },
	              onBlur: function onBlur(e) {
	                return _this2.handleSearch(e.target.value);
	              }
	            })
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          style: { background: '#fff' },
	          rowSelection: {},
	          rowKey: 'uuid',
	          columns: this.columns(),
	          dataSource: list,
	          pagination: pagination,
	          onChange: this.props.handleTableChange
	        }),
	        visible ? _react2.default.createElement(
	          _antd.Drawer,
	          {
	            title: detail.uuid ? '编辑员工' : '新增员工',
	            placement: 'right',
	            closable: true,
	            visible: visible,
	            onClose: this.onClose,
	            width: 680
	          },
	          _react2.default.createElement(_FormStaff2.default, {
	            saveHr: this.saveHr,
	            registerHr: this.registerHr,
	            resetHr: this.resetHr,
	            disableHr: this.disableHr,
	            enableHr: this.enableHr,
	            deleteHr: this.deleteHr,
	            orgUuid: this.props.orgUuid,
	            uuid: this.uuid
	          })
	        ) : null,
	        _react2.default.createElement(_ModalImport2.default, {
	          visible: importVisible,
	          handleSubmit: this.importHr,
	          handleCancel: function handleCancel() {
	            return _this2.handleImportVisible(false);
	          }
	        }),
	        _react2.default.createElement(
	          _antd.Modal,
	          {
	            title: '\u63D0\u793A',
	            footer: false,
	            visible: tipVisible,
	            onCancel: function onCancel() {
	              return _this2.handleTipVisible(false);
	            }
	          },
	          _react2.default.createElement(
	            'p',
	            null,
	            '\u4E0A\u4F20\u603B\u6570' + tips.total + ',\u5931\u8D25' + tips.remain + ',\u6210\u529F' + tips.update
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            tips.warning ? '\u5931\u8D25\u539F\u56E0:' + tips.warning : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { data: state.staff_list };
	})(Index);

/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _attachment = __webpack_require__(27);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _BackBtn = __webpack_require__(12);
	
	var _org = __webpack_require__(53);
	
	var _wage = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var MonthPicker = _antd.DatePicker.MonthPicker;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.getOrgCompanyList = function () {
	      (0, _org.queryOrgCompanyList)().then(function (res) {});
	    };
	
	    _this.getPrice = function (params) {
	      var values = Object.assign({}, _this.props.form.getFieldsValue(), params);
	      (0, _wage.queryWageStaticComMonth)({
	        year: (0, _moment2.default)(values.date).format('YYYY'),
	        month: (0, _moment2.default)(values.date).format('MM'),
	        companyUuid: values.companyUuid
	      }).then(function (res) {
	        _this.props.form.setFieldsValue({
	          price: res.data.bankPayment
	        });
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var dataItem = _this.props.data;
	      var handSubmit = _this.props.handSubmit;
	
	      var params = Object.assign({}, dataItem, _this.props.form.getFieldsValue());
	      var date = params.date;
	
	      if (date) {
	        params.year = (0, _moment2.default)(date).format('YYYY');
	        params.month = (0, _moment2.default)(date).format('MM');
	      }
	      delete params.date;
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handSubmit(params);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function (res) {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.handleYearChange = function (value) {
	      _this.getPrice({ date: value });
	    };
	
	    _this.handleCompanyChange = function (value, option) {
	      _this.props.form.setFieldsValue({
	        company: option.props.children
	      });
	      _this.getPrice({ companyUuid: value });
	    };
	
	    _this.state = {
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getOrgCompanyList();
	    }
	
	    /**
	     *文件删除
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var isSubmitting = this.props.isSubmitting;
	
	      var dataItem = this.props.data;
	      getFieldDecorator('company', { initialValue: dataItem.company });
	      getFieldDecorator('typeName');
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              htmlType: 'submit',
	              loading: isSubmitting
	            },
	            '\u53D1\u8D77\u7533\u8BF7'
	          ),
	          dataItem.uuid ? _react2.default.createElement(
	            _antd.Button,
	            { icon: 'delete', style: { marginRight: 10 }, onClick: this.props.handleDelete },
	            '\u5220\u9664'
	          ) : null
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u53D1\u653E\u5E74\u5EA6' }, ItemLayout),
	                getFieldDecorator('date', {
	                  rules: [{ required: true, message: '请选择发放年度' }],
	                  initialValue: dataItem.year && dataItem.month ? (0, _moment2.default)(dataItem.year + '/' + dataItem.month, 'YYYY/MM') : undefined
	                })(_react2.default.createElement(MonthPicker, { style: { width: '100%' }, onChange: this.handleYearChange }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u53D1\u653E\u516C\u53F8' }, ItemLayout),
	                getFieldDecorator('companyUuid', {
	                  rules: [{ required: true, message: '请选择发放公司' }],
	                  initialValue: dataItem.companyUuid
	                })(_react2.default.createElement(_companySearch2.default, Object.assign({
	                  companyName: dataItem.company,
	                  companyUuid: dataItem.companyUuid,
	                  onChange: this.handleCompanyChange
	                }, this.props)))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5DE5\u8D44\u91D1\u989D' }, ItemLayout),
	                getFieldDecorator('price', {
	                  rules: [{ required: true, message: '请输入工资金额!' }],
	                  initialValue: dataItem.price
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5DE5\u8D44\u91D1\u989D', addonAfter: '\u5143', type: 'number', disabled: true }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u5DE5\u8D44\u8BF4\u660E', labelCol: { span: 4 }, wrapperCol: { span: 18 } },
	                getFieldDecorator('reason', {
	                  initialValue: dataItem.reason
	                })(_react2.default.createElement(_antd.Input.TextArea, {
	                  placeholder: '\u5907\u6CE8',
	                  type: 'textarea',
	                  autosize: { minRows: 3, maxRows: 9 },
	                  maxLength: 1000
	                })),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '12px', color: '#999' } },
	                  '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5DE5\u8D44\u9644\u4EF6' }, ItemLayout),
	                getFieldDecorator('files', {
	                  rules: [{ required: true, message: '请上传工资附件' }],
	                  initialValue: dataItem.files || []
	                })(_react2.default.createElement(_UploadFile2.default, {
	                  type: 'ghost',
	                  fileList: dataItem.file,
	                  isPreview: true,
	                  onRemove: this.fileRemove
	                }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(BaseForm);

/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(599);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '流水编号',
	        dataIndex: 'no',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/hr/w_manage/open/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '工资公司',
	        dataIndex: 'company',
	        key: 'company'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5F85\u5BA1\u6838'
	            );
	          }
	          if (record.status === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u53D1\u8D77'
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/hr/w_manage/open/' + record.uuid },
	            '\u67E5\u770B'
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(_antd.Table, {
	        rowKey: 'uuid',
	        dataSource: list,
	        pagination: pagination,
	        columns: this.columns(),
	        loading: this.props.loading,
	        onChange: this.handleChange
	      });
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _workOrg = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.Tree.TreeNode;
	
	var TreeOrg = function (_Component) {
	  _inherits(TreeOrg, _Component);
	
	  function TreeOrg(props) {
	    _classCallCheck(this, TreeOrg);
	
	    var _this = _possibleConstructorReturn(this, (TreeOrg.__proto__ || Object.getPrototypeOf(TreeOrg)).call(this, props));
	
	    _this.getWorkOrg = function () {
	      (0, _workOrg.queryWorkOrg)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.generateList(res.data);
	          _this.setState({
	            gData: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.generateList = function (data) {
	      var dataList = _this.state.dataList;
	
	      data.map(function (item) {
	        dataList.push({ uuid: item.uuid, name: item.name });
	        if (item.children) {
	          _this.generateList(item.children);
	        }
	        return item;
	      });
	    };
	
	    _this.getParentKey = function (key, tree, grandKeys) {
	      var parentKey = void 0;
	      var grandKey = grandKeys || [];
	      tree.map(function (item) {
	        if (item.children) {
	          if (item.children.some(function (item1) {
	            return item1.uuid === key;
	          })) {
	            grandKey.push(item.uuid);
	            parentKey = grandKey;
	          } else if (_this.getParentKey(key, item.children)) {
	            grandKey.push(item.uuid);
	            parentKey = _this.getParentKey(key, item.children, grandKey);
	          }
	        }
	        return item;
	      });
	      return parentKey;
	    };
	
	    _this.onSelect = function (selectedKeys, e) {
	      _this.setState({
	        selectedKeys: selectedKeys
	      });
	      _this.props.onSelect({
	        uuid: e.selected ? e.node.props.dataRef.uuid : '',
	        name: e.selected ? e.node.props.dataRef.name : ''
	      });
	    };
	
	    _this.onChange = function (value) {
	      var _this$state = _this.state,
	          gData = _this$state.gData,
	          dataList = _this$state.dataList;
	
	      var parentKeys = dataList.map(function (item) {
	        if (item.name.indexOf(value) > -1) {
	          var parentKey = _this.getParentKey(item.uuid, gData);
	          return parentKey ? parentKey.join('*') : null;
	        }
	        return null;
	      }).filter(function (item, i, self) {
	        return item && self.indexOf(item) === i;
	      });
	
	      var expandedKeys = [];
	      parentKeys.map(function (item) {
	        expandedKeys = expandedKeys.concat(item.split('*'));
	        return item;
	      });
	      expandedKeys = expandedKeys.filter(function (item, i, self) {
	        return item && self.indexOf(item) === i;
	      });
	      _this.setState({
	        searchValue: value,
	        expandedKeys: expandedKeys
	      });
	    };
	
	    _this.onExpand = function (expandedKeys) {
	      _this.setState({
	        expandedKeys: expandedKeys
	      });
	    };
	
	    _this.state = {
	      gData: [],
	      dataList: [],
	      searchValue: '',
	      expandedKeys: [],
	      selectedKeys: []
	    };
	    return _this;
	  }
	
	  _createClass(TreeOrg, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getWorkOrg();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      var workOrgUuid = nextProps.workOrgUuid;
	      var gData = this.state.gData;
	
	      if (workOrgUuid !== this.props.workOrgUuid && gData.length === 0) {
	        (0, _workOrg.queryWorkOrg)().then(function (res) {
	          if (res.statusCode === 200) {
	            var expandedKeys = [];
	            expandedKeys = expandedKeys.concat(_this2.getParentKey(workOrgUuid, res.data));
	            _this2.generateList(res.data);
	
	            _this2.setState({
	              gData: res.data,
	              selectedKeys: [workOrgUuid],
	              expandedKeys: expandedKeys
	            });
	          } else {
	            _antd.message.error(res.message);
	          }
	        });
	      }
	    }
	
	    // 获取组织架构
	
	
	    // 设置组织架构
	
	
	    // 找到该目录的所有父级目录（及以上）
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          searchValue = _state.searchValue,
	          selectedKeys = _state.selectedKeys,
	          expandedKeys = _state.expandedKeys;
	
	      var loop = function loop(data) {
	        return data.map(function (item) {
	          var index = item.name.indexOf(searchValue);
	          var beforeStr = item.name.substr(0, index);
	          var afterStr = item.name.substr(index + searchValue.length);
	          var title = index > -1 ? _react2.default.createElement(
	            'span',
	            null,
	            beforeStr,
	            _react2.default.createElement(
	              'span',
	              { style: { color: '#f50' } },
	              searchValue
	            ),
	            afterStr
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            item.name
	          );
	          if (item.children) {
	            return _react2.default.createElement(
	              TreeNode,
	              { key: item.uuid, title: title, dataRef: item },
	              loop(item.children)
	            );
	          }
	          return _react2.default.createElement(TreeNode, { key: item.uuid, title: title, dataRef: item });
	        });
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Tree,
	            {
	              showLine: true,
	              onExpand: this.onExpand,
	              expandedKeys: expandedKeys,
	              onSelect: this.onSelect,
	              selectedKeys: selectedKeys
	            },
	            loop(this.state.gData)
	          )
	        )
	      );
	    }
	  }]);
	
	  return TreeOrg;
	}(_react.Component);
	
	exports.default = TreeOrg;

/***/ },
/* 724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _task = __webpack_require__(66);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BackBtn = __webpack_require__(12);
	
	var _TableFilesAddDel = __webpack_require__(725);
	
	var _TableFilesAddDel2 = _interopRequireDefault(_TableFilesAddDel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.getTaskInfo = function (uuid) {
	      (0, _task.queryTaskInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.attachment && res.data.attachment.map(function (item) {
	            item.id = item.uuid;
	            return item;
	          });
	          _this.setState({
	            taskInfo: res.data,
	            fileList: res.data.attachment.length > 0 ? res.data.attachment : [{ id: 0 }],
	            completionStatus: res.data.completionStatus
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.submitTask = function () {
	      var _this$state = _this.state,
	          taskInfo = _this$state.taskInfo,
	          completionStatus = _this$state.completionStatus,
	          fileList = _this$state.fileList;
	      var uuid = _this.props.params.uuid;
	
	      var attachment = [];
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = {};
	          _this.setState({
	            subLoading: true
	          });
	
	          params.uuid = uuid;
	
	          if (taskInfo.aim) {
	            params.actual = values.actual;
	            params.fettle = completionStatus;
	          } else {
	            params.fettle = values.completionStatus;
	          }
	          fileList.map(function (item) {
	            if (values['name' + item.id] && values['files' + item.id]) {
	              attachment.push({
	                name: values['name' + item.id],
	                files: values['files' + item.id]
	              });
	            }
	            return item;
	          });
	          params.attachment = attachment;
	          params.remark = values.remark;
	
	          (0, _task.queryTaskCompletion)(params).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              _this.setState({
	                subLoading: false
	              });
	              if (taskInfo.isReview === 1) {
	                _this.props.router.push('/task/task_check_mine');
	              } else {
	                _this.props.router.go(-1);
	              }
	            } else {
	              _antd.message.error(res.message);
	              _this.setState({
	                subLoading: false
	              });
	            }
	          });
	        }
	      });
	    };
	
	    _this.changeActual = function (value) {
	      var aim = _this.state.taskInfo.aim;
	
	      if (value >= aim) {
	        _this.setState({
	          completionStatus: 2
	        });
	      } else {
	        _this.setState({
	          completionStatus: 1
	        });
	      }
	    };
	
	    _this.addFiles = function () {
	      var _this$state2 = _this.state,
	          fileList = _this$state2.fileList,
	          fileCount = _this$state2.fileCount;
	
	      fileList.push({ id: fileCount });
	      _this.setState({
	        fileList: fileList,
	        fileCount: fileCount + 1
	      });
	    };
	
	    _this.deleteFiles = function (id) {
	      var fileList = _this.state.fileList;
	
	      _this.setState({
	        fileList: fileList.filter(function (item) {
	          return item.id !== id;
	        })
	      });
	    };
	
	    _this.fileRemove = function (file) {};
	
	    _this.state = {
	      taskInfo: {},
	      subLoading: false,
	      completionStatus: 1,
	      fileList: [{ id: 0 }],
	      fileCount: 1
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.params.uuid;
	
	      this.getTaskInfo(uuid);
	    }
	
	    // 获取任务信息
	
	
	    // 提交任务结果
	
	
	    /** -------------------------------------设置附件模板列表开始--------------------------------*/
	    // 新增一行
	
	
	    // 删除该行
	
	
	    // 文件删除
	
	  }, {
	    key: 'render',
	
	
	    /** -------------------------------------设置附件模板列表结束--------------------------------*/
	
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _state = this.state,
	          taskInfo = _state.taskInfo,
	          completionStatus = _state.completionStatus,
	          fileList = _state.fileList,
	          subLoading = _state.subLoading;
	      // 一整行
	
	      var ItemLayout = {
	        labelCol: { span: 2 },
	        wrapperCol: { span: 21 }
	      };
	
	      // 一行2等分
	      var ItemLayout2 = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 19 }
	      };
	
	      // 一行3等分
	      var ItemLayout3 = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 17 }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          { style: { marginBottom: '15px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              type: 'primary',
	              onClick: function onClick() {
	                return _this2.submitTask(1);
	              },
	              icon: 'upload',
	              loading: subLoading
	            },
	            '\u63D0\u4EA4'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'space-around', align: 'middle', style: { marginBottom: '30px' } },
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '20px', fontWeight: 'bold' } },
	              '\u63D0\u4EA4\u4EFB\u52A1\u7ED3\u679C'
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Form,
	            null,
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  _antd.Form.Item,
	                  Object.assign({ label: '\u4EFB\u52A1\u540D\u79F0' }, ItemLayout2),
	                  taskInfo.name
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  _antd.Form.Item,
	                  Object.assign({ label: '\u4EFB\u52A1\u5468\u671F' }, ItemLayout2),
	                  _moment2.default.unix(taskInfo.beginDate / 1000).format('YYYY-MM-DD') + '\u81F3' + _moment2.default.unix(taskInfo.endDate / 1000).format('YYYY-MM-DD')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u4EFB\u52A1\u63CF\u8FF0' }, ItemLayout),
	              taskInfo.remark
	            ),
	            _react2.default.createElement(_antd.Divider, null),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              taskInfo.aim ? _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                  _antd.Form.Item,
	                  Object.assign({ label: '\u4EFB\u52A1\u76EE\u6807' }, ItemLayout3),
	                  taskInfo.aim
	                )
	              ) : '',
	              taskInfo.aim ? _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                  _antd.Form.Item,
	                  Object.assign({ label: '\u5B9E\u9645\u6570\u636E' }, ItemLayout3),
	                  getFieldDecorator('actual', {
	                    rules: [{ required: true, message: '请填写最终数据' }],
	                    initialValue: taskInfo.actual
	                  })(_react2.default.createElement(_antd.InputNumber, {
	                    style: { width: '150px' },
	                    placeholder: '\u8BF7\u8F93\u5165\u6700\u7EC8\u6570\u636E',
	                    onChange: this.changeActual
	                  }))
	                )
	              ) : '',
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                  _antd.Form.Item,
	                  Object.assign({ label: '\u4EFB\u52A1\u7ED3\u679C' }, ItemLayout3),
	                  taskInfo.aim ? _react2.default.createElement(
	                    'span',
	                    null,
	                    completionStatus === 2 ? '已完成' : '未完成'
	                  ) : _react2.default.createElement(
	                    'div',
	                    null,
	                    getFieldDecorator('completionStatus', {
	                      rules: [{ required: true, message: '请选择任务结果' }],
	                      initialValue: '' + (taskInfo.completionStatus ? taskInfo.completionStatus : '')
	                    })(_react2.default.createElement(
	                      _antd.Select,
	                      null,
	                      _react2.default.createElement(
	                        _antd.Select.Option,
	                        { key: '1' },
	                        '\u672A\u5B8C\u6210'
	                      ),
	                      _react2.default.createElement(
	                        _antd.Select.Option,
	                        { key: '2' },
	                        '\u5DF2\u5B8C\u6210'
	                      )
	                    ))
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u76F8\u5173\u9644\u4EF6' }, ItemLayout),
	              getFieldDecorator('attachment')(_react2.default.createElement(_TableFilesAddDel2.default, Object.assign({
	                fileList: fileList,
	                addFiles: this.addFiles,
	                deleteFiles: this.deleteFiles,
	                fileRemove: this.fileRemove
	              }, this.props)))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u5907\u6CE8\u8BF4\u660E' }, ItemLayout),
	              getFieldDecorator('remark', {
	                initialValue: taskInfo.completionRemark
	              })(_react2.default.createElement(_antd.Input.TextArea, {
	                placeholder: '\u8BF7\u8F93\u5165\u5907\u6CE8',
	                type: 'textarea',
	                autosize: { minRows: 3, maxRows: 9 },
	                maxLength: 5000
	              })),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '12px', color: '#999' } },
	                '*\u6700\u591A\u53EF\u8F93\u51655000\u5B57'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Page);

/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _UploadFileTable = __webpack_require__(192);
	
	var _UploadFileTable2 = _interopRequireDefault(_UploadFileTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var TableFiles = function (_Component) {
	  _inherits(TableFiles, _Component);
	
	  function TableFiles(props) {
	    _classCallCheck(this, TableFiles);
	
	    var _this = _possibleConstructorReturn(this, (TableFiles.__proto__ || Object.getPrototypeOf(TableFiles)).call(this, props));
	
	    _this.columns = function () {
	      var _this$props$form = _this.props.form,
	          getFieldDecorator = _this$props$form.getFieldDecorator,
	          getFieldValue = _this$props$form.getFieldValue;
	
	      return [{
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name',
	        width: '30%',
	        render: function render(text, record) {
	          var filesArr = getFieldValue('files' + record.id) || [];
	          var defaultName = filesArr[0] ? filesArr[0].name : '';
	          var index = defaultName.indexOf('.');
	          defaultName = defaultName.slice(0, index);
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('name' + record.id, {
	              initialValue: record.name || defaultName || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u6587\u4EF6\u540D\u79F0' }))
	          );
	        }
	      }, {
	        title: '附件',
	        dataIndex: 'files',
	        key: 'files',
	        width: '50%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('files' + record.id, {
	              initialValue: record.files || []
	            })(_react2.default.createElement(_UploadFileTable2.default, {
	              type: 'ghost',
	              fileList: record.file,
	              isPreview: true,
	              onRemove: _this.props.fileRemove
	            }))
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        key: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            { style: { margin: 0, height: '45px' } },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { onClick: _this.props.deleteFiles(record.id) },
	              '\u5220\u9664'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(TableFiles, [{
	    key: 'render',
	    value: function render() {
	      var fileList = this.props.fileList;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Table, { columns: this.columns(), dataSource: fileList, pagination: false, rowKey: 'id' }),
	        _react2.default.createElement(
	          _antd.Button,
	          { onClick: this.props.addFiles, style: { width: '100%', borderStyle: 'dashed' } },
	          '+\u6DFB\u52A0\u9644\u4EF6'
	        )
	      );
	    }
	  }]);
	
	  return TableFiles;
	}(_react.Component);
	
	exports.default = TableFiles;

/***/ },
/* 726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(313);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.onChange = function (e) {
	      _this.props.onChange(e.target.value);
	    };
	
	    _this.onSearch = function () {
	      var data = _this.props.form.getFieldsValue();
	      var params = {
	        name: data.name || ''
	      };
	      _this.props.onSearch(params);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'expense-search-form' },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('name', {
	              initialValue: this.props.name || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u4EFB\u52A1\u540D\u79F0\u641C\u7D22' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: this.onSearch },
	              '\u641C\u7D22'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(313);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '任务名称',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/task/task_check_detail/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '业务部门',
	        dataIndex: 'workorg',
	        key: 'workorg'
	      }, {
	        title: '任务描述',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '任务审批人',
	        dataIndex: 'name1',
	        key: 'name1',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? '' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5BA1\u6838\u4E2D'
	            );
	          }
	          if (record.status === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u53D1\u8D77'
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource,
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource,
	        isLoading: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          _state$dataSource = _state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination,
	          isLoading = _state.isLoading;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: list,
	          pagination: pagination,
	          rowKey: 'uuid',
	          loading: isLoading,
	          onChange: this.handleChange
	        })
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _protect = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadDetail = function (uuid) {
	      (0, _protect.queryProtectionInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      data.name = data.name.replace(/\s+/g, '');
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          if (_this.props.protectUuid) {
	            data.uuid = _this.props.protectUuid;
	          }
	          (0, _protect.querySaveProtection)(data).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              _this.props.loadDate();
	              _this.props.cancel();
	            } else {
	              _antd.message.error(res.message);
	            }
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function () {
	      _this.props.form.setFieldsValue({
	        name: 111
	      });
	    };
	
	    _this.state = {
	      data: {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.protectUuid) {
	        this.loadDetail(this.props.protectUuid);
	      }
	    }
	
	    /**
	     * 获取客户保护详情
	     */
	
	
	    /**
	     * 添加客户保护
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancel = _props.cancel,
	          title = _props.title;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: title,
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u516C\u53F8\u540D\u79F0' }, formItemLayout),
	              getFieldDecorator('name', {
	                rules: [{
	                  required: true,
	                  message: '公司名称不能包含空格！',
	                  pattern: /^[^ ]+$/
	                }],
	                initialValue: data.name
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8054\u7CFB\u4EBA\u59D3\u540D' }, formItemLayout),
	              getFieldDecorator('contactName', {
	                rules: [{ message: '联系人姓名不能为空！' }],
	                initialValue: data.contactName
	              })(_react2.default.createElement(_antd.Input, { placeholder: '' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8054\u7CFB\u4EBA\u7535\u8BDD' }, formItemLayout),
	              getFieldDecorator('phone', {
	                rules: [{ message: '联系人电话不能为空！' }],
	                initialValue: data.phone
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8054\u7CFB\u4EBA\u624B\u673A' }, formItemLayout),
	              getFieldDecorator('mobile', {
	                rules: [{
	                  required: true,
	                  message: '手机号不合法！',
	                  pattern: /^((1[,358]\d)|(14[,57])|(17[,06-8])|(197))\d{8}$/
	                }],
	                initialValue: data.mobile
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u884C\u4E1A' }, formItemLayout),
	              getFieldDecorator('industry', {
	                rules: [{ message: '行业不能为空！' }],
	                initialValue: data.industry
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                this.props.list.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.value },
	                    item.key
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u516C\u53F8\u7F51\u5740' }, formItemLayout),
	              getFieldDecorator('url', {
	                rules: [{ message: '基金名称不能为空！' }],
	                initialValue: data.url
	              })(_react2.default.createElement(_antd.Input, { placeholder: '' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u6CD5\u4EBA\u59D3\u540D' }, formItemLayout),
	              getFieldDecorator('legal', {
	                rules: [{ message: '基金名称不能为空！' }],
	                initialValue: data.legal
	              })(_react2.default.createElement(_antd.Input, { placeholder: '' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u516C\u53F8\u5730\u5740' }, formItemLayout),
	              getFieldDecorator('area', {
	                rules: [{ message: '基金名称不能为空！' }],
	                initialValue: data.area
	              })(_react2.default.createElement(_antd.Input, { placeholder: '' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8BE6\u7EC6\u5730\u5740' }, formItemLayout),
	              getFieldDecorator('addr', {
	                rules: [{ message: '基金名称不能为空！' }],
	                initialValue: data.addr
	              })(_react2.default.createElement(_antd.Input, { placeholder: '' }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { list: state.industry_list };
	})(_antd.Form.create()(Index));

/***/ },
/* 729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.accountInfo = undefined;
	exports.getAccountInfo = getAccountInfo;
	
	var _user = __webpack_require__(54);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 按模块的action, reducer整合体
	var ACCOUNT_INFO = 'ACCOUNT_INFO';
	
	var judgeRole = function judgeRole(info) {
	  // 判断是否有财务管理的权限
	  var isFinancialM = info.roles.some(function (item) {
	    return item === '[FinanceMenber]';
	  });
	  // 判断是否总经理
	  var isComLeader = info.roles.some(function (item) {
	    return item === '[ComLeader]';
	  });
	  // 判断是孵化器管理员（众客）
	  var isHatcherMng = info.roles.some(function (item) {
	    return item === '[HatcherMng]';
	  });
	  // 判断是孵化器管委会秘书
	  var isIncubatorMng = info.roles.some(function (item) {
	    return item === '[IncubatorMng]';
	  });
	  // 判断是孵化器人员）
	  var isIncubatorEdit = info.roles.some(function (item) {
	    return item === '[IncubatorEdit]';
	  });
	  return {
	    isFinancialM: isFinancialM,
	    isComLeader: isComLeader,
	    isHatcherMng: isHatcherMng,
	    isIncubatorMng: isIncubatorMng,
	    isIncubatorEdit: isIncubatorEdit
	  };
	};
	
	function getAccountInfo() {
	  return function (dispatch) {
	    return (0, _user.queryAccountInfo)().then(function (res) {
	      if (res.statusCode === 200) {
	        var roles = judgeRole(res.data);
	        _localDb2.default.set(ACCOUNT_INFO, Object.assign({}, res.data, roles));
	        _localDb2.default.set('userUuid', res.data.userUuid);
	        return dispatch({
	          type: ACCOUNT_INFO,
	          data: Object.assign({}, res.data, roles)
	        });
	      }
	    });
	  };
	}
	
	// Reducer
	var accountInfo = exports.accountInfo = function accountInfo() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case ACCOUNT_INFO:
	      return action.data;
	    default:
	      return _localDb2.default.get(ACCOUNT_INFO);
	  }
	};

/***/ },
/* 730 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getDepartmentList = getDepartmentList;
	exports.departmentList = departmentList;
	
	var _org = __webpack_require__(53);
	
	// 按模块的action, reducer整合体
	var DEPARTMENT_LIST = 'CDEPARTMENT_LIST'; // 指定组织的树状列表
	function getDepartmentList(params) {
	  return function (dispatch, getState) {
	    (0, _org.queryByOrgTree)(Object.assign({}, params)).then(function (res) {
	      if (res.statusCode === 200) {
	        return dispatch({
	          type: DEPARTMENT_LIST,
	          data: res.data
	        });
	      }
	    });
	  };
	}
	
	function departmentList() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case DEPARTMENT_LIST:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getEnableOrganization = getEnableOrganization;
	exports.enableOrgTree = enableOrgTree;
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 按模块的action, reducer整合体
	var GET_ENABLE_ORGANIZATION_LIST = 'GET_ENABLE_ORGANIZATION_LIST';
	
	// Action
	function getEnableOrganization() {
	  return function (dispatch) {
	    (0, _org.queryOrgEnableTree)().then(function (res) {
	      if (res.statusCode === 200) {
	        _localDb2.default.set(GET_ENABLE_ORGANIZATION_LIST, res.data);
	        return dispatch({
	          type: GET_ENABLE_ORGANIZATION_LIST,
	          data: res.data
	        });
	      }
	    });
	  };
	}
	
	// Reducer
	function enableOrgTree() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case GET_ENABLE_ORGANIZATION_LIST:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 732 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAllCompany = getAllCompany;
	exports.allCompany = allCompany;
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var ALL_COMPANY = 'ALL_COMPANY';
	
	function getAllCompany(data) {
	  return function (dispatch) {
	    dispatch({
	      type: ALL_COMPANY,
	      data: [].concat(_toConsumableArray(data))
	    });
	  };
	}
	
	function allCompany() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case ALL_COMPANY:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 733 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLocalFinanceStatis = getLocalFinanceStatis;
	exports.financeStatis = financeStatis;
	var FINANCE_STATIS = 'FINANCE_STATIS';
	
	function getLocalFinanceStatis(params) {
	  return function (dispatch) {
	    return dispatch({
	      type: FINANCE_STATIS,
	      data: params
	    });
	  };
	}
	
	// Reducer
	function financeStatis() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    checkedUUids: [],
	    data: [],
	    wid: 1000,
	    scrollLeft: 0,
	    scrollTop: 0,
	    org: [],
	    type: []
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FINANCE_STATIS:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.saveFundsBook = saveFundsBook;
	exports.fundsBook = fundsBook;
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 按模块的action, reducer整合体
	var FUNDS_BOOK = 'FUNDS_BOOK';
	
	function saveFundsBook(params) {
	  return function (dispatch) {
	    _localDb2.default.set(FUNDS_BOOK, params);
	    return dispatch({
	      type: FUNDS_BOOK,
	      data: params
	    });
	  };
	}
	
	// Reducer
	function fundsBook() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case FUNDS_BOOK:
	      return action.data;
	    default:
	      return _localDb2.default.get(FUNDS_BOOK);
	  }
	}

/***/ },
/* 735 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getLocalOperationalStatis = getLocalOperationalStatis;
	exports.operationalStatis = operationalStatis;
	// 按模块的action, reducer整合体
	var OPERATIONAL_STATIS = 'OPERATIONAL_STATIS';
	
	function getLocalOperationalStatis(params) {
	  return function (dispatch) {
	    return dispatch({
	      type: OPERATIONAL_STATIS,
	      data: params
	    });
	  };
	}
	
	// Reducer
	function operationalStatis() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    checkedUUids: [],
	    data: [],
	    wid: 1000,
	    scrollLeft: 0,
	    scrollTop: 0,
	    org: [],
	    type: []
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case OPERATIONAL_STATIS:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOrganization = getOrganization;
	exports.organization = organization;
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 按模块的action, reducer整合体
	var GET_ORGANIZATION_LIST = "GET_ORGANIZATION_LIST";
	
	var loopFormatOrgTree = function loopFormatOrgTree(data) {
	  data.map(function (item) {
	    if (item.children && item.children.length < 1) {
	      delete item.children;
	    } else if (item.children && item.children.length > 0) {
	      loopFormatOrgTree(item.children);
	    }
	    return item;
	  });
	};
	
	// Action
	function getOrganization() {
	  return function (dispatch) {
	    (0, _org.queryOrgTree)().then(function (res) {
	      if (res.statusCode === 200) {
	        _localDb2.default.set(GET_ORGANIZATION_LIST, res.data);
	        loopFormatOrgTree(res.data);
	        return dispatch({
	          type: GET_ORGANIZATION_LIST,
	          data: res.data
	        });
	      }
	    });
	  };
	}
	
	// Reducer
	function organization() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case GET_ORGANIZATION_LIST:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _redux = __webpack_require__(312);
	
	var _reactRouterRedux = __webpack_require__(1154);
	
	var _user = __webpack_require__(441);
	
	var _organization = __webpack_require__(736);
	
	var _staff_list = __webpack_require__(440);
	
	var _all_user = __webpack_require__(1821);
	
	var _contract_type = __webpack_require__(435);
	
	var _industry_list = __webpack_require__(438);
	
	var _account_info = __webpack_require__(729);
	
	var _income_info = __webpack_require__(233);
	
	var _funds_book = __webpack_require__(734);
	
	var _finance_statis = __webpack_require__(733);
	
	var _operational_statis = __webpack_require__(735);
	
	var _recoup_info = __webpack_require__(1824);
	
	var _company_list = __webpack_require__(96);
	
	var _department_list = __webpack_require__(730);
	
	var _enable_org_tree = __webpack_require__(731);
	
	var _work_org_list = __webpack_require__(234);
	
	var _core_account_search = __webpack_require__(232);
	
	var _hr_search = __webpack_require__(1823);
	
	var _back_info = __webpack_require__(19);
	
	var _back_info_standby = __webpack_require__(327);
	
	var _reducers = __webpack_require__(1822);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _menu = __webpack_require__(439);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 公共Reducer
	var rootReducer = (0, _redux.combineReducers)(Object.assign({
	  routing: _reactRouterRedux.routerReducer,
	  user: _user.user,
	  organization: _organization.organization,
	  menu: _menu.menu,
	  all_user: _all_user.allUser,
	  back_info: _back_info.backInfo,
	  back_info_standby: _back_info_standby.backInfoStandby,
	  contract_type: _contract_type.contractType,
	  industry_list: _industry_list.industryList,
	  account_info: _account_info.accountInfo,
	  income_info: _income_info.incomeInfo,
	  funds_book: _funds_book.fundsBook,
	  finance_statis: _finance_statis.financeStatis,
	  operational_statis: _operational_statis.operationalStatis,
	  recoup_info: _recoup_info.recoupInfo,
	  company_list: _company_list.companyList,
	  staff_list: _staff_list.staffList,
	  department_list: _department_list.departmentList,
	  enable_org_tree: _enable_org_tree.enableOrgTree,
	  work_org_list: _work_org_list.workOrgList,
	  core_account_search: _core_account_search.coreAccountSearch,
	  hr_search: _hr_search.hrSearch
	}, _reducers2.default));
	
	exports.default = rootReducer;

/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = interceptor;
	exports.auth = auth;
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isLogin() {
	  return _localDb2.default.get('token');
	}
	
	/**
	 * [interceptor Http请求拦截，如果无权限的情况，或者登陆失效的情况，跳转登录页。]
	 * @param  {[type]} response [description]
	 * @return {[type]}          [description]
	 */
	function interceptor(response) {
	  // store.dispatch(setReqState('success'));
	  if (response.status === 403) {
	    _antd.message.warning('登录过期，请重新登录！');
	    _localDb2.default.clear();
	    _reactRouter.browserHistory.replace('/login');
	    return Promise.reject(response);
	  }
	  return response;
	}
	
	// 路由拦截
	function auth(next, replace) {
	  var path = next.location.pathname;
	  if (isLogin() || path.indexOf('login') > -1) {
	    replace(null, path);
	  } else {
	    // message.warning("登录过期，请重新登录！")
	    replace('/login');
	  }
	}

/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1883), __esModule: true };

/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1885), __esModule: true };

/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1890), __esModule: true };

/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	var _threezerotwofour = __webpack_require__(1871);
	
	exports.threezerotwofour = _interopRequire(_threezerotwofour);
	
	var _apathy = __webpack_require__(1838);
	
	exports.apathy = _interopRequire(_apathy);
	
	var _ashes = __webpack_require__(1839);
	
	exports.ashes = _interopRequire(_ashes);
	
	var _atelierDune = __webpack_require__(1840);
	
	exports.atelierDune = _interopRequire(_atelierDune);
	
	var _atelierForest = __webpack_require__(1841);
	
	exports.atelierForest = _interopRequire(_atelierForest);
	
	var _atelierHeath = __webpack_require__(1842);
	
	exports.atelierHeath = _interopRequire(_atelierHeath);
	
	var _atelierLakeside = __webpack_require__(1843);
	
	exports.atelierLakeside = _interopRequire(_atelierLakeside);
	
	var _atelierSeaside = __webpack_require__(1844);
	
	exports.atelierSeaside = _interopRequire(_atelierSeaside);
	
	var _bespin = __webpack_require__(1845);
	
	exports.bespin = _interopRequire(_bespin);
	
	var _brewer = __webpack_require__(1846);
	
	exports.brewer = _interopRequire(_brewer);
	
	var _bright = __webpack_require__(1847);
	
	exports.bright = _interopRequire(_bright);
	
	var _chalk = __webpack_require__(1848);
	
	exports.chalk = _interopRequire(_chalk);
	
	var _codeschool = __webpack_require__(1849);
	
	exports.codeschool = _interopRequire(_codeschool);
	
	var _colors = __webpack_require__(1850);
	
	exports.colors = _interopRequire(_colors);
	
	var _default = __webpack_require__(1851);
	
	exports['default'] = _interopRequire(_default);
	
	var _eighties = __webpack_require__(1852);
	
	exports.eighties = _interopRequire(_eighties);
	
	var _embers = __webpack_require__(1853);
	
	exports.embers = _interopRequire(_embers);
	
	var _flat = __webpack_require__(1854);
	
	exports.flat = _interopRequire(_flat);
	
	var _google = __webpack_require__(1855);
	
	exports.google = _interopRequire(_google);
	
	var _grayscale = __webpack_require__(1856);
	
	exports.grayscale = _interopRequire(_grayscale);
	
	var _greenscreen = __webpack_require__(1857);
	
	exports.greenscreen = _interopRequire(_greenscreen);
	
	var _harmonic = __webpack_require__(1858);
	
	exports.harmonic = _interopRequire(_harmonic);
	
	var _hopscotch = __webpack_require__(1859);
	
	exports.hopscotch = _interopRequire(_hopscotch);
	
	var _isotope = __webpack_require__(1860);
	
	exports.isotope = _interopRequire(_isotope);
	
	var _marrakesh = __webpack_require__(1861);
	
	exports.marrakesh = _interopRequire(_marrakesh);
	
	var _mocha = __webpack_require__(1862);
	
	exports.mocha = _interopRequire(_mocha);
	
	var _monokai = __webpack_require__(1863);
	
	exports.monokai = _interopRequire(_monokai);
	
	var _ocean = __webpack_require__(1864);
	
	exports.ocean = _interopRequire(_ocean);
	
	var _paraiso = __webpack_require__(1865);
	
	exports.paraiso = _interopRequire(_paraiso);
	
	var _pop = __webpack_require__(1866);
	
	exports.pop = _interopRequire(_pop);
	
	var _railscasts = __webpack_require__(1867);
	
	exports.railscasts = _interopRequire(_railscasts);
	
	var _shapeshifter = __webpack_require__(1868);
	
	exports.shapeshifter = _interopRequire(_shapeshifter);
	
	var _solarized = __webpack_require__(1869);
	
	exports.solarized = _interopRequire(_solarized);
	
	var _summerfruit = __webpack_require__(1870);
	
	exports.summerfruit = _interopRequire(_summerfruit);
	
	var _tomorrow = __webpack_require__(1872);
	
	exports.tomorrow = _interopRequire(_tomorrow);
	
	var _tube = __webpack_require__(1873);
	
	exports.tube = _interopRequire(_tube);
	
	var _twilight = __webpack_require__(1874);
	
	exports.twilight = _interopRequire(_twilight);

/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/*
	 * JavaScript MD5
	 * https://github.com/blueimp/JavaScript-MD5
	 *
	 * Copyright 2011, Sebastian Tschan
	 * https://blueimp.net
	 *
	 * Licensed under the MIT license:
	 * https://opensource.org/licenses/MIT
	 *
	 * Based on
	 * A JavaScript implementation of the RSA Data Security, Inc. MD5 Message
	 * Digest Algorithm, as defined in RFC 1321.
	 * Version 2.2 Copyright (C) Paul Johnston 1999 - 2009
	 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
	 * Distributed under the BSD License
	 * See http://pajhome.org.uk/crypt/md5 for more info.
	 */
	
	/* global define */
	
	/* eslint-disable strict */
	
	;(function ($) {
	  'use strict'
	
	  /**
	   * Add integers, wrapping at 2^32.
	   * This uses 16-bit operations internally to work around bugs in interpreters.
	   *
	   * @param {number} x First integer
	   * @param {number} y Second integer
	   * @returns {number} Sum
	   */
	  function safeAdd(x, y) {
	    var lsw = (x & 0xffff) + (y & 0xffff)
	    var msw = (x >> 16) + (y >> 16) + (lsw >> 16)
	    return (msw << 16) | (lsw & 0xffff)
	  }
	
	  /**
	   * Bitwise rotate a 32-bit number to the left.
	   *
	   * @param {number} num 32-bit number
	   * @param {number} cnt Rotation count
	   * @returns {number} Rotated number
	   */
	  function bitRotateLeft(num, cnt) {
	    return (num << cnt) | (num >>> (32 - cnt))
	  }
	
	  /**
	   * Basic operation the algorithm uses.
	   *
	   * @param {number} q q
	   * @param {number} a a
	   * @param {number} b b
	   * @param {number} x x
	   * @param {number} s s
	   * @param {number} t t
	   * @returns {number} Result
	   */
	  function md5cmn(q, a, b, x, s, t) {
	    return safeAdd(bitRotateLeft(safeAdd(safeAdd(a, q), safeAdd(x, t)), s), b)
	  }
	  /**
	   * Basic operation the algorithm uses.
	   *
	   * @param {number} a a
	   * @param {number} b b
	   * @param {number} c c
	   * @param {number} d d
	   * @param {number} x x
	   * @param {number} s s
	   * @param {number} t t
	   * @returns {number} Result
	   */
	  function md5ff(a, b, c, d, x, s, t) {
	    return md5cmn((b & c) | (~b & d), a, b, x, s, t)
	  }
	  /**
	   * Basic operation the algorithm uses.
	   *
	   * @param {number} a a
	   * @param {number} b b
	   * @param {number} c c
	   * @param {number} d d
	   * @param {number} x x
	   * @param {number} s s
	   * @param {number} t t
	   * @returns {number} Result
	   */
	  function md5gg(a, b, c, d, x, s, t) {
	    return md5cmn((b & d) | (c & ~d), a, b, x, s, t)
	  }
	  /**
	   * Basic operation the algorithm uses.
	   *
	   * @param {number} a a
	   * @param {number} b b
	   * @param {number} c c
	   * @param {number} d d
	   * @param {number} x x
	   * @param {number} s s
	   * @param {number} t t
	   * @returns {number} Result
	   */
	  function md5hh(a, b, c, d, x, s, t) {
	    return md5cmn(b ^ c ^ d, a, b, x, s, t)
	  }
	  /**
	   * Basic operation the algorithm uses.
	   *
	   * @param {number} a a
	   * @param {number} b b
	   * @param {number} c c
	   * @param {number} d d
	   * @param {number} x x
	   * @param {number} s s
	   * @param {number} t t
	   * @returns {number} Result
	   */
	  function md5ii(a, b, c, d, x, s, t) {
	    return md5cmn(c ^ (b | ~d), a, b, x, s, t)
	  }
	
	  /**
	   * Calculate the MD5 of an array of little-endian words, and a bit length.
	   *
	   * @param {Array} x Array of little-endian words
	   * @param {number} len Bit length
	   * @returns {Array<number>} MD5 Array
	   */
	  function binlMD5(x, len) {
	    /* append padding */
	    x[len >> 5] |= 0x80 << len % 32
	    x[(((len + 64) >>> 9) << 4) + 14] = len
	
	    var i
	    var olda
	    var oldb
	    var oldc
	    var oldd
	    var a = 1732584193
	    var b = -271733879
	    var c = -1732584194
	    var d = 271733878
	
	    for (i = 0; i < x.length; i += 16) {
	      olda = a
	      oldb = b
	      oldc = c
	      oldd = d
	
	      a = md5ff(a, b, c, d, x[i], 7, -680876936)
	      d = md5ff(d, a, b, c, x[i + 1], 12, -389564586)
	      c = md5ff(c, d, a, b, x[i + 2], 17, 606105819)
	      b = md5ff(b, c, d, a, x[i + 3], 22, -1044525330)
	      a = md5ff(a, b, c, d, x[i + 4], 7, -176418897)
	      d = md5ff(d, a, b, c, x[i + 5], 12, 1200080426)
	      c = md5ff(c, d, a, b, x[i + 6], 17, -1473231341)
	      b = md5ff(b, c, d, a, x[i + 7], 22, -45705983)
	      a = md5ff(a, b, c, d, x[i + 8], 7, 1770035416)
	      d = md5ff(d, a, b, c, x[i + 9], 12, -1958414417)
	      c = md5ff(c, d, a, b, x[i + 10], 17, -42063)
	      b = md5ff(b, c, d, a, x[i + 11], 22, -1990404162)
	      a = md5ff(a, b, c, d, x[i + 12], 7, 1804603682)
	      d = md5ff(d, a, b, c, x[i + 13], 12, -40341101)
	      c = md5ff(c, d, a, b, x[i + 14], 17, -1502002290)
	      b = md5ff(b, c, d, a, x[i + 15], 22, 1236535329)
	
	      a = md5gg(a, b, c, d, x[i + 1], 5, -165796510)
	      d = md5gg(d, a, b, c, x[i + 6], 9, -1069501632)
	      c = md5gg(c, d, a, b, x[i + 11], 14, 643717713)
	      b = md5gg(b, c, d, a, x[i], 20, -373897302)
	      a = md5gg(a, b, c, d, x[i + 5], 5, -701558691)
	      d = md5gg(d, a, b, c, x[i + 10], 9, 38016083)
	      c = md5gg(c, d, a, b, x[i + 15], 14, -660478335)
	      b = md5gg(b, c, d, a, x[i + 4], 20, -405537848)
	      a = md5gg(a, b, c, d, x[i + 9], 5, 568446438)
	      d = md5gg(d, a, b, c, x[i + 14], 9, -1019803690)
	      c = md5gg(c, d, a, b, x[i + 3], 14, -187363961)
	      b = md5gg(b, c, d, a, x[i + 8], 20, 1163531501)
	      a = md5gg(a, b, c, d, x[i + 13], 5, -1444681467)
	      d = md5gg(d, a, b, c, x[i + 2], 9, -51403784)
	      c = md5gg(c, d, a, b, x[i + 7], 14, 1735328473)
	      b = md5gg(b, c, d, a, x[i + 12], 20, -1926607734)
	
	      a = md5hh(a, b, c, d, x[i + 5], 4, -378558)
	      d = md5hh(d, a, b, c, x[i + 8], 11, -2022574463)
	      c = md5hh(c, d, a, b, x[i + 11], 16, 1839030562)
	      b = md5hh(b, c, d, a, x[i + 14], 23, -35309556)
	      a = md5hh(a, b, c, d, x[i + 1], 4, -1530992060)
	      d = md5hh(d, a, b, c, x[i + 4], 11, 1272893353)
	      c = md5hh(c, d, a, b, x[i + 7], 16, -155497632)
	      b = md5hh(b, c, d, a, x[i + 10], 23, -1094730640)
	      a = md5hh(a, b, c, d, x[i + 13], 4, 681279174)
	      d = md5hh(d, a, b, c, x[i], 11, -358537222)
	      c = md5hh(c, d, a, b, x[i + 3], 16, -722521979)
	      b = md5hh(b, c, d, a, x[i + 6], 23, 76029189)
	      a = md5hh(a, b, c, d, x[i + 9], 4, -640364487)
	      d = md5hh(d, a, b, c, x[i + 12], 11, -421815835)
	      c = md5hh(c, d, a, b, x[i + 15], 16, 530742520)
	      b = md5hh(b, c, d, a, x[i + 2], 23, -995338651)
	
	      a = md5ii(a, b, c, d, x[i], 6, -198630844)
	      d = md5ii(d, a, b, c, x[i + 7], 10, 1126891415)
	      c = md5ii(c, d, a, b, x[i + 14], 15, -1416354905)
	      b = md5ii(b, c, d, a, x[i + 5], 21, -57434055)
	      a = md5ii(a, b, c, d, x[i + 12], 6, 1700485571)
	      d = md5ii(d, a, b, c, x[i + 3], 10, -1894986606)
	      c = md5ii(c, d, a, b, x[i + 10], 15, -1051523)
	      b = md5ii(b, c, d, a, x[i + 1], 21, -2054922799)
	      a = md5ii(a, b, c, d, x[i + 8], 6, 1873313359)
	      d = md5ii(d, a, b, c, x[i + 15], 10, -30611744)
	      c = md5ii(c, d, a, b, x[i + 6], 15, -1560198380)
	      b = md5ii(b, c, d, a, x[i + 13], 21, 1309151649)
	      a = md5ii(a, b, c, d, x[i + 4], 6, -145523070)
	      d = md5ii(d, a, b, c, x[i + 11], 10, -1120210379)
	      c = md5ii(c, d, a, b, x[i + 2], 15, 718787259)
	      b = md5ii(b, c, d, a, x[i + 9], 21, -343485551)
	
	      a = safeAdd(a, olda)
	      b = safeAdd(b, oldb)
	      c = safeAdd(c, oldc)
	      d = safeAdd(d, oldd)
	    }
	    return [a, b, c, d]
	  }
	
	  /**
	   * Convert an array of little-endian words to a string
	   *
	   * @param {Array<number>} input MD5 Array
	   * @returns {string} MD5 string
	   */
	  function binl2rstr(input) {
	    var i
	    var output = ''
	    var length32 = input.length * 32
	    for (i = 0; i < length32; i += 8) {
	      output += String.fromCharCode((input[i >> 5] >>> i % 32) & 0xff)
	    }
	    return output
	  }
	
	  /**
	   * Convert a raw string to an array of little-endian words
	   * Characters >255 have their high-byte silently ignored.
	   *
	   * @param {string} input Raw input string
	   * @returns {Array<number>} Array of little-endian words
	   */
	  function rstr2binl(input) {
	    var i
	    var output = []
	    output[(input.length >> 2) - 1] = undefined
	    for (i = 0; i < output.length; i += 1) {
	      output[i] = 0
	    }
	    var length8 = input.length * 8
	    for (i = 0; i < length8; i += 8) {
	      output[i >> 5] |= (input.charCodeAt(i / 8) & 0xff) << i % 32
	    }
	    return output
	  }
	
	  /**
	   * Calculate the MD5 of a raw string
	   *
	   * @param {string} s Input string
	   * @returns {string} Raw MD5 string
	   */
	  function rstrMD5(s) {
	    return binl2rstr(binlMD5(rstr2binl(s), s.length * 8))
	  }
	
	  /**
	   * Calculates the HMAC-MD5 of a key and some data (raw strings)
	   *
	   * @param {string} key HMAC key
	   * @param {string} data Raw input string
	   * @returns {string} Raw MD5 string
	   */
	  function rstrHMACMD5(key, data) {
	    var i
	    var bkey = rstr2binl(key)
	    var ipad = []
	    var opad = []
	    var hash
	    ipad[15] = opad[15] = undefined
	    if (bkey.length > 16) {
	      bkey = binlMD5(bkey, key.length * 8)
	    }
	    for (i = 0; i < 16; i += 1) {
	      ipad[i] = bkey[i] ^ 0x36363636
	      opad[i] = bkey[i] ^ 0x5c5c5c5c
	    }
	    hash = binlMD5(ipad.concat(rstr2binl(data)), 512 + data.length * 8)
	    return binl2rstr(binlMD5(opad.concat(hash), 512 + 128))
	  }
	
	  /**
	   * Convert a raw string to a hex string
	   *
	   * @param {string} input Raw input string
	   * @returns {string} Hex encoded string
	   */
	  function rstr2hex(input) {
	    var hexTab = '0123456789abcdef'
	    var output = ''
	    var x
	    var i
	    for (i = 0; i < input.length; i += 1) {
	      x = input.charCodeAt(i)
	      output += hexTab.charAt((x >>> 4) & 0x0f) + hexTab.charAt(x & 0x0f)
	    }
	    return output
	  }
	
	  /**
	   * Encode a string as UTF-8
	   *
	   * @param {string} input Input string
	   * @returns {string} UTF8 string
	   */
	  function str2rstrUTF8(input) {
	    return unescape(encodeURIComponent(input))
	  }
	
	  /**
	   * Encodes input string as raw MD5 string
	   *
	   * @param {string} s Input string
	   * @returns {string} Raw MD5 string
	   */
	  function rawMD5(s) {
	    return rstrMD5(str2rstrUTF8(s))
	  }
	  /**
	   * Encodes input string as Hex encoded string
	   *
	   * @param {string} s Input string
	   * @returns {string} Hex encoded string
	   */
	  function hexMD5(s) {
	    return rstr2hex(rawMD5(s))
	  }
	  /**
	   * Calculates the raw HMAC-MD5 for the given key and data
	   *
	   * @param {string} k HMAC key
	   * @param {string} d Input string
	   * @returns {string} Raw MD5 string
	   */
	  function rawHMACMD5(k, d) {
	    return rstrHMACMD5(str2rstrUTF8(k), str2rstrUTF8(d))
	  }
	  /**
	   * Calculates the Hex encoded HMAC-MD5 for the given key and data
	   *
	   * @param {string} k HMAC key
	   * @param {string} d Input string
	   * @returns {string} Raw MD5 string
	   */
	  function hexHMACMD5(k, d) {
	    return rstr2hex(rawHMACMD5(k, d))
	  }
	
	  /**
	   * Calculates MD5 value for a given string.
	   * If a key is provided, calculates the HMAC-MD5 value.
	   * Returns a Hex encoded string unless the raw argument is given.
	   *
	   * @param {string} string Input string
	   * @param {string} [key] HMAC key
	   * @param {boolean} [raw] Raw output switch
	   * @returns {string} MD5 output
	   */
	  function md5(string, key, raw) {
	    if (!key) {
	      if (!raw) {
	        return hexMD5(string)
	      }
	      return rawMD5(string)
	    }
	    if (!raw) {
	      return hexHMACMD5(key, string)
	    }
	    return rawHMACMD5(key, string)
	  }
	
	  if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	      return md5
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__))
	  } else if (typeof module === 'object' && module.exports) {
	    module.exports = md5
	  } else {
	    $.md5 = md5
	  }
	})(this)


/***/ },
/* 744 */
/***/ function(module, exports) {

	module.exports = function(arr, obj){
	  if (arr.indexOf) return arr.indexOf(obj);
	  for (var i = 0; i < arr.length; ++i) {
	    if (arr[i] === obj) return i;
	  }
	  return -1;
	};

/***/ },
/* 745 */
[3006, 445, 115],
/* 746 */
[3010, 195, 170],
/* 747 */
[3014, 169, 236, 746],
/* 748 */
[3015, 445],
/* 749 */
[3021, 331, 155, 754, 237, 238, 1901, 452, 752, 115],
/* 750 */
[3029, 196, 751],
/* 751 */
[3030, 753, 448],
/* 752 */
[3031, 194, 239, 453],
/* 753 */
[3032, 194, 196, 1893, 453],
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(237);


/***/ },
/* 755 */
[3042, 455],
/* 756 */
[3048, 745, 115, 238, 78],
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	var cof = __webpack_require__(116);
	module.exports = function (it, msg) {
	  if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	  return +it;
	};


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	'use strict';
	var toObject = __webpack_require__(75);
	var toAbsoluteIndex = __webpack_require__(205);
	var toLength = __webpack_require__(63);
	
	module.exports = [].copyWithin || function copyWithin(target /* = 0 */, start /* = 0, end = @length */) {
	  var O = toObject(this);
	  var len = toLength(O.length);
	  var to = toAbsoluteIndex(target, len);
	  var from = toAbsoluteIndex(start, len);
	  var end = arguments.length > 2 ? arguments[2] : undefined;
	  var count = Math.min((end === undefined ? len : toAbsoluteIndex(end, len)) - from, len - to);
	  var inc = 1;
	  if (from < to && to < from + count) {
	    inc = -1;
	    from += count - 1;
	    to += count - 1;
	  }
	  while (count-- > 0) {
	    if (from in O) O[to] = O[from];
	    else delete O[to];
	    to += inc;
	    from += inc;
	  } return O;
	};


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var forOf = __webpack_require__(198);
	
	module.exports = function (iter, ITERATOR) {
	  var result = [];
	  forOf(iter, false, result.push, result, ITERATOR);
	  return result;
	};


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var aFunction = __webpack_require__(84);
	var toObject = __webpack_require__(75);
	var IObject = __webpack_require__(277);
	var toLength = __webpack_require__(63);
	
	module.exports = function (that, callbackfn, aLen, memo, isRight) {
	  aFunction(callbackfn);
	  var O = toObject(that);
	  var self = IObject(O);
	  var length = toLength(O.length);
	  var index = isRight ? length - 1 : 0;
	  var i = isRight ? -1 : 1;
	  if (aLen < 2) for (;;) {
	    if (index in self) {
	      memo = self[index];
	      index += i;
	      break;
	    }
	    index += i;
	    if (isRight ? index < 0 : length <= index) {
	      throw TypeError('Reduce of empty array with no initial value');
	    }
	  }
	  for (;isRight ? index >= 0 : length > index; index += i) if (index in self) {
	    memo = callbackfn(memo, self[index], index, O);
	  }
	  return memo;
	};


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var aFunction = __webpack_require__(84);
	var isObject = __webpack_require__(45);
	var invoke = __webpack_require__(767);
	var arraySlice = [].slice;
	var factories = {};
	
	var construct = function (F, len, args) {
	  if (!(len in factories)) {
	    for (var n = [], i = 0; i < len; i++) n[i] = 'a[' + i + ']';
	    // eslint-disable-next-line no-new-func
	    factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	  } return factories[len](F, args);
	};
	
	module.exports = Function.bind || function bind(that /* , ...args */) {
	  var fn = aFunction(this);
	  var partArgs = arraySlice.call(arguments, 1);
	  var bound = function (/* args... */) {
	    var args = partArgs.concat(arraySlice.call(arguments));
	    return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	  };
	  if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	  return bound;
	};


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var dP = __webpack_require__(69).f;
	var create = __webpack_require__(199);
	var redefineAll = __webpack_require__(203);
	var ctx = __webpack_require__(118);
	var anInstance = __webpack_require__(197);
	var forOf = __webpack_require__(198);
	var $iterDefine = __webpack_require__(471);
	var step = __webpack_require__(770);
	var setSpecies = __webpack_require__(204);
	var DESCRIPTORS = __webpack_require__(65);
	var fastKey = __webpack_require__(174).fastKey;
	var validate = __webpack_require__(207);
	var SIZE = DESCRIPTORS ? '_s' : 'size';
	
	var getEntry = function (that, key) {
	  // fast case
	  var index = fastKey(key);
	  var entry;
	  if (index !== 'F') return that._i[index];
	  // frozen object case
	  for (entry = that._f; entry; entry = entry.n) {
	    if (entry.k == key) return entry;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;         // collection type
	      that._i = create(null); // index
	      that._f = undefined;    // first entry
	      that._l = undefined;    // last entry
	      that[SIZE] = 0;         // size
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.1.3.1 Map.prototype.clear()
	      // 23.2.3.2 Set.prototype.clear()
	      clear: function clear() {
	        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
	          entry.r = true;
	          if (entry.p) entry.p = entry.p.n = undefined;
	          delete data[entry.i];
	        }
	        that._f = that._l = undefined;
	        that[SIZE] = 0;
	      },
	      // 23.1.3.3 Map.prototype.delete(key)
	      // 23.2.3.4 Set.prototype.delete(value)
	      'delete': function (key) {
	        var that = validate(this, NAME);
	        var entry = getEntry(that, key);
	        if (entry) {
	          var next = entry.n;
	          var prev = entry.p;
	          delete that._i[entry.i];
	          entry.r = true;
	          if (prev) prev.n = next;
	          if (next) next.p = prev;
	          if (that._f == entry) that._f = next;
	          if (that._l == entry) that._l = prev;
	          that[SIZE]--;
	        } return !!entry;
	      },
	      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	      forEach: function forEach(callbackfn /* , that = undefined */) {
	        validate(this, NAME);
	        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
	        var entry;
	        while (entry = entry ? entry.n : this._f) {
	          f(entry.v, entry.k, this);
	          // revert to the last existing entry
	          while (entry && entry.r) entry = entry.p;
	        }
	      },
	      // 23.1.3.7 Map.prototype.has(key)
	      // 23.2.3.7 Set.prototype.has(value)
	      has: function has(key) {
	        return !!getEntry(validate(this, NAME), key);
	      }
	    });
	    if (DESCRIPTORS) dP(C.prototype, 'size', {
	      get: function () {
	        return validate(this, NAME)[SIZE];
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var entry = getEntry(that, key);
	    var prev, index;
	    // change existing entry
	    if (entry) {
	      entry.v = value;
	    // create new entry
	    } else {
	      that._l = entry = {
	        i: index = fastKey(key, true), // <- index
	        k: key,                        // <- key
	        v: value,                      // <- value
	        p: prev = that._l,             // <- previous entry
	        n: undefined,                  // <- next entry
	        r: false                       // <- removed
	      };
	      if (!that._f) that._f = entry;
	      if (prev) prev.n = entry;
	      that[SIZE]++;
	      // add to index
	      if (index !== 'F') that._i[index] = entry;
	    } return that;
	  },
	  getEntry: getEntry,
	  setStrong: function (C, NAME, IS_MAP) {
	    // add .keys, .values, .entries, [@@iterator]
	    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	    $iterDefine(C, NAME, function (iterated, kind) {
	      this._t = validate(iterated, NAME); // target
	      this._k = kind;                     // kind
	      this._l = undefined;                // previous
	    }, function () {
	      var that = this;
	      var kind = that._k;
	      var entry = that._l;
	      // revert to the last existing entry
	      while (entry && entry.r) entry = entry.p;
	      // get next entry
	      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	        // or finish the iteration
	        that._t = undefined;
	        return step(1);
	      }
	      // return step by kind
	      if (kind == 'keys') return step(0, entry.k);
	      if (kind == 'values') return step(0, entry.v);
	      return step(0, [entry.k, entry.v]);
	    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	    // add [@@species], 23.1.2.2, 23.2.2.2
	    setSpecies(NAME);
	  }
	};


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var classof = __webpack_require__(240);
	var from = __webpack_require__(759);
	module.exports = function (NAME) {
	  return function toJSON() {
	    if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	    return from(this);
	  };
	};


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var redefineAll = __webpack_require__(203);
	var getWeak = __webpack_require__(174).getWeak;
	var anObject = __webpack_require__(31);
	var isObject = __webpack_require__(45);
	var anInstance = __webpack_require__(197);
	var forOf = __webpack_require__(198);
	var createArrayMethod = __webpack_require__(135);
	var $has = __webpack_require__(104);
	var validate = __webpack_require__(207);
	var arrayFind = createArrayMethod(5);
	var arrayFindIndex = createArrayMethod(6);
	var id = 0;
	
	// fallback for uncaught frozen keys
	var uncaughtFrozenStore = function (that) {
	  return that._l || (that._l = new UncaughtFrozenStore());
	};
	var UncaughtFrozenStore = function () {
	  this.a = [];
	};
	var findUncaughtFrozen = function (store, key) {
	  return arrayFind(store.a, function (it) {
	    return it[0] === key;
	  });
	};
	UncaughtFrozenStore.prototype = {
	  get: function (key) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) return entry[1];
	  },
	  has: function (key) {
	    return !!findUncaughtFrozen(this, key);
	  },
	  set: function (key, value) {
	    var entry = findUncaughtFrozen(this, key);
	    if (entry) entry[1] = value;
	    else this.a.push([key, value]);
	  },
	  'delete': function (key) {
	    var index = arrayFindIndex(this.a, function (it) {
	      return it[0] === key;
	    });
	    if (~index) this.a.splice(index, 1);
	    return !!~index;
	  }
	};
	
	module.exports = {
	  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
	    var C = wrapper(function (that, iterable) {
	      anInstance(that, C, NAME, '_i');
	      that._t = NAME;      // collection type
	      that._i = id++;      // collection id
	      that._l = undefined; // leak store for uncaught frozen objects
	      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	    });
	    redefineAll(C.prototype, {
	      // 23.3.3.2 WeakMap.prototype.delete(key)
	      // 23.4.3.3 WeakSet.prototype.delete(value)
	      'delete': function (key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME))['delete'](key);
	        return data && $has(data, this._i) && delete data[this._i];
	      },
	      // 23.3.3.4 WeakMap.prototype.has(key)
	      // 23.4.3.4 WeakSet.prototype.has(value)
	      has: function has(key) {
	        if (!isObject(key)) return false;
	        var data = getWeak(key);
	        if (data === true) return uncaughtFrozenStore(validate(this, NAME)).has(key);
	        return data && $has(data, this._i);
	      }
	    });
	    return C;
	  },
	  def: function (that, key, value) {
	    var data = getWeak(anObject(key), true);
	    if (data === true) uncaughtFrozenStore(that).set(key, value);
	    else data[that._i] = value;
	    return that;
	  },
	  ufstore: uncaughtFrozenStore
	};


/***/ },
/* 765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
	var isArray = __webpack_require__(339);
	var isObject = __webpack_require__(45);
	var toLength = __webpack_require__(63);
	var ctx = __webpack_require__(118);
	var IS_CONCAT_SPREADABLE = __webpack_require__(58)('isConcatSpreadable');
	
	function flattenIntoArray(target, original, source, sourceLen, start, depth, mapper, thisArg) {
	  var targetIndex = start;
	  var sourceIndex = 0;
	  var mapFn = mapper ? ctx(mapper, thisArg, 3) : false;
	  var element, spreadable;
	
	  while (sourceIndex < sourceLen) {
	    if (sourceIndex in source) {
	      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];
	
	      spreadable = false;
	      if (isObject(element)) {
	        spreadable = element[IS_CONCAT_SPREADABLE];
	        spreadable = spreadable !== undefined ? !!spreadable : isArray(element);
	      }
	
	      if (spreadable && depth > 0) {
	        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
	      } else {
	        if (targetIndex >= 0x1fffffffffffff) throw TypeError();
	        target[targetIndex] = element;
	      }
	
	      targetIndex++;
	    }
	    sourceIndex++;
	  }
	  return targetIndex;
	}
	
	module.exports = flattenIntoArray;


/***/ },
/* 766 */
[3014, 65, 43, 464],
/* 767 */
/***/ function(module, exports) {

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	module.exports = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};


/***/ },
/* 768 */
[3018, 45],
/* 769 */
[3019, 31],
/* 770 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var sign = __webpack_require__(473);
	var pow = Math.pow;
	var EPSILON = pow(2, -52);
	var EPSILON32 = pow(2, -23);
	var MAX32 = pow(2, 127) * (2 - EPSILON32);
	var MIN32 = pow(2, -126);
	
	var roundTiesToEven = function (n) {
	  return n + 1 / EPSILON - 1 / EPSILON;
	};
	
	module.exports = Math.fround || function fround(x) {
	  var $abs = Math.abs(x);
	  var $sign = sign(x);
	  var a, result;
	  if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	  a = (1 + EPSILON32 / EPSILON) * $abs;
	  result = a - (a - $abs);
	  // eslint-disable-next-line no-self-compare
	  if (result > MAX32 || result != result) return $sign * Infinity;
	  return $sign * result;
	};


/***/ },
/* 772 */
/***/ function(module, exports) {

	// 20.2.2.20 Math.log1p(x)
	module.exports = Math.log1p || function log1p(x) {
	  return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	};


/***/ },
/* 773 */
/***/ function(module, exports) {

	// https://rwaldron.github.io/proposal-math-extensions/
	module.exports = Math.scale || function scale(x, inLow, inHigh, outLow, outHigh) {
	  if (
	    arguments.length === 0
	      // eslint-disable-next-line no-self-compare
	      || x != x
	      // eslint-disable-next-line no-self-compare
	      || inLow != inLow
	      // eslint-disable-next-line no-self-compare
	      || inHigh != inHigh
	      // eslint-disable-next-line no-self-compare
	      || outLow != outLow
	      // eslint-disable-next-line no-self-compare
	      || outHigh != outHigh
	  ) return NaN;
	  if (x === Infinity || x === -Infinity) return x;
	  return (x - inLow) * (outHigh - outLow) / (inHigh - inLow) + outLow;
	};


/***/ },
/* 774 */
[3024, 65, 201, 343, 278, 75, 277, 43],
/* 775 */
[3027, 69, 31, 201, 65],
/* 776 */
[3029, 107, 200],
/* 777 */
[3032, 104, 107, 336, 478],
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	var DESCRIPTORS = __webpack_require__(65);
	var getKeys = __webpack_require__(201);
	var toIObject = __webpack_require__(107);
	var isEnum = __webpack_require__(278).f;
	module.exports = function (isEntries) {
	  return function (it) {
	    var O = toIObject(it);
	    var keys = getKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!DESCRIPTORS || isEnum.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	// all object keys, includes non-enumerable and symbols
	var gOPN = __webpack_require__(200);
	var gOPS = __webpack_require__(343);
	var anObject = __webpack_require__(31);
	var Reflect = __webpack_require__(42).Reflect;
	module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = gOPN.f(anObject(it));
	  var getSymbols = gOPS.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	var $parseFloat = __webpack_require__(42).parseFloat;
	var $trim = __webpack_require__(243).trim;
	
	module.exports = 1 / $parseFloat(__webpack_require__(481) + '-0') !== -Infinity ? function parseFloat(str) {
	  var string = $trim(String(str), 3);
	  var result = $parseFloat(string);
	  return result === 0 && string.charAt(0) == '-' ? -0 : result;
	} : $parseFloat;


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	var $parseInt = __webpack_require__(42).parseInt;
	var $trim = __webpack_require__(243).trim;
	var ws = __webpack_require__(481);
	var hex = /^[-+]?0[xX]/;
	
	module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;


/***/ },
/* 782 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};


/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(31);
	var isObject = __webpack_require__(45);
	var newPromiseCapability = __webpack_require__(475);
	
	module.exports = function (C, x) {
	  anObject(C);
	  if (isObject(x) && x.constructor === C) return x;
	  var promiseCapability = newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};


/***/ },
/* 784 */
/***/ function(module, exports) {

	// 7.2.9 SameValue(x, y)
	module.exports = Object.is || function is(x, y) {
	  // eslint-disable-next-line no-self-compare
	  return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	};


/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-string-pad-start-end
	var toLength = __webpack_require__(63);
	var repeat = __webpack_require__(480);
	var defined = __webpack_require__(136);
	
	module.exports = function (that, maxLength, fillString, left) {
	  var S = String(defined(that));
	  var stringLength = S.length;
	  var fillStr = fillString === undefined ? ' ' : String(fillString);
	  var intMaxLength = toLength(maxLength);
	  if (intMaxLength <= stringLength || fillStr == '') return S;
	  var fillLen = intMaxLength - stringLength;
	  var stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	  if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	  return left ? stringFiller + S : S + stringFiller;
	};


/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/ecma262/#sec-toindex
	var toInteger = __webpack_require__(120);
	var toLength = __webpack_require__(63);
	module.exports = function (it) {
	  if (it === undefined) return 0;
	  var number = toInteger(it);
	  var length = toLength(number);
	  if (number !== length) throw RangeError('Wrong length!');
	  return length;
	};


/***/ },
/* 787 */
[3046, 58],
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(762);
	var validate = __webpack_require__(207);
	var MAP = 'Map';
	
	// 23.1 Map Objects
	module.exports = __webpack_require__(337)(MAP, function (get) {
	  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.1.3.6 Map.prototype.get(key)
	  get: function get(key) {
	    var entry = strong.getEntry(validate(this, MAP), key);
	    return entry && entry.v;
	  },
	  // 23.1.3.9 Map.prototype.set(key, value)
	  set: function set(key, value) {
	    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
	  }
	}, strong, true);


/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var regexpExec = __webpack_require__(476);
	__webpack_require__(7)({
	  target: 'RegExp',
	  proto: true,
	  forced: regexpExec !== /./.exec
	}, {
	  exec: regexpExec
	});


/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	// 21.2.5.3 get RegExp.prototype.flags()
	if (__webpack_require__(65) && /./g.flags != 'g') __webpack_require__(69).f(RegExp.prototype, 'flags', {
	  configurable: true,
	  get: __webpack_require__(276)
	});


/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strong = __webpack_require__(762);
	var validate = __webpack_require__(207);
	var SET = 'Set';
	
	// 23.2 Set Objects
	module.exports = __webpack_require__(337)(SET, function (get) {
	  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.2.3.1 Set.prototype.add(value)
	  add: function add(value) {
	    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
	  }
	}, strong);


/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(42);
	var each = __webpack_require__(135)(0);
	var redefine = __webpack_require__(98);
	var meta = __webpack_require__(174);
	var assign = __webpack_require__(774);
	var weak = __webpack_require__(764);
	var isObject = __webpack_require__(45);
	var validate = __webpack_require__(207);
	var NATIVE_WEAK_MAP = __webpack_require__(207);
	var IS_IE11 = !global.ActiveXObject && 'ActiveXObject' in global;
	var WEAK_MAP = 'WeakMap';
	var getWeak = meta.getWeak;
	var isExtensible = Object.isExtensible;
	var uncaughtFrozenStore = weak.ufstore;
	var InternalMap;
	
	var wrapper = function (get) {
	  return function WeakMap() {
	    return get(this, arguments.length > 0 ? arguments[0] : undefined);
	  };
	};
	
	var methods = {
	  // 23.3.3.3 WeakMap.prototype.get(key)
	  get: function get(key) {
	    if (isObject(key)) {
	      var data = getWeak(key);
	      if (data === true) return uncaughtFrozenStore(validate(this, WEAK_MAP)).get(key);
	      return data ? data[this._i] : undefined;
	    }
	  },
	  // 23.3.3.5 WeakMap.prototype.set(key, value)
	  set: function set(key, value) {
	    return weak.def(validate(this, WEAK_MAP), key, value);
	  }
	};
	
	// 23.3 WeakMap Objects
	var $WeakMap = module.exports = __webpack_require__(337)(WEAK_MAP, wrapper, methods, weak, true, true);
	
	// IE11 WeakMap frozen keys fix
	if (NATIVE_WEAK_MAP && IS_IE11) {
	  InternalMap = weak.getConstructor(wrapper, WEAK_MAP);
	  assign(InternalMap.prototype, methods);
	  meta.NEED = true;
	  each(['delete', 'has', 'get', 'set'], function (key) {
	    var proto = $WeakMap.prototype;
	    var method = proto[key];
	    redefine(proto, key, function (a, b) {
	      // store frozen objects on internal weakmap shim
	      if (isObject(a) && !isExtensible(a)) {
	        if (!this._f) this._f = new InternalMap();
	        var result = this._f[key](a, b);
	        return key == 'set' ? this : result;
	      // store all the rest on native weakmap
	      } return method.call(this, a, b);
	    });
	  });
	}


/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(2126);
	
	// -- Inlined from fbjs --
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function _invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	var warning = function(){};
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	// /-- Inlined from fbjs --
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillMount`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillReceiveProps`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Replacement for (deprecated) `componentWillUpdate`.
	     *
	     * @optional
	     */
	    UNSAFE_componentWillUpdate: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Similar to ReactClassInterface but for static methods.
	   */
	  var ReactClassStaticInterface = {
	    /**
	     * This method is invoked after a component is instantiated and when it
	     * receives new props. Return an object to update state in response to
	     * prop changes. Return null to indicate no change to state.
	     *
	     * If an object is returned, its keys will be merged into the existing state.
	     *
	     * @return {object || null}
	     * @optional
	     */
	    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isAlreadyDefined = name in Constructor;
	      if (isAlreadyDefined) {
	        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
	          ? ReactClassStaticInterface[name]
	          : null;
	
	        _invariant(
	          specPolicy === 'DEFINE_MANY_MERGED',
	          'ReactClass: You are attempting to define ' +
	            '`%s` on your component more than once. This conflict may be ' +
	            'due to a mixin.',
	          name
	        );
	
	        Constructor[name] = createMergedResultFunction(Constructor[name], property);
	
	        return;
	      }
	
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
	        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
	          'Did you mean UNSAFE_componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 794 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var START_EVENT_NAME_MAP = {
	  transitionstart: {
	    transition: 'transitionstart',
	    WebkitTransition: 'webkitTransitionStart',
	    MozTransition: 'mozTransitionStart',
	    OTransition: 'oTransitionStart',
	    msTransition: 'MSTransitionStart'
	  },
	
	  animationstart: {
	    animation: 'animationstart',
	    WebkitAnimation: 'webkitAnimationStart',
	    MozAnimation: 'mozAnimationStart',
	    OAnimation: 'oAnimationStart',
	    msAnimation: 'MSAnimationStart'
	  }
	};
	
	var END_EVENT_NAME_MAP = {
	  transitionend: {
	    transition: 'transitionend',
	    WebkitTransition: 'webkitTransitionEnd',
	    MozTransition: 'mozTransitionEnd',
	    OTransition: 'oTransitionEnd',
	    msTransition: 'MSTransitionEnd'
	  },
	
	  animationend: {
	    animation: 'animationend',
	    WebkitAnimation: 'webkitAnimationEnd',
	    MozAnimation: 'mozAnimationEnd',
	    OAnimation: 'oAnimationEnd',
	    msAnimation: 'MSAnimationEnd'
	  }
	};
	
	var startEvents = [];
	var endEvents = [];
	
	function detectEvents() {
	  var testEl = document.createElement('div');
	  var style = testEl.style;
	
	  if (!('AnimationEvent' in window)) {
	    delete START_EVENT_NAME_MAP.animationstart.animation;
	    delete END_EVENT_NAME_MAP.animationend.animation;
	  }
	
	  if (!('TransitionEvent' in window)) {
	    delete START_EVENT_NAME_MAP.transitionstart.transition;
	    delete END_EVENT_NAME_MAP.transitionend.transition;
	  }
	
	  function process(EVENT_NAME_MAP, events) {
	    for (var baseEventName in EVENT_NAME_MAP) {
	      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
	        var baseEvents = EVENT_NAME_MAP[baseEventName];
	        for (var styleName in baseEvents) {
	          if (styleName in style) {
	            events.push(baseEvents[styleName]);
	            break;
	          }
	        }
	      }
	    }
	  }
	
	  process(START_EVENT_NAME_MAP, startEvents);
	  process(END_EVENT_NAME_MAP, endEvents);
	}
	
	if (typeof window !== 'undefined' && typeof document !== 'undefined') {
	  detectEvents();
	}
	
	function addEventListener(node, eventName, eventListener) {
	  node.addEventListener(eventName, eventListener, false);
	}
	
	function removeEventListener(node, eventName, eventListener) {
	  node.removeEventListener(eventName, eventListener, false);
	}
	
	var TransitionEvents = {
	  // Start events
	  startEvents: startEvents,
	
	  addStartEventListener: function addStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      addEventListener(node, startEvent, eventListener);
	    });
	  },
	  removeStartEventListener: function removeStartEventListener(node, eventListener) {
	    if (startEvents.length === 0) {
	      return;
	    }
	    startEvents.forEach(function (startEvent) {
	      removeEventListener(node, startEvent, eventListener);
	    });
	  },
	
	
	  // End events
	  endEvents: endEvents,
	
	  addEndEventListener: function addEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      window.setTimeout(eventListener, 0);
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      addEventListener(node, endEvent, eventListener);
	    });
	  },
	  removeEndEventListener: function removeEndEventListener(node, eventListener) {
	    if (endEvents.length === 0) {
	      return;
	    }
	    endEvents.forEach(function (endEvent) {
	      removeEventListener(node, endEvent, eventListener);
	    });
	  }
	};
	
	exports['default'] = TransitionEvents;
	module.exports = exports['default'];

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule BlockTree
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(39);
	
	var emptyFunction = __webpack_require__(101);
	var findRangesImmutable = __webpack_require__(284);
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat,
	    Record = Immutable.Record;
	
	
	var returnTrue = emptyFunction.thatReturnsTrue;
	
	var FINGERPRINT_DELIMITER = '-';
	
	var defaultLeafRange = {
	  start: null,
	  end: null
	};
	
	var LeafRange = Record(defaultLeafRange);
	
	var defaultDecoratorRange = {
	  start: null,
	  end: null,
	  decoratorKey: null,
	  leaves: null
	};
	
	var DecoratorRange = Record(defaultDecoratorRange);
	
	var BlockTree = {
	  /**
	   * Generate a block tree for a given ContentBlock/decorator pair.
	   */
	  generate: function generate(contentState, block, decorator) {
	    var textLength = block.getLength();
	    if (!textLength) {
	      return List.of(new DecoratorRange({
	        start: 0,
	        end: 0,
	        decoratorKey: null,
	        leaves: List.of(new LeafRange({ start: 0, end: 0 }))
	      }));
	    }
	
	    var leafSets = [];
	    var decorations = decorator ? decorator.getDecorations(block, contentState) : List(Repeat(null, textLength));
	
	    var chars = block.getCharacterList();
	
	    findRangesImmutable(decorations, areEqual, returnTrue, function (start, end) {
	      leafSets.push(new DecoratorRange({
	        start: start,
	        end: end,
	        decoratorKey: decorations.get(start),
	        leaves: generateLeaves(chars.slice(start, end).toList(), start)
	      }));
	    });
	
	    return List(leafSets);
	  },
	
	  /**
	   * Create a string representation of the given tree map. This allows us
	   * to rapidly determine whether a tree has undergone a significant
	   * structural change.
	   */
	  getFingerprint: function getFingerprint(tree) {
	    return tree.map(function (leafSet) {
	      var decoratorKey = leafSet.get('decoratorKey');
	      var fingerprintString = decoratorKey !== null ? decoratorKey + '.' + (leafSet.get('end') - leafSet.get('start')) : '';
	      return '' + fingerprintString + '.' + leafSet.get('leaves').size;
	    }).join(FINGERPRINT_DELIMITER);
	  }
	};
	
	/**
	 * Generate LeafRange records for a given character list.
	 */
	function generateLeaves(characters, offset) {
	  var leaves = [];
	  var inlineStyles = characters.map(function (c) {
	    return c.getStyle();
	  }).toList();
	  findRangesImmutable(inlineStyles, areEqual, returnTrue, function (start, end) {
	    leaves.push(new LeafRange({
	      start: start + offset,
	      end: end + offset
	    }));
	  });
	  return List(leaves);
	}
	
	function areEqual(a, b) {
	  return a === b;
	}
	
	module.exports = BlockTree;

/***/ },
/* 796 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DefaultDraftInlineStyle
	 * @format
	 * 
	 */
	
	'use strict';
	
	module.exports = {
	  BOLD: {
	    fontWeight: 'bold'
	  },
	
	  CODE: {
	    fontFamily: 'monospace',
	    wordWrap: 'break-word'
	  },
	
	  ITALIC: {
	    fontStyle: 'italic'
	  },
	
	  STRIKETHROUGH: {
	    textDecoration: 'line-through'
	  },
	
	  UNDERLINE: {
	    textDecoration: 'underline'
	  }
	};

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorBlock.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorLeaf = __webpack_require__(2142);
	var DraftOffsetKey = __webpack_require__(283);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(23);
	var Scroll = __webpack_require__(883);
	var Style = __webpack_require__(520);
	var UnicodeBidi = __webpack_require__(884);
	var UnicodeBidiDirection = __webpack_require__(521);
	
	var cx = __webpack_require__(253);
	var getElementPosition = __webpack_require__(2471);
	var getScrollPosition = __webpack_require__(523);
	var getViewportDimensions = __webpack_require__(2475);
	var invariant = __webpack_require__(18);
	var nullthrows = __webpack_require__(123);
	
	var SCROLL_BUFFER = 10;
	
	/**
	 * Return whether a block overlaps with either edge of the `SelectionState`.
	 */
	var isBlockOnSelectionEdge = function isBlockOnSelectionEdge(selection, key) {
	  return selection.getAnchorKey() === key || selection.getFocusKey() === key;
	};
	
	/**
	 * The default block renderer for a `DraftEditor` component.
	 *
	 * A `DraftEditorBlock` is able to render a given `ContentBlock` to its
	 * appropriate decorator and inline style components.
	 */
	
	var DraftEditorBlock = function (_React$Component) {
	  _inherits(DraftEditorBlock, _React$Component);
	
	  function DraftEditorBlock() {
	    _classCallCheck(this, DraftEditorBlock);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorBlock.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.block !== nextProps.block || this.props.tree !== nextProps.tree || this.props.direction !== nextProps.direction || isBlockOnSelectionEdge(nextProps.selection, nextProps.block.getKey()) && nextProps.forceSelection;
	  };
	
	  /**
	   * When a block is mounted and overlaps the selection state, we need to make
	   * sure that the cursor is visible to match native behavior. This may not
	   * be the case if the user has pressed `RETURN` or pasted some content, since
	   * programatically creating these new blocks and setting the DOM selection
	   * will miss out on the browser natively scrolling to that position.
	   *
	   * To replicate native behavior, if the block overlaps the selection state
	   * on mount, force the scroll position. Check the scroll state of the scroll
	   * parent, and adjust it to align the entire block to the bottom of the
	   * scroll parent.
	   */
	
	
	  DraftEditorBlock.prototype.componentDidMount = function componentDidMount() {
	    var selection = this.props.selection;
	    var endKey = selection.getEndKey();
	    if (!selection.getHasFocus() || endKey !== this.props.block.getKey()) {
	      return;
	    }
	
	    var blockNode = ReactDOM.findDOMNode(this);
	    var scrollParent = Style.getScrollParent(blockNode);
	    var scrollPosition = getScrollPosition(scrollParent);
	    var scrollDelta = void 0;
	
	    if (scrollParent === window) {
	      var nodePosition = getElementPosition(blockNode);
	      var nodeBottom = nodePosition.y + nodePosition.height;
	      var viewportHeight = getViewportDimensions().height;
	      scrollDelta = nodeBottom - viewportHeight;
	      if (scrollDelta > 0) {
	        window.scrollTo(scrollPosition.x, scrollPosition.y + scrollDelta + SCROLL_BUFFER);
	      }
	    } else {
	      !(blockNode instanceof HTMLElement) ?  false ? invariant(false, 'blockNode is not an HTMLElement') : invariant(false) : void 0;
	      var blockBottom = blockNode.offsetHeight + blockNode.offsetTop;
	      var scrollBottom = scrollParent.offsetHeight + scrollPosition.y;
	      scrollDelta = blockBottom - scrollBottom;
	      if (scrollDelta > 0) {
	        Scroll.setTop(scrollParent, Scroll.getTop(scrollParent) + scrollDelta + SCROLL_BUFFER);
	      }
	    }
	  };
	
	  DraftEditorBlock.prototype._renderChildren = function _renderChildren() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var blockKey = block.getKey();
	    var text = block.getText();
	    var lastLeafSet = this.props.tree.size - 1;
	    var hasSelection = isBlockOnSelectionEdge(this.props.selection, blockKey);
	
	    return this.props.tree.map(function (leafSet, ii) {
	      var leavesForLeafSet = leafSet.get('leaves');
	      var lastLeaf = leavesForLeafSet.size - 1;
	      var leaves = leavesForLeafSet.map(function (leaf, jj) {
	        var offsetKey = DraftOffsetKey.encode(blockKey, ii, jj);
	        var start = leaf.get('start');
	        var end = leaf.get('end');
	        return React.createElement(DraftEditorLeaf, {
	          key: offsetKey,
	          offsetKey: offsetKey,
	          block: block,
	          start: start,
	          selection: hasSelection ? _this2.props.selection : null,
	          forceSelection: _this2.props.forceSelection,
	          text: text.slice(start, end),
	          styleSet: block.getInlineStyleAt(start),
	          customStyleMap: _this2.props.customStyleMap,
	          customStyleFn: _this2.props.customStyleFn,
	          isLast: ii === lastLeafSet && jj === lastLeaf
	        });
	      }).toArray();
	
	      var decoratorKey = leafSet.get('decoratorKey');
	      if (decoratorKey == null) {
	        return leaves;
	      }
	
	      if (!_this2.props.decorator) {
	        return leaves;
	      }
	
	      var decorator = nullthrows(_this2.props.decorator);
	
	      var DecoratorComponent = decorator.getComponentForKey(decoratorKey);
	      if (!DecoratorComponent) {
	        return leaves;
	      }
	
	      var decoratorProps = decorator.getPropsForKey(decoratorKey);
	      var decoratorOffsetKey = DraftOffsetKey.encode(blockKey, ii, 0);
	      var decoratedText = text.slice(leavesForLeafSet.first().get('start'), leavesForLeafSet.last().get('end'));
	
	      // Resetting dir to the same value on a child node makes Chrome/Firefox
	      // confused on cursor movement. See http://jsfiddle.net/d157kLck/3/
	      var dir = UnicodeBidiDirection.getHTMLDirIfDifferent(UnicodeBidi.getDirection(decoratedText), _this2.props.direction);
	
	      return React.createElement(
	        DecoratorComponent,
	        _extends({}, decoratorProps, {
	          contentState: _this2.props.contentState,
	          decoratedText: decoratedText,
	          dir: dir,
	          key: decoratorOffsetKey,
	          entityKey: block.getEntityAt(leafSet.get('start')),
	          offsetKey: decoratorOffsetKey }),
	        leaves
	      );
	    }).toArray();
	  };
	
	  DraftEditorBlock.prototype.render = function render() {
	    var _props = this.props,
	        direction = _props.direction,
	        offsetKey = _props.offsetKey;
	
	    var className = cx({
	      'public/DraftStyleDefault/block': true,
	      'public/DraftStyleDefault/ltr': direction === 'LTR',
	      'public/DraftStyleDefault/rtl': direction === 'RTL'
	    });
	
	    return React.createElement(
	      'div',
	      { 'data-offset-key': offsetKey, className: className },
	      this._renderChildren()
	    );
	  };
	
	  return DraftEditorBlock;
	}(React.Component);
	
	module.exports = DraftEditorBlock;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntityInstance
	 * @legacyServerCallableInstance
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Immutable = __webpack_require__(39);
	
	var Record = Immutable.Record;
	
	
	var DraftEntityInstanceRecord = Record({
	  type: 'TOKEN',
	  mutability: 'IMMUTABLE',
	  data: Object
	});
	
	/**
	 * An instance of a document entity, consisting of a `type` and relevant
	 * `data`, metadata about the entity.
	 *
	 * For instance, a "link" entity might provide a URI, and a "mention"
	 * entity might provide the mentioned user's ID. These pieces of data
	 * may be used when rendering the entity as part of a ContentBlock DOM
	 * representation. For a link, the data would be used as an href for
	 * the rendered anchor. For a mention, the ID could be used to retrieve
	 * a hovercard.
	 */
	
	var DraftEntityInstance = function (_DraftEntityInstanceR) {
	  _inherits(DraftEntityInstance, _DraftEntityInstanceR);
	
	  function DraftEntityInstance() {
	    _classCallCheck(this, DraftEntityInstance);
	
	    return _possibleConstructorReturn(this, _DraftEntityInstanceR.apply(this, arguments));
	  }
	
	  DraftEntityInstance.prototype.getType = function getType() {
	    return this.get('type');
	  };
	
	  DraftEntityInstance.prototype.getMutability = function getMutability() {
	    return this.get('mutability');
	  };
	
	  DraftEntityInstance.prototype.getData = function getData() {
	    return this.get('data');
	  };
	
	  return DraftEntityInstance;
	}(DraftEntityInstanceRecord);
	
	module.exports = DraftEntityInstance;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftRemovableWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var TokenizeUtil = __webpack_require__(2463);
	
	var punctuation = TokenizeUtil.getPunctuation();
	
	// The apostrophe and curly single quotes behave in a curious way: when
	// surrounded on both sides by word characters, they behave as word chars; when
	// either neighbor is punctuation or an end of the string, they behave as
	// punctuation.
	var CHAMELEON_CHARS = '[\'\u2018\u2019]';
	
	// Remove the underscore, which should count as part of the removable word. The
	// "chameleon chars" also count as punctuation in this regex.
	var WHITESPACE_AND_PUNCTUATION = '\\s|(?![_])' + punctuation;
	
	var DELETE_STRING = '^' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)';
	var DELETE_REGEX = new RegExp(DELETE_STRING);
	
	var BACKSPACE_STRING = '(?:(?!' + WHITESPACE_AND_PUNCTUATION + ').)' + '(?:' + CHAMELEON_CHARS + '|(?!' + WHITESPACE_AND_PUNCTUATION + ').)*' + '(?:' + WHITESPACE_AND_PUNCTUATION + ')*' + '$';
	var BACKSPACE_REGEX = new RegExp(BACKSPACE_STRING);
	
	function getRemovableWord(text, isBackward) {
	  var matches = isBackward ? BACKSPACE_REGEX.exec(text) : DELETE_REGEX.exec(text);
	  return matches ? matches[0] : text;
	}
	
	var DraftRemovableWord = {
	  getBackward: function getBackward(text) {
	    return getRemovableWord(text, true);
	  },
	
	  getForward: function getForward(text) {
	    return getRemovableWord(text, false);
	  }
	};
	
	module.exports = DraftRemovableWord;

/***/ },
/* 800 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftStringKey
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = {
	  stringify: function stringify(key) {
	    return '_' + String(key);
	  },
	
	  unstringify: function unstringify(key) {
	    return key.slice(1);
	  }
	};
	
	module.exports = DraftStringKey;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule RichTextEditorUtil
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(92);
	var EditorState = __webpack_require__(52);
	var SelectionState = __webpack_require__(244);
	
	var adjustBlockDepthForContentState = __webpack_require__(2152);
	var nullthrows = __webpack_require__(123);
	
	var RichTextEditorUtil = {
	  currentBlockContainsLink: function currentBlockContainsLink(editorState) {
	    var selection = editorState.getSelection();
	    var contentState = editorState.getCurrentContent();
	    var entityMap = contentState.getEntityMap();
	    return contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList().slice(selection.getStartOffset(), selection.getEndOffset()).some(function (v) {
	      var entity = v.getEntity();
	      return !!entity && entityMap.__get(entity).getType() === 'LINK';
	    });
	  },
	
	  getCurrentBlockType: function getCurrentBlockType(editorState) {
	    var selection = editorState.getSelection();
	    return editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();
	  },
	
	  getDataObjectForLinkURL: function getDataObjectForLinkURL(uri) {
	    return { url: uri.toString() };
	  },
	
	  handleKeyCommand: function handleKeyCommand(editorState, command) {
	    switch (command) {
	      case 'bold':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'BOLD');
	      case 'italic':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'ITALIC');
	      case 'underline':
	        return RichTextEditorUtil.toggleInlineStyle(editorState, 'UNDERLINE');
	      case 'code':
	        return RichTextEditorUtil.toggleCode(editorState);
	      case 'backspace':
	      case 'backspace-word':
	      case 'backspace-to-start-of-line':
	        return RichTextEditorUtil.onBackspace(editorState);
	      case 'delete':
	      case 'delete-word':
	      case 'delete-to-end-of-block':
	        return RichTextEditorUtil.onDelete(editorState);
	      default:
	        // they may have custom editor commands; ignore those
	        return null;
	    }
	  },
	
	  insertSoftNewline: function insertSoftNewline(editorState) {
	    var contentState = DraftModifier.insertText(editorState.getCurrentContent(), editorState.getSelection(), '\n', editorState.getCurrentInlineStyle(), null);
	
	    var newEditorState = EditorState.push(editorState, contentState, 'insert-characters');
	
	    return EditorState.forceSelection(newEditorState, contentState.getSelectionAfter());
	  },
	
	  /**
	   * For collapsed selections at the start of styled blocks, backspace should
	   * just remove the existing style.
	   */
	  onBackspace: function onBackspace(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed() || selection.getAnchorOffset() || selection.getFocusOffset()) {
	      return null;
	    }
	
	    // First, try to remove a preceding atomic block.
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var blockBefore = content.getBlockBefore(startKey);
	
	    if (blockBefore && blockBefore.getType() === 'atomic') {
	      var blockMap = content.getBlockMap()['delete'](blockBefore.getKey());
	      var withoutAtomicBlock = content.merge({
	        blockMap: blockMap,
	        selectionAfter: selection
	      });
	      if (withoutAtomicBlock !== content) {
	        return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	      }
	    }
	
	    // If that doesn't succeed, try to remove the current block style.
	    var withoutBlockStyle = RichTextEditorUtil.tryToRemoveBlockStyle(editorState);
	
	    if (withoutBlockStyle) {
	      return EditorState.push(editorState, withoutBlockStyle, 'change-block-type');
	    }
	
	    return null;
	  },
	
	  onDelete: function onDelete(editorState) {
	    var selection = editorState.getSelection();
	    if (!selection.isCollapsed()) {
	      return null;
	    }
	
	    var content = editorState.getCurrentContent();
	    var startKey = selection.getStartKey();
	    var block = content.getBlockForKey(startKey);
	    var length = block.getLength();
	
	    // The cursor is somewhere within the text. Behave normally.
	    if (selection.getStartOffset() < length) {
	      return null;
	    }
	
	    var blockAfter = content.getBlockAfter(startKey);
	
	    if (!blockAfter || blockAfter.getType() !== 'atomic') {
	      return null;
	    }
	
	    var atomicBlockTarget = selection.merge({
	      focusKey: blockAfter.getKey(),
	      focusOffset: blockAfter.getLength()
	    });
	
	    var withoutAtomicBlock = DraftModifier.removeRange(content, atomicBlockTarget, 'forward');
	
	    if (withoutAtomicBlock !== content) {
	      return EditorState.push(editorState, withoutAtomicBlock, 'remove-range');
	    }
	
	    return null;
	  },
	
	  onTab: function onTab(event, editorState, maxDepth) {
	    var selection = editorState.getSelection();
	    var key = selection.getAnchorKey();
	    if (key !== selection.getFocusKey()) {
	      return editorState;
	    }
	
	    var content = editorState.getCurrentContent();
	    var block = content.getBlockForKey(key);
	    var type = block.getType();
	    if (type !== 'unordered-list-item' && type !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    event.preventDefault();
	
	    // Only allow indenting one level beyond the block above, and only if
	    // the block above is a list item as well.
	    var blockAbove = content.getBlockBefore(key);
	    if (!blockAbove) {
	      return editorState;
	    }
	
	    var typeAbove = blockAbove.getType();
	    if (typeAbove !== 'unordered-list-item' && typeAbove !== 'ordered-list-item') {
	      return editorState;
	    }
	
	    var depth = block.getDepth();
	    if (!event.shiftKey && depth === maxDepth) {
	      return editorState;
	    }
	
	    maxDepth = Math.min(blockAbove.getDepth() + 1, maxDepth);
	
	    var withAdjustment = adjustBlockDepthForContentState(content, selection, event.shiftKey ? -1 : 1, maxDepth);
	
	    return EditorState.push(editorState, withAdjustment, 'adjust-depth');
	  },
	
	  toggleBlockType: function toggleBlockType(editorState, blockType) {
	    var selection = editorState.getSelection();
	    var startKey = selection.getStartKey();
	    var endKey = selection.getEndKey();
	    var content = editorState.getCurrentContent();
	    var target = selection;
	
	    // Triple-click can lead to a selection that includes offset 0 of the
	    // following block. The `SelectionState` for this case is accurate, but
	    // we should avoid toggling block type for the trailing block because it
	    // is a confusing interaction.
	    if (startKey !== endKey && selection.getEndOffset() === 0) {
	      var blockBefore = nullthrows(content.getBlockBefore(endKey));
	      endKey = blockBefore.getKey();
	      target = target.merge({
	        anchorKey: startKey,
	        anchorOffset: selection.getStartOffset(),
	        focusKey: endKey,
	        focusOffset: blockBefore.getLength(),
	        isBackward: false
	      });
	    }
	
	    var hasAtomicBlock = content.getBlockMap().skipWhile(function (_, k) {
	      return k !== startKey;
	    }).reverse().skipWhile(function (_, k) {
	      return k !== endKey;
	    }).some(function (v) {
	      return v.getType() === 'atomic';
	    });
	
	    if (hasAtomicBlock) {
	      return editorState;
	    }
	
	    var typeToSet = content.getBlockForKey(startKey).getType() === blockType ? 'unstyled' : blockType;
	
	    return EditorState.push(editorState, DraftModifier.setBlockType(content, target, typeToSet), 'change-block-type');
	  },
	
	  toggleCode: function toggleCode(editorState) {
	    var selection = editorState.getSelection();
	    var anchorKey = selection.getAnchorKey();
	    var focusKey = selection.getFocusKey();
	
	    if (selection.isCollapsed() || anchorKey !== focusKey) {
	      return RichTextEditorUtil.toggleBlockType(editorState, 'code-block');
	    }
	
	    return RichTextEditorUtil.toggleInlineStyle(editorState, 'CODE');
	  },
	
	  /**
	   * Toggle the specified inline style for the selection. If the
	   * user's selection is collapsed, apply or remove the style for the
	   * internal state. If it is not collapsed, apply the change directly
	   * to the document state.
	   */
	  toggleInlineStyle: function toggleInlineStyle(editorState, inlineStyle) {
	    var selection = editorState.getSelection();
	    var currentStyle = editorState.getCurrentInlineStyle();
	
	    // If the selection is collapsed, toggle the specified style on or off and
	    // set the result as the new inline style override. This will then be
	    // used as the inline style for the next character to be inserted.
	    if (selection.isCollapsed()) {
	      return EditorState.setInlineStyleOverride(editorState, currentStyle.has(inlineStyle) ? currentStyle.remove(inlineStyle) : currentStyle.add(inlineStyle));
	    }
	
	    // If characters are selected, immediately apply or remove the
	    // inline style on the document state itself.
	    var content = editorState.getCurrentContent();
	    var newContent;
	
	    // If the style is already present for the selection range, remove it.
	    // Otherwise, apply it.
	    if (currentStyle.has(inlineStyle)) {
	      newContent = DraftModifier.removeInlineStyle(content, selection, inlineStyle);
	    } else {
	      newContent = DraftModifier.applyInlineStyle(content, selection, inlineStyle);
	    }
	
	    return EditorState.push(editorState, newContent, 'change-inline-style');
	  },
	
	  toggleLink: function toggleLink(editorState, targetSelection, entityKey) {
	    var withoutLink = DraftModifier.applyEntity(editorState.getCurrentContent(), targetSelection, entityKey);
	
	    return EditorState.push(editorState, withoutLink, 'apply-entity');
	  },
	
	  /**
	   * When a collapsed cursor is at the start of the first styled block, or
	   * an empty styled block, changes block to 'unstyled'. Returns null if
	   * block or selection does not meet that criteria.
	   */
	  tryToRemoveBlockStyle: function tryToRemoveBlockStyle(editorState) {
	    var selection = editorState.getSelection();
	    var offset = selection.getAnchorOffset();
	    if (selection.isCollapsed() && offset === 0) {
	      var key = selection.getAnchorKey();
	      var content = editorState.getCurrentContent();
	      var block = content.getBlockForKey(key);
	
	      var firstBlock = content.getFirstBlock();
	      if (block.getLength() > 0 && block !== firstBlock) {
	        return null;
	      }
	
	      var type = block.getType();
	      var blockBefore = content.getBlockBefore(key);
	      if (type === 'code-block' && blockBefore && blockBefore.getType() === 'code-block' && blockBefore.getLength() !== 0) {
	        return null;
	      }
	
	      if (type !== 'unstyled') {
	        return DraftModifier.setBlockType(content, selection, 'unstyled');
	      }
	    }
	    return null;
	  }
	};
	
	module.exports = RichTextEditorUtil;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromHTMLToContentBlocks
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _knownListItemDepthCl,
	    _assign = __webpack_require__(40);
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var CharacterMetadata = __webpack_require__(100);
	var ContentBlock = __webpack_require__(208);
	var ContentBlockNode = __webpack_require__(108);
	var DefaultDraftBlockRenderMap = __webpack_require__(489);
	var DraftEntity = __webpack_require__(350);
	var DraftFeatureFlags = __webpack_require__(176);
	var Immutable = __webpack_require__(39);
	
	var _require = __webpack_require__(39),
	    Set = _require.Set;
	
	var URI = __webpack_require__(2464);
	
	var cx = __webpack_require__(253);
	var generateRandomKey = __webpack_require__(158);
	var getSafeBodyFromHTML = __webpack_require__(808);
	var invariant = __webpack_require__(18);
	var sanitizeDraftText = __webpack_require__(494);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var List = Immutable.List,
	    OrderedSet = Immutable.OrderedSet;
	
	
	var NBSP = '&nbsp;';
	var SPACE = ' ';
	
	// Arbitrary max indent
	var MAX_DEPTH = 4;
	
	// used for replacing characters in HTML
	var REGEX_CR = new RegExp('\r', 'g');
	var REGEX_LF = new RegExp('\n', 'g');
	var REGEX_NBSP = new RegExp(NBSP, 'g');
	var REGEX_CARRIAGE = new RegExp('&#13;?', 'g');
	var REGEX_ZWS = new RegExp('&#8203;?', 'g');
	
	// https://developer.mozilla.org/en-US/docs/Web/CSS/font-weight
	var boldValues = ['bold', 'bolder', '500', '600', '700', '800', '900'];
	var notBoldValues = ['light', 'lighter', '100', '200', '300', '400'];
	
	// Block tag flow is different because LIs do not have
	// a deterministic style ;_;
	var inlineTags = {
	  b: 'BOLD',
	  code: 'CODE',
	  del: 'STRIKETHROUGH',
	  em: 'ITALIC',
	  i: 'ITALIC',
	  s: 'STRIKETHROUGH',
	  strike: 'STRIKETHROUGH',
	  strong: 'BOLD',
	  u: 'UNDERLINE'
	};
	
	var knownListItemDepthClasses = (_knownListItemDepthCl = {}, _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth0'), 0), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth1'), 1), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth2'), 2), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth3'), 3), _defineProperty(_knownListItemDepthCl, cx('public/DraftStyleDefault/depth4'), 4), _knownListItemDepthCl);
	
	var anchorAttr = ['className', 'href', 'rel', 'target', 'title'];
	
	var imgAttr = ['alt', 'className', 'height', 'src', 'width'];
	
	var lastBlock = void 0;
	
	var EMPTY_CHUNK = {
	  text: '',
	  inlines: [],
	  entities: [],
	  blocks: []
	};
	
	var EMPTY_BLOCK = {
	  children: List(),
	  depth: 0,
	  key: '',
	  type: ''
	};
	
	var getListBlockType = function getListBlockType(tag, lastList) {
	  if (tag === 'li') {
	    return lastList === 'ol' ? 'ordered-list-item' : 'unordered-list-item';
	  }
	  return null;
	};
	
	var getBlockMapSupportedTags = function getBlockMapSupportedTags(blockRenderMap) {
	  var unstyledElement = blockRenderMap.get('unstyled').element;
	  var tags = Set([]);
	
	  blockRenderMap.forEach(function (draftBlock) {
	    if (draftBlock.aliasedElements) {
	      draftBlock.aliasedElements.forEach(function (tag) {
	        tags = tags.add(tag);
	      });
	    }
	
	    tags = tags.add(draftBlock.element);
	  });
	
	  return tags.filter(function (tag) {
	    return tag && tag !== unstyledElement;
	  }).toArray().sort();
	};
	
	// custom element conversions
	var getMultiMatchedType = function getMultiMatchedType(tag, lastList, multiMatchExtractor) {
	  for (var ii = 0; ii < multiMatchExtractor.length; ii++) {
	    var matchType = multiMatchExtractor[ii](tag, lastList);
	    if (matchType) {
	      return matchType;
	    }
	  }
	  return null;
	};
	
	var getBlockTypeForTag = function getBlockTypeForTag(tag, lastList, blockRenderMap) {
	  var matchedTypes = blockRenderMap.filter(function (draftBlock) {
	    return draftBlock.element === tag || draftBlock.wrapper === tag || draftBlock.aliasedElements && draftBlock.aliasedElements.some(function (alias) {
	      return alias === tag;
	    });
	  }).keySeq().toSet().toArray().sort();
	
	  // if we dont have any matched type, return unstyled
	  // if we have one matched type return it
	  // if we have multi matched types use the multi-match function to gather type
	  switch (matchedTypes.length) {
	    case 0:
	      return 'unstyled';
	    case 1:
	      return matchedTypes[0];
	    default:
	      return getMultiMatchedType(tag, lastList, [getListBlockType]) || 'unstyled';
	  }
	};
	
	var processInlineTag = function processInlineTag(tag, node, currentStyle) {
	  var styleToCheck = inlineTags[tag];
	  if (styleToCheck) {
	    currentStyle = currentStyle.add(styleToCheck).toOrderedSet();
	  } else if (node instanceof HTMLElement) {
	    var htmlElement = node;
	    currentStyle = currentStyle.withMutations(function (style) {
	      var fontWeight = htmlElement.style.fontWeight;
	      var fontStyle = htmlElement.style.fontStyle;
	      var textDecoration = htmlElement.style.textDecoration;
	
	      if (boldValues.indexOf(fontWeight) >= 0) {
	        style.add('BOLD');
	      } else if (notBoldValues.indexOf(fontWeight) >= 0) {
	        style.remove('BOLD');
	      }
	
	      if (fontStyle === 'italic') {
	        style.add('ITALIC');
	      } else if (fontStyle === 'normal') {
	        style.remove('ITALIC');
	      }
	
	      if (textDecoration === 'underline') {
	        style.add('UNDERLINE');
	      }
	      if (textDecoration === 'line-through') {
	        style.add('STRIKETHROUGH');
	      }
	      if (textDecoration === 'none') {
	        style.remove('UNDERLINE');
	        style.remove('STRIKETHROUGH');
	      }
	    }).toOrderedSet();
	  }
	  return currentStyle;
	};
	
	var joinChunks = function joinChunks(A, B, experimentalHasNestedBlocks) {
	  // Sometimes two blocks will touch in the DOM and we need to strip the
	  // extra delimiter to preserve niceness.
	  var lastInA = A.text.slice(-1);
	  var firstInB = B.text.slice(0, 1);
	
	  if (lastInA === '\r' && firstInB === '\r' && !experimentalHasNestedBlocks) {
	    A.text = A.text.slice(0, -1);
	    A.inlines.pop();
	    A.entities.pop();
	    A.blocks.pop();
	  }
	
	  // Kill whitespace after blocks
	  if (lastInA === '\r') {
	    if (B.text === SPACE || B.text === '\n') {
	      return A;
	    } else if (firstInB === SPACE || firstInB === '\n') {
	      B.text = B.text.slice(1);
	      B.inlines.shift();
	      B.entities.shift();
	    }
	  }
	
	  return {
	    text: A.text + B.text,
	    inlines: A.inlines.concat(B.inlines),
	    entities: A.entities.concat(B.entities),
	    blocks: A.blocks.concat(B.blocks)
	  };
	};
	
	/**
	 * Check to see if we have anything like <p> <blockquote> <h1>... to create
	 * block tags from. If we do, we can use those and ignore <div> tags. If we
	 * don't, we can treat <div> tags as meaningful (unstyled) blocks.
	 */
	var containsSemanticBlockMarkup = function containsSemanticBlockMarkup(html, blockTags) {
	  return blockTags.some(function (tag) {
	    return html.indexOf('<' + tag) !== -1;
	  });
	};
	
	var hasValidLinkText = function hasValidLinkText(link) {
	  !(link instanceof HTMLAnchorElement) ?  false ? invariant(false, 'Link must be an HTMLAnchorElement.') : invariant(false) : void 0;
	  var protocol = link.protocol;
	  return protocol === 'http:' || protocol === 'https:' || protocol === 'mailto:';
	};
	
	var getWhitespaceChunk = function getWhitespaceChunk(inEntity) {
	  var entities = new Array(1);
	  if (inEntity) {
	    entities[0] = inEntity;
	  }
	  return _extends({}, EMPTY_CHUNK, {
	    text: SPACE,
	    inlines: [OrderedSet()],
	    entities: entities
	  });
	};
	
	var getSoftNewlineChunk = function getSoftNewlineChunk() {
	  return _extends({}, EMPTY_CHUNK, {
	    text: '\n',
	    inlines: [OrderedSet()],
	    entities: new Array(1)
	  });
	};
	
	var getChunkedBlock = function getChunkedBlock() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  return _extends({}, EMPTY_BLOCK, props);
	};
	
	var getBlockDividerChunk = function getBlockDividerChunk(block, depth) {
	  var parentKey = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	
	  return {
	    text: '\r',
	    inlines: [OrderedSet()],
	    entities: new Array(1),
	    blocks: [getChunkedBlock({
	      parent: parentKey,
	      key: generateRandomKey(),
	      type: block,
	      depth: Math.max(0, Math.min(MAX_DEPTH, depth))
	    })]
	  };
	};
	
	/**
	 *  If we're pasting from one DraftEditor to another we can check to see if
	 *  existing list item depth classes are being used and preserve this style
	 */
	var getListItemDepth = function getListItemDepth(node) {
	  var depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  Object.keys(knownListItemDepthClasses).some(function (depthClass) {
	    if (node.classList.contains(depthClass)) {
	      depth = knownListItemDepthClasses[depthClass];
	    }
	  });
	  return depth;
	};
	
	var genFragment = function genFragment(entityMap, node, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, inEntity, parentKey) {
	  var lastLastBlock = lastBlock;
	  var nodeName = node.nodeName.toLowerCase();
	  var newEntityMap = entityMap;
	  var nextBlockType = 'unstyled';
	  var newBlock = false;
	  var inBlockType = inBlock && getBlockTypeForTag(inBlock, lastList, blockRenderMap);
	  var chunk = _extends({}, EMPTY_CHUNK);
	  var newChunk = null;
	  var blockKey = void 0;
	
	  // Base Case
	  if (nodeName === '#text') {
	    var _text = node.textContent;
	    var nodeTextContent = _text.trim();
	
	    // We should not create blocks for leading spaces that are
	    // existing around ol/ul and their children list items
	    if (lastList && nodeTextContent === '' && node.parentElement) {
	      var parentNodeName = node.parentElement.nodeName.toLowerCase();
	      if (parentNodeName === 'ol' || parentNodeName === 'ul') {
	        return { chunk: _extends({}, EMPTY_CHUNK), entityMap: entityMap };
	      }
	    }
	
	    if (nodeTextContent === '' && inBlock !== 'pre') {
	      return { chunk: getWhitespaceChunk(inEntity), entityMap: entityMap };
	    }
	    if (inBlock !== 'pre') {
	      // Can't use empty string because MSWord
	      _text = _text.replace(REGEX_LF, SPACE);
	    }
	
	    // save the last block so we can use it later
	    lastBlock = nodeName;
	
	    return {
	      chunk: {
	        text: _text,
	        inlines: Array(_text.length).fill(inlineStyle),
	        entities: Array(_text.length).fill(inEntity),
	        blocks: []
	      },
	      entityMap: entityMap
	    };
	  }
	
	  // save the last block so we can use it later
	  lastBlock = nodeName;
	
	  // BR tags
	  if (nodeName === 'br') {
	    if (lastLastBlock === 'br' && (!inBlock || inBlockType === 'unstyled')) {
	      return {
	        chunk: getBlockDividerChunk('unstyled', depth, parentKey),
	        entityMap: entityMap
	      };
	    }
	    return { chunk: getSoftNewlineChunk(), entityMap: entityMap };
	  }
	
	  // IMG tags
	  if (nodeName === 'img' && node instanceof HTMLImageElement && node.attributes.getNamedItem('src') && node.attributes.getNamedItem('src').value) {
	    var image = node;
	    var entityConfig = {};
	
	    imgAttr.forEach(function (attr) {
	      var imageAttribute = image.getAttribute(attr);
	      if (imageAttribute) {
	        entityConfig[attr] = imageAttribute;
	      }
	    });
	    // Forcing this node to have children because otherwise no entity will be
	    // created for this node.
	    // The child text node cannot just have a space or return as content -
	    // we strip those out.
	    // See https://github.com/facebook/draft-js/issues/231 for some context.
	    node.textContent = '\uD83D\uDCF7';
	
	    // TODO: update this when we remove DraftEntity entirely
	    inEntity = DraftEntity.__create('IMAGE', 'MUTABLE', entityConfig || {});
	  }
	
	  // Inline tags
	  inlineStyle = processInlineTag(nodeName, node, inlineStyle);
	
	  // Handle lists
	  if (nodeName === 'ul' || nodeName === 'ol') {
	    if (lastList) {
	      depth += 1;
	    }
	    lastList = nodeName;
	  }
	
	  if (!experimentalTreeDataSupport && nodeName === 'li' && node instanceof HTMLElement) {
	    depth = getListItemDepth(node, depth);
	  }
	
	  var blockType = getBlockTypeForTag(nodeName, lastList, blockRenderMap);
	  var inListBlock = lastList && inBlock === 'li' && nodeName === 'li';
	  var inBlockOrHasNestedBlocks = (!inBlock || experimentalTreeDataSupport) && blockTags.indexOf(nodeName) !== -1;
	
	  // Block Tags
	  if (inListBlock || inBlockOrHasNestedBlocks) {
	    chunk = getBlockDividerChunk(blockType, depth, parentKey);
	    blockKey = chunk.blocks[0].key;
	    inBlock = nodeName;
	    newBlock = !experimentalTreeDataSupport;
	  }
	
	  // this is required so that we can handle 'ul' and 'ol'
	  if (inListBlock) {
	    nextBlockType = lastList === 'ul' ? 'unordered-list-item' : 'ordered-list-item';
	  }
	
	  // Recurse through children
	  var child = node.firstChild;
	  if (child != null) {
	    nodeName = child.nodeName.toLowerCase();
	  }
	
	  var entityId = null;
	
	  while (child) {
	    if (child instanceof HTMLAnchorElement && child.href && hasValidLinkText(child)) {
	      (function () {
	        var anchor = child;
	        var entityConfig = {};
	
	        anchorAttr.forEach(function (attr) {
	          var anchorAttribute = anchor.getAttribute(attr);
	          if (anchorAttribute) {
	            entityConfig[attr] = anchorAttribute;
	          }
	        });
	
	        entityConfig.url = new URI(anchor.href).toString();
	        // TODO: update this when we remove DraftEntity completely
	        entityId = DraftEntity.__create('LINK', 'MUTABLE', entityConfig || {});
	      })();
	    } else {
	      entityId = undefined;
	    }
	
	    var _genFragment = genFragment(newEntityMap, child, inlineStyle, lastList, inBlock, blockTags, depth, blockRenderMap, entityId || inEntity, experimentalTreeDataSupport ? blockKey : null),
	        generatedChunk = _genFragment.chunk,
	        maybeUpdatedEntityMap = _genFragment.entityMap;
	
	    newChunk = generatedChunk;
	    newEntityMap = maybeUpdatedEntityMap;
	
	    chunk = joinChunks(chunk, newChunk, experimentalTreeDataSupport);
	    var sibling = child.nextSibling;
	
	    // Put in a newline to break up blocks inside blocks
	    if (!parentKey && sibling && blockTags.indexOf(nodeName) >= 0 && inBlock) {
	      chunk = joinChunks(chunk, getSoftNewlineChunk());
	    }
	    if (sibling) {
	      nodeName = sibling.nodeName.toLowerCase();
	    }
	    child = sibling;
	  }
	
	  if (newBlock) {
	    chunk = joinChunks(chunk, getBlockDividerChunk(nextBlockType, depth, parentKey));
	  }
	
	  return { chunk: chunk, entityMap: newEntityMap };
	};
	
	var getChunkForHTML = function getChunkForHTML(html, DOMBuilder, blockRenderMap, entityMap) {
	  html = html.trim().replace(REGEX_CR, '').replace(REGEX_NBSP, SPACE).replace(REGEX_CARRIAGE, '').replace(REGEX_ZWS, '');
	
	  var supportedBlockTags = getBlockMapSupportedTags(blockRenderMap);
	
	  var safeBody = DOMBuilder(html);
	  if (!safeBody) {
	    return null;
	  }
	  lastBlock = null;
	
	  // Sometimes we aren't dealing with content that contains nice semantic
	  // tags. In this case, use divs to separate everything out into paragraphs
	  // and hope for the best.
	  var workingBlocks = containsSemanticBlockMarkup(html, supportedBlockTags) ? supportedBlockTags : ['div'];
	
	  // Start with -1 block depth to offset the fact that we are passing in a fake
	  // UL block to start with.
	  var fragment = genFragment(entityMap, safeBody, OrderedSet(), 'ul', null, workingBlocks, -1, blockRenderMap);
	
	  var chunk = fragment.chunk;
	  var newEntityMap = fragment.entityMap;
	
	  // join with previous block to prevent weirdness on paste
	  if (chunk.text.indexOf('\r') === 0) {
	    chunk = {
	      text: chunk.text.slice(1),
	      inlines: chunk.inlines.slice(1),
	      entities: chunk.entities.slice(1),
	      blocks: chunk.blocks
	    };
	  }
	
	  // Kill block delimiter at the end
	  if (chunk.text.slice(-1) === '\r') {
	    chunk.text = chunk.text.slice(0, -1);
	    chunk.inlines = chunk.inlines.slice(0, -1);
	    chunk.entities = chunk.entities.slice(0, -1);
	    chunk.blocks.pop();
	  }
	
	  // If we saw no block tags, put an unstyled one in
	  if (chunk.blocks.length === 0) {
	    chunk.blocks.push(_extends({}, EMPTY_CHUNK, {
	      type: 'unstyled',
	      depth: 0
	    }));
	  }
	
	  // Sometimes we start with text that isn't in a block, which is then
	  // followed by blocks. Need to fix up the blocks to add in
	  // an unstyled block for this content
	  if (chunk.text.split('\r').length === chunk.blocks.length + 1) {
	    chunk.blocks.unshift({ type: 'unstyled', depth: 0 });
	  }
	
	  return { chunk: chunk, entityMap: newEntityMap };
	};
	
	var convertChunkToContentBlocks = function convertChunkToContentBlocks(chunk) {
	  if (!chunk || !chunk.text || !Array.isArray(chunk.blocks)) {
	    return null;
	  }
	
	  var initialState = {
	    cacheRef: {},
	    contentBlocks: []
	  };
	
	  var start = 0;
	
	  var rawBlocks = chunk.blocks,
	      rawInlines = chunk.inlines,
	      rawEntities = chunk.entities;
	
	
	  var BlockNodeRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	  return chunk.text.split('\r').reduce(function (acc, textBlock, index) {
	    // Make absolutely certain that our text is acceptable.
	    textBlock = sanitizeDraftText(textBlock);
	
	    var block = rawBlocks[index];
	    var end = start + textBlock.length;
	    var inlines = rawInlines.slice(start, end);
	    var entities = rawEntities.slice(start, end);
	    var characterList = List(inlines.map(function (style, index) {
	      var data = { style: style, entity: null };
	      if (entities[index]) {
	        data.entity = entities[index];
	      }
	      return CharacterMetadata.create(data);
	    }));
	    start = end + 1;
	
	    var depth = block.depth,
	        type = block.type,
	        parent = block.parent;
	
	
	    var key = block.key || generateRandomKey();
	    var parentTextNodeKey = null; // will be used to store container text nodes
	
	    // childrens add themselves to their parents since we are iterating in order
	    if (parent) {
	      var parentIndex = acc.cacheRef[parent];
	      var parentRecord = acc.contentBlocks[parentIndex];
	
	      // if parent has text we need to split it into a separate unstyled element
	      if (parentRecord.getChildKeys().isEmpty() && parentRecord.getText()) {
	        var parentCharacterList = parentRecord.getCharacterList();
	        var parentText = parentRecord.getText();
	        parentTextNodeKey = generateRandomKey();
	
	        var textNode = new ContentBlockNode({
	          key: parentTextNodeKey,
	          text: parentText,
	          characterList: parentCharacterList,
	          parent: parent,
	          nextSibling: key
	        });
	
	        acc.contentBlocks.push(textNode);
	
	        parentRecord = parentRecord.withMutations(function (block) {
	          block.set('characterList', List()).set('text', '').set('children', parentRecord.children.push(textNode.getKey()));
	        });
	      }
	
	      acc.contentBlocks[parentIndex] = parentRecord.set('children', parentRecord.children.push(key));
	    }
	
	    var blockNode = new BlockNodeRecord({
	      key: key,
	      parent: parent,
	      type: type,
	      depth: depth,
	      text: textBlock,
	      characterList: characterList,
	      prevSibling: parentTextNodeKey || (index === 0 || rawBlocks[index - 1].parent !== parent ? null : rawBlocks[index - 1].key),
	      nextSibling: index === rawBlocks.length - 1 || rawBlocks[index + 1].parent !== parent ? null : rawBlocks[index + 1].key
	    });
	
	    // insert node
	    acc.contentBlocks.push(blockNode);
	
	    // cache ref for building links
	    acc.cacheRef[blockNode.key] = index;
	
	    return acc;
	  }, initialState).contentBlocks;
	};
	
	var convertFromHTMLtoContentBlocks = function convertFromHTMLtoContentBlocks(html) {
	  var DOMBuilder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getSafeBodyFromHTML;
	  var blockRenderMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DefaultDraftBlockRenderMap;
	
	  // Be ABSOLUTELY SURE that the dom builder you pass here won't execute
	  // arbitrary code in whatever environment you're running this in. For an
	  // example of how we try to do this in-browser, see getSafeBodyFromHTML.
	
	  // TODO: replace DraftEntity with an OrderedMap here
	  var chunkData = getChunkForHTML(html, DOMBuilder, blockRenderMap, DraftEntity);
	
	  if (chunkData == null) {
	    return null;
	  }
	
	  var chunk = chunkData.chunk,
	      entityMap = chunkData.entityMap;
	
	  var contentBlocks = convertChunkToContentBlocks(chunk);
	
	  return {
	    contentBlocks: contentBlocks,
	    entityMap: entityMap
	  };
	};
	
	module.exports = convertFromHTMLtoContentBlocks;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDefaultKeyBinding
	 * @format
	 * 
	 */
	
	'use strict';
	
	var KeyBindingUtil = __webpack_require__(490);
	var Keys = __webpack_require__(519);
	var UserAgent = __webpack_require__(142);
	
	var isOSX = UserAgent.isPlatform('Mac OS X');
	var isWindows = UserAgent.isPlatform('Windows');
	
	// Firefox on OSX had a bug resulting in navigation instead of cursor movement.
	// This bug was fixed in Firefox 29. Feature detection is virtually impossible
	// so we just check the version number. See #342765.
	var shouldFixFirefoxMovement = isOSX && UserAgent.isBrowser('Firefox < 29');
	
	var hasCommandModifier = KeyBindingUtil.hasCommandModifier,
	    isCtrlKeyCommand = KeyBindingUtil.isCtrlKeyCommand;
	
	
	function shouldRemoveWord(e) {
	  return isOSX && e.altKey || isCtrlKeyCommand(e);
	}
	
	/**
	 * Get the appropriate undo/redo command for a Z key command.
	 */
	function getZCommand(e) {
	  if (!hasCommandModifier(e)) {
	    return null;
	  }
	  return e.shiftKey ? 'redo' : 'undo';
	}
	
	function getDeleteCommand(e) {
	  // Allow default "cut" behavior for Windows on Shift + Delete.
	  if (isWindows && e.shiftKey) {
	    return null;
	  }
	  return shouldRemoveWord(e) ? 'delete-word' : 'delete';
	}
	
	function getBackspaceCommand(e) {
	  if (hasCommandModifier(e) && isOSX) {
	    return 'backspace-to-start-of-line';
	  }
	  return shouldRemoveWord(e) ? 'backspace-word' : 'backspace';
	}
	
	/**
	 * Retrieve a bound key command for the given event.
	 */
	function getDefaultKeyBinding(e) {
	  switch (e.keyCode) {
	    case 66:
	      // B
	      return hasCommandModifier(e) ? 'bold' : null;
	    case 68:
	      // D
	      return isCtrlKeyCommand(e) ? 'delete' : null;
	    case 72:
	      // H
	      return isCtrlKeyCommand(e) ? 'backspace' : null;
	    case 73:
	      // I
	      return hasCommandModifier(e) ? 'italic' : null;
	    case 74:
	      // J
	      return hasCommandModifier(e) ? 'code' : null;
	    case 75:
	      // K
	      return !isWindows && isCtrlKeyCommand(e) ? 'secondary-cut' : null;
	    case 77:
	      // M
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 79:
	      // O
	      return isCtrlKeyCommand(e) ? 'split-block' : null;
	    case 84:
	      // T
	      return isOSX && isCtrlKeyCommand(e) ? 'transpose-characters' : null;
	    case 85:
	      // U
	      return hasCommandModifier(e) ? 'underline' : null;
	    case 87:
	      // W
	      return isOSX && isCtrlKeyCommand(e) ? 'backspace-word' : null;
	    case 89:
	      // Y
	      if (isCtrlKeyCommand(e)) {
	        return isWindows ? 'redo' : 'secondary-paste';
	      }
	      return null;
	    case 90:
	      // Z
	      return getZCommand(e) || null;
	    case Keys.RETURN:
	      return 'split-block';
	    case Keys.DELETE:
	      return getDeleteCommand(e);
	    case Keys.BACKSPACE:
	      return getBackspaceCommand(e);
	    // LEFT/RIGHT handlers serve as a workaround for a Firefox bug.
	    case Keys.LEFT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-start-of-block' : null;
	    case Keys.RIGHT:
	      return shouldFixFirefoxMovement && hasCommandModifier(e) ? 'move-selection-to-end-of-block' : null;
	    default:
	      return null;
	  }
	}
	
	module.exports = getDefaultKeyBinding;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelectionWithNodes
	 * @format
	 * 
	 */
	
	'use strict';
	
	var findAncestorOffsetKey = __webpack_require__(491);
	var getSelectionOffsetKeyForNode = __webpack_require__(809);
	var getUpdatedSelectionState = __webpack_require__(811);
	var invariant = __webpack_require__(18);
	var nullthrows = __webpack_require__(123);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelectionWithNodes(editorState, root, anchorNode, anchorOffset, focusNode, focusOffset) {
	  var anchorIsTextNode = anchorNode.nodeType === Node.TEXT_NODE;
	  var focusIsTextNode = focusNode.nodeType === Node.TEXT_NODE;
	
	  // If the selection range lies only on text nodes, the task is simple.
	  // Find the nearest offset-aware elements and use the
	  // offset values supplied by the selection range.
	  if (anchorIsTextNode && focusIsTextNode) {
	    return {
	      selectionState: getUpdatedSelectionState(editorState, nullthrows(findAncestorOffsetKey(anchorNode)), anchorOffset, nullthrows(findAncestorOffsetKey(focusNode)), focusOffset),
	      needsRecovery: false
	    };
	  }
	
	  var anchorPoint = null;
	  var focusPoint = null;
	  var needsRecovery = true;
	
	  // An element is selected. Convert this selection range into leaf offset
	  // keys and offset values for consumption at the component level. This
	  // is common in Firefox, where select-all and triple click behavior leads
	  // to entire elements being selected.
	  //
	  // Note that we use the `needsRecovery` parameter in the callback here. This
	  // is because when certain elements are selected, the behavior for subsequent
	  // cursor movement (e.g. via arrow keys) is uncertain and may not match
	  // expectations at the component level. For example, if an entire <div> is
	  // selected and the user presses the right arrow, Firefox keeps the selection
	  // on the <div>. If we allow subsequent keypresses to insert characters
	  // natively, they will be inserted into a browser-created text node to the
	  // right of that <div>. This is obviously undesirable.
	  //
	  // With the `needsRecovery` flag, we inform the caller that it is responsible
	  // for manually setting the selection state on the rendered document to
	  // ensure proper selection state maintenance.
	
	  if (anchorIsTextNode) {
	    anchorPoint = {
	      key: nullthrows(findAncestorOffsetKey(anchorNode)),
	      offset: anchorOffset
	    };
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	  } else if (focusIsTextNode) {
	    focusPoint = {
	      key: nullthrows(findAncestorOffsetKey(focusNode)),
	      offset: focusOffset
	    };
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	  } else {
	    anchorPoint = getPointForNonTextNode(root, anchorNode, anchorOffset);
	    focusPoint = getPointForNonTextNode(root, focusNode, focusOffset);
	
	    // If the selection is collapsed on an empty block, don't force recovery.
	    // This way, on arrow key selection changes, the browser can move the
	    // cursor from a non-zero offset on one block, through empty blocks,
	    // to a matching non-zero offset on other text blocks.
	    if (anchorNode === focusNode && anchorOffset === focusOffset) {
	      needsRecovery = !!anchorNode.firstChild && anchorNode.firstChild.nodeName !== 'BR';
	    }
	  }
	
	  return {
	    selectionState: getUpdatedSelectionState(editorState, anchorPoint.key, anchorPoint.offset, focusPoint.key, focusPoint.offset),
	    needsRecovery: needsRecovery
	  };
	}
	
	/**
	 * Identify the first leaf descendant for the given node.
	 */
	function getFirstLeaf(node) {
	  while (node.firstChild && (
	  // data-blocks has no offset
	  node.firstChild instanceof Element && node.firstChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.firstChild))) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Identify the last leaf descendant for the given node.
	 */
	function getLastLeaf(node) {
	  while (node.lastChild && (
	  // data-blocks has no offset
	  node.lastChild instanceof Element && node.lastChild.getAttribute('data-blocks') === 'true' || getSelectionOffsetKeyForNode(node.lastChild))) {
	    node = node.lastChild;
	  }
	  return node;
	}
	
	function getPointForNonTextNode(editorRoot, startNode, childOffset) {
	  var node = startNode;
	  var offsetKey = findAncestorOffsetKey(node);
	
	  !(offsetKey != null || editorRoot && (editorRoot === node || editorRoot.firstChild === node)) ?  false ? invariant(false, 'Unknown node in selection range.') : invariant(false) : void 0;
	
	  // If the editorRoot is the selection, step downward into the content
	  // wrapper.
	  if (editorRoot === node) {
	    node = node.firstChild;
	    !(node instanceof Element && node.getAttribute('data-contents') === 'true') ?  false ? invariant(false, 'Invalid DraftEditorContents structure.') : invariant(false) : void 0;
	    if (childOffset > 0) {
	      childOffset = node.childNodes.length;
	    }
	  }
	
	  // If the child offset is zero and we have an offset key, we're done.
	  // If there's no offset key because the entire editor is selected,
	  // find the leftmost ("first") leaf in the tree and use that as the offset
	  // key.
	  if (childOffset === 0) {
	    var key = null;
	    if (offsetKey != null) {
	      key = offsetKey;
	    } else {
	      var firstLeaf = getFirstLeaf(node);
	      key = nullthrows(getSelectionOffsetKeyForNode(firstLeaf));
	    }
	    return { key: key, offset: 0 };
	  }
	
	  var nodeBeforeCursor = node.childNodes[childOffset - 1];
	  var leafKey = null;
	  var textLength = null;
	
	  if (!getSelectionOffsetKeyForNode(nodeBeforeCursor)) {
	    // Our target node may be a leaf or a text node, in which case we're
	    // already where we want to be and can just use the child's length as
	    // our offset.
	    leafKey = nullthrows(offsetKey);
	    textLength = getTextContentLength(nodeBeforeCursor);
	  } else {
	    // Otherwise, we'll look at the child to the left of the cursor and find
	    // the last leaf node in its subtree.
	    var lastLeaf = getLastLeaf(nodeBeforeCursor);
	    leafKey = nullthrows(getSelectionOffsetKeyForNode(lastLeaf));
	    textLength = getTextContentLength(lastLeaf);
	  }
	
	  return {
	    key: leafKey,
	    offset: textLength
	  };
	}
	
	/**
	 * Return the length of a node's textContent, regarding single newline
	 * characters as zero-length. This allows us to avoid problems with identifying
	 * the correct selection offset for empty blocks in IE, in which we
	 * render newlines instead of break tags.
	 */
	function getTextContentLength(node) {
	  var textContent = node.textContent;
	  return textContent === '\n' ? 0 : textContent.length;
	}
	
	module.exports = getDraftEditorSelectionWithNodes;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getFragmentFromSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getContentStateFragment = __webpack_require__(351);
	
	function getFragmentFromSelection(editorState) {
	  var selectionState = editorState.getSelection();
	
	  if (selectionState.isCollapsed()) {
	    return null;
	  }
	
	  return getContentStateFragment(editorState.getCurrentContent(), selectionState);
	}
	
	module.exports = getFragmentFromSelection;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getNextDelimiterBlockKey
	 * @format
	 * 
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	var ContentBlockNode = __webpack_require__(108);
	
	var getNextDelimiterBlockKey = function getNextDelimiterBlockKey(block, blockMap) {
	  var isExperimentalTreeBlock = block instanceof ContentBlockNode;
	
	  if (!isExperimentalTreeBlock) {
	    return null;
	  }
	
	  var nextSiblingKey = block.getNextSiblingKey();
	
	  if (nextSiblingKey) {
	    return nextSiblingKey;
	  }
	
	  var parent = block.getParentKey();
	
	  if (!parent) {
	    return null;
	  }
	
	  var nextNonDescendantBlock = blockMap.get(parent);
	  while (nextNonDescendantBlock && !nextNonDescendantBlock.getNextSiblingKey()) {
	    var parentKey = nextNonDescendantBlock.getParentKey();
	    nextNonDescendantBlock = parentKey ? blockMap.get(parentKey) : null;
	  }
	
	  if (!nextNonDescendantBlock) {
	    return null;
	  }
	
	  return nextNonDescendantBlock.getNextSiblingKey();
	};
	
	module.exports = getNextDelimiterBlockKey;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeClientRects
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(142);
	
	var invariant = __webpack_require__(18);
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	// In Chrome, the client rects will include the entire bounds of all nodes that
	// begin (have a start tag) within the selection, even if the selection does
	// not overlap the entire node. To resolve this, we split the range at each
	// start tag and join the client rects together.
	// https://code.google.com/p/chromium/issues/detail?id=324437
	/* eslint-disable consistent-return */
	function getRangeClientRectsChrome(range) {
	  var tempRange = range.cloneRange();
	  var clientRects = [];
	
	  for (var ancestor = range.endContainer; ancestor != null; ancestor = ancestor.parentNode) {
	    // If we've climbed up to the common ancestor, we can now use the
	    // original start point and stop climbing the tree.
	    var atCommonAncestor = ancestor === range.commonAncestorContainer;
	    if (atCommonAncestor) {
	      tempRange.setStart(range.startContainer, range.startOffset);
	    } else {
	      tempRange.setStart(tempRange.endContainer, 0);
	    }
	    var rects = Array.from(tempRange.getClientRects());
	    clientRects.push(rects);
	    if (atCommonAncestor) {
	      var _ref;
	
	      clientRects.reverse();
	      return (_ref = []).concat.apply(_ref, clientRects);
	    }
	    tempRange.setEndBefore(ancestor);
	  }
	
	   true ?  false ? invariant(false, 'Found an unexpected detached subtree when getting range client rects.') : invariant(false) : void 0;
	}
	/* eslint-enable consistent-return */
	
	/**
	 * Like range.getClientRects() but normalizes for browser bugs.
	 */
	var getRangeClientRects = isChrome ? getRangeClientRectsChrome : function (range) {
	  return Array.from(range.getClientRects());
	};
	
	module.exports = getRangeClientRects;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSafeBodyFromHTML
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UserAgent = __webpack_require__(142);
	
	var invariant = __webpack_require__(18);
	
	var isOldIE = UserAgent.isBrowser('IE <= 9');
	
	// Provides a dom node that will not execute scripts
	// https://developer.mozilla.org/en-US/docs/Web/API/DOMImplementation.createHTMLDocument
	// https://developer.mozilla.org/en-US/Add-ons/Code_snippets/HTML_to_DOM
	
	function getSafeBodyFromHTML(html) {
	  var doc;
	  var root = null;
	  // Provides a safe context
	  if (!isOldIE && document.implementation && document.implementation.createHTMLDocument) {
	    doc = document.implementation.createHTMLDocument('foo');
	    !doc.documentElement ?  false ? invariant(false, 'Missing doc.documentElement') : invariant(false) : void 0;
	    doc.documentElement.innerHTML = html;
	    root = doc.getElementsByTagName('body')[0];
	  }
	  return root;
	}
	
	module.exports = getSafeBodyFromHTML;

/***/ },
/* 809 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getSelectionOffsetKeyForNode
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Get offset key from a node or it's child nodes. Return the first offset key
	 * found on the DOM tree of given node.
	 */
	
	function getSelectionOffsetKeyForNode(node) {
	  if (node instanceof Element) {
	    var offsetKey = node.getAttribute('data-offset-key');
	    if (offsetKey) {
	      return offsetKey;
	    }
	    for (var ii = 0; ii < node.childNodes.length; ii++) {
	      var childOffsetKey = getSelectionOffsetKeyForNode(node.childNodes[ii]);
	      if (childOffsetKey) {
	        return childOffsetKey;
	      }
	    }
	  }
	  return null;
	}
	
	module.exports = getSelectionOffsetKeyForNode;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getTextContentFromFiles
	 * @format
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(18);
	
	var TEXT_CLIPPING_REGEX = /\.textClipping$/;
	
	var TEXT_TYPES = {
	  'text/plain': true,
	  'text/html': true,
	  'text/rtf': true
	};
	
	// Somewhat arbitrary upper bound on text size. Let's not lock up the browser.
	var TEXT_SIZE_UPPER_BOUND = 5000;
	
	/**
	 * Extract the text content from a file list.
	 */
	function getTextContentFromFiles(files, callback) {
	  var readCount = 0;
	  var results = [];
	  files.forEach(function ( /*blob*/file) {
	    readFile(file, function ( /*string*/text) {
	      readCount++;
	      text && results.push(text.slice(0, TEXT_SIZE_UPPER_BOUND));
	      if (readCount == files.length) {
	        callback(results.join('\r'));
	      }
	    });
	  });
	}
	
	/**
	 * todo isaac: Do work to turn html/rtf into a content fragment.
	 */
	function readFile(file, callback) {
	  if (!global.FileReader || file.type && !(file.type in TEXT_TYPES)) {
	    callback('');
	    return;
	  }
	
	  if (file.type === '') {
	    var contents = '';
	    // Special-case text clippings, which have an empty type but include
	    // `.textClipping` in the file name. `readAsText` results in an empty
	    // string for text clippings, so we force the file name to serve
	    // as the text value for the file.
	    if (TEXT_CLIPPING_REGEX.test(file.name)) {
	      contents = file.name.replace(TEXT_CLIPPING_REGEX, '');
	    }
	    callback(contents);
	    return;
	  }
	
	  var reader = new FileReader();
	  reader.onload = function () {
	    var result = reader.result;
	    !(typeof result === 'string') ?  false ? invariant(false, 'We should be calling "FileReader.readAsText" which returns a string') : invariant(false) : void 0;
	    callback(result);
	  };
	  reader.onerror = function () {
	    callback('');
	  };
	  reader.readAsText(file);
	}
	
	module.exports = getTextContentFromFiles;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getUpdatedSelectionState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftOffsetKey = __webpack_require__(283);
	
	var nullthrows = __webpack_require__(123);
	
	function getUpdatedSelectionState(editorState, anchorKey, anchorOffset, focusKey, focusOffset) {
	  var selection = nullthrows(editorState.getSelection());
	  if (false) {
	    if (!anchorKey || !focusKey) {
	      /*eslint-disable no-console */
	      console.warn('Invalid selection state.', arguments, editorState.toJS());
	      /*eslint-enable no-console */
	      return selection;
	    }
	  }
	
	  var anchorPath = DraftOffsetKey.decode(anchorKey);
	  var anchorBlockKey = anchorPath.blockKey;
	  var anchorLeaf = editorState.getBlockTree(anchorBlockKey).getIn([anchorPath.decoratorKey, 'leaves', anchorPath.leafKey]);
	
	  var focusPath = DraftOffsetKey.decode(focusKey);
	  var focusBlockKey = focusPath.blockKey;
	  var focusLeaf = editorState.getBlockTree(focusBlockKey).getIn([focusPath.decoratorKey, 'leaves', focusPath.leafKey]);
	
	  var anchorLeafStart = anchorLeaf.get('start');
	  var focusLeafStart = focusLeaf.get('start');
	
	  var anchorBlockOffset = anchorLeaf ? anchorLeafStart + anchorOffset : null;
	  var focusBlockOffset = focusLeaf ? focusLeafStart + focusOffset : null;
	
	  var areEqual = selection.getAnchorKey() === anchorBlockKey && selection.getAnchorOffset() === anchorBlockOffset && selection.getFocusKey() === focusBlockKey && selection.getFocusOffset() === focusBlockOffset;
	
	  if (areEqual) {
	    return selection;
	  }
	
	  var isBackward = false;
	  if (anchorBlockKey === focusBlockKey) {
	    var anchorLeafEnd = anchorLeaf.get('end');
	    var focusLeafEnd = focusLeaf.get('end');
	    if (focusLeafStart === anchorLeafStart && focusLeafEnd === anchorLeafEnd) {
	      isBackward = focusOffset < anchorOffset;
	    } else {
	      isBackward = focusLeafStart < anchorLeafStart;
	    }
	  } else {
	    var startKey = editorState.getCurrentContent().getBlockMap().keySeq().skipUntil(function (v) {
	      return v === anchorBlockKey || v === focusBlockKey;
	    }).first();
	    isBackward = startKey === focusBlockKey;
	  }
	
	  return selection.merge({
	    anchorKey: anchorBlockKey,
	    anchorOffset: anchorBlockOffset,
	    focusKey: focusBlockKey,
	    focusOffset: focusBlockOffset,
	    isBackward: isBackward
	  });
	}
	
	module.exports = getUpdatedSelectionState;

/***/ },
/* 812 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertIntoList
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Maintain persistence for target list when appending and prepending.
	 */
	function insertIntoList(targetList, toInsert, offset) {
	  if (offset === targetList.count()) {
	    toInsert.forEach(function (c) {
	      targetList = targetList.push(c);
	    });
	  } else if (offset === 0) {
	    toInsert.reverse().forEach(function (c) {
	      targetList = targetList.unshift(c);
	    });
	  } else {
	    var head = targetList.slice(0, offset);
	    var tail = targetList.slice(offset);
	    targetList = head.concat(toInsert, tail).toList();
	  }
	  return targetList;
	}
	
	module.exports = insertIntoList;

/***/ },
/* 813 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule isSelectionAtLeafStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	function isSelectionAtLeafStart(editorState) {
	  var selection = editorState.getSelection();
	  var anchorKey = selection.getAnchorKey();
	  var blockTree = editorState.getBlockTree(anchorKey);
	  var offset = selection.getStartOffset();
	
	  var isAtStart = false;
	
	  blockTree.some(function (leafSet) {
	    if (offset === leafSet.get('start')) {
	      isAtStart = true;
	      return true;
	    }
	
	    if (offset < leafSet.get('end')) {
	      return leafSet.get('leaves').some(function (leaf) {
	        var leafStart = leaf.get('start');
	        if (offset === leafStart) {
	          isAtStart = true;
	          return true;
	        }
	
	        return false;
	      });
	    }
	
	    return false;
	  });
	
	  return isAtStart;
	}
	
	module.exports = isSelectionAtLeafStart;

/***/ },
/* 814 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveSelectionForward
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Given a collapsed selection, move the focus `maxDistance` forward within
	 * the selected block. If the selection will go beyond the end of the block,
	 * move focus to the start of the next block, but no further.
	 *
	 * This function is not Unicode-aware, so surrogate pairs will be treated
	 * as having length 2.
	 */
	function moveSelectionForward(editorState, maxDistance) {
	  var selection = editorState.getSelection();
	  var key = selection.getStartKey();
	  var offset = selection.getStartOffset();
	  var content = editorState.getCurrentContent();
	
	  var focusKey = key;
	  var focusOffset;
	
	  var block = content.getBlockForKey(key);
	
	  if (maxDistance > block.getText().length - offset) {
	    focusKey = content.getKeyAfter(key);
	    focusOffset = 0;
	  } else {
	    focusOffset = offset + maxDistance;
	  }
	
	  return selection.merge({ focusKey: focusKey, focusOffset: focusOffset });
	}
	
	module.exports = moveSelectionForward;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule randomizeBlockMapKeys
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(108);
	var Immutable = __webpack_require__(39);
	
	var generateRandomKey = __webpack_require__(158);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var randomizeContentBlockNodeKeys = function randomizeContentBlockNodeKeys(blockMap) {
	  var newKeysRef = {};
	
	  // we keep track of root blocks in order to update subsequent sibling links
	  var lastRootBlock = void 0;
	
	  return OrderedMap(blockMap.withMutations(function (blockMapState) {
	    blockMapState.forEach(function (block, index) {
	      var oldKey = block.getKey();
	      var nextKey = block.getNextSiblingKey();
	      var prevKey = block.getPrevSiblingKey();
	      var childrenKeys = block.getChildKeys();
	      var parentKey = block.getParentKey();
	
	      // new key that we will use to build linking
	      var key = generateRandomKey();
	
	      // we will add it here to re-use it later
	      newKeysRef[oldKey] = key;
	
	      if (nextKey) {
	        var nextBlock = blockMapState.get(nextKey);
	        if (nextBlock) {
	          blockMapState.setIn([nextKey, 'prevSibling'], key);
	        } else {
	          // this can happen when generating random keys for fragments
	          blockMapState.setIn([oldKey, 'nextSibling'], null);
	        }
	      }
	
	      if (prevKey) {
	        var prevBlock = blockMapState.get(prevKey);
	        if (prevBlock) {
	          blockMapState.setIn([prevKey, 'nextSibling'], key);
	        } else {
	          // this can happen when generating random keys for fragments
	          blockMapState.setIn([oldKey, 'prevSibling'], null);
	        }
	      }
	
	      if (parentKey && blockMapState.get(parentKey)) {
	        var parentBlock = blockMapState.get(parentKey);
	        var parentChildrenList = parentBlock.getChildKeys();
	        blockMapState.setIn([parentKey, 'children'], parentChildrenList.set(parentChildrenList.indexOf(block.getKey()), key));
	      } else {
	        // blocks will then be treated as root block nodes
	        blockMapState.setIn([oldKey, 'parent'], null);
	
	        if (lastRootBlock) {
	          blockMapState.setIn([lastRootBlock.getKey(), 'nextSibling'], key);
	          blockMapState.setIn([oldKey, 'prevSibling'], newKeysRef[lastRootBlock.getKey()]);
	        }
	
	        lastRootBlock = blockMapState.get(oldKey);
	      }
	
	      childrenKeys.forEach(function (childKey) {
	        var childBlock = blockMapState.get(childKey);
	        if (childBlock) {
	          blockMapState.setIn([childKey, 'parent'], key);
	        } else {
	          blockMapState.setIn([oldKey, 'children'], block.getChildKeys().filter(function (child) {
	            return child !== childKey;
	          }));
	        }
	      });
	    });
	  }).toArray().map(function (block) {
	    return [newKeysRef[block.getKey()], block.set('key', newKeysRef[block.getKey()])];
	  }));
	};
	
	var randomizeContentBlockKeys = function randomizeContentBlockKeys(blockMap) {
	  return OrderedMap(blockMap.toArray().map(function (block) {
	    var key = generateRandomKey();
	    return [key, block.set('key', key)];
	  }));
	};
	
	var randomizeBlockMapKeys = function randomizeBlockMapKeys(blockMap) {
	  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
	
	  if (!isTreeBasedBlockMap) {
	    return randomizeContentBlockKeys(blockMap);
	  }
	
	  return randomizeContentBlockNodeKeys(blockMap);
	};
	
	module.exports = randomizeBlockMapKeys;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeEntitiesAtEdges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(100);
	
	var findRangesImmutable = __webpack_require__(284);
	var invariant = __webpack_require__(18);
	
	function removeEntitiesAtEdges(contentState, selectionState) {
	  var blockMap = contentState.getBlockMap();
	  var entityMap = contentState.getEntityMap();
	
	  var updatedBlocks = {};
	
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var startBlock = blockMap.get(startKey);
	  var updatedStart = removeForBlock(entityMap, startBlock, startOffset);
	
	  if (updatedStart !== startBlock) {
	    updatedBlocks[startKey] = updatedStart;
	  }
	
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	  var endBlock = blockMap.get(endKey);
	  if (startKey === endKey) {
	    endBlock = updatedStart;
	  }
	
	  var updatedEnd = removeForBlock(entityMap, endBlock, endOffset);
	
	  if (updatedEnd !== endBlock) {
	    updatedBlocks[endKey] = updatedEnd;
	  }
	
	  if (!Object.keys(updatedBlocks).length) {
	    return contentState.set('selectionAfter', selectionState);
	  }
	
	  return contentState.merge({
	    blockMap: blockMap.merge(updatedBlocks),
	    selectionAfter: selectionState
	  });
	}
	
	function getRemovalRange(characters, key, offset) {
	  var removalRange;
	  findRangesImmutable(characters, function (a, b) {
	    return a.getEntity() === b.getEntity();
	  }, function (element) {
	    return element.getEntity() === key;
	  }, function (start, end) {
	    if (start <= offset && end >= offset) {
	      removalRange = { start: start, end: end };
	    }
	  });
	  !(typeof removalRange === 'object') ?  false ? invariant(false, 'Removal range must exist within character list.') : invariant(false) : void 0;
	  return removalRange;
	}
	
	function removeForBlock(entityMap, block, offset) {
	  var chars = block.getCharacterList();
	  var charBefore = offset > 0 ? chars.get(offset - 1) : undefined;
	  var charAfter = offset < chars.count() ? chars.get(offset) : undefined;
	  var entityBeforeCursor = charBefore ? charBefore.getEntity() : undefined;
	  var entityAfterCursor = charAfter ? charAfter.getEntity() : undefined;
	
	  if (entityAfterCursor && entityAfterCursor === entityBeforeCursor) {
	    var entity = entityMap.__get(entityAfterCursor);
	    if (entity.getMutability() !== 'MUTABLE') {
	      var _getRemovalRange = getRemovalRange(chars, entityAfterCursor, offset),
	          start = _getRemovalRange.start,
	          end = _getRemovalRange.end;
	
	      var current;
	      while (start < end) {
	        current = chars.get(start);
	        chars = chars.set(start, CharacterMetadata.applyEntity(current, null));
	        start++;
	      }
	      return block.set('characterList', chars);
	    }
	  }
	
	  return block;
	}
	
	module.exports = removeEntitiesAtEdges;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _echarts = __webpack_require__(10);
	
	(function () {
	  for (var key in _echarts) {
	    if (_echarts == null || !_echarts.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _echarts[key];
	  }
	})();
	
	var _export = __webpack_require__(873);
	
	(function () {
	  for (var key in _export) {
	    if (_export == null || !_export.hasOwnProperty(key) || key === 'default' || key === '__esModule') return;
	    exports[key] = _export[key];
	  }
	})();
	
	__webpack_require__(842);
	
	__webpack_require__(2249);
	
	__webpack_require__(2198);
	
	__webpack_require__(2269);
	
	__webpack_require__(2285);
	
	__webpack_require__(2274);
	
	__webpack_require__(2257);
	
	__webpack_require__(2299);
	
	__webpack_require__(2305);
	
	__webpack_require__(2227);
	
	__webpack_require__(2223);
	
	__webpack_require__(2219);
	
	__webpack_require__(2264);
	
	__webpack_require__(2279);
	
	__webpack_require__(2204);
	
	__webpack_require__(2209);
	
	__webpack_require__(2216);
	
	__webpack_require__(2253);
	
	__webpack_require__(2240);
	
	__webpack_require__(2268);
	
	__webpack_require__(2294);
	
	__webpack_require__(2288);
	
	__webpack_require__(2215);
	
	__webpack_require__(2346);
	
	__webpack_require__(2363);
	
	__webpack_require__(2343);
	
	__webpack_require__(852);
	
	__webpack_require__(851);
	
	__webpack_require__(2331);
	
	__webpack_require__(2345);
	
	__webpack_require__(2377);
	
	__webpack_require__(2386);
	
	__webpack_require__(289);
	
	__webpack_require__(2325);
	
	__webpack_require__(2376);
	
	__webpack_require__(2367);
	
	__webpack_require__(2355);
	
	__webpack_require__(2354);
	
	__webpack_require__(2353);
	
	__webpack_require__(2352);
	
	__webpack_require__(848);
	
	__webpack_require__(2333);
	
	__webpack_require__(840);
	
	__webpack_require__(841);
	
	__webpack_require__(2391);
	
	__webpack_require__(860);
	
	__webpack_require__(861);
	
	__webpack_require__(3003);
	
	__webpack_require__(2999);

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var echartsAPIList = ['getDom', 'getZr', 'getWidth', 'getHeight', 'getDevicePixelRatio', 'dispatchAction', 'isDisposed', 'on', 'off', 'getDataURL', 'getConnectedDataURL', 'getModel', 'getOption', 'getViewOfComponentModel', 'getViewOfSeriesModel']; // And `getCoordinateSystems` and `getComponentByElement` will be injected in echarts.js
	
	function ExtensionAPI(chartInstance) {
	  zrUtil.each(echartsAPIList, function (name) {
	    this[name] = zrUtil.bind(chartInstance[name], chartInstance);
	  }, this);
	}
	
	var _default = ExtensionAPI;
	module.exports = _default;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(seriesType, actionInfos) {
	  zrUtil.each(actionInfos, function (actionInfo) {
	    actionInfo.update = 'updateView';
	    /**
	     * @payload
	     * @property {string} seriesName
	     * @property {string} name
	     */
	
	    echarts.registerAction(actionInfo, function (payload, ecModel) {
	      var selected = {};
	      ecModel.eachComponent({
	        mainType: 'series',
	        subType: seriesType,
	        query: payload
	      }, function (seriesModel) {
	        if (seriesModel[actionInfo.method]) {
	          seriesModel[actionInfo.method](payload.name, payload.dataIndex);
	        }
	
	        var data = seriesModel.getData(); // Create selected map
	
	        data.each(function (idx) {
	          var name = data.getName(idx);
	          selected[name] = seriesModel.isSelected(name) || false;
	        });
	      });
	      return {
	        name: payload.name,
	        selected: selected,
	        seriesId: payload.seriesId
	      };
	    });
	  });
	}
	
	module.exports = _default;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var _roamHelper = __webpack_require__(495);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {string} [componentType=series]
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	echarts.registerAction({
	  type: 'geoRoam',
	  event: 'geoRoam',
	  update: 'updateTransform'
	}, function (payload, ecModel) {
	  var componentType = payload.componentType || 'series';
	  ecModel.eachComponent({
	    mainType: componentType,
	    query: payload
	  }, function (componentModel) {
	    var geo = componentModel.coordinateSystem;
	
	    if (geo.type !== 'geo') {
	      return;
	    }
	
	    var res = updateCenterAndZoom(geo, payload, componentModel.get('scaleLimit'));
	    componentModel.setCenter && componentModel.setCenter(res.center);
	    componentModel.setZoom && componentModel.setZoom(res.zoom); // All map series with same `map` use the same geo coordinate system
	    // So the center and zoom must be in sync. Include the series not selected by legend
	
	    if (componentType === 'series') {
	      zrUtil.each(componentModel.seriesGroup, function (seriesModel) {
	        seriesModel.setCenter(res.center);
	        seriesModel.setZoom(res.zoom);
	      });
	    }
	  });
	});

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(77);
	
	var createListFromArray = __webpack_require__(159);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.__base_bar__',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  getMarkerPosition: function (value) {
	    var coordSys = this.coordinateSystem;
	
	    if (coordSys) {
	      // PENDING if clamp ?
	      var pt = coordSys.dataToPoint(coordSys.clampData(value));
	      var data = this.getData();
	      var offset = data.getLayout('offset');
	      var size = data.getLayout('size');
	      var offsetIndex = coordSys.getBaseAxis().isHorizontal() ? 0 : 1;
	      pt[offsetIndex] += offset + size / 2;
	      return pt;
	    }
	
	    return [NaN, NaN];
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    // stack: null
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // 最小高度改为0
	    barMinHeight: 0,
	    // 最小角度为0，仅对极坐标系下的柱状图有效
	    barMinAngle: 0,
	    // cursor: null,
	    large: false,
	    largeThreshold: 400,
	    progressive: 3e3,
	    progressiveChunkMode: 'mod',
	    // barMaxWidth: null,
	    // In cartesian, the default value is 1. Otherwise null.
	    // barMinWidth: null,
	    // 默认自适应
	    // barWidth: null,
	    // 柱间距离，默认为柱形宽度的30%，可设固定值
	    // barGap: '30%',
	    // 类目间柱形距离，默认为类目间距的20%，可设固定值
	    // barCategoryGap: '20%',
	    // label: {
	    //      show: false
	    // },
	    itemStyle: {},
	    emphasis: {}
	  }
	});
	
	module.exports = _default;

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var _labelHelper = __webpack_require__(499);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function setLabel(normalStyle, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside) {
	  var labelModel = itemModel.getModel('label');
	  var hoverLabelModel = itemModel.getModel('emphasis.label');
	  graphic.setLabelStyle(normalStyle, hoverStyle, labelModel, hoverLabelModel, {
	    labelFetcher: seriesModel,
	    labelDataIndex: dataIndex,
	    defaultText: getDefaultLabel(seriesModel.getData(), dataIndex),
	    isRectText: true,
	    autoColor: color
	  });
	  fixPosition(normalStyle);
	  fixPosition(hoverStyle);
	}
	
	function fixPosition(style, labelPositionOutside) {
	  if (style.textPosition === 'outside') {
	    style.textPosition = labelPositionOutside;
	  }
	}
	
	exports.setLabel = setLabel;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(55);
	
	var _graphHelper = __webpack_require__(496);
	
	var getSymbolSize = _graphHelper.getSymbolSize;
	var getNodeGlobalScale = _graphHelper.getNodeGlobalScale;
	
	var zrUtil = __webpack_require__(4);
	
	var _multipleGraphEdgeHelper = __webpack_require__(353);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	var _symbolRadiansHalf = [];
	/**
	 * `basedOn` can be:
	 * 'value':
	 *     This layout is not accurate and have same bad case. For example,
	 *     if the min value is very smaller than the max value, the nodes
	 *     with the min value probably overlap even though there is enough
	 *     space to layout them. So we only use this approach in the as the
	 *     init layout of the force layout.
	 *     FIXME
	 *     Probably we do not need this method any more but use
	 *     `basedOn: 'symbolSize'` in force layout if
	 *     delay its init operations to GraphView.
	 * 'symbolSize':
	 *     This approach work only if all of the symbol size calculated.
	 *     That is, the progressive rendering is not applied to graph.
	 *     FIXME
	 *     If progressive rendering is applied to graph some day,
	 *     probably we have to use `basedOn: 'value'`.
	 *
	 * @param {module:echarts/src/model/Series} seriesModel
	 * @param {string} basedOn 'value' or 'symbolSize'
	 */
	
	function circularLayout(seriesModel, basedOn) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var rect = coordSys.getBoundingRect();
	  var nodeData = seriesModel.getData();
	  var graph = nodeData.graph;
	  var cx = rect.width / 2 + rect.x;
	  var cy = rect.height / 2 + rect.y;
	  var r = Math.min(rect.width, rect.height) / 2;
	  var count = nodeData.count();
	  nodeData.setLayout({
	    cx: cx,
	    cy: cy
	  });
	
	  if (!count) {
	    return;
	  }
	
	  _layoutNodesBasedOn[basedOn](seriesModel, coordSys, graph, nodeData, r, cx, cy, count);
	
	  graph.eachEdge(function (edge, index) {
	    var curveness = zrUtil.retrieve3(edge.getModel().get('lineStyle.curveness'), getCurvenessForEdge(edge, seriesModel, index), 0);
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var cp1;
	    var x12 = (p1[0] + p2[0]) / 2;
	    var y12 = (p1[1] + p2[1]) / 2;
	
	    if (+curveness) {
	      curveness *= 3;
	      cp1 = [cx * curveness + x12 * (1 - curveness), cy * curveness + y12 * (1 - curveness)];
	    }
	
	    edge.setLayout([p1, p2, cp1]);
	  });
	}
	
	var _layoutNodesBasedOn = {
	  value: function (seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
	    var angle = 0;
	    var sum = nodeData.getSum('value');
	    var unitAngle = Math.PI * 2 / (sum || count);
	    graph.eachNode(function (node) {
	      var value = node.getValue('value');
	      var radianHalf = unitAngle * (sum ? value : 1) / 2;
	      angle += radianHalf;
	      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	      angle += radianHalf;
	    });
	  },
	  symbolSize: function (seriesModel, coordSys, graph, nodeData, r, cx, cy, count) {
	    var sumRadian = 0;
	    _symbolRadiansHalf.length = count;
	    var nodeScale = getNodeGlobalScale(seriesModel);
	    graph.eachNode(function (node) {
	      var symbolSize = getSymbolSize(node); // Normally this case will not happen, but we still add
	      // some the defensive code (2px is an arbitrary value).
	
	      isNaN(symbolSize) && (symbolSize = 2);
	      symbolSize < 0 && (symbolSize = 0);
	      symbolSize *= nodeScale;
	      var symbolRadianHalf = Math.asin(symbolSize / 2 / r); // when `symbolSize / 2` is bigger than `r`.
	
	      isNaN(symbolRadianHalf) && (symbolRadianHalf = PI / 2);
	      _symbolRadiansHalf[node.dataIndex] = symbolRadianHalf;
	      sumRadian += symbolRadianHalf * 2;
	    });
	    var halfRemainRadian = (2 * PI - sumRadian) / count / 2;
	    var angle = 0;
	    graph.eachNode(function (node) {
	      var radianHalf = halfRemainRadian + _symbolRadiansHalf[node.dataIndex];
	      angle += radianHalf;
	      node.setLayout([r * Math.cos(angle) + cx, r * Math.sin(angle) + cy]);
	      angle += radianHalf;
	    });
	  }
	};
	exports.circularLayout = circularLayout;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(55);
	
	var zrUtil = __webpack_require__(4);
	
	var _multipleGraphEdgeHelper = __webpack_require__(353);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function simpleLayout(seriesModel) {
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (coordSys && coordSys.type !== 'view') {
	    return;
	  }
	
	  var graph = seriesModel.getGraph();
	  graph.eachNode(function (node) {
	    var model = node.getModel();
	    node.setLayout([+model.get('x'), +model.get('y')]);
	  });
	  simpleLayoutEdge(graph, seriesModel);
	}
	
	function simpleLayoutEdge(graph, seriesModel) {
	  graph.eachEdge(function (edge, index) {
	    var curveness = zrUtil.retrieve3(edge.getModel().get('lineStyle.curveness'), -getCurvenessForEdge(edge, seriesModel, index, true), 0);
	    var p1 = vec2.clone(edge.node1.getLayout());
	    var p2 = vec2.clone(edge.node2.getLayout());
	    var points = [p1, p2];
	
	    if (+curveness) {
	      points.push([(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * curveness]);
	    }
	
	    edge.setLayout(points);
	  });
	}
	
	exports.simpleLayout = simpleLayout;
	exports.simpleLayoutEdge = simpleLayoutEdge;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var Line = __webpack_require__(497);
	
	var zrUtil = __webpack_require__(4);
	
	var _symbol = __webpack_require__(110);
	
	var createSymbol = _symbol.createSymbol;
	
	var vec2 = __webpack_require__(55);
	
	var curveUtil = __webpack_require__(188);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Line}
	 */
	function EffectLine(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	  this.add(this.createLine(lineData, idx, seriesScope));
	
	  this._updateEffectSymbol(lineData, idx);
	}
	
	var effectLineProto = EffectLine.prototype;
	
	effectLineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Line(lineData, idx, seriesScope);
	};
	
	effectLineProto._updateEffectSymbol = function (lineData, idx) {
	  var itemModel = lineData.getItemModel(idx);
	  var effectModel = itemModel.getModel('effect');
	  var size = effectModel.get('symbolSize');
	  var symbolType = effectModel.get('symbol');
	
	  if (!zrUtil.isArray(size)) {
	    size = [size, size];
	  }
	
	  var color = effectModel.get('color') || lineData.getItemVisual(idx, 'color');
	  var symbol = this.childAt(1);
	
	  if (this._symbolType !== symbolType) {
	    // Remove previous
	    this.remove(symbol);
	    symbol = createSymbol(symbolType, -0.5, -0.5, 1, 1, color);
	    symbol.z2 = 100;
	    symbol.culling = true;
	    this.add(symbol);
	  } // Symbol may be removed if loop is false
	
	
	  if (!symbol) {
	    return;
	  } // Shadow color is same with color in default
	
	
	  symbol.setStyle('shadowColor', color);
	  symbol.setStyle(effectModel.getItemStyle(['color']));
	  symbol.attr('scale', size);
	  symbol.setColor(color);
	  symbol.attr('scale', size);
	  this._symbolType = symbolType;
	  this._symbolScale = size;
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	effectLineProto._updateEffectAnimation = function (lineData, effectModel, idx) {
	  var symbol = this.childAt(1);
	
	  if (!symbol) {
	    return;
	  }
	
	  var self = this;
	  var points = lineData.getItemLayout(idx);
	  var period = effectModel.get('period') * 1000;
	  var loop = effectModel.get('loop');
	  var constantSpeed = effectModel.get('constantSpeed');
	  var delayExpr = zrUtil.retrieve(effectModel.get('delay'), function (idx) {
	    return idx / lineData.count() * period / 3;
	  });
	  var isDelayFunc = typeof delayExpr === 'function'; // Ignore when updating
	
	  symbol.ignore = true;
	  this.updateAnimationPoints(symbol, points);
	
	  if (constantSpeed > 0) {
	    period = this.getLineLength(symbol) / constantSpeed * 1000;
	  }
	
	  if (period !== this._period || loop !== this._loop) {
	    symbol.stopAnimation();
	    var delay = delayExpr;
	
	    if (isDelayFunc) {
	      delay = delayExpr(idx);
	    }
	
	    if (symbol.__t > 0) {
	      delay = -period * symbol.__t;
	    }
	
	    symbol.__t = 0;
	    var animator = symbol.animate('', loop).when(period, {
	      __t: 1
	    }).delay(delay).during(function () {
	      self.updateSymbolPosition(symbol);
	    });
	
	    if (!loop) {
	      animator.done(function () {
	        self.remove(symbol);
	      });
	    }
	
	    animator.start();
	  }
	
	  this._period = period;
	  this._loop = loop;
	};
	
	effectLineProto.getLineLength = function (symbol) {
	  // Not so accurate
	  return vec2.dist(symbol.__p1, symbol.__cp1) + vec2.dist(symbol.__cp1, symbol.__p2);
	};
	
	effectLineProto.updateAnimationPoints = function (symbol, points) {
	  symbol.__p1 = points[0];
	  symbol.__p2 = points[1];
	  symbol.__cp1 = points[2] || [(points[0][0] + points[1][0]) / 2, (points[0][1] + points[1][1]) / 2];
	};
	
	effectLineProto.updateData = function (lineData, idx, seriesScope) {
	  this.childAt(0).updateData(lineData, idx, seriesScope);
	
	  this._updateEffectSymbol(lineData, idx);
	};
	
	effectLineProto.updateSymbolPosition = function (symbol) {
	  var p1 = symbol.__p1;
	  var p2 = symbol.__p2;
	  var cp1 = symbol.__cp1;
	  var t = symbol.__t;
	  var pos = symbol.position;
	  var lastPos = [pos[0], pos[1]];
	  var quadraticAt = curveUtil.quadraticAt;
	  var quadraticDerivativeAt = curveUtil.quadraticDerivativeAt;
	  pos[0] = quadraticAt(p1[0], cp1[0], p2[0], t);
	  pos[1] = quadraticAt(p1[1], cp1[1], p2[1], t); // Tangent
	
	  var tx = quadraticDerivativeAt(p1[0], cp1[0], p2[0], t);
	  var ty = quadraticDerivativeAt(p1[1], cp1[1], p2[1], t);
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2; // enable continuity trail for 'line', 'rect', 'roundRect' symbolType
	
	  if (this._symbolType === 'line' || this._symbolType === 'rect' || this._symbolType === 'roundRect') {
	    if (symbol.__lastT !== undefined && symbol.__lastT < symbol.__t) {
	      var scaleY = vec2.dist(lastPos, pos) * 1.05;
	      symbol.attr('scale', [symbol.scale[0], scaleY]); // make sure the last segment render within endPoint
	
	      if (t === 1) {
	        pos[0] = lastPos[0] + (pos[0] - lastPos[0]) / 2;
	        pos[1] = lastPos[1] + (pos[1] - lastPos[1]) / 2;
	      }
	    } else if (symbol.__lastT === 1) {
	      // After first loop, symbol.__t does NOT start with 0, so connect p1 to pos directly.
	      var scaleY = 2 * vec2.dist(p1, pos);
	      symbol.attr('scale', [symbol.scale[0], scaleY]);
	    } else {
	      symbol.attr('scale', this._symbolScale);
	    }
	  }
	
	  symbol.__lastT = symbol.__t;
	  symbol.ignore = false;
	};
	
	effectLineProto.updateLayout = function (lineData, idx) {
	  this.childAt(0).updateLayout(lineData, idx);
	  var effectModel = lineData.getItemModel(idx).getModel('effect');
	
	  this._updateEffectAnimation(lineData, effectModel, idx);
	};
	
	zrUtil.inherits(EffectLine, graphic.Group);
	var _default = EffectLine;
	module.exports = _default;

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/chart/helper/Line
	 */
	
	/**
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function Polyline(lineData, idx, seriesScope) {
	  graphic.Group.call(this);
	
	  this._createPolyline(lineData, idx, seriesScope);
	}
	
	var polylineProto = Polyline.prototype;
	
	polylineProto._createPolyline = function (lineData, idx, seriesScope) {
	  // var seriesModel = lineData.hostModel;
	  var points = lineData.getItemLayout(idx);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    }
	  });
	  this.add(line);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto.updateData = function (lineData, idx, seriesScope) {
	  var seriesModel = lineData.hostModel;
	  var line = this.childAt(0);
	  var target = {
	    shape: {
	      points: lineData.getItemLayout(idx)
	    }
	  };
	  graphic.updateProps(line, target, seriesModel, idx);
	
	  this._updateCommonStl(lineData, idx, seriesScope);
	};
	
	polylineProto._updateCommonStl = function (lineData, idx, seriesScope) {
	  var line = this.childAt(0);
	  var itemModel = lineData.getItemModel(idx);
	  var visualColor = lineData.getItemVisual(idx, 'color');
	  var lineStyle = seriesScope && seriesScope.lineStyle;
	  var hoverLineStyle = seriesScope && seriesScope.hoverLineStyle;
	
	  if (!seriesScope || lineData.hasItemOption) {
	    lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	    hoverLineStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	  }
	
	  line.useStyle(zrUtil.defaults({
	    strokeNoScale: true,
	    fill: 'none',
	    stroke: visualColor
	  }, lineStyle));
	  line.hoverStyle = hoverLineStyle;
	  graphic.setHoverStyle(this);
	};
	
	polylineProto.updateLayout = function (lineData, idx) {
	  var polyline = this.childAt(0);
	  polyline.setShape('points', lineData.getItemLayout(idx));
	};
	
	zrUtil.inherits(Polyline, graphic.Group);
	var _default = Polyline;
	module.exports = _default;

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var List = __webpack_require__(109);
	
	var Graph = __webpack_require__(2433);
	
	var linkList = __webpack_require__(872);
	
	var createDimensions = __webpack_require__(251);
	
	var CoordinateSystem = __webpack_require__(121);
	
	var createListFromArray = __webpack_require__(159);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(nodes, edges, seriesModel, directed, beforeLink) {
	  // ??? TODO
	  // support dataset?
	  var graph = new Graph(directed);
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(zrUtil.retrieve( // Id, name, dataIndex
	    nodes[i].id, nodes[i].name, i), i);
	  }
	
	  var linkNameList = [];
	  var validEdges = [];
	  var linkCount = 0;
	
	  for (var i = 0; i < edges.length; i++) {
	    var link = edges[i];
	    var source = link.source;
	    var target = link.target; // addEdge may fail when source or target not exists
	
	    if (graph.addEdge(source, target, linkCount)) {
	      validEdges.push(link);
	      linkNameList.push(zrUtil.retrieve(link.id, source + ' > ' + target));
	      linkCount++;
	    }
	  }
	
	  var coordSys = seriesModel.get('coordinateSystem');
	  var nodeData;
	
	  if (coordSys === 'cartesian2d' || coordSys === 'polar') {
	    nodeData = createListFromArray(nodes, seriesModel);
	  } else {
	    var coordSysCtor = CoordinateSystem.get(coordSys);
	    var coordDimensions = coordSysCtor && coordSysCtor.type !== 'view' ? coordSysCtor.dimensions || [] : []; // FIXME: Some geo do not need `value` dimenson, whereas `calendar` needs
	    // `value` dimension, but graph need `value` dimension. It's better to
	    // uniform this behavior.
	
	    if (zrUtil.indexOf(coordDimensions, 'value') < 0) {
	      coordDimensions.concat(['value']);
	    }
	
	    var dimensionNames = createDimensions(nodes, {
	      coordDimensions: coordDimensions
	    });
	    nodeData = new List(dimensionNames, seriesModel);
	    nodeData.initData(nodes);
	  }
	
	  var edgeData = new List(['value'], seriesModel);
	  edgeData.initData(validEdges, linkNameList);
	  beforeLink && beforeLink(nodeData, edgeData);
	  linkList({
	    mainData: nodeData,
	    struct: graph,
	    structAttr: 'graph',
	    datas: {
	      node: nodeData,
	      edge: edgeData
	    },
	    datasAttr: {
	      node: 'data',
	      edge: 'edgeData'
	    }
	  }); // Update dataIndex of nodes and edges because invalid edge may be removed
	
	  graph.update();
	  return graph;
	}
	
	module.exports = _default;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 * @property {number} [dataIndex]
	 */
	echarts.registerAction({
	  type: 'focusNodeAdjacency',
	  event: 'focusNodeAdjacency',
	  update: 'series:focusNodeAdjacency'
	}, function () {});
	/**
	 * @payload
	 * @property {number} [seriesIndex]
	 * @property {string} [seriesId]
	 * @property {string} [seriesName]
	 */
	
	echarts.registerAction({
	  type: 'unfocusNodeAdjacency',
	  event: 'unfocusNodeAdjacency',
	  update: 'series:unfocusNodeAdjacency'
	}, function () {});

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListSimply = __webpack_require__(245);
	
	var zrUtil = __webpack_require__(4);
	
	var _dimensionHelper = __webpack_require__(293);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var _sourceHelper = __webpack_require__(160);
	
	var makeSeriesEncodeForAxisCoordSys = _sourceHelper.makeSeriesEncodeForAxisCoordSys;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var seriesModelMixin = {
	  /**
	   * @private
	   * @type {string}
	   */
	  _baseAxisDim: null,
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // When both types of xAxis and yAxis are 'value', layout is
	    // needed to be specified by user. Otherwise, layout can be
	    // judged by which axis is category.
	    var ordinalMeta;
	    var xAxisModel = ecModel.getComponent('xAxis', this.get('xAxisIndex'));
	    var yAxisModel = ecModel.getComponent('yAxis', this.get('yAxisIndex'));
	    var xAxisType = xAxisModel.get('type');
	    var yAxisType = yAxisModel.get('type');
	    var addOrdinal; // FIXME
	    // Consider time axis.
	
	    if (xAxisType === 'category') {
	      option.layout = 'horizontal';
	      ordinalMeta = xAxisModel.getOrdinalMeta();
	      addOrdinal = true;
	    } else if (yAxisType === 'category') {
	      option.layout = 'vertical';
	      ordinalMeta = yAxisModel.getOrdinalMeta();
	      addOrdinal = true;
	    } else {
	      option.layout = option.layout || 'horizontal';
	    }
	
	    var coordDims = ['x', 'y'];
	    var baseAxisDimIndex = option.layout === 'horizontal' ? 0 : 1;
	    var baseAxisDim = this._baseAxisDim = coordDims[baseAxisDimIndex];
	    var otherAxisDim = coordDims[1 - baseAxisDimIndex];
	    var axisModels = [xAxisModel, yAxisModel];
	    var baseAxisType = axisModels[baseAxisDimIndex].get('type');
	    var otherAxisType = axisModels[1 - baseAxisDimIndex].get('type');
	    var data = option.data; // ??? FIXME make a stage to perform data transfrom.
	    // MUST create a new data, consider setOption({}) again.
	
	    if (data && addOrdinal) {
	      var newOptionData = [];
	      zrUtil.each(data, function (item, index) {
	        var newItem;
	
	        if (item.value && zrUtil.isArray(item.value)) {
	          newItem = item.value.slice();
	          item.value.unshift(index);
	        } else if (zrUtil.isArray(item)) {
	          newItem = item.slice();
	          item.unshift(index);
	        } else {
	          newItem = item;
	        }
	
	        newOptionData.push(newItem);
	      });
	      option.data = newOptionData;
	    }
	
	    var defaultValueDimensions = this.defaultValueDimensions;
	    var coordDimensions = [{
	      name: baseAxisDim,
	      type: getDimensionTypeByAxis(baseAxisType),
	      ordinalMeta: ordinalMeta,
	      otherDims: {
	        tooltip: false,
	        itemName: 0
	      },
	      dimsDef: ['base']
	    }, {
	      name: otherAxisDim,
	      type: getDimensionTypeByAxis(otherAxisType),
	      dimsDef: defaultValueDimensions.slice()
	    }];
	    return createListSimply(this, {
	      coordDimensions: coordDimensions,
	      dimensionsCount: defaultValueDimensions.length + 1,
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForAxisCoordSys, coordDimensions, this)
	    });
	  },
	
	  /**
	   * If horizontal, base axis is x, otherwise y.
	   * @override
	   */
	  getBaseAxis: function () {
	    var dim = this._baseAxisDim;
	    return this.ecModel.getComponent(dim + 'Axis', this.get(dim + 'AxisIndex')).axis;
	  }
	};
	exports.seriesModelMixin = seriesModelMixin;

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _dataStackHelper = __webpack_require__(140);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	var _util = __webpack_require__(4);
	
	var map = _util.map;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} coordSys
	 * @param {module:echarts/data/List} data
	 * @param {string} valueOrigin lineSeries.option.areaStyle.origin
	 */
	function prepareDataCoordInfo(coordSys, data, valueOrigin) {
	  var baseAxis = coordSys.getBaseAxis();
	  var valueAxis = coordSys.getOtherAxis(baseAxis);
	  var valueStart = getValueStart(valueAxis, valueOrigin);
	  var baseAxisDim = baseAxis.dim;
	  var valueAxisDim = valueAxis.dim;
	  var valueDim = data.mapDimension(valueAxisDim);
	  var baseDim = data.mapDimension(baseAxisDim);
	  var baseDataOffset = valueAxisDim === 'x' || valueAxisDim === 'radius' ? 1 : 0;
	  var dims = map(coordSys.dimensions, function (coordDim) {
	    return data.mapDimension(coordDim);
	  });
	  var stacked;
	  var stackResultDim = data.getCalculationInfo('stackResultDimension');
	
	  if (stacked |= isDimensionStacked(data, dims[0]
	  /*, dims[1]*/
	  )) {
	    // jshint ignore:line
	    dims[0] = stackResultDim;
	  }
	
	  if (stacked |= isDimensionStacked(data, dims[1]
	  /*, dims[0]*/
	  )) {
	    // jshint ignore:line
	    dims[1] = stackResultDim;
	  }
	
	  return {
	    dataDimsForPoint: dims,
	    valueStart: valueStart,
	    valueAxisDim: valueAxisDim,
	    baseAxisDim: baseAxisDim,
	    stacked: !!stacked,
	    valueDim: valueDim,
	    baseDim: baseDim,
	    baseDataOffset: baseDataOffset,
	    stackedOverDimension: data.getCalculationInfo('stackedOverDimension')
	  };
	}
	
	function getValueStart(valueAxis, valueOrigin) {
	  var valueStart = 0;
	  var extent = valueAxis.scale.getExtent();
	
	  if (valueOrigin === 'start') {
	    valueStart = extent[0];
	  } else if (valueOrigin === 'end') {
	    valueStart = extent[1];
	  } // auto
	  else {
	      // Both positive
	      if (extent[0] > 0) {
	        valueStart = extent[0];
	      } // Both negative
	      else if (extent[1] < 0) {
	          valueStart = extent[1];
	        } // If is one positive, and one negative, onZero shall be true
	
	    }
	
	  return valueStart;
	}
	
	function getStackedOnPoint(dataCoordInfo, coordSys, data, idx) {
	  var value = NaN;
	
	  if (dataCoordInfo.stacked) {
	    value = data.get(data.getCalculationInfo('stackedOverDimension'), idx);
	  }
	
	  if (isNaN(value)) {
	    value = dataCoordInfo.valueStart;
	  }
	
	  var baseDataOffset = dataCoordInfo.baseDataOffset;
	  var stackedData = [];
	  stackedData[baseDataOffset] = data.get(dataCoordInfo.baseDim, idx);
	  stackedData[1 - baseDataOffset] = value;
	  return coordSys.dataToPoint(stackedData);
	}
	
	exports.prepareDataCoordInfo = prepareDataCoordInfo;
	exports.getStackedOnPoint = getStackedOnPoint;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Path = __webpack_require__(67);
	
	var vec2 = __webpack_require__(55);
	
	var fixClipWithShadow = __webpack_require__(1199);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Poly path support NaN point
	var vec2Min = vec2.min;
	var vec2Max = vec2.max;
	var scaleAndAdd = vec2.scaleAndAdd;
	var v2Copy = vec2.copy; // Temporary variable
	
	var v = [];
	var cp0 = [];
	var cp1 = [];
	
	function isPointNull(p) {
	  return isNaN(p[0]) || isNaN(p[1]);
	}
	
	function drawSegment(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  // if (smoothMonotone == null) {
	  //     if (isMono(points, 'x')) {
	  //         return drawMono(ctx, points, start, segLen, allLen,
	  //             dir, smoothMin, smoothMax, smooth, 'x', connectNulls);
	  //     }
	  //     else if (isMono(points, 'y')) {
	  //         return drawMono(ctx, points, start, segLen, allLen,
	  //             dir, smoothMin, smoothMax, smooth, 'y', connectNulls);
	  //     }
	  //     else {
	  //         return drawNonMono.apply(this, arguments);
	  //     }
	  // }
	  // else if (smoothMonotone !== 'none' && isMono(points, smoothMonotone)) {
	  //     return drawMono.apply(this, arguments);
	  // }
	  // else {
	  //     return drawNonMono.apply(this, arguments);
	  // }
	  if (smoothMonotone === 'none' || !smoothMonotone) {
	    return drawNonMono.apply(this, arguments);
	  } else {
	    return drawMono.apply(this, arguments);
	  }
	}
	/**
	 * Check if points is in monotone.
	 *
	 * @param {number[][]} points         Array of points which is in [x, y] form
	 * @param {string}     smoothMonotone 'x', 'y', or 'none', stating for which
	 *                                    dimension that is checking.
	 *                                    If is 'none', `drawNonMono` should be
	 *                                    called.
	 *                                    If is undefined, either being monotone
	 *                                    in 'x' or 'y' will call `drawMono`.
	 */
	// function isMono(points, smoothMonotone) {
	//     if (points.length <= 1) {
	//         return true;
	//     }
	//     var dim = smoothMonotone === 'x' ? 0 : 1;
	//     var last = points[0][dim];
	//     var lastDiff = 0;
	//     for (var i = 1; i < points.length; ++i) {
	//         var diff = points[i][dim] - last;
	//         if (!isNaN(diff) && !isNaN(lastDiff)
	//             && diff !== 0 && lastDiff !== 0
	//             && ((diff >= 0) !== (lastDiff >= 0))
	//         ) {
	//             return false;
	//         }
	//         if (!isNaN(diff) && diff !== 0) {
	//             lastDiff = diff;
	//             last = points[i][dim];
	//         }
	//     }
	//     return true;
	// }
	
	/**
	 * Draw smoothed line in monotone, in which only vertical or horizontal bezier
	 * control points will be used. This should be used when points are monotone
	 * either in x or y dimension.
	 */
	
	
	function drawMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  var prevIdx = 0;
	  var idx = start;
	
	  for (var k = 0; k < segLen; k++) {
	    var p = points[idx];
	
	    if (idx >= allLen || idx < 0) {
	      break;
	    }
	
	    if (isPointNull(p)) {
	      if (connectNulls) {
	        idx += dir;
	        continue;
	      }
	
	      break;
	    }
	
	    if (idx === start) {
	      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
	    } else {
	      if (smooth > 0) {
	        var prevP = points[prevIdx];
	        var dim = smoothMonotone === 'y' ? 1 : 0; // Length of control point to p, either in x or y, but not both
	
	        var ctrlLen = (p[dim] - prevP[dim]) * smooth;
	        v2Copy(cp0, prevP);
	        cp0[dim] = prevP[dim] + ctrlLen;
	        v2Copy(cp1, p);
	        cp1[dim] = p[dim] - ctrlLen;
	        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]);
	      } else {
	        ctx.lineTo(p[0], p[1]);
	      }
	    }
	
	    prevIdx = idx;
	    idx += dir;
	  }
	
	  return k;
	}
	/**
	 * Draw smoothed line in non-monotone, in may cause undesired curve in extreme
	 * situations. This should be used when points are non-monotone neither in x or
	 * y dimension.
	 */
	
	
	function drawNonMono(ctx, points, start, segLen, allLen, dir, smoothMin, smoothMax, smooth, smoothMonotone, connectNulls) {
	  var prevIdx = 0;
	  var idx = start;
	
	  for (var k = 0; k < segLen; k++) {
	    var p = points[idx];
	
	    if (idx >= allLen || idx < 0) {
	      break;
	    }
	
	    if (isPointNull(p)) {
	      if (connectNulls) {
	        idx += dir;
	        continue;
	      }
	
	      break;
	    }
	
	    if (idx === start) {
	      ctx[dir > 0 ? 'moveTo' : 'lineTo'](p[0], p[1]);
	      v2Copy(cp0, p);
	    } else {
	      if (smooth > 0) {
	        var nextIdx = idx + dir;
	        var nextP = points[nextIdx];
	
	        if (connectNulls) {
	          // Find next point not null
	          while (nextP && isPointNull(points[nextIdx])) {
	            nextIdx += dir;
	            nextP = points[nextIdx];
	          }
	        }
	
	        var ratioNextSeg = 0.5;
	        var prevP = points[prevIdx];
	        var nextP = points[nextIdx]; // Last point
	
	        if (!nextP || isPointNull(nextP)) {
	          v2Copy(cp1, p);
	        } else {
	          // If next data is null in not connect case
	          if (isPointNull(nextP) && !connectNulls) {
	            nextP = p;
	          }
	
	          vec2.sub(v, nextP, prevP);
	          var lenPrevSeg;
	          var lenNextSeg;
	
	          if (smoothMonotone === 'x' || smoothMonotone === 'y') {
	            var dim = smoothMonotone === 'x' ? 0 : 1;
	            lenPrevSeg = Math.abs(p[dim] - prevP[dim]);
	            lenNextSeg = Math.abs(p[dim] - nextP[dim]);
	          } else {
	            lenPrevSeg = vec2.dist(p, prevP);
	            lenNextSeg = vec2.dist(p, nextP);
	          } // Use ratio of seg length
	
	
	          ratioNextSeg = lenNextSeg / (lenNextSeg + lenPrevSeg);
	          scaleAndAdd(cp1, p, v, -smooth * (1 - ratioNextSeg));
	        } // Smooth constraint
	
	
	        vec2Min(cp0, cp0, smoothMax);
	        vec2Max(cp0, cp0, smoothMin);
	        vec2Min(cp1, cp1, smoothMax);
	        vec2Max(cp1, cp1, smoothMin);
	        ctx.bezierCurveTo(cp0[0], cp0[1], cp1[0], cp1[1], p[0], p[1]); // cp0 of next segment
	
	        scaleAndAdd(cp0, p, v, smooth * ratioNextSeg);
	      } else {
	        ctx.lineTo(p[0], p[1]);
	      }
	    }
	
	    prevIdx = idx;
	    idx += dir;
	  }
	
	  return k;
	}
	
	function getBoundingBox(points, smoothConstraint) {
	  var ptMin = [Infinity, Infinity];
	  var ptMax = [-Infinity, -Infinity];
	
	  if (smoothConstraint) {
	    for (var i = 0; i < points.length; i++) {
	      var pt = points[i];
	
	      if (pt[0] < ptMin[0]) {
	        ptMin[0] = pt[0];
	      }
	
	      if (pt[1] < ptMin[1]) {
	        ptMin[1] = pt[1];
	      }
	
	      if (pt[0] > ptMax[0]) {
	        ptMax[0] = pt[0];
	      }
	
	      if (pt[1] > ptMax[1]) {
	        ptMax[1] = pt[1];
	      }
	    }
	  }
	
	  return {
	    min: smoothConstraint ? ptMin : ptMax,
	    max: smoothConstraint ? ptMax : ptMin
	  };
	}
	
	var Polyline = Path.extend({
	  type: 'ec-polyline',
	  shape: {
	    points: [],
	    smooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  style: {
	    fill: null,
	    stroke: '#000'
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var i = 0;
	    var len = points.length;
	    var result = getBoundingBox(points, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      i += drawSegment(ctx, points, i, len, len, 1, result.min, result.max, shape.smooth, shape.smoothMonotone, shape.connectNulls) + 1;
	    }
	  }
	});
	var Polygon = Path.extend({
	  type: 'ec-polygon',
	  shape: {
	    points: [],
	    // Offset between stacked base points and points
	    stackedOnPoints: [],
	    smooth: 0,
	    stackedOnSmooth: 0,
	    smoothConstraint: true,
	    smoothMonotone: null,
	    connectNulls: false
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var points = shape.points;
	    var stackedOnPoints = shape.stackedOnPoints;
	    var i = 0;
	    var len = points.length;
	    var smoothMonotone = shape.smoothMonotone;
	    var bbox = getBoundingBox(points, shape.smoothConstraint);
	    var stackedOnBBox = getBoundingBox(stackedOnPoints, shape.smoothConstraint);
	
	    if (shape.connectNulls) {
	      // Must remove first and last null values avoid draw error in polygon
	      for (; len > 0; len--) {
	        if (!isPointNull(points[len - 1])) {
	          break;
	        }
	      }
	
	      for (; i < len; i++) {
	        if (!isPointNull(points[i])) {
	          break;
	        }
	      }
	    }
	
	    while (i < len) {
	      var k = drawSegment(ctx, points, i, len, len, 1, bbox.min, bbox.max, shape.smooth, smoothMonotone, shape.connectNulls);
	      drawSegment(ctx, stackedOnPoints, i + k - 1, k, len, -1, stackedOnBBox.min, stackedOnBBox.max, shape.stackedOnSmooth, smoothMonotone, shape.connectNulls);
	      i += k + 1;
	      ctx.closePath();
	    }
	  }
	});
	exports.Polyline = Polyline;
	exports.Polygon = Polygon;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createRenderPlanner = __webpack_require__(246);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var _default = {
	  seriesType: 'lines',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var isPolyline = seriesModel.get('polyline');
	    var isLarge = seriesModel.pipelineContext.large;
	
	    function progress(params, lineData) {
	      var lineCoords = [];
	
	      if (isLarge) {
	        var points;
	        var segCount = params.end - params.start;
	
	        if (isPolyline) {
	          var totalCoordsCount = 0;
	
	          for (var i = params.start; i < params.end; i++) {
	            totalCoordsCount += seriesModel.getLineCoordsCount(i);
	          }
	
	          points = new Float32Array(segCount + totalCoordsCount * 2);
	        } else {
	          points = new Float32Array(segCount * 4);
	        }
	
	        var offset = 0;
	        var pt = [];
	
	        for (var i = params.start; i < params.end; i++) {
	          var len = seriesModel.getLineCoords(i, lineCoords);
	
	          if (isPolyline) {
	            points[offset++] = len;
	          }
	
	          for (var k = 0; k < len; k++) {
	            pt = coordSys.dataToPoint(lineCoords[k], false, pt);
	            points[offset++] = pt[0];
	            points[offset++] = pt[1];
	          }
	        }
	
	        lineData.setLayout('linesPoints', points);
	      } else {
	        for (var i = params.start; i < params.end; i++) {
	          var itemModel = lineData.getItemModel(i);
	          var len = seriesModel.getLineCoords(i, lineCoords);
	          var pts = [];
	
	          if (isPolyline) {
	            for (var j = 0; j < len; j++) {
	              pts.push(coordSys.dataToPoint(lineCoords[j]));
	            }
	          } else {
	            pts[0] = coordSys.dataToPoint(lineCoords[0]);
	            pts[1] = coordSys.dataToPoint(lineCoords[1]);
	            var curveness = itemModel.get('lineStyle.curveness');
	
	            if (+curveness) {
	              pts[2] = [(pts[0][0] + pts[1][0]) / 2 - (pts[0][1] - pts[1][1]) * curveness, (pts[0][1] + pts[1][1]) / 2 - (pts[1][0] - pts[0][0]) * curveness];
	            }
	          }
	
	          lineData.setItemLayout(i, pts);
	        }
	      }
	    }
	
	    return {
	      progress: progress
	    };
	  }
	};
	module.exports = _default;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var layout = __webpack_require__(46);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The tree layoutHelper implementation was originally copied from
	* "d3.js"(https://github.com/d3/d3-hierarchy) with
	* some modifications made for this project.
	* (see more details in the comment of the specific method below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the licence of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	
	/**
	 * @file The layout algorithm of node-link tree diagrams. Here we using Reingold-Tilford algorithm to drawing
	 *       the tree.
	 */
	
	/**
	 * Initialize all computational message for following algorithm.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} root   The virtual root of the tree.
	 */
	function init(root) {
	  root.hierNode = {
	    defaultAncestor: null,
	    ancestor: root,
	    prelim: 0,
	    modifier: 0,
	    change: 0,
	    shift: 0,
	    i: 0,
	    thread: null
	  };
	  var nodes = [root];
	  var node;
	  var children;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    children = node.children;
	
	    if (node.isExpand && children.length) {
	      var n = children.length;
	
	      for (var i = n - 1; i >= 0; i--) {
	        var child = children[i];
	        child.hierNode = {
	          defaultAncestor: null,
	          ancestor: child,
	          prelim: 0,
	          modifier: 0,
	          change: 0,
	          shift: 0,
	          i: i,
	          thread: null
	        };
	        nodes.push(child);
	      }
	    }
	  }
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Computes a preliminary x coordinate for node. Before that, this function is
	 * applied recursively to the children of node, as well as the function
	 * apportion(). After spacing out the children by calling executeShifts(), the
	 * node is placed to the midpoint of its outermost children.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param {Function} separation
	 */
	
	
	function firstWalk(node, separation) {
	  var children = node.isExpand ? node.children : [];
	  var siblings = node.parentNode.children;
	  var subtreeW = node.hierNode.i ? siblings[node.hierNode.i - 1] : null;
	
	  if (children.length) {
	    executeShifts(node);
	    var midPoint = (children[0].hierNode.prelim + children[children.length - 1].hierNode.prelim) / 2;
	
	    if (subtreeW) {
	      node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	      node.hierNode.modifier = node.hierNode.prelim - midPoint;
	    } else {
	      node.hierNode.prelim = midPoint;
	    }
	  } else if (subtreeW) {
	    node.hierNode.prelim = subtreeW.hierNode.prelim + separation(node, subtreeW);
	  }
	
	  node.parentNode.hierNode.defaultAncestor = apportion(node, subtreeW, node.parentNode.hierNode.defaultAncestor || siblings[0], separation);
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Computes all real x-coordinates by summing up the modifiers recursively.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function secondWalk(node) {
	  var nodeX = node.hierNode.prelim + node.parentNode.hierNode.modifier;
	  node.setLayout({
	    x: nodeX
	  }, true);
	  node.hierNode.modifier += node.parentNode.hierNode.modifier;
	}
	
	function separation(cb) {
	  return arguments.length ? cb : defaultSeparation;
	}
	/**
	 * Transform the common coordinate to radial coordinate.
	 *
	 * @param  {number} x
	 * @param  {number} y
	 * @return {Object}
	 */
	
	
	function radialCoordinate(x, y) {
	  var radialCoor = {};
	  x -= Math.PI / 2;
	  radialCoor.x = y * Math.cos(x);
	  radialCoor.y = y * Math.sin(x);
	  return radialCoor;
	}
	/**
	 * Get the layout position of the whole view.
	 *
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	/**
	 * All other shifts, applied to the smaller subtrees between w- and w+, are
	 * performed by this function.
	 *
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 */
	
	
	function executeShifts(node) {
	  var children = node.children;
	  var n = children.length;
	  var shift = 0;
	  var change = 0;
	
	  while (--n >= 0) {
	    var child = children[n];
	    child.hierNode.prelim += shift;
	    child.hierNode.modifier += shift;
	    change += child.hierNode.change;
	    shift += child.hierNode.shift + change;
	  }
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * The core of the algorithm. Here, a new subtree is combined with the
	 * previous subtrees. Threads are used to traverse the inside and outside
	 * contours of the left and right subtree up to the highest common level.
	 * Whenever two nodes of the inside contours conflict, we compute the left
	 * one of the greatest uncommon ancestors using the function nextAncestor()
	 * and call moveSubtree() to shift the subtree and prepare the shifts of
	 * smaller subtrees. Finally, we add a new thread (if necessary).
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeV
	 * @param  {module:echarts/data/Tree~TreeNode} subtreeW
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @param  {Function} separation
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function apportion(subtreeV, subtreeW, ancestor, separation) {
	  if (subtreeW) {
	    var nodeOutRight = subtreeV;
	    var nodeInRight = subtreeV;
	    var nodeOutLeft = nodeInRight.parentNode.children[0];
	    var nodeInLeft = subtreeW;
	    var sumOutRight = nodeOutRight.hierNode.modifier;
	    var sumInRight = nodeInRight.hierNode.modifier;
	    var sumOutLeft = nodeOutLeft.hierNode.modifier;
	    var sumInLeft = nodeInLeft.hierNode.modifier;
	
	    while (nodeInLeft = nextRight(nodeInLeft), nodeInRight = nextLeft(nodeInRight), nodeInLeft && nodeInRight) {
	      nodeOutRight = nextRight(nodeOutRight);
	      nodeOutLeft = nextLeft(nodeOutLeft);
	      nodeOutRight.hierNode.ancestor = subtreeV;
	      var shift = nodeInLeft.hierNode.prelim + sumInLeft - nodeInRight.hierNode.prelim - sumInRight + separation(nodeInLeft, nodeInRight);
	
	      if (shift > 0) {
	        moveSubtree(nextAncestor(nodeInLeft, subtreeV, ancestor), subtreeV, shift);
	        sumInRight += shift;
	        sumOutRight += shift;
	      }
	
	      sumInLeft += nodeInLeft.hierNode.modifier;
	      sumInRight += nodeInRight.hierNode.modifier;
	      sumOutRight += nodeOutRight.hierNode.modifier;
	      sumOutLeft += nodeOutLeft.hierNode.modifier;
	    }
	
	    if (nodeInLeft && !nextRight(nodeOutRight)) {
	      nodeOutRight.hierNode.thread = nodeInLeft;
	      nodeOutRight.hierNode.modifier += sumInLeft - sumOutRight;
	    }
	
	    if (nodeInRight && !nextLeft(nodeOutLeft)) {
	      nodeOutLeft.hierNode.thread = nodeInRight;
	      nodeOutLeft.hierNode.modifier += sumInRight - sumOutLeft;
	      ancestor = subtreeV;
	    }
	  }
	
	  return ancestor;
	}
	/**
	 * This function is used to traverse the right contour of a subtree.
	 * It returns the rightmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextRight(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[children.length - 1] : node.hierNode.thread;
	}
	/**
	 * This function is used to traverse the left contour of a subtree (or a subforest).
	 * It returns the leftmost child of node or the thread of node. The function
	 * returns null if and only if node is on the highest depth of its subtree.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextLeft(node) {
	  var children = node.children;
	  return children.length && node.isExpand ? children[0] : node.hierNode.thread;
	}
	/**
	 * If nodeInLeft’s ancestor is a sibling of node, returns nodeInLeft’s ancestor.
	 * Otherwise, returns the specified ancestor.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} nodeInLeft
	 * @param  {module:echarts/data/Tree~TreeNode} node
	 * @param  {module:echarts/data/Tree~TreeNode} ancestor
	 * @return {module:echarts/data/Tree~TreeNode}
	 */
	
	
	function nextAncestor(nodeInLeft, node, ancestor) {
	  return nodeInLeft.hierNode.ancestor.parentNode === node.parentNode ? nodeInLeft.hierNode.ancestor : ancestor;
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * Shifts the current subtree rooted at wr.
	 * This is done by increasing prelim(w+) and modifier(w+) by shift.
	 *
	 * @param  {module:echarts/data/Tree~TreeNode} wl
	 * @param  {module:echarts/data/Tree~TreeNode} wr
	 * @param  {number} shift [description]
	 */
	
	
	function moveSubtree(wl, wr, shift) {
	  var change = shift / (wr.hierNode.i - wl.hierNode.i);
	  wr.hierNode.change -= change;
	  wr.hierNode.shift += shift;
	  wr.hierNode.modifier += shift;
	  wr.hierNode.prelim += shift;
	  wl.hierNode.change += change;
	}
	/**
	 * The implementation of this function was originally copied from "d3.js"
	 * <https://github.com/d3/d3-hierarchy/blob/4c1f038f2725d6eae2e49b61d01456400694bac4/src/tree.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 */
	
	
	function defaultSeparation(node1, node2) {
	  return node1.parentNode === node2.parentNode ? 1 : 2;
	}
	
	exports.init = init;
	exports.firstWalk = firstWalk;
	exports.secondWalk = secondWalk;
	exports.separation = separation;
	exports.radialCoordinate = radialCoordinate;
	exports.getViewRect = getViewRect;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function rectCoordAxisBuildSplitArea(axisView, axisGroup, axisModel, gridModel) {
	  var axis = axisModel.axis;
	
	  if (axis.scale.isBlank()) {
	    return;
	  }
	
	  var splitAreaModel = axisModel.getModel('splitArea');
	  var areaStyleModel = splitAreaModel.getModel('areaStyle');
	  var areaColors = areaStyleModel.get('color');
	  var gridRect = gridModel.coordinateSystem.getRect();
	  var ticksCoords = axis.getTicksCoords({
	    tickModel: splitAreaModel,
	    clamp: true
	  });
	
	  if (!ticksCoords.length) {
	    return;
	  } // For Making appropriate splitArea animation, the color and anid
	  // should be corresponding to previous one if possible.
	
	
	  var areaColorsLen = areaColors.length;
	  var lastSplitAreaColors = axisView.__splitAreaColors;
	  var newSplitAreaColors = zrUtil.createHashMap();
	  var colorIndex = 0;
	
	  if (lastSplitAreaColors) {
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var cIndex = lastSplitAreaColors.get(ticksCoords[i].tickValue);
	
	      if (cIndex != null) {
	        colorIndex = (cIndex + (areaColorsLen - 1) * i) % areaColorsLen;
	        break;
	      }
	    }
	  }
	
	  var prev = axis.toGlobalCoord(ticksCoords[0].coord);
	  var areaStyle = areaStyleModel.getAreaStyle();
	  areaColors = zrUtil.isArray(areaColors) ? areaColors : [areaColors];
	
	  for (var i = 1; i < ticksCoords.length; i++) {
	    var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	    var x;
	    var y;
	    var width;
	    var height;
	
	    if (axis.isHorizontal()) {
	      x = prev;
	      y = gridRect.y;
	      width = tickCoord - x;
	      height = gridRect.height;
	      prev = x + width;
	    } else {
	      x = gridRect.x;
	      y = prev;
	      width = gridRect.width;
	      height = tickCoord - y;
	      prev = y + height;
	    }
	
	    var tickValue = ticksCoords[i - 1].tickValue;
	    tickValue != null && newSplitAreaColors.set(tickValue, colorIndex);
	    axisGroup.add(new graphic.Rect({
	      anid: tickValue != null ? 'area_' + tickValue : null,
	      shape: {
	        x: x,
	        y: y,
	        width: width,
	        height: height
	      },
	      style: zrUtil.defaults({
	        fill: areaColors[colorIndex]
	      }, areaStyle),
	      silent: true
	    }));
	    colorIndex = (colorIndex + 1) % areaColorsLen;
	  }
	
	  axisView.__splitAreaColors = newSplitAreaColors;
	}
	
	function rectCoordAxisHandleRemove(axisView) {
	  axisView.__splitAreaColors = null;
	}
	
	exports.rectCoordAxisBuildSplitArea = rectCoordAxisBuildSplitArea;
	exports.rectCoordAxisHandleRemove = rectCoordAxisHandleRemove;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseAxisPointer = __webpack_require__(500);
	
	var viewHelper = __webpack_require__(355);
	
	var cartesianAxisHelper = __webpack_require__(864);
	
	var AxisView = __webpack_require__(210);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CartesianAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisPointerType = axisPointerModel.get('type');
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var pixelValue = axis.toGlobalCoord(axis.dataToCoord(value, true));
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = cartesianAxisHelper.layout(grid.model, axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = cartesianAxisHelper.layout(axisModel.axis.grid.model, axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var grid = axis.grid;
	    var axisExtent = axis.getGlobalExtent(true);
	    var otherExtent = getCartesian(grid, axis).getOtherAxis(axis).getGlobalExtent();
	    var dimIndex = axis.dim === 'x' ? 0 : 1;
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex]; // Make tooltip do not overlap axisPointer and in the middle of the grid.
	
	    var tooltipOptions = [{
	      verticalAlign: 'middle'
	    }, {
	      align: 'center'
	    }];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: tooltipOptions[dimIndex]
	    };
	  }
	});
	
	function getCartesian(grid, axis) {
	  var opt = {};
	  opt[axis.dim + 'AxisIndex'] = axis.index;
	  return grid.getCartesian(opt);
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getAxisDimIndex(axis));
	    return {
	      type: 'Line',
	      subPixelOptimize: true,
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent) {
	    var bandWidth = Math.max(1, axis.getBandWidth());
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getAxisDimIndex(axis))
	    };
	  }
	};
	
	function getAxisDimIndex(axis) {
	  return axis.dim === 'x' ? 0 : 1;
	}
	
	AxisView.registerAxisPointerClass('CartesianAxisPointer', CartesianAxisPointer);
	var _default = CartesianAxisPointer;
	module.exports = _default;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var modelUtil = __webpack_require__(29);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} finder contains {seriesIndex, dataIndex, dataIndexInside}
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} {point: [x, y], el: ...} point Will not be null.
	 */
	function _default(finder, ecModel) {
	  var point = [];
	  var seriesIndex = finder.seriesIndex;
	  var seriesModel;
	
	  if (seriesIndex == null || !(seriesModel = ecModel.getSeriesByIndex(seriesIndex))) {
	    return {
	      point: []
	    };
	  }
	
	  var data = seriesModel.getData();
	  var dataIndex = modelUtil.queryDataIndex(data, finder);
	
	  if (dataIndex == null || dataIndex < 0 || zrUtil.isArray(dataIndex)) {
	    return {
	      point: []
	    };
	  }
	
	  var el = data.getItemGraphicEl(dataIndex);
	  var coordSys = seriesModel.coordinateSystem;
	
	  if (seriesModel.getTooltipPosition) {
	    point = seriesModel.getTooltipPosition(dataIndex) || [];
	  } else if (coordSys && coordSys.dataToPoint) {
	    point = coordSys.dataToPoint(data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
	      return data.mapDimension(dim);
	    }), dataIndex, true)) || [];
	  } else if (el) {
	    // Use graphic bounding rect
	    var rect = el.getBoundingRect().clone();
	    rect.applyTransform(el.transform);
	    point = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  }
	
	  return {
	    point: point,
	    el: el
	  };
	}
	
	module.exports = _default;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var env = __webpack_require__(73);
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var each = zrUtil.each;
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Function} handler
	 *      param: {string} currTrigger
	 *      param: {Array.<number>} point
	 */
	
	function register(key, api, handler) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  inner(zr).records || (inner(zr).records = {});
	  initGlobalListeners(zr, api);
	  var record = inner(zr).records[key] || (inner(zr).records[key] = {});
	  record.handler = handler;
	}
	
	function initGlobalListeners(zr, api) {
	  if (inner(zr).initialized) {
	    return;
	  }
	
	  inner(zr).initialized = true;
	  useHandler('click', zrUtil.curry(doEnter, 'click'));
	  useHandler('mousemove', zrUtil.curry(doEnter, 'mousemove')); // useHandler('mouseout', onLeave);
	
	  useHandler('globalout', onLeave);
	
	  function useHandler(eventType, cb) {
	    zr.on(eventType, function (e) {
	      var dis = makeDispatchAction(api);
	      each(inner(zr).records, function (record) {
	        record && cb(record, e, dis.dispatchAction);
	      });
	      dispatchTooltipFinally(dis.pendings, api);
	    });
	  }
	}
	
	function dispatchTooltipFinally(pendings, api) {
	  var showLen = pendings.showTip.length;
	  var hideLen = pendings.hideTip.length;
	  var actuallyPayload;
	
	  if (showLen) {
	    actuallyPayload = pendings.showTip[showLen - 1];
	  } else if (hideLen) {
	    actuallyPayload = pendings.hideTip[hideLen - 1];
	  }
	
	  if (actuallyPayload) {
	    actuallyPayload.dispatchAction = null;
	    api.dispatchAction(actuallyPayload);
	  }
	}
	
	function onLeave(record, e, dispatchAction) {
	  record.handler('leave', null, dispatchAction);
	}
	
	function doEnter(currTrigger, record, e, dispatchAction) {
	  record.handler(currTrigger, e, dispatchAction);
	}
	
	function makeDispatchAction(api) {
	  var pendings = {
	    showTip: [],
	    hideTip: []
	  }; // FIXME
	  // better approach?
	  // 'showTip' and 'hideTip' can be triggered by axisPointer and tooltip,
	  // which may be conflict, (axisPointer call showTip but tooltip call hideTip);
	  // So we have to add "final stage" to merge those dispatched actions.
	
	  var dispatchAction = function (payload) {
	    var pendingList = pendings[payload.type];
	
	    if (pendingList) {
	      pendingList.push(payload);
	    } else {
	      payload.dispatchAction = dispatchAction;
	      api.dispatchAction(payload);
	    }
	  };
	
	  return {
	    dispatchAction: dispatchAction,
	    pendings: pendings
	  };
	}
	/**
	 * @param {string} key
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function unregister(key, api) {
	  if (env.node) {
	    return;
	  }
	
	  var zr = api.getZr();
	  var record = (inner(zr).records || {})[key];
	
	  if (record) {
	    inner(zr).records[key] = null;
	  }
	}
	
	exports.register = register;
	exports.unregister = unregister;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var BoundingRect = __webpack_require__(60);
	
	var visualSolution = __webpack_require__(364);
	
	var selector = __webpack_require__(2330);
	
	var throttleUtil = __webpack_require__(181);
	
	var BrushTargetManager = __webpack_require__(843);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var STATE_LIST = ['inBrush', 'outOfBrush'];
	var DISPATCH_METHOD = '__ecBrushSelect';
	var DISPATCH_FLAG = '__ecInBrushSelectEvent';
	var PRIORITY_BRUSH = echarts.PRIORITY.VISUAL.BRUSH;
	/**
	 * Layout for visual, the priority higher than other layout, and before brush visual.
	 */
	
	echarts.registerLayout(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    payload && payload.type === 'takeGlobalCursor' && brushModel.setBrushOption(payload.key === 'brush' ? payload.brushOption : {
	      brushType: false
	    });
	  });
	  layoutCovers(ecModel);
	});
	
	function layoutCovers(ecModel) {
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    var brushTargetManager = brushModel.brushTargetManager = new BrushTargetManager(brushModel.option, ecModel);
	    brushTargetManager.setInputRanges(brushModel.areas, ecModel);
	  });
	}
	/**
	 * Register the visual encoding if this modules required.
	 */
	
	
	echarts.registerVisual(PRIORITY_BRUSH, function (ecModel, api, payload) {
	  var brushSelected = [];
	  var throttleType;
	  var throttleDelay;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel, brushIndex) {
	    var thisBrushSelected = {
	      brushId: brushModel.id,
	      brushIndex: brushIndex,
	      brushName: brushModel.name,
	      areas: zrUtil.clone(brushModel.areas),
	      selected: []
	    }; // Every brush component exists in event params, convenient
	    // for user to find by index.
	
	    brushSelected.push(thisBrushSelected);
	    var brushOption = brushModel.option;
	    var brushLink = brushOption.brushLink;
	    var linkedSeriesMap = [];
	    var selectedDataIndexForLink = [];
	    var rangeInfoBySeries = [];
	    var hasBrushExists = 0;
	
	    if (!brushIndex) {
	      // Only the first throttle setting works.
	      throttleType = brushOption.throttleType;
	      throttleDelay = brushOption.throttleDelay;
	    } // Add boundingRect and selectors to range.
	
	
	    var areas = zrUtil.map(brushModel.areas, function (area) {
	      return bindSelector(zrUtil.defaults({
	        boundingRect: boundingRectBuilders[area.brushType](area)
	      }, area));
	    });
	    var visualMappings = visualSolution.createVisualMappings(brushModel.option, STATE_LIST, function (mappingOption) {
	      mappingOption.mappingMethod = 'fixed';
	    });
	    zrUtil.isArray(brushLink) && zrUtil.each(brushLink, function (seriesIndex) {
	      linkedSeriesMap[seriesIndex] = 1;
	    });
	
	    function linkOthers(seriesIndex) {
	      return brushLink === 'all' || linkedSeriesMap[seriesIndex];
	    } // If no supported brush or no brush on the series,
	    // all visuals should be in original state.
	
	
	    function brushed(rangeInfoList) {
	      return !!rangeInfoList.length;
	    }
	    /**
	     * Logic for each series: (If the logic has to be modified one day, do it carefully!)
	     *
	     * ( brushed ┬ && ┬hasBrushExist ┬ && linkOthers  ) => StepA: ┬record, ┬ StepB: ┬visualByRecord.
	     *   !brushed┘    ├hasBrushExist ┤                            └nothing,┘        ├visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( !brushed  && ┬hasBrushExist ┬ && linkOthers  ) => StepA:  nothing,  StepB: ┬visualByRecord.
	     *                └!hasBrushExist┘                                              └nothing.
	     * ( brushed ┬ &&                     !linkOthers ) => StepA:  nothing,  StepB: ┬visualByCheck.
	     *   !brushed┘                                                                  └nothing.
	     * ( !brushed  &&                     !linkOthers ) => StepA:  nothing,  StepB:  nothing.
	     */
	    // Step A
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var rangeInfoList = rangeInfoBySeries[seriesIndex] = [];
	      seriesModel.subType === 'parallel' ? stepAParallel(seriesModel, seriesIndex, rangeInfoList) : stepAOthers(seriesModel, seriesIndex, rangeInfoList);
	    });
	
	    function stepAParallel(seriesModel, seriesIndex) {
	      var coordSys = seriesModel.coordinateSystem;
	      hasBrushExists |= coordSys.hasAxisBrushed();
	      linkOthers(seriesIndex) && coordSys.eachActiveState(seriesModel.getData(), function (activeState, dataIndex) {
	        activeState === 'active' && (selectedDataIndexForLink[dataIndex] = 1);
	      });
	    }
	
	    function stepAOthers(seriesModel, seriesIndex, rangeInfoList) {
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	
	      if (!selectorsByBrushType || brushModelNotControll(brushModel, seriesIndex)) {
	        return;
	      }
	
	      zrUtil.each(areas, function (area) {
	        selectorsByBrushType[area.brushType] && brushModel.brushTargetManager.controlSeries(area, seriesModel, ecModel) && rangeInfoList.push(area);
	        hasBrushExists |= brushed(rangeInfoList);
	      });
	
	      if (linkOthers(seriesIndex) && brushed(rangeInfoList)) {
	        var data = seriesModel.getData();
	        data.each(function (dataIndex) {
	          if (checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex)) {
	            selectedDataIndexForLink[dataIndex] = 1;
	          }
	        });
	      }
	    } // Step B
	
	
	    ecModel.eachSeries(function (seriesModel, seriesIndex) {
	      var seriesBrushSelected = {
	        seriesId: seriesModel.id,
	        seriesIndex: seriesIndex,
	        seriesName: seriesModel.name,
	        dataIndex: []
	      }; // Every series exists in event params, convenient
	      // for user to find series by seriesIndex.
	
	      thisBrushSelected.selected.push(seriesBrushSelected);
	      var selectorsByBrushType = getSelectorsByBrushType(seriesModel);
	      var rangeInfoList = rangeInfoBySeries[seriesIndex];
	      var data = seriesModel.getData();
	      var getValueState = linkOthers(seriesIndex) ? function (dataIndex) {
	        return selectedDataIndexForLink[dataIndex] ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      } : function (dataIndex) {
	        return checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) ? (seriesBrushSelected.dataIndex.push(data.getRawIndex(dataIndex)), 'inBrush') : 'outOfBrush';
	      }; // If no supported brush or no brush, all visuals are in original state.
	
	      (linkOthers(seriesIndex) ? hasBrushExists : brushed(rangeInfoList)) && visualSolution.applyVisual(STATE_LIST, visualMappings, data, getValueState);
	    });
	  });
	  dispatchAction(api, throttleType, throttleDelay, brushSelected, payload);
	});
	
	function dispatchAction(api, throttleType, throttleDelay, brushSelected, payload) {
	  // This event will not be triggered when `setOpion`, otherwise dead lock may
	  // triggered when do `setOption` in event listener, which we do not find
	  // satisfactory way to solve yet. Some considered resolutions:
	  // (a) Diff with prevoius selected data ant only trigger event when changed.
	  // But store previous data and diff precisely (i.e., not only by dataIndex, but
	  // also detect value changes in selected data) might bring complexity or fragility.
	  // (b) Use spectial param like `silent` to suppress event triggering.
	  // But such kind of volatile param may be weird in `setOption`.
	  if (!payload) {
	    return;
	  }
	
	  var zr = api.getZr();
	
	  if (zr[DISPATCH_FLAG]) {
	    return;
	  }
	
	  if (!zr[DISPATCH_METHOD]) {
	    zr[DISPATCH_METHOD] = doDispatch;
	  }
	
	  var fn = throttleUtil.createOrUpdate(zr, DISPATCH_METHOD, throttleDelay, throttleType);
	  fn(api, brushSelected);
	}
	
	function doDispatch(api, brushSelected) {
	  if (!api.isDisposed()) {
	    var zr = api.getZr();
	    zr[DISPATCH_FLAG] = true;
	    api.dispatchAction({
	      type: 'brushSelect',
	      batch: brushSelected
	    });
	    zr[DISPATCH_FLAG] = false;
	  }
	}
	
	function checkInRange(selectorsByBrushType, rangeInfoList, data, dataIndex) {
	  for (var i = 0, len = rangeInfoList.length; i < len; i++) {
	    var area = rangeInfoList[i];
	
	    if (selectorsByBrushType[area.brushType](dataIndex, data, area.selectors, area)) {
	      return true;
	    }
	  }
	}
	
	function getSelectorsByBrushType(seriesModel) {
	  var brushSelector = seriesModel.brushSelector;
	
	  if (zrUtil.isString(brushSelector)) {
	    var sels = [];
	    zrUtil.each(selector, function (selectorsByElementType, brushType) {
	      sels[brushType] = function (dataIndex, data, selectors, area) {
	        var itemLayout = data.getItemLayout(dataIndex);
	        return selectorsByElementType[brushSelector](itemLayout, selectors, area);
	      };
	    });
	    return sels;
	  } else if (zrUtil.isFunction(brushSelector)) {
	    var bSelector = {};
	    zrUtil.each(selector, function (sel, brushType) {
	      bSelector[brushType] = brushSelector;
	    });
	    return bSelector;
	  }
	
	  return brushSelector;
	}
	
	function brushModelNotControll(brushModel, seriesIndex) {
	  var seriesIndices = brushModel.option.seriesIndex;
	  return seriesIndices != null && seriesIndices !== 'all' && (zrUtil.isArray(seriesIndices) ? zrUtil.indexOf(seriesIndices, seriesIndex) < 0 : seriesIndex !== seriesIndices);
	}
	
	function bindSelector(area) {
	  var selectors = area.selectors = {};
	  zrUtil.each(selector[area.brushType], function (selFn, elType) {
	    // Do not use function binding or curry for performance.
	    selectors[elType] = function (itemLayout) {
	      return selFn(itemLayout, selectors, area);
	    };
	  });
	  return area;
	}
	
	var boundingRectBuilders = {
	  lineX: zrUtil.noop,
	  lineY: zrUtil.noop,
	  rect: function (area) {
	    return getBoundingRectFromMinMax(area.range);
	  },
	  polygon: function (area) {
	    var minMax;
	    var range = area.range;
	
	    for (var i = 0, len = range.length; i < len; i++) {
	      minMax = minMax || [[Infinity, -Infinity], [Infinity, -Infinity]];
	      var rg = range[i];
	      rg[0] < minMax[0][0] && (minMax[0][0] = rg[0]);
	      rg[0] > minMax[0][1] && (minMax[0][1] = rg[0]);
	      rg[1] < minMax[1][0] && (minMax[1][0] = rg[1]);
	      rg[1] > minMax[1][1] && (minMax[1][1] = rg[1]);
	    }
	
	    return minMax && getBoundingRectFromMinMax(minMax);
	  }
	};
	
	function getBoundingRectFromMinMax(minMax) {
	  return new BoundingRect(minMax[0][0], minMax[1][0], minMax[0][1] - minMax[0][0], minMax[1][1] - minMax[1][0]);
	}
	
	exports.layoutCovers = layoutCovers;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var ATTR = '\0_ec_hist_store';
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} newSnapshot {dataZoomId, batch: [payloadInfo, ...]}
	 */
	
	function push(ecModel, newSnapshot) {
	  var store = giveStore(ecModel); // If previous dataZoom can not be found,
	  // complete an range with current range.
	
	  each(newSnapshot, function (batchItem, dataZoomId) {
	    var i = store.length - 1;
	
	    for (; i >= 0; i--) {
	      var snapshot = store[i];
	
	      if (snapshot[dataZoomId]) {
	        break;
	      }
	    }
	
	    if (i < 0) {
	      // No origin range set, create one by current range.
	      var dataZoomModel = ecModel.queryComponents({
	        mainType: 'dataZoom',
	        subType: 'select',
	        id: dataZoomId
	      })[0];
	
	      if (dataZoomModel) {
	        var percentRange = dataZoomModel.getPercentRange();
	        store[0][dataZoomId] = {
	          dataZoomId: dataZoomId,
	          start: percentRange[0],
	          end: percentRange[1]
	        };
	      }
	    }
	  });
	  store.push(newSnapshot);
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object} snapshot
	 */
	
	
	function pop(ecModel) {
	  var store = giveStore(ecModel);
	  var head = store[store.length - 1];
	  store.length > 1 && store.pop(); // Find top for all dataZoom.
	
	  var snapshot = {};
	  each(head, function (batchItem, dataZoomId) {
	    for (var i = store.length - 1; i >= 0; i--) {
	      var batchItem = store[i][dataZoomId];
	
	      if (batchItem) {
	        snapshot[dataZoomId] = batchItem;
	        break;
	      }
	    }
	  });
	  return snapshot;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 */
	
	
	function clear(ecModel) {
	  ecModel[ATTR] = null;
	}
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @return {number} records. always >= 1.
	 */
	
	
	function count(ecModel) {
	  return giveStore(ecModel).length;
	}
	/**
	 * [{key: dataZoomId, value: {dataZoomId, range}}, ...]
	 * History length of each dataZoom may be different.
	 * this._history[0] is used to store origin range.
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(ecModel) {
	  var store = ecModel[ATTR];
	
	  if (!store) {
	    store = ecModel[ATTR] = [{}];
	  }
	
	  return store;
	}
	
	exports.push = push;
	exports.pop = pop;
	exports.clear = clear;
	exports.count = count;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(504);
	
	__webpack_require__(247);
	
	__webpack_require__(248);
	
	__webpack_require__(2335);
	
	__webpack_require__(2336);
	
	__webpack_require__(502);
	
	__webpack_require__(501);

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(504);
	
	__webpack_require__(247);
	
	__webpack_require__(248);
	
	__webpack_require__(2339);
	
	__webpack_require__(2340);
	
	__webpack_require__(502);
	
	__webpack_require__(501);

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentModel = __webpack_require__(76);
	
	var ComponentView = __webpack_require__(362);
	
	var _sourceHelper = __webpack_require__(160);
	
	var detectSourceFormat = _sourceHelper.detectSourceFormat;
	
	var _sourceType = __webpack_require__(294);
	
	var SERIES_LAYOUT_BY_COLUMN = _sourceType.SERIES_LAYOUT_BY_COLUMN;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * This module is imported by echarts directly.
	 *
	 * Notice:
	 * Always keep this file exists for backward compatibility.
	 * Because before 4.1.0, dataset is an optional component,
	 * some users may import this module manually.
	 */
	ComponentModel.extend({
	  type: 'dataset',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    // 'row', 'column'
	    seriesLayoutBy: SERIES_LAYOUT_BY_COLUMN,
	    // null/'auto': auto detect header, see "module:echarts/data/helper/sourceHelper"
	    sourceHeader: null,
	    dimensions: null,
	    source: null
	  },
	  optionUpdated: function () {
	    detectSourceFormat(this);
	  }
	});
	ComponentView.extend({
	  type: 'dataset'
	});

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var modelUtil = __webpack_require__(29);
	
	var brushHelper = __webpack_require__(845);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var indexOf = zrUtil.indexOf;
	var curry = zrUtil.curry;
	var COORD_CONVERTS = ['dataToPoint', 'pointToData']; // FIXME
	// how to genarialize to more coordinate systems.
	
	var INCLUDE_FINDER_MAIN_TYPES = ['grid', 'xAxis', 'yAxis', 'geo', 'graph', 'polar', 'radiusAxis', 'angleAxis', 'bmap'];
	/**
	 * [option in constructor]:
	 * {
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 * }
	 *
	 *
	 * [targetInfo]:
	 *
	 * There can be multiple axes in a single targetInfo. Consider the case
	 * of `grid` component, a targetInfo represents a grid which contains one or more
	 * cartesian and one or more axes. And consider the case of parallel system,
	 * which has multiple axes in a coordinate system.
	 * Can be {
	 *     panelId: ...,
	 *     coordSys: <a representitive cartesian in grid (first cartesian by default)>,
	 *     coordSyses: all cartesians.
	 *     gridModel: <grid component>
	 *     xAxes: correspond to coordSyses on index
	 *     yAxes: correspond to coordSyses on index
	 * }
	 * or {
	 *     panelId: ...,
	 *     coordSys: <geo coord sys>
	 *     coordSyses: [<geo coord sys>]
	 *     geoModel: <geo component>
	 * }
	 *
	 *
	 * [panelOpt]:
	 *
	 * Make from targetInfo. Input to BrushController.
	 * {
	 *     panelId: ...,
	 *     rect: ...
	 * }
	 *
	 *
	 * [area]:
	 *
	 * Generated by BrushController or user input.
	 * {
	 *     panelId: Used to locate coordInfo directly. If user inpput, no panelId.
	 *     brushType: determine how to convert to/from coord('rect' or 'polygon' or 'lineX/Y').
	 *     Index/Id/Name of geo, xAxis, yAxis, grid: See util/model#parseFinder.
	 *     range: pixel range.
	 *     coordRange: representitive coord range (the first one of coordRanges).
	 *     coordRanges: <Array> coord ranges, used in multiple cartesian in one grid.
	 * }
	 */
	
	/**
	 * @param {Object} option contains Index/Id/Name of xAxis/yAxis/geo/grid
	 *        Each can be {number|Array.<number>}. like: {xAxisIndex: [3, 4]}
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} [opt]
	 * @param {Array.<string>} [opt.include] include coordinate system types.
	 */
	
	function BrushTargetManager(option, ecModel, opt) {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  var targetInfoList = this._targetInfoList = [];
	  var info = {};
	  var foundCpts = parseFinder(ecModel, option);
	  each(targetInfoBuilders, function (builder, type) {
	    if (!opt || !opt.include || indexOf(opt.include, type) >= 0) {
	      builder(foundCpts, targetInfoList, info);
	    }
	  });
	}
	
	var proto = BrushTargetManager.prototype;
	
	proto.setOutputRanges = function (areas, ecModel) {
	  this.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    (area.coordRanges || (area.coordRanges = [])).push(coordRange); // area.coordRange is the first of area.coordRanges
	
	    if (!area.coordRange) {
	      area.coordRange = coordRange; // In 'category' axis, coord to pixel is not reversible, so we can not
	      // rebuild range by coordRange accrately, which may bring trouble when
	      // brushing only one item. So we use __rangeOffset to rebuilding range
	      // by coordRange. And this it only used in brush component so it is no
	      // need to be adapted to coordRanges.
	
	      var result = coordConvert[area.brushType](0, coordSys, coordRange);
	      area.__rangeOffset = {
	        offset: diffProcessor[area.brushType](result.values, area.range, [1, 1]),
	        xyMinMax: result.xyMinMax
	      };
	    }
	  });
	};
	
	proto.matchOutputRanges = function (areas, ecModel, cb) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	
	    if (targetInfo && targetInfo !== true) {
	      zrUtil.each(targetInfo.coordSyses, function (coordSys) {
	        var result = coordConvert[area.brushType](1, coordSys, area.range);
	        cb(area, result.values, coordSys, ecModel);
	      });
	    }
	  }, this);
	};
	
	proto.setInputRanges = function (areas, ecModel) {
	  each(areas, function (area) {
	    var targetInfo = this.findTargetInfo(area, ecModel);
	    area.range = area.range || []; // convert coordRange to global range and set panelId.
	
	    if (targetInfo && targetInfo !== true) {
	      area.panelId = targetInfo.panelId; // (1) area.range shoule always be calculate from coordRange but does
	      // not keep its original value, for the sake of the dataZoom scenario,
	      // where area.coordRange remains unchanged but area.range may be changed.
	      // (2) Only support converting one coordRange to pixel range in brush
	      // component. So do not consider `coordRanges`.
	      // (3) About __rangeOffset, see comment above.
	
	      var result = coordConvert[area.brushType](0, targetInfo.coordSys, area.coordRange);
	      var rangeOffset = area.__rangeOffset;
	      area.range = rangeOffset ? diffProcessor[area.brushType](result.values, rangeOffset.offset, getScales(result.xyMinMax, rangeOffset.xyMinMax)) : result.values;
	    }
	  }, this);
	};
	
	proto.makePanelOpts = function (api, getDefaultBrushType) {
	  return zrUtil.map(this._targetInfoList, function (targetInfo) {
	    var rect = targetInfo.getPanelRect();
	    return {
	      panelId: targetInfo.panelId,
	      defaultBrushType: getDefaultBrushType && getDefaultBrushType(targetInfo),
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, targetInfo.coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect)
	    };
	  });
	};
	
	proto.controlSeries = function (area, seriesModel, ecModel) {
	  // Check whether area is bound in coord, and series do not belong to that coord.
	  // If do not do this check, some brush (like lineX) will controll all axes.
	  var targetInfo = this.findTargetInfo(area, ecModel);
	  return targetInfo === true || targetInfo && indexOf(targetInfo.coordSyses, seriesModel.coordinateSystem) >= 0;
	};
	/**
	 * If return Object, a coord found.
	 * If reutrn true, global found.
	 * Otherwise nothing found.
	 *
	 * @param {Object} area
	 * @param {Array} targetInfoList
	 * @return {Object|boolean}
	 */
	
	
	proto.findTargetInfo = function (area, ecModel) {
	  var targetInfoList = this._targetInfoList;
	  var foundCpts = parseFinder(ecModel, area);
	
	  for (var i = 0; i < targetInfoList.length; i++) {
	    var targetInfo = targetInfoList[i];
	    var areaPanelId = area.panelId;
	
	    if (areaPanelId) {
	      if (targetInfo.panelId === areaPanelId) {
	        return targetInfo;
	      }
	    } else {
	      for (var i = 0; i < targetInfoMatchers.length; i++) {
	        if (targetInfoMatchers[i](foundCpts, targetInfo)) {
	          return targetInfo;
	        }
	      }
	    }
	  }
	
	  return true;
	};
	
	function formatMinMax(minMax) {
	  minMax[0] > minMax[1] && minMax.reverse();
	  return minMax;
	}
	
	function parseFinder(ecModel, option) {
	  return modelUtil.parseFinder(ecModel, option, {
	    includeMainTypes: INCLUDE_FINDER_MAIN_TYPES
	  });
	}
	
	var targetInfoBuilders = {
	  grid: function (foundCpts, targetInfoList) {
	    var xAxisModels = foundCpts.xAxisModels;
	    var yAxisModels = foundCpts.yAxisModels;
	    var gridModels = foundCpts.gridModels; // Remove duplicated.
	
	    var gridModelMap = zrUtil.createHashMap();
	    var xAxesHas = {};
	    var yAxesHas = {};
	
	    if (!xAxisModels && !yAxisModels && !gridModels) {
	      return;
	    }
	
	    each(xAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	    });
	    each(yAxisModels, function (axisModel) {
	      var gridModel = axisModel.axis.grid.model;
	      gridModelMap.set(gridModel.id, gridModel);
	      yAxesHas[gridModel.id] = true;
	    });
	    each(gridModels, function (gridModel) {
	      gridModelMap.set(gridModel.id, gridModel);
	      xAxesHas[gridModel.id] = true;
	      yAxesHas[gridModel.id] = true;
	    });
	    gridModelMap.each(function (gridModel) {
	      var grid = gridModel.coordinateSystem;
	      var cartesians = [];
	      each(grid.getCartesians(), function (cartesian, index) {
	        if (indexOf(xAxisModels, cartesian.getAxis('x').model) >= 0 || indexOf(yAxisModels, cartesian.getAxis('y').model) >= 0) {
	          cartesians.push(cartesian);
	        }
	      });
	      targetInfoList.push({
	        panelId: 'grid--' + gridModel.id,
	        gridModel: gridModel,
	        coordSysModel: gridModel,
	        // Use the first one as the representitive coordSys.
	        coordSys: cartesians[0],
	        coordSyses: cartesians,
	        getPanelRect: panelRectBuilder.grid,
	        xAxisDeclared: xAxesHas[gridModel.id],
	        yAxisDeclared: yAxesHas[gridModel.id]
	      });
	    });
	  },
	  geo: function (foundCpts, targetInfoList) {
	    each(foundCpts.geoModels, function (geoModel) {
	      var coordSys = geoModel.coordinateSystem;
	      targetInfoList.push({
	        panelId: 'geo--' + geoModel.id,
	        geoModel: geoModel,
	        coordSysModel: geoModel,
	        coordSys: coordSys,
	        coordSyses: [coordSys],
	        getPanelRect: panelRectBuilder.geo
	      });
	    });
	  }
	};
	var targetInfoMatchers = [// grid
	function (foundCpts, targetInfo) {
	  var xAxisModel = foundCpts.xAxisModel;
	  var yAxisModel = foundCpts.yAxisModel;
	  var gridModel = foundCpts.gridModel;
	  !gridModel && xAxisModel && (gridModel = xAxisModel.axis.grid.model);
	  !gridModel && yAxisModel && (gridModel = yAxisModel.axis.grid.model);
	  return gridModel && gridModel === targetInfo.gridModel;
	}, // geo
	function (foundCpts, targetInfo) {
	  var geoModel = foundCpts.geoModel;
	  return geoModel && geoModel === targetInfo.geoModel;
	}];
	var panelRectBuilder = {
	  grid: function () {
	    // grid is not Transformable.
	    return this.coordSys.grid.getRect().clone();
	  },
	  geo: function () {
	    var coordSys = this.coordSys;
	    var rect = coordSys.getBoundingRect().clone(); // geo roam and zoom transform
	
	    rect.applyTransform(graphic.getTransform(coordSys));
	    return rect;
	  }
	};
	var coordConvert = {
	  lineX: curry(axisConvert, 0),
	  lineY: curry(axisConvert, 1),
	  rect: function (to, coordSys, rangeOrCoordRange) {
	    var xminymin = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][0], rangeOrCoordRange[1][0]]);
	    var xmaxymax = coordSys[COORD_CONVERTS[to]]([rangeOrCoordRange[0][1], rangeOrCoordRange[1][1]]);
	    var values = [formatMinMax([xminymin[0], xmaxymax[0]]), formatMinMax([xminymin[1], xmaxymax[1]])];
	    return {
	      values: values,
	      xyMinMax: values
	    };
	  },
	  polygon: function (to, coordSys, rangeOrCoordRange) {
	    var xyMinMax = [[Infinity, -Infinity], [Infinity, -Infinity]];
	    var values = zrUtil.map(rangeOrCoordRange, function (item) {
	      var p = coordSys[COORD_CONVERTS[to]](item);
	      xyMinMax[0][0] = Math.min(xyMinMax[0][0], p[0]);
	      xyMinMax[1][0] = Math.min(xyMinMax[1][0], p[1]);
	      xyMinMax[0][1] = Math.max(xyMinMax[0][1], p[0]);
	      xyMinMax[1][1] = Math.max(xyMinMax[1][1], p[1]);
	      return p;
	    });
	    return {
	      values: values,
	      xyMinMax: xyMinMax
	    };
	  }
	};
	
	function axisConvert(axisNameIndex, to, coordSys, rangeOrCoordRange) {
	  var axis = coordSys.getAxis(['x', 'y'][axisNameIndex]);
	  var values = formatMinMax(zrUtil.map([0, 1], function (i) {
	    return to ? axis.coordToData(axis.toLocalCoord(rangeOrCoordRange[i])) : axis.toGlobalCoord(axis.dataToCoord(rangeOrCoordRange[i]));
	  }));
	  var xyMinMax = [];
	  xyMinMax[axisNameIndex] = values;
	  xyMinMax[1 - axisNameIndex] = [NaN, NaN];
	  return {
	    values: values,
	    xyMinMax: xyMinMax
	  };
	}
	
	var diffProcessor = {
	  lineX: curry(axisDiffProcessor, 0),
	  lineY: curry(axisDiffProcessor, 1),
	  rect: function (values, refer, scales) {
	    return [[values[0][0] - scales[0] * refer[0][0], values[0][1] - scales[0] * refer[0][1]], [values[1][0] - scales[1] * refer[1][0], values[1][1] - scales[1] * refer[1][1]]];
	  },
	  polygon: function (values, refer, scales) {
	    return zrUtil.map(values, function (item, idx) {
	      return [item[0] - scales[0] * refer[idx][0], item[1] - scales[1] * refer[idx][1]];
	    });
	  }
	};
	
	function axisDiffProcessor(axisNameIndex, values, refer, scales) {
	  return [values[0] - scales[axisNameIndex] * refer[0], values[1] - scales[axisNameIndex] * refer[1]];
	} // We have to process scale caused by dataZoom manually,
	// although it might be not accurate.
	
	
	function getScales(xyMinMaxCurr, xyMinMaxOrigin) {
	  var sizeCurr = getSize(xyMinMaxCurr);
	  var sizeOrigin = getSize(xyMinMaxOrigin);
	  var scales = [sizeCurr[0] / sizeOrigin[0], sizeCurr[1] / sizeOrigin[1]];
	  isNaN(scales[0]) && (scales[0] = 1);
	  isNaN(scales[1]) && (scales[1] = 1);
	  return scales;
	}
	
	function getSize(xyMinMax) {
	  return xyMinMax ? [xyMinMax[0][1] - xyMinMax[0][0], xyMinMax[1][1] - xyMinMax[1][0]] : [NaN, NaN];
	}
	
	var _default = BrushTargetManager;
	module.exports = _default;

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var RoamController = __webpack_require__(291);
	
	var roamHelper = __webpack_require__(506);
	
	var _cursorHelper = __webpack_require__(356);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(14);
	
	var geoSourceManager = __webpack_require__(358);
	
	var _component = __webpack_require__(297);
	
	var getUID = _component.getUID;
	
	var Transformable = __webpack_require__(396);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getFixedItemStyle(model) {
	  var itemStyle = model.getItemStyle();
	  var areaColor = model.get('areaColor'); // If user want the color not to be changed when hover,
	  // they should both set areaColor and color to be null.
	
	  if (areaColor != null) {
	    itemStyle.fill = areaColor;
	  }
	
	  return itemStyle;
	}
	
	function updateMapSelectHandler(mapDraw, mapOrGeoModel, regionsGroup, api, fromView) {
	  regionsGroup.off('click');
	  regionsGroup.off('mousedown');
	
	  if (mapOrGeoModel.get('selectedMode')) {
	    regionsGroup.on('mousedown', function () {
	      mapDraw._mouseDownFlag = true;
	    });
	    regionsGroup.on('click', function (e) {
	      if (!mapDraw._mouseDownFlag) {
	        return;
	      }
	
	      mapDraw._mouseDownFlag = false;
	      var el = e.target;
	
	      while (!el.__regions) {
	        el = el.parent;
	      }
	
	      if (!el) {
	        return;
	      }
	
	      var action = {
	        type: (mapOrGeoModel.mainType === 'geo' ? 'geo' : 'map') + 'ToggleSelect',
	        batch: zrUtil.map(el.__regions, function (region) {
	          return {
	            name: region.name,
	            from: fromView.uid
	          };
	        })
	      };
	      action[mapOrGeoModel.mainType + 'Id'] = mapOrGeoModel.id;
	      api.dispatchAction(action);
	      updateMapSelected(mapOrGeoModel, regionsGroup);
	    });
	  }
	}
	
	function updateMapSelected(mapOrGeoModel, regionsGroup) {
	  // FIXME
	  regionsGroup.eachChild(function (otherRegionEl) {
	    zrUtil.each(otherRegionEl.__regions, function (region) {
	      otherRegionEl.trigger(mapOrGeoModel.isSelected(region.name) ? 'emphasis' : 'normal');
	    });
	  });
	}
	/**
	 * @alias module:echarts/component/helper/MapDraw
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {boolean} updateGroup
	 */
	
	
	function MapDraw(api, updateGroup) {
	  var group = new graphic.Group();
	  /**
	   * @type {string}
	   * @private
	   */
	
	  this.uid = getUID('ec_map_draw');
	  /**
	   * @type {module:echarts/component/helper/RoamController}
	   * @private
	   */
	
	  this._controller = new RoamController(api.getZr());
	  /**
	   * @type {Object} {target, zoom, zoomLimit}
	   * @private
	   */
	
	  this._controllerHost = {
	    target: updateGroup ? group : null
	  };
	  /**
	   * @type {module:zrender/container/Group}
	   * @readOnly
	   */
	
	  this.group = group;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._updateGroup = updateGroup;
	  /**
	   * This flag is used to make sure that only one among
	   * `pan`, `zoom`, `click` can occurs, otherwise 'selected'
	   * action may be triggered when `pan`, which is unexpected.
	   * @type {booelan}
	   */
	
	  this._mouseDownFlag;
	  /**
	   * @type {string}
	   */
	
	  this._mapName;
	  /**
	   * @type {boolean}
	   */
	
	  this._initialized;
	  /**
	   * @type {module:zrender/container/Group}
	   */
	
	  group.add(this._regionsGroup = new graphic.Group());
	  /**
	   * @type {module:zrender/container/Group}
	   */
	
	  group.add(this._backgroundGroup = new graphic.Group());
	}
	
	MapDraw.prototype = {
	  constructor: MapDraw,
	  draw: function (mapOrGeoModel, ecModel, api, fromView, payload) {
	    var isGeo = mapOrGeoModel.mainType === 'geo'; // Map series has data. GEO model that controlled by map series
	    // will be assigned with map data. Other GEO model has no data.
	
	    var data = mapOrGeoModel.getData && mapOrGeoModel.getData();
	    isGeo && ecModel.eachComponent({
	      mainType: 'series',
	      subType: 'map'
	    }, function (mapSeries) {
	      if (!data && mapSeries.getHostGeoModel() === mapOrGeoModel) {
	        data = mapSeries.getData();
	      }
	    });
	    var geo = mapOrGeoModel.coordinateSystem;
	
	    this._updateBackground(geo);
	
	    var regionsGroup = this._regionsGroup;
	    var group = this.group;
	    var transformInfo = geo.getTransformInfo(); // No animation when first draw or in action
	
	    var isFirstDraw = !regionsGroup.childAt(0) || payload;
	    var targetScale;
	
	    if (isFirstDraw) {
	      group.transform = transformInfo.roamTransform;
	      group.decomposeTransform();
	      group.dirty();
	    } else {
	      var target = new Transformable();
	      target.transform = transformInfo.roamTransform;
	      target.decomposeTransform();
	      var props = {
	        scale: target.scale,
	        position: target.position
	      };
	      targetScale = target.scale;
	      graphic.updateProps(group, props, mapOrGeoModel);
	    }
	
	    var scale = transformInfo.rawScale;
	    var position = transformInfo.rawPosition;
	    regionsGroup.removeAll();
	    var itemStyleAccessPath = ['itemStyle'];
	    var hoverItemStyleAccessPath = ['emphasis', 'itemStyle'];
	    var labelAccessPath = ['label'];
	    var hoverLabelAccessPath = ['emphasis', 'label'];
	    var nameMap = zrUtil.createHashMap();
	    zrUtil.each(geo.regions, function (region) {
	      // Consider in GeoJson properties.name may be duplicated, for example,
	      // there is multiple region named "United Kindom" or "France" (so many
	      // colonies). And it is not appropriate to merge them in geo, which
	      // will make them share the same label and bring trouble in label
	      // location calculation.
	      var regionGroup = nameMap.get(region.name) || nameMap.set(region.name, new graphic.Group());
	      var compoundPath = new graphic.CompoundPath({
	        segmentIgnoreThreshold: 1,
	        shape: {
	          paths: []
	        }
	      });
	      regionGroup.add(compoundPath);
	      var regionModel = mapOrGeoModel.getRegionModel(region.name) || mapOrGeoModel;
	      var itemStyleModel = regionModel.getModel(itemStyleAccessPath);
	      var hoverItemStyleModel = regionModel.getModel(hoverItemStyleAccessPath);
	      var itemStyle = getFixedItemStyle(itemStyleModel);
	      var hoverItemStyle = getFixedItemStyle(hoverItemStyleModel);
	      var labelModel = regionModel.getModel(labelAccessPath);
	      var hoverLabelModel = regionModel.getModel(hoverLabelAccessPath);
	      var dataIdx; // Use the itemStyle in data if has data
	
	      if (data) {
	        dataIdx = data.indexOfName(region.name); // Only visual color of each item will be used. It can be encoded by dataRange
	        // But visual color of series is used in symbol drawing
	        //
	        // Visual color for each series is for the symbol draw
	
	        var visualColor = data.getItemVisual(dataIdx, 'color', true);
	
	        if (visualColor) {
	          itemStyle.fill = visualColor;
	        }
	      }
	
	      var transformPoint = function (point) {
	        return [point[0] * scale[0] + position[0], point[1] * scale[1] + position[1]];
	      };
	
	      zrUtil.each(region.geometries, function (geometry) {
	        if (geometry.type !== 'polygon') {
	          return;
	        }
	
	        var points = [];
	
	        for (var i = 0; i < geometry.exterior.length; ++i) {
	          points.push(transformPoint(geometry.exterior[i]));
	        }
	
	        compoundPath.shape.paths.push(new graphic.Polygon({
	          segmentIgnoreThreshold: 1,
	          shape: {
	            points: points
	          }
	        }));
	
	        for (var i = 0; i < (geometry.interiors ? geometry.interiors.length : 0); ++i) {
	          var interior = geometry.interiors[i];
	          var points = [];
	
	          for (var j = 0; j < interior.length; ++j) {
	            points.push(transformPoint(interior[j]));
	          }
	
	          compoundPath.shape.paths.push(new graphic.Polygon({
	            segmentIgnoreThreshold: 1,
	            shape: {
	              points: points
	            }
	          }));
	        }
	      });
	      compoundPath.setStyle(itemStyle);
	      compoundPath.style.strokeNoScale = true;
	      compoundPath.culling = true; // Label
	
	      var showLabel = labelModel.get('show');
	      var hoverShowLabel = hoverLabelModel.get('show');
	      var isDataNaN = data && isNaN(data.get(data.mapDimension('value'), dataIdx));
	      var itemLayout = data && data.getItemLayout(dataIdx); // In the following cases label will be drawn
	      // 1. In map series and data value is NaN
	      // 2. In geo component
	      // 4. Region has no series legendSymbol, which will be add a showLabel flag in mapSymbolLayout
	
	      if (isGeo || isDataNaN && (showLabel || hoverShowLabel) || itemLayout && itemLayout.showLabel) {
	        var query = !isGeo ? dataIdx : region.name;
	        var labelFetcher; // Consider dataIdx not found.
	
	        if (!data || dataIdx >= 0) {
	          labelFetcher = mapOrGeoModel;
	        }
	
	        var textEl = new graphic.Text({
	          position: transformPoint(region.center.slice()),
	          // FIXME
	          // label rotation is not support yet in geo or regions of series-map
	          // that has no data. The rotation will be effected by this `scale`.
	          // So needed to change to RectText?
	          scale: [1 / group.scale[0], 1 / group.scale[1]],
	          z2: 10,
	          silent: true
	        });
	        graphic.setLabelStyle(textEl.style, textEl.hoverStyle = {}, labelModel, hoverLabelModel, {
	          labelFetcher: labelFetcher,
	          labelDataIndex: query,
	          defaultText: region.name,
	          useInsideStyle: false
	        }, {
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        });
	
	        if (!isFirstDraw) {
	          // Text animation
	          var textScale = [1 / targetScale[0], 1 / targetScale[1]];
	          graphic.updateProps(textEl, {
	            scale: textScale
	          }, mapOrGeoModel);
	        }
	
	        regionGroup.add(textEl);
	      } // setItemGraphicEl, setHoverStyle after all polygons and labels
	      // are added to the rigionGroup
	
	
	      if (data) {
	        data.setItemGraphicEl(dataIdx, regionGroup);
	      } else {
	        var regionModel = mapOrGeoModel.getRegionModel(region.name); // Package custom mouse event for geo component
	
	        compoundPath.eventData = {
	          componentType: 'geo',
	          componentIndex: mapOrGeoModel.componentIndex,
	          geoIndex: mapOrGeoModel.componentIndex,
	          name: region.name,
	          region: regionModel && regionModel.option || {}
	        };
	      }
	
	      var groupRegions = regionGroup.__regions || (regionGroup.__regions = []);
	      groupRegions.push(region);
	      regionGroup.highDownSilentOnTouch = !!mapOrGeoModel.get('selectedMode');
	      graphic.setHoverStyle(regionGroup, hoverItemStyle);
	      regionsGroup.add(regionGroup);
	    });
	
	    this._updateController(mapOrGeoModel, ecModel, api);
	
	    updateMapSelectHandler(this, mapOrGeoModel, regionsGroup, api, fromView);
	    updateMapSelected(mapOrGeoModel, regionsGroup);
	  },
	  remove: function () {
	    this._regionsGroup.removeAll();
	
	    this._backgroundGroup.removeAll();
	
	    this._controller.dispose();
	
	    this._mapName && geoSourceManager.removeGraphic(this._mapName, this.uid);
	    this._mapName = null;
	    this._controllerHost = {};
	  },
	  _updateBackground: function (geo) {
	    var mapName = geo.map;
	
	    if (this._mapName !== mapName) {
	      zrUtil.each(geoSourceManager.makeGraphic(mapName, this.uid), function (root) {
	        this._backgroundGroup.add(root);
	      }, this);
	    }
	
	    this._mapName = mapName;
	  },
	  _updateController: function (mapOrGeoModel, ecModel, api) {
	    var geo = mapOrGeoModel.coordinateSystem;
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    controllerHost.zoomLimit = mapOrGeoModel.get('scaleLimit');
	    controllerHost.zoom = geo.getZoom(); // roamType is will be set default true if it is null
	
	    controller.enable(mapOrGeoModel.get('roam') || false);
	    var mainType = mapOrGeoModel.mainType;
	
	    function makeActionBase() {
	      var action = {
	        type: 'geoRoam',
	        componentType: mainType
	      };
	      action[mainType + 'Id'] = mapOrGeoModel.id;
	      return action;
	    }
	
	    controller.off('pan').on('pan', function (e) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        dx: e.dx,
	        dy: e.dy
	      }));
	    }, this);
	    controller.off('zoom').on('zoom', function (e) {
	      this._mouseDownFlag = false;
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction(zrUtil.extend(makeActionBase(), {
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      }));
	
	      if (this._updateGroup) {
	        var scale = this.group.scale;
	
	        this._regionsGroup.traverse(function (el) {
	          if (el.type === 'text') {
	            el.attr('scale', [1 / scale[0], 1 / scale[1]]);
	          }
	        });
	      }
	    }, this);
	    controller.setPointerChecker(function (e, x, y) {
	      return geo.getViewRectAfterRoam().contain(x, y) && !onIrrelevantElement(e, api, mapOrGeoModel);
	    });
	  }
	};
	var _default = MapDraw;
	module.exports = _default;

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BoundingRect = __webpack_require__(60);
	
	var _cursorHelper = __webpack_require__(356);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphicUtil = __webpack_require__(14);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function makeRectPanelClipPath(rect) {
	  rect = normalizeRect(rect);
	  return function (localPoints, transform) {
	    return graphicUtil.clipPointsByRect(localPoints, rect);
	  };
	}
	
	function makeLinearBrushOtherExtent(rect, specifiedXYIndex) {
	  rect = normalizeRect(rect);
	  return function (xyIndex) {
	    var idx = specifiedXYIndex != null ? specifiedXYIndex : xyIndex;
	    var brushWidth = idx ? rect.width : rect.height;
	    var base = idx ? rect.x : rect.y;
	    return [base, base + (brushWidth || 0)];
	  };
	}
	
	function makeRectIsTargetByCursor(rect, api, targetModel) {
	  rect = normalizeRect(rect);
	  return function (e, localCursorPoint, transform) {
	    return rect.contain(localCursorPoint[0], localCursorPoint[1]) && !onIrrelevantElement(e, api, targetModel);
	  };
	} // Consider width/height is negative.
	
	
	function normalizeRect(rect) {
	  return BoundingRect.create(rect);
	}
	
	exports.makeRectPanelClipPath = makeRectPanelClipPath;
	exports.makeLinearBrushOtherExtent = makeLinearBrushOtherExtent;
	exports.makeRectIsTargetByCursor = makeRectIsTargetByCursor;

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ATTR = '\0_ec_interaction_mutex';
	
	function take(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  store[resourceKey] = userKey;
	}
	
	function release(zr, resourceKey, userKey) {
	  var store = getStore(zr);
	  var uKey = store[resourceKey];
	
	  if (uKey === userKey) {
	    store[resourceKey] = null;
	  }
	}
	
	function isTaken(zr, resourceKey) {
	  return !!getStore(zr)[resourceKey];
	}
	
	function getStore(zr) {
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	/**
	 * payload: {
	 *     type: 'takeGlobalCursor',
	 *     key: 'dataZoomSelect', or 'brush', or ...,
	 *         If no userKey, release global cursor.
	 * }
	 */
	
	
	echarts.registerAction({
	  type: 'takeGlobalCursor',
	  event: 'globalCursorTaken',
	  update: 'update'
	}, function () {});
	exports.take = take;
	exports.release = release;
	exports.isTaken = isTaken;

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _layout = __webpack_require__(46);
	
	var getLayoutRect = _layout.getLayoutRect;
	var layoutBox = _layout.box;
	var positionElement = _layout.positionElement;
	
	var formatUtil = __webpack_require__(48);
	
	var graphic = __webpack_require__(14);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Layout list like component.
	 * It will box layout each items in group of component and then position the whole group in the viewport
	 * @param {module:zrender/group/Group} group
	 * @param {module:echarts/model/Component} componentModel
	 * @param {module:echarts/ExtensionAPI}
	 */
	function layout(group, componentModel, api) {
	  var boxLayoutParams = componentModel.getBoxLayoutParams();
	  var padding = componentModel.get('padding');
	  var viewportSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var rect = getLayoutRect(boxLayoutParams, viewportSize, padding);
	  layoutBox(componentModel.get('orient'), group, componentModel.get('itemGap'), rect.width, rect.height);
	  positionElement(group, boxLayoutParams, viewportSize, padding);
	}
	
	function makeBackground(rect, componentModel) {
	  var padding = formatUtil.normalizeCssArray(componentModel.get('padding'));
	  var style = componentModel.getItemStyle(['color', 'opacity']);
	  style.fill = componentModel.get('backgroundColor');
	  var rect = new graphic.Rect({
	    shape: {
	      x: rect.x - padding[3],
	      y: rect.y - padding[0],
	      width: rect.width + padding[1] + padding[3],
	      height: rect.height + padding[0] + padding[2],
	      r: componentModel.get('borderRadius')
	    },
	    style: style,
	    silent: true,
	    z2: -1
	  }); // FIXME
	  // `subPixelOptimizeRect` may bring some gap between edge of viewpart
	  // and background rect when setting like `left: 0`, `top: 0`.
	  // graphic.subPixelOptimizeRect(rect);
	
	  return rect;
	}
	
	exports.layout = layout;
	exports.makeBackground = makeBackground;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(849);
	
	__webpack_require__(2349);
	
	__webpack_require__(850);
	
	var legendFilter = __webpack_require__(2350);
	
	var Component = __webpack_require__(76);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Do not contain scrollable legend, for sake of file size.
	// Series Filter
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.SERIES_FILTER, legendFilter);
	Component.registerSubTypeDefaulter('legend', function () {
	  // Default 'plain' when no type specified.
	  return 'plain';
	});

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var Model = __webpack_require__(70);
	
	var _model = __webpack_require__(29);
	
	var isNameSpecified = _model.isNameSpecified;
	
	var lang = __webpack_require__(180);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var langSelector = lang.legend.selector;
	var defaultSelectorOption = {
	  all: {
	    type: 'all',
	    title: zrUtil.clone(langSelector.all)
	  },
	  inverse: {
	    type: 'inverse',
	    title: zrUtil.clone(langSelector.inverse)
	  }
	};
	var LegendModel = echarts.extendComponentModel({
	  type: 'legend.plain',
	  dependencies: ['series'],
	  layoutMode: {
	    type: 'box',
	    // legend.width/height are maxWidth/maxHeight actually,
	    // whereas realy width/height is calculated by its content.
	    // (Setting {left: 10, right: 10} does not make sense).
	    // So consider the case:
	    // `setOption({legend: {left: 10});`
	    // then `setOption({legend: {right: 10});`
	    // The previous `left` should be cleared by setting `ignoreSize`.
	    ignoreSize: true
	  },
	  init: function (option, parentModel, ecModel) {
	    this.mergeDefaultAndTheme(option, ecModel);
	    option.selected = option.selected || {};
	
	    this._updateSelector(option);
	  },
	  mergeOption: function (option) {
	    LegendModel.superCall(this, 'mergeOption', option);
	
	    this._updateSelector(option);
	  },
	  _updateSelector: function (option) {
	    var selector = option.selector;
	
	    if (selector === true) {
	      selector = option.selector = ['all', 'inverse'];
	    }
	
	    if (zrUtil.isArray(selector)) {
	      zrUtil.each(selector, function (item, index) {
	        zrUtil.isString(item) && (item = {
	          type: item
	        });
	        selector[index] = zrUtil.merge(item, defaultSelectorOption[item.type]);
	      });
	    }
	  },
	  optionUpdated: function () {
	    this._updateData(this.ecModel);
	
	    var legendData = this._data; // If selectedMode is single, try to select one
	
	    if (legendData[0] && this.get('selectedMode') === 'single') {
	      var hasSelected = false; // If has any selected in option.selected
	
	      for (var i = 0; i < legendData.length; i++) {
	        var name = legendData[i].get('name');
	
	        if (this.isSelected(name)) {
	          // Force to unselect others
	          this.select(name);
	          hasSelected = true;
	          break;
	        }
	      } // Try select the first if selectedMode is single
	
	
	      !hasSelected && this.select(legendData[0].get('name'));
	    }
	  },
	  _updateData: function (ecModel) {
	    var potentialData = [];
	    var availableNames = [];
	    ecModel.eachRawSeries(function (seriesModel) {
	      var seriesName = seriesModel.name;
	      availableNames.push(seriesName);
	      var isPotential;
	
	      if (seriesModel.legendVisualProvider) {
	        var provider = seriesModel.legendVisualProvider;
	        var names = provider.getAllNames();
	
	        if (!ecModel.isSeriesFiltered(seriesModel)) {
	          availableNames = availableNames.concat(names);
	        }
	
	        if (names.length) {
	          potentialData = potentialData.concat(names);
	        } else {
	          isPotential = true;
	        }
	      } else {
	        isPotential = true;
	      }
	
	      if (isPotential && isNameSpecified(seriesModel)) {
	        potentialData.push(seriesModel.name);
	      }
	    });
	    /**
	     * @type {Array.<string>}
	     * @private
	     */
	
	    this._availableNames = availableNames; // If legend.data not specified in option, use availableNames as data,
	    // which is convinient for user preparing option.
	
	    var rawData = this.get('data') || potentialData;
	    var legendData = zrUtil.map(rawData, function (dataItem) {
	      // Can be string or number
	      if (typeof dataItem === 'string' || typeof dataItem === 'number') {
	        dataItem = {
	          name: dataItem
	        };
	      }
	
	      return new Model(dataItem, this, this.ecModel);
	    }, this);
	    /**
	     * @type {Array.<module:echarts/model/Model>}
	     * @private
	     */
	
	    this._data = legendData;
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Model>}
	   */
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @param {string} name
	   */
	  select: function (name) {
	    var selected = this.option.selected;
	    var selectedMode = this.get('selectedMode');
	
	    if (selectedMode === 'single') {
	      var data = this._data;
	      zrUtil.each(data, function (dataItem) {
	        selected[dataItem.get('name')] = false;
	      });
	    }
	
	    selected[name] = true;
	  },
	
	  /**
	   * @param {string} name
	   */
	  unSelect: function (name) {
	    if (this.get('selectedMode') !== 'single') {
	      this.option.selected[name] = false;
	    }
	  },
	
	  /**
	   * @param {string} name
	   */
	  toggleSelected: function (name) {
	    var selected = this.option.selected; // Default is true
	
	    if (!selected.hasOwnProperty(name)) {
	      selected[name] = true;
	    }
	
	    this[selected[name] ? 'unSelect' : 'select'](name);
	  },
	  allSelect: function () {
	    var data = this._data;
	    var selected = this.option.selected;
	    zrUtil.each(data, function (dataItem) {
	      selected[dataItem.get('name', true)] = true;
	    });
	  },
	  inverseSelect: function () {
	    var data = this._data;
	    var selected = this.option.selected;
	    zrUtil.each(data, function (dataItem) {
	      var name = dataItem.get('name', true); // Initially, default value is true
	
	      if (!selected.hasOwnProperty(name)) {
	        selected[name] = true;
	      }
	
	      selected[name] = !selected[name];
	    });
	  },
	
	  /**
	   * @param {string} name
	   */
	  isSelected: function (name) {
	    var selected = this.option.selected;
	    return !(selected.hasOwnProperty(name) && !selected[name]) && zrUtil.indexOf(this._availableNames, name) >= 0;
	  },
	  getOrient: function () {
	    return this.get('orient') === 'vertical' ? {
	      index: 1,
	      name: 'vertical'
	    } : {
	      index: 0,
	      name: 'horizontal'
	    };
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 4,
	    show: true,
	    // 布局方式，默认为水平布局，可选为：
	    // 'horizontal' | 'vertical'
	    orient: 'horizontal',
	    left: 'center',
	    // right: 'center',
	    top: 0,
	    // bottom: null,
	    // 水平对齐
	    // 'auto' | 'left' | 'right'
	    // 默认为 'auto', 根据 x 的位置判断是左对齐还是右对齐
	    align: 'auto',
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 图例边框颜色
	    borderColor: '#ccc',
	    borderRadius: 0,
	    // 图例边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 图例内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 各个item之间的间隔，单位px，默认为10，
	    // 横向布局时为水平间隔，纵向布局时为纵向间隔
	    itemGap: 10,
	    // the width of legend symbol
	    itemWidth: 25,
	    // the height of legend symbol
	    itemHeight: 14,
	    // the color of unselected legend symbol
	    inactiveColor: '#ccc',
	    // the borderColor of unselected legend symbol
	    inactiveBorderColor: '#ccc',
	    itemStyle: {
	      // the default borderWidth of legend symbol
	      borderWidth: 0
	    },
	    textStyle: {
	      // 图例文字颜色
	      color: '#333'
	    },
	    // formatter: '',
	    // 选择模式，默认开启图例开关
	    selectedMode: true,
	    // 配置默认选中状态，可配合LEGEND.SELECTED事件做动态数据载入
	    // selected: null,
	    // 图例内容（详见legend.data，数组中每一项代表一个item
	    // data: [],
	    // Usage:
	    // selector: [{type: 'all or inverse', title: xxx}]
	    // or
	    // selector: true
	    // or
	    // selector: ['all', 'inverse']
	    selector: false,
	    selectorLabel: {
	      show: true,
	      borderRadius: 10,
	      padding: [3, 5, 3, 5],
	      fontSize: 12,
	      fontFamily: ' sans-serif',
	      color: '#666',
	      borderWidth: 1,
	      borderColor: '#666'
	    },
	    emphasis: {
	      selectorLabel: {
	        show: true,
	        color: '#eee',
	        backgroundColor: '#666'
	      }
	    },
	    // Value can be 'start' or 'end'
	    selectorPosition: 'auto',
	    selectorItemGap: 7,
	    selectorButtonGap: 10,
	    // Tooltip 相关配置
	    tooltip: {
	      show: false
	    }
	  }
	});
	var _default = LegendModel;
	module.exports = _default;

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var _symbol = __webpack_require__(110);
	
	var createSymbol = _symbol.createSymbol;
	
	var graphic = __webpack_require__(14);
	
	var _listComponent = __webpack_require__(847);
	
	var makeBackground = _listComponent.makeBackground;
	
	var layoutUtil = __webpack_require__(46);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var curry = zrUtil.curry;
	var each = zrUtil.each;
	var Group = graphic.Group;
	
	var _default = echarts.extendComponentView({
	  type: 'legend.plain',
	  newlineDisabled: false,
	
	  /**
	   * @override
	   */
	  init: function () {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this.group.add(this._contentGroup = new Group());
	    /**
	     * @private
	     * @type {module:zrender/Element}
	     */
	
	    this._backgroundEl;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this.group.add(this._selectorGroup = new Group());
	    /**
	     * If first rendering, `contentGroup.position` is [0, 0], which
	     * does not make sense and may cause unexepcted animation if adopted.
	     * @private
	     * @type {boolean}
	     */
	
	    this._isFirstRender = true;
	  },
	
	  /**
	   * @protected
	   */
	  getContentGroup: function () {
	    return this._contentGroup;
	  },
	
	  /**
	   * @protected
	   */
	  getSelectorGroup: function () {
	    return this._selectorGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (legendModel, ecModel, api) {
	    var isFirstRender = this._isFirstRender;
	    this._isFirstRender = false;
	    this.resetInner();
	
	    if (!legendModel.get('show', true)) {
	      return;
	    }
	
	    var itemAlign = legendModel.get('align');
	    var orient = legendModel.get('orient');
	
	    if (!itemAlign || itemAlign === 'auto') {
	      itemAlign = legendModel.get('left') === 'right' && orient === 'vertical' ? 'right' : 'left';
	    }
	
	    var selector = legendModel.get('selector', true);
	    var selectorPosition = legendModel.get('selectorPosition', true);
	
	    if (selector && (!selectorPosition || selectorPosition === 'auto')) {
	      selectorPosition = orient === 'horizontal' ? 'end' : 'start';
	    }
	
	    this.renderInner(itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition); // Perform layout.
	
	    var positionInfo = legendModel.getBoxLayoutParams();
	    var viewportSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var padding = legendModel.get('padding');
	    var maxSize = layoutUtil.getLayoutRect(positionInfo, viewportSize, padding);
	    var mainRect = this.layoutInner(legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition); // Place mainGroup, based on the calculated `mainRect`.
	
	    var layoutRect = layoutUtil.getLayoutRect(zrUtil.defaults({
	      width: mainRect.width,
	      height: mainRect.height
	    }, positionInfo), viewportSize, padding);
	    this.group.attr('position', [layoutRect.x - mainRect.x, layoutRect.y - mainRect.y]); // Render background after group is layout.
	
	    this.group.add(this._backgroundEl = makeBackground(mainRect, legendModel));
	  },
	
	  /**
	   * @protected
	   */
	  resetInner: function () {
	    this.getContentGroup().removeAll();
	    this._backgroundEl && this.group.remove(this._backgroundEl);
	    this.getSelectorGroup().removeAll();
	  },
	
	  /**
	   * @protected
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
	    var contentGroup = this.getContentGroup();
	    var legendDrawnMap = zrUtil.createHashMap();
	    var selectMode = legendModel.get('selectedMode');
	    var excludeSeriesId = [];
	    ecModel.eachRawSeries(function (seriesModel) {
	      !seriesModel.get('legendHoverLink') && excludeSeriesId.push(seriesModel.id);
	    });
	    each(legendModel.getData(), function (itemModel, dataIndex) {
	      var name = itemModel.get('name'); // Use empty string or \n as a newline string
	
	      if (!this.newlineDisabled && (name === '' || name === '\n')) {
	        contentGroup.add(new Group({
	          newline: true
	        }));
	        return;
	      } // Representitive series.
	
	
	      var seriesModel = ecModel.getSeriesByName(name)[0];
	
	      if (legendDrawnMap.get(name)) {
	        // Have been drawed
	        return;
	      } // Legend to control series.
	
	
	      if (seriesModel) {
	        var data = seriesModel.getData();
	        var color = data.getVisual('color');
	        var borderColor = data.getVisual('borderColor'); // If color is a callback function
	
	        if (typeof color === 'function') {
	          // Use the first data
	          color = color(seriesModel.getDataParams(0));
	        } // If borderColor is a callback function
	
	
	        if (typeof borderColor === 'function') {
	          // Use the first data
	          borderColor = borderColor(seriesModel.getDataParams(0));
	        } // Using rect symbol defaultly
	
	
	        var legendSymbolType = data.getVisual('legendSymbol') || 'roundRect';
	        var symbolType = data.getVisual('symbol');
	
	        var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode);
	
	        itemGroup.on('click', curry(dispatchSelectAction, name, null, api, excludeSeriesId)).on('mouseover', curry(dispatchHighlightAction, seriesModel.name, null, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, seriesModel.name, null, api, excludeSeriesId));
	        legendDrawnMap.set(name, true);
	      } else {
	        // Legend to control data. In pie and funnel.
	        ecModel.eachRawSeries(function (seriesModel) {
	          // In case multiple series has same data name
	          if (legendDrawnMap.get(name)) {
	            return;
	          }
	
	          if (seriesModel.legendVisualProvider) {
	            var provider = seriesModel.legendVisualProvider;
	
	            if (!provider.containName(name)) {
	              return;
	            }
	
	            var idx = provider.indexOfName(name);
	            var color = provider.getItemVisual(idx, 'color');
	            var borderColor = provider.getItemVisual(idx, 'borderColor');
	            var legendSymbolType = 'roundRect';
	
	            var itemGroup = this._createItem(name, dataIndex, itemModel, legendModel, legendSymbolType, null, itemAlign, color, borderColor, selectMode); // FIXME: consider different series has items with the same name.
	
	
	            itemGroup.on('click', curry(dispatchSelectAction, null, name, api, excludeSeriesId)) // Should not specify the series name, consider legend controls
	            // more than one pie series.
	            .on('mouseover', curry(dispatchHighlightAction, null, name, api, excludeSeriesId)).on('mouseout', curry(dispatchDownplayAction, null, name, api, excludeSeriesId));
	            legendDrawnMap.set(name, true);
	          }
	        }, this);
	      }
	    }, this);
	
	    if (selector) {
	      this._createSelector(selector, legendModel, api, orient, selectorPosition);
	    }
	  },
	  _createSelector: function (selector, legendModel, api, orient, selectorPosition) {
	    var selectorGroup = this.getSelectorGroup();
	    each(selector, function (selectorItem) {
	      createSelectorButton(selectorItem);
	    });
	
	    function createSelectorButton(selectorItem) {
	      var type = selectorItem.type;
	      var labelText = new graphic.Text({
	        style: {
	          x: 0,
	          y: 0,
	          align: 'center',
	          verticalAlign: 'middle'
	        },
	        onclick: function () {
	          api.dispatchAction({
	            type: type === 'all' ? 'legendAllSelect' : 'legendInverseSelect'
	          });
	        }
	      });
	      selectorGroup.add(labelText);
	      var labelModel = legendModel.getModel('selectorLabel');
	      var emphasisLabelModel = legendModel.getModel('emphasis.selectorLabel');
	      graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, emphasisLabelModel, {
	        defaultText: selectorItem.title,
	        isRectText: false
	      });
	      graphic.setHoverStyle(labelText);
	    }
	  },
	  _createItem: function (name, dataIndex, itemModel, legendModel, legendSymbolType, symbolType, itemAlign, color, borderColor, selectMode) {
	    var itemWidth = legendModel.get('itemWidth');
	    var itemHeight = legendModel.get('itemHeight');
	    var inactiveColor = legendModel.get('inactiveColor');
	    var inactiveBorderColor = legendModel.get('inactiveBorderColor');
	    var symbolKeepAspect = legendModel.get('symbolKeepAspect');
	    var legendModelItemStyle = legendModel.getModel('itemStyle');
	    var isSelected = legendModel.isSelected(name);
	    var itemGroup = new Group();
	    var textStyleModel = itemModel.getModel('textStyle');
	    var itemIcon = itemModel.get('icon');
	    var tooltipModel = itemModel.getModel('tooltip');
	    var legendGlobalTooltipModel = tooltipModel.parentModel; // Use user given icon first
	
	    legendSymbolType = itemIcon || legendSymbolType;
	    var legendSymbol = createSymbol(legendSymbolType, 0, 0, itemWidth, itemHeight, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
	    symbolKeepAspect == null ? true : symbolKeepAspect);
	    itemGroup.add(setSymbolStyle(legendSymbol, legendSymbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected)); // Compose symbols
	    // PENDING
	
	    if (!itemIcon && symbolType // At least show one symbol, can't be all none
	    && (symbolType !== legendSymbolType || symbolType === 'none')) {
	      var size = itemHeight * 0.8;
	
	      if (symbolType === 'none') {
	        symbolType = 'circle';
	      }
	
	      var legendSymbolCenter = createSymbol(symbolType, (itemWidth - size) / 2, (itemHeight - size) / 2, size, size, isSelected ? color : inactiveColor, // symbolKeepAspect default true for legend
	      symbolKeepAspect == null ? true : symbolKeepAspect); // Put symbol in the center
	
	      itemGroup.add(setSymbolStyle(legendSymbolCenter, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected));
	    }
	
	    var textX = itemAlign === 'left' ? itemWidth + 5 : -5;
	    var textAlign = itemAlign;
	    var formatter = legendModel.get('formatter');
	    var content = name;
	
	    if (typeof formatter === 'string' && formatter) {
	      content = formatter.replace('{name}', name != null ? name : '');
	    } else if (typeof formatter === 'function') {
	      content = formatter(name);
	    }
	
	    itemGroup.add(new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: content,
	        x: textX,
	        y: itemHeight / 2,
	        textFill: isSelected ? textStyleModel.getTextColor() : inactiveColor,
	        textAlign: textAlign,
	        textVerticalAlign: 'middle'
	      })
	    })); // Add a invisible rect to increase the area of mouse hover
	
	    var hitRect = new graphic.Rect({
	      shape: itemGroup.getBoundingRect(),
	      invisible: true,
	      tooltip: tooltipModel.get('show') ? zrUtil.extend({
	        content: name,
	        // Defaul formatter
	        formatter: legendGlobalTooltipModel.get('formatter', true) || function () {
	          return name;
	        },
	        formatterParams: {
	          componentType: 'legend',
	          legendIndex: legendModel.componentIndex,
	          name: name,
	          $vars: ['name']
	        }
	      }, tooltipModel.option) : null
	    });
	    itemGroup.add(hitRect);
	    itemGroup.eachChild(function (child) {
	      child.silent = true;
	    });
	    hitRect.silent = !selectMode;
	    this.getContentGroup().add(itemGroup);
	    graphic.setHoverStyle(itemGroup);
	    itemGroup.__legendDataIndex = dataIndex;
	    return itemGroup;
	  },
	
	  /**
	   * @protected
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
	    var contentGroup = this.getContentGroup();
	    var selectorGroup = this.getSelectorGroup(); // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), maxSize.width, maxSize.height);
	    var contentRect = contentGroup.getBoundingRect();
	    var contentPos = [-contentRect.x, -contentRect.y];
	
	    if (selector) {
	      // Place buttons in selectorGroup
	      layoutUtil.box( // Buttons in selectorGroup always layout horizontally
	      'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
	      var selectorRect = selectorGroup.getBoundingRect();
	      var selectorPos = [-selectorRect.x, -selectorRect.y];
	      var selectorButtonGap = legendModel.get('selectorButtonGap', true);
	      var orientIdx = legendModel.getOrient().index;
	      var wh = orientIdx === 0 ? 'width' : 'height';
	      var hw = orientIdx === 0 ? 'height' : 'width';
	      var yx = orientIdx === 0 ? 'y' : 'x';
	
	      if (selectorPosition === 'end') {
	        selectorPos[orientIdx] += contentRect[wh] + selectorButtonGap;
	      } else {
	        contentPos[orientIdx] += selectorRect[wh] + selectorButtonGap;
	      } //Always align selector to content as 'middle'
	
	
	      selectorPos[1 - orientIdx] += contentRect[hw] / 2 - selectorRect[hw] / 2;
	      selectorGroup.attr('position', selectorPos);
	      contentGroup.attr('position', contentPos);
	      var mainRect = {
	        x: 0,
	        y: 0
	      };
	      mainRect[wh] = contentRect[wh] + selectorButtonGap + selectorRect[wh];
	      mainRect[hw] = Math.max(contentRect[hw], selectorRect[hw]);
	      mainRect[yx] = Math.min(0, selectorRect[yx] + selectorPos[1 - orientIdx]);
	      return mainRect;
	    } else {
	      contentGroup.attr('position', contentPos);
	      return this.group.getBoundingRect();
	    }
	  },
	
	  /**
	   * @protected
	   */
	  remove: function () {
	    this.getContentGroup().removeAll();
	    this._isFirstRender = true;
	  }
	});
	
	function setSymbolStyle(symbol, symbolType, legendModelItemStyle, borderColor, inactiveBorderColor, isSelected) {
	  var itemStyle;
	
	  if (symbolType !== 'line' && symbolType.indexOf('empty') < 0) {
	    itemStyle = legendModelItemStyle.getItemStyle();
	    symbol.style.stroke = borderColor;
	
	    if (!isSelected) {
	      itemStyle.stroke = inactiveBorderColor;
	    }
	  } else {
	    itemStyle = legendModelItemStyle.getItemStyle(['borderWidth', 'borderColor']);
	  }
	
	  return symbol.setStyle(itemStyle);
	}
	
	function dispatchSelectAction(seriesName, dataName, api, excludeSeriesId) {
	  // downplay before unselect
	  dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId);
	  api.dispatchAction({
	    type: 'legendToggleSelect',
	    name: seriesName != null ? seriesName : dataName
	  }); // highlight after select
	
	  dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId);
	}
	
	function dispatchHighlightAction(seriesName, dataName, api, excludeSeriesId) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    api.dispatchAction({
	      type: 'highlight',
	      seriesName: seriesName,
	      name: dataName,
	      excludeSeriesId: excludeSeriesId
	    });
	  }
	}
	
	function dispatchDownplayAction(seriesName, dataName, api, excludeSeriesId) {
	  // If element hover will move to a hoverLayer.
	  var el = api.getZr().storage.getDisplayList()[0];
	
	  if (!(el && el.useHoverLayer)) {
	    api.dispatchAction({
	      type: 'downplay',
	      seriesName: seriesName,
	      name: dataName,
	      excludeSeriesId: excludeSeriesId
	    });
	  }
	}
	
	module.exports = _default;

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var throttleUtil = __webpack_require__(181);
	
	var parallelPreprocessor = __webpack_require__(2418);
	
	__webpack_require__(867);
	
	__webpack_require__(2417);
	
	__webpack_require__(2362);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CLICK_THRESHOLD = 5; // > 4
	// Parallel view
	
	echarts.extendComponentView({
	  type: 'parallel',
	  render: function (parallelModel, ecModel, api) {
	    this._model = parallelModel;
	    this._api = api;
	
	    if (!this._handlers) {
	      this._handlers = {};
	      zrUtil.each(handlers, function (handler, eventName) {
	        api.getZr().on(eventName, this._handlers[eventName] = zrUtil.bind(handler, this));
	      }, this);
	    }
	
	    throttleUtil.createOrUpdate(this, '_throttledDispatchExpand', parallelModel.get('axisExpandRate'), 'fixRate');
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._handlers, function (handler, eventName) {
	      api.getZr().off(eventName, handler);
	    });
	    this._handlers = null;
	  },
	
	  /**
	   * @param {Object} [opt] If null, cancle the last action triggering for debounce.
	   */
	  _throttledDispatchExpand: function (opt) {
	    this._dispatchExpand(opt);
	  },
	  _dispatchExpand: function (opt) {
	    opt && this._api.dispatchAction(zrUtil.extend({
	      type: 'parallelAxisExpand'
	    }, opt));
	  }
	});
	var handlers = {
	  mousedown: function (e) {
	    if (checkTrigger(this, 'click')) {
	      this._mouseDownPoint = [e.offsetX, e.offsetY];
	    }
	  },
	  mouseup: function (e) {
	    var mouseDownPoint = this._mouseDownPoint;
	
	    if (checkTrigger(this, 'click') && mouseDownPoint) {
	      var point = [e.offsetX, e.offsetY];
	      var dist = Math.pow(mouseDownPoint[0] - point[0], 2) + Math.pow(mouseDownPoint[1] - point[1], 2);
	
	      if (dist > CLICK_THRESHOLD) {
	        return;
	      }
	
	      var result = this._model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	
	      result.behavior !== 'none' && this._dispatchExpand({
	        axisExpandWindow: result.axisExpandWindow
	      });
	    }
	
	    this._mouseDownPoint = null;
	  },
	  mousemove: function (e) {
	    // Should do nothing when brushing.
	    if (this._mouseDownPoint || !checkTrigger(this, 'mousemove')) {
	      return;
	    }
	
	    var model = this._model;
	    var result = model.coordinateSystem.getSlidedAxisExpandWindow([e.offsetX, e.offsetY]);
	    var behavior = result.behavior;
	    behavior === 'jump' && this._throttledDispatchExpand.debounceNextCall(model.get('axisExpandDebounce'));
	
	    this._throttledDispatchExpand(behavior === 'none' ? null // Cancle the last trigger, in case that mouse slide out of the area quickly.
	    : {
	      axisExpandWindow: result.axisExpandWindow,
	      // Jumping uses animation, and sliding suppresses animation.
	      animation: behavior === 'jump' ? null : false
	    });
	  }
	};
	
	function checkTrigger(view, triggerOn) {
	  var model = view._model;
	  return model.get('axisExpandable') && model.get('axisExpandTriggerOn') === triggerOn;
	}
	
	echarts.registerPreprocessor(parallelPreprocessor);

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2432);
	
	__webpack_require__(2318);
	
	__webpack_require__(2428);
	
	__webpack_require__(289);
	
	__webpack_require__(2323);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.extendComponentView({
	  type: 'single'
	});

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var env = __webpack_require__(73);
	
	var visualDefault = __webpack_require__(878);
	
	var VisualMapping = __webpack_require__(213);
	
	var visualSolution = __webpack_require__(364);
	
	var modelUtil = __webpack_require__(29);
	
	var numberUtil = __webpack_require__(25);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var mapVisual = VisualMapping.mapVisual;
	var eachVisual = VisualMapping.eachVisual;
	var isArray = zrUtil.isArray;
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	var linearMap = numberUtil.linearMap;
	var noop = zrUtil.noop;
	var VisualMapModel = echarts.extendComponentModel({
	  type: 'visualMap',
	  dependencies: ['series'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  stateList: ['inRange', 'outOfRange'],
	
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  replacableOptionKeys: ['inRange', 'outOfRange', 'target', 'controller', 'color'],
	
	  /**
	   * [lowerBound, upperBound]
	   *
	   * @readOnly
	   * @type {Array.<number>}
	   */
	  dataBound: [-Infinity, Infinity],
	
	  /**
	   * @readOnly
	   * @type {string|Object}
	   */
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    zlevel: 0,
	    z: 4,
	    seriesIndex: 'all',
	    // 'all' or null/undefined: all series.
	    // A number or an array of number: the specified series.
	    // set min: 0, max: 200, only for campatible with ec2.
	    // In fact min max should not have default value.
	    min: 0,
	    // min value, must specified if pieces is not specified.
	    max: 200,
	    // max value, must specified if pieces is not specified.
	    dimension: null,
	    inRange: null,
	    // 'color', 'colorHue', 'colorSaturation', 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    outOfRange: null,
	    // 'color', 'colorHue', 'colorSaturation',
	    // 'colorLightness', 'colorAlpha',
	    // 'symbol', 'symbolSize'
	    left: 0,
	    // 'center' ¦ 'left' ¦ 'right' ¦ {number} (px)
	    right: null,
	    // The same as left.
	    top: null,
	    // 'top' ¦ 'bottom' ¦ 'center' ¦ {number} (px)
	    bottom: 0,
	    // The same as top.
	    itemWidth: null,
	    itemHeight: null,
	    inverse: false,
	    orient: 'vertical',
	    // 'horizontal' ¦ 'vertical'
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderColor: '#ccc',
	    // 值域边框颜色
	    contentColor: '#5793f3',
	    inactiveColor: '#aaa',
	    borderWidth: 0,
	    // 值域边框线宽，单位px，默认为0（无边框）
	    padding: 5,
	    // 值域内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    textGap: 10,
	    //
	    precision: 0,
	    // 小数精度，默认为0，无小数点
	    color: null,
	    //颜色（deprecated，兼容ec2，顺序同pieces，不同于inRange/outOfRange）
	    formatter: null,
	    text: null,
	    // 文本，如['高', '低']，兼容ec2，text[0]对应高值，text[1]对应低值
	    textStyle: {
	      color: '#333' // 值域文字颜色
	
	    }
	  },
	
	  /**
	   * @protected
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {Array.<number>}
	     */
	    this._dataExtent;
	    /**
	     * @readOnly
	     */
	
	    this.targetVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.controllerVisuals = {};
	    /**
	     * @readOnly
	     */
	
	    this.textStyleModel;
	    /**
	     * [width, height]
	     * @readOnly
	     * @type {Array.<number>}
	     */
	
	    this.itemSize;
	    this.mergeDefaultAndTheme(option, ecModel);
	  },
	
	  /**
	   * @protected
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option; // FIXME
	    // necessary?
	    // Disable realtime view update if canvas is not supported.
	
	    if (!env.canvasSupported) {
	      thisOption.realtime = false;
	    }
	
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, this.replacableOptionKeys);
	    this.textStyleModel = this.getModel('textStyle');
	    this.resetItemSize();
	    this.completeVisualOption();
	  },
	
	  /**
	   * @protected
	   */
	  resetVisual: function (supplementVisualOption) {
	    var stateList = this.stateList;
	    supplementVisualOption = zrUtil.bind(supplementVisualOption, this);
	    this.controllerVisuals = visualSolution.createVisualMappings(this.option.controller, stateList, supplementVisualOption);
	    this.targetVisuals = visualSolution.createVisualMappings(this.option.target, stateList, supplementVisualOption);
	  },
	
	  /**
	   * @protected
	   * @return {Array.<number>} An array of series indices.
	   */
	  getTargetSeriesIndices: function () {
	    var optionSeriesIndex = this.option.seriesIndex;
	    var seriesIndices = [];
	
	    if (optionSeriesIndex == null || optionSeriesIndex === 'all') {
	      this.ecModel.eachSeries(function (seriesModel, index) {
	        seriesIndices.push(index);
	      });
	    } else {
	      seriesIndices = modelUtil.normalizeToArray(optionSeriesIndex);
	    }
	
	    return seriesIndices;
	  },
	
	  /**
	   * @public
	   */
	  eachTargetSeries: function (callback, context) {
	    zrUtil.each(this.getTargetSeriesIndices(), function (seriesIndex) {
	      callback.call(context, this.ecModel.getSeriesByIndex(seriesIndex));
	    }, this);
	  },
	
	  /**
	   * @pubilc
	   */
	  isTargetSeries: function (seriesModel) {
	    var is = false;
	    this.eachTargetSeries(function (model) {
	      model === seriesModel && (is = true);
	    });
	    return is;
	  },
	
	  /**
	   * @example
	   * this.formatValueText(someVal); // format single numeric value to text.
	   * this.formatValueText(someVal, true); // format single category value to text.
	   * this.formatValueText([min, max]); // format numeric min-max to text.
	   * this.formatValueText([this.dataBound[0], max]); // using data lower bound.
	   * this.formatValueText([min, this.dataBound[1]]); // using data upper bound.
	   *
	   * @param {number|Array.<number>} value Real value, or this.dataBound[0 or 1].
	   * @param {boolean} [isCategory=false] Only available when value is number.
	   * @param {Array.<string>} edgeSymbols Open-close symbol when value is interval.
	   * @return {string}
	   * @protected
	   */
	  formatValueText: function (value, isCategory, edgeSymbols) {
	    var option = this.option;
	    var precision = option.precision;
	    var dataBound = this.dataBound;
	    var formatter = option.formatter;
	    var isMinMax;
	    var textValue;
	    edgeSymbols = edgeSymbols || ['<', '>'];
	
	    if (zrUtil.isArray(value)) {
	      value = value.slice();
	      isMinMax = true;
	    }
	
	    textValue = isCategory ? value : isMinMax ? [toFixed(value[0]), toFixed(value[1])] : toFixed(value);
	
	    if (zrUtil.isString(formatter)) {
	      return formatter.replace('{value}', isMinMax ? textValue[0] : textValue).replace('{value2}', isMinMax ? textValue[1] : textValue);
	    } else if (zrUtil.isFunction(formatter)) {
	      return isMinMax ? formatter(value[0], value[1]) : formatter(value);
	    }
	
	    if (isMinMax) {
	      if (value[0] === dataBound[0]) {
	        return edgeSymbols[0] + ' ' + textValue[1];
	      } else if (value[1] === dataBound[1]) {
	        return edgeSymbols[1] + ' ' + textValue[0];
	      } else {
	        return textValue[0] + ' - ' + textValue[1];
	      }
	    } else {
	      // Format single value (includes category case).
	      return textValue;
	    }
	
	    function toFixed(val) {
	      return val === dataBound[0] ? 'min' : val === dataBound[1] ? 'max' : (+val).toFixed(Math.min(precision, 20));
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetExtent: function () {
	    var thisOption = this.option; // Can not calculate data extent by data here.
	    // Because series and data may be modified in processing stage.
	    // So we do not support the feature "auto min/max".
	
	    var extent = asc([thisOption.min, thisOption.max]);
	    this._dataExtent = extent;
	  },
	
	  /**
	   * @public
	   * @param {module:echarts/data/List} list
	   * @return {string} Concrete dimention. If return null/undefined,
	   *                  no dimension used.
	   */
	  getDataDimension: function (list) {
	    var optDim = this.option.dimension;
	    var listDimensions = list.dimensions;
	
	    if (optDim == null && !listDimensions.length) {
	      return;
	    }
	
	    if (optDim != null) {
	      return list.getDimension(optDim);
	    }
	
	    var dimNames = list.dimensions;
	
	    for (var i = dimNames.length - 1; i >= 0; i--) {
	      var dimName = dimNames[i];
	      var dimInfo = list.getDimensionInfo(dimName);
	
	      if (!dimInfo.isCalculationCoord) {
	        return dimName;
	      }
	    }
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getExtent: function () {
	    return this._dataExtent.slice();
	  },
	
	  /**
	   * @protected
	   */
	  completeVisualOption: function () {
	    var ecModel = this.ecModel;
	    var thisOption = this.option;
	    var base = {
	      inRange: thisOption.inRange,
	      outOfRange: thisOption.outOfRange
	    };
	    var target = thisOption.target || (thisOption.target = {});
	    var controller = thisOption.controller || (thisOption.controller = {});
	    zrUtil.merge(target, base); // Do not override
	
	    zrUtil.merge(controller, base); // Do not override
	
	    var isCategory = this.isCategory();
	    completeSingle.call(this, target);
	    completeSingle.call(this, controller);
	    completeInactive.call(this, target, 'inRange', 'outOfRange'); // completeInactive.call(this, target, 'outOfRange', 'inRange');
	
	    completeController.call(this, controller);
	
	    function completeSingle(base) {
	      // Compatible with ec2 dataRange.color.
	      // The mapping order of dataRange.color is: [high value, ..., low value]
	      // whereas inRange.color and outOfRange.color is [low value, ..., high value]
	      // Notice: ec2 has no inverse.
	      if (isArray(thisOption.color) // If there has been inRange: {symbol: ...}, adding color is a mistake.
	      // So adding color only when no inRange defined.
	      && !base.inRange) {
	        base.inRange = {
	          color: thisOption.color.slice().reverse()
	        };
	      } // Compatible with previous logic, always give a defautl color, otherwise
	      // simple config with no inRange and outOfRange will not work.
	      // Originally we use visualMap.color as the default color, but setOption at
	      // the second time the default color will be erased. So we change to use
	      // constant DEFAULT_COLOR.
	      // If user do not want the default color, set inRange: {color: null}.
	
	
	      base.inRange = base.inRange || {
	        color: ecModel.get('gradientColor')
	      }; // If using shortcut like: {inRange: 'symbol'}, complete default value.
	
	      each(this.stateList, function (state) {
	        var visualType = base[state];
	
	        if (zrUtil.isString(visualType)) {
	          var defa = visualDefault.get(visualType, 'active', isCategory);
	
	          if (defa) {
	            base[state] = {};
	            base[state][visualType] = defa;
	          } else {
	            // Mark as not specified.
	            delete base[state];
	          }
	        }
	      }, this);
	    }
	
	    function completeInactive(base, stateExist, stateAbsent) {
	      var optExist = base[stateExist];
	      var optAbsent = base[stateAbsent];
	
	      if (optExist && !optAbsent) {
	        optAbsent = base[stateAbsent] = {};
	        each(optExist, function (visualData, visualType) {
	          if (!VisualMapping.isValidType(visualType)) {
	            return;
	          }
	
	          var defa = visualDefault.get(visualType, 'inactive', isCategory);
	
	          if (defa != null) {
	            optAbsent[visualType] = defa; // Compatibable with ec2:
	            // Only inactive color to rgba(0,0,0,0) can not
	            // make label transparent, so use opacity also.
	
	            if (visualType === 'color' && !optAbsent.hasOwnProperty('opacity') && !optAbsent.hasOwnProperty('colorAlpha')) {
	              optAbsent.opacity = [0, 0];
	            }
	          }
	        });
	      }
	    }
	
	    function completeController(controller) {
	      var symbolExists = (controller.inRange || {}).symbol || (controller.outOfRange || {}).symbol;
	      var symbolSizeExists = (controller.inRange || {}).symbolSize || (controller.outOfRange || {}).symbolSize;
	      var inactiveColor = this.get('inactiveColor');
	      each(this.stateList, function (state) {
	        var itemSize = this.itemSize;
	        var visuals = controller[state]; // Set inactive color for controller if no other color
	        // attr (like colorAlpha) specified.
	
	        if (!visuals) {
	          visuals = controller[state] = {
	            color: isCategory ? inactiveColor : [inactiveColor]
	          };
	        } // Consistent symbol and symbolSize if not specified.
	
	
	        if (visuals.symbol == null) {
	          visuals.symbol = symbolExists && zrUtil.clone(symbolExists) || (isCategory ? 'roundRect' : ['roundRect']);
	        }
	
	        if (visuals.symbolSize == null) {
	          visuals.symbolSize = symbolSizeExists && zrUtil.clone(symbolSizeExists) || (isCategory ? itemSize[0] : [itemSize[0], itemSize[0]]);
	        } // Filter square and none.
	
	
	        visuals.symbol = mapVisual(visuals.symbol, function (symbol) {
	          return symbol === 'none' || symbol === 'square' ? 'roundRect' : symbol;
	        }); // Normalize symbolSize
	
	        var symbolSize = visuals.symbolSize;
	
	        if (symbolSize != null) {
	          var max = -Infinity; // symbolSize can be object when categories defined.
	
	          eachVisual(symbolSize, function (value) {
	            value > max && (max = value);
	          });
	          visuals.symbolSize = mapVisual(symbolSize, function (value) {
	            return linearMap(value, [0, max], [0, itemSize[0]], true);
	          });
	        }
	      }, this);
	    }
	  },
	
	  /**
	   * @protected
	   */
	  resetItemSize: function () {
	    this.itemSize = [parseFloat(this.get('itemWidth')), parseFloat(this.get('itemHeight'))];
	  },
	
	  /**
	   * @public
	   */
	  isCategory: function () {
	    return !!this.option.categories;
	  },
	
	  /**
	   * @public
	   * @abstract
	   */
	  setSelected: noop,
	
	  /**
	   * @public
	   * @abstract
	   * @param {*|module:echarts/data/List} valueOrData
	   * @param {number} dataIndex
	   * @return {string} state See this.stateList
	   */
	  getValueState: noop,
	
	  /**
	   * FIXME
	   * Do not publish to thirt-part-dev temporarily
	   * util the interface is stable. (Should it return
	   * a function but not visual meta?)
	   *
	   * @pubilc
	   * @abstract
	   * @param {Function} getColorVisual
	   *        params: value, valueState
	   *        return: color
	   * @return {Object} visualMeta
	   *        should includes {stops, outerColors}
	   *        outerColor means [colorBeyondMinValue, colorBeyondMaxValue]
	   */
	  getVisualMeta: noop
	});
	var _default = VisualMapModel;
	module.exports = _default;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var formatUtil = __webpack_require__(48);
	
	var layout = __webpack_require__(46);
	
	var VisualMapping = __webpack_require__(213);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'visualMap',
	
	  /**
	   * @readOnly
	   * @type {Object}
	   */
	  autoPositionValues: {
	    left: 1,
	    right: 1,
	    top: 1,
	    bottom: 1
	  },
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/visualMap/visualMapModel}
	     */
	
	    this.visualMapModel;
	  },
	
	  /**
	   * @protected
	   */
	  render: function (visualMapModel, ecModel, api, payload) {
	    this.visualMapModel = visualMapModel;
	
	    if (visualMapModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    }
	
	    this.doRender.apply(this, arguments);
	  },
	
	  /**
	   * @protected
	   */
	  renderBackground: function (group) {
	    var visualMapModel = this.visualMapModel;
	    var padding = formatUtil.normalizeCssArray(visualMapModel.get('padding') || 0);
	    var rect = group.getBoundingRect();
	    group.add(new graphic.Rect({
	      z2: -1,
	      // Lay background rect on the lowest layer.
	      silent: true,
	      shape: {
	        x: rect.x - padding[3],
	        y: rect.y - padding[0],
	        width: rect.width + padding[3] + padding[1],
	        height: rect.height + padding[0] + padding[2]
	      },
	      style: {
	        fill: visualMapModel.get('backgroundColor'),
	        stroke: visualMapModel.get('borderColor'),
	        lineWidth: visualMapModel.get('borderWidth')
	      }
	    }));
	  },
	
	  /**
	   * @protected
	   * @param {number} targetValue can be Infinity or -Infinity
	   * @param {string=} visualCluster Only can be 'color' 'opacity' 'symbol' 'symbolSize'
	   * @param {Object} [opts]
	   * @param {string=} [opts.forceState] Specify state, instead of using getValueState method.
	   * @param {string=} [opts.convertOpacityToAlpha=false] For color gradient in controller widget.
	   * @return {*} Visual value.
	   */
	  getControllerVisual: function (targetValue, visualCluster, opts) {
	    opts = opts || {};
	    var forceState = opts.forceState;
	    var visualMapModel = this.visualMapModel;
	    var visualObj = {}; // Default values.
	
	    if (visualCluster === 'symbol') {
	      visualObj.symbol = visualMapModel.get('itemSymbol');
	    }
	
	    if (visualCluster === 'color') {
	      var defaultColor = visualMapModel.get('contentColor');
	      visualObj.color = defaultColor;
	    }
	
	    function getter(key) {
	      return visualObj[key];
	    }
	
	    function setter(key, value) {
	      visualObj[key] = value;
	    }
	
	    var mappings = visualMapModel.controllerVisuals[forceState || visualMapModel.getValueState(targetValue)];
	    var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	    zrUtil.each(visualTypes, function (type) {
	      var visualMapping = mappings[type];
	
	      if (opts.convertOpacityToAlpha && type === 'opacity') {
	        type = 'colorAlpha';
	        visualMapping = mappings.__alphaForOpacity;
	      }
	
	      if (VisualMapping.dependsOn(type, visualCluster)) {
	        visualMapping && visualMapping.applyVisual(targetValue, getter, setter);
	      }
	    });
	    return visualObj[visualCluster];
	  },
	
	  /**
	   * @protected
	   */
	  positionGroup: function (group) {
	    var model = this.visualMapModel;
	    var api = this.api;
	    layout.positionElement(group, model.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  },
	
	  /**
	   * @protected
	   * @abstract
	   */
	  doRender: zrUtil.noop
	});
	
	module.exports = _default;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var _layout = __webpack_require__(46);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/component/visualMap/VisualMapModel} visualMapModel\
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Array.<number>} itemSize always [short, long]
	 * @return {string} 'left' or 'right' or 'top' or 'bottom'
	 */
	function getItemAlign(visualMapModel, api, itemSize) {
	  var modelOption = visualMapModel.option;
	  var itemAlign = modelOption.align;
	
	  if (itemAlign != null && itemAlign !== 'auto') {
	    return itemAlign;
	  } // Auto decision align.
	
	
	  var ecSize = {
	    width: api.getWidth(),
	    height: api.getHeight()
	  };
	  var realIndex = modelOption.orient === 'horizontal' ? 1 : 0;
	  var paramsSet = [['left', 'right', 'width'], ['top', 'bottom', 'height']];
	  var reals = paramsSet[realIndex];
	  var fakeValue = [0, null, 10];
	  var layoutInput = {};
	
	  for (var i = 0; i < 3; i++) {
	    layoutInput[paramsSet[1 - realIndex][i]] = fakeValue[i];
	    layoutInput[reals[i]] = i === 2 ? itemSize[0] : modelOption[reals[i]];
	  }
	
	  var rParam = [['x', 'width', 3], ['y', 'height', 0]][realIndex];
	  var rect = getLayoutRect(layoutInput, ecSize, modelOption.padding);
	  return reals[(rect.margin[rParam[2]] || 0) + rect[rParam[0]] + rect[rParam[1]] * 0.5 < ecSize[rParam[1]] * 0.5 ? 0 : 1];
	}
	/**
	 * Prepare dataIndex for outside usage, where dataIndex means rawIndex, and
	 * dataIndexInside means filtered index.
	 */
	
	
	function makeHighDownBatch(batch, visualMapModel) {
	  zrUtil.each(batch || [], function (batchItem) {
	    if (batchItem.dataIndex != null) {
	      batchItem.dataIndexInside = batchItem.dataIndex;
	      batchItem.dataIndex = null;
	    }
	
	    batchItem.highlightKey = 'visualMap' + (visualMapModel ? visualMapModel.componentIndex : '');
	  });
	  return batch;
	}
	
	exports.getItemAlign = getItemAlign;
	exports.makeHighDownBatch = makeHighDownBatch;

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	
	function _default(option) {
	  var visualMap = option && option.visualMap;
	
	  if (!zrUtil.isArray(visualMap)) {
	    visualMap = visualMap ? [visualMap] : [];
	  }
	
	  each(visualMap, function (opt) {
	    if (!opt) {
	      return;
	    } // rename splitList to pieces
	
	
	    if (has(opt, 'splitList') && !has(opt, 'pieces')) {
	      opt.pieces = opt.splitList;
	      delete opt.splitList;
	    }
	
	    var pieces = opt.pieces;
	
	    if (pieces && zrUtil.isArray(pieces)) {
	      each(pieces, function (piece) {
	        if (zrUtil.isObject(piece)) {
	          if (has(piece, 'start') && !has(piece, 'min')) {
	            piece.min = piece.start;
	          }
	
	          if (has(piece, 'end') && !has(piece, 'max')) {
	            piece.max = piece.end;
	          }
	        }
	      });
	    }
	  });
	}
	
	function has(obj, name) {
	  return obj && obj.hasOwnProperty && obj.hasOwnProperty(name);
	}
	
	module.exports = _default;

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(76);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('visualMap', function (option) {
	  // Compatible with ec2, when splitNumber === 0, continuous visualMap will be used.
	  return !option.categories && (!(option.pieces ? option.pieces.length > 0 : option.splitNumber > 0) || option.calculable) ? 'continuous' : 'piecewise';
	});

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var visualSolution = __webpack_require__(364);
	
	var VisualMapping = __webpack_require__(213);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var VISUAL_PRIORITY = echarts.PRIORITY.VISUAL.COMPONENT;
	echarts.registerVisual(VISUAL_PRIORITY, {
	  createOnAllSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var resetDefines = [];
	    ecModel.eachComponent('visualMap', function (visualMapModel) {
	      var pipelineContext = seriesModel.pipelineContext;
	
	      if (!visualMapModel.isTargetSeries(seriesModel) || pipelineContext && pipelineContext.large) {
	        return;
	      }
	
	      resetDefines.push(visualSolution.incrementalApplyVisual(visualMapModel.stateList, visualMapModel.targetVisuals, zrUtil.bind(visualMapModel.getValueState, visualMapModel), visualMapModel.getDataDimension(seriesModel.getData())));
	    });
	    return resetDefines;
	  }
	}); // Only support color.
	
	echarts.registerVisual(VISUAL_PRIORITY, {
	  createOnAllSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var visualMetaList = [];
	    ecModel.eachComponent('visualMap', function (visualMapModel) {
	      if (visualMapModel.isTargetSeries(seriesModel)) {
	        var visualMeta = visualMapModel.getVisualMeta(zrUtil.bind(getColorVisual, null, seriesModel, visualMapModel)) || {
	          stops: [],
	          outerColors: []
	        };
	        var concreteDim = visualMapModel.getDataDimension(data);
	        var dimInfo = data.getDimensionInfo(concreteDim);
	
	        if (dimInfo != null) {
	          // visualMeta.dimension should be dimension index, but not concrete dimension.
	          visualMeta.dimension = dimInfo.index;
	          visualMetaList.push(visualMeta);
	        }
	      }
	    }); // console.log(JSON.stringify(visualMetaList.map(a => a.stops)));
	
	    seriesModel.getData().setVisual('visualMeta', visualMetaList);
	  }
	}); // FIXME
	// performance and export for heatmap?
	// value can be Infinity or -Infinity
	
	function getColorVisual(seriesModel, visualMapModel, value, valueState) {
	  var mappings = visualMapModel.targetVisuals[valueState];
	  var visualTypes = VisualMapping.prepareVisualTypes(mappings);
	  var resultVisual = {
	    color: seriesModel.getData().getVisual('color') // default color.
	
	  };
	
	  for (var i = 0, len = visualTypes.length; i < len; i++) {
	    var type = visualTypes[i];
	    var mapping = mappings[type === 'opacity' ? '__alphaForOpacity' : type];
	    mapping && mapping.applyVisual(value, getVisual, setVisual);
	  }
	
	  return resultVisual.color;
	
	  function getVisual(key) {
	    return resultVisual[key];
	  }
	
	  function setVisual(key, value) {
	    resultVisual[key] = value;
	  }
	}

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var actionInfo = {
	  type: 'selectDataRange',
	  event: 'dataRangeSelected',
	  // FIXME use updateView appears wrong
	  update: 'update'
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'visualMap',
	    query: payload
	  }, function (model) {
	    model.setSelected(payload.selected);
	  });
	});

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var preprocessor = __webpack_require__(856);
	
	__webpack_require__(857);
	
	__webpack_require__(858);
	
	__webpack_require__(2392);
	
	__webpack_require__(2393);
	
	__webpack_require__(859);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var preprocessor = __webpack_require__(856);
	
	__webpack_require__(857);
	
	__webpack_require__(858);
	
	__webpack_require__(2394);
	
	__webpack_require__(2395);
	
	__webpack_require__(859);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var defaultOption = {
	  show: true,
	  zlevel: 0,
	  z: 0,
	  // Inverse the axis.
	  inverse: false,
	  // Axis name displayed.
	  name: '',
	  // 'start' | 'middle' | 'end'
	  nameLocation: 'end',
	  // By degree. By default auto rotate by nameLocation.
	  nameRotate: null,
	  nameTruncate: {
	    maxWidth: null,
	    ellipsis: '...',
	    placeholder: '.'
	  },
	  // Use global text style by default.
	  nameTextStyle: {},
	  // The gap between axisName and axisLine.
	  nameGap: 15,
	  // Default `false` to support tooltip.
	  silent: false,
	  // Default `false` to avoid legacy user event listener fail.
	  triggerEvent: false,
	  tooltip: {
	    show: false
	  },
	  axisPointer: {},
	  axisLine: {
	    show: true,
	    onZero: true,
	    onZeroAxisIndex: null,
	    lineStyle: {
	      color: '#333',
	      width: 1,
	      type: 'solid'
	    },
	    // The arrow at both ends the the axis.
	    symbol: ['none', 'none'],
	    symbolSize: [10, 15]
	  },
	  axisTick: {
	    show: true,
	    // Whether axisTick is inside the grid or outside the grid.
	    inside: false,
	    // The length of axisTick.
	    length: 5,
	    lineStyle: {
	      width: 1
	    }
	  },
	  axisLabel: {
	    show: true,
	    // Whether axisLabel is inside the grid or outside the grid.
	    inside: false,
	    rotate: 0,
	    // true | false | null/undefined (auto)
	    showMinLabel: null,
	    // true | false | null/undefined (auto)
	    showMaxLabel: null,
	    margin: 8,
	    // formatter: null,
	    fontSize: 12
	  },
	  splitLine: {
	    show: true,
	    lineStyle: {
	      color: ['#ccc'],
	      width: 1,
	      type: 'solid'
	    }
	  },
	  splitArea: {
	    show: false,
	    areaStyle: {
	      color: ['rgba(250,250,250,0.3)', 'rgba(200,200,200,0.3)']
	    }
	  }
	};
	var axisDefault = {};
	axisDefault.categoryAxis = zrUtil.merge({
	  // The gap at both ends of the axis. For categoryAxis, boolean.
	  boundaryGap: true,
	  // Set false to faster category collection.
	  // Only usefull in the case like: category is
	  // ['2012-01-01', '2012-01-02', ...], where the input
	  // data has been ensured not duplicate and is large data.
	  // null means "auto":
	  // if axis.data provided, do not deduplication,
	  // else do deduplication.
	  deduplication: null,
	  // splitArea: {
	  // show: false
	  // },
	  splitLine: {
	    show: false
	  },
	  axisTick: {
	    // If tick is align with label when boundaryGap is true
	    alignWithLabel: false,
	    interval: 'auto'
	  },
	  axisLabel: {
	    interval: 'auto'
	  }
	}, defaultOption);
	axisDefault.valueAxis = zrUtil.merge({
	  // The gap at both ends of the axis. For value axis, [GAP, GAP], where
	  // `GAP` can be an absolute pixel number (like `35`), or percent (like `'30%'`)
	  boundaryGap: [0, 0],
	  // TODO
	  // min/max: [30, datamin, 60] or [20, datamin] or [datamin, 60]
	  // Min value of the axis. can be:
	  // + a number
	  // + 'dataMin': use the min value in data.
	  // + null/undefined: auto decide min value (consider pretty look and boundaryGap).
	  // min: null,
	  // Max value of the axis. can be:
	  // + a number
	  // + 'dataMax': use the max value in data.
	  // + null/undefined: auto decide max value (consider pretty look and boundaryGap).
	  // max: null,
	  // Readonly prop, specifies start value of the range when using data zoom.
	  // rangeStart: null
	  // Readonly prop, specifies end value of the range when using data zoom.
	  // rangeEnd: null
	  // Optional value can be:
	  // + `false`: always include value 0.
	  // + `true`: the extent do not consider value 0.
	  // scale: false,
	  // AxisTick and axisLabel and splitLine are caculated based on splitNumber.
	  splitNumber: 5,
	  // Interval specifies the span of the ticks is mandatorily.
	  // interval: null
	  // Specify min interval when auto calculate tick interval.
	  // minInterval: null
	  // Specify max interval when auto calculate tick interval.
	  // maxInterval: null
	  minorTick: {
	    // Minor tick, not available for cateogry axis.
	    show: false,
	    // Split number of minor ticks. The value should be in range of (0, 100)
	    splitNumber: 5,
	    // Lenght of minor tick
	    length: 3,
	    // Same inside with axisTick
	    // Line style
	    lineStyle: {// Default to be same with axisTick
	    }
	  },
	  minorSplitLine: {
	    show: false,
	    lineStyle: {
	      color: '#eee',
	      width: 1
	    }
	  }
	}, defaultOption);
	axisDefault.timeAxis = zrUtil.defaults({
	  scale: true,
	  min: 'dataMin',
	  max: 'dataMax'
	}, axisDefault.valueAxis);
	axisDefault.logAxis = zrUtil.defaults({
	  scale: true,
	  logBase: 10
	}, axisDefault.valueAxis);
	var _default = axisDefault;
	module.exports = _default;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var ComponentModel = __webpack_require__(76);
	
	var axisModelCreator = __webpack_require__(357);
	
	var axisModelCommonMixin = __webpack_require__(250);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'cartesian2dAxis',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Axis2D}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  init: function () {
	    AxisModel.superApply(this, 'init', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function () {
	    AxisModel.superApply(this, 'mergeOption', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   */
	  restoreData: function () {
	    AxisModel.superApply(this, 'restoreData', arguments);
	    this.resetRange();
	  },
	
	  /**
	   * @override
	   * @return {module:echarts/model/Component}
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'grid',
	      index: this.option.gridIndex,
	      id: this.option.gridId
	    })[0];
	  }
	});
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	var extraOption = {
	  // gridIndex: 0,
	  // gridId: '',
	  // Offset is for multiple axis on the same position
	  offset: 0
	};
	axisModelCreator('x', AxisModel, getAxisType, extraOption);
	axisModelCreator('y', AxisModel, getAxisType, extraOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Can only be called after coordinate system creation stage.
	 * (Can be called before coordinate system update stage).
	 *
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, z2
	 * }
	 */
	function layout(gridModel, axisModel, opt) {
	  opt = opt || {};
	  var grid = gridModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var otherAxisOnZeroOf = axis.getAxesOnZeroOf()[0];
	  var rawAxisPosition = axis.position;
	  var axisPosition = otherAxisOnZeroOf ? 'onZero' : rawAxisPosition;
	  var axisDim = axis.dim;
	  var rect = grid.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var idx = {
	    left: 0,
	    right: 1,
	    top: 0,
	    bottom: 1,
	    onZero: 2
	  };
	  var axisOffset = axisModel.get('offset') || 0;
	  var posBound = axisDim === 'x' ? [rectBound[2] - axisOffset, rectBound[3] + axisOffset] : [rectBound[0] - axisOffset, rectBound[1] + axisOffset];
	
	  if (otherAxisOnZeroOf) {
	    var onZeroCoord = otherAxisOnZeroOf.toGlobalCoord(otherAxisOnZeroOf.dataToCoord(0));
	    posBound[idx.onZero] = Math.max(Math.min(onZeroCoord, posBound[1]), posBound[0]);
	  } // Axis position
	
	
	  layout.position = [axisDim === 'y' ? posBound[idx[axisPosition]] : rectBound[0], axisDim === 'x' ? posBound[idx[axisPosition]] : rectBound[3]]; // Axis rotation
	
	  layout.rotation = Math.PI / 2 * (axisDim === 'x' ? 0 : 1); // Tick and label direction, x y is axisDim
	
	  var dirMap = {
	    top: -1,
	    bottom: 1,
	    left: -1,
	    right: 1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = dirMap[rawAxisPosition];
	  layout.labelOffset = otherAxisOnZeroOf ? posBound[idx[rawAxisPosition]] - posBound[idx.onZero] : 0;
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  } // Special label rotation
	
	
	  var labelRotate = axisModel.get('axisLabel.rotate');
	  layout.labelRotate = axisPosition === 'top' ? -labelRotate : labelRotate; // Over splitLine and splitArea
	
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BoundingRect = __webpack_require__(60);
	
	var bbox = __webpack_require__(314);
	
	var vec2 = __webpack_require__(55);
	
	var polygonContain = __webpack_require__(1191);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/coord/geo/Region
	 */
	
	/**
	 * @param {string|Region} name
	 * @param {Array} geometries
	 * @param {Array.<number>} cp
	 */
	function Region(name, geometries, cp) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.name = name;
	  /**
	   * @type {Array.<Array>}
	   * @readOnly
	   */
	
	  this.geometries = geometries;
	
	  if (!cp) {
	    var rect = this.getBoundingRect();
	    cp = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  } else {
	    cp = [cp[0], cp[1]];
	  }
	  /**
	   * @type {Array.<number>}
	   */
	
	
	  this.center = cp;
	}
	
	Region.prototype = {
	  constructor: Region,
	  properties: null,
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getBoundingRect: function () {
	    var rect = this._rect;
	
	    if (rect) {
	      return rect;
	    }
	
	    var MAX_NUMBER = Number.MAX_VALUE;
	    var min = [MAX_NUMBER, MAX_NUMBER];
	    var max = [-MAX_NUMBER, -MAX_NUMBER];
	    var min2 = [];
	    var max2 = [];
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      } // Doesn't consider hole
	
	
	      var exterior = geometries[i].exterior;
	      bbox.fromPoints(exterior, min2, max2);
	      vec2.min(min, min, min2);
	      vec2.max(max, max, max2);
	    } // No data
	
	
	    if (i === 0) {
	      min[0] = min[1] = max[0] = max[1] = 0;
	    }
	
	    return this._rect = new BoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	  },
	
	  /**
	   * @param {<Array.<number>} coord
	   * @return {boolean}
	   */
	  contain: function (coord) {
	    var rect = this.getBoundingRect();
	    var geometries = this.geometries;
	
	    if (!rect.contain(coord[0], coord[1])) {
	      return false;
	    }
	
	    loopGeo: for (var i = 0, len = geometries.length; i < len; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      if (polygonContain.contain(exterior, coord[0], coord[1])) {
	        // Not in the region if point is in the hole.
	        for (var k = 0; k < (interiors ? interiors.length : 0); k++) {
	          if (polygonContain.contain(interiors[k])) {
	            continue loopGeo;
	          }
	        }
	
	        return true;
	      }
	    }
	
	    return false;
	  },
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var aspect = rect.width / rect.height;
	
	    if (!width) {
	      width = aspect * height;
	    } else if (!height) {
	      height = width / aspect;
	    }
	
	    var target = new BoundingRect(x, y, width, height);
	    var transform = rect.calculateTransform(target);
	    var geometries = this.geometries;
	
	    for (var i = 0; i < geometries.length; i++) {
	      // Only support polygon.
	      if (geometries[i].type !== 'polygon') {
	        continue;
	      }
	
	      var exterior = geometries[i].exterior;
	      var interiors = geometries[i].interiors;
	
	      for (var p = 0; p < exterior.length; p++) {
	        vec2.applyTransform(exterior[p], exterior[p], transform);
	      }
	
	      for (var h = 0; h < (interiors ? interiors.length : 0); h++) {
	        for (var p = 0; p < interiors[h].length; p++) {
	          vec2.applyTransform(interiors[h][p], interiors[h][p], transform);
	        }
	      }
	    }
	
	    rect = this._rect;
	    rect.copy(target); // Update center
	
	    this.center = [rect.x + rect.width / 2, rect.y + rect.height / 2];
	  },
	  cloneShallow: function (name) {
	    name == null && (name = this.name);
	    var newRegion = new Region(name, this.geometries, this.center);
	    newRegion._rect = this._rect;
	    newRegion.transformTo = null; // Simply avoid to be called.
	
	    return newRegion;
	  }
	};
	var _default = Region;
	module.exports = _default;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Region = __webpack_require__(865);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parse and decode geo json
	 * @module echarts/coord/geo/parseGeoJson
	 */
	function decode(json) {
	  if (!json.UTF8Encoding) {
	    return json;
	  }
	
	  var encodeScale = json.UTF8Scale;
	
	  if (encodeScale == null) {
	    encodeScale = 1024;
	  }
	
	  var features = json.features;
	
	  for (var f = 0; f < features.length; f++) {
	    var feature = features[f];
	    var geometry = feature.geometry;
	    var coordinates = geometry.coordinates;
	    var encodeOffsets = geometry.encodeOffsets;
	
	    for (var c = 0; c < coordinates.length; c++) {
	      var coordinate = coordinates[c];
	
	      if (geometry.type === 'Polygon') {
	        coordinates[c] = decodePolygon(coordinate, encodeOffsets[c], encodeScale);
	      } else if (geometry.type === 'MultiPolygon') {
	        for (var c2 = 0; c2 < coordinate.length; c2++) {
	          var polygon = coordinate[c2];
	          coordinate[c2] = decodePolygon(polygon, encodeOffsets[c][c2], encodeScale);
	        }
	      }
	    }
	  } // Has been decoded
	
	
	  json.UTF8Encoding = false;
	  return json;
	}
	
	function decodePolygon(coordinate, encodeOffsets, encodeScale) {
	  var result = [];
	  var prevX = encodeOffsets[0];
	  var prevY = encodeOffsets[1];
	
	  for (var i = 0; i < coordinate.length; i += 2) {
	    var x = coordinate.charCodeAt(i) - 64;
	    var y = coordinate.charCodeAt(i + 1) - 64; // ZigZag decoding
	
	    x = x >> 1 ^ -(x & 1);
	    y = y >> 1 ^ -(y & 1); // Delta deocding
	
	    x += prevX;
	    y += prevY;
	    prevX = x;
	    prevY = y; // Dequantize
	
	    result.push([x / encodeScale, y / encodeScale]);
	  }
	
	  return result;
	}
	/**
	 * @alias module:echarts/coord/geo/parseGeoJson
	 * @param {Object} geoJson
	 * @param {string} nameProperty
	 * @return {module:zrender/container/Group}
	 */
	
	
	function _default(geoJson, nameProperty) {
	  decode(geoJson);
	  return zrUtil.map(zrUtil.filter(geoJson.features, function (featureObj) {
	    // Output of mapshaper may have geometry null
	    return featureObj.geometry && featureObj.properties && featureObj.geometry.coordinates.length > 0;
	  }), function (featureObj) {
	    var properties = featureObj.properties;
	    var geo = featureObj.geometry;
	    var coordinates = geo.coordinates;
	    var geometries = [];
	
	    if (geo.type === 'Polygon') {
	      geometries.push({
	        type: 'polygon',
	        // According to the GeoJSON specification.
	        // First must be exterior, and the rest are all interior(holes).
	        exterior: coordinates[0],
	        interiors: coordinates.slice(1)
	      });
	    }
	
	    if (geo.type === 'MultiPolygon') {
	      zrUtil.each(coordinates, function (item) {
	        if (item[0]) {
	          geometries.push({
	            type: 'polygon',
	            exterior: item[0],
	            interiors: item.slice(1)
	          });
	        }
	      });
	    }
	
	    var region = new Region(properties[nameProperty || 'name'], geometries, properties.cp);
	    region.properties = properties;
	    return region;
	  });
	}
	
	module.exports = _default;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Parallel = __webpack_require__(2415);
	
	var CoordinateSystem = __webpack_require__(121);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parallel coordinate system creater.
	 */
	function create(ecModel, api) {
	  var coordSysList = [];
	  ecModel.eachComponent('parallel', function (parallelModel, idx) {
	    var coordSys = new Parallel(parallelModel, ecModel, api);
	    coordSys.name = 'parallel_' + idx;
	    coordSys.resize(parallelModel, api);
	    parallelModel.coordinateSystem = coordSys;
	    coordSys.model = parallelModel;
	    coordSysList.push(coordSys);
	  }); // Inject the coordinateSystems into seriesModel
	
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'parallel') {
	      var parallelModel = ecModel.queryComponents({
	        mainType: 'parallel',
	        index: seriesModel.get('parallelIndex'),
	        id: seriesModel.get('parallelId')
	      })[0];
	      seriesModel.coordinateSystem = parallelModel.coordinateSystem;
	    }
	  });
	  return coordSysList;
	}
	
	CoordinateSystem.register('parallel', {
	  create: create
	});

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {Object} opt {labelInside}
	 * @return {Object} {
	 *  position, rotation, labelDirection, labelOffset,
	 *  tickDirection, labelRotate, z2
	 * }
	 */
	function layout(axisModel, opt) {
	  opt = opt || {};
	  var single = axisModel.coordinateSystem;
	  var axis = axisModel.axis;
	  var layout = {};
	  var axisPosition = axis.position;
	  var orient = axis.orient;
	  var rect = single.getRect();
	  var rectBound = [rect.x, rect.x + rect.width, rect.y, rect.y + rect.height];
	  var positionMap = {
	    horizontal: {
	      top: rectBound[2],
	      bottom: rectBound[3]
	    },
	    vertical: {
	      left: rectBound[0],
	      right: rectBound[1]
	    }
	  };
	  layout.position = [orient === 'vertical' ? positionMap.vertical[axisPosition] : rectBound[0], orient === 'horizontal' ? positionMap.horizontal[axisPosition] : rectBound[3]];
	  var r = {
	    horizontal: 0,
	    vertical: 1
	  };
	  layout.rotation = Math.PI / 2 * r[orient];
	  var directionMap = {
	    top: -1,
	    bottom: 1,
	    right: 1,
	    left: -1
	  };
	  layout.labelDirection = layout.tickDirection = layout.nameDirection = directionMap[axisPosition];
	
	  if (axisModel.get('axisTick.inside')) {
	    layout.tickDirection = -layout.tickDirection;
	  }
	
	  if (zrUtil.retrieve(opt.labelInside, axisModel.get('axisLabel.inside'))) {
	    layout.labelDirection = -layout.labelDirection;
	  }
	
	  var labelRotation = opt.rotate;
	  labelRotation == null && (labelRotation = axisModel.get('axisLabel.rotate'));
	  layout.labelRotation = axisPosition === 'top' ? -labelRotation : labelRotation;
	  layout.z2 = 1;
	  return layout;
	}
	
	exports.layout = layout;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @class
	 * @param {Object|DataDimensionInfo} [opt] All of the fields will be shallow copied.
	 */
	function DataDimensionInfo(opt) {
	  if (opt != null) {
	    zrUtil.extend(this, opt);
	  }
	  /**
	   * Dimension name.
	   * Mandatory.
	   * @type {string}
	   */
	  // this.name;
	
	  /**
	   * The origin name in dimsDef, see source helper.
	   * If displayName given, the tooltip will displayed vertically.
	   * Optional.
	   * @type {string}
	   */
	  // this.displayName;
	
	  /**
	   * Which coordSys dimension this dimension mapped to.
	   * A `coordDim` can be a "coordSysDim" that the coordSys required
	   * (for example, an item in `coordSysDims` of `model/referHelper#CoordSysInfo`),
	   * or an generated "extra coord name" if does not mapped to any "coordSysDim"
	   * (That is determined by whether `isExtraCoord` is `true`).
	   * Mandatory.
	   * @type {string}
	   */
	  // this.coordDim;
	
	  /**
	   * The index of this dimension in `series.encode[coordDim]`.
	   * Mandatory.
	   * @type {number}
	   */
	  // this.coordDimIndex;
	
	  /**
	   * Dimension type. The enumerable values are the key of
	   * `dataCtors` of `data/List`.
	   * Optional.
	   * @type {string}
	   */
	  // this.type;
	
	  /**
	   * This index of this dimension info in `data/List#_dimensionInfos`.
	   * Mandatory after added to `data/List`.
	   * @type {number}
	   */
	  // this.index;
	
	  /**
	   * The format of `otherDims` is:
	   * ```js
	   * {
	   *     tooltip: number optional,
	   *     label: number optional,
	   *     itemName: number optional,
	   *     seriesName: number optional,
	   * }
	   * ```
	   *
	   * A `series.encode` can specified these fields:
	   * ```js
	   * encode: {
	   *     // "3, 1, 5" is the index of data dimension.
	   *     tooltip: [3, 1, 5],
	   *     label: [0, 3],
	   *     ...
	   * }
	   * ```
	   * `otherDims` is the parse result of the `series.encode` above, like:
	   * ```js
	   * // Suppose the index of this data dimension is `3`.
	   * this.otherDims = {
	   *     // `3` is at the index `0` of the `encode.tooltip`
	   *     tooltip: 0,
	   *     // `3` is at the index `1` of the `encode.tooltip`
	   *     label: 1
	   * };
	   * ```
	   *
	   * This prop should never be `null`/`undefined` after initialized.
	   * @type {Object}
	   */
	
	
	  this.otherDims = {};
	  /**
	   * Be `true` if this dimension is not mapped to any "coordSysDim" that the
	   * "coordSys" required.
	   * Mandatory.
	   * @type {boolean}
	   */
	  // this.isExtraCoord;
	
	  /**
	   * @type {module:data/OrdinalMeta}
	   */
	  // this.ordinalMeta;
	
	  /**
	   * Whether to create inverted indices.
	   * @type {boolean}
	   */
	  // this.createInvertedIndices;
	}
	
	;
	var _default = DataDimensionInfo;
	module.exports = _default;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var createHashMap = _util.createHashMap;
	var isObject = _util.isObject;
	var map = _util.map;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor
	 * @param {Object} [opt]
	 * @param {Object} [opt.categories=[]]
	 * @param {Object} [opt.needCollect=false]
	 * @param {Object} [opt.deduplication=false]
	 */
	function OrdinalMeta(opt) {
	  /**
	   * @readOnly
	   * @type {Array.<string>}
	   */
	  this.categories = opt.categories || [];
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._needCollect = opt.needCollect;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._deduplication = opt.deduplication;
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._map;
	}
	/**
	 * @param {module:echarts/model/Model} axisModel
	 * @return {module:echarts/data/OrdinalMeta}
	 */
	
	
	OrdinalMeta.createByAxisModel = function (axisModel) {
	  var option = axisModel.option;
	  var data = option.data;
	  var categories = data && map(data, getName);
	  return new OrdinalMeta({
	    categories: categories,
	    needCollect: !categories,
	    // deduplication is default in axis.
	    deduplication: option.dedplication !== false
	  });
	};
	
	var proto = OrdinalMeta.prototype;
	/**
	 * @param {string} category
	 * @return {number} ordinal
	 */
	
	proto.getOrdinal = function (category) {
	  return getOrCreateMap(this).get(category);
	};
	/**
	 * @param {*} category
	 * @return {number} The ordinal. If not found, return NaN.
	 */
	
	
	proto.parseAndCollect = function (category) {
	  var index;
	  var needCollect = this._needCollect; // The value of category dim can be the index of the given category set.
	  // This feature is only supported when !needCollect, because we should
	  // consider a common case: a value is 2017, which is a number but is
	  // expected to be tread as a category. This case usually happen in dataset,
	  // where it happent to be no need of the index feature.
	
	  if (typeof category !== 'string' && !needCollect) {
	    return category;
	  } // Optimize for the scenario:
	  // category is ['2012-01-01', '2012-01-02', ...], where the input
	  // data has been ensured not duplicate and is large data.
	  // Notice, if a dataset dimension provide categroies, usually echarts
	  // should remove duplication except user tell echarts dont do that
	  // (set axis.deduplication = false), because echarts do not know whether
	  // the values in the category dimension has duplication (consider the
	  // parallel-aqi example)
	
	
	  if (needCollect && !this._deduplication) {
	    index = this.categories.length;
	    this.categories[index] = category;
	    return index;
	  }
	
	  var map = getOrCreateMap(this);
	  index = map.get(category);
	
	  if (index == null) {
	    if (needCollect) {
	      index = this.categories.length;
	      this.categories[index] = category;
	      map.set(category, index);
	    } else {
	      index = NaN;
	    }
	  }
	
	  return index;
	}; // Consider big data, do not create map until needed.
	
	
	function getOrCreateMap(ordinalMeta) {
	  return ordinalMeta._map || (ordinalMeta._map = createHashMap(ordinalMeta.categories));
	}
	
	function getName(obj) {
	  if (isObject(obj) && obj.value != null) {
	    return obj.value;
	  } else {
	    return obj + '';
	  }
	}
	
	var _default = OrdinalMeta;
	module.exports = _default;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	var isString = _util.isString;
	var defaults = _util.defaults;
	var extend = _util.extend;
	var isObject = _util.isObject;
	var clone = _util.clone;
	
	var _model = __webpack_require__(29);
	
	var normalizeToArray = _model.normalizeToArray;
	
	var _sourceHelper = __webpack_require__(160);
	
	var guessOrdinal = _sourceHelper.guessOrdinal;
	var BE_ORDINAL = _sourceHelper.BE_ORDINAL;
	
	var Source = __webpack_require__(292);
	
	var _dimensionHelper = __webpack_require__(293);
	
	var OTHER_DIMENSIONS = _dimensionHelper.OTHER_DIMENSIONS;
	
	var DataDimensionInfo = __webpack_require__(869);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @deprecated
	 * Use `echarts/data/helper/createDimensions` instead.
	 */
	
	/**
	 * @see {module:echarts/test/ut/spec/data/completeDimensions}
	 *
	 * This method builds the relationship between:
	 * + "what the coord sys or series requires (see `sysDims`)",
	 * + "what the user defines (in `encode` and `dimensions`, see `opt.dimsDef` and `opt.encodeDef`)"
	 * + "what the data source provids (see `source`)".
	 *
	 * Some guess strategy will be adapted if user does not define something.
	 * If no 'value' dimension specified, the first no-named dimension will be
	 * named as 'value'.
	 *
	 * @param {Array.<string>} sysDims Necessary dimensions, like ['x', 'y'], which
	 *      provides not only dim template, but also default order.
	 *      properties: 'name', 'type', 'displayName'.
	 *      `name` of each item provides default coord name.
	 *      [{dimsDef: [string|Object, ...]}, ...] dimsDef of sysDim item provides default dim name, and
	 *                                    provide dims count that the sysDim required.
	 *      [{ordinalMeta}] can be specified.
	 * @param {module:echarts/data/Source|Array|Object} source or data (for compatibal with pervious)
	 * @param {Object} [opt]
	 * @param {Array.<Object|string>} [opt.dimsDef] option.series.dimensions User defined dimensions
	 *      For example: ['asdf', {name, type}, ...].
	 * @param {Object|HashMap} [opt.encodeDef] option.series.encode {x: 2, y: [3, 1], tooltip: [1, 2], label: 3}
	 * @param {Function} [opt.encodeDefaulter] Called if no `opt.encodeDef` exists.
	 *      If not specified, auto find the next available data dim.
	 *      param source {module:data/Source}
	 *      param dimCount {number}
	 *      return {Object} encode Never be `null/undefined`.
	 * @param {string} [opt.generateCoord] Generate coord dim with the given name.
	 *      If not specified, extra dim names will be:
	 *      'value', 'value0', 'value1', ...
	 * @param {number} [opt.generateCoordCount] By default, the generated dim name is `generateCoord`.
	 *      If `generateCoordCount` specified, the generated dim names will be:
	 *      `generateCoord` + 0, `generateCoord` + 1, ...
	 *      can be Infinity, indicate that use all of the remain columns.
	 * @param {number} [opt.dimCount] If not specified, guess by the first data item.
	 * @return {Array.<module:data/DataDimensionInfo>}
	 */
	function completeDimensions(sysDims, source, opt) {
	  if (!Source.isInstance(source)) {
	    source = Source.seriesDataToSource(source);
	  }
	
	  opt = opt || {};
	  sysDims = (sysDims || []).slice();
	  var dimsDef = (opt.dimsDef || []).slice();
	  var dataDimNameMap = createHashMap();
	  var coordDimNameMap = createHashMap(); // var valueCandidate;
	
	  var result = [];
	  var dimCount = getDimCount(source, sysDims, dimsDef, opt.dimCount); // Apply user defined dims (`name` and `type`) and init result.
	
	  for (var i = 0; i < dimCount; i++) {
	    var dimDefItem = dimsDef[i] = extend({}, isObject(dimsDef[i]) ? dimsDef[i] : {
	      name: dimsDef[i]
	    });
	    var userDimName = dimDefItem.name;
	    var resultItem = result[i] = new DataDimensionInfo(); // Name will be applied later for avoiding duplication.
	
	    if (userDimName != null && dataDimNameMap.get(userDimName) == null) {
	      // Only if `series.dimensions` is defined in option
	      // displayName, will be set, and dimension will be diplayed vertically in
	      // tooltip by default.
	      resultItem.name = resultItem.displayName = userDimName;
	      dataDimNameMap.set(userDimName, i);
	    }
	
	    dimDefItem.type != null && (resultItem.type = dimDefItem.type);
	    dimDefItem.displayName != null && (resultItem.displayName = dimDefItem.displayName);
	  }
	
	  var encodeDef = opt.encodeDef;
	
	  if (!encodeDef && opt.encodeDefaulter) {
	    encodeDef = opt.encodeDefaulter(source, dimCount);
	  }
	
	  encodeDef = createHashMap(encodeDef); // Set `coordDim` and `coordDimIndex` by `encodeDef` and normalize `encodeDef`.
	
	  encodeDef.each(function (dataDims, coordDim) {
	    dataDims = normalizeToArray(dataDims).slice(); // Note: It is allowed that `dataDims.length` is `0`, e.g., options is
	    // `{encode: {x: -1, y: 1}}`. Should not filter anything in
	    // this case.
	
	    if (dataDims.length === 1 && !isString(dataDims[0]) && dataDims[0] < 0) {
	      encodeDef.set(coordDim, false);
	      return;
	    }
	
	    var validDataDims = encodeDef.set(coordDim, []);
	    each(dataDims, function (resultDimIdx, idx) {
	      // The input resultDimIdx can be dim name or index.
	      isString(resultDimIdx) && (resultDimIdx = dataDimNameMap.get(resultDimIdx));
	
	      if (resultDimIdx != null && resultDimIdx < dimCount) {
	        validDataDims[idx] = resultDimIdx;
	        applyDim(result[resultDimIdx], coordDim, idx);
	      }
	    });
	  }); // Apply templetes and default order from `sysDims`.
	
	  var availDimIdx = 0;
	  each(sysDims, function (sysDimItem, sysDimIndex) {
	    var coordDim;
	    var sysDimItem;
	    var sysDimItemDimsDef;
	    var sysDimItemOtherDims;
	
	    if (isString(sysDimItem)) {
	      coordDim = sysDimItem;
	      sysDimItem = {};
	    } else {
	      coordDim = sysDimItem.name;
	      var ordinalMeta = sysDimItem.ordinalMeta;
	      sysDimItem.ordinalMeta = null;
	      sysDimItem = clone(sysDimItem);
	      sysDimItem.ordinalMeta = ordinalMeta; // `coordDimIndex` should not be set directly.
	
	      sysDimItemDimsDef = sysDimItem.dimsDef;
	      sysDimItemOtherDims = sysDimItem.otherDims;
	      sysDimItem.name = sysDimItem.coordDim = sysDimItem.coordDimIndex = sysDimItem.dimsDef = sysDimItem.otherDims = null;
	    }
	
	    var dataDims = encodeDef.get(coordDim); // negative resultDimIdx means no need to mapping.
	
	    if (dataDims === false) {
	      return;
	    }
	
	    var dataDims = normalizeToArray(dataDims); // dimensions provides default dim sequences.
	
	    if (!dataDims.length) {
	      for (var i = 0; i < (sysDimItemDimsDef && sysDimItemDimsDef.length || 1); i++) {
	        while (availDimIdx < result.length && result[availDimIdx].coordDim != null) {
	          availDimIdx++;
	        }
	
	        availDimIdx < result.length && dataDims.push(availDimIdx++);
	      }
	    } // Apply templates.
	
	
	    each(dataDims, function (resultDimIdx, coordDimIndex) {
	      var resultItem = result[resultDimIdx];
	      applyDim(defaults(resultItem, sysDimItem), coordDim, coordDimIndex);
	
	      if (resultItem.name == null && sysDimItemDimsDef) {
	        var sysDimItemDimsDefItem = sysDimItemDimsDef[coordDimIndex];
	        !isObject(sysDimItemDimsDefItem) && (sysDimItemDimsDefItem = {
	          name: sysDimItemDimsDefItem
	        });
	        resultItem.name = resultItem.displayName = sysDimItemDimsDefItem.name;
	        resultItem.defaultTooltip = sysDimItemDimsDefItem.defaultTooltip;
	      } // FIXME refactor, currently only used in case: {otherDims: {tooltip: false}}
	
	
	      sysDimItemOtherDims && defaults(resultItem.otherDims, sysDimItemOtherDims);
	    });
	  });
	
	  function applyDim(resultItem, coordDim, coordDimIndex) {
	    if (OTHER_DIMENSIONS.get(coordDim) != null) {
	      resultItem.otherDims[coordDim] = coordDimIndex;
	    } else {
	      resultItem.coordDim = coordDim;
	      resultItem.coordDimIndex = coordDimIndex;
	      coordDimNameMap.set(coordDim, true);
	    }
	  } // Make sure the first extra dim is 'value'.
	
	
	  var generateCoord = opt.generateCoord;
	  var generateCoordCount = opt.generateCoordCount;
	  var fromZero = generateCoordCount != null;
	  generateCoordCount = generateCoord ? generateCoordCount || 1 : 0;
	  var extra = generateCoord || 'value'; // Set dim `name` and other `coordDim` and other props.
	
	  for (var resultDimIdx = 0; resultDimIdx < dimCount; resultDimIdx++) {
	    var resultItem = result[resultDimIdx] = result[resultDimIdx] || new DataDimensionInfo();
	    var coordDim = resultItem.coordDim;
	
	    if (coordDim == null) {
	      resultItem.coordDim = genName(extra, coordDimNameMap, fromZero);
	      resultItem.coordDimIndex = 0;
	
	      if (!generateCoord || generateCoordCount <= 0) {
	        resultItem.isExtraCoord = true;
	      }
	
	      generateCoordCount--;
	    }
	
	    resultItem.name == null && (resultItem.name = genName(resultItem.coordDim, dataDimNameMap));
	
	    if (resultItem.type == null && (guessOrdinal(source, resultDimIdx, resultItem.name) === BE_ORDINAL.Must // Consider the case:
	    // {
	    //    dataset: {source: [
	    //        ['2001', 123],
	    //        ['2002', 456],
	    //        ...
	    //        ['The others', 987],
	    //    ]},
	    //    series: {type: 'pie'}
	    // }
	    // The first colum should better be treated as a "ordinal" although it
	    // might not able to be detected as an "ordinal" by `guessOrdinal`.
	    || resultItem.isExtraCoord && (resultItem.otherDims.itemName != null || resultItem.otherDims.seriesName != null))) {
	      resultItem.type = 'ordinal';
	    }
	  }
	
	  return result;
	} // ??? TODO
	// Originally detect dimCount by data[0]. Should we
	// optimize it to only by sysDims and dimensions and encode.
	// So only necessary dims will be initialized.
	// But
	// (1) custom series should be considered. where other dims
	// may be visited.
	// (2) sometimes user need to calcualte bubble size or use visualMap
	// on other dimensions besides coordSys needed.
	// So, dims that is not used by system, should be shared in storage?
	
	
	function getDimCount(source, sysDims, dimsDef, optDimCount) {
	  // Note that the result dimCount should not small than columns count
	  // of data, otherwise `dataDimNameMap` checking will be incorrect.
	  var dimCount = Math.max(source.dimensionsDetectCount || 1, sysDims.length, dimsDef.length, optDimCount || 0);
	  each(sysDims, function (sysDimItem) {
	    var sysDimItemDimsDef = sysDimItem.dimsDef;
	    sysDimItemDimsDef && (dimCount = Math.max(dimCount, sysDimItemDimsDef.length));
	  });
	  return dimCount;
	}
	
	function genName(name, map, fromZero) {
	  if (fromZero || map.get(name) != null) {
	    var i = 0;
	
	    while (map.get(name + i) != null) {
	      i++;
	    }
	
	    name += i;
	  }
	
	  map.set(name, true);
	  return name;
	}
	
	var _default = completeDimensions;
	module.exports = _default;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Link lists and struct (graph or tree)
	 */
	var each = zrUtil.each;
	var DATAS = '\0__link_datas';
	var MAIN_DATA = '\0__link_mainData'; // Caution:
	// In most case, either list or its shallow clones (see list.cloneShallow)
	// is active in echarts process. So considering heap memory consumption,
	// we do not clone tree or graph, but share them among list and its shallow clones.
	// But in some rare case, we have to keep old list (like do animation in chart). So
	// please take care that both the old list and the new list share the same tree/graph.
	
	/**
	 * @param {Object} opt
	 * @param {module:echarts/data/List} opt.mainData
	 * @param {Object} [opt.struct] For example, instance of Graph or Tree.
	 * @param {string} [opt.structAttr] designation: list[structAttr] = struct;
	 * @param {Object} [opt.datas] {dataType: data},
	 *                 like: {node: nodeList, edge: edgeList}.
	 *                 Should contain mainData.
	 * @param {Object} [opt.datasAttr] {dataType: attr},
	 *                 designation: struct[datasAttr[dataType]] = list;
	 */
	
	function linkList(opt) {
	  var mainData = opt.mainData;
	  var datas = opt.datas;
	
	  if (!datas) {
	    datas = {
	      main: mainData
	    };
	    opt.datasAttr = {
	      main: 'data'
	    };
	  }
	
	  opt.datas = opt.mainData = null;
	  linkAll(mainData, datas, opt); // Porxy data original methods.
	
	  each(datas, function (data) {
	    each(mainData.TRANSFERABLE_METHODS, function (methodName) {
	      data.wrapMethod(methodName, zrUtil.curry(transferInjection, opt));
	    });
	  }); // Beyond transfer, additional features should be added to `cloneShallow`.
	
	  mainData.wrapMethod('cloneShallow', zrUtil.curry(cloneShallowInjection, opt)); // Only mainData trigger change, because struct.update may trigger
	  // another changable methods, which may bring about dead lock.
	
	  each(mainData.CHANGABLE_METHODS, function (methodName) {
	    mainData.wrapMethod(methodName, zrUtil.curry(changeInjection, opt));
	  }); // Make sure datas contains mainData.
	
	  zrUtil.assert(datas[mainData.dataType] === mainData);
	}
	
	function transferInjection(opt, res) {
	  if (isMainData(this)) {
	    // Transfer datas to new main data.
	    var datas = zrUtil.extend({}, this[DATAS]);
	    datas[this.dataType] = res;
	    linkAll(res, datas, opt);
	  } else {
	    // Modify the reference in main data to point newData.
	    linkSingle(res, this.dataType, this[MAIN_DATA], opt);
	  }
	
	  return res;
	}
	
	function changeInjection(opt, res) {
	  opt.struct && opt.struct.update(this);
	  return res;
	}
	
	function cloneShallowInjection(opt, res) {
	  // cloneShallow, which brings about some fragilities, may be inappropriate
	  // to be exposed as an API. So for implementation simplicity we can make
	  // the restriction that cloneShallow of not-mainData should not be invoked
	  // outside, but only be invoked here.
	  each(res[DATAS], function (data, dataType) {
	    data !== res && linkSingle(data.cloneShallow(), dataType, res, opt);
	  });
	  return res;
	}
	/**
	 * Supplement method to List.
	 *
	 * @public
	 * @param {string} [dataType] If not specified, return mainData.
	 * @return {module:echarts/data/List}
	 */
	
	
	function getLinkedData(dataType) {
	  var mainData = this[MAIN_DATA];
	  return dataType == null || mainData == null ? mainData : mainData[DATAS][dataType];
	}
	
	function isMainData(data) {
	  return data[MAIN_DATA] === data;
	}
	
	function linkAll(mainData, datas, opt) {
	  mainData[DATAS] = {};
	  each(datas, function (data, dataType) {
	    linkSingle(data, dataType, mainData, opt);
	  });
	}
	
	function linkSingle(data, dataType, mainData, opt) {
	  mainData[DATAS][dataType] = data;
	  data[MAIN_DATA] = mainData;
	  data.dataType = dataType;
	
	  if (opt.struct) {
	    data[opt.structAttr] = opt.struct;
	    opt.struct[opt.datasAttr[dataType]] = data;
	  } // Supplement method.
	
	
	  data.getLinkedData = getLinkedData;
	}
	
	var _default = linkList;
	module.exports = _default;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrender = __webpack_require__(397);
	
	exports.zrender = zrender;
	
	var matrix = __webpack_require__(86);
	
	exports.matrix = matrix;
	
	var vector = __webpack_require__(55);
	
	exports.vector = vector;
	
	var zrUtil = __webpack_require__(4);
	
	var colorTool = __webpack_require__(148);
	
	exports.color = colorTool;
	
	var graphicUtil = __webpack_require__(14);
	
	var numberUtil = __webpack_require__(25);
	
	exports.number = numberUtil;
	
	var formatUtil = __webpack_require__(48);
	
	exports.format = formatUtil;
	
	var _throttle = __webpack_require__(181);
	
	var throttle = _throttle.throttle;
	exports.throttle = _throttle.throttle;
	
	var ecHelper = __webpack_require__(2434);
	
	exports.helper = ecHelper;
	
	var parseGeoJSON = __webpack_require__(866);
	
	exports.parseGeoJSON = parseGeoJSON;
	
	var _List = __webpack_require__(109);
	
	exports.List = _List;
	
	var _Model = __webpack_require__(70);
	
	exports.Model = _Model;
	
	var _Axis = __webpack_require__(179);
	
	exports.Axis = _Axis;
	
	var _env = __webpack_require__(73);
	
	exports.env = _env;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Do not mount those modules on 'src/echarts' for better tree shaking.
	 */
	var parseGeoJson = parseGeoJSON;
	var ecUtil = {};
	zrUtil.each(['map', 'each', 'filter', 'indexOf', 'inherits', 'reduce', 'filter', 'bind', 'curry', 'isArray', 'isString', 'isObject', 'isFunction', 'extend', 'defaults', 'clone', 'merge'], function (name) {
	  ecUtil[name] = zrUtil[name];
	});
	var graphic = {};
	zrUtil.each(['extendShape', 'extendPath', 'makePath', 'makeImage', 'mergePath', 'resizePath', 'createIcon', 'setHoverStyle', 'setLabelStyle', 'setTextStyle', 'setText', 'getFont', 'updateProps', 'initProps', 'getTransform', 'clipPointsByRect', 'clipRectByRect', 'registerShape', 'getShapeClass', 'Group', 'Image', 'Text', 'Circle', 'Sector', 'Ring', 'Polygon', 'Polyline', 'Rect', 'Line', 'BezierCurve', 'Arc', 'IncrementalDisplayable', 'CompoundPath', 'LinearGradient', 'RadialGradient', 'BoundingRect'], function (name) {
	  graphic[name] = graphicUtil[name];
	});
	exports.parseGeoJson = parseGeoJson;
	exports.util = ecUtil;
	exports.graphic = graphic;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	var filter = _util.filter;
	var map = _util.map;
	var isArray = _util.isArray;
	var indexOf = _util.indexOf;
	var isObject = _util.isObject;
	var isString = _util.isString;
	var createHashMap = _util.createHashMap;
	var assert = _util.assert;
	var clone = _util.clone;
	var merge = _util.merge;
	var extend = _util.extend;
	var mixin = _util.mixin;
	
	var modelUtil = __webpack_require__(29);
	
	var Model = __webpack_require__(70);
	
	var ComponentModel = __webpack_require__(76);
	
	var globalDefault = __webpack_require__(2438);
	
	var colorPaletteMixin = __webpack_require__(875);
	
	var _sourceHelper = __webpack_require__(160);
	
	var resetSourceDefaulter = _sourceHelper.resetSourceDefaulter;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * ECharts global model
	 *
	 * @module {echarts/model/Global}
	 */
	
	/**
	 * Caution: If the mechanism should be changed some day, these cases
	 * should be considered:
	 *
	 * (1) In `merge option` mode, if using the same option to call `setOption`
	 * many times, the result should be the same (try our best to ensure that).
	 * (2) In `merge option` mode, if a component has no id/name specified, it
	 * will be merged by index, and the result sequence of the components is
	 * consistent to the original sequence.
	 * (3) `reset` feature (in toolbox). Find detailed info in comments about
	 * `mergeOption` in module:echarts/model/OptionManager.
	 */
	var OPTION_INNER_KEY = '\0_ec_inner';
	/**
	 * @alias module:echarts/model/Global
	 *
	 * @param {Object} option
	 * @param {module:echarts/model/Model} parentModel
	 * @param {Object} theme
	 */
	
	var GlobalModel = Model.extend({
	  init: function (option, parentModel, theme, optionManager) {
	    theme = theme || {};
	    this.option = null; // Mark as not initialized.
	
	    /**
	     * @type {module:echarts/model/Model}
	     * @private
	     */
	
	    this._theme = new Model(theme);
	    /**
	     * @type {module:echarts/model/OptionManager}
	     */
	
	    this._optionManager = optionManager;
	  },
	  setOption: function (option, optionPreprocessorFuncs) {
	    assert(!(OPTION_INNER_KEY in option), 'please use chart.getOption()');
	
	    this._optionManager.setOption(option, optionPreprocessorFuncs);
	
	    this.resetOption(null);
	  },
	
	  /**
	   * @param {string} type null/undefined: reset all.
	   *                      'recreate': force recreate all.
	   *                      'timeline': only reset timeline option
	   *                      'media': only reset media query option
	   * @return {boolean} Whether option changed.
	   */
	  resetOption: function (type) {
	    var optionChanged = false;
	    var optionManager = this._optionManager;
	
	    if (!type || type === 'recreate') {
	      var baseOption = optionManager.mountOption(type === 'recreate');
	
	      if (!this.option || type === 'recreate') {
	        initBase.call(this, baseOption);
	      } else {
	        this.restoreData();
	        this.mergeOption(baseOption);
	      }
	
	      optionChanged = true;
	    }
	
	    if (type === 'timeline' || type === 'media') {
	      this.restoreData();
	    }
	
	    if (!type || type === 'recreate' || type === 'timeline') {
	      var timelineOption = optionManager.getTimelineOption(this);
	      timelineOption && (this.mergeOption(timelineOption), optionChanged = true);
	    }
	
	    if (!type || type === 'recreate' || type === 'media') {
	      var mediaOptions = optionManager.getMediaOption(this, this._api);
	
	      if (mediaOptions.length) {
	        each(mediaOptions, function (mediaOption) {
	          this.mergeOption(mediaOption, optionChanged = true);
	        }, this);
	      }
	    }
	
	    return optionChanged;
	  },
	
	  /**
	   * @protected
	   */
	  mergeOption: function (newOption) {
	    var option = this.option;
	    var componentsMap = this._componentsMap;
	    var newCptTypes = [];
	    resetSourceDefaulter(this); // If no component class, merge directly.
	    // For example: color, animaiton options, etc.
	
	    each(newOption, function (componentOption, mainType) {
	      if (componentOption == null) {
	        return;
	      }
	
	      if (!ComponentModel.hasClass(mainType)) {
	        // globalSettingTask.dirty();
	        option[mainType] = option[mainType] == null ? clone(componentOption) : merge(option[mainType], componentOption, true);
	      } else if (mainType) {
	        newCptTypes.push(mainType);
	      }
	    });
	    ComponentModel.topologicalTravel(newCptTypes, ComponentModel.getAllClassMainTypes(), visitComponent, this);
	
	    function visitComponent(mainType, dependencies) {
	      var newCptOptionList = modelUtil.normalizeToArray(newOption[mainType]);
	      var mapResult = modelUtil.mappingToExists(componentsMap.get(mainType), newCptOptionList);
	      modelUtil.makeIdAndName(mapResult); // Set mainType and complete subType.
	
	      each(mapResult, function (item, index) {
	        var opt = item.option;
	
	        if (isObject(opt)) {
	          item.keyInfo.mainType = mainType;
	          item.keyInfo.subType = determineSubType(mainType, opt, item.exist);
	        }
	      });
	      var dependentModels = getComponentsByTypes(componentsMap, dependencies);
	      option[mainType] = [];
	      componentsMap.set(mainType, []);
	      each(mapResult, function (resultItem, index) {
	        var componentModel = resultItem.exist;
	        var newCptOption = resultItem.option;
	        assert(isObject(newCptOption) || componentModel, 'Empty component definition'); // Consider where is no new option and should be merged using {},
	        // see removeEdgeAndAdd in topologicalTravel and
	        // ComponentModel.getAllClassMainTypes.
	
	        if (!newCptOption) {
	          componentModel.mergeOption({}, this);
	          componentModel.optionUpdated({}, false);
	        } else {
	          var ComponentModelClass = ComponentModel.getClass(mainType, resultItem.keyInfo.subType, true);
	
	          if (componentModel && componentModel.constructor === ComponentModelClass) {
	            componentModel.name = resultItem.keyInfo.name; // componentModel.settingTask && componentModel.settingTask.dirty();
	
	            componentModel.mergeOption(newCptOption, this);
	            componentModel.optionUpdated(newCptOption, false);
	          } else {
	            // PENDING Global as parent ?
	            var extraOpt = extend({
	              dependentModels: dependentModels,
	              componentIndex: index
	            }, resultItem.keyInfo);
	            componentModel = new ComponentModelClass(newCptOption, this, this, extraOpt);
	            extend(componentModel, extraOpt);
	            componentModel.init(newCptOption, this, this, extraOpt); // Call optionUpdated after init.
	            // newCptOption has been used as componentModel.option
	            // and may be merged with theme and default, so pass null
	            // to avoid confusion.
	
	            componentModel.optionUpdated(null, true);
	          }
	        }
	
	        componentsMap.get(mainType)[index] = componentModel;
	        option[mainType][index] = componentModel.option;
	      }, this); // Backup series for filtering.
	
	      if (mainType === 'series') {
	        createSeriesIndices(this, componentsMap.get('series'));
	      }
	    }
	
	    this._seriesIndicesMap = createHashMap(this._seriesIndices = this._seriesIndices || []);
	  },
	
	  /**
	   * Get option for output (cloned option and inner info removed)
	   * @public
	   * @return {Object}
	   */
	  getOption: function () {
	    var option = clone(this.option);
	    each(option, function (opts, mainType) {
	      if (ComponentModel.hasClass(mainType)) {
	        var opts = modelUtil.normalizeToArray(opts);
	
	        for (var i = opts.length - 1; i >= 0; i--) {
	          // Remove options with inner id.
	          if (modelUtil.isIdInner(opts[i])) {
	            opts.splice(i, 1);
	          }
	        }
	
	        option[mainType] = opts;
	      }
	    });
	    delete option[OPTION_INNER_KEY];
	    return option;
	  },
	
	  /**
	   * @return {module:echarts/model/Model}
	   */
	  getTheme: function () {
	    return this._theme;
	  },
	
	  /**
	   * @param {string} mainType
	   * @param {number} [idx=0]
	   * @return {module:echarts/model/Component}
	   */
	  getComponent: function (mainType, idx) {
	    var list = this._componentsMap.get(mainType);
	
	    if (list) {
	      return list[idx || 0];
	    }
	  },
	
	  /**
	   * If none of index and id and name used, return all components with mainType.
	   * @param {Object} condition
	   * @param {string} condition.mainType
	   * @param {string} [condition.subType] If ignore, only query by mainType
	   * @param {number|Array.<number>} [condition.index] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.id] Either input index or id or name.
	   * @param {string|Array.<string>} [condition.name] Either input index or id or name.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  queryComponents: function (condition) {
	    var mainType = condition.mainType;
	
	    if (!mainType) {
	      return [];
	    }
	
	    var index = condition.index;
	    var id = condition.id;
	    var name = condition.name;
	
	    var cpts = this._componentsMap.get(mainType);
	
	    if (!cpts || !cpts.length) {
	      return [];
	    }
	
	    var result;
	
	    if (index != null) {
	      if (!isArray(index)) {
	        index = [index];
	      }
	
	      result = filter(map(index, function (idx) {
	        return cpts[idx];
	      }), function (val) {
	        return !!val;
	      });
	    } else if (id != null) {
	      var isIdArray = isArray(id);
	      result = filter(cpts, function (cpt) {
	        return isIdArray && indexOf(id, cpt.id) >= 0 || !isIdArray && cpt.id === id;
	      });
	    } else if (name != null) {
	      var isNameArray = isArray(name);
	      result = filter(cpts, function (cpt) {
	        return isNameArray && indexOf(name, cpt.name) >= 0 || !isNameArray && cpt.name === name;
	      });
	    } else {
	      // Return all components with mainType
	      result = cpts.slice();
	    }
	
	    return filterBySubType(result, condition);
	  },
	
	  /**
	   * The interface is different from queryComponents,
	   * which is convenient for inner usage.
	   *
	   * @usage
	   * var result = findComponents(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}}
	   * );
	   * var result = findComponents(
	   *     {mainType: 'series',
	   *     filter: function (model, index) {...}}
	   * );
	   * // result like [component0, componnet1, ...]
	   *
	   * @param {Object} condition
	   * @param {string} condition.mainType Mandatory.
	   * @param {string} [condition.subType] Optional.
	   * @param {Object} [condition.query] like {xxxIndex, xxxId, xxxName},
	   *        where xxx is mainType.
	   *        If query attribute is null/undefined or has no index/id/name,
	   *        do not filtering by query conditions, which is convenient for
	   *        no-payload situations or when target of action is global.
	   * @param {Function} [condition.filter] parameter: component, return boolean.
	   * @return {Array.<module:echarts/model/Component>}
	   */
	  findComponents: function (condition) {
	    var query = condition.query;
	    var mainType = condition.mainType;
	    var queryCond = getQueryCond(query);
	    var result = queryCond ? this.queryComponents(queryCond) : this._componentsMap.get(mainType);
	    return doFilter(filterBySubType(result, condition));
	
	    function getQueryCond(q) {
	      var indexAttr = mainType + 'Index';
	      var idAttr = mainType + 'Id';
	      var nameAttr = mainType + 'Name';
	      return q && (q[indexAttr] != null || q[idAttr] != null || q[nameAttr] != null) ? {
	        mainType: mainType,
	        // subType will be filtered finally.
	        index: q[indexAttr],
	        id: q[idAttr],
	        name: q[nameAttr]
	      } : null;
	    }
	
	    function doFilter(res) {
	      return condition.filter ? filter(res, condition.filter) : res;
	    }
	  },
	
	  /**
	   * @usage
	   * eachComponent('legend', function (legendModel, index) {
	   *     ...
	   * });
	   * eachComponent(function (componentType, model, index) {
	   *     // componentType does not include subType
	   *     // (componentType is 'xxx' but not 'xxx.aa')
	   * });
	   * eachComponent(
	   *     {mainType: 'dataZoom', query: {dataZoomId: 'abc'}},
	   *     function (model, index) {...}
	   * );
	   * eachComponent(
	   *     {mainType: 'series', subType: 'pie', query: {seriesName: 'uio'}},
	   *     function (model, index) {...}
	   * );
	   *
	   * @param {string|Object=} mainType When mainType is object, the definition
	   *                                  is the same as the method 'findComponents'.
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachComponent: function (mainType, cb, context) {
	    var componentsMap = this._componentsMap;
	
	    if (typeof mainType === 'function') {
	      context = cb;
	      cb = mainType;
	      componentsMap.each(function (components, componentType) {
	        each(components, function (component, index) {
	          cb.call(context, componentType, component, index);
	        });
	      });
	    } else if (isString(mainType)) {
	      each(componentsMap.get(mainType), cb, context);
	    } else if (isObject(mainType)) {
	      var queryResult = this.findComponents(mainType);
	      each(queryResult, cb, context);
	    }
	  },
	
	  /**
	   * @param {string} name
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByName: function (name) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.name === name;
	    });
	  },
	
	  /**
	   * @param {number} seriesIndex
	   * @return {module:echarts/model/Series}
	   */
	  getSeriesByIndex: function (seriesIndex) {
	    return this._componentsMap.get('series')[seriesIndex];
	  },
	
	  /**
	   * Get series list before filtered by type.
	   * FIXME: rename to getRawSeriesByType?
	   *
	   * @param {string} subType
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeriesByType: function (subType) {
	    var series = this._componentsMap.get('series');
	
	    return filter(series, function (oneSeries) {
	      return oneSeries.subType === subType;
	    });
	  },
	
	  /**
	   * @return {Array.<module:echarts/model/Series>}
	   */
	  getSeries: function () {
	    return this._componentsMap.get('series').slice();
	  },
	
	  /**
	   * @return {number}
	   */
	  getSeriesCount: function () {
	    return this._componentsMap.get('series').length;
	  },
	
	  /**
	   * After filtering, series may be different
	   * frome raw series.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      cb.call(context, series, rawSeriesIndex);
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered.
	   *
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeries: function (cb, context) {
	    each(this._componentsMap.get('series'), cb, context);
	  },
	
	  /**
	   * After filtering, series may be different.
	   * frome raw series.
	   *
	   * @param {string} subType.
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachSeriesByType: function (subType, cb, context) {
	    assertSeriesInitialized(this);
	    each(this._seriesIndices, function (rawSeriesIndex) {
	      var series = this._componentsMap.get('series')[rawSeriesIndex];
	
	      if (series.subType === subType) {
	        cb.call(context, series, rawSeriesIndex);
	      }
	    }, this);
	  },
	
	  /**
	   * Iterate raw series before filtered of given type.
	   *
	   * @parma {string} subType
	   * @param {Function} cb
	   * @param {*} context
	   */
	  eachRawSeriesByType: function (subType, cb, context) {
	    return each(this.getSeriesByType(subType), cb, context);
	  },
	
	  /**
	   * @param {module:echarts/model/Series} seriesModel
	   */
	  isSeriesFiltered: function (seriesModel) {
	    assertSeriesInitialized(this);
	    return this._seriesIndicesMap.get(seriesModel.componentIndex) == null;
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getCurrentSeriesIndices: function () {
	    return (this._seriesIndices || []).slice();
	  },
	
	  /**
	   * @param {Function} cb
	   * @param {*} context
	   */
	  filterSeries: function (cb, context) {
	    assertSeriesInitialized(this);
	    var filteredSeries = filter(this._componentsMap.get('series'), cb, context);
	    createSeriesIndices(this, filteredSeries);
	  },
	  restoreData: function (payload) {
	    var componentsMap = this._componentsMap;
	    createSeriesIndices(this, componentsMap.get('series'));
	    var componentTypes = [];
	    componentsMap.each(function (components, componentType) {
	      componentTypes.push(componentType);
	    });
	    ComponentModel.topologicalTravel(componentTypes, ComponentModel.getAllClassMainTypes(), function (componentType, dependencies) {
	      each(componentsMap.get(componentType), function (component) {
	        (componentType !== 'series' || !isNotTargetSeries(component, payload)) && component.restoreData();
	      });
	    });
	  }
	});
	
	function isNotTargetSeries(seriesModel, payload) {
	  if (payload) {
	    var index = payload.seiresIndex;
	    var id = payload.seriesId;
	    var name = payload.seriesName;
	    return index != null && seriesModel.componentIndex !== index || id != null && seriesModel.id !== id || name != null && seriesModel.name !== name;
	  }
	}
	/**
	 * @inner
	 */
	
	
	function mergeTheme(option, theme) {
	  // PENDING
	  // NOT use `colorLayer` in theme if option has `color`
	  var notMergeColorLayer = option.color && !option.colorLayer;
	  each(theme, function (themeItem, name) {
	    if (name === 'colorLayer' && notMergeColorLayer) {
	      return;
	    } // 如果有 component model 则把具体的 merge 逻辑交给该 model 处理
	
	
	    if (!ComponentModel.hasClass(name)) {
	      if (typeof themeItem === 'object') {
	        option[name] = !option[name] ? clone(themeItem) : merge(option[name], themeItem, false);
	      } else {
	        if (option[name] == null) {
	          option[name] = themeItem;
	        }
	      }
	    }
	  });
	}
	
	function initBase(baseOption) {
	  baseOption = baseOption; // Using OPTION_INNER_KEY to mark that this option can not be used outside,
	  // i.e. `chart.setOption(chart.getModel().option);` is forbiden.
	
	  this.option = {};
	  this.option[OPTION_INNER_KEY] = 1;
	  /**
	   * Init with series: [], in case of calling findSeries method
	   * before series initialized.
	   * @type {Object.<string, Array.<module:echarts/model/Model>>}
	   * @private
	   */
	
	  this._componentsMap = createHashMap({
	    series: []
	  });
	  /**
	   * Mapping between filtered series list and raw series list.
	   * key: filtered series indices, value: raw series indices.
	   * @type {Array.<nubmer>}
	   * @private
	   */
	
	  this._seriesIndices;
	  this._seriesIndicesMap;
	  mergeTheme(baseOption, this._theme.option); // TODO Needs clone when merging to the unexisted property
	
	  merge(baseOption, globalDefault, false);
	  this.mergeOption(baseOption);
	}
	/**
	 * @inner
	 * @param {Array.<string>|string} types model types
	 * @return {Object} key: {string} type, value: {Array.<Object>} models
	 */
	
	
	function getComponentsByTypes(componentsMap, types) {
	  if (!isArray(types)) {
	    types = types ? [types] : [];
	  }
	
	  var ret = {};
	  each(types, function (type) {
	    ret[type] = (componentsMap.get(type) || []).slice();
	  });
	  return ret;
	}
	/**
	 * @inner
	 */
	
	
	function determineSubType(mainType, newCptOption, existComponent) {
	  var subType = newCptOption.type ? newCptOption.type : existComponent ? existComponent.subType // Use determineSubType only when there is no existComponent.
	  : ComponentModel.determineSubType(mainType, newCptOption); // tooltip, markline, markpoint may always has no subType
	
	  return subType;
	}
	/**
	 * @inner
	 */
	
	
	function createSeriesIndices(ecModel, seriesModels) {
	  ecModel._seriesIndicesMap = createHashMap(ecModel._seriesIndices = map(seriesModels, function (series) {
	    return series.componentIndex;
	  }) || []);
	}
	/**
	 * @inner
	 */
	
	
	function filterBySubType(components, condition) {
	  // Using hasOwnProperty for restrict. Consider
	  // subType is undefined in user payload.
	  return condition.hasOwnProperty('subType') ? filter(components, function (cpt) {
	    return cpt.subType === condition.subType;
	  }) : components;
	}
	/**
	 * @inner
	 */
	
	
	function assertSeriesInitialized(ecModel) {}
	
	mixin(GlobalModel, colorPaletteMixin);
	var _default = GlobalModel;
	module.exports = _default;

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	
	function getNearestColorPalette(colors, requestColorNum) {
	  var paletteNum = colors.length; // TODO colors must be in order
	
	  for (var i = 0; i < paletteNum; i++) {
	    if (colors[i].length > requestColorNum) {
	      return colors[i];
	    }
	  }
	
	  return colors[paletteNum - 1];
	}
	
	var _default = {
	  clearColorPalette: function () {
	    inner(this).colorIdx = 0;
	    inner(this).colorNameMap = {};
	  },
	
	  /**
	   * @param {string} name MUST NOT be null/undefined. Otherwise call this function
	   *                 twise with the same parameters will get different result.
	   * @param {Object} [scope=this]
	   * @param {Object} [requestColorNum]
	   * @return {string} color string.
	   */
	  getColorFromPalette: function (name, scope, requestColorNum) {
	    scope = scope || this;
	    var scopeFields = inner(scope);
	    var colorIdx = scopeFields.colorIdx || 0;
	    var colorNameMap = scopeFields.colorNameMap = scopeFields.colorNameMap || {}; // Use `hasOwnProperty` to avoid conflict with Object.prototype.
	
	    if (colorNameMap.hasOwnProperty(name)) {
	      return colorNameMap[name];
	    }
	
	    var defaultColorPalette = normalizeToArray(this.get('color', true));
	    var layeredColorPalette = this.get('colorLayer', true);
	    var colorPalette = requestColorNum == null || !layeredColorPalette ? defaultColorPalette : getNearestColorPalette(layeredColorPalette, requestColorNum); // In case can't find in layered color palette.
	
	    colorPalette = colorPalette || defaultColorPalette;
	
	    if (!colorPalette || !colorPalette.length) {
	      return;
	    }
	
	    var color = colorPalette[colorIdx];
	
	    if (name) {
	      colorNameMap[name] = color;
	    }
	
	    scopeFields.colorIdx = (colorIdx + 1) % colorPalette.length;
	    return color;
	  }
	};
	module.exports = _default;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Scale = __webpack_require__(361);
	
	var numberUtil = __webpack_require__(25);
	
	var IntervalScale = __webpack_require__(360);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Log scale
	 * @module echarts/scale/Log
	 */
	// Use some method of IntervalScale
	var scaleProto = Scale.prototype;
	var intervalScaleProto = IntervalScale.prototype;
	var getPrecisionSafe = numberUtil.getPrecisionSafe;
	var roundingErrorFix = numberUtil.round;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var mathPow = Math.pow;
	var mathLog = Math.log;
	var LogScale = Scale.extend({
	  type: 'log',
	  base: 10,
	  $constructor: function () {
	    Scale.apply(this, arguments);
	    this._originalScale = new IntervalScale();
	  },
	
	  /**
	   * @param {boolean} [expandToNicedExtent=false] If expand the ticks to niced extent.
	   * @return {Array.<number>}
	   */
	  getTicks: function (expandToNicedExtent) {
	    var originalScale = this._originalScale;
	    var extent = this._extent;
	    var originalExtent = originalScale.getExtent();
	    return zrUtil.map(intervalScaleProto.getTicks.call(this, expandToNicedExtent), function (val) {
	      var powVal = numberUtil.round(mathPow(this.base, val)); // Fix #4158
	
	      powVal = val === extent[0] && originalScale.__fixMin ? fixRoundingError(powVal, originalExtent[0]) : powVal;
	      powVal = val === extent[1] && originalScale.__fixMax ? fixRoundingError(powVal, originalExtent[1]) : powVal;
	      return powVal;
	    }, this);
	  },
	
	  /**
	   * @param {number} splitNumber
	   * @return {Array.<Array.<number>>}
	   */
	  getMinorTicks: intervalScaleProto.getMinorTicks,
	
	  /**
	   * @param {number} val
	   * @return {string}
	   */
	  getLabel: intervalScaleProto.getLabel,
	
	  /**
	   * @param  {number} val
	   * @return {number}
	   */
	  scale: function (val) {
	    val = scaleProto.scale.call(this, val);
	    return mathPow(this.base, val);
	  },
	
	  /**
	   * @param {number} start
	   * @param {number} end
	   */
	  setExtent: function (start, end) {
	    var base = this.base;
	    start = mathLog(start) / mathLog(base);
	    end = mathLog(end) / mathLog(base);
	    intervalScaleProto.setExtent.call(this, start, end);
	  },
	
	  /**
	   * @return {number} end
	   */
	  getExtent: function () {
	    var base = this.base;
	    var extent = scaleProto.getExtent.call(this);
	    extent[0] = mathPow(base, extent[0]);
	    extent[1] = mathPow(base, extent[1]); // Fix #4158
	
	    var originalScale = this._originalScale;
	    var originalExtent = originalScale.getExtent();
	    originalScale.__fixMin && (extent[0] = fixRoundingError(extent[0], originalExtent[0]));
	    originalScale.__fixMax && (extent[1] = fixRoundingError(extent[1], originalExtent[1]));
	    return extent;
	  },
	
	  /**
	   * @param  {Array.<number>} extent
	   */
	  unionExtent: function (extent) {
	    this._originalScale.unionExtent(extent);
	
	    var base = this.base;
	    extent[0] = mathLog(extent[0]) / mathLog(base);
	    extent[1] = mathLog(extent[1]) / mathLog(base);
	    scaleProto.unionExtent.call(this, extent);
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    // TODO
	    // filter value that <= 0
	    this.unionExtent(data.getApproximateExtent(dim));
	  },
	
	  /**
	   * Update interval and extent of intervals for nice ticks
	   * @param  {number} [approxTickNum = 10] Given approx tick number
	   */
	  niceTicks: function (approxTickNum) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	
	    if (span === Infinity || span <= 0) {
	      return;
	    }
	
	    var interval = numberUtil.quantity(span);
	    var err = approxTickNum / span * interval; // Filter ticks to get closer to the desired count.
	
	    if (err <= 0.5) {
	      interval *= 10;
	    } // Interval should be integer
	
	
	    while (!isNaN(interval) && Math.abs(interval) < 1 && Math.abs(interval) > 0) {
	      interval *= 10;
	    }
	
	    var niceExtent = [numberUtil.round(mathCeil(extent[0] / interval) * interval), numberUtil.round(mathFloor(extent[1] / interval) * interval)];
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	
	  /**
	   * Nice extent.
	   * @override
	   */
	  niceExtent: function (opt) {
	    intervalScaleProto.niceExtent.call(this, opt);
	    var originalScale = this._originalScale;
	    originalScale.__fixMin = opt.fixMin;
	    originalScale.__fixMax = opt.fixMax;
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  LogScale.prototype[methodName] = function (val) {
	    val = mathLog(val) / mathLog(this.base);
	    return scaleProto[methodName].call(this, val);
	  };
	});
	
	LogScale.create = function () {
	  return new LogScale();
	};
	
	function fixRoundingError(val, originalVal) {
	  return roundingErrorFix(val, getPrecisionSafe(originalVal));
	}
	
	var _default = LogScale;
	module.exports = _default;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var numberUtil = __webpack_require__(25);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * For testable.
	 */
	var roundNumber = numberUtil.round;
	/**
	 * @param {Array.<number>} extent Both extent[0] and extent[1] should be valid number.
	 *                                Should be extent[0] < extent[1].
	 * @param {number} splitNumber splitNumber should be >= 1.
	 * @param {number} [minInterval]
	 * @param {number} [maxInterval]
	 * @return {Object} {interval, intervalPrecision, niceTickExtent}
	 */
	
	function intervalScaleNiceTicks(extent, splitNumber, minInterval, maxInterval) {
	  var result = {};
	  var span = extent[1] - extent[0];
	  var interval = result.interval = numberUtil.nice(span / splitNumber, true);
	
	  if (minInterval != null && interval < minInterval) {
	    interval = result.interval = minInterval;
	  }
	
	  if (maxInterval != null && interval > maxInterval) {
	    interval = result.interval = maxInterval;
	  } // Tow more digital for tick.
	
	
	  var precision = result.intervalPrecision = getIntervalPrecision(interval); // Niced extent inside original extent
	
	  var niceTickExtent = result.niceTickExtent = [roundNumber(Math.ceil(extent[0] / interval) * interval, precision), roundNumber(Math.floor(extent[1] / interval) * interval, precision)];
	  fixExtent(niceTickExtent, extent);
	  return result;
	}
	/**
	 * @param {number} interval
	 * @return {number} interval precision
	 */
	
	
	function getIntervalPrecision(interval) {
	  // Tow more digital for tick.
	  return numberUtil.getPrecisionSafe(interval) + 2;
	}
	
	function clamp(niceTickExtent, idx, extent) {
	  niceTickExtent[idx] = Math.max(Math.min(niceTickExtent[idx], extent[1]), extent[0]);
	} // In some cases (e.g., splitNumber is 1), niceTickExtent may be out of extent.
	
	
	function fixExtent(niceTickExtent, extent) {
	  !isFinite(niceTickExtent[0]) && (niceTickExtent[0] = extent[0]);
	  !isFinite(niceTickExtent[1]) && (niceTickExtent[1] = extent[1]);
	  clamp(niceTickExtent, 0, extent);
	  clamp(niceTickExtent, 1, extent);
	
	  if (niceTickExtent[0] > niceTickExtent[1]) {
	    niceTickExtent[0] = niceTickExtent[1];
	  }
	}
	
	exports.intervalScaleNiceTicks = intervalScaleNiceTicks;
	exports.getIntervalPrecision = getIntervalPrecision;
	exports.fixExtent = fixExtent;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Visual mapping.
	 */
	var visualDefault = {
	  /**
	   * @public
	   */
	  get: function (visualType, key, isCategory) {
	    var value = zrUtil.clone((defaultOption[visualType] || {})[key]);
	    return isCategory ? zrUtil.isArray(value) ? value[value.length - 1] : value : value;
	  }
	};
	var defaultOption = {
	  color: {
	    active: ['#006edd', '#e0ffff'],
	    inactive: ['rgba(0,0,0,0)']
	  },
	  colorHue: {
	    active: [0, 360],
	    inactive: [0, 0]
	  },
	  colorSaturation: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  colorLightness: {
	    active: [0.9, 0.5],
	    inactive: [0, 0]
	  },
	  colorAlpha: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  opacity: {
	    active: [0.3, 1],
	    inactive: [0, 0]
	  },
	  symbol: {
	    active: ['circle', 'roundRect', 'diamond'],
	    inactive: ['none']
	  },
	  symbolSize: {
	    active: [10, 50],
	    inactive: [0, 0]
	  }
	};
	var _default = visualDefault;
	module.exports = _default;

/***/ },
/* 879 */
/***/ function(module, exports) {

	/**
	 * Helper function for iterating over a collection
	 *
	 * @param collection
	 * @param fn
	 */
	function each(collection, fn) {
	    var i      = 0,
	        length = collection.length,
	        cont;
	
	    for(i; i < length; i++) {
	        cont = fn(collection[i], i);
	        if(cont === false) {
	            break; //allow early exit
	        }
	    }
	}
	
	/**
	 * Helper function for determining whether target object is an array
	 *
	 * @param target the object under test
	 * @return {Boolean} true if array, false otherwise
	 */
	function isArray(target) {
	    return Object.prototype.toString.apply(target) === '[object Array]';
	}
	
	/**
	 * Helper function for determining whether target object is a function
	 *
	 * @param target the object under test
	 * @return {Boolean} true if function, false otherwise
	 */
	function isFunction(target) {
	    return typeof target === 'function';
	}
	
	module.exports = {
	    isFunction : isFunction,
	    isArray : isArray,
	    each : each
	};


/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQueryDispatch = __webpack_require__(2459);
	module.exports = new MediaQueryDispatch();


/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var PhotosMimeType = __webpack_require__(2462);
	
	var createArrayFromMixed = __webpack_require__(886);
	var emptyFunction = __webpack_require__(101);
	
	var CR_LF_REGEX = new RegExp('\r\n', 'g');
	var LF_ONLY = '\n';
	
	var RICH_TEXT_TYPES = {
	  'text/rtf': 1,
	  'text/html': 1
	};
	
	/**
	 * If DataTransferItem is a file then return the Blob of data.
	 *
	 * @param {object} item
	 * @return {?blob}
	 */
	function getFileFromDataTransfer(item) {
	  if (item.kind == 'file') {
	    return item.getAsFile();
	  }
	}
	
	var DataTransfer = function () {
	  /**
	   * @param {object} data
	   */
	  function DataTransfer(data) {
	    _classCallCheck(this, DataTransfer);
	
	    this.data = data;
	
	    // Types could be DOMStringList or array
	    this.types = data.types ? createArrayFromMixed(data.types) : [];
	  }
	
	  /**
	   * Is this likely to be a rich text data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isRichText = function isRichText() {
	    // If HTML is available, treat this data as rich text. This way, we avoid
	    // using a pasted image if it is packaged with HTML -- this may occur with
	    // pastes from MS Word, for example.  However this is only rich text if
	    // there's accompanying text.
	    if (this.getHTML() && this.getText()) {
	      return true;
	    }
	
	    // When an image is copied from a preview window, you end up with two
	    // DataTransferItems one of which is a file's metadata as text.  Skip those.
	    if (this.isImage()) {
	      return false;
	    }
	
	    return this.types.some(function (type) {
	      return RICH_TEXT_TYPES[type];
	    });
	  };
	
	  /**
	   * Get raw text.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getText = function getText() {
	    var text;
	    if (this.data.getData) {
	      if (!this.types.length) {
	        text = this.data.getData('Text');
	      } else if (this.types.indexOf('text/plain') != -1) {
	        text = this.data.getData('text/plain');
	      }
	    }
	    return text ? text.replace(CR_LF_REGEX, LF_ONLY) : null;
	  };
	
	  /**
	   * Get HTML paste data
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getHTML = function getHTML() {
	    if (this.data.getData) {
	      if (!this.types.length) {
	        return this.data.getData('Text');
	      } else if (this.types.indexOf('text/html') != -1) {
	        return this.data.getData('text/html');
	      }
	    }
	  };
	
	  /**
	   * Is this a link data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isLink = function isLink() {
	    return this.types.some(function (type) {
	      return type.indexOf('Url') != -1 || type.indexOf('text/uri-list') != -1 || type.indexOf('text/x-moz-url');
	    });
	  };
	
	  /**
	   * Get a link url.
	   *
	   * @return {?string}
	   */
	
	
	  DataTransfer.prototype.getLink = function getLink() {
	    if (this.data.getData) {
	      if (this.types.indexOf('text/x-moz-url') != -1) {
	        var url = this.data.getData('text/x-moz-url').split('\n');
	        return url[0];
	      }
	      return this.types.indexOf('text/uri-list') != -1 ? this.data.getData('text/uri-list') : this.data.getData('url');
	    }
	
	    return null;
	  };
	
	  /**
	   * Is this an image data transfer?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.isImage = function isImage() {
	    var isImage = this.types.some(function (type) {
	      // Firefox will have a type of application/x-moz-file for images during
	      // dragging
	      return type.indexOf('application/x-moz-file') != -1;
	    });
	
	    if (isImage) {
	      return true;
	    }
	
	    var items = this.getFiles();
	    for (var i = 0; i < items.length; i++) {
	      var type = items[i].type;
	      if (!PhotosMimeType.isImage(type)) {
	        return false;
	      }
	    }
	
	    return true;
	  };
	
	  DataTransfer.prototype.getCount = function getCount() {
	    if (this.data.hasOwnProperty('items')) {
	      return this.data.items.length;
	    } else if (this.data.hasOwnProperty('mozItemCount')) {
	      return this.data.mozItemCount;
	    } else if (this.data.files) {
	      return this.data.files.length;
	    }
	    return null;
	  };
	
	  /**
	   * Get files.
	   *
	   * @return {array}
	   */
	
	
	  DataTransfer.prototype.getFiles = function getFiles() {
	    if (this.data.items) {
	      // createArrayFromMixed doesn't properly handle DataTransferItemLists.
	      return Array.prototype.slice.call(this.data.items).map(getFileFromDataTransfer).filter(emptyFunction.thatReturnsArgument);
	    } else if (this.data.files) {
	      return Array.prototype.slice.call(this.data.files);
	    } else {
	      return [];
	    }
	  };
	
	  /**
	   * Are there any files to fetch?
	   *
	   * @return {boolean}
	   */
	
	
	  DataTransfer.prototype.hasFiles = function hasFiles() {
	    return this.getFiles().length > 0;
	  };
	
	  return DataTransfer;
	}();
	
	module.exports = DataTransfer;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(101);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 883 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * @param {DOMElement} element
	 * @param {DOMDocument} doc
	 * @return {boolean}
	 */
	function _isViewportScrollElement(element, doc) {
	  return !!doc && (element === doc.documentElement || element === doc.body);
	}
	
	/**
	 * Scroll Module. This class contains 4 simple static functions
	 * to be used to access Element.scrollTop/scrollLeft properties.
	 * To solve the inconsistencies between browsers when either
	 * document.body or document.documentElement is supplied,
	 * below logic will be used to alleviate the issue:
	 *
	 * 1. If 'element' is either 'document.body' or 'document.documentElement,
	 *    get whichever element's 'scroll{Top,Left}' is larger.
	 * 2. If 'element' is either 'document.body' or 'document.documentElement',
	 *    set the 'scroll{Top,Left}' on both elements.
	 */
	
	var Scroll = {
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getTop: function getTop(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ?
	    // In practice, they will either both have the same value,
	    // or one will be zero and the other will be the scroll position
	    // of the viewport. So we can use `X || Y` instead of `Math.max(X, Y)`
	    doc.body.scrollTop || doc.documentElement.scrollTop : element.scrollTop;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newTop
	   */
	  setTop: function setTop(element, newTop) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollTop = doc.documentElement.scrollTop = newTop;
	    } else {
	      element.scrollTop = newTop;
	    }
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @return {number}
	   */
	  getLeft: function getLeft(element) {
	    var doc = element.ownerDocument;
	    return _isViewportScrollElement(element, doc) ? doc.body.scrollLeft || doc.documentElement.scrollLeft : element.scrollLeft;
	  },
	
	  /**
	   * @param {DOMElement} element
	   * @param {number} newLeft
	   */
	  setLeft: function setLeft(element, newLeft) {
	    var doc = element.ownerDocument;
	    if (_isViewportScrollElement(element, doc)) {
	      doc.body.scrollLeft = doc.documentElement.scrollLeft = newLeft;
	    } else {
	      element.scrollLeft = newLeft;
	    }
	  }
	};
	
	module.exports = Scroll;

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Basic (stateless) API for text direction detection
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	var UnicodeBidiDirection = __webpack_require__(521);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * RegExp ranges of characters with a *Strong* Bidi_Class value.
	 *
	 * Data is based on DerivedBidiClass.txt in UCD version 7.0.0.
	 *
	 * NOTE: For performance reasons, we only support Unicode's
	 *       Basic Multilingual Plane (BMP) for now.
	 */
	var RANGE_BY_BIDI_TYPE = {
	
	  L: 'A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u01BA\u01BB' + '\u01BC-\u01BF\u01C0-\u01C3\u01C4-\u0293\u0294\u0295-\u02AF\u02B0-\u02B8' + '\u02BB-\u02C1\u02D0-\u02D1\u02E0-\u02E4\u02EE\u0370-\u0373\u0376-\u0377' + '\u037A\u037B-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1' + '\u03A3-\u03F5\u03F7-\u0481\u0482\u048A-\u052F\u0531-\u0556\u0559' + '\u055A-\u055F\u0561-\u0587\u0589\u0903\u0904-\u0939\u093B\u093D' + '\u093E-\u0940\u0949-\u094C\u094E-\u094F\u0950\u0958-\u0961\u0964-\u0965' + '\u0966-\u096F\u0970\u0971\u0972-\u0980\u0982-\u0983\u0985-\u098C' + '\u098F-\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD' + '\u09BE-\u09C0\u09C7-\u09C8\u09CB-\u09CC\u09CE\u09D7\u09DC-\u09DD' + '\u09DF-\u09E1\u09E6-\u09EF\u09F0-\u09F1\u09F4-\u09F9\u09FA\u0A03' + '\u0A05-\u0A0A\u0A0F-\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32-\u0A33' + '\u0A35-\u0A36\u0A38-\u0A39\u0A3E-\u0A40\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F' + '\u0A72-\u0A74\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0' + '\u0AB2-\u0AB3\u0AB5-\u0AB9\u0ABD\u0ABE-\u0AC0\u0AC9\u0ACB-\u0ACC\u0AD0' + '\u0AE0-\u0AE1\u0AE6-\u0AEF\u0AF0\u0B02-\u0B03\u0B05-\u0B0C\u0B0F-\u0B10' + '\u0B13-\u0B28\u0B2A-\u0B30\u0B32-\u0B33\u0B35-\u0B39\u0B3D\u0B3E\u0B40' + '\u0B47-\u0B48\u0B4B-\u0B4C\u0B57\u0B5C-\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F' + '\u0B70\u0B71\u0B72-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95' + '\u0B99-\u0B9A\u0B9C\u0B9E-\u0B9F\u0BA3-\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9' + '\u0BBE-\u0BBF\u0BC1-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCC\u0BD0\u0BD7' + '\u0BE6-\u0BEF\u0BF0-\u0BF2\u0C01-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10' + '\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C41-\u0C44\u0C58-\u0C59\u0C60-\u0C61' + '\u0C66-\u0C6F\u0C7F\u0C82-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8' + '\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CBE\u0CBF\u0CC0-\u0CC4\u0CC6' + '\u0CC7-\u0CC8\u0CCA-\u0CCB\u0CD5-\u0CD6\u0CDE\u0CE0-\u0CE1\u0CE6-\u0CEF' + '\u0CF1-\u0CF2\u0D02-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D' + '\u0D3E-\u0D40\u0D46-\u0D48\u0D4A-\u0D4C\u0D4E\u0D57\u0D60-\u0D61' + '\u0D66-\u0D6F\u0D70-\u0D75\u0D79\u0D7A-\u0D7F\u0D82-\u0D83\u0D85-\u0D96' + '\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCF-\u0DD1\u0DD8-\u0DDF' + '\u0DE6-\u0DEF\u0DF2-\u0DF3\u0DF4\u0E01-\u0E30\u0E32-\u0E33\u0E40-\u0E45' + '\u0E46\u0E4F\u0E50-\u0E59\u0E5A-\u0E5B\u0E81-\u0E82\u0E84\u0E87-\u0E88' + '\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7' + '\u0EAA-\u0EAB\u0EAD-\u0EB0\u0EB2-\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6' + '\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F01-\u0F03\u0F04-\u0F12\u0F13\u0F14' + '\u0F15-\u0F17\u0F1A-\u0F1F\u0F20-\u0F29\u0F2A-\u0F33\u0F34\u0F36\u0F38' + '\u0F3E-\u0F3F\u0F40-\u0F47\u0F49-\u0F6C\u0F7F\u0F85\u0F88-\u0F8C' + '\u0FBE-\u0FC5\u0FC7-\u0FCC\u0FCE-\u0FCF\u0FD0-\u0FD4\u0FD5-\u0FD8' + '\u0FD9-\u0FDA\u1000-\u102A\u102B-\u102C\u1031\u1038\u103B-\u103C\u103F' + '\u1040-\u1049\u104A-\u104F\u1050-\u1055\u1056-\u1057\u105A-\u105D\u1061' + '\u1062-\u1064\u1065-\u1066\u1067-\u106D\u106E-\u1070\u1075-\u1081' + '\u1083-\u1084\u1087-\u108C\u108E\u108F\u1090-\u1099\u109A-\u109C' + '\u109E-\u109F\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FB\u10FC' + '\u10FD-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288' + '\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5' + '\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1360-\u1368' + '\u1369-\u137C\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166D-\u166E' + '\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EB-\u16ED\u16EE-\u16F0' + '\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1735-\u1736' + '\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17B6\u17BE-\u17C5' + '\u17C7-\u17C8\u17D4-\u17D6\u17D7\u17D8-\u17DA\u17DC\u17E0-\u17E9' + '\u1810-\u1819\u1820-\u1842\u1843\u1844-\u1877\u1880-\u18A8\u18AA' + '\u18B0-\u18F5\u1900-\u191E\u1923-\u1926\u1929-\u192B\u1930-\u1931' + '\u1933-\u1938\u1946-\u194F\u1950-\u196D\u1970-\u1974\u1980-\u19AB' + '\u19B0-\u19C0\u19C1-\u19C7\u19C8-\u19C9\u19D0-\u19D9\u19DA\u1A00-\u1A16' + '\u1A19-\u1A1A\u1A1E-\u1A1F\u1A20-\u1A54\u1A55\u1A57\u1A61\u1A63-\u1A64' + '\u1A6D-\u1A72\u1A80-\u1A89\u1A90-\u1A99\u1AA0-\u1AA6\u1AA7\u1AA8-\u1AAD' + '\u1B04\u1B05-\u1B33\u1B35\u1B3B\u1B3D-\u1B41\u1B43-\u1B44\u1B45-\u1B4B' + '\u1B50-\u1B59\u1B5A-\u1B60\u1B61-\u1B6A\u1B74-\u1B7C\u1B82\u1B83-\u1BA0' + '\u1BA1\u1BA6-\u1BA7\u1BAA\u1BAE-\u1BAF\u1BB0-\u1BB9\u1BBA-\u1BE5\u1BE7' + '\u1BEA-\u1BEC\u1BEE\u1BF2-\u1BF3\u1BFC-\u1BFF\u1C00-\u1C23\u1C24-\u1C2B' + '\u1C34-\u1C35\u1C3B-\u1C3F\u1C40-\u1C49\u1C4D-\u1C4F\u1C50-\u1C59' + '\u1C5A-\u1C77\u1C78-\u1C7D\u1C7E-\u1C7F\u1CC0-\u1CC7\u1CD3\u1CE1' + '\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF2-\u1CF3\u1CF5-\u1CF6\u1D00-\u1D2B' + '\u1D2C-\u1D6A\u1D6B-\u1D77\u1D78\u1D79-\u1D9A\u1D9B-\u1DBF\u1E00-\u1F15' + '\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D' + '\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC' + '\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u200E' + '\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D' + '\u2124\u2126\u2128\u212A-\u212D\u212F-\u2134\u2135-\u2138\u2139' + '\u213C-\u213F\u2145-\u2149\u214E\u214F\u2160-\u2182\u2183-\u2184' + '\u2185-\u2188\u2336-\u237A\u2395\u249C-\u24E9\u26AC\u2800-\u28FF' + '\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2C7B\u2C7C-\u2C7D\u2C7E-\u2CE4' + '\u2CEB-\u2CEE\u2CF2-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F' + '\u2D70\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE' + '\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u3005\u3006\u3007' + '\u3021-\u3029\u302E-\u302F\u3031-\u3035\u3038-\u303A\u303B\u303C' + '\u3041-\u3096\u309D-\u309E\u309F\u30A1-\u30FA\u30FC-\u30FE\u30FF' + '\u3105-\u312D\u3131-\u318E\u3190-\u3191\u3192-\u3195\u3196-\u319F' + '\u31A0-\u31BA\u31F0-\u31FF\u3200-\u321C\u3220-\u3229\u322A-\u3247' + '\u3248-\u324F\u3260-\u327B\u327F\u3280-\u3289\u328A-\u32B0\u32C0-\u32CB' + '\u32D0-\u32FE\u3300-\u3376\u337B-\u33DD\u33E0-\u33FE\u3400-\u4DB5' + '\u4E00-\u9FCC\uA000-\uA014\uA015\uA016-\uA48C\uA4D0-\uA4F7\uA4F8-\uA4FD' + '\uA4FE-\uA4FF\uA500-\uA60B\uA60C\uA610-\uA61F\uA620-\uA629\uA62A-\uA62B' + '\uA640-\uA66D\uA66E\uA680-\uA69B\uA69C-\uA69D\uA6A0-\uA6E5\uA6E6-\uA6EF' + '\uA6F2-\uA6F7\uA722-\uA76F\uA770\uA771-\uA787\uA789-\uA78A\uA78B-\uA78E' + '\uA790-\uA7AD\uA7B0-\uA7B1\uA7F7\uA7F8-\uA7F9\uA7FA\uA7FB-\uA801' + '\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA823-\uA824\uA827\uA830-\uA835' + '\uA836-\uA837\uA840-\uA873\uA880-\uA881\uA882-\uA8B3\uA8B4-\uA8C3' + '\uA8CE-\uA8CF\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8F8-\uA8FA\uA8FB\uA900-\uA909' + '\uA90A-\uA925\uA92E-\uA92F\uA930-\uA946\uA952-\uA953\uA95F\uA960-\uA97C' + '\uA983\uA984-\uA9B2\uA9B4-\uA9B5\uA9BA-\uA9BB\uA9BD-\uA9C0\uA9C1-\uA9CD' + '\uA9CF\uA9D0-\uA9D9\uA9DE-\uA9DF\uA9E0-\uA9E4\uA9E6\uA9E7-\uA9EF' + '\uA9F0-\uA9F9\uA9FA-\uA9FE\uAA00-\uAA28\uAA2F-\uAA30\uAA33-\uAA34' + '\uAA40-\uAA42\uAA44-\uAA4B\uAA4D\uAA50-\uAA59\uAA5C-\uAA5F\uAA60-\uAA6F' + '\uAA70\uAA71-\uAA76\uAA77-\uAA79\uAA7A\uAA7B\uAA7D\uAA7E-\uAAAF\uAAB1' + '\uAAB5-\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADC\uAADD\uAADE-\uAADF' + '\uAAE0-\uAAEA\uAAEB\uAAEE-\uAAEF\uAAF0-\uAAF1\uAAF2\uAAF3-\uAAF4\uAAF5' + '\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E' + '\uAB30-\uAB5A\uAB5B\uAB5C-\uAB5F\uAB64-\uAB65\uABC0-\uABE2\uABE3-\uABE4' + '\uABE6-\uABE7\uABE9-\uABEA\uABEB\uABEC\uABF0-\uABF9\uAC00-\uD7A3' + '\uD7B0-\uD7C6\uD7CB-\uD7FB\uE000-\uF8FF\uF900-\uFA6D\uFA70-\uFAD9' + '\uFB00-\uFB06\uFB13-\uFB17\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFF6F\uFF70' + '\uFF71-\uFF9D\uFF9E-\uFF9F\uFFA0-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF' + '\uFFD2-\uFFD7\uFFDA-\uFFDC',
	
	  R: '\u0590\u05BE\u05C0\u05C3\u05C6\u05C8-\u05CF\u05D0-\u05EA\u05EB-\u05EF' + '\u05F0-\u05F2\u05F3-\u05F4\u05F5-\u05FF\u07C0-\u07C9\u07CA-\u07EA' + '\u07F4-\u07F5\u07FA\u07FB-\u07FF\u0800-\u0815\u081A\u0824\u0828' + '\u082E-\u082F\u0830-\u083E\u083F\u0840-\u0858\u085C-\u085D\u085E' + '\u085F-\u089F\u200F\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB37\uFB38-\uFB3C' + '\uFB3D\uFB3E\uFB3F\uFB40-\uFB41\uFB42\uFB43-\uFB44\uFB45\uFB46-\uFB4F',
	
	  AL: '\u0608\u060B\u060D\u061B\u061C\u061D\u061E-\u061F\u0620-\u063F\u0640' + '\u0641-\u064A\u066D\u066E-\u066F\u0671-\u06D3\u06D4\u06D5\u06E5-\u06E6' + '\u06EE-\u06EF\u06FA-\u06FC\u06FD-\u06FE\u06FF\u0700-\u070D\u070E\u070F' + '\u0710\u0712-\u072F\u074B-\u074C\u074D-\u07A5\u07B1\u07B2-\u07BF' + '\u08A0-\u08B2\u08B3-\u08E3\uFB50-\uFBB1\uFBB2-\uFBC1\uFBC2-\uFBD2' + '\uFBD3-\uFD3D\uFD40-\uFD4F\uFD50-\uFD8F\uFD90-\uFD91\uFD92-\uFDC7' + '\uFDC8-\uFDCF\uFDF0-\uFDFB\uFDFC\uFDFE-\uFDFF\uFE70-\uFE74\uFE75' + '\uFE76-\uFEFC\uFEFD-\uFEFE'
	
	};
	
	var REGEX_STRONG = new RegExp('[' + RANGE_BY_BIDI_TYPE.L + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	var REGEX_RTL = new RegExp('[' + RANGE_BY_BIDI_TYPE.R + RANGE_BY_BIDI_TYPE.AL + ']');
	
	/**
	 * Returns the first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     A character with strong bidi direction, or null if not found
	 */
	function firstStrongChar(str) {
	  var match = REGEX_STRONG.exec(str);
	  return match == null ? null : match[0];
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL).
	 *
	 * @param str  A text block; e.g. paragraph, table cell, tag
	 * @return     The resolved direction
	 */
	function firstStrongCharDir(str) {
	  var strongChar = firstStrongChar(str);
	  if (strongChar == null) {
	    return UnicodeBidiDirection.NEUTRAL;
	  }
	  return REGEX_RTL.exec(strongChar) ? UnicodeBidiDirection.RTL : UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str       A text block; e.g. paragraph, table cell, tag
	 * @param fallback  Fallback direction, used if no strong direction detected
	 *                  for the block (default = NEUTRAL)
	 * @return          The resolved direction
	 */
	function resolveBlockDir(str, fallback) {
	  fallback = fallback || UnicodeBidiDirection.NEUTRAL;
	  if (!str.length) {
	    return fallback;
	  }
	  var blockDir = firstStrongCharDir(str);
	  return blockDir === UnicodeBidiDirection.NEUTRAL ? fallback : blockDir;
	}
	
	/**
	 * Returns the direction of a block of text, based on the direction of its
	 * first strong character (has Bidi_Class value of L, R, or AL), or a fallback
	 * direction, if no strong character is found.
	 *
	 * NOTE: This function is similar to resolveBlockDir(), but uses the global
	 * direction as the fallback, so it *always* returns a Strong direction,
	 * making it useful for integration in places that you need to make the final
	 * decision, like setting some CSS class.
	 *
	 * This function is supposed to be used in respect to Higher-Level Protocol
	 * rule HL1. (http://www.unicode.org/reports/tr9/#HL1)
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                The resolved Strong direction
	 */
	function getDirection(str, strongFallback) {
	  if (!strongFallback) {
	    strongFallback = UnicodeBidiDirection.getGlobalDir();
	  }
	  !UnicodeBidiDirection.isStrong(strongFallback) ?  false ? invariant(false, 'Fallback direction must be a strong direction') : invariant(false) : void 0;
	  return resolveBlockDir(str, strongFallback);
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns LTR.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is LTR
	 */
	function isDirectionLTR(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.LTR;
	}
	
	/**
	 * Returns true if getDirection(arguments...) returns RTL.
	 *
	 * @param str             A text block; e.g. paragraph, table cell
	 * @param strongFallback  Fallback direction, used if no strong direction
	 *                        detected for the block (default = global direction)
	 * @return                True if the resolved direction is RTL
	 */
	function isDirectionRTL(str, strongFallback) {
	  return getDirection(str, strongFallback) === UnicodeBidiDirection.RTL;
	}
	
	var UnicodeBidi = {
	  firstStrongChar: firstStrongChar,
	  firstStrongCharDir: firstStrongCharDir,
	  resolveBlockDir: resolveBlockDir,
	  getDirection: getDirection,
	  isDirectionLTR: isDirectionLTR,
	  isDirectionRTL: isDirectionRTL
	};
	
	module.exports = UnicodeBidi;

/***/ },
/* 885 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 887 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 888 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 889 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 890 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.readState = exports.saveState = undefined;
	
	var _warning = __webpack_require__(216);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var QuotaExceededErrors = {
	  QuotaExceededError: true,
	  QUOTA_EXCEEDED_ERR: true
	};
	
	var SecurityErrors = {
	  SecurityError: true
	};
	
	var KeyPrefix = '@@History/';
	
	var createKey = function createKey(key) {
	  return KeyPrefix + key;
	};
	
	var saveState = exports.saveState = function saveState(key, state) {
	  if (!window.sessionStorage) {
	    // Session storage is not available or hidden.
	    // sessionStorage is undefined in Internet Explorer when served via file protocol.
	     false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available') : void 0;
	
	    return;
	  }
	
	  try {
	    if (state == null) {
	      window.sessionStorage.removeItem(createKey(key));
	    } else {
	      window.sessionStorage.setItem(createKey(key), JSON.stringify(state));
	    }
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available due to security settings') : void 0;
	
	      return;
	    }
	
	    if (QuotaExceededErrors[error.name] && window.sessionStorage.length === 0) {
	      // Safari "private mode" throws QuotaExceededError.
	       false ? (0, _warning2.default)(false, '[history] Unable to save state; sessionStorage is not available in Safari private mode') : void 0;
	
	      return;
	    }
	
	    throw error;
	  }
	};
	
	var readState = exports.readState = function readState(key) {
	  var json = void 0;
	  try {
	    json = window.sessionStorage.getItem(createKey(key));
	  } catch (error) {
	    if (SecurityErrors[error.name]) {
	      // Blocking cookies in Chrome/Firefox/Safari throws SecurityError on any
	      // attempt to access window.sessionStorage.
	       false ? (0, _warning2.default)(false, '[history] Unable to read state; sessionStorage is not available due to security settings') : void 0;
	
	      return undefined;
	    }
	  }
	
	  if (json) {
	    try {
	      return JSON.parse(json);
	    } catch (error) {
	      // Ignore invalid JSON.
	    }
	  }
	
	  return undefined;
	};

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _runTransitionHook = __webpack_require__(528);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _PathUtils = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var useBasename = function useBasename(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var basename = options.basename;
	
	
	    var addBasename = function addBasename(location) {
	      if (!location) return location;
	
	      if (basename && location.basename == null) {
	        if (location.pathname.toLowerCase().indexOf(basename.toLowerCase()) === 0) {
	          location.pathname = location.pathname.substring(basename.length);
	          location.basename = basename;
	
	          if (location.pathname === '') location.pathname = '/';
	        } else {
	          location.basename = '';
	        }
	      }
	
	      return location;
	    };
	
	    var prependBasename = function prependBasename(location) {
	      if (!basename) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var pname = object.pathname;
	      var normalizedBasename = basename.slice(-1) === '/' ? basename : basename + '/';
	      var normalizedPathname = pname.charAt(0) === '/' ? pname.slice(1) : pname;
	      var pathname = normalizedBasename + normalizedPathname;
	
	      return _extends({}, object, {
	        pathname: pathname
	      });
	    };
	
	    // Override all read methods with basename-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return addBasename(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, addBasename(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(addBasename(location));
	      });
	    };
	
	    // Override all write methods with basename-aware versions.
	    var push = function push(location) {
	      return history.push(prependBasename(location));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(prependBasename(location));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(prependBasename(location));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(prependBasename(location));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      return addBasename(history.createLocation.apply(history, [prependBasename(location)].concat(args)));
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useBasename;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _queryString = __webpack_require__(2633);
	
	var _runTransitionHook = __webpack_require__(528);
	
	var _runTransitionHook2 = _interopRequireDefault(_runTransitionHook);
	
	var _LocationUtils = __webpack_require__(254);
	
	var _PathUtils = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultStringifyQuery = function defaultStringifyQuery(query) {
	  return (0, _queryString.stringify)(query).replace(/%20/g, '+');
	};
	
	var defaultParseQueryString = _queryString.parse;
	
	/**
	 * Returns a new createHistory function that may be used to create
	 * history objects that know how to handle URL queries.
	 */
	var useQueries = function useQueries(createHistory) {
	  return function () {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    var history = createHistory(options);
	    var stringifyQuery = options.stringifyQuery,
	        parseQueryString = options.parseQueryString;
	
	
	    if (typeof stringifyQuery !== 'function') stringifyQuery = defaultStringifyQuery;
	
	    if (typeof parseQueryString !== 'function') parseQueryString = defaultParseQueryString;
	
	    var decodeQuery = function decodeQuery(location) {
	      if (!location) return location;
	
	      if (location.query == null) location.query = parseQueryString(location.search.substring(1));
	
	      return location;
	    };
	
	    var encodeQuery = function encodeQuery(location, query) {
	      if (query == null) return location;
	
	      var object = typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : location;
	      var queryString = stringifyQuery(query);
	      var search = queryString ? '?' + queryString : '';
	
	      return _extends({}, object, {
	        search: search
	      });
	    };
	
	    // Override all read methods with query-aware versions.
	    var getCurrentLocation = function getCurrentLocation() {
	      return decodeQuery(history.getCurrentLocation());
	    };
	
	    var listenBefore = function listenBefore(hook) {
	      return history.listenBefore(function (location, callback) {
	        return (0, _runTransitionHook2.default)(hook, decodeQuery(location), callback);
	      });
	    };
	
	    var listen = function listen(listener) {
	      return history.listen(function (location) {
	        return listener(decodeQuery(location));
	      });
	    };
	
	    // Override all write methods with query-aware versions.
	    var push = function push(location) {
	      return history.push(encodeQuery(location, location.query));
	    };
	
	    var replace = function replace(location) {
	      return history.replace(encodeQuery(location, location.query));
	    };
	
	    var createPath = function createPath(location) {
	      return history.createPath(encodeQuery(location, location.query));
	    };
	
	    var createHref = function createHref(location) {
	      return history.createHref(encodeQuery(location, location.query));
	    };
	
	    var createLocation = function createLocation(location) {
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      var newLocation = history.createLocation.apply(history, [encodeQuery(location, location.query)].concat(args));
	
	      if (location.query) newLocation.query = (0, _LocationUtils.createQuery)(location.query);
	
	      return decodeQuery(newLocation);
	    };
	
	    return _extends({}, history, {
	      getCurrentLocation: getCurrentLocation,
	      listenBefore: listenBefore,
	      listen: listen,
	      push: push,
	      replace: replace,
	      createPath: createPath,
	      createHref: createHref,
	      createLocation: createLocation
	    });
	  };
	};
	
	exports.default = useQueries;

/***/ },
/* 894 */
/***/ function(module, exports) {

	module.exports = [
		{
			"code": "11",
			"name": "北京市"
		},
		{
			"code": "12",
			"name": "天津市"
		},
		{
			"code": "13",
			"name": "河北省"
		},
		{
			"code": "14",
			"name": "山西省"
		},
		{
			"code": "15",
			"name": "内蒙古自治区"
		},
		{
			"code": "21",
			"name": "辽宁省"
		},
		{
			"code": "22",
			"name": "吉林省"
		},
		{
			"code": "23",
			"name": "黑龙江省"
		},
		{
			"code": "31",
			"name": "上海市"
		},
		{
			"code": "32",
			"name": "江苏省"
		},
		{
			"code": "33",
			"name": "浙江省"
		},
		{
			"code": "34",
			"name": "安徽省"
		},
		{
			"code": "35",
			"name": "福建省"
		},
		{
			"code": "36",
			"name": "江西省"
		},
		{
			"code": "37",
			"name": "山东省"
		},
		{
			"code": "41",
			"name": "河南省"
		},
		{
			"code": "42",
			"name": "湖北省"
		},
		{
			"code": "43",
			"name": "湖南省"
		},
		{
			"code": "44",
			"name": "广东省"
		},
		{
			"code": "45",
			"name": "广西壮族自治区"
		},
		{
			"code": "46",
			"name": "海南省"
		},
		{
			"code": "50",
			"name": "重庆市"
		},
		{
			"code": "51",
			"name": "四川省"
		},
		{
			"code": "52",
			"name": "贵州省"
		},
		{
			"code": "53",
			"name": "云南省"
		},
		{
			"code": "54",
			"name": "西藏自治区"
		},
		{
			"code": "61",
			"name": "陕西省"
		},
		{
			"code": "62",
			"name": "甘肃省"
		},
		{
			"code": "63",
			"name": "青海省"
		},
		{
			"code": "64",
			"name": "宁夏回族自治区"
		},
		{
			"code": "65",
			"name": "新疆维吾尔自治区"
		}
	];

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(218),
	    root = __webpack_require__(124);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(124);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	var baseIndexOf = __webpack_require__(2510);
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array == null ? 0 : array.length;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	module.exports = arrayIncludes;


/***/ },
/* 898 */
/***/ function(module, exports) {

	/**
	 * This function is like `arrayIncludes` except that it accepts a comparator.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @param {Function} comparator The comparator invoked per element.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludesWith(array, value, comparator) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (comparator(value, array[index])) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arrayIncludesWith;


/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(2528),
	    isArguments = __webpack_require__(378),
	    isArray = __webpack_require__(125),
	    isBuffer = __webpack_require__(545),
	    isIndex = __webpack_require__(374),
	    isTypedArray = __webpack_require__(548);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 900 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(372),
	    eq = __webpack_require__(256);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(372),
	    eq = __webpack_require__(256);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 903 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = baseFindIndex;


/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(900),
	    isFlattenable = __webpack_require__(2553);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(2538);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(538),
	    toKey = __webpack_require__(299);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(2512),
	    isObjectLike = __webpack_require__(183);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 908 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(255),
	    arrayMap = __webpack_require__(534),
	    isArray = __webpack_require__(125),
	    isSymbol = __webpack_require__(380);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 910 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(532),
	    arrayIncludes = __webpack_require__(897),
	    arrayIncludesWith = __webpack_require__(898),
	    cacheHas = __webpack_require__(537),
	    createSet = __webpack_require__(2539),
	    setToArray = __webpack_require__(376);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 */
	function baseUniq(array, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      length = array.length,
	      isCommon = true,
	      result = [],
	      seen = result;
	
	  if (comparator) {
	    isCommon = false;
	    includes = arrayIncludesWith;
	  }
	  else if (length >= LARGE_ARRAY_SIZE) {
	    var set = iteratee ? null : createSet(array);
	    if (set) {
	      return setToArray(set);
	    }
	    isCommon = false;
	    includes = cacheHas;
	    seen = new SetCache;
	  }
	  else {
	    seen = iteratee ? [] : result;
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee ? iteratee(value) : value;
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var seenIndex = seen.length;
	      while (seenIndex--) {
	        if (seen[seenIndex] === computed) {
	          continue outer;
	        }
	      }
	      if (iteratee) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	    else if (!includes(seen, computed, comparator)) {
	      if (seen !== result) {
	        seen.push(computed);
	      }
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseUniq;


/***/ },
/* 912 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	var baseRepeat = __webpack_require__(2524),
	    baseToString = __webpack_require__(909),
	    castSlice = __webpack_require__(2531),
	    hasUnicode = __webpack_require__(539),
	    stringSize = __webpack_require__(542),
	    stringToArray = __webpack_require__(925);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeCeil = Math.ceil;
	
	/**
	 * Creates the padding for `string` based on `length`. The `chars` string
	 * is truncated if the number of characters exceeds `length`.
	 *
	 * @private
	 * @param {number} length The padding length.
	 * @param {string} [chars=' '] The string used as padding.
	 * @returns {string} Returns the padding for `string`.
	 */
	function createPadding(length, chars) {
	  chars = chars === undefined ? ' ' : baseToString(chars);
	
	  var charsLength = chars.length;
	  if (charsLength < 2) {
	    return charsLength ? baseRepeat(chars, length) : chars;
	  }
	  var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	  return hasUnicode(chars)
	    ? castSlice(stringToArray(result), 0, length).join('')
	    : result.slice(0, length);
	}
	
	module.exports = createPadding;


/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(218);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(532),
	    arraySome = __webpack_require__(2501),
	    cacheHas = __webpack_require__(537);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Check that cyclic values are equal.
	  var arrStacked = stack.get(array);
	  var othStacked = stack.get(other);
	  if (arrStacked && othStacked) {
	    return arrStacked == other && othStacked == array;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 916 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(923);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(2495),
	    Map = __webpack_require__(530),
	    Promise = __webpack_require__(2497),
	    Set = __webpack_require__(895),
	    WeakMap = __webpack_require__(2498),
	    baseGetTag = __webpack_require__(217),
	    toSource = __webpack_require__(926);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(538),
	    isArguments = __webpack_require__(378),
	    isArray = __webpack_require__(125),
	    isIndex = __webpack_require__(374),
	    isLength = __webpack_require__(547),
	    toKey = __webpack_require__(299);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(126);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 921 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 922 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 923 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 924 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function safeGet(object, key) {
	  if (key === 'constructor' && typeof object[key] === 'function') {
	    return;
	  }
	
	  if (key == '__proto__') {
	    return;
	  }
	
	  return object[key];
	}
	
	module.exports = safeGet;


/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	var asciiToArray = __webpack_require__(2503),
	    hasUnicode = __webpack_require__(539),
	    unicodeToArray = __webpack_require__(2587);
	
	/**
	 * Converts `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function stringToArray(string) {
	  return hasUnicode(string)
	    ? unicodeToArray(string)
	    : asciiToArray(string);
	}
	
	module.exports = stringToArray;


/***/ },
/* 926 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(899),
	    baseKeysIn = __webpack_require__(2518),
	    isArrayLike = __webpack_require__(301);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(2525);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	var baseTrim = __webpack_require__(2529),
	    isObject = __webpack_require__(126),
	    isSymbol = __webpack_require__(380);
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = baseTrim(value);
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = toNumber;


/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.storeShape = undefined;
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  setState: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Afrikaans [af]
	//! author : Werner Mollentze : https://github.com/wernerm
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var af = moment.defineLocale('af', {
	        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
	            '_'
	        ),
	        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
	        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
	        meridiemParse: /vm|nm/i,
	        isPM: function (input) {
	            return /^nm$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'vm' : 'VM';
	            } else {
	                return isLower ? 'nm' : 'NM';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Vandag om] LT',
	            nextDay: '[Môre om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[Gister om] LT',
	            lastWeek: '[Laas] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oor %s',
	            past: '%s gelede',
	            s: "'n paar sekondes",
	            ss: '%d sekondes',
	            m: "'n minuut",
	            mm: '%d minute',
	            h: "'n uur",
	            hh: '%d ure',
	            d: "'n dag",
	            dd: '%d dae',
	            M: "'n maand",
	            MM: '%d maande',
	            y: "'n jaar",
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            ); // Thanks to Joris Röling : https://github.com/jjupiter
	        },
	        week: {
	            dow: 1, // Maandag is die eerste dag van die week.
	            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
	        },
	    });
	
	    return af;
	
	})));


/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Algeria) [ar-dz]
	//! author : Amine Roukh: https://github.com/Amine27
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'جانفي',
	            'فيفري',
	            'مارس',
	            'أفريل',
	            'ماي',
	            'جوان',
	            'جويلية',
	            'أوت',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arDz = moment.defineLocale('ar-dz', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arDz;
	
	})));


/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Kuwait) [ar-kw]
	//! author : Nusret Parlak: https://github.com/nusretparlak
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arKw = moment.defineLocale('ar-kw', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arKw;
	
	})));


/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Libya) [ar-ly]
	//! author : Ali Hmer: https://github.com/kikoanis
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '1',
	            2: '2',
	            3: '3',
	            4: '4',
	            5: '5',
	            6: '6',
	            7: '7',
	            8: '8',
	            9: '9',
	            0: '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var arLy = moment.defineLocale('ar-ly', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return arLy;
	
	})));


/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Morocco) [ar-ma]
	//! author : ElFadili Yassine : https://github.com/ElFadiliY
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arMa = moment.defineLocale('ar-ma', {
	        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arMa;
	
	})));


/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic (Saudi Arabia) [ar-sa]
	//! author : Suhail Alkowaileet : https://github.com/xsoh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        };
	
	    var arSa = moment.defineLocale('ar-sa', {
	        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return arSa;
	
	})));


/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale  :  Arabic (Tunisia) [ar-tn]
	//! author : Nader Toukabri : https://github.com/naderio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var arTn = moment.defineLocale('ar-tn', {
	        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
	                '_'
	            ),
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[اليوم على الساعة] LT',
	            nextDay: '[غدا على الساعة] LT',
	            nextWeek: 'dddd [على الساعة] LT',
	            lastDay: '[أمس على الساعة] LT',
	            lastWeek: 'dddd [على الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'في %s',
	            past: 'منذ %s',
	            s: 'ثوان',
	            ss: '%d ثانية',
	            m: 'دقيقة',
	            mm: '%d دقائق',
	            h: 'ساعة',
	            hh: '%d ساعات',
	            d: 'يوم',
	            dd: '%d أيام',
	            M: 'شهر',
	            MM: '%d أشهر',
	            y: 'سنة',
	            yy: '%d سنوات',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return arTn;
	
	})));


/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Arabic [ar]
	//! author : Abdel Said: https://github.com/abdelsaid
	//! author : Ahmed Elkhatib
	//! author : forabi https://github.com/forabi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        pluralForm = function (n) {
	            return n === 0
	                ? 0
	                : n === 1
	                ? 1
	                : n === 2
	                ? 2
	                : n % 100 >= 3 && n % 100 <= 10
	                ? 3
	                : n % 100 >= 11
	                ? 4
	                : 5;
	        },
	        plurals = {
	            s: [
	                'أقل من ثانية',
	                'ثانية واحدة',
	                ['ثانيتان', 'ثانيتين'],
	                '%d ثوان',
	                '%d ثانية',
	                '%d ثانية',
	            ],
	            m: [
	                'أقل من دقيقة',
	                'دقيقة واحدة',
	                ['دقيقتان', 'دقيقتين'],
	                '%d دقائق',
	                '%d دقيقة',
	                '%d دقيقة',
	            ],
	            h: [
	                'أقل من ساعة',
	                'ساعة واحدة',
	                ['ساعتان', 'ساعتين'],
	                '%d ساعات',
	                '%d ساعة',
	                '%d ساعة',
	            ],
	            d: [
	                'أقل من يوم',
	                'يوم واحد',
	                ['يومان', 'يومين'],
	                '%d أيام',
	                '%d يومًا',
	                '%d يوم',
	            ],
	            M: [
	                'أقل من شهر',
	                'شهر واحد',
	                ['شهران', 'شهرين'],
	                '%d أشهر',
	                '%d شهرا',
	                '%d شهر',
	            ],
	            y: [
	                'أقل من عام',
	                'عام واحد',
	                ['عامان', 'عامين'],
	                '%d أعوام',
	                '%d عامًا',
	                '%d عام',
	            ],
	        },
	        pluralize = function (u) {
	            return function (number, withoutSuffix, string, isFuture) {
	                var f = pluralForm(number),
	                    str = plurals[u][pluralForm(number)];
	                if (f === 2) {
	                    str = str[withoutSuffix ? 0 : 1];
	                }
	                return str.replace(/%d/i, number);
	            };
	        },
	        months = [
	            'يناير',
	            'فبراير',
	            'مارس',
	            'أبريل',
	            'مايو',
	            'يونيو',
	            'يوليو',
	            'أغسطس',
	            'سبتمبر',
	            'أكتوبر',
	            'نوفمبر',
	            'ديسمبر',
	        ];
	
	    var ar = moment.defineLocale('ar', {
	        months: months,
	        monthsShort: months,
	        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
	        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
	        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/\u200FM/\u200FYYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ص|م/,
	        isPM: function (input) {
	            return 'م' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ص';
	            } else {
	                return 'م';
	            }
	        },
	        calendar: {
	            sameDay: '[اليوم عند الساعة] LT',
	            nextDay: '[غدًا عند الساعة] LT',
	            nextWeek: 'dddd [عند الساعة] LT',
	            lastDay: '[أمس عند الساعة] LT',
	            lastWeek: 'dddd [عند الساعة] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'بعد %s',
	            past: 'منذ %s',
	            s: pluralize('s'),
	            ss: pluralize('s'),
	            m: pluralize('m'),
	            mm: pluralize('m'),
	            h: pluralize('h'),
	            hh: pluralize('h'),
	            d: pluralize('d'),
	            dd: pluralize('d'),
	            M: pluralize('M'),
	            MM: pluralize('M'),
	            y: pluralize('y'),
	            yy: pluralize('y'),
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ar;
	
	})));


/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Azerbaijani [az]
	//! author : topchiyev : https://github.com/topchiyev
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: '-inci',
	        5: '-inci',
	        8: '-inci',
	        70: '-inci',
	        80: '-inci',
	        2: '-nci',
	        7: '-nci',
	        20: '-nci',
	        50: '-nci',
	        3: '-üncü',
	        4: '-üncü',
	        100: '-üncü',
	        6: '-ncı',
	        9: '-uncu',
	        10: '-uncu',
	        30: '-uncu',
	        60: '-ıncı',
	        90: '-ıncı',
	    };
	
	    var az = moment.defineLocale('az', {
	        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
	        weekdays:
	            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
	                '_'
	            ),
	        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
	        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[sabah saat] LT',
	            nextWeek: '[gələn həftə] dddd [saat] LT',
	            lastDay: '[dünən] LT',
	            lastWeek: '[keçən həftə] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s əvvəl',
	            s: 'bir neçə saniyə',
	            ss: '%d saniyə',
	            m: 'bir dəqiqə',
	            mm: '%d dəqiqə',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir il',
	            yy: '%d il',
	        },
	        meridiemParse: /gecə|səhər|gündüz|axşam/,
	        isPM: function (input) {
	            return /^(gündüz|axşam)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'gecə';
	            } else if (hour < 12) {
	                return 'səhər';
	            } else if (hour < 17) {
	                return 'gündüz';
	            } else {
	                return 'axşam';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
	        ordinal: function (number) {
	            if (number === 0) {
	                // special case for zero
	                return number + '-ıncı';
	            }
	            var a = number % 10,
	                b = (number % 100) - a,
	                c = number >= 100 ? 100 : null;
	            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return az;
	
	})));


/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Belarusian [be]
	//! author : Dmitry Demidov : https://github.com/demidov91
	//! author: Praleska: http://praleska.pro/
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
	            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
	            dd: 'дзень_дні_дзён',
	            MM: 'месяц_месяцы_месяцаў',
	            yy: 'год_гады_гадоў',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвіліна' : 'хвіліну';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'гадзіна' : 'гадзіну';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	
	    var be = moment.defineLocale('be', {
	        months: {
	            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
	                '_'
	            ),
	            standalone:
	                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
	        weekdays: {
	            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
	                '_'
	            ),
	            standalone:
	                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
	                    '_'
	                ),
	            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
	        },
	        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
	        },
	        calendar: {
	            sameDay: '[Сёння ў] LT',
	            nextDay: '[Заўтра ў] LT',
	            lastDay: '[Учора ў] LT',
	            nextWeek: function () {
	                return '[У] dddd [ў] LT';
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return '[У мінулую] dddd [ў] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                        return '[У мінулы] dddd [ў] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'праз %s',
	            past: '%s таму',
	            s: 'некалькі секунд',
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithPlural,
	            hh: relativeTimeWithPlural,
	            d: 'дзень',
	            dd: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночы|раніцы|дня|вечара/,
	        isPM: function (input) {
	            return /^(дня|вечара)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночы';
	            } else if (hour < 12) {
	                return 'раніцы';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечара';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return (number % 10 === 2 || number % 10 === 3) &&
	                        number % 100 !== 12 &&
	                        number % 100 !== 13
	                        ? number + '-і'
	                        : number + '-ы';
	                case 'D':
	                    return number + '-га';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return be;
	
	})));


/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bulgarian [bg]
	//! author : Krasen Borisov : https://github.com/kraz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bg = moment.defineLocale('bg', {
	        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Днес в] LT',
	            nextDay: '[Утре в] LT',
	            nextWeek: 'dddd [в] LT',
	            lastDay: '[Вчера в] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Миналата] dddd [в] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Миналия] dddd [в] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'след %s',
	            past: 'преди %s',
	            s: 'няколко секунди',
	            ss: '%d секунди',
	            m: 'минута',
	            mm: '%d минути',
	            h: 'час',
	            hh: '%d часа',
	            d: 'ден',
	            dd: '%d дена',
	            w: 'седмица',
	            ww: '%d седмици',
	            M: 'месец',
	            MM: '%d месеца',
	            y: 'година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bg;
	
	})));


/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bambara [bm]
	//! author : Estelle Comment : https://github.com/estellecomment
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var bm = moment.defineLocale('bm', {
	        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
	            '_'
	        ),
	        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
	        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
	        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
	        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'MMMM [tile] D [san] YYYY',
	            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bi lɛrɛ] LT',
	            nextDay: '[Sini lɛrɛ] LT',
	            nextWeek: 'dddd [don lɛrɛ] LT',
	            lastDay: '[Kunu lɛrɛ] LT',
	            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s kɔnɔ',
	            past: 'a bɛ %s bɔ',
	            s: 'sanga dama dama',
	            ss: 'sekondi %d',
	            m: 'miniti kelen',
	            mm: 'miniti %d',
	            h: 'lɛrɛ kelen',
	            hh: 'lɛrɛ %d',
	            d: 'tile kelen',
	            dd: 'tile %d',
	            M: 'kalo kelen',
	            MM: 'kalo %d',
	            y: 'san kelen',
	            yy: 'san %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return bm;
	
	})));


/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali (Bangladesh) [bn-bd]
	//! author : Asraf Hossain Patoary : https://github.com/ashwoolford
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bnBd = moment.defineLocale('bn-bd', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	
	        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'রাত') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ভোর') {
	                return hour;
	            } else if (meridiem === 'সকাল') {
	                return hour;
	            } else if (meridiem === 'দুপুর') {
	                return hour >= 3 ? hour : hour + 12;
	            } else if (meridiem === 'বিকাল') {
	                return hour + 12;
	            } else if (meridiem === 'সন্ধ্যা') {
	                return hour + 12;
	            }
	        },
	
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 6) {
	                return 'ভোর';
	            } else if (hour < 12) {
	                return 'সকাল';
	            } else if (hour < 15) {
	                return 'দুপুর';
	            } else if (hour < 18) {
	                return 'বিকাল';
	            } else if (hour < 20) {
	                return 'সন্ধ্যা';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bnBd;
	
	})));


/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bengali [bn]
	//! author : Kaushik Gandhi : https://github.com/kaushikgandhi
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '১',
	            2: '২',
	            3: '৩',
	            4: '৪',
	            5: '৫',
	            6: '৬',
	            7: '৭',
	            8: '৮',
	            9: '৯',
	            0: '০',
	        },
	        numberMap = {
	            '১': '1',
	            '২': '2',
	            '৩': '3',
	            '৪': '4',
	            '৫': '5',
	            '৬': '6',
	            '৭': '7',
	            '৮': '8',
	            '৯': '9',
	            '০': '0',
	        };
	
	    var bn = moment.defineLocale('bn', {
	        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
	            '_'
	        ),
	        monthsShort:
	            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
	                '_'
	            ),
	        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
	            '_'
	        ),
	        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
	        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm সময়',
	            LTS: 'A h:mm:ss সময়',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm সময়',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
	        },
	        calendar: {
	            sameDay: '[আজ] LT',
	            nextDay: '[আগামীকাল] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[গতকাল] LT',
	            lastWeek: '[গত] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s পরে',
	            past: '%s আগে',
	            s: 'কয়েক সেকেন্ড',
	            ss: '%d সেকেন্ড',
	            m: 'এক মিনিট',
	            mm: '%d মিনিট',
	            h: 'এক ঘন্টা',
	            hh: '%d ঘন্টা',
	            d: 'এক দিন',
	            dd: '%d দিন',
	            M: 'এক মাস',
	            MM: '%d মাস',
	            y: 'এক বছর',
	            yy: '%d বছর',
	        },
	        preparse: function (string) {
	            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'রাত' && hour >= 4) ||
	                (meridiem === 'দুপুর' && hour < 5) ||
	                meridiem === 'বিকাল'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'রাত';
	            } else if (hour < 10) {
	                return 'সকাল';
	            } else if (hour < 17) {
	                return 'দুপুর';
	            } else if (hour < 20) {
	                return 'বিকাল';
	            } else {
	                return 'রাত';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bn;
	
	})));


/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tibetan [bo]
	//! author : Thupten N. Chakrishar : https://github.com/vajradog
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '༡',
	            2: '༢',
	            3: '༣',
	            4: '༤',
	            5: '༥',
	            6: '༦',
	            7: '༧',
	            8: '༨',
	            9: '༩',
	            0: '༠',
	        },
	        numberMap = {
	            '༡': '1',
	            '༢': '2',
	            '༣': '3',
	            '༤': '4',
	            '༥': '5',
	            '༦': '6',
	            '༧': '7',
	            '༨': '8',
	            '༩': '9',
	            '༠': '0',
	        };
	
	    var bo = moment.defineLocale('bo', {
	        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
	                '_'
	            ),
	        monthsShortRegex: /^(ཟླ་\d{1,2})/,
	        monthsParseExact: true,
	        weekdays:
	            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
	                '_'
	            ),
	        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
	            '_'
	        ),
	        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[དི་རིང] LT',
	            nextDay: '[སང་ཉིན] LT',
	            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
	            lastDay: '[ཁ་སང] LT',
	            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ལ་',
	            past: '%s སྔན་ལ',
	            s: 'ལམ་སང',
	            ss: '%d སྐར་ཆ།',
	            m: 'སྐར་མ་གཅིག',
	            mm: '%d སྐར་མ',
	            h: 'ཆུ་ཚོད་གཅིག',
	            hh: '%d ཆུ་ཚོད',
	            d: 'ཉིན་གཅིག',
	            dd: '%d ཉིན་',
	            M: 'ཟླ་བ་གཅིག',
	            MM: '%d ཟླ་བ',
	            y: 'ལོ་གཅིག',
	            yy: '%d ལོ',
	        },
	        preparse: function (string) {
	            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'མཚན་མོ' && hour >= 4) ||
	                (meridiem === 'ཉིན་གུང' && hour < 5) ||
	                meridiem === 'དགོང་དག'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'མཚན་མོ';
	            } else if (hour < 10) {
	                return 'ཞོགས་ཀས';
	            } else if (hour < 17) {
	                return 'ཉིན་གུང';
	            } else if (hour < 20) {
	                return 'དགོང་དག';
	            } else {
	                return 'མཚན་མོ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return bo;
	
	})));


/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Breton [br]
	//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithMutation(number, withoutSuffix, key) {
	        var format = {
	            mm: 'munutenn',
	            MM: 'miz',
	            dd: 'devezh',
	        };
	        return number + ' ' + mutation(format[key], number);
	    }
	    function specialMutationForYears(number) {
	        switch (lastNumber(number)) {
	            case 1:
	            case 3:
	            case 4:
	            case 5:
	            case 9:
	                return number + ' bloaz';
	            default:
	                return number + ' vloaz';
	        }
	    }
	    function lastNumber(number) {
	        if (number > 9) {
	            return lastNumber(number % 10);
	        }
	        return number;
	    }
	    function mutation(text, number) {
	        if (number === 2) {
	            return softMutation(text);
	        }
	        return text;
	    }
	    function softMutation(text) {
	        var mutationTable = {
	            m: 'v',
	            b: 'v',
	            d: 'z',
	        };
	        if (mutationTable[text.charAt(0)] === undefined) {
	            return text;
	        }
	        return mutationTable[text.charAt(0)] + text.substring(1);
	    }
	
	    var monthsParse = [
	            /^gen/i,
	            /^c[ʼ\']hwe/i,
	            /^meu/i,
	            /^ebr/i,
	            /^mae/i,
	            /^(mez|eve)/i,
	            /^gou/i,
	            /^eos/i,
	            /^gwe/i,
	            /^her/i,
	            /^du/i,
	            /^ker/i,
	        ],
	        monthsRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        monthsStrictRegex =
	            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
	        monthsShortStrictRegex =
	            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
	        fullWeekdaysParse = [
	            /^sul/i,
	            /^lun/i,
	            /^meurzh/i,
	            /^merc[ʼ\']her/i,
	            /^yaou/i,
	            /^gwener/i,
	            /^sadorn/i,
	        ],
	        shortWeekdaysParse = [
	            /^Sul/i,
	            /^Lun/i,
	            /^Meu/i,
	            /^Mer/i,
	            /^Yao/i,
	            /^Gwe/i,
	            /^Sad/i,
	        ],
	        minWeekdaysParse = [
	            /^Su/i,
	            /^Lu/i,
	            /^Me([^r]|$)/i,
	            /^Mer/i,
	            /^Ya/i,
	            /^Gw/i,
	            /^Sa/i,
	        ];
	
	    var br = moment.defineLocale('br', {
	        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
	            '_'
	        ),
	        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
	        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
	        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
	        weekdaysParse: minWeekdaysParse,
	        fullWeekdaysParse: fullWeekdaysParse,
	        shortWeekdaysParse: shortWeekdaysParse,
	        minWeekdaysParse: minWeekdaysParse,
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [a viz] MMMM YYYY',
	            LLL: 'D [a viz] MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hiziv da] LT',
	            nextDay: '[Warcʼhoazh da] LT',
	            nextWeek: 'dddd [da] LT',
	            lastDay: '[Decʼh da] LT',
	            lastWeek: 'dddd [paset da] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'a-benn %s',
	            past: '%s ʼzo',
	            s: 'un nebeud segondennoù',
	            ss: '%d eilenn',
	            m: 'ur vunutenn',
	            mm: relativeTimeWithMutation,
	            h: 'un eur',
	            hh: '%d eur',
	            d: 'un devezh',
	            dd: relativeTimeWithMutation,
	            M: 'ur miz',
	            MM: relativeTimeWithMutation,
	            y: 'ur bloaz',
	            yy: specialMutationForYears,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'añ' : 'vet';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
	        isPM: function (token) {
	            return token === 'g.m.';
	        },
	        meridiem: function (hour, minute, isLower) {
	            return hour < 12 ? 'a.m.' : 'g.m.';
	        },
	    });
	
	    return br;
	
	})));


/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Bosnian [bs]
	//! author : Nedim Cholich : https://github.com/frontyard
	//! based on (hr) translation by Bojan Marković
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var bs = moment.defineLocale('bs', {
	        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                        return '[prošlu] dddd [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return bs;
	
	})));


/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Catalan [ca]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ca = moment.defineLocale('ca', {
	        months: {
	            standalone:
	                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
	                    '_'
	                ),
	            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
	                '_'
	            ),
	        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a les] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextDay: function () {
	                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastDay: function () {
	                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [passat a ' +
	                    (this.hours() !== 1 ? 'les' : 'la') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'uns segons',
	            ss: '%d segons',
	            m: 'un minut',
	            mm: '%d minuts',
	            h: 'una hora',
	            hh: '%d hores',
	            d: 'un dia',
	            dd: '%d dies',
	            M: 'un mes',
	            MM: '%d mesos',
	            y: 'un any',
	            yy: '%d anys',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ca;
	
	})));


/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Czech [cs]
	//! author : petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = {
	            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
	                '_'
	            ),
	            standalone:
	                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
	                    '_'
	                ),
	        },
	        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
	        monthsParse = [
	            /^led/i,
	            /^úno/i,
	            /^bře/i,
	            /^dub/i,
	            /^kvě/i,
	            /^(čvn|červen$|června)/i,
	            /^(čvc|červenec|července)/i,
	            /^srp/i,
	            /^zář/i,
	            /^říj/i,
	            /^lis/i,
	            /^pro/i,
	        ],
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsRegex =
	            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
	
	    function plural(n) {
	        return n > 1 && n < 5 && ~~(n / 10) !== 1;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekund');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minuty' : 'minut');
	                } else {
	                    return result + 'minutami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodin');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'den' : 'dnem';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dny' : 'dní');
	                } else {
	                    return result + 'dny';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'měsíce' : 'měsíců');
	                } else {
	                    return result + 'měsíci';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokem';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'let');
	                } else {
	                    return result + 'lety';
	                }
	        }
	    }
	
	    var cs = moment.defineLocale('cs', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
	        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
	        monthsStrictRegex:
	            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
	        monthsShortStrictRegex:
	            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
	        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
	        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	            l: 'D. M. YYYY',
	        },
	        calendar: {
	            sameDay: '[dnes v] LT',
	            nextDay: '[zítra v] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [v] LT';
	                    case 3:
	                        return '[ve středu v] LT';
	                    case 4:
	                        return '[ve čtvrtek v] LT';
	                    case 5:
	                        return '[v pátek v] LT';
	                    case 6:
	                        return '[v sobotu v] LT';
	                }
	            },
	            lastDay: '[včera v] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulou neděli v] LT';
	                    case 1:
	                    case 2:
	                        return '[minulé] dddd [v] LT';
	                    case 3:
	                        return '[minulou středu v] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [v] LT';
	                    case 6:
	                        return '[minulou sobotu v] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'před %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cs;
	
	})));


/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chuvash [cv]
	//! author : Anatoly Mironov : https://github.com/mirontoli
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cv = moment.defineLocale('cv', {
	        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
	            '_'
	        ),
	        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
	        weekdays:
	            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
	                '_'
	            ),
	        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
	        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
	            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
	        },
	        calendar: {
	            sameDay: '[Паян] LT [сехетре]',
	            nextDay: '[Ыран] LT [сехетре]',
	            lastDay: '[Ӗнер] LT [сехетре]',
	            nextWeek: '[Ҫитес] dddd LT [сехетре]',
	            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (output) {
	                var affix = /сехет$/i.exec(output)
	                    ? 'рен'
	                    : /ҫул$/i.exec(output)
	                    ? 'тан'
	                    : 'ран';
	                return output + affix;
	            },
	            past: '%s каялла',
	            s: 'пӗр-ик ҫеккунт',
	            ss: '%d ҫеккунт',
	            m: 'пӗр минут',
	            mm: '%d минут',
	            h: 'пӗр сехет',
	            hh: '%d сехет',
	            d: 'пӗр кун',
	            dd: '%d кун',
	            M: 'пӗр уйӑх',
	            MM: '%d уйӑх',
	            y: 'пӗр ҫул',
	            yy: '%d ҫул',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
	        ordinal: '%d-мӗш',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return cv;
	
	})));


/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Welsh [cy]
	//! author : Robert Allen : https://github.com/robgallen
	//! author : https://github.com/ryangreaves
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var cy = moment.defineLocale('cy', {
	        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
	            '_'
	        ),
	        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
	            '_'
	        ),
	        weekdays:
	            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
	        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
	        weekdaysParseExact: true,
	        // time formats are the same as en-gb
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Heddiw am] LT',
	            nextDay: '[Yfory am] LT',
	            nextWeek: 'dddd [am] LT',
	            lastDay: '[Ddoe am] LT',
	            lastWeek: 'dddd [diwethaf am] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'mewn %s',
	            past: '%s yn ôl',
	            s: 'ychydig eiliadau',
	            ss: '%d eiliad',
	            m: 'munud',
	            mm: '%d munud',
	            h: 'awr',
	            hh: '%d awr',
	            d: 'diwrnod',
	            dd: '%d diwrnod',
	            M: 'mis',
	            MM: '%d mis',
	            y: 'blwyddyn',
	            yy: '%d flynedd',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
	        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
	        ordinal: function (number) {
	            var b = number,
	                output = '',
	                lookup = [
	                    '',
	                    'af',
	                    'il',
	                    'ydd',
	                    'ydd',
	                    'ed',
	                    'ed',
	                    'ed',
	                    'fed',
	                    'fed',
	                    'fed', // 1af to 10fed
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'eg',
	                    'fed',
	                    'eg',
	                    'fed', // 11eg to 20fed
	                ];
	            if (b > 20) {
	                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
	                    output = 'fed'; // not 30ain, 70ain or 90ain
	                } else {
	                    output = 'ain';
	                }
	            } else if (b > 0) {
	                output = lookup[b];
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return cy;
	
	})));


/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Danish [da]
	//! author : Ulrik Nielsen : https://github.com/mrbase
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var da = moment.defineLocale('da', {
	        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'på dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[i] dddd[s kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'få sekunder',
	            ss: '%d sekunder',
	            m: 'et minut',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dage',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'et år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return da;
	
	})));


/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Austria) [de-at]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Martin Groller : https://github.com/MadMG
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deAt = moment.defineLocale('de-at', {
	        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deAt;
	
	})));


/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German (Switzerland) [de-ch]
	//! author : sschueller : https://github.com/sschueller
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var deCh = moment.defineLocale('de-ch', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return deCh;
	
	})));


/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : German [de]
	//! author : lluchs : https://github.com/lluchs
	//! author: Menelion Elensúle: https://github.com/Oire
	//! author : Mikolaj Dadela : https://github.com/mik01aj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eine Minute', 'einer Minute'],
	            h: ['eine Stunde', 'einer Stunde'],
	            d: ['ein Tag', 'einem Tag'],
	            dd: [number + ' Tage', number + ' Tagen'],
	            w: ['eine Woche', 'einer Woche'],
	            M: ['ein Monat', 'einem Monat'],
	            MM: [number + ' Monate', number + ' Monaten'],
	            y: ['ein Jahr', 'einem Jahr'],
	            yy: [number + ' Jahre', number + ' Jahren'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	
	    var de = moment.defineLocale('de', {
	        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays:
	            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY HH:mm',
	            LLLL: 'dddd, D. MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[heute um] LT [Uhr]',
	            sameElse: 'L',
	            nextDay: '[morgen um] LT [Uhr]',
	            nextWeek: 'dddd [um] LT [Uhr]',
	            lastDay: '[gestern um] LT [Uhr]',
	            lastWeek: '[letzten] dddd [um] LT [Uhr]',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: 'vor %s',
	            s: 'ein paar Sekunden',
	            ss: '%d Sekunden',
	            m: processRelativeTime,
	            mm: '%d Minuten',
	            h: processRelativeTime,
	            hh: '%d Stunden',
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            w: processRelativeTime,
	            ww: '%d Wochen',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return de;
	
	})));


/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maldivian [dv]
	//! author : Jawish Hameed : https://github.com/jawish
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'ޖެނުއަރީ',
	            'ފެބްރުއަރީ',
	            'މާރިޗު',
	            'އޭޕްރީލު',
	            'މޭ',
	            'ޖޫން',
	            'ޖުލައި',
	            'އޯގަސްޓު',
	            'ސެޕްޓެމްބަރު',
	            'އޮކްޓޯބަރު',
	            'ނޮވެމްބަރު',
	            'ޑިސެމްބަރު',
	        ],
	        weekdays = [
	            'އާދިއްތަ',
	            'ހޯމަ',
	            'އަންގާރަ',
	            'ބުދަ',
	            'ބުރާސްފަތި',
	            'ހުކުރު',
	            'ހޮނިހިރު',
	        ];
	
	    var dv = moment.defineLocale('dv', {
	        months: months,
	        monthsShort: months,
	        weekdays: weekdays,
	        weekdaysShort: weekdays,
	        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'D/M/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /މކ|މފ/,
	        isPM: function (input) {
	            return 'މފ' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'މކ';
	            } else {
	                return 'މފ';
	            }
	        },
	        calendar: {
	            sameDay: '[މިއަދު] LT',
	            nextDay: '[މާދަމާ] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[އިއްޔެ] LT',
	            lastWeek: '[ފާއިތުވި] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ތެރޭގައި %s',
	            past: 'ކުރިން %s',
	            s: 'ސިކުންތުކޮޅެއް',
	            ss: 'd% ސިކުންތު',
	            m: 'މިނިޓެއް',
	            mm: 'މިނިޓު %d',
	            h: 'ގަޑިއިރެއް',
	            hh: 'ގަޑިއިރު %d',
	            d: 'ދުވަހެއް',
	            dd: 'ދުވަސް %d',
	            M: 'މަހެއް',
	            MM: 'މަސް %d',
	            y: 'އަހަރެއް',
	            yy: 'އަހަރު %d',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 7, // Sunday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return dv;
	
	})));


/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Greek [el]
	//! author : Aggelos Karalias : https://github.com/mehiel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function isFunction(input) {
	        return (
	            (typeof Function !== 'undefined' && input instanceof Function) ||
	            Object.prototype.toString.call(input) === '[object Function]'
	        );
	    }
	
	    var el = moment.defineLocale('el', {
	        monthsNominativeEl:
	            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
	                '_'
	            ),
	        monthsGenitiveEl:
	            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
	                '_'
	            ),
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return this._monthsNominativeEl;
	            } else if (
	                typeof format === 'string' &&
	                /D/.test(format.substring(0, format.indexOf('MMMM')))
	            ) {
	                // if there is a day number before 'MMMM'
	                return this._monthsGenitiveEl[momentToFormat.month()];
	            } else {
	                return this._monthsNominativeEl[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
	        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
	            '_'
	        ),
	        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
	        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'μμ' : 'ΜΜ';
	            } else {
	                return isLower ? 'πμ' : 'ΠΜ';
	            }
	        },
	        isPM: function (input) {
	            return (input + '').toLowerCase()[0] === 'μ';
	        },
	        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendarEl: {
	            sameDay: '[Σήμερα {}] LT',
	            nextDay: '[Αύριο {}] LT',
	            nextWeek: 'dddd [{}] LT',
	            lastDay: '[Χθες {}] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 6:
	                        return '[το προηγούμενο] dddd [{}] LT';
	                    default:
	                        return '[την προηγούμενη] dddd [{}] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        calendar: function (key, mom) {
	            var output = this._calendarEl[key],
	                hours = mom && mom.hours();
	            if (isFunction(output)) {
	                output = output.apply(mom);
	            }
	            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
	        },
	        relativeTime: {
	            future: 'σε %s',
	            past: '%s πριν',
	            s: 'λίγα δευτερόλεπτα',
	            ss: '%d δευτερόλεπτα',
	            m: 'ένα λεπτό',
	            mm: '%d λεπτά',
	            h: 'μία ώρα',
	            hh: '%d ώρες',
	            d: 'μία μέρα',
	            dd: '%d μέρες',
	            M: 'ένας μήνας',
	            MM: '%d μήνες',
	            y: 'ένας χρόνος',
	            yy: '%d χρόνια',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}η/,
	        ordinal: '%dη',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4st is the first week of the year.
	        },
	    });
	
	    return el;
	
	})));


/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Australia) [en-au]
	//! author : Jared Morse : https://github.com/jarcoal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enAu = moment.defineLocale('en-au', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enAu;
	
	})));


/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Canada) [en-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enCa = moment.defineLocale('en-ca', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'YYYY-MM-DD',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY h:mm A',
	            LLLL: 'dddd, MMMM D, YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enCa;
	
	})));


/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (United Kingdom) [en-gb]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enGb = moment.defineLocale('en-gb', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enGb;
	
	})));


/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Ireland) [en-ie]
	//! author : Chris Cartlidge : https://github.com/chriscartlidge
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIe = moment.defineLocale('en-ie', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enIe;
	
	})));


/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Israel) [en-il]
	//! author : Chris Gedrim : https://github.com/chrisgedrim
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIl = moment.defineLocale('en-il', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	    });
	
	    return enIl;
	
	})));


/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (India) [en-in]
	//! author : Jatin Agrawal : https://github.com/jatinag22
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enIn = moment.defineLocale('en-in', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return enIn;
	
	})));


/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (New Zealand) [en-nz]
	//! author : Luke McGregor : https://github.com/lukemcgregor
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enNz = moment.defineLocale('en-nz', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enNz;
	
	})));


/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : English (Singapore) [en-sg]
	//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var enSg = moment.defineLocale('en-sg', {
	        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
	        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
	            '_'
	        ),
	        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
	        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Today at] LT',
	            nextDay: '[Tomorrow at] LT',
	            nextWeek: 'dddd [at] LT',
	            lastDay: '[Yesterday at] LT',
	            lastWeek: '[Last] dddd [at] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'in %s',
	            past: '%s ago',
	            s: 'a few seconds',
	            ss: '%d seconds',
	            m: 'a minute',
	            mm: '%d minutes',
	            h: 'an hour',
	            hh: '%d hours',
	            d: 'a day',
	            dd: '%d days',
	            M: 'a month',
	            MM: '%d months',
	            y: 'a year',
	            yy: '%d years',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return enSg;
	
	})));


/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Esperanto [eo]
	//! author : Colin Dean : https://github.com/colindean
	//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
	//! comment : miestasmia corrected the translation by colindean
	//! comment : Vivakvo corrected the translation by colindean and miestasmia
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eo = moment.defineLocale('eo', {
	        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
	        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
	        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: '[la] D[-an de] MMMM, YYYY',
	            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
	            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
	            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
	        },
	        meridiemParse: /[ap]\.t\.m/i,
	        isPM: function (input) {
	            return input.charAt(0).toLowerCase() === 'p';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'p.t.m.' : 'P.T.M.';
	            } else {
	                return isLower ? 'a.t.m.' : 'A.T.M.';
	            }
	        },
	        calendar: {
	            sameDay: '[Hodiaŭ je] LT',
	            nextDay: '[Morgaŭ je] LT',
	            nextWeek: 'dddd[n je] LT',
	            lastDay: '[Hieraŭ je] LT',
	            lastWeek: '[pasintan] dddd[n je] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'post %s',
	            past: 'antaŭ %s',
	            s: 'kelkaj sekundoj',
	            ss: '%d sekundoj',
	            m: 'unu minuto',
	            mm: '%d minutoj',
	            h: 'unu horo',
	            hh: '%d horoj',
	            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
	            dd: '%d tagoj',
	            M: 'unu monato',
	            MM: '%d monatoj',
	            y: 'unu jaro',
	            yy: '%d jaroj',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}a/,
	        ordinal: '%da',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eo;
	
	})));


/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Dominican Republic) [es-do]
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esDo = moment.defineLocale('es-do', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return esDo;
	
	})));


/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (Mexico) [es-mx]
	//! author : JC Franco : https://github.com/jcfranco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esMx = moment.defineLocale('es-mx', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return esMx;
	
	})));


/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish (United States) [es-us]
	//! author : bustta : https://github.com/bustta
	//! author : chrisrodz : https://github.com/chrisrodz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var esUs = moment.defineLocale('es-us', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'MM/DD/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY h:mm A',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return esUs;
	
	})));


/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Spanish [es]
	//! author : Julio Napurí : https://github.com/julionc
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortDot =
	            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
	                '_'
	            ),
	        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
	        monthsParse = [
	            /^ene/i,
	            /^feb/i,
	            /^mar/i,
	            /^abr/i,
	            /^may/i,
	            /^jun/i,
	            /^jul/i,
	            /^ago/i,
	            /^sep/i,
	            /^oct/i,
	            /^nov/i,
	            /^dic/i,
	        ],
	        monthsRegex =
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
	
	    var es = moment.defineLocale('es', {
	        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortDot;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShort[m.month()];
	            } else {
	                return monthsShortDot[m.month()];
	            }
	        },
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
	        monthsShortStrictRegex:
	            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastDay: function () {
	                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[el] dddd [pasado a la' +
	                    (this.hours() !== 1 ? 's' : '') +
	                    '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'en %s',
	            past: 'hace %s',
	            s: 'unos segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'una hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            w: 'una semana',
	            ww: '%d semanas',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un año',
	            yy: '%d años',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	        invalidDate: 'Fecha inválida',
	    });
	
	    return es;
	
	})));


/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Estonian [et]
	//! author : Henry Kehlmann : https://github.com/madhenry
	//! improvements : Illimar Tambek : https://github.com/ragulka
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
	            ss: [number + 'sekundi', number + 'sekundit'],
	            m: ['ühe minuti', 'üks minut'],
	            mm: [number + ' minuti', number + ' minutit'],
	            h: ['ühe tunni', 'tund aega', 'üks tund'],
	            hh: [number + ' tunni', number + ' tundi'],
	            d: ['ühe päeva', 'üks päev'],
	            M: ['kuu aja', 'kuu aega', 'üks kuu'],
	            MM: [number + ' kuu', number + ' kuud'],
	            y: ['ühe aasta', 'aasta', 'üks aasta'],
	            yy: [number + ' aasta', number + ' aastat'],
	        };
	        if (withoutSuffix) {
	            return format[key][2] ? format[key][2] : format[key][1];
	        }
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var et = moment.defineLocale('et', {
	        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
	        weekdays:
	            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
	                '_'
	            ),
	        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
	        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Täna,] LT',
	            nextDay: '[Homme,] LT',
	            nextWeek: '[Järgmine] dddd LT',
	            lastDay: '[Eile,] LT',
	            lastWeek: '[Eelmine] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s pärast',
	            past: '%s tagasi',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: '%d päeva',
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return et;
	
	})));


/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Basque [eu]
	//! author : Eneko Illarramendi : https://github.com/eillarra
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var eu = moment.defineLocale('eu', {
	        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
	            '_'
	        ),
	        monthsShort:
	            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
	                '_'
	            ),
	        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
	        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY[ko] MMMM[ren] D[a]',
	            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
	            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
	            l: 'YYYY-M-D',
	            ll: 'YYYY[ko] MMM D[a]',
	            lll: 'YYYY[ko] MMM D[a] HH:mm',
	            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
	        },
	        calendar: {
	            sameDay: '[gaur] LT[etan]',
	            nextDay: '[bihar] LT[etan]',
	            nextWeek: 'dddd LT[etan]',
	            lastDay: '[atzo] LT[etan]',
	            lastWeek: '[aurreko] dddd LT[etan]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s barru',
	            past: 'duela %s',
	            s: 'segundo batzuk',
	            ss: '%d segundo',
	            m: 'minutu bat',
	            mm: '%d minutu',
	            h: 'ordu bat',
	            hh: '%d ordu',
	            d: 'egun bat',
	            dd: '%d egun',
	            M: 'hilabete bat',
	            MM: '%d hilabete',
	            y: 'urte bat',
	            yy: '%d urte',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return eu;
	
	})));


/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Persian [fa]
	//! author : Ebrahim Byagowi : https://github.com/ebraminio
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '۱',
	            2: '۲',
	            3: '۳',
	            4: '۴',
	            5: '۵',
	            6: '۶',
	            7: '۷',
	            8: '۸',
	            9: '۹',
	            0: '۰',
	        },
	        numberMap = {
	            '۱': '1',
	            '۲': '2',
	            '۳': '3',
	            '۴': '4',
	            '۵': '5',
	            '۶': '6',
	            '۷': '7',
	            '۸': '8',
	            '۹': '9',
	            '۰': '0',
	        };
	
	    var fa = moment.defineLocale('fa', {
	        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	            '_'
	        ),
	        monthsShort:
	            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
	                '_'
	            ),
	        weekdays:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
	                '_'
	            ),
	        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /قبل از ظهر|بعد از ظهر/,
	        isPM: function (input) {
	            return /بعد از ظهر/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'قبل از ظهر';
	            } else {
	                return 'بعد از ظهر';
	            }
	        },
	        calendar: {
	            sameDay: '[امروز ساعت] LT',
	            nextDay: '[فردا ساعت] LT',
	            nextWeek: 'dddd [ساعت] LT',
	            lastDay: '[دیروز ساعت] LT',
	            lastWeek: 'dddd [پیش] [ساعت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'در %s',
	            past: '%s پیش',
	            s: 'چند ثانیه',
	            ss: '%d ثانیه',
	            m: 'یک دقیقه',
	            mm: '%d دقیقه',
	            h: 'یک ساعت',
	            hh: '%d ساعت',
	            d: 'یک روز',
	            dd: '%d روز',
	            M: 'یک ماه',
	            MM: '%d ماه',
	            y: 'یک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[۰-۹]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}م/,
	        ordinal: '%dم',
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return fa;
	
	})));


/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Finnish [fi]
	//! author : Tarmo Aidantausta : https://github.com/bleadof
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersPast =
	            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
	                ' '
	            ),
	        numbersFuture = [
	            'nolla',
	            'yhden',
	            'kahden',
	            'kolmen',
	            'neljän',
	            'viiden',
	            'kuuden',
	            numbersPast[7],
	            numbersPast[8],
	            numbersPast[9],
	        ];
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = '';
	        switch (key) {
	            case 's':
	                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
	            case 'ss':
	                result = isFuture ? 'sekunnin' : 'sekuntia';
	                break;
	            case 'm':
	                return isFuture ? 'minuutin' : 'minuutti';
	            case 'mm':
	                result = isFuture ? 'minuutin' : 'minuuttia';
	                break;
	            case 'h':
	                return isFuture ? 'tunnin' : 'tunti';
	            case 'hh':
	                result = isFuture ? 'tunnin' : 'tuntia';
	                break;
	            case 'd':
	                return isFuture ? 'päivän' : 'päivä';
	            case 'dd':
	                result = isFuture ? 'päivän' : 'päivää';
	                break;
	            case 'M':
	                return isFuture ? 'kuukauden' : 'kuukausi';
	            case 'MM':
	                result = isFuture ? 'kuukauden' : 'kuukautta';
	                break;
	            case 'y':
	                return isFuture ? 'vuoden' : 'vuosi';
	            case 'yy':
	                result = isFuture ? 'vuoden' : 'vuotta';
	                break;
	        }
	        result = verbalNumber(number, isFuture) + ' ' + result;
	        return result;
	    }
	    function verbalNumber(number, isFuture) {
	        return number < 10
	            ? isFuture
	                ? numbersFuture[number]
	                : numbersPast[number]
	            : number;
	    }
	
	    var fi = moment.defineLocale('fi', {
	        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
	            '_'
	        ),
	        monthsShort:
	            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
	                '_'
	            ),
	        weekdays:
	            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
	                '_'
	            ),
	        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM[ta] YYYY',
	            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
	            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
	            l: 'D.M.YYYY',
	            ll: 'Do MMM YYYY',
	            lll: 'Do MMM YYYY, [klo] HH.mm',
	            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
	        },
	        calendar: {
	            sameDay: '[tänään] [klo] LT',
	            nextDay: '[huomenna] [klo] LT',
	            nextWeek: 'dddd [klo] LT',
	            lastDay: '[eilen] [klo] LT',
	            lastWeek: '[viime] dddd[na] [klo] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s päästä',
	            past: '%s sitten',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fi;
	
	})));


/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Filipino [fil]
	//! author : Dan Hagman : https://github.com/hagmandan
	//! author : Matthew Co : https://github.com/matthewdeeco
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fil = moment.defineLocale('fil', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fil;
	
	})));


/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Faroese [fo]
	//! author : Ragnar Johannesen : https://github.com/ragnar123
	//! author : Kristian Sakarisson : https://github.com/sakarisson
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var fo = moment.defineLocale('fo', {
	        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
	        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D. MMMM, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Í dag kl.] LT',
	            nextDay: '[Í morgin kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[Í gjár kl.] LT',
	            lastWeek: '[síðstu] dddd [kl] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'um %s',
	            past: '%s síðani',
	            s: 'fá sekund',
	            ss: '%d sekundir',
	            m: 'ein minuttur',
	            mm: '%d minuttir',
	            h: 'ein tími',
	            hh: '%d tímar',
	            d: 'ein dagur',
	            dd: '%d dagar',
	            M: 'ein mánaður',
	            MM: '%d mánaðir',
	            y: 'eitt ár',
	            yy: '%d ár',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fo;
	
	})));


/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Canada) [fr-ca]
	//! author : Jonathan Abourbih : https://github.com/jonbca
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCa = moment.defineLocale('fr-ca', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	    });
	
	    return frCa;
	
	})));


/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French (Switzerland) [fr-ch]
	//! author : Gaspard Bucher : https://github.com/gaspard
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var frCh = moment.defineLocale('fr-ch', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'D':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return frCh;
	
	})));


/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : French [fr]
	//! author : John Fischer : https://github.com/jfroffice
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsStrictRegex =
	            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsShortStrictRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
	        monthsRegex =
	            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
	        monthsParse = [
	            /^janv/i,
	            /^févr/i,
	            /^mars/i,
	            /^avr/i,
	            /^mai/i,
	            /^juin/i,
	            /^juil/i,
	            /^août/i,
	            /^sept/i,
	            /^oct/i,
	            /^nov/i,
	            /^déc/i,
	        ];
	
	    var fr = moment.defineLocale('fr', {
	        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
	            '_'
	        ),
	        monthsShort:
	            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
	                '_'
	            ),
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex: monthsStrictRegex,
	        monthsShortStrictRegex: monthsShortStrictRegex,
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
	        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
	        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Aujourd’hui à] LT',
	            nextDay: '[Demain à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[Hier à] LT',
	            lastWeek: 'dddd [dernier à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dans %s',
	            past: 'il y a %s',
	            s: 'quelques secondes',
	            ss: '%d secondes',
	            m: 'une minute',
	            mm: '%d minutes',
	            h: 'une heure',
	            hh: '%d heures',
	            d: 'un jour',
	            dd: '%d jours',
	            w: 'une semaine',
	            ww: '%d semaines',
	            M: 'un mois',
	            MM: '%d mois',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // TODO: Return 'e' when day of month > 1. Move this case inside
	                // block for masculine words below.
	                // See https://github.com/moment/moment/issues/3375
	                case 'D':
	                    return number + (number === 1 ? 'er' : '');
	
	                // Words with masculine grammatical gender: mois, trimestre, jour
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                    return number + (number === 1 ? 'er' : 'e');
	
	                // Words with feminine grammatical gender: semaine
	                case 'w':
	                case 'W':
	                    return number + (number === 1 ? 're' : 'e');
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fr;
	
	})));


/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Frisian [fy]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');
	
	    var fy = moment.defineLocale('fy', {
	        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	        monthsParseExact: true,
	        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
	            '_'
	        ),
	        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
	        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[hjoed om] LT',
	            nextDay: '[moarn om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[juster om] LT',
	            lastWeek: '[ôfrûne] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'oer %s',
	            past: '%s lyn',
	            s: 'in pear sekonden',
	            ss: '%d sekonden',
	            m: 'ien minút',
	            mm: '%d minuten',
	            h: 'ien oere',
	            hh: '%d oeren',
	            d: 'ien dei',
	            dd: '%d dagen',
	            M: 'ien moanne',
	            MM: '%d moannen',
	            y: 'ien jier',
	            yy: '%d jierren',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return fy;
	
	})));


/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Irish or Irish Gaelic [ga]
	//! author : André Silva : https://github.com/askpt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Eanáir',
	            'Feabhra',
	            'Márta',
	            'Aibreán',
	            'Bealtaine',
	            'Meitheamh',
	            'Iúil',
	            'Lúnasa',
	            'Meán Fómhair',
	            'Deireadh Fómhair',
	            'Samhain',
	            'Nollaig',
	        ],
	        monthsShort = [
	            'Ean',
	            'Feabh',
	            'Márt',
	            'Aib',
	            'Beal',
	            'Meith',
	            'Iúil',
	            'Lún',
	            'M.F.',
	            'D.F.',
	            'Samh',
	            'Noll',
	        ],
	        weekdays = [
	            'Dé Domhnaigh',
	            'Dé Luain',
	            'Dé Máirt',
	            'Dé Céadaoin',
	            'Déardaoin',
	            'Dé hAoine',
	            'Dé Sathairn',
	        ],
	        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
	        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];
	
	    var ga = moment.defineLocale('ga', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Inniu ag] LT',
	            nextDay: '[Amárach ag] LT',
	            nextWeek: 'dddd [ag] LT',
	            lastDay: '[Inné ag] LT',
	            lastWeek: 'dddd [seo caite] [ag] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i %s',
	            past: '%s ó shin',
	            s: 'cúpla soicind',
	            ss: '%d soicind',
	            m: 'nóiméad',
	            mm: '%d nóiméad',
	            h: 'uair an chloig',
	            hh: '%d uair an chloig',
	            d: 'lá',
	            dd: '%d lá',
	            M: 'mí',
	            MM: '%d míonna',
	            y: 'bliain',
	            yy: '%d bliain',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ga;
	
	})));


/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Scottish Gaelic [gd]
	//! author : Jon Ashdown : https://github.com/jonashdown
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'Am Faoilleach',
	            'An Gearran',
	            'Am Màrt',
	            'An Giblean',
	            'An Cèitean',
	            'An t-Ògmhios',
	            'An t-Iuchar',
	            'An Lùnastal',
	            'An t-Sultain',
	            'An Dàmhair',
	            'An t-Samhain',
	            'An Dùbhlachd',
	        ],
	        monthsShort = [
	            'Faoi',
	            'Gear',
	            'Màrt',
	            'Gibl',
	            'Cèit',
	            'Ògmh',
	            'Iuch',
	            'Lùn',
	            'Sult',
	            'Dàmh',
	            'Samh',
	            'Dùbh',
	        ],
	        weekdays = [
	            'Didòmhnaich',
	            'Diluain',
	            'Dimàirt',
	            'Diciadain',
	            'Diardaoin',
	            'Dihaoine',
	            'Disathairne',
	        ],
	        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
	        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];
	
	    var gd = moment.defineLocale('gd', {
	        months: months,
	        monthsShort: monthsShort,
	        monthsParseExact: true,
	        weekdays: weekdays,
	        weekdaysShort: weekdaysShort,
	        weekdaysMin: weekdaysMin,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[An-diugh aig] LT',
	            nextDay: '[A-màireach aig] LT',
	            nextWeek: 'dddd [aig] LT',
	            lastDay: '[An-dè aig] LT',
	            lastWeek: 'dddd [seo chaidh] [aig] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ann an %s',
	            past: 'bho chionn %s',
	            s: 'beagan diogan',
	            ss: '%d diogan',
	            m: 'mionaid',
	            mm: '%d mionaidean',
	            h: 'uair',
	            hh: '%d uairean',
	            d: 'latha',
	            dd: '%d latha',
	            M: 'mìos',
	            MM: '%d mìosan',
	            y: 'bliadhna',
	            yy: '%d bliadhna',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
	        ordinal: function (number) {
	            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gd;
	
	})));


/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Galician [gl]
	//! author : Juan G. Hurtado : https://github.com/juanghurtado
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var gl = moment.defineLocale('gl', {
	        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
	            '_'
	        ),
	        monthsShort:
	            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
	        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
	        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY H:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextDay: function () {
	                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
	            },
	            nextWeek: function () {
	                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
	            },
	            lastDay: function () {
	                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
	            },
	            lastWeek: function () {
	                return (
	                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
	                );
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (str) {
	                if (str.indexOf('un') === 0) {
	                    return 'n' + str;
	                }
	                return 'en ' + str;
	            },
	            past: 'hai %s',
	            s: 'uns segundos',
	            ss: '%d segundos',
	            m: 'un minuto',
	            mm: '%d minutos',
	            h: 'unha hora',
	            hh: '%d horas',
	            d: 'un día',
	            dd: '%d días',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return gl;
	
	})));


/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Devanagari script [gom-deva]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
	            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
	            m: ['एका मिणटान', 'एक मिनूट'],
	            mm: [number + ' मिणटांनी', number + ' मिणटां'],
	            h: ['एका वरान', 'एक वर'],
	            hh: [number + ' वरांनी', number + ' वरां'],
	            d: ['एका दिसान', 'एक दीस'],
	            dd: [number + ' दिसांनी', number + ' दीस'],
	            M: ['एका म्हयन्यान', 'एक म्हयनो'],
	            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
	            y: ['एका वर्सान', 'एक वर्स'],
	            yy: [number + ' वर्सांनी', number + ' वर्सां'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomDeva = moment.defineLocale('gom-deva', {
	        months: {
	            standalone:
	                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	                    '_'
	                ),
	            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
	        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
	        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [वाजतां]',
	            LTS: 'A h:mm:ss [वाजतां]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
	            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
	        },
	        calendar: {
	            sameDay: '[आयज] LT',
	            nextDay: '[फाल्यां] LT',
	            nextWeek: '[फुडलो] dddd[,] LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[फाटलो] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s आदीं',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'वेर' only applies to day of the month
	                case 'D':
	                    return number + 'वेर';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राती') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सकाळीं') {
	                return hour;
	            } else if (meridiem === 'दनपारां') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'सांजे') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'राती';
	            } else if (hour < 12) {
	                return 'सकाळीं';
	            } else if (hour < 16) {
	                return 'दनपारां';
	            } else if (hour < 20) {
	                return 'सांजे';
	            } else {
	                return 'राती';
	            }
	        },
	    });
	
	    return gomDeva;
	
	})));


/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Konkani Latin script [gom-latn]
	//! author : The Discoverer : https://github.com/WikiDiscoverer
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['thoddea sekondamni', 'thodde sekond'],
	            ss: [number + ' sekondamni', number + ' sekond'],
	            m: ['eka mintan', 'ek minut'],
	            mm: [number + ' mintamni', number + ' mintam'],
	            h: ['eka voran', 'ek vor'],
	            hh: [number + ' voramni', number + ' voram'],
	            d: ['eka disan', 'ek dis'],
	            dd: [number + ' disamni', number + ' dis'],
	            M: ['eka mhoinean', 'ek mhoino'],
	            MM: [number + ' mhoineamni', number + ' mhoine'],
	            y: ['eka vorsan', 'ek voros'],
	            yy: [number + ' vorsamni', number + ' vorsam'],
	        };
	        return isFuture ? format[key][0] : format[key][1];
	    }
	
	    var gomLatn = moment.defineLocale('gom-latn', {
	        months: {
	            standalone:
	                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
	                    '_'
	                ),
	            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
	                '_'
	            ),
	            isFormat: /MMMM(\s)+D[oD]?/,
	        },
	        monthsShort:
	            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
	        monthsParseExact: true,
	        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
	        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
	        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'A h:mm [vazta]',
	            LTS: 'A h:mm:ss [vazta]',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY A h:mm [vazta]',
	            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
	            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
	        },
	        calendar: {
	            sameDay: '[Aiz] LT',
	            nextDay: '[Faleam] LT',
	            nextWeek: '[Fuddlo] dddd[,] LT',
	            lastDay: '[Kal] LT',
	            lastWeek: '[Fattlo] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s',
	            past: '%s adim',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                // the ordinal 'er' only applies to day of the month
	                case 'D':
	                    return number + 'er';
	                default:
	                case 'M':
	                case 'Q':
	                case 'DDD':
	                case 'd':
	                case 'w':
	                case 'W':
	                    return number;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week
	            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
	        },
	        meridiemParse: /rati|sokallim|donparam|sanje/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'rati') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'sokallim') {
	                return hour;
	            } else if (meridiem === 'donparam') {
	                return hour > 12 ? hour : hour + 12;
	            } else if (meridiem === 'sanje') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'rati';
	            } else if (hour < 12) {
	                return 'sokallim';
	            } else if (hour < 16) {
	                return 'donparam';
	            } else if (hour < 20) {
	                return 'sanje';
	            } else {
	                return 'rati';
	            }
	        },
	    });
	
	    return gomLatn;
	
	})));


/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Gujarati [gu]
	//! author : Kaushik Thanki : https://github.com/Kaushik1987
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '૧',
	            2: '૨',
	            3: '૩',
	            4: '૪',
	            5: '૫',
	            6: '૬',
	            7: '૭',
	            8: '૮',
	            9: '૯',
	            0: '૦',
	        },
	        numberMap = {
	            '૧': '1',
	            '૨': '2',
	            '૩': '3',
	            '૪': '4',
	            '૫': '5',
	            '૬': '6',
	            '૭': '7',
	            '૮': '8',
	            '૯': '9',
	            '૦': '0',
	        };
	
	    var gu = moment.defineLocale('gu', {
	        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
	            '_'
	        ),
	        monthsShort:
	            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
	            '_'
	        ),
	        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
	        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm વાગ્યે',
	            LTS: 'A h:mm:ss વાગ્યે',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
	        },
	        calendar: {
	            sameDay: '[આજ] LT',
	            nextDay: '[કાલે] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ગઇકાલે] LT',
	            lastWeek: '[પાછલા] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s મા',
	            past: '%s પહેલા',
	            s: 'અમુક પળો',
	            ss: '%d સેકંડ',
	            m: 'એક મિનિટ',
	            mm: '%d મિનિટ',
	            h: 'એક કલાક',
	            hh: '%d કલાક',
	            d: 'એક દિવસ',
	            dd: '%d દિવસ',
	            M: 'એક મહિનો',
	            MM: '%d મહિનો',
	            y: 'એક વર્ષ',
	            yy: '%d વર્ષ',
	        },
	        preparse: function (string) {
	            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
	        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'રાત') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'સવાર') {
	                return hour;
	            } else if (meridiem === 'બપોર') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'સાંજ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'રાત';
	            } else if (hour < 10) {
	                return 'સવાર';
	            } else if (hour < 17) {
	                return 'બપોર';
	            } else if (hour < 20) {
	                return 'સાંજ';
	            } else {
	                return 'રાત';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return gu;
	
	})));


/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hebrew [he]
	//! author : Tomer Cohen : https://github.com/tomer
	//! author : Moshe Simantov : https://github.com/DevelopmentIL
	//! author : Tal Ater : https://github.com/TalAter
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var he = moment.defineLocale('he', {
	        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
	            '_'
	        ),
	        monthsShort:
	            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
	        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
	        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
	        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [ב]MMMM YYYY',
	            LLL: 'D [ב]MMMM YYYY HH:mm',
	            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[היום ב־]LT',
	            nextDay: '[מחר ב־]LT',
	            nextWeek: 'dddd [בשעה] LT',
	            lastDay: '[אתמול ב־]LT',
	            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'בעוד %s',
	            past: 'לפני %s',
	            s: 'מספר שניות',
	            ss: '%d שניות',
	            m: 'דקה',
	            mm: '%d דקות',
	            h: 'שעה',
	            hh: function (number) {
	                if (number === 2) {
	                    return 'שעתיים';
	                }
	                return number + ' שעות';
	            },
	            d: 'יום',
	            dd: function (number) {
	                if (number === 2) {
	                    return 'יומיים';
	                }
	                return number + ' ימים';
	            },
	            M: 'חודש',
	            MM: function (number) {
	                if (number === 2) {
	                    return 'חודשיים';
	                }
	                return number + ' חודשים';
	            },
	            y: 'שנה',
	            yy: function (number) {
	                if (number === 2) {
	                    return 'שנתיים';
	                } else if (number % 10 === 0 && number !== 10) {
	                    return number + ' שנה';
	                }
	                return number + ' שנים';
	            },
	        },
	        meridiemParse:
	            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
	        isPM: function (input) {
	            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 5) {
	                return 'לפנות בוקר';
	            } else if (hour < 10) {
	                return 'בבוקר';
	            } else if (hour < 12) {
	                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
	            } else if (hour < 18) {
	                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
	            } else {
	                return 'בערב';
	            }
	        },
	    });
	
	    return he;
	
	})));


/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hindi [hi]
	//! author : Mayank Singhal : https://github.com/mayanksinghal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        },
	        monthsParse = [
	            /^जन/i,
	            /^फ़र|फर/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सितं|सित/i,
	            /^अक्टू/i,
	            /^नव|नवं/i,
	            /^दिसं|दिस/i,
	        ],
	        shortMonthsParse = [
	            /^जन/i,
	            /^फ़र/i,
	            /^मार्च/i,
	            /^अप्रै/i,
	            /^मई/i,
	            /^जून/i,
	            /^जुल/i,
	            /^अग/i,
	            /^सित/i,
	            /^अक्टू/i,
	            /^नव/i,
	            /^दिस/i,
	        ];
	
	    var hi = moment.defineLocale('hi', {
	        months: {
	            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
	                '_'
	            ),
	            standalone:
	                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
	        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm बजे',
	            LTS: 'A h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
	        },
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: shortMonthsParse,
	
	        monthsRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsShortRegex:
	            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
	
	        monthsStrictRegex:
	            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
	
	        monthsShortStrictRegex:
	            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
	
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[कल] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[कल] LT',
	            lastWeek: '[पिछले] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s में',
	            past: '%s पहले',
	            s: 'कुछ ही क्षण',
	            ss: '%d सेकंड',
	            m: 'एक मिनट',
	            mm: '%d मिनट',
	            h: 'एक घंटा',
	            hh: '%d घंटे',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महीने',
	            MM: '%d महीने',
	            y: 'एक वर्ष',
	            yy: '%d वर्ष',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
	        meridiemParse: /रात|सुबह|दोपहर|शाम/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'रात') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'सुबह') {
	                return hour;
	            } else if (meridiem === 'दोपहर') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'शाम') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'रात';
	            } else if (hour < 10) {
	                return 'सुबह';
	            } else if (hour < 17) {
	                return 'दोपहर';
	            } else if (hour < 20) {
	                return 'शाम';
	            } else {
	                return 'रात';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return hi;
	
	})));


/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Croatian [hr]
	//! author : Bojan Marković : https://github.com/bmarkovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                if (number === 1) {
	                    result += 'sekunda';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sekunde';
	                } else {
	                    result += 'sekundi';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
	            case 'mm':
	                if (number === 1) {
	                    result += 'minuta';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'minute';
	                } else {
	                    result += 'minuta';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'jedan sat' : 'jednog sata';
	            case 'hh':
	                if (number === 1) {
	                    result += 'sat';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'sata';
	                } else {
	                    result += 'sati';
	                }
	                return result;
	            case 'dd':
	                if (number === 1) {
	                    result += 'dan';
	                } else {
	                    result += 'dana';
	                }
	                return result;
	            case 'MM':
	                if (number === 1) {
	                    result += 'mjesec';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'mjeseca';
	                } else {
	                    result += 'mjeseci';
	                }
	                return result;
	            case 'yy':
	                if (number === 1) {
	                    result += 'godina';
	                } else if (number === 2 || number === 3 || number === 4) {
	                    result += 'godine';
	                } else {
	                    result += 'godina';
	                }
	                return result;
	        }
	    }
	
	    var hr = moment.defineLocale('hr', {
	        months: {
	            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
	                '_'
	            ),
	            standalone:
	                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
	                    '_'
	                ),
	        },
	        monthsShort:
	            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'Do MMMM YYYY',
	            LLL: 'Do MMMM YYYY H:mm',
	            LLLL: 'dddd, Do MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[jučer u] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prošlu] [nedjelju] [u] LT';
	                    case 3:
	                        return '[prošlu] [srijedu] [u] LT';
	                    case 6:
	                        return '[prošle] [subote] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prošli] dddd [u] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'par sekundi',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: 'dan',
	            dd: translate,
	            M: 'mjesec',
	            MM: translate,
	            y: 'godinu',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hr;
	
	})));


/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Hungarian [hu]
	//! author : Adam Brunner : https://github.com/adambrunner
	//! author : Peter Viszt  : https://github.com/passatgt
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var weekEndings =
	        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
	    function translate(number, withoutSuffix, key, isFuture) {
	        var num = number;
	        switch (key) {
	            case 's':
	                return isFuture || withoutSuffix
	                    ? 'néhány másodperc'
	                    : 'néhány másodperce';
	            case 'ss':
	                return num + (isFuture || withoutSuffix)
	                    ? ' másodperc'
	                    : ' másodperce';
	            case 'm':
	                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'mm':
	                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
	            case 'h':
	                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'hh':
	                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
	            case 'd':
	                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'dd':
	                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
	            case 'M':
	                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'MM':
	                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
	            case 'y':
	                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
	            case 'yy':
	                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
	        }
	        return '';
	    }
	    function week(isFuture) {
	        return (
	            (isFuture ? '' : '[múlt] ') +
	            '[' +
	            weekEndings[this.day()] +
	            '] LT[-kor]'
	        );
	    }
	
	    var hu = moment.defineLocale('hu', {
	        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
	        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
	        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY. MMMM D.',
	            LLL: 'YYYY. MMMM D. H:mm',
	            LLLL: 'YYYY. MMMM D., dddd H:mm',
	        },
	        meridiemParse: /de|du/i,
	        isPM: function (input) {
	            return input.charAt(1).toLowerCase() === 'u';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower === true ? 'de' : 'DE';
	            } else {
	                return isLower === true ? 'du' : 'DU';
	            }
	        },
	        calendar: {
	            sameDay: '[ma] LT[-kor]',
	            nextDay: '[holnap] LT[-kor]',
	            nextWeek: function () {
	                return week.call(this, true);
	            },
	            lastDay: '[tegnap] LT[-kor]',
	            lastWeek: function () {
	                return week.call(this, false);
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s múlva',
	            past: '%s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return hu;
	
	})));


/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Armenian [hy-am]
	//! author : Armendarabyan : https://github.com/armendarabyan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var hyAm = moment.defineLocale('hy-am', {
	        months: {
	            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
	                '_'
	            ),
	            standalone:
	                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
	        weekdays:
	            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
	                '_'
	            ),
	        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY թ.',
	            LLL: 'D MMMM YYYY թ., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
	        },
	        calendar: {
	            sameDay: '[այսօր] LT',
	            nextDay: '[վաղը] LT',
	            lastDay: '[երեկ] LT',
	            nextWeek: function () {
	                return 'dddd [օրը ժամը] LT';
	            },
	            lastWeek: function () {
	                return '[անցած] dddd [օրը ժամը] LT';
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s հետո',
	            past: '%s առաջ',
	            s: 'մի քանի վայրկյան',
	            ss: '%d վայրկյան',
	            m: 'րոպե',
	            mm: '%d րոպե',
	            h: 'ժամ',
	            hh: '%d ժամ',
	            d: 'օր',
	            dd: '%d օր',
	            M: 'ամիս',
	            MM: '%d ամիս',
	            y: 'տարի',
	            yy: '%d տարի',
	        },
	        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
	        isPM: function (input) {
	            return /^(ցերեկվա|երեկոյան)$/.test(input);
	        },
	        meridiem: function (hour) {
	            if (hour < 4) {
	                return 'գիշերվա';
	            } else if (hour < 12) {
	                return 'առավոտվա';
	            } else if (hour < 17) {
	                return 'ցերեկվա';
	            } else {
	                return 'երեկոյան';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'DDD':
	                case 'w':
	                case 'W':
	                case 'DDDo':
	                    if (number === 1) {
	                        return number + '-ին';
	                    }
	                    return number + '-րդ';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return hyAm;
	
	})));


/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Indonesian [id]
	//! author : Mohammad Satrio Utomo : https://github.com/tyok
	//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var id = moment.defineLocale('id', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
	        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|siang|sore|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'siang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sore' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'siang';
	            } else if (hours < 19) {
	                return 'sore';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Besok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kemarin pukul] LT',
	            lastWeek: 'dddd [lalu pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lalu',
	            s: 'beberapa detik',
	            ss: '%d detik',
	            m: 'semenit',
	            mm: '%d menit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return id;
	
	})));


/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Icelandic [is]
	//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(n) {
	        if (n % 100 === 11) {
	            return true;
	        } else if (n % 10 === 1) {
	            return false;
	        }
	        return true;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nokkrar sekúndur'
	                    : 'nokkrum sekúndum';
	            case 'ss':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
	                    );
	                }
	                return result + 'sekúnda';
	            case 'm':
	                return withoutSuffix ? 'mínúta' : 'mínútu';
	            case 'mm':
	                if (plural(number)) {
	                    return (
	                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
	                    );
	                } else if (withoutSuffix) {
	                    return result + 'mínúta';
	                }
	                return result + 'mínútu';
	            case 'hh':
	                if (plural(number)) {
	                    return (
	                        result +
	                        (withoutSuffix || isFuture
	                            ? 'klukkustundir'
	                            : 'klukkustundum')
	                    );
	                }
	                return result + 'klukkustund';
	            case 'd':
	                if (withoutSuffix) {
	                    return 'dagur';
	                }
	                return isFuture ? 'dag' : 'degi';
	            case 'dd':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'dagar';
	                    }
	                    return result + (isFuture ? 'daga' : 'dögum');
	                } else if (withoutSuffix) {
	                    return result + 'dagur';
	                }
	                return result + (isFuture ? 'dag' : 'degi');
	            case 'M':
	                if (withoutSuffix) {
	                    return 'mánuður';
	                }
	                return isFuture ? 'mánuð' : 'mánuði';
	            case 'MM':
	                if (plural(number)) {
	                    if (withoutSuffix) {
	                        return result + 'mánuðir';
	                    }
	                    return result + (isFuture ? 'mánuði' : 'mánuðum');
	                } else if (withoutSuffix) {
	                    return result + 'mánuður';
	                }
	                return result + (isFuture ? 'mánuð' : 'mánuði');
	            case 'y':
	                return withoutSuffix || isFuture ? 'ár' : 'ári';
	            case 'yy':
	                if (plural(number)) {
	                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
	                }
	                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
	        }
	    }
	
	    var is = moment.defineLocale('is', {
	        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
	        weekdays:
	            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
	                '_'
	            ),
	        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
	        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
	        },
	        calendar: {
	            sameDay: '[í dag kl.] LT',
	            nextDay: '[á morgun kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[í gær kl.] LT',
	            lastWeek: '[síðasta] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'eftir %s',
	            past: 'fyrir %s síðan',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: 'klukkustund',
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return is;
	
	})));


/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian (Switzerland) [it-ch]
	//! author : xfh : https://github.com/xfh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var itCh = moment.defineLocale('it-ch', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Oggi alle] LT',
	            nextDay: '[Domani alle] LT',
	            nextWeek: 'dddd [alle] LT',
	            lastDay: '[Ieri alle] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[la scorsa] dddd [alle] LT';
	                    default:
	                        return '[lo scorso] dddd [alle] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
	            },
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return itCh;
	
	})));


/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Italian [it]
	//! author : Lorenzo : https://github.com/aliem
	//! author: Mattia Larentis: https://github.com/nostalgiaz
	//! author: Marco : https://github.com/Manfre98
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var it = moment.defineLocale('it', {
	        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
	            '_'
	        ),
	        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
	        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
	            '_'
	        ),
	        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
	        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: function () {
	                return (
	                    '[Oggi a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextDay: function () {
	                return (
	                    '[Domani a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            nextWeek: function () {
	                return (
	                    'dddd [a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastDay: function () {
	                return (
	                    '[Ieri a' +
	                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
	                    ']LT'
	                );
	            },
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return (
	                            '[La scorsa] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                    default:
	                        return (
	                            '[Lo scorso] dddd [a' +
	                            (this.hours() > 1
	                                ? 'lle '
	                                : this.hours() === 0
	                                ? ' '
	                                : "ll'") +
	                            ']LT'
	                        );
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'tra %s',
	            past: '%s fa',
	            s: 'alcuni secondi',
	            ss: '%d secondi',
	            m: 'un minuto',
	            mm: '%d minuti',
	            h: "un'ora",
	            hh: '%d ore',
	            d: 'un giorno',
	            dd: '%d giorni',
	            w: 'una settimana',
	            ww: '%d settimane',
	            M: 'un mese',
	            MM: '%d mesi',
	            y: 'un anno',
	            yy: '%d anni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return it;
	
	})));


/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Japanese [ja]
	//! author : LI Long : https://github.com/baryon
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ja = moment.defineLocale('ja', {
	        eras: [
	            {
	                since: '2019-05-01',
	                offset: 1,
	                name: '令和',
	                narrow: '㋿',
	                abbr: 'R',
	            },
	            {
	                since: '1989-01-08',
	                until: '2019-04-30',
	                offset: 1,
	                name: '平成',
	                narrow: '㍻',
	                abbr: 'H',
	            },
	            {
	                since: '1926-12-25',
	                until: '1989-01-07',
	                offset: 1,
	                name: '昭和',
	                narrow: '㍼',
	                abbr: 'S',
	            },
	            {
	                since: '1912-07-30',
	                until: '1926-12-24',
	                offset: 1,
	                name: '大正',
	                narrow: '㍽',
	                abbr: 'T',
	            },
	            {
	                since: '1873-01-01',
	                until: '1912-07-29',
	                offset: 6,
	                name: '明治',
	                narrow: '㍾',
	                abbr: 'M',
	            },
	            {
	                since: '0001-01-01',
	                until: '1873-12-31',
	                offset: 1,
	                name: '西暦',
	                narrow: 'AD',
	                abbr: 'AD',
	            },
	            {
	                since: '0000-12-31',
	                until: -Infinity,
	                offset: 1,
	                name: '紀元前',
	                narrow: 'BC',
	                abbr: 'BC',
	            },
	        ],
	        eraYearOrdinalRegex: /(元|\d+)年/,
	        eraYearOrdinalParse: function (input, match) {
	            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
	        },
	        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
	        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
	        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日 dddd HH:mm',
	            l: 'YYYY/MM/DD',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日(ddd) HH:mm',
	        },
	        meridiemParse: /午前|午後/i,
	        isPM: function (input) {
	            return input === '午後';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return '午前';
	            } else {
	                return '午後';
	            }
	        },
	        calendar: {
	            sameDay: '[今日] LT',
	            nextDay: '[明日] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    return '[来週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            lastDay: '[昨日] LT',
	            lastWeek: function (now) {
	                if (this.week() !== now.week()) {
	                    return '[先週]dddd LT';
	                } else {
	                    return 'dddd LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}日/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'y':
	                    return number === 1 ? '元年' : number + '年';
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '数秒',
	            ss: '%d秒',
	            m: '1分',
	            mm: '%d分',
	            h: '1時間',
	            hh: '%d時間',
	            d: '1日',
	            dd: '%d日',
	            M: '1ヶ月',
	            MM: '%dヶ月',
	            y: '1年',
	            yy: '%d年',
	        },
	    });
	
	    return ja;
	
	})));


/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Javanese [jv]
	//! author : Rony Lantip : https://github.com/lantip
	//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var jv = moment.defineLocale('jv', {
	        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
	        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
	        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
	        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /enjing|siyang|sonten|ndalu/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'enjing') {
	                return hour;
	            } else if (meridiem === 'siyang') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'enjing';
	            } else if (hours < 15) {
	                return 'siyang';
	            } else if (hours < 19) {
	                return 'sonten';
	            } else {
	                return 'ndalu';
	            }
	        },
	        calendar: {
	            sameDay: '[Dinten puniko pukul] LT',
	            nextDay: '[Mbenjang pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kala wingi pukul] LT',
	            lastWeek: 'dddd [kepengker pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'wonten ing %s',
	            past: '%s ingkang kepengker',
	            s: 'sawetawis detik',
	            ss: '%d detik',
	            m: 'setunggal menit',
	            mm: '%d menit',
	            h: 'setunggal jam',
	            hh: '%d jam',
	            d: 'sedinten',
	            dd: '%d dinten',
	            M: 'sewulan',
	            MM: '%d wulan',
	            y: 'setaun',
	            yy: '%d taun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return jv;
	
	})));


/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Georgian [ka]
	//! author : Irakli Janiashvili : https://github.com/IrakliJani
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ka = moment.defineLocale('ka', {
	        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
	            '_'
	        ),
	        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
	        weekdays: {
	            standalone:
	                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
	                    '_'
	                ),
	            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
	                '_'
	            ),
	            isFormat: /(წინა|შემდეგ)/,
	        },
	        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
	        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[დღეს] LT[-ზე]',
	            nextDay: '[ხვალ] LT[-ზე]',
	            lastDay: '[გუშინ] LT[-ზე]',
	            nextWeek: '[შემდეგ] dddd LT[-ზე]',
	            lastWeek: '[წინა] dddd LT-ზე',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: function (s) {
	                return s.replace(
	                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
	                    function ($0, $1, $2) {
	                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
	                    }
	                );
	            },
	            past: function (s) {
	                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
	                    return s.replace(/(ი|ე)$/, 'ის წინ');
	                }
	                if (/წელი/.test(s)) {
	                    return s.replace(/წელი$/, 'წლის წინ');
	                }
	                return s;
	            },
	            s: 'რამდენიმე წამი',
	            ss: '%d წამი',
	            m: 'წუთი',
	            mm: '%d წუთი',
	            h: 'საათი',
	            hh: '%d საათი',
	            d: 'დღე',
	            dd: '%d დღე',
	            M: 'თვე',
	            MM: '%d თვე',
	            y: 'წელი',
	            yy: '%d წელი',
	        },
	        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
	        ordinal: function (number) {
	            if (number === 0) {
	                return number;
	            }
	            if (number === 1) {
	                return number + '-ლი';
	            }
	            if (
	                number < 20 ||
	                (number <= 100 && number % 20 === 0) ||
	                number % 100 === 0
	            ) {
	                return 'მე-' + number;
	            }
	            return number + '-ე';
	        },
	        week: {
	            dow: 1,
	            doy: 7,
	        },
	    });
	
	    return ka;
	
	})));


/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kazakh [kk]
	//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ші',
	        1: '-ші',
	        2: '-ші',
	        3: '-ші',
	        4: '-ші',
	        5: '-ші',
	        6: '-шы',
	        7: '-ші',
	        8: '-ші',
	        9: '-шы',
	        10: '-шы',
	        20: '-шы',
	        30: '-шы',
	        40: '-шы',
	        50: '-ші',
	        60: '-шы',
	        70: '-ші',
	        80: '-ші',
	        90: '-шы',
	        100: '-ші',
	    };
	
	    var kk = moment.defineLocale('kk', {
	        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
	            '_'
	        ),
	        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
	        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
	            '_'
	        ),
	        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
	        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгін сағат] LT',
	            nextDay: '[Ертең сағат] LT',
	            nextWeek: 'dddd [сағат] LT',
	            lastDay: '[Кеше сағат] LT',
	            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ішінде',
	            past: '%s бұрын',
	            s: 'бірнеше секунд',
	            ss: '%d секунд',
	            m: 'бір минут',
	            mm: '%d минут',
	            h: 'бір сағат',
	            hh: '%d сағат',
	            d: 'бір күн',
	            dd: '%d күн',
	            M: 'бір ай',
	            MM: '%d ай',
	            y: 'бір жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return kk;
	
	})));


/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Cambodian [km]
	//! author : Kruy Vanna : https://github.com/kruyvanna
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '១',
	            2: '២',
	            3: '៣',
	            4: '៤',
	            5: '៥',
	            6: '៦',
	            7: '៧',
	            8: '៨',
	            9: '៩',
	            0: '០',
	        },
	        numberMap = {
	            '១': '1',
	            '២': '2',
	            '៣': '3',
	            '៤': '4',
	            '៥': '5',
	            '៦': '6',
	            '៧': '7',
	            '៨': '8',
	            '៩': '9',
	            '០': '0',
	        };
	
	    var km = moment.defineLocale('km', {
	        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	            '_'
	        ),
	        monthsShort:
	            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
	                '_'
	            ),
	        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
	        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ព្រឹក|ល្ងាច/,
	        isPM: function (input) {
	            return input === 'ល្ងាច';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ព្រឹក';
	            } else {
	                return 'ល្ងាច';
	            }
	        },
	        calendar: {
	            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
	            nextDay: '[ស្អែក ម៉ោង] LT',
	            nextWeek: 'dddd [ម៉ោង] LT',
	            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
	            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sទៀត',
	            past: '%sមុន',
	            s: 'ប៉ុន្មានវិនាទី',
	            ss: '%d វិនាទី',
	            m: 'មួយនាទី',
	            mm: '%d នាទី',
	            h: 'មួយម៉ោង',
	            hh: '%d ម៉ោង',
	            d: 'មួយថ្ងៃ',
	            dd: '%d ថ្ងៃ',
	            M: 'មួយខែ',
	            MM: '%d ខែ',
	            y: 'មួយឆ្នាំ',
	            yy: '%d ឆ្នាំ',
	        },
	        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
	        ordinal: 'ទី%d',
	        preparse: function (string) {
	            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return km;
	
	})));


/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kannada [kn]
	//! author : Rajeev Naik : https://github.com/rajeevnaikte
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '೧',
	            2: '೨',
	            3: '೩',
	            4: '೪',
	            5: '೫',
	            6: '೬',
	            7: '೭',
	            8: '೮',
	            9: '೯',
	            0: '೦',
	        },
	        numberMap = {
	            '೧': '1',
	            '೨': '2',
	            '೩': '3',
	            '೪': '4',
	            '೫': '5',
	            '೬': '6',
	            '೭': '7',
	            '೮': '8',
	            '೯': '9',
	            '೦': '0',
	        };
	
	    var kn = moment.defineLocale('kn', {
	        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
	            '_'
	        ),
	        monthsShort:
	            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
	        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[ಇಂದು] LT',
	            nextDay: '[ನಾಳೆ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ನಿನ್ನೆ] LT',
	            lastWeek: '[ಕೊನೆಯ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ನಂತರ',
	            past: '%s ಹಿಂದೆ',
	            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
	            ss: '%d ಸೆಕೆಂಡುಗಳು',
	            m: 'ಒಂದು ನಿಮಿಷ',
	            mm: '%d ನಿಮಿಷ',
	            h: 'ಒಂದು ಗಂಟೆ',
	            hh: '%d ಗಂಟೆ',
	            d: 'ಒಂದು ದಿನ',
	            dd: '%d ದಿನ',
	            M: 'ಒಂದು ತಿಂಗಳು',
	            MM: '%d ತಿಂಗಳು',
	            y: 'ಒಂದು ವರ್ಷ',
	            yy: '%d ವರ್ಷ',
	        },
	        preparse: function (string) {
	            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ರಾತ್ರಿ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
	                return hour;
	            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ಸಂಜೆ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ರಾತ್ರಿ';
	            } else if (hour < 10) {
	                return 'ಬೆಳಿಗ್ಗೆ';
	            } else if (hour < 17) {
	                return 'ಮಧ್ಯಾಹ್ನ';
	            } else if (hour < 20) {
	                return 'ಸಂಜೆ';
	            } else {
	                return 'ರಾತ್ರಿ';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
	        ordinal: function (number) {
	            return number + 'ನೇ';
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return kn;
	
	})));


/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Korean [ko]
	//! author : Kyungwook, Park : https://github.com/kyungw00k
	//! author : Jeeeyul Lee <jeeeyul@gmail.com>
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ko = moment.defineLocale('ko', {
	        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
	        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
	            '_'
	        ),
	        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
	        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
	        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'YYYY.MM.DD.',
	            LL: 'YYYY년 MMMM D일',
	            LLL: 'YYYY년 MMMM D일 A h:mm',
	            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
	            l: 'YYYY.MM.DD.',
	            ll: 'YYYY년 MMMM D일',
	            lll: 'YYYY년 MMMM D일 A h:mm',
	            llll: 'YYYY년 MMMM D일 dddd A h:mm',
	        },
	        calendar: {
	            sameDay: '오늘 LT',
	            nextDay: '내일 LT',
	            nextWeek: 'dddd LT',
	            lastDay: '어제 LT',
	            lastWeek: '지난주 dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s 후',
	            past: '%s 전',
	            s: '몇 초',
	            ss: '%d초',
	            m: '1분',
	            mm: '%d분',
	            h: '한 시간',
	            hh: '%d시간',
	            d: '하루',
	            dd: '%d일',
	            M: '한 달',
	            MM: '%d달',
	            y: '일 년',
	            yy: '%d년',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '일';
	                case 'M':
	                    return number + '월';
	                case 'w':
	                case 'W':
	                    return number + '주';
	                default:
	                    return number;
	            }
	        },
	        meridiemParse: /오전|오후/,
	        isPM: function (token) {
	            return token === '오후';
	        },
	        meridiem: function (hour, minute, isUpper) {
	            return hour < 12 ? '오전' : '오후';
	        },
	    });
	
	    return ko;
	
	})));


/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kurdish [ku]
	//! author : Shahram Mebashar : https://github.com/ShahramMebashar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '١',
	            2: '٢',
	            3: '٣',
	            4: '٤',
	            5: '٥',
	            6: '٦',
	            7: '٧',
	            8: '٨',
	            9: '٩',
	            0: '٠',
	        },
	        numberMap = {
	            '١': '1',
	            '٢': '2',
	            '٣': '3',
	            '٤': '4',
	            '٥': '5',
	            '٦': '6',
	            '٧': '7',
	            '٨': '8',
	            '٩': '9',
	            '٠': '0',
	        },
	        months = [
	            'کانونی دووەم',
	            'شوبات',
	            'ئازار',
	            'نیسان',
	            'ئایار',
	            'حوزەیران',
	            'تەمموز',
	            'ئاب',
	            'ئەیلوول',
	            'تشرینی یەكەم',
	            'تشرینی دووەم',
	            'كانونی یەکەم',
	        ];
	
	    var ku = moment.defineLocale('ku', {
	        months: months,
	        monthsShort: months,
	        weekdays:
	            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
	                '_'
	            ),
	        weekdaysShort:
	            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
	        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ئێواره‌|به‌یانی/,
	        isPM: function (input) {
	            return /ئێواره‌/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'به‌یانی';
	            } else {
	                return 'ئێواره‌';
	            }
	        },
	        calendar: {
	            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
	            nextDay: '[به‌یانی كاتژمێر] LT',
	            nextWeek: 'dddd [كاتژمێر] LT',
	            lastDay: '[دوێنێ كاتژمێر] LT',
	            lastWeek: 'dddd [كاتژمێر] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'له‌ %s',
	            past: '%s',
	            s: 'چه‌ند چركه‌یه‌ك',
	            ss: 'چركه‌ %d',
	            m: 'یه‌ك خوله‌ك',
	            mm: '%d خوله‌ك',
	            h: 'یه‌ك كاتژمێر',
	            hh: '%d كاتژمێر',
	            d: 'یه‌ك ڕۆژ',
	            dd: '%d ڕۆژ',
	            M: 'یه‌ك مانگ',
	            MM: '%d مانگ',
	            y: 'یه‌ك ساڵ',
	            yy: '%d ساڵ',
	        },
	        preparse: function (string) {
	            return string
	                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
	                    return numberMap[match];
	                })
	                .replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string
	                .replace(/\d/g, function (match) {
	                    return symbolMap[match];
	                })
	                .replace(/,/g, '،');
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return ku;
	
	})));


/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Kyrgyz [ky]
	//! author : Chyngyz Arystan uulu : https://github.com/chyngyz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-чү',
	        1: '-чи',
	        2: '-чи',
	        3: '-чү',
	        4: '-чү',
	        5: '-чи',
	        6: '-чы',
	        7: '-чи',
	        8: '-чи',
	        9: '-чу',
	        10: '-чу',
	        20: '-чы',
	        30: '-чу',
	        40: '-чы',
	        50: '-чү',
	        60: '-чы',
	        70: '-чи',
	        80: '-чи',
	        90: '-чу',
	        100: '-чү',
	    };
	
	    var ky = moment.defineLocale('ky', {
	        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
	            '_'
	        ),
	        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
	            '_'
	        ),
	        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
	        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бүгүн саат] LT',
	            nextDay: '[Эртең саат] LT',
	            nextWeek: 'dddd [саат] LT',
	            lastDay: '[Кечээ саат] LT',
	            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ичинде',
	            past: '%s мурун',
	            s: 'бирнече секунд',
	            ss: '%d секунд',
	            m: 'бир мүнөт',
	            mm: '%d мүнөт',
	            h: 'бир саат',
	            hh: '%d саат',
	            d: 'бир күн',
	            dd: '%d күн',
	            M: 'бир ай',
	            MM: '%d ай',
	            y: 'бир жыл',
	            yy: '%d жыл',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ky;
	
	})));


/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Luxembourgish [lb]
	//! author : mweimerskirch : https://github.com/mweimerskirch
	//! author : David Raison : https://github.com/kwisatz
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            m: ['eng Minutt', 'enger Minutt'],
	            h: ['eng Stonn', 'enger Stonn'],
	            d: ['een Dag', 'engem Dag'],
	            M: ['ee Mount', 'engem Mount'],
	            y: ['ee Joer', 'engem Joer'],
	        };
	        return withoutSuffix ? format[key][0] : format[key][1];
	    }
	    function processFutureTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'a ' + string;
	        }
	        return 'an ' + string;
	    }
	    function processPastTime(string) {
	        var number = string.substr(0, string.indexOf(' '));
	        if (eifelerRegelAppliesToNumber(number)) {
	            return 'viru ' + string;
	        }
	        return 'virun ' + string;
	    }
	    /**
	     * Returns true if the word before the given number loses the '-n' ending.
	     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
	     *
	     * @param number {integer}
	     * @returns {boolean}
	     */
	    function eifelerRegelAppliesToNumber(number) {
	        number = parseInt(number, 10);
	        if (isNaN(number)) {
	            return false;
	        }
	        if (number < 0) {
	            // Negative Number --> always true
	            return true;
	        } else if (number < 10) {
	            // Only 1 digit
	            if (4 <= number && number <= 7) {
	                return true;
	            }
	            return false;
	        } else if (number < 100) {
	            // 2 digits
	            var lastDigit = number % 10,
	                firstDigit = number / 10;
	            if (lastDigit === 0) {
	                return eifelerRegelAppliesToNumber(firstDigit);
	            }
	            return eifelerRegelAppliesToNumber(lastDigit);
	        } else if (number < 10000) {
	            // 3 or 4 digits --> recursively check first digit
	            while (number >= 10) {
	                number = number / 10;
	            }
	            return eifelerRegelAppliesToNumber(number);
	        } else {
	            // Anything larger than 4 digits: recursively check first n-3 digits
	            number = number / 1000;
	            return eifelerRegelAppliesToNumber(number);
	        }
	    }
	
	    var lb = moment.defineLocale('lb', {
	        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
	            '_'
	        ),
	        monthsShort:
	            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
	                '_'
	            ),
	        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
	        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm [Auer]',
	            LTS: 'H:mm:ss [Auer]',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm [Auer]',
	            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
	        },
	        calendar: {
	            sameDay: '[Haut um] LT',
	            sameElse: 'L',
	            nextDay: '[Muer um] LT',
	            nextWeek: 'dddd [um] LT',
	            lastDay: '[Gëschter um] LT',
	            lastWeek: function () {
	                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
	                switch (this.day()) {
	                    case 2:
	                    case 4:
	                        return '[Leschten] dddd [um] LT';
	                    default:
	                        return '[Leschte] dddd [um] LT';
	                }
	            },
	        },
	        relativeTime: {
	            future: processFutureTime,
	            past: processPastTime,
	            s: 'e puer Sekonnen',
	            ss: '%d Sekonnen',
	            m: processRelativeTime,
	            mm: '%d Minutten',
	            h: processRelativeTime,
	            hh: '%d Stonnen',
	            d: processRelativeTime,
	            dd: '%d Deeg',
	            M: processRelativeTime,
	            MM: '%d Méint',
	            y: processRelativeTime,
	            yy: '%d Joer',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lb;
	
	})));


/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lao [lo]
	//! author : Ryan Hart : https://github.com/ryanhart2
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var lo = moment.defineLocale('lo', {
	        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
	                '_'
	            ),
	        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
	        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
	        isPM: function (input) {
	            return input === 'ຕອນແລງ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ຕອນເຊົ້າ';
	            } else {
	                return 'ຕອນແລງ';
	            }
	        },
	        calendar: {
	            sameDay: '[ມື້ນີ້ເວລາ] LT',
	            nextDay: '[ມື້ອື່ນເວລາ] LT',
	            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
	            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
	            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ອີກ %s',
	            past: '%sຜ່ານມາ',
	            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
	            ss: '%d ວິນາທີ',
	            m: '1 ນາທີ',
	            mm: '%d ນາທີ',
	            h: '1 ຊົ່ວໂມງ',
	            hh: '%d ຊົ່ວໂມງ',
	            d: '1 ມື້',
	            dd: '%d ມື້',
	            M: '1 ເດືອນ',
	            MM: '%d ເດືອນ',
	            y: '1 ປີ',
	            yy: '%d ປີ',
	        },
	        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
	        ordinal: function (number) {
	            return 'ທີ່' + number;
	        },
	    });
	
	    return lo;
	
	})));


/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Lithuanian [lt]
	//! author : Mindaugas Mozūras : https://github.com/mmozuras
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundė_sekundžių_sekundes',
	        m: 'minutė_minutės_minutę',
	        mm: 'minutės_minučių_minutes',
	        h: 'valanda_valandos_valandą',
	        hh: 'valandos_valandų_valandas',
	        d: 'diena_dienos_dieną',
	        dd: 'dienos_dienų_dienas',
	        M: 'mėnuo_mėnesio_mėnesį',
	        MM: 'mėnesiai_mėnesių_mėnesius',
	        y: 'metai_metų_metus',
	        yy: 'metai_metų_metus',
	    };
	    function translateSeconds(number, withoutSuffix, key, isFuture) {
	        if (withoutSuffix) {
	            return 'kelios sekundės';
	        } else {
	            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
	        }
	    }
	    function translateSingular(number, withoutSuffix, key, isFuture) {
	        return withoutSuffix
	            ? forms(key)[0]
	            : isFuture
	            ? forms(key)[1]
	            : forms(key)[2];
	    }
	    function special(number) {
	        return number % 10 === 0 || (number > 10 && number < 20);
	    }
	    function forms(key) {
	        return units[key].split('_');
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        if (number === 1) {
	            return (
	                result + translateSingular(number, withoutSuffix, key[0], isFuture)
	            );
	        } else if (withoutSuffix) {
	            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
	        } else {
	            if (isFuture) {
	                return result + forms(key)[1];
	            } else {
	                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
	            }
	        }
	    }
	    var lt = moment.defineLocale('lt', {
	        months: {
	            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
	                '_'
	            ),
	            standalone:
	                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
	                    '_'
	                ),
	            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
	        },
	        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
	        weekdays: {
	            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
	                '_'
	            ),
	            standalone:
	                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
	                    '_'
	                ),
	            isFormat: /dddd HH:mm/,
	        },
	        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
	        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY [m.] MMMM D [d.]',
	            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
	            l: 'YYYY-MM-DD',
	            ll: 'YYYY [m.] MMMM D [d.]',
	            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
	            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
	        },
	        calendar: {
	            sameDay: '[Šiandien] LT',
	            nextDay: '[Rytoj] LT',
	            nextWeek: 'dddd LT',
	            lastDay: '[Vakar] LT',
	            lastWeek: '[Praėjusį] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'po %s',
	            past: 'prieš %s',
	            s: translateSeconds,
	            ss: translate,
	            m: translateSingular,
	            mm: translate,
	            h: translateSingular,
	            hh: translate,
	            d: translateSingular,
	            dd: translate,
	            M: translateSingular,
	            MM: translate,
	            y: translateSingular,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
	        ordinal: function (number) {
	            return number + '-oji';
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lt;
	
	})));


/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Latvian [lv]
	//! author : Kristaps Karlsons : https://github.com/skakri
	//! author : Jānis Elmeris : https://github.com/JanisE
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var units = {
	        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
	        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
	        h: 'stundas_stundām_stunda_stundas'.split('_'),
	        hh: 'stundas_stundām_stunda_stundas'.split('_'),
	        d: 'dienas_dienām_diena_dienas'.split('_'),
	        dd: 'dienas_dienām_diena_dienas'.split('_'),
	        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
	        y: 'gada_gadiem_gads_gadi'.split('_'),
	        yy: 'gada_gadiem_gads_gadi'.split('_'),
	    };
	    /**
	     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
	     */
	    function format(forms, number, withoutSuffix) {
	        if (withoutSuffix) {
	            // E.g. "21 minūte", "3 minūtes".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
	        } else {
	            // E.g. "21 minūtes" as in "pēc 21 minūtes".
	            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
	            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
	        }
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        return number + ' ' + format(units[key], number, withoutSuffix);
	    }
	    function relativeTimeWithSingular(number, withoutSuffix, key) {
	        return format(units[key], number, withoutSuffix);
	    }
	    function relativeSeconds(number, withoutSuffix) {
	        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
	    }
	
	    var lv = moment.defineLocale('lv', {
	        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
	        weekdays:
	            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
	                '_'
	            ),
	        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY.',
	            LL: 'YYYY. [gada] D. MMMM',
	            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
	            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
	        },
	        calendar: {
	            sameDay: '[Šodien pulksten] LT',
	            nextDay: '[Rīt pulksten] LT',
	            nextWeek: 'dddd [pulksten] LT',
	            lastDay: '[Vakar pulksten] LT',
	            lastWeek: '[Pagājušā] dddd [pulksten] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'pēc %s',
	            past: 'pirms %s',
	            s: relativeSeconds,
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithSingular,
	            mm: relativeTimeWithPlural,
	            h: relativeTimeWithSingular,
	            hh: relativeTimeWithPlural,
	            d: relativeTimeWithSingular,
	            dd: relativeTimeWithPlural,
	            M: relativeTimeWithSingular,
	            MM: relativeTimeWithPlural,
	            y: relativeTimeWithSingular,
	            yy: relativeTimeWithPlural,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return lv;
	
	})));


/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Montenegrin [me]
	//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekund', 'sekunda', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            dd: ['dan', 'dana', 'dana'],
	            MM: ['mjesec', 'mjeseca', 'mjeseci'],
	            yy: ['godina', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            return number === 1
	                ? wordKey[0]
	                : number >= 2 && number <= 4
	                ? wordKey[1]
	                : wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key) {
	            var wordKey = translator.words[key];
	            if (key.length === 1) {
	                return withoutSuffix ? wordKey[0] : wordKey[1];
	            } else {
	                return (
	                    number +
	                    ' ' +
	                    translator.correctGrammaticalCase(number, wordKey)
	                );
	            }
	        },
	    };
	
	    var me = moment.defineLocale('me', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sjutra u] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedjelju] [u] LT';
	                    case 3:
	                        return '[u] [srijedu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedjelje] [u] LT',
	                    '[prošlog] [ponedjeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srijede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'prije %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: 'dan',
	            dd: translator.translate,
	            M: 'mjesec',
	            MM: translator.translate,
	            y: 'godinu',
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return me;
	
	})));


/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maori [mi]
	//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mi = moment.defineLocale('mi', {
	        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
	            '_'
	        ),
	        monthsShort:
	            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
	                '_'
	            ),
	        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
	        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
	        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
	        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [i] HH:mm',
	            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i teie mahana, i] LT',
	            nextDay: '[apopo i] LT',
	            nextWeek: 'dddd [i] LT',
	            lastDay: '[inanahi i] LT',
	            lastWeek: 'dddd [whakamutunga i] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'i roto i %s',
	            past: '%s i mua',
	            s: 'te hēkona ruarua',
	            ss: '%d hēkona',
	            m: 'he meneti',
	            mm: '%d meneti',
	            h: 'te haora',
	            hh: '%d haora',
	            d: 'he ra',
	            dd: '%d ra',
	            M: 'he marama',
	            MM: '%d marama',
	            y: 'he tau',
	            yy: '%d tau',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mi;
	
	})));


/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Macedonian [mk]
	//! author : Borislav Mickov : https://github.com/B0k0
	//! author : Sashko Todorov : https://github.com/bkyceh
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mk = moment.defineLocale('mk', {
	        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
	            '_'
	        ),
	        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
	        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
	            '_'
	        ),
	        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
	        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[Денес во] LT',
	            nextDay: '[Утре во] LT',
	            nextWeek: '[Во] dddd [во] LT',
	            lastDay: '[Вчера во] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 6:
	                        return '[Изминатата] dddd [во] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[Изминатиот] dddd [во] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пред %s',
	            s: 'неколку секунди',
	            ss: '%d секунди',
	            m: 'една минута',
	            mm: '%d минути',
	            h: 'еден час',
	            hh: '%d часа',
	            d: 'еден ден',
	            dd: '%d дена',
	            M: 'еден месец',
	            MM: '%d месеци',
	            y: 'една година',
	            yy: '%d години',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
	        ordinal: function (number) {
	            var lastDigit = number % 10,
	                last2Digits = number % 100;
	            if (number === 0) {
	                return number + '-ев';
	            } else if (last2Digits === 0) {
	                return number + '-ен';
	            } else if (last2Digits > 10 && last2Digits < 20) {
	                return number + '-ти';
	            } else if (lastDigit === 1) {
	                return number + '-ви';
	            } else if (lastDigit === 2) {
	                return number + '-ри';
	            } else if (lastDigit === 7 || lastDigit === 8) {
	                return number + '-ми';
	            } else {
	                return number + '-ти';
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return mk;
	
	})));


/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malayalam [ml]
	//! author : Floyd Pink : https://github.com/floydpink
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ml = moment.defineLocale('ml', {
	        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
	                '_'
	            ),
	        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
	        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm -നു',
	            LTS: 'A h:mm:ss -നു',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm -നു',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
	        },
	        calendar: {
	            sameDay: '[ഇന്ന്] LT',
	            nextDay: '[നാളെ] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[ഇന്നലെ] LT',
	            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s കഴിഞ്ഞ്',
	            past: '%s മുൻപ്',
	            s: 'അൽപ നിമിഷങ്ങൾ',
	            ss: '%d സെക്കൻഡ്',
	            m: 'ഒരു മിനിറ്റ്',
	            mm: '%d മിനിറ്റ്',
	            h: 'ഒരു മണിക്കൂർ',
	            hh: '%d മണിക്കൂർ',
	            d: 'ഒരു ദിവസം',
	            dd: '%d ദിവസം',
	            M: 'ഒരു മാസം',
	            MM: '%d മാസം',
	            y: 'ഒരു വർഷം',
	            yy: '%d വർഷം',
	        },
	        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                (meridiem === 'രാത്രി' && hour >= 4) ||
	                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
	                meridiem === 'വൈകുന്നേരം'
	            ) {
	                return hour + 12;
	            } else {
	                return hour;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'രാത്രി';
	            } else if (hour < 12) {
	                return 'രാവിലെ';
	            } else if (hour < 17) {
	                return 'ഉച്ച കഴിഞ്ഞ്';
	            } else if (hour < 20) {
	                return 'വൈകുന്നേരം';
	            } else {
	                return 'രാത്രി';
	            }
	        },
	    });
	
	    return ml;
	
	})));


/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Mongolian [mn]
	//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function translate(number, withoutSuffix, key, isFuture) {
	        switch (key) {
	            case 's':
	                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
	            case 'ss':
	                return number + (withoutSuffix ? ' секунд' : ' секундын');
	            case 'm':
	            case 'mm':
	                return number + (withoutSuffix ? ' минут' : ' минутын');
	            case 'h':
	            case 'hh':
	                return number + (withoutSuffix ? ' цаг' : ' цагийн');
	            case 'd':
	            case 'dd':
	                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
	            case 'M':
	            case 'MM':
	                return number + (withoutSuffix ? ' сар' : ' сарын');
	            case 'y':
	            case 'yy':
	                return number + (withoutSuffix ? ' жил' : ' жилийн');
	            default:
	                return number;
	        }
	    }
	
	    var mn = moment.defineLocale('mn', {
	        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
	            '_'
	        ),
	        monthsShort:
	            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
	        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
	        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY оны MMMMын D',
	            LLL: 'YYYY оны MMMMын D HH:mm',
	            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
	        },
	        meridiemParse: /ҮӨ|ҮХ/i,
	        isPM: function (input) {
	            return input === 'ҮХ';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ҮӨ';
	            } else {
	                return 'ҮХ';
	            }
	        },
	        calendar: {
	            sameDay: '[Өнөөдөр] LT',
	            nextDay: '[Маргааш] LT',
	            nextWeek: '[Ирэх] dddd LT',
	            lastDay: '[Өчигдөр] LT',
	            lastWeek: '[Өнгөрсөн] dddd LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s дараа',
	            past: '%s өмнө',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + ' өдөр';
	                default:
	                    return number;
	            }
	        },
	    });
	
	    return mn;
	
	})));


/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Marathi [mr]
	//! author : Harshad Kale : https://github.com/kalehv
	//! author : Vivek Athalye : https://github.com/vnathalye
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
	        var output = '';
	        if (withoutSuffix) {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंद';
	                    break;
	                case 'ss':
	                    output = '%d सेकंद';
	                    break;
	                case 'm':
	                    output = 'एक मिनिट';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटे';
	                    break;
	                case 'h':
	                    output = 'एक तास';
	                    break;
	                case 'hh':
	                    output = '%d तास';
	                    break;
	                case 'd':
	                    output = 'एक दिवस';
	                    break;
	                case 'dd':
	                    output = '%d दिवस';
	                    break;
	                case 'M':
	                    output = 'एक महिना';
	                    break;
	                case 'MM':
	                    output = '%d महिने';
	                    break;
	                case 'y':
	                    output = 'एक वर्ष';
	                    break;
	                case 'yy':
	                    output = '%d वर्षे';
	                    break;
	            }
	        } else {
	            switch (string) {
	                case 's':
	                    output = 'काही सेकंदां';
	                    break;
	                case 'ss':
	                    output = '%d सेकंदां';
	                    break;
	                case 'm':
	                    output = 'एका मिनिटा';
	                    break;
	                case 'mm':
	                    output = '%d मिनिटां';
	                    break;
	                case 'h':
	                    output = 'एका तासा';
	                    break;
	                case 'hh':
	                    output = '%d तासां';
	                    break;
	                case 'd':
	                    output = 'एका दिवसा';
	                    break;
	                case 'dd':
	                    output = '%d दिवसां';
	                    break;
	                case 'M':
	                    output = 'एका महिन्या';
	                    break;
	                case 'MM':
	                    output = '%d महिन्यां';
	                    break;
	                case 'y':
	                    output = 'एका वर्षा';
	                    break;
	                case 'yy':
	                    output = '%d वर्षां';
	                    break;
	            }
	        }
	        return output.replace(/%d/i, number);
	    }
	
	    var mr = moment.defineLocale('mr', {
	        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
	        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
	        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm वाजता',
	            LTS: 'A h:mm:ss वाजता',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm वाजता',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[उद्या] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[काल] LT',
	            lastWeek: '[मागील] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमध्ये',
	            past: '%sपूर्वी',
	            s: relativeTimeMr,
	            ss: relativeTimeMr,
	            m: relativeTimeMr,
	            mm: relativeTimeMr,
	            h: relativeTimeMr,
	            hh: relativeTimeMr,
	            d: relativeTimeMr,
	            dd: relativeTimeMr,
	            M: relativeTimeMr,
	            MM: relativeTimeMr,
	            y: relativeTimeMr,
	            yy: relativeTimeMr,
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
	                return hour;
	            } else if (
	                meridiem === 'दुपारी' ||
	                meridiem === 'सायंकाळी' ||
	                meridiem === 'रात्री'
	            ) {
	                return hour >= 12 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour >= 0 && hour < 6) {
	                return 'पहाटे';
	            } else if (hour < 12) {
	                return 'सकाळी';
	            } else if (hour < 17) {
	                return 'दुपारी';
	            } else if (hour < 20) {
	                return 'सायंकाळी';
	            } else {
	                return 'रात्री';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return mr;
	
	})));


/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms-my]
	//! note : DEPRECATED, the correct one is [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var msMy = moment.defineLocale('ms-my', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return msMy;
	
	})));


/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Malay [ms]
	//! author : Weldan Jamili : https://github.com/weldan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ms = moment.defineLocale('ms', {
	        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
	        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
	        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
	        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [pukul] HH.mm',
	            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
	        },
	        meridiemParse: /pagi|tengahari|petang|malam/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'pagi') {
	                return hour;
	            } else if (meridiem === 'tengahari') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'petang' || meridiem === 'malam') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'pagi';
	            } else if (hours < 15) {
	                return 'tengahari';
	            } else if (hours < 19) {
	                return 'petang';
	            } else {
	                return 'malam';
	            }
	        },
	        calendar: {
	            sameDay: '[Hari ini pukul] LT',
	            nextDay: '[Esok pukul] LT',
	            nextWeek: 'dddd [pukul] LT',
	            lastDay: '[Kelmarin pukul] LT',
	            lastWeek: 'dddd [lepas pukul] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dalam %s',
	            past: '%s yang lepas',
	            s: 'beberapa saat',
	            ss: '%d saat',
	            m: 'seminit',
	            mm: '%d minit',
	            h: 'sejam',
	            hh: '%d jam',
	            d: 'sehari',
	            dd: '%d hari',
	            M: 'sebulan',
	            MM: '%d bulan',
	            y: 'setahun',
	            yy: '%d tahun',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ms;
	
	})));


/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Maltese (Malta) [mt]
	//! author : Alessandro Maruccia : https://github.com/alesma
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var mt = moment.defineLocale('mt', {
	        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
	        weekdays:
	            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
	                '_'
	            ),
	        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
	        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Illum fil-]LT',
	            nextDay: '[Għada fil-]LT',
	            nextWeek: 'dddd [fil-]LT',
	            lastDay: '[Il-bieraħ fil-]LT',
	            lastWeek: 'dddd [li għadda] [fil-]LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'f’ %s',
	            past: '%s ilu',
	            s: 'ftit sekondi',
	            ss: '%d sekondi',
	            m: 'minuta',
	            mm: '%d minuti',
	            h: 'siegħa',
	            hh: '%d siegħat',
	            d: 'ġurnata',
	            dd: '%d ġranet',
	            M: 'xahar',
	            MM: '%d xhur',
	            y: 'sena',
	            yy: '%d sni',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return mt;
	
	})));


/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Burmese [my]
	//! author : Squar team, mysquar.com
	//! author : David Rossellat : https://github.com/gholadr
	//! author : Tin Aung Lin : https://github.com/thanyawzinmin
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '၁',
	            2: '၂',
	            3: '၃',
	            4: '၄',
	            5: '၅',
	            6: '၆',
	            7: '၇',
	            8: '၈',
	            9: '၉',
	            0: '၀',
	        },
	        numberMap = {
	            '၁': '1',
	            '၂': '2',
	            '၃': '3',
	            '၄': '4',
	            '၅': '5',
	            '၆': '6',
	            '၇': '7',
	            '၈': '8',
	            '၉': '9',
	            '၀': '0',
	        };
	
	    var my = moment.defineLocale('my', {
	        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
	            '_'
	        ),
	        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
	        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
	            '_'
	        ),
	        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
	
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ယနေ.] LT [မှာ]',
	            nextDay: '[မနက်ဖြန်] LT [မှာ]',
	            nextWeek: 'dddd LT [မှာ]',
	            lastDay: '[မနေ.က] LT [မှာ]',
	            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'လာမည့် %s မှာ',
	            past: 'လွန်ခဲ့သော %s က',
	            s: 'စက္ကန်.အနည်းငယ်',
	            ss: '%d စက္ကန့်',
	            m: 'တစ်မိနစ်',
	            mm: '%d မိနစ်',
	            h: 'တစ်နာရီ',
	            hh: '%d နာရီ',
	            d: 'တစ်ရက်',
	            dd: '%d ရက်',
	            M: 'တစ်လ',
	            MM: '%d လ',
	            y: 'တစ်နှစ်',
	            yy: '%d နှစ်',
	        },
	        preparse: function (string) {
	            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return my;
	
	})));


/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Norwegian Bokmål [nb]
	//! authors : Espen Hovlandsdal : https://github.com/rexxars
	//!           Sigurd Gartmann : https://github.com/sigurdga
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nb = moment.defineLocale('nb', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
	        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
	        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[i dag kl.] LT',
	            nextDay: '[i morgen kl.] LT',
	            nextWeek: 'dddd [kl.] LT',
	            lastDay: '[i går kl.] LT',
	            lastWeek: '[forrige] dddd [kl.] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s siden',
	            s: 'noen sekunder',
	            ss: '%d sekunder',
	            m: 'ett minutt',
	            mm: '%d minutter',
	            h: 'en time',
	            hh: '%d timer',
	            d: 'en dag',
	            dd: '%d dager',
	            w: 'en uke',
	            ww: '%d uker',
	            M: 'en måned',
	            MM: '%d måneder',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nb;
	
	})));


/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nepalese [ne]
	//! author : suvash : https://github.com/suvash
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '१',
	            2: '२',
	            3: '३',
	            4: '४',
	            5: '५',
	            6: '६',
	            7: '७',
	            8: '८',
	            9: '९',
	            0: '०',
	        },
	        numberMap = {
	            '१': '1',
	            '२': '2',
	            '३': '3',
	            '४': '4',
	            '५': '5',
	            '६': '6',
	            '७': '7',
	            '८': '8',
	            '९': '9',
	            '०': '0',
	        };
	
	    var ne = moment.defineLocale('ne', {
	        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
	            '_'
	        ),
	        monthsShort:
	            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
	            '_'
	        ),
	        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
	        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'Aको h:mm बजे',
	            LTS: 'Aको h:mm:ss बजे',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, Aको h:mm बजे',
	            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
	        },
	        preparse: function (string) {
	            return string.replace(/[१२३४५६७८९०]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'राति') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'बिहान') {
	                return hour;
	            } else if (meridiem === 'दिउँसो') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'साँझ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 3) {
	                return 'राति';
	            } else if (hour < 12) {
	                return 'बिहान';
	            } else if (hour < 16) {
	                return 'दिउँसो';
	            } else if (hour < 20) {
	                return 'साँझ';
	            } else {
	                return 'राति';
	            }
	        },
	        calendar: {
	            sameDay: '[आज] LT',
	            nextDay: '[भोलि] LT',
	            nextWeek: '[आउँदो] dddd[,] LT',
	            lastDay: '[हिजो] LT',
	            lastWeek: '[गएको] dddd[,] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sमा',
	            past: '%s अगाडि',
	            s: 'केही क्षण',
	            ss: '%d सेकेण्ड',
	            m: 'एक मिनेट',
	            mm: '%d मिनेट',
	            h: 'एक घण्टा',
	            hh: '%d घण्टा',
	            d: 'एक दिन',
	            dd: '%d दिन',
	            M: 'एक महिना',
	            MM: '%d महिना',
	            y: 'एक बर्ष',
	            yy: '%d बर्ष',
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ne;
	
	})));


/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch (Belgium) [nl-be]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nlBe = moment.defineLocale('nl-be', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nlBe;
	
	})));


/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Dutch [nl]
	//! author : Joris Röling : https://github.com/jorisroling
	//! author : Jacob Middag : https://github.com/middagj
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsShortWithDots =
	            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
	        monthsShortWithoutDots =
	            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        monthsParse = [
	            /^jan/i,
	            /^feb/i,
	            /^maart|mrt.?$/i,
	            /^apr/i,
	            /^mei$/i,
	            /^jun[i.]?$/i,
	            /^jul[i.]?$/i,
	            /^aug/i,
	            /^sep/i,
	            /^okt/i,
	            /^nov/i,
	            /^dec/i,
	        ],
	        monthsRegex =
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
	
	    var nl = moment.defineLocale('nl', {
	        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: function (m, format) {
	            if (!m) {
	                return monthsShortWithDots;
	            } else if (/-MMM-/.test(format)) {
	                return monthsShortWithoutDots[m.month()];
	            } else {
	                return monthsShortWithDots[m.month()];
	            }
	        },
	
	        monthsRegex: monthsRegex,
	        monthsShortRegex: monthsRegex,
	        monthsStrictRegex:
	            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
	        monthsShortStrictRegex:
	            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
	
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        weekdays:
	            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
	        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
	        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD-MM-YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[vandaag om] LT',
	            nextDay: '[morgen om] LT',
	            nextWeek: 'dddd [om] LT',
	            lastDay: '[gisteren om] LT',
	            lastWeek: '[afgelopen] dddd [om] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'over %s',
	            past: '%s geleden',
	            s: 'een paar seconden',
	            ss: '%d seconden',
	            m: 'één minuut',
	            mm: '%d minuten',
	            h: 'één uur',
	            hh: '%d uur',
	            d: 'één dag',
	            dd: '%d dagen',
	            w: 'één week',
	            ww: '%d weken',
	            M: 'één maand',
	            MM: '%d maanden',
	            y: 'één jaar',
	            yy: '%d jaar',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
	        ordinal: function (number) {
	            return (
	                number +
	                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
	            );
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nl;
	
	})));


/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Nynorsk [nn]
	//! authors : https://github.com/mechuwind
	//!           Stephen Ramthun : https://github.com/stephenramthun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var nn = moment.defineLocale('nn', {
	        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
	        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
	        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY [kl.] H:mm',
	            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[I dag klokka] LT',
	            nextDay: '[I morgon klokka] LT',
	            nextWeek: 'dddd [klokka] LT',
	            lastDay: '[I går klokka] LT',
	            lastWeek: '[Føregåande] dddd [klokka] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: '%s sidan',
	            s: 'nokre sekund',
	            ss: '%d sekund',
	            m: 'eit minutt',
	            mm: '%d minutt',
	            h: 'ein time',
	            hh: '%d timar',
	            d: 'ein dag',
	            dd: '%d dagar',
	            w: 'ei veke',
	            ww: '%d veker',
	            M: 'ein månad',
	            MM: '%d månader',
	            y: 'eit år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return nn;
	
	})));


/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Occitan, lengadocian dialecte [oc-lnc]
	//! author : Quentin PAGÈS : https://github.com/Quenty31
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ocLnc = moment.defineLocale('oc-lnc', {
	        months: {
	            standalone:
	                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
	                    '_'
	                ),
	            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
	                '_'
	            ),
	            isFormat: /D[oD]?(\s)+MMMM/,
	        },
	        monthsShort:
	            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
	            '_'
	        ),
	        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
	        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [de] YYYY',
	            ll: 'D MMM YYYY',
	            LLL: 'D MMMM [de] YYYY [a] H:mm',
	            lll: 'D MMM YYYY, H:mm',
	            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
	            llll: 'ddd D MMM YYYY, H:mm',
	        },
	        calendar: {
	            sameDay: '[uèi a] LT',
	            nextDay: '[deman a] LT',
	            nextWeek: 'dddd [a] LT',
	            lastDay: '[ièr a] LT',
	            lastWeek: 'dddd [passat a] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: "d'aquí %s",
	            past: 'fa %s',
	            s: 'unas segondas',
	            ss: '%d segondas',
	            m: 'una minuta',
	            mm: '%d minutas',
	            h: 'una ora',
	            hh: '%d oras',
	            d: 'un jorn',
	            dd: '%d jorns',
	            M: 'un mes',
	            MM: '%d meses',
	            y: 'un an',
	            yy: '%d ans',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
	        ordinal: function (number, period) {
	            var output =
	                number === 1
	                    ? 'r'
	                    : number === 2
	                    ? 'n'
	                    : number === 3
	                    ? 'r'
	                    : number === 4
	                    ? 't'
	                    : 'è';
	            if (period === 'w' || period === 'W') {
	                output = 'a';
	            }
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4,
	        },
	    });
	
	    return ocLnc;
	
	})));


/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Punjabi (India) [pa-in]
	//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '੧',
	            2: '੨',
	            3: '੩',
	            4: '੪',
	            5: '੫',
	            6: '੬',
	            7: '੭',
	            8: '੮',
	            9: '੯',
	            0: '੦',
	        },
	        numberMap = {
	            '੧': '1',
	            '੨': '2',
	            '੩': '3',
	            '੪': '4',
	            '੫': '5',
	            '੬': '6',
	            '੭': '7',
	            '੮': '8',
	            '੯': '9',
	            '੦': '0',
	        };
	
	    var paIn = moment.defineLocale('pa-in', {
	        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
	        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
	                '_'
	            ),
	        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
	            '_'
	        ),
	        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm ਵਜੇ',
	            LTS: 'A h:mm:ss ਵਜੇ',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
	        },
	        calendar: {
	            sameDay: '[ਅਜ] LT',
	            nextDay: '[ਕਲ] LT',
	            nextWeek: '[ਅਗਲਾ] dddd, LT',
	            lastDay: '[ਕਲ] LT',
	            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s ਵਿੱਚ',
	            past: '%s ਪਿਛਲੇ',
	            s: 'ਕੁਝ ਸਕਿੰਟ',
	            ss: '%d ਸਕਿੰਟ',
	            m: 'ਇਕ ਮਿੰਟ',
	            mm: '%d ਮਿੰਟ',
	            h: 'ਇੱਕ ਘੰਟਾ',
	            hh: '%d ਘੰਟੇ',
	            d: 'ਇੱਕ ਦਿਨ',
	            dd: '%d ਦਿਨ',
	            M: 'ਇੱਕ ਮਹੀਨਾ',
	            MM: '%d ਮਹੀਨੇ',
	            y: 'ਇੱਕ ਸਾਲ',
	            yy: '%d ਸਾਲ',
	        },
	        preparse: function (string) {
	            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
	        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
	        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ਰਾਤ') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ਸਵੇਰ') {
	                return hour;
	            } else if (meridiem === 'ਦੁਪਹਿਰ') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'ਸ਼ਾਮ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ਰਾਤ';
	            } else if (hour < 10) {
	                return 'ਸਵੇਰ';
	            } else if (hour < 17) {
	                return 'ਦੁਪਹਿਰ';
	            } else if (hour < 20) {
	                return 'ਸ਼ਾਮ';
	            } else {
	                return 'ਰਾਤ';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return paIn;
	
	})));


/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Polish [pl]
	//! author : Rafal Hirsz : https://github.com/evoL
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var monthsNominative =
	            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
	                '_'
	            ),
	        monthsSubjective =
	            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
	                '_'
	            ),
	        monthsParse = [
	            /^sty/i,
	            /^lut/i,
	            /^mar/i,
	            /^kwi/i,
	            /^maj/i,
	            /^cze/i,
	            /^lip/i,
	            /^sie/i,
	            /^wrz/i,
	            /^paź/i,
	            /^lis/i,
	            /^gru/i,
	        ];
	    function plural(n) {
	        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
	    }
	    function translate(number, withoutSuffix, key) {
	        var result = number + ' ';
	        switch (key) {
	            case 'ss':
	                return result + (plural(number) ? 'sekundy' : 'sekund');
	            case 'm':
	                return withoutSuffix ? 'minuta' : 'minutę';
	            case 'mm':
	                return result + (plural(number) ? 'minuty' : 'minut');
	            case 'h':
	                return withoutSuffix ? 'godzina' : 'godzinę';
	            case 'hh':
	                return result + (plural(number) ? 'godziny' : 'godzin');
	            case 'ww':
	                return result + (plural(number) ? 'tygodnie' : 'tygodni');
	            case 'MM':
	                return result + (plural(number) ? 'miesiące' : 'miesięcy');
	            case 'yy':
	                return result + (plural(number) ? 'lata' : 'lat');
	        }
	    }
	
	    var pl = moment.defineLocale('pl', {
	        months: function (momentToFormat, format) {
	            if (!momentToFormat) {
	                return monthsNominative;
	            } else if (/D MMMM/.test(format)) {
	                return monthsSubjective[momentToFormat.month()];
	            } else {
	                return monthsNominative[momentToFormat.month()];
	            }
	        },
	        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	        weekdays:
	            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
	        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
	        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Dziś o] LT',
	            nextDay: '[Jutro o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W niedzielę o] LT';
	
	                    case 2:
	                        return '[We wtorek o] LT';
	
	                    case 3:
	                        return '[W środę o] LT';
	
	                    case 6:
	                        return '[W sobotę o] LT';
	
	                    default:
	                        return '[W] dddd [o] LT';
	                }
	            },
	            lastDay: '[Wczoraj o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[W zeszłą niedzielę o] LT';
	                    case 3:
	                        return '[W zeszłą środę o] LT';
	                    case 6:
	                        return '[W zeszłą sobotę o] LT';
	                    default:
	                        return '[W zeszły] dddd [o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: '%s temu',
	            s: 'kilka sekund',
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: '1 dzień',
	            dd: '%d dni',
	            w: 'tydzień',
	            ww: translate,
	            M: 'miesiąc',
	            MM: translate,
	            y: 'rok',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pl;
	
	})));


/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese (Brazil) [pt-br]
	//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ptBr = moment.defineLocale('pt-br', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
	        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'poucos segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        invalidDate: 'Data inválida',
	    });
	
	    return ptBr;
	
	})));


/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Portuguese [pt]
	//! author : Jefferson : https://github.com/jalex79
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var pt = moment.defineLocale('pt', {
	        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
	            '_'
	        ),
	        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
	        weekdays:
	            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
	                '_'
	            ),
	        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
	        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D [de] MMMM [de] YYYY',
	            LLL: 'D [de] MMMM [de] YYYY HH:mm',
	            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hoje às] LT',
	            nextDay: '[Amanhã às] LT',
	            nextWeek: 'dddd [às] LT',
	            lastDay: '[Ontem às] LT',
	            lastWeek: function () {
	                return this.day() === 0 || this.day() === 6
	                    ? '[Último] dddd [às] LT' // Saturday + Sunday
	                    : '[Última] dddd [às] LT'; // Monday - Friday
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'em %s',
	            past: 'há %s',
	            s: 'segundos',
	            ss: '%d segundos',
	            m: 'um minuto',
	            mm: '%d minutos',
	            h: 'uma hora',
	            hh: '%d horas',
	            d: 'um dia',
	            dd: '%d dias',
	            w: 'uma semana',
	            ww: '%d semanas',
	            M: 'um mês',
	            MM: '%d meses',
	            y: 'um ano',
	            yy: '%d anos',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}º/,
	        ordinal: '%dº',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return pt;
	
	})));


/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Romanian [ro]
	//! author : Vlad Gurdiga : https://github.com/gurdiga
	//! author : Valentin Agachi : https://github.com/avaly
	//! author : Emanuel Cepoi : https://github.com/cepem
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	                ss: 'secunde',
	                mm: 'minute',
	                hh: 'ore',
	                dd: 'zile',
	                ww: 'săptămâni',
	                MM: 'luni',
	                yy: 'ani',
	            },
	            separator = ' ';
	        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
	            separator = ' de ';
	        }
	        return number + separator + format[key];
	    }
	
	    var ro = moment.defineLocale('ro', {
	        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
	            '_'
	        ),
	        monthsShort:
	            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
	        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
	        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY H:mm',
	            LLLL: 'dddd, D MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[azi la] LT',
	            nextDay: '[mâine la] LT',
	            nextWeek: 'dddd [la] LT',
	            lastDay: '[ieri la] LT',
	            lastWeek: '[fosta] dddd [la] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'peste %s',
	            past: '%s în urmă',
	            s: 'câteva secunde',
	            ss: relativeTimeWithPlural,
	            m: 'un minut',
	            mm: relativeTimeWithPlural,
	            h: 'o oră',
	            hh: relativeTimeWithPlural,
	            d: 'o zi',
	            dd: relativeTimeWithPlural,
	            w: 'o săptămână',
	            ww: relativeTimeWithPlural,
	            M: 'o lună',
	            MM: relativeTimeWithPlural,
	            y: 'un an',
	            yy: relativeTimeWithPlural,
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return ro;
	
	})));


/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Russian [ru]
	//! author : Viktorminator : https://github.com/Viktorminator
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Коренберг Марк : https://github.com/socketpair
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
	            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
	            hh: 'час_часа_часов',
	            dd: 'день_дня_дней',
	            ww: 'неделя_недели_недель',
	            MM: 'месяц_месяца_месяцев',
	            yy: 'год_года_лет',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'минута' : 'минуту';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    var monthsParse = [
	        /^янв/i,
	        /^фев/i,
	        /^мар/i,
	        /^апр/i,
	        /^ма[йя]/i,
	        /^июн/i,
	        /^июл/i,
	        /^авг/i,
	        /^сен/i,
	        /^окт/i,
	        /^ноя/i,
	        /^дек/i,
	    ];
	
	    // http://new.gramota.ru/spravka/rules/139-prop : § 103
	    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
	    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
	    var ru = moment.defineLocale('ru', {
	        months: {
	            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
	                '_'
	            ),
	            standalone:
	                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
	                    '_'
	                ),
	        },
	        monthsShort: {
	            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
	            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
	                '_'
	            ),
	            standalone:
	                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
	                    '_'
	                ),
	        },
	        weekdays: {
	            standalone:
	                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
	                    '_'
	                ),
	            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
	                '_'
	            ),
	            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
	        },
	        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
	        monthsParse: monthsParse,
	        longMonthsParse: monthsParse,
	        shortMonthsParse: monthsParse,
	
	        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
	        monthsRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // копия предыдущего
	        monthsShortRegex:
	            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
	
	        // полные названия с падежами
	        monthsStrictRegex:
	            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
	
	        // Выражение, которое соответствует только сокращённым формам
	        monthsShortStrictRegex:
	            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY г.',
	            LLL: 'D MMMM YYYY г., H:mm',
	            LLLL: 'dddd, D MMMM YYYY г., H:mm',
	        },
	        calendar: {
	            sameDay: '[Сегодня, в] LT',
	            nextDay: '[Завтра, в] LT',
	            lastDay: '[Вчера, в] LT',
	            nextWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В следующее] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В следующий] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В следующую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            lastWeek: function (now) {
	                if (now.week() !== this.week()) {
	                    switch (this.day()) {
	                        case 0:
	                            return '[В прошлое] dddd, [в] LT';
	                        case 1:
	                        case 2:
	                        case 4:
	                            return '[В прошлый] dddd, [в] LT';
	                        case 3:
	                        case 5:
	                        case 6:
	                            return '[В прошлую] dddd, [в] LT';
	                    }
	                } else {
	                    if (this.day() === 2) {
	                        return '[Во] dddd, [в] LT';
	                    } else {
	                        return '[В] dddd, [в] LT';
	                    }
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'через %s',
	            past: '%s назад',
	            s: 'несколько секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'час',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            w: 'неделя',
	            ww: relativeTimeWithPlural,
	            M: 'месяц',
	            MM: relativeTimeWithPlural,
	            y: 'год',
	            yy: relativeTimeWithPlural,
	        },
	        meridiemParse: /ночи|утра|дня|вечера/i,
	        isPM: function (input) {
	            return /^(дня|вечера)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночи';
	            } else if (hour < 12) {
	                return 'утра';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечера';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                case 'w':
	                case 'W':
	                    return number + '-я';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ru;
	
	})));


/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sindhi [sd]
	//! author : Narain Sagar : https://github.com/narainsagar
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوري',
	            'فيبروري',
	            'مارچ',
	            'اپريل',
	            'مئي',
	            'جون',
	            'جولاءِ',
	            'آگسٽ',
	            'سيپٽمبر',
	            'آڪٽوبر',
	            'نومبر',
	            'ڊسمبر',
	        ],
	        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];
	
	    var sd = moment.defineLocale('sd', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[اڄ] LT',
	            nextDay: '[سڀاڻي] LT',
	            nextWeek: 'dddd [اڳين هفتي تي] LT',
	            lastDay: '[ڪالهه] LT',
	            lastWeek: '[گزريل هفتي] dddd [تي] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s پوء',
	            past: '%s اڳ',
	            s: 'چند سيڪنڊ',
	            ss: '%d سيڪنڊ',
	            m: 'هڪ منٽ',
	            mm: '%d منٽ',
	            h: 'هڪ ڪلاڪ',
	            hh: '%d ڪلاڪ',
	            d: 'هڪ ڏينهن',
	            dd: '%d ڏينهن',
	            M: 'هڪ مهينو',
	            MM: '%d مهينا',
	            y: 'هڪ سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sd;
	
	})));


/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Northern Sami [se]
	//! authors : Bård Rolstad Henriksen : https://github.com/karamell
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var se = moment.defineLocale('se', {
	        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
	            '_'
	        ),
	        monthsShort:
	            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
	        weekdays:
	            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
	                '_'
	            ),
	        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
	        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'MMMM D. [b.] YYYY',
	            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
	            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
	        },
	        calendar: {
	            sameDay: '[otne ti] LT',
	            nextDay: '[ihttin ti] LT',
	            nextWeek: 'dddd [ti] LT',
	            lastDay: '[ikte ti] LT',
	            lastWeek: '[ovddit] dddd [ti] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s geažes',
	            past: 'maŋit %s',
	            s: 'moadde sekunddat',
	            ss: '%d sekunddat',
	            m: 'okta minuhta',
	            mm: '%d minuhtat',
	            h: 'okta diimmu',
	            hh: '%d diimmut',
	            d: 'okta beaivi',
	            dd: '%d beaivvit',
	            M: 'okta mánnu',
	            MM: '%d mánut',
	            y: 'okta jahki',
	            yy: '%d jagit',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return se;
	
	})));


/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Sinhalese [si]
	//! author : Sampath Sitinamaluwa : https://github.com/sampathsris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    /*jshint -W100*/
	    var si = moment.defineLocale('si', {
	        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
	            '_'
	        ),
	        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
	            '_'
	        ),
	        weekdays:
	            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
	                '_'
	            ),
	        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
	        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'a h:mm',
	            LTS: 'a h:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY MMMM D',
	            LLL: 'YYYY MMMM D, a h:mm',
	            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
	        },
	        calendar: {
	            sameDay: '[අද] LT[ට]',
	            nextDay: '[හෙට] LT[ට]',
	            nextWeek: 'dddd LT[ට]',
	            lastDay: '[ඊයේ] LT[ට]',
	            lastWeek: '[පසුගිය] dddd LT[ට]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%sකින්',
	            past: '%sකට පෙර',
	            s: 'තත්පර කිහිපය',
	            ss: 'තත්පර %d',
	            m: 'මිනිත්තුව',
	            mm: 'මිනිත්තු %d',
	            h: 'පැය',
	            hh: 'පැය %d',
	            d: 'දිනය',
	            dd: 'දින %d',
	            M: 'මාසය',
	            MM: 'මාස %d',
	            y: 'වසර',
	            yy: 'වසර %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
	        ordinal: function (number) {
	            return number + ' වැනි';
	        },
	        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
	        isPM: function (input) {
	            return input === 'ප.ව.' || input === 'පස් වරු';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? 'ප.ව.' : 'පස් වරු';
	            } else {
	                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
	            }
	        },
	    });
	
	    return si;
	
	})));


/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovak [sk]
	//! author : Martin Minka : https://github.com/k2s
	//! based on work of petrbela : https://github.com/petrbela
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months =
	            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
	                '_'
	            ),
	        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
	    function plural(n) {
	        return n > 1 && n < 5;
	    }
	    function translate(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's': // a few seconds / in a few seconds / a few seconds ago
	                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
	            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
	                } else {
	                    return result + 'sekundami';
	                }
	            case 'm': // a minute / in a minute / a minute ago
	                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
	            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'minúty' : 'minút');
	                } else {
	                    return result + 'minútami';
	                }
	            case 'h': // an hour / in an hour / an hour ago
	                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
	            case 'hh': // 9 hours / in 9 hours / 9 hours ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'hodiny' : 'hodín');
	                } else {
	                    return result + 'hodinami';
	                }
	            case 'd': // a day / in a day / a day ago
	                return withoutSuffix || isFuture ? 'deň' : 'dňom';
	            case 'dd': // 9 days / in 9 days / 9 days ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'dni' : 'dní');
	                } else {
	                    return result + 'dňami';
	                }
	            case 'M': // a month / in a month / a month ago
	                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
	            case 'MM': // 9 months / in 9 months / 9 months ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
	                } else {
	                    return result + 'mesiacmi';
	                }
	            case 'y': // a year / in a year / a year ago
	                return withoutSuffix || isFuture ? 'rok' : 'rokom';
	            case 'yy': // 9 years / in 9 years / 9 years ago
	                if (withoutSuffix || isFuture) {
	                    return result + (plural(number) ? 'roky' : 'rokov');
	                } else {
	                    return result + 'rokmi';
	                }
	        }
	    }
	
	    var sk = moment.defineLocale('sk', {
	        months: months,
	        monthsShort: monthsShort,
	        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
	        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
	        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[dnes o] LT',
	            nextDay: '[zajtra o] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[v] dddd [o] LT';
	                    case 3:
	                        return '[v stredu o] LT';
	                    case 4:
	                        return '[vo štvrtok o] LT';
	                    case 5:
	                        return '[v piatok o] LT';
	                    case 6:
	                        return '[v sobotu o] LT';
	                }
	            },
	            lastDay: '[včera o] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[minulú nedeľu o] LT';
	                    case 1:
	                    case 2:
	                        return '[minulý] dddd [o] LT';
	                    case 3:
	                        return '[minulú stredu o] LT';
	                    case 4:
	                    case 5:
	                        return '[minulý] dddd [o] LT';
	                    case 6:
	                        return '[minulú sobotu o] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pred %s',
	            s: translate,
	            ss: translate,
	            m: translate,
	            mm: translate,
	            h: translate,
	            hh: translate,
	            d: translate,
	            dd: translate,
	            M: translate,
	            MM: translate,
	            y: translate,
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sk;
	
	})));


/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Slovenian [sl]
	//! author : Robert Sedovšek : https://github.com/sedovsek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var result = number + ' ';
	        switch (key) {
	            case 's':
	                return withoutSuffix || isFuture
	                    ? 'nekaj sekund'
	                    : 'nekaj sekundami';
	            case 'ss':
	                if (number === 1) {
	                    result += withoutSuffix ? 'sekundo' : 'sekundi';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
	                } else {
	                    result += 'sekund';
	                }
	                return result;
	            case 'm':
	                return withoutSuffix ? 'ena minuta' : 'eno minuto';
	            case 'mm':
	                if (number === 1) {
	                    result += withoutSuffix ? 'minuta' : 'minuto';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
	                }
	                return result;
	            case 'h':
	                return withoutSuffix ? 'ena ura' : 'eno uro';
	            case 'hh':
	                if (number === 1) {
	                    result += withoutSuffix ? 'ura' : 'uro';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
	                } else {
	                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
	                }
	                return result;
	            case 'd':
	                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
	            case 'dd':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
	                } else {
	                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
	                }
	                return result;
	            case 'M':
	                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
	            case 'MM':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
	                } else {
	                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
	                }
	                return result;
	            case 'y':
	                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
	            case 'yy':
	                if (number === 1) {
	                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
	                } else if (number === 2) {
	                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
	                } else if (number < 5) {
	                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
	                } else {
	                    result += withoutSuffix || isFuture ? 'let' : 'leti';
	                }
	                return result;
	        }
	    }
	
	    var sl = moment.defineLocale('sl', {
	        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
	        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
	        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD. MM. YYYY',
	            LL: 'D. MMMM YYYY',
	            LLL: 'D. MMMM YYYY H:mm',
	            LLLL: 'dddd, D. MMMM YYYY H:mm',
	        },
	        calendar: {
	            sameDay: '[danes ob] LT',
	            nextDay: '[jutri ob] LT',
	
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[v] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[v] [sredo] [ob] LT';
	                    case 6:
	                        return '[v] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[v] dddd [ob] LT';
	                }
	            },
	            lastDay: '[včeraj ob] LT',
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[prejšnjo] [nedeljo] [ob] LT';
	                    case 3:
	                        return '[prejšnjo] [sredo] [ob] LT';
	                    case 6:
	                        return '[prejšnjo] [soboto] [ob] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[prejšnji] dddd [ob] LT';
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'čez %s',
	            past: 'pred %s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sl;
	
	})));


/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Albanian [sq]
	//! author : Flakërim Ismani : https://github.com/flakerimi
	//! author : Menelion Elensúle : https://github.com/Oire
	//! author : Oerd Cukalla : https://github.com/oerd
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sq = moment.defineLocale('sq', {
	        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
	        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
	            '_'
	        ),
	        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
	        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /PD|MD/,
	        isPM: function (input) {
	            return input.charAt(0) === 'M';
	        },
	        meridiem: function (hours, minutes, isLower) {
	            return hours < 12 ? 'PD' : 'MD';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Sot në] LT',
	            nextDay: '[Nesër në] LT',
	            nextWeek: 'dddd [në] LT',
	            lastDay: '[Dje në] LT',
	            lastWeek: 'dddd [e kaluar në] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'në %s',
	            past: '%s më parë',
	            s: 'disa sekonda',
	            ss: '%d sekonda',
	            m: 'një minutë',
	            mm: '%d minuta',
	            h: 'një orë',
	            hh: '%d orë',
	            d: 'një ditë',
	            dd: '%d ditë',
	            M: 'një muaj',
	            MM: '%d muaj',
	            y: 'një vit',
	            yy: '%d vite',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sq;
	
	})));


/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian Cyrillic [sr-cyrl]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['секунда', 'секунде', 'секунди'],
	            m: ['један минут', 'једног минута'],
	            mm: ['минут', 'минута', 'минута'],
	            h: ['један сат', 'једног сата'],
	            hh: ['сат', 'сата', 'сати'],
	            d: ['један дан', 'једног дана'],
	            dd: ['дан', 'дана', 'дана'],
	            M: ['један месец', 'једног месеца'],
	            MM: ['месец', 'месеца', 'месеци'],
	            y: ['једну годину', 'једне године'],
	            yy: ['годину', 'године', 'година'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'једна година';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'годину') {
	                return number + ' година';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var srCyrl = moment.defineLocale('sr-cyrl', {
	        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
	            '_'
	        ),
	        monthsShort:
	            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
	        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
	        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[данас у] LT',
	            nextDay: '[сутра у] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[у] [недељу] [у] LT';
	                    case 3:
	                        return '[у] [среду] [у] LT';
	                    case 6:
	                        return '[у] [суботу] [у] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[у] dddd [у] LT';
	                }
	            },
	            lastDay: '[јуче у] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[прошле] [недеље] [у] LT',
	                    '[прошлог] [понедељка] [у] LT',
	                    '[прошлог] [уторка] [у] LT',
	                    '[прошле] [среде] [у] LT',
	                    '[прошлог] [четвртка] [у] LT',
	                    '[прошлог] [петка] [у] LT',
	                    '[прошле] [суботе] [у] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: 'пре %s',
	            s: 'неколико секунди',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return srCyrl;
	
	})));


/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Serbian [sr]
	//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
	//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var translator = {
	        words: {
	            //Different grammatical cases
	            ss: ['sekunda', 'sekunde', 'sekundi'],
	            m: ['jedan minut', 'jednog minuta'],
	            mm: ['minut', 'minuta', 'minuta'],
	            h: ['jedan sat', 'jednog sata'],
	            hh: ['sat', 'sata', 'sati'],
	            d: ['jedan dan', 'jednog dana'],
	            dd: ['dan', 'dana', 'dana'],
	            M: ['jedan mesec', 'jednog meseca'],
	            MM: ['mesec', 'meseca', 'meseci'],
	            y: ['jednu godinu', 'jedne godine'],
	            yy: ['godinu', 'godine', 'godina'],
	        },
	        correctGrammaticalCase: function (number, wordKey) {
	            if (
	                number % 10 >= 1 &&
	                number % 10 <= 4 &&
	                (number % 100 < 10 || number % 100 >= 20)
	            ) {
	                return number % 10 === 1 ? wordKey[0] : wordKey[1];
	            }
	            return wordKey[2];
	        },
	        translate: function (number, withoutSuffix, key, isFuture) {
	            var wordKey = translator.words[key],
	                word;
	
	            if (key.length === 1) {
	                // Nominativ
	                if (key === 'y' && withoutSuffix) return 'jedna godina';
	                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
	            }
	
	            word = translator.correctGrammaticalCase(number, wordKey);
	            // Nominativ
	            if (key === 'yy' && withoutSuffix && word === 'godinu') {
	                return number + ' godina';
	            }
	
	            return number + ' ' + word;
	        },
	    };
	
	    var sr = moment.defineLocale('sr', {
	        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
	            '_'
	        ),
	        monthsShort:
	            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
	        monthsParseExact: true,
	        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
	            '_'
	        ),
	        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
	        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'D. M. YYYY.',
	            LL: 'D. MMMM YYYY.',
	            LLL: 'D. MMMM YYYY. H:mm',
	            LLLL: 'dddd, D. MMMM YYYY. H:mm',
	        },
	        calendar: {
	            sameDay: '[danas u] LT',
	            nextDay: '[sutra u] LT',
	            nextWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                        return '[u] [nedelju] [u] LT';
	                    case 3:
	                        return '[u] [sredu] [u] LT';
	                    case 6:
	                        return '[u] [subotu] [u] LT';
	                    case 1:
	                    case 2:
	                    case 4:
	                    case 5:
	                        return '[u] dddd [u] LT';
	                }
	            },
	            lastDay: '[juče u] LT',
	            lastWeek: function () {
	                var lastWeekDays = [
	                    '[prošle] [nedelje] [u] LT',
	                    '[prošlog] [ponedeljka] [u] LT',
	                    '[prošlog] [utorka] [u] LT',
	                    '[prošle] [srede] [u] LT',
	                    '[prošlog] [četvrtka] [u] LT',
	                    '[prošlog] [petka] [u] LT',
	                    '[prošle] [subote] [u] LT',
	                ];
	                return lastWeekDays[this.day()];
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'za %s',
	            past: 'pre %s',
	            s: 'nekoliko sekundi',
	            ss: translator.translate,
	            m: translator.translate,
	            mm: translator.translate,
	            h: translator.translate,
	            hh: translator.translate,
	            d: translator.translate,
	            dd: translator.translate,
	            M: translator.translate,
	            MM: translator.translate,
	            y: translator.translate,
	            yy: translator.translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sr;
	
	})));


/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : siSwati [ss]
	//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ss = moment.defineLocale('ss', {
	        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
	            '_'
	        ),
	        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
	        weekdays:
	            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
	                '_'
	            ),
	        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
	        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Namuhla nga] LT',
	            nextDay: '[Kusasa nga] LT',
	            nextWeek: 'dddd [nga] LT',
	            lastDay: '[Itolo nga] LT',
	            lastWeek: 'dddd [leliphelile] [nga] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'nga %s',
	            past: 'wenteka nga %s',
	            s: 'emizuzwana lomcane',
	            ss: '%d mzuzwana',
	            m: 'umzuzu',
	            mm: '%d emizuzu',
	            h: 'lihora',
	            hh: '%d emahora',
	            d: 'lilanga',
	            dd: '%d emalanga',
	            M: 'inyanga',
	            MM: '%d tinyanga',
	            y: 'umnyaka',
	            yy: '%d iminyaka',
	        },
	        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 11) {
	                return 'ekuseni';
	            } else if (hours < 15) {
	                return 'emini';
	            } else if (hours < 19) {
	                return 'entsambama';
	            } else {
	                return 'ebusuku';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'ekuseni') {
	                return hour;
	            } else if (meridiem === 'emini') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
	                if (hour === 0) {
	                    return 0;
	                }
	                return hour + 12;
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: '%d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ss;
	
	})));


/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swedish [sv]
	//! author : Jens Alm : https://github.com/ulmus
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sv = moment.defineLocale('sv', {
	        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
	            '_'
	        ),
	        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
	        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
	        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
	        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY [kl.] HH:mm',
	            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Idag] LT',
	            nextDay: '[Imorgon] LT',
	            lastDay: '[Igår] LT',
	            nextWeek: '[På] dddd LT',
	            lastWeek: '[I] dddd[s] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'om %s',
	            past: 'för %s sedan',
	            s: 'några sekunder',
	            ss: '%d sekunder',
	            m: 'en minut',
	            mm: '%d minuter',
	            h: 'en timme',
	            hh: '%d timmar',
	            d: 'en dag',
	            dd: '%d dagar',
	            M: 'en månad',
	            MM: '%d månader',
	            y: 'ett år',
	            yy: '%d år',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? ':e'
	                        : b === 1
	                        ? ':a'
	                        : b === 2
	                        ? ':a'
	                        : b === 3
	                        ? ':e'
	                        : ':e';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return sv;
	
	})));


/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Swahili [sw]
	//! author : Fahad Kassim : https://github.com/fadsel
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var sw = moment.defineLocale('sw', {
	        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
	        weekdays:
	            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
	                '_'
	            ),
	        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
	        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'hh:mm A',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[leo saa] LT',
	            nextDay: '[kesho saa] LT',
	            nextWeek: '[wiki ijayo] dddd [saat] LT',
	            lastDay: '[jana] LT',
	            lastWeek: '[wiki iliyopita] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s baadaye',
	            past: 'tokea %s',
	            s: 'hivi punde',
	            ss: 'sekunde %d',
	            m: 'dakika moja',
	            mm: 'dakika %d',
	            h: 'saa limoja',
	            hh: 'masaa %d',
	            d: 'siku moja',
	            dd: 'siku %d',
	            M: 'mwezi mmoja',
	            MM: 'miezi %d',
	            y: 'mwaka mmoja',
	            yy: 'miaka %d',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return sw;
	
	})));


/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tamil [ta]
	//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var symbolMap = {
	            1: '௧',
	            2: '௨',
	            3: '௩',
	            4: '௪',
	            5: '௫',
	            6: '௬',
	            7: '௭',
	            8: '௮',
	            9: '௯',
	            0: '௦',
	        },
	        numberMap = {
	            '௧': '1',
	            '௨': '2',
	            '௩': '3',
	            '௪': '4',
	            '௫': '5',
	            '௬': '6',
	            '௭': '7',
	            '௮': '8',
	            '௯': '9',
	            '௦': '0',
	        };
	
	    var ta = moment.defineLocale('ta', {
	        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	            '_'
	        ),
	        monthsShort:
	            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
	                '_'
	            ),
	        weekdays:
	            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
	                '_'
	            ),
	        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
	            '_'
	        ),
	        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, HH:mm',
	            LLLL: 'dddd, D MMMM YYYY, HH:mm',
	        },
	        calendar: {
	            sameDay: '[இன்று] LT',
	            nextDay: '[நாளை] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[நேற்று] LT',
	            lastWeek: '[கடந்த வாரம்] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s இல்',
	            past: '%s முன்',
	            s: 'ஒரு சில விநாடிகள்',
	            ss: '%d விநாடிகள்',
	            m: 'ஒரு நிமிடம்',
	            mm: '%d நிமிடங்கள்',
	            h: 'ஒரு மணி நேரம்',
	            hh: '%d மணி நேரம்',
	            d: 'ஒரு நாள்',
	            dd: '%d நாட்கள்',
	            M: 'ஒரு மாதம்',
	            MM: '%d மாதங்கள்',
	            y: 'ஒரு வருடம்',
	            yy: '%d ஆண்டுகள்',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}வது/,
	        ordinal: function (number) {
	            return number + 'வது';
	        },
	        preparse: function (string) {
	            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
	                return numberMap[match];
	            });
	        },
	        postformat: function (string) {
	            return string.replace(/\d/g, function (match) {
	                return symbolMap[match];
	            });
	        },
	        // refer http://ta.wikipedia.org/s/1er1
	        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 2) {
	                return ' யாமம்';
	            } else if (hour < 6) {
	                return ' வைகறை'; // வைகறை
	            } else if (hour < 10) {
	                return ' காலை'; // காலை
	            } else if (hour < 14) {
	                return ' நண்பகல்'; // நண்பகல்
	            } else if (hour < 18) {
	                return ' எற்பாடு'; // எற்பாடு
	            } else if (hour < 22) {
	                return ' மாலை'; // மாலை
	            } else {
	                return ' யாமம்';
	            }
	        },
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'யாமம்') {
	                return hour < 2 ? hour : hour + 12;
	            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
	                return hour;
	            } else if (meridiem === 'நண்பகல்') {
	                return hour >= 10 ? hour : hour + 12;
	            } else {
	                return hour + 12;
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return ta;
	
	})));


/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Telugu [te]
	//! author : Krishna Chaitanya Thota : https://github.com/kcthota
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var te = moment.defineLocale('te', {
	        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
	            '_'
	        ),
	        monthsShort:
	            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
	                '_'
	            ),
	        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
	        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
	        longDateFormat: {
	            LT: 'A h:mm',
	            LTS: 'A h:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY, A h:mm',
	            LLLL: 'dddd, D MMMM YYYY, A h:mm',
	        },
	        calendar: {
	            sameDay: '[నేడు] LT',
	            nextDay: '[రేపు] LT',
	            nextWeek: 'dddd, LT',
	            lastDay: '[నిన్న] LT',
	            lastWeek: '[గత] dddd, LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s లో',
	            past: '%s క్రితం',
	            s: 'కొన్ని క్షణాలు',
	            ss: '%d సెకన్లు',
	            m: 'ఒక నిమిషం',
	            mm: '%d నిమిషాలు',
	            h: 'ఒక గంట',
	            hh: '%d గంటలు',
	            d: 'ఒక రోజు',
	            dd: '%d రోజులు',
	            M: 'ఒక నెల',
	            MM: '%d నెలలు',
	            y: 'ఒక సంవత్సరం',
	            yy: '%d సంవత్సరాలు',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}వ/,
	        ordinal: '%dవ',
	        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'రాత్రి') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'ఉదయం') {
	                return hour;
	            } else if (meridiem === 'మధ్యాహ్నం') {
	                return hour >= 10 ? hour : hour + 12;
	            } else if (meridiem === 'సాయంత్రం') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'రాత్రి';
	            } else if (hour < 10) {
	                return 'ఉదయం';
	            } else if (hour < 17) {
	                return 'మధ్యాహ్నం';
	            } else if (hour < 20) {
	                return 'సాయంత్రం';
	            } else {
	                return 'రాత్రి';
	            }
	        },
	        week: {
	            dow: 0, // Sunday is the first day of the week.
	            doy: 6, // The week that contains Jan 6th is the first week of the year.
	        },
	    });
	
	    return te;
	
	})));


/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tetun Dili (East Timor) [tet]
	//! author : Joshua Brooks : https://github.com/joshbrooks
	//! author : Onorio De J. Afonso : https://github.com/marobo
	//! author : Sonia Simoes : https://github.com/soniasimoes
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tet = moment.defineLocale('tet', {
	        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
	        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
	        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
	        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Ohin iha] LT',
	            nextDay: '[Aban iha] LT',
	            nextWeek: 'dddd [iha] LT',
	            lastDay: '[Horiseik iha] LT',
	            lastWeek: 'dddd [semana kotuk] [iha] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'iha %s',
	            past: '%s liuba',
	            s: 'segundu balun',
	            ss: 'segundu %d',
	            m: 'minutu ida',
	            mm: 'minutu %d',
	            h: 'oras ida',
	            hh: 'oras %d',
	            d: 'loron ida',
	            dd: 'loron %d',
	            M: 'fulan ida',
	            MM: 'fulan %d',
	            y: 'tinan ida',
	            yy: 'tinan %d',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tet;
	
	})));


/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tajik [tg]
	//! author : Orif N. Jr. : https://github.com/orif-jr
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        0: '-ум',
	        1: '-ум',
	        2: '-юм',
	        3: '-юм',
	        4: '-ум',
	        5: '-ум',
	        6: '-ум',
	        7: '-ум',
	        8: '-ум',
	        9: '-ум',
	        10: '-ум',
	        12: '-ум',
	        13: '-ум',
	        20: '-ум',
	        30: '-юм',
	        40: '-ум',
	        50: '-ум',
	        60: '-ум',
	        70: '-ум',
	        80: '-ум',
	        90: '-ум',
	        100: '-ум',
	    };
	
	    var tg = moment.defineLocale('tg', {
	        months: {
	            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
	                '_'
	            ),
	            standalone:
	                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
	            '_'
	        ),
	        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
	        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Имрӯз соати] LT',
	            nextDay: '[Фардо соати] LT',
	            lastDay: '[Дирӯз соати] LT',
	            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
	            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'баъди %s',
	            past: '%s пеш',
	            s: 'якчанд сония',
	            m: 'як дақиқа',
	            mm: '%d дақиқа',
	            h: 'як соат',
	            hh: '%d соат',
	            d: 'як рӯз',
	            dd: '%d рӯз',
	            M: 'як моҳ',
	            MM: '%d моҳ',
	            y: 'як сол',
	            yy: '%d сол',
	        },
	        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === 'шаб') {
	                return hour < 4 ? hour : hour + 12;
	            } else if (meridiem === 'субҳ') {
	                return hour;
	            } else if (meridiem === 'рӯз') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === 'бегоҳ') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'шаб';
	            } else if (hour < 11) {
	                return 'субҳ';
	            } else if (hour < 16) {
	                return 'рӯз';
	            } else if (hour < 19) {
	                return 'бегоҳ';
	            } else {
	                return 'шаб';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
	        ordinal: function (number) {
	            var a = number % 10,
	                b = number >= 100 ? 100 : null;
	            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1th is the first week of the year.
	        },
	    });
	
	    return tg;
	
	})));


/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Thai [th]
	//! author : Kridsada Thanabulpong : https://github.com/sirn
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var th = moment.defineLocale('th', {
	        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
	            '_'
	        ),
	        monthsShort:
	            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
	        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
	        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'H:mm',
	            LTS: 'H:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY เวลา H:mm',
	            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
	        },
	        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
	        isPM: function (input) {
	            return input === 'หลังเที่ยง';
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'ก่อนเที่ยง';
	            } else {
	                return 'หลังเที่ยง';
	            }
	        },
	        calendar: {
	            sameDay: '[วันนี้ เวลา] LT',
	            nextDay: '[พรุ่งนี้ เวลา] LT',
	            nextWeek: 'dddd[หน้า เวลา] LT',
	            lastDay: '[เมื่อวานนี้ เวลา] LT',
	            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'อีก %s',
	            past: '%sที่แล้ว',
	            s: 'ไม่กี่วินาที',
	            ss: '%d วินาที',
	            m: '1 นาที',
	            mm: '%d นาที',
	            h: '1 ชั่วโมง',
	            hh: '%d ชั่วโมง',
	            d: '1 วัน',
	            dd: '%d วัน',
	            w: '1 สัปดาห์',
	            ww: '%d สัปดาห์',
	            M: '1 เดือน',
	            MM: '%d เดือน',
	            y: '1 ปี',
	            yy: '%d ปี',
	        },
	    });
	
	    return th;
	
	})));


/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkmen [tk]
	//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inji",
	        5: "'inji",
	        8: "'inji",
	        70: "'inji",
	        80: "'inji",
	        2: "'nji",
	        7: "'nji",
	        20: "'nji",
	        50: "'nji",
	        3: "'ünji",
	        4: "'ünji",
	        100: "'ünji",
	        6: "'njy",
	        9: "'unjy",
	        10: "'unjy",
	        30: "'unjy",
	        60: "'ynjy",
	        90: "'ynjy",
	    };
	
	    var tk = moment.defineLocale('tk', {
	        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
	        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
	            '_'
	        ),
	        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
	        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün sagat] LT',
	            nextDay: '[ertir sagat] LT',
	            nextWeek: '[indiki] dddd [sagat] LT',
	            lastDay: '[düýn] LT',
	            lastWeek: '[geçen] dddd [sagat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s soň',
	            past: '%s öň',
	            s: 'birnäçe sekunt',
	            m: 'bir minut',
	            mm: '%d minut',
	            h: 'bir sagat',
	            hh: '%d sagat',
	            d: 'bir gün',
	            dd: '%d gün',
	            M: 'bir aý',
	            MM: '%d aý',
	            y: 'bir ýyl',
	            yy: '%d ýyl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'unjy";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tk;
	
	})));


/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Tagalog (Philippines) [tl-ph]
	//! author : Dan Hagman : https://github.com/hagmandan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tlPh = moment.defineLocale('tl-ph', {
	        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
	            '_'
	        ),
	        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
	        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
	            '_'
	        ),
	        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
	        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'MM/D/YYYY',
	            LL: 'MMMM D, YYYY',
	            LLL: 'MMMM D, YYYY HH:mm',
	            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: 'LT [ngayong araw]',
	            nextDay: '[Bukas ng] LT',
	            nextWeek: 'LT [sa susunod na] dddd',
	            lastDay: 'LT [kahapon]',
	            lastWeek: 'LT [noong nakaraang] dddd',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'sa loob ng %s',
	            past: '%s ang nakalipas',
	            s: 'ilang segundo',
	            ss: '%d segundo',
	            m: 'isang minuto',
	            mm: '%d minuto',
	            h: 'isang oras',
	            hh: '%d oras',
	            d: 'isang araw',
	            dd: '%d araw',
	            M: 'isang buwan',
	            MM: '%d buwan',
	            y: 'isang taon',
	            yy: '%d taon',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlPh;
	
	})));


/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Klingon [tlh]
	//! author : Dominika Kruk : https://github.com/amaranthrose
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');
	
	    function translateFuture(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'leS'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'waQ'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'nem'
	                : time + ' pIq';
	        return time;
	    }
	
	    function translatePast(output) {
	        var time = output;
	        time =
	            output.indexOf('jaj') !== -1
	                ? time.slice(0, -3) + 'Hu’'
	                : output.indexOf('jar') !== -1
	                ? time.slice(0, -3) + 'wen'
	                : output.indexOf('DIS') !== -1
	                ? time.slice(0, -3) + 'ben'
	                : time + ' ret';
	        return time;
	    }
	
	    function translate(number, withoutSuffix, string, isFuture) {
	        var numberNoun = numberAsNoun(number);
	        switch (string) {
	            case 'ss':
	                return numberNoun + ' lup';
	            case 'mm':
	                return numberNoun + ' tup';
	            case 'hh':
	                return numberNoun + ' rep';
	            case 'dd':
	                return numberNoun + ' jaj';
	            case 'MM':
	                return numberNoun + ' jar';
	            case 'yy':
	                return numberNoun + ' DIS';
	        }
	    }
	
	    function numberAsNoun(number) {
	        var hundred = Math.floor((number % 1000) / 100),
	            ten = Math.floor((number % 100) / 10),
	            one = number % 10,
	            word = '';
	        if (hundred > 0) {
	            word += numbersNouns[hundred] + 'vatlh';
	        }
	        if (ten > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
	        }
	        if (one > 0) {
	            word += (word !== '' ? ' ' : '') + numbersNouns[one];
	        }
	        return word === '' ? 'pagh' : word;
	    }
	
	    var tlh = moment.defineLocale('tlh', {
	        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
	            '_'
	        ),
	        monthsShort:
	            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
	            '_'
	        ),
	        weekdaysShort:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        weekdaysMin:
	            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[DaHjaj] LT',
	            nextDay: '[wa’leS] LT',
	            nextWeek: 'LLL',
	            lastDay: '[wa’Hu’] LT',
	            lastWeek: 'LLL',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: translateFuture,
	            past: translatePast,
	            s: 'puS lup',
	            ss: translate,
	            m: 'wa’ tup',
	            mm: translate,
	            h: 'wa’ rep',
	            hh: translate,
	            d: 'wa’ jaj',
	            dd: translate,
	            M: 'wa’ jar',
	            MM: translate,
	            y: 'wa’ DIS',
	            yy: translate,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return tlh;
	
	})));


/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Turkish [tr]
	//! authors : Erhan Gundogan : https://github.com/erhangundogan,
	//!           Burak Yiğit Kaya: https://github.com/BYK
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var suffixes = {
	        1: "'inci",
	        5: "'inci",
	        8: "'inci",
	        70: "'inci",
	        80: "'inci",
	        2: "'nci",
	        7: "'nci",
	        20: "'nci",
	        50: "'nci",
	        3: "'üncü",
	        4: "'üncü",
	        100: "'üncü",
	        6: "'ncı",
	        9: "'uncu",
	        10: "'uncu",
	        30: "'uncu",
	        60: "'ıncı",
	        90: "'ıncı",
	    };
	
	    var tr = moment.defineLocale('tr', {
	        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
	            '_'
	        ),
	        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
	        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
	            '_'
	        ),
	        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
	        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'öö' : 'ÖÖ';
	            } else {
	                return isLower ? 'ös' : 'ÖS';
	            }
	        },
	        meridiemParse: /öö|ÖÖ|ös|ÖS/,
	        isPM: function (input) {
	            return input === 'ös' || input === 'ÖS';
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[bugün saat] LT',
	            nextDay: '[yarın saat] LT',
	            nextWeek: '[gelecek] dddd [saat] LT',
	            lastDay: '[dün] LT',
	            lastWeek: '[geçen] dddd [saat] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s sonra',
	            past: '%s önce',
	            s: 'birkaç saniye',
	            ss: '%d saniye',
	            m: 'bir dakika',
	            mm: '%d dakika',
	            h: 'bir saat',
	            hh: '%d saat',
	            d: 'bir gün',
	            dd: '%d gün',
	            w: 'bir hafta',
	            ww: '%d hafta',
	            M: 'bir ay',
	            MM: '%d ay',
	            y: 'bir yıl',
	            yy: '%d yıl',
	        },
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'Do':
	                case 'DD':
	                    return number;
	                default:
	                    if (number === 0) {
	                        // special case for zero
	                        return number + "'ıncı";
	                    }
	                    var a = number % 10,
	                        b = (number % 100) - a,
	                        c = number >= 100 ? 100 : null;
	                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return tr;
	
	})));


/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Talossan [tzl]
	//! author : Robin van der Vliet : https://github.com/robin0van0der0v
	//! author : Iustì Canun
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
	    // This is currently too difficult (maybe even impossible) to add.
	    var tzl = moment.defineLocale('tzl', {
	        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
	            '_'
	        ),
	        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
	        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
	        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
	        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
	        longDateFormat: {
	            LT: 'HH.mm',
	            LTS: 'HH.mm.ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D. MMMM [dallas] YYYY',
	            LLL: 'D. MMMM [dallas] YYYY HH.mm',
	            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
	        },
	        meridiemParse: /d\'o|d\'a/i,
	        isPM: function (input) {
	            return "d'o" === input.toLowerCase();
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours > 11) {
	                return isLower ? "d'o" : "D'O";
	            } else {
	                return isLower ? "d'a" : "D'A";
	            }
	        },
	        calendar: {
	            sameDay: '[oxhi à] LT',
	            nextDay: '[demà à] LT',
	            nextWeek: 'dddd [à] LT',
	            lastDay: '[ieiri à] LT',
	            lastWeek: '[sür el] dddd [lasteu à] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'osprei %s',
	            past: 'ja%s',
	            s: processRelativeTime,
	            ss: processRelativeTime,
	            m: processRelativeTime,
	            mm: processRelativeTime,
	            h: processRelativeTime,
	            hh: processRelativeTime,
	            d: processRelativeTime,
	            dd: processRelativeTime,
	            M: processRelativeTime,
	            MM: processRelativeTime,
	            y: processRelativeTime,
	            yy: processRelativeTime,
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}\./,
	        ordinal: '%d.',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    function processRelativeTime(number, withoutSuffix, key, isFuture) {
	        var format = {
	            s: ['viensas secunds', "'iensas secunds"],
	            ss: [number + ' secunds', '' + number + ' secunds'],
	            m: ["'n míut", "'iens míut"],
	            mm: [number + ' míuts', '' + number + ' míuts'],
	            h: ["'n þora", "'iensa þora"],
	            hh: [number + ' þoras', '' + number + ' þoras'],
	            d: ["'n ziua", "'iensa ziua"],
	            dd: [number + ' ziuas', '' + number + ' ziuas'],
	            M: ["'n mes", "'iens mes"],
	            MM: [number + ' mesen', '' + number + ' mesen'],
	            y: ["'n ar", "'iens ar"],
	            yy: [number + ' ars', '' + number + ' ars'],
	        };
	        return isFuture
	            ? format[key][0]
	            : withoutSuffix
	            ? format[key][0]
	            : format[key][1];
	    }
	
	    return tzl;
	
	})));


/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight Latin [tzm-latn]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzmLatn = moment.defineLocale('tzm-latn', {
	        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	            '_'
	        ),
	        monthsShort:
	            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
	                '_'
	            ),
	        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[asdkh g] LT',
	            nextDay: '[aska g] LT',
	            nextWeek: 'dddd [g] LT',
	            lastDay: '[assant g] LT',
	            lastWeek: 'dddd [g] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'dadkh s yan %s',
	            past: 'yan %s',
	            s: 'imik',
	            ss: '%d imik',
	            m: 'minuḍ',
	            mm: '%d minuḍ',
	            h: 'saɛa',
	            hh: '%d tassaɛin',
	            d: 'ass',
	            dd: '%d ossan',
	            M: 'ayowr',
	            MM: '%d iyyirn',
	            y: 'asgas',
	            yy: '%d isgasn',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzmLatn;
	
	})));


/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Central Atlas Tamazight [tzm]
	//! author : Abdel Said : https://github.com/abdelsaid
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var tzm = moment.defineLocale('tzm', {
	        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	            '_'
	        ),
	        monthsShort:
	            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
	                '_'
	            ),
	        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
	            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
	            nextWeek: 'dddd [ⴴ] LT',
	            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
	            lastWeek: 'dddd [ⴴ] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
	            past: 'ⵢⴰⵏ %s',
	            s: 'ⵉⵎⵉⴽ',
	            ss: '%d ⵉⵎⵉⴽ',
	            m: 'ⵎⵉⵏⵓⴺ',
	            mm: '%d ⵎⵉⵏⵓⴺ',
	            h: 'ⵙⴰⵄⴰ',
	            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
	            d: 'ⴰⵙⵙ',
	            dd: '%d oⵙⵙⴰⵏ',
	            M: 'ⴰⵢoⵓⵔ',
	            MM: '%d ⵉⵢⵢⵉⵔⵏ',
	            y: 'ⴰⵙⴳⴰⵙ',
	            yy: '%d ⵉⵙⴳⴰⵙⵏ',
	        },
	        week: {
	            dow: 6, // Saturday is the first day of the week.
	            doy: 12, // The week that contains Jan 12th is the first week of the year.
	        },
	    });
	
	    return tzm;
	
	})));


/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uyghur (China) [ug-cn]
	//! author: boyaq : https://github.com/boyaq
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var ugCn = moment.defineLocale('ug-cn', {
	        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	            '_'
	        ),
	        monthsShort:
	            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
	                '_'
	            ),
	        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
	            '_'
	        ),
	        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY-MM-DD',
	            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
	            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
	        },
	        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (
	                meridiem === 'يېرىم كېچە' ||
	                meridiem === 'سەھەر' ||
	                meridiem === 'چۈشتىن بۇرۇن'
	            ) {
	                return hour;
	            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
	                return hour + 12;
	            } else {
	                return hour >= 11 ? hour : hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return 'يېرىم كېچە';
	            } else if (hm < 900) {
	                return 'سەھەر';
	            } else if (hm < 1130) {
	                return 'چۈشتىن بۇرۇن';
	            } else if (hm < 1230) {
	                return 'چۈش';
	            } else if (hm < 1800) {
	                return 'چۈشتىن كېيىن';
	            } else {
	                return 'كەچ';
	            }
	        },
	        calendar: {
	            sameDay: '[بۈگۈن سائەت] LT',
	            nextDay: '[ئەتە سائەت] LT',
	            nextWeek: '[كېلەركى] dddd [سائەت] LT',
	            lastDay: '[تۆنۈگۈن] LT',
	            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s كېيىن',
	            past: '%s بۇرۇن',
	            s: 'نەچچە سېكونت',
	            ss: '%d سېكونت',
	            m: 'بىر مىنۇت',
	            mm: '%d مىنۇت',
	            h: 'بىر سائەت',
	            hh: '%d سائەت',
	            d: 'بىر كۈن',
	            dd: '%d كۈن',
	            M: 'بىر ئاي',
	            MM: '%d ئاي',
	            y: 'بىر يىل',
	            yy: '%d يىل',
	        },
	
	        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '-كۈنى';
	                case 'w':
	                case 'W':
	                    return number + '-ھەپتە';
	                default:
	                    return number;
	            }
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 1st is the first week of the year.
	        },
	    });
	
	    return ugCn;
	
	})));


/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Ukrainian [uk]
	//! author : zemlanin : https://github.com/zemlanin
	//! Author : Menelion Elensúle : https://github.com/Oire
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    function plural(word, num) {
	        var forms = word.split('_');
	        return num % 10 === 1 && num % 100 !== 11
	            ? forms[0]
	            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
	            ? forms[1]
	            : forms[2];
	    }
	    function relativeTimeWithPlural(number, withoutSuffix, key) {
	        var format = {
	            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
	            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
	            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
	            dd: 'день_дні_днів',
	            MM: 'місяць_місяці_місяців',
	            yy: 'рік_роки_років',
	        };
	        if (key === 'm') {
	            return withoutSuffix ? 'хвилина' : 'хвилину';
	        } else if (key === 'h') {
	            return withoutSuffix ? 'година' : 'годину';
	        } else {
	            return number + ' ' + plural(format[key], +number);
	        }
	    }
	    function weekdaysCaseReplace(m, format) {
	        var weekdays = {
	                nominative:
	                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
	                        '_'
	                    ),
	                accusative:
	                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
	                        '_'
	                    ),
	                genitive:
	                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
	                        '_'
	                    ),
	            },
	            nounCase;
	
	        if (m === true) {
	            return weekdays['nominative']
	                .slice(1, 7)
	                .concat(weekdays['nominative'].slice(0, 1));
	        }
	        if (!m) {
	            return weekdays['nominative'];
	        }
	
	        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
	            ? 'accusative'
	            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
	            ? 'genitive'
	            : 'nominative';
	        return weekdays[nounCase][m.day()];
	    }
	    function processHoursFunction(str) {
	        return function () {
	            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
	        };
	    }
	
	    var uk = moment.defineLocale('uk', {
	        months: {
	            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
	                '_'
	            ),
	            standalone:
	                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
	                    '_'
	                ),
	        },
	        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
	            '_'
	        ),
	        weekdays: weekdaysCaseReplace,
	        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD.MM.YYYY',
	            LL: 'D MMMM YYYY р.',
	            LLL: 'D MMMM YYYY р., HH:mm',
	            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
	        },
	        calendar: {
	            sameDay: processHoursFunction('[Сьогодні '),
	            nextDay: processHoursFunction('[Завтра '),
	            lastDay: processHoursFunction('[Вчора '),
	            nextWeek: processHoursFunction('[У] dddd ['),
	            lastWeek: function () {
	                switch (this.day()) {
	                    case 0:
	                    case 3:
	                    case 5:
	                    case 6:
	                        return processHoursFunction('[Минулої] dddd [').call(this);
	                    case 1:
	                    case 2:
	                    case 4:
	                        return processHoursFunction('[Минулого] dddd [').call(this);
	                }
	            },
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'за %s',
	            past: '%s тому',
	            s: 'декілька секунд',
	            ss: relativeTimeWithPlural,
	            m: relativeTimeWithPlural,
	            mm: relativeTimeWithPlural,
	            h: 'годину',
	            hh: relativeTimeWithPlural,
	            d: 'день',
	            dd: relativeTimeWithPlural,
	            M: 'місяць',
	            MM: relativeTimeWithPlural,
	            y: 'рік',
	            yy: relativeTimeWithPlural,
	        },
	        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
	        meridiemParse: /ночі|ранку|дня|вечора/,
	        isPM: function (input) {
	            return /^(дня|вечора)$/.test(input);
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 4) {
	                return 'ночі';
	            } else if (hour < 12) {
	                return 'ранку';
	            } else if (hour < 17) {
	                return 'дня';
	            } else {
	                return 'вечора';
	            }
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'M':
	                case 'd':
	                case 'DDD':
	                case 'w':
	                case 'W':
	                    return number + '-й';
	                case 'D':
	                    return number + '-го';
	                default:
	                    return number;
	            }
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uk;
	
	})));


/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Urdu [ur]
	//! author : Sawood Alam : https://github.com/ibnesayeed
	//! author : Zack : https://github.com/ZackVision
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var months = [
	            'جنوری',
	            'فروری',
	            'مارچ',
	            'اپریل',
	            'مئی',
	            'جون',
	            'جولائی',
	            'اگست',
	            'ستمبر',
	            'اکتوبر',
	            'نومبر',
	            'دسمبر',
	        ],
	        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];
	
	    var ur = moment.defineLocale('ur', {
	        months: months,
	        monthsShort: months,
	        weekdays: days,
	        weekdaysShort: days,
	        weekdaysMin: days,
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd، D MMMM YYYY HH:mm',
	        },
	        meridiemParse: /صبح|شام/,
	        isPM: function (input) {
	            return 'شام' === input;
	        },
	        meridiem: function (hour, minute, isLower) {
	            if (hour < 12) {
	                return 'صبح';
	            }
	            return 'شام';
	        },
	        calendar: {
	            sameDay: '[آج بوقت] LT',
	            nextDay: '[کل بوقت] LT',
	            nextWeek: 'dddd [بوقت] LT',
	            lastDay: '[گذشتہ روز بوقت] LT',
	            lastWeek: '[گذشتہ] dddd [بوقت] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s بعد',
	            past: '%s قبل',
	            s: 'چند سیکنڈ',
	            ss: '%d سیکنڈ',
	            m: 'ایک منٹ',
	            mm: '%d منٹ',
	            h: 'ایک گھنٹہ',
	            hh: '%d گھنٹے',
	            d: 'ایک دن',
	            dd: '%d دن',
	            M: 'ایک ماہ',
	            MM: '%d ماہ',
	            y: 'ایک سال',
	            yy: '%d سال',
	        },
	        preparse: function (string) {
	            return string.replace(/،/g, ',');
	        },
	        postformat: function (string) {
	            return string.replace(/,/g, '،');
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return ur;
	
	})));


/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek Latin [uz-latn]
	//! author : Rasulbek Mirzayev : github.com/Rasulbeeek
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uzLatn = moment.defineLocale('uz-latn', {
	        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
	            '_'
	        ),
	        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
	        weekdays:
	            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
	                '_'
	            ),
	        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
	        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Bugun soat] LT [da]',
	            nextDay: '[Ertaga] LT [da]',
	            nextWeek: 'dddd [kuni soat] LT [da]',
	            lastDay: '[Kecha soat] LT [da]',
	            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Yaqin %s ichida',
	            past: 'Bir necha %s oldin',
	            s: 'soniya',
	            ss: '%d soniya',
	            m: 'bir daqiqa',
	            mm: '%d daqiqa',
	            h: 'bir soat',
	            hh: '%d soat',
	            d: 'bir kun',
	            dd: '%d kun',
	            M: 'bir oy',
	            MM: '%d oy',
	            y: 'bir yil',
	            yy: '%d yil',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 7th is the first week of the year.
	        },
	    });
	
	    return uzLatn;
	
	})));


/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Uzbek [uz]
	//! author : Sardor Muminov : https://github.com/muminoff
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var uz = moment.defineLocale('uz', {
	        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
	            '_'
	        ),
	        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
	        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
	        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
	        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'D MMMM YYYY, dddd HH:mm',
	        },
	        calendar: {
	            sameDay: '[Бугун соат] LT [да]',
	            nextDay: '[Эртага] LT [да]',
	            nextWeek: 'dddd [куни соат] LT [да]',
	            lastDay: '[Кеча соат] LT [да]',
	            lastWeek: '[Утган] dddd [куни соат] LT [да]',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'Якин %s ичида',
	            past: 'Бир неча %s олдин',
	            s: 'фурсат',
	            ss: '%d фурсат',
	            m: 'бир дакика',
	            mm: '%d дакика',
	            h: 'бир соат',
	            hh: '%d соат',
	            d: 'бир кун',
	            dd: '%d кун',
	            M: 'бир ой',
	            MM: '%d ой',
	            y: 'бир йил',
	            yy: '%d йил',
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 7, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return uz;
	
	})));


/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Vietnamese [vi]
	//! author : Bang Nguyen : https://github.com/bangnk
	//! author : Chien Kira : https://github.com/chienkira
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var vi = moment.defineLocale('vi', {
	        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
	            '_'
	        ),
	        monthsShort:
	            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
	            '_'
	        ),
	        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
	        weekdaysParseExact: true,
	        meridiemParse: /sa|ch/i,
	        isPM: function (input) {
	            return /^ch$/i.test(input);
	        },
	        meridiem: function (hours, minutes, isLower) {
	            if (hours < 12) {
	                return isLower ? 'sa' : 'SA';
	            } else {
	                return isLower ? 'ch' : 'CH';
	            }
	        },
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM [năm] YYYY',
	            LLL: 'D MMMM [năm] YYYY HH:mm',
	            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
	            l: 'DD/M/YYYY',
	            ll: 'D MMM YYYY',
	            lll: 'D MMM YYYY HH:mm',
	            llll: 'ddd, D MMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[Hôm nay lúc] LT',
	            nextDay: '[Ngày mai lúc] LT',
	            nextWeek: 'dddd [tuần tới lúc] LT',
	            lastDay: '[Hôm qua lúc] LT',
	            lastWeek: 'dddd [tuần trước lúc] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: '%s tới',
	            past: '%s trước',
	            s: 'vài giây',
	            ss: '%d giây',
	            m: 'một phút',
	            mm: '%d phút',
	            h: 'một giờ',
	            hh: '%d giờ',
	            d: 'một ngày',
	            dd: '%d ngày',
	            w: 'một tuần',
	            ww: '%d tuần',
	            M: 'một tháng',
	            MM: '%d tháng',
	            y: 'một năm',
	            yy: '%d năm',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}/,
	        ordinal: function (number) {
	            return number;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return vi;
	
	})));


/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Pseudo [x-pseudo]
	//! author : Andrew Hood : https://github.com/andrewhood125
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var xPseudo = moment.defineLocale('x-pseudo', {
	        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
	            '_'
	        ),
	        monthsShort:
	            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
	                '_'
	            ),
	        monthsParseExact: true,
	        weekdays:
	            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
	                '_'
	            ),
	        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
	        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
	        weekdaysParseExact: true,
	        longDateFormat: {
	            LT: 'HH:mm',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY HH:mm',
	            LLLL: 'dddd, D MMMM YYYY HH:mm',
	        },
	        calendar: {
	            sameDay: '[T~ódá~ý át] LT',
	            nextDay: '[T~ómó~rró~w át] LT',
	            nextWeek: 'dddd [át] LT',
	            lastDay: '[Ý~ést~érdá~ý át] LT',
	            lastWeek: '[L~ást] dddd [át] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'í~ñ %s',
	            past: '%s á~gó',
	            s: 'á ~féw ~sécó~ñds',
	            ss: '%d s~écóñ~ds',
	            m: 'á ~míñ~úté',
	            mm: '%d m~íñú~tés',
	            h: 'á~ñ hó~úr',
	            hh: '%d h~óúrs',
	            d: 'á ~dáý',
	            dd: '%d d~áýs',
	            M: 'á ~móñ~th',
	            MM: '%d m~óñt~hs',
	            y: 'á ~ýéár',
	            yy: '%d ý~éárs',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
	        ordinal: function (number) {
	            var b = number % 10,
	                output =
	                    ~~((number % 100) / 10) === 1
	                        ? 'th'
	                        : b === 1
	                        ? 'st'
	                        : b === 2
	                        ? 'nd'
	                        : b === 3
	                        ? 'rd'
	                        : 'th';
	            return number + output;
	        },
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return xPseudo;
	
	})));


/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Yoruba Nigeria [yo]
	//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var yo = moment.defineLocale('yo', {
	        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
	            '_'
	        ),
	        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
	        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
	        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
	        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
	        longDateFormat: {
	            LT: 'h:mm A',
	            LTS: 'h:mm:ss A',
	            L: 'DD/MM/YYYY',
	            LL: 'D MMMM YYYY',
	            LLL: 'D MMMM YYYY h:mm A',
	            LLLL: 'dddd, D MMMM YYYY h:mm A',
	        },
	        calendar: {
	            sameDay: '[Ònì ni] LT',
	            nextDay: '[Ọ̀la ni] LT',
	            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
	            lastDay: '[Àna ni] LT',
	            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
	            sameElse: 'L',
	        },
	        relativeTime: {
	            future: 'ní %s',
	            past: '%s kọjá',
	            s: 'ìsẹjú aayá die',
	            ss: 'aayá %d',
	            m: 'ìsẹjú kan',
	            mm: 'ìsẹjú %d',
	            h: 'wákati kan',
	            hh: 'wákati %d',
	            d: 'ọjọ́ kan',
	            dd: 'ọjọ́ %d',
	            M: 'osù kan',
	            MM: 'osù %d',
	            y: 'ọdún kan',
	            yy: 'ọdún %d',
	        },
	        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
	        ordinal: 'ọjọ́ %d',
	        week: {
	            dow: 1, // Monday is the first day of the week.
	            doy: 4, // The week that contains Jan 4th is the first week of the year.
	        },
	    });
	
	    return yo;
	
	})));


/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Hong Kong) [zh-hk]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Konstantin : https://github.com/skfd
	//! author : Anthony : https://github.com/anthonylau
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhHk = moment.defineLocale('zh-hk', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1200) {
	                return '上午';
	            } else if (hm === 1200) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天]LT',
	            nextDay: '[明天]LT',
	            nextWeek: '[下]ddddLT',
	            lastDay: '[昨天]LT',
	            lastWeek: '[上]ddddLT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhHk;
	
	})));


/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Macau) [zh-mo]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	//! author : Tan Yuanhong : https://github.com/le0tan
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhMo = moment.defineLocale('zh-mo', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'DD/MM/YYYY',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'D/M/YYYY',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s內',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhMo;
	
	})));


/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	//! moment.js locale configuration
	//! locale : Chinese (Taiwan) [zh-tw]
	//! author : Ben : https://github.com/ben-lin
	//! author : Chris Lam : https://github.com/hehachris
	
	;(function (global, factory) {
	    true ? factory(__webpack_require__(3)) :
	   typeof define === 'function' && define.amd ? define(['../moment'], factory) :
	   factory(global.moment)
	}(this, (function (moment) { 'use strict';
	
	    //! moment.js locale configuration
	
	    var zhTw = moment.defineLocale('zh-tw', {
	        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
	            '_'
	        ),
	        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
	            '_'
	        ),
	        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
	        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
	        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
	        longDateFormat: {
	            LT: 'HH:mm',
	            LTS: 'HH:mm:ss',
	            L: 'YYYY/MM/DD',
	            LL: 'YYYY年M月D日',
	            LLL: 'YYYY年M月D日 HH:mm',
	            LLLL: 'YYYY年M月D日dddd HH:mm',
	            l: 'YYYY/M/D',
	            ll: 'YYYY年M月D日',
	            lll: 'YYYY年M月D日 HH:mm',
	            llll: 'YYYY年M月D日dddd HH:mm',
	        },
	        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
	        meridiemHour: function (hour, meridiem) {
	            if (hour === 12) {
	                hour = 0;
	            }
	            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
	                return hour;
	            } else if (meridiem === '中午') {
	                return hour >= 11 ? hour : hour + 12;
	            } else if (meridiem === '下午' || meridiem === '晚上') {
	                return hour + 12;
	            }
	        },
	        meridiem: function (hour, minute, isLower) {
	            var hm = hour * 100 + minute;
	            if (hm < 600) {
	                return '凌晨';
	            } else if (hm < 900) {
	                return '早上';
	            } else if (hm < 1130) {
	                return '上午';
	            } else if (hm < 1230) {
	                return '中午';
	            } else if (hm < 1800) {
	                return '下午';
	            } else {
	                return '晚上';
	            }
	        },
	        calendar: {
	            sameDay: '[今天] LT',
	            nextDay: '[明天] LT',
	            nextWeek: '[下]dddd LT',
	            lastDay: '[昨天] LT',
	            lastWeek: '[上]dddd LT',
	            sameElse: 'L',
	        },
	        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
	        ordinal: function (number, period) {
	            switch (period) {
	                case 'd':
	                case 'D':
	                case 'DDD':
	                    return number + '日';
	                case 'M':
	                    return number + '月';
	                case 'w':
	                case 'W':
	                    return number + '週';
	                default:
	                    return number;
	            }
	        },
	        relativeTime: {
	            future: '%s後',
	            past: '%s前',
	            s: '幾秒',
	            ss: '%d 秒',
	            m: '1 分鐘',
	            mm: '%d 分鐘',
	            h: '1 小時',
	            hh: '%d 小時',
	            d: '1 天',
	            dd: '%d 天',
	            M: '1 個月',
	            MM: '%d 個月',
	            y: '1 年',
	            yy: '%d 年',
	        },
	    });
	
	    return zhTw;
	
	})));


/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(1375);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(2624);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 1067 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 1068 */
/***/ function(module, exports) {

	var component = /-?\d+(\.\d+)?%?/g;
	function extractComponents(color) {
	  return color.match(component);
	}
	
	module.exports = extractComponents;

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Align = __webpack_require__(2634);
	
	var _Align2 = _interopRequireDefault(_Align);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Align2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 1070 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var util = {
	  isAppearSupported: function isAppearSupported(props) {
	    return props.transitionName && props.transitionAppear || props.animation.appear;
	  },
	  isEnterSupported: function isEnterSupported(props) {
	    return props.transitionName && props.transitionEnter || props.animation.enter;
	  },
	  isLeaveSupported: function isLeaveSupported(props) {
	    return props.transitionName && props.transitionLeave || props.animation.leave;
	  },
	  allowAppearCallback: function allowAppearCallback(props) {
	    return props.transitionAppear || props.animation.appear;
	  },
	  allowEnterCallback: function allowEnterCallback(props) {
	    return props.transitionEnter || props.animation.enter;
	  },
	  allowLeaveCallback: function allowLeaveCallback(props) {
	    return props.transitionLeave || props.animation.leave;
	  }
	};
	exports["default"] = util;
	module.exports = exports['default'];

/***/ },
/* 1071 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getVendorPrefixes = getVendorPrefixes;
	exports.getVendorPrefixedEventName = getVendorPrefixedEventName;
	exports.getTransitionName = getTransitionName;
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	// ================= Transition =================
	// Event wrapper. Copy from react source code
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	function getVendorPrefixes(domSupport, win) {
	  var prefixes = {
	    animationend: makePrefixMap('Animation', 'AnimationEnd'),
	    transitionend: makePrefixMap('Transition', 'TransitionEnd')
	  };
	
	  if (domSupport) {
	    if (!('AnimationEvent' in win)) {
	      delete prefixes.animationend.animation;
	    }
	
	    if (!('TransitionEvent' in win)) {
	      delete prefixes.transitionend.transition;
	    }
	  }
	
	  return prefixes;
	}
	
	var vendorPrefixes = getVendorPrefixes(canUseDOM, typeof window !== 'undefined' ? window : {});
	
	var style = {};
	
	if (canUseDOM) {
	  style = document.createElement('div').style;
	}
	
	var prefixedEventNames = {};
	
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  if (prefixMap) {
	    var stylePropList = Object.keys(prefixMap);
	    var len = stylePropList.length;
	    for (var i = 0; i < len; i += 1) {
	      var styleProp = stylePropList[i];
	      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
	        prefixedEventNames[eventName] = prefixMap[styleProp];
	        return prefixedEventNames[eventName];
	      }
	    }
	  }
	
	  return '';
	}
	
	var animationEndName = exports.animationEndName = getVendorPrefixedEventName('animationend');
	var transitionEndName = exports.transitionEndName = getVendorPrefixedEventName('transitionend');
	var supportTransition = exports.supportTransition = !!(animationEndName && transitionEndName);
	
	function getTransitionName(transitionName, transitionType) {
	  if (!transitionName) return null;
	
	  if (typeof transitionName === 'object') {
	    var type = transitionType.replace(/-\w/g, function (match) {
	      return match[1].toUpperCase();
	    });
	    return transitionName[type];
	  }
	
	  return transitionName + '-' + transitionType;
	}

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(71);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _CalendarHeader = __webpack_require__(555);
	
	var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	var _CalendarFooter = __webpack_require__(1073);
	
	var _CalendarFooter2 = _interopRequireDefault(_CalendarFooter);
	
	var _CalendarMixin = __webpack_require__(557);
	
	var _CommonMixin = __webpack_require__(382);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MonthCalendar = function (_React$Component) {
	  (0, _inherits3['default'])(MonthCalendar, _React$Component);
	
	  function MonthCalendar(props) {
	    (0, _classCallCheck3['default'])(this, MonthCalendar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.onKeyDown = function (event) {
	      var keyCode = event.keyCode;
	      var ctrlKey = event.ctrlKey || event.metaKey;
	      var stateValue = _this.state.value;
	      var disabledDate = _this.props.disabledDate;
	
	      var value = stateValue;
	      switch (keyCode) {
	        case _KeyCode2['default'].DOWN:
	          value = stateValue.clone();
	          value.add(3, 'months');
	          break;
	        case _KeyCode2['default'].UP:
	          value = stateValue.clone();
	          value.add(-3, 'months');
	          break;
	        case _KeyCode2['default'].LEFT:
	          value = stateValue.clone();
	          if (ctrlKey) {
	            value.add(-1, 'years');
	          } else {
	            value.add(-1, 'months');
	          }
	          break;
	        case _KeyCode2['default'].RIGHT:
	          value = stateValue.clone();
	          if (ctrlKey) {
	            value.add(1, 'years');
	          } else {
	            value.add(1, 'months');
	          }
	          break;
	        case _KeyCode2['default'].ENTER:
	          if (!disabledDate || !disabledDate(stateValue)) {
	            _this.onSelect(stateValue);
	          }
	          event.preventDefault();
	          return 1;
	        default:
	          return undefined;
	      }
	      if (value !== stateValue) {
	        _this.setValue(value);
	        event.preventDefault();
	        return 1;
	      }
	    };
	
	    _this.handlePanelChange = function (_, mode) {
	      if (mode !== 'date') {
	        _this.setState({ mode: mode });
	      }
	    };
	
	    _this.state = {
	      mode: 'month',
	      value: props.value || props.defaultValue || (0, _moment2['default'])(),
	      selectedValue: props.selectedValue || props.defaultSelectedValue
	    };
	    return _this;
	  }
	
	  MonthCalendar.prototype.render = function render() {
	    var props = this.props,
	        state = this.state;
	    var mode = state.mode,
	        value = state.value;
	
	    var children = _react2['default'].createElement(
	      'div',
	      { className: props.prefixCls + '-month-calendar-content' },
	      _react2['default'].createElement(
	        'div',
	        { className: props.prefixCls + '-month-header-wrap' },
	        _react2['default'].createElement(_CalendarHeader2['default'], {
	          prefixCls: props.prefixCls,
	          mode: mode,
	          value: value,
	          locale: props.locale,
	          disabledMonth: props.disabledDate,
	          monthCellRender: props.monthCellRender,
	          monthCellContentRender: props.monthCellContentRender,
	          onMonthSelect: this.onSelect,
	          onValueChange: this.setValue,
	          onPanelChange: this.handlePanelChange
	        })
	      ),
	      _react2['default'].createElement(_CalendarFooter2['default'], {
	        prefixCls: props.prefixCls,
	        renderFooter: props.renderFooter
	      })
	    );
	    return this.renderRoot({
	      className: props.prefixCls + '-month-calendar',
	      children: children
	    });
	  };
	
	  return MonthCalendar;
	}(_react2['default'].Component);
	
	MonthCalendar.propTypes = (0, _extends3['default'])({}, _CalendarMixin.calendarMixinPropTypes, _CommonMixin.propType, {
	  monthCellRender: _propTypes2['default'].func,
	  value: _propTypes2['default'].object,
	  defaultValue: _propTypes2['default'].object,
	  selectedValue: _propTypes2['default'].object,
	  defaultSelectedValue: _propTypes2['default'].object,
	  disabledDate: _propTypes2['default'].func
	});
	MonthCalendar.defaultProps = (0, _extends3['default'])({}, _CommonMixin.defaultProp, _CalendarMixin.calendarMixinDefaultProps);
	exports['default'] = (0, _reactLifecyclesCompat.polyfill)((0, _CalendarMixin.calendarMixinWrapper)((0, _CommonMixin.commonMixinWrapper)(MonthCalendar)));
	module.exports = exports['default'];

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _mapSelf = __webpack_require__(1122);
	
	var _mapSelf2 = _interopRequireDefault(_mapSelf);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _TodayButton = __webpack_require__(1076);
	
	var _TodayButton2 = _interopRequireDefault(_TodayButton);
	
	var _OkButton = __webpack_require__(1074);
	
	var _OkButton2 = _interopRequireDefault(_OkButton);
	
	var _TimePickerButton = __webpack_require__(1075);
	
	var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CalendarFooter = function (_React$Component) {
	  (0, _inherits3['default'])(CalendarFooter, _React$Component);
	
	  function CalendarFooter() {
	    (0, _classCallCheck3['default'])(this, CalendarFooter);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CalendarFooter.prototype.onSelect = function onSelect(value) {
	    this.props.onSelect(value);
	  };
	
	  CalendarFooter.prototype.getRootDOMNode = function getRootDOMNode() {
	    return _reactDom2['default'].findDOMNode(this);
	  };
	
	  CalendarFooter.prototype.render = function render() {
	    var props = this.props;
	    var value = props.value,
	        prefixCls = props.prefixCls,
	        showOk = props.showOk,
	        timePicker = props.timePicker,
	        renderFooter = props.renderFooter,
	        mode = props.mode;
	
	    var footerEl = null;
	    var extraFooter = renderFooter && renderFooter(mode);
	    if (props.showToday || timePicker || extraFooter) {
	      var _cx;
	
	      var nowEl = void 0;
	      if (props.showToday) {
	        nowEl = _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, { value: value }));
	      }
	      var okBtn = void 0;
	      if (showOk === true || showOk !== false && !!props.timePicker) {
	        okBtn = _react2['default'].createElement(_OkButton2['default'], props);
	      }
	      var timePickerBtn = void 0;
	      if (!!props.timePicker) {
	        timePickerBtn = _react2['default'].createElement(_TimePickerButton2['default'], props);
	      }
	
	      var footerBtn = void 0;
	      if (nowEl || timePickerBtn || okBtn || extraFooter) {
	        footerBtn = _react2['default'].createElement(
	          'span',
	          { className: prefixCls + '-footer-btn' },
	          extraFooter,
	          (0, _mapSelf2['default'])([nowEl, timePickerBtn, okBtn])
	        );
	      }
	      var cls = (0, _classnames2['default'])(prefixCls + '-footer', (_cx = {}, _cx[prefixCls + '-footer-show-ok'] = okBtn, _cx));
	      footerEl = _react2['default'].createElement(
	        'div',
	        { className: cls },
	        footerBtn
	      );
	    }
	    return footerEl;
	  };
	
	  return CalendarFooter;
	}(_react2['default'].Component);
	
	CalendarFooter.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  showDateInput: _propTypes2['default'].bool,
	  disabledTime: _propTypes2['default'].any,
	  timePicker: _propTypes2['default'].element,
	  selectedValue: _propTypes2['default'].any,
	  showOk: _propTypes2['default'].bool,
	  onSelect: _propTypes2['default'].func,
	  value: _propTypes2['default'].object,
	  renderFooter: _propTypes2['default'].func,
	  defaultValue: _propTypes2['default'].object,
	  mode: _propTypes2['default'].string
	};
	exports['default'] = CalendarFooter;
	module.exports = exports['default'];

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = OkButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function OkButton(_ref) {
	  var prefixCls = _ref.prefixCls,
	      locale = _ref.locale,
	      okDisabled = _ref.okDisabled,
	      onOk = _ref.onOk;
	
	  var className = prefixCls + "-ok-btn";
	  if (okDisabled) {
	    className += " " + prefixCls + "-ok-btn-disabled";
	  }
	  return _react2["default"].createElement(
	    "a",
	    {
	      className: className,
	      role: "button",
	      onClick: okDisabled ? null : onOk
	    },
	    locale.ok
	  );
	}
	module.exports = exports['default'];

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = TimePickerButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function TimePickerButton(_ref) {
	  var _classnames;
	
	  var prefixCls = _ref.prefixCls,
	      locale = _ref.locale,
	      showTimePicker = _ref.showTimePicker,
	      onOpenTimePicker = _ref.onOpenTimePicker,
	      onCloseTimePicker = _ref.onCloseTimePicker,
	      timePickerDisabled = _ref.timePickerDisabled;
	
	  var className = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-time-picker-btn'] = true, _classnames[prefixCls + '-time-picker-btn-disabled'] = timePickerDisabled, _classnames));
	  var onClick = null;
	  if (!timePickerDisabled) {
	    onClick = showTimePicker ? onCloseTimePicker : onOpenTimePicker;
	  }
	  return _react2['default'].createElement(
	    'a',
	    {
	      className: className,
	      role: 'button',
	      onClick: onClick
	    },
	    showTimePicker ? locale.dateSelect : locale.timeSelect
	  );
	}
	module.exports = exports['default'];

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = TodayButton;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _util = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function TodayButton(_ref) {
	  var prefixCls = _ref.prefixCls,
	      locale = _ref.locale,
	      value = _ref.value,
	      timePicker = _ref.timePicker,
	      disabled = _ref.disabled,
	      disabledDate = _ref.disabledDate,
	      onToday = _ref.onToday,
	      text = _ref.text;
	
	  var localeNow = (!text && timePicker ? locale.now : text) || locale.today;
	  var disabledToday = disabledDate && !(0, _util.isAllowedDate)((0, _util.getTodayTime)(value), disabledDate);
	  var isDisabled = disabledToday || disabled;
	  var disabledTodayClass = isDisabled ? prefixCls + '-today-btn-disabled' : '';
	  return _react2['default'].createElement(
	    'a',
	    {
	      className: prefixCls + '-today-btn ' + disabledTodayClass,
	      role: 'button',
	      onClick: isDisabled ? null : onToday,
	      title: (0, _util.getTodayTimeStr)(value)
	    },
	    localeNow
	  );
	}
	module.exports = exports['default'];

/***/ },
/* 1077 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = {
	  DATE_ROW_COUNT: 6,
	  DATE_COL_COUNT: 7
	};
	module.exports = exports['default'];

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(71);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _util = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var cachedSelectionStart = void 0;
	var cachedSelectionEnd = void 0;
	var dateInputInstance = void 0;
	
	var DateInput = function (_React$Component) {
	  (0, _inherits3['default'])(DateInput, _React$Component);
	
	  function DateInput(props) {
	    (0, _classCallCheck3['default'])(this, DateInput);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var selectedValue = props.selectedValue;
	
	    _this.state = {
	      str: (0, _util.formatDate)(selectedValue, _this.props.format),
	      invalid: false,
	      hasFocus: false
	    };
	    return _this;
	  }
	
	  DateInput.prototype.componentDidUpdate = function componentDidUpdate() {
	    if (dateInputInstance && this.state.hasFocus && !this.state.invalid && !(cachedSelectionStart === 0 && cachedSelectionEnd === 0)) {
	      dateInputInstance.setSelectionRange(cachedSelectionStart, cachedSelectionEnd);
	    }
	  };
	
	  DateInput.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
	    var newState = {};
	
	    if (dateInputInstance) {
	      cachedSelectionStart = dateInputInstance.selectionStart;
	      cachedSelectionEnd = dateInputInstance.selectionEnd;
	    }
	    // when popup show, click body will call this, bug!
	    var selectedValue = nextProps.selectedValue;
	    if (!state.hasFocus) {
	      newState = {
	        str: (0, _util.formatDate)(selectedValue, nextProps.format),
	        invalid: false
	      };
	    }
	
	    return newState;
	  };
	
	  DateInput.getInstance = function getInstance() {
	    return dateInputInstance;
	  };
	
	  DateInput.prototype.render = function render() {
	    var props = this.props;
	    var _state = this.state,
	        invalid = _state.invalid,
	        str = _state.str;
	    var locale = props.locale,
	        prefixCls = props.prefixCls,
	        placeholder = props.placeholder,
	        clearIcon = props.clearIcon,
	        inputMode = props.inputMode;
	
	    var invalidClass = invalid ? prefixCls + '-input-invalid' : '';
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-input-wrap' },
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-date-input-wrap' },
	        _react2['default'].createElement('input', {
	          ref: this.saveDateInput,
	          className: prefixCls + '-input ' + invalidClass,
	          value: str,
	          disabled: props.disabled,
	          placeholder: placeholder,
	          onChange: this.onInputChange,
	          onKeyDown: this.onKeyDown,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          inputMode: inputMode
	        })
	      ),
	      props.showClear ? _react2['default'].createElement(
	        'a',
	        {
	          role: 'button',
	          title: locale.clear,
	          onClick: this.onClear
	        },
	        clearIcon || _react2['default'].createElement('span', { className: prefixCls + '-clear-btn' })
	      ) : null
	    );
	  };
	
	  return DateInput;
	}(_react2['default'].Component);
	
	DateInput.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  timePicker: _propTypes2['default'].object,
	  value: _propTypes2['default'].object,
	  disabledTime: _propTypes2['default'].any,
	  format: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  locale: _propTypes2['default'].object,
	  disabledDate: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  onClear: _propTypes2['default'].func,
	  placeholder: _propTypes2['default'].string,
	  onSelect: _propTypes2['default'].func,
	  selectedValue: _propTypes2['default'].object,
	  clearIcon: _propTypes2['default'].node,
	  inputMode: _propTypes2['default'].string
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onClear = function () {
	    _this2.setState({
	      str: ''
	    });
	    _this2.props.onClear(null);
	  };
	
	  this.onInputChange = function (event) {
	    var str = event.target.value;
	    var _props = _this2.props,
	        disabledDate = _props.disabledDate,
	        format = _props.format,
	        onChange = _props.onChange,
	        selectedValue = _props.selectedValue;
	
	    // 没有内容，合法并直接退出
	
	    if (!str) {
	      onChange(null);
	      _this2.setState({
	        invalid: false,
	        str: str
	      });
	      return;
	    }
	
	    // 不合法直接退出
	    var parsed = (0, _moment2['default'])(str, format, true);
	    if (!parsed.isValid()) {
	      _this2.setState({
	        invalid: true,
	        str: str
	      });
	      return;
	    }
	
	    var value = _this2.props.value.clone();
	    value.year(parsed.year()).month(parsed.month()).date(parsed.date()).hour(parsed.hour()).minute(parsed.minute()).second(parsed.second());
	
	    if (!value || disabledDate && disabledDate(value)) {
	      _this2.setState({
	        invalid: true,
	        str: str
	      });
	      return;
	    }
	
	    if (selectedValue !== value || selectedValue && value && !selectedValue.isSame(value)) {
	      _this2.setState({
	        invalid: false,
	        str: str
	      });
	      onChange(value);
	    }
	  };
	
	  this.onFocus = function () {
	    _this2.setState({ hasFocus: true });
	  };
	
	  this.onBlur = function () {
	    _this2.setState(function (prevState, prevProps) {
	      return {
	        hasFocus: false,
	        str: (0, _util.formatDate)(prevProps.value, prevProps.format)
	      };
	    });
	  };
	
	  this.onKeyDown = function (event) {
	    var keyCode = event.keyCode;
	    var _props2 = _this2.props,
	        onSelect = _props2.onSelect,
	        value = _props2.value,
	        disabledDate = _props2.disabledDate;
	
	    if (keyCode === _KeyCode2['default'].ENTER && onSelect) {
	      var validateDate = !disabledDate || !disabledDate(value);
	      if (validateDate) {
	        onSelect(value.clone());
	      }
	      event.preventDefault();
	    }
	  };
	
	  this.getRootDOMNode = function () {
	    return _reactDom2['default'].findDOMNode(_this2);
	  };
	
	  this.focus = function () {
	    if (dateInputInstance) {
	      dateInputInstance.focus();
	    }
	  };
	
	  this.saveDateInput = function (dateInput) {
	    dateInputInstance = dateInput;
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(DateInput);
	
	exports['default'] = DateInput;
	module.exports = exports['default'];

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Calendar = __webpack_require__(2640);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Calendar2['default'];
	module.exports = exports['default'];

/***/ },
/* 1080 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  today: 'Today',
	  now: 'Now',
	  backToToday: 'Back to today',
	  ok: 'Ok',
	  clear: 'Clear',
	  month: 'Month',
	  year: 'Year',
	  timeSelect: 'select time',
	  dateSelect: 'select date',
	  weekSelect: 'Choose a week',
	  monthSelect: 'Choose a month',
	  yearSelect: 'Choose a year',
	  decadeSelect: 'Choose a decade',
	  yearFormat: 'YYYY',
	  dateFormat: 'M/D/YYYY',
	  dayFormat: 'D',
	  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
	  monthBeforeYear: true,
	  previousMonth: 'Previous month (PageUp)',
	  nextMonth: 'Next month (PageDown)',
	  previousYear: 'Last year (Control + left)',
	  nextYear: 'Next year (Control + right)',
	  previousDecade: 'Last decade',
	  nextDecade: 'Next decade',
	  previousCentury: 'Last century',
	  nextCentury: 'Next century'
	};
	module.exports = exports['default'];

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _index = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROW = 4;
	var COL = 3;
	
	function noop() {}
	
	var MonthTable = function (_Component) {
	  (0, _inherits3['default'])(MonthTable, _Component);
	
	  function MonthTable() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, MonthTable);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {}, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  MonthTable.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
	    if ('value' in props) {
	      return { value: props.value };
	    }
	    return null;
	  };
	
	  MonthTable.prototype.setAndSelectValue = function setAndSelectValue(value) {
	    this.setState({
	      value: value
	    });
	    this.props.onSelect(value);
	  };
	
	  MonthTable.prototype.chooseMonth = function chooseMonth(month) {
	    var next = this.state.value.clone();
	    next.month(month);
	    this.setAndSelectValue(next);
	  };
	
	  MonthTable.prototype.months = function months() {
	    var value = this.state.value;
	    var current = value.clone();
	    var months = [];
	    var index = 0;
	    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
	      months[rowIndex] = [];
	      for (var colIndex = 0; colIndex < COL; colIndex++) {
	        current.month(index);
	        var content = (0, _index.getMonthName)(current);
	        months[rowIndex][colIndex] = {
	          value: index,
	          content: content,
	          title: content
	        };
	        index++;
	      }
	    }
	    return months;
	  };
	
	  MonthTable.prototype.render = function render() {
	    var _this2 = this;
	
	    var props = this.props;
	    var value = this.state.value;
	    var today = (0, _index.getTodayTime)(value);
	    var months = this.months();
	    var currentMonth = value.month();
	    var prefixCls = props.prefixCls,
	        locale = props.locale,
	        contentRender = props.contentRender,
	        cellRender = props.cellRender;
	
	    var monthsEls = months.map(function (month, index) {
	      var tds = month.map(function (monthData) {
	        var _classNameMap;
	
	        var disabled = false;
	        if (props.disabledDate) {
	          var testValue = value.clone();
	          testValue.month(monthData.value);
	          disabled = props.disabledDate(testValue);
	        }
	        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-cell-disabled'] = disabled, _classNameMap[prefixCls + '-selected-cell'] = monthData.value === currentMonth, _classNameMap[prefixCls + '-current-cell'] = today.year() === value.year() && monthData.value === today.month(), _classNameMap);
	        var cellEl = void 0;
	        if (cellRender) {
	          var currentValue = value.clone();
	          currentValue.month(monthData.value);
	          cellEl = cellRender(currentValue, locale);
	        } else {
	          var content = void 0;
	          if (contentRender) {
	            var _currentValue = value.clone();
	            _currentValue.month(monthData.value);
	            content = contentRender(_currentValue, locale);
	          } else {
	            content = monthData.content;
	          }
	          cellEl = _react2['default'].createElement(
	            'a',
	            { className: prefixCls + '-month' },
	            content
	          );
	        }
	        return _react2['default'].createElement(
	          'td',
	          {
	            role: 'gridcell',
	            key: monthData.value,
	            onClick: disabled ? null : function () {
	              return _this2.chooseMonth(monthData.value);
	            },
	            title: monthData.title,
	            className: (0, _classnames2['default'])(classNameMap)
	          },
	          cellEl
	        );
	      });
	      return _react2['default'].createElement(
	        'tr',
	        { key: index, role: 'row' },
	        tds
	      );
	    });
	
	    return _react2['default'].createElement(
	      'table',
	      { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
	      _react2['default'].createElement(
	        'tbody',
	        { className: prefixCls + '-tbody' },
	        monthsEls
	      )
	    );
	  };
	
	  return MonthTable;
	}(_react.Component);
	
	MonthTable.defaultProps = {
	  onSelect: noop
	};
	
	MonthTable.propTypes = {
	  onSelect: _propTypes2['default'].func,
	  cellRender: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  value: _propTypes2['default'].object
	};
	
	(0, _reactLifecyclesCompat.polyfill)(MonthTable);
	
	exports['default'] = MonthTable;
	module.exports = exports['default'];

/***/ },
/* 1082 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.goStartMonth = goStartMonth;
	exports.goEndMonth = goEndMonth;
	exports.goTime = goTime;
	exports.includesTime = includesTime;
	function goStartMonth(time) {
	  return time.clone().startOf('month');
	}
	
	function goEndMonth(time) {
	  return time.clone().endOf('month');
	}
	
	function goTime(time, direction, unit) {
	  return time.clone().add(direction, unit);
	}
	
	function includesTime() {
	  var timeList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var time = arguments[1];
	  var unit = arguments[2];
	
	  return timeList.some(function (t) {
	    return t.isSame(time, unit);
	  });
	}

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Checkbox = __webpack_require__(2655);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Checkbox2['default'];
	module.exports = exports['default'];

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Panel = undefined;
	
	var _Collapse = __webpack_require__(2656);
	
	var _Collapse2 = _interopRequireDefault(_Collapse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Collapse2['default'];
	var Panel = exports.Panel = _Collapse2['default'].Panel;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Nav = function (_Component) {
	  (0, _inherits3['default'])(Nav, _Component);
	
	  function Nav() {
	    (0, _classCallCheck3['default'])(this, Nav);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  Nav.prototype.render = function render() {
	    var props = this.props;
	
	    return _react2['default'].createElement('div', props);
	  };
	
	  return Nav;
	}(_react.Component);
	
	exports['default'] = Nav;
	module.exports = exports['default'];

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = getMentions;
	
	var _getRegExp = __webpack_require__(1088);
	
	var _getRegExp2 = _interopRequireDefault(_getRegExp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getMentions(contentState) {
	  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '@';
	
	  var regex = (0, _getRegExp2['default'])(prefix);
	  var entities = [];
	  contentState.getBlockMap().forEach(function (block) {
	    var blockText = block.getText();
	    var matchArr = void 0;
	    while ((matchArr = regex.exec(blockText)) !== null) {
	      // eslint-disable-line
	      entities.push(matchArr[0].trim());
	    }
	  });
	  return entities;
	}
	module.exports = exports['default'];

/***/ },
/* 1087 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = getOffset;
	function getOffset(element, container) {
	  var rect = element.getBoundingClientRect();
	  if (rect.width || rect.height) {
	    var elementContainer = container || element.parentElement;
	    return {
	      top: rect.top - elementContainer.clientTop,
	      left: rect.left - elementContainer.clientLeft
	    };
	  }
	  return rect;
	}
	module.exports = exports['default'];

/***/ },
/* 1088 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = getRegExp;
	function getRegExp(prefix) {
	  var prefixArray = Array.isArray(prefix) ? prefix : [prefix];
	  var prefixToken = prefixArray.join('').replace(/(\$|\^)/g, '\\$1');
	
	  if (prefixArray.length > 1) {
	    prefixToken = '[' + prefixToken + ']';
	  }
	
	  return new RegExp('(\\s|^)(' + prefixToken + ')[^\\s]*', 'g');
	}
	module.exports = exports['default'];

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends5 = __webpack_require__(21);
	
	var _extends6 = _interopRequireDefault(_extends5);
	
	var _toConsumableArray2 = __webpack_require__(443);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(139);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _unsafeLifecyclesPolyfill = __webpack_require__(384);
	
	var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);
	
	var _asyncValidator = __webpack_require__(1376);
	
	var _asyncValidator2 = _interopRequireDefault(_asyncValidator);
	
	var _warning = __webpack_require__(94);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _get = __webpack_require__(543);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _set = __webpack_require__(928);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _eq = __webpack_require__(256);
	
	var _eq2 = _interopRequireDefault(_eq);
	
	var _createFieldsStore = __webpack_require__(2692);
	
	var _createFieldsStore2 = _interopRequireDefault(_createFieldsStore);
	
	var _utils = __webpack_require__(560);
	
	var _FieldElemWrapper = __webpack_require__(2690);
	
	var _FieldElemWrapper2 = _interopRequireDefault(_FieldElemWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DEFAULT_TRIGGER = 'onChange'; /* eslint-disable react/prefer-es6-class */
	/* eslint-disable prefer-promise-reject-errors */
	
	function createBaseForm() {
	  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var mixins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var validateMessages = option.validateMessages,
	      onFieldsChange = option.onFieldsChange,
	      onValuesChange = option.onValuesChange,
	      _option$mapProps = option.mapProps,
	      mapProps = _option$mapProps === undefined ? _utils.identity : _option$mapProps,
	      mapPropsToFields = option.mapPropsToFields,
	      fieldNameProp = option.fieldNameProp,
	      fieldMetaProp = option.fieldMetaProp,
	      fieldDataProp = option.fieldDataProp,
	      _option$formPropName = option.formPropName,
	      formPropName = _option$formPropName === undefined ? 'form' : _option$formPropName,
	      formName = option.name,
	      withRef = option.withRef;
	
	
	  return function decorate(WrappedComponent) {
	    var Form = (0, _createReactClass2['default'])({
	      displayName: 'Form',
	
	      mixins: mixins,
	
	      getInitialState: function getInitialState() {
	        var _this = this;
	
	        var fields = mapPropsToFields && mapPropsToFields(this.props);
	        this.fieldsStore = (0, _createFieldsStore2['default'])(fields || {});
	
	        this.instances = {};
	        this.cachedBind = {};
	        this.clearedFieldMetaCache = {};
	
	        this.renderFields = {};
	        this.domFields = {};
	
	        // HACK: https://github.com/ant-design/ant-design/issues/6406
	        ['getFieldsValue', 'getFieldValue', 'setFieldsInitialValue', 'getFieldsError', 'getFieldError', 'isFieldValidating', 'isFieldsValidating', 'isFieldsTouched', 'isFieldTouched'].forEach(function (key) {
	          _this[key] = function () {
	            var _fieldsStore;
	
	            if (false) {
	              (0, _warning2['default'])(false, 'you should not use `ref` on enhanced form, please use `wrappedComponentRef`. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
	            }
	            return (_fieldsStore = _this.fieldsStore)[key].apply(_fieldsStore, arguments);
	          };
	        });
	
	        return {
	          submitting: false
	        };
	      },
	      componentDidMount: function componentDidMount() {
	        this.cleanUpUselessFields();
	      },
	      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	        if (mapPropsToFields) {
	          this.fieldsStore.updateFields(mapPropsToFields(nextProps));
	        }
	      },
	      componentDidUpdate: function componentDidUpdate() {
	        this.cleanUpUselessFields();
	      },
	      onCollectCommon: function onCollectCommon(name, action, args) {
	        var fieldMeta = this.fieldsStore.getFieldMeta(name);
	        if (fieldMeta[action]) {
	          fieldMeta[action].apply(fieldMeta, (0, _toConsumableArray3['default'])(args));
	        } else if (fieldMeta.originalProps && fieldMeta.originalProps[action]) {
	          var _fieldMeta$originalPr;
	
	          (_fieldMeta$originalPr = fieldMeta.originalProps)[action].apply(_fieldMeta$originalPr, (0, _toConsumableArray3['default'])(args));
	        }
	        var value = fieldMeta.getValueFromEvent ? fieldMeta.getValueFromEvent.apply(fieldMeta, (0, _toConsumableArray3['default'])(args)) : _utils.getValueFromEvent.apply(undefined, (0, _toConsumableArray3['default'])(args));
	        if (onValuesChange && value !== this.fieldsStore.getFieldValue(name)) {
	          var valuesAll = this.fieldsStore.getAllValues();
	          var valuesAllSet = {};
	          valuesAll[name] = value;
	          Object.keys(valuesAll).forEach(function (key) {
	            return (0, _set2['default'])(valuesAllSet, key, valuesAll[key]);
	          });
	          onValuesChange((0, _extends6['default'])((0, _defineProperty3['default'])({}, formPropName, this.getForm()), this.props), (0, _set2['default'])({}, name, value), valuesAllSet);
	        }
	        var field = this.fieldsStore.getField(name);
	        return { name: name, field: (0, _extends6['default'])({}, field, { value: value, touched: true }), fieldMeta: fieldMeta };
	      },
	      onCollect: function onCollect(name_, action) {
	        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	          args[_key - 2] = arguments[_key];
	        }
	
	        var _onCollectCommon = this.onCollectCommon(name_, action, args),
	            name = _onCollectCommon.name,
	            field = _onCollectCommon.field,
	            fieldMeta = _onCollectCommon.fieldMeta;
	
	        var validate = fieldMeta.validate;
	
	
	        this.fieldsStore.setFieldsAsDirty();
	
	        var newField = (0, _extends6['default'])({}, field, {
	          dirty: (0, _utils.hasRules)(validate)
	        });
	        this.setFields((0, _defineProperty3['default'])({}, name, newField));
	      },
	      onCollectValidate: function onCollectValidate(name_, action) {
	        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	          args[_key2 - 2] = arguments[_key2];
	        }
	
	        var _onCollectCommon2 = this.onCollectCommon(name_, action, args),
	            field = _onCollectCommon2.field,
	            fieldMeta = _onCollectCommon2.fieldMeta;
	
	        var newField = (0, _extends6['default'])({}, field, {
	          dirty: true
	        });
	
	        this.fieldsStore.setFieldsAsDirty();
	
	        this.validateFieldsInternal([newField], {
	          action: action,
	          options: {
	            firstFields: !!fieldMeta.validateFirst
	          }
	        });
	      },
	      getCacheBind: function getCacheBind(name, action, fn) {
	        if (!this.cachedBind[name]) {
	          this.cachedBind[name] = {};
	        }
	        var cache = this.cachedBind[name];
	        if (!cache[action] || cache[action].oriFn !== fn) {
	          cache[action] = {
	            fn: fn.bind(this, name, action),
	            oriFn: fn
	          };
	        }
	        return cache[action].fn;
	      },
	      getFieldDecorator: function getFieldDecorator(name, fieldOption) {
	        var _this2 = this;
	
	        var props = this.getFieldProps(name, fieldOption);
	        return function (fieldElem) {
	          // We should put field in record if it is rendered
	          _this2.renderFields[name] = true;
	
	          var fieldMeta = _this2.fieldsStore.getFieldMeta(name);
	          var originalProps = fieldElem.props;
	          if (false) {
	            var valuePropName = fieldMeta.valuePropName;
	            (0, _warning2['default'])(!(valuePropName in originalProps), '`getFieldDecorator` will override `' + valuePropName + '`, ' + ('so please don\'t set `' + valuePropName + '` directly ') + 'and use `setFieldsValue` to set it.');
	            var defaultValuePropName = 'default' + valuePropName[0].toUpperCase() + valuePropName.slice(1);
	            (0, _warning2['default'])(!(defaultValuePropName in originalProps), '`' + defaultValuePropName + '` is invalid ' + ('for `getFieldDecorator` will set `' + valuePropName + '`,') + ' please use `option.initialValue` instead.');
	          }
	          fieldMeta.originalProps = originalProps;
	          fieldMeta.ref = fieldElem.ref;
	          var decoratedFieldElem = _react2['default'].cloneElement(fieldElem, (0, _extends6['default'])({}, props, _this2.fieldsStore.getFieldValuePropValue(fieldMeta)));
	          return (0, _utils.supportRef)(fieldElem) ? decoratedFieldElem : _react2['default'].createElement(
	            _FieldElemWrapper2['default'],
	            { name: name, form: _this2 },
	            decoratedFieldElem
	          );
	        };
	      },
	      getFieldProps: function getFieldProps(name) {
	        var _this3 = this;
	
	        var usersFieldOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	        if (!name) {
	          throw new Error('Must call `getFieldProps` with valid name string!');
	        }
	        if (false) {
	          (0, _warning2['default'])(this.fieldsStore.isValidNestedFieldName(name), 'One field name cannot be part of another, e.g. `a` and `a.b`. Check field: ' + name);
	          (0, _warning2['default'])(!('exclusive' in usersFieldOption), '`option.exclusive` of `getFieldProps`|`getFieldDecorator` had been remove.');
	        }
	
	        delete this.clearedFieldMetaCache[name];
	
	        var fieldOption = (0, _extends6['default'])({
	          name: name,
	          trigger: DEFAULT_TRIGGER,
	          valuePropName: 'value',
	          validate: []
	        }, usersFieldOption);
	
	        var rules = fieldOption.rules,
	            trigger = fieldOption.trigger,
	            _fieldOption$validate = fieldOption.validateTrigger,
	            validateTrigger = _fieldOption$validate === undefined ? trigger : _fieldOption$validate,
	            validate = fieldOption.validate;
	
	
	        var fieldMeta = this.fieldsStore.getFieldMeta(name);
	        if ('initialValue' in fieldOption) {
	          fieldMeta.initialValue = fieldOption.initialValue;
	        }
	
	        var inputProps = (0, _extends6['default'])({}, this.fieldsStore.getFieldValuePropValue(fieldOption), {
	          ref: this.getCacheBind(name, name + '__ref', this.saveRef)
	        });
	        if (fieldNameProp) {
	          inputProps[fieldNameProp] = formName ? formName + '_' + name : name;
	        }
	
	        var validateRules = (0, _utils.normalizeValidateRules)(validate, rules, validateTrigger);
	        var validateTriggers = (0, _utils.getValidateTriggers)(validateRules);
	        validateTriggers.forEach(function (action) {
	          if (inputProps[action]) return;
	          inputProps[action] = _this3.getCacheBind(name, action, _this3.onCollectValidate);
	        });
	
	        // make sure that the value will be collect
	        if (trigger && validateTriggers.indexOf(trigger) === -1) {
	          inputProps[trigger] = this.getCacheBind(name, trigger, this.onCollect);
	        }
	
	        var meta = (0, _extends6['default'])({}, fieldMeta, fieldOption, {
	          validate: validateRules
	        });
	        this.fieldsStore.setFieldMeta(name, meta);
	        if (fieldMetaProp) {
	          inputProps[fieldMetaProp] = meta;
	        }
	
	        if (fieldDataProp) {
	          inputProps[fieldDataProp] = this.fieldsStore.getField(name);
	        }
	
	        // This field is rendered, record it
	        this.renderFields[name] = true;
	
	        return inputProps;
	      },
	      getFieldInstance: function getFieldInstance(name) {
	        return this.instances[name];
	      },
	      getRules: function getRules(fieldMeta, action) {
	        var actionRules = fieldMeta.validate.filter(function (item) {
	          return !action || item.trigger.indexOf(action) >= 0;
	        }).map(function (item) {
	          return item.rules;
	        });
	        return (0, _utils.flattenArray)(actionRules);
	      },
	      setFields: function setFields(maybeNestedFields, callback) {
	        var _this4 = this;
	
	        var fields = this.fieldsStore.flattenRegisteredFields(maybeNestedFields);
	        this.fieldsStore.setFields(fields);
	        if (onFieldsChange) {
	          var changedFields = Object.keys(fields).reduce(function (acc, name) {
	            return (0, _set2['default'])(acc, name, _this4.fieldsStore.getField(name));
	          }, {});
	          onFieldsChange((0, _extends6['default'])((0, _defineProperty3['default'])({}, formPropName, this.getForm()), this.props), changedFields, this.fieldsStore.getNestedAllFields());
	        }
	        this.forceUpdate(callback);
	      },
	      setFieldsValue: function setFieldsValue(changedValues, callback) {
	        var fieldsMeta = this.fieldsStore.fieldsMeta;
	
	        var values = this.fieldsStore.flattenRegisteredFields(changedValues);
	        var newFields = Object.keys(values).reduce(function (acc, name) {
	          var isRegistered = fieldsMeta[name];
	          if (false) {
	            (0, _warning2['default'])(isRegistered, 'Cannot use `setFieldsValue` until ' + 'you use `getFieldDecorator` or `getFieldProps` to register it.');
	          }
	          if (isRegistered) {
	            var value = values[name];
	            acc[name] = {
	              value: value
	            };
	          }
	          return acc;
	        }, {});
	        this.setFields(newFields, callback);
	        if (onValuesChange) {
	          var allValues = this.fieldsStore.getAllValues();
	          onValuesChange((0, _extends6['default'])((0, _defineProperty3['default'])({}, formPropName, this.getForm()), this.props), changedValues, allValues);
	        }
	      },
	      saveRef: function saveRef(name, _, component) {
	        if (!component) {
	          var _fieldMeta = this.fieldsStore.getFieldMeta(name);
	          if (!_fieldMeta.preserve) {
	            // after destroy, delete data
	            this.clearedFieldMetaCache[name] = {
	              field: this.fieldsStore.getField(name),
	              meta: _fieldMeta
	            };
	            this.clearField(name);
	          }
	          delete this.domFields[name];
	          return;
	        }
	        this.domFields[name] = true;
	        this.recoverClearedField(name);
	        var fieldMeta = this.fieldsStore.getFieldMeta(name);
	        if (fieldMeta) {
	          var ref = fieldMeta.ref;
	          if (ref) {
	            if (typeof ref === 'string') {
	              throw new Error('can not set ref string for ' + name);
	            } else if (typeof ref === 'function') {
	              ref(component);
	            } else if (Object.prototype.hasOwnProperty.call(ref, 'current')) {
	              ref.current = component;
	            }
	          }
	        }
	        this.instances[name] = component;
	      },
	      cleanUpUselessFields: function cleanUpUselessFields() {
	        var _this5 = this;
	
	        var fieldList = this.fieldsStore.getAllFieldsName();
	        var removedList = fieldList.filter(function (field) {
	          var fieldMeta = _this5.fieldsStore.getFieldMeta(field);
	          return !_this5.renderFields[field] && !_this5.domFields[field] && !fieldMeta.preserve;
	        });
	        if (removedList.length) {
	          removedList.forEach(this.clearField);
	        }
	        this.renderFields = {};
	      },
	      clearField: function clearField(name) {
	        this.fieldsStore.clearField(name);
	        delete this.instances[name];
	        delete this.cachedBind[name];
	      },
	      resetFields: function resetFields(ns) {
	        var _this6 = this;
	
	        var newFields = this.fieldsStore.resetFields(ns);
	        if (Object.keys(newFields).length > 0) {
	          this.setFields(newFields);
	        }
	        if (ns) {
	          var names = Array.isArray(ns) ? ns : [ns];
	          names.forEach(function (name) {
	            return delete _this6.clearedFieldMetaCache[name];
	          });
	        } else {
	          this.clearedFieldMetaCache = {};
	        }
	      },
	      recoverClearedField: function recoverClearedField(name) {
	        if (this.clearedFieldMetaCache[name]) {
	          this.fieldsStore.setFields((0, _defineProperty3['default'])({}, name, this.clearedFieldMetaCache[name].field));
	          this.fieldsStore.setFieldMeta(name, this.clearedFieldMetaCache[name].meta);
	          delete this.clearedFieldMetaCache[name];
	        }
	      },
	      validateFieldsInternal: function validateFieldsInternal(fields, _ref, callback) {
	        var _this7 = this;
	
	        var fieldNames = _ref.fieldNames,
	            action = _ref.action,
	            _ref$options = _ref.options,
	            options = _ref$options === undefined ? {} : _ref$options;
	
	        var allRules = {};
	        var allValues = {};
	        var allFields = {};
	        var alreadyErrors = {};
	        fields.forEach(function (field) {
	          var name = field.name;
	          if (options.force !== true && field.dirty === false) {
	            if (field.errors) {
	              (0, _set2['default'])(alreadyErrors, name, { errors: field.errors });
	            }
	            return;
	          }
	          var fieldMeta = _this7.fieldsStore.getFieldMeta(name);
	          var newField = (0, _extends6['default'])({}, field);
	          newField.errors = undefined;
	          newField.validating = true;
	          newField.dirty = true;
	          allRules[name] = _this7.getRules(fieldMeta, action);
	          allValues[name] = newField.value;
	          allFields[name] = newField;
	        });
	        this.setFields(allFields);
	        // in case normalize
	        Object.keys(allValues).forEach(function (f) {
	          allValues[f] = _this7.fieldsStore.getFieldValue(f);
	        });
	        if (callback && (0, _utils.isEmptyObject)(allFields)) {
	          callback((0, _utils.isEmptyObject)(alreadyErrors) ? null : alreadyErrors, this.fieldsStore.getFieldsValue(fieldNames));
	          return;
	        }
	        var validator = new _asyncValidator2['default'](allRules);
	        if (validateMessages) {
	          validator.messages(validateMessages);
	        }
	        validator.validate(allValues, options, function (errors) {
	          var errorsGroup = (0, _extends6['default'])({}, alreadyErrors);
	          if (errors && errors.length) {
	            errors.forEach(function (e) {
	              var errorFieldName = e.field;
	              var fieldName = errorFieldName;
	
	              // Handle using array validation rule.
	              // ref: https://github.com/ant-design/ant-design/issues/14275
	              Object.keys(allRules).some(function (ruleFieldName) {
	                var rules = allRules[ruleFieldName] || [];
	
	                // Exist if match rule
	                if (ruleFieldName === errorFieldName) {
	                  fieldName = ruleFieldName;
	                  return true;
	                }
	
	                // Skip if not match array type
	                if (rules.every(function (_ref2) {
	                  var type = _ref2.type;
	                  return type !== 'array';
	                }) || errorFieldName.indexOf(ruleFieldName + '.') !== 0) {
	                  return false;
	                }
	
	                // Exist if match the field name
	                var restPath = errorFieldName.slice(ruleFieldName.length + 1);
	                if (/^\d+$/.test(restPath)) {
	                  fieldName = ruleFieldName;
	                  return true;
	                }
	
	                return false;
	              });
	
	              var field = (0, _get2['default'])(errorsGroup, fieldName);
	              if (typeof field !== 'object' || Array.isArray(field)) {
	                (0, _set2['default'])(errorsGroup, fieldName, { errors: [] });
	              }
	              var fieldErrors = (0, _get2['default'])(errorsGroup, fieldName.concat('.errors'));
	              fieldErrors.push(e);
	            });
	          }
	          var expired = [];
	          var nowAllFields = {};
	          Object.keys(allRules).forEach(function (name) {
	            var fieldErrors = (0, _get2['default'])(errorsGroup, name);
	            var nowField = _this7.fieldsStore.getField(name);
	            // avoid concurrency problems
	            if (!(0, _eq2['default'])(nowField.value, allValues[name])) {
	              expired.push({
	                name: name
	              });
	            } else {
	              nowField.errors = fieldErrors && fieldErrors.errors;
	              nowField.value = allValues[name];
	              nowField.validating = false;
	              nowField.dirty = false;
	              nowAllFields[name] = nowField;
	            }
	          });
	          _this7.setFields(nowAllFields);
	          if (callback) {
	            if (expired.length) {
	              expired.forEach(function (_ref3) {
	                var name = _ref3.name;
	
	                var fieldErrors = [{
	                  message: name + ' need to revalidate',
	                  field: name
	                }];
	                (0, _set2['default'])(errorsGroup, name, {
	                  expired: true,
	                  errors: fieldErrors
	                });
	              });
	            }
	
	            callback((0, _utils.isEmptyObject)(errorsGroup) ? null : errorsGroup, _this7.fieldsStore.getFieldsValue(fieldNames));
	          }
	        });
	      },
	      validateFields: function validateFields(ns, opt, cb) {
	        var _this8 = this;
	
	        var pending = new Promise(function (resolve, reject) {
	          var _getParams = (0, _utils.getParams)(ns, opt, cb),
	              names = _getParams.names,
	              options = _getParams.options;
	
	          var _getParams2 = (0, _utils.getParams)(ns, opt, cb),
	              callback = _getParams2.callback;
	
	          if (!callback || typeof callback === 'function') {
	            var oldCb = callback;
	            callback = function callback(errors, values) {
	              if (oldCb) {
	                oldCb(errors, values);
	              }
	              if (errors) {
	                reject({ errors: errors, values: values });
	              } else {
	                resolve(values);
	              }
	            };
	          }
	          var fieldNames = names ? _this8.fieldsStore.getValidFieldsFullName(names) : _this8.fieldsStore.getValidFieldsName();
	          var fields = fieldNames.filter(function (name) {
	            var fieldMeta = _this8.fieldsStore.getFieldMeta(name);
	            return (0, _utils.hasRules)(fieldMeta.validate);
	          }).map(function (name) {
	            var field = _this8.fieldsStore.getField(name);
	            field.value = _this8.fieldsStore.getFieldValue(name);
	            return field;
	          });
	          if (!fields.length) {
	            callback(null, _this8.fieldsStore.getFieldsValue(fieldNames));
	            return;
	          }
	          if (!('firstFields' in options)) {
	            options.firstFields = fieldNames.filter(function (name) {
	              var fieldMeta = _this8.fieldsStore.getFieldMeta(name);
	              return !!fieldMeta.validateFirst;
	            });
	          }
	          _this8.validateFieldsInternal(fields, {
	            fieldNames: fieldNames,
	            options: options
	          }, callback);
	        });
	        pending['catch'](function (e) {
	          // eslint-disable-next-line no-console
	          if (console.error && ("production") !== 'production') {
	            // eslint-disable-next-line no-console
	            console.error(e);
	          }
	          return e;
	        });
	        return pending;
	      },
	      isSubmitting: function isSubmitting() {
	        if (false) {
	          (0, _warning2['default'])(false, '`isSubmitting` is deprecated. ' + "Actually, it's more convenient to handle submitting status by yourself.");
	        }
	        return this.state.submitting;
	      },
	      submit: function submit(callback) {
	        var _this9 = this;
	
	        if (false) {
	          (0, _warning2['default'])(false, '`submit` is deprecated. ' + "Actually, it's more convenient to handle submitting status by yourself.");
	        }
	        var fn = function fn() {
	          _this9.setState({
	            submitting: false
	          });
	        };
	        this.setState({
	          submitting: true
	        });
	        callback(fn);
	      },
	      render: function render() {
	        var _props = this.props,
	            wrappedComponentRef = _props.wrappedComponentRef,
	            restProps = (0, _objectWithoutProperties3['default'])(_props, ['wrappedComponentRef']); // eslint-disable-line
	
	        var formProps = (0, _defineProperty3['default'])({}, formPropName, this.getForm());
	        if (withRef) {
	          if (false) {
	            (0, _warning2['default'])(false, '`withRef` is deprecated, please use `wrappedComponentRef` instead. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
	          }
	          formProps.ref = 'wrappedComponent';
	        } else if (wrappedComponentRef) {
	          formProps.ref = wrappedComponentRef;
	        }
	        var props = mapProps.call(this, (0, _extends6['default'])({}, formProps, restProps));
	        return _react2['default'].createElement(WrappedComponent, props);
	      }
	    });
	
	    return (0, _utils.argumentContainer)((0, _unsafeLifecyclesPolyfill2['default'])(Form), WrappedComponent);
	  };
	}
	
	exports['default'] = createBaseForm;
	module.exports = exports['default'];

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	exports.isFormField = isFormField;
	exports["default"] = createFormField;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Field = function Field(fields) {
	  (0, _classCallCheck3["default"])(this, Field);
	
	  (0, _extends3["default"])(this, fields);
	};
	
	function isFormField(obj) {
	  return obj instanceof Field;
	}
	
	function createFormField(field) {
	  if (isFormField(field)) {
	    return field;
	  }
	  return new Field(field);
	}

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.MentionsContextConsumer = exports.MentionsContextProvider = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/* tslint:disable: no-object-literal-type-assertion */
	// We will never use default, here only to fix TypeScript warning
	var MentionsContext = (0, _createReactContext.default)(null);
	var MentionsContextProvider = MentionsContext.Provider;
	exports.MentionsContextProvider = MentionsContextProvider;
	var MentionsContextConsumer = MentionsContext.Consumer;
	exports.MentionsContextConsumer = MentionsContextConsumer;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.SubMenu = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var _rcTrigger = _interopRequireDefault(__webpack_require__(185));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(71));
	
	var _CSSMotion = _interopRequireDefault(__webpack_require__(553));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _miniStore = __webpack_require__(143);
	
	var _SubPopupMenu = _interopRequireDefault(__webpack_require__(1093));
	
	var _placements = _interopRequireDefault(__webpack_require__(2707));
	
	var _util = __webpack_require__(257);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var guid = 0;
	var popupPlacementMap = {
	  horizontal: 'bottomLeft',
	  vertical: 'rightTop',
	  'vertical-left': 'rightTop',
	  'vertical-right': 'leftTop'
	};
	
	var updateDefaultActiveFirst = function updateDefaultActiveFirst(store, eventKey, defaultActiveFirst) {
	  var menuId = (0, _util.getMenuIdFromSubMenuEventKey)(eventKey);
	  var state = store.getState();
	  store.setState({
	    defaultActiveFirst: _objectSpread({}, state.defaultActiveFirst, _defineProperty({}, menuId, defaultActiveFirst))
	  });
	};
	
	var SubMenu =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(SubMenu, _React$Component);
	
	  function SubMenu(props) {
	    var _this;
	
	    _classCallCheck(this, SubMenu);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubMenu).call(this, props));
	
	    _this.onDestroy = function (key) {
	      _this.props.onDestroy(key);
	    };
	    /**
	     * note:
	     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
	     *  which need return code to check if this event is handled
	     */
	
	
	    _this.onKeyDown = function (e) {
	      var keyCode = e.keyCode;
	      var menu = _this.menuInstance;
	      var _this$props = _this.props,
	          isOpen = _this$props.isOpen,
	          store = _this$props.store;
	
	      if (keyCode === _KeyCode.default.ENTER) {
	        _this.onTitleClick(e);
	
	        updateDefaultActiveFirst(store, _this.props.eventKey, true);
	        return true;
	      }
	
	      if (keyCode === _KeyCode.default.RIGHT) {
	        if (isOpen) {
	          menu.onKeyDown(e);
	        } else {
	          _this.triggerOpenChange(true); // need to update current menu's defaultActiveFirst value
	
	
	          updateDefaultActiveFirst(store, _this.props.eventKey, true);
	        }
	
	        return true;
	      }
	
	      if (keyCode === _KeyCode.default.LEFT) {
	        var handled;
	
	        if (isOpen) {
	          handled = menu.onKeyDown(e);
	        } else {
	          return undefined;
	        }
	
	        if (!handled) {
	          _this.triggerOpenChange(false);
	
	          handled = true;
	        }
	
	        return handled;
	      }
	
	      if (isOpen && (keyCode === _KeyCode.default.UP || keyCode === _KeyCode.default.DOWN)) {
	        return menu.onKeyDown(e);
	      }
	
	      return undefined;
	    };
	
	    _this.onOpenChange = function (e) {
	      _this.props.onOpenChange(e);
	    };
	
	    _this.onPopupVisibleChange = function (visible) {
	      _this.triggerOpenChange(visible, visible ? 'mouseenter' : 'mouseleave');
	    };
	
	    _this.onMouseEnter = function (e) {
	      var _this$props2 = _this.props,
	          key = _this$props2.eventKey,
	          onMouseEnter = _this$props2.onMouseEnter,
	          store = _this$props2.store;
	      updateDefaultActiveFirst(store, _this.props.eventKey, false);
	      onMouseEnter({
	        key: key,
	        domEvent: e
	      });
	    };
	
	    _this.onMouseLeave = function (e) {
	      var _this$props3 = _this.props,
	          parentMenu = _this$props3.parentMenu,
	          eventKey = _this$props3.eventKey,
	          onMouseLeave = _this$props3.onMouseLeave;
	      parentMenu.subMenuInstance = _assertThisInitialized(_this);
	      onMouseLeave({
	        key: eventKey,
	        domEvent: e
	      });
	    };
	
	    _this.onTitleMouseEnter = function (domEvent) {
	      var _this$props4 = _this.props,
	          key = _this$props4.eventKey,
	          onItemHover = _this$props4.onItemHover,
	          onTitleMouseEnter = _this$props4.onTitleMouseEnter;
	      onItemHover({
	        key: key,
	        hover: true
	      });
	      onTitleMouseEnter({
	        key: key,
	        domEvent: domEvent
	      });
	    };
	
	    _this.onTitleMouseLeave = function (e) {
	      var _this$props5 = _this.props,
	          parentMenu = _this$props5.parentMenu,
	          eventKey = _this$props5.eventKey,
	          onItemHover = _this$props5.onItemHover,
	          onTitleMouseLeave = _this$props5.onTitleMouseLeave;
	      parentMenu.subMenuInstance = _assertThisInitialized(_this);
	      onItemHover({
	        key: eventKey,
	        hover: false
	      });
	      onTitleMouseLeave({
	        key: eventKey,
	        domEvent: e
	      });
	    };
	
	    _this.onTitleClick = function (e) {
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      props.onTitleClick({
	        key: props.eventKey,
	        domEvent: e
	      });
	
	      if (props.triggerSubMenuAction === 'hover') {
	        return;
	      }
	
	      _this.triggerOpenChange(!props.isOpen, 'click');
	
	      updateDefaultActiveFirst(props.store, _this.props.eventKey, false);
	    };
	
	    _this.onSubMenuClick = function (info) {
	      // in the case of overflowed submenu
	      // onClick is not copied over
	      if (typeof _this.props.onClick === 'function') {
	        _this.props.onClick(_this.addKeyPath(info));
	      }
	    };
	
	    _this.onSelect = function (info) {
	      _this.props.onSelect(info);
	    };
	
	    _this.onDeselect = function (info) {
	      _this.props.onDeselect(info);
	    };
	
	    _this.getPrefixCls = function () {
	      return "".concat(_this.props.rootPrefixCls, "-submenu");
	    };
	
	    _this.getActiveClassName = function () {
	      return "".concat(_this.getPrefixCls(), "-active");
	    };
	
	    _this.getDisabledClassName = function () {
	      return "".concat(_this.getPrefixCls(), "-disabled");
	    };
	
	    _this.getSelectedClassName = function () {
	      return "".concat(_this.getPrefixCls(), "-selected");
	    };
	
	    _this.getOpenClassName = function () {
	      return "".concat(_this.props.rootPrefixCls, "-submenu-open");
	    };
	
	    _this.saveMenuInstance = function (c) {
	      // children menu instance
	      _this.menuInstance = c;
	    };
	
	    _this.addKeyPath = function (info) {
	      return _objectSpread({}, info, {
	        keyPath: (info.keyPath || []).concat(_this.props.eventKey)
	      });
	    };
	
	    _this.triggerOpenChange = function (open, type) {
	      var key = _this.props.eventKey;
	
	      var openChange = function openChange() {
	        _this.onOpenChange({
	          key: key,
	          item: _assertThisInitialized(_this),
	          trigger: type,
	          open: open
	        });
	      };
	
	      if (type === 'mouseenter') {
	        // make sure mouseenter happen after other menu item's mouseleave
	        _this.mouseenterTimeout = setTimeout(function () {
	          openChange();
	        }, 0);
	      } else {
	        openChange();
	      }
	    };
	
	    _this.isChildrenSelected = function () {
	      var ret = {
	        find: false
	      };
	      (0, _util.loopMenuItemRecursively)(_this.props.children, _this.props.selectedKeys, ret);
	      return ret.find;
	    };
	
	    _this.isOpen = function () {
	      return _this.props.openKeys.indexOf(_this.props.eventKey) !== -1;
	    };
	
	    _this.adjustWidth = function () {
	      /* istanbul ignore if */
	      if (!_this.subMenuTitle || !_this.menuInstance) {
	        return;
	      }
	
	      var popupMenu = ReactDOM.findDOMNode(_this.menuInstance);
	
	      if (popupMenu.offsetWidth >= _this.subMenuTitle.offsetWidth) {
	        return;
	      }
	      /* istanbul ignore next */
	
	
	      popupMenu.style.minWidth = "".concat(_this.subMenuTitle.offsetWidth, "px");
	    };
	
	    _this.saveSubMenuTitle = function (subMenuTitle) {
	      _this.subMenuTitle = subMenuTitle;
	    };
	
	    var store = props.store,
	        eventKey = props.eventKey;
	
	    var _store$getState = store.getState(),
	        defaultActiveFirst = _store$getState.defaultActiveFirst;
	
	    _this.isRootMenu = false;
	    var value = false;
	
	    if (defaultActiveFirst) {
	      value = defaultActiveFirst[eventKey];
	    }
	
	    updateDefaultActiveFirst(store, eventKey, value);
	    return _this;
	  }
	
	  _createClass(SubMenu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.componentDidUpdate();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var _this$props6 = this.props,
	          mode = _this$props6.mode,
	          parentMenu = _this$props6.parentMenu,
	          manualRef = _this$props6.manualRef; // invoke customized ref to expose component to mixin
	
	      if (manualRef) {
	        manualRef(this);
	      }
	
	      if (mode !== 'horizontal' || !parentMenu.isRootMenu || !this.props.isOpen) {
	        return;
	      }
	
	      this.minWidthTimeout = setTimeout(function () {
	        return _this2.adjustWidth();
	      }, 0);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this$props7 = this.props,
	          onDestroy = _this$props7.onDestroy,
	          eventKey = _this$props7.eventKey;
	
	      if (onDestroy) {
	        onDestroy(eventKey);
	      }
	      /* istanbul ignore if */
	
	
	      if (this.minWidthTimeout) {
	        clearTimeout(this.minWidthTimeout);
	      }
	      /* istanbul ignore if */
	
	
	      if (this.mouseenterTimeout) {
	        clearTimeout(this.mouseenterTimeout);
	      }
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren(children) {
	      var _this3 = this;
	
	      var props = this.props;
	      var baseProps = {
	        mode: props.mode === 'horizontal' ? 'vertical' : props.mode,
	        visible: this.props.isOpen,
	        level: props.level + 1,
	        inlineIndent: props.inlineIndent,
	        focusable: false,
	        onClick: this.onSubMenuClick,
	        onSelect: this.onSelect,
	        onDeselect: this.onDeselect,
	        onDestroy: this.onDestroy,
	        selectedKeys: props.selectedKeys,
	        eventKey: "".concat(props.eventKey, "-menu-"),
	        openKeys: props.openKeys,
	        motion: props.motion,
	        onOpenChange: this.onOpenChange,
	        subMenuOpenDelay: props.subMenuOpenDelay,
	        parentMenu: this,
	        subMenuCloseDelay: props.subMenuCloseDelay,
	        forceSubMenuRender: props.forceSubMenuRender,
	        triggerSubMenuAction: props.triggerSubMenuAction,
	        builtinPlacements: props.builtinPlacements,
	        defaultActiveFirst: props.store.getState().defaultActiveFirst[(0, _util.getMenuIdFromSubMenuEventKey)(props.eventKey)],
	        multiple: props.multiple,
	        prefixCls: props.rootPrefixCls,
	        id: this.internalMenuId,
	        manualRef: this.saveMenuInstance,
	        itemIcon: props.itemIcon,
	        expandIcon: props.expandIcon
	      };
	      var haveRendered = this.haveRendered;
	      this.haveRendered = true;
	      this.haveOpened = this.haveOpened || baseProps.visible || baseProps.forceSubMenuRender; // never rendered not planning to, don't render
	
	      if (!this.haveOpened) {
	        return React.createElement("div", null);
	      } // ================== Motion ==================
	      // don't show transition on first rendering (no animation for opened menu)
	      // show appear transition if it's not visible (not sure why)
	      // show appear transition if it's not inline mode
	
	
	      var mergedMotion = _objectSpread({}, props.motion, {
	        leavedClassName: "".concat(props.rootPrefixCls, "-hidden"),
	        removeOnLeave: false,
	        motionAppear: haveRendered || !baseProps.visible || baseProps.mode !== 'inline'
	      });
	
	      return React.createElement(_CSSMotion.default, Object.assign({
	        visible: baseProps.visible
	      }, mergedMotion), function (_ref) {
	        var className = _ref.className,
	            style = _ref.style;
	        var mergedClassName = (0, _classnames.default)("".concat(baseProps.prefixCls, "-sub"), className);
	        return React.createElement(_SubPopupMenu.default, Object.assign({}, baseProps, {
	          id: _this3.internalMenuId,
	          className: mergedClassName,
	          style: style
	        }), children);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var props = _objectSpread({}, this.props);
	
	      var isOpen = props.isOpen;
	      var prefixCls = this.getPrefixCls();
	      var isInlineMode = props.mode === 'inline';
	      var className = (0, _classnames.default)(prefixCls, "".concat(prefixCls, "-").concat(props.mode), (_classNames = {}, _defineProperty(_classNames, props.className, !!props.className), _defineProperty(_classNames, this.getOpenClassName(), isOpen), _defineProperty(_classNames, this.getActiveClassName(), props.active || isOpen && !isInlineMode), _defineProperty(_classNames, this.getDisabledClassName(), props.disabled), _defineProperty(_classNames, this.getSelectedClassName(), this.isChildrenSelected()), _classNames));
	
	      if (!this.internalMenuId) {
	        if (props.eventKey) {
	          this.internalMenuId = "".concat(props.eventKey, "$Menu");
	        } else {
	          guid += 1;
	          this.internalMenuId = "$__$".concat(guid, "$Menu");
	        }
	      }
	
	      var mouseEvents = {};
	      var titleClickEvents = {};
	      var titleMouseEvents = {};
	
	      if (!props.disabled) {
	        mouseEvents = {
	          onMouseLeave: this.onMouseLeave,
	          onMouseEnter: this.onMouseEnter
	        }; // only works in title, not outer li
	
	        titleClickEvents = {
	          onClick: this.onTitleClick
	        };
	        titleMouseEvents = {
	          onMouseEnter: this.onTitleMouseEnter,
	          onMouseLeave: this.onTitleMouseLeave
	        };
	      }
	
	      var style = {};
	
	      if (isInlineMode) {
	        style.paddingLeft = props.inlineIndent * props.level;
	      }
	
	      var ariaOwns = {}; // only set aria-owns when menu is open
	      // otherwise it would be an invalid aria-owns value
	      // since corresponding node cannot be found
	
	      if (this.props.isOpen) {
	        ariaOwns = {
	          'aria-owns': this.internalMenuId
	        };
	      } // expand custom icon should NOT be displayed in menu with horizontal mode.
	
	
	      var icon = null;
	
	      if (props.mode !== 'horizontal') {
	        icon = this.props.expandIcon; // ReactNode
	
	        if (typeof this.props.expandIcon === 'function') {
	          icon = React.createElement(this.props.expandIcon, _objectSpread({}, this.props));
	        }
	      }
	
	      var title = React.createElement("div", Object.assign({
	        ref: this.saveSubMenuTitle,
	        style: style,
	        className: "".concat(prefixCls, "-title")
	      }, titleMouseEvents, titleClickEvents, {
	        "aria-expanded": isOpen
	      }, ariaOwns, {
	        "aria-haspopup": "true",
	        title: typeof props.title === 'string' ? props.title : undefined
	      }), props.title, icon || React.createElement("i", {
	        className: "".concat(prefixCls, "-arrow")
	      }));
	      var children = this.renderChildren(props.children);
	      var getPopupContainer = props.parentMenu.isRootMenu ? props.parentMenu.props.getPopupContainer : function (triggerNode) {
	        return triggerNode.parentNode;
	      };
	      var popupPlacement = popupPlacementMap[props.mode];
	      var popupAlign = props.popupOffset ? {
	        offset: props.popupOffset
	      } : {};
	      var popupClassName = props.mode === 'inline' ? '' : props.popupClassName;
	      var disabled = props.disabled,
	          triggerSubMenuAction = props.triggerSubMenuAction,
	          subMenuOpenDelay = props.subMenuOpenDelay,
	          forceSubMenuRender = props.forceSubMenuRender,
	          subMenuCloseDelay = props.subMenuCloseDelay,
	          builtinPlacements = props.builtinPlacements;
	
	      _util.menuAllProps.forEach(function (key) {
	        return delete props[key];
	      }); // Set onClick to null, to ignore propagated onClick event
	
	
	      delete props.onClick;
	      return React.createElement("li", Object.assign({}, props, mouseEvents, {
	        className: className,
	        role: "menuitem"
	      }), isInlineMode && title, isInlineMode && children, !isInlineMode && React.createElement(_rcTrigger.default, {
	        prefixCls: prefixCls,
	        popupClassName: "".concat(prefixCls, "-popup ").concat(popupClassName),
	        getPopupContainer: getPopupContainer,
	        builtinPlacements: Object.assign({}, _placements.default, builtinPlacements),
	        popupPlacement: popupPlacement,
	        popupVisible: isOpen,
	        popupAlign: popupAlign,
	        popup: children,
	        action: disabled ? [] : [triggerSubMenuAction],
	        mouseEnterDelay: subMenuOpenDelay,
	        mouseLeaveDelay: subMenuCloseDelay,
	        onPopupVisibleChange: this.onPopupVisibleChange,
	        forceRender: forceSubMenuRender
	      }, title));
	    }
	  }]);
	
	  return SubMenu;
	}(React.Component);
	
	exports.SubMenu = SubMenu;
	SubMenu.defaultProps = {
	  onMouseEnter: _util.noop,
	  onMouseLeave: _util.noop,
	  onTitleMouseEnter: _util.noop,
	  onTitleMouseLeave: _util.noop,
	  onTitleClick: _util.noop,
	  manualRef: _util.noop,
	  mode: 'vertical',
	  title: ''
	};
	var connected = (0, _miniStore.connect)(function (_ref2, _ref3) {
	  var openKeys = _ref2.openKeys,
	      activeKey = _ref2.activeKey,
	      selectedKeys = _ref2.selectedKeys;
	  var eventKey = _ref3.eventKey,
	      subMenuKey = _ref3.subMenuKey;
	  return {
	    isOpen: openKeys.indexOf(eventKey) > -1,
	    active: activeKey[subMenuKey] === eventKey,
	    selectedKeys: selectedKeys
	  };
	})(SubMenu);
	connected.isSubMenu = true;
	var _default = connected;
	exports.default = _default;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getActiveKey = getActiveKey;
	exports.saveRef = saveRef;
	exports.default = exports.SubPopupMenu = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _miniStore = __webpack_require__(143);
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(71));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(570));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(79));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _util = __webpack_require__(257);
	
	var _DOMWrap = _interopRequireDefault(__webpack_require__(2702));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function allDisabled(arr) {
	  if (!arr.length) {
	    return true;
	  }
	
	  return arr.every(function (c) {
	    return !!c.props.disabled;
	  });
	}
	
	function updateActiveKey(store, menuId, activeKey) {
	  var state = store.getState();
	  store.setState({
	    activeKey: _objectSpread({}, state.activeKey, _defineProperty({}, menuId, activeKey))
	  });
	}
	
	function getEventKey(props) {
	  // when eventKey not available ,it's menu and return menu id '0-menu-'
	  return props.eventKey || '0-menu-';
	}
	
	function getActiveKey(props, originalActiveKey) {
	  var activeKey = originalActiveKey;
	  var children = props.children,
	      eventKey = props.eventKey;
	
	  if (activeKey) {
	    var found;
	    (0, _util.loopMenuItem)(children, function (c, i) {
	      if (c && c.props && !c.props.disabled && activeKey === (0, _util.getKeyFromChildrenIndex)(c, eventKey, i)) {
	        found = true;
	      }
	    });
	
	    if (found) {
	      return activeKey;
	    }
	  }
	
	  activeKey = null;
	
	  if (props.defaultActiveFirst) {
	    (0, _util.loopMenuItem)(children, function (c, i) {
	      if (!activeKey && c && !c.props.disabled) {
	        activeKey = (0, _util.getKeyFromChildrenIndex)(c, eventKey, i);
	      }
	    });
	    return activeKey;
	  }
	
	  return activeKey;
	}
	
	function saveRef(c) {
	  if (c) {
	    var index = this.instanceArray.indexOf(c);
	
	    if (index !== -1) {
	      // update component if it's already inside instanceArray
	      this.instanceArray[index] = c;
	    } else {
	      // add component if it's not in instanceArray yet;
	      this.instanceArray.push(c);
	    }
	  }
	}
	
	var SubPopupMenu =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(SubPopupMenu, _React$Component);
	
	  function SubPopupMenu(props) {
	    var _this;
	
	    _classCallCheck(this, SubPopupMenu);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SubPopupMenu).call(this, props));
	    /**
	     * all keyboard events callbacks run from here at first
	     *
	     * note:
	     *  This legacy code that `onKeyDown` is called by parent instead of dom self.
	     *  which need return code to check if this event is handled
	     */
	
	    _this.onKeyDown = function (e, callback) {
	      var keyCode = e.keyCode;
	      var handled;
	
	      _this.getFlatInstanceArray().forEach(function (obj) {
	        if (obj && obj.props.active && obj.onKeyDown) {
	          handled = obj.onKeyDown(e);
	        }
	      });
	
	      if (handled) {
	        return 1;
	      }
	
	      var activeItem = null;
	
	      if (keyCode === _KeyCode.default.UP || keyCode === _KeyCode.default.DOWN) {
	        activeItem = _this.step(keyCode === _KeyCode.default.UP ? -1 : 1);
	      }
	
	      if (activeItem) {
	        e.preventDefault();
	        updateActiveKey(_this.props.store, getEventKey(_this.props), activeItem.props.eventKey);
	
	        if (typeof callback === 'function') {
	          callback(activeItem);
	        }
	
	        return 1;
	      }
	
	      return undefined;
	    };
	
	    _this.onItemHover = function (e) {
	      var key = e.key,
	          hover = e.hover;
	      updateActiveKey(_this.props.store, getEventKey(_this.props), hover ? key : null);
	    };
	
	    _this.onDeselect = function (selectInfo) {
	      _this.props.onDeselect(selectInfo);
	    };
	
	    _this.onSelect = function (selectInfo) {
	      _this.props.onSelect(selectInfo);
	    };
	
	    _this.onClick = function (e) {
	      _this.props.onClick(e);
	    };
	
	    _this.onOpenChange = function (e) {
	      _this.props.onOpenChange(e);
	    };
	
	    _this.onDestroy = function (key) {
	      /* istanbul ignore next */
	      _this.props.onDestroy(key);
	    };
	
	    _this.getFlatInstanceArray = function () {
	      return _this.instanceArray;
	    };
	
	    _this.step = function (direction) {
	      var children = _this.getFlatInstanceArray();
	
	      var activeKey = _this.props.store.getState().activeKey[getEventKey(_this.props)];
	
	      var len = children.length;
	
	      if (!len) {
	        return null;
	      }
	
	      if (direction < 0) {
	        children = children.concat().reverse();
	      } // find current activeIndex
	
	
	      var activeIndex = -1;
	      children.every(function (c, ci) {
	        if (c && c.props.eventKey === activeKey) {
	          activeIndex = ci;
	          return false;
	        }
	
	        return true;
	      });
	
	      if (!_this.props.defaultActiveFirst && activeIndex !== -1 && allDisabled(children.slice(activeIndex, len - 1))) {
	        return undefined;
	      }
	
	      var start = (activeIndex + 1) % len;
	      var i = start;
	
	      do {
	        var child = children[i];
	
	        if (!child || child.props.disabled) {
	          i = (i + 1) % len;
	        } else {
	          return child;
	        }
	      } while (i !== start);
	
	      return null;
	    };
	
	    _this.renderCommonMenuItem = function (child, i, extraProps) {
	      var state = _this.props.store.getState();
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var key = (0, _util.getKeyFromChildrenIndex)(child, props.eventKey, i);
	      var childProps = child.props; // https://github.com/ant-design/ant-design/issues/11517#issuecomment-477403055
	
	      if (!childProps || typeof child.type === 'string') {
	        return child;
	      }
	
	      var isActive = key === state.activeKey;
	
	      var newChildProps = _objectSpread({
	        mode: childProps.mode || props.mode,
	        level: props.level,
	        inlineIndent: props.inlineIndent,
	        renderMenuItem: _this.renderMenuItem,
	        rootPrefixCls: props.prefixCls,
	        index: i,
	        parentMenu: props.parentMenu,
	        // customized ref function, need to be invoked manually in child's componentDidMount
	        manualRef: childProps.disabled ? undefined : (0, _createChainedFunction.default)(child.ref, saveRef.bind(_assertThisInitialized(_this))),
	        eventKey: key,
	        active: !childProps.disabled && isActive,
	        multiple: props.multiple,
	        onClick: function onClick(e) {
	          (childProps.onClick || _util.noop)(e);
	
	          _this.onClick(e);
	        },
	        onItemHover: _this.onItemHover,
	        motion: props.motion,
	        subMenuOpenDelay: props.subMenuOpenDelay,
	        subMenuCloseDelay: props.subMenuCloseDelay,
	        forceSubMenuRender: props.forceSubMenuRender,
	        onOpenChange: _this.onOpenChange,
	        onDeselect: _this.onDeselect,
	        onSelect: _this.onSelect,
	        builtinPlacements: props.builtinPlacements,
	        itemIcon: childProps.itemIcon || _this.props.itemIcon,
	        expandIcon: childProps.expandIcon || _this.props.expandIcon
	      }, extraProps); // ref: https://github.com/ant-design/ant-design/issues/13943
	
	
	      if (props.mode === 'inline' || (0, _util.isMobileDevice)()) {
	        newChildProps.triggerSubMenuAction = 'click';
	      }
	
	      return React.cloneElement(child, newChildProps);
	    };
	
	    _this.renderMenuItem = function (c, i, subMenuKey) {
	      /* istanbul ignore if */
	      if (!c) {
	        return null;
	      }
	
	      var state = _this.props.store.getState();
	
	      var extraProps = {
	        openKeys: state.openKeys,
	        selectedKeys: state.selectedKeys,
	        triggerSubMenuAction: _this.props.triggerSubMenuAction,
	        subMenuKey: subMenuKey
	      };
	      return _this.renderCommonMenuItem(c, i, extraProps);
	    };
	
	    props.store.setState({
	      activeKey: _objectSpread({}, props.store.getState().activeKey, _defineProperty({}, props.eventKey, getActiveKey(props, props.activeKey)))
	    });
	    _this.instanceArray = [];
	    return _this;
	  }
	
	  _createClass(SubPopupMenu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // invoke customized ref to expose component to mixin
	      if (this.props.manualRef) {
	        this.props.manualRef(this);
	      }
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.visible || nextProps.visible || this.props.className !== nextProps.className || !(0, _shallowequal.default)(this.props.style, nextProps.style);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var props = this.props;
	      var originalActiveKey = 'activeKey' in props ? props.activeKey : props.store.getState().activeKey[getEventKey(props)];
	      var activeKey = getActiveKey(props, originalActiveKey);
	
	      if (activeKey !== originalActiveKey) {
	        updateActiveKey(props.store, getEventKey(props), activeKey);
	      } else if ('activeKey' in prevProps) {
	        // If prev activeKey is not same as current activeKey,
	        // we should set it.
	        var prevActiveKey = getActiveKey(prevProps, prevProps.activeKey);
	
	        if (activeKey !== prevActiveKey) {
	          updateActiveKey(props.store, getEventKey(props), activeKey);
	        }
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var props = _extends({}, this.props);
	
	      this.instanceArray = [];
	      var className = (0, _classnames.default)(props.prefixCls, props.className, "".concat(props.prefixCls, "-").concat(props.mode));
	      var domProps = {
	        className: className,
	        // role could be 'select' and by default set to menu
	        role: props.role || 'menu'
	      };
	
	      if (props.id) {
	        domProps.id = props.id;
	      }
	
	      if (props.focusable) {
	        domProps.tabIndex = 0;
	        domProps.onKeyDown = this.onKeyDown;
	      }
	
	      var prefixCls = props.prefixCls,
	          eventKey = props.eventKey,
	          visible = props.visible,
	          level = props.level,
	          mode = props.mode,
	          overflowedIndicator = props.overflowedIndicator,
	          theme = props.theme;
	
	      _util.menuAllProps.forEach(function (key) {
	        return delete props[key];
	      }); // Otherwise, the propagated click event will trigger another onClick
	
	
	      delete props.onClick;
	      return React.createElement(_DOMWrap.default, Object.assign({}, props, {
	        prefixCls: prefixCls,
	        mode: mode,
	        tag: "ul",
	        level: level,
	        theme: theme,
	        visible: visible,
	        overflowedIndicator: overflowedIndicator
	      }, domProps), React.Children.map(props.children, function (c, i) {
	        return _this2.renderMenuItem(c, i, eventKey || '0-menu-');
	      }));
	    }
	  }]);
	
	  return SubPopupMenu;
	}(React.Component);
	
	exports.SubPopupMenu = SubPopupMenu;
	SubPopupMenu.defaultProps = {
	  prefixCls: 'rc-menu',
	  className: '',
	  mode: 'vertical',
	  level: 1,
	  inlineIndent: 24,
	  visible: true,
	  focusable: true,
	  style: {},
	  manualRef: _util.noop
	};
	var connected = (0, _miniStore.connect)()(SubPopupMenu);
	var _default = connected;
	exports.default = _default;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Notification = __webpack_require__(2711);
	
	var _Notification2 = _interopRequireDefault(_Notification);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Notification2['default'];
	module.exports = exports['default'];

/***/ },
/* 1095 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  ZERO: 48,
	  NINE: 57,
	
	  NUMPAD_ZERO: 96,
	  NUMPAD_NINE: 105,
	
	  BACKSPACE: 8,
	  DELETE: 46,
	  ENTER: 13,
	
	  ARROW_UP: 38,
	  ARROW_DOWN: 40
	};
	module.exports = exports['default'];

/***/ },
/* 1096 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = {
	  // Options.jsx
	  items_per_page: '/ page',
	  jump_to: 'Go to',
	  jump_to_confirm: 'confirm',
	  page: '',
	
	  // Pagination.jsx
	  prev_page: 'Previous Page',
	  next_page: 'Next Page',
	  prev_5: 'Previous 5 Pages',
	  next_5: 'Next 5 Pages',
	  prev_3: 'Previous 3 Pages',
	  next_3: 'Next 3 Pages'
	};
	module.exports = exports['default'];

/***/ },
/* 1097 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = {
	  // Options.jsx
	  items_per_page: '条/页',
	  jump_to: '跳至',
	  jump_to_confirm: '确定',
	  page: '页',
	
	  // Pagination.jsx
	  prev_page: '上一页',
	  next_page: '下一页',
	  prev_5: '向前 5 页',
	  next_5: '向后 5 页',
	  prev_3: '向前 3 页',
	  next_3: '向后 3 页'
	};
	module.exports = exports['default'];

/***/ },
/* 1098 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }
	
	function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var enhancer = function enhancer(WrappedComponent) {
	  return /*#__PURE__*/function (_WrappedComponent) {
	    _inherits(Progress, _WrappedComponent);
	
	    var _super = _createSuper(Progress);
	
	    function Progress() {
	      _classCallCheck(this, Progress);
	
	      return _super.apply(this, arguments);
	    }
	
	    _createClass(Progress, [{
	      key: "componentDidUpdate",
	      value: function componentDidUpdate() {
	        var _this = this;
	
	        var now = Date.now();
	        var updated = false;
	        Object.keys(this.paths).forEach(function (key) {
	          var path = _this.paths[key];
	
	          if (!path) {
	            return;
	          }
	
	          updated = true;
	          var pathStyle = path.style;
	          pathStyle.transitionDuration = '.3s, .3s, .3s, .06s';
	
	          if (_this.prevTimeStamp && now - _this.prevTimeStamp < 100) {
	            pathStyle.transitionDuration = '0s, 0s';
	          }
	        });
	
	        if (updated) {
	          this.prevTimeStamp = Date.now();
	        }
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return _get(_getPrototypeOf(Progress.prototype), "render", this).call(this);
	      }
	    }]);
	
	    return Progress;
	  }(WrappedComponent);
	};
	
	var _default = enhancer;
	exports["default"] = _default;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.propTypes = exports.defaultProps = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var defaultProps = {
	  className: '',
	  percent: 0,
	  prefixCls: 'rc-progress',
	  strokeColor: '#2db7f5',
	  strokeLinecap: 'round',
	  strokeWidth: 1,
	  style: {},
	  trailColor: '#D9D9D9',
	  trailWidth: 1
	};
	exports.defaultProps = defaultProps;
	
	var mixedType = _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]);
	
	var propTypes = {
	  className: _propTypes["default"].string,
	  percent: _propTypes["default"].oneOfType([mixedType, _propTypes["default"].arrayOf(mixedType)]),
	  prefixCls: _propTypes["default"].string,
	  strokeColor: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].arrayOf(_propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].object])), _propTypes["default"].object]),
	  strokeLinecap: _propTypes["default"].oneOf(['butt', 'round', 'square']),
	  strokeWidth: mixedType,
	  style: _propTypes["default"].object,
	  trailColor: _propTypes["default"].string,
	  trailWidth: mixedType
	};
	exports.propTypes = propTypes;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _react = __webpack_require__(1);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Option =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Option, _Component);
	
	  function Option() {
	    _classCallCheck(this, Option);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Option).apply(this, arguments));
	  }
	
	  return Option;
	}(_react.Component);
	
	exports["default"] = Option;
	Option.propTypes = {
	  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
	};
	Option.isSelectOption = true;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function propsValueType() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var props = args[0],
	      propName = args[1],
	      componentName = args[2],
	      rest = args.slice(3);
	  var basicType = PropTypes.oneOfType([PropTypes.string, PropTypes.number]);
	  var labelInValueShape = PropTypes.shape({
	    key: basicType.isRequired,
	    label: PropTypes.node
	  });
	
	  if (props.labelInValue) {
	    var validate = PropTypes.oneOfType([PropTypes.arrayOf(labelInValueShape), labelInValueShape]);
	    var error = validate.apply(void 0, [props, propName, componentName].concat(_toConsumableArray(rest)));
	
	    if (error) {
	      return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(componentName, "`, ") + "when you set `labelInValue` to `true`, `".concat(propName, "` should in ") + "shape of `{ key: string | number, label?: ReactNode }`.");
	    }
	  } else if ((props.mode === 'multiple' || props.mode === 'tags' || props.multiple || props.tags) && props[propName] === '') {
	    return new Error("Invalid prop `".concat(propName, "` of type `string` supplied to `").concat(componentName, "`, ") + "expected `array` when `multiple` or `tags` is `true`.");
	  } else {
	    var _validate = PropTypes.oneOfType([PropTypes.arrayOf(basicType), basicType]);
	
	    return _validate.apply(void 0, [props, propName, componentName].concat(_toConsumableArray(rest)));
	  }
	
	  return null;
	}
	
	var SelectPropTypes = {
	  id: PropTypes.string,
	  defaultActiveFirstOption: PropTypes.bool,
	  multiple: PropTypes.bool,
	  filterOption: PropTypes.any,
	  children: PropTypes.any,
	  showSearch: PropTypes.bool,
	  disabled: PropTypes.bool,
	  allowClear: PropTypes.bool,
	  showArrow: PropTypes.bool,
	  tags: PropTypes.bool,
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  transitionName: PropTypes.string,
	  optionLabelProp: PropTypes.string,
	  optionFilterProp: PropTypes.string,
	  animation: PropTypes.string,
	  choiceTransitionName: PropTypes.string,
	  open: PropTypes.bool,
	  defaultOpen: PropTypes.bool,
	  onChange: PropTypes.func,
	  onBlur: PropTypes.func,
	  onFocus: PropTypes.func,
	  onSelect: PropTypes.func,
	  onSearch: PropTypes.func,
	  onPopupScroll: PropTypes.func,
	  onMouseEnter: PropTypes.func,
	  onMouseLeave: PropTypes.func,
	  onInputKeyDown: PropTypes.func,
	  placeholder: PropTypes.any,
	  onDeselect: PropTypes.func,
	  labelInValue: PropTypes.bool,
	  loading: PropTypes.bool,
	  value: propsValueType,
	  defaultValue: propsValueType,
	  dropdownStyle: PropTypes.object,
	  maxTagTextLength: PropTypes.number,
	  maxTagCount: PropTypes.number,
	  maxTagPlaceholder: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
	  tokenSeparators: PropTypes.arrayOf(PropTypes.string),
	  getInputElement: PropTypes.func,
	  showAction: PropTypes.arrayOf(PropTypes.string),
	  clearIcon: PropTypes.node,
	  inputIcon: PropTypes.node,
	  removeIcon: PropTypes.node,
	  menuItemSelectedIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
	  dropdownRender: PropTypes.func
	};
	var _default = SelectPropTypes;
	exports["default"] = _default;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "OptGroup", {
	  enumerable: true,
	  get: function get() {
	    return _OptGroup["default"];
	  }
	});
	Object.defineProperty(exports, "Option", {
	  enumerable: true,
	  get: function get() {
	    return _Option["default"];
	  }
	});
	Object.defineProperty(exports, "SelectPropTypes", {
	  enumerable: true,
	  get: function get() {
	    return _PropTypes["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _OptGroup = _interopRequireDefault(__webpack_require__(2724));
	
	var _Option = _interopRequireDefault(__webpack_require__(1100));
	
	var _PropTypes = _interopRequireDefault(__webpack_require__(1101));
	
	var _Select = _interopRequireDefault(__webpack_require__(2725));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_Select["default"].Option = _Option["default"];
	_Select["default"].OptGroup = _OptGroup["default"];
	var _default = _Select["default"];
	exports["default"] = _default;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _addEventListener = __webpack_require__(145);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Handle = function (_React$Component) {
	  (0, _inherits3['default'])(Handle, _React$Component);
	
	  function Handle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Handle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Handle.__proto__ || Object.getPrototypeOf(Handle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      clickFocused: false
	    }, _this.setHandleRef = function (node) {
	      _this.handle = node;
	    }, _this.handleMouseUp = function () {
	      if (document.activeElement === _this.handle) {
	        _this.setClickFocus(true);
	      }
	    }, _this.handleMouseDown = function () {
	      // fix https://github.com/ant-design/ant-design/issues/15324
	      _this.focus();
	    }, _this.handleBlur = function () {
	      _this.setClickFocus(false);
	    }, _this.handleKeyDown = function () {
	      _this.setClickFocus(false);
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Handle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // mouseup won't trigger if mouse moved out of handle,
	      // so we listen on document here.
	      this.onMouseUpListener = (0, _addEventListener2['default'])(document, 'mouseup', this.handleMouseUp);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.onMouseUpListener) {
	        this.onMouseUpListener.remove();
	      }
	    }
	  }, {
	    key: 'setClickFocus',
	    value: function setClickFocus(focused) {
	      this.setState({ clickFocused: focused });
	    }
	  }, {
	    key: 'clickFocus',
	    value: function clickFocus() {
	      this.setClickFocus(true);
	      this.focus();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.handle.focus();
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.handle.blur();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _ref2, _ref3;
	
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          vertical = _props.vertical,
	          reverse = _props.reverse,
	          offset = _props.offset,
	          style = _props.style,
	          disabled = _props.disabled,
	          min = _props.min,
	          max = _props.max,
	          value = _props.value,
	          tabIndex = _props.tabIndex,
	          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'vertical', 'reverse', 'offset', 'style', 'disabled', 'min', 'max', 'value', 'tabIndex']);
	
	
	      var className = (0, _classnames2['default'])(this.props.className, (0, _defineProperty3['default'])({}, prefixCls + '-handle-click-focused', this.state.clickFocused));
	      var positionStyle = vertical ? (_ref2 = {}, (0, _defineProperty3['default'])(_ref2, reverse ? 'top' : 'bottom', offset + '%'), (0, _defineProperty3['default'])(_ref2, reverse ? 'bottom' : 'top', 'auto'), (0, _defineProperty3['default'])(_ref2, 'transform', 'translateY(+50%)'), _ref2) : (_ref3 = {}, (0, _defineProperty3['default'])(_ref3, reverse ? 'right' : 'left', offset + '%'), (0, _defineProperty3['default'])(_ref3, reverse ? 'left' : 'right', 'auto'), (0, _defineProperty3['default'])(_ref3, 'transform', 'translateX(' + (reverse ? '+' : '-') + '50%)'), _ref3);
	      var elStyle = (0, _extends3['default'])({}, style, positionStyle);
	
	      var _tabIndex = tabIndex || 0;
	      if (disabled || tabIndex === null) {
	        _tabIndex = null;
	      }
	
	      return _react2['default'].createElement('div', (0, _extends3['default'])({
	        ref: this.setHandleRef,
	        tabIndex: _tabIndex
	      }, restProps, {
	        className: className,
	        style: elStyle,
	        onBlur: this.handleBlur,
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleMouseDown
	
	        // aria attribute
	        , role: 'slider',
	        'aria-valuemin': min,
	        'aria-valuemax': max,
	        'aria-valuenow': value,
	        'aria-disabled': !!disabled
	      }));
	    }
	  }]);
	  return Handle;
	}(_react2['default'].Component);
	
	exports['default'] = Handle;
	
	
	Handle.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  vertical: _propTypes2['default'].bool,
	  offset: _propTypes2['default'].number,
	  style: _propTypes2['default'].object,
	  disabled: _propTypes2['default'].bool,
	  min: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  value: _propTypes2['default'].number,
	  tabIndex: _propTypes2['default'].number,
	  reverse: _propTypes2['default'].bool
	};
	module.exports = exports['default'];

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Track = function Track(props) {
	  var _ref, _ref2;
	
	  var className = props.className,
	      included = props.included,
	      vertical = props.vertical,
	      offset = props.offset,
	      length = props.length,
	      style = props.style,
	      reverse = props.reverse;
	
	  var positonStyle = vertical ? (_ref = {}, (0, _defineProperty3['default'])(_ref, reverse ? 'top' : 'bottom', offset + '%'), (0, _defineProperty3['default'])(_ref, reverse ? 'bottom' : 'top', 'auto'), (0, _defineProperty3['default'])(_ref, 'height', length + '%'), _ref) : (_ref2 = {}, (0, _defineProperty3['default'])(_ref2, reverse ? 'right' : 'left', offset + '%'), (0, _defineProperty3['default'])(_ref2, reverse ? 'left' : 'right', 'auto'), (0, _defineProperty3['default'])(_ref2, 'width', length + '%'), _ref2);
	
	  var elStyle = (0, _extends3['default'])({}, style, positonStyle);
	  return included ? _react2['default'].createElement('div', { className: className, style: elStyle }) : null;
	}; /* eslint-disable react/prop-types */
	exports['default'] = Track;
	module.exports = exports['default'];

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _get2 = __webpack_require__(1836);
	
	var _get3 = _interopRequireDefault(_get2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports['default'] = createSlider;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _addEventListener = __webpack_require__(145);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(94);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Steps = __webpack_require__(2730);
	
	var _Steps2 = _interopRequireDefault(_Steps);
	
	var _Marks = __webpack_require__(2729);
	
	var _Marks2 = _interopRequireDefault(_Marks);
	
	var _Handle = __webpack_require__(1103);
	
	var _Handle2 = _interopRequireDefault(_Handle);
	
	var _utils = __webpack_require__(562);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function createSlider(Component) {
	  var _class, _temp;
	
	  return _temp = _class = function (_Component) {
	    (0, _inherits3['default'])(ComponentEnhancer, _Component);
	
	    function ComponentEnhancer(props) {
	      (0, _classCallCheck3['default'])(this, ComponentEnhancer);
	
	      var _this = (0, _possibleConstructorReturn3['default'])(this, (ComponentEnhancer.__proto__ || Object.getPrototypeOf(ComponentEnhancer)).call(this, props));
	
	      _this.onMouseDown = function (e) {
	        if (e.button !== 0) {
	          return;
	        }
	
	        var isVertical = _this.props.vertical;
	        var position = utils.getMousePosition(isVertical, e);
	        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.dragOffset = 0;
	        } else {
	          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
	          _this.dragOffset = position - handlePosition;
	          position = handlePosition;
	        }
	        _this.removeDocumentEvents();
	        _this.onStart(position);
	        _this.addDocumentMouseEvents();
	      };
	
	      _this.onTouchStart = function (e) {
	        if (utils.isNotTouchEvent(e)) return;
	
	        var isVertical = _this.props.vertical;
	        var position = utils.getTouchPosition(isVertical, e);
	        if (!utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.dragOffset = 0;
	        } else {
	          var handlePosition = utils.getHandleCenterPosition(isVertical, e.target);
	          _this.dragOffset = position - handlePosition;
	          position = handlePosition;
	        }
	        _this.onStart(position);
	        _this.addDocumentTouchEvents();
	        utils.pauseEvent(e);
	      };
	
	      _this.onFocus = function (e) {
	        var _this$props = _this.props,
	            onFocus = _this$props.onFocus,
	            vertical = _this$props.vertical;
	
	        if (utils.isEventFromHandle(e, _this.handlesRefs)) {
	          var handlePosition = utils.getHandleCenterPosition(vertical, e.target);
	          _this.dragOffset = 0;
	          _this.onStart(handlePosition);
	          utils.pauseEvent(e);
	          if (onFocus) {
	            onFocus(e);
	          }
	        }
	      };
	
	      _this.onBlur = function (e) {
	        var onBlur = _this.props.onBlur;
	
	        _this.onEnd();
	        if (onBlur) {
	          onBlur(e);
	        }
	      };
	
	      _this.onMouseUp = function () {
	        if (_this.handlesRefs[_this.prevMovedHandleIndex]) {
	          _this.handlesRefs[_this.prevMovedHandleIndex].clickFocus();
	        }
	      };
	
	      _this.onMouseMove = function (e) {
	        if (!_this.sliderRef) {
	          _this.onEnd();
	          return;
	        }
	        var position = utils.getMousePosition(_this.props.vertical, e);
	        _this.onMove(e, position - _this.dragOffset);
	      };
	
	      _this.onTouchMove = function (e) {
	        if (utils.isNotTouchEvent(e) || !_this.sliderRef) {
	          _this.onEnd();
	          return;
	        }
	
	        var position = utils.getTouchPosition(_this.props.vertical, e);
	        _this.onMove(e, position - _this.dragOffset);
	      };
	
	      _this.onKeyDown = function (e) {
	        if (_this.sliderRef && utils.isEventFromHandle(e, _this.handlesRefs)) {
	          _this.onKeyboard(e);
	        }
	      };
	
	      _this.onClickMarkLabel = function (e, value) {
	        e.stopPropagation();
	        _this.onChange({ value: value });
	        _this.setState({ value: value }, function () {
	          return _this.onEnd(true);
	        });
	      };
	
	      _this.saveSlider = function (slider) {
	        _this.sliderRef = slider;
	      };
	
	      var step = props.step,
	          max = props.max,
	          min = props.min;
	
	      var isPointDiffEven = isFinite(max - min) ? (max - min) % step === 0 : true; // eslint-disable-line
	      (0, _warning2['default'])(step && Math.floor(step) === step ? isPointDiffEven : true, 'Slider[max] - Slider[min] (%s) should be a multiple of Slider[step] (%s)', max - min, step);
	      _this.handlesRefs = {};
	      return _this;
	    }
	
	    (0, _createClass3['default'])(ComponentEnhancer, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        // Snapshot testing cannot handle refs, so be sure to null-check this.
	        this.document = this.sliderRef && this.sliderRef.ownerDocument;
	
	        var _props = this.props,
	            autoFocus = _props.autoFocus,
	            disabled = _props.disabled;
	
	        if (autoFocus && !disabled) {
	          this.focus();
	        }
	      }
	    }, {
	      key: 'componentWillUnmount',
	      value: function componentWillUnmount() {
	        if ((0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this)) (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'componentWillUnmount', this).call(this);
	        this.removeDocumentEvents();
	      }
	    }, {
	      key: 'getSliderStart',
	      value: function getSliderStart() {
	        var slider = this.sliderRef;
	        var _props2 = this.props,
	            vertical = _props2.vertical,
	            reverse = _props2.reverse;
	
	        var rect = slider.getBoundingClientRect();
	        if (vertical) {
	          return reverse ? rect.bottom : rect.top;
	        }
	        return window.pageXOffset + (reverse ? rect.right : rect.left);
	      }
	    }, {
	      key: 'getSliderLength',
	      value: function getSliderLength() {
	        var slider = this.sliderRef;
	        if (!slider) {
	          return 0;
	        }
	
	        var coords = slider.getBoundingClientRect();
	        return this.props.vertical ? coords.height : coords.width;
	      }
	    }, {
	      key: 'addDocumentTouchEvents',
	      value: function addDocumentTouchEvents() {
	        // just work for Chrome iOS Safari and Android Browser
	        this.onTouchMoveListener = (0, _addEventListener2['default'])(this.document, 'touchmove', this.onTouchMove);
	        this.onTouchUpListener = (0, _addEventListener2['default'])(this.document, 'touchend', this.onEnd);
	      }
	    }, {
	      key: 'addDocumentMouseEvents',
	      value: function addDocumentMouseEvents() {
	        this.onMouseMoveListener = (0, _addEventListener2['default'])(this.document, 'mousemove', this.onMouseMove);
	        this.onMouseUpListener = (0, _addEventListener2['default'])(this.document, 'mouseup', this.onEnd);
	      }
	    }, {
	      key: 'removeDocumentEvents',
	      value: function removeDocumentEvents() {
	        /* eslint-disable no-unused-expressions */
	        this.onTouchMoveListener && this.onTouchMoveListener.remove();
	        this.onTouchUpListener && this.onTouchUpListener.remove();
	
	        this.onMouseMoveListener && this.onMouseMoveListener.remove();
	        this.onMouseUpListener && this.onMouseUpListener.remove();
	        /* eslint-enable no-unused-expressions */
	      }
	    }, {
	      key: 'focus',
	      value: function focus() {
	        if (!this.props.disabled) {
	          this.handlesRefs[0].focus();
	        }
	      }
	    }, {
	      key: 'blur',
	      value: function blur() {
	        var _this2 = this;
	
	        if (!this.props.disabled) {
	          Object.keys(this.handlesRefs).forEach(function (key) {
	            if (_this2.handlesRefs[key] && _this2.handlesRefs[key].blur) {
	              _this2.handlesRefs[key].blur();
	            }
	          });
	        }
	      }
	    }, {
	      key: 'calcValue',
	      value: function calcValue(offset) {
	        var _props3 = this.props,
	            vertical = _props3.vertical,
	            min = _props3.min,
	            max = _props3.max;
	
	        var ratio = Math.abs(Math.max(offset, 0) / this.getSliderLength());
	        var value = vertical ? (1 - ratio) * (max - min) + min : ratio * (max - min) + min;
	        return value;
	      }
	    }, {
	      key: 'calcValueByPos',
	      value: function calcValueByPos(position) {
	        var sign = this.props.reverse ? -1 : +1;
	        var pixelOffset = sign * (position - this.getSliderStart());
	        var nextValue = this.trimAlignValue(this.calcValue(pixelOffset));
	        return nextValue;
	      }
	    }, {
	      key: 'calcOffset',
	      value: function calcOffset(value) {
	        var _props4 = this.props,
	            min = _props4.min,
	            max = _props4.max;
	
	        var ratio = (value - min) / (max - min);
	        return ratio * 100;
	      }
	    }, {
	      key: 'saveHandle',
	      value: function saveHandle(index, handle) {
	        this.handlesRefs[index] = handle;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _classNames;
	
	        var _props5 = this.props,
	            prefixCls = _props5.prefixCls,
	            className = _props5.className,
	            marks = _props5.marks,
	            dots = _props5.dots,
	            step = _props5.step,
	            included = _props5.included,
	            disabled = _props5.disabled,
	            vertical = _props5.vertical,
	            reverse = _props5.reverse,
	            min = _props5.min,
	            max = _props5.max,
	            children = _props5.children,
	            maximumTrackStyle = _props5.maximumTrackStyle,
	            style = _props5.style,
	            railStyle = _props5.railStyle,
	            dotStyle = _props5.dotStyle,
	            activeDotStyle = _props5.activeDotStyle;
	
	        var _get$call = (0, _get3['default'])(ComponentEnhancer.prototype.__proto__ || Object.getPrototypeOf(ComponentEnhancer.prototype), 'render', this).call(this),
	            tracks = _get$call.tracks,
	            handles = _get$call.handles;
	
	        var sliderClassName = (0, _classnames2['default'])(prefixCls, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-with-marks', Object.keys(marks).length), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, prefixCls + '-vertical', vertical), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
	        return _react2['default'].createElement(
	          'div',
	          {
	            ref: this.saveSlider,
	            className: sliderClassName,
	            onTouchStart: disabled ? noop : this.onTouchStart,
	            onMouseDown: disabled ? noop : this.onMouseDown,
	            onMouseUp: disabled ? noop : this.onMouseUp,
	            onKeyDown: disabled ? noop : this.onKeyDown,
	            onFocus: disabled ? noop : this.onFocus,
	            onBlur: disabled ? noop : this.onBlur,
	            style: style
	          },
	          _react2['default'].createElement('div', {
	            className: prefixCls + '-rail',
	            style: (0, _extends3['default'])({}, maximumTrackStyle, railStyle)
	          }),
	          tracks,
	          _react2['default'].createElement(_Steps2['default'], {
	            prefixCls: prefixCls,
	            vertical: vertical,
	            reverse: reverse,
	            marks: marks,
	            dots: dots,
	            step: step,
	            included: included,
	            lowerBound: this.getLowerBound(),
	            upperBound: this.getUpperBound(),
	            max: max,
	            min: min,
	            dotStyle: dotStyle,
	            activeDotStyle: activeDotStyle
	          }),
	          handles,
	          _react2['default'].createElement(_Marks2['default'], {
	            className: prefixCls + '-mark',
	            onClickLabel: disabled ? noop : this.onClickMarkLabel,
	            vertical: vertical,
	            marks: marks,
	            included: included,
	            lowerBound: this.getLowerBound(),
	            upperBound: this.getUpperBound(),
	            max: max,
	            min: min,
	            reverse: reverse
	          }),
	          children
	        );
	      }
	    }]);
	    return ComponentEnhancer;
	  }(Component), _class.displayName = 'ComponentEnhancer(' + Component.displayName + ')', _class.propTypes = (0, _extends3['default'])({}, Component.propTypes, {
	    min: _propTypes2['default'].number,
	    max: _propTypes2['default'].number,
	    step: _propTypes2['default'].number,
	    marks: _propTypes2['default'].object,
	    included: _propTypes2['default'].bool,
	    className: _propTypes2['default'].string,
	    prefixCls: _propTypes2['default'].string,
	    disabled: _propTypes2['default'].bool,
	    children: _propTypes2['default'].any,
	    onBeforeChange: _propTypes2['default'].func,
	    onChange: _propTypes2['default'].func,
	    onAfterChange: _propTypes2['default'].func,
	    handle: _propTypes2['default'].func,
	    dots: _propTypes2['default'].bool,
	    vertical: _propTypes2['default'].bool,
	    style: _propTypes2['default'].object,
	    reverse: _propTypes2['default'].bool,
	    minimumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
	    maximumTrackStyle: _propTypes2['default'].object, // just for compatibility, will be deperecate
	    handleStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	    trackStyle: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	    railStyle: _propTypes2['default'].object,
	    dotStyle: _propTypes2['default'].object,
	    activeDotStyle: _propTypes2['default'].object,
	    autoFocus: _propTypes2['default'].bool,
	    onFocus: _propTypes2['default'].func,
	    onBlur: _propTypes2['default'].func
	  }), _class.defaultProps = (0, _extends3['default'])({}, Component.defaultProps, {
	    prefixCls: 'rc-slider',
	    className: '',
	    min: 0,
	    max: 100,
	    step: 1,
	    marks: {},
	    handle: function handle(_ref) {
	      var index = _ref.index,
	          restProps = (0, _objectWithoutProperties3['default'])(_ref, ['index']);
	
	      delete restProps.dragging;
	      if (restProps.value === null) {
	        return null;
	      }
	
	      return _react2['default'].createElement(_Handle2['default'], (0, _extends3['default'])({}, restProps, { key: index }));
	    },
	
	    onBeforeChange: noop,
	    onChange: noop,
	    onAfterChange: noop,
	    included: true,
	    disabled: false,
	    dots: false,
	    vertical: false,
	    reverse: false,
	    trackStyle: [{}],
	    handleStyle: [{}],
	    railStyle: {},
	    dotStyle: {},
	    activeDotStyle: {}
	  }), _temp;
	}
	module.exports = exports['default'];

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SentinelConsumer = exports.SentinelProvider = undefined;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(71);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _createReactContext = __webpack_require__(129);
	
	var _createReactContext2 = _interopRequireDefault(_createReactContext);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint-disable jsx-a11y/no-noninteractive-tabindex */
	var SentinelContext = (0, _createReactContext2['default'])({});
	var SentinelProvider = exports.SentinelProvider = SentinelContext.Provider;
	var SentinelConsumer = exports.SentinelConsumer = SentinelContext.Consumer;
	
	var sentinelStyle = { width: 0, height: 0, overflow: 'hidden', position: 'absolute' };
	
	var Sentinel = function (_React$Component) {
	  (0, _inherits3['default'])(Sentinel, _React$Component);
	
	  function Sentinel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Sentinel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Sentinel.__proto__ || Object.getPrototypeOf(Sentinel)).call.apply(_ref, [this].concat(args))), _this), _this.onKeyDown = function (_ref2) {
	      var target = _ref2.target,
	          which = _ref2.which,
	          shiftKey = _ref2.shiftKey;
	      var _this$props = _this.props,
	          nextElement = _this$props.nextElement,
	          prevElement = _this$props.prevElement;
	
	      if (which !== _KeyCode2['default'].TAB || document.activeElement !== target) return;
	
	      // Tab next
	      if (!shiftKey && nextElement) {
	        nextElement.focus();
	      }
	
	      // Tab prev
	      if (shiftKey && prevElement) {
	        prevElement.focus();
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Sentinel, [{
	    key: 'render',
	    value: function render() {
	      var setRef = this.props.setRef;
	
	
	      return _react2['default'].createElement('div', {
	        tabIndex: 0,
	        ref: setRef,
	        style: sentinelStyle,
	        onKeyDown: this.onKeyDown,
	        role: 'presentation'
	      });
	    }
	  }]);
	  return Sentinel;
	}(_react2['default'].Component);
	
	Sentinel.propTypes = {
	  setRef: _propTypes2['default'].func,
	  prevElement: _propTypes2['default'].object,
	  nextElement: _propTypes2['default'].object
	};
	exports['default'] = Sentinel;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _utils = __webpack_require__(220);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabContent = function (_React$Component) {
	  (0, _inherits3['default'])(TabContent, _React$Component);
	
	  function TabContent() {
	    (0, _classCallCheck3['default'])(this, TabContent);
	    return (0, _possibleConstructorReturn3['default'])(this, (TabContent.__proto__ || Object.getPrototypeOf(TabContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(TabContent, [{
	    key: 'getTabPanes',
	    value: function getTabPanes() {
	      var props = this.props;
	      var activeKey = props.activeKey;
	      var children = props.children;
	      var newChildren = [];
	
	      _react2['default'].Children.forEach(children, function (child) {
	        if (!child) {
	          return;
	        }
	        var key = child.key;
	        var active = activeKey === key;
	        newChildren.push(_react2['default'].cloneElement(child, {
	          active: active,
	          destroyInactiveTabPane: props.destroyInactiveTabPane,
	          rootPrefixCls: props.prefixCls
	        }));
	      });
	
	      return newChildren;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var props = this.props;
	      var prefixCls = props.prefixCls,
	          children = props.children,
	          activeKey = props.activeKey,
	          className = props.className,
	          tabBarPosition = props.tabBarPosition,
	          animated = props.animated,
	          animatedWithMargin = props.animatedWithMargin,
	          direction = props.direction;
	      var style = props.style;
	
	      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-content', true), (0, _defineProperty3['default'])(_classnames, animated ? prefixCls + '-content-animated' : prefixCls + '-content-no-animated', true), _classnames), className);
	      if (animated) {
	        var activeIndex = (0, _utils.getActiveIndex)(children, activeKey);
	        if (activeIndex !== -1) {
	          var animatedStyle = animatedWithMargin ? (0, _utils.getMarginStyle)(activeIndex, tabBarPosition) : (0, _utils.getTransformPropValue)((0, _utils.getTransformByIndex)(activeIndex, tabBarPosition, direction));
	          style = (0, _extends3['default'])({}, style, animatedStyle);
	        } else {
	          style = (0, _extends3['default'])({}, style, {
	            display: 'none'
	          });
	        }
	      }
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: classes,
	          style: style
	        },
	        this.getTabPanes()
	      );
	    }
	  }]);
	  return TabContent;
	}(_react2['default'].Component);
	
	exports['default'] = TabContent;
	
	
	TabContent.propTypes = {
	  animated: _propTypes2['default'].bool,
	  animatedWithMargin: _propTypes2['default'].bool,
	  prefixCls: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  activeKey: _propTypes2['default'].string,
	  style: _propTypes2['default'].any,
	  tabBarPosition: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  destroyInactiveTabPane: _propTypes2['default'].bool,
	  direction: _propTypes2['default'].string
	};
	
	TabContent.defaultProps = {
	  animated: true
	};
	module.exports = exports['default'];

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _utils = __webpack_require__(220);
	
	var _Sentinel = __webpack_require__(1106);
	
	var _Sentinel2 = _interopRequireDefault(_Sentinel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabPane = function (_React$Component) {
	  (0, _inherits3['default'])(TabPane, _React$Component);
	
	  function TabPane() {
	    (0, _classCallCheck3['default'])(this, TabPane);
	    return (0, _possibleConstructorReturn3['default'])(this, (TabPane.__proto__ || Object.getPrototypeOf(TabPane)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(TabPane, [{
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          id = _props.id,
	          className = _props.className,
	          destroyInactiveTabPane = _props.destroyInactiveTabPane,
	          active = _props.active,
	          forceRender = _props.forceRender,
	          rootPrefixCls = _props.rootPrefixCls,
	          style = _props.style,
	          children = _props.children,
	          placeholder = _props.placeholder,
	          restProps = (0, _objectWithoutProperties3['default'])(_props, ['id', 'className', 'destroyInactiveTabPane', 'active', 'forceRender', 'rootPrefixCls', 'style', 'children', 'placeholder']);
	
	      this._isActived = this._isActived || active;
	      var prefixCls = rootPrefixCls + '-tabpane';
	      var cls = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls, 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-inactive', !active), (0, _defineProperty3['default'])(_classnames, prefixCls + '-active', active), (0, _defineProperty3['default'])(_classnames, className, className), _classnames));
	      var isRender = destroyInactiveTabPane ? active : this._isActived;
	      var shouldRender = isRender || forceRender;
	
	      return _react2['default'].createElement(
	        _Sentinel.SentinelConsumer,
	        null,
	        function (_ref) {
	          var sentinelStart = _ref.sentinelStart,
	              sentinelEnd = _ref.sentinelEnd,
	              setPanelSentinelStart = _ref.setPanelSentinelStart,
	              setPanelSentinelEnd = _ref.setPanelSentinelEnd;
	
	          // Create sentinel
	          var panelSentinelStart = void 0;
	          var panelSentinelEnd = void 0;
	          if (active && shouldRender) {
	            panelSentinelStart = _react2['default'].createElement(_Sentinel2['default'], {
	              setRef: setPanelSentinelStart,
	              prevElement: sentinelStart
	            });
	            panelSentinelEnd = _react2['default'].createElement(_Sentinel2['default'], {
	              setRef: setPanelSentinelEnd,
	              nextElement: sentinelEnd
	            });
	          }
	
	          return _react2['default'].createElement(
	            'div',
	            (0, _extends3['default'])({
	              style: style,
	              role: 'tabpanel',
	              'aria-hidden': active ? 'false' : 'true',
	              className: cls,
	              id: id
	            }, (0, _utils.getDataAttr)(restProps)),
	            panelSentinelStart,
	            shouldRender ? children : placeholder,
	            panelSentinelEnd
	          );
	        }
	      );
	    }
	  }]);
	  return TabPane;
	}(_react2['default'].Component);
	
	exports['default'] = TabPane;
	
	
	TabPane.propTypes = {
	  className: _propTypes2['default'].string,
	  active: _propTypes2['default'].bool,
	  style: _propTypes2['default'].any,
	  destroyInactiveTabPane: _propTypes2['default'].bool,
	  forceRender: _propTypes2['default'].bool,
	  placeholder: _propTypes2['default'].node,
	  rootPrefixCls: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  id: _propTypes2['default'].string
	};
	
	TabPane.defaultProps = {
	  placeholder: null
	};
	module.exports = exports['default'];

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _moment = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _Header = _interopRequireDefault(__webpack_require__(2745));
	
	var _Combobox = _interopRequireDefault(__webpack_require__(2744));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function noop() {}
	
	function generateOptions(length, disabledOptions, hideDisabledOptions) {
	  var step = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
	  var arr = [];
	
	  for (var value = 0; value < length; value += step) {
	    if (!disabledOptions || disabledOptions.indexOf(value) < 0 || !hideDisabledOptions) {
	      arr.push(value);
	    }
	  }
	
	  return arr;
	}
	
	function toNearestValidTime(time, hourOptions, minuteOptions, secondOptions) {
	  var hour = hourOptions.slice().sort(function (a, b) {
	    return Math.abs(time.hour() - a) - Math.abs(time.hour() - b);
	  })[0];
	  var minute = minuteOptions.slice().sort(function (a, b) {
	    return Math.abs(time.minute() - a) - Math.abs(time.minute() - b);
	  })[0];
	  var second = secondOptions.slice().sort(function (a, b) {
	    return Math.abs(time.second() - a) - Math.abs(time.second() - b);
	  })[0];
	  return (0, _moment["default"])("".concat(hour, ":").concat(minute, ":").concat(second), 'HH:mm:ss');
	}
	
	var Panel =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Panel, _Component);
	
	  function Panel() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Panel);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Panel)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {});
	
	    _defineProperty(_assertThisInitialized(_this), "onChange", function (newValue) {
	      var onChange = _this.props.onChange;
	
	      _this.setState({
	        value: newValue
	      });
	
	      onChange(newValue);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
	      var onAmPmChange = _this.props.onAmPmChange;
	      onAmPmChange(ampm);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onCurrentSelectPanelChange", function (currentSelectPanel) {
	      _this.setState({
	        currentSelectPanel: currentSelectPanel
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "disabledHours", function () {
	      var _this$props = _this.props,
	          use12Hours = _this$props.use12Hours,
	          disabledHours = _this$props.disabledHours;
	      var disabledOptions = disabledHours();
	
	      if (use12Hours && Array.isArray(disabledOptions)) {
	        if (_this.isAM()) {
	          disabledOptions = disabledOptions.filter(function (h) {
	            return h < 12;
	          }).map(function (h) {
	            return h === 0 ? 12 : h;
	          });
	        } else {
	          disabledOptions = disabledOptions.map(function (h) {
	            return h === 12 ? 12 : h - 12;
	          });
	        }
	      }
	
	      return disabledOptions;
	    });
	
	    return _this;
	  }
	
	  _createClass(Panel, [{
	    key: "close",
	    // https://github.com/ant-design/ant-design/issues/5829
	    value: function close() {
	      var onEsc = this.props.onEsc;
	      onEsc();
	    }
	  }, {
	    key: "isAM",
	    value: function isAM() {
	      var defaultOpenValue = this.props.defaultOpenValue;
	      var value = this.state.value;
	      var realValue = value || defaultOpenValue;
	      return realValue.hour() >= 0 && realValue.hour() < 12;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          placeholder = _this$props2.placeholder,
	          disabledMinutes = _this$props2.disabledMinutes,
	          disabledSeconds = _this$props2.disabledSeconds,
	          hideDisabledOptions = _this$props2.hideDisabledOptions,
	          showHour = _this$props2.showHour,
	          showMinute = _this$props2.showMinute,
	          showSecond = _this$props2.showSecond,
	          format = _this$props2.format,
	          defaultOpenValue = _this$props2.defaultOpenValue,
	          clearText = _this$props2.clearText,
	          onEsc = _this$props2.onEsc,
	          addon = _this$props2.addon,
	          use12Hours = _this$props2.use12Hours,
	          focusOnOpen = _this$props2.focusOnOpen,
	          onKeyDown = _this$props2.onKeyDown,
	          hourStep = _this$props2.hourStep,
	          minuteStep = _this$props2.minuteStep,
	          secondStep = _this$props2.secondStep,
	          inputReadOnly = _this$props2.inputReadOnly,
	          clearIcon = _this$props2.clearIcon;
	      var _this$state = this.state,
	          value = _this$state.value,
	          currentSelectPanel = _this$state.currentSelectPanel;
	      var disabledHourOptions = this.disabledHours();
	      var disabledMinuteOptions = disabledMinutes(value ? value.hour() : null);
	      var disabledSecondOptions = disabledSeconds(value ? value.hour() : null, value ? value.minute() : null);
	      var hourOptions = generateOptions(24, disabledHourOptions, hideDisabledOptions, hourStep);
	      var minuteOptions = generateOptions(60, disabledMinuteOptions, hideDisabledOptions, minuteStep);
	      var secondOptions = generateOptions(60, disabledSecondOptions, hideDisabledOptions, secondStep);
	      var validDefaultOpenValue = toNearestValidTime(defaultOpenValue, hourOptions, minuteOptions, secondOptions);
	      return _react["default"].createElement("div", {
	        className: (0, _classnames["default"])(className, "".concat(prefixCls, "-inner"))
	      }, _react["default"].createElement(_Header["default"], {
	        clearText: clearText,
	        prefixCls: prefixCls,
	        defaultOpenValue: validDefaultOpenValue,
	        value: value,
	        currentSelectPanel: currentSelectPanel,
	        onEsc: onEsc,
	        format: format,
	        placeholder: placeholder,
	        hourOptions: hourOptions,
	        minuteOptions: minuteOptions,
	        secondOptions: secondOptions,
	        disabledHours: this.disabledHours,
	        disabledMinutes: disabledMinutes,
	        disabledSeconds: disabledSeconds,
	        onChange: this.onChange,
	        focusOnOpen: focusOnOpen,
	        onKeyDown: onKeyDown,
	        inputReadOnly: inputReadOnly,
	        clearIcon: clearIcon
	      }), _react["default"].createElement(_Combobox["default"], {
	        prefixCls: prefixCls,
	        value: value,
	        defaultOpenValue: validDefaultOpenValue,
	        format: format,
	        onChange: this.onChange,
	        onAmPmChange: this.onAmPmChange,
	        showHour: showHour,
	        showMinute: showMinute,
	        showSecond: showSecond,
	        hourOptions: hourOptions,
	        minuteOptions: minuteOptions,
	        secondOptions: secondOptions,
	        disabledHours: this.disabledHours,
	        disabledMinutes: disabledMinutes,
	        disabledSeconds: disabledSeconds,
	        onCurrentSelectPanelChange: this.onCurrentSelectPanelChange,
	        use12Hours: use12Hours,
	        onEsc: onEsc,
	        isAM: this.isAM()
	      }), addon(this));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, state) {
	      if ('value' in props) {
	        return _objectSpread({}, state, {
	          value: props.value
	        });
	      }
	
	      return null;
	    }
	  }]);
	
	  return Panel;
	}(_react.Component);
	
	_defineProperty(Panel, "propTypes", {
	  clearText: _propTypes["default"].string,
	  prefixCls: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  defaultOpenValue: _propTypes["default"].object,
	  value: _propTypes["default"].object,
	  placeholder: _propTypes["default"].string,
	  format: _propTypes["default"].string,
	  inputReadOnly: _propTypes["default"].bool,
	  disabledHours: _propTypes["default"].func,
	  disabledMinutes: _propTypes["default"].func,
	  disabledSeconds: _propTypes["default"].func,
	  hideDisabledOptions: _propTypes["default"].bool,
	  onChange: _propTypes["default"].func,
	  onAmPmChange: _propTypes["default"].func,
	  onEsc: _propTypes["default"].func,
	  showHour: _propTypes["default"].bool,
	  showMinute: _propTypes["default"].bool,
	  showSecond: _propTypes["default"].bool,
	  use12Hours: _propTypes["default"].bool,
	  hourStep: _propTypes["default"].number,
	  minuteStep: _propTypes["default"].number,
	  secondStep: _propTypes["default"].number,
	  addon: _propTypes["default"].func,
	  focusOnOpen: _propTypes["default"].bool,
	  onKeyDown: _propTypes["default"].func,
	  clearIcon: _propTypes["default"].node
	});
	
	_defineProperty(Panel, "defaultProps", {
	  prefixCls: 'rc-time-picker-panel',
	  onChange: noop,
	  disabledHours: noop,
	  disabledMinutes: noop,
	  disabledSeconds: noop,
	  defaultOpenValue: (0, _moment["default"])(),
	  use12Hours: false,
	  addon: noop,
	  onKeyDown: noop,
	  onAmPmChange: noop,
	  inputReadOnly: false
	});
	
	(0, _reactLifecyclesCompat.polyfill)(Panel);
	var _default = Panel;
	exports["default"] = _default;

/***/ },
/* 1110 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  left: {
	    points: ['cr', 'cl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  right: {
	    points: ['cl', 'cr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  top: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottom: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  rightBottom: {
	    points: ['bl', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  leftBottom: {
	    points: ['br', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.searchContextTypes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _util = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var searchContextTypes = {
	  onSearchInputChange: _propTypes["default"].func.isRequired
	};
	exports.searchContextTypes = searchContextTypes;
	
	var SearchInput =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(SearchInput, _React$Component);
	
	  function SearchInput() {
	    var _this;
	
	    _classCallCheck(this, SearchInput);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SearchInput).call(this));
	
	    _defineProperty(_assertThisInitialized(_this), "alignInputWidth", function () {
	      _this.inputRef.current.style.width = "".concat(_this.mirrorInputRef.current.clientWidth, "px");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "focus", function (isDidMount) {
	      if (_this.inputRef.current) {
	        _this.inputRef.current.focus();
	
	        if (isDidMount) {
	          setTimeout(function () {
	            _this.inputRef.current.focus();
	          }, 0);
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "blur", function () {
	      if (_this.inputRef.current) {
	        _this.inputRef.current.blur();
	      }
	    });
	
	    _this.inputRef = (0, _util.createRef)();
	    _this.mirrorInputRef = (0, _util.createRef)();
	    return _this;
	  }
	
	  _createClass(SearchInput, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          open = _this$props.open,
	          needAlign = _this$props.needAlign;
	
	      if (needAlign) {
	        this.alignInputWidth();
	      }
	
	      if (open) {
	        this.focus(true);
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props2 = this.props,
	          open = _this$props2.open,
	          searchValue = _this$props2.searchValue,
	          needAlign = _this$props2.needAlign;
	
	      if (open && prevProps.open !== open) {
	        this.focus();
	      }
	
	      if (needAlign && searchValue !== prevProps.searchValue) {
	        this.alignInputWidth();
	      }
	    }
	    /**
	     * `scrollWidth` is not correct in IE, do the workaround.
	     * ref: https://github.com/react-component/tree-select/issues/65
	     */
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          searchValue = _this$props3.searchValue,
	          prefixCls = _this$props3.prefixCls,
	          disabled = _this$props3.disabled,
	          renderPlaceholder = _this$props3.renderPlaceholder,
	          open = _this$props3.open,
	          ariaId = _this$props3.ariaId;
	      var _this$context$rcTreeS = this.context.rcTreeSelect,
	          onSearchInputChange = _this$context$rcTreeS.onSearchInputChange,
	          onSearchInputKeyDown = _this$context$rcTreeS.onSearchInputKeyDown;
	      return _react["default"].createElement("span", {
	        className: "".concat(prefixCls, "-search__field__wrap")
	      }, _react["default"].createElement("input", {
	        type: "text",
	        ref: this.inputRef,
	        onChange: onSearchInputChange,
	        onKeyDown: onSearchInputKeyDown,
	        value: searchValue,
	        disabled: disabled,
	        className: "".concat(prefixCls, "-search__field"),
	        "aria-label": "filter select",
	        "aria-autocomplete": "list",
	        "aria-controls": open ? ariaId : undefined,
	        "aria-multiline": "false"
	      }), _react["default"].createElement("span", {
	        ref: this.mirrorInputRef,
	        className: "".concat(prefixCls, "-search__field__mirror")
	      }, searchValue, "\xA0"), renderPlaceholder ? renderPlaceholder() : null);
	    }
	  }]);
	
	  return SearchInput;
	}(_react["default"].Component);
	
	_defineProperty(SearchInput, "propTypes", {
	  open: _propTypes["default"].bool,
	  searchValue: _propTypes["default"].string,
	  prefixCls: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  renderPlaceholder: _propTypes["default"].func,
	  needAlign: _propTypes["default"].bool,
	  ariaId: _propTypes["default"].string
	});
	
	_defineProperty(SearchInput, "contextTypes", {
	  rcTreeSelect: _propTypes["default"].shape(_objectSpread({}, searchContextTypes))
	});
	
	(0, _reactLifecyclesCompat.polyfill)(SearchInput);
	var _default = SearchInput;
	exports["default"] = _default;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _rcTree = __webpack_require__(566);
	
	var _propTypes = __webpack_require__(1113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * SelectNode wrapped the tree node.
	 * Let's use SelectNode instead of TreeNode
	 * since TreeNode is so confuse here.
	 */
	var SelectNode = function SelectNode(props) {
	  return _react["default"].createElement(_rcTree.TreeNode, props);
	};
	
	SelectNode.propTypes = _objectSpread({}, _rcTree.TreeNode.propTypes, {
	  value: _propTypes.valueProp
	}); // Let Tree trade as TreeNode to reuse this for performance saving.
	
	SelectNode.isTreeNode = 1;
	var _default = SelectNode;
	exports["default"] = _default;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.genArrProps = genArrProps;
	exports.valueProp = valueProp;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _util = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var internalValProp = _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]);
	
	function genArrProps(propType) {
	  return _propTypes["default"].oneOfType([propType, _propTypes["default"].arrayOf(propType)]);
	}
	/**
	 * Origin code check `multiple` is true when `treeCheckStrictly` & `labelInValue`.
	 * But in process logic is already cover to array.
	 * Check array is not necessary. Let's simplify this check logic.
	 */
	
	
	function valueProp() {
	  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	    args[_key] = arguments[_key];
	  }
	
	  var props = args[0],
	      propName = args[1],
	      Component = args[2];
	
	  if ((0, _util.isLabelInValue)(props)) {
	    var _err = genArrProps(_propTypes["default"].shape({
	      label: _propTypes["default"].node,
	      value: internalValProp
	    })).apply(void 0, args);
	
	    if (_err) {
	      return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(Component, "`. ") + "You should use { label: string, value: string | number } or [{ label: string, value: string | number }] instead.");
	    }
	
	    return null;
	  }
	
	  var err = genArrProps(internalValProp).apply(void 0, args);
	
	  if (err) {
	    return new Error("Invalid prop `".concat(propName, "` supplied to `").concat(Component, "`. ") + "You should use string or [string] instead.");
	  }
	
	  return null;
	}

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var LazyRenderBox = function (_Component) {
	  (0, _inherits3['default'])(LazyRenderBox, _Component);
	
	  function LazyRenderBox() {
	    (0, _classCallCheck3['default'])(this, LazyRenderBox);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return nextProps.hiddenClassName || nextProps.visible;
	  };
	
	  LazyRenderBox.prototype.render = function render() {
	    var _props = this.props,
	        hiddenClassName = _props.hiddenClassName,
	        visible = _props.visible,
	        props = (0, _objectWithoutProperties3['default'])(_props, ['hiddenClassName', 'visible']);
	
	
	    if (hiddenClassName || _react2['default'].Children.count(props.children) > 1) {
	      if (!visible && hiddenClassName) {
	        props.className += ' ' + hiddenClassName;
	      }
	      return _react2['default'].createElement('div', props);
	    }
	
	    return _react2['default'].Children.only(props.children);
	  };
	
	  return LazyRenderBox;
	}(_react.Component);
	
	LazyRenderBox.propTypes = {
	  children: _propTypes2['default'].any,
	  className: _propTypes2['default'].string,
	  visible: _propTypes2['default'].bool,
	  hiddenClassName: _propTypes2['default'].string
	};
	exports['default'] = LazyRenderBox;
	module.exports = exports['default'];

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.getAlignFromPlacement = getAlignFromPlacement;
	exports.getAlignPopupClassName = getAlignPopupClassName;
	exports.saveRef = saveRef;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isPointsEq(a1, a2, isAlignPoint) {
	  if (isAlignPoint) {
	    return a1[0] === a2[0];
	  }
	  return a1[0] === a2[0] && a1[1] === a2[1];
	}
	
	function getAlignFromPlacement(builtinPlacements, placementStr, align) {
	  var baseAlign = builtinPlacements[placementStr] || {};
	  return (0, _extends3['default'])({}, baseAlign, align);
	}
	
	function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
	  var points = align.points;
	  for (var placement in builtinPlacements) {
	    if (builtinPlacements.hasOwnProperty(placement)) {
	      if (isPointsEq(builtinPlacements[placement].points, points, isAlignPoint)) {
	        return prefixCls + '-placement-' + placement;
	      }
	    }
	  }
	  return '';
	}
	
	function saveRef(name, component) {
	  this[name] = component;
	}

/***/ },
/* 1116 */
1070,
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.InternalTreeNode = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _CSSMotion = _interopRequireDefault(__webpack_require__(553));
	
	var _toArray = _interopRequireDefault(__webpack_require__(112));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _contextTypes = __webpack_require__(1118);
	
	var _util = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ICON_OPEN = 'open';
	var ICON_CLOSE = 'close';
	var defaultTitle = '---';
	
	var TreeNode = /*#__PURE__*/function (_React$Component) {
	  _inherits(TreeNode, _React$Component);
	
	  var _super = _createSuper(TreeNode);
	
	  function TreeNode() {
	    var _this;
	
	    _classCallCheck(this, TreeNode);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      dragNodeHighlight: false
	    };
	
	    _this.onSelectorClick = function (e) {
	      // Click trigger before select/check operation
	      var onNodeClick = _this.props.context.onNodeClick;
	      onNodeClick(e, _assertThisInitialized(_this));
	
	      if (_this.isSelectable()) {
	        _this.onSelect(e);
	      } else {
	        _this.onCheck(e);
	      }
	    };
	
	    _this.onSelectorDoubleClick = function (e) {
	      var onNodeDoubleClick = _this.props.context.onNodeDoubleClick;
	      onNodeDoubleClick(e, _assertThisInitialized(_this));
	    };
	
	    _this.onSelect = function (e) {
	      if (_this.isDisabled()) return;
	      var onNodeSelect = _this.props.context.onNodeSelect;
	      e.preventDefault();
	      onNodeSelect(e, _assertThisInitialized(_this));
	    };
	
	    _this.onCheck = function (e) {
	      if (_this.isDisabled()) return;
	      var _this$props = _this.props,
	          disableCheckbox = _this$props.disableCheckbox,
	          checked = _this$props.checked;
	      var onNodeCheck = _this.props.context.onNodeCheck;
	      if (!_this.isCheckable() || disableCheckbox) return;
	      e.preventDefault();
	      var targetChecked = !checked;
	      onNodeCheck(e, _assertThisInitialized(_this), targetChecked);
	    };
	
	    _this.onMouseEnter = function (e) {
	      var onNodeMouseEnter = _this.props.context.onNodeMouseEnter;
	      onNodeMouseEnter(e, _assertThisInitialized(_this));
	    };
	
	    _this.onMouseLeave = function (e) {
	      var onNodeMouseLeave = _this.props.context.onNodeMouseLeave;
	      onNodeMouseLeave(e, _assertThisInitialized(_this));
	    };
	
	    _this.onContextMenu = function (e) {
	      var onNodeContextMenu = _this.props.context.onNodeContextMenu;
	      onNodeContextMenu(e, _assertThisInitialized(_this));
	    };
	
	    _this.onDragStart = function (e) {
	      var onNodeDragStart = _this.props.context.onNodeDragStart;
	      e.stopPropagation();
	
	      _this.setState({
	        dragNodeHighlight: true
	      });
	
	      onNodeDragStart(e, _assertThisInitialized(_this));
	
	      try {
	        // ie throw error
	        // firefox-need-it
	        e.dataTransfer.setData('text/plain', '');
	      } catch (error) {// empty
	      }
	    };
	
	    _this.onDragEnter = function (e) {
	      var onNodeDragEnter = _this.props.context.onNodeDragEnter;
	      e.preventDefault();
	      e.stopPropagation();
	      onNodeDragEnter(e, _assertThisInitialized(_this));
	    };
	
	    _this.onDragOver = function (e) {
	      var onNodeDragOver = _this.props.context.onNodeDragOver;
	      e.preventDefault();
	      e.stopPropagation();
	      onNodeDragOver(e, _assertThisInitialized(_this));
	    };
	
	    _this.onDragLeave = function (e) {
	      var onNodeDragLeave = _this.props.context.onNodeDragLeave;
	      e.stopPropagation();
	      onNodeDragLeave(e, _assertThisInitialized(_this));
	    };
	
	    _this.onDragEnd = function (e) {
	      var onNodeDragEnd = _this.props.context.onNodeDragEnd;
	      e.stopPropagation();
	
	      _this.setState({
	        dragNodeHighlight: false
	      });
	
	      onNodeDragEnd(e, _assertThisInitialized(_this));
	    };
	
	    _this.onDrop = function (e) {
	      var onNodeDrop = _this.props.context.onNodeDrop;
	      e.preventDefault();
	      e.stopPropagation();
	
	      _this.setState({
	        dragNodeHighlight: false
	      });
	
	      onNodeDrop(e, _assertThisInitialized(_this));
	    }; // Disabled item still can be switch
	
	
	    _this.onExpand = function (e) {
	      var onNodeExpand = _this.props.context.onNodeExpand;
	      onNodeExpand(e, _assertThisInitialized(_this));
	    }; // Drag usage
	
	
	    _this.setSelectHandle = function (node) {
	      _this.selectHandle = node;
	    };
	
	    _this.getNodeChildren = function () {
	      var children = _this.props.children;
	      var originList = (0, _toArray.default)(children).filter(function (node) {
	        return node;
	      });
	      var targetList = (0, _util.getNodeChildren)(originList);
	
	      if (originList.length !== targetList.length) {
	        (0, _util.warnOnlyTreeNode)();
	      }
	
	      return targetList;
	    };
	
	    _this.getNodeState = function () {
	      var expanded = _this.props.expanded;
	
	      if (_this.isLeaf()) {
	        return null;
	      }
	
	      return expanded ? ICON_OPEN : ICON_CLOSE;
	    };
	
	    _this.isLeaf = function () {
	      var _this$props2 = _this.props,
	          isLeaf = _this$props2.isLeaf,
	          loaded = _this$props2.loaded;
	      var loadData = _this.props.context.loadData;
	      var hasChildren = _this.getNodeChildren().length !== 0;
	
	      if (isLeaf === false) {
	        return false;
	      }
	
	      return isLeaf || !loadData && !hasChildren || loadData && loaded && !hasChildren;
	    };
	
	    _this.isDisabled = function () {
	      var disabled = _this.props.disabled;
	      var treeDisabled = _this.props.context.disabled; // Follow the logic of Selectable
	
	      if (disabled === false) {
	        return false;
	      }
	
	      return !!(treeDisabled || disabled);
	    };
	
	    _this.isCheckable = function () {
	      var checkable = _this.props.checkable;
	      var treeCheckable = _this.props.context.checkable; // Return false if tree or treeNode is not checkable
	
	      if (!treeCheckable || checkable === false) return false;
	      return treeCheckable;
	    }; // Load data to avoid default expanded tree without data
	
	
	    _this.syncLoadData = function (props) {
	      var expanded = props.expanded,
	          loading = props.loading,
	          loaded = props.loaded;
	      var _this$props$context = _this.props.context,
	          loadData = _this$props$context.loadData,
	          onNodeLoad = _this$props$context.onNodeLoad;
	      if (loading) return; // read from state to avoid loadData at same time
	
	      if (loadData && expanded && !_this.isLeaf()) {
	        // We needn't reload data when has children in sync logic
	        // It's only needed in node expanded
	        var hasChildren = _this.getNodeChildren().length !== 0;
	
	        if (!hasChildren && !loaded) {
	          onNodeLoad(_assertThisInitialized(_this));
	        }
	      }
	    }; // Switcher
	
	
	    _this.renderSwitcher = function () {
	      var _this$props3 = _this.props,
	          expanded = _this$props3.expanded,
	          switcherIconFromProps = _this$props3.switcherIcon;
	      var _this$props$context2 = _this.props.context,
	          prefixCls = _this$props$context2.prefixCls,
	          switcherIconFromCtx = _this$props$context2.switcherIcon;
	      var switcherIcon = switcherIconFromProps || switcherIconFromCtx;
	
	      if (_this.isLeaf()) {
	        return React.createElement("span", {
	          className: (0, _classnames.default)("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher-noop"))
	        }, typeof switcherIcon === 'function' ? switcherIcon(_objectSpread({}, _this.props, {
	          isLeaf: true
	        })) : switcherIcon);
	      }
	
	      var switcherCls = (0, _classnames.default)("".concat(prefixCls, "-switcher"), "".concat(prefixCls, "-switcher_").concat(expanded ? ICON_OPEN : ICON_CLOSE));
	      return React.createElement("span", {
	        onClick: _this.onExpand,
	        className: switcherCls
	      }, typeof switcherIcon === 'function' ? switcherIcon(_objectSpread({}, _this.props, {
	        isLeaf: false
	      })) : switcherIcon);
	    }; // Checkbox
	
	
	    _this.renderCheckbox = function () {
	      var _this$props4 = _this.props,
	          checked = _this$props4.checked,
	          halfChecked = _this$props4.halfChecked,
	          disableCheckbox = _this$props4.disableCheckbox;
	      var prefixCls = _this.props.context.prefixCls;
	
	      var disabled = _this.isDisabled();
	
	      var checkable = _this.isCheckable();
	
	      if (!checkable) return null; // [Legacy] Custom element should be separate with `checkable` in future
	
	      var $custom = typeof checkable !== 'boolean' ? checkable : null;
	      return React.createElement("span", {
	        className: (0, _classnames.default)("".concat(prefixCls, "-checkbox"), checked && "".concat(prefixCls, "-checkbox-checked"), !checked && halfChecked && "".concat(prefixCls, "-checkbox-indeterminate"), (disabled || disableCheckbox) && "".concat(prefixCls, "-checkbox-disabled")),
	        onClick: _this.onCheck
	      }, $custom);
	    };
	
	    _this.renderIcon = function () {
	      var loading = _this.props.loading;
	      var prefixCls = _this.props.context.prefixCls;
	      return React.createElement("span", {
	        className: (0, _classnames.default)("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__").concat(_this.getNodeState() || 'docu'), loading && "".concat(prefixCls, "-icon_loading"))
	      });
	    }; // Icon + Title
	
	
	    _this.renderSelector = function () {
	      var dragNodeHighlight = _this.state.dragNodeHighlight;
	      var _this$props5 = _this.props,
	          title = _this$props5.title,
	          selected = _this$props5.selected,
	          icon = _this$props5.icon,
	          loading = _this$props5.loading;
	      var _this$props$context3 = _this.props.context,
	          prefixCls = _this$props$context3.prefixCls,
	          showIcon = _this$props$context3.showIcon,
	          treeIcon = _this$props$context3.icon,
	          draggable = _this$props$context3.draggable,
	          loadData = _this$props$context3.loadData;
	
	      var disabled = _this.isDisabled();
	
	      var wrapClass = "".concat(prefixCls, "-node-content-wrapper"); // Icon - Still show loading icon when loading without showIcon
	
	      var $icon;
	
	      if (showIcon) {
	        var currentIcon = icon || treeIcon;
	        $icon = currentIcon ? React.createElement("span", {
	          className: (0, _classnames.default)("".concat(prefixCls, "-iconEle"), "".concat(prefixCls, "-icon__customize"))
	        }, typeof currentIcon === 'function' ? currentIcon(_this.props) : currentIcon) : _this.renderIcon();
	      } else if (loadData && loading) {
	        $icon = _this.renderIcon();
	      } // Title
	
	
	      var $title = React.createElement("span", {
	        className: "".concat(prefixCls, "-title")
	      }, title);
	      return React.createElement("span", {
	        ref: _this.setSelectHandle,
	        title: typeof title === 'string' ? title : '',
	        className: (0, _classnames.default)("".concat(wrapClass), "".concat(wrapClass, "-").concat(_this.getNodeState() || 'normal'), !disabled && (selected || dragNodeHighlight) && "".concat(prefixCls, "-node-selected"), !disabled && draggable && 'draggable'),
	        draggable: !disabled && draggable || undefined,
	        "aria-grabbed": !disabled && draggable || undefined,
	        onMouseEnter: _this.onMouseEnter,
	        onMouseLeave: _this.onMouseLeave,
	        onContextMenu: _this.onContextMenu,
	        onClick: _this.onSelectorClick,
	        onDoubleClick: _this.onSelectorDoubleClick,
	        onDragStart: draggable ? _this.onDragStart : undefined
	      }, $icon, $title);
	    }; // Children list wrapped with `Animation`
	
	
	    _this.renderChildren = function () {
	      var _this$props6 = _this.props,
	          expanded = _this$props6.expanded,
	          pos = _this$props6.pos;
	      var _this$props$context4 = _this.props.context,
	          prefixCls = _this$props$context4.prefixCls,
	          motion = _this$props$context4.motion,
	          renderTreeNode = _this$props$context4.renderTreeNode; // Children TreeNode
	
	      var nodeList = _this.getNodeChildren();
	
	      if (nodeList.length === 0) {
	        return null;
	      }
	
	      return React.createElement(_CSSMotion.default, Object.assign({
	        visible: expanded
	      }, motion), function (_ref) {
	        var style = _ref.style,
	            className = _ref.className;
	        return React.createElement("ul", {
	          className: (0, _classnames.default)(className, "".concat(prefixCls, "-child-tree"), expanded && "".concat(prefixCls, "-child-tree-open")),
	          style: style,
	          "data-expanded": expanded,
	          role: "group"
	        }, (0, _util.mapChildren)(nodeList, function (node, index) {
	          return renderTreeNode(node, index, pos);
	        }));
	      });
	    };
	
	    return _this;
	  } // Isomorphic needn't load data in server side
	
	
	  _createClass(TreeNode, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props7 = this.props,
	          eventKey = _this$props7.eventKey,
	          registerTreeNode = _this$props7.context.registerTreeNode;
	      this.syncLoadData(this.props);
	      registerTreeNode(eventKey, this);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.syncLoadData(this.props);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this$props8 = this.props,
	          eventKey = _this$props8.eventKey,
	          registerTreeNode = _this$props8.context.registerTreeNode;
	      registerTreeNode(eventKey, null);
	    }
	  }, {
	    key: "isSelectable",
	    value: function isSelectable() {
	      var selectable = this.props.selectable;
	      var treeSelectable = this.props.context.selectable; // Ignore when selectable is undefined or null
	
	      if (typeof selectable === 'boolean') {
	        return selectable;
	      }
	
	      return treeSelectable;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var loading = this.props.loading;
	
	      var _this$props9 = this.props,
	          className = _this$props9.className,
	          style = _this$props9.style,
	          dragOver = _this$props9.dragOver,
	          dragOverGapTop = _this$props9.dragOverGapTop,
	          dragOverGapBottom = _this$props9.dragOverGapBottom,
	          isLeaf = _this$props9.isLeaf,
	          expanded = _this$props9.expanded,
	          selected = _this$props9.selected,
	          checked = _this$props9.checked,
	          halfChecked = _this$props9.halfChecked,
	          otherProps = _objectWithoutProperties(_this$props9, ["className", "style", "dragOver", "dragOverGapTop", "dragOverGapBottom", "isLeaf", "expanded", "selected", "checked", "halfChecked"]);
	
	      var _this$props$context5 = this.props.context,
	          prefixCls = _this$props$context5.prefixCls,
	          filterTreeNode = _this$props$context5.filterTreeNode,
	          draggable = _this$props$context5.draggable;
	      var disabled = this.isDisabled();
	      var dataOrAriaAttributeProps = (0, _util.getDataAndAria)(otherProps);
	      return React.createElement("li", Object.assign({
	        className: (0, _classnames.default)(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-treenode-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-switcher-").concat(expanded ? 'open' : 'close'), !isLeaf), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-checkbox-checked"), checked), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-checkbox-indeterminate"), halfChecked), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-selected"), selected), _defineProperty(_classNames, "".concat(prefixCls, "-treenode-loading"), loading), _defineProperty(_classNames, 'drag-over', !disabled && dragOver), _defineProperty(_classNames, 'drag-over-gap-top', !disabled && dragOverGapTop), _defineProperty(_classNames, 'drag-over-gap-bottom', !disabled && dragOverGapBottom), _defineProperty(_classNames, 'filter-node', filterTreeNode && filterTreeNode(this)), _classNames)),
	        style: style,
	        role: "treeitem",
	        onDragEnter: draggable ? this.onDragEnter : undefined,
	        onDragOver: draggable ? this.onDragOver : undefined,
	        onDragLeave: draggable ? this.onDragLeave : undefined,
	        onDrop: draggable ? this.onDrop : undefined,
	        onDragEnd: draggable ? this.onDragEnd : undefined
	      }, dataOrAriaAttributeProps), this.renderSwitcher(), this.renderCheckbox(), this.renderSelector(), this.renderChildren());
	    }
	  }]);
	
	  return TreeNode;
	}(React.Component);
	
	exports.InternalTreeNode = TreeNode;
	TreeNode.propTypes = {
	  eventKey: _propTypes.default.string,
	  prefixCls: _propTypes.default.string,
	  className: _propTypes.default.string,
	  style: _propTypes.default.object,
	  onSelect: _propTypes.default.func,
	  // By parent
	  expanded: _propTypes.default.bool,
	  selected: _propTypes.default.bool,
	  checked: _propTypes.default.bool,
	  loaded: _propTypes.default.bool,
	  loading: _propTypes.default.bool,
	  halfChecked: _propTypes.default.bool,
	  children: _propTypes.default.node,
	  title: _propTypes.default.node,
	  pos: _propTypes.default.string,
	  dragOver: _propTypes.default.bool,
	  dragOverGapTop: _propTypes.default.bool,
	  dragOverGapBottom: _propTypes.default.bool,
	  // By user
	  isLeaf: _propTypes.default.bool,
	  checkable: _propTypes.default.bool,
	  selectable: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  disableCheckbox: _propTypes.default.bool,
	  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  switcherIcon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func])
	};
	(0, _reactLifecyclesCompat.polyfill)(TreeNode);
	
	var ContextTreeNode = function ContextTreeNode(props) {
	  return React.createElement(_contextTypes.TreeContext.Consumer, null, function (context) {
	    return React.createElement(TreeNode, Object.assign({}, props, {
	      context: context
	    }));
	  });
	};
	
	ContextTreeNode.defaultProps = {
	  title: defaultTitle
	};
	ContextTreeNode.isTreeNode = 1;
	var _default = ContextTreeNode;
	exports.default = _default;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TreeContext = void 0;
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(129));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TreeContext = (0, _createReactContext.default)(null);
	exports.TreeContext = TreeContext;

/***/ },
/* 1119 */
1114,
/* 1120 */
1115,
/* 1121 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = uid;
	var now = +new Date();
	var index = 0;
	
	function uid() {
	  return "rc-upload-" + now + "-" + ++index;
	}
	module.exports = exports['default'];

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mapSelf;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function mirror(o) {
	  return o;
	}
	
	function mapSelf(children) {
	  // return ReactFragment
	  return _react.default.Children.map(children, mirror);
	}

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _ContainerRender = _interopRequireDefault(__webpack_require__(567));
	
	var _Portal = _interopRequireDefault(__webpack_require__(569));
	
	var _switchScrollingEffect = _interopRequireDefault(__webpack_require__(2779));
	
	var _setStyle = _interopRequireDefault(__webpack_require__(1126));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var openCount = 0;
	var windowIsUndefined = !(typeof window !== 'undefined' && window.document && window.document.createElement);
	var IS_REACT_16 = ('createPortal' in _reactDom.default); // https://github.com/ant-design/ant-design/issues/19340
	// https://github.com/ant-design/ant-design/issues/19332
	
	var cacheOverflow = {};
	
	var PortalWrapper = /*#__PURE__*/function (_React$Component) {
	  _inherits(PortalWrapper, _React$Component);
	
	  var _super = _createSuper(PortalWrapper);
	
	  function PortalWrapper(props) {
	    var _this;
	
	    _classCallCheck(this, PortalWrapper);
	
	    _this = _super.call(this, props);
	
	    _this.getParent = function () {
	      var getContainer = _this.props.getContainer;
	
	      if (getContainer) {
	        if (typeof getContainer === 'string') {
	          return document.querySelectorAll(getContainer)[0];
	        }
	
	        if (typeof getContainer === 'function') {
	          return getContainer();
	        }
	
	        if (_typeof(getContainer) === 'object' && getContainer instanceof window.HTMLElement) {
	          return getContainer;
	        }
	      }
	
	      return document.body;
	    };
	
	    _this.getContainer = function () {
	      if (windowIsUndefined) {
	        return null;
	      }
	
	      if (!_this.container) {
	        _this.container = document.createElement('div');
	
	        var parent = _this.getParent();
	
	        if (parent) {
	          parent.appendChild(_this.container);
	        }
	      }
	
	      _this.setWrapperClassName();
	
	      return _this.container;
	    };
	
	    _this.setWrapperClassName = function () {
	      var wrapperClassName = _this.props.wrapperClassName;
	
	      if (_this.container && wrapperClassName && wrapperClassName !== _this.container.className) {
	        _this.container.className = wrapperClassName;
	      }
	    };
	
	    _this.savePortal = function (c) {
	      // Warning: don't rename _component
	      // https://github.com/react-component/util/pull/65#discussion_r352407916
	      _this._component = c;
	    };
	
	    _this.removeCurrentContainer = function (visible) {
	      _this.container = null;
	      _this._component = null;
	
	      if (!IS_REACT_16) {
	        if (visible) {
	          _this.renderComponent({
	            afterClose: _this.removeContainer,
	            onClose: function onClose() {},
	            visible: false
	          });
	        } else {
	          _this.removeContainer();
	        }
	      }
	    };
	
	    _this.switchScrollingEffect = function () {
	      if (openCount === 1 && !Object.keys(cacheOverflow).length) {
	        (0, _switchScrollingEffect.default)(); // Must be set after switchScrollingEffect
	
	        cacheOverflow = (0, _setStyle.default)({
	          overflow: 'hidden',
	          overflowX: 'hidden',
	          overflowY: 'hidden'
	        });
	      } else if (!openCount) {
	        (0, _setStyle.default)(cacheOverflow);
	        cacheOverflow = {};
	        (0, _switchScrollingEffect.default)(true);
	      }
	    };
	
	    var _visible = props.visible;
	    openCount = _visible ? openCount + 1 : openCount;
	    _this.state = {
	      _self: _assertThisInitialized(_this)
	    };
	    return _this;
	  }
	
	  _createClass(PortalWrapper, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.setWrapperClassName();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var visible = this.props.visible; // 离开时不会 render， 导到离开时数值不变，改用 func 。。
	
	      openCount = visible && openCount ? openCount - 1 : openCount;
	      this.removeCurrentContainer(visible);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          children = _this$props.children,
	          forceRender = _this$props.forceRender,
	          visible = _this$props.visible;
	      var portal = null;
	      var childProps = {
	        getOpenCount: function getOpenCount() {
	          return openCount;
	        },
	        getContainer: this.getContainer,
	        switchScrollingEffect: this.switchScrollingEffect
	      }; // suppport react15
	
	      if (!IS_REACT_16) {
	        return /*#__PURE__*/_react.default.createElement(_ContainerRender.default, {
	          parent: this,
	          visible: visible,
	          autoDestroy: false,
	          getComponent: function getComponent() {
	            var extra = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	            return children(_objectSpread(_objectSpread(_objectSpread({}, extra), childProps), {}, {
	              ref: _this2.savePortal
	            }));
	          },
	          getContainer: this.getContainer,
	          forceRender: forceRender
	        }, function (_ref) {
	          var renderComponent = _ref.renderComponent,
	              removeContainer = _ref.removeContainer;
	          _this2.renderComponent = renderComponent;
	          _this2.removeContainer = removeContainer;
	          return null;
	        });
	      }
	
	      if (forceRender || visible || this._component) {
	        portal = /*#__PURE__*/_react.default.createElement(_Portal.default, {
	          getContainer: this.getContainer,
	          ref: this.savePortal
	        }, children(childProps));
	      }
	
	      return portal;
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, _ref2) {
	      var prevProps = _ref2.prevProps,
	          _self = _ref2._self;
	      var visible = props.visible,
	          getContainer = props.getContainer;
	
	      if (prevProps) {
	        var prevVisible = prevProps.visible,
	            prevGetContainer = prevProps.getContainer;
	
	        if (visible !== prevVisible) {
	          openCount = visible && !prevVisible ? openCount + 1 : openCount - 1;
	        }
	
	        var getContainerIsFunc = typeof getContainer === 'function' && typeof prevGetContainer === 'function';
	
	        if (getContainerIsFunc ? getContainer.toString() !== prevGetContainer.toString() : getContainer !== prevGetContainer) {
	          _self.removeCurrentContainer(false);
	        }
	      }
	
	      return {
	        prevProps: props
	      };
	    }
	  }]);
	
	  return PortalWrapper;
	}(_react.default.Component);
	
	PortalWrapper.propTypes = {
	  wrapperClassName: _propTypes.default.string,
	  forceRender: _propTypes.default.bool,
	  getContainer: _propTypes.default.any,
	  children: _propTypes.default.func,
	  visible: _propTypes.default.bool
	};
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(PortalWrapper);
	
	exports.default = _default;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ReactComponentWithPureRenderMixin
	 */
	var shallowEqual = __webpack_require__(79);
	
	function shallowCompare(instance, nextProps, nextState) {
	  return !shallowEqual(instance.props, nextProps) || !shallowEqual(instance.state, nextState);
	}
	/**
	 * If your React component's render function is "pure", e.g. it will render the
	 * same result given the same props and state, provide this mixin for a
	 * considerable performance boost.
	 *
	 * Most React components have pure render functions.
	 *
	 * Example:
	 *
	 *   var ReactComponentWithPureRenderMixin =
	 *     require('ReactComponentWithPureRenderMixin');
	 *   React.createClass({
	 *     mixins: [ReactComponentWithPureRenderMixin],
	 *
	 *     render: function() {
	 *       return <div className={this.props.className}>foo</div>;
	 *     }
	 *   });
	 *
	 * Note: This only checks shallow equality for props and state. If these contain
	 * complex data structures this mixin may have false-negatives for deeper
	 * differences. Only mixin to components which have simple props and state, or
	 * use `forceUpdate()` when you know deep data structures have changed.
	 *
	 * See https://facebook.github.io/react/docs/pure-render-mixin.html
	 */
	
	
	var ReactComponentWithPureRenderMixin = {
	  shouldComponentUpdate: function shouldComponentUpdate(nextProps, nextState) {
	    return shallowCompare(this, nextProps, nextState);
	  }
	};
	module.exports = ReactComponentWithPureRenderMixin;

/***/ },
/* 1125 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScrollBarSize;
	var cached;
	
	function getScrollBarSize(fresh) {
	  if (typeof document === 'undefined') {
	    return 0;
	  }
	
	  if (fresh || cached === undefined) {
	    var inner = document.createElement('div');
	    inner.style.width = '100%';
	    inner.style.height = '200px';
	    var outer = document.createElement('div');
	    var outerStyle = outer.style;
	    outerStyle.position = 'absolute';
	    outerStyle.top = 0;
	    outerStyle.left = 0;
	    outerStyle.pointerEvents = 'none';
	    outerStyle.visibility = 'hidden';
	    outerStyle.width = '200px';
	    outerStyle.height = '150px';
	    outerStyle.overflow = 'hidden';
	    outer.appendChild(inner);
	    document.body.appendChild(outer);
	    var widthContained = inner.offsetWidth;
	    outer.style.overflow = 'scroll';
	    var widthScroll = inner.offsetWidth;
	
	    if (widthContained === widthScroll) {
	      widthScroll = outer.clientWidth;
	    }
	
	    document.body.removeChild(outer);
	    cached = widthContained - widthScroll;
	  }
	
	  return cached;
	}

/***/ },
/* 1126 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/**
	 * Easy to set element style, return previous style
	 * IE browser compatible(IE browser doesn't merge overflow style, need to set it separately)
	 * https://github.com/ant-design/ant-design/issues/19393
	 *
	 */
	function setStyle(style) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$element = options.element,
	      element = _options$element === void 0 ? document.body : _options$element;
	  var oldStyle = {};
	  var styleKeys = Object.keys(style); // IE browser compatible
	
	  styleKeys.forEach(function (key) {
	    oldStyle[key] = element.style[key];
	  });
	  styleKeys.forEach(function (key) {
	    element.style[key] = style[key];
	  });
	  return oldStyle;
	}
	
	var _default = setStyle;
	exports.default = _default;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBase16Theme = exports.createStyling = exports.invertTheme = undefined;
	
	var _typeof2 = __webpack_require__(330);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(1837);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _keys = __webpack_require__(329);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _lodash = __webpack_require__(2492);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _base = __webpack_require__(742);
	
	var base16 = _interopRequireWildcard(_base);
	
	var _rgb2hex = __webpack_require__(2628);
	
	var _rgb2hex2 = _interopRequireDefault(_rgb2hex);
	
	var _parse = __webpack_require__(2631);
	
	var _parse2 = _interopRequireDefault(_parse);
	
	var _lodash3 = __webpack_require__(2493);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _colorConverters = __webpack_require__(2780);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DEFAULT_BASE16 = base16.default;
	
	var BASE16_KEYS = (0, _keys2.default)(DEFAULT_BASE16);
	
	// we need a correcting factor, so that a dark, but not black background color
	// converts to bright enough inversed color
	var flip = function flip(x) {
	  return x < 0.25 ? 1 : x < 0.5 ? 0.9 - x : 1.1 - x;
	};
	
	var invertColor = (0, _lodash4.default)(_parse2.default, _colorConverters.rgb2yuv, function (_ref) {
	  var _ref2 = (0, _slicedToArray3.default)(_ref, 3),
	      y = _ref2[0],
	      u = _ref2[1],
	      v = _ref2[2];
	
	  return [flip(y), u, v];
	}, _colorConverters.yuv2rgb, _rgb2hex2.default);
	
	var merger = function merger(styling) {
	  return function (prevStyling) {
	    return {
	      className: [prevStyling.className, styling.className].filter(Boolean).join(' '),
	      style: (0, _extends3.default)({}, prevStyling.style || {}, styling.style || {})
	    };
	  };
	};
	
	var mergeStyling = function mergeStyling(customStyling, defaultStyling) {
	  if (customStyling === undefined) {
	    return defaultStyling;
	  }
	  if (defaultStyling === undefined) {
	    return customStyling;
	  }
	
	  var customType = typeof customStyling === 'undefined' ? 'undefined' : (0, _typeof3.default)(customStyling);
	  var defaultType = typeof defaultStyling === 'undefined' ? 'undefined' : (0, _typeof3.default)(defaultStyling);
	
	  switch (customType) {
	    case 'string':
	      switch (defaultType) {
	        case 'string':
	          return [defaultStyling, customStyling].filter(Boolean).join(' ');
	        case 'object':
	          return merger({ className: customStyling, style: defaultStyling });
	        case 'function':
	          return function (styling) {
	            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	              args[_key - 1] = arguments[_key];
	            }
	
	            return merger({
	              className: customStyling
	            })(defaultStyling.apply(undefined, [styling].concat(args)));
	          };
	      }
	    case 'object':
	      switch (defaultType) {
	        case 'string':
	          return merger({ className: defaultStyling, style: customStyling });
	        case 'object':
	          return (0, _extends3.default)({}, defaultStyling, customStyling);
	        case 'function':
	          return function (styling) {
	            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	              args[_key2 - 1] = arguments[_key2];
	            }
	
	            return merger({
	              style: customStyling
	            })(defaultStyling.apply(undefined, [styling].concat(args)));
	          };
	      }
	    case 'function':
	      switch (defaultType) {
	        case 'string':
	          return function (styling) {
	            for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	              args[_key3 - 1] = arguments[_key3];
	            }
	
	            return customStyling.apply(undefined, [merger(styling)({
	              className: defaultStyling
	            })].concat(args));
	          };
	        case 'object':
	          return function (styling) {
	            for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	              args[_key4 - 1] = arguments[_key4];
	            }
	
	            return customStyling.apply(undefined, [merger(styling)({
	              style: defaultStyling
	            })].concat(args));
	          };
	        case 'function':
	          return function (styling) {
	            for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	              args[_key5 - 1] = arguments[_key5];
	            }
	
	            return customStyling.apply(undefined, [defaultStyling.apply(undefined, [styling].concat(args))].concat(args));
	          };
	      }
	  }
	};
	
	var mergeStylings = function mergeStylings(customStylings, defaultStylings) {
	  var keys = (0, _keys2.default)(defaultStylings);
	  for (var key in customStylings) {
	    if (keys.indexOf(key) === -1) keys.push(key);
	  }
	
	  return keys.reduce(function (mergedStyling, key) {
	    return mergedStyling[key] = mergeStyling(customStylings[key], defaultStylings[key]), mergedStyling;
	  }, {});
	};
	
	var getStylingByKeys = function getStylingByKeys(mergedStyling, keys) {
	  for (var _len6 = arguments.length, args = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
	    args[_key6 - 2] = arguments[_key6];
	  }
	
	  if (keys === null) {
	    return mergedStyling;
	  }
	
	  if (!Array.isArray(keys)) {
	    keys = [keys];
	  }
	
	  var styles = keys.map(function (key) {
	    return mergedStyling[key];
	  }).filter(Boolean);
	
	  var props = styles.reduce(function (obj, s) {
	    if (typeof s === 'string') {
	      obj.className = [obj.className, s].filter(Boolean).join(' ');
	    } else if ((typeof s === 'undefined' ? 'undefined' : (0, _typeof3.default)(s)) === 'object') {
	      obj.style = (0, _extends3.default)({}, obj.style, s);
	    } else if (typeof s === 'function') {
	      obj = (0, _extends3.default)({}, obj, s.apply(undefined, [obj].concat(args)));
	    }
	
	    return obj;
	  }, { className: '', style: {} });
	
	  if (!props.className) {
	    delete props.className;
	  }
	
	  if ((0, _keys2.default)(props.style).length === 0) {
	    delete props.style;
	  }
	
	  return props;
	};
	
	var invertTheme = exports.invertTheme = function invertTheme(theme) {
	  return (0, _keys2.default)(theme).reduce(function (t, key) {
	    return t[key] = /^base/.test(key) ? invertColor(theme[key]) : key === 'scheme' ? theme[key] + ':inverted' : theme[key], t;
	  }, {});
	};
	
	var createStyling = exports.createStyling = (0, _lodash2.default)(function (getStylingFromBase16) {
	  for (var _len7 = arguments.length, args = Array(_len7 > 3 ? _len7 - 3 : 0), _key7 = 3; _key7 < _len7; _key7++) {
	    args[_key7 - 3] = arguments[_key7];
	  }
	
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var themeOrStyling = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var _options$defaultBase = options.defaultBase16,
	      defaultBase16 = _options$defaultBase === undefined ? DEFAULT_BASE16 : _options$defaultBase,
	      _options$base16Themes = options.base16Themes,
	      base16Themes = _options$base16Themes === undefined ? null : _options$base16Themes;
	
	
	  var base16Theme = getBase16Theme(themeOrStyling, base16Themes);
	  if (base16Theme) {
	    themeOrStyling = (0, _extends3.default)({}, base16Theme, themeOrStyling);
	  }
	
	  var theme = BASE16_KEYS.reduce(function (t, key) {
	    return t[key] = themeOrStyling[key] || defaultBase16[key], t;
	  }, {});
	
	  var customStyling = (0, _keys2.default)(themeOrStyling).reduce(function (s, key) {
	    return BASE16_KEYS.indexOf(key) === -1 ? (s[key] = themeOrStyling[key], s) : s;
	  }, {});
	
	  var defaultStyling = getStylingFromBase16(theme);
	
	  var mergedStyling = mergeStylings(customStyling, defaultStyling);
	
	  return (0, _lodash2.default)(getStylingByKeys, 2).apply(undefined, [mergedStyling].concat(args));
	}, 3);
	
	var getBase16Theme = exports.getBase16Theme = function getBase16Theme(theme, base16Themes) {
	  if (theme && theme.extend) {
	    theme = theme.extend;
	  }
	
	  if (typeof theme === 'string') {
	    var _theme$split = theme.split(':'),
	        _theme$split2 = (0, _slicedToArray3.default)(_theme$split, 2),
	        themeName = _theme$split2[0],
	        modifier = _theme$split2[1];
	
	    theme = (base16Themes || {})[themeName] || base16[themeName];
	    if (modifier === 'inverted') {
	      theme = invertTheme(theme);
	    }
	  }
	
	  return theme && theme.hasOwnProperty('base00') ? theme : undefined;
	};

/***/ },
/* 1128 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(221);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(259);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactInstrumentation = __webpack_require__(128);
	
	var quoteAttributeValueForBrowser = __webpack_require__(2842);
	var warning = __webpack_require__(49);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 1131 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var LinkedValueUtils = __webpack_require__(576);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactUpdates = __webpack_require__(146);
	
	var warning = __webpack_require__(49);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 1133 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 1134 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var invariant = __webpack_require__(18);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(2802);
	
	var containsNode = __webpack_require__(365);
	var focusNode = __webpack_require__(887);
	var getActiveElement = __webpack_require__(366);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var DOMLazyTree = __webpack_require__(258);
	var DOMProperty = __webpack_require__(259);
	var React = __webpack_require__(263);
	var ReactBrowserEventEmitter = __webpack_require__(385);
	var ReactCurrentOwner = __webpack_require__(164);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactDOMContainerInfo = __webpack_require__(2796);
	var ReactDOMFeatureFlags = __webpack_require__(2798);
	var ReactFeatureFlags = __webpack_require__(1134);
	var ReactInstanceMap = __webpack_require__(306);
	var ReactInstrumentation = __webpack_require__(128);
	var ReactMarkupChecksum = __webpack_require__(2812);
	var ReactReconciler = __webpack_require__(260);
	var ReactUpdateQueue = __webpack_require__(579);
	var ReactUpdates = __webpack_require__(146);
	
	var emptyObject = __webpack_require__(522);
	var instantiateReactComponent = __webpack_require__(1145);
	var invariant = __webpack_require__(18);
	var setInnerHTML = __webpack_require__(389);
	var shouldUpdateReactComponent = __webpack_require__(585);
	var warning = __webpack_require__(49);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var React = __webpack_require__(263);
	
	var invariant = __webpack_require__(18);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 1139 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 1141 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(1138);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(93);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(72);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47),
	    _assign = __webpack_require__(40);
	
	var ReactCompositeComponent = __webpack_require__(2793);
	var ReactEmptyComponent = __webpack_require__(1133);
	var ReactHostComponent = __webpack_require__(1135);
	
	var getNextDebugID = __webpack_require__(2895);
	var invariant = __webpack_require__(18);
	var warning = __webpack_require__(49);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 1146 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(93);
	var escapeTextContentForBrowser = __webpack_require__(388);
	var setInnerHTML = __webpack_require__(389);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactCurrentOwner = __webpack_require__(164);
	var REACT_ELEMENT_TYPE = __webpack_require__(2808);
	
	var getIteratorFn = __webpack_require__(2839);
	var invariant = __webpack_require__(18);
	var KeyEscapeUtils = __webpack_require__(575);
	var warning = __webpack_require__(49);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(399);
	
	var _interopRequireDefault = __webpack_require__(130);
	
	exports.__esModule = true;
	exports.default = connectAdvanced;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(610));
	
	var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(1218));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(398));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(400));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(529));
	
	var _invariant = _interopRequireDefault(__webpack_require__(85));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactIs = __webpack_require__(222);
	
	var _Subscription = _interopRequireDefault(__webpack_require__(2857));
	
	var _PropTypes = __webpack_require__(1151);
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var hotReloadingVersion = 0;
	var dummyState = {};
	
	function noop() {}
	
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory, // options object:
	_ref) {
	  var _contextTypes, _childContextTypes;
	
	  if (_ref === void 0) {
	    _ref = {};
	  }
	
	  var _ref2 = _ref,
	      _ref2$getDisplayName = _ref2.getDisplayName,
	      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
	    return "ConnectAdvanced(" + name + ")";
	  } : _ref2$getDisplayName,
	      _ref2$methodName = _ref2.methodName,
	      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
	      _ref2$renderCountProp = _ref2.renderCountProp,
	      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
	      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
	      _ref2$storeKey = _ref2.storeKey,
	      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
	      _ref2$withRef = _ref2.withRef,
	      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
	      connectOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant.default)((0, _reactIs.isValidElementType)(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	    var displayName = getDisplayName(wrappedComponentName);
	    var selectorFactoryOptions = (0, _extends2.default)({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps
	
	      /* eslint-disable react/no-deprecated */
	
	    });
	
	    var Connect =
	    /*#__PURE__*/
	    function (_Component) {
	      (0, _inheritsLoose2.default)(Connect, _Component);
	
	      function Connect(props, context) {
	        var _this;
	
	        _this = _Component.call(this, props, context) || this;
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind((0, _assertThisInitialized2.default)((0, _assertThisInitialized2.default)(_this)));
	        (0, _invariant.default)(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));
	
	        _this.initSelector();
	
	        _this.initSubscription();
	
	        return _this;
	      }
	
	      var _proto = Connect.prototype;
	
	      _proto.getChildContext = function getChildContext() {
	        var _ref3;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
	      };
	
	      _proto.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0
	
	
	      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      _proto.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      _proto.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant.default)(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
	        return this.wrappedInstance;
	      };
	
	      _proto.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      _proto.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      _proto.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription.default(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      _proto.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      _proto.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      _proto.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	
	        var withExtras = (0, _extends2.default)({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      _proto.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    if (prefixUnsafeLifecycleMethods) {
	      // Use UNSAFE_ event name where supported
	      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
	      delete Connect.prototype.componentWillReceiveProps;
	    }
	    /* eslint-enable react/no-deprecated */
	
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      // Use UNSAFE_ event name where supported
	      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';
	
	      Connect.prototype[eventName] = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	
	          this.initSubscription();
	
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(130);
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(1152));
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	
	
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	
	
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    }; // allow detectFactoryAndVerify to get ownProps
	
	
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject.default)(props, displayName, methodName);
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(130);
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var subscriptionShape = _propTypes.default.shape({
	  trySubscribe: _propTypes.default.func.isRequired,
	  tryUnsubscribe: _propTypes.default.func.isRequired,
	  notifyNestedSubs: _propTypes.default.func.isRequired,
	  isSubscribed: _propTypes.default.func.isRequired
	});
	
	exports.subscriptionShape = subscriptionShape;
	
	var storeShape = _propTypes.default.shape({
	  subscribe: _propTypes.default.func.isRequired,
	  dispatch: _propTypes.default.func.isRequired,
	  getState: _propTypes.default.func.isRequired
	});
	
	exports.storeShape = storeShape;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(130);
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(2858));
	
	var _warning = _interopRequireDefault(__webpack_require__(587));
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject.default)(value)) {
	    (0, _warning.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
	  }
	}

/***/ },
/* 1153 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * This action type will be dispatched by the history actions below.
	 * If you're writing a middleware to watch for navigation events, be sure to
	 * look for actions of this type.
	 */
	var CALL_HISTORY_METHOD = exports.CALL_HISTORY_METHOD = '@@router/CALL_HISTORY_METHOD';
	
	function updateLocation(method) {
	  return function () {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return {
	      type: CALL_HISTORY_METHOD,
	      payload: { method: method, args: args }
	    };
	  };
	}
	
	/**
	 * These actions correspond to the history API.
	 * The associated routerMiddleware will capture these events before they get to
	 * your reducer and reissue them as the matching function on your history.
	 */
	var push = exports.push = updateLocation('push');
	var replace = exports.replace = updateLocation('replace');
	var go = exports.go = updateLocation('go');
	var goBack = exports.goBack = updateLocation('goBack');
	var goForward = exports.goForward = updateLocation('goForward');
	
	var routerActions = exports.routerActions = { push: push, replace: replace, go: go, goBack: goBack, goForward: goForward };

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.routerMiddleware = exports.routerActions = exports.goForward = exports.goBack = exports.go = exports.replace = exports.push = exports.CALL_HISTORY_METHOD = exports.routerReducer = exports.LOCATION_CHANGE = exports.syncHistoryWithStore = undefined;
	
	var _reducer = __webpack_require__(1155);
	
	Object.defineProperty(exports, 'LOCATION_CHANGE', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.LOCATION_CHANGE;
	  }
	});
	Object.defineProperty(exports, 'routerReducer', {
	  enumerable: true,
	  get: function get() {
	    return _reducer.routerReducer;
	  }
	});
	
	var _actions = __webpack_require__(1153);
	
	Object.defineProperty(exports, 'CALL_HISTORY_METHOD', {
	  enumerable: true,
	  get: function get() {
	    return _actions.CALL_HISTORY_METHOD;
	  }
	});
	Object.defineProperty(exports, 'push', {
	  enumerable: true,
	  get: function get() {
	    return _actions.push;
	  }
	});
	Object.defineProperty(exports, 'replace', {
	  enumerable: true,
	  get: function get() {
	    return _actions.replace;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _actions.go;
	  }
	});
	Object.defineProperty(exports, 'goBack', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goBack;
	  }
	});
	Object.defineProperty(exports, 'goForward', {
	  enumerable: true,
	  get: function get() {
	    return _actions.goForward;
	  }
	});
	Object.defineProperty(exports, 'routerActions', {
	  enumerable: true,
	  get: function get() {
	    return _actions.routerActions;
	  }
	});
	
	var _sync = __webpack_require__(2861);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _middleware = __webpack_require__(2860);
	
	var _middleware2 = _interopRequireDefault(_middleware);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports.syncHistoryWithStore = _sync2['default'];
	exports.routerMiddleware = _middleware2['default'];

/***/ },
/* 1155 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.routerReducer = routerReducer;
	/**
	 * This action type will be dispatched when your history
	 * receives a location change.
	 */
	var LOCATION_CHANGE = exports.LOCATION_CHANGE = '@@router/LOCATION_CHANGE';
	
	var initialState = {
	  locationBeforeTransitions: null
	};
	
	/**
	 * This reducer will update the state with the most recent location history
	 * has transitioned to. This may not be in sync with the router, particularly
	 * if you have asynchronously-loaded routes, so reading from and relying on
	 * this state is discouraged.
	 */
	function routerReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      type = _ref.type,
	      payload = _ref.payload;
	
	  if (type === LOCATION_CHANGE) {
	    return _extends({}, state, { locationBeforeTransitions: payload });
	  }
	
	  return state;
	}

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(139);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(6);
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _PropTypes = __webpack_require__(590);
	
	var _ContextUtils = __webpack_require__(589);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function isLeftClickEvent(event) {
	  return event.button === 0;
	}
	
	function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	}
	
	// TODO: De-duplicate against hasAnyProperties in createTransitionManager.
	function isEmptyObject(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return false;
	  }return true;
	}
	
	function resolveToLocation(to, router) {
	  return typeof to === 'function' ? to(router.location) : to;
	}
	
	/**
	 * A <Link> is used to create an <a> element that links to a route.
	 * When that route is active, the link gets the value of its
	 * activeClassName prop.
	 *
	 * For example, assuming you have the following route:
	 *
	 *   <Route path="/posts/:postID" component={Post} />
	 *
	 * You could use the following component to link to that route:
	 *
	 *   <Link to={`/posts/${post.id}`} />
	 */
	var Link = (0, _createReactClass2.default)({
	  displayName: 'Link',
	
	  mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	  contextTypes: {
	    router: _PropTypes.routerShape
	  },
	
	  propTypes: {
	    to: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.object, _propTypes.func]),
	    activeStyle: _propTypes.object,
	    activeClassName: _propTypes.string,
	    onlyActiveOnIndex: _propTypes.bool.isRequired,
	    onClick: _propTypes.func,
	    target: _propTypes.string,
	    innerRef: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func, (0, _propTypes.shape)({ current: _propTypes.elementType })])
	  },
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      onlyActiveOnIndex: false,
	      style: {}
	    };
	  },
	  handleClick: function handleClick(event) {
	    if (this.props.onClick) this.props.onClick(event);
	
	    if (event.defaultPrevented) return;
	
	    var router = this.context.router;
	
	    !router ?  false ? (0, _invariant2.default)(false, '<Link>s rendered outside of a router context cannot navigate.') : (0, _invariant2.default)(false) : void 0;
	
	    if (isModifiedEvent(event) || !isLeftClickEvent(event)) return;
	
	    // If target prop is set (e.g. to "_blank"), let browser handle link.
	    /* istanbul ignore if: untestable with Karma */
	    if (this.props.target) return;
	
	    event.preventDefault();
	
	    router.push(resolveToLocation(this.props.to, router));
	  },
	  render: function render() {
	    var _props = this.props,
	        to = _props.to,
	        activeClassName = _props.activeClassName,
	        activeStyle = _props.activeStyle,
	        onlyActiveOnIndex = _props.onlyActiveOnIndex,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['to', 'activeClassName', 'activeStyle', 'onlyActiveOnIndex', 'innerRef']);
	
	    // Ignore if rendered outside the context of router to simplify unit testing.
	
	
	    var router = this.context.router;
	
	
	    if (router) {
	      // If user does not specify a `to` prop, return an empty anchor tag.
	      if (!to) {
	        return _react2.default.createElement('a', _extends({}, props, { ref: innerRef }));
	      }
	
	      var toLocation = resolveToLocation(to, router);
	      props.href = router.createHref(toLocation);
	
	      if (activeClassName || activeStyle != null && !isEmptyObject(activeStyle)) {
	        if (router.isActive(toLocation, onlyActiveOnIndex)) {
	          if (activeClassName) {
	            if (props.className) {
	              props.className += ' ' + activeClassName;
	            } else {
	              props.className = activeClassName;
	            }
	          }
	
	          if (activeStyle) props.style = _extends({}, props.style, activeStyle);
	        }
	      }
	    }
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, ref: innerRef }));
	  }
	});
	
	exports.default = Link;
	module.exports = exports['default'];

/***/ },
/* 1157 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.isPromise = isPromise;
	function isPromise(obj) {
	  return obj && typeof obj.then === 'function';
	}

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(139);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(6);
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(186);
	
	var _PatternUtils = __webpack_require__(261);
	
	var _InternalPropTypes = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Redirect> is used to declare another URL path a client should
	 * be sent to when they request a given URL.
	 *
	 * Redirects are placed alongside routes in the route configuration
	 * and are traversed in the same manner.
	 */
	/* eslint-disable react/require-render-return */
	var Redirect = (0, _createReactClass2.default)({
	  displayName: 'Redirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element) {
	      var route = (0, _RouteUtils.createRouteFromReactElement)(element);
	
	      if (route.from) route.path = route.from;
	
	      route.onEnter = function (nextState, replace) {
	        var location = nextState.location,
	            params = nextState.params;
	
	
	        var pathname = void 0;
	        if (route.to.charAt(0) === '/') {
	          pathname = (0, _PatternUtils.formatPattern)(route.to, params);
	        } else if (!route.to) {
	          pathname = location.pathname;
	        } else {
	          var routeIndex = nextState.routes.indexOf(route);
	          var parentPattern = Redirect.getRoutePattern(nextState.routes, routeIndex - 1);
	          var pattern = parentPattern.replace(/\/*$/, '/') + route.to;
	          pathname = (0, _PatternUtils.formatPattern)(pattern, params);
	        }
	
	        replace({
	          pathname: pathname,
	          query: route.query || location.query,
	          state: route.state || location.state
	        });
	      };
	
	      return route;
	    },
	    getRoutePattern: function getRoutePattern(routes, routeIndex) {
	      var parentPattern = '';
	
	      for (var i = routeIndex; i >= 0; i--) {
	        var route = routes[i];
	        var pattern = route.path || '';
	
	        parentPattern = pattern.replace(/\/*$/, '/') + parentPattern;
	
	        if (pattern.indexOf('/') === 0) break;
	      }
	
	      return '/' + parentPattern;
	    }
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    from: _propTypes.string, // Alias for path
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Redirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Redirect;
	module.exports = exports['default'];

/***/ },
/* 1159 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createRouterObject = createRouterObject;
	exports.assignRouterState = assignRouterState;
	function createRouterObject(history, transitionManager, state) {
	  var router = _extends({}, history, {
	    setRouteLeaveHook: transitionManager.listenBeforeLeavingRoute,
	    isActive: transitionManager.isActive
	  });
	
	  return assignRouterState(router, state);
	}
	
	function assignRouterState(router, _ref) {
	  var location = _ref.location,
	      params = _ref.params,
	      routes = _ref.routes;
	
	  router.location = location;
	  router.params = params;
	  router.routes = routes;
	
	  return router;
	}

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createMemoryHistory;
	
	var _useQueries = __webpack_require__(893);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(892);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	var _createMemoryHistory = __webpack_require__(2488);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createMemoryHistory(options) {
	  // signatures and type checking differ between `useQueries` and
	  // `createMemoryHistory`, have to create `memoryHistory` first because
	  // `useQueries` doesn't understand the signature
	  var memoryHistory = (0, _createMemoryHistory2.default)(options);
	  var createHistory = function createHistory() {
	    return memoryHistory;
	  };
	  var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = createRouterHistory;
	
	var _useRouterHistory = __webpack_require__(1163);
	
	var _useRouterHistory2 = _interopRequireDefault(_useRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	function createRouterHistory(createHistory) {
	  var history = void 0;
	  if (canUseDOM) history = (0, _useRouterHistory2.default)(createHistory)();
	  return history;
	}
	module.exports = exports['default'];

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = createTransitionManager;
	
	var _routerWarning = __webpack_require__(262);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _computeChangedRoutes2 = __webpack_require__(2870);
	
	var _computeChangedRoutes3 = _interopRequireDefault(_computeChangedRoutes2);
	
	var _TransitionUtils = __webpack_require__(2867);
	
	var _TransitionUtils2 = _interopRequireDefault(_TransitionUtils);
	
	var _isActive2 = __webpack_require__(2874);
	
	var _isActive3 = _interopRequireDefault(_isActive2);
	
	var _getComponents = __webpack_require__(2871);
	
	var _getComponents2 = _interopRequireDefault(_getComponents);
	
	var _matchRoutes = __webpack_require__(2876);
	
	var _matchRoutes2 = _interopRequireDefault(_matchRoutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hasAnyProperties(object) {
	  for (var p in object) {
	    if (Object.prototype.hasOwnProperty.call(object, p)) return true;
	  }return false;
	}
	
	function createTransitionManager(history, routes) {
	  var state = {};
	
	  var _getTransitionUtils = (0, _TransitionUtils2.default)(),
	      runEnterHooks = _getTransitionUtils.runEnterHooks,
	      runChangeHooks = _getTransitionUtils.runChangeHooks,
	      runLeaveHooks = _getTransitionUtils.runLeaveHooks;
	
	  // Signature should be (location, indexOnly), but needs to support (path,
	  // query, indexOnly)
	
	
	  function isActive(location, indexOnly) {
	    location = history.createLocation(location);
	
	    return (0, _isActive3.default)(location, indexOnly, state.location, state.routes, state.params);
	  }
	
	  var partialNextState = void 0;
	
	  function match(location, callback) {
	    if (partialNextState && partialNextState.location === location) {
	      // Continue from where we left off.
	      finishMatch(partialNextState, callback);
	    } else {
	      (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	        if (error) {
	          callback(error);
	        } else if (nextState) {
	          finishMatch(_extends({}, nextState, { location: location }), callback);
	        } else {
	          callback();
	        }
	      });
	    }
	  }
	
	  function finishMatch(nextState, callback) {
	    var _computeChangedRoutes = (0, _computeChangedRoutes3.default)(state, nextState),
	        leaveRoutes = _computeChangedRoutes.leaveRoutes,
	        changeRoutes = _computeChangedRoutes.changeRoutes,
	        enterRoutes = _computeChangedRoutes.enterRoutes;
	
	    runLeaveHooks(leaveRoutes, state);
	
	    // Tear down confirmation hooks for left routes
	    leaveRoutes.filter(function (route) {
	      return enterRoutes.indexOf(route) === -1;
	    }).forEach(removeListenBeforeHooksForRoute);
	
	    // change and enter hooks are run in series
	    runChangeHooks(changeRoutes, state, nextState, function (error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      runEnterHooks(enterRoutes, nextState, finishEnterHooks);
	    });
	
	    function finishEnterHooks(error, redirectInfo) {
	      if (error || redirectInfo) return handleErrorOrRedirect(error, redirectInfo);
	
	      // TODO: Fetch components after state is updated.
	      (0, _getComponents2.default)(nextState, function (error, components) {
	        if (error) {
	          callback(error);
	        } else {
	          // TODO: Make match a pure function and have some other API
	          // for "match and update state".
	          callback(null, null, state = _extends({}, nextState, { components: components }));
	        }
	      });
	    }
	
	    function handleErrorOrRedirect(error, redirectInfo) {
	      if (error) callback(error);else callback(null, redirectInfo);
	    }
	  }
	
	  var RouteGuid = 1;
	
	  function getRouteID(route) {
	    var create = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	    return route.__id__ || create && (route.__id__ = RouteGuid++);
	  }
	
	  var RouteHooks = Object.create(null);
	
	  function getRouteHooksForRoutes(routes) {
	    return routes.map(function (route) {
	      return RouteHooks[getRouteID(route)];
	    }).filter(function (hook) {
	      return hook;
	    });
	  }
	
	  function transitionHook(location, callback) {
	    (0, _matchRoutes2.default)(routes, location, function (error, nextState) {
	      if (nextState == null) {
	        // TODO: We didn't actually match anything, but hang
	        // onto error/nextState so we don't have to matchRoutes
	        // again in the listen callback.
	        callback();
	        return;
	      }
	
	      // Cache some state here so we don't have to
	      // matchRoutes() again in the listen callback.
	      partialNextState = _extends({}, nextState, { location: location });
	
	      var hooks = getRouteHooksForRoutes((0, _computeChangedRoutes3.default)(state, partialNextState).leaveRoutes);
	
	      var result = void 0;
	      for (var i = 0, len = hooks.length; result == null && i < len; ++i) {
	        // Passing the location arg here indicates to
	        // the user that this is a transition hook.
	        result = hooks[i](location);
	      }
	
	      callback(result);
	    });
	  }
	
	  /* istanbul ignore next: untestable with Karma */
	  function beforeUnloadHook() {
	    // Synchronously check to see if any route hooks want
	    // to prevent the current window/tab from closing.
	    if (state.routes) {
	      var hooks = getRouteHooksForRoutes(state.routes);
	
	      var message = void 0;
	      for (var i = 0, len = hooks.length; typeof message !== 'string' && i < len; ++i) {
	        // Passing no args indicates to the user that this is a
	        // beforeunload hook. We don't know the next location.
	        message = hooks[i]();
	      }
	
	      return message;
	    }
	  }
	
	  var unlistenBefore = void 0,
	      unlistenBeforeUnload = void 0;
	
	  function removeListenBeforeHooksForRoute(route) {
	    var routeID = getRouteID(route);
	    if (!routeID) {
	      return;
	    }
	
	    delete RouteHooks[routeID];
	
	    if (!hasAnyProperties(RouteHooks)) {
	      // teardown transition & beforeunload hooks
	      if (unlistenBefore) {
	        unlistenBefore();
	        unlistenBefore = null;
	      }
	
	      if (unlistenBeforeUnload) {
	        unlistenBeforeUnload();
	        unlistenBeforeUnload = null;
	      }
	    }
	  }
	
	  /**
	   * Registers the given hook function to run before leaving the given route.
	   *
	   * During a normal transition, the hook function receives the next location
	   * as its only argument and can return either a prompt message (string) to show the user,
	   * to make sure they want to leave the page; or `false`, to prevent the transition.
	   * Any other return value will have no effect.
	   *
	   * During the beforeunload event (in browsers) the hook receives no arguments.
	   * In this case it must return a prompt message to prevent the transition.
	   *
	   * Returns a function that may be used to unbind the listener.
	   */
	  function listenBeforeLeavingRoute(route, hook) {
	    var thereWereNoRouteHooks = !hasAnyProperties(RouteHooks);
	    var routeID = getRouteID(route, true);
	
	    RouteHooks[routeID] = hook;
	
	    if (thereWereNoRouteHooks) {
	      // setup transition & beforeunload hooks
	      unlistenBefore = history.listenBefore(transitionHook);
	
	      if (history.listenBeforeUnload) unlistenBeforeUnload = history.listenBeforeUnload(beforeUnloadHook);
	    }
	
	    return function () {
	      removeListenBeforeHooksForRoute(route);
	    };
	  }
	
	  /**
	   * This is the API for stateful environments. As the location
	   * changes, we update state and call the listener. We can also
	   * gracefully handle errors and redirects.
	   */
	  function listen(listener) {
	    function historyListener(location) {
	      if (state.location === location) {
	        listener(null, state);
	      } else {
	        match(location, function (error, redirectLocation, nextState) {
	          if (error) {
	            listener(error);
	          } else if (redirectLocation) {
	            history.replace(redirectLocation);
	          } else if (nextState) {
	            listener(null, nextState);
	          } else {
	             false ? (0, _routerWarning2.default)(false, 'Location "%s" did not match any routes', location.pathname + location.search + location.hash) : void 0;
	          }
	        });
	      }
	    }
	
	    // TODO: Only use a single history listener. Otherwise we'll end up with
	    // multiple concurrent calls to match.
	
	    // Set up the history listener first in case the initial match redirects.
	    var unsubscribe = history.listen(historyListener);
	
	    if (state.location) {
	      // Picking up on a matchContext.
	      listener(null, state);
	    } else {
	      historyListener(history.getCurrentLocation());
	    }
	
	    return unsubscribe;
	  }
	
	  return {
	    isActive: isActive,
	    match: match,
	    listenBeforeLeavingRoute: listenBeforeLeavingRoute,
	    listen: listen
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = useRouterHistory;
	
	var _useQueries = __webpack_require__(893);
	
	var _useQueries2 = _interopRequireDefault(_useQueries);
	
	var _useBasename = __webpack_require__(892);
	
	var _useBasename2 = _interopRequireDefault(_useBasename);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function useRouterHistory(createHistory) {
	  return function (options) {
	    var history = (0, _useQueries2.default)((0, _useBasename2.default)(createHistory))(options);
	    return history;
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(311),
	    _assign = __webpack_require__(40);
	
	var ReactNoopUpdateQueue = __webpack_require__(1167);
	
	var canDefineProperty = __webpack_require__(1168);
	var emptyObject = __webpack_require__(522);
	var invariant = __webpack_require__(18);
	var lowPriorityWarning = __webpack_require__(2896);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(311);
	
	var ReactCurrentOwner = __webpack_require__(164);
	
	var invariant = __webpack_require__(18);
	var warning = __webpack_require__(49);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 1166 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(49);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 1169 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toggleVisibility = toggleVisibility;
	exports.changePosition = changePosition;
	exports.changeSize = changeSize;
	exports.changeMonitor = changeMonitor;
	exports.CHANGE_MONITOR = exports.CHANGE_SIZE = exports.CHANGE_POSITION = exports.TOGGLE_VISIBILITY = void 0;
	var TOGGLE_VISIBILITY = '@@redux-devtools-log-monitor/TOGGLE_VISIBILITY';
	exports.TOGGLE_VISIBILITY = TOGGLE_VISIBILITY;
	
	function toggleVisibility() {
	  return {
	    type: TOGGLE_VISIBILITY
	  };
	}
	
	var CHANGE_POSITION = '@@redux-devtools-log-monitor/CHANGE_POSITION';
	exports.CHANGE_POSITION = CHANGE_POSITION;
	
	function changePosition() {
	  return {
	    type: CHANGE_POSITION
	  };
	}
	
	var CHANGE_SIZE = '@@redux-devtools-log-monitor/CHANGE_SIZE';
	exports.CHANGE_SIZE = CHANGE_SIZE;
	
	function changeSize(size) {
	  return {
	    type: CHANGE_SIZE,
	    size: size
	  };
	}
	
	var CHANGE_MONITOR = '@@redux-devtools-log-monitor/CHANGE_MONITOR';
	exports.CHANGE_MONITOR = CHANGE_MONITOR;
	
	function changeMonitor() {
	  return {
	    type: CHANGE_MONITOR
	  };
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 1170 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.POSITIONS = void 0;
	var POSITIONS = ['left', 'top', 'right', 'bottom'];
	exports.POSITIONS = POSITIONS;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9jb25zdGFudHMudHMiXSwibmFtZXMiOlsiUE9TSVRJT05TIl0sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBTyxJQUFNQSxTQUFTLEdBQUcsQ0FBQyxNQUFELEVBQVMsS0FBVCxFQUFnQixPQUFoQixFQUF5QixRQUF6QixDQUFsQiIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBjb25zdCBQT1NJVElPTlMgPSBbJ2xlZnQnLCAndG9wJywgJ3JpZ2h0JywgJ2JvdHRvbSddIGFzIGNvbnN0O1xuIl19

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.liftAction = liftAction;
	exports.liftReducerWith = liftReducerWith;
	exports.unliftState = unliftState;
	exports.unliftStore = unliftStore;
	exports["default"] = instrument;
	exports.INIT_ACTION = exports.ActionCreators = exports.ActionTypes = void 0;
	
	var _difference = _interopRequireDefault(__webpack_require__(2589));
	
	var _union = _interopRequireDefault(__webpack_require__(2607));
	
	var _isPlainObject = _interopRequireDefault(__webpack_require__(379));
	
	var _symbolObservable = _interopRequireDefault(__webpack_require__(1182));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var ActionTypes = {
	  PERFORM_ACTION: 'PERFORM_ACTION',
	  RESET: 'RESET',
	  ROLLBACK: 'ROLLBACK',
	  COMMIT: 'COMMIT',
	  SWEEP: 'SWEEP',
	  TOGGLE_ACTION: 'TOGGLE_ACTION',
	  SET_ACTIONS_ACTIVE: 'SET_ACTIONS_ACTIVE',
	  JUMP_TO_STATE: 'JUMP_TO_STATE',
	  JUMP_TO_ACTION: 'JUMP_TO_ACTION',
	  REORDER_ACTION: 'REORDER_ACTION',
	  IMPORT_STATE: 'IMPORT_STATE',
	  LOCK_CHANGES: 'LOCK_CHANGES',
	  PAUSE_RECORDING: 'PAUSE_RECORDING'
	};
	exports.ActionTypes = ActionTypes;
	var isChrome = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && (typeof window.chrome !== 'undefined' || typeof window.process !== 'undefined' && window.process.type === 'renderer');
	var isChromeOrNode = isChrome || typeof process !== 'undefined' && process.release && process.release.name === 'node';
	
	/**
	 * Action creators to change the History state.
	 */
	var ActionCreators = {
	  performAction: function performAction(action, trace, traceLimit, // eslint-disable-next-line @typescript-eslint/ban-types
	  toExcludeFromTrace) {
	    if (!(0, _isPlainObject["default"])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    var stack;
	
	    if (trace) {
	      var extraFrames = 0;
	
	      if (typeof trace === 'function') {
	        stack = trace(action);
	      } else {
	        var error = Error();
	        var prevStackTraceLimit;
	
	        if (Error.captureStackTrace && isChromeOrNode) {
	          // avoid error-polyfill
	          if (traceLimit && Error.stackTraceLimit < traceLimit) {
	            prevStackTraceLimit = Error.stackTraceLimit;
	            Error.stackTraceLimit = traceLimit;
	          }
	
	          Error.captureStackTrace(error, toExcludeFromTrace);
	        } else {
	          extraFrames = 3;
	        }
	
	        stack = error.stack;
	        if (prevStackTraceLimit) Error.stackTraceLimit = prevStackTraceLimit;
	
	        if (extraFrames || typeof Error.stackTraceLimit !== 'number' || traceLimit && Error.stackTraceLimit > traceLimit) {
	          if (stack != null) {
	            var frames = stack.split('\n');
	
	            if (traceLimit && frames.length > traceLimit) {
	              stack = frames.slice(0, traceLimit + extraFrames + (frames[0].startsWith('Error') ? 1 : 0)).join('\n');
	            }
	          }
	        }
	      }
	    }
	
	    return {
	      type: ActionTypes.PERFORM_ACTION,
	      action: action,
	      timestamp: Date.now(),
	      stack: stack
	    };
	  },
	  reset: function reset() {
	    return {
	      type: ActionTypes.RESET,
	      timestamp: Date.now()
	    };
	  },
	  rollback: function rollback() {
	    return {
	      type: ActionTypes.ROLLBACK,
	      timestamp: Date.now()
	    };
	  },
	  commit: function commit() {
	    return {
	      type: ActionTypes.COMMIT,
	      timestamp: Date.now()
	    };
	  },
	  sweep: function sweep() {
	    return {
	      type: ActionTypes.SWEEP
	    };
	  },
	  toggleAction: function toggleAction(id) {
	    return {
	      type: ActionTypes.TOGGLE_ACTION,
	      id: id
	    };
	  },
	  setActionsActive: function setActionsActive(start, end) {
	    var active = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    return {
	      type: ActionTypes.SET_ACTIONS_ACTIVE,
	      start: start,
	      end: end,
	      active: active
	    };
	  },
	  reorderAction: function reorderAction(actionId, beforeActionId) {
	    return {
	      type: ActionTypes.REORDER_ACTION,
	      actionId: actionId,
	      beforeActionId: beforeActionId
	    };
	  },
	  jumpToState: function jumpToState(index) {
	    return {
	      type: ActionTypes.JUMP_TO_STATE,
	      index: index
	    };
	  },
	  jumpToAction: function jumpToAction(actionId) {
	    return {
	      type: ActionTypes.JUMP_TO_ACTION,
	      actionId: actionId
	    };
	  },
	  importState: function importState(nextLiftedState, noRecompute) {
	    return {
	      type: ActionTypes.IMPORT_STATE,
	      nextLiftedState: nextLiftedState,
	      noRecompute: noRecompute
	    };
	  },
	  lockChanges: function lockChanges(status) {
	    return {
	      type: ActionTypes.LOCK_CHANGES,
	      status: status
	    };
	  },
	  pauseRecording: function pauseRecording(status) {
	    return {
	      type: ActionTypes.PAUSE_RECORDING,
	      status: status
	    };
	  }
	};
	exports.ActionCreators = ActionCreators;
	var INIT_ACTION = {
	  type: '@@INIT'
	};
	/**
	 * Computes the next entry with exceptions catching.
	 */
	
	exports.INIT_ACTION = INIT_ACTION;
	
	function computeWithTryCatch(reducer, action, state) {
	  var nextState = state;
	  var nextError;
	
	  try {
	    nextState = reducer(state, action);
	  } catch (err) {
	    nextError = err.toString();
	
	    if (isChrome) {
	      // In Chrome, rethrowing provides better source map support
	      setTimeout(function () {
	        throw err;
	      });
	    } else {
	      console.error(err); // eslint-disable-line no-console
	    }
	  }
	
	  return {
	    state: nextState,
	    error: nextError
	  };
	}
	/**
	 * Computes the next entry in the log by applying an action.
	 */
	
	
	function computeNextEntry(reducer, action, state, shouldCatchErrors) {
	  if (!shouldCatchErrors) {
	    return {
	      state: reducer(state, action)
	    };
	  }
	
	  return computeWithTryCatch(reducer, action, state);
	}
	/**
	 * Runs the reducer on invalidated actions to get a fresh computation log.
	 */
	
	
	function recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, shouldCatchErrors) {
	  // Optimization: exit early and return the same reference
	  // if we know nothing could have changed.
	  if (!computedStates || minInvalidatedStateIndex === -1 || minInvalidatedStateIndex >= computedStates.length && computedStates.length === stagedActionIds.length) {
	    return computedStates;
	  }
	
	  var nextComputedStates = computedStates.slice(0, minInvalidatedStateIndex);
	
	  for (var i = minInvalidatedStateIndex; i < stagedActionIds.length; i++) {
	    var _actionId = stagedActionIds[i];
	    var _action = actionsById[_actionId].action;
	    var previousEntry = nextComputedStates[i - 1];
	    var previousState = previousEntry ? previousEntry.state : committedState;
	    var shouldSkip = skippedActionIds.indexOf(_actionId) > -1;
	    var entry = void 0;
	
	    if (shouldSkip) {
	      entry = previousEntry;
	    } else {
	      if (shouldCatchErrors && previousEntry && previousEntry.error) {
	        entry = {
	          state: previousState,
	          error: 'Interrupted by an error up the chain'
	        };
	      } else {
	        entry = computeNextEntry(reducer, _action, previousState, shouldCatchErrors);
	      }
	    }
	
	    nextComputedStates.push(entry);
	  }
	
	  return nextComputedStates;
	}
	/**
	 * Lifts an app's action into an action on the lifted store.
	 */
	
	
	function liftAction(action, trace, traceLimit, // eslint-disable-next-line @typescript-eslint/ban-types
	toExcludeFromTrace) {
	  return ActionCreators.performAction(action, trace, traceLimit, toExcludeFromTrace);
	}
	
	function isArray(nextLiftedState) {
	  return Array.isArray(nextLiftedState);
	}
	
	/**
	 * Creates a history state reducer from an app's reducer.
	 */
	function liftReducerWith(reducer, initialCommittedState, monitorReducer, options) {
	  var initialLiftedState = {
	    monitorState: monitorReducer(undefined, {}),
	    nextActionId: 1,
	    actionsById: {
	      0: liftAction(INIT_ACTION)
	    },
	    stagedActionIds: [0],
	    skippedActionIds: [],
	    committedState: initialCommittedState,
	    currentStateIndex: 0,
	    computedStates: [],
	    isLocked: options.shouldStartLocked === true,
	    isPaused: options.shouldRecordChanges === false
	  };
	  /**
	   * Manages how the history actions modify the history state.
	   */
	
	  return function (liftedState, liftedAction) {
	    var _ref = liftedState || initialLiftedState,
	        monitorState = _ref.monitorState,
	        actionsById = _ref.actionsById,
	        nextActionId = _ref.nextActionId,
	        stagedActionIds = _ref.stagedActionIds,
	        skippedActionIds = _ref.skippedActionIds,
	        committedState = _ref.committedState,
	        currentStateIndex = _ref.currentStateIndex,
	        computedStates = _ref.computedStates,
	        isLocked = _ref.isLocked,
	        isPaused = _ref.isPaused;
	
	    if (!liftedState) {
	      // Prevent mutating initialLiftedState
	      actionsById = _objectSpread({}, actionsById);
	    }
	
	    function commitExcessActions(n) {
	      // Auto-commits n-number of excess actions.
	      var excess = n;
	      var idsToDelete = stagedActionIds.slice(1, excess + 1);
	
	      for (var i = 0; i < idsToDelete.length; i++) {
	        if (computedStates[i + 1].error) {
	          // Stop if error is found. Commit actions up to error.
	          excess = i;
	          idsToDelete = stagedActionIds.slice(1, excess + 1);
	          break;
	        } else {
	          delete actionsById[idsToDelete[i]];
	        }
	      }
	
	      skippedActionIds = skippedActionIds.filter(function (id) {
	        return idsToDelete.indexOf(id) === -1;
	      });
	      stagedActionIds = [0].concat(_toConsumableArray(stagedActionIds.slice(excess + 1)));
	      committedState = computedStates[excess].state;
	      computedStates = computedStates.slice(excess);
	      currentStateIndex = currentStateIndex > excess ? currentStateIndex - excess : 0;
	    }
	
	    function computePausedAction(shouldInit) {
	      var computedState;
	
	      if (shouldInit) {
	        computedState = computedStates[currentStateIndex];
	        monitorState = monitorReducer(monitorState, liftedAction);
	      } else {
	        computedState = computeNextEntry(reducer, liftedAction.action, computedStates[currentStateIndex].state, false);
	      }
	
	      if (!options.pauseActionType || nextActionId === 1) {
	        return {
	          monitorState: monitorState,
	          actionsById: {
	            0: liftAction(INIT_ACTION)
	          },
	          nextActionId: 1,
	          stagedActionIds: [0],
	          skippedActionIds: [],
	          committedState: computedState.state,
	          currentStateIndex: 0,
	          computedStates: [computedState],
	          isLocked: isLocked,
	          isPaused: true
	        };
	      }
	
	      if (shouldInit) {
	        if (currentStateIndex === stagedActionIds.length - 1) {
	          currentStateIndex++;
	        }
	
	        stagedActionIds = [].concat(_toConsumableArray(stagedActionIds), [nextActionId]);
	        nextActionId++;
	      }
	
	      return {
	        monitorState: monitorState,
	        actionsById: _objectSpread(_objectSpread({}, actionsById), {}, _defineProperty({}, nextActionId - 1, liftAction({
	          type: options.pauseActionType
	        }))),
	        nextActionId: nextActionId,
	        stagedActionIds: stagedActionIds,
	        skippedActionIds: skippedActionIds,
	        committedState: committedState,
	        currentStateIndex: currentStateIndex,
	        computedStates: [].concat(_toConsumableArray(computedStates.slice(0, stagedActionIds.length - 1)), [computedState]),
	        isLocked: isLocked,
	        isPaused: true
	      };
	    } // By default, aggressively recompute every state whatever happens.
	    // This has O(n) performance, so we'll override this to a sensible
	    // value whenever we feel like we don't have to recompute the states.
	
	
	    var minInvalidatedStateIndex = 0; // maxAge number can be changed dynamically
	
	    var maxAge = options.maxAge;
	    if (typeof maxAge === 'function') maxAge = maxAge(liftedAction, liftedState);
	
	    if (/^@@redux\/(INIT|REPLACE)/.test(liftedAction.type)) {
	      if (options.shouldHotReload === false) {
	        actionsById = {
	          0: liftAction(INIT_ACTION)
	        };
	        nextActionId = 1;
	        stagedActionIds = [0];
	        skippedActionIds = [];
	        committedState = computedStates.length === 0 ? initialCommittedState : computedStates[currentStateIndex].state;
	        currentStateIndex = 0;
	        computedStates = [];
	      } // Recompute states on hot reload and init.
	
	
	      minInvalidatedStateIndex = 0;
	
	      if (maxAge && stagedActionIds.length > maxAge) {
	        // States must be recomputed before committing excess.
	        computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);
	        commitExcessActions(stagedActionIds.length - maxAge); // Avoid double computation.
	
	        minInvalidatedStateIndex = Infinity;
	      }
	    } else {
	      switch (liftedAction.type) {
	        case ActionTypes.PERFORM_ACTION:
	          {
	            if (isLocked) return liftedState || initialLiftedState;
	            if (isPaused) return computePausedAction(); // Auto-commit as new actions come in.
	
	            if (maxAge && stagedActionIds.length >= maxAge) {
	              commitExcessActions(stagedActionIds.length - maxAge + 1);
	            }
	
	            if (currentStateIndex === stagedActionIds.length - 1) {
	              currentStateIndex++;
	            }
	
	            var _actionId2 = nextActionId++; // Mutation! This is the hottest path, and we optimize on purpose.
	            // It is safe because we set a new key in a cache dictionary.
	
	
	            actionsById[_actionId2] = liftedAction;
	            stagedActionIds = [].concat(_toConsumableArray(stagedActionIds), [_actionId2]); // Optimization: we know that only the new action needs computing.
	
	            minInvalidatedStateIndex = stagedActionIds.length - 1;
	            break;
	          }
	
	        case ActionTypes.RESET:
	          {
	            // Get back to the state the store was created with.
	            actionsById = {
	              0: liftAction(INIT_ACTION)
	            };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            committedState = initialCommittedState;
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	
	        case ActionTypes.COMMIT:
	          {
	            // Consider the last committed state the new starting point.
	            // Squash any staged actions into a single committed state.
	            actionsById = {
	              0: liftAction(INIT_ACTION)
	            };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            committedState = computedStates[currentStateIndex].state;
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	
	        case ActionTypes.ROLLBACK:
	          {
	            // Forget about any staged actions.
	            // Start again from the last committed state.
	            actionsById = {
	              0: liftAction(INIT_ACTION)
	            };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	
	        case ActionTypes.TOGGLE_ACTION:
	          {
	            // Toggle whether an action with given ID is skipped.
	            // Being skipped means it is a no-op during the computation.
	            var _actionId3 = liftedAction.id;
	            var index = skippedActionIds.indexOf(_actionId3);
	
	            if (index === -1) {
	              skippedActionIds = [_actionId3].concat(_toConsumableArray(skippedActionIds));
	            } else {
	              skippedActionIds = skippedActionIds.filter(function (id) {
	                return id !== _actionId3;
	              });
	            } // Optimization: we know history before this action hasn't changed
	
	
	            minInvalidatedStateIndex = stagedActionIds.indexOf(_actionId3);
	            break;
	          }
	
	        case ActionTypes.SET_ACTIONS_ACTIVE:
	          {
	            // Toggle whether an action with given ID is skipped.
	            // Being skipped means it is a no-op during the computation.
	            var start = liftedAction.start,
	                end = liftedAction.end,
	                active = liftedAction.active;
	            var actionIds = [];
	
	            for (var i = start; i < end; i++) {
	              actionIds.push(i);
	            }
	
	            if (active) {
	              skippedActionIds = (0, _difference["default"])(skippedActionIds, actionIds);
	            } else {
	              skippedActionIds = (0, _union["default"])(skippedActionIds, actionIds);
	            } // Optimization: we know history before this action hasn't changed
	
	
	            minInvalidatedStateIndex = stagedActionIds.indexOf(start);
	            break;
	          }
	
	        case ActionTypes.JUMP_TO_STATE:
	          {
	            // Without recomputing anything, move the pointer that tell us
	            // which state is considered the current one. Useful for sliders.
	            currentStateIndex = liftedAction.index; // Optimization: we know the history has not changed.
	
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	
	        case ActionTypes.JUMP_TO_ACTION:
	          {
	            // Jumps to a corresponding state to a specific action.
	            // Useful when filtering actions.
	            var _index = stagedActionIds.indexOf(liftedAction.actionId);
	
	            if (_index !== -1) currentStateIndex = _index;
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	
	        case ActionTypes.SWEEP:
	          {
	            // Forget any actions that are currently being skipped.
	            stagedActionIds = (0, _difference["default"])(stagedActionIds, skippedActionIds);
	            skippedActionIds = [];
	            currentStateIndex = Math.min(currentStateIndex, stagedActionIds.length - 1);
	            break;
	          }
	
	        case ActionTypes.REORDER_ACTION:
	          {
	            // Recompute actions in a new order.
	            var _actionId4 = liftedAction.actionId;
	            var idx = stagedActionIds.indexOf(_actionId4); // do nothing in case the action is already removed or trying to move the first action
	
	            if (idx < 1) break;
	            var beforeActionId = liftedAction.beforeActionId;
	            var newIdx = stagedActionIds.indexOf(beforeActionId);
	
	            if (newIdx < 1) {
	              // move to the beginning or to the end
	              var count = stagedActionIds.length;
	              newIdx = beforeActionId > stagedActionIds[count - 1] ? count : 1;
	            }
	
	            var diff = idx - newIdx;
	
	            if (diff > 0) {
	              // move left
	              stagedActionIds = [].concat(_toConsumableArray(stagedActionIds.slice(0, newIdx)), [_actionId4], _toConsumableArray(stagedActionIds.slice(newIdx, idx)), _toConsumableArray(stagedActionIds.slice(idx + 1)));
	              minInvalidatedStateIndex = newIdx;
	            } else if (diff < 0) {
	              // move right
	              stagedActionIds = [].concat(_toConsumableArray(stagedActionIds.slice(0, idx)), _toConsumableArray(stagedActionIds.slice(idx + 1, newIdx)), [_actionId4], _toConsumableArray(stagedActionIds.slice(newIdx)));
	              minInvalidatedStateIndex = idx;
	            }
	
	            break;
	          }
	
	        case ActionTypes.IMPORT_STATE:
	          {
	            if (isArray(liftedAction.nextLiftedState)) {
	              // recompute array of actions
	              actionsById = {
	                0: liftAction(INIT_ACTION)
	              };
	              nextActionId = 1;
	              stagedActionIds = [0];
	              skippedActionIds = [];
	              currentStateIndex = liftedAction.nextLiftedState.length;
	              computedStates = [];
	              committedState = liftedAction.preloadedState;
	              minInvalidatedStateIndex = 0; // iterate through actions
	
	              liftedAction.nextLiftedState.forEach(function (action) {
	                actionsById[nextActionId] = liftAction(action, options.trace || options.shouldIncludeCallstack);
	                stagedActionIds.push(nextActionId);
	                nextActionId++;
	              });
	            } else {
	              // Completely replace everything.
	              var _liftedAction$nextLif = liftedAction.nextLiftedState;
	              monitorState = _liftedAction$nextLif.monitorState;
	              actionsById = _liftedAction$nextLif.actionsById;
	              nextActionId = _liftedAction$nextLif.nextActionId;
	              stagedActionIds = _liftedAction$nextLif.stagedActionIds;
	              skippedActionIds = _liftedAction$nextLif.skippedActionIds;
	              committedState = _liftedAction$nextLif.committedState;
	              currentStateIndex = _liftedAction$nextLif.currentStateIndex;
	              computedStates = _liftedAction$nextLif.computedStates;
	
	              if (liftedAction.noRecompute) {
	                minInvalidatedStateIndex = Infinity;
	              }
	            }
	
	            break;
	          }
	
	        case ActionTypes.LOCK_CHANGES:
	          {
	            isLocked = liftedAction.status;
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	
	        case ActionTypes.PAUSE_RECORDING:
	          {
	            isPaused = liftedAction.status;
	
	            if (isPaused) {
	              return computePausedAction(true);
	            } // Commit when unpausing
	
	
	            actionsById = {
	              0: liftAction(INIT_ACTION)
	            };
	            nextActionId = 1;
	            stagedActionIds = [0];
	            skippedActionIds = [];
	            committedState = computedStates[currentStateIndex].state;
	            currentStateIndex = 0;
	            computedStates = [];
	            break;
	          }
	
	        default:
	          {
	            // If the action is not recognized, it's a monitor action.
	            // Optimization: a monitor action can't change history.
	            minInvalidatedStateIndex = Infinity;
	            break;
	          }
	      }
	    }
	
	    computedStates = recomputeStates(computedStates, minInvalidatedStateIndex, reducer, committedState, actionsById, stagedActionIds, skippedActionIds, options.shouldCatchErrors);
	    monitorState = monitorReducer(monitorState, liftedAction);
	    return {
	      monitorState: monitorState,
	      actionsById: actionsById,
	      nextActionId: nextActionId,
	      stagedActionIds: stagedActionIds,
	      skippedActionIds: skippedActionIds,
	      committedState: committedState,
	      currentStateIndex: currentStateIndex,
	      computedStates: computedStates,
	      isLocked: isLocked,
	      isPaused: isPaused
	    };
	  };
	}
	/**
	 * Provides an app's view into the state of the lifted store.
	 */
	
	
	function unliftState(liftedState) {
	  var computedStates = liftedState.computedStates,
	      currentStateIndex = liftedState.currentStateIndex;
	  var state = computedStates[currentStateIndex].state;
	  return state;
	}
	
	/**
	 * Provides an app's view into the lifted store.
	 */
	function unliftStore(liftedStore, liftReducer, options) {
	  var lastDefinedState;
	  var trace = options.trace || options.shouldIncludeCallstack;
	  var traceLimit = options.traceLimit || 10;
	
	  function getState() {
	    var state = unliftState(liftedStore.getState());
	
	    if (state !== undefined) {
	      lastDefinedState = state;
	    }
	
	    return lastDefinedState;
	  }
	
	  function dispatch(action) {
	    liftedStore.dispatch(liftAction(action, trace, traceLimit, dispatch));
	    return action;
	  }
	
	  return _objectSpread(_objectSpread({}, liftedStore), {}, _defineProperty({
	    liftedStore: liftedStore,
	    dispatch: dispatch,
	    getState: getState,
	    replaceReducer: function replaceReducer(nextReducer) {
	      liftedStore.replaceReducer(liftReducer(nextReducer));
	    }
	  }, _symbolObservable["default"], function () {
	    return _objectSpread(_objectSpread({}, liftedStore[_symbolObservable["default"]]()), {}, _defineProperty({
	      subscribe: function subscribe(observer) {
	        if (_typeof(observer) !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = liftedStore.subscribe(observeState);
	        return {
	          unsubscribe: unsubscribe
	        };
	      }
	    }, _symbolObservable["default"], function () {
	      return this;
	    }));
	  }));
	}
	
	/**
	 * Redux instrumentation store enhancer.
	 */
	function instrument() {
	  var monitorReducer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {
	    return null;
	  };
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options.maxAge === 'number' && options.maxAge < 2) {
	    throw new Error('DevTools.instrument({ maxAge }) option, if specified, ' + 'may not be less than 2.');
	  }
	
	  return function (createStore) {
	    return function (reducer, initialState) {
	      function liftReducer(r) {
	        if (typeof r !== 'function') {
	          if (r && typeof r["default"] === 'function') {
	            throw new Error('Expected the reducer to be a function. ' + 'Instead got an object with a "default" field. ' + 'Did you pass a module instead of the default export? ' + 'Try passing require(...).default instead.');
	          }
	
	          throw new Error('Expected the reducer to be a function.');
	        }
	
	        return liftReducerWith(r, initialState, monitorReducer, options);
	      }
	
	      var liftedStore = createStore(liftReducer(reducer));
	
	      if (liftedStore.liftedStore) {
	        throw new Error('DevTools instrumentation should not be applied more than once. ' + 'Check your store configuration.');
	      }
	
	      return unliftStore(liftedStore, liftReducer, options);
	    };
	  };
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ },
/* 1172 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.updateScrollTop = updateScrollTop;
	exports.startConsecutiveToggle = startConsecutiveToggle;
	var UPDATE_SCROLL_TOP = exports.UPDATE_SCROLL_TOP = '@@redux-devtools-log-monitor/UPDATE_SCROLL_TOP';
	function updateScrollTop(scrollTop) {
	  return { type: UPDATE_SCROLL_TOP, scrollTop: scrollTop };
	}
	
	var START_CONSECUTIVE_TOGGLE = exports.START_CONSECUTIVE_TOGGLE = '@@redux-devtools-log-monitor/START_CONSECUTIVE_TOGGLE';
	function startConsecutiveToggle(id) {
	  return { type: START_CONSECUTIVE_TOGGLE, id: id };
	}

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var JSONArrow = function JSONArrow(_ref) {
	  var styling = _ref.styling,
	      arrowStyle = _ref.arrowStyle,
	      expanded = _ref.expanded,
	      nodeType = _ref.nodeType,
	      onClick = _ref.onClick;
	  return _react2['default'].createElement(
	    'div',
	    (0, _extends3['default'])({}, styling('arrowContainer', arrowStyle), { onClick: onClick }),
	    _react2['default'].createElement(
	      'div',
	      styling(['arrow', 'arrowSign'], nodeType, expanded, arrowStyle),
	      '\u25B6',
	      arrowStyle === 'double' && _react2['default'].createElement(
	        'div',
	        styling(['arrowSign', 'arrowSignInner']),
	        '\u25B6'
	      )
	    )
	  );
	};
	
	JSONArrow.propTypes = {
	  styling: _propTypes2['default'].func.isRequired,
	  arrowStyle: _propTypes2['default'].oneOf(['single', 'double']),
	  expanded: _propTypes2['default'].bool.isRequired,
	  nodeType: _propTypes2['default'].string.isRequired,
	  onClick: _propTypes2['default'].func.isRequired
	};
	
	JSONArrow.defaultProps = {
	  arrowStyle: 'single'
	};
	
	exports['default'] = JSONArrow;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _objType = __webpack_require__(2922);
	
	var _objType2 = _interopRequireDefault(_objType);
	
	var _JSONObjectNode = __webpack_require__(2918);
	
	var _JSONObjectNode2 = _interopRequireDefault(_JSONObjectNode);
	
	var _JSONArrayNode = __webpack_require__(2916);
	
	var _JSONArrayNode2 = _interopRequireDefault(_JSONArrayNode);
	
	var _JSONIterableNode = __webpack_require__(2917);
	
	var _JSONIterableNode2 = _interopRequireDefault(_JSONIterableNode);
	
	var _JSONValueNode = __webpack_require__(2919);
	
	var _JSONValueNode2 = _interopRequireDefault(_JSONValueNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var JSONNode = function JSONNode(_ref) {
	  var getItemString = _ref.getItemString,
	      keyPath = _ref.keyPath,
	      labelRenderer = _ref.labelRenderer,
	      styling = _ref.styling,
	      value = _ref.value,
	      valueRenderer = _ref.valueRenderer,
	      isCustomNode = _ref.isCustomNode,
	      rest = (0, _objectWithoutProperties3['default'])(_ref, ['getItemString', 'keyPath', 'labelRenderer', 'styling', 'value', 'valueRenderer', 'isCustomNode']);
	
	  var nodeType = isCustomNode(value) ? 'Custom' : (0, _objType2['default'])(value);
	
	  var simpleNodeProps = {
	    getItemString: getItemString,
	    key: keyPath[0],
	    keyPath: keyPath,
	    labelRenderer: labelRenderer,
	    nodeType: nodeType,
	    styling: styling,
	    value: value,
	    valueRenderer: valueRenderer
	  };
	
	  var nestedNodeProps = (0, _extends3['default'])({}, rest, simpleNodeProps, {
	    data: value,
	    isCustomNode: isCustomNode
	  });
	
	  switch (nodeType) {
	    case 'Object':
	    case 'Error':
	    case 'WeakMap':
	    case 'WeakSet':
	      return _react2['default'].createElement(_JSONObjectNode2['default'], nestedNodeProps);
	    case 'Array':
	      return _react2['default'].createElement(_JSONArrayNode2['default'], nestedNodeProps);
	    case 'Iterable':
	    case 'Map':
	    case 'Set':
	      return _react2['default'].createElement(_JSONIterableNode2['default'], nestedNodeProps);
	    case 'String':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter(raw) {
	          return '"' + raw + '"';
	        } }));
	    case 'Number':
	      return _react2['default'].createElement(_JSONValueNode2['default'], simpleNodeProps);
	    case 'Boolean':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, {
	        valueGetter: function valueGetter(raw) {
	          return raw ? 'true' : 'false';
	        }
	      }));
	    case 'Date':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, {
	        valueGetter: function valueGetter(raw) {
	          return raw.toISOString();
	        }
	      }));
	    case 'Null':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter() {
	          return 'null';
	        } }));
	    case 'Undefined':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter() {
	          return 'undefined';
	        } }));
	    case 'Function':
	    case 'Symbol':
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, {
	        valueGetter: function valueGetter(raw) {
	          return raw.toString();
	        }
	      }));
	    case 'Custom':
	      return _react2['default'].createElement(_JSONValueNode2['default'], simpleNodeProps);
	    default:
	      return _react2['default'].createElement(_JSONValueNode2['default'], (0, _extends3['default'])({}, simpleNodeProps, { valueGetter: function valueGetter(raw) {
	          return '<' + nodeType + '>';
	        } }));
	  }
	};
	
	JSONNode.propTypes = {
	  getItemString: _propTypes2['default'].func.isRequired,
	  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
	  labelRenderer: _propTypes2['default'].func.isRequired,
	  styling: _propTypes2['default'].func.isRequired,
	  value: _propTypes2['default'].any,
	  valueRenderer: _propTypes2['default'].func.isRequired,
	  isCustomNode: _propTypes2['default'].func.isRequired
	};
	
	exports['default'] = JSONNode;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(329);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _JSONNode = __webpack_require__(1174);
	
	var _JSONNode2 = _interopRequireDefault(_JSONNode);
	
	var _createStylingFromTheme = __webpack_require__(2920);
	
	var _createStylingFromTheme2 = _interopRequireDefault(_createStylingFromTheme);
	
	var _reactBase16Styling = __webpack_require__(1127);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var identity = function identity(value) {
	  return value;
	}; // ES6 + inline style port of JSONViewer https://bitbucket.org/davevedder/react-json-viewer/
	// all credits and original code to the author
	// Dave Vedder <veddermatic@gmail.com> http://www.eskimospy.com/
	// port by Daniele Zannotti http://www.github.com/dzannotti <dzannotti@me.com>
	
	var expandRootNode = function expandRootNode(keyName, data, level) {
	  return level === 0;
	};
	var defaultItemString = function defaultItemString(type, data, itemType, itemString) {
	  return _react2['default'].createElement(
	    'span',
	    null,
	    itemType,
	    ' ',
	    itemString
	  );
	};
	var defaultLabelRenderer = function defaultLabelRenderer(_ref) {
	  var label = _ref[0];
	  return _react2['default'].createElement(
	    'span',
	    null,
	    label,
	    ':'
	  );
	};
	var noCustomNode = function noCustomNode() {
	  return false;
	};
	
	function checkLegacyTheming(theme, props) {
	  var deprecatedStylingMethodsMap = {
	    getArrowStyle: 'arrow',
	    getListStyle: 'nestedNodeChildren',
	    getItemStringStyle: 'nestedNodeItemString',
	    getLabelStyle: 'label',
	    getValueStyle: 'valueText'
	  };
	
	  var deprecatedStylingMethods = (0, _keys2['default'])(deprecatedStylingMethodsMap).filter(function (name) {
	    return props[name];
	  });
	
	  if (deprecatedStylingMethods.length > 0) {
	    if (typeof theme === 'string') {
	      theme = {
	        extend: theme
	      };
	    } else {
	      theme = (0, _extends3['default'])({}, theme);
	    }
	
	    deprecatedStylingMethods.forEach(function (name) {
	      // eslint-disable-next-line no-console
	      console.error('Styling method "' + name + '" is deprecated, use "theme" property instead');
	
	      theme[deprecatedStylingMethodsMap[name]] = function (_ref2) {
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        var style = _ref2.style;
	        return {
	          style: (0, _extends3['default'])({}, style, props[name].apply(props, args))
	        };
	      };
	    });
	  }
	
	  return theme;
	}
	
	function getStateFromProps(props) {
	  var theme = checkLegacyTheming(props.theme, props);
	  if (props.invertTheme) {
	    if (typeof theme === 'string') {
	      theme = theme + ':inverted';
	    } else if (theme && theme.extend) {
	      if (typeof theme === 'string') {
	        theme = (0, _extends3['default'])({}, theme, { extend: theme.extend + ':inverted' });
	      } else {
	        theme = (0, _extends3['default'])({}, theme, { extend: (0, _reactBase16Styling.invertTheme)(theme.extend) });
	      }
	    } else if (theme) {
	      theme = (0, _reactBase16Styling.invertTheme)(theme);
	    }
	  }
	  return {
	    styling: (0, _createStylingFromTheme2['default'])(theme)
	  };
	}
	
	var JSONTree = function (_React$Component) {
	  (0, _inherits3['default'])(JSONTree, _React$Component);
	
	  function JSONTree(props) {
	    (0, _classCallCheck3['default'])(this, JSONTree);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.state = getStateFromProps(props);
	    return _this;
	  }
	
	  JSONTree.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var _this2 = this;
	
	    if (['theme', 'invertTheme'].find(function (k) {
	      return nextProps[k] !== _this2.props[k];
	    })) {
	      this.setState(getStateFromProps(nextProps));
	    }
	  };
	
	  JSONTree.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var _this3 = this;
	
	    return !!(0, _keys2['default'])(nextProps).find(function (k) {
	      return k === 'keyPath' ? nextProps[k].join('/') !== _this3.props[k].join('/') : nextProps[k] !== _this3.props[k];
	    });
	  };
	
	  JSONTree.prototype.render = function render() {
	    var _props = this.props,
	        value = _props.data,
	        keyPath = _props.keyPath,
	        postprocessValue = _props.postprocessValue,
	        hideRoot = _props.hideRoot,
	        theme = _props.theme,
	        _ = _props.invertTheme,
	        rest = (0, _objectWithoutProperties3['default'])(_props, ['data', 'keyPath', 'postprocessValue', 'hideRoot', 'theme', 'invertTheme']);
	    var styling = this.state.styling;
	
	
	    return _react2['default'].createElement(
	      'ul',
	      styling('tree'),
	      _react2['default'].createElement(_JSONNode2['default'], (0, _extends3['default'])({}, (0, _extends3['default'])({ postprocessValue: postprocessValue, hideRoot: hideRoot, styling: styling }, rest), {
	        keyPath: hideRoot ? [] : keyPath,
	        value: postprocessValue(value)
	      }))
	    );
	  };
	
	  return JSONTree;
	}(_react2['default'].Component);
	
	JSONTree.propTypes = {
	  data: _propTypes2['default'].oneOfType([_propTypes2['default'].array, _propTypes2['default'].object]).isRequired,
	  hideRoot: _propTypes2['default'].bool,
	  theme: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].string]),
	  invertTheme: _propTypes2['default'].bool,
	  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])),
	  postprocessValue: _propTypes2['default'].func,
	  sortObjectKeys: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].bool])
	};
	JSONTree.defaultProps = {
	  shouldExpandNode: expandRootNode,
	  hideRoot: false,
	  keyPath: ['root'],
	  getItemString: defaultItemString,
	  labelRenderer: defaultLabelRenderer,
	  valueRenderer: identity,
	  postprocessValue: identity,
	  isCustomNode: noCustomNode,
	  collectionLimit: 50,
	  invertTheme: true
	};
	exports['default'] = JSONTree;

/***/ },
/* 1176 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var repeat = exports.repeat = function repeat(str, times) {
	  return new Array(times + 1).join(str);
	};
	
	var pad = exports.pad = function pad(num, maxLength) {
	  return repeat("0", maxLength - num.toString().length) + num;
	};
	
	var formatTime = exports.formatTime = function formatTime(time) {
	  return pad(time.getHours(), 2) + ":" + pad(time.getMinutes(), 2) + ":" + pad(time.getSeconds(), 2) + "." + pad(time.getMilliseconds(), 3);
	};
	
	// Use performance API if it's available in order to get better precision
	var timer = exports.timer = typeof performance !== "undefined" && performance !== null && typeof performance.now === "function" ? performance : Date;

/***/ },
/* 1177 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/** A function that accepts a potential "extra argument" value to be injected later,
	 * and returns an instance of the thunk middleware that uses that value
	 */
	function createThunkMiddleware(extraArgument) {
	  // Standard Redux middleware definition pattern:
	  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
	  var middleware = function middleware(_ref) {
	    var dispatch = _ref.dispatch,
	        getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
	        // If this "action" is really a function, call it and return the result.
	        if (typeof action === 'function') {
	          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
	          return action(dispatch, getState, extraArgument);
	        } // Otherwise, pass the action down the middleware chain as usual
	
	
	        return next(action);
	      };
	    };
	  };
	
	  return middleware;
	}
	
	var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
	// with whatever "extra arg" they want to inject into their thunks
	
	thunk.withExtraArgument = createThunkMiddleware;
	var _default = thunk;
	exports.default = _default;

/***/ },
/* 1178 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(379);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(1182);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 1180 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 1181 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2014, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	 * additional grant of patent rights can be found in the PATENTS file in
	 * the same directory.
	 */
	
	!(function(global) {
	  "use strict";
	
	  var Op = Object.prototype;
	  var hasOwn = Op.hasOwnProperty;
	  var undefined; // More compressible than void 0.
	  var $Symbol = typeof Symbol === "function" ? Symbol : {};
	  var iteratorSymbol = $Symbol.iterator || "@@iterator";
	  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
	  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	  var inModule = typeof module === "object";
	  var runtime = global.regeneratorRuntime;
	  if (runtime) {
	    if (inModule) {
	      // If regeneratorRuntime is defined globally and we're in a module,
	      // make the exports object identical to regeneratorRuntime.
	      module.exports = runtime;
	    }
	    // Don't bother evaluating the rest of this file if the runtime was
	    // already defined globally.
	    return;
	  }
	
	  // Define the runtime globally (as expected by generated code) as either
	  // module.exports (if we're in a module) or a new, empty object.
	  runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	  function wrap(innerFn, outerFn, self, tryLocsList) {
	    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	    var generator = Object.create(protoGenerator.prototype);
	    var context = new Context(tryLocsList || []);
	
	    // The ._invoke method unifies the implementations of the .next,
	    // .throw, and .return methods.
	    generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	    return generator;
	  }
	  runtime.wrap = wrap;
	
	  // Try/catch helper to minimize deoptimizations. Returns a completion
	  // record like context.tryEntries[i].completion. This interface could
	  // have been (and was previously) designed to take a closure to be
	  // invoked without arguments, but in all the cases we care about we
	  // already have an existing method we want to call, so there's no need
	  // to create a new function object. We can even get away with assuming
	  // the method takes exactly one argument, since that happens to be true
	  // in every case, so we don't have to touch the arguments object. The
	  // only additional allocation required is the completion record, which
	  // has a stable shape and so hopefully should be cheap to allocate.
	  function tryCatch(fn, obj, arg) {
	    try {
	      return { type: "normal", arg: fn.call(obj, arg) };
	    } catch (err) {
	      return { type: "throw", arg: err };
	    }
	  }
	
	  var GenStateSuspendedStart = "suspendedStart";
	  var GenStateSuspendedYield = "suspendedYield";
	  var GenStateExecuting = "executing";
	  var GenStateCompleted = "completed";
	
	  // Returning this object from the innerFn has the same effect as
	  // breaking out of the dispatch switch statement.
	  var ContinueSentinel = {};
	
	  // Dummy constructor functions that we use as the .constructor and
	  // .constructor.prototype properties for functions that return Generator
	  // objects. For full spec compliance, you may wish to configure your
	  // minifier not to mangle the names of these two functions.
	  function Generator() {}
	  function GeneratorFunction() {}
	  function GeneratorFunctionPrototype() {}
	
	  // This is a polyfill for %IteratorPrototype% for environments that
	  // don't natively support it.
	  var IteratorPrototype = {};
	  IteratorPrototype[iteratorSymbol] = function () {
	    return this;
	  };
	
	  var getProto = Object.getPrototypeOf;
	  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	  if (NativeIteratorPrototype &&
	      NativeIteratorPrototype !== Op &&
	      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	    // This environment has a native %IteratorPrototype%; use it instead
	    // of the polyfill.
	    IteratorPrototype = NativeIteratorPrototype;
	  }
	
	  var Gp = GeneratorFunctionPrototype.prototype =
	    Generator.prototype = Object.create(IteratorPrototype);
	  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	  GeneratorFunctionPrototype.constructor = GeneratorFunction;
	  GeneratorFunctionPrototype[toStringTagSymbol] =
	    GeneratorFunction.displayName = "GeneratorFunction";
	
	  // Helper for defining the .next, .throw, and .return methods of the
	  // Iterator interface in terms of a single ._invoke method.
	  function defineIteratorMethods(prototype) {
	    ["next", "throw", "return"].forEach(function(method) {
	      prototype[method] = function(arg) {
	        return this._invoke(method, arg);
	      };
	    });
	  }
	
	  runtime.isGeneratorFunction = function(genFun) {
	    var ctor = typeof genFun === "function" && genFun.constructor;
	    return ctor
	      ? ctor === GeneratorFunction ||
	        // For the native GeneratorFunction constructor, the best we can
	        // do is to check its .name property.
	        (ctor.displayName || ctor.name) === "GeneratorFunction"
	      : false;
	  };
	
	  runtime.mark = function(genFun) {
	    if (Object.setPrototypeOf) {
	      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	    } else {
	      genFun.__proto__ = GeneratorFunctionPrototype;
	      if (!(toStringTagSymbol in genFun)) {
	        genFun[toStringTagSymbol] = "GeneratorFunction";
	      }
	    }
	    genFun.prototype = Object.create(Gp);
	    return genFun;
	  };
	
	  // Within the body of any async function, `await x` is transformed to
	  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	  // `hasOwn.call(value, "__await")` to determine if the yielded value is
	  // meant to be awaited.
	  runtime.awrap = function(arg) {
	    return { __await: arg };
	  };
	
	  function AsyncIterator(generator) {
	    function invoke(method, arg, resolve, reject) {
	      var record = tryCatch(generator[method], generator, arg);
	      if (record.type === "throw") {
	        reject(record.arg);
	      } else {
	        var result = record.arg;
	        var value = result.value;
	        if (value &&
	            typeof value === "object" &&
	            hasOwn.call(value, "__await")) {
	          return Promise.resolve(value.__await).then(function(value) {
	            invoke("next", value, resolve, reject);
	          }, function(err) {
	            invoke("throw", err, resolve, reject);
	          });
	        }
	
	        return Promise.resolve(value).then(function(unwrapped) {
	          // When a yielded Promise is resolved, its final value becomes
	          // the .value of the Promise<{value,done}> result for the
	          // current iteration. If the Promise is rejected, however, the
	          // result for this iteration will be rejected with the same
	          // reason. Note that rejections of yielded Promises are not
	          // thrown back into the generator function, as is the case
	          // when an awaited Promise is rejected. This difference in
	          // behavior between yield and await is important, because it
	          // allows the consumer to decide what to do with the yielded
	          // rejection (swallow it and continue, manually .throw it back
	          // into the generator, abandon iteration, whatever). With
	          // await, by contrast, there is no opportunity to examine the
	          // rejection reason outside the generator function, so the
	          // only option is to throw it from the await expression, and
	          // let the generator function handle the exception.
	          result.value = unwrapped;
	          resolve(result);
	        }, reject);
	      }
	    }
	
	    if (typeof global.process === "object" && global.process.domain) {
	      invoke = global.process.domain.bind(invoke);
	    }
	
	    var previousPromise;
	
	    function enqueue(method, arg) {
	      function callInvokeWithMethodAndArg() {
	        return new Promise(function(resolve, reject) {
	          invoke(method, arg, resolve, reject);
	        });
	      }
	
	      return previousPromise =
	        // If enqueue has been called before, then we want to wait until
	        // all previous Promises have been resolved before calling invoke,
	        // so that results are always delivered in the correct order. If
	        // enqueue has not been called before, then it is important to
	        // call invoke immediately, without waiting on a callback to fire,
	        // so that the async generator function has the opportunity to do
	        // any necessary setup in a predictable way. This predictability
	        // is why the Promise constructor synchronously invokes its
	        // executor callback, and why async functions synchronously
	        // execute code before the first await. Since we implement simple
	        // async functions in terms of async generators, it is especially
	        // important to get this right, even though it requires care.
	        previousPromise ? previousPromise.then(
	          callInvokeWithMethodAndArg,
	          // Avoid propagating failures to Promises returned by later
	          // invocations of the iterator.
	          callInvokeWithMethodAndArg
	        ) : callInvokeWithMethodAndArg();
	    }
	
	    // Define the unified helper method that is used to implement .next,
	    // .throw, and .return (see defineIteratorMethods).
	    this._invoke = enqueue;
	  }
	
	  defineIteratorMethods(AsyncIterator.prototype);
	  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
	    return this;
	  };
	  runtime.AsyncIterator = AsyncIterator;
	
	  // Note that simple async functions are implemented on top of
	  // AsyncIterator objects; they just return a Promise for the value of
	  // the final result produced by the iterator.
	  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
	    var iter = new AsyncIterator(
	      wrap(innerFn, outerFn, self, tryLocsList)
	    );
	
	    return runtime.isGeneratorFunction(outerFn)
	      ? iter // If outerFn is a generator, return the full iterator.
	      : iter.next().then(function(result) {
	          return result.done ? result.value : iter.next();
	        });
	  };
	
	  function makeInvokeMethod(innerFn, self, context) {
	    var state = GenStateSuspendedStart;
	
	    return function invoke(method, arg) {
	      if (state === GenStateExecuting) {
	        throw new Error("Generator is already running");
	      }
	
	      if (state === GenStateCompleted) {
	        if (method === "throw") {
	          throw arg;
	        }
	
	        // Be forgiving, per 25.3.3.3.3 of the spec:
	        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	        return doneResult();
	      }
	
	      context.method = method;
	      context.arg = arg;
	
	      while (true) {
	        var delegate = context.delegate;
	        if (delegate) {
	          var delegateResult = maybeInvokeDelegate(delegate, context);
	          if (delegateResult) {
	            if (delegateResult === ContinueSentinel) continue;
	            return delegateResult;
	          }
	        }
	
	        if (context.method === "next") {
	          // Setting context._sent for legacy support of Babel's
	          // function.sent implementation.
	          context.sent = context._sent = context.arg;
	
	        } else if (context.method === "throw") {
	          if (state === GenStateSuspendedStart) {
	            state = GenStateCompleted;
	            throw context.arg;
	          }
	
	          context.dispatchException(context.arg);
	
	        } else if (context.method === "return") {
	          context.abrupt("return", context.arg);
	        }
	
	        state = GenStateExecuting;
	
	        var record = tryCatch(innerFn, self, context);
	        if (record.type === "normal") {
	          // If an exception is thrown from innerFn, we leave state ===
	          // GenStateExecuting and loop back for another invocation.
	          state = context.done
	            ? GenStateCompleted
	            : GenStateSuspendedYield;
	
	          if (record.arg === ContinueSentinel) {
	            continue;
	          }
	
	          return {
	            value: record.arg,
	            done: context.done
	          };
	
	        } else if (record.type === "throw") {
	          state = GenStateCompleted;
	          // Dispatch the exception by looping back around to the
	          // context.dispatchException(context.arg) call above.
	          context.method = "throw";
	          context.arg = record.arg;
	        }
	      }
	    };
	  }
	
	  // Call delegate.iterator[context.method](context.arg) and handle the
	  // result, either by returning a { value, done } result from the
	  // delegate iterator, or by modifying context.method and context.arg,
	  // setting context.delegate to null, and returning the ContinueSentinel.
	  function maybeInvokeDelegate(delegate, context) {
	    var method = delegate.iterator[context.method];
	    if (method === undefined) {
	      // A .throw or .return when the delegate iterator has no .throw
	      // method always terminates the yield* loop.
	      context.delegate = null;
	
	      if (context.method === "throw") {
	        if (delegate.iterator.return) {
	          // If the delegate iterator has a return method, give it a
	          // chance to clean up.
	          context.method = "return";
	          context.arg = undefined;
	          maybeInvokeDelegate(delegate, context);
	
	          if (context.method === "throw") {
	            // If maybeInvokeDelegate(context) changed context.method from
	            // "return" to "throw", let that override the TypeError below.
	            return ContinueSentinel;
	          }
	        }
	
	        context.method = "throw";
	        context.arg = new TypeError(
	          "The iterator does not provide a 'throw' method");
	      }
	
	      return ContinueSentinel;
	    }
	
	    var record = tryCatch(method, delegate.iterator, context.arg);
	
	    if (record.type === "throw") {
	      context.method = "throw";
	      context.arg = record.arg;
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    var info = record.arg;
	
	    if (! info) {
	      context.method = "throw";
	      context.arg = new TypeError("iterator result is not an object");
	      context.delegate = null;
	      return ContinueSentinel;
	    }
	
	    if (info.done) {
	      // Assign the result of the finished delegate to the temporary
	      // variable specified by delegate.resultName (see delegateYield).
	      context[delegate.resultName] = info.value;
	
	      // Resume execution at the desired location (see delegateYield).
	      context.next = delegate.nextLoc;
	
	      // If context.method was "throw" but the delegate handled the
	      // exception, let the outer generator proceed normally. If
	      // context.method was "next", forget context.arg since it has been
	      // "consumed" by the delegate iterator. If context.method was
	      // "return", allow the original .return call to continue in the
	      // outer generator.
	      if (context.method !== "return") {
	        context.method = "next";
	        context.arg = undefined;
	      }
	
	    } else {
	      // Re-yield the result returned by the delegate method.
	      return info;
	    }
	
	    // The delegate iterator is finished, so forget it and continue with
	    // the outer generator.
	    context.delegate = null;
	    return ContinueSentinel;
	  }
	
	  // Define Generator.prototype.{next,throw,return} in terms of the
	  // unified ._invoke helper method.
	  defineIteratorMethods(Gp);
	
	  Gp[toStringTagSymbol] = "Generator";
	
	  // A Generator should always return itself as the iterator object when the
	  // @@iterator function is called on it. Some browsers' implementations of the
	  // iterator prototype chain incorrectly implement this, causing the Generator
	  // object to not be returned from this call. This ensures that doesn't happen.
	  // See https://github.com/facebook/regenerator/issues/274 for more details.
	  Gp[iteratorSymbol] = function() {
	    return this;
	  };
	
	  Gp.toString = function() {
	    return "[object Generator]";
	  };
	
	  function pushTryEntry(locs) {
	    var entry = { tryLoc: locs[0] };
	
	    if (1 in locs) {
	      entry.catchLoc = locs[1];
	    }
	
	    if (2 in locs) {
	      entry.finallyLoc = locs[2];
	      entry.afterLoc = locs[3];
	    }
	
	    this.tryEntries.push(entry);
	  }
	
	  function resetTryEntry(entry) {
	    var record = entry.completion || {};
	    record.type = "normal";
	    delete record.arg;
	    entry.completion = record;
	  }
	
	  function Context(tryLocsList) {
	    // The root entry object (effectively a try statement without a catch
	    // or a finally block) gives us a place to store values thrown from
	    // locations where there is no enclosing try statement.
	    this.tryEntries = [{ tryLoc: "root" }];
	    tryLocsList.forEach(pushTryEntry, this);
	    this.reset(true);
	  }
	
	  runtime.keys = function(object) {
	    var keys = [];
	    for (var key in object) {
	      keys.push(key);
	    }
	    keys.reverse();
	
	    // Rather than returning an object with a next method, we keep
	    // things simple and return the next function itself.
	    return function next() {
	      while (keys.length) {
	        var key = keys.pop();
	        if (key in object) {
	          next.value = key;
	          next.done = false;
	          return next;
	        }
	      }
	
	      // To avoid creating an additional object, we just hang the .value
	      // and .done properties off the next function object itself. This
	      // also ensures that the minifier will not anonymize the function.
	      next.done = true;
	      return next;
	    };
	  };
	
	  function values(iterable) {
	    if (iterable) {
	      var iteratorMethod = iterable[iteratorSymbol];
	      if (iteratorMethod) {
	        return iteratorMethod.call(iterable);
	      }
	
	      if (typeof iterable.next === "function") {
	        return iterable;
	      }
	
	      if (!isNaN(iterable.length)) {
	        var i = -1, next = function next() {
	          while (++i < iterable.length) {
	            if (hasOwn.call(iterable, i)) {
	              next.value = iterable[i];
	              next.done = false;
	              return next;
	            }
	          }
	
	          next.value = undefined;
	          next.done = true;
	
	          return next;
	        };
	
	        return next.next = next;
	      }
	    }
	
	    // Return an iterator with no values.
	    return { next: doneResult };
	  }
	  runtime.values = values;
	
	  function doneResult() {
	    return { value: undefined, done: true };
	  }
	
	  Context.prototype = {
	    constructor: Context,
	
	    reset: function(skipTempReset) {
	      this.prev = 0;
	      this.next = 0;
	      // Resetting context._sent for legacy support of Babel's
	      // function.sent implementation.
	      this.sent = this._sent = undefined;
	      this.done = false;
	      this.delegate = null;
	
	      this.method = "next";
	      this.arg = undefined;
	
	      this.tryEntries.forEach(resetTryEntry);
	
	      if (!skipTempReset) {
	        for (var name in this) {
	          // Not sure about the optimal order of these conditions:
	          if (name.charAt(0) === "t" &&
	              hasOwn.call(this, name) &&
	              !isNaN(+name.slice(1))) {
	            this[name] = undefined;
	          }
	        }
	      }
	    },
	
	    stop: function() {
	      this.done = true;
	
	      var rootEntry = this.tryEntries[0];
	      var rootRecord = rootEntry.completion;
	      if (rootRecord.type === "throw") {
	        throw rootRecord.arg;
	      }
	
	      return this.rval;
	    },
	
	    dispatchException: function(exception) {
	      if (this.done) {
	        throw exception;
	      }
	
	      var context = this;
	      function handle(loc, caught) {
	        record.type = "throw";
	        record.arg = exception;
	        context.next = loc;
	
	        if (caught) {
	          // If the dispatched exception was caught by a catch block,
	          // then let that catch block handle the exception normally.
	          context.method = "next";
	          context.arg = undefined;
	        }
	
	        return !! caught;
	      }
	
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        var record = entry.completion;
	
	        if (entry.tryLoc === "root") {
	          // Exception thrown outside of any try block that could handle
	          // it, so set the completion value of the entire function to
	          // throw the exception.
	          return handle("end");
	        }
	
	        if (entry.tryLoc <= this.prev) {
	          var hasCatch = hasOwn.call(entry, "catchLoc");
	          var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	          if (hasCatch && hasFinally) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            } else if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else if (hasCatch) {
	            if (this.prev < entry.catchLoc) {
	              return handle(entry.catchLoc, true);
	            }
	
	          } else if (hasFinally) {
	            if (this.prev < entry.finallyLoc) {
	              return handle(entry.finallyLoc);
	            }
	
	          } else {
	            throw new Error("try statement without catch or finally");
	          }
	        }
	      }
	    },
	
	    abrupt: function(type, arg) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc <= this.prev &&
	            hasOwn.call(entry, "finallyLoc") &&
	            this.prev < entry.finallyLoc) {
	          var finallyEntry = entry;
	          break;
	        }
	      }
	
	      if (finallyEntry &&
	          (type === "break" ||
	           type === "continue") &&
	          finallyEntry.tryLoc <= arg &&
	          arg <= finallyEntry.finallyLoc) {
	        // Ignore the finally entry if control is not jumping to a
	        // location outside the try/catch block.
	        finallyEntry = null;
	      }
	
	      var record = finallyEntry ? finallyEntry.completion : {};
	      record.type = type;
	      record.arg = arg;
	
	      if (finallyEntry) {
	        this.method = "next";
	        this.next = finallyEntry.finallyLoc;
	        return ContinueSentinel;
	      }
	
	      return this.complete(record);
	    },
	
	    complete: function(record, afterLoc) {
	      if (record.type === "throw") {
	        throw record.arg;
	      }
	
	      if (record.type === "break" ||
	          record.type === "continue") {
	        this.next = record.arg;
	      } else if (record.type === "return") {
	        this.rval = this.arg = record.arg;
	        this.method = "return";
	        this.next = "end";
	      } else if (record.type === "normal" && afterLoc) {
	        this.next = afterLoc;
	      }
	
	      return ContinueSentinel;
	    },
	
	    finish: function(finallyLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.finallyLoc === finallyLoc) {
	          this.complete(entry.completion, entry.afterLoc);
	          resetTryEntry(entry);
	          return ContinueSentinel;
	        }
	      }
	    },
	
	    "catch": function(tryLoc) {
	      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	        var entry = this.tryEntries[i];
	        if (entry.tryLoc === tryLoc) {
	          var record = entry.completion;
	          if (record.type === "throw") {
	            var thrown = record.arg;
	            resetTryEntry(entry);
	          }
	          return thrown;
	        }
	      }
	
	      // The context.catch method must only be called with a location
	      // argument that corresponds to a known catch block.
	      throw new Error("illegal catch attempt");
	    },
	
	    delegateYield: function(iterable, resultName, nextLoc) {
	      this.delegate = {
	        iterator: values(iterable),
	        resultName: resultName,
	        nextLoc: nextLoc
	      };
	
	      if (this.method === "next") {
	        // Deliberately forget the last sent value so that we don't
	        // accidentally pass it on to the delegate.
	        this.arg = undefined;
	      }
	
	      return ContinueSentinel;
	    }
	  };
	})(
	  // Among the various tricks for obtaining a reference to the global
	  // object, this seems to be the most reliable technique that does not
	  // use indirect eval (which violates Content Security Policy).
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this
	);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2941);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(187)(module)))

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(594);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1184 */
36,
/* 1185 */
36,
/* 1186 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (typeof input === 'string') {
	      this.url = input
	    } else {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split('\r\n').forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	var guid = __webpack_require__(1197);
	
	var Eventful = __webpack_require__(225);
	
	var Transformable = __webpack_require__(396);
	
	var Animatable = __webpack_require__(2993);
	
	var zrUtil = __webpack_require__(4);
	
	/**
	 * @alias module:zrender/Element
	 * @constructor
	 * @extends {module:zrender/mixin/Animatable}
	 * @extends {module:zrender/mixin/Transformable}
	 * @extends {module:zrender/mixin/Eventful}
	 */
	var Element = function (opts) {
	  // jshint ignore:line
	  Transformable.call(this, opts);
	  Eventful.call(this, opts);
	  Animatable.call(this, opts);
	  /**
	   * 画布元素ID
	   * @type {string}
	   */
	
	  this.id = opts.id || guid();
	};
	
	Element.prototype = {
	  /**
	   * 元素类型
	   * Element type
	   * @type {string}
	   */
	  type: 'element',
	
	  /**
	   * 元素名字
	   * Element name
	   * @type {string}
	   */
	  name: '',
	
	  /**
	   * ZRender 实例对象，会在 element 添加到 zrender 实例中后自动赋值
	   * ZRender instance will be assigned when element is associated with zrender
	   * @name module:/zrender/Element#__zr
	   * @type {module:zrender/ZRender}
	   */
	  __zr: null,
	
	  /**
	   * 图形是否忽略，为true时忽略图形的绘制以及事件触发
	   * If ignore drawing and events of the element object
	   * @name module:/zrender/Element#ignore
	   * @type {boolean}
	   * @default false
	   */
	  ignore: false,
	
	  /**
	   * 用于裁剪的路径(shape)，所有 Group 内的路径在绘制时都会被这个路径裁剪
	   * 该路径会继承被裁减对象的变换
	   * @type {module:zrender/graphic/Path}
	   * @see http://www.w3.org/TR/2dcontext/#clipping-region
	   * @readOnly
	   */
	  clipPath: null,
	
	  /**
	   * 是否是 Group
	   * @type {boolean}
	   */
	  isGroup: false,
	
	  /**
	   * Drift element
	   * @param  {number} dx dx on the global space
	   * @param  {number} dy dy on the global space
	   */
	  drift: function (dx, dy) {
	    switch (this.draggable) {
	      case 'horizontal':
	        dy = 0;
	        break;
	
	      case 'vertical':
	        dx = 0;
	        break;
	    }
	
	    var m = this.transform;
	
	    if (!m) {
	      m = this.transform = [1, 0, 0, 1, 0, 0];
	    }
	
	    m[4] += dx;
	    m[5] += dy;
	    this.decomposeTransform();
	    this.dirty(false);
	  },
	
	  /**
	   * Hook before update
	   */
	  beforeUpdate: function () {},
	
	  /**
	   * Hook after update
	   */
	  afterUpdate: function () {},
	
	  /**
	   * Update each frame
	   */
	  update: function () {
	    this.updateTransform();
	  },
	
	  /**
	   * @param  {Function} cb
	   * @param  {}   context
	   */
	  traverse: function (cb, context) {},
	
	  /**
	   * @protected
	   */
	  attrKV: function (key, value) {
	    if (key === 'position' || key === 'scale' || key === 'origin') {
	      // Copy the array
	      if (value) {
	        var target = this[key];
	
	        if (!target) {
	          target = this[key] = [];
	        }
	
	        target[0] = value[0];
	        target[1] = value[1];
	      }
	    } else {
	      this[key] = value;
	    }
	  },
	
	  /**
	   * Hide the element
	   */
	  hide: function () {
	    this.ignore = true;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * Show the element
	   */
	  show: function () {
	    this.ignore = false;
	    this.__zr && this.__zr.refresh();
	  },
	
	  /**
	   * @param {string|Object} key
	   * @param {*} value
	   */
	  attr: function (key, value) {
	    if (typeof key === 'string') {
	      this.attrKV(key, value);
	    } else if (zrUtil.isObject(key)) {
	      for (var name in key) {
	        if (key.hasOwnProperty(name)) {
	          this.attrKV(name, key[name]);
	        }
	      }
	    }
	
	    this.dirty(false);
	    return this;
	  },
	
	  /**
	   * @param {module:zrender/graphic/Path} clipPath
	   */
	  setClipPath: function (clipPath) {
	    var zr = this.__zr;
	
	    if (zr) {
	      clipPath.addSelfToZr(zr);
	    } // Remove previous clip path
	
	
	    if (this.clipPath && this.clipPath !== clipPath) {
	      this.removeClipPath();
	    }
	
	    this.clipPath = clipPath;
	    clipPath.__zr = zr;
	    clipPath.__clipTarget = this;
	    this.dirty(false);
	  },
	
	  /**
	   */
	  removeClipPath: function () {
	    var clipPath = this.clipPath;
	
	    if (clipPath) {
	      if (clipPath.__zr) {
	        clipPath.removeSelfFromZr(clipPath.__zr);
	      }
	
	      clipPath.__zr = null;
	      clipPath.__clipTarget = null;
	      this.clipPath = null;
	      this.dirty(false);
	    }
	  },
	
	  /**
	   * Add self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  addSelfToZr: function (zr) {
	    this.__zr = zr; // 添加动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.addAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.addSelfToZr(zr);
	    }
	  },
	
	  /**
	   * Remove self from zrender instance.
	   * Not recursively because it will be invoked when element added to storage.
	   * @param {module:zrender/ZRender} zr
	   */
	  removeSelfFromZr: function (zr) {
	    this.__zr = null; // 移除动画
	
	    var animators = this.animators;
	
	    if (animators) {
	      for (var i = 0; i < animators.length; i++) {
	        zr.animation.removeAnimator(animators[i]);
	      }
	    }
	
	    if (this.clipPath) {
	      this.clipPath.removeSelfFromZr(zr);
	    }
	  }
	};
	zrUtil.mixin(Element, Animatable);
	zrUtil.mixin(Element, Transformable);
	zrUtil.mixin(Element, Eventful);
	var _default = Element;
	module.exports = _default;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	var Clip = __webpack_require__(2975);
	
	var color = __webpack_require__(148);
	
	var _util = __webpack_require__(4);
	
	var isArrayLike = _util.isArrayLike;
	
	/**
	 * @module echarts/animation/Animator
	 */
	var arraySlice = Array.prototype.slice;
	
	function defaultGetter(target, key) {
	  return target[key];
	}
	
	function defaultSetter(target, key, value) {
	  target[key] = value;
	}
	/**
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} percent
	 * @return {number}
	 */
	
	
	function interpolateNumber(p0, p1, percent) {
	  return (p1 - p0) * percent + p0;
	}
	/**
	 * @param  {string} p0
	 * @param  {string} p1
	 * @param  {number} percent
	 * @return {string}
	 */
	
	
	function interpolateString(p0, p1, percent) {
	  return percent > 0.5 ? p1 : p0;
	}
	/**
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {number} percent
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function interpolateArray(p0, p1, percent, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = interpolateNumber(p0[i], p1[i], percent);
	    }
	  } else {
	    var len2 = len && p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = interpolateNumber(p0[i][j], p1[i][j], percent);
	      }
	    }
	  }
	} // arr0 is source array, arr1 is target array.
	// Do some preprocess to avoid error happened when interpolating from arr0 to arr1
	
	
	function fillArr(arr0, arr1, arrDim) {
	  var arr0Len = arr0.length;
	  var arr1Len = arr1.length;
	
	  if (arr0Len !== arr1Len) {
	    // FIXME Not work for TypedArray
	    var isPreviousLarger = arr0Len > arr1Len;
	
	    if (isPreviousLarger) {
	      // Cut the previous
	      arr0.length = arr1Len;
	    } else {
	      // Fill the previous
	      for (var i = arr0Len; i < arr1Len; i++) {
	        arr0.push(arrDim === 1 ? arr1[i] : arraySlice.call(arr1[i]));
	      }
	    }
	  } // Handling NaN value
	
	
	  var len2 = arr0[0] && arr0[0].length;
	
	  for (var i = 0; i < arr0.length; i++) {
	    if (arrDim === 1) {
	      if (isNaN(arr0[i])) {
	        arr0[i] = arr1[i];
	      }
	    } else {
	      for (var j = 0; j < len2; j++) {
	        if (isNaN(arr0[i][j])) {
	          arr0[i][j] = arr1[i][j];
	        }
	      }
	    }
	  }
	}
	/**
	 * @param  {Array} arr0
	 * @param  {Array} arr1
	 * @param  {number} arrDim
	 * @return {boolean}
	 */
	
	
	function isArraySame(arr0, arr1, arrDim) {
	  if (arr0 === arr1) {
	    return true;
	  }
	
	  var len = arr0.length;
	
	  if (len !== arr1.length) {
	    return false;
	  }
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      if (arr0[i] !== arr1[i]) {
	        return false;
	      }
	    }
	  } else {
	    var len2 = arr0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        if (arr0[i][j] !== arr1[i][j]) {
	          return false;
	        }
	      }
	    }
	  }
	
	  return true;
	}
	/**
	 * Catmull Rom interpolate array
	 * @param  {Array} p0
	 * @param  {Array} p1
	 * @param  {Array} p2
	 * @param  {Array} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @param  {Array} out
	 * @param  {number} arrDim
	 */
	
	
	function catmullRomInterpolateArray(p0, p1, p2, p3, t, t2, t3, out, arrDim) {
	  var len = p0.length;
	
	  if (arrDim === 1) {
	    for (var i = 0; i < len; i++) {
	      out[i] = catmullRomInterpolate(p0[i], p1[i], p2[i], p3[i], t, t2, t3);
	    }
	  } else {
	    var len2 = p0[0].length;
	
	    for (var i = 0; i < len; i++) {
	      for (var j = 0; j < len2; j++) {
	        out[i][j] = catmullRomInterpolate(p0[i][j], p1[i][j], p2[i][j], p3[i][j], t, t2, t3);
	      }
	    }
	  }
	}
	/**
	 * Catmull Rom interpolate number
	 * @param  {number} p0
	 * @param  {number} p1
	 * @param  {number} p2
	 * @param  {number} p3
	 * @param  {number} t
	 * @param  {number} t2
	 * @param  {number} t3
	 * @return {number}
	 */
	
	
	function catmullRomInterpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	
	function cloneValue(value) {
	  if (isArrayLike(value)) {
	    var len = value.length;
	
	    if (isArrayLike(value[0])) {
	      var ret = [];
	
	      for (var i = 0; i < len; i++) {
	        ret.push(arraySlice.call(value[i]));
	      }
	
	      return ret;
	    }
	
	    return arraySlice.call(value);
	  }
	
	  return value;
	}
	
	function rgba2String(rgba) {
	  rgba[0] = Math.floor(rgba[0]);
	  rgba[1] = Math.floor(rgba[1]);
	  rgba[2] = Math.floor(rgba[2]);
	  return 'rgba(' + rgba.join(',') + ')';
	}
	
	function getArrayDim(keyframes) {
	  var lastValue = keyframes[keyframes.length - 1].value;
	  return isArrayLike(lastValue && lastValue[0]) ? 2 : 1;
	}
	
	function createTrackClip(animator, easing, oneTrackDone, keyframes, propName, forceAnimate) {
	  var getter = animator._getter;
	  var setter = animator._setter;
	  var useSpline = easing === 'spline';
	  var trackLen = keyframes.length;
	
	  if (!trackLen) {
	    return;
	  } // Guess data type
	
	
	  var firstVal = keyframes[0].value;
	  var isValueArray = isArrayLike(firstVal);
	  var isValueColor = false;
	  var isValueString = false; // For vertices morphing
	
	  var arrDim = isValueArray ? getArrayDim(keyframes) : 0;
	  var trackMaxTime; // Sort keyframe as ascending
	
	  keyframes.sort(function (a, b) {
	    return a.time - b.time;
	  });
	  trackMaxTime = keyframes[trackLen - 1].time; // Percents of each keyframe
	
	  var kfPercents = []; // Value of each keyframe
	
	  var kfValues = [];
	  var prevValue = keyframes[0].value;
	  var isAllValueEqual = true;
	
	  for (var i = 0; i < trackLen; i++) {
	    kfPercents.push(keyframes[i].time / trackMaxTime); // Assume value is a color when it is a string
	
	    var value = keyframes[i].value; // Check if value is equal, deep check if value is array
	
	    if (!(isValueArray && isArraySame(value, prevValue, arrDim) || !isValueArray && value === prevValue)) {
	      isAllValueEqual = false;
	    }
	
	    prevValue = value; // Try converting a string to a color array
	
	    if (typeof value === 'string') {
	      var colorArray = color.parse(value);
	
	      if (colorArray) {
	        value = colorArray;
	        isValueColor = true;
	      } else {
	        isValueString = true;
	      }
	    }
	
	    kfValues.push(value);
	  }
	
	  if (!forceAnimate && isAllValueEqual) {
	    return;
	  }
	
	  var lastValue = kfValues[trackLen - 1]; // Polyfill array and NaN value
	
	  for (var i = 0; i < trackLen - 1; i++) {
	    if (isValueArray) {
	      fillArr(kfValues[i], lastValue, arrDim);
	    } else {
	      if (isNaN(kfValues[i]) && !isNaN(lastValue) && !isValueString && !isValueColor) {
	        kfValues[i] = lastValue;
	      }
	    }
	  }
	
	  isValueArray && fillArr(getter(animator._target, propName), lastValue, arrDim); // Cache the key of last frame to speed up when
	  // animation playback is sequency
	
	  var lastFrame = 0;
	  var lastFramePercent = 0;
	  var start;
	  var w;
	  var p0;
	  var p1;
	  var p2;
	  var p3;
	
	  if (isValueColor) {
	    var rgba = [0, 0, 0, 0];
	  }
	
	  var onframe = function (target, percent) {
	    // Find the range keyframes
	    // kf1-----kf2---------current--------kf3
	    // find kf2 and kf3 and do interpolation
	    var frame; // In the easing function like elasticOut, percent may less than 0
	
	    if (percent < 0) {
	      frame = 0;
	    } else if (percent < lastFramePercent) {
	      // Start from next key
	      // PENDING start from lastFrame ?
	      start = Math.min(lastFrame + 1, trackLen - 1);
	
	      for (frame = start; frame >= 0; frame--) {
	        if (kfPercents[frame] <= percent) {
	          break;
	        }
	      } // PENDING really need to do this ?
	
	
	      frame = Math.min(frame, trackLen - 2);
	    } else {
	      for (frame = lastFrame; frame < trackLen; frame++) {
	        if (kfPercents[frame] > percent) {
	          break;
	        }
	      }
	
	      frame = Math.min(frame - 1, trackLen - 2);
	    }
	
	    lastFrame = frame;
	    lastFramePercent = percent;
	    var range = kfPercents[frame + 1] - kfPercents[frame];
	
	    if (range === 0) {
	      return;
	    } else {
	      w = (percent - kfPercents[frame]) / range;
	    }
	
	    if (useSpline) {
	      p1 = kfValues[frame];
	      p0 = kfValues[frame === 0 ? frame : frame - 1];
	      p2 = kfValues[frame > trackLen - 2 ? trackLen - 1 : frame + 1];
	      p3 = kfValues[frame > trackLen - 3 ? trackLen - 1 : frame + 2];
	
	      if (isValueArray) {
	        catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          value = catmullRomInterpolateArray(p0, p1, p2, p3, w, w * w, w * w * w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(p1, p2, w);
	        } else {
	          value = catmullRomInterpolate(p0, p1, p2, p3, w, w * w, w * w * w);
	        }
	
	        setter(target, propName, value);
	      }
	    } else {
	      if (isValueArray) {
	        interpolateArray(kfValues[frame], kfValues[frame + 1], w, getter(target, propName), arrDim);
	      } else {
	        var value;
	
	        if (isValueColor) {
	          interpolateArray(kfValues[frame], kfValues[frame + 1], w, rgba, 1);
	          value = rgba2String(rgba);
	        } else if (isValueString) {
	          // String is step(0.5)
	          return interpolateString(kfValues[frame], kfValues[frame + 1], w);
	        } else {
	          value = interpolateNumber(kfValues[frame], kfValues[frame + 1], w);
	        }
	
	        setter(target, propName, value);
	      }
	    }
	  };
	
	  var clip = new Clip({
	    target: animator._target,
	    life: trackMaxTime,
	    loop: animator._loop,
	    delay: animator._delay,
	    onframe: onframe,
	    ondestroy: oneTrackDone
	  });
	
	  if (easing && easing !== 'spline') {
	    clip.easing = easing;
	  }
	
	  return clip;
	}
	/**
	 * @alias module:zrender/animation/Animator
	 * @constructor
	 * @param {Object} target
	 * @param {boolean} loop
	 * @param {Function} getter
	 * @param {Function} setter
	 */
	
	
	var Animator = function (target, loop, getter, setter) {
	  this._tracks = {};
	  this._target = target;
	  this._loop = loop || false;
	  this._getter = getter || defaultGetter;
	  this._setter = setter || defaultSetter;
	  this._clipCount = 0;
	  this._delay = 0;
	  this._doneList = [];
	  this._onframeList = [];
	  this._clipList = [];
	};
	
	Animator.prototype = {
	  /**
	   * Set Animation keyframe
	   * @param  {number} time 关键帧时间，单位是ms
	   * @param  {Object} props 关键帧的属性值，key-value表示
	   * @return {module:zrender/animation/Animator}
	   */
	  when: function (time
	  /* ms */
	  , props) {
	    var tracks = this._tracks;
	
	    for (var propName in props) {
	      if (!props.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      if (!tracks[propName]) {
	        tracks[propName] = []; // Invalid value
	
	        var value = this._getter(this._target, propName);
	
	        if (value == null) {
	          // zrLog('Invalid property ' + propName);
	          continue;
	        } // If time is 0
	        //  Then props is given initialize value
	        // Else
	        //  Initialize value from current prop value
	
	
	        if (time !== 0) {
	          tracks[propName].push({
	            time: 0,
	            value: cloneValue(value)
	          });
	        }
	      }
	
	      tracks[propName].push({
	        time: time,
	        value: props[propName]
	      });
	    }
	
	    return this;
	  },
	
	  /**
	   * 添加动画每一帧的回调函数
	   * @param  {Function} callback
	   * @return {module:zrender/animation/Animator}
	   */
	  during: function (callback) {
	    this._onframeList.push(callback);
	
	    return this;
	  },
	  pause: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].pause();
	    }
	
	    this._paused = true;
	  },
	  resume: function () {
	    for (var i = 0; i < this._clipList.length; i++) {
	      this._clipList[i].resume();
	    }
	
	    this._paused = false;
	  },
	  isPaused: function () {
	    return !!this._paused;
	  },
	  _doneCallback: function () {
	    // Clear all tracks
	    this._tracks = {}; // Clear all clips
	
	    this._clipList.length = 0;
	    var doneList = this._doneList;
	    var len = doneList.length;
	
	    for (var i = 0; i < len; i++) {
	      doneList[i].call(this);
	    }
	  },
	
	  /**
	   * Start the animation
	   * @param  {string|Function} [easing]
	   *         动画缓动函数，详见{@link module:zrender/animation/easing}
	   * @param  {boolean} forceAnimate
	   * @return {module:zrender/animation/Animator}
	   */
	  start: function (easing, forceAnimate) {
	    var self = this;
	    var clipCount = 0;
	
	    var oneTrackDone = function () {
	      clipCount--;
	
	      if (!clipCount) {
	        self._doneCallback();
	      }
	    };
	
	    var lastClip;
	
	    for (var propName in this._tracks) {
	      if (!this._tracks.hasOwnProperty(propName)) {
	        continue;
	      }
	
	      var clip = createTrackClip(this, easing, oneTrackDone, this._tracks[propName], propName, forceAnimate);
	
	      if (clip) {
	        this._clipList.push(clip);
	
	        clipCount++; // If start after added to animation
	
	        if (this.animation) {
	          this.animation.addClip(clip);
	        }
	
	        lastClip = clip;
	      }
	    } // Add during callback on the last clip
	
	
	    if (lastClip) {
	      var oldOnFrame = lastClip.onframe;
	
	      lastClip.onframe = function (target, percent) {
	        oldOnFrame(target, percent);
	
	        for (var i = 0; i < self._onframeList.length; i++) {
	          self._onframeList[i](target, percent);
	        }
	      };
	    } // This optimization will help the case that in the upper application
	    // the view may be refreshed frequently, where animation will be
	    // called repeatly but nothing changed.
	
	
	    if (!clipCount) {
	      this._doneCallback();
	    }
	
	    return this;
	  },
	
	  /**
	   * Stop animation
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stop: function (forwardToLast) {
	    var clipList = this._clipList;
	    var animation = this.animation;
	
	    for (var i = 0; i < clipList.length; i++) {
	      var clip = clipList[i];
	
	      if (forwardToLast) {
	        // Move to last frame before stop
	        clip.onframe(this._target, 1);
	      }
	
	      animation && animation.removeClip(clip);
	    }
	
	    clipList.length = 0;
	  },
	
	  /**
	   * Set when animation delay starts
	   * @param  {number} time 单位ms
	   * @return {module:zrender/animation/Animator}
	   */
	  delay: function (time) {
	    this._delay = time;
	    return this;
	  },
	
	  /**
	   * Add callback for animation end
	   * @param  {Function} cb
	   * @return {module:zrender/animation/Animator}
	   */
	  done: function (cb) {
	    if (cb) {
	      this._doneList.push(cb);
	    }
	
	    return this;
	  },
	
	  /**
	   * @return {Array.<module:zrender/animation/Clip>}
	   */
	  getClips: function () {
	    return this._clipList;
	  }
	};
	var _default = Animator;
	module.exports = _default;

/***/ },
/* 1189 */
/***/ function(module, exports) {

	var _default = typeof window !== 'undefined' && (window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || // https://github.com/ecomfe/zrender/issues/189#issuecomment-224919809
	window.msRequestAnimationFrame && window.msRequestAnimationFrame.bind(window) || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame) || function (func) {
	  setTimeout(func, 16);
	};
	
	module.exports = _default;

/***/ },
/* 1190 */
/***/ function(module, exports) {

	/**
	 * 线段包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  var _a = 0;
	  var _b = x0; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l || y < y0 - _l && y < y1 - _l || x > x0 + _l && x > x1 + _l || x < x0 - _l && x < x1 - _l) {
	    return false;
	  }
	
	  if (x0 !== x1) {
	    _a = (y0 - y1) / (x0 - x1);
	    _b = (x0 * y1 - x1 * y0) / (x0 - x1);
	  } else {
	    return Math.abs(x - x0) <= _l / 2;
	  }
	
	  var tmp = _a * x - y + _b;
	
	  var _s = tmp * tmp / (_a * _a + 1);
	
	  return _s <= _l / 2 * _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	var windingLine = __webpack_require__(1194);
	
	var EPSILON = 1e-8;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	}
	
	function contain(points, x, y) {
	  var w = 0;
	  var p = points[0];
	
	  if (!p) {
	    return false;
	  }
	
	  for (var i = 1; i < points.length; i++) {
	    var p2 = points[i];
	    w += windingLine(p[0], p[1], p2[0], p2[1], x, y);
	    p = p2;
	  } // Close polygon
	
	
	  var p0 = points[0];
	
	  if (!isAroundEqual(p[0], p0[0]) || !isAroundEqual(p[1], p0[1])) {
	    w += windingLine(p[0], p[1], p0[0], p0[1], x, y);
	  }
	
	  return w !== 0;
	}
	
	exports.contain = contain;

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	var _curve = __webpack_require__(188);
	
	var quadraticProjectPoint = _curve.quadraticProjectPoint;
	
	/**
	 * 二次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l) {
	    return false;
	  }
	
	  var d = quadraticProjectPoint(x0, y0, x1, y1, x2, y2, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ },
/* 1193 */
/***/ function(module, exports) {

	var PI2 = Math.PI * 2;
	
	function normalizeRadian(angle) {
	  angle %= PI2;
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle;
	}
	
	exports.normalizeRadian = normalizeRadian;

/***/ },
/* 1194 */
/***/ function(module, exports) {

	function windingLine(x0, y0, x1, y1, x, y) {
	  if (y > y0 && y > y1 || y < y0 && y < y1) {
	    return 0;
	  } // Ignore horizontal line
	
	
	  if (y1 === y0) {
	    return 0;
	  }
	
	  var dir = y1 < y0 ? 1 : -1;
	  var t = (y - y0) / (y1 - y0); // Avoid winding error when intersection point is the connect point of two line of polygon
	
	  if (t === 1 || t === 0) {
	    dir = y1 < y0 ? 0.5 : -0.5;
	  }
	
	  var x_ = t * (x1 - x0) + x0; // If (x, y) on the line, considered as "contain".
	
	  return x_ === x ? Infinity : x_ > x ? dir : 0;
	}
	
	module.exports = windingLine;

/***/ },
/* 1195 */
/***/ function(module, exports) {

	// Simple LRU cache use doubly linked list
	// @module zrender/core/LRU
	
	/**
	 * Simple double linked list. Compared with array, it has O(1) remove operation.
	 * @constructor
	 */
	var LinkedList = function () {
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	  this.head = null;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.tail = null;
	  this._len = 0;
	};
	
	var linkedListProto = LinkedList.prototype;
	/**
	 * Insert a new value at the tail
	 * @param  {} val
	 * @return {module:zrender/core/LRU~Entry}
	 */
	
	linkedListProto.insert = function (val) {
	  var entry = new Entry(val);
	  this.insertEntry(entry);
	  return entry;
	};
	/**
	 * Insert an entry at the tail
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.insertEntry = function (entry) {
	  if (!this.head) {
	    this.head = this.tail = entry;
	  } else {
	    this.tail.next = entry;
	    entry.prev = this.tail;
	    entry.next = null;
	    this.tail = entry;
	  }
	
	  this._len++;
	};
	/**
	 * Remove entry.
	 * @param  {module:zrender/core/LRU~Entry} entry
	 */
	
	
	linkedListProto.remove = function (entry) {
	  var prev = entry.prev;
	  var next = entry.next;
	
	  if (prev) {
	    prev.next = next;
	  } else {
	    // Is head
	    this.head = next;
	  }
	
	  if (next) {
	    next.prev = prev;
	  } else {
	    // Is tail
	    this.tail = prev;
	  }
	
	  entry.next = entry.prev = null;
	  this._len--;
	};
	/**
	 * @return {number}
	 */
	
	
	linkedListProto.len = function () {
	  return this._len;
	};
	/**
	 * Clear list
	 */
	
	
	linkedListProto.clear = function () {
	  this.head = this.tail = null;
	  this._len = 0;
	};
	/**
	 * @constructor
	 * @param {} val
	 */
	
	
	var Entry = function (val) {
	  /**
	   * @type {}
	   */
	  this.value = val;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.next;
	  /**
	   * @type {module:zrender/core/LRU~Entry}
	   */
	
	  this.prev;
	};
	/**
	 * LRU Cache
	 * @constructor
	 * @alias module:zrender/core/LRU
	 */
	
	
	var LRU = function (maxSize) {
	  this._list = new LinkedList();
	  this._map = {};
	  this._maxSize = maxSize || 10;
	  this._lastRemovedEntry = null;
	};
	
	var LRUProto = LRU.prototype;
	/**
	 * @param  {string} key
	 * @param  {} value
	 * @return {} Removed value
	 */
	
	LRUProto.put = function (key, value) {
	  var list = this._list;
	  var map = this._map;
	  var removed = null;
	
	  if (map[key] == null) {
	    var len = list.len(); // Reuse last removed entry
	
	    var entry = this._lastRemovedEntry;
	
	    if (len >= this._maxSize && len > 0) {
	      // Remove the least recently used
	      var leastUsedEntry = list.head;
	      list.remove(leastUsedEntry);
	      delete map[leastUsedEntry.key];
	      removed = leastUsedEntry.value;
	      this._lastRemovedEntry = leastUsedEntry;
	    }
	
	    if (entry) {
	      entry.value = value;
	    } else {
	      entry = new Entry(value);
	    }
	
	    entry.key = key;
	    list.insertEntry(entry);
	    map[key] = entry;
	  }
	
	  return removed;
	};
	/**
	 * @param  {string} key
	 * @return {}
	 */
	
	
	LRUProto.get = function (key) {
	  var entry = this._map[key];
	  var list = this._list;
	
	  if (entry != null) {
	    // Put the latest used entry in the tail
	    if (entry !== list.tail) {
	      list.remove(entry);
	      list.insertEntry(entry);
	    }
	
	    return entry.value;
	  }
	};
	/**
	 * Clear the cache
	 */
	
	
	LRUProto.clear = function () {
	  this._list.clear();
	
	  this._map = {};
	};
	
	var _default = LRU;
	module.exports = _default;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	var env = __webpack_require__(73);
	
	var _fourPointsTransform = __webpack_require__(2982);
	
	var buildTransformer = _fourPointsTransform.buildTransformer;
	var EVENT_SAVED_PROP = '___zrEVENTSAVED';
	var _calcOut = [];
	/**
	 * Transform "local coord" from `elFrom` to `elTarget`.
	 * "local coord": the coord based on the input `el`. The origin point is at
	 *     the position of "left: 0; top: 0;" in the `el`.
	 *
	 * Support when CSS transform is used.
	 *
	 * Having the `out` (that is, `[outX, outY]`), we can create an DOM element
	 * and set the CSS style as "left: outX; top: outY;" and append it to `elTarge`
	 * to locate the element.
	 *
	 * For example, this code below positions a child of `document.body` on the event
	 * point, no matter whether `body` has `margin`/`paddin`/`transfrom`/... :
	 * ```js
	 * transformLocalCoord(out, container, document.body, event.offsetX, event.offsetY);
	 * if (!eqNaN(out[0])) {
	 *     // Then locate the tip element on the event point.
	 *     var tipEl = document.createElement('div');
	 *     tipEl.style.cssText = 'position: absolute; left:' + out[0] + ';top:' + out[1] + ';';
	 *     document.body.appendChild(tipEl);
	 * }
	 * ```
	 *
	 * Notice: In some env this method is not supported. If called, `out` will be `[NaN, NaN]`.
	 *
	 * @param {Array.<number>} out [inX: number, inY: number] The output..
	 *        If can not transform, `out` will not be modified but return `false`.
	 * @param {HTMLElement} elFrom The `[inX, inY]` is based on elFrom.
	 * @param {HTMLElement} elTarget The `out` is based on elTarget.
	 * @param {number} inX
	 * @param {number} inY
	 * @return {boolean} Whether transform successfully.
	 */
	
	function transformLocalCoord(out, elFrom, elTarget, inX, inY) {
	  return transformCoordWithViewport(_calcOut, elFrom, inX, inY, true) && transformCoordWithViewport(out, elTarget, _calcOut[0], _calcOut[1]);
	}
	/**
	 * Transform between a "viewport coord" and a "local coord".
	 * "viewport coord": the coord based on the left-top corner of the viewport
	 *     of the browser.
	 * "local coord": the coord based on the input `el`. The origin point is at
	 *     the position of "left: 0; top: 0;" in the `el`.
	 *
	 * Support the case when CSS transform is used on el.
	 *
	 * @param {Array.<number>} out [inX: number, inY: number] The output. If `inverse: false`,
	 *        it represents "local coord", otherwise "vireport coord".
	 *        If can not transform, `out` will not be modified but return `false`.
	 * @param {HTMLElement} el The "local coord" is based on the `el`, see comment above.
	 * @param {number} inX If `inverse: false`,
	 *        it represents "vireport coord", otherwise "local coord".
	 * @param {number} inY If `inverse: false`,
	 *        it represents "vireport coord", otherwise "local coord".
	 * @param {boolean} [inverse=false]
	 *        `true`: from "viewport coord" to "local coord".
	 *        `false`: from "local coord" to "viewport coord".
	 * @return {boolean} Whether transform successfully.
	 */
	
	
	function transformCoordWithViewport(out, el, inX, inY, inverse) {
	  if (el.getBoundingClientRect && env.domSupported && !isCanvasEl(el)) {
	    var saved = el[EVENT_SAVED_PROP] || (el[EVENT_SAVED_PROP] = {});
	    var markers = prepareCoordMarkers(el, saved);
	    var transformer = preparePointerTransformer(markers, saved, inverse);
	
	    if (transformer) {
	      transformer(out, inX, inY);
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function prepareCoordMarkers(el, saved) {
	  var markers = saved.markers;
	
	  if (markers) {
	    return markers;
	  }
	
	  markers = saved.markers = [];
	  var propLR = ['left', 'right'];
	  var propTB = ['top', 'bottom'];
	
	  for (var i = 0; i < 4; i++) {
	    var marker = document.createElement('div');
	    var stl = marker.style;
	    var idxLR = i % 2;
	    var idxTB = (i >> 1) % 2;
	    stl.cssText = ['position: absolute', 'visibility: hidden', 'padding: 0', 'margin: 0', 'border-width: 0', 'user-select: none', 'width:0', 'height:0', // 'width: 5px',
	    // 'height: 5px',
	    propLR[idxLR] + ':0', propTB[idxTB] + ':0', propLR[1 - idxLR] + ':auto', propTB[1 - idxTB] + ':auto', ''].join('!important;');
	    el.appendChild(marker);
	    markers.push(marker);
	  }
	
	  return markers;
	}
	
	function preparePointerTransformer(markers, saved, inverse) {
	  var transformerName = inverse ? 'invTrans' : 'trans';
	  var transformer = saved[transformerName];
	  var oldSrcCoords = saved.srcCoords;
	  var oldCoordTheSame = true;
	  var srcCoords = [];
	  var destCoords = [];
	
	  for (var i = 0; i < 4; i++) {
	    var rect = markers[i].getBoundingClientRect();
	    var ii = 2 * i;
	    var x = rect.left;
	    var y = rect.top;
	    srcCoords.push(x, y);
	    oldCoordTheSame = oldCoordTheSame && oldSrcCoords && x === oldSrcCoords[ii] && y === oldSrcCoords[ii + 1];
	    destCoords.push(markers[i].offsetLeft, markers[i].offsetTop);
	  } // Cache to avoid time consuming of `buildTransformer`.
	
	
	  return oldCoordTheSame && transformer ? transformer : (saved.srcCoords = srcCoords, saved[transformerName] = inverse ? buildTransformer(destCoords, srcCoords) : buildTransformer(srcCoords, destCoords));
	}
	
	function isCanvasEl(el) {
	  return el.nodeName.toUpperCase() === 'CANVAS';
	}
	
	exports.transformLocalCoord = transformLocalCoord;
	exports.transformCoordWithViewport = transformCoordWithViewport;
	exports.isCanvasEl = isCanvasEl;

/***/ },
/* 1197 */
/***/ function(module, exports) {

	/**
	 * zrender: 生成唯一id
	 *
	 * @author errorrik (errorrik@gmail.com)
	 */
	var idStart = 0x0907;
	
	function _default() {
	  return idStart++;
	}
	
	module.exports = _default;

/***/ },
/* 1198 */
/***/ function(module, exports) {

	var Pattern = function (image, repeat) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {image: ...}`, where this constructor will not be called.
	  this.image = image;
	  this.repeat = repeat; // Can be cloned
	
	  this.type = 'pattern';
	};
	
	Pattern.prototype.getCanvasPattern = function (ctx) {
	  return ctx.createPattern(this.image, this.repeat || 'repeat');
	};
	
	var _default = Pattern;
	module.exports = _default;

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	var env = __webpack_require__(73);
	
	// Fix weird bug in some version of IE11 (like 11.0.9600.178**),
	// where exception "unexpected call to method or property access"
	// might be thrown when calling ctx.fill or ctx.stroke after a path
	// whose area size is zero is drawn and ctx.clip() is called and
	// shadowBlur is set. See #4572, #3112, #5777.
	// (e.g.,
	//  ctx.moveTo(10, 10);
	//  ctx.lineTo(20, 10);
	//  ctx.closePath();
	//  ctx.clip();
	//  ctx.shadowBlur = 10;
	//  ...
	//  ctx.fill();
	// )
	var shadowTemp = [['shadowBlur', 0], ['shadowColor', '#000'], ['shadowOffsetX', 0], ['shadowOffsetY', 0]];
	
	function _default(orignalBrush) {
	  // version string can be: '11.0'
	  return env.browser.ie && env.browser.version >= 11 ? function () {
	    var clipPaths = this.__clipPaths;
	    var style = this.style;
	    var modified;
	
	    if (clipPaths) {
	      for (var i = 0; i < clipPaths.length; i++) {
	        var clipPath = clipPaths[i];
	        var shape = clipPath && clipPath.shape;
	        var type = clipPath && clipPath.type;
	
	        if (shape && (type === 'sector' && shape.startAngle === shape.endAngle || type === 'rect' && (!shape.width || !shape.height))) {
	          for (var j = 0; j < shadowTemp.length; j++) {
	            // It is save to put shadowTemp static, because shadowTemp
	            // will be all modified each item brush called.
	            shadowTemp[j][2] = style[shadowTemp[j][0]];
	            style[shadowTemp[j][0]] = shadowTemp[j][1];
	          }
	
	          modified = true;
	          break;
	        }
	      }
	    }
	
	    orignalBrush.apply(this, arguments);
	
	    if (modified) {
	      for (var j = 0; j < shadowTemp.length; j++) {
	        style[shadowTemp[j][0]] = shadowTemp[j][2];
	      }
	    }
	  } : orignalBrush;
	}
	
	module.exports = _default;

/***/ },
/* 1200 */
/***/ function(module, exports) {

	var SHADOW_PROPS = {
	  'shadowBlur': 1,
	  'shadowOffsetX': 1,
	  'shadowOffsetY': 1,
	  'textShadowBlur': 1,
	  'textShadowOffsetX': 1,
	  'textShadowOffsetY': 1,
	  'textBoxShadowBlur': 1,
	  'textBoxShadowOffsetX': 1,
	  'textBoxShadowOffsetY': 1
	};
	
	function _default(ctx, propName, value) {
	  if (SHADOW_PROPS.hasOwnProperty(propName)) {
	    return value *= ctx.dpr;
	  }
	
	  return value;
	}
	
	module.exports = _default;

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	var smoothSpline = __webpack_require__(2987);
	
	var smoothBezier = __webpack_require__(2986);
	
	function buildPath(ctx, shape, closePath) {
	  var points = shape.points;
	  var smooth = shape.smooth;
	
	  if (points && points.length >= 2) {
	    if (smooth && smooth !== 'spline') {
	      var controlPoints = smoothBezier(points, smooth, closePath, shape.smoothConstraint);
	      ctx.moveTo(points[0][0], points[0][1]);
	      var len = points.length;
	
	      for (var i = 0; i < (closePath ? len : len - 1); i++) {
	        var cp1 = controlPoints[i * 2];
	        var cp2 = controlPoints[i * 2 + 1];
	        var p = points[(i + 1) % len];
	        ctx.bezierCurveTo(cp1[0], cp1[1], cp2[0], cp2[1], p[0], p[1]);
	      }
	    } else {
	      if (smooth === 'spline') {
	        points = smoothSpline(points, closePath);
	      }
	
	      ctx.moveTo(points[0][0], points[0][1]);
	
	      for (var i = 1, l = points.length; i < l; i++) {
	        ctx.lineTo(points[i][0], points[i][1]);
	      }
	    }
	
	    closePath && ctx.closePath();
	  }
	}
	
	exports.buildPath = buildPath;

/***/ },
/* 1202 */
/***/ function(module, exports) {

	/**
	 * @param {Object} ctx
	 * @param {Object} shape
	 * @param {number} shape.x
	 * @param {number} shape.y
	 * @param {number} shape.width
	 * @param {number} shape.height
	 * @param {number} shape.r
	 */
	function buildPath(ctx, shape) {
	  var x = shape.x;
	  var y = shape.y;
	  var width = shape.width;
	  var height = shape.height;
	  var r = shape.r;
	  var r1;
	  var r2;
	  var r3;
	  var r4; // Convert width and height to positive for better borderRadius
	
	  if (width < 0) {
	    x = x + width;
	    width = -width;
	  }
	
	  if (height < 0) {
	    y = y + height;
	    height = -height;
	  }
	
	  if (typeof r === 'number') {
	    r1 = r2 = r3 = r4 = r;
	  } else if (r instanceof Array) {
	    if (r.length === 1) {
	      r1 = r2 = r3 = r4 = r[0];
	    } else if (r.length === 2) {
	      r1 = r3 = r[0];
	      r2 = r4 = r[1];
	    } else if (r.length === 3) {
	      r1 = r[0];
	      r2 = r4 = r[1];
	      r3 = r[2];
	    } else {
	      r1 = r[0];
	      r2 = r[1];
	      r3 = r[2];
	      r4 = r[3];
	    }
	  } else {
	    r1 = r2 = r3 = r4 = 0;
	  }
	
	  var total;
	
	  if (r1 + r2 > width) {
	    total = r1 + r2;
	    r1 *= width / total;
	    r2 *= width / total;
	  }
	
	  if (r3 + r4 > width) {
	    total = r3 + r4;
	    r3 *= width / total;
	    r4 *= width / total;
	  }
	
	  if (r2 + r3 > height) {
	    total = r2 + r3;
	    r2 *= height / total;
	    r3 *= height / total;
	  }
	
	  if (r1 + r4 > height) {
	    total = r1 + r4;
	    r1 *= height / total;
	    r4 *= height / total;
	  }
	
	  ctx.moveTo(x + r1, y);
	  ctx.lineTo(x + width - r2, y);
	  r2 !== 0 && ctx.arc(x + width - r2, y + r2, r2, -Math.PI / 2, 0);
	  ctx.lineTo(x + width, y + height - r3);
	  r3 !== 0 && ctx.arc(x + width - r3, y + height - r3, r3, 0, Math.PI / 2);
	  ctx.lineTo(x + r4, y + height);
	  r4 !== 0 && ctx.arc(x + r4, y + height - r4, r4, Math.PI / 2, Math.PI);
	  ctx.lineTo(x, y + r1);
	  r1 !== 0 && ctx.arc(x + r1, y + r1, r1, Math.PI, Math.PI * 1.5);
	}
	
	exports.buildPath = buildPath;

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	var textHelper = __webpack_require__(395);
	
	var BoundingRect = __webpack_require__(60);
	
	var _constant = __webpack_require__(394);
	
	var WILL_BE_RESTORED = _constant.WILL_BE_RESTORED;
	
	/**
	 * Mixin for drawing text in a element bounding rect
	 * @module zrender/mixin/RectText
	 */
	var tmpRect = new BoundingRect();
	
	var RectText = function () {};
	
	RectText.prototype = {
	  constructor: RectText,
	
	  /**
	   * Draw text in a rect with specified position.
	   * @param  {CanvasRenderingContext2D} ctx
	   * @param  {Object} rect Displayable rect
	   */
	  drawRectText: function (ctx, rect) {
	    var style = this.style;
	    rect = style.textRect || rect; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!textHelper.needDrawText(text, style)) {
	      return;
	    } // FIXME
	    // Do not provide prevEl to `textHelper.renderText` for ctx prop cache,
	    // but use `ctx.save()` and `ctx.restore()`. Because the cache for rect
	    // text propably break the cache for its host elements.
	
	
	    ctx.save(); // Transform rect to view space
	
	    var transform = this.transform;
	
	    if (!style.transformText) {
	      if (transform) {
	        tmpRect.copy(rect);
	        tmpRect.applyTransform(transform);
	        rect = tmpRect;
	      }
	    } else {
	      this.setTransform(ctx);
	    } // transformText and textRotation can not be used at the same time.
	
	
	    textHelper.renderText(this, ctx, text, style, rect, WILL_BE_RESTORED);
	    ctx.restore();
	  }
	};
	var _default = RectText;
	module.exports = _default;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	/**
	 * 圆形
	 * @module zrender/shape/Circle
	 */
	var _default = Path.extend({
	  type: 'circle',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0
	  },
	  buildPath: function (ctx, shape, inBundle) {
	    // Better stroking in ShapeBundle
	    // Always do it may have performence issue ( fill may be 2x more cost)
	    if (inBundle) {
	      ctx.moveTo(shape.cx + shape.r, shape.cy);
	    } // else {
	    //     if (ctx.allocate && !ctx.data.length) {
	    //         ctx.allocate(ctx.CMD_MEM_SIZE.A);
	    //     }
	    // }
	    // Better stroking in ShapeBundle
	    // ctx.moveTo(shape.cx + shape.r, shape.cy);
	
	
	    ctx.arc(shape.cx, shape.cy, shape.r, 0, Math.PI * 2, true);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	var _subPixelOptimize = __webpack_require__(605);
	
	var subPixelOptimizeLine = _subPixelOptimize.subPixelOptimizeLine;
	
	/**
	 * 直线
	 * @module zrender/graphic/shape/Line
	 */
	// Avoid create repeatly.
	var subPixelOptimizeOutputShape = {};
	
	var _default = Path.extend({
	  type: 'line',
	  shape: {
	    // Start point
	    x1: 0,
	    y1: 0,
	    // End point
	    x2: 0,
	    y2: 0,
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1;
	    var y1;
	    var x2;
	    var y2;
	
	    if (this.subPixelOptimize) {
	      subPixelOptimizeLine(subPixelOptimizeOutputShape, shape, this.style);
	      x1 = subPixelOptimizeOutputShape.x1;
	      y1 = subPixelOptimizeOutputShape.y1;
	      x2 = subPixelOptimizeOutputShape.x2;
	      y2 = subPixelOptimizeOutputShape.y2;
	    } else {
	      x1 = shape.x1;
	      y1 = shape.y1;
	      x2 = shape.x2;
	      y2 = shape.y2;
	    }
	
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (percent < 1) {
	      x2 = x1 * (1 - percent) + x2 * percent;
	      y2 = y1 * (1 - percent) + y2 * percent;
	    }
	
	    ctx.lineTo(x2, y2);
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} percent
	   * @return {Array.<number>}
	   */
	  pointAt: function (p) {
	    var shape = this.shape;
	    return [shape.x1 * (1 - p) + shape.x2 * p, shape.y1 * (1 - p) + shape.y2 * p];
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	var polyHelper = __webpack_require__(1201);
	
	/**
	 * 多边形
	 * @module zrender/shape/Polygon
	 */
	var _default = Path.extend({
	  type: 'polygon',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, true);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	var polyHelper = __webpack_require__(1201);
	
	/**
	 * @module zrender/graphic/shape/Polyline
	 */
	var _default = Path.extend({
	  type: 'polyline',
	  shape: {
	    points: null,
	    smooth: false,
	    smoothConstraint: null
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    polyHelper.buildPath(ctx, shape, false);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	var Group = __webpack_require__(223);
	
	var ZImage = __webpack_require__(267);
	
	var Text = __webpack_require__(224);
	
	var Circle = __webpack_require__(1204);
	
	var Rect = __webpack_require__(606);
	
	var Ellipse = __webpack_require__(2990);
	
	var Line = __webpack_require__(1205);
	
	var Path = __webpack_require__(67);
	
	var Polygon = __webpack_require__(1206);
	
	var Polyline = __webpack_require__(1207);
	
	var LinearGradient = __webpack_require__(602);
	
	var Style = __webpack_require__(603);
	
	var matrix = __webpack_require__(86);
	
	var _path = __webpack_require__(1209);
	
	var createFromString = _path.createFromString;
	
	var _util = __webpack_require__(4);
	
	var isString = _util.isString;
	var extend = _util.extend;
	var defaults = _util.defaults;
	var trim = _util.trim;
	var each = _util.each;
	// import RadialGradient from '../graphic/RadialGradient';
	// import Pattern from '../graphic/Pattern';
	// import * as vector from '../core/vector';
	// Most of the values can be separated by comma and/or white space.
	var DILIMITER_REG = /[\s,]+/;
	/**
	 * For big svg string, this method might be time consuming.
	 *
	 * @param {string} svg xml string
	 * @return {Object} xml root.
	 */
	
	function parseXML(svg) {
	  if (isString(svg)) {
	    var parser = new DOMParser();
	    svg = parser.parseFromString(svg, 'text/xml');
	  } // Document node. If using $.get, doc node may be input.
	
	
	  if (svg.nodeType === 9) {
	    svg = svg.firstChild;
	  } // nodeName of <!DOCTYPE svg> is also 'svg'.
	
	
	  while (svg.nodeName.toLowerCase() !== 'svg' || svg.nodeType !== 1) {
	    svg = svg.nextSibling;
	  }
	
	  return svg;
	}
	
	function SVGParser() {
	  this._defs = {};
	  this._root = null;
	  this._isDefine = false;
	  this._isText = false;
	}
	
	SVGParser.prototype.parse = function (xml, opt) {
	  opt = opt || {};
	  var svg = parseXML(xml);
	
	  if (!svg) {
	    throw new Error('Illegal svg');
	  }
	
	  var root = new Group();
	  this._root = root; // parse view port
	
	  var viewBox = svg.getAttribute('viewBox') || ''; // If width/height not specified, means "100%" of `opt.width/height`.
	  // TODO: Other percent value not supported yet.
	
	  var width = parseFloat(svg.getAttribute('width') || opt.width);
	  var height = parseFloat(svg.getAttribute('height') || opt.height); // If width/height not specified, set as null for output.
	
	  isNaN(width) && (width = null);
	  isNaN(height) && (height = null); // Apply inline style on svg element.
	
	  parseAttributes(svg, root, null, true);
	  var child = svg.firstChild;
	
	  while (child) {
	    this._parseNode(child, root);
	
	    child = child.nextSibling;
	  }
	
	  var viewBoxRect;
	  var viewBoxTransform;
	
	  if (viewBox) {
	    var viewBoxArr = trim(viewBox).split(DILIMITER_REG); // Some invalid case like viewBox: 'none'.
	
	    if (viewBoxArr.length >= 4) {
	      viewBoxRect = {
	        x: parseFloat(viewBoxArr[0] || 0),
	        y: parseFloat(viewBoxArr[1] || 0),
	        width: parseFloat(viewBoxArr[2]),
	        height: parseFloat(viewBoxArr[3])
	      };
	    }
	  }
	
	  if (viewBoxRect && width != null && height != null) {
	    viewBoxTransform = makeViewBoxTransform(viewBoxRect, width, height);
	
	    if (!opt.ignoreViewBox) {
	      // If set transform on the output group, it probably bring trouble when
	      // some users only intend to show the clipped content inside the viewBox,
	      // but not intend to transform the output group. So we keep the output
	      // group no transform. If the user intend to use the viewBox as a
	      // camera, just set `opt.ignoreViewBox` as `true` and set transfrom
	      // manually according to the viewBox info in the output of this method.
	      var elRoot = root;
	      root = new Group();
	      root.add(elRoot);
	      elRoot.scale = viewBoxTransform.scale.slice();
	      elRoot.position = viewBoxTransform.position.slice();
	    }
	  } // Some shapes might be overflow the viewport, which should be
	  // clipped despite whether the viewBox is used, as the SVG does.
	
	
	  if (!opt.ignoreRootClip && width != null && height != null) {
	    root.setClipPath(new Rect({
	      shape: {
	        x: 0,
	        y: 0,
	        width: width,
	        height: height
	      }
	    }));
	  } // Set width/height on group just for output the viewport size.
	
	
	  return {
	    root: root,
	    width: width,
	    height: height,
	    viewBoxRect: viewBoxRect,
	    viewBoxTransform: viewBoxTransform
	  };
	};
	
	SVGParser.prototype._parseNode = function (xmlNode, parentGroup) {
	  var nodeName = xmlNode.nodeName.toLowerCase(); // TODO
	  // support <style>...</style> in svg, where nodeName is 'style',
	  // CSS classes is defined globally wherever the style tags are declared.
	
	  if (nodeName === 'defs') {
	    // define flag
	    this._isDefine = true;
	  } else if (nodeName === 'text') {
	    this._isText = true;
	  }
	
	  var el;
	
	  if (this._isDefine) {
	    var parser = defineParsers[nodeName];
	
	    if (parser) {
	      var def = parser.call(this, xmlNode);
	      var id = xmlNode.getAttribute('id');
	
	      if (id) {
	        this._defs[id] = def;
	      }
	    }
	  } else {
	    var parser = nodeParsers[nodeName];
	
	    if (parser) {
	      el = parser.call(this, xmlNode, parentGroup);
	      parentGroup.add(el);
	    }
	  }
	
	  var child = xmlNode.firstChild;
	
	  while (child) {
	    if (child.nodeType === 1) {
	      this._parseNode(child, el);
	    } // Is text
	
	
	    if (child.nodeType === 3 && this._isText) {
	      this._parseText(child, el);
	    }
	
	    child = child.nextSibling;
	  } // Quit define
	
	
	  if (nodeName === 'defs') {
	    this._isDefine = false;
	  } else if (nodeName === 'text') {
	    this._isText = false;
	  }
	};
	
	SVGParser.prototype._parseText = function (xmlNode, parentGroup) {
	  if (xmlNode.nodeType === 1) {
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    this._textX += parseFloat(dx);
	    this._textY += parseFloat(dy);
	  }
	
	  var text = new Text({
	    style: {
	      text: xmlNode.textContent,
	      transformText: true
	    },
	    position: [this._textX || 0, this._textY || 0]
	  });
	  inheritStyle(parentGroup, text);
	  parseAttributes(xmlNode, text, this._defs);
	  var fontSize = text.style.fontSize;
	
	  if (fontSize && fontSize < 9) {
	    // PENDING
	    text.style.fontSize = 9;
	    text.scale = text.scale || [1, 1];
	    text.scale[0] *= fontSize / 9;
	    text.scale[1] *= fontSize / 9;
	  }
	
	  var rect = text.getBoundingRect();
	  this._textX += rect.width;
	  parentGroup.add(text);
	  return text;
	};
	
	var nodeParsers = {
	  'g': function (xmlNode, parentGroup) {
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    return g;
	  },
	  'rect': function (xmlNode, parentGroup) {
	    var rect = new Rect();
	    inheritStyle(parentGroup, rect);
	    parseAttributes(xmlNode, rect, this._defs);
	    rect.setShape({
	      x: parseFloat(xmlNode.getAttribute('x') || 0),
	      y: parseFloat(xmlNode.getAttribute('y') || 0),
	      width: parseFloat(xmlNode.getAttribute('width') || 0),
	      height: parseFloat(xmlNode.getAttribute('height') || 0)
	    }); // console.log(xmlNode.getAttribute('transform'));
	    // console.log(rect.transform);
	
	    return rect;
	  },
	  'circle': function (xmlNode, parentGroup) {
	    var circle = new Circle();
	    inheritStyle(parentGroup, circle);
	    parseAttributes(xmlNode, circle, this._defs);
	    circle.setShape({
	      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
	      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
	      r: parseFloat(xmlNode.getAttribute('r') || 0)
	    });
	    return circle;
	  },
	  'line': function (xmlNode, parentGroup) {
	    var line = new Line();
	    inheritStyle(parentGroup, line);
	    parseAttributes(xmlNode, line, this._defs);
	    line.setShape({
	      x1: parseFloat(xmlNode.getAttribute('x1') || 0),
	      y1: parseFloat(xmlNode.getAttribute('y1') || 0),
	      x2: parseFloat(xmlNode.getAttribute('x2') || 0),
	      y2: parseFloat(xmlNode.getAttribute('y2') || 0)
	    });
	    return line;
	  },
	  'ellipse': function (xmlNode, parentGroup) {
	    var ellipse = new Ellipse();
	    inheritStyle(parentGroup, ellipse);
	    parseAttributes(xmlNode, ellipse, this._defs);
	    ellipse.setShape({
	      cx: parseFloat(xmlNode.getAttribute('cx') || 0),
	      cy: parseFloat(xmlNode.getAttribute('cy') || 0),
	      rx: parseFloat(xmlNode.getAttribute('rx') || 0),
	      ry: parseFloat(xmlNode.getAttribute('ry') || 0)
	    });
	    return ellipse;
	  },
	  'polygon': function (xmlNode, parentGroup) {
	    var points = xmlNode.getAttribute('points');
	
	    if (points) {
	      points = parsePoints(points);
	    }
	
	    var polygon = new Polygon({
	      shape: {
	        points: points || []
	      }
	    });
	    inheritStyle(parentGroup, polygon);
	    parseAttributes(xmlNode, polygon, this._defs);
	    return polygon;
	  },
	  'polyline': function (xmlNode, parentGroup) {
	    var path = new Path();
	    inheritStyle(parentGroup, path);
	    parseAttributes(xmlNode, path, this._defs);
	    var points = xmlNode.getAttribute('points');
	
	    if (points) {
	      points = parsePoints(points);
	    }
	
	    var polyline = new Polyline({
	      shape: {
	        points: points || []
	      }
	    });
	    return polyline;
	  },
	  'image': function (xmlNode, parentGroup) {
	    var img = new ZImage();
	    inheritStyle(parentGroup, img);
	    parseAttributes(xmlNode, img, this._defs);
	    img.setStyle({
	      image: xmlNode.getAttribute('xlink:href'),
	      x: xmlNode.getAttribute('x'),
	      y: xmlNode.getAttribute('y'),
	      width: xmlNode.getAttribute('width'),
	      height: xmlNode.getAttribute('height')
	    });
	    return img;
	  },
	  'text': function (xmlNode, parentGroup) {
	    var x = xmlNode.getAttribute('x') || 0;
	    var y = xmlNode.getAttribute('y') || 0;
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    this._textX = parseFloat(x) + parseFloat(dx);
	    this._textY = parseFloat(y) + parseFloat(dy);
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    return g;
	  },
	  'tspan': function (xmlNode, parentGroup) {
	    var x = xmlNode.getAttribute('x');
	    var y = xmlNode.getAttribute('y');
	
	    if (x != null) {
	      // new offset x
	      this._textX = parseFloat(x);
	    }
	
	    if (y != null) {
	      // new offset y
	      this._textY = parseFloat(y);
	    }
	
	    var dx = xmlNode.getAttribute('dx') || 0;
	    var dy = xmlNode.getAttribute('dy') || 0;
	    var g = new Group();
	    inheritStyle(parentGroup, g);
	    parseAttributes(xmlNode, g, this._defs);
	    this._textX += dx;
	    this._textY += dy;
	    return g;
	  },
	  'path': function (xmlNode, parentGroup) {
	    // TODO svg fill rule
	    // https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/fill-rule
	    // path.style.globalCompositeOperation = 'xor';
	    var d = xmlNode.getAttribute('d') || ''; // Performance sensitive.
	
	    var path = createFromString(d);
	    inheritStyle(parentGroup, path);
	    parseAttributes(xmlNode, path, this._defs);
	    return path;
	  }
	};
	var defineParsers = {
	  'lineargradient': function (xmlNode) {
	    var x1 = parseInt(xmlNode.getAttribute('x1') || 0, 10);
	    var y1 = parseInt(xmlNode.getAttribute('y1') || 0, 10);
	    var x2 = parseInt(xmlNode.getAttribute('x2') || 10, 10);
	    var y2 = parseInt(xmlNode.getAttribute('y2') || 0, 10);
	    var gradient = new LinearGradient(x1, y1, x2, y2);
	
	    _parseGradientColorStops(xmlNode, gradient);
	
	    return gradient;
	  },
	  'radialgradient': function (xmlNode) {}
	};
	
	function _parseGradientColorStops(xmlNode, gradient) {
	  var stop = xmlNode.firstChild;
	
	  while (stop) {
	    if (stop.nodeType === 1) {
	      var offset = stop.getAttribute('offset');
	
	      if (offset.indexOf('%') > 0) {
	        // percentage
	        offset = parseInt(offset, 10) / 100;
	      } else if (offset) {
	        // number from 0 to 1
	        offset = parseFloat(offset);
	      } else {
	        offset = 0;
	      }
	
	      var stopColor = stop.getAttribute('stop-color') || '#000000';
	      gradient.addColorStop(offset, stopColor);
	    }
	
	    stop = stop.nextSibling;
	  }
	}
	
	function inheritStyle(parent, child) {
	  if (parent && parent.__inheritedStyle) {
	    if (!child.__inheritedStyle) {
	      child.__inheritedStyle = {};
	    }
	
	    defaults(child.__inheritedStyle, parent.__inheritedStyle);
	  }
	}
	
	function parsePoints(pointsString) {
	  var list = trim(pointsString).split(DILIMITER_REG);
	  var points = [];
	
	  for (var i = 0; i < list.length; i += 2) {
	    var x = parseFloat(list[i]);
	    var y = parseFloat(list[i + 1]);
	    points.push([x, y]);
	  }
	
	  return points;
	}
	
	var attributesMap = {
	  'fill': 'fill',
	  'stroke': 'stroke',
	  'stroke-width': 'lineWidth',
	  'opacity': 'opacity',
	  'fill-opacity': 'fillOpacity',
	  'stroke-opacity': 'strokeOpacity',
	  'stroke-dasharray': 'lineDash',
	  'stroke-dashoffset': 'lineDashOffset',
	  'stroke-linecap': 'lineCap',
	  'stroke-linejoin': 'lineJoin',
	  'stroke-miterlimit': 'miterLimit',
	  'font-family': 'fontFamily',
	  'font-size': 'fontSize',
	  'font-style': 'fontStyle',
	  'font-weight': 'fontWeight',
	  'text-align': 'textAlign',
	  'alignment-baseline': 'textBaseline'
	};
	
	function parseAttributes(xmlNode, el, defs, onlyInlineStyle) {
	  var zrStyle = el.__inheritedStyle || {};
	  var isTextEl = el.type === 'text'; // TODO Shadow
	
	  if (xmlNode.nodeType === 1) {
	    parseTransformAttribute(xmlNode, el);
	    extend(zrStyle, parseStyleAttribute(xmlNode));
	
	    if (!onlyInlineStyle) {
	      for (var svgAttrName in attributesMap) {
	        if (attributesMap.hasOwnProperty(svgAttrName)) {
	          var attrValue = xmlNode.getAttribute(svgAttrName);
	
	          if (attrValue != null) {
	            zrStyle[attributesMap[svgAttrName]] = attrValue;
	          }
	        }
	      }
	    }
	  }
	
	  var elFillProp = isTextEl ? 'textFill' : 'fill';
	  var elStrokeProp = isTextEl ? 'textStroke' : 'stroke';
	  el.style = el.style || new Style();
	  var elStyle = el.style;
	  zrStyle.fill != null && elStyle.set(elFillProp, getPaint(zrStyle.fill, defs));
	  zrStyle.stroke != null && elStyle.set(elStrokeProp, getPaint(zrStyle.stroke, defs));
	  each(['lineWidth', 'opacity', 'fillOpacity', 'strokeOpacity', 'miterLimit', 'fontSize'], function (propName) {
	    var elPropName = propName === 'lineWidth' && isTextEl ? 'textStrokeWidth' : propName;
	    zrStyle[propName] != null && elStyle.set(elPropName, parseFloat(zrStyle[propName]));
	  });
	
	  if (!zrStyle.textBaseline || zrStyle.textBaseline === 'auto') {
	    zrStyle.textBaseline = 'alphabetic';
	  }
	
	  if (zrStyle.textBaseline === 'alphabetic') {
	    zrStyle.textBaseline = 'bottom';
	  }
	
	  if (zrStyle.textAlign === 'start') {
	    zrStyle.textAlign = 'left';
	  }
	
	  if (zrStyle.textAlign === 'end') {
	    zrStyle.textAlign = 'right';
	  }
	
	  each(['lineDashOffset', 'lineCap', 'lineJoin', 'fontWeight', 'fontFamily', 'fontStyle', 'textAlign', 'textBaseline'], function (propName) {
	    zrStyle[propName] != null && elStyle.set(propName, zrStyle[propName]);
	  });
	
	  if (zrStyle.lineDash) {
	    el.style.lineDash = trim(zrStyle.lineDash).split(DILIMITER_REG);
	  }
	
	  if (elStyle[elStrokeProp] && elStyle[elStrokeProp] !== 'none') {
	    // enable stroke
	    el[elStrokeProp] = true;
	  }
	
	  el.__inheritedStyle = zrStyle;
	}
	
	var urlRegex = /url\(\s*#(.*?)\)/;
	
	function getPaint(str, defs) {
	  // if (str === 'none') {
	  //     return;
	  // }
	  var urlMatch = defs && str && str.match(urlRegex);
	
	  if (urlMatch) {
	    var url = trim(urlMatch[1]);
	    var def = defs[url];
	    return def;
	  }
	
	  return str;
	}
	
	var transformRegex = /(translate|scale|rotate|skewX|skewY|matrix)\(([\-\s0-9\.e,]*)\)/g;
	
	function parseTransformAttribute(xmlNode, node) {
	  var transform = xmlNode.getAttribute('transform');
	
	  if (transform) {
	    transform = transform.replace(/,/g, ' ');
	    var m = null;
	    var transformOps = [];
	    transform.replace(transformRegex, function (str, type, value) {
	      transformOps.push(type, value);
	    });
	
	    for (var i = transformOps.length - 1; i > 0; i -= 2) {
	      var value = transformOps[i];
	      var type = transformOps[i - 1];
	      m = m || matrix.create();
	
	      switch (type) {
	        case 'translate':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.translate(m, m, [parseFloat(value[0]), parseFloat(value[1] || 0)]);
	          break;
	
	        case 'scale':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.scale(m, m, [parseFloat(value[0]), parseFloat(value[1] || value[0])]);
	          break;
	
	        case 'rotate':
	          value = trim(value).split(DILIMITER_REG);
	          matrix.rotate(m, m, parseFloat(value[0]));
	          break;
	
	        case 'skew':
	          value = trim(value).split(DILIMITER_REG);
	          console.warn('Skew transform is not supported yet');
	          break;
	
	        case 'matrix':
	          var value = trim(value).split(DILIMITER_REG);
	          m[0] = parseFloat(value[0]);
	          m[1] = parseFloat(value[1]);
	          m[2] = parseFloat(value[2]);
	          m[3] = parseFloat(value[3]);
	          m[4] = parseFloat(value[4]);
	          m[5] = parseFloat(value[5]);
	          break;
	      }
	    }
	
	    node.setLocalTransform(m);
	  }
	} // Value may contain space.
	
	
	var styleRegex = /([^\s:;]+)\s*:\s*([^:;]+)/g;
	
	function parseStyleAttribute(xmlNode) {
	  var style = xmlNode.getAttribute('style');
	  var result = {};
	
	  if (!style) {
	    return result;
	  }
	
	  var styleList = {};
	  styleRegex.lastIndex = 0;
	  var styleRegResult;
	
	  while ((styleRegResult = styleRegex.exec(style)) != null) {
	    styleList[styleRegResult[1]] = styleRegResult[2];
	  }
	
	  for (var svgAttrName in attributesMap) {
	    if (attributesMap.hasOwnProperty(svgAttrName) && styleList[svgAttrName] != null) {
	      result[attributesMap[svgAttrName]] = styleList[svgAttrName];
	    }
	  }
	
	  return result;
	}
	/**
	 * @param {Array.<number>} viewBoxRect
	 * @param {number} width
	 * @param {number} height
	 * @return {Object} {scale, position}
	 */
	
	
	function makeViewBoxTransform(viewBoxRect, width, height) {
	  var scaleX = width / viewBoxRect.width;
	  var scaleY = height / viewBoxRect.height;
	  var scale = Math.min(scaleX, scaleY); // preserveAspectRatio 'xMidYMid'
	
	  var viewBoxScale = [scale, scale];
	  var viewBoxPosition = [-(viewBoxRect.x + viewBoxRect.width / 2) * scale + width / 2, -(viewBoxRect.y + viewBoxRect.height / 2) * scale + height / 2];
	  return {
	    scale: viewBoxScale,
	    position: viewBoxPosition
	  };
	}
	/**
	 * @param {string|XMLElement} xml
	 * @param {Object} [opt]
	 * @param {number} [opt.width] Default width if svg width not specified or is a percent value.
	 * @param {number} [opt.height] Default height if svg height not specified or is a percent value.
	 * @param {boolean} [opt.ignoreViewBox]
	 * @param {boolean} [opt.ignoreRootClip]
	 * @return {Object} result:
	 * {
	 *     root: Group, The root of the the result tree of zrender shapes,
	 *     width: number, the viewport width of the SVG,
	 *     height: number, the viewport height of the SVG,
	 *     viewBoxRect: {x, y, width, height}, the declared viewBox rect of the SVG, if exists,
	 *     viewBoxTransform: the {scale, position} calculated by viewBox and viewport, is exists.
	 * }
	 */
	
	
	function parseSVG(xml, opt) {
	  var parser = new SVGParser();
	  return parser.parse(xml, opt);
	}
	
	exports.parseXML = parseXML;
	exports.makeViewBoxTransform = makeViewBoxTransform;
	exports.parseSVG = parseSVG;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	var PathProxy = __webpack_require__(266);
	
	var transformPath = __webpack_require__(3000);
	
	// command chars
	// var cc = [
	//     'm', 'M', 'l', 'L', 'v', 'V', 'h', 'H', 'z', 'Z',
	//     'c', 'C', 'q', 'Q', 't', 'T', 's', 'S', 'a', 'A'
	// ];
	var mathSqrt = Math.sqrt;
	var mathSin = Math.sin;
	var mathCos = Math.cos;
	var PI = Math.PI;
	
	var vMag = function (v) {
	  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
	};
	
	var vRatio = function (u, v) {
	  return (u[0] * v[0] + u[1] * v[1]) / (vMag(u) * vMag(v));
	};
	
	var vAngle = function (u, v) {
	  return (u[0] * v[1] < u[1] * v[0] ? -1 : 1) * Math.acos(vRatio(u, v));
	};
	
	function processArc(x1, y1, x2, y2, fa, fs, rx, ry, psiDeg, cmd, path) {
	  var psi = psiDeg * (PI / 180.0);
	  var xp = mathCos(psi) * (x1 - x2) / 2.0 + mathSin(psi) * (y1 - y2) / 2.0;
	  var yp = -1 * mathSin(psi) * (x1 - x2) / 2.0 + mathCos(psi) * (y1 - y2) / 2.0;
	  var lambda = xp * xp / (rx * rx) + yp * yp / (ry * ry);
	
	  if (lambda > 1) {
	    rx *= mathSqrt(lambda);
	    ry *= mathSqrt(lambda);
	  }
	
	  var f = (fa === fs ? -1 : 1) * mathSqrt((rx * rx * (ry * ry) - rx * rx * (yp * yp) - ry * ry * (xp * xp)) / (rx * rx * (yp * yp) + ry * ry * (xp * xp))) || 0;
	  var cxp = f * rx * yp / ry;
	  var cyp = f * -ry * xp / rx;
	  var cx = (x1 + x2) / 2.0 + mathCos(psi) * cxp - mathSin(psi) * cyp;
	  var cy = (y1 + y2) / 2.0 + mathSin(psi) * cxp + mathCos(psi) * cyp;
	  var theta = vAngle([1, 0], [(xp - cxp) / rx, (yp - cyp) / ry]);
	  var u = [(xp - cxp) / rx, (yp - cyp) / ry];
	  var v = [(-1 * xp - cxp) / rx, (-1 * yp - cyp) / ry];
	  var dTheta = vAngle(u, v);
	
	  if (vRatio(u, v) <= -1) {
	    dTheta = PI;
	  }
	
	  if (vRatio(u, v) >= 1) {
	    dTheta = 0;
	  }
	
	  if (fs === 0 && dTheta > 0) {
	    dTheta = dTheta - 2 * PI;
	  }
	
	  if (fs === 1 && dTheta < 0) {
	    dTheta = dTheta + 2 * PI;
	  }
	
	  path.addData(cmd, cx, cy, rx, ry, theta, dTheta, psi, fs);
	}
	
	var commandReg = /([mlvhzcqtsa])([^mlvhzcqtsa]*)/ig; // Consider case:
	// (1) delimiter can be comma or space, where continuous commas
	// or spaces should be seen as one comma.
	// (2) value can be like:
	// '2e-4', 'l.5.9' (ignore 0), 'M-10-10', 'l-2.43e-1,34.9983',
	// 'l-.5E1,54', '121-23-44-11' (no delimiter)
	
	var numberReg = /-?([0-9]*\.)?[0-9]+([eE]-?[0-9]+)?/g; // var valueSplitReg = /[\s,]+/;
	
	function createPathProxyFromString(data) {
	  if (!data) {
	    return new PathProxy();
	  } // var data = data.replace(/-/g, ' -')
	  //     .replace(/  /g, ' ')
	  //     .replace(/ /g, ',')
	  //     .replace(/,,/g, ',');
	  // var n;
	  // create pipes so that we can split the data
	  // for (n = 0; n < cc.length; n++) {
	  //     cs = cs.replace(new RegExp(cc[n], 'g'), '|' + cc[n]);
	  // }
	  // data = data.replace(/-/g, ',-');
	  // create array
	  // var arr = cs.split('|');
	  // init context point
	
	
	  var cpx = 0;
	  var cpy = 0;
	  var subpathX = cpx;
	  var subpathY = cpy;
	  var prevCmd;
	  var path = new PathProxy();
	  var CMD = PathProxy.CMD; // commandReg.lastIndex = 0;
	  // var cmdResult;
	  // while ((cmdResult = commandReg.exec(data)) != null) {
	  //     var cmdStr = cmdResult[1];
	  //     var cmdContent = cmdResult[2];
	
	  var cmdList = data.match(commandReg);
	
	  for (var l = 0; l < cmdList.length; l++) {
	    var cmdText = cmdList[l];
	    var cmdStr = cmdText.charAt(0);
	    var cmd; // String#split is faster a little bit than String#replace or RegExp#exec.
	    // var p = cmdContent.split(valueSplitReg);
	    // var pLen = 0;
	    // for (var i = 0; i < p.length; i++) {
	    //     // '' and other invalid str => NaN
	    //     var val = parseFloat(p[i]);
	    //     !isNaN(val) && (p[pLen++] = val);
	    // }
	
	    var p = cmdText.match(numberReg) || [];
	    var pLen = p.length;
	
	    for (var i = 0; i < pLen; i++) {
	      p[i] = parseFloat(p[i]);
	    }
	
	    var off = 0;
	
	    while (off < pLen) {
	      var ctlPtx;
	      var ctlPty;
	      var rx;
	      var ry;
	      var psi;
	      var fa;
	      var fs;
	      var x1 = cpx;
	      var y1 = cpy; // convert l, H, h, V, and v to L
	
	      switch (cmdStr) {
	        case 'l':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'L':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'm':
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          subpathX = cpx;
	          subpathY = cpy;
	          cmdStr = 'l';
	          break;
	
	        case 'M':
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.M;
	          path.addData(cmd, cpx, cpy);
	          subpathX = cpx;
	          subpathY = cpy;
	          cmdStr = 'L';
	          break;
	
	        case 'h':
	          cpx += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'H':
	          cpx = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'v':
	          cpy += p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'V':
	          cpy = p[off++];
	          cmd = CMD.L;
	          path.addData(cmd, cpx, cpy);
	          break;
	
	        case 'C':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++], p[off++], p[off++], p[off++], p[off++], p[off++]);
	          cpx = p[off - 2];
	          cpy = p[off - 1];
	          break;
	
	        case 'c':
	          cmd = CMD.C;
	          path.addData(cmd, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy, p[off++] + cpx, p[off++] + cpy);
	          cpx += p[off - 2];
	          cpy += p[off - 1];
	          break;
	
	        case 'S':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 's':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.C) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cmd = CMD.C;
	          x1 = cpx + p[off++];
	          y1 = cpy + p[off++];
	          cpx += p[off++];
	          cpy += p[off++];
	          path.addData(cmd, ctlPtx, ctlPty, x1, y1, cpx, cpy);
	          break;
	
	        case 'Q':
	          x1 = p[off++];
	          y1 = p[off++];
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'q':
	          x1 = p[off++] + cpx;
	          y1 = p[off++] + cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, x1, y1, cpx, cpy);
	          break;
	
	        case 'T':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 't':
	          ctlPtx = cpx;
	          ctlPty = cpy;
	          var len = path.len();
	          var pathData = path.data;
	
	          if (prevCmd === CMD.Q) {
	            ctlPtx += cpx - pathData[len - 4];
	            ctlPty += cpy - pathData[len - 3];
	          }
	
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.Q;
	          path.addData(cmd, ctlPtx, ctlPty, cpx, cpy);
	          break;
	
	        case 'A':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx = p[off++];
	          cpy = p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	
	        case 'a':
	          rx = p[off++];
	          ry = p[off++];
	          psi = p[off++];
	          fa = p[off++];
	          fs = p[off++];
	          x1 = cpx, y1 = cpy;
	          cpx += p[off++];
	          cpy += p[off++];
	          cmd = CMD.A;
	          processArc(x1, y1, cpx, cpy, fa, fs, rx, ry, psi, cmd, path);
	          break;
	      }
	    }
	
	    if (cmdStr === 'z' || cmdStr === 'Z') {
	      cmd = CMD.Z;
	      path.addData(cmd); // z may be in the middle of the path.
	
	      cpx = subpathX;
	      cpy = subpathY;
	    }
	
	    prevCmd = cmd;
	  }
	
	  path.toStatic();
	  return path;
	} // TODO Optimize double memory cost problem
	
	
	function createPathOptions(str, opts) {
	  var pathProxy = createPathProxyFromString(str);
	  opts = opts || {};
	
	  opts.buildPath = function (path) {
	    if (path.setData) {
	      path.setData(pathProxy.data); // Svg and vml renderer don't have context
	
	      var ctx = path.getContext();
	
	      if (ctx) {
	        path.rebuildPath(ctx);
	      }
	    } else {
	      var ctx = path;
	      pathProxy.rebuildPath(ctx);
	    }
	  };
	
	  opts.applyTransform = function (m) {
	    transformPath(pathProxy, m);
	    this.dirty(true);
	  };
	
	  return opts;
	}
	/**
	 * Create a Path object from path string data
	 * http://www.w3.org/TR/SVG/paths.html#PathData
	 * @param  {Object} opts Other options
	 */
	
	
	function createFromString(str, opts) {
	  return new Path(createPathOptions(str, opts));
	}
	/**
	 * Create a Path class from path string data
	 * @param  {string} str
	 * @param  {Object} opts Other options
	 */
	
	
	function extendFromString(str, opts) {
	  return Path.extend(createPathOptions(str, opts));
	}
	/**
	 * Merge multiple paths
	 */
	// TODO Apply transform
	// TODO stroke dash
	// TODO Optimize double memory cost problem
	
	
	function mergePath(pathEls, opts) {
	  var pathList = [];
	  var len = pathEls.length;
	
	  for (var i = 0; i < len; i++) {
	    var pathEl = pathEls[i];
	
	    if (!pathEl.path) {
	      pathEl.createPathProxy();
	    }
	
	    if (pathEl.__dirtyPath) {
	      pathEl.buildPath(pathEl.path, pathEl.shape, true);
	    }
	
	    pathList.push(pathEl.path);
	  }
	
	  var pathBundle = new Path(opts); // Need path proxy.
	
	  pathBundle.createPathProxy();
	
	  pathBundle.buildPath = function (path) {
	    path.appendPath(pathList); // Svg and vml renderer don't have context
	
	    var ctx = path.getContext();
	
	    if (ctx) {
	      path.rebuildPath(ctx);
	    }
	  };
	
	  return pathBundle;
	}
	
	exports.createFromString = createFromString;
	exports.extendFromString = extendFromString;
	exports.mergePath = mergePath;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	var env = __webpack_require__(73);
	
	var urn = 'urn:schemas-microsoft-com:vml';
	var win = typeof window === 'undefined' ? null : window;
	var vmlInited = false;
	var doc = win && win.document;
	
	function createNode(tagName) {
	  return doCreateNode(tagName);
	} // Avoid assign to an exported variable, for transforming to cjs.
	
	
	var doCreateNode;
	
	if (doc && !env.canvasSupported) {
	  try {
	    !doc.namespaces.zrvml && doc.namespaces.add('zrvml', urn);
	
	    doCreateNode = function (tagName) {
	      return doc.createElement('<zrvml:' + tagName + ' class="zrvml">');
	    };
	  } catch (e) {
	    doCreateNode = function (tagName) {
	      return doc.createElement('<' + tagName + ' xmlns="' + urn + '" class="zrvml">');
	    };
	  }
	} // From raphael
	
	
	function initVML() {
	  if (vmlInited || !doc) {
	    return;
	  }
	
	  vmlInited = true;
	  var styleSheets = doc.styleSheets;
	
	  if (styleSheets.length < 31) {
	    doc.createStyleSheet().addRule('.zrvml', 'behavior:url(#default#VML)');
	  } else {
	    // http://msdn.microsoft.com/en-us/library/ms531194%28VS.85%29.aspx
	    styleSheets[0].addRule('.zrvml', 'behavior:url(#default#VML)');
	  }
	}
	
	exports.doc = doc;
	exports.createNode = createNode;
	exports.initVML = initVML;

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(2621).enable();
	  window.Promise = __webpack_require__(2620);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1186);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(40);


/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var tinycolor2_1 = __importDefault(__webpack_require__(2942));
	var hueStep = 2; // 色相阶梯
	var saturationStep = 16; // 饱和度阶梯，浅色部分
	var saturationStep2 = 5; // 饱和度阶梯，深色部分
	var brightnessStep1 = 5; // 亮度阶梯，浅色部分
	var brightnessStep2 = 15; // 亮度阶梯，深色部分
	var lightColorCount = 5; // 浅色数量，主色上
	var darkColorCount = 4; // 深色数量，主色下
	function getHue(hsv, i, light) {
	    var hue;
	    // 根据色相不同，色相转向不同
	    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
	        hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
	    }
	    else {
	        hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
	    }
	    if (hue < 0) {
	        hue += 360;
	    }
	    else if (hue >= 360) {
	        hue -= 360;
	    }
	    return hue;
	}
	function getSaturation(hsv, i, light) {
	    // grey color don't change saturation
	    if (hsv.h === 0 && hsv.s === 0) {
	        return hsv.s;
	    }
	    var saturation;
	    if (light) {
	        saturation = Math.round(hsv.s * 100) - saturationStep * i;
	    }
	    else if (i === darkColorCount) {
	        saturation = Math.round(hsv.s * 100) + saturationStep;
	    }
	    else {
	        saturation = Math.round(hsv.s * 100) + saturationStep2 * i;
	    }
	    // 边界值修正
	    if (saturation > 100) {
	        saturation = 100;
	    }
	    // 第一格的 s 限制在 6-10 之间
	    if (light && i === lightColorCount && saturation > 10) {
	        saturation = 10;
	    }
	    if (saturation < 6) {
	        saturation = 6;
	    }
	    return saturation;
	}
	function getValue(hsv, i, light) {
	    if (light) {
	        return Math.round(hsv.v * 100) + brightnessStep1 * i;
	    }
	    return Math.round(hsv.v * 100) - brightnessStep2 * i;
	}
	function generate(color) {
	    var patterns = [];
	    var pColor = tinycolor2_1.default(color);
	    for (var i = lightColorCount; i > 0; i -= 1) {
	        var hsv = pColor.toHsv();
	        var colorString = tinycolor2_1.default({
	            h: getHue(hsv, i, true),
	            s: getSaturation(hsv, i, true),
	            v: getValue(hsv, i, true),
	        }).toHexString();
	        patterns.push(colorString);
	    }
	    patterns.push(pColor.toHexString());
	    for (var i = 1; i <= darkColorCount; i += 1) {
	        var hsv = pColor.toHsv();
	        var colorString = tinycolor2_1.default({
	            h: getHue(hsv, i),
	            s: getSaturation(hsv, i),
	            v: getValue(hsv, i),
	        }).toHexString();
	        patterns.push(colorString);
	    }
	    return patterns;
	}
	exports.default = generate;


/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	var __importDefault = (this && this.__importDefault) || function (mod) {
	    return (mod && mod.__esModule) ? mod : { "default": mod };
	};
	Object.defineProperty(exports, "__esModule", { value: true });
	var generate_1 = __importDefault(__webpack_require__(1212));
	exports.generate = generate_1.default;
	var presetPrimaryColors = {
	    red: '#F5222D',
	    volcano: '#FA541C',
	    orange: '#FA8C16',
	    gold: '#FAAD14',
	    yellow: '#FADB14',
	    lime: '#A0D911',
	    green: '#52C41A',
	    cyan: '#13C2C2',
	    blue: '#1890FF',
	    geekblue: '#2F54EB',
	    purple: '#722ED1',
	    magenta: '#EB2F96',
	    grey: '#666666',
	};
	exports.presetPrimaryColors = presetPrimaryColors;
	var presetPalettes = {};
	exports.presetPalettes = presetPalettes;
	Object.keys(presetPrimaryColors).forEach(function (key) {
	    presetPalettes[key] = generate_1.default(presetPrimaryColors[key]);
	    presetPalettes[key].primary = presetPalettes[key][5];
	});
	var red = presetPalettes.red;
	exports.red = red;
	var volcano = presetPalettes.volcano;
	exports.volcano = volcano;
	var gold = presetPalettes.gold;
	exports.gold = gold;
	var orange = presetPalettes.orange;
	exports.orange = orange;
	var yellow = presetPalettes.yellow;
	exports.yellow = yellow;
	var lime = presetPalettes.lime;
	exports.lime = lime;
	var green = presetPalettes.green;
	exports.green = green;
	var cyan = presetPalettes.cyan;
	exports.cyan = cyan;
	var blue = presetPalettes.blue;
	exports.blue = blue;
	var geekblue = presetPalettes.geekblue;
	exports.geekblue = geekblue;
	var purple = presetPalettes.purple;
	exports.purple = purple;
	var magenta = presetPalettes.magenta;
	exports.magenta = magenta;
	var grey = presetPalettes.grey;
	exports.grey = grey;


/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gud = __webpack_require__(2482);
	
	var _gud2 = _interopRequireDefault(_gud);
	
	var _warning = __webpack_require__(94);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	// Inlined Object.is polyfill.
	// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    function Provider() {
	      var _temp, _this, _ret;
	
	      _classCallCheck(this, Provider);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
	    }
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits = void 0;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0; // No change
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	          if (false) {
	            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    Provider.prototype.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);
	
	  var Consumer = function (_Component2) {
	    _inherits(Consumer, _Component2);
	
	    function Consumer() {
	      var _temp2, _this2, _ret2;
	
	      _classCallCheck(this, Consumer);
	
	      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
	        value: _this2.getValue()
	      }, _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({ value: _this2.getValue() });
	        }
	      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
	    }
	
	    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	      var observedBits = this.props.observedBits;
	
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
	      : observedBits;
	    };
	
	    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    Consumer.prototype.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    Consumer.prototype.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(_react.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);
	
	
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}
	
	exports.default = createReactContext;
	module.exports = exports['default'];

/***/ },
/* 1215 */
794,
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isCssAnimationSupported = undefined;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _Event = __webpack_require__(1215);
	
	var _Event2 = _interopRequireDefault(_Event);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isCssAnimationSupported = _Event2['default'].endEvents.length !== 0;
	var capitalPrefixes = ['Webkit', 'Moz', 'O',
	// ms is special .... !
	'ms'];
	var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];
	
	function getStyleProperty(node, name) {
	  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
	  var style = window.getComputedStyle(node, null);
	  var ret = '';
	  for (var i = 0; i < prefixes.length; i++) {
	    ret = style.getPropertyValue(prefixes[i] + name);
	    if (ret) {
	      break;
	    }
	  }
	  return ret;
	}
	
	function fixBrowserByTimeout(node) {
	  if (isCssAnimationSupported) {
	    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
	    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
	    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
	    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
	    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
	    // sometimes, browser bug
	    node.rcEndAnimTimeout = setTimeout(function () {
	      node.rcEndAnimTimeout = null;
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }, time * 1000 + 200);
	  }
	}
	
	function clearBrowserBugTimeout(node) {
	  if (node.rcEndAnimTimeout) {
	    clearTimeout(node.rcEndAnimTimeout);
	    node.rcEndAnimTimeout = null;
	  }
	}
	
	var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
	  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : _typeof(transitionName)) === 'object';
	  var className = nameIsObj ? transitionName.name : transitionName;
	  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
	  var end = endCallback;
	  var start = void 0;
	  var active = void 0;
	
	  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
	    end = endCallback.end;
	    start = endCallback.start;
	    active = endCallback.active;
	  }
	
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    node.classList.remove(className);
	    node.classList.remove(activeClassName);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional end is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (end) {
	      end();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  if (start) {
	    start();
	  }
	  node.classList.add(className);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    node.rcAnimTimeout = null;
	    node.classList.add(activeClassName);
	    if (active) {
	      active();
	    }
	    fixBrowserByTimeout(node);
	  }, 0);
	
	  return {
	    stop: function stop() {
	      if (node.rcEndListener) {
	        node.rcEndListener();
	      }
	    }
	  };
	};
	
	cssAnimation.style = function (node, style, callback) {
	  if (node.rcEndListener) {
	    node.rcEndListener();
	  }
	
	  node.rcEndListener = function (e) {
	    if (e && e.target !== node) {
	      return;
	    }
	
	    if (node.rcAnimTimeout) {
	      clearTimeout(node.rcAnimTimeout);
	      node.rcAnimTimeout = null;
	    }
	
	    clearBrowserBugTimeout(node);
	
	    _Event2['default'].removeEndEventListener(node, node.rcEndListener);
	    node.rcEndListener = null;
	
	    // Usually this optional callback is used for informing an owner of
	    // a leave animation and telling it to remove the child.
	    if (callback) {
	      callback();
	    }
	  };
	
	  _Event2['default'].addEndEventListener(node, node.rcEndListener);
	
	  node.rcAnimTimeout = setTimeout(function () {
	    for (var s in style) {
	      if (style.hasOwnProperty(s)) {
	        node.style[s] = style[s];
	      }
	    }
	    node.rcAnimTimeout = null;
	    fixBrowserByTimeout(node);
	  }, 0);
	};
	
	cssAnimation.setTransition = function (node, p, value) {
	  var property = p;
	  var v = value;
	  if (value === undefined) {
	    v = property;
	    property = '';
	  }
	  property = property || '';
	  capitalPrefixes.forEach(function (prefix) {
	    node.style[prefix + 'Transition' + property] = v;
	  });
	};
	
	cssAnimation.isCssAnimationSupported = isCssAnimationSupported;
	
	exports.isCssAnimationSupported = isCssAnimationSupported;
	exports['default'] = cssAnimation;

/***/ },
/* 1217 */
/***/ function(module, exports) {

	"use strict";
	Object.defineProperty(exports, "__esModule", { value: true });
	var normalViewBox = '0 0 1024 1024';
	var newViewBox = '64 64 896 896';
	var fill = 'fill';
	var outline = 'outline';
	var twotone = 'twotone';
	function getNode(viewBox) {
	    var paths = [];
	    for (var _i = 1; _i < arguments.length; _i++) {
	        paths[_i - 1] = arguments[_i];
	    }
	    return {
	        tag: 'svg',
	        attrs: { viewBox: viewBox, focusable: false },
	        children: paths.map(function (path) {
	            if (Array.isArray(path)) {
	                return {
	                    tag: 'path',
	                    attrs: {
	                        fill: path[0],
	                        d: path[1]
	                    }
	                };
	            }
	            return {
	                tag: 'path',
	                attrs: {
	                    d: path
	                }
	            };
	        })
	    };
	}
	function getIcon(name, theme, icon) {
	    return {
	        name: name,
	        theme: theme,
	        icon: icon
	    };
	}
	exports.AccountBookFill = getIcon('account-book', fill, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z'));
	exports.AlertFill = getIcon('alert', fill, getNode(newViewBox, 'M512 244c176.18 0 319 142.82 319 319v233a32 32 0 0 1-32 32H225a32 32 0 0 1-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 0 1 8 8v96a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V76a8 8 0 0 1 8-8zM177.25 191.66a8 8 0 0 1 11.32 0l67.88 67.88a8 8 0 0 1 0 11.31l-39.6 39.6a8 8 0 0 1-11.31 0l-67.88-67.88a8 8 0 0 1 0-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 0 1 0 11.3l-67.88 67.9a8 8 0 0 1-11.32 0l-39.6-39.6a8 8 0 0 1 0-11.32l67.89-67.88a8 8 0 0 1 11.31 0zM192 892h640a32 32 0 0 1 32 32v24a8 8 0 0 1-8 8H168a8 8 0 0 1-8-8v-24a32 32 0 0 1 32-32zm148-317v253h64V575h-64z'));
	exports.AlipaySquareFill = getIcon('alipay-square', fill, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z'));
	exports.AliwangwangFill = getIcon('aliwangwang', fill, getNode(newViewBox, 'M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z'));
	exports.AlipayCircleFill = getIcon('alipay-circle', fill, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z'));
	exports.AmazonCircleFill = getIcon('amazon-circle', fill, getNode(newViewBox, 'M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z'));
	exports.AndroidFill = getIcon('android', fill, getNode(newViewBox, 'M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm208.4 0a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z'));
	exports.AmazonSquareFill = getIcon('amazon-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z'));
	exports.ApiFill = getIcon('api', fill, getNode(newViewBox, 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z'));
	exports.AppstoreFill = getIcon('appstore', fill, getNode(newViewBox, 'M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z'));
	exports.AudioFill = getIcon('audio', fill, getNode(newViewBox, 'M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z'));
	exports.AppleFill = getIcon('apple', fill, getNode(newViewBox, 'M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z'));
	exports.BackwardFill = getIcon('backward', fill, getNode(normalViewBox, 'M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z'));
	exports.BankFill = getIcon('bank', fill, getNode(newViewBox, 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z'));
	exports.BehanceCircleFill = getIcon('behance-circle', fill, getNode(newViewBox, 'M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0 0 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z'));
	exports.BellFill = getIcon('bell', fill, getNode(newViewBox, 'M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z'));
	exports.BehanceSquareFill = getIcon('behance-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z'));
	exports.BookFill = getIcon('book', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z'));
	exports.BoxPlotFill = getIcon('box-plot', fill, getNode(newViewBox, 'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z'));
	exports.BugFill = getIcon('bug', fill, getNode(newViewBox, 'M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 0 0-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 0 0-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z', 'M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 0 1-63 63H232a63 63 0 0 1-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0 0 22.7 49c24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5a281.38 281.38 0 0 0 123.2-149.5A120.4 120.4 0 0 1 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.CalculatorFill = getIcon('calculator', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z'));
	exports.BulbFill = getIcon('bulb', fill, getNode(newViewBox, 'M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z'));
	exports.BuildFill = getIcon('build', fill, getNode(newViewBox, 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z'));
	exports.CalendarFill = getIcon('calendar', fill, getNode(newViewBox, 'M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z'));
	exports.CameraFill = getIcon('camera', fill, getNode(newViewBox, 'M864 260H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 1 0 192 0 96 96 0 1 0-192 0z'));
	exports.CarFill = getIcon('car', fill, getNode(newViewBox, 'M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z'));
	exports.CaretDownFill = getIcon('caret-down', fill, getNode(normalViewBox, 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'));
	exports.CaretLeftFill = getIcon('caret-left', fill, getNode(normalViewBox, 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'));
	exports.CaretRightFill = getIcon('caret-right', fill, getNode(normalViewBox, 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'));
	exports.CarryOutFill = getIcon('carry-out', fill, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z'));
	exports.CaretUpFill = getIcon('caret-up', fill, getNode(normalViewBox, 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'));
	exports.CheckCircleFill = getIcon('check-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z'));
	exports.CheckSquareFill = getIcon('check-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z'));
	exports.ChromeFill = getIcon('chrome', fill, getNode(newViewBox, 'M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0 0 96 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z'));
	exports.CiCircleFill = getIcon('ci-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z'));
	exports.ClockCircleFill = getIcon('clock-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z'));
	exports.CloseCircleFill = getIcon('close-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z'));
	exports.CloudFill = getIcon('cloud', fill, getNode(newViewBox, 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z'));
	exports.CloseSquareFill = getIcon('close-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM676.1 657.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9z'));
	exports.CodeSandboxSquareFill = getIcon('code-sandbox-square', fill, getNode(newViewBox, 'M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z'));
	exports.CodeSandboxCircleFill = getIcon('code-sandbox-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z'));
	exports.CodeFill = getIcon('code', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z'));
	exports.CompassFill = getIcon('compass', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z'));
	exports.CodepenCircleFill = getIcon('codepen-circle', fill, getNode(newViewBox, 'M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z'));
	exports.CodepenSquareFill = getIcon('codepen-square', fill, getNode(newViewBox, 'M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z'));
	exports.ContactsFill = getIcon('contacts', fill, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z'));
	exports.ControlFill = getIcon('control', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z'));
	exports.ContainerFill = getIcon('container', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z'));
	exports.CopyFill = getIcon('copy', fill, getNode(newViewBox, 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z'));
	exports.CopyrightCircleFill = getIcon('copyright-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z'));
	exports.CreditCardFill = getIcon('credit-card', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z'));
	exports.CrownFill = getIcon('crown', fill, getNode(newViewBox, 'M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z'));
	exports.CustomerServiceFill = getIcon('customer-service', fill, getNode(newViewBox, 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z'));
	exports.DashboardFill = getIcon('dashboard', fill, getNode(newViewBox, 'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 0 1-11.3 0L261.7 352a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z'));
	exports.DeleteFill = getIcon('delete', fill, getNode(newViewBox, 'M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z'));
	exports.DiffFill = getIcon('diff', fill, getNode(newViewBox, 'M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z'));
	exports.DingtalkCircleFill = getIcon('dingtalk-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z'));
	exports.DatabaseFill = getIcon('database', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'));
	exports.DingtalkSquareFill = getIcon('dingtalk-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z'));
	exports.DislikeFill = getIcon('dislike', fill, getNode(newViewBox, 'M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z'));
	exports.DollarCircleFill = getIcon('dollar-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z'));
	exports.DownCircleFill = getIcon('down-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z'));
	exports.DownSquareFill = getIcon('down-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z'));
	exports.DribbbleCircleFill = getIcon('dribbble-circle', fill, getNode(newViewBox, 'M675.1 328.3a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z'));
	exports.DribbbleSquareFill = getIcon('dribbble-square', fill, getNode(newViewBox, 'M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z'));
	exports.DropboxCircleFill = getIcon('dropbox-circle', fill, getNode(newViewBox, 'M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z'));
	exports.DropboxSquareFill = getIcon('dropbox-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z'));
	exports.EnvironmentFill = getIcon('environment', fill, getNode(newViewBox, 'M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 0 0 400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 0 0 512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'));
	exports.EditFill = getIcon('edit', fill, getNode(newViewBox, 'M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z'));
	exports.ExclamationCircleFill = getIcon('exclamation-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
	exports.EuroCircleFill = getIcon('euro-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z'));
	exports.ExperimentFill = getIcon('experiment', fill, getNode(newViewBox, 'M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0 0 94.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 0 1 164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0 0 36.6-82.5z'));
	exports.EyeInvisibleFill = getIcon('eye-invisible', fill, getNode(newViewBox, 'M508 624a112 112 0 0 0 112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 0 0-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 0 0 0 11.31L155.25 889a8 8 0 0 0 11.31 0l712.16-712.12a8 8 0 0 0 0-11.32zM332 512a176 176 0 0 1 258.88-155.28l-48.62 48.62a112.08 112.08 0 0 0-140.92 140.92l-48.62 48.62A175.09 175.09 0 0 1 332 512z', 'M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 0 1 445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z'));
	exports.EyeFill = getIcon('eye', fill, getNode(newViewBox, 'M396 512a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'));
	exports.FacebookFill = getIcon('facebook', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z'));
	exports.FastBackwardFill = getIcon('fast-backward', fill, getNode(normalViewBox, 'M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
	exports.FastForwardFill = getIcon('fast-forward', fill, getNode(normalViewBox, 'M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
	exports.FileAddFill = getIcon('file-add', fill, getNode(newViewBox, 'M480 580H372a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h108v108a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V644h108a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H544V472a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z'));
	exports.FileExcelFill = getIcon('file-excel', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 0 0-10.27-5.79h-38.44a12 12 0 0 0-6.4 1.85 12 12 0 0 0-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 0 0-1.84 6.39 12 12 0 0 0 12 12h34.46a12 12 0 0 0 10.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0 0 10.23 5.72h37.48a12 12 0 0 0 6.48-1.9 12 12 0 0 0 3.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 0 0 1.9-6.5 12 12 0 0 0-12-12h-35.7a12 12 0 0 0-10.29 5.84z'));
	exports.FileExclamationFill = getIcon('file-exclamation', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 1 0 0-80 40 40 0 0 0 0 80zm32-152V448a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v184a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8z'));
	exports.FileImageFill = getIcon('file-image', fill, getNode(newViewBox, 'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8 8 0 0 1 12.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z'));
	exports.FileMarkdownFill = getIcon('file-markdown', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0 0 14.62 9.5h24.06a16 16 0 0 0 14.63-9.51l59.1-133.35V758a16 16 0 0 0 16.01 16H641a16 16 0 0 0 16-16V486a16 16 0 0 0-16-16h-34.75a16 16 0 0 0-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 0 0-14.67-9.61H383a16 16 0 0 0-16 16v272a16 16 0 0 0 16 16h27.13a16 16 0 0 0 16-16V600.93z'));
	exports.FilePdfFill = getIcon('file-pdf', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 0 1 5.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 0 1-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 0 1-1.12-.15 2.07 2.07 0 0 1-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 0 1-1.36 6.31 6.7 6.7 0 0 1-2.17 1.28z'));
	exports.FilePptFill = getIcon('file-ppt', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 0 0-12 12v276a12 12 0 0 0 12 12h32.53a12 12 0 0 0 12-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z'));
	exports.FileTextFill = getIcon('file-text', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320zm0 136a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h184a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z'));
	exports.FileWordFill = getIcon('file-word', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0 0 11.6 8.9h31.77a12 12 0 0 0 11.6-8.88l74.37-276a12 12 0 0 0 .4-3.12 12 12 0 0 0-12-12h-35.57a12 12 0 0 0-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 0 0 528.1 472h-32.2a12 12 0 0 0-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 0 0-11.68-9.29h-35.39a12 12 0 0 0-3.11.41 12 12 0 0 0-8.47 14.7l74.17 276A12 12 0 0 0 415.6 772h31.99a12 12 0 0 0 11.59-8.9l52.81-197z'));
	exports.FileUnknownFill = getIcon('file-unknown', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 1 0 0-64 32 32 0 0 0 0 64z'));
	exports.FileZipFill = getIcon('file-zip', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z'));
	exports.FileFill = getIcon('file', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z'));
	exports.FilterFill = getIcon('filter', fill, getNode(newViewBox, 'M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z'));
	exports.FireFill = getIcon('fire', fill, getNode(newViewBox, 'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9z'));
	exports.FlagFill = getIcon('flag', fill, getNode(newViewBox, 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z'));
	exports.FolderAddFill = getIcon('folder-add', fill, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z'));
	exports.FolderFill = getIcon('folder', fill, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z'));
	exports.FolderOpenFill = getIcon('folder-open', fill, getNode(newViewBox, 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z'));
	exports.ForwardFill = getIcon('forward', fill, getNode(normalViewBox, 'M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z'));
	exports.FrownFill = getIcon('frown', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
	exports.FundFill = getIcon('fund', fill, getNode(newViewBox, 'M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 0 1-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 0 1-11.3 0l-36.8-36.8a8.03 8.03 0 0 1 0-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z'));
	exports.FunnelPlotFill = getIcon('funnel-plot', fill, getNode(newViewBox, 'M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z'));
	exports.GiftFill = getIcon('gift', fill, getNode(newViewBox, 'M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z'));
	exports.GithubFill = getIcon('github', fill, getNode(newViewBox, 'M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z'));
	exports.GitlabFill = getIcon('gitlab', fill, getNode(newViewBox, 'M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z'));
	exports.GoldenFill = getIcon('golden', fill, getNode(newViewBox, 'M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z'));
	exports.GoogleCircleFill = getIcon('google-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z'));
	exports.GooglePlusCircleFill = getIcon('google-plus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z'));
	exports.GooglePlusSquareFill = getIcon('google-plus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z'));
	exports.GoogleSquareFill = getIcon('google-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 0 1 272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z'));
	exports.HddFill = getIcon('hdd', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z'));
	exports.HeartFill = getIcon('heart', fill, getNode(newViewBox, 'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z'));
	exports.HighlightFill = getIcon('highlight', fill, getNode(newViewBox, 'M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z'));
	exports.HomeFill = getIcon('home', fill, getNode(newViewBox, 'M946.5 505L534.6 93.4a31.93 31.93 0 0 0-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z'));
	exports.HourglassFill = getIcon('hourglass', fill, getNode(newViewBox, 'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z'));
	exports.Html5Fill = getIcon('html5', fill, getNode(newViewBox, 'M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z'));
	exports.IdcardFill = getIcon('idcard', fill, getNode(newViewBox, 'M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z'));
	exports.IeCircleFill = getIcon('ie-circle', fill, getNode(newViewBox, 'M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z'));
	exports.IeSquareFill = getIcon('ie-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z'));
	exports.InfoCircleFill = getIcon('info-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
	exports.InstagramFill = getIcon('instagram', fill, getNode(newViewBox, 'M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 0 1-47.9 47.9z'));
	exports.InsuranceFill = getIcon('insurance', fill, getNode(newViewBox, 'M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 0 1-8.9-1.4L430 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z'));
	exports.InteractionFill = getIcon('interaction', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z'));
	exports.InterationFill = getIcon('interation', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z'));
	exports.LayoutFill = getIcon('layout', fill, getNode(newViewBox, 'M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z'));
	exports.LeftCircleFill = getIcon('left-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178a8 8 0 0 1 12.7 6.5v46.8z'));
	exports.LeftSquareFill = getIcon('left-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z'));
	exports.LikeFill = getIcon('like', fill, getNode(newViewBox, 'M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z'));
	exports.LockFill = getIcon('lock', fill, getNode(newViewBox, 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z'));
	exports.LinkedinFill = getIcon('linkedin', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1 1 68.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z'));
	exports.MailFill = getIcon('mail', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 0 1 194 256h648.8a7.2 7.2 0 0 1 4.4 12.9z'));
	exports.MedicineBoxFill = getIcon('medicine-box', fill, getNode(newViewBox, 'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z'));
	exports.MediumCircleFill = getIcon('medium-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z'));
	exports.MediumSquareFill = getIcon('medium-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z'));
	exports.MehFill = getIcon('meh', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
	exports.MessageFill = getIcon('message', fill, getNode(newViewBox, 'M924.3 338.4a447.57 447.57 0 0 0-96.1-143.3 443.09 443.09 0 0 0-143-96.3A443.91 443.91 0 0 0 512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 0 0-141.7 96.5 445 445 0 0 0-95 142.8A449.89 449.89 0 0 0 65 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 0 0 199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 0 0 827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z'));
	exports.MinusCircleFill = getIcon('minus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'));
	exports.MinusSquareFill = getIcon('minus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'));
	exports.MobileFill = getIcon('mobile', fill, getNode(newViewBox, 'M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'));
	exports.MoneyCollectFill = getIcon('money-collect', fill, getNode(newViewBox, 'M911.5 699.7a8 8 0 0 0-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z'));
	exports.PauseCircleFill = getIcon('pause-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z'));
	exports.PayCircleFill = getIcon('pay-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 0 1 7-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 0 1 7.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z'));
	exports.NotificationFill = getIcon('notification', fill, getNode(newViewBox, 'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z'));
	exports.PhoneFill = getIcon('phone', fill, getNode(newViewBox, 'M885.6 230.2L779.1 123.8a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 0 0-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 0 1 553.1 553 395.34 395.34 0 0 1 437 633.8L353.2 550a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 0 0-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z'));
	exports.PictureFill = getIcon('picture', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 0 1-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z'));
	exports.PieChartFill = getIcon('pie-chart', fill, getNode(newViewBox, 'M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 0 0-282.5 117 397.47 397.47 0 0 0-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 0 0 155.6 31.5 398.57 398.57 0 0 0 282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0 0 31.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 0 0 588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z'));
	exports.PlayCircleFill = getIcon('play-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 0 1-12.7-6.5V353.7a8 8 0 0 1 12.7-6.5L656.1 506a7.9 7.9 0 0 1 0 12.9z'));
	exports.PlaySquareFill = getIcon('play-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6z'));
	exports.PlusCircleFill = getIcon('plus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'));
	exports.PlusSquareFill = getIcon('plus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'));
	exports.PoundCircleFill = getIcon('pound-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z'));
	exports.PrinterFill = getIcon('printer', fill, getNode(newViewBox, 'M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z'));
	exports.ProfileFill = getIcon('profile', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z'));
	exports.ProjectFill = getIcon('project', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z'));
	exports.PushpinFill = getIcon('pushpin', fill, getNode(newViewBox, 'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z'));
	exports.PropertySafetyFill = getIcon('property-safety', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z'));
	exports.QqCircleFill = getIcon('qq-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z'));
	exports.QqSquareFill = getIcon('qq-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z'));
	exports.QuestionCircleFill = getIcon('question-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'));
	exports.ReadFill = getIcon('read', fill, getNode(newViewBox, 'M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z'));
	exports.ReconciliationFill = getIcon('reconciliation', fill, getNode(newViewBox, 'M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z'));
	exports.RedEnvelopeFill = getIcon('red-envelope', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 0 1 7.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z'));
	exports.RedditCircleFill = getIcon('reddit-circle', fill, getNode(newViewBox, 'M584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm72 108a36 36 0 1 0 72 0 36 36 0 1 0-72 0z'));
	exports.RedditSquareFill = getIcon('reddit-square', fill, getNode(newViewBox, 'M296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM368 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0z'));
	exports.RestFill = getIcon('rest', fill, getNode(newViewBox, 'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 1 0 160 0 80 80 0 1 0-160 0z'));
	exports.RightCircleFill = getIcon('right-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z'));
	exports.RocketFill = getIcon('rocket', fill, getNode(newViewBox, 'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 0 1 0 96 48.01 48.01 0 0 1 0-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z'));
	exports.RightSquareFill = getIcon('right-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z'));
	exports.SafetyCertificateFill = getIcon('safety-certificate', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z'));
	exports.SaveFill = getIcon('save', fill, getNode(newViewBox, 'M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z'));
	exports.ScheduleFill = getIcon('schedule', fill, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z'));
	exports.SecurityScanFill = getIcon('security-scan', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 1 0 113.27-113.28 80.1 80.1 0 1 0-113.27 113.28z'));
	exports.SettingFill = getIcon('setting', fill, getNode(newViewBox, 'M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 0 0-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a442.5 442.5 0 0 0-79.6-137.7l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.3a353.44 353.44 0 0 0-98.9 57.3l-81.8-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a445.93 445.93 0 0 0-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0 0 25.8 25.7l2.7.5a448.27 448.27 0 0 0 158.8 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z'));
	exports.ShopFill = getIcon('shop', fill, getNode(newViewBox, 'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z'));
	exports.ShoppingFill = getIcon('shopping', fill, getNode(newViewBox, 'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z'));
	exports.SketchCircleFill = getIcon('sketch-circle', fill, getNode(newViewBox, 'M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z'));
	exports.SketchSquareFill = getIcon('sketch-square', fill, getNode(newViewBox, 'M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z'));
	exports.SkinFill = getIcon('skin', fill, getNode(newViewBox, 'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44z'));
	exports.SlackCircleFill = getIcon('slack-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
	exports.SlackSquareFill = getIcon('slack-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
	exports.SkypeFill = getIcon('skype', fill, getNode(newViewBox, 'M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z'));
	exports.SlidersFill = getIcon('sliders', fill, getNode(newViewBox, 'M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z'));
	exports.SmileFill = getIcon('smile', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
	exports.SnippetsFill = getIcon('snippets', fill, getNode(newViewBox, 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'));
	exports.SoundFill = getIcon('sound', fill, getNode(newViewBox, 'M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z'));
	exports.StarFill = getIcon('star', fill, getNode(newViewBox, 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z'));
	exports.StepBackwardFill = getIcon('step-backward', fill, getNode(normalViewBox, 'M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8'));
	exports.StepForwardFill = getIcon('step-forward', fill, getNode(normalViewBox, 'M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8'));
	exports.StopFill = getIcon('stop', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z'));
	exports.SwitcherFill = getIcon('switcher', fill, getNode(newViewBox, 'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z'));
	exports.TabletFill = getIcon('tablet', fill, getNode(newViewBox, 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'));
	exports.TagFill = getIcon('tag', fill, getNode(newViewBox, 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z'));
	exports.TagsFill = getIcon('tags', fill, getNode(newViewBox, 'M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z'));
	exports.TaobaoCircleFill = getIcon('taobao-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
	exports.TaobaoSquareFill = getIcon('taobao-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
	exports.ToolFill = getIcon('tool', fill, getNode(newViewBox, 'M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 0 0 419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z'));
	exports.ThunderboltFill = getIcon('thunderbolt', fill, getNode(newViewBox, 'M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z'));
	exports.TrademarkCircleFill = getIcon('trademark-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z'));
	exports.TwitterCircleFill = getIcon('twitter-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z'));
	exports.TrophyFill = getIcon('trophy', fill, getNode(newViewBox, 'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z'));
	exports.TwitterSquareFill = getIcon('twitter-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z'));
	exports.UnlockFill = getIcon('unlock', fill, getNode(newViewBox, 'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0z'));
	exports.UpCircleFill = getIcon('up-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'));
	exports.UpSquareFill = getIcon('up-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'));
	exports.UsbFill = getIcon('usb', fill, getNode(newViewBox, 'M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
	exports.WalletFill = getIcon('wallet', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
	exports.VideoCameraFill = getIcon('video-camera', fill, getNode(newViewBox, 'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z'));
	exports.WarningFill = getIcon('warning', fill, getNode(newViewBox, 'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
	exports.WeiboCircleFill = getIcon('weibo-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
	exports.WechatFill = getIcon('wechat', fill, getNode(newViewBox, 'M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z'));
	exports.WindowsFill = getIcon('windows', fill, getNode(newViewBox, 'M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z'));
	exports.YahooFill = getIcon('yahoo', fill, getNode(newViewBox, 'M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z'));
	exports.WeiboSquareFill = getIcon('weibo-square', fill, getNode(newViewBox, 'M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
	exports.YuqueFill = getIcon('yuque', fill, getNode(newViewBox, 'M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z'));
	exports.YoutubeFill = getIcon('youtube', fill, getNode(newViewBox, 'M941.3 296.1a112.3 112.3 0 0 0-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0 0 82.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z'));
	exports.ZhihuSquareFill = getIcon('zhihu-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z'));
	exports.ZhihuCircleFill = getIcon('zhihu-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z'));
	exports.AccountBookOutline = getIcon('account-book', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z'));
	exports.AlertOutline = getIcon('alert', outline, getNode(newViewBox, 'M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z'));
	exports.AlipayCircleOutline = getIcon('alipay-circle', outline, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z'));
	exports.AliwangwangOutline = getIcon('aliwangwang', outline, getNode(newViewBox, 'M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 0 1-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 0 1-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 0 1 217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z'));
	exports.AndroidOutline = getIcon('android', outline, getNode(newViewBox, 'M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z'));
	exports.ApiOutline = getIcon('api', outline, getNode(newViewBox, 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 0 1-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z'));
	exports.AppstoreOutline = getIcon('appstore', outline, getNode(newViewBox, 'M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z'));
	exports.AudioOutline = getIcon('audio', outline, getNode(newViewBox, 'M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z'));
	exports.AppleOutline = getIcon('apple', outline, getNode(newViewBox, 'M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z'));
	exports.BackwardOutline = getIcon('backward', outline, getNode(normalViewBox, 'M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z'));
	exports.BankOutline = getIcon('bank', outline, getNode(newViewBox, 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z'));
	exports.BellOutline = getIcon('bell', outline, getNode(newViewBox, 'M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z'));
	exports.BehanceSquareOutline = getIcon('behance-square', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z'));
	exports.BookOutline = getIcon('book', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z'));
	exports.BoxPlotOutline = getIcon('box-plot', outline, getNode(newViewBox, 'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z'));
	exports.BulbOutline = getIcon('bulb', outline, getNode(newViewBox, 'M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z'));
	exports.BugOutline = getIcon('bug', outline, getNode(newViewBox, 'M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 0 0-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 0 0-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z', 'M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 0 1-63 63H232a63 63 0 0 1-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0 0 22.7 49c24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2a281.38 281.38 0 0 0 123.2-149.5A120 120 0 0 1 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3A202.75 202.75 0 0 1 308 680V412h408v268z'));
	exports.CalculatorOutline = getIcon('calculator', outline, getNode(newViewBox, 'M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z'));
	exports.BuildOutline = getIcon('build', outline, getNode(newViewBox, 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z'));
	exports.CalendarOutline = getIcon('calendar', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z'));
	exports.CameraOutline = getIcon('camera', outline, getNode(newViewBox, 'M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z'));
	exports.CarOutline = getIcon('car', outline, getNode(newViewBox, 'M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm239-167.6L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
	exports.CaretDownOutline = getIcon('caret-down', outline, getNode(normalViewBox, 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'));
	exports.CaretLeftOutline = getIcon('caret-left', outline, getNode(normalViewBox, 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'));
	exports.CaretRightOutline = getIcon('caret-right', outline, getNode(normalViewBox, 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'));
	exports.CarryOutOutline = getIcon('carry-out', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z'));
	exports.CheckCircleOutline = getIcon('check-circle', outline, getNode(newViewBox, 'M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
	exports.CaretUpOutline = getIcon('caret-up', outline, getNode(normalViewBox, 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'));
	exports.CheckSquareOutline = getIcon('check-square', outline, getNode(newViewBox, 'M433.1 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.ChromeOutline = getIcon('chrome', outline, getNode(newViewBox, 'M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z'));
	exports.ClockCircleOutline = getIcon('clock-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z'));
	exports.CloseCircleOutline = getIcon('close-circle', outline, getNode(newViewBox, 'M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z', 'M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
	exports.CloudOutline = getIcon('cloud', outline, getNode(newViewBox, 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z'));
	exports.CloseSquareOutline = getIcon('close-square', outline, getNode(newViewBox, 'M354 671h58.9c4.7 0 9.2-2.1 12.3-5.7L512 561.8l86.8 103.5c3 3.6 7.5 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.4-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.7 0-9.2 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3-3.6-7.5-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.CodeOutline = getIcon('code', outline, getNode(newViewBox, 'M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.CodepenCircleOutline = getIcon('codepen-circle', outline, getNode(newViewBox, 'M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z'));
	exports.CompassOutline = getIcon('compass', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 0 0-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 0 0-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z'));
	exports.ContactsOutline = getIcon('contacts', outline, getNode(newViewBox, 'M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'));
	exports.ContainerOutline = getIcon('container', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
	exports.ControlOutline = getIcon('control', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z'));
	exports.CopyOutline = getIcon('copy', outline, getNode(newViewBox, 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z'));
	exports.CreditCardOutline = getIcon('credit-card', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z'));
	exports.CrownOutline = getIcon('crown', outline, getNode(newViewBox, 'M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z'));
	exports.CustomerServiceOutline = getIcon('customer-service', outline, getNode(newViewBox, 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z'));
	exports.DashboardOutline = getIcon('dashboard', outline, getNode(newViewBox, 'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z'));
	exports.DeleteOutline = getIcon('delete', outline, getNode(newViewBox, 'M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z'));
	exports.DiffOutline = getIcon('diff', outline, getNode(newViewBox, 'M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z'));
	exports.DatabaseOutline = getIcon('database', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
	exports.DislikeOutline = getIcon('dislike', outline, getNode(newViewBox, 'M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z'));
	exports.DownCircleOutline = getIcon('down-circle', outline, getNode(newViewBox, 'M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
	exports.DownSquareOutline = getIcon('down-square', outline, getNode(newViewBox, 'M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.DribbbleSquareOutline = getIcon('dribbble-square', outline, getNode(newViewBox, 'M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z'));
	exports.EnvironmentOutline = getIcon('environment', outline, getNode(newViewBox, 'M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z'));
	exports.EditOutline = getIcon('edit', outline, getNode(newViewBox, 'M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z'));
	exports.ExclamationCircleOutline = getIcon('exclamation-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z'));
	exports.ExperimentOutline = getIcon('experiment', outline, getNode(newViewBox, 'M512 472a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z'));
	exports.EyeInvisibleOutline = getIcon('eye-invisible', outline, getNode(newViewBox, 'M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z', 'M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z'));
	exports.EyeOutline = getIcon('eye', outline, getNode(newViewBox, 'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'));
	exports.FacebookOutline = getIcon('facebook', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z'));
	exports.FastBackwardOutline = getIcon('fast-backward', outline, getNode(normalViewBox, 'M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
	exports.FastForwardOutline = getIcon('fast-forward', outline, getNode(normalViewBox, 'M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
	exports.FileAddOutline = getIcon('file-add', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z'));
	exports.FileExcelOutline = getIcon('file-excel', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z'));
	exports.FileExclamationOutline = getIcon('file-exclamation', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM472 744a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z'));
	exports.FileImageOutline = getIcon('file-image', outline, getNode(newViewBox, 'M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
	exports.FileMarkdownOutline = getIcon('file-markdown', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z'));
	exports.FilePptOutline = getIcon('file-ppt', outline, getNode(newViewBox, 'M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
	exports.FileTextOutline = getIcon('file-text', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z'));
	exports.FilePdfOutline = getIcon('file-pdf', outline, getNode(newViewBox, 'M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
	exports.FileZipOutline = getIcon('file-zip', outline, getNode(newViewBox, 'M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z'));
	exports.FileOutline = getIcon('file', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
	exports.FilterOutline = getIcon('filter', outline, getNode(newViewBox, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z'));
	exports.FileWordOutline = getIcon('file-word', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z'));
	exports.FireOutline = getIcon('fire', outline, getNode(newViewBox, 'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z'));
	exports.FileUnknownOutline = getIcon('file-unknown', outline, getNode(newViewBox, 'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1 0 64 0 32 32 0 1 0-64 0z'));
	exports.FlagOutline = getIcon('flag', outline, getNode(newViewBox, 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z'));
	exports.FolderAddOutline = getIcon('folder-add', outline, getNode(newViewBox, 'M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'));
	exports.FolderOutline = getIcon('folder', outline, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'));
	exports.FolderOpenOutline = getIcon('folder-open', outline, getNode(newViewBox, 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z'));
	exports.ForwardOutline = getIcon('forward', outline, getNode(normalViewBox, 'M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z'));
	exports.FrownOutline = getIcon('frown', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533z'));
	exports.FundOutline = getIcon('fund', outline, getNode(newViewBox, 'M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L531 565 416.6 450.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z'));
	exports.FunnelPlotOutline = getIcon('funnel-plot', outline, getNode(newViewBox, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z'));
	exports.GiftOutline = getIcon('gift', outline, getNode(newViewBox, 'M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z'));
	exports.GithubOutline = getIcon('github', outline, getNode(newViewBox, 'M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z'));
	exports.GitlabOutline = getIcon('gitlab', outline, getNode(newViewBox, 'M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z'));
	exports.HeartOutline = getIcon('heart', outline, getNode(newViewBox, 'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z'));
	exports.HddOutline = getIcon('hdd', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
	exports.HighlightOutline = getIcon('highlight', outline, getNode(newViewBox, 'M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z'));
	exports.HomeOutline = getIcon('home', outline, getNode(newViewBox, 'M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z'));
	exports.HourglassOutline = getIcon('hourglass', outline, getNode(newViewBox, 'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z'));
	exports.Html5Outline = getIcon('html5', outline, getNode(newViewBox, 'M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z'));
	exports.IdcardOutline = getIcon('idcard', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z'));
	exports.InfoCircleOutline = getIcon('info-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z'));
	exports.InstagramOutline = getIcon('instagram', outline, getNode(newViewBox, 'M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 0 0-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z'));
	exports.InsuranceOutline = getIcon('insurance', outline, getNode(newViewBox, 'M441.6 306.8L403 288.6a6.1 6.1 0 0 0-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 0 0-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0 0 33.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'));
	exports.InteractionOutline = getIcon('interaction', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'));
	exports.InterationOutline = getIcon('interation', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'));
	exports.LayoutOutline = getIcon('layout', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z'));
	exports.LeftCircleOutline = getIcon('left-circle', outline, getNode(newViewBox, 'M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
	exports.LeftSquareOutline = getIcon('left-square', outline, getNode(newViewBox, 'M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 0 0 0 13z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.LikeOutline = getIcon('like', outline, getNode(newViewBox, 'M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0 1 42.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z'));
	exports.LinkedinOutline = getIcon('linkedin', outline, getNode(newViewBox, 'M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 1 0-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z'));
	exports.LockOutline = getIcon('lock', outline, getNode(newViewBox, 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'));
	exports.MedicineBoxOutline = getIcon('medicine-box', outline, getNode(newViewBox, 'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
	exports.MehOutline = getIcon('meh', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
	exports.MailOutline = getIcon('mail', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z'));
	exports.MessageOutline = getIcon('message', outline, getNode(newViewBox, 'M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z'));
	exports.MinusCircleOutline = getIcon('minus-circle', outline, getNode(newViewBox, 'M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
	exports.MinusSquareOutline = getIcon('minus-square', outline, getNode(newViewBox, 'M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.MobileOutline = getIcon('mobile', outline, getNode(newViewBox, 'M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
	exports.MoneyCollectOutline = getIcon('money-collect', outline, getNode(newViewBox, 'M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z'));
	exports.PauseCircleOutline = getIcon('pause-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z'));
	exports.PayCircleOutline = getIcon('pay-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 0 0-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z'));
	exports.NotificationOutline = getIcon('notification', outline, getNode(newViewBox, 'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z'));
	exports.PhoneOutline = getIcon('phone', outline, getNode(newViewBox, 'M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z'));
	exports.PictureOutline = getIcon('picture', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z'));
	exports.PieChartOutline = getIcon('pie-chart', outline, getNode(newViewBox, 'M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z'));
	exports.PlaySquareOutline = getIcon('play-square', outline, getNode(newViewBox, 'M442.3 677.6l199.4-156.7a11.3 11.3 0 0 0 0-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.PlayCircleOutline = getIcon('play-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M719.4 499.1l-296.1-215A15.9 15.9 0 0 0 398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 0 0 0-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z'));
	exports.PlusCircleOutline = getIcon('plus-circle', outline, getNode(newViewBox, 'M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
	exports.PrinterOutline = getIcon('printer', outline, getNode(newViewBox, 'M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z'));
	exports.PlusSquareOutline = getIcon('plus-square', outline, getNode(newViewBox, 'M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.ProfileOutline = getIcon('profile', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
	exports.ProjectOutline = getIcon('project', outline, getNode(newViewBox, 'M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.PushpinOutline = getIcon('pushpin', outline, getNode(newViewBox, 'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z'));
	exports.PropertySafetyOutline = getIcon('property-safety', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 0 0-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 0 0-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z'));
	exports.QuestionCircleOutline = getIcon('question-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
	exports.ReadOutline = getIcon('read', outline, getNode(newViewBox, 'M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z'));
	exports.ReconciliationOutline = getIcon('reconciliation', outline, getNode(newViewBox, 'M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
	exports.RedEnvelopeOutline = getIcon('red-envelope', outline, getNode(newViewBox, 'M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z'));
	exports.RestOutline = getIcon('rest', outline, getNode(newViewBox, 'M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z', 'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z'));
	exports.RightCircleOutline = getIcon('right-circle', outline, getNode(newViewBox, 'M666.7 505.5l-246-178A8 8 0 0 0 408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
	exports.RocketOutline = getIcon('rocket', outline, getNode(newViewBox, 'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0 1 62.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'));
	exports.RightSquareOutline = getIcon('right-square', outline, getNode(newViewBox, 'M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.SafetyCertificateOutline = getIcon('safety-certificate', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z'));
	exports.ScheduleOutline = getIcon('schedule', outline, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z'));
	exports.SaveOutline = getIcon('save', outline, getNode(newViewBox, 'M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'));
	exports.SecurityScanOutline = getIcon('security-scan', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z'));
	exports.SettingOutline = getIcon('setting', outline, getNode(newViewBox, 'M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5a449.4 449.4 0 0 0 159 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2z'));
	exports.ShoppingOutline = getIcon('shopping', outline, getNode(newViewBox, 'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z'));
	exports.SkinOutline = getIcon('skin', outline, getNode(newViewBox, 'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z'));
	exports.SkypeOutline = getIcon('skype', outline, getNode(newViewBox, 'M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 0 1-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 0 1-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0 1 71.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z'));
	exports.SlackSquareOutline = getIcon('slack-square', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
	exports.SlidersOutline = getIcon('sliders', outline, getNode(newViewBox, 'M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74z'));
	exports.SmileOutline = getIcon('smile', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4z'));
	exports.SnippetsOutline = getIcon('snippets', outline, getNode(newViewBox, 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'));
	exports.SoundOutline = getIcon('sound', outline, getNode(newViewBox, 'M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344z'));
	exports.StarOutline = getIcon('star', outline, getNode(newViewBox, 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z'));
	exports.StepBackwardOutline = getIcon('step-backward', outline, getNode(normalViewBox, 'M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8'));
	exports.StepForwardOutline = getIcon('step-forward', outline, getNode(normalViewBox, 'M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8'));
	exports.StopOutline = getIcon('stop', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z'));
	exports.SwitcherOutline = getIcon('switcher', outline, getNode(newViewBox, 'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z'));
	exports.TagOutline = getIcon('tag', outline, getNode(newViewBox, 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'));
	exports.TabletOutline = getIcon('tablet', outline, getNode(newViewBox, 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
	exports.ShopOutline = getIcon('shop', outline, getNode(newViewBox, 'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z'));
	exports.TagsOutline = getIcon('tags', outline, getNode(newViewBox, 'M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1 0 67.88-67.89 48 48 0 1 0-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z'));
	exports.TaobaoCircleOutline = getIcon('taobao-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
	exports.ToolOutline = getIcon('tool', outline, getNode(newViewBox, 'M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z'));
	exports.ThunderboltOutline = getIcon('thunderbolt', outline, getNode(newViewBox, 'M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z'));
	exports.TrophyOutline = getIcon('trophy', outline, getNode(newViewBox, 'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM184 352V232h64v207.6a91.99 91.99 0 0 1-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z'));
	exports.UnlockOutline = getIcon('unlock', outline, getNode(newViewBox, 'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'));
	exports.UpCircleOutline = getIcon('up-circle', outline, getNode(newViewBox, 'M518.5 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
	exports.UpSquareOutline = getIcon('up-square', outline, getNode(newViewBox, 'M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246A7.96 7.96 0 0 0 334 624z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.UsbOutline = getIcon('usb', outline, getNode(newViewBox, 'M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
	exports.VideoCameraOutline = getIcon('video-camera', outline, getNode(newViewBox, 'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
	exports.WalletOutline = getIcon('wallet', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
	exports.WarningOutline = getIcon('warning', outline, getNode(newViewBox, 'M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z'));
	exports.WechatOutline = getIcon('wechat', outline, getNode(newViewBox, 'M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z'));
	exports.WeiboCircleOutline = getIcon('weibo-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
	exports.WindowsOutline = getIcon('windows', outline, getNode(newViewBox, 'M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z'));
	exports.YahooOutline = getIcon('yahoo', outline, getNode(newViewBox, 'M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z'));
	exports.WeiboSquareOutline = getIcon('weibo-square', outline, getNode(newViewBox, 'M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
	exports.YuqueOutline = getIcon('yuque', outline, getNode(newViewBox, 'M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z'));
	exports.YoutubeOutline = getIcon('youtube', outline, getNode(newViewBox, 'M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 0 0-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0 0 82.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z'));
	exports.AlibabaOutline = getIcon('alibaba', outline, getNode(newViewBox, 'M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z'));
	exports.AlignCenterOutline = getIcon('align-center', outline, getNode(newViewBox, 'M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.AlignLeftOutline = getIcon('align-left', outline, getNode(newViewBox, 'M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.AlignRightOutline = getIcon('align-right', outline, getNode(newViewBox, 'M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.AlipayOutline = getIcon('alipay', outline, getNode(newViewBox, 'M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 0 1-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z'));
	exports.AliyunOutline = getIcon('aliyun', outline, getNode(newViewBox, 'M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0 1 32.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 0 1-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 0 1-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z'));
	exports.AmazonOutline = getIcon('amazon', outline, getNode(newViewBox, 'M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 0 0-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z'));
	exports.AntCloudOutline = getIcon('ant-cloud', outline, getNode(newViewBox, 'M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0 1 22.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 0 1-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-65.7 61.3a24 24 0 1 0 48 0 24 24 0 1 0-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z'));
	exports.ApartmentOutline = getIcon('apartment', outline, getNode(newViewBox, 'M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z'));
	exports.AntDesignOutline = getIcon('ant-design', outline, getNode(newViewBox, 'M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 0 0 0 76.4L474.6 944a54.14 54.14 0 0 0 76.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 0 0-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 1 0 212.6 0 106.3 106.2 0 1 0-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 0 0 0 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 0 0 0 68.6 48.7 48.7 0 0 0 68.7 0l121.8-121.7a53.93 53.93 0 0 0-.1-76.4z'));
	exports.AreaChartOutline = getIcon('area-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 0 0-11.3 0l-189 189.6a7.87 7.87 0 0 0-2.3 5.6V720c0 4.4 3.6 8 8 8z'));
	exports.ArrowLeftOutline = getIcon('arrow-left', outline, getNode(newViewBox, 'M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
	exports.ArrowDownOutline = getIcon('arrow-down', outline, getNode(newViewBox, 'M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0 0 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z'));
	exports.ArrowUpOutline = getIcon('arrow-up', outline, getNode(newViewBox, 'M868 545.5L536.1 163a31.96 31.96 0 0 0-48.3 0L156 545.5a7.97 7.97 0 0 0 6 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z'));
	exports.ArrowsAltOutline = getIcon('arrows-alt', outline, getNode(newViewBox, 'M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z'));
	exports.ArrowRightOutline = getIcon('arrow-right', outline, getNode(newViewBox, 'M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z'));
	exports.AuditOutline = getIcon('audit', outline, getNode(newViewBox, 'M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z'));
	exports.BarChartOutline = getIcon('bar-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z'));
	exports.BarcodeOutline = getIcon('barcode', outline, getNode(newViewBox, 'M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
	exports.BarsOutline = getIcon('bars', outline, getNode(normalViewBox, 'M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
	exports.BgColorsOutline = getIcon('bg-colors', outline, getNode(newViewBox, 'M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 0 0-12.8 0l-48 48a9.11 9.11 0 0 0 0 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z'));
	exports.BehanceOutline = getIcon('behance', outline, getNode(newViewBox, 'M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z'));
	exports.BlockOutline = getIcon('block', outline, getNode(newViewBox, 'M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z'));
	exports.BoldOutline = getIcon('bold', outline, getNode(newViewBox, 'M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z'));
	exports.BorderBottomOutline = getIcon('border-bottom', outline, getNode(newViewBox, 'M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
	exports.BorderLeftOutline = getIcon('border-left', outline, getNode(newViewBox, 'M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.BorderOuterOutline = getIcon('border-outer', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
	exports.BorderInnerOutline = getIcon('border-inner', outline, getNode(newViewBox, 'M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.BorderRightOutline = getIcon('border-right', outline, getNode(newViewBox, 'M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.BorderHorizontalOutline = getIcon('border-horizontal', outline, getNode(newViewBox, 'M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.BorderTopOutline = getIcon('border-top', outline, getNode(newViewBox, 'M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.BorderVerticleOutline = getIcon('border-verticle', outline, getNode(newViewBox, 'M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.BorderOutline = getIcon('border', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
	exports.BranchesOutline = getIcon('branches', outline, getNode(newViewBox, 'M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0 0 34.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm408-491a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
	exports.CheckOutline = getIcon('check', outline, getNode(newViewBox, 'M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z'));
	exports.CiOutline = getIcon('ci', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z'));
	exports.CloseOutline = getIcon('close', outline, getNode(newViewBox, 'M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z'));
	exports.CloudDownloadOutline = getIcon('cloud-download', outline, getNode(newViewBox, 'M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z', 'M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z'));
	exports.CloudServerOutline = getIcon('cloud-server', outline, getNode(newViewBox, 'M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z', 'M424 748a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm0-178a32 32 0 1 0 64 0 32 32 0 1 0-64 0z', 'M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z'));
	exports.CloudSyncOutline = getIcon('cloud-sync', outline, getNode(newViewBox, 'M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z', 'M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 0 0 3 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 0 0-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z'));
	exports.CloudUploadOutline = getIcon('cloud-upload', outline, getNode(newViewBox, 'M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z', 'M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z'));
	exports.ClusterOutline = getIcon('cluster', outline, getNode(newViewBox, 'M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
	exports.CodepenOutline = getIcon('codepen', outline, getNode(newViewBox, 'M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 0 0-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z'));
	exports.CodeSandboxOutline = getIcon('code-sandbox', outline, getNode(newViewBox, 'M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z'));
	exports.ColumHeightOutline = getIcon('colum-height', outline, getNode(newViewBox, 'M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z'));
	exports.ColumnWidthOutline = getIcon('column-width', outline, getNode(newViewBox, 'M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 0 0-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z'));
	exports.ColumnHeightOutline = getIcon('column-height', outline, getNode(newViewBox, 'M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z'));
	exports.CoffeeOutline = getIcon('coffee', outline, getNode(normalViewBox, 'M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z'));
	exports.CopyrightOutline = getIcon('copyright', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z'));
	exports.DashOutline = getIcon('dash', outline, getNode(newViewBox, 'M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z'));
	exports.DeploymentUnitOutline = getIcon('deployment-unit', outline, getNode(newViewBox, 'M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 0 1-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0 1 65.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z'));
	exports.DesktopOutline = getIcon('desktop', outline, getNode(newViewBox, 'M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z'));
	exports.DingdingOutline = getIcon('dingding', outline, getNode(newViewBox, 'M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z'));
	exports.DisconnectOutline = getIcon('disconnect', outline, getNode(newViewBox, 'M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 0 0-11.3 0L209.4 249a8.03 8.03 0 0 0 0 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z'));
	exports.DollarOutline = getIcon('dollar', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z'));
	exports.DoubleRightOutline = getIcon('double-right', outline, getNode(newViewBox, 'M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 0 0 188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 0 0 492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z'));
	exports.DotChartOutline = getIcon('dot-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm118-224a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm158 228a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm148-314a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
	exports.DoubleLeftOutline = getIcon('double-left', outline, getNode(newViewBox, 'M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z'));
	exports.DownloadOutline = getIcon('download', outline, getNode(newViewBox, 'M505.7 661a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'));
	exports.DribbbleOutline = getIcon('dribbble', outline, getNode(newViewBox, 'M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 0 1 512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z'));
	exports.DropboxOutline = getIcon('dropbox', outline, getNode(newViewBox, 'M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z'));
	exports.EllipsisOutline = getIcon('ellipsis', outline, getNode(newViewBox, 'M176 511a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
	exports.EnterOutline = getIcon('enter', outline, getNode(newViewBox, 'M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z'));
	exports.EuroOutline = getIcon('euro', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z'));
	exports.ExceptionOutline = getIcon('exception', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.ExclamationOutline = getIcon('exclamation', outline, getNode(newViewBox, 'M448 804a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'));
	exports.ExportOutline = getIcon('export', outline, getNode(newViewBox, 'M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zm18.6-251.7L765 393.7c-5.3-4.2-13-.4-13 6.3v76H438c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'));
	exports.FallOutline = getIcon('fall', outline, getNode(newViewBox, 'M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 0 0-11.3 0l-45 45.2a8.03 8.03 0 0 0 0 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 0 0 4.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z'));
	exports.FileDoneOutline = getIcon('file-done', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 0 0-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.FileSyncOutline = getIcon('file-sync', outline, getNode(newViewBox, 'M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 0 0 3 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 0 0-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 0 0-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0 0 12.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z'));
	exports.FileProtectOutline = getIcon('file-protect', outline, getNode(newViewBox, 'M644.7 669.2a7.92 7.92 0 0 0-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 0 0-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z'));
	exports.FileSearchOutline = getIcon('file-search', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 0 0 0-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'));
	exports.FileJpgOutline = getIcon('file-jpg', outline, getNode(normalViewBox, 'M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z'));
	exports.FontColorsOutline = getIcon('font-colors', outline, getNode(newViewBox, 'M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 0 0 6-12.4L573.6 118.6a9.9 9.9 0 0 0-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z'));
	exports.FontSizeOutline = getIcon('font-size', outline, getNode(newViewBox, 'M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z'));
	exports.ForkOutline = getIcon('fork', outline, getNode(newViewBox, 'M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm336 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm192-552a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
	exports.FormOutline = getIcon('form', outline, getNode(newViewBox, 'M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z', 'M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 0 0-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z'));
	exports.FullscreenExitOutline = getIcon('fullscreen-exit', outline, getNode(newViewBox, 'M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 0 0 0 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 0 0 391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 0 0-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z'));
	exports.FullscreenOutline = getIcon('fullscreen', outline, getNode(newViewBox, 'M290 236.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0 0 13.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 0 0 0 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 0 0-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z'));
	exports.GatewayOutline = getIcon('gateway', outline, getNode(newViewBox, 'M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z'));
	exports.DownOutline = getIcon('down', outline, getNode(newViewBox, 'M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z'));
	exports.DragOutline = getIcon('drag', outline, getNode(newViewBox, 'M909.3 506.3L781.7 405.6a7.23 7.23 0 0 0-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 0 0-11.3 0L405.6 242.3a7.23 7.23 0 0 0 5.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 0 0 .1-11.4z'));
	exports.GlobalOutline = getIcon('global', outline, getNode(newViewBox, 'M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z'));
	exports.GooglePlusOutline = getIcon('google-plus', outline, getNode(newViewBox, 'M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z'));
	exports.GoogleOutline = getIcon('google', outline, getNode(newViewBox, 'M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z'));
	exports.HeatMapOutline = getIcon('heat-map', outline, getNode(newViewBox, 'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z'));
	exports.GoldOutline = getIcon('gold', outline, getNode(newViewBox, 'M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z'));
	exports.HistoryOutline = getIcon('history', outline, getNode(newViewBox, 'M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 0 0 3 14.1zm167.7 301.1l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 0 1-112.5 75.9 352.18 352.18 0 0 1-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 0 1-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 0 1 171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 0 1 112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 0 1 775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z'));
	exports.IeOutline = getIcon('ie', outline, getNode(newViewBox, 'M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z'));
	exports.InboxOutline = getIcon('inbox', outline, getNode(normalViewBox, 'M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0 0 60.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z'));
	exports.ImportOutline = getIcon('import', outline, getNode(newViewBox, 'M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zM902 476H588v-76c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-76h314c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.InfoOutline = getIcon('info', outline, getNode(newViewBox, 'M448 224a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z'));
	exports.ItalicOutline = getIcon('italic', outline, getNode(newViewBox, 'M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'));
	exports.IssuesCloseOutline = getIcon('issues-close', outline, getNode(newViewBox, 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 0 0-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0 0 26 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 0 1-49.8 62.2A355.92 355.92 0 0 1 651.1 840a355 355 0 0 1-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 0 1-113.3-76.3A353.06 353.06 0 0 1 184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 0 1 138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 0 0 892 694z'));
	exports.KeyOutline = getIcon('key', outline, getNode(newViewBox, 'M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 0 0 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z'));
	exports.LaptopOutline = getIcon('laptop', outline, getNode(newViewBox, 'M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z'));
	exports.LeftOutline = getIcon('left', outline, getNode(newViewBox, 'M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z'));
	exports.LinkOutline = getIcon('link', outline, getNode(newViewBox, 'M574 665.4a8.03 8.03 0 0 0-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 0 0-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 0 0 0 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 0 0 0 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 0 0-11.3 0L372.3 598.7a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z'));
	exports.LineChartOutline = getIcon('line-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3l39.5 39.7z'));
	exports.LineHeightOutline = getIcon('line-height', outline, getNode(newViewBox, 'M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 0 0-11.3 0L713.6 306.3a7.23 7.23 0 0 0 5.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 0 0-5.6-11.7z'));
	exports.LineOutline = getIcon('line', outline, getNode(newViewBox, 'M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.Loading3QuartersOutline = getIcon('loading-3-quarters', outline, getNode(normalViewBox, 'M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z'));
	exports.LoadingOutline = getIcon('loading', outline, getNode(normalViewBox, 'M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z'));
	exports.LoginOutline = getIcon('login', outline, getNode(newViewBox, 'M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 0 1 520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 0 1 270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 0 1 0 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z'));
	exports.LogoutOutline = getIcon('logout', outline, getNode(newViewBox, 'M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'));
	exports.ManOutline = getIcon('man', outline, getNode(newViewBox, 'M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z'));
	exports.MediumOutline = getIcon('medium', outline, getNode(newViewBox, 'M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 0 1-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 0 1 6.8-17.2z'));
	exports.MediumWorkmarkOutline = getIcon('medium-workmark', outline, getNode(normalViewBox, 'M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 0 1-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0 1 34.61 21.67v-56.19a6.99 6.99 0 0 0-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 0 0-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0 0 19.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 0 0-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 0 1-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 0 0-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0 0 19.35-12.2v-80.85a7.65 7.65 0 0 0-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 0 0-21.19 11.64 99.68 99.68 0 0 1 2.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 0 0 2.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 0 0-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0 1 44.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 0 0 2.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 0 0 2.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 0 0 2.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 0 0 2.96-17.78V457.97A19.71 19.71 0 0 0 24 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 0 0-2.72 6.8v139.37a6.5 6.5 0 0 0 2.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0 0 40.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z'));
	exports.MenuUnfoldOutline = getIcon('menu-unfold', outline, getNode(newViewBox, 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z'));
	exports.MenuFoldOutline = getIcon('menu-fold', outline, getNode(newViewBox, 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 0 0 0 13.8z'));
	exports.MenuOutline = getIcon('menu', outline, getNode(newViewBox, 'M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'));
	exports.MinusOutline = getIcon('minus', outline, getNode(newViewBox, 'M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
	exports.MonitorOutline = getIcon('monitor', outline, getNode(newViewBox, 'M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 0 0-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 0 0-11.2-1.4l-37.9 29.7a7.97 7.97 0 0 0-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z'));
	exports.MoreOutline = getIcon('more', outline, getNode(newViewBox, 'M456 231a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
	exports.OrderedListOutline = getIcon('ordered-list', outline, getNode(newViewBox, 'M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 0 0-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 0 0 2.1-5.4V432c0-2.2-1.8-4-4-4z'));
	exports.NumberOutline = getIcon('number', outline, getNode(newViewBox, 'M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z'));
	exports.PauseOutline = getIcon('pause', outline, getNode(newViewBox, 'M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z'));
	exports.PercentageOutline = getIcon('percentage', outline, getNode(newViewBox, 'M855.7 210.8l-42.4-42.4a8.03 8.03 0 0 0-11.3 0L168.3 801.9a8.03 8.03 0 0 0 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z'));
	exports.PaperClipOutline = getIcon('paper-clip', outline, getNode(newViewBox, 'M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z'));
	exports.PicCenterOutline = getIcon('pic-center', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z'));
	exports.PicLeftOutline = getIcon('pic-left', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
	exports.PlusOutline = getIcon('plus', outline, getNode(newViewBox, 'M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z', 'M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z'));
	exports.PicRightOutline = getIcon('pic-right', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
	exports.PoundOutline = getIcon('pound', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z'));
	exports.PoweroffOutline = getIcon('poweroff', outline, getNode(newViewBox, 'M705.6 124.9a8 8 0 0 0-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0 1 62.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0 1 27.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 0 1-76.3 113.3 353.06 353.06 0 0 1-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 0 1-113.2-76.4A355.92 355.92 0 0 1 184 650.4a355 355 0 0 1-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'));
	exports.PullRequestOutline = getIcon('pull-request', outline, getNode(newViewBox, 'M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0z'));
	exports.QqOutline = getIcon('qq', outline, getNode(newViewBox, 'M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z'));
	exports.QuestionOutline = getIcon('question', outline, getNode(newViewBox, 'M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 0 0-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z'));
	exports.RadarChartOutline = getIcon('radar-chart', outline, getNode(newViewBox, 'M926.8 397.1l-396-288a31.81 31.81 0 0 0-37.6 0l-396 288a31.99 31.99 0 0 0-11.6 35.8l151.3 466a32 32 0 0 0 30.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z'));
	exports.QrcodeOutline = getIcon('qrcode', outline, getNode(newViewBox, 'M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
	exports.RadiusBottomleftOutline = getIcon('radius-bottomleft', outline, getNode(newViewBox, 'M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.RadiusBottomrightOutline = getIcon('radius-bottomright', outline, getNode(newViewBox, 'M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z'));
	exports.RadiusUpleftOutline = getIcon('radius-upleft', outline, getNode(newViewBox, 'M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.RadiusUprightOutline = getIcon('radius-upright', outline, getNode(newViewBox, 'M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z'));
	exports.RadiusSettingOutline = getIcon('radius-setting', outline, getNode(newViewBox, 'M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z'));
	exports.RedditOutline = getIcon('reddit', outline, getNode(newViewBox, 'M288 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 1 0-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 0 0-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 0 0 176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 1 1 0 63 31.5 31.5 0 0 1 0-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0 1 50.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 0 1-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
	exports.RedoOutline = getIcon('redo', outline, getNode(newViewBox, 'M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 0 0-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z'));
	exports.ReloadOutline = getIcon('reload', outline, getNode(newViewBox, 'M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z'));
	exports.RetweetOutline = getIcon('retweet', outline, getNode(normalViewBox, 'M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0 0 11.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 0 0-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 0 0-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z'));
	exports.RightOutline = getIcon('right', outline, getNode(newViewBox, 'M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z'));
	exports.RiseOutline = getIcon('rise', outline, getNode(newViewBox, 'M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 0 0 0 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0 0 13.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z'));
	exports.RollbackOutline = getIcon('rollback', outline, getNode(newViewBox, 'M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 0 0 0 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z'));
	exports.SafetyOutline = getIcon('safety', outline, getNode(normalViewBox, 'M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z', 'M378.4 475.1a35.91 35.91 0 0 0-50.9 0 35.91 35.91 0 0 0 0 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0 0 48.1 0L730.6 434a33.98 33.98 0 0 0 0-48.1l-2.8-2.8a33.98 33.98 0 0 0-48.1 0L483 579.7 378.4 475.1z'));
	exports.RobotOutline = getIcon('robot', outline, getNode(newViewBox, 'M300 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
	exports.SearchOutline = getIcon('search', outline, getNode(newViewBox, 'M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z'));
	exports.ScanOutline = getIcon('scan', outline, getNode(newViewBox, 'M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.ScissorOutline = getIcon('scissor', outline, getNode(newViewBox, 'M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 0 0 288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z'));
	exports.SelectOutline = getIcon('select', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 0 0-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z'));
	exports.ShakeOutline = getIcon('shake', outline, getNode(newViewBox, 'M324 666a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 0 0 0 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0 0 11.2 0L373.7 164a7.9 7.9 0 0 0 0-11.2l-38.4-38.4a7.9 7.9 0 0 0-11.2 0L114.3 323.9a7.9 7.9 0 0 0 0 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 0 0-11.2 0L650.3 860.1a7.9 7.9 0 0 0 0 11.2l38.4 38.4a7.9 7.9 0 0 0 11.2 0L909.7 700a7.9 7.9 0 0 0 0-11.2l-38.3-38.5z'));
	exports.ShareAltOutline = getIcon('share-alt', outline, getNode(newViewBox, 'M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z'));
	exports.ShoppingCartOutline = getIcon('shopping-cart', outline, getNode(normalViewBox, 'M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 0 0-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 1 0 0 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 0 0-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 0 0-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6z'));
	exports.ShrinkOutline = getIcon('shrink', outline, getNode(newViewBox, 'M881.7 187.4l-45.1-45.1a8.03 8.03 0 0 0-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L447.9 585a7.9 7.9 0 0 0-8.9-8.9z'));
	exports.SlackOutline = getIcon('slack', outline, getNode(newViewBox, 'M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3a76.92 76.92 0 0 0-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5c42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z'));
	exports.SmallDashOutline = getIcon('small-dash', outline, getNode(newViewBox, 'M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z'));
	exports.SolutionOutline = getIcon('solution', outline, getNode(newViewBox, 'M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'));
	exports.SketchOutline = getIcon('sketch', outline, getNode(newViewBox, 'M925.6 405.1l-203-253.7a6.5 6.5 0 0 0-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 0 0 .2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 0 0 .2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z'));
	exports.SortDescendingOutline = getIcon('sort-descending', outline, getNode(newViewBox, 'M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM310.3 167.1a8 8 0 0 0-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z'));
	exports.SortAscendingOutline = getIcon('sort-ascending', outline, getNode(newViewBox, 'M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0 0 12.6 0l112-141.9c4.1-5.2.4-13-6.3-13z'));
	exports.StockOutline = getIcon('stock', outline, getNode(newViewBox, 'M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z'));
	exports.SwapLeftOutline = getIcon('swap-left', outline, getNode(normalViewBox, 'M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
	exports.SwapRightOutline = getIcon('swap-right', outline, getNode(normalViewBox, 'M873.1 596.2l-164-208A32 32 0 0 0 684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z'));
	exports.StrikethroughOutline = getIcon('strikethrough', outline, getNode(newViewBox, 'M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 0 0-8-7.9z'));
	exports.SwapOutline = getIcon('swap', outline, getNode(newViewBox, 'M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
	exports.SyncOutline = getIcon('sync', outline, getNode(newViewBox, 'M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 0 1 755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 0 1 512.1 856a342.24 342.24 0 0 1-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 0 0-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 0 0-8-8.2z'));
	exports.TableOutline = getIcon('table', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z'));
	exports.TeamOutline = getIcon('team', outline, getNode(newViewBox, 'M824.2 699.9a301.55 301.55 0 0 0-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 0 1 612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 0 0 8-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 0 1 612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z'));
	exports.TaobaoOutline = getIcon('taobao', outline, getNode(newViewBox, 'M168.5 273.7a68.7 68.7 0 1 0 137.4 0 68.7 68.7 0 1 0-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z'));
	exports.ToTopOutline = getIcon('to-top', outline, getNode(newViewBox, 'M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z'));
	exports.TrademarkOutline = getIcon('trademark', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 0 0 7.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z'));
	exports.TransactionOutline = getIcon('transaction', outline, getNode(newViewBox, 'M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 0 1 103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 0 1-103.5 242.4 352.57 352.57 0 0 1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 0 1-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z'));
	exports.TwitterOutline = getIcon('twitter', outline, getNode(newViewBox, 'M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0 0 75-94 336.64 336.64 0 0 1-108.2 41.2A170.1 170.1 0 0 0 672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 0 0-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 0 1-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 0 1-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z'));
	exports.UnderlineOutline = getIcon('underline', outline, getNode(newViewBox, 'M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z'));
	exports.UndoOutline = getIcon('undo', outline, getNode(newViewBox, 'M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 0 0-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 0 0-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z'));
	exports.UnorderedListOutline = getIcon('unordered-list', outline, getNode(newViewBox, 'M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
	exports.UpOutline = getIcon('up', outline, getNode(newViewBox, 'M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 0 0 140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z'));
	exports.UploadOutline = getIcon('upload', outline, getNode(newViewBox, 'M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'));
	exports.UserAddOutline = getIcon('user-add', outline, getNode(newViewBox, 'M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 888.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.UsergroupAddOutline = getIcon('usergroup-add', outline, getNode(newViewBox, 'M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z'));
	exports.UserOutline = getIcon('user', outline, getNode(newViewBox, 'M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z'));
	exports.UserDeleteOutline = getIcon('user-delete', outline, getNode(newViewBox, 'M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 901.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
	exports.UsergroupDeleteOutline = getIcon('usergroup-delete', outline, getNode(newViewBox, 'M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z'));
	exports.VerticalAlignBottomOutline = getIcon('vertical-align-bottom', outline, getNode(newViewBox, 'M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z'));
	exports.VerticalAlignMiddleOutline = getIcon('vertical-align-middle', outline, getNode(newViewBox, 'M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 0 0-11.3 0L405.6 752.3a7.23 7.23 0 0 0 5.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z'));
	exports.VerticalAlignTopOutline = getIcon('vertical-align-top', outline, getNode(newViewBox, 'M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z'));
	exports.VerticalRightOutline = getIcon('vertical-right', outline, getNode(newViewBox, 'M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z'));
	exports.VerticalLeftOutline = getIcon('vertical-left', outline, getNode(newViewBox, 'M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 0 0 254 164z'));
	exports.WifiOutline = getIcon('wifi', outline, getNode(newViewBox, 'M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 0 0-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 0 0-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 0 0-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 1 0 128 0 64 64 0 1 0-128 0z'));
	exports.ZhihuOutline = getIcon('zhihu', outline, getNode(newViewBox, 'M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z'));
	exports.WeiboOutline = getIcon('weibo', outline, getNode(newViewBox, 'M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 0 0-106-34.3 28.45 28.45 0 0 0-21.9 33.8 28.39 28.39 0 0 0 33.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0 1 11.3 53.3 28.45 28.45 0 0 0 18.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 0 0-25.4 39.3 33.12 33.12 0 0 0 39.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z'));
	exports.WomanOutline = getIcon('woman', outline, getNode(newViewBox, 'M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z'));
	exports.ZoomInOutline = getIcon('zoom-in', outline, getNode(newViewBox, 'M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'));
	exports.AccountBookTwoTone = getIcon('account-book', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 0 1 7.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z'
	    ], [
	        primaryColor,
	        'M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z'
	    ], [
	        primaryColor,
	        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z'
	    ]);
	});
	exports.ZoomOutOutline = getIcon('zoom-out', outline, getNode(newViewBox, 'M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'));
	exports.AlertTwoTone = getIcon('alert', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z'
	    ], [
	        primaryColor,
	        'M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z'
	    ]);
	});
	exports.ApiTwoTone = getIcon('api', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z'
	    ], [
	        primaryColor,
	        'M578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 0 0-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z'
	    ]);
	});
	exports.AppstoreTwoTone = getIcon('appstore', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z'
	    ], [
	        secondaryColor,
	        'M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z'
	    ]);
	});
	exports.BankTwoTone = getIcon('bank', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M240.9 393.9h542.2L512 196.7z'], [
	        primaryColor,
	        'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z'
	    ]);
	});
	exports.AudioTwoTone = getIcon('audio', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z'
	    ], [
	        primaryColor,
	        'M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z'
	    ], [
	        primaryColor,
	        'M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z'
	    ]);
	});
	exports.BellTwoTone = getIcon('bell', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z'
	    ], [
	        primaryColor,
	        'M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z'
	    ]);
	});
	exports.BookTwoTone = getIcon('book', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z'
	    ], [secondaryColor, 'M668 345.9V136h-96v211.4l49.5-35.4z'], [
	        secondaryColor,
	        'M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 0 1-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z'
	    ]);
	});
	exports.BoxPlotTwoTone = getIcon('box-plot', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M296 368h88v288h-88zm152 0h280v288H448z'], [
	        primaryColor,
	        'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z'
	    ]);
	});
	exports.BugTwoTone = getIcon('bug', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0 0 73.3 73.3A202.68 202.68 0 0 0 512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0 0 73.3-73.3A202.68 202.68 0 0 0 716 680V412H308zm484 172v96c0 6.5-.22 12.95-.66 19.35C859.94 728.64 908 796.7 908 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-44.24-23.94-82.89-59.57-103.7a278.63 278.63 0 0 1-22.66 49.02 281.39 281.39 0 0 1-100.45 100.45C611.84 946.07 563.55 960 512 960s-99.84-13.93-141.32-38.23a281.39 281.39 0 0 1-100.45-100.45 278.63 278.63 0 0 1-22.66-49.02A119.95 119.95 0 0 0 188 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-79.3 48.07-147.36 116.66-176.65A284.12 284.12 0 0 1 232 680v-96H84a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h148V412c-76.77 0-139-62.23-139-139a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8 63 63 0 0 0 63 63h560a63 63 0 0 0 63-63 8 8 0 0 1 8-8h60a8 8 0 0 1 8 8c0 76.77-62.23 139-139 139v100h148a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8H792zM368 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-40.04 8.78-76.75 25.9-108.07a184.57 184.57 0 0 1 74.03-74.03C427.25 72.78 463.96 64 504 64h16c40.04 0 76.75 8.78 108.07 25.9a184.57 184.57 0 0 1 74.03 74.03C719.22 195.25 728 231.96 728 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-28.33-5.94-53.15-17.08-73.53a112.56 112.56 0 0 0-45.39-45.4C573.15 141.95 548.33 136 520 136h-16c-28.33 0-53.15 5.94-73.53 17.08a112.56 112.56 0 0 0-45.4 45.39C373.95 218.85 368 243.67 368 272z'
	    ], [
	        secondaryColor,
	        'M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0 0 73.3 73.3A202.68 202.68 0 0 0 512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0 0 73.3-73.3A202.68 202.68 0 0 0 716 680V412H308z'
	    ]);
	});
	exports.BulbTwoTone = getIcon('bulb', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z'
	    ], [
	        primaryColor,
	        'M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z'
	    ]);
	});
	exports.CalculatorTwoTone = getIcon('calculator', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z'
	    ], [
	        primaryColor,
	        'M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z'
	    ]);
	});
	exports.BuildTwoTone = getIcon('build', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M144 546h200v200H144zm268-268h200v200H412z'], [
	        primaryColor,
	        'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z'
	    ]);
	});
	exports.CalendarTwoTone = getIcon('calendar', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z'
	    ], [
	        primaryColor,
	        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z'
	    ]);
	});
	exports.CameraTwoTone = getIcon('camera', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z'
	    ], [
	        primaryColor,
	        'M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z'
	    ], [
	        primaryColor,
	        'M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z'
	    ]);
	});
	exports.CarTwoTone = getIcon('car', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'
	    ], [primaryColor, 'M720 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'], [
	        primaryColor,
	        'M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z'
	    ], [
	        primaryColor,
	        'M224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z'
	    ]);
	});
	exports.CarryOutTwoTone = getIcon('carry-out', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z'
	    ], [
	        secondaryColor,
	        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z'
	    ], [
	        primaryColor,
	        'M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z'
	    ]);
	});
	exports.CheckCircleTwoTone = getIcon('check-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z'
	    ], [
	        primaryColor,
	        'M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z'
	    ]);
	});
	exports.CheckSquareTwoTone = getIcon('check-square', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z'
	    ], [
	        primaryColor,
	        'M432.2 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z'
	    ]);
	});
	exports.ClockCircleTwoTone = getIcon('clock-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z'
	    ], [
	        primaryColor,
	        'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z'
	    ]);
	});
	exports.CloseCircleTwoTone = getIcon('close-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 0 1-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z'
	    ], [
	        primaryColor,
	        'M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z'
	    ]);
	});
	exports.CloudTwoTone = getIcon('cloud', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 0 0-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 0 0-52.4 49.9 240.47 240.47 0 0 0-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 0 0-66.1 43.7A123.1 123.1 0 0 0 140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 0 0 884 612c0-56.2-37.8-105.5-92.1-120z'
	    ], [
	        primaryColor,
	        'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z'
	    ]);
	});
	exports.CloseSquareTwoTone = getIcon('close-square', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z'
	    ], [
	        primaryColor,
	        'M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z'
	    ]);
	});
	exports.CodeTwoTone = getIcon('code', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z'
	    ], [
	        primaryColor,
	        'M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z'
	    ]);
	});
	exports.CompassTwoTone = getIcon('compass', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z'
	    ], [
	        primaryColor,
	        'M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z'
	    ], [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ]);
	});
	exports.ContactsTwoTone = getIcon('contacts', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M460.3 526a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z'
	    ], [
	        secondaryColor,
	        'M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 0 1-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 0 1-8 8.4z'
	    ], [
	        primaryColor,
	        'M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z'
	    ], [
	        primaryColor,
	        'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'
	    ]);
	});
	exports.ContainerTwoTone = getIcon('container', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z'
	    ], [
	        primaryColor,
	        'M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
	    ], [
	        primaryColor,
	        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z'
	    ], [
	        primaryColor,
	        'M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
	    ]);
	});
	exports.ControlTwoTone = getIcon('control', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z'
	    ], [
	        primaryColor,
	        'M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 0 1 408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z'
	    ]);
	});
	exports.CopyTwoTone = getIcon('copy', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z'], [
	        primaryColor,
	        'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z'
	    ], [
	        primaryColor,
	        'M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z'
	    ]);
	});
	exports.CreditCardTwoTone = getIcon('credit-card', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z'
	    ], [
	        primaryColor,
	        'M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z'
	    ], [
	        primaryColor,
	        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z'
	    ]);
	});
	exports.CrownTwoTone = getIcon('crown', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z'
	    ], [
	        secondaryColor,
	        'M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z'
	    ], [
	        primaryColor,
	        'M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z'
	    ], [
	        primaryColor,
	        'M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z'
	    ]);
	});
	exports.CustomerServiceTwoTone = getIcon('customer-service', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M696 632h128v192H696zm-496 0h128v192H200z'], [
	        primaryColor,
	        'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z'
	    ]);
	});
	exports.DashboardTwoTone = getIcon('dashboard', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 0 0 884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 0 1-11.3 0l-56.6-56.6a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z'
	    ], [
	        primaryColor,
	        'M623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z'
	    ], [
	        primaryColor,
	        'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z'
	    ], [
	        primaryColor,
	        'M762.7 340.8l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z'
	    ]);
	});
	exports.DeleteTwoTone = getIcon('delete', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M292.7 840h438.6l24.2-512h-487z'], [
	        primaryColor,
	        'M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z'
	    ]);
	});
	exports.DiffTwoTone = getIcon('diff', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z'
	    ], [
	        primaryColor,
	        'M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z'
	    ], [
	        primaryColor,
	        'M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z'
	    ], [
	        primaryColor,
	        'M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z'
	    ]);
	});
	exports.DatabaseTwoTone = getIcon('database', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
	    ], [
	        primaryColor,
	        'M304 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-544a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
	    ], [
	        primaryColor,
	        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z'
	    ]);
	});
	exports.DislikeTwoTone = getIcon('dislike', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0 0 42.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z'
	    ], [
	        primaryColor,
	        'M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z'
	    ]);
	});
	exports.DownCircleTwoTone = getIcon('down-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z'
	    ], [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        primaryColor,
	        'M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z'
	    ]);
	});
	exports.DownSquareTwoTone = getIcon('down-square', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z'
	    ], [
	        primaryColor,
	        'M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z'
	    ]);
	});
	exports.EnvironmentTwoTone = getIcon('environment', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'
	    ], [
	        primaryColor,
	        'M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z'
	    ], [
	        primaryColor,
	        'M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z'
	    ]);
	});
	exports.EditTwoTone = getIcon('edit', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z'], [
	        primaryColor,
	        'M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z'
	    ]);
	});
	exports.ExclamationCircleTwoTone = getIcon('exclamation-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
	    ], [
	        primaryColor,
	        'M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
	    ]);
	});
	exports.ExperimentTwoTone = getIcon('experiment', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 0 1 552 512a40 40 0 0 1-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z'
	    ], [
	        primaryColor,
	        'M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z'
	    ], [
	        primaryColor,
	        'M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0 0 40 39.4z'
	    ]);
	});
	exports.EyeInvisibleTwoTone = getIcon('eye-invisible', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M254.89 758.85l125.57-125.57a176 176 0 0 1 248.82-248.82L757 256.72Q651.69 186.07 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q69.27 145.91 173.09 221.05zM942.2 486.2Q889.46 375.11 816.7 305L672.48 449.27a176.09 176.09 0 0 1-227.22 227.21L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z'
	    ], [
	        primaryColor,
	        'M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zM878.63 165.56L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z'
	    ], [
	        primaryColor,
	        'M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z'
	    ]);
	});
	exports.EyeTwoTone = getIcon('eye', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M81.8 537.8a60.3 60.3 0 0 1 0-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z'
	    ], [
	        secondaryColor,
	        'M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'
	    ], [
	        primaryColor,
	        'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z'
	    ], [
	        primaryColor,
	        'M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'
	    ]);
	});
	exports.FileAddTwoTone = getIcon('file-add', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z'
	    ], [
	        primaryColor,
	        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
	    ], [
	        primaryColor,
	        'M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z'
	    ]);
	});
	exports.FileExclamationTwoTone = getIcon('file-exclamation', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'
	    ], [
	        primaryColor,
	        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
	    ], [
	        primaryColor,
	        'M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
	    ]);
	});
	exports.FileImageTwoTone = getIcon('file-image', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0 1 12.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z'
	    ], [
	        primaryColor,
	        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
	    ], [
	        primaryColor,
	        'M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
	    ]);
	});
	exports.FileExcelTwoTone = getIcon('file-excel', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm51.6 120h35.7a12.04 12.04 0 0 1 10.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 0 1-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z'
	    ], [
	        primaryColor,
	        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
	    ], [
	        primaryColor,
	        'M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z'
	    ]);
	});
	exports.FileMarkdownTwoTone = getIcon('file-markdown', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 0 1-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z'
	    ], [
	        primaryColor,
	        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
	    ], [
	        primaryColor,
	        'M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z'
	    ]);
	});
	exports.FilePdfTwoTone = getIcon('file-pdf', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z'
	    ], [
	        secondaryColor,
	        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z'
	    ], [
	        secondaryColor,
	        'M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z'
	    ], [
	        primaryColor,
	        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
	    ], [
	        primaryColor,
	        'M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z'
	    ]);
	});
	exports.FilePptTwoTone = getIcon('file-ppt', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z'
	    ], [
	        secondaryColor,
	        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z'
	    ], [
	        primaryColor,
	        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
	    ], [
	        primaryColor,
	        'M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z'
	    ]);
	});
	exports.FileTextTwoTone = getIcon('file-text', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z'
	    ], [
	        primaryColor,
	        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
	    ], [
	        primaryColor,
	        'M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
	    ]);
	});
	exports.FileUnknownTwoTone = getIcon('file-unknown', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z'
	    ], [
	        primaryColor,
	        'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
	    ], [
	        primaryColor,
	        'M480 744a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z'
	    ]);
	});
	exports.FileZipTwoTone = getIcon('file-zip', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M344 630h32v2h-32z'], [
	        secondaryColor,
	        'M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 0 1-42-42z'
	    ], [
	        primaryColor,
	        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z'
	    ], [
	        primaryColor,
	        'M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z'
	    ]);
	});
	exports.FileWordTwoTone = getIcon('file-word', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0 1 11.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0 1 11.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z'
	    ], [
	        primaryColor,
	        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
	    ], [
	        primaryColor,
	        'M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z'
	    ]);
	});
	exports.FileTwoTone = getIcon('file', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42z'], [
	        primaryColor,
	        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
	    ]);
	});
	exports.FilterTwoTone = getIcon('filter', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z'
	    ], [
	        primaryColor,
	        'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z'
	    ]);
	});
	exports.FireTwoTone = getIcon('fire', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 0 1-51 24.4 73.36 73.36 0 0 1-53.4-18.8 74.01 74.01 0 0 1-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 0 1-12.1 46.5 354.26 354.26 0 0 1-58.2 101 349.6 349.6 0 0 1-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 0 0-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z'
	    ], [
	        primaryColor,
	        'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z'
	    ]);
	});
	exports.FolderAddTwoTone = getIcon('folder-add', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z'
	    ], [
	        primaryColor,
	        'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'
	    ], [
	        primaryColor,
	        'M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z'
	    ]);
	});
	exports.FlagTwoTone = getIcon('flag', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M184 232h368v336H184z'], [secondaryColor, 'M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z'], [
	        primaryColor,
	        'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z'
	    ]);
	});
	exports.FolderTwoTone = getIcon('folder', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'
	    ], [secondaryColor, 'M372.5 256H184v512h656V370.4H492.1z']);
	});
	exports.FolderOpenTwoTone = getIcon('folder-open', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M159 768h612.3l103.4-256H262.3z'], [
	        primaryColor,
	        'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z'
	    ]);
	});
	exports.FrownTwoTone = getIcon('frown', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
	    ], [
	        primaryColor,
	        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
	    ]);
	});
	exports.FundTwoTone = getIcon('fund', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z'
	    ], [
	        secondaryColor,
	        'M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 0 1-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 0 1-11.3 0l-36.7-36.9a8.03 8.03 0 0 1 0-11.3z'
	    ], [
	        primaryColor,
	        'M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L533 561 418.6 446.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z'
	    ]);
	});
	exports.FunnelPlotTwoTone = getIcon('funnel-plot', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z'
	    ], [
	        primaryColor,
	        'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z'
	    ]);
	});
	exports.GiftTwoTone = getIcon('gift', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z'
	    ], [
	        primaryColor,
	        'M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z'
	    ]);
	});
	exports.HddTwoTone = getIcon('hdd', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z'
	    ], [
	        primaryColor,
	        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z'
	    ], [
	        primaryColor,
	        'M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
	    ]);
	});
	exports.HeartTwoTone = getIcon('heart', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z'
	    ], [
	        secondaryColor,
	        'M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z'
	    ]);
	});
	exports.HighlightTwoTone = getIcon('highlight', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z'
	    ], [
	        primaryColor,
	        'M957.6 507.5L603.2 158.3a7.9 7.9 0 0 0-11.2 0L353.3 393.5a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z'
	    ]);
	});
	exports.HomeTwoTone = getIcon('home', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z'
	    ], [
	        primaryColor,
	        'M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.6 63.6 0 0 0-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0 0 18.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z'
	    ]);
	});
	exports.HourglassTwoTone = getIcon('hourglass', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 0 0 354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 0 0 512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z'
	    ], [
	        primaryColor,
	        'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z'
	    ]);
	});
	exports.Html5TwoTone = getIcon('html5', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z'
	    ], [
	        secondaryColor,
	        'M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z'
	    ], [
	        primaryColor,
	        'M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z'
	    ]);
	});
	exports.IdcardTwoTone = getIcon('idcard', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z'
	    ], [
	        secondaryColor,
	        'M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 0 1-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z'
	    ], [
	        secondaryColor,
	        'M321.3 463a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z'
	    ], [
	        primaryColor,
	        'M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z'
	    ]);
	});
	exports.InfoCircleTwoTone = getIcon('info-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
	    ], [
	        primaryColor,
	        'M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z'
	    ]);
	});
	exports.InsuranceTwoTone = getIcon('insurance', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
	    ], [secondaryColor, 'M521.9 358.8h97.9v41.6h-97.9z'], [
	        secondaryColor,
	        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 0 1-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z'
	    ], [
	        primaryColor,
	        'M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 0 0-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0 0 33.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z'
	    ]);
	});
	exports.InteractionTwoTone = getIcon('interaction', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z'
	    ], [
	        primaryColor,
	        'M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'
	    ]);
	});
	exports.InterationTwoTone = getIcon('interation', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z'
	    ], [
	        primaryColor,
	        'M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'
	    ]);
	});
	exports.LayoutTwoTone = getIcon('layout', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z'
	    ], [
	        primaryColor,
	        'M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z'
	    ]);
	});
	exports.LeftCircleTwoTone = getIcon('left-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z'
	    ], [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        primaryColor,
	        'M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z'
	    ]);
	});
	exports.LeftSquareTwoTone = getIcon('left-square', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 0 1 0-12.9z'
	    ], [
	        primaryColor,
	        'M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 0 0 0 12.9z'
	    ]);
	});
	exports.LikeTwoTone = getIcon('like', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0 0 33.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0 0 19.6-43c0-19.1-11-37.5-28.8-48.4z'
	    ], [
	        primaryColor,
	        'M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 0 0-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 0 0-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0 1 42.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z'
	    ]);
	});
	exports.LockTwoTone = getIcon('lock', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z'
	    ], [
	        secondaryColor,
	        'M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z'
	    ], [
	        primaryColor,
	        'M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'
	    ]);
	});
	exports.MailTwoTone = getIcon('mail', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 0 1-68.7 0z'
	    ], [secondaryColor, 'M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z'], [
	        primaryColor,
	        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z'
	    ]);
	});
	exports.MedicineBoxTwoTone = getIcon('medicine-box', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z'
	    ], [
	        primaryColor,
	        'M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
	    ], [
	        primaryColor,
	        'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z'
	    ]);
	});
	exports.MehTwoTone = getIcon('meh', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
	    ], [
	        primaryColor,
	        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
	    ]);
	});
	exports.MessageTwoTone = getIcon('message', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M775.3 248.9a369.62 369.62 0 0 0-119-80A370.2 370.2 0 0 0 512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 0 0-80-119zM312 560a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
	    ], [
	        primaryColor,
	        'M664 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
	    ], [
	        primaryColor,
	        'M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z'
	    ], [primaryColor, 'M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
	});
	exports.MinusCircleTwoTone = getIcon('minus-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'
	    ], [
	        primaryColor,
	        'M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
	    ]);
	});
	exports.MinusSquareTwoTone = getIcon('minus-square', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z'
	    ], [
	        primaryColor,
	        'M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
	    ]);
	});
	exports.MobileTwoTone = getIcon('mobile', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z'
	    ], [
	        secondaryColor,
	        'M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
	    ], [primaryColor, 'M472 786a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
	});
	exports.PauseCircleTwoTone = getIcon('pause-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z'
	    ], [
	        primaryColor,
	        'M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z'
	    ]);
	});
	exports.MoneyCollectTwoTone = getIcon('money-collect', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z'
	    ], [
	        primaryColor,
	        'M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z'
	    ], [
	        primaryColor,
	        'M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z'
	    ]);
	});
	exports.NotificationTwoTone = getIcon('notification', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z'
	    ], [
	        primaryColor,
	        'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z'
	    ]);
	});
	exports.PhoneTwoTone = getIcon('phone', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 0 1 438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z'
	    ], [
	        primaryColor,
	        'M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z'
	    ]);
	});
	exports.PictureTwoTone = getIcon('picture', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z'
	    ], [
	        secondaryColor,
	        'M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z'
	    ], [
	        secondaryColor,
	        'M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 1 1 0 176 88 88 0 0 1 0-176z'
	    ], [secondaryColor, 'M276 368a28 28 0 1 0 56 0 28 28 0 1 0-56 0z'], [
	        primaryColor,
	        'M304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z'
	    ]);
	});
	exports.PlayCircleTwoTone = getIcon('play-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 0 1-12.7-6.5V353a8 8 0 0 1 12.7-6.5l218.4 158.8a7.9 7.9 0 0 1 0 12.9z'
	    ], [
	        primaryColor,
	        'M676.1 505.3L457.7 346.5A8 8 0 0 0 445 353v317.6a8.02 8.02 0 0 0 12.7 6.5l218.4-158.9a7.9 7.9 0 0 0 0-12.9z'
	    ]);
	});
	exports.PlaySquareTwoTone = getIcon('play-square', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z'
	    ], [
	        primaryColor,
	        'M442.3 677.6l199.4-156.8a11.2 11.2 0 0 0 0-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z'
	    ]);
	});
	exports.PieChartTwoTone = getIcon('pie-chart', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 0 1-85.7-127.1A397.12 397.12 0 0 1 72 552.2v.2a398.57 398.57 0 0 0 117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 0 0 471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z'
	    ], [
	        secondaryColor,
	        'M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 0 0-166.4-89.8z'
	    ], [
	        secondaryColor,
	        'M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z'
	    ], [
	        primaryColor,
	        'M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z'
	    ], [
	        primaryColor,
	        'M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 0 0-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 0 0 4.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z'
	    ]);
	});
	exports.PlusCircleTwoTone = getIcon('plus-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'
	    ], [
	        primaryColor,
	        'M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
	    ]);
	});
	exports.PlusSquareTwoTone = getIcon('plus-square', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z'
	    ], [
	        primaryColor,
	        'M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
	    ]);
	});
	exports.PoundCircleTwoTone = getIcon('pound-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z'
	    ], [
	        primaryColor,
	        'M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0 0 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z'
	    ]);
	});
	exports.PrinterTwoTone = getIcon('printer', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z'
	    ], [
	        primaryColor,
	        'M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z'
	    ], [
	        primaryColor,
	        'M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z'
	    ]);
	});
	exports.ProfileTwoTone = getIcon('profile', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
	    ], [
	        primaryColor,
	        'M340 656a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
	    ]);
	});
	exports.ProjectTwoTone = getIcon('project', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z'
	    ], [
	        primaryColor,
	        'M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z'
	    ]);
	});
	exports.PushpinTwoTone = getIcon('pushpin', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0 0 30.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z'
	    ], [
	        primaryColor,
	        'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z'
	    ]);
	});
	exports.PropertySafetyTwoTone = getIcon('property-safety', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
	    ], [
	        secondaryColor,
	        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 0 1 8.9-5.5z'
	    ], [
	        primaryColor,
	        'M438.9 323.5a9.88 9.88 0 0 0-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 0 0-8.9 5.5l-73.2 144.3-72.9-144.3z'
	    ]);
	});
	exports.QuestionCircleTwoTone = getIcon('question-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'
	    ], [
	        primaryColor,
	        'M472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z'
	    ]);
	});
	exports.ReconciliationTwoTone = getIcon('reconciliation', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z'
	    ], [secondaryColor, 'M642 657a34 34 0 1 0 68 0 34 34 0 1 0-68 0z'], [
	        primaryColor,
	        'M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z'
	    ], [
	        primaryColor,
	        'M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z'
	    ], [
	        primaryColor,
	        'M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z'
	    ]);
	});
	exports.RedEnvelopeTwoTone = getIcon('red-envelope', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z'
	    ], [
	        secondaryColor,
	        'M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 0 1-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 0 1 7.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 0 1 3.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 0 1 7.5-4.6z'
	    ], [secondaryColor, 'M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z'], [
	        primaryColor,
	        'M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z'
	    ]);
	});
	exports.RestTwoTone = getIcon('rest', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z'
	    ], [
	        primaryColor,
	        'M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'
	    ], [
	        primaryColor,
	        'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z'
	    ]);
	});
	exports.RightCircleTwoTone = getIcon('right-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z'
	    ], [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        primaryColor,
	        'M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z'
	    ]);
	});
	exports.RocketTwoTone = getIcon('rocket', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 0 0-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
	    ], [
	        primaryColor,
	        'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0 1 62.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z'
	    ], [primaryColor, 'M464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
	});
	exports.RightSquareTwoTone = getIcon('right-square', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z'
	    ], [
	        primaryColor,
	        'M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z'
	    ]);
	});
	exports.SafetyCertificateTwoTone = getIcon('safety-certificate', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
	    ], [
	        secondaryColor,
	        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z'
	    ], [
	        primaryColor,
	        'M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z'
	    ]);
	});
	exports.SaveTwoTone = getIcon('save', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z'
	    ], [
	        primaryColor,
	        'M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'
	    ], [
	        primaryColor,
	        'M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 0 0-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z'
	    ]);
	});
	exports.ScheduleTwoTone = getIcon('schedule', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z'
	    ], [
	        primaryColor,
	        'M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
	    ], [
	        primaryColor,
	        'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'
	    ], [
	        primaryColor,
	        'M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
	    ]);
	});
	exports.SecurityScanTwoTone = getIcon('security-scan', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
	    ], [
	        secondaryColor,
	        'M460.7 451.1a80.1 80.1 0 1 0 160.2 0 80.1 80.1 0 1 0-160.2 0z'
	    ], [
	        secondaryColor,
	        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z'
	    ], [
	        primaryColor,
	        'M418.8 527.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 0 1 113.3 0 80.1 80.1 0 0 1 0 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z'
	    ]);
	});
	exports.SettingTwoTone = getIcon('setting', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 0 0-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z'
	    ], [
	        secondaryColor,
	        'M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 0 1-79.7 137.9l-1.8 2.1a32 32 0 0 1-35.1 9.5l-81.3-28.9a350 350 0 0 1-99.7 57.6l-15.7 85a32.05 32.05 0 0 1-25.8 25.7l-2.7.5a445.2 445.2 0 0 1-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z'
	    ], [
	        primaryColor,
	        'M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502z'
	    ], [
	        primaryColor,
	        'M594.1 952.2a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 0 0-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6a32.09 32.09 0 0 0 7.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z'
	    ]);
	});
	exports.ShopTwoTone = getIcon('shop', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z'
	    ], [
	        primaryColor,
	        'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z'
	    ]);
	});
	exports.ShoppingTwoTone = getIcon('shopping', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z'
	    ], [
	        primaryColor,
	        'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z'
	    ]);
	});
	exports.SkinTwoTone = getIcon('skin', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z'
	    ], [
	        primaryColor,
	        'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z'
	    ]);
	});
	exports.SlidersTwoTone = getIcon('sliders', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M180 292h80v440h-80zm369 180h-74a3 3 0 0 0-3 3v74a3 3 0 0 0 3 3h74a3 3 0 0 0 3-3v-74a3 3 0 0 0-3-3zm215-108h80v296h-80z'
	    ], [
	        primaryColor,
	        'M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z'
	    ]);
	});
	exports.SmileTwoTone = getIcon('smile', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
	    ], [
	        primaryColor,
	        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4zm-24-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
	    ]);
	});
	exports.SnippetsTwoTone = getIcon('snippets', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z'
	    ], [
	        primaryColor,
	        'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'
	    ]);
	});
	exports.SoundTwoTone = getIcon('sound', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z'
	    ], [
	        primaryColor,
	        'M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z'
	    ]);
	});
	exports.StarTwoTone = getIcon('star', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z'
	    ], [
	        primaryColor,
	        'M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0 0 46.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z'
	    ]);
	});
	exports.StopTwoTone = getIcon('stop', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z'
	    ]);
	});
	exports.SwitcherTwoTone = getIcon('switcher', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [secondaryColor, 'M184 840h528V312H184v528zm116-290h296v64H300v-64z'], [
	        primaryColor,
	        'M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z'
	    ], [
	        primaryColor,
	        'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z'
	    ], [primaryColor, 'M300 550h296v64H300z']);
	});
	exports.TabletTwoTone = getIcon('tablet', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z'
	    ], [
	        secondaryColor,
	        'M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
	    ], [primaryColor, 'M472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
	});
	exports.TagTwoTone = getIcon('tag', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z'
	    ], [
	        primaryColor,
	        'M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'
	    ], [
	        primaryColor,
	        'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8a9.9 9.9 0 0 0 7.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z'
	    ]);
	});
	exports.TagsTwoTone = getIcon('tags', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0 1 33.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0 1 12.4 46.4 47.81 47.81 0 0 1-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 0 1-12.4-46.4z'
	    ], [
	        secondaryColor,
	        'M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 0 1 0-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z'
	    ], [
	        primaryColor,
	        'M889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0 0 33.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 0 0-46.4-12.4 47.81 47.81 0 0 0-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0 0 46.4 12.4z'
	    ], [
	        primaryColor,
	        'M137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z'
	    ]);
	});
	exports.ToolTwoTone = getIcon('tool', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M706.8 488.7a32.05 32.05 0 0 1-45.3 0L537 364.2a32.05 32.05 0 0 1 0-45.3l132.9-132.8a184.2 184.2 0 0 0-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z'
	    ], [
	        primaryColor,
	        'M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z'
	    ]);
	});
	exports.TrademarkCircleTwoTone = getIcon('trademark-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z'
	    ], [
	        secondaryColor,
	        'M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z'
	    ], [
	        primaryColor,
	        'M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z'
	    ]);
	});
	exports.UnlockTwoTone = getIcon('unlock', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z'
	    ], [
	        primaryColor,
	        'M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'
	    ], [
	        primaryColor,
	        'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z'
	    ]);
	});
	exports.TrophyTwoTone = getIcon('trophy', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z'
	    ], [
	        primaryColor,
	        'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6a91.99 91.99 0 0 1-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z'
	    ]);
	});
	exports.UpCircleTwoTone = getIcon('up-circle', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'
	    ], [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        primaryColor,
	        'M518.4 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z'
	    ]);
	});
	exports.ThunderboltTwoTone = getIcon('thunderbolt', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z'
	    ], [
	        primaryColor,
	        'M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z'
	    ]);
	});
	exports.UpSquareTwoTone = getIcon('up-square', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
	    ], [
	        secondaryColor,
	        'M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z'
	    ], [
	        primaryColor,
	        'M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z'
	    ]);
	});
	exports.UsbTwoTone = getIcon('usb', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z'
	    ], [
	        primaryColor,
	        'M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
	    ], [
	        primaryColor,
	        'M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z'
	    ]);
	});
	exports.VideoCameraTwoTone = getIcon('video-camera', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z'
	    ], [
	        primaryColor,
	        'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z'
	    ], [
	        primaryColor,
	        'M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
	    ]);
	});
	exports.WalletTwoTone = getIcon('wallet', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z'
	    ], [
	        secondaryColor,
	        'M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
	    ], [primaryColor, 'M580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'], [
	        secondaryColor,
	        'M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z'
	    ]);
	});
	exports.WarningTwoTone = getIcon('warning', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z'
	    ], [
	        secondaryColor,
	        'M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z'
	    ], [
	        primaryColor,
	        'M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z'
	    ]);
	});
	exports.CiTwoTone = getIcon('ci', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z'
	    ], [
	        primaryColor,
	        'M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z'
	    ]);
	});
	exports.CopyrightTwoTone = getIcon('copyright', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z'
	    ], [
	        primaryColor,
	        'M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z'
	    ]);
	});
	exports.DollarTwoTone = getIcon('dollar', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 0 1-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z'
	    ], [
	        primaryColor,
	        'M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z'
	    ]);
	});
	exports.EuroTwoTone = getIcon('euro', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
	    ], [
	        secondaryColor,
	        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 0 1-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z'
	    ], [
	        primaryColor,
	        'M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z'
	    ]);
	});
	exports.GoldTwoTone = getIcon('gold', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        primaryColor,
	        'M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z'
	    ], [
	        secondaryColor,
	        'M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z'
	    ]);
	});
	exports.CanlendarTwoTone = getIcon('canlendar', twotone, function (primaryColor, secondaryColor) {
	    return getNode(newViewBox, [
	        secondaryColor,
	        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z'
	    ], [
	        primaryColor,
	        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z'
	    ]);
	});


/***/ },
/* 1218 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1219 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1220 */
/***/ function(module, exports) {

	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
	}
	
	module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ },
/* 1221 */
/***/ function(module, exports) {

	/**
	 * @ignore
	 * base event object for custom and dom event.
	 * @author yiminghe@gmail.com
	 */
	
	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function returnFalse() {
	  return false;
	}
	
	function returnTrue() {
	  return true;
	}
	
	function EventBaseObject() {
	  this.timeStamp = Date.now();
	  this.target = undefined;
	  this.currentTarget = undefined;
	}
	
	EventBaseObject.prototype = {
	  isEventObject: 1,
	
	  constructor: EventBaseObject,
	
	  isDefaultPrevented: returnFalse,
	
	  isPropagationStopped: returnFalse,
	
	  isImmediatePropagationStopped: returnFalse,
	
	  preventDefault: function preventDefault() {
	    this.isDefaultPrevented = returnTrue;
	  },
	
	  stopPropagation: function stopPropagation() {
	    this.isPropagationStopped = returnTrue;
	  },
	
	  stopImmediatePropagation: function stopImmediatePropagation() {
	    this.isImmediatePropagationStopped = returnTrue;
	    // fixed 1.2
	    // call stopPropagation implicitly
	    this.stopPropagation();
	  },
	
	  halt: function halt(immediate) {
	    if (immediate) {
	      this.stopImmediatePropagation();
	    } else {
	      this.stopPropagation();
	    }
	    this.preventDefault();
	  }
	};
	
	exports["default"] = EventBaseObject;
	module.exports = exports["default"];

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * @ignore
	 * event object for dom
	 * @author yiminghe@gmail.com
	 */
	
	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventBaseObject = __webpack_require__(1221);
	
	var _EventBaseObject2 = _interopRequireDefault(_EventBaseObject);
	
	var _objectAssign = __webpack_require__(40);
	
	var _objectAssign2 = _interopRequireDefault(_objectAssign);
	
	var TRUE = true;
	var FALSE = false;
	var commonProps = ['altKey', 'bubbles', 'cancelable', 'ctrlKey', 'currentTarget', 'eventPhase', 'metaKey', 'shiftKey', 'target', 'timeStamp', 'view', 'type'];
	
	function isNullOrUndefined(w) {
	  return w === null || w === undefined;
	}
	
	var eventNormalizers = [{
	  reg: /^key/,
	  props: ['char', 'charCode', 'key', 'keyCode', 'which'],
	  fix: function fix(event, nativeEvent) {
	    if (isNullOrUndefined(event.which)) {
	      event.which = !isNullOrUndefined(nativeEvent.charCode) ? nativeEvent.charCode : nativeEvent.keyCode;
	    }
	
	    // add metaKey to non-Mac browsers (use ctrl for PC 's and Meta for Macs)
	    if (event.metaKey === undefined) {
	      event.metaKey = event.ctrlKey;
	    }
	  }
	}, {
	  reg: /^touch/,
	  props: ['touches', 'changedTouches', 'targetTouches']
	}, {
	  reg: /^hashchange$/,
	  props: ['newURL', 'oldURL']
	}, {
	  reg: /^gesturechange$/i,
	  props: ['rotation', 'scale']
	}, {
	  reg: /^(mousewheel|DOMMouseScroll)$/,
	  props: [],
	  fix: function fix(event, nativeEvent) {
	    var deltaX = undefined;
	    var deltaY = undefined;
	    var delta = undefined;
	    var wheelDelta = nativeEvent.wheelDelta;
	    var axis = nativeEvent.axis;
	    var wheelDeltaY = nativeEvent.wheelDeltaY;
	    var wheelDeltaX = nativeEvent.wheelDeltaX;
	    var detail = nativeEvent.detail;
	
	    // ie/webkit
	    if (wheelDelta) {
	      delta = wheelDelta / 120;
	    }
	
	    // gecko
	    if (detail) {
	      // press control e.detail == 1 else e.detail == 3
	      delta = 0 - (detail % 3 === 0 ? detail / 3 : detail);
	    }
	
	    // Gecko
	    if (axis !== undefined) {
	      if (axis === event.HORIZONTAL_AXIS) {
	        deltaY = 0;
	        deltaX = 0 - delta;
	      } else if (axis === event.VERTICAL_AXIS) {
	        deltaX = 0;
	        deltaY = delta;
	      }
	    }
	
	    // Webkit
	    if (wheelDeltaY !== undefined) {
	      deltaY = wheelDeltaY / 120;
	    }
	    if (wheelDeltaX !== undefined) {
	      deltaX = -1 * wheelDeltaX / 120;
	    }
	
	    // 默认 deltaY (ie)
	    if (!deltaX && !deltaY) {
	      deltaY = delta;
	    }
	
	    if (deltaX !== undefined) {
	      /**
	       * deltaX of mousewheel event
	       * @property deltaX
	       * @member Event.DomEvent.Object
	       */
	      event.deltaX = deltaX;
	    }
	
	    if (deltaY !== undefined) {
	      /**
	       * deltaY of mousewheel event
	       * @property deltaY
	       * @member Event.DomEvent.Object
	       */
	      event.deltaY = deltaY;
	    }
	
	    if (delta !== undefined) {
	      /**
	       * delta of mousewheel event
	       * @property delta
	       * @member Event.DomEvent.Object
	       */
	      event.delta = delta;
	    }
	  }
	}, {
	  reg: /^mouse|contextmenu|click|mspointer|(^DOMMouseScroll$)/i,
	  props: ['buttons', 'clientX', 'clientY', 'button', 'offsetX', 'relatedTarget', 'which', 'fromElement', 'toElement', 'offsetY', 'pageX', 'pageY', 'screenX', 'screenY'],
	  fix: function fix(event, nativeEvent) {
	    var eventDoc = undefined;
	    var doc = undefined;
	    var body = undefined;
	    var target = event.target;
	    var button = nativeEvent.button;
	
	    // Calculate pageX/Y if missing and clientX/Y available
	    if (target && isNullOrUndefined(event.pageX) && !isNullOrUndefined(nativeEvent.clientX)) {
	      eventDoc = target.ownerDocument || document;
	      doc = eventDoc.documentElement;
	      body = eventDoc.body;
	      event.pageX = nativeEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) - (doc && doc.clientLeft || body && body.clientLeft || 0);
	      event.pageY = nativeEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) - (doc && doc.clientTop || body && body.clientTop || 0);
	    }
	
	    // which for click: 1 === left; 2 === middle; 3 === right
	    // do not use button
	    if (!event.which && button !== undefined) {
	      if (button & 1) {
	        event.which = 1;
	      } else if (button & 2) {
	        event.which = 3;
	      } else if (button & 4) {
	        event.which = 2;
	      } else {
	        event.which = 0;
	      }
	    }
	
	    // add relatedTarget, if necessary
	    if (!event.relatedTarget && event.fromElement) {
	      event.relatedTarget = event.fromElement === target ? event.toElement : event.fromElement;
	    }
	
	    return event;
	  }
	}];
	
	function retTrue() {
	  return TRUE;
	}
	
	function retFalse() {
	  return FALSE;
	}
	
	function DomEventObject(nativeEvent) {
	  var type = nativeEvent.type;
	
	  var isNative = typeof nativeEvent.stopPropagation === 'function' || typeof nativeEvent.cancelBubble === 'boolean';
	
	  _EventBaseObject2['default'].call(this);
	
	  this.nativeEvent = nativeEvent;
	
	  // in case dom event has been mark as default prevented by lower dom node
	  var isDefaultPrevented = retFalse;
	  if ('defaultPrevented' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.defaultPrevented ? retTrue : retFalse;
	  } else if ('getPreventDefault' in nativeEvent) {
	    // https://bugzilla.mozilla.org/show_bug.cgi?id=691151
	    isDefaultPrevented = nativeEvent.getPreventDefault() ? retTrue : retFalse;
	  } else if ('returnValue' in nativeEvent) {
	    isDefaultPrevented = nativeEvent.returnValue === FALSE ? retTrue : retFalse;
	  }
	
	  this.isDefaultPrevented = isDefaultPrevented;
	
	  var fixFns = [];
	  var fixFn = undefined;
	  var l = undefined;
	  var prop = undefined;
	  var props = commonProps.concat();
	
	  eventNormalizers.forEach(function (normalizer) {
	    if (type.match(normalizer.reg)) {
	      props = props.concat(normalizer.props);
	      if (normalizer.fix) {
	        fixFns.push(normalizer.fix);
	      }
	    }
	  });
	
	  l = props.length;
	
	  // clone properties of the original event object
	  while (l) {
	    prop = props[--l];
	    this[prop] = nativeEvent[prop];
	  }
	
	  // fix target property, if necessary
	  if (!this.target && isNative) {
	    this.target = nativeEvent.srcElement || document; // srcElement might not be defined either
	  }
	
	  // check if target is a text node (safari)
	  if (this.target && this.target.nodeType === 3) {
	    this.target = this.target.parentNode;
	  }
	
	  l = fixFns.length;
	
	  while (l) {
	    fixFn = fixFns[--l];
	    fixFn(this, nativeEvent);
	  }
	
	  this.timeStamp = nativeEvent.timeStamp || Date.now();
	}
	
	var EventBaseObjectProto = _EventBaseObject2['default'].prototype;
	
	(0, _objectAssign2['default'])(DomEventObject.prototype, EventBaseObjectProto, {
	  constructor: DomEventObject,
	
	  preventDefault: function preventDefault() {
	    var e = this.nativeEvent;
	
	    // if preventDefault exists run it on the original event
	    if (e.preventDefault) {
	      e.preventDefault();
	    } else {
	      // otherwise set the returnValue property of the original event to FALSE (IE)
	      e.returnValue = FALSE;
	    }
	
	    EventBaseObjectProto.preventDefault.call(this);
	  },
	
	  stopPropagation: function stopPropagation() {
	    var e = this.nativeEvent;
	
	    // if stopPropagation exists run it on the original event
	    if (e.stopPropagation) {
	      e.stopPropagation();
	    } else {
	      // otherwise set the cancelBubble property of the original event to TRUE (IE)
	      e.cancelBubble = TRUE;
	    }
	
	    EventBaseObjectProto.stopPropagation.call(this);
	  }
	});
	
	exports['default'] = DomEventObject;
	module.exports = exports['default'];

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', {
	  value: true
	});
	exports['default'] = addEventListener;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var _EventObject = __webpack_require__(1222);
	
	var _EventObject2 = _interopRequireDefault(_EventObject);
	
	function addEventListener(target, eventType, callback, option) {
	  function wrapCallback(e) {
	    var ne = new _EventObject2['default'](e);
	    callback.call(target, ne);
	  }
	
	  if (target.addEventListener) {
	    var _ret = (function () {
	      var useCapture = false;
	      if (typeof option === 'object') {
	        useCapture = option.capture || false;
	      } else if (typeof option === 'boolean') {
	        useCapture = option;
	      }
	
	      target.addEventListener(eventType, wrapCallback, option || false);
	
	      return {
	        v: {
	          remove: function remove() {
	            target.removeEventListener(eventType, wrapCallback, useCapture);
	          }
	        }
	      };
	    })();
	
	    if (typeof _ret === 'object') return _ret.v;
	  } else if (target.attachEvent) {
	    target.attachEvent('on' + eventType, wrapCallback);
	    return {
	      remove: function remove() {
	        target.detachEvent('on' + eventType, wrapCallback);
	      }
	    };
	  }
	}
	
	module.exports = exports['default'];

/***/ },
/* 1224 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.easeInOutCubic = easeInOutCubic;
	
	// eslint-disable-next-line import/prefer-default-export
	function easeInOutCubic(t, b, c, d) {
	  var cc = c - b;
	  t /= d / 2;
	
	  if (t < 1) {
	    return cc / 2 * t * t * t + b;
	  }
	
	  return cc / 2 * ((t -= 2) * t * t + 2) + b;
	}

/***/ },
/* 1225 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var isNumeric = function isNumeric(value) {
	  return !isNaN(parseFloat(value)) && isFinite(value);
	};
	
	var _default = isNumeric;
	exports["default"] = _default;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _cssAnimation = _interopRequireDefault(__webpack_require__(487));
	
	var _raf = _interopRequireDefault(__webpack_require__(127));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	/**
	 * Deprecated. We should replace the animation with pure react motion instead of modify style directly.
	 * If you are creating new component with animation, please use `./motion`.
	 */
	function animate(node, show, done) {
	  var height;
	  var requestAnimationFrameId;
	  return (0, _cssAnimation["default"])(node, 'ant-motion-collapse-legacy', {
	    start: function start() {
	      if (!show) {
	        node.style.height = "".concat(node.offsetHeight, "px");
	        node.style.opacity = '1';
	      } else {
	        height = node.offsetHeight;
	        node.style.height = '0px';
	        node.style.opacity = '0';
	      }
	    },
	    active: function active() {
	      if (requestAnimationFrameId) {
	        _raf["default"].cancel(requestAnimationFrameId);
	      }
	
	      requestAnimationFrameId = (0, _raf["default"])(function () {
	        node.style.height = "".concat(show ? height : 0, "px");
	        node.style.opacity = show ? '1' : '0';
	      });
	    },
	    end: function end() {
	      if (requestAnimationFrameId) {
	        _raf["default"].cancel(requestAnimationFrameId);
	      }
	
	      node.style.height = '';
	      node.style.opacity = '';
	      done();
	    }
	  });
	}
	
	var animation = {
	  enter: function enter(node, done) {
	    return animate(node, true, done);
	  },
	  leave: function leave(node, done) {
	    return animate(node, false, done);
	  },
	  appear: function appear(node, done) {
	    return animate(node, true, done);
	  }
	};
	var _default = animation;
	exports["default"] = _default;

/***/ },
/* 1227 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fillRef = fillRef;
	exports.composeRef = composeRef;
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function fillRef(ref, node) {
	  if (typeof ref === 'function') {
	    ref(node);
	  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
	    ref.current = node;
	  }
	}
	
	function composeRef() {
	  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
	    refs[_key] = arguments[_key];
	  }
	
	  return function (node) {
	    refs.forEach(function (ref) {
	      fillRef(ref, node);
	    });
	  };
	}

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = throttleByAnimationFrame;
	exports.throttleByAnimationFrameDecorator = throttleByAnimationFrameDecorator;
	
	var _raf = _interopRequireDefault(__webpack_require__(127));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function throttleByAnimationFrame(fn) {
	  var requestId;
	
	  var later = function later(args) {
	    return function () {
	      requestId = null;
	      fn.apply(void 0, _toConsumableArray(args));
	    };
	  };
	
	  var throttled = function throttled() {
	    if (requestId == null) {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      requestId = (0, _raf["default"])(later(args));
	    }
	  };
	
	  throttled.cancel = function () {
	    return _raf["default"].cancel(requestId);
	  };
	
	  return throttled;
	}
	
	function throttleByAnimationFrameDecorator() {
	  // eslint-disable-next-line func-names
	  return function (target, key, descriptor) {
	    var fn = descriptor.value;
	    var definingProperty = false;
	    return {
	      configurable: true,
	      get: function get() {
	        // eslint-disable-next-line no-prototype-builtins
	        if (definingProperty || this === target.prototype || this.hasOwnProperty(key)) {
	          return fn;
	        }
	
	        var boundFn = throttleByAnimationFrame(fn.bind(this));
	        definingProperty = true;
	        Object.defineProperty(this, key, {
	          value: boundFn,
	          configurable: true,
	          writable: true
	        });
	        definingProperty = false;
	        return boundFn;
	      }
	    };
	  };
	}

/***/ },
/* 1229 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = triggerEvent;
	
	function triggerEvent(el, type) {
	  if ('createEvent' in document) {
	    // modern browsers, IE9+
	    var e = document.createEvent('HTMLEvents');
	    e.initEvent(type, false, true);
	    el.dispatchEvent(e);
	  }
	}

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTargetRect = getTargetRect;
	exports.getFixedTop = getFixedTop;
	exports.getFixedBottom = getFixedBottom;
	exports.getObserverEntities = getObserverEntities;
	exports.addObserveTarget = addObserveTarget;
	exports.removeObserveTarget = removeObserveTarget;
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(145));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function getTargetRect(target) {
	  return target !== window ? target.getBoundingClientRect() : {
	    top: 0,
	    bottom: window.innerHeight
	  };
	}
	
	function getFixedTop(placeholderReact, targetRect, offsetTop) {
	  if (offsetTop !== undefined && targetRect.top > placeholderReact.top - offsetTop) {
	    return offsetTop + targetRect.top;
	  }
	
	  return undefined;
	}
	
	function getFixedBottom(placeholderReact, targetRect, offsetBottom) {
	  if (offsetBottom !== undefined && targetRect.bottom < placeholderReact.bottom + offsetBottom) {
	    var targetBottomOffset = window.innerHeight - targetRect.bottom;
	    return offsetBottom + targetBottomOffset;
	  }
	
	  return undefined;
	} // ======================== Observer ========================
	
	
	var TRIGGER_EVENTS = ['resize', 'scroll', 'touchstart', 'touchmove', 'touchend', 'pageshow', 'load'];
	var observerEntities = [];
	
	function getObserverEntities() {
	  // Only used in test env. Can be removed if refactor.
	  return observerEntities;
	}
	
	function addObserveTarget(target, affix) {
	  if (!target) return;
	  var entity = observerEntities.find(function (item) {
	    return item.target === target;
	  });
	
	  if (entity) {
	    entity.affixList.push(affix);
	  } else {
	    entity = {
	      target: target,
	      affixList: [affix],
	      eventHandlers: {}
	    };
	    observerEntities.push(entity); // Add listener
	
	    TRIGGER_EVENTS.forEach(function (eventName) {
	      entity.eventHandlers[eventName] = (0, _addEventListener["default"])(target, eventName, function () {
	        entity.affixList.forEach(function (targetAffix) {
	          targetAffix.lazyUpdatePosition();
	        });
	      });
	    });
	  }
	}
	
	function removeObserveTarget(affix) {
	  var observerEntity = observerEntities.find(function (oriObserverEntity) {
	    var hasAffix = oriObserverEntity.affixList.some(function (item) {
	      return item === affix;
	    });
	
	    if (hasAffix) {
	      oriObserverEntity.affixList = oriObserverEntity.affixList.filter(function (item) {
	        return item !== affix;
	      });
	    }
	
	    return hasAffix;
	  });
	
	  if (observerEntity && observerEntity.affixList.length === 0) {
	    observerEntities = observerEntities.filter(function (item) {
	      return item !== observerEntity;
	    }); // Remove listener
	
	    TRIGGER_EVENTS.forEach(function (eventName) {
	      var handler = observerEntity.eventHandlers[eventName];
	
	      if (handler && handler.remove) {
	        handler.remove();
	      }
	    });
	  }
	}

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(111));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(612));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function noop() {}
	
	var Alert = /*#__PURE__*/function (_React$Component) {
	  _inherits(Alert, _React$Component);
	
	  var _super = _createSuper(Alert);
	
	  function Alert(props) {
	    var _this;
	
	    _classCallCheck(this, Alert);
	
	    _this = _super.call(this, props);
	
	    _this.handleClose = function (e) {
	      e.preventDefault();
	      var dom = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      dom.style.height = "".concat(dom.offsetHeight, "px"); // Magic code
	      // 重复一次后才能正确设置 height
	
	      dom.style.height = "".concat(dom.offsetHeight, "px");
	
	      _this.setState({
	        closing: true
	      });
	
	      (_this.props.onClose || noop)(e);
	    };
	
	    _this.animationEnd = function () {
	      _this.setState({
	        closing: false,
	        closed: true
	      });
	
	      (_this.props.afterClose || noop)();
	    };
	
	    _this.renderAlert = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          description = _this$props.description,
	          customizePrefixCls = _this$props.prefixCls,
	          message = _this$props.message,
	          closeText = _this$props.closeText,
	          banner = _this$props.banner,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          style = _this$props.style,
	          icon = _this$props.icon;
	      var _this$props2 = _this.props,
	          closable = _this$props2.closable,
	          type = _this$props2.type,
	          showIcon = _this$props2.showIcon,
	          iconType = _this$props2.iconType;
	      var _this$state = _this.state,
	          closing = _this$state.closing,
	          closed = _this$state.closed;
	      var prefixCls = getPrefixCls('alert', customizePrefixCls); // banner模式默认有 Icon
	
	      showIcon = banner && showIcon === undefined ? true : showIcon; // banner模式默认为警告
	
	      type = banner && type === undefined ? 'warning' : type || 'info';
	      var iconTheme = 'filled';
	
	      if (!iconType) {
	        switch (type) {
	          case 'success':
	            iconType = 'check-circle';
	            break;
	
	          case 'info':
	            iconType = 'info-circle';
	            break;
	
	          case 'error':
	            iconType = 'close-circle';
	            break;
	
	          case 'warning':
	            iconType = 'exclamation-circle';
	            break;
	
	          default:
	            iconType = 'default';
	        } // use outline icon in alert with description
	
	
	        if (description) {
	          iconTheme = 'outlined';
	        }
	      } // closeable when closeText is assigned
	
	
	      if (closeText) {
	        closable = true;
	      }
	
	      var alertCls = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-closing"), closing), _defineProperty(_classNames, "".concat(prefixCls, "-with-description"), !!description), _defineProperty(_classNames, "".concat(prefixCls, "-no-icon"), !showIcon), _defineProperty(_classNames, "".concat(prefixCls, "-banner"), !!banner), _defineProperty(_classNames, "".concat(prefixCls, "-closable"), closable), _classNames), className);
	      var closeIcon = closable ? /*#__PURE__*/React.createElement("button", {
	        type: "button",
	        onClick: _this.handleClose,
	        className: "".concat(prefixCls, "-close-icon"),
	        tabIndex: 0
	      }, closeText ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-close-text")
	      }, closeText) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close"
	      })) : null;
	      var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(_this.props);
	      var iconNode = icon && ( /*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.cloneElement(icon, {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), _defineProperty({}, icon.props.className, icon.props.className))
	      }) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-icon")
	      }, icon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-icon"),
	        type: iconType,
	        theme: iconTheme
	      });
	      return closed ? null : /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	        component: "",
	        showProp: "data-show",
	        transitionName: "".concat(prefixCls, "-slide-up"),
	        onEnd: _this.animationEnd
	      }, /*#__PURE__*/React.createElement("div", _extends({
	        "data-show": !closing,
	        className: alertCls,
	        style: style
	      }, dataOrAriaProps), showIcon ? iconNode : null, /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-message")
	      }, message), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-description")
	      }, description), closeIcon));
	    };
	
	    (0, _warning["default"])(!('iconType' in props), 'Alert', '`iconType` is deprecated. Please use `icon` instead.');
	    _this.state = {
	      closing: false,
	      closed: false
	    };
	    return _this;
	  }
	
	  _createClass(Alert, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAlert);
	    }
	  }]);
	
	  return Alert;
	}(React.Component);
	
	exports["default"] = Alert;

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(145));
	
	var _affix = _interopRequireDefault(__webpack_require__(617));
	
	var _configProvider = __webpack_require__(11);
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(402));
	
	var _getScroll = _interopRequireDefault(__webpack_require__(401));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function getDefaultContainer() {
	  return window;
	}
	
	function getOffsetTop(element, container) {
	  if (!element) {
	    return 0;
	  }
	
	  if (!element.getClientRects().length) {
	    return 0;
	  }
	
	  var rect = element.getBoundingClientRect();
	
	  if (rect.width || rect.height) {
	    if (container === window) {
	      container = element.ownerDocument.documentElement;
	      return rect.top - container.clientTop;
	    }
	
	    return rect.top - container.getBoundingClientRect().top;
	  }
	
	  return rect.top;
	}
	
	var sharpMatcherRegx = /#([^#]+)$/;
	
	var Anchor = /*#__PURE__*/function (_React$Component) {
	  _inherits(Anchor, _React$Component);
	
	  var _super = _createSuper(Anchor);
	
	  function Anchor() {
	    var _this;
	
	    _classCallCheck(this, Anchor);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      activeLink: null
	    };
	    _this.links = [];
	
	    _this.handleScrollTo = function (link) {
	      var _this$props = _this.props,
	          offsetTop = _this$props.offsetTop,
	          getContainer = _this$props.getContainer,
	          targetOffset = _this$props.targetOffset;
	
	      _this.setCurrentActiveLink(link);
	
	      var container = getContainer();
	      var scrollTop = (0, _getScroll["default"])(container, true);
	      var sharpLinkMatch = sharpMatcherRegx.exec(link);
	
	      if (!sharpLinkMatch) {
	        return;
	      }
	
	      var targetElement = document.getElementById(sharpLinkMatch[1]);
	
	      if (!targetElement) {
	        return;
	      }
	
	      var eleOffsetTop = getOffsetTop(targetElement, container);
	      var y = scrollTop + eleOffsetTop;
	      y -= targetOffset !== undefined ? targetOffset : offsetTop || 0;
	      _this.animating = true;
	      (0, _scrollTo["default"])(y, {
	        callback: function callback() {
	          _this.animating = false;
	        },
	        getContainer: getContainer
	      });
	    };
	
	    _this.saveInkNode = function (node) {
	      _this.inkNode = node;
	    };
	
	    _this.setCurrentActiveLink = function (link) {
	      var activeLink = _this.state.activeLink;
	      var onChange = _this.props.onChange;
	
	      if (activeLink !== link) {
	        _this.setState({
	          activeLink: link
	        });
	
	        if (onChange) {
	          onChange(link);
	        }
	      }
	    };
	
	    _this.handleScroll = function () {
	      if (_this.animating) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          offsetTop = _this$props2.offsetTop,
	          bounds = _this$props2.bounds,
	          targetOffset = _this$props2.targetOffset;
	
	      var currentActiveLink = _this.getCurrentAnchor(targetOffset !== undefined ? targetOffset : offsetTop || 0, bounds);
	
	      _this.setCurrentActiveLink(currentActiveLink);
	    };
	
	    _this.updateInk = function () {
	      if (typeof document === 'undefined') {
	        return;
	      }
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      var anchorNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var linkNode = anchorNode.getElementsByClassName("".concat(prefixCls, "-link-title-active"))[0];
	
	      if (linkNode) {
	        _this.inkNode.style.top = "".concat(linkNode.offsetTop + linkNode.clientHeight / 2 - 4.5, "px");
	      }
	    };
	
	    _this.renderAnchor = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props3 = _this.props,
	          customizePrefixCls = _this$props3.prefixCls,
	          _this$props3$classNam = _this$props3.className,
	          className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam,
	          style = _this$props3.style,
	          offsetTop = _this$props3.offsetTop,
	          affix = _this$props3.affix,
	          showInkInFixed = _this$props3.showInkInFixed,
	          children = _this$props3.children,
	          getContainer = _this$props3.getContainer;
	      var activeLink = _this.state.activeLink;
	      var prefixCls = getPrefixCls('anchor', customizePrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      var inkClass = (0, _classnames["default"])("".concat(prefixCls, "-ink-ball"), {
	        visible: activeLink
	      });
	      var wrapperClass = (0, _classnames["default"])(className, "".concat(prefixCls, "-wrapper"));
	      var anchorClass = (0, _classnames["default"])(prefixCls, {
	        fixed: !affix && !showInkInFixed
	      });
	
	      var wrapperStyle = _extends({
	        maxHeight: offsetTop ? "calc(100vh - ".concat(offsetTop, "px)") : '100vh'
	      }, style);
	
	      var anchorContent = /*#__PURE__*/React.createElement("div", {
	        className: wrapperClass,
	        style: wrapperStyle
	      }, /*#__PURE__*/React.createElement("div", {
	        className: anchorClass
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-ink")
	      }, /*#__PURE__*/React.createElement("span", {
	        className: inkClass,
	        ref: _this.saveInkNode
	      })), children));
	      return !affix ? anchorContent : /*#__PURE__*/React.createElement(_affix["default"], {
	        offsetTop: offsetTop,
	        target: getContainer
	      }, anchorContent);
	    };
	
	    return _this;
	  }
	
	  _createClass(Anchor, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      var _this2 = this;
	
	      var antAnchor = {
	        registerLink: function registerLink(link) {
	          if (!_this2.links.includes(link)) {
	            _this2.links.push(link);
	          }
	        },
	        unregisterLink: function unregisterLink(link) {
	          var index = _this2.links.indexOf(link);
	
	          if (index !== -1) {
	            _this2.links.splice(index, 1);
	          }
	        },
	        activeLink: this.state.activeLink,
	        scrollTo: this.handleScrollTo,
	        onClick: this.props.onClick
	      };
	      return {
	        antAnchor: antAnchor
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var getContainer = this.props.getContainer;
	      this.scrollContainer = getContainer();
	      this.scrollEvent = (0, _addEventListener["default"])(this.scrollContainer, 'scroll', this.handleScroll);
	      this.handleScroll();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if (this.scrollEvent) {
	        var getContainer = this.props.getContainer;
	        var currentContainer = getContainer();
	
	        if (this.scrollContainer !== currentContainer) {
	          this.scrollContainer = currentContainer;
	          this.scrollEvent.remove();
	          this.scrollEvent = (0, _addEventListener["default"])(this.scrollContainer, 'scroll', this.handleScroll);
	          this.handleScroll();
	        }
	      }
	
	      this.updateInk();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.scrollEvent) {
	        this.scrollEvent.remove();
	      }
	    }
	  }, {
	    key: "getCurrentAnchor",
	    value: function getCurrentAnchor() {
	      var offsetTop = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	      var bounds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
	      var getCurrentAnchor = this.props.getCurrentAnchor;
	
	      if (typeof getCurrentAnchor === 'function') {
	        return getCurrentAnchor();
	      }
	
	      var activeLink = '';
	
	      if (typeof document === 'undefined') {
	        return activeLink;
	      }
	
	      var linkSections = [];
	      var getContainer = this.props.getContainer;
	      var container = getContainer();
	      this.links.forEach(function (link) {
	        var sharpLinkMatch = sharpMatcherRegx.exec(link.toString());
	
	        if (!sharpLinkMatch) {
	          return;
	        }
	
	        var target = document.getElementById(sharpLinkMatch[1]);
	
	        if (target) {
	          var top = getOffsetTop(target, container);
	
	          if (top < offsetTop + bounds) {
	            linkSections.push({
	              link: link,
	              top: top
	            });
	          }
	        }
	      });
	
	      if (linkSections.length) {
	        var maxSection = linkSections.reduce(function (prev, curr) {
	          return curr.top > prev.top ? curr : prev;
	        });
	        return maxSection.link;
	      }
	
	      return '';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAnchor);
	    }
	  }]);
	
	  return Anchor;
	}(React.Component);
	
	exports["default"] = Anchor;
	Anchor.defaultProps = {
	  affix: true,
	  showInkInFixed: false,
	  getContainer: getDefaultContainer
	};
	Anchor.childContextTypes = {
	  antAnchor: PropTypes.object
	};

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var AnchorLink = /*#__PURE__*/function (_React$Component) {
	  _inherits(AnchorLink, _React$Component);
	
	  var _super = _createSuper(AnchorLink);
	
	  function AnchorLink() {
	    var _this;
	
	    _classCallCheck(this, AnchorLink);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleClick = function (e) {
	      var _this$context$antAnch = _this.context.antAnchor,
	          scrollTo = _this$context$antAnch.scrollTo,
	          onClick = _this$context$antAnch.onClick;
	      var _this$props = _this.props,
	          href = _this$props.href,
	          title = _this$props.title;
	
	      if (onClick) {
	        onClick(e, {
	          title: title,
	          href: href
	        });
	      }
	
	      scrollTo(href);
	    };
	
	    _this.renderAnchorLink = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          href = _this$props2.href,
	          title = _this$props2.title,
	          children = _this$props2.children,
	          className = _this$props2.className,
	          target = _this$props2.target;
	      var prefixCls = getPrefixCls('anchor', customizePrefixCls);
	      var active = _this.context.antAnchor.activeLink === href;
	      var wrapperClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-link"), _defineProperty({}, "".concat(prefixCls, "-link-active"), active));
	      var titleClassName = (0, _classnames["default"])("".concat(prefixCls, "-link-title"), _defineProperty({}, "".concat(prefixCls, "-link-title-active"), active));
	      return /*#__PURE__*/React.createElement("div", {
	        className: wrapperClassName
	      }, /*#__PURE__*/React.createElement("a", {
	        className: titleClassName,
	        href: href,
	        title: typeof title === 'string' ? title : '',
	        target: target,
	        onClick: _this.handleClick
	      }, title), children);
	    };
	
	    return _this;
	  }
	
	  _createClass(AnchorLink, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.context.antAnchor.registerLink(this.props.href);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_ref2) {
	      var prevHref = _ref2.href;
	      var href = this.props.href;
	
	      if (prevHref !== href) {
	        this.context.antAnchor.unregisterLink(prevHref);
	        this.context.antAnchor.registerLink(href);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.context.antAnchor.unregisterLink(this.props.href);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAnchorLink);
	    }
	  }]);
	
	  return AnchorLink;
	}(React.Component);
	
	AnchorLink.defaultProps = {
	  href: '#'
	};
	AnchorLink.contextTypes = {
	  antAnchor: PropTypes.object
	};
	(0, _reactLifecyclesCompat.polyfill)(AnchorLink);
	var _default = AnchorLink;
	exports["default"] = _default;

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Anchor = _interopRequireDefault(__webpack_require__(1232));
	
	var _AnchorLink = _interopRequireDefault(__webpack_require__(1233));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_Anchor["default"].Link = _AnchorLink["default"];
	var _default = _Anchor["default"];
	exports["default"] = _default;

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var InputElement = /*#__PURE__*/function (_React$Component) {
	  _inherits(InputElement, _React$Component);
	
	  var _super = _createSuper(InputElement);
	
	  function InputElement() {
	    var _this;
	
	    _classCallCheck(this, InputElement);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveRef = function (ele) {
	      var childRef = _this.props.children.ref;
	
	      if (typeof childRef === 'function') {
	        childRef(ele);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(InputElement, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.cloneElement(this.props.children, _extends(_extends({}, this.props), {
	        ref: this.saveRef
	      }), null);
	    }
	  }]);
	
	  return InputElement;
	}(React.Component);
	
	exports["default"] = InputElement;

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcSelect = __webpack_require__(1102);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _InputElement = _interopRequireDefault(__webpack_require__(1235));
	
	var _input = _interopRequireDefault(__webpack_require__(319));
	
	var _select = _interopRequireDefault(__webpack_require__(270));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function isSelectOptionOrSelectOptGroup(child) {
	  return child && child.type && (child.type.isSelectOption || child.type.isSelectOptGroup);
	}
	
	var AutoComplete = /*#__PURE__*/function (_React$Component) {
	  _inherits(AutoComplete, _React$Component);
	
	  var _super = _createSuper(AutoComplete);
	
	  function AutoComplete() {
	    var _this;
	
	    _classCallCheck(this, AutoComplete);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveSelect = function (node) {
	      _this.select = node;
	    };
	
	    _this.getInputElement = function () {
	      var children = _this.props.children;
	      var element = children && /*#__PURE__*/React.isValidElement(children) && children.type !== _rcSelect.Option ? React.Children.only(_this.props.children) : /*#__PURE__*/React.createElement(_input["default"], null);
	
	      var elementProps = _extends({}, element.props); // https://github.com/ant-design/ant-design/pull/7742
	
	
	      delete elementProps.children;
	      return /*#__PURE__*/React.createElement(_InputElement["default"], elementProps, element);
	    };
	
	    _this.renderAutoComplete = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          size = _this$props.size,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          notFoundContent = _this$props.notFoundContent,
	          optionLabelProp = _this$props.optionLabelProp,
	          dataSource = _this$props.dataSource,
	          children = _this$props.children;
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, "".concat(prefixCls, "-show-search"), true), _defineProperty(_classNames, "".concat(prefixCls, "-auto-complete"), true), _classNames));
	      var options;
	      var childArray = React.Children.toArray(children);
	
	      if (childArray.length && isSelectOptionOrSelectOptGroup(childArray[0])) {
	        options = children;
	      } else {
	        options = dataSource ? dataSource.map(function (item) {
	          if ( /*#__PURE__*/React.isValidElement(item)) {
	            return item;
	          }
	
	          switch (_typeof(item)) {
	            case 'string':
	              return /*#__PURE__*/React.createElement(_rcSelect.Option, {
	                key: item
	              }, item);
	
	            case 'object':
	              return /*#__PURE__*/React.createElement(_rcSelect.Option, {
	                key: item.value
	              }, item.text);
	
	            default:
	              throw new Error('AutoComplete[dataSource] only supports type `string[] | Object[]`.');
	          }
	        }) : [];
	      }
	
	      return /*#__PURE__*/React.createElement(_select["default"], _extends({}, _this.props, {
	        className: cls,
	        mode: _select["default"].SECRET_COMBOBOX_MODE_DO_NOT_USE,
	        optionLabelProp: optionLabelProp,
	        getInputElement: _this.getInputElement,
	        notFoundContent: notFoundContent,
	        ref: _this.saveSelect
	      }), options);
	    };
	
	    return _this;
	  }
	
	  _createClass(AutoComplete, [{
	    key: "focus",
	    value: function focus() {
	      this.select.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.select.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderAutoComplete);
	    }
	  }]);
	
	  return AutoComplete;
	}(React.Component);
	
	exports["default"] = AutoComplete;
	AutoComplete.Option = _rcSelect.Option;
	AutoComplete.OptGroup = _rcSelect.OptGroup;
	AutoComplete.defaultProps = {
	  transitionName: 'slide-up',
	  optionLabelProp: 'children',
	  choiceTransitionName: 'zoom',
	  showSearch: false,
	  filterOption: false
	};

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(111));
	
	var _addEventListener = _interopRequireDefault(__webpack_require__(145));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _configProvider = __webpack_require__(11);
	
	var _getScroll = _interopRequireDefault(__webpack_require__(401));
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(402));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function getDefaultTarget() {
	  return window;
	}
	
	var BackTop = /*#__PURE__*/function (_React$Component) {
	  _inherits(BackTop, _React$Component);
	
	  var _super = _createSuper(BackTop);
	
	  function BackTop(props) {
	    var _this;
	
	    _classCallCheck(this, BackTop);
	
	    _this = _super.call(this, props);
	
	    _this.scrollToTop = function (e) {
	      var _this$props = _this.props,
	          _this$props$target = _this$props.target,
	          target = _this$props$target === void 0 ? getDefaultTarget : _this$props$target,
	          onClick = _this$props.onClick;
	      (0, _scrollTo["default"])(0, {
	        getContainer: target
	      });
	
	      if (typeof onClick === 'function') {
	        onClick(e);
	      }
	    };
	
	    _this.handleScroll = function () {
	      var _this$props2 = _this.props,
	          visibilityHeight = _this$props2.visibilityHeight,
	          _this$props2$target = _this$props2.target,
	          target = _this$props2$target === void 0 ? getDefaultTarget : _this$props2$target;
	      var scrollTop = (0, _getScroll["default"])(target(), true);
	
	      _this.setState({
	        visible: scrollTop > visibilityHeight
	      });
	    };
	
	    _this.renderBackTop = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props3 = _this.props,
	          customizePrefixCls = _this$props3.prefixCls,
	          _this$props3$classNam = _this$props3.className,
	          className = _this$props3$classNam === void 0 ? '' : _this$props3$classNam,
	          children = _this$props3.children;
	      var prefixCls = getPrefixCls('back-top', customizePrefixCls);
	      var classString = (0, _classnames["default"])(prefixCls, className);
	      var defaultElement = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-icon")
	      })); // fix https://fb.me/react-unknown-prop
	
	      var divProps = (0, _omit["default"])(_this.props, ['prefixCls', 'className', 'children', 'visibilityHeight', 'target', 'visible']);
	      var visible = 'visible' in _this.props ? _this.props.visible : _this.state.visible;
	      var backTopBtn = visible ? /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	        className: classString,
	        onClick: _this.scrollToTop
	      }), children || defaultElement) : null;
	      return /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	        component: "",
	        transitionName: "fade"
	      }, backTopBtn);
	    };
	
	    _this.state = {
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(BackTop, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var getTarget = this.props.target || getDefaultTarget;
	      this.scrollEvent = (0, _addEventListener["default"])(getTarget(), 'scroll', this.handleScroll);
	      this.handleScroll();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.scrollEvent) {
	        this.scrollEvent.remove();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBackTop);
	    }
	  }]);
	
	  return BackTop;
	}(React.Component);
	
	exports["default"] = BackTop;
	BackTop.defaultProps = {
	  visibilityHeight: 400
	};

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function getNumberArray(num) {
	  return num ? num.toString().split('').reverse().map(function (i) {
	    var current = Number(i);
	    return isNaN(current) ? i : current;
	  }) : [];
	}
	
	function renderNumberList(position, className) {
	  var childrenToReturn = [];
	
	  for (var i = 0; i < 30; i++) {
	    childrenToReturn.push( /*#__PURE__*/React.createElement("p", {
	      key: i.toString(),
	      className: (0, _classnames["default"])(className, {
	        current: position === i
	      })
	    }, i % 10));
	  }
	
	  return childrenToReturn;
	}
	
	var ScrollNumber = /*#__PURE__*/function (_React$Component) {
	  _inherits(ScrollNumber, _React$Component);
	
	  var _super = _createSuper(ScrollNumber);
	
	  function ScrollNumber(props) {
	    var _this;
	
	    _classCallCheck(this, ScrollNumber);
	
	    _this = _super.call(this, props);
	
	    _this.onAnimated = function () {
	      var onAnimated = _this.props.onAnimated;
	
	      if (onAnimated) {
	        onAnimated();
	      }
	    };
	
	    _this.renderScrollNumber = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          style = _this$props.style,
	          title = _this$props.title,
	          _this$props$component = _this$props.component,
	          component = _this$props$component === void 0 ? 'sup' : _this$props$component,
	          displayComponent = _this$props.displayComponent; // fix https://fb.me/react-unknown-prop
	
	      var restProps = (0, _omit["default"])(_this.props, ['count', 'onAnimated', 'component', 'prefixCls', 'displayComponent']);
	      var prefixCls = getPrefixCls('scroll-number', customizePrefixCls);
	
	      var newProps = _extends(_extends({}, restProps), {
	        className: (0, _classnames["default"])(prefixCls, className),
	        title: title
	      }); // allow specify the border
	      // mock border-color by box-shadow for compatible with old usage:
	      // <Badge count={4} style={{ backgroundColor: '#fff', color: '#999', borderColor: '#d9d9d9' }} />
	
	
	      if (style && style.borderColor) {
	        newProps.style = _extends(_extends({}, style), {
	          boxShadow: "0 0 0 1px ".concat(style.borderColor, " inset")
	        });
	      }
	
	      if (displayComponent) {
	        return /*#__PURE__*/React.cloneElement(displayComponent, {
	          className: (0, _classnames["default"])("".concat(prefixCls, "-custom-component"), displayComponent.props && displayComponent.props.className)
	        });
	      }
	
	      return /*#__PURE__*/React.createElement(component, newProps, _this.renderNumberElement(prefixCls));
	    };
	
	    _this.state = {
	      animateStarted: true,
	      count: props.count
	    };
	    return _this;
	  }
	
	  _createClass(ScrollNumber, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      var _this2 = this;
	
	      this.lastCount = prevState.count;
	      var animateStarted = this.state.animateStarted;
	
	      if (animateStarted) {
	        this.clearTimeout(); // Let browser has time to reset the scroller before actually
	        // performing the transition.
	
	        this.timeout = setTimeout(function () {
	          // eslint-disable-next-line react/no-did-update-set-state
	          _this2.setState(function (__, props) {
	            return {
	              animateStarted: false,
	              count: props.count
	            };
	          }, _this2.onAnimated);
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearTimeout();
	    }
	  }, {
	    key: "getPositionByNum",
	    value: function getPositionByNum(num, i) {
	      var count = this.state.count;
	      var currentCount = Math.abs(Number(count));
	      var lastCount = Math.abs(Number(this.lastCount));
	      var currentDigit = Math.abs(getNumberArray(this.state.count)[i]);
	      var lastDigit = Math.abs(getNumberArray(this.lastCount)[i]);
	
	      if (this.state.animateStarted) {
	        return 10 + num;
	      } // 同方向则在同一侧切换数字
	
	
	      if (currentCount > lastCount) {
	        if (currentDigit >= lastDigit) {
	          return 10 + num;
	        }
	
	        return 20 + num;
	      }
	
	      if (currentDigit <= lastDigit) {
	        return 10 + num;
	      }
	
	      return num;
	    }
	  }, {
	    key: "renderCurrentNumber",
	    value: function renderCurrentNumber(prefixCls, num, i) {
	      if (typeof num === 'number') {
	        var position = this.getPositionByNum(num, i);
	        var removeTransition = this.state.animateStarted || getNumberArray(this.lastCount)[i] === undefined;
	        return /*#__PURE__*/React.createElement('span', {
	          className: "".concat(prefixCls, "-only"),
	          style: {
	            transition: removeTransition ? 'none' : undefined,
	            msTransform: "translateY(".concat(-position * 100, "%)"),
	            WebkitTransform: "translateY(".concat(-position * 100, "%)"),
	            transform: "translateY(".concat(-position * 100, "%)")
	          },
	          key: i
	        }, renderNumberList(position, "".concat(prefixCls, "-only-unit")));
	      }
	
	      return /*#__PURE__*/React.createElement("span", {
	        key: "symbol",
	        className: "".concat(prefixCls, "-symbol")
	      }, num);
	    }
	  }, {
	    key: "renderNumberElement",
	    value: function renderNumberElement(prefixCls) {
	      var _this3 = this;
	
	      var count = this.state.count;
	
	      if (count && Number(count) % 1 === 0) {
	        return getNumberArray(count).map(function (num, i) {
	          return _this3.renderCurrentNumber(prefixCls, num, i);
	        }).reverse();
	      }
	
	      return count;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderScrollNumber);
	    }
	  }, {
	    key: "clearTimeout",
	    value: function (_clearTimeout) {
	      function clearTimeout() {
	        return _clearTimeout.apply(this, arguments);
	      }
	
	      clearTimeout.toString = function () {
	        return _clearTimeout.toString();
	      };
	
	      return clearTimeout;
	    }(function () {
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = undefined;
	      }
	    })
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, nextState) {
	      if ('count' in nextProps) {
	        if (nextState.count === nextProps.count) {
	          return null;
	        }
	
	        return {
	          animateStarted: true
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return ScrollNumber;
	}(React.Component);
	
	ScrollNumber.defaultProps = {
	  count: null,
	  onAnimated: function onAnimated() {}
	};
	(0, _reactLifecyclesCompat.polyfill)(ScrollNumber);
	var _default = ScrollNumber;
	exports["default"] = _default;

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(111));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _ScrollNumber = _interopRequireDefault(__webpack_require__(1238));
	
	var _colors = __webpack_require__(611);
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function isPresetColor(color) {
	  return _colors.PresetColorTypes.indexOf(color) !== -1;
	}
	
	var Badge = /*#__PURE__*/function (_React$Component) {
	  _inherits(Badge, _React$Component);
	
	  var _super = _createSuper(Badge);
	
	  function Badge() {
	    var _this;
	
	    _classCallCheck(this, Badge);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderBadge = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeScrollNumberPrefixCls = _a.scrollNumberPrefixCls,
	          children = _a.children,
	          status = _a.status,
	          text = _a.text,
	          color = _a.color,
	          restProps = __rest(_a, ["prefixCls", "scrollNumberPrefixCls", "children", "status", "text", "color"]);
	
	      var omitArr = ['count', 'showZero', 'overflowCount', 'className', 'style', 'dot', 'offset', 'title'];
	      var prefixCls = getPrefixCls('badge', customizePrefixCls);
	      var scrollNumberPrefixCls = getPrefixCls('scroll-number', customizeScrollNumberPrefixCls);
	
	      var scrollNumber = _this.renderBadgeNumber(prefixCls, scrollNumberPrefixCls);
	
	      var statusText = _this.renderStatusText(prefixCls);
	
	      var statusCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-status-dot"), _this.hasStatus()), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(status), !!status), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(color), isPresetColor(color)), _classNames));
	      var statusStyle = {};
	
	      if (color && !isPresetColor(color)) {
	        statusStyle.background = color;
	      } // <Badge status="success" />
	
	
	      if (!children && _this.hasStatus()) {
	        var styleWithOffset = _this.getStyleWithOffset();
	
	        var statusTextColor = styleWithOffset && styleWithOffset.color;
	        return /*#__PURE__*/React.createElement("span", _extends({}, (0, _omit["default"])(restProps, omitArr), {
	          className: _this.getBadgeClassName(prefixCls),
	          style: styleWithOffset
	        }), /*#__PURE__*/React.createElement("span", {
	          className: statusCls,
	          style: statusStyle
	        }), /*#__PURE__*/React.createElement("span", {
	          style: {
	            color: statusTextColor
	          },
	          className: "".concat(prefixCls, "-status-text")
	        }, text));
	      }
	
	      return /*#__PURE__*/React.createElement("span", _extends({}, (0, _omit["default"])(restProps, omitArr), {
	        className: _this.getBadgeClassName(prefixCls)
	      }), children, /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	        component: "",
	        showProp: "data-show",
	        transitionName: children ? "".concat(prefixCls, "-zoom") : '',
	        transitionAppear: true
	      }, scrollNumber), statusText);
	    };
	
	    return _this;
	  }
	
	  _createClass(Badge, [{
	    key: "getNumberedDispayCount",
	    value: function getNumberedDispayCount() {
	      var _this$props = this.props,
	          count = _this$props.count,
	          overflowCount = _this$props.overflowCount;
	      var displayCount = count > overflowCount ? "".concat(overflowCount, "+") : count;
	      return displayCount;
	    }
	  }, {
	    key: "getDispayCount",
	    value: function getDispayCount() {
	      var isDot = this.isDot(); // dot mode don't need count
	
	      if (isDot) {
	        return '';
	      }
	
	      return this.getNumberedDispayCount();
	    }
	  }, {
	    key: "getScrollNumberTitle",
	    value: function getScrollNumberTitle() {
	      var _this$props2 = this.props,
	          title = _this$props2.title,
	          count = _this$props2.count;
	
	      if (title) {
	        return title;
	      }
	
	      return typeof count === 'string' || typeof count === 'number' ? count : undefined;
	    }
	  }, {
	    key: "getStyleWithOffset",
	    value: function getStyleWithOffset() {
	      var _this$props3 = this.props,
	          offset = _this$props3.offset,
	          style = _this$props3.style;
	      return offset ? _extends({
	        right: -parseInt(offset[0], 10),
	        marginTop: offset[1]
	      }, style) : style;
	    }
	  }, {
	    key: "getBadgeClassName",
	    value: function getBadgeClassName(prefixCls) {
	      var _classNames2;
	
	      var _this$props4 = this.props,
	          className = _this$props4.className,
	          children = _this$props4.children;
	      return (0, _classnames["default"])(className, prefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-status"), this.hasStatus()), _defineProperty(_classNames2, "".concat(prefixCls, "-not-a-wrapper"), !children), _classNames2));
	    }
	  }, {
	    key: "hasStatus",
	    value: function hasStatus() {
	      var _this$props5 = this.props,
	          status = _this$props5.status,
	          color = _this$props5.color;
	      return !!status || !!color;
	    }
	  }, {
	    key: "isZero",
	    value: function isZero() {
	      var numberedDispayCount = this.getNumberedDispayCount();
	      return numberedDispayCount === '0' || numberedDispayCount === 0;
	    }
	  }, {
	    key: "isDot",
	    value: function isDot() {
	      var dot = this.props.dot;
	      var isZero = this.isZero();
	      return dot && !isZero || this.hasStatus();
	    }
	  }, {
	    key: "isHidden",
	    value: function isHidden() {
	      var showZero = this.props.showZero;
	      var displayCount = this.getDispayCount();
	      var isZero = this.isZero();
	      var isDot = this.isDot();
	      var isEmpty = displayCount === null || displayCount === undefined || displayCount === '';
	      return (isEmpty || isZero && !showZero) && !isDot;
	    }
	  }, {
	    key: "renderStatusText",
	    value: function renderStatusText(prefixCls) {
	      var text = this.props.text;
	      var hidden = this.isHidden();
	      return hidden || !text ? null : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-status-text")
	      }, text);
	    }
	  }, {
	    key: "renderDispayComponent",
	    value: function renderDispayComponent() {
	      var count = this.props.count;
	      var customNode = count;
	
	      if (!customNode || _typeof(customNode) !== 'object') {
	        return undefined;
	      }
	
	      return /*#__PURE__*/React.cloneElement(customNode, {
	        style: _extends(_extends({}, this.getStyleWithOffset()), customNode.props && customNode.props.style)
	      });
	    }
	  }, {
	    key: "renderBadgeNumber",
	    value: function renderBadgeNumber(prefixCls, scrollNumberPrefixCls) {
	      var _classNames3;
	
	      var _this$props6 = this.props,
	          status = _this$props6.status,
	          count = _this$props6.count,
	          color = _this$props6.color;
	      var displayCount = this.getDispayCount();
	      var isDot = this.isDot();
	      var hidden = this.isHidden();
	      var scrollNumberCls = (0, _classnames["default"])((_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-dot"), isDot), _defineProperty(_classNames3, "".concat(prefixCls, "-count"), !isDot), _defineProperty(_classNames3, "".concat(prefixCls, "-multiple-words"), !isDot && count && count.toString && count.toString().length > 1), _defineProperty(_classNames3, "".concat(prefixCls, "-status-").concat(status), !!status), _defineProperty(_classNames3, "".concat(prefixCls, "-status-").concat(color), isPresetColor(color)), _classNames3));
	      var statusStyle = this.getStyleWithOffset();
	
	      if (color && !isPresetColor(color)) {
	        statusStyle = statusStyle || {};
	        statusStyle.background = color;
	      }
	
	      return hidden ? null : /*#__PURE__*/React.createElement(_ScrollNumber["default"], {
	        prefixCls: scrollNumberPrefixCls,
	        "data-show": !hidden,
	        className: scrollNumberCls,
	        count: displayCount,
	        displayComponent: this.renderDispayComponent() // <Badge status="success" count={<Icon type="xxx" />}></Badge>
	        ,
	        title: this.getScrollNumberTitle(),
	        style: statusStyle,
	        key: "scrollNumber"
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBadge);
	    }
	  }]);
	
	  return Badge;
	}(React.Component);
	
	exports["default"] = Badge;
	Badge.defaultProps = {
	  count: null,
	  showZero: false,
	  dot: false,
	  overflowCount: 99
	};
	Badge.propTypes = {
	  count: PropTypes.node,
	  showZero: PropTypes.bool,
	  dot: PropTypes.bool,
	  overflowCount: PropTypes.number
	};

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _toArray = _interopRequireDefault(__webpack_require__(112));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _BreadcrumbItem = _interopRequireDefault(__webpack_require__(619));
	
	var _menu = _interopRequireDefault(__webpack_require__(410));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getBreadcrumbName(route, params) {
	  if (!route.breadcrumbName) {
	    return null;
	  }
	
	  var paramsKeys = Object.keys(params).join('|');
	  var name = route.breadcrumbName.replace(new RegExp(":(".concat(paramsKeys, ")"), 'g'), function (replacement, key) {
	    return params[key] || replacement;
	  });
	  return name;
	}
	
	function defaultItemRender(route, params, routes, paths) {
	  var isLastItem = routes.indexOf(route) === routes.length - 1;
	  var name = getBreadcrumbName(route, params);
	  return isLastItem ? /*#__PURE__*/React.createElement("span", null, name) : /*#__PURE__*/React.createElement("a", {
	    href: "#/".concat(paths.join('/'))
	  }, name);
	}
	
	function filterFragment(children) {
	  return (0, _toArray["default"])(children).map(function (element) {
	    if ( /*#__PURE__*/React.isValidElement(element) && element.type === React.Fragment) {
	      var props = element.props;
	      return props.children;
	    }
	
	    return element;
	  });
	}
	
	var Breadcrumb = /*#__PURE__*/function (_React$Component) {
	  _inherits(Breadcrumb, _React$Component);
	
	  var _super = _createSuper(Breadcrumb);
	
	  function Breadcrumb() {
	    var _this;
	
	    _classCallCheck(this, Breadcrumb);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getPath = function (path, params) {
	      path = (path || '').replace(/^\//, '');
	      Object.keys(params).forEach(function (key) {
	        path = path.replace(":".concat(key), params[key]);
	      });
	      return path;
	    };
	
	    _this.addChildPath = function (paths) {
	      var childPath = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	      var params = arguments.length > 2 ? arguments[2] : undefined;
	
	      var originalPaths = _toConsumableArray(paths);
	
	      var path = _this.getPath(childPath, params);
	
	      if (path) {
	        originalPaths.push(path);
	      }
	
	      return originalPaths;
	    };
	
	    _this.genForRoutes = function (_ref) {
	      var _ref$routes = _ref.routes,
	          routes = _ref$routes === void 0 ? [] : _ref$routes,
	          _ref$params = _ref.params,
	          params = _ref$params === void 0 ? {} : _ref$params,
	          separator = _ref.separator,
	          _ref$itemRender = _ref.itemRender,
	          itemRender = _ref$itemRender === void 0 ? defaultItemRender : _ref$itemRender;
	      var paths = [];
	      return routes.map(function (route) {
	        var path = _this.getPath(route.path, params);
	
	        if (path) {
	          paths.push(path);
	        } // generated overlay by route.children
	
	
	        var overlay = null;
	
	        if (route.children && route.children.length) {
	          overlay = /*#__PURE__*/React.createElement(_menu["default"], null, route.children.map(function (child) {
	            return /*#__PURE__*/React.createElement(_menu["default"].Item, {
	              key: child.breadcrumbName || child.path
	            }, itemRender(child, params, routes, _this.addChildPath(paths, child.path, params)));
	          }));
	        }
	
	        return /*#__PURE__*/React.createElement(_BreadcrumbItem["default"], {
	          overlay: overlay,
	          separator: separator,
	          key: route.breadcrumbName || path
	        }, itemRender(route, params, routes, paths));
	      });
	    };
	
	    _this.renderBreadcrumb = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	      var crumbs;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          separator = _a.separator,
	          style = _a.style,
	          className = _a.className,
	          routes = _a.routes,
	          children = _a.children,
	          restProps = __rest(_a, ["prefixCls", "separator", "style", "className", "routes", "children"]);
	
	      var prefixCls = getPrefixCls('breadcrumb', customizePrefixCls);
	
	      if (routes && routes.length > 0) {
	        // generated by route
	        crumbs = _this.genForRoutes(_this.props);
	      } else if (children) {
	        crumbs = React.Children.map(filterFragment(children), function (element, index) {
	          if (!element) {
	            return element;
	          }
	
	          (0, _warning["default"])(element.type && (element.type.__ANT_BREADCRUMB_ITEM === true || element.type.__ANT_BREADCRUMB_SEPARATOR === true), 'Breadcrumb', "Only accepts Breadcrumb.Item and Breadcrumb.Separator as it's children");
	          return /*#__PURE__*/React.cloneElement(element, {
	            separator: separator,
	            key: index
	          });
	        });
	      }
	
	      return /*#__PURE__*/React.createElement("div", _extends({
	        className: (0, _classnames["default"])(className, prefixCls),
	        style: style
	      }, (0, _omit["default"])(restProps, ['itemRender', 'params'])), crumbs);
	    };
	
	    return _this;
	  }
	
	  _createClass(Breadcrumb, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var props = this.props;
	      (0, _warning["default"])(!('linkRender' in props || 'nameRender' in props), 'Breadcrumb', '`linkRender` and `nameRender` are removed, please use `itemRender` instead, ' + 'see: https://u.ant.design/item-render.');
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderBreadcrumb);
	    }
	  }]);
	
	  return Breadcrumb;
	}(React.Component);
	
	exports["default"] = Breadcrumb;
	Breadcrumb.defaultProps = {
	  separator: '/'
	};
	Breadcrumb.propTypes = {
	  prefixCls: PropTypes.string,
	  separator: PropTypes.node,
	  routes: PropTypes.array
	};

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _configProvider = __webpack_require__(11);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var BreadcrumbSeparator = /*#__PURE__*/function (_React$Component) {
	  _inherits(BreadcrumbSeparator, _React$Component);
	
	  var _super = _createSuper(BreadcrumbSeparator);
	
	  function BreadcrumbSeparator() {
	    var _this;
	
	    _classCallCheck(this, BreadcrumbSeparator);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSeparator = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var children = _this.props.children;
	      var prefixCls = getPrefixCls('breadcrumb');
	      return /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-separator")
	      }, children || '/');
	    };
	
	    return _this;
	  }
	
	  _createClass(BreadcrumbSeparator, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSeparator);
	    }
	  }]);
	
	  return BreadcrumbSeparator;
	}(React.Component);
	
	exports["default"] = BreadcrumbSeparator;
	BreadcrumbSeparator.__ANT_BREADCRUMB_SEPARATOR = true;

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ButtonGroup = function ButtonGroup(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	    var getPrefixCls = _ref.getPrefixCls;
	
	    var customizePrefixCls = props.prefixCls,
	        size = props.size,
	        className = props.className,
	        others = __rest(props, ["prefixCls", "size", "className"]);
	
	    var prefixCls = getPrefixCls('btn-group', customizePrefixCls); // large => lg
	    // small => sm
	
	    var sizeCls = '';
	
	    switch (size) {
	      case 'large':
	        sizeCls = 'lg';
	        break;
	
	      case 'small':
	        sizeCls = 'sm';
	        break;
	
	      default:
	        break;
	    }
	
	    var classes = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), className);
	    return /*#__PURE__*/React.createElement("div", _extends({}, others, {
	      className: classes
	    }));
	  });
	};
	
	var _default = ButtonGroup;
	exports["default"] = _default;

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	var _wave = _interopRequireDefault(__webpack_require__(404));
	
	var _type = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable react/button-has-type */
	
	
	var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
	var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
	
	function isString(str) {
	  return typeof str === 'string';
	} // Insert one space between two chinese characters automatically.
	
	
	function insertSpace(child, needInserted) {
	  // Check the child if is undefined or null.
	  if (child == null) {
	    return;
	  }
	
	  var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.
	
	  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
	    return /*#__PURE__*/React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
	  }
	
	  if (typeof child === 'string') {
	    if (isTwoCNChar(child)) {
	      child = child.split('').join(SPACE);
	    }
	
	    return /*#__PURE__*/React.createElement("span", null, child);
	  }
	
	  return child;
	}
	
	function spaceChildren(children, needInserted) {
	  var isPrevChildPure = false;
	  var childList = [];
	  React.Children.forEach(children, function (child) {
	    var type = _typeof(child);
	
	    var isCurrentChildPure = type === 'string' || type === 'number';
	
	    if (isPrevChildPure && isCurrentChildPure) {
	      var lastIndex = childList.length - 1;
	      var lastChild = childList[lastIndex];
	      childList[lastIndex] = "".concat(lastChild).concat(child);
	    } else {
	      childList.push(child);
	    }
	
	    isPrevChildPure = isCurrentChildPure;
	  }); // Pass to React.Children.map to auto fill key
	
	  return React.Children.map(childList, function (child) {
	    return insertSpace(child, needInserted);
	  });
	}
	
	var ButtonTypes = (0, _type.tuple)('default', 'primary', 'ghost', 'dashed', 'danger', 'link');
	var ButtonShapes = (0, _type.tuple)('circle', 'circle-outline', 'round');
	var ButtonSizes = (0, _type.tuple)('large', 'default', 'small');
	var ButtonHTMLTypes = (0, _type.tuple)('submit', 'button', 'reset');
	
	var Button = /*#__PURE__*/function (_React$Component) {
	  _inherits(Button, _React$Component);
	
	  var _super = _createSuper(Button);
	
	  function Button(props) {
	    var _this;
	
	    _classCallCheck(this, Button);
	
	    _this = _super.call(this, props);
	
	    _this.saveButtonRef = function (node) {
	      _this.buttonNode = node;
	    };
	
	    _this.handleClick = function (e) {
	      var loading = _this.state.loading;
	      var onClick = _this.props.onClick;
	
	      if (loading) {
	        return;
	      }
	
	      if (onClick) {
	        onClick(e);
	      }
	    };
	
	    _this.renderButton = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          autoInsertSpaceInButton = _ref.autoInsertSpaceInButton;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          shape = _a.shape,
	          size = _a.size,
	          className = _a.className,
	          children = _a.children,
	          icon = _a.icon,
	          ghost = _a.ghost,
	          block = _a.block,
	          rest = __rest(_a, ["prefixCls", "type", "shape", "size", "className", "children", "icon", "ghost", "block"]);
	
	      var _this$state = _this.state,
	          loading = _this$state.loading,
	          hasTwoCNChar = _this$state.hasTwoCNChar;
	      var prefixCls = getPrefixCls('btn', customizePrefixCls);
	      var autoInsertSpace = autoInsertSpaceInButton !== false; // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var iconType = loading ? 'loading' : icon;
	      var classes = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && iconType), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), !!loading), _defineProperty(_classNames, "".concat(prefixCls, "-background-ghost"), ghost), _defineProperty(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace), _defineProperty(_classNames, "".concat(prefixCls, "-block"), block), _classNames));
	      var iconNode = iconType ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType
	      }) : null;
	      var kids = children || children === 0 ? spaceChildren(children, _this.isNeedInserted() && autoInsertSpace) : null;
	      var linkButtonRestProps = (0, _omit["default"])(rest, ['htmlType', 'loading']);
	
	      if (linkButtonRestProps.href !== undefined) {
	        return /*#__PURE__*/React.createElement("a", _extends({}, linkButtonRestProps, {
	          className: classes,
	          onClick: _this.handleClick,
	          ref: _this.saveButtonRef
	        }), iconNode, kids);
	      } // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
	
	
	      var _b = rest,
	          htmlType = _b.htmlType,
	          otherProps = __rest(_b, ["htmlType"]);
	
	      var buttonNode = /*#__PURE__*/React.createElement("button", _extends({}, (0, _omit["default"])(otherProps, ['loading']), {
	        type: htmlType,
	        className: classes,
	        onClick: _this.handleClick,
	        ref: _this.saveButtonRef
	      }), iconNode, kids);
	
	      if (type === 'link') {
	        return buttonNode;
	      }
	
	      return /*#__PURE__*/React.createElement(_wave["default"], null, buttonNode);
	    };
	
	    _this.state = {
	      loading: props.loading,
	      hasTwoCNChar: false
	    };
	    return _this;
	  }
	
	  _createClass(Button, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.fixTwoCNChar();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      this.fixTwoCNChar();
	
	      if (prevProps.loading && typeof prevProps.loading !== 'boolean') {
	        clearTimeout(this.delayTimeout);
	      }
	
	      var loading = this.props.loading;
	
	      if (loading && typeof loading !== 'boolean' && loading.delay) {
	        this.delayTimeout = window.setTimeout(function () {
	          _this2.setState({
	            loading: loading
	          });
	        }, loading.delay);
	      } else if (prevProps.loading !== loading) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({
	          loading: loading
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.delayTimeout) {
	        clearTimeout(this.delayTimeout);
	      }
	    }
	  }, {
	    key: "fixTwoCNChar",
	    value: function fixTwoCNChar() {
	      // Fix for HOC usage like <FormatMessage />
	      if (!this.buttonNode) {
	        return;
	      }
	
	      var buttonText = this.buttonNode.textContent;
	
	      if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
	        if (!this.state.hasTwoCNChar) {
	          this.setState({
	            hasTwoCNChar: true
	          });
	        }
	      } else if (this.state.hasTwoCNChar) {
	        this.setState({
	          hasTwoCNChar: false
	        });
	      }
	    }
	  }, {
	    key: "isNeedInserted",
	    value: function isNeedInserted() {
	      var _this$props = this.props,
	          icon = _this$props.icon,
	          children = _this$props.children,
	          type = _this$props.type;
	      return React.Children.count(children) === 1 && !icon && type !== 'link';
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton);
	    }
	  }]);
	
	  return Button;
	}(React.Component);
	
	Button.__ANT_BUTTON = true;
	Button.defaultProps = {
	  loading: false,
	  ghost: false,
	  block: false,
	  htmlType: 'button'
	};
	Button.propTypes = {
	  type: PropTypes.string,
	  shape: PropTypes.oneOf(ButtonShapes),
	  size: PropTypes.oneOf(ButtonSizes),
	  htmlType: PropTypes.oneOf(ButtonHTMLTypes),
	  onClick: PropTypes.func,
	  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	  className: PropTypes.string,
	  icon: PropTypes.string,
	  block: PropTypes.bool,
	  title: PropTypes.string
	};
	(0, _reactLifecyclesCompat.polyfill)(Button);
	var _default = Button;
	exports["default"] = _default;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _select = _interopRequireDefault(__webpack_require__(270));
	
	var _radio = __webpack_require__(320);
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Option = _select["default"].Option;
	
	function getMonthsLocale(value) {
	  var current = value.clone();
	  var localeData = value.localeData();
	  var months = [];
	
	  for (var i = 0; i < 12; i++) {
	    current.month(i);
	    months.push(localeData.monthsShort(current));
	  }
	
	  return months;
	}
	
	var Header = /*#__PURE__*/function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  var _super = _createSuper(Header);
	
	  function Header() {
	    var _this;
	
	    _classCallCheck(this, Header);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onYearChange = function (year) {
	      var _this$props = _this.props,
	          value = _this$props.value,
	          validRange = _this$props.validRange;
	      var newValue = value.clone();
	      newValue.year(parseInt(year, 10)); // switch the month so that it remains within range when year changes
	
	      if (validRange) {
	        var _validRange = _slicedToArray(validRange, 2),
	            start = _validRange[0],
	            end = _validRange[1];
	
	        var newYear = newValue.get('year');
	        var newMonth = newValue.get('month');
	
	        if (newYear === end.get('year') && newMonth > end.get('month')) {
	          newValue.month(end.get('month'));
	        }
	
	        if (newYear === start.get('year') && newMonth < start.get('month')) {
	          newValue.month(start.get('month'));
	        }
	      }
	
	      var onValueChange = _this.props.onValueChange;
	
	      if (onValueChange) {
	        onValueChange(newValue);
	      }
	    };
	
	    _this.onMonthChange = function (month) {
	      var newValue = _this.props.value.clone();
	
	      newValue.month(parseInt(month, 10));
	      var onValueChange = _this.props.onValueChange;
	
	      if (onValueChange) {
	        onValueChange(newValue);
	      }
	    };
	
	    _this.onInternalTypeChange = function (e) {
	      _this.onTypeChange(e.target.value);
	    };
	
	    _this.onTypeChange = function (type) {
	      var onTypeChange = _this.props.onTypeChange;
	
	      if (onTypeChange) {
	        onTypeChange(type);
	      }
	    };
	
	    _this.getCalenderHeaderNode = function (node) {
	      _this.calenderHeaderNode = node;
	    };
	
	    _this.getMonthYearSelections = function (getPrefixCls) {
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          type = _this$props2.type,
	          value = _this$props2.value;
	      var prefixCls = getPrefixCls('fullcalendar', customizePrefixCls);
	
	      var yearReactNode = _this.getYearSelectElement(prefixCls, value.year());
	
	      var monthReactNode = type === 'month' ? _this.getMonthSelectElement(prefixCls, value.month(), getMonthsLocale(value)) : null;
	      return {
	        yearReactNode: yearReactNode,
	        monthReactNode: monthReactNode
	      };
	    };
	
	    _this.getTypeSwitch = function () {
	      var _this$props3 = _this.props,
	          _this$props3$locale = _this$props3.locale,
	          locale = _this$props3$locale === void 0 ? {} : _this$props3$locale,
	          type = _this$props3.type,
	          fullscreen = _this$props3.fullscreen;
	      var size = fullscreen ? 'default' : 'small';
	      return /*#__PURE__*/React.createElement(_radio.Group, {
	        onChange: _this.onInternalTypeChange,
	        value: type,
	        size: size
	      }, /*#__PURE__*/React.createElement(_radio.Button, {
	        value: "month"
	      }, locale.month), /*#__PURE__*/React.createElement(_radio.Button, {
	        value: "year"
	      }, locale.year));
	    };
	
	    _this.headerRenderCustom = function (headerRender) {
	      var _this$props4 = _this.props,
	          type = _this$props4.type,
	          onValueChange = _this$props4.onValueChange,
	          value = _this$props4.value;
	      return headerRender({
	        value: value,
	        type: type || 'month',
	        onChange: onValueChange,
	        onTypeChange: _this.onTypeChange
	      });
	    };
	
	    _this.renderHeader = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props5 = _this.props,
	          prefixCls = _this$props5.prefixCls,
	          headerRender = _this$props5.headerRender;
	
	      var typeSwitch = _this.getTypeSwitch();
	
	      var _this$getMonthYearSel = _this.getMonthYearSelections(getPrefixCls),
	          yearReactNode = _this$getMonthYearSel.yearReactNode,
	          monthReactNode = _this$getMonthYearSel.monthReactNode;
	
	      return headerRender ? _this.headerRenderCustom(headerRender) : /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-header"),
	        ref: _this.getCalenderHeaderNode
	      }, yearReactNode, monthReactNode, typeSwitch);
	    };
	
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: "getYearSelectElement",
	    value: function getYearSelectElement(prefixCls, year) {
	      var _this2 = this;
	
	      var _this$props6 = this.props,
	          yearSelectOffset = _this$props6.yearSelectOffset,
	          yearSelectTotal = _this$props6.yearSelectTotal,
	          _this$props6$locale = _this$props6.locale,
	          locale = _this$props6$locale === void 0 ? {} : _this$props6$locale,
	          fullscreen = _this$props6.fullscreen,
	          validRange = _this$props6.validRange;
	      var start = year - yearSelectOffset;
	      var end = start + yearSelectTotal;
	
	      if (validRange) {
	        start = validRange[0].get('year');
	        end = validRange[1].get('year') + 1;
	      }
	
	      var suffix = locale.year === '年' ? '年' : '';
	      var options = [];
	
	      for (var index = start; index < end; index++) {
	        options.push( /*#__PURE__*/React.createElement(Option, {
	          key: "".concat(index)
	        }, index + suffix));
	      }
	
	      return /*#__PURE__*/React.createElement(_select["default"], {
	        size: fullscreen ? 'default' : 'small',
	        dropdownMatchSelectWidth: false,
	        className: "".concat(prefixCls, "-year-select"),
	        onChange: this.onYearChange,
	        value: String(year),
	        getPopupContainer: function getPopupContainer() {
	          return _this2.calenderHeaderNode;
	        }
	      }, options);
	    }
	  }, {
	    key: "getMonthSelectElement",
	    value: function getMonthSelectElement(prefixCls, month, months) {
	      var _this3 = this;
	
	      var _this$props7 = this.props,
	          fullscreen = _this$props7.fullscreen,
	          validRange = _this$props7.validRange,
	          value = _this$props7.value;
	      var options = [];
	      var start = 0;
	      var end = 12;
	
	      if (validRange) {
	        var _validRange2 = _slicedToArray(validRange, 2),
	            rangeStart = _validRange2[0],
	            rangeEnd = _validRange2[1];
	
	        var currentYear = value.get('year');
	
	        if (rangeEnd.get('year') === currentYear) {
	          end = rangeEnd.get('month') + 1;
	        }
	
	        if (rangeStart.get('year') === currentYear) {
	          start = rangeStart.get('month');
	        }
	      }
	
	      for (var index = start; index < end; index++) {
	        options.push( /*#__PURE__*/React.createElement(Option, {
	          key: "".concat(index)
	        }, months[index]));
	      }
	
	      return /*#__PURE__*/React.createElement(_select["default"], {
	        size: fullscreen ? 'default' : 'small',
	        dropdownMatchSelectWidth: false,
	        className: "".concat(prefixCls, "-month-select"),
	        value: String(month),
	        onChange: this.onMonthChange,
	        getPopupContainer: function getPopupContainer() {
	          return _this3.calenderHeaderNode;
	        }
	      }, options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderHeader);
	    }
	  }]);
	
	  return Header;
	}(React.Component);
	
	exports["default"] = Header;
	Header.defaultProps = {
	  yearSelectOffset: 10,
	  yearSelectTotal: 20
	};

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var moment = _interopRequireWildcard(__webpack_require__(3));
	
	var _FullCalendar = _interopRequireDefault(__webpack_require__(2641));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _Header = _interopRequireDefault(__webpack_require__(1244));
	
	var _en_US = _interopRequireDefault(__webpack_require__(621));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _configProvider = __webpack_require__(11);
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(149));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function noop() {
	  return null;
	}
	
	function zerofixed(v) {
	  if (v < 10) {
	    return "0".concat(v);
	  }
	
	  return "".concat(v);
	}
	
	var Calendar = /*#__PURE__*/function (_React$Component) {
	  _inherits(Calendar, _React$Component);
	
	  var _super = _createSuper(Calendar);
	
	  function Calendar(props) {
	    var _this;
	
	    _classCallCheck(this, Calendar);
	
	    _this = _super.call(this, props);
	
	    _this.onHeaderValueChange = function (value) {
	      _this.setValue(value, 'changePanel');
	    };
	
	    _this.onHeaderTypeChange = function (mode) {
	      _this.setState({
	        mode: mode
	      });
	
	      _this.onPanelChange(_this.state.value, mode);
	    };
	
	    _this.onSelect = function (value) {
	      _this.setValue(value, 'select');
	    };
	
	    _this.setValue = function (value, way) {
	      var prevValue = _this.props.value || _this.state.value;
	      var mode = _this.state.mode;
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      if (way === 'select') {
	        if (prevValue && prevValue.month() !== value.month()) {
	          _this.onPanelChange(value, mode);
	        }
	
	        if (_this.props.onSelect) {
	          _this.props.onSelect(value);
	        }
	      } else if (way === 'changePanel') {
	        _this.onPanelChange(value, mode);
	      }
	    };
	
	    _this.getDateRange = function (validRange, disabledDate) {
	      return function (current) {
	        if (!current) {
	          return false;
	        }
	
	        var _validRange = _slicedToArray(validRange, 2),
	            startDate = _validRange[0],
	            endDate = _validRange[1];
	
	        var inRange = !current.isBetween(startDate, endDate, 'days', '[]');
	
	        if (disabledDate) {
	          return disabledDate(current) || inRange;
	        }
	
	        return inRange;
	      };
	    };
	
	    _this.getDefaultLocale = function () {
	      var result = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	      result.lang = _extends(_extends({}, result.lang), (_this.props.locale || {}).lang);
	      return result;
	    };
	
	    _this.monthCellRender = function (value) {
	      var _this$props$monthCell = _this.props.monthCellRender,
	          monthCellRender = _this$props$monthCell === void 0 ? noop : _this$props$monthCell;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      return /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-month")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-value")
	      }, value.localeData().monthsShort(value)), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content")
	      }, monthCellRender(value)));
	    };
	
	    _this.dateCellRender = function (value) {
	      var _this$props$dateCellR = _this.props.dateCellRender,
	          dateCellRender = _this$props$dateCellR === void 0 ? noop : _this$props$dateCellR;
	
	      var _assertThisInitialize2 = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize2.prefixCls;
	
	      return /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-date")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-value")
	      }, zerofixed(value.date())), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content")
	      }, dateCellRender(value)));
	    };
	
	    _this.renderCalendar = function (locale, localeCode) {
	      var _assertThisInitialize3 = _assertThisInitialized(_this),
	          state = _assertThisInitialize3.state,
	          props = _assertThisInitialize3.props;
	
	      var value = state.value,
	          mode = state.mode;
	
	      if (value && localeCode) {
	        value.locale(localeCode);
	      }
	
	      var customizePrefixCls = props.prefixCls,
	          style = props.style,
	          className = props.className,
	          fullscreen = props.fullscreen,
	          headerRender = props.headerRender,
	          dateFullCellRender = props.dateFullCellRender,
	          monthFullCellRender = props.monthFullCellRender;
	      var monthCellRender = monthFullCellRender || _this.monthCellRender;
	      var dateCellRender = dateFullCellRender || _this.dateCellRender;
	      var disabledDate = props.disabledDate;
	
	      if (props.validRange) {
	        disabledDate = _this.getDateRange(props.validRange, disabledDate);
	      }
	
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	        var getPrefixCls = _ref.getPrefixCls;
	        var prefixCls = getPrefixCls('fullcalendar', customizePrefixCls); // To support old version react.
	        // Have to add prefixCls on the instance.
	        // https://github.com/facebook/react/issues/12397
	
	        _this.prefixCls = prefixCls;
	        var cls = className || '';
	
	        if (fullscreen) {
	          cls += " ".concat(prefixCls, "-fullscreen");
	        }
	
	        return /*#__PURE__*/React.createElement("div", {
	          className: cls,
	          style: style
	        }, /*#__PURE__*/React.createElement(_Header["default"], {
	          fullscreen: fullscreen,
	          type: mode,
	          headerRender: headerRender,
	          value: value,
	          locale: locale.lang,
	          prefixCls: prefixCls,
	          onTypeChange: _this.onHeaderTypeChange,
	          onValueChange: _this.onHeaderValueChange,
	          validRange: props.validRange
	        }), /*#__PURE__*/React.createElement(_FullCalendar["default"], _extends({}, props, {
	          disabledDate: disabledDate,
	          Select: noop,
	          locale: locale.lang,
	          type: mode === 'year' ? 'month' : 'date',
	          prefixCls: prefixCls,
	          showHeader: false,
	          value: value,
	          monthCellRender: monthCellRender,
	          dateCellRender: dateCellRender,
	          onSelect: _this.onSelect
	        })));
	      });
	    };
	
	    var value = props.value || props.defaultValue || (0, _interopDefault["default"])(moment)();
	
	    if (!(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of Calendar must be a moment object after `antd@2.0`, ' + 'see: https://u.ant.design/calendar-value');
	    }
	
	    _this.state = {
	      value: value,
	      mode: props.mode || 'month'
	    };
	    return _this;
	  }
	
	  _createClass(Calendar, [{
	    key: "onPanelChange",
	    value: function onPanelChange(value, mode) {
	      var _this$props = this.props,
	          onPanelChange = _this$props.onPanelChange,
	          onChange = _this$props.onChange;
	
	      if (onPanelChange) {
	        onPanelChange(value, mode);
	      }
	
	      if (onChange && value !== this.state.value) {
	        onChange(value);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Calendar",
	        defaultLocale: this.getDefaultLocale
	      }, this.renderCalendar);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	
	      if ('value' in nextProps) {
	        newState.value = nextProps.value;
	      }
	
	      if ('mode' in nextProps) {
	        newState.mode = nextProps.mode;
	      }
	
	      return Object.keys(newState).length > 0 ? newState : null;
	    }
	  }]);
	
	  return Calendar;
	}(React.Component);
	
	Calendar.defaultProps = {
	  locale: {},
	  fullscreen: true,
	  onSelect: noop,
	  onPanelChange: noop,
	  onChange: noop
	};
	Calendar.propTypes = {
	  monthCellRender: PropTypes.func,
	  dateCellRender: PropTypes.func,
	  monthFullCellRender: PropTypes.func,
	  dateFullCellRender: PropTypes.func,
	  fullscreen: PropTypes.bool,
	  locale: PropTypes.object,
	  prefixCls: PropTypes.string,
	  className: PropTypes.string,
	  style: PropTypes.object,
	  onPanelChange: PropTypes.func,
	  value: PropTypes.object,
	  onSelect: PropTypes.func,
	  onChange: PropTypes.func,
	  headerRender: PropTypes.func
	};
	(0, _reactLifecyclesCompat.polyfill)(Calendar);
	var _default = Calendar;
	exports["default"] = _default;

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _zh_CN = _interopRequireDefault(__webpack_require__(625));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _zh_CN["default"];
	exports["default"] = _default;

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Grid = function Grid(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	    var getPrefixCls = _ref.getPrefixCls;
	
	    var customizePrefixCls = props.prefixCls,
	        className = props.className,
	        _props$hoverable = props.hoverable,
	        hoverable = _props$hoverable === void 0 ? true : _props$hoverable,
	        others = __rest(props, ["prefixCls", "className", "hoverable"]);
	
	    var prefixCls = getPrefixCls('card', customizePrefixCls);
	    var classString = (0, _classnames["default"])("".concat(prefixCls, "-grid"), className, _defineProperty({}, "".concat(prefixCls, "-grid-hoverable"), hoverable));
	    return /*#__PURE__*/React.createElement("div", _extends({}, others, {
	      className: classString
	    }));
	  });
	};
	
	var _default = Grid;
	exports["default"] = _default;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Meta = function Meta(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	    var getPrefixCls = _ref.getPrefixCls;
	
	    var customizePrefixCls = props.prefixCls,
	        className = props.className,
	        avatar = props.avatar,
	        title = props.title,
	        description = props.description,
	        others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
	
	    var prefixCls = getPrefixCls('card', customizePrefixCls);
	    var classString = (0, _classnames["default"])("".concat(prefixCls, "-meta"), className);
	    var avatarDom = avatar ? /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-meta-avatar")
	    }, avatar) : null;
	    var titleDom = title ? /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-meta-title")
	    }, title) : null;
	    var descriptionDom = description ? /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-meta-description")
	    }, description) : null;
	    var MetaDetail = titleDom || descriptionDom ? /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-meta-detail")
	    }, titleDom, descriptionDom) : null;
	    return /*#__PURE__*/React.createElement("div", _extends({}, others, {
	      className: classString
	    }), avatarDom, MetaDetail);
	  });
	};
	
	var _default = Meta;
	exports["default"] = _default;

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _Grid = _interopRequireDefault(__webpack_require__(1247));
	
	var _Meta = _interopRequireDefault(__webpack_require__(1248));
	
	var _tabs = _interopRequireDefault(__webpack_require__(642));
	
	var _row = _interopRequireDefault(__webpack_require__(639));
	
	var _col = _interopRequireDefault(__webpack_require__(623));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getAction(actions) {
	  var actionList = actions.map(function (action, index) {
	    return (
	      /*#__PURE__*/
	      // eslint-disable-next-line react/no-array-index-key
	      React.createElement("li", {
	        style: {
	          width: "".concat(100 / actions.length, "%")
	        },
	        key: "action-".concat(index)
	      }, /*#__PURE__*/React.createElement("span", null, action))
	    );
	  });
	  return actionList;
	}
	
	var Card = /*#__PURE__*/function (_React$Component) {
	  _inherits(Card, _React$Component);
	
	  var _super = _createSuper(Card);
	
	  function Card() {
	    var _this;
	
	    _classCallCheck(this, Card);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onTabChange = function (key) {
	      if (_this.props.onTabChange) {
	        _this.props.onTabChange(key);
	      }
	    };
	
	    _this.renderCard = function (_ref) {
	      var _classNames, _extraProps;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          extra = _a.extra,
	          _a$headStyle = _a.headStyle,
	          headStyle = _a$headStyle === void 0 ? {} : _a$headStyle,
	          _a$bodyStyle = _a.bodyStyle,
	          bodyStyle = _a$bodyStyle === void 0 ? {} : _a$bodyStyle,
	          title = _a.title,
	          loading = _a.loading,
	          _a$bordered = _a.bordered,
	          bordered = _a$bordered === void 0 ? true : _a$bordered,
	          _a$size = _a.size,
	          size = _a$size === void 0 ? 'default' : _a$size,
	          type = _a.type,
	          cover = _a.cover,
	          actions = _a.actions,
	          tabList = _a.tabList,
	          children = _a.children,
	          activeTabKey = _a.activeTabKey,
	          defaultActiveTabKey = _a.defaultActiveTabKey,
	          tabBarExtraContent = _a.tabBarExtraContent,
	          others = __rest(_a, ["prefixCls", "className", "extra", "headStyle", "bodyStyle", "title", "loading", "bordered", "size", "type", "cover", "actions", "tabList", "children", "activeTabKey", "defaultActiveTabKey", "tabBarExtraContent"]);
	
	      var prefixCls = getPrefixCls('card', customizePrefixCls);
	      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-hoverable"), _this.getCompatibleHoverable()), _defineProperty(_classNames, "".concat(prefixCls, "-contain-grid"), _this.isContainGrid()), _defineProperty(_classNames, "".concat(prefixCls, "-contain-tabs"), tabList && tabList.length), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size !== 'default'), _defineProperty(_classNames, "".concat(prefixCls, "-type-").concat(type), !!type), _classNames));
	      var loadingBlockStyle = bodyStyle.padding === 0 || bodyStyle.padding === '0px' ? {
	        padding: 24
	      } : undefined;
	      var loadingBlock = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-content"),
	        style: loadingBlockStyle
	      }, /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 22
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 8
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 15
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 6
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 18
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 13
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 9
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))), /*#__PURE__*/React.createElement(_row["default"], {
	        gutter: 8
	      }, /*#__PURE__*/React.createElement(_col["default"], {
	        span: 4
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 3
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      })), /*#__PURE__*/React.createElement(_col["default"], {
	        span: 16
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-loading-block")
	      }))));
	      var hasActiveTabKey = activeTabKey !== undefined;
	      var extraProps = (_extraProps = {}, _defineProperty(_extraProps, hasActiveTabKey ? 'activeKey' : 'defaultActiveKey', hasActiveTabKey ? activeTabKey : defaultActiveTabKey), _defineProperty(_extraProps, "tabBarExtraContent", tabBarExtraContent), _extraProps);
	      var head;
	      var tabs = tabList && tabList.length ? /*#__PURE__*/React.createElement(_tabs["default"], _extends({}, extraProps, {
	        className: "".concat(prefixCls, "-head-tabs"),
	        size: "large",
	        onChange: _this.onTabChange
	      }), tabList.map(function (item) {
	        return /*#__PURE__*/React.createElement(_tabs["default"].TabPane, {
	          tab: item.tab,
	          disabled: item.disabled,
	          key: item.key
	        });
	      })) : null;
	
	      if (title || extra || tabs) {
	        head = /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head"),
	          style: headStyle
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head-wrapper")
	        }, title && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-head-title")
	        }, title), extra && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-extra")
	        }, extra)), tabs);
	      }
	
	      var coverDom = cover ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-cover")
	      }, cover) : null;
	      var body = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-body"),
	        style: bodyStyle
	      }, loading ? loadingBlock : children);
	      var actionDom = actions && actions.length ? /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-actions")
	      }, getAction(actions)) : null;
	      var divProps = (0, _omit["default"])(others, ['onTabChange', 'noHovering', 'hoverable']);
	      return /*#__PURE__*/React.createElement("div", _extends({}, divProps, {
	        className: classString
	      }), head, coverDom, body, actionDom);
	    };
	
	    return _this;
	  }
	
	  _createClass(Card, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if ('noHovering' in this.props) {
	        (0, _warning["default"])(!this.props.noHovering, 'Card', '`noHovering` is deprecated, you can remove it safely or use `hoverable` instead.');
	        (0, _warning["default"])(!!this.props.noHovering, 'Card', '`noHovering={false}` is deprecated, use `hoverable` instead.');
	      }
	    } // For 2.x compatible
	
	  }, {
	    key: "getCompatibleHoverable",
	    value: function getCompatibleHoverable() {
	      var _this$props = this.props,
	          noHovering = _this$props.noHovering,
	          hoverable = _this$props.hoverable;
	
	      if ('noHovering' in this.props) {
	        return !noHovering || hoverable;
	      }
	
	      return !!hoverable;
	    }
	  }, {
	    key: "isContainGrid",
	    value: function isContainGrid() {
	      var containGrid;
	      React.Children.forEach(this.props.children, function (element) {
	        if (element && element.type && element.type === _Grid["default"]) {
	          containGrid = true;
	        }
	      });
	      return containGrid;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCard);
	    }
	  }]);
	
	  return Card;
	}(React.Component);
	
	exports["default"] = Card;
	Card.Grid = _Grid["default"];
	Card.Meta = _Meta["default"];

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _debounce = _interopRequireDefault(__webpack_require__(300));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	// matchMedia polyfill for
	// https://github.com/WickyNilliams/enquire.js/issues/82
	// TODO: Will be removed in antd 4.0 because we will no longer support ie9
	if (typeof window !== 'undefined') {
	  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
	    return {
	      media: mediaQuery,
	      matches: false,
	      addListener: function addListener() {},
	      removeListener: function removeListener() {}
	    };
	  }; // ref: https://github.com/ant-design/ant-design/issues/18774
	
	
	  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill;
	} // Use require over import (will be lifted up)
	// make sure matchMedia polyfill run before require('react-slick')
	// Fix https://github.com/ant-design/ant-design/issues/6560
	// Fix https://github.com/ant-design/ant-design/issues/3308
	
	
	var SlickCarousel = __webpack_require__(2882)["default"];
	
	var Carousel = /*#__PURE__*/function (_React$Component) {
	  _inherits(Carousel, _React$Component);
	
	  var _super = _createSuper(Carousel);
	
	  function Carousel(props) {
	    var _this;
	
	    _classCallCheck(this, Carousel);
	
	    _this = _super.call(this, props);
	
	    _this.saveSlick = function (node) {
	      _this.slick = node;
	    };
	
	    _this.onWindowResized = function () {
	      // Fix https://github.com/ant-design/ant-design/issues/2550
	      var autoplay = _this.props.autoplay;
	
	      if (autoplay && _this.slick && _this.slick.innerSlider && _this.slick.innerSlider.autoPlay) {
	        _this.slick.innerSlider.autoPlay();
	      }
	    };
	
	    _this.renderCarousel = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var props = _extends({}, _this.props);
	
	      if (props.effect === 'fade') {
	        props.fade = true;
	      }
	
	      var className = getPrefixCls('carousel', props.prefixCls);
	      var dotsClass = 'slick-dots';
	
	      var dotPosition = _this.getDotPosition();
	
	      props.vertical = dotPosition === 'left' || dotPosition === 'right';
	      props.dotsClass = "".concat(dotsClass, " ").concat(dotsClass, "-").concat(dotPosition || 'bottom');
	
	      if (props.vertical) {
	        className = "".concat(className, " ").concat(className, "-vertical");
	      }
	
	      return /*#__PURE__*/React.createElement("div", {
	        className: className
	      }, /*#__PURE__*/React.createElement(SlickCarousel, _extends({
	        ref: _this.saveSlick
	      }, props)));
	    };
	
	    _this.onWindowResized = (0, _debounce["default"])(_this.onWindowResized, 500, {
	      leading: false
	    });
	
	    if ('vertical' in _this.props) {
	      (0, _warning["default"])(!_this.props.vertical, 'Carousel', '`vertical` is deprecated, please use `dotPosition` instead.');
	    }
	
	    return _this;
	  }
	
	  _createClass(Carousel, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var autoplay = this.props.autoplay;
	
	      if (autoplay) {
	        window.addEventListener('resize', this.onWindowResized);
	      } // https://github.com/ant-design/ant-design/issues/7191
	
	
	      this.innerSlider = this.slick && this.slick.innerSlider;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (React.Children.count(this.props.children) !== React.Children.count(prevProps.children)) {
	        this.goTo(this.props.initialSlide || 0, false);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var autoplay = this.props.autoplay;
	
	      if (autoplay) {
	        window.removeEventListener('resize', this.onWindowResized);
	        this.onWindowResized.cancel();
	      }
	    }
	  }, {
	    key: "getDotPosition",
	    value: function getDotPosition() {
	      if (this.props.dotPosition) {
	        return this.props.dotPosition;
	      }
	
	      if ('vertical' in this.props) {
	        return this.props.vertical ? 'right' : 'bottom';
	      }
	
	      return 'bottom';
	    }
	  }, {
	    key: "next",
	    value: function next() {
	      this.slick.slickNext();
	    }
	  }, {
	    key: "prev",
	    value: function prev() {
	      this.slick.slickPrev();
	    }
	  }, {
	    key: "goTo",
	    value: function goTo(slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      this.slick.slickGoTo(slide, dontAnimate);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCarousel);
	    }
	  }]);
	
	  return Carousel;
	}(React.Component);
	
	exports["default"] = Carousel;
	Carousel.defaultProps = {
	  dots: true,
	  arrows: false,
	  draggable: false
	};

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcCascader = _interopRequireDefault(__webpack_require__(2654));
	
	var _arrayTreeFilter = _interopRequireDefault(__webpack_require__(418));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(71));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _input = _interopRequireDefault(__webpack_require__(319));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// We limit the filtered item count by default
	var defaultLimit = 50;
	
	function highlightKeyword(str, keyword, prefixCls) {
	  return str.split(keyword).map(function (node, index) {
	    return index === 0 ? node : [/*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-menu-item-keyword"),
	      key: "seperator"
	    }, keyword), node];
	  });
	}
	
	function defaultFilterOption(inputValue, path, names) {
	  return path.some(function (option) {
	    return option[names.label].indexOf(inputValue) > -1;
	  });
	}
	
	function defaultRenderFilteredOption(inputValue, path, prefixCls, names) {
	  return path.map(function (option, index) {
	    var label = option[names.label];
	    var node = label.indexOf(inputValue) > -1 ? highlightKeyword(label, inputValue, prefixCls) : label;
	    return index === 0 ? node : [' / ', node];
	  });
	}
	
	function defaultSortFilteredOption(a, b, inputValue, names) {
	  function callback(elem) {
	    return elem[names.label].indexOf(inputValue) > -1;
	  }
	
	  return a.findIndex(callback) - b.findIndex(callback);
	}
	
	function getFieldNames(props) {
	  var fieldNames = props.fieldNames,
	      filedNames = props.filedNames;
	
	  if ('filedNames' in props) {
	    return filedNames; // For old compatibility
	  }
	
	  return fieldNames;
	}
	
	function getFilledFieldNames(props) {
	  var fieldNames = getFieldNames(props) || {};
	  var names = {
	    children: fieldNames.children || 'children',
	    label: fieldNames.label || 'label',
	    value: fieldNames.value || 'value'
	  };
	  return names;
	}
	
	function flattenTree(options, props) {
	  var ancestor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
	  var names = getFilledFieldNames(props);
	  var flattenOptions = [];
	  var childrenName = names.children;
	  options.forEach(function (option) {
	    var path = ancestor.concat(option);
	
	    if (props.changeOnSelect || !option[childrenName] || !option[childrenName].length) {
	      flattenOptions.push(path);
	    }
	
	    if (option[childrenName]) {
	      flattenOptions = flattenOptions.concat(flattenTree(option[childrenName], props, path));
	    }
	  });
	  return flattenOptions;
	}
	
	var defaultDisplayRender = function defaultDisplayRender(label) {
	  return label.join(' / ');
	};
	
	function warningValueNotExist(list) {
	  var fieldNames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  (list || []).forEach(function (item) {
	    var valueFieldName = fieldNames.value || 'value';
	    (0, _warning["default"])(valueFieldName in item, 'Cascader', 'Not found `value` in `options`.');
	    warningValueNotExist(item[fieldNames.children || 'children'], fieldNames);
	  });
	}
	
	var Cascader = /*#__PURE__*/function (_React$Component) {
	  _inherits(Cascader, _React$Component);
	
	  var _super = _createSuper(Cascader);
	
	  function Cascader(props) {
	    var _this;
	
	    _classCallCheck(this, Cascader);
	
	    _this = _super.call(this, props);
	    _this.cachedOptions = [];
	
	    _this.setValue = function (value) {
	      var selectedOptions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange(value, selectedOptions);
	      }
	    };
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.handleChange = function (value, selectedOptions) {
	      _this.setState({
	        inputValue: ''
	      });
	
	      if (selectedOptions[0].__IS_FILTERED_OPTION) {
	        var unwrappedValue = value[0];
	        var unwrappedSelectedOptions = selectedOptions[0].path;
	
	        _this.setValue(unwrappedValue, unwrappedSelectedOptions);
	
	        return;
	      }
	
	      _this.setValue(value, selectedOptions);
	    };
	
	    _this.handlePopupVisibleChange = function (popupVisible) {
	      if (!('popupVisible' in _this.props)) {
	        _this.setState(function (state) {
	          return {
	            popupVisible: popupVisible,
	            inputFocused: popupVisible,
	            inputValue: popupVisible ? state.inputValue : ''
	          };
	        });
	      }
	
	      var onPopupVisibleChange = _this.props.onPopupVisibleChange;
	
	      if (onPopupVisibleChange) {
	        onPopupVisibleChange(popupVisible);
	      }
	    };
	
	    _this.handleInputBlur = function () {
	      _this.setState({
	        inputFocused: false
	      });
	    };
	
	    _this.handleInputClick = function (e) {
	      var _this$state = _this.state,
	          inputFocused = _this$state.inputFocused,
	          popupVisible = _this$state.popupVisible; // Prevent `Trigger` behaviour.
	
	      if (inputFocused || popupVisible) {
	        e.stopPropagation();
	
	        if (e.nativeEvent.stopImmediatePropagation) {
	          e.nativeEvent.stopImmediatePropagation();
	        }
	      }
	    };
	
	    _this.handleKeyDown = function (e) {
	      // SPACE => https://github.com/ant-design/ant-design/issues/16871
	      if (e.keyCode === _KeyCode["default"].BACKSPACE || e.keyCode === _KeyCode["default"].SPACE) {
	        e.stopPropagation();
	      }
	    };
	
	    _this.handleInputChange = function (e) {
	      var inputValue = e.target.value;
	
	      _this.setState({
	        inputValue: inputValue
	      });
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      if (!_this.state.inputValue) {
	        _this.setValue([]);
	
	        _this.handlePopupVisibleChange(false);
	      } else {
	        _this.setState({
	          inputValue: ''
	        });
	      }
	    };
	
	    _this.renderCascader = function (_ref, locale) {
	      var _classNames, _classNames2, _classNames3, _classNames4;
	
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          customizeInputPrefixCls = props.inputPrefixCls,
	          children = props.children,
	          _props$placeholder = props.placeholder,
	          placeholder = _props$placeholder === void 0 ? locale.placeholder || 'Please select' : _props$placeholder,
	          size = props.size,
	          disabled = props.disabled,
	          className = props.className,
	          style = props.style,
	          allowClear = props.allowClear,
	          _props$showSearch = props.showSearch,
	          showSearch = _props$showSearch === void 0 ? false : _props$showSearch,
	          suffixIcon = props.suffixIcon,
	          notFoundContent = props.notFoundContent,
	          otherProps = __rest(props, ["prefixCls", "inputPrefixCls", "children", "placeholder", "size", "disabled", "className", "style", "allowClear", "showSearch", "suffixIcon", "notFoundContent"]);
	
	      var value = state.value,
	          inputFocused = state.inputFocused;
	      var prefixCls = getPrefixCls('cascader', customizePrefixCls);
	      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(inputPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(inputPrefixCls, "-sm"), size === 'small'), _classNames));
	      var clearIcon = allowClear && !disabled && value.length > 0 || state.inputValue ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection
	      }) : null;
	      var arrowCls = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-picker-arrow"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-arrow-expand"), state.popupVisible), _classNames2));
	      var pickerCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-picker"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-picker-with-value"), state.inputValue), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-disabled"), disabled), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-").concat(size), !!size), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-show-search"), !!showSearch), _defineProperty(_classNames3, "".concat(prefixCls, "-picker-focused"), inputFocused), _classNames3)); // Fix bug of https://github.com/facebook/react/pull/5004
	      // and https://fb.me/react-unknown-prop
	
	      var inputProps = (0, _omit["default"])(otherProps, ['onChange', 'options', 'popupPlacement', 'transitionName', 'displayRender', 'onPopupVisibleChange', 'changeOnSelect', 'expandTrigger', 'popupVisible', 'getPopupContainer', 'loadData', 'popupClassName', 'filterOption', 'renderFilteredOption', 'sortFilteredOption', 'notFoundContent', 'fieldNames', 'filedNames']);
	      var options = props.options;
	      var names = getFilledFieldNames(_this.props);
	
	      if (options && options.length > 0) {
	        if (state.inputValue) {
	          options = _this.generateFilteredOptions(prefixCls, renderEmpty);
	        }
	      } else {
	        var _ref2;
	
	        options = [(_ref2 = {}, _defineProperty(_ref2, names.value, 'ANT_CASCADER_NOT_FOUND'), _defineProperty(_ref2, names.label, notFoundContent || renderEmpty('Cascader')), _defineProperty(_ref2, "disabled", true), _defineProperty(_ref2, "isEmptyNode", true), _ref2)];
	      } // Dropdown menu should keep previous status until it is fully closed.
	
	
	      if (!state.popupVisible) {
	        options = _this.cachedOptions;
	      } else {
	        _this.cachedOptions = options;
	      }
	
	      var dropdownMenuColumnStyle = {};
	      var isNotFound = (options || []).length === 1 && options[0].isEmptyNode;
	
	      if (isNotFound) {
	        dropdownMenuColumnStyle.height = 'auto'; // Height of one row.
	      } // The default value of `matchInputWidth` is `true`
	
	
	      var resultListMatchInputWidth = showSearch.matchInputWidth !== false;
	
	      if (resultListMatchInputWidth && (state.inputValue || isNotFound) && _this.input) {
	        dropdownMenuColumnStyle.width = _this.input.input.offsetWidth;
	      }
	
	      var inputIcon = suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	        className: (0, _classnames["default"])((_classNames4 = {}, _defineProperty(_classNames4, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames4, "".concat(prefixCls, "-picker-arrow"), true), _classNames4))
	      }) : /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-picker-arrow")
	      }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: arrowCls
	      });
	      var input = children || /*#__PURE__*/React.createElement("span", {
	        style: style,
	        className: pickerCls
	      }, /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-picker-label")
	      }, _this.getLabel()), /*#__PURE__*/React.createElement(_input["default"], _extends({}, inputProps, {
	        tabIndex: "-1",
	        ref: _this.saveInput,
	        prefixCls: inputPrefixCls,
	        placeholder: value && value.length > 0 ? undefined : placeholder,
	        className: "".concat(prefixCls, "-input ").concat(sizeCls),
	        value: state.inputValue,
	        disabled: disabled,
	        readOnly: !showSearch,
	        autoComplete: inputProps.autoComplete || 'off',
	        onClick: showSearch ? _this.handleInputClick : undefined,
	        onBlur: showSearch ? _this.handleInputBlur : undefined,
	        onKeyDown: _this.handleKeyDown,
	        onChange: showSearch ? _this.handleInputChange : undefined
	      })), clearIcon, inputIcon);
	      var expandIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right"
	      });
	      var loadingIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-menu-item-loading-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "redo",
	        spin: true
	      }));
	      var getPopupContainer = props.getPopupContainer || getContextPopupContainer;
	      var rest = (0, _omit["default"])(props, ['inputIcon', 'expandIcon', 'loadingIcon']);
	      return /*#__PURE__*/React.createElement(_rcCascader["default"], _extends({}, rest, {
	        prefixCls: prefixCls,
	        getPopupContainer: getPopupContainer,
	        options: options,
	        value: value,
	        popupVisible: state.popupVisible,
	        onPopupVisibleChange: _this.handlePopupVisibleChange,
	        onChange: _this.handleChange,
	        dropdownMenuColumnStyle: dropdownMenuColumnStyle,
	        expandIcon: expandIcon,
	        loadingIcon: loadingIcon
	      }), input);
	    };
	
	    _this.state = {
	      value: props.value || props.defaultValue || [],
	      inputValue: '',
	      inputFocused: false,
	      popupVisible: props.popupVisible,
	      flattenOptions: props.showSearch ? flattenTree(props.options, props) : undefined,
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(Cascader, [{
	    key: "getLabel",
	    value: function getLabel() {
	      var _this$props = this.props,
	          options = _this$props.options,
	          _this$props$displayRe = _this$props.displayRender,
	          displayRender = _this$props$displayRe === void 0 ? defaultDisplayRender : _this$props$displayRe;
	      var names = getFilledFieldNames(this.props);
	      var value = this.state.value;
	      var unwrappedValue = Array.isArray(value[0]) ? value[0] : value;
	      var selectedOptions = (0, _arrayTreeFilter["default"])(options, function (o, level) {
	        return o[names.value] === unwrappedValue[level];
	      }, {
	        childrenKeyName: names.children
	      });
	      var label = selectedOptions.map(function (o) {
	        return o[names.label];
	      });
	      return displayRender(label, selectedOptions);
	    }
	  }, {
	    key: "generateFilteredOptions",
	    value: function generateFilteredOptions(prefixCls, renderEmpty) {
	      var _this2 = this,
	          _ref4;
	
	      var _this$props2 = this.props,
	          showSearch = _this$props2.showSearch,
	          notFoundContent = _this$props2.notFoundContent;
	      var names = getFilledFieldNames(this.props);
	      var _showSearch$filter = showSearch.filter,
	          filter = _showSearch$filter === void 0 ? defaultFilterOption : _showSearch$filter,
	          _showSearch$render = showSearch.render,
	          render = _showSearch$render === void 0 ? defaultRenderFilteredOption : _showSearch$render,
	          _showSearch$sort = showSearch.sort,
	          sort = _showSearch$sort === void 0 ? defaultSortFilteredOption : _showSearch$sort,
	          _showSearch$limit = showSearch.limit,
	          limit = _showSearch$limit === void 0 ? defaultLimit : _showSearch$limit;
	      var _this$state2 = this.state,
	          _this$state2$flattenO = _this$state2.flattenOptions,
	          flattenOptions = _this$state2$flattenO === void 0 ? [] : _this$state2$flattenO,
	          inputValue = _this$state2.inputValue; // Limit the filter if needed
	
	      var filtered;
	
	      if (limit > 0) {
	        filtered = [];
	        var matchCount = 0; // Perf optimization to filter items only below the limit
	
	        flattenOptions.some(function (path) {
	          var match = filter(_this2.state.inputValue, path, names);
	
	          if (match) {
	            filtered.push(path);
	            matchCount += 1;
	          }
	
	          return matchCount >= limit;
	        });
	      } else {
	        (0, _warning["default"])(typeof limit !== 'number', 'Cascader', "'limit' of showSearch should be positive number or false.");
	        filtered = flattenOptions.filter(function (path) {
	          return filter(_this2.state.inputValue, path, names);
	        });
	      }
	
	      filtered.sort(function (a, b) {
	        return sort(a, b, inputValue, names);
	      });
	
	      if (filtered.length > 0) {
	        return filtered.map(function (path) {
	          var _ref3;
	
	          return _ref3 = {
	            __IS_FILTERED_OPTION: true,
	            path: path
	          }, _defineProperty(_ref3, names.value, path.map(function (o) {
	            return o[names.value];
	          })), _defineProperty(_ref3, names.label, render(inputValue, path, prefixCls, names)), _defineProperty(_ref3, "disabled", path.some(function (o) {
	            return !!o.disabled;
	          })), _defineProperty(_ref3, "isEmptyNode", true), _ref3;
	        });
	      }
	
	      return [(_ref4 = {}, _defineProperty(_ref4, names.value, 'ANT_CASCADER_NOT_FOUND'), _defineProperty(_ref4, names.label, notFoundContent || renderEmpty('Cascader')), _defineProperty(_ref4, "disabled", true), _defineProperty(_ref4, "isEmptyNode", true), _ref4)];
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (configArgument) {
	        return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (locale) {
	          return _this3.renderCascader(configArgument, locale);
	        });
	      });
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, _ref5) {
	      var prevProps = _ref5.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	
	      if ('value' in nextProps) {
	        newState.value = nextProps.value || [];
	      }
	
	      if ('popupVisible' in nextProps) {
	        newState.popupVisible = nextProps.popupVisible;
	      }
	
	      if (nextProps.showSearch && prevProps.options !== nextProps.options) {
	        newState.flattenOptions = flattenTree(nextProps.options, nextProps);
	      }
	
	      if (false) {
	        warningValueNotExist(nextProps.options, getFieldNames(nextProps));
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Cascader;
	}(React.Component);
	
	Cascader.defaultProps = {
	  transitionName: 'slide-up',
	  popupPlacement: 'bottomLeft',
	  options: [],
	  disabled: false,
	  allowClear: true
	};
	(0, _reactLifecyclesCompat.polyfill)(Cascader);
	var _default = Cascader;
	exports["default"] = _default;

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(79));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(622));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var CheckboxGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(CheckboxGroup, _React$Component);
	
	  var _super = _createSuper(CheckboxGroup);
	
	  function CheckboxGroup(props) {
	    var _this;
	
	    _classCallCheck(this, CheckboxGroup);
	
	    _this = _super.call(this, props);
	
	    _this.cancelValue = function (value) {
	      _this.setState(function (_ref) {
	        var registeredValues = _ref.registeredValues;
	        return {
	          registeredValues: registeredValues.filter(function (val) {
	            return val !== value;
	          })
	        };
	      });
	    };
	
	    _this.registerValue = function (value) {
	      _this.setState(function (_ref2) {
	        var registeredValues = _ref2.registeredValues;
	        return {
	          registeredValues: [].concat(_toConsumableArray(registeredValues), [value])
	        };
	      });
	    };
	
	    _this.toggleOption = function (option) {
	      var registeredValues = _this.state.registeredValues;
	
	      var optionIndex = _this.state.value.indexOf(option.value);
	
	      var value = _toConsumableArray(_this.state.value);
	
	      if (optionIndex === -1) {
	        value.push(option.value);
	      } else {
	        value.splice(optionIndex, 1);
	      }
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        var options = _this.getOptions();
	
	        onChange(value.filter(function (val) {
	          return registeredValues.indexOf(val) !== -1;
	        }).sort(function (a, b) {
	          var indexA = options.findIndex(function (opt) {
	            return opt.value === a;
	          });
	          var indexB = options.findIndex(function (opt) {
	            return opt.value === b;
	          });
	          return indexA - indexB;
	        }));
	      }
	    };
	
	    _this.renderGroup = function (_ref3) {
	      var getPrefixCls = _ref3.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props,
	          state = _assertThisInitialize.state;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          style = props.style,
	          options = props.options,
	          restProps = __rest(props, ["prefixCls", "className", "style", "options"]);
	
	      var prefixCls = getPrefixCls('checkbox', customizePrefixCls);
	      var groupPrefixCls = "".concat(prefixCls, "-group");
	      var domProps = (0, _omit["default"])(restProps, ['children', 'defaultValue', 'value', 'onChange', 'disabled']);
	      var children = props.children;
	
	      if (options && options.length > 0) {
	        children = _this.getOptions().map(function (option) {
	          return /*#__PURE__*/React.createElement(_Checkbox["default"], {
	            prefixCls: prefixCls,
	            key: option.value.toString(),
	            disabled: 'disabled' in option ? option.disabled : props.disabled,
	            value: option.value,
	            checked: state.value.indexOf(option.value) !== -1,
	            onChange: option.onChange,
	            className: "".concat(groupPrefixCls, "-item")
	          }, option.label);
	        });
	      }
	
	      var classString = (0, _classnames["default"])(groupPrefixCls, className);
	      return /*#__PURE__*/React.createElement("div", _extends({
	        className: classString,
	        style: style
	      }, domProps), children);
	    };
	
	    _this.state = {
	      value: props.value || props.defaultValue || [],
	      registeredValues: []
	    };
	    return _this;
	  }
	
	  _createClass(CheckboxGroup, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        checkboxGroup: {
	          toggleOption: this.toggleOption,
	          value: this.state.value,
	          disabled: this.props.disabled,
	          name: this.props.name,
	          // https://github.com/ant-design/ant-design/issues/16376
	          registerValue: this.registerValue,
	          cancelValue: this.cancelValue
	        }
	      };
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
	    }
	  }, {
	    key: "getOptions",
	    value: function getOptions() {
	      var options = this.props.options; // https://github.com/Microsoft/TypeScript/issues/7960
	
	      return options.map(function (option) {
	        if (typeof option === 'string') {
	          return {
	            label: option,
	            value: option
	          };
	        }
	
	        return option;
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value || []
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return CheckboxGroup;
	}(React.Component);
	
	CheckboxGroup.defaultProps = {
	  options: []
	};
	CheckboxGroup.propTypes = {
	  defaultValue: PropTypes.array,
	  value: PropTypes.array,
	  options: PropTypes.array.isRequired,
	  onChange: PropTypes.func
	};
	CheckboxGroup.childContextTypes = {
	  checkboxGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(CheckboxGroup);
	var _default = CheckboxGroup;
	exports["default"] = _default;

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcCollapse = _interopRequireDefault(__webpack_require__(1084));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _CollapsePanel = _interopRequireDefault(__webpack_require__(1254));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	var _openAnimation = _interopRequireDefault(__webpack_require__(1226));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Collapse = /*#__PURE__*/function (_React$Component) {
	  _inherits(Collapse, _React$Component);
	
	  var _super = _createSuper(Collapse);
	
	  function Collapse() {
	    var _this;
	
	    _classCallCheck(this, Collapse);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderExpandIcon = function () {
	      var panelProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var prefixCls = arguments.length > 1 ? arguments[1] : undefined;
	      var expandIcon = _this.props.expandIcon;
	      var icon = expandIcon ? expandIcon(panelProps) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right",
	        rotate: panelProps.isActive ? 90 : undefined
	      });
	      return /*#__PURE__*/React.isValidElement(icon) ? /*#__PURE__*/React.cloneElement(icon, {
	        className: (0, _classnames["default"])(icon.props.className, "".concat(prefixCls, "-arrow"))
	      }) : icon;
	    };
	
	    _this.renderCollapse = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          bordered = _this$props.bordered,
	          expandIconPosition = _this$props.expandIconPosition;
	      var prefixCls = getPrefixCls('collapse', customizePrefixCls);
	      var collapseClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-borderless"), !bordered), _defineProperty(_classNames, "".concat(prefixCls, "-icon-position-").concat(expandIconPosition), true), _classNames), className);
	      return /*#__PURE__*/React.createElement(_rcCollapse["default"], _extends({}, _this.props, {
	        expandIcon: function expandIcon(panelProps) {
	          return _this.renderExpandIcon(panelProps, prefixCls);
	        },
	        prefixCls: prefixCls,
	        className: collapseClassName
	      }));
	    };
	
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCollapse);
	    }
	  }]);
	
	  return Collapse;
	}(React.Component);
	
	exports["default"] = Collapse;
	Collapse.Panel = _CollapsePanel["default"];
	Collapse.defaultProps = {
	  bordered: true,
	  openAnimation: _extends(_extends({}, _openAnimation["default"]), {
	    appear: function appear() {}
	  }),
	  expandIconPosition: 'left'
	};

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcCollapse = _interopRequireDefault(__webpack_require__(1084));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var CollapsePanel = /*#__PURE__*/function (_React$Component) {
	  _inherits(CollapsePanel, _React$Component);
	
	  var _super = _createSuper(CollapsePanel);
	
	  function CollapsePanel() {
	    var _this;
	
	    _classCallCheck(this, CollapsePanel);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderCollapsePanel = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          _this$props$showArrow = _this$props.showArrow,
	          showArrow = _this$props$showArrow === void 0 ? true : _this$props$showArrow;
	      var prefixCls = getPrefixCls('collapse', customizePrefixCls);
	      var collapsePanelClassName = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-no-arrow"), !showArrow), className);
	      return /*#__PURE__*/React.createElement(_rcCollapse["default"].Panel, _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        className: collapsePanelClassName
	      }));
	    };
	
	    return _this;
	  }
	
	  _createClass(CollapsePanel, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCollapsePanel);
	    }
	  }]);
	
	  return CollapsePanel;
	}(React.Component);
	
	exports["default"] = CollapsePanel;

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Collapse = _interopRequireDefault(__webpack_require__(1253));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _Collapse["default"];
	exports["default"] = _default;

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getAction(actions) {
	  if (!actions || !actions.length) {
	    return null;
	  } // eslint-disable-next-line react/no-array-index-key
	
	
	  var actionList = actions.map(function (action, index) {
	    return /*#__PURE__*/React.createElement("li", {
	      key: "action-".concat(index)
	    }, action);
	  });
	  return actionList;
	}
	
	var Comment = /*#__PURE__*/function (_React$Component) {
	  _inherits(Comment, _React$Component);
	
	  var _super = _createSuper(Comment);
	
	  function Comment() {
	    var _this;
	
	    _classCallCheck(this, Comment);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderNested = function (prefixCls, children) {
	      return /*#__PURE__*/React.createElement("div", {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-nested"))
	      }, children);
	    };
	
	    _this.renderComment = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          actions = _a.actions,
	          author = _a.author,
	          avatar = _a.avatar,
	          children = _a.children,
	          className = _a.className,
	          content = _a.content,
	          customizePrefixCls = _a.prefixCls,
	          style = _a.style,
	          datetime = _a.datetime,
	          otherProps = __rest(_a, ["actions", "author", "avatar", "children", "className", "content", "prefixCls", "style", "datetime"]);
	
	      var prefixCls = getPrefixCls('comment', customizePrefixCls);
	      var avatarDom = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-avatar")
	      }, typeof avatar === 'string' ? /*#__PURE__*/React.createElement("img", {
	        src: avatar,
	        alt: "comment-avatar"
	      }) : avatar);
	      var actionDom = actions && actions.length ? /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-actions")
	      }, getAction(actions)) : null;
	      var authorContent = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content-author")
	      }, author && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-author-name")
	      }, author), datetime && /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-author-time")
	      }, datetime));
	      var contentDom = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content")
	      }, authorContent, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-content-detail")
	      }, content), actionDom);
	      var comment = /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-inner")
	      }, avatarDom, contentDom);
	      return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
	        className: (0, _classnames["default"])(prefixCls, className),
	        style: style
	      }), comment, children ? _this.renderNested(prefixCls, children) : null);
	    };
	
	    return _this;
	  }
	
	  _createClass(Comment, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComment);
	    }
	  }]);
	
	  return Comment;
	}(React.Component);
	
	exports["default"] = Comment;

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _empty = _interopRequireDefault(__webpack_require__(627));
	
	var _ = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var renderEmpty = function renderEmpty(componentName) {
	  return /*#__PURE__*/React.createElement(_.ConfigConsumer, null, function (_ref) {
	    var getPrefixCls = _ref.getPrefixCls;
	    var prefix = getPrefixCls('empty');
	
	    switch (componentName) {
	      case 'Table':
	      case 'List':
	        return /*#__PURE__*/React.createElement(_empty["default"], {
	          image: _empty["default"].PRESENTED_IMAGE_SIMPLE
	        });
	
	      case 'Select':
	      case 'TreeSelect':
	      case 'Cascader':
	      case 'Transfer':
	      case 'Mentions':
	        return /*#__PURE__*/React.createElement(_empty["default"], {
	          image: _empty["default"].PRESENTED_IMAGE_SIMPLE,
	          className: "".concat(prefix, "-small")
	        });
	
	      default:
	        return /*#__PURE__*/React.createElement(_empty["default"], null);
	    }
	  });
	};
	
	var _default = renderEmpty;
	exports["default"] = _default;

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var moment = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _RangeCalendar = _interopRequireDefault(__webpack_require__(2642));
	
	var _Picker = _interopRequireDefault(__webpack_require__(554));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(79));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _tag = _interopRequireDefault(__webpack_require__(643));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(149));
	
	var _utils = __webpack_require__(626);
	
	var _InputIcon = _interopRequireDefault(__webpack_require__(624));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	function getShowDateFromValue(value, mode) {
	  var _value = _slicedToArray(value, 2),
	      start = _value[0],
	      end = _value[1]; // value could be an empty array, then we should not reset showDate
	
	
	  if (!start && !end) {
	    return;
	  }
	
	  if (mode && mode[0] === 'month') {
	    return [start, end];
	  }
	
	  var newEnd = end && end.isSame(start, 'month') ? end.clone().add(1, 'month') : end;
	  return [start, newEnd];
	}
	
	function pickerValueAdapter(value) {
	  if (!value) {
	    return;
	  }
	
	  if (Array.isArray(value)) {
	    return value;
	  }
	
	  return [value, value.clone().add(1, 'month')];
	}
	
	function isEmptyArray(arr) {
	  if (Array.isArray(arr)) {
	    return arr.length === 0 || arr.every(function (i) {
	      return !i;
	    });
	  }
	
	  return false;
	}
	
	function fixLocale(value, localeCode) {
	  if (!localeCode) {
	    return;
	  }
	
	  if (!value || value.length === 0) {
	    return;
	  }
	
	  var _value2 = _slicedToArray(value, 2),
	      start = _value2[0],
	      end = _value2[1];
	
	  if (start) {
	    start.locale(localeCode);
	  }
	
	  if (end) {
	    end.locale(localeCode);
	  }
	}
	
	var RangePicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(RangePicker, _React$Component);
	
	  var _super = _createSuper(RangePicker);
	
	  function RangePicker(props) {
	    var _this;
	
	    _classCallCheck(this, RangePicker);
	
	    _this = _super.call(this, props);
	
	    _this.savePicker = function (node) {
	      _this.picker = node;
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      _this.setState({
	        value: []
	      });
	
	      _this.handleChange([]);
	    };
	
	    _this.clearHoverValue = function () {
	      return _this.setState({
	        hoverValue: []
	      });
	    };
	
	    _this.handleChange = function (value) {
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      if (!('value' in props)) {
	        _this.setState(function (_ref) {
	          var showDate = _ref.showDate;
	          return {
	            value: value,
	            showDate: getShowDateFromValue(value) || showDate
	          };
	        });
	      }
	
	      if (value[0] && value[1] && value[0].diff(value[1]) > 0) {
	        value[1] = undefined;
	      }
	
	      var _value3 = _slicedToArray(value, 2),
	          start = _value3[0],
	          end = _value3[1];
	
	      if (typeof props.onChange === 'function') {
	        props.onChange(value, [(0, _utils.formatDate)(start, props.format), (0, _utils.formatDate)(end, props.format)]);
	      }
	    };
	
	    _this.handleOpenChange = function (open) {
	      if (!('open' in _this.props)) {
	        _this.setState({
	          open: open
	        });
	      }
	
	      if (open === false) {
	        _this.clearHoverValue();
	      }
	
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.handleShowDateChange = function (showDate) {
	      return _this.setState({
	        showDate: showDate
	      });
	    };
	
	    _this.handleHoverChange = function (hoverValue) {
	      return _this.setState({
	        hoverValue: hoverValue
	      });
	    };
	
	    _this.handleRangeMouseLeave = function () {
	      if (_this.state.open) {
	        _this.clearHoverValue();
	      }
	    };
	
	    _this.handleCalendarInputSelect = function (value) {
	      var _value4 = _slicedToArray(value, 1),
	          start = _value4[0];
	
	      if (!start) {
	        return;
	      }
	
	      _this.setState(function (_ref2) {
	        var showDate = _ref2.showDate;
	        return {
	          value: value,
	          showDate: getShowDateFromValue(value) || showDate
	        };
	      });
	    };
	
	    _this.handleRangeClick = function (value) {
	      if (typeof value === 'function') {
	        value = value();
	      }
	
	      _this.setValue(value, true);
	
	      var _this$props = _this.props,
	          onOk = _this$props.onOk,
	          onOpenChange = _this$props.onOpenChange;
	
	      if (onOk) {
	        onOk(value);
	      }
	
	      if (onOpenChange) {
	        onOpenChange(false);
	      }
	    };
	
	    _this.renderFooter = function () {
	      var _this$props2 = _this.props,
	          ranges = _this$props2.ranges,
	          renderExtraFooter = _this$props2.renderExtraFooter;
	
	      var _assertThisInitialize2 = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize2.prefixCls,
	          tagPrefixCls = _assertThisInitialize2.tagPrefixCls;
	
	      if (!ranges && !renderExtraFooter) {
	        return null;
	      }
	
	      var customFooter = renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra"),
	        key: "extra"
	      }, renderExtraFooter()) : null;
	      var operations = ranges && Object.keys(ranges).map(function (range) {
	        var value = ranges[range];
	        var hoverValue = typeof value === 'function' ? value.call(_assertThisInitialized(_this)) : value;
	        return /*#__PURE__*/React.createElement(_tag["default"], {
	          key: range,
	          prefixCls: tagPrefixCls,
	          color: "blue",
	          onClick: function onClick() {
	            return _this.handleRangeClick(value);
	          },
	          onMouseEnter: function onMouseEnter() {
	            return _this.setState({
	              hoverValue: hoverValue
	            });
	          },
	          onMouseLeave: _this.handleRangeMouseLeave
	        }, range);
	      });
	      var rangeNode = operations && operations.length > 0 ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra ").concat(prefixCls, "-range-quick-selector"),
	        key: "range"
	      }, operations) : null;
	      return [rangeNode, customFooter];
	    };
	
	    _this.renderRangePicker = function (_ref3) {
	      var _classNames;
	
	      var getPrefixCls = _ref3.getPrefixCls;
	
	      var _assertThisInitialize3 = _assertThisInitialized(_this),
	          state = _assertThisInitialize3.state,
	          props = _assertThisInitialize3.props;
	
	      var value = state.value,
	          showDate = state.showDate,
	          hoverValue = state.hoverValue,
	          open = state.open;
	      var customizePrefixCls = props.prefixCls,
	          customizeTagPrefixCls = props.tagPrefixCls,
	          popupStyle = props.popupStyle,
	          style = props.style,
	          disabledDate = props.disabledDate,
	          disabledTime = props.disabledTime,
	          showTime = props.showTime,
	          showToday = props.showToday,
	          ranges = props.ranges,
	          onOk = props.onOk,
	          locale = props.locale,
	          localeCode = props.localeCode,
	          format = props.format,
	          dateRender = props.dateRender,
	          onCalendarChange = props.onCalendarChange,
	          suffixIcon = props.suffixIcon,
	          separator = props.separator;
	      var prefixCls = getPrefixCls('calendar', customizePrefixCls);
	      var tagPrefixCls = getPrefixCls('tag', customizeTagPrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      _this.tagPrefixCls = tagPrefixCls;
	      fixLocale(value, localeCode);
	      fixLocale(showDate, localeCode);
	      (0, _warning["default"])(!('onOK' in props), 'RangePicker', 'It should be `RangePicker[onOk]`, instead of `onOK`!');
	      var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), showTime), _defineProperty(_classNames, "".concat(prefixCls, "-range-with-ranges"), ranges), _classNames)); // 需要选择时间时，点击 ok 时才触发 onChange
	
	      var pickerChangeHandler = {
	        onChange: _this.handleChange
	      };
	      var calendarProps = {
	        onOk: _this.handleChange
	      };
	
	      if (props.timePicker) {
	        pickerChangeHandler.onChange = function (changedValue) {
	          return _this.handleChange(changedValue);
	        };
	      } else {
	        calendarProps = {};
	      }
	
	      if ('mode' in props) {
	        calendarProps.mode = props.mode;
	      }
	
	      var startPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[0] : locale.lang.rangePlaceholder[0];
	      var endPlaceholder = Array.isArray(props.placeholder) ? props.placeholder[1] : locale.lang.rangePlaceholder[1];
	      var calendar = /*#__PURE__*/React.createElement(_RangeCalendar["default"], _extends({}, calendarProps, {
	        seperator: separator,
	        onChange: onCalendarChange,
	        format: format,
	        prefixCls: prefixCls,
	        className: calendarClassName,
	        renderFooter: _this.renderFooter,
	        timePicker: props.timePicker,
	        disabledDate: disabledDate,
	        disabledTime: disabledTime,
	        dateInputPlaceholder: [startPlaceholder, endPlaceholder],
	        locale: locale.lang,
	        onOk: onOk,
	        dateRender: dateRender,
	        value: showDate,
	        onValueChange: _this.handleShowDateChange,
	        hoverValue: hoverValue,
	        onHoverChange: _this.handleHoverChange,
	        onPanelChange: props.onPanelChange,
	        showToday: showToday,
	        onInputSelect: _this.handleCalendarInputSelect
	      })); // default width for showTime
	
	      var pickerStyle = {};
	
	      if (props.showTime) {
	        pickerStyle.width = style && style.width || 350;
	      }
	
	      var _value5 = _slicedToArray(value, 2),
	          startValue = _value5[0],
	          endValue = _value5[1];
	
	      var clearIcon = !props.disabled && props.allowClear && value && (startValue || endValue) ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection,
	        theme: "filled"
	      }) : null;
	      var inputIcon = /*#__PURE__*/React.createElement(_InputIcon["default"], {
	        suffixIcon: suffixIcon,
	        prefixCls: prefixCls
	      });
	
	      var input = function input(_ref4) {
	        var inputValue = _ref4.value;
	
	        var _inputValue = _slicedToArray(inputValue, 2),
	            start = _inputValue[0],
	            end = _inputValue[1];
	
	        return /*#__PURE__*/React.createElement("span", {
	          className: props.pickerInputClass
	        }, /*#__PURE__*/React.createElement("input", {
	          disabled: props.disabled,
	          readOnly: true,
	          value: (0, _utils.formatDate)(start, props.format),
	          placeholder: startPlaceholder,
	          className: "".concat(prefixCls, "-range-picker-input"),
	          tabIndex: -1
	        }), /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-range-picker-separator")
	        }, " ", separator, " "), /*#__PURE__*/React.createElement("input", {
	          disabled: props.disabled,
	          readOnly: true,
	          value: (0, _utils.formatDate)(end, props.format),
	          placeholder: endPlaceholder,
	          className: "".concat(prefixCls, "-range-picker-input"),
	          tabIndex: -1
	        }), clearIcon, inputIcon);
	      };
	
	      return /*#__PURE__*/React.createElement("span", {
	        ref: _this.savePicker,
	        id: typeof props.id === 'number' ? props.id.toString() : props.id,
	        className: (0, _classnames["default"])(props.className, props.pickerClass),
	        style: _extends(_extends({}, style), pickerStyle),
	        tabIndex: props.disabled ? -1 : 0,
	        onFocus: props.onFocus,
	        onBlur: props.onBlur,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave
	      }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, props, pickerChangeHandler, {
	        calendar: calendar,
	        value: value,
	        open: open,
	        onOpenChange: _this.handleOpenChange,
	        prefixCls: "".concat(prefixCls, "-picker-container"),
	        style: popupStyle
	      }), input));
	    };
	
	    var value = props.value || props.defaultValue || [];
	
	    var _value6 = _slicedToArray(value, 2),
	        start = _value6[0],
	        end = _value6[1];
	
	    if (start && !(0, _interopDefault["default"])(moment).isMoment(start) || end && !(0, _interopDefault["default"])(moment).isMoment(end)) {
	      throw new Error('The value/defaultValue of RangePicker must be a moment object array after `antd@2.0`, ' + 'see: https://u.ant.design/date-picker-value');
	    }
	
	    var pickerValue = !value || isEmptyArray(value) ? props.defaultPickerValue : value;
	    _this.state = {
	      value: value,
	      showDate: pickerValueAdapter(pickerValue || (0, _interopDefault["default"])(moment)()),
	      open: props.open,
	      hoverValue: []
	    };
	    return _this;
	  }
	
	  _createClass(RangePicker, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      if (!('open' in this.props) && prevState.open && !this.state.open) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "setValue",
	    value: function setValue(value, hidePanel) {
	      this.handleChange(value);
	
	      if ((hidePanel || !this.props.showTime) && !('open' in this.props)) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.picker.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.picker.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRangePicker);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var state = null;
	
	      if ('value' in nextProps) {
	        var value = nextProps.value || [];
	        state = {
	          value: value
	        };
	
	        if (!(0, _shallowequal["default"])(nextProps.value, prevState.value)) {
	          state = _extends(_extends({}, state), {
	            showDate: getShowDateFromValue(value, nextProps.mode) || prevState.showDate
	          });
	        }
	      }
	
	      if ('open' in nextProps && prevState.open !== nextProps.open) {
	        state = _extends(_extends({}, state), {
	          open: nextProps.open
	        });
	      }
	
	      return state;
	    }
	  }]);
	
	  return RangePicker;
	}(React.Component);
	
	RangePicker.defaultProps = {
	  allowClear: true,
	  showToday: false,
	  separator: '~'
	};
	(0, _reactLifecyclesCompat.polyfill)(RangePicker);
	var _default = RangePicker;
	exports["default"] = _default;

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var moment = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _rcCalendar = _interopRequireDefault(__webpack_require__(1079));
	
	var _Picker = _interopRequireDefault(__webpack_require__(554));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(149));
	
	var _InputIcon = _interopRequireDefault(__webpack_require__(624));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function formatValue(value, format) {
	  return value && value.format(format) || '';
	}
	
	var WeekPicker = /*#__PURE__*/function (_React$Component) {
	  _inherits(WeekPicker, _React$Component);
	
	  var _super = _createSuper(WeekPicker);
	
	  function WeekPicker(props) {
	    var _this;
	
	    _classCallCheck(this, WeekPicker);
	
	    _this = _super.call(this, props);
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.weekDateRender = function (current) {
	      var selectedValue = _this.state.value;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          prefixCls = _assertThisInitialize.prefixCls;
	
	      var dateRender = _this.props.dateRender;
	      var dateNode = dateRender ? dateRender(current) : current.date();
	
	      if (selectedValue && current.year() === selectedValue.year() && current.week() === selectedValue.week()) {
	        return /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-selected-day")
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-date")
	        }, dateNode));
	      }
	
	      return /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-date")
	      }, dateNode);
	    };
	
	    _this.handleChange = function (value) {
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      _this.props.onChange(value, formatValue(value, _this.props.format));
	    };
	
	    _this.handleOpenChange = function (open) {
	      var onOpenChange = _this.props.onOpenChange;
	
	      if (!('open' in _this.props)) {
	        _this.setState({
	          open: open
	        });
	      }
	
	      if (onOpenChange) {
	        onOpenChange(open);
	      }
	    };
	
	    _this.clearSelection = function (e) {
	      e.preventDefault();
	      e.stopPropagation();
	
	      _this.handleChange(null);
	    };
	
	    _this.renderFooter = function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          renderExtraFooter = _this$props.renderExtraFooter;
	      return renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer-extra")
	      }, renderExtraFooter.apply(void 0, arguments)) : null;
	    };
	
	    _this.renderWeekPicker = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props2 = _this.props,
	          customizePrefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          disabled = _this$props2.disabled,
	          pickerClass = _this$props2.pickerClass,
	          popupStyle = _this$props2.popupStyle,
	          pickerInputClass = _this$props2.pickerInputClass,
	          format = _this$props2.format,
	          allowClear = _this$props2.allowClear,
	          locale = _this$props2.locale,
	          localeCode = _this$props2.localeCode,
	          disabledDate = _this$props2.disabledDate,
	          style = _this$props2.style,
	          onFocus = _this$props2.onFocus,
	          onBlur = _this$props2.onBlur,
	          id = _this$props2.id,
	          suffixIcon = _this$props2.suffixIcon,
	          defaultPickerValue = _this$props2.defaultPickerValue;
	      var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
	      // Have to add prefixCls on the instance.
	      // https://github.com/facebook/react/issues/12397
	
	      _this.prefixCls = prefixCls;
	      var _this$state = _this.state,
	          open = _this$state.open,
	          pickerValue = _this$state.value;
	
	      if (pickerValue && localeCode) {
	        pickerValue.locale(localeCode);
	      }
	
	      var placeholder = 'placeholder' in _this.props ? _this.props.placeholder : locale.lang.placeholder;
	      var calendar = /*#__PURE__*/React.createElement(_rcCalendar["default"], {
	        showWeekNumber: true,
	        dateRender: _this.weekDateRender,
	        prefixCls: prefixCls,
	        format: format,
	        locale: locale.lang,
	        showDateInput: false,
	        showToday: false,
	        disabledDate: disabledDate,
	        renderFooter: _this.renderFooter,
	        defaultValue: defaultPickerValue
	      });
	      var clearIcon = !disabled && allowClear && _this.state.value ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        className: "".concat(prefixCls, "-picker-clear"),
	        onClick: _this.clearSelection,
	        theme: "filled"
	      }) : null;
	      var inputIcon = /*#__PURE__*/React.createElement(_InputIcon["default"], {
	        suffixIcon: suffixIcon,
	        prefixCls: prefixCls
	      });
	
	      var input = function input(_ref2) {
	        var value = _ref2.value;
	        return /*#__PURE__*/React.createElement("span", {
	          style: {
	            display: 'inline-block',
	            width: '100%'
	          }
	        }, /*#__PURE__*/React.createElement("input", {
	          ref: _this.saveInput,
	          disabled: disabled,
	          readOnly: true,
	          value: value && value.format(format) || '',
	          placeholder: placeholder,
	          className: pickerInputClass,
	          onFocus: onFocus,
	          onBlur: onBlur
	        }), clearIcon, inputIcon);
	      };
	
	      return /*#__PURE__*/React.createElement("span", {
	        className: (0, _classnames["default"])(className, pickerClass),
	        style: style,
	        id: id
	      }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, _this.props, {
	        calendar: calendar,
	        prefixCls: "".concat(prefixCls, "-picker-container"),
	        value: pickerValue,
	        onChange: _this.handleChange,
	        open: open,
	        onOpenChange: _this.handleOpenChange,
	        style: popupStyle
	      }), input));
	    };
	
	    var value = props.value || props.defaultValue;
	
	    if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	      throw new Error('The value/defaultValue of WeekPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
	    }
	
	    _this.state = {
	      value: value,
	      open: props.open
	    };
	    return _this;
	  }
	
	  _createClass(WeekPicker, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      if (!('open' in this.props) && prevState.open && !this.state.open) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWeekPicker);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps || 'open' in nextProps) {
	        var state = {};
	
	        if ('value' in nextProps) {
	          state.value = nextProps.value;
	        }
	
	        if ('open' in nextProps) {
	          state.open = nextProps.open;
	        }
	
	        return state;
	      }
	
	      return null;
	    }
	  }]);
	
	  return WeekPicker;
	}(React.Component);
	
	WeekPicker.defaultProps = {
	  format: 'gggg-wo',
	  allowClear: true
	};
	(0, _reactLifecyclesCompat.polyfill)(WeekPicker);
	var _default = WeekPicker;
	exports["default"] = _default;

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createPicker;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var moment = _interopRequireWildcard(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _MonthCalendar = _interopRequireDefault(__webpack_require__(1072));
	
	var _Picker = _interopRequireDefault(__webpack_require__(554));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(149));
	
	var _getDataOrAriaProps = _interopRequireDefault(__webpack_require__(612));
	
	var _utils = __webpack_require__(626);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function createPicker(TheCalendar) {
	  var CalenderWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(CalenderWrapper, _React$Component);
	
	    var _super = _createSuper(CalenderWrapper);
	
	    function CalenderWrapper(props) {
	      var _this;
	
	      _classCallCheck(this, CalenderWrapper);
	
	      _this = _super.call(this, props);
	
	      _this.saveInput = function (node) {
	        _this.input = node;
	      };
	
	      _this.clearSelection = function (e) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        _this.handleChange(null);
	      };
	
	      _this.handleChange = function (value) {
	        var _assertThisInitialize = _assertThisInitialized(_this),
	            props = _assertThisInitialize.props;
	
	        if (!('value' in props)) {
	          _this.setState({
	            value: value,
	            showDate: value
	          });
	        }
	
	        props.onChange(value, (0, _utils.formatDate)(value, props.format));
	      };
	
	      _this.handleCalendarChange = function (value) {
	        _this.setState({
	          showDate: value
	        });
	      };
	
	      _this.handleOpenChange = function (open) {
	        var onOpenChange = _this.props.onOpenChange;
	
	        if (!('open' in _this.props)) {
	          _this.setState({
	            open: open
	          });
	        }
	
	        if (onOpenChange) {
	          onOpenChange(open);
	        }
	      };
	
	      _this.renderFooter = function () {
	        var renderExtraFooter = _this.props.renderExtraFooter;
	
	        var _assertThisInitialize2 = _assertThisInitialized(_this),
	            prefixCls = _assertThisInitialize2.prefixCls;
	
	        return renderExtraFooter ? /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-footer-extra")
	        }, renderExtraFooter.apply(void 0, arguments)) : null;
	      };
	
	      _this.renderPicker = function (_ref) {
	        var _classNames, _classNames2;
	
	        var getPrefixCls = _ref.getPrefixCls;
	        var _this$state = _this.state,
	            value = _this$state.value,
	            showDate = _this$state.showDate,
	            open = _this$state.open;
	        var props = (0, _omit["default"])(_this.props, ['onChange']);
	        var customizePrefixCls = props.prefixCls,
	            locale = props.locale,
	            localeCode = props.localeCode,
	            suffixIcon = props.suffixIcon;
	        var prefixCls = getPrefixCls('calendar', customizePrefixCls); // To support old version react.
	        // Have to add prefixCls on the instance.
	        // https://github.com/facebook/react/issues/12397
	
	        _this.prefixCls = prefixCls;
	        var placeholder = 'placeholder' in props ? props.placeholder : locale.lang.placeholder;
	        var disabledTime = props.showTime ? props.disabledTime : null;
	        var calendarClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-time"), props.showTime), _defineProperty(_classNames, "".concat(prefixCls, "-month"), _MonthCalendar["default"] === TheCalendar), _classNames));
	
	        if (value && localeCode) {
	          value.locale(localeCode);
	        }
	
	        var pickerProps = {};
	        var calendarProps = {};
	        var pickerStyle = {};
	
	        if (props.showTime) {
	          calendarProps = {
	            // fix https://github.com/ant-design/ant-design/issues/1902
	            onSelect: _this.handleChange
	          };
	          pickerStyle.minWidth = 195;
	        } else {
	          pickerProps = {
	            onChange: _this.handleChange
	          };
	        }
	
	        if ('mode' in props) {
	          calendarProps.mode = props.mode;
	        }
	
	        (0, _warning["default"])(!('onOK' in props), 'DatePicker', 'It should be `DatePicker[onOk]` or `MonthPicker[onOk]`, instead of `onOK`!');
	        var calendar = /*#__PURE__*/React.createElement(TheCalendar, _extends({}, calendarProps, {
	          disabledDate: props.disabledDate,
	          disabledTime: disabledTime,
	          locale: locale.lang,
	          timePicker: props.timePicker,
	          defaultValue: props.defaultPickerValue || (0, _interopDefault["default"])(moment)(),
	          dateInputPlaceholder: placeholder,
	          prefixCls: prefixCls,
	          className: calendarClassName,
	          onOk: props.onOk,
	          dateRender: props.dateRender,
	          format: props.format,
	          showToday: props.showToday,
	          monthCellContentRender: props.monthCellContentRender,
	          renderFooter: _this.renderFooter,
	          onPanelChange: props.onPanelChange,
	          onChange: _this.handleCalendarChange,
	          value: showDate
	        }));
	        var clearIcon = !props.disabled && props.allowClear && value ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close-circle",
	          className: "".concat(prefixCls, "-picker-clear"),
	          onClick: _this.clearSelection,
	          theme: "filled"
	        }) : null;
	        var inputIcon = suffixIcon && ( /*#__PURE__*/React.isValidElement(suffixIcon) ? /*#__PURE__*/React.cloneElement(suffixIcon, {
	          className: (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, suffixIcon.props.className, suffixIcon.props.className), _defineProperty(_classNames2, "".concat(prefixCls, "-picker-icon"), true), _classNames2))
	        }) : /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-picker-icon")
	        }, suffixIcon)) || /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "calendar",
	          className: "".concat(prefixCls, "-picker-icon")
	        });
	        var dataOrAriaProps = (0, _getDataOrAriaProps["default"])(props);
	
	        var input = function input(_ref2) {
	          var inputValue = _ref2.value;
	          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({
	            ref: _this.saveInput,
	            disabled: props.disabled,
	            readOnly: true,
	            value: (0, _utils.formatDate)(inputValue, props.format),
	            placeholder: placeholder,
	            className: props.pickerInputClass,
	            tabIndex: props.tabIndex,
	            name: props.name
	          }, dataOrAriaProps)), clearIcon, inputIcon);
	        };
	
	        return /*#__PURE__*/React.createElement("span", {
	          id: props.id,
	          className: (0, _classnames["default"])(props.className, props.pickerClass),
	          style: _extends(_extends({}, pickerStyle), props.style),
	          onFocus: props.onFocus,
	          onBlur: props.onBlur,
	          onMouseEnter: props.onMouseEnter,
	          onMouseLeave: props.onMouseLeave
	        }, /*#__PURE__*/React.createElement(_Picker["default"], _extends({}, props, pickerProps, {
	          calendar: calendar,
	          value: value,
	          prefixCls: "".concat(prefixCls, "-picker-container"),
	          style: props.popupStyle,
	          open: open,
	          onOpenChange: _this.handleOpenChange
	        }), input));
	      };
	
	      var value = props.value || props.defaultValue;
	
	      if (value && !(0, _interopDefault["default"])(moment).isMoment(value)) {
	        throw new Error('The value/defaultValue of DatePicker or MonthPicker must be ' + 'a moment object after `antd@2.0`, see: https://u.ant.design/date-picker-value');
	      }
	
	      _this.state = {
	        value: value,
	        showDate: value,
	        open: false
	      };
	      return _this;
	    }
	
	    _createClass(CalenderWrapper, [{
	      key: "componentDidUpdate",
	      value: function componentDidUpdate(_, prevState) {
	        if (!('open' in this.props) && prevState.open && !this.state.open) {
	          this.focus();
	        }
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.input.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.input.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderPicker);
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(nextProps, prevState) {
	        var state = {};
	        var open = prevState.open;
	
	        if ('open' in nextProps) {
	          state.open = nextProps.open;
	          open = nextProps.open || false;
	        }
	
	        if ('value' in nextProps) {
	          state.value = nextProps.value;
	
	          if (nextProps.value !== prevState.value || !open && nextProps.value !== prevState.showDate) {
	            state.showDate = nextProps.value;
	          }
	        }
	
	        return Object.keys(state).length > 0 ? state : null;
	      }
	    }]);
	
	    return CalenderWrapper;
	  }(React.Component);
	
	  CalenderWrapper.defaultProps = {
	    allowClear: true,
	    showToday: true
	  };
	  (0, _reactLifecyclesCompat.polyfill)(CalenderWrapper);
	  return CalenderWrapper;
	}

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _rcCalendar = _interopRequireDefault(__webpack_require__(1079));
	
	var _MonthCalendar = _interopRequireDefault(__webpack_require__(1072));
	
	var _createPicker = _interopRequireDefault(__webpack_require__(1260));
	
	var _wrapPicker = _interopRequireDefault(__webpack_require__(1262));
	
	var _RangePicker = _interopRequireDefault(__webpack_require__(1258));
	
	var _WeekPicker = _interopRequireDefault(__webpack_require__(1259));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var DatePicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_rcCalendar["default"]), 'date');
	var MonthPicker = (0, _wrapPicker["default"])((0, _createPicker["default"])(_MonthCalendar["default"]), 'month');
	
	_extends(DatePicker, {
	  RangePicker: (0, _wrapPicker["default"])(_RangePicker["default"], 'date'),
	  MonthPicker: MonthPicker,
	  WeekPicker: (0, _wrapPicker["default"])(_WeekPicker["default"], 'week')
	});
	
	var _default = DatePicker;
	exports["default"] = _default;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = wrapPicker;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _Panel = _interopRequireDefault(__webpack_require__(1109));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var moment = _interopRequireWildcard(__webpack_require__(3));
	
	var _en_US = _interopRequireDefault(__webpack_require__(405));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(149));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _timePicker = __webpack_require__(644);
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var DEFAULT_FORMAT = {
	  date: 'YYYY-MM-DD',
	  dateTime: 'YYYY-MM-DD HH:mm:ss',
	  week: 'gggg-wo',
	  month: 'YYYY-MM'
	};
	var LOCALE_FORMAT_MAPPING = {
	  date: 'dateFormat',
	  dateTime: 'dateTimeFormat',
	  week: 'weekFormat',
	  month: 'monthFormat'
	};
	
	function getColumns(_ref) {
	  var showHour = _ref.showHour,
	      showMinute = _ref.showMinute,
	      showSecond = _ref.showSecond,
	      use12Hours = _ref.use12Hours;
	  var column = 0;
	
	  if (showHour) {
	    column += 1;
	  }
	
	  if (showMinute) {
	    column += 1;
	  }
	
	  if (showSecond) {
	    column += 1;
	  }
	
	  if (use12Hours) {
	    column += 1;
	  }
	
	  return column;
	}
	
	function checkValidate(value, propName) {
	  var values = Array.isArray(value) ? value : [value];
	  values.forEach(function (val) {
	    if (!val) return;
	    (0, _warning["default"])(!(0, _interopDefault["default"])(moment).isMoment(val) || val.isValid(), 'DatePicker', "`".concat(propName, "` provides invalidate moment time. If you want to set empty value, use `null` instead."));
	  });
	}
	
	function wrapPicker(Picker, pickerType) {
	  var PickerWrapper = /*#__PURE__*/function (_React$Component) {
	    _inherits(PickerWrapper, _React$Component);
	
	    var _super = _createSuper(PickerWrapper);
	
	    function PickerWrapper() {
	      var _this;
	
	      _classCallCheck(this, PickerWrapper);
	
	      _this = _super.apply(this, arguments); // Since we need call `getDerivedStateFromProps` for check. Need leave an empty `state` here.
	
	      _this.state = {};
	
	      _this.savePicker = function (node) {
	        _this.picker = node;
	      };
	
	      _this.getDefaultLocale = function () {
	        var result = _extends(_extends({}, _en_US["default"]), _this.props.locale);
	
	        result.lang = _extends(_extends({}, result.lang), (_this.props.locale || {}).lang);
	        return result;
	      };
	
	      _this.handleOpenChange = function (open) {
	        var onOpenChange = _this.props.onOpenChange;
	        onOpenChange(open);
	      };
	
	      _this.handleFocus = function (e) {
	        var onFocus = _this.props.onFocus;
	
	        if (onFocus) {
	          onFocus(e);
	        }
	      };
	
	      _this.handleBlur = function (e) {
	        var onBlur = _this.props.onBlur;
	
	        if (onBlur) {
	          onBlur(e);
	        }
	      };
	
	      _this.handleMouseEnter = function (e) {
	        var onMouseEnter = _this.props.onMouseEnter;
	
	        if (onMouseEnter) {
	          onMouseEnter(e);
	        }
	      };
	
	      _this.handleMouseLeave = function (e) {
	        var onMouseLeave = _this.props.onMouseLeave;
	
	        if (onMouseLeave) {
	          onMouseLeave(e);
	        }
	      };
	
	      _this.renderPicker = function (locale, localeCode) {
	        var _this$props = _this.props,
	            format = _this$props.format,
	            showTime = _this$props.showTime;
	        var mergedPickerType = showTime ? "".concat(pickerType, "Time") : pickerType;
	        var mergedFormat = format || locale[LOCALE_FORMAT_MAPPING[mergedPickerType]] || DEFAULT_FORMAT[mergedPickerType];
	        return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	          var _classNames2;
	
	          var getPrefixCls = _ref2.getPrefixCls,
	              getContextPopupContainer = _ref2.getPopupContainer;
	          var _this$props2 = _this.props,
	              customizePrefixCls = _this$props2.prefixCls,
	              customizeInputPrefixCls = _this$props2.inputPrefixCls,
	              getCalendarContainer = _this$props2.getCalendarContainer,
	              size = _this$props2.size,
	              disabled = _this$props2.disabled;
	          var getPopupContainer = getCalendarContainer || getContextPopupContainer;
	          var prefixCls = getPrefixCls('calendar', customizePrefixCls);
	          var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	          var pickerClass = (0, _classnames["default"])("".concat(prefixCls, "-picker"), _defineProperty({}, "".concat(prefixCls, "-picker-").concat(size), !!size));
	          var pickerInputClass = (0, _classnames["default"])("".concat(prefixCls, "-picker-input"), inputPrefixCls, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(inputPrefixCls, "-lg"), size === 'large'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-sm"), size === 'small'), _defineProperty(_classNames2, "".concat(inputPrefixCls, "-disabled"), disabled), _classNames2));
	          var timeFormat = showTime && showTime.format || 'HH:mm:ss';
	
	          var rcTimePickerProps = _extends(_extends({}, (0, _timePicker.generateShowHourMinuteSecond)(timeFormat)), {
	            format: timeFormat,
	            use12Hours: showTime && showTime.use12Hours
	          });
	
	          var columns = getColumns(rcTimePickerProps);
	          var timePickerCls = "".concat(prefixCls, "-time-picker-column-").concat(columns);
	          var timePicker = showTime ? /*#__PURE__*/React.createElement(_Panel["default"], _extends({}, rcTimePickerProps, showTime, {
	            prefixCls: "".concat(prefixCls, "-time-picker"),
	            className: timePickerCls,
	            placeholder: locale.timePickerLocale.placeholder,
	            transitionName: "slide-up",
	            onEsc: function onEsc() {}
	          })) : null;
	          return /*#__PURE__*/React.createElement(Picker, _extends({}, _this.props, {
	            getCalendarContainer: getPopupContainer,
	            format: mergedFormat,
	            ref: _this.savePicker,
	            pickerClass: pickerClass,
	            pickerInputClass: pickerInputClass,
	            locale: locale,
	            localeCode: localeCode,
	            timePicker: timePicker,
	            onOpenChange: _this.handleOpenChange,
	            onFocus: _this.handleFocus,
	            onBlur: _this.handleBlur,
	            onMouseEnter: _this.handleMouseEnter,
	            onMouseLeave: _this.handleMouseLeave
	          }));
	        });
	      };
	
	      return _this;
	    }
	
	    _createClass(PickerWrapper, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        var _this$props3 = this.props,
	            autoFocus = _this$props3.autoFocus,
	            disabled = _this$props3.disabled;
	
	        if (autoFocus && !disabled) {
	          this.focus();
	        }
	      }
	    }, {
	      key: "focus",
	      value: function focus() {
	        this.picker.focus();
	      }
	    }, {
	      key: "blur",
	      value: function blur() {
	        this.picker.blur();
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	          componentName: "DatePicker",
	          defaultLocale: this.getDefaultLocale
	        }, this.renderPicker);
	      }
	    }], [{
	      key: "getDerivedStateFromProps",
	      value: function getDerivedStateFromProps(_ref3) {
	        var value = _ref3.value,
	            defaultValue = _ref3.defaultValue;
	        checkValidate(defaultValue, 'defaultValue');
	        checkValidate(value, 'value');
	        return {};
	      }
	    }]);
	
	    return PickerWrapper;
	  }(React.Component);
	
	  PickerWrapper.defaultProps = {
	    transitionName: 'slide-up',
	    popupStyle: {},
	    onChange: function onChange() {},
	    onOk: function onOk() {},
	    onOpenChange: function onOpenChange() {},
	    locale: {}
	  };
	  (0, _reactLifecyclesCompat.polyfill)(PickerWrapper);
	  return PickerWrapper;
	}

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Col = function Col(props) {
	  var _classNames;
	
	  var child = props.child,
	      bordered = props.bordered,
	      colon = props.colon,
	      type = props.type,
	      layout = props.layout;
	  var _child$props = child.props,
	      prefixCls = _child$props.prefixCls,
	      label = _child$props.label,
	      className = _child$props.className,
	      children = _child$props.children,
	      _child$props$span = _child$props.span,
	      span = _child$props$span === void 0 ? 1 : _child$props$span;
	  var labelProps = {
	    className: (0, _classnames["default"])("".concat(prefixCls, "-item-label"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-colon"), colon), _defineProperty(_classNames, "".concat(prefixCls, "-item-no-label"), !label), _classNames)),
	    key: 'label'
	  };
	
	  if (layout === 'vertical') {
	    labelProps.colSpan = span * 2 - 1;
	  }
	
	  if (bordered) {
	    if (type === 'label') {
	      return /*#__PURE__*/React.createElement("th", labelProps, label);
	    }
	
	    return /*#__PURE__*/React.createElement("td", {
	      className: (0, _classnames["default"])("".concat(prefixCls, "-item-content"), className),
	      key: "content",
	      colSpan: span * 2 - 1
	    }, children);
	  }
	
	  if (layout === 'vertical') {
	    if (type === 'content') {
	      return /*#__PURE__*/React.createElement("td", {
	        colSpan: span,
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	      }, /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-content"),
	        key: "content"
	      }, children));
	    }
	
	    return /*#__PURE__*/React.createElement("td", {
	      colSpan: span,
	      className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	    }, /*#__PURE__*/React.createElement("span", {
	      className: (0, _classnames["default"])("".concat(prefixCls, "-item-label"), _defineProperty({}, "".concat(prefixCls, "-item-colon"), colon)),
	      key: "label"
	    }, label));
	  }
	
	  return /*#__PURE__*/React.createElement("td", {
	    colSpan: span,
	    className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className)
	  }, /*#__PURE__*/React.createElement("span", labelProps, label), /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-item-content"),
	    key: "content"
	  }, children));
	};
	
	var _default = Col;
	exports["default"] = _default;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _toArray = _interopRequireDefault(__webpack_require__(112));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _responsiveObserve = _interopRequireWildcard(__webpack_require__(615));
	
	var _configProvider = __webpack_require__(11);
	
	var _Col = _interopRequireDefault(__webpack_require__(1263));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	// https://github.com/smooth-code/react-flatten-children/
	function flattenChildren(children) {
	  if (!children) {
	    return [];
	  }
	
	  return (0, _toArray["default"])(children).reduce(function (flatChildren, child) {
	    if (child && child.type === React.Fragment) {
	      return flatChildren.concat(flattenChildren(child.props.children));
	    }
	
	    flatChildren.push(child);
	    return flatChildren;
	  }, []);
	}
	
	var DescriptionsItem = function DescriptionsItem(_ref) {
	  var children = _ref.children;
	  return children;
	};
	/**
	 * Convert children into `column` groups.
	 * @param children: DescriptionsItem
	 * @param column: number
	 */
	
	
	var generateChildrenRows = function generateChildrenRows(children, column) {
	  var rows = [];
	  var columns = null;
	  var leftSpans;
	  var itemNodes = flattenChildren(children);
	  itemNodes.forEach(function (node, index) {
	    var itemNode = node;
	
	    if (!columns) {
	      leftSpans = column;
	      columns = [];
	      rows.push(columns);
	    } // Always set last span to align the end of Descriptions
	
	
	    var lastItem = index === itemNodes.length - 1;
	    var lastSpanSame = true;
	
	    if (lastItem) {
	      lastSpanSame = !itemNode.props.span || itemNode.props.span === leftSpans;
	      itemNode = /*#__PURE__*/React.cloneElement(itemNode, {
	        span: leftSpans
	      });
	    } // Calculate left fill span
	
	
	    var _itemNode$props$span = itemNode.props.span,
	        span = _itemNode$props$span === void 0 ? 1 : _itemNode$props$span;
	    columns.push(itemNode);
	    leftSpans -= span;
	
	    if (leftSpans <= 0) {
	      columns = null;
	      (0, _warning["default"])(leftSpans === 0 && lastSpanSame, 'Descriptions', 'Sum of column `span` in a line exceeds `column` of Descriptions.');
	    }
	  });
	  return rows;
	};
	
	var renderRow = function renderRow(children, index, _ref2, bordered, layout, colon) {
	  var prefixCls = _ref2.prefixCls;
	
	  var renderCol = function renderCol(colItem, type, idx) {
	    return /*#__PURE__*/React.createElement(_Col["default"], {
	      child: colItem,
	      bordered: bordered,
	      colon: colon,
	      type: type,
	      key: "".concat(type, "-").concat(colItem.key || idx),
	      layout: layout
	    });
	  };
	
	  var cloneChildren = [];
	  var cloneContentChildren = [];
	  flattenChildren(children).forEach(function (childrenItem, idx) {
	    cloneChildren.push(renderCol(childrenItem, 'label', idx));
	
	    if (layout === 'vertical') {
	      cloneContentChildren.push(renderCol(childrenItem, 'content', idx));
	    } else if (bordered) {
	      cloneChildren.push(renderCol(childrenItem, 'content', idx));
	    }
	  });
	
	  if (layout === 'vertical') {
	    return [/*#__PURE__*/React.createElement("tr", {
	      className: "".concat(prefixCls, "-row"),
	      key: "label-".concat(index)
	    }, cloneChildren), /*#__PURE__*/React.createElement("tr", {
	      className: "".concat(prefixCls, "-row"),
	      key: "content-".concat(index)
	    }, cloneContentChildren)];
	  }
	
	  return /*#__PURE__*/React.createElement("tr", {
	    className: "".concat(prefixCls, "-row"),
	    key: index
	  }, cloneChildren);
	};
	
	var defaultColumnMap = {
	  xxl: 3,
	  xl: 3,
	  lg: 3,
	  md: 3,
	  sm: 2,
	  xs: 1
	};
	
	var Descriptions = /*#__PURE__*/function (_React$Component) {
	  _inherits(Descriptions, _React$Component);
	
	  var _super = _createSuper(Descriptions);
	
	  function Descriptions() {
	    var _this;
	
	    _classCallCheck(this, Descriptions);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      screens: {}
	    };
	    return _this;
	  }
	
	  _createClass(Descriptions, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var column = this.props.column;
	      this.token = _responsiveObserve["default"].subscribe(function (screens) {
	        if (_typeof(column) !== 'object') {
	          return;
	        }
	
	        _this2.setState({
	          screens: screens
	        });
	      });
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _responsiveObserve["default"].unsubscribe(this.token);
	    }
	  }, {
	    key: "getColumn",
	    value: function getColumn() {
	      var column = this.props.column;
	
	      if (_typeof(column) === 'object') {
	        for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
	          var breakpoint = _responsiveObserve.responsiveArray[i];
	
	          if (this.state.screens[breakpoint] && column[breakpoint] !== undefined) {
	            return column[breakpoint] || defaultColumnMap[breakpoint];
	          }
	        }
	      } // If the configuration is not an object, it is a number, return number
	
	
	      if (typeof column === 'number') {
	        return column;
	      } // If it is an object, but no response is found, this happens only in the test.
	      // Maybe there are some strange environments
	
	
	      return 3;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref3) {
	        var _classNames;
	
	        var getPrefixCls = _ref3.getPrefixCls;
	        var _this3$props = _this3.props,
	            className = _this3$props.className,
	            customizePrefixCls = _this3$props.prefixCls,
	            title = _this3$props.title,
	            size = _this3$props.size,
	            children = _this3$props.children,
	            _this3$props$bordered = _this3$props.bordered,
	            bordered = _this3$props$bordered === void 0 ? false : _this3$props$bordered,
	            _this3$props$layout = _this3$props.layout,
	            layout = _this3$props$layout === void 0 ? 'horizontal' : _this3$props$layout,
	            _this3$props$colon = _this3$props.colon,
	            colon = _this3$props$colon === void 0 ? true : _this3$props$colon,
	            style = _this3$props.style;
	        var prefixCls = getPrefixCls('descriptions', customizePrefixCls);
	
	        var column = _this3.getColumn();
	
	        var cloneChildren = flattenChildren(children).map(function (child) {
	          if ( /*#__PURE__*/React.isValidElement(child)) {
	            return /*#__PURE__*/React.cloneElement(child, {
	              prefixCls: prefixCls
	            });
	          }
	
	          return null;
	        }).filter(function (node) {
	          return node;
	        });
	        var childrenArray = generateChildrenRows(cloneChildren, column);
	        return /*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size !== 'default'), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), !!bordered), _classNames)),
	          style: style
	        }, title && /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-title")
	        }, title), /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-view")
	        }, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, childrenArray.map(function (child, index) {
	          return renderRow(child, index, {
	            prefixCls: prefixCls
	          }, bordered, layout, colon);
	        })))));
	      });
	    }
	  }]);
	
	  return Descriptions;
	}(React.Component);
	
	Descriptions.defaultProps = {
	  size: 'default',
	  column: defaultColumnMap
	};
	Descriptions.Item = DescriptionsItem;
	var _default = Descriptions;
	exports["default"] = _default;

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Divider = function Divider(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	    var _classNames;
	
	    var getPrefixCls = _ref.getPrefixCls;
	
	    var customizePrefixCls = props.prefixCls,
	        _props$type = props.type,
	        type = _props$type === void 0 ? 'horizontal' : _props$type,
	        _props$orientation = props.orientation,
	        orientation = _props$orientation === void 0 ? 'center' : _props$orientation,
	        className = props.className,
	        children = props.children,
	        dashed = props.dashed,
	        restProps = __rest(props, ["prefixCls", "type", "orientation", "className", "children", "dashed"]);
	
	    var prefixCls = getPrefixCls('divider', customizePrefixCls);
	    var orientationPrefix = orientation.length > 0 ? "-".concat(orientation) : orientation;
	    var classString = (0, _classnames["default"])(className, prefixCls, "".concat(prefixCls, "-").concat(type), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-text").concat(orientationPrefix), children), _defineProperty(_classNames, "".concat(prefixCls, "-dashed"), !!dashed), _classNames));
	    return /*#__PURE__*/React.createElement("div", _extends({
	      className: classString
	    }, restProps, {
	      role: "separator"
	    }), children && /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-inner-text")
	    }, children));
	  });
	};
	
	var _default = Divider;
	exports["default"] = _default;

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcDrawer = _interopRequireDefault(__webpack_require__(2665));
	
	var _createReactContext = _interopRequireDefault(__webpack_require__(129));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _context = __webpack_require__(317);
	
	var _type = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var DrawerContext = (0, _createReactContext["default"])(null);
	var PlacementTypes = (0, _type.tuple)('top', 'right', 'bottom', 'left');
	
	var Drawer = /*#__PURE__*/function (_React$Component) {
	  _inherits(Drawer, _React$Component);
	
	  var _super = _createSuper(Drawer);
	
	  function Drawer() {
	    var _this;
	
	    _classCallCheck(this, Drawer);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      push: false
	    };
	
	    _this.push = function () {
	      _this.setState({
	        push: true
	      });
	    };
	
	    _this.pull = function () {
	      _this.setState({
	        push: false
	      });
	    };
	
	    _this.onDestroyTransitionEnd = function () {
	      var isDestroyOnClose = _this.getDestroyOnClose();
	
	      if (!isDestroyOnClose) {
	        return;
	      }
	
	      if (!_this.props.visible) {
	        _this.destroyClose = true;
	
	        _this.forceUpdate();
	      }
	    };
	
	    _this.getDestroyOnClose = function () {
	      return _this.props.destroyOnClose && !_this.props.visible;
	    }; // get drawer push width or height
	
	
	    _this.getPushTransform = function (placement) {
	      if (placement === 'left' || placement === 'right') {
	        return "translateX(".concat(placement === 'left' ? 180 : -180, "px)");
	      }
	
	      if (placement === 'top' || placement === 'bottom') {
	        return "translateY(".concat(placement === 'top' ? 180 : -180, "px)");
	      }
	    };
	
	    _this.getRcDrawerStyle = function () {
	      var _this$props = _this.props,
	          zIndex = _this$props.zIndex,
	          placement = _this$props.placement,
	          style = _this$props.style;
	      var push = _this.state.push;
	      return _extends({
	        zIndex: zIndex,
	        transform: push ? _this.getPushTransform(placement) : undefined
	      }, style);
	    }; // render drawer body dom
	
	
	    _this.renderBody = function () {
	      var _this$props2 = _this.props,
	          bodyStyle = _this$props2.bodyStyle,
	          drawerStyle = _this$props2.drawerStyle,
	          prefixCls = _this$props2.prefixCls,
	          visible = _this$props2.visible;
	
	      if (_this.destroyClose && !visible) {
	        return null;
	      }
	
	      _this.destroyClose = false;
	      var containerStyle = {};
	
	      var isDestroyOnClose = _this.getDestroyOnClose();
	
	      if (isDestroyOnClose) {
	        // Increase the opacity transition, delete children after closing.
	        containerStyle.opacity = 0;
	        containerStyle.transition = 'opacity .3s';
	      }
	
	      return /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-wrapper-body"),
	        style: _extends(_extends({}, containerStyle), drawerStyle),
	        onTransitionEnd: _this.onDestroyTransitionEnd
	      }, _this.renderHeader(), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-body"),
	        style: bodyStyle
	      }, _this.props.children));
	    }; // render Provider for Multi-level drawer
	
	
	    _this.renderProvider = function (value) {
	      var _a = _this.props,
	          prefixCls = _a.prefixCls,
	          placement = _a.placement,
	          className = _a.className,
	          wrapClassName = _a.wrapClassName,
	          width = _a.width,
	          height = _a.height,
	          mask = _a.mask,
	          rest = __rest(_a, ["prefixCls", "placement", "className", "wrapClassName", "width", "height", "mask"]);
	
	      (0, _warning["default"])(wrapClassName === undefined, 'Drawer', 'wrapClassName is deprecated, please use className instead.');
	      var haveMask = mask ? '' : 'no-mask';
	      _this.parentDrawer = value;
	      var offsetStyle = {};
	
	      if (placement === 'left' || placement === 'right') {
	        offsetStyle.width = width;
	      } else {
	        offsetStyle.height = height;
	      }
	
	      return /*#__PURE__*/React.createElement(DrawerContext.Provider, {
	        value: _assertThisInitialized(_this)
	      }, /*#__PURE__*/React.createElement(_rcDrawer["default"], _extends({
	        handler: false
	      }, (0, _omit["default"])(rest, ['zIndex', 'style', 'closable', 'destroyOnClose', 'drawerStyle', 'headerStyle', 'bodyStyle', 'title', 'push', 'visible', 'getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'pageHeader', 'autoInsertSpaceInButton']), offsetStyle, {
	        prefixCls: prefixCls,
	        open: _this.props.visible,
	        showMask: mask,
	        placement: placement,
	        style: _this.getRcDrawerStyle(),
	        className: (0, _classnames["default"])(wrapClassName, className, haveMask)
	      }), _this.renderBody()));
	    };
	
	    return _this;
	  }
	
	  _createClass(Drawer, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // fix: delete drawer in child and re-render, no push started.
	      // <Drawer>{show && <Drawer />}</Drawer>
	      var visible = this.props.visible;
	
	      if (visible && this.parentDrawer) {
	        this.parentDrawer.push();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(preProps) {
	      var visible = this.props.visible;
	
	      if (preProps.visible !== visible && this.parentDrawer) {
	        if (visible) {
	          this.parentDrawer.push();
	        } else {
	          this.parentDrawer.pull();
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // unmount drawer in child, clear push.
	      if (this.parentDrawer) {
	        this.parentDrawer.pull();
	        this.parentDrawer = null;
	      }
	    }
	  }, {
	    key: "renderHeader",
	    value: function renderHeader() {
	      var _this$props3 = this.props,
	          title = _this$props3.title,
	          prefixCls = _this$props3.prefixCls,
	          closable = _this$props3.closable,
	          headerStyle = _this$props3.headerStyle;
	
	      if (!title && !closable) {
	        return null;
	      }
	
	      var headerClassName = title ? "".concat(prefixCls, "-header") : "".concat(prefixCls, "-header-no-title");
	      return /*#__PURE__*/React.createElement("div", {
	        className: headerClassName,
	        style: headerStyle
	      }, title && /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-title")
	      }, title), closable && this.renderCloseIcon());
	    }
	  }, {
	    key: "renderCloseIcon",
	    value: function renderCloseIcon() {
	      var _this$props4 = this.props,
	          closable = _this$props4.closable,
	          prefixCls = _this$props4.prefixCls,
	          onClose = _this$props4.onClose;
	      return closable &&
	      /*#__PURE__*/
	      // eslint-disable-next-line react/button-has-type
	      React.createElement("button", {
	        onClick: onClose,
	        "aria-label": "Close",
	        className: "".concat(prefixCls, "-close")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close"
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(DrawerContext.Consumer, null, this.renderProvider);
	    }
	  }]);
	
	  return Drawer;
	}(React.Component);
	
	Drawer.defaultProps = {
	  width: 256,
	  height: 256,
	  closable: true,
	  placement: 'right',
	  maskClosable: true,
	  mask: true,
	  level: null,
	  keyboard: true
	};
	
	var _default = (0, _context.withConfigConsumer)({
	  prefixCls: 'drawer'
	})(Drawer);
	
	exports["default"] = _default;

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _button = _interopRequireDefault(__webpack_require__(189));
	
	var _configProvider = __webpack_require__(11);
	
	var _dropdown = _interopRequireDefault(__webpack_require__(406));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ButtonGroup = _button["default"].Group;
	
	var DropdownButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(DropdownButton, _React$Component);
	
	  var _super = _createSuper(DropdownButton);
	
	  function DropdownButton() {
	    var _this;
	
	    _classCallCheck(this, DropdownButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderButton = function (_ref) {
	      var getContextPopupContainer = _ref.getPopupContainer,
	          getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          type = _a.type,
	          disabled = _a.disabled,
	          onClick = _a.onClick,
	          htmlType = _a.htmlType,
	          children = _a.children,
	          className = _a.className,
	          overlay = _a.overlay,
	          trigger = _a.trigger,
	          align = _a.align,
	          visible = _a.visible,
	          onVisibleChange = _a.onVisibleChange,
	          placement = _a.placement,
	          getPopupContainer = _a.getPopupContainer,
	          href = _a.href,
	          _a$icon = _a.icon,
	          icon = _a$icon === void 0 ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "ellipsis"
	      }) : _a$icon,
	          title = _a.title,
	          restProps = __rest(_a, ["prefixCls", "type", "disabled", "onClick", "htmlType", "children", "className", "overlay", "trigger", "align", "visible", "onVisibleChange", "placement", "getPopupContainer", "href", "icon", "title"]);
	
	      var prefixCls = getPrefixCls('dropdown-button', customizePrefixCls);
	      var dropdownProps = {
	        align: align,
	        overlay: overlay,
	        disabled: disabled,
	        trigger: disabled ? [] : trigger,
	        onVisibleChange: onVisibleChange,
	        placement: placement,
	        getPopupContainer: getPopupContainer || getContextPopupContainer
	      };
	
	      if ('visible' in _this.props) {
	        dropdownProps.visible = visible;
	      }
	
	      return /*#__PURE__*/React.createElement(ButtonGroup, _extends({}, restProps, {
	        className: (0, _classnames["default"])(prefixCls, className)
	      }), /*#__PURE__*/React.createElement(_button["default"], {
	        type: type,
	        disabled: disabled,
	        onClick: onClick,
	        htmlType: htmlType,
	        href: href,
	        title: title
	      }, children), /*#__PURE__*/React.createElement(_dropdown["default"], dropdownProps, /*#__PURE__*/React.createElement(_button["default"], {
	        type: type
	      }, icon)));
	    };
	
	    return _this;
	  }
	
	  _createClass(DropdownButton, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton);
	    }
	  }]);
	
	  return DropdownButton;
	}(React.Component);
	
	exports["default"] = DropdownButton;
	DropdownButton.defaultProps = {
	  placement: 'bottomRight',
	  type: 'default'
	};

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Empty = function Empty() {
	  return /*#__PURE__*/React.createElement("svg", {
	    width: "184",
	    height: "152",
	    viewBox: "0 0 184 152",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, /*#__PURE__*/React.createElement("g", {
	    fill: "none",
	    fillRule: "evenodd"
	  }, /*#__PURE__*/React.createElement("g", {
	    transform: "translate(24 31.67)"
	  }, /*#__PURE__*/React.createElement("ellipse", {
	    fillOpacity: ".8",
	    fill: "#F5F5F7",
	    cx: "67.797",
	    cy: "106.89",
	    rx: "67.797",
	    ry: "12.668"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
	    fill: "#AEB8C2"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
	    fill: "url(#linearGradient-1)",
	    transform: "translate(13.56)"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
	    fill: "#F5F5F7"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
	    fill: "#DCE0E6"
	  })), /*#__PURE__*/React.createElement("path", {
	    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
	    fill: "#DCE0E6"
	  }), /*#__PURE__*/React.createElement("g", {
	    transform: "translate(149.65 15.383)",
	    fill: "#FFF"
	  }, /*#__PURE__*/React.createElement("ellipse", {
	    cx: "20.654",
	    cy: "3.167",
	    rx: "2.849",
	    ry: "2.815"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
	  }))));
	};
	
	var _default = Empty;
	exports["default"] = _default;

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Simple = function Simple() {
	  return /*#__PURE__*/React.createElement("svg", {
	    width: "64",
	    height: "41",
	    viewBox: "0 0 64 41",
	    xmlns: "http://www.w3.org/2000/svg"
	  }, /*#__PURE__*/React.createElement("g", {
	    transform: "translate(0 1)",
	    fill: "none",
	    fillRule: "evenodd"
	  }, /*#__PURE__*/React.createElement("ellipse", {
	    fill: "#F5F5F5",
	    cx: "32",
	    cy: "33",
	    rx: "32",
	    ry: "7"
	  }), /*#__PURE__*/React.createElement("g", {
	    fillRule: "nonzero",
	    stroke: "#D9D9D9"
	  }, /*#__PURE__*/React.createElement("path", {
	    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
	    fill: "#FAFAFA"
	  }))));
	};
	
	var _default = Simple;
	exports["default"] = _default;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _createDOMForm = _interopRequireDefault(__webpack_require__(2691));
	
	var _createFormField = _interopRequireDefault(__webpack_require__(1090));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _configProvider = __webpack_require__(11);
	
	var _type = __webpack_require__(87);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _FormItem = _interopRequireDefault(__webpack_require__(1271));
	
	var _constants = __webpack_require__(628);
	
	var _context = _interopRequireDefault(__webpack_require__(629));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var FormLayouts = (0, _type.tuple)('horizontal', 'inline', 'vertical');
	
	var Form = /*#__PURE__*/function (_React$Component) {
	  _inherits(Form, _React$Component);
	
	  var _super = _createSuper(Form);
	
	  function Form(props) {
	    var _this;
	
	    _classCallCheck(this, Form);
	
	    _this = _super.call(this, props);
	
	    _this.renderForm = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          hideRequiredMark = _this$props.hideRequiredMark,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          layout = _this$props.layout;
	      var prefixCls = getPrefixCls('form', customizePrefixCls);
	      var formClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-horizontal"), layout === 'horizontal'), _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), layout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-inline"), layout === 'inline'), _defineProperty(_classNames, "".concat(prefixCls, "-hide-required-mark"), hideRequiredMark), _classNames), className);
	      var formProps = (0, _omit["default"])(_this.props, ['prefixCls', 'className', 'layout', 'form', 'hideRequiredMark', 'wrapperCol', 'labelAlign', 'labelCol', 'colon']);
	      return /*#__PURE__*/React.createElement("form", _extends({}, formProps, {
	        className: formClassName
	      }));
	    };
	
	    (0, _warning["default"])(!props.form, 'Form', 'It is unnecessary to pass `form` to `Form` after antd@1.7.0.');
	    return _this;
	  }
	
	  _createClass(Form, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          wrapperCol = _this$props2.wrapperCol,
	          labelAlign = _this$props2.labelAlign,
	          labelCol = _this$props2.labelCol,
	          layout = _this$props2.layout,
	          colon = _this$props2.colon;
	      return /*#__PURE__*/React.createElement(_context["default"].Provider, {
	        value: {
	          wrapperCol: wrapperCol,
	          labelAlign: labelAlign,
	          labelCol: labelCol,
	          vertical: layout === 'vertical',
	          colon: colon
	        }
	      }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderForm));
	    }
	  }]);
	
	  return Form;
	}(React.Component);
	
	exports["default"] = Form;
	Form.defaultProps = {
	  colon: true,
	  layout: 'horizontal',
	  hideRequiredMark: false,
	  onSubmit: function onSubmit(e) {
	    e.preventDefault();
	  }
	};
	Form.propTypes = {
	  prefixCls: PropTypes.string,
	  layout: PropTypes.oneOf(FormLayouts),
	  children: PropTypes.any,
	  onSubmit: PropTypes.func,
	  hideRequiredMark: PropTypes.bool,
	  colon: PropTypes.bool
	};
	Form.Item = _FormItem["default"];
	Form.createFormField = _createFormField["default"];
	
	Form.create = function create() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return (0, _createDOMForm["default"])(_extends(_extends({
	    fieldNameProp: 'id'
	  }, options), {
	    fieldMetaProp: _constants.FIELD_META_PROP,
	    fieldDataProp: _constants.FIELD_DATA_PROP
	  }));
	};

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(111));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _row = _interopRequireDefault(__webpack_require__(632));
	
	var _col = _interopRequireDefault(__webpack_require__(631));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _type = __webpack_require__(87);
	
	var _constants = __webpack_require__(628);
	
	var _context = _interopRequireDefault(__webpack_require__(629));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ValidateStatuses = (0, _type.tuple)('success', 'warning', 'error', 'validating', '');
	var FormLabelAligns = (0, _type.tuple)('left', 'right');
	
	function intersperseSpace(list) {
	  return list.reduce(function (current, item) {
	    return [].concat(_toConsumableArray(current), [' ', item]);
	  }, []).slice(1);
	}
	
	var FormItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(FormItem, _React$Component);
	
	  var _super = _createSuper(FormItem);
	
	  function FormItem() {
	    var _this;
	
	    _classCallCheck(this, FormItem);
	
	    _this = _super.apply(this, arguments);
	    _this.helpShow = false; // Resolve duplicated ids bug between different forms
	    // https://github.com/ant-design/ant-design/issues/7351
	
	    _this.onLabelClick = function () {
	      var id = _this.props.id || _this.getId();
	
	      if (!id) {
	        return;
	      }
	
	      var formItemNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var control = formItemNode.querySelector("[id=\"".concat(id, "\"]"));
	
	      if (control && control.focus) {
	        control.focus();
	      }
	    };
	
	    _this.onHelpAnimEnd = function (_key, helpShow) {
	      _this.helpShow = helpShow;
	
	      if (!helpShow) {
	        _this.setState({});
	      }
	    };
	
	    _this.renderFormItem = function (_ref) {
	      var _itemClassName;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          style = _a.style,
	          className = _a.className,
	          restProps = __rest(_a, ["prefixCls", "style", "className"]);
	
	      var prefixCls = getPrefixCls('form', customizePrefixCls);
	
	      var children = _this.renderChildren(prefixCls);
	
	      var itemClassName = (_itemClassName = {}, _defineProperty(_itemClassName, "".concat(prefixCls, "-item"), true), _defineProperty(_itemClassName, "".concat(prefixCls, "-item-with-help"), _this.helpShow), _defineProperty(_itemClassName, "".concat(className), !!className), _itemClassName);
	      return /*#__PURE__*/React.createElement(_row["default"], _extends({
	        className: (0, _classnames["default"])(itemClassName),
	        style: style
	      }, (0, _omit["default"])(restProps, ['id', 'htmlFor', 'label', 'labelAlign', 'labelCol', 'wrapperCol', 'help', 'extra', 'validateStatus', 'hasFeedback', 'required', 'colon']), {
	        key: "row"
	      }), children);
	    };
	
	    return _this;
	  }
	
	  _createClass(FormItem, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          help = _this$props.help,
	          validateStatus = _this$props.validateStatus,
	          id = _this$props.id;
	      (0, _warning["default"])(this.getControls(children, true).length <= 1 || help !== undefined || validateStatus !== undefined, 'Form.Item', 'Cannot generate `validateStatus` and `help` automatically, ' + 'while there are more than one `getFieldDecorator` in it.');
	      (0, _warning["default"])(!id, 'Form.Item', '`id` is deprecated for its label `htmlFor`. Please use `htmlFor` directly.');
	    }
	  }, {
	    key: "getHelpMessage",
	    value: function getHelpMessage() {
	      var help = this.props.help;
	
	      if (help === undefined && this.getOnlyControl()) {
	        var _this$getField = this.getField(),
	            errors = _this$getField.errors;
	
	        if (errors) {
	          return intersperseSpace(errors.map(function (e, index) {
	            var node = null;
	
	            if ( /*#__PURE__*/React.isValidElement(e)) {
	              node = e;
	            } else if ( /*#__PURE__*/React.isValidElement(e.message)) {
	              node = e.message;
	            } // eslint-disable-next-line react/no-array-index-key
	
	
	            return node ? /*#__PURE__*/React.cloneElement(node, {
	              key: index
	            }) : e.message;
	          }));
	        }
	
	        return '';
	      }
	
	      return help;
	    }
	  }, {
	    key: "getControls",
	    value: function getControls(children, recursively) {
	      var controls = [];
	      var childrenArray = React.Children.toArray(children);
	
	      for (var i = 0; i < childrenArray.length; i++) {
	        if (!recursively && controls.length > 0) {
	          break;
	        }
	
	        var child = childrenArray[i];
	
	        if (child.type && (child.type === FormItem || child.type.displayName === 'FormItem')) {
	          continue;
	        }
	
	        if (!child.props) {
	          continue;
	        }
	
	        if (_constants.FIELD_META_PROP in child.props) {
	          // And means FIELD_DATA_PROP in child.props, too.
	          controls.push(child);
	        } else if (child.props.children) {
	          controls = controls.concat(this.getControls(child.props.children, recursively));
	        }
	      }
	
	      return controls;
	    }
	  }, {
	    key: "getOnlyControl",
	    value: function getOnlyControl() {
	      var child = this.getControls(this.props.children, false)[0];
	      return child !== undefined ? child : null;
	    }
	  }, {
	    key: "getChildProp",
	    value: function getChildProp(prop) {
	      var child = this.getOnlyControl();
	      return child && child.props && child.props[prop];
	    }
	  }, {
	    key: "getId",
	    value: function getId() {
	      return this.getChildProp('id');
	    }
	  }, {
	    key: "getMeta",
	    value: function getMeta() {
	      return this.getChildProp(_constants.FIELD_META_PROP);
	    }
	  }, {
	    key: "getField",
	    value: function getField() {
	      return this.getChildProp(_constants.FIELD_DATA_PROP);
	    }
	  }, {
	    key: "getValidateStatus",
	    value: function getValidateStatus() {
	      var onlyControl = this.getOnlyControl();
	
	      if (!onlyControl) {
	        return '';
	      }
	
	      var field = this.getField();
	
	      if (field.validating) {
	        return 'validating';
	      }
	
	      if (field.errors) {
	        return 'error';
	      }
	
	      var fieldValue = 'value' in field ? field.value : this.getMeta().initialValue;
	
	      if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
	        return 'success';
	      }
	
	      return '';
	    }
	  }, {
	    key: "isRequired",
	    value: function isRequired() {
	      var required = this.props.required;
	
	      if (required !== undefined) {
	        return required;
	      }
	
	      if (this.getOnlyControl()) {
	        var meta = this.getMeta() || {};
	        var validate = meta.validate || [];
	        return validate.filter(function (item) {
	          return !!item.rules;
	        }).some(function (item) {
	          return item.rules.some(function (rule) {
	            return rule.required;
	          });
	        });
	      }
	
	      return false;
	    }
	  }, {
	    key: "renderHelp",
	    value: function renderHelp(prefixCls) {
	      var help = this.getHelpMessage();
	      var children = help ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-explain"),
	        key: "help"
	      }, help) : null;
	
	      if (children) {
	        this.helpShow = !!children;
	      }
	
	      return /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	        transitionName: "show-help",
	        component: "",
	        transitionAppear: true,
	        key: "help",
	        onEnd: this.onHelpAnimEnd
	      }, children);
	    }
	  }, {
	    key: "renderExtra",
	    value: function renderExtra(prefixCls) {
	      var extra = this.props.extra;
	      return extra ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-extra")
	      }, extra) : null;
	    }
	  }, {
	    key: "renderValidateWrapper",
	    value: function renderValidateWrapper(prefixCls, c1, c2, c3) {
	      var props = this.props;
	      var onlyControl = this.getOnlyControl;
	      var validateStatus = props.validateStatus === undefined && onlyControl ? this.getValidateStatus() : props.validateStatus;
	      var classes = "".concat(prefixCls, "-item-control");
	
	      if (validateStatus) {
	        classes = (0, _classnames["default"])("".concat(prefixCls, "-item-control"), {
	          'has-feedback': validateStatus && props.hasFeedback,
	          'has-success': validateStatus === 'success',
	          'has-warning': validateStatus === 'warning',
	          'has-error': validateStatus === 'error',
	          'is-validating': validateStatus === 'validating'
	        });
	      }
	
	      var iconType = '';
	
	      switch (validateStatus) {
	        case 'success':
	          iconType = 'check-circle';
	          break;
	
	        case 'warning':
	          iconType = 'exclamation-circle';
	          break;
	
	        case 'error':
	          iconType = 'close-circle';
	          break;
	
	        case 'validating':
	          iconType = 'loading';
	          break;
	
	        default:
	          iconType = '';
	          break;
	      }
	
	      var icon = props.hasFeedback && iconType ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-children-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType,
	        theme: iconType === 'loading' ? 'outlined' : 'filled'
	      })) : null;
	      return /*#__PURE__*/React.createElement("div", {
	        className: classes
	      }, /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-children")
	      }, c1, icon), c2, c3);
	    }
	  }, {
	    key: "renderWrapper",
	    value: function renderWrapper(prefixCls, children) {
	      var _this2 = this;
	
	      return /*#__PURE__*/React.createElement(_context["default"].Consumer, {
	        key: "wrapper"
	      }, function (_ref2) {
	        var contextWrapperCol = _ref2.wrapperCol,
	            vertical = _ref2.vertical;
	        var wrapperCol = _this2.props.wrapperCol;
	        var mergedWrapperCol = ('wrapperCol' in _this2.props ? wrapperCol : contextWrapperCol) || {};
	        var className = (0, _classnames["default"])("".concat(prefixCls, "-item-control-wrapper"), mergedWrapperCol.className); // No pass FormContext since it's useless
	
	        return /*#__PURE__*/React.createElement(_context["default"].Provider, {
	          value: {
	            vertical: vertical
	          }
	        }, /*#__PURE__*/React.createElement(_col["default"], _extends({}, mergedWrapperCol, {
	          className: className
	        }), children));
	      });
	    }
	  }, {
	    key: "renderLabel",
	    value: function renderLabel(prefixCls) {
	      var _this3 = this;
	
	      return /*#__PURE__*/React.createElement(_context["default"].Consumer, {
	        key: "label"
	      }, function (_ref3) {
	        var _classNames;
	
	        var vertical = _ref3.vertical,
	            contextLabelAlign = _ref3.labelAlign,
	            contextLabelCol = _ref3.labelCol,
	            contextColon = _ref3.colon;
	        var _this3$props = _this3.props,
	            label = _this3$props.label,
	            labelCol = _this3$props.labelCol,
	            labelAlign = _this3$props.labelAlign,
	            colon = _this3$props.colon,
	            id = _this3$props.id,
	            htmlFor = _this3$props.htmlFor;
	
	        var required = _this3.isRequired();
	
	        var mergedLabelCol = ('labelCol' in _this3.props ? labelCol : contextLabelCol) || {};
	        var mergedLabelAlign = 'labelAlign' in _this3.props ? labelAlign : contextLabelAlign;
	        var labelClsBasic = "".concat(prefixCls, "-item-label");
	        var labelColClassName = (0, _classnames["default"])(labelClsBasic, mergedLabelAlign === 'left' && "".concat(labelClsBasic, "-left"), mergedLabelCol.className);
	        var labelChildren = label; // Keep label is original where there should have no colon
	
	        var computedColon = colon === true || contextColon !== false && colon !== false;
	        var haveColon = computedColon && !vertical; // Remove duplicated user input colon
	
	        if (haveColon && typeof label === 'string' && label.trim() !== '') {
	          labelChildren = label.replace(/[：:]\s*$/, '');
	        }
	
	        var labelClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-required"), required), _defineProperty(_classNames, "".concat(prefixCls, "-item-no-colon"), !computedColon), _classNames));
	        return label ? /*#__PURE__*/React.createElement(_col["default"], _extends({}, mergedLabelCol, {
	          className: labelColClassName
	        }), /*#__PURE__*/React.createElement("label", {
	          htmlFor: htmlFor || id || _this3.getId(),
	          className: labelClassName,
	          title: typeof label === 'string' ? label : '',
	          onClick: _this3.onLabelClick
	        }, labelChildren)) : null;
	      });
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren(prefixCls) {
	      var children = this.props.children;
	      return [this.renderLabel(prefixCls), this.renderWrapper(prefixCls, this.renderValidateWrapper(prefixCls, children, this.renderHelp(prefixCls), this.renderExtra(prefixCls)))];
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderFormItem);
	    }
	  }]);
	
	  return FormItem;
	}(React.Component);
	
	exports["default"] = FormItem;
	FormItem.defaultProps = {
	  hasFeedback: false
	};
	FormItem.propTypes = {
	  prefixCls: PropTypes.string,
	  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	  labelCol: PropTypes.object,
	  help: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
	  validateStatus: PropTypes.oneOf(ValidateStatuses),
	  hasFeedback: PropTypes.bool,
	  wrapperCol: PropTypes.object,
	  className: PropTypes.string,
	  id: PropTypes.string,
	  children: PropTypes.node,
	  colon: PropTypes.bool
	};

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Form = _interopRequireDefault(__webpack_require__(1270));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _Form["default"];
	exports["default"] = _default;

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = create;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _index = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var customCache = new Set();
	
	function create() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var scriptUrl = options.scriptUrl,
	      _options$extraCommonP = options.extraCommonProps,
	      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
	  /**
	   * DOM API required.
	   * Make sure in browser environment.
	   * The Custom Icon will create a <script/>
	   * that loads SVG symbols and insert the SVG Element into the document body.
	   */
	
	  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
	    var script = document.createElement('script');
	    script.setAttribute('src', scriptUrl);
	    script.setAttribute('data-namespace', scriptUrl);
	    customCache.add(scriptUrl);
	    document.body.appendChild(script);
	  }
	
	  var Iconfont = function Iconfont(props) {
	    var type = props.type,
	        children = props.children,
	        restProps = __rest(props, ["type", "children"]); // component > children > type
	
	
	    var content = null;
	
	    if (props.type) {
	      content = /*#__PURE__*/React.createElement("use", {
	        xlinkHref: "#".concat(type)
	      });
	    }
	
	    if (children) {
	      content = children;
	    }
	
	    return /*#__PURE__*/React.createElement(_index["default"], _extends({}, extraCommonProps, restProps), content);
	  };
	
	  Iconfont.displayName = 'Iconfont';
	  return Iconfont;
	}

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTwoToneColor = setTwoToneColor;
	exports.getTwoToneColor = getTwoToneColor;
	
	var _iconsReact = _interopRequireDefault(__webpack_require__(651));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function setTwoToneColor(primaryColor) {
	  return _iconsReact["default"].setTwoToneColors({
	    primaryColor: primaryColor
	  });
	}
	
	function getTwoToneColor() {
	  var colors = _iconsReact["default"].getTwoToneColors();
	
	  return colors.primaryColor;
	}

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getThemeFromTypeName = getThemeFromTypeName;
	exports.removeTypeTheme = removeTypeTheme;
	exports.withThemeSuffix = withThemeSuffix;
	exports.alias = alias;
	exports.svgBaseProps = void 0;
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	// These props make sure that the SVG behaviours like general text.
	// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
	var svgBaseProps = {
	  width: '1em',
	  height: '1em',
	  fill: 'currentColor',
	  'aria-hidden': true,
	  focusable: 'false'
	};
	exports.svgBaseProps = svgBaseProps;
	var fillTester = /-fill$/;
	var outlineTester = /-o$/;
	var twoToneTester = /-twotone$/;
	
	function getThemeFromTypeName(type) {
	  var result = null;
	
	  if (fillTester.test(type)) {
	    result = 'filled';
	  } else if (outlineTester.test(type)) {
	    result = 'outlined';
	  } else if (twoToneTester.test(type)) {
	    result = 'twoTone';
	  }
	
	  return result;
	}
	
	function removeTypeTheme(type) {
	  return type.replace(fillTester, '').replace(outlineTester, '').replace(twoToneTester, '');
	}
	
	function withThemeSuffix(type, theme) {
	  var result = type;
	
	  if (theme === 'filled') {
	    result += '-fill';
	  } else if (theme === 'outlined') {
	    result += '-o';
	  } else if (theme === 'twoTone') {
	    result += '-twotone';
	  } else {
	    (0, _warning["default"])(false, 'Icon', "This icon '".concat(type, "' has unknown theme '").concat(theme, "'"));
	  }
	
	  return result;
	} // For alias or compatibility
	
	
	function alias(type) {
	  var newType = type;
	
	  switch (type) {
	    case 'cross':
	      newType = 'close';
	      break;
	    // https://github.com/ant-design/ant-design/issues/13007
	
	    case 'interation':
	      newType = 'interaction';
	      break;
	    // https://github.com/ant-design/ant-design/issues/16810
	
	    case 'canlendar':
	      newType = 'calendar';
	      break;
	    // https://github.com/ant-design/ant-design/issues/17448
	
	    case 'colum-height':
	      newType = 'column-height';
	      break;
	
	    default:
	  }
	
	  (0, _warning["default"])(newType === type, 'Icon', "Icon '".concat(type, "' was a typo and is now deprecated, please use '").concat(newType, "' instead."));
	  return newType;
	}

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _rcInputNumber = _interopRequireDefault(__webpack_require__(2695));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var InputNumber = /*#__PURE__*/function (_React$Component) {
	  _inherits(InputNumber, _React$Component);
	
	  var _super = _createSuper(InputNumber);
	
	  function InputNumber() {
	    var _this;
	
	    _classCallCheck(this, InputNumber);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveInputNumber = function (inputNumberRef) {
	      _this.inputNumberRef = inputNumberRef;
	    };
	
	    _this.renderInputNumber = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          className = _a.className,
	          size = _a.size,
	          customizePrefixCls = _a.prefixCls,
	          others = __rest(_a, ["className", "size", "prefixCls"]);
	
	      var prefixCls = getPrefixCls('input-number', customizePrefixCls);
	      var inputNumberClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className);
	      var upIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "up",
	        className: "".concat(prefixCls, "-handler-up-inner")
	      });
	      var downIcon = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: "".concat(prefixCls, "-handler-down-inner")
	      });
	      return /*#__PURE__*/React.createElement(_rcInputNumber["default"], _extends({
	        ref: _this.saveInputNumber,
	        className: inputNumberClass,
	        upHandler: upIcon,
	        downHandler: downIcon,
	        prefixCls: prefixCls
	      }, others));
	    };
	
	    return _this;
	  }
	
	  _createClass(InputNumber, [{
	    key: "focus",
	    value: function focus() {
	      this.inputNumberRef.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.inputNumberRef.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderInputNumber);
	    }
	  }]);
	
	  return InputNumber;
	}(React.Component);
	
	exports["default"] = InputNumber;
	InputNumber.defaultProps = {
	  step: 1
	};

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Group = function Group(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	    var _classNames;
	
	    var getPrefixCls = _ref.getPrefixCls;
	    var customizePrefixCls = props.prefixCls,
	        _props$className = props.className,
	        className = _props$className === void 0 ? '' : _props$className;
	    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
	    var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-compact"), props.compact), _classNames), className);
	    return /*#__PURE__*/React.createElement("span", {
	      className: cls,
	      style: props.style,
	      onMouseEnter: props.onMouseEnter,
	      onMouseLeave: props.onMouseLeave,
	      onFocus: props.onFocus,
	      onBlur: props.onBlur
	    }, props.children);
	  });
	};
	
	var _default = Group;
	exports["default"] = _default;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _Input = _interopRequireDefault(__webpack_require__(269));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ActionMap = {
	  click: 'onClick',
	  hover: 'onMouseOver'
	};
	
	var Password = /*#__PURE__*/function (_React$Component) {
	  _inherits(Password, _React$Component);
	
	  var _super = _createSuper(Password);
	
	  function Password() {
	    var _this;
	
	    _classCallCheck(this, Password);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      visible: false
	    };
	
	    _this.onVisibleChange = function () {
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        return;
	      }
	
	      _this.setState(function (_ref) {
	        var visible = _ref.visible;
	        return {
	          visible: !visible
	        };
	      });
	    };
	
	    _this.saveInput = function (instance) {
	      if (instance && instance.input) {
	        _this.input = instance.input;
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(Password, [{
	    key: "getIcon",
	    value: function getIcon() {
	      var _iconProps;
	
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          action = _this$props.action;
	      var iconTrigger = ActionMap[action] || '';
	      var iconProps = (_iconProps = {}, _defineProperty(_iconProps, iconTrigger, this.onVisibleChange), _defineProperty(_iconProps, "className", "".concat(prefixCls, "-icon")), _defineProperty(_iconProps, "type", this.state.visible ? 'eye' : 'eye-invisible'), _defineProperty(_iconProps, "key", 'passwordIcon'), _defineProperty(_iconProps, "onMouseDown", function onMouseDown(e) {
	        // Prevent focused state lost
	        // https://github.com/ant-design/ant-design/issues/15173
	        e.preventDefault();
	      }), _iconProps);
	      return /*#__PURE__*/React.createElement(_icon["default"], iconProps);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "select",
	    value: function select() {
	      this.input.select();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          className = _a.className,
	          prefixCls = _a.prefixCls,
	          inputPrefixCls = _a.inputPrefixCls,
	          size = _a.size,
	          visibilityToggle = _a.visibilityToggle,
	          restProps = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);
	
	      var suffixIcon = visibilityToggle && this.getIcon();
	      var inputClassName = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
	      return /*#__PURE__*/React.createElement(_Input["default"], _extends({}, (0, _omit["default"])(restProps, ['suffix']), {
	        type: this.state.visible ? 'text' : 'password',
	        size: size,
	        className: inputClassName,
	        prefixCls: inputPrefixCls,
	        suffix: suffixIcon,
	        ref: this.saveInput
	      }));
	    }
	  }]);
	
	  return Password;
	}(React.Component);
	
	exports["default"] = Password;
	Password.defaultProps = {
	  inputPrefixCls: 'ant-input',
	  prefixCls: 'ant-input-password',
	  action: 'click',
	  visibilityToggle: true
	};

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _rcResizeObserver = _interopRequireDefault(__webpack_require__(417));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _calculateNodeHeight = _interopRequireDefault(__webpack_require__(1281));
	
	var _raf = _interopRequireDefault(__webpack_require__(268));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ResizableTextArea = /*#__PURE__*/function (_React$Component) {
	  _inherits(ResizableTextArea, _React$Component);
	
	  var _super = _createSuper(ResizableTextArea);
	
	  function ResizableTextArea(props) {
	    var _this;
	
	    _classCallCheck(this, ResizableTextArea);
	
	    _this = _super.call(this, props);
	
	    _this.saveTextArea = function (textArea) {
	      _this.textArea = textArea;
	    };
	
	    _this.resizeOnNextFrame = function () {
	      _raf["default"].cancel(_this.nextFrameActionId);
	
	      _this.nextFrameActionId = (0, _raf["default"])(_this.resizeTextarea);
	    };
	
	    _this.resizeTextarea = function () {
	      var autoSize = _this.props.autoSize || _this.props.autosize;
	
	      if (!autoSize || !_this.textArea) {
	        return;
	      }
	
	      var minRows = autoSize.minRows,
	          maxRows = autoSize.maxRows;
	      var textareaStyles = (0, _calculateNodeHeight["default"])(_this.textArea, false, minRows, maxRows);
	
	      _this.setState({
	        textareaStyles: textareaStyles,
	        resizing: true
	      }, function () {
	        _raf["default"].cancel(_this.resizeFrameId);
	
	        _this.resizeFrameId = (0, _raf["default"])(function () {
	          _this.setState({
	            resizing: false
	          });
	
	          _this.fixFirefoxAutoScroll();
	        });
	      });
	    };
	
	    _this.renderTextArea = function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          autoSize = _this$props.autoSize,
	          autosize = _this$props.autosize,
	          className = _this$props.className,
	          disabled = _this$props.disabled;
	      var _this$state = _this.state,
	          textareaStyles = _this$state.textareaStyles,
	          resizing = _this$state.resizing;
	      (0, _warning["default"])(autosize === undefined, 'Input.TextArea', 'autosize is deprecated, please use autoSize instead.');
	      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'autoSize', 'autosize', 'defaultValue', 'allowClear']);
	      var cls = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)); // Fix https://github.com/ant-design/ant-design/issues/6776
	      // Make sure it could be reset when using form.getFieldDecorator
	
	      if ('value' in otherProps) {
	        otherProps.value = otherProps.value || '';
	      }
	
	      var style = _extends(_extends(_extends({}, _this.props.style), textareaStyles), resizing ? {
	        overflowX: 'hidden',
	        overflowY: 'hidden'
	      } : null);
	
	      return /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
	        onResize: _this.resizeOnNextFrame,
	        disabled: !(autoSize || autosize)
	      }, /*#__PURE__*/React.createElement("textarea", _extends({}, otherProps, {
	        className: cls,
	        style: style,
	        ref: _this.saveTextArea
	      })));
	    };
	
	    _this.state = {
	      textareaStyles: {},
	      resizing: false
	    };
	    return _this;
	  }
	
	  _createClass(ResizableTextArea, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.resizeTextarea();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      // Re-render with the new content then recalculate the height as required.
	      if (prevProps.value !== this.props.value) {
	        this.resizeTextarea();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.nextFrameActionId);
	
	      _raf["default"].cancel(this.resizeFrameId);
	    } // https://github.com/ant-design/ant-design/issues/21870
	
	  }, {
	    key: "fixFirefoxAutoScroll",
	    value: function fixFirefoxAutoScroll() {
	      try {
	        if (document.activeElement === this.textArea) {
	          var currentStart = this.textArea.selectionStart;
	          var currentEnd = this.textArea.selectionEnd;
	          this.textArea.setSelectionRange(currentStart, currentEnd);
	        }
	      } catch (e) {// Fix error in Chrome:
	        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
	        // http://stackoverflow.com/q/21177489/3040605
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.renderTextArea();
	    }
	  }]);
	
	  return ResizableTextArea;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(ResizableTextArea);
	var _default = ResizableTextArea;
	exports["default"] = _default;

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _isMobile = __webpack_require__(2489);
	
	var _Input = _interopRequireDefault(__webpack_require__(269));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _button = _interopRequireDefault(__webpack_require__(189));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Search = /*#__PURE__*/function (_React$Component) {
	  _inherits(Search, _React$Component);
	
	  var _super = _createSuper(Search);
	
	  function Search() {
	    var _this;
	
	    _classCallCheck(this, Search);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    _this.onChange = function (e) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          onSearch = _this$props.onSearch;
	
	      if (e && e.target && e.type === 'click' && onSearch) {
	        onSearch(e.target.value, e);
	      }
	
	      if (onChange) {
	        onChange(e);
	      }
	    };
	
	    _this.onSearch = function (e) {
	      var _this$props2 = _this.props,
	          onSearch = _this$props2.onSearch,
	          loading = _this$props2.loading,
	          disabled = _this$props2.disabled;
	
	      if (loading || disabled) {
	        return;
	      }
	
	      if (onSearch) {
	        onSearch(_this.input.input.value, e);
	      }
	
	      if (!(0, _isMobile.isMobile)({
	        tablet: true
	      })) {
	        _this.input.focus();
	      }
	    };
	
	    _this.renderLoading = function (prefixCls) {
	      var _this$props3 = _this.props,
	          enterButton = _this$props3.enterButton,
	          size = _this$props3.size;
	
	      if (enterButton) {
	        return /*#__PURE__*/React.createElement(_button["default"], {
	          className: "".concat(prefixCls, "-button"),
	          type: "primary",
	          size: size,
	          key: "enterButton"
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "loading"
	        }));
	      }
	
	      return /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-icon"),
	        type: "loading",
	        key: "loadingIcon"
	      });
	    };
	
	    _this.renderSuffix = function (prefixCls) {
	      var _this$props4 = _this.props,
	          suffix = _this$props4.suffix,
	          enterButton = _this$props4.enterButton,
	          loading = _this$props4.loading;
	
	      if (loading && !enterButton) {
	        return [suffix, _this.renderLoading(prefixCls)];
	      }
	
	      if (enterButton) return suffix;
	      var icon = /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-icon"),
	        type: "search",
	        key: "searchIcon",
	        onClick: _this.onSearch
	      });
	
	      if (suffix) {
	        return [/*#__PURE__*/React.isValidElement(suffix) ? /*#__PURE__*/React.cloneElement(suffix, {
	          key: 'suffix'
	        }) : null, icon];
	      }
	
	      return icon;
	    };
	
	    _this.renderAddonAfter = function (prefixCls) {
	      var _this$props5 = _this.props,
	          enterButton = _this$props5.enterButton,
	          size = _this$props5.size,
	          disabled = _this$props5.disabled,
	          addonAfter = _this$props5.addonAfter,
	          loading = _this$props5.loading;
	      var btnClassName = "".concat(prefixCls, "-button");
	
	      if (loading && enterButton) {
	        return [_this.renderLoading(prefixCls), addonAfter];
	      }
	
	      if (!enterButton) return addonAfter;
	      var button;
	      var enterButtonAsElement = enterButton;
	      var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;
	
	      if (isAntdButton || enterButtonAsElement.type === 'button') {
	        button = /*#__PURE__*/React.cloneElement(enterButtonAsElement, _extends({
	          onClick: _this.onSearch,
	          key: 'enterButton'
	        }, isAntdButton ? {
	          className: btnClassName,
	          size: size
	        } : {}));
	      } else {
	        button = /*#__PURE__*/React.createElement(_button["default"], {
	          className: btnClassName,
	          type: "primary",
	          size: size,
	          disabled: disabled,
	          key: "enterButton",
	          onClick: _this.onSearch
	        }, enterButton === true ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "search"
	        }) : enterButton);
	      }
	
	      if (addonAfter) {
	        return [button, /*#__PURE__*/React.isValidElement(addonAfter) ? /*#__PURE__*/React.cloneElement(addonAfter, {
	          key: 'addonAfter'
	        }) : null];
	      }
	
	      return button;
	    };
	
	    _this.renderSearch = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeInputPrefixCls = _a.inputPrefixCls,
	          size = _a.size,
	          enterButton = _a.enterButton,
	          className = _a.className,
	          restProps = __rest(_a, ["prefixCls", "inputPrefixCls", "size", "enterButton", "className"]);
	
	      delete restProps.onSearch;
	      delete restProps.loading;
	      var prefixCls = getPrefixCls('input-search', customizePrefixCls);
	      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
	      var inputClassName;
	
	      if (enterButton) {
	        var _classNames;
	
	        inputClassName = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-enter-button"), !!enterButton), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _classNames));
	      } else {
	        inputClassName = (0, _classnames["default"])(prefixCls, className);
	      }
	
	      return /*#__PURE__*/React.createElement(_Input["default"], _extends({
	        onPressEnter: _this.onSearch
	      }, restProps, {
	        size: size,
	        prefixCls: inputPrefixCls,
	        addonAfter: _this.renderAddonAfter(prefixCls),
	        suffix: _this.renderSuffix(prefixCls),
	        onChange: _this.onChange,
	        ref: _this.saveInput,
	        className: inputClassName
	      }));
	    };
	
	    return _this;
	  }
	
	  _createClass(Search, [{
	    key: "focus",
	    value: function focus() {
	      this.input.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.input.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSearch);
	    }
	  }]);
	
	  return Search;
	}(React.Component);
	
	exports["default"] = Search;
	Search.defaultProps = {
	  enterButton: false
	};

/***/ },
/* 1281 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.calculateNodeStyling = calculateNodeStyling;
	exports["default"] = calculateNodeHeight;
	// Thanks to https://github.com/andreypopp/react-textarea-autosize/
	
	/**
	 * calculateNodeHeight(uiTextNode, useCache = false)
	 */
	var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
	var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
	var computedStyleCache = {};
	var hiddenTextarea;
	
	function calculateNodeStyling(node) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');
	
	  if (useCache && computedStyleCache[nodeRef]) {
	    return computedStyleCache[nodeRef];
	  }
	
	  var style = window.getComputedStyle(node);
	  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
	  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
	  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
	  var sizingStyle = SIZING_STYLE.map(function (name) {
	    return "".concat(name, ":").concat(style.getPropertyValue(name));
	  }).join(';');
	  var nodeInfo = {
	    sizingStyle: sizingStyle,
	    paddingSize: paddingSize,
	    borderSize: borderSize,
	    boxSizing: boxSizing
	  };
	
	  if (useCache && nodeRef) {
	    computedStyleCache[nodeRef] = nodeInfo;
	  }
	
	  return nodeInfo;
	}
	
	function calculateNodeHeight(uiTextNode) {
	  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
	  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  if (!hiddenTextarea) {
	    hiddenTextarea = document.createElement('textarea');
	    document.body.appendChild(hiddenTextarea);
	  } // Fix wrap="off" issue
	  // https://github.com/ant-design/ant-design/issues/6577
	
	
	  if (uiTextNode.getAttribute('wrap')) {
	    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
	  } else {
	    hiddenTextarea.removeAttribute('wrap');
	  } // Copy all CSS properties that have an impact on the height of the content in
	  // the textbox
	
	
	  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
	      paddingSize = _calculateNodeStyling.paddingSize,
	      borderSize = _calculateNodeStyling.borderSize,
	      boxSizing = _calculateNodeStyling.boxSizing,
	      sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
	  // text-lines will not calculated properly as the shadow will technically be
	  // narrower for content
	
	
	  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
	  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
	  var minHeight = Number.MIN_SAFE_INTEGER;
	  var maxHeight = Number.MAX_SAFE_INTEGER;
	  var height = hiddenTextarea.scrollHeight;
	  var overflowY;
	
	  if (boxSizing === 'border-box') {
	    // border-box: add border, since height = content + padding + border
	    height += borderSize;
	  } else if (boxSizing === 'content-box') {
	    // remove padding, since height = content
	    height -= paddingSize;
	  }
	
	  if (minRows !== null || maxRows !== null) {
	    // measure height of a textarea with a single row
	    hiddenTextarea.value = ' ';
	    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
	
	    if (minRows !== null) {
	      minHeight = singleRowHeight * minRows;
	
	      if (boxSizing === 'border-box') {
	        minHeight = minHeight + paddingSize + borderSize;
	      }
	
	      height = Math.max(minHeight, height);
	    }
	
	    if (maxRows !== null) {
	      maxHeight = singleRowHeight * maxRows;
	
	      if (boxSizing === 'border-box') {
	        maxHeight = maxHeight + paddingSize + borderSize;
	      }
	
	      overflowY = height > maxHeight ? '' : 'hidden';
	      height = Math.min(maxHeight, height);
	    }
	  }
	
	  return {
	    height: height,
	    minHeight: minHeight,
	    maxHeight: maxHeight,
	    overflowY: overflowY
	  };
	}

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _layout = _interopRequireDefault(__webpack_require__(635));
	
	var _Sider = _interopRequireDefault(__webpack_require__(408));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_layout["default"].Sider = _Sider["default"];
	var _default = _layout["default"];
	exports["default"] = _default;

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.Meta = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _grid = __webpack_require__(318);
	
	var _configProvider = __webpack_require__(11);
	
	var _reactNode = __webpack_require__(614);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Meta = function Meta(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	    var getPrefixCls = _ref.getPrefixCls;
	
	    var customizePrefixCls = props.prefixCls,
	        className = props.className,
	        avatar = props.avatar,
	        title = props.title,
	        description = props.description,
	        others = __rest(props, ["prefixCls", "className", "avatar", "title", "description"]);
	
	    var prefixCls = getPrefixCls('list', customizePrefixCls);
	    var classString = (0, _classnames["default"])("".concat(prefixCls, "-item-meta"), className);
	    var content = /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-item-meta-content")
	    }, title && /*#__PURE__*/React.createElement("h4", {
	      className: "".concat(prefixCls, "-item-meta-title")
	    }, title), description && /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-item-meta-description")
	    }, description));
	    return /*#__PURE__*/React.createElement("div", _extends({}, others, {
	      className: classString
	    }), avatar && /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-item-meta-avatar")
	    }, avatar), (title || description) && content);
	  });
	};
	
	exports.Meta = Meta;
	
	function getGrid(grid, t) {
	  return grid[t] && Math.floor(24 / grid[t]);
	}
	
	var Item = /*#__PURE__*/function (_React$Component) {
	  _inherits(Item, _React$Component);
	
	  var _super = _createSuper(Item);
	
	  function Item() {
	    var _this;
	
	    _classCallCheck(this, Item);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderItem = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	      var _this$context = _this.context,
	          grid = _this$context.grid,
	          itemLayout = _this$context.itemLayout;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          children = _a.children,
	          actions = _a.actions,
	          extra = _a.extra,
	          className = _a.className,
	          others = __rest(_a, ["prefixCls", "children", "actions", "extra", "className"]);
	
	      var prefixCls = getPrefixCls('list', customizePrefixCls);
	      var actionsContent = actions && actions.length > 0 && /*#__PURE__*/React.createElement("ul", {
	        className: "".concat(prefixCls, "-item-action"),
	        key: "actions"
	      }, actions.map(function (action, i) {
	        return (
	          /*#__PURE__*/
	          // eslint-disable-next-line react/no-array-index-key
	          React.createElement("li", {
	            key: "".concat(prefixCls, "-item-action-").concat(i)
	          }, action, i !== actions.length - 1 && /*#__PURE__*/React.createElement("em", {
	            className: "".concat(prefixCls, "-item-action-split")
	          }))
	        );
	      }));
	      var Tag = grid ? 'div' : 'li';
	      var itemChildren = /*#__PURE__*/React.createElement(Tag, _extends({}, others, {
	        // `li` element `onCopy` prop args is not same as `div`
	        className: (0, _classnames["default"])("".concat(prefixCls, "-item"), className, _defineProperty({}, "".concat(prefixCls, "-item-no-flex"), !_this.isFlexMode()))
	      }), itemLayout === 'vertical' && extra ? [/*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-main"),
	        key: "content"
	      }, children, actionsContent), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-extra"),
	        key: "extra"
	      }, extra)] : [children, actionsContent, (0, _reactNode.cloneElement)(extra, {
	        key: 'extra'
	      })]);
	      return grid ? /*#__PURE__*/React.createElement(_grid.Col, {
	        span: getGrid(grid, 'column'),
	        xs: getGrid(grid, 'xs'),
	        sm: getGrid(grid, 'sm'),
	        md: getGrid(grid, 'md'),
	        lg: getGrid(grid, 'lg'),
	        xl: getGrid(grid, 'xl'),
	        xxl: getGrid(grid, 'xxl')
	      }, itemChildren) : itemChildren;
	    };
	
	    return _this;
	  }
	
	  _createClass(Item, [{
	    key: "isItemContainsTextNodeAndNotSingular",
	    value: function isItemContainsTextNodeAndNotSingular() {
	      var children = this.props.children;
	      var result;
	      React.Children.forEach(children, function (element) {
	        if (typeof element === 'string') {
	          result = true;
	        }
	      });
	      return result && React.Children.count(children) > 1;
	    }
	  }, {
	    key: "isFlexMode",
	    value: function isFlexMode() {
	      var extra = this.props.extra;
	      var itemLayout = this.context.itemLayout;
	
	      if (itemLayout === 'vertical') {
	        return !!extra;
	      }
	
	      return !this.isItemContainsTextNodeAndNotSingular();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderItem);
	    }
	  }]);
	
	  return Item;
	}(React.Component);
	
	exports["default"] = Item;
	Item.Meta = Meta;
	Item.contextTypes = {
	  grid: PropTypes.any,
	  itemLayout: PropTypes.string
	};

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _spin = _interopRequireDefault(__webpack_require__(321));
	
	var _configProvider = __webpack_require__(11);
	
	var _pagination = _interopRequireDefault(__webpack_require__(412));
	
	var _grid = __webpack_require__(318);
	
	var _Item = _interopRequireDefault(__webpack_require__(1283));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var List = /*#__PURE__*/function (_React$Component) {
	  _inherits(List, _React$Component);
	
	  var _super = _createSuper(List);
	
	  function List(props) {
	    var _this;
	
	    _classCallCheck(this, List);
	
	    _this = _super.call(this, props);
	    _this.defaultPaginationProps = {
	      current: 1,
	      total: 0
	    };
	    _this.keys = {};
	    _this.onPaginationChange = _this.triggerPaginationEvent('onChange');
	    _this.onPaginationShowSizeChange = _this.triggerPaginationEvent('onShowSizeChange');
	
	    _this.renderItem = function (item, index) {
	      var _this$props = _this.props,
	          renderItem = _this$props.renderItem,
	          rowKey = _this$props.rowKey;
	      if (!renderItem) return null;
	      var key;
	
	      if (typeof rowKey === 'function') {
	        key = rowKey(item);
	      } else if (typeof rowKey === 'string') {
	        key = item[rowKey];
	      } else {
	        key = item.key;
	      }
	
	      if (!key) {
	        key = "list-item-".concat(index);
	      }
	
	      _this.keys[index] = key;
	      return renderItem(item, index);
	    };
	
	    _this.renderEmpty = function (prefixCls, renderEmpty) {
	      var locale = _this.props.locale;
	      return /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-empty-text")
	      }, locale && locale.emptyText || renderEmpty('List'));
	    };
	
	    _this.renderList = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	      var _this$state = _this.state,
	          paginationCurrent = _this$state.paginationCurrent,
	          paginationSize = _this$state.paginationSize;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          bordered = _a.bordered,
	          split = _a.split,
	          className = _a.className,
	          children = _a.children,
	          itemLayout = _a.itemLayout,
	          loadMore = _a.loadMore,
	          pagination = _a.pagination,
	          grid = _a.grid,
	          _a$dataSource = _a.dataSource,
	          dataSource = _a$dataSource === void 0 ? [] : _a$dataSource,
	          size = _a.size,
	          header = _a.header,
	          footer = _a.footer,
	          loading = _a.loading,
	          rest = __rest(_a, ["prefixCls", "bordered", "split", "className", "children", "itemLayout", "loadMore", "pagination", "grid", "dataSource", "size", "header", "footer", "loading"]);
	
	      var prefixCls = getPrefixCls('list', customizePrefixCls);
	      var loadingProp = loading;
	
	      if (typeof loadingProp === 'boolean') {
	        loadingProp = {
	          spinning: loadingProp
	        };
	      }
	
	      var isLoading = loadingProp && loadingProp.spinning; // large => lg
	      // small => sm
	
	      var sizeCls = '';
	
	      switch (size) {
	        case 'large':
	          sizeCls = 'lg';
	          break;
	
	        case 'small':
	          sizeCls = 'sm';
	          break;
	
	        default:
	          break;
	      }
	
	      var classString = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), itemLayout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-split"), split), _defineProperty(_classNames, "".concat(prefixCls, "-bordered"), bordered), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), isLoading), _defineProperty(_classNames, "".concat(prefixCls, "-grid"), grid), _defineProperty(_classNames, "".concat(prefixCls, "-something-after-last-item"), _this.isSomethingAfterLastItem()), _classNames));
	
	      var paginationProps = _extends(_extends(_extends({}, _this.defaultPaginationProps), {
	        total: dataSource.length,
	        current: paginationCurrent,
	        pageSize: paginationSize
	      }), pagination || {});
	
	      var largestPage = Math.ceil(paginationProps.total / paginationProps.pageSize);
	
	      if (paginationProps.current > largestPage) {
	        paginationProps.current = largestPage;
	      }
	
	      var paginationContent = pagination ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-pagination")
	      }, /*#__PURE__*/React.createElement(_pagination["default"], _extends({}, paginationProps, {
	        onChange: _this.onPaginationChange,
	        onShowSizeChange: _this.onPaginationShowSizeChange
	      }))) : null;
	
	      var splitDataSource = _toConsumableArray(dataSource);
	
	      if (pagination) {
	        if (dataSource.length > (paginationProps.current - 1) * paginationProps.pageSize) {
	          splitDataSource = _toConsumableArray(dataSource).splice((paginationProps.current - 1) * paginationProps.pageSize, paginationProps.pageSize);
	        }
	      }
	
	      var childrenContent;
	      childrenContent = isLoading && /*#__PURE__*/React.createElement("div", {
	        style: {
	          minHeight: 53
	        }
	      });
	
	      if (splitDataSource.length > 0) {
	        var items = splitDataSource.map(function (item, index) {
	          return _this.renderItem(item, index);
	        });
	        var childrenList = [];
	        React.Children.forEach(items, function (child, index) {
	          childrenList.push( /*#__PURE__*/React.cloneElement(child, {
	            key: _this.keys[index]
	          }));
	        });
	        childrenContent = grid ? /*#__PURE__*/React.createElement(_grid.Row, {
	          gutter: grid.gutter
	        }, childrenList) : /*#__PURE__*/React.createElement("ul", {
	          className: "".concat(prefixCls, "-items")
	        }, childrenList);
	      } else if (!children && !isLoading) {
	        childrenContent = _this.renderEmpty(prefixCls, renderEmpty);
	      }
	
	      var paginationPosition = paginationProps.position || 'bottom';
	      return /*#__PURE__*/React.createElement("div", _extends({
	        className: classString
	      }, (0, _omit["default"])(rest, ['rowKey', 'renderItem', 'locale'])), (paginationPosition === 'top' || paginationPosition === 'both') && paginationContent, header && /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-header")
	      }, header), /*#__PURE__*/React.createElement(_spin["default"], loadingProp, childrenContent, children), footer && /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer")
	      }, footer), loadMore || (paginationPosition === 'bottom' || paginationPosition === 'both') && paginationContent);
	    };
	
	    var pagination = props.pagination;
	    var paginationObj = pagination && _typeof(pagination) === 'object' ? pagination : {};
	    _this.state = {
	      paginationCurrent: paginationObj.defaultCurrent || 1,
	      paginationSize: paginationObj.defaultPageSize || 10
	    };
	    return _this;
	  }
	
	  _createClass(List, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        grid: this.props.grid,
	        itemLayout: this.props.itemLayout
	      };
	    }
	  }, {
	    key: "triggerPaginationEvent",
	    value: function triggerPaginationEvent(eventName) {
	      var _this2 = this;
	
	      return function (page, pageSize) {
	        var pagination = _this2.props.pagination;
	
	        _this2.setState({
	          paginationCurrent: page,
	          paginationSize: pageSize
	        });
	
	        if (pagination && pagination[eventName]) {
	          pagination[eventName](page, pageSize);
	        }
	      };
	    }
	  }, {
	    key: "isSomethingAfterLastItem",
	    value: function isSomethingAfterLastItem() {
	      var _this$props2 = this.props,
	          loadMore = _this$props2.loadMore,
	          pagination = _this$props2.pagination,
	          footer = _this$props2.footer;
	      return !!(loadMore || pagination || footer);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderList);
	    }
	  }]);
	
	  return List;
	}(React.Component);
	
	exports["default"] = List;
	List.Item = _Item["default"];
	List.childContextTypes = {
	  grid: PropTypes.any,
	  itemLayout: PropTypes.string
	};
	List.defaultProps = {
	  dataSource: [],
	  bordered: false,
	  split: true,
	  loading: false,
	  pagination: false
	};

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _default2 = _interopRequireDefault(__webpack_require__(227));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _default2["default"];
	exports["default"] = _default;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _zh_CN = _interopRequireDefault(__webpack_require__(1287));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _zh_CN["default"];
	exports["default"] = _default;

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _zh_CN = _interopRequireDefault(__webpack_require__(1097));
	
	var _zh_CN2 = _interopRequireDefault(__webpack_require__(625));
	
	var _zh_CN3 = _interopRequireDefault(__webpack_require__(645));
	
	var _zh_CN4 = _interopRequireDefault(__webpack_require__(1246));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = {
	  locale: 'zh-cn',
	  Pagination: _zh_CN["default"],
	  DatePicker: _zh_CN2["default"],
	  TimePicker: _zh_CN3["default"],
	  Calendar: _zh_CN4["default"],
	  // locales for all comoponents
	  global: {
	    placeholder: '请选择'
	  },
	  Table: {
	    filterTitle: '筛选',
	    filterConfirm: '确定',
	    filterReset: '重置',
	    selectAll: '全选当页',
	    selectInvert: '反选当页',
	    sortTitle: '排序',
	    expand: '展开行',
	    collapse: '关闭行'
	  },
	  Modal: {
	    okText: '确定',
	    cancelText: '取消',
	    justOkText: '知道了'
	  },
	  Popconfirm: {
	    cancelText: '取消',
	    okText: '确定'
	  },
	  Transfer: {
	    searchPlaceholder: '请输入搜索内容',
	    itemUnit: '项',
	    itemsUnit: '项'
	  },
	  Upload: {
	    uploading: '文件上传中',
	    removeFile: '删除文件',
	    uploadError: '上传错误',
	    previewFile: '预览文件',
	    downloadFile: '下载文件'
	  },
	  Empty: {
	    description: '暂无数据'
	  },
	  Icon: {
	    icon: '图标'
	  },
	  Text: {
	    edit: '编辑',
	    copy: '复制',
	    copied: '复制成功',
	    expand: '展开'
	  },
	  PageHeader: {
	    back: '返回'
	  }
	};
	exports["default"] = _default;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcEditorMention = _interopRequireWildcard(__webpack_require__(2685));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Mention = /*#__PURE__*/function (_React$Component) {
	  _inherits(Mention, _React$Component);
	
	  var _super = _createSuper(Mention);
	
	  function Mention(props) {
	    var _this;
	
	    _classCallCheck(this, Mention);
	
	    _this = _super.call(this, props);
	
	    _this.mentionRef = function (ele) {
	      _this.mentionEle = ele;
	    };
	
	    _this.onSearchChange = function (value, prefix) {
	      if (_this.props.onSearchChange) {
	        return _this.props.onSearchChange(value, prefix);
	      }
	
	      return _this.defaultSearchChange(value);
	    };
	
	    _this.onChange = function (editorState) {
	      if (_this.props.onChange) {
	        _this.props.onChange(editorState);
	      }
	    };
	
	    _this.onFocus = function (ev) {
	      _this.setState({
	        focus: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(ev);
	      }
	    };
	
	    _this.onBlur = function (ev) {
	      _this.setState({
	        focus: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(ev);
	      }
	    };
	
	    _this.focus = function () {
	      _this.mentionEle._editor.focusEditor();
	    };
	
	    _this.renderMention = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          loading = _this$props.loading,
	          placement = _this$props.placement,
	          suggestions = _this$props.suggestions;
	      var _this$state = _this.state,
	          filteredSuggestions = _this$state.filteredSuggestions,
	          focus = _this$state.focus;
	      var prefixCls = getPrefixCls('mention', customizePrefixCls);
	      var cls = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-active"), focus), _defineProperty(_classNames, "".concat(prefixCls, "-placement-top"), placement === 'top'), _classNames));
	      var notFoundContent = loading ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "loading"
	      }) : _this.props.notFoundContent;
	      return /*#__PURE__*/React.createElement(_rcEditorMention["default"], _extends({}, _this.props, {
	        prefixCls: prefixCls,
	        className: cls,
	        ref: _this.mentionRef,
	        onSearchChange: _this.onSearchChange,
	        onChange: _this.onChange,
	        onFocus: _this.onFocus,
	        onBlur: _this.onBlur,
	        suggestions: suggestions || filteredSuggestions,
	        notFoundContent: notFoundContent
	      }));
	    };
	
	    _this.state = {
	      filteredSuggestions: props.defaultSuggestions,
	      focus: false
	    };
	    (0, _warning["default"])(false, 'Mention', 'Mention component is deprecated. Please use Mentions component instead.');
	    return _this;
	  }
	
	  _createClass(Mention, [{
	    key: "defaultSearchChange",
	    value: function defaultSearchChange(value) {
	      var searchValue = value.toLowerCase();
	      var filteredSuggestions = (this.props.defaultSuggestions || []).filter(function (suggestion) {
	        if (typeof suggestion === 'string') {
	          return suggestion.toLowerCase().indexOf(searchValue) !== -1;
	        }
	
	        if (suggestion.type && suggestion.type === _rcEditorMention.Nav) {
	          return suggestion.props.value ? suggestion.props.value.toLowerCase().indexOf(searchValue) !== -1 : true;
	        }
	
	        return false;
	      });
	      this.setState({
	        filteredSuggestions: filteredSuggestions
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMention);
	    }
	  }]);
	
	  return Mention;
	}(React.Component);
	
	Mention.getMentions = _rcEditorMention.getMentions;
	Mention.defaultProps = {
	  notFoundContent: 'No matches found',
	  loading: false,
	  multiLines: false,
	  placement: 'bottom'
	};
	Mention.Nav = _rcEditorMention.Nav;
	Mention.toString = _rcEditorMention.toString;
	Mention.toContentState = _rcEditorMention.toEditorState;
	(0, _reactLifecyclesCompat.polyfill)(Mention);
	var _default = Mention;
	exports["default"] = _default;

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _rcMentions = _interopRequireDefault(__webpack_require__(2700));
	
	var _spin = _interopRequireDefault(__webpack_require__(321));
	
	var _configProvider = __webpack_require__(11);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Option = _rcMentions["default"].Option;
	
	function loadingFilterOption() {
	  return true;
	}
	
	var Mentions = /*#__PURE__*/function (_React$Component) {
	  _inherits(Mentions, _React$Component);
	
	  var _super = _createSuper(Mentions);
	
	  function Mentions() {
	    var _this;
	
	    _classCallCheck(this, Mentions);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      focused: false
	    };
	
	    _this.onFocus = function () {
	      var onFocus = _this.props.onFocus;
	
	      if (onFocus) {
	        onFocus.apply(void 0, arguments);
	      }
	
	      _this.setState({
	        focused: true
	      });
	    };
	
	    _this.onBlur = function () {
	      var onBlur = _this.props.onBlur;
	
	      if (onBlur) {
	        onBlur.apply(void 0, arguments);
	      }
	
	      _this.setState({
	        focused: false
	      });
	    };
	
	    _this.getOptions = function () {
	      var _this$props = _this.props,
	          children = _this$props.children,
	          loading = _this$props.loading;
	
	      if (loading) {
	        return /*#__PURE__*/React.createElement(Option, {
	          value: "ANTD_SEARCHING",
	          disabled: true
	        }, /*#__PURE__*/React.createElement(_spin["default"], {
	          size: "small"
	        }));
	      }
	
	      return children;
	    };
	
	    _this.getFilterOption = function () {
	      var _this$props2 = _this.props,
	          filterOption = _this$props2.filterOption,
	          loading = _this$props2.loading;
	
	      if (loading) {
	        return loadingFilterOption;
	      }
	
	      return filterOption;
	    };
	
	    _this.saveMentions = function (node) {
	      _this.rcMentions = node;
	    };
	
	    _this.renderMentions = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls,
	          renderEmpty = _ref.renderEmpty;
	      var focused = _this.state.focused;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          disabled = _a.disabled,
	          restProps = __rest(_a, ["prefixCls", "className", "disabled"]);
	
	      var prefixCls = getPrefixCls('mentions', customizePrefixCls);
	      var mentionsProps = (0, _omit["default"])(restProps, ['loading']);
	      var mergedClassName = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-focused"), focused), _classNames));
	      return /*#__PURE__*/React.createElement(_rcMentions["default"], _extends({
	        prefixCls: prefixCls,
	        notFoundContent: _this.getNotFoundContent(renderEmpty),
	        className: mergedClassName,
	        disabled: disabled
	      }, mentionsProps, {
	        filterOption: _this.getFilterOption(),
	        onFocus: _this.onFocus,
	        onBlur: _this.onBlur,
	        ref: _this.saveMentions
	      }), _this.getOptions());
	    };
	
	    return _this;
	  }
	
	  _createClass(Mentions, [{
	    key: "getNotFoundContent",
	    value: function getNotFoundContent(renderEmpty) {
	      var notFoundContent = this.props.notFoundContent;
	
	      if (notFoundContent !== undefined) {
	        return notFoundContent;
	      }
	
	      return renderEmpty('Select');
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.rcMentions.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcMentions.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderMentions);
	    }
	  }]);
	
	  return Mentions;
	}(React.Component);
	
	Mentions.Option = Option;
	
	Mentions.getMentions = function () {
	  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	  var config = arguments.length > 1 ? arguments[1] : undefined;
	
	  var _ref2 = config || {},
	      _ref2$prefix = _ref2.prefix,
	      prefix = _ref2$prefix === void 0 ? '@' : _ref2$prefix,
	      _ref2$split = _ref2.split,
	      split = _ref2$split === void 0 ? ' ' : _ref2$split;
	
	  var prefixList = Array.isArray(prefix) ? prefix : [prefix];
	  return value.split(split).map(function () {
	    var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	    var hitPrefix = null;
	    prefixList.some(function (prefixStr) {
	      var startStr = str.slice(0, prefixStr.length);
	
	      if (startStr === prefixStr) {
	        hitPrefix = prefixStr;
	        return true;
	      }
	
	      return false;
	    });
	
	    if (hitPrefix !== null) {
	      return {
	        prefix: hitPrefix,
	        value: str.slice(hitPrefix.length)
	      };
	    }
	
	    return null;
	  }).filter(function (entity) {
	    return !!entity && !!entity.value;
	  });
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Mentions);
	var _default = Mentions;
	exports["default"] = _default;

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcMenu = __webpack_require__(219);
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(409));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(165));
	
	var _Sider = __webpack_require__(408);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var MenuItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  var _super = _createSuper(MenuItem);
	
	  function MenuItem() {
	    var _this;
	
	    _classCallCheck(this, MenuItem);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (e) {
	      _this.menuItem.onKeyDown(e);
	    };
	
	    _this.saveMenuItem = function (menuItem) {
	      _this.menuItem = menuItem;
	    };
	
	    _this.renderItem = function (_ref) {
	      var siderCollapsed = _ref.siderCollapsed;
	      var _this$props = _this.props,
	          level = _this$props.level,
	          children = _this$props.children,
	          rootPrefixCls = _this$props.rootPrefixCls;
	
	      var _a = _this.props,
	          title = _a.title,
	          rest = __rest(_a, ["title"]);
	
	      return /*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref2) {
	        var inlineCollapsed = _ref2.inlineCollapsed;
	        var tooltipProps = {
	          title: title || (level === 1 ? children : '')
	        };
	
	        if (!siderCollapsed && !inlineCollapsed) {
	          tooltipProps.title = null; // Reset `visible` to fix control mode tooltip display not correct
	          // ref: https://github.com/ant-design/ant-design/issues/16742
	
	          tooltipProps.visible = false;
	        }
	
	        return /*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, tooltipProps, {
	          placement: "right",
	          overlayClassName: "".concat(rootPrefixCls, "-inline-collapsed-tooltip")
	        }), /*#__PURE__*/React.createElement(_rcMenu.Item, _extends({}, rest, {
	          title: title,
	          ref: _this.saveMenuItem
	        })));
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(MenuItem, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_Sider.SiderContext.Consumer, null, this.renderItem);
	    }
	  }]);
	
	  return MenuItem;
	}(React.Component);
	
	exports["default"] = MenuItem;
	MenuItem.isMenuItem = true;

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcMenu = __webpack_require__(219);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _MenuContext = _interopRequireDefault(__webpack_require__(409));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var SubMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(SubMenu, _React$Component);
	
	  var _super = _createSuper(SubMenu);
	
	  function SubMenu() {
	    var _this;
	
	    _classCallCheck(this, SubMenu);
	
	    _this = _super.apply(this, arguments);
	
	    _this.onKeyDown = function (e) {
	      _this.subMenu.onKeyDown(e);
	    };
	
	    _this.saveSubMenu = function (subMenu) {
	      _this.subMenu = subMenu;
	    };
	
	    return _this;
	  }
	
	  _createClass(SubMenu, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          rootPrefixCls = _this$props.rootPrefixCls,
	          popupClassName = _this$props.popupClassName;
	      return /*#__PURE__*/React.createElement(_MenuContext["default"].Consumer, null, function (_ref) {
	        var antdMenuTheme = _ref.antdMenuTheme;
	        return /*#__PURE__*/React.createElement(_rcMenu.SubMenu, _extends({}, _this2.props, {
	          ref: _this2.saveSubMenu,
	          popupClassName: (0, _classnames["default"])("".concat(rootPrefixCls, "-").concat(antdMenuTheme), popupClassName)
	        }));
	      });
	    }
	  }]);
	
	  return SubMenu;
	}(React.Component);
	
	SubMenu.contextTypes = {
	  antdMenuTheme: PropTypes.string
	}; // fix issue:https://github.com/ant-design/ant-design/issues/8666
	
	SubMenu.isSubMenu = 1;
	var _default = SubMenu;
	exports["default"] = _default;

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcNotification = _interopRequireDefault(__webpack_require__(1094));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var defaultDuration = 3;
	var defaultTop;
	var messageInstance;
	var key = 1;
	var prefixCls = 'ant-message';
	var transitionName = 'move-up';
	var getContainer;
	var maxCount;
	
	function getMessageInstance(callback) {
	  if (messageInstance) {
	    callback(messageInstance);
	    return;
	  }
	
	  _rcNotification["default"].newInstance({
	    prefixCls: prefixCls,
	    transitionName: transitionName,
	    style: {
	      top: defaultTop
	    },
	    getContainer: getContainer,
	    maxCount: maxCount
	  }, function (instance) {
	    if (messageInstance) {
	      callback(messageInstance);
	      return;
	    }
	
	    messageInstance = instance;
	    callback(instance);
	  });
	}
	
	function notice(args) {
	  var duration = args.duration !== undefined ? args.duration : defaultDuration;
	  var iconType = {
	    info: 'info-circle',
	    success: 'check-circle',
	    error: 'close-circle',
	    warning: 'exclamation-circle',
	    loading: 'loading'
	  }[args.type];
	  var target = args.key || key++;
	  var closePromise = new Promise(function (resolve) {
	    var callback = function callback() {
	      if (typeof args.onClose === 'function') {
	        args.onClose();
	      }
	
	      return resolve(true);
	    };
	
	    getMessageInstance(function (instance) {
	      var iconNode = /*#__PURE__*/React.createElement(_icon["default"], {
	        type: iconType,
	        theme: iconType === 'loading' ? 'outlined' : 'filled'
	      });
	      var switchIconNode = iconType ? iconNode : '';
	      instance.notice({
	        key: target,
	        duration: duration,
	        style: {},
	        content: /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-custom-content").concat(args.type ? " ".concat(prefixCls, "-").concat(args.type) : '')
	        }, args.icon ? args.icon : switchIconNode, /*#__PURE__*/React.createElement("span", null, args.content)),
	        onClose: callback
	      });
	    });
	  });
	
	  var result = function result() {
	    if (messageInstance) {
	      messageInstance.removeNotice(target);
	    }
	  };
	
	  result.then = function (filled, rejected) {
	    return closePromise.then(filled, rejected);
	  };
	
	  result.promise = closePromise;
	  return result;
	}
	
	function isArgsProps(content) {
	  return Object.prototype.toString.call(content) === '[object Object]' && !!content.content;
	}
	
	var api = {
	  open: notice,
	  config: function config(options) {
	    if (options.top !== undefined) {
	      defaultTop = options.top;
	      messageInstance = null; // delete messageInstance for new defaultTop
	    }
	
	    if (options.duration !== undefined) {
	      defaultDuration = options.duration;
	    }
	
	    if (options.prefixCls !== undefined) {
	      prefixCls = options.prefixCls;
	    }
	
	    if (options.getContainer !== undefined) {
	      getContainer = options.getContainer;
	    }
	
	    if (options.transitionName !== undefined) {
	      transitionName = options.transitionName;
	      messageInstance = null; // delete messageInstance for new transitionName
	    }
	
	    if (options.maxCount !== undefined) {
	      maxCount = options.maxCount;
	      messageInstance = null;
	    }
	  },
	  destroy: function destroy() {
	    if (messageInstance) {
	      messageInstance.destroy();
	      messageInstance = null;
	    }
	  }
	};
	['success', 'info', 'warning', 'error', 'loading'].forEach(function (type) {
	  api[type] = function (content, duration, onClose) {
	    if (isArgsProps(content)) {
	      return api.open(_extends(_extends({}, content), {
	        type: type
	      }));
	    }
	
	    if (typeof duration === 'function') {
	      onClose = duration;
	      duration = undefined;
	    }
	
	    return api.open({
	      content: content,
	      duration: duration,
	      type: type,
	      onClose: onClose
	    });
	  };
	});
	api.warn = api.warning;
	var _default = api;
	exports["default"] = _default;

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var _button = _interopRequireDefault(__webpack_require__(189));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ActionButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(ActionButton, _React$Component);
	
	  var _super = _createSuper(ActionButton);
	
	  function ActionButton(props) {
	    var _this;
	
	    _classCallCheck(this, ActionButton);
	
	    _this = _super.call(this, props);
	
	    _this.onClick = function () {
	      var _this$props = _this.props,
	          actionFn = _this$props.actionFn,
	          closeModal = _this$props.closeModal;
	
	      if (actionFn) {
	        var ret;
	
	        if (actionFn.length) {
	          ret = actionFn(closeModal);
	        } else {
	          ret = actionFn();
	
	          if (!ret) {
	            closeModal();
	          }
	        }
	
	        if (ret && ret.then) {
	          _this.setState({
	            loading: true
	          });
	
	          ret.then(function () {
	            // It's unnecessary to set loading=false, for the Modal will be unmounted after close.
	            // this.setState({ loading: false });
	            closeModal.apply(void 0, arguments);
	          }, function (e) {
	            // Emit error when catch promise reject
	            // eslint-disable-next-line no-console
	            console.error(e); // See: https://github.com/ant-design/ant-design/issues/6183
	
	            _this.setState({
	              loading: false
	            });
	          });
	        }
	      } else {
	        closeModal();
	      }
	    };
	
	    _this.state = {
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(ActionButton, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.props.autoFocus) {
	        var $this = ReactDOM.findDOMNode(this);
	        this.timeoutId = setTimeout(function () {
	          return $this.focus();
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeoutId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          type = _this$props2.type,
	          children = _this$props2.children,
	          buttonProps = _this$props2.buttonProps;
	      var loading = this.state.loading;
	      return /*#__PURE__*/React.createElement(_button["default"], _extends({
	        type: type,
	        onClick: this.onClick,
	        loading: loading
	      }, buttonProps), children);
	    }
	  }]);
	
	  return ActionButton;
	}(React.Component);
	
	exports["default"] = ActionButton;

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = confirm;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(637));
	
	var _ActionButton = _interopRequireDefault(__webpack_require__(1293));
	
	var _locale = __webpack_require__(411);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var IS_REACT_16 = !!ReactDOM.createPortal;
	
	var ConfirmDialog = function ConfirmDialog(props) {
	  var onCancel = props.onCancel,
	      onOk = props.onOk,
	      close = props.close,
	      zIndex = props.zIndex,
	      afterClose = props.afterClose,
	      visible = props.visible,
	      keyboard = props.keyboard,
	      centered = props.centered,
	      getContainer = props.getContainer,
	      maskStyle = props.maskStyle,
	      okButtonProps = props.okButtonProps,
	      cancelButtonProps = props.cancelButtonProps,
	      _props$iconType = props.iconType,
	      iconType = _props$iconType === void 0 ? 'question-circle' : _props$iconType;
	  (0, _warning["default"])(!('iconType' in props), 'Modal', "The property 'iconType' is deprecated. Use the property 'icon' instead."); // 支持传入{ icon: null }来隐藏`Modal.confirm`默认的Icon
	
	  var icon = props.icon === undefined ? iconType : props.icon;
	  var okType = props.okType || 'primary';
	  var prefixCls = props.prefixCls || 'ant-modal';
	  var contentPrefixCls = "".concat(prefixCls, "-confirm"); // 默认为 true，保持向下兼容
	
	  var okCancel = 'okCancel' in props ? props.okCancel : true;
	  var width = props.width || 416;
	  var style = props.style || {};
	  var mask = props.mask === undefined ? true : props.mask; // 默认为 false，保持旧版默认行为
	
	  var maskClosable = props.maskClosable === undefined ? false : props.maskClosable;
	  var runtimeLocale = (0, _locale.getConfirmLocale)();
	  var okText = props.okText || (okCancel ? runtimeLocale.okText : runtimeLocale.justOkText);
	  var cancelText = props.cancelText || runtimeLocale.cancelText;
	  var autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || 'ok';
	  var transitionName = props.transitionName || 'zoom';
	  var maskTransitionName = props.maskTransitionName || 'fade';
	  var classString = (0, _classnames["default"])(contentPrefixCls, "".concat(contentPrefixCls, "-").concat(props.type), props.className);
	  var cancelButton = okCancel && /*#__PURE__*/React.createElement(_ActionButton["default"], {
	    actionFn: onCancel,
	    closeModal: close,
	    autoFocus: autoFocusButton === 'cancel',
	    buttonProps: cancelButtonProps
	  }, cancelText);
	  var iconNode = typeof icon === 'string' ? /*#__PURE__*/React.createElement(_icon["default"], {
	    type: icon
	  }) : icon;
	  return /*#__PURE__*/React.createElement(_Modal["default"], {
	    prefixCls: prefixCls,
	    className: classString,
	    wrapClassName: (0, _classnames["default"])(_defineProperty({}, "".concat(contentPrefixCls, "-centered"), !!props.centered)),
	    onCancel: function onCancel() {
	      return close({
	        triggerCancel: true
	      });
	    },
	    visible: visible,
	    title: "",
	    transitionName: transitionName,
	    footer: "",
	    maskTransitionName: maskTransitionName,
	    mask: mask,
	    maskClosable: maskClosable,
	    maskStyle: maskStyle,
	    style: style,
	    width: width,
	    zIndex: zIndex,
	    afterClose: afterClose,
	    keyboard: keyboard,
	    centered: centered,
	    getContainer: getContainer
	  }, /*#__PURE__*/React.createElement("div", {
	    className: "".concat(contentPrefixCls, "-body-wrapper")
	  }, /*#__PURE__*/React.createElement("div", {
	    className: "".concat(contentPrefixCls, "-body")
	  }, iconNode, props.title === undefined ? null : /*#__PURE__*/React.createElement("span", {
	    className: "".concat(contentPrefixCls, "-title")
	  }, props.title), /*#__PURE__*/React.createElement("div", {
	    className: "".concat(contentPrefixCls, "-content")
	  }, props.content)), /*#__PURE__*/React.createElement("div", {
	    className: "".concat(contentPrefixCls, "-btns")
	  }, cancelButton, /*#__PURE__*/React.createElement(_ActionButton["default"], {
	    type: okType,
	    actionFn: onOk,
	    closeModal: close,
	    autoFocus: autoFocusButton === 'ok',
	    buttonProps: okButtonProps
	  }, okText))));
	};
	
	function confirm(config) {
	  var div = document.createElement('div');
	  document.body.appendChild(div); // eslint-disable-next-line no-use-before-define
	
	  var currentConfig = _extends(_extends({}, config), {
	    close: close,
	    visible: true
	  });
	
	  function destroy() {
	    var unmountResult = ReactDOM.unmountComponentAtNode(div);
	
	    if (unmountResult && div.parentNode) {
	      div.parentNode.removeChild(div);
	    }
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var triggerCancel = args.some(function (param) {
	      return param && param.triggerCancel;
	    });
	
	    if (config.onCancel && triggerCancel) {
	      config.onCancel.apply(config, args);
	    }
	
	    for (var i = 0; i < _Modal.destroyFns.length; i++) {
	      var fn = _Modal.destroyFns[i]; // eslint-disable-next-line no-use-before-define
	
	      if (fn === close) {
	        _Modal.destroyFns.splice(i, 1);
	
	        break;
	      }
	    }
	  }
	
	  function render(props) {
	    ReactDOM.render( /*#__PURE__*/React.createElement(ConfirmDialog, props), div);
	  }
	
	  function close() {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    currentConfig = _extends(_extends({}, currentConfig), {
	      visible: false,
	      afterClose: destroy.bind.apply(destroy, [this].concat(args))
	    });
	
	    if (IS_REACT_16) {
	      render(currentConfig);
	    } else {
	      destroy.apply(void 0, args);
	    }
	  }
	
	  function update(newConfig) {
	    currentConfig = _extends(_extends({}, currentConfig), newConfig);
	    render(currentConfig);
	  }
	
	  render(currentConfig);
	
	  _Modal.destroyFns.push(close);
	
	  return {
	    destroy: close,
	    update: update
	  };
	}

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _Modal = _interopRequireWildcard(__webpack_require__(637));
	
	var _confirm = _interopRequireDefault(__webpack_require__(1294));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function modalWarn(props) {
	  var config = _extends({
	    type: 'warning',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "exclamation-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	}
	
	_Modal["default"].info = function infoFn(props) {
	  var config = _extends({
	    type: 'info',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "info-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].success = function successFn(props) {
	  var config = _extends({
	    type: 'success',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "check-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].error = function errorFn(props) {
	  var config = _extends({
	    type: 'error',
	    icon: /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "close-circle"
	    }),
	    okCancel: false
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].warning = modalWarn;
	_Modal["default"].warn = modalWarn;
	
	_Modal["default"].confirm = function confirmFn(props) {
	  var config = _extends({
	    type: 'confirm',
	    okCancel: true
	  }, props);
	
	  return (0, _confirm["default"])(config);
	};
	
	_Modal["default"].destroyAll = function destroyAllFn() {
	  while (_Modal.destroyFns.length) {
	    var close = _Modal.destroyFns.pop();
	
	    if (close) {
	      close();
	    }
	  }
	};
	
	var _default = _Modal["default"];
	exports["default"] = _default;

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcNotification = _interopRequireDefault(__webpack_require__(1094));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var notificationInstance = {};
	var defaultDuration = 4.5;
	var defaultTop = 24;
	var defaultBottom = 24;
	var defaultPlacement = 'topRight';
	var defaultGetContainer;
	var defaultCloseIcon;
	
	function setNotificationConfig(options) {
	  var duration = options.duration,
	      placement = options.placement,
	      bottom = options.bottom,
	      top = options.top,
	      getContainer = options.getContainer,
	      closeIcon = options.closeIcon;
	
	  if (duration !== undefined) {
	    defaultDuration = duration;
	  }
	
	  if (placement !== undefined) {
	    defaultPlacement = placement;
	  }
	
	  if (bottom !== undefined) {
	    defaultBottom = bottom;
	  }
	
	  if (top !== undefined) {
	    defaultTop = top;
	  }
	
	  if (getContainer !== undefined) {
	    defaultGetContainer = getContainer;
	  }
	
	  if (closeIcon !== undefined) {
	    defaultCloseIcon = closeIcon;
	  }
	}
	
	function getPlacementStyle(placement) {
	  var top = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultTop;
	  var bottom = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultBottom;
	  var style;
	
	  switch (placement) {
	    case 'topLeft':
	      style = {
	        left: 0,
	        top: top,
	        bottom: 'auto'
	      };
	      break;
	
	    case 'topRight':
	      style = {
	        right: 0,
	        top: top,
	        bottom: 'auto'
	      };
	      break;
	
	    case 'bottomLeft':
	      style = {
	        left: 0,
	        top: 'auto',
	        bottom: bottom
	      };
	      break;
	
	    default:
	      style = {
	        right: 0,
	        top: 'auto',
	        bottom: bottom
	      };
	      break;
	  }
	
	  return style;
	}
	
	function getNotificationInstance(_ref, callback) {
	  var prefixCls = _ref.prefixCls,
	      _ref$placement = _ref.placement,
	      placement = _ref$placement === void 0 ? defaultPlacement : _ref$placement,
	      _ref$getContainer = _ref.getContainer,
	      getContainer = _ref$getContainer === void 0 ? defaultGetContainer : _ref$getContainer,
	      top = _ref.top,
	      bottom = _ref.bottom,
	      _ref$closeIcon = _ref.closeIcon,
	      closeIcon = _ref$closeIcon === void 0 ? defaultCloseIcon : _ref$closeIcon;
	  var cacheKey = "".concat(prefixCls, "-").concat(placement);
	
	  if (notificationInstance[cacheKey]) {
	    callback(notificationInstance[cacheKey]);
	    return;
	  }
	
	  var closeIconToRender = /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-close-x")
	  }, closeIcon || /*#__PURE__*/React.createElement(_icon["default"], {
	    className: "".concat(prefixCls, "-close-icon"),
	    type: "close"
	  }));
	
	  _rcNotification["default"].newInstance({
	    prefixCls: prefixCls,
	    className: "".concat(prefixCls, "-").concat(placement),
	    style: getPlacementStyle(placement, top, bottom),
	    getContainer: getContainer,
	    closeIcon: closeIconToRender
	  }, function (notification) {
	    notificationInstance[cacheKey] = notification;
	    callback(notification);
	  });
	}
	
	var typeToIcon = {
	  success: 'check-circle-o',
	  info: 'info-circle-o',
	  error: 'close-circle-o',
	  warning: 'exclamation-circle-o'
	};
	
	function notice(args) {
	  var outerPrefixCls = args.prefixCls || 'ant-notification';
	  var prefixCls = "".concat(outerPrefixCls, "-notice");
	  var duration = args.duration === undefined ? defaultDuration : args.duration;
	  var iconNode = null;
	
	  if (args.icon) {
	    iconNode = /*#__PURE__*/React.createElement("span", {
	      className: "".concat(prefixCls, "-icon")
	    }, args.icon);
	  } else if (args.type) {
	    var iconType = typeToIcon[args.type];
	    iconNode = /*#__PURE__*/React.createElement(_icon["default"], {
	      className: "".concat(prefixCls, "-icon ").concat(prefixCls, "-icon-").concat(args.type),
	      type: iconType
	    });
	  }
	
	  var autoMarginTag = !args.description && iconNode ? /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-message-single-line-auto-margin")
	  }) : null;
	  var placement = args.placement,
	      top = args.top,
	      bottom = args.bottom,
	      getContainer = args.getContainer,
	      closeIcon = args.closeIcon;
	  getNotificationInstance({
	    prefixCls: outerPrefixCls,
	    placement: placement,
	    top: top,
	    bottom: bottom,
	    getContainer: getContainer,
	    closeIcon: closeIcon
	  }, function (notification) {
	    notification.notice({
	      content: /*#__PURE__*/React.createElement("div", {
	        className: iconNode ? "".concat(prefixCls, "-with-icon") : ''
	      }, iconNode, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-message")
	      }, autoMarginTag, args.message), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-description")
	      }, args.description), args.btn ? /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-btn")
	      }, args.btn) : null),
	      duration: duration,
	      closable: true,
	      onClose: args.onClose,
	      onClick: args.onClick,
	      key: args.key,
	      style: args.style || {},
	      className: args.className
	    });
	  });
	}
	
	var api = {
	  open: notice,
	  close: function close(key) {
	    Object.keys(notificationInstance).forEach(function (cacheKey) {
	      return notificationInstance[cacheKey].removeNotice(key);
	    });
	  },
	  config: setNotificationConfig,
	  destroy: function destroy() {
	    Object.keys(notificationInstance).forEach(function (cacheKey) {
	      notificationInstance[cacheKey].destroy();
	      delete notificationInstance[cacheKey];
	    });
	  }
	};
	['success', 'info', 'warning', 'error'].forEach(function (type) {
	  api[type] = function (args) {
	    return api.open(_extends(_extends({}, args), {
	      type: type
	    }));
	  };
	});
	api.warn = api.warning;
	var _default = api;
	exports["default"] = _default;

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames2 = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _breadcrumb = _interopRequireDefault(__webpack_require__(620));
	
	var _avatar = _interopRequireDefault(__webpack_require__(618));
	
	var _transButton = _interopRequireDefault(__webpack_require__(403));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var renderBack = function renderBack(prefixCls, backIcon, onBack) {
	  if (!backIcon || !onBack) {
	    return null;
	  }
	
	  return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	    componentName: "PageHeader"
	  }, function (_ref) {
	    var back = _ref.back;
	    return /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-back")
	    }, /*#__PURE__*/React.createElement(_transButton["default"], {
	      onClick: function onClick(e) {
	        if (onBack) {
	          onBack(e);
	        }
	      },
	      className: "".concat(prefixCls, "-back-button"),
	      "aria-label": back
	    }, backIcon));
	  });
	};
	
	var renderBreadcrumb = function renderBreadcrumb(breadcrumb) {
	  return /*#__PURE__*/React.createElement(_breadcrumb["default"], breadcrumb);
	};
	
	var renderTitle = function renderTitle(prefixCls, props) {
	  var title = props.title,
	      avatar = props.avatar,
	      subTitle = props.subTitle,
	      tags = props.tags,
	      extra = props.extra,
	      backIcon = props.backIcon,
	      onBack = props.onBack;
	  var headingPrefixCls = "".concat(prefixCls, "-heading");
	
	  if (title || subTitle || tags || extra) {
	    var backIconDom = renderBack(prefixCls, backIcon, onBack);
	    return /*#__PURE__*/React.createElement("div", {
	      className: headingPrefixCls
	    }, backIconDom, avatar && /*#__PURE__*/React.createElement(_avatar["default"], avatar), title && /*#__PURE__*/React.createElement("span", {
	      className: "".concat(headingPrefixCls, "-title")
	    }, title), subTitle && /*#__PURE__*/React.createElement("span", {
	      className: "".concat(headingPrefixCls, "-sub-title")
	    }, subTitle), tags && /*#__PURE__*/React.createElement("span", {
	      className: "".concat(headingPrefixCls, "-tags")
	    }, tags), extra && /*#__PURE__*/React.createElement("span", {
	      className: "".concat(headingPrefixCls, "-extra")
	    }, extra));
	  }
	
	  return null;
	};
	
	var renderFooter = function renderFooter(prefixCls, footer) {
	  if (footer) {
	    return /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-footer")
	    }, footer);
	  }
	
	  return null;
	};
	
	var renderChildren = function renderChildren(prefixCls, children) {
	  return /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-content")
	  }, children);
	};
	
	var PageHeader = function PageHeader(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	    var getPrefixCls = _ref2.getPrefixCls,
	        pageHeader = _ref2.pageHeader;
	    var customizePrefixCls = props.prefixCls,
	        style = props.style,
	        footer = props.footer,
	        children = props.children,
	        breadcrumb = props.breadcrumb,
	        customizeClassName = props.className;
	    var ghost = true; // Use `ghost` from `props` or from `ConfigProvider` instead.
	
	    if ('ghost' in props) {
	      ghost = props.ghost;
	    } else if (pageHeader && 'ghost' in pageHeader) {
	      ghost = pageHeader.ghost;
	    }
	
	    var prefixCls = getPrefixCls('page-header', customizePrefixCls);
	    var breadcrumbDom = breadcrumb && breadcrumb.routes ? renderBreadcrumb(breadcrumb) : null;
	    var className = (0, _classnames2["default"])(prefixCls, customizeClassName, _defineProperty({
	      'has-breadcrumb': breadcrumbDom,
	      'has-footer': footer
	    }, "".concat(prefixCls, "-ghost"), ghost));
	    return /*#__PURE__*/React.createElement("div", {
	      className: className,
	      style: style
	    }, breadcrumbDom, renderTitle(prefixCls, props), children && renderChildren(prefixCls, children), renderFooter(prefixCls, footer));
	  });
	};
	
	PageHeader.defaultProps = {
	  backIcon: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "arrow-left"
	  })
	};
	var _default = PageHeader;
	exports["default"] = _default;

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _select = _interopRequireDefault(__webpack_require__(270));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var MiniSelect = /*#__PURE__*/function (_React$Component) {
	  _inherits(MiniSelect, _React$Component);
	
	  var _super = _createSuper(MiniSelect);
	
	  function MiniSelect() {
	    _classCallCheck(this, MiniSelect);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(MiniSelect, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_select["default"], _extends({
	        size: "small"
	      }, this.props));
	    }
	  }]);
	
	  return MiniSelect;
	}(React.Component);
	
	exports["default"] = MiniSelect;
	MiniSelect.Option = _select["default"].Option;

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcPagination = _interopRequireDefault(__webpack_require__(2715));
	
	var _en_US = _interopRequireDefault(__webpack_require__(1096));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _MiniSelect = _interopRequireDefault(__webpack_require__(1298));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _select = _interopRequireDefault(__webpack_require__(270));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Pagination = /*#__PURE__*/function (_React$Component) {
	  _inherits(Pagination, _React$Component);
	
	  var _super = _createSuper(Pagination);
	
	  function Pagination() {
	    var _this;
	
	    _classCallCheck(this, Pagination);
	
	    _this = _super.apply(this, arguments);
	
	    _this.getIconsProps = function (prefixCls) {
	      var prevIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "left"
	      }));
	      var nextIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "right"
	      }));
	      var jumpPrevIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-container")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-item-link-icon"),
	        type: "double-left"
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-ellipsis")
	      }, "\u2022\u2022\u2022")));
	      var jumpNextIcon = /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-item-link")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-item-container")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        className: "".concat(prefixCls, "-item-link-icon"),
	        type: "double-right"
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-item-ellipsis")
	      }, "\u2022\u2022\u2022")));
	      return {
	        prevIcon: prevIcon,
	        nextIcon: nextIcon,
	        jumpPrevIcon: jumpPrevIcon,
	        jumpNextIcon: jumpNextIcon
	      };
	    };
	
	    _this.renderPagination = function (contextLocale) {
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeSelectPrefixCls = _a.selectPrefixCls,
	          className = _a.className,
	          size = _a.size,
	          customLocale = _a.locale,
	          restProps = __rest(_a, ["prefixCls", "selectPrefixCls", "className", "size", "locale"]);
	
	      var locale = _extends(_extends({}, contextLocale), customLocale);
	
	      var isSmall = size === 'small';
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	        var getPrefixCls = _ref.getPrefixCls;
	        var prefixCls = getPrefixCls('pagination', customizePrefixCls);
	        var selectPrefixCls = getPrefixCls('select', customizeSelectPrefixCls);
	        return /*#__PURE__*/React.createElement(_rcPagination["default"], _extends({}, restProps, {
	          prefixCls: prefixCls,
	          selectPrefixCls: selectPrefixCls
	        }, _this.getIconsProps(prefixCls), {
	          className: (0, _classnames["default"])(className, {
	            mini: isSmall
	          }),
	          selectComponentClass: isSmall ? _MiniSelect["default"] : _select["default"],
	          locale: locale
	        }));
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(Pagination, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Pagination",
	        defaultLocale: _en_US["default"]
	      }, this.renderPagination);
	    }
	  }]);
	
	  return Pagination;
	}(React.Component);
	
	exports["default"] = Pagination;

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _tooltip = _interopRequireDefault(__webpack_require__(165));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _button = _interopRequireDefault(__webpack_require__(189));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _default2 = _interopRequireDefault(__webpack_require__(227));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Popconfirm = /*#__PURE__*/function (_React$Component) {
	  _inherits(Popconfirm, _React$Component);
	
	  var _super = _createSuper(Popconfirm);
	
	  function Popconfirm(props) {
	    var _this;
	
	    _classCallCheck(this, Popconfirm);
	
	    _this = _super.call(this, props);
	
	    _this.onConfirm = function (e) {
	      _this.setVisible(false, e);
	
	      var onConfirm = _this.props.onConfirm;
	
	      if (onConfirm) {
	        onConfirm.call(_assertThisInitialized(_this), e);
	      }
	    };
	
	    _this.onCancel = function (e) {
	      _this.setVisible(false, e);
	
	      var onCancel = _this.props.onCancel;
	
	      if (onCancel) {
	        onCancel.call(_assertThisInitialized(_this), e);
	      }
	    };
	
	    _this.onVisibleChange = function (visible) {
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        return;
	      }
	
	      _this.setVisible(visible);
	    };
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    };
	
	    _this.renderOverlay = function (prefixCls, popconfirmLocale) {
	      var _this$props = _this.props,
	          okButtonProps = _this$props.okButtonProps,
	          cancelButtonProps = _this$props.cancelButtonProps,
	          title = _this$props.title,
	          cancelText = _this$props.cancelText,
	          okText = _this$props.okText,
	          okType = _this$props.okType,
	          icon = _this$props.icon;
	      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-inner-content")
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-message")
	      }, icon, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-message-title")
	      }, title)), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-buttons")
	      }, /*#__PURE__*/React.createElement(_button["default"], _extends({
	        onClick: _this.onCancel,
	        size: "small"
	      }, cancelButtonProps), cancelText || popconfirmLocale.cancelText), /*#__PURE__*/React.createElement(_button["default"], _extends({
	        onClick: _this.onConfirm,
	        type: okType,
	        size: "small"
	      }, okButtonProps), okText || popconfirmLocale.okText))));
	    };
	
	    _this.renderConfirm = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          placement = _a.placement,
	          restProps = __rest(_a, ["prefixCls", "placement"]);
	
	      var prefixCls = getPrefixCls('popover', customizePrefixCls);
	      var overlay = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Popconfirm",
	        defaultLocale: _default2["default"].Popconfirm
	      }, function (popconfirmLocale) {
	        return _this.renderOverlay(prefixCls, popconfirmLocale);
	      });
	      return /*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, restProps, {
	        prefixCls: prefixCls,
	        placement: placement,
	        onVisibleChange: _this.onVisibleChange,
	        visible: _this.state.visible,
	        overlay: overlay,
	        ref: _this.saveTooltip
	      }));
	    };
	
	    _this.state = {
	      visible: props.visible
	    };
	    return _this;
	  }
	
	  _createClass(Popconfirm, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible, e) {
	      var props = this.props;
	
	      if (!('visible' in props)) {
	        this.setState({
	          visible: visible
	        });
	      }
	
	      var onVisibleChange = props.onVisibleChange;
	
	      if (onVisibleChange) {
	        onVisibleChange(visible, e);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderConfirm);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('visible' in nextProps) {
	        return {
	          visible: nextProps.visible
	        };
	      }
	
	      if ('defaultVisible' in nextProps) {
	        return {
	          visible: nextProps.defaultVisible
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Popconfirm;
	}(React.Component);
	
	Popconfirm.defaultProps = {
	  transitionName: 'zoom-big',
	  placement: 'top',
	  trigger: 'click',
	  okType: 'primary',
	  icon: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "exclamation-circle",
	    theme: "filled"
	  }),
	  disabled: false
	};
	(0, _reactLifecyclesCompat.polyfill)(Popconfirm);
	var _default = Popconfirm;
	exports["default"] = _default;

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(165));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Popover = /*#__PURE__*/function (_React$Component) {
	  _inherits(Popover, _React$Component);
	
	  var _super = _createSuper(Popover);
	
	  function Popover() {
	    var _this;
	
	    _classCallCheck(this, Popover);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveTooltip = function (node) {
	      _this.tooltip = node;
	    };
	
	    _this.renderPopover = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          props = __rest(_a, ["prefixCls"]);
	
	      delete props.title;
	      var prefixCls = getPrefixCls('popover', customizePrefixCls);
	      return /*#__PURE__*/React.createElement(_tooltip["default"], _extends({}, props, {
	        prefixCls: prefixCls,
	        ref: _this.saveTooltip,
	        overlay: _this.getOverlay(prefixCls)
	      }));
	    };
	
	    return _this;
	  }
	
	  _createClass(Popover, [{
	    key: "getPopupDomNode",
	    value: function getPopupDomNode() {
	      return this.tooltip.getPopupDomNode();
	    }
	  }, {
	    key: "getOverlay",
	    value: function getOverlay(prefixCls) {
	      var _this$props = this.props,
	          title = _this$props.title,
	          content = _this$props.content;
	      (0, _warning["default"])(!('overlay' in this.props), 'Popover', '`overlay` is removed, please use `content` instead, ' + 'see: https://u.ant.design/popover-content');
	      return /*#__PURE__*/React.createElement("div", null, title && /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-title")
	      }, title), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-inner-content")
	      }, content));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderPopover);
	    }
	  }]);
	
	  return Popover;
	}(React.Component);
	
	exports["default"] = Popover;
	Popover.defaultProps = {
	  placement: 'top',
	  transitionName: 'zoom-big',
	  trigger: 'hover',
	  mouseEnterDelay: 0.1,
	  mouseLeaveDelay: 0.1,
	  overlayStyle: {}
	};

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcProgress = __webpack_require__(2718);
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var statusColorMap = {
	  normal: '#108ee9',
	  exception: '#ff5500',
	  success: '#87d068'
	};
	
	function getPercentage(_ref) {
	  var percent = _ref.percent,
	      successPercent = _ref.successPercent;
	  var ptg = (0, _utils.validProgress)(percent);
	
	  if (!successPercent) {
	    return ptg;
	  }
	
	  var successPtg = (0, _utils.validProgress)(successPercent);
	  return [successPercent, (0, _utils.validProgress)(ptg - successPtg)];
	}
	
	function getStrokeColor(_ref2) {
	  var progressStatus = _ref2.progressStatus,
	      successPercent = _ref2.successPercent,
	      strokeColor = _ref2.strokeColor;
	  var color = strokeColor || statusColorMap[progressStatus];
	
	  if (!successPercent) {
	    return color;
	  }
	
	  return [statusColorMap.success, color];
	}
	
	var Circle = function Circle(props) {
	  var prefixCls = props.prefixCls,
	      width = props.width,
	      strokeWidth = props.strokeWidth,
	      trailColor = props.trailColor,
	      strokeLinecap = props.strokeLinecap,
	      gapPosition = props.gapPosition,
	      gapDegree = props.gapDegree,
	      type = props.type,
	      children = props.children;
	  var circleSize = width || 120;
	  var circleStyle = {
	    width: circleSize,
	    height: circleSize,
	    fontSize: circleSize * 0.15 + 6
	  };
	  var circleWidth = strokeWidth || 6;
	  var gapPos = gapPosition || type === 'dashboard' && 'bottom' || 'top';
	  var gapDeg = gapDegree || (type === 'dashboard' ? 75 : undefined);
	  var strokeColor = getStrokeColor(props);
	  var isGradient = Object.prototype.toString.call(strokeColor) === '[object Object]';
	  var wrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-inner"), _defineProperty({}, "".concat(prefixCls, "-circle-gradient"), isGradient));
	  return /*#__PURE__*/React.createElement("div", {
	    className: wrapperClassName,
	    style: circleStyle
	  }, /*#__PURE__*/React.createElement(_rcProgress.Circle, {
	    percent: getPercentage(props),
	    strokeWidth: circleWidth,
	    trailWidth: circleWidth,
	    strokeColor: strokeColor,
	    strokeLinecap: strokeLinecap,
	    trailColor: trailColor,
	    prefixCls: prefixCls,
	    gapDegree: gapDeg,
	    gapPosition: gapPos
	  }), children);
	};
	
	var _default = Circle;
	exports["default"] = _default;

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.handleGradient = exports.sortGradient = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _utils = __webpack_require__(413);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	/**
	 * {
	 *   '0%': '#afc163',
	 *   '75%': '#009900',
	 *   '50%': 'green',     ====>     '#afc163 0%, #66FF00 25%, #00CC00 50%, #009900 75%, #ffffff 100%'
	 *   '25%': '#66FF00',
	 *   '100%': '#ffffff'
	 * }
	 */
	var sortGradient = function sortGradient(gradients) {
	  var tempArr = []; // eslint-disable-next-line no-restricted-syntax
	
	  for (var _i = 0, _Object$entries = Object.entries(gradients); _i < _Object$entries.length; _i++) {
	    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
	        key = _Object$entries$_i[0],
	        value = _Object$entries$_i[1];
	
	    var formatKey = parseFloat(key.replace(/%/g, ''));
	
	    if (isNaN(formatKey)) {
	      return {};
	    }
	
	    tempArr.push({
	      key: formatKey,
	      value: value
	    });
	  }
	
	  tempArr = tempArr.sort(function (a, b) {
	    return a.key - b.key;
	  });
	  return tempArr.map(function (_ref) {
	    var key = _ref.key,
	        value = _ref.value;
	    return "".concat(value, " ").concat(key, "%");
	  }).join(', ');
	};
	/**
	 * {
	 *   '0%': '#afc163',
	 *   '25%': '#66FF00',
	 *   '50%': '#00CC00',     ====>  linear-gradient(to right, #afc163 0%, #66FF00 25%,
	 *   '75%': '#009900',              #00CC00 50%, #009900 75%, #ffffff 100%)
	 *   '100%': '#ffffff'
	 * }
	 *
	 * Then this man came to realize the truth:
	 * Besides six pence, there is the moon.
	 * Besides bread and butter, there is the bug.
	 * And...
	 * Besides women, there is the code.
	 */
	
	
	exports.sortGradient = sortGradient;
	
	var handleGradient = function handleGradient(strokeColor) {
	  var _strokeColor$from = strokeColor.from,
	      from = _strokeColor$from === void 0 ? '#1890ff' : _strokeColor$from,
	      _strokeColor$to = strokeColor.to,
	      to = _strokeColor$to === void 0 ? '#1890ff' : _strokeColor$to,
	      _strokeColor$directio = strokeColor.direction,
	      direction = _strokeColor$directio === void 0 ? 'to right' : _strokeColor$directio,
	      rest = __rest(strokeColor, ["from", "to", "direction"]);
	
	  if (Object.keys(rest).length !== 0) {
	    var sortedGradients = sortGradient(rest);
	    return {
	      backgroundImage: "linear-gradient(".concat(direction, ", ").concat(sortedGradients, ")")
	    };
	  }
	
	  return {
	    backgroundImage: "linear-gradient(".concat(direction, ", ").concat(from, ", ").concat(to, ")")
	  };
	};
	
	exports.handleGradient = handleGradient;
	
	var Line = function Line(props) {
	  var prefixCls = props.prefixCls,
	      percent = props.percent,
	      successPercent = props.successPercent,
	      strokeWidth = props.strokeWidth,
	      size = props.size,
	      strokeColor = props.strokeColor,
	      strokeLinecap = props.strokeLinecap,
	      children = props.children;
	  var backgroundProps;
	
	  if (strokeColor && typeof strokeColor !== 'string') {
	    backgroundProps = handleGradient(strokeColor);
	  } else {
	    backgroundProps = {
	      background: strokeColor
	    };
	  }
	
	  var percentStyle = _extends({
	    width: "".concat((0, _utils.validProgress)(percent), "%"),
	    height: strokeWidth || (size === 'small' ? 6 : 8),
	    borderRadius: strokeLinecap === 'square' ? 0 : ''
	  }, backgroundProps);
	
	  var successPercentStyle = {
	    width: "".concat((0, _utils.validProgress)(successPercent), "%"),
	    height: strokeWidth || (size === 'small' ? 6 : 8),
	    borderRadius: strokeLinecap === 'square' ? 0 : ''
	  };
	  var successSegment = successPercent !== undefined ? /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-success-bg"),
	    style: successPercentStyle
	  }) : null;
	  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-outer")
	  }, /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-inner")
	  }, /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-bg"),
	    style: percentStyle
	  }), successSegment)), children);
	};
	
	var _default = Line;
	exports["default"] = _default;

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	var _type = __webpack_require__(87);
	
	var _Line = _interopRequireDefault(__webpack_require__(1303));
	
	var _Circle = _interopRequireDefault(__webpack_require__(1302));
	
	var _utils = __webpack_require__(413);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var ProgressTypes = (0, _type.tuple)('line', 'circle', 'dashboard');
	var ProgressStatuses = (0, _type.tuple)('normal', 'exception', 'active', 'success');
	
	var Progress = /*#__PURE__*/function (_React$Component) {
	  _inherits(Progress, _React$Component);
	
	  var _super = _createSuper(Progress);
	
	  function Progress() {
	    var _this;
	
	    _classCallCheck(this, Progress);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderProgress = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          className = props.className,
	          size = props.size,
	          type = props.type,
	          showInfo = props.showInfo,
	          restProps = __rest(props, ["prefixCls", "className", "size", "type", "showInfo"]);
	
	      var prefixCls = getPrefixCls('progress', customizePrefixCls);
	
	      var progressStatus = _this.getProgressStatus();
	
	      var progressInfo = _this.renderProcessInfo(prefixCls, progressStatus);
	
	      var progress; // Render progress shape
	
	      if (type === 'line') {
	        progress = /*#__PURE__*/React.createElement(_Line["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls
	        }), progressInfo);
	      } else if (type === 'circle' || type === 'dashboard') {
	        progress = /*#__PURE__*/React.createElement(_Circle["default"], _extends({}, _this.props, {
	          prefixCls: prefixCls,
	          progressStatus: progressStatus
	        }), progressInfo);
	      }
	
	      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type === 'dashboard' && 'circle' || type), true), _defineProperty(_classNames, "".concat(prefixCls, "-status-").concat(progressStatus), true), _defineProperty(_classNames, "".concat(prefixCls, "-show-info"), showInfo), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _classNames), className);
	      return /*#__PURE__*/React.createElement("div", _extends({}, (0, _omit["default"])(restProps, ['status', 'format', 'trailColor', 'successPercent', 'strokeWidth', 'width', 'gapDegree', 'gapPosition', 'strokeColor', 'strokeLinecap', 'percent']), {
	        className: classString
	      }), progress);
	    };
	
	    return _this;
	  }
	
	  _createClass(Progress, [{
	    key: "getPercentNumber",
	    value: function getPercentNumber() {
	      var _this$props = this.props,
	          successPercent = _this$props.successPercent,
	          _this$props$percent = _this$props.percent,
	          percent = _this$props$percent === void 0 ? 0 : _this$props$percent;
	      return parseInt(successPercent !== undefined ? successPercent.toString() : percent.toString(), 10);
	    }
	  }, {
	    key: "getProgressStatus",
	    value: function getProgressStatus() {
	      var status = this.props.status;
	
	      if (ProgressStatuses.indexOf(status) < 0 && this.getPercentNumber() >= 100) {
	        return 'success';
	      }
	
	      return status || 'normal';
	    }
	  }, {
	    key: "renderProcessInfo",
	    value: function renderProcessInfo(prefixCls, progressStatus) {
	      var _this$props2 = this.props,
	          showInfo = _this$props2.showInfo,
	          format = _this$props2.format,
	          type = _this$props2.type,
	          percent = _this$props2.percent,
	          successPercent = _this$props2.successPercent;
	      if (!showInfo) return null;
	      var text;
	
	      var textFormatter = format || function (percentNumber) {
	        return "".concat(percentNumber, "%");
	      };
	
	      var iconType = type === 'circle' || type === 'dashboard' ? '' : '-circle';
	
	      if (format || progressStatus !== 'exception' && progressStatus !== 'success') {
	        text = textFormatter((0, _utils.validProgress)(percent), (0, _utils.validProgress)(successPercent));
	      } else if (progressStatus === 'exception') {
	        text = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close".concat(iconType),
	          theme: type === 'line' ? 'filled' : 'outlined'
	        });
	      } else if (progressStatus === 'success') {
	        text = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "check".concat(iconType),
	          theme: type === 'line' ? 'filled' : 'outlined'
	        });
	      }
	
	      return /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-text"),
	        title: typeof text === 'string' ? text : undefined
	      }, text);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderProgress);
	    }
	  }]);
	
	  return Progress;
	}(React.Component);
	
	exports["default"] = Progress;
	Progress.defaultProps = {
	  type: 'line',
	  percent: 0,
	  showInfo: true,
	  trailColor: '#f3f3f3',
	  size: 'default',
	  gapDegree: 0,
	  strokeLinecap: 'round'
	};
	Progress.propTypes = {
	  status: PropTypes.oneOf(ProgressStatuses),
	  type: PropTypes.oneOf(ProgressTypes),
	  showInfo: PropTypes.bool,
	  percent: PropTypes.number,
	  width: PropTypes.number,
	  strokeWidth: PropTypes.number,
	  strokeLinecap: PropTypes.oneOf(['round', 'square']),
	  strokeColor: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
	  trailColor: PropTypes.string,
	  format: PropTypes.func,
	  gapDegree: PropTypes.number
	};

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(79));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _radio = _interopRequireDefault(__webpack_require__(414));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function getCheckedValue(children) {
	  var value = null;
	  var matched = false;
	  React.Children.forEach(children, function (radio) {
	    if (radio && radio.props && radio.props.checked) {
	      value = radio.props.value;
	      matched = true;
	    }
	  });
	  return matched ? {
	    value: value
	  } : undefined;
	}
	
	var RadioGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(RadioGroup, _React$Component);
	
	  var _super = _createSuper(RadioGroup);
	
	  function RadioGroup(props) {
	    var _this;
	
	    _classCallCheck(this, RadioGroup);
	
	    _this = _super.call(this, props);
	
	    _this.onRadioChange = function (ev) {
	      var lastValue = _this.state.value;
	      var value = ev.target.value;
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      var onChange = _this.props.onChange;
	
	      if (onChange && value !== lastValue) {
	        onChange(ev);
	      }
	    };
	
	    _this.renderGroup = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      var customizePrefixCls = props.prefixCls,
	          _props$className = props.className,
	          className = _props$className === void 0 ? '' : _props$className,
	          options = props.options,
	          buttonStyle = props.buttonStyle;
	      var prefixCls = getPrefixCls('radio', customizePrefixCls);
	      var groupPrefixCls = "".concat(prefixCls, "-group");
	      var classString = (0, _classnames["default"])(groupPrefixCls, "".concat(groupPrefixCls, "-").concat(buttonStyle), _defineProperty({}, "".concat(groupPrefixCls, "-").concat(props.size), props.size), className);
	      var children = props.children; // 如果存在 options, 优先使用
	
	      if (options && options.length > 0) {
	        children = options.map(function (option) {
	          if (typeof option === 'string') {
	            // 此处类型自动推导为 string
	            return /*#__PURE__*/React.createElement(_radio["default"], {
	              key: option,
	              prefixCls: prefixCls,
	              disabled: _this.props.disabled,
	              value: option,
	              checked: _this.state.value === option
	            }, option);
	          } // 此处类型自动推导为 { label: string value: string }
	
	
	          return /*#__PURE__*/React.createElement(_radio["default"], {
	            key: "radio-group-value-options-".concat(option.value),
	            prefixCls: prefixCls,
	            disabled: option.disabled || _this.props.disabled,
	            value: option.value,
	            checked: _this.state.value === option.value
	          }, option.label);
	        });
	      }
	
	      return /*#__PURE__*/React.createElement("div", {
	        className: classString,
	        style: props.style,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        id: props.id
	      }, children);
	    };
	
	    var value;
	
	    if ('value' in props) {
	      value = props.value;
	    } else if ('defaultValue' in props) {
	      value = props.defaultValue;
	    } else {
	      var checkedValue = getCheckedValue(props.children);
	      value = checkedValue && checkedValue.value;
	    }
	
	    _this.state = {
	      value: value
	    };
	    return _this;
	  }
	
	  _createClass(RadioGroup, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        radioGroup: {
	          onChange: this.onRadioChange,
	          value: this.state.value,
	          disabled: this.props.disabled,
	          name: this.props.name
	        }
	      };
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal["default"])(this.props, nextProps) || !(0, _shallowequal["default"])(this.state, nextState);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderGroup);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if ('value' in nextProps) {
	        return {
	          value: nextProps.value
	        };
	      }
	
	      var checkedValue = getCheckedValue(nextProps.children);
	
	      if (checkedValue) {
	        return {
	          value: checkedValue.value
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return RadioGroup;
	}(React.Component);
	
	RadioGroup.defaultProps = {
	  buttonStyle: 'outline'
	};
	RadioGroup.childContextTypes = {
	  radioGroup: PropTypes.any
	};
	(0, _reactLifecyclesCompat.polyfill)(RadioGroup);
	var _default = RadioGroup;
	exports["default"] = _default;

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _radio = _interopRequireDefault(__webpack_require__(414));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var RadioButton = /*#__PURE__*/function (_React$Component) {
	  _inherits(RadioButton, _React$Component);
	
	  var _super = _createSuper(RadioButton);
	
	  function RadioButton() {
	    var _this;
	
	    _classCallCheck(this, RadioButton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderRadioButton = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          radioProps = __rest(_a, ["prefixCls"]);
	
	      var prefixCls = getPrefixCls('radio-button', customizePrefixCls);
	
	      if (_this.context.radioGroup) {
	        radioProps.checked = _this.props.value === _this.context.radioGroup.value;
	        radioProps.disabled = _this.props.disabled || _this.context.radioGroup.disabled;
	      }
	
	      return /*#__PURE__*/React.createElement(_radio["default"], _extends({
	        prefixCls: prefixCls
	      }, radioProps));
	    };
	
	    return _this;
	  }
	
	  _createClass(RadioButton, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRadioButton);
	    }
	  }]);
	
	  return RadioButton;
	}(React.Component);
	
	exports["default"] = RadioButton;
	RadioButton.contextTypes = {
	  radioGroup: PropTypes.any
	};

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcRate = _interopRequireDefault(__webpack_require__(2721));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(165));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Rate = /*#__PURE__*/function (_React$Component) {
	  _inherits(Rate, _React$Component);
	
	  var _super = _createSuper(Rate);
	
	  function Rate() {
	    var _this;
	
	    _classCallCheck(this, Rate);
	
	    _this = _super.apply(this, arguments);
	
	    _this.saveRate = function (node) {
	      _this.rcRate = node;
	    };
	
	    _this.characterRender = function (node, _ref) {
	      var index = _ref.index;
	      var tooltips = _this.props.tooltips;
	      if (!tooltips) return node;
	      return /*#__PURE__*/React.createElement(_tooltip["default"], {
	        title: tooltips[index]
	      }, node);
	    };
	
	    _this.renderRate = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          prefixCls = _a.prefixCls,
	          restProps = __rest(_a, ["prefixCls"]);
	
	      var rateProps = (0, _omit["default"])(restProps, ['tooltips']);
	      return /*#__PURE__*/React.createElement(_rcRate["default"], _extends({
	        ref: _this.saveRate,
	        characterRender: _this.characterRender
	      }, rateProps, {
	        prefixCls: getPrefixCls('rate', prefixCls)
	      }));
	    };
	
	    return _this;
	  }
	
	  _createClass(Rate, [{
	    key: "focus",
	    value: function focus() {
	      this.rcRate.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcRate.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRate);
	    }
	  }]);
	
	  return Rate;
	}(React.Component);
	
	exports["default"] = Rate;
	Rate.propTypes = {
	  prefixCls: PropTypes.string,
	  character: PropTypes.node
	};
	Rate.defaultProps = {
	  character: /*#__PURE__*/React.createElement(_icon["default"], {
	    type: "star",
	    theme: "filled"
	  })
	};

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.ExceptionMap = exports.IconMap = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _noFound = _interopRequireDefault(__webpack_require__(1309));
	
	var _serverError = _interopRequireDefault(__webpack_require__(1310));
	
	var _unauthorized = _interopRequireDefault(__webpack_require__(1311));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var IconMap = {
	  success: 'check-circle',
	  error: 'close-circle',
	  info: 'exclamation-circle',
	  warning: 'warning'
	};
	exports.IconMap = IconMap;
	var ExceptionMap = {
	  '404': _noFound["default"],
	  '500': _serverError["default"],
	  '403': _unauthorized["default"]
	}; // ExceptionImageMap keys
	
	exports.ExceptionMap = ExceptionMap;
	var ExceptionStatus = Object.keys(ExceptionMap);
	/**
	 * render icon
	 * if ExceptionStatus includes ,render svg image
	 * else render iconNode
	 * @param prefixCls
	 * @param {status, icon}
	 */
	
	var renderIcon = function renderIcon(prefixCls, _ref) {
	  var status = _ref.status,
	      icon = _ref.icon;
	  var className = (0, _classnames["default"])("".concat(prefixCls, "-icon"));
	
	  if (ExceptionStatus.includes("".concat(status))) {
	    var SVGComponent = ExceptionMap[status];
	    return /*#__PURE__*/React.createElement("div", {
	      className: "".concat(className, " ").concat(prefixCls, "-image")
	    }, /*#__PURE__*/React.createElement(SVGComponent, null));
	  }
	
	  var iconString = IconMap[status];
	  var iconNode = icon || /*#__PURE__*/React.createElement(_icon["default"], {
	    type: iconString,
	    theme: "filled"
	  });
	  return /*#__PURE__*/React.createElement("div", {
	    className: className
	  }, iconNode);
	};
	
	var renderExtra = function renderExtra(prefixCls, _ref2) {
	  var extra = _ref2.extra;
	  return extra && /*#__PURE__*/React.createElement("div", {
	    className: "".concat(prefixCls, "-extra")
	  }, extra);
	};
	
	var Result = function Result(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref3) {
	    var getPrefixCls = _ref3.getPrefixCls;
	    var customizePrefixCls = props.prefixCls,
	        customizeClassName = props.className,
	        subTitle = props.subTitle,
	        title = props.title,
	        style = props.style,
	        children = props.children,
	        status = props.status;
	    var prefixCls = getPrefixCls('result', customizePrefixCls);
	    var className = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(status), customizeClassName);
	    return /*#__PURE__*/React.createElement("div", {
	      className: className,
	      style: style
	    }, renderIcon(prefixCls, props), /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-title")
	    }, title), subTitle && /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-subtitle")
	    }, subTitle), children && /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-content")
	    }, children), renderExtra(prefixCls, props));
	  });
	};
	
	Result.defaultProps = {
	  status: 'info'
	};
	Result.PRESENTED_IMAGE_403 = ExceptionMap[403];
	Result.PRESENTED_IMAGE_404 = ExceptionMap[404];
	Result.PRESENTED_IMAGE_500 = ExceptionMap[500];
	var _default = Result;
	exports["default"] = _default;

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var NoFound = function NoFound() {
	  return /*#__PURE__*/React.createElement("svg", {
	    width: "252",
	    height: "294"
	  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
	    d: "M0 .387h251.772v251.772H0z"
	  })), /*#__PURE__*/React.createElement("g", {
	    fill: "none",
	    fillRule: "evenodd"
	  }, /*#__PURE__*/React.createElement("g", {
	    transform: "translate(0 .012)"
	  }, /*#__PURE__*/React.createElement("mask", {
	    fill: "#fff"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M0 127.32v-2.095C0 56.279 55.892.387 124.838.387h2.096c68.946 0 124.838 55.892 124.838 124.838v2.096c0 68.946-55.892 124.838-124.838 124.838h-2.096C55.892 252.16 0 196.267 0 127.321",
	    fill: "#E4EBF7",
	    mask: "url(#b)"
	  })), /*#__PURE__*/React.createElement("path", {
	    d: "M39.755 130.84a8.276 8.276 0 1 1-16.468-1.66 8.276 8.276 0 0 1 16.468 1.66",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M36.975 134.297l10.482 5.943M48.373 146.508l-12.648 10.788",
	    stroke: "#FFF",
	    strokeWidth: "2"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M39.875 159.352a5.667 5.667 0 1 1-11.277-1.136 5.667 5.667 0 0 1 11.277 1.136M57.588 143.247a5.708 5.708 0 1 1-11.358-1.145 5.708 5.708 0 0 1 11.358 1.145M99.018 26.875l29.82-.014a4.587 4.587 0 1 0-.003-9.175l-29.82.013a4.587 4.587 0 1 0 .003 9.176M110.424 45.211l29.82-.013a4.588 4.588 0 0 0-.004-9.175l-29.82.013a4.587 4.587 0 1 0 .004 9.175",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M112.798 26.861v-.002l15.784-.006a4.588 4.588 0 1 0 .003 9.175l-15.783.007v-.002a4.586 4.586 0 0 0-.004-9.172M184.523 135.668c-.553 5.485-5.447 9.483-10.931 8.93-5.485-.553-9.483-5.448-8.93-10.932.552-5.485 5.447-9.483 10.932-8.93 5.485.553 9.483 5.447 8.93 10.932",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M179.26 141.75l12.64 7.167M193.006 156.477l-15.255 13.011",
	    stroke: "#FFF",
	    strokeWidth: "2"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M184.668 170.057a6.835 6.835 0 1 1-13.6-1.372 6.835 6.835 0 0 1 13.6 1.372M203.34 153.325a6.885 6.885 0 1 1-13.7-1.382 6.885 6.885 0 0 1 13.7 1.382",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M151.931 192.324a2.222 2.222 0 1 1-4.444 0 2.222 2.222 0 0 1 4.444 0zM225.27 116.056a2.222 2.222 0 1 1-4.445 0 2.222 2.222 0 0 1 4.444 0zM216.38 151.08a2.223 2.223 0 1 1-4.446-.001 2.223 2.223 0 0 1 4.446 0zM176.917 107.636a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM195.291 92.165a2.223 2.223 0 1 1-4.445 0 2.223 2.223 0 0 1 4.445 0zM202.058 180.711a2.223 2.223 0 1 1-4.446 0 2.223 2.223 0 0 1 4.446 0z",
	    stroke: "#FFF",
	    strokeWidth: "2"
	  }), /*#__PURE__*/React.createElement("path", {
	    stroke: "#FFF",
	    strokeWidth: "2",
	    d: "M214.404 153.302l-1.912 20.184-10.928 5.99M173.661 174.792l-6.356 9.814h-11.36l-4.508 6.484M174.941 125.168v-15.804M220.824 117.25l-12.84 7.901-15.31-7.902V94.39"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M166.588 65.936h-3.951a4.756 4.756 0 0 1-4.743-4.742 4.756 4.756 0 0 1 4.743-4.743h3.951a4.756 4.756 0 0 1 4.743 4.743 4.756 4.756 0 0 1-4.743 4.742",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M174.823 30.03c0-16.281 13.198-29.48 29.48-29.48 16.28 0 29.48 13.199 29.48 29.48 0 16.28-13.2 29.48-29.48 29.48-16.282 0-29.48-13.2-29.48-29.48",
	    fill: "#1890FF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M205.952 38.387c.5.5.785 1.142.785 1.928s-.286 1.465-.785 1.964c-.572.5-1.214.75-2 .75-.785 0-1.429-.285-1.929-.785-.572-.5-.82-1.143-.82-1.929s.248-1.428.82-1.928c.5-.5 1.144-.75 1.93-.75.785 0 1.462.25 1.999.75m4.285-19.463c1.428 1.249 2.143 2.963 2.143 5.142 0 1.712-.427 3.13-1.219 4.25-.067.096-.137.18-.218.265-.416.429-1.41 1.346-2.956 2.699a5.07 5.07 0 0 0-1.428 1.75 5.207 5.207 0 0 0-.536 2.357v.5h-4.107v-.5c0-1.357.215-2.536.714-3.5.464-.964 1.857-2.464 4.178-4.536l.43-.5c.643-.785.964-1.643.964-2.535 0-1.18-.358-2.108-1-2.785-.678-.68-1.643-1.001-2.858-1.001-1.536 0-2.642.464-3.357 1.43-.37.5-.621 1.135-.76 1.904a1.999 1.999 0 0 1-1.971 1.63h-.004c-1.277 0-2.257-1.183-1.98-2.43.337-1.518 1.02-2.78 2.073-3.784 1.536-1.5 3.607-2.25 6.25-2.25 2.32 0 4.214.607 5.642 1.894",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M52.04 76.131s21.81 5.36 27.307 15.945c5.575 10.74-6.352 9.26-15.73 4.935-10.86-5.008-24.7-11.822-11.577-20.88",
	    fill: "#FFB594"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M90.483 67.504l-.449 2.893c-.753.49-4.748-2.663-4.748-2.663l-1.645.748-1.346-5.684s6.815-4.589 8.917-5.018c2.452-.501 9.884.94 10.7 2.278 0 0 1.32.486-2.227.69-3.548.203-5.043.447-6.79 3.132-1.747 2.686-2.412 3.624-2.412 3.624",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M128.055 111.367c-2.627-7.724-6.15-13.18-8.917-15.478-3.5-2.906-9.34-2.225-11.366-4.187-1.27-1.231-3.215-1.197-3.215-1.197s-14.98-3.158-16.828-3.479c-2.37-.41-2.124-.714-6.054-1.405-1.57-1.907-2.917-1.122-2.917-1.122l-7.11-1.383c-.853-1.472-2.423-1.023-2.423-1.023l-2.468-.897c-1.645 9.976-7.74 13.796-7.74 13.796 1.795 1.122 15.703 8.3 15.703 8.3l5.107 37.11s-3.321 5.694 1.346 9.109c0 0 19.883-3.743 34.921-.329 0 0 3.047-2.546.972-8.806.523-3.01 1.394-8.263 1.736-11.622.385.772 2.019 1.918 3.14 3.477 0 0 9.407-7.365 11.052-14.012-.832-.723-1.598-1.585-2.267-2.453-.567-.736-.358-2.056-.765-2.717-.669-1.084-1.804-1.378-1.907-1.682",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M101.09 289.998s4.295 2.041 7.354 1.021c2.821-.94 4.53.668 7.08 1.178 2.55.51 6.874 1.1 11.686-1.26-.103-5.51-6.889-3.98-11.96-6.713-2.563-1.38-3.784-4.722-3.598-8.799h-9.402s-1.392 10.52-1.16 14.573",
	    fill: "#CBD1D1"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M101.067 289.826s2.428 1.271 6.759.653c3.058-.437 3.712.481 7.423 1.031 3.712.55 10.724-.069 11.823-.894.413 1.1-.343 2.063-.343 2.063s-1.512.603-4.812.824c-2.03.136-5.8.291-7.607-.503-1.787-1.375-5.247-1.903-5.728-.241-3.918.95-7.355-.286-7.355-.286l-.16-2.647z",
	    fill: "#2B0849"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M108.341 276.044h3.094s-.103 6.702 4.536 8.558c-4.64.618-8.558-2.303-7.63-8.558",
	    fill: "#A4AABA"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M57.542 272.401s-2.107 7.416-4.485 12.306c-1.798 3.695-4.225 7.492 5.465 7.492 6.648 0 8.953-.48 7.423-6.599-1.53-6.12.266-13.199.266-13.199h-8.669z",
	    fill: "#CBD1D1"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M51.476 289.793s2.097 1.169 6.633 1.169c6.083 0 8.249-1.65 8.249-1.65s.602 1.114-.619 2.165c-.993.855-3.597 1.591-7.39 1.546-4.145-.048-5.832-.566-6.736-1.168-.825-.55-.687-1.58-.137-2.062",
	    fill: "#2B0849"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M58.419 274.304s.033 1.519-.314 2.93c-.349 1.42-1.078 3.104-1.13 4.139-.058 1.151 4.537 1.58 5.155.034.62-1.547 1.294-6.427 1.913-7.252.619-.825-4.903-2.119-5.624.15",
	    fill: "#A4AABA"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M99.66 278.514l13.378.092s1.298-54.52 1.853-64.403c.554-9.882 3.776-43.364 1.002-63.128l-12.547-.644-22.849.78s-.434 3.966-1.195 9.976c-.063.496-.682.843-.749 1.365-.075.585.423 1.354.32 1.966-2.364 14.08-6.377 33.104-8.744 46.677-.116.666-1.234 1.009-1.458 2.691-.04.302.211 1.525.112 1.795-6.873 18.744-10.949 47.842-14.277 61.885l14.607-.014s2.197-8.57 4.03-16.97c2.811-12.886 23.111-85.01 23.111-85.01l3.016-.521 1.043 46.35s-.224 1.234.337 2.02c.56.785-.56 1.123-.392 2.244l.392 1.794s-.449 7.178-.898 11.89c-.448 4.71-.092 39.165-.092 39.165",
	    fill: "#7BB2F9"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M76.085 221.626c1.153.094 4.038-2.019 6.955-4.935M106.36 225.142s2.774-1.11 6.103-3.883",
	    stroke: "#648BD8",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M107.275 222.1s2.773-1.11 6.102-3.884",
	    stroke: "#648BD8",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M74.74 224.767s2.622-.591 6.505-3.365M86.03 151.634c-.27 3.106.3 8.525-4.336 9.123M103.625 149.88s.11 14.012-1.293 15.065c-2.219 1.664-2.99 1.944-2.99 1.944M99.79 150.438s.035 12.88-1.196 24.377M93.673 175.911s7.212-1.664 9.431-1.664M74.31 205.861a212.013 212.013 0 0 1-.979 4.56s-1.458 1.832-1.009 3.776c.449 1.944-.947 2.045-4.985 15.355-1.696 5.59-4.49 18.591-6.348 27.597l-.231 1.12M75.689 197.807a320.934 320.934 0 0 1-.882 4.754M82.591 152.233L81.395 162.7s-1.097.15-.5 2.244c.113 1.346-2.674 15.775-5.18 30.43M56.12 274.418h13.31",
	    stroke: "#648BD8",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M116.241 148.22s-17.047-3.104-35.893.2c.158 2.514-.003 4.15-.003 4.15s14.687-2.818 35.67-.312c.252-2.355.226-4.038.226-4.038",
	    fill: "#192064"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M106.322 151.165l.003-4.911a.81.81 0 0 0-.778-.815c-2.44-.091-5.066-.108-7.836-.014a.818.818 0 0 0-.789.815l-.003 4.906a.81.81 0 0 0 .831.813c2.385-.06 4.973-.064 7.73.017a.815.815 0 0 0 .842-.81",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M105.207 150.233l.002-3.076a.642.642 0 0 0-.619-.646 94.321 94.321 0 0 0-5.866-.01.65.65 0 0 0-.63.647v3.072a.64.64 0 0 0 .654.644 121.12 121.12 0 0 1 5.794.011c.362.01.665-.28.665-.642",
	    fill: "#192064"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M100.263 275.415h12.338M101.436 270.53c.006 3.387.042 5.79.111 6.506M101.451 264.548a915.75 915.75 0 0 0-.015 4.337M100.986 174.965l.898 44.642s.673 1.57-.225 2.692c-.897 1.122 2.468.673.898 2.243-1.57 1.57.897 1.122 0 3.365-.596 1.489-.994 21.1-1.096 35.146",
	    stroke: "#648BD8",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M46.876 83.427s-.516 6.045 7.223 5.552c11.2-.712 9.218-9.345 31.54-21.655-.786-2.708-2.447-4.744-2.447-4.744s-11.068 3.11-22.584 8.046c-6.766 2.9-13.395 6.352-13.732 12.801M104.46 91.057l.941-5.372-8.884-11.43-5.037 5.372-1.74 7.834a.321.321 0 0 0 .108.32c.965.8 6.5 5.013 14.347 3.544a.332.332 0 0 0 .264-.268",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M93.942 79.387s-4.533-2.853-2.432-6.855c1.623-3.09 4.513 1.133 4.513 1.133s.52-3.642 3.121-3.642c.52-1.04 1.561-4.162 1.561-4.162s11.445 2.601 13.526 3.121c0 5.203-2.304 19.424-7.84 19.861-8.892.703-12.449-9.456-12.449-9.456",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M113.874 73.446c2.601-2.081 3.47-9.722 3.47-9.722s-2.479-.49-6.64-2.05c-4.683-2.081-12.798-4.747-17.48.976-9.668 3.223-2.05 19.823-2.05 19.823l2.713-3.021s-3.935-3.287-2.08-6.243c2.17-3.462 3.92 1.073 3.92 1.073s.637-2.387 3.581-3.342c.355-.71 1.036-2.674 1.432-3.85a1.073 1.073 0 0 1 1.263-.704c2.4.558 8.677 2.019 11.356 2.662.522.125.871.615.82 1.15l-.305 3.248z",
	    fill: "#520038"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M104.977 76.064c-.103.61-.582 1.038-1.07.956-.489-.083-.801-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.644.698 1.254M112.132 77.694c-.103.61-.582 1.038-1.07.956-.488-.083-.8-.644-.698-1.254.103-.61.582-1.038 1.07-.956.488.082.8.643.698 1.254",
	    fill: "#552950"
	  }), /*#__PURE__*/React.createElement("path", {
	    stroke: "#DB836E",
	    strokeWidth: "1.118",
	    strokeLinecap: "round",
	    strokeLinejoin: "round",
	    d: "M110.13 74.84l-.896 1.61-.298 4.357h-2.228"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M110.846 74.481s1.79-.716 2.506.537",
	    stroke: "#5C2552",
	    strokeWidth: "1.118",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M92.386 74.282s.477-1.114 1.113-.716c.637.398 1.274 1.433.558 1.99-.717.556.159 1.67.159 1.67",
	    stroke: "#DB836E",
	    strokeWidth: "1.118",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M103.287 72.93s1.83 1.113 4.137.954",
	    stroke: "#5C2552",
	    strokeWidth: "1.118",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M103.685 81.762s2.227 1.193 4.376 1.193M104.64 84.308s.954.398 1.511.318M94.693 81.205s2.308 7.4 10.424 7.639",
	    stroke: "#DB836E",
	    strokeWidth: "1.118",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M81.45 89.384s.45 5.647-4.935 12.787M69 82.654s-.726 9.282-8.204 14.206",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.101",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M129.405 122.865s-5.272 7.403-9.422 10.768",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M119.306 107.329s.452 4.366-2.127 32.062",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.101",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M150.028 151.232h-49.837a1.01 1.01 0 0 1-1.01-1.01v-31.688c0-.557.452-1.01 1.01-1.01h49.837c.558 0 1.01.453 1.01 1.01v31.688a1.01 1.01 0 0 1-1.01 1.01",
	    fill: "#F2D7AD"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M150.29 151.232h-19.863v-33.707h20.784v32.786a.92.92 0 0 1-.92.92",
	    fill: "#F4D19D"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M123.554 127.896H92.917a.518.518 0 0 1-.425-.816l6.38-9.113c.193-.277.51-.442.85-.442h31.092l-7.26 10.371z",
	    fill: "#F2D7AD"
	  }), /*#__PURE__*/React.createElement("path", {
	    fill: "#CC9B6E",
	    d: "M123.689 128.447H99.25v-.519h24.169l7.183-10.26.424.298z"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M158.298 127.896h-18.669a2.073 2.073 0 0 1-1.659-.83l-7.156-9.541h19.965c.49 0 .95.23 1.244.622l6.69 8.92a.519.519 0 0 1-.415.83",
	    fill: "#F4D19D"
	  }), /*#__PURE__*/React.createElement("path", {
	    fill: "#CC9B6E",
	    d: "M157.847 128.479h-19.384l-7.857-10.475.415-.31 7.7 10.266h19.126zM130.554 150.685l-.032-8.177.519-.002.032 8.177z"
	  }), /*#__PURE__*/React.createElement("path", {
	    fill: "#CC9B6E",
	    d: "M130.511 139.783l-.08-21.414.519-.002.08 21.414zM111.876 140.932l-.498-.143 1.479-5.167.498.143zM108.437 141.06l-2.679-2.935 2.665-3.434.41.318-2.397 3.089 2.384 2.612zM116.607 141.06l-.383-.35 2.383-2.612-2.397-3.089.41-.318 2.665 3.434z"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M154.316 131.892l-3.114-1.96.038 3.514-1.043.092c-1.682.115-3.634.23-4.789.23-1.902 0-2.693 2.258 2.23 2.648l-2.645-.596s-2.168 1.317.504 2.3c0 0-1.58 1.217.561 2.58-.584 3.504 5.247 4.058 7.122 3.59 1.876-.47 4.233-2.359 4.487-5.16.28-3.085-.89-5.432-3.35-7.238",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M153.686 133.577s-6.522.47-8.36.372c-1.836-.098-1.904 2.19 2.359 2.264 3.739.15 5.451-.044 5.451-.044",
	    stroke: "#DB836E",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M145.16 135.877c-1.85 1.346.561 2.355.561 2.355s3.478.898 6.73.617",
	    stroke: "#DB836E",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M151.89 141.71s-6.28.111-6.73-2.132c-.223-1.346.45-1.402.45-1.402M146.114 140.868s-1.103 3.16 5.44 3.533M151.202 129.932v3.477M52.838 89.286c3.533-.337 8.423-1.248 13.582-7.754",
	    stroke: "#DB836E",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M168.567 248.318a6.647 6.647 0 0 1-6.647-6.647v-66.466a6.647 6.647 0 1 1 13.294 0v66.466a6.647 6.647 0 0 1-6.647 6.647",
	    fill: "#5BA02E"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M176.543 247.653a6.647 6.647 0 0 1-6.646-6.647v-33.232a6.647 6.647 0 1 1 13.293 0v33.232a6.647 6.647 0 0 1-6.647 6.647",
	    fill: "#92C110"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M186.443 293.613H158.92a3.187 3.187 0 0 1-3.187-3.187v-46.134a3.187 3.187 0 0 1 3.187-3.187h27.524a3.187 3.187 0 0 1 3.187 3.187v46.134a3.187 3.187 0 0 1-3.187 3.187",
	    fill: "#F2D7AD"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M88.979 89.48s7.776 5.384 16.6 2.842",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.101",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  })));
	};
	
	var _default = NoFound;
	exports["default"] = _default;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var ServerError = function ServerError() {
	  return /*#__PURE__*/React.createElement("svg", {
	    width: "254",
	    height: "294"
	  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
	    d: "M0 .335h253.49v253.49H0z"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M0 293.665h253.49V.401H0z"
	  })), /*#__PURE__*/React.createElement("g", {
	    fill: "none",
	    fillRule: "evenodd"
	  }, /*#__PURE__*/React.createElement("g", {
	    transform: "translate(0 .067)"
	  }, /*#__PURE__*/React.createElement("mask", {
	    fill: "#fff"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M0 128.134v-2.11C0 56.608 56.273.334 125.69.334h2.11c69.416 0 125.69 56.274 125.69 125.69v2.11c0 69.417-56.274 125.69-125.69 125.69h-2.11C56.273 253.824 0 197.551 0 128.134",
	    fill: "#E4EBF7",
	    mask: "url(#b)"
	  })), /*#__PURE__*/React.createElement("path", {
	    d: "M39.989 132.108a8.332 8.332 0 1 1-16.581-1.671 8.332 8.332 0 0 1 16.58 1.671",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M37.19 135.59l10.553 5.983M48.665 147.884l-12.734 10.861",
	    stroke: "#FFF",
	    strokeWidth: "2"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M40.11 160.816a5.706 5.706 0 1 1-11.354-1.145 5.706 5.706 0 0 1 11.354 1.145M57.943 144.6a5.747 5.747 0 1 1-11.436-1.152 5.747 5.747 0 0 1 11.436 1.153M99.656 27.434l30.024-.013a4.619 4.619 0 1 0-.004-9.238l-30.024.013a4.62 4.62 0 0 0 .004 9.238M111.14 45.896l30.023-.013a4.62 4.62 0 1 0-.004-9.238l-30.024.013a4.619 4.619 0 1 0 .004 9.238",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M113.53 27.421v-.002l15.89-.007a4.619 4.619 0 1 0 .005 9.238l-15.892.007v-.002a4.618 4.618 0 0 0-.004-9.234M150.167 70.091h-3.979a4.789 4.789 0 0 1-4.774-4.775 4.788 4.788 0 0 1 4.774-4.774h3.979a4.789 4.789 0 0 1 4.775 4.774 4.789 4.789 0 0 1-4.775 4.775",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M171.687 30.234c0-16.392 13.289-29.68 29.681-29.68 16.392 0 29.68 13.288 29.68 29.68 0 16.393-13.288 29.681-29.68 29.681s-29.68-13.288-29.68-29.68",
	    fill: "#FF603B"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M203.557 19.435l-.676 15.035a1.514 1.514 0 0 1-3.026 0l-.675-15.035a2.19 2.19 0 1 1 4.377 0m-.264 19.378c.513.477.77 1.1.77 1.87s-.257 1.393-.77 1.907c-.55.476-1.21.733-1.943.733a2.545 2.545 0 0 1-1.87-.77c-.55-.514-.806-1.136-.806-1.87 0-.77.256-1.393.806-1.87.513-.513 1.137-.733 1.87-.733.77 0 1.43.22 1.943.733",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M119.3 133.275c4.426-.598 3.612-1.204 4.079-4.778.675-5.18-3.108-16.935-8.262-25.118-1.088-10.72-12.598-11.24-12.598-11.24s4.312 4.895 4.196 16.199c1.398 5.243.804 14.45.804 14.45s5.255 11.369 11.78 10.487",
	    fill: "#FFB594"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M100.944 91.61s1.463-.583 3.211.582c8.08 1.398 10.368 6.706 11.3 11.368 1.864 1.282 1.864 2.33 1.864 3.496.365.777 1.515 3.03 1.515 3.03s-7.225 1.748-10.954 6.758c-1.399-6.41-6.936-25.235-6.936-25.235",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M94.008 90.5l1.019-5.815-9.23-11.874-5.233 5.581-2.593 9.863s8.39 5.128 16.037 2.246",
	    fill: "#FFB594"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M82.931 78.216s-4.557-2.868-2.445-6.892c1.632-3.107 4.537 1.139 4.537 1.139s.524-3.662 3.139-3.662c.523-1.046 1.569-4.184 1.569-4.184s11.507 2.615 13.6 3.138c-.001 5.23-2.317 19.529-7.884 19.969-8.94.706-12.516-9.508-12.516-9.508",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M102.971 72.243c2.616-2.093 3.489-9.775 3.489-9.775s-2.492-.492-6.676-2.062c-4.708-2.092-12.867-4.771-17.575.982-9.54 4.41-2.062 19.93-2.062 19.93l2.729-3.037s-3.956-3.304-2.092-6.277c2.183-3.48 3.943 1.08 3.943 1.08s.64-2.4 3.6-3.36c.356-.714 1.04-2.69 1.44-3.872a1.08 1.08 0 0 1 1.27-.707c2.41.56 8.723 2.03 11.417 2.676.524.126.876.619.825 1.156l-.308 3.266z",
	    fill: "#520038"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M101.22 76.514c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.961.491.083.805.647.702 1.26M94.26 75.074c-.104.613-.585 1.044-1.076.96-.49-.082-.805-.646-.702-1.26.104-.613.585-1.044 1.076-.96.491.082.805.646.702 1.26",
	    fill: "#552950"
	  }), /*#__PURE__*/React.createElement("path", {
	    stroke: "#DB836E",
	    strokeWidth: "1.063",
	    strokeLinecap: "round",
	    strokeLinejoin: "round",
	    d: "M99.206 73.644l-.9 1.62-.3 4.38h-2.24"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M99.926 73.284s1.8-.72 2.52.54",
	    stroke: "#5C2552",
	    strokeWidth: "1.117",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M81.367 73.084s.48-1.12 1.12-.72c.64.4 1.28 1.44.56 2s.16 1.68.16 1.68",
	    stroke: "#DB836E",
	    strokeWidth: "1.117",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M92.326 71.724s1.84 1.12 4.16.96",
	    stroke: "#5C2552",
	    strokeWidth: "1.117",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M92.726 80.604s2.24 1.2 4.4 1.2M93.686 83.164s.96.4 1.52.32M83.687 80.044s1.786 6.547 9.262 7.954",
	    stroke: "#DB836E",
	    strokeWidth: "1.063",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M95.548 91.663s-1.068 2.821-8.298 2.105c-7.23-.717-10.29-5.044-10.29-5.044",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.136",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M78.126 87.478s6.526 4.972 16.47 2.486c0 0 9.577 1.02 11.536 5.322 5.36 11.77.543 36.835 0 39.962 3.496 4.055-.466 8.483-.466 8.483-15.624-3.548-35.81-.6-35.81-.6-4.849-3.546-1.223-9.044-1.223-9.044L62.38 110.32c-2.485-15.227.833-19.803 3.549-20.743 3.03-1.049 8.04-1.282 8.04-1.282.496-.058 1.08-.076 1.37-.233 2.36-1.282 2.787-.583 2.787-.583",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M65.828 89.81s-6.875.465-7.59 8.156c-.466 8.857 3.03 10.954 3.03 10.954s6.075 22.102 16.796 22.957c8.39-2.176 4.758-6.702 4.661-11.42-.233-11.304-7.108-16.897-7.108-16.897s-4.212-13.75-9.789-13.75",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M71.716 124.225s.855 11.264 9.828 6.486c4.765-2.536 7.581-13.828 9.789-22.568 1.456-5.768 2.58-12.197 2.58-12.197l-4.973-1.709s-2.408 5.516-7.769 12.275c-4.335 5.467-9.144 11.11-9.455 17.713",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M108.463 105.191s1.747 2.724-2.331 30.535c2.376 2.216 1.053 6.012-.233 7.51",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.085",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M123.262 131.527s-.427 2.732-11.77 1.981c-15.187-1.006-25.326-3.25-25.326-3.25l.933-5.8s.723.215 9.71-.068c11.887-.373 18.714-6.07 24.964-1.022 4.039 3.263 1.489 8.16 1.489 8.16",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M70.24 90.974s-5.593-4.739-11.054 2.68c-3.318 7.223.517 15.284 2.664 19.578-.31 3.729 2.33 4.311 2.33 4.311s.108.895 1.516 2.68c4.078-7.03 6.72-9.166 13.711-12.546-.328-.656-1.877-3.265-1.825-3.767.175-1.69-1.282-2.623-1.282-2.623s-.286-.156-1.165-2.738c-.788-2.313-2.036-5.177-4.895-7.575",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M90.232 288.027s4.855 2.308 8.313 1.155c3.188-1.063 5.12.755 8.002 1.331 2.881.577 7.769 1.243 13.207-1.424-.117-6.228-7.786-4.499-13.518-7.588-2.895-1.56-4.276-5.336-4.066-9.944H91.544s-1.573 11.89-1.312 16.47",
	    fill: "#CBD1D1"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M90.207 287.833s2.745 1.437 7.639.738c3.456-.494 3.223.66 7.418 1.282 4.195.621 13.092-.194 14.334-1.126.466 1.242-.388 2.33-.388 2.33s-1.709.682-5.438.932c-2.295.154-8.098.276-10.14-.621-2.02-1.554-4.894-1.515-6.06-.234-4.427 1.075-7.184-.31-7.184-.31l-.181-2.991z",
	    fill: "#2B0849"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M98.429 272.257h3.496s-.117 7.574 5.127 9.671c-5.244.7-9.672-2.602-8.623-9.671",
	    fill: "#A4AABA"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M44.425 272.046s-2.208 7.774-4.702 12.899c-1.884 3.874-4.428 7.854 5.729 7.854 6.97 0 9.385-.503 7.782-6.917-1.604-6.415.279-13.836.279-13.836h-9.088z",
	    fill: "#CBD1D1"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M38.066 290.277s2.198 1.225 6.954 1.225c6.376 0 8.646-1.73 8.646-1.73s.63 1.168-.649 2.27c-1.04.897-3.77 1.668-7.745 1.621-4.347-.05-6.115-.593-7.062-1.224-.864-.577-.72-1.657-.144-2.162",
	    fill: "#2B0849"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M45.344 274.041s.035 1.592-.329 3.07c-.365 1.49-1.13 3.255-1.184 4.34-.061 1.206 4.755 1.657 5.403.036.65-1.622 1.357-6.737 2.006-7.602.648-.865-5.14-2.222-5.896.156",
	    fill: "#A4AABA"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M89.476 277.57l13.899.095s1.349-56.643 1.925-66.909c.576-10.267 3.923-45.052 1.042-65.585l-13.037-.669-23.737.81s-.452 4.12-1.243 10.365c-.065.515-.708.874-.777 1.417-.078.608.439 1.407.332 2.044-2.455 14.627-5.797 32.736-8.256 46.837-.121.693-1.282 1.048-1.515 2.796-.042.314.22 1.584.116 1.865-7.14 19.473-12.202 52.601-15.66 67.19l15.176-.015s2.282-10.145 4.185-18.871c2.922-13.389 24.012-88.32 24.012-88.32l3.133-.954-.158 48.568s-.233 1.282.35 2.098c.583.815-.581 1.167-.408 2.331l.408 1.864s-.466 7.458-.932 12.352c-.467 4.895 1.145 40.69 1.145 40.69",
	    fill: "#7BB2F9"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M64.57 218.881c1.197.099 4.195-2.097 7.225-5.127M96.024 222.534s2.881-1.152 6.34-4.034",
	    stroke: "#648BD8",
	    strokeWidth: "1.085",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M96.973 219.373s2.882-1.153 6.34-4.034",
	    stroke: "#648BD8",
	    strokeWidth: "1.032",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M63.172 222.144s2.724-.614 6.759-3.496M74.903 146.166c-.281 3.226.31 8.856-4.506 9.478M93.182 144.344s.115 14.557-1.344 15.65c-2.305 1.73-3.107 2.02-3.107 2.02M89.197 144.923s.269 13.144-1.01 25.088M83.525 170.71s6.81-1.051 9.116-1.051M46.026 270.045l-.892 4.538M46.937 263.289l-.815 4.157M62.725 202.503c-.33 1.618-.102 1.904-.449 3.438 0 0-2.756 1.903-2.29 3.923.466 2.02-.31 3.424-4.505 17.252-1.762 5.807-4.233 18.922-6.165 28.278-.03.144-.521 2.646-1.14 5.8M64.158 194.136c-.295 1.658-.6 3.31-.917 4.938M71.33 146.787l-1.244 10.877s-1.14.155-.519 2.33c.117 1.399-2.778 16.39-5.382 31.615M44.242 273.727H58.07",
	    stroke: "#648BD8",
	    strokeWidth: "1.085",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M106.18 142.117c-3.028-.489-18.825-2.744-36.219.2a.625.625 0 0 0-.518.644c.063 1.307.044 2.343.015 2.995a.617.617 0 0 0 .716.636c3.303-.534 17.037-2.412 35.664-.266.347.04.66-.214.692-.56.124-1.347.16-2.425.17-3.029a.616.616 0 0 0-.52-.62",
	    fill: "#192064"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M96.398 145.264l.003-5.102a.843.843 0 0 0-.809-.847 114.104 114.104 0 0 0-8.141-.014.85.85 0 0 0-.82.847l-.003 5.097c0 .476.388.857.864.845 2.478-.064 5.166-.067 8.03.017a.848.848 0 0 0 .876-.843",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M95.239 144.296l.002-3.195a.667.667 0 0 0-.643-.672c-1.9-.061-3.941-.073-6.094-.01a.675.675 0 0 0-.654.672l-.002 3.192c0 .376.305.677.68.669 1.859-.042 3.874-.043 6.02.012.376.01.69-.291.691-.668",
	    fill: "#192064"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M90.102 273.522h12.819M91.216 269.761c.006 3.519-.072 5.55 0 6.292M90.923 263.474c-.009 1.599-.016 2.558-.016 4.505M90.44 170.404l.932 46.38s.7 1.631-.233 2.796c-.932 1.166 2.564.7.932 2.33-1.63 1.633.933 1.166 0 3.497-.618 1.546-1.031 21.921-1.138 36.513",
	    stroke: "#648BD8",
	    strokeWidth: "1.085",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M73.736 98.665l2.214 4.312s2.098.816 1.865 2.68l.816 2.214M64.297 116.611c.233-.932 2.176-7.147 12.585-10.488M77.598 90.042s7.691 6.137 16.547 2.72",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.085",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M91.974 86.954s5.476-.816 7.574-4.545c1.297-.345.72 2.212-.33 3.671-.7.971-1.01 1.554-1.01 1.554s.194.31.155.816c-.053.697-.175.653-.272 1.048-.081.335.108.657 0 1.049-.046.17-.198.5-.382.878-.12.249-.072.687-.2.948-.231.469-1.562 1.87-2.622 2.855-3.826 3.554-5.018 1.644-6.001-.408-.894-1.865-.661-5.127-.874-6.875-.35-2.914-2.622-3.03-1.923-4.429.343-.685 2.87.69 3.263 1.748.757 2.04 2.952 1.807 2.622 1.69",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M99.8 82.429c-.465.077-.35.272-.97 1.243-.622.971-4.817 2.932-6.39 3.224-2.589.48-2.278-1.56-4.254-2.855-1.69-1.107-3.562-.638-1.398 1.398.99.932.932 1.107 1.398 3.205.335 1.506-.64 3.67.7 5.593",
	    stroke: "#DB836E",
	    strokeWidth: ".774",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M79.543 108.673c-2.1 2.926-4.266 6.175-5.557 8.762",
	    stroke: "#E59788",
	    strokeWidth: ".774",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M87.72 124.768s-2.098-1.942-5.127-2.719c-3.03-.777-3.574-.155-5.516.078-1.942.233-3.885-.932-3.652.7.233 1.63 5.05 1.01 5.206 2.097.155 1.087-6.37 2.796-8.313 2.175-.777.777.466 1.864 2.02 2.175.233 1.554 2.253 1.554 2.253 1.554s.699 1.01 2.641 1.088c2.486 1.32 8.934-.7 10.954-1.554 2.02-.855-.466-5.594-.466-5.594",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M73.425 122.826s.66 1.127 3.167 1.418c2.315.27 2.563.583 2.563.583s-2.545 2.894-9.07 2.272M72.416 129.274s3.826.097 4.933-.718M74.98 130.75s1.961.136 3.36-.505M77.232 131.916s1.748.019 2.914-.505M73.328 122.321s-.595-1.032 1.262-.427c1.671.544 2.833.055 5.128.155 1.389.061 3.067-.297 3.982.15 1.606.784 3.632 2.181 3.632 2.181s10.526 1.204 19.033-1.127M78.864 108.104s-8.39 2.758-13.168 12.12",
	    stroke: "#E59788",
	    strokeWidth: ".774",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M109.278 112.533s3.38-3.613 7.575-4.662",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.085",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M107.375 123.006s9.697-2.745 11.445-.88",
	    stroke: "#E59788",
	    strokeWidth: ".774",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M194.605 83.656l3.971-3.886M187.166 90.933l3.736-3.655M191.752 84.207l-4.462-4.56M198.453 91.057l-4.133-4.225M129.256 163.074l3.718-3.718M122.291 170.039l3.498-3.498M126.561 163.626l-4.27-4.27M132.975 170.039l-3.955-3.955",
	    stroke: "#BFCDDD",
	    strokeWidth: "2",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M190.156 211.779h-1.604a4.023 4.023 0 0 1-4.011-4.011V175.68a4.023 4.023 0 0 1 4.01-4.01h1.605a4.023 4.023 0 0 1 4.011 4.01v32.088a4.023 4.023 0 0 1-4.01 4.01",
	    fill: "#A3B4C6"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M237.824 212.977a4.813 4.813 0 0 1-4.813 4.813h-86.636a4.813 4.813 0 0 1 0-9.626h86.636a4.813 4.813 0 0 1 4.813 4.813",
	    fill: "#A3B4C6"
	  }), /*#__PURE__*/React.createElement("mask", {
	    fill: "#fff"
	  }), /*#__PURE__*/React.createElement("path", {
	    fill: "#A3B4C6",
	    mask: "url(#d)",
	    d: "M154.098 190.096h70.513v-84.617h-70.513z"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M224.928 190.096H153.78a3.219 3.219 0 0 1-3.208-3.209V167.92a3.219 3.219 0 0 1 3.208-3.21h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.219 3.219 0 0 1-3.21 3.209M224.928 130.832H153.78a3.218 3.218 0 0 1-3.208-3.208v-18.968a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.21v18.967a3.218 3.218 0 0 1-3.21 3.208",
	    fill: "#BFCDDD",
	    mask: "url(#d)"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M159.563 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 120.546a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 120.546h-22.461a.802.802 0 0 1-.802-.802v-3.208c0-.443.359-.803.802-.803h22.46c.444 0 .803.36.803.803v3.208c0 .443-.36.802-.802.802",
	    fill: "#FFF",
	    mask: "url(#d)"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M224.928 160.464H153.78a3.218 3.218 0 0 1-3.208-3.209v-18.967a3.219 3.219 0 0 1 3.208-3.209h71.148a3.219 3.219 0 0 1 3.209 3.209v18.967a3.218 3.218 0 0 1-3.21 3.209",
	    fill: "#BFCDDD",
	    mask: "url(#d)"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M173.455 130.832h49.301M164.984 130.832h6.089M155.952 130.832h6.75M173.837 160.613h49.3M165.365 160.613h6.089M155.57 160.613h6.751",
	    stroke: "#7C90A5",
	    strokeWidth: "1.124",
	    strokeLinecap: "round",
	    strokeLinejoin: "round",
	    mask: "url(#d)"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M159.563 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M166.98 151.038a2.407 2.407 0 1 1 0-4.814 2.407 2.407 0 0 1 0 4.814M174.397 151.038a2.407 2.407 0 1 1 .001-4.814 2.407 2.407 0 0 1 0 4.814M222.539 151.038h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802M159.563 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M166.98 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M174.397 179.987a2.407 2.407 0 1 1 0-4.813 2.407 2.407 0 0 1 0 4.813M222.539 179.987h-22.461a.802.802 0 0 1-.802-.802v-3.209c0-.443.359-.802.802-.802h22.46c.444 0 .803.36.803.802v3.209c0 .443-.36.802-.802.802",
	    fill: "#FFF",
	    mask: "url(#d)"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M203.04 221.108h-27.372a2.413 2.413 0 0 1-2.406-2.407v-11.448a2.414 2.414 0 0 1 2.406-2.407h27.372a2.414 2.414 0 0 1 2.407 2.407V218.7a2.413 2.413 0 0 1-2.407 2.407",
	    fill: "#BFCDDD",
	    mask: "url(#d)"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M177.259 207.217v11.52M201.05 207.217v11.52",
	    stroke: "#A3B4C6",
	    strokeWidth: "1.124",
	    strokeLinecap: "round",
	    strokeLinejoin: "round",
	    mask: "url(#d)"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M162.873 267.894a9.422 9.422 0 0 1-9.422-9.422v-14.82a9.423 9.423 0 0 1 18.845 0v14.82a9.423 9.423 0 0 1-9.423 9.422",
	    fill: "#5BA02E",
	    mask: "url(#d)"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M171.22 267.83a9.422 9.422 0 0 1-9.422-9.423v-3.438a9.423 9.423 0 0 1 18.845 0v3.438a9.423 9.423 0 0 1-9.422 9.423",
	    fill: "#92C110",
	    mask: "url(#d)"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M181.31 293.666h-27.712a3.209 3.209 0 0 1-3.209-3.21V269.79a3.209 3.209 0 0 1 3.209-3.21h27.711a3.209 3.209 0 0 1 3.209 3.21v20.668a3.209 3.209 0 0 1-3.209 3.209",
	    fill: "#F2D7AD",
	    mask: "url(#d)"
	  })));
	};
	
	var _default = ServerError;
	exports["default"] = _default;

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Unauthorized = function Unauthorized() {
	  return /*#__PURE__*/React.createElement("svg", {
	    width: "251",
	    height: "294"
	  }, /*#__PURE__*/React.createElement("g", {
	    fill: "none",
	    fillRule: "evenodd"
	  }, /*#__PURE__*/React.createElement("path", {
	    d: "M0 129.023v-2.084C0 58.364 55.591 2.774 124.165 2.774h2.085c68.574 0 124.165 55.59 124.165 124.165v2.084c0 68.575-55.59 124.166-124.165 124.166h-2.085C55.591 253.189 0 197.598 0 129.023",
	    fill: "#E4EBF7"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M41.417 132.92a8.231 8.231 0 1 1-16.38-1.65 8.231 8.231 0 0 1 16.38 1.65",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M38.652 136.36l10.425 5.91M49.989 148.505l-12.58 10.73",
	    stroke: "#FFF",
	    strokeWidth: "2"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M41.536 161.28a5.636 5.636 0 1 1-11.216-1.13 5.636 5.636 0 0 1 11.216 1.13M59.154 145.261a5.677 5.677 0 1 1-11.297-1.138 5.677 5.677 0 0 1 11.297 1.138M100.36 29.516l29.66-.013a4.562 4.562 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 0 0 .005 9.126M111.705 47.754l29.659-.013a4.563 4.563 0 1 0-.004-9.126l-29.66.013a4.563 4.563 0 1 0 .005 9.126",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M114.066 29.503V29.5l15.698-.007a4.563 4.563 0 1 0 .004 9.126l-15.698.007v-.002a4.562 4.562 0 0 0-.004-9.122M185.405 137.723c-.55 5.455-5.418 9.432-10.873 8.882-5.456-.55-9.432-5.418-8.882-10.873.55-5.455 5.418-9.432 10.873-8.882 5.455.55 9.432 5.418 8.882 10.873",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M180.17 143.772l12.572 7.129M193.841 158.42L178.67 171.36",
	    stroke: "#FFF",
	    strokeWidth: "2"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M185.55 171.926a6.798 6.798 0 1 1-13.528-1.363 6.798 6.798 0 0 1 13.527 1.363M204.12 155.285a6.848 6.848 0 1 1-13.627-1.375 6.848 6.848 0 0 1 13.626 1.375",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M152.988 194.074a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0zM225.931 118.217a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM217.09 153.051a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.42 0zM177.84 109.842a2.21 2.21 0 1 1-4.422 0 2.21 2.21 0 0 1 4.421 0zM196.114 94.454a2.21 2.21 0 1 1-4.421 0 2.21 2.21 0 0 1 4.421 0zM202.844 182.523a2.21 2.21 0 1 1-4.42 0 2.21 2.21 0 0 1 4.42 0z",
	    stroke: "#FFF",
	    strokeWidth: "2"
	  }), /*#__PURE__*/React.createElement("path", {
	    stroke: "#FFF",
	    strokeWidth: "2",
	    d: "M215.125 155.262l-1.902 20.075-10.87 5.958M174.601 176.636l-6.322 9.761H156.98l-4.484 6.449M175.874 127.28V111.56M221.51 119.404l-12.77 7.859-15.228-7.86V96.668"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M180.68 29.32C180.68 13.128 193.806 0 210 0c16.193 0 29.32 13.127 29.32 29.32 0 16.194-13.127 29.322-29.32 29.322-16.193 0-29.32-13.128-29.32-29.321",
	    fill: "#A26EF4"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M221.45 41.706l-21.563-.125a1.744 1.744 0 0 1-1.734-1.754l.071-12.23a1.744 1.744 0 0 1 1.754-1.734l21.562.125c.964.006 1.74.791 1.735 1.755l-.071 12.229a1.744 1.744 0 0 1-1.754 1.734",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M215.106 29.192c-.015 2.577-2.049 4.654-4.543 4.64-2.494-.014-4.504-2.115-4.489-4.693l.04-6.925c.016-2.577 2.05-4.654 4.543-4.64 2.494.015 4.504 2.116 4.49 4.693l-.04 6.925zm-4.53-14.074a6.877 6.877 0 0 0-6.916 6.837l-.043 7.368a6.877 6.877 0 0 0 13.754.08l.042-7.368a6.878 6.878 0 0 0-6.837-6.917zM167.566 68.367h-3.93a4.73 4.73 0 0 1-4.717-4.717 4.73 4.73 0 0 1 4.717-4.717h3.93a4.73 4.73 0 0 1 4.717 4.717 4.73 4.73 0 0 1-4.717 4.717",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M168.214 248.838a6.611 6.611 0 0 1-6.61-6.611v-66.108a6.611 6.611 0 0 1 13.221 0v66.108a6.611 6.611 0 0 1-6.61 6.61",
	    fill: "#5BA02E"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M176.147 248.176a6.611 6.611 0 0 1-6.61-6.61v-33.054a6.611 6.611 0 1 1 13.221 0v33.053a6.611 6.611 0 0 1-6.61 6.611",
	    fill: "#92C110"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M185.994 293.89h-27.376a3.17 3.17 0 0 1-3.17-3.17v-45.887a3.17 3.17 0 0 1 3.17-3.17h27.376a3.17 3.17 0 0 1 3.17 3.17v45.886a3.17 3.17 0 0 1-3.17 3.17",
	    fill: "#F2D7AD"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M81.972 147.673s6.377-.927 17.566-1.28c11.729-.371 17.57 1.086 17.57 1.086s3.697-3.855.968-8.424c1.278-12.077 5.982-32.827.335-48.273-1.116-1.339-3.743-1.512-7.536-.62-1.337.315-7.147-.149-7.983-.1l-15.311-.347s-3.487-.17-8.035-.508c-1.512-.113-4.227-1.683-5.458-.338-.406.443-2.425 5.669-1.97 16.077l8.635 35.642s-3.141 3.61 1.219 7.085",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M75.768 73.325l-.9-6.397 11.982-6.52s7.302-.118 8.038 1.205c.737 1.324-5.616.993-5.616.993s-1.836 1.388-2.615 2.5c-1.654 2.363-.986 6.471-8.318 5.986-1.708.284-2.57 2.233-2.57 2.233",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M52.44 77.672s14.217 9.406 24.973 14.444c1.061.497-2.094 16.183-11.892 11.811-7.436-3.318-20.162-8.44-21.482-14.496-.71-3.258 2.543-7.643 8.401-11.76M141.862 80.113s-6.693 2.999-13.844 6.876c-3.894 2.11-10.137 4.704-12.33 7.988-6.224 9.314 3.536 11.22 12.947 7.503 6.71-2.651 28.999-12.127 13.227-22.367",
	    fill: "#FFB594"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M76.166 66.36l3.06 3.881s-2.783 2.67-6.31 5.747c-7.103 6.195-12.803 14.296-15.995 16.44-3.966 2.662-9.754 3.314-12.177-.118-3.553-5.032.464-14.628 31.422-25.95",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M64.674 85.116s-2.34 8.413-8.912 14.447c.652.548 18.586 10.51 22.144 10.056 5.238-.669 6.417-18.968 1.145-20.531-.702-.208-5.901-1.286-8.853-2.167-.87-.26-1.611-1.71-3.545-.936l-1.98-.869zM128.362 85.826s5.318 1.956 7.325 13.734c-.546.274-17.55 12.35-21.829 7.805-6.534-6.94-.766-17.393 4.275-18.61 4.646-1.121 5.03-1.37 10.23-2.929",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M78.18 94.656s.911 7.41-4.914 13.078",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M87.397 94.68s3.124 2.572 10.263 2.572c7.14 0 9.074-3.437 9.074-3.437",
	    stroke: "#E4EBF7",
	    strokeWidth: ".932",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M117.184 68.639l-6.781-6.177s-5.355-4.314-9.223-.893c-3.867 3.422 4.463 2.083 5.653 4.165 1.19 2.082.848 1.143-2.083.446-5.603-1.331-2.082.893 2.975 5.355 2.091 1.845 6.992.955 6.992.955l2.467-3.851z",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M105.282 91.315l-.297-10.937-15.918-.027-.53 10.45c-.026.403.17.788.515.999 2.049 1.251 9.387 5.093 15.799.424.287-.21.443-.554.431-.91",
	    fill: "#FFB594"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M107.573 74.24c.817-1.147.982-9.118 1.015-11.928a1.046 1.046 0 0 0-.965-1.055l-4.62-.365c-7.71-1.044-17.071.624-18.253 6.346-5.482 5.813-.421 13.244-.421 13.244s1.963 3.566 4.305 6.791c.756 1.041.398-3.731 3.04-5.929 5.524-4.594 15.899-7.103 15.899-7.103",
	    fill: "#5C2552"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M88.426 83.206s2.685 6.202 11.602 6.522c7.82.28 8.973-7.008 7.434-17.505l-.909-5.483c-6.118-2.897-15.478.54-15.478.54s-.576 2.044-.19 5.504c-2.276 2.066-1.824 5.618-1.824 5.618s-.905-1.922-1.98-2.321c-.86-.32-1.897.089-2.322 1.98-1.04 4.632 3.667 5.145 3.667 5.145",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    stroke: "#DB836E",
	    strokeWidth: "1.145",
	    strokeLinecap: "round",
	    strokeLinejoin: "round",
	    d: "M100.843 77.099l1.701-.928-1.015-4.324.674-1.406"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M105.546 74.092c-.022.713-.452 1.279-.96 1.263-.51-.016-.904-.607-.882-1.32.021-.713.452-1.278.96-1.263.51.016.904.607.882 1.32M97.592 74.349c-.022.713-.452 1.278-.961 1.263-.509-.016-.904-.607-.882-1.32.022-.713.452-1.279.961-1.263.51.016.904.606.882 1.32",
	    fill: "#552950"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M91.132 86.786s5.269 4.957 12.679 2.327",
	    stroke: "#DB836E",
	    strokeWidth: "1.145",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M99.776 81.903s-3.592.232-1.44-2.79c1.59-1.496 4.897-.46 4.897-.46s1.156 3.906-3.457 3.25",
	    fill: "#DB836E"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M102.88 70.6s2.483.84 3.402.715M93.883 71.975s2.492-1.144 4.778-1.073",
	    stroke: "#5C2552",
	    strokeWidth: "1.526",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M86.32 77.374s.961.879 1.458 2.106c-.377.48-1.033 1.152-.236 1.809M99.337 83.719s1.911.151 2.509-.254",
	    stroke: "#DB836E",
	    strokeWidth: "1.145",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M87.782 115.821l15.73-3.012M100.165 115.821l10.04-2.008",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M66.508 86.763s-1.598 8.83-6.697 14.078",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.114",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M128.31 87.934s3.013 4.121 4.06 11.785",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M64.09 84.816s-6.03 9.912-13.607 9.903",
	    stroke: "#DB836E",
	    strokeWidth: ".795",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M112.366 65.909l-.142 5.32s5.993 4.472 11.945 9.202c4.482 3.562 8.888 7.455 10.985 8.662 4.804 2.766 8.9 3.355 11.076 1.808 4.071-2.894 4.373-9.878-8.136-15.263-4.271-1.838-16.144-6.36-25.728-9.73",
	    fill: "#FFC6A0"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M130.532 85.488s4.588 5.757 11.619 6.214",
	    stroke: "#DB836E",
	    strokeWidth: ".75",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M121.708 105.73s-.393 8.564-1.34 13.612",
	    stroke: "#E4EBF7",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M115.784 161.512s-3.57-1.488-2.678-7.14",
	    stroke: "#648BD8",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M101.52 290.246s4.326 2.057 7.408 1.03c2.842-.948 4.564.673 7.132 1.186 2.57.514 6.925 1.108 11.772-1.269-.104-5.551-6.939-4.01-12.048-6.763-2.582-1.39-3.812-4.757-3.625-8.863h-9.471s-1.402 10.596-1.169 14.68",
	    fill: "#CBD1D1"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M101.496 290.073s2.447 1.281 6.809.658c3.081-.44 3.74.485 7.479 1.039 3.739.554 10.802-.07 11.91-.9.415 1.108-.347 2.077-.347 2.077s-1.523.608-4.847.831c-2.045.137-5.843.293-7.663-.507-1.8-1.385-5.286-1.917-5.77-.243-3.947.958-7.41-.288-7.41-.288l-.16-2.667z",
	    fill: "#2B0849"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M108.824 276.19h3.116s-.103 6.751 4.57 8.62c-4.673.624-8.62-2.32-7.686-8.62",
	    fill: "#A4AABA"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M57.65 272.52s-2.122 7.47-4.518 12.396c-1.811 3.724-4.255 7.548 5.505 7.548 6.698 0 9.02-.483 7.479-6.648-1.541-6.164.268-13.296.268-13.296H57.65z",
	    fill: "#CBD1D1"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M51.54 290.04s2.111 1.178 6.682 1.178c6.128 0 8.31-1.662 8.31-1.662s.605 1.122-.624 2.18c-1 .862-3.624 1.603-7.444 1.559-4.177-.049-5.876-.57-6.786-1.177-.831-.554-.692-1.593-.138-2.078",
	    fill: "#2B0849"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M58.533 274.438s.034 1.529-.315 2.95c-.352 1.431-1.087 3.127-1.139 4.17-.058 1.16 4.57 1.592 5.194.035.623-1.559 1.303-6.475 1.927-7.306.622-.831-4.94-2.135-5.667.15",
	    fill: "#A4AABA"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M100.885 277.015l13.306.092s1.291-54.228 1.843-64.056c.552-9.828 3.756-43.13.997-62.788l-12.48-.64-22.725.776s-.433 3.944-1.19 9.921c-.062.493-.677.838-.744 1.358-.075.582.42 1.347.318 1.956-2.35 14.003-6.343 32.926-8.697 46.425-.116.663-1.227 1.004-1.45 2.677-.04.3.21 1.516.112 1.785-6.836 18.643-10.89 47.584-14.2 61.551l14.528-.014s2.185-8.524 4.008-16.878c2.796-12.817 22.987-84.553 22.987-84.553l3-.517 1.037 46.1s-.223 1.228.334 2.008c.558.782-.556 1.117-.39 2.233l.39 1.784s-.446 7.14-.892 11.826c-.446 4.685-.092 38.954-.092 38.954",
	    fill: "#7BB2F9"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M77.438 220.434c1.146.094 4.016-2.008 6.916-4.91M107.55 223.931s2.758-1.103 6.069-3.862",
	    stroke: "#648BD8",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M108.459 220.905s2.759-1.104 6.07-3.863",
	    stroke: "#648BD8",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M76.099 223.557s2.608-.587 6.47-3.346M87.33 150.82c-.27 3.088.297 8.478-4.315 9.073M104.829 149.075s.11 13.936-1.286 14.983c-2.207 1.655-2.975 1.934-2.975 1.934M101.014 149.63s.035 12.81-1.19 24.245M94.93 174.965s7.174-1.655 9.38-1.655M75.671 204.754c-.316 1.55-.64 3.067-.973 4.535 0 0-1.45 1.822-1.003 3.756.446 1.934-.943 2.034-4.96 15.273-1.686 5.559-4.464 18.49-6.313 27.447-.078.38-4.018 18.06-4.093 18.423M77.043 196.743a313.269 313.269 0 0 1-.877 4.729M83.908 151.414l-1.19 10.413s-1.091.148-.496 2.23c.111 1.34-2.66 15.692-5.153 30.267M57.58 272.94h13.238",
	    stroke: "#648BD8",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M117.377 147.423s-16.955-3.087-35.7.199c.157 2.501-.002 4.128-.002 4.128s14.607-2.802 35.476-.31c.251-2.342.226-4.017.226-4.017",
	    fill: "#192064"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M107.511 150.353l.004-4.885a.807.807 0 0 0-.774-.81c-2.428-.092-5.04-.108-7.795-.014a.814.814 0 0 0-.784.81l-.003 4.88c0 .456.371.82.827.808a140.76 140.76 0 0 1 7.688.017.81.81 0 0 0 .837-.806",
	    fill: "#FFF"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M106.402 149.426l.002-3.06a.64.64 0 0 0-.616-.643 94.135 94.135 0 0 0-5.834-.009.647.647 0 0 0-.626.643l-.001 3.056c0 .36.291.648.651.64 1.78-.04 3.708-.041 5.762.012.36.009.662-.279.662-.64",
	    fill: "#192064"
	  }), /*#__PURE__*/React.createElement("path", {
	    d: "M101.485 273.933h12.272M102.652 269.075c.006 3.368.04 5.759.11 6.47M102.667 263.125c-.009 1.53-.015 2.98-.016 4.313M102.204 174.024l.893 44.402s.669 1.561-.224 2.677c-.892 1.116 2.455.67.893 2.231-1.562 1.562.893 1.116 0 3.347-.592 1.48-.988 20.987-1.09 34.956",
	    stroke: "#648BD8",
	    strokeWidth: "1.051",
	    strokeLinecap: "round",
	    strokeLinejoin: "round"
	  })));
	};
	
	var _default = Unauthorized;
	exports["default"] = _default;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	// eslint-disable-next-line react/prefer-stateless-function
	var SkeletonAvatar = /*#__PURE__*/function (_React$Component) {
	  _inherits(SkeletonAvatar, _React$Component);
	
	  var _super = _createSuper(SkeletonAvatar);
	
	  function SkeletonAvatar() {
	    _classCallCheck(this, SkeletonAvatar);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(SkeletonAvatar, [{
	    key: "render",
	    value: function render() {
	      var _classNames, _classNames2;
	
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          style = _this$props.style,
	          size = _this$props.size,
	          shape = _this$props.shape;
	      var sizeCls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames));
	      var shapeCls = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-circle"), shape === 'circle'), _defineProperty(_classNames2, "".concat(prefixCls, "-square"), shape === 'square'), _classNames2));
	      var sizeStyle = typeof size === 'number' ? {
	        width: size,
	        height: size,
	        lineHeight: "".concat(size, "px")
	      } : {};
	      return /*#__PURE__*/React.createElement("span", {
	        className: (0, _classnames["default"])(prefixCls, className, sizeCls, shapeCls),
	        style: _extends(_extends({}, sizeStyle), style)
	      });
	    }
	  }]);
	
	  return SkeletonAvatar;
	}(React.Component);
	
	SkeletonAvatar.defaultProps = {
	  size: 'large'
	};
	var _default = SkeletonAvatar;
	exports["default"] = _default;

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Paragraph = /*#__PURE__*/function (_React$Component) {
	  _inherits(Paragraph, _React$Component);
	
	  var _super = _createSuper(Paragraph);
	
	  function Paragraph() {
	    _classCallCheck(this, Paragraph);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Paragraph, [{
	    key: "getWidth",
	    value: function getWidth(index) {
	      var _this$props = this.props,
	          width = _this$props.width,
	          _this$props$rows = _this$props.rows,
	          rows = _this$props$rows === void 0 ? 2 : _this$props$rows;
	
	      if (Array.isArray(width)) {
	        return width[index];
	      } // last paragraph
	
	
	      if (rows - 1 === index) {
	        return width;
	      }
	
	      return undefined;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          className = _this$props2.className,
	          style = _this$props2.style,
	          rows = _this$props2.rows;
	
	      var rowList = _toConsumableArray(Array(rows)).map(function (_, index) {
	        return (
	          /*#__PURE__*/
	          // eslint-disable-next-line react/no-array-index-key
	          React.createElement("li", {
	            key: index,
	            style: {
	              width: _this.getWidth(index)
	            }
	          })
	        );
	      });
	
	      return /*#__PURE__*/React.createElement("ul", {
	        className: (0, _classnames["default"])(prefixCls, className),
	        style: style
	      }, rowList);
	    }
	  }]);
	
	  return Paragraph;
	}(React.Component);
	
	var _default = Paragraph;
	exports["default"] = _default;

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Title = function Title(_ref) {
	  var prefixCls = _ref.prefixCls,
	      className = _ref.className,
	      width = _ref.width,
	      style = _ref.style;
	  return /*#__PURE__*/React.createElement("h3", {
	    className: (0, _classnames["default"])(prefixCls, className),
	    style: _extends({
	      width: width
	    }, style)
	  });
	};
	
	var _default = Title;
	exports["default"] = _default;

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _Avatar = _interopRequireDefault(__webpack_require__(1312));
	
	var _Title = _interopRequireDefault(__webpack_require__(1314));
	
	var _Paragraph = _interopRequireDefault(__webpack_require__(1313));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function getComponentProps(prop) {
	  if (prop && _typeof(prop) === 'object') {
	    return prop;
	  }
	
	  return {};
	}
	
	function getAvatarBasicProps(hasTitle, hasParagraph) {
	  if (hasTitle && !hasParagraph) {
	    return {
	      shape: 'square'
	    };
	  }
	
	  return {
	    shape: 'circle'
	  };
	}
	
	function getTitleBasicProps(hasAvatar, hasParagraph) {
	  if (!hasAvatar && hasParagraph) {
	    return {
	      width: '38%'
	    };
	  }
	
	  if (hasAvatar && hasParagraph) {
	    return {
	      width: '50%'
	    };
	  }
	
	  return {};
	}
	
	function getParagraphBasicProps(hasAvatar, hasTitle) {
	  var basicProps = {}; // Width
	
	  if (!hasAvatar || !hasTitle) {
	    basicProps.width = '61%';
	  } // Rows
	
	
	  if (!hasAvatar && hasTitle) {
	    basicProps.rows = 3;
	  } else {
	    basicProps.rows = 2;
	  }
	
	  return basicProps;
	}
	
	var Skeleton = /*#__PURE__*/function (_React$Component) {
	  _inherits(Skeleton, _React$Component);
	
	  var _super = _createSuper(Skeleton);
	
	  function Skeleton() {
	    var _this;
	
	    _classCallCheck(this, Skeleton);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSkeleton = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          loading = _this$props.loading,
	          className = _this$props.className,
	          children = _this$props.children,
	          avatar = _this$props.avatar,
	          title = _this$props.title,
	          paragraph = _this$props.paragraph,
	          active = _this$props.active;
	      var prefixCls = getPrefixCls('skeleton', customizePrefixCls);
	
	      if (loading || !('loading' in _this.props)) {
	        var _classNames;
	
	        var hasAvatar = !!avatar;
	        var hasTitle = !!title;
	        var hasParagraph = !!paragraph; // Avatar
	
	        var avatarNode;
	
	        if (hasAvatar) {
	          var avatarProps = _extends(_extends({
	            prefixCls: "".concat(prefixCls, "-avatar")
	          }, getAvatarBasicProps(hasTitle, hasParagraph)), getComponentProps(avatar));
	
	          avatarNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-header")
	          }, /*#__PURE__*/React.createElement(_Avatar["default"], avatarProps));
	        }
	
	        var contentNode;
	
	        if (hasTitle || hasParagraph) {
	          // Title
	          var $title;
	
	          if (hasTitle) {
	            var titleProps = _extends(_extends({
	              prefixCls: "".concat(prefixCls, "-title")
	            }, getTitleBasicProps(hasAvatar, hasParagraph)), getComponentProps(title));
	
	            $title = /*#__PURE__*/React.createElement(_Title["default"], titleProps);
	          } // Paragraph
	
	
	          var paragraphNode;
	
	          if (hasParagraph) {
	            var paragraphProps = _extends(_extends({
	              prefixCls: "".concat(prefixCls, "-paragraph")
	            }, getParagraphBasicProps(hasAvatar, hasTitle)), getComponentProps(paragraph));
	
	            paragraphNode = /*#__PURE__*/React.createElement(_Paragraph["default"], paragraphProps);
	          }
	
	          contentNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-content")
	          }, $title, paragraphNode);
	        }
	
	        var cls = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-with-avatar"), hasAvatar), _defineProperty(_classNames, "".concat(prefixCls, "-active"), active), _classNames));
	        return /*#__PURE__*/React.createElement("div", {
	          className: cls
	        }, avatarNode, contentNode);
	      }
	
	      return children;
	    };
	
	    return _this;
	  }
	
	  _createClass(Skeleton, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSkeleton);
	    }
	  }]);
	
	  return Skeleton;
	}(React.Component);
	
	Skeleton.defaultProps = {
	  avatar: false,
	  title: true,
	  paragraph: true
	};
	var _default = Skeleton;
	exports["default"] = _default;

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _Slider = _interopRequireDefault(__webpack_require__(2728));
	
	var _Range = _interopRequireDefault(__webpack_require__(2727));
	
	var _Handle = _interopRequireDefault(__webpack_require__(1103));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(165));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Slider = /*#__PURE__*/function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  var _super = _createSuper(Slider);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _super.call(this, props);
	
	    _this.toggleTooltipVisible = function (index, visible) {
	      _this.setState(function (_ref) {
	        var visibles = _ref.visibles;
	        return {
	          visibles: _extends(_extends({}, visibles), _defineProperty({}, index, visible))
	        };
	      });
	    };
	
	    _this.handleWithTooltip = function (_a) {
	      var tooltipPrefixCls = _a.tooltipPrefixCls,
	          prefixCls = _a.prefixCls,
	          _b = _a.info,
	          value = _b.value,
	          dragging = _b.dragging,
	          index = _b.index,
	          restProps = __rest(_b, ["value", "dragging", "index"]);
	
	      var _this$props = _this.props,
	          tipFormatter = _this$props.tipFormatter,
	          tooltipVisible = _this$props.tooltipVisible,
	          tooltipPlacement = _this$props.tooltipPlacement,
	          getTooltipPopupContainer = _this$props.getTooltipPopupContainer;
	      var visibles = _this.state.visibles;
	      var isTipFormatter = tipFormatter ? visibles[index] || dragging : false;
	      var visible = tooltipVisible || tooltipVisible === undefined && isTipFormatter;
	      return /*#__PURE__*/React.createElement(_tooltip["default"], {
	        prefixCls: tooltipPrefixCls,
	        title: tipFormatter ? tipFormatter(value) : '',
	        visible: visible,
	        placement: tooltipPlacement || 'top',
	        transitionName: "zoom-down",
	        key: index,
	        overlayClassName: "".concat(prefixCls, "-tooltip"),
	        getPopupContainer: getTooltipPopupContainer || function () {
	          return document.body;
	        }
	      }, /*#__PURE__*/React.createElement(_Handle["default"], _extends({}, restProps, {
	        value: value,
	        onMouseEnter: function onMouseEnter() {
	          return _this.toggleTooltipVisible(index, true);
	        },
	        onMouseLeave: function onMouseLeave() {
	          return _this.toggleTooltipVisible(index, false);
	        }
	      })));
	    };
	
	    _this.saveSlider = function (node) {
	      _this.rcSlider = node;
	    };
	
	    _this.renderSlider = function (_ref2) {
	      var getPrefixCls = _ref2.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          customizeTooltipPrefixCls = _a.tooltipPrefixCls,
	          range = _a.range,
	          restProps = __rest(_a, ["prefixCls", "tooltipPrefixCls", "range"]);
	
	      var prefixCls = getPrefixCls('slider', customizePrefixCls);
	      var tooltipPrefixCls = getPrefixCls('tooltip', customizeTooltipPrefixCls);
	
	      if (range) {
	        return /*#__PURE__*/React.createElement(_Range["default"], _extends({}, restProps, {
	          ref: _this.saveSlider,
	          handle: function handle(info) {
	            return _this.handleWithTooltip({
	              tooltipPrefixCls: tooltipPrefixCls,
	              prefixCls: prefixCls,
	              info: info
	            });
	          },
	          prefixCls: prefixCls,
	          tooltipPrefixCls: tooltipPrefixCls
	        }));
	      }
	
	      return /*#__PURE__*/React.createElement(_Slider["default"], _extends({}, restProps, {
	        ref: _this.saveSlider,
	        handle: function handle(info) {
	          return _this.handleWithTooltip({
	            tooltipPrefixCls: tooltipPrefixCls,
	            prefixCls: prefixCls,
	            info: info
	          });
	        },
	        prefixCls: prefixCls,
	        tooltipPrefixCls: tooltipPrefixCls
	      }));
	    };
	
	    _this.state = {
	      visibles: {}
	    };
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "focus",
	    value: function focus() {
	      this.rcSlider.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSlider.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSlider);
	    }
	  }]);
	
	  return Slider;
	}(React.Component);
	
	exports["default"] = Slider;
	Slider.defaultProps = {
	  tipFormatter: function tipFormatter(value) {
	    return value.toString();
	  }
	};

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var moment = _interopRequireWildcard(__webpack_require__(3));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(149));
	
	var _Statistic = _interopRequireDefault(__webpack_require__(640));
	
	var _utils = __webpack_require__(1320);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var REFRESH_INTERVAL = 1000 / 30;
	
	function getTime(value) {
	  return (0, _interopDefault["default"])(moment)(value).valueOf();
	}
	
	var Countdown = /*#__PURE__*/function (_React$Component) {
	  _inherits(Countdown, _React$Component);
	
	  var _super = _createSuper(Countdown);
	
	  function Countdown() {
	    var _this;
	
	    _classCallCheck(this, Countdown);
	
	    _this = _super.apply(this, arguments);
	
	    _this.syncTimer = function () {
	      var value = _this.props.value;
	      var timestamp = getTime(value);
	
	      if (timestamp >= Date.now()) {
	        _this.startTimer();
	      } else {
	        _this.stopTimer();
	      }
	    };
	
	    _this.startTimer = function () {
	      if (_this.countdownId) return;
	      _this.countdownId = window.setInterval(function () {
	        _this.forceUpdate();
	      }, REFRESH_INTERVAL);
	    };
	
	    _this.stopTimer = function () {
	      var _this$props = _this.props,
	          onFinish = _this$props.onFinish,
	          value = _this$props.value;
	
	      if (_this.countdownId) {
	        clearInterval(_this.countdownId);
	        _this.countdownId = undefined;
	        var timestamp = getTime(value);
	
	        if (onFinish && timestamp < Date.now()) {
	          onFinish();
	        }
	      }
	    };
	
	    _this.formatCountdown = function (value, config) {
	      var format = _this.props.format;
	      return (0, _utils.formatCountdown)(value, _extends(_extends({}, config), {
	        format: format
	      }));
	    }; // Countdown do not need display the timestamp
	
	
	    _this.valueRender = function (node) {
	      return /*#__PURE__*/React.cloneElement(node, {
	        title: undefined
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(Countdown, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.syncTimer();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.syncTimer();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.stopTimer();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_Statistic["default"], _extends({
	        valueRender: this.valueRender
	      }, this.props, {
	        formatter: this.formatCountdown
	      }));
	    }
	  }]);
	
	  return Countdown;
	}(React.Component);
	
	Countdown.defaultProps = {
	  format: 'HH:mm:ss'
	};
	(0, _reactLifecyclesCompat.polyfill)(Countdown);
	var _default = Countdown;
	exports["default"] = _default;

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _padEnd = _interopRequireDefault(__webpack_require__(2599));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var StatisticNumber = function StatisticNumber(props) {
	  var value = props.value,
	      formatter = props.formatter,
	      precision = props.precision,
	      decimalSeparator = props.decimalSeparator,
	      _props$groupSeparator = props.groupSeparator,
	      groupSeparator = _props$groupSeparator === void 0 ? '' : _props$groupSeparator,
	      prefixCls = props.prefixCls;
	  var valueNode;
	
	  if (typeof formatter === 'function') {
	    // Customize formatter
	    valueNode = formatter(value);
	  } else {
	    // Internal formatter
	    var val = String(value);
	    var cells = val.match(/^(-?)(\d*)(\.(\d+))?$/); // Process if illegal number
	
	    if (!cells) {
	      valueNode = val;
	    } else {
	      var negative = cells[1];
	
	      var _int = cells[2] || '0';
	
	      var decimal = cells[4] || '';
	      _int = _int.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator);
	
	      if (typeof precision === 'number') {
	        decimal = (0, _padEnd["default"])(decimal, precision, '0').slice(0, precision);
	      }
	
	      if (decimal) {
	        decimal = "".concat(decimalSeparator).concat(decimal);
	      }
	
	      valueNode = [/*#__PURE__*/React.createElement("span", {
	        key: "int",
	        className: "".concat(prefixCls, "-content-value-int")
	      }, negative, _int), decimal && /*#__PURE__*/React.createElement("span", {
	        key: "decimal",
	        className: "".concat(prefixCls, "-content-value-decimal")
	      }, decimal)];
	    }
	  }
	
	  return /*#__PURE__*/React.createElement("span", {
	    className: "".concat(prefixCls, "-content-value")
	  }, valueNode);
	};
	
	var _default = StatisticNumber;
	exports["default"] = _default;

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Statistic = _interopRequireDefault(__webpack_require__(640));
	
	var _Countdown = _interopRequireDefault(__webpack_require__(1317));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_Statistic["default"].Countdown = _Countdown["default"];
	var _default = _Statistic["default"];
	exports["default"] = _default;

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.formatTimeStr = formatTimeStr;
	exports.formatCountdown = formatCountdown;
	
	var moment = _interopRequireWildcard(__webpack_require__(3));
	
	var _padStart = _interopRequireDefault(__webpack_require__(2600));
	
	var _interopDefault = _interopRequireDefault(__webpack_require__(149));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	// Countdown
	var timeUnits = [['Y', 1000 * 60 * 60 * 24 * 365], ['M', 1000 * 60 * 60 * 24 * 30], ['D', 1000 * 60 * 60 * 24], ['H', 1000 * 60 * 60], ['m', 1000 * 60], ['s', 1000], ['S', 1]];
	
	function formatTimeStr(duration, format) {
	  var leftDuration = duration;
	  var escapeRegex = /\[[^\]]*\]/g;
	  var keepList = (format.match(escapeRegex) || []).map(function (str) {
	    return str.slice(1, -1);
	  });
	  var templateText = format.replace(escapeRegex, '[]');
	  var replacedText = timeUnits.reduce(function (current, _ref) {
	    var _ref2 = _slicedToArray(_ref, 2),
	        name = _ref2[0],
	        unit = _ref2[1];
	
	    if (current.indexOf(name) !== -1) {
	      var value = Math.floor(leftDuration / unit);
	      leftDuration -= value * unit;
	      return current.replace(new RegExp("".concat(name, "+"), 'g'), function (match) {
	        var len = match.length;
	        return (0, _padStart["default"])(value.toString(), len, '0');
	      });
	    }
	
	    return current;
	  }, templateText);
	  var index = 0;
	  return replacedText.replace(escapeRegex, function () {
	    var match = keepList[index];
	    index += 1;
	    return match;
	  });
	}
	
	function formatCountdown(value, config) {
	  var _config$format = config.format,
	      format = _config$format === void 0 ? '' : _config$format;
	  var target = (0, _interopDefault["default"])(moment)(value).valueOf();
	  var current = (0, _interopDefault["default"])(moment)().valueOf();
	  var diff = Math.max(target - current, 0);
	  return formatTimeStr(diff, format);
	}

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSteps = _interopRequireDefault(__webpack_require__(2733));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Steps = /*#__PURE__*/function (_React$Component) {
	  _inherits(Steps, _React$Component);
	
	  var _super = _createSuper(Steps);
	
	  function Steps() {
	    var _this;
	
	    _classCallCheck(this, Steps);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderSteps = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	      var prefixCls = getPrefixCls('steps', _this.props.prefixCls);
	      var iconPrefix = getPrefixCls('', _this.props.iconPrefix);
	      var icons = {
	        finish: /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "check",
	          className: "".concat(prefixCls, "-finish-icon")
	        }),
	        error: /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "close",
	          className: "".concat(prefixCls, "-error-icon")
	        })
	      };
	      return /*#__PURE__*/React.createElement(_rcSteps["default"], _extends({
	        icons: icons
	      }, _this.props, {
	        prefixCls: prefixCls,
	        iconPrefix: iconPrefix
	      }));
	    };
	
	    return _this;
	  }
	
	  _createClass(Steps, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSteps);
	    }
	  }]);
	
	  return Steps;
	}(React.Component);
	
	exports["default"] = Steps;
	Steps.Step = _rcSteps["default"].Step;
	Steps.defaultProps = {
	  current: 0
	};
	Steps.propTypes = {
	  prefixCls: PropTypes.string,
	  iconPrefix: PropTypes.string,
	  current: PropTypes.number
	};

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _rcSwitch = _interopRequireDefault(__webpack_require__(1362));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _wave = _interopRequireDefault(__webpack_require__(404));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Switch = /*#__PURE__*/function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  var _super = _createSuper(Switch);
	
	  function Switch(props) {
	    var _this;
	
	    _classCallCheck(this, Switch);
	
	    _this = _super.call(this, props);
	
	    _this.saveSwitch = function (node) {
	      _this.rcSwitch = node;
	    };
	
	    _this.renderSwitch = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          size = _this$props.size,
	          loading = _this$props.loading,
	          _this$props$className = _this$props.className,
	          className = _this$props$className === void 0 ? '' : _this$props$className,
	          disabled = _this$props.disabled;
	      var prefixCls = getPrefixCls('switch', customizePrefixCls);
	      var classes = (0, _classnames["default"])(className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-small"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), loading), _classNames));
	      var loadingIcon = loading ? /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "loading",
	        className: "".concat(prefixCls, "-loading-icon")
	      }) : null;
	      return /*#__PURE__*/React.createElement(_wave["default"], {
	        insertExtraNode: true
	      }, /*#__PURE__*/React.createElement(_rcSwitch["default"], _extends({}, (0, _omit["default"])(_this.props, ['loading']), {
	        prefixCls: prefixCls,
	        className: classes,
	        disabled: disabled || loading,
	        ref: _this.saveSwitch,
	        loadingIcon: loadingIcon
	      })));
	    };
	
	    (0, _warning["default"])('checked' in props || !('value' in props), 'Switch', '`value` is not validate prop, do you mean `checked`?');
	    return _this;
	  }
	
	  _createClass(Switch, [{
	    key: "focus",
	    value: function focus() {
	      this.rcSwitch.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcSwitch.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSwitch);
	    }
	  }]);
	
	  return Switch;
	}(React.Component);
	
	exports["default"] = Switch;
	Switch.__ANT_SWITCH = true;
	Switch.propTypes = {
	  prefixCls: PropTypes.string,
	  // HACK: https://github.com/ant-design/ant-design/issues/5368
	  // size=default and size=large are the same
	  size: PropTypes.oneOf(['small', 'default', 'large']),
	  className: PropTypes.string
	};

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	/* eslint-disable react/prefer-stateless-function */
	var Column = /*#__PURE__*/function (_React$Component) {
	  _inherits(Column, _React$Component);
	
	  var _super = _createSuper(Column);
	
	  function Column() {
	    _classCallCheck(this, Column);
	
	    return _super.apply(this, arguments);
	  }
	
	  return Column;
	}(React.Component);
	
	exports["default"] = Column;

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ColumnGroup = /*#__PURE__*/function (_React$Component) {
	  _inherits(ColumnGroup, _React$Component);
	
	  var _super = _createSuper(ColumnGroup);
	
	  function ColumnGroup() {
	    _classCallCheck(this, ColumnGroup);
	
	    return _super.apply(this, arguments);
	  }
	
	  return ColumnGroup;
	}(React.Component);
	
	exports["default"] = ColumnGroup;
	ColumnGroup.__ANT_TABLE_COLUMN_GROUP = true;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var FilterDropdownMenuWrapper = function FilterDropdownMenuWrapper(props) {
	  return /*#__PURE__*/React.createElement("div", {
	    className: props.className,
	    onClick: function onClick(e) {
	      return e.stopPropagation();
	    }
	  }, props.children);
	};
	
	var _default = FilterDropdownMenuWrapper;
	exports["default"] = _default;

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(226));
	
	var _radio = _interopRequireDefault(__webpack_require__(320));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var SelectionBox = /*#__PURE__*/function (_React$Component) {
	  _inherits(SelectionBox, _React$Component);
	
	  var _super = _createSuper(SelectionBox);
	
	  function SelectionBox(props) {
	    var _this;
	
	    _classCallCheck(this, SelectionBox);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      checked: _this.getCheckState(props)
	    };
	    return _this;
	  }
	
	  _createClass(SelectionBox, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.subscribe();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.unsubscribe) {
	        this.unsubscribe();
	      }
	    } // eslint-disable-next-line class-methods-use-this
	
	  }, {
	    key: "getCheckState",
	    value: function getCheckState(props) {
	      var store = props.store,
	          defaultSelection = props.defaultSelection,
	          rowIndex = props.rowIndex;
	      var checked = false;
	
	      if (store.getState().selectionDirty) {
	        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0;
	      } else {
	        checked = store.getState().selectedRowKeys.indexOf(rowIndex) >= 0 || defaultSelection.indexOf(rowIndex) >= 0;
	      }
	
	      return checked;
	    }
	  }, {
	    key: "subscribe",
	    value: function subscribe() {
	      var _this2 = this;
	
	      var store = this.props.store;
	      this.unsubscribe = store.subscribe(function () {
	        var checked = _this2.getCheckState(_this2.props);
	
	        _this2.setState({
	          checked: checked
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          type = _a.type,
	          rowIndex = _a.rowIndex,
	          rest = __rest(_a, ["type", "rowIndex"]);
	
	      var checked = this.state.checked;
	
	      if (type === 'radio') {
	        return /*#__PURE__*/React.createElement(_radio["default"], _extends({
	          checked: checked,
	          value: rowIndex
	        }, rest));
	      }
	
	      return /*#__PURE__*/React.createElement(_checkbox["default"], _extends({
	        checked: checked
	      }, rest));
	    }
	  }]);
	
	  return SelectionBox;
	}(React.Component);
	
	exports["default"] = SelectionBox;

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _checkbox = _interopRequireDefault(__webpack_require__(226));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(407));
	
	var _menu = _interopRequireDefault(__webpack_require__(410));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function checkSelection(_ref) {
	  var store = _ref.store,
	      getCheckboxPropsByItem = _ref.getCheckboxPropsByItem,
	      getRecordKey = _ref.getRecordKey,
	      data = _ref.data,
	      type = _ref.type,
	      byDefaultChecked = _ref.byDefaultChecked;
	  return byDefaultChecked ? data[type](function (item, i) {
	    return getCheckboxPropsByItem(item, i).defaultChecked;
	  }) : data[type](function (item, i) {
	    return store.getState().selectedRowKeys.indexOf(getRecordKey(item, i)) >= 0;
	  });
	}
	
	function getIndeterminateState(props) {
	  var store = props.store,
	      data = props.data;
	
	  if (!data.length) {
	    return false;
	  }
	
	  var someCheckedNotByDefaultChecked = checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'some',
	    byDefaultChecked: false
	  })) && !checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: false
	  }));
	  var someCheckedByDefaultChecked = checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'some',
	    byDefaultChecked: true
	  })) && !checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: true
	  }));
	
	  if (store.getState().selectionDirty) {
	    return someCheckedNotByDefaultChecked;
	  }
	
	  return someCheckedNotByDefaultChecked || someCheckedByDefaultChecked;
	}
	
	function getCheckState(props) {
	  var store = props.store,
	      data = props.data;
	
	  if (!data.length) {
	    return false;
	  }
	
	  if (store.getState().selectionDirty) {
	    return checkSelection(_extends(_extends({}, props), {
	      data: data,
	      type: 'every',
	      byDefaultChecked: false
	    }));
	  }
	
	  return checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: false
	  })) || checkSelection(_extends(_extends({}, props), {
	    data: data,
	    type: 'every',
	    byDefaultChecked: true
	  }));
	}
	
	var SelectionCheckboxAll = /*#__PURE__*/function (_React$Component) {
	  _inherits(SelectionCheckboxAll, _React$Component);
	
	  var _super = _createSuper(SelectionCheckboxAll);
	
	  function SelectionCheckboxAll(props) {
	    var _this;
	
	    _classCallCheck(this, SelectionCheckboxAll);
	
	    _this = _super.call(this, props);
	    _this.state = {
	      checked: false,
	      indeterminate: false
	    };
	
	    _this.handleSelectAllChange = function (e) {
	      var checked = e.target.checked;
	
	      _this.props.onSelect(checked ? 'all' : 'removeAll', 0, null);
	    };
	
	    _this.defaultSelections = props.hideDefaultSelections ? [] : [{
	      key: 'all',
	      text: props.locale.selectAll
	    }, {
	      key: 'invert',
	      text: props.locale.selectInvert
	    }];
	    return _this;
	  }
	
	  _createClass(SelectionCheckboxAll, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.subscribe();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.unsubscribe) {
	        this.unsubscribe();
	      }
	    }
	  }, {
	    key: "setCheckState",
	    value: function setCheckState(props) {
	      var checked = getCheckState(props);
	      var indeterminate = getIndeterminateState(props);
	      this.setState(function (prevState) {
	        var newState = {};
	
	        if (indeterminate !== prevState.indeterminate) {
	          newState.indeterminate = indeterminate;
	        }
	
	        if (checked !== prevState.checked) {
	          newState.checked = checked;
	        }
	
	        return newState;
	      });
	    }
	  }, {
	    key: "subscribe",
	    value: function subscribe() {
	      var _this2 = this;
	
	      var store = this.props.store;
	      this.unsubscribe = store.subscribe(function () {
	        _this2.setCheckState(_this2.props);
	      });
	    }
	  }, {
	    key: "renderMenus",
	    value: function renderMenus(selections) {
	      var _this3 = this;
	
	      return selections.map(function (selection, index) {
	        return /*#__PURE__*/React.createElement(_menu["default"].Item, {
	          key: selection.key || index
	        }, /*#__PURE__*/React.createElement("div", {
	          onClick: function onClick() {
	            _this3.props.onSelect(selection.key, index, selection.onSelect);
	          }
	        }, selection.text));
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          disabled = _this$props.disabled,
	          prefixCls = _this$props.prefixCls,
	          selections = _this$props.selections,
	          getPopupContainer = _this$props.getPopupContainer;
	      var _this$state = this.state,
	          checked = _this$state.checked,
	          indeterminate = _this$state.indeterminate;
	      var selectionPrefixCls = "".concat(prefixCls, "-selection");
	      var customSelections = null;
	
	      if (selections) {
	        var newSelections = Array.isArray(selections) ? this.defaultSelections.concat(selections) : this.defaultSelections;
	        var menu = /*#__PURE__*/React.createElement(_menu["default"], {
	          className: "".concat(selectionPrefixCls, "-menu"),
	          selectedKeys: []
	        }, this.renderMenus(newSelections));
	        customSelections = newSelections.length > 0 ? /*#__PURE__*/React.createElement(_dropdown["default"], {
	          overlay: menu,
	          getPopupContainer: getPopupContainer
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(selectionPrefixCls, "-down")
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "down"
	        }))) : null;
	      }
	
	      return /*#__PURE__*/React.createElement("div", {
	        className: selectionPrefixCls
	      }, /*#__PURE__*/React.createElement(_checkbox["default"], {
	        className: (0, _classnames["default"])(_defineProperty({}, "".concat(selectionPrefixCls, "-select-all-custom"), customSelections)),
	        checked: checked,
	        indeterminate: indeterminate,
	        disabled: disabled,
	        onChange: this.handleSelectAllChange
	      }), customSelections);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, state) {
	      var checked = getCheckState(props);
	      var indeterminate = getIndeterminateState(props);
	      var newState = {};
	
	      if (indeterminate !== state.indeterminate) {
	        newState.indeterminate = indeterminate;
	      }
	
	      if (checked !== state.checked) {
	        newState.checked = checked;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return SelectionCheckboxAll;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(SelectionCheckboxAll);
	var _default = SelectionCheckboxAll;
	exports["default"] = _default;

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _rcTable = _interopRequireWildcard(__webpack_require__(1374));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(79));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _filterDropdown = _interopRequireDefault(__webpack_require__(1331));
	
	var _createStore = _interopRequireDefault(__webpack_require__(1330));
	
	var _SelectionBox = _interopRequireDefault(__webpack_require__(1326));
	
	var _SelectionCheckboxAll = _interopRequireDefault(__webpack_require__(1327));
	
	var _Column = _interopRequireDefault(__webpack_require__(1323));
	
	var _ColumnGroup = _interopRequireDefault(__webpack_require__(1324));
	
	var _createBodyRow = _interopRequireDefault(__webpack_require__(1329));
	
	var _util = __webpack_require__(641);
	
	var _scrollTo = _interopRequireDefault(__webpack_require__(402));
	
	var _pagination = _interopRequireDefault(__webpack_require__(412));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _spin = _interopRequireDefault(__webpack_require__(321));
	
	var _transButton = _interopRequireDefault(__webpack_require__(403));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _default2 = _interopRequireDefault(__webpack_require__(227));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	/* eslint-disable prefer-spread */
	
	
	function noop() {}
	
	function stopPropagation(e) {
	  e.stopPropagation();
	}
	
	function getRowSelection(props) {
	  return props.rowSelection || {};
	}
	
	function getColumnKey(column, index) {
	  return column.key || column.dataIndex || index;
	}
	
	function isSameColumn(a, b) {
	  if (a && b && a.key && a.key === b.key) {
	    return true;
	  }
	
	  return a === b || (0, _shallowequal["default"])(a, b, function (value, other) {
	    // https://github.com/ant-design/ant-design/issues/12737
	    if (typeof value === 'function' && typeof other === 'function') {
	      return value === other || value.toString() === other.toString();
	    } // https://github.com/ant-design/ant-design/issues/19398
	
	
	    if (Array.isArray(value) && Array.isArray(other)) {
	      return value === other || (0, _shallowequal["default"])(value, other);
	    }
	  });
	}
	
	var defaultPagination = {
	  onChange: noop,
	  onShowSizeChange: noop
	};
	/**
	 * Avoid creating new object, so that parent component's shouldComponentUpdate
	 * can works appropriately。
	 */
	
	var emptyObject = {};
	
	var createComponents = function createComponents() {
	  var components = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var bodyRow = components && components.body && components.body.row;
	  return _extends(_extends({}, components), {
	    body: _extends(_extends({}, components.body), {
	      row: (0, _createBodyRow["default"])(bodyRow)
	    })
	  });
	};
	
	function isTheSameComponents() {
	  var components1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var components2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return components1 === components2 || ['table', 'header', 'body'].every(function (key) {
	    return (0, _shallowequal["default"])(components1[key], components2[key]);
	  });
	}
	
	function getFilteredValueColumns(state, columns) {
	  return (0, _util.flatFilter)(columns || (state || {}).columns || [], function (column) {
	    return typeof column.filteredValue !== 'undefined';
	  });
	}
	
	function getFiltersFromColumns() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var columns = arguments.length > 1 ? arguments[1] : undefined;
	  var filters = {};
	  getFilteredValueColumns(state, columns).forEach(function (col) {
	    var colKey = getColumnKey(col);
	    filters[colKey] = col.filteredValue;
	  });
	  return filters;
	}
	
	function isFiltersChanged(state, filters) {
	  if (Object.keys(filters).length !== Object.keys(state.filters).length) {
	    return true;
	  }
	
	  return Object.keys(filters).some(function (columnKey) {
	    return filters[columnKey] !== state.filters[columnKey];
	  });
	}
	
	var Table = /*#__PURE__*/function (_React$Component) {
	  _inherits(Table, _React$Component);
	
	  var _super = _createSuper(Table);
	
	  function Table(props) {
	    var _this;
	
	    _classCallCheck(this, Table);
	
	    _this = _super.call(this, props);
	
	    _this.setTableRef = function (table) {
	      _this.rcTable = table;
	    };
	
	    _this.getCheckboxPropsByItem = function (item, index) {
	      var rowSelection = getRowSelection(_this.props);
	
	      if (!rowSelection.getCheckboxProps) {
	        return {};
	      }
	
	      var key = _this.getRecordKey(item, index); // Cache checkboxProps
	
	
	      if (!_this.props.checkboxPropsCache[key]) {
	        _this.props.checkboxPropsCache[key] = rowSelection.getCheckboxProps(item) || {};
	        var checkboxProps = _this.props.checkboxPropsCache[key];
	        (0, _warning["default"])(!('checked' in checkboxProps) && !('defaultChecked' in checkboxProps), 'Table', 'Do not set `checked` or `defaultChecked` in `getCheckboxProps`. Please use `selectedRowKeys` instead.');
	      }
	
	      return _this.props.checkboxPropsCache[key];
	    };
	
	    _this.getRecordKey = function (record, index) {
	      var rowKey = _this.props.rowKey;
	      var recordKey = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
	      (0, _warning["default"])(recordKey !== undefined, 'Table', 'Each record in dataSource of table should have a unique `key` prop, ' + 'or set `rowKey` of Table to an unique primary key, ' + 'see https://u.ant.design/table-row-key');
	      return recordKey === undefined ? index : recordKey;
	    };
	
	    _this.onRow = function (prefixCls, record, index) {
	      var onRow = _this.props.onRow;
	      var custom = onRow ? onRow(record, index) : {};
	      return _extends(_extends({}, custom), {
	        prefixCls: prefixCls,
	        store: _this.props.store,
	        rowKey: _this.getRecordKey(record, index)
	      });
	    };
	
	    _this.generatePopupContainerFunc = function (getPopupContainer) {
	      var scroll = _this.props.scroll;
	      var table = _this.rcTable;
	
	      if (getPopupContainer) {
	        return getPopupContainer;
	      } // Use undefined to let rc component use default logic.
	
	
	      return scroll && table ? function () {
	        return table.tableNode;
	      } : undefined;
	    };
	
	    _this.scrollToFirstRow = function () {
	      var scroll = _this.props.scroll;
	
	      if (scroll && scroll.scrollToFirstRowOnChange !== false) {
	        (0, _scrollTo["default"])(0, {
	          getContainer: function getContainer() {
	            return _this.rcTable.bodyTable;
	          }
	        });
	      }
	    };
	
	    _this.handleFilter = function (column, nextFilters) {
	      var props = _this.props;
	
	      var pagination = _extends({}, _this.state.pagination);
	
	      var filters = _extends(_extends({}, _this.state.filters), _defineProperty({}, getColumnKey(column), nextFilters)); // Remove filters not in current columns
	
	
	      var currentColumnKeys = [];
	      (0, _util.treeMap)(_this.state.columns, function (c) {
	        if (!c.children) {
	          currentColumnKeys.push(getColumnKey(c));
	        }
	      });
	      Object.keys(filters).forEach(function (columnKey) {
	        if (currentColumnKeys.indexOf(columnKey) < 0) {
	          delete filters[columnKey];
	        }
	      });
	
	      if (props.pagination) {
	        // Reset current prop
	        pagination.current = 1;
	        pagination.onChange(pagination.current);
	      }
	
	      var newState = {
	        pagination: pagination,
	        filters: {}
	      };
	
	      var filtersToSetState = _extends({}, filters); // Remove filters which is controlled
	
	
	      getFilteredValueColumns(_this.state).forEach(function (col) {
	        var columnKey = getColumnKey(col);
	
	        if (columnKey) {
	          delete filtersToSetState[columnKey];
	        }
	      });
	
	      if (Object.keys(filtersToSetState).length > 0) {
	        newState.filters = filtersToSetState;
	      } // Controlled current prop will not respond user interaction
	
	
	      if (_typeof(props.pagination) === 'object' && 'current' in props.pagination) {
	        newState.pagination = _extends(_extends({}, pagination), {
	          current: _this.state.pagination.current
	        });
	      }
	
	      _this.setState(newState, function () {
	        _this.scrollToFirstRow();
	
	        _this.props.store.setState({
	          selectionDirty: false
	        });
	
	        var onChange = _this.props.onChange;
	
	        if (onChange) {
	          onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	            selectionDirty: false,
	            filters: filters,
	            pagination: pagination
	          })));
	        }
	      });
	    };
	
	    _this.handleSelect = function (record, rowIndex, e) {
	      var checked = e.target.checked;
	      var nativeEvent = e.nativeEvent;
	      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
	
	      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);
	
	      var key = _this.getRecordKey(record, rowIndex);
	
	      var pivot = _this.state.pivot;
	
	      var rows = _this.getFlatCurrentPageData();
	
	      var realIndex = rowIndex;
	
	      if (_this.props.expandedRowRender) {
	        realIndex = rows.findIndex(function (row) {
	          return _this.getRecordKey(row, rowIndex) === key;
	        });
	      }
	
	      if (nativeEvent.shiftKey && pivot !== undefined && realIndex !== pivot) {
	        var changeRowKeys = [];
	        var direction = Math.sign(pivot - realIndex);
	        var dist = Math.abs(pivot - realIndex);
	        var step = 0;
	
	        var _loop = function _loop() {
	          var i = realIndex + step * direction;
	          step += 1;
	          var row = rows[i];
	
	          var rowKey = _this.getRecordKey(row, i);
	
	          var checkboxProps = _this.getCheckboxPropsByItem(row, i);
	
	          if (!checkboxProps.disabled) {
	            if (selectedRowKeys.includes(rowKey)) {
	              if (!checked) {
	                selectedRowKeys = selectedRowKeys.filter(function (j) {
	                  return rowKey !== j;
	                });
	                changeRowKeys.push(rowKey);
	              }
	            } else if (checked) {
	              selectedRowKeys.push(rowKey);
	              changeRowKeys.push(rowKey);
	            }
	          }
	        };
	
	        while (step <= dist) {
	          _loop();
	        }
	
	        _this.setState({
	          pivot: realIndex
	        });
	
	        _this.props.store.setState({
	          selectionDirty: true
	        });
	
	        _this.setSelectedRowKeys(selectedRowKeys, {
	          selectWay: 'onSelectMultiple',
	          record: record,
	          checked: checked,
	          changeRowKeys: changeRowKeys,
	          nativeEvent: nativeEvent
	        });
	      } else {
	        if (checked) {
	          selectedRowKeys.push(_this.getRecordKey(record, realIndex));
	        } else {
	          selectedRowKeys = selectedRowKeys.filter(function (i) {
	            return key !== i;
	          });
	        }
	
	        _this.setState({
	          pivot: realIndex
	        });
	
	        _this.props.store.setState({
	          selectionDirty: true
	        });
	
	        _this.setSelectedRowKeys(selectedRowKeys, {
	          selectWay: 'onSelect',
	          record: record,
	          checked: checked,
	          changeRowKeys: undefined,
	          nativeEvent: nativeEvent
	        });
	      }
	    };
	
	    _this.handleRadioSelect = function (record, rowIndex, e) {
	      var checked = e.target.checked;
	      var nativeEvent = e.nativeEvent;
	
	      var key = _this.getRecordKey(record, rowIndex);
	
	      var selectedRowKeys = [key];
	
	      _this.props.store.setState({
	        selectionDirty: true
	      });
	
	      _this.setSelectedRowKeys(selectedRowKeys, {
	        selectWay: 'onSelect',
	        record: record,
	        checked: checked,
	        changeRowKeys: undefined,
	        nativeEvent: nativeEvent
	      });
	    };
	
	    _this.handleSelectRow = function (selectionKey, index, onSelectFunc) {
	      var data = _this.getFlatCurrentPageData();
	
	      var defaultSelection = _this.props.store.getState().selectionDirty ? [] : _this.getDefaultSelection();
	
	      var selectedRowKeys = _this.props.store.getState().selectedRowKeys.concat(defaultSelection);
	
	      var changeableRowKeys = data.filter(function (item, i) {
	        return !_this.getCheckboxPropsByItem(item, i).disabled;
	      }).map(function (item, i) {
	        return _this.getRecordKey(item, i);
	      });
	      var changeRowKeys = [];
	      var selectWay = 'onSelectAll';
	      var checked; // handle default selection
	
	      switch (selectionKey) {
	        case 'all':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) < 0) {
	              selectedRowKeys.push(key);
	              changeRowKeys.push(key);
	            }
	          });
	          selectWay = 'onSelectAll';
	          checked = true;
	          break;
	
	        case 'removeAll':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) >= 0) {
	              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
	              changeRowKeys.push(key);
	            }
	          });
	          selectWay = 'onSelectAll';
	          checked = false;
	          break;
	
	        case 'invert':
	          changeableRowKeys.forEach(function (key) {
	            if (selectedRowKeys.indexOf(key) < 0) {
	              selectedRowKeys.push(key);
	            } else {
	              selectedRowKeys.splice(selectedRowKeys.indexOf(key), 1);
	            }
	
	            changeRowKeys.push(key);
	            selectWay = 'onSelectInvert';
	          });
	          break;
	
	        default:
	          break;
	      }
	
	      _this.props.store.setState({
	        selectionDirty: true
	      }); // when select custom selection, callback selections[n].onSelect
	
	
	      var rowSelection = _this.props.rowSelection;
	      var customSelectionStartIndex = 2;
	
	      if (rowSelection && rowSelection.hideDefaultSelections) {
	        customSelectionStartIndex = 0;
	      }
	
	      if (index >= customSelectionStartIndex && typeof onSelectFunc === 'function') {
	        return onSelectFunc(changeableRowKeys);
	      }
	
	      _this.setSelectedRowKeys(selectedRowKeys, {
	        selectWay: selectWay,
	        checked: checked,
	        changeRowKeys: changeRowKeys
	      });
	    };
	
	    _this.handlePageChange = function (current) {
	      var props = _this.props;
	
	      var pagination = _extends({}, _this.state.pagination);
	
	      if (current) {
	        pagination.current = current;
	      } else {
	        pagination.current = pagination.current || 1;
	      }
	
	      for (var _len = arguments.length, otherArguments = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        otherArguments[_key - 1] = arguments[_key];
	      }
	
	      pagination.onChange.apply(pagination, [pagination.current].concat(otherArguments));
	      var newState = {
	        pagination: pagination
	      }; // Controlled current prop will not respond user interaction
	
	      if (props.pagination && _typeof(props.pagination) === 'object' && 'current' in props.pagination) {
	        newState.pagination = _extends(_extends({}, pagination), {
	          current: _this.state.pagination.current
	        });
	      }
	
	      _this.setState(newState, _this.scrollToFirstRow);
	
	      _this.props.store.setState({
	        selectionDirty: false
	      });
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	          selectionDirty: false,
	          pagination: pagination
	        })));
	      }
	    };
	
	    _this.handleShowSizeChange = function (current, pageSize) {
	      var pagination = _this.state.pagination;
	      pagination.onShowSizeChange(current, pageSize);
	
	      var nextPagination = _extends(_extends({}, pagination), {
	        pageSize: pageSize,
	        current: current
	      });
	
	      _this.setState({
	        pagination: nextPagination
	      }, _this.scrollToFirstRow);
	
	      var onChange = _this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, _this.prepareParamsArguments(_extends(_extends({}, _this.state), {
	          pagination: nextPagination
	        })));
	      }
	    };
	
	    _this.renderExpandIcon = function (prefixCls) {
	      return function (_ref) {
	        var expandable = _ref.expandable,
	            expanded = _ref.expanded,
	            needIndentSpaced = _ref.needIndentSpaced,
	            record = _ref.record,
	            onExpand = _ref.onExpand;
	
	        if (expandable) {
	          return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	            componentName: "Table",
	            defaultLocale: _default2["default"].Table
	          }, function (locale) {
	            var _classNames;
	
	            return /*#__PURE__*/React.createElement(_transButton["default"], {
	              className: (0, _classnames["default"])("".concat(prefixCls, "-row-expand-icon"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-row-collapsed"), !expanded), _defineProperty(_classNames, "".concat(prefixCls, "-row-expanded"), expanded), _classNames)),
	              onClick: function onClick(event) {
	                onExpand(record, event);
	              },
	              "aria-label": expanded ? locale.collapse : locale.expand,
	              noStyle: true
	            });
	          });
	        }
	
	        if (needIndentSpaced) {
	          return /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-row-expand-icon ").concat(prefixCls, "-row-spaced")
	          });
	        }
	
	        return null;
	      };
	    };
	
	    _this.renderSelectionBox = function (type) {
	      return function (_, record, index) {
	        var rowKey = _this.getRecordKey(record, index);
	
	        var props = _this.getCheckboxPropsByItem(record, index);
	
	        var handleChange = function handleChange(e) {
	          return type === 'radio' ? _this.handleRadioSelect(record, index, e) : _this.handleSelect(record, index, e);
	        };
	
	        return /*#__PURE__*/React.createElement("span", {
	          onClick: stopPropagation
	        }, /*#__PURE__*/React.createElement(_SelectionBox["default"], _extends({
	          type: type,
	          store: _this.props.store,
	          rowIndex: rowKey,
	          onChange: handleChange,
	          defaultSelection: _this.getDefaultSelection()
	        }, props)));
	      };
	    };
	
	    _this.renderTable = function (_ref2) {
	      var _classNames2;
	
	      var prefixCls = _ref2.prefixCls,
	          renderEmpty = _ref2.renderEmpty,
	          dropdownPrefixCls = _ref2.dropdownPrefixCls,
	          contextLocale = _ref2.contextLocale,
	          contextGetPopupContainer = _ref2.getPopupContainer;
	
	      var _a = _this.props,
	          showHeader = _a.showHeader,
	          locale = _a.locale,
	          getPopupContainer = _a.getPopupContainer,
	          restTableProps = __rest(_a, ["showHeader", "locale", "getPopupContainer"]); // do not pass prop.style to rc-table, since already apply it to container div
	
	
	      var restProps = (0, _omit["default"])(restTableProps, ['style']);
	
	      var data = _this.getCurrentPageData();
	
	      var expandIconAsCell = _this.props.expandedRowRender && _this.props.expandIconAsCell !== false; // use props.getPopupContainer first
	
	      var realGetPopupContainer = getPopupContainer || contextGetPopupContainer; // Merge too locales
	
	      var mergedLocale = _extends(_extends({}, contextLocale), locale);
	
	      if (!locale || !locale.emptyText) {
	        mergedLocale.emptyText = renderEmpty('Table');
	      }
	
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-").concat(_this.props.size), (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-bordered"), _this.props.bordered), _defineProperty(_classNames2, "".concat(prefixCls, "-empty"), !data.length), _defineProperty(_classNames2, "".concat(prefixCls, "-without-column-header"), !showHeader), _classNames2));
	
	      var columnsWithRowSelection = _this.renderRowSelection({
	        prefixCls: prefixCls,
	        locale: mergedLocale,
	        getPopupContainer: realGetPopupContainer
	      });
	
	      var columns = _this.renderColumnsDropdown({
	        columns: columnsWithRowSelection,
	        prefixCls: prefixCls,
	        dropdownPrefixCls: dropdownPrefixCls,
	        locale: mergedLocale,
	        getPopupContainer: realGetPopupContainer
	      }).map(function (column, i) {
	        var newColumn = _extends({}, column);
	
	        newColumn.key = getColumnKey(newColumn, i);
	        return newColumn;
	      });
	
	      var expandIconColumnIndex = columns[0] && columns[0].key === 'selection-column' ? 1 : 0;
	
	      if ('expandIconColumnIndex' in restProps) {
	        expandIconColumnIndex = restProps.expandIconColumnIndex;
	      }
	
	      return /*#__PURE__*/React.createElement(_rcTable["default"], _extends({
	        ref: _this.setTableRef,
	        key: "table",
	        expandIcon: _this.renderExpandIcon(prefixCls)
	      }, restProps, {
	        onRow: function onRow(record, index) {
	          return _this.onRow(prefixCls, record, index);
	        },
	        components: _this.state.components,
	        prefixCls: prefixCls,
	        data: data,
	        columns: columns,
	        showHeader: showHeader,
	        className: classString,
	        expandIconColumnIndex: expandIconColumnIndex,
	        expandIconAsCell: expandIconAsCell,
	        emptyText: mergedLocale.emptyText
	      }));
	    };
	
	    _this.renderComponent = function (_ref3) {
	      var getPrefixCls = _ref3.getPrefixCls,
	          renderEmpty = _ref3.renderEmpty,
	          getPopupContainer = _ref3.getPopupContainer;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          customizeDropdownPrefixCls = _this$props.dropdownPrefixCls,
	          style = _this$props.style,
	          className = _this$props.className;
	
	      var data = _this.getCurrentPageData();
	
	      var loading = _this.props.loading;
	
	      if (typeof loading === 'boolean') {
	        loading = {
	          spinning: loading
	        };
	      }
	
	      var prefixCls = getPrefixCls('table', customizePrefixCls);
	      var dropdownPrefixCls = getPrefixCls('dropdown', customizeDropdownPrefixCls);
	      var table = /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Table",
	        defaultLocale: _default2["default"].Table
	      }, function (locale) {
	        return _this.renderTable({
	          prefixCls: prefixCls,
	          renderEmpty: renderEmpty,
	          dropdownPrefixCls: dropdownPrefixCls,
	          contextLocale: locale,
	          getPopupContainer: getPopupContainer
	        });
	      }); // if there is no pagination or no data,
	      // the height of spin should decrease by half of pagination
	
	      var paginationPatchClass = _this.hasPagination() && data && data.length !== 0 ? "".concat(prefixCls, "-with-pagination") : "".concat(prefixCls, "-without-pagination");
	      return /*#__PURE__*/React.createElement("div", {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), className),
	        style: style
	      }, /*#__PURE__*/React.createElement(_spin["default"], _extends({}, loading, {
	        className: loading.spinning ? "".concat(paginationPatchClass, " ").concat(prefixCls, "-spin-holder") : ''
	      }), _this.renderPagination(prefixCls, 'top'), table, _this.renderPagination(prefixCls, 'bottom')));
	    };
	
	    var expandedRowRender = props.expandedRowRender,
	        columnsProp = props.columns;
	    (0, _warning["default"])(!('columnsPageRange' in props || 'columnsPageSize' in props), 'Table', '`columnsPageRange` and `columnsPageSize` are removed, please use ' + 'fixed columns instead, see: https://u.ant.design/fixed-columns.');
	
	    if (expandedRowRender && (columnsProp || []).some(function (_ref4) {
	      var fixed = _ref4.fixed;
	      return !!fixed;
	    })) {
	      (0, _warning["default"])(false, 'Table', '`expandedRowRender` and `Column.fixed` are not compatible. Please use one of them at one time.');
	    }
	
	    var columns = columnsProp || (0, _util.normalizeColumns)(props.children);
	    _this.state = _extends(_extends({}, _this.getDefaultSortOrder(columns || [])), {
	      // 减少状态
	      filters: _this.getDefaultFilters(columns),
	      pagination: _this.getDefaultPagination(props),
	      pivot: undefined,
	      prevProps: props,
	      components: createComponents(props.components),
	      columns: columns
	    });
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this$state = this.state,
	          columns = _this$state.columns,
	          sortColumn = _this$state.sortColumn,
	          sortOrder = _this$state.sortOrder;
	
	      if (this.getSortOrderColumns(columns).length > 0) {
	        var sortState = this.getSortStateFromColumns(columns);
	
	        if (!isSameColumn(sortState.sortColumn, sortColumn) || sortState.sortOrder !== sortOrder) {
	          this.setState(sortState);
	        }
	      }
	    }
	  }, {
	    key: "getDefaultSelection",
	    value: function getDefaultSelection() {
	      var _this2 = this;
	
	      var rowSelection = getRowSelection(this.props);
	
	      if (!rowSelection.getCheckboxProps) {
	        return [];
	      }
	
	      return this.getFlatData().filter(function (item, rowIndex) {
	        return _this2.getCheckboxPropsByItem(item, rowIndex).defaultChecked;
	      }).map(function (record, rowIndex) {
	        return _this2.getRecordKey(record, rowIndex);
	      });
	    }
	  }, {
	    key: "getDefaultPagination",
	    value: function getDefaultPagination(props) {
	      var pagination = _typeof(props.pagination) === 'object' ? props.pagination : {};
	      var current;
	
	      if ('current' in pagination) {
	        current = pagination.current;
	      } else if ('defaultCurrent' in pagination) {
	        current = pagination.defaultCurrent;
	      }
	
	      var pageSize;
	
	      if ('pageSize' in pagination) {
	        pageSize = pagination.pageSize;
	      } else if ('defaultPageSize' in pagination) {
	        pageSize = pagination.defaultPageSize;
	      }
	
	      return this.hasPagination(props) ? _extends(_extends(_extends({}, defaultPagination), pagination), {
	        current: current || 1,
	        pageSize: pageSize || 10
	      }) : {};
	    }
	  }, {
	    key: "getSortOrderColumns",
	    value: function getSortOrderColumns(columns) {
	      return (0, _util.flatFilter)(columns || (this.state || {}).columns || [], function (column) {
	        return 'sortOrder' in column;
	      });
	    }
	  }, {
	    key: "getDefaultFilters",
	    value: function getDefaultFilters(columns) {
	      var definedFilters = getFiltersFromColumns(this.state, columns);
	      var defaultFilteredValueColumns = (0, _util.flatFilter)(columns || [], function (column) {
	        return typeof column.defaultFilteredValue !== 'undefined';
	      });
	      var defaultFilters = defaultFilteredValueColumns.reduce(function (soFar, col) {
	        var colKey = getColumnKey(col);
	        soFar[colKey] = col.defaultFilteredValue;
	        return soFar;
	      }, {});
	      return _extends(_extends({}, defaultFilters), definedFilters);
	    }
	  }, {
	    key: "getDefaultSortOrder",
	    value: function getDefaultSortOrder(columns) {
	      var definedSortState = this.getSortStateFromColumns(columns);
	      var defaultSortedColumn = (0, _util.flatFilter)(columns || [], function (column) {
	        return column.defaultSortOrder != null;
	      })[0];
	
	      if (defaultSortedColumn && !definedSortState.sortColumn) {
	        return {
	          sortColumn: defaultSortedColumn,
	          sortOrder: defaultSortedColumn.defaultSortOrder
	        };
	      }
	
	      return definedSortState;
	    }
	  }, {
	    key: "getSortStateFromColumns",
	    value: function getSortStateFromColumns(columns) {
	      // return first column which sortOrder is not falsy
	      var sortedColumn = this.getSortOrderColumns(columns).filter(function (col) {
	        return col.sortOrder;
	      })[0];
	
	      if (sortedColumn) {
	        return {
	          sortColumn: sortedColumn,
	          sortOrder: sortedColumn.sortOrder
	        };
	      }
	
	      return {
	        sortColumn: null,
	        sortOrder: null
	      };
	    }
	  }, {
	    key: "getMaxCurrent",
	    value: function getMaxCurrent(total) {
	      var _this$state$paginatio = this.state.pagination,
	          current = _this$state$paginatio.current,
	          pageSize = _this$state$paginatio.pageSize;
	
	      if ((current - 1) * pageSize >= total) {
	        return Math.floor((total - 1) / pageSize) + 1;
	      }
	
	      return current;
	    }
	  }, {
	    key: "getSorterFn",
	    value: function getSorterFn(state) {
	      var _ref5 = state || this.state,
	          sortOrder = _ref5.sortOrder,
	          sortColumn = _ref5.sortColumn;
	
	      if (!sortOrder || !sortColumn || typeof sortColumn.sorter !== 'function') {
	        return;
	      }
	
	      return function (a, b) {
	        var result = sortColumn.sorter(a, b, sortOrder);
	
	        if (result !== 0) {
	          return sortOrder === 'descend' ? -result : result;
	        }
	
	        return 0;
	      };
	    }
	  }, {
	    key: "getCurrentPageData",
	    value: function getCurrentPageData() {
	      var data = this.getLocalData();
	      var current;
	      var pageSize;
	      var state = this.state; // 如果没有分页的话，默认全部展示
	
	      if (!this.hasPagination()) {
	        pageSize = Number.MAX_VALUE;
	        current = 1;
	      } else {
	        pageSize = state.pagination.pageSize;
	        current = this.getMaxCurrent(state.pagination.total || data.length);
	      } // 分页
	      // ---
	      // 当数据量少于等于每页数量时，直接设置数据
	      // 否则进行读取分页数据
	
	
	      if (data.length > pageSize || pageSize === Number.MAX_VALUE) {
	        data = data.slice((current - 1) * pageSize, current * pageSize);
	      }
	
	      return data;
	    }
	  }, {
	    key: "getFlatData",
	    value: function getFlatData() {
	      var childrenColumnName = this.props.childrenColumnName;
	      return (0, _util.flatArray)(this.getLocalData(null, false), childrenColumnName);
	    }
	  }, {
	    key: "getFlatCurrentPageData",
	    value: function getFlatCurrentPageData() {
	      var childrenColumnName = this.props.childrenColumnName;
	      return (0, _util.flatArray)(this.getCurrentPageData(), childrenColumnName);
	    }
	  }, {
	    key: "getLocalData",
	    value: function getLocalData(state) {
	      var _this3 = this;
	
	      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var currentState = state || this.state;
	      var dataSource = this.props.dataSource;
	      var data = dataSource || []; // 优化本地排序
	
	      data = data.slice(0);
	      var sorterFn = this.getSorterFn(currentState);
	
	      if (sorterFn) {
	        data = this.recursiveSort(data, sorterFn);
	      } // 筛选
	
	
	      if (filter && currentState.filters) {
	        Object.keys(currentState.filters).forEach(function (columnKey) {
	          var col = _this3.findColumn(columnKey);
	
	          if (!col) {
	            return;
	          }
	
	          var values = currentState.filters[columnKey] || [];
	
	          if (values.length === 0) {
	            return;
	          }
	
	          var onFilter = col.onFilter;
	          data = onFilter ? data.filter(function (record) {
	            return values.some(function (v) {
	              return onFilter(v, record);
	            });
	          }) : data;
	        });
	      }
	
	      return data;
	    }
	  }, {
	    key: "setSelectedRowKeys",
	    value: function setSelectedRowKeys(selectedRowKeys, selectionInfo) {
	      var _this4 = this;
	
	      var selectWay = selectionInfo.selectWay,
	          record = selectionInfo.record,
	          checked = selectionInfo.checked,
	          changeRowKeys = selectionInfo.changeRowKeys,
	          nativeEvent = selectionInfo.nativeEvent;
	      var rowSelection = getRowSelection(this.props);
	
	      if (rowSelection && !('selectedRowKeys' in rowSelection)) {
	        this.props.store.setState({
	          selectedRowKeys: selectedRowKeys
	        });
	      }
	
	      var data = this.getFlatData();
	
	      if (!rowSelection.onChange && !rowSelection[selectWay]) {
	        return;
	      }
	
	      var selectedRows = data.filter(function (row, i) {
	        return selectedRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	      });
	
	      if (rowSelection.onChange) {
	        rowSelection.onChange(selectedRowKeys, selectedRows);
	      }
	
	      if (selectWay === 'onSelect' && rowSelection.onSelect) {
	        rowSelection.onSelect(record, checked, selectedRows, nativeEvent);
	      } else if (selectWay === 'onSelectMultiple' && rowSelection.onSelectMultiple) {
	        var changeRows = data.filter(function (row, i) {
	          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	        });
	        rowSelection.onSelectMultiple(checked, selectedRows, changeRows);
	      } else if (selectWay === 'onSelectAll' && rowSelection.onSelectAll) {
	        var _changeRows = data.filter(function (row, i) {
	          return changeRowKeys.indexOf(_this4.getRecordKey(row, i)) >= 0;
	        });
	
	        rowSelection.onSelectAll(checked, selectedRows, _changeRows);
	      } else if (selectWay === 'onSelectInvert' && rowSelection.onSelectInvert) {
	        rowSelection.onSelectInvert(selectedRowKeys);
	      }
	    }
	  }, {
	    key: "toggleSortOrder",
	    value: function toggleSortOrder(column) {
	      var sortDirections = column.sortDirections || this.props.sortDirections;
	      var _this$state2 = this.state,
	          sortOrder = _this$state2.sortOrder,
	          sortColumn = _this$state2.sortColumn; // 只同时允许一列进行排序，否则会导致排序顺序的逻辑问题
	
	      var newSortOrder; // 切换另一列时，丢弃 sortOrder 的状态
	
	      if (isSameColumn(sortColumn, column) && sortOrder !== undefined) {
	        // 按照sortDirections的内容依次切换排序状态
	        var methodIndex = sortDirections.indexOf(sortOrder) + 1;
	        newSortOrder = methodIndex === sortDirections.length ? undefined : sortDirections[methodIndex];
	      } else {
	        newSortOrder = sortDirections[0];
	      }
	
	      var newState = {
	        sortOrder: newSortOrder,
	        sortColumn: newSortOrder ? column : null
	      }; // Controlled
	
	      if (this.getSortOrderColumns().length === 0) {
	        this.setState(newState, this.scrollToFirstRow);
	      }
	
	      var onChange = this.props.onChange;
	
	      if (onChange) {
	        onChange.apply(null, this.prepareParamsArguments(_extends(_extends({}, this.state), newState), column));
	      }
	    }
	  }, {
	    key: "hasPagination",
	    value: function hasPagination(props) {
	      return (props || this.props).pagination !== false;
	    }
	  }, {
	    key: "isSortColumn",
	    value: function isSortColumn(column) {
	      var sortColumn = this.state.sortColumn;
	
	      if (!column || !sortColumn) {
	        return false;
	      }
	
	      return getColumnKey(sortColumn) === getColumnKey(column);
	    } // Get pagination, filters, sorter
	
	  }, {
	    key: "prepareParamsArguments",
	    value: function prepareParamsArguments(state, column) {
	      var pagination = _extends({}, state.pagination); // remove useless handle function in Table.onChange
	
	
	      delete pagination.onChange;
	      delete pagination.onShowSizeChange;
	      var filters = state.filters;
	      var sorter = {};
	      var currentColumn = column;
	
	      if (state.sortColumn && state.sortOrder) {
	        currentColumn = state.sortColumn;
	        sorter.column = state.sortColumn;
	        sorter.order = state.sortOrder;
	      }
	
	      if (currentColumn) {
	        sorter.field = currentColumn.dataIndex;
	        sorter.columnKey = getColumnKey(currentColumn);
	      }
	
	      var extra = {
	        currentDataSource: this.getLocalData(state)
	      };
	      return [pagination, filters, sorter, extra];
	    }
	  }, {
	    key: "findColumn",
	    value: function findColumn(myKey) {
	      var column;
	      (0, _util.treeMap)(this.state.columns, function (c) {
	        if (getColumnKey(c) === myKey) {
	          column = c;
	        }
	      });
	      return column;
	    }
	  }, {
	    key: "recursiveSort",
	    value: function recursiveSort(data, sorterFn) {
	      var _this5 = this;
	
	      var _this$props$childrenC = this.props.childrenColumnName,
	          childrenColumnName = _this$props$childrenC === void 0 ? 'children' : _this$props$childrenC;
	      return data.sort(sorterFn).map(function (item) {
	        return item[childrenColumnName] ? _extends(_extends({}, item), _defineProperty({}, childrenColumnName, _this5.recursiveSort(item[childrenColumnName], sorterFn))) : item;
	      });
	    }
	  }, {
	    key: "renderPagination",
	    value: function renderPagination(prefixCls, paginationPosition) {
	      // 强制不需要分页
	      if (!this.hasPagination()) {
	        return null;
	      }
	
	      var size = 'default';
	      var pagination = this.state.pagination;
	
	      if (pagination.size) {
	        size = pagination.size;
	      } else if (this.props.size === 'middle' || this.props.size === 'small') {
	        size = 'small';
	      }
	
	      var position = pagination.position || 'bottom';
	      var total = pagination.total || this.getLocalData().length;
	      return total > 0 && (position === paginationPosition || position === 'both') ? /*#__PURE__*/React.createElement(_pagination["default"], _extends({
	        key: "pagination-".concat(paginationPosition)
	      }, pagination, {
	        className: (0, _classnames["default"])(pagination.className, "".concat(prefixCls, "-pagination")),
	        onChange: this.handlePageChange,
	        total: total,
	        size: size,
	        current: this.getMaxCurrent(total),
	        onShowSizeChange: this.handleShowSizeChange
	      })) : null;
	    }
	  }, {
	    key: "renderRowSelection",
	    value: function renderRowSelection(_ref6) {
	      var _this6 = this;
	
	      var prefixCls = _ref6.prefixCls,
	          locale = _ref6.locale,
	          getPopupContainer = _ref6.getPopupContainer;
	      var rowSelection = this.props.rowSelection;
	      var columns = this.state.columns.concat();
	
	      if (rowSelection) {
	        var data = this.getFlatCurrentPageData().filter(function (item, index) {
	          if (rowSelection.getCheckboxProps) {
	            return !_this6.getCheckboxPropsByItem(item, index).disabled;
	          }
	
	          return true;
	        });
	        var selectionColumnClass = (0, _classnames["default"])("".concat(prefixCls, "-selection-column"), _defineProperty({}, "".concat(prefixCls, "-selection-column-custom"), rowSelection.selections));
	
	        var selectionColumn = _defineProperty({
	          key: 'selection-column',
	          render: this.renderSelectionBox(rowSelection.type),
	          className: selectionColumnClass,
	          fixed: rowSelection.fixed,
	          width: rowSelection.columnWidth,
	          title: rowSelection.columnTitle
	        }, _rcTable.INTERNAL_COL_DEFINE, {
	          className: "".concat(prefixCls, "-selection-col")
	        });
	
	        if (rowSelection.type !== 'radio') {
	          var checkboxAllDisabled = data.every(function (item, index) {
	            return _this6.getCheckboxPropsByItem(item, index).disabled;
	          });
	          selectionColumn.title = selectionColumn.title || /*#__PURE__*/React.createElement(_SelectionCheckboxAll["default"], {
	            store: this.props.store,
	            locale: locale,
	            data: data,
	            getCheckboxPropsByItem: this.getCheckboxPropsByItem,
	            getRecordKey: this.getRecordKey,
	            disabled: checkboxAllDisabled,
	            prefixCls: prefixCls,
	            onSelect: this.handleSelectRow,
	            selections: rowSelection.selections,
	            hideDefaultSelections: rowSelection.hideDefaultSelections,
	            getPopupContainer: this.generatePopupContainerFunc(getPopupContainer)
	          });
	        }
	
	        if ('fixed' in rowSelection) {
	          selectionColumn.fixed = rowSelection.fixed;
	        } else if (columns.some(function (column) {
	          return column.fixed === 'left' || column.fixed === true;
	        })) {
	          selectionColumn.fixed = 'left';
	        }
	
	        if (columns[0] && columns[0].key === 'selection-column') {
	          columns[0] = selectionColumn;
	        } else {
	          columns.unshift(selectionColumn);
	        }
	      }
	
	      return columns;
	    }
	  }, {
	    key: "renderColumnsDropdown",
	    value: function renderColumnsDropdown(_ref7) {
	      var _this7 = this;
	
	      var prefixCls = _ref7.prefixCls,
	          dropdownPrefixCls = _ref7.dropdownPrefixCls,
	          columns = _ref7.columns,
	          locale = _ref7.locale,
	          getPopupContainer = _ref7.getPopupContainer;
	      var _this$state3 = this.state,
	          sortOrder = _this$state3.sortOrder,
	          filters = _this$state3.filters;
	      return (0, _util.treeMap)(columns, function (column, i) {
	        var _classNames4;
	
	        var key = getColumnKey(column, i);
	        var filterDropdown;
	        var sortButton;
	        var onHeaderCell = column.onHeaderCell;
	
	        var isSortColumn = _this7.isSortColumn(column);
	
	        if (column.filters && column.filters.length > 0 || column.filterDropdown) {
	          var colFilters = key in filters ? filters[key] : [];
	          filterDropdown = /*#__PURE__*/React.createElement(_filterDropdown["default"], {
	            locale: locale,
	            column: column,
	            selectedKeys: colFilters,
	            confirmFilter: _this7.handleFilter,
	            prefixCls: "".concat(prefixCls, "-filter"),
	            dropdownPrefixCls: dropdownPrefixCls || 'ant-dropdown',
	            getPopupContainer: _this7.generatePopupContainerFunc(getPopupContainer),
	            key: "filter-dropdown"
	          });
	        }
	
	        if (column.sorter) {
	          var sortDirections = column.sortDirections || _this7.props.sortDirections;
	          var isAscend = isSortColumn && sortOrder === 'ascend';
	          var isDescend = isSortColumn && sortOrder === 'descend';
	          var ascend = sortDirections.indexOf('ascend') !== -1 && /*#__PURE__*/React.createElement(_icon["default"], {
	            className: "".concat(prefixCls, "-column-sorter-up ").concat(isAscend ? 'on' : 'off'),
	            type: "caret-up",
	            theme: "filled"
	          });
	          var descend = sortDirections.indexOf('descend') !== -1 && /*#__PURE__*/React.createElement(_icon["default"], {
	            className: "".concat(prefixCls, "-column-sorter-down ").concat(isDescend ? 'on' : 'off'),
	            type: "caret-down",
	            theme: "filled"
	          });
	          sortButton = /*#__PURE__*/React.createElement("div", {
	            title: locale.sortTitle,
	            className: (0, _classnames["default"])("".concat(prefixCls, "-column-sorter-inner"), ascend && descend && "".concat(prefixCls, "-column-sorter-inner-full")),
	            key: "sorter"
	          }, ascend, descend);
	
	          onHeaderCell = function onHeaderCell(col) {
	            var colProps = {}; // Get original first
	
	            if (column.onHeaderCell) {
	              colProps = _extends({}, column.onHeaderCell(col));
	            } // Add sorter logic
	
	
	            var onHeaderCellClick = colProps.onClick;
	
	            colProps.onClick = function () {
	              _this7.toggleSortOrder(column);
	
	              if (onHeaderCellClick) {
	                onHeaderCellClick.apply(void 0, arguments);
	              }
	            };
	
	            return colProps;
	          };
	        }
	
	        return _extends(_extends({}, column), {
	          className: (0, _classnames["default"])(column.className, (_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-actions"), sortButton || filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-filters"), filterDropdown), _defineProperty(_classNames4, "".concat(prefixCls, "-column-has-sorters"), sortButton), _defineProperty(_classNames4, "".concat(prefixCls, "-column-sort"), isSortColumn && sortOrder), _classNames4)),
	          title: [/*#__PURE__*/React.createElement("span", {
	            key: "title",
	            className: "".concat(prefixCls, "-header-column")
	          }, /*#__PURE__*/React.createElement("div", {
	            className: sortButton ? "".concat(prefixCls, "-column-sorters") : undefined
	          }, /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-column-title")
	          }, _this7.renderColumnTitle(column.title)), /*#__PURE__*/React.createElement("span", {
	            className: "".concat(prefixCls, "-column-sorter")
	          }, sortButton))), filterDropdown],
	          onHeaderCell: onHeaderCell
	        });
	      });
	    }
	  }, {
	    key: "renderColumnTitle",
	    value: function renderColumnTitle(title) {
	      var _this$state4 = this.state,
	          filters = _this$state4.filters,
	          sortOrder = _this$state4.sortOrder,
	          sortColumn = _this$state4.sortColumn; // https://github.com/ant-design/ant-design/issues/11246#issuecomment-405009167
	
	      if (title instanceof Function) {
	        return title({
	          filters: filters,
	          sortOrder: sortOrder,
	          sortColumn: sortColumn
	        });
	      }
	
	      return title;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevProps = prevState.prevProps;
	      var columns = nextProps.columns || (0, _util.normalizeColumns)(nextProps.children);
	
	      var nextState = _extends(_extends({}, prevState), {
	        prevProps: nextProps,
	        columns: columns
	      });
	
	      if ('pagination' in nextProps || 'pagination' in prevProps) {
	        var newPagination = _extends(_extends(_extends({}, defaultPagination), prevState.pagination), nextProps.pagination);
	
	        newPagination.current = newPagination.current || 1;
	        newPagination.pageSize = newPagination.pageSize || 10;
	        nextState = _extends(_extends({}, nextState), {
	          pagination: nextProps.pagination !== false ? newPagination : emptyObject
	        });
	      }
	
	      if (nextProps.rowSelection && 'selectedRowKeys' in nextProps.rowSelection) {
	        nextProps.store.setState({
	          selectedRowKeys: nextProps.rowSelection.selectedRowKeys || []
	        });
	      } else if (prevProps.rowSelection && !nextProps.rowSelection) {
	        nextProps.store.setState({
	          selectedRowKeys: []
	        });
	      }
	
	      if ('dataSource' in nextProps && nextProps.dataSource !== prevProps.dataSource) {
	        nextProps.store.setState({
	          selectionDirty: false
	        });
	      } // https://github.com/ant-design/ant-design/issues/10133
	
	
	      nextProps.setCheckboxPropsCache({}); // Update filters
	
	      var filteredValueColumns = getFilteredValueColumns(nextState, nextState.columns);
	
	      if (filteredValueColumns.length > 0) {
	        var filtersFromColumns = getFiltersFromColumns(nextState, nextState.columns);
	
	        var newFilters = _extends({}, nextState.filters);
	
	        Object.keys(filtersFromColumns).forEach(function (key) {
	          newFilters[key] = filtersFromColumns[key];
	        });
	
	        if (isFiltersChanged(nextState, newFilters)) {
	          nextState = _extends(_extends({}, nextState), {
	            filters: newFilters
	          });
	        }
	      }
	
	      if (!isTheSameComponents(nextProps.components, prevProps.components)) {
	        var components = createComponents(nextProps.components);
	        nextState = _extends(_extends({}, nextState), {
	          components: components
	        });
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return Table;
	}(React.Component);
	
	Table.propTypes = {
	  dataSource: PropTypes.array,
	  columns: PropTypes.array,
	  prefixCls: PropTypes.string,
	  useFixedHeader: PropTypes.bool,
	  rowSelection: PropTypes.object,
	  className: PropTypes.string,
	  size: PropTypes.string,
	  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	  bordered: PropTypes.bool,
	  onChange: PropTypes.func,
	  locale: PropTypes.object,
	  dropdownPrefixCls: PropTypes.string,
	  sortDirections: PropTypes.array,
	  getPopupContainer: PropTypes.func
	};
	Table.defaultProps = {
	  dataSource: [],
	  useFixedHeader: false,
	  className: '',
	  size: 'default',
	  loading: false,
	  bordered: false,
	  indentSize: 20,
	  locale: {},
	  rowKey: 'key',
	  showHeader: true,
	  sortDirections: ['ascend', 'descend'],
	  childrenColumnName: 'children'
	};
	(0, _reactLifecyclesCompat.polyfill)(Table);
	
	var StoreTable = /*#__PURE__*/function (_React$Component2) {
	  _inherits(StoreTable, _React$Component2);
	
	  var _super2 = _createSuper(StoreTable);
	
	  function StoreTable(props) {
	    var _this8;
	
	    _classCallCheck(this, StoreTable);
	
	    _this8 = _super2.call(this, props);
	
	    _this8.setCheckboxPropsCache = function (cache) {
	      return _this8.CheckboxPropsCache = cache;
	    };
	
	    _this8.CheckboxPropsCache = {};
	    _this8.store = (0, _createStore["default"])({
	      selectedRowKeys: getRowSelection(props).selectedRowKeys || [],
	      selectionDirty: false
	    });
	    return _this8;
	  }
	
	  _createClass(StoreTable, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(Table, _extends({}, this.props, {
	        store: this.store,
	        checkboxPropsCache: this.CheckboxPropsCache,
	        setCheckboxPropsCache: this.setCheckboxPropsCache
	      }));
	    }
	  }]);
	
	  return StoreTable;
	}(React.Component);
	
	StoreTable.displayName = 'withStore(Table)';
	StoreTable.Column = _Column["default"];
	StoreTable.ColumnGroup = _ColumnGroup["default"];
	var _default = StoreTable;
	exports["default"] = _default;

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createBodyRow;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames2 = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function createBodyRow() {
	  var Component = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'tr';
	
	  var BodyRow = /*#__PURE__*/function (_React$Component) {
	    _inherits(BodyRow, _React$Component);
	
	    var _super = _createSuper(BodyRow);
	
	    function BodyRow(props) {
	      var _this;
	
	      _classCallCheck(this, BodyRow);
	
	      _this = _super.call(this, props);
	      _this.store = props.store;
	
	      var _this$store$getState = _this.store.getState(),
	          selectedRowKeys = _this$store$getState.selectedRowKeys;
	
	      _this.state = {
	        selected: selectedRowKeys.indexOf(props.rowKey) >= 0
	      };
	      return _this;
	    }
	
	    _createClass(BodyRow, [{
	      key: "componentDidMount",
	      value: function componentDidMount() {
	        this.subscribe();
	      }
	    }, {
	      key: "componentWillUnmount",
	      value: function componentWillUnmount() {
	        if (this.unsubscribe) {
	          this.unsubscribe();
	        }
	      }
	    }, {
	      key: "subscribe",
	      value: function subscribe() {
	        var _this2 = this;
	
	        var _this$props = this.props,
	            store = _this$props.store,
	            rowKey = _this$props.rowKey;
	        this.unsubscribe = store.subscribe(function () {
	          var _this2$store$getState = _this2.store.getState(),
	              selectedRowKeys = _this2$store$getState.selectedRowKeys;
	
	          var selected = selectedRowKeys.indexOf(rowKey) >= 0;
	
	          if (selected !== _this2.state.selected) {
	            _this2.setState({
	              selected: selected
	            });
	          }
	        });
	      }
	    }, {
	      key: "render",
	      value: function render() {
	        var rowProps = (0, _omit["default"])(this.props, ['prefixCls', 'rowKey', 'store']);
	        var className = (0, _classnames2["default"])(this.props.className, _defineProperty({}, "".concat(this.props.prefixCls, "-row-selected"), this.state.selected));
	        return /*#__PURE__*/React.createElement(Component, _extends(_extends({}, rowProps), {
	          className: className
	        }), this.props.children);
	      }
	    }]);
	
	    return BodyRow;
	  }(React.Component);
	
	  return BodyRow;
	}

/***/ },
/* 1330 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createStore;
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function createStore(initialState) {
	  var state = initialState;
	  var listeners = [];
	
	  function setState(partial) {
	    state = _extends(_extends({}, state), partial);
	
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	  }
	
	  function getState() {
	    return state;
	  }
	
	  function subscribe(listener) {
	    listeners.push(listener);
	    return function unsubscribe() {
	      var index = listeners.indexOf(listener);
	      listeners.splice(index, 1);
	    };
	  }
	
	  return {
	    setState: setState,
	    getState: getState,
	    subscribe: subscribe
	  };
	}

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _rcMenu = _interopRequireWildcard(__webpack_require__(219));
	
	var _domClosest = _interopRequireDefault(__webpack_require__(2129));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(79));
	
	var _dropdown = _interopRequireDefault(__webpack_require__(407));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(226));
	
	var _radio = _interopRequireDefault(__webpack_require__(320));
	
	var _FilterDropdownMenuWrapper = _interopRequireDefault(__webpack_require__(1325));
	
	var _util = __webpack_require__(641);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function stopPropagation(e) {
	  e.stopPropagation();
	
	  if (e.nativeEvent.stopImmediatePropagation) {
	    e.nativeEvent.stopImmediatePropagation();
	  }
	}
	
	var FilterMenu = /*#__PURE__*/function (_React$Component) {
	  _inherits(FilterMenu, _React$Component);
	
	  var _super = _createSuper(FilterMenu);
	
	  function FilterMenu(props) {
	    var _this;
	
	    _classCallCheck(this, FilterMenu);
	
	    _this = _super.call(this, props);
	
	    _this.setNeverShown = function (column) {
	      var rootNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	      var filterBelongToScrollBody = !!(0, _domClosest["default"])(rootNode, ".ant-table-scroll");
	
	      if (filterBelongToScrollBody) {
	        // When fixed column have filters, there will be two dropdown menus
	        // Filter dropdown menu inside scroll body should never be shown
	        // To fix https://github.com/ant-design/ant-design/issues/5010 and
	        // https://github.com/ant-design/ant-design/issues/7909
	        _this.neverShown = !!column.fixed;
	      }
	    };
	
	    _this.setSelectedKeys = function (_ref) {
	      var selectedKeys = _ref.selectedKeys;
	
	      _this.setState({
	        selectedKeys: selectedKeys
	      });
	    };
	
	    _this.handleClearFilters = function () {
	      _this.setState({
	        selectedKeys: []
	      }, _this.handleConfirm);
	    };
	
	    _this.handleConfirm = function () {
	      _this.setVisible(false); // Call `setSelectedKeys` & `confirm` in the same time will make filter data not up to date
	      // https://github.com/ant-design/ant-design/issues/12284
	
	
	      _this.setState({}, _this.confirmFilter);
	    };
	
	    _this.onVisibleChange = function (visible) {
	      _this.setVisible(visible);
	
	      var column = _this.props.column; // https://github.com/ant-design/ant-design/issues/17833
	
	      if (!visible && !(column.filterDropdown instanceof Function)) {
	        _this.confirmFilter();
	      }
	    };
	
	    _this.handleMenuItemClick = function (info) {
	      var selectedKeys = _this.state.selectedKeys;
	
	      if (!info.keyPath || info.keyPath.length <= 1) {
	        return;
	      }
	
	      var keyPathOfSelectedItem = _this.state.keyPathOfSelectedItem;
	
	      if (selectedKeys && selectedKeys.indexOf(info.key) >= 0) {
	        // deselect SubMenu child
	        delete keyPathOfSelectedItem[info.key];
	      } else {
	        // select SubMenu child
	        keyPathOfSelectedItem[info.key] = info.keyPath;
	      }
	
	      _this.setState({
	        keyPathOfSelectedItem: keyPathOfSelectedItem
	      });
	    };
	
	    _this.renderFilterIcon = function () {
	      var _classNames;
	
	      var _this$props = _this.props,
	          column = _this$props.column,
	          locale = _this$props.locale,
	          prefixCls = _this$props.prefixCls,
	          selectedKeys = _this$props.selectedKeys;
	      var filtered = selectedKeys && selectedKeys.length > 0;
	      var filterIcon = column.filterIcon;
	
	      if (typeof filterIcon === 'function') {
	        filterIcon = filterIcon(filtered);
	      }
	
	      var dropdownIconClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-selected"), 'filtered' in column ? column.filtered : filtered), _defineProperty(_classNames, "".concat(prefixCls, "-open"), _this.getDropdownVisible()), _classNames));
	
	      if (!filterIcon) {
	        return /*#__PURE__*/React.createElement(_icon["default"], {
	          title: locale.filterTitle,
	          type: "filter",
	          theme: "filled",
	          className: dropdownIconClass,
	          onClick: stopPropagation
	        });
	      }
	
	      if ( /*#__PURE__*/React.isValidElement(filterIcon)) {
	        return /*#__PURE__*/React.cloneElement(filterIcon, {
	          title: filterIcon.props.title || locale.filterTitle,
	          className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass, filterIcon.props.className),
	          onClick: stopPropagation
	        });
	      }
	
	      return /*#__PURE__*/React.createElement("span", {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-icon"), dropdownIconClass)
	      }, filterIcon);
	    };
	
	    var visible = 'filterDropdownVisible' in props.column ? props.column.filterDropdownVisible : false;
	    _this.state = {
	      selectedKeys: props.selectedKeys,
	      valueKeys: (0, _util.generateValueMaps)(props.column.filters),
	      keyPathOfSelectedItem: {},
	      visible: visible,
	      prevProps: props
	    };
	    return _this;
	  }
	
	  _createClass(FilterMenu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var column = this.props.column;
	      this.setNeverShown(column);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var column = this.props.column;
	      this.setNeverShown(column);
	    }
	  }, {
	    key: "getDropdownVisible",
	    value: function getDropdownVisible() {
	      return this.neverShown ? false : this.state.visible;
	    }
	  }, {
	    key: "setVisible",
	    value: function setVisible(visible) {
	      var column = this.props.column;
	
	      if (!('filterDropdownVisible' in column)) {
	        this.setState({
	          visible: visible
	        });
	      }
	
	      if (column.onFilterDropdownVisibleChange) {
	        column.onFilterDropdownVisibleChange(visible);
	      }
	    }
	  }, {
	    key: "hasSubMenu",
	    value: function hasSubMenu() {
	      var _this$props$column$fi = this.props.column.filters,
	          filters = _this$props$column$fi === void 0 ? [] : _this$props$column$fi;
	      return filters.some(function (item) {
	        return !!(item.children && item.children.length > 0);
	      });
	    }
	  }, {
	    key: "confirmFilter",
	    value: function confirmFilter() {
	      var _this$props2 = this.props,
	          column = _this$props2.column,
	          propSelectedKeys = _this$props2.selectedKeys,
	          confirmFilter = _this$props2.confirmFilter;
	      var _this$state = this.state,
	          selectedKeys = _this$state.selectedKeys,
	          valueKeys = _this$state.valueKeys;
	      var filterDropdown = column.filterDropdown;
	
	      if (!(0, _shallowequal["default"])(selectedKeys, propSelectedKeys)) {
	        confirmFilter(column, filterDropdown ? selectedKeys : selectedKeys.map(function (key) {
	          return valueKeys[key];
	        }).filter(function (key) {
	          return key !== undefined;
	        }));
	      }
	    }
	  }, {
	    key: "renderMenus",
	    value: function renderMenus(items) {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          dropdownPrefixCls = _this$props3.dropdownPrefixCls,
	          prefixCls = _this$props3.prefixCls;
	      return items.map(function (item) {
	        if (item.children && item.children.length > 0) {
	          var keyPathOfSelectedItem = _this2.state.keyPathOfSelectedItem;
	          var containSelected = Object.keys(keyPathOfSelectedItem).some(function (key) {
	            return keyPathOfSelectedItem[key].indexOf(item.value) >= 0;
	          });
	          var subMenuCls = (0, _classnames["default"])("".concat(prefixCls, "-dropdown-submenu"), _defineProperty({}, "".concat(dropdownPrefixCls, "-submenu-contain-selected"), containSelected));
	          return /*#__PURE__*/React.createElement(_rcMenu.SubMenu, {
	            title: item.text,
	            popupClassName: subMenuCls,
	            key: item.value.toString()
	          }, _this2.renderMenus(item.children));
	        }
	
	        return _this2.renderMenuItem(item);
	      });
	    }
	  }, {
	    key: "renderMenuItem",
	    value: function renderMenuItem(item) {
	      var column = this.props.column;
	      var selectedKeys = this.state.selectedKeys;
	      var multiple = 'filterMultiple' in column ? column.filterMultiple : true; // We still need trade key as string since Menu render need string
	
	      var internalSelectedKeys = (selectedKeys || []).map(function (key) {
	        return key.toString();
	      });
	      var input = multiple ? /*#__PURE__*/React.createElement(_checkbox["default"], {
	        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
	      }) : /*#__PURE__*/React.createElement(_radio["default"], {
	        checked: internalSelectedKeys.indexOf(item.value.toString()) >= 0
	      });
	      return /*#__PURE__*/React.createElement(_rcMenu.Item, {
	        key: item.value
	      }, input, /*#__PURE__*/React.createElement("span", null, item.text));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var originSelectedKeys = this.state.selectedKeys;
	      var _this$props4 = this.props,
	          column = _this$props4.column,
	          locale = _this$props4.locale,
	          prefixCls = _this$props4.prefixCls,
	          dropdownPrefixCls = _this$props4.dropdownPrefixCls,
	          getPopupContainer = _this$props4.getPopupContainer; // default multiple selection in filter dropdown
	
	      var multiple = 'filterMultiple' in column ? column.filterMultiple : true;
	      var dropdownMenuClass = (0, _classnames["default"])(_defineProperty({}, "".concat(dropdownPrefixCls, "-menu-without-submenu"), !this.hasSubMenu()));
	      var filterDropdown = column.filterDropdown;
	
	      if (filterDropdown instanceof Function) {
	        filterDropdown = filterDropdown({
	          prefixCls: "".concat(dropdownPrefixCls, "-custom"),
	          setSelectedKeys: function setSelectedKeys(selectedKeys) {
	            return _this3.setSelectedKeys({
	              selectedKeys: selectedKeys
	            });
	          },
	          selectedKeys: originSelectedKeys,
	          confirm: this.handleConfirm,
	          clearFilters: this.handleClearFilters,
	          filters: column.filters,
	          visible: this.getDropdownVisible()
	        });
	      }
	
	      var menus = filterDropdown ? /*#__PURE__*/React.createElement(_FilterDropdownMenuWrapper["default"], {
	        className: "".concat(prefixCls, "-dropdown")
	      }, filterDropdown) : /*#__PURE__*/React.createElement(_FilterDropdownMenuWrapper["default"], {
	        className: "".concat(prefixCls, "-dropdown")
	      }, /*#__PURE__*/React.createElement(_rcMenu["default"], {
	        multiple: multiple,
	        onClick: this.handleMenuItemClick,
	        prefixCls: "".concat(dropdownPrefixCls, "-menu"),
	        className: dropdownMenuClass,
	        onSelect: this.setSelectedKeys,
	        onDeselect: this.setSelectedKeys,
	        selectedKeys: originSelectedKeys && originSelectedKeys.map(function (val) {
	          return val.toString();
	        }),
	        getPopupContainer: getPopupContainer
	      }, this.renderMenus(column.filters)), /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-dropdown-btns")
	      }, /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-dropdown-link confirm"),
	        onClick: this.handleConfirm
	      }, locale.filterConfirm), /*#__PURE__*/React.createElement("a", {
	        className: "".concat(prefixCls, "-dropdown-link clear"),
	        onClick: this.handleClearFilters
	      }, locale.filterReset)));
	      return /*#__PURE__*/React.createElement(_dropdown["default"], {
	        trigger: ['click'],
	        placement: "bottomRight",
	        overlay: menus,
	        visible: this.getDropdownVisible(),
	        onVisibleChange: this.onVisibleChange,
	        getPopupContainer: getPopupContainer,
	        forceRender: true
	      }, this.renderFilterIcon());
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var column = nextProps.column;
	      var prevProps = prevState.prevProps;
	      var newState = {
	        prevProps: nextProps
	      };
	      /**
	       * if the state is visible the component should ignore updates on selectedKeys prop to avoid
	       * that the user selection is lost
	       * this happens frequently when a table is connected on some sort of realtime data
	       * Fixes https://github.com/ant-design/ant-design/issues/10289 and
	       * https://github.com/ant-design/ant-design/issues/10209
	       */
	
	      if ('selectedKeys' in nextProps && !(0, _shallowequal["default"])(prevProps.selectedKeys, nextProps.selectedKeys)) {
	        newState.selectedKeys = nextProps.selectedKeys;
	      }
	
	      if (!(0, _shallowequal["default"])((prevProps.column || {}).filters, (nextProps.column || {}).filters)) {
	        newState.valueKeys = (0, _util.generateValueMaps)(nextProps.column.filters);
	      }
	
	      if ('filterDropdownVisible' in column) {
	        newState.visible = column.filterDropdownVisible;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return FilterMenu;
	}(React.Component);
	
	FilterMenu.defaultProps = {
	  column: {}
	};
	(0, _reactLifecyclesCompat.polyfill)(FilterMenu);
	var _default = FilterMenu;
	exports["default"] = _default;

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Table = _interopRequireDefault(__webpack_require__(1328));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _Table["default"];
	exports["default"] = _default;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _ScrollableInkTabBar = _interopRequireDefault(__webpack_require__(2738));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var TabBar = /*#__PURE__*/function (_React$Component) {
	  _inherits(TabBar, _React$Component);
	
	  var _super = _createSuper(TabBar);
	
	  function TabBar() {
	    _classCallCheck(this, TabBar);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(TabBar, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          tabBarStyle = _this$props.tabBarStyle,
	          animated = _this$props.animated,
	          renderTabBar = _this$props.renderTabBar,
	          tabBarExtraContent = _this$props.tabBarExtraContent,
	          tabPosition = _this$props.tabPosition,
	          prefixCls = _this$props.prefixCls,
	          className = _this$props.className,
	          size = _this$props.size,
	          type = _this$props.type;
	      var inkBarAnimated = _typeof(animated) === 'object' ? animated.inkBar : animated;
	      var isVertical = tabPosition === 'left' || tabPosition === 'right';
	      var prevIconType = isVertical ? 'up' : 'left';
	      var nextIconType = isVertical ? 'down' : 'right';
	      var prevIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-tab-prev-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: prevIconType,
	        className: "".concat(prefixCls, "-tab-prev-icon-target")
	      }));
	      var nextIcon = /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-tab-next-icon")
	      }, /*#__PURE__*/React.createElement(_icon["default"], {
	        type: nextIconType,
	        className: "".concat(prefixCls, "-tab-next-icon-target")
	      })); // Additional className for style usage
	
	      var cls = (0, _classnames["default"])("".concat(prefixCls, "-").concat(tabPosition, "-bar"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size, "-bar"), !!size), _defineProperty(_classNames, "".concat(prefixCls, "-card-bar"), type && type.indexOf('card') >= 0), _classNames), className);
	
	      var renderProps = _extends(_extends({}, this.props), {
	        children: null,
	        inkBarAnimated: inkBarAnimated,
	        extraContent: tabBarExtraContent,
	        style: tabBarStyle,
	        prevIcon: prevIcon,
	        nextIcon: nextIcon,
	        className: cls
	      });
	
	      var RenderTabBar;
	
	      if (renderTabBar) {
	        RenderTabBar = renderTabBar(renderProps, _ScrollableInkTabBar["default"]);
	      } else {
	        RenderTabBar = /*#__PURE__*/React.createElement(_ScrollableInkTabBar["default"], renderProps);
	      }
	
	      return /*#__PURE__*/React.cloneElement(RenderTabBar);
	    }
	  }]);
	
	  return TabBar;
	}(React.Component);
	
	exports["default"] = TabBar;
	TabBar.defaultProps = {
	  animated: true,
	  type: 'line'
	};

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var CheckableTag = /*#__PURE__*/function (_React$Component) {
	  _inherits(CheckableTag, _React$Component);
	
	  var _super = _createSuper(CheckableTag);
	
	  function CheckableTag() {
	    var _this;
	
	    _classCallCheck(this, CheckableTag);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleClick = function () {
	      var _this$props = _this.props,
	          checked = _this$props.checked,
	          onChange = _this$props.onChange;
	
	      if (onChange) {
	        onChange(!checked);
	      }
	    };
	
	    _this.renderCheckableTag = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          checked = _a.checked,
	          restProps = __rest(_a, ["prefixCls", "className", "checked"]);
	
	      var prefixCls = getPrefixCls('tag', customizePrefixCls);
	      var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-checkable"), true), _defineProperty(_classNames, "".concat(prefixCls, "-checkable-checked"), checked), _classNames), className);
	      delete restProps.onChange; // TypeScript cannot check delete now.
	
	      return /*#__PURE__*/React.createElement("span", _extends({}, restProps, {
	        className: cls,
	        onClick: _this.handleClick
	      }));
	    };
	
	    return _this;
	  }
	
	  _createClass(CheckableTag, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCheckableTag);
	    }
	  }]);
	
	  return CheckableTag;
	}(React.Component);
	
	exports["default"] = CheckableTag;

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _TimelineItem = _interopRequireDefault(__webpack_require__(1336));
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Timeline = /*#__PURE__*/function (_React$Component) {
	  _inherits(Timeline, _React$Component);
	
	  var _super = _createSuper(Timeline);
	
	  function Timeline() {
	    var _this;
	
	    _classCallCheck(this, Timeline);
	
	    _this = _super.apply(this, arguments);
	
	    _this.renderTimeline = function (_ref) {
	      var _classNames;
	
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          _a$pending = _a.pending,
	          pending = _a$pending === void 0 ? null : _a$pending,
	          pendingDot = _a.pendingDot,
	          children = _a.children,
	          className = _a.className,
	          reverse = _a.reverse,
	          mode = _a.mode,
	          restProps = __rest(_a, ["prefixCls", "pending", "pendingDot", "children", "className", "reverse", "mode"]);
	
	      var prefixCls = getPrefixCls('timeline', customizePrefixCls);
	      var pendingNode = typeof pending === 'boolean' ? null : pending;
	      var classString = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-pending"), !!pending), _defineProperty(_classNames, "".concat(prefixCls, "-reverse"), !!reverse), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(mode), !!mode), _classNames), className);
	      var pendingItem = pending ? /*#__PURE__*/React.createElement(_TimelineItem["default"], {
	        pending: !!pending,
	        dot: pendingDot || /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "loading"
	        })
	      }, pendingNode) : null;
	      var timeLineItems = reverse ? [pendingItem].concat(_toConsumableArray(React.Children.toArray(children).reverse())) : [].concat(_toConsumableArray(React.Children.toArray(children)), [pendingItem]);
	
	      var getPositionCls = function getPositionCls(ele, idx) {
	        if (mode === 'alternate') {
	          if (ele.props.position === 'right') return "".concat(prefixCls, "-item-right");
	          if (ele.props.position === 'left') return "".concat(prefixCls, "-item-left");
	          return idx % 2 === 0 ? "".concat(prefixCls, "-item-left") : "".concat(prefixCls, "-item-right");
	        }
	
	        if (mode === 'left') return "".concat(prefixCls, "-item-left");
	        if (mode === 'right') return "".concat(prefixCls, "-item-right");
	        if (ele.props.position === 'right') return "".concat(prefixCls, "-item-right");
	        return '';
	      }; // Remove falsy items
	
	
	      var truthyItems = timeLineItems.filter(function (item) {
	        return !!item;
	      });
	      var itemsCount = React.Children.count(truthyItems);
	      var lastCls = "".concat(prefixCls, "-item-last");
	      var items = React.Children.map(truthyItems, function (ele, idx) {
	        var pendingClass = idx === itemsCount - 2 ? lastCls : '';
	        var readyClass = idx === itemsCount - 1 ? lastCls : '';
	        return /*#__PURE__*/React.cloneElement(ele, {
	          className: (0, _classnames["default"])([ele.props.className, !reverse && !!pending ? pendingClass : readyClass, getPositionCls(ele, idx)])
	        });
	      });
	      return /*#__PURE__*/React.createElement("ul", _extends({}, restProps, {
	        className: classString
	      }), items);
	    };
	
	    return _this;
	  }
	
	  _createClass(Timeline, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTimeline);
	    }
	  }]);
	
	  return Timeline;
	}(React.Component);
	
	exports["default"] = Timeline;
	Timeline.Item = _TimelineItem["default"];
	Timeline.defaultProps = {
	  reverse: false,
	  mode: ''
	};

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TimelineItem = function TimelineItem(props) {
	  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
	    var _classNames, _classNames2;
	
	    var getPrefixCls = _ref.getPrefixCls;
	
	    var customizePrefixCls = props.prefixCls,
	        className = props.className,
	        _props$color = props.color,
	        color = _props$color === void 0 ? '' : _props$color,
	        children = props.children,
	        pending = props.pending,
	        dot = props.dot,
	        restProps = __rest(props, ["prefixCls", "className", "color", "children", "pending", "dot"]);
	
	    var prefixCls = getPrefixCls('timeline', customizePrefixCls);
	    var itemClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-item-pending"), pending), _classNames), className);
	    var dotClassName = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-item-head"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-item-head-custom"), dot), _defineProperty(_classNames2, "".concat(prefixCls, "-item-head-").concat(color), true), _classNames2));
	    return /*#__PURE__*/React.createElement("li", _extends({}, (0, _omit["default"])(restProps, ['position']), {
	      className: itemClassName
	    }), /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-item-tail")
	    }), /*#__PURE__*/React.createElement("div", {
	      className: dotClassName,
	      style: {
	        borderColor: /blue|red|green|gray/.test(color) ? undefined : color
	      }
	    }, dot), /*#__PURE__*/React.createElement("div", {
	      className: "".concat(prefixCls, "-item-content")
	    }, children));
	  });
	};
	
	TimelineItem.defaultProps = {
	  color: 'blue',
	  pending: false,
	  position: ''
	};
	var _default = TimelineItem;
	exports["default"] = _default;

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Timeline = _interopRequireDefault(__webpack_require__(1335));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _Timeline["default"];
	exports["default"] = _default;

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOverflowOptions = getOverflowOptions;
	exports["default"] = getPlacements;
	
	var _placements = __webpack_require__(1110);
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var autoAdjustOverflowEnabled = {
	  adjustX: 1,
	  adjustY: 1
	};
	var autoAdjustOverflowDisabled = {
	  adjustX: 0,
	  adjustY: 0
	};
	var targetOffset = [0, 0];
	
	function getOverflowOptions(autoAdjustOverflow) {
	  if (typeof autoAdjustOverflow === 'boolean') {
	    return autoAdjustOverflow ? autoAdjustOverflowEnabled : autoAdjustOverflowDisabled;
	  }
	
	  return _extends(_extends({}, autoAdjustOverflowDisabled), autoAdjustOverflow);
	}
	
	function getPlacements() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$arrowWidth = config.arrowWidth,
	      arrowWidth = _config$arrowWidth === void 0 ? 5 : _config$arrowWidth,
	      _config$horizontalArr = config.horizontalArrowShift,
	      horizontalArrowShift = _config$horizontalArr === void 0 ? 16 : _config$horizontalArr,
	      _config$verticalArrow = config.verticalArrowShift,
	      verticalArrowShift = _config$verticalArrow === void 0 ? 12 : _config$verticalArrow,
	      _config$autoAdjustOve = config.autoAdjustOverflow,
	      autoAdjustOverflow = _config$autoAdjustOve === void 0 ? true : _config$autoAdjustOve;
	  var placementMap = {
	    left: {
	      points: ['cr', 'cl'],
	      offset: [-4, 0]
	    },
	    right: {
	      points: ['cl', 'cr'],
	      offset: [4, 0]
	    },
	    top: {
	      points: ['bc', 'tc'],
	      offset: [0, -4]
	    },
	    bottom: {
	      points: ['tc', 'bc'],
	      offset: [0, 4]
	    },
	    topLeft: {
	      points: ['bl', 'tc'],
	      offset: [-(horizontalArrowShift + arrowWidth), -4]
	    },
	    leftTop: {
	      points: ['tr', 'cl'],
	      offset: [-4, -(verticalArrowShift + arrowWidth)]
	    },
	    topRight: {
	      points: ['br', 'tc'],
	      offset: [horizontalArrowShift + arrowWidth, -4]
	    },
	    rightTop: {
	      points: ['tl', 'cr'],
	      offset: [4, -(verticalArrowShift + arrowWidth)]
	    },
	    bottomRight: {
	      points: ['tr', 'bc'],
	      offset: [horizontalArrowShift + arrowWidth, 4]
	    },
	    rightBottom: {
	      points: ['bl', 'cr'],
	      offset: [4, verticalArrowShift + arrowWidth]
	    },
	    bottomLeft: {
	      points: ['tl', 'bc'],
	      offset: [-(horizontalArrowShift + arrowWidth), 4]
	    },
	    leftBottom: {
	      points: ['br', 'cl'],
	      offset: [-4, verticalArrowShift + arrowWidth]
	    }
	  };
	  Object.keys(placementMap).forEach(function (key) {
	    placementMap[key] = config.arrowPointAtCenter ? _extends(_extends({}, placementMap[key]), {
	      overflow: getOverflowOptions(autoAdjustOverflow),
	      targetOffset: targetOffset
	    }) : _extends(_extends({}, _placements.placements[key]), {
	      overflow: getOverflowOptions(autoAdjustOverflow)
	    });
	    placementMap[key].ignoreShake = true;
	  });
	  return placementMap;
	}

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _PureRenderMixin = _interopRequireDefault(__webpack_require__(1124));
	
	var _reactLazyLoad = _interopRequireDefault(__webpack_require__(2845));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(226));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var ListItem = /*#__PURE__*/function (_React$Component) {
	  _inherits(ListItem, _React$Component);
	
	  var _super = _createSuper(ListItem);
	
	  function ListItem() {
	    _classCallCheck(this, ListItem);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ListItem, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _PureRenderMixin["default"].shouldComponentUpdate.apply(this, args);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props = this.props,
	          renderedText = _this$props.renderedText,
	          renderedEl = _this$props.renderedEl,
	          item = _this$props.item,
	          lazy = _this$props.lazy,
	          checked = _this$props.checked,
	          disabled = _this$props.disabled,
	          prefixCls = _this$props.prefixCls,
	          onClick = _this$props.onClick;
	      var className = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-content-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-content-item-disabled"), disabled || item.disabled), _classNames));
	      var title;
	
	      if (typeof renderedText === 'string' || typeof renderedText === 'number') {
	        title = String(renderedText);
	      }
	
	      var listItem = /*#__PURE__*/React.createElement("li", {
	        className: className,
	        title: title,
	        onClick: disabled || item.disabled ? undefined : function () {
	          return onClick(item);
	        }
	      }, /*#__PURE__*/React.createElement(_checkbox["default"], {
	        checked: checked,
	        disabled: disabled || item.disabled
	      }), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-content-item-text")
	      }, renderedEl));
	      var children = null;
	
	      if (lazy) {
	        var lazyProps = _extends({
	          height: 32,
	          offset: 500,
	          throttle: 0,
	          debounce: false
	        }, lazy);
	
	        children = /*#__PURE__*/React.createElement(_reactLazyLoad["default"], lazyProps, listItem);
	      } else {
	        children = listItem;
	      }
	
	      return children;
	    }
	  }]);
	
	  return ListItem;
	}(React.Component);
	
	exports["default"] = ListItem;

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _list = _interopRequireDefault(__webpack_require__(1341));
	
	var _operation = _interopRequireDefault(__webpack_require__(1342));
	
	var _search = _interopRequireDefault(__webpack_require__(646));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _LocaleReceiver = _interopRequireDefault(__webpack_require__(81));
	
	var _default2 = _interopRequireDefault(__webpack_require__(227));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Transfer = /*#__PURE__*/function (_React$Component) {
	  _inherits(Transfer, _React$Component);
	
	  var _super = _createSuper(Transfer);
	
	  function Transfer(props) {
	    var _this;
	
	    _classCallCheck(this, Transfer);
	
	    _this = _super.call(this, props);
	    _this.separatedDataSource = null;
	
	    _this.getLocale = function (transferLocale, renderEmpty) {
	      // Keep old locale props still working.
	      var oldLocale = {
	        notFoundContent: renderEmpty('Transfer')
	      };
	
	      if ('notFoundContent' in _this.props) {
	        oldLocale.notFoundContent = _this.props.notFoundContent;
	      }
	
	      if ('searchPlaceholder' in _this.props) {
	        oldLocale.searchPlaceholder = _this.props.searchPlaceholder;
	      }
	
	      return _extends(_extends(_extends({}, transferLocale), oldLocale), _this.props.locale);
	    };
	
	    _this.moveTo = function (direction) {
	      var _this$props = _this.props,
	          _this$props$targetKey = _this$props.targetKeys,
	          targetKeys = _this$props$targetKey === void 0 ? [] : _this$props$targetKey,
	          _this$props$dataSourc = _this$props.dataSource,
	          dataSource = _this$props$dataSourc === void 0 ? [] : _this$props$dataSourc,
	          onChange = _this$props.onChange;
	      var _this$state = _this.state,
	          sourceSelectedKeys = _this$state.sourceSelectedKeys,
	          targetSelectedKeys = _this$state.targetSelectedKeys;
	      var moveKeys = direction === 'right' ? sourceSelectedKeys : targetSelectedKeys; // filter the disabled options
	
	      var newMoveKeys = moveKeys.filter(function (key) {
	        return !dataSource.some(function (data) {
	          return !!(key === data.key && data.disabled);
	        });
	      }); // move items to target box
	
	      var newTargetKeys = direction === 'right' ? newMoveKeys.concat(targetKeys) : targetKeys.filter(function (targetKey) {
	        return newMoveKeys.indexOf(targetKey) === -1;
	      }); // empty checked keys
	
	      var oppositeDirection = direction === 'right' ? 'left' : 'right';
	
	      _this.setState(_defineProperty({}, _this.getSelectedKeysName(oppositeDirection), []));
	
	      _this.handleSelectChange(oppositeDirection, []);
	
	      if (onChange) {
	        onChange(newTargetKeys, direction, newMoveKeys);
	      }
	    };
	
	    _this.moveToLeft = function () {
	      return _this.moveTo('left');
	    };
	
	    _this.moveToRight = function () {
	      return _this.moveTo('right');
	    };
	
	    _this.onItemSelectAll = function (direction, selectedKeys, checkAll) {
	      var originalSelectedKeys = _this.state[_this.getSelectedKeysName(direction)] || [];
	      var mergedCheckedKeys = [];
	
	      if (checkAll) {
	        // Merge current keys with origin key
	        mergedCheckedKeys = Array.from(new Set([].concat(_toConsumableArray(originalSelectedKeys), _toConsumableArray(selectedKeys))));
	      } else {
	        // Remove current keys from origin keys
	        mergedCheckedKeys = originalSelectedKeys.filter(function (key) {
	          return selectedKeys.indexOf(key) === -1;
	        });
	      }
	
	      _this.handleSelectChange(direction, mergedCheckedKeys);
	
	      if (!_this.props.selectedKeys) {
	        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), mergedCheckedKeys));
	      }
	    };
	
	    _this.handleSelectAll = function (direction, filteredDataSource, checkAll) {
	      (0, _warning["default"])(false, 'Transfer', '`handleSelectAll` will be removed, please use `onSelectAll` instead.');
	
	      _this.onItemSelectAll(direction, filteredDataSource.map(function (_ref) {
	        var key = _ref.key;
	        return key;
	      }), !checkAll);
	    }; // [Legacy] Old prop `body` pass origin check as arg. It's confusing.
	    // TODO: Remove this in next version.
	
	
	    _this.handleLeftSelectAll = function (filteredDataSource, checkAll) {
	      return _this.handleSelectAll('left', filteredDataSource, !checkAll);
	    };
	
	    _this.handleRightSelectAll = function (filteredDataSource, checkAll) {
	      return _this.handleSelectAll('right', filteredDataSource, !checkAll);
	    };
	
	    _this.onLeftItemSelectAll = function (selectedKeys, checkAll) {
	      return _this.onItemSelectAll('left', selectedKeys, checkAll);
	    };
	
	    _this.onRightItemSelectAll = function (selectedKeys, checkAll) {
	      return _this.onItemSelectAll('right', selectedKeys, checkAll);
	    };
	
	    _this.handleFilter = function (direction, e) {
	      var _this$props2 = _this.props,
	          onSearchChange = _this$props2.onSearchChange,
	          onSearch = _this$props2.onSearch;
	      var value = e.target.value;
	
	      if (onSearchChange) {
	        (0, _warning["default"])(false, 'Transfer', '`onSearchChange` is deprecated. Please use `onSearch` instead.');
	        onSearchChange(direction, e);
	      }
	
	      if (onSearch) {
	        onSearch(direction, value);
	      }
	    };
	
	    _this.handleLeftFilter = function (e) {
	      return _this.handleFilter('left', e);
	    };
	
	    _this.handleRightFilter = function (e) {
	      return _this.handleFilter('right', e);
	    };
	
	    _this.handleClear = function (direction) {
	      var onSearch = _this.props.onSearch;
	
	      if (onSearch) {
	        onSearch(direction, '');
	      }
	    };
	
	    _this.handleLeftClear = function () {
	      return _this.handleClear('left');
	    };
	
	    _this.handleRightClear = function () {
	      return _this.handleClear('right');
	    };
	
	    _this.onItemSelect = function (direction, selectedKey, checked) {
	      var _this$state2 = _this.state,
	          sourceSelectedKeys = _this$state2.sourceSelectedKeys,
	          targetSelectedKeys = _this$state2.targetSelectedKeys;
	      var holder = direction === 'left' ? _toConsumableArray(sourceSelectedKeys) : _toConsumableArray(targetSelectedKeys);
	      var index = holder.indexOf(selectedKey);
	
	      if (index > -1) {
	        holder.splice(index, 1);
	      }
	
	      if (checked) {
	        holder.push(selectedKey);
	      }
	
	      _this.handleSelectChange(direction, holder);
	
	      if (!_this.props.selectedKeys) {
	        _this.setState(_defineProperty({}, _this.getSelectedKeysName(direction), holder));
	      }
	    };
	
	    _this.handleSelect = function (direction, selectedItem, checked) {
	      (0, _warning["default"])(false, 'Transfer', '`handleSelect` will be removed, please use `onSelect` instead.');
	
	      _this.onItemSelect(direction, selectedItem.key, checked);
	    };
	
	    _this.handleLeftSelect = function (selectedItem, checked) {
	      return _this.handleSelect('left', selectedItem, checked);
	    };
	
	    _this.handleRightSelect = function (selectedItem, checked) {
	      return _this.handleSelect('right', selectedItem, checked);
	    };
	
	    _this.onLeftItemSelect = function (selectedKey, checked) {
	      return _this.onItemSelect('left', selectedKey, checked);
	    };
	
	    _this.onRightItemSelect = function (selectedKey, checked) {
	      return _this.onItemSelect('right', selectedKey, checked);
	    };
	
	    _this.handleScroll = function (direction, e) {
	      var onScroll = _this.props.onScroll;
	
	      if (onScroll) {
	        onScroll(direction, e);
	      }
	    };
	
	    _this.handleLeftScroll = function (e) {
	      return _this.handleScroll('left', e);
	    };
	
	    _this.handleRightScroll = function (e) {
	      return _this.handleScroll('right', e);
	    };
	
	    _this.handleListStyle = function (listStyle, direction) {
	      if (typeof listStyle === 'function') {
	        return listStyle({
	          direction: direction
	        });
	      }
	
	      return listStyle;
	    };
	
	    _this.renderTransfer = function (transferLocale) {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref2) {
	        var _classNames;
	
	        var getPrefixCls = _ref2.getPrefixCls,
	            renderEmpty = _ref2.renderEmpty;
	        var _this$props3 = _this.props,
	            customizePrefixCls = _this$props3.prefixCls,
	            className = _this$props3.className,
	            disabled = _this$props3.disabled,
	            _this$props3$operatio = _this$props3.operations,
	            operations = _this$props3$operatio === void 0 ? [] : _this$props3$operatio,
	            showSearch = _this$props3.showSearch,
	            body = _this$props3.body,
	            footer = _this$props3.footer,
	            style = _this$props3.style,
	            listStyle = _this$props3.listStyle,
	            operationStyle = _this$props3.operationStyle,
	            filterOption = _this$props3.filterOption,
	            render = _this$props3.render,
	            lazy = _this$props3.lazy,
	            children = _this$props3.children,
	            showSelectAll = _this$props3.showSelectAll;
	        var prefixCls = getPrefixCls('transfer', customizePrefixCls);
	
	        var locale = _this.getLocale(transferLocale, renderEmpty);
	
	        var _this$state3 = _this.state,
	            sourceSelectedKeys = _this$state3.sourceSelectedKeys,
	            targetSelectedKeys = _this$state3.targetSelectedKeys;
	
	        var _this$separateDataSou = _this.separateDataSource(),
	            leftDataSource = _this$separateDataSou.leftDataSource,
	            rightDataSource = _this$separateDataSou.rightDataSource;
	
	        var leftActive = targetSelectedKeys.length > 0;
	        var rightActive = sourceSelectedKeys.length > 0;
	        var cls = (0, _classnames["default"])(className, prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames, "".concat(prefixCls, "-customize-list"), !!children), _classNames));
	
	        var titles = _this.getTitles(locale);
	
	        return /*#__PURE__*/React.createElement("div", {
	          className: cls,
	          style: style
	        }, /*#__PURE__*/React.createElement(_list["default"], _extends({
	          prefixCls: "".concat(prefixCls, "-list"),
	          titleText: titles[0],
	          dataSource: leftDataSource,
	          filterOption: filterOption,
	          style: _this.handleListStyle(listStyle, 'left'),
	          checkedKeys: sourceSelectedKeys,
	          handleFilter: _this.handleLeftFilter,
	          handleClear: _this.handleLeftClear,
	          handleSelect: _this.handleLeftSelect,
	          handleSelectAll: _this.handleLeftSelectAll,
	          onItemSelect: _this.onLeftItemSelect,
	          onItemSelectAll: _this.onLeftItemSelectAll,
	          render: render,
	          showSearch: showSearch,
	          body: body,
	          renderList: children,
	          footer: footer,
	          lazy: lazy,
	          onScroll: _this.handleLeftScroll,
	          disabled: disabled,
	          direction: "left",
	          showSelectAll: showSelectAll
	        }, locale)), /*#__PURE__*/React.createElement(_operation["default"], {
	          className: "".concat(prefixCls, "-operation"),
	          rightActive: rightActive,
	          rightArrowText: operations[0],
	          moveToRight: _this.moveToRight,
	          leftActive: leftActive,
	          leftArrowText: operations[1],
	          moveToLeft: _this.moveToLeft,
	          style: operationStyle,
	          disabled: disabled
	        }), /*#__PURE__*/React.createElement(_list["default"], _extends({
	          prefixCls: "".concat(prefixCls, "-list"),
	          titleText: titles[1],
	          dataSource: rightDataSource,
	          filterOption: filterOption,
	          style: _this.handleListStyle(listStyle, 'right'),
	          checkedKeys: targetSelectedKeys,
	          handleFilter: _this.handleRightFilter,
	          handleClear: _this.handleRightClear,
	          handleSelect: _this.handleRightSelect,
	          handleSelectAll: _this.handleRightSelectAll,
	          onItemSelect: _this.onRightItemSelect,
	          onItemSelectAll: _this.onRightItemSelectAll,
	          render: render,
	          showSearch: showSearch,
	          body: body,
	          renderList: children,
	          footer: footer,
	          lazy: lazy,
	          onScroll: _this.handleRightScroll,
	          disabled: disabled,
	          direction: "right",
	          showSelectAll: showSelectAll
	        }, locale)));
	      });
	    };
	
	    (0, _warning["default"])(!('notFoundContent' in props || 'searchPlaceholder' in props), 'Transfer', '`notFoundContent` and `searchPlaceholder` will be removed, ' + 'please use `locale` instead.');
	    (0, _warning["default"])(!('body' in props), 'Transfer', '`body` is internal usage and will bre removed, please use `children` instead.');
	    var _props$selectedKeys = props.selectedKeys,
	        selectedKeys = _props$selectedKeys === void 0 ? [] : _props$selectedKeys,
	        _props$targetKeys = props.targetKeys,
	        targetKeys = _props$targetKeys === void 0 ? [] : _props$targetKeys;
	    _this.state = {
	      sourceSelectedKeys: selectedKeys.filter(function (key) {
	        return targetKeys.indexOf(key) === -1;
	      }),
	      targetSelectedKeys: selectedKeys.filter(function (key) {
	        return targetKeys.indexOf(key) > -1;
	      })
	    };
	    return _this;
	  }
	
	  _createClass(Transfer, [{
	    key: "getSelectedKeysName",
	    // eslint-disable-next-line
	    value: function getSelectedKeysName(direction) {
	      return direction === 'left' ? 'sourceSelectedKeys' : 'targetSelectedKeys';
	    }
	  }, {
	    key: "getTitles",
	    value: function getTitles(transferLocale) {
	      var props = this.props;
	
	      if (props.titles) {
	        return props.titles;
	      }
	
	      return transferLocale.titles;
	    }
	  }, {
	    key: "handleSelectChange",
	    value: function handleSelectChange(direction, holder) {
	      var _this$state4 = this.state,
	          sourceSelectedKeys = _this$state4.sourceSelectedKeys,
	          targetSelectedKeys = _this$state4.targetSelectedKeys;
	      var onSelectChange = this.props.onSelectChange;
	
	      if (!onSelectChange) {
	        return;
	      }
	
	      if (direction === 'left') {
	        onSelectChange(holder, targetSelectedKeys);
	      } else {
	        onSelectChange(sourceSelectedKeys, holder);
	      }
	    }
	  }, {
	    key: "separateDataSource",
	    value: function separateDataSource() {
	      var _this$props4 = this.props,
	          dataSource = _this$props4.dataSource,
	          rowKey = _this$props4.rowKey,
	          _this$props4$targetKe = _this$props4.targetKeys,
	          targetKeys = _this$props4$targetKe === void 0 ? [] : _this$props4$targetKe;
	      var leftDataSource = [];
	      var rightDataSource = new Array(targetKeys.length);
	      dataSource.forEach(function (record) {
	        if (rowKey) {
	          record.key = rowKey(record);
	        } // rightDataSource should be ordered by targetKeys
	        // leftDataSource should be ordered by dataSource
	
	
	        var indexOfKey = targetKeys.indexOf(record.key);
	
	        if (indexOfKey !== -1) {
	          rightDataSource[indexOfKey] = record;
	        } else {
	          leftDataSource.push(record);
	        }
	      });
	      return {
	        leftDataSource: leftDataSource,
	        rightDataSource: rightDataSource
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
	        componentName: "Transfer",
	        defaultLocale: _default2["default"].Transfer
	      }, this.renderTransfer);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      if (nextProps.selectedKeys) {
	        var targetKeys = nextProps.targetKeys || [];
	        return {
	          sourceSelectedKeys: nextProps.selectedKeys.filter(function (key) {
	            return !targetKeys.includes(key);
	          }),
	          targetSelectedKeys: nextProps.selectedKeys.filter(function (key) {
	            return targetKeys.includes(key);
	          })
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Transfer;
	}(React.Component); // For high-level customized Transfer @dqaria
	
	
	Transfer.List = _list["default"];
	Transfer.Operation = _operation["default"];
	Transfer.Search = _search["default"];
	Transfer.defaultProps = {
	  dataSource: [],
	  locale: {},
	  showSearch: false,
	  listStyle: function listStyle() {}
	};
	Transfer.propTypes = {
	  prefixCls: PropTypes.string,
	  disabled: PropTypes.bool,
	  dataSource: PropTypes.array,
	  render: PropTypes.func,
	  targetKeys: PropTypes.array,
	  onChange: PropTypes.func,
	  height: PropTypes.number,
	  style: PropTypes.object,
	  listStyle: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
	  operationStyle: PropTypes.object,
	  className: PropTypes.string,
	  titles: PropTypes.array,
	  operations: PropTypes.array,
	  showSearch: PropTypes.bool,
	  filterOption: PropTypes.func,
	  searchPlaceholder: PropTypes.string,
	  notFoundContent: PropTypes.node,
	  locale: PropTypes.object,
	  body: PropTypes.func,
	  footer: PropTypes.func,
	  rowKey: PropTypes.func,
	  lazy: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
	};
	(0, _reactLifecyclesCompat.polyfill)(Transfer);
	var _default = Transfer;
	exports["default"] = _default;

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _PureRenderMixin = _interopRequireDefault(__webpack_require__(1124));
	
	var _checkbox = _interopRequireDefault(__webpack_require__(226));
	
	var _search = _interopRequireDefault(__webpack_require__(646));
	
	var _renderListBody = _interopRequireWildcard(__webpack_require__(1343));
	
	var _triggerEvent = _interopRequireDefault(__webpack_require__(1229));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var defaultRender = function defaultRender() {
	  return null;
	};
	
	function isRenderResultPlainObject(result) {
	  return result && ! /*#__PURE__*/React.isValidElement(result) && Object.prototype.toString.call(result) === '[object Object]';
	}
	
	function renderListNode(renderList, props) {
	  var bodyContent = renderList ? renderList(props) : null;
	  var customize = !!bodyContent;
	
	  if (!customize) {
	    bodyContent = (0, _renderListBody["default"])(props);
	  }
	
	  return {
	    customize: customize,
	    bodyContent: bodyContent
	  };
	}
	
	var TransferList = /*#__PURE__*/function (_React$Component) {
	  _inherits(TransferList, _React$Component);
	
	  var _super = _createSuper(TransferList);
	
	  function TransferList(props) {
	    var _this;
	
	    _classCallCheck(this, TransferList);
	
	    _this = _super.call(this, props);
	
	    _this.handleFilter = function (e) {
	      var handleFilter = _this.props.handleFilter;
	      var filterValue = e.target.value;
	
	      _this.setState({
	        filterValue: filterValue
	      });
	
	      handleFilter(e);
	
	      if (!filterValue) {
	        return;
	      } // Manually trigger scroll event for lazy search bug
	      // https://github.com/ant-design/ant-design/issues/5631
	
	
	      _this.triggerScrollTimer = window.setTimeout(function () {
	        var transferNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	        var listNode = transferNode.querySelectorAll('.ant-transfer-list-content')[0];
	
	        if (listNode) {
	          (0, _triggerEvent["default"])(listNode, 'scroll');
	        }
	      }, 0);
	    };
	
	    _this.handleClear = function () {
	      var handleClear = _this.props.handleClear;
	
	      _this.setState({
	        filterValue: ''
	      });
	
	      handleClear();
	    };
	
	    _this.matchFilter = function (text, item) {
	      var filterValue = _this.state.filterValue;
	      var filterOption = _this.props.filterOption;
	
	      if (filterOption) {
	        return filterOption(filterValue, item);
	      }
	
	      return text.indexOf(filterValue) >= 0;
	    };
	
	    _this.renderItem = function (item) {
	      var _this$props$render = _this.props.render,
	          render = _this$props$render === void 0 ? defaultRender : _this$props$render;
	      var renderResult = render(item);
	      var isRenderResultPlain = isRenderResultPlainObject(renderResult);
	      return {
	        renderedText: isRenderResultPlain ? renderResult.value : renderResult,
	        renderedEl: isRenderResultPlain ? renderResult.label : renderResult,
	        item: item
	      };
	    };
	
	    _this.state = {
	      filterValue: ''
	    };
	    return _this;
	  }
	
	  _createClass(TransferList, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate() {
	      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _PureRenderMixin["default"].shouldComponentUpdate.apply(this, args);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      clearTimeout(this.triggerScrollTimer);
	    }
	  }, {
	    key: "getCheckStatus",
	    value: function getCheckStatus(filteredItems) {
	      var checkedKeys = this.props.checkedKeys;
	
	      if (checkedKeys.length === 0) {
	        return 'none';
	      }
	
	      if (filteredItems.every(function (item) {
	        return checkedKeys.indexOf(item.key) >= 0 || !!item.disabled;
	      })) {
	        return 'all';
	      }
	
	      return 'part';
	    }
	  }, {
	    key: "getFilteredItems",
	    value: function getFilteredItems(dataSource, filterValue) {
	      var _this2 = this;
	
	      var filteredItems = [];
	      var filteredRenderItems = [];
	      dataSource.forEach(function (item) {
	        var renderedItem = _this2.renderItem(item);
	
	        var renderedText = renderedItem.renderedText; // Filter skip
	
	        if (filterValue && filterValue.trim() && !_this2.matchFilter(renderedText, item)) {
	          return null;
	        }
	
	        filteredItems.push(item);
	        filteredRenderItems.push(renderedItem);
	      });
	      return {
	        filteredItems: filteredItems,
	        filteredRenderItems: filteredRenderItems
	      };
	    }
	  }, {
	    key: "getListBody",
	    value: function getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, bodyDom, filteredRenderItems, checkedKeys, renderList, showSearch, disabled) {
	      var search = showSearch ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-body-search-wrapper")
	      }, /*#__PURE__*/React.createElement(_search["default"], {
	        prefixCls: "".concat(prefixCls, "-search"),
	        onChange: this.handleFilter,
	        handleClear: this.handleClear,
	        placeholder: searchPlaceholder,
	        value: filterValue,
	        disabled: disabled
	      })) : null;
	      var listBody = bodyDom;
	
	      if (!listBody) {
	        var bodyNode;
	
	        var _renderListNode = renderListNode(renderList, _extends(_extends({}, (0, _omit["default"])(this.props, _renderListBody.OmitProps)), {
	          filteredItems: filteredItems,
	          filteredRenderItems: filteredRenderItems,
	          selectedKeys: checkedKeys
	        })),
	            bodyContent = _renderListNode.bodyContent,
	            customize = _renderListNode.customize; // We should wrap customize list body in a classNamed div to use flex layout.
	
	
	        if (customize) {
	          bodyNode = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-body-customize-wrapper")
	          }, bodyContent);
	        } else {
	          bodyNode = filteredItems.length ? bodyContent : /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-body-not-found")
	          }, notFoundContent);
	        }
	
	        listBody = /*#__PURE__*/React.createElement("div", {
	          className: (0, _classnames["default"])(showSearch ? "".concat(prefixCls, "-body ").concat(prefixCls, "-body-with-search") : "".concat(prefixCls, "-body"))
	        }, search, bodyNode);
	      }
	
	      return listBody;
	    }
	  }, {
	    key: "getCheckBox",
	    value: function getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled) {
	      var checkStatus = this.getCheckStatus(filteredItems);
	      var checkedAll = checkStatus === 'all';
	      var checkAllCheckbox = showSelectAll !== false && /*#__PURE__*/React.createElement(_checkbox["default"], {
	        disabled: disabled,
	        checked: checkedAll,
	        indeterminate: checkStatus === 'part',
	        onChange: function onChange() {
	          // Only select enabled items
	          onItemSelectAll(filteredItems.filter(function (item) {
	            return !item.disabled;
	          }).map(function (_ref) {
	            var key = _ref.key;
	            return key;
	          }), !checkedAll);
	        }
	      });
	      return checkAllCheckbox;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var filterValue = this.state.filterValue;
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          dataSource = _this$props.dataSource,
	          titleText = _this$props.titleText,
	          checkedKeys = _this$props.checkedKeys,
	          disabled = _this$props.disabled,
	          body = _this$props.body,
	          footer = _this$props.footer,
	          showSearch = _this$props.showSearch,
	          style = _this$props.style,
	          searchPlaceholder = _this$props.searchPlaceholder,
	          notFoundContent = _this$props.notFoundContent,
	          itemUnit = _this$props.itemUnit,
	          itemsUnit = _this$props.itemsUnit,
	          renderList = _this$props.renderList,
	          onItemSelectAll = _this$props.onItemSelectAll,
	          showSelectAll = _this$props.showSelectAll; // Custom Layout
	
	      var footerDom = footer && footer(this.props);
	      var bodyDom = body && body(this.props);
	      var listCls = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-with-footer"), !!footerDom)); // ====================== Get filtered, checked item list ======================
	
	      var _this$getFilteredItem = this.getFilteredItems(dataSource, filterValue),
	          filteredItems = _this$getFilteredItem.filteredItems,
	          filteredRenderItems = _this$getFilteredItem.filteredRenderItems; // ================================= List Body =================================
	
	
	      var unit = dataSource.length > 1 ? itemsUnit : itemUnit;
	      var listBody = this.getListBody(prefixCls, searchPlaceholder, filterValue, filteredItems, notFoundContent, bodyDom, filteredRenderItems, checkedKeys, renderList, showSearch, disabled); // ================================ List Footer ================================
	
	      var listFooter = footerDom ? /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-footer")
	      }, footerDom) : null;
	      var checkAllCheckbox = this.getCheckBox(filteredItems, onItemSelectAll, showSelectAll, disabled); // ================================== Render ===================================
	
	      return /*#__PURE__*/React.createElement("div", {
	        className: listCls,
	        style: style
	      }, /*#__PURE__*/React.createElement("div", {
	        className: "".concat(prefixCls, "-header")
	      }, checkAllCheckbox, /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-header-selected")
	      }, /*#__PURE__*/React.createElement("span", null, (checkedKeys.length > 0 ? "".concat(checkedKeys.length, "/") : '') + filteredItems.length, ' ', unit), /*#__PURE__*/React.createElement("span", {
	        className: "".concat(prefixCls, "-header-title")
	      }, titleText))), listBody, listFooter);
	    }
	  }]);
	
	  return TransferList;
	}(React.Component);
	
	exports["default"] = TransferList;
	TransferList.defaultProps = {
	  dataSource: [],
	  titleText: '',
	  showSearch: false,
	  lazy: {}
	};

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _button = _interopRequireDefault(__webpack_require__(189));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Operation = function Operation(_ref) {
	  var disabled = _ref.disabled,
	      moveToLeft = _ref.moveToLeft,
	      moveToRight = _ref.moveToRight,
	      _ref$leftArrowText = _ref.leftArrowText,
	      leftArrowText = _ref$leftArrowText === void 0 ? '' : _ref$leftArrowText,
	      _ref$rightArrowText = _ref.rightArrowText,
	      rightArrowText = _ref$rightArrowText === void 0 ? '' : _ref$rightArrowText,
	      leftActive = _ref.leftActive,
	      rightActive = _ref.rightActive,
	      className = _ref.className,
	      style = _ref.style;
	  return /*#__PURE__*/React.createElement("div", {
	    className: className,
	    style: style
	  }, /*#__PURE__*/React.createElement(_button["default"], {
	    type: "primary",
	    size: "small",
	    disabled: disabled || !rightActive,
	    onClick: moveToRight,
	    icon: "right"
	  }, rightArrowText), /*#__PURE__*/React.createElement(_button["default"], {
	    type: "primary",
	    size: "small",
	    disabled: disabled || !leftActive,
	    onClick: moveToLeft,
	    icon: "left"
	  }, leftArrowText));
	};
	
	var _default = Operation;
	exports["default"] = _default;

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.OmitProps = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(23);
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(111));
	
	var _raf = _interopRequireDefault(__webpack_require__(268));
	
	var _type = __webpack_require__(87);
	
	var _ListItem = _interopRequireDefault(__webpack_require__(1339));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var OmitProps = (0, _type.tuple)('handleFilter', 'handleSelect', 'handleSelectAll', 'handleClear', 'body', 'checkedKeys');
	exports.OmitProps = OmitProps;
	
	var ListBody = /*#__PURE__*/function (_React$Component) {
	  _inherits(ListBody, _React$Component);
	
	  var _super = _createSuper(ListBody);
	
	  function ListBody() {
	    var _this;
	
	    _classCallCheck(this, ListBody);
	
	    _this = _super.apply(this, arguments);
	    _this.state = {
	      mounted: false
	    };
	
	    _this.onItemSelect = function (item) {
	      var _this$props = _this.props,
	          onItemSelect = _this$props.onItemSelect,
	          selectedKeys = _this$props.selectedKeys;
	      var checked = selectedKeys.indexOf(item.key) >= 0;
	      onItemSelect(item.key, !checked);
	    };
	
	    return _this;
	  }
	
	  _createClass(ListBody, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.mountId = (0, _raf["default"])(function () {
	        _this2.setState({
	          mounted: true
	        });
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props2 = this.props,
	          filteredRenderItems = _this$props2.filteredRenderItems,
	          lazy = _this$props2.lazy;
	
	      if (prevProps.filteredRenderItems.length !== filteredRenderItems.length && lazy !== false) {
	        // TODO: Replace this with ref when react 15 support removed.
	        var container = (0, _reactDom.findDOMNode)(this);
	
	        _raf["default"].cancel(this.lazyId);
	
	        this.lazyId = (0, _raf["default"])(function () {
	          if (container) {
	            var scrollEvent = new Event('scroll', {
	              bubbles: true
	            });
	            container.dispatchEvent(scrollEvent);
	          }
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      _raf["default"].cancel(this.mountId);
	
	      _raf["default"].cancel(this.lazyId);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var mounted = this.state.mounted;
	      var _this$props3 = this.props,
	          prefixCls = _this$props3.prefixCls,
	          onScroll = _this$props3.onScroll,
	          filteredRenderItems = _this$props3.filteredRenderItems,
	          lazy = _this$props3.lazy,
	          selectedKeys = _this$props3.selectedKeys,
	          globalDisabled = _this$props3.disabled;
	      return /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	        component: "ul",
	        componentProps: {
	          onScroll: onScroll
	        },
	        className: "".concat(prefixCls, "-content"),
	        transitionName: mounted ? "".concat(prefixCls, "-content-item-highlight") : '',
	        transitionLeave: false
	      }, filteredRenderItems.map(function (_ref) {
	        var renderedEl = _ref.renderedEl,
	            renderedText = _ref.renderedText,
	            item = _ref.item;
	        var disabled = item.disabled;
	        var checked = selectedKeys.indexOf(item.key) >= 0;
	        return /*#__PURE__*/React.createElement(_ListItem["default"], {
	          disabled: globalDisabled || disabled,
	          key: item.key,
	          item: item,
	          lazy: lazy,
	          renderedText: renderedText,
	          renderedEl: renderedEl,
	          checked: checked,
	          prefixCls: prefixCls,
	          onClick: _this3.onItemSelect
	        });
	      }));
	    }
	  }]);
	
	  return ListBody;
	}(React.Component);
	
	var ListBodyWrapper = function ListBodyWrapper(props) {
	  return /*#__PURE__*/React.createElement(ListBody, props);
	};
	
	var _default = ListBodyWrapper;
	exports["default"] = _default;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcTreeSelect = _interopRequireWildcard(__webpack_require__(2760));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _configProvider = __webpack_require__(11);
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _reactNode = __webpack_require__(614);
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TreeSelect = /*#__PURE__*/function (_React$Component) {
	  _inherits(TreeSelect, _React$Component);
	
	  var _super = _createSuper(TreeSelect);
	
	  function TreeSelect(props) {
	    var _this;
	
	    _classCallCheck(this, TreeSelect);
	
	    _this = _super.call(this, props);
	
	    _this.saveTreeSelect = function (node) {
	      _this.rcTreeSelect = node;
	    };
	
	    _this.renderSwitcherIcon = function (prefixCls, _ref) {
	      var isLeaf = _ref.isLeaf,
	          loading = _ref.loading;
	
	      if (loading) {
	        return /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "loading",
	          className: "".concat(prefixCls, "-switcher-loading-icon")
	        });
	      }
	
	      if (isLeaf) {
	        return null;
	      }
	
	      return /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "caret-down",
	        className: "".concat(prefixCls, "-switcher-icon")
	      });
	    };
	
	    _this.renderTreeSelect = function (_ref2) {
	      var _classNames;
	
	      var getContextPopupContainer = _ref2.getPopupContainer,
	          getPrefixCls = _ref2.getPrefixCls,
	          renderEmpty = _ref2.renderEmpty;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          size = _a.size,
	          notFoundContent = _a.notFoundContent,
	          dropdownStyle = _a.dropdownStyle,
	          dropdownClassName = _a.dropdownClassName,
	          suffixIcon = _a.suffixIcon,
	          removeIcon = _a.removeIcon,
	          clearIcon = _a.clearIcon,
	          getPopupContainer = _a.getPopupContainer,
	          restProps = __rest(_a, ["prefixCls", "className", "size", "notFoundContent", "dropdownStyle", "dropdownClassName", "suffixIcon", "removeIcon", "clearIcon", "getPopupContainer"]);
	
	      var rest = (0, _omit["default"])(restProps, ['inputIcon', 'removeIcon', 'clearIcon', 'switcherIcon']);
	      var prefixCls = getPrefixCls('select', customizePrefixCls);
	      var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _classNames), className); // showSearch: single - false, multiple - true
	
	      var showSearch = restProps.showSearch;
	
	      if (!('showSearch' in restProps)) {
	        showSearch = !!(restProps.multiple || restProps.treeCheckable);
	      }
	
	      var checkable = rest.treeCheckable;
	
	      if (checkable) {
	        checkable = /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-tree-checkbox-inner")
	        });
	      }
	
	      var inputIcon = suffixIcon ? (0, _reactNode.cloneElement)(suffixIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "down",
	        className: "".concat(prefixCls, "-arrow-icon")
	      });
	      var finalRemoveIcon = removeIcon ? (0, _reactNode.cloneElement)(removeIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close",
	        className: "".concat(prefixCls, "-remove-icon")
	      });
	      var finalClearIcon = clearIcon ? (0, _reactNode.cloneElement)(clearIcon) : /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "close-circle",
	        theme: "filled",
	        className: "".concat(prefixCls, "-clear-icon")
	      });
	      return /*#__PURE__*/React.createElement(_rcTreeSelect["default"], _extends({
	        switcherIcon: function switcherIcon(nodeProps) {
	          return _this.renderSwitcherIcon(prefixCls, nodeProps);
	        },
	        inputIcon: inputIcon,
	        removeIcon: finalRemoveIcon,
	        clearIcon: finalClearIcon
	      }, rest, {
	        showSearch: showSearch,
	        getPopupContainer: getPopupContainer || getContextPopupContainer,
	        dropdownClassName: (0, _classnames["default"])(dropdownClassName, "".concat(prefixCls, "-tree-dropdown")),
	        prefixCls: prefixCls,
	        className: cls,
	        dropdownStyle: _extends({
	          maxHeight: '100vh',
	          overflow: 'auto'
	        }, dropdownStyle),
	        treeCheckable: checkable,
	        notFoundContent: notFoundContent || renderEmpty('Select'),
	        ref: _this.saveTreeSelect
	      }));
	    };
	
	    (0, _warning["default"])(props.multiple !== false || !props.treeCheckable, 'TreeSelect', '`multiple` will alway be `true` when `treeCheckable` is true');
	    return _this;
	  }
	
	  _createClass(TreeSelect, [{
	    key: "focus",
	    value: function focus() {
	      this.rcTreeSelect.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.rcTreeSelect.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderTreeSelect);
	    }
	  }]);
	
	  return TreeSelect;
	}(React.Component);
	
	exports["default"] = TreeSelect;
	TreeSelect.TreeNode = _rcTreeSelect.TreeNode;
	TreeSelect.SHOW_ALL = _rcTreeSelect.SHOW_ALL;
	TreeSelect.SHOW_PARENT = _rcTreeSelect.SHOW_PARENT;
	TreeSelect.SHOW_CHILD = _rcTreeSelect.SHOW_CHILD;
	TreeSelect.defaultProps = {
	  transitionName: 'slide-up',
	  choiceTransitionName: 'zoom'
	};

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _omit = _interopRequireDefault(__webpack_require__(41));
	
	var _debounce = _interopRequireDefault(__webpack_require__(300));
	
	var _util = __webpack_require__(302);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _configProvider = __webpack_require__(11);
	
	var _Tree = _interopRequireDefault(__webpack_require__(647));
	
	var _util2 = __webpack_require__(1347);
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	function getIcon(props) {
	  var isLeaf = props.isLeaf,
	      expanded = props.expanded;
	
	  if (isLeaf) {
	    return /*#__PURE__*/React.createElement(_icon["default"], {
	      type: "file"
	    });
	  }
	
	  return /*#__PURE__*/React.createElement(_icon["default"], {
	    type: expanded ? 'folder-open' : 'folder'
	  });
	}
	
	var DirectoryTree = /*#__PURE__*/function (_React$Component) {
	  _inherits(DirectoryTree, _React$Component);
	
	  var _super = _createSuper(DirectoryTree);
	
	  function DirectoryTree(props) {
	    var _this;
	
	    _classCallCheck(this, DirectoryTree);
	
	    _this = _super.call(this, props);
	
	    _this.onExpand = function (expandedKeys, info) {
	      var onExpand = _this.props.onExpand;
	
	      _this.setUncontrolledState({
	        expandedKeys: expandedKeys
	      }); // Call origin function
	
	
	      if (onExpand) {
	        return onExpand(expandedKeys, info);
	      }
	
	      return undefined;
	    };
	
	    _this.onClick = function (event, node) {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          expandAction = _this$props.expandAction; // Expand the tree
	
	      if (expandAction === 'click') {
	        _this.onDebounceExpand(event, node);
	      }
	
	      if (onClick) {
	        onClick(event, node);
	      }
	    };
	
	    _this.onDoubleClick = function (event, node) {
	      var _this$props2 = _this.props,
	          onDoubleClick = _this$props2.onDoubleClick,
	          expandAction = _this$props2.expandAction; // Expand the tree
	
	      if (expandAction === 'doubleClick') {
	        _this.onDebounceExpand(event, node);
	      }
	
	      if (onDoubleClick) {
	        onDoubleClick(event, node);
	      }
	    };
	
	    _this.onSelect = function (keys, event) {
	      var _this$props3 = _this.props,
	          onSelect = _this$props3.onSelect,
	          multiple = _this$props3.multiple,
	          children = _this$props3.children;
	      var _this$state$expandedK = _this.state.expandedKeys,
	          expandedKeys = _this$state$expandedK === void 0 ? [] : _this$state$expandedK;
	      var node = event.node,
	          nativeEvent = event.nativeEvent;
	      var _node$props$eventKey = node.props.eventKey,
	          eventKey = _node$props$eventKey === void 0 ? '' : _node$props$eventKey;
	      var newState = {}; // We need wrap this event since some value is not same
	
	      var newEvent = _extends(_extends({}, event), {
	        selected: true
	      }); // Windows / Mac single pick
	
	
	      var ctrlPick = nativeEvent.ctrlKey || nativeEvent.metaKey;
	      var shiftPick = nativeEvent.shiftKey; // Generate new selected keys
	
	      var newSelectedKeys;
	
	      if (multiple && ctrlPick) {
	        // Control click
	        newSelectedKeys = keys;
	        _this.lastSelectedKey = eventKey;
	        _this.cachedSelectedKeys = newSelectedKeys;
	        newEvent.selectedNodes = (0, _util2.convertDirectoryKeysToNodes)(children, newSelectedKeys);
	      } else if (multiple && shiftPick) {
	        // Shift click
	        newSelectedKeys = Array.from(new Set([].concat(_toConsumableArray(_this.cachedSelectedKeys || []), _toConsumableArray((0, _util2.calcRangeKeys)(children, expandedKeys, eventKey, _this.lastSelectedKey)))));
	        newEvent.selectedNodes = (0, _util2.convertDirectoryKeysToNodes)(children, newSelectedKeys);
	      } else {
	        // Single click
	        newSelectedKeys = [eventKey];
	        _this.lastSelectedKey = eventKey;
	        _this.cachedSelectedKeys = newSelectedKeys;
	        newEvent.selectedNodes = [event.node];
	      }
	
	      newState.selectedKeys = newSelectedKeys;
	
	      if (onSelect) {
	        onSelect(newSelectedKeys, newEvent);
	      }
	
	      _this.setUncontrolledState(newState);
	    };
	
	    _this.setTreeRef = function (node) {
	      _this.tree = node;
	    };
	
	    _this.expandFolderNode = function (event, node) {
	      var isLeaf = node.props.isLeaf;
	
	      if (isLeaf || event.shiftKey || event.metaKey || event.ctrlKey) {
	        return;
	      } // Get internal rc-tree
	
	
	      var internalTree = _this.tree.tree; // Call internal rc-tree expand function
	      // https://github.com/ant-design/ant-design/issues/12567
	
	      internalTree.onNodeExpand(event, node);
	    };
	
	    _this.setUncontrolledState = function (state) {
	      var newState = (0, _omit["default"])(state, Object.keys(_this.props));
	
	      if (Object.keys(newState).length) {
	        _this.setState(newState);
	      }
	    };
	
	    _this.renderDirectoryTree = function (_ref) {
	      var getPrefixCls = _ref.getPrefixCls;
	
	      var _a = _this.props,
	          customizePrefixCls = _a.prefixCls,
	          className = _a.className,
	          props = __rest(_a, ["prefixCls", "className"]);
	
	      var _this$state = _this.state,
	          expandedKeys = _this$state.expandedKeys,
	          selectedKeys = _this$state.selectedKeys;
	      var prefixCls = getPrefixCls('tree', customizePrefixCls);
	      var connectClassName = (0, _classnames["default"])("".concat(prefixCls, "-directory"), className);
	      return /*#__PURE__*/React.createElement(_Tree["default"], _extends({
	        icon: getIcon,
	        ref: _this.setTreeRef
	      }, props, {
	        prefixCls: prefixCls,
	        className: connectClassName,
	        expandedKeys: expandedKeys,
	        selectedKeys: selectedKeys,
	        onSelect: _this.onSelect,
	        onClick: _this.onClick,
	        onDoubleClick: _this.onDoubleClick,
	        onExpand: _this.onExpand
	      }));
	    };
	
	    var defaultExpandAll = props.defaultExpandAll,
	        defaultExpandParent = props.defaultExpandParent,
	        expandedKeys = props.expandedKeys,
	        defaultExpandedKeys = props.defaultExpandedKeys,
	        children = props.children;
	
	    var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
	        keyEntities = _convertTreeToEntitie.keyEntities; // Selected keys
	
	
	    _this.state = {
	      selectedKeys: props.selectedKeys || props.defaultSelectedKeys || []
	    }; // Expanded keys
	
	    if (defaultExpandAll) {
	      if (props.treeData) {
	        _this.state.expandedKeys = (0, _util2.getFullKeyListByTreeData)(props.treeData);
	      } else {
	        _this.state.expandedKeys = (0, _util2.getFullKeyList)(props.children);
	      }
	    } else if (defaultExpandParent) {
	      _this.state.expandedKeys = (0, _util.conductExpandParent)(expandedKeys || defaultExpandedKeys, keyEntities);
	    } else {
	      _this.state.expandedKeys = expandedKeys || defaultExpandedKeys;
	    }
	
	    _this.onDebounceExpand = (0, _debounce["default"])(_this.expandFolderNode, 200, {
	      leading: true
	    });
	    return _this;
	  }
	
	  _createClass(DirectoryTree, [{
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderDirectoryTree);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	
	      if ('expandedKeys' in nextProps) {
	        newState.expandedKeys = nextProps.expandedKeys;
	      }
	
	      if ('selectedKeys' in nextProps) {
	        newState.selectedKeys = nextProps.selectedKeys;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return DirectoryTree;
	}(React.Component);
	
	DirectoryTree.defaultProps = {
	  showIcon: true,
	  expandAction: 'click'
	};
	(0, _reactLifecyclesCompat.polyfill)(DirectoryTree);
	var _default = DirectoryTree;
	exports["default"] = _default;

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Tree = _interopRequireDefault(__webpack_require__(647));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _Tree["default"];
	exports["default"] = _default;

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFullKeyList = getFullKeyList;
	exports.calcRangeKeys = calcRangeKeys;
	exports.convertDirectoryKeysToNodes = convertDirectoryKeysToNodes;
	exports.getFullKeyListByTreeData = getFullKeyListByTreeData;
	
	var _util = __webpack_require__(302);
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var Record;
	
	(function (Record) {
	  Record[Record["None"] = 0] = "None";
	  Record[Record["Start"] = 1] = "Start";
	  Record[Record["End"] = 2] = "End";
	})(Record || (Record = {})); // TODO: Move this logic into `rc-tree`
	
	
	function traverseNodesKey(rootChildren, callback) {
	  var nodeList = (0, _util.getNodeChildren)(rootChildren) || [];
	
	  function processNode(node) {
	    var key = node.key,
	        children = node.props.children;
	
	    if (callback(key, node) !== false) {
	      traverseNodesKey(children, callback);
	    }
	  }
	
	  nodeList.forEach(processNode);
	}
	
	function getFullKeyList(children) {
	  var _convertTreeToEntitie = (0, _util.convertTreeToEntities)(children),
	      keyEntities = _convertTreeToEntitie.keyEntities;
	
	  return Object.keys(keyEntities);
	}
	/** 计算选中范围，只考虑expanded情况以优化性能 */
	
	
	function calcRangeKeys(rootChildren, expandedKeys, startKey, endKey) {
	  var keys = [];
	  var record = Record.None;
	
	  if (startKey && startKey === endKey) {
	    return [startKey];
	  }
	
	  if (!startKey || !endKey) {
	    return [];
	  }
	
	  function matchKey(key) {
	    return key === startKey || key === endKey;
	  }
	
	  traverseNodesKey(rootChildren, function (key) {
	    if (record === Record.End) {
	      return false;
	    }
	
	    if (matchKey(key)) {
	      // Match test
	      keys.push(key);
	
	      if (record === Record.None) {
	        record = Record.Start;
	      } else if (record === Record.Start) {
	        record = Record.End;
	        return false;
	      }
	    } else if (record === Record.Start) {
	      // Append selection
	      keys.push(key);
	    }
	
	    if (expandedKeys.indexOf(key) === -1) {
	      return false;
	    }
	
	    return true;
	  });
	  return keys;
	}
	
	function convertDirectoryKeysToNodes(rootChildren, keys) {
	  var restKeys = _toConsumableArray(keys);
	
	  var nodes = [];
	  traverseNodesKey(rootChildren, function (key, node) {
	    var index = restKeys.indexOf(key);
	
	    if (index !== -1) {
	      nodes.push(node);
	      restKeys.splice(index, 1);
	    }
	
	    return !!restKeys.length;
	  });
	  return nodes;
	}
	
	function getFullKeyListByTreeData(treeData) {
	  var keys = [];
	  (treeData || []).forEach(function (item) {
	    keys.push(item.key);
	
	    if (item.children) {
	      keys = [].concat(_toConsumableArray(keys), _toConsumableArray(getFullKeyListByTreeData(item.children)));
	    }
	  });
	  return keys;
	}

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(71));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _TextArea = _interopRequireDefault(__webpack_require__(634));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Editable = /*#__PURE__*/function (_React$Component) {
	  _inherits(Editable, _React$Component);
	
	  var _super = _createSuper(Editable);
	
	  function Editable() {
	    var _this;
	
	    _classCallCheck(this, Editable);
	
	    _this = _super.apply(this, arguments);
	    _this.inComposition = false;
	    _this.state = {
	      current: ''
	    };
	
	    _this.onChange = function (_ref) {
	      var value = _ref.target.value;
	
	      _this.setState({
	        current: value.replace(/[\r\n]/g, '')
	      });
	    };
	
	    _this.onCompositionStart = function () {
	      _this.inComposition = true;
	    };
	
	    _this.onCompositionEnd = function () {
	      _this.inComposition = false;
	    };
	
	    _this.onKeyDown = function (_ref2) {
	      var keyCode = _ref2.keyCode;
	      // We don't record keyCode when IME is using
	      if (_this.inComposition) return;
	      _this.lastKeyCode = keyCode;
	    };
	
	    _this.onKeyUp = function (_ref3) {
	      var keyCode = _ref3.keyCode,
	          ctrlKey = _ref3.ctrlKey,
	          altKey = _ref3.altKey,
	          metaKey = _ref3.metaKey,
	          shiftKey = _ref3.shiftKey;
	      var onCancel = _this.props.onCancel; // Check if it's a real key
	
	      if (_this.lastKeyCode === keyCode && !_this.inComposition && !ctrlKey && !altKey && !metaKey && !shiftKey) {
	        if (keyCode === _KeyCode["default"].ENTER) {
	          _this.confirmChange();
	        } else if (keyCode === _KeyCode["default"].ESC) {
	          onCancel();
	        }
	      }
	    };
	
	    _this.onBlur = function () {
	      _this.confirmChange();
	    };
	
	    _this.confirmChange = function () {
	      var current = _this.state.current;
	      var onSave = _this.props.onSave;
	      onSave(current.trim());
	    };
	
	    _this.setTextarea = function (textarea) {
	      _this.textarea = textarea;
	    };
	
	    return _this;
	  }
	
	  _createClass(Editable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.textarea && this.textarea.resizableTextArea) {
	        var textArea = this.textarea.resizableTextArea.textArea;
	        textArea.focus();
	        var length = textArea.value.length;
	        textArea.setSelectionRange(length, length);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var current = this.state.current;
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          ariaLabel = _this$props['aria-label'],
	          className = _this$props.className,
	          style = _this$props.style;
	      return /*#__PURE__*/React.createElement("div", {
	        className: (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-edit-content"), className),
	        style: style
	      }, /*#__PURE__*/React.createElement(_TextArea["default"], {
	        ref: this.setTextarea,
	        value: current,
	        onChange: this.onChange,
	        onKeyDown: this.onKeyDown,
	        onKeyUp: this.onKeyUp,
	        onCompositionStart: this.onCompositionStart,
	        onCompositionEnd: this.onCompositionEnd,
	        onBlur: this.onBlur,
	        "aria-label": ariaLabel,
	        autoSize: true
	      }), /*#__PURE__*/React.createElement(_icon["default"], {
	        type: "enter",
	        className: "".concat(prefixCls, "-edit-content-confirm")
	      }));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var prevValue = prevState.prevValue;
	      var value = nextProps.value;
	      var newState = {
	        prevValue: value
	      };
	
	      if (prevValue !== value) {
	        newState.current = value;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Editable;
	}(React.Component);
	
	(0, _reactLifecyclesCompat.polyfill)(Editable);
	var _default = Editable;
	exports["default"] = _default;

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _Base = _interopRequireDefault(__webpack_require__(416));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var Paragraph = function Paragraph(props) {
	  return /*#__PURE__*/React.createElement(_Base["default"], _extends({}, props, {
	    component: "div"
	  }));
	};
	
	var _default = Paragraph;
	exports["default"] = _default;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(37));
	
	var _Base = _interopRequireDefault(__webpack_require__(416));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var Text = function Text(_a) {
	  var ellipsis = _a.ellipsis,
	      restProps = __rest(_a, ["ellipsis"]);
	
	  (0, _warning["default"])(_typeof(ellipsis) !== 'object', 'Typography.Text', '`ellipsis` only supports boolean value.');
	  return /*#__PURE__*/React.createElement(_Base["default"], _extends({}, restProps, {
	    ellipsis: !!ellipsis,
	    component: "span"
	  }));
	};
	
	var _default = Text;
	exports["default"] = _default;

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _warning = _interopRequireDefault(__webpack_require__(94));
	
	var _Base = _interopRequireDefault(__webpack_require__(416));
	
	var _type = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	var TITLE_ELE_LIST = (0, _type.tupleNum)(1, 2, 3, 4);
	
	var Title = function Title(props) {
	  var _props$level = props.level,
	      level = _props$level === void 0 ? 1 : _props$level,
	      restProps = __rest(props, ["level"]);
	
	  var component;
	
	  if (TITLE_ELE_LIST.indexOf(level) !== -1) {
	    component = "h".concat(level);
	  } else {
	    (0, _warning["default"])(false, 'Title only accept `1 | 2 | 3 | 4` as `level` value.');
	    component = 'h1';
	  }
	
	  return /*#__PURE__*/React.createElement(_Base["default"], _extends({}, restProps, {
	    component: component
	  }));
	};
	
	var _default = Title;
	exports["default"] = _default;

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Typography = _interopRequireDefault(__webpack_require__(648));
	
	var _Text = _interopRequireDefault(__webpack_require__(1350));
	
	var _Title = _interopRequireDefault(__webpack_require__(1351));
	
	var _Paragraph = _interopRequireDefault(__webpack_require__(1349));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var Typography = _Typography["default"];
	Typography.Text = _Text["default"];
	Typography.Title = _Title["default"];
	Typography.Paragraph = _Paragraph["default"];
	var _default = Typography;
	exports["default"] = _default;

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _reactDom = __webpack_require__(23);
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _toArray = _interopRequireDefault(__webpack_require__(112));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	// We only handle element & text node.
	var ELEMENT_NODE = 1;
	var TEXT_NODE = 3;
	var COMMENT_NODE = 8;
	var ellipsisContainer;
	var wrapperStyle = {
	  padding: 0,
	  margin: 0,
	  display: 'inline',
	  lineHeight: 'inherit'
	};
	
	function pxToNumber(value) {
	  if (!value) return 0;
	  var match = value.match(/^\d*(\.\d*)?/);
	  return match ? Number(match[0]) : 0;
	}
	
	function styleToString(style) {
	  // There are some different behavior between Firefox & Chrome.
	  // We have to handle this ourself.
	  var styleNames = Array.prototype.slice.apply(style);
	  return styleNames.map(function (name) {
	    return "".concat(name, ": ").concat(style.getPropertyValue(name), ";");
	  }).join('');
	}
	
	function mergeChildren(children) {
	  var childList = [];
	  children.forEach(function (child) {
	    var prevChild = childList[childList.length - 1];
	
	    if (typeof child === 'string' && typeof prevChild === 'string') {
	      childList[childList.length - 1] += child;
	    } else {
	      childList.push(child);
	    }
	  });
	  return childList;
	}
	
	var _default = function _default(originEle, rows, content, fixedContent, ellipsisStr) {
	  if (!ellipsisContainer) {
	    ellipsisContainer = document.createElement('div');
	    ellipsisContainer.setAttribute('aria-hidden', 'true');
	    document.body.appendChild(ellipsisContainer);
	  } // Get origin style
	
	
	  var originStyle = window.getComputedStyle(originEle);
	  var originCSS = styleToString(originStyle);
	  var lineHeight = pxToNumber(originStyle.lineHeight);
	  var maxHeight = lineHeight * (rows + 1) + pxToNumber(originStyle.paddingTop) + pxToNumber(originStyle.paddingBottom); // Set shadow
	
	  ellipsisContainer.setAttribute('style', originCSS);
	  ellipsisContainer.style.position = 'fixed';
	  ellipsisContainer.style.left = '0';
	  ellipsisContainer.style.height = 'auto';
	  ellipsisContainer.style.minHeight = 'auto';
	  ellipsisContainer.style.maxHeight = 'auto';
	  ellipsisContainer.style.top = '-999999px';
	  ellipsisContainer.style.zIndex = '-1000'; // clean up css overflow
	
	  ellipsisContainer.style.textOverflow = 'clip';
	  ellipsisContainer.style.whiteSpace = 'normal';
	  ellipsisContainer.style.webkitLineClamp = 'none'; // Render in the fake container
	
	  var contentList = mergeChildren((0, _toArray["default"])(content));
	  (0, _reactDom.render)( /*#__PURE__*/React.createElement("div", {
	    style: wrapperStyle
	  }, /*#__PURE__*/React.createElement("span", {
	    style: wrapperStyle
	  }, contentList), /*#__PURE__*/React.createElement("span", {
	    style: wrapperStyle
	  }, fixedContent)), ellipsisContainer); // wrap in an div for old version react
	  // Check if ellipsis in measure div is height enough for content
	
	  function inRange() {
	    return ellipsisContainer.offsetHeight < maxHeight;
	  } // Skip ellipsis if already match
	
	
	  if (inRange()) {
	    (0, _reactDom.unmountComponentAtNode)(ellipsisContainer);
	    return {
	      content: content,
	      text: ellipsisContainer.innerHTML,
	      ellipsis: false
	    };
	  } // We should clone the childNode since they're controlled by React and we can't reuse it without warning
	
	
	  var childNodes = Array.prototype.slice.apply(ellipsisContainer.childNodes[0].childNodes[0].cloneNode(true).childNodes).filter(function (_ref) {
	    var nodeType = _ref.nodeType;
	    return nodeType !== COMMENT_NODE;
	  });
	  var fixedNodes = Array.prototype.slice.apply(ellipsisContainer.childNodes[0].childNodes[1].cloneNode(true).childNodes);
	  (0, _reactDom.unmountComponentAtNode)(ellipsisContainer); // ========================= Find match ellipsis content =========================
	
	  var ellipsisChildren = [];
	  ellipsisContainer.innerHTML = ''; // Create origin content holder
	
	  var ellipsisContentHolder = document.createElement('span');
	  ellipsisContainer.appendChild(ellipsisContentHolder);
	  var ellipsisTextNode = document.createTextNode(ellipsisStr);
	  ellipsisContentHolder.appendChild(ellipsisTextNode);
	  fixedNodes.forEach(function (childNode) {
	    ellipsisContainer.appendChild(childNode);
	  }); // Append before fixed nodes
	
	  function appendChildNode(node) {
	    ellipsisContentHolder.insertBefore(node, ellipsisTextNode);
	  } // Get maximum text
	
	
	  function measureText(textNode, fullText) {
	    var startLoc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	    var endLoc = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : fullText.length;
	    var lastSuccessLoc = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	    var midLoc = Math.floor((startLoc + endLoc) / 2);
	    var currentText = fullText.slice(0, midLoc);
	    textNode.textContent = currentText;
	
	    if (startLoc >= endLoc - 1) {
	      // Loop when step is small
	      for (var step = endLoc; step >= startLoc; step -= 1) {
	        var currentStepText = fullText.slice(0, step);
	        textNode.textContent = currentStepText;
	
	        if (inRange()) {
	          return step === fullText.length ? {
	            finished: false,
	            reactNode: fullText
	          } : {
	            finished: true,
	            reactNode: currentStepText
	          };
	        }
	      }
	    }
	
	    if (inRange()) {
	      return measureText(textNode, fullText, midLoc, endLoc, midLoc);
	    }
	
	    return measureText(textNode, fullText, startLoc, midLoc, lastSuccessLoc);
	  }
	
	  function measureNode(childNode, index) {
	    var type = childNode.nodeType;
	
	    if (type === ELEMENT_NODE) {
	      // We don't split element, it will keep if whole element can be displayed.
	      appendChildNode(childNode);
	
	      if (inRange()) {
	        return {
	          finished: false,
	          reactNode: contentList[index]
	        };
	      } // Clean up if can not pull in
	
	
	      ellipsisContentHolder.removeChild(childNode);
	      return {
	        finished: true,
	        reactNode: null
	      };
	    }
	
	    if (type === TEXT_NODE) {
	      var fullText = childNode.textContent || '';
	      var textNode = document.createTextNode(fullText);
	      appendChildNode(textNode);
	      return measureText(textNode, fullText);
	    } // Not handle other type of content
	    // PS: This code should not be attached after react 16
	
	
	    return {
	      finished: false,
	      reactNode: null
	    };
	  }
	
	  childNodes.some(function (childNode, index) {
	    var _measureNode = measureNode(childNode, index),
	        finished = _measureNode.finished,
	        reactNode = _measureNode.reactNode;
	
	    if (reactNode) {
	      ellipsisChildren.push(reactNode);
	    }
	
	    return finished;
	  });
	  return {
	    content: ellipsisChildren,
	    text: ellipsisContainer.innerHTML,
	    ellipsis: true
	  };
	};
	
	exports["default"] = _default;

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _Upload = _interopRequireDefault(__webpack_require__(649));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	// stick class comoponent to avoid React ref warning inside Form
	// https://github.com/ant-design/ant-design/issues/18707
	// eslint-disable-next-line react/prefer-stateless-function
	var Dragger = /*#__PURE__*/function (_React$Component) {
	  _inherits(Dragger, _React$Component);
	
	  var _super = _createSuper(Dragger);
	
	  function Dragger() {
	    _classCallCheck(this, Dragger);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(Dragger, [{
	    key: "render",
	    value: function render() {
	      var _a = this.props,
	          style = _a.style,
	          height = _a.height,
	          restProps = __rest(_a, ["style", "height"]);
	
	      return /*#__PURE__*/React.createElement(_Upload["default"], _extends({}, restProps, {
	        type: "drag",
	        style: _extends(_extends({}, style), {
	          height: height
	        })
	      }));
	    }
	  }]);
	
	  return Dragger;
	}(React.Component);
	
	exports["default"] = Dragger;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(111));
	
	var _classnames = _interopRequireDefault(__webpack_require__(9));
	
	var _utils = __webpack_require__(650);
	
	var _icon = _interopRequireDefault(__webpack_require__(24));
	
	var _tooltip = _interopRequireDefault(__webpack_require__(165));
	
	var _progress = _interopRequireDefault(__webpack_require__(638));
	
	var _configProvider = __webpack_require__(11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var UploadList = /*#__PURE__*/function (_React$Component) {
	  _inherits(UploadList, _React$Component);
	
	  var _super = _createSuper(UploadList);
	
	  function UploadList() {
	    var _this;
	
	    _classCallCheck(this, UploadList);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handlePreview = function (file, e) {
	      var onPreview = _this.props.onPreview;
	
	      if (!onPreview) {
	        return;
	      }
	
	      e.preventDefault();
	      return onPreview(file);
	    };
	
	    _this.handleDownload = function (file) {
	      var onDownload = _this.props.onDownload;
	
	      if (typeof onDownload === 'function') {
	        onDownload(file);
	      } else if (file.url) {
	        window.open(file.url);
	      }
	    };
	
	    _this.handleClose = function (file) {
	      var onRemove = _this.props.onRemove;
	
	      if (onRemove) {
	        onRemove(file);
	      }
	    };
	
	    _this.renderUploadList = function (_ref) {
	      var _classNames4;
	
	      var getPrefixCls = _ref.getPrefixCls;
	      var _this$props = _this.props,
	          customizePrefixCls = _this$props.prefixCls,
	          _this$props$items = _this$props.items,
	          items = _this$props$items === void 0 ? [] : _this$props$items,
	          listType = _this$props.listType,
	          showPreviewIcon = _this$props.showPreviewIcon,
	          showRemoveIcon = _this$props.showRemoveIcon,
	          showDownloadIcon = _this$props.showDownloadIcon,
	          locale = _this$props.locale,
	          progressAttr = _this$props.progressAttr;
	      var prefixCls = getPrefixCls('upload', customizePrefixCls);
	      var list = items.map(function (file) {
	        var _classNames, _classNames2;
	
	        var progress;
	        var icon = /*#__PURE__*/React.createElement(_icon["default"], {
	          type: file.status === 'uploading' ? 'loading' : 'paper-clip'
	        });
	
	        if (listType === 'picture' || listType === 'picture-card') {
	          if (listType === 'picture-card' && file.status === 'uploading') {
	            icon = /*#__PURE__*/React.createElement("div", {
	              className: "".concat(prefixCls, "-list-item-uploading-text")
	            }, locale.uploading);
	          } else if (!file.thumbUrl && !file.url) {
	            icon = /*#__PURE__*/React.createElement(_icon["default"], {
	              className: "".concat(prefixCls, "-list-item-thumbnail"),
	              type: "picture",
	              theme: "twoTone"
	            });
	          } else {
	            var thumbnail = (0, _utils.isImageUrl)(file) ? /*#__PURE__*/React.createElement("img", {
	              src: file.thumbUrl || file.url,
	              alt: file.name,
	              className: "".concat(prefixCls, "-list-item-image")
	            }) : /*#__PURE__*/React.createElement(_icon["default"], {
	              type: "file",
	              className: "".concat(prefixCls, "-list-item-icon"),
	              theme: "twoTone"
	            });
	            icon = /*#__PURE__*/React.createElement("a", {
	              className: "".concat(prefixCls, "-list-item-thumbnail"),
	              onClick: function onClick(e) {
	                return _this.handlePreview(file, e);
	              },
	              href: file.url || file.thumbUrl,
	              target: "_blank",
	              rel: "noopener noreferrer"
	            }, thumbnail);
	          }
	        }
	
	        if (file.status === 'uploading') {
	          // show loading icon if upload progress listener is disabled
	          var loadingProgress = 'percent' in file ? /*#__PURE__*/React.createElement(_progress["default"], _extends({
	            type: "line"
	          }, progressAttr, {
	            percent: file.percent
	          })) : null;
	          progress = /*#__PURE__*/React.createElement("div", {
	            className: "".concat(prefixCls, "-list-item-progress"),
	            key: "progress"
	          }, loadingProgress);
	        }
	
	        var infoUploadingClass = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-list-item"), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-").concat(file.status), true), _defineProperty(_classNames, "".concat(prefixCls, "-list-item-list-type-").concat(listType), true), _classNames));
	        var linkProps = typeof file.linkProps === 'string' ? JSON.parse(file.linkProps) : file.linkProps;
	        var removeIcon = showRemoveIcon ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "delete",
	          title: locale.removeFile,
	          onClick: function onClick() {
	            return _this.handleClose(file);
	          }
	        }) : null;
	        var downloadIcon = showDownloadIcon && file.status === 'done' ? /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "download",
	          title: locale.downloadFile,
	          onClick: function onClick() {
	            return _this.handleDownload(file);
	          }
	        }) : null;
	        var downloadOrDelete = listType !== 'picture-card' && /*#__PURE__*/React.createElement("span", {
	          key: "download-delete",
	          className: "".concat(prefixCls, "-list-item-card-actions ").concat(listType === 'picture' ? 'picture' : '')
	        }, downloadIcon && /*#__PURE__*/React.createElement("a", {
	          title: locale.downloadFile
	        }, downloadIcon), removeIcon && /*#__PURE__*/React.createElement("a", {
	          title: locale.removeFile
	        }, removeIcon));
	        var listItemNameClass = (0, _classnames["default"])((_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name"), true), _defineProperty(_classNames2, "".concat(prefixCls, "-list-item-name-icon-count-").concat([downloadIcon, removeIcon].filter(function (x) {
	          return x;
	        }).length), true), _classNames2));
	        var preview = file.url ? [/*#__PURE__*/React.createElement("a", _extends({
	          key: "view",
	          target: "_blank",
	          rel: "noopener noreferrer",
	          className: listItemNameClass,
	          title: file.name
	        }, linkProps, {
	          href: file.url,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          }
	        }), file.name), downloadOrDelete] : [/*#__PURE__*/React.createElement("span", {
	          key: "view",
	          className: listItemNameClass,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          },
	          title: file.name
	        }, file.name), downloadOrDelete];
	        var style = {
	          pointerEvents: 'none',
	          opacity: 0.5
	        };
	        var previewIcon = showPreviewIcon ? /*#__PURE__*/React.createElement("a", {
	          href: file.url || file.thumbUrl,
	          target: "_blank",
	          rel: "noopener noreferrer",
	          style: file.url || file.thumbUrl ? undefined : style,
	          onClick: function onClick(e) {
	            return _this.handlePreview(file, e);
	          },
	          title: locale.previewFile
	        }, /*#__PURE__*/React.createElement(_icon["default"], {
	          type: "eye-o"
	        })) : null;
	        var actions = listType === 'picture-card' && file.status !== 'uploading' && /*#__PURE__*/React.createElement("span", {
	          className: "".concat(prefixCls, "-list-item-actions")
	        }, previewIcon, file.status === 'done' && downloadIcon, removeIcon);
	        var message;
	
	        if (file.response && typeof file.response === 'string') {
	          message = file.response;
	        } else {
	          message = file.error && file.error.statusText || locale.uploadError;
	        }
	
	        var iconAndPreview = /*#__PURE__*/React.createElement("span", null, icon, preview);
	        var dom = /*#__PURE__*/React.createElement("div", {
	          className: infoUploadingClass
	        }, /*#__PURE__*/React.createElement("div", {
	          className: "".concat(prefixCls, "-list-item-info")
	        }, iconAndPreview), actions, /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	          transitionName: "fade",
	          component: ""
	        }, progress));
	        var listContainerNameClass = (0, _classnames["default"])(_defineProperty({}, "".concat(prefixCls, "-list-picture-card-container"), listType === 'picture-card'));
	        return /*#__PURE__*/React.createElement("div", {
	          key: file.uid,
	          className: listContainerNameClass
	        }, file.status === 'error' ? /*#__PURE__*/React.createElement(_tooltip["default"], {
	          title: message
	        }, dom) : /*#__PURE__*/React.createElement("span", null, dom));
	      });
	      var listClassNames = (0, _classnames["default"])((_classNames4 = {}, _defineProperty(_classNames4, "".concat(prefixCls, "-list"), true), _defineProperty(_classNames4, "".concat(prefixCls, "-list-").concat(listType), true), _classNames4));
	      var animationDirection = listType === 'picture-card' ? 'animate-inline' : 'animate';
	      return /*#__PURE__*/React.createElement(_rcAnimate["default"], {
	        transitionName: "".concat(prefixCls, "-").concat(animationDirection),
	        component: "div",
	        className: listClassNames
	      }, list);
	    };
	
	    return _this;
	  }
	
	  _createClass(UploadList, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          listType = _this$props2.listType,
	          items = _this$props2.items,
	          previewFile = _this$props2.previewFile;
	
	      if (listType !== 'picture' && listType !== 'picture-card') {
	        return;
	      }
	
	      (items || []).forEach(function (file) {
	        if (typeof document === 'undefined' || typeof window === 'undefined' || !window.FileReader || !window.File || !(file.originFileObj instanceof File || file.originFileObj instanceof Blob) || file.thumbUrl !== undefined) {
	          return;
	        }
	
	        file.thumbUrl = '';
	
	        if (previewFile) {
	          previewFile(file.originFileObj).then(function (previewDataUrl) {
	            // Need append '' to avoid dead loop
	            file.thumbUrl = previewDataUrl || '';
	
	            _this2.forceUpdate();
	          });
	        }
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderUploadList);
	    }
	  }]);
	
	  return UploadList;
	}(React.Component);
	
	exports["default"] = UploadList;
	UploadList.defaultProps = {
	  listType: 'text',
	  progressAttr: {
	    strokeWidth: 2,
	    showInfo: false
	  },
	  showRemoveIcon: true,
	  showDownloadIcon: false,
	  showPreviewIcon: true,
	  previewFile: _utils.previewImage
	};

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Upload = _interopRequireDefault(__webpack_require__(649));
	
	var _Dragger = _interopRequireDefault(__webpack_require__(1354));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_Upload["default"].Dragger = _Dragger["default"];
	var _default = _Upload["default"];
	exports["default"] = _default;

/***/ },
/* 1357 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _package = _interopRequireDefault({ version: '3.26.20' });
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _package["default"].version;
	exports["default"] = _default;

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends3 = __webpack_require__(21);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _utils = __webpack_require__(1359);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var twoToneColorPalette = {
	    primaryColor: '#333',
	    secondaryColor: '#E6E6E6'
	};
	
	var Icon = function (_React$Component) {
	    (0, _inherits3['default'])(Icon, _React$Component);
	
	    function Icon() {
	        (0, _classCallCheck3['default'])(this, Icon);
	        return (0, _possibleConstructorReturn3['default'])(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
	    }
	
	    (0, _createClass3['default'])(Icon, [{
	        key: 'render',
	        value: function render() {
	            var _extends2;
	
	            var _props = this.props,
	                type = _props.type,
	                className = _props.className,
	                onClick = _props.onClick,
	                style = _props.style,
	                primaryColor = _props.primaryColor,
	                secondaryColor = _props.secondaryColor,
	                rest = (0, _objectWithoutProperties3['default'])(_props, ['type', 'className', 'onClick', 'style', 'primaryColor', 'secondaryColor']);
	
	            var target = void 0;
	            var colors = twoToneColorPalette;
	            if (primaryColor) {
	                colors = {
	                    primaryColor: primaryColor,
	                    secondaryColor: secondaryColor || (0, _utils.getSecondaryColor)(primaryColor)
	                };
	            }
	            if ((0, _utils.isIconDefinition)(type)) {
	                target = type;
	            } else if (typeof type === 'string') {
	                target = Icon.get(type, colors);
	                if (!target) {
	                    // log(`Could not find icon: ${type}`);
	                    return null;
	                }
	            }
	            if (!target) {
	                (0, _utils.log)('type should be string or icon definiton, but got ' + type);
	                return null;
	            }
	            if (target && typeof target.icon === 'function') {
	                target = (0, _extends4['default'])({}, target, {
	                    icon: target.icon(colors.primaryColor, colors.secondaryColor)
	                });
	            }
	            return (0, _utils.generate)(target.icon, 'svg-' + target.name, (0, _extends4['default'])((_extends2 = {
	                className: className,
	                onClick: onClick,
	                style: style
	            }, (0, _defineProperty3['default'])(_extends2, 'data-icon', target.name), (0, _defineProperty3['default'])(_extends2, 'width', '1em'), (0, _defineProperty3['default'])(_extends2, 'height', '1em'), (0, _defineProperty3['default'])(_extends2, 'fill', 'currentColor'), (0, _defineProperty3['default'])(_extends2, 'aria-hidden', 'true'), (0, _defineProperty3['default'])(_extends2, 'focusable', 'false'), _extends2), rest));
	        }
	    }], [{
	        key: 'add',
	        value: function add() {
	            var _this2 = this;
	
	            for (var _len = arguments.length, icons = Array(_len), _key = 0; _key < _len; _key++) {
	                icons[_key] = arguments[_key];
	            }
	
	            icons.forEach(function (icon) {
	                _this2.definitions.set((0, _utils.withSuffix)(icon.name, icon.theme), icon);
	            });
	        }
	    }, {
	        key: 'clear',
	        value: function clear() {
	            this.definitions.clear();
	        }
	    }, {
	        key: 'get',
	        value: function get(key) {
	            var colors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : twoToneColorPalette;
	
	            if (key) {
	                var target = this.definitions.get(key);
	                if (target && typeof target.icon === 'function') {
	                    target = (0, _extends4['default'])({}, target, {
	                        icon: target.icon(colors.primaryColor, colors.secondaryColor)
	                    });
	                }
	                return target;
	            }
	        }
	    }, {
	        key: 'setTwoToneColors',
	        value: function setTwoToneColors(_ref) {
	            var primaryColor = _ref.primaryColor,
	                secondaryColor = _ref.secondaryColor;
	
	            twoToneColorPalette.primaryColor = primaryColor;
	            twoToneColorPalette.secondaryColor = secondaryColor || (0, _utils.getSecondaryColor)(primaryColor);
	        }
	    }, {
	        key: 'getTwoToneColors',
	        value: function getTwoToneColors() {
	            return (0, _extends4['default'])({}, twoToneColorPalette);
	        }
	    }]);
	    return Icon;
	}(React.Component);
	
	Icon.displayName = 'IconReact';
	Icon.definitions = new _utils.MiniMap();
	exports['default'] = Icon;
	module.exports = exports['default'];

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.MiniMap = undefined;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports.log = log;
	exports.isIconDefinition = isIconDefinition;
	exports.normalizeAttrs = normalizeAttrs;
	exports.generate = generate;
	exports.getSecondaryColor = getSecondaryColor;
	exports.withSuffix = withSuffix;
	
	var _colors = __webpack_require__(1213);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function log(message) {
	    if (!(process && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'production')) {
	        console.error('[@ant-design/icons-react]: ' + message + '.');
	    }
	}
	function isIconDefinition(target) {
	    return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
	}
	function normalizeAttrs() {
	    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    return Object.keys(attrs).reduce(function (acc, key) {
	        var val = attrs[key];
	        switch (key) {
	            case 'class':
	                acc.className = val;
	                delete acc['class'];
	                break;
	            default:
	                acc[key] = val;
	        }
	        return acc;
	    }, {});
	}
	
	var MiniMap = exports.MiniMap = function () {
	    function MiniMap() {
	        (0, _classCallCheck3['default'])(this, MiniMap);
	
	        this.collection = {};
	    }
	
	    (0, _createClass3['default'])(MiniMap, [{
	        key: 'clear',
	        value: function clear() {
	            this.collection = {};
	        }
	    }, {
	        key: 'delete',
	        value: function _delete(key) {
	            return delete this.collection[key];
	        }
	    }, {
	        key: 'get',
	        value: function get(key) {
	            return this.collection[key];
	        }
	    }, {
	        key: 'has',
	        value: function has(key) {
	            return Boolean(this.collection[key]);
	        }
	    }, {
	        key: 'set',
	        value: function set(key, value) {
	            this.collection[key] = value;
	            return this;
	        }
	    }, {
	        key: 'size',
	        get: function get() {
	            return Object.keys(this.collection).length;
	        }
	    }]);
	    return MiniMap;
	}();
	
	function generate(node, key, rootProps) {
	    if (!rootProps) {
	        return React.createElement(node.tag, (0, _extends3['default'])({ key: key }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
	            return generate(child, key + '-' + node.tag + '-' + index);
	        }));
	    }
	    return React.createElement(node.tag, (0, _extends3['default'])({
	        key: key
	    }, normalizeAttrs(node.attrs), rootProps), (node.children || []).map(function (child, index) {
	        return generate(child, key + '-' + node.tag + '-' + index);
	    }));
	}
	function getSecondaryColor(primaryColor) {
	    // choose the second color
	    return (0, _colors.generate)(primaryColor)[0];
	}
	function withSuffix(name, theme) {
	    switch (theme) {
	        case 'fill':
	            return name + '-fill';
	        case 'outline':
	            return name + '-o';
	        case 'twotone':
	            return name + '-twotone';
	        default:
	            throw new TypeError('Unknown theme type: ' + theme + ', name: ' + name);
	    }
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ },
/* 1360 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function supportRef(node) {
	  // Function component
	  if (node.type && node.type.prototype && !node.type.prototype.render) {
	    return false;
	  }
	
	  return true;
	}
	
	exports.supportRef = supportRef;

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var classNames = __webpack_require__(9);
	
	var Switch = /*#__PURE__*/function (_Component) {
	  _inherits(Switch, _Component);
	
	  var _super = _createSuper(Switch);
	
	  function Switch(props) {
	    var _this;
	
	    _classCallCheck(this, Switch);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
	      var checked = _this.state.checked;
	      var onClick = _this.props.onClick;
	      var newChecked = !checked;
	
	      _this.setChecked(newChecked, e);
	
	      if (onClick) {
	        onClick(newChecked, e);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
	      if (e.keyCode === 37) {
	        // Left
	        _this.setChecked(false, e);
	      } else if (e.keyCode === 39) {
	        // Right
	        _this.setChecked(true, e);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function (e) {
	      var onMouseUp = _this.props.onMouseUp;
	
	      if (_this.node) {
	        _this.node.blur();
	      }
	
	      if (onMouseUp) {
	        onMouseUp(e);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "saveNode", function (node) {
	      _this.node = node;
	    });
	
	    var _checked = false;
	
	    if ('checked' in props) {
	      _checked = !!props.checked;
	    } else {
	      _checked = !!props.defaultChecked;
	    }
	
	    _this.state = {
	      checked: _checked
	    };
	    return _this;
	  }
	
	  _createClass(Switch, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props = this.props,
	          autoFocus = _this$props.autoFocus,
	          disabled = _this$props.disabled;
	
	      if (autoFocus && !disabled) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "setChecked",
	    value: function setChecked(checked, e) {
	      var _this$props2 = this.props,
	          disabled = _this$props2.disabled,
	          onChange = _this$props2.onChange;
	
	      if (disabled) {
	        return;
	      }
	
	      if (!('checked' in this.props)) {
	        this.setState({
	          checked: checked
	        });
	      }
	
	      if (onChange) {
	        onChange(checked, e);
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.node.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.node.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props3 = this.props,
	          className = _this$props3.className,
	          prefixCls = _this$props3.prefixCls,
	          disabled = _this$props3.disabled,
	          loadingIcon = _this$props3.loadingIcon,
	          checkedChildren = _this$props3.checkedChildren,
	          unCheckedChildren = _this$props3.unCheckedChildren,
	          restProps = _objectWithoutProperties(_this$props3, ["className", "prefixCls", "disabled", "loadingIcon", "checkedChildren", "unCheckedChildren"]);
	
	      var checked = this.state.checked;
	      var switchClassName = classNames((_classNames = {}, _defineProperty(_classNames, className, !!className), _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, "".concat(prefixCls, "-checked"), checked), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
	      return /*#__PURE__*/_react["default"].createElement("button", _extends({}, restProps, {
	        type: "button",
	        role: "switch",
	        "aria-checked": checked,
	        disabled: disabled,
	        className: switchClassName,
	        ref: this.saveNode,
	        onKeyDown: this.handleKeyDown,
	        onClick: this.handleClick,
	        onMouseUp: this.handleMouseUp
	      }), loadingIcon, /*#__PURE__*/_react["default"].createElement("span", {
	        className: "".concat(prefixCls, "-inner")
	      }, checked ? checkedChildren : unCheckedChildren));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	      var checked = nextProps.checked;
	
	      if ('checked' in nextProps) {
	        newState.checked = !!checked;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Switch;
	}(_react.Component);
	
	Switch.propTypes = {
	  className: _propTypes["default"].string,
	  prefixCls: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  checkedChildren: _propTypes["default"].any,
	  unCheckedChildren: _propTypes["default"].any,
	  onChange: _propTypes["default"].func,
	  onMouseUp: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  tabIndex: _propTypes["default"].number,
	  checked: _propTypes["default"].bool,
	  defaultChecked: _propTypes["default"].bool,
	  autoFocus: _propTypes["default"].bool,
	  loadingIcon: _propTypes["default"].node
	};
	Switch.defaultProps = {
	  prefixCls: 'rc-switch',
	  checkedChildren: null,
	  unCheckedChildren: null,
	  className: '',
	  defaultChecked: false
	};
	(0, _reactLifecyclesCompat.polyfill)(Switch);
	var _default = Switch;
	exports["default"] = _default;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = __webpack_require__(1361);

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var PropTypes = __importStar(__webpack_require__(6));
	
	var utils_1 = __webpack_require__(228);
	
	var BaseTable_1 = __importDefault(__webpack_require__(652));
	
	function BodyTable(props, _ref) {
	  var table = _ref.table;
	  var _table$props = table.props,
	      prefixCls = _table$props.prefixCls,
	      scroll = _table$props.scroll;
	  var columns = props.columns,
	      fixed = props.fixed,
	      tableClassName = props.tableClassName,
	      getRowKey = props.getRowKey,
	      handleBodyScroll = props.handleBodyScroll,
	      handleWheel = props.handleWheel,
	      expander = props.expander,
	      isAnyColumnsFixed = props.isAnyColumnsFixed;
	  var saveRef = table.saveRef;
	  var useFixedHeader = table.props.useFixedHeader;
	
	  var bodyStyle = _objectSpread({}, table.props.bodyStyle);
	
	  var innerBodyStyle = {};
	
	  if (scroll.x || fixed) {
	    bodyStyle.overflowX = bodyStyle.overflowX || 'scroll'; // Fix weird webkit render bug
	    // https://github.com/ant-design/ant-design/issues/7783
	
	    bodyStyle.WebkitTransform = 'translate3d (0, 0, 0)';
	  }
	
	  if (scroll.y) {
	    // maxHeight will make fixed-Table scrolling not working
	    // so we only set maxHeight to body-Table here
	    if (fixed) {
	      innerBodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
	      innerBodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
	    } else {
	      bodyStyle.maxHeight = bodyStyle.maxHeight || scroll.y;
	    }
	
	    bodyStyle.overflowY = bodyStyle.overflowY || 'scroll';
	    useFixedHeader = true; // Add negative margin bottom for scroll bar overflow bug
	
	    var scrollbarWidth = utils_1.measureScrollbar({
	      direction: 'vertical'
	    });
	
	    if (scrollbarWidth > 0 && fixed) {
	      bodyStyle.marginBottom = "-".concat(scrollbarWidth, "px");
	      bodyStyle.paddingBottom = '0px';
	    }
	  }
	
	  var baseTable = React.createElement(BaseTable_1.default, {
	    tableClassName: tableClassName,
	    hasHead: !useFixedHeader,
	    hasBody: true,
	    fixed: fixed,
	    columns: columns,
	    expander: expander,
	    getRowKey: getRowKey,
	    isAnyColumnsFixed: isAnyColumnsFixed
	  });
	
	  if (fixed && columns.length) {
	    var refName;
	
	    if (columns[0].fixed === 'left' || columns[0].fixed === true) {
	      refName = 'fixedColumnsBodyLeft';
	    } else if (columns[0].fixed === 'right') {
	      refName = 'fixedColumnsBodyRight';
	    }
	
	    delete bodyStyle.overflowX;
	    delete bodyStyle.overflowY;
	    return React.createElement("div", {
	      key: "bodyTable",
	      className: "".concat(prefixCls, "-body-outer"),
	      style: _objectSpread({}, bodyStyle)
	    }, React.createElement("div", {
	      className: "".concat(prefixCls, "-body-inner"),
	      style: innerBodyStyle,
	      ref: saveRef(refName),
	      onWheel: handleWheel,
	      onScroll: handleBodyScroll
	    }, baseTable));
	  } // Should provides `tabIndex` if use scroll to enable keyboard scroll
	
	
	  var useTabIndex = scroll && (scroll.x || scroll.y);
	  return React.createElement("div", {
	    tabIndex: useTabIndex ? -1 : undefined,
	    key: "bodyTable",
	    className: "".concat(prefixCls, "-body"),
	    style: bodyStyle,
	    ref: saveRef('bodyTable'),
	    onWheel: handleWheel,
	    onScroll: handleBodyScroll
	  }, baseTable);
	}
	
	exports.default = BodyTable;
	BodyTable.contextTypes = {
	  table: PropTypes.any
	};

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var PropTypes = __importStar(__webpack_require__(6));
	
	var utils_1 = __webpack_require__(228);
	
	var ColGroup = function ColGroup(props, _ref) {
	  var table = _ref.table;
	  var _table$props = table.props,
	      prefixCls = _table$props.prefixCls,
	      expandIconAsCell = _table$props.expandIconAsCell;
	  var fixed = props.fixed;
	  var cols = [];
	
	  if (expandIconAsCell && fixed !== 'right') {
	    cols.push(React.createElement("col", {
	      className: "".concat(prefixCls, "-expand-icon-col"),
	      key: "rc-table-expand-icon-col"
	    }));
	  }
	
	  var leafColumns;
	
	  if (fixed === 'left') {
	    leafColumns = table.columnManager.leftLeafColumns();
	  } else if (fixed === 'right') {
	    leafColumns = table.columnManager.rightLeafColumns();
	  } else {
	    leafColumns = table.columnManager.leafColumns();
	  }
	
	  cols = cols.concat(leafColumns.map(function (_ref2) {
	    var key = _ref2.key,
	        dataIndex = _ref2.dataIndex,
	        width = _ref2.width,
	        additionalProps = _ref2[utils_1.INTERNAL_COL_DEFINE];
	    var mergedKey = key !== undefined ? key : dataIndex;
	    return React.createElement("col", Object.assign({
	      key: mergedKey,
	      style: {
	        width: width,
	        minWidth: width
	      }
	    }, additionalProps));
	  }));
	  return React.createElement("colgroup", null, cols);
	};
	
	ColGroup.contextTypes = {
	  table: PropTypes.any
	};
	exports.default = ColGroup;

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/* eslint-disable no-underscore-dangle */
	
	var React = __importStar(__webpack_require__(1));
	
	var ColumnManager = /*#__PURE__*/function () {
	  function ColumnManager(columns, elements) {
	    _classCallCheck(this, ColumnManager);
	
	    this._cached = {};
	    this.columns = columns || this.normalize(elements);
	  }
	
	  _createClass(ColumnManager, [{
	    key: "isAnyColumnsFixed",
	    value: function isAnyColumnsFixed() {
	      var _this = this;
	
	      return this._cache('isAnyColumnsFixed', function () {
	        return _this.columns.some(function (column) {
	          return !!column.fixed;
	        });
	      });
	    }
	  }, {
	    key: "isAnyColumnsLeftFixed",
	    value: function isAnyColumnsLeftFixed() {
	      var _this2 = this;
	
	      return this._cache('isAnyColumnsLeftFixed', function () {
	        return _this2.columns.some(function (column) {
	          return column.fixed === 'left' || column.fixed === true;
	        });
	      });
	    }
	  }, {
	    key: "isAnyColumnsRightFixed",
	    value: function isAnyColumnsRightFixed() {
	      var _this3 = this;
	
	      return this._cache('isAnyColumnsRightFixed', function () {
	        return _this3.columns.some(function (column) {
	          return column.fixed === 'right';
	        });
	      });
	    }
	  }, {
	    key: "leftColumns",
	    value: function leftColumns() {
	      var _this4 = this;
	
	      return this._cache('leftColumns', function () {
	        return _this4.groupedColumns().filter(function (column) {
	          return column.fixed === 'left' || column.fixed === true;
	        });
	      });
	    }
	  }, {
	    key: "rightColumns",
	    value: function rightColumns() {
	      var _this5 = this;
	
	      return this._cache('rightColumns', function () {
	        return _this5.groupedColumns().filter(function (column) {
	          return column.fixed === 'right';
	        });
	      });
	    }
	  }, {
	    key: "leafColumns",
	    value: function leafColumns() {
	      var _this6 = this;
	
	      return this._cache('leafColumns', function () {
	        return _this6._leafColumns(_this6.columns);
	      });
	    }
	  }, {
	    key: "leftLeafColumns",
	    value: function leftLeafColumns() {
	      var _this7 = this;
	
	      return this._cache('leftLeafColumns', function () {
	        return _this7._leafColumns(_this7.leftColumns());
	      });
	    }
	  }, {
	    key: "rightLeafColumns",
	    value: function rightLeafColumns() {
	      var _this8 = this;
	
	      return this._cache('rightLeafColumns', function () {
	        return _this8._leafColumns(_this8.rightColumns());
	      });
	    } // add appropriate rowspan and colspan to column
	
	  }, {
	    key: "groupedColumns",
	    value: function groupedColumns() {
	      var _this9 = this;
	
	      return this._cache('groupedColumns', function () {
	        var _groupColumns = function _groupColumns(columns) {
	          var currentRow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	          var parentColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	          var rows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	
	          /* eslint-disable no-param-reassign */
	          // track how many rows we got
	          rows[currentRow] = rows[currentRow] || [];
	          var grouped = [];
	
	          var setRowSpan = function setRowSpan(column) {
	            var rowSpan = rows.length - currentRow;
	
	            if (column && !column.children && // parent columns are supposed to be one row
	            rowSpan > 1 && (!column.rowSpan || column.rowSpan < rowSpan)) {
	              column.rowSpan = rowSpan;
	            }
	          };
	
	          columns.forEach(function (column, index) {
	            var newColumn = _objectSpread({}, column);
	
	            rows[currentRow].push(newColumn);
	            parentColumn.colSpan = parentColumn.colSpan || 0;
	
	            if (newColumn.children && newColumn.children.length > 0) {
	              newColumn.children = _groupColumns(newColumn.children, currentRow + 1, newColumn, rows);
	              parentColumn.colSpan += newColumn.colSpan;
	            } else {
	              parentColumn.colSpan += 1;
	            } // update rowspan to all same row columns
	
	
	            for (var i = 0; i < rows[currentRow].length - 1; i += 1) {
	              setRowSpan(rows[currentRow][i]);
	            } // last column, update rowspan immediately
	
	
	            if (index + 1 === columns.length) {
	              setRowSpan(newColumn);
	            }
	
	            grouped.push(newColumn);
	          });
	          return grouped;
	          /* eslint-enable no-param-reassign */
	        };
	
	        return _groupColumns(_this9.columns);
	      });
	    }
	  }, {
	    key: "normalize",
	    value: function normalize(elements) {
	      var _this10 = this;
	
	      var columns = [];
	      React.Children.forEach(elements, function (element) {
	        if (!React.isValidElement(element)) {
	          return;
	        }
	
	        var column = _objectSpread({}, element.props);
	
	        if (element.key) {
	          column.key = element.key;
	        }
	
	        if (element.type.isTableColumnGroup) {
	          column.children = _this10.normalize(column.children);
	        }
	
	        columns.push(column);
	      });
	      return columns;
	    }
	  }, {
	    key: "reset",
	    value: function reset(columns, elements) {
	      this.columns = columns || this.normalize(elements);
	      this._cached = {};
	    }
	  }, {
	    key: "_cache",
	    value: function _cache(name, fn) {
	      if (name in this._cached) {
	        return this._cached[name];
	      }
	
	      this._cached[name] = fn();
	      return this._cached[name];
	    }
	  }, {
	    key: "_leafColumns",
	    value: function _leafColumns(columns) {
	      var _this11 = this;
	
	      var leafColumns = [];
	      columns.forEach(function (column) {
	        if (!column.children) {
	          leafColumns.push(column);
	        } else {
	          leafColumns.push.apply(leafColumns, _toConsumableArray(_this11._leafColumns(column.children)));
	        }
	      });
	      return leafColumns;
	    }
	  }]);
	
	  return ColumnManager;
	}();
	
	exports.default = ColumnManager;
	/* eslint-enable */

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var shallowequal_1 = __importDefault(__webpack_require__(79));
	
	var ExpandIcon = /*#__PURE__*/function (_React$Component) {
	  _inherits(ExpandIcon, _React$Component);
	
	  var _super = _createSuper(ExpandIcon);
	
	  function ExpandIcon() {
	    _classCallCheck(this, ExpandIcon);
	
	    return _super.apply(this, arguments);
	  }
	
	  _createClass(ExpandIcon, [{
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      return !shallowequal_1.default(nextProps, this.props);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          expandable = _this$props.expandable,
	          prefixCls = _this$props.prefixCls,
	          onExpand = _this$props.onExpand,
	          needIndentSpaced = _this$props.needIndentSpaced,
	          expanded = _this$props.expanded,
	          record = _this$props.record;
	
	      if (expandable) {
	        var expandClassName = expanded ? 'expanded' : 'collapsed';
	        return React.createElement("span", {
	          className: "".concat(prefixCls, "-expand-icon ").concat(prefixCls, "-").concat(expandClassName),
	          onClick: function onClick(e) {
	            return onExpand(record, e);
	          }
	        });
	      }
	
	      if (needIndentSpaced) {
	        return React.createElement("span", {
	          className: "".concat(prefixCls, "-expand-icon ").concat(prefixCls, "-spaced")
	        });
	      }
	
	      return null;
	    }
	  }]);
	
	  return ExpandIcon;
	}(React.Component);
	
	exports.default = ExpandIcon;

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var mini_store_1 = __webpack_require__(143);
	
	var ExpandIcon_1 = __importDefault(__webpack_require__(1366));
	
	var ExpandableRow = /*#__PURE__*/function (_React$Component) {
	  _inherits(ExpandableRow, _React$Component);
	
	  var _super = _createSuper(ExpandableRow);
	
	  function ExpandableRow() {
	    var _this;
	
	    _classCallCheck(this, ExpandableRow);
	
	    _this = _super.apply(this, arguments); // Show icon within first column
	
	    _this.hasExpandIcon = function (columnIndex) {
	      var _this$props = _this.props,
	          expandRowByClick = _this$props.expandRowByClick,
	          expandIcon = _this$props.expandIcon;
	
	      if (_this.expandIconAsCell || columnIndex !== _this.expandIconColumnIndex) {
	        return false;
	      }
	
	      return !!expandIcon || !expandRowByClick;
	    };
	
	    _this.handleExpandChange = function (record, event) {
	      var _this$props2 = _this.props,
	          onExpandedChange = _this$props2.onExpandedChange,
	          expanded = _this$props2.expanded,
	          rowKey = _this$props2.rowKey;
	
	      if (_this.expandable) {
	        onExpandedChange(!expanded, record, event, rowKey);
	      }
	    };
	
	    _this.handleRowClick = function (record, index, event) {
	      var _this$props3 = _this.props,
	          expandRowByClick = _this$props3.expandRowByClick,
	          onRowClick = _this$props3.onRowClick;
	
	      if (expandRowByClick) {
	        _this.handleExpandChange(record, event);
	      }
	
	      if (onRowClick) {
	        onRowClick(record, index, event);
	      }
	    };
	
	    _this.renderExpandIcon = function () {
	      var _this$props4 = _this.props,
	          prefixCls = _this$props4.prefixCls,
	          expanded = _this$props4.expanded,
	          record = _this$props4.record,
	          needIndentSpaced = _this$props4.needIndentSpaced,
	          expandIcon = _this$props4.expandIcon;
	
	      if (expandIcon) {
	        return expandIcon({
	          prefixCls: prefixCls,
	          expanded: expanded,
	          record: record,
	          needIndentSpaced: needIndentSpaced,
	          expandable: _this.expandable,
	          onExpand: _this.handleExpandChange
	        });
	      }
	
	      return React.createElement(ExpandIcon_1.default, {
	        expandable: _this.expandable,
	        prefixCls: prefixCls,
	        onExpand: _this.handleExpandChange,
	        needIndentSpaced: needIndentSpaced,
	        expanded: expanded,
	        record: record
	      });
	    };
	
	    _this.renderExpandIconCell = function (cells) {
	      if (!_this.expandIconAsCell) {
	        return;
	      }
	
	      var prefixCls = _this.props.prefixCls;
	      cells.push(React.createElement("td", {
	        className: "".concat(prefixCls, "-expand-icon-cell"),
	        key: "rc-table-expand-icon-cell"
	      }, _this.renderExpandIcon()));
	    };
	
	    return _this;
	  }
	
	  _createClass(ExpandableRow, [{
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.handleDestroy();
	    }
	  }, {
	    key: "handleDestroy",
	    value: function handleDestroy() {
	      var _this$props5 = this.props,
	          onExpandedChange = _this$props5.onExpandedChange,
	          rowKey = _this$props5.rowKey,
	          record = _this$props5.record;
	
	      if (this.expandable) {
	        onExpandedChange(false, record, null, rowKey, true);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          childrenColumnName = _this$props6.childrenColumnName,
	          expandedRowRender = _this$props6.expandedRowRender,
	          indentSize = _this$props6.indentSize,
	          record = _this$props6.record,
	          fixed = _this$props6.fixed,
	          expanded = _this$props6.expanded;
	      this.expandIconAsCell = fixed !== 'right' ? this.props.expandIconAsCell : false;
	      this.expandIconColumnIndex = fixed !== 'right' ? this.props.expandIconColumnIndex : -1;
	      var childrenData = record[childrenColumnName];
	      this.expandable = !!(childrenData || expandedRowRender);
	      var expandableRowProps = {
	        indentSize: indentSize,
	        // not used in TableRow, but it's required to re-render TableRow when `expanded` changes
	        expanded: expanded,
	        onRowClick: this.handleRowClick,
	        hasExpandIcon: this.hasExpandIcon,
	        renderExpandIcon: this.renderExpandIcon,
	        renderExpandIconCell: this.renderExpandIconCell
	      };
	      return this.props.children(expandableRowProps);
	    }
	  }]);
	
	  return ExpandableRow;
	}(React.Component);
	
	exports.default = mini_store_1.connect(function (_ref, _ref2) {
	  var _ref$expandedRowKeys = _ref.expandedRowKeys,
	      expandedRowKeys = _ref$expandedRowKeys === void 0 ? [] : _ref$expandedRowKeys;
	  var rowKey = _ref2.rowKey;
	  return {
	    expanded: expandedRowKeys.includes(rowKey)
	  };
	})(ExpandableRow);

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var mini_store_1 = __webpack_require__(143);
	
	var react_lifecycles_compat_1 = __webpack_require__(15);
	
	var shallowequal_1 = __importDefault(__webpack_require__(79));
	
	var TableRow_1 = __importDefault(__webpack_require__(655));
	
	var utils_1 = __webpack_require__(228);
	
	var ExpandableTable = /*#__PURE__*/function (_React$Component) {
	  _inherits(ExpandableTable, _React$Component);
	
	  var _super = _createSuper(ExpandableTable);
	
	  function ExpandableTable(props) {
	    var _this;
	
	    _classCallCheck(this, ExpandableTable);
	
	    _this = _super.call(this, props);
	
	    _this.handleExpandChange = function (expanded, record, event, rowKey) {
	      var destroy = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	      if (event) {
	        event.stopPropagation();
	      }
	
	      var _this$props = _this.props,
	          onExpandedRowsChange = _this$props.onExpandedRowsChange,
	          onExpand = _this$props.onExpand;
	
	      var _this$store$getState = _this.store.getState(),
	          expandedRowKeys = _this$store$getState.expandedRowKeys;
	
	      if (expanded) {
	        // row was expanded
	        expandedRowKeys = [].concat(_toConsumableArray(expandedRowKeys), [rowKey]);
	      } else {
	        // row was collapse
	        var expandedRowIndex = expandedRowKeys.indexOf(rowKey);
	
	        if (expandedRowIndex !== -1) {
	          expandedRowKeys = utils_1.remove(expandedRowKeys, rowKey);
	        }
	      }
	
	      if (!_this.props.expandedRowKeys) {
	        _this.store.setState({
	          expandedRowKeys: expandedRowKeys
	        });
	      } // De-dup of repeat call
	
	
	      if (!_this.latestExpandedRows || !shallowequal_1.default(_this.latestExpandedRows, expandedRowKeys)) {
	        _this.latestExpandedRows = expandedRowKeys;
	        onExpandedRowsChange(expandedRowKeys);
	      }
	
	      if (!destroy) {
	        onExpand(expanded, record);
	      }
	    };
	
	    _this.renderExpandIndentCell = function (rows, fixed) {
	      var _this$props2 = _this.props,
	          prefixCls = _this$props2.prefixCls,
	          expandIconAsCell = _this$props2.expandIconAsCell;
	
	      if (!expandIconAsCell || fixed === 'right' || !rows.length) {
	        return;
	      }
	
	      var iconColumn = {
	        key: 'rc-table-expand-icon-cell',
	        className: "".concat(prefixCls, "-expand-icon-th"),
	        title: '',
	        rowSpan: rows.length
	      };
	      rows[0].unshift(_objectSpread({}, iconColumn, {
	        column: iconColumn
	      }));
	    };
	
	    _this.renderRows = function (renderRows, rows, record, index, indent, fixed, parentKey, ancestorKeys) {
	      var _this$props3 = _this.props,
	          expandedRowClassName = _this$props3.expandedRowClassName,
	          expandedRowRender = _this$props3.expandedRowRender,
	          childrenColumnName = _this$props3.childrenColumnName;
	      var childrenData = record[childrenColumnName];
	      var nextAncestorKeys = [].concat(_toConsumableArray(ancestorKeys), [parentKey]);
	      var nextIndent = indent + 1;
	
	      if (expandedRowRender) {
	        rows.push(_this.renderExpandedRow(record, index, expandedRowRender, expandedRowClassName(record, index, indent), nextAncestorKeys, nextIndent, fixed));
	      }
	
	      if (childrenData) {
	        rows.push.apply(rows, _toConsumableArray(renderRows(childrenData, nextIndent, nextAncestorKeys)));
	      }
	    };
	
	    var data = props.data,
	        childrenColumnName = props.childrenColumnName,
	        defaultExpandAllRows = props.defaultExpandAllRows,
	        expandedRowKeys = props.expandedRowKeys,
	        defaultExpandedRowKeys = props.defaultExpandedRowKeys,
	        getRowKey = props.getRowKey;
	    var finalExpandedRowKeys = [];
	
	    var rows = _toConsumableArray(data);
	
	    if (defaultExpandAllRows) {
	      for (var i = 0; i < rows.length; i += 1) {
	        var row = rows[i];
	        finalExpandedRowKeys.push(getRowKey(row, i));
	        rows = rows.concat(row[childrenColumnName] || []);
	      }
	    } else {
	      finalExpandedRowKeys = expandedRowKeys || defaultExpandedRowKeys;
	    }
	
	    _this.columnManager = props.columnManager;
	    _this.store = props.store;
	
	    _this.store.setState({
	      expandedRowsHeight: {},
	      expandedRowKeys: finalExpandedRowKeys
	    });
	
	    return _this;
	  }
	
	  _createClass(ExpandableTable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.handleUpdated();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if ('expandedRowKeys' in this.props) {
	        this.store.setState({
	          expandedRowKeys: this.props.expandedRowKeys
	        });
	      }
	
	      this.handleUpdated();
	    }
	  }, {
	    key: "handleUpdated",
	    value: function handleUpdated() {
	      /**
	       * We should record latest expanded rows to avoid
	       * multiple rows remove cause `onExpandedRowsChange` trigger many times
	       */
	      this.latestExpandedRows = null;
	    }
	  }, {
	    key: "renderExpandedRow",
	    value: function renderExpandedRow(record, index, _render, className, ancestorKeys, indent, fixed) {
	      var _this2 = this;
	
	      var _this$props4 = this.props,
	          prefixCls = _this$props4.prefixCls,
	          expandIconAsCell = _this$props4.expandIconAsCell,
	          indentSize = _this$props4.indentSize;
	      var parentKey = ancestorKeys[ancestorKeys.length - 1];
	      var rowKey = "".concat(parentKey, "-extra-row");
	      var components = {
	        body: {
	          row: 'tr',
	          cell: 'td'
	        }
	      };
	      var colCount;
	
	      if (fixed === 'left') {
	        colCount = this.columnManager.leftLeafColumns().length;
	      } else if (fixed === 'right') {
	        colCount = this.columnManager.rightLeafColumns().length;
	      } else {
	        colCount = this.columnManager.leafColumns().length;
	      }
	
	      var columns = [{
	        key: 'extra-row',
	        render: function render() {
	          var _this2$store$getState = _this2.store.getState(),
	              _this2$store$getState2 = _this2$store$getState.expandedRowKeys,
	              expandedRowKeys = _this2$store$getState2 === void 0 ? [] : _this2$store$getState2;
	
	          var expanded = expandedRowKeys.includes(parentKey);
	          return {
	            props: {
	              colSpan: colCount
	            },
	            children: fixed !== 'right' ? _render(record, index, indent, expanded) : '&nbsp;'
	          };
	        }
	      }];
	
	      if (expandIconAsCell && fixed !== 'right') {
	        columns.unshift({
	          key: 'expand-icon-placeholder',
	          render: function render() {
	            return null;
	          }
	        });
	      }
	
	      return React.createElement(TableRow_1.default, {
	        key: rowKey,
	        columns: columns,
	        className: className,
	        rowKey: rowKey,
	        ancestorKeys: ancestorKeys,
	        prefixCls: "".concat(prefixCls, "-expanded-row"),
	        indentSize: indentSize,
	        indent: indent,
	        fixed: fixed,
	        components: components,
	        expandedRow: true
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props5 = this.props,
	          data = _this$props5.data,
	          childrenColumnName = _this$props5.childrenColumnName,
	          children = _this$props5.children;
	      var needIndentSpaced = data.some(function (record) {
	        return record[childrenColumnName];
	      });
	      return children({
	        props: this.props,
	        needIndentSpaced: needIndentSpaced,
	        renderRows: this.renderRows,
	        handleExpandChange: this.handleExpandChange,
	        renderExpandIndentCell: this.renderExpandIndentCell
	      });
	    }
	  }]);
	
	  return ExpandableTable;
	}(React.Component);
	
	ExpandableTable.defaultProps = {
	  expandIconAsCell: false,
	  expandedRowClassName: function expandedRowClassName() {
	    return '';
	  },
	  expandIconColumnIndex: 0,
	  defaultExpandAllRows: false,
	  defaultExpandedRowKeys: [],
	  childrenColumnName: 'children',
	  indentSize: 15,
	  onExpand: function onExpand() {},
	  onExpandedRowsChange: function onExpandedRowsChange() {}
	};
	react_lifecycles_compat_1.polyfill(ExpandableTable);
	exports.default = mini_store_1.connect()(ExpandableTable);

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var PropTypes = __importStar(__webpack_require__(6));
	
	var classnames_1 = __importDefault(__webpack_require__(9));
	
	var utils_1 = __webpack_require__(228);
	
	var BaseTable_1 = __importDefault(__webpack_require__(652));
	
	function HeadTable(props, _ref) {
	  var table = _ref.table;
	  var _table$props = table.props,
	      prefixCls = _table$props.prefixCls,
	      scroll = _table$props.scroll,
	      showHeader = _table$props.showHeader;
	  var columns = props.columns,
	      fixed = props.fixed,
	      tableClassName = props.tableClassName,
	      handleBodyScrollLeft = props.handleBodyScrollLeft,
	      expander = props.expander;
	  var saveRef = table.saveRef;
	  var useFixedHeader = table.props.useFixedHeader;
	  var headStyle = {};
	  var scrollbarWidth = utils_1.measureScrollbar({
	    direction: 'vertical'
	  });
	
	  if (scroll.y) {
	    useFixedHeader = true; // https://github.com/ant-design/ant-design/issues/17051
	
	    var scrollbarWidthOfHeader = utils_1.measureScrollbar({
	      direction: 'horizontal',
	      prefixCls: prefixCls
	    }); // Add negative margin bottom for scroll bar overflow bug
	
	    if (scrollbarWidthOfHeader > 0 && !fixed) {
	      headStyle.marginBottom = "-".concat(scrollbarWidthOfHeader, "px");
	      headStyle.paddingBottom = '0px'; // https://github.com/ant-design/ant-design/pull/19986
	
	      headStyle.minWidth = "".concat(scrollbarWidth, "px"); // https://github.com/ant-design/ant-design/issues/17051
	
	      headStyle.overflowX = 'scroll';
	      headStyle.overflowY = scrollbarWidth === 0 ? 'hidden' : 'scroll';
	    }
	  }
	
	  if (!useFixedHeader || !showHeader) {
	    return null;
	  }
	
	  return React.createElement("div", {
	    key: "headTable",
	    ref: fixed ? null : saveRef('headTable'),
	    className: classnames_1.default("".concat(prefixCls, "-header"), _defineProperty({}, "".concat(prefixCls, "-hide-scrollbar"), scrollbarWidth > 0)),
	    style: headStyle,
	    onScroll: handleBodyScrollLeft
	  }, React.createElement(BaseTable_1.default, {
	    tableClassName: tableClassName,
	    hasHead: true,
	    hasBody: false,
	    fixed: fixed,
	    columns: columns,
	    expander: expander
	  }));
	}
	
	exports.default = HeadTable;
	HeadTable.contextTypes = {
	  table: PropTypes.any
	};

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var PropTypes = __importStar(__webpack_require__(6));
	
	var shallowequal_1 = __importDefault(__webpack_require__(79));
	
	var addEventListener_1 = __importDefault(__webpack_require__(145));
	
	var warning_1 = __importDefault(__webpack_require__(303));
	
	var mini_store_1 = __webpack_require__(143);
	
	var merge_1 = __importDefault(__webpack_require__(2596));
	
	var component_classes_1 = __importDefault(__webpack_require__(444));
	
	var classnames_1 = __importDefault(__webpack_require__(9));
	
	var react_lifecycles_compat_1 = __webpack_require__(15);
	
	var utils_1 = __webpack_require__(228);
	
	var ColumnManager_1 = __importDefault(__webpack_require__(1365));
	
	var HeadTable_1 = __importDefault(__webpack_require__(1369));
	
	var BodyTable_1 = __importDefault(__webpack_require__(1363));
	
	var Column_1 = __importDefault(__webpack_require__(653));
	
	var ColumnGroup_1 = __importDefault(__webpack_require__(654));
	
	var ExpandableTable_1 = __importDefault(__webpack_require__(1368));
	
	var Table = /*#__PURE__*/function (_React$Component) {
	  _inherits(Table, _React$Component);
	
	  var _super = _createSuper(Table);
	
	  function Table(props) {
	    var _this;
	
	    _classCallCheck(this, Table);
	
	    _this = _super.call(this, props);
	    _this.state = {};
	
	    _this.getRowKey = function (record, index) {
	      var rowKey = _this.props.rowKey;
	      var key = typeof rowKey === 'function' ? rowKey(record, index) : record[rowKey];
	      warning_1.default(key !== undefined, 'Each record in table should have a unique `key` prop,' + 'or set `rowKey` to an unique primary key.');
	      return key === undefined ? index : key;
	    };
	
	    _this.handleWindowResize = function () {
	      _this.syncFixedTableRowHeight();
	
	      _this.setScrollPositionClassName();
	    };
	
	    _this.syncFixedTableRowHeight = function () {
	      var tableRect = _this.tableNode.getBoundingClientRect(); // If tableNode's height less than 0, suppose it is hidden and don't recalculate rowHeight.
	      // see: https://github.com/ant-design/ant-design/issues/4836
	
	
	      if (tableRect.height !== undefined && tableRect.height <= 0) {
	        return;
	      }
	
	      var prefixCls = _this.props.prefixCls;
	      var headRows = _this.headTable ? _this.headTable.querySelectorAll('thead') : _this.bodyTable.querySelectorAll('thead');
	      var bodyRows = _this.bodyTable.querySelectorAll(".".concat(prefixCls, "-row")) || [];
	      var fixedColumnsHeadRowsHeight = [].map.call(headRows, function (row) {
	        return row.getBoundingClientRect().height || 'auto';
	      });
	
	      var state = _this.store.getState();
	
	      var fixedColumnsBodyRowsHeight = [].reduce.call(bodyRows, function (acc, row) {
	        var rowKey = row.getAttribute('data-row-key');
	        var height = row.getBoundingClientRect().height || state.fixedColumnsBodyRowsHeight[rowKey] || 'auto';
	        acc[rowKey] = height;
	        return acc;
	      }, {});
	
	      if (shallowequal_1.default(state.fixedColumnsHeadRowsHeight, fixedColumnsHeadRowsHeight) && shallowequal_1.default(state.fixedColumnsBodyRowsHeight, fixedColumnsBodyRowsHeight)) {
	        return;
	      }
	
	      _this.store.setState({
	        fixedColumnsHeadRowsHeight: fixedColumnsHeadRowsHeight,
	        fixedColumnsBodyRowsHeight: fixedColumnsBodyRowsHeight
	      });
	    };
	
	    _this.handleBodyScrollLeft = function (e) {
	      // Fix https://github.com/ant-design/ant-design/issues/7635
	      if (e.currentTarget !== e.target) {
	        return;
	      }
	
	      var target = e.target;
	      var _this$props$scroll = _this.props.scroll,
	          scroll = _this$props$scroll === void 0 ? {} : _this$props$scroll;
	
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          headTable = _assertThisInitialize.headTable,
	          bodyTable = _assertThisInitialize.bodyTable;
	
	      if (target.scrollLeft !== _this.lastScrollLeft && scroll.x) {
	        if (target === bodyTable && headTable) {
	          headTable.scrollLeft = target.scrollLeft;
	        } else if (target === headTable && bodyTable) {
	          bodyTable.scrollLeft = target.scrollLeft;
	        }
	
	        _this.setScrollPositionClassName();
	      } // Remember last scrollLeft for scroll direction detecting.
	
	
	      _this.lastScrollLeft = target.scrollLeft;
	    };
	
	    _this.handleBodyScrollTop = function (e) {
	      var target = e.target; // Fix https://github.com/ant-design/ant-design/issues/9033
	
	      if (e.currentTarget !== target) {
	        return;
	      }
	
	      var _this$props$scroll2 = _this.props.scroll,
	          scroll = _this$props$scroll2 === void 0 ? {} : _this$props$scroll2;
	
	      var _assertThisInitialize2 = _assertThisInitialized(_this),
	          headTable = _assertThisInitialize2.headTable,
	          bodyTable = _assertThisInitialize2.bodyTable,
	          fixedColumnsBodyLeft = _assertThisInitialize2.fixedColumnsBodyLeft,
	          fixedColumnsBodyRight = _assertThisInitialize2.fixedColumnsBodyRight;
	
	      if (target.scrollTop !== _this.lastScrollTop && scroll.y && target !== headTable) {
	        var scrollTop = target.scrollTop;
	
	        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
	          fixedColumnsBodyLeft.scrollTop = scrollTop;
	        }
	
	        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
	          fixedColumnsBodyRight.scrollTop = scrollTop;
	        }
	
	        if (bodyTable && target !== bodyTable) {
	          bodyTable.scrollTop = scrollTop;
	        }
	      } // Remember last scrollTop for scroll direction detecting.
	
	
	      _this.lastScrollTop = target.scrollTop;
	    };
	
	    _this.handleBodyScroll = function (e) {
	      _this.handleBodyScrollLeft(e);
	
	      _this.handleBodyScrollTop(e);
	    };
	
	    _this.handleWheel = function (event) {
	      var _this$props$scroll3 = _this.props.scroll,
	          scroll = _this$props$scroll3 === void 0 ? {} : _this$props$scroll3;
	
	      if (window.navigator.userAgent.match(/Trident\/7\./) && scroll.y) {
	        var wd = event.deltaY;
	        var target = event.target;
	
	        var _assertThisInitialize3 = _assertThisInitialized(_this),
	            bodyTable = _assertThisInitialize3.bodyTable,
	            fixedColumnsBodyLeft = _assertThisInitialize3.fixedColumnsBodyLeft,
	            fixedColumnsBodyRight = _assertThisInitialize3.fixedColumnsBodyRight;
	
	        var scrollTop = 0;
	
	        if (_this.lastScrollTop) {
	          scrollTop = _this.lastScrollTop + wd;
	        } else {
	          scrollTop = wd;
	        }
	
	        if (fixedColumnsBodyLeft && target !== fixedColumnsBodyLeft) {
	          event.preventDefault();
	          fixedColumnsBodyLeft.scrollTop = scrollTop;
	        }
	
	        if (fixedColumnsBodyRight && target !== fixedColumnsBodyRight) {
	          event.preventDefault();
	          fixedColumnsBodyRight.scrollTop = scrollTop;
	        }
	
	        if (bodyTable && target !== bodyTable) {
	          // https://github.com/ant-design/ant-design/issues/22341
	          event.preventDefault();
	          bodyTable.scrollTop = scrollTop;
	        }
	      }
	    };
	
	    _this.saveRef = function (name) {
	      return function (node) {
	        _this[name] = node;
	      };
	    };
	
	    _this.saveTableNodeRef = function (node) {
	      _this.tableNode = node;
	    };
	
	    ['onRowClick', 'onRowDoubleClick', 'onRowContextMenu', 'onRowMouseEnter', 'onRowMouseLeave'].forEach(function (name) {
	      warning_1.default(props[name] === undefined, "".concat(name, " is deprecated, please use onRow instead."));
	    });
	    warning_1.default(props.getBodyWrapper === undefined, 'getBodyWrapper is deprecated, please use custom components instead.');
	    _this.columnManager = new ColumnManager_1.default(props.columns, props.children);
	    _this.store = mini_store_1.create({
	      currentHoverKey: null,
	      fixedColumnsHeadRowsHeight: [],
	      fixedColumnsBodyRowsHeight: {}
	    });
	
	    _this.setScrollPosition('left');
	
	    _this.debouncedWindowResize = utils_1.debounce(_this.handleWindowResize, 150);
	    return _this;
	  }
	
	  _createClass(Table, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        table: {
	          props: this.props,
	          columnManager: this.columnManager,
	          saveRef: this.saveRef,
	          components: merge_1.default({
	            table: 'table',
	            header: {
	              wrapper: 'thead',
	              row: 'tr',
	              cell: 'th'
	            },
	            body: {
	              wrapper: 'tbody',
	              row: 'tr',
	              cell: 'td'
	            }
	          }, this.props.components)
	        }
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      if (this.columnManager.isAnyColumnsFixed()) {
	        this.handleWindowResize();
	        this.resizeEvent = addEventListener_1.default(window, 'resize', this.debouncedWindowResize);
	      } // https://github.com/ant-design/ant-design/issues/11635
	
	
	      if (this.headTable) {
	        this.headTable.scrollLeft = 0;
	      }
	
	      if (this.bodyTable) {
	        this.bodyTable.scrollLeft = 0;
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      if (this.columnManager.isAnyColumnsFixed()) {
	        this.handleWindowResize();
	
	        if (!this.resizeEvent) {
	          this.resizeEvent = addEventListener_1.default(window, 'resize', this.debouncedWindowResize);
	        }
	      } // when table changes to empty, reset scrollLeft
	
	
	      if (prevProps.data.length > 0 && this.props.data.length === 0 && this.hasScrollX()) {
	        this.resetScrollX();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.resizeEvent) {
	        this.resizeEvent.remove();
	      }
	
	      if (this.debouncedWindowResize) {
	        this.debouncedWindowResize.cancel();
	      }
	    }
	  }, {
	    key: "setScrollPosition",
	    value: function setScrollPosition(position) {
	      this.scrollPosition = position;
	
	      if (this.tableNode) {
	        var prefixCls = this.props.prefixCls;
	
	        if (position === 'both') {
	          component_classes_1.default(this.tableNode).remove(new RegExp("^".concat(prefixCls, "-scroll-position-.+$"))).add("".concat(prefixCls, "-scroll-position-left")).add("".concat(prefixCls, "-scroll-position-right"));
	        } else {
	          component_classes_1.default(this.tableNode).remove(new RegExp("^".concat(prefixCls, "-scroll-position-.+$"))).add("".concat(prefixCls, "-scroll-position-").concat(position));
	        }
	      }
	    }
	  }, {
	    key: "setScrollPositionClassName",
	    value: function setScrollPositionClassName() {
	      var node = this.bodyTable;
	      var scrollToLeft = node.scrollLeft === 0;
	      var scrollToRight = node.scrollLeft + 1 >= node.children[0].getBoundingClientRect().width - node.getBoundingClientRect().width;
	
	      if (scrollToLeft && scrollToRight) {
	        this.setScrollPosition('both');
	      } else if (scrollToLeft) {
	        this.setScrollPosition('left');
	      } else if (scrollToRight) {
	        this.setScrollPosition('right');
	      } else if (this.scrollPosition !== 'middle') {
	        this.setScrollPosition('middle');
	      }
	    }
	  }, {
	    key: "isTableLayoutFixed",
	    value: function isTableLayoutFixed() {
	      var _this$props = this.props,
	          tableLayout = _this$props.tableLayout,
	          _this$props$columns = _this$props.columns,
	          columns = _this$props$columns === void 0 ? [] : _this$props$columns,
	          useFixedHeader = _this$props.useFixedHeader,
	          _this$props$scroll4 = _this$props.scroll,
	          scroll = _this$props$scroll4 === void 0 ? {} : _this$props$scroll4;
	
	      if (typeof tableLayout !== 'undefined') {
	        return tableLayout === 'fixed';
	      } // if one column is ellipsis, use fixed table layout to fix align issue
	
	
	      if (columns.some(function (_ref) {
	        var ellipsis = _ref.ellipsis;
	        return !!ellipsis;
	      })) {
	        return true;
	      } // if header fixed, use fixed table layout to fix align issue
	
	
	      if (useFixedHeader || scroll.y) {
	        return true;
	      } // if scroll.x is number/px/% width value, we should fixed table layout
	      // to avoid long word layout broken issue
	
	
	      if (scroll.x && scroll.x !== true && scroll.x !== 'max-content') {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: "resetScrollX",
	    value: function resetScrollX() {
	      if (this.headTable) {
	        this.headTable.scrollLeft = 0;
	      }
	
	      if (this.bodyTable) {
	        this.bodyTable.scrollLeft = 0;
	      }
	    }
	  }, {
	    key: "hasScrollX",
	    value: function hasScrollX() {
	      var _this$props$scroll5 = this.props.scroll,
	          scroll = _this$props$scroll5 === void 0 ? {} : _this$props$scroll5;
	      return 'x' in scroll;
	    }
	  }, {
	    key: "renderMainTable",
	    value: function renderMainTable() {
	      var _this$props2 = this.props,
	          scroll = _this$props2.scroll,
	          prefixCls = _this$props2.prefixCls;
	      var isAnyColumnsFixed = this.columnManager.isAnyColumnsFixed();
	      var scrollable = isAnyColumnsFixed || scroll.x || scroll.y;
	      var table = [this.renderTable({
	        columns: this.columnManager.groupedColumns(),
	        isAnyColumnsFixed: isAnyColumnsFixed
	      }), this.renderEmptyText(), this.renderFooter()];
	      return scrollable ? React.createElement("div", {
	        className: "".concat(prefixCls, "-scroll")
	      }, table) : table;
	    }
	  }, {
	    key: "renderLeftFixedTable",
	    value: function renderLeftFixedTable() {
	      var prefixCls = this.props.prefixCls;
	      return React.createElement("div", {
	        className: "".concat(prefixCls, "-fixed-left")
	      }, this.renderTable({
	        columns: this.columnManager.leftColumns(),
	        fixed: 'left'
	      }));
	    }
	  }, {
	    key: "renderRightFixedTable",
	    value: function renderRightFixedTable() {
	      var prefixCls = this.props.prefixCls;
	      return React.createElement("div", {
	        className: "".concat(prefixCls, "-fixed-right")
	      }, this.renderTable({
	        columns: this.columnManager.rightColumns(),
	        fixed: 'right'
	      }));
	    }
	  }, {
	    key: "renderTable",
	    value: function renderTable(options) {
	      var columns = options.columns,
	          fixed = options.fixed,
	          isAnyColumnsFixed = options.isAnyColumnsFixed;
	      var _this$props3 = this.props,
	          prefixCls = _this$props3.prefixCls,
	          _this$props3$scroll = _this$props3.scroll,
	          scroll = _this$props3$scroll === void 0 ? {} : _this$props3$scroll;
	      var tableClassName = scroll.x || fixed ? "".concat(prefixCls, "-fixed") : '';
	      var headTable = React.createElement(HeadTable_1.default, {
	        key: "head",
	        columns: columns,
	        fixed: fixed,
	        tableClassName: tableClassName,
	        handleBodyScrollLeft: this.handleBodyScrollLeft,
	        expander: this.expander
	      });
	      var bodyTable = React.createElement(BodyTable_1.default, {
	        key: "body",
	        columns: columns,
	        fixed: fixed,
	        tableClassName: tableClassName,
	        getRowKey: this.getRowKey,
	        handleWheel: this.handleWheel,
	        handleBodyScroll: this.handleBodyScroll,
	        expander: this.expander,
	        isAnyColumnsFixed: isAnyColumnsFixed
	      });
	      return [headTable, bodyTable];
	    }
	  }, {
	    key: "renderTitle",
	    value: function renderTitle() {
	      var _this$props4 = this.props,
	          title = _this$props4.title,
	          prefixCls = _this$props4.prefixCls;
	      return title ? React.createElement("div", {
	        className: "".concat(prefixCls, "-title"),
	        key: "title"
	      }, title(this.props.data)) : null;
	    }
	  }, {
	    key: "renderFooter",
	    value: function renderFooter() {
	      var _this$props5 = this.props,
	          footer = _this$props5.footer,
	          prefixCls = _this$props5.prefixCls;
	      return footer ? React.createElement("div", {
	        className: "".concat(prefixCls, "-footer"),
	        key: "footer"
	      }, footer(this.props.data)) : null;
	    }
	  }, {
	    key: "renderEmptyText",
	    value: function renderEmptyText() {
	      var _this$props6 = this.props,
	          emptyText = _this$props6.emptyText,
	          prefixCls = _this$props6.prefixCls,
	          data = _this$props6.data;
	
	      if (data.length) {
	        return null;
	      }
	
	      var emptyClassName = "".concat(prefixCls, "-placeholder");
	      return React.createElement("div", {
	        className: emptyClassName,
	        key: "emptyText"
	      }, typeof emptyText === 'function' ? emptyText() : emptyText);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classnames_1$default,
	          _this2 = this;
	
	      var props = this.props;
	      var prefixCls = props.prefixCls;
	
	      if (this.state.columns) {
	        this.columnManager.reset(props.columns);
	      } else if (this.state.children) {
	        this.columnManager.reset(null, props.children);
	      }
	
	      var tableClassName = classnames_1.default(props.prefixCls, props.className, (_classnames_1$default = {}, _defineProperty(_classnames_1$default, "".concat(prefixCls, "-fixed-header"), props.useFixedHeader || props.scroll && props.scroll.y), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-scroll-position-left ").concat(prefixCls, "-scroll-position-right"), this.scrollPosition === 'both'), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-scroll-position-").concat(this.scrollPosition), this.scrollPosition !== 'both'), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-layout-fixed"), this.isTableLayoutFixed()), _classnames_1$default));
	      var hasLeftFixed = this.columnManager.isAnyColumnsLeftFixed();
	      var hasRightFixed = this.columnManager.isAnyColumnsRightFixed();
	      var dataAndAriaProps = utils_1.getDataAndAriaProps(props);
	      return React.createElement(mini_store_1.Provider, {
	        store: this.store
	      }, React.createElement(ExpandableTable_1.default, Object.assign({}, props, {
	        columnManager: this.columnManager,
	        getRowKey: this.getRowKey
	      }), function (expander) {
	        _this2.expander = expander;
	        return React.createElement("div", Object.assign({
	          ref: _this2.saveTableNodeRef,
	          className: tableClassName,
	          style: props.style,
	          id: props.id
	        }, dataAndAriaProps), _this2.renderTitle(), React.createElement("div", {
	          className: "".concat(prefixCls, "-content")
	        }, _this2.renderMainTable(), hasLeftFixed && _this2.renderLeftFixedTable(), hasRightFixed && _this2.renderRightFixedTable()));
	      }));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      if (nextProps.columns && nextProps.columns !== prevState.columns) {
	        return {
	          columns: nextProps.columns,
	          children: null
	        };
	      }
	
	      if (nextProps.children !== prevState.children) {
	        return {
	          columns: null,
	          children: nextProps.children
	        };
	      }
	
	      return null;
	    }
	  }]);
	
	  return Table;
	}(React.Component);
	
	Table.childContextTypes = {
	  table: PropTypes.any,
	  components: PropTypes.any
	};
	Table.Column = Column_1.default;
	Table.ColumnGroup = ColumnGroup_1.default;
	Table.defaultProps = {
	  data: [],
	  useFixedHeader: false,
	  rowKey: 'key',
	  rowClassName: function rowClassName() {
	    return '';
	  },
	  onRow: function onRow() {},
	  onHeaderRow: function onHeaderRow() {},
	  prefixCls: 'rc-table',
	  bodyStyle: {},
	  style: {},
	  showHeader: true,
	  scroll: {},
	  rowRef: function rowRef() {
	    return null;
	  },
	  emptyText: function emptyText() {
	    return 'No Data';
	  }
	};
	react_lifecycles_compat_1.polyfill(Table);
	exports.default = Table;

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var classnames_1 = __importDefault(__webpack_require__(9));
	
	var get_1 = __importDefault(__webpack_require__(543));
	
	function isInvalidRenderCellText(text) {
	  return text && !React.isValidElement(text) && Object.prototype.toString.call(text) === '[object Object]';
	}
	
	var TableCell = /*#__PURE__*/function (_React$Component) {
	  _inherits(TableCell, _React$Component);
	
	  var _super = _createSuper(TableCell);
	
	  function TableCell() {
	    var _this;
	
	    _classCallCheck(this, TableCell);
	
	    _this = _super.apply(this, arguments);
	
	    _this.handleClick = function (e) {
	      var _this$props = _this.props,
	          record = _this$props.record,
	          onCellClick = _this$props.column.onCellClick;
	
	      if (onCellClick) {
	        onCellClick(record, e);
	      }
	    };
	
	    return _this;
	  }
	
	  _createClass(TableCell, [{
	    key: "render",
	    value: function render() {
	      var _classnames_1$default;
	
	      var _this$props2 = this.props,
	          record = _this$props2.record,
	          indentSize = _this$props2.indentSize,
	          prefixCls = _this$props2.prefixCls,
	          indent = _this$props2.indent,
	          index = _this$props2.index,
	          expandIcon = _this$props2.expandIcon,
	          column = _this$props2.column,
	          BodyCell = _this$props2.component;
	      var dataIndex = column.dataIndex,
	          render = column.render,
	          _column$className = column.className,
	          className = _column$className === void 0 ? '' : _column$className; // We should return undefined if no dataIndex is specified, but in order to
	      // be compatible with object-path's behavior, we return the record object instead.
	
	      var text;
	
	      if (typeof dataIndex === 'number') {
	        text = get_1.default(record, dataIndex);
	      } else if (!dataIndex || dataIndex.length === 0) {
	        text = record;
	      } else {
	        text = get_1.default(record, dataIndex);
	      }
	
	      var tdProps = {};
	      var colSpan;
	      var rowSpan;
	
	      if (render) {
	        text = render(text, record, index); // `render` support cell with additional config like `props`
	
	        if (isInvalidRenderCellText(text)) {
	          tdProps = text.props || tdProps;
	          var _tdProps = tdProps;
	          colSpan = _tdProps.colSpan;
	          rowSpan = _tdProps.rowSpan;
	          text = text.children;
	        }
	      }
	
	      if (column.onCell) {
	        tdProps = _objectSpread({}, tdProps, {}, column.onCell(record, index));
	      } // Fix https://github.com/ant-design/ant-design/issues/1202
	
	
	      if (isInvalidRenderCellText(text)) {
	        text = null;
	      }
	
	      var indentText = expandIcon ? React.createElement("span", {
	        style: {
	          paddingLeft: "".concat(indentSize * indent, "px")
	        },
	        className: "".concat(prefixCls, "-indent indent-level-").concat(indent)
	      }) : null;
	
	      if (rowSpan === 0 || colSpan === 0) {
	        return null;
	      }
	
	      if (column.align) {
	        tdProps.style = _objectSpread({
	          textAlign: column.align
	        }, tdProps.style);
	      }
	
	      var cellClassName = classnames_1.default(className, (_classnames_1$default = {}, _defineProperty(_classnames_1$default, "".concat(prefixCls, "-cell-ellipsis"), !!column.ellipsis), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-cell-break-word"), !!column.width), _classnames_1$default));
	
	      if (column.ellipsis) {
	        if (typeof text === 'string') {
	          tdProps.title = text;
	        } else if (text) {
	          var _text = text,
	              textProps = _text.props;
	
	          if (textProps && textProps.children && typeof textProps.children === 'string') {
	            tdProps.title = textProps.children;
	          }
	        }
	      }
	
	      return React.createElement(BodyCell, Object.assign({
	        className: cellClassName,
	        onClick: this.handleClick
	      }, tdProps), indentText, expandIcon, text);
	    }
	  }]);
	
	  return TableCell;
	}(React.Component);
	
	exports.default = TableCell;

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var PropTypes = __importStar(__webpack_require__(6));
	
	var TableHeaderRow_1 = __importDefault(__webpack_require__(1373));
	
	function getHeaderRows(_ref) {
	  var _ref$columns = _ref.columns,
	      columns = _ref$columns === void 0 ? [] : _ref$columns,
	      _ref$currentRow = _ref.currentRow,
	      currentRow = _ref$currentRow === void 0 ? 0 : _ref$currentRow,
	      _ref$rows = _ref.rows,
	      rows = _ref$rows === void 0 ? [] : _ref$rows,
	      _ref$isLast = _ref.isLast,
	      isLast = _ref$isLast === void 0 ? true : _ref$isLast;
	  // eslint-disable-next-line no-param-reassign
	  rows[currentRow] = rows[currentRow] || [];
	  columns.forEach(function (column, i) {
	    if (column.rowSpan && rows.length < column.rowSpan) {
	      while (rows.length < column.rowSpan) {
	        rows.push([]);
	      }
	    }
	
	    var cellIsLast = isLast && i === columns.length - 1;
	    var cell = {
	      key: column.key,
	      className: column.className || '',
	      children: column.title,
	      isLast: cellIsLast,
	      column: column
	    };
	
	    if (column.children) {
	      getHeaderRows({
	        columns: column.children,
	        currentRow: currentRow + 1,
	        rows: rows,
	        isLast: cellIsLast
	      });
	    }
	
	    if ('colSpan' in column) {
	      cell.colSpan = column.colSpan;
	    }
	
	    if ('rowSpan' in column) {
	      cell.rowSpan = column.rowSpan;
	    }
	
	    if (cell.colSpan !== 0) {
	      rows[currentRow].push(cell);
	    }
	  });
	  return rows.filter(function (row) {
	    return row.length > 0;
	  });
	}
	
	var TableHeader = function TableHeader(props, _ref2) {
	  var table = _ref2.table;
	  var components = table.components;
	  var _table$props = table.props,
	      prefixCls = _table$props.prefixCls,
	      showHeader = _table$props.showHeader,
	      onHeaderRow = _table$props.onHeaderRow;
	  var expander = props.expander,
	      columns = props.columns,
	      fixed = props.fixed;
	
	  if (!showHeader) {
	    return null;
	  }
	
	  var rows = getHeaderRows({
	    columns: columns
	  });
	  expander.renderExpandIndentCell(rows, fixed);
	  var HeaderWrapper = components.header.wrapper;
	  return React.createElement(HeaderWrapper, {
	    className: "".concat(prefixCls, "-thead")
	  }, rows.map(function (row, index) {
	    return React.createElement(TableHeaderRow_1.default, {
	      prefixCls: prefixCls,
	      key: index,
	      index: index,
	      fixed: fixed,
	      columns: columns,
	      rows: rows,
	      row: row,
	      components: components,
	      onHeaderRow: onHeaderRow
	    });
	  }));
	};
	
	TableHeader.contextTypes = {
	  table: PropTypes.any
	};
	exports.default = TableHeader;

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var __importStar = void 0 && (void 0).__importStar || function (mod) {
	  if (mod && mod.__esModule) return mod;
	  var result = {};
	  if (mod != null) for (var k in mod) {
	    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
	  }
	  result["default"] = mod;
	  return result;
	};
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var React = __importStar(__webpack_require__(1));
	
	var mini_store_1 = __webpack_require__(143);
	
	var classnames_1 = __importDefault(__webpack_require__(9));
	
	function TableHeaderRow(_ref) {
	  var row = _ref.row,
	      index = _ref.index,
	      height = _ref.height,
	      components = _ref.components,
	      onHeaderRow = _ref.onHeaderRow,
	      prefixCls = _ref.prefixCls;
	  var HeaderRow = components.header.row;
	  var HeaderCell = components.header.cell;
	  var rowProps = onHeaderRow(row.map(function (cell) {
	    return cell.column;
	  }), index);
	  var customStyle = rowProps ? rowProps.style : {};
	
	  var style = _objectSpread({
	    // https://github.com/ant-design/ant-design/issues/20126
	    // https://github.com/ant-design/ant-design/issues/20269
	    // https://github.com/ant-design/ant-design/issues/20495
	    height: row.length > 1 && index === 0 && height && height !== 'auto' ? parseInt(height.toString(), 10) : height
	  }, customStyle);
	
	  return React.createElement(HeaderRow, Object.assign({}, rowProps, {
	    style: style
	  }), row.map(function (cell, i) {
	    var _classnames_1$default;
	
	    var column = cell.column,
	        isLast = cell.isLast,
	        cellProps = _objectWithoutProperties(cell, ["column", "isLast"]);
	
	    var customProps = column.onHeaderCell ? column.onHeaderCell(column) : {};
	
	    if (column.align) {
	      customProps.style = _objectSpread({}, customProps.style, {
	        textAlign: column.align
	      });
	    }
	
	    customProps.className = classnames_1.default(customProps.className, column.className, (_classnames_1$default = {}, _defineProperty(_classnames_1$default, "".concat(prefixCls, "-align-").concat(column.align), !!column.align), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-row-cell-ellipsis"), !!column.ellipsis), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-row-cell-break-word"), !!column.width), _defineProperty(_classnames_1$default, "".concat(prefixCls, "-row-cell-last"), isLast), _classnames_1$default));
	    return React.createElement(HeaderCell, Object.assign({}, cellProps, customProps, {
	      key: column.key || column.dataIndex || i
	    }));
	  }));
	}
	
	function getRowHeight(state, props) {
	  var fixedColumnsHeadRowsHeight = state.fixedColumnsHeadRowsHeight;
	  var columns = props.columns,
	      rows = props.rows,
	      fixed = props.fixed;
	  var headerHeight = fixedColumnsHeadRowsHeight[0];
	
	  if (!fixed) {
	    return null;
	  }
	
	  if (headerHeight && columns) {
	    if (headerHeight === 'auto') {
	      return 'auto';
	    }
	
	    return headerHeight / rows.length;
	  }
	
	  return null;
	}
	
	exports.default = mini_store_1.connect(function (state, props) {
	  return {
	    height: getRowHeight(state, props)
	  };
	})(TableHeaderRow);

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
	  return mod && mod.__esModule ? mod : {
	    "default": mod
	  };
	};
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var Table_1 = __importDefault(__webpack_require__(1370));
	
	var Column_1 = __importDefault(__webpack_require__(653));
	
	exports.Column = Column_1.default;
	
	var ColumnGroup_1 = __importDefault(__webpack_require__(654));
	
	exports.ColumnGroup = ColumnGroup_1.default;
	
	var utils_1 = __webpack_require__(228);
	
	exports.INTERNAL_COL_DEFINE = utils_1.INTERNAL_COL_DEFINE;
	exports.default = Table_1.default;

/***/ },
/* 1375 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __webpack_require__(74);
	
	var _validator = __webpack_require__(1388);
	
	var _validator2 = _interopRequireDefault(_validator);
	
	var _messages2 = __webpack_require__(1377);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Encapsulates a validation schema.
	 *
	 *  @param descriptor An object declaring validation rules
	 *  for this schema.
	 */
	function Schema(descriptor) {
	  this.rules = null;
	  this._messages = _messages2.messages;
	  this.define(descriptor);
	}
	
	Schema.prototype = {
	  messages: function messages(_messages) {
	    if (_messages) {
	      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
	    }
	    return this._messages;
	  },
	  define: function define(rules) {
	    if (!rules) {
	      throw new Error('Cannot configure a schema with no rules');
	    }
	    if ((typeof rules === 'undefined' ? 'undefined' : _typeof(rules)) !== 'object' || Array.isArray(rules)) {
	      throw new Error('Rules must be an object');
	    }
	    this.rules = {};
	    var z = void 0;
	    var item = void 0;
	    for (z in rules) {
	      if (rules.hasOwnProperty(z)) {
	        item = rules[z];
	        this.rules[z] = Array.isArray(item) ? item : [item];
	      }
	    }
	  },
	  validate: function validate(source_) {
	    var _this = this;
	
	    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
	
	    var source = source_;
	    var options = o;
	    var callback = oc;
	    if (typeof options === 'function') {
	      callback = options;
	      options = {};
	    }
	    if (!this.rules || Object.keys(this.rules).length === 0) {
	      if (callback) {
	        callback();
	      }
	      return Promise.resolve();
	    }
	
	    function complete(results) {
	      var i = void 0;
	      var errors = [];
	      var fields = {};
	
	      function add(e) {
	        if (Array.isArray(e)) {
	          var _errors;
	
	          errors = (_errors = errors).concat.apply(_errors, e);
	        } else {
	          errors.push(e);
	        }
	      }
	
	      for (i = 0; i < results.length; i++) {
	        add(results[i]);
	      }
	      if (!errors.length) {
	        errors = null;
	        fields = null;
	      } else {
	        fields = (0, _util.convertFieldsError)(errors);
	      }
	      callback(errors, fields);
	    }
	
	    if (options.messages) {
	      var messages = this.messages();
	      if (messages === _messages2.messages) {
	        messages = (0, _messages2.newMessages)();
	      }
	      (0, _util.deepMerge)(messages, options.messages);
	      options.messages = messages;
	    } else {
	      options.messages = this.messages();
	    }
	    var arr = void 0;
	    var value = void 0;
	    var series = {};
	    var keys = options.keys || Object.keys(this.rules);
	    keys.forEach(function (z) {
	      arr = _this.rules[z];
	      value = source[z];
	      arr.forEach(function (r) {
	        var rule = r;
	        if (typeof rule.transform === 'function') {
	          if (source === source_) {
	            source = _extends({}, source);
	          }
	          value = source[z] = rule.transform(value);
	        }
	        if (typeof rule === 'function') {
	          rule = {
	            validator: rule
	          };
	        } else {
	          rule = _extends({}, rule);
	        }
	        rule.validator = _this.getValidationMethod(rule);
	        rule.field = z;
	        rule.fullField = rule.fullField || z;
	        rule.type = _this.getType(rule);
	        if (!rule.validator) {
	          return;
	        }
	        series[z] = series[z] || [];
	        series[z].push({
	          rule: rule,
	          value: value,
	          source: source,
	          field: z
	        });
	      });
	    });
	    var errorFields = {};
	    return (0, _util.asyncMap)(series, options, function (data, doIt) {
	      var rule = data.rule;
	      var deep = (rule.type === 'object' || rule.type === 'array') && (_typeof(rule.fields) === 'object' || _typeof(rule.defaultField) === 'object');
	      deep = deep && (rule.required || !rule.required && data.value);
	      rule.field = data.field;
	
	      function addFullfield(key, schema) {
	        return _extends({}, schema, {
	          fullField: rule.fullField + '.' + key
	        });
	      }
	
	      function cb() {
	        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	        var errors = e;
	        if (!Array.isArray(errors)) {
	          errors = [errors];
	        }
	        if (!options.suppressWarning && errors.length) {
	          Schema.warning('async-validator:', errors);
	        }
	        if (errors.length && rule.message) {
	          errors = [].concat(rule.message);
	        }
	
	        errors = errors.map((0, _util.complementError)(rule));
	
	        if (options.first && errors.length) {
	          errorFields[rule.field] = 1;
	          return doIt(errors);
	        }
	        if (!deep) {
	          doIt(errors);
	        } else {
	          // if rule is required but the target object
	          // does not exist fail at the rule level and don't
	          // go deeper
	          if (rule.required && !data.value) {
	            if (rule.message) {
	              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
	            } else if (options.error) {
	              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
	            } else {
	              errors = [];
	            }
	            return doIt(errors);
	          }
	
	          var fieldsSchema = {};
	          if (rule.defaultField) {
	            for (var k in data.value) {
	              if (data.value.hasOwnProperty(k)) {
	                fieldsSchema[k] = rule.defaultField;
	              }
	            }
	          }
	          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
	          for (var f in fieldsSchema) {
	            if (fieldsSchema.hasOwnProperty(f)) {
	              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
	              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
	            }
	          }
	          var schema = new Schema(fieldsSchema);
	          schema.messages(options.messages);
	          if (data.rule.options) {
	            data.rule.options.messages = options.messages;
	            data.rule.options.error = options.error;
	          }
	          schema.validate(data.value, data.rule.options || options, function (errs) {
	            var finalErrors = [];
	            if (errors && errors.length) {
	              finalErrors.push.apply(finalErrors, errors);
	            }
	            if (errs && errs.length) {
	              finalErrors.push.apply(finalErrors, errs);
	            }
	            doIt(finalErrors.length ? finalErrors : null);
	          });
	        }
	      }
	
	      var res = void 0;
	      if (rule.asyncValidator) {
	        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
	      } else if (rule.validator) {
	        res = rule.validator(rule, data.value, cb, data.source, options);
	        if (res === true) {
	          cb();
	        } else if (res === false) {
	          cb(rule.message || rule.field + ' fails');
	        } else if (res instanceof Array) {
	          cb(res);
	        } else if (res instanceof Error) {
	          cb(res.message);
	        }
	      }
	      if (res && res.then) {
	        res.then(function () {
	          return cb();
	        }, function (e) {
	          return cb(e);
	        });
	      }
	    }, function (results) {
	      complete(results);
	    });
	  },
	  getType: function getType(rule) {
	    if (rule.type === undefined && rule.pattern instanceof RegExp) {
	      rule.type = 'pattern';
	    }
	    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
	      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
	    }
	    return rule.type || 'string';
	  },
	  getValidationMethod: function getValidationMethod(rule) {
	    if (typeof rule.validator === 'function') {
	      return rule.validator;
	    }
	    var keys = Object.keys(rule);
	    var messageIndex = keys.indexOf('message');
	    if (messageIndex !== -1) {
	      keys.splice(messageIndex, 1);
	    }
	    if (keys.length === 1 && keys[0] === 'required') {
	      return _validator2['default'].required;
	    }
	    return _validator2['default'][this.getType(rule)] || false;
	  }
	};
	
	Schema.register = function register(type, validator) {
	  if (typeof validator !== 'function') {
	    throw new Error('Cannot register a validator by type, validator is not a function');
	  }
	  _validator2['default'][type] = validator;
	};
	
	Schema.warning = _util.warning;
	
	Schema.messages = _messages2.messages;
	
	exports['default'] = Schema;
	module.exports = exports['default'];

/***/ },
/* 1377 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.newMessages = newMessages;
	function newMessages() {
	  return {
	    'default': 'Validation error on field %s',
	    required: '%s is required',
	    'enum': '%s must be one of %s',
	    whitespace: '%s cannot be empty',
	    date: {
	      format: '%s date %s is invalid for format %s',
	      parse: '%s date could not be parsed, %s is invalid ',
	      invalid: '%s date %s is invalid'
	    },
	    types: {
	      string: '%s is not a %s',
	      method: '%s is not a %s (function)',
	      array: '%s is not an %s',
	      object: '%s is not an %s',
	      number: '%s is not a %s',
	      date: '%s is not a %s',
	      boolean: '%s is not a %s',
	      integer: '%s is not an %s',
	      float: '%s is not a %s',
	      regexp: '%s is not a valid %s',
	      email: '%s is not a valid %s',
	      url: '%s is not a valid %s',
	      hex: '%s is not a valid %s'
	    },
	    string: {
	      len: '%s must be exactly %s characters',
	      min: '%s must be at least %s characters',
	      max: '%s cannot be longer than %s characters',
	      range: '%s must be between %s and %s characters'
	    },
	    number: {
	      len: '%s must equal %s',
	      min: '%s cannot be less than %s',
	      max: '%s cannot be greater than %s',
	      range: '%s must be between %s and %s'
	    },
	    array: {
	      len: '%s must be exactly %s in length',
	      min: '%s cannot be less than %s in length',
	      max: '%s cannot be greater than %s in length',
	      range: '%s must be between %s and %s in length'
	    },
	    pattern: {
	      mismatch: '%s value %s does not match pattern %s'
	    },
	    clone: function clone() {
	      var cloned = JSON.parse(JSON.stringify(this));
	      cloned.clone = this.clone;
	      return cloned;
	    }
	  };
	}
	
	var messages = exports.messages = newMessages();

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _util = __webpack_require__(74);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	var ENUM = 'enum';
	
	/**
	 *  Rule for validating a value exists in an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, source, errors, options) {
	  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
	  if (rule[ENUM].indexOf(value) === -1) {
	    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
	  }
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _util = __webpack_require__(74);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating a regular expression pattern.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, source, errors, options) {
	  if (rule.pattern) {
	    if (rule.pattern instanceof RegExp) {
	      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
	      // flag is accidentally set to `true`, which in a validation scenario
	      // is not necessary and the result might be misleading
	      rule.pattern.lastIndex = 0;
	      if (!rule.pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    } else if (typeof rule.pattern === 'string') {
	      var _pattern = new RegExp(rule.pattern);
	      if (!_pattern.test(value)) {
	        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
	      }
	    }
	  }
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _util = __webpack_require__(74);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating minimum and maximum allowed values.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function range(rule, value, source, errors, options) {
	  var len = typeof rule.len === 'number';
	  var min = typeof rule.min === 'number';
	  var max = typeof rule.max === 'number';
	  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
	  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	  var val = value;
	  var key = null;
	  var num = typeof value === 'number';
	  var str = typeof value === 'string';
	  var arr = Array.isArray(value);
	  if (num) {
	    key = 'number';
	  } else if (str) {
	    key = 'string';
	  } else if (arr) {
	    key = 'array';
	  }
	  // if the value is not of a supported type for range validation
	  // the validation rule rule should use the
	  // type property to also test for a particular type
	  if (!key) {
	    return false;
	  }
	  if (arr) {
	    val = value.length;
	  }
	  if (str) {
	    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
	    val = value.replace(spRegexp, '_').length;
	  }
	  if (len) {
	    if (val !== rule.len) {
	      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
	    }
	  } else if (min && !max && val < rule.min) {
	    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
	  } else if (max && !min && val > rule.max) {
	    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
	  } else if (min && max && (val < rule.min || val > rule.max)) {
	    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
	  }
	}
	
	exports['default'] = range;
	module.exports = exports['default'];

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _util = __webpack_require__(74);
	
	var util = _interopRequireWildcard(_util);
	
	var _required = __webpack_require__(656);
	
	var _required2 = _interopRequireDefault(_required);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/* eslint max-len:0 */
	
	var pattern = {
	  // http://emailregex.com/
	  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
	  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
	  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
	};
	
	var types = {
	  integer: function integer(value) {
	    return types.number(value) && parseInt(value, 10) === value;
	  },
	  float: function float(value) {
	    return types.number(value) && !types.integer(value);
	  },
	  array: function array(value) {
	    return Array.isArray(value);
	  },
	  regexp: function regexp(value) {
	    if (value instanceof RegExp) {
	      return true;
	    }
	    try {
	      return !!new RegExp(value);
	    } catch (e) {
	      return false;
	    }
	  },
	  date: function date(value) {
	    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
	  },
	  number: function number(value) {
	    if (isNaN(value)) {
	      return false;
	    }
	    return typeof value === 'number';
	  },
	  object: function object(value) {
	    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !types.array(value);
	  },
	  method: function method(value) {
	    return typeof value === 'function';
	  },
	  email: function email(value) {
	    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
	  },
	  url: function url(value) {
	    return typeof value === 'string' && !!value.match(pattern.url);
	  },
	  hex: function hex(value) {
	    return typeof value === 'string' && !!value.match(pattern.hex);
	  }
	};
	
	/**
	 *  Rule for validating the type of a value.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function type(rule, value, source, errors, options) {
	  if (rule.required && value === undefined) {
	    (0, _required2['default'])(rule, value, source, errors, options);
	    return;
	  }
	  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
	  var ruleType = rule.type;
	  if (custom.indexOf(ruleType) > -1) {
	    if (!types[ruleType](value)) {
	      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	    }
	    // straight typeof check
	  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== rule.type) {
	    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
	  }
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _util = __webpack_require__(74);
	
	var util = _interopRequireWildcard(_util);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	/**
	 *  Rule for validating whitespace.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param source The source object being validated.
	 *  @param errors An array of errors that this rule may add
	 *  validation errors to.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function whitespace(rule, value, source, errors, options) {
	  if (/^\s+$/.test(value) || value === '') {
	    errors.push(util.format(options.messages.whitespace, rule.fullField));
	  }
	}
	
	exports['default'] = whitespace;
	module.exports = exports['default'];

/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an array.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function array(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'array');
	    if (!(0, _util.isEmptyValue)(value, 'array')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = array;
	module.exports = exports['default'];

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _util = __webpack_require__(74);
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a boolean.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function boolean(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = boolean;
	module.exports = exports['default'];

/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function date(rule, value, callback, source, options) {
	  // console.log('integer rule called %j', rule);
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  // console.log('validate on %s value', value);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      var dateObject = void 0;
	
	      if (typeof value === 'number') {
	        dateObject = new Date(value);
	      } else {
	        dateObject = value;
	      }
	
	      _rule2['default'].type(rule, dateObject, source, errors, options);
	      if (dateObject) {
	        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = date;
	module.exports = exports['default'];

/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ENUM = 'enum';
	
	/**
	 *  Validates an enumerable list.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function enumerable(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value) {
	      _rule2['default'][ENUM](rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = enumerable;
	module.exports = exports['default'];

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is a floating point number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function floatFn(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = floatFn;
	module.exports = exports['default'];

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _string = __webpack_require__(1396);
	
	var _string2 = _interopRequireDefault(_string);
	
	var _method = __webpack_require__(1390);
	
	var _method2 = _interopRequireDefault(_method);
	
	var _number = __webpack_require__(1391);
	
	var _number2 = _interopRequireDefault(_number);
	
	var _boolean = __webpack_require__(1384);
	
	var _boolean2 = _interopRequireDefault(_boolean);
	
	var _regexp = __webpack_require__(1394);
	
	var _regexp2 = _interopRequireDefault(_regexp);
	
	var _integer = __webpack_require__(1389);
	
	var _integer2 = _interopRequireDefault(_integer);
	
	var _float = __webpack_require__(1387);
	
	var _float2 = _interopRequireDefault(_float);
	
	var _array = __webpack_require__(1383);
	
	var _array2 = _interopRequireDefault(_array);
	
	var _object = __webpack_require__(1392);
	
	var _object2 = _interopRequireDefault(_object);
	
	var _enum = __webpack_require__(1386);
	
	var _enum2 = _interopRequireDefault(_enum);
	
	var _pattern = __webpack_require__(1393);
	
	var _pattern2 = _interopRequireDefault(_pattern);
	
	var _date = __webpack_require__(1385);
	
	var _date2 = _interopRequireDefault(_date);
	
	var _required = __webpack_require__(1395);
	
	var _required2 = _interopRequireDefault(_required);
	
	var _type = __webpack_require__(1397);
	
	var _type2 = _interopRequireDefault(_type);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = {
	  string: _string2['default'],
	  method: _method2['default'],
	  number: _number2['default'],
	  boolean: _boolean2['default'],
	  regexp: _regexp2['default'],
	  integer: _integer2['default'],
	  float: _float2['default'],
	  array: _array2['default'],
	  object: _object2['default'],
	  'enum': _enum2['default'],
	  pattern: _pattern2['default'],
	  date: _date2['default'],
	  url: _type2['default'],
	  hex: _type2['default'],
	  email: _type2['default'],
	  required: _required2['default']
	};
	module.exports = exports['default'];

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number is an integer.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function integer(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = integer;
	module.exports = exports['default'];

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a function.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function method(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = method;
	module.exports = exports['default'];

/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a number.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function number(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if (value === '') {
	      value = undefined;
	    }
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = number;
	module.exports = exports['default'];

/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates an object.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function object(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (value !== undefined) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = object;
	module.exports = exports['default'];

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates a regular expression pattern.
	 *
	 *  Performs validation when a rule only contains
	 *  a pattern property but is not declared as a string type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function pattern(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].pattern(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = pattern;
	module.exports = exports['default'];

/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Validates the regular expression type.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function regexp(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options);
	    if (!(0, _util.isEmptyValue)(value)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = regexp;
	module.exports = exports['default'];

/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function required(rule, value, callback, source, options) {
	  var errors = [];
	  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : _typeof(value);
	  _rule2['default'].required(rule, value, source, errors, options, type);
	  callback(errors);
	}
	
	exports['default'] = required;
	module.exports = exports['default'];

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 *  Performs validation for string types.
	 *
	 *  @param rule The validation rule.
	 *  @param value The value of the field on the source object.
	 *  @param callback The callback function.
	 *  @param source The source object being validated.
	 *  @param options The validation options.
	 *  @param options.messages The validation messages.
	 */
	function string(rule, value, callback, source, options) {
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, 'string');
	    if (!(0, _util.isEmptyValue)(value, 'string')) {
	      _rule2['default'].type(rule, value, source, errors, options);
	      _rule2['default'].range(rule, value, source, errors, options);
	      _rule2['default'].pattern(rule, value, source, errors, options);
	      if (rule.whitespace === true) {
	        _rule2['default'].whitespace(rule, value, source, errors, options);
	      }
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = string;
	module.exports = exports['default'];

/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _rule = __webpack_require__(88);
	
	var _rule2 = _interopRequireDefault(_rule);
	
	var _util = __webpack_require__(74);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function type(rule, value, callback, source, options) {
	  var ruleType = rule.type;
	  var errors = [];
	  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
	  if (validate) {
	    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
	      return callback();
	    }
	    _rule2['default'].required(rule, value, source, errors, options, ruleType);
	    if (!(0, _util.isEmptyValue)(value, ruleType)) {
	      _rule2['default'].type(rule, value, source, errors, options);
	    }
	  }
	  callback(errors);
	}
	
	exports['default'] = type;
	module.exports = exports['default'];

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'root' },
	        this.props.children || 'loading...'
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.querySaveTalk = exports.queryTalkList = undefined;
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var queryTalkList = exports.queryTalkList = function () {
	  var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee(params) {
	    return _regenerator2.default.wrap(function _callee$(_context) {
	      while (1) {
	        switch (_context.prev = _context.next) {
	          case 0:
	            return _context.abrupt('return', _http2.default.get(_req.common.TALK_LIST, params));
	
	          case 1:
	          case 'end':
	            return _context.stop();
	        }
	      }
	    }, _callee, this);
	  }));
	
	  return function queryTalkList(_x) {
	    return _ref.apply(this, arguments);
	  };
	}();
	
	var querySaveTalk = exports.querySaveTalk = function () {
	  var _ref2 = _asyncToGenerator(_regenerator2.default.mark(function _callee2(params) {
	    return _regenerator2.default.wrap(function _callee2$(_context2) {
	      while (1) {
	        switch (_context2.prev = _context2.next) {
	          case 0:
	            return _context2.abrupt('return', _http2.default.post(_req.common.TALK_SAVE, params));
	
	          case 1:
	          case 'end':
	            return _context2.stop();
	        }
	      }
	    }, _callee2, this);
	  }));
	
	  return function querySaveTalk(_x2) {
	    return _ref2.apply(this, arguments);
	  };
	}();
	
	var _http = __webpack_require__(38);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            * The main api service
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                            */

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _account_info = __webpack_require__(729);
	
	var _local = __webpack_require__(1825);
	
	var _local2 = _interopRequireDefault(_local);
	
	var _Siderbar = __webpack_require__(1505);
	
	var _Siderbar2 = _interopRequireDefault(_Siderbar);
	
	var _Header = __webpack_require__(1500);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Index = __webpack_require__(714);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable no-unused-vars */
	
	
	var Content = _antd.Layout.Content,
	    Sider = _antd.Layout.Sider,
	    Header = _antd.Layout.Header;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.logout = function () {
	      var router = _this.props.router;
	
	      _local2.default.clearUser();
	      _antd.message.info('您已退出系统！');
	      router.push('/login');
	    };
	
	    _this.itemRender = function (route, params, routes, paths) {
	      if (routes.indexOf(route) === 0) {
	        // 首页
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/' + paths.join('/') },
	          _react2.default.createElement(_antd.Icon, { type: 'home' }),
	          route.breadcrumbName
	        );
	      }
	      if (routes.indexOf(route) === routes.length - 1) {
	        // 最后一页
	        return _react2.default.createElement(
	          'span',
	          null,
	          route.breadcrumbName
	        );
	      }
	      return _react2.default.createElement(
	        _reactRouter.Link,
	        { to: '/' + paths.join('/') },
	        route.breadcrumbName
	      );
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.current = 1;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch((0, _account_info.getAccountInfo)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          routes = _props.routes,
	          params = _props.params;
	
	      var loginUser = _local2.default.getUser();
	      var _document = document,
	          domain = _document.domain;
	
	
	      var Page = this.props.children ? this.props.children : _react2.default.createElement(_Index2.default, this.props);
	      return _react2.default.createElement(
	        _antd.Layout,
	        { style: { height: '100%' } },
	        _react2.default.createElement(
	          _antd.Layout,
	          null,
	          _react2.default.createElement(
	            Sider,
	            null,
	            _react2.default.createElement(_Siderbar2.default, this.props)
	          ),
	          _react2.default.createElement(
	            _antd.Layout,
	            null,
	            _react2.default.createElement(
	              Header,
	              { style: { background: '#fff', padding: 0 } },
	              _react2.default.createElement(_Header2.default, this.props)
	            ),
	            _react2.default.createElement(
	              Content,
	              {
	                style: {
	                  padding: 15,
	                  minWidth: 1040,
	                  paddingBottom: 0,
	                  background: '#ececec',
	                  height: '100%'
	                },
	                id: 'boxbox',
	                className: 'localContent'
	              },
	              Page
	            )
	          )
	        ),
	        ')'
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    account_info: state.account_info
	  };
	})(Index);

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _blueimpMd = __webpack_require__(743);
	
	var _blueimpMd2 = _interopRequireDefault(_blueimpMd);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _user = __webpack_require__(441);
	
	var _menu = __webpack_require__(439);
	
	var _api = __webpack_require__(421);
	
	var _login_banner = __webpack_require__(2966);
	
	var _login_banner2 = _interopRequireDefault(_login_banner);
	
	var _login_pic = __webpack_require__(2967);
	
	var _login_pic2 = _interopRequireDefault(_login_pic);
	
	__webpack_require__(2947);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Login = function (_Component) {
	  _inherits(Login, _Component);
	
	  function Login(props) {
	    _classCallCheck(this, Login);
	
	    var _this = _possibleConstructorReturn(this, (Login.__proto__ || Object.getPrototypeOf(Login)).call(this, props));
	
	    _this.submit = function (e) {
	      e.preventDefault();
	      var user = _this.props.form.getFieldsValue();
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          user.password = (0, _blueimpMd2.default)(user.password);
	          _this.httpLogin(user);
	        }
	      });
	    };
	
	    _this.httpLogin = function (user) {
	      var _this$props = _this.props,
	          router = _this$props.router,
	          dispatch = _this$props.dispatch;
	
	      (0, _api.queryLogin)(user).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('欢迎登陆！');
	          _localDb2.default.set('token', res.data.token);
	          dispatch((0, _user.setUser)());
	          dispatch((0, _menu.getMenu)());
	          router.push('/');
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Login, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'login_main' },
	        _react2.default.createElement('div', { className: 'login_blue' }),
	        _react2.default.createElement(
	          'div',
	          { className: 'login_center' },
	          _react2.default.createElement('img', { className: 'login_top', src: _login_banner2.default, alt: _login_banner2.default, width: 250 }),
	          _react2.default.createElement(
	            'div',
	            { className: 'login_box' },
	            _react2.default.createElement(
	              _antd.Row,
	              { type: 'flex', align: 'middle' },
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 14 },
	                _react2.default.createElement('img', { src: _login_pic2.default, alt: _login_pic2.default })
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 10 },
	                _react2.default.createElement(
	                  _antd.Card,
	                  { title: '\u7528\u6237\u767B\u5F55', bordered: false },
	                  _react2.default.createElement(
	                    _antd.Form,
	                    { onSubmit: this.submit },
	                    _react2.default.createElement(
	                      FormItem,
	                      null,
	                      getFieldDecorator('account', {
	                        rules: [{ required: true, message: '请输入您的用户名!' }]
	                      })(_react2.default.createElement(_antd.Input, { prefix: _react2.default.createElement(_antd.Icon, { type: 'user' }), placeholder: '\u7528\u6237\u540D' }))
	                    ),
	                    _react2.default.createElement(
	                      FormItem,
	                      null,
	                      getFieldDecorator('password', {
	                        rules: [{ required: true, message: '请输入您的密码!' }]
	                      })(_react2.default.createElement(_antd.Input, { prefix: _react2.default.createElement(_antd.Icon, { type: 'lock' }), type: 'password', placeholder: '\u5BC6\u7801' }))
	                    ),
	                    _react2.default.createElement(
	                      FormItem,
	                      null,
	                      getFieldDecorator('remember', {
	                        valuePropName: 'checked',
	                        initialValue: true
	                      })(_react2.default.createElement(
	                        _antd.Checkbox,
	                        null,
	                        '\u8BB0\u4F4F\u6211'
	                      ))
	                    ),
	                    _react2.default.createElement(
	                      FormItem,
	                      null,
	                      _react2.default.createElement(
	                        _antd.Button,
	                        { style: { width: '100%' }, type: 'primary', htmlType: 'submit' },
	                        '\u767B\u5F55'
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Login;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create()(Login));

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 404页面
	
	
	var NotFound = function (_Component) {
	  _inherits(NotFound, _Component);
	
	  function NotFound(props) {
	    _classCallCheck(this, NotFound);
	
	    var _this = _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(NotFound, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Not Found Anything.'
	        )
	      );
	    }
	  }]);
	
	  return NotFound;
	}(_react.Component);
	
	exports.default = NotFound;

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Test = function (_Component) {
	  _inherits(Test, _Component);
	
	  function Test(props) {
	    _classCallCheck(this, Test);
	
	    var _this = _possibleConstructorReturn(this, (Test.__proto__ || Object.getPrototypeOf(Test)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Test, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_UploadFile2.default, { type: 'ghost', handleUpload: {}, fileList: [] });
	    }
	  }]);
	
	  return Test;
	}(_react.Component);
	
	exports.default = Test;

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// In the fifth row, other columns are merged into first column
	// by setting it's colSpan to be 0
	
	
	var renderContent = function renderContent(value, row, index) {
	  var obj = {
	    children: value,
	    props: {}
	  };
	  if (index === 4) {
	    obj.props.colSpan = 0;
	  }
	  return obj;
	};
	
	var columns = [{
	  title: 'Name',
	  dataIndex: 'name',
	  render: function render(text, row, index) {
	    if (index === 2) {
	      return {
	        children: _react2.default.createElement(
	          'a',
	          { href: '#' },
	          text
	        ),
	        props: {
	          rowSpan: 2
	        }
	      };
	    }
	    if (index === 3) {
	      return {
	        children: _react2.default.createElement(
	          'a',
	          { href: '#' },
	          text
	        ),
	        props: {
	          rowSpan: 0
	        }
	      };
	    }
	    if (index < 4) {
	      return _react2.default.createElement(
	        'a',
	        { href: '#' },
	        text
	      );
	    }
	    return {
	      children: _react2.default.createElement(
	        'a',
	        { href: '#' },
	        text
	      ),
	      props: {
	        colSpan: 5
	      }
	    };
	  }
	}, {
	  title: 'Age',
	  dataIndex: 'age',
	  render: renderContent
	}, {
	  title: 'Home phone',
	  colSpan: 2,
	  dataIndex: 'tel',
	  render: function render(value, row, index) {
	    var obj = {
	      children: value,
	      props: {}
	    };
	    if (index === 4) {
	      obj.props.colSpan = 0;
	    }
	    return obj;
	  }
	}, {
	  title: 'Phone',
	  colSpan: 0,
	  dataIndex: 'phone',
	  render: renderContent
	}, {
	  title: 'Address',
	  dataIndex: 'address',
	  render: renderContent
	}];
	
	var data = [{
	  key: '1',
	  name: 'John Brown',
	  age: 32,
	  tel: '0571-22098909',
	  phone: 18889898989,
	  address: 'New York No. 1 Lake Park'
	}, {
	  key: '2',
	  name: 'Jim Green',
	  tel: '0571-22098333',
	  phone: 18889898888,
	  age: 42,
	  address: 'London No. 1 Lake Park'
	}, {
	  key: '3',
	  name: 'Joe Black',
	  age: 32,
	  tel: '0575-22098909',
	  phone: 18900010002,
	  address: 'Sidney No. 1 Lake Park',
	  children: [{
	    key: '10',
	    name: 'Joe Black',
	    age: 32,
	    tel: '0575-22098909',
	    phone: 18900010002,
	    address: 'Sidney No. 1 Lake Park'
	  }]
	}, {
	  key: '4',
	  name: 'Jim Red',
	  age: 18,
	  tel: '0575-22098909',
	  phone: 18900010002,
	  address: 'London No. 2 Lake Park'
	}, {
	  key: '5',
	  name: 'Jake White',
	  age: 18,
	  tel: '0575-22098909',
	  phone: 18900010002,
	  address: 'Dublin No. 2 Lake Park'
	}];
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_antd.Table, { columns: columns, dataSource: data, bordered: true });
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _BackBtn = __webpack_require__(12);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	
	var categoryName = ['文档', '链接'];
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handSubmit = _this.props.handSubmit;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handSubmit(values);
	        }
	      });
	    };
	
	    _this.handleCategoryChange = function (value) {
	      _this.setState({ category: value });
	    };
	
	    _this.handleUpload = function (fileList) {
	      var file = {};
	      if (fileList && fileList.length > 0) {
	        file = fileList[0];
	        _this.props.form.setFieldsValue({
	          url: file.url
	        });
	      }
	    };
	
	    _this.state = {
	      category: 0,
	      files: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.dataInfo.url) {
	        this.setState({
	          files: [{ name: nextProps.dataInfo.title, url: nextProps.dataInfo.url }]
	        });
	      }
	      if (this.props.dataInfo.category !== nextProps.dataInfo.category) {
	        this.setState({
	          category: nextProps.dataInfo.category
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var dataInfo = this.props.dataInfo;
	      var _state = this.state,
	          category = _state.category,
	          files = _state.files;
	
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', style: { marginRight: 10 }, htmlType: 'submit' },
	            '\u786E\u8BA4'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6807\u9898' }, ItemLayout),
	                getFieldDecorator('title', {
	                  rules: [{
	                    required: true,
	                    message: '填写标题'
	                  }],
	                  initialValue: dataInfo.title
	                })(_react2.default.createElement(_antd.Input, { type: 'text', placeholder: '\u6807\u9898' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7C7B\u578B' }, ItemLayout),
	                getFieldDecorator('type', {
	                  initialValue: dataInfo.type || 0
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  null,
	                  _react2.default.createElement(
	                    Option,
	                    { value: 0 },
	                    '\u516C\u53F8\u516C\u544A'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { value: 1 },
	                    '\u4E1A\u52A1\u52A8\u6001'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7C7B\u578B' }, ItemLayout),
	                getFieldDecorator('category', {
	                  initialValue: dataInfo.category || 0
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { onChange: this.handleCategoryChange },
	                  _react2.default.createElement(
	                    Option,
	                    { value: 0 },
	                    '\u6587\u6863'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { value: 1 },
	                    '\u94FE\u63A5'
	                  )
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '' + categoryName[category] }, ItemLayout),
	                getFieldDecorator('url', {
	                  rules: [{
	                    required: true,
	                    message: categoryName[category] + '\u4E0D\u80FD\u4E3A\u7A7A'
	                  }],
	                  initialValue: category === 1 ? dataInfo.url : files
	                })(category === 1 ? _react2.default.createElement(_antd.Input, { placeholder: '\u94FE\u63A5', type: 'text' }) : _react2.default.createElement(_UploadFile2.default, { handleUpload: this.handleUpload, fileList: files, limit: 1 }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(BaseForm);

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _announcement = __webpack_require__(322);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var typeName = ['公司公告', '业务动态'];
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo) {
	      var params = {};
	      var condition = _this.state.condition;
	
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      _this.setState({
	        pageNo: current,
	        isLoading: true
	      });
	      (0, _announcement.queryAnnouncementList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var pageNo = _this.state.pageNo;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.loadData(pageNo);
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.judge = function (accountInfo) {
	      var role = accountInfo.roles;
	      var isPermission = false;
	      role.forEach(function (sign) {
	        if (sign === '[XZManager]' || sign === '[HRVP]' || sign === '[HrManager]') {
	          isPermission = true;
	        }
	      });
	      if (accountInfo.admin) {
	        isPermission = true;
	      }
	
	      _this.setState({
	        isPermission: isPermission
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '标题',
	        dataIndex: 'title',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/administrative/announcement/edit/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '类型',
	        dataIndex: 'type',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            typeName[text]
	          );
	        }
	      }, {
	        title: '更新时间',
	        dataIndex: 'updateTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm:ss')
	          );
	        }
	      }, {
	        title: '操作',
	        render: function render(text, record) {
	          var isPermission = _this.state.isPermission;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/administrative/announcement/open/' + record.uuid },
	              '\u67E5\u770B'
	            ),
	            isPermission ? _react2.default.createElement('span', { className: 'ant-divider' }) : null,
	            isPermission ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/administrative/announcement/edit/' + record.uuid },
	              '\u7F16\u8F91'
	            ) : null
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: true,
	      total: 0,
	      pageNo: 1,
	      isPermission: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	      this.judge(this.props.account_info);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          pageNo = _state.pageNo,
	          condition = _state.condition;
	
	      var params = {
	        pageNo: pageNo,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    // 加载需公告列表数据
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          data = _state2.data,
	          isLoading = _state2.isLoading,
	          total = _state2.total,
	          pageNo = _state2.pageNo,
	          isPermission = _state2.isPermission;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 13 },
	              isPermission ? _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/administrative/announcement/add' },
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary' },
	                  '\u6DFB\u52A0'
	                )
	              ) : null
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          loading: isLoading,
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    account_info: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Index));

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _announcement = __webpack_require__(322);
	
	var _PageAdd2 = __webpack_require__(658);
	
	var _PageAdd3 = _interopRequireDefault(_PageAdd2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageEdit = function (_PageAdd) {
	  _inherits(PageEdit, _PageAdd);
	
	  function PageEdit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PageEdit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PageEdit.__proto__ || Object.getPrototypeOf(PageEdit)).call.apply(_ref, [this].concat(args))), _this), _this.getAnnouncement = function () {
	      (0, _announcement.queryAnnouncementInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PageEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAnnouncement();
	    }
	  }]);
	
	  return PageEdit;
	}(_PageAdd3.default);
	
	exports.default = PageEdit;

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _BackBtn = __webpack_require__(12);
	
	var _announcement = __webpack_require__(322);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	
	var typeName = ['公司公告', '业务动态'];
	var categoryName = ['文档', '链接'];
	
	var PageOpen = function (_Component) {
	  _inherits(PageOpen, _Component);
	
	  function PageOpen(props) {
	    _classCallCheck(this, PageOpen);
	
	    var _this = _possibleConstructorReturn(this, (PageOpen.__proto__ || Object.getPrototypeOf(PageOpen)).call(this, props));
	
	    _this.getAnnouncementInfo = function () {
	      (0, _announcement.queryAnnouncementInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      data: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageOpen, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAnnouncementInfo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Row,
	          { style: { paddingBottom: '20px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 13 },
	            _react2.default.createElement(_BackBtn.BackBtn, null)
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u516C\u544A\u4FE1\u606F' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u6807\u9898' },
	              data.title,
	              '\u5143'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7C7B\u578B' },
	              typeName[data.type]
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u516C\u544A\u683C\u5F0F' },
	              categoryName[data.category]
	            ),
	            data.category === 1 ? _react2.default.createElement(
	              Description,
	              { term: '\u9644\u4EF6' },
	              _react2.default.createElement(
	                'a',
	                {
	                  href: 'http://preview.oa.vcchina.com/upload?url=' + data.url,
	                  target: '_blank',
	                  rel: 'noreferrer'
	                },
	                data.title
	              )
	            ) : _react2.default.createElement(
	              Description,
	              { term: '\u8FDE\u63A5' },
	              _react2.default.createElement(
	                'a',
	                { href: '' + data.url, target: '_blank', rel: 'noreferrer' },
	                data.url
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PageOpen;
	}(_react.Component);
	
	exports.default = PageOpen;

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _TreeOrg = __webpack_require__(662);
	
	var _TreeOrg2 = _interopRequireDefault(_TreeOrg);
	
	var _ModalAdd = __webpack_require__(659);
	
	var _ModalAdd2 = _interopRequireDefault(_ModalAdd);
	
	var _TableOrg = __webpack_require__(661);
	
	var _TableOrg2 = _interopRequireDefault(_TableOrg);
	
	var _SelectDatabase = __webpack_require__(660);
	
	var _SelectDatabase2 = _interopRequireDefault(_SelectDatabase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var confirm = _antd.Modal.confirm;
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    var _this3 = this;
	
	    _classCallCheck(this, Index);
	
	    var _this2 = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this2.initialPage = function () {
	      (0, _material.queryMaterialDatabaseList)().then(function (res) {
	        // 资料库列表
	        if (res.statusCode === 200) {
	          _this2.setState({
	            databaseList: res.data || [],
	            databaseUuid: res.data[0] ? res.data[0].uuid : '',
	            databaseName: res.data[0] ? res.data[0].name : ''
	          }, function () {
	            var _this2$state = _this2.state,
	                databaseUuid = _this2$state.databaseUuid,
	                databaseName = _this2$state.databaseName;
	
	            _this2.handleDatabaseChange(databaseUuid, {
	              props: { children: databaseName }
	            });
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.getDatabaseType = function () {
	      var databaseUuid = _this2.state.databaseUuid;
	
	      (0, _material.queryMaterialDatabaseType)({ databaseUuid: databaseUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            types: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.getDatabaseList = function () {
	      (0, _material.queryMaterialDatabaseList)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            databaseList: res.data || []
	          });
	          _this2.databaseList = res.data;
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.getDatabaseInfo = function () {
	      var databaseUuid = _this2.state.databaseUuid;
	
	      (0, _material.queryMaterialDatabaseInfo)({ uuid: databaseUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            databaseInfo: res.data || []
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.getDatabaseDelete = function () {
	      var databaseUuid = _this2.state.databaseUuid;
	
	      _this2.getMaterialDatabaseDelete({ uuid: databaseUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	          _this2.initialPage();
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.getDirectoryList = function () {
	      var databaseUuid = _this2.state.databaseUuid;
	
	      (0, _material.queryMaterialDirectoryList)({
	        databaseUuid: databaseUuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            directoryList: res.data || []
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.getDocumentList = function () {
	      var _this2$state2 = _this2.state,
	          databaseUuid = _this2$state2.databaseUuid,
	          directoryUuid = _this2$state2.directoryUuid,
	          documentType = _this2$state2.documentType,
	          documentCondition = _this2$state2.documentCondition;
	
	      var params = Object.assign({
	        databaseUuid: databaseUuid,
	        directoryUuid: directoryUuid,
	        type: documentType
	      }, _this2.pagination, {
	        condition: documentCondition
	      });
	      _this2.setState({
	        isLoading: true
	      });
	      (0, _material.queryMaterialDocumentList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            documentList: res.data || [],
	            pagination: {
	              total: res.totalSize,
	              pageSize: 15,
	              current: _this2.current
	            },
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.handleDatabaseChange = function (value, option) {
	      _this2.pagination = {
	        limit: 15,
	        start: 1
	      };
	      _this2.current = 1;
	      _this2.setState({
	        databaseUuid: value,
	        databaseName: option.props.children,
	        directory: '',
	        directoryUuid: ''
	      }, function () {
	        _this2.getDirectoryList();
	        _this2.getDatabaseType();
	        _this2.getDocumentList();
	      });
	    };
	
	    _this2.handleDirectorySelect = function (value) {
	      _this2.setState({
	        directoryUuid: value.uuid,
	        directory: value.name
	      }, function () {
	        _this2.getDocumentList();
	      });
	    };
	
	    _this2.handleSearch = function () {
	      _this2.props.form.validateFields(function (err, values) {
	        var documentType = values.documentType || '';
	        var documentCondition = values.condition || '';
	        _this2.setState({
	          documentType: documentType,
	          documentCondition: documentCondition
	        }, function () {
	          _this2.getDocumentList();
	        });
	      });
	    };
	
	    _this2.hideModalAdd = function (flag) {
	      _this2.setState({
	        addVisible: !!flag
	      });
	    };
	
	    _this2.addDatabase = function () {
	      _this2.setState({ isAddType: true }, function () {
	        _this2.hideModalAdd(true);
	      });
	    };
	
	    _this2.editDatabase = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var databaseUuid;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              databaseUuid = _this2.state.databaseUuid;
	              _context.next = 3;
	              return _this2.getDatabaseInfo(databaseUuid);
	
	            case 3:
	              _this2.setState({ isAddType: false }, function () {
	                _this2.hideModalAdd(true);
	              });
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this3);
	    }));
	
	    _this2.databaseAddSubmit = function (params) {
	      (0, _material.queryMaterialDatabaseSave)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this2.getDatabaseList();
	          _this2.hideModalAdd();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.showDel = function () {
	      var _this = _this2;
	      confirm({
	        title: '确定删除该资料库?',
	        onOk: function onOk() {
	          _this.getDatabaseDelete();
	        }
	      });
	    };
	
	    _this2.documentAdd = function () {
	      var _this2$state3 = _this2.state,
	          databaseUuid = _this2$state3.databaseUuid,
	          directoryUuid = _this2$state3.directoryUuid;
	
	      _this2.props.router.push({
	        pathname: '/administrative/material/add/new',
	        query: {
	          databaseUuid: databaseUuid,
	          directoryUuid: directoryUuid
	        }
	      });
	    };
	
	    _this2.handleDel = function (uuid) {
	      (0, _material.queryDeleteMaterialDocument)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	          _this2.getDocumentList();
	        }
	      });
	    };
	
	    _this2.handleTableChange = function (pagination) {
	      _this2.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this2.current = pagination.current;
	      _this2.getDocumentList();
	    };
	
	    _this2.state = {
	      databaseName: '',
	      databaseUuid: '',
	      databaseList: [],
	      databaseInfo: {},
	
	      directory: '',
	      directoryUuid: '',
	      directoryList: [],
	
	      documentList: [],
	      types: [],
	      documentType: '',
	      documentCondition: '',
	
	      pagination: {},
	      isLoading: false,
	      addVisible: false,
	      isAddType: true
	    };
	    return _this2;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this4 = this;
	
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        this.getDatabaseList();
	        // 分页设置
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	        this.setState({
	          databaseName: backInfo.databaseName,
	          databaseUuid: backInfo.databaseUuid,
	          directory: backInfo.directory,
	          directoryUuid: backInfo.directoryUuid,
	          documentType: backInfo.documentType,
	          documentCondition: backInfo.documentCondition
	        }, function () {
	          _this4.getDatabaseType();
	          _this4.getDirectoryList();
	          _this4.getDocumentList();
	        });
	      } else {
	        this.initialPage();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          databaseName = _state.databaseName,
	          databaseUuid = _state.databaseUuid,
	          directory = _state.directory,
	          directoryUuid = _state.directoryUuid,
	          documentType = _state.documentType,
	          documentCondition = _state.documentCondition;
	
	      var params = Object.assign({
	        path: this.props.location.pathname
	      }, this.pagination, {
	        databaseName: databaseName,
	        databaseUuid: databaseUuid,
	        directory: directory,
	        directoryUuid: directoryUuid,
	        documentType: documentType || '',
	        documentCondition: documentCondition || ''
	      });
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 页面初始状态
	
	
	    // 获取资料类型
	
	
	    // 资料库列表
	
	
	    // 资料库详情
	
	
	    // 资料库删除
	
	
	    // 资料目录列表
	
	
	    // 资料文档列表
	
	
	    // 资料库改变
	
	
	    // 资料目录选中
	
	
	    // 资料文档搜索
	
	
	    /** ------------------新增/编辑资料库--------------------------------------------*/
	    // 弹窗开关
	
	
	    // 新增的弹窗
	
	
	    // 编辑的弹窗
	
	
	    // 提交
	
	
	    /**-----------------------------------------------------------------------------*/
	    // 删除资料库
	
	
	    // 添加资料文档
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _state2 = this.state,
	          databaseUuid = _state2.databaseUuid,
	          databaseName = _state2.databaseName,
	          databaseList = _state2.databaseList,
	          databaseInfo = _state2.databaseInfo,
	          directoryUuid = _state2.directoryUuid,
	          directoryList = _state2.directoryList,
	          documentList = _state2.documentList,
	          types = _state2.types,
	          pagination = _state2.pagination,
	          documentType = _state2.documentType,
	          documentCondition = _state2.documentCondition,
	          isLoading = _state2.isLoading,
	          isAddType = _state2.isAddType;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var parentProps = {
	        databaseUuid: databaseUuid,
	        databaseName: databaseName,
	        directoryUuid: directoryUuid,
	        documentList: documentList,
	        pagination: pagination,
	        isLoading: isLoading,
	        handleDel: this.handleDel,
	        onChange: this.handleTableChange
	      };
	
	      var formItemLayout = {
	        labelCol: {
	          xs: { span: 12 },
	          sm: { span: 6 }
	        },
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 18 },
	          md: { span: 18 }
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 6 },
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '15px' } },
	            _react2.default.createElement(_SelectDatabase2.default, {
	              data: databaseList,
	              onChange: this.handleDatabaseChange,
	              value: databaseUuid
	            })
	          ),
	          _react2.default.createElement(_TreeOrg2.default, {
	            data: directoryList,
	            database: databaseName,
	            databaseUuid: databaseUuid,
	            directoryUuid: directoryUuid,
	            onSelect: this.handleDirectorySelect,
	            getDirectoryList: this.getDirectoryList
	          })
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 18, style: { paddingLeft: '2%' } },
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'end', style: { paddingBottom: '15px' } },
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: this.documentAdd },
	              '+ \u6DFB\u52A0\u8D44\u6599'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { style: { marginLeft: '10px' }, onClick: this.editDatabase },
	              '\u7F16\u8F91\u8D44\u6599\u5E93'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { style: { marginLeft: '10px' }, onClick: this.addDatabase },
	              '\u65B0\u589E\u8D44\u6599\u5E93'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { style: { marginLeft: '10px' }, onClick: this.showDel },
	              '\u5220\u9664\u8D44\u6599\u5E93'
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Card,
	            null,
	            _react2.default.createElement(
	              _antd.Form,
	              null,
	              _react2.default.createElement(
	                _antd.Row,
	                null,
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 6 },
	                  _react2.default.createElement(
	                    FormItem,
	                    Object.assign({ label: '\u7C7B\u578B' }, formItemLayout),
	                    getFieldDecorator('documentType', {
	                      initialValue: documentType
	                    })(_react2.default.createElement(
	                      _antd.Select,
	                      { allowClear: true },
	                      types.map(function (item) {
	                        return _react2.default.createElement(
	                          _antd.Select.Option,
	                          { value: item.name, key: item.name },
	                          item.name
	                        );
	                      })
	                    ))
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 4, style: { paddingLeft: '10px', paddingRight: '10px' } },
	                  _react2.default.createElement(
	                    FormItem,
	                    null,
	                    getFieldDecorator('condition', {
	                      initialValue: documentCondition
	                    })(_react2.default.createElement(_antd.Input, { placeholder: '\u5176\u4ED6\u641C\u7D22' }))
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 3 },
	                  _react2.default.createElement(
	                    FormItem,
	                    null,
	                    _react2.default.createElement(
	                      _antd.Button,
	                      { type: 'primary', onClick: this.handleSearch },
	                      '\u641C\u7D22'
	                    )
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(_TableOrg2.default, parentProps)
	          )
	        ),
	        _react2.default.createElement(_ModalAdd2.default, {
	          visible: this.state.addVisible,
	          onOk: this.databaseAddSubmit,
	          onCancel: function onCancel() {
	            return _this5.hideModalAdd(false);
	          },
	          data: isAddType ? {} : databaseInfo
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create()(Index));

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _TableOrg = __webpack_require__(1411);
	
	var _TableOrg2 = _interopRequireDefault(_TableOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getDocumentList = function () {
	      var documentCondition = _this.state.documentCondition;
	
	      var params = Object.assign({}, _this.pagination, {
	        condition: documentCondition
	      });
	      _this.setState({
	        isLoading: true
	      });
	      (0, _material.queryMaterialDocumentListBR)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            documentList: res.data || [],
	            pagination: {
	              total: res.totalSize,
	              pageSize: 15,
	              current: _this.current
	            },
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.handleSearch = function () {
	      _this.props.form.validateFields(function (err, values) {
	        var documentCondition = values.condition || '';
	        _this.pagination = {
	          limit: 15,
	          start: 1
	        };
	        _this.current = 1;
	        _this.setState({
	          documentCondition: documentCondition
	        }, function () {
	          _this.getDocumentList();
	        });
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.getDocumentList();
	    };
	
	    _this.state = {
	      documentList: [],
	      documentCondition: '',
	
	      pagination: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        // 分页设置
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	        this.setState({
	          documentCondition: backInfo.documentCondition
	        }, function () {
	          _this2.getDocumentList();
	        });
	      } else {
	        this.getDocumentList();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var documentCondition = this.state.documentCondition;
	
	      var params = Object.assign({
	        path: this.props.location.pathname
	      }, this.pagination, {
	        documentCondition: documentCondition || ''
	      });
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 资料文档列表
	
	
	    // 资料文档搜索
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          documentList = _state.documentList,
	          pagination = _state.pagination,
	          documentCondition = _state.documentCondition,
	          isLoading = _state.isLoading;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var parentProps = {
	        documentList: documentList,
	        pagination: pagination,
	        isLoading: isLoading,
	        handleDel: this.handleDel,
	        onChange: this.handleTableChange
	      };
	
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 4, style: { paddingRight: '10px' } },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                getFieldDecorator('condition', {
	                  initialValue: documentCondition
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 3 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary', onClick: this.handleSearch },
	                  '\u641C\u7D22'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_TableOrg2.default, parentProps)
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create()(Index));

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableOrg = function (_Component) {
	  _inherits(TableOrg, _Component);
	
	  function TableOrg(props) {
	    _classCallCheck(this, TableOrg);
	
	    var _this = _possibleConstructorReturn(this, (TableOrg.__proto__ || Object.getPrototypeOf(TableOrg)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '文件编号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/administrative/material/info/' + record.uuid },
	            _react2.default.createElement(
	              _antd.Popover,
	              { content: record.no },
	              _react2.default.createElement(
	                'p',
	                {
	                  style: {
	                    width: '180px',
	                    margin: '0',
	                    overflow: 'hidden',
	                    whiteSpace: 'nowrap',
	                    textOverflow: 'ellipsis'
	                  }
	                },
	                record.no
	              )
	            )
	          );
	        }
	      }, {
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text) {
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: text },
	            _react2.default.createElement(
	              'p',
	              {
	                style: {
	                  width: '200px',
	                  margin: '0',
	                  overflow: 'hidden',
	                  whiteSpace: 'nowrap',
	                  textOverflow: 'ellipsis'
	                }
	              },
	              text
	            )
	          );
	        }
	      }, {
	        title: '文件类型',
	        dataIndex: 'type',
	        key: 'type'
	      }, {
	        title: '文件有效期',
	        dataIndex: 'beginDate',
	        key: 'beginDate',
	        render: function render(text, record) {
	          var endDate = '';
	          var beginDate = '';
	          endDate = record.endDate ? (0, _moment2.default)(record.endDate).format('YYYY-MM-DD') : '永久';
	          beginDate = record.beginDate ? (0, _moment2.default)(record.beginDate).format('YYYY-MM-DD') : '';
	          return _react2.default.createElement(
	            'span',
	            null,
	            beginDate,
	            '\u81F3',
	            endDate
	          );
	        }
	      }, {
	        title: '所属公司',
	        dataIndex: 'company',
	        key: 'company'
	      }, {
	        title: '所属资料库',
	        dataIndex: 'database',
	        key: 'database'
	      }, {
	        title: '管理员',
	        dataIndex: 'manager',
	        key: 'manager'
	      }, {
	        title: '总量/库存',
	        dataIndex: 'amount',
	        key: 'amount',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.amount,
	            '/',
	            record.number || 0
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        key: 'status',
	        render: function render(text) {
	          switch (text) {
	            case 1:
	              return '有效';
	            case 2:
	              return '失效';
	            default:
	          }
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(TableOrg, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          documentList = _props.documentList,
	          pagination = _props.pagination,
	          isLoading = _props.isLoading;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Table, {
	          loading: isLoading
	          // style={{ height: "200px" }}
	          , onChange: this.handleChange,
	          columns: this.columns(),
	          dataSource: documentList,
	          pagination: pagination,
	          rowKey: 'uuid'
	        })
	      );
	    }
	  }]);
	
	  return TableOrg;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(TableOrg);

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.submit = function () {
	      var _this$props = _this.props,
	          data = _this$props.data,
	          isAddType = _this$props.isAddType,
	          databaseUuid = _this$props.databaseUuid,
	          database = _this$props.database;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = {};
	          if (isAddType) {
	            params.parentUuid = null;
	            data && data.uuid && (params.parentUuid = data.uuid);
	          } else {
	            params.uuid = data.uuid;
	            params.parentUuid = data.parentUuid;
	          }
	          params.name = values.name;
	          params.database = database;
	          params.databaseUuid = databaseUuid;
	          _this.props.onOk(params);
	          _this.props.form.resetFields();
	        }
	      });
	    };
	
	    _this.onCancel = function () {
	      _this.props.form.resetFields();
	      _this.props.onCancel();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          data = _props.data,
	          isAddType = _props.isAddType;
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: isAddType ? '创建资料目录' : '编辑资料目录',
	          visible: this.props.visible,
	          onOk: this.submit,
	          onCancel: this.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u8D44\u6599\u76EE\u5F55\u540D\u79F0' }, formItemLayout),
	            getFieldDecorator('name', {
	              rules: [{ required: true, message: '请填写资料目录名称' }],
	              initialValue: isAddType ? null : data.name
	            })(_react2.default.createElement(_antd.Input, null))
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(IndexModal));

/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	var _attachment = __webpack_require__(27);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(59);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.getMaterialDocumentType = function () {
	      (0, _material.queryMaterialDocumentType)().then(function (res) {
	        if (res.statusCode !== 200) {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.findTypeName = function (type) {
	      var typeName = '';
	      _this.props.expendType.forEach(function (item) {
	        if (type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.columns = function () {
	      var dataItem = _this.state.dataItem;
	
	      return [{
	        title: '文件编号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          var waterMark = +dataItem.instance.status === 1 ? dataItem.waterMark || '\u4EC5\u9650' + dataItem.createUserName + '\u67E5\u770B' : '\u4EC5\u9650' + dataItem.createUserName + '\u67E5\u770B';
	          var file = void 0;
	          if (record.files && record.files.length > 0) {
	            file = record.files[0];
	          } else {
	            file = record;
	          }
	          return _react2.default.createElement(
	            'div',
	            { key: record.url },
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return (0, _attachment.queryFilePreview)(file, waterMark);
	                } },
	              record.no
	            )
	          );
	        }
	      }, {
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '所属公司',
	        dataIndex: 'company',
	        key: 'company'
	      }, {
	        title: '所属资料库',
	        dataIndex: 'database',
	        key: 'database'
	      }, {
	        title: '文件类型',
	        dataIndex: 'type',
	        key: 'type'
	      }, {
	        title: '文件有效期',
	        dataIndex: 'beginDate',
	        key: 'beginDate',
	        render: function render(text, record) {
	          var beginDate = '';
	          var endDate = '';
	          beginDate = record.beginDate ? (0, _moment2.default)(record.beginDate).format('YYYY-MM-DD') : '';
	          endDate = record.endDate ? (0, _moment2.default)(record.endDate).format('YYYY-MM-DD') : '永久';
	          return _react2.default.createElement(
	            'span',
	            null,
	            beginDate,
	            '\u81F3',
	            endDate
	          );
	        }
	      }, {
	        title: '管理员',
	        dataIndex: 'manager',
	        key: 'manager'
	      }, {
	        title: '总量/库存',
	        dataIndex: 'amount',
	        key: 'amount',
	        render: function render(text, record) {
	          return record.amount + '/' + record.number;
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        key: 'status',
	        render: function render(text) {
	          switch (text) {
	            case 1:
	              return '有效';
	            case 0:
	              return '无效';
	            default:
	          }
	        }
	      }];
	    };
	
	    _this.state = {
	      dataItem: _this.props.data
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getMaterialDocumentType();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataItem: nextProps.data
	      });
	    }
	
	    // 获取资料类型
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataItem = this.state.dataItem;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u8D44\u6599\u501F\u7528\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u501F\u7528\u6D41\u6C34' },
	              dataItem.no
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u501F\u7528\u7533\u8BF7\u4EBA' },
	              dataItem.createUserName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u501F\u7528\u7C7B\u578B' },
	              +dataItem.type ? '电子版' : '纸质原件'
	            ),
	            +dataItem.type ? _react2.default.createElement(
	              Description,
	              { term: '\u6C34\u5370\u6587\u5B57' },
	              dataItem.waterMark
	            ) : null,
	            +dataItem.type ? null : _react2.default.createElement(
	              Description,
	              { term: '\u501F\u7528\u6570\u91CF' },
	              dataItem.number
	            ),
	            +dataItem.type ? null : _react2.default.createElement(
	              Description,
	              { term: '\u7EA6\u5B9A\u5F52\u8FD8' },
	              (0, _moment2.default)(dataItem.expectReturnDate).format('YYYY-MM-DD')
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u501F\u7528\u8BF4\u660E' },
	              dataItem.reason
	            )
	          ),
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            dataSource: [dataItem.document],
	            pagination: false,
	            rowKey: 'uuid',
	            style: { marginTop: '10px' }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = Open;

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination) {
	      _this.props.onChange(pagination);
	    };
	
	    _this.onSelectChange = function (selectedRowKeys, selectedRows) {
	      _this.setState({
	        selectedRowKeys: selectedRowKeys,
	        selectedRows: selectedRows
	      });
	    };
	
	    _this.handleOk = function () {
	      var _this$state = _this.state,
	          selectedRowKeys = _this$state.selectedRowKeys,
	          selectedRows = _this$state.selectedRows;
	
	      selectedRowKeys && selectedRows && _this.props.onSelectChange(selectedRowKeys, selectedRows);
	      _this.props.handleCancel();
	    };
	
	    _this.handleCancel = function () {
	      _this.props.handleCancel();
	    };
	
	    _this.handleSearch = function () {
	      _this.props.form.validateFields(function (err, values) {
	        var condition = values.condition || '';
	        _this.props.handleSearch(condition);
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '文件编号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            { key: record.url },
	            _react2.default.createElement(
	              'a',
	              {
	                onClick: function onClick() {
	                  return (0, _attachment.queryFilePreview)(record.files[0], '\u4EC5\u9650' + _this.props.accountInfo.userName + '\u67E5\u770B');
	                }
	              },
	              record.no
	            )
	          );
	        }
	      }, {
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '文件类型',
	        dataIndex: 'type',
	        key: 'type'
	      }, {
	        title: '文件有效期',
	        dataIndex: 'beginDate',
	        key: 'beginDate',
	        render: function render(text, record) {
	          var beginDate = '';
	          beginDate = record.beginDate ? (0, _moment2.default)(record.beginDate).format('YYYY-MM-DD') : '';
	          var endDate = '';
	          endDate = record.endDate ? (0, _moment2.default)(record.endDate).format('YYYY-MM-DD') : '永久';
	          return _react2.default.createElement(
	            'span',
	            null,
	            beginDate,
	            '\u81F3',
	            endDate
	          );
	        }
	      }, {
	        title: '所属公司',
	        dataIndex: 'company',
	        key: 'company'
	      }, {
	        title: '所属资料库',
	        dataIndex: 'database',
	        key: 'database'
	      }, {
	        title: '管理员',
	        dataIndex: 'manager',
	        key: 'manager'
	      }, {
	        title: '总量/库存',
	        dataIndex: 'amount',
	        key: 'amount',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.amount,
	            '/',
	            record.number || 0
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource,
	      selectedRowKeys: []
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var selectedRowKeys = this.props.selectedRowKeys;
	
	      this.setState({ selectedRowKeys: selectedRowKeys });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var selectedRowKeys = nextProps.selectedRowKeys;
	
	      this.setState({
	        dataSource: nextProps.dataSource,
	        selectedRowKeys: selectedRowKeys
	      });
	    }
	
	    // 分页跳转
	
	
	    // 选中
	
	
	    // 确认
	
	
	    // 关闭
	
	
	    // 资料文档搜索
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          _state$dataSource = _state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination,
	          selectedRowKeys = _state.selectedRowKeys;
	      var isLoading = this.props.isLoading;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var rowSelection = {
	        selectedRowKeys: selectedRowKeys,
	        onChange: this.onSelectChange,
	        type: 'radio'
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u8D44\u6599\u5217\u8868',
	          visible: this.props.visible,
	          onCancel: this.handleCancel,
	          onOk: this.handleOk,
	          width: '90%'
	        },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4, style: { paddingRight: '10px' } },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('condition', {
	                initialValue: this.props.condition
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 3 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', onClick: this.handleSearch },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          tableLayout: 'inline',
	          loading: isLoading,
	          rowSelection: rowSelection,
	          onChange: this.handleChange,
	          columns: this.columns(),
	          pagination: pagination,
	          dataSource: list,
	          rowKey: 'uuid'
	        })
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(Manage));

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _company_list = __webpack_require__(96);
	
	var _expend_type = __webpack_require__(80);
	
	var _FormBase = __webpack_require__(663);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveMaterialBorrow(item);
	    };
	
	    _this.materialBorrowWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _material.queryMaterialBorrowWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveMaterialBorrow = function (item) {
	      _this.setState({ isSubmitting: true });
	      (0, _material.querySaveMaterialBorrow)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	          _this.setState({ isSubmitting: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isSubmitting: false });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.materialBorrowWorkflow();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	      dispatch((0, _company_list.getCompanyList)());
	    }
	
	    /**
	     * 提交资料借用
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, { data: dataInfo, handSubmit: this.handSubmit, isSubmitting: isSubmitting }),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance })
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(Page);

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _reactRouter = __webpack_require__(8);
	
	var _material = __webpack_require__(50);
	
	var _FormBase = __webpack_require__(663);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveMaterialBorrow(item);
	    };
	
	    _this.materialBorrowWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _material.queryMaterialBorrowWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveMaterialBorrow = function (item) {
	      _this.setState({ isSubmitting: true });
	      (0, _material.querySaveMaterialBorrow)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isSubmitting: false });
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	          _this.setState({ isSubmitting: false });
	        } else {
	          _this.setState({
	            isSubmitting: false
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({});
	    };
	
	    _this.deleteMaterialBorrow = function () {
	      (0, _material.queryDeleteMaterialBorrow)({
	        uuid: _this.props.data.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.materialBorrowWorkflow();
	    }
	
	    /**
	     * 提交资料借用
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, Object.assign({
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          handleDelete: this.deleteMaterialBorrow,
	          isSubmitting: isSubmitting
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _PageEdit = __webpack_require__(1416);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1419);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getMaterialBorrowInfo = function () {
	      (0, _material.queryMaterialBorrowInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getMaterialBorrowInfo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	      // return <PageOpen data={dataInfo} {...this.props} />;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = PageInfo;

/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _material = __webpack_require__(50);
	
	__webpack_require__(59);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _FormSearch = __webpack_require__(153);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(664);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.setState({});
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getMaterialBorrowMyList = function (params) {
	      _this.setState({ loading: true });
	      (0, _material.queryMaterialBorrowMyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getMaterialBorrowMyList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        loading: false,
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        type: 'mine',
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/administrative/material/borrow_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u8D44\u6599\u501F\u7528'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(_TableExpenses2.default, parentProps)
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _material = __webpack_require__(50);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _WorkflowOp = __webpack_require__(134);
	
	var _WorkflowOp2 = _interopRequireDefault(_WorkflowOp);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _FormOpen = __webpack_require__(1413);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.doTask = function (pass, refuse) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackMaterialBorrow(item);
	          break;
	        case 'next':
	          _this.nextMaterialBorrow(item);
	          break;
	        case 'return':
	          _this.returnMaterialBorrow(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackMaterialBorrow = function (params) {
	      (0, _material.queryCallbackMaterialBorrow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextMaterialBorrow = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _material.queryNextMaterialBorrow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnMaterialBorrow = function (params, refuse) {
	      (0, _material.queryReturnMaterialBorrow)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null
	          );
	        }
	      }, {
	        title: '操作内容',
	        dataIndex: 'operating'
	      }, {
	        title: '处理意见',
	        dataIndex: 'refuse'
	      }];
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ dataInfo: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowOp2.default, {
	          op: 'materialBorrow',
	          data: dataInfo,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_FormOpen2.default, Object.assign({ data: dataInfo, doTask: this.doTask, watchTask: this.watchTask }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'materialBorrow', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	__webpack_require__(59);
	
	var _reactRedux = __webpack_require__(5);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	var _back_info = __webpack_require__(19);
	
	var _TableExpenses = __webpack_require__(664);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getMaterialBorrowList = function (params) {
	      _this.setState({ loading: true });
	      (0, _material.queryMaterialBorrowList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getMaterialBorrowList(params);
	    };
	
	    _this.handleReturnCancel = function () {};
	
	    _this.handleSaveReturn = function (data) {
	      var params = data;
	      (0, _material.querySaveMaterialReturn)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	          _this.handleReturnCancel();
	        } else {
	          _antd.message.error(res.message, 2.5);
	          _this.handleReturnCancel();
	        }
	      });
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition))
	        ),
	        _react2.default.createElement(_TableExpenses2.default, parentProps)
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create()(PageManage));

/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _material = __webpack_require__(50);
	
	var _attachment = __webpack_require__(27);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _orgStructure = __webpack_require__(683);
	
	var _orgStructure2 = _interopRequireDefault(_orgStructure);
	
	var _BackBtn = __webpack_require__(12);
	
	var _SearchUser = __webpack_require__(273);
	
	var _SearchUser2 = _interopRequireDefault(_SearchUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.getMaterialDatabaseType = function (databaseUuid) {
	      (0, _material.queryMaterialDatabaseType)({ databaseUuid: databaseUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            documentType: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.checkedChange = function (list) {
	      _this.setState({
	        viewTypes: list
	      });
	    };
	
	    _this.checkedRadioChange = function () {};
	
	    _this.handleUserChange = function (value, option) {
	      _this.props.form.setFieldsValue({ renewalUserName: option.props.children });
	    };
	
	    _this.showLable = function (label) {
	      var text = label[label.length - 1];
	      return text;
	    };
	
	    _this.formatArr = function (arr, uuid) {
	      arr.map(function (item) {
	        if (item.uuid === uuid) {
	          _this.defaultArr = item.valueArr;
	        } else if (item.children && item.children.length > 0) {
	          _this.formatArr(item.children, uuid);
	        }
	
	        return item;
	      });
	    };
	
	    _this.formatOption = function (obj, arr) {
	      arr.map(function (item) {
	        item.value = item.uuid;
	        item.label = item.name;
	        if (obj === '') {
	          item.valueArr = [item.uuid];
	        } else {
	          var newValueArr = obj.valueArr.slice(0);
	          newValueArr.push(item.uuid);
	          item.valueArr = newValueArr;
	        }
	        if (item.children && item.children.length > 0) {
	          _this.formatOption(item, item.children);
	        }
	        return item;
	      });
	    };
	
	    _this.formatName = function (arr, uuid) {
	      arr.map(function (item) {
	        if (item.uuid === uuid) {
	          _this.directory = item.name;
	        } else if (item.children && item.children.length > 0) {
	          _this.formatName(item.children, uuid);
	        }
	
	        return item;
	      });
	    };
	
	    _this.handleCompanyChange = function (value, option) {
	      _this.props.form.setFieldsValue({
	        company: option.props.children
	      });
	    };
	
	    _this.showDrawer = function () {
	      _this.setState({
	        DrawerVisible: true
	      });
	    };
	
	    _this.closeDrawer = function () {
	      _this.setState({
	        DrawerVisible: false
	      });
	    };
	
	    _this.setViews = function (views) {
	      _this.setState({ views: views });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.submit = function (e) {
	      var _this$props = _this.props,
	          data = _this$props.data,
	          databaseInfo = _this$props.databaseInfo,
	          userList = _this$props.userList,
	          directoryList = _this$props.directoryList;
	      var _this$state = _this.state,
	          authorityMixes = _this$state.authorityMixes,
	          views = _this$state.views;
	
	      if (e) {
	        e.preventDefault();
	      }
	      _this.props.form.validateFields(function (err, value) {
	        if (!err) {
	          var params = data ? Object.assign({}, data) : {};
	
	          data && data.uuid && (params.uuid = data.uuid);
	          params.name = value.name;
	          params.no = value.no;
	          params.databaseUuid = databaseInfo.uuid;
	          params.database = databaseInfo.name;
	          params.directoryUuid = value.directoryUuid[value.directoryUuid.length - 1];
	          _this.formatName(directoryList, params.directoryUuid);
	          params.directory = _this.directory;
	          params.companyUuid = value.companyUuid;
	          params.company = value.company;
	          params.type = value.type;
	          params.beginDate = value.beginDate ? value.beginDate.format('YYYY-MM-DD') : null;
	          params.endDate = value.endDate ? value.endDate.format('YYYY-MM-DD') : null;
	          params.manager = databaseInfo.manager;
	          params.managerUuid = databaseInfo.managerUuid;
	          params.amount = value.amount;
	          params.number = value.number;
	          params.status = value.status;
	          params.isRenewal = value.isRenewal;
	          if (value.isRenewal) {
	            params.renewalUserUuid = value.renewalUserUuid;
	            params.renewalUserName = value.renewalUserName;
	            params.renewalReminderDate = value.renewalReminderDate ? value.renewalReminderDate.format('YYYY-MM-DD') : null;
	          } else {
	            params.renewalUserUuid = null;
	            params.renewalUserName = null;
	            params.renewalReminderDate = null;
	          }
	
	          params.viewTypes = value.viewTypes;
	          params.views = views;
	          authorityMixes.map(function (item) {
	            item.mixUuid = value['mixUuid' + item.uid];
	            userList.map(function (it) {
	              if (it.uuid === item.mixUuid) {
	                item.mixName = it.name;
	              }
	              return it;
	            });
	            value['limitCount' + item.uid] && (item.limitCount = value['limitCount' + item.uid]);
	            value['maturityDate' + item.uid] && (item.maturityDate = value['maturityDate' + item.uid].format('YYYY-MM-DD'));
	            return item;
	          });
	          params.authorityMixes = JSON.parse(JSON.stringify(authorityMixes));
	          params.authorityMixes.map(function (item) {
	            delete item.uid;
	            return item;
	          });
	          params.files = value.files;
	          params.remark = value.remark;
	
	          _this.props.handSubmit(params);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function () {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.addAuthorityMixesItem = function () {
	      var authorityMixes = _this.state.authorityMixes;
	
	      var item = {
	        uid: Date.now()
	      };
	      authorityMixes.push(item);
	      _this.setState({ authorityMixes: authorityMixes });
	    };
	
	    _this.delAuthorityMixes = function (uid) {
	      var authorityMixes = _this.state.authorityMixes;
	
	      authorityMixes = authorityMixes.filter(function (item) {
	        return item.uid !== uid;
	      });
	      _this.setState({ authorityMixes: authorityMixes });
	    };
	
	    _this.authorityMixesItem = function (item) {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var userList = _this.props.userList;
	
	      return _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 7 },
	          _react2.default.createElement(
	            FormItem,
	            { style: { marginBottom: '0' } },
	            getFieldDecorator('mixUuid' + item.uid, {
	              rules: [{ required: true, message: '请选择目标' }],
	              initialValue: item.mixUuid || []
	            })(_react2.default.createElement(
	              _antd.Select,
	              {
	                showSearch: true,
	                placeholder: '\u9009\u62E9\u76EE\u6807',
	                filterOption: function filterOption(input, option) {
	                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                }
	              },
	              userList ? userList.map(function (user) {
	                return _react2.default.createElement(
	                  _antd.Select.Option,
	                  { key: user.uuid, value: user.uuid },
	                  user.name
	                );
	              }) : null
	            ))
	          )
	        ),
	        _react2.default.createElement(_antd.Col, { span: 1 }),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 4, style: { paddingLeft: '10px' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('limitCount' + item.uid, {
	              initialValue: item.limitCount
	            })(_react2.default.createElement(_antd.InputNumber, { style: { width: '100%' }, placeholder: '\u8BF7\u8BBE\u7F6E\u6B21\u6570' }))
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 4, style: { paddingLeft: '10px' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            item.maturityDate ? getFieldDecorator('maturityDate' + item.uid, {
	              initialValue: (0, _moment2.default)(item.maturityDate)
	            })(_react2.default.createElement(_antd.DatePicker, null)) : getFieldDecorator('maturityDate' + item.uid)(_react2.default.createElement(_antd.DatePicker, null))
	          )
	        ),
	        _react2.default.createElement(_antd.Col, { span: 1 }),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 3 },
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.delAuthorityMixes(item.uid);
	              } },
	            '\u5220\u9664'
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      viewTypes: [],
	      delFiles: [],
	      authorityMixes: [],
	      documentType: [],
	      checkedList: [{ label: '全部', value: 0 }, { label: '本公司人员', value: 1 }, { label: '其他', value: 2 }],
	      views: [],
	      DrawerVisible: false
	    };
	    return _this;
	  }
	
	  // 获取资料类型
	
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          databaseInfo = _props.databaseInfo;
	
	      if (data && data.authorityMixes) {
	        data.authorityMixes.map(function (item) {
	          item.uid = item.uuid;
	          return item;
	        });
	        this.setState({
	          authorityMixes: data.authorityMixes
	        });
	      }
	      this.getMaterialDatabaseType(databaseInfo.uuid);
	      this.setState({
	        views: data ? data.views : databaseInfo.views,
	        viewTypes: data ? data.viewTypes : databaseInfo.viewTypes
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var data = nextProps.data,
	          databaseInfo = nextProps.databaseInfo;
	      // const { authorityMixes } = this.state;
	      // if (data && data.authorityMixes && authorityMixes.length === 0) {
	
	      if (databaseInfo && databaseInfo.uuid !== this.props.databaseInfo.uuid) {
	        databaseInfo && this.setState({
	          views: databaseInfo.views,
	          viewTypes: databaseInfo.viewTypes
	        });
	        this.getMaterialDatabaseType(databaseInfo.uuid);
	      }
	
	      if (data && data.uuid !== this.props.data.uuid) {
	        data.authorityMixes && data.authorityMixes.map(function (item) {
	          item.uid = item.uuid;
	          return item;
	        });
	        this.setState({
	          authorityMixes: data.authorityMixes
	        });
	        data && this.setState({
	          views: data.views,
	          viewTypes: data.viewTypes
	        });
	      }
	    }
	
	    // 其他权限选择
	
	    /* ---------------------------------------------级联选择器--------------------------------------------------------------*/
	
	    // 获取资料目录arr
	
	
	    // 设置资料目录列表
	
	
	    // 获取资料目录名称
	
	
	    /* ---------------------------------------------级联选择器结束-----------------------------------------------------------*/
	
	
	    /* --------------- 其他权限详情---------------------------*/
	
	
	    /* --------------- 其他权限详情结束------------------------*/
	    // 文件删除
	
	
	    // 提交
	
	
	    /** --------------------------临时权限增加-------------------------------------------------*/
	
	  }, {
	    key: 'render',
	
	
	    /**---------------------------------------------------------------------------------------*/
	
	    value: function render() {
	      var _this2 = this;
	
	      var _props$form = this.props.form,
	          getFieldDecorator = _props$form.getFieldDecorator,
	          getFieldValue = _props$form.getFieldValue;
	      var _props2 = this.props,
	          _props2$data = _props2.data,
	          data = _props2$data === undefined ? {} : _props2$data,
	          databaseInfo = _props2.databaseInfo,
	          directoryUuid = _props2.directoryUuid,
	          directoryList = _props2.directoryList,
	          isSubmitting = _props2.isSubmitting;
	      var _state = this.state,
	          viewTypes = _state.viewTypes,
	          DrawerVisible = _state.DrawerVisible,
	          checkedList = _state.checkedList,
	          documentType = _state.documentType,
	          views = _state.views;
	      var authorityMixes = this.state.authorityMixes;
	
	      var formItemLayout = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 15 }
	      };
	      var formItemLayout2 = {
	        labelCol: { span: 2 },
	        wrapperCol: { span: 15 }
	      };
	      var dataViews = [];
	      var databaseInfoViews = [];
	      this.formatOption('', directoryList);
	      this.formatArr(directoryList, data.directoryUuid ? data.directoryUuid : directoryUuid);
	      data.views && data.views.map(function (item) {
	        dataViews.push(item.uuid);
	        return item;
	      });
	      databaseInfo.views && databaseInfo.views.map(function (item) {
	        databaseInfoViews.push(item.uuid);
	        return item;
	      });
	      getFieldDecorator('company');
	
	      getFieldDecorator('renewalUserName', {
	        initialValue: data.renewalUserName
	      });
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: this.submit,
	              loading: isSubmitting
	            },
	            '\u63D0\u4EA4'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Card,
	            { title: '\u57FA\u672C\u4FE1\u606F', style: { marginTop: '16px' } },
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u8D44\u6599\u540D\u79F0' }, formItemLayout),
	                  getFieldDecorator('name', {
	                    rules: [{ required: true, message: '请填写资料名称' }],
	                    initialValue: data.name || null
	                  })(_react2.default.createElement(_antd.Input, null))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u8D44\u6599\u7F16\u53F7' }, formItemLayout),
	                  getFieldDecorator('no', {
	                    initialValue: data.no || null
	                  })(_react2.default.createElement(_antd.Input, null))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u5F52\u5C5E\u76EE\u5F55' }, formItemLayout),
	                  getFieldDecorator('directoryUuid', {
	                    rules: [{ required: true, message: '请选择归属目录' }],
	                    initialValue: this.defaultArr
	                  })(_react2.default.createElement(_antd.Cascader, {
	                    options: directoryList,
	                    changeOnSelect: true,
	                    placeholder: '\u8BF7\u9009\u62E9\u5F52\u5C5E\u76EE\u5F55',
	                    displayRender: this.showLable
	                  }))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u5F52\u5C5E\u516C\u53F8' }, formItemLayout),
	                  getFieldDecorator('companyUuid', {
	                    rules: [{ required: true, message: '请选择归属公司' }],
	                    initialValue: data.companyUuid
	                  })(_react2.default.createElement(_companySearch2.default, Object.assign({
	                    companyName: data.company,
	                    companyUuid: data.companyUuid,
	                    onChange: this.handleCompanyChange
	                  }, this.props)))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u5F52\u5C5E\u8D44\u6599\u5E93' }, formItemLayout),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    databaseInfo.name || null
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u8D44\u6599\u7C7B\u578B' }, formItemLayout),
	                  getFieldDecorator('type', {
	                    rules: [{ required: true, message: '请选择资料类型' }],
	                    initialValue: data.type ? data.type : null
	                  })(_react2.default.createElement(
	                    _antd.Select,
	                    null,
	                    documentType.map(function (item) {
	                      return _react2.default.createElement(
	                        _antd.Select.Option,
	                        { value: item.name, key: item.name },
	                        item.name
	                      );
	                    })
	                  ))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u8D44\u6599\u5468\u671F' }, formItemLayout),
	                  data.beginDate ? getFieldDecorator('beginDate', {
	                    initialValue: (0, _moment2.default)(data.beginDate)
	                  })(_react2.default.createElement(_antd.DatePicker, { style: { width: '45%' } })) : getFieldDecorator('beginDate')(_react2.default.createElement(_antd.DatePicker, { style: { width: '45%' } })),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '--'
	                  ),
	                  data.endDate ? getFieldDecorator('endDate', {
	                    initialValue: (0, _moment2.default)(data.endDate)
	                  })(_react2.default.createElement(_antd.DatePicker, { style: { width: '45%' } })) : getFieldDecorator('endDate')(_react2.default.createElement(_antd.DatePicker, { style: { width: '45%' } }))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u8D44\u6599\u72B6\u6001' }, formItemLayout),
	                  getFieldDecorator('status', {
	                    rules: [{ required: true, message: '请选择资料状态' }],
	                    initialValue: data.status || 1
	                  })(_react2.default.createElement(
	                    _antd.Radio.Group,
	                    null,
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 1 },
	                      '\u6709\u6548'
	                    ),
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 2 },
	                      '\u5931\u6548'
	                    )
	                  ))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u603B\u91CF' }, formItemLayout),
	                  getFieldDecorator('amount', {
	                    rules: [{ required: true, message: '请填写总量' }],
	                    initialValue: data.amount || null
	                  })(_react2.default.createElement(_antd.InputNumber, null))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u5E93\u5B58' }, formItemLayout),
	                  getFieldDecorator('number', {
	                    rules: [{ required: true, message: '请填写库存' }],
	                    initialValue: data.number || null
	                  })(_react2.default.createElement(_antd.InputNumber, null))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u7BA1\u7406\u4EBA\u5458' }, formItemLayout),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    databaseInfo.manager || null
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Card,
	            { title: '\u7EED\u8BC1\u914D\u7F6E' },
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                  FormItem,
	                  { label: '\u662F\u5426\u7EED\u8BC1', labelCol: { span: 8 }, wrapperCol: { span: 16 } },
	                  getFieldDecorator('isRenewal', {
	                    rules: [{ required: true, message: '请选择是否续证' }],
	                    initialValue: data.isRenewal || false
	                  })(_react2.default.createElement(_antd.Radio.Group, {
	                    options: [{ value: false, label: '否' }, { value: true, label: '是' }],
	                    onChange: this.checkedRadioChange
	                  }))
	                )
	              ),
	              getFieldValue('isRenewal') && _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                  FormItem,
	                  { label: '\u7EED\u8BC1\u7ECF\u529E\u4EBA', labelCol: { span: 8 }, wrapperCol: { span: 16 } },
	                  getFieldDecorator('renewalUserUuid', {
	                    rules: [{ required: true, message: '请选择续证经办人' }],
	                    initialValue: data.renewalUserUuid
	                  })(_react2.default.createElement(_SearchUser2.default, { onChange: this.handleUserChange }))
	                )
	              ),
	              getFieldValue('isRenewal') && _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                  FormItem,
	                  { label: '\u7EED\u8BC1\u63D0\u9192\u65F6\u95F4', labelCol: { span: 8 }, wrapperCol: { span: 16 } },
	                  getFieldDecorator('renewalReminderDate', {
	                    rules: [{ required: true, message: '请选择续证提醒时间' }],
	                    initialValue: data.renewalReminderDate ? (0, _moment2.default)(data.renewalReminderDate) : null
	                  })(_react2.default.createElement(_antd.DatePicker, null))
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Card,
	            { title: '\u6743\u9650\u63A7\u5236' },
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                  FormItem,
	                  { label: '\u957F\u671F\u6743\u9650', labelCol: { span: 8 }, wrapperCol: { span: 16 } },
	                  getFieldDecorator('viewTypes', {
	                    rules: [{ required: true, message: '请选择长期权限' }],
	                    initialValue: data.viewTypes || databaseInfo.viewTypes
	                  })(_react2.default.createElement(_antd.Checkbox.Group, { options: checkedList, onChange: this.checkedChange }))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 6 },
	                viewTypes && viewTypes.some(function (item) {
	                  return item === 2;
	                }) ? _react2.default.createElement(
	                  FormItem,
	                  { style: { marginBottom: '0' } },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: this.showDrawer, style: { whiteSpace: 'nowrap' } },
	                    '\u5176\u4ED6\u6743\u9650\u8BE6\u60C5'
	                  )
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4E34\u65F6\u6743\u9650' }, formItemLayout2),
	                authorityMixes.map(function (item) {
	                  return _this2.authorityMixesItem(item);
	                }),
	                _react2.default.createElement(
	                  _antd.Button,
	                  {
	                    style: { width: '100%', borderStyle: 'dashed' },
	                    onClick: this.addAuthorityMixesItem
	                  },
	                  '+\u6DFB\u52A0\u4E34\u65F6\u6743\u9650'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Card,
	            { title: '\u8D44\u6599\u9644\u4EF6' },
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u8D44\u6599\u9644\u4EF6', labelCol: { span: 2 }, wrapperCol: { span: 5 } },
	              getFieldDecorator('files', {
	                rules: [{ required: true, message: '请上传资料附件' }],
	                initialValue: data.files || []
	              })(_react2.default.createElement(_UploadFile2.default, {
	                type: 'ghost',
	                fileList: data.file,
	                onRemove: this.fileRemove,
	                isPreview: true
	              }))
	            ),
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5907\u6CE8\u8BF4\u660E' }, formItemLayout2),
	              getFieldDecorator('remark', {
	                initialValue: data.remark || null
	              })(_react2.default.createElement(_antd.Input.TextArea, {
	                placeholder: '\u5907\u6CE8',
	                type: 'textarea',
	                autosize: { minRows: 3, maxRows: 9 },
	                maxLength: 1000
	              })),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '12px', color: '#999' } },
	                '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u5165\u5E93\u4EBA\u5458' }, formItemLayout),
	                  getFieldDecorator('crName', {
	                    initialValue: data.createUserName
	                  })(_react2.default.createElement(
	                    'span',
	                    null,
	                    this.props.accountInfo.userName
	                  ))
	                )
	              ),
	              _react2.default.createElement(_antd.Col, { span: 12 })
	            )
	          )
	        ),
	        DrawerVisible ? _react2.default.createElement(_orgStructure2.default, {
	          onClose: this.closeDrawer,
	          visible: DrawerVisible,
	          views: views,
	          setViews: this.setViews
	        }) : null
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(BaseForm));

/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	var _user = __webpack_require__(54);
	
	var _FormBase = __webpack_require__(1421);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.getDocumentSave(item);
	    };
	
	    _this.getDatabaseInfo = function (uuid) {
	      (0, _material.queryMaterialDatabaseInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            databaseInfo: res.data || []
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.getAccountList = function () {
	      (0, _user.queryAccountList)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            userList: res.data || []
	          });
	        } else {
	          _antd.message.err(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.getDocumentInfo = function (params) {
	      (0, _material.queryMaterialDocumentInfo)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            documentInfo: res.data
	          });
	        } else {
	          _antd.message.err(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.getDirectoryList = function (databaseUuid) {
	      (0, _material.queryMaterialDirectoryList)({ databaseUuid: databaseUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            directoryList: res.data
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.getDocumentLog = function (params) {
	      (0, _material.queryMaterialDocumentLog)(params).then(function (res) {
	        if (res.statusCode !== 200) {
	          _antd.message.err(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.getDocumentSave = function (params) {
	      _this.setState({
	        isSubmitting: false
	      });
	      (0, _material.querySaveMaterialDocument)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	          _this.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.state = {
	      userList: [],
	      databaseInfo: {},
	      directoryList: [],
	      documentInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.params.uuid;
	      var databaseUuid = this.props.location.query.databaseUuid;
	
	      this.getDatabaseInfo(databaseUuid);
	      this.getDirectoryList(databaseUuid);
	      this.getAccountList();
	
	      if (uuid !== 'new') {
	        var params = { uuid: uuid };
	        this.getDocumentInfo(params);
	        this.getDocumentLog(params);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var uuid = nextProps.params.uuid;
	      var databaseUuid = nextProps.location.query.databaseUuid;
	
	      if (this.props.params.uuid !== uuid && uuid !== 'new') {
	        var params = { uuid: uuid };
	        this.getDocumentInfo(params);
	        this.getDocumentLog(params);
	      }
	      if (this.props.location.query.databaseUuid !== databaseUuid) {
	        this.getDatabaseInfo(databaseUuid);
	        this.getDirectoryList(databaseUuid);
	      }
	    }
	
	    // 资料库详情
	
	
	    // 用户列表
	
	
	    // 资料详情
	
	
	    // 资料目录列表
	
	
	    // 操作日志
	
	
	    // 资料保存
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          userList = _state.userList,
	          directoryList = _state.directoryList,
	          databaseInfo = _state.databaseInfo,
	          documentInfo = _state.documentInfo,
	          isSubmitting = _state.isSubmitting;
	      var directoryUuid = this.props.location.query.directoryUuid;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.props.params.uuid === 'new' ? _react2.default.createElement(_FormBase2.default, {
	          userList: userList,
	          isSubmitting: isSubmitting,
	          databaseInfo: databaseInfo,
	          directoryList: directoryList,
	          directoryUuid: directoryUuid,
	          handSubmit: this.handSubmit
	        }) : _react2.default.createElement(_FormBase2.default, {
	          data: documentInfo,
	          userList: userList,
	          isSubmitting: isSubmitting,
	          databaseInfo: databaseInfo,
	          directoryList: directoryList,
	          directoryUuid: directoryUuid,
	          handSubmit: this.handSubmit
	        })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _material = __webpack_require__(50);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _BackBtn = __webpack_require__(12);
	
	var _attachment = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.state = {
	      data: {
	        files: []
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var uuid = this.props.params.uuid;
	
	      (0, _material.queryMaterialDocumentInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            data: res.data
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          { style: { marginBottom: '20px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(_BackBtn.BackBtn, null)
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6587\u4EF6\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u540D\u79F0' },
	              data.name
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u7F16\u53F7' },
	              data.no
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u7C7B\u578B' },
	              data.type
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u72B6\u6001' },
	              data.status === 1 ? '有效' : '失效'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u5468\u671F' },
	              data.beginDate ? (0, _moment2.default)(data.beginDate).format('YYYY-MM-DD') : '',
	              '\u81F3',
	              data.endDate ? (0, _moment2.default)(data.endDate).format('YYYY-MM-DD') : '永久'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7BA1\u7406\u5458' },
	              data.manager
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F52\u5C5E\u516C\u53F8' },
	              data.company
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F52\u5C5E\u8D44\u6599\u5E93' },
	              data.database
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F52\u5C5E\u76EE\u5F55' },
	              data.directory
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u603B\u6570' },
	              data.amount
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u5E93\u5B58' },
	              data.number
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u5907\u6CE8\u8BF4\u660E' },
	              data.remark
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u662F\u5426\u7EED\u8BC1' },
	              data.isRenewal ? '是' : '否'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7EED\u8BC1\u7ECF\u529E\u4EBA' },
	              data.renewalUserName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7EED\u8BC1\u63D0\u9192\u65F6\u95F4' },
	              data.renewalReminderDate ? (0, _moment2.default)(data.renewalReminderDate).format('yyyy-MM-DD') : null
	            ),
	            data.renewalUuid && _react2.default.createElement(
	              Description,
	              { term: '\u7EED\u8BC1\u7533\u8BF7' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/administrative/material/renewal/open/' + data.renewalUuid },
	                '\u67E5\u770B\u8BE6\u60C5'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D44\u6599\u9644\u4EF6' },
	              data.files.map(function (item) {
	                return _react2.default.createElement(
	                  'div',
	                  { key: item.url },
	                  _react2.default.createElement(
	                    'a',
	                    {
	                      onClick: function onClick() {
	                        return (0, _attachment.queryFilePreview)(item, '\u4EC5\u9650' + _this3.props.accountInfo.userName + '\u67E5\u770B');
	                      }
	                    },
	                    item.name
	                  )
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(Page);

/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _TreeOrg = __webpack_require__(662);
	
	var _TreeOrg2 = _interopRequireDefault(_TreeOrg);
	
	var _ModalAdd = __webpack_require__(659);
	
	var _ModalAdd2 = _interopRequireDefault(_ModalAdd);
	
	var _TableOrg = __webpack_require__(661);
	
	var _TableOrg2 = _interopRequireDefault(_TableOrg);
	
	var _SelectDatabase = __webpack_require__(660);
	
	var _SelectDatabase2 = _interopRequireDefault(_SelectDatabase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var confirm = _antd.Modal.confirm;
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this2 = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this2.initialPage = function () {
	      (0, _material.queryMaterialDatabaseListBR)().then(function (res) {
	        // 资料库列表
	        if (res.statusCode === 200) {
	          if (res.data.length === 0) {
	            _this2.setState({ emptyFlag: true });
	          } else {
	            _this2.setState({
	              databaseList: res.data || [],
	              databaseUuid: res.data[0] ? res.data[0].uuid : '',
	              databaseName: res.data[0] ? res.data[0].name : '',
	              emptyFlag: false
	            }, function () {
	              var _this2$state = _this2.state,
	                  databaseUuid = _this2$state.databaseUuid,
	                  databaseName = _this2$state.databaseName;
	
	              _this2.handleDatabaseChange(databaseUuid, {
	                props: { children: databaseName }
	              });
	            });
	          }
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.getDatabaseType = function () {
	      var databaseUuid = _this2.state.databaseUuid;
	
	      (0, _material.queryMaterialDatabaseType)({ databaseUuid: databaseUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            types: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.getDatabaseList = function () {
	      (0, _material.queryMaterialDatabaseListBR)().then(function (res) {
	        if (res.statusCode === 200) {
	          if (res.data.length === 1) {
	            // 首次创建资料库
	            _this2.setState({
	              databaseList: res.data || [],
	              databaseUuid: res.data[0] ? res.data[0].uuid : '',
	              databaseName: res.data[0] ? res.data[0].name : '',
	              emptyFlag: false
	            });
	            _this2.databaseList = res.data;
	          } else if (res.data.length > 0) {
	            _this2.setState({
	              databaseList: res.data || [],
	              emptyFlag: false
	            });
	            _this2.databaseList = res.data;
	          } else {
	            _this2.setState({
	              emptyFlag: true
	            });
	          }
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.getDatabaseInfo = function () {
	      var databaseUuid = _this2.state.databaseUuid;
	
	      (0, _material.queryMaterialDatabaseInfo)({ uuid: databaseUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            databaseInfo: res.data || []
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.getDatabaseDelete = function () {
	      var databaseUuid = _this2.state.databaseUuid;
	
	      (0, _material.queryMaterialDatabaseDelete)({ uuid: databaseUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	          _this2.initialPage();
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.getDirectoryList = function () {
	      var databaseUuid = _this2.state.databaseUuid;
	
	      (0, _material.queryMaterialDirectoryList)({
	        databaseUuid: databaseUuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            directoryList: res.data || []
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.getDocumentList = function () {
	      var _this2$state2 = _this2.state,
	          databaseUuid = _this2$state2.databaseUuid,
	          directoryUuid = _this2$state2.directoryUuid,
	          documentType = _this2$state2.documentType,
	          documentCondition = _this2$state2.documentCondition;
	
	      var params = Object.assign({
	        databaseUuid: databaseUuid,
	        directoryUuid: directoryUuid,
	        type: documentType
	      }, _this2.pagination, {
	        condition: documentCondition
	      });
	      _this2.setState({
	        isLoading: true
	      });
	      (0, _material.queryMaterialDocumentList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            documentList: res.data || [],
	            pagination: {
	              total: res.totalSize,
	              pageSize: 15,
	              current: _this2.current
	            },
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.handleDatabaseChange = function (value, option) {
	      _this2.pagination = {
	        limit: 15,
	        start: 1
	      };
	      _this2.current = 1;
	      _this2.setState({
	        databaseUuid: value,
	        databaseName: option.props.children,
	        directory: '',
	        directoryUuid: ''
	      }, function () {
	        _this2.getDirectoryList();
	        _this2.getDatabaseType();
	        _this2.getDocumentList();
	      });
	    };
	
	    _this2.handleDirectorySelect = function (value) {
	      _this2.setState({
	        directoryUuid: value.uuid,
	        directory: value.name
	      }, function () {
	        _this2.getDocumentList();
	      });
	    };
	
	    _this2.handleSearch = function () {
	      _this2.props.form.validateFields(function (err, values) {
	        var documentType = values.documentType || '';
	        var documentCondition = values.condition || '';
	        _this2.setState({
	          documentType: documentType,
	          documentCondition: documentCondition
	        }, function () {
	          _this2.getDocumentList();
	        });
	      });
	    };
	
	    _this2.hideModalAdd = function (flag) {
	      _this2.setState({
	        addVisible: !!flag
	      });
	    };
	
	    _this2.addDatabase = function () {
	      _this2.setState({ isAddType: true }, function () {
	        _this2.hideModalAdd(true);
	      });
	    };
	
	    _this2.editDatabase = function () {
	      var databaseUuid = _this2.state.databaseUuid;
	
	      _this2.getDatabaseInfo(databaseUuid);
	      _this2.setState({ isAddType: false }, function () {
	        _this2.hideModalAdd(true);
	      });
	    };
	
	    _this2.databaseAddSubmit = function (params) {
	      (0, _material.queryMaterialDatabaseSave)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this2.getDatabaseList();
	          _this2.hideModalAdd();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.showDel = function () {
	      var _this = _this2;
	      confirm({
	        title: '确定删除该资料库?',
	        onOk: function onOk() {
	          _this.getDatabaseDelete();
	        }
	      });
	    };
	
	    _this2.documentAdd = function () {
	      var _this2$state3 = _this2.state,
	          databaseUuid = _this2$state3.databaseUuid,
	          directoryUuid = _this2$state3.directoryUuid;
	
	      _this2.props.router.push({
	        pathname: '/administrative/material/add/new',
	        query: {
	          databaseUuid: databaseUuid,
	          directoryUuid: directoryUuid
	        }
	      });
	    };
	
	    _this2.handleDel = function (uuid) {
	      (0, _material.queryDeleteMaterialDocument)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	          _this2.getDocumentList();
	        }
	      });
	    };
	
	    _this2.handleTableChange = function (pagination) {
	      _this2.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this2.current = pagination.current;
	      _this2.getDocumentList();
	    };
	
	    _this2.state = {
	      databaseName: '',
	      databaseUuid: '',
	      databaseList: [],
	      databaseInfo: {},
	
	      directory: '',
	      directoryUuid: '',
	      directoryList: [],
	
	      documentList: [],
	      types: [],
	      documentType: '',
	      documentCondition: '',
	
	      pagination: {},
	      isLoading: false,
	      addVisible: false,
	      emptyFlag: true,
	      isAddType: true
	    };
	    return _this2;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        this.getDatabaseList();
	        // 分页设置
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	        this.setState({
	          databaseName: backInfo.databaseName,
	          databaseUuid: backInfo.databaseUuid,
	          directory: backInfo.directory,
	          directoryUuid: backInfo.directoryUuid,
	          documentType: backInfo.documentType,
	          documentCondition: backInfo.documentCondition
	        }, function () {
	          _this3.getDatabaseType();
	          _this3.getDirectoryList();
	          _this3.getDocumentList();
	        });
	      } else {
	        this.initialPage();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          databaseName = _state.databaseName,
	          databaseUuid = _state.databaseUuid,
	          directory = _state.directory,
	          directoryUuid = _state.directoryUuid,
	          documentType = _state.documentType,
	          documentCondition = _state.documentCondition;
	
	      var params = Object.assign({
	        path: this.props.location.pathname
	      }, this.pagination, {
	        databaseName: databaseName,
	        databaseUuid: databaseUuid,
	        directory: directory,
	        directoryUuid: directoryUuid,
	        documentType: documentType || '',
	        documentCondition: documentCondition || ''
	      });
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 页面初始状态
	
	
	    // 获取资料类型
	
	
	    // 资料库列表
	
	
	    // 资料库详情
	
	
	    // 资料库删除
	
	
	    // 资料目录列表
	
	
	    // 资料文档列表
	
	
	    // 资料库改变(也用于初始状态)
	
	
	    // 资料目录选中
	
	
	    // 资料文档搜索
	
	
	    /** ------------------新增/编辑资料库--------------------------------------------*/
	    // 弹窗开关
	
	
	    // 新增的弹窗
	
	
	    // 编辑的弹窗
	
	
	    // 提交
	
	
	    /**-----------------------------------------------------------------------------*/
	    // 删除资料库
	
	
	    // 添加资料文档
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state2 = this.state,
	          databaseUuid = _state2.databaseUuid,
	          databaseName = _state2.databaseName,
	          databaseList = _state2.databaseList,
	          databaseInfo = _state2.databaseInfo,
	          directoryUuid = _state2.directoryUuid,
	          directoryList = _state2.directoryList,
	          documentList = _state2.documentList,
	          types = _state2.types,
	          pagination = _state2.pagination,
	          documentType = _state2.documentType,
	          documentCondition = _state2.documentCondition,
	          isLoading = _state2.isLoading,
	          isAddType = _state2.isAddType,
	          emptyFlag = _state2.emptyFlag;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var parentProps = {
	        databaseUuid: databaseUuid,
	        databaseName: databaseName,
	        directoryUuid: directoryUuid,
	        documentList: documentList,
	        pagination: pagination,
	        isLoading: isLoading,
	        handleDel: this.handleDel,
	        onChange: this.handleTableChange
	      };
	
	      var formItemLayout = {
	        labelCol: {
	          xs: { span: 12 },
	          sm: { span: 6 }
	        },
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 18 },
	          md: { span: 18 }
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        emptyFlag ? _react2.default.createElement(
	          _antd.Button,
	          { style: { marginLeft: '10px' }, onClick: this.addDatabase },
	          '\u65B0\u589E\u8D44\u6599\u5E93'
	        ) : _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              _antd.Row,
	              { style: { paddingBottom: '15px' } },
	              _react2.default.createElement(_SelectDatabase2.default, {
	                data: databaseList,
	                onChange: this.handleDatabaseChange,
	                value: databaseUuid
	              })
	            ),
	            _react2.default.createElement(_TreeOrg2.default, {
	              data: directoryList,
	              database: databaseName,
	              databaseUuid: databaseUuid,
	              directoryUuid: directoryUuid,
	              onSelect: this.handleDirectorySelect,
	              getDirectoryList: this.getDirectoryList
	            })
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 18, style: { paddingLeft: '2%' } },
	            _react2.default.createElement(
	              _antd.Row,
	              { type: 'flex', justify: 'end', style: { paddingBottom: '15px' } },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', onClick: this.documentAdd },
	                '+ \u6DFB\u52A0\u8D44\u6599'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: '10px' }, onClick: this.editDatabase },
	                '\u7F16\u8F91\u8D44\u6599\u5E93'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: '10px' }, onClick: this.addDatabase },
	                '\u65B0\u589E\u8D44\u6599\u5E93'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: '10px' }, onClick: this.showDel },
	                '\u5220\u9664\u8D44\u6599\u5E93'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Card,
	              null,
	              _react2.default.createElement(
	                _antd.Form,
	                null,
	                _react2.default.createElement(
	                  _antd.Row,
	                  null,
	                  _react2.default.createElement(
	                    _antd.Col,
	                    { span: 6 },
	                    _react2.default.createElement(
	                      FormItem,
	                      Object.assign({ label: '\u7C7B\u578B' }, formItemLayout),
	                      getFieldDecorator('documentType', {
	                        initialValue: documentType
	                      })(_react2.default.createElement(
	                        _antd.Select,
	                        { allowClear: true },
	                        types.map(function (item) {
	                          return _react2.default.createElement(
	                            _antd.Select.Option,
	                            { value: item.name, key: item.name },
	                            item.name
	                          );
	                        })
	                      ))
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _antd.Col,
	                    { span: 4, style: { paddingLeft: '10px', paddingRight: '10px' } },
	                    _react2.default.createElement(
	                      FormItem,
	                      null,
	                      getFieldDecorator('condition', {
	                        initialValue: documentCondition
	                      })(_react2.default.createElement(_antd.Input, { placeholder: '\u5176\u4ED6\u641C\u7D22' }))
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _antd.Col,
	                    { span: 3 },
	                    _react2.default.createElement(
	                      FormItem,
	                      null,
	                      _react2.default.createElement(
	                        _antd.Button,
	                        { type: 'primary', onClick: this.handleSearch },
	                        '\u641C\u7D22'
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(_TableOrg2.default, parentProps)
	            )
	          )
	        ),
	        _react2.default.createElement(_ModalAdd2.default, {
	          visible: this.state.addVisible,
	          onOk: this.databaseAddSubmit,
	          onCancel: function onCancel() {
	            return _this4.hideModalAdd(false);
	          },
	          data: isAddType ? {} : databaseInfo
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create()(Index));

/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	__webpack_require__(59);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _attachment = __webpack_require__(27);
	
	var _reactRouter = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.chaptersColumns = function () {
	      return [{
	        title: '用章公司',
	        dataIndex: 'company',
	        key: 'company',
	        width: '40%'
	      }, {
	        title: '用章类型',
	        dataIndex: 'type',
	        key: 'type',
	        width: '30%',
	        render: function render(text) {
	          switch (text) {
	            case 0:
	              return '公章';
	            case 1:
	              return '合同章';
	            case 2:
	              return '法人章';
	            default:
	              break;
	          }
	        }
	      }, {
	        title: '是否外借',
	        dataIndex: 'seal',
	        key: 'seal',
	        width: '30%',
	        render: function render(text) {
	          if (text === 0) {
	            return '不外借';
	          }
	          return '外借';
	        }
	      }];
	    };
	
	    _this.effectColumns = function () {
	      return [{
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '附件',
	        dataIndex: 'files',
	        key: 'files',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            text ? text.map(function (item) {
	              return _react2.default.createElement(
	                'div',
	                { key: item.url },
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return (0, _attachment.queryFilePreview)(item);
	                    } },
	                  item.name
	                )
	              );
	            }) : null
	          );
	        }
	      }, {
	        title: '扫描件',
	        dataIndex: 'scans',
	        key: 'scans',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            text ? text.map(function (item) {
	              return _react2.default.createElement(
	                'div',
	                { key: item.url },
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return (0, _attachment.queryFilePreview)(item);
	                    } },
	                  item.name
	                )
	              );
	            }) : null
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataItem: _this.props.data
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        dataItem: this.props.data
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataItem: nextProps.data
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataItem = this.state.dataItem;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u7528\u7AE0\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u7533\u8BF7\u4EBA\u5458' },
	              dataItem.createUserName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7EED\u8BC1\u8D44\u6599\u540D\u79F0' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/administrative/material/info/' + dataItem.documentUuid },
	                dataItem.documentName
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u65B0\u8D44\u6599\u540D\u79F0' },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/administrative/material/info/' + dataItem.newDocumentUuid },
	                dataItem.newDocumentName
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u8BF4\u660E' },
	              dataItem.reason
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { height: '30px', fontWeight: 'bold', paddingTop: '10px' } },
	            '\u7528\u7AE0\u7C7B\u522B'
	          ),
	          _react2.default.createElement(_antd.Table, {
	            columns: this.chaptersColumns(),
	            dataSource: dataItem.chapters,
	            pagination: false
	          }),
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { height: '30px', fontWeight: 'bold', paddingTop: '10px' } },
	            '\u7528\u7AE0\u9644\u4EF6'
	          ),
	          _react2.default.createElement(_antd.Table, {
	            columns: this.effectColumns(),
	            dataSource: dataItem.renewalFiles,
	            pagination: false
	          })
	        )
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    company: state.company_list
	  };
	})(Open);

/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _material = __webpack_require__(50);
	
	var _FormBase = __webpack_require__(665);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveRenewal(item);
	    };
	
	    _this.sealWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _material.queryRenewalWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveRenewal = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _material.querySaveRenewal)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataInfo = this.state.dataInfo;
	
	      this.setState({ dataInfo: dataInfo });
	      this.sealWorkflow();
	    }
	
	    /**
	     * 提交用章
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, Object.assign({
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          isSubmitting: isSubmitting
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _expend_type = __webpack_require__(80);
	
	var _material = __webpack_require__(50);
	
	var _PageEdit = __webpack_require__(1426);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1429);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getRenewalInfo = function () {
	      (0, _material.queryRenewalInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data || {}
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getRenewalInfo();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type
	  };
	})(PageInfo);

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(59);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _material = __webpack_require__(50);
	
	var _FormSearch = __webpack_require__(153);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(666);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getRenewalMMyList = function (params) {
	      _this.setState({
	        loading: true
	      });
	      (0, _material.queryRenewalMyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            loading: false
	          });
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getRenewalMMyList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        loading: false,
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataSource = _state.dataSource,
	          loading = _state.loading;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        type: 'mine',
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19, offset: 5 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _WorkflowRenewal = __webpack_require__(1519);
	
	var _WorkflowRenewal2 = _interopRequireDefault(_WorkflowRenewal);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _material = __webpack_require__(50);
	
	var _FormOpen = __webpack_require__(1425);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	var _FormBase = __webpack_require__(665);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.doTask = function (pass, refuse, info) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackRenewal(item);
	          break;
	        case 'next':
	          _this.nextRenewal(item);
	          break;
	        case 'nextUpload':
	          _this.nextRenewalUpload(Object.assign({}, item, info));
	          break;
	        case 'nextScan':
	          _this.nextRenewalScan(Object.assign({}, item, info));
	          break;
	        case 'nextArchive':
	          _this.nextRenewalArchive(Object.assign({}, item, info));
	          break;
	        case 'return':
	          _this.returnRenewal(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.handSubmit = function (item) {
	      var dataInfo = _this.state.dataInfo;
	
	      _this.doTask('nextUpload', item, Object.assign({}, item, { uuid: dataInfo.uuid }));
	    };
	
	    _this.callbackRenewal = function (params) {
	      (0, _material.queryCallbackRenewal)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextRenewal = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _material.queryNextRenewal)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.nextRenewalUpload = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _material.queryNextRenewalUpload)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.nextRenewalScan = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _material.queryNextRenewalScan)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.nextRenewalArchive = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _material.queryNextRenewalArchive)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnRenewal = function (params, refuse) {
	      (0, _material.queryReturnRenewal)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null
	          );
	        }
	      }, {
	        title: '操作内容',
	        dataIndex: 'operating'
	      }, {
	        title: '处理意见',
	        dataIndex: 'refuse'
	      }];
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ dataInfo: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 续证经办人处理
	
	
	    // 扫描件通过
	
	
	    // 行政归档通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	
	      var currentActivity = instance.currentActivity;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        currentActivity === undefined || currentActivity.name !== '续证经办人' ? _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_WorkflowRenewal2.default, {
	            op: 'renewal',
	            data: dataInfo,
	            doTask: this.doTask,
	            watchTask: this.watchTask,
	            isLoading: isLoading
	          }),
	          _react2.default.createElement(_FormOpen2.default, Object.assign({
	            data: dataInfo,
	            doTask: this.doTask,
	            watchTask: this.watchTask
	          }, this.props))
	        ) : _react2.default.createElement(_FormBase2.default, Object.assign({ data: dataInfo, handSubmit: this.handSubmit }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'renewal', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	var _back_info = __webpack_require__(19);
	
	var _material = __webpack_require__(50);
	
	var _TableExpenses = __webpack_require__(666);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getRenewalList = function (params) {
	      _this.setState({
	        loading: true
	      });
	      (0, _material.queryRenewalList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            loading: false
	          });
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getRenewalList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        loading: false,
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataSource = _state.dataSource,
	          loading = _state.loading;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	__webpack_require__(59);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _ModalReturn = __webpack_require__(424);
	
	var _ModalReturn2 = _interopRequireDefault(_ModalReturn);
	
	var _FormSearch = __webpack_require__(153);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(425);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.setTodoData = function (res) {
	      _this.setState({
	        TodoDataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.setTableDoneData = function (res) {
	      _this.setState({
	        DoneDataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getMaterialReturnListBMTodo = function (params) {
	      (0, _material.queryMaterialReturnListBMTodo)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTodoData(res);
	        }
	      });
	    };
	
	    _this.getMaterialReturnListBMDone = function (params) {
	      (0, _material.queryMaterialReturnListBMDone)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableDoneData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getMaterialReturnListBMTodo(params);
	      _this.getMaterialReturnListBMDone(params);
	    };
	
	    _this.showModalReturn = function (data) {
	      _this.setState({ returnData: data, returnVisible: true });
	    };
	
	    _this.handleReturnCancel = function () {
	      _this.setState({ returnVisible: false });
	    };
	
	    _this.handleSaveReturn = function (data) {
	      var params = data;
	      (0, _material.querySaveMaterialReturn)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	          _this.handleReturnCancel();
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.state = {
	      TodoDataSource: {
	        list: [],
	        pagination: {}
	      },
	      DoneDataSource: {
	        list: [],
	        pagination: {}
	      },
	      returnVisible: false,
	      returnData: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 资料借还
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          TodoDataSource = _state.TodoDataSource,
	          DoneDataSource = _state.DoneDataSource,
	          returnVisible = _state.returnVisible,
	          returnData = _state.returnData;
	
	      var TodoParentProps = {
	        type: 'todo',
	        type2: 'manage',
	        dataSource: TodoDataSource,
	        onChange: this.handleTableChange,
	        showModalReturn: this.showModalReturn
	      };
	      var DoneParentProps = {
	        type: 'done',
	        type2: 'manage',
	        dataSource: DoneDataSource,
	        onChange: this.handleTableChange,
	        showModalReturn: this.showModalReturn
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          _antd.Tabs,
	          null,
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u5F85\u5F52\u8FD8', key: '1' },
	            _react2.default.createElement(
	              'div',
	              { id: 'ant-small-table' },
	              _react2.default.createElement(_TableExpenses2.default, TodoParentProps)
	            )
	          ),
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u5DF2\u5B8C\u6210', key: '2' },
	            _react2.default.createElement(
	              'div',
	              { id: 'ant-small-table' },
	              _react2.default.createElement(_TableExpenses2.default, DoneParentProps)
	            )
	          )
	        ),
	        _react2.default.createElement(_ModalReturn2.default, {
	          data: returnData,
	          visible: returnVisible,
	          handleOk: this.handleSaveReturn,
	          handleCancel: this.handleReturnCancel
	        })
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	__webpack_require__(59);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _ModalReturn = __webpack_require__(424);
	
	var _ModalReturn2 = _interopRequireDefault(_ModalReturn);
	
	var _FormSearch = __webpack_require__(153);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(425);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.setTodoData = function (res) {
	      _this.setState({
	        TodoDataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.setTableDoneData = function (res) {
	      _this.setState({
	        DoneDataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getMaterialReturnListBRTodo = function (params) {
	      (0, _material.queryMaterialReturnListBRTodo)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTodoData(res);
	        }
	      });
	    };
	
	    _this.getMaterialReturnListBRDone = function (params) {
	      (0, _material.queryMaterialReturnListBRDone)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableDoneData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getMaterialReturnListBRTodo(params);
	      _this.getMaterialReturnListBRDone(params);
	    };
	
	    _this.showModalReturn = function (data) {
	      _this.setState({ returnData: data, returnVisible: true });
	    };
	
	    _this.handleReturnCancel = function () {
	      _this.setState({ returnVisible: false });
	    };
	
	    _this.handleSaveReturn = function (data) {
	      var params = data;
	      (0, _material.querySaveMaterialReturn)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	          _this.handleReturnCancel();
	        } else {
	          _antd.message.error(res.message, 2.5);
	          _this.handleReturnCancel();
	        }
	      });
	    };
	
	    _this.state = {
	      TodoDataSource: {
	        list: [],
	        pagination: {}
	      },
	      DoneDataSource: {
	        list: [],
	        pagination: {}
	      },
	      returnVisible: false,
	      returnData: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 资料借还
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          TodoDataSource = _state.TodoDataSource,
	          DoneDataSource = _state.DoneDataSource,
	          returnVisible = _state.returnVisible,
	          returnData = _state.returnData;
	
	      var TodoParentProps = {
	        type: 'todo',
	        type2: 'mine',
	        dataSource: TodoDataSource,
	        onChange: this.handleTableChange,
	        showModalReturn: this.showModalReturn
	      };
	      var DoneParentProps = {
	        type: 'done',
	        type2: 'mine',
	        dataSource: DoneDataSource,
	        onChange: this.handleTableChange,
	        showModalReturn: this.showModalReturn
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          _antd.Tabs,
	          null,
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u5F85\u5F52\u8FD8', key: '1' },
	            _react2.default.createElement(
	              'div',
	              { id: 'ant-small-table' },
	              _react2.default.createElement(_TableExpenses2.default, TodoParentProps)
	            )
	          ),
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u5DF2\u5B8C\u6210', key: '2' },
	            _react2.default.createElement(
	              'div',
	              { id: 'ant-small-table' },
	              _react2.default.createElement(_TableExpenses2.default, DoneParentProps)
	            )
	          )
	        ),
	        _react2.default.createElement(_ModalReturn2.default, {
	          data: returnData,
	          visible: returnVisible,
	          handleOk: this.handleSaveReturn,
	          handleCancel: this.handleReturnCancel
	        })
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _material = __webpack_require__(50);
	
	__webpack_require__(59);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _ModalReturn = __webpack_require__(424);
	
	var _ModalReturn2 = _interopRequireDefault(_ModalReturn);
	
	var _FormSearch = __webpack_require__(153);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(425);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.setTodoData = function (res) {
	      _this.setState({
	        TodoDataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.setTableDoneData = function (res) {
	      _this.setState({
	        DoneDataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getMaterialReturnListTodo = function (params) {
	      (0, _material.queryMaterialReturnListTodo)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTodoData(res);
	        }
	      });
	    };
	
	    _this.getMaterialReturnListDone = function (params) {
	      (0, _material.queryMaterialReturnListDone)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableDoneData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getMaterialReturnListTodo(params);
	      _this.getMaterialReturnListDone(params);
	    };
	
	    _this.showModalReturn = function (data) {
	      _this.setState({ returnData: data, returnVisible: true });
	    };
	
	    _this.handleReturnCancel = function () {
	      _this.setState({ returnVisible: false });
	    };
	
	    _this.handleSaveReturn = function (data) {
	      var params = data;
	      (0, _material.querySaveMaterialReturn)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	          _this.handleReturnCancel();
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.state = {
	      TodoDataSource: {
	        list: [],
	        pagination: {}
	      },
	      DoneDataSource: {
	        list: [],
	        pagination: {}
	      },
	      returnVisible: false,
	      returnData: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 资料借还
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          TodoDataSource = _state.TodoDataSource,
	          DoneDataSource = _state.DoneDataSource,
	          returnVisible = _state.returnVisible,
	          returnData = _state.returnData;
	
	      var TodoParentProps = {
	        type: 'todo',
	        type2: 'watch',
	        dataSource: TodoDataSource,
	        onChange: this.handleTableChange,
	        showModalReturn: this.showModalReturn
	      };
	      var DoneParentProps = {
	        type: 'done',
	        type2: 'watch',
	        dataSource: DoneDataSource,
	        onChange: this.handleTableChange,
	        showModalReturn: this.showModalReturn
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          _antd.Tabs,
	          null,
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u5F85\u5F52\u8FD8', key: '1' },
	            _react2.default.createElement(
	              'div',
	              { id: 'ant-small-table' },
	              _react2.default.createElement(_TableExpenses2.default, TodoParentProps)
	            )
	          ),
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u5DF2\u5B8C\u6210', key: '2' },
	            _react2.default.createElement(
	              'div',
	              { id: 'ant-small-table' },
	              _react2.default.createElement(_TableExpenses2.default, DoneParentProps)
	            )
	          )
	        ),
	        _react2.default.createElement(_ModalReturn2.default, {
	          data: returnData,
	          visible: returnVisible,
	          handleOk: this.handleSaveReturn,
	          handleCancel: this.handleReturnCancel
	        })
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	__webpack_require__(59);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: '采购物品',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '型号',
	        dataIndex: 'model',
	        key: 'model'
	      }, {
	        title: '单价(元)',
	        dataIndex: 'unit',
	        key: 'unit',
	        render: function render(text) {
	          return _util2.default.numberFormat(text);
	        }
	      }, {
	        title: '数量',
	        dataIndex: 'count',
	        key: 'count'
	      }];
	    };
	
	    _this.state = {
	      dataItem: _this.props.data
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        dataItem: this.props.data
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataItem: nextProps.data
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataItem = this.state.dataItem;
	
	      var files = dataItem.files || [];
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u91C7\u8D2D\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u7533\u8BF7\u4EBA\u5458' },
	              dataItem.createUserName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u4EA4\u4ED8\u65F6\u95F4' },
	              _moment2.default.unix(dataItem.expectedDate / 1000).format('YYYY-MM-DD')
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u91C7\u8D2D\u51ED\u8BC1' },
	              _react2.default.createElement(
	                'div',
	                null,
	                files.map(function (item) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: item.url },
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: function onClick() {
	                          return (0, _attachment.queryFilePreview)(item);
	                        } },
	                      item.name
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u91C7\u8D2D\u8BF4\u660E' },
	              dataItem.reason
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { height: '30px', fontWeight: 'bold', paddingTop: '10px' } },
	            '\u7269\u54C1\u8BE6\u60C5:'
	          ),
	          _react2.default.createElement(_antd.Table, { columns: this.columns(), dataSource: dataItem.details, pagination: false }),
	          _react2.default.createElement(
	            'p',
	            { style: { marginTop: '10px' } },
	            '\u5408\u8BA1\uFF1A',
	            _util2.default.numberFormat(dataItem.price),
	            '\u5143'
	          )
	        )
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(Open);

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _purchase = __webpack_require__(229);
	
	var _FormBase = __webpack_require__(667);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.savePurchase(item);
	    };
	
	    _this.purchaseWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _purchase.queryPurchaseWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.savePurchase = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _purchase.querySavePurchase)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.purchaseWorkflow();
	    }
	
	    /**
	     * 提交采购
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, { data: dataInfo, handSubmit: this.handSubmit, isSubmitting: isSubmitting }),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance })
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _reactRouter = __webpack_require__(8);
	
	var _purchase = __webpack_require__(229);
	
	var _FormBase = __webpack_require__(667);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.savePurchase(item);
	    };
	
	    _this.purchaseWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _purchase.queryPurchaseWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.savePurchase = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _purchase.querySavePurchase)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deletePurchase = function () {
	      (0, _purchase.queryDeletePurchase)({
	        uuid: _this.props.data.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.purchaseWorkflow();
	    }
	
	    /**
	     * 提交采购
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, Object.assign({
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          handleDelete: this.deletePurchase,
	          isSubmitting: isSubmitting
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _purchase = __webpack_require__(229);
	
	var _PageEdit = __webpack_require__(1436);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1439);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getPurchaseInfo = function () {
	      (0, _purchase.queryPurchaseInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPurchaseInfo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = PageInfo;

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(59);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _purchase = __webpack_require__(229);
	
	var _FormSearch = __webpack_require__(153);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(668);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getPurchaseMyList = function (params) {
	      _this.setState({ loading: true });
	      (0, _purchase.queryPurchaseMyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getPurchaseMyList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        type: 'mine',
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/administrative/purchase_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u91C7\u8D2D'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _purchase = __webpack_require__(229);
	
	var _WorkflowOp = __webpack_require__(1443);
	
	var _WorkflowOp2 = _interopRequireDefault(_WorkflowOp);
	
	var _FormOpen = __webpack_require__(1434);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.doTask = function (pass, refuse, info) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackPurchase(item);
	          break;
	        case 'next':
	          _this.nextPurchase(item);
	          break;
	        case 'transfer':
	          _this.transferPurchase(Object.assign({}, item, info));
	          break;
	        case 'return':
	          _this.returnPurchase(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackPurchase = function (params) {
	      (0, _purchase.queryCallbackPurchase)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextPurchase = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _purchase.queryNextPurchase)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.transferPurchase = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _purchase.queryTransferPurchase)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnPurchase = function (params, refuse) {
	      (0, _purchase.queryReturnPurchase)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null
	          );
	        }
	      }, {
	        title: '操作内容',
	        dataIndex: 'operating'
	      }, {
	        title: '处理意见',
	        dataIndex: 'refuse'
	      }];
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ dataInfo: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 转交
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowOp2.default, {
	          op: 'purchase',
	          data: dataInfo,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_FormOpen2.default, Object.assign({ data: dataInfo, doTask: this.doTask, watchTask: this.watchTask }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'purchase', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	__webpack_require__(59);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _purchase = __webpack_require__(229);
	
	var _TableExpenses = __webpack_require__(668);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getPurchaseList = function (params) {
	      _this.setState({ loading: true });
	      (0, _purchase.queryPurchaseList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getPurchaseList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _user = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleOk = function () {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.props.handleOk(values);
	        }
	      });
	    };
	
	    _this.state = {
	      accountList: []
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _user.queryAccountList)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            accountList: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          getFieldDecorator = _props.form.getFieldDecorator,
	          visible = _props.visible,
	          handleCancel = _props.handleCancel;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u91C7\u8D2D\u8F6C\u4EA4',
	          visible: visible,
	          onOk: this.handleOk,
	          onCancel: function onCancel() {
	            return handleCancel(false);
	          }
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u64CD\u4F5C\u4EBA' },
	            getFieldDecorator('processor', {
	              rules: [{ required: true, message: '请选择操作人' }]
	            })(_react2.default.createElement(
	              _antd.Select,
	              {
	                showSearch: true,
	                filterOption: function filterOption(input, option) {
	                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                }
	              },
	              this.state.accountList.map(function (item) {
	                return _react2.default.createElement(
	                  _antd.Select.Option,
	                  { value: item.uuid, key: item.uuid },
	                  item.name
	                );
	              })
	            ))
	          )
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Manage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manage.__proto__ || Object.getPrototypeOf(Manage)).call.apply(_ref, [this].concat(args))), _this), _this.handleOk = function () {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.props.handleOk(values);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Manage, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          getFieldDecorator = _props.form.getFieldDecorator,
	          visible = _props.visible,
	          handleCancel = _props.handleCancel;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u9000\u56DE\u7406\u7531',
	          visible: visible,
	          onOk: this.handleOk,
	          onCancel: function onCancel() {
	            return handleCancel(false);
	          }
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u539F\u56E0' },
	            getFieldDecorator('refuse', {
	              rules: [{ required: true, message: '请填写退回理由' }]
	            })(_react2.default.createElement(_antd.Input, null))
	          )
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _BackBtn = __webpack_require__(12);
	
	var _ModalReject = __webpack_require__(1442);
	
	var _ModalReject2 = _interopRequireDefault(_ModalReject);
	
	var _ModalPurchase = __webpack_require__(1441);
	
	var _ModalPurchase2 = _interopRequireDefault(_ModalPurchase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.handleRejectVisible = function (flag) {
	      _this.setState({
	        rejectVisible: !!flag
	      });
	    };
	
	    _this.handleTransferVisible = function (flag) {
	      _this.setState({
	        transferVisible: !!flag
	      });
	    };
	
	    _this.handlePurchase = function (params) {
	      var data = _this.props.data;
	
	      _this.props.doTask('transfer', '', Object.assign({}, params, { uuid: data.uuid }));
	      _this.handleTransferVisible(false);
	    };
	
	    _this.handleNext = function () {
	      var _this$props = _this.props,
	          currentActivity = _this$props.data.instance.currentActivity,
	          doTask = _this$props.doTask,
	          op = _this$props.op;
	
	
	      switch (op) {
	        // 采购
	        case 'purchase':
	          if (currentActivity.name === '采购执行') {
	            _this.handleTransferVisible(true);
	          } else {
	            doTask('next');
	          }
	          break;
	        // 默认
	        default:
	          doTask('next');
	          break;
	      }
	    };
	
	    _this.handleTransfer = function () {
	      _this.handleTransferVisible(true);
	    };
	
	    _this.isAuditor = function (activities, currentUser) {
	      return activities.some(function (item, index) {
	        return (_this.userUuid === item.processor || item.processor.indexOf(_this.userUuid) !== -1) && activities[index + 1] && currentUser.uuid === activities[index + 1].uuid;
	      });
	    };
	
	    _this.handleReturn = function (params) {
	      _this.props.doTask('return', params);
	      _this.handleRejectVisible(false);
	    };
	
	    _this.changeButton = function () {
	      var _this$props2 = _this.props,
	          data = _this$props2.data,
	          doTask = _this$props2.doTask;
	
	      var instance = data.instance || {};
	      var currentUser = instance.currentActivity || {};
	      var activities = instance.activities || [];
	      // status:(0,流程进行中；1,流程结束；2.废弃)
	      // activities:status:(0,未开始；1,正在进行；2.结束)
	
	      // 审核开关(会签情况)
	      var examineFlag = currentUser.messages && currentUser.messages.some(function (item) {
	        return item.processor === _this.userUuid && item.isDone === 0 && item.status === 0;
	      });
	      if (instance.status !== 0) {
	        return null;
	      }
	      if (examineFlag) {
	        // 当前流程审核人打开
	        return _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'arrow-left',
	              style: { marginRight: 10 },
	              onClick: function onClick() {
	                return _this.handleRejectVisible(true);
	              }
	            },
	            '\u9000\u56DE'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'check',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: function onClick() {
	                return doTask('next');
	              },
	              loading: _this.props.isLoading || false
	            },
	            '\u901A\u8FC7'
	          ),
	          currentUser.name === '采购执行' ? _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'arrow-right',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: _this.handleTransfer,
	              loading: _this.props.isLoading || false
	            },
	            '\u8F6C\u4EA4'
	          ) : null,
	          data.createUser === _this.userUuid && activities[0] && activities[0].status !== 2 ? _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'arrow-left',
	              style: { marginRight: 10 },
	              onClick: function onClick() {
	                return doTask('callback');
	              }
	            },
	            '\u6536\u56DE'
	          ) : null
	        );
	      }
	      if (data.createUser === _this.userUuid && activities[0] && activities[0].status !== 2 || _this.isAuditor(activities, currentUser)) {
	        // 申请人打开
	        return _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { icon: 'arrow-left', style: { marginRight: 10 }, onClick: function onClick() {
	                return doTask('callback');
	              } },
	            '\u6536\u56DE'
	          )
	        );
	      }
	      return null;
	    };
	
	    _this.state = {
	      rejectVisible: false,
	      transferVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	
	    // 退回
	
	
	    // 移交
	
	
	    // 通过按钮，不同流程有不同的特殊操作
	
	
	    /**
	     * 判断流程中的用户是否有收回按钮
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          rejectVisible = _state.rejectVisible,
	          transferVisible = _state.transferVisible;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          this.changeButton()
	        ),
	        _react2.default.createElement(_ModalReject2.default, {
	          visible: rejectVisible,
	          handleOk: this.handleReturn,
	          handleCancel: this.handleRejectVisible
	        }),
	        _react2.default.createElement(_ModalPurchase2.default, {
	          visible: transferVisible,
	          handleOk: this.handlePurchase,
	          handleCancel: this.handleTransferVisible
	        })
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = Open;

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1409);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(1424);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _PageAdd = __webpack_require__(1422);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	var _PageInfo = __webpack_require__(1423);
	
	var _PageInfo2 = _interopRequireDefault(_PageInfo);
	
	var _Index5 = __webpack_require__(1410);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _PageAdd3 = __webpack_require__(1415);
	
	var _PageAdd4 = _interopRequireDefault(_PageAdd3);
	
	var _PageMine = __webpack_require__(1418);
	
	var _PageMine2 = _interopRequireDefault(_PageMine);
	
	var _PageWatch = __webpack_require__(1420);
	
	var _PageWatch2 = _interopRequireDefault(_PageWatch);
	
	var _PageInfo3 = __webpack_require__(1417);
	
	var _PageInfo4 = _interopRequireDefault(_PageInfo3);
	
	var _PageMine3 = __webpack_require__(1432);
	
	var _PageMine4 = _interopRequireDefault(_PageMine3);
	
	var _PageWatch3 = __webpack_require__(1433);
	
	var _PageWatch4 = _interopRequireDefault(_PageWatch3);
	
	var _PageManage = __webpack_require__(1431);
	
	var _PageManage2 = _interopRequireDefault(_PageManage);
	
	var _PageMine5 = __webpack_require__(1428);
	
	var _PageMine6 = _interopRequireDefault(_PageMine5);
	
	var _PageWatch5 = __webpack_require__(1430);
	
	var _PageWatch6 = _interopRequireDefault(_PageWatch5);
	
	var _PageInfo5 = __webpack_require__(1427);
	
	var _PageInfo6 = _interopRequireDefault(_PageInfo5);
	
	var _PageAdd5 = __webpack_require__(1446);
	
	var _PageAdd6 = _interopRequireDefault(_PageAdd5);
	
	var _PageMine7 = __webpack_require__(1451);
	
	var _PageMine8 = _interopRequireDefault(_PageMine7);
	
	var _PageWatch7 = __webpack_require__(1453);
	
	var _PageWatch8 = _interopRequireDefault(_PageWatch7);
	
	var _PageInfo7 = __webpack_require__(1450);
	
	var _PageInfo8 = _interopRequireDefault(_PageInfo7);
	
	var _PageCompany = __webpack_require__(1447);
	
	var _PageCompany2 = _interopRequireDefault(_PageCompany);
	
	var _PageIncubator = __webpack_require__(1449);
	
	var _PageIncubator2 = _interopRequireDefault(_PageIncubator);
	
	var _PageAdd7 = __webpack_require__(1435);
	
	var _PageAdd8 = _interopRequireDefault(_PageAdd7);
	
	var _PageMine9 = __webpack_require__(1438);
	
	var _PageMine10 = _interopRequireDefault(_PageMine9);
	
	var _PageWatch9 = __webpack_require__(1440);
	
	var _PageWatch10 = _interopRequireDefault(_PageWatch9);
	
	var _PageInfo9 = __webpack_require__(1437);
	
	var _PageInfo10 = _interopRequireDefault(_PageInfo9);
	
	var _Index7 = __webpack_require__(1406);
	
	var _Index8 = _interopRequireDefault(_Index7);
	
	var _PageAdd9 = __webpack_require__(658);
	
	var _PageAdd10 = _interopRequireDefault(_PageAdd9);
	
	var _PageEdit = __webpack_require__(1407);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1408);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 采购申请
	
	
	// 用章申请
	
	// 资料归还
	
	// 资料借用申请
	var router = {
	  path: 'administrative',
	  breadcrumbName: '行政',
	  childRoutes: [
	  // 资料管理
	  {
	    path: 'material',
	    breadcrumbName: '资料管理',
	    indexRoute: { component: _Index2.default },
	    childRoutes: [{
	      path: 'lookUp',
	      component: _Index6.default,
	      breadcrumbName: '查阅资料'
	    }, {
	      path: 'add/:uuid',
	      component: _PageAdd2.default,
	      breadcrumbName: '资料文档编辑'
	    }, {
	      path: 'info/:uuid',
	      component: _PageInfo2.default,
	      breadcrumbName: '资料文档详情'
	    },
	    // 资料借用
	    {
	      path: 'borrow_manage',
	      indexRoute: {
	        component: _PageMine2.default
	      },
	      breadcrumbName: '资料借用管理',
	      childRoutes: [{
	        path: 'add',
	        component: _PageAdd4.default,
	        breadcrumbName: '资料借用申请'
	      }, {
	        path: 'open/:uuid',
	        component: _PageInfo4.default,
	        breadcrumbName: '查看资料借用'
	      }]
	    }, {
	      path: 'borrow_manage_mine',
	      component: _PageMine2.default,
	      breadcrumbName: '我的资料借用'
	    }, {
	      path: 'borrow_manage_watch',
	      component: _PageWatch2.default,
	      breadcrumbName: '资料借用监控'
	    },
	    // 资料归还
	    {
	      path: 'return_manage_mine',
	      component: _PageMine4.default,
	      breadcrumbName: '我借用的资料归还'
	    }, {
	      path: 'return_manage_watch',
	      component: _PageWatch4.default,
	      breadcrumbName: '资料归还管理'
	    }, {
	      path: 'return_manage_manage',
	      component: _PageManage2.default,
	      breadcrumbName: '我的资料归还管理'
	    }, {
	      path: 'renewal',
	      indexRoute: {
	        component: _PageMine6.default
	      },
	      childRoutes: [{
	        path: 'edit/:uuid',
	        component: _PageInfo6.default,
	        breadcrumbName: '编辑'
	      }, {
	        path: 'open/:uuid',
	        component: _PageInfo6.default,
	        breadcrumbName: '编辑'
	      }]
	    }, {
	      path: 'renewal_mine',
	      component: _PageMine6.default,
	      breadcrumbName: '我的资料续证'
	    }, {
	      path: 'renewal_watch',
	      component: _PageWatch6.default,
	      breadcrumbName: '资料续证监控'
	    }]
	  }, {
	    path: 'myMaterial',
	    component: _Index4.default,
	    breadcrumbName: '我的资料管理'
	  },
	  // 用章
	  {
	    path: 's_manage',
	    indexRoute: {
	      component: _PageMine8.default
	    },
	    breadcrumbName: '用章管理',
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd6.default,
	      breadcrumbName: '用章申请'
	    }, {
	      path: 'open/:uuid',
	      component: _PageInfo8.default,
	      breadcrumbName: '查看用章'
	    }]
	  }, {
	    path: 's_manage_mine',
	    component: _PageMine8.default,
	    breadcrumbName: '我的用章'
	  }, {
	    path: 's_manage_watch',
	    component: _PageWatch8.default,
	    breadcrumbName: '用章监控'
	  }, {
	    path: 's_manage_company',
	    component: _PageCompany2.default,
	    breadcrumbName: '按公司统计'
	  }, {
	    path: 's_manage_incubator',
	    component: _PageIncubator2.default,
	    breadcrumbName: '按孵化器统计'
	  },
	  // 采购
	  {
	    path: 'purchase_manage',
	    indexRoute: {
	      component: _PageMine10.default
	    },
	    breadcrumbName: '采购管理',
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd8.default,
	      breadcrumbName: '采购申请'
	    }, {
	      path: 'open/:uuid',
	      component: _PageInfo10.default,
	      breadcrumbName: '查看采购'
	    }]
	  }, {
	    path: 'purchase_manage_mine',
	    component: _PageMine10.default,
	    breadcrumbName: '我的采购'
	  }, {
	    path: 'purchase_manage_watch',
	    component: _PageWatch10.default,
	    breadcrumbName: '采购监控'
	  }, {
	    path: 'announcement',
	    indexRoute: {
	      component: _Index8.default
	    },
	    breadcrumbName: '公告列表',
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd10.default,
	      breadcrumbName: '公告新增'
	    }, {
	      path: 'open/:uuid',
	      component: _PageOpen2.default,
	      breadcrumbName: '查看公告'
	    }, {
	      path: 'edit/:uuid',
	      component: _PageEdit2.default,
	      breadcrumbName: '编辑公告'
	    }]
	  }]
	};
	
	// 资料续证
	// 资料管理
	exports.default = router;

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	__webpack_require__(59);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dict = __webpack_require__(64);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.findTypeName = function (type) {
	      var typeName = '';
	      _this.state.ichapterappType.forEach(function (item) {
	        if (type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.chaptersColumns = function () {
	      return [{
	        title: '用章公司',
	        dataIndex: 'company',
	        key: 'company',
	        width: '40%'
	      }, {
	        title: '用章类型',
	        dataIndex: 'type',
	        key: 'type',
	        width: '30%',
	        render: function render(text) {
	          switch (text) {
	            case 0:
	              return '公章';
	            case 1:
	              return '合同章';
	            case 2:
	              return '法人章';
	            default:
	              break;
	          }
	        }
	      }, {
	        title: '是否外借',
	        dataIndex: 'seal',
	        key: 'seal',
	        width: '30%',
	        render: function render(text) {
	          if (text === 0) {
	            return '不外借';
	          }
	          return '外借';
	        }
	      }];
	    };
	
	    _this.effectColumns = function () {
	      return [{
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '附件',
	        dataIndex: 'files',
	        key: 'files',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            text ? text.map(function (item) {
	              return _react2.default.createElement(
	                'div',
	                { key: item.url },
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return (0, _attachment.queryFilePreview)(item);
	                    } },
	                  item.name
	                )
	              );
	            }) : null
	          );
	        }
	      }, {
	        title: '扫描件',
	        dataIndex: 'scans',
	        key: 'scans',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            text ? text.map(function (item) {
	              return _react2.default.createElement(
	                'div',
	                { key: item.url },
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return (0, _attachment.queryFilePreview)(item);
	                    } },
	                  item.name
	                )
	              );
	            }) : null
	          );
	        }
	      }, {
	        title: '涉及金额',
	        dataIndex: 'price',
	        key: 'price'
	      }, {
	        title: '数量',
	        dataIndex: 'count',
	        key: 'count'
	      }, {
	        title: '是否归还',
	        dataIndex: 'isReturn',
	        key: 'isReturn',
	        render: function render(text, record) {
	          if (text) {
	            return _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                'p',
	                null,
	                '\u5F52\u8FD8\u6570\u91CF\uFF1A',
	                record.returnCount
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                '\u5F52\u8FD8\u65F6\u95F4\uFF1A',
	                _moment2.default.unix(record.returnExpectedDate / 1000).format('YYYY-MM-DD')
	              )
	            );
	          }
	          return _react2.default.createElement(
	            'p',
	            null,
	            '\u4E0D\u5F52\u8FD8'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataItem: _this.props.data,
	      ichapterappType: []
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setState({
	        dataItem: this.props.data
	      });
	
	      (0, _dict.queryIchapterappType)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            ichapterappType: res.data
	          });
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataItem: nextProps.data
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataItem = this.state.dataItem;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u7528\u7AE0\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u4E8B\u4EF6\u7C7B\u578B' },
	              this.findTypeName('' + dataItem.type)
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7533\u8BF7\u4EBA\u5458' },
	              dataItem.createUserName
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u7528\u7AE0\u8BF4\u660E' },
	              dataItem.reason
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { height: '30px', fontWeight: 'bold', paddingTop: '10px' } },
	            '\u7528\u7AE0\u7C7B\u522B'
	          ),
	          _react2.default.createElement(_antd.Table, {
	            columns: this.chaptersColumns(),
	            dataSource: dataItem.chapters,
	            pagination: false
	          }),
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { height: '30px', fontWeight: 'bold', paddingTop: '10px' } },
	            '\u7528\u7AE0\u9644\u4EF6'
	          ),
	          _react2.default.createElement(_antd.Table, { columns: this.effectColumns(), dataSource: dataItem.effects, pagination: false })
	        )
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    company: state.company_list
	  };
	})(Open);

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _expend_type = __webpack_require__(80);
	
	var _seal = __webpack_require__(150);
	
	var _FormBase = __webpack_require__(669);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      delete item.apportionType;
	      _this.saveSeal(item);
	    };
	
	    _this.sealWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _seal.querySealWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveSeal = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _seal.querySaveSeal)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.hideModal = function () {};
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.sealWorkflow();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	    }
	
	    /**
	     * 提交用章
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          dataInfo = _state.dataInfo;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, { data: dataInfo, handSubmit: this.handSubmit, isSubmitting: isSubmitting }),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance })
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type
	  };
	})(Page);

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(59);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _seal = __webpack_require__(150);
	
	var _FormSearch = __webpack_require__(153);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableStaticOrg = __webpack_require__(671);
	
	var _TableStaticOrg2 = _interopRequireDefault(_TableStaticOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getSealOrgStatic = function (params) {
	      (0, _seal.querySealOrgStatic)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getSealOrgStatic(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableStaticOrg2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _seal = __webpack_require__(150);
	
	var _FormBase = __webpack_require__(669);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveSeal(item);
	    };
	
	    _this.sealWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _seal.querySealWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveSeal = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _seal.querySaveSeal)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deleteSeal = function () {
	      (0, _seal.queryDeleteSeal)({
	        uuid: _this.props.data.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataInfo = this.state.dataInfo;
	
	      this.setState({ dataInfo: dataInfo });
	      this.sealWorkflow();
	    }
	
	    /**
	     * 提交用章
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, Object.assign({
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          handleDelete: this.deleteSeal,
	          isSubmitting: isSubmitting
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(59);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _seal = __webpack_require__(150);
	
	var _FormSearch = __webpack_require__(153);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableStaticOrg = __webpack_require__(671);
	
	var _TableStaticOrg2 = _interopRequireDefault(_TableStaticOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getSealIncubatorStatic = function (params) {
	      (0, _seal.querySealIncubatorStatic)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getSealIncubatorStatic(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableStaticOrg2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _expend_type = __webpack_require__(80);
	
	var _seal = __webpack_require__(150);
	
	var _PageEdit = __webpack_require__(1448);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1452);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getSealInfo = function () {
	      (0, _seal.querySealInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSealInfo();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type
	  };
	})(PageInfo);

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(59);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _seal = __webpack_require__(150);
	
	var _FormSearch = __webpack_require__(153);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(670);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getSealMyList = function (params) {
	      _this.setState({
	        loading: true
	      });
	      (0, _seal.querySealMyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            loading: false
	          });
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getSealMyList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        loading: false,
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataSource = _state.dataSource,
	          loading = _state.loading;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        type: 'mine',
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/administrative/s_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u7528\u7AE0'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _WorkflowSeal = __webpack_require__(1522);
	
	var _WorkflowSeal2 = _interopRequireDefault(_WorkflowSeal);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _seal = __webpack_require__(150);
	
	var _FormOpen = __webpack_require__(1445);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.doTask = function (pass, refuse, info) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackSeal(item);
	          break;
	        case 'next':
	          _this.nextSeal(item);
	          break;
	        case 'nextScan':
	          _this.nextSealScan(Object.assign({}, item, info));
	          break;
	        case 'nextArchive':
	          _this.nextSealArchive(Object.assign({}, item, info));
	          break;
	        case 'return':
	          _this.returnSeal(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackSeal = function (params) {
	      (0, _seal.queryCallbackSeal)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextSeal = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _seal.queryNextSeal)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.nextSealScan = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _seal.queryNextSealScan)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.nextSealArchive = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _seal.queryNextSealArchive)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnSeal = function (params, refuse) {
	      (0, _seal.queryReturnSeal)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null
	          );
	        }
	      }, {
	        title: '操作内容',
	        dataIndex: 'operating'
	      }, {
	        title: '处理意见',
	        dataIndex: 'refuse'
	      }];
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ dataInfo: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 扫描件通过
	
	
	    // 行政归档通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowSeal2.default, {
	          op: 'seal',
	          data: dataInfo,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_FormOpen2.default, Object.assign({ data: dataInfo, doTask: this.doTask, watchTask: this.watchTask }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'seal', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	var _back_info = __webpack_require__(19);
	
	var _seal = __webpack_require__(150);
	
	var _TableExpenses = __webpack_require__(670);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	__webpack_require__(59);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getSealList = function (params) {
	      _this.setState({
	        loading: true
	      });
	      (0, _seal.querySealList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            loading: false
	          });
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getSealList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        loading: false,
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataSource = _state.dataSource,
	          loading = _state.loading;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(59);
	
	var _seal = __webpack_require__(150);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.getSealOrgRecord = function (params) {
	      (0, _seal.querySealOrgRecord)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataSource: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 15
	              }
	            }
	          });
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({
	        companyUuid: _this.props.org.companyUuid
	      }, _this.pagination);
	      _this.getSealOrgRecord(params);
	    };
	
	    _this.onChange = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '流水编号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/administrative/s_manage/open/' + record.uuid },
	            text || '查看'
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price'
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD')
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'long',
	        render: function render(text, record) {
	          return record.status ? _react2.default.createElement(
	            'span',
	            null,
	            '\u5DF2\u5B8C\u6210',
	            _react2.default.createElement(
	              'span',
	              null,
	              '(\u7528\u65F6',
	              record.consume,
	              '\u5929)'
	            )
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u5BA1\u6838\u4E2D'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	      var org = this.props.org;
	
	      return _react2.default.createElement(
	        _antd.Drawer,
	        {
	          visible: true,
	          width: '70%',
	          title: org.company,
	          onClose: function onClose() {
	            return _this2.props.handleVisible(false);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            dataSource: list,
	            pagination: pagination,
	            rowKey: 'uuid',
	            size: 'small',
	            onChange: this.handleTableChange
	          })
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _config = __webpack_require__(657);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ModalGlobalConfigAdd = __webpack_require__(1456);
	
	var _ModalGlobalConfigAdd2 = _interopRequireDefault(_ModalGlobalConfigAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo) {
	      var params = {};
	      var condition = _this.state.condition;
	
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      _this.setState({
	        pageNo: current,
	        isLoading: true
	      });
	      (0, _config.queryGlobalConfigList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var pageNo = _this.state.pageNo;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.loadData(pageNo);
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.judge = function (accountInfo) {
	      var isPermission = false;
	      if (accountInfo.admin) {
	        isPermission = true;
	      }
	
	      _this.setState({
	        isPermission: isPermission
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '配置项标题',
	        dataIndex: 'label'
	      }, {
	        title: '配置项值',
	        dataIndex: 'value'
	      }, {
	        title: '配置项描述',
	        dataIndex: 'desc'
	      }, {
	        title: '创建时间',
	        dataIndex: 'createDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm:ss')
	          );
	        }
	      }, {
	        title: '更新时间',
	        dataIndex: 'updateDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm:ss')
	          );
	        }
	      }, {
	        title: '操作',
	        render: function render(text, record) {
	          var isPermission = _this.state.isPermission;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            isPermission ? _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.editGlobalConfig(record.uuid);
	                } },
	              '\u7F16\u8F91'
	            ) : null
	          );
	        }
	      }];
	    };
	
	    _this.handlerVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.addGlobalConfig = function () {
	      _this.handlerVisible(true);
	      _this.setState({ dataInfo: null });
	    };
	
	    _this.editGlobalConfig = function (uuid) {
	      (0, _config.queryGlobalConfigInfo)({
	        uuid: uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          }, function () {
	            return _this.handlerVisible(true);
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.saveGlobalConfig = function (item) {
	      (0, _config.querySaveGlobalConfig)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handlerVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: true,
	      total: 0,
	      pageNo: 1,
	      isPermission: false,
	      visible: false,
	      dataInfo: null
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	      this.judge(this.props.account_info);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          pageNo = _state.pageNo,
	          condition = _state.condition;
	
	      var params = {
	        pageNo: pageNo,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    // 加载需公司账户信息数据
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          data = _state2.data,
	          isLoading = _state2.isLoading,
	          total = _state2.total,
	          pageNo = _state2.pageNo,
	          isPermission = _state2.isPermission,
	          visible = _state2.visible,
	          dataInfo = _state2.dataInfo;
	
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            'div',
	            { className: 'tableList' },
	            _react2.default.createElement(
	              _antd.Row,
	              { style: { paddingBottom: '20px' } },
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 13 },
	                isPermission ? _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary', onClick: this.addGlobalConfig },
	                  '\u6DFB\u52A0'
	                ) : null
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 11 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'tableListForm' },
	                  this.renderSearchForm()
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_antd.Table, {
	            rowKey: 'uuid',
	            loading: isLoading,
	            columns: this.columns(),
	            dataSource: data,
	            pagination: pagination
	          }),
	          _react2.default.createElement(_ModalGlobalConfigAdd2.default, {
	            visible: visible,
	            data: dataInfo,
	            onOk: function onOk(params) {
	              return _this2.saveGlobalConfig(params);
	            },
	            onCancel: function onCancel() {
	              return _this2.handlerVisible(false);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    account_info: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Index));

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _dict = __webpack_require__(64);
	
	var _config = __webpack_require__(657);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Textarea = _antd.Input;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.updateConfigs = function () {
	      (0, _dict.queryGlobalConfig)().then(function (res) {
	        if (res.statusCode === 200) {
	          var data = res.data;
	          (0, _config.queryGlobalConfigConfig)().then(function (res1) {
	            if (res1.statusCode === 200) {
	              var configs = res1.data;
	              var result = data.filter(function (item) {
	                return !configs.includes(item.value);
	              });
	              console.table(result);
	              _this.setState({ configs: result });
	            }
	          });
	        }
	      });
	    };
	
	    _this.submit = function () {
	      var data = _this.props.data;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          values.unid = data ? data.unid : '';
	          _this.props.onOk(values);
	          _this.props.form.resetFields();
	        }
	      });
	    };
	
	    _this.onCancel = function () {
	      _this.props.form.resetFields();
	      _this.props.onCancel();
	    };
	
	    _this.handleChange = function (value, option) {
	      _this.props.form.setFieldsValue({
	        label: option.props.children
	      });
	    };
	
	    _this.renderOptions = function (data) {
	      if (data && data.uuid) {
	        return _react2.default.createElement(
	          Option,
	          { value: data.uuid },
	          data.label
	        );
	      } else {
	        var configs = _this.state.configs;
	
	        if (configs.length > 0) {
	          return configs.map(function (config) {
	            return _react2.default.createElement(
	              Option,
	              { key: config.value, value: config.value },
	              config.key
	            );
	          });
	        }
	        return null;
	      }
	    };
	
	    _this.state = { configs: [] };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateConfigs();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (!nextProps.data) {
	        this.updateConfigs();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var data = this.props.data;
	
	      var ItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	
	      getFieldDecorator('label', { initialValue: data && data.uuid ? data.label : '' });
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: data && data.uuid ? '编辑配置项设置' : '创建配置项设置',
	          visible: this.props.visible,
	          onOk: this.submit,
	          onCancel: this.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u914D\u7F6E\u9879\u6807\u9898' }, ItemLayout),
	                getFieldDecorator('uuid', {
	                  rules: [{
	                    required: true,
	                    message: '请选择配置项'
	                  }],
	                  initialValue: data && data.uuid ? data.uuid : ''
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { onChange: function onChange(value, option) {
	                      return _this2.handleChange(value, option);
	                    } },
	                  this.renderOptions(data)
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u914D\u7F6E\u9879\u503C' }, ItemLayout),
	                getFieldDecorator('value', {
	                  initialValue: data ? data.value : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u914D\u7F6E\u9879\u503C', type: 'text' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u914D\u7F6E\u9879\u63CF\u8FF0' }, ItemLayout),
	                getFieldDecorator('desc', {
	                  initialValue: data ? data.desc : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u914D\u7F6E\u9879\u63CF\u8FF0' }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(IndexModal));

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _dict = __webpack_require__(64);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _ModalDictAdd = __webpack_require__(1458);
	
	var _ModalDictAdd2 = _interopRequireDefault(_ModalDictAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (dict, pageNo, pageSize) {
	      var params = {};
	      var _this$state = _this.state,
	          condition = _this$state.condition,
	          no = _this$state.pageNo;
	      var breadcrumbDicts = _this.state.breadcrumbDicts;
	
	      var current = pageNo || no;
	      params.limit = pageSize || 10;
	      params.start = current;
	      params.condition = condition || '';
	      if (dict) {
	        params.parentLevelCode = dict.levelCode || '';
	      } else {
	        params.parentLevelCode = '';
	      }
	      _this.setState({
	        pageNo: current,
	        pageSize: pageSize,
	        isLoading: true,
	        parentLevelCode: params.parentLevelCode
	      });
	      (0, _dict.queryDictListTree)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          if (dict) {
	            if (breadcrumbDicts.indexOf(dict) > -1) {
	              breadcrumbDicts = breadcrumbDicts.slice(0, breadcrumbDicts.indexOf(dict));
	            }
	            breadcrumbDicts.push(dict);
	          } else {
	            breadcrumbDicts = [];
	          }
	          _this.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false,
	            breadcrumbDicts: breadcrumbDicts
	          });
	        }
	      });
	    };
	
	    _this.searchData = function () {
	      var breadcrumbDicts = _this.state.breadcrumbDicts;
	
	      var dict = breadcrumbDicts[breadcrumbDicts.length - 1];
	      _this.loadData(dict, 1, 10);
	    };
	
	    _this.loadDataOnClick = function (dict) {
	      _this.props.form.setFieldsValue({
	        condition: ''
	      });
	      _this.setState({ condition: '' }, function () {
	        _this.loadData(dict, 1);
	      });
	    };
	
	    _this.getDictInfo = function (uuid) {
	      (0, _dict.queryDictInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data || []
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.saveDict = function (params) {
	      (0, _dict.querySaveDict)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handlerVisible(false);
	          _this.setState({ dataInfo: null });
	          _this.searchData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deleteDict = function (uuid) {
	      (0, _dict.queryDeleteDict)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.searchData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.searchData();
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.judge = function (accountInfo) {
	      var isPermission = false;
	      if (accountInfo.admin) {
	        isPermission = true;
	      }
	
	      _this.setState({
	        isPermission: isPermission
	      });
	    };
	
	    _this.handlerVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '名称',
	        dataIndex: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            { onClick: function onClick() {
	                return _this.loadDataOnClick(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: '分类代码',
	        dataIndex: 'charCode'
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 1 ? '启用' : '禁用'
	          );
	        }
	      }, {
	        title: '操作',
	        render: function render(text, record) {
	          var isPermission = _this.state.isPermission;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            isPermission ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.editDict(record.uuid);
	                  } },
	                '\u7F16\u8F91'
	              ),
	              _react2.default.createElement('span', { className: 'ant-divider' }),
	              _react2.default.createElement(
	                _antd.Popconfirm,
	                {
	                  onConfirm: function onConfirm() {
	                    return _this.deleteDict(record.uuid);
	                  },
	                  title: '\u786E\u5B9A\u5220\u9664\u5F53\u524D\u5B57\u5178\u6570\u636E\u5417\uFF1F',
	                  placement: 'topRight',
	                  overlayStyle: { width: 200 }
	                },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'ant-dropdown-link' },
	                  '\u5220\u9664'
	                )
	              )
	            ) : null
	          );
	        }
	      }];
	    };
	
	    _this.addDict = function () {
	      _this.setState({ dataInfo: null });
	      _this.handlerVisible(true);
	    };
	
	    _this.editDict = function (uuid) {
	      _this.getDictInfo(uuid);
	      _this.handlerVisible(true);
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: true,
	      total: 0,
	      pageNo: 1,
	      pageSize: 15,
	      isPermission: false,
	      visible: false,
	      parentLevelCode: '',
	      breadcrumbDicts: [],
	      dataInfo: null
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(null, 1);
	      this.judge(this.props.account_info);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          pageNo = _state.pageNo,
	          condition = _state.condition;
	
	      var params = {
	        pageNo: pageNo,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    // 加载需公司账户信息数据
	
	
	    // 字典详情
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          data = _state2.data,
	          isLoading = _state2.isLoading,
	          total = _state2.total,
	          pageNo = _state2.pageNo,
	          pageSize = _state2.pageSize,
	          isPermission = _state2.isPermission,
	          parentLevelCode = _state2.parentLevelCode,
	          breadcrumbDicts = _state2.breadcrumbDicts,
	          visible = _state2.visible,
	          dataInfo = _state2.dataInfo;
	
	      var dict = breadcrumbDicts[breadcrumbDicts.length - 1];
	      var pagination = {
	        showSizeChanger: true,
	        pageSize: pageSize,
	        total: total,
	        current: pageNo,
	        pageSizeOptions: ['10', '50', '100', '200', '500'],
	        onShowSizeChange: function onShowSizeChange(current, size) {
	          _this2.loadData(dict, current, size);
	        },
	        onChange: function onChange(current) {
	          _this2.loadData(dict, current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 13 },
	              isPermission ? _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', onClick: this.addDict },
	                '\u6DFB\u52A0'
	              ) : null
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tableList' },
	            _react2.default.createElement(
	              _antd.Breadcrumb,
	              null,
	              _react2.default.createElement(
	                _antd.Breadcrumb.Item,
	                { onClick: function onClick() {
	                    return _this2.loadDataOnClick(null);
	                  } },
	                'root'
	              ),
	              breadcrumbDicts.map(function (breadcrumbDict) {
	                return _react2.default.createElement(
	                  _antd.Breadcrumb.Item,
	                  {
	                    key: breadcrumbDict.uuid,
	                    onClick: function onClick() {
	                      return _this2.loadDataOnClick(breadcrumbDict);
	                    }
	                  },
	                  breadcrumbDict.name
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(_antd.Table, {
	            rowKey: 'uuid',
	            loading: isLoading,
	            columns: this.columns(),
	            dataSource: data,
	            pagination: pagination
	          }),
	          _react2.default.createElement(_ModalDictAdd2.default, {
	            parentLevelCode: parentLevelCode,
	            visible: visible,
	            data: dataInfo,
	            onOk: function onOk(params) {
	              return _this2.saveDict(params);
	            },
	            onCancel: function onCancel() {
	              return _this2.handlerVisible(false);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    account_info: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Index));

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Textarea = _antd.Input;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.submit = function () {
	      var _this$props = _this.props,
	          data = _this$props.data,
	          parentLevelCode = _this$props.parentLevelCode;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          values.uuid = data ? data.uuid : '';
	          values.parentLevelCode = parentLevelCode;
	          values.levelCode = data ? data.levelCode : '';
	          _this.props.onOk(values);
	          _this.props.form.resetFields();
	        }
	      });
	    };
	
	    _this.onCancel = function () {
	      _this.props.form.resetFields();
	      _this.props.onCancel();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var data = this.props.data;
	
	      var ItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: data && data.uuid ? '编辑字典' : '创建字典',
	          visible: this.props.visible,
	          onOk: this.submit,
	          onCancel: this.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u540D\u79F0' }, ItemLayout),
	                getFieldDecorator('name', {
	                  rules: [{ required: true, message: '请输入名称!' }],
	                  initialValue: data && data.uuid ? data.name : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u540D\u79F0' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u7C7B\u4EE3\u7801' }, ItemLayout),
	                getFieldDecorator('charCode', {
	                  rules: [{ required: true, message: '请输入分类代码!' }],
	                  initialValue: data && data.uuid ? data.charCode : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5206\u7C7B\u4EE3\u7801' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u72B6\u6001' }, ItemLayout),
	                getFieldDecorator('status', {
	                  rules: [{ required: true, message: '请选择状态!' }],
	                  initialValue: data && data.uuid ? data.status : 1
	                })(_react2.default.createElement(
	                  _antd.Radio.Group,
	                  null,
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 1 },
	                    '\u542F\u7528'
	                  ),
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 0 },
	                    '\u7981\u7528'
	                  ),
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 2 },
	                    '\u5220\u9664'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5907\u6CE8' }, ItemLayout),
	                getFieldDecorator('remark', {
	                  initialValue: data && data.uuid ? data.remark : ''
	                })(_react2.default.createElement(Textarea, { placeholder: '\u5907\u6CE8' }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(IndexModal));

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _function = __webpack_require__(419);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _ModalFunctionAdd = __webpack_require__(1460);
	
	var _ModalFunctionAdd2 = _interopRequireDefault(_ModalFunctionAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var typeNames = {
	  A: '系统分类',
	  C: '导航分类',
	  N: '功能导航',
	  B: '功能按钮'
	};
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function () {
	      var params = {};
	      _this.setState({
	        isLoading: true
	      });
	      (0, _function.queryFunctionListTree)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.getFunctionInfo = function (uuid) {
	      (0, _function.queryFunctionInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          var levelCode = res.data.levelCode;
	
	          var parentLevelCode = void 0;
	          if (levelCode && levelCode.length > 2) {
	            parentLevelCode = levelCode.slice(0, levelCode.length - 2);
	          }
	          _this.setState({
	            dataInfo: res.data || [],
	            parentLevelCode: parentLevelCode || ''
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.saveFunction = function (params) {
	      (0, _function.querySaveFunction)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handlerVisible(false);
	          _this.setState({ dataInfo: null });
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deleteFunction = function (uuid) {
	      (0, _function.queryDeleteFunction)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.loadData();
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.judge = function (accountInfo) {
	      var isPermission = false;
	      if (accountInfo.admin) {
	        isPermission = true;
	      }
	
	      _this.setState({
	        isPermission: isPermission
	      });
	    };
	
	    _this.handlerVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '名称',
	        dataIndex: 'funName'
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 1 ? '启用' : '禁用'
	          );
	        }
	      }, {
	        title: '服务名称',
	        dataIndex: 'resource'
	      }, {
	        title: '加载目标',
	        dataIndex: 'target'
	      }, {
	        title: '功能项类型',
	        dataIndex: 'type',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            typeNames[text]
	          );
	        }
	      }, {
	        title: '图标资源',
	        dataIndex: 'pic'
	      }, {
	        title: '备注',
	        dataIndex: 'remark'
	      }, {
	        title: '操作',
	        render: function render(text, record) {
	          var isPermission = _this.state.isPermission;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            isPermission ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.addFunction(record.levelCode);
	                  } },
	                '\u65B0\u589E'
	              ),
	              _react2.default.createElement('span', { className: 'ant-divider' }),
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.editFunction(record.uuid);
	                  } },
	                '\u7F16\u8F91'
	              ),
	              _react2.default.createElement('span', { className: 'ant-divider' }),
	              _react2.default.createElement(
	                _antd.Popconfirm,
	                {
	                  onConfirm: function onConfirm() {
	                    return _this.deleteFunction(record.uuid);
	                  },
	                  title: '\u786E\u5B9A\u5220\u9664\u5F53\u524D\u83DC\u5355\u680F\u5417\uFF1F',
	                  placement: 'topRight',
	                  overlayStyle: { width: 200 }
	                },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'ant-dropdown-link' },
	                  '\u5220\u9664'
	                )
	              )
	            ) : null,
	            ' '
	          );
	        }
	      }];
	    };
	
	    _this.addFunction = function (levelCode) {
	      levelCode && _this.setState({ parentLevelCode: levelCode });
	      _this.setState({ dataInfo: null });
	      _this.handlerVisible(true);
	    };
	
	    _this.editFunction = function (uuid) {
	      _this.getFunctionInfo(uuid);
	      _this.handlerVisible(true);
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: true,
	      parentLevelCode: '',
	      isPermission: false,
	      visible: false,
	      dataInfo: null
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(null, 1);
	      this.judge(this.props.account_info);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.dispatch((0, _back_info.setBackInfo)({}));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    // 加载需公司账户信息数据
	
	
	    // 菜单栏详情
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          isLoading = _state.isLoading,
	          parentLevelCode = _state.parentLevelCode,
	          isPermission = _state.isPermission,
	          visible = _state.visible,
	          dataInfo = _state.dataInfo;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 13 },
	              isPermission ? _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', onClick: function onClick() {
	                    return _this2.addFunction('');
	                  } },
	                '\u6DFB\u52A0'
	              ) : null
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          ),
	          _react2.default.createElement(_antd.Table, {
	            rowKey: 'uuid',
	            loading: isLoading,
	            columns: this.columns(),
	            dataSource: data,
	            pagination: false
	          }),
	          _react2.default.createElement(_ModalFunctionAdd2.default, {
	            parentLevelCode: parentLevelCode,
	            visible: visible,
	            data: dataInfo,
	            onOk: function onOk(params) {
	              return _this2.saveFunction(params);
	            },
	            onCancel: function onCancel() {
	              return _this2.handlerVisible(false);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    account_info: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Index));

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Textarea = _antd.Input;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.submit = function () {
	      var _this$props = _this.props,
	          data = _this$props.data,
	          parentLevelCode = _this$props.parentLevelCode;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          values.uuid = data ? data.uuid : '';
	          values.parentLevelCode = parentLevelCode;
	          values.levelCode = data ? data.levelCode : '';
	          _this.props.onOk(values);
	          _this.props.form.resetFields();
	        }
	      });
	    };
	
	    _this.onCancel = function () {
	      _this.props.form.resetFields();
	      _this.props.onCancel();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var data = this.props.data;
	
	      var ItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: data && data.uuid ? '编辑菜单栏' : '创建菜单栏',
	          visible: this.props.visible,
	          onOk: this.submit,
	          onCancel: this.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6240\u5C5E\u7CFB\u7EDF' }, ItemLayout),
	                getFieldDecorator('crappUuid', {
	                  rules: [{ required: true, message: '所属系统!' }],
	                  initialValue: data && data.uuid ? data.crappUuid : 'bszb'
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  null,
	                  _react2.default.createElement(
	                    Option,
	                    { value: 'core' },
	                    '\u7CFB\u7EDF\u5E73\u53F0'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { value: 'bszb' },
	                    '\u5E2E\u5B9E\u8D44\u672C\u6295\u8D44\u7BA1\u7406\u51B3\u7B56\u7CFB\u7EDF'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u529F\u80FD\u9879\u540D\u79F0' }, ItemLayout),
	                getFieldDecorator('funName', {
	                  rules: [{ required: true, message: '请输入功能项名称!' }],
	                  initialValue: data && data.uuid ? data.funName : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u529F\u80FD\u9879\u540D\u79F0' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u72B6\u6001' }, ItemLayout),
	                getFieldDecorator('status', {
	                  rules: [{ required: true, message: '请选择状态!' }],
	                  initialValue: data && data.uuid ? data.status : 1
	                })(_react2.default.createElement(
	                  _antd.Radio.Group,
	                  { value: data && data.uuid ? data.status : 1 },
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 1 },
	                    '\u542F\u7528'
	                  ),
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 0 },
	                    '\u7981\u7528'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u529F\u80FD\u9879\u7C7B\u578B' }, ItemLayout),
	                getFieldDecorator('type', {
	                  rules: [{ required: true, message: '请选择功能项类型!' }],
	                  initialValue: data && data.uuid ? data.type : 'N'
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  null,
	                  _react2.default.createElement(
	                    Option,
	                    { value: 'A' },
	                    '\u7CFB\u7EDF\u5206\u7C7B'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { value: 'C' },
	                    '\u5BFC\u822A\u5206\u7C7B'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { value: 'N' },
	                    '\u529F\u80FD\u5BFC\u822A'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { value: 'B' },
	                    '\u529F\u80FD\u6309\u94AE'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u670D\u52A1\u540D\u79F0' }, ItemLayout),
	                getFieldDecorator('resource', {
	                  rules: [{ required: true, message: '请输入服务名称!' }],
	                  initialValue: data && data.uuid ? data.resource : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u670D\u52A1\u540D\u79F0' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u52A0\u8F7D\u76EE\u6807' }, ItemLayout),
	                getFieldDecorator('target', {
	                  initialValue: data && data.uuid ? data.target : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u52A0\u8F7D\u76EE\u6807' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u56FE\u6807\u8D44\u6E90' }, ItemLayout),
	                getFieldDecorator('pic', {
	                  initialValue: data && data.uuid ? data.pic : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u56FE\u6807\u8D44\u6E90' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5907\u6CE8' }, ItemLayout),
	                getFieldDecorator('remark', {
	                  initialValue: data && data.uuid ? data.remark : ''
	                })(_react2.default.createElement(Textarea, { placeholder: '\u5907\u6CE8' }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(IndexModal));

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _role = __webpack_require__(323);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _ModalRoleAdd = __webpack_require__(1462);
	
	var _ModalRoleAdd2 = _interopRequireDefault(_ModalRoleAdd);
	
	var _ModalRoleFuncAdd = __webpack_require__(1463);
	
	var _ModalRoleFuncAdd2 = _interopRequireDefault(_ModalRoleFuncAdd);
	
	var _ModalRoleUsercAdd = __webpack_require__(1464);
	
	var _ModalRoleUsercAdd2 = _interopRequireDefault(_ModalRoleUsercAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo, pageSize) {
	      _this.setState({
	        isLoading: true
	      });
	      var params = {};
	      var _this$state = _this.state,
	          condition = _this$state.condition,
	          no = _this$state.pageNo;
	
	      var current = pageNo || no;
	      params.limit = pageSize || 15;
	      params.start = current;
	      params.condition = condition || '';
	      (0, _role.queryRoleList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            isLoading: false,
	            total: res.totalSize,
	            pageNo: current
	          });
	        }
	      });
	    };
	
	    _this.getRoleInfo = function (uuid) {
	      (0, _role.queryRoleInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data || []
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.saveRole = function (params) {
	      (0, _role.querySaveRole)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handlerVisible(false);
	          _this.setState({ dataInfo: null });
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.saveRoleFunc = function (roleUuid, functionUuids, callback) {
	      (0, _role.querySaveRoleFunc)({ roleUuid: roleUuid, funcUuids: functionUuids }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handlerFuncRelateVisible(false, callback);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.saveRoleUser = function (roleUuid, accountUuids, callback) {
	      (0, _role.querySaveRoleUserByRole)({ roleUuid: roleUuid, accountUuids: accountUuids }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handlerUserRelateVisible(false, callback);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deleteRole = function (uuid) {
	      (0, _role.queryDeleteRole)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.loadData();
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.judge = function (accountInfo) {
	      var isPermission = false;
	      if (accountInfo.admin) {
	        isPermission = true;
	      }
	
	      _this.setState({
	        isPermission: isPermission
	      });
	    };
	
	    _this.handlerVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handlerFuncRelateVisible = function (flag, callback) {
	      _this.setState({
	        funcRelateVisible: !!flag
	      }, callback);
	    };
	
	    _this.handlerUserRelateVisible = function (flag, callback) {
	      _this.setState({
	        userRelateVisible: !!flag
	      }, callback);
	    };
	
	    _this.addRole = function () {
	      _this.setState({ dataInfo: null });
	      _this.handlerVisible(true);
	    };
	
	    _this.addRoleFunc = function (uuid) {
	      _this.setState({ roleUuid: uuid }, _this.handlerFuncRelateVisible(true));
	    };
	
	    _this.addRoleUser = function (uuid) {
	      _this.setState({ roleUuid: uuid }, _this.handlerUserRelateVisible(true));
	    };
	
	    _this.editRole = function (uuid) {
	      _this.getRoleInfo(uuid);
	      _this.handlerVisible(true);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '角色名称',
	        dataIndex: 'name'
	      }, {
	        title: '角色状态',
	        dataIndex: 'status',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 1 ? '启用' : '禁用'
	          );
	        }
	      }, {
	        title: '创建日期',
	        dataIndex: 'createDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-dd HH:mm:ss')
	          );
	        }
	      }, {
	        title: '业务系统名称',
	        dataIndex: 'crappUuid',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 'bszb' ? '帮实资本投资管理决策系统' : '系统平台'
	          );
	        }
	      }, {
	        title: '备注',
	        dataIndex: 'remark'
	      }, {
	        title: '操作',
	        render: function render(text, record) {
	          var isPermission = _this.state.isPermission;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            isPermission ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.editRole(record.uuid);
	                  } },
	                '\u7F16\u8F91'
	              ),
	              _react2.default.createElement('span', { className: 'ant-divider' }),
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.addRoleFunc(record.uuid);
	                  } },
	                '\u89D2\u8272\u5B9A\u4E49'
	              ),
	              _react2.default.createElement('span', { className: 'ant-divider' }),
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.addRoleUser(record.uuid);
	                  } },
	                '\u89D2\u8272\u7528\u6237\u6388\u6743'
	              ),
	              _react2.default.createElement('span', { className: 'ant-divider' }),
	              _react2.default.createElement(
	                _antd.Popconfirm,
	                {
	                  onConfirm: function onConfirm() {
	                    return _this.deleteRole(record.uuid);
	                  },
	                  title: '\u786E\u5B9A\u5220\u9664\u5F53\u524D\u83DC\u5355\u680F\u5417\uFF1F',
	                  placement: 'topRight',
	                  overlayStyle: { width: 200 }
	                },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'ant-dropdown-link' },
	                  '\u5220\u9664'
	                )
	              )
	            ) : null,
	            ' '
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: true,
	      total: 0,
	      pageNo: 1,
	      pageSize: 15,
	      isPermission: false,
	      visible: false,
	      funcRelateVisible: false,
	      userRelateVisible: false,
	      dataInfo: null
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	      this.judge(this.props.account_info);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.props.dispatch((0, _back_info.setBackInfo)({}));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    // 菜单栏详情
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          isLoading = _state.isLoading,
	          total = _state.total,
	          pageNo = _state.pageNo,
	          pageSize = _state.pageSize,
	          isPermission = _state.isPermission,
	          visible = _state.visible,
	          funcRelateVisible = _state.funcRelateVisible,
	          userRelateVisible = _state.userRelateVisible,
	          dataInfo = _state.dataInfo,
	          roleUuid = _state.roleUuid;
	
	      var pagination = {
	        showSizeChanger: true,
	        pageSize: pageSize,
	        total: total,
	        current: pageNo,
	        pageSizeOptions: ['10', '50', '100', '200', '500'],
	        onShowSizeChange: function onShowSizeChange(current, size) {
	          _this2.loadData(current, size);
	        },
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 13 },
	              isPermission ? _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', onClick: function onClick() {
	                    return _this2.addRole('');
	                  } },
	                '\u6DFB\u52A0'
	              ) : null
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          ),
	          _react2.default.createElement(_antd.Table, {
	            rowKey: 'uuid',
	            loading: isLoading,
	            columns: this.columns(),
	            dataSource: data,
	            pagination: pagination
	          }),
	          _react2.default.createElement(_ModalRoleAdd2.default, {
	            visible: visible,
	            data: dataInfo,
	            onOk: function onOk(params) {
	              return _this2.saveRole(params);
	            },
	            onCancel: function onCancel() {
	              return _this2.handlerVisible(false);
	            }
	          }),
	          _react2.default.createElement(_ModalRoleFuncAdd2.default, {
	            visible: funcRelateVisible,
	            roleUuid: roleUuid,
	            onOk: function onOk(uuid, selectedKeys, callback) {
	              return _this2.saveRoleFunc(uuid, selectedKeys, callback);
	            },
	            onCancel: function onCancel() {
	              return _this2.handlerFuncRelateVisible(false);
	            }
	          }),
	          _react2.default.createElement(_ModalRoleUsercAdd2.default, {
	            visible: userRelateVisible,
	            roleUuid: roleUuid,
	            onOk: function onOk(accountUuids, callback) {
	              return _this2.saveRoleUser(roleUuid, accountUuids, callback);
	            },
	            onCancel: function onCancel() {
	              return _this2.handlerUserRelateVisible(false);
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    account_info: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Index));

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Textarea = _antd.Input;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.data;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          values.unid = data ? data.unid : '';
	          _this.props.onOk(values);
	          _this.props.form.resetFields();
	        }
	      });
	    };
	
	    _this.onCancel = function () {
	      _this.props.form.resetFields();
	      _this.props.onCancel();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var data = this.props.data;
	
	      var ItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: data && data.uuid ? '编辑菜单栏' : '创建菜单栏',
	          visible: this.props.visible,
	          onOk: this.submit,
	          onCancel: this.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6240\u5C5E\u7CFB\u7EDF' }, ItemLayout),
	                getFieldDecorator('crappUuid', {
	                  rules: [{ required: true, message: '所属系统!' }],
	                  initialValue: data && data.uuid ? data.crappUuid : 'bszb'
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  null,
	                  _react2.default.createElement(
	                    Option,
	                    { value: 'core' },
	                    '\u7CFB\u7EDF\u5E73\u53F0'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { value: 'bszb' },
	                    '\u5E2E\u5B9E\u8D44\u672C\u6295\u8D44\u7BA1\u7406\u51B3\u7B56\u7CFB\u7EDF'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6807\u8BC6UUID' }, ItemLayout),
	                getFieldDecorator('uuid', {
	                  rules: [{ required: true, message: '请输入标识UUID!' }],
	                  initialValue: data && data.uuid ? data.uuid : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u6807\u8BC6UUID', disabled: data && data.uuid }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u89D2\u8272\u540D\u79F0' }, ItemLayout),
	                getFieldDecorator('name', {
	                  rules: [{ required: true, message: '角色名称!' }],
	                  initialValue: data && data.uuid ? data.name : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u89D2\u8272\u540D\u79F0' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u89D2\u8272\u72B6\u6001' }, ItemLayout),
	                getFieldDecorator('status', {
	                  rules: [{ required: true, message: '角色状态!' }],
	                  initialValue: data && data.uuid ? data.status : 1
	                })(_react2.default.createElement(
	                  _antd.Radio.Group,
	                  null,
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 1 },
	                    '\u542F\u7528'
	                  ),
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 0 },
	                    '\u7981\u7528'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5907\u6CE8' }, ItemLayout),
	                getFieldDecorator('remark', {
	                  initialValue: data && data.uuid ? data.remark : ''
	                })(_react2.default.createElement(Textarea, { placeholder: '\u5907\u6CE8' }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(IndexModal));

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _SelectFunction = __webpack_require__(1465);
	
	var _SelectFunction2 = _interopRequireDefault(_SelectFunction);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.setStateCheckedKeys = function (checkedKeys) {
	      _this.setState({
	        checkedKeys: checkedKeys
	      });
	    };
	
	    _this.submit = function () {
	      var roleUuid = _this.props.roleUuid;
	      var _this$state$checkedKe = _this.state.checkedKeys,
	          checked = _this$state$checkedKe.checked,
	          halfChecked = _this$state$checkedKe.halfChecked;
	
	      var checkedKeys = checked.concat(halfChecked);
	      _this.props.onOk(roleUuid, checkedKeys, function () {
	        return _this.props.form.resetFields();
	      });
	    };
	
	    _this.onCancel = function () {
	      _this.props.onCancel();
	    };
	
	    _this.state = {
	      checkedKeys: { checked: [], halfChecked: [] }
	    };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var roleUuid = this.props.roleUuid;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u89D2\u8272\u5B9A\u4E49',
	          visible: this.props.visible,
	          onOk: this.submit,
	          onCancel: this.onCancel
	        },
	        _react2.default.createElement(_SelectFunction2.default, { roleUuid: roleUuid, setStateCheckedKeys: this.setStateCheckedKeys })
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(IndexModal));

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _role = __webpack_require__(323);
	
	var _SearchUser = __webpack_require__(273);
	
	var _SearchUser2 = _interopRequireDefault(_SearchUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.submit = function () {
	      var form = _this.props.form;
	
	      form.validateFields(function (err, values) {
	        if (!err) {
	          _this.props.onOk(values.accountUuids, function () {
	            return form.resetFields();
	          });
	        }
	      });
	    };
	
	    _this.onCancel = function () {
	      _this.props.onCancel();
	    };
	
	    _this.loadData = function (roleUuid) {
	      roleUuid && (0, _role.queryAccountRoleAccounts)({ roleUuid: roleUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          var accountUuids = res.data.map(function (item) {
	            return item.uuid;
	          });
	          _this.setState({
	            accountUuids: accountUuids
	          }, function () {
	            return _this.props.form.setFieldsValue({ accountUuids: accountUuids });
	          });
	        }
	      });
	    };
	
	    _this.onChangeProcessor = function (value) {
	      _this.setState({ accountUuids: value });
	    };
	
	    _this.state = { accountUuids: [] };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.loadData(this.props.roleUuid);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.props.roleUuid !== nextProps.roleUuid && this.loadData(nextProps.roleUuid);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var accountUuids = this.state.accountUuids;
	
	      var ItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u89D2\u8272\u7528\u6237\u6388\u6743',
	          visible: this.props.visible,
	          onOk: this.submit,
	          onCancel: this.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5173\u8054\u7528\u6237' }, ItemLayout),
	                getFieldDecorator('accountUuids', {
	                  rules: [{ required: true, message: '关联用户!' }],
	                  initialValue: accountUuids || []
	                })(_react2.default.createElement(_SearchUser2.default, {
	                  isMultiple: 'multiple',
	                  onChange: function onChange(value, options) {
	                    _this2.onChangeProcessor(value, options);
	                  }
	                }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(IndexModal));

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _role = __webpack_require__(323);
	
	var _function = __webpack_require__(419);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.Tree.TreeNode;
	
	var SelectFunction = function (_Component) {
	  _inherits(SelectFunction, _Component);
	
	  function SelectFunction(props) {
	    _classCallCheck(this, SelectFunction);
	
	    var _this = _possibleConstructorReturn(this, (SelectFunction.__proto__ || Object.getPrototypeOf(SelectFunction)).call(this, props));
	
	    _this.loadData = function () {
	      return (0, _function.queryFunctionListTreeEnable)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ list: res.data });
	        }
	      });
	    };
	
	    _this.loadChecks = function (roleUuid) {
	      return (0, _role.queryRoleFunctionFunctionList)({ roleUuid: roleUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            checkedKeys: {
	              checked: res.data.map(function (item) {
	                return item.uuid;
	              }),
	              halfChecked: []
	            }
	          });
	        }
	      });
	    };
	
	    _this.initCheckedKeys = function () {
	      var _this$state = _this.state,
	          list = _this$state.list,
	          checked = _this$state.checkedKeys.checked;
	      var setStateCheckedKeys = _this.props.setStateCheckedKeys;
	
	
	      _this.handlerCheck(list, checked);
	      var newChecked = [];
	      var halfChecked = [];
	      _this.handlerCheckedKeys(list, newChecked, halfChecked);
	      var checkedKeys = { checked: newChecked, halfChecked: halfChecked };
	      _this.setState({
	        checkedKeys: checkedKeys
	      });
	      setStateCheckedKeys(checkedKeys);
	    };
	
	    _this.handlerCheck = function (list, checked) {
	      return list.map(function (item) {
	        if (checked.includes(item.uuid)) {
	          if (item.children && item.children.length > 0) {
	            _this.handlerCheck(item.children, checked);
	            var temp = item.children.filter(function (item1) {
	              return item1 && item1.isChecked === 0;
	            });
	            if (temp.length > 0) {
	              item.isChecked = 1;
	            }
	          } else {
	            item.isChecked = 2;
	          }
	        } else {
	          item.isChecked = 0;
	        }
	        return item;
	      });
	    };
	
	    _this.handlerCheckedKeys = function (list, checked, halfChecked) {
	      list.forEach(function (item) {
	        if (item.isChecked === 2) {
	          checked.push(item.uuid);
	        } else if (item.isChecked === 1) {
	          halfChecked.push(item.uuid);
	        }
	        if (item.children && item.children.length > 0) {
	          _this.handlerCheckedKeys(item.children, checked, halfChecked);
	        }
	      });
	    };
	
	    _this.onCheck = function (checkedKeys, info) {
	      var setStateCheckedKeys = _this.props.setStateCheckedKeys;
	
	      var hanldedcheckedKeys = { checked: checkedKeys, halfChecked: info.halfCheckedKeys };
	      _this.setState({ checkedKeys: hanldedcheckedKeys });
	      setStateCheckedKeys(hanldedcheckedKeys);
	    };
	
	    _this.renderTreeNodes = function (data) {
	      return data.map(function (item) {
	        if (item.children) {
	          return _react2.default.createElement(
	            TreeNode,
	            { title: _this.titleItem(item), key: item.uuid, dataRef: item },
	            _this.renderTreeNodes(item.children)
	          );
	        }
	        return _react2.default.createElement(TreeNode, Object.assign({ title: _this.titleItem(item), key: item.uuid, dataRef: item }, item));
	      });
	    };
	
	    _this.titleItem = function (item) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'treeTitle' },
	        _react2.default.createElement(
	          'span',
	          { style: { width: '200px' } },
	          item.funName
	        )
	      );
	    };
	
	    _this.state = {
	      list: [],
	      checkedKeys: { checked: [], halfChecked: [] }
	    };
	    return _this;
	  }
	
	  _createClass(SelectFunction, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.loadData().then(function () {
	        return _this2.loadChecks(_this2.props.roleUuid).then(function () {
	          return _this2.initCheckedKeys();
	        });
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.props.roleUuid !== nextProps.roleUuid && this.loadChecks(nextProps.roleUuid).then(function () {
	        return _this3.initCheckedKeys();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          list = _state.list,
	          checkedKeys = _state.checkedKeys;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Tree,
	          { checkable: true, onCheck: this.onCheck, checkedKeys: checkedKeys },
	          this.renderTreeNodes(list || [])
	        )
	      );
	    }
	  }]);
	
	  return SelectFunction;
	}(_react.Component);
	
	exports.default = SelectFunction;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1461);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(1471);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _Index5 = __webpack_require__(1468);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _PageAdd = __webpack_require__(672);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	var _PageEdit = __webpack_require__(1469);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _Index7 = __webpack_require__(1457);
	
	var _Index8 = _interopRequireDefault(_Index7);
	
	var _Index9 = __webpack_require__(1455);
	
	var _Index10 = _interopRequireDefault(_Index9);
	
	var _Index11 = __webpack_require__(1459);
	
	var _Index12 = _interopRequireDefault(_Index11);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * routers
	 * 更多关于Router的使用，请参考以下教程
	 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
	 */
	
	// 人力资源
	var router = {
	  path: 'boss',
	  breadcrumbName: '开发者中心',
	  childRoutes: [{
	    path: 'serialNumber',
	    breadcrumbName: '角色管理',
	    indexRoute: { component: _Index6.default },
	    childRoutes: [{
	      path: 'add',
	      breadcrumbName: '新增流水号',
	      component: _PageAdd2.default
	    }, {
	      path: 'edit/:uuid',
	      breadcrumbName: '编辑流水号',
	      component: _PageEdit2.default
	    }]
	  }, {
	    path: 'dict',
	    breadcrumbName: '字典设置',
	    indexRoute: { component: _Index8.default },
	    childRoutes: []
	  }, {
	    path: 'global/config',
	    breadcrumbName: '系统配置项设置',
	    indexRoute: { component: _Index10.default },
	    childRoutes: []
	  }, {
	    path: 'function',
	    breadcrumbName: '系统菜单栏设置',
	    indexRoute: { component: _Index12.default },
	    childRoutes: []
	  }, {
	    path: 'role',
	    breadcrumbName: '角色管理',
	    indexRoute: { component: _Index2.default },
	    childRoutes: []
	  }, {
	    path: 'user',
	    breadcrumbName: '用户管理',
	    indexRoute: { component: _Index4.default },
	    childRoutes: []
	  }]
	};
	
	exports.default = router;

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var TextArea = _antd.Input.TextArea;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handSubmit = _this.props.handSubmit;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          values.autogrow = values.autogrow ? 1 : 0;
	          values.recordHistory = values.recordHistory ? 1 : 0;
	          handSubmit(values);
	        }
	      });
	    };
	
	    _this.handleAutogrowChange = function (checked) {
	      _this.props.form.setFieldsValue({
	        autogrow: checked === true ? 1 : 0
	      });
	    };
	
	    _this.handleRecordHistoryChange = function (checked) {
	      _this.props.form.setFieldsValue({
	        recordHistory: checked === true ? 1 : 0
	      });
	    };
	
	    _this.state = {
	      defaultAutogrowChecked: true,
	      defaultRecordHistoryChecked: true
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.dataInfo !== this.props.dataInfo) {
	        var defaultAutogrowChecked = nextProps.dataInfo.autogrow === 1;
	        var defaultRecordHistoryChecked = nextProps.dataInfo.recordHistory === 1;
	        this.setState({
	          defaultAutogrowChecked: defaultAutogrowChecked,
	          defaultRecordHistoryChecked: defaultRecordHistoryChecked
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var dataInfo = this.props.dataInfo;
	      var _state = this.state,
	          defaultAutogrowChecked = _state.defaultAutogrowChecked,
	          defaultRecordHistoryChecked = _state.defaultRecordHistoryChecked;
	
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      var ItemLayout2 = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 18 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', style: { marginRight: 10 }, htmlType: 'submit' },
	            '\u786E\u8BA4'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6D41\u6C34\u53F7\u6807\u8BC6' }, ItemLayout),
	                getFieldDecorator('uuid', {
	                  rules: [{
	                    required: true,
	                    message: '流水号标识'
	                  }],
	                  initialValue: dataInfo.uuid
	                })(_react2.default.createElement(_antd.Input, { disabled: !!dataInfo.uuid, placeholder: '\u6D41\u6C34\u53F7\u6807\u8BC6', type: 'text' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6D41\u6C34\u53F7\u540D\u79F0' }, ItemLayout),
	                getFieldDecorator('label', {
	                  initialValue: dataInfo.label
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u6D41\u6C34\u53F7\u540D\u79F0', type: 'text' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6D41\u6C34\u53F7\u6A21\u5F0F' }, ItemLayout),
	                getFieldDecorator('patten', {
	                  initialValue: dataInfo.patten
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u6D41\u6C34\u53F7\u6A21\u5F0F' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F53\u524D\u7F16\u53F7' }, ItemLayout),
	                getFieldDecorator('currentNumber', {
	                  initialValue: dataInfo.currentNumber
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5F53\u524D\u7F16\u53F7', type: 'text' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u81EA\u52A8\u589E\u6DA8' }, ItemLayout),
	                getFieldDecorator('autogrow', {
	                  initialValue: dataInfo.autogrow || 1
	                })(_react2.default.createElement(_antd.Switch, {
	                  key: defaultAutogrowChecked,
	                  defaultChecked: defaultAutogrowChecked,
	                  checkedChildren: '\u542F\u7528',
	                  unCheckedChildren: '\u7981\u7528',
	                  onChange: this.handleAutogrowChange
	                }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8BB0\u5F55\u5386\u53F2' }, ItemLayout),
	                getFieldDecorator('recordHistory', { initialValue: dataInfo.recordHistory || 1 })(_react2.default.createElement(_antd.Switch, {
	                  key: defaultRecordHistoryChecked,
	                  defaultChecked: defaultRecordHistoryChecked,
	                  checkedChildren: '\u542F\u7528',
	                  unCheckedChildren: '\u7981\u7528',
	                  onChange: this.handleRecordHistoryChange
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u589E\u6DA8\u6B65\u957F' }, ItemLayout),
	                getFieldDecorator('step', {
	                  initialValue: dataInfo.step
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u589E\u6DA8\u6B65\u957F', type: 'number' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u914D\u7F6E\u9879\u63CF\u8FF0' }, ItemLayout2),
	                getFieldDecorator('desc', {
	                  initialValue: dataInfo.desc
	                })(_react2.default.createElement(TextArea, { placeholder: '\u914D\u7F6E\u9879\u63CF\u8FF0', type: 'textarea', rows: 4 }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(BaseForm);

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _serialNumber = __webpack_require__(420);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo) {
	      var params = {};
	      var condition = _this.state.condition;
	
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      _this.setState({
	        pageNo: current,
	        isLoading: true
	      });
	      (0, _serialNumber.querySerialNumberList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var pageNo = _this.state.pageNo;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.loadData(pageNo);
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.judge = function (accountInfo) {
	      var isPermission = false;
	      if (accountInfo.admin) {
	        isPermission = true;
	      }
	      _this.setState({
	        isPermission: isPermission
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '流水号名称',
	        dataIndex: 'label'
	      }, {
	        title: '流水号模式',
	        dataIndex: 'patten'
	      }, {
	        title: '历史编号',
	        dataIndex: 'history',
	        render: function render(text) {
	          var title = text;
	          if (text && text.length > 100) {
	            text = text.slice(0, 100) + '...';
	          }
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: title },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	        }
	      }, {
	        title: '当前编号',
	        dataIndex: 'currentNumber'
	      }, {
	        title: '自动增涨',
	        dataIndex: 'autogrow',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 1 ? '启用' : '禁用'
	          );
	        }
	      }, {
	        title: '记录历史',
	        dataIndex: 'recordHistory',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 1 ? '启用' : '禁用'
	          );
	        }
	      }, {
	        title: '创建时间',
	        dataIndex: 'createTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }, {
	        title: '更新时间',
	        dataIndex: 'updateTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }, {
	        title: '操作',
	        render: function render(text, record) {
	          var isPermission = _this.state.isPermission;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            isPermission ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/boss/serialNumber/edit/' + record.uuid },
	              '\u7F16\u8F91'
	            ) : null
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: true,
	      total: 0,
	      pageNo: 1,
	      isPermission: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	      this.judge(this.props.account_info);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          pageNo = _state.pageNo,
	          condition = _state.condition;
	
	      var params = {
	        pageNo: pageNo,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    // 加载需公司账户信息数据
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state2 = this.state,
	          data = _state2.data,
	          isLoading = _state2.isLoading,
	          total = _state2.total,
	          pageNo = _state2.pageNo,
	          isPermission = _state2.isPermission;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 13 },
	              isPermission ? _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/boss/serialNumber/add' },
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary' },
	                  '\u6DFB\u52A0'
	                )
	              ) : null
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          loading: isLoading,
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    account_info: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Index));

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _serialNumber = __webpack_require__(420);
	
	var _PageAdd2 = __webpack_require__(672);
	
	var _PageAdd3 = _interopRequireDefault(_PageAdd2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageEdit = function (_PageAdd) {
	  _inherits(PageEdit, _PageAdd);
	
	  function PageEdit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PageEdit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PageEdit.__proto__ || Object.getPrototypeOf(PageEdit)).call.apply(_ref, [this].concat(args))), _this), _this.getSerialNumber = function () {
	      (0, _serialNumber.querySerialNumberInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PageEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSerialNumber();
	    }
	  }]);
	
	  return PageEdit;
	}(_PageAdd3.default);
	
	exports.default = PageEdit;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.Tree.TreeNode;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.initialValue = function () {
	      var gData = _this.state.gData;
	
	      gData && gData.length > 0 && _this.props.handleChange(gData[0].uuid);
	    };
	
	    _this.getOrgTree = function (callBack) {
	      (0, _org.queryOrgTree)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            gData: res.data
	          }, callBack);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleSelect = function (a) {
	      _this.props.handleChange(a);
	    };
	
	    _this.onExpand = function (expandedKeys) {
	      _this.setState({
	        expandedKeys: expandedKeys
	      });
	    };
	
	    _this.renderTreeNodes = function (data) {
	      return data.map(function (item) {
	        if (item.children) {
	          return _react2.default.createElement(
	            TreeNode,
	            { title: _this.titleItem(item), key: item.uuid, dataRef: item },
	            _this.renderTreeNodes(item.children)
	          );
	        }
	        return _react2.default.createElement(TreeNode, Object.assign({ title: _this.titleItem(item), key: item.uuid, dataRef: item }, item));
	      });
	    };
	
	    _this.titleItem = function (item) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'treeTitle' },
	        _react2.default.createElement(
	          'span',
	          { style: { width: '200px' } },
	          item.name
	        )
	      );
	    };
	
	    _this.state = {
	      gData: [],
	      expandedKeys: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getOrgTree(this.initialValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          gData = _state.gData,
	          expandedKeys = _state.expandedKeys;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Tree,
	          {
	            defaultExpandAll: true,
	            onExpand: this.onExpand,
	            onSelect: this.handleSelect,
	            expandedKeys: expandedKeys
	          },
	          this.renderTreeNodes(gData || [])
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _user = __webpack_require__(54);
	
	var _ComponentOrg = __webpack_require__(1470);
	
	var _ComponentOrg2 = _interopRequireDefault(_ComponentOrg);
	
	var _ModalUserAdd = __webpack_require__(1472);
	
	var _ModalUserAdd2 = _interopRequireDefault(_ModalUserAdd);
	
	var _ModalUserOrgAdd = __webpack_require__(1473);
	
	var _ModalUserOrgAdd2 = _interopRequireDefault(_ModalUserOrgAdd);
	
	var _ModalUserRoleAdd = __webpack_require__(1474);
	
	var _ModalUserRoleAdd2 = _interopRequireDefault(_ModalUserRoleAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo) {
	      var orgUuid = _this.state.orgUuid;
	
	      if (orgUuid) {
	        var params = { orgUuid: orgUuid };
	        var no = _this.state.pageNo;
	        var current = pageNo || no;
	        params.limit = 15;
	        params.start = current;
	        _this.setState({
	          pageNo: current,
	          isLoading: true
	        });
	        (0, _user.queryAdminAccountList)(params).then(function (res) {
	          if (res.statusCode === 200) {
	            _this.setState({ data: res.data, total: res.totalSize, isLoading: false });
	          } else {
	            _antd.message.error(res.message);
	          }
	        });
	      }
	    };
	
	    _this.loadUserInfo = function (uuid, callback) {
	      (0, _user.queryAdminAccountInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ dataInfo: res.data }, callback);
	        }
	      });
	    };
	
	    _this.saveUser = function (params) {
	      (0, _user.querySaveAccount)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handlerVisible(false);
	          _this.loadData(1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.saveUserRole = function (accountUuid, roleUuids) {
	      (0, _user.querySaveAccountRole)({ accountUuid: accountUuid, roleUuids: roleUuids }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handlerRoleVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.saveUserOrg = function (params) {
	      (0, _user.querySaveAccountOrg)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handlerOrgVisible(false);
	          _this.loadData(_this.state.pageNo);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.judge = function (accountInfo) {
	      var isPermission = false;
	      if (accountInfo.admin) {
	        isPermission = true;
	      }
	
	      _this.setState({
	        isPermission: isPermission
	      });
	    };
	
	    _this.add = function () {
	      _this.setState({ dataInfo: null });
	      _this.handlerVisible(true);
	    };
	
	    _this.edit = function (uuid) {
	      _this.loadUserInfo(uuid, function () {
	        return _this.handlerVisible(true);
	      });
	    };
	
	    _this.editRole = function (uuid) {
	      _this.loadUserInfo(uuid, function () {
	        return _this.handlerRoleVisible(true);
	      });
	    };
	
	    _this.editOrg = function (uuid) {
	      _this.loadUserInfo(uuid, function () {
	        return _this.handlerOrgVisible(true);
	      });
	    };
	
	    _this.handlerVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handlerRoleVisible = function (flag) {
	      _this.setState({
	        roleVisible: !!flag
	      });
	    };
	
	    _this.handlerOrgVisible = function (flag) {
	      _this.setState({
	        orgVisible: !!flag
	      });
	    };
	
	    _this.handleOrgChange = function (value) {
	      if (Array.isArray(value) && value.length > 0) {
	        _this.setState({ orgUuid: value[0] }, function () {
	          return _this.loadData(1);
	        });
	      } else {
	        _this.setState({ orgUuid: value }, function () {
	          return _this.loadData(1);
	        });
	      }
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '默认机构名称',
	        dataIndex: 'orgName',
	        key: 'orgName'
	      }, {
	        title: '姓名',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '账户代码',
	        dataIndex: 'code',
	        key: 'code'
	      }, {
	        title: '手机号码',
	        dataIndex: 'mobile',
	        key: 'mobile'
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 1 ? '启用' : '禁用'
	          );
	        }
	      }, {
	        title: '编辑',
	        key: 'done',
	        render: function render(rext, record) {
	          var isPermission = _this.state.isPermission;
	
	          return isPermission ? _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.edit(record.uuid);
	                } },
	              '\u7F16\u8F91'
	            ),
	            _react2.default.createElement('span', { className: 'ant-divider' }),
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.editRole(record.uuid);
	                } },
	              '\u89D2\u8272\u6388\u6743'
	            ),
	            _react2.default.createElement('span', { className: 'ant-divider' }),
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.editOrg(record.uuid);
	                } },
	              '\u673A\u6784\u8BBE\u7F6E'
	            )
	          ) : null;
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: true,
	      orgUuid: '',
	      total: 0,
	      pageNo: 1,
	      isPermission: false,
	      dataInfo: null,
	      visible: false,
	      orgVisible: false,
	      roleVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	      this.judge(this.props.account_info);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          orgUuid = _state.orgUuid,
	          isLoading = _state.isLoading,
	          total = _state.total,
	          pageNo = _state.pageNo,
	          visible = _state.visible,
	          orgVisible = _state.orgVisible,
	          roleVisible = _state.roleVisible,
	          dataInfo = _state.dataInfo;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { display: 'flex' }, className: 'pageStaff' },
	          _react2.default.createElement(
	            'div',
	            { style: { width: '350px', marginRight: '16px' } },
	            _react2.default.createElement(_ComponentOrg2.default, { handleChange: this.handleOrgChange })
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: { flex: 1 } },
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', icon: 'plus', style: { marginBottom: 15 }, onClick: this.add },
	              '\u6DFB\u52A0'
	            ),
	            _react2.default.createElement(_antd.Table, {
	              rowKey: function rowKey(record) {
	                return record.uuid;
	              },
	              loading: isLoading,
	              columns: this.columns(),
	              dataSource: data,
	              pagination: pagination
	            }),
	            _react2.default.createElement(_ModalUserAdd2.default, {
	              visible: visible,
	              orgUuid: orgUuid,
	              data: dataInfo,
	              onOk: function onOk(params) {
	                return _this2.saveUser(params);
	              },
	              onCancel: function onCancel() {
	                return _this2.handlerVisible(false);
	              }
	            }),
	            _react2.default.createElement(_ModalUserRoleAdd2.default, {
	              visible: roleVisible,
	              accountUuid: dataInfo ? dataInfo.uuid : '',
	              onOk: function onOk(targetKeys) {
	                return _this2.saveUserRole(dataInfo ? dataInfo.uuid : '', targetKeys);
	              },
	              onCancel: function onCancel() {
	                return _this2.handlerRoleVisible(false);
	              }
	            }),
	            _react2.default.createElement(_ModalUserOrgAdd2.default, {
	              visible: orgVisible,
	              accountUuid: dataInfo ? dataInfo.uuid : '',
	              defaultOrgUuid: dataInfo ? dataInfo.orgUuid : '',
	              onOk: function onOk(params) {
	                return _this2.saveUserOrg(params);
	              },
	              onCancel: function onCancel() {
	                return _this2.handlerOrgVisible(false);
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    account_info: state.account_info
	  };
	})(Index);

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Textarea = _antd.Input;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.submit = function () {
	      var _this$props = _this.props,
	          data = _this$props.data,
	          orgUuid = _this$props.orgUuid;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          values.uuid = data ? data.uuid : '';
	          values.orgUuid = orgUuid;
	          _this.props.onOk(values);
	          _this.props.form.resetFields();
	        }
	      });
	    };
	
	    _this.onCancel = function () {
	      _this.props.form.resetFields();
	      _this.props.onCancel();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var data = this.props.data;
	
	      var ItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: data && data.uuid ? '编辑用户' : '创建用户',
	          visible: this.props.visible,
	          onOk: this.submit,
	          onCancel: this.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u540D\u79F0' }, ItemLayout),
	                getFieldDecorator('name', {
	                  rules: [{ required: true, message: '请输入名称!' }],
	                  initialValue: data && data.uuid ? data.name : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u540D\u79F0' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8D26\u6237\u4EE3\u7801' }, ItemLayout),
	                getFieldDecorator('code', {
	                  rules: [{ required: true, message: '请输入账户代码!' }],
	                  initialValue: data && data.uuid ? data.code : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u4EE3\u7801' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u72B6\u6001' }, ItemLayout),
	                getFieldDecorator('status', {
	                  rules: [{ required: true, message: '请选择状态!' }],
	                  initialValue: data && data.uuid ? data.status : 1
	                })(_react2.default.createElement(
	                  _antd.Radio.Group,
	                  null,
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 1 },
	                    '\u542F\u7528'
	                  ),
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 0 },
	                    '\u7981\u7528'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5907\u6CE8' }, ItemLayout),
	                getFieldDecorator('remark', {
	                  initialValue: data && data.uuid ? data.remark : ''
	                })(_react2.default.createElement(Textarea, { placeholder: '\u5907\u6CE8' }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(IndexModal));

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _user = __webpack_require__(54);
	
	var _SelectOrg = __webpack_require__(1475);
	
	var _SelectOrg2 = _interopRequireDefault(_SelectOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.loadData = function (accountUuid) {
	      accountUuid && (0, _user.queryAccountOrgOrgs)({ accountUuid: accountUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          var checkedKeys = res.data.map(function (item) {
	            return item.uuid;
	          });
	          var defaultOrgUuid = _this.state.defaultOrgUuid;
	
	          if (checkedKeys.includes(defaultOrgUuid)) {
	            checkedKeys.push(defaultOrgUuid);
	          }
	          _this.setState({ checkedKeys: checkedKeys, selectedItems: res.data });
	        }
	      });
	    };
	
	    _this.submit = function () {
	      var accountUuid = _this.props.accountUuid;
	      var _this$state = _this.state,
	          checkedKeys = _this$state.checkedKeys,
	          defaultOrgUuid = _this$state.defaultOrgUuid;
	
	      var params = {};
	      params.accountUuid = accountUuid;
	      params.orgUuids = checkedKeys;
	      params.defaultOrgUuid = defaultOrgUuid;
	      _this.props.onOk(params);
	    };
	
	    _this.onCancel = function () {
	      _this.props.form.resetFields();
	      _this.props.onCancel();
	    };
	
	    _this.setStateCheckedKeys = function (checkedKeys) {
	      _this.setState({
	        checkedKeys: checkedKeys
	      });
	    };
	
	    _this.setStateSelectedItems = function (selectedItems) {
	      _this.setState({
	        selectedItems: selectedItems
	      });
	    };
	
	    _this.onChangeDefault = function (uuid) {
	      _this.setState({ defaultOrgUuid: uuid });
	    };
	
	    _this.columns = function (defaultOrgUuid) {
	      return [{
	        title: '默认机构名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '操作',
	        dataIndex: 'uuid',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            rext !== defaultOrgUuid ? _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.onChangeDefault(record.uuid);
	                } },
	              '\u8BBE\u7F6E\u9ED8\u8BA4'
	            ) : '默认'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      checkedKeys: [],
	      selectedItems: [],
	      defaultOrgUuid: ''
	    };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(this.props.accountUuid);
	      this.setState({ defaultOrgUuid: this.props.defaultOrgUuid });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.props.accountUuid !== nextProps.accountUuid && this.loadData(nextProps.accountUuid);
	      this.props.defaultOrgUuid !== nextProps.defaultOrgUuid && this.setState({ defaultOrgUuid: nextProps.defaultOrgUuid });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var accountUuid = this.props.accountUuid;
	      var _state = this.state,
	          checkedKeys = _state.checkedKeys,
	          selectedItems = _state.selectedItems,
	          defaultOrgUuid = _state.defaultOrgUuid;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u673A\u6784\u90E8\u95E8\u8BBE\u7F6E',
	          visible: this.props.visible,
	          onOk: this.submit,
	          onCancel: this.onCancel,
	          width: '750px'
	        },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(_SelectOrg2.default, {
	              accountUuid: accountUuid,
	              checkedKeys: checkedKeys,
	              selectedItems: selectedItems,
	              setStateCheckedKeys: this.setStateCheckedKeys,
	              setStateSelectedItems: this.setStateSelectedItems
	            })
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(_antd.Table, {
	              rowKey: function rowKey(record) {
	                return record.uuid;
	              },
	              columns: this.columns(defaultOrgUuid),
	              dataSource: selectedItems,
	              pagination: false
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(IndexModal));

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _role = __webpack_require__(323);
	
	var _user = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.loadData = function () {
	      (0, _role.queryAllRoleList)({ status: 1 }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ list: res.data });
	        }
	      });
	    };
	
	    _this.loadUserRole = function (accountUuid) {
	      (0, _user.queryAccountRoleRoles)({ accountUuid: accountUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ targetKeys: res.data.map(function (item) {
	              return item.uuid;
	            }) });
	        }
	      });
	    };
	
	    _this.submit = function () {
	      var targetKeys = _this.state.targetKeys;
	
	      _this.props.onOk(targetKeys);
	      _this.loadUserRole(_this.props.accountUuid);
	    };
	
	    _this.onCancel = function () {
	      _this.props.form.resetFields();
	      _this.props.onCancel();
	    };
	
	    _this.onChange = function (value) {
	      _this.setState({ targetKeys: value });
	    };
	
	    _this.state = { list: [], targetKeys: [] };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	      this.loadUserRole(this.props.accountUuid);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.props.accountUuid && nextProps.accountUuid && this.loadUserRole(nextProps.accountUuid);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          list = _state.list,
	          total = _state.total,
	          pageNo = _state.pageNo,
	          targetKeys = _state.targetKeys;
	
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u89D2\u8272\u6388\u6743',
	          visible: this.props.visible,
	          onOk: this.submit,
	          onCancel: this.onCancel
	        },
	        _react2.default.createElement(_antd.Transfer, {
	          rowKey: function rowKey(record) {
	            return record.uuid;
	          },
	          dataSource: list,
	          titles: ['Source', 'Target'],
	          targetKeys: targetKeys,
	          onChange: this.onChange,
	          render: function render(item) {
	            return item.name;
	          },
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(IndexModal));

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.Tree.TreeNode;
	
	var SelectOrg = function (_Component) {
	  _inherits(SelectOrg, _Component);
	
	  function SelectOrg(props) {
	    _classCallCheck(this, SelectOrg);
	
	    var _this = _possibleConstructorReturn(this, (SelectOrg.__proto__ || Object.getPrototypeOf(SelectOrg)).call(this, props));
	
	    _this.loadData = function () {
	      return (0, _org.queryOrgTree)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ list: res.data });
	        }
	      });
	    };
	
	    _this.onCheck = function (value, e) {
	      var _this$props = _this.props,
	          setStateCheckedKeys = _this$props.setStateCheckedKeys,
	          setStateSelectedItems = _this$props.setStateSelectedItems;
	      var selectedItems = _this.props.selectedItems;
	
	      if (e.checked) {
	        selectedItems.push({
	          uuid: e.node.props.dataRef.uuid || '',
	          name: e.node.props.dataRef.name || ''
	        });
	      } else {
	        selectedItems = selectedItems.filter(function (item) {
	          return item.uuid !== e.node.props.dataRef.uuid;
	        });
	      }
	      _this.setState({ checkedKeys: value });
	      setStateCheckedKeys(value.checked);
	      setStateSelectedItems(selectedItems);
	    };
	
	    _this.renderTreeNodes = function (data) {
	      return data.map(function (item) {
	        if (item.children) {
	          return _react2.default.createElement(
	            TreeNode,
	            { title: _this.titleItem(item), key: item.uuid, value: item.uuid, dataRef: item },
	            _this.renderTreeNodes(item.children)
	          );
	        }
	        return _react2.default.createElement(TreeNode, Object.assign({
	          title: _this.titleItem(item),
	          key: item.uuid,
	          value: item.uuid,
	          dataRef: item
	        }, item));
	      });
	    };
	
	    _this.titleItem = function (item) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'treeTitle' },
	        _react2.default.createElement(
	          'span',
	          { style: { width: '200px' } },
	          item.name
	        )
	      );
	    };
	
	    _this.state = {
	      list: [],
	      checkedKeys: []
	    };
	    return _this;
	  }
	
	  _createClass(SelectOrg, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	      this.setState({ checkedKeys: this.props.checkedKeys });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.props.checkedKeys !== nextProps.checked && this.setState({ checkedKeys: nextProps.checkedKeys });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          list = _state.list,
	          checkedKeys = _state.checkedKeys;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Tree,
	          { checkable: true, onCheck: this.onCheck, checkedKeys: checkedKeys, checkStrictly: true },
	          this.renderTreeNodes(list || [])
	        )
	      );
	    }
	  }]);
	
	  return SelectOrg;
	}(_react.Component);
	
	exports.default = SelectOrg;

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1480);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _PageAdd = __webpack_require__(673);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	var _PageEdit = __webpack_require__(1481);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = {
	  path: 'workflow',
	  breadcrumbName: '工作流',
	  childRoutes: [{
	    path: 'template',
	    breadcrumbName: '工作流模板设置',
	    indexRoute: { component: _Index2.default },
	    childRoutes: [{
	      path: 'add',
	      breadcrumbName: '工作流模板添加',
	      component: _PageAdd2.default
	    }, {
	      path: 'edit/:uuid',
	      breadcrumbName: '工作流模板修改',
	      component: _PageEdit2.default
	    }]
	  }]
	}; /**
	    * routers
	    * 更多关于Router的使用，请参考以下教程
	    * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
	    */
	
	// 资金管理
	exports.default = router;

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Activity = function (_Component) {
	  _inherits(Activity, _Component);
	
	  function Activity(props) {
	    _classCallCheck(this, Activity);
	
	    var _this = _possibleConstructorReturn(this, (Activity.__proto__ || Object.getPrototypeOf(Activity)).call(this, props));
	
	    _this.state = {
	      activity: {}
	    };
	    return _this;
	  }
	
	  _createClass(Activity, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var activity = this.props.activity;
	
	      this.setState({
	        activity: activity
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ activity: nextProps.activity });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var activity = this.state.activity;
	      var showDrawer = this.props.showDrawer;
	
	      return _react2.default.createElement(
	        'span',
	        {
	          id: 'activity' + (activity.index ? activity.index : '0'),
	          onClick: function onClick() {
	            return showDrawer(activity);
	          },
	          style: { marginRight: 5 }
	        },
	        _react2.default.createElement(_antd.Icon, { type: 'user' }),
	        _react2.default.createElement(
	          'span',
	          null,
	          activity.name ? activity.name : ''
	        ),
	        _react2.default.createElement(_antd.Icon, { type: 'arrow-right' })
	      );
	    }
	  }]);
	
	  return Activity;
	}(_react.Component);
	
	exports.default = Activity;

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _SearchUser = __webpack_require__(273);
	
	var _SearchUser2 = _interopRequireDefault(_SearchUser);
	
	var _core_account_search = __webpack_require__(232);
	
	__webpack_require__(2949);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RadioGroup = _antd.Radio.Group;
	
	var ActivityAdd = function (_Component) {
	  _inherits(ActivityAdd, _Component);
	
	  function ActivityAdd(props) {
	    _classCallCheck(this, ActivityAdd);
	
	    var _this = _possibleConstructorReturn(this, (ActivityAdd.__proto__ || Object.getPrototypeOf(ActivityAdd)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          addActivity = _this$props.addActivity,
	          activity = _this$props.activity;
	
	      var permis = _this.props.form.getFieldsValue();
	      var str = '';
	      if (permis.type === 0) {
	        if (permis.type === 1 || permis.type === 2) {
	          permis.processor.map(function (item) {
	            str = str + item + ',';
	            return 1;
	          });
	          str = str.substring(0, str.length - 1);
	          permis.processor = str;
	        } else {
	          Array.isArray(permis.processor) && (permis.processor = permis.processor[0]);
	        }
	      }
	
	      if (activity && activity.uuid) {
	        permis.uuid = activity.uuid;
	      }
	      permis.index = activity.index;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          addActivity(permis);
	          // this.props.form.resetFields();
	        }
	      });
	    };
	
	    _this.onChange = function (e) {
	      var _e$target = e.target,
	          name = _e$target.name,
	          value = _e$target.value;
	
	      var params = {};
	      params[name] = value;
	      _this.setState(Object.assign({}, params));
	    };
	
	    _this.changeType = function (e) {
	      if (e.target.value === 1 || e.target.value === 2) {
	        _this.setState({
	          isMultiple: 'multiple'
	        });
	      } else {
	        _this.setState({
	          isMultiple: ''
	        });
	      }
	
	      return e.target.value;
	    };
	
	    _this.onChangeProcessor = function () {};
	
	    _this.state = {
	      processorType: 0,
	      timeOutFlag: 0,
	      isMultiple: ''
	    };
	    return _this;
	  }
	
	  _createClass(ActivityAdd, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        processorType: this.props.activity.processorType,
	        timeOutFlag: this.props.activity.timeOutFlag
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var isMultiple = '';
	      var activity = this.props.activity;
	
	      this.props.dispatch((0, _core_account_search.getAccountSearch)());
	      if (activity.type === 1 || activity.type === 2) {
	        isMultiple = 'multiple';
	      }
	      this.setState({
	        processorType: activity.processorType,
	        timeOutFlag: activity.timeOutFlag,
	        isMultiple: isMultiple
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var isMultiple = '';
	      if (nextProps.activity.processorType === this.props.activity.processorType) {
	        return;
	      }
	      if (nextProps.activity.type === 1 || nextProps.activity.type === 2) {
	        isMultiple = 'multiple';
	      }
	      this.setState({
	        processorType: nextProps.activity.processorType,
	        timeOutFlag: nextProps.activity.timeOutFlag,
	        isMultiple: isMultiple
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          deleteActivity = _props.deleteActivity,
	          closeDrawer = _props.closeDrawer,
	          visible = _props.visible,
	          activity = _props.activity;
	      var processor = activity.processor;
	      var _state = this.state,
	          processorType = _state.processorType,
	          timeOutFlag = _state.timeOutFlag,
	          isMultiple = _state.isMultiple;
	
	      var ItemLayout = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 20 }
	      };
	      !Array.isArray(processor) && processor && (processor = processor.split(','));
	      var element = isMultiple === '' ? _react2.default.createElement(_SearchUser2.default, {
	        isMultiple: this.state.isMultiple,
	        onChange: function onChange() {
	          _this2.onChangeProcessor();
	        }
	      }) : _react2.default.createElement(_SearchUser2.default, {
	        isMultiple: this.state.isMultiple,
	        onChange: function onChange() {
	          _this2.onChangeProcessor();
	        }
	      });
	      return _react2.default.createElement(
	        _antd.Drawer,
	        {
	          title: '\u6D3B\u52A8\u8BE6\u60C5',
	          placement: 'right',
	          width: 720,
	          onClose: closeDrawer,
	          visible: visible,
	          className: 'template-drawer'
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.submit },
	          _react2.default.createElement(
	            _antd.Card,
	            null,
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u6D3B\u52A8\u540D\u79F0' }, ItemLayout),
	                  getFieldDecorator('name', {
	                    rules: [{ required: true, message: '请输入活动名称 !' }],
	                    initialValue: activity.name ? activity.name : ''
	                  })(_react2.default.createElement(_antd.Input, { placeholder: '\u6D3B\u52A8\u540D\u79F0' }))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u6D3B\u52A8\u6761\u4EF6' }, ItemLayout),
	                  getFieldDecorator('condition', {
	                    initialValue: activity.condition ? activity.condition : ''
	                  })(_react2.default.createElement(_antd.Input, { placeholder: '\u6D3B\u52A8\u6761\u4EF6' }))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u6D3B\u52A8\u7C7B\u578B' }, ItemLayout),
	                  getFieldDecorator('type', {
	                    rules: [{ required: true, message: '请输入活动类型 !' }],
	                    initialValue: activity.type ? activity.type : 0,
	                    getValueFromEvent: this.changeType
	                  })(_react2.default.createElement(
	                    RadioGroup,
	                    { name: 'type' },
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 0 },
	                      '\u4F9D\u6B21\u5BA1\u6279 (\u672C\u73AF\u8282\u5185\u5BA1\u6279\u4EBA\u4F9D\u6B21\u5BA1\u6279)'
	                    ),
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 1 },
	                      '\u4F1A\u7B7E (\u987B\u6240\u6709\u5BA1\u6279\u4EBA\u540C\u610F)'
	                    ),
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 2 },
	                      '\u6216\u7B7E (\u4E00\u540D\u5BA1\u6279\u4EBA\u540C\u610F\u6216\u62D2\u7EDD\u5373\u53EF)'
	                    )
	                  ))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u64CD\u4F5C\u4EBA\u7C7B\u578B' }, ItemLayout),
	                  getFieldDecorator('processorType', {
	                    rules: [{ required: true, message: '请选择操作人类型 !' }],
	                    initialValue: activity.processorType ? activity.processorType : 0
	                  })(_react2.default.createElement(
	                    RadioGroup,
	                    { name: 'processorType', onChange: this.onChange },
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 0 },
	                      '\u6307\u5B9A\u6210\u5458'
	                    ),
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 1 },
	                      '\u53D8\u91CF\u83B7\u53D6'
	                    )
	                  ))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u64CD\u4F5C\u4EBA' }, ItemLayout),
	                  getFieldDecorator('processor', {
	                    rules: [{ required: true, message: '请选择操作人 !' }],
	                    initialValue: processor || ''
	                  })(processorType ? _react2.default.createElement(_antd.Input, null) : element)
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u662F\u5426\u8BBE\u8D85\u65F6\u6807\u8BC6' }, ItemLayout),
	                  getFieldDecorator('timeOutFlag', {
	                    rules: [{
	                      required: true,
	                      message: '请选择是否设置超时操作标识 !'
	                    }],
	                    initialValue: activity.timeOutFlag ? activity.timeOutFlag : 0
	                  })(_react2.default.createElement(
	                    RadioGroup,
	                    { name: 'timeOutFlag', onChange: this.onChange },
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 1 },
	                      '\u662F'
	                    ),
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 0 },
	                      '\u5426'
	                    )
	                  ))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                timeOutFlag ? _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u8D85\u65F6\u65F6\u95F4' }, ItemLayout),
	                  getFieldDecorator('timeOut', {
	                    rules: [{ required: true, message: '请设置超时时间 !' }],
	                    initialValue: activity.timeOut ? activity.timeOut : 0
	                  })(_react2.default.createElement(_antd.InputNumber, null))
	                ) : null
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u8D85\u65F6\u64CD\u4F5C' }, ItemLayout),
	                  getFieldDecorator('timeOutHandler', {
	                    rules: [{
	                      required: true,
	                      message: '请选择是否设置超时操作标识 !'
	                    }],
	                    initialValue: activity.timeOutHandler ? activity.timeOutHandler : 0
	                  })(_react2.default.createElement(
	                    RadioGroup,
	                    { name: 'timeOutHandler', onChange: this.onChange },
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 0 },
	                      '\u4E0D\u64CD\u4F5C'
	                    ),
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 1 },
	                      '\u8D85\u65F6\u81EA\u52A8\u63D0\u4EA4'
	                    ),
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 2 },
	                      '\u8D85\u65F6\u81EA\u52A8\u6253\u56DE'
	                    )
	                  ))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u662F\u5426\u7981\u6B62\u6253\u56DE' }, ItemLayout),
	                  getFieldDecorator('isBanReturn', {
	                    rules: [{ required: true, message: '请选择是否是否禁止打回 !' }],
	                    initialValue: activity.timeOutFlag ? activity.timeOutFlag : 0
	                  })(_react2.default.createElement(
	                    RadioGroup,
	                    { name: 'timeOutFlag', onChange: this.onChange },
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 1 },
	                      '\u662F'
	                    ),
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 0 },
	                      '\u5426'
	                    )
	                  ))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u662F\u5426\u901A\u77E5' }, ItemLayout),
	                  getFieldDecorator('notification', {
	                    rules: [{ required: true, message: '请选择是否通知 !' }],
	                    initialValue: activity.notification ? activity.notification : 0
	                  })(_react2.default.createElement(
	                    RadioGroup,
	                    { name: 'notification', onChange: this.onChange },
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 1 },
	                      '\u662F'
	                    ),
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 0 },
	                      '\u5426'
	                    )
	                  ))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u662F\u5426\u53BB\u91CD\u590D' }, ItemLayout),
	                  getFieldDecorator('deduplication', {
	                    rules: [{ required: true, message: '请选择是否去重复 !' }],
	                    initialValue: activity.deduplication ? activity.deduplication : 0
	                  })(_react2.default.createElement(
	                    RadioGroup,
	                    { name: 'deduplication' },
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 1 },
	                      '\u662F'
	                    ),
	                    _react2.default.createElement(
	                      _antd.Radio,
	                      { value: 0 },
	                      '\u5426'
	                    )
	                  ))
	                )
	              )
	            ),
	            _react2.default.createElement(_antd.Row, null),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(
	                  _antd.Button,
	                  { htmlType: 'submit', icon: 'save', style: { marginRight: 10 } },
	                  '\u4FDD\u5B58'
	                ),
	                _react2.default.createElement(
	                  _antd.Button,
	                  {
	                    icon: 'delete',
	                    style: { marginRight: 10 },
	                    onClick: function onClick() {
	                      return deleteActivity(activity);
	                    }
	                  },
	                  '\u5220\u9664\u8282\u70B9'
	                ),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { icon: 'cancel', style: { marginRight: 10 }, onClick: closeDrawer },
	                  '\u53D6\u6D88'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ActivityAdd;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create({ wrappedComponentRef: true })(ActivityAdd));

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _SearchUser = __webpack_require__(273);
	
	var _SearchUser2 = _interopRequireDefault(_SearchUser);
	
	var _core_account_search = __webpack_require__(232);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BackBtn = __webpack_require__(12);
	
	var _Activity = __webpack_require__(1477);
	
	var _Activity2 = _interopRequireDefault(_Activity);
	
	var _ActivityAdd = __webpack_require__(1478);
	
	var _ActivityAdd2 = _interopRequireDefault(_ActivityAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var TabPane = _antd.Tabs.TabPane;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handSubmit = _this$props.handSubmit,
	          data = _this$props.data;
	
	      var permis = _this.props.form.getFieldsValue();
	      if (data && data.uuid) {
	        permis.uuid = data.uuid;
	      }
	      permis.activities = data.activities;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          // TODO 需要处理数据
	          handSubmit(permis);
	        }
	      });
	    };
	
	    _this.callback = function () {};
	
	    _this.showDrawer = function (activity) {
	      // TODO 显示活动内容
	      _this.setState({
	        visible: true,
	        currentActivity: activity
	      });
	    };
	
	    _this.closeDrawer = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.deleteActivity = function (activity) {
	      var data = _this.props.data;
	
	      var activities = data.activities ? data.activities : [];
	      data.activities = activities.filter(function (form) {
	        return form.index !== activity.index;
	      });
	      _this.setState({}, _this.closeDrawer());
	    };
	
	    _this.addActivity = function (activity) {
	      // TODO 辨别是否已将存在
	      if (activity !== undefined) {
	        var data = _this.props.data;
	
	        var activities = data.activities ? data.activities : [];
	        var flag = false;
	        var index = 0;
	        activities = activities.map(function (form) {
	          if (form.index === activity.index) {
	            flag = true;
	            return activity;
	          }
	          return form;
	        });
	        if (!flag) {
	          activity.index = index + 1;
	          activities.push(activity);
	        }
	        data.activities = activities;
	        _this.setState({}, _this.closeDrawer());
	      }
	    };
	
	    _this.onChangeProcessor = function () {};
	
	    _this.state = {
	      visible: false,
	      currentActivity: {}
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch((0, _core_account_search.getAccountSearch)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var dataItem = this.props.data;
	      var activities = dataItem.activities ? dataItem.activities : [];
	      var listActities = activities.map(function (activity) {
	        return _react2.default.createElement(_Activity2.default, {
	          activity: activity,
	          key: activity.uuid,
	          showDrawer: function showDrawer(current) {
	            _this2.showDrawer(current);
	          }
	        });
	      });
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15 } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            { icon: 'save', style: { marginRight: 10 }, htmlType: 'submit' },
	            '\u4FDD\u5B58'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Tabs,
	          { defaultActiveKey: '1', onChange: this.callback },
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u57FA\u7840\u8BBE\u7F6E', key: '1' },
	            _react2.default.createElement(
	              _antd.Card,
	              null,
	              _react2.default.createElement(
	                _antd.Row,
	                null,
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 20 },
	                  _react2.default.createElement(
	                    FormItem,
	                    Object.assign({ label: '\u5DE5\u4F5C\u6D41\u6A21\u677F\u540D\u79F0' }, ItemLayout),
	                    getFieldDecorator('name', {
	                      rules: [{ required: true, message: '请输入名称 !' }],
	                      initialValue: dataItem.name ? dataItem.name : ''
	                    })(_react2.default.createElement(_antd.Input, { placeholder: '\u5DE5\u4F5C\u6D41\u6A21\u677F\u540D\u79F0' }))
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Row,
	                null,
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 20 },
	                  _react2.default.createElement(
	                    FormItem,
	                    Object.assign({ label: '\u5DE5\u4F5C\u6D41\u6A21\u677F\u6807\u8BC6' }, ItemLayout),
	                    getFieldDecorator('sign', {
	                      rules: [{ required: true, message: '请输入标识 !' }],
	                      initialValue: dataItem.sign ? dataItem.sign : ''
	                    })(_react2.default.createElement(_antd.Input, { placeholder: '\u5DE5\u4F5C\u6D41\u6A21\u677F\u6807\u8BC6' }))
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u6D41\u7A0B\u8BBE\u8BA1', key: '2' },
	            _react2.default.createElement(
	              _antd.Card,
	              { title: '\u9ED8\u8BA4\u5BA1\u6279\u6D41\u7A0B' },
	              _react2.default.createElement(
	                _antd.Row,
	                null,
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 20 },
	                  _react2.default.createElement(
	                    FormItem,
	                    Object.assign({ label: '\u9ED8\u8BA4\u5BA1\u6279\u4EBA' }, ItemLayout),
	                    listActities,
	                    _react2.default.createElement(_antd.Button, {
	                      type: 'primary',
	                      shape: 'circle',
	                      icon: 'plus',
	                      onClick: function onClick() {
	                        return _this2.showDrawer({});
	                      }
	                    })
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Row,
	                null,
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 20 },
	                  _react2.default.createElement(
	                    FormItem,
	                    Object.assign({ label: '\u9ED8\u8BA4\u6284\u9001\u4EBA' }, ItemLayout),
	                    getFieldDecorator('cc', {
	                      initialValue: dataItem.cc ? dataItem.cc : ''
	                    })(_react2.default.createElement(_SearchUser2.default, null))
	                  )
	                )
	              )
	            ),
	            this.state.visible ? _react2.default.createElement(_ActivityAdd2.default, {
	              ref: function ref(form) {
	                _this2.form = form;
	              },
	              activity: this.state.currentActivity,
	              closeDrawer: function closeDrawer() {
	                return _this2.closeDrawer();
	              },
	              deleteActivity: function deleteActivity(activity) {
	                return _this2.deleteActivity(activity);
	              },
	              addActivity: function addActivity(activity) {
	                return _this2.addActivity(activity);
	              },
	              getFieldDecorator: getFieldDecorator,
	              visible: this.state.visible
	            }) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create({ wrappedComponentRef: true })(BaseForm));

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _workflow = __webpack_require__(272);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getWorkflowTemplateListList = function () {
	      var params = {};
	      params.limit = _this.pageSize;
	      params.start = _this.current;
	      (0, _workflow.queryWorkflowTemplateList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            pagination: {
	              total: res.totalSize,
	              showSizeChanger: true,
	              current: _this.current,
	              pageSize: _this.pageSize
	            }
	          });
	        }
	      });
	    };
	
	    _this.deleteWorkflowTemplate = function (uuid) {
	      (0, _workflow.queryDeleteWorkflowTemplate)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('删除成功');
	          _this.getWorkflowTemplateListList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleChange = function (pagination) {
	      _this.current = pagination.current;
	      _this.pageSize = pagination.pageSize;
	      _this.getWorkflowTemplateListList();
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '模板名字',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/workflow/template/edit/' + record.uuid },
	            record.name
	          );
	        }
	      }, {
	        title: '标签',
	        dataIndex: 'sign',
	        key: 'sign',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                onConfirm: function onConfirm() {
	                  return _this.deleteWorkflowTemplate(record.uuid);
	                },
	                title: '\u786E\u5B9A\u5220\u9664\u5F53\u524D\u7EC4\u7EC7\u5417\uFF1F',
	                placement: 'topRight',
	                overlayStyle: { width: 200 }
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'ant-dropdown-link' },
	                '\u5220\u9664'
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      pagination: {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.current = 1;
	      this.pageSize = 10;
	      this.getWorkflowTemplateListList();
	    }
	
	    // 列表改变
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          data = _state.data,
	          pagination = _state.pagination;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/workflow/template/add' },
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', icon: 'plus', style: { marginBottom: 15 } },
	            '\u6DFB\u52A0'
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          dataSource: data,
	          rowSelection: {},
	          pagination: pagination,
	          columns: this.columns(),
	          style: { background: '#fff' },
	          onChange: this.handleChange
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _workflow = __webpack_require__(272);
	
	var _PageAdd2 = __webpack_require__(673);
	
	var _PageAdd3 = _interopRequireDefault(_PageAdd2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Edit = function (_PageAdd) {
	  _inherits(Edit, _PageAdd);
	
	  function Edit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Edit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Edit.__proto__ || Object.getPrototypeOf(Edit)).call.apply(_ref, [this].concat(args))), _this), _this.loadData = function (uuid) {
	      var context = _this;
	      (0, _workflow.queryWorkflowTemplateInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({ data: res.data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Edit, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var uuid = this.props.routeParams.uuid;
	
	      this.loadData(uuid);
	    }
	  }]);
	
	  return Edit;
	}(_PageAdd3.default);
	
	exports.default = Edit;

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _TabHistory = __webpack_require__(1488);
	
	var _TabHistory2 = _interopRequireDefault(_TabHistory);
	
	var _TabContract = __webpack_require__(1486);
	
	var _TabContract2 = _interopRequireDefault(_TabContract);
	
	var _TabFile = __webpack_require__(1487);
	
	var _TabFile2 = _interopRequireDefault(_TabFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var ClientDetail = function (_Component) {
	  _inherits(ClientDetail, _Component);
	
	  function ClientDetail(props) {
	    _classCallCheck(this, ClientDetail);
	
	    var _this = _possibleConstructorReturn(this, (ClientDetail.__proto__ || Object.getPrototypeOf(ClientDetail)).call(this, props));
	
	    _this.callback = function () {};
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ClientDetail, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _antd.Tabs,
	        { defaultActiveKey: '1', onChange: this.callback },
	        _react2.default.createElement(
	          TabPane,
	          { tab: '\u52A8\u6001', key: '1' },
	          _react2.default.createElement(_TabHistory2.default, null)
	        ),
	        _react2.default.createElement(
	          TabPane,
	          { tab: '\u5408\u540C', key: '2' },
	          _react2.default.createElement(_TabContract2.default, null)
	        ),
	        _react2.default.createElement(
	          TabPane,
	          { tab: '\u8D44\u6599', key: '3' },
	          _react2.default.createElement(_TabFile2.default, null)
	        )
	      );
	    }
	  }]);
	
	  return ClientDetail;
	}(_react.Component);
	
	exports.default = ClientDetail;

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _BackBtn = __webpack_require__(12);
	
	var _crm = __webpack_require__(33);
	
	var _cascaderAddressOptions = __webpack_require__(429);
	
	var _cascaderAddressOptions2 = _interopRequireDefault(_cascaderAddressOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	var TextArea = _antd.Input.TextArea;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.loadCategory = function (selectedOptions) {
	      var targetOption = selectedOptions[selectedOptions.length - 1];
	      targetOption.loading = true;
	
	      (0, _crm.queryCustomCategory)(targetOption.value).then(function (req) {
	        if (req.statusCode === 200) {
	          targetOption.loading = false;
	          targetOption.children = req.data;
	        }
	      });
	    };
	
	    _this.chaneCategory = function (value) {
	      if (value.length > 0) {
	        _this.props.form.setFieldsValue({
	          category1: value[0],
	          category2: value[1]
	        });
	      }
	    };
	
	    _this.chaneRegion = function (value) {
	      if (value.length > 0) {
	        _this.props.form.setFieldsValue({ province: value[0], city: value[1] });
	      }
	    };
	
	    _this.changeOrderUser = function (value, selectedOptions) {
	      _this.props.form.setFieldsValue({
	        orderName: selectedOptions.props.children
	      });
	    };
	
	    _this.changeRecommendUser = function (value, selectedOptions) {
	      _this.props.form.setFieldsValue({
	        recommendName: selectedOptions.props.children
	      });
	    };
	
	    _this.changeManagerUser = function (value, selectedOptions) {
	      _this.props.form.setFieldsValue({
	        managerName: selectedOptions.props.children
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handleSubmit = _this$props.handleSubmit,
	          data = _this$props.data;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          if (data && data.uuid) {
	            values.uuid = data.uuid;
	          }
	
	          values.establishedDate = values.establishedDate ? values.establishedDate.format('YYYY-MM-DD') : undefined;
	          handleSubmit(values);
	        }
	      });
	    };
	
	    _this.changeType = function () {
	      // TODO 当是个人时隐去一些信息
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _crm.queryCustomCategory)().then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.map(function (item) {
	            item.isLeaf = false;
	            return item;
	          });
	          _this2.setState({});
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var key = nextProps.data.category1;
	      if (!key) {
	        return false;
	      }
	      (0, _crm.queryCustomCategory)().then(function (res) {
	        if (res.statusCode === 200) {
	          var data = res.data.map(function (item) {
	            item.isLeaf = false;
	            return item;
	          });
	          if (!key) {
	            _this3.setState({});
	            return;
	          }
	          (0, _crm.queryCustomCategory)(key).then(function (result) {
	            if (result.statusCode === 200) {
	              data.map(function (item) {
	                if (item.key === key) {
	                  item.children = result.data;
	                }
	                return item;
	              });
	              _this3.setState({});
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var data = this.props.data;
	
	      getFieldDecorator('province', { initialValue: data ? data.province : '' });
	      getFieldDecorator('city', { initialValue: data ? data.city : '' });
	      getFieldDecorator('category1', {
	        initialValue: data ? data.category1 : ''
	      });
	      getFieldDecorator('category2', {
	        initialValue: data ? data.category2 : ''
	      });
	      getFieldDecorator('orderName', {
	        initialValue: data ? data.orderName : ''
	      });
	      getFieldDecorator('recommendName', {
	        initialValue: data ? data.recommendName : ''
	      });
	      getFieldDecorator('managerName', {
	        initialValue: data ? data.managerName : ''
	      });
	      var ItemLayout2 = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	
	      var ItemLayout = {
	        labelCol: { span: 5 },
	        wrapperCol: { span: 19 }
	      };
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15, marginTop: '-45px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u57FA\u672C\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u516C\u53F8\u540D\u79F0' }, ItemLayout2),
	                getFieldDecorator('name', {
	                  rules: [{ required: true, message: '请输入公司名称!' }],
	                  initialValue: data ? data.name : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u516C\u53F8\u540D\u79F0' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5BA2\u6237\u7C7B\u578B' }, ItemLayout2),
	                getFieldDecorator('type', {
	                  initialValue: data ? data.type : '1'
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { onChange: this.changeType },
	                  _react2.default.createElement(
	                    Option,
	                    { key: '1', value: '1' },
	                    '\u516C\u53F8'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { key: '0', value: '0' },
	                    '\u4E2A\u4EBA'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 16 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5907\u6CE8' }, ItemLayout),
	                getFieldDecorator('type', {
	                  initialValue: data ? data.type : '1'
	                })(_react2.default.createElement(TextArea, { rows: 4 }))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u8054\u7CFB\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6240\u5728\u5730\u533A' }, ItemLayout2),
	                getFieldDecorator('region', {
	                  initialValue: data ? data.region : []
	                })(_react2.default.createElement(_antd.Cascader, {
	                  options: _cascaderAddressOptions2.default,
	                  onChange: this.chaneRegion,
	                  changeOnSelect: true,
	                  placeholder: '\u8BF7\u9009\u62E9\u5730\u5740'
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 16 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8BE6\u7EC6\u5730\u5740' }, ItemLayout),
	                getFieldDecorator('addr', {
	                  initialValue: data ? data.addr : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 1 },
	              '1'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8054\u7CFB\u4EBA' }, ItemLayout2),
	                getFieldDecorator('contactName', {
	                  rules: [{ required: true, message: '请输入联系人!' }],
	                  initialValue: data ? data.contactName : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8054\u7CFB\u7535\u8BDD' }, ItemLayout2),
	                getFieldDecorator('contactTel', {
	                  rules: [{ required: true, message: '请输入联系电话!' }],
	                  initialValue: data ? data.contactTel : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 18, style: { marginBottom: 15, textAlign: 'right' } },
	            _react2.default.createElement(
	              _antd.Button,
	              { style: { marginRight: 10 }, type: 'primary', htmlType: 'submit' },
	              '\u786E\u5B9A'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { style: { marginRight: 10 }, onClick: _BackBtn.goBack },
	              '\u53D6\u6D88'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _crm = __webpack_require__(33);
	
	var _ClientDetail = __webpack_require__(1482);
	
	var _ClientDetail2 = _interopRequireDefault(_ClientDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo, condition) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      _this.setState({
	        pageNo: pageNo
	      });
	      (0, _crm.queryCustomList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function () {};
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.loadData(1, values.condition);
	        }
	      });
	    };
	
	    _this.handleFormReset = function (e) {
	      e.preventDefault();
	      _this.props.form.resetFields();
	      _this.loadData(1);
	    };
	
	    _this.handleModalVisible = function (visible) {
	      _this.setState({ visible: visible });
	    };
	
	    _this.showModal = function () {
	      _this.setState({
	        visible: true
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', onSubmit: _this.handleSubmit },
	        _react2.default.createElement(
	          _antd.Row,
	          { gutter: { md: 8, lg: 24, xl: 48 } },
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u90E8\u95E8' },
	              getFieldDecorator('condition')(_react2.default.createElement(
	                _antd.Select,
	                null,
	                _react2.default.createElement(
	                  Option,
	                  { key: '1' },
	                  '\u90E8\u95E8\u4E00'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { key: '2' },
	                  '\u90E8\u95E8\u4E8C'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u641C\u7D22\u6761\u4EF6' },
	              getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              'span',
	              { className: 'submitButtons' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit' },
	                '\u67E5\u8BE2'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: 8 }, onClick: _this.handleFormReset },
	                '\u91CD\u7F6E'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.onClose = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.showDrawer = function () {
	      _this.setState({
	        visible: true
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '编号',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '客户名称',
	        dataIndex: 'name',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: _this.showDrawer },
	            text
	          );
	        }
	      }, {
	        title: '所属人',
	        dataIndex: 'belonger'
	      }, {
	        title: '所属行业',
	        dataIndex: 'category'
	      }, {
	        title: '所属地区',
	        dataIndex: 'origin'
	      }, {
	        title: '更新时间',
	        dataIndex: 'updateTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [{ uuid: '1', name: '唉唉唉' }, { uuid: '2' }],
	      total: 0,
	      pageNo: 1,
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListForm' },
	            this.renderSearchForm()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/custom/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u5BFC\u51FA'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/client/manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                null,
	                '\u65B0\u5EFA\u5BA2\u6237'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          size: 'small',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        }),
	        this.state.visible ? _react2.default.createElement(
	          _antd.Drawer,
	          { title: 'Basic Drawer', placement: 'right', onClose: this.onClose, visible: true, width: 700 },
	          _react2.default.createElement(_ClientDetail2.default, null)
	        ) : null
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _crm = __webpack_require__(33);
	
	var _FormClient = __webpack_require__(1483);
	
	var _FormClient2 = _interopRequireDefault(_FormClient);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.handleAdd = function (params) {
	      (0, _crm.querySaveCustom)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = { data: {} };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ data: nextProps.data });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormClient2.default, {
	          ref: function ref(form) {
	            _this2.form = form;
	          },
	          handleSubmit: this.handleAdd,
	          data: data
	        })
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { organization: state.organization };
	})(BaseForm);

/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _crm = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabContract = function (_Component) {
	  _inherits(TabContract, _Component);
	
	  function TabContract(props) {
	    _classCallCheck(this, TabContract);
	
	    var _this = _possibleConstructorReturn(this, (TabContract.__proto__ || Object.getPrototypeOf(TabContract)).call(this, props));
	
	    _this.loadData = function (pageNo, condition) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      _this.setState({
	        pageNo: pageNo
	      });
	      (0, _crm.queryCustomList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '序号',
	        dataIndex: 'no',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '合同编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '签约人员',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '签约日期',
	        dataIndex: 'updateTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [{ uuid: '1', name: '唉唉唉' }, { uuid: '2' }],
	      total: 0,
	      pageNo: 1
	    };
	    return _this;
	  }
	
	  _createClass(TabContract, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          size: 'small',
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return TabContract;
	}(_react.Component);
	
	exports.default = TabContract;

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabContract = function (_Component) {
	  _inherits(TabContract, _Component);
	
	  function TabContract(props) {
	    _classCallCheck(this, TabContract);
	
	    var _this = _possibleConstructorReturn(this, (TabContract.__proto__ || Object.getPrototypeOf(TabContract)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(TabContract, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          { title: "\u57FA\u672C\u4FE1\u606F" },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u516C\u53F8\u540D\u79F0\uFF1A"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u4E07\u798F\u96C6\u56E2"
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u8054\u7CFB\u4EBA\u5458\uFF1A"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u6768\u4E07\u798F"
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u8054\u7CFB\u7535\u8BDD\uFF1A"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "13565555555"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u6240\u5C5E\u884C\u4E1A\uFF1A"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u5236\u9020"
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u6240\u5728\u533A\u57DF\uFF1A"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u676D\u5DDE\u897F\u6E56"
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u8BE6\u7EC6\u5730\u5740\uFF1A"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u897F\u6EAA\u65B0\u5EA76\u5E62"
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: "\u9644\u4EF6" },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u70B9\u51FB\u4E0A\u4F20BP"
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u9009\u62E9\u6587\u4EF6"
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TabContract;
	}(_react.Component);
	
	exports.default = TabContract;

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _crm = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo, condition) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      _this.setState({
	        pageNo: pageNo
	      });
	      (0, _crm.queryCustomList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '更新时间',
	        dataIndex: 'updateTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '内容',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '来源',
	        dataIndex: 'name',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: _this.showDrawer },
	            text
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [{ uuid: '1', name: '唉唉唉' }, { uuid: '2' }],
	      total: 0,
	      pageNo: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _antd.Button,
	              null,
	              '\u6DFB\u52A0\u8BB0\u5F55'
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          size: 'small',
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _TabProtect = __webpack_require__(1490);
	
	var _TabProtect2 = _interopRequireDefault(_TabProtect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RadioButton = _antd.Radio.Button;
	var RadioGroup = _antd.Radio.Group;
	
	var MineIndex = function (_Component) {
	  _inherits(MineIndex, _Component);
	
	  function MineIndex(props) {
	    _classCallCheck(this, MineIndex);
	
	    var _this = _possibleConstructorReturn(this, (MineIndex.__proto__ || Object.getPrototypeOf(MineIndex)).call(this, props));
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', onSubmit: _this.handleSubmit },
	        _react2.default.createElement(
	          _antd.Row,
	          { gutter: { md: 8, lg: 24, xl: 48 } },
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u641C\u7D22\u6761\u4EF6' },
	              getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              'span',
	              { className: 'submitButtons' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit' },
	                '\u67E5\u8BE2'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: 8 }, onClick: _this.handleFormReset },
	                '\u91CD\u7F6E'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(MineIndex, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListForm' },
	            this.renderSearchForm()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 14 },
	                _react2.default.createElement(
	                  RadioGroup,
	                  { defaultValue: 'a' },
	                  _react2.default.createElement(
	                    RadioButton,
	                    { value: 'a' },
	                    '\u4FDD\u62A4\u5BA2\u6237'
	                  ),
	                  _react2.default.createElement(
	                    RadioButton,
	                    { value: 'b' },
	                    '\u7B7E\u7EA6\u5BA2\u6237'
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 10, style: { textAlign: 'right' } },
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/crm/custom/add' },
	                  _react2.default.createElement(
	                    _antd.Button,
	                    null,
	                    '\u63A8\u8350\u7ED9\u6211'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/client/manage/add' },
	                  _react2.default.createElement(
	                    _antd.Button,
	                    null,
	                    '\u6211\u7684\u4F63\u91D1'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/client/manage/add' },
	                  _react2.default.createElement(
	                    _antd.Button,
	                    null,
	                    '\u5BFC\u51FA'
	                  )
	                ),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/client/manage/add' },
	                  _react2.default.createElement(
	                    _antd.Button,
	                    { style: { marginRight: 0 }, type: 'primary' },
	                    '\u65B0\u5EFA\u5BA2\u6237'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_TabProtect2.default, null)
	      );
	    }
	  }]);
	
	  return MineIndex;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(MineIndex);

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _crm = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabContract = function (_Component) {
	  _inherits(TabContract, _Component);
	
	  function TabContract(props) {
	    _classCallCheck(this, TabContract);
	
	    var _this = _possibleConstructorReturn(this, (TabContract.__proto__ || Object.getPrototypeOf(TabContract)).call(this, props));
	
	    _this.loadData = function (pageNo, condition) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      _this.setState({
	        pageNo: pageNo
	      });
	      (0, _crm.queryCustomList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '序号',
	        dataIndex: 'no',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '客户名称',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '保护人',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '所属行业',
	        dataIndex: 'updateTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '所属地区',
	        dataIndex: 'area',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '更新时间',
	        dataIndex: 'create_at',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '到期时间',
	        dataIndex: 'end_time',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [{ uuid: '1', name: '唉唉唉' }, { uuid: '2' }],
	      total: 0,
	      pageNo: 1
	    };
	    return _this;
	  }
	
	  _createClass(TabContract, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px', fontSize: '14px' } },
	          _react2.default.createElement(
	            'span',
	            null,
	            '\u5DF2\u9009\u62E90\u9879'
	          ),
	          _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	          _react2.default.createElement(
	            'a',
	            null,
	            '\u8DDF\u8E2A\u8BB0\u5F55'
	          ),
	          _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	          _react2.default.createElement(
	            'a',
	            null,
	            '\u63A8\u8350\u5BA2\u6237'
	          ),
	          _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	          _react2.default.createElement(
	            'a',
	            null,
	            '\u56DE\u6536\u5BA2\u6237'
	          ),
	          _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	          _react2.default.createElement(
	            'a',
	            null,
	            '\u53D6\u6D88\u4FDD\u62A4'
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          size: 'small',
	          columns: this.columns(),
	          dataSource: data,
	          rowSelection: {},
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return TabContract;
	}(_react.Component);
	
	exports.default = TabContract;

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _crm = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo, condition) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      _this.setState({
	        pageNo: pageNo
	      });
	      (0, _crm.queryCustomList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function () {};
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.loadData(1, values.condition);
	        }
	      });
	    };
	
	    _this.handleFormReset = function (e) {
	      e.preventDefault();
	      _this.props.form.resetFields();
	      _this.loadData(1);
	    };
	
	    _this.handleModalVisible = function () {};
	
	    _this.showModal = function () {};
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', onSubmit: _this.handleSubmit },
	        _react2.default.createElement(
	          _antd.Row,
	          { gutter: { md: 8, lg: 24, xl: 48 } },
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u90E8\u95E8' },
	              getFieldDecorator('condition')(_react2.default.createElement(
	                _antd.Select,
	                null,
	                _react2.default.createElement(
	                  Option,
	                  { key: '1' },
	                  '\u90E8\u95E8\u4E00'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { key: '2' },
	                  '\u90E8\u95E8\u4E8C'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u641C\u7D22\u6761\u4EF6' },
	              getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57\u641C\u7D22' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              'span',
	              { className: 'submitButtons' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit' },
	                '\u67E5\u8BE2'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: 8 }, onClick: _this.handleFormReset },
	                '\u91CD\u7F6E'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.onClose = function () {};
	
	    _this.showDrawer = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '编号',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '客户名称',
	        dataIndex: 'name',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: _this.showDrawer },
	            text
	          );
	        }
	      }, {
	        title: '所属行业',
	        dataIndex: 'category'
	      }, {
	        title: '所属地区',
	        dataIndex: 'origin'
	      }, {
	        title: '更新时间',
	        dataIndex: 'updateTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [{ uuid: '1', name: '唉唉唉' }, { uuid: '2' }],
	      total: 0,
	      pageNo: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListForm' },
	            this.renderSearchForm
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/custom/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u5BFC\u51FA'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/client/manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                null,
	                '\u65B0\u5EFA\u5BA2\u6237'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          size: 'small',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _UploadSinglePic = __webpack_require__(1513);
	
	var _UploadSinglePic2 = _interopRequireDefault(_UploadSinglePic);
	
	var _crm = __webpack_require__(33);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	var TextArea = _antd.Input.TextArea;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.loadCategory = function (selectedOptions) {
	      var targetOption = selectedOptions[selectedOptions.length - 1];
	      targetOption.loading = true;
	
	      (0, _crm.queryCustomCategory)(targetOption.value).then(function (req) {
	        if (req.statusCode === 200) {
	          targetOption.loading = false;
	          targetOption.children = req.data;
	        }
	      });
	    };
	
	    _this.chaneCategory = function (value) {
	      if (value.length > 0) {
	        _this.props.form.setFieldsValue({
	          category1: value[0],
	          category2: value[1]
	        });
	      }
	    };
	
	    _this.chaneRegion = function (value) {
	      if (value.length > 0) {
	        _this.props.form.setFieldsValue({ province: value[0], city: value[1] });
	      }
	    };
	
	    _this.changeOrderUser = function (value, selectedOptions) {
	      _this.props.form.setFieldsValue({
	        orderName: selectedOptions.props.children
	      });
	    };
	
	    _this.changeRecommendUser = function (value, selectedOptions) {
	      _this.props.form.setFieldsValue({
	        recommendName: selectedOptions.props.children
	      });
	    };
	
	    _this.changeManagerUser = function (value, selectedOptions) {
	      _this.props.form.setFieldsValue({
	        managerName: selectedOptions.props.children
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handleSubmit = _this$props.handleSubmit,
	          data = _this$props.data;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          if (data && data.uuid) {
	            values.uuid = data.uuid;
	          }
	
	          values.establishedDate = values.establishedDate ? values.establishedDate.format('YYYY-MM-DD') : undefined;
	          handleSubmit(values);
	        }
	      });
	    };
	
	    _this.changeType = function (value) {
	      // TODO 当是个人时隐去一些信息
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _crm.queryCustomCategory)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({});
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var key = nextProps.data.category1;
	      if (!key) {
	        return false;
	      }
	      (0, _crm.queryCustomCategory)().then(function (res) {
	        if (res.statusCode === 200) {
	          var data = res.data.map(function (item) {
	            item.isLeaf = false;
	            return item;
	          });
	          if (!key) {
	            _this3.setState({});
	            return;
	          }
	          (0, _crm.queryCustomCategory)(key).then(function (result) {
	            if (result.statusCode === 200) {
	              data.map(function (item) {
	                if (item.key === key) {
	                  item.children = result.data;
	                }
	                return item;
	              });
	              _this3.setState({});
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var data = this.props.data;
	
	      getFieldDecorator('province', { initialValue: data ? data.province : '' });
	      getFieldDecorator('city', { initialValue: data ? data.city : '' });
	      getFieldDecorator('category1', {
	        initialValue: data ? data.category1 : ''
	      });
	      getFieldDecorator('category2', {
	        initialValue: data ? data.category2 : ''
	      });
	      getFieldDecorator('orderName', {
	        initialValue: data ? data.orderName : ''
	      });
	      getFieldDecorator('recommendName', {
	        initialValue: data ? data.recommendName : ''
	      });
	      getFieldDecorator('managerName', {
	        initialValue: data ? data.managerName : ''
	      });
	      var ItemLayout2 = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	
	      var ItemLayout = {
	        labelCol: { span: 5 },
	        wrapperCol: { span: 19 }
	      };
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15, marginTop: '-45px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u57FA\u672C\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4EA7\u54C1Logo' }, ItemLayout2),
	                _react2.default.createElement(_UploadSinglePic2.default, null)
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4EA7\u54C1\u540D\u79F0' }, ItemLayout2),
	                getFieldDecorator('name', {
	                  initialValue: data ? data.name : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u516C\u53F8\u540D\u79F0' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4EA7\u54C1\u8D1F\u8D23\u4EBA' }, ItemLayout2),
	                getFieldDecorator('type', {
	                  initialValue: data ? data.type : '1'
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { onChange: this.changeType },
	                  _react2.default.createElement(
	                    Option,
	                    { key: '1', value: '1' },
	                    '\u516C\u53F8'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { key: '0', value: '0' },
	                    '\u4E2A\u4EBA'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 16 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4EA7\u54C1\u4ECB\u7ECD' }, ItemLayout),
	                getFieldDecorator('type', {
	                  initialValue: data ? data.type : '1'
	                })(_react2.default.createElement(TextArea, { rows: 4 }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 16 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                _react2.default.createElement(
	                  _antd.Row,
	                  null,
	                  _react2.default.createElement(_antd.Col, { span: 5 }),
	                  _react2.default.createElement(
	                    _antd.Col,
	                    { span: 19 },
	                    _react2.default.createElement(
	                      _antd.Button,
	                      { style: { marginRight: 10 }, type: 'primary', htmlType: 'submit' },
	                      '\u786E\u5B9A'
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(2950);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProductIndex = function (_Component) {
	  _inherits(ProductIndex, _Component);
	
	  function ProductIndex(props) {
	    _classCallCheck(this, ProductIndex);
	
	    var _this = _possibleConstructorReturn(this, (ProductIndex.__proto__ || Object.getPrototypeOf(ProductIndex)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ProductIndex, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = ['', {
	        title: 'Title 1'
	      }, {
	        title: 'Title 2'
	      }, {
	        title: 'Title 3'
	      }, {
	        title: 'Title 4'
	      }, {
	        title: 'Title 5'
	      }, {
	        title: 'Title 6'
	      }];
	      return _react2.default.createElement(
	        'div',
	        { className: 'productIndex' },
	        _react2.default.createElement(_antd.List, {
	          grid: { gutter: 24, lg: 3, md: 2, sm: 1, xs: 1 },
	          dataSource: data,
	          renderItem: function renderItem(item) {
	            return item ? _react2.default.createElement(
	              _antd.List.Item,
	              null,
	              _react2.default.createElement(
	                _antd.Card,
	                { actions: [] },
	                _react2.default.createElement(_antd.Card.Meta, {
	                  avatar: _react2.default.createElement(_antd.Avatar, { src: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png' }),
	                  title: '\u6280\u672F\u652F\u6491',
	                  description: '\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7 \u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD\u4EA7\u54C1\u4ECB\u7ECD'
	                })
	              )
	            ) : _react2.default.createElement(
	              _antd.List.Item,
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/client/product/add' },
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'dashed', className: 'newButton' },
	                  _react2.default.createElement(_antd.Icon, { type: 'plus' }),
	                  ' \u65B0\u5EFA\u4EA7\u54C1'
	                )
	              )
	            );
	          }
	        })
	      );
	    }
	  }]);
	
	  return ProductIndex;
	}(_react.Component);
	
	exports.default = ProductIndex;

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _crm = __webpack_require__(33);
	
	var _FormProduct = __webpack_require__(1492);
	
	var _FormProduct2 = _interopRequireDefault(_FormProduct);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.handleAdd = function (params) {
	      (0, _crm.querySaveCustom)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = { data: {} };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ data: nextProps.data });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormProduct2.default, {
	          ref: function ref(form) {
	            _this2.form = form;
	          },
	          handleSubmit: this.handleAdd,
	          data: data
	        })
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { organization: state.organization };
	})(BaseForm);

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(2951);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var ProtectSetIndex = function (_Component) {
	  _inherits(ProtectSetIndex, _Component);
	
	  function ProtectSetIndex(props) {
	    _classCallCheck(this, ProtectSetIndex);
	
	    var _this = _possibleConstructorReturn(this, (ProtectSetIndex.__proto__ || Object.getPrototypeOf(ProtectSetIndex)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ProtectSetIndex, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        { title: '\u4FDD\u62A4\u8BBE\u7F6E', className: 'protectSet' },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: this.handleSubmit },
	          _react2.default.createElement(
	            _antd.Row,
	            { gutter: { md: 8, lg: 24, xl: 48 } },
	            _react2.default.createElement(
	              _antd.Col,
	              { md: 8, sm: 24 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                '\u4FDD\u62A4\u6709\u6548\u671F',
	                getFieldDecorator('condition')(_react2.default.createElement(_antd.InputNumber, null)),
	                '\u5929'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                '\u5408\u540C\u5230\u671F',
	                getFieldDecorator('condition')(_react2.default.createElement(_antd.InputNumber, null)),
	                '\u5929\u540E\u4FDD\u62A4\u6709\u6548\u671F',
	                getFieldDecorator('condition')(_react2.default.createElement(_antd.InputNumber, null)),
	                '\u5929'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                '\u4FDD\u62A4\u4E0A\u9650',
	                getFieldDecorator('condition')(_react2.default.createElement(_antd.InputNumber, null)),
	                '\u4E2A'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { md: 8, sm: 24 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary' },
	                  '\u786E\u5B9A'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ProtectSetIndex;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(ProtectSetIndex);

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1484);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _PageAdd = __webpack_require__(1485);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	var _Index3 = __webpack_require__(1491);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _Index5 = __webpack_require__(1489);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _Index7 = __webpack_require__(1495);
	
	var _Index8 = _interopRequireDefault(_Index7);
	
	var _Index9 = __webpack_require__(1493);
	
	var _Index10 = _interopRequireDefault(_Index9);
	
	var _PageAdd3 = __webpack_require__(1494);
	
	var _PageAdd4 = _interopRequireDefault(_PageAdd3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = {
	  path: 'client',
	  breadcrumbName: '客户管理',
	  childRoutes: [{
	    path: 'manage',
	    breadcrumbName: '客户管理',
	    indexRoute: { component: _Index2.default },
	    childRoutes: [{
	      path: 'add',
	      breadcrumbName: '新建客户',
	      indexRoute: { component: _PageAdd2.default }
	    }]
	  }, {
	    path: 'pool',
	    breadcrumbName: '客户共享池管理',
	    indexRoute: { component: _Index4.default },
	    childRoutes: [{
	      path: 'add',
	      breadcrumbName: '新建客户',
	      indexRoute: { component: _PageAdd2.default }
	    }]
	  }, {
	    path: 'mine',
	    breadcrumbName: '我的客户',
	    indexRoute: { component: _Index6.default }
	  }, {
	    path: 'protectSet',
	    breadcrumbName: '保护设置',
	    indexRoute: { component: _Index8.default }
	  }, {
	    path: 'product',
	    breadcrumbName: '业务产品管理',
	    indexRoute: { component: _Index10.default },
	    childRoutes: [{
	      path: 'add',
	      breadcrumbName: '新建业务产品',
	      indexRoute: { component: _PageAdd4.default }
	    }]
	  }]
	}; /**
	    * routers
	    * 更多关于Router的使用，请参考以下教程
	    * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
	    */
	
	// 资金管理
	exports.default = router;

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(1184);
	
	var _responsive = __webpack_require__(1499);
	
	var _responsive2 = _interopRequireDefault(_responsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	// eslint-disable-next-line import/no-extraneous-dependencies
	
	
	var Description = function Description(_ref) {
	  var term = _ref.term,
	      column = _ref.column,
	      children = _ref.children,
	      restProps = _objectWithoutProperties(_ref, ['term', 'column', 'children']);
	
	  return _react2.default.createElement(
	    _antd.Col,
	    Object.assign({}, _responsive2.default[column], restProps),
	    term && _react2.default.createElement(
	      'div',
	      { className: 'term' },
	      term
	    ),
	    children !== null && children !== undefined && _react2.default.createElement(
	      'div',
	      { className: 'detail' },
	      children
	    )
	  );
	};
	
	Description.defaultProps = {
	  term: ''
	};
	
	Description.propTypes = {
	  term: _propTypes2.default.node
	};
	
	exports.default = Description;

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(1184);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var DescriptionList = function DescriptionList(_ref) {
	  var className = _ref.className,
	      title = _ref.title,
	      _ref$col = _ref.col,
	      col = _ref$col === undefined ? 3 : _ref$col,
	      _ref$gutter = _ref.gutter,
	      gutter = _ref$gutter === undefined ? 32 : _ref$gutter,
	      children = _ref.children,
	      size = _ref.size,
	      restProps = _objectWithoutProperties(_ref, ['className', 'title', 'col', 'gutter', 'children', 'size']);
	
	  var clsString = (0, _classnames2.default)('descriptionList', 'layout');
	  var column = col > 4 ? 4 : col;
	  return _react2.default.createElement(
	    'div',
	    Object.assign({ className: clsString }, restProps),
	    title ? _react2.default.createElement(
	      'div',
	      { className: 'title' },
	      title
	    ) : null,
	    _react2.default.createElement(
	      _antd.Row,
	      { gutter: gutter },
	      _react2.default.Children.map(children, function (child) {
	        return child ? _react2.default.cloneElement(child, { column: column }) : child;
	      })
	    )
	  );
	};
	
	exports.default = DescriptionList;

/***/ },
/* 1499 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  1: { xs: 24 },
	  2: { xs: 24, sm: 12 },
	  3: { xs: 24, sm: 12, md: 8 },
	  4: { xs: 24, sm: 12, md: 6 }
	};

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _user = __webpack_require__(54);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _user2 = __webpack_require__(441);
	
	var _UpdatePassword = __webpack_require__(1692);
	
	var _UpdatePassword2 = _interopRequireDefault(_UpdatePassword);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).call(this, props));
	
	    _this.showCodeModal = function () {
	      _this.setState({ popVisible: false, codeModalVisible: true });
	    };
	
	    _this.hideCodeModal = function () {
	      _this.setState({ codeModalVisible: false });
	    };
	
	    _this.handleVisibleChange = function (visible) {
	      _this.setState({ popVisible: visible });
	    };
	
	    _this.logout = function () {
	      var _this$props = _this.props,
	          dispatch = _this$props.dispatch,
	          router = _this$props.router;
	
	      dispatch((0, _user2.cleanUser)());
	      _localDb2.default.clear();
	      _antd.message.info('您已退出系统！');
	      router.push('/login');
	    };
	
	    _this.edit = function (user) {
	      var context = _this;
	      var _this$props2 = _this.props,
	          dispatch = _this$props2.dispatch,
	          router = _this$props2.router;
	
	      (0, _user.queryUpdatePwd)(user).then(function (res) {
	        if (res.statusCode === 200) {
	          context.hideCodeModal();
	          _antd.message.success('密码修改成功,请重新登录！');
	          dispatch((0, _user2.cleanUser)());
	          _localDb2.default.clear();
	          router.push('/login');
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      codeModalVisible: false,
	      popVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var user = this.props.user;
	
	      var menu = _react2.default.createElement(
	        _antd.Menu,
	        null,
	        _react2.default.createElement(
	          _antd.Menu.Item,
	          null,
	          _react2.default.createElement(
	            'a',
	            { style: { color: '#108ee9' }, onClick: this.showCodeModal },
	            '\u4FEE\u6539\u5BC6\u7801'
	          )
	        )
	      );
	      var _state = this.state,
	          popVisible = _state.popVisible,
	          codeModalVisible = _state.codeModalVisible;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'header' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'end', align: 'middle' },
	          _react2.default.createElement(
	            _antd.Col,
	            { className: 'user', span: 8, offset: 10 },
	            _react2.default.createElement(
	              'div',
	              { className: 'header-line' },
	              _react2.default.createElement(
	                _antd.Dropdown,
	                {
	                  overlay: menu,
	                  visible: popVisible,
	                  onVisibleChange: this.handleVisibleChange
	                },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'info' },
	                  user.userName || '匿名',
	                  ' ',
	                  _react2.default.createElement(_antd.Icon, { type: 'down', style: { fontSize: '15px' } })
	                )
	              ),
	              _react2.default.createElement(
	                'div',
	                { className: 'exit', onClick: this.logout },
	                _react2.default.createElement(_antd.Icon, { type: 'poweroff', style: { fontSize: '15px' } })
	              )
	            )
	          )
	        ),
	        codeModalVisible ? _react2.default.createElement(
	          _antd.Modal,
	          {
	            title: '\u4FEE\u6539\u5BC6\u7801',
	            visible: codeModalVisible,
	            footer: false,
	            onCancel: this.hideCodeModal,
	            maskClosable: false,
	            width: 300
	          },
	          _react2.default.createElement(_UpdatePassword2.default, {
	            user: user,
	            title: '\u4FEE\u6539\u5BC6\u7801',
	            handSubmit: function handSubmit(userDate) {
	              return _this2.edit(userDate);
	            }
	          })
	        ) : ''
	      );
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { user: state.user };
	})(Header);

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MonthPicker = _antd.DatePicker.MonthPicker;
	
	var MonthRange = function (_Component) {
	  _inherits(MonthRange, _Component);
	
	  function MonthRange() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MonthRange);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = MonthRange.__proto__ || Object.getPrototypeOf(MonthRange)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      startValue: _this.props.startValue,
	      endValue: _this.props.endValue,
	      endOpen: false
	    }, _this.disabledStartDate = function (startValue) {
	      var endValue = _this.state.endValue;
	
	      if (!startValue || !endValue) {
	        return false;
	      }
	      return startValue.valueOf() >= endValue.valueOf();
	    }, _this.disabledEndDate = function (endValue) {
	      var startValue = _this.state.startValue;
	
	      if (!endValue || !startValue) {
	        return false;
	      }
	      return endValue.valueOf() <= startValue.valueOf();
	    }, _this.onChange = function (field, value) {
	      _this.setState(_defineProperty({}, field, value), function () {
	        var date = [];
	        date.push(_this.state.startValue);
	        date.push(_this.state.endValue);
	        _this.props.transferValue(date);
	      });
	    }, _this.onStartChange = function (value) {
	      _this.onChange('startValue', value);
	    }, _this.onEndChange = function (value) {
	      _this.onChange('endValue', value);
	    }, _this.handleStartOpenChange = function (open) {
	      if (!open) {
	        _this.setState({ endOpen: true });
	      }
	    }, _this.handleEndOpenChange = function (open) {
	      _this.setState({ endOpen: open });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(MonthRange, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          startValue = _state.startValue,
	          endValue = _state.endValue,
	          endOpen = _state.endOpen;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(MonthPicker, {
	          disabledDate: this.disabledStartDate,
	          showTime: true,
	          format: 'YYYY-MM',
	          value: startValue,
	          placeholder: 'Start',
	          onChange: this.onStartChange,
	          onOpenChange: this.handleStartOpenChange
	        }),
	        '-',
	        _react2.default.createElement(MonthPicker, {
	          disabledDate: this.disabledEndDate,
	          showTime: true,
	          format: 'YYYY-MM',
	          value: endValue,
	          placeholder: 'End',
	          onChange: this.onEndChange,
	          open: endOpen,
	          onOpenChange: this.handleEndOpenChange
	        })
	      );
	    }
	  }]);
	
	  return MonthRange;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(MonthRange);

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(2953);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * 暂无数据
	 */
	var color = ['#1890ff', '#52c41a'];
	
	var Pmgressbar = function (_Component) {
	  _inherits(Pmgressbar, _Component);
	
	  function Pmgressbar() {
	    _classCallCheck(this, Pmgressbar);
	
	    return _possibleConstructorReturn(this, (Pmgressbar.__proto__ || Object.getPrototypeOf(Pmgressbar)).apply(this, arguments));
	  }
	
	  _createClass(Pmgressbar, [{
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	
	      var dePer = 1;
	      var ind = 1;
	      data.map(function (item, index) {
	        if (item.per < dePer) {
	          dePer = item.per;
	          ind = index;
	        }
	        return item;
	      });
	      return _react2.default.createElement(
	        'div',
	        { className: 'bar1' },
	        data.map(function (item, index) {
	          var per = ((item.per || 0) * 100).toFixed(2) + '%';
	          return _react2.default.createElement(
	            'div',
	            {
	              style: {
	                width: parseFloat(per) > 100 ? '100%' : per,
	                background: item.color || color[index],
	                zIndex: index === ind && '10'
	              },
	              className: 'bar-item',
	              key: item.type
	            },
	            item.location === 'top' ? _react2.default.createElement(
	              'div',
	              { className: 'bar-tip bar-tip-top' },
	              _react2.default.createElement(
	                'div',
	                { className: 'value-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  item.type
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'value' },
	                  _index2.default.numberFormat(item.value || 0)
	                ),
	                per
	              ),
	              _react2.default.createElement(_antd.Icon, { type: 'caret-down', style: { color: '#d5d5d5' } })
	            ) : _react2.default.createElement(
	              'div',
	              { className: 'bar-tip bar-tip-bot' },
	              _react2.default.createElement(_antd.Icon, { type: 'caret-up', style: { color: '#d5d5d5' } }),
	              _react2.default.createElement(
	                'div',
	                { className: 'value-wrapper' },
	                _react2.default.createElement(
	                  'div',
	                  null,
	                  item.type
	                ),
	                _react2.default.createElement(
	                  'div',
	                  { className: 'value' },
	                  _index2.default.numberFormat(item.value || 0)
	                ),
	                per
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return Pmgressbar;
	}(_react.Component);
	
	exports.default = Pmgressbar;

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(2952);
	
	var _path = __webpack_require__(2618);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * 暂无数据
	 */
	var months = [];
	for (var i = 1; i <= 12; i++) {
	  months.push(i);
	}
	
	var Pmgressbar = function (_Component) {
	  _inherits(Pmgressbar, _Component);
	
	  function Pmgressbar(props) {
	    _classCallCheck(this, Pmgressbar);
	
	    var _this = _possibleConstructorReturn(this, (Pmgressbar.__proto__ || Object.getPrototypeOf(Pmgressbar)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Pmgressbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          _props$per = _props.per,
	          per = _props$per === undefined ? 0.1 : _props$per,
	          _props$money = _props.money,
	          money = _props$money === undefined ? 0 : _props$money,
	          nowAimPre = _props.nowAimPre;
	
	      var monthFinishedNum = 0; // 已完成的月数
	      var currentMonthPer = 0; // 当前进行月的进度
	      var isOverruns = 'bar-month-finished';
	      if (nowAimPre || nowAimPre === 0) {
	        if (per > nowAimPre) {
	          isOverruns = 'bar-month-finished-red';
	        }
	      }
	
	      if (per >= 1) {
	        monthFinishedNum = 12;
	        currentMonthPer = '0.00';
	      } else {
	        monthFinishedNum = Math.floor(12 * per);
	        currentMonthPer = ((12 * per - monthFinishedNum) * 100).toFixed(2);
	      }
	
	      var months2 = [];
	      for (var _i = 1; _i <= Math.min(monthFinishedNum, 12); _i++) {
	        months2.push(_i);
	      }
	      var tips = _react2.default.createElement(
	        'div',
	        {
	          className: 'bar-tip',
	          style: {
	            position: 'absolute',
	            bottom: '10px',
	            left: currentMonthPer === '0.00' ? '100%' : currentMonthPer + '%'
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          { className: 'value-wrapper' },
	          _react2.default.createElement(
	            'span',
	            { className: 'value' },
	            _index2.default.numberFormat(money)
	          ),
	          (per * 100).toFixed(2) + '%'
	        ),
	        _react2.default.createElement(_antd.Icon, { type: 'caret-down', style: { color: '#d5d5d5' } })
	      );
	      return _react2.default.createElement(
	        'div',
	        { className: 'bar-month' },
	        _react2.default.createElement(
	          'div',
	          { className: 'all' },
	          _react2.default.createElement(
	            _antd.Row,
	            { gutter: 8 },
	            months.map(function (item) {
	              return _react2.default.createElement(
	                _antd.Col,
	                { span: 2, key: item },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar-month-item' },
	                  item,
	                  '\u6708'
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'finished' },
	          _react2.default.createElement(
	            _antd.Row,
	            { gutter: 8 },
	            months2.map(function (item, index) {
	              return currentMonthPer !== '0.00' || index < months2.length - 1 ? _react2.default.createElement(
	                _antd.Col,
	                { span: 2 },
	                _react2.default.createElement('div', { className: 'bar-month-item  ' + isOverruns })
	              ) : _react2.default.createElement(
	                _antd.Col,
	                { span: 2 },
	                _react2.default.createElement(
	                  'div',
	                  { className: 'bar-month-item  ' + isOverruns, style: { position: 'relative' } },
	                  tips
	                )
	              );
	            }),
	            currentMonthPer === '0.00' ? null : _react2.default.createElement(
	              _antd.Col,
	              { span: 2 },
	              _react2.default.createElement(
	                'div',
	                {
	                  className: 'bar-month-item  ' + isOverruns,
	                  style: {
	                    width: currentMonthPer + '%',
	                    position: _path.relative
	                  }
	                },
	                tips
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Pmgressbar;
	}(_react.Component);
	
	exports.default = Pmgressbar;

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _hr = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      data.orgUuid = _this.state.orgUuid;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          _this.props.handSubmit(data);
	        }
	      });
	    };
	
	    _this.onChange = function (value, options) {
	      _this.setState({
	        value: value
	      });
	      _this.props.onChange(value, options);
	    };
	
	    _this.searchUser = function (value) {
	      var params = {};
	      params.condition = value;
	      (0, _hr.queryHrList)(Object.assign({}, params, { status: 1 })).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data
	          });
	        }
	      });
	    };
	
	    _this.state = { data: [] };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchUser('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          value = _state.value,
	          data = _state.data;
	
	      return _react2.default.createElement(
	        _antd.Select,
	        {
	          showSearch: true,
	          mode: this.props.isMultiple || '',
	          value: value,
	          onChange: this.onChange,
	          onSearch: this.searchUser,
	          placeholder: '\u4EBA\u5458',
	          optionFilterProp: 'children',
	          filterOption: function filterOption(input, option) {
	            return option.props.children.length ? option.props.children.filter(function (child) {
	              return child.toLowerCase().indexOf(input.toLowerCase());
	            }).length >= 0 : option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	          }
	        },
	        value && name && !data.some(function (item) {
	          return item.uuid === value;
	        }) ? _react2.default.createElement(
	          Option,
	          { key: value, disabled: true },
	          name,
	          '(\u5DF2\u7981\u7528)'
	        ) : null,
	        data.map(function (item) {
	          return _react2.default.createElement(
	            Option,
	            { key: item.uuid },
	            item.name,
	            ' ',
	            item.workOrgName ? '(' + item.workOrgName + ')' : ''
	          );
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _menu = __webpack_require__(439);
	
	var _reactRedux = __webpack_require__(5);
	
	var _logo = __webpack_require__(2968);
	
	var _logo2 = _interopRequireDefault(_logo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = _antd.Layout.Header,
	    Content = _antd.Layout.Content;
	var SubMenu = _antd.Menu.SubMenu;
	
	var Siderbar = function (_Component) {
	  _inherits(Siderbar, _Component);
	
	  function Siderbar(props) {
	    _classCallCheck(this, Siderbar);
	
	    var _this = _possibleConstructorReturn(this, (Siderbar.__proto__ || Object.getPrototypeOf(Siderbar)).call(this, props));
	
	    _this.handleClick = function (e) {
	      _this.setState({
	        current: e.key
	      });
	    };
	
	    _this.onOpenChange = function (openKeys) {
	      var state = _this.state;
	
	      var latestOpenKey = openKeys.find(function (key) {
	        return !(state.openKeys.indexOf(key) > -1);
	      });
	      var latestCloseKey = state.openKeys.find(function (key) {
	        return !(openKeys.indexOf(key) > -1);
	      });
	
	      var nextOpenKeys = [];
	      if (latestOpenKey) {
	        nextOpenKeys = _this.getAncestorKeys(latestOpenKey).concat(latestOpenKey);
	      }
	      if (latestCloseKey) {
	        nextOpenKeys = _this.getAncestorKeys(latestCloseKey);
	      }
	      _this.setState({
	        openKeys: nextOpenKeys
	      });
	    };
	
	    _this.getAncestorKeys = function (key) {
	      var map = {
	        auth: ['boss'],
	        attendance: ['hr'],
	        leave: ['hr'],
	        overTime: ['hr'],
	        fill: ['hr'],
	        incuanalyze: ['incubator']
	      };
	      return map[key] || [];
	    };
	
	    _this.getMenuXml = function (data) {
	      if (data && data.length > 0) {
	        return data.map(function (item) {
	          if (item.child && item.child.length > 0) {
	            return _react2.default.createElement(
	              SubMenu,
	              {
	                key: item.key,
	                title: _react2.default.createElement(
	                  'span',
	                  null,
	                  item.icon ? _react2.default.createElement(_antd.Icon, { type: item.icon }) : '',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    item.name
	                  )
	                )
	              },
	              _this.getMenuXml(item.child)
	            );
	          }
	          return _react2.default.createElement(
	            _antd.Menu.Item,
	            { key: item.key },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: item.link },
	              item.icon ? _react2.default.createElement(_antd.Icon, { type: item.icon }) : '',
	              _react2.default.createElement(
	                'span',
	                null,
	                item.name
	              )
	            )
	          );
	        });
	      }
	      return '';
	    };
	
	    _this.state = {
	      current: '',
	      openKeys: ['']
	    };
	    return _this;
	  }
	
	  _createClass(Siderbar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var pathname = this.props.router.location.pathname;
	
	      var arr = pathname.split('/');
	      this.setState({
	        current: arr[3] || arr[2],
	        openKeys: [arr[1]]
	      });
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _menu.getMenu)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var menus = this.props.menu;
	
	      return _react2.default.createElement(
	        _antd.Layout,
	        {
	          style: {
	            overflowY: 'scroll',
	            height: '100%',
	            background: '#001529',
	            width: 220
	          }
	        },
	        _react2.default.createElement(
	          Header,
	          { style: { minHeight: 100, margin: '0 auto', width: 200, padding: 0 } },
	          _react2.default.createElement('img', { src: _logo2.default, alt: _logo2.default, style: { width: '100%', paddingTop: 20 } })
	        ),
	        _react2.default.createElement(
	          Content,
	          null,
	          _react2.default.createElement(
	            _antd.Menu,
	            {
	              mode: 'inline',
	              theme: 'dark',
	              openKeys: this.state.openKeys,
	              selectedKeys: [this.state.current],
	              onOpenChange: this.onOpenChange,
	              onClick: this.handleClick
	            },
	            this.getMenuXml(menus)
	          )
	        )
	      );
	    }
	  }]);
	
	  return Siderbar;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { menu: state.menu };
	})(Siderbar);

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(597);
	
	var _apportion = __webpack_require__(166);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalApportion = function (_Component) {
	  _inherits(ModalApportion, _Component);
	
	  function ModalApportion(props) {
	    _classCallCheck(this, ModalApportion);
	
	    var _this = _possibleConstructorReturn(this, (ModalApportion.__proto__ || Object.getPrototypeOf(ModalApportion)).call(this, props));
	
	    _this.reset = function () {
	      var treeData = _this.state.treeData;
	
	      var newData = treeData.map(function (item) {
	        return Object.assign({}, item, {
	          children: item.children.map(function (item2) {
	            return Object.assign({}, item2, { isChoosed: false });
	          })
	        });
	      });
	      _this.setState({
	        treeData: newData,
	        searchKey: ''
	      });
	      _this.props.onChange([]);
	    };
	
	    _this.getApportionOrigin = function () {
	      (0, _apportion.queryApportionOrigin)().then(function (res) {
	        if (_this.props.choosedArr) {
	          res.data.map(function (item) {
	            item.children.map(function (item2) {
	              if (_this.props.choosedArr.some(function (item3) {
	                return item3 === item2.value;
	              })) {
	                item2.isChoosed = true;
	              }
	              return item2;
	            });
	            return item;
	          });
	        }
	        _this.setState({
	          treeData: res.data
	        });
	      });
	    };
	
	    _this.onChange = function () {};
	
	    _this.handleOpen = function (key) {
	      var treeData = _this.state.treeData;
	
	      _this.loopFind(treeData, key);
	      _this.setState({
	        treeData: treeData
	      });
	    };
	
	    _this.loopFind = function (data, key) {
	      data.map(function (item) {
	        if (item.value === key) {
	          item.isOpen = !item.isOpen;
	        }
	        return item;
	      });
	    };
	
	    _this.handleChange = function (key, parentId) {
	      var treeData = _this.state.treeData;
	
	      var newData = treeData.map(function (item) {
	        if (item.value === parentId) {
	          return Object.assign({}, item, {
	            children: item.children.map(function (item2) {
	              if (item2.value === key) {
	                return Object.assign({}, item2, {
	                  isChoosed: !item2.isChoosed
	                });
	              }
	              return Object.assign({}, item2);
	            })
	          });
	        }
	        return item;
	      });
	      _this.setState({
	        treeData: newData
	      });
	    };
	
	    _this.handleAllChange = function (record) {
	      var treeData = _this.state.treeData;
	
	      var newData = treeData.map(function (item) {
	        if (item.value === record.value) {
	          var isTrue = item.children.every(function (item2) {
	            return item2.isChoosed;
	          });
	          if (!isTrue) {
	            return Object.assign({}, item, {
	              children: item.children.map(function (item3) {
	                return Object.assign({}, item3, {
	                  isChoosed: true
	                });
	              })
	            });
	          }
	          return Object.assign({}, item, {
	            children: item.children.map(function (item3) {
	              return Object.assign({}, item3, { isChoosed: false });
	            })
	          });
	        }
	        return item;
	      });
	      _this.setState({
	        treeData: newData
	      });
	    };
	
	    _this.handleSearch = function (e) {
	      _this.setState({
	        searchKey: e.target.value
	      });
	    };
	
	    _this.loopSearchFilter = function (data, key) {
	      data.map(function (item) {
	        item.isOpen = true;
	        item.children = item.children.filter(function (it) {
	          return it.title.indexOf(key) >= 0;
	        });
	        return item;
	      });
	      data = data.filter(function (item) {
	        return item.children.length > 0;
	      });
	      return data;
	    };
	
	    _this.handleAdd = function () {
	      var treeData = _this.state.treeData;
	
	      var newDataList = treeData.reduce(function (total, curr) {
	        var data = curr.children.map(function (item) {
	          return Object.assign({}, item, {
	            type: curr.value
	          });
	        });
	        return total.concat(data);
	      }, []).filter(function (item2) {
	        return item2.isChoosed;
	      });
	      _this.props.onChange(newDataList);
	    };
	
	    _this.renderUser = function (data, parentId) {
	      var com = data.map(function (item) {
	        if (item.children) {
	          return _react2.default.createElement(
	            'li',
	            { key: item.value, style: { marginBottom: '5px' } },
	            _react2.default.createElement(_antd.Icon, {
	              className: item.isOpen ? 'open' : 'close',
	              type: 'caret-down',
	              onClick: function onClick() {
	                return _this.handleOpen(item.value);
	              }
	            }),
	            _react2.default.createElement(_antd.Checkbox, {
	              style: { marginRight: '5px' },
	              onChange: function onChange() {
	                return _this.handleAllChange(item);
	              },
	              checked: item.children.length > 0 && item.children.every(function (item2) {
	                return item2.isChoosed;
	              })
	            }),
	            item.title,
	            _react2.default.createElement(
	              'ul',
	              { className: item.isOpen ? 'childOpen' : 'childClose' },
	              _this.renderUser(item.children, item.value)
	            )
	          );
	        }
	        return _react2.default.createElement(
	          'li',
	          { key: item.value, style: { marginLeft: '26px', marginBottom: '5px' } },
	          _react2.default.createElement(_antd.Checkbox, {
	            style: { marginRight: '5px' },
	            onChange: function onChange() {
	              _this.handleChange(item.value, parentId);
	            },
	            checked: item.isChoosed
	          }),
	          item.title
	        );
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        com
	      );
	    };
	
	    _this.renderSearchUser = function (data, parentId) {
	      var searchKey = _this.state.searchKey;
	
	      if (!searchKey) {
	        return null;
	      }
	      var com = data.map(function (item) {
	        if (item.children) {
	          if (item.children.every(function (it) {
	            return it.title.indexOf(searchKey) < 0;
	          })) {
	            return null;
	          }
	          return _react2.default.createElement(
	            'li',
	            { key: item.value, style: { marginBottom: '5px' } },
	            _react2.default.createElement(_antd.Icon, {
	              className: item.isOpen ? 'open' : 'close',
	              type: 'caret-down',
	              onClick: function onClick() {
	                return _this.handleOpen(item.value);
	              }
	            }),
	            _react2.default.createElement(_antd.Checkbox, {
	              style: { marginRight: '5px' },
	              onChange: function onChange() {
	                return _this.handleAllChange(item);
	              },
	              checked: item.children.length > 0 && item.children.every(function (item2) {
	                return item2.isChoosed;
	              })
	            }),
	            item.title,
	            _react2.default.createElement(
	              'ul',
	              { className: item.isOpen ? 'childOpen' : 'childClose' },
	              _this.renderSearchUser(item.children, item.value)
	            )
	          );
	        }
	        return item.title.indexOf(searchKey) >= 0 ? _react2.default.createElement(
	          'li',
	          { key: item.value, style: { marginLeft: '26px', marginBottom: '5px' } },
	          _react2.default.createElement(_antd.Checkbox, {
	            style: { marginRight: '5px' },
	            onChange: function onChange() {
	              _this.handleChange(item.value, parentId);
	            },
	            checked: item.isChoosed
	          }),
	          item.title
	        ) : null;
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        com
	      );
	    };
	
	    _this.state = {
	      treeData: [],
	      searchKey: ''
	    };
	    return _this;
	  }
	
	  _createClass(ModalApportion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getApportionOrigin();
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	
	    // 控制子列表是否显示
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          treeData = _state.treeData,
	          searchKey = _state.searchKey;
	
	      return _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 5, className: 'appLabel' },
	          '\u9884\u7B97\u5206\u644A\uFF1A'
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 14 },
	          _react2.default.createElement(
	            'div',
	            { className: 'left' },
	            _react2.default.createElement(
	              'div',
	              { className: 'selected' },
	              treeData.map(function (item) {
	                if (item.children.length > 0 && item.children.every(function (item2) {
	                  return item2.isChoosed;
	                })) {
	                  return _react2.default.createElement(
	                    _antd.Tag,
	                    {
	                      closable: true,
	                      key: item.value,
	                      onClose: function onClose() {
	                        _this2.handleAllChange(item);
	                      }
	                    },
	                    item.title
	                  );
	                }
	                return item.children.map(function (item2) {
	                  if (item2.isChoosed) {
	                    return _react2.default.createElement(
	                      _antd.Tag,
	                      {
	                        closable: true,
	                        key: item2.value,
	                        onClose: function onClose() {
	                          _this2.handleChange(item2.value, item.value);
	                        }
	                      },
	                      item2.title
	                    );
	                  }
	                  return null;
	                });
	              })
	            ),
	            _react2.default.createElement(
	              'div',
	              { className: 'wrapper' },
	              _react2.default.createElement(
	                'div',
	                { className: 'searchBox' },
	                _react2.default.createElement(_antd.Input, {
	                  style: {
	                    border: 'none',
	                    borderBottom: '1px solid #ddd',
	                    borderRadius: '0'
	                  },
	                  onPressEnter: this.handleSearch,
	                  placeholder: '\u5173\u952E\u5B57\u641C\u7D22'
	                }),
	                searchKey === '' ? _react2.default.createElement(
	                  'ul',
	                  { className: 'selectList' },
	                  this.renderUser(treeData)
	                ) : _react2.default.createElement(
	                  'ul',
	                  { className: 'selectList' },
	                  this.renderSearchUser(treeData)
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 4 },
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              type: 'primary',
	              style: { marginBottom: '8px', marginTop: '130px' },
	              onClick: this.handleAdd
	            },
	            '\u6DFB\u52A0'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { onClick: this.reset },
	            '\u91CD\u7F6E'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalApportion;
	}(_react.Component);
	
	exports.default = ModalApportion;

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(597);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var type = ['全部人员', '部门', '项目'];
	
	var ModalApportion = function (_Component) {
	  _inherits(ModalApportion, _Component);
	
	  function ModalApportion(props) {
	    _classCallCheck(this, ModalApportion);
	
	    var _this = _possibleConstructorReturn(this, (ModalApportion.__proto__ || Object.getPrototypeOf(ModalApportion)).call(this, props));
	
	    _this.findIndex = function (arr, record) {
	      var recordIndex = -1;
	      arr.forEach(function (item, index) {
	        if (item.originUuid === record.originUuid) {
	          recordIndex = index;
	        }
	      });
	      return recordIndex;
	    };
	
	    _this.handleMouseEnter = function (record) {
	      var apportion = _this.state.apportion;
	
	      var index = _this.findIndex(apportion, record);
	      apportion[index].isEditable = true;
	      _this.props.resetApportion(apportion);
	    };
	
	    _this.handleMouseLeave = function (record) {
	      var apportion = _this.state.apportion;
	
	      var index = _this.findIndex(apportion, record);
	      apportion[index].isEditable = false;
	      _this.props.resetApportion(apportion);
	    };
	
	    _this.handlePriceChange = function (record) {
	      return function (e) {
	        var apportion = _this.state.apportion;
	
	        var index = _this.findIndex(apportion, record);
	        apportion[index].price = e.target.value;
	        _this.props.resetApportion(apportion);
	      };
	    };
	
	    _this.handleDelete = function (record) {
	      var apportion = _this.state.apportion;
	
	      var index = _this.findIndex(apportion, record);
	      apportion.splice(index, 1);
	      _this.props.onDelete(apportion);
	      _this.props.setChoooseArr(apportion);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '分摊对象',
	        dataIndex: 'originName',
	        width: 100
	      }, {
	        title: '类型',
	        dataIndex: 'originType',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            type[text]
	          );
	        },
	        width: 100
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        onCell: function onCell(record) {
	          return {
	            onMouseEnter: function onMouseEnter() {
	              return _this.handleMouseEnter(record);
	            },
	            onMouseLeave: function onMouseLeave() {
	              return _this.handleMouseLeave(record);
	            }
	          };
	        },
	        width: 160,
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            record.isEditable ? _react2.default.createElement(_antd.Input, { value: text, onChange: _this.handlePriceChange(record) }) : _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        width: 60,
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.handleDelete(record);
	              } },
	            '\u5220\u9664'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      apportion: []
	    };
	    return _this;
	  }
	
	  _createClass(ModalApportion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({
	        apportion: this.props.data
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        apportion: nextProps.data
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var apportion = this.state.apportion;
	
	      return _react2.default.createElement(_antd.Table, {
	        bordered: true,
	        rowKey: 'originUuid',
	        columns: this.columns(),
	        dataSource: apportion,
	        scroll: { y: 260 },
	        size: 'small'
	      });
	    }
	  }]);
	
	  return ModalApportion;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalApportion);

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _echarts = __webpack_require__(817);
	
	var _echarts2 = _interopRequireDefault(_echarts);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Series = function (_React$Component) {
	  _inherits(Series, _React$Component);
	
	  function Series() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Series);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Series.__proto__ || Object.getPrototypeOf(Series)).call.apply(_ref, [this].concat(args))), _this), _this.drawChart = function (params) {
	      var data = params.data;
	
	      _this.myChart.setOption({
	        title: {
	          text: data.title
	        },
	        tooltip: {
	          trigger: "item",
	          // formatter: '{a} <br/>{b} : {c} ({d}%)',
	          formatter: function formatter(obj) {
	            return obj.seriesName + "<br>" + obj.name + "\uFF1A" + _index2.default.numberFormat(obj.value) + "(" + obj.percent + "%)";
	          }
	        },
	        legend: {
	          type: "scroll",
	          orient: "vertical",
	          right: 10,
	          top: 20,
	          bottom: 20,
	          data: data.legendData,
	          selected: data.selected
	        },
	        series: [{
	          name: "费用",
	          type: "pie",
	          radius: "55%",
	          center: ["40%", "50%"],
	          data: data.seriesData,
	          itemStyle: {
	            emphasis: {
	              shadowBlur: 10,
	              shadowOffsetX: 0,
	              shadowColor: "rgba(0, 0, 0, 0.5)"
	            }
	          }
	        }]
	      });
	      _this.myChart.resize();
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Series, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.myChart = _echarts2.default.init(document.getElementById("pieCharts"));
	      this.drawChart(this.props);
	      window.addEventListener("resize", function () {
	        _this2.myChart.resize();
	      });
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.drawChart(nextProps);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement("div", { id: "pieCharts", style: { width: "100%", height: 500 } });
	    }
	  }]);
	
	  return Series;
	}(_react2.default.Component);
	
	exports.default = Series;

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(2956);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {}
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          title = _props.title;
	
	      var rankData = data;
	      return _react2.default.createElement(
	        "div",
	        { className: "salesRank" },
	        _react2.default.createElement(
	          "h4",
	          { className: "rankingTitle" },
	          title
	        ),
	        _react2.default.createElement(
	          "ul",
	          { className: "rankingList" },
	          rankData.map(function (item, i) {
	            return _react2.default.createElement(
	              "li",
	              { key: item.title },
	              _react2.default.createElement(
	                "span",
	                { className: "rankingItemNumber " + (i < 3 ? "active" : "") },
	                i + 1
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "rankingItemTitle" },
	                item.name
	              ),
	              _react2.default.createElement(
	                "span",
	                { className: "rankingItemValue" },
	                _index2.default.numberFormat(item.value)
	              )
	            );
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _budget = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var Group = function (_Component) {
	  _inherits(Group, _Component);
	
	  function Group(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Group);
	
	    var _this = _possibleConstructorReturn(this, (Group.__proto__ || Object.getPrototypeOf(Group)).call(this, props));
	
	    _this.formatOption = function (arr) {
	      var companyAll = _this.state.companyAll;
	
	      arr.map(function (item) {
	        if (item.children && item.children.length > 0) {
	          _this.formatOption(item.children);
	        }
	        companyAll.push(item);
	        return item;
	      });
	      _this.setState({
	        companyAll: companyAll
	      });
	    };
	
	    _this.formatGroup = function (arr) {
	      arr.map(function (item) {
	        if (item.children) {
	          if (item.children.length === 0) {
	            delete item.children;
	            return item;
	          }
	          if (item.children.length > 0) {
	            _this.formatGroup(item.children);
	          }
	        }
	        return item;
	      });
	      return arr;
	    };
	
	    _this.getGroupList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var groupList;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              groupList = [];
	              _context.next = 3;
	              return (0, _budget.queryBudgetGroupList)({ isEnable: 1 }).then(function (res) {
	                if (res.statusCode === 200) {
	                  groupList = _this.formatGroup(res.data);
	                } else {
	                  _antd.message.error(res.message);
	                }
	              });
	
	            case 3:
	
	              _this.formatOption(groupList);
	
	            case 4:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.change = function (value) {
	      var companyAll = _this.state.companyAll;
	
	      var groupUuid = value;
	      var groupName = '';
	      companyAll.map(function (item) {
	        if (value === item.uuid) {
	          groupName = item.name;
	        }
	        return 1;
	      });
	      _this.props.onChange({ groupUuid: groupUuid, groupName: groupName });
	    };
	
	    _this.state = {
	      companyAll: []
	    };
	    return _this;
	  }
	
	  _createClass(Group, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getGroupList();
	    }
	
	    // 设置预算组下拉菜单
	
	
	    // 递归删除空的children
	
	
	    // 预算组列表
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var defaultValue = this.props.defaultValue;
	
	      if (defaultValue) {
	        return _react2.default.createElement(
	          _antd.Select,
	          {
	            mode: this.props.mode,
	            filterOption: function filterOption(input, option) {
	              return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	            },
	            style: { width: '100%' },
	            onChange: this.change,
	            defaultValue: defaultValue
	          },
	          this.state.companyAll.map(function (item) {
	            return _react2.default.createElement(
	              Option,
	              { key: item.uuid },
	              item.name
	            );
	          })
	        );
	      }
	      return _react2.default.createElement(
	        _antd.Select,
	        {
	          mode: this.props.mode,
	          filterOption: function filterOption(input, option) {
	            return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	          },
	          style: { width: '100%' },
	          onChange: this.change
	        },
	        this.state.companyAll.map(function (item) {
	          return _react2.default.createElement(
	            Option,
	            { key: item.uuid, value: item.uuid },
	            item.name
	          );
	        })
	      );
	    }
	  }]);
	
	  return Group;
	}(_react.Component);
	
	exports.default = Group;

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Editor = __webpack_require__(682);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommentItem = function CommentItem(_ref) {
	  var createTime = _ref.createTime,
	      fromName = _ref.fromName,
	      toName = _ref.toName,
	      isReply = _ref.isReply,
	      content = _ref.content,
	      children = _ref.children,
	      handleReply = _ref.handleReply,
	      uuid = _ref.uuid,
	      onSubmit = _ref.onSubmit,
	      onChange = _ref.onChange,
	      onMention = _ref.onMention,
	      submitting = _ref.submitting;
	  return _react2.default.createElement(
	    _antd.Comment,
	    {
	      className: 'comment-item',
	      author: _react2.default.createElement(
	        'a',
	        null,
	        toName ? _react2.default.createElement(
	          'span',
	          { className: 'name' },
	          '' + fromName,
	          _react2.default.createElement(
	            'span',
	            { className: 'reply' },
	            '\u56DE\u590D'
	          ),
	          '' + toName
	        ) : _react2.default.createElement(
	          'span',
	          { className: 'name' },
	          fromName
	        )
	      ),
	      datetime: _react2.default.createElement(
	        _antd.Tooltip,
	        { title: _moment2.default.unix(createTime / 1000).format('YYYY-MM-DD HH:mm:ss') },
	        _react2.default.createElement(
	          'span',
	          null,
	          _moment2.default.unix(createTime / 1000).fromNow()
	        )
	      ),
	      content: _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          null,
	          content
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'reply-stat' },
	          _react2.default.createElement(_antd.Icon, { type: 'edit' }),
	          isReply ? _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return handleReply(uuid);
	              } },
	            '\u53D6\u6D88\u56DE\u590D'
	          ) : _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return handleReply(uuid);
	              } },
	            '\u56DE\u590D'
	          )
	        ),
	        isReply ? _react2.default.createElement(
	          'div',
	          { className: 'reply-form' },
	          _react2.default.createElement(_Editor2.default, {
	            placeholder: '\u56DE\u590D' + fromName,
	            onSubmit: onSubmit,
	            onChange: onChange,
	            onMention: onMention,
	            submitting: submitting
	          })
	        ) : null
	      )
	    },
	    children
	  );
	};
	exports.default = CommentItem;

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _provinces = __webpack_require__(894);
	
	var _provinces2 = _interopRequireDefault(_provinces);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var region = function region(provinceCode, cityCode) {
	  var strProvince = '';
	  var strCity = '';
	  var city = [];
	  _provinces2.default.forEach(function (item) {
	    // eslint-disable-next-line eqeqeq
	    if (item.code == provinceCode) {
	      strProvince = item.name;
	      city = item.children;
	    }
	  });
	  city.forEach(function (item) {
	    // eslint-disable-next-line eqeqeq
	    if (item.value == cityCode) {
	      strCity = item.label;
	    }
	  });
	  return '' + strProvince + strCity;
	};
	
	exports.default = region;

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _req = __webpack_require__(32);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getBase64(img, callback) {
	  var reader = new FileReader();
	  reader.addEventListener('load', function () {
	    return callback(reader.result);
	  });
	  reader.readAsDataURL(img);
	}
	
	function beforeUpload(file) {
	  var isJPG = file.type === 'image/jpeg';
	  if (!isJPG) {
	    _antd.message.error('You can only upload JPG file!');
	  }
	  var isLt2M = file.size / 1024 / 1024 < 2;
	  if (!isLt2M) {
	    _antd.message.error('Image must smaller than 2MB!');
	  }
	  return isJPG && isLt2M;
	}
	
	var Avatar = function (_React$Component) {
	  _inherits(Avatar, _React$Component);
	
	  function Avatar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Avatar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Avatar.__proto__ || Object.getPrototypeOf(Avatar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      loading: false
	    }, _this.handleChange = function (info) {
	      if (info.file.status === 'uploading') {
	        _this.setState({ loading: true });
	        return;
	      }
	      if (info.file.status === 'done') {
	        // Get this url from response in real world.
	
	        _this.props.onChange(info.file.response.data[0].url);
	        getBase64(info.file.originFileObj, function (imageUrl) {
	          return _this.setState({
	            imageUrl: imageUrl,
	            loading: false
	          });
	        });
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Avatar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        imageUrl: nextProps.value
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var uploadButton = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Icon, { type: this.state.loading ? 'loading' : 'plus' })
	      );
	      var imageUrl = this.state.imageUrl;
	
	      return _react2.default.createElement(
	        _antd.Upload,
	        {
	          name: 'files',
	          showUploadList: false,
	          listType: 'picture-card',
	          className: 'avatar-uploader',
	          action: '' + _req.common.UPLOAD,
	          headers: {
	            Authorization: '' + _localDb2.default.get('token')
	          },
	          beforeUpload: beforeUpload,
	          onChange: this.handleChange
	        },
	        imageUrl ? _react2.default.createElement('img', { src: imageUrl, alt: 'avatar', style: { width: '102px', height: '102px' } }) : uploadButton
	      );
	    }
	  }]);
	
	  return Avatar;
	}(_react2.default.Component);
	
	exports.default = Avatar;

/***/ },
/* 1514 */
1442,
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Manage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Manage.__proto__ || Object.getPrototypeOf(Manage)).call.apply(_ref, [this].concat(args))), _this), _this.handleOk = function () {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.props.handleOk(values);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Manage, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          getFieldDecorator = _props.form.getFieldDecorator,
	          visible = _props.visible,
	          handleCancel = _props.handleCancel,
	          confirmLoading = _props.confirmLoading;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u5F00\u7968\u5BA1\u6838',
	          visible: visible,
	          okText: '\u901A\u8FC7',
	          onOk: this.handleOk,
	          confirmLoading: confirmLoading,
	          onCancel: function onCancel() {
	            return handleCancel(false);
	          }
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u53D1\u7968\u53F7\u7801' },
	            getFieldDecorator('codeNo', {
	              rules: [{ required: true, message: '请填写发票号码' }]
	            })(_react2.default.createElement(_antd.Input, null))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u9886\u7968\u4EBA' },
	            getFieldDecorator('receiver', {
	              rules: [{ required: true, message: '请填写领票人' }]
	            })(_react2.default.createElement(_antd.Input, null))
	          )
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _HOCWorkflow = __webpack_require__(326);
	
	var _HOCWorkflow2 = _interopRequireDefault(_HOCWorkflow);
	
	var _ModalInvoice = __webpack_require__(1515);
	
	var _ModalInvoice2 = _interopRequireDefault(_ModalInvoice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Opration = function (_Component) {
	  _inherits(Opration, _Component);
	
	  function Opration(props) {
	    _classCallCheck(this, Opration);
	
	    var _this = _possibleConstructorReturn(this, (Opration.__proto__ || Object.getPrototypeOf(Opration)).call(this, props));
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handleInvoice = function (params) {
	      var data = _this.props.data;
	
	      _this.props.doTask('next', '', Object.assign({}, params, { uuid: data.uuid }));
	      _this.handleVisible(false);
	    };
	
	    _this.handleNext = function () {
	      var _this$props = _this.props,
	          currentActivity = _this$props.data.instance.currentActivity,
	          doTask = _this$props.doTask;
	
	      if (currentActivity.name === '出纳办理') {
	        _this.handleVisible(true);
	      } else {
	        doTask('next');
	      }
	    };
	
	    _this.state = {
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Opration, [{
	    key: 'render',
	    value: function render() {
	      var visible = this.state.visible;
	      var _props = this.props,
	          currentActivity = _props.data.instance.currentActivity,
	          isLoading = _props.isLoading;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            icon: 'check',
	            type: 'primary',
	            onClick: this.handleNext,
	            style: { marginRight: 10 },
	            loading: isLoading || false
	          },
	          currentActivity.name === '出纳办理' ? '开票审核' : '通过'
	        ),
	        _react2.default.createElement(_ModalInvoice2.default, {
	          visible: visible,
	          handleOk: this.handleInvoice,
	          confirmLoading: isLoading || false,
	          handleCancel: this.handleVisible
	        })
	      );
	    }
	  }]);
	
	  return Opration;
	}(_react.Component);
	
	exports.default = (0, _HOCWorkflow2.default)(Opration);

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _attachment = __webpack_require__(27);
	
	var _UploadFileTable = __webpack_require__(192);
	
	var _UploadFileTable2 = _interopRequireDefault(_UploadFileTable);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var ModalAccount = function (_Component) {
	  _inherits(ModalAccount, _Component);
	
	  function ModalAccount(props) {
	    _classCallCheck(this, ModalAccount);
	
	    var _this2 = _possibleConstructorReturn(this, (ModalAccount.__proto__ || Object.getPrototypeOf(ModalAccount)).call(this, props));
	
	    _this2.formatList = function (arr) {
	      arr.map(function (item) {
	        item.label = item.name;
	        item.value = item.uuid;
	        item.children && _this2.formatList(item.children);
	        return item;
	      });
	    };
	
	    _this2.handleOk = function () {
	      var files = _this2.state.files;
	
	      var params = [];
	      _this2.props.form.validateFields(function (err, values) {
	        if (!err) {
	          files.map(function (item) {
	            var it = Object.assign({}, item);
	            it.scans = values['scans' + item.uuid];
	            it.no = values['no' + item.uuid];
	            it.isArchive = values['isArchive' + item.uuid];
	            it.endDate = values['endDate' + item.uuid] ? values['endDate' + item.uuid].format('yyyy-MM-DD') : null;
	            it.reminderDate = values['reminderDate' + item.uuid] ? values['reminderDate' + item.uuid].format('yyyy-MM-DD') : null;
	            if (it.delFiles.length > 0) {
	              it.delFiles.map(function (i) {
	                (0, _attachment.queryDeleteAttachment)({
	                  uuid: i.uuid || i.uid
	                }).then(function () {});
	                return i;
	              });
	            }
	            params.push(it);
	            return item;
	          });
	          _this2.props.handleOk(params);
	        }
	      });
	    };
	
	    _this2.fileRemove = function (item, file) {
	      item.delFiles.push(file);
	    };
	
	    _this2.renewalFilesItem = function (item) {
	      var _this2$props$form = _this2.props.form,
	          getFieldDecorator = _this2$props$form.getFieldDecorator,
	          getFieldValue = _this2$props$form.getFieldValue,
	          setFieldsValue = _this2$props$form.setFieldsValue;
	      var files = _this2.state.files;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              item.files.map(function (it) {
	                return _react2.default.createElement(
	                  'div',
	                  { key: it.url },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                        return (0, _attachment.queryFilePreview)(it);
	                      } },
	                    it.name
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            getFieldValue('isArchive' + item.uuid) ? _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px' } },
	              getFieldDecorator('no' + item.uuid)(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u586B\u5199\u6587\u4EF6\u7F16\u53F7' }))
	            ) : null
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px', paddingTop: '4px' } },
	              getFieldDecorator('scans' + item.uuid, {
	                initialValue: item.scans
	              })(_react2.default.createElement(_UploadFileTable2.default, {
	                type: 'ghost',
	                fileList: item.scans,
	                style: { width: '60%' },
	                onRemove: function onRemove(file) {
	                  return _this2.fileRemove(item, file);
	                },
	                isPreview: true
	              }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 2, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px', paddingTop: '4px' } },
	              getFieldDecorator('isArchive' + item.uuid, {
	                initialValue: item.isArchive,
	                valuePropName: 'checked'
	              })(_react2.default.createElement(_antd.Checkbox, {
	                onChange: function onChange(e) {
	                  if (files && files.length > 0) {
	                    files.forEach(function (it) {
	                      if (it.uuid !== item.uuid) {
	                        setFieldsValue(_defineProperty({}, 'isArchive' + it.uuid, !e.target.checked));
	                      }
	                    });
	                  }
	                }
	              }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            getFieldValue('isArchive' + item.uuid) && _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px', paddingTop: '4px' } },
	              getFieldDecorator('endDate' + item.uuid, {
	                initialValue: item.endDate ? (0, _moment2.default)(item.endDate) : null,
	                rules: [{ required: true, message: '提醒必填!' }]
	              })(_react2.default.createElement(_antd.DatePicker, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            getFieldValue('isArchive' + item.uuid) && _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px', paddingTop: '4px' } },
	              getFieldDecorator('reminderDate' + item.uuid, {
	                initialValue: item.reminderDate ? (0, _moment2.default)(item.reminderDate) : null,
	                rules: [{ required: true, message: '到期时间必填!' }]
	              })(_react2.default.createElement(_antd.DatePicker, null))
	            )
	          )
	        )
	      );
	    };
	
	    _this2.emptyInfo = function () {
	      var _this = _this2;
	      _antd.Modal.confirm({
	        icon: _react2.default.createElement(_antd.Icon, { type: 'login' }),
	        title: '没有需要归档的文件,点击确定直接通过',
	        onOk: function onOk() {
	          _this.handleOk();
	        },
	        onCancel: function onCancel() {
	          _this.props.handleCancel(false);
	        }
	      });
	    };
	
	    _this2.state = {
	      files: []
	    };
	    return _this2;
	  }
	
	  _createClass(ModalAccount, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var renewalFiles = this.props.renewalFiles;
	      var files = this.state.files;
	
	      renewalFiles && renewalFiles.map(function (item) {
	        item.delFiles = [];
	        files.push(item);
	        return 1;
	      });
	      this.setState({ files: files });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var renewalFiles = nextProps.renewalFiles;
	      var files = this.state.files;
	
	      if (renewalFiles.length !== this.props.renewalFiles.length) {
	        renewalFiles && renewalFiles.map(function (item) {
	          item.delFiles = [];
	          files.push(item);
	          return 1;
	        });
	        this.setState({ files: files });
	      }
	    }
	
	    /**
	     *文件删除
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          visible = _props.visible,
	          handleCancel = _props.handleCancel,
	          confirmLoading = _props.confirmLoading;
	      var files = this.state.files;
	
	      if (files.length) {
	        return _react2.default.createElement(
	          _antd.Modal,
	          {
	            title: '\u884C\u653F\u6587\u4EF6\u5F52\u6863',
	            visible: visible,
	            onOk: this.handleOk,
	            okText: '\u901A\u8FC7',
	            confirmLoading: confirmLoading,
	            onCancel: function onCancel() {
	              return handleCancel(false);
	            },
	            width: '65%'
	          },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '\u9644\u4EF6(\u7528\u7AE0\u540E)'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '\u6587\u4EF6\u7F16\u53F7'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 5, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '\u4E0A\u4F20\u626B\u63CF\u4EF6'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 2, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '\u662F\u5426\u5F52\u6863'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 4, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '\u5230\u671F\u65F6\u95F4'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 4, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '\u63D0\u9192\u65F6\u95F4'
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Form,
	            null,
	            files.map(function (item) {
	              return _this3.renewalFilesItem(item);
	            })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        visible ? this.emptyInfo() : null
	      );
	    }
	  }]);
	
	  return ModalAccount;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalAccount);

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _attachment = __webpack_require__(27);
	
	var _UploadFileTable = __webpack_require__(192);
	
	var _UploadFileTable2 = _interopRequireDefault(_UploadFileTable);
	
	var _reactRouter = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var ModalAccount = function (_Component) {
	  _inherits(ModalAccount, _Component);
	
	  function ModalAccount() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ModalAccount);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalAccount.__proto__ || Object.getPrototypeOf(ModalAccount)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      renewalFiles: [],
	      renewalFilesCount: 0
	    }, _this.handleOk = function () {
	      var renewalFiles = _this.props.renewalFiles;
	
	      var newRenewalFiles = [];
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          renewalFiles.map(function (item) {
	            item.scans = values['scans' + (item.uuid || item.id)];
	            newRenewalFiles.push({
	              uuid: item.uuid,
	              name: values['name' + (item.uuid || item.id)],
	              scans: item.scans
	            });
	
	            if (item.delFiles && item.delFiles.length > 0) {
	              item.delFiles.map(function (i) {
	                (0, _attachment.queryDeleteAttachment)({
	                  uuid: i.uuid || i.uid
	                }).then(function () {});
	                return i;
	              });
	            }
	            return item;
	          });
	
	          _this.props.handleOk({ renewalFiles: newRenewalFiles });
	        }
	      });
	    }, _this.deleteEffects = function (id) {
	      var renewalFiles = _this.state.renewalFiles;
	
	      _this.setState({
	        renewalFiles: renewalFiles.filter(function (item) {
	          return item.id !== id;
	        })
	      });
	    }, _this.addEffects = function () {
	      var _this$state = _this.state,
	          renewalFiles = _this$state.renewalFiles,
	          renewalFilesCount = _this$state.renewalFilesCount;
	
	      renewalFiles.push({ id: renewalFilesCount });
	      _this.setState({
	        renewalFiles: renewalFiles,
	        renewalFilesCount: renewalFilesCount + 1
	      });
	    }, _this.fileRemove = function (item, file) {
	      item.delFiles.push(file);
	    }, _this.scansColumns = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return [{
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name',
	        width: '50%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('name' + (record.uuid || record.id), {
	              rules: [{ required: !record.uuid, message: '请填写文件名称' }]
	            })(!record.uuid ? _react2.default.createElement(_antd.Input, null) : _react2.default.createElement(
	              'span',
	              null,
	              record.name || '暂无名称'
	            ))
	          );
	        }
	      }, {
	        title: '扫描件',
	        dataIndex: 'scans',
	        key: 'scans',
	        width: '50%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('scans' + (record.uuid || record.id), {
	              rules: [{ required: record.isReturn, message: '请上传扫描件' }],
	              initialValue: record.scans
	            })(_react2.default.createElement(_UploadFileTable2.default, {
	              type: 'ghost',
	              fileList: record.file,
	              onRemove: function onRemove(file) {
	                return _this.fileRemove(record, file);
	              },
	              isPreview: true
	            }))
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'action',
	        key: 'action',
	        width: '50%',
	        render: function render(text, record) {
	          return !record.uuid && _react2.default.createElement(
	            'div',
	            { style: { margin: 0, height: '45px' } },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { onClick: function onClick() {
	                  return _this.deleteEffects(record.id);
	                } },
	              '\u5220\u9664'
	            )
	          );
	        }
	      }];
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ModalAccount, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var renewalFiles = this.props.renewalFiles;
	
	      if (renewalFiles && renewalFiles.length) {
	        renewalFiles.map(function (item) {
	          item.id = item.uuid;
	          return 1;
	        });
	        this.setState({
	          renewalFiles: renewalFiles,
	          renewalFilesCount: renewalFiles.length
	        });
	      }
	    }
	
	    /**
	     *文件删除
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          visible = _props.visible,
	          handleCancel = _props.handleCancel,
	          confirmLoading = _props.confirmLoading;
	      var renewalFiles = this.state.renewalFiles;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u4E0A\u4F20\u626B\u63CF\u4EF6\uFF08\u7528\u7AE0\u540E\uFF09',
	          visible: visible,
	          onOk: this.handleOk,
	          okText: '\u901A\u8FC7',
	          confirmLoading: confirmLoading,
	          onCancel: function onCancel() {
	            return handleCancel(false);
	          },
	          width: '40%'
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(_antd.Table, {
	            columns: this.scansColumns(),
	            dataSource: renewalFiles,
	            pagination: false,
	            rowKey: function rowKey(record) {
	              return record.uuid;
	            }
	          }),
	          _react2.default.createElement(
	            _antd.Button,
	            { onClick: this.addEffects, style: { width: '100%', borderStyle: 'dashed' } },
	            '+\u6DFB\u52A0\u9644\u4EF6'
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalAccount;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalAccount);

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _HOCWorkflow = __webpack_require__(326);
	
	var _HOCWorkflow2 = _interopRequireDefault(_HOCWorkflow);
	
	var _ModalScanUpload = __webpack_require__(1518);
	
	var _ModalScanUpload2 = _interopRequireDefault(_ModalScanUpload);
	
	var _ModalArchiveUpload = __webpack_require__(1517);
	
	var _ModalArchiveUpload2 = _interopRequireDefault(_ModalArchiveUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Opration = function (_Component) {
	  _inherits(Opration, _Component);
	
	  function Opration(props) {
	    _classCallCheck(this, Opration);
	
	    var _this = _possibleConstructorReturn(this, (Opration.__proto__ || Object.getPrototypeOf(Opration)).call(this, props));
	
	    _this.handleScanVisible = function (flag) {
	      _this.setState({
	        scanVisible: !!flag
	      });
	    };
	
	    _this.handleRenewalScan = function (params) {
	      var data = _this.props.data;
	
	      _this.props.doTask('nextScan', '', Object.assign({}, params, { uuid: data.uuid }));
	      _this.handleScanVisible(false);
	    };
	
	    _this.handleArchiveVisible = function (flag) {
	      _this.setState({
	        archiveVisible: !!flag
	      });
	    };
	
	    _this.handleRenewalArchive = function (params) {
	      var data = _this.props.data;
	
	      _this.props.doTask('nextArchive', '', { archiveFiles: params, uuid: data.uuid });
	      _this.handleArchiveVisible(true);
	    };
	
	    _this.handleNext = function () {
	      var _this$props = _this.props,
	          currentActivity = _this$props.data.instance.currentActivity,
	          doTask = _this$props.doTask;
	
	      if (currentActivity.name === '经办人提交扫描件') {
	        _this.handleScanVisible(true);
	      } else if (currentActivity.name === '行政归档') {
	        _this.handleArchiveVisible(true);
	      } else {
	        doTask('next');
	      }
	    };
	
	    _this.state = {
	      scanVisible: false,
	      archiveVisible: false
	    };
	    return _this;
	  }
	
	  // 用章-经办人提交扫描件
	
	
	  // 用章-行政文件归档
	
	
	  _createClass(Opration, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          scanVisible = _state.scanVisible,
	          archiveVisible = _state.archiveVisible;
	      var _props = this.props,
	          data = _props.data,
	          currentActivity = _props.data.instance.currentActivity,
	          isLoading = _props.isLoading;
	
	      var nextText = '通过';
	      if (currentActivity.name === '经办人提交扫描件') {
	        nextText = '上传扫描件';
	      } else if (currentActivity.name === '行政归档') {
	        nextText = '文件归档';
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            icon: 'check',
	            type: 'primary',
	            onClick: this.handleNext,
	            style: { marginRight: 10 },
	            loading: isLoading || false
	          },
	          nextText
	        ),
	        _react2.default.createElement(_ModalScanUpload2.default, {
	          visible: scanVisible,
	          confirmLoading: isLoading || false,
	          handleOk: this.handleRenewalScan,
	          handleCancel: this.handleScanVisible,
	          renewalFiles: data.renewalFiles || []
	        }),
	        _react2.default.createElement(_ModalArchiveUpload2.default, {
	          visible: archiveVisible,
	          confirmLoading: isLoading || false,
	          handleOk: this.handleRenewalArchive,
	          handleCancel: this.handleArchiveVisible,
	          renewalFiles: data.renewalFiles || []
	        })
	      );
	    }
	  }]);
	
	  return Opration;
	}(_react.Component);
	
	exports.default = (0, _HOCWorkflow2.default)(Opration);

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _material = __webpack_require__(50);
	
	var _attachment = __webpack_require__(27);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _UploadFileTable = __webpack_require__(192);
	
	var _UploadFileTable2 = _interopRequireDefault(_UploadFileTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var ModalAccount = function (_Component) {
	  _inherits(ModalAccount, _Component);
	
	  function ModalAccount(props) {
	    _classCallCheck(this, ModalAccount);
	
	    var _this2 = _possibleConstructorReturn(this, (ModalAccount.__proto__ || Object.getPrototypeOf(ModalAccount)).call(this, props));
	
	    _this2.getDatabaseList = function () {
	      (0, _material.queryMaterialDatabaseList)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            databaseList: res.data || []
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.handleDatabaseChange = function (item, value) {
	      item.databaseUuid = value;
	      _this2.getDirectoryList(item.databaseUuid);
	      _this2.getDatabaseType(item.databaseUuid);
	      _this2.props.form.resetFields(['directoryUuid' + item.uuid, 'materialType' + item.uuid]);
	    };
	
	    _this2.getDirectoryList = function (uuid) {
	      var returnEffect = _this2.state.returnEffect;
	
	      (0, _material.queryMaterialDirectoryList)({
	        databaseUuid: uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          returnEffect.map(function (item) {
	            if (item.databaseUuid === uuid) {
	              _this2.formatList(res.data);
	              item.directoryList = res.data;
	            }
	            return item;
	          });
	          _this2.setState({ returnEffect: returnEffect });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.getDatabaseType = function (uuid) {
	      var returnEffect = _this2.state.returnEffect;
	
	      (0, _material.queryMaterialDatabaseType)({
	        databaseUuid: uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          returnEffect.map(function (item) {
	            if (item.databaseUuid === uuid) {
	              item.types = res.data;
	            }
	            return item;
	          });
	          _this2.setState({ returnEffect: returnEffect });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.formatList = function (arr) {
	      arr.map(function (item) {
	        item.label = item.name;
	        item.value = item.uuid;
	        item.children && _this2.formatList(item.children);
	        return item;
	      });
	    };
	
	    _this2.handleOk = function () {
	      var _this2$state = _this2.state,
	          returnEffect = _this2$state.returnEffect,
	          databaseList = _this2$state.databaseList;
	
	      var params = [];
	      _this2.props.form.validateFields(function (err, values) {
	        if (!err) {
	          returnEffect.map(function (item) {
	            var it = Object.assign({}, item);
	            if (it.isReturn) {
	              it.no = values['no' + item.uuid];
	              it.databaseUuid = values['databaseUuid' + item.uuid];
	              databaseList.map(function (i) {
	                if (i.uuid === it.databaseUuid) {
	                  it.databaseName = i.name;
	                }
	                return i;
	              });
	              it.directoryUuid = item.directoryUuid;
	              it.directory = item.directory;
	              it.materialType = values['materialType' + item.uuid];
	              it.returnDate = values['returnDate' + item.uuid].format('YYYY-MM-DD');
	              it.companyUuid = values['companyUuid' + item.id];
	              it.company = values['company' + item.id];
	            }
	            it.scans = values['scans' + item.uuid];
	            if (it.delFiles.length > 0) {
	              it.delFiles.map(function (i) {
	                (0, _attachment.queryDeleteAttachment)({
	                  uuid: i.uuid || i.uid
	                }).then(function () {});
	                return i;
	              });
	            }
	            params.push(it);
	            return item;
	          });
	          _this2.props.handleOk(params);
	        }
	      });
	    };
	
	    _this2.onChange = function (uuid, value, selectedOptions) {
	      var returnEffect = _this2.state.returnEffect;
	
	      returnEffect.map(function (item) {
	        if (item.uuid === uuid) {
	          item.directoryUuid = selectedOptions[selectedOptions.length - 1].uuid;
	          item.directory = selectedOptions[selectedOptions.length - 1].name;
	        }
	        return item;
	      });
	      _this2.setState({ returnEffect: returnEffect });
	    };
	
	    _this2.showLable = function (label) {
	      var text = label[label.length - 1];
	      return text;
	    };
	
	    _this2.handleCompanyChange = function (id, value, option) {
	      _this2.props.form.setFieldsValue(_defineProperty({}, 'company' + id, option ? option.props.children : ''));
	    };
	
	    _this2.fileRemove = function (item, file) {
	      item.delFiles.push(file);
	    };
	
	    _this2.effectItem = function (item) {
	      var getFieldDecorator = _this2.props.form.getFieldDecorator;
	
	      getFieldDecorator('company' + item.id);
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 2, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              item.files.map(function (it) {
	                return _react2.default.createElement(
	                  'div',
	                  { key: it.url },
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                        return (0, _attachment.queryFilePreview)(it);
	                      } },
	                    it.name
	                  )
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 2, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            item.isReturn ? _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px' } },
	              getFieldDecorator('no' + item.uuid)(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u586B\u5199\u6587\u4EF6\u7F16\u53F7' }))
	            ) : null
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            item.isReturn ? _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px' } },
	              getFieldDecorator('databaseUuid' + item.uuid, {
	                rules: [{ required: true, message: '请填写资料库' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  onChange: function onChange(value) {
	                    return _this2.handleDatabaseChange(item, value);
	                  },
	                  style: { width: '100%' },
	                  placeholder: '\u8D44\u6599\u5E93\u9009\u62E9'
	                },
	                _this2.state.databaseList && _this2.state.databaseList.map(function (it) {
	                  return _react2.default.createElement(
	                    _antd.Select.Option,
	                    { value: it.uuid, key: it.uuid },
	                    it.name
	                  );
	                })
	              ))
	            ) : null
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            item.isReturn ? _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px' } },
	              getFieldDecorator('companyUuid' + item.id, {
	                rules: [{ required: true, message: '请选择用章公司' }],
	                initialValue: item.companyUuid
	              })(_react2.default.createElement(_companySearch2.default, Object.assign({
	                companyName: item.company,
	                companyUuid: item.companyUuid,
	                onChange: function onChange(value, option) {
	                  return _this2.handleCompanyChange(item.id, value, option);
	                }
	              }, _this2.props)))
	            ) : null
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            item.isReturn ? _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px' } },
	              getFieldDecorator('directoryUuid' + item.uuid, {
	                rules: [{ required: true, message: '请选择所属目录' }]
	              })(_react2.default.createElement(_antd.Cascader, {
	                changeOnSelect: true,
	                onChange: function onChange(value, selectedOptions) {
	                  return _this2.onChange(item.uuid, value, selectedOptions);
	                },
	                options: item.directoryList,
	                placeholder: '\u8BF7\u9009\u62E9\u6240\u5C5E\u76EE\u5F55',
	                displayRender: _this2.showLable
	              }))
	            ) : null
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 2, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            item.isReturn ? _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px' } },
	              getFieldDecorator('materialType' + item.uuid, {
	                rules: [{ required: true, message: '请选择所属类型' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                { style: { width: '100%' }, placeholder: '\u6240\u5C5E\u7C7B\u578B\u9009\u62E9' },
	                item.types && item.types.map(function (it) {
	                  return _react2.default.createElement(
	                    _antd.Select.Option,
	                    { value: it.name, key: it.name },
	                    it.name
	                  );
	                })
	              ))
	            ) : null
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 1, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            item.isReturn ? _react2.default.createElement(
	              'span',
	              { style: { height: '30px', lineHeight: '30px' } },
	              item.returnCount
	            ) : null
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 2, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            item.isReturn ? _react2.default.createElement(
	              'span',
	              { style: { height: '30px', lineHeight: '30px' } },
	              (0, _moment2.default)(item.returnExpectedDate).format('YYYY-MM-DD')
	            ) : _react2.default.createElement(
	              'span',
	              { style: { height: '30px', lineHeight: '30px' } },
	              '\u4E0D\u9700\u8981\u5F52\u6863'
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            item.isReturn ? _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px' } },
	              getFieldDecorator('returnDate' + item.uuid, {
	                rules: [{ required: true, message: '请填写实际归档时间' }]
	              })(_react2.default.createElement(_antd.DatePicker, null))
	            ) : null
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	            _react2.default.createElement(
	              FormItem,
	              { style: { margin: 0, height: '60px', paddingTop: '4px' } },
	              getFieldDecorator('scans' + item.uuid, {
	                initialValue: item.scans
	              })(_react2.default.createElement(_UploadFileTable2.default, {
	                type: 'ghost',
	                fileList: item.scans,
	                style: { width: '60%' },
	                onRemove: function onRemove(file) {
	                  return _this2.fileRemove(item, file);
	                },
	                isPreview: true
	              }))
	            )
	          )
	        )
	      );
	    };
	
	    _this2.emptyInfo = function () {
	      var _this = _this2;
	      _antd.Modal.confirm({
	        icon: _react2.default.createElement(_antd.Icon, { type: 'login' }),
	        title: '没有需要归档的文件,点击确定直接通过',
	        onOk: function onOk() {
	          _this.handleOk();
	        },
	        onCancel: function onCancel() {
	          _this.props.handleCancel(false);
	        }
	      });
	    };
	
	    _this2.state = {
	      returnEffect: []
	    };
	    return _this2;
	  }
	
	  _createClass(ModalAccount, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var effect = this.props.effect;
	      var returnEffect = this.state.returnEffect;
	
	      effect && effect.map(function (item) {
	        item.delFiles = [];
	        returnEffect.push(item);
	        return 1;
	      });
	      this.setState({ returnEffect: returnEffect });
	      this.getDatabaseList();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var effect = nextProps.effect;
	      var returnEffect = this.state.returnEffect;
	
	      if (effect.length !== this.props.effect.length) {
	        effect && effect.map(function (item) {
	          item.delFiles = [];
	          returnEffect.push(item);
	          return 1;
	        });
	        this.setState({ returnEffect: returnEffect });
	      }
	    }
	
	    // 资料库列表
	
	
	    // 资料目录列表
	
	
	    // 获取资料类型
	
	
	    /**
	     *文件删除
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          visible = _props.visible,
	          handleCancel = _props.handleCancel,
	          confirmLoading = _props.confirmLoading;
	      var returnEffect = this.state.returnEffect;
	
	      if (returnEffect.length) {
	        return _react2.default.createElement(
	          _antd.Modal,
	          {
	            title: '\u884C\u653F\u6587\u4EF6\u5F52\u6863',
	            visible: visible,
	            onOk: this.handleOk,
	            okText: '\u901A\u8FC7',
	            confirmLoading: confirmLoading,
	            onCancel: function onCancel() {
	              return handleCancel(false);
	            },
	            width: '95%'
	          },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 2, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '\u9644\u4EF6(\u7528\u7AE0\u540E)'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 2, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '\u6587\u4EF6\u7F16\u53F7'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '*\u5F52\u5C5E\u8D44\u6599\u5E93'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '*\u5F52\u5C5E\u516C\u53F8'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '*\u5F52\u5C5E\u76EE\u5F55'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 2, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '*\u5F52\u5C5E\u7C7B\u578B'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 1, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '\u5F52\u6863\u6570\u91CF'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 2, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '\u9884\u8BA1\u5F52\u6863\u65F6\u95F4'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '*\u5B9E\u9645\u5F52\u6863\u65F6\u95F4'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 3, style: { paddingLeft: '10px', paddingRight: '10px' } },
	              '\u4E0A\u4F20\u626B\u63CF\u4EF6'
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Form,
	            null,
	            returnEffect.map(function (item) {
	              return _this3.effectItem(item);
	            })
	          )
	        );
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        visible ? this.emptyInfo() : null
	      );
	    }
	  }]);
	
	  return ModalAccount;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalAccount);

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _attachment = __webpack_require__(27);
	
	var _UploadFileTable = __webpack_require__(192);
	
	var _UploadFileTable2 = _interopRequireDefault(_UploadFileTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var ModalAccount = function (_Component) {
	  _inherits(ModalAccount, _Component);
	
	  function ModalAccount() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ModalAccount);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalAccount.__proto__ || Object.getPrototypeOf(ModalAccount)).call.apply(_ref, [this].concat(args))), _this), _this.handleOk = function () {
	      var effects = _this.props.effects;
	
	      var newEffects = [];
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          effects.map(function (item) {
	            item.scans = values['scans' + item.uuid];
	            newEffects.push({
	              uuid: item.uuid,
	              scans: item.scans
	            });
	
	            if (item.delFiles.length > 0) {
	              item.delFiles.map(function (i) {
	                (0, _attachment.queryDeleteAttachment)({
	                  uuid: i.uuid || i.uid
	                }).then(function () {});
	                return i;
	              });
	            }
	            return item;
	          });
	
	          _this.props.handleOk({ effects: newEffects });
	        }
	      });
	    }, _this.fileRemove = function (item, file) {
	      item.delFiles.push(file);
	    }, _this.scansColumns = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return [{
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name',
	        width: '50%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            { style: { margin: 0, height: '60px' } },
	            getFieldDecorator('name' + record.uuid)(_react2.default.createElement(
	              'span',
	              null,
	              record.name || '暂无名称'
	            ))
	          );
	        }
	      }, {
	        title: '扫描件',
	        dataIndex: 'scans',
	        key: 'scans',
	        width: '50%',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('scans' + record.uuid, {
	              rules: [{ required: record.isReturn, message: '请上传扫描件' }],
	              initialValue: record.scans
	            })(_react2.default.createElement(_UploadFileTable2.default, {
	              type: 'ghost',
	              fileList: record.file,
	              onRemove: function onRemove() {
	                return _this.fileRemove(record);
	              },
	              isPreview: true
	            }))
	          );
	        }
	      }];
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  /**
	   *文件删除
	   */
	
	
	  _createClass(ModalAccount, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          visible = _props.visible,
	          handleCancel = _props.handleCancel,
	          effects = _props.effects,
	          confirmLoading = _props.confirmLoading;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u4E0A\u4F20\u626B\u63CF\u4EF6\uFF08\u7528\u7AE0\u540E\uFF09',
	          visible: visible,
	          onOk: this.handleOk,
	          okText: '\u901A\u8FC7',
	          confirmLoading: confirmLoading,
	          onCancel: function onCancel() {
	            return handleCancel(false);
	          },
	          width: '40%'
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(_antd.Table, {
	            columns: this.scansColumns(),
	            dataSource: effects,
	            pagination: false,
	            rowKey: function rowKey(record) {
	              return record.uuid;
	            }
	          })
	        )
	      );
	    }
	  }]);
	
	  return ModalAccount;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalAccount);

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _HOCWorkflow = __webpack_require__(326);
	
	var _HOCWorkflow2 = _interopRequireDefault(_HOCWorkflow);
	
	var _ModalScanUpload = __webpack_require__(1521);
	
	var _ModalScanUpload2 = _interopRequireDefault(_ModalScanUpload);
	
	var _ModalArchiveUpload = __webpack_require__(1520);
	
	var _ModalArchiveUpload2 = _interopRequireDefault(_ModalArchiveUpload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Opration = function (_Component) {
	  _inherits(Opration, _Component);
	
	  function Opration(props) {
	    _classCallCheck(this, Opration);
	
	    var _this = _possibleConstructorReturn(this, (Opration.__proto__ || Object.getPrototypeOf(Opration)).call(this, props));
	
	    _this.handleScanVisible = function (flag) {
	      _this.setState({
	        scanVisible: !!flag
	      });
	    };
	
	    _this.handleSealScan = function (params) {
	      var data = _this.props.data;
	
	      _this.props.doTask('nextScan', '', Object.assign({}, params, { uuid: data.uuid }));
	      _this.handleScanVisible(false);
	    };
	
	    _this.handleArchiveVisible = function (flag) {
	      _this.setState({
	        archiveVisible: !!flag
	      });
	    };
	
	    _this.handleSealArchive = function (params) {
	      var data = _this.props.data;
	
	      _this.props.doTask('nextArchive', '', { returns: params, uuid: data.uuid });
	      _this.handleArchiveVisible(true);
	    };
	
	    _this.handleNext = function () {
	      var _this$props = _this.props,
	          currentActivity = _this$props.data.instance.currentActivity,
	          doTask = _this$props.doTask;
	
	
	      if (currentActivity.name === '经办人提交扫描件') {
	        _this.handleScanVisible(true);
	      } else if (currentActivity.name === '行政归档') {
	        _this.handleArchiveVisible(true);
	      } else {
	        doTask('next');
	      }
	    };
	
	    _this.state = {
	      scanVisible: false,
	      archiveVisible: false
	    };
	    return _this;
	  }
	
	  // 用章-经办人提交扫描件
	
	
	  // 用章-行政文件归档
	
	
	  _createClass(Opration, [{
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          scanVisible = _state.scanVisible,
	          archiveVisible = _state.archiveVisible;
	      var _props = this.props,
	          data = _props.data,
	          currentActivity = _props.data.instance.currentActivity,
	          isLoading = _props.isLoading;
	
	      var nextText = '通过';
	      if (currentActivity.name === '经办人提交扫描件') {
	        nextText = '上传扫描件';
	      } else if (currentActivity.name === '行政归档') {
	        nextText = '文件归档';
	      }
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            icon: 'check',
	            type: 'primary',
	            onClick: this.handleNext,
	            style: { marginRight: 10 },
	            loading: isLoading || false
	          },
	          nextText
	        ),
	        _react2.default.createElement(_ModalScanUpload2.default, {
	          visible: scanVisible,
	          confirmLoading: isLoading || false,
	          handleOk: this.handleSealScan,
	          handleCancel: this.handleScanVisible,
	          effects: data.effects || []
	        }),
	        _react2.default.createElement(_ModalArchiveUpload2.default, {
	          visible: archiveVisible,
	          confirmLoading: isLoading || false,
	          handleOk: this.handleSealArchive,
	          handleCancel: this.handleArchiveVisible,
	          effect: data.effects || []
	        })
	      );
	    }
	  }]);
	
	  return Opration;
	}(_react.Component);
	
	exports.default = (0, _HOCWorkflow2.default)(Opration);

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _crm = __webpack_require__(33);
	
	var _ModalBusiness = __webpack_require__(1524);
	
	var _ModalBusiness2 = _interopRequireDefault(_ModalBusiness);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.saveBusiness = function (params) {
	      (0, _crm.querySaveBusiness)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getBusiness();
	          _this.handleModalVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getBusiness = function (pageNo) {
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      _this.setState({
	        pageNo: current
	      });
	      (0, _crm.queryBusinessList)({
	        condition: _this.condition || '',
	        type: _this.type || '',
	        start: current
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.getMyDepartment = function () {
	      (0, _crm.queryDepartmentMy)().then(function (res) {
	        if (res.statusCode === 200) {
	          var uuid = res.data.uuid;
	
	          _this.getStage(uuid);
	          _this.getMyCustom(uuid);
	        }
	      });
	    };
	
	    _this.getMyCustom = function () {
	      (0, _crm.queryCustomDepartmentList)().then(function (res) {
	        _this.setState({
	          custom: res.data.customs
	        });
	      });
	    };
	
	    _this.getStage = function (uuid) {
	      (0, _crm.queryDepartmentOpportunity)({
	        uuid: uuid
	      }).then(function (res) {
	        _this.setState({
	          stage: res.data
	        });
	      });
	    };
	
	    _this.handleModalVisible = function (flag, uuid) {
	      _this.uuid = uuid;
	      _this.setState({
	        modalVisible: !!flag
	      });
	    };
	
	    _this.handleModalEditVisible = function (flag, uuid) {
	      _this.uuid = uuid;
	    };
	
	    _this.handleSubmit = function (params) {
	      _this.saveBusiness(params);
	    };
	
	    _this.handleSearch = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      _this.props.form.validateFields(function (err, values) {
	        _this.condition = values.condition;
	        _this.getBusiness(1);
	      });
	    };
	
	    _this.handleFormReset = function (e) {
	      e.preventDefault();
	      _this.props.form.resetFields();
	      _this.condition = '';
	      _this.getBusiness(1);
	    };
	
	    _this.handleChange = function (e) {
	      var value = e.target.value;
	
	      _this.type = value === 'all' ? '' : value;
	      _this.getBusiness(1);
	    };
	
	    _this.renderSearchForm = function () {
	      var stage = _this.state.stage;
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', onSubmit: _this.handleSearch },
	        _react2.default.createElement(
	          FormItem,
	          { label: '\u9636\u6BB5' },
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _antd.Radio.Group,
	              { defaultValue: 'a', buttonStyle: 'solid', onChange: _this.handleChange },
	              _react2.default.createElement(
	                _antd.Radio.Button,
	                { value: 'all' },
	                '\u5168\u90E8'
	              ),
	              stage.map(function (item) {
	                return _react2.default.createElement(
	                  _antd.Radio.Button,
	                  { value: item.name, key: item.name },
	                  item.name
	                );
	              })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          { gutter: { md: 8, lg: 24, xl: 48 }, style: { minWidth: '650px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24, style: { minWidth: '400px' } },
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u5BA2\u6237\u540D\u79F0' },
	              getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165', style: { minWidth: '200px' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              'span',
	              { className: 'submitButtons' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit' },
	                '\u67E5\u8BE2'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: 8 }, onClick: _this.handleFormReset },
	                '\u91CD\u7F6E'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '编号',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.handleModalVisible(true, record.uuid);
	              } },
	            index + 1
	          );
	        }
	      }, {
	        title: '客户名称',
	        dataIndex: 'customerName'
	      }, {
	        title: '阶段',
	        dataIndex: 'type'
	      }, {
	        title: '预测百分比',
	        dataIndex: 'percentage'
	      }, {
	        title: '预测金额',
	        dataIndex: 'prediction'
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      pageNo: 1,
	      stage: [],
	      total: 0,
	      custom: [],
	      modalVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getMyDepartment();
	      this.getBusiness();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          modalVisible = _state.modalVisible,
	          stage = _state.stage,
	          custom = _state.custom,
	          total = _state.total,
	          pageNo = _state.pageNo;
	
	      var parentProps = {
	        handleModalVisible: this.handleModalVisible,
	        handleSubmit: this.handleSubmit,
	        stage: stage,
	        custom: custom,
	        uuid: this.uuid
	      };
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.getBusiness(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListForm' },
	            this.renderSearchForm()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: function onClick() {
	                  return _this2.handleModalVisible(true);
	                } },
	              '\u6DFB\u52A0'
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        }),
	        modalVisible ? _react2.default.createElement(_ModalBusiness2.default, parentProps) : null
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _crm = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.getBusiness = function () {
	      (0, _crm.queryBusinessInfo)({
	        uuid: _this.props.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            detail: res.data
	          });
	        }
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handleSubmit = _this.props.handleSubmit;
	      var detail = _this.state.detail;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = {
	            customer: values.customerObj.split('-')[0],
	            customerName: values.customerObj.split('-')[1],
	            type: values.stageObj.split('-')[0],
	            percentage: values.stageObj.split('-')[1],
	            prediction: values.prediction
	          };
	
	          if (detail.uuid) {
	            params.uuid = detail.uuid;
	          }
	          handleSubmit(params);
	        }
	      });
	    };
	
	    _this.state = {
	      detail: {}
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.uuid) {
	        this.getBusiness();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var ItemLayout2 = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      var _props = this.props,
	          handleModalVisible = _props.handleModalVisible,
	          custom = _props.custom,
	          stage = _props.stage;
	      var detail = this.state.detail;
	
	      var isEdit = !!detail.uuid;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: detail.uuid ? '编辑商机' : '新增商机',
	          visible: true,
	          onCancel: function onCancel() {
	            return handleModalVisible(false);
	          },
	          onOk: this.submit
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.submit },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5BA2\u6237\u540D\u79F0' }, ItemLayout2),
	                getFieldDecorator('customerObj', {
	                  rules: [{ required: true, message: '请选择客户!' }],
	                  initialValue: detail.customer ? detail.customer + '-' + detail.customerName : ''
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { disabled: isEdit },
	                  custom.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.uuid + '-' + item.name },
	                      item.name
	                    );
	                  })
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u9636\u6BB5\u7C7B\u578B' }, ItemLayout2),
	                getFieldDecorator('stageObj', {
	                  rules: [{ required: true, message: '请选择联阶段类型!' }],
	                  initialValue: detail.type ? detail.type + '-' + detail.percentage : ''
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  null,
	                  stage.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      {
	                        key: item.name + '-' + item.percentage
	                      },
	                      item.name + '(' + item.percentage + '%)'
	                    );
	                  })
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u9884\u6D4B\u91D1\u989D' }, ItemLayout2),
	                getFieldDecorator('prediction', {
	                  rules: [{ required: true, message: '请输入预测金额!' }],
	                  initialValue: detail.prediction
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1523);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = {
	  path: "business",
	  breadcrumbName: "商机管理",
	  childRoutes: [{
	    path: "list",
	    breadcrumbName: "商机列表",
	    indexRoute: {
	      component: _Index2.default
	    }
	  }]
	}; /**
	    * routers
	    * 更多关于Router的使用，请参考以下教程
	    * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
	    */
	
	exports.default = router;

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BackBtn = __webpack_require__(12);
	
	var _crm = __webpack_require__(33);
	
	var _cascaderAddressOptions = __webpack_require__(429);
	
	var _cascaderAddressOptions2 = _interopRequireDefault(_cascaderAddressOptions);
	
	var _SelectUser = __webpack_require__(325);
	
	var _SelectUser2 = _interopRequireDefault(_SelectUser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	var RadioGroup = _antd.Radio.Group;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.loadCategory = function (selectedOptions) {
	      var targetOption = selectedOptions[selectedOptions.length - 1];
	      targetOption.loading = true;
	
	      (0, _crm.queryCustomCategory)(targetOption.value).then(function (req) {
	        if (req.statusCode === 200) {
	          targetOption.loading = false;
	          targetOption.children = req.data;
	        }
	      });
	    };
	
	    _this.chaneCategory = function (value) {
	      if (value.length > 0) {
	        _this.props.form.setFieldsValue({
	          category1: value[0],
	          category2: value[1]
	        });
	      }
	    };
	
	    _this.chaneRegion = function (value) {
	      if (value.length > 0) {
	        _this.props.form.setFieldsValue({ province: value[0], city: value[1] });
	      }
	    };
	
	    _this.changeOrderUser = function (value, selectedOptions) {
	      _this.props.form.setFieldsValue({
	        orderName: selectedOptions.props.children
	      });
	    };
	
	    _this.changeRecommendUser = function (value, selectedOptions) {
	      _this.props.form.setFieldsValue({
	        recommendName: selectedOptions.props.children
	      });
	    };
	
	    _this.changeManagerUser = function (value, selectedOptions) {
	      _this.props.form.setFieldsValue({
	        managerName: selectedOptions.props.children
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handleSubmit = _this$props.handleSubmit,
	          data = _this$props.data;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          if (data && data.uuid) {
	            values.uuid = data.uuid;
	          }
	
	          values.establishedDate = values.establishedDate ? values.establishedDate.format('YYYY-MM-DD') : undefined;
	          handleSubmit(values);
	        }
	      });
	    };
	
	    _this.changeType = function () {
	      // TODO 当是个人时隐去一些信息
	    };
	
	    _this.state = {
	      category: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _crm.queryCustomCategory)().then(function (res) {
	        if (res.statusCode === 200) {
	          var data = res.data.map(function (item) {
	            item.isLeaf = false;
	            return item;
	          });
	          _this2.setState({
	            category: data
	          });
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      var key = nextProps.data.category1;
	      if (!key) {
	        return false;
	      }
	      (0, _crm.queryCustomCategory)().then(function (res) {
	        if (res.statusCode === 200) {
	          var data = res.data.map(function (item) {
	            item.isLeaf = false;
	            return item;
	          });
	          if (!key) {
	            _this3.setState({
	              category: data
	            });
	            return;
	          }
	          (0, _crm.queryCustomCategory)(key).then(function (result) {
	            if (result.statusCode === 200) {
	              data.map(function (item) {
	                if (item.key === key) {
	                  item.children = result.data;
	                }
	                return item;
	              });
	              _this3.setState({
	                category: data
	              });
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var data = this.props.data;
	
	      getFieldDecorator('province', { initialValue: data ? data.province : '' });
	      getFieldDecorator('city', { initialValue: data ? data.city : '' });
	      getFieldDecorator('category1', {
	        initialValue: data ? data.category1 : ''
	      });
	      getFieldDecorator('category2', {
	        initialValue: data ? data.category2 : ''
	      });
	      getFieldDecorator('orderName', {
	        initialValue: data ? data.orderName : ''
	      });
	      getFieldDecorator('recommendName', {
	        initialValue: data ? data.recommendName : ''
	      });
	      getFieldDecorator('managerName', {
	        initialValue: data ? data.managerName : ''
	      });
	      var ItemLayout2 = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	
	      var ItemLayout = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 18 }
	      };
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15, marginTop: '-45px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u57FA\u672C\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u516C\u53F8\u540D\u79F0' }, ItemLayout2),
	                getFieldDecorator('name', {
	                  rules: [{ required: true, message: '请输入公司名称!' }],
	                  initialValue: data ? data.name : ''
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u516C\u53F8\u540D\u79F0' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5355\u4F4D\u7C7B\u578B' }, ItemLayout2),
	                getFieldDecorator('type', {
	                  rules: [{ required: true, message: '请选择单位类型!' }],
	                  initialValue: data ? data.type : '1'
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { onChange: this.changeType },
	                  _react2.default.createElement(
	                    Option,
	                    { key: '1', value: '1' },
	                    '\u516C\u53F8'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { key: '0', value: '0' },
	                    '\u4E2A\u4EBA'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u66FE\u7528\u540D' }, ItemLayout2),
	                getFieldDecorator('oldName', {
	                  initialValue: data ? data.oldName : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4F01\u4E1A\u6210\u7ACB\u65F6\u95F4' }, ItemLayout2),
	                getFieldDecorator('establishedDate', {
	                  initialValue: data.establishedDate ? _moment2.default.unix(data.establishedDate / 1000) : undefined
	                })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7EC4\u7EC7\u673A\u6784\u4EE3\u7801' }, ItemLayout2),
	                getFieldDecorator('code', {
	                  initialValue: data ? data.code : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4F01\u4E1A\u89C4\u6A21(\u4EBA)' }, ItemLayout2),
	                getFieldDecorator('scale', {
	                  initialValue: data ? data.scale : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6CE8\u518C\u5730\u5740' }, ItemLayout),
	                getFieldDecorator('registerAddr', {
	                  initialValue: data ? data.registerAddr : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5BA2\u6237\u884C\u4E1A' }, ItemLayout2),
	                getFieldDecorator('category', {
	                  initialValue: data ? data.category : []
	                })(_react2.default.createElement(_antd.Cascader, {
	                  options: this.state.category,
	                  loadData: this.loadCategory,
	                  onChange: this.chaneCategory,
	                  fieldNames: {
	                    label: 'key',
	                    value: 'value',
	                    children: 'children'
	                  },
	                  changeOnSelect: true,
	                  placeholder: '\u8BF7\u9009\u62E9\u5BA2\u6237\u884C\u4E1A'
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4E3B\u8425\u4E1A\u52A1' }, ItemLayout),
	                getFieldDecorator('business', {
	                  initialValue: data ? data.business : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u516C\u53F8\u7F51\u5740' }, ItemLayout),
	                getFieldDecorator('website', {
	                  initialValue: data ? data.website : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u516C\u53F8\u7B80\u4ECB' }, ItemLayout),
	                getFieldDecorator('summary', {
	                  initialValue: data ? data.summary : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5907\u6CE8' }, ItemLayout),
	                getFieldDecorator('remark', {})(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u8054\u7CFB\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6240\u5728\u5730\u533A' }, ItemLayout2),
	                getFieldDecorator('region', {
	                  initialValue: data ? data.region : []
	                })(_react2.default.createElement(_antd.Cascader, {
	                  options: _cascaderAddressOptions2.default,
	                  onChange: this.chaneRegion,
	                  changeOnSelect: true,
	                  placeholder: '\u8BF7\u9009\u62E9\u5730\u5740'
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8BE6\u7EC6\u5730\u5740' }, ItemLayout),
	                getFieldDecorator('addr', {
	                  initialValue: data ? data.addr : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8054\u7CFB\u4EBA' }, ItemLayout2),
	                getFieldDecorator('contactName', {
	                  rules: [{ required: true, message: '请输入联系人!' }],
	                  initialValue: data ? data.contactName : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u804C\u4F4D' }, ItemLayout2),
	                getFieldDecorator('contactDep', {
	                  initialValue: data ? data.contactDep : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8054\u7CFB\u7535\u8BDD' }, ItemLayout2),
	                getFieldDecorator('contactTel', {
	                  initialValue: data ? data.contactTel : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u5176\u4ED6\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(_SelectUser2.default, Object.assign({
	                onChange: this.changeOrderUser,
	                user: { uuid: data.orderUuid, name: data.orderName }
	              }, this.props, {
	                ItemLayout: ItemLayout2,
	                data: data,
	                field: { fieldName: '成单人', field: 'orderUuid' }
	              }))
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(_SelectUser2.default, Object.assign({
	                onChange: this.changeRecommendUser,
	                user: {
	                  uuid: data.recommendUuid,
	                  name: data.recommendName
	                },
	                data: data,
	                ItemLayout: ItemLayout2
	              }, this.props, {
	                field: { fieldName: '推荐人', field: 'recommendUuid' }
	              }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(_SelectUser2.default, Object.assign({
	                onChange: this.changeManagerUser,
	                ItemLayout: ItemLayout2,
	                user: {
	                  uuid: data.managerUuid,
	                  name: data.managerName
	                },
	                data: data
	              }, this.props, {
	                field: { fieldName: '管理人', field: 'managerUuid' }
	              }))
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7528\u6237id' }, ItemLayout2),
	                getFieldDecorator('userId', {
	                  initialValue: data ? data.userId : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u662F\u5426\u6709\u5173\u8054\u7528\u6237\u540D' }, ItemLayout2),
	                getFieldDecorator('related', {
	                  initialValue: data ? data.related : 0
	                })(_react2.default.createElement(
	                  RadioGroup,
	                  null,
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 0 },
	                    '\u5426'
	                  ),
	                  _react2.default.createElement(
	                    _antd.Radio,
	                    { value: 1 },
	                    '\u662F'
	                  )
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5FAE\u4FE1\u540D' }, ItemLayout2),
	                getFieldDecorator('wechat', {
	                  initialValue: data ? data.wechat : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: 'qq' }, ItemLayout2),
	                getFieldDecorator('qq', { initialValue: data ? data.qq : '' })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u624B\u673A' }, ItemLayout2),
	                getFieldDecorator('tel', {
	                  initialValue: data ? data.tel : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5BA2\u6237\u6765\u6E90' }, ItemLayout2),
	                getFieldDecorator('source', {
	                  initialValue: data ? data.source : ''
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 18, style: { marginBottom: 15, textAlign: 'right' } },
	            _react2.default.createElement(
	              _antd.Button,
	              { style: { marginRight: 10 }, type: 'primary', htmlType: 'submit' },
	              '\u786E\u5B9A'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { style: { marginRight: 10 }, onClick: _BackBtn.goBack },
	              '\u53D6\u6D88'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _crm = __webpack_require__(33);
	
	var _ModalDepartment = __webpack_require__(1528);
	
	var _ModalDepartment2 = _interopRequireDefault(_ModalDepartment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo, condition) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      _this.setState({
	        pageNo: pageNo
	      });
	      (0, _crm.queryCustomList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        }
	      });
	    };
	
	    _this.handleChange = function () {};
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.loadData(1, values.condition);
	        }
	      });
	    };
	
	    _this.handleFormReset = function (e) {
	      e.preventDefault();
	      _this.props.form.resetFields();
	      _this.loadData(1);
	    };
	
	    _this.handleModalVisible = function (visible) {
	      _this.setState({ visible: visible, selectUuid: '' });
	    };
	
	    _this.showModal = function (uuid) {
	      _this.setState({
	        selectUuid: uuid,
	        visible: true
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', onSubmit: _this.handleSubmit },
	        _react2.default.createElement(
	          _antd.Row,
	          { gutter: { md: 8, lg: 24, xl: 48 }, style: { minWidth: '650px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24, style: { minWidth: '400px' } },
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u641C\u7D22\u6761\u4EF6' },
	              getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165', style: { minWidth: '200px' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              'span',
	              { className: 'submitButtons' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit' },
	                '\u67E5\u8BE2'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: 8 }, onClick: _this.handleFormReset },
	                '\u91CD\u7F6E'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '编号',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '客户名称',
	        dataIndex: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/crm/custom/edit/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '客户行业',
	        dataIndex: 'category'
	      }, {
	        title: '来源渠道',
	        dataIndex: 'origin'
	      }, {
	        title: '更新时间',
	        dataIndex: 'updateTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.showModal(record.uuid);
	              } },
	            '\u4E0B\u653E'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      total: 0,
	      pageNo: 1,
	      visible: false,
	      selectUuid: ''
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListForm' },
	            this.renderSearchForm()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/custom/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u6DFB\u52A0'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/custom/protect' },
	              _react2.default.createElement(
	                _antd.Button,
	                null,
	                '\u5BA2\u6237\u4FDD\u62A4'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        }),
	        this.state.visible ? _react2.default.createElement(_ModalDepartment2.default, {
	          handleModalVisible: this.handleModalVisible,
	          uuid: this.state.selectUuid
	        }) : ''
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _crm = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.loadDepartments = new Promise(function (resolve, reject) {
	      (0, _crm.queryDepartmentList)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ departments: res.data });
	          resolve();
	        } else {
	          _antd.message.error(res.message);
	          reject();
	        }
	      });
	    });
	
	    _this.loadData = function (uuid) {
	      (0, _crm.queryCustomDepartmentDistributionList)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ distributions: res.data }, _this.handlerData);
	        }
	      });
	    };
	
	    _this.submit = function (params) {
	      var uuid = _this.props.uuid;
	
	      if (uuid) {
	        params.customUuid = uuid;
	      }
	
	      (0, _crm.querySaveCustomDepartmentDistribution)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.onChange = function (uuid) {
	      return function () {
	        var data = _this.state.data;
	
	        var result = data.map(function (item) {
	          if (item.uuid === uuid) {
	            item.isOpen = true;
	          }
	          return item;
	        });
	        _this.setState({ data: result }, function () {
	          return _this.submit({ departmentUuid: uuid });
	        });
	      };
	    };
	
	    _this.handlerData = function () {
	      var _this$state = _this.state,
	          departments = _this$state.departments,
	          distributions = _this$state.distributions;
	
	      var result = departments.map(function (department) {
	        var checks = distributions ? distributions.filter(function (distribution) {
	          return distribution.departmentUuid === department.uuid;
	        }) : [];
	
	        department.isOpen = checks.length > 0;
	        return department;
	      });
	      _this.setState({ data: result });
	    };
	
	    _this.renderForm = function () {
	      var data = _this.state.data;
	
	
	      return data.map(function (item, index) {
	        return _react2.default.createElement(
	          _antd.Row,
	          { style: { marginTop: 15 }, key: item.uuid },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              'span',
	              { style: { width: 200 } },
	              item.organizationName
	            ),
	            _react2.default.createElement(_antd.Switch, {
	              style: { float: 'right' },
	              className: 'switch-' + index,
	              checked: item.isOpen,
	              disabled: item.isOpen,
	              onChange: _this.onChange(item.uuid)
	            })
	          )
	        );
	      });
	    };
	
	    _this.state = {
	      departments: [],
	      distributions: [],
	      data: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.loadDepartments.then(function () {
	        var uuid = _this2.props.uuid;
	
	        _this2.loadData(uuid);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var handleModalVisible = this.props.handleModalVisible;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u4E0B\u653E', visible: true, onCancel: function onCancel() {
	            return handleModalVisible(false);
	          }, footer: false },
	        this.renderForm()
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _crm = __webpack_require__(33);
	
	var _PageAdd = __webpack_require__(687);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageEdit = function PageEdit(Page) {
	  return function (_Component) {
	    _inherits(pageAdd, _Component);
	
	    function pageAdd(props) {
	      _classCallCheck(this, pageAdd);
	
	      var _this = _possibleConstructorReturn(this, (pageAdd.__proto__ || Object.getPrototypeOf(pageAdd)).call(this, props));
	
	      _this.loadData = function (uuid) {
	        (0, _crm.queryCustomInfo)(uuid).then(function (res) {
	          if (res.statusCode === 200) {
	            var data = res.data;
	
	            data.category = [data.category1, data.category2];
	            data.region = [data.province, data.city];
	            _this.setState({ data: data });
	          } else {
	            _antd.message.error(res.message);
	          }
	        });
	      };
	
	      _this.state = {
	        data: {}
	      };
	      return _this;
	    }
	
	    _createClass(pageAdd, [{
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	        var uuid = this.props.params.uuid;
	
	        this.loadData(uuid);
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var newPros = {
	          data: this.state.data
	        };
	        return _react2.default.createElement(Page, Object.assign({}, this.props, newPros));
	      }
	    }]);
	
	    return pageAdd;
	  }(_react.Component);
	};
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { organization: state.organization };
	})(PageEdit(_PageAdd2.default));

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _crm = __webpack_require__(33);
	
	var _SelectUser = __webpack_require__(325);
	
	var _SelectUser2 = _interopRequireDefault(_SelectUser);
	
	var _cascaderAddressOptions = __webpack_require__(429);
	
	var _cascaderAddressOptions2 = _interopRequireDefault(_cascaderAddressOptions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	var RadioGroup = _antd.Radio.Group;
	
	var ConfigItem = function (_Component) {
	  _inherits(ConfigItem, _Component);
	
	  function ConfigItem(props) {
	    _classCallCheck(this, ConfigItem);
	
	    var _this = _possibleConstructorReturn(this, (ConfigItem.__proto__ || Object.getPrototypeOf(ConfigItem)).call(this, props));
	
	    _this.chaneRegion = function (value) {
	      if (value.length > 0) {
	        _this.props.form.setFieldsValue({ province: value[0], city: value[1] });
	      }
	    };
	
	    _this.getName = function (key) {
	      var name = '';
	      switch (key) {
	        case 'orderUuid':
	          name = 'orderName';
	          break;
	        case 'managerUuid':
	          name = 'managerName';
	          break;
	        case 'recommendUuid':
	          name = 'recommendName';
	          break;
	        default:
	          break;
	      }
	      return name;
	    };
	
	    _this.handleSelectChangge = function (key) {
	      var name = _this.getName(key);
	      return function (value, selectedOptions) {
	        var params = {};
	        params[name] = selectedOptions.props.children;
	        _this.props.form.setFieldsValue(params);
	      };
	    };
	
	    _this.getSelectedOptions = function (key) {
	      _this.state.category.filter(function (item) {
	        return item.key === key;
	      });
	    };
	
	    _this.loadCategory = function (selectedOptions) {
	      var targetOption = selectedOptions[selectedOptions.length - 1];
	      targetOption.loading = true;
	
	      (0, _crm.queryCustomCategory)(targetOption.value).then(function (req) {
	        if (req.statusCode === 200) {
	          targetOption.loading = false;
	          targetOption.children = req.data;
	        }
	      });
	    };
	
	    _this.chaneCategory = function (value) {
	      if (value.length > 0) {
	        _this.props.form.setFieldsValue({
	          category1: value[0],
	          category2: value[1]
	        });
	      }
	    };
	
	    _this.renderFormItem = function (field) {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var data = _this.props.data;
	
	      var ComponentRender = null;
	      if (field.field === 'orderName') {
	        field.field = 'orderUuid';
	      } else if (field.field === 'managerName') {
	        field.field = 'managerUuid';
	      } else if (field.field === 'recommendName') {
	        field.field = 'recommendUuid';
	      }
	      switch (field.field) {
	        case 'establishedDate':
	          ComponentRender = _react2.default.createElement(
	            FormItem,
	            { label: field.fieldName },
	            getFieldDecorator('establishedDate', {
	              rules: [{
	                required: field.isRequire,
	                message: '\u8BF7\u8F93\u5165' + field.fieldName + '!'
	              }],
	              initialValue: data.establishedDate ? _moment2.default.unix(data.establishedDate / 1000) : data.establishedDate
	            })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	          );
	          break;
	        case 'type':
	          ComponentRender = _react2.default.createElement(
	            FormItem,
	            { label: field.fieldName },
	            getFieldDecorator('type', {
	              rules: [{
	                required: field.isRequire,
	                message: '\u8BF7\u9009\u62E9' + field.fieldName + '!'
	              }],
	              initialValue: data.type ? '' + data.type : data.type
	            })(_react2.default.createElement(
	              _antd.Select,
	              { onChange: _this.changeType },
	              _react2.default.createElement(
	                Option,
	                { key: '1', value: '1' },
	                '\u516C\u53F8'
	              ),
	              _react2.default.createElement(
	                Option,
	                { key: '0', value: '0' },
	                '\u4E2A\u4EBA'
	              )
	            ))
	          );
	          break;
	        case 'category':
	          ComponentRender = _react2.default.createElement(
	            FormItem,
	            { label: '\u5BA2\u6237\u884C\u4E1A' },
	            getFieldDecorator('category', {
	              rules: [{
	                required: field.isRequire,
	                message: '\u8BF7\u8F93\u5165' + field.fieldName + '!'
	              }],
	              initialValue: data.category
	            })(_react2.default.createElement(_antd.Cascader, {
	              options: _this.state.category,
	              loadData: _this.loadCategory,
	              onChange: _this.chaneCategory,
	              fieldNames: {
	                label: 'key',
	                value: 'value',
	                children: 'children'
	              },
	              changeOnSelect: true,
	              placeholder: '\u8BF7\u9009\u62E9\u5BA2\u6237\u884C\u4E1A'
	            }))
	          );
	          break;
	        case 'orderUuid':
	        case 'recommendUuid':
	        case 'managerUuid':
	          ComponentRender = _react2.default.createElement(_SelectUser2.default, Object.assign({
	            onChange: function onChange() {
	              return _this.handleSelectChangge(field.field);
	            },
	            field: field
	          }, _this.props));
	          break;
	        case 'region':
	          ComponentRender = _react2.default.createElement(
	            FormItem,
	            { label: field.fieldName },
	            getFieldDecorator('region', {
	              rules: [{
	                required: field.isRequire,
	                message: '\u8BF7\u8F93\u5165' + field.fieldName + '!'
	              }],
	              initialValue: data ? data.region : ''
	            })(_react2.default.createElement(_antd.Cascader, {
	              options: _cascaderAddressOptions2.default,
	              onChange: _this.chaneRegion,
	              changeOnSelect: true,
	              placeholder: '\u8BF7\u9009\u62E9\u5730\u5740'
	            }))
	          );
	          break;
	        case 'related':
	          ComponentRender = _react2.default.createElement(
	            FormItem,
	            { label: '\u662F\u5426\u6709\u5173\u8054\u7528\u6237\u540D' },
	            getFieldDecorator('related', {
	              rules: [{
	                required: field.isRequire,
	                message: '\u8BF7\u8F93\u5165' + field.fieldName + '!'
	              }],
	              initialValue: data ? data.related : ''
	            })(_react2.default.createElement(
	              RadioGroup,
	              null,
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: 0 },
	                '\u5426'
	              ),
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: 1 },
	                '\u662F'
	              )
	            ))
	          );
	          break;
	        default:
	          ComponentRender = _react2.default.createElement(
	            FormItem,
	            { label: field.fieldName },
	            getFieldDecorator(field.field, {
	              rules: [{
	                required: field.isRequire,
	                message: '\u8BF7\u8F93\u5165' + field.fieldName + '!'
	              }],
	              initialValue: data ? data[field.field] : ''
	            })(_react2.default.createElement(_antd.Input, null))
	          );
	          break;
	      }
	      return ComponentRender;
	    };
	
	    _this.state = {
	      category: []
	    };
	    return _this;
	  }
	
	  _createClass(ConfigItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.field.field.indexOf('category') < 0) {
	        return;
	      }
	      var key = this.props.data.category1;
	      (0, _crm.queryCustomCategory)().then(function (res) {
	        if (res.statusCode === 200) {
	          var data = res.data.map(function (item) {
	            item.isLeaf = false;
	            return item;
	          });
	          if (!key) {
	            _this2.setState({
	              category: data
	            });
	            return;
	          }
	          (0, _crm.queryCustomCategory)(key).then(function (result) {
	            if (result.statusCode === 200) {
	              data.map(function (item) {
	                if (item.key === key) {
	                  item.children = result.data;
	                }
	                return item;
	              });
	              _this2.setState({
	                category: data
	              });
	            }
	          });
	        }
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _antd.Col,
	        { span: 12 },
	        this.renderFormItem(this.props.field)
	      );
	    }
	  }]);
	
	  return ConfigItem;
	}(_react.Component);
	
	exports.default = ConfigItem;

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _crm = __webpack_require__(33);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _getArea = __webpack_require__(1512);
	
	var _getArea2 = _interopRequireDefault(_getArea);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var type = ['个人', '公司'];
	var related = ['未关联', '已关联'];
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.handleSearch = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      _this.props.form.validateFields(function (err, values) {
	        _this.condition = values.condition;
	        _this.loadData(1);
	      });
	    };
	
	    _this.handleFormReset = function (e) {
	      e.preventDefault();
	      _this.props.form.resetFields();
	      _this.condition = '';
	      _this.loadData(1);
	    };
	
	    _this.loadData = function (pageNo) {
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      var params = {};
	      params.limit = 15;
	      params.start = current;
	      params.condition = _this.condition || '';
	      _this.setState({
	        pageNo: pageNo
	      });
	      (0, _crm.queryCustomDepartmentList)(params).then(function (res) {
	        _this.setState({
	          columns: res.data.columns,
	          data: res.data.customs,
	          total: res.totalSize,
	          wid: (res.data.columns.length + 3) * 150 + 350
	        });
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', onSubmit: _this.handleSearch },
	        _react2.default.createElement(
	          _antd.Row,
	          { gutter: { md: 8, lg: 24, xl: 48 }, style: { minWidth: '650px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24, style: { minWidth: '400px' } },
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u5BA2\u6237\u540D\u79F0' },
	              getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165', style: { minWidth: '200px' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              'span',
	              { className: 'submitButtons' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit' },
	                '\u67E5\u8BE2'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: 8 }, onClick: _this.handleFormReset },
	                '\u91CD\u7F6E'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.fieldsColumns = function () {
	      var columns = _this.state.columns;
	
	      return columns.map(function (item) {
	        var params = {
	          title: item.fieldName,
	          dataIndex: item.field,
	          width: 150
	        };
	        if (item.field === 'establishedDate') {
	          params = Object.assign({}, params, {
	            render: function render(text) {
	              return _react2.default.createElement(
	                'span',
	                null,
	                text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	              );
	            }
	          });
	        } else if (item.field === 'category') {
	          params = Object.assign({}, params, {
	            render: function render(text, record) {
	              return _react2.default.createElement(
	                'span',
	                null,
	                record.category1 ? record.category1 + '/' + record.category2 : ''
	              );
	            }
	          });
	        } else if (item.field === 'region') {
	          params = Object.assign({}, params, {
	            render: function render(text, record) {
	              return _react2.default.createElement(
	                'span',
	                null,
	                (0, _getArea2.default)(record.province, record.city)
	              );
	            }
	          });
	        } else if (item.field === 'related') {
	          params = Object.assign({}, params, {
	            render: function render(text) {
	              return _react2.default.createElement(
	                'span',
	                null,
	                related[text]
	              );
	            }
	          });
	        } else if (item.field === 'type') {
	          params = Object.assign({}, params, {
	            render: function render(text) {
	              return _react2.default.createElement(
	                'span',
	                null,
	                type[text]
	              );
	            }
	          });
	        }
	        return params;
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '客户名称',
	        dataIndex: 'name',
	        width: 150,
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/crm/custom/department/' + record.uuid + '/edit' },
	            text
	          );
	        }
	      }].concat(_toConsumableArray(_this.fieldsColumns()), [{
	        title: '操作',
	        dataIndex: 'done',
	        width: 150,
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/custom/department/' + record.uuid + '/contact' },
	              '\u8054\u7CFB\u8BB0\u5F55'
	            )
	          );
	        }
	      }]);
	    };
	
	    _this.state = {
	      data: [],
	      columns: [],
	      total: 0,
	      pageNo: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      (0, _getArea2.default)(13, 1301);
	      this.loadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total,
	          wid = _state.wid;
	
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListForm' },
	            this.renderSearchForm()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/custom/department/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u6DFB\u52A0'
	              )
	            ),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/custom/department/protect' },
	              _react2.default.createElement(
	                _antd.Button,
	                null,
	                '\u5BA2\u6237\u4FDD\u62A4'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination,
	          scroll: { x: wid, y: _util2.default.pageHeight() - 330 }
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handleSubmit = _this.props.handleSubmit;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = values;
	          handleSubmit(params);
	        }
	      });
	    };
	
	    _this.state = {
	      detail: {}
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var handleModalVisible = this.props.handleModalVisible;
	      var detail = this.state.detail;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u6838\u5B9E', visible: true, onCancel: function onCancel() {
	            return handleModalVisible(false);
	          }, onOk: this.submit },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.submit },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                getFieldDecorator('record', {
	                  initialValue: detail.record
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u8054\u7CFB\u8BB0\u5F55' }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handleSubmit = _this.props.handleSubmit;
	      var detail = _this.state.detail;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = values;
	
	          if (detail.uuid) {
	            params.uuid = detail.uuid;
	          }
	          handleSubmit(params);
	        }
	      });
	    };
	
	    _this.state = {
	      detail: {}
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var ItemLayout2 = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      var handleModalVisible = this.props.handleModalVisible;
	      var detail = this.state.detail;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u6DFB\u52A0\u8054\u7CFB\u8BB0\u5F55',
	          visible: true,
	          onCancel: function onCancel() {
	            return handleModalVisible(false);
	          },
	          onOk: this.submit
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.submit },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 24 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u8054\u7CFB\u65F6\u95F4' }, ItemLayout2),
	                  getFieldDecorator('date', {
	                    rules: [{ required: true, message: '请填写联系方式!' }]
	                  })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5907\u6CE8' }, ItemLayout2),
	                getFieldDecorator('remark', {
	                  initialValue: detail.remark
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8054\u7CFB\u65B9\u5F0F' }, ItemLayout2),
	                getFieldDecorator('tel', {
	                  rules: [{ required: true, message: '请填写联系方式!' }],
	                  initialValue: detail.tel
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8054\u7CFB\u7C7B\u578B' }, ItemLayout2),
	                getFieldDecorator('type', {
	                  rules: [{ required: true, message: '请输入预测金额!' }],
	                  initialValue: detail.prediction
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  null,
	                  _react2.default.createElement(
	                    Option,
	                    { key: '0' },
	                    '\u5230\u8BBF'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { key: '1' },
	                    '\u7535\u8BDD'
	                  )
	                ))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _crm = __webpack_require__(33);
	
	var _FormCustom = __webpack_require__(689);
	
	var _FormCustom2 = _interopRequireDefault(_FormCustom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.handleAdd = function (params) {
	      (0, _crm.querySaveDepartmentCustom)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = { data: {} };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ data: nextProps.data });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormCustom2.default, {
	          ref: function ref(form) {
	            _this2.form = form;
	          },
	          handleSubmit: this.handleAdd,
	          data: data
	        })
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { organization: state.organization };
	})(BaseForm);

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _crm = __webpack_require__(33);
	
	var _org = __webpack_require__(53);
	
	var _ModalContact = __webpack_require__(1533);
	
	var _ModalContact2 = _interopRequireDefault(_ModalContact);
	
	var _ModalCheck = __webpack_require__(1532);
	
	var _ModalCheck2 = _interopRequireDefault(_ModalCheck);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getOrgList = function () {
	      (0, _org.queryOrgList)({
	        type: 1
	      }).then(function () {});
	    };
	
	    _this.getData = function (pageNo) {
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      _this.setState({
	        pageNo: current
	      });
	      (0, _crm.queryCustomContact)({
	        start: current,
	        customUuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.saveContact = function (params) {
	      (0, _crm.querySaveCustomContact)(Object.assign({}, params, {
	        custom: _this.props.params.uuid
	      })).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handleModalVisible(false);
	          _this.getData(1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleChange = function (checked) {};
	
	    _this.handleSubmit = function (params) {
	      _this.saveContact(params);
	    };
	
	    _this.handleCheckSubmit = function (params) {
	      (0, _crm.queryVerifyCustomContact)(Object.assign({}, params, {
	        uuid: _this.uuid
	      })).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handleModalCheckVisible(false);
	          _this.getData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleModalVisible = function (flag) {
	      _this.setState({
	        modalVisible: !!flag
	      });
	    };
	
	    _this.handleModalCheckVisible = function (flag, uuid) {
	      _this.uuid = uuid;
	      _this.setState({
	        modalCheckVisible: !!flag
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '联系时间',
	        dataIndex: 'date',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '备注',
	        dataIndex: 'remark'
	      }, {
	        title: '联系方式',
	        dataIndex: 'tel'
	      }, {
	        title: '联系记录',
	        dataIndex: 'record'
	      }, {
	        title: '操作',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 1 ? _react2.default.createElement(
	              'a',
	              null,
	              '\u5DF2\u6838\u5B9E'
	            ) : _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.handleModalCheckVisible(true, record.uuid);
	                } },
	              '\u6838\u5B9E'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      modalVisible: false,
	      modalCheckVisible: false,
	      pageNo: 1,
	      total: 0
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.uuid = this.props.params.uuid;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	      this.getOrgList();
	    }
	
	    // 核实联系记录
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          modalVisible = _state.modalVisible,
	          total = _state.total,
	          pageNo = _state.pageNo,
	          modalCheckVisible = _state.modalCheckVisible;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.getBusiness(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      var parentProps = {
	        handleModalVisible: this.handleModalVisible,
	        handleSubmit: this.handleSubmit
	      };
	      var parentCheckProps = {
	        handleModalVisible: this.handleModalCheckVisible,
	        handleSubmit: this.handleCheckSubmit
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: function onClick() {
	                  return _this2.handleModalVisible(true);
	                } },
	              '\u6DFB\u52A0'
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        }),
	        modalVisible ? _react2.default.createElement(_ModalContact2.default, parentProps) : null,
	        modalCheckVisible ? _react2.default.createElement(_ModalCheck2.default, parentCheckProps) : null
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _crm = __webpack_require__(33);
	
	var _FormCustom = __webpack_require__(689);
	
	var _FormCustom2 = _interopRequireDefault(_FormCustom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.handleAdd = function (params) {
	      params.uuid = _this.props.params.uuid;
	      (0, _crm.querySaveDepartmentCustom)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getDetail = function () {
	      (0, _crm.queryCustomDepartmentInfo)(_this.props.params.uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          var data = res.data.customs;
	          data.region = [data.province, data.city];
	          data.category = [data.category1, data.category2];
	          // this.initCategory(data.category1)
	          _this.setState({
	            data: data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.initCategory = function (key) {
	      (0, _crm.queryCustomCategory)(key).then(function () {});
	    };
	
	    _this.state = { data: {} };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getDetail();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({ data: nextProps.data });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormCustom2.default, {
	          ref: function ref(form) {
	            _this2.form = form;
	          },
	          handleSubmit: this.handleAdd,
	          data: data
	        })
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { organization: state.organization };
	})(BaseForm);

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _crm = __webpack_require__(33);
	
	var _ModalProtect = __webpack_require__(1538);
	
	var _ModalProtect2 = _interopRequireDefault(_ModalProtect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.saveProtection = function (params) {
	      (0, _crm.querySaveCustomProtection)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getProtection();
	          _this.handleModalVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getProtection = function (pageNo) {
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      _this.setState({
	        pageNo: current
	      });
	      (0, _crm.queryMyCustomProtectionList)({
	        condition: _this.condition || '',
	        type: _this.type || '',
	        start: current
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.getMyDepartment = function () {
	      (0, _crm.queryDepartmentMy)().then(function (res) {
	        if (res.statusCode === 200) {
	          var uuid = res.data.uuid;
	
	          _this.getProduct(uuid);
	          _this.getMyCustom(uuid);
	        }
	      });
	    };
	
	    _this.getMyCustom = function () {
	      (0, _crm.queryCustomDepartmentList)().then(function (res) {});
	    };
	
	    _this.getProduct = function (uuid) {
	      (0, _crm.queryDepartmentProduct)({
	        uuid: uuid
	      }).then(function (res) {
	        _this.setState({
	          product: res.data
	        });
	      });
	    };
	
	    _this.handleModalVisible = function (flag, uuid) {
	      _this.uuid = uuid;
	      _this.setState({
	        modalVisible: !!flag
	      });
	    };
	
	    _this.handleSubmit = function (params) {
	      _this.saveProtection(params);
	    };
	
	    _this.handleSearch = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      _this.props.form.validateFields(function (err, values) {
	        _this.condition = values.condition;
	        _this.getProtection(1);
	      });
	    };
	
	    _this.confirm = function (customUuid) {
	      return function (e) {
	        (0, _crm.queryCancelCustomProtection)({
	          customUuid: customUuid
	        }).then(function (res) {
	          if (res.statusCode === 200) {
	            _antd.message.success(res.message);
	            _this.getProtection();
	            _this.handleModalVisible(false);
	          } else {
	            _antd.message.error(res.message);
	          }
	        });
	      };
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', onSubmit: _this.handleSearch },
	        _react2.default.createElement(
	          _antd.Row,
	          { gutter: { md: 8, lg: 24, xl: 48 }, style: { minWidth: '650px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24, style: { minWidth: '400px' } },
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u5BA2\u6237\u540D\u79F0' },
	              getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165', style: { minWidth: '200px' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              'span',
	              { className: 'submitButtons' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit' },
	                '\u67E5\u8BE2'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: 8 }, onClick: _this.handleFormReset },
	                '\u91CD\u7F6E'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '编号',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '客户名称',
	        dataIndex: 'name'
	      }, {
	        title: '行业',
	        dataIndex: 'type'
	      }, {
	        title: '来源渠道',
	        dataIndex: 'origin'
	      }, {
	        title: '保护时间',
	        dataIndex: 'protectDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '保护到期时间',
	        dataIndex: 'maturityDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _antd.Popconfirm,
	            { title: '\u786E\u5B9A\u53D6\u6D88\u8BE5\u5BA2\u6237\u4FDD\u62A4?', onConfirm: function onConfirm() {
	                return _this.confirm(record.uuid);
	              } },
	            _react2.default.createElement(
	              'a',
	              null,
	              '\u53D6\u6D88\u4FDD\u62A4'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      pageNo: 1,
	      product: [],
	      total: 0,
	      modalVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getMyDepartment();
	      this.getProtection();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          modalVisible = _state.modalVisible,
	          product = _state.product,
	          total = _state.total,
	          pageNo = _state.pageNo;
	
	      var parentProps = {
	        handleModalVisible: this.handleModalVisible,
	        handleSubmit: this.handleSubmit,
	        product: product,
	        uuid: this.uuid
	      };
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.getProtection(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListForm' },
	            this.renderSearchForm()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: function onClick() {
	                  return _this2.handleModalVisible(true);
	                } },
	              '\u6DFB\u52A0'
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        }),
	        modalVisible ? _react2.default.createElement(_ModalProtect2.default, parentProps) : null
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _crm = __webpack_require__(33);
	
	var _SelectCustom = __webpack_require__(688);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.getMyCustom = function (params) {
	      return new Promise(function (resolve, reject) {
	        (0, _crm.queryCustomDepartmentList)(Object.assign({}, params)).then(function (res) {
	          if (res.statusCode === 200) {
	            resolve(res.data.customs);
	          } else {
	            reject(res);
	          }
	        });
	      });
	    };
	
	    _this.getBusiness = function () {
	      (0, _crm.queryBusinessInfo)({
	        uuid: _this.props.uuid
	      }).then(function () {});
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handleSubmit = _this.props.handleSubmit;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handleSubmit(values);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.uuid) {
	        this.getBusiness();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var ItemLayout2 = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      var _props = this.props,
	          handleModalVisible = _props.handleModalVisible,
	          product = _props.product;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u6DFB\u52A0\u5BA2\u6237\u4FDD\u62A4',
	          visible: true,
	          onCancel: function onCancel() {
	            return handleModalVisible(false);
	          },
	          onOk: this.submit
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.submit },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_SelectCustom2.default, Object.assign({}, this.props, { ItemLayout: ItemLayout2, loaddata: this.getMyCustom }))
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4EA7\u54C1' }, ItemLayout2),
	                getFieldDecorator('product', {
	                  rules: [{ required: true, message: '请选择产品!' }]
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  null,
	                  product.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.name },
	                      item.name
	                    );
	                  })
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6210\u5355\u91D1\u989D' }, ItemLayout2),
	                getFieldDecorator('amount', {
	                  rules: [{ required: true, message: '请输入成单金额!' }]
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _crm = __webpack_require__(33);
	
	var _ModalProtect = __webpack_require__(1541);
	
	var _ModalProtect2 = _interopRequireDefault(_ModalProtect);
	
	var _ModalAllot = __webpack_require__(1540);
	
	var _ModalAllot2 = _interopRequireDefault(_ModalAllot);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.saveProtection = function (params) {
	      (0, _crm.querySaveCustomDepartmentDistribution)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getProtection();
	          _this.handleModalVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getProtection = function (pageNo) {
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      _this.setState({
	        pageNo: current
	      });
	      (0, _crm.queryCustomProtectionList)({
	        condition: _this.condition || '',
	        type: _this.type || '',
	        start: current
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.handleModalVisible = function (flag, uuid) {
	      _this.uuid = uuid;
	      _this.setState({
	        modalVisible: !!flag
	      });
	    };
	
	    _this.handleSubmit = function (params) {
	      _this.saveProtection(params);
	    };
	
	    _this.handleAllotSubmit = function (params) {
	      (0, _crm.querySaveCustomDepartmentDistribution)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getProtection();
	          _this.handleAllotModalVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleSearch = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      _this.props.form.validateFields(function (err, values) {
	        _this.condition = values.condition;
	        _this.getProtection(1);
	      });
	    };
	
	    _this.confirm = function (customUuid) {
	      return function (e) {
	        (0, _crm.queryCancelCustomProtection)({
	          customUuid: customUuid
	        }).then(function (res) {
	          if (res.statusCode === 200) {
	            _antd.message.success(res.message);
	            _this.getProtection();
	            _this.handleModalVisible(false);
	          } else {
	            _antd.message.error(res.message);
	          }
	        });
	      };
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', onSubmit: _this.handleSearch },
	        _react2.default.createElement(
	          _antd.Row,
	          { gutter: { md: 8, lg: 24, xl: 48 }, style: { minWidth: '650px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24, style: { minWidth: '400px' } },
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u5BA2\u6237\u540D\u79F0' },
	              getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165', style: { minWidth: '200px' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { md: 8, sm: 24 },
	            _react2.default.createElement(
	              'span',
	              { className: 'submitButtons' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit' },
	                '\u67E5\u8BE2'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginLeft: 8 }, onClick: _this.handleFormReset },
	                '\u91CD\u7F6E'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.handleAllotModalVisible = function (flag, record) {
	      record = record || {};
	      record.protectionUser = record.protectUuid;
	      _this.record = record;
	      _this.setState({
	        allotModalVisible: !!flag
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '编号',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '客户名称',
	        dataIndex: 'name'
	      }, {
	        title: '行业',
	        dataIndex: 'type'
	      }, {
	        title: '来源渠道',
	        dataIndex: 'origin'
	      }, {
	        title: '保护人名称',
	        dataIndex: 'protectName'
	      }, {
	        title: '保护时间',
	        dataIndex: 'protectDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '保护到期时间',
	        dataIndex: 'maturityDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.handleAllotModalVisible(true, record);
	                } },
	              '\u5206\u914D'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      pageNo: 1,
	      total: 0,
	      modalVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getProtection();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          modalVisible = _state.modalVisible,
	          total = _state.total,
	          pageNo = _state.pageNo,
	          allotModalVisible = _state.allotModalVisible;
	
	      var parentProps = {
	        handleModalVisible: this.handleModalVisible,
	        handleSubmit: this.handleSubmit,
	        uuid: this.uuid
	      };
	      var parentProps2 = {
	        handleModalVisible: this.handleAllotModalVisible,
	        handleSubmit: this.handleAllotSubmit,
	        record: this.record
	      };
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.getProtection(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListForm' },
	            this.renderSearchForm()
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: function onClick() {
	                  return _this2.handleModalVisible(true);
	                } },
	              '\u6DFB\u52A0'
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        }),
	        modalVisible ? _react2.default.createElement(_ModalProtect2.default, parentProps) : null,
	        allotModalVisible ? _react2.default.createElement(_ModalAllot2.default, parentProps2) : null
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _crm = __webpack_require__(33);
	
	var _SelectUser = __webpack_require__(325);
	
	var _SelectUser2 = _interopRequireDefault(_SelectUser);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var ModalAllot = function (_Component) {
	  _inherits(ModalAllot, _Component);
	
	  function ModalAllot(props) {
	    _classCallCheck(this, ModalAllot);
	
	    var _this = _possibleConstructorReturn(this, (ModalAllot.__proto__ || Object.getPrototypeOf(ModalAllot)).call(this, props));
	
	    _this.getBusiness = function () {
	      (0, _crm.queryBusinessInfo)({
	        uuid: _this.props.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({});
	        }
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$props = _this.props,
	          handleSubmit = _this$props.handleSubmit,
	          record = _this$props.record;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handleSubmit(Object.assign({}, values, {
	            protectionMaturityDate: values.protectionMaturityDate.format('YYYY-MM-DD'),
	            customUuid: record.uuid
	          }));
	        }
	      });
	    };
	
	    _this.handleSelectChangge = function () {
	      return function (value, selectedOptions) {
	        _this.props.form.setFieldsValue({
	          protectionUserName: selectedOptions.props.children
	        });
	      };
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ModalAllot, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.uuid) {
	        this.getBusiness();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          handleModalVisible = _props.handleModalVisible,
	          record = _props.record;
	
	      getFieldDecorator('protectionUserName');
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u5206\u914D', visible: true, onCancel: function onCancel() {
	            return handleModalVisible(false);
	          }, onOk: this.submit },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.submit },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u4FDD\u62A4\u65F6\u95F4' },
	                getFieldDecorator('protectionMaturityDate', {
	                  rules: [{ required: true, message: '请选择保护时间!' }],
	                  initialValue: record.maturityDate ? _moment2.default.unix(record.maturityDate / 1000) : record.maturityDate
	                })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_SelectUser2.default, Object.assign({}, this.props, {
	                field: {
	                  field: 'protectionUser',
	                  fieldName: '保护人',
	                  isRequire: true
	                },
	                data: record,
	                onChange: this.handleSelectChangge()
	              }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalAllot;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(ModalAllot);

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _crm = __webpack_require__(33);
	
	var _SelectUser = __webpack_require__(325);
	
	var _SelectUser2 = _interopRequireDefault(_SelectUser);
	
	var _SelectCustom = __webpack_require__(688);
	
	var _SelectCustom2 = _interopRequireDefault(_SelectCustom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.getBusiness = function () {
	      (0, _crm.queryBusinessInfo)({
	        uuid: _this.props.uuid
	      }).then(function () {});
	    };
	
	    _this.getCustom = function (params) {
	      return new Promise(function (resolve, reject) {
	        (0, _crm.queryCustomList)(Object.assign({}, params)).then(function (res) {
	          if (res.statusCode === 200) {
	            resolve(res.data);
	          } else {
	            reject(res);
	          }
	        });
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handleSubmit = _this.props.handleSubmit;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handleSubmit(Object.assign({}, values, {
	            protectionMaturityDate: values.protectionMaturityDate.format('YYYY-MM-DD')
	          }));
	        }
	      });
	    };
	
	    _this.handleSelectChangge = function () {
	      return function (value, selectedOptions) {
	        _this.props.form.setFieldsValue({
	          protectionUserName: selectedOptions.props.children
	        });
	      };
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.uuid) {
	        this.getBusiness();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var handleModalVisible = this.props.handleModalVisible;
	
	      getFieldDecorator('protectionUserName');
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u6DFB\u52A0\u5BA2\u6237\u4FDD\u62A4',
	          visible: true,
	          onCancel: function onCancel() {
	            return handleModalVisible(false);
	          },
	          onOk: this.submit
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.submit },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_SelectCustom2.default, Object.assign({}, this.props, { ItemLayout: {}, loaddata: this.getCustom }))
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u4FDD\u62A4\u65F6\u95F4' },
	                getFieldDecorator('protectionMaturityDate', {
	                  rules: [{ required: true, message: '请选择联阶段类型!' }]
	                })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_SelectUser2.default, Object.assign({}, this.props, {
	                field: {
	                  field: 'protectionUser',
	                  fieldName: '保护人',
	                  isRequire: true
	                },
	                data: {},
	                onChange: this.handleSelectChangge()
	              }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1527);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(1537);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _Index5 = __webpack_require__(1539);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _PageAdd = __webpack_require__(687);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	var _PageEdit = __webpack_require__(1529);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _Index7 = __webpack_require__(1531);
	
	var _Index8 = _interopRequireDefault(_Index7);
	
	var _PageAdd3 = __webpack_require__(1534);
	
	var _PageAdd4 = _interopRequireDefault(_PageAdd3);
	
	var _PageEdit3 = __webpack_require__(1536);
	
	var _PageEdit4 = _interopRequireDefault(_PageEdit3);
	
	var _PageContact = __webpack_require__(1535);
	
	var _PageContact2 = _interopRequireDefault(_PageContact);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = {
	  path: "custom",
	  breadcrumbName: "客户管理",
	  childRoutes: [{
	    path: "list",
	    breadcrumbName: "客户列表",
	    indexRoute: {
	      component: _Index2.default
	    }
	  }, {
	    path: "protect",
	    breadcrumbName: "客户保护监控列表",
	    indexRoute: {
	      component: _Index6.default
	    }
	  }, {
	    path: "department",
	    breadcrumbName: "分属部门客户管理",
	    indexRoute: {
	      component: _Index8.default
	    },
	    childRoutes: [{
	      path: ":uuid/contact",
	      breadcrumbName: "联系记录",
	      component: _PageContact2.default
	    }, {
	      path: "protect",
	      breadcrumbName: "保护列表",
	      component: _Index4.default
	    }, {
	      path: "add",
	      breadcrumbName: "客户添加",
	      component: _PageAdd4.default
	    }, {
	      path: ":uuid/edit",
	      breadcrumbName: "客户添加",
	      component: _PageEdit4.default
	    }]
	  }, {
	    path: "add",
	    breadcrumbName: "客户添加",
	    indexRoute: {
	      component: _PageAdd2.default
	    }
	  }, {
	    path: "edit/:uuid",
	    breadcrumbName: "客户修改",
	    indexRoute: {
	      component: _PageEdit2.default
	    }
	  }]
	}; /**
	    * routers
	    * 更多关于Router的使用，请参考以下教程
	    * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
	    */
	
	exports.default = router;

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _crm = __webpack_require__(33);
	
	var _org = __webpack_require__(53);
	
	var _ModalDepartment = __webpack_require__(1544);
	
	var _ModalDepartment2 = _interopRequireDefault(_ModalDepartment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getOrgList = function () {
	      (0, _org.queryOrgList)({
	        type: 1
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            orgList: res.data
	          });
	        }
	      });
	    };
	
	    _this.getData = function (pageNo) {
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      _this.setState({
	        pageNo: current
	      });
	      (0, _crm.queryDepartmentList)({
	        start: current
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.saveDepartment = function (params) {
	      (0, _crm.querySaveDepartment)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handleModalVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleChange = function (checked) {};
	
	    _this.handleSubmit = function (params) {
	      _this.saveDepartment(params);
	    };
	
	    _this.handleModalVisible = function (flag) {
	      _this.setState({
	        modalVisible: !!flag
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '编号',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '分属部门',
	        dataIndex: 'organizationName'
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/department/' + record.uuid + '/setInfo' },
	              '\u8BBE\u7F6E\u5BA2\u6237\u663E\u793A'
	            ),
	            _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/department/' + record.uuid + '/setProtect' },
	              '\u8BBE\u7F6E\u5BA2\u6237\u4FDD\u62A4\u9650\u5236'
	            ),
	            _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/department/' + record.uuid + '/stage/add' },
	              '\u8BBE\u7F6E\u5546\u673A\u9636\u6BB5'
	            ),
	            _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/department/' + record.uuid + '/setProject' },
	              '\u8BBE\u7F6E\u4EA7\u54C1'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      modalVisible: false,
	      orgList: [],
	      pageNo: 1,
	      total: 0
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.uuid = this.props.params.uuid;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	      this.getOrgList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          modalVisible = _state.modalVisible,
	          orgList = _state.orgList,
	          total = _state.total,
	          pageNo = _state.pageNo;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.getBusiness(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: function onClick() {
	                  return _this2.handleModalVisible(true);
	                } },
	              '\u6DFB\u52A0'
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        }),
	        modalVisible ? _react2.default.createElement(_ModalDepartment2.default, {
	          handleModalVisible: this.handleModalVisible,
	          handleSubmit: this.handleSubmit,
	          orgList: orgList
	        }) : null
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BaseForm);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function () {
	      var handleSubmit = _this.props.handleSubmit;
	
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handleSubmit({
	            organizationName: _this.organizationName,
	            organization: _this.organization
	          });
	        }
	      });
	    }, _this.handleChange = function (e, option) {
	      _this.organizationName = option.props.children;
	      _this.organization = e;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(BaseForm, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          handleModalVisible = _props.handleModalVisible,
	          orgList = _props.orgList;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u4FDD\u5B58',
	          visible: true,
	          onCancel: function onCancel() {
	            return handleModalVisible(false);
	          },
	          onOk: this.handleSubmit
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u7EC4\u7EC7\u540D\u79F0' },
	                getFieldDecorator('organizationName', {
	                  rules: [{ required: true, message: '请输入组织名称!' }]
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { onSelect: this.handleChange },
	                  orgList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.uuid },
	                      item.name
	                    );
	                  })
	                ))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _BackBtn = __webpack_require__(12);
	
	var _crm = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getCustomField = function () {
	      (0, _crm.queryCustomField)().then(function (res) {
	        if (res.statusCode === 200) {
	          var fields = res.data.map(function (item) {
	            return {
	              key: item.value,
	              value: item.key
	            };
	          });
	          _this.setState({
	            fields: fields
	          });
	        }
	      });
	    };
	
	    _this.getCustomView = function () {
	      (0, _crm.queryCustomView)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          var targetKeys = [];
	          var fields2 = [];
	          var targetKeys2 = [];
	          res.data.map(function (item) {
	            if (!item.field) {
	              return null;
	            }
	            targetKeys.push(item.field);
	            fields2.push({
	              key: item.field,
	              value: item.fieldName
	            });
	            if (item.isRequire) {
	              targetKeys2.push(item.field);
	            }
	            return item;
	          });
	          _this.setState({
	            targetKeys: targetKeys,
	            fields2: fields2,
	            targetKeys2: targetKeys2
	          });
	        }
	      });
	    };
	
	    _this.formatItem = function (key) {
	      var _this$state = _this.state,
	          fields = _this$state.fields,
	          targetKeys2 = _this$state.targetKeys2;
	
	      var filedItem = {};
	      var isRequire = 0;
	      fields.forEach(function (item, index) {
	        if (key === item.key) {
	          filedItem = fields[index];
	        }
	      });
	      if (targetKeys2.includes(key)) {
	        isRequire = 1;
	      }
	      return {
	        field: filedItem.key,
	        fieldName: filedItem.value,
	        isRequire: isRequire
	      };
	    };
	
	    _this.handleSubmit = function () {
	      var targetKeys = _this.state.targetKeys;
	
	
	      var config = [];
	      targetKeys.forEach(function (item) {
	        config.push(_this.formatItem(item));
	      });
	      var params = {
	        uuid: _this.props.params.uuid,
	        config: config
	      };
	      _this.saveCustomView(params);
	    };
	
	    _this.saveCustomView = function (params) {
	      (0, _crm.querySaveCustomView)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.setFields2 = function (nextTargetKeys) {
	      var fields = _this.state.fields;
	
	      var fields2 = [];
	      nextTargetKeys.forEach(function (key) {
	        fields2 = fields2.concat(fields.filter(function (item) {
	          return item.key === key;
	        }));
	      });
	      _this.setState({
	        fields2: fields2
	      });
	    };
	
	    _this.handleChange = function (nextTargetKeys) {
	      _this.setState({ targetKeys: nextTargetKeys });
	      _this.setFields2(nextTargetKeys);
	    };
	
	    _this.handleSelectChange = function (sourceSelectedKeys, targetSelectedKeys) {
	      _this.setState({
	        selectedKeys: [].concat(_toConsumableArray(sourceSelectedKeys), _toConsumableArray(targetSelectedKeys))
	      });
	    };
	
	    _this.handleChange2 = function (nextTargetKeys) {
	      _this.setState({ targetKeys2: nextTargetKeys });
	    };
	
	    _this.handleSelectChange2 = function (sourceSelectedKeys, targetSelectedKeys) {
	      _this.setState({
	        selectedKeys2: [].concat(_toConsumableArray(sourceSelectedKeys), _toConsumableArray(targetSelectedKeys))
	      });
	    };
	
	    _this.state = {
	      targetKeys: [],
	      selectedKeys: [],
	      fields: [],
	      targetKeys2: [],
	      selectedKeys2: [],
	      fields2: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCustomField();
	      this.getCustomView();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          targetKeys = _state.targetKeys,
	          selectedKeys = _state.selectedKeys,
	          fields = _state.fields;
	      var _state2 = this.state,
	          targetKeys2 = _state2.targetKeys2,
	          selectedKeys2 = _state2.selectedKeys2,
	          fields2 = _state2.fields2;
	
	
	      return _react2.default.createElement(
	        _antd.Card,
	        { title: '\u8BBE\u7F6E\u5BA2\u6237\u663E\u793A' },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u5BA2\u6237\u9ED8\u8BA4\u7684\u5B57\u6BB5\uFF1A\u540D\u5B57/\u8054\u7CFB\u4EBA/\u7535\u8BDD'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          FormItem,
	          { label: '\u8BBE\u7F6E\u663E\u793A\u5B57\u6BB5' },
	          _react2.default.createElement(_antd.Transfer, {
	            dataSource: fields,
	            titles: ['主要字段', '显示字段'],
	            targetKeys: targetKeys,
	            selectedKeys: selectedKeys,
	            onChange: this.handleChange,
	            onSelectChange: this.handleSelectChange,
	            render: function render(item) {
	              return item.value;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          FormItem,
	          { label: '\u8BBE\u7F6E\u5FC5\u586B\u5B57\u6BB5' },
	          _react2.default.createElement(_antd.Transfer, {
	            dataSource: fields2,
	            titles: ['显示字段', '必填字段'],
	            targetKeys: targetKeys2,
	            selectedKeys: selectedKeys2,
	            onChange: this.handleChange2,
	            onSelectChange: this.handleSelectChange2,
	            render: function render(item) {
	              return item.value;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24, style: { marginBottom: 15, textAlign: 'right' } },
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                style: { marginRight: 10 },
	                type: 'primary',
	                htmlType: 'submit',
	                onClick: this.handleSubmit
	              },
	              '\u786E\u5B9A'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { onClick: _BackBtn.goBack },
	              '\u53D6\u6D88'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _crm = __webpack_require__(33);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      e.preventDefault();
	      var config = _this.state.config;
	
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          var params = {
	            uuid: _this.props.params.uuid,
	            config: config
	          };
	          _this.postData(params);
	        }
	      });
	    };
	
	    _this.getData = function () {
	      (0, _crm.queryDepartmentProduct)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200 && res.data) {
	          res.data.map(function (item, index) {
	            item.key = index;
	            return item;
	          });
	          _this.setState({
	            config: res.data
	          });
	        }
	      });
	    };
	
	    _this.postData = function (params) {
	      (0, _crm.querySaveDepartmentProduct)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.addConfig = function () {
	      var config = _this.state.config;
	
	      var key = config[config.length - 1].key + 1;
	      _this.setState({
	        config: [].concat(_toConsumableArray(config), [{ key: key }])
	      });
	    };
	
	    _this.subConfig = function (key) {
	      var config = _this.state.config;
	
	      var configArr = config.filter(function (item) {
	        return item.key !== key;
	      });
	      _this.setState({
	        config: configArr
	      });
	    };
	
	    _this.handleChange = function (type, index) {
	      return function (e) {
	        var config = _this.state.config;
	
	        config[index][type] = e.target.value;
	
	        _this.setState({
	          config: config
	        });
	      };
	    };
	
	    _this.state = {
	      config: [{ key: 0 }]
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var config = this.state.config;
	
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      return _react2.default.createElement(
	        _antd.Card,
	        { title: '\u9636\u6BB5\u8BBE\u7F6E' },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.submit, className: '' },
	          config.map(function (item, index) {
	            return _react2.default.createElement(
	              _antd.Row,
	              { key: item.key },
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 6 },
	                _react2.default.createElement(
	                  FormItem,
	                  Object.assign({ label: '\u4EA7\u54C1\u540D\u79F0' }, ItemLayout),
	                  getFieldDecorator('name' + item.key, {
	                    rules: [{ required: true, message: '请填写产品名称!' }],
	                    initialValue: item.name
	                  })(_react2.default.createElement(_antd.Input, { onChange: _this2.handleChange('name', index) }))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 5 },
	                _react2.default.createElement(
	                  FormItem,
	                  { style: { textAlign: 'right' } },
	                  config.length - 1 === index ? _react2.default.createElement(
	                    _antd.Button,
	                    { type: 'primary', onClick: _this2.addConfig, style: { marginRight: 10 } },
	                    '+'
	                  ) : null,
	                  config.length === 1 ? null : _react2.default.createElement(
	                    _antd.Button,
	                    { onClick: function onClick() {
	                        return _this2.subConfig(item.key);
	                      } },
	                    '-'
	                  )
	                )
	              )
	            );
	          }),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: 15, textAlign: 'right' } },
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginRight: 10 }, type: 'primary', htmlType: 'submit' },
	                '\u786E\u5B9A'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { onClick: _BackBtn.goBack },
	                '\u53D6\u6D88'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _BackBtn = __webpack_require__(12);
	
	var _crm = __webpack_require__(33);
	
	__webpack_require__(2961);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var protect = {
	  termSelfNoRegistered: '自己挖掘的非注册客户保护期',
	  termSelfRegistered: '自己挖掘的注册客户保护期',
	  termPool: '开放客户池的保护期',
	  maxTerm: '最大保护期限制'
	};
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.formatParams = function (key, values) {
	      return {
	        unit: values[key + '-unit'],
	        term: values[key + '-term']
	      };
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var config = {};
	          config.termSelfNoRegistered = _this.formatParams('termSelfNoRegistered', values);
	          config.termSelfRegistered = _this.formatParams('termSelfRegistered', values);
	          config.maxTerm = _this.formatParams('maxTerm', values);
	          config.termPool = _this.formatParams('termPool', values);
	          config.limitPool = values.limitPool;
	          config.limitSelf = values.limitSelf;
	          config.termAmount = _this.state.termAmount;
	          var params = {
	            uuid: _this.uuid,
	            config: config
	          };
	          _this.handleSave(params);
	        }
	      });
	    };
	
	    _this.handleSave = function (params) {
	      (0, _crm.querySaveDepartmentProtection)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getData = function () {
	      (0, _crm.queryDepartmentProtection)({
	        uuid: _this.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200 && res.data) {
	          res.data.termAmount.map(function (item, index) {
	            item.key = index;
	            return item;
	          });
	          _this.setState({
	            termAmount: res.data.termAmount,
	            termSelfNoRegistered: res.data.termSelfNoRegistered,
	            termSelfRegistered: res.data.termSelfRegistered,
	            termPool: res.data.termPool,
	            maxTerm: res.data.maxTerm,
	            limitPool: res.data.limitPool,
	            limitSelf: res.data.limitSelf
	          });
	        } else if (res.statusCode !== 200) {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.addAmount = function () {
	      var termAmount = _this.state.termAmount;
	
	      var key = termAmount[termAmount.length - 1].key + 1;
	      _this.setState({
	        termAmount: [].concat(_toConsumableArray(termAmount), [{ term: {}, key: key }])
	      });
	    };
	
	    _this.subAmount = function (key) {
	      var termAmount = _this.state.termAmount;
	
	      var termAmountArr = termAmount.filter(function (item) {
	        return item.key !== key;
	      });
	      _this.setState({
	        termAmount: termAmountArr
	      });
	    };
	
	    _this.handleChange = function (index, key1, key2) {
	      return function (e) {
	        var termAmount = _this.state.termAmount;
	
	        if (key2) {
	          termAmount[index][key1][key2] = e;
	        } else {
	          termAmount[index][key1] = e;
	        }
	        _this.setState({
	          termAmount: termAmount
	        });
	      };
	    };
	
	    _this.renderFormItem = function (key) {
	      var form = _this.props.form;
	
	      var configItem = _this.state[key];
	      return _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          FormItem,
	          { label: protect[key] },
	          form.getFieldDecorator(key + '-term', {
	            rules: [{ required: true, message: '请输入 !' }],
	            initialValue: configItem.term
	          })(_react2.default.createElement(_antd.InputNumber, null))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          form.getFieldDecorator(key + '-unit', {
	            rules: [{ required: true, message: '请输入 !' }],
	            initialValue: configItem.unit ? '' + configItem.unit : '5'
	          })(_react2.default.createElement(
	            _antd.Select,
	            { style: { width: '80px' } },
	            _react2.default.createElement(
	              Option,
	              { key: '1' },
	              '\u5E74'
	            ),
	            _react2.default.createElement(
	              Option,
	              { key: '2' },
	              '\u6708'
	            ),
	            _react2.default.createElement(
	              Option,
	              { key: '5' },
	              '\u65E5'
	            )
	          ))
	        )
	      );
	    };
	
	    _this.renderTermAmount = function () {
	      var form = _this.props.form;
	      var getFieldDecorator = form.getFieldDecorator;
	      var termAmount = _this.state.termAmount;
	
	      return termAmount.map(function (item, index) {
	        return _react2.default.createElement(
	          _antd.Row,
	          { key: item.key },
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u6D88\u8D39\u91D1\u989D\u4FDD\u62A4\u671F' },
	            getFieldDecorator('amount' + item.key, {
	              rules: [{ required: true, message: '请填写消费金额!' }],
	              initialValue: item.amount
	            })(_react2.default.createElement(_antd.InputNumber, { onChange: _this.handleChange(index, 'amount') })),
	            '\u5143'
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('term' + item.key, {
	              rules: [{ required: true, message: '请填写保护时长!' }],
	              initialValue: item.term.term
	            })(_react2.default.createElement(_antd.InputNumber, { onChange: _this.handleChange(index, 'term', 'term') }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('unit' + item.key, {
	              rules: [{ required: true, message: '请选择时间单位!' }],
	              initialValue: item.term.unit ? '' + item.term.unit : '5'
	            })(_react2.default.createElement(
	              _antd.Select,
	              { style: { width: '80px' }, onChange: _this.handleChange(index, 'term', 'unit') },
	              _react2.default.createElement(
	                Option,
	                { key: '1' },
	                '\u5E74'
	              ),
	              _react2.default.createElement(
	                Option,
	                { key: '2' },
	                '\u6708'
	              ),
	              _react2.default.createElement(
	                Option,
	                { key: '5' },
	                '\u65E5'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            index === termAmount.length - 1 ? _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', style: { marginRight: '10px' }, onClick: _this.addAmount },
	              '+'
	            ) : null,
	            termAmount.length === 1 ? null : _react2.default.createElement(
	              _antd.Button,
	              { onClick: function onClick() {
	                  return _this.subAmount(item.key);
	                } },
	              '-'
	            )
	          )
	        );
	      });
	    };
	
	    _this.state = {
	      termAmount: [{ term: {}, key: 0 }],
	      termSelfNoRegistered: {},
	      termSelfRegistered: {},
	      termPool: {},
	      maxTerm: {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.uuid = this.props.params.uuid;
	      this.getData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var form = this.props.form;
	      var _state = this.state,
	          limitPool = _state.limitPool,
	          limitSelf = _state.limitSelf;
	
	
	      return _react2.default.createElement(
	        _antd.Card,
	        { title: '\u8BBE\u7F6E\u5BA2\u6237\u4FDD\u62A4\u9650\u5236' },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.handleSubmit, className: 'set-protect', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Card,
	            { title: '\u4FDD\u62A4\u8BBE\u7F6E', bordered: false },
	            this.renderFormItem('termSelfNoRegistered'),
	            this.renderFormItem('termSelfRegistered'),
	            this.renderFormItem('termPool'),
	            this.renderTermAmount()
	          ),
	          _react2.default.createElement(
	            _antd.Card,
	            { title: '\u4FDD\u62A4\u6570\u8BBE\u7F6E', bordered: false },
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u5F00\u653E\u5BA2\u6237\u4FDD\u62A4\u6570' },
	                form.getFieldDecorator('limitPool', {
	                  rules: [{ required: true, message: '请输入 !' }],
	                  initialValue: limitPool
	                })(_react2.default.createElement(_antd.InputNumber, null))
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'unit' },
	                '\u4E2A'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u81EA\u5DF1\u6316\u6398\u4FDD\u62A4\u6570' },
	                form.getFieldDecorator('limitSelf', {
	                  rules: [{ required: true, message: '请输入 !' }],
	                  initialValue: limitSelf
	                })(_react2.default.createElement(_antd.InputNumber, null))
	              ),
	              _react2.default.createElement(
	                'p',
	                { className: 'unit' },
	                '\u4E2A'
	              )
	            ),
	            this.renderFormItem('maxTerm')
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: 15, textAlign: 'right' } },
	              _react2.default.createElement(
	                _antd.Button,
	                { style: { marginRight: 10 }, type: 'primary', htmlType: 'submit' },
	                '\u786E\u5B9A'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { onClick: _BackBtn.goBack },
	                '\u53D6\u6D88'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1543);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _PageSetInfo = __webpack_require__(1545);
	
	var _PageSetInfo2 = _interopRequireDefault(_PageSetInfo);
	
	var _Index3 = __webpack_require__(1549);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _PageAdd = __webpack_require__(1550);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	var _PageEdit = __webpack_require__(1551);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageSetProtect = __webpack_require__(1547);
	
	var _PageSetProtect2 = _interopRequireDefault(_PageSetProtect);
	
	var _PageSetProject = __webpack_require__(1546);
	
	var _PageSetProject2 = _interopRequireDefault(_PageSetProject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = {
	  path: "department",
	  breadcrumbName: "分属部门管理",
	  childRoutes: [{
	    path: "list",
	    breadcrumbName: "部门列表",
	    component: _Index2.default
	  }, {
	    path: ":uuid/stage",
	    breadcrumbName: "阶段设置",
	    indexRoute: { component: _Index4.default },
	    childRoutes: [{
	      path: "add",
	      breadcrumbName: "阶段添加",
	      component: _PageAdd2.default
	    }, {
	      path: "edit",
	      breadcrumbName: "阶段编辑",
	      component: _PageEdit2.default
	    }]
	  }, {
	    path: ":uuid/setInfo",
	    breadcrumbName: "设置客户显示",
	    component: _PageSetInfo2.default
	  }, {
	    path: ":uuid/setProtect",
	    breadcrumbName: "设置客户保护限制",
	    component: _PageSetProtect2.default
	  }, {
	    path: ":uuid/setProject",
	    breadcrumbName: "设置客户保护限制",
	    component: _PageSetProject2.default
	  }]
	}; /**
	    * routers
	    * 更多关于Router的使用，请参考以下教程
	    * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
	    */
	
	exports.default = router;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _crm = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getData = function () {
	      (0, _crm.queryDepartmentOpportunity)({
	        uuid: _this.uuid
	      }).then(function (res) {
	        _this.setState({
	          data: res.data
	        });
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '编号',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '阶段',
	        dataIndex: 'name'
	      }, {
	        title: '预测百分比',
	        dataIndex: 'percentage',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text + '%'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.uuid = this.props.params.uuid;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/crm/department/' + this.uuid + '/stage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u8BBE\u7F6E\u9636\u6BB5'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, { rowKey: 'index', columns: this.columns(), dataSource: data })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _crm = __webpack_require__(33);
	
	var _FormStage = __webpack_require__(690);
	
	var _FormStage2 = _interopRequireDefault(_FormStage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.handleAdd = function (params) {
	      (0, _crm.querySaveDepartmentOpportunity)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormStage2.default, Object.assign({ handleSubmit: this.handleAdd }, this.props))
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { organization: state.organization };
	})(BaseForm);

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _crm = __webpack_require__(33);
	
	var _FormStage = __webpack_require__(690);
	
	var _FormStage2 = _interopRequireDefault(_FormStage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.handleAdd = function (params) {
	      (0, _crm.querySaveCustom)(params).then(function (res) {
	        if (res.code === 200) {
	          _antd.message.success(res.message);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormStage2.default, { handleSubmit: this.handleAdd })
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { organization: state.organization };
	})(BaseForm);

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _router = __webpack_require__(1548);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _router3 = __webpack_require__(1556);
	
	var _router4 = _interopRequireDefault(_router3);
	
	var _router5 = __webpack_require__(1525);
	
	var _router6 = _interopRequireDefault(_router5);
	
	var _router7 = __webpack_require__(1542);
	
	var _router8 = _interopRequireDefault(_router7);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 商机管理
	
	// 线索管理
	var router = {
	  path: 'crm',
	  breadcrumbName: '商机管理',
	  childRoutes: [_router2.default, _router4.default, _router6.default, _router8.default]
	}; // 商机管理
	// 分属部门
	exports.default = router;

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _crm = __webpack_require__(33);
	
	var _ModalThread = __webpack_require__(1555);
	
	var _ModalThread2 = _interopRequireDefault(_ModalThread);
	
	var _ModalImport = __webpack_require__(1554);
	
	var _ModalImport2 = _interopRequireDefault(_ModalImport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getData = function (pageNo) {
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      _this.setState({
	        pageNo: current
	      });
	      (0, _crm.queryClueList)({
	        start: current
	      }).then(function (res) {
	        _this.setState({
	          data: res.data,
	          total: res.totalSize
	        });
	      });
	    };
	
	    _this.handleModalVisible = function (flag, record) {
	      _this.record = record || {};
	      _this.setState({
	        modalVisible: !!flag
	      });
	    };
	
	    _this.handleImportModalVisible = function (flag, record) {
	      _this.record = record || {};
	      _this.setState({
	        importModalVisible: !!flag
	      });
	    };
	
	    _this.handleSubmit = function (params) {
	      (0, _crm.querySaveClue)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getData();
	          _this.handleModalVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleImport = function (params) {
	      (0, _crm.queryImportClue)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getData();
	          _this.handleImportModalVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '编号',
	        dataIndex: 'uuid',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '名称',
	        dataIndex: 'name'
	      }, {
	        title: '联系人',
	        dataIndex: 'contactName'
	      }, {
	        title: '联系人电话',
	        dataIndex: 'contactTel'
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.handleModalVisible(true, record);
	                } },
	              '\u7F16\u8F91'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      pageNo: 1,
	      total: 0,
	      modalVisible: false,
	      importModalVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          modalVisible = _state.modalVisible,
	          importModalVisible = _state.importModalVisible,
	          pageNo = _state.pageNo,
	          total = _state.total;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.getData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            'div',
	            { className: 'tableListOperator' },
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: function onClick() {
	                  return _this2.handleModalVisible(true);
	                } },
	              '\u6DFB\u52A0'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { type: 'primary', onClick: function onClick() {
	                  return _this2.handleImportModalVisible(true);
	                } },
	              '\u5BFC\u5165\u7EBF\u7D22'
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        }),
	        modalVisible ? _react2.default.createElement(_ModalThread2.default, {
	          handleModalVisible: this.handleModalVisible,
	          handleSubmit: this.handleSubmit,
	          detail: this.record
	        }) : null,
	        importModalVisible ? _react2.default.createElement(_ModalImport2.default, { cancel: this.handleImportModalVisible, handleSubmit: this.handleImport }) : null
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _crm = __webpack_require__(33);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var DetailModal = function (_Component) {
	  _inherits(DetailModal, _Component);
	
	  function DetailModal(props) {
	    _classCallCheck(this, DetailModal);
	
	    var _this = _possibleConstructorReturn(this, (DetailModal.__proto__ || Object.getPrototypeOf(DetailModal)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var fileUuid = '';
	      if (_this.state.licenseFile && _this.state.licenseFile.length > 0) {
	        fileUuid = _this.state.licenseFile[0].uuid;
	      }
	      var handleSubmit = _this.props.handleSubmit;
	
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handleSubmit({ fileUuid: fileUuid });
	        }
	      });
	    };
	
	    _this.handlelicenseFile = function (fileList) {
	      _this.setState({
	        licenseFile: fileList
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(DetailModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	
	      var date = new Date();
	      var year = date.getFullYear();
	      var years = [];
	      for (var i = year; i >= 2014; i--) {
	        years.push(i.toString());
	      }
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u5BFC\u5165', visible: true, onOk: this.submit, onCancel: function onCancel() {
	            return _this2.props.cancel(false);
	          } },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'horizontal' },
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u4E0A\u4F20Excel\u6587\u4EF6' }, formItemLayout, { required: true }),
	            _react2.default.createElement(_UploadFile2.default, { type: 'ghost', handleUpload: this.handlelicenseFile, isExcel: true }),
	            _react2.default.createElement(
	              'span',
	              { className: 'ant-form-text' },
	              '\xA0\u4EC5\u9650excel\u683C\u5F0F',
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return (0, _crm.queryDownloadClueTemplate)();
	                  }, style: { marginLeft: '10px' } },
	                '\u6A21\u677F\u4E0B\u8F7D'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DetailModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(DetailModal);

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _this$props = _this.props,
	          handleSubmit = _this$props.handleSubmit,
	          detail = _this$props.detail;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          if (detail.uuid) {
	            values.uuid = detail.uuid;
	          }
	          handleSubmit(values);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var ItemLayout2 = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      var _props = this.props,
	          handleModalVisible = _props.handleModalVisible,
	          detail = _props.detail;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: detail.uuid ? '编辑线索' : '新增线索',
	          visible: true,
	          onCancel: function onCancel() {
	            return handleModalVisible(false);
	          },
	          onOk: this.submit
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.submit },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u540D\u79F0' }, ItemLayout2),
	                getFieldDecorator('name', {
	                  rules: [{ required: true, message: '请输入线索名称!' }],
	                  initialValue: detail.name
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8054\u7CFB\u4EBA\u540D\u79F0' }, ItemLayout2),
	                getFieldDecorator('contactName', {
	                  rules: [{ required: true, message: '请选择联系人名称!' }],
	                  initialValue: detail.contactName
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8054\u7CFB\u4EBA\u7535\u8BDD' }, ItemLayout2),
	                getFieldDecorator('contactTel', {
	                  rules: [{ required: true, message: '请选择联系人电话!' }],
	                  initialValue: detail.contactTel
	                })(_react2.default.createElement(_antd.Input, null))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(BaseForm);

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1553);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = {
	  path: "thread",
	  breadcrumbName: "线索管理",
	  childRoutes: [{
	    path: "list",
	    breadcrumbName: "线索列表",
	    component: _Index2.default
	  }]
	}; /**
	    * routers
	    * 更多关于Router的使用，请参考以下教程
	    * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
	    */
	
	exports.default = router;

/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _attachment = __webpack_require__(27);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.formatFile = function (fileList) {
	      var file = [];
	      fileList.map(function (item) {
	        var fileItem = {};
	        fileItem.uuid = item.uuid;
	        fileItem.url = item.url;
	        fileItem.size = item.size;
	        fileItem.name = item.name;
	        fileItem.suffix = item.name.split('.')[1];
	        file.push(fileItem);
	        return file;
	      });
	      return file;
	    };
	
	    _this.fixFileArr = function (file) {
	      var fileArr = [];
	      var fileItem = {};
	      if (file) {
	        fileItem.uid = file.uuid;
	        fileItem.name = file.name;
	        fileItem.status = 'done';
	        fileItem.url = file.url;
	        fileArr.push(fileItem);
	      }
	      return fileArr;
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var saveBase = _this.props.saveBase;
	
	      var custom = _this.props.form.getFieldsValue();
	      var _this$state = _this.state,
	          legalCodeFile = _this$state.legalCodeFile,
	          licenseFile = _this$state.licenseFile;
	
	      if (legalCodeFile.length) {
	        custom.legalCodeFile = _this.formatFile(legalCodeFile)[0];
	        custom.legalCodeFileUuid = custom.legalCodeFile.uuid;
	      }
	      if (licenseFile.length) {
	        custom.licenseFile = _this.formatFile(licenseFile)[0];
	        custom.licenseFileUuid = custom.licenseFile.uuid;
	      }
	      custom.date = custom.date ? custom.date._d.getTime() : '';
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          saveBase(custom);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function () {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.handlelicenseFile = function (fileList) {
	      _this.setState({
	        licenseFile: fileList
	      });
	    };
	
	    _this.handlelegalCodeFile = function (fileList) {
	      _this.setState({
	        legalCodeFile: fileList
	      });
	    };
	
	    _this.changePage = function () {
	      _this.props.changePage(2);
	    };
	
	    _this.handleClick = function () {};
	
	    _this.handleChange = function (value) {
	      _this.setState({
	        type: value
	      });
	    };
	
	    _this.state = {
	      // type:'1',
	      type: _this.props.data.type,
	      legalCodeFile: [],
	      licenseFile: [],
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.data.type !== this.props.data.type) {
	        this.setState({
	          type: '' + nextProps.data.type
	        });
	      }
	    }
	
	    /**
	     *文件删除
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var data = this.props.data;
	
	      var typedata = data.typedata || {};
	      var legalCodeFile = this.fixFileArr(data.legalCodeFile);
	      var licenseFile = this.fixFileArr(data.licenseFile);
	      if (data.type === 0) {
	        data.type = '0';
	      }
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15, marginTop: '-45px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u57FA\u672C\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5BA2\u6237\u7C7B\u578B' }, ItemLayout),
	                getFieldDecorator('type', {
	                  rules: [{ required: true, message: '请选择客户类型!' }],
	                  initialValue: '' + typedata.type
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { size: 'large', onChange: this.handleChange },
	                  _react2.default.createElement(
	                    Option,
	                    { key: '1', value: '1' },
	                    '\u516C\u53F8'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { key: '0', value: '0' },
	                    '\u4E2A\u4EBA'
	                  )
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5BA2\u6237\u540D\u79F0' }, ItemLayout),
	                getFieldDecorator('name', {
	                  rules: [{ required: true, message: '客户名称!' }],
	                  initialValue: data.name
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5BA2\u6237\u540D\u79F0' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8054\u7CFB\u4EBA' }, ItemLayout),
	                getFieldDecorator('contactsName', {
	                  rules: [{ required: true, message: '请输入联系人姓名!' }],
	                  initialValue: data.contactsName
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u8054\u7CFB\u4EBA' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u804C\u4F4D' }, ItemLayout),
	                getFieldDecorator('contactsPost', {
	                  initialValue: data.contactsPost
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u804C\u4F4D' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8054\u7CFB\u65B9\u5F0F' }, ItemLayout),
	                getFieldDecorator('contactsPhone', {
	                  rules: [{ required: true, message: '请输入联系人电话!' }],
	                  initialValue: data.contactsPhone
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u8054\u7CFB\u65B9\u5F0F' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5FAE\u4FE1' }, ItemLayout),
	                getFieldDecorator('contactsWx', {
	                  initialValue: data.contactsWx
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5FAE\u4FE1' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u90AE\u7BB1' }, ItemLayout),
	                getFieldDecorator('contactsEmail', {
	                  initialValue: data.contactsEmail
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u90AE\u7BB1' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u901A\u4FE1\u5730\u5740' }, ItemLayout),
	                getFieldDecorator('contactsAddr', {
	                  initialValue: data.contactsAddr
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u901A\u4FE1\u5730\u5740' }))
	              )
	            )
	          )
	        ),
	        this.state.type !== '0' ? _react2.default.createElement(
	          _antd.Card,
	          { title: '\u516C\u53F8\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u516C\u53F8\u540D\u79F0' }, ItemLayout),
	                getFieldDecorator('organizationName', {
	                  rules: [{ required: true, message: '请输入公司名称!' }],
	                  initialValue: data.organizationName || '帮实'
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u516C\u53F8\u540D\u79F0' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7EDF\u4E00\u793E\u4F1A\u4FE1\u7528\u4EE3\u7801' }, ItemLayout),
	                getFieldDecorator('organizingCode', {
	                  rules: [{ required: true, message: '请输入统一社会信用代码!' }],
	                  initialValue: data.organizingCode
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u7EDF\u4E00\u793E\u4F1A\u4FE1\u7528\u4EE3\u7801' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6CE8\u518C\u5730\u5740' }, ItemLayout),
	                getFieldDecorator('registerAddress', {
	                  rules: [{ required: true, message: '请输入注册地址!' }],
	                  initialValue: data.registerAddress
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u6CE8\u518C\u5730\u5740' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u6210\u7ACB\u65F6\u95F4' }, ItemLayout),
	                getFieldDecorator('date', {
	                  initialValue: data.date ? (0, _moment2.default)(data.date) : null
	                })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8425\u4E1A\u6267\u7167\u4E0A\u4F20' }, ItemLayout),
	                _react2.default.createElement(_UploadFile2.default, {
	                  type: 'ghost',
	                  handleUpload: this.handlelicenseFile,
	                  fileList: licenseFile,
	                  onRemove: this.fileRemove
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u516C\u53F8\u89C4\u6A21' }, ItemLayout),
	                getFieldDecorator('scale', {
	                  initialValue: data.scale
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u516C\u53F8\u89C4\u6A21' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u516C\u53F8\u5B98\u7F51' }, ItemLayout),
	                getFieldDecorator('website', {
	                  rules: [{ required: true, message: '请输入公司官网!' }],
	                  initialValue: data.website
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u516C\u53F8\u5B98\u7F51' }))
	              )
	            )
	          )
	        ) : '',
	        this.state.type !== '0' ? _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6CD5\u4EBA\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u59D3\u540D' }, ItemLayout),
	                getFieldDecorator('legalName', {
	                  initialValue: data.legalName
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u59D3\u540D' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8EAB\u4EFD\u8BC1\u53F7' }, ItemLayout),
	                getFieldDecorator('legalCode', {
	                  initialValue: data.legalCode
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u8EAB\u4EFD\u8BC1\u53F7' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8054\u7CFB\u65B9\u5F0F' }, ItemLayout),
	                getFieldDecorator('legalPhone', {
	                  initialValue: data.legalPhone
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u8054\u7CFB\u65B9\u5F0F' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u8EAB\u4EFD\u8BC1\u4E0A\u4F20' }, ItemLayout),
	                _react2.default.createElement(_UploadFile2.default, {
	                  type: 'ghost',
	                  handleUpload: this.handlelegalCodeFile,
	                  fileList: legalCodeFile,
	                  onRemove: this.fileRemove
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5FAE\u4FE1\u53F7' }, ItemLayout),
	                getFieldDecorator('legalWx', {
	                  initialValue: data.legalWx
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5FAE\u4FE1\u53F7' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u90AE\u7BB1' }, ItemLayout),
	                getFieldDecorator('legalEmail', {
	                  initialValue: data.legalEmail
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u90AE\u7BB1' }))
	              )
	            )
	          )
	        ) : '',
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u5176\u4ED6' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u77E5\u8BC6\u4EA7\u6743\u60C5\u51B5' }, ItemLayout),
	                getFieldDecorator('intellectual', {
	                  initialValue: data.intellectual
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u77E5\u8BC6\u4EA7\u6743\u60C5\u51B5' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u79D1\u6280\u9879\u76EE\u7533\u8BF7\u60C5\u51B5' }, ItemLayout),
	                getFieldDecorator('technology', {
	                  initialValue: data.technology
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u79D1\u6280\u9879\u76EE\u7533\u8BF7\u60C5\u51B5' }))
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15 } },
	          _react2.default.createElement(
	            _antd.Button,
	            { icon: 'save', style: { marginRight: 10 }, type: 'primary', htmlType: 'submit' },
	            '\u4E0B\u4E00\u6B65'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { icon: 'save', style: { marginRight: 10 }, htmlType: 'submit' },
	            '\u6682\u5B58'
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { organization: state.organization };
	})(_antd.Form.create({ wrappedComponentRef: true })(BaseForm));

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _custom = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getCustomList = function (pageNo, pageSize) {
	      var params = {};
	      params.pageNo = pageNo || 1;
	      params.pageSize = pageSize || 15;
	      (0, _custom.queryCustomList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data.result,
	            total: res.data.totalCount,
	            pageSize: res.data.pageSize,
	            nowPage: res.data.pageNo
	          });
	        }
	      });
	    };
	
	    _this.deleteCustom = function (uuid) {
	      var context = _this;
	      var _this$state = _this.state,
	          nowPage = _this$state.nowPage,
	          pageSize = _this$state.pageSize;
	
	      (0, _custom.queryDeleteCustom)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('删除成功');
	          context.getCustomList(nowPage, pageSize);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '客户名称',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/custom/base/edit/' + record.uuid },
	            record.name
	          );
	        }
	      }, {
	        title: '曾用名',
	        dataIndex: 'usedName',
	        key: 'usedName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.usedName
	          );
	        }
	      }, {
	        title: '客户类型',
	        dataIndex: 'type',
	        key: 'type',
	        render: function render(text) {
	          return text === 1 ? _react2.default.createElement(
	            'span',
	            null,
	            '\u516C\u53F8'
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u4E2A\u4EBA'
	          );
	        }
	      }, {
	        title: '公司官网',
	        dataIndex: 'website',
	        key: 'website',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.website
	          );
	        }
	      }, {
	        title: '行业类型',
	        dataIndex: 'industry',
	        key: 'industry',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.industry
	          );
	        }
	      }, {
	        title: '联系人姓名',
	        dataIndex: 'contactsName',
	        key: 'contactsName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.contactsName
	          );
	        }
	      }, {
	        title: '联系人电话',
	        dataIndex: 'contactsPhone',
	        key: 'contactsPhone',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.contactsPhone
	          );
	        }
	      }, {
	        title: '资金列表',
	        dataIndex: 'bill',
	        key: 'bill',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/custom/base/' + record.uuid + '/bill' },
	            '\u8D44\u91D1\u5217\u8868'
	          );
	        }
	      }, {
	        title: '公司列表',
	        dataIndex: 'company',
	        key: 'company',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/custom/base/' + record.uuid + '/company' },
	            '\u516C\u53F8\u5217\u8868'
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                onConfirm: function onConfirm() {
	                  return _this.deleteCustom(record.uuid);
	                },
	                title: '\u786E\u5B9A\u5220\u9664\u5F53\u524D\u7EC4\u7EC7\u5417\uFF1F',
	                placement: 'topRight',
	                overlayStyle: { width: 200 }
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'ant-dropdown-link' },
	                '\u5220\u9664'
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      total: 0,
	      pageSize: 15,
	      nowPage: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCustomList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	      var _state = this.state,
	          pageSize = _state.pageSize,
	          total = _state.total;
	
	      var pagination = {
	        total: total,
	        showSizeChanger: true,
	        pageSize: pageSize,
	        onShowSizeChange: function onShowSizeChange(current, size) {
	          _this2.getCustomList(current, size);
	        },
	        onChange: function onChange(current) {
	          _this2.getCustomList(current, pageSize);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/custom/base/add' },
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', icon: 'plus', style: { marginBottom: 15 } },
	            '\u6DFB\u52A0'
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          style: { background: '#fff' },
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _custom = __webpack_require__(131);
	
	var _PageAdd2 = __webpack_require__(692);
	
	var _PageAdd3 = _interopRequireDefault(_PageAdd2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Edit = function (_PageAdd) {
	  _inherits(Edit, _PageAdd);
	
	  function Edit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Edit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Edit.__proto__ || Object.getPrototypeOf(Edit)).call.apply(_ref, [this].concat(args))), _this), _this.loadData = function (uuid) {
	      var context = _this;
	      (0, _custom.queryCustomInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({ customInfo: res.data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Edit, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.routeParams.uuid;
	
	      this.loadData(uuid);
	    }
	  }]);
	
	  return Edit;
	}(_PageAdd3.default);
	
	exports.default = Edit;

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _custom = __webpack_require__(131);
	
	var _FormProEdit = __webpack_require__(691);
	
	var _FormProEdit2 = _interopRequireDefault(_FormProEdit);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Edit = function (_Component) {
	  _inherits(Edit, _Component);
	
	  function Edit(props) {
	    _classCallCheck(this, Edit);
	
	    var _this = _possibleConstructorReturn(this, (Edit.__proto__ || Object.getPrototypeOf(Edit)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      var context = _this;
	      (0, _custom.querySaveCustom)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('保存成功');
	          context.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(Edit, [{
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      return _react2.default.createElement(_FormProEdit2.default, { handSubmit: this.handSubmit, data: dataInfo });
	    }
	  }]);
	
	  return Edit;
	}(_react.Component);
	
	exports.default = Edit;

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _custom = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getCustomBillList = function (uuid, pageNo, pageSize) {
	      var params = {};
	      params.customerUuid = uuid;
	      params.pageNo = pageNo || 1;
	      params.pageSize = pageSize || 15;
	      (0, _custom.queryCustomBillList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data.result,
	            total: res.data.totalCount,
	            pageSize: res.data.pageSize,
	            nowPage: res.data.pageNo
	          });
	        }
	      });
	    };
	
	    _this.getCustomBillInfo = function (uuid) {
	      (0, _custom.queryCustomBillInfo)(uuid).then(function () {});
	    };
	
	    _this.deleteCustomBill = function (uuid) {
	      var context = _this;
	      var _this$state = _this.state,
	          nowPage = _this$state.nowPage,
	          pageSize = _this$state.pageSize;
	
	      (0, _custom.queryDeleteCustomBill)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('删除成功');
	          context.getCustomBillList(nowPage, pageSize);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '账户名称',
	        dataIndex: 'accountName',
	        key: 'accountName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/custom/base/edit/' + record.uuid },
	            record.bill.accountName
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                onConfirm: function onConfirm() {
	                  return _this.deleteCustomBill(record.uuid);
	                },
	                title: '\u786E\u5B9A\u5220\u9664\u5F53\u524D\u7EC4\u7EC7\u5417\uFF1F',
	                placement: 'topRight',
	                overlayStyle: { width: 200 }
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'ant-dropdown-link' },
	                '\u5220\u9664'
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      total: 0,
	      pageSize: 15,
	      nowPage: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.params.uuid;
	
	      this.getCustomBillList(uuid, 1, 15);
	      this.getCustomBillInfo('c5213f9a5a1611e7ad2600163e0025a0');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	      var _state = this.state,
	          pageSize = _state.pageSize,
	          total = _state.total;
	      var uuid = this.props.params.uuid;
	
	      var pagination = {
	        total: total,
	        showSizeChanger: true,
	        pageSize: pageSize,
	        onShowSizeChange: function onShowSizeChange(current, size) {
	          _this2.getCustomBillList(current, size);
	        },
	        onChange: function onChange(current) {
	          _this2.getCustomBillList(current, pageSize);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/custom/base/' + uuid + '/bill/add' },
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', icon: 'plus', style: { marginBottom: 15 } },
	            '\u6DFB\u52A0'
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          style: { background: '#fff' },
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _custom = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getCustomCompany = function () {
	      var params = {};
	      params.customerUuid = _this.props.params.uuid;
	      (0, _custom.queryCustomCompany)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.data.totalCount,
	            pageSize: res.data.pageSize,
	            nowPage: res.data.pageNo
	          });
	        }
	      });
	    };
	
	    _this.deleteCustom = function (uuid) {
	      var context = _this;
	      var _this$state = _this.state,
	          nowPage = _this$state.nowPage,
	          pageSize = _this$state.pageSize;
	
	      (0, _custom.queryDeleteCustom)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('删除成功');
	          context.getCustomCompany(nowPage, pageSize);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '公司名称',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }, {
	        title: '客户类型',
	        dataIndex: 'type',
	        key: 'type',
	        render: function render(text) {
	          return text === 1 ? _react2.default.createElement(
	            'span',
	            null,
	            '\u516C\u53F8'
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u4E2A\u4EBA'
	          );
	        }
	      }, {
	        title: '公司官网',
	        dataIndex: 'website',
	        key: 'website',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.website
	          );
	        }
	      }, {
	        title: '行业类型',
	        dataIndex: 'industry',
	        key: 'industry',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.industry
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                onConfirm: function onConfirm() {
	                  return _this.deleteCustom(record.uuid);
	                },
	                title: '\u786E\u5B9A\u5220\u9664\u5F53\u524D\u7EC4\u7EC7\u5417\uFF1F',
	                placement: 'topRight',
	                overlayStyle: { width: 200 }
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'ant-dropdown-link' },
	                '\u5220\u9664'
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      total: 0,
	      pageSize: 15,
	      nowPage: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCustomCompany();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	
	      var customerUuid = this.props.params.uuid;
	      var _state = this.state,
	          pageSize = _state.pageSize,
	          total = _state.total;
	
	      var pagination = {
	        total: total,
	        showSizeChanger: true,
	        pageSize: pageSize,
	        onShowSizeChange: function onShowSizeChange(current, size) {
	          _this2.getCustomCompany(current, size);
	        },
	        onChange: function onChange(current) {
	          _this2.getCustomCompany(current, pageSize);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/custom/base/' + customerUuid + '/company/add' },
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', icon: 'plus', style: { marginBottom: 15 } },
	            '\u6DFB\u52A0'
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          style: { background: '#fff' },
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _BackBtn = __webpack_require__(12);
	
	var _custom = __webpack_require__(131);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Add = function (_Component) {
	  _inherits(Add, _Component);
	
	  function Add(props) {
	    _classCallCheck(this, Add);
	
	    var _this = _possibleConstructorReturn(this, (Add.__proto__ || Object.getPrototypeOf(Add)).call(this, props));
	
	    _this.loadData = function () {
	      var context = _this;
	      var params = {};
	      params.customerUuid = _this.props.params.uuid;
	      (0, _custom.queryCustomCompany)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var datas = [];
	          for (var i = 0; i < res.data.length; i++) {
	            datas.push(res.data[i].uuid);
	          }
	          context.setState({ targetKeys: datas });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getOrganiztion = function () {
	      var context = _this;
	      var params = {};
	      params.type = 1;
	      (0, _org.queryOrgCompanyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({ data: res.data.result });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.save = function () {
	      var uuid = _this.props.params.uuid;
	
	      var params = {};
	      params.customUuid = uuid;
	      params.orgUuids = _this.state.targetKeys;
	      (0, _custom.querySaveCustomCompany)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('保存成功');
	          (0, _BackBtn.goBack)();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleChange = function (nextTargetKeys) {
	      _this.setState({ targetKeys: nextTargetKeys });
	    };
	
	    _this.handleSelectChange = function (sourceSelectedKeys, targetSelectedKeys) {
	      _this.setState({
	        selectedKeys: [].concat(_toConsumableArray(sourceSelectedKeys), _toConsumableArray(targetSelectedKeys))
	      });
	    };
	
	    _this.state = {
	      data: [],
	      targetKeys: [],
	      selectedKeys: []
	    };
	    return _this;
	  }
	
	  _createClass(Add, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var uuid = this.props.routeParams.uuid;
	
	      this.loadData(uuid);
	      this.getOrganiztion();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var state = this.state;
	
	      return _react2.default.createElement(
	        _antd.Layout,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15 } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            { icon: 'save', style: { marginRight: 10 }, onClick: this.save },
	            '\u4FDD\u5B58'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_antd.Transfer, {
	            rowKey: function rowKey(record) {
	              return record.uuid;
	            },
	            dataSource: state.data,
	            listStyle: { width: 300, height: 400 },
	            titles: ['所有公司', '客户公司'],
	            targetKeys: state.targetKeys,
	            selectedKeys: state.selectedKeys,
	            onChange: this.handleChange,
	            onSelectChange: this.handleSelectChange,
	            render: function render(item) {
	              return item.name;
	            },
	            notFoundContent: '\u6682\u65E0\u516C\u53F8'
	          })
	        )
	      );
	    }
	  }]);
	
	  return Add;
	}(_react.Component);
	
	exports.default = Add;

/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _custom = __webpack_require__(131);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getOrganiztion = function (pageNo, pageSize) {
	      var context = _this;
	      var params = {};
	      params.type = 1;
	      params.pageNo = pageNo || 1;
	      params.pageSize = pageSize || 10;
	      (0, _org.queryOrgCompanyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data.result,
	            pageSize: res.data.pageSize
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deleteCustom = function (uuid) {
	      var context = _this;
	      var _this$state = _this.state,
	          nowPage = _this$state.nowPage,
	          pageSize = _this$state.pageSize;
	
	      (0, _custom.queryDeleteCustom)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('删除成功');
	          context.getCustomCompany(nowPage, pageSize);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '公司名称',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            null,
	            record.name
	          );
	        }
	      }, {
	        title: '客户列表',
	        dataIndex: 'custom',
	        key: 'custom',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/custom/company/' + record.uuid + '/custom' },
	            '\u5BA2\u6237\u5217\u8868'
	          );
	        }
	      }, {
	        title: '资金列表',
	        dataIndex: 'bill',
	        key: 'bill',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/custom/company/' + record.uuid + '/bill' },
	            '\u8D44\u91D1\u5217\u8868'
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/custom/company/' + record.uuid + '/custom' },
	              '\u5BA2\u6237\u5173\u8054'
	            ),
	            _react2.default.createElement('span', { className: 'ant-divider' }),
	            _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                onConfirm: function onConfirm() {
	                  return _this.deleteCustom(record.uuid);
	                },
	                title: '\u786E\u5B9A\u5220\u9664\u5F53\u524D\u7EC4\u7EC7\u5417\uFF1F',
	                placement: 'topRight',
	                overlayStyle: { width: 200 }
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'ant-dropdown-link' },
	                '\u5220\u9664'
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      total: 0,
	      pageSize: 10,
	      nowPage: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getOrganiztion();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	      var _state = this.state,
	          pageSize = _state.pageSize,
	          total = _state.total;
	
	      var pagination = {
	        total: total,
	        showSizeChanger: true,
	        pageSize: pageSize,
	        onShowSizeChange: function onShowSizeChange(current, size) {
	          _this2.getOrganiztion(current, size);
	        },
	        onChange: function onChange(current) {
	          _this2.getOrganiztion(current, pageSize);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          style: { background: '#fff' },
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _BackBtn = __webpack_require__(12);
	
	var _custom = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Add = function (_Component) {
	  _inherits(Add, _Component);
	
	  function Add(props) {
	    _classCallCheck(this, Add);
	
	    var _this = _possibleConstructorReturn(this, (Add.__proto__ || Object.getPrototypeOf(Add)).call(this, props));
	
	    _this.loadData = function () {
	      var context = _this;
	      var params = {};
	      params.orgUuid = _this.props.params.uuid;
	      (0, _custom.queryCompanyCustomList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var datas = [];
	          for (var i = 0; i < res.data.length; i++) {
	            datas.push(res.data[i].uuid);
	          }
	          context.setState({ targetKeys: datas });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getCustomList = function (pageNo, pageSize) {
	      var params = {};
	      params.pageNo = pageNo || 1;
	      params.pageSize = pageSize || 15;
	      (0, _custom.queryCustomList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data.result
	          });
	        }
	      });
	    };
	
	    _this.save = function () {
	      var uuid = _this.props.params.uuid;
	
	      var params = {};
	      params.orgUuid = uuid;
	      params.customUuids = _this.state.targetKeys;
	      (0, _custom.querySaveCompanyCustom)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('保存成功');
	          (0, _BackBtn.goBack)();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleChange = function (nextTargetKeys) {
	      _this.setState({ targetKeys: nextTargetKeys });
	    };
	
	    _this.handleSelectChange = function (sourceSelectedKeys, targetSelectedKeys) {
	      _this.setState({
	        selectedKeys: [].concat(_toConsumableArray(sourceSelectedKeys), _toConsumableArray(targetSelectedKeys))
	      });
	    };
	
	    _this.state = {
	      data: [],
	      targetKeys: [],
	      selectedKeys: []
	    };
	    return _this;
	  }
	
	  _createClass(Add, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var uuid = this.props.routeParams.uuid;
	
	      this.loadData(uuid);
	      this.getCustomList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var state = this.state;
	
	      return _react2.default.createElement(
	        _antd.Layout,
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15 } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            { icon: 'save', style: { marginRight: 10 }, onClick: this.save },
	            '\u4FDD\u5B58'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_antd.Transfer, {
	            rowKey: function rowKey(record) {
	              return record.uuid;
	            },
	            dataSource: state.data,
	            listStyle: { width: 300, height: 400 },
	            titles: ['所有客户', '关联客户'],
	            targetKeys: state.targetKeys,
	            selectedKeys: state.selectedKeys,
	            onChange: this.handleChange,
	            onSelectChange: this.handleSelectChange,
	            render: function render(item) {
	              return item.name;
	            },
	            notFoundContent: '\u6682\u65E0\u5BA2\u6237'
	          })
	        )
	      );
	    }
	  }]);
	
	  return Add;
	}(_react.Component);
	
	exports.default = Add;

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _custom = __webpack_require__(131);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getCompanyCustomList = function () {
	      var orgUuid = _this.props.params.uuid;
	      var params = {};
	      params.orgUuid = orgUuid;
	      (0, _custom.queryCompanyCustomList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.data.totalCount,
	            pageSize: res.data.pageSize,
	            nowPage: res.data.pageNo
	          });
	        }
	      });
	    };
	
	    _this.deleteCustom = function (uuid) {
	      var context = _this;
	      var _this$state = _this.state,
	          nowPage = _this$state.nowPage,
	          pageSize = _this$state.pageSize;
	
	      (0, _custom.queryDeleteCustom)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('删除成功');
	          context.getCompanyCustomList(nowPage, pageSize);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '客户名称',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/custom/base/edit/' + record.uuid },
	            record.name
	          );
	        }
	      }, {
	        title: '曾用名',
	        dataIndex: 'usedName',
	        key: 'usedName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.usedName
	          );
	        }
	      }, {
	        title: '客户类型',
	        dataIndex: 'type',
	        key: 'type',
	        render: function render(text) {
	          return text === 1 ? _react2.default.createElement(
	            'span',
	            null,
	            '\u516C\u53F8'
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u4E2A\u4EBA'
	          );
	        }
	      }, {
	        title: '公司官网',
	        dataIndex: 'website',
	        key: 'website',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.website
	          );
	        }
	      }, {
	        title: '行业类型',
	        dataIndex: 'industry',
	        key: 'industry',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.industry
	          );
	        }
	      }, {
	        title: '联系人姓名',
	        dataIndex: 'contactsName',
	        key: 'contactsName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.contactsName
	          );
	        }
	      }, {
	        title: '联系人电话',
	        dataIndex: 'contactsPhone',
	        key: 'contactsPhone',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.contactsPhone
	          );
	        }
	      }, {
	        title: '资金列表',
	        dataIndex: 'bill',
	        key: 'bill',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/custom/base/' + record.uuid + '/bill' },
	            '\u8D44\u91D1\u5217\u8868'
	          );
	        }
	      }, {
	        title: '公司列表',
	        dataIndex: 'company',
	        key: 'company',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/custom/base/' + record.uuid + '/company' },
	            '\u516C\u53F8\u5217\u8868'
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                onConfirm: function onConfirm() {
	                  return _this.deleteCustom(record.uuid);
	                },
	                title: '\u786E\u5B9A\u5220\u9664\u5F53\u524D\u7EC4\u7EC7\u5417\uFF1F',
	                placement: 'topRight',
	                overlayStyle: { width: 200 }
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'ant-dropdown-link' },
	                '\u5220\u9664'
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      total: 0,
	      pageSize: 15,
	      nowPage: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getCompanyCustomList();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	      var _state = this.state,
	          pageSize = _state.pageSize,
	          total = _state.total;
	      var uuid = this.props.params.uuid;
	
	      var pagination = {
	        total: total,
	        showSizeChanger: true,
	        pageSize: pageSize,
	        onShowSizeChange: function onShowSizeChange(current, size) {
	          _this2.getCompanyCustomList(current, size);
	        },
	        onChange: function onChange(current) {
	          _this2.getCompanyCustomList(current, pageSize);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _reactRouter.Link,
	          { to: '/custom/company/' + uuid + '/custom/add' },
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', icon: 'plus', style: { marginBottom: 15 } },
	            '\u6DFB\u52A0'
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          style: { background: '#fff' },
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1558);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _PageAdd = __webpack_require__(692);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	var _PageEdit = __webpack_require__(1559);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageProAdd = __webpack_require__(1560);
	
	var _PageProAdd2 = _interopRequireDefault(_PageProAdd);
	
	var _Index3 = __webpack_require__(1562);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _PageConfig = __webpack_require__(1565);
	
	var _PageConfig2 = _interopRequireDefault(_PageConfig);
	
	var _PageAdd3 = __webpack_require__(1563);
	
	var _PageAdd4 = _interopRequireDefault(_PageAdd3);
	
	var _Index5 = __webpack_require__(1561);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _Index7 = __webpack_require__(1564);
	
	var _Index8 = _interopRequireDefault(_Index7);
	
	var _Index9 = __webpack_require__(1566);
	
	var _Index10 = _interopRequireDefault(_Index9);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 客户
	var router = {
	  path: 'custom',
	  breadcrumbName: '客户',
	  childRoutes: [{
	    path: 'base',
	    breadcrumbName: '客户总表',
	    indexRoute: { component: _Index2.default },
	    childRoutes: [{
	      path: 'add',
	      breadcrumbName: '新增客户',
	      component: _PageAdd2.default
	    }, {
	      path: 'addPro',
	      breadcrumbName: '项目信息',
	      component: _PageProAdd2.default
	    }, {
	      path: 'edit/:uuid',
	      breadcrumbName: '编辑',
	      component: _PageEdit2.default
	    }, {
	      path: ':uuid/bill',
	      breadcrumbName: '资金列表',
	      indexRoute: { component: _Index6.default },
	      childRoutes: []
	    }, {
	      path: ':uuid/company',
	      breadcrumbName: '公司列表',
	      indexRoute: { component: _Index4.default },
	      childRoutes: [{
	        path: 'add',
	        breadcrumbName: '增加客户公司',
	        component: _PageAdd4.default
	      }]
	    }]
	  }, {
	    path: 'company',
	    breadcrumbName: '公司列表',
	    indexRoute: { component: _Index8.default },
	    childRoutes: [
	    /* {
	                path: ':uuid/custom',
	                breadcrumbName:"关联公司",
	                indexRoute: { component: CustomConfig }
	            }, */
	    {
	      path: ':uuid/custom',
	      breadcrumbName: '公司客户',
	      indexRoute: { component: _Index10.default },
	      childRoutes: [{
	        path: 'add',
	        breadcrumbName: '关联公司',
	        indexRoute: { component: _PageConfig2.default }
	      }]
	    }]
	  }, {
	    path: 'bill',
	    breadcrumbName: '资金列表',
	    indexRoute: { component: _Index6.default }
	  }]
	};
	
	exports.default = router;

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadDataLocal = function () {
	      var data = [];
	      for (var i = 50; i >= 0; i--) {
	        data.push({
	          key: i,
	          compname: 'Edward King ' + i,
	          name: 32,
	          init: 'London. ' + i,
	          current: 'Park. ' + i,
	          remark: 'Lane. ' + i
	        });
	      }
	    };
	
	    _this.companyInfo = function () {
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          _antd.Button,
	          null,
	          ' \u8D22\u52A1\u7EDF\u8BA1\u5206\u6790 '
	        ),
	        _react2.default.createElement(
	          _antd.Button,
	          null,
	          ' \u6BCF\u6708\u8D22\u52A1\u7EDF\u8BA1\u5206\u6790 '
	        ),
	        _react2.default.createElement(
	          _antd.Button,
	          null,
	          ' \u5229\u6DA6\u5206\u6790 '
	        ),
	        _react2.default.createElement(
	          _antd.Button,
	          null,
	          ' \u6295\u8D44\u73B0\u91D1\u56DE\u62A5 '
	        )
	      );
	    };
	
	    _this.searchBar = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      var dateFormat = 'YYYY-MM-DD';
	      return _react2.default.createElement(
	        _antd.Form,
	        { inline: true, onSubmit: _this.handleSubmit, style: { marginBottom: 15 } },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('company', {
	            initialValue: [(0, _moment2.default)('2015/01/01', dateFormat), (0, _moment2.default)('2015/01/01', dateFormat)]
	          })(_react2.default.createElement(RangePicker, { format: dateFormat }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit' },
	            '\u641C\u7D22'
	          )
	        )
	      );
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.loadDataLocal();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        null,
	        this.companyInfo(),
	        this.searchBar()
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Index);

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _BackBtn = __webpack_require__(12);
	
	var _dict = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	var RadioButton = _antd.Radio.Button;
	var RadioGroup = _antd.Radio.Group;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.loadExpendType = function () {
	      (0, _dict.queryDictExpend)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            expendType: res.data
	          });
	        }
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handSubmit = _this.props.handSubmit;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handSubmit(values);
	        }
	      });
	    };
	
	    _this.start = function () {};
	
	    _this.state = {
	      expendType: []
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadExpendType();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var expendType = this.state.expendType;
	      var dataInfo = this.props.dataInfo;
	
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              icon: 'upload',
	              type: 'primary',
	              style: { marginRight: 10 },
	              onClick: this.start,
	              htmlType: 'submit'
	            },
	            '\u786E\u8BA4'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u9884\u7B97\u79D1\u76EE' }, ItemLayout),
	                getFieldDecorator('budgetType', {
	                  rules: [{ required: true, message: '请选择预算科目' }],
	                  initialValue: dataInfo.budgetType ? '' + dataInfo.budgetType : dataInfo.budgetType
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { onChange: this.handleTypeChange },
	                  expendType.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.value },
	                      item.key
	                    );
	                  })
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u91D1\u989D' }, ItemLayout),
	                getFieldDecorator('price', {
	                  rules: [{ required: true, message: '请输入报销金额!' }],
	                  initialValue: dataInfo.price
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u62A5\u9500\u91D1\u989D', addonAfter: '\u5143', type: 'number' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u7C7B\u578B' }, ItemLayout),
	                getFieldDecorator('type', {
	                  rules: [{ required: true, message: '请设置分摊类型!' }],
	                  initialValue: dataInfo.type
	                })(_react2.default.createElement(
	                  RadioGroup,
	                  null,
	                  _react2.default.createElement(
	                    RadioButton,
	                    { value: '0' },
	                    '\u5355\u6B21\u5206\u644A'
	                  ),
	                  _react2.default.createElement(
	                    RadioButton,
	                    { value: '1' },
	                    '\u591A\u6B21\u5206\u644A'
	                  )
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                { label: '\u8BF4\u660E', labelCol: { span: 4 }, wrapperCol: { span: 18 } },
	                getFieldDecorator('remark', {
	                  initialValue: dataInfo.remark
	                })(_react2.default.createElement(_antd.Input.TextArea, {
	                  placeholder: '\u5907\u6CE8',
	                  type: 'textarea',
	                  autosize: { minRows: 3, maxRows: 9 },
	                  maxLength: 1000
	                })),
	                _react2.default.createElement(
	                  'span',
	                  { style: { fontSize: '12px', color: '#999' } },
	                  '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(BaseForm);

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _apportion = __webpack_require__(166);
	
	var _reactRedux = __webpack_require__(5);
	
	var _YearPicker = __webpack_require__(154);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	var _Index = __webpack_require__(686);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _back_info = __webpack_require__(19);
	
	var _ModalApportion = __webpack_require__(677);
	
	var _ModalApportion2 = _interopRequireDefault(_ModalApportion);
	
	var _dict = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var TabPane = _antd.Tabs.TabPane;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadExpendType = function () {
	      (0, _dict.queryDictExpend)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            expendType: res.data
	          });
	        }
	      });
	    };
	
	    _this.findTypeName = function (type) {
	      var typeName = '';
	      _this.state.expendType.forEach(function (item) {
	        if (type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.loadData = function (pageNo) {
	      var params = {};
	      var context = _this;
	      var _this$state = _this.state,
	          condition = _this$state.condition,
	          year = _this$state.year;
	
	      var no = _this.state.pageNoNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      params.year = year || _moment2.default.unix(Date.now() / 1000).format('YYYY');
	      params.isNo = 0;
	      _this.setState({
	        pageNo: current,
	        isLoading: true
	      });
	      (0, _apportion.queryApportionList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            statistics: res.data.statistics,
	            data: res.data.list,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        }
	      });
	    };
	
	    _this.loadNoData = function (pageNoNo) {
	      var params = {};
	      var context = _this;
	      var _this$state2 = _this.state,
	          condition = _this$state2.condition,
	          year = _this$state2.year;
	
	      var no = _this.state.pageNoNo;
	      var current = pageNoNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      params.isNo = 1;
	      params.year = year || _moment2.default.unix(Date.now() / 1000).format('YYYY');
	      _this.setState({
	        pageNoNo: current,
	        isLoading: true
	      });
	      (0, _apportion.queryApportionList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            statistics: res.data.statistics,
	            dataNo: res.data.list,
	            totalNo: res.totalSize,
	            isLoading: false,
	            currentTotalNo: res.data.currentTotal
	          });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      var isNo = _this.state.isNo;
	
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            if (isNo === 0) {
	              _this.loadData(1);
	            } else if (isNo === 1) {
	              _this.loadNoData(1);
	            }
	          });
	        }
	      });
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handleOk = function (params) {
	      var isNo = _this.state.isNo;
	
	      _this.apportion = params;
	      _this.handleVisible(false);
	      _this.saveApportionDetail(_this.apportionUuid, params.details);
	      if (isNo === 0) {
	        _this.loadData();
	      } else if (isNo === 1) {
	        _this.loadNoData();
	      }
	    };
	
	    _this.changeYear = function (value) {
	      var isNo = _this.state.isNo;
	
	      _this.setState({
	        year: value
	      }, function () {
	        if (isNo === 0) {
	          _this.loadData(1);
	        } else if (isNo === 1) {
	          _this.loadNoData(1);
	        }
	      });
	    };
	
	    _this.changeIsNo = function (key) {
	      _this.setState({
	        isNo: +key
	      });
	
	      if (key === '0') {
	        _this.loadData();
	      } else if (key === '1') {
	        _this.loadNoData();
	      }
	    };
	
	    _this.toRestore = function (uuid) {
	      (0, _apportion.queryApportionToRestore)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	          _this.loadData();
	          _this.loadNoData();
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.toNo = function (uuid) {
	      (0, _apportion.queryApportionToNo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message, 2.5);
	          _this.loadData();
	          _this.loadNoData();
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.saveApportionDetail = function (uuid, params) {
	      (0, _apportion.querySaveApportionDetail)(uuid, params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleAddRecord = function (params) {
	      _this.apportionUuid = params.uuid;
	      _this.setState({
	        dataInfo: {
	          type: params.budgetType,
	          apportion: {
	            type: params.type
	          }
	        }
	      });
	      _this.handleVisible(true);
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	      var _this$props$backInfo = _this.props.backInfo,
	          path = _this$props$backInfo.path,
	          year = _this$props$backInfo.year;
	
	      var defaultYear = _moment2.default.unix(Date.now() / 1000).format('YYYY');
	      if (path === _this.props.location.pathname) {
	        defaultYear = year;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(_YearPicker2.default, {
	            defaultValue: defaultYear,
	            style: { width: '120px', marginRight: 8 },
	            onChange: _this.changeYear
	          }),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '分摊编号',
	        dataIndex: 'unid'
	      }, {
	        title: '预算科目',
	        dataIndex: 'budgetType',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _this.findTypeName(text)
	          );
	        }
	      }, {
	        title: '用款说明',
	        dataIndex: 'remark',
	        width: 300,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              {
	                style: {
	                  width: '300px',
	                  whiteSpace: 'nowrap',
	                  overflow: 'hidden',
	                  textOverflow: 'ellipsis',
	                  marginBottom: 0
	                }
	              },
	              text
	            )
	          );
	        }
	      }, {
	        title: '预算发生时间',
	        dataIndex: 'updateTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '发生金额',
	        dataIndex: 'price'
	      }, {
	        title: '待分摊金额',
	        dataIndex: 'balance',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'itemType',
	        render: function render(text, record) {
	          // itemType 0：草稿，1：正常数据，2：失效数据,3:已分摊
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.itemType === 0 ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/e_manage/open/' + record.itemUuid },
	              '\u62A5\u9500\u660E\u7EC6'
	            ) : null,
	            record.itemType === 1 ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/p_manage/open/' + record.itemUuid },
	              '\u4ED8\u6B3E\u660E\u7EC6'
	            ) : null,
	            record.itemType === 2 ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/l_manage/open/' + record.itemUuid },
	              '\u501F\u6B3E\u660E\u7EC6'
	            ) : null,
	            record.itemType === 0 || record.itemType === 1 || record.itemType === 2 ? _react2.default.createElement(_antd.Divider, { type: 'verticle' }) : null,
	            _this.state.isNo === 0 ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/apportion/record/' + record.uuid },
	              '\u5206\u644A\u8BB0\u5F55'
	            ) : null,
	            _this.state.isNo === 0 ? _react2.default.createElement(_antd.Divider, { type: 'verticle' }) : null,
	            record.status === 1 ? _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.handleAddRecord(record);
	                } },
	              '\u7F16\u8F91\u5206\u644A'
	            ) : null,
	            record.status === 1 ? _react2.default.createElement(_antd.Divider, { type: 'verticle' }) : null,
	            _this.state.isNo ? _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.toRestore(record.uuid);
	                } },
	              '\u6062\u590D\u5206\u644A'
	            ) : _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.toNo(record.uuid);
	                } },
	              '\u4E0D\u5206\u644A'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.setClassName = function (record) {
	      if (record.status !== 1) {
	        return 'td-gray';
	      }
	    };
	
	    _this.state = {
	      expendType: [],
	      statistics: {},
	      data: [],
	      dataNo: [],
	      isLoading: true,
	      isNo: 0,
	      year: '',
	      total: 0,
	      totalNo: 0,
	      pageNo: 1,
	      pageNoNo: 1,
	      visible: false,
	      dataInfo: {
	        apportion: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var backInfo = this.props.backInfo;
	
	      this.loadExpendType();
	      if (backInfo.path === this.props.location.pathname) {
	        this.setState({
	          isNo: backInfo.isNo,
	          year: backInfo.year,
	          pageNo: backInfo.pageNo,
	          pageNoNo: backInfo.pageNoNo,
	          condition: backInfo.condition
	        }, function () {
	          backInfo.isNo === 0 && _this2.loadData();
	          backInfo.isNo === 1 && _this2.loadNoData();
	        });
	      } else {
	        this.loadData(1);
	        this.setState({
	          year: _moment2.default.unix(Date.now() / 1000).format('YYYY')
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          isNo = _state.isNo,
	          year = _state.year,
	          pageNo = _state.pageNo,
	          pageNoNo = _state.pageNoNo,
	          condition = _state.condition;
	
	      var params = {
	        path: this.props.location.pathname,
	        isNo: isNo,
	        year: year,
	        pageNo: pageNo,
	        pageNoNo: pageNoNo,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 加载需分摊数据
	
	
	    // 加载不分摊数据
	
	
	    // 改变年份
	
	
	    // 是否分摊列表切换
	
	
	    // 恢复分摊
	
	
	    // 不分摊
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          statistics = _state2.statistics,
	          data = _state2.data,
	          dataNo = _state2.dataNo,
	          isLoading = _state2.isLoading,
	          total = _state2.total,
	          totalNo = _state2.totalNo,
	          isNo = _state2.isNo,
	          pageNo = _state2.pageNo,
	          pageNoNo = _state2.pageNoNo,
	          visible = _state2.visible,
	          dataInfo = _state2.dataInfo,
	          expendType = _state2.expendType;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this3.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      var paginationNo = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: totalNo,
	        current: pageNoNo,
	        onChange: function onChange(current) {
	          _this3.loadNoData(current);
	        },
	        showTotal: function showTotal(_showTotal2) {
	          return '\u5171 ' + _showTotal2 + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(_antd.Col, { span: 13 }),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, {
	          data: [{
	            title: '发生总金额',
	            value: _index2.default.numberFormat(statistics.sum || 0)
	          }, {
	            title: '待分摊金额',
	            value: _index2.default.numberFormat(statistics.todo || 0)
	          }, {
	            title: '已分摊金额',
	            value: _index2.default.numberFormat(statistics.done || 0)
	          }, {
	            title: '不分摊金额',
	            value: _index2.default.numberFormat(statistics.no || 0)
	          }]
	        }),
	        _react2.default.createElement(
	          _antd.Tabs,
	          { defaultActiveKey: '0', activeKey: '' + isNo || '0', onChange: this.changeIsNo },
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u9700\u5206\u644A', key: '0' },
	            _react2.default.createElement(_antd.Table, {
	              rowKey: 'uuid',
	              loading: isLoading,
	              columns: this.columns(),
	              dataSource: data,
	              pagination: pagination,
	              rowClassName: this.setClassName
	            })
	          ),
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u4E0D\u5206\u644A', key: '1' },
	            _react2.default.createElement(_antd.Table, {
	              rowKey: 'uuid',
	              loading: isLoading,
	              columns: this.columns(),
	              dataSource: dataNo,
	              pagination: paginationNo,
	              rowClassName: this.setClassName
	            })
	          )
	        ),
	        _react2.default.createElement(_ModalApportion2.default, {
	          onCancel: this.handleVisible,
	          dataInfo: {},
	          dataItem: dataInfo,
	          visible: visible,
	          onOk: this.handleOk,
	          expendType: expendType
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Index));

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _apportion = __webpack_require__(166);
	
	var _PageAdd2 = __webpack_require__(693);
	
	var _PageAdd3 = _interopRequireDefault(_PageAdd2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_PageAdd) {
	  _inherits(Page, _PageAdd);
	
	  function Page() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Page);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Page.__proto__ || Object.getPrototypeOf(Page)).call.apply(_ref, [this].concat(args))), _this), _this.getApportionInfo = function () {
	      (0, _apportion.queryApportionInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getApportionInfo();
	    }
	  }]);
	
	  return Page;
	}(_PageAdd3.default);
	
	exports.default = Page;

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _apportion = __webpack_require__(166);
	
	var _ModalApportion = __webpack_require__(677);
	
	var _ModalApportion2 = _interopRequireDefault(_ModalApportion);
	
	var _BackBtn = __webpack_require__(12);
	
	var _dict = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var confirm = _antd.Modal.confirm;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadExpendType = function () {
	      (0, _dict.queryDictExpend)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            expendType: res.data
	          });
	        }
	      });
	    };
	
	    _this.findTypeName = function (type) {
	      var typeName = '';
	      _this.state.expendType.forEach(function (item) {
	        if (type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.getApportionInfo = function () {
	      _this.setState({ loading: true });
	      (0, _apportion.queryApportionInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            budgetType: res.data.budgetType,
	            data: res.data.details,
	            dataInfo: {
	              type: res.data.budgetType,
	              apportion: {
	                type: res.data.type
	              }
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      }).finally(function () {
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.loadData(1, values.condition);
	        }
	      });
	    };
	
	    _this.handleFormReset = function (e) {
	      e.preventDefault();
	      _this.props.form.resetFields();
	      _this.loadData(1);
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.saveApportionDetail = function (uuid, params) {
	      _this.setState({ loading: true });
	      (0, _apportion.querySaveApportionDetail)(uuid, params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getApportionInfo();
	        } else {
	          _antd.message.error(res.message);
	        }
	      }).finally(function () {
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.confirmDeleteApportionDetail = function (uuid) {
	      confirm({
	        title: '是否删除分摊明细??',
	        content: _react2.default.createElement(_antd.Input, {
	          autoFocus: true,
	          onChange: function onChange(e) {
	            _this.setState({ deleteReason: e.target.value });
	          },
	          placeholder: '\u8BF7\u8F93\u5165\u5220\u9664\u7406\u7531'
	        }),
	        onOk: function onOk() {
	          return _this.deleteApportionDetail(uuid);
	        }
	      });
	    };
	
	    _this.deleteApportionDetail = function (uuid) {
	      (0, _apportion.queryDeleteApportionDetail)({ uuid: uuid, reason: _this.state.deleteReason }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getApportionInfo();
	          _this.setState({ deleteReason: '' });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.checkApportionDetail = function (uuid) {
	      _this.setState({ loading: true });
	      (0, _apportion.queryCheckApportionDetail)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getApportionInfo();
	        } else {
	          _antd.message.error(res.message);
	        }
	      }).finally(function () {
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.handleOk = function (params) {
	      _this.apportion = params;
	      _this.handleVisible(false);
	      if (params.details && params.details.length > 0) {
	        params.details.forEach(function (detail) {
	          detail.remark = params.remark;
	        });
	      }
	      _this.saveApportionDetail(_this.props.params.uuid, params.details);
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	        _react2.default.createElement(
	          FormItem,
	          { label: '\u641C\u7D22\u6761\u4EF6' },
	          getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit' },
	            '\u67E5\u8BE2'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { style: { marginLeft: 8, marginRight: '-16px' }, onClick: _this.handleFormReset },
	            '\u91CD\u7F6E'
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      var budgetType = _this.state.budgetType;
	
	      return [{
	        title: '流水编号',
	        dataIndex: 'no'
	      }, {
	        title: '预算组名称',
	        dataIndex: 'groupName'
	      }, {
	        title: '费用',
	        dataIndex: 'price'
	      }, {
	        title: '摘要(包括删除原因)',
	        dataIndex: 'remark',
	        width: '400px',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'p',
	            null,
	            text,
	            record.deleteReason ? _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\uFF08',
	              record.deleteReason,
	              '\uFF09'
	            ) : null
	          );
	        }
	      }, {
	        title: '预算科目',
	        dataIndex: 'type',
	        render: function render() {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _this.findTypeName(budgetType)
	          );
	        }
	      }, {
	        title: '分摊时间',
	        dataIndex: 'updateTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          switch (record.status) {
	            case 1:
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _antd.Popconfirm,
	                  {
	                    title: '\u662F\u5426\u786E\u8BA4\u5206\u644A\uFF1F',
	                    onConfirm: function onConfirm() {
	                      return _this.checkApportionDetail(record.uuid);
	                    }
	                  },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#' },
	                    '\u786E\u8BA4\u5206\u644A'
	                  )
	                ),
	                _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                _react2.default.createElement(
	                  _antd.Popconfirm,
	                  {
	                    title: '\u662F\u5426\u5220\u9664\u5206\u644A\uFF1F',
	                    onConfirm: function onConfirm() {
	                      _this.confirmDeleteApportionDetail(record.uuid);
	                    }
	                  },
	                  _react2.default.createElement(
	                    'a',
	                    { href: '#' },
	                    '\u5220\u9664'
	                  )
	                )
	              );
	            case 2:
	              return _react2.default.createElement(
	                'span',
	                null,
	                '\u5DF2\u5220\u9664'
	              );
	            case 3:
	              return _react2.default.createElement(
	                'span',
	                null,
	                '\u5DF2\u786E\u8BA4'
	              );
	            default:
	          }
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      visible: false,
	      expendType: [],
	      dataInfo: {
	        apportion: {}
	      },
	      deleteReason: '',
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadExpendType();
	      this.getApportionInfo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          visible = _state.visible,
	          dataInfo = _state.dataInfo,
	          expendType = _state.expendType,
	          loading = _state.loading;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 13 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                _react2.default.createElement(_BackBtn.BackBtn, null),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary', icon: 'plus', onClick: function onClick() {
	                      return _this2.handleVisible(true);
	                    } },
	                  '\u6DFB\u52A0'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          loading: loading,
	          pagination: false
	        }),
	        _react2.default.createElement(_ModalApportion2.default, {
	          onCancel: function onCancel() {
	            return _this2.handleVisible(false);
	          },
	          dataInfo: {},
	          dataItem: dataInfo,
	          visible: visible,
	          onOk: this.handleOk,
	          expendType: expendType
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handSubmit = _this.props.handSubmit;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handSubmit(values);
	        }
	      });
	    };
	
	    _this.handleCompanyChange = function (value, option) {
	      _this.props.form.setFieldsValue({
	        compName: option.props.children
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var dataInfo = this.props.dataInfo;
	
	      getFieldDecorator('compName', { initialValue: dataInfo.compName });
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', style: { marginRight: 10 }, htmlType: 'submit' },
	            '\u786E\u8BA4'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u516C\u53F8\u540D\u79F0' }, ItemLayout),
	                getFieldDecorator('compUuid', {
	                  rules: [{
	                    required: true,
	                    message: '请选择公司'
	                  }],
	                  initialValue: dataInfo.compUuid
	                })(_react2.default.createElement(_companySearch2.default, Object.assign({
	                  companyName: dataInfo.compName,
	                  companyUuid: dataInfo.compUuid,
	                  onChange: function onChange(value, option) {
	                    return _this2.handleCompanyChange(value, option);
	                  }
	                }, this.props)))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7' }, ItemLayout),
	                getFieldDecorator('taxpayerNumber', {
	                  initialValue: dataInfo.taxpayerNumber
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7', type: 'text' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5730\u5740' }, ItemLayout),
	                getFieldDecorator('address', {
	                  initialValue: dataInfo.address
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5730\u5740' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7535\u8BDD' }, ItemLayout),
	                getFieldDecorator('telephone', {
	                  initialValue: dataInfo.telephone
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u7535\u8BDD', type: 'text' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F00\u6237\u884C' }, ItemLayout),
	                getFieldDecorator('bankName', {
	                  initialValue: dataInfo.bankName
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5F00\u6237\u884C', type: 'text' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F00\u6237\u5E10\u53F7' }, ItemLayout),
	                getFieldDecorator('bankBook', {
	                  initialValue: dataInfo.bankBook
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5F00\u6237\u5E10\u53F7', type: 'number' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u7C7B\u578B' }, ItemLayout),
	                getFieldDecorator('type', {
	                  initialValue: dataInfo.type
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { defaultValue: dataInfo.type || 0 },
	                  _react2.default.createElement(
	                    Option,
	                    { value: 0 },
	                    '\u4E00\u822C\u7EB3\u7A0E\u4EBA'
	                  ),
	                  _react2.default.createElement(
	                    Option,
	                    { value: 1 },
	                    '\u5C0F\u89C4\u6A21\u7EB3\u7A0E\u4EBA'
	                  )
	                ))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(BaseForm);

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _finance = __webpack_require__(61);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var typeName = ['一般纳税人', '小规模纳税人'];
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo) {
	      var params = {};
	      var _this$state = _this.state,
	          condition = _this$state.condition,
	          isPermission = _this$state.isPermission;
	
	
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      if (!isPermission) {
	        params.status = 1;
	      }
	      _this.setState({
	        pageNo: current,
	        isLoading: true
	      });
	      (0, _finance.queryBookInfoList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var pageNo = _this.state.pageNo;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.loadData(pageNo);
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.judge = function (accountInfo, callback) {
	      var role = accountInfo.roles;
	      var isPermission = false;
	      role.forEach(function (item) {
	        switch (item) {
	          case '[CWManager]':
	          case '[Caissier]':
	            isPermission = true;
	            break;
	          default:
	            break;
	        }
	      });
	      if (accountInfo.admin) {
	        isPermission = true;
	      }
	
	      _this.setState({
	        isPermission: isPermission
	      }, callback);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '公司名称',
	        dataIndex: 'compName'
	      }, {
	        title: '纳税人识别号',
	        dataIndex: 'taxpayerNumber'
	      }, {
	        title: '开户行',
	        dataIndex: 'bankName'
	      }, {
	        title: '开户账号',
	        dataIndex: 'bankBook'
	      }, {
	        title: '地址',
	        dataIndex: 'address'
	      }, {
	        title: '电话',
	        dataIndex: 'telephone'
	      }, {
	        title: '类型',
	        dataIndex: 'type',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            typeName[text]
	          );
	        }
	      }, {
	        title: '操作',
	        render: function render(text, record) {
	          var isPermission = _this.state.isPermission;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/bookInfo/open/' + record.uuid },
	              '\u67E5\u770B'
	            ),
	            isPermission ? _react2.default.createElement('span', { className: 'ant-divider' }) : null,
	            isPermission ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/bookInfo/edit/' + record.uuid },
	              '\u7F16\u8F91'
	            ) : null,
	            isPermission ? _react2.default.createElement('span', { className: 'ant-divider' }) : null,
	            isPermission ? _react2.default.createElement(
	              'a',
	              {
	                href: '#',
	                onClick: function onClick() {
	                  (0, _finance.queryAbleBookInfo)({
	                    uuid: record.uuid,
	                    status: record.status === 2 ? 1 : 2
	                  }).then(function (_ref) {
	                    var statusCode = _ref.statusCode;
	
	                    if (statusCode === 200) {
	                      _antd.message.success((record.status === 2 ? '启用' : '禁用') + '\u6210\u529F');
	                      _this.loadData();
	                    }
	                  });
	                }
	              },
	              record.status === 2 ? '启用' : '禁用'
	            ) : null
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: true,
	      total: 0,
	      pageNo: 1,
	      isPermission: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.judge(this.props.account_info, function () {
	        _this2.loadData(1);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          pageNo = _state.pageNo,
	          condition = _state.condition;
	
	      var params = {
	        pageNo: pageNo,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    // 加载需公司账户信息数据
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          data = _state2.data,
	          isLoading = _state2.isLoading,
	          total = _state2.total,
	          pageNo = _state2.pageNo,
	          isPermission = _state2.isPermission;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this3.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 13 },
	              isPermission ? _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/finance/bookInfo/add' },
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary' },
	                  '\u6DFB\u52A0'
	                )
	              ) : null
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          loading: isLoading,
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    account_info: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Index));

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _finance = __webpack_require__(61);
	
	var _PageAdd2 = __webpack_require__(694);
	
	var _PageAdd3 = _interopRequireDefault(_PageAdd2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageEdit = function (_PageAdd) {
	  _inherits(PageEdit, _PageAdd);
	
	  function PageEdit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PageEdit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PageEdit.__proto__ || Object.getPrototypeOf(PageEdit)).call.apply(_ref, [this].concat(args))), _this), _this.getBookInfo = function () {
	      (0, _finance.queryBookInfoInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PageEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getBookInfo();
	    }
	  }]);
	
	  return PageEdit;
	}(_PageAdd3.default);
	
	exports.default = PageEdit;

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _finance = __webpack_require__(61);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	
	var typeName = ['一般纳税人', '小规模纳税人'];
	
	var PageOpen = function (_Component) {
	  _inherits(PageOpen, _Component);
	
	  function PageOpen(props) {
	    _classCallCheck(this, PageOpen);
	
	    var _this = _possibleConstructorReturn(this, (PageOpen.__proto__ || Object.getPrototypeOf(PageOpen)).call(this, props));
	
	    _this.getBookInfoInfo = function () {
	      (0, _finance.queryBookInfoInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      data: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageOpen, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getBookInfoInfo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Row,
	          { style: { paddingBottom: '20px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 13 },
	            _react2.default.createElement(_BackBtn.BackBtn, null)
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u516C\u53F8\u8D26\u6237\u4FE1\u606F' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u516C\u53F8\u540D\u79F0' },
	              data.compName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7' },
	              data.taxpayerNumber
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5730\u5740' },
	              data.address
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7535\u8BDD' },
	              data.telephone
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F00\u6237\u884C' },
	              data.bankName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F00\u6237\u8D26\u53F7' },
	              data.bankBook
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7C7B\u578B' },
	              typeName[data.type]
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PageOpen;
	}(_react.Component);
	
	exports.default = PageOpen;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Index = __webpack_require__(686);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _back_info = __webpack_require__(19);
	
	var _all_company = __webpack_require__(732);
	
	var _user = __webpack_require__(54);
	
	var _finance = __webpack_require__(61);
	
	var _budget = __webpack_require__(30);
	
	var _workOrg = __webpack_require__(191);
	
	var _ModalSetTarget = __webpack_require__(1580);
	
	var _ModalSetTarget2 = _interopRequireDefault(_ModalSetTarget);
	
	var _ModalImport = __webpack_require__(1579);
	
	var _ModalImport2 = _interopRequireDefault(_ModalImport);
	
	var _ModalAdd = __webpack_require__(1578);
	
	var _ModalAdd2 = _interopRequireDefault(_ModalAdd);
	
	var _TableOrg = __webpack_require__(1581);
	
	var _TableOrg2 = _interopRequireDefault(_TableOrg);
	
	__webpack_require__(2962);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.handleEnable = function (uuid) {
	      (0, _budget.queryEnableBudgetGroup)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadData();
	          _this.loadSum();
	          _this.loadEnableData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleDisable = function (uuid) {
	      (0, _budget.queryDisableBudgetGroup)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadData();
	          _this.loadSum();
	          _this.loadEnableData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadWorkOrgs = function () {
	      (0, _workOrg.queryWorkOrg)({ orgUuid: '' }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.workOrgs = res.data;
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadUsers = function () {
	      (0, _user.queryAccountList)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.users = res.data;
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadBook = function () {
	      (0, _finance.queryFinanceBooksOrg)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.books = res.data;
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadAllData = function () {
	      (0, _budget.queryBudgetGroupList)({ isEnable: 1 }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            companyAll: _this.formatGroup(res.data)
	          });
	          _this.props.dispatch((0, _all_company.getAllCompany)(res.data));
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadSum = function () {
	      var params = {
	        isProject: _this.key === '2' ? 1 : 0,
	        isEnable: 1
	      };
	      var context = _this;
	      params.year = _this.state.condition || '';
	      (0, _budget.queryBudgetGroupSum)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            sumData: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = {
	        isProject: _this.key === '2' ? 1 : 0,
	        isEnable: 1
	      };
	      var context = _this;
	      params.year = _this.state.condition || '';
	      _this.setState({
	        isLoading: true
	      });
	      (0, _budget.queryBudgetGroupList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            company: _this.formatGroup(res.data),
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadEnableData = function () {
	      var params = {
	        isProject: _this.key === '2' ? 1 : 0,
	        isEnable: 0
	      };
	      params.year = _this.state.condition || '';
	      _this.setState({
	        isLoading: true
	      });
	      (0, _budget.queryBudgetGroupList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            companyEnable: _this.formatGroup(res.data)
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.formatGroup = function (arr) {
	      arr.map(function (item) {
	        if (item.children) {
	          if (item.children.length === 0) {
	            delete item.children;
	            return item;
	          }
	          if (item.children.length > 0) {
	            _this.formatGroup(item.children);
	          }
	        }
	        return item;
	      });
	      return arr;
	    };
	
	    _this.showModalAdd = function () {
	      _this.setState({
	        modalAddVisible: true
	      });
	    };
	
	    _this.showModalTarget = function (flag) {
	      _this.setState({
	        modalTargetVisible: !!flag
	      });
	    };
	
	    _this.showModalImport = function () {
	      _this.setState({
	        modalImportVisible: true
	      });
	    };
	
	    _this.disableShow = function () {
	      var showFlag = _this.state.showFlag;
	
	      _this.setState({
	        showFlag: !showFlag
	      });
	    };
	
	    _this.disableProShow = function () {
	      var showProFlag = _this.state.showProFlag;
	
	      _this.setState({
	        showProFlag: !showProFlag
	      });
	    };
	
	    _this.showModalEdit = function (uuid) {
	      _this.uuid = uuid;
	      _this.setState({
	        modalEditVisible: true
	      });
	    };
	
	    _this.handAddSubmit = function (item) {
	      item.parentUuid = _this.parentUuid;
	      (0, _budget.querySaveBudgetGroup)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.loadData();
	          _this.loadSum();
	          _this.loadEnableData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.importBudget = function (params) {
	      _this.setState({
	        isLoading: true,
	        importLoading: true
	      });
	      (0, _budget.queryBatchImportBudgetGroupSet)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.props.router.push('/finance/budget/set_manage_mine');
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          isLoading: false,
	          importLoading: false
	        });
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        modalAddVisible: false,
	        modalEditVisible: false,
	        modalImportVisible: false
	      });
	    };
	
	    _this.handleAdd = function (parentUuid) {
	      _this.parentUuid = parentUuid;
	    };
	
	    _this.callback = function (key) {
	      _this.key = key;
	      _this.loadData();
	      _this.loadSum();
	      _this.loadEnableData();
	    };
	
	    _this.setCondition = function (e) {
	      _this.setState({
	        condition: e
	      }, function () {
	        _this.loadData();
	        _this.loadSum();
	        _this.loadEnableData();
	      });
	    };
	
	    _this.yearss = function () {
	      var currentYear = _moment2.default.unix(new Date().getTime() / 1000).format('YYYY');
	      var _this$props$backInfo = _this.props.backInfo,
	          condition = _this$props$backInfo.condition,
	          path = _this$props$backInfo.path;
	
	      var years = [];
	      var searchCondition = 0;
	      if (path === _this.props.location.pathname) {
	        searchCondition = condition;
	      }
	
	      for (var i = -1; i < 4; i++) {
	        years.push(currentYear - i);
	      }
	      return _react2.default.createElement(
	        _antd.Select,
	        {
	          style: { width: '120px', marginRight: '20px' },
	          placeholder: '\u9009\u62E9\u5E74\u4EFD',
	          onChange: _this.setCondition,
	          defaultValue: searchCondition || currentYear
	        },
	        years.map(function (item) {
	          return _react2.default.createElement(
	            _antd.Select.Option,
	            { key: item },
	            item
	          );
	        })
	      );
	    };
	
	    _this.setBudgetGroupAims = function (params) {
	      _this.setState({
	        modalTargetVisible: false
	      });
	      (0, _budget.querySetBudgetGroupAims)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.showModalTarget(false);
	          _this.loadData();
	          _this.loadSum();
	          _this.loadEnableData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.sumAdujust = function () {
	      var sumData = _this.state.sumData;
	
	      var color = '';
	      if (sumData && sumData.adjustmentSum > 0) {
	        color = 'red';
	      } else if (sumData && sumData.adjustmentSum < 0) {
	        color = 'green';
	      }
	      return _react2.default.createElement(
	        'span',
	        null,
	        sumData.adjustmentCount ? _react2.default.createElement(
	          'span',
	          { style: { color: '#FF9F9F' } },
	          _react2.default.createElement(
	            'span',
	            { style: { color: '#505659' } },
	            '( '
	          ),
	          sumData.adjustmentCount,
	          ':',
	          _react2.default.createElement(
	            'span',
	            { style: { color: color } },
	            _index2.default.numberFormat(sumData.adjustmentSum || 0)
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { color: '#505659' } },
	            ' )'
	          )
	        ) : ''
	      );
	    };
	
	    _this.sumFreeze = function () {
	      var sumData = _this.state.sumData;
	
	      return _react2.default.createElement(
	        'span',
	        null,
	        sumData.freeze ? _react2.default.createElement(
	          'span',
	          { style: { color: '#BCBCBC' } },
	          _react2.default.createElement(
	            'span',
	            { style: { color: '#505659' } },
	            '( '
	          ),
	          '\u51BB\u7ED3',
	          _index2.default.numberFormat(sumData.freeze || 0),
	          _react2.default.createElement(
	            'span',
	            { style: { color: '#505659' } },
	            ' )'
	          )
	        ) : ''
	      );
	    };
	
	    _this.state = {
	      companyAll: [],
	      company: [],
	      companyEnable: [],
	      condition: _moment2.default.unix(new Date().getTime() / 1000).format('YYYY'),
	      modalAddVisible: false,
	      modalTargetVisible: false,
	      modalEditVisible: false,
	      modalImportVisible: false,
	      showFlag: false,
	      showProFlag: false,
	      importLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var backInfo = this.props.backInfo;
	
	
	      this.loadWorkOrgs();
	      this.loadUsers();
	      this.loadBook();
	      this.loadAllData();
	
	      if (backInfo.path === this.props.location.pathname) {
	        this.key = backInfo.key;
	        this.setState({
	          condition: backInfo.condition
	        }, function () {
	          _this2.loadData();
	          _this2.loadSum();
	          _this2.loadEnableData();
	        });
	      } else {
	        this.loadData();
	        this.loadSum();
	        this.loadEnableData();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var condition = this.state.condition;
	
	      var params = {
	        path: this.props.location.pathname,
	        key: this.key,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    /**
	     *获取业务部门列表
	     */
	
	
	    /**
	     * 获取用户列表
	     */
	
	
	    /**
	     * 获取资金账户列表
	     */
	
	
	    /**
	     * 递归删除空的children
	     */
	
	
	    /**
	     *
	     * 显示编辑账户弹窗
	     */
	
	
	    /**
	     * 新增账号
	     */
	
	
	    // 根据年份生成表
	
	
	    // 设置年份下拉菜单
	
	
	    // 设置收入目标
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          sumData = _state.sumData,
	          company = _state.company,
	          companyEnable = _state.companyEnable,
	          isLoading = _state.isLoading,
	          importLoading = _state.importLoading,
	          showFlag = _state.showFlag,
	          showProFlag = _state.showProFlag;
	
	      var parentProps = {
	        company: company,
	        isLoading: isLoading,
	        year: this.state.condition,
	        handleAdd: this.handleAdd,
	        handleEdit: this.showModalEdit,
	        handleEnable: this.handleEnable,
	        handleDisable: this.handleDisable
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'budget-content' },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'end', style: { paddingRight: '15px', paddingBottom: '15px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              this.yearss(),
	              _react2.default.createElement(
	                _antd.Button,
	                {
	                  icon: 'plus',
	                  style: { marginRight: 8 },
	                  onClick: function onClick() {
	                    return _this3.showModalTarget(true);
	                  }
	                },
	                '\u76EE\u6807\u6536\u5165'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { icon: 'plus', style: { marginRight: 8 }, onClick: this.showModalImport },
	                '\u6DFB\u52A0\u9884\u7B97\u660E\u7EC6'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { icon: 'plus', style: { marginRight: 8 }, onClick: this.showModalAdd },
	                '\u6DFB\u52A0\u9884\u7B97\u7EC4'
	              )
	            ),
	            _react2.default.createElement(_antd.Col, { style: { textAlign: 'right' } })
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          sumData ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(_Index2.default, {
	              data: [{
	                title: '本年预算',
	                value: _index2.default.numberFormat(sumData.init || 0)
	              }, {
	                title: '预算余额',
	                value: _index2.default.numberFormat(sumData.current || 0)
	              }, {
	                title: '目标收入',
	                value: _index2.default.numberFormat(sumData.aim || 0)
	              }, {
	                title: '实际收入',
	                value: _index2.default.numberFormat(sumData.income || 0)
	              }]
	            }),
	            _react2.default.createElement(
	              _antd.Row,
	              { style: { display: 'relative', top: '-20px' } },
	              _react2.default.createElement(_antd.Col, { span: 2 }),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 6 },
	                ' ',
	                this.sumAdujust()
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 6 },
	                this.sumFreeze()
	              )
	            )
	          ) : null,
	          _react2.default.createElement(
	            _antd.Tabs,
	            { defaultActiveKey: '1', activeKey: this.key || '1', onChange: this.callback },
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u90E8\u95E8\u9884\u7B97\u7EC4', key: '1' },
	              _react2.default.createElement(_TableOrg2.default, Object.assign({}, parentProps, { company: company })),
	              _react2.default.createElement(
	                _antd.Divider,
	                { style: { marginTop: '75px' } },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'disableTitle', onClick: this.disableShow },
	                  '\u7981\u7528\u9884\u7B97\u7EC4',
	                  showFlag ? _react2.default.createElement(_antd.Icon, {
	                    type: 'up',
	                    style: {
	                      fontSize: '10px',
	                      paddingLeft: '10px',
	                      position: 'relative',
	                      top: '-3px'
	                    }
	                  }) : _react2.default.createElement(_antd.Icon, {
	                    type: 'down',
	                    style: {
	                      fontSize: '10px',
	                      paddingLeft: '10px',
	                      position: 'relative',
	                      top: '-3px'
	                    }
	                  })
	                )
	              ),
	              showFlag ? _react2.default.createElement(_TableOrg2.default, Object.assign({}, parentProps, { company: companyEnable })) : null,
	              _react2.default.createElement('div', { style: { paddingTop: '100px' } })
	            ),
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u9879\u76EE\u9884\u7B97\u7EC4', key: '2' },
	              _react2.default.createElement(_TableOrg2.default, Object.assign({}, parentProps, { company: company })),
	              _react2.default.createElement(
	                _antd.Divider,
	                { style: { marginTop: '75px' } },
	                _react2.default.createElement(
	                  'span',
	                  { className: 'disableTitle', onClick: this.disableProShow },
	                  '\u7981\u7528\u9884\u7B97\u7EC4',
	                  showProFlag ? _react2.default.createElement(_antd.Icon, {
	                    type: 'up',
	                    style: {
	                      fontSize: '10px',
	                      paddingLeft: '10px',
	                      position: 'relative',
	                      top: '-3px'
	                    }
	                  }) : _react2.default.createElement(_antd.Icon, {
	                    type: 'down',
	                    style: {
	                      fontSize: '10px',
	                      paddingLeft: '10px',
	                      position: 'relative',
	                      top: '-3px'
	                    }
	                  })
	                )
	              ),
	              showProFlag ? _react2.default.createElement(_TableOrg2.default, Object.assign({}, parentProps, { company: companyEnable })) : null,
	              _react2.default.createElement('div', { style: { paddingTop: '100px' } })
	            )
	          ),
	          this.state.modalImportVisible ? _react2.default.createElement(_ModalImport2.default, {
	            cancel: this.hideModal,
	            handleSubmit: this.importBudget,
	            loading: importLoading
	          }) : null,
	          this.state.modalAddVisible ? _react2.default.createElement(_ModalAdd2.default, {
	            handSubmit: this.handAddSubmit,
	            data: {},
	            cancel: this.hideModal,
	            footer: false,
	            title: '\u65B0\u589E\u9884\u7B97\u7EC4',
	            workOrgs: this.workOrgs,
	            users: this.users,
	            books: this.books
	          }) : null,
	          this.state.modalTargetVisible ? _react2.default.createElement(_ModalSetTarget2.default, {
	            handSubmit: this.setBudgetGroupAims,
	            data: {
	              companyAll: this.state.companyAll
	            },
	            cancel: function cancel() {
	              return _this3.showModalTarget(false);
	            },
	            title: '\u65B0\u5EFA\u76EE\u6807\u6536\u5165',
	            workOrgs: this.workOrgs,
	            users: this.users,
	            books: this.books
	          }) : null,
	          this.state.modalEditVisible ? _react2.default.createElement(_ModalAdd2.default, {
	            handSubmit: this.handAddSubmit,
	            data: {},
	            uuid: this.uuid,
	            footer: false,
	            title: '\u9884\u7B97\u7EC4\u7F16\u8F91',
	            workOrgs: this.workOrgs,
	            users: this.users,
	            cancel: this.hideModal,
	            books: this.books
	          }) : null
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    companyAll: state.all_company,
	    backInfo: state.back_info
	  };
	})(Index);

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _budget = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handSubmit = _this.props.handSubmit;
	
	      var capital = _this.props.form.getFieldsValue();
	      !capital.bookUuid && (capital.bookUuid = '');
	      capital.managerName = _this.dealManager(capital.managerUuid);
	      capital.isProject = _this.state.isProject ? 1 : 0;
	      capital.viewUsers = _this.dealView(capital.viewUsers);
	      capital.bookName = _this.dealBook(capital.bookUuid);
	
	      if (_this.props.uuid) {
	        capital.uuid = _this.props.uuid;
	      }
	      if (capital.isProject === 1) {
	        capital.workOrgs = _this.dealView(capital.workOrgs);
	      } else {
	        capital.workOrgs = _this.dealWorkOrg(capital.workOrgs);
	      }
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handSubmit(capital);
	        }
	      });
	    };
	
	    _this.dealManager = function (managerUuid) {
	      var usersAll = _this.props.users;
	      var managerName = '';
	      usersAll.map(function (item) {
	        if (item.uuid === managerUuid) {
	          managerName = item.name;
	        }
	
	        return 1;
	      });
	
	      return managerName;
	    };
	
	    _this.dealView = function (users) {
	      var params = [];
	      var usersAll = _this.props.users;
	      for (var i = 0; i < usersAll.length; i++) {
	        for (var j = 0; j < users.length; j++) {
	          if (usersAll[i].uuid === users[j]) {
	            params.push(usersAll[i]);
	          }
	        }
	      }
	      return params;
	    };
	
	    _this.dealWorkOrg = function (users) {
	      var params = [];
	      var usersAll = _this.props.workOrgs;
	      for (var i = 0; i < usersAll.length; i++) {
	        for (var j = 0; j < users.length; j++) {
	          if (usersAll[i].uuid === users[j]) {
	            params.push(usersAll[i]);
	          }
	        }
	      }
	      return params;
	    };
	
	    _this.dealBook = function (books) {
	      var booksAll = _this.props.books;
	      for (var i = 0; i < booksAll.length; i++) {
	        if (booksAll[i].uuid === books) {
	          return booksAll[i].companyName + '(' + booksAll[i].remark + ')';
	        }
	      }
	    };
	
	    _this.loadDetail = function (uuid) {
	      (0, _budget.queryBudgetGroupInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          var workOrgUuids = [];
	          var viewUsersUuids = [];
	          // 设置总的业务部门
	          var workOrgs = _this.props.workOrgs;
	          var users = _this.props.users;
	          // .concat(res.data.workOrgs);
	          // users = this.props.users.concat(res.data.viewUsers);
	
	          res.data.workOrgs.map(function (item) {
	            workOrgUuids.push(item.uuid);
	            return workOrgUuids;
	          });
	          res.data.viewUsers.map(function (item) {
	            viewUsersUuids.push(item.uuid);
	            return viewUsersUuids;
	          });
	          _this.setState({
	            content: res.data,
	            isProject: res.data.isProject === 1,
	            managerUuid: res.data.managerUuid,
	            workOrgUuids: workOrgUuids,
	            viewUsersUuids: viewUsersUuids,
	            workOrgs: workOrgs,
	            users: users
	          });
	        }
	      });
	    };
	
	    _this.handleRadio = function () {
	      _this.props.form.resetFields(['workOrgUuids']);
	      var isProject = _this.state.isProject;
	
	      _this.setState({
	        isProject: !isProject
	      });
	      _this.props.form.setFieldsValue({ workOrgs: [] });
	    };
	
	    _this.handleBookName = function () {};
	
	    _this.state = {
	      content: {},
	      isProject: false,
	      managerUuid: '',
	      workOrgUuids: [],
	      viewUsersUuids: [],
	      workOrgs: props.workOrgs,
	      users: props.users,
	      books: props.books
	    };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.uuid;
	
	      if (uuid) {
	        this.loadDetail(uuid);
	      }
	    }
	
	    // 设置负责人name
	
	
	    // 设置可查看人员name
	
	
	    // 设置关联人员name
	
	
	    // 设置资金账户name
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _state = this.state,
	          isProject = _state.isProject,
	          workOrgUuids = _state.workOrgUuids,
	          workOrgs = _state.workOrgs,
	          users = _state.users,
	          managerUuid = _state.managerUuid,
	          viewUsersUuids = _state.viewUsersUuids,
	          books = _state.books;
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	
	      var content = this.state.content;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: this.props.title, visible: true, onOk: this.submit, onCancel: this.props.cancel },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u9884\u7B97\u7EC4\u540D\u79F0' }, formItemLayout),
	            getFieldDecorator('name', {
	              rules: [{ required: true, message: '请输入账户名称' }],
	              initialValue: content.name
	            })(_react2.default.createElement(_antd.Input, null))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u9879\u76EE\u9884\u7B97' }, formItemLayout),
	            getFieldDecorator('isProject', {
	              initialValue: content.isProject !== 0
	            })(_react2.default.createElement(_antd.Radio, { onClick: this.handleRadio, checked: isProject }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u9884\u7B97\u8D1F\u8D23\u4EBA' }, formItemLayout),
	            getFieldDecorator('managerUuid', {
	              initialValue: managerUuid
	            })(_react2.default.createElement(
	              _antd.Select,
	              {
	                showSearch: true,
	                filterOption: function filterOption(input, option) {
	                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                }
	              },
	              users.map(function (item, index) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item.uuid },
	                  item.name
	                );
	              })
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u53EF\u4EE5\u67E5\u770B\u4EBA\u5458' }, formItemLayout),
	            getFieldDecorator('viewUsers', {
	              initialValue: viewUsersUuids
	            })(_react2.default.createElement(
	              _antd.Select,
	              {
	                mode: 'multiple',
	                filterOption: function filterOption(input, option) {
	                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                }
	              },
	              users.map(function (item, index) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item.uuid },
	                  item.name
	                );
	              })
	            ))
	          ),
	          isProject ? _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u5173\u8054\u4EBA\u5458' }, formItemLayout),
	            getFieldDecorator('workOrgs', {
	              initialValue: workOrgUuids
	            })(_react2.default.createElement(
	              _antd.Select,
	              {
	                mode: 'multiple',
	                filterOption: function filterOption(input, option) {
	                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                }
	              },
	              users.map(function (item, index) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item.uuid },
	                  item.name
	                );
	              })
	            ))
	          ) : _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u5173\u8054\u4E1A\u52A1\u90E8\u95E8' }, formItemLayout),
	            getFieldDecorator('workOrgs', {
	              initialValue: workOrgUuids
	            })(_react2.default.createElement(
	              _antd.Select,
	              {
	                mode: 'multiple',
	                filterOption: function filterOption(input, option) {
	                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                }
	              },
	              workOrgs.map(function (item, index) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item.uuid },
	                  item.name
	                );
	              })
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u5173\u8054\u8D44\u91D1\u8D26\u6237' }, formItemLayout),
	            getFieldDecorator('bookUuid', {
	              initialValue: content.bookUuid
	            })(_react2.default.createElement(
	              _antd.Select,
	              {
	                allowClear: true,
	                filterOption: function filterOption(input, option) {
	                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                },
	                onSelect: this.handleBookName,
	                dropdownStyle: { width: '500px' },
	                dropdownMatchSelectWidth: false,
	                dropdownClassName: 'bookList'
	              },
	              books.map(function (item, index) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item.uuid },
	                  item.companyName + '(' + item.remark + ')'
	                );
	              })
	            ))
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(IndexModal);

/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _budget = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var DetailModal = function (_Component) {
	  _inherits(DetailModal, _Component);
	
	  function DetailModal(props) {
	    _classCallCheck(this, DetailModal);
	
	    var _this = _possibleConstructorReturn(this, (DetailModal.__proto__ || Object.getPrototypeOf(DetailModal)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var income = _this.props.form.getFieldsValue();
	
	      var obj = Object.assign(_this.state.content, income);
	      if (_this.state.licenseFile && _this.state.licenseFile.length > 0) {
	        obj.fileUuid = _this.state.licenseFile[0].uuid;
	      }
	      var handleSubmit = _this.props.handleSubmit;
	
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handleSubmit(obj);
	        }
	      });
	    };
	
	    _this.handlelicenseFile = function (fileList) {
	      _this.setState({
	        licenseFile: fileList
	      });
	    };
	
	    _this.state = {
	      content: {}
	    };
	    return _this;
	  }
	
	  _createClass(DetailModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	
	      var licenseFile = this.state.licenseFile || [];
	      var date = new Date();
	      var year = date.getFullYear();
	      var years = [];
	      for (var i = year + 1; i >= 2014; i--) {
	        years.push(i.toString());
	      }
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u5BFC\u5165',
	          visible: true,
	          onCancel: this.props.cancel,
	          onOk: this.submit,
	          footer: [_react2.default.createElement(
	            _antd.Button,
	            { key: 'back', onClick: this.props.cancel },
	            '\u53D6\u6D88'
	          ), _react2.default.createElement(
	            _antd.Button,
	            { key: 'submit', type: 'primary', loading: this.props.loading, onClick: this.submit },
	            '\u786E\u5B9A'
	          )]
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'horizontal' },
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u8BF7\u9009\u62E9\u5E74\u4EFD' }, formItemLayout),
	            getFieldDecorator('year', {
	              rules: [{ required: true, message: '请选择年份' }]
	            })(_react2.default.createElement(
	              _antd.Select,
	              null,
	              years.map(function (item) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item },
	                  item
	                );
	              })
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u4E0A\u4F20Excel\u6587\u4EF6' }, formItemLayout, { required: true }),
	            _react2.default.createElement(_UploadFile2.default, {
	              type: 'ghost',
	              handleUpload: this.handlelicenseFile,
	              fileList: licenseFile,
	              isExcel: true
	            }),
	            _react2.default.createElement(
	              'span',
	              { className: 'ant-form-text' },
	              '\xA0\u4EC5\u9650excel\u683C\u5F0F',
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return (0, _budget.queryDownloadGroupSetTemplate)();
	                  }, style: { marginLeft: '10px' } },
	                '\u6A21\u677F\u4E0B\u8F7D'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DetailModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(DetailModal);

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _YearPicker = __webpack_require__(154);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	var _budget = __webpack_require__(30);
	
	var _dict = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.loadDictIncome = function () {
	      (0, _dict.queryDictIncome)().then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.map(function (item) {
	            item.flag = false;
	            return 1;
	          });
	          _this.setState({
	            type: res.data
	          });
	        }
	      });
	    };
	
	    _this.getBudgetGroupAims = function (params) {
	      (0, _budget.queryBudgetGroupAims)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          if (res.data) {
	            res.data.aims && res.data.aims.map(function (item) {
	              item.id = item.uuid;
	              return item;
	            });
	            _this.setState({
	              sumAim: res.data.sumAim,
	              targetArr: res.data.aims || []
	            }, function () {
	              _this.changeArrFlag();
	            });
	          }
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.formatGroup = function (arr) {
	      arr.map(function (item) {
	        if (item.children) {
	          if (item.children.length === 0) {
	            delete item.children;
	            return item;
	          }
	          if (item.children.length > 0) {
	            _this.formatGroup(item.children);
	          }
	        }
	        return item;
	      });
	      return arr;
	    };
	
	    _this.formatOption = function (arr) {
	      var groupList = _this.state.groupList;
	
	      (arr || []).map(function (item) {
	        if (item.children && item.children.length > 0) {
	          _this.formatOption(item.children);
	        }
	        groupList.push(item);
	        return item;
	      });
	      _this.setState({ groupList: groupList });
	    };
	
	    _this.getGroupList = function () {
	      var companyAll = _this.props.data.companyAll;
	
	      var companyList = _this.formatGroup(companyAll);
	      _this.formatOption(companyList);
	    };
	
	    _this.changeGroupUuid = function (e) {
	      var year = _this.props.form.getFieldValue('year');
	      var groupUuid = e;
	      _this.setState({
	        sumAim: 0,
	        targetArr: []
	      });
	      year && groupUuid && _this.getBudgetGroupAims({
	        groupUuid: groupUuid,
	        year: year
	      });
	      return e;
	    };
	
	    _this.changeYear = function (e) {
	      var groupUuid = _this.props.form.getFieldValue('groupUuid');
	      var year = e;
	      _this.setState({
	        sumAim: 0,
	        targetArr: []
	      });
	      year && groupUuid && _this.getBudgetGroupAims({
	        groupUuid: groupUuid,
	        year: year
	      });
	      return e;
	    };
	
	    _this.changeArrFlag = function () {
	      var _this$state = _this.state,
	          targetArr = _this$state.targetArr,
	          type = _this$state.type;
	
	      var newType = [];
	      targetArr.map(function (item) {
	        newType = newType.concat(item.types);
	        return 1;
	      });
	      type.map(function (item) {
	        item.flag = newType.includes(item.value);
	        return 1;
	      });
	      _this.setState({
	        type: type
	      });
	    };
	
	    _this.handleAdd = function () {
	      var targetArr = _this.state.targetArr;
	
	      targetArr.push({ id: new Date().getTime() });
	      _this.setState({
	        targetArr: targetArr
	      });
	      _this.changeArrFlag();
	    };
	
	    _this.handleSub = function (index) {
	      var targetArr = _this.state.targetArr;
	
	      targetArr.splice(index, 1);
	      _this.setState({
	        targetArr: targetArr
	      });
	      _this.changeArrFlag();
	    };
	
	    _this.validateMax = function (rule, value, callback) {
	      var sumAim = _this.props.form.getFieldValue('sumAim');
	
	      if (value > sumAim) {
	        callback('不能大于总收入目标');
	      }
	      callback();
	    };
	
	    _this.validateMin = function (rule, value, callback) {
	      var targetArr = _this.state.targetArr;
	
	      var num = 0;
	      targetArr.map(function (item) {
	        num += item.aim;
	        return 1;
	      });
	      if (value < num) {
	        callback('不能小于类目收入之和');
	      }
	      callback();
	    };
	
	    _this.changeArrType = function (id, e) {
	      var targetArr = _this.state.targetArr;
	
	      targetArr.map(function (item) {
	        if (item.id === id) {
	          item.types = e;
	        }
	        return 1;
	      });
	
	      _this.setState({ targetArr: targetArr });
	      return e;
	    };
	
	    _this.changeArrAim = function (id, e) {
	      var targetArr = _this.state.targetArr;
	
	      var val = +e.target.value;
	
	      targetArr.map(function (item) {
	        if (item.id === id) {
	          item.aim = val;
	        }
	        return 1;
	      });
	      _this.setState({ targetArr: targetArr });
	      return val;
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var targetArr = _this.state.targetArr;
	
	      var target = _this.props.form.getFieldsValue();
	
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          var groupUuid = target.groupUuid;
	          var sumAim = target.sumAim;
	          var year = target.year;
	
	          _this.props.handSubmit({
	            groupUuid: groupUuid,
	            sumAim: sumAim,
	            year: year,
	            aims: targetArr
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      groupList: [],
	      targetArr: [],
	      sumAim: 0
	    };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadDictIncome();
	      this.getGroupList();
	    }
	
	    // 获得资金类型
	
	
	    // 获得历史数据
	
	
	    /** 设置预算组列表 */
	
	
	    // 使选过的资金类型不可以再选
	
	
	    // 新增具体类目
	
	
	    // 删除具体类目
	
	
	    // 具体类目收入验证
	
	
	    // 总收入目标验证
	
	
	    // 更新targetArr.item.type
	
	
	    // 更新targetArr.item.Aim
	
	
	    // 提交
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _state = this.state,
	          targetArr = _state.targetArr,
	          type = _state.type;
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: this.props.title,
	          visible: true,
	          width: 600,
	          onOk: this.submit,
	          onCancel: this.props.cancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u9009\u62E9\u9884\u7B97\u7EC4' }, formItemLayout),
	            getFieldDecorator('groupUuid', {
	              rules: [{ required: true, message: '请选择预算组' }],
	              getValueFromEvent: this.changeGroupUuid
	            })(_react2.default.createElement(
	              _antd.Select,
	              {
	                showSearch: true,
	                filterOption: function filterOption(input, option) {
	                  return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                },
	                placeholder: '\u8BF7\u9009\u62E9\u9884\u7B97\u7EC4'
	              },
	              this.state.groupList.map(function (item) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item.uuid },
	                  item.name
	                );
	              })
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u9009\u62E9\u5E74\u4EFD' }, formItemLayout),
	            getFieldDecorator('year', {
	              rules: [{ required: true, message: '请选择年份' }],
	              getValueFromEvent: this.changeYear
	            })(_react2.default.createElement(_YearPicker2.default, null))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u76EE\u6807\u6536\u5165' }, formItemLayout),
	            getFieldDecorator('sumAim', {
	              rules: [{ required: true, message: '请填写目标收入' }, { validator: this.validateMin }],
	              initialValue: this.state.sumAim || ''
	            })(_react2.default.createElement(_antd.Input, {
	              addonAfter: _react2.default.createElement(
	                'span',
	                null,
	                '\u5143'
	              ),
	              min: 0,
	              placeholder: '\u8BF7\u586B\u5199\u672C\u5E74\u603B\u7684\u6536\u5165\u76EE\u6807',
	              type: 'number'
	            }))
	          ),
	          targetArr.map(function (item, index) {
	            return _react2.default.createElement(
	              _antd.Row,
	              { key: item.id },
	              _react2.default.createElement(_antd.Col, { span: 2 }),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 18 },
	                _react2.default.createElement(
	                  _antd.Row,
	                  null,
	                  _react2.default.createElement(
	                    _antd.Col,
	                    { span: 10 },
	                    _react2.default.createElement(
	                      FormItem,
	                      null,
	                      getFieldDecorator('types' + item.id, {
	                        rules: [{ required: true, message: '请选择资金类型' }],
	                        getValueFromEvent: function getValueFromEvent(e) {
	                          return _this2.changeArrType(item.id, e);
	                        },
	                        initialValue: item.types || []
	                      })(_react2.default.createElement(
	                        _antd.Select,
	                        {
	                          mode: 'multiple',
	                          filterOption: function filterOption(input, option) {
	                            return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                          },
	                          placeholder: '\u8BF7\u9009\u62E9\u8D44\u91D1\u7C7B\u578B'
	                        },
	                        type.map(function (item1) {
	                          return _react2.default.createElement(
	                            Option,
	                            { key: item1.value, disabled: item1.flag },
	                            item1.key
	                          );
	                        })
	                      ))
	                    )
	                  ),
	                  _react2.default.createElement(_antd.Col, { span: 1 }),
	                  _react2.default.createElement(
	                    _antd.Col,
	                    { span: 10 },
	                    _react2.default.createElement(
	                      FormItem,
	                      null,
	                      getFieldDecorator('aim' + item.id, {
	                        rules: [{ required: true, message: '请填写目标收入' }, { validator: _this2.validateMax }],
	                        getValueFromEvent: function getValueFromEvent(e) {
	                          return _this2.changeArrAim(item.id, e);
	                        },
	                        initialValue: item.aim || ''
	                      })(_react2.default.createElement(_antd.Input, {
	                        addonAfter: _react2.default.createElement(
	                          'span',
	                          null,
	                          '\u5143'
	                        ),
	                        type: 'number',
	                        min: 1,
	                        placeholder: '\u8BF7\u586B\u5199\u6536\u5165\u76EE\u6807'
	                      }))
	                    )
	                  ),
	                  _react2.default.createElement(_antd.Col, { span: 1 }),
	                  _react2.default.createElement(
	                    _antd.Col,
	                    { span: 2 },
	                    _react2.default.createElement(
	                      FormItem,
	                      null,
	                      _react2.default.createElement(
	                        _antd.Button,
	                        { onClick: function onClick() {
	                            return _this2.handleSub(index);
	                          } },
	                        '-'
	                      )
	                    )
	                  )
	                )
	              )
	            );
	          }),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(_antd.Col, { span: 2 }),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 18 },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'dashed', block: true, onClick: this.handleAdd },
	                '+\u65B0\u589E\u5177\u4F53\u7C7B\u76EE\u7684\u76EE\u6807\u6536\u5165'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(IndexModal);

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(5);
	
	var _adjust_data = __webpack_require__(436);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _budget = __webpack_require__(30);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _dict = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.handleEdit = function (uuid) {
	      _this.props.handleEdit(uuid);
	    };
	
	    _this.handleEnable = function (uuid) {
	      _this.props.handleEnable(uuid);
	    };
	
	    _this.handleDisable = function (uuid) {
	      _this.props.handleDisable(uuid);
	    };
	
	    _this.loadExpendType = function () {
	      (0, _dict.queryDictExpend)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            expendType: res.data
	          });
	        }
	      });
	    };
	
	    _this.getAccount = function (uuid) {
	      var expendType = _this.state.expendType;
	
	      (0, _budget.queryBudgetAccount)({
	        groupUuid: uuid,
	        year: _this.state.year
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.map(function (item) {
	            expendType.map(function (it) {
	              if (item.type === it.value) {
	                item.typeName = it.key;
	              }
	              return it;
	            });
	            return item;
	          });
	          _this.setState({
	            accountList1: res.data.slice(0, 15),
	            accountList2: res.data.slice(15),
	            accountFlag: true
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {
	      _this.setState({
	        accountFlag: false
	      });
	    };
	
	    _this.accountColumns = function () {
	      return [{
	        title: '类目',
	        dataIndex: 'typeName',
	        key: 'typeName',
	        width: '6%',
	        render: function render(text) {
	          return text;
	        }
	      }, {
	        title: '余额',
	        dataIndex: 'current',
	        key: 'current',
	        width: '6%',
	        render: function render(text) {
	          var current = _util2.default.numberFormat(text);
	          return text ? current : text;
	        }
	      }, {
	        title: '冻结金额',
	        dataIndex: 'freeze',
	        key: 'freeze',
	        width: '6%',
	        render: function render(text) {
	          var freeze = _util2.default.numberFormat(text);
	          return text ? freeze : text;
	        }
	      }];
	    };
	
	    _this.accordYear = function () {
	      var currentYear = +_this.state.year;
	      var year = +(_this.props.year ? _this.props.year : _this.state.year);
	      var adjustFlag = true;
	      if (year < currentYear) {
	        adjustFlag = false;
	      } else {
	        adjustFlag = true;
	      }
	
	      return adjustFlag;
	    };
	
	    _this.setAdjustGroup = function (id) {
	      var company = _this.props.company;
	
	      company.map(function (item) {
	        if (item.uuid === id) {
	          _this.props.dispatch((0, _adjust_data.getAdjustData)(item));
	        } else if (item.children && item.children.length > 0) {
	          item.children.map(function (item1) {
	            if (item1.uuid === id) {
	              _this.props.dispatch((0, _adjust_data.getAdjustData)(item1));
	            }
	            return 1;
	          });
	        }
	
	        return 1;
	      });
	    };
	
	    _this.initTitle = function () {
	      var content = '本年预算(调整次数，调整总金额)';
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u672C\u5E74\u9884\u7B97',
	        _react2.default.createElement(
	          _antd.Tooltip,
	          { title: content },
	          _react2.default.createElement(_antd.Icon, { type: 'info-circle', style: { fontSize: '10px' } })
	        )
	      );
	    };
	
	    _this.currentTitle = function () {
	      var content = '预算余额(冻结金额)';
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u9884\u7B97\u4F59\u989D',
	        _react2.default.createElement(
	          _antd.Tooltip,
	          { title: content },
	          _react2.default.createElement(_antd.Icon, { type: 'info-circle', style: { fontSize: '10px' } })
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '序号',
	        dataIndex: 'num',
	        key: 'num',
	        width: '6%',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '预算组名称',
	        dataIndex: 'name',
	        key: 'name',
	        width: '12%',
	        align: 'left',
	        render: function render(text, record) {
	          if (record.isEnable === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              text
	            );
	          }
	          if (record.isEnable === 1) {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/budget/' + record.uuid + '/check' },
	              text
	            );
	          }
	        }
	      }, {
	        title: _this.initTitle(),
	        dataIndex: 'init',
	        key: 'init',
	        width: '16%',
	        align: 'left',
	        render: function render(text, record) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	          var color = '';
	          if (record.adjustmentSum > 0) {
	            color = 'red';
	          } else if (record.adjustmentSum < 0) {
	            color = 'green';
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            money === '0.00' ? '-' : money,
	            record.adjustmentCount ? _react2.default.createElement(
	              'span',
	              { style: { color: '#FF9F9F' } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#505659' } },
	                '( '
	              ),
	              record.adjustmentCount,
	              ':',
	              _react2.default.createElement(
	                'span',
	                { style: { color: color } },
	                record.adjustmentSum
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#505659' } },
	                ' )'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: _this.currentTitle(),
	        dataIndex: 'current',
	        key: 'current',
	        width: '16%',
	        align: 'left',
	        render: function render(text, record) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	          return _react2.default.createElement(
	            'div',
	            null,
	            money === '0.00' ? '-' : _react2.default.createElement(
	              _reactRouter.Link,
	              { onClick: function onClick() {
	                  return _this.getAccount(record.uuid);
	                } },
	              money
	            ),
	            record.freeze ? _react2.default.createElement(
	              'span',
	              { style: { color: '#BCBCBC' } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#505659' } },
	                '( '
	              ),
	              '\u51BB\u7ED3',
	              record.freeze,
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#505659' } },
	                ' )'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '本年目标收入',
	        dataIndex: 'aims',
	        key: 'aims',
	        width: '12%',
	        align: 'left',
	        render: function render(text) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	          return _react2.default.createElement(
	            'span',
	            null,
	            money === '0.00' ? '-' : money
	          );
	        }
	      }, {
	        title: '实际收入',
	        dataIndex: 'income',
	        key: 'income',
	        width: '12%',
	        align: 'left',
	        render: function render(text) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	          return _react2.default.createElement(
	            'span',
	            null,
	            money === '0.00' ? '-' : money
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        width: '26%',
	        render: function render(text, record) {
	          var year = +(_this.props.year ? _this.props.year : _this.state.year);
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.isEnable === 0 ? _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                placement: 'leftTop',
	                title: '\u786E\u5B9A\u542F\u7528\u6B64\u9884\u7B97\u7EC4\u5417\uFF1F',
	                onConfirm: function onConfirm() {
	                  return _this.handleEnable(record.uuid);
	                },
	                okText: '\u786E\u5B9A',
	                cancelText: '\u53D6\u6D88'
	              },
	              _react2.default.createElement(
	                'a',
	                null,
	                '\u542F\u7528'
	              )
	            ) : _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.handleEdit(record.uuid);
	                  } },
	                '\u7F16\u8F91'
	              ),
	              _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	              _react2.default.createElement(
	                _antd.Popconfirm,
	                {
	                  placement: 'leftTop',
	                  title: '\u786E\u5B9A\u7981\u7528\u6B64\u9884\u7B97\u7EC4\u5417\uFF1F',
	                  onConfirm: function onConfirm() {
	                    return _this.handleDisable(record.uuid);
	                  },
	                  okText: '\u786E\u5B9A',
	                  cancelText: '\u53D6\u6D88'
	                },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  '\u7981\u7528'
	                )
	              ),
	              _this.accordYear() ? _react2.default.createElement(_antd.Divider, { type: 'vertical' }) : null,
	              _this.accordYear() ? _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  onClick: function onClick() {
	                    return _this.setAdjustGroup(record.uuid);
	                  },
	                  to: '/finance/budget/' + 'initiate' + '/' + year + '/adjust'
	                },
	                '\u8C03\u6574\u9884\u7B97'
	              ) : null,
	              _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: {
	                    pathname: '/finance/budget/' + record.uuid + '/toviewDetail',
	                    query: {
	                      groupName: record.name,
	                      year: _this.props.year
	                    }
	                  }
	                },
	                '\u67E5\u770B\u9884\u7B97'
	              ),
	              _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: {
	                    pathname: '/finance/budget/' + record.uuid + '/' + year + '/balance',
	                    query: {
	                      source: 'all'
	                    }
	                  }
	                },
	                '\u6536\u652F\u5206\u6790'
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.onSelectChange = function (selectedRowKeys) {
	      var selected = [];
	      if (selectedRowKeys.length > 1) {
	        selected.push(selectedRowKeys[1]);
	      } else {
	        selected = selected.concat(selectedRowKeys);
	      }
	      _this.setState({ selectedRowKeys: selected });
	      _this.props.handleAdd(selected[0]);
	    };
	
	    _this.state = {
	      selectedRowKeys: [],
	      expendType: [],
	      accountList1: [],
	      accountList2: [],
	      accountFlag: false,
	      year: ''
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        year: nextProps.year
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadExpendType();
	      var currentYear = this.props.year || _moment2.default.unix(new Date().getTime() / 1000).format('YYYY');
	      this.setState({
	        year: currentYear
	      });
	    }
	
	    // 获取支出类别
	
	
	    // 获取余额明细
	
	
	    // 根据年份判断（预算调整）
	
	
	    // 预算调整数据生成
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          company = _props.company,
	          isLoading = _props.isLoading;
	      var _state = this.state,
	          selectedRowKeys = _state.selectedRowKeys,
	          accountList1 = _state.accountList1,
	          accountList2 = _state.accountList2;
	
	      var rowSelection = {
	        selectedRowKeys: selectedRowKeys,
	        onChange: this.onSelectChange
	      };
	      var sp = 24;
	      if (accountList2 && accountList2.length > 0) {
	        sp = 11;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Table, {
	          key: Date.now(),
	          rowKey: function rowKey(record) {
	            return record.uuid;
	          },
	          rowSelection: rowSelection,
	          defaultExpandAllRows: true,
	          columns: this.columns(),
	          dataSource: company,
	          pagination: false,
	          loading: isLoading,
	          size: 'small'
	        }),
	        _react2.default.createElement(
	          _antd.Modal,
	          {
	            title: _react2.default.createElement(
	              'span',
	              null,
	              '\u9884\u7B97\u4F59\u989D  \u5E74\u4EFD\uFF1A' + this.state.year
	            ),
	            footer: null,
	            onCancel: this.handleCancel,
	            visible: this.state.accountFlag,
	            width: '60%'
	          },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: sp },
	              _react2.default.createElement(_antd.Table, {
	                dataSource: accountList1,
	                tableLayout: 'inline',
	                columns: this.accountColumns(),
	                pagination: false
	              })
	            ),
	            accountList2 && accountList2.length > 0 ? _react2.default.createElement(_antd.Col, { span: 2 }) : null,
	            accountList2 && accountList2.length > 0 ? _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(_antd.Table, {
	                dataSource: accountList2,
	                tableLayout: 'inline',
	                columns: this.accountColumns(),
	                pagination: false
	              })
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.user
	  };
	})(Index);

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _budget = __webpack_require__(30);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _dict = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.setDR = function () {
	      var _this$state = _this.state,
	          details = _this$state.details,
	          records = _this$state.records,
	          expendType = _this$state.expendType,
	          monthList = _this$state.monthList,
	          adjustList = _this$state.adjustList;
	
	      var minRecords = [];
	      var yearAdjustment = 0;
	      var lengthh = records.length < 5 ? records.length : 5;
	
	      details.map(function (item) {
	        expendType.map(function (it) {
	          if (it.value === item.type) {
	            item.type = it.key;
	          }
	          return 1;
	        });
	
	        monthList.map(function (it) {
	          if (it.value === item.month) {
	            item.month = it.key;
	          }
	          return 1;
	        });
	
	        adjustList.map(function (it) {
	          if (+it.value === item.target) {
	            item.target = it.key;
	          }
	          return 1;
	        });
	
	        return 1;
	      });
	
	      records.map(function (item) {
	        yearAdjustment += +item.adjustment;
	        item.createTime = _moment2.default.unix(item.createTime / 1000).format('YYYY-MM-DD');
	        expendType.map(function (it) {
	          if (it.value === item.type) {
	            item.type = it.key;
	          }
	          return 1;
	        });
	
	        monthList.map(function (it) {
	          if (it.value === item.month) {
	            item.month = it.key;
	          }
	          return 1;
	        });
	
	        adjustList.map(function (it) {
	          if (+it.value === item.target) {
	            item.target = it.key;
	          }
	          return 1;
	        });
	
	        return 1;
	      });
	
	      for (var i = 0; i < lengthh; i++) {
	        minRecords.push(records[i]);
	      }
	
	      _this.setState({
	        details: details,
	        records: records,
	        minRecords: minRecords,
	        yearAdjustment: yearAdjustment
	      });
	    };
	
	    _this.toPage = function (record) {
	      _this.props.router.push({
	        pathname: '/finance/budget/' + record.uuid + '/' + record.year + '/adjust/info'
	      });
	    };
	
	    _this.getAnalysis = function () {
	      var params = {};
	      var nowAimPre = 0;
	      var year = _this.props.params.year;
	
	      var yStart = new Date(+year, 0, 1, 0, 0, 0, 0);
	      var yEnd = new Date(+year + 1, 0, 1, 0, 0, 0, 0);
	      var yNow = Date.now();
	
	      if (yNow <= yStart) {
	        nowAimPre = 0;
	      } else if (yNow >= yEnd) {
	        nowAimPre = 1;
	      } else {
	        nowAimPre = Math.floor((yNow - yStart) / (yEnd - yStart) * 10000) / 10000;
	      }
	      params.groupUuids = [_this.state.data.groupUuid];
	      params.year = year;
	      (0, _budget.queryBudgetAnalysis)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.income.map(function (item) {
	            if (item.type === 'sum') {
	              item.plan = item.aim * nowAimPre;
	              _this.setState({
	                incomeData: item,
	                expendData: res.data.expenditure
	              });
	            }
	            return item;
	          });
	        }
	      });
	    };
	
	    _this.inExtra = function () {
	      var _this$state2 = _this.state,
	          records = _this$state2.records,
	          isSpread = _this$state2.isSpread;
	
	      if (records.length > 5) {
	        if (isSpread === false) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { onClick: _this.changeIsSpread },
	            '\u66F4\u591A',
	            _react2.default.createElement(_antd.Icon, {
	              type: 'down',
	              style: {
	                fontSize: '10px',
	                paddingLeft: '3px',
	                position: 'relative',
	                top: '-1px'
	              }
	            })
	          );
	        }
	        if (isSpread === true) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { onClick: _this.changeIsSpread },
	            '\u6536\u8D77',
	            _react2.default.createElement(_antd.Icon, {
	              type: 'up',
	              style: {
	                fontSize: '10px',
	                paddingLeft: '3px',
	                position: 'relative',
	                top: '-1px'
	              }
	            })
	          );
	        }
	        return null;
	      }
	      return null;
	    };
	
	    _this.changeIsSpread = function () {
	      var isSpread = _this.state.isSpread;
	
	      _this.setState({
	        isSpread: !isSpread
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '资金类型',
	        dataIndex: 'type',
	        key: 'type',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }, {
	        title: '月份',
	        dataIndex: 'month',
	        key: 'month',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }, {
	        title: '预算类型',
	        dataIndex: 'target',
	        key: 'target',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }, {
	        title: '调整金额',
	        dataIndex: 'adjustment',
	        key: 'adjustment',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ','),
	            '\u5143'
	          );
	        }
	      }, {
	        title: '原因',
	        dataIndex: 'reason',
	        key: 'reason',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }];
	    };
	
	    _this.recordsColumns = function () {
	      return [{
	        title: '流水编号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { onClick: function onClick() {
	                return _this.toPage(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: '预算组名称',
	        dataIndex: 'groupName',
	        key: 'groupName'
	      }, {
	        title: '预算年度',
	        dataIndex: 'year',
	        key: 'year'
	      }, {
	        title: '预算调整金额',
	        dataIndex: 'adjustment',
	        key: 'adjustment',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _index2.default.numberFormat(text, 2, '.', ',') : '-'
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text || '-'
	          );
	        }
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: {},
	      details: [],
	      records: [],
	      minRecords: [],
	      instance: {},
	      histories: [],
	      expendType: [],
	      monthList: [],
	      adjustList: [],
	      incomeData: {},
	      expendData: {},
	      isSpread: false
	    };
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        var _this2 = this;
	
	        var data, monthList, adjustList;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                // 获取数据
	                data = this.props.data;
	
	
	                this.setState({
	                  data: data,
	                  records: data.records,
	                  details: data.details,
	                  instance: data.instance,
	                  histories: data.histories
	                });
	
	                // 设置支出类别
	                _context.next = 4;
	                return (0, _dict.queryDictExpend)().then(function (res) {
	                  if (res.statusCode === 200) {
	                    _this2.setState({
	                      expendType: res.data
	                    });
	                  }
	                });
	
	              case 4:
	
	                // 设置月份数组
	                monthList = [{ key: '一月', value: '01', disFlag: false }, { key: '二月', value: '02', disFlag: false }, { key: '三月', value: '03', disFlag: false }, { key: '四月', value: '04', disFlag: false }, { key: '五月', value: '05', disFlag: false }, { key: '六月', value: '06', disFlag: false }, { key: '七月', value: '07', disFlag: false }, { key: '八月', value: '08', disFlag: false }, { key: '九月', value: '09', disFlag: false }, { key: '十月', value: '10', disFlag: false }, { key: '十一月', value: '11', disFlag: false }, { key: '十二月', value: '12', disFlag: false }];
	
	                // 设置调整类型
	
	                adjustList = [{ key: '增加预算', value: 1 }, { key: '减少预算', value: 0 }];
	
	
	                this.setState({
	                  monthList: monthList,
	                  adjustList: adjustList
	                });
	
	                (0, _budget.queryAdjustmentWorkflow)().then(function (res) {
	                  if (res.statusCode === 200) {
	                    var instanceBak = {};
	                    _this2.setState(function () {
	                      instanceBak.activities = res.data;
	                      return {
	                        instanceBak: instanceBak
	                      };
	                    });
	                  }
	                });
	                this.setDR();
	                this.getAnalysis();
	
	              case 10:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.params.uuid !== this.props.params.uuid) {
	        window.location.reload();
	      }
	    }
	
	    // 设置details和records
	
	
	    // 获取收支数据
	
	
	    // 展开历史列表
	
	
	    // 表格
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          data = _state.data,
	          records = _state.records,
	          minRecords = _state.minRecords,
	          details = _state.details,
	          instance = _state.instance,
	          histories = _state.histories,
	          isSpread = _state.isSpread,
	          incomeData = _state.incomeData,
	          expendData = _state.expendData,
	          yearAdjustment = _state.yearAdjustment;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          {
	            title: '\u9884\u7B97\u4FE1\u606F',
	            extra: _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: {
	                    pathname: '/finance/budgets/' + data.groupUuid + '/year',
	                    query: {
	                      companyName: data.groupName
	                    }
	                  },
	                  style: { marginRight: '10px' }
	                },
	                '\u67E5\u770B\u9884\u7B97\u7EDF\u8BA1'
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: {
	                    pathname: '/finance/budget/' + data.groupUuid + '/' + data.year + '/balance',
	                    query: {
	                      source: 'all'
	                    }
	                  }
	                },
	                '\u67E5\u770B\u6536\u652F\u5206\u6790'
	              )
	            )
	          },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u7EC4' },
	              data.groupName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5168\u5E74\u76EE\u6807\u6536\u5165' },
	              _index2.default.numberFormat(+incomeData.aim)
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5168\u5E74\u9884\u7B97\u652F\u51FA' },
	              _index2.default.numberFormat(+expendData.budget)
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u603B\u989D' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _index2.default.numberFormat(+data.budget),
	                data.adjustment && data.instance.status === 0 ? _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red' } },
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: '#505659' } },
	                    '( '
	                  ),
	                  '\u8C03\u6574\u540E\uFF1A',
	                  _index2.default.numberFormat(+data.adjustment + +data.budget),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: '#505659' } },
	                    ' )'
	                  )
	                ) : ''
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F53\u524D\u8BA1\u5212\u5B9E\u73B0\u6536\u5165' },
	              _index2.default.numberFormat(+incomeData.plan)
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F53\u524D\u5B9E\u9645\u4F7F\u7528\u9884\u7B97' },
	              _index2.default.numberFormat(+expendData.actual)
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u5E74\u5EA6' },
	              data.year
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F53\u524D\u5B9E\u9645\u5B9E\u73B0\u6536\u5165' },
	              _index2.default.numberFormat(+incomeData.actual)
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u672C\u671F\u9884\u7B97\u4F59\u989D' },
	              _react2.default.createElement(
	                'span',
	                null,
	                _index2.default.numberFormat(+data.current),
	                data.freeze ? _react2.default.createElement(
	                  'span',
	                  { style: { color: '#BCBCBC' } },
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: '#505659' } },
	                    '( '
	                  ),
	                  '\u51BB\u7ED3',
	                  _index2.default.numberFormat(+data.freeze),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { color: '#505659' } },
	                    ' )'
	                  )
	                ) : ''
	              )
	            )
	          ),
	          _react2.default.createElement(_antd.Divider, null),
	          _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center', padding: '30px 0' } },
	            '\u9884\u7B97\u8C03\u6574\u660E\u7EC6'
	          ),
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            dataSource: details,
	            pagination: false,
	            rowKey: function rowKey(record) {
	              return record.uuid;
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center', padding: '30px 0' } },
	            +yearAdjustment < 0 ? _react2.default.createElement(
	              'span',
	              { style: { color: 'red', paddingRight: '10px' } },
	              data.groupName,
	              '\u672C\u5E74\u5EA6\u51CF\u5C11\u9884\u7B97\u91D1\u989D\uFF1A',
	              _index2.default.numberFormat(Math.abs(+yearAdjustment)),
	              '\u5143'
	            ) : _react2.default.createElement(
	              'span',
	              { style: { color: 'red', paddingRight: '10px' } },
	              data.groupName,
	              '\u672C\u5E74\u5EA6\u589E\u52A0\u9884\u7B97\u91D1\u989D\uFF1A',
	              _index2.default.numberFormat(+yearAdjustment),
	              '\u5143'
	            ),
	            this.inExtra()
	          ),
	          _react2.default.createElement(_antd.Table, {
	            columns: this.recordsColumns(),
	            dataSource: isSpread ? records : minRecords,
	            pagination: false,
	            rowKey: function rowKey(record) {
	              return record.uuid;
	            }
	          })
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              instance ? _react2.default.createElement(_Process2.default, { instance: instance }) : null,
	              !instance && this.state.instanceBak ? _react2.default.createElement(_Process2.default, { instance: this.state.instanceBak }) : null
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              histories ? _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories }) : null
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'budgetAdjust', uuid: data.uuid } })
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = BaseForm;

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _budget = __webpack_require__(30);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _expend_type = __webpack_require__(80);
	
	var _company_list = __webpack_require__(96);
	
	var _PageAdd = __webpack_require__(695);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	var _PageOpen = __webpack_require__(1585);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getAdjustmentInfo = function () {
	      var uuid = _this.props.params.uuid;
	
	      (0, _budget.queryAdjustmentInfo)({
	        uuid: uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getAdjustmentInfo();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	      dispatch((0, _company_list.getCompanyList)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageAdd2.default, Object.assign({ params: this.props.params }, this.props));
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(PageInfo);

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _budget = __webpack_require__(30);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _DateConditionSearch = __webpack_require__(684);
	
	var _DateConditionSearch2 = _interopRequireDefault(_DateConditionSearch);
	
	var _TableSet = __webpack_require__(696);
	
	var _TableSet2 = _interopRequireDefault(_TableSet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getAdjustBudgetMy = function (params) {
	      _this.setState({ loading: true });
	      (0, _budget.queryAdjustBudgetMy)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataSource: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 15,
	                current: _this.current
	              }
	            }
	          });
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getAdjustBudgetMy(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        loading: false,
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.location.pathname
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_DateConditionSearch2.default, Object.assign({ onChange: this.handleSearch }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableSet2.default, Object.assign({}, parentProps, this.props))
	        )
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _budget = __webpack_require__(30);
	
	var _WorkflowOp = __webpack_require__(134);
	
	var _WorkflowOp2 = _interopRequireDefault(_WorkflowOp);
	
	var _PageDetails = __webpack_require__(1582);
	
	var _PageDetails2 = _interopRequireDefault(_PageDetails);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.doTask = function (pass, refuse) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackAdjustment(item);
	          break;
	        case 'next':
	          _this.nextAdjustment(item);
	          break;
	        case 'return':
	          _this.returnAdjustment(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackAdjustment = function (params) {
	      (0, _budget.queryCallbackAdjustment)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextAdjustment = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _budget.queryNextAdjustment)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.setState({ isLoading: false });
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnAdjustment = function (params, refuse) {
	      (0, _budget.queryReturnAdjustment)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null
	          );
	        }
	      }, {
	        title: '操作内容',
	        dataIndex: 'operating'
	      }, {
	        title: '处理意见',
	        dataIndex: 'refuse'
	      }];
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ dataInfo: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isLoading = _state.isLoading;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowOp2.default, {
	          data: dataInfo,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_PageDetails2.default, Object.assign({ data: dataInfo }, this.props))
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _budget = __webpack_require__(30);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _TableSet = __webpack_require__(696);
	
	var _TableSet2 = _interopRequireDefault(_TableSet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getAdjustBudgetWatch = function (params) {
	      _this.setState({ loading: true });
	      (0, _budget.queryAdjustBudgetWatch)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataSource: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 15,
	                current: _this.current
	              }
	            }
	          });
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getAdjustBudgetWatch(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        loading: false,
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.location.pathname
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableSet2.default, Object.assign({}, parentProps, this.props))
	        )
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(265);
	
	var _BackBtn = __webpack_require__(12);
	
	var _reactRedux = __webpack_require__(5);
	
	var _DateSearch = __webpack_require__(685);
	
	var _DateSearch2 = _interopRequireDefault(_DateSearch);
	
	var _expend_type = __webpack_require__(80);
	
	var _income_type = __webpack_require__(437);
	
	var _TabDetail = __webpack_require__(1589);
	
	var _TabDetail2 = _interopRequireDefault(_TabDetail);
	
	var _TabChart = __webpack_require__(1588);
	
	var _TabChart2 = _interopRequireDefault(_TabChart);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.handleChange = function (params) {
	      _this.setState({
	        condition: Object.assign({}, params)
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)()); // 资金流水列表需要类目
	      dispatch((0, _income_type.getIncomeType)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var condition = this.state.condition;
	      var year = this.props.location.query.year;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_BackBtn.BackBtn, null),
	        _react2.default.createElement(
	          _antd.Tabs,
	          {
	            defaultActiveKey: '1',
	            onChange: this.callback,
	            tabBarExtraContent: _react2.default.createElement(_DateSearch2.default, {
	              onChange: this.handleChange,
	              defaultValue: {
	                beginDate: year + '-01-01',
	                endDate: year + '-12-31'
	              }
	            })
	          },
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u603B\u652F\u51FA', key: '1' },
	            _react2.default.createElement(
	              _antd.Card,
	              null,
	              _react2.default.createElement(_TabChart2.default, Object.assign({}, this.props, { condition: condition }))
	            )
	          ),
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u8BE6\u60C5', key: '2' },
	            _react2.default.createElement(_TabDetail2.default, Object.assign({}, this.props, { condition: condition }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    incomeType: state.income_type
	  };
	})(Index);

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _big = __webpack_require__(235);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _Index = __webpack_require__(680);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(681);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _Index5 = __webpack_require__(430);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _YearPicker = __webpack_require__(154);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	var _budget = __webpack_require__(30);
	
	__webpack_require__(265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import moment from "moment";
	
	
	var FormItem = _antd.Form.Item;
	var month = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	// const currentYear = moment.unix(new Date().getTime() / 1000).format("YYYY");
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.findTypeName = function (key) {
	      var typeName = '';
	      var expendType = _this.props.expendType;
	
	      expendType.forEach(function (item) {
	        if (key === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.getAnalysisBudget = function () {
	      var sum = new _big2.default(0);
	      var groupUuids = _this.props.params.uuid.split(',');
	      (0, _budget.queryBudgetAnalysisBudget)(Object.assign({
	        groupUuids: groupUuids,
	        target: 0
	      }, _this.condition)).then(function (res) {
	        if (res.statusCode === 200) {
	          var pieData2 = [];
	          var legendData = [];
	          var selected = {};
	          res.data.forEach(function (item, index) {
	            sum = sum.plus(new _big2.default(item.price || 0));
	            var typeName = _this.findTypeName(item.type) || '未定义类型';
	            legendData.push(typeName);
	            selected[typeName] = index < 15;
	            pieData2.push({
	              name: typeName,
	              value: item.price
	            });
	          });
	          _this.setState({
	            selected: selected,
	            pieData2: pieData2,
	            legendData: legendData
	          });
	        }
	      });
	    };
	
	    _this.getAnalysisBudgetMonth = function () {
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          beginYear = _this$props$form$getF.beginYear,
	          endYear = _this$props$form$getF.endYear,
	          type = _this$props$form$getF.type;
	
	      var groupUuids = _this.props.params.uuid.split(',');
	      (0, _budget.queryBudgetAnalysisBudgetMonth)({
	        groupUuids: groupUuids,
	        type: type === '-1' ? '' : type,
	        target: 0,
	        beginYear: beginYear,
	        endYear: endYear
	      }).then(function (res) {
	        var beginData = [];
	        var endData = [];
	        if (res.statusCode === 200) {
	          for (var i = 0; i < month.length; i++) {
	            beginData.push(res.data[beginYear][month[i]] || 0);
	            endData.push(res.data[endYear][month[i]] || 0);
	            _this.setState({
	              beginYear: beginYear,
	              endYear: endYear,
	              beginData: beginData,
	              endData: endData
	            });
	          }
	        }
	      });
	    };
	
	    _this.handleSearch = function () {
	      _this.getAnalysisBudgetMonth();
	    };
	
	    _this.state = {
	      selected: {},
	      legendData: [],
	      pieData2: [],
	      beginYear: '' + (_this.props.location.query.year - 1),
	      endYear: _this.props.location.query.year,
	      beginData: [],
	      endData: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var year = this.props.location.query.year;
	
	      this.condition = {
	        beginDate: year + '-01-01',
	        endDate: year + '-12-31'
	      };
	      this.getAnalysisBudget();
	      this.getAnalysisBudgetMonth();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (Object.keys(nextProps.condition || {}).some(function (key) {
	        return nextProps.condition[key] !== _this2.condition[key];
	      })) {
	        this.condition = nextProps.condition;
	        this.getAnalysisBudget();
	        this.getAnalysisBudgetMonth();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          beginYear = _state.beginYear,
	          endYear = _state.endYear,
	          beginData = _state.beginData,
	          endData = _state.endData,
	          legendData = _state.legendData,
	          pieData2 = _state.pieData2,
	          selected = _state.selected;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var line2Props = {
	        title: '月支出对比',
	        legend: [beginYear, endYear],
	        xAxisData: month,
	        series: [{
	          name: beginYear,
	          type: 'line',
	          data: beginData
	        }, {
	          name: endYear,
	          type: 'line',
	          data: endData
	        }]
	      };
	      var pieData3 = {
	        title: '支出类型统计',
	        selected: selected,
	        legendData: legendData,
	        seriesData: pieData2
	      };
	      var expendType = this.props.expendType;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'analyze' },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 16 },
	            _react2.default.createElement(_Index2.default, { data: pieData3 })
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 8 },
	            _react2.default.createElement(_Index4.default, { data: pieData2, title: '\u652F\u51FA\u7C7B\u578B\u6392\u540D' })
	          )
	        ),
	        _react2.default.createElement(_antd.Divider, null),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              '\u6708\u652F\u51FA\u5BF9\u6BD4(\u5355\u4F4D\uFF1A\u5143)'
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('type', {
	                initialValue: '-1'
	              })(_react2.default.createElement(
	                _antd.Select,
	                { style: { width: '150px' } },
	                _react2.default.createElement(
	                  _antd.Select.Option,
	                  { value: '-1' },
	                  '\u5168\u90E8'
	                ),
	                expendType.map(function (item) {
	                  return _react2.default.createElement(
	                    _antd.Select.Option,
	                    { value: item.value, key: item.value },
	                    item.key
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('beginYear', {
	                initialValue: beginYear
	              })(_react2.default.createElement(_YearPicker2.default, { style: { width: '150px' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('endYear', {
	                initialValue: endYear
	              })(_react2.default.createElement(_YearPicker2.default, { style: { width: '150px' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              _react2.default.createElement(
	                _antd.Button,
	                { onClick: this.handleSearch, type: 'primary' },
	                '\u67E5\u8BE2'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Index6.default, line2Props)
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Index = __webpack_require__(676);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(675);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _budget = __webpack_require__(30);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var TabDetail = function (_Component) {
	  _inherits(TabDetail, _Component);
	
	  function TabDetail(props) {
	    _classCallCheck(this, TabDetail);
	
	    var _this = _possibleConstructorReturn(this, (TabDetail.__proto__ || Object.getPrototypeOf(TabDetail)).call(this, props));
	
	    _this.findTypeName = function (record) {
	      var typeName = '';
	      var _this$props = _this.props,
	          incomeType = _this$props.incomeType,
	          expendType = _this$props.expendType;
	
	      var type = record.target === 0 ? expendType : incomeType;
	      type.forEach(function (item) {
	        if (record.type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.exportFinanceRecord = function () {
	      (0, _budget.queryExportBudgetAnalysisExpenditure)(Object.assign({
	        groupUuids: _this.props.params.uuid,
	        target: 0
	      }, _this.condition, _this.searchCondition));
	    };
	
	    _this.getAnalysisExpenditure = function () {
	      var pageSize = 10;
	      (0, _budget.queryBudgetAnalysisExpenditure)(Object.assign({
	        groupUuids: _this.props.params.uuid,
	        limit: pageSize,
	        target: 0,
	        start: _this.current || 1
	      }, _this.condition, _this.searchCondition)).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.forEach(function (item) {
	            item.typeName = _this.findTypeName(item);
	          });
	          _this.setState({
	            recordData: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: pageSize,
	                current: _this.current
	              }
	            }
	          });
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.current = pagination.current;
	      _this.getAnalysisExpenditure();
	    };
	
	    _this.handleSearCh = function () {
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          _this$props$form$getF2 = _this$props$form$getF.types,
	          types = _this$props$form$getF2 === undefined ? [] : _this$props$form$getF2,
	          _this$props$form$getF3 = _this$props$form$getF.money,
	          money = _this$props$form$getF3 === undefined ? [] : _this$props$form$getF3,
	          _this$props$form$getF4 = _this$props$form$getF.account,
	          account = _this$props$form$getF4 === undefined ? '' : _this$props$form$getF4,
	          _this$props$form$getF5 = _this$props$form$getF.remark,
	          remark = _this$props$form$getF5 === undefined ? '' : _this$props$form$getF5;
	
	      var moneyRange = money.length > 0 ? money[0].split('~') : [];
	      _this.current = 1;
	      _this.searchCondition = {
	        types: types,
	        account: account,
	        remark: remark,
	        begin: moneyRange[0] ? parseInt(moneyRange[0], 10) : '',
	        end: moneyRange[1] || ''
	      };
	      _this.getAnalysisExpenditure();
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'createTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '支出金额',
	        dataIndex: 'expenditure',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text > 0 ? _index2.default.numberFormat(text) : 0
	          );
	        }
	      }, {
	        title: '业务类型',
	        dataIndex: 'type',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.typeName
	          );
	        }
	      }, {
	        title: '备注',
	        dataIndex: 'remark',
	        width: '400px',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'p',
	            { className: 'banlance-remark' },
	            text
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      recordData: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(TabDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var year = this.props.location.query.year;
	
	      this.condition = {
	        beginDate: year + '-01-01',
	        endDate: year + '-12-31'
	      };
	      this.getAnalysisExpenditure();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (Object.keys(nextProps.condition || {}).some(function (key) {
	        return nextProps.condition[key] !== _this2.condition[key];
	      })) {
	        this.condition = nextProps.condition;
	        this.getAnalysisExpenditure();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var formItemLayout = {
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 16 }
	        }
	      };
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var actionsTextMap = {
	        expandText: '展开',
	        collapseText: '收起',
	        selectAllText: '全部'
	      };
	      var _state$recordData = this.state.recordData,
	          list = _state$recordData.list,
	          pagination = _state$recordData.pagination;
	      var expendType = this.props.expendType;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'analyze' },
	        _react2.default.createElement(
	          _antd.Card,
	          { bordered: false, style: { marginBottom: '16px' } },
	          _react2.default.createElement(
	            _antd.Form,
	            { layout: 'inline' },
	            _react2.default.createElement(
	              _Index4.default,
	              { title: '\u6240\u5C5E\u7C7B\u76EE', block: true, style: { paddingBottom: 11 } },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                getFieldDecorator('types')(_react2.default.createElement(
	                  _Index2.default,
	                  { expandable: true, actionsText: actionsTextMap, multiple: true },
	                  expendType.map(function (item) {
	                    return _react2.default.createElement(
	                      _Index2.default.Option,
	                      { value: item.value, key: item.value },
	                      item.key
	                    );
	                  })
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _Index4.default,
	              { title: '\u91D1\u989D', block: true, style: { paddingBottom: 11 } },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                getFieldDecorator('money')(_react2.default.createElement(
	                  _Index2.default,
	                  { expandable: false, multiple: false, hideCheckAll: true },
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '0' },
	                    '\u5168\u90E8'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '0~500' },
	                    '0~500'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '501~1000' },
	                    '501~1000'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '1001~1500' },
	                    '1001~1500'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '1501~2000' },
	                    '1501~2000'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '2001~5000' },
	                    '2001~5000'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '5000\u4EE5\u4E0A' },
	                    '5000\u4EE5\u4E0A'
	                  )
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _Index4.default,
	              { title: '\u5176\u5B83\u9009\u9879', grid: true, last: true },
	              _react2.default.createElement(
	                _antd.Row,
	                { gutter: 16 },
	                _react2.default.createElement(
	                  _antd.Col,
	                  { lg: 8, md: 10, sm: 10, xs: 24 },
	                  _react2.default.createElement(
	                    FormItem,
	                    Object.assign({}, formItemLayout, { label: '\u5907\u6CE8' }),
	                    getFieldDecorator('remark', {})(_react2.default.createElement(_antd.Input, null))
	                  )
	                ),
	                _react2.default.createElement(_antd.Col, { lg: 8, md: 10, sm: 10, xs: 24 }),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { lg: 8, md: 10, sm: 10, xs: 24, style: { textAlign: 'right' } },
	                  _react2.default.createElement(
	                    _antd.Button,
	                    { type: 'primary', onClick: this.handleSearCh },
	                    '\u67E5\u8BE2'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u652F\u51FA\u8BE6\u60C5\u8868', extra: _react2.default.createElement(
	              _antd.Button,
	              { onClick: this.exportFinanceRecord },
	              '\u5BFC\u51FA'
	            ) },
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            dataSource: list,
	            pagination: pagination,
	            onChange: this.handleTableChange,
	            rowKey: 'uuid'
	          })
	        )
	      );
	    }
	  }]);
	
	  return TabDetail;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(TabDetail);

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _BackBtn = __webpack_require__(12);
	
	var _DateSearch = __webpack_require__(685);
	
	var _DateSearch2 = _interopRequireDefault(_DateSearch);
	
	var _reactRedux = __webpack_require__(5);
	
	var _expend_type = __webpack_require__(80);
	
	var _income_type = __webpack_require__(437);
	
	var _TabDetail = __webpack_require__(1592);
	
	var _TabDetail2 = _interopRequireDefault(_TabDetail);
	
	var _TabChart = __webpack_require__(1591);
	
	var _TabChart2 = _interopRequireDefault(_TabChart);
	
	__webpack_require__(265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var IncomeIndex = function (_Component) {
	  _inherits(IncomeIndex, _Component);
	
	  function IncomeIndex(props) {
	    _classCallCheck(this, IncomeIndex);
	
	    var _this = _possibleConstructorReturn(this, (IncomeIndex.__proto__ || Object.getPrototypeOf(IncomeIndex)).call(this, props));
	
	    _this.handleChange = function (params) {
	      _this.setState({
	        condition: Object.assign({}, params)
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(IncomeIndex, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)()); // 资金流水列表需要类目
	      dispatch((0, _income_type.getIncomeType)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var condition = this.state.condition;
	      var year = this.props.location.query.year;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_BackBtn.BackBtn, null),
	        _react2.default.createElement(
	          _antd.Tabs,
	          {
	            defaultActiveKey: '1',
	            onChange: this.callback,
	            tabBarExtraContent: _react2.default.createElement(_DateSearch2.default, {
	              onChange: this.handleChange,
	              defaultValue: {
	                beginDate: year + '-01-01',
	                endDate: year + '-12-31'
	              }
	            })
	          },
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u603B\u6536\u5165', key: '1' },
	            _react2.default.createElement(
	              _antd.Card,
	              null,
	              _react2.default.createElement(_TabChart2.default, Object.assign({}, this.props, { condition: condition }))
	            )
	          ),
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u8BE6\u60C5', key: '2' },
	            _react2.default.createElement(_TabDetail2.default, Object.assign({}, this.props, { condition: condition }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return IncomeIndex;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    incomeType: state.income_type
	  };
	})(IncomeIndex);

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _big = __webpack_require__(235);
	
	var _big2 = _interopRequireDefault(_big);
	
	var _Index = __webpack_require__(680);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(681);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _Index5 = __webpack_require__(430);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _YearPicker = __webpack_require__(154);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	var _budget = __webpack_require__(30);
	
	__webpack_require__(265);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import moment from "moment";
	
	
	var FormItem = _antd.Form.Item;
	var month = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	
	// const currentYear = moment.unix(new Date().getTime() / 1000).format("YYYY");
	
	var TabChart = function (_Component) {
	  _inherits(TabChart, _Component);
	
	  function TabChart(props) {
	    _classCallCheck(this, TabChart);
	
	    var _this = _possibleConstructorReturn(this, (TabChart.__proto__ || Object.getPrototypeOf(TabChart)).call(this, props));
	
	    _this.findTypeName = function (key) {
	      var typeName = '';
	      var incomeType = _this.props.incomeType;
	
	      incomeType.forEach(function (item) {
	        if (key === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.getAnalysisFunds = function () {
	      var sum = new _big2.default(0);
	      var groupUuids = _this.props.params.uuid.split(',');
	      (0, _budget.queryBudgetAnalysisFunds)(Object.assign({
	        groupUuids: groupUuids,
	        target: 1
	      }, _this.condition)).then(function (res) {
	        if (res.statusCode === 200) {
	          var pieData2 = [];
	          var legendData = [];
	          var selected = {};
	          res.data.forEach(function (item, index) {
	            sum = sum.plus(new _big2.default(item.price || 0));
	            var typeName = _this.findTypeName(item.type) || '未定义类型';
	            legendData.push(typeName);
	            selected[typeName] = index < 10;
	            pieData2.push({
	              name: typeName,
	              value: item.price
	            });
	          });
	          _this.setState({
	            selected: selected,
	            pieData2: pieData2,
	            legendData: legendData
	          });
	        }
	      });
	    };
	
	    _this.getAnalysisFundsMonth = function () {
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          beginYear = _this$props$form$getF.beginYear,
	          endYear = _this$props$form$getF.endYear,
	          type = _this$props$form$getF.type;
	
	      var groupUuids = _this.props.params.uuid.split(',');
	      (0, _budget.queryBudgetAnalysisFundsMonth)({
	        groupUuids: groupUuids,
	        target: 1,
	        beginYear: beginYear,
	        type: type === '-1' ? '' : type,
	        endYear: endYear
	      }).then(function (res) {
	        var beginData = [];
	        var endData = [];
	
	        if (res.statusCode === 200) {
	          for (var i = 0; i < month.length; i++) {
	            beginData.push(res.data[beginYear][month[i]] || 0);
	            endData.push(res.data[endYear][month[i]] || 0);
	            _this.setState({
	              beginYear: beginYear,
	              endYear: endYear,
	              beginData: beginData,
	              endData: endData
	            });
	          }
	        }
	      });
	    };
	
	    _this.handleSearch = function () {
	      _this.getAnalysisFundsMonth();
	    };
	
	    _this.state = {
	      selected: {},
	      legendData: [],
	      pieData2: [],
	      beginYear: '' + (_this.props.location.query.year - 1),
	      endYear: _this.props.location.query.year,
	      beginData: [],
	      endData: []
	    };
	    return _this;
	  }
	
	  _createClass(TabChart, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var year = this.props.location.query.year;
	
	      this.condition = {
	        beginDate: year + '-01-01',
	        endDate: year + '-12-31'
	      };
	      this.getAnalysisFunds();
	      this.getAnalysisFundsMonth();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (Object.keys(nextProps.condition || {}).some(function (key) {
	        return nextProps.condition[key] !== _this2.condition[key];
	      })) {
	        this.condition = nextProps.condition;
	        this.getAnalysisFunds();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          beginYear = _state.beginYear,
	          endYear = _state.endYear,
	          beginData = _state.beginData,
	          endData = _state.endData,
	          legendData = _state.legendData,
	          pieData2 = _state.pieData2,
	          selected = _state.selected;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var line2Props = {
	        title: '月收入对比',
	        legend: [beginYear, endYear],
	        xAxisData: month,
	        series: [{
	          name: beginYear,
	          type: 'line',
	          data: beginData
	        }, {
	          name: endYear,
	          type: 'line',
	          data: endData
	        }]
	      };
	      var pieData3 = {
	        title: '收入类型统计',
	        selected: selected,
	        legendData: legendData,
	        seriesData: pieData2
	      };
	      var incomeType = this.props.incomeType;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'analyze' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-between' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 16 },
	            _react2.default.createElement(_Index2.default, { data: pieData3 })
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 7 },
	            _react2.default.createElement(_Index4.default, { data: pieData2, title: '\u6536\u5165\u7C7B\u578B\u6392\u540D' })
	          )
	        ),
	        _react2.default.createElement(_antd.Divider, null),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              '\u6708\u6536\u5165\u5BF9\u6BD4(\u5355\u4F4D\uFF1A\u5143)'
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('type', {
	                initialValue: '-1'
	              })(_react2.default.createElement(
	                _antd.Select,
	                { style: { width: '150px' } },
	                _react2.default.createElement(
	                  _antd.Select.Option,
	                  { value: '-1' },
	                  '\u5168\u90E8'
	                ),
	                incomeType.map(function (item) {
	                  return _react2.default.createElement(
	                    _antd.Select.Option,
	                    { value: item.value, key: item.value },
	                    item.key
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('beginYear', {
	                initialValue: beginYear
	              })(_react2.default.createElement(_YearPicker2.default, { style: { width: '150px' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('endYear', {
	                initialValue: endYear
	              })(_react2.default.createElement(_YearPicker2.default, { style: { width: '150px' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              _react2.default.createElement(
	                _antd.Button,
	                { onClick: this.handleSearch, type: 'primary' },
	                '\u67E5\u8BE2'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_Index6.default, line2Props)
	      );
	    }
	  }]);
	
	  return TabChart;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(TabChart);

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _Index = __webpack_require__(676);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(675);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _budget = __webpack_require__(30);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(265);
	
	var _finance = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var TabDetail = function (_Component) {
	  _inherits(TabDetail, _Component);
	
	  function TabDetail(props) {
	    _classCallCheck(this, TabDetail);
	
	    var _this = _possibleConstructorReturn(this, (TabDetail.__proto__ || Object.getPrototypeOf(TabDetail)).call(this, props));
	
	    _this.findTypeName = function (record) {
	      var typeName = '';
	      var _this$props = _this.props,
	          incomeType = _this$props.incomeType,
	          expendType = _this$props.expendType;
	
	      var type = record.target === 0 ? expendType : incomeType;
	      type.forEach(function (item) {
	        if (record.type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.exportFinanceRecord = function () {
	      (0, _budget.queryExportBudgetAnalysisIncome)(Object.assign({
	        groupUuids: _this.props.params.uuid,
	        target: 1
	      }, _this.condition, _this.searchCondition));
	    };
	
	    _this.getAnalysisIncome = function () {
	      var pageSize = 10;
	      (0, _budget.queryBudgetAnalysisIncome)(Object.assign({
	        groupUuids: [_this.props.params.uuid],
	        limit: pageSize,
	        target: 1,
	        start: _this.current || 1
	      }, _this.condition, _this.searchCondition)).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.forEach(function (item) {
	            item.typeName = _this.findTypeName(item);
	          });
	          _this.setState({
	            recordData: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: pageSize,
	                current: _this.current
	              }
	            }
	          });
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.current = pagination.current;
	      _this.getAnalysisIncome();
	    };
	
	    _this.handleSearCh = function () {
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          _this$props$form$getF2 = _this$props$form$getF.types,
	          types = _this$props$form$getF2 === undefined ? [] : _this$props$form$getF2,
	          _this$props$form$getF3 = _this$props$form$getF.money,
	          money = _this$props$form$getF3 === undefined ? [] : _this$props$form$getF3,
	          _this$props$form$getF4 = _this$props$form$getF.account,
	          account = _this$props$form$getF4 === undefined ? '' : _this$props$form$getF4,
	          _this$props$form$getF5 = _this$props$form$getF.remark,
	          remark = _this$props$form$getF5 === undefined ? '' : _this$props$form$getF5;
	
	      var moneyRange = money.length > 0 ? money[0].split('~') : [];
	      _this.current = 1;
	      _this.searchCondition = {
	        types: types,
	        account: account,
	        remark: remark,
	        begin: moneyRange[0] ? parseInt(moneyRange[0], 10) : '',
	        end: moneyRange[1] || ''
	      };
	      _this.getAnalysisIncome();
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '入账公司',
	        dataIndex: 'accountName'
	      }, {
	        title: '收入金额',
	        dataIndex: 'money',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text > 0 ? _index2.default.numberFormat(text) : 0
	          );
	        }
	      }, {
	        title: '业务类型',
	        dataIndex: 'type',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.typeName
	          );
	        }
	      }, {
	        title: '备注',
	        dataIndex: 'remark',
	        width: '400px',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'p',
	            { className: 'banlance-remark' },
	            text
	          );
	        }
	      }, {
	        title: '操作',
	        width: '200px',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'a',
	            {
	              href: '#',
	              onClick: function onClick() {
	                _antd.Modal.confirm({
	                  title: '修改备注',
	                  content: _react2.default.createElement(
	                    'div',
	                    { className: 'ant-row  ant-form-item' },
	                    _react2.default.createElement(_antd.Input.TextArea, {
	                      className: 'ant-col ant-form-item-required ant-form-item-control ',
	                      type: 'text',
	                      defaultValue: record.remark || '',
	                      onBlur: function onBlur(e) {
	                        return _this.setState({ incomeRemark: e.target.value });
	                      },
	                      rows: 5
	                    })
	                  ),
	                  onOk: function onOk() {
	                    var incomeRemark = _this.state.incomeRemark;
	
	                    (0, _finance.querySaveBooksIncome)({
	                      uuid: record.uuid,
	                      remark: incomeRemark,
	                      type: record.type
	                    }).then(function (res) {
	                      if (res.statusCode === 200) {
	                        _antd.message.success('修改成功');
	                        _this.setState({ incomeRemark: '' });
	                        _this.getAnalysisIncome();
	                      } else {
	                        _antd.message.error(res.message);
	                      }
	                    });
	                  }
	                });
	              }
	            },
	            '\u7F16\u8F91\u5907\u6CE8'
	          );
	        }
	      }];
	    };
	
	    _this.setClassName = function (record) {
	      if (record.ignore !== 0) {
	        return 'td-gray';
	      }
	    };
	
	    _this.state = {
	      recordData: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(TabDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var year = this.props.location.query.year;
	
	      this.condition = {
	        beginDate: year + '-01-01',
	        endDate: year + '-12-31'
	      };
	      this.getAnalysisIncome();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (Object.keys(nextProps.condition || {}).some(function (key) {
	        return nextProps.condition[key] !== _this2.condition[key];
	      })) {
	        this.condition = nextProps.condition;
	        this.getAnalysisIncome();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var formItemLayout = {
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 16 }
	        }
	      };
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var actionsTextMap = {
	        expandText: '展开',
	        collapseText: '收起',
	        selectAllText: '全部'
	      };
	      var _state$recordData = this.state.recordData,
	          list = _state$recordData.list,
	          pagination = _state$recordData.pagination;
	      var incomeType = this.props.incomeType;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'analyze' },
	        _react2.default.createElement(
	          _antd.Card,
	          { bordered: false, style: { marginBottom: '16px' } },
	          _react2.default.createElement(
	            _antd.Form,
	            { layout: 'inline' },
	            _react2.default.createElement(
	              _Index4.default,
	              { title: '\u6240\u5C5E\u7C7B\u76EE', block: true, style: { paddingBottom: 11 } },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                getFieldDecorator('types')(_react2.default.createElement(
	                  _Index2.default,
	                  { expandable: true, actionsText: actionsTextMap, multiple: true },
	                  incomeType.map(function (item) {
	                    return _react2.default.createElement(
	                      _Index2.default.Option,
	                      { value: item.value, key: item.key },
	                      item.key
	                    );
	                  })
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _Index4.default,
	              { title: '\u91D1\u989D', block: true, style: { paddingBottom: 11 } },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                getFieldDecorator('money')(_react2.default.createElement(
	                  _Index2.default,
	                  { expandable: false, multiple: false, hideCheckAll: true },
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '0' },
	                    '\u5168\u90E8'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '0~500' },
	                    '0~500'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '501~1000' },
	                    '501~1000'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '1001~1500' },
	                    '1001~1500'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '1501~2000' },
	                    '1501~2000'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '2001~5000' },
	                    '2001~5000'
	                  ),
	                  _react2.default.createElement(
	                    _Index2.default.Option,
	                    { value: '5000\u4EE5\u4E0A' },
	                    '5000\u4EE5\u4E0A'
	                  )
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _Index4.default,
	              { title: '\u5176\u5B83\u9009\u9879', grid: true, last: true },
	              _react2.default.createElement(
	                _antd.Row,
	                { gutter: 16 },
	                _react2.default.createElement(
	                  _antd.Col,
	                  { lg: 8, md: 10, sm: 10, xs: 24 },
	                  _react2.default.createElement(
	                    FormItem,
	                    Object.assign({}, formItemLayout, { label: '\u5907\u6CE8' }),
	                    getFieldDecorator('remark', {})(_react2.default.createElement(_antd.Input, null))
	                  )
	                ),
	                _react2.default.createElement(_antd.Col, { lg: 8, md: 10, sm: 10, xs: 24 }),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { lg: 8, md: 10, sm: 10, xs: 24, style: { textAlign: 'right' } },
	                  _react2.default.createElement(
	                    _antd.Button,
	                    { type: 'primary', onClick: this.handleSearCh },
	                    '\u67E5\u8BE2'
	                  )
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6536\u5165\u8BE6\u60C5\u8868', extra: _react2.default.createElement(
	              _antd.Button,
	              { onClick: this.exportFinanceRecord },
	              '\u5BFC\u51FA'
	            ) },
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            dataSource: list,
	            pagination: pagination,
	            onChange: this.handleTableChange,
	            rowClassName: this.setClassName,
	            rowKey: 'uuid'
	          })
	        )
	      );
	    }
	  }]);
	
	  return TabDetail;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(TabDetail);

/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _finance = __webpack_require__(61);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _budget = __webpack_require__(30);
	
	var _BackBtn = __webpack_require__(12);
	
	var _Index = __webpack_require__(1502);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _MonthPro = __webpack_require__(1503);
	
	var _MonthPro2 = _interopRequireDefault(_MonthPro);
	
	var _dict = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import util from "@util/index";
	
	
	// const { Option } = Select;
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.formatGroup = function (arr) {
	      arr.map(function (item) {
	        if (item.children) {
	          if (item.children.length === 0) {
	            delete item.children;
	            return item;
	          }
	          if (item.children.length > 0) {
	            _this.formatGroup(item.children);
	          }
	        }
	        return item;
	      });
	      return arr;
	    };
	
	    _this.formatOption = function (arr) {
	      var groupList = _this.state.groupList;
	
	      (arr || []).map(function (item) {
	        if (item.children && item.children.length > 0) {
	          _this.formatOption(item.children);
	        }
	        groupList.push(item);
	        return item;
	      });
	      _this.setState({
	        groupList: groupList
	      }, function () {
	        _this.setGroupName([_this.props.params.uuid]);
	      });
	    };
	
	    _this.getNowAimPre = function () {
	      var nowAimPre = 0;
	      var year = _this.props.params.year;
	
	      if (year) {
	        var yStart = new Date(+year, 0, 1, 0, 0, 0, 0);
	        var yEnd = new Date(+year + 1, 0, 1, 0, 0, 0, 0);
	        var yNow = Date.now();
	
	        if (yNow <= yStart) {
	          nowAimPre = 0;
	        } else if (yNow >= yEnd) {
	          nowAimPre = 1;
	        } else {
	          nowAimPre = Math.floor((yNow - yStart) / (yEnd - yStart) * 10000) / 10000;
	        }
	
	        _this.setState({
	          nowAimPre: nowAimPre
	        });
	      }
	    };
	
	    _this.getGroupList = function () {
	      var params = {
	        isEnable: 1,
	        year: _this.props.params.year
	      };
	      _this.props.location.query.source ? (0, _budget.queryBudgetGroupList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var companyList = _this.formatGroup(res.data);
	          _this.formatOption(companyList);
	        } else {
	          _antd.message.error(res.message);
	        }
	      }) : (0, _budget.queryBudgetGroupPerList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var companyList = _this.formatGroup(res.data);
	          _this.formatOption(companyList);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.setGroupName = function (uuidArr) {
	      var str = '';
	      var groupList = _this.state.groupList;
	
	
	      uuidArr.map(function (item) {
	        groupList.map(function (it) {
	          if (it.uuid === item) {
	            str += it.name + ',';
	          }
	          return it;
	        });
	        return item;
	      });
	      str = str.substring(0, str.length - 1);
	      _this.setState({
	        groupName: str
	      });
	    };
	
	    _this.getDictExpend = function () {
	      (0, _dict.queryDictExpend)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            expendType: res.data
	          });
	        }
	      });
	    };
	
	    _this.getAnalysis = function () {
	      var _this$state = _this.state,
	          nowAimPre = _this$state.nowAimPre,
	          groupUuids = _this$state.groupUuids;
	
	      var params = {};
	      params.groupUuids = groupUuids.length ? groupUuids : [_this.props.params.uuid];
	      params.year = _this.props.params.year;
	      (0, _budget.queryBudgetAnalysis)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var _res$data = res.data,
	              income = _res$data.income,
	              expenditure = _res$data.expenditure;
	
	          income.map(function (item, index) {
	            item.index = index;
	            item.nowAimincomeValue = item.aim * nowAimPre;
	            item.acturalPre = item.aim ? Math.floor(item.actual / item.aim * 10000) / 10000 : 0;
	            return 1;
	          });
	
	          expenditure.actualPre = expenditure.budget ? Math.floor(expenditure.actual / expenditure.budget * 10000) / 10000 : 0;
	          expenditure.top.forEach(function (item) {
	            item.typeName = _this.findTypeName(item.type);
	          });
	          _this.setState({
	            incomeData: res.data.income,
	            expenditureData: res.data.expenditure
	          });
	        }
	      });
	    };
	
	    _this.getOrg = function () {
	      var groupUuids = _this.state.groupUuids;
	
	      (0, _finance.queryFinanceBooksOrgList)({
	        groupUuids: groupUuids
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          var org = res.data;
	          _this.setState({
	            org: org
	          });
	        }
	      });
	    };
	
	    _this.findTypeName = function (key) {
	      var typeName = '';
	      var expendType = _this.state.expendType;
	
	      expendType.forEach(function (item) {
	        if (key === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.changeGroup = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          groupUuids = _this$props$form$getF.groupUuids;
	
	      _this.props.params.uuid = groupUuids;
	
	      if (groupUuids.length >= 1) {
	        _this.setGroupName(groupUuids);
	        _this.setState({
	          groupUuids: groupUuids
	        }, function () {
	          _this.getAnalysis();
	          _this.getOrg();
	        });
	      }
	    };
	
	    _this.setLocalDbYear = function () {
	      var year = _this.props.params.year;
	
	      _localDb2.default.set('year', year);
	    };
	
	    _this.state = {
	      groupList: [],
	      groupUuids: [_this.props.params.uuid],
	      groupName: '',
	      nowAimPre: 1,
	      incomeData: [],
	      expenditureData: {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return this.getNowAimPre();
	
	              case 2:
	                _context.next = 4;
	                return this.getGroupList();
	
	              case 4:
	                _context.next = 6;
	                return this.getDictExpend();
	
	              case 6:
	                this.getAnalysis();
	                this.getOrg();
	
	              case 8:
	              case 'end':
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	
	    /**
	     * 递归删除空的children
	     */
	
	
	    // 设置预算组下拉菜单
	
	
	    // 换算当前目标收入
	
	
	    // 预算组列表
	
	
	    // 页面加载时设置预算组名
	
	
	    // 获取收支数据
	
	
	    // 获取预算组公司(以判断运营报表是否去详情页)
	
	
	    // 改变预算组
	
	
	    // 设置年份
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var urlPrefix = '/finance/budget/' + (this.state.groupUuids.length ? this.state.groupUuids : this.props.params.uuid) + '/balance';
	      var _state = this.state,
	          incomeData = _state.incomeData,
	          expenditureData = _state.expenditureData,
	          nowAimPre = _state.nowAimPre,
	          groupUuids = _state.groupUuids,
	          groupName = _state.groupName,
	          org = _state.org;
	
	      // const { getFieldDecorator } = this.props.form;
	
	      var extra = _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.changeGroup },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 8, style: { paddingTop: '10px', paddingRight: '10px' } },
	            groupUuids.length > 1 ? _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: '/finance/budgets',
	                  query: { groupUuids: groupUuids }
	                }
	              },
	              '\u9884\u7B97\u7EDF\u8BA1'
	            ) : _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                onClick: this.setLocalDbYear,
	                to: {
	                  pathname: '/finance/budgets/' + groupUuids + '/year',
	                  query: { companyName: groupName }
	                }
	              },
	              '\u9884\u7B97\u7EDF\u8BA1'
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 8, style: { paddingTop: '10px', paddingRight: '10px' } },
	            org && org.length > 1 ? _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: '/finance/operational',
	                  query: {
	                    groupUuids: groupUuids
	                  }
	                }
	              },
	              '\u8FD0\u8425\u62A5\u8868'
	            ) : _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: '/finance/operational/' + groupUuids + '/year',
	                  query: {
	                    companyName: groupName,
	                    isBalance: true
	                  }
	                }
	              },
	              '\u8FD0\u8425\u62A5\u8868'
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 8, style: { paddingTop: '10px', paddingRight: '10px' } },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              {
	                to: {
	                  pathname: urlPrefix + '/trace',
	                  query: {
	                    year: this.props.params.year
	                  }
	                }
	              },
	              '\u5229\u6DA6\u8FFD\u8E2A'
	            )
	          )
	        )
	      );
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          { style: { marginBottom: '10px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6536\u652F\u5206\u6790', extra: extra },
	          incomeData && incomeData.length ? _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'end' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 19, style: { textAlign: 'right' } },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  style: { marginRight: '8px' },
	                  to: {
	                    pathname: urlPrefix + '/income',
	                    query: {
	                      year: this.props.params.year
	                    }
	                  }
	                },
	                '\u6536\u5165\u5206\u6790'
	              )
	            )
	          ) : null,
	          incomeData && incomeData.length ? incomeData.map(function (item) {
	            return _react2.default.createElement(
	              'div',
	              { key: item.index },
	              _react2.default.createElement(
	                _antd.Row,
	                { style: { paddingTop: '50px', paddingBottom: '50px' } },
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 5 },
	                  _react2.default.createElement(_antd.Statistic, {
	                    title: '\u672C\u5E74' + item.typeName + '\u76EE\u6807\u6536\u5165\uFF1A',
	                    value: item.aim,
	                    precision: 2,
	                    valueStyle: { color: '#55AA88' },
	                    suffix: '\u5143'
	                  }),
	                  _react2.default.createElement(_antd.Statistic, {
	                    title: '\u5B9E\u9645\u6536\u5165\uFF1A',
	                    value: item.actual,
	                    precision: 2,
	                    valueStyle: { color: '#55AA88' },
	                    suffix: '\u5143'
	                  })
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { span: 18, style: { paddingTop: '50px', paddingBottom: '50px' } },
	                  _react2.default.createElement(_Index2.default, {
	                    data: [{
	                      type: '目标',
	                      per: item.aim ? nowAimPre : 0,
	                      value: item.nowAimincomeValue || 0,
	                      color: 'rgba(25, 144, 255)',
	                      location: 'top'
	                    }, {
	                      type: '实际',
	                      per: item.acturalPre,
	                      value: item.actual || 0,
	                      color: item.acturalPre >= nowAimPre ? 'rgba(82,196,26)' : 'red'
	                    }]
	                  })
	                )
	              ),
	              _react2.default.createElement(_antd.Divider, null)
	            );
	          }) : null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 5 },
	              _react2.default.createElement(_antd.Statistic, {
	                title: '\u672C\u5E74\u603B\u8BA1\u9884\u7B97\u652F\u51FA\uFF1A',
	                value: expenditureData.budget,
	                precision: 2,
	                valueStyle: { color: 'red' },
	                suffix: '\u5143'
	              })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 19, style: { textAlign: 'right' } },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  style: { marginRight: '8px' },
	                  to: {
	                    pathname: urlPrefix + '/expense',
	                    query: {
	                      year: this.props.params.year
	                    }
	                  }
	                },
	                '\u652F\u51FA\u5206\u6790'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'space-between' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 5 },
	              _react2.default.createElement(_antd.Statistic, {
	                title: '\u5B9E\u9645\u652F\u51FA\uFF1A',
	                value: expenditureData.actual,
	                precision: 2,
	                valueStyle: { color: 'red' },
	                suffix: '\u5143'
	              })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 18 },
	              _react2.default.createElement(_MonthPro2.default, {
	                per: parseFloat(expenditureData.actualPre),
	                money: expenditureData.actual,
	                nowAimPre: expenditureData.budget ? nowAimPre : 0
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    incomeData: state.payable_statis,
	    allCompany: state.all_company
	  };
	})(_antd.Form.create()(Index));

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BackBtn = __webpack_require__(12);
	
	var _Index = __webpack_require__(430);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _budget = __webpack_require__(30);
	
	var _YearPicker = __webpack_require__(154);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	var _TableDetail = __webpack_require__(1595);
	
	var _TableDetail2 = _interopRequireDefault(_TableDetail);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.findTypeName = function (record) {
	      var typeName = '';
	      var _this$props = _this.props,
	          incomeType = _this$props.incomeType,
	          expendType = _this$props.expendType;
	
	      var type = record.target === 0 ? expendType : incomeType;
	      type.forEach(function (item) {
	        if (record.type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.getProfitChartData = function () {
	      var date = [];
	      var expenditure = [];
	      var income = [];
	      var profit = [];
	      var aim = [];
	      (0, _budget.queryAnalysisProfit)({
	        groupUuids: _this.props.params.uuid,
	        year: _this.year
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.detail.map(function (item) {
	            date.push(item.date || 0);
	            expenditure.push(item.expenditure || 0);
	            income.push(item.income || 0);
	            profit.push(item.profit || 0);
	            aim.push(item.aim || 0);
	            return item;
	          });
	          _this.setState({
	            date: date,
	            expenditure: expenditure,
	            income: income,
	            aim: aim,
	            profit: profit
	          });
	        }
	      });
	    };
	
	    _this.getProfitDetail = function () {
	      var pageSize = 15;
	      (0, _budget.queryAnalysisProfitDetail)({
	        groupUuids: _this.props.params.uuid,
	        target: 1,
	        limit: pageSize,
	        start: _this.current || 1,
	        year: _this.year
	      }).then(function (res) {
	        // res.data.map (item => (item.typeName = this.findTypeName (item)));
	        _this.setState({
	          recordData: {
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              pageSize: pageSize,
	              current: _this.current
	            }
	          }
	        });
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.current = pagination.current;
	      _this.getProfitDetail();
	    };
	
	    _this.handleYearChange = function (year) {
	      _this.year = year;
	      _this.getProfitDetail();
	      _this.getProfitChartData();
	    };
	
	    _this.state = {
	      recordData: {
	        list: [],
	        pagination: {}
	      },
	      date: [],
	      expenditure: [],
	      income: [],
	      aim: [],
	      profit: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.year = this.props.location.query.year || _moment2.default.unix(new Date().getTime() / 1000).format('YYYY');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getProfitChartData();
	      this.getProfitDetail();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          recordData = _state.recordData,
	          date = _state.date,
	          expenditure = _state.expenditure,
	          income = _state.income,
	          profit = _state.profit,
	          aim = _state.aim;
	
	      var line2Props = {
	        title: '利润追踪',
	        legend: ['支出', '收入', '利润', '月目标'],
	        xAxisData: date,
	        series: [{
	          name: '支出',
	          type: 'line',
	          data: expenditure
	        }, {
	          name: '收入',
	          type: 'line',
	          data: income
	        }, {
	          name: '利润',
	          type: 'line',
	          data: profit
	        }, {
	          name: '月目标',
	          type: 'line',
	          data: aim
	        }]
	      };
	      return _react2.default.createElement(
	        'div',
	        { className: 'analyze' },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(_YearPicker2.default, {
	            style: { width: '150px' },
	            onChange: this.handleYearChange,
	            defaultValue: this.year
	          })
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u5229\u6DA6\u8FFD\u8E2A' },
	          _react2.default.createElement(_Index2.default, line2Props)
	        ),
	        _react2.default.createElement(_TableDetail2.default, { data: recordData, handleChange: this.handleTableChange })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactHtmlTableToExcel = __webpack_require__(308);
	
	var _reactHtmlTableToExcel2 = _interopRequireDefault(_reactHtmlTableToExcel);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableDetail = function (_Component) {
	  _inherits(TableDetail, _Component);
	
	  function TableDetail(props) {
	    _classCallCheck(this, TableDetail);
	
	    var _this = _possibleConstructorReturn(this, (TableDetail.__proto__ || Object.getPrototypeOf(TableDetail)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: "当前月份",
	        dataIndex: "month"
	      }, {
	        title: "预算支出(预算实际支出)",
	        dataIndex: "budgetExpenditure",
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            text > 0 ? _index2.default.numberFormat(text) : 0
	          );
	        }
	      }, {
	        title: "实际收入(去除往来款)",
	        dataIndex: "actualIncome",
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            text > 0 ? _index2.default.numberFormat(text) : 0
	          );
	        }
	      }, {
	        title: "实际支出",
	        dataIndex: "actualExpenditure",
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            text > 0 ? _index2.default.numberFormat(text) : 0
	          );
	        }
	      }, {
	        title: "实际利润(实际收入-预算支出)",
	        dataIndex: "actualProfit",
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text)
	          );
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(TableDetail, [{
	    key: "componentWillMount",
	    value: function componentWillMount() {}
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      var _props = this.props,
	          list = _props.data.list,
	          handleChange = _props.handleChange;
	
	      return _react2.default.createElement(
	        "div",
	        { className: "analyze" },
	        _react2.default.createElement(
	          _antd.Card,
	          {
	            title: _react2.default.createElement(
	              "div",
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u5229\u6DA6\u8FFD\u8E2A\u8BE6\u60C5\u8868"
	              ),
	              _react2.default.createElement(
	                "span",
	                null,
	                "\u5355\u4F4D\uFF08\u5143\uFF09"
	              )
	            ),
	            extra: _react2.default.createElement(_reactHtmlTableToExcel2.default, {
	              id: "test-table-xls-button",
	              className: "download-table-xls-button ant-btn",
	              table: "table-to-xls",
	              filename: "tablexls",
	              sheet: "tablexls",
	              style: {
	                marginTop: "4px"
	              },
	              buttonText: "\u5BFC\u51FA"
	            })
	          },
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            dataSource: list,
	            pagination: false,
	            onChange: handleChange,
	            id: "table-to-xls"
	          })
	        )
	      );
	    }
	  }]);
	
	  return TableDetail;
	}(_react.Component);
	
	exports.default = TableDetail;

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _finance = __webpack_require__(61);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FinanceCapitalDetail = function (_Component) {
	  _inherits(FinanceCapitalDetail, _Component);
	
	  function FinanceCapitalDetail(props) {
	    _classCallCheck(this, FinanceCapitalDetail);
	
	    var _this = _possibleConstructorReturn(this, (FinanceCapitalDetail.__proto__ || Object.getPrototypeOf(FinanceCapitalDetail)).call(this, props));
	
	    _this.loadStatistics = function (uuid) {
	      (0, _finance.queryFinanceBooksStatistics)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ statistics: res.data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      statistics: {}
	    };
	    return _this;
	  }
	
	  _createClass(FinanceCapitalDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.uuid;
	
	      this.loadStatistics(uuid);
	    }
	
	    /**
	     * 获取账号统计
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var statistics = this.state.statistics;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        { className: 'description', style: { paddingTop: '46px' } },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-around', align: 'middle' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u8D26\u6237\u540D\u79F0:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.accountName
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u8D26\u9762\u79D1\u76EE:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.companyName
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u6240\u5728\u90E8\u95E8:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.accountName
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u4ED8\u6B3E\u91D1\u989D:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.companyName
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u4ED8\u6B3E\u5355\u53F7:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _util2.default.numberFormat(statistics.incomeSum, 2, '.', ',')
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u7533\u8BF7\u65F6\u95F4:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _util2.default.numberFormat(statistics.expenditureSum, 2, '.', ',')
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u6240\u5728\u516C\u53F8:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _util2.default.numberFormat(statistics.expenditureSum, 2, '.', ',')
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u4ED8\u6B3E\u516C\u53F8:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _util2.default.numberFormat(statistics.expenditureSum, 2, '.', ',')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-around', align: 'middle' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u5206\u644A\u65B9\u6848:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.accountName
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-around', align: 'middle' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u6536\u6B3E\u65B9:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.accountName
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u53D1\u7968\u7F16\u53F7:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _util2.default.numberFormat(statistics.incomeSum, 2, '.', ',')
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-around', align: 'middle' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u4ED8\u6B3E\u51ED\u8BC1:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.accountName
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-around', align: 'middle' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u4ED8\u6B3E\u8BF4\u660E:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.accountName
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FinanceCapitalDetail;
	}(_react.Component);
	
	exports.default = FinanceCapitalDetail;

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BackBtn = __webpack_require__(12);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _dict = __webpack_require__(64);
	
	var _budget = __webpack_require__(30);
	
	var _ModalAdd = __webpack_require__(1598);
	
	var _ModalAdd2 = _interopRequireDefault(_ModalAdd);
	
	var _ModalApportion = __webpack_require__(1599);
	
	var _ModalApportion2 = _interopRequireDefault(_ModalApportion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { getAccountInfo } from "../../../../store/modules/account_info";
	
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.judgeHandle = function () {
	      var fromPage = _this.props.location.query.fromPage;
	
	      var canHandle = 2;
	      if (fromPage === 'budget') {
	        canHandle = 2; // 可以添加和编辑
	      } else if (fromPage === 'org') {
	        canHandle = 0; // 都不可以
	      } else if (fromPage === 'statis') {
	        canHandle = 1; // 可已编辑但不能添加
	      }
	      _this.setState({
	        canHandle: canHandle
	      });
	    };
	
	    _this.loadData = function (pageNo) {
	      if (_this.props.location.pathname.indexOf('operational') > 0) {
	        _this.loadBooksIncomeList(pageNo);
	      } else {
	        _this.loadBudgetRecord(pageNo);
	      }
	    };
	
	    _this.loadBudgetRecord = function (pageNo) {
	      var params = {};
	      var query = _this.props.location.query;
	
	      if (query.type) {
	        params = query;
	      }
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 50;
	      params.start = current;
	      params.condition = _this.state.condition || '';
	      params.groupUuid = _this.props.params.uuid;
	      delete params.fromPage;
	      _this.setState({
	        pageNo: current,
	        isLoading: true
	      });
	      (0, _budget.queryGroupRecordList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.map(function (item) {
	            item.typeFont = _this.matchType(item.target, item.type);
	            return item;
	          });
	          context.setState({
	            company: res.data,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadBooksIncomeList = function (pageNo) {
	      var params = {};
	      var uuid = _this.props.params.uuid;
	
	      if (uuid !== undefined) {
	        params.bookUuid = uuid;
	      }
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      _this.setState({
	        pageNo: current
	      });
	      var types = _this.props.income_info.types;
	
	      if (types !== undefined) {
	        params.type = types;
	      }
	      if (_this.props.income_info.yearMonth) {
	        params.yearMonth = _this.props.income_info.yearMonth;
	      } else if (_this.props.income_info.date) {
	        params.beginDate = (0, _moment2.default)(_this.props.income_info.date[0]).format('YYYY-MM-DD');
	        params.endDate = (0, _moment2.default)(_this.props.income_info.date[1]).format('YYYY-MM-DD');
	      }
	      (0, _budget.queryAddGroupBookList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            company: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.search = function () {
	      _this.loadData();
	    };
	
	    _this.showModalAdd = function () {
	      _this.setState({
	        modalAddVisible: true
	      });
	    };
	
	    _this.showModalEdit = function (uuid) {
	      if (_this.state.canHandle === 2) {
	        _this.loadDetail(uuid);
	      }
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        modalAddVisible: false,
	        modalEditVisible: false,
	        approtionVisible: false
	      });
	    };
	
	    _this.handAddSubmit = function (record) {
	      record.groupUuid = _this.props.params.uuid;
	      (0, _budget.queryAddGroupRecord)(record).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadDetail = function (uuid) {
	      (0, _budget.queryGroupRecordInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            detail: res.data,
	            modalEditVisible: true
	          });
	        }
	      });
	    };
	
	    _this.handEditSubmit = function (item) {
	      item.uuid = _this.state.detail.uuid;
	      delete item.expenditure;
	      delete item.income;
	      delete item.target;
	      (0, _budget.queryUpdateGroupRecord)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleDelClick = function (uuid) {
	      _this.setState({
	        delUuid: uuid
	      }, function () {
	        _this.handleDelVisible(true);
	      });
	    };
	
	    _this.handleDelVisible = function (flag) {
	      _this.setState({
	        delVisible: !!flag
	      });
	    };
	
	    _this.handleDelOk = function () {
	      var delUuid = _this.state.delUuid;
	
	      _this.props.form.validateFields(['reason'], function (err, values) {
	        if (!err) {
	          _this.deleteRecord({
	            uuid: delUuid,
	            reason: values.reason
	          });
	          _this.handleDelVisible(false);
	        }
	      });
	    };
	
	    _this.deleteRecord = function (params) {
	      (0, _budget.queryDeleteGroupBook)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadData();
	          _antd.message.success(res.message);
	        } else {
	          _antd.message.err(res.message);
	        }
	      });
	    };
	
	    _this.setCondition = function (e) {
	      _this.setState({
	        condition: e.target.value
	      });
	    };
	
	    _this.loadBudgetIncomeType = function () {
	      (0, _dict.queryBudgetType)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            incomeType: res.data
	          });
	        }
	      });
	    };
	
	    _this.loadBudgetExpendType = function () {
	      (0, _dict.queryDictExpend)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            expendType: res.data
	          });
	        }
	      });
	    };
	
	    _this.dealApportion = function (apportionUuid) {
	      _this.loadApportionDetail(apportionUuid);
	    };
	
	    _this.loadApportionDetail = function (uuid) {
	      (0, _budget.queryBudgetApportionInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            content: res.data
	          });
	          _this.setState({
	            approtionVisible: true
	          });
	        } else if (res.statusCode === 500) {
	          _antd.message.info(res.message);
	        }
	      });
	    };
	
	    _this.matchType = function (target, value) {
	      var type = '';
	      if (+target === 1) {
	        _this.state.incomeType.map(function (item) {
	          if (item.value === value) {
	            type = item.key;
	            return type;
	          }
	          return type;
	        });
	      }
	      if (+target === 0) {
	        _this.state.expendType.map(function (item) {
	          if (item.value === value) {
	            type = item.key;
	          }
	          return type;
	        });
	      }
	      return type;
	    };
	
	    _this.columns = function () {
	      var isAdmin = _this.props.account_info.isAdmin;
	
	      var columns = [{
	        title: '流水编号',
	        dataIndex: 'no',
	        key: 'no'
	        // render: (text, record) => {
	        //   return (
	        //     <a onClick={() => this.showModalEdit( record.uuid)}>{text}</a>
	        //   );
	        // }
	      }, {
	        title: '费用',
	        dataIndex: 'income',
	        key: 'income',
	        render: function render(text, record) {
	          return record.expenditure ? _react2.default.createElement(
	            'span',
	            { style: { color: 'red' } },
	            _util2.default.numberFormat(record.expenditure, 2, '.', ',')
	          ) : _react2.default.createElement(
	            'span',
	            { style: { color: 'green' } },
	            _util2.default.numberFormat(record.income, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '预算组',
	        dataIndex: 'groupName',
	        key: 'groupName'
	      }, {
	        title: '摘要',
	        dataIndex: 'remark',
	        key: 'remark',
	        width: '20%'
	      }, {
	        title: '预算科目',
	        dataIndex: 'type',
	        key: 'type',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.typeFont
	          );
	        }
	      }, {
	        title: '发生时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          var style = {};
	          if (record.noticeFlag === 1) {
	            style.color = 'red';
	          }
	          return _react2.default.createElement(
	            'span',
	            { style: style },
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(text, record) {
	          if (record.type !== '210' && record.type !== '21w') {
	            return _react2.default.createElement(
	              'span',
	              null,
	              record.apportion ? _react2.default.createElement(
	                'span',
	                null,
	                record.apportion.itemType === 0 ? _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/finance/e_manage/open/' + record.apportion.itemUuid },
	                  '\u62A5\u9500\u660E\u7EC6'
	                ) : null,
	                record.apportion.itemType === 1 ? _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/finance/p_manage/open/' + record.apportion.itemUuid },
	                  '\u4ED8\u6B3E\u660E\u7EC6'
	                ) : null,
	                record.apportion.itemType === 2 ? _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/finance/l_manage/open/' + record.apportion.itemUuid },
	                  '\u501F\u6B3E\u660E\u7EC6'
	                ) : null,
	                record.apportion.itemType === 0 || record.apportion.itemType === 1 || record.apportion.itemType === 2 ? _react2.default.createElement(_antd.Divider, { type: 'verticle' }) : null
	              ) : null,
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.dealApportion(record.apportionUuid);
	                  } },
	                '\u5206\u644A\u660E\u7EC6'
	              ),
	              isAdmin ? _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                _react2.default.createElement(
	                  'a',
	                  {
	                    className: 'ant-dropdown-link',
	                    onClick: function onClick() {
	                      return _this.handleDelClick(record.uuid);
	                    }
	                  },
	                  '\u5220\u9664'
	                )
	              ) : null
	            );
	          }
	        }
	      }];
	      return columns;
	    };
	
	    _this.state = {
	      company: [],
	      pageNo: 1,
	      total: 0,
	      delUuid: '',
	      content: {},
	      modalAddVisible: false,
	      modalEditVisible: false,
	      approtionVisible: false,
	      delVisible: false,
	      detail: {},
	      incomeType: [],
	      expendType: [],
	      canHandle: 2 // 判断是否可以进行添加和编辑
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.loadBudgetIncomeType();
	      this.loadBudgetExpendType();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	      // this.props.dispatch(getAccountInfo());
	      this.judgeHandle();
	    }
	
	    // 判断能否进行添加和编辑操作
	
	
	    // 从预算管理列表查看流水
	
	
	    /**
	     * 从资金运营统计进入获取流水记录列表
	     */
	
	
	    /**
	     * 按条件搜索
	     */
	
	
	    /**
	     * 显示添加账户弹窗
	     */
	
	
	    /**
	     * 显示编辑账户弹窗
	     */
	
	
	    /**
	     * 新增流水记录
	     */
	
	
	    /**
	     * 获取流水明细
	     */
	
	
	    /**
	     * 编辑账号
	     */
	
	
	    // 删除按钮
	
	
	    // 删除流水
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          total = _state.total,
	          company = _state.company,
	          isLoading = _state.isLoading,
	          content = _state.content,
	          incomeType = _state.incomeType,
	          expendType = _state.expendType,
	          delVisible = _state.delVisible;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 50,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'fixed-header' },
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'space-between' },
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              _react2.default.createElement(_BackBtn.BackBtn, null)
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { style: { textAlign: 'right' } },
	              _react2.default.createElement(_antd.Input, {
	                placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57',
	                style: { width: '300px' },
	                value: this.state.condition,
	                onChange: this.setCondition
	              }),
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', style: { marginLeft: '10px' }, onClick: this.search },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: function rowKey(record) {
	            return record.uuid;
	          },
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: company,
	          pagination: pagination,
	          loading: isLoading,
	          style: { paddingTop: '46px' },
	          size: 'small'
	        }),
	        this.state.modalAddVisible ? _react2.default.createElement(_ModalAdd2.default, {
	          handSubmit: this.handAddSubmit,
	          detail: {},
	          incomeType: incomeType,
	          expendType: expendType,
	          cancel: this.hideModal,
	          disabled: false
	        }) : '',
	        this.state.modalEditVisible ? _react2.default.createElement(_ModalAdd2.default, {
	          handSubmit: this.handEditSubmit,
	          detail: this.state.detail,
	          uuid: this.uuid,
	          incomeType: incomeType,
	          expendType: expendType,
	          cancel: this.hideModal,
	          disabled: true
	        }) : '',
	        this.state.approtionVisible ? _react2.default.createElement(_ModalApportion2.default, { cancel: this.hideModal, content: content, expendType: expendType }) : '',
	        _react2.default.createElement(
	          _antd.Modal,
	          {
	            title: '\u5220\u9664\u539F\u56E0',
	            visible: delVisible,
	            onOk: this.handleDelOk,
	            onCancel: function onCancel() {
	              return _this2.handleDelVisible(false);
	            }
	          },
	          _react2.default.createElement(
	            _antd.Form,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { label: '\u5220\u9664\u539F\u56E0' },
	              getFieldDecorator('reason', {
	                rules: [{ required: true, message: '请输入删除原因' }]
	              })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5220\u9664\u539F\u56E0' }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    user: state.user,
	    income_info: state.income_info,
	    account_info: state.account_info
	  };
	})(_antd.Form.create()(Index));

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.handleTarget = function (value) {
	      _this.setState({
	        target: value
	      });
	      _this.props.form.resetFields(['type']);
	      if (value === '1') {
	        _this.setState({
	          type: _this.props.incomeType
	        });
	      } else if (value === '0') {
	        _this.setState({
	          type: _this.props.expendType
	        });
	      }
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handSubmit = _this.props.handSubmit;
	
	      var capital = _this.props.form.getFieldsValue();
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handSubmit(capital);
	        }
	      });
	    };
	
	    _this.state = {
	      content: _this.props.detail,
	      type: [],
	      target: _this.props.detail.target || '0'
	    };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.handleTarget('' + this.props.detail.target);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _state = this.state,
	          type = _state.type,
	          target = _state.target;
	      var disabled = this.props.disabled;
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	
	      var content = this.state.content;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u65B0\u589E\u9884\u7B97\u7EC4\u6D41\u6C34', visible: true, onOk: this.submit, onCancel: this.props.cancel },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u6536\u652F\u65B9\u5411' }, formItemLayout),
	            getFieldDecorator('target', {
	              rules: [{ required: true, message: '请选择收支方向' }],
	              initialValue: content.target === 1 || content.target === 0 ? '' + content.target : content.target
	            })(_react2.default.createElement(
	              _antd.Select,
	              { onChange: this.handleTarget, disabled: disabled },
	              _react2.default.createElement(
	                Option,
	                { value: '1' },
	                '\u6536\u5165'
	              ),
	              _react2.default.createElement(
	                Option,
	                { value: '0' },
	                '\u652F\u51FA'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u9884\u7B97\u7C7B\u578B' }, formItemLayout),
	            getFieldDecorator('type', {
	              rules: [{ required: true, message: '请选择预算类型' }],
	              initialValue: content.type
	            })(_react2.default.createElement(
	              _antd.Select,
	              null,
	              type.map(function (item) {
	                return _react2.default.createElement(
	                  Option,
	                  { value: item.value, key: item.value },
	                  item.key
	                );
	              })
	            ))
	          ),
	          target === '1' ? _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u53D1\u751F\u91D1\u989D' }, formItemLayout),
	            getFieldDecorator('income', {
	              rules: [{ required: true, message: '请输入发生金额' }],
	              initialValue: content.income
	            })(_react2.default.createElement(_antd.Input, { type: 'number', disabled: disabled }))
	          ) : _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u53D1\u751F\u91D1\u989D' }, formItemLayout),
	            getFieldDecorator('expenditure', {
	              rules: [{ required: true, message: '请输入发生金额' }],
	              initialValue: content.expenditure
	            })(_react2.default.createElement(_antd.Input, { type: 'number', disabled: disabled }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u6458\u8981' }, formItemLayout),
	            getFieldDecorator('remark', {
	              rules: [{ required: true, message: '请输入摘要' }],
	              initialValue: content.remark
	            })(_react2.default.createElement(_antd.Input.TextArea, { rows: 2, maxLength: 1000 })),
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '12px', color: '#999' } },
	              '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(IndexModal);

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var TextArea = _antd.Input.TextArea;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: '流水编号',
	        dataIndex: 'no',
	        key: 'no',
	        width: '15%'
	      }, {
	        title: '预算组',
	        dataIndex: 'groupName',
	        key: 'groupName',
	        width: '15%'
	      }, {
	        title: '费用',
	        dataIndex: 'price',
	        key: 'price',
	        width: '15%',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '摘要',
	        dataIndex: 'remark',
	        key: 'remark',
	        width: '20%'
	      }, {
	        title: '分摊时间',
	        dataIndex: 'time',
	        key: 'time',
	        width: '15%'
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        key: 'status',
	        width: '10%',
	        render: function render(text) {
	          if (text === 1) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u672A\u5206\u644A'
	            );
	          }
	          if (text === 3) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5DF2\u5206\u644A'
	            );
	          }
	        }
	      }];
	    };
	
	    _this.matchType = function (value) {
	      var type = '';
	      _this.props.expendType.map(function (item) {
	        if (item.value === value) {
	          type = item.key;
	          return type;
	        }
	        return item;
	      });
	      return type;
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 18 }
	      };
	      var formItemLayout2 = {
	        labelCol: { span: 3 },
	        wrapperCol: { span: 21 }
	      };
	
	      var content = this.props.content;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u9884\u7B97\u5206\u644A\u660E\u7EC6', visible: true, width: 700, onCancel: this.props.cancel, footer: false },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { gutter: 25 },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5206\u644A\u91D1\u989D' }, formItemLayout),
	                getFieldDecorator('price', {
	                  rules: [{ required: true, message: '请输入账户名称' }],
	                  initialValue: content.price
	                })(_react2.default.createElement(_antd.Input, { disabled: true }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u9884\u7B97\u79D1\u76EE' }, formItemLayout),
	                getFieldDecorator('budgetType', {
	                  rules: [{ required: true, message: '请选择收支方向' }],
	                  initialValue: this.matchType(content.budgetType)
	                })(_react2.default.createElement(_antd.Input, { disabled: true }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u8BF4\u660E' }, formItemLayout2),
	            getFieldDecorator('remark', {
	              rules: [{ required: true, message: '请选择预算类型' }],
	              initialValue: content.remark
	            })(_react2.default.createElement(TextArea, { rows: 4, disabled: true }))
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          dataSource: content.details || [],
	          columns: this.columns(),
	          bordered: true,
	          pagination: false,
	          rowKey: 'uuid',
	          size: 'small',
	          scroll: { y: '300' }
	        })
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(IndexModal);

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _finance = __webpack_require__(61);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.loadCompany = function () {
	      var params = {};
	      params.type = 1;
	      (0, _org.queryCompany)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var options = [];
	          res.data.map(function (item) {
	            var optionItem = {};
	            optionItem.label = item.name;
	            optionItem.value = item.uuid;
	            optionItem.key = item.uuid;
	            options.push(optionItem);
	            return options;
	          });
	          _this.setState({
	            treeData: options
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.onLoadData = function (treeNode) {
	      var arr = [];
	      var key = treeNode.props.eventKey;
	      var params = {};
	      params.type = 1;
	      params.uuid = key.split('-')[key.split('-').length - 1];
	      return new Promise(function (resolve) {
	        (0, _org.queryCompany)(params).then(function (res) {
	          if (res.statusCode === 200) {
	            res.data.map(function (item) {
	              var optionItem = {};
	              optionItem.label = item.name;
	              optionItem.value = item.uuid;
	              optionItem.key = key + '-' + item.uuid;
	              arr.push(optionItem);
	              return arr;
	            });
	            var treeData = [].concat(_toConsumableArray(_this.state.treeData));
	            var loop = function loop(data) {
	              data.forEach(function (item) {
	                if (key.indexOf(item.key) === 0) {
	                  if (item.children) {
	                    resolve();
	                    loop(item.children);
	                  } else if (item.key === key) {
	                    if (arr.length > 0) {
	                      item.children = arr;
	                      _this.setState({ treeData: treeData }, function () {
	                        resolve();
	                      });
	                    } else if (arr.length === 0) {
	                      item.isLeaf = true;
	                      _this.setState({ treeData: treeData }, function () {
	                        resolve();
	                      });
	                    } else {
	                      resolve();
	                    }
	                  }
	                }
	              });
	            };
	            loop(treeData);
	          }
	        });
	      });
	    };
	
	    _this.handleCompany = function (e, option) {
	      _this.companyName = option[0];
	      _this.companyUuid = e;
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handSubmit = _this.props.handSubmit;
	
	      var capital = _this.props.form.getFieldsValue();
	      capital.companyName = _this.companyName || _this.state.content.companyName;
	      capital.companyUuid = _this.companyUuid || _this.state.content.companyUuid;
	      delete capital.company;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handSubmit(capital);
	        }
	      });
	    };
	
	    _this.setCompanyName = function (value, option) {
	      _this.companyName = option.props.children;
	      _this.companyUuid = value;
	    };
	
	    _this.loadDetail = function (uuid) {
	      (0, _finance.queryFinanceBooksInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            content: res.data
	          });
	        }
	      });
	    };
	
	    _this.handleRadio = function () {
	      var isProBudget = _this.state.isProBudget;
	
	      _this.setState({
	        isProBudget: !isProBudget
	      });
	    };
	
	    _this.state = {
	      content: {},
	      treeData: [],
	      isProBudget: false
	    };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.uuid;
	
	      this.loadCompany();
	      if (uuid) {
	        this.loadDetail(uuid);
	      }
	    }
	
	    /**
	     *获取组织列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	
	      var content = this.state.content;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u65B0\u589E\u9884\u7B97\u7EC4\u6D41\u6C34',
	          visible: true,
	          onOk: this.submit,
	          onCancel: this.props.cancel,
	          footer: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u9884\u7B97\u7EC4\u540D\u79F0' }, formItemLayout),
	            getFieldDecorator('bookName', {
	              rules: [{ required: true, message: '请输入账户名称' }],
	              initialValue: content.bookName
	            })(_react2.default.createElement(_antd.Input, null))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u6536\u652F\u65B9\u5411' }, formItemLayout),
	            getFieldDecorator('pro', {
	              rules: [{ required: true, message: '请选择收支方向' }],
	              initialValue: content.bookName
	            })(_react2.default.createElement(
	              _antd.Select,
	              null,
	              _react2.default.createElement(
	                Option,
	                { value: '1' },
	                '\u6536\u5165'
	              ),
	              _react2.default.createElement(
	                Option,
	                { value: '2' },
	                '\u652F\u51FA'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u9884\u7B97\u7C7B\u578B' }, formItemLayout),
	            getFieldDecorator('pro', {
	              rules: [{ required: true, message: '请选择预算类型' }],
	              initialValue: content.bookName
	            })(_react2.default.createElement(
	              _antd.Select,
	              null,
	              _react2.default.createElement(
	                Option,
	                { value: '1' },
	                '\u6536\u5165'
	              ),
	              _react2.default.createElement(
	                Option,
	                { value: '2' },
	                '\u652F\u51FA'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u53D1\u751F\u91D1\u989D' }, formItemLayout),
	            getFieldDecorator('pro', {
	              rules: [{ required: true, message: '请输入发生金额' }],
	              initialValue: content.bookName
	            })(_react2.default.createElement(
	              _antd.Select,
	              null,
	              _react2.default.createElement(
	                Option,
	                { value: '1' },
	                '\u6536\u5165'
	              ),
	              _react2.default.createElement(
	                Option,
	                { value: '2' },
	                '\u652F\u51FA'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u6458\u8981' }, formItemLayout),
	            getFieldDecorator('pro', {
	              rules: [{ required: true, message: '请输入摘要' }],
	              initialValue: content.bookName
	            })(_react2.default.createElement(
	              _antd.Select,
	              null,
	              _react2.default.createElement(
	                Option,
	                { value: '1' },
	                '\u6536\u5165'
	              ),
	              _react2.default.createElement(
	                Option,
	                { value: '2' },
	                '\u652F\u51FA'
	              )
	            ))
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(IndexModal);

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BackBtn = __webpack_require__(12);
	
	var _finance = __webpack_require__(61);
	
	var _getAllType = __webpack_require__(168);
	
	var _getAllType2 = _interopRequireDefault(_getAllType);
	
	var _CardStatic = __webpack_require__(1596);
	
	var _CardStatic2 = _interopRequireDefault(_CardStatic);
	
	var _ModalProgress = __webpack_require__(1600);
	
	var _ModalProgress2 = _interopRequireDefault(_ModalProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FinanceCapitalDetail = function (_Component) {
	  _inherits(FinanceCapitalDetail, _Component);
	
	  function FinanceCapitalDetail(props) {
	    _classCallCheck(this, FinanceCapitalDetail);
	
	    var _this = _possibleConstructorReturn(this, (FinanceCapitalDetail.__proto__ || Object.getPrototypeOf(FinanceCapitalDetail)).call(this, props));
	
	    _this.loadStatistics = function (uuid) {
	      (0, _finance.queryFinanceBooksStatistics)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode !== 200) {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadBooksIncomeList = function (pageNo) {
	      var params = {};
	      var uuid = _this.props.params.uuid;
	
	      params.bookUuid = uuid;
	      params.condition = _this.state.condition;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      _this.setState({
	        pageNo: current
	      });
	      if (_this.state.source === 'statis') {
	        params.ignoreLevel = _this.props.income_info.igNore;
	        params.types = _this.props.income_info.types;
	        if (_this.props.income_info.yearMonth) {
	          params.yearMonth = _this.props.income_info.yearMonth;
	        } else if (_this.props.income_info.date) {
	          params.beginDate = (0, _moment2.default)(_this.props.income_info.date[0]);
	          params.endDate = (0, _moment2.default)(_this.props.income_info.date[1]);
	        }
	      }
	      (0, _finance.queryBooksIncomeList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            record: res.data
	          });
	        }
	      });
	    };
	
	    _this.search = function (condition) {
	      _this.condition = condition;
	      _this.loadBooksIncomeList(1);
	    };
	
	    _this.columns = function () {
	      var type = _this.state.type;
	
	      return [{
	        title: '付款单号',
	        dataIndex: 'accountName',
	        key: 'accountName',
	        width: 200
	      }, {
	        title: '付款金额',
	        dataIndex: 'remark',
	        key: 'remark',
	        width: 200
	      }, {
	        title: '申请人',
	        dataIndex: 'type',
	        key: 'type',
	        width: 200,
	        render: function render(text) {
	          var typeName = '';
	          if (type.length > 0) {
	            type.forEach(function (item) {
	              if (text === item.value) {
	                typeName = item.key;
	                return typeName;
	              }
	            });
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            typeName
	          );
	        }
	      }, {
	        title: '申请日期',
	        dataIndex: 'date',
	        key: 'date',
	        width: 200,
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.showModal(record.uuid);
	              } },
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD')
	          );
	        }
	      }];
	    };
	
	    _this.showModal = function () {};
	
	    _this.showImport = function () {};
	
	    _this.handleOk = function () {
	      // this.refs.form.refs.wrappedComponent.refs.formWrappedComponent.submit()
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.handleSubmit = function (result) {
	      if (result) {
	        _this.handleCancel();
	        _this.loadBooksIncomeList();
	      }
	    };
	
	    _this.setCondition = function (e) {
	      _this.setState({
	        condition: e.target.value
	      });
	    };
	
	    _this.showProgress = function () {
	      _this.setState({
	        progressVisible: true
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        progressVisible: false
	      });
	    };
	
	    _this.state = {
	      pageNo: 1,
	      record: [],
	      condition: '',
	      type: [],
	      source: 'capital',
	      progressVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(FinanceCapitalDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _getAllType2.default)().then(function (res) {
	        _this2.setState({
	          type: res
	        });
	      });
	      if (this.props.location.pathname.indexOf('statis') > 0) {
	        this.setState({
	          source: 'statis'
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.params.uuid;
	
	
	      this.loadStatistics(uuid);
	      this.loadBooksIncomeList(1);
	    }
	
	    /**
	     * 获取账号统计
	     */
	
	
	    /**
	     * 获取流水记录列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var record = this.state.record;
	      var progressVisible = this.state.progressVisible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'payDetail' },
	          _react2.default.createElement(
	            'div',
	            { className: 'fixed-header' },
	            _react2.default.createElement(
	              _antd.Row,
	              { type: 'flex', justify: 'space-between', style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(_BackBtn.BackBtn, null),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { icon: 'left', onClick: this.showProgress },
	                  '\u6D41\u7A0B\u8DDF\u8E2A'
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { style: { textAlign: 'right' } },
	                _react2.default.createElement(_antd.Input, {
	                  placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57',
	                  style: { width: '300px' },
	                  value: this.state.condition,
	                  onChange: this.setCondition
	                }),
	                _react2.default.createElement(
	                  _antd.Button,
	                  {
	                    type: 'primary',
	                    style: { marginLeft: '10px' },
	                    onClick: function onClick() {
	                      return _this3.loadBooksIncomeList(1);
	                    }
	                  },
	                  '\u641C\u7D22'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_CardStatic2.default, { uuid: this.props.params.uuid })
	        ),
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: record,
	          pagination: false,
	          rowKey: 'uuid',
	          title: function title() {
	            return _react2.default.createElement(
	              'p',
	              { style: { textAlign: 'center', borderColor: '#e8e8e8' } },
	              '\u676D\u5DDE\u540D\u8F69\u82B1\u5349\u56ED\u827A\u6709\u9650\u516C\u53F8\u8FC7\u5F80\u8BB0\u5F55'
	            );
	          }
	        }),
	        progressVisible ? _react2.default.createElement(_ModalProgress2.default, { cancel: this.hideModal }) : ''
	      );
	    }
	  }]);
	
	  return FinanceCapitalDetail;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(FinanceCapitalDetail);

/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BackBtn = __webpack_require__(12);
	
	var _finance = __webpack_require__(61);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _budget = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	// import { getAccountInfo } from "../../../../store/modules/account_info";
	
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function () {
	      var params = {};
	      var context = _this;
	      params.condition = _this.state.condition || '';
	      params.groupUuid = _this.props.params.uuid;
	      _this.setState({
	        isLoading: true
	      });
	      (0, _budget.queryBudgetGroupSetList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            company: res.data,
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.search = function () {
	      _this.loadData();
	    };
	
	    _this.showModalAdd = function () {};
	
	    _this.showModalEdit = function (uuid) {
	      _this.uuid = uuid;
	    };
	
	    _this.hideModal = function () {};
	
	    _this.handAddSubmit = function (item) {
	      (0, _finance.querySaveFinanceBooks)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handEditSubmit = function (item) {
	      item.uuid = _this.uuid;
	      (0, _finance.querySaveFinanceBooks)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.setCondition = function (e) {
	      _this.setState({
	        condition: e.target.value
	      });
	    };
	
	    _this.showApportion = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '序号',
	        dataIndex: 'num',
	        key: 'num',
	        width: '80',
	        render: function render(text, record, index) {
	          var tot = 15 * (_this.state.pageNo - 1) + index + 1;
	          return _react2.default.createElement(
	            'span',
	            null,
	            tot
	          );
	        }
	      }, {
	        title: '预算组名称',
	        dataIndex: 'groupName',
	        key: 'groupName',
	        width: '200'
	      }, {
	        title: '预算余额',
	        dataIndex: 'current',
	        key: 'current',
	        width: '200',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '新增预算',
	        dataIndex: 'add',
	        key: 'add',
	        width: '200',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '实际支出',
	        dataIndex: 'expenditureSum',
	        key: 'expenditureSum',
	        width: '200',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '实际收入',
	        dataIndex: 'incomeSum',
	        key: 'rest1',
	        width: '200',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '开始时间',
	        dataIndex: 'beginDate',
	        key: 'beginDate',
	        width: '200',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '结束时间',
	        dataIndex: 'endDate',
	        key: 'endDate',
	        width: '200',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      company: [],
	      pageNo: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	      // this.props.dispatch(getAccountInfo());
	    }
	
	    /**
	     * 按条件搜索
	     */
	
	
	    /**
	     * 显示添加账户弹窗
	     */
	
	
	    /**
	     * 显示编辑账户弹窗
	     */
	
	
	    /**
	     * 新增账号
	     */
	
	
	    /**
	     * 编辑账号
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          company = _state.company,
	          isLoading = _state.isLoading;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'fixed-header' },
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'space-between' },
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              _react2.default.createElement(_BackBtn.BackBtn, null)
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { style: { textAlign: 'right' } },
	              _react2.default.createElement(_antd.Input, {
	                placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57',
	                style: { width: '300px' },
	                value: this.state.condition,
	                onChange: this.setCondition
	              }),
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', style: { marginLeft: '10px' }, onClick: this.search },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: function rowKey(record) {
	            return record.uuid;
	          },
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: company,
	          pagination: false,
	          loading: isLoading,
	          style: { paddingTop: '46px' },
	          scroll: { x: 1400, y: _util2.default.pageHeight() - 120 }
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { user: state.user };
	})(Index);

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BackBtn = __webpack_require__(12);
	
	var _finance = __webpack_require__(61);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { getAccountInfo } from "../../../../store/modules/account_info";
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = _this.state.condition || '';
	      _this.setState({
	        pageNo: current,
	        isLoading: true
	      });
	      (0, _finance.queryFinanceBooksList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            company: res.data.result,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.search = function () {
	      _this.loadData();
	    };
	
	    _this.delete = function (uuid) {
	      var context = _this;
	      (0, _finance.queryDeleteFinanceBooks)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          context.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.showModalAdd = function () {};
	
	    _this.showModalEdit = function (uuid) {
	      _this.uuid = uuid;
	    };
	
	    _this.hideModal = function () {};
	
	    _this.handAddSubmit = function (item) {
	      (0, _finance.querySaveFinanceBooks)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handEditSubmit = function (item) {
	      item.uuid = _this.uuid;
	      (0, _finance.querySaveFinanceBooks)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.setCondition = function (e) {
	      _this.setState({
	        condition: e.target.value
	      });
	    };
	
	    _this.showApportion = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '预算类别',
	        dataIndex: 'companyName',
	        key: 'companyName'
	      }, {
	        title: '预算（元）',
	        dataIndex: 'bookName',
	        key: 'bookName'
	      }];
	    };
	
	    _this.state = {
	      company: [],
	      pageNo: 1,
	      total: 0
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	      // this.props.dispatch(getAccountInfo());
	    }
	
	    /**
	     * 按条件搜索
	     */
	
	
	    /**
	     * 显示添加账户弹窗
	     */
	
	
	    /**
	     * 显示编辑账户弹窗
	     */
	
	
	    /**
	     * 新增账号
	     */
	
	
	    /**
	     * 编辑账号
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          total = _state.total,
	          company = _state.company,
	          isLoading = _state.isLoading;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'fixed-header' },
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'space-between' },
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              _react2.default.createElement(_BackBtn.BackBtn, null)
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { style: { textAlign: 'right' } },
	              _react2.default.createElement(_antd.Input, {
	                placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57',
	                style: { width: '300px' },
	                value: this.state.condition,
	                onChange: this.setCondition
	              }),
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', style: { marginLeft: '10px' }, onClick: this.search },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: function rowKey(record) {
	            return record.uuid;
	          },
	          columns: this.columns(),
	          dataSource: company,
	          pagination: pagination,
	          loading: isLoading,
	          style: { paddingTop: '46px' }
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { user: state.user };
	})(Index);

/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _budget = __webpack_require__(30);
	
	var _TableOrg = __webpack_require__(1605);
	
	var _TableOrg2 = _interopRequireDefault(_TableOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function () {
	      var params = {};
	      var context = _this;
	      params.year = _this.state.condition || '';
	      _this.setState({
	        isLoading: true
	      });
	      (0, _budget.queryBudgetGroupPerList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            company: _this.formatGroup(res.data),
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.formatGroup = function (arr) {
	      arr.map(function (item) {
	        if (item.children) {
	          if (item.children.length === 0) {
	            delete item.children;
	            return item;
	          }
	          if (item.children.length > 0) {
	            _this.formatGroup(item.children);
	          }
	        }
	        return item;
	      });
	      return arr;
	    };
	
	    _this.setCondition = function (e) {
	      _this.setState({
	        condition: e
	      }, function () {
	        _this.loadData();
	      });
	    };
	
	    _this.yearss = function () {
	      var currentYear = _moment2.default.unix(new Date().getTime() / 1000).format('YYYY');
	      var years = [];
	      for (var i = -1; i < 4; i++) {
	        years.push(currentYear - i);
	      }
	      return _react2.default.createElement(
	        _antd.Select,
	        {
	          style: { width: '120px', marginRight: '20px' },
	          placeholder: '\u9009\u62E9\u5E74\u4EFD',
	          onChange: _this.setCondition,
	          defaultValue: currentYear
	        },
	        years.map(function (item) {
	          return _react2.default.createElement(
	            _antd.Select.Option,
	            { key: item },
	            item
	          );
	        })
	      );
	    };
	
	    _this.state = {
	      company: [],
	      condition: _moment2.default.unix(new Date().getTime() / 1000).format('YYYY')
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	    }
	
	    /**
	     * 递归删除空的children
	     */
	
	
	    // 根据年份生成表
	
	
	    // 设置年份下拉菜单
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          company = _state.company,
	          isLoading = _state.isLoading;
	
	      var parentProps = {
	        company: company,
	        year: this.state.condition,
	        isLoading: isLoading
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'end', style: { paddingBottom: '20px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            this.yearss()
	          )
	        ),
	        _react2.default.createElement(_TableOrg2.default, Object.assign({}, parentProps, { company: company }))
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _budget = __webpack_require__(30);
	
	var _antd = __webpack_require__(2);
	
	var _adjust_data = __webpack_require__(436);
	
	var _dict = __webpack_require__(64);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.accordYear = function () {
	      var currentYear = +_this.state.year;
	      var year = +(_this.props.year ? _this.props.year : _this.state.year);
	      var adjustFlag = true;
	      if (year < currentYear) {
	        adjustFlag = false;
	      } else {
	        adjustFlag = true;
	      }
	
	      return adjustFlag;
	    };
	
	    _this.setAdjustGroup = function (id) {
	      var company = _this.props.company;
	
	      company.map(function (item) {
	        if (item.uuid === id) {
	          _this.props.dispatch((0, _adjust_data.getAdjustData)(item));
	        } else if (item.children && item.children.length > 0) {
	          item.children.map(function (item1) {
	            if (item1.uuid === id) {
	              _this.props.dispatch((0, _adjust_data.getAdjustData)(item1));
	            }
	            return 1;
	          });
	        }
	
	        return 1;
	      });
	    };
	
	    _this.initTitle = function () {
	      var content = '本年预算(调整次数，调整总金额)';
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u672C\u5E74\u9884\u7B97',
	        _react2.default.createElement(
	          _antd.Tooltip,
	          { title: content },
	          _react2.default.createElement(_antd.Icon, { type: 'info-circle', style: { fontSize: '10px' } })
	        )
	      );
	    };
	
	    _this.currentTitle = function () {
	      var content = '预算余额(冻结金额)';
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u9884\u7B97\u4F59\u989D',
	        _react2.default.createElement(
	          _antd.Tooltip,
	          { title: content },
	          _react2.default.createElement(_antd.Icon, { type: 'info-circle', style: { fontSize: '10px' } })
	        )
	      );
	    };
	
	    _this.loadExpendType = function () {
	      (0, _dict.queryDictExpend)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            expendType: res.data
	          });
	        }
	      });
	    };
	
	    _this.getAccount = function (uuid) {
	      var expendType = _this.state.expendType;
	
	      (0, _budget.queryBudgetAccount)({
	        groupUuid: uuid,
	        year: _this.state.year
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.map(function (item) {
	            expendType.map(function (it) {
	              if (item.type === it.value) {
	                item.typeName = it.key;
	              }
	              return it;
	            });
	            return item;
	          });
	          _this.setState({
	            accountList1: res.data.slice(0, 15),
	            accountList2: res.data.slice(15),
	            accountFlag: true
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {
	      _this.setState({
	        accountFlag: false
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '序号',
	        dataIndex: 'num',
	        key: 'num',
	        width: '6%',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '预算组名称',
	        dataIndex: 'name',
	        key: 'name',
	        width: '12%',
	        align: 'left',
	        render: function render(text, record) {
	          if (record.isEnable === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              text
	            );
	          }
	          if (record.isEnable === 1) {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/budget/' + record.uuid + '/check' },
	              text
	            );
	          }
	        }
	      }, {
	        title: _this.initTitle(),
	        dataIndex: 'init',
	        key: 'init',
	        width: '16%',
	        align: 'left',
	        render: function render(text, record) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            money === '0.00' ? '-' : money,
	            record.adjustmentCount ? _react2.default.createElement(
	              'span',
	              { style: { color: '#FF9F9F' } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#505659' } },
	                '( '
	              ),
	              record.adjustmentCount,
	              ':',
	              record.adjustmentSum,
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#505659' } },
	                ' )'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: _this.currentTitle(),
	        dataIndex: 'current',
	        key: 'current',
	        width: '16%',
	        align: 'left',
	        render: function render(text, record) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	          return _react2.default.createElement(
	            'div',
	            null,
	            money === '0.00' ? '-' : _react2.default.createElement(
	              _reactRouter.Link,
	              { onClick: function onClick() {
	                  return _this.getAccount(record.uuid);
	                } },
	              money
	            ),
	            record.freeze ? _react2.default.createElement(
	              'span',
	              { style: { color: '#BCBCBC' } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#505659' } },
	                '( '
	              ),
	              '\u51BB\u7ED3',
	              record.freeze,
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#505659' } },
	                ' )'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '本年目标收入',
	        dataIndex: 'aims',
	        key: 'aims',
	        width: '12%',
	        align: 'left',
	        render: function render(text) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	          return _react2.default.createElement(
	            'span',
	            null,
	            money === '0.00' ? '-' : money
	          );
	        }
	      }, {
	        title: '实际收入',
	        dataIndex: 'income',
	        key: 'income',
	        width: '12%',
	        align: 'left',
	        render: function render(text) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	          return _react2.default.createElement(
	            'span',
	            null,
	            money === '0.00' ? '-' : money
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        width: '26%',
	        render: function render(text, record) {
	          var year = +(_this.props.year ? _this.props.year : _this.state.year);
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              _this.accordYear() ? _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  onClick: function onClick() {
	                    return _this.setAdjustGroup(record.uuid);
	                  },
	                  to: '/finance/budget/' + 'initiate' + '/' + year + '/adjust'
	                },
	                '\u8C03\u6574\u9884\u7B97'
	              ) : null,
	              _this.accordYear() ? _react2.default.createElement(_antd.Divider, { type: 'vertical' }) : null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                {
	                  to: {
	                    pathname: '/finance/budget/' + record.uuid + '/toviewDetail',
	                    query: {
	                      groupName: record.name,
	                      year: _this.props.year
	                    }
	                  }
	                },
	                '\u67E5\u770B\u9884\u7B97'
	              ),
	              _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/finance/budget/' + record.uuid + '/' + year + '/balance' },
	                '\u6536\u652F\u5206\u6790'
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.accountColumns = function () {
	      return [{
	        title: '类目',
	        dataIndex: 'typeName',
	        key: 'typeName',
	        width: '6%',
	        render: function render(text) {
	          return text;
	        }
	      }, {
	        title: '余额',
	        dataIndex: 'current',
	        key: 'current',
	        width: '6%',
	        render: function render(text) {
	          var current = _util2.default.numberFormat(text);
	          return text ? current : text;
	        }
	      }, {
	        title: '冻结金额',
	        dataIndex: 'freeze',
	        key: 'freeze',
	        width: '6%',
	        render: function render(text) {
	          var freeze = _util2.default.numberFormat(text);
	          return text ? freeze : text;
	        }
	      }];
	    };
	
	    _this.onSelectChange = function (selectedRowKeys) {
	      var selected = [];
	      if (selectedRowKeys.length > 1) {
	        selected.push(selectedRowKeys[1]);
	      } else {
	        selected = selected.concat(selectedRowKeys);
	      }
	      _this.props.handleAdd(selected[0]);
	    };
	
	    _this.state = {
	      expendType: [],
	      accountList1: [],
	      accountList2: [],
	      accountFlag: false,
	      year: ''
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var currentYear = this.props.year || _moment2.default.unix(new Date().getTime() / 1000).format('YYYY');
	      this.loadExpendType();
	      this.setState({
	        year: currentYear
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        year: nextProps.year
	      });
	    }
	
	    // 根据年份判断（预算调整）
	
	
	    // 预算调整数据生成
	
	
	    // 获取支出类别
	
	
	    // 获取余额明细
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          company = _props.company,
	          isLoading = _props.isLoading;
	      var _state = this.state,
	          accountList1 = _state.accountList1,
	          accountList2 = _state.accountList2;
	
	      var sp = 24;
	      if (accountList2 && accountList2.length > 0) {
	        sp = 11;
	      }
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Table, {
	          rowKey: function rowKey(record) {
	            return record.uuid;
	          },
	          columns: this.columns(),
	          dataSource: company,
	          pagination: false,
	          loading: isLoading,
	          size: 'small'
	        }),
	        _react2.default.createElement(
	          _antd.Modal,
	          {
	            title: _react2.default.createElement(
	              'span',
	              null,
	              '\u9884\u7B97\u4F59\u989D  \u5E74\u4EFD\uFF1A' + this.state.year
	            ),
	            footer: null,
	            onCancel: this.handleCancel,
	            visible: this.state.accountFlag,
	            width: '60%'
	          },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: sp },
	              _react2.default.createElement(_antd.Table, { dataSource: accountList1, columns: this.accountColumns(), pagination: false })
	            ),
	            accountList2 && accountList2.length > 0 ? _react2.default.createElement(_antd.Col, { span: 2 }) : null,
	            accountList2 && accountList2.length > 0 ? _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(_antd.Table, {
	                dataSource: accountList2,
	                columns: this.accountColumns(),
	                pagination: false
	              })
	            ) : null
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(Index);

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _budget = __webpack_require__(30);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _FormOpen = __webpack_require__(697);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	var _submitOp = __webpack_require__(1611);
	
	var _submitOp2 = _interopRequireDefault(_submitOp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveSet(item);
	    };
	
	    _this.setWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _budget.queryBudgetSetWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveSet = function () {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _budget.querySaveBudgetSet)({
	        uuid: _this.props.data.uuid,
	        groupUuid: _this.props.data.groupUuid,
	        groupName: _this.props.data.groupName,
	        year: _this.props.data.year
	      }).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deleteSet = function () {
	      (0, _budget.queryDeleteBudgetSet)({
	        uuid: _this.props.data.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataInfo = this.state.dataInfo;
	
	      this.setState({ dataInfo: dataInfo });
	      this.setWorkflow();
	    }
	
	    /**
	     * 提交设置
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_submitOp2.default, Object.assign({
	          data: this.props.data,
	          handSubmit: this.handSubmit,
	          handleDelete: this.deleteSet,
	          isSubmitting: isSubmitting
	        }, this.props)),
	        _react2.default.createElement(_FormOpen2.default, Object.assign({
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          doTask: this.doTask,
	          watchTask: this.watchTask
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _budget = __webpack_require__(30);
	
	var _expend_type = __webpack_require__(80);
	
	var _company_list = __webpack_require__(96);
	
	var _PageEdit = __webpack_require__(1606);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1609);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getSetInfo = function () {
	      (0, _budget.queryBudgetSetInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSetInfo();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	      dispatch((0, _company_list.getCompanyList)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(PageInfo);

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _budget = __webpack_require__(30);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _DateConditionSearch = __webpack_require__(684);
	
	var _DateConditionSearch2 = _interopRequireDefault(_DateConditionSearch);
	
	var _TableSet = __webpack_require__(698);
	
	var _TableSet2 = _interopRequireDefault(_TableSet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getSetBudgetMy = function (params) {
	      _this.setState({ loading: true });
	      (0, _budget.querySetBudgetMy)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataSource: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 15,
	                current: _this.current
	              }
	            }
	          });
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getSetBudgetMy(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.location.pathname
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_DateConditionSearch2.default, Object.assign({ onChange: this.handleSearch }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableSet2.default, Object.assign({}, parentProps, this.props))
	        )
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _budget = __webpack_require__(30);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _WorkflowOp = __webpack_require__(134);
	
	var _WorkflowOp2 = _interopRequireDefault(_WorkflowOp);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _FormOpen = __webpack_require__(697);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.getSetInfo = function () {
	      var uuid = _this.props.params.uuid;
	
	      (0, _budget.queryBudgetSetInfo)({
	        uuid: uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        }
	      });
	    };
	
	    _this.doTask = function (pass, refuse) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackSet(item);
	          break;
	        case 'delete':
	          _this.deleteIncuOregistapp({ uuid: dataInfo.uuid });
	          break;
	        case 'next':
	          _this.nextSet(item);
	          break;
	        case 'return':
	          _this.returnSet(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackSet = function (params) {
	      (0, _budget.queryCallbackBudgetSet)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextSet = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _budget.queryNextBudgetSet)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.setState({ isLoading: false });
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnSet = function (params, refuse) {
	      (0, _budget.queryReturnBudgetSet)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null
	          );
	        }
	      }, {
	        title: '操作内容',
	        dataIndex: 'operating'
	      }, {
	        title: '处理意见',
	        dataIndex: 'refuse'
	      }];
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getSetInfo();
	    }
	
	    // 获取数据
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowOp2.default, {
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_FormOpen2.default, Object.assign({
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          doTask: this.doTask,
	          watchTask: this.watchTask
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'budgetSet', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _budget = __webpack_require__(30);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _TableSet = __webpack_require__(698);
	
	var _TableSet2 = _interopRequireDefault(_TableSet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getSetBudgetWatch = function (params) {
	      _this.setState({ loading: true });
	      (0, _budget.querySetBudgetWatch)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataSource: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 15,
	                current: _this.current
	              }
	            }
	          });
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getSetBudgetWatch(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.location.pathname
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableSet2.default, Object.assign({}, parentProps, this.props))
	        )
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var submitOp = function (_Component) {
	  _inherits(submitOp, _Component);
	
	  function submitOp(props) {
	    _classCallCheck(this, submitOp);
	
	    var _this = _possibleConstructorReturn(this, (submitOp.__proto__ || Object.getPrototypeOf(submitOp)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(submitOp, [{
	    key: 'render',
	    value: function render() {
	      var isSubmitting = this.props.isSubmitting;
	
	      var dataItem = this.props.data;
	      return _react2.default.createElement(
	        'div',
	        { style: { marginBottom: '16px' } },
	        _react2.default.createElement(_BackBtn.BackBtn, null),
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            icon: 'upload',
	            type: 'primary',
	            style: { marginRight: 10 },
	            onClick: this.props.handSubmit,
	            loading: isSubmitting
	          },
	          '\u53D1\u8D77\u7533\u8BF7'
	        ),
	        dataItem.uuid ? _react2.default.createElement(
	          _antd.Button,
	          { icon: 'delete', style: { marginRight: 10 }, onClick: this.props.handleDelete },
	          '\u5220\u9664'
	        ) : null
	      );
	    }
	  }]);
	
	  return submitOp;
	}(_react.Component);
	
	exports.default = submitOp;

/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _BackBtn = __webpack_require__(12);
	
	var _dict = __webpack_require__(64);
	
	var _budget = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadBudgetExpendType = function () {
	      (0, _dict.queryDictExpend)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            expendType: res.data
	          });
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      _this.setState({
	        isLoading: true
	      });
	      var pa = {};
	      pa.groupUuid = _this.props.params.uuid;
	      pa.year = _this.props.location.query.year;
	      (0, _budget.queryImportBudgetGroupSetInfo)(pa).then(function (res) {
	        if (res.statusCode === 200) {
	          var data = [];
	          data = data.concat(res.data.LABOR_COSTS);
	          data = data.concat(res.data.BUSINESS_COSTS);
	          data = data.concat(res.data.BUSINESS_POOL);
	          data = data.concat(res.data.FIXED_POOL);
	
	          res.data.SUM.flag = 5;
	          if (data.length > 0) {
	            data = data.concat(res.data.SUM);
	          }
	          _this.setState({
	            sum: res.data.SUM.SUM,
	            data: data,
	            isLoading: false,
	            busCosLen: res.data.BUSINESS_COSTS.length,
	            busPoolLen: res.data.BUSINESS_POOL.length,
	            fixedLen: res.data.FIXED_POOL.length,
	            laborLen: res.data.LABOR_COSTS.length
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      var config = [];
	      var _this$state = _this.state,
	          data = _this$state.data,
	          busCosLen = _this$state.busCosLen,
	          busPoolLen = _this$state.busPoolLen,
	          fixedLen = _this$state.fixedLen,
	          laborLen = _this$state.laborLen;
	
	      for (var i = 1; i <= 12; i++) {
	        var item = {};
	        var key = i < 10 ? '0' + i : '' + i;
	        item.title = i < 10 ? '0' + i : '' + i;
	        item.dataIndex = key;
	        item.key = key;
	        item.width = 100;
	        item.render = function (text) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	          return _react2.default.createElement(
	            'span',
	            null,
	            money === '0.00' ? '' : money
	          );
	        };
	        config.push(item);
	      }
	      config.unshift({
	        title: '合计',
	        dataIndex: 'sum',
	        key: 'sum',
	        width: 150,
	        render: function render(text) {
	          var money = _util2.default.numberFormat(text, 2, '.', ',');
	          return _react2.default.createElement(
	            'span',
	            null,
	            money === '0.00' ? '' : money
	          );
	        }
	      });
	      config.unshift({
	        title: '费用科目',
	        dataIndex: 'type',
	        key: 'type',
	        width: 150,
	        render: function render(text, record, index) {
	          var obj = {
	            children: _react2.default.createElement(
	              'span',
	              null,
	              _this.matchType(text)
	            ),
	            props: {}
	          };
	          if (index === data.length - 1) {
	            obj.props.colSpan = 0;
	          }
	          return obj;
	        }
	      });
	      config.unshift({
	        title: '二级科目',
	        dataIndex: 'sub',
	        key: 'sub',
	        width: 150,
	        render: function render(text, record, index) {
	          var sub = '';
	          if (record.flag === 1) {
	            sub = '人力成本';
	          } else if (record.flag === 2) {
	            sub = '业务成本';
	          } else if (record.flag === 3) {
	            sub = '固定公摊';
	          } else if (record.flag === 4) {
	            sub = '业务公摊';
	          } else if (record.flag === 5) {
	            sub = '合计';
	          }
	          var obj = {
	            children: _react2.default.createElement(
	              'span',
	              null,
	              sub
	            ),
	            props: {}
	          };
	          if (laborLen !== 0 && index === 0) {
	            obj.props.rowSpan = laborLen; // 合并业务公摊
	          } else if (index > 0 && index < laborLen) {
	            obj.props.rowSpan = 0;
	          } else if (busCosLen !== 0 && index === laborLen) {
	            obj.props.rowSpan = busCosLen; // 合并业务成本
	          } else if (index > laborLen && index < laborLen + busCosLen) {
	            obj.props.rowSpan = 0;
	          } else if (fixedLen !== 0 && index === laborLen + busCosLen) {
	            obj.props.rowSpan = fixedLen; // 合并固定公摊
	          } else if (index > laborLen + busCosLen && index < laborLen + busCosLen + fixedLen) {
	            obj.props.rowSpan = 0;
	          } else if (busPoolLen !== 0 && index === fixedLen + busCosLen + laborLen) {
	            obj.props.rowSpan = busPoolLen;
	          } else if (index > busPoolLen + busCosLen + laborLen && index < busPoolLen + busCosLen + fixedLen + laborLen) {
	            obj.props.rowSpan = 0;
	          } else {
	            obj.props.colSpan = 2;
	          }
	          return obj;
	        }
	      });
	      config.unshift({
	        title: '一级科目',
	        dataIndex: 'main',
	        key: 'main',
	        width: 150,
	        render: function render(text, record, index) {
	          var obj = {
	            children: _react2.default.createElement(
	              'span',
	              null,
	              '\u8FD0\u8425\u6210\u672C'
	            ),
	            props: {}
	          };
	          if (index === 0) {
	            obj.props.rowSpan = data.length;
	          } else {
	            obj.props.rowSpan = 0;
	          }
	          return obj;
	        }
	      });
	      return config;
	    };
	
	    _this.matchType = function (value) {
	      var type = void 0;
	      _this.state.expendType.map(function (item) {
	        if (item.value === value) {
	          type = item.key;
	          return item;
	        }
	        return type;
	      });
	      return type;
	    };
	
	    _this.state = {
	      data: [],
	      expendType: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.loadBudgetExpendType();
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isLoading = _state.isLoading,
	          data = _state.data,
	          sum = _state.sum;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(_antd.Col, { span: 1 }),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u9884\u7B97\u90E8\u95E8\uFF1A'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.props.location.query.groupName
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u9884\u7B97\u5468\u671F\uFF1A'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                this.props.location.query.year,
	                '\u5E74'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u9884\u7B97\u603B\u989D\uFF1A'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                sum,
	                '\u5143'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_antd.Table, {
	            rowKey: function rowKey(record) {
	              return record.index;
	            },
	            columns: this.columns(),
	            dataSource: data,
	            pagination: false,
	            loading: isLoading,
	            style: { paddingTop: '20px' },
	            bordered: true,
	            size: 'small',
	            scroll: { x: 1800, y: _util2.default.pageHeight() - 120 }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactHtmlTableToExcel = __webpack_require__(308);
	
	var _reactHtmlTableToExcel2 = _interopRequireDefault(_reactHtmlTableToExcel);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BackBtn = __webpack_require__(12);
	
	var _budget = __webpack_require__(30);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _getAllType = __webpack_require__(168);
	
	var _getAllType2 = _interopRequireDefault(_getAllType);
	
	var _MonthRangePicker = __webpack_require__(1501);
	
	var _MonthRangePicker2 = _interopRequireDefault(_MonthRangePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var date = new Date();
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.allcheckedUuids = [];
	
	    _this.loopTitleLen = function (thead) {
	      thead.length > 0 && thead.map(function (item) {
	        if (item.children && item.children.length === 0) {
	          _this.len++;
	          thead.checked = true;
	        } else if (item.children && item.children.length > 0) {
	          _this.loopTitleLen(item.children);
	        }
	        return item;
	      });
	      return thead;
	    };
	
	    _this.initChecked = function (thead) {
	      thead.length > 0 && thead.map(function (item) {
	        if (item.children && item.children.length === 0) {
	          item.checked = true;
	          _this.checkedUUids.push(item.key);
	        } else if (item.children && item.children.length > 0) {
	          _this.initChecked(item.children);
	        }
	        return item;
	      });
	      _this.allcheckedUuids = _this.checkedUUids.map(function (item) {
	        return item;
	      });
	      _this.setState({
	        checkedUUids: _this.checkedUUids
	      });
	      return thead;
	    };
	
	    _this.loopJoin = function (budget, actual) {
	      budget.map(function (item, index) {
	        Object.keys(item).forEach(function (key) {
	          if (key !== 'children' && key !== 'type' && key !== 'typeName' && key !== 'apportionFlag') {
	            item[key] = item[key] + '\u4E28' + actual[index][key];
	          } else if (key === 'children' && item.children && item.children.length > 0) {
	            _this.expandedRowKeys.push('' + item.uuid);
	            _this.loopJoin(item[key], actual[index][key]);
	          }
	          item.show = 'all';
	        });
	        return item;
	      });
	      return budget;
	    };
	
	    _this.joinSum = function (budgetSum, actualSum) {
	      var sum = {};
	      // eslint-disable-next-line guard-for-in
	      Object.keys(budgetSum).forEach(function (key) {
	        sum[key] = budgetSum[key] + '\u4E28' + actualSum[key];
	      });
	      return sum;
	    };
	
	    _this.setIncomeType = function (income) {
	      var type = _this.type;
	
	      income.forEach(function (item) {
	        item.direction = 'income';
	        type.forEach(function (typeItem) {
	          if (item.type === typeItem.value) {
	            item.typeName = typeItem.key;
	          }
	        });
	      });
	      return income;
	    };
	
	    _this.loopSetshow = function (data, show) {
	      data.map(function (item) {
	        Object.keys(item).forEach(function (key) {
	          if (key !== 'children' && key !== 'type' && key !== 'typeName' && key !== 'apportionFlag') {
	            item.show = show;
	          } else if (key === 'children' && item.children && item.children.length > 0) {
	            _this.loopSetshow(item.children, show);
	          }
	        });
	        return item;
	      });
	      return data;
	    };
	
	    _this.loadData = function (searchDate) {
	      _this.setState({
	        isLoading: true
	      });
	      _this.len = 0;
	      var groupUuids = _this.state.groupUuids;
	
	      groupUuids.length === 0 ? (0, _budget.queryBudgetStatistics)(searchDate).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loopTitleLen(res.data.thead);
	          var data = _this.loopJoin(res.data.budget, res.data.actual);
	          var sum = _this.joinSum(res.data.budgetSum, res.data.actualSum);
	          var countSum = _this.joinSum(res.data.budgetCountSum, res.data.actualCountSum);
	          countSum.typeName = '人力成本+业务成本';
	          sum.typeName = '合计';
	          res.data.noTypes[0].typeName = '未定义类型';
	          data = data.concat(res.data.noTypes);
	          data.push(countSum);
	          data.push(sum);
	          data = _this.loopSetshow(data, 'all');
	          var thead = _this.initChecked(res.data.thead);
	          _this.setState({
	            thead: thead,
	            data: data,
	            isLoading: false,
	            wid: (_this.len + 1) * 250 + 350
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      }) : (0, _budget.queryAnalysisBudgets)(searchDate).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loopTitleLen(res.data.thead);
	          var data = _this.loopJoin(res.data.budget, res.data.actual);
	          var sum = _this.joinSum(res.data.budgetSum, res.data.actualSum);
	          var countSum = _this.joinSum(res.data.budgetCountSum, res.data.actualCountSum);
	          countSum.typeName = '人力成本+业务成本';
	          sum.typeName = '合计';
	          res.data.noTypes[0].typeName = '未定义类型';
	          data = data.concat(res.data.noTypes);
	          data.push(countSum);
	          data.push(sum);
	          data = _this.loopSetshow(data, 'all');
	          var thead = _this.initChecked(res.data.thead);
	          _this.setState({
	            thead: thead,
	            data: data,
	            isLoading: false,
	            wid: (_this.len + 1) * 250 + 350
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var _this$state = _this.state,
	          value = _this$state.value,
	          groupUuids = _this$state.groupUuids;
	
	      var params = {};
	      params.beginDate = (0, _moment2.default)(value[0]).format('YYYY-MM-DD');
	      params.endDate = (0, _moment2.default)(value[1]).format('YYYY-MM');
	      params.groupUuids = groupUuids;
	      _localDb2.default.set('date', value);
	      _this.loadData(params);
	    };
	
	    _this.handlePanelChange = function (value) {
	      _this.setState({
	        value: value
	      });
	    };
	
	    _this.transferValue = function (value) {
	      _this.setState({
	        value: value
	      });
	    };
	
	    _this.searchBar = function () {
	      var value = _this.state.value;
	      var groupUuids = _this.state.groupUuids;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: _this.handleSubmit },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'start' },
	          groupUuids.length !== 0 ? _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(_BackBtn.BackBtn, null)
	          ) : null,
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(_MonthRangePicker2.default, {
	                startValue: value[0],
	                endValue: value[1],
	                transferValue: function transferValue(_transferValue) {
	                  return _this.transferValue(_transferValue);
	                }
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit', style: { marginLeft: '10px' } },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.toYearStatic = function (company) {
	      _this.props.router.push({
	        pathname: '/finance/budgets/' + company.key + '/year',
	        query: {
	          companyName: company.title2
	        }
	      });
	    };
	
	    _this.toDetail = function (uuid, record) {
	      var value = _this.state.value;
	
	      var params = {};
	      params.beginDate = (0, _moment2.default)(value[0]).format('YYYY-MM');
	      params.endDate = (0, _moment2.default)(value[1]).format('YYYY-MM');
	      params.type = record.type;
	      params.fromPage = 'statis';
	      if (record.typeName === '未定义类型') {
	        params.type = 'NULL';
	      }
	      params.apportionFlag = record.apportionFlag ? 1 : 0;
	      if (params.type) {
	        _this.props.router.push({
	          pathname: '/finance/budget/' + uuid + '/check',
	          query: params
	        });
	      }
	    };
	
	    _this.loopchangeCheck = function (checkedUUids, thead) {
	      thead.length > 0 && thead.map(function (item) {
	        if (!item.children) {
	          var isChecked = checkedUUids.some(function (uuid) {
	            return item.key === uuid;
	          });
	          item.checked = !!isChecked;
	        } else if (item.children && item.children.length > 0) {
	          _this.loopchangeCheck(checkedUUids, item.children);
	        }
	        return item;
	      });
	      return thead;
	    };
	
	    _this.handleAllChecked = function () {
	      var _this$state2 = _this.state,
	          checkedUUids = _this$state2.checkedUUids,
	          thead = _this$state2.thead;
	
	      if (_this.allcheckedUuids.length > checkedUUids.length) {
	        checkedUUids = [].concat(_this.allcheckedUuids);
	      } else {
	        checkedUUids = [];
	      }
	      thead = _this.loopchangeCheck(checkedUUids, thead);
	      thead.pop();
	      thead.shift();
	      _this.setState({
	        checkedUUids: checkedUUids
	      });
	    };
	
	    _this.changeAllCheck = function (item) {
	      return function () {
	        var _this$state3 = _this.state,
	            checkedUUids = _this$state3.checkedUUids,
	            thead = _this$state3.thead;
	
	        var flag = item.children.every(function (item1) {
	          return item1.checked;
	        });
	        if (flag) {
	          item.children.forEach(function (item1) {
	            checkedUUids = checkedUUids.filter(function (item2) {
	              return item2 !== item1.key;
	            });
	          });
	        } else {
	          item.children.forEach(function (item1) {
	            var notInclude = checkedUUids.every(function (item2) {
	              return item2 !== item1.key;
	            });
	            if (notInclude) {
	              checkedUUids.push(item1.key);
	            }
	          });
	        }
	        thead = _this.loopchangeCheck(checkedUUids, thead);
	        thead.pop();
	        thead.shift();
	        _this.setState({
	          checkedUUids: checkedUUids,
	          thead: thead
	        });
	      };
	    };
	
	    _this.changeCheck = function (key) {
	      var thead = _this.state.thead;
	      var checkedUUids = _this.state.checkedUUids;
	
	      var index = 0;
	      var isChecked = checkedUUids.some(function (item) {
	        return item === key;
	      });
	      if (isChecked) {
	        index = checkedUUids.indexOf(key);
	        checkedUUids.splice(index, 1);
	      } else {
	        checkedUUids.push(key);
	      }
	      thead = _this.loopchangeCheck(checkedUUids, thead);
	      thead.pop();
	      thead.shift();
	      _this.setState({
	        checkedUUids: checkedUUids,
	        thead: thead
	      });
	    };
	
	    _this.setShow = function (key) {
	      var _this$state4 = _this.state,
	          data = _this$state4.data,
	          show = _this$state4.show,
	          showChecked = _this$state4.showChecked;
	
	      var flag = false;
	      showChecked.map(function (item) {
	        if (item === key) {
	          flag = true;
	        }
	        return item;
	      });
	      if (flag) {
	        showChecked = showChecked.filter(function (item) {
	          return item !== key;
	        });
	      } else {
	        showChecked.push(key);
	      }
	      if (showChecked.length === 2) {
	        show = 'all';
	      } else if (showChecked.length === 1) {
	        show = showChecked[0];
	      }
	      data = _this.loopSetshow(data, show);
	      _this.setState({
	        data: data,
	        show: show,
	        showChecked: showChecked
	      });
	    };
	
	    _this.loopTitle = function (thead) {
	      thead.length > 0 && thead.map(function (item) {
	        if (item.dataIndex === 'typeName' || item.dataIndex === 'sum') {
	          return null;
	        }
	        item.title2 = item.title2 || item.title;
	        if (!item.children || item.children && item.children.length === 0) {
	          delete item.children;
	          item.title = _react2.default.createElement(
	            'p',
	            { style: { textAlign: 'center' } },
	            _react2.default.createElement(_antd.Checkbox, { checked: item.checked, onClick: function onClick() {
	                return _this.changeCheck(item.key);
	              } }),
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.toYearStatic(item);
	                }, style: { marginLeft: '5px' } },
	              item.title2
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '(\u5B9E\u9645|\u9884\u7B97)'
	            )
	          );
	          item.dataIndex = item.key;
	          item.width = 250;
	          item.render = function (text, record) {
	            if (record.typeName === '未定义类型') {
	              var numFont = _util2.default.numberFormat(text, 2, '.', ',');
	              return numFont === '0.00' ? _react2.default.createElement(
	                'span',
	                null,
	                '-'
	              ) : _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.toDetail(item.key, record);
	                  } },
	                numFont
	              );
	            }
	            if (record.direction === 'income') {
	              var _numFont = _util2.default.numberFormat(text, 2, '.', ',');
	              return _numFont === '0.00' ? _react2.default.createElement(
	                'span',
	                null,
	                '-'
	              ) : _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.toDetail(item.key, record);
	                  } },
	                _numFont
	              );
	            }
	            if (record.typeName !== '未定义类型' && !record.direction) {
	              var textArr = ('' + text).split('丨');
	              var style = {};
	              if (parseFloat(textArr[1]) > parseFloat(textArr[0])) {
	                style.color = 'red';
	              }
	              var actualFont = _util2.default.numberFormat(textArr[1], 2, '.', ',');
	              var budgetFont = _util2.default.numberFormat(textArr[0], 2, '.', ',');
	              // 只显示实际
	              if (record.show === 'actual') {
	                if (actualFont === '0.00') {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    '-'
	                  );
	                }
	                if (actualFont !== '0.00') {
	                  return _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                        return _this.toDetail(item.key, record);
	                      } },
	                    actualFont
	                  );
	                }
	              }
	              // 只显示预算
	              if (record.show === 'budget') {
	                if (budgetFont === '0.00') {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    '-'
	                  );
	                }
	                if (budgetFont !== '0.00') {
	                  return _react2.default.createElement(
	                    'a',
	                    { style: { color: 'gray' } },
	                    budgetFont
	                  );
	                }
	              }
	              // 都显示
	              if (record.show === 'all') {
	                if (actualFont === '0.00' && budgetFont === '0.00') {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    '-'
	                  );
	                }
	                if (actualFont === '0.00') {
	                  return _react2.default.createElement(
	                    'a',
	                    { style: { color: 'gray' } },
	                    budgetFont
	                  );
	                }
	                if (budgetFont === '0.00') {
	                  return _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                        return _this.toDetail(item.key, record);
	                      } },
	                    actualFont
	                  );
	                }
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                        return _this.toDetail(item.key, record);
	                      }, style: style },
	                    actualFont
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { margin: '0 5px' } },
	                    '\u4E28'
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { style: { color: 'gray' } },
	                    budgetFont
	                  )
	                );
	              }
	            }
	          };
	        } else if (item.children && item.children.length > 0) {
	          item.title = _react2.default.createElement(
	            'p',
	            { style: { textAlign: 'center' } },
	            _react2.default.createElement(_antd.Checkbox, {
	              checked: item.children.every(function (item1) {
	                return item1.checked;
	              }),
	              onClick: function onClick() {
	                return _this.changeAllCheck(item);
	              }
	            }),
	            _react2.default.createElement(
	              'span',
	              { style: { marginLeft: '5px' } },
	              item.title2
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              '(\u5B9E\u9645|\u9884\u7B97)'
	            )
	          );
	          _this.loopTitle(item.children);
	        }
	        return item;
	      });
	      return thead;
	    };
	
	    _this.expandAllRows = function () {
	      _this.setState({
	        expandedRowKeys: _this.expandedRowKeys
	      });
	    };
	
	    _this.handleExpend = function (expandedRows) {
	      _this.setState({
	        expandedRowKeys: expandedRows
	      });
	    };
	
	    _this.columns = function () {
	      var _this$state5 = _this.state,
	          thead = _this$state5.thead,
	          checkedUUids = _this$state5.checkedUUids;
	
	      var columns = _this.loopTitle(thead);
	      if (columns[0] && columns[0].key !== 'typeName') {
	        columns.unshift({
	          title: _react2.default.createElement(
	            'div',
	            { style: { textAlign: 'center', height: '109px' } },
	            _react2.default.createElement('a', null),
	            _react2.default.createElement('p', null)
	          ),
	          dataIndex: 'typeName',
	          key: 'typeName',
	          width: 250,
	          fixed: 'left',
	          render: function render(text, record) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              record.typeName || record.type
	            );
	          }
	        });
	      }
	      if (columns[0] && columns[columns.length - 1].key !== 'sum') {
	        columns.push({
	          title: '合计',
	          dataIndex: 'sum',
	          key: 'sum',
	          width: 280,
	          fixed: 'right',
	          render: function render(text, record) {
	            if (record.typeName !== '未定义类型' && record.direction !== 'income') {
	              var budgetSum = 0;
	              var actualSum = 0;
	              var item = [];
	              var budgetItem = 0;
	              var actualItem = 0;
	              Object.keys(record).forEach(function (key) {
	                if (checkedUUids.includes(key)) {
	                  item = ('' + record[key]).split('丨');
	                  actualItem = parseFloat(item[1]);
	                  budgetItem = parseFloat(item[0]);
	                  actualSum += actualItem;
	                  budgetSum += budgetItem;
	                  actualSum = parseFloat(actualSum);
	                  budgetSum = parseFloat(budgetSum);
	                }
	              });
	              var style = {};
	              if (parseFloat(actualSum) > parseFloat(budgetSum)) {
	                style.color = 'red';
	              }
	              actualSum = _util2.default.numberFormat(actualSum, 2, '.', ',');
	              budgetSum = _util2.default.numberFormat(budgetSum, 2, '.', ',');
	
	              // 只显示实际
	              if (record.show === 'actual') {
	                if (actualSum === '0.00') {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    '-'
	                  );
	                }
	                if (actualSum === '0.00') {
	                  return _react2.default.createElement(
	                    'a',
	                    null,
	                    actualSum
	                  );
	                }
	              }
	              // 只显示预算
	              if (record.show === 'budget') {
	                if (budgetSum !== '0.00') {
	                  return _react2.default.createElement(
	                    'a',
	                    { style: { color: 'gray' } },
	                    budgetSum
	                  );
	                }
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  '-'
	                );
	              }
	              // 都显示
	              if (record.show === 'all') {
	                if (actualSum === '0.00' && budgetSum === '0.00') {
	                  return _react2.default.createElement(
	                    'span',
	                    null,
	                    '-'
	                  );
	                }
	                if (actualSum === '0.00') {
	                  return _react2.default.createElement(
	                    'a',
	                    { style: { color: 'gray' } },
	                    budgetSum
	                  );
	                }
	                if (budgetSum === '0.00') {
	                  return _react2.default.createElement(
	                    'a',
	                    null,
	                    actualSum
	                  );
	                }
	                return _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(
	                    'a',
	                    { style: style },
	                    actualSum
	                  ),
	                  _react2.default.createElement(
	                    'span',
	                    { style: { margin: '0 5px' } },
	                    '\u4E28'
	                  ),
	                  _react2.default.createElement(
	                    'a',
	                    { style: { color: 'gray' } },
	                    budgetSum
	                  )
	                );
	              }
	            } else {
	              var sum = 0;
	              Object.keys(record).forEach(function (key) {
	                var sumFlag = key !== 'type' && key !== 'children' && key !== 'parent' && key !== 'uuid' && key !== 'typeName' && key !== 'apportionFlag' && key !== 'direction';
	                if (sumFlag) {
	                  if (checkedUUids.includes(key)) {
	                    sum += parseFloat(record[key]);
	                    sum = parseFloat(sum);
	                  }
	                }
	              });
	              var sumFont = _util2.default.numberFormat(sum);
	              return _react2.default.createElement(
	                'span',
	                null,
	                sumFont
	              );
	            }
	          }
	        });
	      }
	
	      return columns;
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: false,
	      thead: [],
	      expandedRowKeys: [],
	      checkedUUids: [],
	      show: 'all', // all显示实际和预算
	      showChecked: ['actual', 'budget'],
	      value: _localDb2.default.get('date') ? [(0, _moment2.default)(_localDb2.default.get('date')[0]), (0, _moment2.default)(_localDb2.default.get('date')[1])] : [_moment2.default.unix(date.getTime() / 1000), _moment2.default.unix(date.getTime() / 1000)],
	      groupUuids: _this.props.location.query.groupUuids || []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.expandedRowKeys = [];
	
	      this.checkedUUids = [];
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var table = document.getElementsByClassName('ant-table-scroll')[0];
	      table.id = 'table-to-xls';
	
	      var params = {};
	      var _state = this.state,
	          value = _state.value,
	          groupUuids = _state.groupUuids;
	
	      params.beginDate = (0, _moment2.default)(value[0]).format('YYYY-MM');
	      params.endDate = (0, _moment2.default)(value[1]).format('YYYY-MM');
	      params.groupUuids = groupUuids;
	      (0, _getAllType2.default)().then(function (res) {
	        _this2.type = res;
	        _this2.loadData(params);
	      });
	      this.len = 0;
	    }
	
	    /** 拼接实际和预算 */
	
	
	    // 设置收入类目对应的名字
	
	
	    // 递归给每个单元格设置show属性
	
	
	    /**
	     * 获取预算统计列表
	     */
	
	
	    /**
	     * 跳转至按年统计详情页
	     */
	
	
	    /**
	     * 递归设置表头
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          data = _state2.data,
	          wid = _state2.wid,
	          isLoading = _state2.isLoading,
	          expandedRowKeys = _state2.expandedRowKeys,
	          show = _state2.show,
	          checkedUUids = _state2.checkedUUids;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex' },
	          _react2.default.createElement(
	            _antd.Col,
	            { style: { textAlign: 'right' }, span: 12 },
	            this.searchBar()
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12, style: { textAlign: 'right' } },
	            _react2.default.createElement(
	              _antd.Checkbox,
	              {
	                onChange: function onChange() {
	                  return _this3.handleAllChecked();
	                },
	                checked: checkedUUids.length === this.allcheckedUuids.length
	              },
	              '\u5168\u9009'
	            ),
	            _react2.default.createElement(
	              _antd.Checkbox,
	              {
	                onChange: function onChange() {
	                  return _this3.setShow('actual');
	                },
	                checked: show === 'actual' || show === 'all'
	              },
	              '\u5B9E\u9645'
	            ),
	            _react2.default.createElement(
	              _antd.Checkbox,
	              {
	                onChange: function onChange() {
	                  return _this3.setShow('budget');
	                },
	                checked: show === 'budget' || show === 'all'
	              },
	              '\u9884\u7B97'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { onClick: this.expandAllRows, style: { marginRight: '10px' } },
	              '\u5C55\u5F00\u5168\u90E8\u884C'
	            ),
	            _react2.default.createElement(_reactHtmlTableToExcel2.default, {
	              id: 'test-table-xls-button',
	              className: 'download-table-xls-button ant-btn',
	              table: 'table-to-xls',
	              filename: 'tablexls',
	              sheet: 'tablexls',
	              style: {
	                marginTop: '4px'
	              },
	              buttonText: '\u5BFC\u51FA'
	            })
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: data,
	          loading: isLoading,
	          bordered: true,
	          rowKey: 'uuid',
	          size: 'small',
	          expandedRowKeys: expandedRowKeys,
	          defaultExpandAllRows: true,
	          scroll: { x: wid, y: _util2.default.pageHeight() - 200 },
	          pagination: false,
	          onExpandedRowsChange: this.handleExpend
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    type: state.income_expend_type,
	    account_info: state.account_info
	  };
	})(_antd.Form.create()(Index));

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BackBtn = __webpack_require__(12);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _budget = __webpack_require__(30);
	
	var _reactHtmlTableToExcel = __webpack_require__(308);
	
	var _reactHtmlTableToExcel2 = _interopRequireDefault(_reactHtmlTableToExcel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var date = new Date();
	var month = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loopJoin = function (budget, actual) {
	      budget.map(function (item, index) {
	        Object.keys(item).forEach(function (key) {
	          if (key !== 'children' && key !== 'type' && key !== 'typeName' && key !== 'apportionFlag') {
	            item[key] = item[key] + '\u4E28' + actual[index][key];
	          } else if (key === 'children' && item.children && item.children.length > 0) {
	            _this.loopJoin(item[key], actual[index][key]);
	          }
	        });
	        return item;
	      });
	      return budget;
	    };
	
	    _this.joinSum = function (budgetSum, actualSum) {
	      var sum = {};
	      // eslint-disable-next-line guard-for-in
	
	      Object.keys(budgetSum).forEach(function (key) {
	        sum[key] = budgetSum[key] + '\u4E28' + actualSum[key];
	      });
	      return sum;
	    };
	
	    _this.loadData = function (year) {
	      _this.setState({
	        isLoading: true
	      });
	      var params = {};
	      params.groupUuids = _this.props.params.uuid;
	      params.year = year;
	
	      (0, _budget.queryBudgetStatisticsMonth)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var data = _this.loopJoin(res.data.budget, res.data.actual);
	          var sum = _this.joinSum(res.data.budgetSum, res.data.actualSum);
	          var countSum = _this.joinSum(res.data.budgetCountSum, res.data.actualCountSum);
	          countSum.typeName = '人力成本+业务成本';
	          sum.typeName = '合计';
	          res.data.noTypes[0].typeName = '未定义类型';
	          data = data.concat(res.data.noTypes);
	          data.push(countSum);
	          data.push(sum);
	          _this.setState({
	            data: data,
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          year = _this$props$form$getF.year;
	
	      _this.setState({
	        year: year
	      });
	      _this.year = year;
	      _localDb2.default.set('year', year);
	      _this.loadData(year);
	    };
	
	    _this.toDetail = function (yearMonth, record) {
	      var params = {};
	      params.yearMonth = yearMonth;
	      params.type = record.type;
	      params.apportionFlag = record.apportionFlag ? 1 : 0;
	      params.fromPage = 'statis';
	      if (record.type) {
	        _this.props.router.push({
	          pathname: '/finance/budget/' + _this.props.params.uuid + '/check',
	          query: params
	        });
	      }
	    };
	
	    _this.searchBar = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      var year = date.getFullYear();
	      var years = [];
	      for (var i = year; i >= 2014; i--) {
	        years.push(i.toString());
	      }
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: _this.handleSubmit },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'end' },
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              getFieldDecorator('year', {
	                initialValue: _this.state.year
	              })(_react2.default.createElement(
	                _antd.Select,
	                { style: { width: '200px' } },
	                years.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item },
	                    item
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit', style: { marginLeft: '10px' } },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.handleAllChecked = function () {
	      var checkedMonth = _this.state.checkedMonth;
	
	      if (checkedMonth.length === month.length) {
	        _this.setState({
	          checkedMonth: []
	        });
	      } else {
	        _this.setState({
	          checkedMonth: month
	        });
	      }
	    };
	
	    _this.changeCheck = function (key) {
	      var checkedMonth = _this.state.checkedMonth;
	
	      if (checkedMonth.some(function (item) {
	        return item === key;
	      })) {
	        checkedMonth = checkedMonth.filter(function (item) {
	          return item !== key;
	        });
	      } else {
	        checkedMonth.push(key);
	      }
	      _this.setState({
	        checkedMonth: checkedMonth
	      });
	    };
	
	    _this.columns = function () {
	      var _this$state = _this.state,
	          year = _this$state.year,
	          checkedMonth = _this$state.checkedMonth;
	
	      _this.month = month.map(function (item) {
	        return {
	          title: year + '-' + item,
	          uuid: item,
	          checked: checkedMonth.some(function (item2) {
	            return item2 === item;
	          })
	        };
	      });
	      var columns = _this.month.map(function (item) {
	        var config = {};
	        config.title = _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_antd.Checkbox, { checked: item.checked, onClick: function onClick() {
	              return _this.changeCheck(item.uuid);
	            } }),
	          _react2.default.createElement(
	            'span',
	            { style: { paddingLeft: '8px' } },
	            item.title
	          )
	        );
	        config.dataIndex = item.uuid;
	        config.key = item.uuid;
	        config.width = 250;
	        config.render = function (text, record) {
	          if (record.typeName === '未定义类型') {
	            var numFont = _util2.default.numberFormat(text, 2, '.', ',');
	            return _react2.default.createElement(
	              'span',
	              null,
	              numFont === '0.00' ? '-' : numFont
	            );
	          }
	          if (record.typeName !== '未定义类型') {
	            var textArr = ('' + text).split('丨');
	            var actualFont = _util2.default.numberFormat(textArr[1], 2, '.', ',');
	            var budgetFont = _util2.default.numberFormat(textArr[0], 2, '.', ',');
	            var style = {};
	            if (parseFloat(textArr[1]) > parseFloat(textArr[0])) {
	              style.color = 'red';
	            }
	            if (actualFont === '0.00' && budgetFont === '0.00') {
	              return _react2.default.createElement(
	                'span',
	                null,
	                '-'
	              );
	            }
	            if (actualFont === '0.00') {
	              return _react2.default.createElement(
	                'a',
	                { style: { color: 'gray' } },
	                budgetFont
	              );
	            }
	            if (budgetFont === '0.00') {
	              return _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.toDetail(item.title, record);
	                  } },
	                actualFont
	              );
	            }
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.toDetail(item.title, record);
	                  }, style: style },
	                actualFont
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { margin: '0 5px' } },
	                '\u4E28'
	              ),
	              _react2.default.createElement(
	                'a',
	                { style: { color: 'gray' } },
	                budgetFont
	              )
	            );
	          }
	        };
	        return config;
	      });
	
	      columns.unshift({
	        title: '',
	        dataIndex: 'typeName',
	        key: 'typeName',
	        width: 250,
	        fixed: 'left'
	      });
	      columns.push({
	        title: '合计',
	        dataIndex: 'sum',
	        key: 'sum',
	        width: 280,
	        fixed: 'right',
	        render: function render(text, record) {
	          if (record.typeName !== '未定义类型') {
	            var budgetSum = 0;
	            var actualSum = 0;
	            var item = [];
	            var budgetItem = 0;
	            var actualItem = 0;
	            // eslint-disable-next-line guard-for-in
	            Object.keys(record).forEach(function (key) {
	              var sumFlag = key !== 'type' && key !== 'children' && key !== 'parent' && key !== 'uuid' && key !== 'typeName' && key !== 'apportionFlag';
	              if (sumFlag && checkedMonth.some(function (item1) {
	                return item1 === key;
	              })) {
	                item = record[key].split('丨');
	                actualItem = parseFloat(item[1]);
	                budgetItem = parseFloat(item[0]);
	                actualSum += actualItem;
	                budgetSum += budgetItem;
	                actualSum = parseFloat(actualSum);
	                budgetSum = parseFloat(budgetSum);
	              }
	            });
	            var style = {};
	            if (parseFloat(actualSum) > parseFloat(budgetSum)) {
	              style.color = 'red';
	            }
	            actualSum = _util2.default.numberFormat(actualSum, 2, '.', ',');
	            budgetSum = _util2.default.numberFormat(budgetSum, 2, '.', ',');
	            if (actualSum === '0.00' && budgetSum === '0.00') {
	              return _react2.default.createElement(
	                'span',
	                null,
	                '-'
	              );
	            }
	            if (actualSum === '0.00') {
	              return _react2.default.createElement(
	                'a',
	                { style: { color: 'gray' } },
	                budgetSum
	              );
	            }
	            if (budgetSum === '0.00') {
	              return _react2.default.createElement(
	                'a',
	                null,
	                actualSum
	              );
	            }
	            return _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                { style: style },
	                actualSum
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { margin: '0 5px' } },
	                '\u4E28'
	              ),
	              _react2.default.createElement(
	                'a',
	                { style: { color: 'gray' } },
	                budgetSum
	              )
	            );
	          }
	          var sum = 0;
	          // eslint-disable-next-line guard-for-in
	          Object.keys(record).forEach(function (key) {
	            var sumFlag = key !== 'type' && key !== 'children' && key !== 'parent' && key !== 'uuid' && key !== 'typeName' && key !== 'apportionFlag';
	            if (sumFlag) {
	              sum += parseFloat(record[key]);
	              sum = parseFloat(sum);
	            }
	          });
	          var sumFont = _util2.default.numberFormat(sum);
	          return _react2.default.createElement(
	            'span',
	            null,
	            sumFont
	          );
	        }
	      });
	      return columns;
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: false,
	      checkedMonth: month,
	      year: _localDb2.default.get('year') || date.getFullYear(),
	      initDate: _localDb2.default.get('date') ? [(0, _moment2.default)(_localDb2.default.get('date').beginDate), (0, _moment2.default)(_localDb2.default.get('date').endDate)] : [_moment2.default.unix(date.getTime() / 1000), _moment2.default.unix(date.getTime() / 1000)]
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.company = this.props.location.query.companyName;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var params = {};
	      var initDate = this.state.initDate;
	
	      params.beginDate = initDate[0];
	      params.endDate = initDate[1];
	      this.loadData(this.state.year);
	      this.len = 0;
	
	      var table = document.getElementsByClassName('ant-table-scroll')[0];
	      table.id = 'table-to-xls';
	    }
	
	    /**
	     * 获取预算统计列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          isLoading = _state.isLoading,
	          year = _state.year,
	          checkedMonth = _state.checkedMonth;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'statis-box' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-between' },
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(_BackBtn.BackBtn, null)
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { style: { textAlign: 'right' }, span: 12 },
	            _react2.default.createElement(
	              'div',
	              { style: { display: 'flex', justifyContent: 'flex-end' } },
	              _react2.default.createElement(
	                _antd.Checkbox,
	                {
	                  onChange: function onChange() {
	                    return _this2.handleAllChecked();
	                  },
	                  checked: checkedMonth.length === month.length,
	                  style: { marginTop: '10px' }
	                },
	                '\u5168\u9009'
	              ),
	              this.searchBar()
	            ),
	            _react2.default.createElement(_reactHtmlTableToExcel2.default, {
	              id: 'test-table-xls-button',
	              className: 'download-table-xls-button ant-btn',
	              table: 'table-to-xls',
	              filename: 'tablexls',
	              sheet: 'tablexls',
	              style: {
	                marginTop: '4px'
	              },
	              buttonText: '\u5BFC\u51FA'
	            })
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          id: 'table-to-xls',
	          columns: this.columns(),
	          dataSource: data,
	          loading: isLoading,
	          bordered: true,
	          rowKey: function rowKey(record) {
	            return record.uuid;
	          },
	          size: 'small',
	          title: function title() {
	            return _react2.default.createElement(
	              'p',
	              { style: { textAlign: 'Center' } },
	              _this2.company + '-' + year
	            );
	          },
	          scroll: { x: 3530, y: _util2.default.pageHeight() - 160 },
	          pagination: false
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    type: state.income_expend_type,
	    account_info: state.account_info
	  };
	})(_antd.Form.create()(Index));

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(5);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _finance = __webpack_require__(61);
	
	var _back_info = __webpack_require__(19);
	
	var _income_info = __webpack_require__(233);
	
	var _budget = __webpack_require__(30);
	
	var _ModalAdd = __webpack_require__(1616);
	
	var _ModalAdd2 = _interopRequireDefault(_ModalAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo) {
	      var params = {};
	      var context = _this;
	      var _this$state = _this.state,
	          pageSize = _this$state.pageSize,
	          condition = _this$state.condition,
	          tabKey = _this$state.tabKey;
	
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.type = tabKey;
	      params.limit = pageSize;
	      params.condition = condition || '';
	      params.start = current;
	
	      _this.setState({
	        pageNo: current,
	        isLoading: true
	      });
	
	      (0, _finance.queryFinanceBooksList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            isLoading: false,
	            total: res.totalSize,
	            company: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.search = function () {
	      _this.loadData(1);
	    };
	
	    _this.delete = function (uuid) {
	      var context = _this;
	      (0, _finance.queryDeleteFinanceBooks)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          context.loadData();
	          context.loadStatisticsData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.showModalAdd = function () {
	      _this.setState({
	        modalAddVisible: true
	      });
	    };
	
	    _this.handleCheckAmountErr = function () {
	      _this.setState({ checkErrorLoading: true });
	      (0, _finance.queryCheckBooksErr)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ checkErrorLoading: false });
	          _this.loadData();
	        }
	      });
	    };
	
	    _this.showModalEdit = function (uuid) {
	      _this.uuid = uuid;
	      _this.setState({
	        modalEditVisible: true
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        modalAddVisible: false,
	        modalEditVisible: false
	      });
	    };
	
	    _this.handAddSubmit = function (item) {
	      (0, _finance.querySaveFinanceBooks)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.loadData();
	          _this.loadStatisticsData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handEditSubmit = function (item) {
	      item.uuid = _this.uuid;
	      (0, _finance.querySaveFinanceBooks)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.loadData();
	          _this.loadStatisticsData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.setCondition = function (e) {
	      _this.setState({
	        condition: e.target.value
	      });
	    };
	
	    _this.handleEnable = function (uuid) {
	      (0, _budget.queryEnableCapitalGroup)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadData();
	          _this.loadStatisticsData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleDisable = function (uuid) {
	      (0, _budget.queryDisableCapitalGroup)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadData();
	          _this.loadStatisticsData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.callback = function (key) {
	      _this.setState({
	        tabKey: key
	      }, function () {
	        _this.loadData(1);
	        _this.loadStatisticsData();
	      });
	    };
	
	    _this.currentBalanceTitle = function () {
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u4F59\u989D\uFF08\u5143\uFF09',
	        _react2.default.createElement(
	          _antd.Tooltip,
	          { title: '\u9A8C\u8BC1\u516C\u5F0F:\u521D\u59CB\u8D44\u91D1+\u603B\u6536\u5165-\u603B\u652F\u51FA=\u5F53\u524D\u4F59\u989D' },
	          _react2.default.createElement(_antd.Icon, { type: 'info-circle', style: { fontSize: '10px' } })
	        )
	      );
	    };
	
	    _this.formatFloat = function (f) {
	      var m = Math.pow(10, 2);
	      return Math.round(f * m) / m;
	    };
	
	    _this.columns = function () {
	      var isFinancialM = _this.props.isFinancialM;
	      var pageSize = _this.state.pageSize;
	
	      return [{
	        title: '序号',
	        dataIndex: 'num',
	        key: 'num',
	        render: function render(text, record, index) {
	          var tot = pageSize * (_this.state.pageNo - 1) + index + 1;
	          return _react2.default.createElement(
	            'span',
	            null,
	            tot
	          );
	        }
	      }, {
	        title: '公司名称',
	        dataIndex: 'companyName',
	        key: 'companyName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/capital/' + record.uuid + '/detail' },
	            text
	          );
	        }
	      }, {
	        title: '账户名称',
	        dataIndex: 'bookName',
	        key: 'bookName'
	      }, {
	        title: '年初余额（元）',
	        dataIndex: 'initBalance',
	        key: 'initBalance',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: _this.currentBalanceTitle(),
	        dataIndex: 'currentBalance',
	        key: 'currentBalance',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'span',
	              null,
	              _util2.default.numberFormat(text, 2, '.', ',')
	            ),
	            record.isErr === 1 ? _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '!\u7EDF\u8BA1\u6709\u8BEF'
	            ) : ''
	          );
	        }
	      }, {
	        title: '摘要',
	        dataIndex: 'remark',
	        key: 'remark',
	        width: '25%'
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(text, record) {
	          if (isFinancialM) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              record.isEnable === 0 ? _react2.default.createElement(
	                _antd.Popconfirm,
	                {
	                  placement: 'leftTop',
	                  title: '\u786E\u5B9A\u542F\u7528\u6B64\u8D44\u91D1\u8D26\u6237\u5417\uFF1F',
	                  onConfirm: function onConfirm() {
	                    return _this.handleEnable(record.uuid);
	                  },
	                  okText: '\u786E\u5B9A',
	                  cancelText: '\u53D6\u6D88'
	                },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  '\u542F\u7528'
	                )
	              ) : _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _antd.Popconfirm,
	                  {
	                    placement: 'leftTop',
	                    title: '\u786E\u5B9A\u7981\u7528\u6B64\u8D44\u91D1\u8D26\u6237\u5417\uFF1F',
	                    onConfirm: function onConfirm() {
	                      return _this.handleDisable(record.uuid);
	                    },
	                    okText: '\u786E\u5B9A',
	                    cancelText: '\u53D6\u6D88'
	                  },
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    '\u7981\u7528'
	                  )
	                ),
	                _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/finance/capital/' + record.uuid + '/detail' },
	                  '\u8BE6\u60C5'
	                ),
	                _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return _this.showModalEdit(record.uuid);
	                    } },
	                  '\u7F16\u8F91'
	                ),
	                isFinancialM ? _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                  _react2.default.createElement(
	                    'a',
	                    { onClick: function onClick() {
	                        return _this.toYearStatic(record);
	                      } },
	                    '\u67E5\u770B\u7EDF\u8BA1'
	                  )
	                ) : null
	              )
	            );
	          }
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/capital/' + record.uuid + '/detail' },
	            '\u8BE6\u60C5'
	          );
	        }
	      }];
	    };
	
	    _this.toYearStatic = function (bookInfo) {
	      _this.props.router.push({
	        pathname: '/finance/statis/' + bookInfo.uuid + '/year',
	        query: {
	          companyName: bookInfo.companyName
	        }
	      });
	    };
	
	    _this.state = {
	      total: 0,
	      pageSize: 15,
	      available: 0,
	      currentTotal: 0,
	      financeTotle: 0,
	      staLoading: false,
	
	      company: [],
	      modalAddVisible: false,
	      modalEditVisible: false,
	
	      pageNo: 1,
	      tabKey: '0',
	      condition: '',
	
	      checkErrorLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _income_info.saveIncomeInfo)({
	        isShowPart: true,
	        // 2 是走账数据
	        isNonBusiness: false
	      }));
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var _props = this.props,
	          backInfo = _props.backInfo,
	          pathname = _props.location.pathname;
	
	      if (backInfo.path === pathname) {
	        this.setState({
	          pageNo: backInfo.pageNo,
	          tabKey: backInfo.tabKey,
	          condition: backInfo.condition
	        }, function () {
	          _this2.loadData();
	        });
	      } else {
	        this.loadData();
	      }
	      this.loadStatisticsData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          pageNo = _state.pageNo,
	          tabKey = _state.tabKey,
	          condition = _state.condition;
	
	      var params = {};
	
	      params.pageNo = pageNo;
	      params.tabKey = tabKey;
	      params.condition = condition;
	      params.path = this.props.location.pathname;
	
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'loadStatisticsData',
	    value: function loadStatisticsData() {
	      var context = this;
	      var tabKey = this.state.tabKey;
	
	      context.setState({
	        staLoading: true
	      });
	      (0, _finance.queryFinanceBooksListStatistics)({ type: tabKey }).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            available: res.data.available,
	            currentTotal: res.data.currentTotal,
	            financeTotle: res.data.financeTotle,
	            staLoading: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    }
	
	    /**
	     * 按条件搜索
	     */
	
	
	    /**
	     * 显示添加账户弹窗
	     */
	
	
	    /**
	     * 显示编辑账户弹窗
	     */
	
	
	    /**
	     * 新增账号
	     */
	
	
	    /**
	     * 编辑账号
	     */
	
	
	    /**
	     * 启用资金账户
	     */
	
	
	    /**
	     * 禁用资金账户
	     */
	
	
	    /**
	     * 跳转至按年统计详情页
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          total = _state2.total,
	          tabKey = _state2.tabKey,
	          pageNo = _state2.pageNo,
	          company = _state2.company,
	          pageSize = _state2.pageSize,
	          isLoading = _state2.isLoading,
	          staLoading = _state2.staLoading,
	          available = _state2.available,
	          currentTotal = _state2.currentTotal,
	          financeTotle = _state2.financeTotle;
	
	      var pagination = {
	        pageSize: pageSize,
	        total: total,
	        current: pageNo,
	        showSizeChanger: false,
	        onChange: function onChange(current) {
	          _this3.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      var isFinancialM = this.props.isFinancialM;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { minWidth: '800px' } },
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'space-between', style: { marginBottom: '16px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { style: { lineHeight: '32px' } },
	              isFinancialM ? _react2.default.createElement(
	                _antd.Button,
	                { icon: 'plus', style: { marginRight: '10px' }, onClick: this.showModalAdd },
	                '\u6DFB\u52A0'
	              ) : '',
	              isFinancialM ? _react2.default.createElement(
	                _antd.Button,
	                {
	                  style: { marginRight: '10px' },
	                  onClick: this.handleCheckAmountErr,
	                  loading: this.state.checkErrorLoading
	                },
	                '\u68C0\u67E5\u7EDF\u8BA1'
	              ) : '',
	              _react2.default.createElement(
	                'span',
	                null,
	                '\u94F6\u884C\u4F59\u989D:',
	                staLoading ? _react2.default.createElement(_antd.Spin, null) : _util2.default.numberFormat(currentTotal, 2, '.', ','),
	                '\u5143'
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { marginLeft: '10px' } },
	                '\u7406\u8D22\u6B3E\u4F59\u989D: ',
	                staLoading ? _react2.default.createElement(_antd.Spin, null) : _util2.default.numberFormat(financeTotle, 2, '.', ','),
	                '\u5143'
	              ),
	              _react2.default.createElement(
	                'span',
	                { style: { marginLeft: '10px' } },
	                '\u53EF\u7528\u4F59\u989D: ',
	                staLoading ? _react2.default.createElement(_antd.Spin, null) : _util2.default.numberFormat(available, 2, '.', ','),
	                '\u5143'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { style: { textAlign: 'right' } },
	              _react2.default.createElement(_antd.Input, {
	                placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57',
	                style: { width: '300px' },
	                value: this.state.condition,
	                onChange: this.setCondition
	              }),
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', style: { marginLeft: '10px' }, onClick: this.search },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _antd.Tabs,
	            { activeKey: tabKey, onChange: this.callback },
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u4F53\u7CFB\u5185', key: '0' },
	              _react2.default.createElement(_antd.Table, {
	                rowKey: function rowKey(record) {
	                  return record.uuid;
	                },
	                rowSelection: {},
	                columns: this.columns(),
	                dataSource: company,
	                pagination: pagination,
	                loading: isLoading
	              })
	            ),
	            isFinancialM ? _react2.default.createElement(
	              TabPane,
	              { tab: '\u4F53\u7CFB\u5916', key: '1' },
	              _react2.default.createElement(_antd.Table, {
	                rowKey: function rowKey(record) {
	                  return record.uuid;
	                },
	                rowSelection: {},
	                columns: this.columns(),
	                dataSource: company,
	                pagination: pagination,
	                loading: isLoading
	              })
	            ) : _react2.default.createElement(TabPane, { tab: '\u4F53\u7CFB\u5916', disable: true, key: '1' })
	          )
	        ),
	        this.state.modalAddVisible ? _react2.default.createElement(_ModalAdd2.default, { handSubmit: this.handAddSubmit, data: {}, cancel: this.hideModal }) : '',
	        this.state.modalEditVisible ? _react2.default.createElement(_ModalAdd2.default, {
	          handSubmit: this.handEditSubmit,
	          data: {},
	          uuid: this.uuid,
	          cancel: this.hideModal
	        }) : ''
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    isFinancialM: state.account_info.isFinancialM
	  };
	})(Index);

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _finance = __webpack_require__(61);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadioGroup = _antd.Radio.Group;
	
	var FormItem = _antd.Form.Item;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.loadCompany = function () {
	      var params = {};
	      (0, _org.queryAllCompany)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var options = [];
	          res.data.map(function (item) {
	            var optionItem = {};
	            optionItem.label = item.name;
	            optionItem.value = item.uuid;
	            optionItem.key = item.uuid;
	            options.push(optionItem);
	            return options;
	          });
	          _this.setState({
	            treeData: options
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.onLoadData = function (treeNode) {
	      var arr = [];
	      var key = treeNode.props.eventKey;
	      var params = {};
	      params.type = 1;
	      params.uuid = key.split('-')[key.split('-').length - 1];
	      return new Promise(function (resolve) {
	        (0, _org.queryCompany)(params).then(function (res) {
	          if (res.statusCode === 200) {
	            res.data.map(function (item) {
	              var optionItem = {};
	              optionItem.label = item.name;
	              optionItem.value = item.uuid;
	              optionItem.key = key + '-' + item.uuid;
	              arr.push(optionItem);
	              return arr;
	            });
	            var treeData = [].concat(_toConsumableArray(_this.state.treeData));
	            var loop = function loop(data) {
	              data.forEach(function (item) {
	                if (key.indexOf(item.key) === 0) {
	                  if (item.children) {
	                    resolve();
	                    loop(item.children);
	                  } else if (item.key === key) {
	                    if (arr.length > 0) {
	                      item.children = arr;
	                      _this.setState({ treeData: treeData }, function () {
	                        resolve();
	                      });
	                    } else if (arr.length === 0) {
	                      item.isLeaf = true;
	                      _this.setState({ treeData: treeData }, function () {
	                        resolve();
	                      });
	                    } else {
	                      resolve();
	                    }
	                  }
	                }
	              });
	            };
	            loop(treeData);
	          }
	        });
	      });
	    };
	
	    _this.handleCompany = function (e, option) {
	      _this.companyName = option[0];
	      _this.companyUuid = e;
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handSubmit = _this.props.handSubmit;
	
	      var capital = _this.props.form.getFieldsValue();
	      capital.companyName = _this.companyName || _this.state.content.companyName;
	      capital.companyUuid = _this.companyUuid || _this.state.content.companyUuid;
	      delete capital.company;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handSubmit(capital);
	        }
	      });
	    };
	
	    _this.setCompanyName = function (value, option) {
	      _this.companyName = option.props.children;
	      _this.companyUuid = value;
	    };
	
	    _this.loadDetail = function (uuid) {
	      (0, _finance.queryFinanceBooksInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            content: res.data
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      content: {},
	      treeData: []
	    };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.uuid;
	
	      this.loadCompany();
	      if (uuid) {
	        this.loadDetail(uuid);
	      }
	    }
	
	    /**
	     *获取组织列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	
	      var content = this.state.content;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u8D26\u6237\u9875\u9762', visible: true, onOk: this.submit, onCancel: this.props.cancel },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u516C\u53F8\u540D\u79F0' }, formItemLayout),
	            getFieldDecorator('company', {
	              rules: [{ required: true, message: '请输入公司名称' }],
	              initialValue: content.companyName
	            })(_react2.default.createElement(_antd.TreeSelect, {
	              treeData: this.state.treeData,
	              loadData: this.onLoadData,
	              dropdownStyle: {
	                maxHeight: '500px',
	                overflowY: 'scroll',
	                minHeight: '200px'
	              },
	              style: { width: '100%' },
	              onChange: this.handleCompany
	            }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u8D26\u6237\u540D\u79F0' }, formItemLayout),
	            getFieldDecorator('bookName', {
	              rules: [{ required: true, message: '请输入账户名称' }],
	              initialValue: content.bookName
	            })(_react2.default.createElement(_antd.Input, null))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u521D\u59CB\u8D44\u91D1' }, formItemLayout),
	            getFieldDecorator('init', {
	              initialValue: content.init || ''
	            })(_react2.default.createElement(_antd.Input, { addonAfter: '\u5143', type: 'number' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u662F\u5426\u662F\u4F53\u7CFB\u5185' }, formItemLayout),
	            getFieldDecorator('type', {
	              initialValue: content.type || 0
	            })(_react2.default.createElement(
	              RadioGroup,
	              { defaultValue: 0, value: content.type },
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: 0 },
	                '\u662F'
	              ),
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: 1 },
	                '\u5426'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u6458\u8981' }, formItemLayout),
	            getFieldDecorator('remark', {
	              initialValue: content.remark
	            })(_react2.default.createElement(_antd.Input, { type: 'textarea', rows: 4 }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(IndexModal);

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _finance = __webpack_require__(61);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FinanceCapitalDetail = function (_Component) {
	  _inherits(FinanceCapitalDetail, _Component);
	
	  function FinanceCapitalDetail(props) {
	    _classCallCheck(this, FinanceCapitalDetail);
	
	    var _this = _possibleConstructorReturn(this, (FinanceCapitalDetail.__proto__ || Object.getPrototypeOf(FinanceCapitalDetail)).call(this, props));
	
	    _this.loadStatistics = function (uuid) {
	      var handlerFlag = _this.props.handlerFlag;
	
	      (0, _finance.queryFinanceBooksPayStatistics)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ statistics: res.data });
	          handlerFlag();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      statistics: {}
	    };
	    return _this;
	  }
	
	  _createClass(FinanceCapitalDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadStatistics();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var reStatistic = nextProps.reStatistic;
	
	      if (reStatistic) {
	        this.loadStatistics();
	      }
	    }
	
	    /**
	     * 获取账号统计
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var statistics = this.state.statistics;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        { className: 'description' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-around', align: 'middle' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u8D70\u8D26\u652F\u51FA:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.expenditure
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u8D70\u8D26\u6536\u5165:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _util2.default.numberFormat(statistics.income, 2, '.', ',')
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u603B\u8BA1:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.sum
	              ),
	              '\u5143'
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u603B\u6570:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.count
	              ),
	              '\u7B14'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FinanceCapitalDetail;
	}(_react.Component);
	
	exports.default = FinanceCapitalDetail;

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _finance = __webpack_require__(61);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CardStatic = function (_Component) {
	  _inherits(CardStatic, _Component);
	
	  function CardStatic(props) {
	    _classCallCheck(this, CardStatic);
	
	    var _this = _possibleConstructorReturn(this, (CardStatic.__proto__ || Object.getPrototypeOf(CardStatic)).call(this, props));
	
	    _this.loadStatistics = function (uuid, beginDate, endDate) {
	      _this.setState({ loading: true });
	      (0, _finance.queryFinanceBooksStatistics)({
	        uuid: uuid,
	        beginDate: beginDate ? (0, _moment2.default)(beginDate).format('YYYY-MM-DD') : '',
	        endDate: endDate ? (0, _moment2.default)(endDate).format('YYYY-MM-DD') : ''
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ statistics: res.data, loading: false });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      statistics: {},
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(CardStatic, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          uuid = _props.uuid,
	          beginDate = _props.beginDate,
	          endDate = _props.endDate;
	
	      this.loadStatistics(uuid, beginDate, endDate);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var changeFlag = nextProps.changeFlag;
	
	      if (changeFlag !== this.props.changeFlag) {
	        this.loadStatistics(nextProps.uuid, nextProps.beginDate, nextProps.endDate);
	      }
	    }
	
	    /**
	     * 获取账号统计
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          statistics = _state.statistics,
	          loading = _state.loading;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        { className: 'description' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-around', align: 'middle' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u8D26\u6237\u540D\u79F0:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                loading ? _react2.default.createElement(_antd.Spin, null) : statistics.accountName
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u6240\u5C5E\u516C\u53F8:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                loading ? _react2.default.createElement(_antd.Spin, null) : statistics.companyName
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u603B\u6536\u5165:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _antd.Popover,
	                  {
	                    title: '\u603B\u6536\u5165=\u975E\u8D70\u8D26\u6536\u5165+\u8D70\u8D26\u6536\u5165',
	                    content: _util2.default.numberFormat(statistics.incomeSum) + '=' + _util2.default.numberFormat(statistics.incomeSumIgnoreNo) + '+' + _util2.default.numberFormat(statistics.incomeSumIgnore)
	                  },
	                  loading ? _react2.default.createElement(_antd.Spin, null) : _util2.default.numberFormat(statistics.incomeSum, 2, '.', ',')
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u603B\u652F\u51FA:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _antd.Popover,
	                  {
	                    title: '\u603B\u652F\u51FA=\u975E\u8D70\u8D26\u652F\u51FA+\u8D70\u8D26\u652F\u51FA',
	                    content: _util2.default.numberFormat(statistics.expenditureSum) + '=' + _util2.default.numberFormat(statistics.expenditureSumIgnoreNo) + '+' + _util2.default.numberFormat(statistics.expenditureSumIgnore)
	                  },
	                  loading ? _react2.default.createElement(_antd.Spin, null) : _util2.default.numberFormat(statistics.expenditureSum, 2, '.', ',')
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u6536\u5165\u6B3E\u9879:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _antd.Popover,
	                  {
	                    title: '\u6536\u5165\u6B3E\u9879=\u975E\u8D70\u8D26\u6536\u5165\u6570+\u8D70\u8D26\u6536\u5165\u6570',
	                    content: statistics.incomeCount + '=' + statistics.incomeCountIgnoreNo + '+' + statistics.incomeCountIgnore
	                  },
	                  loading ? _react2.default.createElement(_antd.Spin, null) : statistics.incomeCount,
	                  '\u7B14'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u652F\u51FA\u6B3E\u9879:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _antd.Popover,
	                  {
	                    title: '\u652F\u51FA\u6B3E\u9879=\u975E\u8D70\u8D26\u652F\u51FA\u6570+\u8D70\u8D26\u652F\u51FA\u6570',
	                    content: statistics.expenditureCount + '=' + statistics.expenditureCountIgnoreNo + '+' + statistics.expenditureCountIgnore
	                  },
	                  loading ? _react2.default.createElement(_antd.Spin, null) : statistics.expenditureCount,
	                  '\u7B14'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u8D26\u6237\u4F59\u989D:'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                loading ? _react2.default.createElement(_antd.Spin, null) : _util2.default.numberFormat(statistics.currentBalance, 2, '.', ',')
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CardStatic;
	}(_react.Component);
	
	exports.default = CardStatic;

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _finance = __webpack_require__(61);
	
	var _getAllType = __webpack_require__(168);
	
	var _getAllType2 = _interopRequireDefault(_getAllType);
	
	var _BackBtn = __webpack_require__(12);
	
	var _CardStatic = __webpack_require__(1618);
	
	var _CardStatic2 = _interopRequireDefault(_CardStatic);
	
	var _ModalDetail = __webpack_require__(699);
	
	var _ModalDetail2 = _interopRequireDefault(_ModalDetail);
	
	var _ModalRemove = __webpack_require__(1621);
	
	var _ModalRemove2 = _interopRequireDefault(_ModalRemove);
	
	var _CardPayStatistic = __webpack_require__(1617);
	
	var _CardPayStatistic2 = _interopRequireDefault(_CardPayStatistic);
	
	var _ModalImportExcel = __webpack_require__(1620);
	
	var _ModalImportExcel2 = _interopRequireDefault(_ModalImportExcel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var confirm = _antd.Modal.confirm;
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var FinanceCapitalDetail = function (_Component) {
	  _inherits(FinanceCapitalDetail, _Component);
	
	  function FinanceCapitalDetail(props) {
	    _classCallCheck(this, FinanceCapitalDetail);
	
	    var _this2 = _possibleConstructorReturn(this, (FinanceCapitalDetail.__proto__ || Object.getPrototypeOf(FinanceCapitalDetail)).call(this, props));
	
	    _this2.loadBooksIncomeList = function (pageNo) {
	      var params = {};
	      var _this2$state = _this2.state,
	          pageSize = _this2$state.pageSize,
	          beginDate = _this2$state.beginDate,
	          endDate = _this2$state.endDate;
	      var uuid = _this2.props.params.uuid;
	
	      if (uuid !== undefined) {
	        params.bookUuid = uuid;
	      }
	      params.condition = _this2.state.condition;
	      var no = _this2.state.pageNo;
	      var current = pageNo || no;
	      params.limit = pageSize;
	      params.start = current;
	      beginDate && (params.beginDate = beginDate.format('YYYY-MM-DD'));
	      endDate && (params.endDate = endDate.format('YYYY-MM-DD'));
	      _this2.setState({
	        pageNo: current
	      });
	      if (_this2.state.source === 'statis') {
	        var _this2$props$income_i = _this2.props.income_info,
	            ignoreLevel = _this2$props$income_i.ignoreLevel,
	            ignoreFlag = _this2$props$income_i.ignoreFlag,
	            types = _this2$props$income_i.types;
	
	        if (ignoreLevel) {
	          params.ignoreLevel = ignoreLevel;
	        }
	        if (ignoreFlag) {
	          params.ignoreFlag = ignoreFlag;
	        }
	        if (types !== undefined) {
	          params.types = types;
	        }
	
	        if (_this2.props.income_info.yearMonth) {
	          params.yearMonth = _this2.props.income_info.yearMonth;
	        } else if (_this2.props.income_info.date) {
	          params.beginDate = (0, _moment2.default)(_this2.props.income_info.date[0]).format('YYYY-MM-DD');
	          params.endDate = (0, _moment2.default)(_this2.props.income_info.date[1]).format('YYYY-MM-DD');
	        }
	      }
	      var isNonBusiness = _this2.props.income_info.isNonBusiness;
	
	
	      _this2.setState({
	        loading: true
	      });
	      if (isNonBusiness) {
	        (0, _finance.queryNonBusinessIncomeList)(params).then(function (res) {
	          if (res.statusCode === 200) {
	            _this2.setState({
	              loading: false,
	              reStatistic: true,
	              record: res.data,
	              total: res.totalSize
	            });
	          }
	        });
	      } else {
	        (0, _finance.queryBooksIncomeList)(params).then(function (res) {
	          if (res.statusCode === 200) {
	            _this2.setState({
	              loading: false,
	              record: res.data,
	              total: res.totalSize
	            });
	          }
	        });
	      }
	    };
	
	    _this2.onShowSizeChange = function (current, pageSize) {
	      _this2.setState({ pageSize: pageSize }, function () {
	        _this2.loadBooksIncomeList(1);
	      });
	    };
	
	    _this2.getBooksIncomeRemoveList = function (current) {
	      var params = {};
	      params.bookUuid = _this2.props.params.uuid;
	      params.limit = 10;
	      params.start = current;
	      (0, _finance.queryBooksIncomeRemoveList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            removeList: res.data,
	            removePagination: {
	              current: current,
	              pageSize: 10,
	              total: res.totalSize
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.handlerFlag = function () {
	      _this2.setState({ reStatistic: false });
	    };
	
	    _this2.handleSelect = function (selectedRowKeys) {
	      _this2.setState({
	        selectedRowKeys: selectedRowKeys
	      });
	    };
	
	    _this2.showConfirm = function () {
	      var _this = _this2;
	      confirm({
	        title: '确定删除选中的流水吗?',
	        onOk: function onOk() {
	          _this.deleteRecords();
	        },
	        onCancel: function onCancel() {}
	      });
	    };
	
	    _this2.deleteRecords = function () {
	      var _this2$state2 = _this2.state,
	          selectedRowKeys = _this2$state2.selectedRowKeys,
	          changeFlag = _this2$state2.changeFlag;
	
	      _this2.setState({
	        deleteLoading: true
	      });
	      (0, _finance.queryDeleteBooksIncomes)({ uuids: selectedRowKeys }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this2.loadBooksIncomeList(1);
	          _this2.getBooksIncomeRemoveList(1);
	          _this2.setState({ changeFlag: changeFlag + 1, deleteLoading: false });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.onRangePickerChange = function (date) {
	      _this2.setState({
	        beginDate: date[0],
	        endDate: date[1]
	      });
	    };
	
	    _this2.setCondition = function (e) {
	      _this2.setState({
	        condition: e.target.value
	      });
	    };
	
	    _this2.search = function (condition) {
	      _this2.condition = condition;
	      _this2.loadBooksIncomeList(1);
	    };
	
	    _this2.showModal = function (uuid) {
	      _this2.setState({
	        visible: true,
	        uuid: uuid
	      });
	    };
	
	    _this2.showImport = function () {
	      _this2.setState({ importVisible: true });
	    };
	
	    _this2.showRemove = function () {
	      _this2.setState({ removeVisible: true });
	    };
	
	    _this2.handleCancel = function () {
	      _this2.setState({
	        visible: false,
	        importVisible: false,
	        removeVisible: false
	      });
	    };
	
	    _this2.handleSubmit = function (result) {
	      if (result) {
	        _this2.handleCancel();
	        _this2.loadBooksIncomeList();
	      }
	    };
	
	    _this2.columns = function () {
	      var _this2$state3 = _this2.state,
	          type = _this2$state3.type,
	          source = _this2$state3.source;
	      var isNonBusiness = _this2.props.income_info.isNonBusiness;
	
	      var config = [{
	        title: '日期',
	        dataIndex: 'date',
	        key: 'date',
	        width: 250,
	        render: function render(text, record) {
	          var ignoreName = void 0;
	          switch (record.ignore) {
	            case 0:
	              ignoreName = '';
	              break;
	            case 1:
	              ignoreName = '(非业务数据)';
	              break;
	            case 2:
	              ignoreName = '(走账数据)';
	              break;
	            default:
	              ignoreName = '';
	              break;
	          }
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this2.showModal(record.uuid);
	              } },
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD'),
	            ' ',
	            ignoreName
	          );
	        }
	      }, {
	        title: '对方户名',
	        dataIndex: 'accountName',
	        key: 'accountName',
	        width: 200
	      }, {
	        title: '摘要',
	        dataIndex: 'remark',
	        key: 'remark',
	        width: 200
	      }, {
	        title: '收支类型',
	        dataIndex: 'type',
	        key: 'type',
	        width: 200,
	        render: function render(text) {
	          var typeName = '';
	          if (type.length > 0) {
	            type.forEach(function (item) {
	              if (text === item.value) {
	                typeName = item.key;
	                return typeName;
	              }
	            });
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            typeName
	          );
	        }
	      }, {
	        title: '收入(元)',
	        dataIndex: 'money',
	        key: 'money',
	        width: 200,
	        render: function render(text, record) {
	          if (record.target === 1) return _react2.default.createElement(
	            'a',
	            { style: { color: 'green' } },
	            text === 0 ? '' : _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '支出(元)',
	        dataIndex: 'payMoney',
	        key: 'payMoney',
	        width: 200,
	        render: function render(text, record) {
	          if (record.target === 0) return _react2.default.createElement(
	            'a',
	            { style: { color: 'red' } },
	            text === 0 ? '' : _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '当前余额(元)',
	        dataIndex: 'current',
	        key: 'current',
	        width: 200,
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              null,
	              text === 0 ? '' : _util2.default.numberFormat(text, 2, '.', ',')
	            ),
	            source === 'capital' && !isNonBusiness && !record.isReal ? _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '(\u51FA\u9519)'
	            ) : ''
	          );
	        }
	      }];
	
	      return config;
	    };
	
	    _this2.state = {
	      type: [],
	      source: 'capital',
	      reStatistic: false,
	      scrollY: _util2.default.pageHeight() - 310,
	
	      pageNo: 1,
	      pageSize: 20,
	
	      endDate: null,
	      beginDate: null,
	      condition: '',
	
	      uuid: '',
	      loading: false,
	      visible: false,
	      importVisible: false,
	      removeVisible: false,
	
	      record: [],
	      removeList: [],
	      selectedRowKeys: [],
	      removePagination: {},
	
	      changeFlag: 1,
	      deleteLoading: false
	    };
	    return _this2;
	  }
	
	  _createClass(FinanceCapitalDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      (0, _getAllType2.default)().then(function (res) {
	        _this3.setState({ type: res });
	      });
	
	      var isNonBusiness = this.props.income_info.isNonBusiness;
	
	      if (this.props.location.pathname.indexOf('statis') > 0) {
	        this.setState({
	          scrollY: _util2.default.pageHeight() - 210,
	          source: 'statis'
	        });
	      }
	
	      if (isNonBusiness) {
	        this.setState({
	          scrollY: _util2.default.pageHeight() - 270
	        });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var isFinancialM = this.props.isFinancialM;
	
	      this.loadBooksIncomeList(1);
	      isFinancialM && this.getBooksIncomeRemoveList(1);
	    }
	
	    // 获取流水记录列表
	
	
	    // 选择分页改变
	
	
	    // 获取回收箱列表
	
	
	    // 之前留下的,我也不知道是干啥的
	
	
	    /** ---------------------------------------流水删除start-------------------------------------*/
	    // 复选框选中
	
	
	    // 删除确认弹窗
	
	
	    // 删除接口
	
	
	    /** ---------------------------------------流水删除end---------------------------------------*/
	
	    /** ---------------------------------------搜索start-----------------------------------------*/
	    // 记录日期
	
	
	    // 记录文字
	
	    /** ---------------------------------------搜索end-------------------------------------------*/
	
	    /** ---------------------------------------弹窗start-----------------------------------------*/
	
	
	    // 导入弹窗
	
	
	    // 回收箱弹窗
	
	
	    // 关闭所有弹窗
	
	
	    // 弹窗提交后
	
	    /** ---------------------------------------弹窗end-------------------------------------------*/
	
	    // 返回按钮
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state = this.state,
	          source = _state.source,
	          scrollY = _state.scrollY,
	          changeFlag = _state.changeFlag,
	          reStatistic = _state.reStatistic,
	          deleteLoading = _state.deleteLoading,
	          record = _state.record,
	          loading = _state.loading,
	          removeList = _state.removeList,
	          removeVisible = _state.removeVisible,
	          removePagination = _state.removePagination,
	          beginDate = _state.beginDate,
	          endDate = _state.endDate;
	      var _props = this.props,
	          isFinancialM = _props.isFinancialM,
	          isNonBusiness = _props.income_info.isNonBusiness;
	
	
	      var pagination = {
	        defaultPageSize: 20,
	        showSizeChanger: true,
	        total: this.state.total,
	        current: this.state.pageNo,
	        onShowSizeChange: this.onShowSizeChange,
	        pageSizeOptions: [20, 50, 100, 200, 500, 1000, 2000, 5000],
	        onChange: function onChange(current) {
	          _this4.loadBooksIncomeList(current);
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _antd.Row,
	              { type: 'flex', justify: 'space-between', style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(_BackBtn.BackBtn, null),
	                source === 'statis' || !isFinancialM ? '' : _react2.default.createElement(
	                  _antd.Button,
	                  { icon: 'import', style: { marginLeft: '10px' }, onClick: this.showImport },
	                  '\u5BFC\u5165'
	                ),
	                isFinancialM ? _react2.default.createElement(
	                  _antd.Button,
	                  {
	                    icon: 'delete',
	                    loading: deleteLoading,
	                    onClick: this.showConfirm,
	                    style: { marginLeft: '10px' }
	                  },
	                  '\u5220\u9664'
	                ) : '',
	                isFinancialM ? _react2.default.createElement(
	                  _antd.Button,
	                  {
	                    icon: 'delete',
	                    style: { marginLeft: '10px' },
	                    onClick: function onClick() {
	                      return _this4.showRemove(true);
	                    }
	                  },
	                  '\u56DE\u6536\u7BB1'
	                ) : ''
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                source === 'statis' ? '' : _react2.default.createElement(RangePicker, {
	                  format: 'YYYY-MM-DD',
	                  onChange: this.onRangePickerChange,
	                  style: { marginRight: '10px', verticalAlign: 'bottom' }
	                }),
	                _react2.default.createElement(_antd.Input, {
	                  placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57',
	                  style: { width: '300px' },
	                  value: this.state.condition,
	                  onChange: this.setCondition
	                }),
	                _react2.default.createElement(
	                  _antd.Button,
	                  {
	                    type: 'primary',
	                    style: { marginLeft: '10px' },
	                    onClick: function onClick() {
	                      _this4.loadBooksIncomeList(1);
	                      _this4.setState({ changeFlag: changeFlag + 1 });
	                    }
	                  },
	                  '\u641C\u7D22'
	                )
	              )
	            )
	          ),
	          source === 'statis' ? '' : _react2.default.createElement(_CardStatic2.default, {
	            uuid: this.props.params.uuid,
	            beginDate: beginDate,
	            endDate: endDate,
	            changeFlag: changeFlag
	          }),
	          isNonBusiness ? _react2.default.createElement(_CardPayStatistic2.default, { reStatistic: reStatistic, handlerFlag: this.handlerFlag }) : ''
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          loading: loading,
	          rowSelection: {
	            onChange: this.handleSelect
	          },
	          dataSource: record,
	          scroll: { y: scrollY },
	          pagination: pagination,
	          columns: this.columns(),
	          rowClassName: function rowClassName(row) {
	            if (row.ignore === 1) {
	              return 'table-ignore-1';
	            }
	            if (row.ignore === 2) {
	              return 'table-ignore-2';
	            }
	          }
	        }),
	        this.state.visible && isFinancialM ? _react2.default.createElement(_ModalDetail2.default, {
	          ref: function ref(form) {
	            _this4.form = form;
	          },
	          uuid: this.state.uuid,
	          cancel: this.handleCancel,
	          handleSubmit: this.handleSubmit
	        }) : '',
	        this.state.importVisible ? _react2.default.createElement(_ModalImportExcel2.default, {
	          ref: function ref(form) {
	            _this4.form = form;
	          },
	          uuid: this.props.params.uuid,
	          cancel: this.handleCancel,
	          handleSubmit: this.handleSubmit
	        }) : '',
	        _react2.default.createElement(_ModalRemove2.default, {
	          data: removeList,
	          visible: removeVisible,
	          pagination: removePagination,
	          onChange: this.getBooksIncomeRemoveList,
	          onCancel: this.handleCancel
	        })
	      );
	    }
	  }]);
	
	  return FinanceCapitalDetail;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    isFinancialM: state.account_info.isFinancialM,
	    account_info: state.account_info,
	    income_info: state.income_info
	  };
	})(FinanceCapitalDetail);

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _finance = __webpack_require__(61);
	
	var _base = __webpack_require__(328);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var DetailModal = function (_Component) {
	  _inherits(DetailModal, _Component);
	
	  function DetailModal(props) {
	    _classCallCheck(this, DetailModal);
	
	    var _this = _possibleConstructorReturn(this, (DetailModal.__proto__ || Object.getPrototypeOf(DetailModal)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var income = _this.props.form.getFieldsValue();
	
	      var obj = Object.assign(_this.state.content, income);
	      if (_this.state.licenseFile && _this.state.licenseFile.length > 0) {
	        obj.fileUuid = _this.state.licenseFile[0].uuid;
	      }
	      obj.bookUuid = _this.props.uuid;
	      var handleSubmit = _this.props.handleSubmit;
	
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          _this.setState({ loading: true });
	          (0, _finance.queryImportBooksIncome)(obj).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              handleSubmit(obj);
	            } else if (res.statusCode === 250) {
	              _antd.message.warn(res.message);
	            } else {
	              _antd.message.error(res.message);
	            }
	            _this.setState({ loading: false });
	          });
	        }
	      });
	    };
	
	    _this.handlelicenseFile = function (fileList) {
	      _this.setState({
	        licenseFile: fileList
	      });
	    };
	
	    _this.state = {
	      content: {},
	      loading: false
	    };
	    return _this;
	  }
	
	  _createClass(DetailModal, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	
	      var licenseFile = this.state.licenseFile || [];
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u5BFC\u5165',
	          visible: true,
	          onCancel: this.props.cancel,
	          onOk: this.submit,
	          footer: [_react2.default.createElement(
	            _antd.Button,
	            { key: 'back', onClick: this.props.cancel },
	            '\u53D6\u6D88'
	          ), _react2.default.createElement(
	            _antd.Button,
	            { key: 'submit', type: 'primary', loading: this.state.loading, onClick: this.submit },
	            '\u786E\u5B9A'
	          )]
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'horizontal' },
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u8BF7\u9009\u62E9\u5F00\u6237\u94F6\u884C' }, formItemLayout),
	            getFieldDecorator('bookType', {
	              rules: [{ required: true, message: '请选择收支类型' }]
	            })(_react2.default.createElement(
	              _antd.Select,
	              null,
	              _base2.default.bookType.map(function (item) {
	                return _react2.default.createElement(
	                  Option,
	                  { key: item.key, value: item.key },
	                  item.name
	                );
	              })
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u4E0A\u4F20Excel\u6587\u4EF6' }, formItemLayout, { required: true }),
	            _react2.default.createElement(_UploadFile2.default, {
	              type: 'ghost',
	              handleUpload: this.handlelicenseFile,
	              fileList: licenseFile,
	              isExcel: true
	            }),
	            _react2.default.createElement(
	              'span',
	              { className: 'ant-form-text' },
	              '\xA0\u4EC5\u9650excel\u683C\u5F0F'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DetailModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(DetailModal);

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _getAllType = __webpack_require__(168);
	
	var _getAllType2 = _interopRequireDefault(_getAllType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalRecycle = function (_Component) {
	  _inherits(ModalRecycle, _Component);
	
	  function ModalRecycle(props) {
	    _classCallCheck(this, ModalRecycle);
	
	    var _this = _possibleConstructorReturn(this, (ModalRecycle.__proto__ || Object.getPrototypeOf(ModalRecycle)).call(this, props));
	
	    _this.handleTableChange = function (pagination) {
	      _this.props.onChange(pagination.current);
	    };
	
	    _this.columns = function () {
	      var type = _this.state.type;
	
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        key: 'date',
	        width: 250,
	        render: function render(text, record) {
	          var ignoreName = void 0;
	          switch (record.ignore) {
	            case 0:
	              ignoreName = '';
	              break;
	            case 1:
	              ignoreName = '(非业务数据)';
	              break;
	            case 2:
	              ignoreName = '(走账数据)';
	              break;
	            default:
	              ignoreName = '';
	              break;
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD'),
	            ' ',
	            ignoreName
	          );
	        }
	      }, {
	        title: '对方户名',
	        dataIndex: 'accountName',
	        key: 'accountName',
	        width: 200
	      }, {
	        title: '摘要',
	        dataIndex: 'remark',
	        key: 'remark',
	        width: 200
	      }, {
	        title: '收支类型',
	        dataIndex: 'type',
	        key: 'type',
	        width: 200,
	        render: function render(text) {
	          var typeName = '';
	          if (type.length > 0) {
	            type.forEach(function (item) {
	              if (text === item.value) {
	                typeName = item.key;
	                return typeName;
	              }
	            });
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            typeName
	          );
	        }
	      }, {
	        title: '收入(元)',
	        dataIndex: 'money',
	        key: 'money',
	        width: 200,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'a',
	            { style: { color: 'green' } },
	            text === 0 ? '' : _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '支出(元)',
	        dataIndex: 'payMoney',
	        key: 'payMoney',
	        width: 200,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'a',
	            { style: { color: 'red' } },
	            text === 0 ? '' : _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '当前余额(元)',
	        dataIndex: 'current',
	        key: 'current',
	        width: 200,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 0 ? '' : _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ModalRecycle, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      (0, _getAllType2.default)().then(function (res) {
	        _this2.setState({
	          type: res
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          visible = _props.visible,
	          pagination = _props.pagination;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u56DE\u6536\u7BB1',
	          footer: null,
	          visible: visible,
	          onCancel: this.props.onCancel,
	          width: '80%'
	        },
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          dataSource: data,
	          pagination: pagination,
	          columns: this.columns(),
	          onChange: this.handleTableChange
	        })
	      );
	    }
	  }]);
	
	  return ModalRecycle;
	}(_react.Component);
	
	exports.default = ModalRecycle;

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _ModalApportionShow = __webpack_require__(428);
	
	var _ModalApportionShow2 = _interopRequireDefault(_ModalApportionShow);
	
	var _attachment = __webpack_require__(27);
	
	__webpack_require__(36);
	
	var _budget = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var budgetType = ['部门预算', '跨部门预算', '项目预算组'];
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.findTypeName = function (type) {
	      var typeName = '';
	      _this.props.expendType.forEach(function (item) {
	        if (type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.getBudgetGroupCandF = function (value) {
	      (0, _budget.queryBudgetGroupCandF)({
	        type: value,
	        userUuid: _this.state.dataItem.createUser
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            groupTip: res.data
	          });
	        }
	      });
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.state = {
	      visible: false,
	      dataItem: _this.props.data,
	      groupTip: {}
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataItem = this.props.data;
	      !(+dataItem.budgetType === 1 || dataItem.instance && dataItem.instance.status === 1) && this.getBudgetGroupCandF(dataItem.type);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataItem: nextProps.data
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          visible = _state.visible,
	          dataItem = _state.dataItem,
	          groupTip = _state.groupTip;
	
	      var files = dataItem.files || [];
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u62A5\u9500\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u62A5\u9500\u7C7B\u578B' },
	              this.findTypeName(dataItem.type),
	              _react2.default.createElement(
	                'span',
	                { className: 'lowspan' },
	                groupTip && groupTip.groupName ? _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red' } },
	                  '\u8BE5\u8D39\u7528\u7C7B\u578B,',
	                  groupTip.groupName,
	                  '\u53EF\u7528\u4F59\u989D',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    groupTip.current || 0
	                  ),
	                  '\u5143',
	                  groupTip.freeze ? _react2.default.createElement(
	                    'span',
	                    null,
	                    ', \u51BB\u7ED3',
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      groupTip.freeze || 0
	                    )
	                  ) : null
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u62A5\u9500\u91D1\u989D' },
	              dataItem.price,
	              '\u5143'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7533\u8BF7\u4EBA\u5458' },
	              dataItem.createUserName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u6765\u6E90' },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.handleVisible(true);
	                  } },
	                budgetType[dataItem.budgetType]
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u62A5\u9500\u516C\u53F8' },
	              dataItem.company
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u62A5\u9500\u51ED\u8BC1' },
	              _react2.default.createElement(
	                'div',
	                null,
	                files.map(function (item) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: item.url },
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: function onClick() {
	                          return (0, _attachment.queryFilePreview)(item);
	                        } },
	                      ' ',
	                      item.name
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u62A5\u9500\u8BF4\u660E' },
	              dataItem.reason
	            )
	          )
	        ),
	        visible ? _react2.default.createElement(_ModalApportionShow2.default, {
	          onCancel: this.handleVisible,
	          dataInfo: {},
	          dataItem: dataItem,
	          visible: visible,
	          onOk: this.handleOk
	        }) : null
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(Open);

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _company_list = __webpack_require__(96);
	
	var _expend_type = __webpack_require__(80);
	
	var _recoup = __webpack_require__(133);
	
	var _FormBase = __webpack_require__(700);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      delete item.apportionType;
	      _this.saveRecoup(item);
	    };
	
	    _this.recoupWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _recoup.queryRecoupWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveRecoup = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _recoup.querySaveRecoup)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.recoupWorkflow();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	      dispatch((0, _company_list.getCompanyList)());
	    }
	
	    /**
	     * 提交报销
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, { data: dataInfo, handSubmit: this.handSubmit, isSubmitting: isSubmitting }),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance })
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(Page);

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _recoup = __webpack_require__(133);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableStaticOrg = __webpack_require__(702);
	
	var _TableStaticOrg2 = _interopRequireDefault(_TableStaticOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getRecoupOrgStatic = function (params) {
	      (0, _recoup.queryRecoupOrgStatic)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getRecoupOrgStatic(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableStaticOrg2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _reactRouter = __webpack_require__(8);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _recoup = __webpack_require__(133);
	
	var _FormBase = __webpack_require__(700);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveRecoup(item);
	    };
	
	    _this.recoupWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _recoup.queryRecoupWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveRecoup = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _recoup.querySaveRecoup)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.deleteRecoup = function () {
	      (0, _recoup.queryDeleteRecoup)({
	        uuid: _this.props.data.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.recoupWorkflow();
	    }
	
	    /**
	     * 提交报销
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, Object.assign({
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          handleDelete: this.deleteRecoup,
	          isSubmitting: isSubmitting
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _recoup = __webpack_require__(133);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableStaticOrg = __webpack_require__(702);
	
	var _TableStaticOrg2 = _interopRequireDefault(_TableStaticOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getRecoupIncubatorStatic = function (params) {
	      (0, _recoup.queryRecoupIncubatorStatic)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getRecoupIncubatorStatic(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableStaticOrg2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _expend_type = __webpack_require__(80);
	
	var _company_list = __webpack_require__(96);
	
	var _recoup = __webpack_require__(133);
	
	var _PageEdit = __webpack_require__(1625);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1629);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getRecoupInfo = function () {
	      (0, _recoup.queryRecoupInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getRecoupInfo();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	      dispatch((0, _company_list.getCompanyList)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(PageInfo);

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _recoup = __webpack_require__(133);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(701);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getRecoupMyList = function (params) {
	      _this.setState({ loading: true });
	      (0, _recoup.queryRecoupMyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getRecoupMyList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataSource = _state.dataSource,
	          loading = _state.loading;
	
	      var parentProps = {
	        dataSource: dataSource,
	        type: 'mine',
	        loading: loading,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/e_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u62A5\u9500'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _WorkflowOp = __webpack_require__(134);
	
	var _WorkflowOp2 = _interopRequireDefault(_WorkflowOp);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _recoup = __webpack_require__(133);
	
	var _FormOpen = __webpack_require__(1622);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.doTask = function (pass, refuse) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackRecoup(item);
	          break;
	        case 'next':
	          _this.nextRecoup(item);
	          break;
	        case 'return':
	          _this.returnRecoup(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackRecoup = function (params) {
	      (0, _recoup.queryCallbackRecoup)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextRecoup = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _recoup.queryNextRecoup)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnRecoup = function (params, refuse) {
	      (0, _recoup.queryReturnRecoup)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null
	          );
	        }
	      }, {
	        title: '操作内容',
	        dataIndex: 'operating'
	      }, {
	        title: '处理意见',
	        dataIndex: 'refuse'
	      }];
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ dataInfo: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowOp2.default, {
	          data: dataInfo,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_FormOpen2.default, Object.assign({ data: dataInfo, doTask: this.doTask, watchTask: this.watchTask }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'recoup', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _recoup = __webpack_require__(133);
	
	var _TableExpenses = __webpack_require__(701);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getRecoupList = function (params) {
	      _this.setState({ loading: true });
	      (0, _recoup.queryRecoupList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getRecoupList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataSource = _state.dataSource,
	          loading = _state.loading;
	
	      var parentProps = {
	        dataSource: dataSource,
	        loading: loading,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(36);
	
	var _recoup = __webpack_require__(133);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.getRecoupOrgRecord = function (params) {
	      (0, _recoup.queryRecoupOrgRecord)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataSource: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 15
	              }
	            }
	          });
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.loadData = function () {
	      var condition = _this.state.condition;
	
	      var params = Object.assign({
	        companyUuid: _this.props.org.companyUuid,
	        condition: condition
	      }, _this.pagination);
	      _this.getRecoupOrgRecord(params);
	    };
	
	    _this.onChange = function () {};
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.loadData();
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '报销单号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/e_manage/open/' + record.uuid },
	            text || '查看'
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price'
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD')
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'long',
	        render: function render(text, record) {
	          return record.status ? _react2.default.createElement(
	            'span',
	            null,
	            '\u5DF2\u5B8C\u6210',
	            _react2.default.createElement(
	              'span',
	              null,
	              '(\u7528\u65F6',
	              record.consume,
	              '\u5929)'
	            )
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u5BA1\u6838\u4E2D'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      },
	      condition: ''
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	      var org = this.props.org;
	
	      return _react2.default.createElement(
	        _antd.Drawer,
	        {
	          visible: true,
	          width: '70%',
	          title: org.company,
	          onClose: function onClose() {
	            return _this2.props.handleVisible(false);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(_antd.Col, { span: 13 }),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          ),
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            dataSource: list,
	            pagination: pagination,
	            rowKey: 'uuid',
	            size: 'small',
	            onChange: this.handleTableChange
	          })
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _funds_book = __webpack_require__(734);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _funds = __webpack_require__(190);
	
	var _ModalAdd = __webpack_require__(1633);
	
	var _ModalAdd2 = _interopRequireDefault(_ModalAdd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { getAccountInfo } from "../../../store/modules/account_info";
	
	
	var TabPane = _antd.Tabs.TabPane;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = _this.state.condition || '';
	      params.type = _this.state.type || 0;
	      _this.setState({
	        pageNo: current,
	        isLoading: true
	      });
	      (0, _funds.queryFundsBookList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            company: res.data,
	            total: res.totalSize,
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.search = function () {
	      _this.loadData();
	    };
	
	    _this.delete = function (uuid) {
	      var context = _this;
	      (0, _funds.queryDeleteFundsBook)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          context.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.showModalAdd = function () {
	      _this.setState({
	        modalAddVisible: true
	      });
	    };
	
	    _this.showModalEdit = function (uuid) {
	      _this.uuid = uuid;
	      _this.setState({
	        modalEditVisible: true
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        modalAddVisible: false,
	        modalEditVisible: false
	      });
	    };
	
	    _this.handAddSubmit = function (item) {
	      (0, _funds_book.saveFundsBook)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handEditSubmit = function (item) {
	      item.uuid = _this.uuid;
	      (0, _funds_book.saveFundsBook)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.hideModal();
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.setCondition = function (e) {
	      _this.setState({
	        condition: e.target.value
	      });
	    };
	
	    _this.handleEnable = function (uuid) {
	      (0, _funds.queryEnableFundsBook)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleDisable = function (uuid) {
	      (0, _funds.queryDisableFundsBook)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.callback = function (key) {
	      _this.setState({
	        type: key
	      }, function () {
	        return _this.loadData(1);
	      });
	    };
	
	    _this.judge = function (accountInfo) {
	      var role = accountInfo.roles;
	      var permission = {};
	      var defaultActiveKey = [];
	      role.map(function (sign) {
	        if (sign === '[cash]') {
	          permission.cash = true;
	          defaultActiveKey.push('0');
	        }
	
	        if (sign === '[stock]') {
	          permission.stock = true;
	          defaultActiveKey.push('1');
	        }
	
	        if (sign === '[digitalCurrency]') {
	          permission.digitalCurrency = true;
	          defaultActiveKey.push('2');
	        }
	
	        return permission;
	      });
	      if (accountInfo.admin) {
	        permission.all = true;
	        defaultActiveKey.push('0');
	      }
	
	      defaultActiveKey = defaultActiveKey.sort();
	
	      _this.setState({
	        permission: permission,
	        defaultActiveKey: defaultActiveKey[0]
	      });
	    };
	
	    _this.toDetail = function (uuid, companyUuid) {
	      var dispatch = _this.props.dispatch;
	
	
	      dispatch((0, _funds_book.saveFundsBook)({
	        companyUuid: companyUuid
	      }));
	      _this.props.router.push('/finance/funds/' + uuid + '/detail');
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '序号',
	        dataIndex: 'num',
	        key: 'num',
	        render: function render(text, record, index) {
	          var tot = 15 * (_this.state.pageNo - 1) + index + 1;
	          return _react2.default.createElement(
	            'span',
	            null,
	            tot
	          );
	        }
	      }, {
	        title: '公司名称',
	        dataIndex: 'companyName',
	        key: 'companyName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.toDetail(record.uuid, record.companyUuid);
	              } },
	            text
	          )
	          // <Link
	          //   to={`/finance/funds/${
	          //     record.uuid
	          //   }/detail`}
	          // >
	          //   {text}
	          // </Link>
	          ;
	        }
	      }, {
	        title: '\u5E74\u521D\u4F59\u989D',
	        dataIndex: 'initBalance',
	        key: 'initBalance',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _util2.default.numberFormat(text, 2, '.', ','),
	            record.unit ? '(' + record.unit + ')' : '(元)'
	          );
	        }
	      }, {
	        title: '\u4F59\u989D',
	        dataIndex: 'current',
	        key: 'current',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _util2.default.numberFormat(text, 2, '.', ','),
	            record.unit ? '(' + record.unit + ')' : '(元)'
	          );
	        }
	      }, {
	        title: '摘要',
	        dataIndex: 'remark',
	        key: 'remark'
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.isEnable === 0 ? _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                placement: 'leftTop',
	                title: '\u786E\u5B9A\u542F\u7528\u6B64\u8D44\u91D1\u8D26\u6237\u5417\uFF1F',
	                onConfirm: function onConfirm() {
	                  return _this.handleEnable(record.uuid);
	                },
	                okText: '\u786E\u5B9A',
	                cancelText: '\u53D6\u6D88'
	              },
	              _react2.default.createElement(
	                'a',
	                null,
	                '\u542F\u7528'
	              )
	            ) : _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _antd.Popconfirm,
	                {
	                  placement: 'leftTop',
	                  title: '\u786E\u5B9A\u7981\u7528\u6B64\u8D44\u91D1\u8D26\u6237\u5417\uFF1F',
	                  onConfirm: function onConfirm() {
	                    return _this.handleDisable(record.uuid);
	                  },
	                  okText: '\u786E\u5B9A',
	                  cancelText: '\u53D6\u6D88'
	                },
	                _react2.default.createElement(
	                  'a',
	                  null,
	                  '\u7981\u7528'
	                )
	              ),
	              _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.toDetail(record.uuid, record.companyUuid);
	                  } },
	                '\u8BE6\u60C5'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return _this.showModalEdit(record.uuid);
	                    } },
	                  '\u7F16\u8F91'
	                )
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      company: [],
	      pageNo: 1,
	      type: 0,
	      total: 0,
	      modalAddVisible: false,
	      modalEditVisible: false,
	      permission: {},
	      defaultActiveKey: ''
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      // this.props.dispatch(getAccountInfo());
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    /**
	     * 按条件搜索
	     */
	
	
	    /**
	     * 显示添加账户弹窗
	     */
	
	
	    /**
	     * 显示编辑账户弹窗
	     */
	
	
	    /**
	     * 新增账号
	     */
	
	
	    /**
	     * 编辑账号
	     */
	
	
	    /**
	     * 启用资金账户
	     */
	
	
	    /**
	     * 禁用资金账户
	     */
	
	
	    /**
	     * 切换标签页
	     * @param {} key
	     */
	
	
	    /**
	     * 依据角色判断权限
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          total = _state.total,
	          company = _state.company,
	          isLoading = _state.isLoading;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      var _state2 = this.state,
	          permission = _state2.permission,
	          defaultActiveKey = _state2.defaultActiveKey;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'fixed-header', style: { minWidth: '800px' } },
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'space-between' },
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              _react2.default.createElement(
	                _antd.Button,
	                { icon: 'plus', style: { marginBottom: 15 }, onClick: this.showModalAdd },
	                '\u6DFB\u52A0'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { style: { textAlign: 'right' } },
	              _react2.default.createElement(_antd.Input, {
	                placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57',
	                style: { width: '300px' },
	                value: this.state.condition,
	                onChange: this.setCondition
	              }),
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', style: { marginLeft: '10px' }, onClick: this.search },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _antd.Tabs,
	            {
	              defaultActiveKey: defaultActiveKey,
	              onChange: this.callback,
	              style: { paddingTop: '46px' }
	            },
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u73B0\u91D1\u5E10', key: '0', disabled: !(permission.all || permission.cash) },
	              _react2.default.createElement(_antd.Table, {
	                rowKey: function rowKey(record) {
	                  return record.uuid;
	                },
	                rowSelection: {},
	                columns: this.columns(),
	                dataSource: company,
	                pagination: pagination,
	                loading: isLoading
	              })
	            ),
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u80A1\u7968', key: '1', disabled: !(permission.all || permission.stock) },
	              _react2.default.createElement(_antd.Table, {
	                rowKey: function rowKey(record) {
	                  return record.uuid;
	                },
	                rowSelection: {},
	                columns: this.columns(),
	                dataSource: company,
	                pagination: pagination,
	                loading: isLoading
	              })
	            ),
	            _react2.default.createElement(
	              TabPane,
	              {
	                tab: '\u865A\u62DF\u8D27\u5E01',
	                key: '2',
	                disabled: !(permission.all || permission.digitalCurrency)
	              },
	              _react2.default.createElement(_antd.Table, {
	                rowKey: function rowKey(record) {
	                  return record.uuid;
	                },
	                rowSelection: {},
	                columns: this.columns(),
	                dataSource: company,
	                pagination: pagination,
	                loading: isLoading
	              })
	            )
	          )
	        ),
	        this.state.modalAddVisible ? _react2.default.createElement(_ModalAdd2.default, {
	          handSubmit: this.handAddSubmit,
	          data: {},
	          cancel: this.hideModal,
	          permission: permission
	        }) : '',
	        this.state.modalEditVisible ? _react2.default.createElement(_ModalAdd2.default, {
	          handSubmit: this.handEditSubmit,
	          data: {},
	          uuid: this.uuid,
	          cancel: this.hideModal,
	          permission: permission
	        }) : ''
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    account_info: state.account_info
	  };
	})(Index);

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _org = __webpack_require__(53);
	
	var _funds = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadioGroup = _antd.Radio.Group;
	
	var FormItem = _antd.Form.Item;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.loadCompany = function () {
	      var params = {};
	      (0, _org.queryAllCompany)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var options = [];
	          res.data.map(function (item) {
	            var optionItem = {};
	            optionItem.label = item.name;
	            optionItem.value = item.uuid;
	            optionItem.key = item.uuid;
	            options.push(optionItem);
	            return options;
	          });
	          _this.setState({
	            treeData: options
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.onLoadData = function (treeNode) {
	      var arr = [];
	      var key = treeNode.props.eventKey;
	      var params = {};
	      params.type = 1;
	      params.uuid = key.split('-')[key.split('-').length - 1];
	      return new Promise(function (resolve) {
	        (0, _org.queryCompany)(params).then(function (res) {
	          if (res.statusCode === 200) {
	            res.data.map(function (item) {
	              var optionItem = {};
	              optionItem.label = item.name;
	              optionItem.value = item.uuid;
	              optionItem.key = key + '-' + item.uuid;
	              arr.push(optionItem);
	              return arr;
	            });
	            var treeData = [].concat(_toConsumableArray(_this.state.treeData));
	            var loop = function loop(data) {
	              data.forEach(function (item) {
	                if (key.indexOf(item.key) === 0) {
	                  if (item.children) {
	                    resolve();
	                    loop(item.children);
	                  } else if (item.key === key) {
	                    if (arr.length > 0) {
	                      item.children = arr;
	                      _this.setState({ treeData: treeData }, function () {
	                        resolve();
	                      });
	                    } else if (arr.length === 0) {
	                      item.isLeaf = true;
	                      _this.setState({ treeData: treeData }, function () {
	                        resolve();
	                      });
	                    } else {
	                      resolve();
	                    }
	                  }
	                }
	              });
	            };
	            loop(treeData);
	          }
	        });
	      });
	    };
	
	    _this.handleCompany = function (e, option) {
	      _this.companyName = option[0];
	      _this.companyUuid = e;
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handSubmit = _this.props.handSubmit;
	
	      var capital = _this.props.form.getFieldsValue();
	      capital.companyName = _this.companyName || _this.state.content.companyName;
	      capital.companyUuid = _this.companyUuid || _this.state.content.companyUuid;
	      delete capital.company;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          handSubmit(capital);
	        }
	      });
	    };
	
	    _this.setCompanyName = function (value, option) {
	      _this.companyName = option.props.children;
	      _this.companyUuid = value;
	    };
	
	    _this.loadDetail = function (uuid) {
	      (0, _funds.queryFundsBookInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            content: res.data
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      content: {},
	      treeData: []
	    };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.uuid;
	
	      this.loadCompany();
	      if (uuid) {
	        this.loadDetail(uuid);
	      }
	    }
	
	    /**
	     *获取组织列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var permission = this.props.permission;
	
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	
	      var content = this.state.content;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u8D26\u6237\u9875\u9762', visible: true, onOk: this.submit, onCancel: this.props.cancel },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u516C\u53F8\u540D\u79F0' }, formItemLayout),
	            getFieldDecorator('company', {
	              rules: [{ required: true, message: '请输入公司名称' }],
	              initialValue: content.companyName
	            })(_react2.default.createElement(_antd.TreeSelect, {
	              treeData: this.state.treeData,
	              loadData: this.onLoadData,
	              dropdownStyle: {
	                maxHeight: '500px',
	                overflowY: 'scroll',
	                minHeight: '200px'
	              },
	              style: { width: '100%' },
	              onChange: this.handleCompany
	            }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u5355\u4F4D' }, formItemLayout),
	            getFieldDecorator('unit', {
	              initialValue: content.unit
	            })(_react2.default.createElement(_antd.Input, { type: 'text' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u521D\u59CB\u8D44\u91D1' }, formItemLayout),
	            getFieldDecorator('init', {
	              initialValue: content.init || ''
	            })(_react2.default.createElement(_antd.Input, { type: 'number' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u7C7B\u522B' }, formItemLayout),
	            getFieldDecorator('type', {
	              initialValue: content.type || 0
	            })(_react2.default.createElement(
	              RadioGroup,
	              { defaultValue: 0, value: content.type },
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: 0, disabled: !(permission.all || permission.cash) },
	                '\u73B0\u91D1\u5E10'
	              ),
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: 1, disabled: !(permission.all || permission.stock) },
	                '\u80A1\u7968'
	              ),
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: 2, disabled: !(permission.all || permission.digitalCurrency) },
	                '\u6570\u5B57\u8D27\u5E01'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u6458\u8981' }, formItemLayout),
	            getFieldDecorator('remark', {
	              initialValue: content.remark
	            })(_react2.default.createElement(_antd.Input, { type: 'textarea', rows: 4 }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(IndexModal);

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _funds = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FinanceCapitalDetail = function (_Component) {
	  _inherits(FinanceCapitalDetail, _Component);
	
	  function FinanceCapitalDetail(props) {
	    _classCallCheck(this, FinanceCapitalDetail);
	
	    var _this = _possibleConstructorReturn(this, (FinanceCapitalDetail.__proto__ || Object.getPrototypeOf(FinanceCapitalDetail)).call(this, props));
	
	    _this.loadStatistics = function (uuid) {
	      (0, _funds.queryStatisticsFundsBook)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ statistics: res.data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      statistics: {}
	    };
	    return _this;
	  }
	
	  _createClass(FinanceCapitalDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.uuid;
	
	      this.loadStatistics(uuid);
	    }
	
	    /**
	     * 获取账号统计
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var statistics = this.state.statistics;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        { className: 'description' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-around', align: 'middle' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u6240\u5C5E\u516C\u53F8:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.companyName
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u8D26\u6237\u4F59\u989D:'
	              ),
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                _util2.default.numberFormat(statistics.currentBalance, 2, '.', ','),
	                statistics.unit ? '(' + statistics.unit + ')' : '(元)'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u603B\u6536\u5165:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _util2.default.numberFormat(statistics.incomeSum, 2, '.', ','),
	                statistics.unit ? '(' + statistics.unit + ')' : '(元)'
	              )
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u603B\u652F\u51FA:'
	              ),
	              _react2.default.createElement(
	                'span',
	                null,
	                _util2.default.numberFormat(statistics.expenditureSum, 2, '.', ','),
	                statistics.unit ? '(' + statistics.unit + ')' : '(元)'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u6536\u5165\u6B3E\u9879:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.incomeCount
	              ),
	              '\u7B14'
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { className: 'title' },
	                '\u652F\u51FA\u6B3E\u9879:'
	              ),
	              ' ',
	              _react2.default.createElement(
	                'span',
	                null,
	                statistics.expenditureCount
	              ),
	              '\u7B14'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FinanceCapitalDetail;
	}(_react.Component);
	
	exports.default = FinanceCapitalDetail;

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BackBtn = __webpack_require__(12);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _funds = __webpack_require__(190);
	
	var _ModalDetail = __webpack_require__(1636);
	
	var _ModalDetail2 = _interopRequireDefault(_ModalDetail);
	
	var _CardStatic = __webpack_require__(1634);
	
	var _CardStatic2 = _interopRequireDefault(_CardStatic);
	
	var _ModalImportExcel = __webpack_require__(1637);
	
	var _ModalImportExcel2 = _interopRequireDefault(_ModalImportExcel);
	
	var _ModalRelate = __webpack_require__(1638);
	
	var _ModalRelate2 = _interopRequireDefault(_ModalRelate);
	
	var _ModalDetail3 = __webpack_require__(699);
	
	var _ModalDetail4 = _interopRequireDefault(_ModalDetail3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { getAccountInfo } from "../../../../store/modules/account_info";
	
	var FinanceCapitalDetail = function (_Component) {
	  _inherits(FinanceCapitalDetail, _Component);
	
	  function FinanceCapitalDetail(props) {
	    _classCallCheck(this, FinanceCapitalDetail);
	
	    var _this = _possibleConstructorReturn(this, (FinanceCapitalDetail.__proto__ || Object.getPrototypeOf(FinanceCapitalDetail)).call(this, props));
	
	    _this.loadBooksIncomeList = function (pageNo) {
	      var params = {};
	      var uuid = _this.props.params.uuid;
	
	      params.bookUuid = uuid;
	      params.condition = _this.state.condition;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      _this.setState({
	        pageNo: current
	      });
	      (0, _funds.queryFundsRecordList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            record: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        modalRelateVisible: false,
	        modalIncomeVisible: false
	      });
	    };
	
	    _this.showModalRelate = function (uuid) {
	      _this.setState({
	        modalRelateVisible: true,
	        uuid: uuid
	      });
	    };
	
	    _this.showModalIncome = function (incomeUuid) {
	      _this.setState({
	        modalIncomeVisible: true,
	        incomeUuid: incomeUuid
	      });
	    };
	
	    _this.search = function (condition) {
	      _this.condition = condition;
	      _this.loadBooksIncomeList(1);
	    };
	
	    _this.columns = function () {
	      var unit = _this.state.unit;
	
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        key: 'date',
	        width: 250,
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.showModal(record.uuid);
	              } },
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD')
	          );
	        }
	      }, {
	        title: '摘要',
	        dataIndex: 'remark',
	        key: 'remark',
	        width: 200
	      }, {
	        title: '\u6536\u5165(' + unit + ')',
	        dataIndex: 'money',
	        key: 'money',
	        width: 200,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'a',
	            { style: { color: 'green' } },
	            text === 0 ? '' : _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '\u652F\u51FA(' + unit + ')',
	        dataIndex: 'payMoney',
	        key: 'payMoney',
	        width: 200,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'a',
	            { style: { color: 'red' } },
	            text === 0 ? '' : _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '\u5F53\u524D\u4F59\u989D(' + unit + ')',
	        dataIndex: 'current',
	        key: 'current',
	        width: 200,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'a',
	            null,
	            text === 0 ? 0 : _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            !record.incomeUuid ? _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.showModalRelate(record.uuid);
	                } },
	              '\u5173\u8054'
	            ) : _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.showModalIncome(record.incomeUuid);
	                } },
	              '\u8BE6\u60C5'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.showModal = function (uuid) {
	      _this.setState({
	        visible: true,
	        uuid: uuid
	      });
	    };
	
	    _this.showImport = function () {
	      _this.setState({
	        importVisible: true
	      });
	    };
	
	    _this.handleCancel = function () {
	      _this.setState({
	        visible: false,
	        importVisible: false,
	        modalRelateVisible: false,
	        modalIncomeVisible: false
	      });
	    };
	
	    _this.handleSubmit = function (result) {
	      if (result) {
	        _this.handleCancel();
	        _this.loadBooksIncomeList();
	      }
	    };
	
	    _this.setCondition = function (e) {
	      _this.setState({
	        condition: e.target.value
	      });
	    };
	
	    _this.state = {
	      visible: false,
	      importVisible: false,
	      modalRelateVisible: false,
	      modalIncomeVisible: false,
	      pageNo: 1,
	      record: [],
	      uuid: '',
	      condition: '',
	      scrollY: _util2.default.pageHeight() - 310,
	      unit: '元'
	    };
	    return _this;
	  }
	
	  _createClass(FinanceCapitalDetail, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadBooksIncomeList(1);
	      // this.props.dispatch(getAccountInfo());
	    }
	
	    /**
	     * 获取流水记录列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var pagination = {
	        defaultPageSize: 15,
	        showSizeChanger: false,
	        onChange: function onChange(current) {
	          _this2.loadBooksIncomeList(current);
	        },
	        current: this.state.pageNo,
	        total: this.state.total
	      };
	      var record = this.state.record;
	      var scrollY = this.state.scrollY;
	      var isFinancialM = this.props.isFinancialM;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _antd.Row,
	              { type: 'flex', justify: 'space-between', style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(_BackBtn.BackBtn, null),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { icon: 'import', onClick: this.showImport, style: { marginLeft: '10px' } },
	                  '\u5BFC\u5165'
	                ),
	                _react2.default.createElement(
	                  'a',
	                  { onClick: function onClick() {
	                      return (0, _funds.queryDownloadFundRecordTemplate)();
	                    }, style: { marginLeft: '10px' } },
	                  '\u6A21\u677F\u4E0B\u8F7D'
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { style: { textAlign: 'right' } },
	                _react2.default.createElement(_antd.Input, {
	                  placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57',
	                  style: { width: '300px' },
	                  value: this.state.condition,
	                  onChange: this.setCondition
	                }),
	                _react2.default.createElement(
	                  _antd.Button,
	                  {
	                    type: 'primary',
	                    style: { marginLeft: '10px' },
	                    onClick: function onClick() {
	                      return _this2.loadBooksIncomeList(1);
	                    }
	                  },
	                  '\u641C\u7D22'
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(_CardStatic2.default, { uuid: this.props.params.uuid })
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: record,
	          pagination: pagination,
	          rowKey: 'uuid',
	          rowClassName: function rowClassName(row) {
	            if (row.ignore === 1) {
	              return 'table-ignore-1';
	            }
	            if (row.ignore === 2) {
	              return 'table-ignore-2';
	            }
	          },
	          scroll: { y: scrollY }
	        }),
	        this.state.visible && isFinancialM ? _react2.default.createElement(_ModalDetail2.default, {
	          ref: function ref(form) {
	            _this2.form = form;
	          },
	          handleSubmit: this.handleSubmit,
	          uuid: this.state.uuid,
	          cancel: this.handleCancel
	        }) : '',
	        this.state.importVisible ? _react2.default.createElement(_ModalImportExcel2.default, {
	          ref: function ref(form) {
	            _this2.form = form;
	          },
	          handleSubmit: this.handleSubmit,
	          uuid: this.props.params.uuid,
	          cancel: this.handleCancel
	        }) : '',
	        this.state.modalRelateVisible ? _react2.default.createElement(_ModalRelate2.default, {
	          ref: function ref(form) {
	            _this2.form = form;
	          },
	          handleSubmit: this.handleSubmit,
	          uuid: this.state.uuid,
	          compUuid: this.props.params.uuid,
	          cancel: this.handleCancel
	        }) : '',
	        this.state.modalIncomeVisible ? _react2.default.createElement(_ModalDetail4.default, {
	          ref: function ref(form) {
	            _this2.form = form;
	          },
	          handleSubmit: this.handleSubmit,
	          data: {},
	          uuid: this.state.incomeUuid,
	          cancel: this.handleCancel,
	          readOnly: true
	        }) : ''
	      );
	    }
	  }]);
	
	  return FinanceCapitalDetail;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    isFinancialM: state.account_info.isFinancialM,
	    account_info: state.account_info,
	    income_info: state.income_info
	  };
	})(FinanceCapitalDetail);

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _dict = __webpack_require__(64);
	
	var _funds = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RadioGroup = _antd.Radio.Group;
	var FormItem = _antd.Form.Item;
	
	var DetailModal = function (_Component) {
	  _inherits(DetailModal, _Component);
	
	  function DetailModal(props) {
	    _classCallCheck(this, DetailModal);
	
	    var _this = _possibleConstructorReturn(this, (DetailModal.__proto__ || Object.getPrototypeOf(DetailModal)).call(this, props));
	
	    _this.loadInfo = function (uuid) {
	      (0, _funds.queryFundsRecordInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ content: res.data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadDictExpend = function () {
	      (0, _dict.queryDictExpend)().then(function () {});
	    };
	
	    _this.loadDictIncome = function () {
	      (0, _dict.queryDictIncome)().then(function () {});
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var income = _this.props.form.getFieldsValue();
	      var obj = {};
	      obj.uuid = _this.props.uuid;
	      obj.ignoreFlag = income.ignoreFlag;
	      obj.type = income.type;
	      obj.remark = income.remark;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          (0, _funds.querySaveFundsRecord)(obj).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              _this.props.handleSubmit(obj);
	            } else {
	              _antd.message.error(res.message);
	            }
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      content: {}
	    };
	    return _this;
	  }
	
	  _createClass(DetailModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var uuid = this.props.uuid;
	
	      if (uuid) {
	        this.loadInfo(uuid);
	      }
	    }
	
	    /**
	     * 获取收入类别
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	      var content = this.state.content;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u6536\u652F\u8BB0\u5F55', visible: true, onCancel: this.props.cancel, onOk: this.submit },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'horizontal' },
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u8D44\u91D1\u65B9\u5411' }, formItemLayout),
	            getFieldDecorator('target', {
	              rules: [{ required: true, message: '请选择资金流向' }],
	              initialValue: '' + content.target
	            })(_react2.default.createElement(
	              RadioGroup,
	              { disabled: true },
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: '1' },
	                '\u6536\u5165'
	              ),
	              _react2.default.createElement(
	                _antd.Radio,
	                { value: '0' },
	                '\u652F\u51FA'
	              )
	            ))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u91D1\u989D' }, formItemLayout),
	            getFieldDecorator('money', {
	              rules: [{ required: true, message: '请输入初始资金' }],
	              initialValue: content.target === '0' ? content.paymoney : content.money
	            })(_react2.default.createElement(_antd.Input, { disabled: true, addonAfter: '\u5143', type: 'number' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u6536\u652F\u65E5\u671F' }, formItemLayout),
	            getFieldDecorator('date', {
	              rules: [{ required: true, message: '请选择发生日期' }],
	              initialValue: content.date ? _moment2.default.unix(content.date / 1000) : (0, _moment2.default)()
	            })(_react2.default.createElement(_antd.DatePicker, { disabled: true }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u6458\u8981' }, formItemLayout),
	            getFieldDecorator('remark', {
	              initialValue: content.remark
	            })(_react2.default.createElement(_antd.Input, { type: 'textarea', rows: 4 }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return DetailModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { account_info: state.account_info };
	})(_antd.Form.create({ wrappedComponentRef: true })(DetailModal));

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _funds = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var DetailModal = function (_Component) {
	  _inherits(DetailModal, _Component);
	
	  function DetailModal(props) {
	    _classCallCheck(this, DetailModal);
	
	    var _this = _possibleConstructorReturn(this, (DetailModal.__proto__ || Object.getPrototypeOf(DetailModal)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var income = _this.props.form.getFieldsValue();
	
	      var obj = Object.assign(_this.state.content, income);
	      if (_this.state.licenseFile && _this.state.licenseFile.length > 0) {
	        obj.fileUuid = _this.state.licenseFile[0].uuid;
	      }
	      obj.bookUuid = _this.props.uuid;
	      var handleSubmit = _this.props.handleSubmit;
	
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          (0, _funds.queryImportFundsRecord)(obj).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              handleSubmit(obj);
	            } else if (res.statusCode === 250) {
	              _antd.message.warn(res.message);
	            } else {
	              _antd.message.error(res.message);
	            }
	          });
	        }
	      });
	    };
	
	    _this.handlelicenseFile = function (fileList) {
	      _this.setState({
	        licenseFile: fileList
	      });
	    };
	
	    _this.state = {
	      content: {}
	    };
	    return _this;
	  }
	
	  _createClass(DetailModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	
	      var licenseFile = this.state.licenseFile || [];
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u5BFC\u5165', visible: true, onCancel: this.props.cancel, onOk: this.submit },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'horizontal' },
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u4E0A\u4F20Excel\u6587\u4EF6' }, formItemLayout, { required: true }),
	            _react2.default.createElement(_UploadFile2.default, {
	              type: 'ghost',
	              handleUpload: this.handlelicenseFile,
	              fileList: licenseFile,
	              isExcel: true
	            }),
	            _react2.default.createElement(
	              'span',
	              { className: 'ant-form-text' },
	              '\xA0\u4EC5\u9650excel\u683C\u5F0F'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DetailModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(DetailModal);

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _funds = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalRelate = function (_Component) {
	  _inherits(ModalRelate, _Component);
	
	  function ModalRelate(props) {
	    _classCallCheck(this, ModalRelate);
	
	    var _this = _possibleConstructorReturn(this, (ModalRelate.__proto__ || Object.getPrototypeOf(ModalRelate)).call(this, props));
	
	    _this.loadIncomeList = function (pageNo) {
	      var params = {};
	      params.condition = _this.state.condition;
	      params.compUuid = _this.props.funds_book.companyUuid;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 10;
	      params.start = current;
	      _this.setState({
	        pageNo: current
	      });
	      (0, _funds.queryFundsRecordIncome)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.saveFundsRecordRelate = function (incomeUuid) {
	      var uuid = _this.state.uuid;
	      var handleSubmit = _this.props.handleSubmit;
	
	
	      var params = {};
	      params.uuid = uuid;
	      params.incomeUuid = incomeUuid;
	      (0, _funds.querySaveFundsRecordRelate)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          handleSubmit();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        key: 'date',
	        width: 250,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD')
	          );
	        }
	      }, {
	        title: '对方户名',
	        dataIndex: 'accountName',
	        key: 'accountName',
	        width: 200
	      }, {
	        title: '摘要',
	        dataIndex: 'remark',
	        key: 'remark',
	        width: 200
	      }, {
	        title: '收入(元)',
	        dataIndex: 'money',
	        key: 'money',
	        width: 200,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'a',
	            { style: { color: 'green' } },
	            text === 0 ? '' : _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '支出(元)',
	        dataIndex: 'payMoney',
	        key: 'payMoney',
	        width: 200,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'a',
	            { style: { color: 'red' } },
	            text === 0 ? '' : _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.saveFundsRecordRelate(record.uuid);
	              } },
	            '\u9009\u62E9'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      uuid: '',
	      condition: '',
	      pageNo: 1,
	      data: []
	    };
	    return _this;
	  }
	
	  _createClass(ModalRelate, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ uuid: this.props.uuid });
	      this.loadIncomeList(1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	
	
	      var pagination = {
	        defaultPageSize: 10,
	        showSizeChanger: false,
	        onChange: function onChange(current) {
	          _this2.loadIncomeList(current);
	        },
	        current: this.state.pageNo,
	        total: this.state.total
	      };
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u5173\u8054\u7684\u94F6\u884C\u6D41\u6C34', visible: true, width: '900', onCancel: this.props.cancel },
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination,
	          rowKey: 'uuid',
	          scroll: { y: scrollY }
	        })
	      );
	    }
	  }]);
	
	  return ModalRelate;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    funds_book: state.funds_book
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(ModalRelate));

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _dict = __webpack_require__(64);
	
	var _attachment = __webpack_require__(27);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.getInvoiceType = function () {
	      (0, _dict.queryInvoiceType)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            invoiceType: res.data
	          });
	        }
	      });
	    };
	
	    _this.findTypeName = function (type) {
	      var typeName = '';
	      _this.state.invoiceType.forEach(function (item) {
	        if (type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.state = {
	      dataItem: _this.props.data,
	      invoiceType: []
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getInvoiceType();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataItem: nextProps.data
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataItem = this.state.dataItem;
	
	      var files = dataItem.files || [];
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u5F00\u7968\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u5165\u8D26\u516C\u53F8' },
	              dataItem.income
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D2D\u8D27\u516C\u53F8' },
	              dataItem.company
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7EB3\u7A0E\u4EBA\u8BC6\u522B\u53F7' },
	              dataItem.idCode
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F00\u7968\u7C7B\u578B' },
	              this.findTypeName(dataItem.type)
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5730\u5740\u7535\u8BDD' },
	              dataItem.link
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F00\u7968\u5185\u5BB9' },
	              dataItem.content
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F00\u6237\u884C\u53CA\u5E10\u53F7' },
	              dataItem.bankCode
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F00\u7968\u91D1\u989D' },
	              dataItem.price,
	              '\u5143'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7533\u8BF7\u4EBA\u5458' },
	              dataItem.createUserName
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F00\u7968\u51ED\u8BC1' },
	              _react2.default.createElement(
	                'div',
	                null,
	                files.map(function (item) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: item.url },
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: function onClick() {
	                          return (0, _attachment.queryFilePreview)(item);
	                        } },
	                      ' ',
	                      item.name
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F00\u7968\u8BF4\u660E' },
	              dataItem.reason
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F00\u7968\u5907\u6CE8' },
	              dataItem.remark
	            )
	          )
	        ),
	        dataItem.codeNo && dataItem.receiver ? _react2.default.createElement(
	          _antd.Card,
	          { title: '\u9886\u7968\u4FE1\u606F' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u53D1\u7968\u7F16\u53F7' },
	              dataItem.codeNo
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9886\u7968\u4EBA' },
	              dataItem.receiver
	            )
	          )
	        ) : null
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    company: state.company_list
	  };
	})(Open);

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalInvalid = function (_Component) {
	  _inherits(ModalInvalid, _Component);
	
	  function ModalInvalid() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ModalInvalid);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalInvalid.__proto__ || Object.getPrototypeOf(ModalInvalid)).call.apply(_ref, [this].concat(args))), _this), _this.onOk = function () {
	      _this.props.form.validateFields(function (err, value) {
	        if (!err) {
	          _this.props.onOk(value, _this.props.data);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(ModalInvalid, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u53D1\u7968\u4F5C\u5E9F',
	          visible: this.props.visible,
	          onOk: this.onOk,
	          onCancel: this.props.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Form.Item,
	            { label: '\u4F5C\u5E9F\u539F\u56E0' },
	            getFieldDecorator('reason', {
	              rules: [{ required: true, message: '请填写作废原因' }]
	            })(_react2.default.createElement(_antd.Input, null))
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalInvalid;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalInvalid);

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _company_list = __webpack_require__(96);
	
	var _invoice = __webpack_require__(151);
	
	var _FormBase = __webpack_require__(703);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveInvoice(item);
	    };
	
	    _this.invoiceWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _invoice.queryInvoiceWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveInvoice = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _invoice.querySaveInvoice)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.invoiceWorkflow();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _company_list.getCompanyList)());
	    }
	
	    /**
	     * 提交开票
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, { data: dataInfo, handSubmit: this.handSubmit, isSubmitting: isSubmitting }),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance })
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    company: state.company_list
	  };
	})(Page);

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _invoice = __webpack_require__(151);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableStaticOrg = __webpack_require__(705);
	
	var _TableStaticOrg2 = _interopRequireDefault(_TableStaticOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getInvoiceOrgStatic = function (params) {
	      (0, _invoice.queryInvoiceOrgStatic)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getInvoiceOrgStatic(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableStaticOrg2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _reactRouter = __webpack_require__(8);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _invoice = __webpack_require__(151);
	
	var _FormBase = __webpack_require__(703);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveInvoice(item);
	    };
	
	    _this.invoiceWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _invoice.queryInvoiceWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveInvoice = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _invoice.querySaveInvoice)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.deleteInvoice = function () {
	      (0, _invoice.queryDeleteInvoice)({
	        uuid: _this.props.data.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.invoiceWorkflow();
	    }
	
	    /**
	     * 提交开票
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, Object.assign({
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          handleDelete: this.deleteInvoice,
	          isSubmitting: isSubmitting
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _invoice = __webpack_require__(151);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableStaticOrg = __webpack_require__(705);
	
	var _TableStaticOrg2 = _interopRequireDefault(_TableStaticOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getInvoiceIncubatorStatic = function (params) {
	      (0, _invoice.queryInvoiceIncubatorStatic)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getInvoiceIncubatorStatic(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableStaticOrg2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _expend_type = __webpack_require__(80);
	
	var _company_list = __webpack_require__(96);
	
	var _invoice = __webpack_require__(151);
	
	var _PageEdit = __webpack_require__(1643);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1647);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getInvoiceInfo = function () {
	      (0, _invoice.queryInvoiceInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getInvoiceInfo();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	      dispatch((0, _company_list.getCompanyList)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(PageInfo);

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _invoice = __webpack_require__(151);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(704);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getInvoiceMyList = function (params) {
	      _this.setState({ loading: true });
	      (0, _invoice.queryInvoiceMyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getInvoiceMyList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        loading: false,
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        type: 'mine',
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/i_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u5F00\u7968'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _WorkflowInvoice = __webpack_require__(1516);
	
	var _WorkflowInvoice2 = _interopRequireDefault(_WorkflowInvoice);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _invoice = __webpack_require__(151);
	
	var _FormOpen = __webpack_require__(1639);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.doTask = function (pass, refuse, info) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackInvoice(item);
	          break;
	        case 'next':
	          _this.nextInvoice(Object.assign({}, item, info));
	          break;
	        case 'return':
	          _this.returnInvoice(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackInvoice = function (params) {
	      (0, _invoice.queryCallbackInvoice)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextInvoice = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _invoice.queryNextInvoice)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnInvoice = function (params, refuse) {
	      (0, _invoice.queryReturnInvoice)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null
	          );
	        }
	      }, {
	        title: '操作内容',
	        dataIndex: 'operating'
	      }, {
	        title: '处理意见',
	        dataIndex: 'refuse'
	      }];
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ dataInfo: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowInvoice2.default, {
	          op: 'invoice',
	          data: dataInfo,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_FormOpen2.default, Object.assign({ data: dataInfo, doTask: this.doTask, watchTask: this.watchTask }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'invoice', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _invoice = __webpack_require__(151);
	
	var _TableExpenses = __webpack_require__(704);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getInvoiceList = function (params) {
	      _this.setState({ loading: true });
	      (0, _invoice.queryInvoiceList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.invoiceInvalid = function (params) {
	      (0, _invoice.queryInvoiceInvalid)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadData();
	          _antd.message.success(res.message, 2.5);
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getInvoiceList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        loading: false,
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataSource = _state.dataSource,
	          loading = _state.loading;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange,
	        invoiceInvalid: this.invoiceInvalid
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(36);
	
	var _invoice = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.getInvoiceOrgRecord = function (params) {
	      (0, _invoice.queryInvoiceOrgRecord)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataSource: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 15
	              }
	            }
	          });
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.loadData = function () {
	      var condition = _this.state.condition;
	
	      var params = Object.assign({
	        companyUuid: _this.props.org.companyUuid,
	        condition: condition
	      }, _this.pagination);
	      _this.getInvoiceOrgRecord(params);
	    };
	
	    _this.onChange = function () {};
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.loadData();
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '开票单号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/i_manage/open/' + record.uuid },
	            text || '查看'
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price'
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD')
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'long',
	        render: function render(text, record) {
	          return record.status ? _react2.default.createElement(
	            'span',
	            null,
	            '\u5DF2\u5B8C\u6210',
	            _react2.default.createElement(
	              'span',
	              null,
	              '(\u7528\u65F6',
	              record.consume,
	              '\u5929)'
	            )
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u5BA1\u6838\u4E2D'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      },
	      condition: ''
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	      var org = this.props.org;
	
	      return _react2.default.createElement(
	        _antd.Drawer,
	        {
	          visible: true,
	          width: '70%',
	          title: org.company,
	          onClose: function onClose() {
	            return _this2.props.handleVisible(false);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(_antd.Col, { span: 13 }),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { id: 'ant-small-table' },
	            _react2.default.createElement(_antd.Table, {
	              columns: this.columns(),
	              dataSource: list,
	              pagination: pagination,
	              rowKey: 'uuid',
	              size: 'small',
	              onChange: this.handleTableChange
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _ModalApportionShow = __webpack_require__(428);
	
	var _ModalApportionShow2 = _interopRequireDefault(_ModalApportionShow);
	
	var _attachment = __webpack_require__(27);
	
	__webpack_require__(36);
	
	var _budget = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var budgetType = ['部门预算', '跨部门预算', '项目预算组'];
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.findTypeName = function (type) {
	      var typeName = '';
	      _this.props.expendType.forEach(function (item) {
	        if (type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.getBudgetGroupCandF = function (value) {
	      (0, _budget.queryBudgetGroupCandF)({
	        type: value,
	        userUuid: _this.state.dataItem.createUser
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            groupTip: res.data
	          });
	        }
	      });
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.state = {
	      visible: false,
	      dataItem: _this.props.data
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataItem = this.props.data;
	      !(+dataItem.budgetType === 1 || dataItem.instance && dataItem.instance.status === 1) && this.getBudgetGroupCandF(dataItem.type);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataItem: nextProps.data
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          visible = _state.visible,
	          dataItem = _state.dataItem,
	          groupTip = _state.groupTip;
	
	      var files = dataItem.files || [];
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u501F\u6B3E\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u501F\u6B3E\u7C7B\u578B' },
	              this.findTypeName(dataItem.type),
	              _react2.default.createElement(
	                'span',
	                { className: 'lowspan' },
	                groupTip && groupTip.groupName ? _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red' } },
	                  '\u8BE5\u8D39\u7528\u7C7B\u578B,',
	                  groupTip.groupName,
	                  '\u53EF\u7528\u4F59\u989D',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    groupTip.current || 0
	                  ),
	                  '\u5143',
	                  groupTip.freeze ? _react2.default.createElement(
	                    'span',
	                    null,
	                    ', \u51BB\u7ED3',
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      groupTip.freeze || 0
	                    )
	                  ) : null
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u501F\u6B3E\u91D1\u989D' },
	              dataItem.price,
	              '\u5143'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7533\u8BF7\u4EBA\u5458' },
	              dataItem.createUserName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u6765\u6E90' },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.handleVisible(true);
	                  } },
	                budgetType[dataItem.budgetType]
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u501F\u6B3E\u516C\u53F8' },
	              dataItem.company
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u501F\u6B3E\u51ED\u8BC1' },
	              _react2.default.createElement(
	                'div',
	                null,
	                files.map(function (item) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: item.url },
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: function onClick() {
	                          return (0, _attachment.queryFilePreview)(item);
	                        } },
	                      ' ',
	                      item.name
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u501F\u6B3E\u8BF4\u660E' },
	              dataItem.reason
	            )
	          )
	        ),
	        visible ? _react2.default.createElement(_ModalApportionShow2.default, {
	          onCancel: this.handleVisible,
	          dataInfo: {},
	          dataItem: dataItem,
	          visible: visible,
	          onOk: this.handleOk
	        }) : null
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(Open);

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var WriteForm = function (_Component) {
	  _inherits(WriteForm, _Component);
	
	  function WriteForm(props) {
	    _classCallCheck(this, WriteForm);
	
	    var _this = _possibleConstructorReturn(this, (WriteForm.__proto__ || Object.getPrototypeOf(WriteForm)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: '序号',
	        dataIndex: 'num',
	        key: 'num',
	        width: '6%',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            index + 1
	          );
	        }
	      }, {
	        title: '核销人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '核销类型',
	        dataIndex: 'type',
	        key: 'type',
	        render: function render(text) {
	          if (text === 0) {
	            return '借款归还';
	          }
	          if (text === 1) {
	            return '发票冲销';
	          }
	          return '';
	        }
	      }, {
	        title: '核销时间',
	        dataIndex: 'date',
	        key: 'date',
	        render: function render(text) {
	          if (text) {
	            return _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm');
	          }
	          return '-';
	        }
	      }, {
	        title: '核销金额',
	        dataIndex: 'price',
	        key: 'price',
	        render: function render(text) {
	          return _util2.default.numberFormat(text, 2, '.', ',');
	        }
	      }, {
	        title: '附件',
	        dataIndex: 'files',
	        key: 'files',
	        render: function render(text) {
	          return text.map(function (item) {
	            return _react2.default.createElement(
	              'div',
	              { key: item.url },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return (0, _attachment.queryFilePreview)(item);
	                  } },
	                ' ',
	                item.name
	              )
	            );
	          });
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(WriteForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        { title: '\u501F\u6B3E\u6838\u9500\u8BE6\u60C5' },
	        _react2.default.createElement(_antd.Table, {
	          rowKey: function rowKey(record) {
	            return record.uuid;
	          },
	          columns: this.columns(),
	          dataSource: data,
	          pagination: false,
	          size: 'small'
	        })
	      );
	    }
	  }]);
	
	  return WriteForm;
	}(_react.Component);
	
	exports.default = WriteForm;

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.submit = function (e) {
	      var arr = _this.state.arr;
	
	      var paramsArr = [];
	      var sum = 0;
	
	      if (e) {
	        e.preventDefault();
	      }
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!arr[0] && !arr[1]) {
	          _antd.message.error('请选择核销类型');
	          return;
	        }
	
	        if (arr[0]) {
	          if (values.type0) {
	            if (values.money0) {
	              arr[0].type = 0;
	              arr[0].price = values.money0;
	              sum += arr[0].price;
	              paramsArr.push(arr[0]);
	            } else {
	              _antd.message.error('借款归还信息填写不完整，如果不需要请取消选择');
	              return;
	            }
	          }
	        }
	
	        if (arr[1]) {
	          if (values.type1) {
	            if (values.money1 && values.files && values.files.length > 0) {
	              arr[1].type = 1;
	              arr[1].price = values.money1;
	              arr[1].files = values.files;
	              sum += arr[1].price;
	              paramsArr.push(arr[1]);
	            } else {
	              _antd.message.error('发票冲销信息填写不完整，如果不需要请取消选择');
	              return;
	            }
	          }
	        }
	
	        if (sum !== +_this.props.data.price) {
	          _antd.message.error('核销金额与借款金额不一致');
	          return;
	        }
	
	        _this.setState({
	          visibleFlag: false
	        });
	
	        _this.props.handleSubmit(paramsArr);
	      });
	    };
	
	    _this.changeFlag = function (index, e) {
	      var arr = _this.state.arr;
	
	      var loanUuid = _this.props.data.uuid;
	      if (e.target.checked) {
	        arr[index] = {
	          loanUuid: loanUuid
	        };
	      } else {
	        arr[index] = null;
	        _this.props.form.resetFields('money' + index);
	        _this.changeMoney(3);
	      }
	
	      _this.setState({
	        arr: arr
	      });
	    };
	
	    _this.changeMoney = function (index, e) {
	      var num0 = +_this.props.form.getFieldValue('money0') || 0;
	      var num1 = +_this.props.form.getFieldValue('money1') || 0;
	      index === 0 && (num0 = +e);
	      index === 1 && (num1 = +e);
	      var sum = num0 + num1;
	      _this.setState({
	        sum: sum
	      });
	      return e;
	    };
	
	    _this.state = {
	      visibleFlag: true,
	      arr: [{}, {}],
	      sum: 0
	    };
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var arr = this.state.arr;
	      var data = this.props.data;
	
	      var loanUuid = data.uuid;
	      arr[0].loanUuid = loanUuid;
	      arr[1].loanUuid = loanUuid;
	      this.setState({
	        arr: arr
	      });
	    }
	
	    // 改变复选框
	
	
	    // 改变金额
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props$data = this.props.data,
	          data = _props$data === undefined ? {} : _props$data;
	      var _state = this.state,
	          arr = _state.arr,
	          visibleFlag = _state.visibleFlag;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: {
	          xs: { span: 24 },
	          sm: { span: 8 }
	        },
	        wrapperCol: {
	          xs: { span: 24 },
	          sm: { span: 16 }
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: this.props.title,
	          visible: visibleFlag,
	          onOk: this.submit,
	          onCancel: this.props.cancel,
	          width: '50%'
	        },
	        _react2.default.createElement(
	          _antd.Row,
	          { style: { marginBottom: '15px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 8 },
	            '\u501F\u6B3E\u91D1\u989D\uFF1A',
	            _react2.default.createElement(
	              'span',
	              null,
	              data.price
	            ),
	            '\u5143'
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            '\u501F\u51FA\u65F6\u95F4\uFF1A',
	            data.createTime ? _moment2.default.unix(data.createTime / 1000).format('YYYY-MM-DD HH:MM') : ''
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          {
	            style: {
	              backgroundColor: '#FAFAFA',
	              height: '40px',
	              lineHeight: '40px',
	              fontWeight: '900',
	              borderBottom: '1px solid #E8E8E8'
	            }
	          },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 9, style: { paddingLeft: '20px' } },
	            '\u9009\u62E9\u6838\u9500\u7C7B\u578B'
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 7 },
	            '\u91D1\u989D'
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 8 },
	            '\u9644\u4EF6(\u53D1\u7968)'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Form,
	          Object.assign({}, formItemLayout, { onSubmit: this.submit }),
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { marginTop: '15px', borderBottom: '1px solid #E8E8E8' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                getFieldDecorator('type0', {
	                  initialValue: true
	                })(_react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_antd.Checkbox, { onChange: function onChange() {
	                      return _this2.changeFlag(0);
	                    }, defaultChecked: true }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u501F\u6B3E\u5F52\u8FD8'
	                  )
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                getFieldDecorator('money0', {
	                  getValueFromEvent: function getValueFromEvent(e) {
	                    return _this2.changeMoney(0, e);
	                  }
	                })(_react2.default.createElement(_antd.InputNumber, {
	                  placeholder: '\u8BF7\u586B\u5199\u91D1\u989D',
	                  min: 0,
	                  max: +data.price,
	                  style: { width: '100%' },
	                  disabled: !arr[0]
	                }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { marginTop: '15px', borderBottom: '1px solid #E8E8E8' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                getFieldDecorator('type1', { initialValue: true })(_react2.default.createElement(
	                  'div',
	                  null,
	                  _react2.default.createElement(_antd.Checkbox, { onChange: function onChange() {
	                      return _this2.changeFlag(1);
	                    }, defaultChecked: true }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u53D1\u7968\u51B2\u9500'
	                  )
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                getFieldDecorator('money1', {
	                  getValueFromEvent: function getValueFromEvent(e) {
	                    return _this2.changeMoney(1, e);
	                  }
	                })(_react2.default.createElement(_antd.InputNumber, {
	                  placeholder: '\u8BF7\u586B\u5199\u91D1\u989D',
	                  min: 0,
	                  max: +data.price,
	                  style: { width: '100%' },
	                  disabled: !arr[1]
	                }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                getFieldDecorator('files')(_react2.default.createElement(_UploadFile2.default, { type: 'ghost', disabled: !arr[1], isPreview: true }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'start', align: 'middle', style: { marginTop: '15px' } },
	            _react2.default.createElement(_antd.Col, { span: 1 }),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              '\u6838\u9500\u91D1\u989D\u7EDF\u8BA1'
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _util2.default.numberFormat(this.state.sum, 2, '.', ','),
	              '\u5143'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(IndexModal);

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _reactRedux = __webpack_require__(5);
	
	var _expend_type = __webpack_require__(80);
	
	var _company_list = __webpack_require__(96);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _loan = __webpack_require__(152);
	
	var _FormBase = __webpack_require__(706);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      delete item.apportionType;
	      _this.saveLoan(item);
	    };
	
	    _this.loanWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _loan.queryLoanWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveLoan = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _loan.querySaveLoan)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataInfo = this.state.dataInfo;
	
	      this.setState({ dataInfo: dataInfo });
	      this.loanWorkflow();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	      dispatch((0, _company_list.getCompanyList)());
	    }
	
	    /**
	     * 提交借款
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, {
	          data: this.state.dataInfo,
	          handSubmit: this.handSubmit,
	          isSubmitting: isSubmitting
	        }),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance })
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(Page);

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _loan = __webpack_require__(152);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableStaticOrg = __webpack_require__(707);
	
	var _TableStaticOrg2 = _interopRequireDefault(_TableStaticOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getLoanOrgStatic = function (params) {
	      (0, _loan.queryLoanOrgStatic)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getLoanOrgStatic(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableStaticOrg2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _reactRouter = __webpack_require__(8);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _loan = __webpack_require__(152);
	
	var _FormBase = __webpack_require__(706);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveLoan(item);
	    };
	
	    _this.loanWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _loan.queryLoanWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveLoan = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _loan.querySaveLoan)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.deleteLoan = function () {
	      (0, _loan.queryDeleteLoan)({
	        uuid: _this.props.data.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataInfo = this.state.dataInfo;
	
	      this.setState({ dataInfo: dataInfo });
	      this.loanWorkflow();
	    }
	
	    /**
	     * 提交借款
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, Object.assign({
	          data: this.props.data,
	          handSubmit: this.handSubmit,
	          handleDelete: this.deleteLoan,
	          isSubmitting: isSubmitting
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _loan = __webpack_require__(152);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableStaticOrg = __webpack_require__(707);
	
	var _TableStaticOrg2 = _interopRequireDefault(_TableStaticOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getLoanIncubatorStatic = function (params) {
	      (0, _loan.queryLoanIncubatorStatic)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getLoanIncubatorStatic(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableStaticOrg2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _expend_type = __webpack_require__(80);
	
	var _company_list = __webpack_require__(96);
	
	var _loan = __webpack_require__(152);
	
	var _PageEdit = __webpack_require__(1655);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1659);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getLoanInfo = function () {
	      (0, _loan.queryLoanInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getLoanWriteInfo = function () {
	      (0, _loan.queryLoanWriteInfo)({
	        loanUuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            writeDataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getLoanInfo();
	      this.getLoanWriteInfo();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	      dispatch((0, _company_list.getCompanyList)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          writeDataInfo = _state.writeDataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo, writeData: writeDataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(PageInfo);

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _loan = __webpack_require__(152);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpensesMy = __webpack_require__(1662);
	
	var _TableExpensesMy2 = _interopRequireDefault(_TableExpensesMy);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getLoanMyList = function (params) {
	      _this.setState({ loading: true });
	      (0, _loan.queryLoanMyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getLoanMyList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        type: 'mine',
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/l_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u501F\u6B3E'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpensesMy2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _WorkflowOp = __webpack_require__(134);
	
	var _WorkflowOp2 = _interopRequireDefault(_WorkflowOp);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _loan = __webpack_require__(152);
	
	var _FormOpen = __webpack_require__(1650);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	var _FormWrite = __webpack_require__(1651);
	
	var _FormWrite2 = _interopRequireDefault(_FormWrite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item, type) {
	      if (type === 'save') {
	        _this.saveLoan(item);
	      }
	    };
	
	    _this.saveLoan = function (item) {
	      (0, _loan.querySaveLoan)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('保存成功');
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.doTask = function (pass, refuse) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackLoan(item);
	          break;
	        case 'next':
	          _this.nextLoan(item);
	          break;
	        case 'return':
	          _this.returnLoan(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackLoan = function (params) {
	      (0, _loan.queryCallbackLoan)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextLoan = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _loan.queryNextLoan)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.setState({ isLoading: false });
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnLoan = function (params, refuse) {
	      (0, _loan.queryReturnLoan)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null
	          );
	        }
	      }, {
	        title: '操作内容',
	        dataIndex: 'operating'
	      }, {
	        title: '处理意见',
	        dataIndex: 'refuse'
	      }];
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	      var writeData = this.props.writeData;
	
	      this.setState({ dataInfo: data, writeDataInfo: writeData });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data,
	        writeDataInfo: nextProps.writeData
	      });
	    }
	
	    /**
	     * 提交借款
	     */
	
	
	    /**
	     * 保存
	     */
	
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          writeDataInfo = _state.writeDataInfo,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowOp2.default, {
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_FormOpen2.default, Object.assign({
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          doTask: this.doTask,
	          watchTask: this.watchTask
	        }, this.props)),
	        writeDataInfo && writeDataInfo.length > 0 ? _react2.default.createElement(_FormWrite2.default, { data: writeDataInfo }) : null,
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'loan', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _loan = __webpack_require__(152);
	
	var _TableExpenses = __webpack_require__(1661);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getLoanList = function (params) {
	      _this.setState({ loading: true });
	      (0, _loan.queryLoanList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getLoanList(params);
	    };
	
	    _this.writeLoan = function (params) {
	      (0, _loan.querySaveWriteLoan)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.loadData();
	        } else {
	          _antd.message.error(res.message);
	          _this.loadData();
	        }
	      });
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        loading: false,
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        writeLoan: this.writeLoan,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(36);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _ModalWrite = __webpack_require__(1652);
	
	var _ModalWrite2 = _interopRequireDefault(_ModalWrite);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.switchModalWrite = function (data) {
	      var modalWriteVisible = _this.state.modalWriteVisible;
	
	      _this.setState({
	        modalWriteVisible: !modalWriteVisible,
	        data: data
	      });
	    };
	
	    _this.writeLoan = function (params) {
	      _this.props.writeLoan(params);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '借款单号',
	        dataIndex: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/l_manage/open/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '借款公司',
	        dataIndex: 'company',
	        key: 'company'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5BA1\u6838\u4E2D'
	            );
	          }
	          if (record.status === 1 && record.writeOffFlag === 0) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210(\u672A\u6838\u9500)'
	            );
	          }
	          if (record.status === 1 && record.writeOffFlag === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: '#515659' } },
	              '\u5DF2\u5B8C\u6210(\u5DF2\u6838\u9500)'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u7F16\u8F91'
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/l_manage/open/' + record.uuid },
	              '\u67E5\u770B'
	            ),
	            record.status === 1 && record.writeOffFlag === 0 ? _react2.default.createElement(_antd.Divider, { type: 'vertical' }) : null,
	            record.status === 1 && record.writeOffFlag === 0 ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { onClick: function onClick() {
	                    return _this.switchModalWrite(record);
	                  } },
	                '\u6838\u9500'
	              )
	            ) : null
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource,
	      modalWriteVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          data = _state.data,
	          _state$dataSource = _state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: list,
	          pagination: pagination,
	          rowKey: 'uuid',
	          loading: this.props.loading,
	          onChange: this.handleChange
	        }),
	        this.state.modalWriteVisible ? _react2.default.createElement(_ModalWrite2.default, Object.assign({
	          title: '\u501F\u6B3E\u6838\u9500',
	          data: data,
	          cancel: this.switchModalWrite,
	          handleSubmit: this.writeLoan
	        }, this.props)) : null
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.handleChange = function (pagination, filters, sorter) {
	      _this.props.onChange(pagination, filters, sorter);
	    };
	
	    _this.columns = function () {
	      var pagination = _this.state.dataSource.pagination;
	
	      var current = pagination.current || 1;
	      var total = pagination.total || 0;
	      var config = [{
	        title: '编号',
	        dataIndex: 'num',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            total - (current - 1) * 15 - index
	          );
	        }
	      }, {
	        title: '借款单号',
	        dataIndex: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/l_manage/open/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '借款公司',
	        dataIndex: 'company',
	        key: 'company'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '当前环节-处理人',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          var instance = record.instance || {};
	          var currentActivity = instance.currentActivity || {};
	          var name = currentActivity.name,
	              processorName = currentActivity.processorName;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            currentActivity.uuid ? (name || '') + '-' + (processorName || '') : ''
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          record.status = record.status === 0 || record.status === 1 ? record.status : 2;
	          if (record.status === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '\u5BA1\u6838\u4E2D'
	            );
	          }
	          if (record.status === 1) {
	            return _react2.default.createElement(
	              'span',
	              { style: { color: 'red' } },
	              '\u5DF2\u5B8C\u6210'
	            );
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            '\u5F85\u7F16\u8F91'
	          );
	        }
	      }];
	      if (_this.props.type === 'mine') {
	        config = config.filter(function (item) {
	          return item.dataIndex !== 'createUserName';
	        });
	      }
	      return config;
	    };
	
	    _this.state = {
	      dataSource: _this.props.dataSource
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataSource: nextProps.dataSource
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	      return _react2.default.createElement(_antd.Table, {
	        columns: this.columns(),
	        dataSource: list,
	        pagination: pagination,
	        rowKey: 'uuid',
	        onChange: this.handleChange
	      });
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(36);
	
	var _loan = __webpack_require__(152);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.getLoanOrgRecord = function (params) {
	      (0, _loan.queryLoanOrgRecord)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataSource: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 15
	              }
	            }
	          });
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.loadData = function () {
	      var condition = _this.state.condition;
	
	      var params = Object.assign({
	        companyUuid: _this.props.org.companyUuid,
	        condition: condition
	      }, _this.pagination);
	      _this.getLoanOrgRecord(params);
	    };
	
	    _this.onChange = function () {};
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.loadData();
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '借款单号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/l_manage/open/' + record.uuid },
	            text || '查看'
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price'
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD')
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'long',
	        render: function render(text, record) {
	          return record.status ? _react2.default.createElement(
	            'span',
	            null,
	            '\u5DF2\u5B8C\u6210',
	            _react2.default.createElement(
	              'span',
	              null,
	              '(\u7528\u65F6',
	              record.consume,
	              '\u5929)'
	            )
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u5BA1\u6838\u4E2D'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      },
	      condition: ''
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	      var org = this.props.org;
	
	      return _react2.default.createElement(
	        _antd.Drawer,
	        {
	          visible: true,
	          width: '70%',
	          title: org.company,
	          onClose: function onClose() {
	            return _this2.props.handleVisible(false);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(_antd.Col, { span: 13 }),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          ),
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            dataSource: list,
	            pagination: pagination,
	            rowKey: 'uuid',
	            size: 'small',
	            onChange: this.handleTableChange
	          })
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(2);
	
	var _reactHtmlTableToExcel = __webpack_require__(308);
	
	var _reactHtmlTableToExcel2 = _interopRequireDefault(_reactHtmlTableToExcel);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _budget = __webpack_require__(30);
	
	var _BackBtn = __webpack_require__(12);
	
	var _finance = __webpack_require__(61);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _getAllType = __webpack_require__(168);
	
	var _getAllType2 = _interopRequireDefault(_getAllType);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _operational_statis = __webpack_require__(735);
	
	var _income_info = __webpack_require__(233);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var date = new Date();
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (searchDate) {
	      var groupUuids = _this.state.groupUuids;
	
	      _this.setState({
	        isLoading: true
	      });
	      searchDate.beginDate = (0, _moment2.default)(searchDate.beginDate).format('YYYY-MM-DD');
	      searchDate.endDate = (0, _moment2.default)(searchDate.endDate).format('YYYY-MM-DD');
	      searchDate.groupUuids = groupUuids;
	      groupUuids.length === 0 ? (0, _finance.queryFinanceOperationalStatistics)(searchDate).then(function (res) {
	        if (res.statusCode === 200) {
	          var ignoreArr = res.data.ignore;
	          _this.setState({
	            data: ignoreArr,
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      }) : (0, _budget.queryAnalysisOperational)(searchDate).then(function (res) {
	        if (res.statusCode === 200) {
	          var ignoreArr = res.data.ignore;
	          _this.setState({
	            data: ignoreArr,
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.initChecked = function (org) {
	      var checkedUUids = _this.state.checkedUUids;
	
	
	      if (checkedUUids.length > 0) {
	        return _this.loopchangeCheck(checkedUUids, org);
	      }
	
	      org.length > 0 && org.map(function (item) {
	        item.checked = true;
	        checkedUUids.push(item.uuid);
	        return item;
	      });
	      _this.setState({
	        checkedUUids: checkedUUids
	      });
	      return org;
	    };
	
	    _this.loadOrg = function () {
	      var groupUuids = _this.state.groupUuids;
	
	      groupUuids.length === 0 ? (0, _finance.queryFinanceBooksOrg)().then(function (res) {
	        if (res.statusCode === 200) {
	          var org = _this.initChecked(res.data);
	          _this.setState({
	            org: org,
	            wid: res.data.length * 200 + 420
	          });
	        }
	      }) : (0, _finance.queryFinanceBooksOrgList)({
	        groupUuids: groupUuids
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          var org = _this.initChecked(res.data);
	          _this.setState({
	            org: org,
	            wid: res.data.length * 200 + 420
	          });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          propsDate = _this$props$form$getF.date;
	
	      var params = {};
	      params.beginDate = propsDate[0];
	      params.endDate = propsDate[1];
	      _localDb2.default.set('date', params);
	      _this.loadData(params);
	    };
	
	    _this.search = function (condition) {
	      _this.condition = condition;
	      _this.loadData(1);
	    };
	
	    _this.toDetail = function (uuid, igNore, typeUid) {
	      // igNore:0不忽略，1忽略
	      var dispatch = _this.props.dispatch;
	      var type = _this.state.type;
	
	      var types = [];
	      var notTo = false;
	      var ignoreFlag = void 0;
	      if (typeUid !== 'payCurrents') {
	        type.forEach(function (item) {
	          if (item.value === typeUid) {
	            types = item.children || [typeUid];
	            var b = item.notTo;
	            notTo = b;
	          }
	        });
	      } else {
	        ignoreFlag = 2;
	      }
	      dispatch((0, _income_info.saveIncomeInfo)({
	        isShowPart: true,
	        types: types,
	        date: _this.props.form.getFieldsValue().date,
	        igLevel: 1,
	        ignoreFlag: ignoreFlag
	      }));
	      if (!notTo) {
	        if (types.every(function (item) {
	          return item.indexOf('2') === 0;
	        })) {
	          _this.props.router.push('/finance/operational/' + uuid + '/buddget');
	        } else {
	          _this.props.router.push('/finance/statis/' + uuid + '/detail');
	        }
	      }
	    };
	
	    _this.toIgnore = function () {
	      // igNore:0不忽略，1忽略
	      var dispatch = _this.props.dispatch;
	
	      dispatch((0, _income_info.saveIncomeInfo)({
	        isShowPart: true,
	        // 2 是走账数据
	        isNonBusiness: true
	      }));
	      _this.props.router.push('/finance/statis/ignore');
	    };
	
	    _this.searchBar = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var groupUuids = _this.state.groupUuids;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: _this.handleSubmit },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'start' },
	          groupUuids.length !== 0 ? _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(_BackBtn.BackBtn, null)
	          ) : null,
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              getFieldDecorator('date', {
	                initialValue: _this.state.initDate
	              })(_react2.default.createElement(RangePicker, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit', style: { marginLeft: '10px' } },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.toYearStatic = function (company) {
	      _this.props.router.push({
	        pathname: '/finance/operational/' + company.uuid + '/year',
	        query: {
	          companyName: company.companyName
	        }
	      });
	    };
	
	    _this.loopchangeCheck = function (checkedUUids, org) {
	      org.length > 0 && org.map(function (item) {
	        var isChecked = checkedUUids.some(function (uuid) {
	          return item.uuid === uuid;
	        });
	        item.checked = !!isChecked;
	        return item;
	      });
	      return org;
	    };
	
	    _this.changeCheck = function (key) {
	      var _this$state = _this.state,
	          checkedUUids = _this$state.checkedUUids,
	          org = _this$state.org;
	
	      var isChecked = checkedUUids.some(function (item) {
	        return item === key;
	      });
	      if (isChecked) {
	        checkedUUids = checkedUUids.filter(function (item) {
	          return item !== key;
	        });
	      } else {
	        checkedUUids.push(key);
	      }
	      org = _this.loopchangeCheck(checkedUUids, org);
	      _this.setState({
	        checkedUUids: checkedUUids,
	        org: org
	      });
	    };
	
	    _this.columns = function () {
	      var type = _this.state.type;
	
	      var columns = _this.state.org.map(function (item, index) {
	        var config = {};
	        config.title = _react2.default.createElement(
	          'p',
	          { style: { textAlign: 'center' } },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_antd.Checkbox, { checked: item.checked, onClick: function onClick() {
	                return _this.changeCheck(item.uuid);
	              } }),
	            _react2.default.createElement(
	              'span',
	              { style: { marginLeft: '5px' } },
	              index + 1
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.toYearStatic(item);
	              } },
	            item.companyName
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            item.date ? '\u622A\u6B62' + item.date : ''
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            item.remark ? '' + item.remark : ''
	          )
	        );
	        var orgUuid = item.uuid;
	        config.dataIndex = item.uuid;
	        config.key = item.uuid;
	        config.width = 200;
	        config.render = function (text, record) {
	          if (text === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '-'
	            );
	          }
	          return _this.handlerItem(text, record, orgUuid);
	        };
	        return config;
	      });
	      columns.unshift({
	        title: _react2.default.createElement(
	          'p',
	          { style: { textAlign: 'center' } },
	          _react2.default.createElement('a', null),
	          _react2.default.createElement('p', null)
	        ),
	        dataIndex: 'type',
	        key: 'type',
	        width: 200,
	        fixed: 'left',
	        render: function render(text) {
	          var typeName = '';
	          var gs = '';
	          var style = {};
	          if (type.length > 0) {
	            type.forEach(function (item) {
	              if (text === item.value) {
	                typeName = '' + (item.index ? item.index + '\u3001' : '') + item.key;
	                if (item.color) {
	                  style.color = item.color;
	                }
	                if (item.indexArr) {
	                  gs = item.indexArr.join('+');
	                  gs = '(' + gs + ')';
	                }
	                return typeName;
	              }
	            });
	          }
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: style },
	              typeName
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              gs
	            )
	          );
	        }
	      });
	      columns.push({
	        title: '合计',
	        dataIndex: 'sum',
	        key: 'sum',
	        width: 220,
	        fixed: 'right',
	        render: function render(text, record) {
	          return _this.handlerItem(text, record, undefined);
	        }
	      });
	      return columns;
	    };
	
	    _this.setShow = function (key) {
	      var _this$state2 = _this.state,
	          show = _this$state2.show,
	          showChecked = _this$state2.showChecked;
	
	      var flag = false;
	      flag = showChecked.some(function (item) {
	        return item === key;
	      });
	      if (flag) {
	        showChecked = showChecked.filter(function (item) {
	          return item !== key;
	        });
	      } else {
	        showChecked.push(key);
	      }
	      if (showChecked.length === 2) {
	        show = 'all';
	      } else if (showChecked.length === 1) {
	        show = showChecked[0];
	      }
	
	      _this.setState({
	        show: show,
	        showChecked: showChecked
	      });
	    };
	
	    _this.handlerItemSum = function (record) {
	      var checkedUUids = _this.state.checkedUUids;
	
	      var ignoreSum = 0;
	      var ignoreItem = 0;
	      Object.keys(record).forEach(function (key) {
	        if (checkedUUids.includes(key)) {
	          ignoreItem = parseFloat(record[key]) * 100;
	          ignoreSum += ignoreItem;
	        }
	      });
	      ignoreSum /= 100;
	      return {
	        ignoreSum: ignoreSum
	      };
	    };
	
	    _this.handlerItem = function (text, item, orgUuid) {
	      var ignoreFont = void 0;
	      if (orgUuid) {
	        ignoreFont = _util2.default.numberFormat(text, 2, '.', ',');
	      } else {
	        var sum = _this.handlerItemSum(item);
	        ignoreFont = _util2.default.numberFormat(sum.ignoreSum, 2, '.', ',');
	      }
	      if (ignoreFont === '0.00') {
	        return _react2.default.createElement(
	          'span',
	          null,
	          '-'
	        );
	      }
	      if (orgUuid !== undefined) {
	        return _react2.default.createElement(
	          'a',
	          { onClick: function onClick() {
	              return _this.toDetail(orgUuid, 1, item.type);
	            } },
	          ignoreFont
	        );
	      }
	      return _react2.default.createElement(
	        'a',
	        null,
	        ignoreFont
	      );
	    };
	
	    _this.state = {
	      org: props.operationalStatisStatus.org,
	      isLoading: false,
	      type: props.operationalStatisStatus.type,
	      data: props.operationalStatisStatus.data,
	      wid: props.operationalStatisStatus.wid,
	      checkedUUids: props.operationalStatisStatus.checkedUUids,
	      show: 'all', // all显示实际和预算，
	      showChecked: ['ignore', 'noIgnore'],
	      initDate: _localDb2.default.get('date') ? [(0, _moment2.default)(_localDb2.default.get('date').beginDate), (0, _moment2.default)(_localDb2.default.get('date').endDate)] : [_moment2.default.unix(date.getTime() / 1000), _moment2.default.unix(date.getTime() / 1000)],
	      groupUuids: _this.props.location.query.groupUuids || []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.loadOrg();
	      (0, _getAllType2.default)().then(function (res) {
	        _this2.setState({
	          type: res
	        });
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var table = document.getElementsByClassName('ant-table-scroll')[0];
	      table.id = 'table-to-xls';
	
	      var Btn = document.getElementsByClassName('ant-table-body')[0];
	      var scrollLeft = this.props.operationalStatisStatus.scrollLeft;
	      var scrollTop = this.props.operationalStatisStatus.scrollTop;
	
	      _reactDom2.default.findDOMNode(Btn).scrollTo(scrollLeft, scrollTop);
	      var params = {};
	      var initDate = this.state.initDate;
	
	      params.beginDate = initDate[0];
	      params.endDate = initDate[1];
	      this.loadData(params);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var scrollLeft = document.getElementsByClassName('ant-table-body')[0].scrollLeft;
	      var scrollTop = document.getElementsByClassName('ant-table-body')[0].scrollTop;
	      var _state = this.state,
	          wid = _state.wid,
	          checkedUUids = _state.checkedUUids,
	          org = _state.org,
	          data = _state.data,
	          type = _state.type;
	
	      this.props.dispatch((0, _operational_statis.getLocalOperationalStatis)({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        checkedUUids: checkedUUids,
	        data: data,
	        wid: wid,
	        org: org,
	        type: type
	      }));
	    }
	
	    /**
	     * 获取资金统计列表
	     */
	
	
	    /**
	     * 获取账号列表
	     */
	
	
	    /**
	     * 跳转至按年统计详情页
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          data = _state2.data,
	          wid = _state2.wid,
	          isLoading = _state2.isLoading;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'statis-box' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex' },
	          _react2.default.createElement(
	            _antd.Col,
	            { style: { textAlign: 'right' }, span: 12 },
	            this.searchBar()
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12, style: { textAlign: 'right' } },
	            _react2.default.createElement(_reactHtmlTableToExcel2.default, {
	              id: 'test-table-xls-button',
	              className: 'download-table-xls-button ant-btn',
	              table: 'table-to-xls',
	              filename: '\u8D44\u91D1\u7EDF\u8BA1',
	              sheet: '\u8D44\u91D1\u7EDF\u8BA1',
	              style: {
	                marginTop: '4px'
	              },
	              buttonText: '\u5BFC\u51FA'
	            })
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: data,
	          loading: isLoading,
	          bordered: true,
	          size: 'small',
	          scroll: { x: wid, y: _util2.default.pageHeight() - 215 },
	          style: {},
	          pagination: false
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    operationalStatisStatus: state.operational_statis
	  };
	})(_antd.Form.create()(Index));

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _budget = __webpack_require__(30);
	
	var _income_info = __webpack_require__(233);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _getAllType = __webpack_require__(168);
	
	var _getAllType2 = _interopRequireDefault(_getAllType);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _finance = __webpack_require__(61);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 按年统计
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var date = new Date();
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function () {
	      var params = {};
	      var isBalance = _this.props.location.query.isBalance;
	
	      _this.setState({
	        isLoading: true
	      });
	
	      params.bookUuid = _this.props.params.uuid;
	      params.year = _this.year || _this.state.year;
	      params.groupUuids = _this.props.params.uuid;
	
	      isBalance ? delete params.bookUuid && (0, _budget.queryAnalysisOperationalDetail)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var ignoreArr = res.data.ignore;
	          var data = [];
	          ignoreArr.map(function (item, index) {
	            var dataItem = {};
	            Object.keys(item).forEach(function (key) {
	              if (key !== 'type') {
	                var igItem = item[key] && item[key] !== '0' ? item[key] : '-';
	                dataItem[key] = '' + igItem;
	              } else if (key === 'type') {
	                dataItem[key] = item[key];
	              }
	            });
	            data.push(dataItem);
	            return ignoreArr;
	          });
	          _this.setState({
	            isLoading: false,
	            ignoreArr: ignoreArr
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      }) : delete params.groupUuids && (0, _finance.queryFinanceOperationalStatisticsDetail)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var ignoreArr = res.data.ignore;
	          var data = [];
	          ignoreArr.map(function (item, index) {
	            var dataItem = {};
	            Object.keys(item).forEach(function (key) {
	              if (key !== 'type') {
	                var igItem = item[key] && item[key] !== '0' ? item[key] : '-';
	                dataItem[key] = '' + igItem;
	              } else if (key === 'type') {
	                dataItem[key] = item[key];
	              }
	            });
	            data.push(dataItem);
	            return ignoreArr;
	          });
	          _this.setState({
	            isLoading: false,
	            ignoreArr: ignoreArr
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadOrg = function () {
	      (0, _finance.queryFinanceBooksOrg)().then(function (res) {});
	    };
	
	    _this.handleSubmit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          year = _this$props$form$getF.year;
	
	      _this.setState({
	        year: year
	      });
	      _this.year = year;
	      _localDb2.default.set('year', year);
	      _this.loadData();
	    };
	
	    _this.toDetail = function (uuid, igNore, typeUid, yearMonth) {
	      // igNore:0不忽略，1忽略
	      var dispatch = _this.props.dispatch;
	      var type = _this.state.type;
	
	      var types = [];
	      var notTo = false;
	      type.forEach(function (item, index) {
	        if (item.value === typeUid) {
	          types = item.children || [typeUid];
	          var b = item.notTo;
	          notTo = b;
	        }
	      });
	      dispatch((0, _income_info.saveIncomeInfo)({
	        isShowPart: true,
	        igNore: igNore,
	        types: types,
	        yearMonth: yearMonth
	      }));
	      if (!notTo) {
	        if (types.every(function (item) {
	          return item.indexOf('2') === 0;
	        })) {
	          _this.props.router.push('/finance/operational/' + uuid + '/buddget');
	        } else {
	          _this.props.router.push('/finance/statis/' + uuid + '/detail');
	        }
	      }
	    };
	
	    _this.searchBar = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      var year = date.getFullYear();
	      var years = [];
	      for (var i = year; i >= 2014; i--) {
	        years.push(i.toString());
	      }
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: _this.handleSubmit },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'end' },
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              getFieldDecorator('year', {
	                initialValue: _this.state.year
	              })(_react2.default.createElement(
	                _antd.Select,
	                { style: { width: '200px' } },
	                years.map(function (item, index) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item },
	                    item
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit', style: { marginLeft: '10px' } },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      var _this$state = _this.state,
	          type = _this$state.type,
	          year = _this$state.year;
	
	      _this.month = [{ title: year + '-01', uuid: '01' }, { title: year + '-02', uuid: '02' }, { title: year + '-03', uuid: '03' }, { title: year + '-04', uuid: '04' }, { title: year + '-05', uuid: '05' }, { title: year + '-06', uuid: '06' }, { title: year + '-07', uuid: '07' }, { title: year + '-08', uuid: '08' }, { title: year + '-09', uuid: '09' }, { title: year + '-10', uuid: '10' }, { title: year + '-11', uuid: '11' }, { title: year + '-12', uuid: '12' }];
	      var columns = _this.month.map(function (item, index) {
	        var config = {};
	        config.title = item.title;
	        config.dataIndex = item.uuid;
	        config.key = item.uuid;
	        config.width = 200;
	        config.render = function (text, record) {
	          if (text === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '-'
	            );
	          }
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.toDetail(item.uuid, 0, record.type);
	              } },
	            _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        };
	        return config;
	      });
	      columns.unshift({
	        title: '',
	        dataIndex: 'type',
	        key: 'type',
	        width: 200,
	        fixed: 'left',
	        render: function render(text, record) {
	          var typeName = '';
	          var style = {};
	          if (type.length > 0) {
	            type.forEach(function (item, index) {
	              if (text === item.value) {
	                typeName = item.key;
	                if (item.color) {
	                  style.color = item.color;
	                }
	                return typeName;
	              }
	            });
	          }
	
	          return _react2.default.createElement(
	            'span',
	            { style: style },
	            typeName
	          );
	        }
	      });
	      columns.push({
	        title: '合计',
	        dataIndex: 'sum',
	        key: 'sum',
	        width: 200,
	        fixed: 'right',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            { style: { color: '#108ee7' } },
	            _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      });
	      return columns;
	    };
	
	    _this.state = {
	      isLoading: false,
	      type: [],
	      ignoreArr: [],
	      year: _localDb2.default.get('year') || date.getFullYear()
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.loadOrg();
	      (0, _getAllType2.default)().then(function (res) {
	        _this2.setState({
	          type: res
	        });
	      });
	      this.company = this.props.location.query.companyName;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(this.state.year);
	    }
	
	    /**
	     * 获取资金统计列表
	     */
	
	
	    /**
	     * 获取账号列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          ignoreArr = _state.ignoreArr,
	          isLoading = _state.isLoading,
	          year = _state.year;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'statis-box' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-between' },
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(_BackBtn.BackBtn, null)
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { style: { textAlign: 'right' }, span: 12 },
	            this.searchBar()
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          id: 'table-to-xls',
	          columns: this.columns(),
	          dataSource: ignoreArr,
	          loading: isLoading,
	          scroll: { x: 2800, y: _util2.default.pageHeight() - 168 },
	          bordered: true,
	          size: 'small',
	          rowKey: function rowKey(record) {
	            return record.type;
	          },
	          title: function title() {
	            return _react2.default.createElement(
	              'p',
	              { style: { textAlign: 'Center' } },
	              _this3.company + '-' + year + '\u5E74\u8FD0\u8425\u6570\u5B57\u5206\u6790'
	            );
	          },
	          pagination: false
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    list: state.contract_type,
	    account_info: state.account_info
	  };
	})(_antd.Form.create()(Index));

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(36);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _ModalApportionShow = __webpack_require__(428);
	
	var _ModalApportionShow2 = _interopRequireDefault(_ModalApportionShow);
	
	var _attachment = __webpack_require__(27);
	
	var _payment = __webpack_require__(132);
	
	var _budget = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var budgetType = ['部门预算', '跨部门预算', '项目预算组'];
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.findTypeName = function (type) {
	      var typeName = '';
	      _this.props.expendType.forEach(function (item) {
	        if (type === item.value) {
	          typeName = item.key;
	        }
	      });
	      return typeName;
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.getBudgetGroupCandF = function (value, option) {
	      (0, _budget.queryBudgetGroupCandF)({
	        type: value,
	        userUuid: _this.state.dataItem.createUser
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            groupTip: res.data
	          });
	        }
	      });
	    };
	
	    _this.paymentIncomepart = function (incomepart, pagination) {
	      var params = {
	        incomepart: incomepart,
	        start: pagination.start || 0,
	        limit: pagination.limit || 15
	      };
	      var current = pagination.current || 1;
	      var start = pagination.start || 0;
	      (0, _payment.queryPaymentIncomepart)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          if (_this.state.isMore) {
	            _this.setState({
	              inLongList: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 15,
	                current: current,
	                start: start
	              }
	            });
	          } else {
	            _this.setState({
	              inShortList: res.data.slice(0, 5),
	              inLongList: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 15,
	                current: current,
	                start: start
	              }
	            });
	          }
	        }
	      });
	    };
	
	    _this.inExtra = function () {
	      var _this$state = _this.state,
	          isMore = _this$state.isMore,
	          inShortList = _this$state.inShortList,
	          inLongList = _this$state.inLongList;
	
	      if (inShortList && inLongList) {
	        if (!isMore) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { onClick: _this.getMore },
	            '\u66F4\u591A',
	            _react2.default.createElement(_antd.Icon, {
	              type: 'down',
	              style: {
	                fontSize: '10px',
	                paddingLeft: '3px',
	                position: 'relative',
	                top: '-1px'
	              }
	            })
	          );
	        }
	        return _react2.default.createElement(
	          _reactRouter.Link,
	          { onClick: _this.getLess },
	          '\u6536\u8D77',
	          _react2.default.createElement(_antd.Icon, {
	            type: 'up',
	            style: {
	              fontSize: '10px',
	              paddingLeft: '3px',
	              position: 'relative',
	              top: '-1px'
	            }
	          })
	        );
	      }
	      return null;
	    };
	
	    _this.getMore = function () {
	      _this.setState({
	        isMore: true
	      });
	    };
	
	    _this.getLess = function () {
	      _this.setState({
	        isMore: false
	      });
	    };
	
	    _this.toPage = function (record) {
	      _this.props.router.push({
	        pathname: '/finance/p_manage/open/' + record.uuid
	      });
	    };
	
	    _this.handleRejectVisible = function (flag) {};
	
	    _this.handleReturn = function (params) {
	      _this.props.doTask('return', params);
	      _this.handleRejectVisible(false);
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current,
	        current: pagination.current
	      };
	      var dataItem = _this.props.data;
	      _this.paymentIncomepart(dataItem.incomepart, _this.pagination);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '流水编号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { onClick: function onClick() {
	                return _this.toPage(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: '付款公司',
	        dataIndex: 'company',
	        key: 'company',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text || '-'
	          );
	        }
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _index2.default.numberFormat(text) : '-'
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text || '-'
	          );
	        }
	      }, {
	        title: '理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(text / 1000).format('YYYY-MM-DD');
	          return _react2.default.createElement(
	            'span',
	            null,
	            a
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          var a = _moment2.default.unix(record.finishTime / 1000);
	          var b = _moment2.default.unix(record.createTime / 1000);
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.finishTime ? _react2.default.createElement(
	              'span',
	              null,
	              _moment2.default.unix(record.finishTime / 1000).format('YYYY-MM-DD'),
	              _react2.default.createElement(
	                'span',
	                null,
	                '(\u7528\u65F6',
	                a.diff(b, 'days'),
	                '\u5929)'
	              )
	            ) : ''
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      visible: false,
	      dataItem: _this.props.data,
	      isMore: false,
	      pagination: {}
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataItem = this.state.dataItem;
	
	      !(+dataItem.budgetType === 1 || dataItem.instance && dataItem.instance.status === 1) && this.getBudgetGroupCandF(dataItem.type);
	
	      !(dataItem.instance && dataItem.instance.status === 1) && this.paymentIncomepart(dataItem.incomepart, this.state.pagination);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataItem: nextProps.data
	      });
	      if (nextProps.params.uuid !== this.props.params.uuid) {
	        window.location.reload();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          visible = _state.visible,
	          dataItem = _state.dataItem,
	          groupTip = _state.groupTip,
	          isMore = _state.isMore,
	          inShortList = _state.inShortList,
	          inLongList = _state.inLongList,
	          pagination = _state.pagination;
	
	
	      var files = dataItem.files || [];
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u4ED8\u6B3E\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u4ED8\u6B3E\u7C7B\u578B' },
	              this.findTypeName(dataItem.type),
	              _react2.default.createElement(
	                'span',
	                { className: 'lowspan' },
	                groupTip && groupTip.groupName ? _react2.default.createElement(
	                  'span',
	                  { style: { color: 'red' } },
	                  '\u8BE5\u8D39\u7528\u7C7B\u578B,',
	                  groupTip.groupName,
	                  '\u53EF\u7528\u4F59\u989D',
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    groupTip.current || 0
	                  ),
	                  '\u5143',
	                  groupTip.freeze ? _react2.default.createElement(
	                    'span',
	                    null,
	                    ', \u51BB\u7ED3',
	                    _react2.default.createElement(
	                      'span',
	                      null,
	                      groupTip.freeze || 0
	                    )
	                  ) : null
	                ) : null
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u4ED8\u6B3E\u91D1\u989D' },
	              dataItem.price,
	              '\u5143'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7533\u8BF7\u4EBA\u5458' },
	              dataItem.createUserName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u6765\u6E90' },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.handleVisible(true);
	                  } },
	                budgetType[dataItem.budgetType]
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u4ED8\u6B3E\u516C\u53F8' },
	              dataItem.company
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u6536\u6B3E\u65B9' },
	              dataItem.incomepart
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u6536\u6B3E\u65B9\u8D26\u6237' },
	              dataItem.account
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u6536\u6B3E\u65B9\u5F00\u6237\u884C' },
	              dataItem.bank
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u4ED8\u6B3E\u51ED\u8BC1' },
	              _react2.default.createElement(
	                'div',
	                null,
	                files.map(function (item) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: item.uuid },
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: function onClick() {
	                          return (0, _attachment.queryFilePreview)(item);
	                        } },
	                      ' ',
	                      item.name
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u4ED8\u6B3E\u8BF4\u660E' },
	              dataItem.reason
	            )
	          ),
	          inShortList && inShortList.length > 0 ? _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'div',
	              { style: { color: 'red', textAlign: 'center', padding: '30px 0' } },
	              '\u6536\u6B3E\u65B9\u5386\u53F2\u6536\u6B3E\u8BB0\u5F55',
	              ' ',
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#1890FF', cursor: 'pointer' } },
	                this.inExtra()
	              )
	            ),
	            _react2.default.createElement(_antd.Table, {
	              columns: this.columns(),
	              dataSource: isMore ? inLongList : inShortList,
	              rowKey: 'uuid',
	              pagination: isMore ? pagination : false,
	              onChange: this.handleTableChange
	            })
	          ) : null
	        ),
	        visible ? _react2.default.createElement(_ModalApportionShow2.default, {
	          onCancel: this.handleVisible,
	          dataInfo: {},
	          dataItem: dataItem,
	          visible: visible,
	          onOk: this.handleOk,
	          company: this.props.company,
	          expendType: this.props.expendType
	        }) : null
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = Open;

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _reactRedux = __webpack_require__(5);
	
	var _expend_type = __webpack_require__(80);
	
	var _company_list = __webpack_require__(96);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _payment = __webpack_require__(132);
	
	var _FormBase = __webpack_require__(708);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.savePayment(item);
	    };
	
	    _this.paymentWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _payment.queryPaymentWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.savePayment = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _payment.querySavePayment)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      company: [],
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataInfo = this.state.dataInfo;
	
	      this.setState({ dataInfo: dataInfo });
	      this.paymentWorkflow();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	      dispatch((0, _company_list.getCompanyList)());
	    }
	
	    /**
	     * 提交付款
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, Object.assign({
	          data: this.state.dataInfo,
	          company: this.state.company,
	          handSubmit: this.handSubmit,
	          isSubmitting: isSubmitting
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance })
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(Page);

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _payment = __webpack_require__(132);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableStaticOrg = __webpack_require__(710);
	
	var _TableStaticOrg2 = _interopRequireDefault(_TableStaticOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      if (res.statusCode === 200) {
	        _this.setState({
	          dataSource: {
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              pageSize: 15,
	              current: _this.current
	            }
	          }
	        });
	      } else {
	        _antd.message.error(res.message);
	        _this.setState({
	          dataSource: {
	            list: [],
	            pagination: {
	              total: 0,
	              pageSize: 15,
	              current: 1
	            }
	          }
	        });
	      }
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getPaymentOrgStatic = function (params) {
	      (0, _payment.queryPaymentOrgStatic)(params).then(function (res) {
	        _this.setTableData(res);
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getPaymentOrgStatic(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/p_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u4ED8\u6B3E'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableStaticOrg2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _reactRouter = __webpack_require__(8);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _payment = __webpack_require__(132);
	
	var _FormBase = __webpack_require__(708);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.savePayment(item);
	    };
	
	    _this.paymentWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _payment.queryPaymentWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.savePayment = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _payment.querySavePayment)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.deletePayment = function () {
	      (0, _payment.queryDeletePayment)({
	        uuid: _this.props.data.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataInfo = this.state.dataInfo;
	
	      this.setState({ dataInfo: dataInfo });
	      this.paymentWorkflow();
	    }
	
	    /**
	     * 提交报销
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, Object.assign({
	          data: this.props.data,
	          handSubmit: this.handSubmit,
	          handleDelete: this.deletePayment,
	          isSubmitting: isSubmitting
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _payment = __webpack_require__(132);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableStaticOrg = __webpack_require__(710);
	
	var _TableStaticOrg2 = _interopRequireDefault(_TableStaticOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      if (res.statusCode === 200) {
	        _this.setState({
	          dataSource: {
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              pageSize: 15,
	              current: _this.current
	            }
	          }
	        });
	      } else {
	        _antd.message.error(res.message);
	        _this.setState({
	          dataSource: {
	            list: [],
	            pagination: {
	              total: 0,
	              pageSize: 15,
	              current: 1
	            }
	          }
	        });
	      }
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getPaymentIncubatorStatic = function (params) {
	      (0, _payment.queryPaymentIncubatorStatic)(params).then(function (res) {
	        _this.setTableData(res);
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getPaymentIncubatorStatic(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/p_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u4ED8\u6B3E'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableStaticOrg2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _reactRedux = __webpack_require__(5);
	
	var _expend_type = __webpack_require__(80);
	
	var _company_list = __webpack_require__(96);
	
	var _payment = __webpack_require__(132);
	
	var _PageEdit = __webpack_require__(1669);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1673);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getPaymentInfo = function () {
	      (0, _payment.queryPaymentInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPaymentInfo();
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _expend_type.getExpendType)());
	      dispatch((0, _company_list.getCompanyList)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(PageInfo);

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _payment = __webpack_require__(132);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(709);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      if (res.statusCode === 200) {
	        _this.setState({
	          dataSource: {
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              pageSize: 15,
	              current: _this.current
	            }
	          }
	        });
	      } else {
	        _antd.message.error(res.message);
	        _this.setState({
	          dataSource: {
	            list: [],
	            pagination: {
	              total: 0,
	              pageSize: 15,
	              current: 1
	            }
	          }
	        });
	      }
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getPaymentMyList = function (params) {
	      _this.setState({ loading: true });
	      (0, _payment.queryPaymentMyList)(params).then(function (res) {
	        _this.setTableData(res);
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getPaymentMyList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataSource = _state.dataSource,
	          loading = _state.loading;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        type: 'mine',
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/p_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u4ED8\u6B3E'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _WorkflowOp = __webpack_require__(134);
	
	var _WorkflowOp2 = _interopRequireDefault(_WorkflowOp);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _payment = __webpack_require__(132);
	
	var _FormOpen = __webpack_require__(1666);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item, type) {
	      if (type === 'save') {
	        _this.savePayment(item);
	      }
	    };
	
	    _this.savePayment = function (item) {
	      (0, _payment.querySavePayment)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('保存成功');
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.doTask = function (pass, refuse) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackPayment(item);
	          break;
	        case 'next':
	          _this.nextPayment(item);
	          break;
	        case 'return':
	          _this.returnPayment(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackPayment = function (params) {
	      (0, _payment.queryCallbackPayment)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextPayment = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _payment.queryNextPayment)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.setState({ isLoading: false });
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnPayment = function (params, refuse) {
	      (0, _payment.queryReturnPayment)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var data = this.props.data;
	
	      this.setState({ dataInfo: data });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 提交付款
	     */
	
	
	    /**
	     * 保存
	     */
	
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowOp2.default, {
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_FormOpen2.default, Object.assign({
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          doTask: this.doTask,
	          watchTask: this.watchTask
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'payment', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	__webpack_require__(36);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _payment = __webpack_require__(132);
	
	var _TableExpenses = __webpack_require__(709);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      if (res.statusCode === 200) {
	        _this.setState({
	          dataSource: {
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              pageSize: 15,
	              current: _this.current
	            }
	          }
	        });
	      } else {
	        _antd.message.error(res.message);
	        _this.setState({
	          dataSource: {
	            list: [],
	            pagination: {
	              total: 0,
	              pageSize: 15,
	              current: 1
	            }
	          }
	        });
	      }
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getPaymentList = function (params) {
	      _this.setState({ loading: true });
	      (0, _payment.queryPaymentList)(params).then(function (res) {
	        _this.setTableData(res);
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getPaymentList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataSource = _state.dataSource,
	          loading = _state.loading;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/p_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u4ED8\u6B3E'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	__webpack_require__(36);
	
	var _payment = __webpack_require__(132);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.getPaymentOrgRecord = function (params) {
	      (0, _payment.queryPaymentOrgRecord)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataSource: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                pageSize: 15
	              }
	            }
	          });
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.loadData = function () {
	      var condition = _this.state.condition;
	
	      var params = Object.assign({
	        companyUuid: _this.props.org.companyUuid,
	        condition: condition
	      }, _this.pagination);
	      _this.getPaymentOrgRecord(params);
	    };
	
	    _this.onChange = function () {};
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.loadData();
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '付款单号',
	        dataIndex: 'no',
	        key: 'no',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/finance/p_manage/open/' + record.uuid },
	            text || '查看'
	          );
	        }
	      }, {
	        title: '申请人',
	        dataIndex: 'createUserName',
	        key: 'createUserName'
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price'
	      }, {
	        title: '申请理由',
	        dataIndex: 'reason',
	        key: 'reason',
	        width: 200,
	        render: function render(text) {
	          var content = _react2.default.createElement(
	            'div',
	            { style: { maxWidth: '600px' } },
	            _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	          return _react2.default.createElement(
	            _antd.Popover,
	            { content: content },
	            _react2.default.createElement(
	              'p',
	              { className: 'ellip' },
	              text
	            )
	          );
	        }
	      }, {
	        title: '申请时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD')
	          );
	        }
	      }, {
	        title: '完成时间',
	        dataIndex: 'finishTime',
	        key: 'finishTime',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'long',
	        render: function render(text, record) {
	          return record.status ? _react2.default.createElement(
	            'span',
	            null,
	            '\u5DF2\u5B8C\u6210',
	            _react2.default.createElement(
	              'span',
	              null,
	              '(\u7528\u65F6',
	              record.consume,
	              '\u5929)'
	            )
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u5BA1\u6838\u4E2D'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      },
	      condition: ''
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	      var org = this.props.org;
	
	      return _react2.default.createElement(
	        _antd.Drawer,
	        {
	          visible: true,
	          width: '70%',
	          title: org.company,
	          onClose: function onClose() {
	            return _this2.props.handleVisible(false);
	          }
	        },
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(_antd.Col, { span: 13 }),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          ),
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            dataSource: list,
	            pagination: pagination,
	            rowKey: 'uuid',
	            size: 'small',
	            onChange: this.handleTableChange
	          })
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Manage);

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	__webpack_require__(36);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.state = {
	      dataItem: _this.props.data
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataItem: nextProps.data
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataItem = this.state.dataItem;
	
	      var files = dataItem.files || [];
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u5212\u6B3E\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u5212\u6B3E\u7C7B\u578B' },
	              dataItem.type === '0' ? '自营佣金' : '',
	              dataItem.type === '1' ? '商家活动费' : '',
	              dataItem.type === '2' ? '其他' : ''
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u7533\u8BF7\u4EBA\u5458' },
	              dataItem.createUserName
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u5212\u6B3E\u9644\u4EF6' },
	              _react2.default.createElement(
	                'div',
	                null,
	                files.map(function (item) {
	                  return _react2.default.createElement(
	                    'div',
	                    { key: item.url },
	                    _react2.default.createElement(
	                      'a',
	                      { onClick: function onClick() {
	                          return (0, _attachment.queryFilePreview)(item, '');
	                        } },
	                      item.name
	                    )
	                  );
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u5212\u6B3E\u8BF4\u660E' },
	              dataItem.reason
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = Open;

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _platformTransfer = __webpack_require__(230);
	
	var _FormBase = __webpack_require__(711);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      delete item.apportionType;
	      _this.savePlatformTransfer(item);
	    };
	
	    _this.platformTransferWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _platformTransfer.queryPlatformTransferWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.savePlatformTransfer = function (item) {
	      _this.setState({
	        isSubmiting: true
	      });
	      (0, _platformTransfer.querySavePlatformTransfer)(item).then(function (res) {
	        _this.setState({
	          isSubmiting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmiting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.platformTransferWorkflow();
	    }
	
	    /**
	     * 提交划款
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isSubmiting = _state.isSubmiting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, { data: dataInfo, handSubmit: this.handSubmit, isSubmiting: isSubmiting }),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance })
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _reactRouter = __webpack_require__(8);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _platformTransfer = __webpack_require__(230);
	
	var _FormBase = __webpack_require__(711);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.savePlatformTransfer(item);
	    };
	
	    _this.platformTransferWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _platformTransfer.queryPlatformTransferWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.savePlatformTransfer = function (item) {
	      _this.setState({
	        isSubmiting: true
	      });
	      (0, _platformTransfer.querySavePlatformTransfer)(item).then(function (res) {
	        _this.setState({
	          isSubmiting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.deletePlatformTransfer = function () {
	      (0, _platformTransfer.queryDeletePlatformTransfer)({
	        uuid: _this.props.data.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      isSubmiting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.platformTransferWorkflow();
	    }
	
	    /**
	     * 提交划款
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmiting = _state.isSubmiting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, Object.assign({
	          data: dataInfo,
	          handSubmit: this.handSubmit,
	          handleDelete: this.deletePlatformTransfer,
	          isSubmiting: isSubmiting
	        }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _platformTransfer = __webpack_require__(230);
	
	var _PageEdit = __webpack_require__(1678);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1681);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getPlatformTransferInfo = function () {
	      (0, _platformTransfer.queryPlatformTransferInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getPlatformTransferInfo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = PageInfo;

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _platformTransfer = __webpack_require__(230);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableApply = __webpack_require__(712);
	
	var _TableApply2 = _interopRequireDefault(_TableApply);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: (pagination.current - 1) * 15
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 0
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.current = 1;
	      _this.pagination = {
	        start: 0
	      };
	      _this.loadData();
	    };
	
	    _this.getPlatformTransferMyList = function (params) {
	      (0, _platformTransfer.queryPlatformTransferMyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getPlatformTransferMyList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = +backInfo.start / +backInfo.limit + 1);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        type: 'mine',
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/pt_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u5212\u6B3E'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableApply2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _WorkflowOp = __webpack_require__(134);
	
	var _WorkflowOp2 = _interopRequireDefault(_WorkflowOp);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _platformTransfer = __webpack_require__(230);
	
	var _FormOpen = __webpack_require__(1676);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.doTask = function (pass, refuse) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackPlatformTransfer(item);
	          break;
	        case 'next':
	          _this.nextPlatformTransfer(item);
	          break;
	        case 'return':
	          _this.returnPlatformTransfer(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackPlatformTransfer = function (params) {
	      (0, _platformTransfer.queryCallbackPlatformTransfer)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextPlatformTransfer = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _platformTransfer.queryNextPlatformTransfer)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnPlatformTransfer = function (params, refuse) {
	      (0, _platformTransfer.queryReturnPlatformTransfer)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null
	          );
	        }
	      }, {
	        title: '操作内容',
	        dataIndex: 'operating'
	      }, {
	        title: '处理意见',
	        dataIndex: 'refuse'
	      }];
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ dataInfo: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 打回
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowOp2.default, {
	          data: dataInfo,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_FormOpen2.default, Object.assign({ data: dataInfo, doTask: this.doTask, watchTask: this.watchTask }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'platformTransfer', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _platformTransfer = __webpack_require__(230);
	
	var _FormSearch = __webpack_require__(90);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableApply = __webpack_require__(712);
	
	var _TableApply2 = _interopRequireDefault(_TableApply);
	
	__webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageManage = function (_Component) {
	  _inherits(PageManage, _Component);
	
	  function PageManage(props) {
	    _classCallCheck(this, PageManage);
	
	    var _this = _possibleConstructorReturn(this, (PageManage.__proto__ || Object.getPrototypeOf(PageManage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: (pagination.current - 1) * 15
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 0
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.current = 1;
	      _this.pagination = {
	        start: 0
	      };
	      _this.loadData();
	    };
	
	    _this.getPlatformTransferList = function (params) {
	      (0, _platformTransfer.queryPlatformTransferList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageManage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        backInfo.start && backInfo.limit && (this.current = +backInfo.start / +backInfo.limit + 1);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'loadData',
	    value: function loadData() {
	      var params = Object.assign({}, this.searchCondition, this.pagination);
	      this.getPlatformTransferList(params);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableApply2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return PageManage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(PageManage));

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var TextArea = _antd.Input.TextArea;
	
	var BaseForm = function (_Component) {
	  _inherits(BaseForm, _Component);
	
	  function BaseForm(props) {
	    _classCallCheck(this, BaseForm);
	
	    var _this = _possibleConstructorReturn(this, (BaseForm.__proto__ || Object.getPrototypeOf(BaseForm)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var handSubmit = _this.props.handSubmit;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handSubmit(values);
	        }
	      });
	    };
	
	    _this.handleCompanyChange = function (value, option) {
	      _this.props.form.setFieldsValue({
	        compName: option.props.children
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(BaseForm, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          dataInfo = _props.dataInfo,
	          goBack = _props.goBack;
	
	      getFieldDecorator('compName', {
	        rules: [{
	          required: true,
	          message: '请选择公司'
	        }],
	        initialValue: dataInfo.compName
	      });
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 12 }
	      };
	      var ItemLayout2 = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 18 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null),
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', style: { marginRight: 10 }, htmlType: 'submit' },
	            '\u786E\u8BA4'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u516C\u53F8\u540D\u79F0' }, ItemLayout),
	                getFieldDecorator('compUuid', {
	                  initialValue: dataInfo.compUuid
	                })(_react2.default.createElement(_companySearch2.default, Object.assign({
	                  companyName: dataInfo.compName,
	                  companyUuid: dataInfo.compUuid,
	                  onChange: function onChange(value, option) {
	                    return _this2.handleCompanyChange(value, option);
	                  }
	                }, this.props)))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F00\u6237\u884C' }, ItemLayout),
	                getFieldDecorator('bankName', {
	                  initialValue: dataInfo.bankName
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5F00\u6237\u884C', type: 'text' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5F00\u6237\u5E10\u53F7' }, ItemLayout),
	                getFieldDecorator('bankBook', {
	                  initialValue: dataInfo.bankBook
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5F00\u6237\u5E10\u53F7', type: 'text' }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5BC6\u7801' }, ItemLayout),
	                getFieldDecorator('passwd', {
	                  initialValue: dataInfo.passwd
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u5BC6\u7801', type: 'text' }))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 20 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u5907\u6CE8' }, ItemLayout2),
	                getFieldDecorator('remark', {
	                  initialValue: dataInfo.remark
	                })(_react2.default.createElement(TextArea, { placeholder: '\u5907\u6CE8', type: 'textarea', rows: 4 }))
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return BaseForm;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(BaseForm);

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _receipt = __webpack_require__(271);
	
	var _ModalImport = __webpack_require__(1685);
	
	var _ModalImport2 = _interopRequireDefault(_ModalImport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo) {
	      var params = {};
	      var _this$state = _this.state,
	          condition = _this$state.condition,
	          permission = _this$state.permission;
	
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      if (!permission.all && !permission.all) {
	        params.status = 1;
	      }
	      _this.setState({
	        pageNo: current,
	        isLoading: true
	      });
	      (0, _receipt.queryReceiptList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      var pageNo = _this.state.pageNo;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            condition: values.condition
	          }, function () {
	            _this.loadData(pageNo);
	          });
	        }
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            FormItem,
	            null,
	            getFieldDecorator('condition', {
	              initialValue: condition || null
	            })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u5173\u952E\u5B57' }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              { htmlType: 'submit' },
	              '\u67E5\u8BE2'
	            )
	          )
	        )
	      );
	    };
	
	    _this.judge = function (accountInfo) {
	      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
	
	      var role = accountInfo.roles;
	      var permission = {};
	      role.forEach(function (sign, index) {
	        if (sign === '[CWManager]' || sign === '[Caissier]') {
	          permission.view = true;
	        }
	        if (sign === '[CWManager]') {
	          permission.add = true;
	        }
	      });
	      if (accountInfo.admin) {
	        permission.all = true;
	      }
	
	      _this.setState({
	        permission: permission
	      }, callback);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '序号',
	        dataIndex: 'unid'
	      }, {
	        title: '开户行',
	        dataIndex: 'bankName'
	      }, {
	        title: '公司名称',
	        dataIndex: 'compName'
	      }, {
	        title: '帐号',
	        dataIndex: 'bankBook'
	      }, {
	        title: '备注',
	        dataIndex: 'remark'
	      }, {
	        title: '操作',
	        render: function render(text, record) {
	          var permission = _this.state.permission;
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            permission.all || permission.view ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/receipt/open/' + record.uuid },
	              '\u67E5\u770B'
	            ) : null,
	            permission.all || permission.add ? _react2.default.createElement('span', { className: 'ant-divider' }) : null,
	            permission.all || permission.add ? _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/finance/receipt/edit/' + record.uuid },
	              '\u7F16\u8F91'
	            ) : null,
	            permission.all || permission.add ? _react2.default.createElement('span', { className: 'ant-divider' }) : null,
	            permission.all || permission.add ? _react2.default.createElement(
	              'a',
	              {
	                href: '#',
	                onClick: function onClick() {
	                  (0, _receipt.queryAbleReceipt)({
	                    uuid: record.uuid,
	                    status: record.status === 2 ? 1 : 2
	                  }).then(function (_ref) {
	                    var statusCode = _ref.statusCode;
	
	                    if (statusCode === 200) {
	                      _antd.message.success((record.status === 2 ? '启用' : '禁用') + '\u6210\u529F');
	                      _this.loadData();
	                    }
	                  });
	                }
	              },
	              record.status === 2 ? '启用' : '禁用'
	            ) : null
	          );
	        }
	      }];
	    };
	
	    _this.handleModalVisible = function (visible) {
	      _this.setState({ visible: visible });
	    };
	
	    _this.handleImport = function (params) {
	      (0, _receipt.queryImportReceipt)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.loadData(1);
	          _this.handleModalVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: true,
	      total: 0,
	      pageNo: 1,
	      permission: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.judge(this.props.account_info, function () {
	        _this2.loadData(1);
	      });
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          pageNo = _state.pageNo,
	          condition = _state.condition;
	
	      var params = {
	        pageNo: pageNo,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps, nextContext) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    // 加载需公司回单卡信息数据
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          data = _state2.data,
	          isLoading = _state2.isLoading,
	          total = _state2.total,
	          pageNo = _state2.pageNo,
	          permission = _state2.permission,
	          visible = _state2.visible;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this3.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { paddingBottom: '20px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 13 },
	              permission.all || permission.add ? _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { to: '/finance/bookInfo/add' },
	                  _react2.default.createElement(
	                    _antd.Button,
	                    { type: 'primary' },
	                    '\u6DFB\u52A0'
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { style: { marginLeft: '10px' }, onClick: this.handleModalVisible },
	                  '\u5BFC\u5165'
	                )
	              ) : null
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          loading: isLoading,
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        }),
	        visible ? _react2.default.createElement(_ModalImport2.default, { cancel: this.handleModalVisible, handleSubmit: this.handleImport }) : null
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    account_info: state.account_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Index));

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _receipt = __webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var DetailModal = function (_Component) {
	  _inherits(DetailModal, _Component);
	
	  function DetailModal(props) {
	    _classCallCheck(this, DetailModal);
	
	    var _this = _possibleConstructorReturn(this, (DetailModal.__proto__ || Object.getPrototypeOf(DetailModal)).call(this, props));
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var fileUuid = '';
	      if (_this.state.licenseFile && _this.state.licenseFile.length > 0) {
	        fileUuid = _this.state.licenseFile[0].uuid;
	      }
	      var handleSubmit = _this.props.handleSubmit;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          handleSubmit({ fileUuid: fileUuid });
	        }
	      });
	    };
	
	    _this.handlelicenseFile = function (fileList) {
	      _this.setState({
	        licenseFile: fileList
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(DetailModal, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u5BFC\u5165', visible: true, onOk: this.submit, onCancel: function onCancel() {
	            return _this2.props.cancel(false);
	          } },
	        _react2.default.createElement(
	          _antd.Form,
	          { layout: 'horizontal' },
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u4E0A\u4F20Excel\u6587\u4EF6' }, formItemLayout, { required: true }),
	            _react2.default.createElement(_UploadFile2.default, { type: 'ghost', handleUpload: this.handlelicenseFile, isExcel: true }),
	            _react2.default.createElement(
	              'span',
	              { className: 'ant-form-text' },
	              '\xA0\u4EC5\u9650excel\u683C\u5F0F',
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return (0, _receipt.queryDownloadReceiptTemplate)();
	                  }, style: { marginLeft: '10px' } },
	                '\u6A21\u677F\u4E0B\u8F7D'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return DetailModal;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(DetailModal);

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _receipt = __webpack_require__(271);
	
	var _PageAdd2 = __webpack_require__(713);
	
	var _PageAdd3 = _interopRequireDefault(_PageAdd2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageEdit = function (_PageAdd) {
	  _inherits(PageEdit, _PageAdd);
	
	  function PageEdit() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, PageEdit);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PageEdit.__proto__ || Object.getPrototypeOf(PageEdit)).call.apply(_ref, [this].concat(args))), _this), _this.getReceipt = function () {
	      (0, _receipt.queryReceiptInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(PageEdit, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getReceipt();
	    }
	  }]);
	
	  return PageEdit;
	}(_PageAdd3.default);
	
	exports.default = PageEdit;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _antd = __webpack_require__(2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _BackBtn = __webpack_require__(12);
	
	var _receipt = __webpack_require__(271);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var PageOpen = function (_Component) {
	  _inherits(PageOpen, _Component);
	
	  function PageOpen(props) {
	    _classCallCheck(this, PageOpen);
	
	    var _this = _possibleConstructorReturn(this, (PageOpen.__proto__ || Object.getPrototypeOf(PageOpen)).call(this, props));
	
	    _this.getReceiptInfo = function () {
	      (0, _receipt.queryReceiptInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      data: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageOpen, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getReceiptInfo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Row,
	          { style: { paddingBottom: '20px' } },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 13 },
	            _react2.default.createElement(_BackBtn.BackBtn, null)
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u516C\u53F8\u56DE\u5355\u5361\u4FE1\u606F' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u516C\u53F8\u540D\u79F0' },
	              data.compName,
	              '\u5143'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F00\u6237\u884C' },
	              data.bankName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u8D26\u53F7' },
	              data.bankBook
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5BC6\u7801' },
	              data.passwd
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5907\u6CE8' },
	              data.remark
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PageOpen;
	}(_react.Component);
	
	exports.default = PageOpen;

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1615);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(1619);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _Index5 = __webpack_require__(1632);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _Index7 = __webpack_require__(1635);
	
	var _Index8 = _interopRequireDefault(_Index7);
	
	var _Index9 = __webpack_require__(1689);
	
	var _Index10 = _interopRequireDefault(_Index9);
	
	var _PageYear = __webpack_require__(1690);
	
	var _PageYear2 = _interopRequireDefault(_PageYear);
	
	var _Index11 = __webpack_require__(1664);
	
	var _Index12 = _interopRequireDefault(_Index11);
	
	var _PageYear3 = __webpack_require__(1665);
	
	var _PageYear4 = _interopRequireDefault(_PageYear3);
	
	var _Index13 = __webpack_require__(1577);
	
	var _Index14 = _interopRequireDefault(_Index13);
	
	var _Index15 = __webpack_require__(1597);
	
	var _Index16 = _interopRequireDefault(_Index15);
	
	var _PagePayDetail = __webpack_require__(1601);
	
	var _PagePayDetail2 = _interopRequireDefault(_PagePayDetail);
	
	var _Index17 = __webpack_require__(1602);
	
	var _Index18 = _interopRequireDefault(_Index17);
	
	var _PageDetail = __webpack_require__(1603);
	
	var _PageDetail2 = _interopRequireDefault(_PageDetail);
	
	var _toview = __webpack_require__(1612);
	
	var _toview2 = _interopRequireDefault(_toview);
	
	var _PageWatch = __webpack_require__(1610);
	
	var _PageWatch2 = _interopRequireDefault(_PageWatch);
	
	var _PageMine = __webpack_require__(1608);
	
	var _PageMine2 = _interopRequireDefault(_PageMine);
	
	var _PageInfo = __webpack_require__(1607);
	
	var _PageInfo2 = _interopRequireDefault(_PageInfo);
	
	var _PageAdd = __webpack_require__(695);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	var _PageInfo3 = __webpack_require__(1583);
	
	var _PageInfo4 = _interopRequireDefault(_PageInfo3);
	
	var _PageWatch3 = __webpack_require__(1586);
	
	var _PageWatch4 = _interopRequireDefault(_PageWatch3);
	
	var _PageMine3 = __webpack_require__(1584);
	
	var _PageMine4 = _interopRequireDefault(_PageMine3);
	
	var _Index19 = __webpack_require__(1604);
	
	var _Index20 = _interopRequireDefault(_Index19);
	
	var _balance = __webpack_require__(1593);
	
	var _balance2 = _interopRequireDefault(_balance);
	
	var _Index21 = __webpack_require__(1590);
	
	var _Index22 = _interopRequireDefault(_Index21);
	
	var _Index23 = __webpack_require__(1587);
	
	var _Index24 = _interopRequireDefault(_Index23);
	
	var _Index25 = __webpack_require__(1594);
	
	var _Index26 = _interopRequireDefault(_Index25);
	
	var _Index27 = __webpack_require__(1613);
	
	var _Index28 = _interopRequireDefault(_Index27);
	
	var _PageYear5 = __webpack_require__(1614);
	
	var _PageYear6 = _interopRequireDefault(_PageYear5);
	
	var _Index29 = __webpack_require__(1568);
	
	var _Index30 = _interopRequireDefault(_Index29);
	
	var _PageAdd3 = __webpack_require__(1677);
	
	var _PageAdd4 = _interopRequireDefault(_PageAdd3);
	
	var _PageInfo5 = __webpack_require__(1679);
	
	var _PageInfo6 = _interopRequireDefault(_PageInfo5);
	
	var _PageMine5 = __webpack_require__(1680);
	
	var _PageMine6 = _interopRequireDefault(_PageMine5);
	
	var _PageWatch5 = __webpack_require__(1682);
	
	var _PageWatch6 = _interopRequireDefault(_PageWatch5);
	
	var _PageMine7 = __webpack_require__(1628);
	
	var _PageMine8 = _interopRequireDefault(_PageMine7);
	
	var _PageAdd5 = __webpack_require__(1623);
	
	var _PageAdd6 = _interopRequireDefault(_PageAdd5);
	
	var _PageWatch7 = __webpack_require__(1630);
	
	var _PageWatch8 = _interopRequireDefault(_PageWatch7);
	
	var _PageCompany = __webpack_require__(1624);
	
	var _PageCompany2 = _interopRequireDefault(_PageCompany);
	
	var _PageIncubator = __webpack_require__(1626);
	
	var _PageIncubator2 = _interopRequireDefault(_PageIncubator);
	
	var _PageInfo7 = __webpack_require__(1627);
	
	var _PageInfo8 = _interopRequireDefault(_PageInfo7);
	
	var _PageAdd7 = __webpack_require__(1667);
	
	var _PageAdd8 = _interopRequireDefault(_PageAdd7);
	
	var _PageInfo9 = __webpack_require__(1671);
	
	var _PageInfo10 = _interopRequireDefault(_PageInfo9);
	
	var _PageWatch9 = __webpack_require__(1674);
	
	var _PageWatch10 = _interopRequireDefault(_PageWatch9);
	
	var _PageMine9 = __webpack_require__(1672);
	
	var _PageMine10 = _interopRequireDefault(_PageMine9);
	
	var _PageCompany3 = __webpack_require__(1668);
	
	var _PageCompany4 = _interopRequireDefault(_PageCompany3);
	
	var _PageIncubator3 = __webpack_require__(1670);
	
	var _PageIncubator4 = _interopRequireDefault(_PageIncubator3);
	
	var _PageMine11 = __webpack_require__(1658);
	
	var _PageMine12 = _interopRequireDefault(_PageMine11);
	
	var _PageAdd9 = __webpack_require__(1653);
	
	var _PageAdd10 = _interopRequireDefault(_PageAdd9);
	
	var _PageWatch11 = __webpack_require__(1660);
	
	var _PageWatch12 = _interopRequireDefault(_PageWatch11);
	
	var _PageCompany5 = __webpack_require__(1654);
	
	var _PageCompany6 = _interopRequireDefault(_PageCompany5);
	
	var _PageIncubator5 = __webpack_require__(1656);
	
	var _PageIncubator6 = _interopRequireDefault(_PageIncubator5);
	
	var _PageInfo11 = __webpack_require__(1657);
	
	var _PageInfo12 = _interopRequireDefault(_PageInfo11);
	
	var _PageAdd11 = __webpack_require__(1641);
	
	var _PageAdd12 = _interopRequireDefault(_PageAdd11);
	
	var _PageCompany7 = __webpack_require__(1642);
	
	var _PageCompany8 = _interopRequireDefault(_PageCompany7);
	
	var _PageIncubator7 = __webpack_require__(1644);
	
	var _PageIncubator8 = _interopRequireDefault(_PageIncubator7);
	
	var _PageMine13 = __webpack_require__(1646);
	
	var _PageMine14 = _interopRequireDefault(_PageMine13);
	
	var _PageWatch13 = __webpack_require__(1648);
	
	var _PageWatch14 = _interopRequireDefault(_PageWatch13);
	
	var _PageInfo13 = __webpack_require__(1645);
	
	var _PageInfo14 = _interopRequireDefault(_PageInfo13);
	
	var _Index31 = __webpack_require__(1570);
	
	var _Index32 = _interopRequireDefault(_Index31);
	
	var _PageAdd13 = __webpack_require__(693);
	
	var _PageAdd14 = _interopRequireDefault(_PageAdd13);
	
	var _PageEdit = __webpack_require__(1571);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageRecord = __webpack_require__(1572);
	
	var _PageRecord2 = _interopRequireDefault(_PageRecord);
	
	var _Index33 = __webpack_require__(1574);
	
	var _Index34 = _interopRequireDefault(_Index33);
	
	var _PageAdd15 = __webpack_require__(694);
	
	var _PageAdd16 = _interopRequireDefault(_PageAdd15);
	
	var _PageEdit3 = __webpack_require__(1575);
	
	var _PageEdit4 = _interopRequireDefault(_PageEdit3);
	
	var _PageOpen = __webpack_require__(1576);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	var _Index35 = __webpack_require__(1684);
	
	var _Index36 = _interopRequireDefault(_Index35);
	
	var _PageAdd17 = __webpack_require__(713);
	
	var _PageAdd18 = _interopRequireDefault(_PageAdd17);
	
	var _PageEdit5 = __webpack_require__(1686);
	
	var _PageEdit6 = _interopRequireDefault(_PageEdit5);
	
	var _PageOpen3 = __webpack_require__(1687);
	
	var _PageOpen4 = _interopRequireDefault(_PageOpen3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 公司回单卡记录
	
	
	// 公司账户信息
	
	// 分摊管理
	
	// 开票申请
	
	// 借款申请
	
	// 付款申请
	
	// 报销申请
	
	// 划款申请
	
	
	// 预算调整
	var router = {
	  path: 'finance',
	  breadcrumbName: '财务',
	  childRoutes: [{
	    path: 'capital',
	    breadcrumbName: '资金管理',
	    indexRoute: { component: _Index2.default },
	    childRoutes: [{
	      path: ':uuid/detail',
	      component: _Index4.default,
	      breadcrumbName: '资金流水'
	    }]
	  }, {
	    path: 'funds',
	    breadcrumbName: '资金帐号管理',
	    indexRoute: { component: _Index6.default },
	    childRoutes: [{
	      path: ':uuid/detail',
	      component: _Index8.default,
	      breadcrumbName: '资金帐号流水'
	    }]
	  }, {
	    path: 'budget',
	    breadcrumbName: '预算管理',
	    indexRoute: { component: _Index14.default },
	    childRoutes: [{
	      path: ':uuid/check',
	      breadcrumbName: '预算流水',
	      indexRoute: { component: _Index16.default },
	      childRoutes: [{
	        path: ':checkUuid/payDetail',
	        component: _PagePayDetail2.default,
	        breadcrumbName: '付款明细'
	      }]
	    }, {
	      path: ':uuid/month',
	      breadcrumbName: '月度预算',
	      indexRoute: { component: _Index18.default },
	      childRoutes: [{
	        path: ':monthUuid/detail',
	        component: _PageDetail2.default,
	        breadcrumbName: '付款明细'
	      }]
	    }, {
	      path: ':uuid/toviewDetail',
	      breadcrumbName: '查看预算',
	      indexRoute: { component: _toview2.default }
	    }, {
	      path: 'set_manage_watch',
	      breadcrumbName: '预算设置监控',
	      indexRoute: { component: _PageWatch2.default }
	    }, {
	      path: 'set_manage_mine',
	      breadcrumbName: '我的预算设置申请',
	      indexRoute: { component: _PageMine2.default }
	    }, {
	      path: ':uuid/set_manage/detail',
	      breadcrumbName: '预算设置审核',
	      indexRoute: { component: _PageInfo2.default }
	    }, {
	      path: 'adjust_manage_watch',
	      breadcrumbName: '预算调整监控',
	      indexRoute: { component: _PageWatch4.default }
	    }, {
	      path: 'adjust_manage_mine',
	      breadcrumbName: '我的预算调整申请',
	      indexRoute: { component: _PageMine4.default }
	    }, {
	      path: ':uuid/:year/adjust',
	      breadcrumbName: '预算调整',
	      indexRoute: { component: _PageAdd2.default }
	    }, {
	      path: ':uuid/:year/adjust/info',
	      breadcrumbName: '预算调整审核',
	      indexRoute: { component: _PageInfo4.default }
	    }, {
	      path: ':uuid/:year/balance',
	      breadcrumbName: '收支分析',
	      indexRoute: { component: _balance2.default }
	    }, {
	      path: ':uuid/balance/income',
	      component: _Index22.default,
	      breadcrumbName: '收入'
	    }, {
	      path: ':uuid/balance/expense',
	      component: _Index24.default,
	      breadcrumbName: '支出'
	    }, {
	      path: ':uuid/balance/trace',
	      component: _Index26.default,
	      breadcrumbName: '利润追踪'
	    }, {
	      path: 'org',
	      breadcrumbName: '部门预算管理',
	      indexRoute: { component: _Index20.default }
	    }]
	  }, {
	    path: 'budgets',
	    breadcrumbName: '预算统计',
	    indexRoute: { component: _Index28.default },
	    childRoutes: [{
	      path: ':uuid/year',
	      component: _PageYear6.default,
	      breadcrumbName: '预算按年统计'
	    }]
	  }, {
	    path: 'operational',
	    breadcrumbName: '资金运营统计',
	    indexRoute: { component: _Index12.default },
	    childRoutes: [{
	      path: ':uuid/buddget',
	      component: _Index16.default,
	      breadcrumbName: '预算按年统计'
	    }, {
	      path: ':uuid/year',
	      component: _PageYear4.default,
	      breadcrumbName: '预算按年统计'
	    }]
	  }, {
	    path: 'statis',
	    breadcrumbName: '资金统计',
	    indexRoute: { component: _Index10.default },
	    childRoutes: [{
	      path: ':uuid/detail',
	      component: _Index4.default,
	      breadcrumbName: '资金统计详情'
	    }, {
	      path: ':uuid/year',
	      component: _PageYear2.default,
	      breadcrumbName: '资金按年统计'
	    }, {
	      path: 'ignore',
	      component: _Index4.default,
	      breadcrumbName: '走账数据列表'
	    }]
	  }, {
	    path: 'analyze',
	    breadcrumbName: '财务分析',
	    indexRoute: { component: _Index30.default }
	  },
	
	  // 平台划款
	  {
	    path: 'pt_manage',
	    indexRoute: {
	      component: _PageMine6.default
	    },
	    breadcrumbName: '平台划款管理',
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd4.default,
	      breadcrumbName: '平台划款申请'
	    }, {
	      path: 'open/:uuid',
	      component: _PageInfo6.default,
	      breadcrumbName: '查看平台划款'
	    }]
	  }, {
	    path: 'pt_manage_watch',
	    component: _PageWatch6.default,
	    breadcrumbName: '平台划款监控'
	  }, {
	    path: 'pt_manage_mine',
	    component: _PageMine6.default,
	    breadcrumbName: '我的平台划款'
	  }, {
	    path: 'e_manage',
	    indexRoute: {
	      component: _PageMine8.default
	    },
	    breadcrumbName: '报销管理',
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd6.default,
	      breadcrumbName: '报销申请'
	    }, {
	      path: 'open/:uuid',
	      component: _PageInfo8.default,
	      breadcrumbName: '查看报销'
	    }]
	  }, {
	    path: 'e_manage_watch',
	    component: _PageWatch8.default,
	    breadcrumbName: '报销监控'
	  }, {
	    path: 'e_manage_mine',
	    component: _PageMine8.default,
	    breadcrumbName: '我的报销'
	  }, {
	    path: 'e_manage_company',
	    component: _PageCompany2.default,
	    breadcrumbName: '按公司统计'
	  }, {
	    path: 'e_manage_incubator',
	    component: _PageIncubator2.default,
	    breadcrumbName: '按孵化器统计'
	  }, {
	    path: 'p_manage',
	    indexRoute: {
	      component: _PageMine10.default
	    },
	    breadcrumbName: '付款管理',
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd8.default,
	      breadcrumbName: '报销申请'
	    }, {
	      path: 'open/:uuid',
	      component: _PageInfo10.default,
	      breadcrumbName: '查看付款'
	    }]
	  }, {
	    path: 'p_manage_mine',
	    component: _PageMine10.default,
	    breadcrumbName: '我的付款'
	  }, {
	    path: 'p_manage_company',
	    component: _PageCompany4.default,
	    breadcrumbName: '按公司统计'
	  }, {
	    path: 'p_manage_incubator',
	    component: _PageIncubator4.default,
	    breadcrumbName: '按孵化器统计'
	  }, {
	    path: 'p_manage_watch',
	    component: _PageWatch10.default,
	    breadcrumbName: '付款监控'
	  },
	  // 借款
	  {
	    path: 'l_manage',
	    indexRoute: {
	      component: _PageMine12.default
	    },
	    breadcrumbName: '借款管理',
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd10.default,
	      breadcrumbName: '借款申请'
	    }, {
	      path: 'open/:uuid',
	      component: _PageInfo12.default,
	      breadcrumbName: '查看借款'
	    }]
	  }, {
	    path: 'l_manage_mine',
	    component: _PageMine12.default,
	    breadcrumbName: '我的借款'
	  }, {
	    path: 'l_manage_company',
	    component: _PageCompany6.default,
	    breadcrumbName: '按公司统计'
	  }, {
	    path: 'l_manage_incubator',
	    component: _PageIncubator6.default,
	    breadcrumbName: '按孵化器统计'
	  }, {
	    path: 'l_manage_watch',
	    component: _PageWatch12.default,
	    breadcrumbName: '借款监控'
	  },
	  // 开票
	  {
	    path: 'i_manage',
	    indexRoute: {
	      component: _PageMine14.default
	    },
	    breadcrumbName: '开票管理',
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd12.default,
	      breadcrumbName: '开票申请'
	    }, {
	      path: 'open/:uuid',
	      component: _PageInfo14.default,
	      breadcrumbName: '查看开票'
	    }]
	  }, {
	    path: 'i_manage_watch',
	    component: _PageWatch14.default,
	    breadcrumbName: '开票监控'
	  }, {
	    path: 'i_manage_mine',
	    component: _PageMine14.default,
	    breadcrumbName: '我的开票'
	  }, {
	    path: 'i_manage_company',
	    component: _PageCompany8.default,
	    breadcrumbName: '按公司统计'
	  }, {
	    path: 'i_manage_incubator',
	    component: _PageIncubator8.default,
	    breadcrumbName: '按孵化器统计'
	  }, {
	    path: 'apportion',
	    indexRoute: {
	      component: _Index32.default
	    },
	    breadcrumbName: '分摊管理',
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd14.default,
	      breadcrumbName: '新增分摊'
	    }, {
	      path: 'open/:uuid',
	      component: _PageEdit2.default,
	      breadcrumbName: '查看分摊'
	    }, {
	      path: 'record/:uuid',
	      component: _PageRecord2.default,
	      breadcrumbName: '分摊记录'
	    }]
	  }, {
	    path: 'bookInfo',
	    indexRoute: {
	      component: _Index34.default
	    },
	    breadcrumbName: '公司账户信息',
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd16.default,
	      breadcrumbName: '新增公司账户信息'
	    }, {
	      path: 'edit/:uuid',
	      component: _PageEdit4.default,
	      breadcrumbName: '编辑公司账户信息'
	    }, {
	      path: 'open/:uuid',
	      component: _PageOpen2.default,
	      breadcrumbName: '查看公司账户信息'
	    }]
	  }, {
	    path: 'receipt',
	    indexRoute: {
	      component: _Index36.default
	    },
	    breadcrumbName: '公司回单卡记录',
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd18.default,
	      breadcrumbName: '新增公司回单卡记录'
	    }, {
	      path: 'edit/:uuid',
	      component: _PageEdit6.default,
	      breadcrumbName: '编辑公司回单卡记录'
	    }, {
	      path: 'open/:uuid',
	      component: _PageOpen4.default,
	      breadcrumbName: '查看公司回单卡记录'
	    }]
	  }]
	};
	// 财务分析
	
	// 预算统计
	
	// 收支分析
	
	// 预算设置
	
	// 预算管理
	
	
	// 资金运营统计
	
	
	// 资金统计
	/**
	 * routers
	 * 更多关于Router的使用，请参考以下教程
	 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
	 */
	
	// 资金管理
	exports.default = router;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _antd = __webpack_require__(2);
	
	var _reactHtmlTableToExcel = __webpack_require__(308);
	
	var _reactHtmlTableToExcel2 = _interopRequireDefault(_reactHtmlTableToExcel);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _finance = __webpack_require__(61);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _getAllType = __webpack_require__(168);
	
	var _getAllType2 = _interopRequireDefault(_getAllType);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _finance_statis = __webpack_require__(733);
	
	var _income_info = __webpack_require__(233);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var date = new Date();
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (searchDate) {
	      _this.setState({
	        isLoading: true
	      });
	      searchDate.beginDate = (0, _moment2.default)(searchDate.beginDate).format('YYYY-MM-DD');
	      searchDate.endDate = (0, _moment2.default)(searchDate.endDate).format('YYYY-MM-DD');
	      (0, _finance.queryFinanceIncomeStatistics)(searchDate).then(function (res) {
	        if (res.statusCode === 200) {
	          var ignoreArr = res.data.ignore;
	          var noIgnoreArr = res.data.noIgnore;
	
	          var statisticsData = _this.loopJoin(ignoreArr, noIgnoreArr);
	
	          _this.setState({
	            data: statisticsData,
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.initChecked = function (org) {
	      var checkedUUids = _this.state.checkedUUids;
	
	
	      if (checkedUUids.length > 0) {
	        return _this.loopchangeCheck(checkedUUids, org);
	      }
	
	      org.length > 0 && org.map(function (item) {
	        item.checked = true;
	        checkedUUids.push(item.uuid);
	        return item;
	      });
	      _this.setState({
	        checkedUUids: checkedUUids
	      });
	      return org;
	    };
	
	    _this.loadOrg = function () {
	      (0, _finance.queryFinanceBooksOrg)().then(function (res) {
	        if (res.statusCode === 200) {
	          var org = _this.initChecked(res.data);
	          _this.setState({
	            org: org,
	            wid: res.data.length * 200 + 420
	          });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          _this$props$form$getF2 = _slicedToArray(_this$props$form$getF.date, 2),
	          beginDate = _this$props$form$getF2[0],
	          endDate = _this$props$form$getF2[1];
	
	      var params = {};
	      params.beginDate = beginDate;
	      params.endDate = endDate;
	      _localDb2.default.set('date', params);
	      _this.loadData(params);
	    };
	
	    _this.search = function (condition) {
	      _this.condition = condition;
	      _this.loadData(1);
	    };
	
	    _this.toDetail = function (uuid, igNore, typeUid) {
	      // igNore:0不忽略，1忽略
	      var dispatch = _this.props.dispatch;
	      var type = _this.state.type;
	
	      var types = [];
	      var notTo = false;
	      var ignoreFlag = void 0;
	      if (typeUid !== 'payCurrents') {
	        type.forEach(function (item, index) {
	          if (item.value === typeUid) {
	            types = item.children || [typeUid];
	            var b = item.notTo;
	            notTo = b;
	          }
	        });
	      } else {
	        ignoreFlag = 2;
	      }
	      dispatch((0, _income_info.saveIncomeInfo)({
	        isShowPart: true,
	        types: types,
	        date: _this.props.form.getFieldsValue().date,
	        igLevel: 1,
	        ignoreFlag: ignoreFlag
	      }));
	      if (!notTo) {
	        _this.props.router.push('/finance/statis/' + uuid + '/detail');
	      }
	    };
	
	    _this.toIgnore = function () {
	      // igNore:0不忽略，1忽略
	      var dispatch = _this.props.dispatch;
	
	      dispatch((0, _income_info.saveIncomeInfo)({
	        isShowPart: true,
	        // 2 是走账数据
	        isNonBusiness: true
	      }));
	      _this.props.router.push('/finance/statis/ignore');
	    };
	
	    _this.loopJoin = function (ignoreArr, noIgnoreArr) {
	      noIgnoreArr.map(function (item, index) {
	        Object.keys(item).forEach(function (key) {
	          if (key !== 'type' && key !== 'TYPE') {
	            if (ignoreArr[index]) {
	              item[key] = ignoreArr[index][key] + '\u4E28' + item[key];
	            } else {
	              item[key] = '0\u4E28' + item[key];
	            }
	          }
	          item.show = 'all';
	        });
	        return item;
	      });
	      return noIgnoreArr;
	    };
	
	    _this.searchBar = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: _this.handleSubmit },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'start' },
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              getFieldDecorator('date', {
	                initialValue: _this.state.initDate
	              })(_react2.default.createElement(RangePicker, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit', style: { marginLeft: '10px' } },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.toYearStatic = function (company) {
	      _this.props.router.push({
	        pathname: '/finance/statis/' + company.uuid + '/year',
	        query: {
	          companyName: company.companyName
	        }
	      });
	    };
	
	    _this.loopchangeCheck = function (checkedUUids, org) {
	      org.length > 0 && org.map(function (item, index) {
	        var isChecked = checkedUUids.some(function (uuid) {
	          return item.uuid === uuid;
	        });
	        if (isChecked) {
	          item.checked = true;
	        } else {
	          item.checked = false;
	        }
	        return item;
	      });
	      return org;
	    };
	
	    _this.changeCheck = function (key) {
	      var _this$state = _this.state,
	          checkedUUids = _this$state.checkedUUids,
	          org = _this$state.org;
	
	      var isChecked = checkedUUids.some(function (item) {
	        return item === key;
	      });
	      if (isChecked) {
	        checkedUUids = checkedUUids.filter(function (item) {
	          return item !== key;
	        });
	      } else {
	        checkedUUids.push(key);
	      }
	      org = _this.loopchangeCheck(checkedUUids, org);
	      _this.setState({
	        checkedUUids: checkedUUids,
	        org: org
	      });
	    };
	
	    _this.columns = function () {
	      var type = _this.state.type;
	
	      var columns = _this.state.org.map(function (item, index) {
	        var config = {};
	        config.title = _react2.default.createElement(
	          'p',
	          { style: { textAlign: 'center' } },
	          _react2.default.createElement(
	            'p',
	            null,
	            _react2.default.createElement(_antd.Checkbox, { checked: item.checked, onClick: function onClick() {
	                return _this.changeCheck(item.uuid);
	              } }),
	            _react2.default.createElement(
	              'span',
	              { style: { marginLeft: '5px' } },
	              index + 1
	            )
	          ),
	          _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.toYearStatic(item);
	              } },
	            item.companyName
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            item.date ? '\u622A\u6B62' + item.date : ''
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            item.remark ? '' + item.remark : ''
	          )
	        );
	        var orgUuid = item.uuid;
	        config.dataIndex = item.uuid;
	        config.key = item.uuid;
	        config.width = 200;
	        config.render = function (text, record) {
	          if (text === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '-'
	            );
	          }
	          return _this.handlerItem(text, record, orgUuid);
	        };
	        return config;
	      });
	      columns.unshift({
	        title: _react2.default.createElement(
	          'p',
	          { style: { textAlign: 'center' } },
	          _react2.default.createElement('a', null),
	          _react2.default.createElement('p', null)
	        ),
	        dataIndex: 'type',
	        key: 'type',
	        width: 200,
	        fixed: 'left',
	        render: function render(text, record) {
	          var typeName = '';
	          var gs = '';
	          var style = {};
	          if (type.length > 0) {
	            type.forEach(function (item, index) {
	              if (text === item.value) {
	                typeName = '' + (item.index ? item.index + '\u3001' : '') + item.key;
	                if (item.color) {
	                  style.color = item.color;
	                }
	                if (item.indexArr) {
	                  gs = item.indexArr.join('+');
	                  gs = '(' + gs + ')';
	                }
	                return typeName;
	              }
	            });
	          }
	
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'span',
	              { style: style },
	              typeName
	            ),
	            _react2.default.createElement(
	              'p',
	              null,
	              gs
	            )
	          );
	        }
	      });
	      columns.push({
	        title: '合计',
	        dataIndex: 'sum',
	        key: 'sum',
	        width: 220,
	        fixed: 'right',
	        render: function render(text, record) {
	          return _this.handlerItem(text, record, undefined);
	        }
	      });
	      return columns;
	    };
	
	    _this.setShow = function (key) {
	      var _this$state2 = _this.state,
	          show = _this$state2.show,
	          showChecked = _this$state2.showChecked;
	
	      var flag = false;
	      flag = showChecked.some(function (item) {
	        return item === key;
	      });
	      if (flag) {
	        showChecked = showChecked.filter(function (item) {
	          return item !== key;
	        });
	      } else {
	        showChecked.push(key);
	      }
	      if (showChecked.length === 2) {
	        show = 'all';
	      } else if (showChecked.length === 1) {
	        show = showChecked[0];
	      }
	
	      _this.setState({
	        show: show,
	        showChecked: showChecked
	      });
	    };
	
	    _this.handlerItemSum = function (record) {
	      var checkedUUids = _this.state.checkedUUids;
	
	      var noIgnoreSum = 0;
	      var ignoreSum = 0;
	      var item = [];
	      var noIgnoreItem = 0;
	      var ignoreItem = 0;
	
	      Object.keys(record).forEach(function (key) {
	        if (checkedUUids.includes(key)) {
	          item = ('' + record[key]).split('丨');
	          noIgnoreItem = parseFloat(item[1]) * 100;
	          ignoreItem = parseFloat(item[0]) * 100;
	          noIgnoreSum += noIgnoreItem;
	          ignoreSum += ignoreItem;
	        }
	      });
	      noIgnoreSum /= 100;
	      ignoreSum /= 100;
	      return {
	        noIgnoreSum: noIgnoreSum,
	        ignoreSum: ignoreSum
	      };
	    };
	
	    _this.handlerItem = function (text, item, orgUuid) {
	      var show = _this.state.show;
	
	      var textArr = ('' + text).split('丨');
	      var noIgnoreFont = void 0;
	      var ignoreFont = void 0;
	      if (orgUuid) {
	        noIgnoreFont = _util2.default.numberFormat(textArr[1], 2, '.', ',');
	        ignoreFont = _util2.default.numberFormat(textArr[0], 2, '.', ',');
	      } else {
	        var sum = _this.handlerItemSum(item);
	        noIgnoreFont = _util2.default.numberFormat(sum.noIgnoreSum, 2, '.', ',');
	        ignoreFont = _util2.default.numberFormat(sum.ignoreSum, 2, '.', ',');
	      }
	      if (show === 'ignore') {
	        if (ignoreFont === '0.00') {
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	        if (orgUuid !== undefined) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.toDetail(orgUuid, 1, item.type);
	              } },
	            ignoreFont
	          );
	        }
	        return _react2.default.createElement(
	          'a',
	          null,
	          ignoreFont
	        );
	      }
	      // 只显示包含非业务数据
	      if (show === 'noIgnore') {
	        if (noIgnoreFont !== '0.00') {
	          if (orgUuid !== undefined) {
	            return _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.toDetail(orgUuid, 0, item.type);
	                }, style: { color: 'gray' } },
	              noIgnoreFont
	            );
	          }
	          return _react2.default.createElement(
	            'a',
	            null,
	            noIgnoreFont
	          );
	        }
	        return _react2.default.createElement(
	          'span',
	          null,
	          '-'
	        );
	      }
	      // 都显示
	      if (show === 'all') {
	        if (ignoreFont === '0.00' && noIgnoreFont === '0.00') {
	          return _react2.default.createElement(
	            'span',
	            null,
	            '-'
	          );
	        }
	        if (ignoreFont === '0.00') {
	          if (orgUuid !== undefined) {
	            return _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.toDetail(orgUuid, 0, item.type);
	                }, style: { color: 'gray' } },
	              noIgnoreFont
	            );
	          }
	          return _react2.default.createElement(
	            'a',
	            null,
	            noIgnoreFont
	          );
	        }
	        if (noIgnoreFont === '0.00') {
	          if (orgUuid !== undefined) {
	            return _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.toDetail(orgUuid, 1, item.type);
	                } },
	              ignoreFont
	            );
	          }
	          return _react2.default.createElement(
	            'a',
	            null,
	            ignoreFont
	          );
	        }
	        if (orgUuid !== undefined) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.toDetail(orgUuid, 1, item.type);
	                } },
	              ignoreFont
	            ),
	            _react2.default.createElement(
	              'span',
	              { style: { margin: '0 5px' } },
	              '\u4E28'
	            ),
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.toDetail(orgUuid, 0, item.type);
	                }, style: { color: 'gray' } },
	              noIgnoreFont
	            )
	          );
	        }
	        return _react2.default.createElement(
	          'span',
	          null,
	          _react2.default.createElement(
	            'a',
	            null,
	            ignoreFont
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: { margin: '0 5px' } },
	            '\u4E28'
	          ),
	          _react2.default.createElement(
	            'a',
	            { style: { color: 'gray' } },
	            noIgnoreFont
	          )
	        );
	      }
	    };
	
	    _this.state = {
	      org: props.financeStatisStatus.org,
	      isLoading: false,
	      type: props.financeStatisStatus.type,
	      data: props.financeStatisStatus.data,
	      wid: props.financeStatisStatus.wid,
	      checkedUUids: props.financeStatisStatus.checkedUUids,
	      show: 'all', // all显示实际和预算，
	      showChecked: ['ignore', 'noIgnore'],
	      initDate: _localDb2.default.get('date') ? [(0, _moment2.default)(_localDb2.default.get('date').beginDate), (0, _moment2.default)(_localDb2.default.get('date').endDate)] : [_moment2.default.unix(date.getTime() / 1000), _moment2.default.unix(date.getTime() / 1000)]
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.loadOrg();
	      (0, _getAllType2.default)().then(function (res) {
	        _this2.setState({
	          type: res
	        });
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var Btn = document.getElementsByClassName('ant-table-body')[0];
	      var scrollLeft = this.props.financeStatisStatus.scrollLeft;
	      var scrollTop = this.props.financeStatisStatus.scrollTop;
	
	      _reactDom2.default.findDOMNode(Btn).scrollTo(scrollLeft, scrollTop);
	
	      var table = document.getElementsByClassName('ant-table-scroll')[0];
	      table.id = 'table-to-xls';
	
	      var params = {};
	      var initDate = this.state.initDate;
	
	      params.beginDate = initDate[0];
	      params.endDate = initDate[1];
	      this.loadData(params);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var scrollLeft = document.getElementsByClassName('ant-table-body')[0].scrollLeft;
	      var scrollTop = document.getElementsByClassName('ant-table-body')[0].scrollTop;
	      var _state = this.state,
	          wid = _state.wid,
	          checkedUUids = _state.checkedUUids,
	          org = _state.org,
	          data = _state.data,
	          type = _state.type;
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _finance_statis.getLocalFinanceStatis)({
	        scrollLeft: scrollLeft,
	        scrollTop: scrollTop,
	        checkedUUids: checkedUUids,
	        data: data,
	        wid: wid,
	        org: org,
	        type: type
	      }));
	    }
	
	    /**
	     * 获取资金统计列表
	     */
	
	
	    /**
	     * 获取账号列表
	     */
	
	
	    /** 拼接业务数据统计和含非业务数据统计 */
	
	
	    /**
	     * 跳转至按年统计详情页
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state2 = this.state,
	          data = _state2.data,
	          wid = _state2.wid,
	          isLoading = _state2.isLoading,
	          show = _state2.show;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'statis-box' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex' },
	          _react2.default.createElement(
	            _antd.Col,
	            { style: { textAlign: 'right' }, span: 12 },
	            this.searchBar()
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12, style: { textAlign: 'right' } },
	            _react2.default.createElement(
	              _antd.Button,
	              { onClick: this.toIgnore, style: { marginRight: '8px' } },
	              '\u975E\u4E1A\u52A1\u6570\u636E'
	            ),
	            _react2.default.createElement(
	              _antd.Checkbox,
	              {
	                onChange: function onChange() {
	                  return _this3.setShow('ignore');
	                },
	                checked: show === 'ignore' || show === 'all'
	              },
	              '\u5B9E\u9645\u4E1A\u52A1\u6570\u636E'
	            ),
	            _react2.default.createElement(
	              _antd.Checkbox,
	              {
	                onChange: function onChange() {
	                  return _this3.setShow('noIgnore');
	                },
	                checked: show === 'noIgnore' || show === 'all'
	              },
	              '\u542B\u975E\u4E1A\u52A1\u6570\u636E'
	            ),
	            _react2.default.createElement(_reactHtmlTableToExcel2.default, {
	              id: 'test-table-xls-button',
	              className: 'download-table-xls-button ant-btn',
	              table: 'table-to-xls',
	              filename: '\u8D44\u91D1\u7EDF\u8BA1',
	              sheet: '\u8D44\u91D1\u7EDF\u8BA1',
	              style: {
	                marginTop: '4px'
	              },
	              buttonText: '\u5BFC\u51FA'
	            })
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          columns: this.columns(),
	          dataSource: data,
	          loading: isLoading,
	          bordered: true,
	          size: 'small',
	          scroll: { x: wid, y: _util2.default.pageHeight() - 215 },
	          pagination: false
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    financeStatisStatus: state.finance_statis
	  };
	})(_antd.Form.create()(Index));

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _BackBtn = __webpack_require__(12);
	
	var _finance = __webpack_require__(61);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _getAllType = __webpack_require__(168);
	
	var _getAllType2 = _interopRequireDefault(_getAllType);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _income_info = __webpack_require__(233);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * 按年统计
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var date = new Date();
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function () {
	      _this.setState({
	        isLoading: true
	      });
	      var params = {};
	      params.bookUuid = _this.props.params.uuid;
	      params.year = _this.year || _this.state.year;
	      (0, _finance.queryIncomeDetail)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var ignoreArr = res.data.ignore;
	          var noIgnoreArr = res.data.noIgnore;
	          var data = [];
	          ignoreArr.map(function (item, index) {
	            var dataItem = {};
	            Object.keys(item).forEach(function (key) {
	              if (key !== 'type') {
	                var igItem = item[key] && item[key] !== '0' ? item[key] : '-';
	                var noItem = noIgnoreArr[index][key] && noIgnoreArr[index][key] !== '0' ? noIgnoreArr[index][key] : '-';
	                dataItem[key] = igItem + '/' + noItem;
	              } else if (key === 'type') {
	                dataItem[key] = item[key];
	              }
	            });
	            data.push(dataItem);
	            return ignoreArr;
	          });
	          _this.setState({
	            isLoading: false,
	            noIgnoreArr: noIgnoreArr
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadOrg = function () {
	      (0, _finance.queryFinanceBooksOrg)().then(function (res) {});
	    };
	
	    _this.handleSubmit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          year = _this$props$form$getF.year;
	
	      _this.setState({
	        year: year
	      });
	      _this.year = year;
	      _localDb2.default.set('year', year);
	      _this.loadData();
	    };
	
	    _this.toDetail = function (uuid, igNore, typeUid, yearMonth) {
	      // igNore:0不忽略，1忽略
	      var dispatch = _this.props.dispatch;
	      var type = _this.state.type;
	
	      var types = [];
	      var notTo = false;
	      type.forEach(function (item, index) {
	        if (item.value === typeUid) {
	          types = item.children || [typeUid];
	          var b = item.notTo;
	          notTo = b;
	        }
	      });
	      dispatch((0, _income_info.saveIncomeInfo)({
	        isShowPart: true,
	        igNore: igNore,
	        types: types,
	        yearMonth: yearMonth
	      }));
	      if (!notTo) {
	        _this.props.router.push('/finance/statis/' + uuid + '/detail');
	      }
	    };
	
	    _this.searchBar = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      var year = date.getFullYear();
	      var years = [];
	      for (var i = year; i >= 2014; i--) {
	        years.push(i.toString());
	      }
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: _this.handleSubmit },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'end' },
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              getFieldDecorator('year', {
	                initialValue: _this.state.year
	              })(_react2.default.createElement(
	                _antd.Select,
	                { style: { width: '200px' } },
	                years.map(function (item, index) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item },
	                    item
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              { style: { marginBottom: '16px' } },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', htmlType: 'submit', style: { marginLeft: '10px' } },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      var _this$state = _this.state,
	          type = _this$state.type,
	          year = _this$state.year;
	
	      _this.month = [{ title: year + '-01', uuid: '01' }, { title: year + '-02', uuid: '02' }, { title: year + '-03', uuid: '03' }, { title: year + '-04', uuid: '04' }, { title: year + '-05', uuid: '05' }, { title: year + '-06', uuid: '06' }, { title: year + '-07', uuid: '07' }, { title: year + '-08', uuid: '08' }, { title: year + '-09', uuid: '09' }, { title: year + '-10', uuid: '10' }, { title: year + '-11', uuid: '11' }, { title: year + '-12', uuid: '12' }];
	      var columns = _this.month.map(function (item, index) {
	        var config = {};
	        config.title = item.title;
	        config.dataIndex = item.uuid;
	        config.key = item.uuid;
	        config.width = 200;
	        config.render = function (text, record) {
	          if (text === 0) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              '-'
	            );
	          }
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.toDetail(item.uuid, 0, record.type);
	              } },
	            _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        };
	        return config;
	      });
	      columns.unshift({
	        title: '',
	        dataIndex: 'type',
	        key: 'type',
	        width: 200,
	        fixed: 'left',
	        render: function render(text, record) {
	          var typeName = '';
	          var style = {};
	          if (type.length > 0) {
	            type.forEach(function (item, index) {
	              if (text === item.value) {
	                typeName = item.key;
	                if (item.color) {
	                  style.color = item.color;
	                }
	                return typeName;
	              }
	            });
	          }
	
	          return _react2.default.createElement(
	            'span',
	            { style: style },
	            typeName
	          );
	        }
	      });
	      columns.push({
	        title: '合计',
	        dataIndex: 'sum',
	        key: 'sum',
	        width: 200,
	        fixed: 'right',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            { style: { color: '#108ee7' } },
	            _util2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      });
	      return columns;
	    };
	
	    _this.state = {
	      isLoading: false,
	      type: [],
	      noIgnoreArr: [],
	      year: _localDb2.default.get('year') || date.getFullYear()
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      this.loadOrg();
	      (0, _getAllType2.default)().then(function (res) {
	        _this2.setState({
	          type: res
	        });
	      });
	      this.company = this.props.location.query.companyName;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(this.state.year);
	    }
	
	    /**
	     * 获取资金统计列表
	     */
	
	
	    /**
	     * 获取账号列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          noIgnoreArr = _state.noIgnoreArr,
	          isLoading = _state.isLoading,
	          year = _state.year;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'statis-box' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-between' },
	          _react2.default.createElement(
	            _antd.Col,
	            null,
	            _react2.default.createElement(_BackBtn.BackBtn, null)
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { style: { textAlign: 'right' }, span: 12 },
	            this.searchBar()
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          id: 'table-to-xls',
	          columns: this.columns(),
	          dataSource: noIgnoreArr,
	          loading: isLoading,
	          scroll: { x: 2800, y: _util2.default.pageHeight() - 168 },
	          bordered: true,
	          size: 'small',
	          rowKey: function rowKey(record) {
	            return record.type;
	          },
	          title: function title() {
	            return _react2.default.createElement(
	              'p',
	              { style: { textAlign: 'Center' } },
	              _this3.company + '-' + year + '\u5E74\u8FD0\u8425\u6570\u5B57\u5206\u6790'
	            );
	          },
	          pagination: false
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    list: state.contract_type,
	    account_info: state.account_info
	  };
	})(_antd.Form.create()(Index));

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _workflow = __webpack_require__(272);
	
	var _getLink = __webpack_require__(715);
	
	var _getLink2 = _interopRequireDefault(_getLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.handleChange = function (pagination) {
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.loadData = function () {
	      var limit = 15;
	      (0, _workflow.queryDoneTaskList)(Object.assign({
	        start: _this.current
	      }, _this.condition)).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataSource: {
	              list: res.data,
	              pagination: {
	                total: res.totalSize,
	                current: _this.current,
	                pageSize: 15
	              }
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.current = 1;
	          _this.condition = values;
	          _this.loadData();
	        }
	      });
	    };
	
	    _this.handleFormReset = function (e) {
	      e.preventDefault();
	      _this.condition = '';
	      _this.props.form.resetFields();
	      _this.loadData();
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        {
	          layout: 'inline',
	          onSubmit: _this.handleSubmit
	          // style={{ textAlign: "right" }}
	        },
	        _react2.default.createElement(
	          FormItem,
	          { label: '\u641C\u7D22\u6761\u4EF6' },
	          getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit' },
	            '\u67E5\u8BE2'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { style: { marginLeft: 8, marginRight: '-16px' }, onClick: _this.handleFormReset },
	            '\u91CD\u7F6E'
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '时间',
	        dataIndex: 'cdate',
	        key: 'cdate',
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD')
	          );
	        }
	      }, {
	        title: '应用',
	        dataIndex: 'instanceName',
	        key: 'instanceName'
	      }, {
	        title: '标题',
	        dataIndex: 'title',
	        render: function render(text, record) {
	          return (0, _getLink2.default)(record);
	        }
	      }];
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.current = 1;
	      this.loadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$dataSource = this.state.dataSource,
	          list = _state$dataSource.list,
	          pagination = _state$dataSource.pagination;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableListForm', style: { marginBottom: '16px' } },
	          this.renderSearchForm()
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: list,
	          pagination: pagination,
	          onChange: this.handleChange
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _blueimpMd = __webpack_require__(743);
	
	var _blueimpMd2 = _interopRequireDefault(_blueimpMd);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var UpdatePassword = function (_Component) {
	  _inherits(UpdatePassword, _Component);
	
	  function UpdatePassword() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, UpdatePassword);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UpdatePassword.__proto__ || Object.getPrototypeOf(UpdatePassword)).call.apply(_ref, [this].concat(args))), _this), _this.submit = function (e) {
	      e.preventDefault();
	      var _this$props = _this.props,
	          handSubmit = _this$props.handSubmit,
	          user = _this$props.user;
	
	      var userData = _this.props.form.getFieldsValue();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          if (userData.oldPassword === userData.password) {
	            _antd.message.error('新密码不能和旧密码相同！');
	          } else if (userData.password !== userData.passwordConfirmation) {
	            _antd.message.error('两次输入密码不一致！');
	          } else {
	            userData.oldPassword = (0, _blueimpMd2.default)(userData.oldPassword);
	            userData.password = (0, _blueimpMd2.default)(userData.password);
	            userData.passwordConfirmation = (0, _blueimpMd2.default)(userData.passwordConfirmation);
	            handSubmit(userData);
	          }
	        }
	      });
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(UpdatePassword, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      return _react2.default.createElement(
	        _antd.Form,
	        {
	          onSubmit: this.submit,
	          className: '',
	          layout: 'vertical',
	          style: { height: '365px', marginTop: '-10px' }
	        },
	        _react2.default.createElement(
	          FormItem,
	          { label: '\u539F\u5BC6\u7801' },
	          getFieldDecorator('oldPassword', {
	            rules: [{ required: true, message: '原密码不能为空！' }]
	          })(_react2.default.createElement(_antd.Input, { type: 'password' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          { label: '\u65B0\u5BC6\u7801' },
	          getFieldDecorator('password', {
	            rules: [{
	              required: true,
	              message: '请输入包含数字和字母的6~16位新密码!',
	              pattern: /(?!^\d+$)(?!^[A-z]+$)(?!^[^\dA-z]+$)^.{6,16}$/
	            }]
	          })(_react2.default.createElement(_antd.Input, { placeholder: '\u5927\u4E8E6\u4F4D\u7684\u6570\u5B57\u6216\u5B57\u6BCD', type: 'password' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          { label: '\u786E\u8BA4\u65B0\u5BC6\u7801' },
	          getFieldDecorator('passwordConfirmation', {
	            rules: [{
	              required: true,
	              message: '请输入包含数字和字母的6~16位新密码!',
	              pattern: /(?!^\d+$)(?!^[A-z]+$)(?!^[^\dA-z]+$)^.{6,16}$/
	            }]
	          })(_react2.default.createElement(_antd.Input, { type: 'password' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit' },
	            '\u4FDD\u5B58'
	          )
	        )
	      );
	    }
	  }]);
	
	  return UpdatePassword;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(UpdatePassword);

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(714);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _PageDone = __webpack_require__(1691);
	
	var _PageDone2 = _interopRequireDefault(_PageDone);
	
	var _Index3 = __webpack_require__(1694);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _PageDetail = __webpack_require__(1695);
	
	var _PageDetail2 = _interopRequireDefault(_PageDetail);
	
	var _PageDetailBonus = __webpack_require__(1696);
	
	var _PageDetailBonus2 = _interopRequireDefault(_PageDetailBonus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = {
	  path: 'home',
	  breadcrumbName: '个人中心',
	  childRoutes: [{
	    path: 'gtasks',
	    breadcrumbName: '所有待办',
	    indexRoute: { component: _Index2.default }
	  }, {
	    path: 'd_gtasks',
	    breadcrumbName: '所有已办',
	    indexRoute: { component: _PageDone2.default }
	  }, {
	    path: 'wage',
	    breadcrumbName: '工资条',
	    indexRoute: { component: _Index4.default },
	    childRoutes: [{
	      path: 'detail/:uuid',
	      component: _PageDetail2.default
	    }, {
	      path: 'detailBonus/:uuid',
	      component: _PageDetailBonus2.default
	    }]
	  }]
	}; /**
	    * routers
	    * 更多关于Router的使用，请参考以下教程
	    * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
	    */
	
	exports.default = router;

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _api = __webpack_require__(421);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo, condition) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      _this.setState({
	        pageNo: pageNo
	      });
	      (0, _api.queryPayRoll)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.loadData(1, values.condition);
	        }
	      });
	    };
	
	    _this.handleFormReset = function (e) {
	      e.preventDefault();
	      _this.props.form.resetFields();
	      _this.loadData(1);
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        {
	          layout: 'inline',
	          onSubmit: _this.handleSubmit
	          // style={{ textAlign: "right" }}
	        },
	        _react2.default.createElement(
	          FormItem,
	          { label: '\u641C\u7D22\u6761\u4EF6' },
	          getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit' },
	            '\u67E5\u8BE2'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { style: { marginLeft: 8, marginRight: '-16px' }, onClick: _this.handleFormReset },
	            '\u91CD\u7F6E'
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '发生时间',
	        dataIndex: 'cdate',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : ''
	          );
	        }
	      }, {
	        title: '应用',
	        dataIndex: 'price'
	      }, {
	        title: '标题',
	        dataIndex: 'title',
	        render: function render(text, record) {
	          if (text.indexOf('年终奖') === -1) {
	            return _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/home/wage/detail/' + record.itemUuid },
	              text
	            );
	          }
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/home/wage/detailBonus/' + record.itemUuid },
	            text
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      total: 0,
	      pageNo: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList', style: { marginBottom: '16px' } },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(_antd.Col, { span: 13 }),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination,
	          size: 'small'
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactRedux = __webpack_require__(5);
	
	var _work_org_list = __webpack_require__(234);
	
	var _BackBtn = __webpack_require__(12);
	
	var _api = __webpack_require__(421);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.getWageDetailInfo = function () {
	      (0, _api.queryWageDetailPersonal)({ uuid: _this.props.params.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          var workOrg = _this.props.workOrg;
	
	          var dataSource = [res.data];
	          workOrg.map(function (item) {
	            if (item.uuid === res.data.workorgname) {
	              dataSource[0].workorgname = item.name;
	            }
	            return item;
	          });
	          _this.setState({
	            dataSource: [res.data]
	          });
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: "公司",
	        dataIndex: "compname",
	        width: 50
	      }, {
	        title: "部门",
	        dataIndex: "workorgname",
	        width: 50
	      }, {
	        title: "月份",
	        dataIndex: "month",
	        width: 80,
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            record.year + "-" + record.month
	          );
	        }
	      }, {
	        title: "姓名",
	        dataIndex: "person",
	        width: 50
	      }, {
	        title: "应发项目",
	        children: [{
	          title: "基本工资",
	          dataIndex: "base",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "岗位津贴",
	          dataIndex: "performance",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "小计",
	          dataIndex: "subtotal",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "全勤奖",
	          dataIndex: "fullAttendance",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "绩效提成",
	          dataIndex: "commission",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "补贴",
	          dataIndex: "commissio",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "福利品",
	          dataIndex: "welfare",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "合计",
	          dataIndex: "wageSum",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }]
	      }, {
	        title: "应扣项目",
	        children: [{
	          title: "缺勤",
	          dataIndex: "absence",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "迟到扣款",
	          dataIndex: "late",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "其他",
	          dataIndex: "other",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "应发合计",
	          dataIndex: "paid",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "社保",
	          children: [{
	            title: "个人",
	            children: [{
	              title: "养老保险",
	              dataIndex: "pensionInsurance",
	              width: 50,
	              render: function render(text) {
	                return _react2.default.createElement(
	                  "span",
	                  null,
	                  _index2.default.numberFormat(text, 2, ".", ",")
	                );
	              }
	            }, {
	              title: "医疗保险",
	              dataIndex: "medicalInsurance",
	              width: 50,
	              render: function render(text) {
	                return _react2.default.createElement(
	                  "span",
	                  null,
	                  _index2.default.numberFormat(text, 2, ".", ",")
	                );
	              }
	            }, {
	              title: "失业保险",
	              dataIndex: "unemploymentInsurance",
	              width: 50,
	              render: function render(text) {
	                return _react2.default.createElement(
	                  "span",
	                  null,
	                  _index2.default.numberFormat(text, 2, ".", ",")
	                );
	              }
	            }, {
	              title: "合计",
	              dataIndex: "insuranceSum",
	              width: 50,
	              render: function render(text) {
	                return _react2.default.createElement(
	                  "span",
	                  null,
	                  _index2.default.numberFormat(text, 2, ".", ",")
	                );
	              }
	            }]
	          }, {
	            title: "公司",
	            dataIndex: "insuranceCompSum",
	            width: 50
	          }]
	        }, {
	          title: "公积金",
	          children: [{
	            title: "个人部分",
	            dataIndex: "providentFund",
	            width: 50,
	            render: function render(text) {
	              return _react2.default.createElement(
	                "span",
	                null,
	                _index2.default.numberFormat(text, 2, ".", ",")
	              );
	            }
	          }, {
	            title: "公司部分",
	            dataIndex: "providentFundComp",
	            width: 50,
	            render: function render(text) {
	              return _react2.default.createElement(
	                "span",
	                null,
	                _index2.default.numberFormat(text, 2, ".", ",")
	              );
	            }
	          }]
	        }, {
	          title: "合计",
	          dataIndex: "buckle",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }]
	      }, {
	        title: "税前合计",
	        dataIndex: "incomeBeforeTax",
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, ".", ",")
	          );
	        }
	      }, {
	        title: "专项附加扣除",
	        children: [{
	          title: "子女教育",
	          dataIndex: "childEductaion",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "继续教育",
	          dataIndex: "continuingEducation",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "住房贷款利息",
	          dataIndex: "homeLoanInterest",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "住房租金",
	          dataIndex: "housingRent",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "赡养父母",
	          dataIndex: "dependentParents",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "婴孩照护",
	          dataIndex: "babyCare",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }, {
	          title: "合计",
	          dataIndex: "deductionTotal",
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, ".", ",")
	            );
	          }
	        }]
	      }, {
	        title: "本期应预扣预缴税额",
	        dataIndex: "tax",
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, ".", ",")
	          );
	        }
	      }, {
	        title: "税后合计",
	        dataIndex: "incomeAfterTax",
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, ".", ",")
	          );
	        }
	      }, {
	        title: "现金发放",
	        dataIndex: "cashPayment",
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, ".", ",")
	          );
	        }
	      }, {
	        title: "福利品发放",
	        dataIndex: "welfarePayment",
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, ".", ",")
	          );
	        }
	      }, {
	        title: "银行发放",
	        dataIndex: "bankPayment",
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, ".", ",")
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataSource: []
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.props.dispatch((0, _work_org_list.getWorkOrgList)());
	      this.getWageDetailInfo();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { marginBottom: "16px" } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_antd.Table, {
	            size: "small",
	            bordered: true,
	            columns: this.columns(),
	            dataSource: dataSource,
	            pagination: false,
	            rowKey: "uuid",
	            onChange: this.handleTableChange,
	            scroll: { x: 1630 }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    workOrg: state.work_org_list
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactRedux = __webpack_require__(5);
	
	var _work_org_list = __webpack_require__(234);
	
	var _BackBtn = __webpack_require__(12);
	
	var _bonus = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.getBonusDetailInfo = function () {
	      (0, _bonus.queryBonusDetailInfo)({ uuid: _this.props.params.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          var workOrg = _this.props.workOrg;
	
	          var dataSource = [res.data];
	          workOrg.map(function (item) {
	            if (item.uuid === res.data.workorgname) {
	              dataSource[0].workorgname = item.name;
	            }
	            return item;
	          });
	          _this.setState({
	            dataSource: [res.data]
	          });
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '公司',
	        dataIndex: 'compname',
	        width: 50
	      }, {
	        title: '部门',
	        dataIndex: 'workorgname',
	        width: 50
	      }, {
	        title: '年份',
	        dataIndex: 'year',
	        width: 50
	      }, {
	        title: '姓名',
	        dataIndex: 'person',
	        width: 50
	      }, {
	        title: '应发项目',
	        children: [{
	          title: '基本工资',
	          dataIndex: 'base',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '绩效工资',
	          dataIndex: 'performance',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              'span',
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }]
	      }, {
	        title: '税前年终奖',
	        dataIndex: 'pretax',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '个税',
	        dataIndex: 'personalTax',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '实发年终奖',
	        dataIndex: 'netPay',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataSource: []
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch((0, _work_org_list.getWorkOrgList)());
	      this.getBonusDetailInfo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_antd.Table, {
	            size: 'small',
	            bordered: true,
	            columns: this.columns(),
	            dataSource: dataSource,
	            pagination: false,
	            rowKey: 'uuid',
	            onChange: this.handleTableChange,
	            scroll: { x: 1630 }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    workOrg: state.work_org_list
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _user = __webpack_require__(54);
	
	var _attachment = __webpack_require__(27);
	
	var _ModalTable = __webpack_require__(1699);
	
	var _ModalTable2 = _interopRequireDefault(_ModalTable);
	
	var _ModalDetailTable = __webpack_require__(1698);
	
	var _ModalDetailTable2 = _interopRequireDefault(_ModalDetailTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.getLoginUser = function () {
	      (0, _user.queryAccountInfo)().then(function (res) {});
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handleDetailVisible = function (flag) {
	      _this.setState({
	        detailVisible: !!flag
	      });
	    };
	
	    _this.isAuditor = function (loginUser, activities) {
	      var location = -1;
	      activities.map(function (item, index) {
	        if (loginUser.userUuid === item.processor) {
	          location = index;
	        }
	        return item;
	      });
	      return location;
	    };
	
	    _this.state = {
	      visible: false,
	      detailVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getLoginUser();
	    }
	
	    /**
	     * 判断当前用户是否处在流程中，及在流程中的索引
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          visible = _state.visible,
	          detailVisible = _state.detailVisible;
	
	      var dataItem = this.props.data;
	      var files = dataItem.files || [];
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u5E74\u7EC8\u5956\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u5E74\u7EC8\u5956\u91D1\u989D' },
	              dataItem.price,
	              '\u5143'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5E74\u7EC8\u5956\u516C\u53F8' },
	              dataItem.company
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5E74\u7EC8\u5956\u51ED\u8BC1' },
	              files.length > 0 ? _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return (0, _attachment.queryFilePreview)(files[0]);
	                  } },
	                ' ',
	                files[0].name
	              ) : ''
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u6765\u6E90' },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.handleVisible(true);
	                  } },
	                '\u53D1\u653E\u8BE6\u60C5'
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5E74\u7EC8\u5956\u660E\u7EC6' },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.handleDetailVisible(true);
	                  } },
	                '\u8BE6\u60C5'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u5E74\u7EC8\u5956\u8BF4\u660E' },
	              dataItem.reason
	            )
	          )
	        ),
	        visible ? _react2.default.createElement(_ModalTable2.default, {
	          onCancel: this.handleVisible,
	          details: dataItem.apportion ? dataItem.apportion.details : [],
	          visible: visible
	        }) : null,
	        detailVisible ? _react2.default.createElement(_ModalDetailTable2.default, Object.assign({
	          onCancel: this.handleDetailVisible,
	          visible: detailVisible
	        }, this.props)) : null
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = Open;

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _DataWrapper = __webpack_require__(674);
	
	var _DataWrapper2 = _interopRequireDefault(_DataWrapper);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalDetailTable = function (_Component) {
	  _inherits(ModalDetailTable, _Component);
	
	  function ModalDetailTable(props) {
	    _classCallCheck(this, ModalDetailTable);
	
	    var _this = _possibleConstructorReturn(this, (ModalDetailTable.__proto__ || Object.getPrototypeOf(ModalDetailTable)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: "姓名",
	        dataIndex: "name"
	      }, {
	        title: "税前年终奖",
	        dataIndex: "pretax",
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, ".", ",")
	          );
	        }
	      }, {
	        title: "个税",
	        dataIndex: "personalTax",
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, ".", ",")
	          );
	        }
	      }, {
	        title: "实发年终奖",
	        dataIndex: "netPay",
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, ".", ",")
	          );
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ModalDetailTable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          dataList = _props.dataList,
	          pagination = _props.pagination,
	          visible = _props.visible;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          width: 900,
	          title: "\u5E74\u7EC8\u5956\u660E\u7EC6\u8BE6\u60C5",
	          visible: visible,
	          footer: false,
	          onCancel: function onCancel() {
	            return _this2.props.onCancel(false);
	          }
	        },
	        _react2.default.createElement(_antd.Table, {
	          rowKey: "uuid",
	          columns: this.columns(),
	          dataSource: dataList,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return ModalDetailTable;
	}(_react.Component);
	
	exports.default = (0, _DataWrapper2.default)(ModalDetailTable);

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var type = ['全部人员', '部门', '项目'];
	
	var ModalApportion = function (_Component) {
	  _inherits(ModalApportion, _Component);
	
	  function ModalApportion(props) {
	    _classCallCheck(this, ModalApportion);
	
	    var _this = _possibleConstructorReturn(this, (ModalApportion.__proto__ || Object.getPrototypeOf(ModalApportion)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: '预算来源',
	        dataIndex: 'originName',
	        width: 100
	      }, {
	        title: '来源类型',
	        dataIndex: 'originType',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            type[text]
	          );
	        },
	        width: 100
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        width: 160,
	        render: function render(text, record, index) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            record.isEditable ? _react2.default.createElement(_antd.Input, { value: text, onChange: function onChange() {
	                return _this.handlePriceChange(record);
	              } }) : _react2.default.createElement(
	              'span',
	              null,
	              text
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ModalApportion, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          details = _props.details,
	          visible = _props.visible;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          width: 900,
	          title: '\u67E5\u770B\u53D1\u653E\u8BE6\u60C5',
	          visible: visible,
	          footer: false,
	          onCancel: function onCancel() {
	            return _this2.props.onCancel(false);
	          }
	        },
	        _react2.default.createElement(_antd.Table, {
	          bordered: true,
	          rowKey: 'originUuid',
	          columns: this.columns(),
	          dataSource: details,
	          scroll: { y: 260 },
	          size: 'small'
	        })
	      );
	    }
	  }]);
	
	  return ModalApportion;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalApportion);

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _bonus = __webpack_require__(113);
	
	var _FormBase = __webpack_require__(717);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveBonus(item);
	    };
	
	    _this.bonusWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _bonus.queryBonusWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveBonus = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _bonus.querySaveBonus)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataInfo = this.state.dataInfo;
	
	      this.setState({ dataInfo: dataInfo });
	      this.bonusWorkflow();
	    }
	
	    /**
	     * 提交报销
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, {
	          data: this.state.dataInfo,
	          handSubmit: this.handSubmit,
	          isSubmitting: isSubmitting
	        }),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance })
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1701 */
1696,
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _reactRouter = __webpack_require__(8);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _bonus = __webpack_require__(113);
	
	var _FormBase = __webpack_require__(717);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveBonus(item);
	    };
	
	    _this.bonusWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _bonus.queryBonusWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveBonus = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _bonus.querySaveBonus)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.deleteBonus = function () {
	      (0, _bonus.queryDeleteBonus)({
	        uuid: _this.props.data.uuid
	      }).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataInfo = this.state.dataInfo;
	
	      this.setState({ dataInfo: dataInfo });
	      this.bonusWorkflow();
	    }
	
	    /**
	     * 提交报销
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, {
	          data: this.props.data,
	          handSubmit: this.handSubmit,
	          isSubmitting: isSubmitting,
	          handleDelete: this.deleteBonus
	        }),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _bonus = __webpack_require__(113);
	
	var _PageEdit = __webpack_require__(1702);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1705);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getBonusInfo = function () {
	      (0, _bonus.queryBonusInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getBonusInfo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, { data: dataInfo });
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, { data: dataInfo });
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = PageInfo;

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(598);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _bonus = __webpack_require__(113);
	
	var _FormSearch = __webpack_require__(716);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(718);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            pageSize: 15,
	            total: res.totalSize,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getBonusMyList = function (params) {
	      _this.setState({ loading: true });
	      (0, _bonus.queryBonusMyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.getBonusOrgRecord = function (params) {
	      (0, _bonus.queryBonusOrgRecord)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getBonusMyList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.location.pathname
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        type: 'mine',
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/hr/b_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u5E74\u7EC8\u5956'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(Manage);

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _WorkflowOp = __webpack_require__(134);
	
	var _WorkflowOp2 = _interopRequireDefault(_WorkflowOp);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _bonus = __webpack_require__(113);
	
	var _FormOpen = __webpack_require__(1697);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item, type) {
	      if (type === 'save') {
	        _this.saveBonus(item);
	      }
	    };
	
	    _this.saveBonus = function (item) {
	      var context = _this;
	      (0, _bonus.querySaveBonus)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('保存成功');
	          context.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.doTask = function (pass, refuse) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackBonus(item);
	          break;
	        case 'next':
	          _this.nextBonus(item);
	          break;
	        case 'return':
	          _this.returnBonus(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackBonus = function (params) {
	      (0, _bonus.queryCallbackBonus)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextBonus = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _bonus.queryNextBonus)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnBonus = function (params, refuse) {
	      (0, _bonus.queryReturnBonus)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.bonusDetailList = function (pageNo) {
	      var params = {};
	      var data = _this.props.data;
	
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.companyUuid = data.companyUuid;
	      params.year = data.year;
	      params.limit = 15;
	      params.start = current;
	      (0, _bonus.queryBonusDetailList)(Object.assign({}, params)).then(function (res) {
	        _this.setState({
	          dataList: res.data,
	          total: res.totalSize
	        });
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      total: 0,
	      pageNo: 1,
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.bonusDetailList();
	      this.setState({ dataInfo: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 提交报销
	     */
	
	
	    /**
	     * 保存
	     */
	
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	
	    /** ---------------------------------年终奖审核页新增 年终奖列表详情---------------------------------*/
	
	  }, {
	    key: 'render',
	
	
	    /**--------------------------------------------------------------------------------------------*/
	
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          dataList = _state.dataList,
	          total = _state.total,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.bonusDetailList(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowOp2.default, {
	          data: dataInfo,
	          isLoading: isLoading,
	          doTask: this.doTask,
	          watchTask: this.watchTask
	        }),
	        _react2.default.createElement(_FormOpen2.default, {
	          data: dataInfo,
	          dataList: dataList,
	          pagination: pagination,
	          handSubmit: this.handSubmit,
	          doTask: this.doTask,
	          watchTask: this.watchTask
	        }),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'bonus', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	__webpack_require__(598);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _bonus = __webpack_require__(113);
	
	var _TableExpenses = __webpack_require__(718);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getBonusList = function (params) {
	      _this.setState({ loading: true });
	      (0, _bonus.bonus)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.getBonusOrgRecord = function (params) {
	      (0, _bonus.queryBonusOrgRecord)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getBonusList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.location.pathname
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(Manage);

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _YearPicker = __webpack_require__(154);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	var _BackBtn = __webpack_require__(12);
	
	var _bonus = __webpack_require__(113);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Description = _DescriptionList2.default.Description;
	
	var PageMonthCompany = function (_Component) {
	  _inherits(PageMonthCompany, _Component);
	
	  function PageMonthCompany(props) {
	    _classCallCheck(this, PageMonthCompany);
	
	    var _this = _possibleConstructorReturn(this, (PageMonthCompany.__proto__ || Object.getPrototypeOf(PageMonthCompany)).call(this, props));
	
	    _this.getParams = function () {
	      var uuid = _this.props.params.uuid;
	
	      return Object.assign({}, _this.props.form.getFieldsValue(), {
	        companyUuid: uuid
	      });
	    };
	
	    _this.bonusStaticComMonth = function () {
	      (0, _bonus.queryBonusStaticComMonth)(_this.getParams()).then(function (res) {
	        _this.setState({
	          staticData: res.data
	        });
	      });
	    };
	
	    _this.bonusDetailList = function (pageNo) {
	      var params = {};
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      (0, _bonus.queryBonusDetailList)(Object.assign({}, _this.getParams(), params)).then(function (res) {
	        _this.setState({
	          data: res.data,
	          total: res.totalSize
	        });
	      });
	    };
	
	    _this.loadData = function () {
	      _this.bonusStaticComMonth();
	      _this.bonusDetailList();
	    };
	
	    _this.handleSearch = function (e) {
	      e.preventDefault();
	      _this.loadData();
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', style: { textAlign: 'right' }, onSubmit: _this.handleSearch },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('year', {
	            initialValue: _moment2.default.unix(new Date().getTime() / 1000).format('YYYY')
	          })(_react2.default.createElement(_YearPicker2.default, { style: { width: '200px' } }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit', style: { marginRight: '-16px' } },
	            '\u67E5\u8BE2'
	          )
	        )
	      );
	    };
	
	    _this.bonusSend = function (uuid) {
	      (0, _bonus.querySendBonus)({
	        uuids: [uuid]
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.bonusDetailList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.bonusBack = function (uuid) {
	      (0, _bonus.queryBackBonus)({
	        uuids: [uuid]
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.bonusDetailList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.bonusBackAll = function () {
	      var params = _this.getParams();
	      (0, _bonus.queryBackAllBonus)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.bonusDetailList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.bonusSendAll = function () {
	      var params = _this.getParams();
	      _this.setState({
	        sendAllLoading: true
	      });
	      (0, _bonus.querySendAllBonus)(params).then(function (res) {
	        _this.setState({
	          sendAllLoading: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.bonusDetailList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '发放年度',
	        dataIndex: 'year'
	      }, {
	        title: '姓名',
	        dataIndex: 'name'
	      }, {
	        title: '税前年终奖',
	        dataIndex: 'pretax',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '个税',
	        dataIndex: 'personalTax',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '实发年终奖',
	        dataIndex: 'netPay',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '导入日期',
	        dataIndex: 'createTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/hr/b_manage/detail/' + record.uuid },
	              '\u67E5\u770B'
	            ),
	            _react2.default.createElement(_antd.Divider, { type: 'verticle' }),
	            record.isSendFlag ? null : _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.bonusSend(record.uuid);
	                } },
	              '\u53D1\u9001\u5E74\u7EC8\u5956\u6761'
	            ),
	            !record.isReadFlag && record.isSendFlag ? _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.bonusBack(record.uuid);
	                } },
	              '\u6536\u56DE'
	            ) : null
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      total: 0,
	      pageNo: 1,
	      staticData: {},
	      sendAllLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(PageMonthCompany, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total,
	          staticData = _state.staticData;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.bonusDetailList(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 6 },
	              _react2.default.createElement(_antd.Button, { icon: 'left', shape: 'circle', style: { marginRight: 10 }, onClick: _BackBtn.goBack })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 18 },
	              this.renderSearchForm()
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Divider, null),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', style: { marginBottom: 32 }, col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u516C\u53F8\u540D\u79F0' },
	              staticData.companyName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5458\u5DE5\u4EBA\u6570' },
	              staticData.hrCount
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5B9E\u53D1\u5E74\u7EC8\u5956\u603B\u989D' },
	              _index2.default.numberFormat(staticData.netPay, 2, '.', ','),
	              '\u5143'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList', style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              style: { margin: '0 8px 16px 0' },
	              type: 'primary',
	              onClick: function onClick() {
	                return _this2.bonusSendAll();
	              },
	              loading: this.state.sendAllLoading
	            },
	            '\u53D1\u9001\u5168\u90E8\u5E74\u7EC8\u5956\u6761'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { onClick: function onClick() {
	                return _this2.bonusBackAll();
	              } },
	            '\u5168\u90E8\u64A4\u56DE'
	          )
	        ),
	        _react2.default.createElement(_antd.Table, { rowKey: 'uuid', columns: this.columns(), dataSource: data, pagination: pagination })
	      );
	    }
	  }]);
	
	  return PageMonthCompany;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(PageMonthCompany);

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _SearchUser = __webpack_require__(273);
	
	var _SearchUser2 = _interopRequireDefault(_SearchUser);
	
	var _core_account_search = __webpack_require__(232);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	
	var FormConfig = function (_Component) {
	  _inherits(FormConfig, _Component);
	
	  function FormConfig(props) {
	    _classCallCheck(this, FormConfig);
	
	    var _this = _possibleConstructorReturn(this, (FormConfig.__proto__ || Object.getPrototypeOf(FormConfig)).call(this, props));
	
	    _this.createRandomId = function () {
	      return (Math.random() * 10000000).toString(16).substr(0, 4) + '-' + new Date().getTime() + '-' + Math.random().toString().substr(2, 5);
	    };
	
	    _this.getDetail = function () {
	      (0, _org.queryConfigOrgInfo)({
	        orgUuid: _this.props.orgUuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          if (res.data) {
	            _this.initValue(res.data);
	          }
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var onSubmit = _this.props.onSubmit;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var arr = {};
	          _this.state.configs.forEach(function (item) {
	            arr[values[item.uuid + '+key']] = {
	              title: values[item.uuid + '+title'],
	              userUuid: values[item.uuid + '+userUuid'],
	              userName: values[item.uuid + '+userName']
	            };
	          });
	          onSubmit(arr);
	        }
	      });
	    };
	
	    _this.initValue = function (data) {
	      var configs = [];
	      var selectedConfig = [];
	      Object.keys(data).forEach(function (item) {
	        if (data[item]) {
	          var uuid = _this.createRandomId();
	          var params = {};
	          params.uuid = uuid;
	          params[uuid + '+key'] = item;
	          params[uuid + '+title'] = data[item].title;
	          params[uuid + '+userName'] = data[item].userName;
	          params[uuid + '+userUuid'] = data[item].userUuid;
	          configs.push(params);
	          selectedConfig.push(item);
	        }
	      });
	      if (configs.length < 1) {
	        configs = [{ uuid: _this.createRandomId() }];
	      }
	      _this.setState({
	        configs: configs,
	        selectedConfig: selectedConfig
	      });
	    };
	
	    _this.getOptions = function () {
	      (0, _org.queryConfigOrgOp)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            configTitles: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.add = function () {
	      var configs = _this.state.configs;
	
	      _this.setState({
	        configs: [].concat(_toConsumableArray(configs), [{ uuid: _this.createRandomId() }])
	      });
	    };
	
	    _this.sub = function (uuid) {
	      var configs = _this.state.configs;
	      var selectedConfig = _this.state.selectedConfig;
	
	      configs = configs.filter(function (item) {
	        return item.uuid !== uuid;
	      });
	      var params = _this.props.form.getFieldsValue();
	      var deleteConfig = params[uuid + '+key'];
	      selectedConfig = selectedConfig.filter(function (item) {
	        return item !== deleteConfig;
	      });
	      _this.setState({
	        configs: configs,
	        selectedConfig: selectedConfig
	      });
	    };
	
	    _this.handleChange = function (fieldName, fieldName2) {
	      return function (value, option) {
	        var params = _this.props.form.getFieldsValue();
	        var selectedConfig = [];
	        Object.keys(params).filter(function (item) {
	          return item.indexOf('key') >= 0;
	        }).forEach(function (item) {
	          if (params[item] && item !== fieldName2) {
	            selectedConfig.push(params[item]);
	          }
	        });
	        var titleObj = {};
	        titleObj[fieldName] = option.props.children;
	        _this.props.form.setFieldsValue(titleObj);
	        _this.setState({
	          selectedConfig: [].concat(selectedConfig, [value])
	        });
	      };
	    };
	
	    _this.handleUserChange = function (fieldName) {
	      return function (value, option) {
	        var nameObj = {};
	        nameObj[fieldName] = option.props.children;
	        _this.props.form.setFieldsValue(nameObj);
	      };
	    };
	
	    _this.state = {
	      configTitles: {},
	      selectedConfig: [],
	      configs: [{ uuid: _this.createRandomId() }]
	    };
	    return _this;
	  }
	
	  _createClass(FormConfig, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getOptions();
	      this.getDetail();
	      this.props.dispatch((0, _core_account_search.getAccountSearch)());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var ItemLayout = {
	        labelCol: { span: 5 },
	        wrapperCol: { span: 15 }
	      };
	      var _state = this.state,
	          configTitles = _state.configTitles,
	          configs = _state.configs,
	          selectedConfig = _state.selectedConfig;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15 } },
	          _react2.default.createElement(
	            _antd.Button,
	            { icon: 'save', style: { marginRight: 10 }, htmlType: 'submit' },
	            '\u4FDD\u5B58'
	          )
	        ),
	        configs.map(function (config, index) {
	          getFieldDecorator(config.uuid + '+title', {
	            initialValue: config[config.uuid + '+title']
	          });
	          getFieldDecorator(config.uuid + '+userName', {
	            initialValue: config[config.uuid + '+userName']
	          });
	          return _react2.default.createElement(
	            _antd.Row,
	            { key: config.uuid },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u804C\u4F4D' }, ItemLayout),
	                getFieldDecorator(config.uuid + '+key', {
	                  rules: [{ required: true, message: '请输入组织名称!' }],
	                  initialValue: config[config.uuid + '+key']
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  {
	                    onChange: _this2.handleChange(config.uuid + '+title', config.uuid + '+key')
	                  },
	                  Object.keys(configTitles).map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item, disabled: selectedConfig.indexOf(item) >= 0 },
	                      configTitles[item]
	                    );
	                  })
	                ))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 10 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4EBA\u5458' }, ItemLayout),
	                getFieldDecorator(config.uuid + '+userUuid', {
	                  initialValue: config[config.uuid + '+userUuid']
	                })(_react2.default.createElement(_SearchUser2.default, {
	                  onChange: _this2.handleUserChange(config.uuid + '+userName'),
	                  name: config[config.uuid + '+userName']
	                }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 4 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                index === configs.length - 1 && configs.length < Object.keys(configTitles).length ? _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary', onClick: _this2.add },
	                  '+'
	                ) : null,
	                configs.length > 1 ? _react2.default.createElement(
	                  _antd.Button,
	                  { style: { marginLeft: '8px' }, onClick: function onClick() {
	                      return _this2.sub(config.uuid);
	                    } },
	                  '-'
	                ) : null
	              )
	            )
	          );
	        })
	      );
	    }
	  }]);
	
	  return FormConfig;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create({ wrappedComponentRef: true })(FormConfig));

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var RadioGroup = _antd.Radio.Group;
	
	var FormOrg = function (_Component) {
	  _inherits(FormOrg, _Component);
	
	  function FormOrg(props) {
	    _classCallCheck(this, FormOrg);
	
	    var _this = _possibleConstructorReturn(this, (FormOrg.__proto__ || Object.getPrototypeOf(FormOrg)).call(this, props));
	
	    _this.getDetail = function () {
	      (0, _org.queryOrgInfo)({ uuid: _this.props.detail.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            detail: res.data
	          });
	        }
	      });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var onSubmit = _this.props.onSubmit;
	      var detail = _this.state.detail;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = values;
	          if (detail.uuid) {
	            params.uuid = detail.uuid;
	            params.levelCode = detail.levelCode;
	          }
	          onSubmit(values);
	        }
	      });
	    };
	
	    _this.format = function (data) {
	      data.map(function (item) {
	        item.title = item.name;
	        item.value = item.levelCode;
	        item.key = item.levelCode;
	        if (item.children) {
	          _this.format(item.children);
	        }
	        return item;
	      });
	    };
	
	    _this.state = {
	      detail: {}
	    };
	    return _this;
	  }
	
	  _createClass(FormOrg, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.detail.uuid) {
	        this.getDetail();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          getFieldDecorator = _props.form.getFieldDecorator,
	          gData = _props.gData;
	      var detail = this.state.detail;
	
	      var initDetail = this.props.detail;
	      var parent = detail.parent || initDetail.parent;
	
	      this.format(gData);
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var ItemLayout2 = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 20 }
	      };
	      if (detail.uuid) {
	        detail.parent = detail.levelCode.slice(0, detail.levelCode.length - 2);
	      }
	      return _react2.default.createElement(
	        _antd.Form,
	        { onSubmit: this.submit },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15 } },
	          _react2.default.createElement(
	            _antd.Button,
	            { icon: 'save', style: { marginRight: 10 }, htmlType: 'submit' },
	            '\u4FDD\u5B58'
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u7EC4\u7EC7\u540D\u79F0' }, ItemLayout),
	              getFieldDecorator('name', {
	                rules: [{ required: true, message: '请输入组织名称!' }],
	                initialValue: detail.name
	              })(_react2.default.createElement(_antd.Input, { placeholder: '\u7EC4\u7EC7\u540D\u79F0' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u7EC4\u7EC7\u7B80\u540D' }, ItemLayout),
	              getFieldDecorator('sort', {
	                initialValue: detail.sort
	              })(_react2.default.createElement(_antd.Input, { placeholder: '\u7EC4\u7EC7\u7B80\u540D' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u7EC4\u7EC7\u7B80\u62FC' }, ItemLayout),
	              getFieldDecorator('pinyin', {
	                initialValue: detail.pinyin
	              })(_react2.default.createElement(_antd.Input, { placeholder: '\u7EC4\u7EC7\u7B80\u62FC' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u4E0A\u7EA7\u7EC4\u7EC7' }, ItemLayout),
	              getFieldDecorator('parent', {
	                initialValue: parent
	              })(_react2.default.createElement(_antd.TreeSelect, {
	                disabled: !!parent,
	                showSearch: true,
	                treeNodeFilterProp: 'title',
	                dropdownStyle: { maxHeight: 400, overflow: 'auto' },
	                treeData: gData,
	                treeDefaultExpandAll: true
	              }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u7EC4\u7EC7\u7C7B\u578B' }, ItemLayout),
	              getFieldDecorator('type', {
	                rules: [{ required: true, message: '请选择组织类型!' }],
	                initialValue: detail.type
	              })(_react2.default.createElement(
	                RadioGroup,
	                null,
	                _react2.default.createElement(
	                  _antd.Radio,
	                  { value: 2 },
	                  '\u516C\u53F8'
	                ),
	                _react2.default.createElement(
	                  _antd.Radio,
	                  { value: 3 },
	                  '\u90E8\u95E8'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5907\u6CE8' }, ItemLayout2),
	              getFieldDecorator('remark', {
	                initialValue: detail.remark
	              })(_react2.default.createElement(_antd.Input.TextArea, { rows: 4, placeholder: '\u5907\u6CE8', maxLength: 1000 })),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '12px', color: '#999' } },
	                '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormOrg;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { gData: state.organization };
	})(_antd.Form.create({ wrappedComponentRef: true })(FormOrg));

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _organization = __webpack_require__(736);
	
	var _org = __webpack_require__(53);
	
	var _FormOrg = __webpack_require__(1709);
	
	var _FormOrg2 = _interopRequireDefault(_FormOrg);
	
	var _FormConfig = __webpack_require__(1708);
	
	var _FormConfig2 = _interopRequireDefault(_FormConfig);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.handleSave = function (params) {
	      if (params.uuid) {
	        _this.updateOrg(params);
	      } else {
	        _this.addOrg(params);
	      }
	    };
	
	    _this.configOrg = function (config) {
	      var params = {
	        orgUuid: _this.uuid,
	        orgName: _this.orgName,
	        config: config
	      };
	      (0, _org.queryConfigOrg)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.handleConfigVisible(false);
	          _antd.message.success(res.message);
	          _this.getOrgTree();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.addOrg = function (params) {
	      (0, _org.queryAddOrg)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.handleVisible(false);
	          _antd.message.success(res.message);
	          _this.getOrgTree();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.updateOrg = function (params) {
	      (0, _org.queryUpdateOrg)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.handleVisible(false);
	          _antd.message.success(res.message);
	          _this.getOrgTree();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deleteOrg = function (uuid) {
	      (0, _org.queryDeleteOrg)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getOrgTree();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.disableOrg = function (uuid) {
	      (0, _org.queryDisableOrg)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getOrgTree();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.enableOrg = function (uuid) {
	      (0, _org.queryEnableOrg)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getOrgTree();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getOrgTree = function () {
	      var dispatch = _this.props.dispatch;
	
	      dispatch((0, _organization.getOrganization)());
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handleConfig = function (uuid, orgName) {
	      _this.uuid = uuid;
	      _this.orgName = orgName;
	      _this.handleConfigVisible(true);
	    };
	
	    _this.handleConfigVisible = function (flag) {
	      _this.setState({
	        configVisible: !!flag
	      });
	    };
	
	    _this.handleAdd = function (detail) {
	      _this.setState({
	        detail: detail
	      });
	      _this.handleVisible(true);
	    };
	
	    _this.handleEdit = function (record) {
	      _this.setState({
	        detail: record
	      });
	      _this.handleVisible(true);
	    };
	
	    _this.onClose = function () {
	      _this.handleVisible(false);
	    };
	
	    _this.onConfigClose = function () {
	      _this.handleConfigVisible(false);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '组织名称',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.handleEdit(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: '性质',
	        dataIndex: 'type',
	        key: 'type',
	        render: function render(text, record) {
	          return text === 2 ? _react2.default.createElement(
	            'span',
	            { style: { color: 'red' } },
	            '\u516C\u53F8'
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u90E8\u95E8'
	          );
	        }
	      }, {
	        title: '备注',
	        dataIndex: 'remark',
	        key: 'remark'
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.handleConfig(record.uuid, record.name);
	                } },
	              '\u7EC4\u7EC7\u914D\u7F6E'
	            ),
	            record.children ? null : _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement('span', { className: 'ant-divider' }),
	              _react2.default.createElement(
	                _antd.Popconfirm,
	                {
	                  onConfirm: function onConfirm() {
	                    return _this.deleteOrg(record.uuid);
	                  },
	                  title: '\u786E\u5B9A\u5220\u9664\u5F53\u524D\u7EC4\u7EC7\u5417\uFF1F',
	                  placement: 'topRight',
	                  overlayStyle: { width: 200 }
	                },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'ant-dropdown-link' },
	                  '\u5220\u9664'
	                )
	              )
	            ),
	            _react2.default.createElement('span', { className: 'ant-divider' }),
	            _react2.default.createElement(
	              'a',
	              {
	                className: 'ant-dropdown-link',
	                onClick: function onClick() {
	                  return _this.handleEdit({ parent: record.levelCode });
	                }
	              },
	              '\u6DFB\u52A0'
	            ),
	            _react2.default.createElement('span', { className: 'ant-divider' }),
	            record.status === 1 ? _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                onConfirm: function onConfirm() {
	                  return _this.disableOrg(record.uuid);
	                },
	                title: '\u786E\u5B9A\u7981\u7528\u5F53\u524D\u7EC4\u7EC7\u5417\uFF1F',
	                placement: 'topRight',
	                overlayStyle: { width: 200 }
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'ant-dropdown-link' },
	                '\u7981\u7528'
	              )
	            ) : _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                onConfirm: function onConfirm() {
	                  return _this.enableOrg(record.uuid);
	                },
	                title: '\u786E\u5B9A\u7981\u7528\u5F53\u524D\u7EC4\u7EC7\u5417\uFF1F',
	                placement: 'topRight',
	                overlayStyle: { width: 200 }
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'ant-dropdown-link' },
	                '\u542F\u7528'
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.setClassName = function (record, index) {
	      if (record.status === 0) {
	        return 'td-gray';
	      }
	    };
	
	    _this.state = {
	      visible: false,
	      detail: {},
	      configVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getOrgTree();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var gData = this.props.gData;
	      var _state = this.state,
	          visible = _state.visible,
	          detail = _state.detail,
	          configVisible = _state.configVisible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            type: 'primary',
	            icon: 'plus',
	            style: { marginBottom: 15 },
	            onClick: function onClick() {
	              return _this2.handleAdd({});
	            }
	          },
	          '\u6DFB\u52A0'
	        ),
	        _react2.default.createElement(_antd.Table, {
	          style: { background: '#fff' },
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: gData,
	          pagination: false,
	          rowKey: 'uuid',
	          rowClassName: this.setClassName
	        }),
	        visible ? _react2.default.createElement(
	          _antd.Drawer,
	          {
	            title: detail.uuid ? '组织编辑' : '组织新增',
	            placement: 'right',
	            closable: true,
	            visible: visible,
	            onClose: this.onClose,
	            width: 680
	          },
	          _react2.default.createElement(_FormOrg2.default, { onSubmit: this.handleSave, detail: detail })
	        ) : null,
	        configVisible ? _react2.default.createElement(
	          _antd.Drawer,
	          {
	            title: '\u7EC4\u7EC7\u914D\u7F6E',
	            placement: 'right',
	            closable: true,
	            visible: configVisible,
	            onClose: this.onConfigClose,
	            width: 680
	          },
	          _react2.default.createElement(_FormConfig2.default, { onSubmit: this.configOrg, detail: detail, orgUuid: this.uuid })
	        ) : null
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { gData: state.organization };
	})(Index);

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _antd = __webpack_require__(2);
	
	var _Index = __webpack_require__(1710);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(1731);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _Index5 = __webpack_require__(1713);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _Index7 = __webpack_require__(1727);
	
	var _Index8 = _interopRequireDefault(_Index7);
	
	var _PageMine = __webpack_require__(1722);
	
	var _PageMine2 = _interopRequireDefault(_PageMine);
	
	var _PageWatch = __webpack_require__(1726);
	
	var _PageWatch2 = _interopRequireDefault(_PageWatch);
	
	var _PageAdd = __webpack_require__(1718);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	var _PageInfo = __webpack_require__(1721);
	
	var _PageInfo2 = _interopRequireDefault(_PageInfo);
	
	var _PageStatic = __webpack_require__(1725);
	
	var _PageStatic2 = _interopRequireDefault(_PageStatic);
	
	var _PageMonthCompany = __webpack_require__(1723);
	
	var _PageMonthCompany2 = _interopRequireDefault(_PageMonthCompany);
	
	var _PageYearCompany = __webpack_require__(1707);
	
	var _PageYearCompany2 = _interopRequireDefault(_PageYearCompany);
	
	var _PageDetail = __webpack_require__(1719);
	
	var _PageDetail2 = _interopRequireDefault(_PageDetail);
	
	var _PageAdd3 = __webpack_require__(1700);
	
	var _PageAdd4 = _interopRequireDefault(_PageAdd3);
	
	var _PageMine3 = __webpack_require__(1704);
	
	var _PageMine4 = _interopRequireDefault(_PageMine3);
	
	var _PageWatch3 = __webpack_require__(1706);
	
	var _PageWatch4 = _interopRequireDefault(_PageWatch3);
	
	var _PageInfo3 = __webpack_require__(1703);
	
	var _PageInfo4 = _interopRequireDefault(_PageInfo3);
	
	var _PageDetail3 = __webpack_require__(1701);
	
	var _PageDetail4 = _interopRequireDefault(_PageDetail3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * routers
	 * 更多关于Router的使用，请参考以下教程
	 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
	 */
	
	// 人力资源
	var router = {
	  path: 'hr',
	  breadcrumbName: '人力资源',
	  childRoutes: [{
	    path: 'org',
	    breadcrumbName: '组织架构',
	    indexRoute: { component: _Index2.default }
	  }, {
	    path: 'workorg',
	    breadcrumbName: '业务部门管理',
	    indexRoute: { component: _Index4.default }
	  }, {
	    path: 'staff',
	    breadcrumbName: '人员列表',
	    indexRoute: { component: _Index6.default }
	  }, {
	    path: 'wage',
	    breadcrumbName: '工资导入',
	    indexRoute: { component: _Index8.default },
	    childRoutes: [{
	      path: 'detail/:uuid',
	      component: _PageDetail2.default,
	      breadcrumbName: '工资明细'
	    }, {
	      path: 'wageCompanyMonth/:uuid',
	      component: _antd.Form.create({ wrappedComponentRef: true })(_PageMonthCompany2.default),
	      breadcrumbName: '工资查看'
	    }, {
	      path: 'bonusCompanyYear/:uuid',
	      component: _antd.Form.create({ wrappedComponentRef: true })(_PageYearCompany2.default),
	      breadcrumbName: '年终奖查看'
	    }]
	  }, {
	    path: 'w_static',
	    breadcrumbName: '公司薪酬总览',
	    indexRoute: { component: _PageStatic2.default }
	  }, {
	    path: 'w_manage',
	    breadcrumbName: '我的工资',
	    indexRoute: { component: _PageMine2.default },
	    childRoutes: [{
	      path: 'add',
	      component: _PageAdd2.default,
	      breadcrumbName: '工资申请'
	    }, {
	      path: 'open/:uuid',
	      component: _PageInfo2.default,
	      breadcrumbName: '查看工资'
	    }]
	  }, {
	    path: 'w_manage_watch',
	    breadcrumbName: '工资监控',
	    indexRoute: { component: _PageWatch2.default }
	  }, {
	    path: 'b_manage',
	    breadcrumbName: '我的年终奖',
	    indexRoute: { component: _PageMine4.default },
	    childRoutes: [{
	      path: 'detail/:uuid',
	      component: _PageDetail4.default,
	      breadcrumbName: '年终奖明细'
	    }, {
	      path: 'add',
	      component: _PageAdd4.default,
	      breadcrumbName: '年终奖申请'
	    }, {
	      path: 'open/:uuid',
	      component: _PageInfo4.default,
	      breadcrumbName: '查看年终奖'
	    }]
	  }, {
	    path: 'b_manage_watch',
	    breadcrumbName: '年终奖监控',
	    indexRoute: { component: _PageWatch4.default }
	  }]
	};
	// 年终奖
	exports.default = router;

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _company_list = __webpack_require__(96);
	
	var _work_org_list = __webpack_require__(234);
	
	var _department_list = __webpack_require__(730);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _companySearch = __webpack_require__(95);
	
	var _companySearch2 = _interopRequireDefault(_companySearch);
	
	var _hr = __webpack_require__(167);
	
	var _attachment = __webpack_require__(27);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Option = _antd.Select.Option;
	
	var FormItem = _antd.Form.Item;
	var RadioGroup = _antd.Radio.Group;
	
	var getParentCompany = function getParentCompany(key, tree, grandKeys) {
	  var parentKey = void 0;
	  var grandKey = grandKeys || [];
	  for (var i = 0; i < tree.length; i++) {
	    var node = tree[i];
	
	    if (node.children) {
	      if (node.children.some(function (item) {
	        return item.uuid === key;
	      })) {
	        if (node.type === 2) {
	          grandKey.push({ orgUuid: node.uuid, orgName: node.name });
	        }
	        parentKey = grandKey;
	      } else if (getParentCompany(key, node.children)) {
	        if (node.type === 2) {
	          grandKey.push({ orgUuid: node.uuid, orgName: node.name });
	        }
	        parentKey = getParentCompany(key, node.children, grandKey);
	      }
	    }
	  }
	  return parentKey;
	};
	
	var FormStaff = function (_Component) {
	  _inherits(FormStaff, _Component);
	
	  function FormStaff(props) {
	    _classCallCheck(this, FormStaff);
	
	    var _this = _possibleConstructorReturn(this, (FormStaff.__proto__ || Object.getPrototypeOf(FormStaff)).call(this, props));
	
	    _this.formatDate = function (date) {
	      return date ? (0, _moment2.default)(date).format('YYYY-MM-DD') : date;
	    };
	
	    _this.getDetail = function () {
	      (0, _hr.queryHrInfo)({ uuid: _this.props.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            detail: res.data
	          });
	        }
	      });
	    };
	
	    _this.getDepartmentList = function (uuid) {
	      _this.props.dispatch((0, _department_list.getDepartmentList)({ uuid: uuid }));
	    };
	
	    _this.getOrgDetail = function () {
	      (0, _org.queryOrgInfo)({ uuid: _this.props.orgUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          if (res.data.type === 2) {
	            _this.comUuid = _this.props.orgUuid;
	            _this.getDepartmentList(_this.comUuid);
	            _this.props.form.setFieldsValue({ comName: res.data.name });
	          } else if (res.data.type === 3) {
	            _this.deptUuid = _this.props.orgUuid;
	            var org = getParentCompany(_this.props.orgUuid, _this.props.orgTree).pop();
	
	            _this.comUuid = org.orgUuid;
	            _this.props.form.setFieldsValue({ comName: org.orgName });
	            _this.getDepartmentList(_this.comUuid);
	            _this.props.form.setFieldsValue({ deptName: res.data.name });
	          }
	        }
	      });
	    };
	
	    _this.handleComChange = function (value, option) {
	      _this.getDepartmentList(value);
	      _this.props.form.setFieldsValue({
	        comName: option.props.children,
	        deptUuid: '',
	        deptName: ''
	      });
	    };
	
	    _this.handleDepChange = function (value, label, extra) {
	      _this.props.form.setFieldsValue({ deptName: label[0] });
	    };
	
	    _this.handleSave = function (e) {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          if (_this.props.uuid) {
	            values.uuid = _this.props.uuid;
	          }
	          _this.formatParamDate(values);
	
	          _this.props.saveHr(values);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function (res) {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.handleRegister = function (e) {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          if (_this.props.uuid) {
	            values.uuid = _this.props.uuid;
	          }
	          _this.formatParamDate(values);
	
	          _this.props.registerHr(values);
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function (res) {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.formatParamDate = function (values) {
	      if (values.sDate) {
	        values.sDate = _this.formatDate(values.sDate);
	      }
	
	      if (values.eDate) {
	        values.eDate = _this.formatDate(values.eDate);
	      }
	
	      if (values.inDate) {
	        values.inDate = _this.formatDate(values.inDate);
	      }
	      if (values.birthday) {
	        values.birthday = _this.formatDate(values.birthday);
	      }
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.format = function (data) {
	      data.map(function (item) {
	        item.title = item.name;
	        item.value = item.uuid;
	        item.key = item.uuid;
	        if (item.children) {
	          _this.format(item.children);
	        }
	        return item;
	      });
	    };
	
	    _this.state = {
	      detail: {},
	      delFiles: []
	    };
	    return _this;
	  }
	
	  _createClass(FormStaff, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch((0, _company_list.getCompanyList)());
	      this.props.dispatch((0, _work_org_list.getWorkOrgList)());
	      if (this.props.orgUuid) {
	        this.getOrgDetail();
	      }
	      if (this.props.uuid) {
	        this.getDetail();
	      }
	    }
	
	    /**
	     *文件删除
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var workOrg = this.props.workOrg;
	      var detail = this.state.detail;
	      var _props = this.props,
	          departTree = _props.departTree,
	          orgTree = _props.orgTree;
	
	      var departmentList = departTree.length > 0 ? departTree : orgTree;
	      this.format(departmentList);
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var ItemLayout2 = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 20 }
	      };
	      getFieldDecorator('comName', {
	        initialValue: detail.comName
	      });
	      getFieldDecorator('deptName', {
	        initialValue: detail.deptName
	      });
	      return _react2.default.createElement(
	        _antd.Form,
	        { className: 'formStaff' },
	        _react2.default.createElement(
	          'div',
	          { style: { marginBottom: 15 } },
	          _react2.default.createElement(
	            _antd.Button,
	            { icon: 'save', style: { marginRight: 10 }, onClick: this.handleSave },
	            '\u4FDD\u5B58'
	          ),
	          detail.accountUuid ? '' : _react2.default.createElement(
	            _antd.Button,
	            { icon: 'save', style: { marginRight: 10 }, onClick: this.handleRegister },
	            '\u6CE8\u518C'
	          ),
	          detail.uuid ? _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                icon: 'delete',
	                style: { marginRight: 10 },
	                onClick: function onClick() {
	                  return _this2.props.deleteHr(detail.uuid);
	                }
	              },
	              '\u5220\u9664'
	            ),
	            detail.status === 1 ? _react2.default.createElement(
	              _antd.Button,
	              {
	                icon: 'lock',
	                style: { marginRight: 10 },
	                onClick: function onClick() {
	                  return _this2.props.disableHr(detail.uuid);
	                }
	              },
	              '\u7981\u7528'
	            ) : _react2.default.createElement(
	              _antd.Button,
	              {
	                icon: 'unlock',
	                style: { marginRight: 10 },
	                onClick: function onClick() {
	                  return _this2.props.enableHr(detail.uuid);
	                }
	              },
	              '\u542F\u7528'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                icon: 'rollback',
	                style: { marginRight: 10 },
	                onClick: function onClick() {
	                  return _this2.props.resetHr(detail.uuid);
	                }
	              },
	              '\u91CD\u7F6E\u5BC6\u7801'
	            )
	          ) : null
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u59D3\u540D' }),
	              getFieldDecorator('name', {
	                rules: [{ required: true, message: '请输入姓名!' }],
	                initialValue: detail.name
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u624B\u673A\u53F7\u7801' }),
	              getFieldDecorator('mobile', {
	                rules: [{ required: true, message: '请输入手机号码!' }],
	                initialValue: detail.mobile
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u516C\u53F8\u540D\u79F0' }, ItemLayout),
	              getFieldDecorator('comUuid', {
	                rules: [{ required: true, message: '请选择归属公司' }],
	                initialValue: detail.uuid ? detail.comUuid : this.comUuid
	              })(_react2.default.createElement(_companySearch2.default, Object.assign({
	                companyName: detail.comName,
	                companyUuid: detail.comUuid,
	                onChange: this.handleComChange
	              }, this.props)))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u90E8\u95E8' }, ItemLayout),
	              getFieldDecorator('deptUuid', {
	                rules: [{ required: true, message: '请输入部门!' }],
	                initialValue: detail.uuid ? detail.deptUuid : this.deptUuid
	              })(_react2.default.createElement(_antd.TreeSelect, {
	                showSearch: true,
	                treeNodeFilterProp: 'title',
	                dropdownStyle: { maxHeight: 400, overflow: 'auto' },
	                treeData: departmentList,
	                treeDefaultExpandAll: true,
	                onChange: this.handleDepChange
	              }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u804C\u80FD\u90E8\u95E8' }, ItemLayout),
	              getFieldDecorator('workOrgUuid', {
	                initialValue: detail.workOrgUuid
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: true,
	                  filterOption: function filterOption(input, option) {
	                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  }
	                },
	                workOrg.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.uuid },
	                    item.name
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u5C97\u4F4D\u7EA7\u522B' }, ItemLayout),
	              getFieldDecorator('workLeave', {
	                initialValue: detail.workLeave
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u85AA\u8D44\u7EA7\u522B' }),
	              getFieldDecorator('incomeLeave', {
	                initialValue: detail.incomeLeave
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u51FA\u751F\u65E5\u671F' }),
	              getFieldDecorator('birthday', {
	                initialValue: detail.birthday ? (0, _moment2.default)(detail.birthday) : detail.birthday
	              })(_react2.default.createElement(_antd.DatePicker, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u6027\u522B' }),
	              getFieldDecorator('sex', {
	                initialValue: detail.sex
	              })(_react2.default.createElement(
	                RadioGroup,
	                ItemLayout,
	                _react2.default.createElement(
	                  _antd.Radio,
	                  { value: 0 },
	                  '\u5973'
	                ),
	                _react2.default.createElement(
	                  _antd.Radio,
	                  { value: 1 },
	                  '\u7537'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u6C11\u65CF' }),
	              getFieldDecorator('nation', {
	                initialValue: detail.nation
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u8EAB\u4EFD\u8BC1' }),
	              getFieldDecorator('idCard', {
	                initialValue: detail.idCard
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u5C97\u4F4D' }),
	              getFieldDecorator('post', {
	                initialValue: detail.post
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u5B66\u5386' }),
	              getFieldDecorator('edu', {
	                initialValue: detail.edu
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u8FDB\u5355\u4F4D\u65E5\u671F' }),
	              getFieldDecorator('inDate', {
	                initialValue: detail.inDate ? (0, _moment2.default)(detail.inDate) : detail.inDate
	              })(_react2.default.createElement(_antd.DatePicker, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u52B3\u52A8\u5408\u540C\u8D77' }),
	              getFieldDecorator('sDate', {
	                initialValue: detail.sDate ? (0, _moment2.default)(detail.sDate) : detail.sDate
	              })(_react2.default.createElement(_antd.DatePicker, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u52B3\u52A8\u5408\u540C\u6B62' }),
	              getFieldDecorator('eDate', {
	                initialValue: detail.eDate ? (0, _moment2.default)(detail.eDate) : detail.eDate
	              })(_react2.default.createElement(_antd.DatePicker, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u5C45\u4F4F\u5730' }),
	              getFieldDecorator('address', {
	                initialValue: detail.address
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u90AE\u7BB1' }),
	              getFieldDecorator('mail', {
	                initialValue: detail.mail
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: 'QQ' }),
	              getFieldDecorator('qq', {
	                initialValue: detail.qq
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout, { label: '\u5FAE\u4FE1\u53F7\u7801' }),
	              getFieldDecorator('wxCode', {
	                initialValue: detail.wxCode
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, ItemLayout2, { label: '\u5176\u4ED6\u4FE1\u606F' }),
	              getFieldDecorator('remark', {
	                initialValue: detail.remark
	              })(_react2.default.createElement(_antd.Input.TextArea, { rows: 4, maxLength: 1000 })),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '12px', color: '#999' } },
	                '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 12 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u9644\u4EF6' }, ItemLayout),
	              getFieldDecorator('files', {
	                initialValue: detail.files || []
	              })(_react2.default.createElement(_UploadFile2.default, {
	                type: 'ghost',
	                fileList: detail.file,
	                isPreview: true,
	                onRemove: this.fileRemove
	              }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormStaff;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    company: state.company_list,
	    workOrg: state.work_org_list,
	    orgTree: state.enable_org_tree,
	    departTree: state.department_list
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(FormStaff));

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _staff_list = __webpack_require__(440);
	
	var _enable_org_tree = __webpack_require__(731);
	
	var _hr = __webpack_require__(167);
	
	var _ComponentOrg = __webpack_require__(719);
	
	var _ComponentOrg2 = _interopRequireDefault(_ComponentOrg);
	
	var _ComponentStaff = __webpack_require__(720);
	
	var _ComponentStaff2 = _interopRequireDefault(_ComponentStaff);
	
	__webpack_require__(2963);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getHr = function () {
	      var dispatch = _this.props.dispatch;
	
	      dispatch((0, _staff_list.getStaffList)({
	        current: _this.current,
	        condition: _this.condition,
	        orgUuid: _this.orgUuid,
	        status: _this.status
	      }));
	    };
	
	    _this.exportHr = function () {
	      (0, _hr.queryExportHr)({ orgUuid: _this.orgUuid || '' });
	    };
	
	    _this.handleSearch = function (value) {
	      _this.condition = value;
	      _this.current = 1;
	      _this.getHr();
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.current = pagination.current;
	      _this.getHr();
	    };
	
	    _this.handleOrgChange = function (value) {
	      _this.orgUuid = value[0];
	      _this.setState({ orgUuid: value[0] });
	      _this.getHr();
	    };
	
	    _this.ChangeStatus = function (value) {
	      value === '2' ? _this.status = '' : _this.status = value;
	      _this.current = 1;
	      _this.getHr();
	    };
	
	    _this.state = {
	      orgUuid: undefined
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.current = 1;
	      this.condition = '';
	      this.orgUuid = '';
	      this.status = 1;
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.props.dispatch((0, _enable_org_tree.getEnableOrganization)());
	      this.getHr();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex' }, className: 'pageStaff' },
	        _react2.default.createElement(
	          'div',
	          { style: { width: '300px', marginRight: '16px' } },
	          _react2.default.createElement(_ComponentOrg2.default, { handleChange: this.handleOrgChange })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { flex: 1 } },
	          _react2.default.createElement(_ComponentStaff2.default, {
	            type: 'hr',
	            getHr: this.getHr,
	            exportHr: this.exportHr,
	            orgUuid: this.state.orgUuid,
	            handleSearch: this.handleSearch,
	            ChangeStatus: this.ChangeStatus,
	            handleTableChange: this.handleTableChange
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { data: state.staff_list };
	})(Index);

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _hr = __webpack_require__(167);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var ModalImport = function (_Component) {
	  _inherits(ModalImport, _Component);
	
	  function ModalImport(props) {
	    _classCallCheck(this, ModalImport);
	
	    var _this = _possibleConstructorReturn(this, (ModalImport.__proto__ || Object.getPrototypeOf(ModalImport)).call(this, props));
	
	    _this.handleOk = function () {
	      var _this$props = _this.props,
	          handleSubmit = _this$props.handleSubmit,
	          validateFields = _this$props.form.validateFields;
	
	      validateFields(function (err, values) {
	        if (!err) {
	          var params = {
	            fileUuid: values.files[0].uuid
	          };
	          handleSubmit(params);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ModalImport, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u4EBA\u5458\u5BFC\u5165',
	          onOk: this.handleOk,
	          onCancel: this.props.handleCancel,
	          visible: this.props.visible
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u8BF7\u4E0A\u4F20Excel\u6587\u4EF6' },
	            getFieldDecorator('files', {
	              rules: [{ required: true, message: '请上传Excel文件' }]
	            })(_react2.default.createElement(_UploadFile2.default, { limit: 1, type: 'ghost', isPreview: true })),
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return (0, _hr.queryDownloadHrTemplate)();
	                } },
	              ' \u70B9\u51FB\u4E0B\u8F7D\u6A21\u677F'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalImport;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(ModalImport);

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _attachment = __webpack_require__(27);
	
	var _ModalTable = __webpack_require__(1717);
	
	var _ModalTable2 = _interopRequireDefault(_ModalTable);
	
	var _ModalDetailTable = __webpack_require__(1716);
	
	var _ModalDetailTable2 = _interopRequireDefault(_ModalDetailTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handleDetailVisible = function (flag) {
	      _this.setState({
	        detailVisible: !!flag
	      });
	    };
	
	    _this.state = {
	      visible: false,
	      detailVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          visible = _state.visible,
	          detailVisible = _state.detailVisible;
	
	      var dataItem = this.props.data;
	      var files = dataItem.files || [];
	      return _react2.default.createElement(
	        'div',
	        { className: 'form-open' },
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u5DE5\u8D44\u8BE6\u60C5' },
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u5DE5\u8D44\u91D1\u989D' },
	              dataItem.price,
	              '\u5143'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5DE5\u8D44\u516C\u53F8' },
	              dataItem.company
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5DE5\u8D44\u51ED\u8BC1' },
	              files.length > 0 ? _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return (0, _attachment.queryFilePreview)(files[0]);
	                  } },
	                ' ',
	                files[0].name
	              ) : ''
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9884\u7B97\u6765\u6E90' },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.handleVisible(true);
	                  } },
	                '\u53D1\u653E\u8BE6\u60C5'
	              )
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5DE5\u8D44\u660E\u7EC6' },
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this2.handleDetailVisible(true);
	                  } },
	                '\u8BE6\u60C5'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 2 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u5DE5\u8D44\u8BF4\u660E' },
	              dataItem.reason
	            )
	          )
	        ),
	        visible ? _react2.default.createElement(_ModalTable2.default, {
	          onCancel: this.handleVisible,
	          details: dataItem.apportion.details,
	          visible: visible
	        }) : null,
	        detailVisible ? _react2.default.createElement(_ModalDetailTable2.default, Object.assign({
	          onCancel: this.handleDetailVisible,
	          visible: detailVisible
	        }, this.props)) : null
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = Open;

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _DataWrapper = __webpack_require__(674);
	
	var _DataWrapper2 = _interopRequireDefault(_DataWrapper);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalDetailTable = function (_Component) {
	  _inherits(ModalDetailTable, _Component);
	
	  function ModalDetailTable(props) {
	    _classCallCheck(this, ModalDetailTable);
	
	    var _this = _possibleConstructorReturn(this, (ModalDetailTable.__proto__ || Object.getPrototypeOf(ModalDetailTable)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: "姓名",
	        dataIndex: "name"
	      }, {
	        title: "人力成本",
	        dataIndex: "hrCost",
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, ".", ",")
	          );
	        }
	      }, {
	        title: "银行发放工资",
	        dataIndex: "bankPayment",
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, ".", ",")
	          );
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ModalDetailTable, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {}
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          dataList = _props.dataList,
	          pagination = _props.pagination,
	          visible = _props.visible;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          width: 900,
	          title: "\u5DE5\u8D44\u660E\u7EC6\u8BE6\u60C5",
	          visible: visible,
	          footer: false,
	          onCancel: function onCancel() {
	            return _this2.props.onCancel(false);
	          }
	        },
	        _react2.default.createElement(_antd.Table, {
	          rowKey: "uuid",
	          columns: this.columns(),
	          dataSource: dataList,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return ModalDetailTable;
	}(_react.Component);
	
	exports.default = (0, _DataWrapper2.default)(ModalDetailTable);

/***/ },
/* 1717 */
1699,
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _wage = __webpack_require__(114);
	
	var _FormBase = __webpack_require__(721);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveWage(item);
	    };
	
	    _this.wageWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _wage.queryWageWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveWage = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _wage.querySaveWage)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataInfo = this.state.dataInfo;
	
	      this.setState({ dataInfo: dataInfo });
	      this.wageWorkflow();
	    }
	
	    /**
	     * 提交报销
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, {
	          data: this.state.dataInfo,
	          handSubmit: this.handSubmit,
	          isSubmitting: isSubmitting
	        }),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance })
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _reactRedux = __webpack_require__(5);
	
	var _work_org_list = __webpack_require__(234);
	
	var _BackBtn = __webpack_require__(12);
	
	var _wage = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.getWageDetailInfo = function () {
	      (0, _wage.queryWageDetailInfo)({ uuid: _this.props.params.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          var workOrg = _this.props.workOrg;
	
	          var dataSource = [res.data];
	          workOrg.map(function (item) {
	            if (item.uuid === res.data.workorgname) {
	              dataSource[0].workorgname = item.name;
	            }
	            return item;
	          });
	          _this.setState({
	            dataSource: dataSource
	          });
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '公司',
	        dataIndex: 'compname',
	        width: 50
	      }, {
	        title: '部门',
	        dataIndex: 'workorgname',
	        width: 50
	      }, {
	        title: '月份',
	        dataIndex: 'month',
	        width: 80,
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            record.year + "-" + record.month
	          );
	        }
	      }, {
	        title: '姓名',
	        dataIndex: 'person',
	        width: 50
	      }, {
	        title: '应发项目',
	        children: [{
	          title: '基本工资',
	          dataIndex: 'base',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '岗位津贴',
	          dataIndex: 'performance',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '公积金避个税',
	          dataIndex: 'providentFundAvoid',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '实际工资',
	          dataIndex: 'actual',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '小计',
	          dataIndex: 'subtotal',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '全勤奖',
	          dataIndex: 'fullAttendance',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '绩效提成',
	          dataIndex: 'commission',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '补贴',
	          dataIndex: 'commissio',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '福利品',
	          dataIndex: 'welfare',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '合计',
	          dataIndex: 'wageSum',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }]
	      }, {
	        title: '应扣项目',
	        children: [{
	          title: '缺勤',
	          dataIndex: 'absence',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '迟到扣款',
	          dataIndex: 'late',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '其他',
	          dataIndex: 'other',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '应发合计',
	          dataIndex: 'paid',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '社保',
	          children: [{
	            title: '个人部分',
	            children: [{
	              title: '养老保险',
	              dataIndex: 'pensionInsurance',
	              width: 50,
	              render: function render(text) {
	                return _react2.default.createElement(
	                  "span",
	                  null,
	                  _index2.default.numberFormat(text, 2, '.', ',')
	                );
	              }
	            }, {
	              title: '医疗保险',
	              dataIndex: 'medicalInsurance',
	              width: 50,
	              render: function render(text) {
	                return _react2.default.createElement(
	                  "span",
	                  null,
	                  _index2.default.numberFormat(text, 2, '.', ',')
	                );
	              }
	            }, {
	              title: '失业保险',
	              dataIndex: 'unemploymentInsurance',
	              width: 50,
	              render: function render(text) {
	                return _react2.default.createElement(
	                  "span",
	                  null,
	                  _index2.default.numberFormat(text, 2, '.', ',')
	                );
	              }
	            }, {
	              title: '合计',
	              dataIndex: 'insuranceSum',
	              width: 50,
	              render: function render(text) {
	                return _react2.default.createElement(
	                  "span",
	                  null,
	                  _index2.default.numberFormat(text, 2, '.', ',')
	                );
	              }
	            }]
	          }, {
	            title: '公司部分',
	            dataIndex: 'insuranceCompSum',
	            width: 50
	          }]
	        }, {
	          title: '公积金',
	          children: [{
	            title: '个人部分',
	            dataIndex: 'providentFund',
	            width: 50,
	            render: function render(text) {
	              return _react2.default.createElement(
	                "span",
	                null,
	                _index2.default.numberFormat(text, 2, '.', ',')
	              );
	            }
	          }, {
	            title: '公司部分',
	            dataIndex: 'providentFundComp',
	            width: 50,
	            render: function render(text) {
	              return _react2.default.createElement(
	                "span",
	                null,
	                _index2.default.numberFormat(text, 2, '.', ',')
	              );
	            }
	          }]
	        }, {
	          title: '合计',
	          dataIndex: 'buckle',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }]
	      }, {
	        title: '税前合计',
	        dataIndex: 'incomeBeforeTax',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '专项附加扣除',
	        children: [{
	          title: '子女教育',
	          dataIndex: 'childEductaion',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '继续教育',
	          dataIndex: 'continuingEducation',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '住房贷款利息',
	          dataIndex: 'homeLoanInterest',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '住房租金',
	          dataIndex: 'housingRent',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '赡养父母',
	          dataIndex: 'dependentParents',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '婴孩照护',
	          dataIndex: 'babyCare',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }, {
	          title: '合计',
	          dataIndex: 'deductionTotal',
	          width: 50,
	          render: function render(text) {
	            return _react2.default.createElement(
	              "span",
	              null,
	              _index2.default.numberFormat(text, 2, '.', ',')
	            );
	          }
	        }]
	      }, {
	        title: '通信费补贴',
	        dataIndex: 'communicationCommissio',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '累计预扣预缴应纳税所得额',
	        dataIndex: 'taxable',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '本期应预扣预缴税额',
	        dataIndex: 'tax',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '税后合计',
	        dataIndex: 'incomeAfterTax',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '人力成本',
	        dataIndex: 'hrCost',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '现金发放',
	        dataIndex: 'cashPayment',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '福利品发放',
	        dataIndex: 'welfarePayment',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '银行发放',
	        dataIndex: 'bankPayment',
	        width: 50,
	        render: function render(text) {
	          return _react2.default.createElement(
	            "span",
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataSource: []
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: "componentDidMount",
	    value: function () {
	      var _ref = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.next = 2;
	                return this.props.dispatch((0, _work_org_list.getWorkOrgList)());
	
	              case 2:
	                this.getWageDetailInfo();
	
	              case 3:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, this);
	      }));
	
	      function componentDidMount() {
	        return _ref.apply(this, arguments);
	      }
	
	      return componentDidMount;
	    }()
	  }, {
	    key: "render",
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_antd.Table, {
	            size: "small",
	            bordered: true,
	            columns: this.columns(),
	            dataSource: dataSource,
	            pagination: false,
	            rowKey: "uuid",
	            onChange: this.handleTableChange,
	            scroll: { x: 2500 }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    workOrg: state.work_org_list
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _reactRouter = __webpack_require__(8);
	
	var _shortfalls = __webpack_require__(83);
	
	var _shortfalls2 = _interopRequireDefault(_shortfalls);
	
	var _wage = __webpack_require__(114);
	
	var _FormBase = __webpack_require__(721);
	
	var _FormBase2 = _interopRequireDefault(_FormBase);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item) {
	      _this.saveWage(item);
	    };
	
	    _this.wageWorkflow = function (params) {
	      var instance = _this.state.instance;
	
	      (0, _wage.queryWageWorkflow)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            instance: Object.assign({}, instance, {
	              activities: res.data
	            })
	          });
	        }
	      });
	    };
	
	    _this.saveWage = function (item) {
	      _this.setState({
	        isSubmitting: true
	      });
	      (0, _wage.querySaveWage)(item).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else if (res.message.indexOf('\n') === -1) {
	          _antd.message.error(res.message);
	        } else {
	          _this.setState({
	            shortData: res.message,
	            visible: true
	          });
	        }
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        visible: false
	      });
	    };
	
	    _this.deleteWage = function () {
	      (0, _wage.queryDeleteWage)({
	        uuid: _this.props.data.uuid
	      }).then(function (res) {
	        _this.setState({
	          isSubmitting: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isSubmitting: false,
	      instance: {
	        activities: [],
	        currentActivity: {}
	      },
	      shortData: '',
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dataInfo = this.state.dataInfo;
	
	      this.setState({ dataInfo: dataInfo });
	      this.wageWorkflow();
	    }
	
	    /**
	     * 提交报销
	     */
	
	
	    /**
	     * 保存
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          isSubmitting = _state.isSubmitting,
	          instance = _state.instance,
	          shortData = _state.shortData,
	          visible = _state.visible;
	
	      var dataInfo = this.props.data;
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FormBase2.default, {
	          data: this.props.data,
	          handSubmit: this.handSubmit,
	          isSubmitting: isSubmitting,
	          handleDelete: this.deleteWage
	        }),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(_Process2.default, { instance: instance }),
	          _react2.default.createElement(
	            'div',
	            { style: { marginTop: '16px' } },
	            _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	          )
	        ),
	        _react2.default.createElement(_shortfalls2.default, { data: shortData || '', visible: visible, hideModal: this.hideModal })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _wage = __webpack_require__(114);
	
	var _PageEdit = __webpack_require__(1720);
	
	var _PageEdit2 = _interopRequireDefault(_PageEdit);
	
	var _PageOpen = __webpack_require__(1724);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getWageInfo = function () {
	      (0, _wage.queryWageInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {
	        apportion: {
	          details: []
	        }
	      }
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getWageInfo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageEdit2.default, { data: dataInfo });
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, { data: dataInfo });
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = PageInfo;

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	__webpack_require__(599);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _wage = __webpack_require__(114);
	
	var _FormSearch = __webpack_require__(716);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableExpenses = __webpack_require__(722);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getWageMyList = function (params) {
	      _this.setState({ loading: true });
	      (0, _wage.queryWageMyList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getWageMyList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        loading: false,
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        backInfo.start && backInfo.limit && (this.current = backInfo.start);
	        backInfo.start && backInfo.limit && (this.pagination = {
	          limit: backInfo.limit,
	          start: backInfo.start
	        });
	
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.location.pathname
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        type: 'mine',
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/hr/w_manage/add' },
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary' },
	                '\u7533\u8BF7\u5DE5\u8D44'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(Manage);

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _index = __webpack_require__(22);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _BackBtn = __webpack_require__(12);
	
	var _wage = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var MonthPicker = _antd.DatePicker.MonthPicker;
	var Description = _DescriptionList2.default.Description;
	
	var PageMonthCompany = function (_Component) {
	  _inherits(PageMonthCompany, _Component);
	
	  function PageMonthCompany(props) {
	    _classCallCheck(this, PageMonthCompany);
	
	    var _this = _possibleConstructorReturn(this, (PageMonthCompany.__proto__ || Object.getPrototypeOf(PageMonthCompany)).call(this, props));
	
	    _this.getParams = function () {
	      var uuid = _this.props.params.uuid;
	
	      var _this$props$form$getF = _this.props.form.getFieldsValue(),
	          date = _this$props$form$getF.date;
	
	      return {
	        year: (0, _moment2.default)(date).format('YYYY'),
	        month: (0, _moment2.default)(date).format('MM'),
	        companyUuid: uuid
	      };
	    };
	
	    _this.wageStaticComMonth = function () {
	      (0, _wage.queryWageStaticComMonth)(_this.getParams()).then(function (res) {
	        _this.setState({
	          staticData: res.data
	        });
	      });
	    };
	
	    _this.wageDetailList = function (pageNo) {
	      var params = {};
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      (0, _wage.queryWageDetailList)(Object.assign({}, _this.getParams(), params)).then(function (res) {
	        _this.setState({
	          data: res.data,
	          total: res.totalSize
	        });
	      });
	    };
	
	    _this.loadData = function () {
	      _this.wageStaticComMonth();
	      _this.wageDetailList();
	    };
	
	    _this.handleSearch = function (e) {
	      e.preventDefault();
	      _this.loadData();
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', style: { textAlign: 'right' }, onSubmit: _this.handleSearch },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('date', {
	            initialValue: (0, _moment2.default)(_moment2.default.unix(new Date().getTime() / 1000).format('YYYY-MM'), 'YYYY-MM')
	          })(_react2.default.createElement(MonthPicker, { format: 'YYYY-MM' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit', style: { marginRight: '-16px' } },
	            '\u67E5\u8BE2'
	          )
	        )
	      );
	    };
	
	    _this.wageSend = function (uuid) {
	      (0, _wage.querySendWage)({
	        uuids: [uuid]
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.wageDetailList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.wageBack = function (uuid) {
	      (0, _wage.queryBackWage)({
	        uuids: [uuid]
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.wageDetailList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.wageBackAll = function () {
	      var params = _this.getParams();
	      (0, _wage.queryBackAllWage)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.wageDetailList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.wageSendAll = function () {
	      var params = _this.getParams();
	      _this.setState({
	        sendAllLoading: true
	      });
	      (0, _wage.querySendAllWage)(params).then(function (res) {
	        _this.setState({
	          sendAllLoading: false
	        });
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.wageDetailList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '发放年度',
	        dataIndex: 'year'
	      }, {
	        title: '发放月份',
	        dataIndex: 'month'
	      }, {
	        title: '姓名',
	        dataIndex: 'name'
	      }, {
	        title: '人力成本',
	        dataIndex: 'hrCost',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '税后工资',
	        dataIndex: 'incomeAfterTax',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '现金发放工资',
	        dataIndex: 'cashPayment',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '银行发放工资',
	        dataIndex: 'bankPayment',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _index2.default.numberFormat(text, 2, '.', ',')
	          );
	        }
	      }, {
	        title: '导入日期',
	        dataIndex: 'createTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/hr/wage/detail/' + record.uuid },
	              '\u67E5\u770B'
	            ),
	            _react2.default.createElement(_antd.Divider, { type: 'verticle' }),
	            record.isSendFlag ? null : _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.wageSend(record.uuid);
	                } },
	              '\u53D1\u9001\u5DE5\u8D44\u6761'
	            ),
	            !record.isReadFlag && record.isSendFlag ? _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.wageBack(record.uuid);
	                } },
	              '\u6536\u56DE'
	            ) : null
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      total: 0,
	      pageNo: 1,
	      staticData: {},
	      sendAllLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(PageMonthCompany, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total,
	          staticData = _state.staticData;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.wageDetailList(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 6 },
	              _react2.default.createElement(_BackBtn.BackBtn, null)
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 18 },
	              this.renderSearchForm()
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Divider, null),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', style: { marginBottom: 32 }, col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u516C\u53F8\u540D\u79F0' },
	              staticData.companyName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F53\u6708\u4EBA\u529B\u6210\u672C' },
	              _index2.default.numberFormat(staticData.hrCost, 2, '.', ','),
	              '\u5143'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5458\u5DE5\u4EBA\u6570' },
	              staticData.hrCount
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F53\u6708\u7A0E\u540E\u5DE5\u8D44' },
	              _index2.default.numberFormat(staticData.incomeAfterTax, 2, '.', ','),
	              '\u5143'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F53\u6708\u73B0\u91D1\u53D1\u653E\u5DE5\u8D44' },
	              _index2.default.numberFormat(staticData.cashPayment, 2, '.', ','),
	              '\u5143'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u5F53\u6708\u94F6\u884C\u53D1\u653E\u5DE5\u8D44' },
	              _index2.default.numberFormat(staticData.bankPayment, 2, '.', ','),
	              '\u5143'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList', style: { textAlign: 'right' } },
	          _react2.default.createElement(
	            _antd.Button,
	            {
	              style: { margin: '0 8px 16px 0' },
	              type: 'primary',
	              onClick: function onClick() {
	                return _this2.wageSendAll();
	              },
	              loading: this.state.sendAllLoading
	            },
	            '\u53D1\u9001\u5168\u90E8\u5DE5\u8D44\u6761'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { onClick: function onClick() {
	                return _this2.wageBackAll();
	              } },
	            '\u5168\u90E8\u64A4\u56DE'
	          )
	        ),
	        _react2.default.createElement(_antd.Table, { rowKey: 'uuid', columns: this.columns(), dataSource: data, pagination: pagination })
	      );
	    }
	  }]);
	
	  return PageMonthCompany;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(PageMonthCompany);

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _WorkflowOp = __webpack_require__(134);
	
	var _WorkflowOp2 = _interopRequireDefault(_WorkflowOp);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _wage = __webpack_require__(114);
	
	var _FormOpen = __webpack_require__(1715);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.handSubmit = function (item, type) {
	      if (type === 'save') {
	        _this.saveWage(item);
	      }
	    };
	
	    _this.saveWage = function (item) {
	      (0, _wage.querySaveWage)(item).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success('保存成功');
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.doTask = function (pass, refuse) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackWage(item);
	          break;
	        case 'next':
	          _this.nextWage(item);
	          break;
	        case 'return':
	          _this.returnWage(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackWage = function (params) {
	      (0, _wage.queryCallbackWage)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextWage = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _wage.queryNextWage)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnWage = function (params, refuse) {
	      (0, _wage.queryReturnWage)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.wageDetailList = function (pageNo) {
	      var data = _this.props.data;
	
	      var params = {};
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.companyUuid = data.companyUuid;
	      params.year = data.year;
	      params.month = data.month;
	      params.limit = 15;
	      params.start = current;
	      (0, _wage.queryWageDetailList)(Object.assign({}, params)).then(function (res) {
	        _this.setState({
	          dataList: res.data,
	          total: res.totalSize
	        });
	      });
	    };
	
	    _this.state = {
	      dataInfo: {},
	      dataList: [],
	      total: 0,
	      pageNo: 1,
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ dataInfo: data });
	      this.wageDetailList();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 提交报销
	     */
	
	
	    /**
	     * 保存
	     */
	
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	
	    /** ---------------------------------工资审核页新增 工资列表详情---------------------------------*/
	
	  }, {
	    key: 'render',
	
	    /**--------------------------------------------------------------------------------------------*/
	
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          dataList = _state.dataList,
	          total = _state.total,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.wageDetailList(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowOp2.default, {
	          data: dataInfo,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_FormOpen2.default, {
	          data: dataInfo,
	          dataList: dataList,
	          pagination: pagination,
	          handSubmit: this.handSubmit,
	          doTask: this.doTask,
	          watchTask: this.watchTask
	        }),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'wage', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _YearPicker = __webpack_require__(154);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	var _wage = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      _this.setState({
	        pageNo: pageNo
	      });
	      (0, _wage.queryWageStatistic)(Object.assign({}, params, _this.props.form.getFieldsValue())).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        }
	      });
	    };
	
	    _this.handleSearch = function (e) {
	      e.preventDefault();
	      _this.loadData();
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', style: { textAlign: 'right' }, onSubmit: _this.handleSearch },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('year', {
	            initialValue: _moment2.default.unix(new Date().getTime() / 1000).format('YYYY')
	          })(_react2.default.createElement(_YearPicker2.default, { style: { width: '200px' } }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit', style: { marginRight: '-16px' } },
	            '\u67E5\u8BE2'
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '单位名称',
	        dataIndex: 'crorgFullName'
	      }, {
	        title: '1月',
	        dataIndex: 'jan_'
	      }, {
	        title: '2月',
	        dataIndex: 'feb_'
	      }, {
	        title: '3月',
	        dataIndex: 'mar_'
	      }, {
	        title: '4月',
	        dataIndex: 'apr_'
	      }, {
	        title: '5月',
	        dataIndex: 'may_'
	      }, {
	        title: '6月',
	        dataIndex: 'jun_'
	      }, {
	        title: '7月',
	        dataIndex: 'jul_'
	      }, {
	        title: '8月',
	        dataIndex: 'aug_'
	      }, {
	        title: '9月',
	        dataIndex: 'sep_'
	      }, {
	        title: '10月',
	        dataIndex: 'oct_'
	      }, {
	        title: '11月',
	        dataIndex: 'nov_'
	      }, {
	        title: '12月',
	        dataIndex: 'dec_'
	      }, {
	        title: '年终奖',
	        dataIndex: 'bonusNetPay'
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      total: 0,
	      pageNo: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              'div',
	              { className: 'tableListForm' },
	              this.renderSearchForm()
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'crorgUuid',
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _FlowSearch = __webpack_require__(103);
	
	var _FlowSearch2 = _interopRequireDefault(_FlowSearch);
	
	__webpack_require__(599);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _wage = __webpack_require__(114);
	
	var _TableExpenses = __webpack_require__(722);
	
	var _TableExpenses2 = _interopRequireDefault(_TableExpenses);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getWageList = function (params) {
	      _this.setState({ loading: true });
	      (0, _wage.queryWageList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	        _this.setState({ loading: false });
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getWageList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {},
	        loading: false
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.condition && (this.searchCondition.condition = backInfo.condition);
	        backInfo.createUser && (this.searchCondition.createUser = backInfo.createUser);
	        backInfo.instanceStatus && (this.searchCondition.instanceStatus = backInfo.instanceStatus);
	        backInfo.beginDate && (this.searchCondition.beginDate = backInfo.beginDate);
	        backInfo.endDate && (this.searchCondition.endDate = backInfo.endDate);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.location.pathname
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          loading = _state.loading,
	          dataSource = _state.dataSource;
	
	      var parentProps = {
	        loading: loading,
	        dataSource: dataSource,
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_FlowSearch2.default, Object.assign({ onSearch: this.handleSearch }, this.searchCondition)),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableExpenses2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(Manage);

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _wage = __webpack_require__(114);
	
	var _bonus = __webpack_require__(113);
	
	var _ModalImportWage = __webpack_require__(1729);
	
	var _ModalImportWage2 = _interopRequireDefault(_ModalImportWage);
	
	var _ModalImportBonus = __webpack_require__(1728);
	
	var _ModalImportBonus2 = _interopRequireDefault(_ModalImportBonus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadData = function (pageNo, condition) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      _this.setState({
	        pageNo: pageNo
	      });
	      (0, _wage.queryHrWageList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false,
	            currentTotal: res.data.currentTotal
	          });
	        }
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.loadData(1, values.condition);
	        }
	      });
	    };
	
	    _this.handleFormReset = function (e) {
	      e.preventDefault();
	      _this.props.form.resetFields();
	      _this.loadData(1);
	    };
	
	    _this.handleImportWage = function (params) {
	      _this.setState({ wageLoading: true });
	      (0, _wage.queryImportWage)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handleWageVisible(false);
	          _this.loadData(1);
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({ wageLoading: false });
	      });
	    };
	
	    _this.handleImportBonus = function (params) {
	      _this.setState({ bonusLoading: true });
	      (0, _bonus.queryImportBonus)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.handleBonusVisible(false);
	          _this.loadData(1);
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({ bonusLoading: false });
	      });
	    };
	
	    _this.handleWageVisible = function (flag) {
	      _this.setState({
	        wageVisible: !!flag
	      });
	    };
	
	    _this.handleBonusVisible = function (flag) {
	      _this.setState({
	        bonusVisible: !!flag
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { layout: 'inline', onSubmit: _this.handleSubmit, style: { textAlign: 'right' } },
	        _react2.default.createElement(
	          FormItem,
	          { label: '\u641C\u7D22\u6761\u4EF6' },
	          getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit' },
	            '\u67E5\u8BE2'
	          ),
	          _react2.default.createElement(
	            _antd.Button,
	            { style: { marginLeft: 8, marginRight: '-16px' }, onClick: _this.handleFormReset },
	            '\u91CD\u7F6E'
	          )
	        )
	      );
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '单位名称',
	        dataIndex: 'name'
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/hr/wage/wageCompanyMonth/' + record.uuid },
	              '\u67E5\u770B\u5DE5\u8D44'
	            ),
	            _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/hr/wage/bonusCompanyYear/' + record.uuid },
	              '\u67E5\u770B\u5E74\u7EC8\u5956'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      total: 0,
	      pageNo: 1,
	      wageVisible: false,
	      bonusVisible: false,
	      wageLoading: false,
	      bonusLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData(1);
	    }
	
	    // 工资导入
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total,
	          wageVisible = _state.wageVisible,
	          bonusVisible = _state.bonusVisible,
	          wageLoading = _state.wageLoading,
	          bonusLoading = _state.bonusLoading;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'tableList' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 13 },
	              _react2.default.createElement(
	                FormItem,
	                null,
	                _react2.default.createElement(
	                  _antd.Button,
	                  {
	                    icon: 'plus',
	                    style: { marginRight: '8px' },
	                    size: 'small',
	                    onClick: function onClick() {
	                      return _this2.handleWageVisible(true);
	                    }
	                  },
	                  '\u5BFC\u5165\u5DE5\u8D44'
	                ),
	                _react2.default.createElement(
	                  _antd.Button,
	                  {
	                    icon: 'plus',
	                    style: { marginRight: '8px' },
	                    size: 'small',
	                    onClick: function onClick() {
	                      return (0, _wage.queryDownloadWageTemplate)();
	                    }
	                  },
	                  '\u5DE5\u8D44\u6A21\u677F\u4E0B\u8F7D'
	                ),
	                _react2.default.createElement(
	                  _antd.Button,
	                  {
	                    icon: 'plus',
	                    style: { marginRight: '8px' },
	                    size: 'small',
	                    onClick: function onClick() {
	                      return _this2.handleBonusVisible(true);
	                    }
	                  },
	                  '\u5BFC\u5165\u5E74\u7EC8\u5956'
	                ),
	                _react2.default.createElement(
	                  _antd.Button,
	                  {
	                    icon: 'plus',
	                    style: { marginRight: '8px' },
	                    size: 'small',
	                    onClick: function onClick() {
	                      return (0, _bonus.queryDownloadBonusTemplate)();
	                    }
	                  },
	                  '\u5E74\u7EC8\u5956\u6A21\u677F\u4E0B\u8F7D'
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 11 },
	              _react2.default.createElement(
	                'div',
	                { className: 'tableListForm' },
	                this.renderSearchForm()
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination
	        }),
	        wageVisible ? _react2.default.createElement(_ModalImportWage2.default, {
	          wageLoading: wageLoading,
	          handleSubmit: this.handleImportWage,
	          handleCancel: function handleCancel() {
	            return _this2.handleWageVisible(false);
	          }
	        }) : null,
	        bonusVisible ? _react2.default.createElement(_ModalImportBonus2.default, {
	          bonusLoading: bonusLoading,
	          handleSubmit: this.handleImportBonus,
	          handleCancel: function handleCancel() {
	            return _this2.handleBonusVisible(false);
	          }
	        }) : null
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(Index);

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	var _YearPicker = __webpack_require__(154);
	
	var _YearPicker2 = _interopRequireDefault(_YearPicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var FormImportWage = function (_Component) {
	  _inherits(FormImportWage, _Component);
	
	  function FormImportWage(props) {
	    _classCallCheck(this, FormImportWage);
	
	    var _this = _possibleConstructorReturn(this, (FormImportWage.__proto__ || Object.getPrototypeOf(FormImportWage)).call(this, props));
	
	    _this.handleOk = function () {
	      var _this$props = _this.props,
	          handleSubmit = _this$props.handleSubmit,
	          validateFields = _this$props.form.validateFields;
	
	      validateFields(function (err, values) {
	        if (!err) {
	          var params = {
	            year: values.year,
	            fileUuid: values.files[0].uuid
	          };
	          handleSubmit(params);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(FormImportWage, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var bonusLoading = this.props.bonusLoading;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u5E74\u7EC8\u5956\u5BFC\u5165',
	          onOk: this.handleOk,
	          onCancel: this.props.handleCancel,
	          confirmLoading: bonusLoading,
	          visible: true
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u53D1\u653E\u5E74\u5EA6' },
	            getFieldDecorator('year', {
	              rules: [{ required: true, message: '请选择发放年月' }]
	            })(_react2.default.createElement(_YearPicker2.default, null))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u5E74\u7EC8\u5956\u9644\u4EF6' },
	            getFieldDecorator('files', {
	              rules: [{ required: true, message: '请上传年终奖附件' }]
	            })(_react2.default.createElement(_UploadFile2.default, { limit: 1, type: 'ghost', isPreview: true }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormImportWage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(FormImportWage);

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var MonthPicker = _antd.DatePicker.MonthPicker;
	
	var FormItem = _antd.Form.Item;
	
	var FormImportWage = function (_Component) {
	  _inherits(FormImportWage, _Component);
	
	  function FormImportWage(props) {
	    _classCallCheck(this, FormImportWage);
	
	    var _this = _possibleConstructorReturn(this, (FormImportWage.__proto__ || Object.getPrototypeOf(FormImportWage)).call(this, props));
	
	    _this.handleOk = function () {
	      var _this$props = _this.props,
	          handleSubmit = _this$props.handleSubmit,
	          validateFields = _this$props.form.validateFields;
	
	      validateFields(function (err, values) {
	        if (!err) {
	          var params = {
	            year: (0, _moment2.default)(values.date).format('YYYY'),
	            month: (0, _moment2.default)(values.date).format('MM'),
	            fileUuid: values.files[0].uuid
	          };
	          handleSubmit(params);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(FormImportWage, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var wageLoading = this.props.wageLoading;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u5DE5\u8D44\u5BFC\u5165',
	          onOk: this.handleOk,
	          onCancel: this.props.handleCancel,
	          confirmLoading: wageLoading,
	          visible: true
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u53D1\u653E\u5E74\u6708' },
	            getFieldDecorator('date', {
	              rules: [{ required: true, message: '请选择发放年月' }]
	            })(_react2.default.createElement(MonthPicker, { style: { width: '100%' } }))
	          ),
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u5DE5\u8D44\u9644\u4EF6' },
	            getFieldDecorator('files', {
	              rules: [{ required: true, message: '请上传工资附件' }]
	            })(_react2.default.createElement(_UploadFile2.default, { limit: 1, type: 'ghost', isPreview: true }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormImportWage;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(FormImportWage);

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _workOrg = __webpack_require__(191);
	
	var _ModalUsers = __webpack_require__(1732);
	
	var _ModalUsers2 = _interopRequireDefault(_ModalUsers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var FormWorkOrg = function (_Component) {
	  _inherits(FormWorkOrg, _Component);
	
	  function FormWorkOrg(props) {
	    _classCallCheck(this, FormWorkOrg);
	
	    var _this = _possibleConstructorReturn(this, (FormWorkOrg.__proto__ || Object.getPrototypeOf(FormWorkOrg)).call(this, props));
	
	    _this.handleSaveRelateHr = function (params) {
	      params.uuid = _this.state.detail.uuid;
	      (0, _workOrg.querySaveWorkOrgHr)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.loadData(_this.props.detail.uuid, _this.state.pageNo);
	          _this.handleVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadData = function (uuid, pageNo) {
	      _this.setState({ detail: _this.props.detail });
	      var params = {};
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 10;
	      params.start = current;
	      params.uuid = uuid;
	      (0, _workOrg.queryHrListByWorkOrg)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ data: res.data, total: res.totalSize, pageNo: pageNo });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({ visible: !!flag });
	    };
	
	    _this.submit = function (e) {
	      if (e) {
	        e.preventDefault();
	      }
	      var onSubmit = _this.props.onSubmit;
	      var detail = _this.state.detail;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = values;
	          if (detail.uuid) {
	            params.uuid = detail.uuid;
	          }
	          onSubmit(params);
	        }
	      });
	    };
	
	    _this.delete = function (uuid) {
	      (0, _workOrg.queryDeleteWorkOrgHr)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          var ceil = Math.ceil((_this.state.total - 1) / 10);
	          if (ceil < _this.state.pageNo) {
	            _this.loadData(_this.props.detail.uuid, ceil);
	          } else {
	            _this.loadData(_this.props.detail.uuid, _this.state.pageNo);
	          }
	          _this.handleVisible(false);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '姓名',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.delete(record.uuid);
	                } },
	              '\u5220\u9664'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      detail: {},
	      data: [],
	      pageNo: 1,
	      visible: false
	    };
	    return _this;
	  }
	
	  _createClass(FormWorkOrg, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.detail.uuid) {
	        this.loadData(this.props.detail.uuid, this.state.pageNo);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _state = this.state,
	          detail = _state.detail,
	          total = _state.total,
	          data = _state.data,
	          visible = _state.visible;
	
	      var ItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 10,
	        total: total,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(detail.uuid, current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          { onSubmit: this.submit },
	          _react2.default.createElement(
	            'div',
	            { style: { marginBottom: 15 } },
	            _react2.default.createElement(
	              _antd.Button,
	              { icon: 'save', style: { marginRight: 10 }, htmlType: 'submit' },
	              '\u4FDD\u5B58'
	            ),
	            detail.uuid ? _react2.default.createElement(
	              _antd.Button,
	              {
	                icon: 'save',
	                style: { marginRight: 10 },
	                onClick: function onClick() {
	                  return _this2.handleVisible(true);
	                }
	              },
	              '\u5173\u8054\u4EBA\u5458'
	            ) : null
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({ label: '\u4E1A\u52A1\u90E8\u95E8\u540D\u79F0' }, ItemLayout),
	                getFieldDecorator('name', {
	                  rules: [{ require: true, message: '请输入业务部门名称!' }],
	                  initialValue: detail.name
	                })(_react2.default.createElement(_antd.Input, { placeholder: '\u4E1A\u52A1\u90E8\u95E8\u540D\u79F0' }))
	              )
	            )
	          ),
	          detail.uuid ? _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(_antd.Table, {
	              style: { background: '#fff' },
	              columns: this.columns(),
	              dataSource: data,
	              pagination: pagination,
	              rowKey: 'uuid'
	            })
	          ) : null
	        ),
	        visible ? _react2.default.createElement(_ModalUsers2.default, {
	          handleSubmit: this.handleSaveRelateHr,
	          handleCancel: function handleCancel() {
	            return _this2.handleVisible(false);
	          }
	        }) : null
	      );
	    }
	  }]);
	
	  return FormWorkOrg;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(FormWorkOrg);

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _workOrg = __webpack_require__(191);
	
	var _FormWorkorg = __webpack_require__(1730);
	
	var _FormWorkorg2 = _interopRequireDefault(_FormWorkorg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.handleSave = function (params) {
	      _this.saveWorkorg(params);
	    };
	
	    _this.saveWorkorg = function (params) {
	      (0, _workOrg.queryAddWorkOrg)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.handleVisible(false);
	          _antd.message.success(res.message);
	          _this.loadData(_this.state.condition, _this.state.pageNo);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deleteWorkorg = function (uuid) {
	      var _this$state = _this.state,
	          condition = _this$state.condition,
	          pageNo = _this$state.pageNo;
	
	      (0, _workOrg.queryDeleteWorkOrg)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.loadData(condition, pageNo);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadData = function (condition, pageNo) {
	      var params = {};
	      var no = _this.state.pageNo;
	
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = condition || '';
	      (0, _workOrg.queryWorkOrgList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({ data: res.data, total: res.totalSize, pageNo: pageNo, condition: condition });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleVisible = function (flag) {
	      _this.setState({
	        visible: !!flag
	      });
	    };
	
	    _this.handleAdd = function (detail) {
	      _this.setState({
	        detail: detail
	      });
	      _this.handleVisible(true);
	    };
	
	    _this.handleEdit = function (record) {
	      _this.setState({
	        detail: record
	      });
	      _this.handleVisible(true);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '业务部门名称',
	        dataIndex: 'name',
	        key: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'a',
	            { onClick: function onClick() {
	                return _this.handleEdit(record);
	              } },
	            text
	          );
	        }
	      }, {
	        title: '人员数量',
	        dataIndex: 'count',
	        key: 'count'
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.handleEdit(record);
	                } },
	              '\u4FEE\u6539'
	            ),
	            _react2.default.createElement('span', { className: 'ant-divider' }),
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.deleteWorkorg(record.uuid);
	                } },
	              '\u5220\u9664'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.setClassName = function (record, index) {
	      if (record.status === 0) {
	        return 'td-gray';
	      }
	    };
	
	    _this.state = {
	      visible: false,
	      data: [],
	      pageNo: 1,
	      condition: ''
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadData('', 1);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          total = _state.total,
	          condition = _state.condition,
	          visible = _state.visible,
	          detail = _state.detail,
	          data = _state.data,
	          pageNo = _state.pageNo;
	
	      var pagination = {
	        showSizeChanger: false,
	        pageSize: 15,
	        total: total,
	        current: pageNo,
	        onChange: function onChange(current) {
	          _this2.loadData(condition, current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Button,
	          {
	            type: 'primary',
	            icon: 'plus',
	            style: { marginBottom: 15 },
	            onClick: function onClick() {
	              _this2.handleAdd({});
	            }
	          },
	          '\u6DFB\u52A0'
	        ),
	        _react2.default.createElement(_antd.Table, {
	          style: { background: '#fff' },
	          rowSelection: {},
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination,
	          rowKey: 'uuid',
	          rowClassName: this.setClassName
	        }),
	        visible ? _react2.default.createElement(
	          _antd.Drawer,
	          {
	            title: detail.uuid ? '业务部门编辑' : '业务部门新增',
	            placement: 'right',
	            closable: true,
	            visible: visible,
	            onClose: function onClose() {
	              _this2.handleVisible(false);
	              _this2.loadData(condition, pageNo);
	            },
	            width: 680
	          },
	          _react2.default.createElement(_FormWorkorg2.default, { onSubmit: this.handleSave, detail: detail })
	        ) : null
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _SearchHr = __webpack_require__(1504);
	
	var _SearchHr2 = _interopRequireDefault(_SearchHr);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var FormModalUsers = function (_Component) {
	  _inherits(FormModalUsers, _Component);
	
	  function FormModalUsers(props) {
	    _classCallCheck(this, FormModalUsers);
	
	    var _this = _possibleConstructorReturn(this, (FormModalUsers.__proto__ || Object.getPrototypeOf(FormModalUsers)).call(this, props));
	
	    _this.handleOk = function () {
	      var _this$props = _this.props,
	          handleSubmit = _this$props.handleSubmit,
	          validateFields = _this$props.form.validateFields;
	
	      validateFields(function (err, values) {
	        if (!err) {
	          var params = {
	            uuids: values.uuids
	          };
	          console.table(values.uuids);
	          handleSubmit(params);
	        }
	      });
	    };
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      data.orgUuid = _this.state.orgUuid;
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.props.handSubmit(data);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(FormModalUsers, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u4E1A\u52A1\u90E8\u95E8\u5173\u8054\u4EBA\u5458',
	          onOk: this.handleOk,
	          onCancel: this.props.handleCancel,
	          visible: true
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            { label: '\u5173\u8054\u4EBA\u5458' },
	            getFieldDecorator('uuids', {
	              rules: [{ required: true, message: '请选择要关联的人员' }]
	            })(_react2.default.createElement(_SearchHr2.default, { isMultiple: 'multiple' }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return FormModalUsers;
	}(_react.Component);
	
	exports.default = _antd.Form.create({ wrappedComponentRef: true })(FormModalUsers);

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _staff_list = __webpack_require__(440);
	
	var _hr = __webpack_require__(167);
	
	var _ComponentOrg = __webpack_require__(719);
	
	var _ComponentOrg2 = _interopRequireDefault(_ComponentOrg);
	
	var _ComponentStaff = __webpack_require__(720);
	
	var _ComponentStaff2 = _interopRequireDefault(_ComponentStaff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getHr = function () {
	      var dispatch = _this.props.dispatch;
	
	      dispatch((0, _staff_list.getStaffList)({
	        current: _this.current,
	        condition: _this.condition,
	        orgUuid: _this.orgUuid,
	        status: 1
	      }));
	    };
	
	    _this.exportHr = function () {
	      (0, _hr.queryExportHr)({ orgUuid: _this.orgUuid || '' });
	    };
	
	    _this.handleSearch = function (value) {
	      _this.condition = value;
	      _this.current = 1;
	      _this.getHr();
	    };
	
	    _this.handleTableChange = function (pagination) {
	      _this.current = pagination.current;
	      _this.getHr();
	    };
	
	    _this.handleOrgChange = function (value) {
	      _this.orgUuid = value[0];
	      _this.getHr();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.current = 1;
	      this.condition = '';
	      this.orgUuid = '';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getHr();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: { display: 'flex' }, className: 'pageStaff' },
	        _react2.default.createElement(
	          'div',
	          { style: { width: '300px', marginRight: '16px' } },
	          _react2.default.createElement(_ComponentOrg2.default, { handleChange: this.handleOrgChange })
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { flex: 1 } },
	          _react2.default.createElement(_ComponentStaff2.default, {
	            type: 'resource',
	            getHr: this.getHr,
	            handleSearch: this.handleSearch,
	            handleTableChange: this.handleTableChange,
	            exportHr: this.exportHr,
	            noEdit: true
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { data: state.staff_list };
	})(Index);

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PageAddress = __webpack_require__(1733);
	
	var _PageAddress2 = _interopRequireDefault(_PageAddress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = {
	  path: 'resource',
	  breadcrumbName: '公共资源',
	  childRoutes: [{
	    path: 'address',
	    breadcrumbName: '公司通讯录',
	    indexRoute: { component: _PageAddress2.default }
	  }]
	}; // 通讯录
	exports.default = router;

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _task = __webpack_require__(66);
	
	var _user = __webpack_require__(54);
	
	var _BackBtn = __webpack_require__(12);
	
	var _TagsInput = __webpack_require__(426);
	
	var _TagsInput2 = _interopRequireDefault(_TagsInput);
	
	var _back_info = __webpack_require__(19);
	
	var _workOrg = __webpack_require__(191);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RangePicker = _antd.DatePicker.RangePicker;
	var confirm = _antd.Modal.confirm;
	var Option = _antd.Select.Option;
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this2 = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this2.loadWorkOrgs = function () {
	      (0, _workOrg.queryWorkOrg)({ orgUuid: '' }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.setState({
	            workOrgs: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.loadAccountList = function () {
	      (0, _user.queryAccountList)().then(function (res) {
	        if (res.statusCode === 200) {
	          var newList = [];
	          res.data.map(function (item) {
	            newList.push({
	              userName: item.name,
	              userUuid: item.uuid
	            });
	            return item;
	          });
	          _this2.setState({
	            accountList: newList
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.loadData = function (uuid) {
	      var setFieldsValue = _this2.props.form.setFieldsValue;
	
	      (0, _task.queryProjInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          var _res$data = res.data,
	              administrators = _res$data.administrators,
	              reviewers = _res$data.reviewers,
	              viewables = _res$data.viewables,
	              tags = _res$data.tags;
	
	          var adminiValue = [];
	          var reviewValue = [];
	          var viewValue = [];
	          // 设置标签
	          var newTags = [];
	          tags.map(function (item, index) {
	            newTags.push({
	              uid: index,
	              name: item
	            });
	            return item;
	          });
	          // 设置人员默认值
	          administrators.map(function (item) {
	            adminiValue.push(item.userUuid);
	            return item;
	          });
	          reviewers.map(function (item) {
	            reviewValue.push(item.userUuid);
	            return item;
	          });
	          viewables.map(function (item) {
	            viewValue.push(item.userUuid);
	            return item;
	          });
	          _this2.setState({
	            data: res.data,
	            tags: newTags,
	            administrators: administrators,
	            reviewers: reviewers,
	            viewables: viewables
	          });
	          setFieldsValue({
	            administrators: adminiValue,
	            reviewers: reviewValue,
	            viewables: viewValue
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.saveProj = function (status) {
	      var _this2$state = _this2.state,
	          data = _this2$state.data,
	          tags = _this2$state.tags,
	          administrators = _this2$state.administrators,
	          reviewers = _this2$state.reviewers,
	          viewables = _this2$state.viewables;
	
	      var params = Object.assign({}, data, _this2.props.form.getFieldsValue());
	
	      _this2.props.form.validateFields(function (err, values) {
	        if (!err) {
	          if (status === 1) {
	            _this2.setState({
	              isReleaseloLoading: true
	            });
	          } else {
	            _this2.setState({
	              isSaveloLoading: true
	            });
	          }
	          // 设置标签
	          var newTags = [];
	          tags.map(function (item) {
	            newTags.push(item.name);
	            return item;
	          });
	          params.tags = newTags;
	          params.status = status;
	          params.reviewers = reviewers;
	          params.viewables = viewables;
	          params.administrators = administrators;
	          params.beginDate = values.date[0].format('YYYY-MM-DD');
	          params.endDate = values.date[1].format('YYYY-MM-DD');
	          delete params.date;
	          (0, _task.queryPostProjSave)(params).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              _this2.setBackPageInfo(status);
	              _this2.props.router.go(-1);
	            } else {
	              var reviewersValue = [];
	              var viewablesValue = [];
	              _antd.message.error(res.message);
	
	              // 把原本的审核人员和查看人员还原
	              data.reviewers.map(function (item) {
	                if (!reviewers.some(function (it) {
	                  return it.userUuid === item.userUuid;
	                })) {
	                  reviewers.push(item);
	                }
	                return item;
	              });
	
	              data.viewables.map(function (item) {
	                if (!viewables.some(function (it) {
	                  return it.userUuid === item.userUuid;
	                })) {
	                  viewables.push(item);
	                }
	                return item;
	              });
	
	              // 设置form select
	              reviewers.map(function (item) {
	                reviewersValue.push(item.userUuid);
	                return item;
	              });
	
	              viewables.map(function (item) {
	                viewablesValue.push(item.userUuid);
	                return item;
	              });
	              _this2.props.form.setFieldsValue({
	                reviewers: reviewersValue,
	                viewables: viewablesValue
	              });
	            }
	            if (status === 1) {
	              _this2.setState({
	                isReleaseloLoading: false
	              });
	            } else {
	              _this2.setState({
	                isSaveloLoading: false
	              });
	            }
	          });
	        }
	      });
	    };
	
	    _this2.showDelConfirm = function () {
	      var uuid = _this2.props.params.uuid;
	
	      var _this = _this2;
	      confirm({
	        title: '确定删除该项目吗?',
	        okText: '确定',
	        okType: 'danger',
	        cancelText: '取消',
	        onOk: function onOk() {
	          (0, _task.queryDeleteProj)({ uuid: uuid }).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              _this.props.router.go(-1);
	            } else {
	              _antd.message.error(res.message);
	            }
	          });
	        },
	        onCancel: function onCancel() {}
	      });
	    };
	
	    _this2.setBackPageInfo = function (status) {
	      var pageType = _this2.state.pageType;
	      var backInfo = _this2.props.backInfo;
	
	      if (backInfo.path === '/task/project_launch') {
	        var params = {};
	        params.path = backInfo.path;
	        params.tabKey = status === 1 ? '1' : '3';
	        params.status = status === 1 ? 'PUBLISH' : 'DRAFT';
	        params.current = pageType === 'add' ? 1 : backInfo.current;
	        params.condition = pageType === 'add' ? '' : backInfo.condition;
	        _this2.props.dispatch((0, _back_info.setBackInfo)(params));
	      }
	    };
	
	    _this2.handleSetTags = function (tags) {
	      _this2.setState({ tags: tags });
	    };
	
	    _this2.handleWorkorgChange = function (value, option) {
	      _this2.props.form.setFieldsValue({
	        workorgName: option.props.children
	      });
	    };
	
	    _this2.changeAdminis = function (value) {
	      var accountList = _this2.state.accountList;
	
	      var administrators = [];
	      value.map(function (item) {
	        accountList.map(function (it) {
	          if (it.userUuid === item) {
	            administrators.push(it);
	          }
	          return it;
	        });
	        return item;
	      });
	
	      _this2.setState({
	        administrators: administrators
	      });
	    };
	
	    _this2.changeReviewers = function (value) {
	      var _this2$state2 = _this2.state,
	          accountList = _this2$state2.accountList,
	          reviewers = _this2$state2.reviewers;
	
	      var newReviewers = [];
	      value.map(function (item) {
	        accountList.map(function (it) {
	          if (it.userUuid === item) {
	            newReviewers.push(it);
	          }
	          return it;
	        });
	        return item;
	      });
	
	      newReviewers.map(function (item) {
	        reviewers.map(function (it) {
	          if (it.userUuid === item.userUuid) {
	            item.uuid = it.uuid;
	          }
	          return it;
	        });
	        return item;
	      });
	
	      _this2.setState({
	        reviewers: newReviewers
	      });
	    };
	
	    _this2.changeViewables = function (value) {
	      var _this2$state3 = _this2.state,
	          accountList = _this2$state3.accountList,
	          viewables = _this2$state3.viewables;
	
	      var newViewables = [];
	      value.map(function (item) {
	        accountList.map(function (it) {
	          if (it.userUuid === item) {
	            newViewables.push(it);
	          }
	          return it;
	        });
	        return item;
	      });
	
	      newViewables.map(function (item) {
	        viewables.map(function (it) {
	          if (it.userUuid === item.userUuid) {
	            item.uuid = it.uuid;
	          }
	          return it;
	        });
	        return item;
	      });
	
	      _this2.setState({
	        viewables: newViewables
	      });
	    };
	
	    _this2.adminiTitle = function () {
	      var content = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: 0 } },
	          '\u62E5\u6709\u672C\u9879\u76EE\u7684\u7F16\u8F91\u6743\u9650\uFF1B'
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: 0 } },
	          '\u53EF\u9009\u591A\u4EBA\uFF1B'
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: 0 } },
	          '\u63A5\u6536\u4EBA\u53EF\u5728\u6211\u53D1\u5E03\u7684\u9879\u76EE\u4E2D\u67E5\u770B'
	        )
	      );
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u9879\u76EE\u7BA1\u7406\u5458',
	        _react2.default.createElement(
	          _antd.Tooltip,
	          { title: content },
	          _react2.default.createElement(_antd.Icon, { type: 'info-circle', style: { fontSize: '10px' } })
	        )
	      );
	    };
	
	    _this2.reviewersTitle = function () {
	      var content = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: 0 } },
	          '\u62E5\u6709\u672C\u9879\u76EE\u7684\u5BA1\u6279\u6743\u9650\uFF0C\u4EFB\u52A1\u7ED3\u679C\u63D0\u4EA4\u82E5\u9700\u5BA1\u6279\uFF0C\u5219\u9700\u901A\u8FC7\u672C\u7C7B\u76EE\u4E0B\u7684\u4EBA\u5458\u5BA1\u6838\uFF08\u6309\u586B\u5199\u987A\u5E8F\u9010\u4E00\u5BA1\u6279\uFF09;'
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: 0 } },
	          '\u53EF\u9009\u591A\u4EBA;'
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: 0 } },
	          '\u63A5\u6536\u4EBA\u65E0\u6CD5\u67E5\u770B\u5230\u9879\u76EE\uFF0C\u4EC5\u8FC7\u6D41\u7A0B\u65F6\u5BA1\u6838'
	        )
	      );
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u9879\u76EE\u5BA1\u6279\u4EBA',
	        _react2.default.createElement(
	          _antd.Tooltip,
	          { title: content },
	          _react2.default.createElement(_antd.Icon, { type: 'info-circle', style: { fontSize: '10px' } })
	        )
	      );
	    };
	
	    _this2.viewablesTitle = function () {
	      var content = _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: 0 } },
	          '\u62E5\u6709\u672C\u9879\u76EE\u6267\u884C\u548C\u534F\u52A9\u6743\u9650\uFF0C\u672C\u9879\u76EE\u4E0B\u7684\u4EFB\u52A1\u6267\u884C\u4EBA\u548C\u534F\u52A9\u4EBA\u53EA\u80FD\u4ECE\u8BE5\u7C7B\u76EE\u4E0B\u7684\u4EBA\u5458\u4E2D\u9009\u62E9;'
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: 0 } },
	          '\u53EF\u9009\u591A\u4EBA;'
	        ),
	        _react2.default.createElement(
	          'p',
	          { style: { marginBottom: 0 } },
	          '\u63A5\u6536\u4EBA\u53EF\u5728\u6211\u6536\u5230\u7684\u9879\u76EE\u4E2D\u67E5\u770B'
	        )
	      );
	      return _react2.default.createElement(
	        'span',
	        null,
	        '\u9879\u76EE\u53C2\u4E0E\u4EBA',
	        _react2.default.createElement(
	          _antd.Tooltip,
	          { title: content },
	          _react2.default.createElement(_antd.Icon, { type: 'info-circle', style: { fontSize: '10px' } })
	        )
	      );
	    };
	
	    _this2.state = {
	      tags: [],
	      data: {},
	      pageType: 'add',
	      administrators: [],
	      reviewers: [],
	      viewables: [],
	      workOrgs: [],
	      accountList: [],
	      isReleaseloLoading: false,
	      typeList: [{
	        uuid: '0',
	        name: '绩效考核'
	      }, {
	        uuid: '1',
	        name: '政府申报'
	      }, {
	        uuid: '2',
	        name: '日常任务'
	      }]
	    };
	    return _this2;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var accountInfo = this.props.accountInfo;
	      var setFieldsValue = this.props.form.setFieldsValue;
	
	      this.loadWorkOrgs();
	      this.loadAccountList();
	      if (this.props.params.uuid) {
	        this.loadData(this.props.params.uuid);
	        this.setState({
	          pageType: 'edit'
	        });
	      } else {
	        this.setState({
	          administrators: [{ userUuid: accountInfo.userUuid, userName: accountInfo.userName }]
	        });
	        setFieldsValue({
	          administrators: [accountInfo.userUuid]
	        });
	      }
	    }
	
	    // 获取业务部门列表
	
	
	    // 获取人员列表
	
	
	    // 获取项目信息
	
	
	    // 保存
	
	
	    // 删除
	
	
	    // 根据情况设置返回页面的信息
	
	
	    // 设置项目类型
	
	
	    // 设置业务部门name参数
	
	
	    /** -------------------------------------------设置人员--开始-------------------------------------------------------*/
	
	    /** -------------------------------------------设置人员--结束-------------------------------------------------------*/
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          tags = _state.tags,
	          data = _state.data,
	          isReleaseloLoading = _state.isReleaseloLoading,
	          isSaveloLoading = _state.isSaveloLoading,
	          workOrgs = _state.workOrgs,
	          typeList = _state.typeList,
	          accountList = _state.accountList;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var ItemLayout = {
	        labelCol: { span: 2 },
	        wrapperCol: { span: 16 }
	      };
	
	      getFieldDecorator('workorgName', {
	        initialValue: data.workorgName
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(_BackBtn.BackBtn, null),
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                type: 'primary',
	                onClick: function onClick() {
	                  return _this3.saveProj(1);
	                },
	                loading: isReleaseloLoading,
	                icon: 'upload'
	              },
	              '\u53D1\u5E03'
	            ),
	            !data.status || data.status === 0 ? _react2.default.createElement(
	              _antd.Button,
	              {
	                type: 'primary',
	                style: { marginLeft: '10px' },
	                onClick: function onClick() {
	                  return _this3.saveProj(0);
	                },
	                loading: isSaveloLoading,
	                icon: 'snippets'
	              },
	              '\u4FDD\u5B58\u4E3A\u8349\u7A3F'
	            ) : null,
	            data.status === 0 ? _react2.default.createElement(
	              _antd.Button,
	              { style: { marginLeft: '10px' }, onClick: this.showDelConfirm, icon: 'delete' },
	              '\u5220\u9664'
	            ) : ''
	          ),
	          _react2.default.createElement(
	            _antd.Card,
	            { style: { marginTop: '10px' } },
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                'p',
	                { style: { fontSize: '20px', fontWeight: 'bolder' } },
	                '\u57FA\u672C\u4FE1\u606F'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u9879\u76EE\u540D\u79F0' }, ItemLayout),
	              getFieldDecorator('name', {
	                rules: [{ required: true, message: '请填写项目名称' }],
	                initialValue: data.name
	              })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u586B\u5199\u9879\u76EE\u540D\u79F0' }))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u9879\u76EE\u5468\u671F' }, ItemLayout),
	              data.uuid ? getFieldDecorator('date', {
	                rules: [{ required: true, message: '请选择项目周期' }],
	                initialValue: [(0, _moment2.default)(data.beginDate), (0, _moment2.default)(data.endDate)]
	              })(_react2.default.createElement(RangePicker, { style: { width: '50%' } })) : getFieldDecorator('date', {
	                rules: [{ required: true, message: '请选择项目周期' }]
	              })(_react2.default.createElement(RangePicker, { style: { width: '50%' } }))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u9879\u76EE\u6807\u7B7E' }, ItemLayout),
	              getFieldDecorator('tags')(_react2.default.createElement(_TagsInput2.default, { tags: tags, handleSetTags: this.handleSetTags }))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u4E1A\u52A1\u90E8\u95E8' }, ItemLayout),
	              getFieldDecorator('workorgUuid', {
	                rules: [{ required: true, message: '请选择业务部门' }],
	                initialValue: data.workorgUuid
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: true,
	                  filterOption: function filterOption(input, option) {
	                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  },
	                  onChange: this.handleWorkorgChange
	                },
	                workOrgs.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.uuid },
	                    item.name
	                  );
	                })
	              ))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u9879\u76EE\u5206\u7C7B' }, ItemLayout),
	              getFieldDecorator('type', {
	                rules: [{ required: true, message: '请选择项目分类' }],
	                initialValue: data.type || data.type === 0 ? '' + data.type : ''
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                typeList.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.uuid },
	                    item.name
	                  );
	                })
	              ))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              { label: '\u9879\u76EE\u63CF\u8FF0', labelCol: { span: 2 }, wrapperCol: { span: 16 } },
	              getFieldDecorator('remark', {
	                rules: [{ required: true, message: '请填写项目描述' }],
	                initialValue: data.remark
	              })(_react2.default.createElement(_antd.Input.TextArea, {
	                placeholder: '\u63CF\u8FF0',
	                type: 'textarea',
	                autosize: { minRows: 3, maxRows: 9 },
	                maxLength: 5000
	              })),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '12px', color: '#999' } },
	                '*\u6700\u591A\u53EF\u8F93\u51655000\u5B57'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                'p',
	                { style: { fontSize: '20px', fontWeight: 'bolder' } },
	                '\u89D2\u8272\u7BA1\u7406'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              { label: this.adminiTitle(), labelCol: { span: 2 }, wrapperCol: { span: 16 } },
	              getFieldDecorator('administrators', {
	                rules: [{ required: true, message: '请选择管理员' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: true,
	                  mode: 'multiple',
	                  filterOption: function filterOption(input, option) {
	                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  },
	                  onChange: this.changeAdminis
	                },
	                accountList.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.userUuid },
	                    item.userName
	                  );
	                })
	              ))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              {
	                label: this.reviewersTitle(),
	                labelCol: { span: 2 },
	                wrapperCol: { span: 16 }
	              },
	              getFieldDecorator('reviewers', {
	                rules: [{ required: true, message: '请选择审批人' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: true,
	                  mode: 'multiple',
	                  filterOption: function filterOption(input, option) {
	                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  },
	                  onChange: this.changeReviewers
	                },
	                accountList.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.userUuid },
	                    item.userName
	                  );
	                })
	              ))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              {
	                label: this.viewablesTitle(),
	                labelCol: { span: 2 },
	                wrapperCol: { span: 16 }
	              },
	              getFieldDecorator('viewables', {
	                rules: [{ required: true, message: '请选择可查看成员' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: true,
	                  mode: 'multiple',
	                  filterOption: function filterOption(input, option) {
	                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  },
	                  onChange: this.changeViewables
	                },
	                accountList.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.userUuid },
	                    item.userName
	                  );
	                })
	              ))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(Page));

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _task = __webpack_require__(66);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getProjInfo = function (uuid) {
	      (0, _task.queryProjInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      data: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.params.uuid;
	
	      this.getProjInfo(uuid);
	    }
	
	    // 获取项目信息
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state$data = this.state.data,
	          data = _state$data === undefined ? {} : _state$data;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          { style: { marginBottom: '15px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 3 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u9879\u76EE\u540D\u79F0' },
	              data.name
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9879\u76EE\u5468\u671F' },
	              data.beginDate ? (0, _moment2.default)(data.beginDate).format('YYYY-MM-DD') : '',
	              '\u81F3',
	              data.endDate ? (0, _moment2.default)(data.endDate).format('YYYY-MM-DD') : '永久'
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9879\u76EE\u5206\u7C7B' },
	              data.type === 0 ? _react2.default.createElement(
	                'span',
	                null,
	                '\u7EE9\u6548\u8003\u6838'
	              ) : '',
	              data.type === 1 ? _react2.default.createElement(
	                'span',
	                null,
	                '\u653F\u5E9C\u7533\u62A5'
	              ) : '',
	              data.type === 2 ? _react2.default.createElement(
	                'span',
	                null,
	                '\u65E5\u5E38\u9879\u76EE'
	              ) : ''
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u4E1A\u52A1\u90E8\u95E8' },
	              data.workorgName
	            ),
	            _react2.default.createElement(
	              Description,
	              { term: '\u9879\u76EE\u6807\u7B7E' },
	              (data.tags || []).map(function (item) {
	                return _react2.default.createElement(
	                  _antd.Tag,
	                  { key: item },
	                  item
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 1 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u9879\u76EE\u63CF\u8FF0' },
	              data.remark
	            )
	          ),
	          _react2.default.createElement(_antd.Divider, null),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 1 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u9879\u76EE\u7BA1\u7406\u5458' },
	              (data.administrators || []).map(function (item) {
	                return _react2.default.createElement(
	                  'span',
	                  { style: { paddingLeft: '10px', paddingRight: '10px' }, key: item.uuid },
	                  item.userName
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 1 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u9879\u76EE\u5BA1\u6279\u4EBA' },
	              (data.reviewers || []).map(function (item) {
	                return _react2.default.createElement(
	                  'span',
	                  { style: { paddingLeft: '10px', paddingRight: '10px' }, key: item.uuid },
	                  item.userName
	                );
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _DescriptionList2.default,
	            { size: 'large', col: 1 },
	            _react2.default.createElement(
	              Description,
	              { term: '\u9879\u76EE\u53C2\u4E0E\u4EBA' },
	              (data.viewables || []).map(function (item) {
	                return _react2.default.createElement(
	                  'span',
	                  { style: { paddingLeft: '10px', paddingRight: '10px' }, key: item.uuid },
	                  item.userName
	                );
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = PageInfo;

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(5);
	
	var _task = __webpack_require__(66);
	
	var _back_info = __webpack_require__(19);
	
	var _TableProj = __webpack_require__(433);
	
	var _TableProj2 = _interopRequireDefault(_TableProj);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var FormItem = _antd.Form.Item;
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.loadData = function () {
	      var _this$state = _this.state,
	          status = _this$state.status,
	          current = _this$state.current,
	          condition = _this$state.condition;
	
	      var limit = 10;
	      _this.setState({
	        isLoading: true
	      });
	      (0, _task.queryProjLauList)({
	        status: status,
	        start: current,
	        limit: limit,
	        name: condition
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              current: current,
	              pageSize: 10
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          isLoading: false
	        });
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            current: 1,
	            condition: values.name
	          }, function () {
	            _this.loadData();
	          });
	        }
	      });
	    };
	
	    _this.changeTabs = function (key) {
	      switch (key) {
	        case '1':
	          _this.setState({
	            status: 'PUBLISH',
	            tabKey: '1',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        case '2':
	          _this.setState({
	            status: 'FINISH',
	            tabKey: '2',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        case '3':
	          _this.setState({
	            status: 'DRAFT',
	            tabKey: '3',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.changeTable = function (pagination) {
	      _this.setState({
	        current: pagination.current
	      }, function () {
	        _this.loadData();
	      });
	    };
	
	    _this.isFocusOn = function (record) {
	      record.isFocusOn = 1;
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        {
	          onSubmit: _this.handleSubmit,
	          style: {
	            position: 'absolute',
	            right: '10px',
	            top: '0',
	            display: 'flex',
	            zIndex: 100
	          }
	        },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('name', {
	            initialValue: condition
	          })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u9879\u76EE\u540D\u79F0' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit', style: { marginLeft: '10px' } },
	            '\u641C\u7D22'
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      status: 'PUBLISH',
	      tabKey: '1',
	      current: 1,
	      isLoading: false,
	      condition: '',
	      pagination: {
	        total: 10,
	        current: 1,
	        PageSize: 10
	      },
	      list: []
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        this.setState({
	          status: backInfo.status,
	          tabKey: backInfo.tabKey,
	          current: backInfo.current,
	          condition: backInfo.condition
	        }, function () {
	          _this2.loadData();
	        });
	      } else {
	        this.loadData();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          status = _state.status,
	          tabKey = _state.tabKey,
	          current = _state.current,
	          condition = _state.condition;
	
	      var params = {
	        path: this.props.location.pathname,
	        status: status,
	        tabKey: tabKey,
	        current: current,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 加载数据
	
	
	    // 搜索
	
	
	    // tab栏切换
	
	
	    // 列表改变
	
	
	    // 关注按钮
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          list = _state2.list,
	          tabKey = _state2.tabKey,
	          pagination = _state2.pagination,
	          isLoading = _state2.isLoading;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', style: { marginBottom: '10px' } },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/task/project_add' },
	            _react2.default.createElement(
	              _antd.Button,
	              { style: { marginRight: '10px' }, type: 'primary' },
	              '\u521B\u5EFA\u9879\u76EE'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: 'relative' } },
	          this.renderSearchForm(),
	          _react2.default.createElement(
	            _antd.Tabs,
	            { defaultActiveKey: '1', activeKey: tabKey, onChange: this.changeTabs },
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u53D1\u5E03\u4E2D', key: '1' },
	              _react2.default.createElement(_TableProj2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            ),
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u5DF2\u7ED3\u675F', key: '2' },
	              _react2.default.createElement(_TableProj2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                type2: 'finish',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            ),
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u8349\u7A3F\u7BB1', key: '3' },
	              _react2.default.createElement(_TableProj2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create()(Page));

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _task = __webpack_require__(66);
	
	var _back_info = __webpack_require__(19);
	
	var _TableProj = __webpack_require__(433);
	
	var _TableProj2 = _interopRequireDefault(_TableProj);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var FormItem = _antd.Form.Item;
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.loadData = function () {
	      var _this$state = _this.state,
	          status = _this$state.status,
	          current = _this$state.current,
	          condition = _this$state.condition;
	
	      var limit = 10;
	      _this.setState({
	        isLoading: true
	      });
	      (0, _task.queryProjReceiveList)({
	        status: status,
	        start: current,
	        limit: limit,
	        name: condition
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              current: current,
	              pageSize: 10
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          isLoading: false
	        });
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            current: 1,
	            condition: values.name
	          }, function () {
	            _this.loadData();
	          });
	        }
	      });
	    };
	
	    _this.changeTabs = function (key) {
	      switch (key) {
	        case '1':
	          _this.setState({
	            status: 'PUBLISH',
	            tabKey: '1',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        case '2':
	          _this.setState({
	            status: 'FINISH',
	            tabKey: '2',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.changeTable = function (pagination) {
	      _this.setState({
	        current: pagination.current
	      }, function () {
	        _this.loadData();
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        {
	          onSubmit: _this.handleSubmit,
	          style: {
	            position: 'absolute',
	            right: '10px',
	            top: '0',
	            display: 'flex',
	            zIndex: 100
	          }
	        },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('name', {
	            initialValue: condition
	          })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u9879\u76EE\u540D\u79F0' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit', style: { marginLeft: '10px' } },
	            '\u641C\u7D22'
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      status: 'PUBLISH',
	      tabKey: '1',
	      current: 1,
	      isLoading: false,
	      condition: '',
	      pagination: {
	        total: 10,
	        current: 1,
	        PageSize: 10
	      },
	      list: []
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        this.setState({
	          status: backInfo.status,
	          tabKey: backInfo.tabKey,
	          current: backInfo.current,
	          condition: backInfo.condition
	        }, function () {
	          _this2.loadData();
	        });
	      } else {
	        this.loadData();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          status = _state.status,
	          tabKey = _state.tabKey,
	          current = _state.current,
	          condition = _state.condition;
	
	      var params = {
	        path: this.props.location.pathname,
	        status: status,
	        tabKey: tabKey,
	        current: current,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 加载数据
	
	
	    // 搜索
	
	
	    // tab栏切换
	
	
	    // 列表改变
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          list = _state2.list,
	          tabKey = _state2.tabKey,
	          pagination = _state2.pagination,
	          isLoading = _state2.isLoading;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { style: { position: 'relative' } },
	          this.renderSearchForm(),
	          _react2.default.createElement(
	            _antd.Tabs,
	            { defaultActiveKey: '1', activeKey: tabKey, onChange: this.changeTabs },
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u53D1\u5E03\u4E2D', key: '1' },
	              _react2.default.createElement(_TableProj2.default, Object.assign({
	                data: list,
	                pagination: pagination,
	                isLoading: isLoading,
	                type: 'receive',
	                onChange: this.changeTable
	              }, this.props))
	            ),
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u5DF2\u7ED3\u675F', key: '2' },
	              _react2.default.createElement(_TableProj2.default, Object.assign({
	                data: list,
	                pagination: pagination,
	                isLoading: isLoading,
	                type: 'receive',
	                type2: 'finish',
	                onChange: this.changeTable
	              }, this.props))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create()(Page));

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _task = __webpack_require__(66);
	
	var _back_info = __webpack_require__(19);
	
	var _TableProj = __webpack_require__(433);
	
	var _TableProj2 = _interopRequireDefault(_TableProj);
	
	var _TreeOrg = __webpack_require__(723);
	
	var _TreeOrg2 = _interopRequireDefault(_TreeOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var FormItem = _antd.Form.Item;
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.loadData = function () {
	      var _this$state = _this.state,
	          status = _this$state.status,
	          current = _this$state.current,
	          condition = _this$state.condition,
	          workOrg = _this$state.workOrg,
	          workOrgUuid = _this$state.workOrgUuid;
	
	      var limit = 10;
	      _this.setState({
	        isLoading: true
	      });
	      (0, _task.queryProjList)({
	        status: status,
	        start: current,
	        limit: limit,
	        name: condition,
	        workOrg: workOrg,
	        workOrgUuid: workOrgUuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              current: current,
	              pageSize: 10
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          isLoading: false
	        });
	      });
	    };
	
	    _this.handleOrgSelect = function (value) {
	      _this.setState({
	        workOrgUuid: value.uuid,
	        workOrg: value.name
	      }, function () {
	        _this.loadData();
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            current: 1,
	            condition: values.name
	          }, function () {
	            _this.loadData();
	          });
	        }
	      });
	    };
	
	    _this.changeTabs = function (key) {
	      switch (key) {
	        case '1':
	          _this.setState({
	            status: 'PUBLISH',
	            tabKey: '1',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        case '2':
	          _this.setState({
	            status: 'FINISH',
	            tabKey: '2',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        case '3':
	          _this.setState({
	            status: 'DRAFT',
	            tabKey: '3',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.changeTable = function (pagination) {
	      _this.setState({
	        current: pagination.current
	      }, function () {
	        _this.loadData();
	      });
	    };
	
	    _this.isFocusOn = function (record) {
	      record.isFocusOn = 1;
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        {
	          onSubmit: _this.handleSubmit,
	          style: {
	            position: 'absolute',
	            right: '10px',
	            top: '0',
	            display: 'flex',
	            zIndex: 100
	          }
	        },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('name', {
	            initialValue: condition
	          })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u9879\u76EE\u540D\u79F0' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit', style: { marginLeft: '10px' } },
	            '\u641C\u7D22'
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      status: 'PUBLISH',
	      tabKey: '1',
	      current: 1,
	      isLoading: false,
	      condition: '',
	      pagination: {
	        total: 10,
	        current: 1,
	        PageSize: 10
	      },
	      list: [],
	      workOrg: '',
	      workOrgUuid: ''
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        this.setState({
	          workOrg: backInfo.workOrg,
	          workOrgUuid: backInfo.workOrgUuid,
	          status: backInfo.status,
	          tabKey: backInfo.tabKey,
	          current: backInfo.current,
	          condition: backInfo.condition
	        }, function () {
	          _this2.loadData();
	        });
	      } else {
	        this.loadData();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          workOrg = _state.workOrg,
	          workOrgUuid = _state.workOrgUuid,
	          status = _state.status,
	          tabKey = _state.tabKey,
	          current = _state.current,
	          condition = _state.condition;
	
	      var params = {
	        path: this.props.location.pathname,
	        workOrg: workOrg,
	        workOrgUuid: workOrgUuid,
	        status: status,
	        tabKey: tabKey,
	        current: current,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 加载数据
	
	
	    // 组织树选中
	
	
	    // 搜索
	
	
	    // tab栏切换
	
	
	    // 列表改变
	
	
	    // 关注按钮
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          workOrg = _state2.workOrg,
	          workOrgUuid = _state2.workOrgUuid,
	          list = _state2.list,
	          tabKey = _state2.tabKey,
	          pagination = _state2.pagination,
	          isLoading = _state2.isLoading;
	
	      return _react2.default.createElement(
	        _antd.Row,
	        { gutter: 16 },
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 5 },
	          _react2.default.createElement(_TreeOrg2.default, { onSelect: this.handleOrgSelect, workOrg: workOrg, workOrgUuid: workOrgUuid })
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 19, style: { position: 'relative' } },
	          this.renderSearchForm(),
	          _react2.default.createElement(
	            _antd.Tabs,
	            { defaultActiveKey: '1', activeKey: tabKey, onChange: this.changeTabs },
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u53D1\u5E03\u4E2D', key: '1' },
	              _react2.default.createElement(_TableProj2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            ),
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u5DF2\u7ED3\u675F', key: '2' },
	              _react2.default.createElement(_TableProj2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                type2: 'finish',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            ),
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u8349\u7A3F\u7BB1', key: '3' },
	              _react2.default.createElement(_TableProj2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create()(Page));

/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _task = __webpack_require__(66);
	
	var _BackBtn = __webpack_require__(12);
	
	var _back_info_standby = __webpack_require__(327);
	
	var _TableTask = __webpack_require__(1743);
	
	var _TableTask2 = _interopRequireDefault(_TableTask);
	
	var _TableFiles = __webpack_require__(1742);
	
	var _TableFiles2 = _interopRequireDefault(_TableFiles);
	
	var _ModalFileAdd = __webpack_require__(1741);
	
	var _ModalFileAdd2 = _interopRequireDefault(_ModalFileAdd);
	
	var _TreeDirectory = __webpack_require__(1744);
	
	var _TreeDirectory2 = _interopRequireDefault(_TreeDirectory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getProjInfo = function () {
	      var uuid = _this.props.params.uuid;
	
	      (0, _task.queryProjInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            projInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getProjStatRate = function () {
	      var uuid = _this.props.params.uuid;
	
	      (0, _task.queryProjStatRate)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            projRate: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getDirectoryList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var uuid, data;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              uuid = _this.props.params.uuid;
	              data = void 0;
	              _context.next = 4;
	              return (0, _task.queryProjDirList)({
	                projectUuid: uuid
	              }).then(function (res) {
	                if (res.statusCode === 200) {
	                  _this.setState({ directoryList: res.data || [] });
	                } else {
	                  _antd.message.error(res.message, 2.5);
	                }
	              });
	
	            case 4:
	              return _context.abrupt('return', data);
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.getProjTaskList = function () {
	      var projectUuid = _this.props.params.uuid;
	      var taskType = _this.state.taskType;
	      var _this$state = _this.state,
	          directoryUuid = _this$state.directoryUuid,
	          taskCurrent = _this$state.taskCurrent;
	
	      taskType === 'All' && (taskType = '');
	      var params = {
	        start: taskCurrent,
	        limit: 10,
	        projectUuid: projectUuid,
	        directoryUuid: directoryUuid,
	        status: taskType
	      };
	      _this.setState({
	        taskLoading: true
	      });
	      (0, _task.queryProjTaskList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            taskList: res.data,
	            taskPagination: {
	              total: res.totalSize,
	              current: taskCurrent,
	              pageSize: 10
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          taskLoading: false
	        });
	      });
	    };
	
	    _this.getProjFilesList = function () {
	      var projectUuid = _this.props.params.uuid;
	      var _this$state2 = _this.state,
	          filesCurrent = _this$state2.filesCurrent,
	          directoryUuid = _this$state2.directoryUuid;
	
	      var params = {
	        start: filesCurrent,
	        limit: 15,
	        directoryUuid: directoryUuid,
	        projectUuid: projectUuid
	      };
	      _this.setState({
	        filesLoading: true
	      });
	      (0, _task.queryProjFilesList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            filesList: res.data,
	            filesPagination: {
	              total: res.totalSize,
	              current: filesCurrent,
	              pageSize: 15
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          filesLoading: false
	        });
	      });
	    };
	
	    _this.handleDirectorySelect = function (value) {
	      _this.setState({
	        taskCurrent: 1,
	        filesCurrent: 1,
	        directory: value.name,
	        directoryUuid: value.uuid
	      }, function () {
	        _this.getProjTaskList();
	        _this.getProjFilesList();
	      });
	    };
	
	    _this.addProjFile = function () {
	      var directoryUuid = _this.state.directoryUuid;
	
	      if (directoryUuid === '') {
	        _antd.message.error('选择目录后，可在该目录下新增文件');
	      } else {
	        _this.setState({
	          addFileVisible: true
	        });
	      }
	    };
	
	    _this.addFileHandleOk = function (params) {
	      var directoryUuid = _this.state.directoryUuid;
	
	      params.projectUuid = _this.props.params.uuid;
	      params.directoryUuid = directoryUuid;
	      _this.setState({
	        addFileVisible: false
	      });
	      (0, _task.querySaveProjFiles)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.setState({
	            addFileVisible: false
	          });
	          _this.getProjFilesList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.addFileHandleCancel = function () {
	      _this.setState({
	        addFileVisible: false
	      });
	    };
	
	    _this.changeTabs = function (key) {
	      key === '1' && _this.setState({ tabKey: '1' });
	      key === '2' && _this.setState({ tabKey: '2' });
	    };
	
	    _this.changeSelect = function (value) {
	      _this.setState({
	        taskType: value
	      }, function () {
	        _this.getProjTaskList();
	      });
	    };
	
	    _this.changeTaskList = function (pagination) {
	      _this.setState({
	        taskCurrent: pagination.current
	      }, function () {
	        _this.getProjTaskList();
	      });
	    };
	
	    _this.changeFilesList = function (pagination) {
	      _this.setState({
	        filesCurrent: pagination.current
	      }, function () {
	        _this.getProjFilesList();
	      });
	    };
	
	    _this.toPageInfo = function () {
	      var uuid = _this.props.params.uuid;
	
	      _this.props.router.push('/task/project_info/' + uuid);
	    };
	
	    _this.state = {
	      projInfo: {},
	      projRate: {},
	
	      directory: '',
	      directoryUuid: '',
	      directoryList: [],
	
	      taskList: [],
	      filesList: [],
	
	      taskCurrent: 1,
	      filesCurrent: 1,
	
	      taskPagination: {
	        total: 10,
	        current: 1,
	        PageSize: 10
	      },
	      filesPagination: {
	        total: 10,
	        current: 1,
	        PageSize: 10
	      },
	
	      tabKey: '1',
	      taskType: 'All',
	      taskLoading: false,
	      filesLoading: false,
	      addFileVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      this.getProjInfo();
	      this.getProjStatRate();
	      var directoryList = this.getDirectoryList();
	
	      var backInfoStandby = this.props.backInfoStandby;
	
	      if (backInfoStandby.path === this.props.location.pathname) {
	        this.setState({
	          tabKey: backInfoStandby.tabKey,
	          taskType: backInfoStandby.taskType,
	
	          taskCurrent: backInfoStandby.taskCurrent,
	          filesCurrent: backInfoStandby.filesCurrent,
	
	          directory: backInfoStandby.directory,
	          directoryUuid: backInfoStandby.directoryUuid
	        }, function () {
	          backInfoStandby.tabKey === '1' && _this3.getProjTaskList();
	          backInfoStandby.tabKey === '2' && _this3.getProjFilesList();
	        });
	      } else {
	        directoryList.then(function (data) {
	          _this3.setState({
	            directory: data[0].name,
	            directoryUuid: data[0].uuid
	          });
	        }).then(function () {
	          _this3.getProjTaskList();
	          _this3.getProjFilesList();
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          tabKey = _state.tabKey,
	          taskType = _state.taskType,
	          taskCurrent = _state.taskCurrent,
	          filesCurrent = _state.filesCurrent,
	          directory = _state.directory,
	          directoryUuid = _state.directoryUuid;
	
	      var params = {
	        path: this.props.location.pathname,
	        tabKey: tabKey,
	        taskType: taskType,
	
	        taskCurrent: taskCurrent,
	        filesCurrent: filesCurrent,
	
	        directory: directory,
	        directoryUuid: directoryUuid
	      };
	      this.props.dispatch((0, _back_info_standby.setBackInfoStandby)(params));
	    }
	
	    // 获取项目详情
	
	
	    // 获取项目任务完成率
	
	
	    // 资料目录列表
	
	
	    // 获取项目下任务列表
	
	
	    // 获取文件列表
	
	
	    // 资料目录选中
	
	
	    /** ---------------------------文件新增start---------------------------*/
	    // 新增文件按钮
	
	
	    // 弹窗确定上传
	
	
	    // 弹窗关闭
	
	
	    /** ---------------------------文件新增end-----------------------------*/
	    // tab栏切换
	
	
	    // 任务类型改变
	
	
	    // 列表改变
	
	
	    // 列表改变
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          projInfo = _state2.projInfo,
	          projRate = _state2.projRate,
	          tabKey = _state2.tabKey,
	          taskType = _state2.taskType,
	          directoryUuid = _state2.directoryUuid,
	          directoryList = _state2.directoryList,
	          taskList = _state2.taskList,
	          filesList = _state2.filesList,
	          taskLoading = _state2.taskLoading,
	          filesLoading = _state2.filesLoading,
	          taskPagination = _state2.taskPagination,
	          filesPagination = _state2.filesPagination,
	          addFileVisible = _state2.addFileVisible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'space-between', align: 'middle' },
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              _react2.default.createElement(_BackBtn.BackBtn, null),
	              _react2.default.createElement(
	                'a',
	                {
	                  style: {
	                    fontWeight: 'bolder',
	                    fontSize: '20px',
	                    paddingLeft: '20px'
	                  },
	                  onClick: this.toPageInfo
	                },
	                projInfo.name
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  style: {
	                    display: 'inline-block',
	                    border: '1px solid #D9D9D9',
	                    borderRadius: '15%',
	                    backgroundColor: '#F5F5F5',
	                    marginLeft: '20px',
	                    paddingLeft: '5px',
	                    paddingRight: '5px'
	                  }
	                },
	                projInfo.endDate ? _moment2.default.unix(projInfo.endDate / 1000).format('YYYY-MM-DD') : ''
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              this.props.route.path === 'project_detail_finish/:uuid' ? _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', onClick: this.addProjFile },
	                '\u65B0\u589E\u6587\u4EF6'
	              ) : ''
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { gutter: 16 },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 6 },
	              _react2.default.createElement(_TreeDirectory2.default, {
	                data: directoryList,
	                project: projInfo.name,
	                projectUuid: projInfo.uuid,
	                directoryUuid: directoryUuid,
	                onSelect: this.handleDirectorySelect,
	                getDirectoryList: this.getDirectoryList
	              })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 18 },
	              _react2.default.createElement(
	                _antd.Tabs,
	                { defaultActiveKey: '1', activeKey: tabKey, onChange: this.changeTabs },
	                _react2.default.createElement(
	                  TabPane,
	                  { tab: '\u4EFB\u52A1\u4FE1\u606F', key: '1' },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { position: 'relative' } },
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        style: {
	                          position: 'absolute',
	                          display: 'flex',
	                          top: '-55px',
	                          right: '10px',
	                          alignItems: 'center'
	                        }
	                      },
	                      _react2.default.createElement(
	                        'p',
	                        { style: { paddingRight: '15px' } },
	                        '\u4EFB\u52A1\u6570\uFF1A',
	                        projRate.taskNum ? projRate.taskNum : 0
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { style: { paddingRight: '15px' } },
	                        '\u5B8C\u6210\u6570\uFF1A',
	                        projRate.taskCompletions ? projRate.taskCompletions : 0
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { style: { paddingRight: '15px' } },
	                        '\u5B8C\u6210\u7387\uFF1A',
	                        projRate.rate ? (projRate.rate * 100).toFixed(2) + '%' : '0%'
	                      ),
	                      _react2.default.createElement(
	                        _antd.Select,
	                        {
	                          value: taskType,
	                          onChange: this.changeSelect,
	                          style: { width: '120px', marginBottom: '10px' }
	                        },
	                        _react2.default.createElement(
	                          _antd.Select.Option,
	                          { key: 'All' },
	                          '\u5168\u90E8'
	                        ),
	                        _react2.default.createElement(
	                          _antd.Select.Option,
	                          { key: 'PUBLISH' },
	                          '\u53D1\u5E03\u4E2D'
	                        ),
	                        _react2.default.createElement(
	                          _antd.Select.Option,
	                          { key: 'FINISH' },
	                          '\u5DF2\u7ED3\u675F'
	                        ),
	                        _react2.default.createElement(
	                          _antd.Select.Option,
	                          { key: 'DRAFT' },
	                          '\u8349\u7A3F\u7BB1'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_TableTask2.default, Object.assign({
	                      data: taskList,
	                      isLoading: taskLoading,
	                      pagination: taskPagination,
	                      onChange: this.changeTaskList,
	                      getProjTaskList: this.getProjTaskList
	                    }, this.props))
	                  )
	                ),
	                _react2.default.createElement(
	                  TabPane,
	                  { tab: '\u76F8\u5173\u6587\u4EF6', key: '2' },
	                  _react2.default.createElement(_TableFiles2.default, Object.assign({
	                    data: filesList,
	                    isLoading: filesLoading,
	                    pagination: filesPagination,
	                    onChange: this.changeFilesList
	                  }, this.props))
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_ModalFileAdd2.default, Object.assign({
	          visible: addFileVisible,
	          onOk: this.addFileHandleOk,
	          onCancel: this.addFileHandleCancel,
	          delFiles: this.delFiles
	        }, this.props))
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    uesrInfo: state.account_info,
	    backInfoStandby: state.back_info_standby
	  };
	})(Index);

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalFiles = function (_Component) {
	  _inherits(ModalFiles, _Component);
	
	  function ModalFiles(props) {
	    _classCallCheck(this, ModalFiles);
	
	    var _this = _possibleConstructorReturn(this, (ModalFiles.__proto__ || Object.getPrototypeOf(ModalFiles)).call(this, props));
	
	    _this.handleOk = function () {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = {};
	          params.name = values.name;
	          params.files = values.files;
	          _this.props.onOk(params);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ModalFiles, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var ItemLayout = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 16 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u65B0\u589E\u6587\u4EF6',
	          visible: this.props.visible,
	          onOk: this.handleOk,
	          onCancel: this.props.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Form.Item,
	            Object.assign({ label: '\u6587\u4EF6\u540D\u79F0' }, ItemLayout),
	            getFieldDecorator('name', {
	              rules: [{ required: true, message: '请填写文件名称' }]
	            })(_react2.default.createElement(_antd.Input, null))
	          ),
	          _react2.default.createElement(
	            _antd.Form.Item,
	            Object.assign({ label: '\u9644\u4EF6\u4E0A\u4F20' }, ItemLayout),
	            getFieldDecorator('files', {
	              rules: [{ required: true, message: '请上传附件' }]
	            })(_react2.default.createElement(_UploadFile2.default, { type: 'ghost', isPreview: true }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalFiles;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalFiles);

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableFiles = function (_Component) {
	  _inherits(TableFiles, _Component);
	
	  function TableFiles(props) {
	    _classCallCheck(this, TableFiles);
	
	    var _this = _possibleConstructorReturn(this, (TableFiles.__proto__ || Object.getPrototypeOf(TableFiles)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '附件',
	        dataIndex: 'files',
	        key: 'files',
	        render: function render(text, record) {
	          return text ? text.map(function (item) {
	            return _react2.default.createElement(
	              'a',
	              {
	                key: item.uuid,
	                style: { display: 'block' },
	                onClick: function onClick() {
	                  return (0, _attachment.queryFilePreview)(item);
	                }
	              },
	              item.name
	            );
	          }) : '';
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(TableFiles, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          pagination = _props.pagination,
	          isLoading = _props.isLoading;
	
	      return _react2.default.createElement(_antd.Table, {
	        rowKey: 'uuid',
	        dataSource: data,
	        loading: isLoading,
	        pagination: pagination,
	        columns: this.columns(),
	        onChange: this.props.onChange
	      });
	    }
	  }]);
	
	  return TableFiles;
	}(_react.Component);
	
	exports.default = TableFiles;

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _task = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableInformation = function (_Component) {
	  _inherits(TableInformation, _Component);
	
	  function TableInformation(props) {
	    _classCallCheck(this, TableInformation);
	
	    var _this = _possibleConstructorReturn(this, (TableInformation.__proto__ || Object.getPrototypeOf(TableInformation)).call(this, props));
	
	    _this.setTaskCollect = function (record) {
	      var data = _this.state.data;
	
	
	      (0, _task.querySetTaskCollect)({ uuid: record.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          record.collectFlag = true;
	          _this.setState({ data: data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.setTaskUnCollect = function (record) {
	      var data = _this.state.data;
	
	
	      (0, _task.querySetTaskUnCollect)({ uuid: record.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          record.collectFlag = false;
	          _this.setState({ data: data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '',
	        dataIndex: 'collectFlag',
	        width: 30,
	        render: function render(text, record) {
	          if (text) {
	            return _react2.default.createElement(_antd.Icon, {
	              type: 'heart',
	              style: {
	                color: 'red'
	              },
	              theme: 'filled',
	              onClick: function onClick() {
	                return _this.setTaskUnCollect(record);
	              }
	            });
	          }
	          return _react2.default.createElement(_antd.Icon, { type: 'heart', theme: 'outlined', onClick: function onClick() {
	              return _this.setTaskCollect(record);
	            } });
	        }
	      }, {
	        title: '任务名称',
	        dataIndex: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/task/task_detail/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '开始时间',
	        dataIndex: 'beginDate',
	        key: 'beginDate',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '截至时间',
	        dataIndex: 'endDate',
	        key: 'endDate',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '相关人员',
	        dataIndex: 'executives',
	        key: 'executives',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#D8D1CF' } },
	                '\u6267'
	              ),
	              record.executives.map(function (item) {
	                return _react2.default.createElement(
	                  'span',
	                  { style: { paddingLeft: '5px', paddingRight: '5px' }, key: item.uuid },
	                  item.userName
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#D8D1CF' } },
	                '\u534F'
	              ),
	              record.assistants.map(function (item) {
	                return _react2.default.createElement(
	                  'span',
	                  { style: { paddingLeft: '5px', paddingRight: '5px' }, key: item.uuid },
	                  item.userName
	                );
	              })
	            )
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          if (record.status === 1) {
	            switch (record.fettle) {
	              case 1:
	                return _react2.default.createElement(_antd.Badge, { color: 'red', text: '\u5DF2\u903E\u671F' });
	              case 2:
	                return _react2.default.createElement(_antd.Badge, { color: 'blue', text: '\u8FDB\u884C\u4E2D' });
	              case 3:
	                return _react2.default.createElement(_antd.Badge, { color: 'yellow', text: '\u672A\u5F00\u59CB' });
	              default:
	            }
	          } else if (record.status === 2) {
	            switch (record.fettle) {
	              case 1:
	                return _react2.default.createElement(_antd.Badge, { color: 'red', text: '\u672A\u5B8C\u6210' });
	              case 2:
	                return _react2.default.createElement(_antd.Badge, { color: 'green', text: '\u5DF2\u5B8C\u6210' });
	              case 3:
	                return _react2.default.createElement(_antd.Badge, { color: 'gray', text: '\u5DF2\u5E9F\u5F03' });
	              default:
	            }
	          } else if (record.status === 0) {
	            return _react2.default.createElement(_antd.Badge, { color: 'yellow', text: '\u5F85\u7F16\u8F91' });
	          }
	        }
	      }];
	    };
	
	    _this.state = {
	      data: []
	    };
	    return _this;
	  }
	
	  _createClass(TableInformation, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ data: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var data = nextProps.data;
	
	      if (data !== this.props.data) {
	        this.setState({ data: data });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          pagination = _props.pagination,
	          isLoading = _props.isLoading;
	
	      return _react2.default.createElement(_antd.Table, {
	        size: 'small',
	        columns: this.columns(),
	        dataSource: data,
	        pagination: pagination,
	        rowKey: 'uuid',
	        loading: isLoading,
	        onChange: this.props.onChange
	      });
	    }
	  }]);
	
	  return TableInformation;
	}(_react.Component);
	
	exports.default = TableInformation;

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	__webpack_require__(2964);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.Tree.TreeNode;
	
	var TreeDirectory = function (_Component) {
	  _inherits(TreeDirectory, _Component);
	
	  function TreeDirectory(props) {
	    _classCallCheck(this, TreeDirectory);
	
	    var _this = _possibleConstructorReturn(this, (TreeDirectory.__proto__ || Object.getPrototypeOf(TreeDirectory)).call(this, props));
	
	    _this.getParentKey = function (key, tree, grandKeys) {
	      var parentKey = void 0;
	      var grandKey = grandKeys || [];
	      tree.map(function (item) {
	        if (item.children) {
	          if (item.children.some(function (item1) {
	            return item1.uuid === key;
	          })) {
	            grandKey.push(item.uuid);
	            parentKey = grandKey;
	          } else if (_this.getParentKey(key, item.children)) {
	            grandKey.push(item.uuid);
	            parentKey = _this.getParentKey(key, item.children, grandKey);
	          }
	        }
	        return item;
	      });
	      return parentKey;
	    };
	
	    _this.onExpand = function (Key, e) {
	      _this.setState({
	        expandedKeys: Key
	      });
	    };
	
	    _this.onSelect = function (selectedKeys, e) {
	      _this.setState({
	        selectedKeys: selectedKeys
	      });
	      _this.props.onSelect({
	        uuid: e.selected ? e.node.props.dataRef.uuid : '',
	        name: e.selected ? e.node.props.dataRef.name : ''
	      });
	    };
	
	    _this.titleItem = function (item) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'treeTitle' },
	        item.name
	      );
	    };
	
	    _this.renderTreeNodes = function (data) {
	      return data.map(function (item) {
	        if (item.children) {
	          return _react2.default.createElement(
	            TreeNode,
	            { title: function title() {
	                return _this.titleItem(item);
	              }, key: item.uuid, dataRef: item },
	            function () {
	              return _this.renderTreeNodes(item.children);
	            }
	          );
	        }
	        return _react2.default.createElement(TreeNode, Object.assign({ title: function title() {
	            return _this.titleItem(item);
	          }, key: item.uuid }, item));
	      });
	    };
	
	    _this.state = {
	      list: [],
	      expandedKeys: [],
	      selectedKeys: []
	    };
	    return _this;
	  }
	
	  _createClass(TreeDirectory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var list = this.props.data;
	      var directoryUuid = this.props.directoryUuid;
	
	      var expandedKeys = [];
	      expandedKeys = expandedKeys.concat(this.getParentKey(directoryUuid, list));
	      this.setState({ list: list, selectedKeys: [directoryUuid], expandedKeys: expandedKeys });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var list = nextProps.data;
	      var directoryUuid = nextProps.directoryUuid;
	      var expandedKeys = this.state.expandedKeys;
	
	      if (list !== this.props.data) {
	        expandedKeys = expandedKeys.concat(this.getParentKey(directoryUuid, list));
	        expandedKeys = expandedKeys.filter(function (currentValue, index, arr) {
	          return arr.indexOf(currentValue) === index && currentValue;
	        });
	        this.setState({
	          list: list,
	          expandedKeys: expandedKeys
	        });
	      }
	
	      if (directoryUuid !== this.props.directoryUuid) {
	        this.setState({
	          selectedKeys: [directoryUuid]
	        });
	      }
	    }
	
	    // 找到该目录的所有父级目录（及以上）
	
	
	    // 展开
	
	
	    // 选中
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          list = _state.list,
	          selectedKeys = _state.selectedKeys,
	          expandedKeys = _state.expandedKeys;
	
	
	      return _react2.default.createElement(
	        _antd.Card,
	        {
	          style: { padding: '10px', height: '100%' },
	          bodyStyle: { padding: '0', height: '100%' }
	        },
	        _react2.default.createElement(_antd.Row, { type: 'flex', justify: 'end' }),
	        _react2.default.createElement(
	          _antd.Tree,
	          {
	            showLine: true,
	            onSelect: this.onSelect,
	            selectedKeys: selectedKeys,
	            onExpand: this.onExpand,
	            expandedKeys: expandedKeys
	          },
	          function () {
	            return _this2.renderTreeNodes(list || []);
	          }
	        )
	      );
	    }
	  }]);
	
	  return TreeDirectory;
	}(_react.Component);
	
	exports.default = TreeDirectory;

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(26);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _task = __webpack_require__(66);
	
	var _BackBtn = __webpack_require__(12);
	
	var _back_info_standby = __webpack_require__(327);
	
	var _TableTask = __webpack_require__(1750);
	
	var _TableTask2 = _interopRequireDefault(_TableTask);
	
	var _TableFiles = __webpack_require__(1749);
	
	var _TableFiles2 = _interopRequireDefault(_TableFiles);
	
	var _ModalFileAdd = __webpack_require__(1747);
	
	var _ModalFileAdd2 = _interopRequireDefault(_ModalFileAdd);
	
	var _ModalFileEdit = __webpack_require__(1748);
	
	var _ModalFileEdit2 = _interopRequireDefault(_ModalFileEdit);
	
	var _TreeDirectory = __webpack_require__(1751);
	
	var _TreeDirectory2 = _interopRequireDefault(_TreeDirectory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    var _this2 = this;
	
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getProjInfo = function () {
	      var uuid = _this.props.params.uuid;
	
	      (0, _task.queryProjInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            projInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getProjStatRate = function () {
	      var uuid = _this.props.params.uuid;
	
	      (0, _task.queryProjStatRate)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            projRate: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getDirectoryList = _asyncToGenerator(_regenerator2.default.mark(function _callee() {
	      var uuid, data;
	      return _regenerator2.default.wrap(function _callee$(_context) {
	        while (1) {
	          switch (_context.prev = _context.next) {
	            case 0:
	              uuid = _this.props.params.uuid;
	              data = void 0;
	              _context.next = 4;
	              return (0, _task.queryProjDirList)({
	                projectUuid: uuid
	              }).then(function (res) {
	                if (res.statusCode === 200) {
	                  _this.setState({
	                    directoryList: res.data || []
	                  });
	                  // eslint-disable-next-line prefer-destructuring
	                  data = res.data;
	                } else {
	                  _antd.message.error(res.message, 2.5);
	                }
	              });
	
	            case 4:
	              return _context.abrupt('return', data);
	
	            case 5:
	            case 'end':
	              return _context.stop();
	          }
	        }
	      }, _callee, _this2);
	    }));
	
	    _this.getProjTaskList = function () {
	      var projectUuid = _this.props.params.uuid;
	      var taskType = _this.state.taskType;
	      var _this$state = _this.state,
	          directoryUuid = _this$state.directoryUuid,
	          taskCurrent = _this$state.taskCurrent;
	
	      taskType === 'All' && (taskType = '');
	      var params = {
	        start: taskCurrent,
	        limit: 10,
	        projectUuid: projectUuid,
	        directoryUuid: directoryUuid,
	        status: taskType
	      };
	      _this.setState({
	        taskLoading: true
	      });
	      (0, _task.queryProjTaskList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            taskList: res.data,
	            taskPagination: {
	              total: res.totalSize,
	              current: taskCurrent,
	              pageSize: 10
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          taskLoading: false
	        });
	      });
	    };
	
	    _this.getProjFilesList = function () {
	      var projectUuid = _this.props.params.uuid;
	      var _this$state2 = _this.state,
	          filesCurrent = _this$state2.filesCurrent,
	          directoryUuid = _this$state2.directoryUuid;
	
	      var params = {
	        start: filesCurrent,
	        limit: 15,
	        directoryUuid: directoryUuid,
	        projectUuid: projectUuid
	      };
	      _this.setState({
	        filesLoading: true
	      });
	      (0, _task.queryProjFilesList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            filesList: res.data,
	            filesPagination: {
	              total: res.totalSize,
	              current: filesCurrent,
	              pageSize: 15
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          filesLoading: false
	        });
	      });
	    };
	
	    _this.handleDirectorySelect = function (value) {
	      _this.setState({
	        taskCurrent: 1,
	        filesCurrent: 1,
	        directory: value.name,
	        directoryUuid: value.uuid
	      }, function () {
	        _this.getProjTaskList();
	        _this.getProjFilesList();
	      });
	    };
	
	    _this.addProjTask = function () {
	      var _this$state3 = _this.state,
	          projInfo = _this$state3.projInfo,
	          directory = _this$state3.directory,
	          directoryUuid = _this$state3.directoryUuid;
	
	      if (directoryUuid === '') {
	        _antd.message.error('选择目录后，可在该目录下新增任务');
	      } else {
	        _this.props.router.push({
	          pathname: '/task/project_task_add',
	          query: {
	            projectUuid: projInfo.uuid,
	            projectName: projInfo.name,
	            directoryUuid: directoryUuid,
	            directoryName: directory
	          }
	        });
	      }
	    };
	
	    _this.editProjTask = function (uuid) {
	      var _this$state4 = _this.state,
	          projInfo = _this$state4.projInfo,
	          directory = _this$state4.directory,
	          directoryUuid = _this$state4.directoryUuid;
	
	      _this.props.router.push({
	        pathname: '/task/project_task_edit/' + uuid,
	        query: {
	          projectUuid: projInfo.uuid,
	          projectName: projInfo.name,
	          directoryUuid: directoryUuid,
	          directoryName: directory
	        }
	      });
	    };
	
	    _this.addProjFile = function () {
	      var directoryUuid = _this.state.directoryUuid;
	
	      if (directoryUuid === '') {
	        _antd.message.error('选择目录后，可在该目录下新增文件');
	      } else {
	        _this.setState({
	          addFileVisible: true
	        });
	      }
	    };
	
	    _this.addFileHandleOk = function (params) {
	      var directoryUuid = _this.state.directoryUuid;
	
	      params.projectUuid = _this.props.params.uuid;
	      params.directoryUuid = directoryUuid;
	      (0, _task.querySaveProjFiles)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.setState({
	            tabKey: '2',
	            addFileVisible: false
	          });
	          _this.getProjFilesList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.addFileHandleCancel = function () {
	      _this.setState({
	        addFileVisible: false
	      });
	    };
	
	    _this.editProjFile = function (record) {
	      _this.setState({
	        editFileInfo: record,
	        editFileVisible: true
	      });
	    };
	
	    _this.editFileHandleOk = function (params) {
	      var _this$state5 = _this.state,
	          directoryUuid = _this$state5.directoryUuid,
	          editFileInfo = _this$state5.editFileInfo;
	
	      params.projectUuid = _this.props.params.uuid;
	      params.directoryUuid = directoryUuid;
	      params.uuid = editFileInfo.uuid;
	      (0, _task.querySaveProjFiles)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.setState({
	            editFileVisible: false
	          });
	          _this.getProjFilesList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.editFileHandleCancel = function () {
	      _this.setState({
	        editFileVisible: false
	      });
	    };
	
	    _this.delProjFile = function (uuid) {
	      (0, _task.queryDeleteProjFiles)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.getProjFilesList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.changeTabs = function (key) {
	      key === '1' && _this.setState({ tabKey: '1' });
	      key === '2' && _this.setState({ tabKey: '2' });
	    };
	
	    _this.changeSelect = function (value) {
	      _this.setState({
	        taskType: value,
	        taskCurrent: 1
	      }, function () {
	        _this.getProjTaskList();
	      });
	    };
	
	    _this.changeTaskList = function (pagination) {
	      _this.setState({
	        taskCurrent: pagination.current
	      }, function () {
	        _this.getProjTaskList();
	      });
	    };
	
	    _this.changeFilesList = function (pagination) {
	      _this.setState({
	        filesCurrent: pagination.current
	      }, function () {
	        _this.getProjFilesList();
	      });
	    };
	
	    _this.toPageInfo = function () {
	      var uuid = _this.props.params.uuid;
	
	      _this.props.router.push('/task/project_info/' + uuid);
	    };
	
	    _this.state = {
	      projInfo: {},
	      projRate: {},
	
	      directory: '',
	      directoryUuid: '',
	      directoryList: [],
	
	      taskList: [],
	      filesList: [],
	
	      taskCurrent: 1,
	      filesCurrent: 1,
	
	      taskPagination: {
	        total: 10,
	        current: 1,
	        PageSize: 10
	      },
	      filesPagination: {
	        total: 10,
	        current: 1,
	        PageSize: 10
	      },
	
	      tabKey: '1',
	      taskType: 'All',
	      editFileInfo: {},
	
	      taskLoading: false,
	      filesLoading: false,
	      addFileVisible: false,
	      editFileVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this3 = this;
	
	      this.getProjInfo();
	      this.getProjStatRate();
	      var directoryList = this.getDirectoryList();
	      var backInfoStandby = this.props.backInfoStandby;
	
	      if (backInfoStandby.path === this.props.location.pathname) {
	        this.setState({
	          tabKey: backInfoStandby.tabKey,
	          taskType: backInfoStandby.taskType,
	
	          taskCurrent: backInfoStandby.taskCurrent,
	          filesCurrent: backInfoStandby.filesCurrent,
	
	          directory: backInfoStandby.directory,
	          directoryUuid: backInfoStandby.directoryUuid
	        }, function () {
	          backInfoStandby.tabKey === '1' && _this3.getProjTaskList();
	          backInfoStandby.tabKey === '2' && _this3.getProjFilesList();
	        });
	      } else {
	        directoryList.then(function (data) {
	          _this3.setState({
	            directory: data[0].name,
	            directoryUuid: data[0].uuid
	          });
	        }).then(function () {
	          _this3.getProjTaskList();
	          _this3.getProjFilesList();
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          tabKey = _state.tabKey,
	          taskType = _state.taskType,
	          taskCurrent = _state.taskCurrent,
	          filesCurrent = _state.filesCurrent,
	          directory = _state.directory,
	          directoryUuid = _state.directoryUuid;
	
	      var params = {
	        path: this.props.location.pathname,
	        tabKey: tabKey,
	        taskType: taskType,
	
	        taskCurrent: taskCurrent,
	        filesCurrent: filesCurrent,
	
	        directory: directory,
	        directoryUuid: directoryUuid
	      };
	      this.props.dispatch((0, _back_info_standby.setBackInfoStandby)(params));
	    }
	
	    // 获取项目详情
	
	
	    // 获取项目任务完成率
	
	
	    // 资料目录列表
	
	
	    // 获取项目下任务列表
	
	
	    // 获取文件列表
	
	
	    // 资料目录选中
	
	
	    // 新增任务
	
	
	    // 编辑任务
	
	
	    /** ---------------------------文件新增start---------------------------*/
	    // 新增文件按钮
	
	
	    // 弹窗确定上传
	
	
	    // 弹窗关闭
	
	    /** ---------------------------文件新增end-----------------------------*/
	
	    /** ---------------------------文件编辑start---------------------------*/
	    // 编辑文件按钮
	
	
	    // 弹窗确定上传
	
	
	    // 弹窗关闭
	
	
	    /** ---------------------------文件编辑end-----------------------------*/
	    // 文件删除
	
	
	    // tab栏切换
	
	
	    // 任务类型改变
	
	
	    // 列表改变
	
	
	    // 列表改变
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          projInfo = _state2.projInfo,
	          projRate = _state2.projRate,
	          tabKey = _state2.tabKey,
	          taskType = _state2.taskType,
	          editFileInfo = _state2.editFileInfo,
	          directoryUuid = _state2.directoryUuid,
	          directoryList = _state2.directoryList,
	          taskList = _state2.taskList,
	          filesList = _state2.filesList,
	          taskLoading = _state2.taskLoading,
	          filesLoading = _state2.filesLoading,
	          taskPagination = _state2.taskPagination,
	          filesPagination = _state2.filesPagination,
	          addFileVisible = _state2.addFileVisible,
	          editFileVisible = _state2.editFileVisible;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'space-between', align: 'middle' },
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              _react2.default.createElement(_BackBtn.BackBtn, null),
	              _react2.default.createElement(
	                'a',
	                {
	                  style: {
	                    fontWeight: 'bolder',
	                    fontSize: '20px',
	                    paddingLeft: '20px'
	                  },
	                  onClick: this.toPageInfo
	                },
	                projInfo.name
	              ),
	              _react2.default.createElement(
	                'span',
	                {
	                  style: {
	                    display: 'inline-block',
	                    border: '1px solid #D9D9D9',
	                    borderRadius: '15%',
	                    backgroundColor: '#F5F5F5',
	                    marginLeft: '20px',
	                    paddingLeft: '5px',
	                    paddingRight: '5px'
	                  }
	                },
	                projInfo.endDate ? _moment2.default.unix(projInfo.endDate / 1000).format('YYYY-MM-DD') : ''
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', style: { marginRight: '20px' }, onClick: this.addProjTask },
	                '\u65B0\u589E\u4EFB\u52A1'
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', onClick: this.addProjFile },
	                '\u65B0\u589E\u6587\u4EF6'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            { gutter: 16 },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 6 },
	              _react2.default.createElement(_TreeDirectory2.default, {
	                data: directoryList,
	                project: projInfo.name,
	                projectUuid: projInfo.uuid,
	                directoryUuid: directoryUuid,
	                onSelect: this.handleDirectorySelect,
	                getDirectoryList: this.getDirectoryList
	              })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 18 },
	              _react2.default.createElement(
	                _antd.Tabs,
	                { defaultActiveKey: '1', activeKey: tabKey, onChange: this.changeTabs },
	                _react2.default.createElement(
	                  TabPane,
	                  { tab: '\u4EFB\u52A1\u4FE1\u606F', key: '1' },
	                  _react2.default.createElement(
	                    'div',
	                    { style: { position: 'relative' } },
	                    _react2.default.createElement(
	                      'div',
	                      {
	                        style: {
	                          position: 'absolute',
	                          display: 'flex',
	                          top: '-55px',
	                          right: '10px',
	                          alignItems: 'center'
	                        }
	                      },
	                      _react2.default.createElement(
	                        'p',
	                        { style: { paddingRight: '15px' } },
	                        '\u4EFB\u52A1\u6570\uFF1A',
	                        projRate.taskNum ? projRate.taskNum : 0
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { style: { paddingRight: '15px' } },
	                        '\u5B8C\u6210\u6570\uFF1A',
	                        projRate.taskCompletions ? projRate.taskCompletions : 0
	                      ),
	                      _react2.default.createElement(
	                        'p',
	                        { style: { paddingRight: '15px' } },
	                        '\u5B8C\u6210\u7387\uFF1A',
	                        projRate.rate ? (projRate.rate * 100).toFixed(2) + '%' : '0%'
	                      ),
	                      _react2.default.createElement(
	                        _antd.Select,
	                        {
	                          value: taskType,
	                          onChange: this.changeSelect,
	                          style: { width: '120px', marginBottom: '10px' }
	                        },
	                        _react2.default.createElement(
	                          _antd.Select.Option,
	                          { key: 'All' },
	                          '\u5168\u90E8'
	                        ),
	                        _react2.default.createElement(
	                          _antd.Select.Option,
	                          { key: 'PUBLISH' },
	                          '\u53D1\u5E03\u4E2D'
	                        ),
	                        _react2.default.createElement(
	                          _antd.Select.Option,
	                          { key: 'FINISH' },
	                          '\u5DF2\u7ED3\u675F'
	                        ),
	                        _react2.default.createElement(
	                          _antd.Select.Option,
	                          { key: 'DRAFT' },
	                          '\u8349\u7A3F\u7BB1'
	                        )
	                      )
	                    ),
	                    _react2.default.createElement(_TableTask2.default, Object.assign({
	                      data: taskList,
	                      isLoading: taskLoading,
	                      pagination: taskPagination,
	                      onChange: this.changeTaskList,
	                      editProjTask: this.editProjTask,
	                      getProjTaskList: this.getProjTaskList
	                    }, this.props))
	                  )
	                ),
	                _react2.default.createElement(
	                  TabPane,
	                  { tab: '\u76F8\u5173\u6587\u4EF6', key: '2' },
	                  _react2.default.createElement(_TableFiles2.default, Object.assign({
	                    data: filesList,
	                    isLoading: filesLoading,
	                    pagination: filesPagination,
	                    delProjFile: this.delProjFile,
	                    editProjFile: this.editProjFile,
	                    onChange: this.changeFilesList
	                  }, this.props))
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_ModalFileAdd2.default, Object.assign({
	          visible: addFileVisible,
	          onOk: this.addFileHandleOk,
	          onCancel: this.addFileHandleCancel,
	          delFiles: this.delFiles
	        }, this.props)),
	        _react2.default.createElement(_ModalFileEdit2.default, Object.assign({
	          visible: editFileVisible,
	          fileName: editFileInfo.name,
	          onOk: this.editFileHandleOk,
	          onCancel: this.editFileHandleCancel
	        }, this.props))
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    uesrInfo: state.account_info,
	    backInfoStandby: state.back_info_standby
	  };
	})(Index);

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var IndexModal = function (_Component) {
	  _inherits(IndexModal, _Component);
	
	  function IndexModal(props) {
	    _classCallCheck(this, IndexModal);
	
	    var _this = _possibleConstructorReturn(this, (IndexModal.__proto__ || Object.getPrototypeOf(IndexModal)).call(this, props));
	
	    _this.submit = function () {
	      var _this$props = _this.props,
	          data = _this$props.data,
	          isAddType = _this$props.isAddType;
	
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = {};
	          if (isAddType) {
	            params.parentUuid = null;
	            data && data.uuid && (params.parentUuid = data.uuid);
	          } else {
	            params.uuid = data.uuid;
	            params.parentUuid = data.parentUuid;
	          }
	          params.name = values.name;
	          _this.props.onOk(params);
	          _this.props.form.resetFields();
	        }
	      });
	    };
	
	    _this.onCancel = function () {
	      _this.props.form.resetFields();
	      _this.props.onCancel();
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(IndexModal, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var _props = this.props,
	          data = _props.data,
	          isAddType = _props.isAddType;
	
	      var formItemLayout = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 14 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: isAddType ? '创建目录' : '编辑目录',
	          visible: this.props.visible,
	          onOk: this.submit,
	          onCancel: this.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            FormItem,
	            Object.assign({ label: '\u76EE\u5F55\u540D\u79F0' }, formItemLayout),
	            getFieldDecorator('name', {
	              rules: [{ required: true, message: '请填写目录名称' }],
	              initialValue: isAddType ? null : data.name
	            })(_react2.default.createElement(_antd.Input, null))
	          )
	        )
	      );
	    }
	  }]);
	
	  return IndexModal;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    accountInfo: state.account_info
	  };
	})(_antd.Form.create()(IndexModal));

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _UploadFile = __webpack_require__(56);
	
	var _UploadFile2 = _interopRequireDefault(_UploadFile);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalFiles = function (_Component) {
	  _inherits(ModalFiles, _Component);
	
	  function ModalFiles(props) {
	    _classCallCheck(this, ModalFiles);
	
	    var _this = _possibleConstructorReturn(this, (ModalFiles.__proto__ || Object.getPrototypeOf(ModalFiles)).call(this, props));
	
	    _this.handleOk = function () {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = {};
	          params.name = values.name;
	          params.files = values.files;
	          _this.props.onOk(params);
	          _this.props.form.setFieldsValue({ name: '', files: 'reset' });
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ModalFiles, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var ItemLayout = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 16 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u65B0\u589E\u6587\u4EF6',
	          visible: this.props.visible,
	          onOk: this.handleOk,
	          onCancel: this.props.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Form.Item,
	            Object.assign({ label: '\u6587\u4EF6\u540D\u79F0' }, ItemLayout),
	            getFieldDecorator('name', {
	              rules: [{ required: true, message: '请填写文件名称' }]
	            })(_react2.default.createElement(_antd.Input, null))
	          ),
	          _react2.default.createElement(
	            _antd.Form.Item,
	            Object.assign({ label: '\u9644\u4EF6\u4E0A\u4F20' }, ItemLayout),
	            getFieldDecorator('files', {
	              rules: [{ required: true, message: '请上传附件' }]
	            })(_react2.default.createElement(_UploadFile2.default, { type: 'ghost', isPreview: true }))
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalFiles;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalFiles);

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ModalFiles = function (_Component) {
	  _inherits(ModalFiles, _Component);
	
	  function ModalFiles(props) {
	    _classCallCheck(this, ModalFiles);
	
	    var _this = _possibleConstructorReturn(this, (ModalFiles.__proto__ || Object.getPrototypeOf(ModalFiles)).call(this, props));
	
	    _this.handleOk = function () {
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          var params = {};
	          params.name = values.name;
	          _this.props.onOk(params);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(ModalFiles, [{
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var ItemLayout = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 16 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u7F16\u8F91\u6587\u4EF6',
	          visible: this.props.visible,
	          onOk: this.handleOk,
	          onCancel: this.props.onCancel
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Form.Item,
	            Object.assign({ label: '\u6587\u4EF6\u540D\u79F0' }, ItemLayout),
	            getFieldDecorator('name', {
	              rules: [{ required: true, message: '请填写文件名称' }]
	            })(_react2.default.createElement(_antd.Input, null))
	          )
	        )
	      );
	    }
	  }]);
	
	  return ModalFiles;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(ModalFiles);

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableFiles = function (_Component) {
	  _inherits(TableFiles, _Component);
	
	  function TableFiles(props) {
	    _classCallCheck(this, TableFiles);
	
	    var _this = _possibleConstructorReturn(this, (TableFiles.__proto__ || Object.getPrototypeOf(TableFiles)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: '文件名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '附件',
	        dataIndex: 'files',
	        key: 'files',
	        render: function render(text, record) {
	          return text ? text.map(function (item) {
	            return _react2.default.createElement(
	              'a',
	              {
	                style: { display: 'block' },
	                onClick: function onClick() {
	                  return (0, _attachment.queryFilePreview)(item);
	                },
	                key: item.uuid
	              },
	              item.name
	            );
	          }) : '';
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.props.editProjFile(record);
	                } },
	              '\u7F16\u8F91'
	            ),
	            _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	            _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                placement: 'leftTop',
	                title: '\u786E\u5B9A\u5220\u9664\u6587\u4EF6\uFF1F',
	                onConfirm: function onConfirm() {
	                  return _this.props.delProjFile(record.uuid);
	                },
	                okText: '\u786E\u5B9A',
	                cancelText: '\u53D6\u6D88'
	              },
	              _react2.default.createElement(
	                'a',
	                null,
	                '\u5220\u9664'
	              )
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(TableFiles, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          pagination = _props.pagination,
	          isLoading = _props.isLoading;
	
	      return _react2.default.createElement(_antd.Table, {
	        columns: this.columns(),
	        dataSource: data,
	        pagination: pagination,
	        rowKey: 'uuid',
	        loading: isLoading,
	        onChange: this.props.onChange
	      });
	    }
	  }]);
	
	  return TableFiles;
	}(_react.Component);
	
	exports.default = TableFiles;

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouter = __webpack_require__(8);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _task = __webpack_require__(66);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TableInformation = function (_Component) {
	  _inherits(TableInformation, _Component);
	
	  function TableInformation(props) {
	    _classCallCheck(this, TableInformation);
	
	    var _this = _possibleConstructorReturn(this, (TableInformation.__proto__ || Object.getPrototypeOf(TableInformation)).call(this, props));
	
	    _this.setTaskCollect = function (record) {
	      var data = _this.state.data;
	
	
	      (0, _task.querySetTaskCollect)({ uuid: record.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          record.collectFlag = true;
	          _this.setState({ data: data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.setTaskUnCollect = function (record) {
	      var data = _this.state.data;
	
	
	      (0, _task.querySetTaskUnCollect)({ uuid: record.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          record.collectFlag = false;
	          _this.setState({ data: data });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleDisTask = function (uuid) {
	      (0, _task.queryTaskDiscard)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.getProjTaskList();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '',
	        dataIndex: 'collectFlag',
	        width: 30,
	        render: function render(text, record) {
	          if (text) {
	            return _react2.default.createElement(_antd.Icon, {
	              type: 'heart',
	              style: {
	                color: 'red'
	              },
	              theme: 'filled',
	              onClick: function onClick() {
	                return _this.setTaskUnCollect(record);
	              }
	            });
	          }
	          return _react2.default.createElement(_antd.Icon, { type: 'heart', theme: 'outlined', onClick: function onClick() {
	              return _this.setTaskCollect(record);
	            } });
	        }
	      }, {
	        title: '任务名称',
	        dataIndex: 'name',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/task/task_detail/' + record.uuid },
	            text
	          );
	        }
	      }, {
	        title: '开始时间',
	        dataIndex: 'beginDate',
	        key: 'beginDate',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '截至时间',
	        dataIndex: 'endDate',
	        key: 'endDate',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '相关人员',
	        dataIndex: 'executives',
	        key: 'executives',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            _react2.default.createElement(
	              'p',
	              null,
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#D8D1CF' } },
	                '\u6267'
	              ),
	              record.executives.map(function (item) {
	                return _react2.default.createElement(
	                  'span',
	                  { style: { paddingLeft: '5px', paddingRight: '5px' }, key: item.uuid },
	                  item.userName
	                );
	              })
	            ),
	            _react2.default.createElement(
	              'p',
	              { style: { marginBottom: '0' } },
	              _react2.default.createElement(
	                'span',
	                { style: { color: '#D8D1CF' } },
	                '\u534F'
	              ),
	              record.assistants.map(function (item) {
	                return _react2.default.createElement(
	                  'span',
	                  { style: { paddingLeft: '5px', paddingRight: '5px' }, key: item.uuid },
	                  item.userName
	                );
	              })
	            )
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        render: function render(text, record) {
	          if (record.status === 1) {
	            switch (record.fettle) {
	              case 1:
	                return _react2.default.createElement(_antd.Badge, { color: 'red', text: '\u5DF2\u903E\u671F' });
	              case 2:
	                return _react2.default.createElement(_antd.Badge, { color: 'blue', text: '\u8FDB\u884C\u4E2D' });
	              case 3:
	                return _react2.default.createElement(_antd.Badge, { color: 'yellow', text: '\u672A\u5F00\u59CB' });
	              default:
	            }
	          } else if (record.status === 2) {
	            switch (record.fettle) {
	              case 1:
	                return _react2.default.createElement(_antd.Badge, { color: 'red', text: '\u672A\u5B8C\u6210' });
	              case 2:
	                return _react2.default.createElement(_antd.Badge, { color: 'green', text: '\u5DF2\u5B8C\u6210' });
	              case 3:
	                return _react2.default.createElement(_antd.Badge, { color: 'gray', text: '\u5DF2\u5E9F\u5F03' });
	              default:
	            }
	          } else if (record.status === 0) {
	            return _react2.default.createElement(_antd.Badge, { color: 'yellow', text: '\u5F85\u7F16\u8F91' });
	          }
	        }
	      }, {
	        title: '操作',
	        dataIndex: 'done',
	        render: function render(text, record) {
	          switch (record.status) {
	            case 0:
	              return _react2.default.createElement(
	                _reactRouter.Link,
	                { onClick: function onClick() {
	                    return _this.editProjTask(record.uuid);
	                  } },
	                '\u7F16\u8F91'
	              );
	            case 1:
	              return _react2.default.createElement(
	                'div',
	                null,
	                _react2.default.createElement(
	                  _reactRouter.Link,
	                  { onClick: function onClick() {
	                      return _this.props.editProjTask(record.uuid);
	                    } },
	                  '\u7F16\u8F91'
	                ),
	                record.fettle === 2 && record.status === 3 ? '' : _react2.default.createElement(_antd.Divider, { type: 'vertical' }),
	                _react2.default.createElement(
	                  _antd.Popconfirm,
	                  {
	                    placement: 'leftTop',
	                    title: '\u786E\u5B9A\u5E9F\u5F03\u4EFB\u52A1\u5417\uFF1F',
	                    onConfirm: function onConfirm() {
	                      return _this.handleDisTask(record.uuid);
	                    },
	                    okText: '\u786E\u5B9A',
	                    cancelText: '\u53D6\u6D88'
	                  },
	                  _react2.default.createElement(
	                    'a',
	                    null,
	                    '\u5E9F\u5F03'
	                  )
	                )
	              );
	            case 2:
	              return _react2.default.createElement('div', null);
	            default:
	          }
	        }
	      }];
	    };
	
	    _this.state = {
	      data: []
	    };
	    return _this;
	  }
	
	  _createClass(TableInformation, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ data: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var data = nextProps.data;
	
	      if (data !== this.props.data) {
	        this.setState({ data: data });
	      }
	    }
	
	    // 废弃任务
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          data = _props.data,
	          pagination = _props.pagination,
	          isLoading = _props.isLoading;
	
	      return _react2.default.createElement(_antd.Table, {
	        size: 'small',
	        rowKey: 'uuid',
	        dataSource: data,
	        loading: isLoading,
	        pagination: pagination,
	        columns: this.columns(),
	        onChange: this.props.onChange
	      });
	    }
	  }]);
	
	  return TableInformation;
	}(_react.Component);
	
	exports.default = TableInformation;

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _task = __webpack_require__(66);
	
	var _ModalDirAdd = __webpack_require__(1746);
	
	var _ModalDirAdd2 = _interopRequireDefault(_ModalDirAdd);
	
	__webpack_require__(2965);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TreeNode = _antd.Tree.TreeNode;
	var confirm = _antd.Modal.confirm;
	
	var TreeDirectory = function (_Component) {
	  _inherits(TreeDirectory, _Component);
	
	  function TreeDirectory(props) {
	    _classCallCheck(this, TreeDirectory);
	
	    var _this2 = _possibleConstructorReturn(this, (TreeDirectory.__proto__ || Object.getPrototypeOf(TreeDirectory)).call(this, props));
	
	    _this2.getParentKey = function (key, tree, grandKeys) {
	      var parentKey = void 0;
	      var grandKey = grandKeys || [];
	      tree.map(function (item) {
	        if (item.children) {
	          if (item.children.some(function (item1) {
	            return item1.uuid === key;
	          })) {
	            grandKey.push(item.uuid);
	            parentKey = grandKey;
	          } else if (_this2.getParentKey(key, item.children)) {
	            grandKey.push(item.uuid);
	            parentKey = _this2.getParentKey(key, item.children, grandKey);
	          }
	        }
	        return item;
	      });
	      return parentKey;
	    };
	
	    _this2.getDirectoryInfo = function (uuid) {
	      (0, _task.queryProjDirInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this2.directoryInfo = res.data;
	          _this2.setState({
	            directoryInfo: res.data || []
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.onExpand = function (Key, e) {
	      _this2.setState({
	        expandedKeys: Key
	      });
	    };
	
	    _this2.onSelect = function (selectedKeys, e) {
	      _this2.setState({
	        selectedKeys: selectedKeys
	      });
	      _this2.props.onSelect({
	        uuid: e.selected ? e.node.props.dataRef.uuid : '',
	        name: e.selected ? e.node.props.dataRef.name : ''
	      });
	    };
	
	    _this2.onDrop = function (info) {
	      var dropPos = info.node.props.pos.split('-');
	      var dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
	      (0, _task.queryProjDirInfo)({ uuid: info.node.props.dataRef.uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          var directoryInfo = res.data;
	          var params = {};
	          params.uuid = info.dragNode.props.dataRef.uuid;
	          params.name = info.dragNode.props.dataRef.name;
	          if (dropPosition === -1) {
	            params.parentUuid = directoryInfo.parentUuid;
	          } else {
	            params.parentUuid = directoryInfo.uuid;
	          }
	          _this2.directoryAddSubmit(params);
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this2.hideModalDirAdd = function (flag) {
	      _this2.setState({
	        dirAddVisible: !!flag
	      });
	    };
	
	    _this2.addTopDirectory = function (e) {
	      e.stopPropagation();
	      _this2.setState({ isAddType: true }, function () {
	        _this2.hideModalDirAdd(true);
	      });
	    };
	
	    _this2.addDirectory = function (item, e) {
	      e.stopPropagation();
	      _this2.getDirectoryInfo(item.uuid);
	      _this2.setState({ isAddType: true }, function () {
	        _this2.hideModalDirAdd(true);
	      });
	    };
	
	    _this2.editDirectory = function (item, e) {
	      e.stopPropagation();
	      _this2.getDirectoryInfo(item.uuid);
	      _this2.setState({ isAddType: false }, function () {
	        _this2.hideModalDirAdd(true);
	      });
	    };
	
	    _this2.directoryAddSubmit = function (params) {
	      var _this2$props = _this2.props,
	          project = _this2$props.project,
	          projectUuid = _this2$props.projectUuid;
	
	      params.project = project;
	      params.projectUuid = projectUuid;
	      (0, _task.querySaveProjDir)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this2.props.getDirectoryList();
	          _this2.hideModalDirAdd();
	          _this2.setState({ directoryInfo: null });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.showDelDirectory = function (item, e) {
	      e.stopPropagation();
	      var _this = _this2;
	      confirm({
	        title: '确定删除该目录?',
	        onOk: function onOk() {
	          _this.directoryDeleteSubmit(item);
	        }
	      });
	    };
	
	    _this2.directoryDeleteSubmit = function (item) {
	      var params = {};
	      item && (params.uuid = item.uuid);
	      item && (0, _task.queryDeleteProjDir)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this2.props.getDirectoryList();
	          _this2.setState({ directoryInfo: null });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this2.titleItem = function (item) {
	      return _react2.default.createElement(
	        'span',
	        { className: 'treeTitle' },
	        item.name,
	        _react2.default.createElement(
	          'span',
	          { className: 'treeButton' },
	          _react2.default.createElement(_antd.Icon, {
	            type: 'edit',
	            onClick: function onClick() {
	              return _this2.editDirectory(item);
	            },
	            style: { paddingRight: '5px' }
	          }),
	          _react2.default.createElement(_antd.Icon, {
	            type: 'plus-circle',
	            onClick: function onClick() {
	              return _this2.addDirectory(item);
	            },
	            style: { paddingRight: '5px' }
	          }),
	          _react2.default.createElement(_antd.Icon, { type: 'minus-circle', onClick: function onClick() {
	              return _this2.showDelDirectory(item);
	            } })
	        )
	      );
	    };
	
	    _this2.renderTreeNodes = function (data) {
	      return data.map(function (item) {
	        if (item.children) {
	          return _react2.default.createElement(
	            TreeNode,
	            { title: _this2.titleItem(item), key: item.uuid, dataRef: item },
	            _this2.renderTreeNodes(item.children)
	          );
	        }
	        return _react2.default.createElement(TreeNode, { title: _this2.titleItem(item), key: item.uuid, dataRef: item });
	      });
	    };
	
	    _this2.state = {
	      list: [],
	      expandedKeys: [],
	      selectedKeys: [],
	      isAddType: true,
	      directoryInfo: null
	    };
	    return _this2;
	  }
	
	  _createClass(TreeDirectory, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var list = this.props.data;
	      var directoryUuid = this.props.directoryUuid;
	
	      var expandedKeys = [];
	      expandedKeys = expandedKeys.concat(this.getParentKey(directoryUuid, list));
	      this.setState({ list: list, selectedKeys: [directoryUuid], expandedKeys: expandedKeys });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var list = nextProps.data;
	      var directoryUuid = nextProps.directoryUuid;
	      var expandedKeys = this.state.expandedKeys;
	
	      if (list !== this.props.data) {
	        expandedKeys = expandedKeys.concat(this.getParentKey(directoryUuid, list));
	        expandedKeys = expandedKeys.filter(function (currentValue, index, arr) {
	          return arr.indexOf(currentValue) === index && currentValue;
	        });
	        this.setState({
	          list: list,
	          directoryInfo: null,
	          expandedKeys: expandedKeys
	        });
	      }
	
	      if (directoryUuid !== this.props.directoryUuid) {
	        this.setState({
	          selectedKeys: [directoryUuid]
	        });
	      }
	    }
	
	    // 找到该目录的所有父级目录（及以上）
	
	
	    // 项目目录详情
	
	
	    // 展开
	
	
	    // 选中
	
	
	    // 拖动
	
	
	    /** ------------------新增/编辑/删除项目目录-------------------------------------------*/
	    // 弹窗开关
	
	
	    // 新增的弹窗
	
	
	    // 编辑的弹窗
	
	
	    // 新增/编辑提交
	
	
	    // 删除
	
	    /**-----------------------------------------------------------------------------*/
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _state = this.state,
	          list = _state.list,
	          isAddType = _state.isAddType,
	          dirAddVisible = _state.dirAddVisible,
	          directoryInfo = _state.directoryInfo,
	          selectedKeys = _state.selectedKeys,
	          expandedKeys = _state.expandedKeys;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        {
	          style: { padding: '10px', height: '100%' },
	          bodyStyle: { padding: '0', height: '100%' }
	        },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'end' },
	          _react2.default.createElement(_antd.Icon, { type: 'plus-circle', onClick: this.addTopDirectory, style: { paddingRight: '5px' } })
	        ),
	        _react2.default.createElement(
	          _antd.Tree,
	          {
	            showLine: true,
	            draggable: true,
	            onDrop: this.onDrop,
	            onSelect: this.onSelect,
	            selectedKeys: selectedKeys,
	            onExpand: this.onExpand,
	            expandedKeys: expandedKeys
	          },
	          this.renderTreeNodes(list || [])
	        ),
	        _react2.default.createElement(_ModalDirAdd2.default, {
	          visible: dirAddVisible,
	          data: directoryInfo || {},
	          isAddType: isAddType,
	          onOk: this.directoryAddSubmit,
	          onCancel: function onCancel() {
	            return _this3.hideModalDirAdd(false);
	          }
	        })
	      );
	    }
	  }]);
	
	  return TreeDirectory;
	}(_react.Component);
	
	exports.default = TreeDirectory;

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _PageAdd = __webpack_require__(1735);
	
	var _PageAdd2 = _interopRequireDefault(_PageAdd);
	
	var _Index = __webpack_require__(1740);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(1745);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _PageInfo = __webpack_require__(1736);
	
	var _PageInfo2 = _interopRequireDefault(_PageInfo);
	
	var _PageWatch = __webpack_require__(1739);
	
	var _PageWatch2 = _interopRequireDefault(_PageWatch);
	
	var _PageLaunch = __webpack_require__(1737);
	
	var _PageLaunch2 = _interopRequireDefault(_PageLaunch);
	
	var _PageReceive = __webpack_require__(1738);
	
	var _PageReceive2 = _interopRequireDefault(_PageReceive);
	
	var _PageAdd3 = __webpack_require__(1755);
	
	var _PageAdd4 = _interopRequireDefault(_PageAdd3);
	
	var _Index5 = __webpack_require__(1761);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _PageInfo3 = __webpack_require__(1763);
	
	var _PageInfo4 = _interopRequireDefault(_PageInfo3);
	
	var _PageSubmit = __webpack_require__(724);
	
	var _PageSubmit2 = _interopRequireDefault(_PageSubmit);
	
	var _PageWatch3 = __webpack_require__(1758);
	
	var _PageWatch4 = _interopRequireDefault(_PageWatch3);
	
	var _PageLaunch3 = __webpack_require__(1756);
	
	var _PageLaunch4 = _interopRequireDefault(_PageLaunch3);
	
	var _PageReceive3 = __webpack_require__(1757);
	
	var _PageReceive4 = _interopRequireDefault(_PageReceive3);
	
	var _PageMine = __webpack_require__(1764);
	
	var _PageMine2 = _interopRequireDefault(_PageMine);
	
	var _PageWatch5 = __webpack_require__(1766);
	
	var _PageWatch6 = _interopRequireDefault(_PageWatch5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 任务管理
	var router = {
	  path: 'task',
	  breadcrumbName: '任务',
	  childRoutes: [{
	    path: 'project_add',
	    breadcrumbName: '新增项目',
	    component: _PageAdd2.default
	  }, {
	    path: 'project_edit/:uuid',
	    breadcrumbName: '编辑项目',
	    component: _PageAdd2.default
	  }, {
	    path: 'project_detail_manage/:uuid',
	    breadcrumbName: '项目详情',
	    component: _Index4.default
	  }, {
	    path: 'project_detail/:uuid',
	    breadcrumbName: '项目详情',
	    component: _Index2.default
	  }, {
	    path: 'project_detail_finish/:uuid',
	    breadcrumbName: '项目详情',
	    component: _Index2.default
	  }, {
	    path: 'project_info/:uuid',
	    breadcrumbName: '项目详情',
	    component: _PageInfo2.default
	  }, {
	    path: 'project_watch',
	    breadcrumbName: '项目监控',
	    component: _PageWatch2.default
	  }, {
	    path: 'project_launch',
	    breadcrumbName: '项目管理',
	    component: _PageLaunch2.default
	  }, {
	    path: 'project_receive',
	    breadcrumbName: '收到的项目',
	    component: _PageReceive2.default
	  }, {
	    path: 'project_task_add',
	    breadcrumbName: '新增任务',
	    component: _PageAdd4.default
	  }, {
	    path: 'task_add',
	    breadcrumbName: '新增任务',
	    component: _PageAdd4.default
	  }, {
	    path: 'project_task_edit/:taskUuid',
	    breadcrumbName: '编辑任务',
	    component: _PageAdd4.default
	  }, {
	    path: 'task_edit/:taskUuid',
	    breadcrumbName: '编辑任务',
	    component: _PageAdd4.default
	  }, {
	    path: 'task_submit/:uuid',
	    breadcrumbName: '提交任务',
	    component: _PageSubmit2.default
	  }, {
	    path: 'task_detail/:uuid',
	    breadcrumbName: '任务详情',
	    component: _Index6.default
	  }, {
	    path: 'task_check_detail/:uuid',
	    breadcrumbName: '任务审核详情',
	    component: _PageInfo4.default
	  }, {
	    path: 'task_watch',
	    breadcrumbName: '任务监控',
	    component: _PageWatch4.default
	  }, {
	    path: 'task_launch',
	    breadcrumbName: '任务管理',
	    component: _PageLaunch4.default
	  }, {
	    path: 'task_check_mine',
	    breadcrumbName: '任务审核',
	    component: _PageMine2.default
	  }, {
	    path: 'task_check_watch',
	    breadcrumbName: '任务审核监控',
	    component: _PageWatch6.default
	  }, {
	    path: 'task_receive',
	    breadcrumbName: '收到的任务',
	    component: _PageReceive4.default
	  }]
	};
	
	exports.default = router;

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var CardAdvSearch = function (_Component) {
	  _inherits(CardAdvSearch, _Component);
	
	  function CardAdvSearch(props) {
	    _classCallCheck(this, CardAdvSearch);
	
	    var _this = _possibleConstructorReturn(this, (CardAdvSearch.__proto__ || Object.getPrototypeOf(CardAdvSearch)).call(this, props));
	
	    _this.changeItem = function (itemName, value) {
	      var data = _this.state.data;
	
	      switch (itemName) {
	        case 'projectName':
	          data.projectName = value.target.value;
	          break;
	        case 'type':
	          data.type = value;
	          break;
	        case 'role':
	          data.role = value;
	          break;
	        case 'projectUuid':
	          data.projectUuid = value;
	          break;
	        case 'tag':
	          data.tag = value;
	          break;
	        case 'endDate':
	          data.endDate = value ? value.valueOf() : '';
	          break;
	        case 'fettle':
	          data.fettle = value;
	          break;
	        default:
	          break;
	      }
	      _this.setState({ data: data });
	    };
	
	    _this.handleOk = function () {
	      var data = _this.state.data;
	
	      var newData = JSON.parse(JSON.stringify(data));
	      Object.keys(newData).forEach(function (key) {
	        if (newData[key] === 'all') {
	          newData[key] = '';
	        }
	      });
	      _this.props.handleOk(newData);
	    };
	
	    _this.resetParams = function () {
	      _this.setState({
	        data: {}
	      });
	    };
	
	    _this.state = {
	      data: {},
	      typeList: [{ value: 'all', name: '全部' }, { value: '0', name: '绩效考核' }, { value: '1', name: '政府申报' }, { value: '2', name: '日常任务' }],
	      roleList: [{ value: 'all', name: '全部' }, { value: 'EXECUTIVE', name: '执行人' }, { value: 'ASSISTANT', name: '协助者' }],
	      fettleList: [{ value: 'all', name: '全部' }, { value: '1', name: '未完成' }, { value: '2', name: '已完成' }, { value: '3', name: '已废弃' }]
	    };
	    return _this;
	  }
	
	  _createClass(CardAdvSearch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({
	        data: JSON.parse(JSON.stringify(data))
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
	        this.setState({
	          data: JSON.parse(JSON.stringify(nextProps.data))
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          typeList = _state.typeList,
	          roleList = _state.roleList,
	          fettleList = _state.fettleList;
	      var _props = this.props,
	          tagList = _props.tagList,
	          projectList = _props.projectList;
	
	      var ItemLayout = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 19 }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        { style: this.props.style },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u4EFB\u52A1\u5206\u7C7B' }),
	                _react2.default.createElement(
	                  _antd.Select,
	                  { value: data.type, onChange: function onChange() {
	                      return _this2.changeItem('type');
	                    } },
	                  typeList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.value, value: item.value },
	                      item.name
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u4EFB\u52A1\u72B6\u6001' }),
	                _react2.default.createElement(
	                  _antd.Select,
	                  { value: data.fettle, onChange: function onChange() {
	                      return _this2.changeItem('fettle');
	                    } },
	                  fettleList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { value: item.value, key: item.value },
	                      item.name
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u4EFB\u52A1\u6807\u7B7E' }),
	                _react2.default.createElement(
	                  _antd.Select,
	                  { value: data.tag, onChange: function onChange() {
	                      return _this2.changeItem('tag');
	                    } },
	                  tagList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.uuid, value: item.uuid },
	                      item.name
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u6211\u7684\u89D2\u8272' }),
	                _react2.default.createElement(
	                  _antd.Select,
	                  { value: data.role, onChange: function onChange() {
	                      return _this2.changeItem('role');
	                    } },
	                  roleList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.value, value: item.value },
	                      item.name
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u5F52\u5C5E\u9879\u76EE' }),
	                _react2.default.createElement(
	                  _antd.Select,
	                  { value: data.projectUuid, onChange: function onChange() {
	                      return _this2.changeItem('projectUuid');
	                    } },
	                  projectList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.uuid, value: item.uuid },
	                      item.name
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u622A\u81F3\u65F6\u95F4' }),
	                data.endDate ? _react2.default.createElement(_antd.DatePicker, {
	                  style: { width: '100%' },
	                  value: (0, _moment2.default)(data.endDate),
	                  onChange: function onChange() {
	                    return _this2.changeItem('endDate');
	                  }
	                }) : _react2.default.createElement(_antd.DatePicker, {
	                  style: { width: '100%' },
	                  onChange: function onChange() {
	                    return _this2.changeItem('endDate');
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { display: 'flex', justifyContent: 'center' } },
	            _react2.default.createElement(
	              _antd.Button,
	              { onClick: this.handleOk, type: 'primary' },
	              '\u786E\u5B9A'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { onClick: this.resetParams, style: { marginLeft: '10px' } },
	              '\u91CD\u7F6E'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CardAdvSearch;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(CardAdvSearch);

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var CardAdvSearch = function (_Component) {
	  _inherits(CardAdvSearch, _Component);
	
	  function CardAdvSearch(props) {
	    _classCallCheck(this, CardAdvSearch);
	
	    var _this = _possibleConstructorReturn(this, (CardAdvSearch.__proto__ || Object.getPrototypeOf(CardAdvSearch)).call(this, props));
	
	    _this.changeItem = function (itemName, value) {
	      var data = _this.state.data;
	
	      switch (itemName) {
	        case 'projectName':
	          data.projectName = value.target.value;
	          break;
	        case 'type':
	          data.type = value;
	          break;
	        case 'role':
	          data.role = value;
	          break;
	        case 'projectUuid':
	          data.projectUuid = value;
	          break;
	        case 'tag':
	          data.tag = value;
	          break;
	        case 'endDate':
	          data.endDate = value ? value.valueOf() : '';
	          break;
	        case 'fettle':
	          data.fettle = value;
	          break;
	        default:
	          break;
	      }
	      _this.setState({ data: data });
	    };
	
	    _this.handleOk = function () {
	      var data = _this.state.data;
	
	      var newData = JSON.parse(JSON.stringify(data));
	      Object.keys(newData).forEach(function (key) {
	        if (newData[key] === 'all') {
	          newData[key] = '';
	        }
	      });
	      _this.props.handleOk(newData);
	    };
	
	    _this.resetParams = function () {
	      _this.setState({
	        data: {}
	      });
	    };
	
	    _this.state = {
	      data: {},
	      typeList: [{ value: 'all', name: '全部' }, { value: '0', name: '绩效考核' }, { value: '1', name: '政府申报' }, { value: '2', name: '日常任务' }],
	      roleList: [{ value: 'all', name: '全部' }, { value: 'EXECUTIVE', name: '执行人' }, { value: 'ASSISTANT', name: '协助者' }],
	      fettleList: [{ value: 'all', name: '全部' }, { value: '1', name: '已逾期' }, { value: '2', name: '进行中' }, { value: '3', name: '未开始' }]
	    };
	    return _this;
	  }
	
	  _createClass(CardAdvSearch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({
	        data: JSON.parse(JSON.stringify(data))
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (JSON.stringify(nextProps.data) !== JSON.stringify(this.props.data)) {
	        this.setState({
	          data: JSON.parse(JSON.stringify(nextProps.data))
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          typeList = _state.typeList,
	          roleList = _state.roleList,
	          fettleList = _state.fettleList;
	      var _props = this.props,
	          tagList = _props.tagList,
	          projectList = _props.projectList;
	
	      var ItemLayout = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 19 }
	      };
	      return _react2.default.createElement(
	        _antd.Card,
	        { style: this.props.style },
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u4EFB\u52A1\u5206\u7C7B' }),
	                _react2.default.createElement(
	                  _antd.Select,
	                  { value: data.type, onChange: function onChange() {
	                      return _this2.changeItem('type');
	                    } },
	                  typeList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { value: item.value, key: item.value },
	                      item.name
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u4EFB\u52A1\u72B6\u6001' }),
	                _react2.default.createElement(
	                  _antd.Select,
	                  { value: data.fettle, onChange: function onChange() {
	                      return _this2.changeItem('fettle');
	                    } },
	                  fettleList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.value, value: item.value },
	                      item.name
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u4EFB\u52A1\u6807\u7B7E' }),
	                _react2.default.createElement(
	                  _antd.Select,
	                  { value: data.tag, onChange: function onChange() {
	                      return _this2.changeItem('tag');
	                    } },
	                  tagList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.uuid, value: item.uuid },
	                      item.name
	                    );
	                  })
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u6211\u7684\u89D2\u8272' }),
	                _react2.default.createElement(
	                  _antd.Select,
	                  { value: data.role, onChange: function onChange() {
	                      return _this2.changeItem('role');
	                    } },
	                  roleList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.value, value: item.value },
	                      item.name
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u5F52\u5C5E\u9879\u76EE' }),
	                _react2.default.createElement(
	                  _antd.Select,
	                  { value: data.projectUuid, onChange: function onChange() {
	                      return _this2.changeItem('projectUuid');
	                    } },
	                  projectList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.uuid, value: item.uuid },
	                      item.name
	                    );
	                  })
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, ItemLayout, { label: '\u622A\u81F3\u65F6\u95F4' }),
	                data.endDate ? _react2.default.createElement(_antd.DatePicker, {
	                  style: { width: '100%' },
	                  value: (0, _moment2.default)(data.endDate),
	                  onChange: function onChange() {
	                    return _this2.changeItem('endDate');
	                  }
	                }) : _react2.default.createElement(_antd.DatePicker, {
	                  style: { width: '100%' },
	                  onChange: function onChange() {
	                    return _this2.changeItem('endDate');
	                  }
	                })
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { style: { display: 'flex', justifyContent: 'center' } },
	            _react2.default.createElement(
	              _antd.Button,
	              { onClick: this.handleOk, type: 'primary' },
	              '\u786E\u5B9A'
	            ),
	            _react2.default.createElement(
	              _antd.Button,
	              { onClick: this.resetParams, style: { marginLeft: '10px' } },
	              '\u91CD\u7F6E'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return CardAdvSearch;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(CardAdvSearch);

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _task = __webpack_require__(66);
	
	var _user = __webpack_require__(54);
	
	var _attachment = __webpack_require__(27);
	
	var _BackBtn = __webpack_require__(12);
	
	var _TagsInput = __webpack_require__(426);
	
	var _TagsInput2 = _interopRequireDefault(_TagsInput);
	
	var _back_info = __webpack_require__(19);
	
	var _back_info_standby = __webpack_require__(327);
	
	var _workOrg = __webpack_require__(191);
	
	var _TableFilesAddDel = __webpack_require__(725);
	
	var _TableFilesAddDel2 = _interopRequireDefault(_TableFilesAddDel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var RangePicker = _antd.DatePicker.RangePicker;
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.loadWorkOrgs = function () {
	      (0, _workOrg.queryWorkOrg)({ orgUuid: '' }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            workOrgs: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadAccountList = function () {
	      (0, _user.queryAccountList)().then(function (res) {
	        if (res.statusCode === 200) {
	          var newList = [];
	          res.data.map(function (item) {
	            newList.push({
	              userName: item.name,
	              userUuid: item.uuid
	            });
	            return item;
	          });
	          _this.setState({
	            accountList: newList
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getProjInfo = function (uuid) {
	      (0, _task.queryProjInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          var _res$data = res.data,
	              administrators = _res$data.administrators,
	              reviewers = _res$data.reviewers,
	              viewables = _res$data.viewables,
	              type = _res$data.type,
	              workorgName = _res$data.workorgName,
	              workorgUuid = _res$data.workorgUuid;
	
	          // 设置人员列表（去除uuid 及设置默认值）
	
	          var reviewersValue = [];
	          administrators.map(function (item) {
	            delete item.uuid;
	            return uuid;
	          });
	          reviewers.map(function (item) {
	            delete item.uuid;
	            reviewersValue.push(item.userUuid);
	            return item;
	          });
	          viewables.map(function (item) {
	            delete item.uuid;
	            return uuid;
	          });
	          _this.setState({
	            projInfo: res.data,
	            reviewers: reviewers,
	            viewables: viewables
	          });
	
	          _this.props.form.setFieldsValue({
	            reviewers: reviewersValue,
	            workorgUuid: workorgUuid,
	            workorgName: workorgName,
	            type: '' + type
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadData = function (uuid) {
	      var setFieldsValue = _this.props.form.setFieldsValue;
	
	      (0, _task.queryTaskInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          var _res$data2 = res.data,
	              tags = _res$data2.tags,
	              executives = _res$data2.executives,
	              reviewers = _res$data2.reviewers,
	              assistants = _res$data2.assistants,
	              taskFiles = _res$data2.taskFiles,
	              workorgName = _res$data2.workorgName,
	              workorgUuid = _res$data2.workorgUuid,
	              type = _res$data2.type,
	              isReview = _res$data2.isReview;
	
	          var newTags = [];
	          var assistantsValue = [];
	          var reviewersValue = [];
	          // 设置附件模板
	          taskFiles && taskFiles.map(function (item) {
	            item.id = item.uuid;
	            return item;
	          });
	          // 设置标签
	          tags.map(function (item, index) {
	            newTags.push({
	              uid: index,
	              name: item
	            });
	            return item;
	          });
	          // 设置人员默认值
	          delete executives[0].uuid;
	          reviewers.map(function (item) {
	            delete item.uuid;
	            reviewersValue.push(item.userUuid);
	            return item;
	          });
	          assistants.map(function (item) {
	            delete item.uuid;
	            assistantsValue.push(item.userUuid);
	            return item;
	          });
	          _this.setState({
	            data: res.data,
	            tags: newTags,
	            executives: executives,
	            assistants: assistants,
	            reviewers: reviewers,
	            fileList: taskFiles,
	            isReview: isReview
	          });
	          setFieldsValue({
	            executives: executives[0].userUuid,
	            reviewers: reviewersValue,
	            assistants: assistantsValue,
	            workorgUuid: workorgUuid,
	            workorgName: workorgName,
	            type: '' + type
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadDirectoryList = function (uuid) {
	      var directoryUuid = _this.props.location.query.directoryUuid;
	
	      (0, _task.queryProjDirList)({
	        projectUuid: uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setDirList(res.data, []);
	          _this.setState({
	            directoryList: res.data || []
	          }, function () {
	            _this.findDirList(_this.state.directoryList, directoryUuid);
	          });
	        } else {
	          _antd.message.error(res.message, 2.5);
	        }
	      });
	    };
	
	    _this.setDirList = function (arr, parentValueArr) {
	      arr.map(function (item) {
	        item.value = item.uuid;
	        item.label = item.name;
	        item.valueArr = parentValueArr.concat([item.value]);
	        if (item.children) {
	          _this.setDirList(item.children, item.valueArr);
	        }
	        return item;
	      });
	    };
	
	    _this.findDirList = function (arr, uuid) {
	      var setFieldsValue = _this.props.form.setFieldsValue;
	
	      arr.map(function (item) {
	        if (uuid === item.uuid) {
	          setFieldsValue({
	            directoryUuid: item.valueArr
	          });
	        } else if (item.children) {
	          _this.findDirList(item.children, uuid);
	        }
	        return item;
	      });
	    };
	
	    _this.changeDir = function (value, option) {
	      _this.setState({
	        newDirectoryUuid: option[option.length - 1].uuid,
	        newDirectoryName: option[option.length - 1].name
	      });
	    };
	
	    _this.saveProj = function (status) {
	      var _this$state = _this.state,
	          data = _this$state.data,
	          tags = _this$state.tags,
	          isReview = _this$state.isReview,
	          pageType = _this$state.pageType,
	          fileList = _this$state.fileList,
	          reviewers = _this$state.reviewers,
	          executives = _this$state.executives,
	          assistants = _this$state.assistants,
	          newDirectoryUuid = _this$state.newDirectoryUuid,
	          newDirectoryName = _this$state.newDirectoryName;
	      var _this$props$location$ = _this.props.location.query,
	          projectUuid = _this$props$location$.projectUuid,
	          projectName = _this$props$location$.projectName,
	          directoryUuid = _this$props$location$.directoryUuid,
	          directoryName = _this$props$location$.directoryName;
	
	
	      var params = Object.assign({}, data, _this.props.form.getFieldsValue());
	      var newFileList = [];
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          if (status === 1) {
	            _this.setState({
	              isReleaseloLoading: true
	            });
	          } else {
	            _this.setState({
	              isSaveloLoading: true
	            });
	          }
	
	          // 项目下任务设置项目uuid和目录uuid
	          if (pageType === 'PTA' || pageType === 'PTE') {
	            params.projectUuid = projectUuid;
	            params.projectName = projectName;
	            params.directoryUuid = newDirectoryUuid || directoryUuid;
	            params.directoryName = newDirectoryName || directoryName;
	          }
	
	          // 处理附件模板
	          fileList.map(function (item) {
	            if (values['name' + item.id] && values['files' + item.id]) {
	              newFileList.push({
	                name: values['name' + item.id],
	                files: values['files' + item.id]
	              });
	            }
	            delete params['name' + item.id];
	            delete params['files' + item.id];
	            return item;
	          });
	          params.taskFiles = newFileList;
	
	          // 设置标签
	          var newTags = [];
	          tags.map(function (item) {
	            newTags.push(item.name);
	            return item;
	          });
	          params.tags = newTags;
	          params.executives = executives;
	          params.reviewers = isReview ? reviewers : [];
	          params.assistants = assistants;
	          params.beginDate = values.date[0].format('YYYY-MM-DD');
	          params.endDate = values.date[1].format('YYYY-MM-DD');
	          params.status = status;
	          delete params.date;
	          (0, _task.querySaveTask)(params).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              _this.setBackPageInfo(status);
	              _this.props.router.go(-1);
	            } else {
	              _antd.message.error(res.message);
	            }
	
	            if (status === 1) {
	              _this.setState({
	                isReleaseloLoading: false
	              });
	            } else {
	              _this.setState({
	                isSaveloLoading: false
	              });
	            }
	          });
	          if (_this.state.delFiles.length > 0) {
	            _this.state.delFiles.map(function (item) {
	              (0, _attachment.queryDeleteAttachment)({
	                uuid: item.uuid
	              }).then(function (res) {});
	              return item;
	            });
	          }
	        }
	      });
	    };
	
	    _this.delProj = function () {
	      var taskUuid = _this.props.params.taskUuid;
	
	      (0, _task.queryDeleteTask)({ uuid: taskUuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.router.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.setBackPageInfo = function (status) {
	      var _this$state2 = _this.state,
	          pageType = _this$state2.pageType,
	          newDirectoryUuid = _this$state2.newDirectoryUuid,
	          newDirectoryName = _this$state2.newDirectoryName;
	      var _this$props = _this.props,
	          backInfo = _this$props.backInfo,
	          backInfoStandby = _this$props.backInfoStandby;
	      var _this$props$location$2 = _this.props.location.query,
	          projectUuid = _this$props$location$2.projectUuid,
	          directoryUuid = _this$props$location$2.directoryUuid,
	          directoryName = _this$props$location$2.directoryName;
	
	      if (backInfoStandby.path === '/task/project_detail_manage/' + projectUuid) {
	        var params = {};
	        params.path = backInfoStandby.path;
	        params.directoryUuid = newDirectoryUuid || directoryUuid;
	        params.directory = newDirectoryName || directoryName;
	        params.taskType = 'All';
	        params.tabKey = '1';
	        params.taskCurrent = 1;
	        _this.props.dispatch((0, _back_info_standby.setBackInfoStandby)(params));
	      }
	
	      if (backInfo.path === '/task/task_launch') {
	        var _params = {};
	        _params.path = backInfo.path;
	        _params.tabKey = status === 1 ? '1' : '3';
	        _params.status = status === 1 ? 'PUBLISH' : 'DRAFT';
	        _params.current = pageType === 'TA' ? 1 : backInfo.current;
	        _params.condition = pageType === 'TA' ? '' : backInfo.condition;
	        _this.props.dispatch((0, _back_info.setBackInfo)(_params));
	      }
	    };
	
	    _this.handleSetTags = function (tags) {
	      _this.setState({ tags: tags });
	    };
	
	    _this.handleWorkorgChange = function (value, option) {
	      _this.props.form.setFieldsValue({
	        workorgName: option.props.children
	      });
	    };
	
	    _this.changeExecutives = function (value, option) {
	      _this.setState({
	        executives: [{ userUuid: value, userName: option.props.children }]
	      });
	    };
	
	    _this.changeReviewers = function (value) {
	      var accountList = _this.state.accountList;
	
	      var reviewers = [];
	      value.map(function (item) {
	        accountList.map(function (it) {
	          if (it.userUuid === item) {
	            reviewers.push(it);
	          }
	          return it;
	        });
	        return item;
	      });
	
	      _this.setState({
	        reviewers: reviewers
	      });
	    };
	
	    _this.changeAssistants = function (value) {
	      var accountList = _this.state.accountList;
	
	      var assistants = [];
	      value.map(function (item) {
	        accountList.map(function (it) {
	          if (it.userUuid === item) {
	            assistants.push(it);
	          }
	          return it;
	        });
	        return item;
	      });
	
	      _this.setState({
	        assistants: assistants
	      });
	    };
	
	    _this.changeIsReview = function (e) {
	      var projInfo = _this.state.projInfo;
	
	      _this.setState({
	        isReview: e.target.value
	      }, function () {
	        if (projInfo.uuid) {
	          var reviewersValue = [];
	          projInfo.reviewers.map(function (item) {
	            reviewersValue.push(item.userUuid);
	            return item;
	          });
	          _this.props.form.setFieldsValue({
	            reviewers: reviewersValue
	          });
	        }
	      });
	    };
	
	    _this.addFiles = function () {
	      var _this$state3 = _this.state,
	          fileList = _this$state3.fileList,
	          fileCount = _this$state3.fileCount;
	
	      fileList.push({ id: fileCount });
	      _this.setState({
	        fileList: fileList,
	        fileCount: fileCount + 1
	      });
	    };
	
	    _this.deleteFiles = function (id) {
	      var fileList = _this.state.fileList;
	
	      _this.setState({
	        fileList: fileList.filter(function (item) {
	          return item.id !== id;
	        })
	      });
	    };
	
	    _this.fileRemove = function (file) {
	      var delFiles = _this.state.delFiles;
	
	      delFiles.push(file);
	      _this.setState({ delFiles: delFiles });
	    };
	
	    _this.disabledDate = function (current) {
	      var _this$state4 = _this.state,
	          pageType = _this$state4.pageType,
	          projInfo = _this$state4.projInfo;
	
	      if (pageType === 'PTA' || pageType === 'PTE') {
	        return current.valueOf() < projInfo.beginDate || current.valueOf() > projInfo.endDate;
	      }
	    };
	
	    _this.state = {
	      pageType: '',
	      projInfo: {},
	      data: {},
	      workOrgs: [],
	      accountList: [],
	      directoryList: [],
	      isReleaseloLoading: false,
	      typeList: [{
	        uuid: '0',
	        name: '绩效考核'
	      }, {
	        uuid: '1',
	        name: '政府申报'
	      }, {
	        uuid: '2',
	        name: '日常任务'
	      }],
	      tags: [],
	      executives: [],
	      reviewers: [],
	      viewables: [],
	      assistants: [],
	      isReview: 1,
	      fileList: [{ id: 0 }],
	      fileCount: 1,
	      delFiles: [],
	      newDirectoryUuid: '',
	      newDirectoryName: ''
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadWorkOrgs();
	      this.loadAccountList();
	      var path = this.props.route.path;
	      var projectUuid = this.props.location.query.projectUuid;
	      var taskUuid = this.props.params.taskUuid;
	
	      var pageType = '';
	      switch (path) {
	        case 'project_task_add':
	          pageType = 'PTA';
	          this.getProjInfo(projectUuid);
	          this.loadDirectoryList(projectUuid);
	          break;
	        case 'project_task_edit/:taskUuid':
	          pageType = 'PTE';
	          this.getProjInfo(projectUuid);
	          this.loadDirectoryList(projectUuid);
	          this.loadData(taskUuid);
	          break;
	        case 'task_add':
	          pageType = 'TA';
	          break;
	        case 'task_edit/:taskUuid':
	          pageType = 'TE';
	          this.loadData(taskUuid);
	          break;
	        default:
	          break;
	      }
	
	      this.setState({
	        pageType: pageType
	      });
	    }
	
	    // 获取业务部门列表
	
	
	    // 获取人员列表
	
	
	    // 获取项目信息
	
	
	    // 获取任务信息
	
	
	    /** ---------------------------------目录设置开始-------------------------------------*/
	    // 获取目录信息
	
	
	    // 设置目录列表
	
	
	    // 查找目录信息
	
	
	    // 改变目录
	
	
	    /** ---------------------------------目录设置结束-------------------------------------*/
	    // 保存
	
	
	    // 删除
	
	
	    // 根据情况设置返回页面的信息
	
	
	    // 设置项目类型
	
	
	    // 设置业务部门名称
	
	
	    // 设置任务执行人
	
	
	    // 设置任务审批人
	
	
	    // 设置任务协助人
	
	
	    // 设置任务是否需要审批
	
	
	    /** -------------------------------------设置附件模板列表开始--------------------------------*/
	    // 新增一行
	
	
	    // 删除该行
	
	
	    // 文件删除
	
	    /** -------------------------------------设置附件模板列表结束--------------------------------*/
	
	    // 不可选择的时间
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          tags = _state.tags,
	          pageType = _state.pageType,
	          workOrgs = _state.workOrgs,
	          viewables = _state.viewables,
	          typeList = _state.typeList,
	          isReview = _state.isReview,
	          fileList = _state.fileList,
	          isReleaseloLoading = _state.isReleaseloLoading,
	          isSaveloLoading = _state.isSaveloLoading,
	          accountList = _state.accountList,
	          reviewers = _state.reviewers,
	          directoryList = _state.directoryList;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var ItemLayout = {
	        labelCol: { span: 2 },
	        wrapperCol: { span: 16 }
	      };
	      var ItemLayout2 = {
	        labelCol: { span: 4 },
	        wrapperCol: { span: 16 }
	      };
	      var ItemLayout3 = {
	        labelCol: { span: 6 },
	        wrapperCol: { span: 17 }
	      };
	      getFieldDecorator('workorgName', {
	        initialValue: data.workorgName
	      });
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Form,
	          null,
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(_BackBtn.BackBtn, null),
	            _react2.default.createElement(
	              _antd.Button,
	              {
	                type: 'primary',
	                onClick: function onClick() {
	                  return _this2.saveProj(1);
	                },
	                loading: isReleaseloLoading,
	                icon: 'upload'
	              },
	              '\u53D1\u5E03'
	            ),
	            !data.status || data.status === 0 ? _react2.default.createElement(
	              _antd.Button,
	              {
	                type: 'primary',
	                style: { marginLeft: '10px' },
	                onClick: function onClick() {
	                  return _this2.saveProj(0);
	                },
	                loading: isSaveloLoading,
	                icon: 'snippets'
	              },
	              '\u4FDD\u5B58\u4E3A\u8349\u7A3F'
	            ) : null,
	            data.status === 0 ? _react2.default.createElement(
	              _antd.Button,
	              { style: { marginLeft: '10px' }, onClick: this.delProj, icon: 'delete' },
	              '\u5220\u9664'
	            ) : null
	          ),
	          _react2.default.createElement(
	            _antd.Card,
	            { style: { marginTop: '10px' } },
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u4EFB\u52A1\u540D\u79F0' }, ItemLayout),
	              getFieldDecorator('name', {
	                rules: [{ required: true, message: '请填写任务名称' }],
	                initialValue: data.name
	              })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u586B\u5199\u4EFB\u52A1\u540D\u79F0' }))
	            ),
	            _react2.default.createElement(
	              _antd.Row,
	              null,
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 8 },
	                _react2.default.createElement(
	                  _antd.Form.Item,
	                  Object.assign({ label: '\u4EFB\u52A1\u5468\u671F' }, ItemLayout3),
	                  data.uuid ? getFieldDecorator('date', {
	                    rules: [{ required: true, message: '请选择任务周期' }],
	                    initialValue: [(0, _moment2.default)(data.beginDate), (0, _moment2.default)(data.endDate)]
	                  })(_react2.default.createElement(RangePicker, { disabledDate: this.disabledDate })) : getFieldDecorator('date', {
	                    rules: [{ required: true, message: '请选择任务周期' }]
	                  })(_react2.default.createElement(RangePicker, { disabledDate: this.disabledDate, style: { width: '100%' } }))
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Col,
	                { span: 12 },
	                pageType === 'PTA' || pageType === 'PTE' ? _react2.default.createElement(
	                  _antd.Form.Item,
	                  Object.assign({ label: '\u6240\u5C5E\u76EE\u5F55' }, ItemLayout2),
	                  getFieldDecorator('directoryUuid', {
	                    rules: [{ required: true, message: '请选择任务所属目录' }]
	                  })(_react2.default.createElement(_antd.Cascader, { changeOnSelect: true, options: directoryList, onChange: this.changeDir }))
	                ) : ''
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u4EFB\u52A1\u6807\u7B7E' }, ItemLayout),
	              getFieldDecorator('tags')(_react2.default.createElement(_TagsInput2.default, { tags: tags, handleSetTags: this.handleSetTags }))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u4E1A\u52A1\u90E8\u95E8' }, ItemLayout),
	              getFieldDecorator('workorgUuid', {
	                rules: [{ required: true, message: '请选择业务部门' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: true,
	                  disabled: !!(pageType === 'PTA' || pageType === 'PTE'),
	                  filterOption: function filterOption(input, option) {
	                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  },
	                  onChange: this.handleWorkorgChange
	                },
	                workOrgs.map(function (item) {
	                  return _react2.default.createElement(
	                    _antd.Select.Option,
	                    { key: item.uuid },
	                    item.name
	                  );
	                })
	              ))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u4EFB\u52A1\u5206\u7C7B' }, ItemLayout),
	              getFieldDecorator('type', {
	                rules: [{ required: true, message: '请选择任务分类' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                { disabled: !!(pageType === 'PTA' || pageType === 'PTE') },
	                typeList.map(function (item) {
	                  return _react2.default.createElement(
	                    _antd.Select.Option,
	                    { key: item.uuid },
	                    item.name
	                  );
	                })
	              ))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              Object.assign({ label: '\u4EFB\u52A1\u76EE\u6807' }, ItemLayout),
	              getFieldDecorator('aim', {
	                initialValue: data.aim || null
	              })(_react2.default.createElement(_antd.InputNumber, { style: { width: '100%' } }))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              { label: '\u4EFB\u52A1\u63CF\u8FF0', labelCol: { span: 2 }, wrapperCol: { span: 16 } },
	              getFieldDecorator('remark', {
	                rules: [{ required: true, message: '请填写任务描述' }],
	                initialValue: data.remark
	              })(_react2.default.createElement(_antd.Input.TextArea, {
	                placeholder: '\u63CF\u8FF0',
	                type: 'textarea',
	                autosize: { minRows: 3, maxRows: 9 },
	                maxLength: 5000
	              })),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '12px', color: '#999' } },
	                '*\u6700\u591A\u53EF\u8F93\u51655000\u5B57'
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              { label: '\u9644\u4EF6\u6A21\u677F', labelCol: { span: 2 }, wrapperCol: { span: 16 } },
	              getFieldDecorator('fileTemplates')(_react2.default.createElement(_TableFilesAddDel2.default, Object.assign({
	                fileList: fileList,
	                addFiles: this.addFiles,
	                deleteFiles: this.deleteFiles,
	                fileRemove: this.fileRemove
	              }, this.props)))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              { label: '\u4EFB\u52A1\u6267\u884C\u65B9\u5F0F', labelCol: { span: 2 }, wrapperCol: { span: 16 } },
	              getFieldDecorator('isReview', {
	                initialValue: data.isReview === 0 ? 0 : 1
	              })(_react2.default.createElement(
	                _antd.Radio.Group,
	                { onChange: this.changeIsReview },
	                _react2.default.createElement(
	                  _antd.Radio,
	                  { value: 1 },
	                  '\u9700\u8981\u5BA1\u6279'
	                ),
	                _react2.default.createElement(
	                  _antd.Radio,
	                  { value: 0 },
	                  '\u65E0\u9700\u5BA1\u6279'
	                )
	              ))
	            ),
	            _react2.default.createElement(
	              _antd.Form.Item,
	              { label: '\u4EFB\u52A1\u6267\u884C\u4EBA', labelCol: { span: 2 }, wrapperCol: { span: 16 } },
	              getFieldDecorator('executives', {
	                rules: [{ required: true, message: '请选择管理员' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: true,
	                  filterOption: function filterOption(input, option) {
	                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  },
	                  onChange: this.changeExecutives
	                },
	                (pageType === 'PTA' || pageType === 'PTE' ? viewables : accountList).map(function (item) {
	                  return _react2.default.createElement(
	                    _antd.Select.Option,
	                    { key: item.userUuid },
	                    item.userName
	                  );
	                })
	              ))
	            ),
	            isReview ? _react2.default.createElement(
	              _antd.Form.Item,
	              { label: '\u4EFB\u52A1\u5BA1\u6279\u4EBA', labelCol: { span: 2 }, wrapperCol: { span: 16 } },
	              getFieldDecorator('reviewers', {
	                rules: [{ required: true, message: '请选择审批人' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: true,
	                  mode: 'multiple',
	                  disabled: !!(pageType === 'PTA' || pageType === 'PTE'),
	                  filterOption: function filterOption(input, option) {
	                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  },
	                  onChange: this.changeReviewers
	                },
	                (pageType === 'PTA' || pageType === 'PTE' ? reviewers : accountList).map(function (item) {
	                  return _react2.default.createElement(
	                    _antd.Select.Option,
	                    { key: item.userUuid },
	                    item.userName
	                  );
	                })
	              ))
	            ) : '',
	            _react2.default.createElement(
	              _antd.Form.Item,
	              { label: '\u4EFB\u52A1\u534F\u52A9\u4EBA', labelCol: { span: 2 }, wrapperCol: { span: 16 } },
	              getFieldDecorator('assistants')(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: true,
	                  mode: 'multiple',
	                  filterOption: function filterOption(input, option) {
	                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  },
	                  onChange: this.changeAssistants
	                },
	                (pageType === 'PTA' || pageType === 'PTE' ? viewables : accountList).map(function (item) {
	                  return _react2.default.createElement(
	                    _antd.Select.Option,
	                    { key: item.userUuid },
	                    item.userName
	                  );
	                })
	              ))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info,
	    backInfoStandby: state.back_info_standby
	  };
	})(_antd.Form.create()(Page));

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(5);
	
	var _task = __webpack_require__(66);
	
	var _back_info = __webpack_require__(19);
	
	var _TableTask = __webpack_require__(434);
	
	var _TableTask2 = _interopRequireDefault(_TableTask);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var FormItem = _antd.Form.Item;
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.loadData = function () {
	      var _this$state = _this.state,
	          status = _this$state.status,
	          current = _this$state.current,
	          condition = _this$state.condition;
	
	      var limit = 10;
	      _this.setState({
	        isLoading: true
	      });
	      (0, _task.queryTaskLauList)({
	        status: status,
	        start: current,
	        limit: limit,
	        name: condition
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              current: current,
	              pageSize: 10
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          isLoading: false
	        });
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            current: 1,
	            condition: values.name
	          }, function () {
	            _this.loadData();
	          });
	        }
	      });
	    };
	
	    _this.changeTabs = function (key) {
	      switch (key) {
	        case '1':
	          _this.setState({
	            status: 'PUBLISH',
	            tabKey: '1',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        case '2':
	          _this.setState({
	            status: 'FINISH',
	            tabKey: '2',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        case '3':
	          _this.setState({
	            status: 'DRAFT',
	            tabKey: '3',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.changeTable = function (pagination) {
	      _this.setState({
	        current: pagination.current
	      }, function () {
	        _this.loadData();
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        {
	          onSubmit: _this.handleSubmit,
	          style: {
	            position: 'absolute',
	            right: '10px',
	            top: '0',
	            display: 'flex',
	            zIndex: 100
	          }
	        },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('name', {
	            initialValue: condition
	          })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u4EFB\u52A1\u540D\u79F0' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit', style: { marginLeft: '10px' } },
	            '\u641C\u7D22'
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      status: 'PUBLISH',
	      tabKey: '1',
	      current: 1,
	      isLoading: false,
	      condition: '',
	      pagination: {
	        total: 10,
	        current: 1,
	        PageSize: 10
	      },
	      list: []
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        this.setState({
	          status: backInfo.status,
	          tabKey: backInfo.tabKey,
	          current: backInfo.current,
	          condition: backInfo.condition,
	          pagination: backInfo.pagination
	        }, function () {
	          _this2.loadData();
	        });
	      } else {
	        this.loadData();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          status = _state.status,
	          tabKey = _state.tabKey,
	          current = _state.current,
	          condition = _state.condition,
	          pagination = _state.pagination;
	
	      var params = {
	        path: this.props.location.pathname,
	        status: status,
	        tabKey: tabKey,
	        current: current,
	        condition: condition,
	        pagination: pagination
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 加载数据
	
	
	    // 搜索
	
	
	    // tab栏切换
	
	
	    // 列表改变
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          list = _state2.list,
	          tabKey = _state2.tabKey,
	          pagination = _state2.pagination,
	          isLoading = _state2.isLoading;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', style: { marginBottom: '10px' } },
	          _react2.default.createElement(
	            _reactRouter.Link,
	            { to: '/task/task_add' },
	            _react2.default.createElement(
	              _antd.Button,
	              { style: { marginRight: '10px' }, type: 'primary' },
	              '\u521B\u5EFA\u4EFB\u52A1'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { position: 'relative' } },
	          this.renderSearchForm(),
	          _react2.default.createElement(
	            _antd.Tabs,
	            { defaultActiveKey: '1', activeKey: tabKey, onChange: this.changeTabs },
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u53D1\u5E03\u4E2D', key: '1' },
	              _react2.default.createElement(_TableTask2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            ),
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u5DF2\u7ED3\u675F', key: '2' },
	              _react2.default.createElement(_TableTask2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                type2: 'finish',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            ),
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u8349\u7A3F\u7BB1', key: '3' },
	              _react2.default.createElement(_TableTask2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create()(Page));

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _task = __webpack_require__(66);
	
	var _back_info = __webpack_require__(19);
	
	var _TableTask = __webpack_require__(434);
	
	var _TableTask2 = _interopRequireDefault(_TableTask);
	
	var _CardAdvPubSearch = __webpack_require__(1754);
	
	var _CardAdvPubSearch2 = _interopRequireDefault(_CardAdvPubSearch);
	
	var _CardAdvFinSearch = __webpack_require__(1753);
	
	var _CardAdvFinSearch2 = _interopRequireDefault(_CardAdvFinSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	var Search = _antd.Input.Search;
	
	var FormItem = _antd.Form.Item;
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.loadData = function () {
	      var _this$state = _this.state,
	          status = _this$state.status,
	          current = _this$state.current,
	          condition = _this$state.condition;
	
	      var limit = 10;
	      _this.setState({
	        isLoading: true
	      });
	      (0, _task.queryTaskReceiveList)({
	        status: status,
	        start: current,
	        limit: limit,
	        name: condition
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              current: current,
	              pageSize: 10
	            },
	            isAdvSearch: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          isLoading: false
	        });
	      });
	    };
	
	    _this.advSearchData = function () {
	      var _this$state2 = _this.state,
	          status = _this$state2.status,
	          current = _this$state2.current,
	          pubSearchCondition = _this$state2.pubSearchCondition,
	          finSearchCondition = _this$state2.finSearchCondition;
	
	      var limit = 10;
	      _this.setState({
	        isLoading: true
	      });
	      var searchCondition = {};
	      status === 'PUBLISH' && (searchCondition = pubSearchCondition);
	      status === 'FINISH' && (searchCondition = finSearchCondition);
	      (0, _task.queryTaskSearchList)(Object.assign({
	        status: status,
	        start: current,
	        limit: limit
	      }, searchCondition, {
	        endDate: searchCondition.endDate ? (0, _moment2.default)(searchCondition.endDate).format('YYYY-MM-DD') : ''
	      })).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              current: current,
	              pageSize: 10
	            },
	            isAdvSearch: true
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          isLoading: false
	        });
	      });
	    };
	
	    _this.getTagList = function () {
	      (0, _task.queryTagList)().then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.unshift({
	            uuid: 'all',
	            name: '全部'
	          });
	          _this.setState({
	            tagList: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.getProjReceiveList = function () {
	      (0, _task.queryProjReceiveList)({}).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.unshift({
	            uuid: 'all',
	            name: '全部'
	          });
	          _this.setState({
	            projectList: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.changeCondition = function (e) {
	      _this.setState({
	        condition: e.target.value
	      });
	    };
	
	    _this.handleSubmit = function () {
	      _this.setState({ current: 1 }, function () {
	        _this.loadData();
	      });
	    };
	
	    _this.showAdvancedSearch = function (e) {
	      e.preventDefault();
	      var _this$state3 = _this.state,
	          status = _this$state3.status,
	          advPubSearchVisible = _this$state3.advPubSearchVisible,
	          advFinSearchVisible = _this$state3.advFinSearchVisible;
	
	      if (status === 'PUBLISH') {
	        _this.setState({
	          advPubSearchVisible: !advPubSearchVisible
	        });
	      } else if (status === 'FINISH') {
	        _this.setState({
	          advFinSearchVisible: !advFinSearchVisible
	        });
	      }
	    };
	
	    _this.handleOk = function (params) {
	      var status = _this.state.status;
	
	      if (status === 'PUBLISH') {
	        _this.setState({
	          current: 1,
	          pubSearchCondition: params
	        }, function () {
	          _this.advSearchData();
	        });
	      } else if (status === 'FINISH') {
	        _this.setState({
	          current: 1,
	          finSearchCondition: params
	        }, function () {
	          _this.advSearchData();
	        });
	      }
	    };
	
	    _this.changeTabs = function (key) {
	      var _this$state4 = _this.state,
	          pubSearchCondition = _this$state4.pubSearchCondition,
	          finSearchCondition = _this$state4.finSearchCondition;
	
	      switch (key) {
	        case '1':
	          _this.setState({
	            status: 'PUBLISH',
	            tabKey: '1',
	            current: 1
	          }, function () {
	            var flag = false;
	            Object.keys(pubSearchCondition).forEach(function (objectKey) {
	              flag = !!pubSearchCondition[objectKey];
	            });
	            flag ? _this.advSearchData() : _this.loadData();
	          });
	          break;
	        case '2':
	          _this.setState({
	            status: 'FINISH',
	            tabKey: '2',
	            current: 1
	          }, function () {
	            var flag = false;
	            Object.keys(finSearchCondition).forEach(function (objectKey) {
	              flag = !!finSearchCondition[objectKey];
	            });
	            flag ? _this.advSearchData() : _this.loadData();
	          });
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.changeTable = function (pagination) {
	      var isAdvSearch = _this.state.isAdvSearch;
	
	      _this.setState({ current: pagination.current }, function () {
	        isAdvSearch ? _this.advSearchData() : _this.loadData();
	      });
	    };
	
	    _this.renderSearchForm = function () {
	      var _this$state5 = _this.state,
	          status = _this$state5.status,
	          condition = _this$state5.condition,
	          advPubSearchVisible = _this$state5.advPubSearchVisible,
	          advFinSearchVisible = _this$state5.advFinSearchVisible;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        {
	          style: {
	            position: 'absolute',
	            right: '10px',
	            top: '0',
	            display: 'flex',
	            zIndex: 100
	          }
	        },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(Search, {
	            value: condition,
	            placeholder: '\u8BF7\u8F93\u5165\u4EFB\u52A1\u540D\u79F0',
	            onSearch: _this.handleSubmit,
	            onChange: _this.changeCondition
	          })
	        ),
	        _react2.default.createElement(
	          FormItem,
	          { style: { marginLeft: '10px' } },
	          _react2.default.createElement(
	            _antd.Button,
	            { onClick: _this.showAdvancedSearch },
	            '\u9AD8\u7EA7\u641C\u7D22',
	            _react2.default.createElement(
	              'span',
	              { style: { fontSize: '10px', paddingLeft: '10px' } },
	              status === 'PUBLISH' && advPubSearchVisible || status === 'FINISH' && advFinSearchVisible ? _react2.default.createElement(_antd.Icon, { type: 'up' }) : _react2.default.createElement(_antd.Icon, { type: 'down' })
	            )
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      list: [],
	      pagination: {
	        total: 10,
	        current: 1,
	        PageSize: 10
	      },
	
	      tabKey: '1',
	      current: 1,
	      condition: '',
	      status: 'PUBLISH',
	
	      tagList: [],
	      projectList: [],
	
	      pubSearchCondition: {},
	      finSearchCondition: {},
	
	      isLoading: false,
	      isAdvSearch: false,
	      advPubSearchVisible: false,
	      advFinSearchVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var backInfo = this.props.backInfo;
	
	      this.getTagList();
	      this.getProjReceiveList();
	      if (backInfo.path === this.props.location.pathname) {
	        this.setState({
	          status: backInfo.status,
	          tabKey: backInfo.tabKey,
	          current: backInfo.current,
	          condition: backInfo.condition,
	          pagination: backInfo.pagination,
	          isAdvSearch: backInfo.isAdvSearch,
	          pubSearchCondition: backInfo.pubSearchCondition,
	          finSearchCondition: backInfo.finSearchCondition,
	          advPubSearchVisible: backInfo.advPubSearchVisible,
	          advFinSearchVisible: backInfo.advFinSearchVisible
	        }, function () {
	          backInfo.isAdvSearch ? _this2.advSearchData() : _this2.loadData();
	        });
	      } else {
	        this.loadData();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          status = _state.status,
	          tabKey = _state.tabKey,
	          current = _state.current,
	          condition = _state.condition,
	          pagination = _state.pagination,
	          isAdvSearch = _state.isAdvSearch,
	          pubSearchCondition = _state.pubSearchCondition,
	          finSearchCondition = _state.finSearchCondition,
	          advPubSearchVisible = _state.advPubSearchVisible,
	          advFinSearchVisible = _state.advFinSearchVisible;
	
	      var params = {
	        path: this.props.location.pathname,
	        status: status,
	        tabKey: tabKey,
	        current: current,
	        condition: condition,
	        pagination: pagination,
	        isAdvSearch: isAdvSearch,
	        pubSearchCondition: pubSearchCondition,
	        finSearchCondition: finSearchCondition,
	        advPubSearchVisible: advPubSearchVisible,
	        advFinSearchVisible: advFinSearchVisible
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 加载数据
	
	
	    // 高级搜索的接口
	
	
	    /** ------------------------------------------------搜索及高级搜索start------------------------------------------------------------------------*/
	
	    // 高级搜索会用到的标签tag列表
	
	
	    // 高级搜索会用到的标签tag列表收到的项目
	
	
	    // 普通搜索
	
	
	    // 高级搜索
	
	
	    /** -----------------------------------------------搜索及高级搜索end------------------------------------------------------------------------*/
	
	    // tab栏切换
	
	
	    // 列表改变
	
	
	    // 搜索栏
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          list = _state2.list,
	          tabKey = _state2.tabKey,
	          isLoading = _state2.isLoading,
	          pagination = _state2.pagination,
	          status = _state2.status,
	          tagList = _state2.tagList,
	          projectList = _state2.projectList,
	          pubSearchCondition = _state2.pubSearchCondition,
	          finSearchCondition = _state2.finSearchCondition,
	          advPubSearchVisible = _state2.advPubSearchVisible,
	          advFinSearchVisible = _state2.advFinSearchVisible;
	
	      return _react2.default.createElement(
	        'div',
	        { style: { position: 'relative' } },
	        this.renderSearchForm(),
	        _react2.default.createElement(
	          _antd.Tabs,
	          { defaultActiveKey: '1', activeKey: tabKey, onChange: this.changeTabs },
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u53D1\u5E03\u4E2D', key: '1' },
	            _react2.default.createElement(_CardAdvPubSearch2.default, {
	              status: status,
	              data: pubSearchCondition,
	              tagList: tagList,
	              projectList: projectList,
	              handleOk: this.handleOk,
	              style: {
	                display: '' + (advPubSearchVisible ? 'block' : 'none')
	              }
	            }),
	            _react2.default.createElement(_TableTask2.default, Object.assign({
	              data: list,
	              type: 'receive',
	              isLoading: isLoading,
	              pagination: pagination,
	              loadData: this.loadData,
	              onChange: this.changeTable
	            }, this.props))
	          ),
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u5DF2\u7ED3\u675F', key: '2' },
	            _react2.default.createElement(_CardAdvFinSearch2.default, {
	              status: status,
	              data: finSearchCondition,
	              tagList: tagList,
	              projectList: projectList,
	              handleOk: this.handleOk,
	              style: {
	                display: '' + (advFinSearchVisible ? 'block' : 'none')
	              }
	            }),
	            _react2.default.createElement(_TableTask2.default, Object.assign({
	              data: list,
	              type: 'receive',
	              type2: 'finish',
	              isLoading: isLoading,
	              pagination: pagination,
	              loadData: this.loadData,
	              onChange: this.changeTable
	            }, this.props))
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create()(Page));

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _task = __webpack_require__(66);
	
	var _back_info = __webpack_require__(19);
	
	var _TableTask = __webpack_require__(434);
	
	var _TableTask2 = _interopRequireDefault(_TableTask);
	
	var _TreeOrg = __webpack_require__(723);
	
	var _TreeOrg2 = _interopRequireDefault(_TreeOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var FormItem = _antd.Form.Item;
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.loadData = function () {
	      var _this$state = _this.state,
	          status = _this$state.status,
	          current = _this$state.current,
	          condition = _this$state.condition,
	          workOrg = _this$state.workOrg,
	          workOrgUuid = _this$state.workOrgUuid;
	
	      var limit = 10;
	      _this.setState({
	        isLoading: true
	      });
	      (0, _task.queryTaskList)({
	        status: status,
	        start: current,
	        limit: limit,
	        name: condition,
	        workOrg: workOrg,
	        workOrgUuid: workOrgUuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            list: res.data,
	            pagination: {
	              total: res.totalSize,
	              current: current,
	              pageSize: 10
	            }
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	        _this.setState({
	          isLoading: false
	        });
	      });
	    };
	
	    _this.handleOrgSelect = function (value) {
	      _this.setState({
	        workOrgUuid: value.uuid,
	        workOrg: value.name
	      }, function () {
	        _this.loadData();
	      });
	    };
	
	    _this.handleSubmit = function (e) {
	      e.preventDefault();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          _this.setState({
	            current: 1,
	            condition: values.name
	          }, function () {
	            _this.loadData();
	          });
	        }
	      });
	    };
	
	    _this.changeTabs = function (key) {
	      switch (key) {
	        case '1':
	          _this.setState({
	            status: 'PUBLISH',
	            tabKey: '1',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        case '2':
	          _this.setState({
	            status: 'FINISH',
	            tabKey: '2',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        case '3':
	          _this.setState({
	            status: 'DRAFT',
	            tabKey: '3',
	            current: 1
	          }, function () {
	            _this.loadData();
	          });
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.changeTable = function (pagination) {
	      _this.setState({
	        current: pagination.current
	      }, function () {
	        _this.loadData();
	      });
	    };
	
	    _this.isFocusOn = function (record) {
	      record.isFocusOn = 1;
	    };
	
	    _this.renderSearchForm = function () {
	      var getFieldDecorator = _this.props.form.getFieldDecorator;
	      var condition = _this.state.condition;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        {
	          onSubmit: _this.handleSubmit,
	          style: {
	            position: 'absolute',
	            right: '10px',
	            top: '0',
	            display: 'flex',
	            zIndex: 100
	          }
	        },
	        _react2.default.createElement(
	          FormItem,
	          null,
	          getFieldDecorator('name', {
	            initialValue: condition
	          })(_react2.default.createElement(_antd.Input, { placeholder: '\u8BF7\u8F93\u5165\u4EFB\u52A1\u540D\u79F0' }))
	        ),
	        _react2.default.createElement(
	          FormItem,
	          null,
	          _react2.default.createElement(
	            _antd.Button,
	            { type: 'primary', htmlType: 'submit', style: { marginLeft: '10px' } },
	            '\u641C\u7D22'
	          )
	        )
	      );
	    };
	
	    _this.state = {
	      status: 'PUBLISH',
	      tabKey: '1',
	      current: 1,
	      isLoading: false,
	      condition: '',
	      pagination: {
	        total: 10,
	        current: 1,
	        PageSize: 10
	      },
	      list: [],
	      workOrg: '',
	      workOrgUuid: ''
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.location.pathname) {
	        this.setState({
	          workOrg: backInfo.workOrg,
	          workOrgUuid: backInfo.workOrgUuid,
	          status: backInfo.status,
	          tabKey: backInfo.tabKey,
	          current: backInfo.current,
	          condition: backInfo.condition
	        }, function () {
	          _this2.loadData();
	        });
	      } else {
	        this.loadData();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _state = this.state,
	          status = _state.status,
	          tabKey = _state.tabKey,
	          current = _state.current,
	          condition = _state.condition,
	          workOrg = _state.workOrg,
	          workOrgUuid = _state.workOrgUuid;
	
	      var params = {
	        path: this.props.location.pathname,
	        workOrg: workOrg,
	        workOrgUuid: workOrgUuid,
	        status: status,
	        tabKey: tabKey,
	        current: current,
	        condition: condition
	      };
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	
	    // 加载数据
	
	
	    // 组织树选中
	
	
	    // 搜索
	
	
	    // tab栏切换
	
	
	    // 列表改变
	
	
	    // 关注按钮
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state2 = this.state,
	          workOrg = _state2.workOrg,
	          workOrgUuid = _state2.workOrgUuid,
	          list = _state2.list,
	          tabKey = _state2.tabKey,
	          pagination = _state2.pagination,
	          isLoading = _state2.isLoading;
	
	      return _react2.default.createElement(
	        _antd.Row,
	        { gutter: 16 },
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 5 },
	          _react2.default.createElement(_TreeOrg2.default, { onSelect: this.handleOrgSelect, workOrg: workOrg, workOrgUuid: workOrgUuid })
	        ),
	        _react2.default.createElement(
	          _antd.Col,
	          { span: 19, style: { position: 'relative' } },
	          this.renderSearchForm(),
	          _react2.default.createElement(
	            _antd.Tabs,
	            { defaultActiveKey: '1', activeKey: tabKey, onChange: this.changeTabs },
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u53D1\u5E03\u4E2D', key: '1' },
	              _react2.default.createElement(_TableTask2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            ),
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u5DF2\u7ED3\u675F', key: '2' },
	              _react2.default.createElement(_TableTask2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                type2: 'finish',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            ),
	            _react2.default.createElement(
	              TabPane,
	              { tab: '\u8349\u7A3F\u7BB1', key: '3' },
	              _react2.default.createElement(_TableTask2.default, Object.assign({
	                data: list,
	                type: 'launch',
	                isLoading: isLoading,
	                pagination: pagination,
	                loadData: this.loadData,
	                onChange: this.changeTable
	              }, this.props))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create()(Page));

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var CardInfo = function (_Component) {
	  _inherits(CardInfo, _Component);
	
	  function CardInfo(props) {
	    _classCallCheck(this, CardInfo);
	
	    var _this = _possibleConstructorReturn(this, (CardInfo.__proto__ || Object.getPrototypeOf(CardInfo)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: '名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '附件',
	        dataIndex: 'uuid',
	        key: 'uuid',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            (record.files || []).map(function (item) {
	              return _react2.default.createElement(
	                'a',
	                {
	                  key: item.uuid,
	                  style: { display: 'block' },
	                  onClick: function onClick() {
	                    return (0, _attachment.queryFilePreview)(item);
	                  }
	                },
	                item.name
	              );
	            })
	          );
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CardInfo, [{
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 1 },
	          _react2.default.createElement(
	            Description,
	            { term: '\u5B8C\u6210\u65F6\u95F4' },
	            data.completionDate ? (0, _moment2.default)(data.completionDate).format('YYYY-MM-DD HH:mm:ss') : ''
	          )
	        ),
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 1 },
	          _react2.default.createElement(
	            Description,
	            { term: '\u5B8C\u6210\u5907\u6CE8' },
	            data.completionRemark
	          )
	        ),
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 1 },
	          _react2.default.createElement(
	            Description,
	            { term: '\u5B8C\u6210\u9644\u4EF6' },
	            _react2.default.createElement(_antd.Table, {
	              rowKey: 'uuid',
	              pagination: false,
	              columns: this.columns(),
	              dataSource: data.attachment
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CardInfo;
	}(_react.Component);
	
	exports.default = CardInfo;

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var CardInfo = function (_Component) {
	  _inherits(CardInfo, _Component);
	
	  function CardInfo(props) {
	    _classCallCheck(this, CardInfo);
	
	    var _this = _possibleConstructorReturn(this, (CardInfo.__proto__ || Object.getPrototypeOf(CardInfo)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: '名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '附件',
	        dataIndex: 'uuid',
	        key: 'uuid',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            (record.files || []).map(function (item) {
	              return _react2.default.createElement(
	                'a',
	                {
	                  key: item.uuid,
	                  style: { display: 'block' },
	                  onClick: function onClick() {
	                    return (0, _attachment.queryFilePreview)(item);
	                  }
	                },
	                item.name
	              );
	            })
	          );
	        }
	      }];
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CardInfo, [{
	    key: 'render',
	    value: function render() {
	      var data = this.props.data;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        null,
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 3 },
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u540D\u79F0' },
	            data.name
	          ),
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u5468\u671F' },
	            data.beginDate ? (0, _moment2.default)(data.beginDate).format('YYYY-MM-DD') : '',
	            '\u81F3',
	            data.endDate ? (0, _moment2.default)(data.endDate).format('YYYY-MM-DD') : '永久'
	          ),
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u5206\u7C7B' },
	            data.type === 0 ? _react2.default.createElement(
	              'span',
	              null,
	              '\u7EE9\u6548\u8003\u6838'
	            ) : '',
	            data.type === 1 ? _react2.default.createElement(
	              'span',
	              null,
	              '\u653F\u5E9C\u7533\u62A5'
	            ) : '',
	            data.type === 2 ? _react2.default.createElement(
	              'span',
	              null,
	              '\u65E5\u5E38\u4EFB\u52A1'
	            ) : ''
	          ),
	          _react2.default.createElement(
	            Description,
	            { term: '\u4E1A\u52A1\u90E8\u95E8' },
	            data.workorgName
	          ),
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u6807\u7B7E' },
	            (data.tags || []).map(function (item) {
	              return _react2.default.createElement(
	                _antd.Tag,
	                { key: item },
	                item
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(_antd.Divider, null),
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 2 },
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u6267\u884C\u65B9\u5F0F' },
	            data.isReview ? '需要审核' : '无需审核'
	          )
	        ),
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 3 },
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u8D1F\u8D23\u4EBA' },
	            data.executives ? data.executives[0].userName : ''
	          ),
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u534F\u52A9\u4EBA' },
	            (data.assistants || []).map(function (item) {
	              return _react2.default.createElement(
	                'span',
	                { key: item.uuid, style: { paddingLeft: '10px', paddingRight: '10px' } },
	                item.userName
	              );
	            })
	          ),
	          data.isReview ? _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u5BA1\u6279\u4EBA' },
	            (data.reviewers || []).map(function (item) {
	              return _react2.default.createElement(
	                'span',
	                { key: item.uuid, style: { paddingLeft: '10px', paddingRight: '10px' } },
	                item.userName
	              );
	            })
	          ) : null
	        ),
	        _react2.default.createElement(_antd.Divider, null),
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large' },
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u76EE\u6807', col: 1 },
	            data.aim
	          )
	        ),
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large' },
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u63CF\u8FF0', col: 1 },
	            data.remark
	          )
	        ),
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 1 },
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u6A21\u677F' },
	            _react2.default.createElement(_antd.Table, {
	              rowKey: 'uuid',
	              pagination: false,
	              columns: this.columns(),
	              dataSource: data.taskFiles
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return CardInfo;
	}(_react.Component);
	
	exports.default = CardInfo;

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _task = __webpack_require__(66);
	
	var _BackBtn = __webpack_require__(12);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _CardTaskInfo = __webpack_require__(1760);
	
	var _CardTaskInfo2 = _interopRequireDefault(_CardTaskInfo);
	
	var _CardCompInfo = __webpack_require__(1759);
	
	var _CardCompInfo2 = _interopRequireDefault(_CardCompInfo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var TabPane = _antd.Tabs.TabPane;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadInfo = function (uuid) {
	      (0, _task.queryTaskInfo)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            infoData: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadFiles = function (uuid) {
	      (0, _task.queryTaskFiles)({ uuid: uuid }).then(function (res) {
	        if (res.statusCode !== 200) {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.changeTabs = function (key) {
	      _this.setState({
	        tabKey: key
	      });
	    };
	
	    _this.toPageSubmit = function () {
	      var infoData = _this.state.infoData;
	
	      _this.props.router.push('/task/task_submit/' + infoData.uuid);
	    };
	
	    _this.toPageCheck = function () {
	      var infoData = _this.state.infoData;
	
	      _this.props.router.push('/task/task_check_detail/' + infoData.uuid);
	    };
	
	    _this.state = {
	      tabKey: '1',
	      infoData: {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.params.uuid;
	
	      this.loadInfo(uuid);
	    }
	
	    // 获取任务信息
	
	
	    // 获取任务附件
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          tabKey = _state.tabKey,
	          infoData = _state.infoData;
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Card,
	          { style: { marginBottom: '0' } },
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', justify: 'space-between', align: 'middle' },
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              _react2.default.createElement(_BackBtn.BackBtn, null),
	              _react2.default.createElement(
	                'span',
	                { style: { fontWeight: 'bolder', fontSize: '20px' } },
	                infoData.name
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              null,
	              _react2.default.createElement(_antd.Divider, { type: 'vertical', style: { height: '30px' } }),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '18px', paddingRight: '15px' } },
	                '\u4EFB\u52A1\u76EE\u6807 ',
	                infoData.aim || '-'
	              ),
	              _react2.default.createElement(_antd.Divider, { type: 'vertical', style: { height: '30px' } }),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '18px', paddingRight: '15px' } },
	                '\u5B9E\u9645\u7ED3\u679C ',
	                infoData.completionDate ? infoData.actual : '-'
	              ),
	              _react2.default.createElement(_antd.Divider, { type: 'vertical', style: { height: '30px' } }),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '18px', paddingRight: '15px' } },
	                infoData.instance && infoData.instance.status === 0 ? _react2.default.createElement(
	                  'span',
	                  null,
	                  _react2.default.createElement(_antd.Badge, { color: 'yellow' }),
	                  '\u5BA1\u6838\u4E2D'
	                ) : _react2.default.createElement(
	                  'span',
	                  null,
	                  infoData.status === 1 && infoData.fettle === 1 ? _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_antd.Badge, { color: 'red' }),
	                    '\u5DF2\u903E\u671F'
	                  ) : null,
	                  infoData.status === 1 && infoData.fettle === 2 ? _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_antd.Badge, { color: 'blue' }),
	                    '\u8FDB\u884C\u4E2D'
	                  ) : null,
	                  infoData.status === 1 && infoData.fettle === 3 ? _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_antd.Badge, { status: 'default' }),
	                    '\u672A\u5F00\u59CB'
	                  ) : null,
	                  infoData.status === 2 && infoData.fettle === 1 ? _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_antd.Badge, { color: 'red' }),
	                    '\u672A\u5B8C\u6210'
	                  ) : null,
	                  infoData.status === 2 && infoData.fettle === 2 ? _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_antd.Badge, { color: 'green' }),
	                    '\u5DF2\u5B8C\u6210'
	                  ) : null,
	                  infoData.status === 2 && infoData.fettle === 3 ? _react2.default.createElement(
	                    'span',
	                    null,
	                    _react2.default.createElement(_antd.Badge, { status: 'default' }),
	                    '\u5DF2\u5E9F\u5F03'
	                  ) : null
	                )
	              ),
	              infoData.status === 1 && this.props.userInfo.userUuid === infoData.executives[0].userUuid && !infoData.instance ? _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', style: { marginRight: '20px' }, onClick: this.toPageSubmit },
	                '\u63D0\u4EA4\u4EFB\u52A1\u7ED3\u679C'
	              ) : '',
	              infoData.instance && infoData.instance.status === 0 ? _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', style: { marginRight: '20px' }, onClick: this.toPageCheck },
	                '\u67E5\u770B\u5BA1\u6838\u6D41\u7A0B'
	              ) : ''
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Tabs,
	          { defaultActiveKey: '1', activeKey: tabKey, onChange: this.changeTabs },
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u4EFB\u52A1\u4FE1\u606F', key: '1' },
	            _react2.default.createElement(_CardTaskInfo2.default, { data: infoData })
	          ),
	          infoData.completionDate ? _react2.default.createElement(
	            TabPane,
	            { tab: '\u4EFB\u52A1\u7ED3\u679C', key: '2' },
	            _react2.default.createElement(_CardCompInfo2.default, { data: infoData })
	          ) : null,
	          _react2.default.createElement(
	            TabPane,
	            { tab: '\u4EFB\u52A1\u8BC4\u8BBA', key: '3' },
	            _react2.default.createElement(_Index2.default, { target: { type: 'taskInfo', uuid: infoData.uuid } })
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    userInfo: state.account_info
	  };
	})(Index);

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _DescriptionList = __webpack_require__(62);
	
	var _DescriptionList2 = _interopRequireDefault(_DescriptionList);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	__webpack_require__(313);
	
	var _attachment = __webpack_require__(27);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Description = _DescriptionList2.default.Description;
	
	var Open = function (_Component) {
	  _inherits(Open, _Component);
	
	  function Open(props) {
	    _classCallCheck(this, Open);
	
	    var _this = _possibleConstructorReturn(this, (Open.__proto__ || Object.getPrototypeOf(Open)).call(this, props));
	
	    _this.columns = function () {
	      return [{
	        title: '名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '附件',
	        dataIndex: 'uuid',
	        key: 'uuid',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'div',
	            null,
	            (record.files || []).map(function (item) {
	              return _react2.default.createElement(
	                'a',
	                {
	                  key: item.uuid,
	                  style: { display: 'block' },
	                  onClick: function onClick() {
	                    return (0, _attachment.queryFilePreview)(item);
	                  }
	                },
	                item.name
	              );
	            })
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      dataItem: _this.props.data
	    };
	    return _this;
	  }
	
	  _createClass(Open, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataItem: nextProps.data
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataItem = this.state.dataItem;
	
	      return _react2.default.createElement(
	        _antd.Card,
	        { title: '\u4EFB\u52A1\u7ED3\u679C' },
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 3 },
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u540D\u79F0' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/task/task_detail/' + dataItem.uuid },
	              dataItem.name
	            )
	          ),
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u5468\u671F' },
	            _moment2.default.unix(dataItem.beginDate / 1000).format('YYYY-MM-DD') + '\u81F3' + _moment2.default.unix(dataItem.endDate / 1000).format('YYYY-MM-DD')
	          ),
	          _react2.default.createElement(
	            Description,
	            { term: '\u6240\u5C5E\u9879\u76EE' },
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/task/project_detail/' + dataItem.projectUuid },
	              dataItem.projectName
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 1 },
	          _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u63CF\u8FF0' },
	            dataItem.remark
	          )
	        ),
	        _react2.default.createElement(_antd.Divider, null),
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 3 },
	          dataItem.aim ? _react2.default.createElement(
	            Description,
	            { term: '\u4EFB\u52A1\u76EE\u6807' },
	            dataItem.aim
	          ) : '',
	          dataItem.aim ? _react2.default.createElement(
	            Description,
	            { term: '\u5B9E\u9645\u6570\u636E' },
	            dataItem.actual
	          ) : '',
	          _react2.default.createElement(
	            Description,
	            { term: '\u5B8C\u6210\u72B6\u6001' },
	            dataItem.completionStatus === 2 ? '已完成' : '未完成'
	          )
	        ),
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 1 },
	          _react2.default.createElement(
	            Description,
	            { term: '\u7533\u8BF7\u6587\u4EF6' },
	            _react2.default.createElement(_antd.Table, {
	              rowKey: 'uuid',
	              pagination: false,
	              columns: this.columns(),
	              dataSource: dataItem.attachment
	            })
	          )
	        ),
	        _react2.default.createElement(
	          _DescriptionList2.default,
	          { size: 'large', col: 1 },
	          _react2.default.createElement(
	            Description,
	            { term: '\u7533\u8BF7\u8BF4\u660E' },
	            dataItem.completionRemark
	          )
	        ),
	        dataItem.completionRemark
	      );
	    }
	  }]);
	
	  return Open;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(Open);

/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _task = __webpack_require__(66);
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _PageSubmit = __webpack_require__(724);
	
	var _PageSubmit2 = _interopRequireDefault(_PageSubmit);
	
	var _PageOpen = __webpack_require__(1765);
	
	var _PageOpen2 = _interopRequireDefault(_PageOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 引入任务详情页
	
	
	var PageInfo = function (_Component) {
	  _inherits(PageInfo, _Component);
	
	  function PageInfo(props) {
	    _classCallCheck(this, PageInfo);
	
	    var _this = _possibleConstructorReturn(this, (PageInfo.__proto__ || Object.getPrototypeOf(PageInfo)).call(this, props));
	
	    _this.getTaskInfo = function () {
	      (0, _task.queryTaskInfo)({
	        uuid: _this.props.params.uuid
	      }).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.createUser = res.data.executives[0].userUuid;
	          _this.setState({
	            dataInfo: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      dataInfo: {}
	    };
	    return _this;
	  }
	
	  _createClass(PageInfo, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.userUuid = _localDb2.default.get('userUuid');
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.getTaskInfo();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataInfo = this.state.dataInfo;
	
	      if (dataInfo.uuid && !dataInfo.instance && this.userUuid === dataInfo.createUser) {
	        return _react2.default.createElement(_PageSubmit2.default, this.props);
	      }
	      if (dataInfo.uuid) {
	        return _react2.default.createElement(_PageOpen2.default, Object.assign({ data: dataInfo }, this.props));
	      }
	      return _react2.default.createElement('span', null);
	    }
	  }]);
	
	  return PageInfo;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    expendType: state.expend_type,
	    company: state.company_list
	  };
	})(PageInfo);

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _task = __webpack_require__(66);
	
	__webpack_require__(313);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _FormSearch = __webpack_require__(726);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableCheckTasks = __webpack_require__(727);
	
	var _TableCheckTasks2 = _interopRequireDefault(_TableCheckTasks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getTaskCheckMy = function (params) {
	      (0, _task.queryTaskCheckMy)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getTaskCheckMy(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.name && (this.searchCondition.name = backInfo.name);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        type: 'mine',
	        onChange: this.handleTableChange
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_antd.Col, { span: 5 }),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 19 },
	            _react2.default.createElement(_FormSearch2.default, Object.assign({
	              onChange: this.handleChange,
	              onSearch: this.handleSearch
	            }, this.searchCondition))
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableCheckTasks2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _task = __webpack_require__(66);
	
	var _Process = __webpack_require__(34);
	
	var _Process2 = _interopRequireDefault(_Process);
	
	var _ProcessHistory = __webpack_require__(51);
	
	var _ProcessHistory2 = _interopRequireDefault(_ProcessHistory);
	
	var _WorkflowOp = __webpack_require__(134);
	
	var _WorkflowOp2 = _interopRequireDefault(_WorkflowOp);
	
	var _Index = __webpack_require__(82);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _FormOpen = __webpack_require__(1762);
	
	var _FormOpen2 = _interopRequireDefault(_FormOpen);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Page = function (_Component) {
	  _inherits(Page, _Component);
	
	  function Page(props) {
	    _classCallCheck(this, Page);
	
	    var _this = _possibleConstructorReturn(this, (Page.__proto__ || Object.getPrototypeOf(Page)).call(this, props));
	
	    _this.doTask = function (pass, refuse) {
	      var dataInfo = _this.state.dataInfo;
	
	      var instance = dataInfo.instance || {};
	      var item = {
	        instanceUuid: instance.uuid
	      };
	      switch (pass) {
	        case 'callback':
	          _this.callbackTaskCheck(item);
	          break;
	        case 'next':
	          _this.nextTaskCheck(item);
	          break;
	        case 'return':
	          _this.returnTaskCheck(item, refuse);
	          break;
	        default:
	          break;
	      }
	    };
	
	    _this.callbackTaskCheck = function (params) {
	      (0, _task.queryCallbackTaskCheck)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.nextTaskCheck = function (params) {
	      _this.setState({ isLoading: true });
	      (0, _task.queryNextTaskCheck)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	          _this.setState({ isLoading: false });
	        } else {
	          _antd.message.error(res.message);
	          _this.setState({ isLoading: false });
	        }
	      });
	    };
	
	    _this.returnTaskCheck = function (params, refuse) {
	      (0, _task.queryReturnTaskCheck)(Object.assign({}, params, refuse)).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _reactRouter.browserHistory.go(-1);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleCancel = function () {};
	
	    _this.watchTask = function () {};
	
	    _this.columns = function () {
	      return [{
	        title: '日期',
	        dataIndex: 'date',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD HH:mm') : null
	          );
	        }
	      }, {
	        title: '操作内容',
	        dataIndex: 'operating'
	      }, {
	        title: '处理意见',
	        dataIndex: 'refuse'
	      }];
	    };
	
	    _this.state = {
	      dataInfo: {},
	      isLoading: false
	    };
	    return _this;
	  }
	
	  _createClass(Page, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.props.data;
	
	      this.setState({ dataInfo: data });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        dataInfo: nextProps.data
	      });
	    }
	
	    /**
	     * 处理流程
	     */
	
	
	    // 收回
	
	
	    // 通过
	
	
	    // 打回
	
	
	    /**
	     * 查看流程
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _state = this.state,
	          dataInfo = _state.dataInfo,
	          isLoading = _state.isLoading;
	
	      var instance = dataInfo.instance || {};
	      var histories = dataInfo.histories || [];
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_WorkflowOp2.default, {
	          data: dataInfo,
	          doTask: this.doTask,
	          watchTask: this.watchTask,
	          isLoading: isLoading
	        }),
	        _react2.default.createElement(_FormOpen2.default, Object.assign({ data: dataInfo, doTask: this.doTask, watchTask: this.watchTask }, this.props)),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u6D41\u7A0B\u8DDF\u8E2A' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'center' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24, style: { marginBottom: '16px', fontSize: '14px' } },
	              _react2.default.createElement(
	                'div',
	                { style: { marginBottom: '16px', fontSize: '14px' } },
	                '\u6D41\u7A0B\u8DEF\u5F84\uFF1A'
	              ),
	              _react2.default.createElement(_Process2.default, { instance: instance })
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_ProcessHistory2.default, { dataSource: histories })
	            )
	          )
	        ),
	        _react2.default.createElement(_Index2.default, { target: { type: 'taskInfo', uuid: dataInfo.uuid } })
	      );
	    }
	  }]);
	
	  return Page;
	}(_react.Component);
	
	exports.default = Page;

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _task = __webpack_require__(66);
	
	__webpack_require__(313);
	
	var _reactRedux = __webpack_require__(5);
	
	var _back_info = __webpack_require__(19);
	
	var _FormSearch = __webpack_require__(726);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _TableCheckTasks = __webpack_require__(727);
	
	var _TableCheckTasks2 = _interopRequireDefault(_TableCheckTasks);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Manage = function (_Component) {
	  _inherits(Manage, _Component);
	
	  function Manage(props) {
	    _classCallCheck(this, Manage);
	
	    var _this = _possibleConstructorReturn(this, (Manage.__proto__ || Object.getPrototypeOf(Manage)).call(this, props));
	
	    _this.setTableData = function (res) {
	      _this.setState({
	        dataSource: {
	          list: res.data,
	          pagination: {
	            total: res.totalSize,
	            pageSize: 15,
	            current: _this.current
	          }
	        }
	      });
	    };
	
	    _this.handleTableChange = function (pagination, filters, sorter) {
	      _this.pagination = {
	        limit: pagination.pageSize,
	        start: pagination.current
	      };
	      _this.current = pagination.current;
	      _this.loadData();
	    };
	
	    _this.handleSearch = function (params) {
	      _this.searchCondition = Object.assign({}, params);
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.handleChange = function (val) {
	      _this.type = val;
	      _this.current = 1;
	      _this.pagination = {
	        start: 1
	      };
	      _this.loadData();
	    };
	
	    _this.getTaskCheckList = function (params) {
	      (0, _task.queryTaskCheckList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setTableData(res);
	        }
	      });
	    };
	
	    _this.loadData = function () {
	      var params = Object.assign({}, _this.searchCondition, _this.pagination);
	      _this.getTaskCheckList(params);
	    };
	
	    _this.state = {
	      dataSource: {
	        list: [],
	        pagination: {}
	      }
	    };
	    return _this;
	  }
	
	  _createClass(Manage, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.type = '0';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.searchCondition = {};
	      var backInfo = this.props.backInfo;
	
	      if (backInfo.path === this.props.route.path) {
	        if (backInfo.start && backInfo.limit) {
	          this.current = backInfo.start;
	          this.pagination = {
	            limit: backInfo.limit,
	            start: backInfo.start
	          };
	        }
	        backInfo.name && (this.searchCondition.name = backInfo.name);
	      }
	      this.loadData();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var params = Object.assign({
	        path: this.props.route.path
	      }, this.searchCondition, this.pagination);
	      this.props.dispatch((0, _back_info.setBackInfo)(params));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var dataSource = this.state.dataSource;
	
	      var parentProps = {
	        dataSource: dataSource,
	        onChange: this.handleTableChange,
	        writeLoan: this.writeLoan
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_FormSearch2.default, Object.assign({
	            onChange: this.handleChange,
	            onSearch: this.handleSearch
	          }, this.searchCondition))
	        ),
	        _react2.default.createElement(
	          'div',
	          { id: 'ant-small-table' },
	          _react2.default.createElement(_TableCheckTasks2.default, parentProps)
	        )
	      );
	    }
	  }]);
	
	  return Manage;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    backInfo: state.back_info
	  };
	})(_antd.Form.create({ wrappedComponentRef: true })(Manage));

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.search = function (e) {
	      e.preventDefault();
	      var data = _this.props.form.getFieldsValue();
	      _this.props.search(data);
	    };
	
	    _this.reset = function (e) {
	      e.preventDefault();
	      _this.props.form.setFieldsValue({
	        no: undefined,
	        status: undefined,
	        type: undefined,
	        maturity: undefined
	      });
	      var data = _this.props.form.getFieldsValue();
	      _this.props.search(data);
	    };
	
	    _this.state = {
	      contract_type: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.contract_type !== nextProps.contract_type) {
	        this.setState({
	          contract_type: nextProps.contract_type
	        });
	      }
	    }
	
	    /**
	     * 合同搜索
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	      var contractType = this.state.contract_type;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { className: 'search-form', onSubmit: this.search },
	        _react2.default.createElement(
	          _antd.Row,
	          { justify: 'space-between', type: 'flex' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('no')(_react2.default.createElement(_antd.Input, { placeholder: '\u5408\u540C\u7F16\u53F7/\u6240\u5C5E\u4EBA\u59D3\u540D' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8FC7\u671F\u65F6\u95F4' }, formItemLayout),
	              getFieldDecorator('maturity')(_react2.default.createElement(_antd.DatePicker, { placeholder: '\u5230\u671F\u65F6\u95F4', style: { width: '100%' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u7C7B\u578B' }, formItemLayout),
	              getFieldDecorator('type')(_react2.default.createElement(
	                _antd.Select,
	                { placeholder: '\u5408\u540C\u7C7B\u578B' },
	                _react2.default.createElement(
	                  Option,
	                  { key: '-1' },
	                  '\u6240\u6709\u7C7B\u578B'
	                ),
	                contractType.map(function (item, index) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.value },
	                    item.key
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u72B6\u6001' }, formItemLayout),
	              getFieldDecorator('status')(_react2.default.createElement(
	                _antd.Select,
	                { placeholder: '\u72B6\u6001' },
	                _react2.default.createElement(
	                  Option,
	                  { value: '-1' },
	                  '\u5168\u90E8'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '0' },
	                  '\u672A\u4F7F\u7528'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '1' },
	                  '\u5DF2\u4F7F\u7528'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '2' },
	                  '\u9057\u5931'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '3' },
	                  '\u4F5C\u5E9F'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '4' },
	                  '\u5DF2\u5206\u914D'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '5' },
	                  '\u5F85\u5BA1\u6838'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '6' },
	                  '\u8F6C\u79FB\u4E2D'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              _react2.default.createElement(
	                _antd.Row,
	                { type: 'flex', justify: 'end' },
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary', htmlType: 'submit', style: { marginRight: '10px' } },
	                  '\u641C\u7D22'
	                ),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { onClick: this.reset, style: { marginRight: '10px' } },
	                  '\u91CD\u7F6E'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create()(Index));

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _contract = __webpack_require__(89);
	
	var _user = __webpack_require__(54);
	
	var _contract_type = __webpack_require__(435);
	
	var _ModalUse = __webpack_require__(1781);
	
	var _ModalUse2 = _interopRequireDefault(_ModalUse);
	
	var _ModalAdd = __webpack_require__(1769);
	
	var _ModalAdd2 = _interopRequireDefault(_ModalAdd);
	
	var _ModalAddGroup = __webpack_require__(1770);
	
	var _ModalAddGroup2 = _interopRequireDefault(_ModalAddGroup);
	
	var _ModalAllot = __webpack_require__(1772);
	
	var _ModalAllot2 = _interopRequireDefault(_ModalAllot);
	
	var _ModalApply = __webpack_require__(1774);
	
	var _ModalApply2 = _interopRequireDefault(_ModalApply);
	
	var _FormSearch = __webpack_require__(1767);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _ModalRecord = __webpack_require__(1778);
	
	var _ModalRecord2 = _interopRequireDefault(_ModalRecord);
	
	var _ModalAgree = __webpack_require__(1771);
	
	var _ModalAgree2 = _interopRequireDefault(_ModalAgree);
	
	var _ModalTip = __webpack_require__(1779);
	
	var _ModalTip2 = _interopRequireDefault(_ModalTip);
	
	var _ModalInvalid = __webpack_require__(1776);
	
	var _ModalInvalid2 = _interopRequireDefault(_ModalInvalid);
	
	var _ModalLost = __webpack_require__(1777);
	
	var _ModalLost2 = _interopRequireDefault(_ModalLost);
	
	var _ModalTransfer = __webpack_require__(1780);
	
	var _ModalTransfer2 = _interopRequireDefault(_ModalTransfer);
	
	var _ModalDealTransfer = __webpack_require__(1775);
	
	var _ModalDealTransfer2 = _interopRequireDefault(_ModalDealTransfer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { getAccountInfo } from "../../../store/modules/account_info";
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getAccountInfo = function () {
	      (0, _user.queryAccountInfo)().then(function (res) {});
	    };
	
	    _this.loadDate = function (pageNo, pageSize, no, maturity, status, type) {
	      var params = {};
	      var context = _this;
	      var statePageNo = _this.state.pageNo;
	      var current = pageNo || statePageNo;
	      params.limit = 15;
	      params.start = current;
	      params.no = no || _this.no;
	      params.maturity = maturity || _this.maturity;
	      params.type = type || _this.type;
	      if (!params.maturity) {
	        delete params.maturity;
	      }
	      _this.setState({
	        pageNo: current
	      });
	      params.status = status || _this.status;
	      if (params.status < 0) {
	        params.status = '';
	      }
	      if (params.type < 0) {
	        params.type = '';
	      }
	      (0, _contract.queryContractList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.map(function (item, index) {
	            item.type = _this.findContractType(item.type);
	            return item;
	          });
	          context.setState({
	            data: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.loadContractType = function () {
	      (0, _contract_type.getContractType)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({});
	        }
	      });
	    };
	
	    _this.search = function (condition) {
	      var type = parseInt(condition.type, 10) >= 0 ? condition.type : '';
	      var status = parseInt(condition.status, 10) >= 0 ? condition.status : '';
	      _this.no = condition.no ? condition.no : '';
	      _this.maturity = condition.maturity;
	      _this.status = status;
	      _this.type = type;
	      _this.loadDate(1, 15, condition.no, condition.maturity, condition.status, condition.type);
	    };
	
	    _this.invalidContract = function (params) {
	      params.uuids = _this.state.selectedRowKeys;
	      (0, _contract.queryInvalidContract)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	          _this.setState({
	            selectedRowKeys: []
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deleteContract = function () {
	      (0, _contract.queryDeleteContract)(_this.state.selectedRowKeys).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	          _this.setState({
	            selectedRowKeys: []
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.lostContract = function (params) {
	      params.uuids = _this.state.selectedRowKeys;
	      (0, _contract.queryLostContract)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	          _this.setState({
	            selectedRowKeys: []
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.restoreContract = function () {
	      (0, _contract.queryRestoreContract)(_this.state.selectedRowKeys).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	          _this.setState({
	            selectedRowKeys: []
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.recycleContract = function () {
	      (0, _contract.queryRecycleContract)(_this.state.selectedRowKeys).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	          _this.setState({
	            selectedRowKeys: []
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.useContract = function (params) {
	      params.uuid = _this.record.uuid;
	      // eslint-disable-next-line react-hooks/rules-of-hooks
	      (0, _contract.queryUseContract)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	      _this.setState({
	        selectedRowKeys: []
	      });
	    };
	
	    _this.allotContract = function (params) {
	      params.uuids = _this.state.selectedRowKeys;
	      (0, _contract.queryAllotContract)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	          _this.setState({
	            selectedRowKeys: []
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.transferContractConfirm = function (params) {
	      (0, _contract.queryTransferContractConfirm)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	      _this.setState({
	        selectedRowKeys: []
	      });
	    };
	
	    _this.transferContractRefuse = function (params) {
	      params.uuids = _this.state.selectedRowKeys;
	      (0, _contract.queryTransferContractRefuse)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	      _this.setState({
	        selectedRowKeys: []
	      });
	    };
	
	    _this.showUseModal = function (record) {
	      _this.record = record;
	      _this.setState({
	        useModalVisible: true
	      });
	    };
	
	    _this.showTransModal = function () {
	      var _this$state = _this.state,
	          selectedRowKeys = _this$state.selectedRowKeys,
	          data = _this$state.data;
	
	      var statusArr = [];
	      var canTransfer = false;
	      selectedRowKeys.map(function (item, index) {
	        data.map(function (item2) {
	          if (item2.uuid === item) {
	            statusArr.push(item2.status);
	          }
	          return statusArr;
	        });
	        return statusArr;
	      });
	      canTransfer = statusArr.some(function (item, index) {
	        return item === 4;
	      });
	      if (_this.state.selectedRowKeys.length < 1) {
	        _antd.message.warn('请先选择待处理的合同！');
	      } else if (!canTransfer) {
	        _antd.message.warn('合同不能转移！');
	      } else {
	        _this.setState({
	          transferVisible: true
	        });
	      }
	    };
	
	    _this.showTipModal1 = function () {
	      if (_this.state.selectedRowKeys.length < 1) {
	        _antd.message.warn('请先选择待处理的合同！');
	      } else {
	        _this.setState({
	          tipModalVisible1: true
	        });
	      }
	    };
	
	    _this.showTipModal2 = function () {
	      if (_this.state.selectedRowKeys.length < 1) {
	        _antd.message.warn('请先选择待作废的合同！');
	      } else {
	        _this.setState({
	          tipModalVisible2: true
	        });
	      }
	    };
	
	    _this.showTipModal3 = function () {
	      if (_this.state.selectedRowKeys.length < 1) {
	        _antd.message.warn('请先选择遗失的合同！');
	      } else {
	        _this.setState({
	          tipModalVisible3: true
	        });
	      }
	    };
	
	    _this.showTipModal4 = function () {
	      if (_this.state.selectedRowKeys.length < 1) {
	        _antd.message.warn('请先选择待处理的合同！');
	      } else {
	        _this.setState({
	          tipModalVisible4: true
	        });
	      }
	    };
	
	    _this.showTipModal5 = function () {
	      if (_this.state.selectedRowKeys.length < 1) {
	        _antd.message.warn('请先选择待处理的合同！');
	      } else {
	        _this.setState({
	          tipModalVisible5: true
	        });
	      }
	    };
	
	    _this.cancel = function () {
	      _this.setState({
	        useModalVisible: false,
	        addModalVisible: false,
	        addGroupVisible: false,
	        allotModalVisible: false,
	        applyModalVisible: false,
	        recordModalVisible: false,
	        agreeModalVisible: false,
	        tipModalVisible1: false,
	        tipModalVisible2: false,
	        tipModalVisible3: false,
	        tipModalVisible4: false,
	        tipModalVisible5: false,
	        transferVisible: false,
	        transferConfirmVisible: false,
	        transferRefuseVisible: false
	      });
	    };
	
	    _this.showAllotModal = function () {
	      if (_this.state.selectedRowKeys < 1) {
	        _antd.message.warn('请先选择待分配的合同！');
	      } else {
	        _this.setState({
	          allotModalVisible: true
	        });
	      }
	    };
	
	    _this.showAgreeModal = function (record, deal) {
	      _this.setState({
	        agreeModalVisible: true
	      });
	      _this.record = record;
	      _this.deal = deal;
	    };
	
	    _this.showConfirmTransferModal = function (record, deal) {
	      _this.setState({
	        transferConfirmVisible: true
	      });
	      _this.record = record;
	    };
	
	    _this.showRefuseTransferModal = function (record, deal) {
	      _this.setState({
	        transferRefuseVisible: true
	      });
	      _this.record = record;
	    };
	
	    _this.showModal = function (type, contractUuid) {
	      /* 1使用丨2添加丨3批量添加丨4分配丨5合同申请 丨6操作记录 丨7同意使用 丨8拒绝使用 */
	      if (type === 1) {
	        _this.setState({
	          useModalVisible: true
	        });
	      } else if (type === 2) {
	        _this.setState({
	          addModalVisible: true
	        });
	      } else if (type === 3) {
	        _this.setState({
	          addGroupVisible: true
	        });
	      } else if (type === 5) {
	        _this.setState({
	          applyModalVisible: true
	        });
	      } else if (type === 6) {
	        _this.setState({
	          recordModalVisible: true,
	          contractUuid: contractUuid
	        });
	      }
	    };
	
	    _this.onSelectChange = function (selectedRowKeys) {
	      _this.setState({
	        selectedRowKeys: selectedRowKeys
	      });
	    };
	
	    _this.findContractType = function (id) {
	      var list = _this.props.list;
	
	      var type = list.map(function (item, index) {
	        if (parseInt(item.value, 10) === parseInt(id, 10)) {
	          return item.key;
	        }
	        return type;
	      });
	      for (var i = 0; i < list.length; i++) {
	        if (parseInt(list[i].value, 10) === parseInt(id, 10)) {
	          return list[i].key;
	        }
	      }
	      return type;
	    };
	
	    _this.judge = function (accountInfo) {
	      var role = accountInfo.roles;
	      var permission = {};
	      role.map(function (sign, index) {
	        if (sign === '[XxSales]' || sign === '[XxSalesManager]') {
	          permission.search = true;
	          permission.use = true;
	          permission.transfer = true;
	          permission.apply = true;
	          permission.apply_list = true;
	        } else if (sign === '[FinanceMenber]') {
	          permission.all = true;
	          permission.transfer = false;
	        } else if (sign === '[XZManager]') {
	          permission.search = true;
	          permission.use = true;
	          permission.transfer = false;
	          permission.apply = true;
	          permission.apply_list = true;
	          permission.allot = true;
	          permission.invalid = true;
	          permission.lost = true;
	          permission.recover = true;
	          permission.recycle = true;
	          permission.export = true;
	        }
	        return permission;
	      });
	      if (accountInfo.admin) {
	        permission.all = true;
	        permission.transfer = true;
	      }
	      _this.setState({
	        permission: permission
	      });
	    };
	
	    _this.exportContract = function () {
	      var params = {};
	      params.no = _this.no;
	      if (params.maturity) {
	        params.maturity = _this.maturity;
	      }
	      params.status = _this.status;
	      params.type = _this.type;
	      (0, _contract.queryExportContract)(params);
	    };
	
	    _this.handSubmit = function () {
	      _this.loadDate();
	      _this.cancel();
	      _this.setState({
	        selectedRowKeys: []
	      });
	    };
	
	    _this.columns = function () {
	      var _this$state2 = _this.state,
	          permission = _this$state2.permission,
	          accountInfo = _this$state2.account_info;
	
	      return [{
	        title: '合同编号',
	        dataIndex: 'no',
	        key: 'no'
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        key: 'status',
	        render: function render(text, record) {
	          var status = '';
	          if (text === 0) {
	            status = '未使用';
	          } else if (text === 1) {
	            status = '已使用';
	          } else if (text === 2) {
	            status = '遗失';
	          } else if (text === 3) {
	            status = '作废';
	          } else if (text === 4) {
	            status = '已分配';
	          } else if (text === 5) {
	            status = '待审核';
	          } else if (text === 6) {
	            status = '转移中';
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            status
	          );
	        }
	      }, {
	        title: '合同类型',
	        dataIndex: 'type',
	        key: 'type',
	        render: function render(text, record) {
	          // let type = this.find_contract_type(text)
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }, {
	        title: '创建时间',
	        dataIndex: 'cdate',
	        key: 'cdate',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '到期时间',
	        dataIndex: 'maturityDate',
	        key: 'maturityDate',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '分配时间',
	        dataIndex: 'allocateDate',
	        key: 'allocateDate',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '所属人',
	        dataIndex: 'belonging',
	        key: 'belonging'
	      }, {
	        title: '订单编号',
	        dataIndex: 'orderNo',
	        key: 'orderNo'
	      }, {
	        title: '客户名称',
	        dataIndex: 'customName',
	        key: 'customName'
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              'a',
	              { onClick: function onClick() {
	                  return _this.showModal(6, record.uuid);
	                } },
	              '\u67E5\u770B'
	            ),
	            record.status === 4 && record.belongUser === accountInfo.userUuid ? _react2.default.createElement(
	              'span',
	              null,
	              '\u4E28',
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.showUseModal(record);
	                  } },
	                '\u4F7F\u7528'
	              )
	            ) : '',
	
	            // 是否同意使用合同的申请
	            record.status === 5 && permission.all ? _react2.default.createElement(
	              'span',
	              null,
	              '\u4E28',
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.showAgreeModal(record, 'agree');
	                  } },
	                '\u540C\u610F'
	              ),
	              '\u4E28',
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.showAgreeModal(record, 'refuse');
	                  } },
	                '\u62D2\u7EDD'
	              )
	            ) : '',
	
	            // 是否同意转移合同的申请
	            record.status === 6 && record.transferUser === accountInfo.userUuid ? _react2.default.createElement(
	              'span',
	              null,
	              '\u4E28',
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.showConfirmTransferModal(record);
	                  } },
	                '\u63A5\u6536'
	              ),
	              '\u4E28',
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.showRefuseTransferModal(record);
	                  } },
	                '\u62D2\u7EDD'
	              )
	            ) : ''
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      pageNo: 1,
	      useModalVisible: false,
	      addModalVisible: false,
	      addGroupVisible: false,
	      allotModalVisible: false,
	      recordModalVisible: false,
	      agreeModalVisible: false,
	      tipModalVisible1: false,
	      tipModalVisible2: false,
	      tipModalVisible3: false,
	      tipModalVisible4: false,
	      tipModalVisible5: false,
	      transferVisible: false,
	      total: 0,
	      selectedRowKeys: [],
	      account_info: _this.props.account_info || {},
	      permission: {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.maturity = '';
	      this.status = '';
	      this.type = '';
	      this.no = '';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dispatch = this.props.dispatch;
	
	      dispatch((0, _contract_type.getContractType)());
	      // dispatch(getAccountInfo());
	      this.loadDate(1, 15);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.setState({
	          account_info: nextProps.account_info
	        });
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    /**
	     * 获取用户信息
	     */
	
	
	    /**
	     * 作废所选合同
	     */
	
	
	    /**
	     * 删除选中合同
	     */
	
	
	    /**
	     * 遗失选中合同
	     */
	
	
	    /**
	     * 恢复合同
	     */
	
	
	    /**
	     * 回收合同
	     */
	
	
	    /**
	     * 使用合同
	     */
	
	
	    /**
	     * 分配合同
	     */
	
	
	    /**
	     * 转移合同确认
	     */
	
	
	    /**
	     * 转移合同拒绝
	     */
	
	
	    /**
	     * 显示使用合同弹窗
	     */
	
	
	    /**
	     * 显示转移框
	     */
	
	
	    /**
	     * 显示删除操作确认框
	     */
	
	
	    /**
	     * 显示作废操作确认框
	     */
	
	
	    /**
	     * 显示遗失操作确认框
	     */
	
	
	    /**
	     * 显示恢复操作确认框
	     */
	
	    /**
	     * 显示回收操作确认框
	     */
	
	    /**
	     * 依据角色判断权限
	     */
	
	
	    /**
	     * 导出合同
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total,
	          selectedRowKeys = _state.selectedRowKeys,
	          permission = _state.permission;
	
	      var pagination = {
	        total: total,
	        showSizeChanger: false,
	        pageSize: 15,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadDate(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      var rowSelection = {
	        selectedRowKeys: selectedRowKeys,
	        onChange: this.onSelectChange
	      };
	      var _state2 = this.state,
	          useModalVisible = _state2.useModalVisible,
	          agreeModalVisible = _state2.agreeModalVisible,
	          addModalVisible = _state2.addModalVisible,
	          allotModalVisible = _state2.allotModalVisible,
	          addGroupVisible = _state2.addGroupVisible,
	          applyModalVisible = _state2.applyModalVisible,
	          tipModalVisible1 = _state2.tipModalVisible1,
	          transferVisible = _state2.transferVisible,
	          recordModalVisible = _state2.recordModalVisible,
	          tipModalVisible2 = _state2.tipModalVisible2,
	          tipModalVisible3 = _state2.tipModalVisible3,
	          tipModalVisible4 = _state2.tipModalVisible4,
	          tipModalVisible5 = _state2.tipModalVisible5,
	          transferConfirmVisible = _state2.transferConfirmVisible,
	          transferRefuseVisible = _state2.transferRefuseVisible;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'fixed-box' },
	        _react2.default.createElement(
	          'div',
	          { className: 'fixed-header' },
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', className: 'btn-group' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 16 },
	              _react2.default.createElement(
	                'ul',
	                { className: 'table-menu' },
	                permission.add || permission.all ? _react2.default.createElement(
	                  'li',
	                  { onClick: function onClick() {
	                      return _this2.showModal(2);
	                    } },
	                  _react2.default.createElement(_antd.Icon, { type: 'addc' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u6DFB\u52A0'
	                  )
	                ) : '',
	                permission.adds || permission.all ? _react2.default.createElement(
	                  'li',
	                  { onClick: function onClick() {
	                      return _this2.showModal(3);
	                    } },
	                  _react2.default.createElement(_antd.Icon, { type: 'addcs' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u6279\u91CF\u6DFB\u52A0'
	                  )
	                ) : '',
	                permission.delete || permission.all ? _react2.default.createElement(
	                  'li',
	                  { onClick: this.showTipModal1 },
	                  _react2.default.createElement(_antd.Icon, { type: 'deletec' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u5220\u9664'
	                  )
	                ) : '',
	                permission.allot || permission.all ? _react2.default.createElement(
	                  'li',
	                  { onClick: this.showAllotModal },
	                  _react2.default.createElement(_antd.Icon, { type: 'allot' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u5206\u914D'
	                  )
	                ) : '',
	                permission.invalid || permission.all ? _react2.default.createElement(
	                  'li',
	                  { onClick: this.showTipModal2 },
	                  _react2.default.createElement(_antd.Icon, { type: 'cancel' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u4F5C\u5E9F'
	                  )
	                ) : '',
	                permission.lost || permission.all ? _react2.default.createElement(
	                  'li',
	                  { onClick: this.showTipModal3 },
	                  _react2.default.createElement(_antd.Icon, { type: 'lose' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u9057\u5931'
	                  )
	                ) : '',
	                permission.recover || permission.all ? _react2.default.createElement(
	                  'li',
	                  { onClick: this.showTipModal4 },
	                  _react2.default.createElement(_antd.Icon, { type: 'recover' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u6062\u590D'
	                  )
	                ) : '',
	                permission.recycle || permission.all ? _react2.default.createElement(
	                  'li',
	                  { onClick: this.showTipModal5 },
	                  _react2.default.createElement(_antd.Icon, { type: 'recycle' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u56DE\u6536'
	                  )
	                ) : '',
	                _react2.default.createElement(
	                  'li',
	                  { onClick: this.showTransModal },
	                  _react2.default.createElement(_antd.Icon, { type: 'transfer' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u8F6C\u79FB'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                _antd.Row,
	                { type: 'flex', justify: 'end', className: 'btn-group' },
	                permission.apply || permission.all ? _react2.default.createElement(
	                  _antd.Col,
	                  null,
	                  _react2.default.createElement(
	                    _antd.Button,
	                    { onClick: function onClick() {
	                        return _this2.showModal(5);
	                      } },
	                    '\u5408\u540C\u7533\u8BF7'
	                  )
	                ) : '',
	                _react2.default.createElement(
	                  _antd.Col,
	                  null,
	                  _react2.default.createElement(
	                    _reactRouter.Link,
	                    { to: '/xianxing/contract/apply' },
	                    _react2.default.createElement(
	                      _antd.Button,
	                      null,
	                      '\u7533\u8BF7\u5217\u8868'
	                    )
	                  )
	                ),
	                permission.export || permission.all ? _react2.default.createElement(
	                  _antd.Col,
	                  null,
	                  _react2.default.createElement(
	                    _antd.Button,
	                    { onClick: this.exportContract },
	                    '\u5BFC\u51FA'
	                  )
	                ) : ''
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'space-between', type: 'flex', style: { marginBottom: '16px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_FormSearch2.default, { search: this.search })
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: rowSelection,
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination,
	          style: { paddingTop: '120px' }
	        }),
	
	        // 合同使用弹窗
	        useModalVisible ? _react2.default.createElement(_ModalUse2.default, { cancel: this.cancel, handSubmit: this.useContract, record: this.record }) : '',
	
	        // 添加单个合同
	        addModalVisible ? _react2.default.createElement(_ModalAdd2.default, { cancel: this.cancel, loadDate: this.loadDate }) : '',
	
	        /* 合同批量添加 */
	        addGroupVisible ? _react2.default.createElement(_ModalAddGroup2.default, { cancel: this.cancel, loadDate: this.loadDate }) : '',
	
	        // 合同分配
	        allotModalVisible ? _react2.default.createElement(_ModalAllot2.default, { cancel: this.cancel, handSubmit: this.allotContract }) : '',
	
	        // 合同转移
	        transferVisible ? _react2.default.createElement(_ModalTransfer2.default, {
	          cancel: this.cancel,
	          handSubmit: this.handSubmit,
	          uuids: selectedRowKeys
	        }) : '',
	
	        // 接收转移的合同
	        transferConfirmVisible ? _react2.default.createElement(_ModalDealTransfer2.default, {
	          cancel: this.cancel,
	          handSubmit: this.handSubmit,
	          deal: 'confirm',
	          record: this.record
	        }) : '',
	
	        // 拒绝转移的合同
	        transferRefuseVisible ? _react2.default.createElement(_ModalDealTransfer2.default, {
	          cancel: this.cancel,
	          handSubmit: this.handSubmit,
	          deal: 'refuse',
	          record: this.record
	        }) : '',
	
	        // 申请合同
	        applyModalVisible ? _react2.default.createElement(_ModalApply2.default, { cancel: this.cancel, loadDate: this.loadDate }) : '',
	
	        // 同意合同使用申请
	        agreeModalVisible ? _react2.default.createElement(_ModalAgree2.default, {
	          cancel: this.cancel,
	          loadDate: this.loadDate,
	          deal: this.deal,
	          record: this.record
	        }) : '',
	
	        // 删除合同确认
	        tipModalVisible1 ? _react2.default.createElement(_ModalTip2.default, { cancel: this.cancel, handSubmit: this.deleteContract }) : '',
	
	        // 作废合同确认
	        tipModalVisible2 ? _react2.default.createElement(_ModalInvalid2.default, { cancel: this.cancel, handSubmit: this.invalidContract }) : '',
	
	        // 遗失合同
	        tipModalVisible3 ? _react2.default.createElement(_ModalLost2.default, { cancel: this.cancel, handSubmit: this.lostContract }) : '',
	
	        // 恢复合同
	        tipModalVisible4 ? _react2.default.createElement(_ModalTip2.default, { cancel: this.cancel, handSubmit: this.restoreContract }) : '',
	
	        // 回收合同
	        tipModalVisible5 ? _react2.default.createElement(_ModalTip2.default, { cancel: this.cancel, handSubmit: this.recycleContract }) : '',
	
	        // 合同操作日志
	        recordModalVisible ? _react2.default.createElement(_ModalRecord2.default, { cancel: this.cancel, contractUuid: this.state.contractUuid }) : ''
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    list: state.contract_type,
	    account_info: state.account_info
	  };
	})(Index);

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _contract = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          (0, _contract.querySaveContract)(data).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              _this.props.loadDate();
	              _this.props.cancel();
	            } else {
	              _antd.message.error(res.message);
	            }
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      contract_type: _this.props.contract_type
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var contractType = this.state.contract_type;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u6DFB\u52A0\u5408\u540C',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u7F16\u53F7' }, formItemLayout),
	              getFieldDecorator('no', {
	                rules: [{
	                  required: true,
	                  message: '合同编号不符合规则！',
	                  pattern: /(^LXCRM\d+$)|(^DSYDH\d+$)|([1-9]{2})(((0[13578]|1[02])(0[1-9]|[12]\d|3[01]))|((0[469]|11)(0[1-9]|[12]\d|30))|(02(0[1-9]|1\d|2\d)))\d{2,3}$/
	                }]
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u7C7B\u578B' }, formItemLayout),
	              getFieldDecorator('type', {
	                rules: [{ required: true, message: '合同类型不能为空！' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                contractType.map(function (item, index) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.value },
	                    item.key
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8FC7\u671F\u65F6\u95F4' }, formItemLayout),
	              getFieldDecorator('maturityDate', {
	                rules: [{ required: true, message: '过期时间不能为空！' }]
	              })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create()(Index));

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _contract = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      _this.props.form.validateFields(function (err, values) {
	        _this.setState({
	          is_adding: true
	        });
	        if (!err) {
	          (0, _contract.queryBatchSaveContract)(data).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              _this.props.loadDate();
	              _this.props.cancel();
	            } else {
	              _antd.message.error(res.message);
	              _this.setState({
	                is_adding: false
	              });
	            }
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      contract_type: _this.props.contract_type || [],
	      is_adding: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var _state = this.state,
	          contractType = _state.contract_type,
	          isAdding = _state.is_adding;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u6279\u91CF\u6DFB\u52A0\u5408\u540C',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          confirmLoading: isAdding,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u8D77\u59CB\u7F16\u53F7' }, formItemLayout),
	              getFieldDecorator('beginNo', {
	                rules: [{
	                  required: true,
	                  message: '合同起始编号不符合规则！',
	                  pattern: /(^LXCRM\d+$)|(^DSYDH\d+$)|([1-9]{2})(((0[13578]|1[02])(0[1-9]|[12]\d|3[01]))|((0[469]|11)(0[1-9]|[12]\d|30))|(02(0[1-9]|1\d|2\d)))\d{2,3}$/
	                }]
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u7ED3\u675F\u7F16\u53F7' }, formItemLayout),
	              getFieldDecorator('endNo', {
	                rules: [{
	                  required: true,
	                  message: '合同结束编号不符合规则！',
	                  pattern: /(^LXCRM\d+$)|(^DSYDH\d+$)|([1-9]{2})(((0[13578]|1[02])(0[1-9]|[12]\d|3[01]))|((0[469]|11)(0[1-9]|[12]\d|30))|(02(0[1-9]|1\d|2\d)))\d{2,3}$/
	                }]
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u7C7B\u578B' }, formItemLayout),
	              getFieldDecorator('type', {
	                rules: [{ required: true, message: '合同类型不能为空！' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                contractType.map(function (item, index) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.value },
	                    item.key
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u8FC7\u671F\u65F6\u95F4' }, formItemLayout),
	              getFieldDecorator('maturityDate', {
	                rules: [{ required: true, message: '合同过期时间不能为空！' }]
	              })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create()(Index));

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _contract = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      var record = _this.props.record;
	
	      data.uuid = record.uuid;
	      delete data.price;
	      _this.props.form.validateFields(function (err, values) {
	        if (!err) {
	          if (_this.props.deal === 'agree') {
	            _this.checkContract(data);
	          } else {
	            _this.refuseContract(data);
	          }
	        }
	      });
	    };
	
	    _this.checkContract = function (params) {
	      (0, _contract.queryCheckContract)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.cancel();
	          _this.props.loadDate();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.refuseContract = function (params) {
	      (0, _contract.queryRefuseContract)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.cancel();
	          _this.props.loadDate();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	
	    /**
	     * 同意使用合同
	     */
	
	
	    /**
	     * 拒绝使用合同
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancel = _props.cancel,
	          record = _props.record,
	          deal = _props.deal;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var titleStr = deal === 'agree' ? '合同使用同意' : '合同使用拒绝';
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: titleStr,
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u7F16\u53F7' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                record.no
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u6240\u5C5E\u4EBA' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                record.belonging
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8BA2\u5355\u7F16\u53F7' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                record.orderNo
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5BA2\u6237\u540D\u79F0' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                record.customName
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u91D1\u989D' }, formItemLayout),
	              getFieldDecorator('price', {
	                rules: [{ required: true, message: '合同金额不能为空！' }],
	                initialValue: record.price
	              })(_react2.default.createElement(_antd.Input, { type: 'number' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5BA1\u6279\u5907\u6CE8' }, formItemLayout),
	              getFieldDecorator('checkRemark', {
	                rules: [{ required: true, message: '审批备注不能为空！' }]
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Index);

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _user = __webpack_require__(54);
	
	var _SelectOrg = __webpack_require__(324);
	
	var _SelectOrg2 = _interopRequireDefault(_SelectOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      data.orgUuid = _this.state.orgUuid;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          _this.props.handSubmit(data);
	        }
	      });
	    };
	
	    _this.onChangeOrg = function (value) {
	      _this.setState({
	        orgUuid: value
	      });
	      _this.loadAccount(value);
	      _this.props.form.setFieldsValue({ userUuid: '' });
	    };
	
	    _this.loadAccount = function (orgUuid) {
	      var uuid = orgUuid || '';
	      (0, _user.queryAccountList)({ orgUuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            accountList: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      accountList: [],
	      orgUuid: ''
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadAccount();
	    }
	
	    /**
	     *获取用户列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var accountList = this.state.accountList;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var formItemLayout2 = {
	        labelCol: { span: 12 },
	        wrapperCol: { span: 11 }
	      };
	      var formItemLayout3 = {
	        labelCol: { span: 1 },
	        wrapperCol: { span: 22 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u5206\u914D\u5408\u540C',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 15 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, formItemLayout2, { label: '\u5206\u914D\u4EBA', style: { width: '100%' } }),
	                getFieldDecorator('orgUuid', {
	                  rules: [{ required: true, message: '部门不能为空！' }]
	                })(_react2.default.createElement(_SelectOrg2.default, { onChange: this.onChangeOrg, orgUuid: this.state.orgUuid }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, formItemLayout3, { style: { width: '100%' } }),
	                getFieldDecorator('userUuid', {
	                  rules: [{ required: true, message: '姓名不能为空！' }]
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { placeholder: '\u59D3\u540D' },
	                  accountList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.uuid },
	                      item.name
	                    );
	                  })
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout, { label: '\u5206\u914D\u539F\u56E0' }),
	              getFieldDecorator('remark', {
	                ules: [{ required: true, message: '分配原因不能为空！' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u521D\u6B21\u9886\u7528\u5206\u914D\u5408\u540C' },
	                  '\u521D\u6B21\u9886\u7528\u5206\u914D\u5408\u540C'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u7ECF\u7406\u5E26\u9886\u8C03\u914D\u5408\u540C' },
	                  '\u7ECF\u7406\u5E26\u9886\u8C03\u914D\u5408\u540C'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u9886\u7528\u548C\u901A\u8FC7\u591A\u7ED9\u4ED6\u4EBA' },
	                  '\u9886\u7528\u548C\u901A\u8FC7\u591A\u7ED9\u4ED6\u4EBA'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u5458\u5DE5\u79BB\u804C\u91CD\u65B0\u8C03\u914D' },
	                  '\u5458\u5DE5\u79BB\u804C\u91CD\u65B0\u8C03\u914D'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u5176\u5B83\u539F\u56E0' },
	                  '\u5176\u5B83\u539F\u56E0'
	                )
	              ))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Index);

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _contract = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.findContractType = function (id) {
	      var list = _this.props.list;
	
	      var type = list.map(function (item) {
	        if (parseInt(item.value, 10) === parseInt(id, 10)) {
	          return item.key;
	        }
	        return type;
	      });
	      for (var i = 0; i < list.length; i++) {
	        if (parseInt(list[i].value, 10) === parseInt(id, 10)) {
	          return list[i].key;
	        }
	      }
	      return type;
	    };
	
	    _this.loadDate = function (limit, type) {
	      var params = {};
	      var context = _this;
	      params.start = 0;
	      params.type = type;
	      params.status = 0;
	      params.limit = _this.props.record.number;
	      (0, _contract.queryContractList)(params).then(function (res) {
	        var selectedRowKeys = [];
	        if (res.statusCode === 200) {
	          res.data.map(function (item) {
	            item.type = _this.findContractType(item.type);
	            selectedRowKeys.push(item.uuid);
	            return selectedRowKeys;
	          });
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            selectedRowKeys: selectedRowKeys
	          });
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '合同编号',
	        dataIndex: 'no',
	        key: 'no',
	        width: 100
	      }, {
	        title: '合同类型',
	        dataIndex: 'type',
	        key: 'type',
	        width: 100
	      }];
	    };
	
	    _this.onSelectChange = function (selectedRowKeys) {
	      _this.setState({
	        selectedRowKeys: selectedRowKeys
	      });
	    };
	
	    _this.submit = function () {
	      var _this$props = _this.props,
	          record = _this$props.record,
	          cancel = _this$props.cancel,
	          loadDate = _this$props.loadDate;
	
	      var data = {};
	      data.uuid = record.uuid;
	      data.contractUuids = _this.state.selectedRowKeys;
	      if (data.contractUuids < 1) {
	        _antd.message.error('暂时没有可分配的合同！');
	        return;
	      }
	      (0, _contract.queryAllotApplyContract)(data).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          cancel();
	          loadDate();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      data: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var record = this.props.record;
	
	      this.loadDate(record.number, record.type);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancel = _props.cancel,
	          record = _props.record;
	      var data = this.state.data;
	
	      var type = this.findContractType(record.type);
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u5206\u914D\u5408\u540C',
	          width: 450,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 7 },
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u7533\u8BF7\u4EBA:',
	              record.userName
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 7 },
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u7533\u8BF7\u4EFD\u6570:',
	              record.number
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 10 },
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u5408\u540C\u7C7B\u578B:',
	              type
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            'p',
	            { style: { padding: '20px 0 5px 0' } },
	            '\u5F85\u5206\u914D\u5408\u540C\u4FE1\u606F'
	          ),
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            dataSource: data,
	            pagination: false,
	            bordered: true,
	            rowKey: 'uuid',
	            scroll: { y: 300 }
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { list: state.contract_type };
	})(Index);

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _contract = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      var accountInfo = _this.state.account_info;
	
	      data.orgUuid = accountInfo.orgUuid;
	      data.userUuid = accountInfo.userUuid;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          if (data.number > 10) {
	            _antd.message.error('最多只能申请10份合同！');
	            return;
	          }
	          (0, _contract.querySaveApplyContract)(data).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              _this.props.cancel();
	              _this.props.loadDate();
	            } else {
	              _antd.message.error(res.message);
	            }
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      contract_type: _this.props.contract_type,
	      account_info: _this.props.account_info || {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var _state = this.state,
	          contractType = _state.contract_type,
	          accountInfo = _state.account_info;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u5408\u540C\u7533\u8BF7',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout, { label: '\u90E8\u95E8' }),
	              _react2.default.createElement(
	                'p',
	                null,
	                accountInfo.orgName
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout, { label: '\u59D3\u540D' }),
	              _react2.default.createElement(
	                'p',
	                null,
	                accountInfo.userName
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout, { label: '\u5408\u540C\u7C7B\u578B' }),
	              getFieldDecorator('type', {
	                rules: [{ required: true, message: '合同类型不能为空！' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                contractType.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.value },
	                    item.key
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout, { label: '\u5408\u540C\u4EFD\u6570' }),
	              getFieldDecorator('number', {
	                rules: [{ required: true, message: '合同份数不能为空！' }]
	              })(_react2.default.createElement(_antd.Input, { type: 'number' }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create()(Index));

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _contract = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      var _this$props = _this.props,
	          record = _this$props.record,
	          deal = _this$props.deal;
	
	      data.uuid = record.uuid;
	      _this.props.form.validateFields(function () {
	        if (deal === 'confirm') {
	          _this.transferContractConfirm(data);
	        } else {
	          _this.transferContractRefuse(data);
	        }
	      });
	    };
	
	    _this.transferContractConfirm = function (params) {
	      (0, _contract.queryTransferContractConfirm)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.handSubmit();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.transferContractRefuse = function (params) {
	      (0, _contract.queryTransferContractRefuse)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.handSubmit();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	
	    /**
	     * 转移合同确认
	     */
	
	
	    /**
	     * 转移合同拒绝
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancel = _props.cancel,
	          record = _props.record,
	          deal = _props.deal;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var title = deal === 'confirm' ? '接收合同' : '拒绝合同';
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: title,
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8F6C\u79FB\u4EBA' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                record.belonging
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8F6C\u79FB\u4E8B\u7531' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                record.transferRemark
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout, { label: '\u5907\u6CE8' }),
	              getFieldDecorator('transferResultRemark')(_react2.default.createElement(_antd.Input.TextArea, {
	                type: 'textarea',
	                size: 'large',
	                autosize: { minRows: 2 },
	                style: { marginLeft: '5px' },
	                maxLength: 1000
	              })),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '12px', color: '#999' } },
	                '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Index);

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          _this.props.handSubmit(data);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadOrg();
	      this.loadAccount();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u4F5C\u5E9F\u5408\u540C',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout, { label: '\u4F5C\u5E9F\u539F\u56E0' }),
	              getFieldDecorator('remark', {
	                rules: [{ required: true, message: '作废原因不能为空！' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u5408\u540C\u586B\u5199\u6709\u8BEF' },
	                  '\u5408\u540C\u586B\u5199\u6709\u8BEF'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u5BA2\u6237\u66F4\u6362\u7248\u672C\u539F\u5408\u540C\u4F5C\u5E9F' },
	                  '\u5BA2\u6237\u66F4\u6362\u7248\u672C\u539F\u5408\u540C\u4F5C\u5E9F'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u5408\u540C\u8FC7\u671F\u6536\u56DE\u4F5C\u5E9F' },
	                  '\u5408\u540C\u8FC7\u671F\u6536\u56DE\u4F5C\u5E9F'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u9000\u5355\u9000\u6B3E\u4E0D\u5408\u4F5C\u5408\u540C\u9000\u56DE' },
	                  '\u9000\u5355\u9000\u6B3E\u4E0D\u5408\u4F5C\u5408\u540C\u9000\u56DE'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u7B7E\u7EA6\u540E\u8FDD\u7EA6' },
	                  '\u7B7E\u7EA6\u540E\u8FDD\u7EA6'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u5176\u5B83\u539F\u56E0' },
	                  '\u5176\u5B83\u539F\u56E0'
	                )
	              ))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Index);

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          _this.props.handSubmit(data);
	        }
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadOrg();
	      this.loadAccount();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u9057\u5931\u5408\u540C',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout, { label: '\u9057\u5931\u539F\u56E0' }),
	              getFieldDecorator('remark', {
	                rules: [{ required: true, message: '遗失原因不能为空！' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u9500\u552E\u4FDD\u7BA1\u4E0D\u5584\u9057\u5931' },
	                  '\u9500\u552E\u4FDD\u7BA1\u4E0D\u5584\u9057\u5931'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '\u5BA2\u6237\u4FDD\u7BA1\u4E0D\u5584\u9057\u5931' },
	                  '\u5BA2\u6237\u4FDD\u7BA1\u4E0D\u5584\u9057\u5931'
	                )
	              ))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Index);

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _contract = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadLog = function (uuid) {
	      (0, _contract.queryContractLog)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            log: res.data
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      log: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadLog(this.props.contractUuid);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var log = this.state.log;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u5408\u540C\u64CD\u4F5C\u8BB0\u5F55',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          footer: false,
	          maskClosable: false
	        },
	        log.length > 0 ? _react2.default.createElement(
	          _antd.Timeline,
	          null,
	          log.map(function (item) {
	            return _react2.default.createElement(
	              _antd.Timeline.Item,
	              { key: item.uuid },
	              _moment2.default.unix(item.cdate / 1000).format('YYYY-MM-DD H:mm:ss'),
	              ' ',
	              item.operator,
	              ' ',
	              item.action
	            );
	          })
	        ) : _react2.default.createElement(
	          'p',
	          { style: { textAlign: 'center', lineHeight: '30px' } },
	          '\u6682\u65E0\u64CD\u4F5C\u8BB0\u5F55'
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u63D0\u793A',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.props.handSubmit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          '\u786E\u8BA4\u5BF9\u6240\u9009\u5408\u540C\u8FDB\u884C\u8BE5\u64CD\u4F5C\u5417\uFF1F'
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Index);

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _contract = __webpack_require__(89);
	
	var _user = __webpack_require__(54);
	
	var _SelectOrg = __webpack_require__(324);
	
	var _SelectOrg2 = _interopRequireDefault(_SelectOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      data.orgUuid = _this.state.orgUuid;
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          _this.transferContract(data);
	        }
	      });
	    };
	
	    _this.transferContract = function (params) {
	      params.uuids = _this.props.uuids;
	      (0, _contract.queryTransferContract)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.props.handSubmit();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.onChangeOrg = function (value) {
	      _this.setState({
	        orgUuid: value
	      });
	      _this.loadAccount(value);
	      _this.props.form.setFieldsValue({ userUuid: '' });
	    };
	
	    _this.loadAccount = function (orgUuid) {
	      var uuid = orgUuid || '';
	      (0, _user.queryAccountList)({ orgUuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            accountList: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      accountList: [],
	      orgUuid: ''
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadAccount();
	    }
	
	    /**
	     * 转移合同
	     */
	
	
	    /**
	     *获取用户列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var accountList = this.state.accountList;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout2 = {
	        labelCol: { span: 12 },
	        wrapperCol: { span: 11 }
	      };
	      var formItemLayout3 = {
	        labelCol: { span: 1 },
	        wrapperCol: { span: 22 }
	      };
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u8F6C\u79FB\u5408\u540C',
	          width: 500,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 15 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, formItemLayout2, { label: '\u63A5\u6536\u4EBA', style: { width: '100%' } }),
	                getFieldDecorator('orgUuid', {
	                  rules: [{ required: true, message: '部门不能为空！' }]
	                })(_react2.default.createElement(_SelectOrg2.default, { onChange: this.onChangeOrg, orgUuid: this.state.orgUuid }))
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 7 },
	              _react2.default.createElement(
	                FormItem,
	                Object.assign({}, formItemLayout3, { style: { width: '100%' } }),
	                getFieldDecorator('userUuid', {
	                  rules: [{ required: true, message: '姓名不能为空！' }]
	                })(_react2.default.createElement(
	                  _antd.Select,
	                  { placeholder: '\u59D3\u540D' },
	                  accountList.map(function (item) {
	                    return _react2.default.createElement(
	                      Option,
	                      { key: item.uuid },
	                      item.name
	                    );
	                  })
	                ))
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout, { label: '\u8F6C\u79FB\u4E8B\u7531' }),
	              getFieldDecorator('remark')(_react2.default.createElement(_antd.Input.TextArea, {
	                type: 'textarea',
	                size: 'large',
	                autosize: { minRows: 2 },
	                style: { marginLeft: '5px' },
	                maxLength: 1000
	              })),
	              _react2.default.createElement(
	                'span',
	                { style: { fontSize: '12px', color: '#999' } },
	                '*\u6700\u591A\u53EF\u8F93\u51651000\u5B57'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Index);

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      _this.props.form.validateFields(function () {
	        _this.props.handSubmit(data);
	      });
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancel = _props.cancel,
	          record = _props.record;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u5408\u540C\u4F7F\u7528',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u7F16\u53F7' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                record.no
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u6240\u5C5E\u4EBA' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                record.belonging
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8BA2\u5355\u7F16\u53F7' }, formItemLayout),
	              getFieldDecorator('orderNo', {
	                rules: [{ required: true, message: '订单编号不能为空！' }]
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u91D1\u989D' }, formItemLayout),
	              getFieldDecorator('price', {
	                rules: [{ required: true, message: '合同金额不合法！' }]
	              })(_react2.default.createElement(_antd.Input, { type: 'number' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5BA2\u6237\u540D\u79F0' }, formItemLayout),
	              getFieldDecorator('customName', {
	                rules: [{ required: true, message: '公司名称不能为空！' }]
	              })(_react2.default.createElement(_antd.Input, { placeholder: '\u516C\u53F8\u540D\u79F0' }))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Index);

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _contract = __webpack_require__(89);
	
	var _BackBtn = __webpack_require__(12);
	
	var _ModalAllot = __webpack_require__(1773);
	
	var _ModalAllot2 = _interopRequireDefault(_ModalAllot);
	
	var _Treeselect = __webpack_require__(1783);
	
	var _Treeselect2 = _interopRequireDefault(_Treeselect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import SearchForm from './FormApplySearch'
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.judge = function (accountInfo) {
	      var permission = {};
	      var role = accountInfo.roles;
	      role.map(function (sign) {
	        if (sign === '[FinanceMenber]' || sign === '[XZManager]') {
	          permission.allot = true;
	        }
	        return permission;
	      });
	      if (accountInfo.admin) {
	        permission.allot = true;
	      }
	      _this.setState({
	        permission: permission
	      });
	    };
	
	    _this.loadDate = function (pageNo, pageSize, date, orgUuid, userUuid, type, status) {
	      var params = {};
	      var context = _this;
	      params.limit = 15;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.start = current;
	      if (date) {
	        params.date = date;
	      }
	      _this.setState({
	        pageNo: current
	      });
	      params.orgUuid = orgUuid || _this.orgUuid;
	      params.userUuid = userUuid || _this.userUuid;
	      params.type = type || _this.type;
	      params.status = status || _this.status;
	      if (params.status < 0) {
	        params.status = '';
	      }
	      if (params.type < 0) {
	        params.type = '';
	      }
	      if (params.userUuid < 0) {
	        params.userUuid = '';
	      }
	      (0, _contract.queryApplyContractList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.map(function (item) {
	            item.type_name = _this.findContractType(item.type);
	            return item;
	          });
	          context.setState({
	            data: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.findContractType = function (id) {
	      var list = _this.props.list;
	
	      var type = list.map(function (item) {
	        if (parseInt(item.value, 10) === parseInt(id, 10)) {
	          return item.key;
	        }
	        return type;
	      });
	      for (var i = 0; i < list.length; i++) {
	        if (parseInt(list[i].value, 10) === parseInt(id, 10)) {
	          return list[i].key;
	        }
	      }
	      return type;
	    };
	
	    _this.search = function (condition) {
	      var type = parseInt(condition.type, 10) >= 0 ? condition.type : '';
	      var status = parseInt(condition.status, 10) >= 0 ? condition.status : '';
	      var userUuid = parseInt(condition.userUuid, 10) >= 0 ? condition.userUuid : '';
	      _this.date = condition.date ? condition.date : '';
	      _this.orgUuid = condition.orgUuid ? condition.orgUuid : '';
	      _this.userUuid = userUuid;
	      _this.status = status;
	      _this.type = type;
	      _this.loadDate(1, 15, condition.date, condition.orgUuid, condition.userUuid, condition.type, condition.status);
	    };
	
	    _this.showModal = function (record) {
	      _this.record = record;
	      _this.setState({
	        applyModalVisible: true
	      });
	    };
	
	    _this.cancel = function () {
	      _this.setState({
	        applyModalVisible: false
	      });
	    };
	
	    _this.goBack = function () {
	      _this.props.router.go(-1);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '申请时间',
	        dataIndex: 'cdate',
	        key: 'cdate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _moment2.default.unix(text / 1000).format('YYYY-MM-DD')
	          );
	        }
	      }, {
	        title: '申请人部门',
	        dataIndex: 'orgName',
	        key: 'orgName'
	      }, {
	        title: '申请人姓名',
	        dataIndex: 'userName',
	        key: 'userName'
	      }, {
	        title: '合同类型',
	        dataIndex: 'type_name',
	        key: 'type_name'
	      }, {
	        title: '份数',
	        dataIndex: 'number',
	        key: 'number'
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        key: 'status',
	        render: function render(text) {
	          return text === 0 ? _react2.default.createElement(
	            'span',
	            null,
	            '\u672A\u5206\u914D'
	          ) : _react2.default.createElement(
	            'span',
	            null,
	            '\u5DF2\u5206\u914D'
	          );
	        }
	      }, {
	        title: '分配时间',
	        dataIndex: 'checkTime',
	        key: 'checkTime',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '分配人',
	        dataIndex: 'checkUser',
	        key: 'checkUser'
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.status === 0 && _this.state.permission.allot ? _react2.default.createElement(
	              'a',
	              { className: 'ant-dropdown-link', onClick: function onClick() {
	                  return _this.showModal(record);
	                } },
	              '\u5206\u914D'
	            ) : ''
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      applyModalVisible: false,
	      pageNo: 1,
	      permission: {},
	      total: 0
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.date = '';
	      this.orgUuid = '';
	      this.userUuid = '';
	      this.type = '';
	      this.status = '';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadDate(1, 15);
	
	      this.judge(this.props.account_info);
	    }
	
	    /**
	     * 依据角色判断权限
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total;
	
	
	      var pagination = {
	        total: total,
	        pageSize: 15,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadDate(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'fixed-header' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'start', type: 'flex', style: { marginBottom: '16px' } },
	            _react2.default.createElement(_BackBtn.BackBtn, null)
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'space-between', type: 'flex', style: { marginBottom: '16px' } },
	            _react2.default.createElement(_Treeselect2.default, { search: this.search })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { paddingTop: '125px' } },
	          _react2.default.createElement(_antd.Table, {
	            rowKey: 'uuid',
	            rowSelection: {},
	            columns: this.columns(),
	            dataSource: data,
	            pagination: pagination
	          })
	        ),
	        this.state.applyModalVisible ? _react2.default.createElement(_ModalAllot2.default, { cancel: this.cancel, record: this.record, loadDate: this.loadDate }) : ''
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    list: state.contract_type,
	    account_info: state.account_info
	  };
	})(Index);

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _user = __webpack_require__(54);
	
	var _SelectOrg = __webpack_require__(324);
	
	var _SelectOrg2 = _interopRequireDefault(_SelectOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function (e) {
	      e.preventDefault();
	      var data = _this.props.form.getFieldsValue();
	      data.orgUuid = _this.state.orgUuid;
	      _this.props.search(data);
	    };
	
	    _this.onChangeOrg = function (value) {
	      _this.setState({
	        orgUuid: value
	      });
	      _this.loadAccount(value);
	      _this.props.form.setFieldsValue({ userUuid: '' });
	    };
	
	    _this.loadAccount = function (orgUuid) {
	      var uuid = orgUuid || '';
	      (0, _user.queryAccountList)({ orgUuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            accountList: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.reset = function (e) {
	      e.preventDefault();
	      _this.props.form.resetFields();
	      _this.setState({
	        orgUuid: undefined
	      });
	      var data = _this.props.form.getFieldsValue();
	      _this.props.search(data);
	    };
	
	    _this.state = {
	      contract_type: [],
	      accountList: [],
	      orgUuid: ''
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadAccount();
	      this.setState({
	        contract_type: this.props.contract_type
	      });
	    }
	
	    /**
	     *获取用户列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var _state = this.state,
	          contractType = _state.contract_type,
	          accountList = _state.accountList;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { className: 'search-form', layout: 'horizontal', onSubmit: this.submit },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 3 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('date')(_react2.default.createElement(_antd.DatePicker, { placeholder: '\u7533\u8BF7\u65F6\u95F4', style: { width: '100%' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 7 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u7533\u8BF7\u4EBA' }, formItemLayout),
	              _react2.default.createElement(_SelectOrg2.default, { onChange: this.onChangeOrg, orgUuid: this.state.orgUuid })
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 2 },
	            _react2.default.createElement(
	              FormItem,
	              { style: { width: '100%' } },
	              getFieldDecorator('userUuid', {
	                rules: [{ message: '姓名不能为空！' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                { placeholder: '\u59D3\u540D' },
	                _react2.default.createElement(
	                  Option,
	                  { key: '-1' },
	                  '\u5168\u90E8'
	                ),
	                accountList.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.uuid },
	                    item.name
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u72B6\u6001' }, formItemLayout),
	              getFieldDecorator('status', {
	                rules: [{ message: '' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                { placeholder: '\u72B6\u6001' },
	                _react2.default.createElement(
	                  Option,
	                  { value: '-1' },
	                  '\u5168\u90E8'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '0' },
	                  '\u672A\u5206\u914D'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '1' },
	                  '\u5DF2\u5206\u914D'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u7C7B\u578B' }, formItemLayout),
	              getFieldDecorator('type', {
	                rules: [{ message: '' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                { placeholder: '\u5408\u540C\u7C7B\u578B' },
	                _react2.default.createElement(
	                  Option,
	                  { value: '-1' },
	                  '\u5168\u90E8'
	                ),
	                contractType.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.value },
	                    item.key
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              _react2.default.createElement(
	                _antd.Row,
	                { type: 'flex', justify: 'end' },
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary', htmlType: 'submit', style: { marginRight: '10px' } },
	                  '\u641C\u7D22'
	                ),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { onClick: this.reset, style: { marginRight: '10px' } },
	                  '\u91CD\u7F6E'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create()(Index));

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _order = __webpack_require__(423);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.handleChange = function (e) {
	      _this.setState({
	        name: e.target.value.replace(/\s+/g, '')
	      });
	    };
	
	    _this.search = function () {
	      _this.name = _this.state.name;
	      _this.loadDate();
	    };
	
	    _this.loadDate = function (pageNo) {
	      _this.name = _this.state.name;
	      var params = {};
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      _this.setState({
	        isLoading: true,
	        pageNo: current
	      });
	      params.limit = 15;
	      params.start = current;
	      params.name = _this.name;
	
	      (0, _order.queryCustom)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.goBack = function () {
	      _this.props.router.go(-1);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '客户名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '联系人名称',
	        dataIndex: 'contactName',
	        key: 'contactName'
	      }, {
	        title: '职位',
	        dataIndex: 'contactPosition',
	        key: 'contactPosition'
	      }, {
	        title: '电话',
	        dataIndex: 'contactPhone',
	        key: 'contactPhone'
	      }, {
	        title: '手机',
	        dataIndex: 'contactMobile',
	        key: 'contactMobile'
	      }, {
	        title: 'qq',
	        dataIndex: 'contactQq',
	        key: 'contactQq'
	      }, {
	        title: '创建时间',
	        dataIndex: 'cdate',
	        key: 'cdate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '客户等级',
	        dataIndex: 'level',
	        key: 'level',
	        render: function render(text) {
	          var levelName = '';
	          switch (text) {
	            case 0:
	              levelName = '初步接触';
	              break;
	            case 1:
	              levelName = '深入了解';
	              break;
	            case 2:
	              levelName = '考虑购买';
	              break;
	            default:
	              break;
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            levelName
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      name: '',
	      total: 0,
	      data: [],
	      isLoading: false,
	      pageNo: 1
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	
	    /**
	     * 获取客户列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          total = _state.total,
	          isLoading = _state.isLoading;
	
	      var pagination = {
	        total: total,
	        showSizeChanger: false,
	        pageSize: 15,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadDate(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'protect-sql' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-between' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              _antd.Row,
	              {
	                type: 'flex',
	                className: 'protect_search',
	                justify: 'end',
	                style: { marginBottom: '16px' }
	              },
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(_antd.Input, {
	                  placeholder: '\u8BF7\u8F93\u5165\u5BA2\u6237\u540D\u79F0',
	                  style: { width: '300px' },
	                  onChange: this.handleChange,
	                  onPressEnter: this.search,
	                  value: this.state.name
	                }),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary', onClick: this.search, style: { marginLeft: '10px' } },
	                  '\u641C\u7D22'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          columns: this.columns(),
	          dataSource: data,
	          pagination: pagination,
	          loading: isLoading
	        })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.search = function (e) {
	      e.preventDefault();
	      var data = _this.props.form.getFieldsValue();
	      _this.props.search(data);
	    };
	
	    _this.reset = function (e) {
	      e.preventDefault();
	      _this.props.form.setFieldsValue({
	        no: undefined,
	        status: undefined,
	        type: undefined,
	        useTime: undefined
	      });
	      var data = _this.props.form.getFieldsValue();
	      _this.props.search(data);
	    };
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	
	    /**
	     * 发票搜索
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      return _react2.default.createElement(
	        _antd.Form,
	        { className: 'search-form', onSubmit: this.search },
	        _react2.default.createElement(
	          _antd.Row,
	          { justify: 'space-between', type: 'flex' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('no')(_react2.default.createElement(_antd.Input, { placeholder: '\u53D1\u7968\u7F16\u53F7' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5F00\u7968\u65E5\u671F' }, formItemLayout),
	              getFieldDecorator('useTime')(_react2.default.createElement(_antd.DatePicker, { placeholder: '\u5F00\u7968\u65E5\u671F', style: { width: '100%' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u72B6\u6001' }, formItemLayout),
	              getFieldDecorator('status')(_react2.default.createElement(
	                _antd.Select,
	                { placeholder: '\u72B6\u6001' },
	                _react2.default.createElement(
	                  Option,
	                  { value: '1' },
	                  '\u672A\u4F7F\u7528'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '2' },
	                  '\u5DF2\u4F7F\u7528'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '3' },
	                  '\u5DF2\u4F5C\u5E9F'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '4' },
	                  '\u5DF2\u51B2\u7EA2'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u53D1\u7968\u7C7B\u578B' }, formItemLayout),
	              getFieldDecorator('type')(_react2.default.createElement(
	                _antd.Select,
	                null,
	                _react2.default.createElement(
	                  Option,
	                  { key: '1' },
	                  '\u56FD\u7A0E\u7F51\u7EDC\u5728\u7EBF\u53D1\u7968'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { key: '2' },
	                  '\u589E\u503C\u7A0E\u4E13\u7528\u53D1\u7968'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { key: '3' },
	                  '\u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              _react2.default.createElement(
	                _antd.Row,
	                { type: 'flex', justify: 'end' },
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary', htmlType: 'submit', style: { marginRight: '10px' } },
	                  '\u641C\u7D22'
	                ),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { onClick: this.reset, style: { marginRight: '10px' } },
	                  '\u91CD\u7F6E'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create()(Index));

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _invoice = __webpack_require__(422);
	
	var _user = __webpack_require__(54);
	
	var _org = __webpack_require__(53);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _base = __webpack_require__(328);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _contract_type = __webpack_require__(435);
	
	var _contract = __webpack_require__(89);
	
	var _ModalUse = __webpack_require__(1790);
	
	var _ModalUse2 = _interopRequireDefault(_ModalUse);
	
	var _ModalAdd = __webpack_require__(1787);
	
	var _ModalAdd2 = _interopRequireDefault(_ModalAdd);
	
	var _FormSearch = __webpack_require__(1785);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	var _ModalTip = __webpack_require__(1789);
	
	var _ModalTip2 = _interopRequireDefault(_ModalTip);
	
	var _ModalRecord = __webpack_require__(1788);
	
	var _ModalRecord2 = _interopRequireDefault(_ModalRecord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.getAccountInfo = function () {
	      (0, _user.queryAccountInfo)();
	    };
	
	    _this.loadDate = function (pageNo, pageSize, no, useTime, status, type) {
	      var params = {};
	      var context = _this;
	      var statePageNo = _this.state.pageNo;
	
	      var current = pageNo || statePageNo;
	      params.limit = 15;
	      params.start = current;
	      params.no = statePageNo || _this.no;
	      params.createTime = useTime || _this.useTime;
	      params.type = type || _this.type;
	      if (!params.createTime) {
	        delete params.createTime;
	      }
	      _this.setState({
	        pageNo: current,
	        isLoading: true
	      });
	      params.status = status || _this.status;
	      if (params.status < 0) {
	        params.status = '';
	      }
	      if (params.type < 0) {
	        params.type = '';
	      }
	      (0, _invoice.queryInvoiceList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          res.data.map(function (item) {
	            _base2.default.bank.map(function (item2) {
	              if (parseInt(item2.key, 10) === parseInt(item.collectBank, 10)) {
	                item.collectBankFont = item2.name;
	              }
	              return item2;
	            });
	            return item;
	          });
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.loadContractType = function () {
	      (0, _contract_type.getContractType)();
	    };
	
	    _this.search = function (condition) {
	      var type = parseInt(condition.type, 10) >= 0 ? condition.type : '';
	      var status = parseInt(condition.status, 10) >= 0 ? condition.status : '';
	      _this.no = condition.no ? condition.no : '';
	      _this.useTime = condition.useTime;
	      _this.status = status;
	      _this.type = type;
	      _this.loadDate(1, 15, condition.no, condition.useTime, condition.status, condition.type);
	    };
	
	    _this.invalidInvoice = function () {
	      (0, _invoice.queryInvalidInvoice)(_this.state.selectedRowKeys).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	          _this.setState({
	            selectedRowKeys: []
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.deleteInvoice = function () {
	      (0, _invoice.queryDeleteInvoice)(_this.state.selectedRowKeys).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	          _this.setState({
	            selectedRowKeys: []
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.redInvoice = function () {
	      (0, _invoice.queryRedInvoice)(_this.state.selectedRowKeys).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	          _this.setState({
	            selectedRowKeys: []
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.restoreInvoice = function () {
	      (0, _invoice.queryRestoreInvoice)(_this.state.selectedRowKeys).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	          _this.setState({
	            selectedRowKeys: []
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadAccount = function () {
	      (0, _user.queryAccountList)().then(function (res) {
	        if (res.statusCode !== 200) _antd.message.error(res.message);
	      });
	    };
	
	    _this.loadOrg = function () {
	      (0, _org.queryOrgList)().then(function (res) {
	        if (res.statusCode !== 200) _antd.message.error(res.message);
	      });
	    };
	
	    _this.recycleContract = function () {
	      (0, _contract.queryRecycleContract)(_this.state.selectedRowKeys).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	          _this.setState({
	            selectedRowKeys: []
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.useInvoice = function (params) {
	      params.uuid = _this.invoiceUuid;
	      // eslint-disable-next-line react-hooks/rules-of-hooks
	      (0, _invoice.queryUseInvoice)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	      _this.setState({
	        selectedRowKeys: []
	      });
	    };
	
	    _this.useInvoiceEdit = function (params) {
	      params.uuid = _this.invoiceUuid;
	      // eslint-disable-next-line react-hooks/rules-of-hooks
	      (0, _invoice.queryUseInvoiceEdit)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          _this.cancel();
	          _this.loadDate();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	      _this.setState({
	        selectedRowKeys: []
	      });
	    };
	
	    _this.showUseModal = function (uuid, record) {
	      _this.invoiceUuid = uuid;
	      _this.record = record;
	      _this.setState({
	        useModalVisible: true
	      });
	    };
	
	    _this.showUseEditModal = function (uuid, record) {
	      _this.invoiceUuid = uuid;
	      _this.record = record;
	      _this.setState({
	        useEditModalVisible: true
	      });
	    };
	
	    _this.showTipModal1 = function () {
	      if (_this.state.selectedRowKeys.length < 1) {
	        _antd.message.warn('请先选择待处理的发票！');
	      } else {
	        _this.setState({
	          tipModalVisible1: true
	        });
	      }
	    };
	
	    _this.showTipModal2 = function () {
	      if (_this.state.selectedRowKeys.length < 1) {
	        _antd.message.warn('请先选择待作废的发票！');
	      } else {
	        _this.setState({
	          tipModalVisible2: true
	        });
	      }
	    };
	
	    _this.showTipModal3 = function () {
	      if (_this.state.selectedRowKeys.length < 1) {
	        _antd.message.warn('请先选择冲红的发票！');
	      } else {
	        _this.setState({
	          tipModalVisible3: true
	        });
	      }
	    };
	
	    _this.showTipModal4 = function () {
	      if (_this.state.selectedRowKeys.length < 1) {
	        _antd.message.warn('请先选择待处理的发票！');
	      } else {
	        _this.setState({
	          tipModalVisible4: true
	        });
	      }
	    };
	
	    _this.cancel = function () {
	      _this.setState({
	        useModalVisible: false,
	        addModalVisible: false,
	        recordModalVisible: false,
	        tipModalVisible1: false,
	        tipModalVisible2: false,
	        tipModalVisible3: false,
	        tipModalVisible4: false,
	        useEditModalVisible: false
	      });
	    };
	
	    _this.showModal = function (type, contractUuid) {
	      /* 1使用丨2添加丨3批量添加丨4分配丨5发票申请 丨6操作记录 丨7同意使用 丨8拒绝使用 */
	      if (type === 2) {
	        _this.setState({
	          addModalVisible: true
	        });
	      } else if (type === 6) {
	        _this.setState({
	          recordModalVisible: true,
	          contractUuid: contractUuid
	        });
	      }
	    };
	
	    _this.onSelectChange = function (selectedRowKeys) {
	      _this.setState({
	        selectedRowKeys: selectedRowKeys
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '发票编号',
	        dataIndex: 'no',
	        key: 'no',
	        width: 150,
	        fixed: 'left'
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        key: 'status',
	        width: 100,
	        fixed: 'left',
	        render: function render(text) {
	          var status = '';
	          if (text === 1) {
	            status = '未使用';
	          } else if (text === 2) {
	            status = '已使用';
	          } else if (text === 3) {
	            status = '已作废';
	          } else if (text === 4) {
	            status = '已冲红';
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            status
	          );
	        }
	      }, {
	        title: '类型',
	        dataIndex: 'invoiceType',
	        key: 'invoiceType',
	        width: 150,
	        render: function render(text, record) {
	          var type = '';
	          if (text === '1') {
	            type = '国税网络在线发票';
	          } else if (text === '2') {
	            type = '增值税专用发票';
	          } else {
	            type = '增值税普通发票';
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            type
	          );
	        }
	      }, {
	        title: '金额',
	        dataIndex: 'price',
	        key: 'price',
	        width: 100,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text > 0 ? text : ''
	          );
	        }
	      }, {
	        title: '发票抬头',
	        dataIndex: 'invoiceTop',
	        key: 'invoiceTop',
	        width: 150
	      }, {
	        title: '合同编号',
	        dataIndex: 'contractNo',
	        key: 'contractNo',
	        width: 150
	      }, {
	        title: '开票类型',
	        dataIndex: 'submitType',
	        key: 'submitType',
	        width: 100,
	        render: function render(text) {
	          var type = '';
	          if (text === 1) {
	            type = '提前开票';
	          } else if (text === 2) {
	            type = '到账开票';
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            type
	          );
	        }
	      }, {
	        title: '开票日期',
	        dataIndex: 'useTime',
	        key: 'useTime',
	        width: 150,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '购方名称',
	        dataIndex: 'name',
	        key: 'name',
	        width: 150
	      }, {
	        title: '购方税号',
	        dataIndex: 'taxId',
	        key: 'taxId',
	        width: 180
	      }, {
	        title: '不含税金额',
	        dataIndex: 'noTaxPrice',
	        key: 'noTaxPrice',
	        width: 150,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text > 0 ? text : ''
	          );
	        }
	      }, {
	        title: '税率',
	        dataIndex: 'taxRate',
	        key: 'taxRate',
	        width: 100,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text > 0 ? text : ''
	          );
	        }
	      }, {
	        title: '合计税额',
	        dataIndex: 'totalPrice',
	        key: 'totalPrice',
	        width: 150,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text > 0 ? text : ''
	          );
	        }
	      }, {
	        title: '到账日期',
	        dataIndex: 'collectDate',
	        key: 'collectDate',
	        width: 150,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '收款方式',
	        dataIndex: 'collectWay',
	        key: 'collectWay',
	        width: 150,
	        render: function render(text) {
	          var type = '';
	          if (text === 1) {
	            type = '汇款';
	          } else if (text === 2) {
	            type = '现金';
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            type
	          );
	        }
	      }, {
	        title: '收款银行',
	        dataIndex: 'collectBankFont',
	        key: 'collectBankFont',
	        width: 190
	      }, {
	        title: '本月开票金额是否与到账金额相符',
	        dataIndex: 'isCorrect',
	        key: 'isCorrect',
	        width: 250,
	        render: function render(text) {
	          var isCorrect = '';
	          if (text === 0) {
	            isCorrect = '否';
	          } else if (text === 1) {
	            isCorrect = '是';
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            isCorrect
	          );
	        }
	      }, {
	        title: '首款金额',
	        dataIndex: 'firstPrice',
	        key: 'firstPrice',
	        width: 150,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text > 0 ? text : ''
	          );
	        }
	      }, {
	        title: '尾款金额',
	        dataIndex: 'balancePrice',
	        key: 'balancePrice',
	        width: 150,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text > 0 ? text : ''
	          );
	        }
	      }, {
	        title: '回执单收回日期',
	        dataIndex: 'recoverDate',
	        key: 'recoverDate',
	        width: 150,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '申请人部门',
	        dataIndex: 'orgName',
	        key: 'orgName',
	        width: 150
	      }, {
	        title: '开票人',
	        dataIndex: 'applyUserName',
	        key: 'applyUserName',
	        width: 100
	      }, {
	        title: '申请人',
	        dataIndex: 'cusrName',
	        key: 'cusrName',
	        width: 100
	      }, {
	        title: '领取人',
	        dataIndex: 'receiveUserName',
	        key: 'receiveUserName',
	        width: 100
	      }, {
	        title: '备注',
	        dataIndex: 'remark',
	        key: 'remark',
	        width: 150
	      }, {
	        title: '操作',
	        key: 'done',
	        width: 100,
	        fixed: 'right',
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.status === 1 ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.showUseModal(record.uuid, record);
	                  } },
	                '\u4F7F\u7528'
	              )
	            ) : '',
	            record.status === 2 ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                { onClick: function onClick() {
	                    return _this.showUseEditModal(record.uuid, record);
	                  } },
	                '\u7F16\u8F91'
	              )
	            ) : ''
	          );
	        }
	      }];
	    };
	
	    _this.exportContract = function () {
	      var params = {};
	      params.no = _this.no;
	      if (params.useTime) {
	        params.useTime = _this.useTime;
	      }
	      params.status = _this.status;
	      params.type = _this.type;
	      (0, _invoice.queryExportInvoice)(params);
	    };
	
	    _this.state = {
	      data: [],
	      pageNo: 1,
	      useModalVisible: false,
	      useEditModalVisible: false,
	      addModalVisible: false,
	      recordModalVisible: false,
	      tipModalVisible1: false,
	      tipModalVisible2: false,
	      tipModalVisible3: false,
	      tipModalVisible4: false,
	      total: 0,
	      isLoading: false,
	      selectedRowKeys: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.useTime = '';
	      this.status = '';
	      this.type = '';
	      this.no = '';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadDate(1, 15);
	      this.loadOrg();
	      this.loadAccount();
	    }
	
	    /**
	     * 获取用户信息
	     */
	
	
	    /**
	     * 作废发票
	     */
	
	
	    /**
	     * 删除发票
	     */
	
	
	    /**
	     * 发票冲红
	     */
	
	
	    /**
	     * 恢复发票
	     */
	
	
	    /**
	     *获取用户列表
	     */
	
	
	    /**
	     *获取用组织列表
	     */
	
	
	    /**
	     * 回收发票
	     */
	
	
	    /**
	     * 使用发票
	     */
	
	
	    /**
	     * 编辑使用发票
	     */
	
	
	    /**
	     * 显示使用发票弹窗
	     */
	
	
	    /**
	     * 发票使用编辑
	     */
	
	
	    /**
	     * 显示删除操作确认框
	     */
	
	
	    /**
	     * 显示作废操作确认框
	     */
	
	
	    /**
	     * 显示遗失操作确认框
	     */
	
	
	    /**
	     * 显示恢复操作确认框
	     */
	
	
	    /**
	     * 导出发票
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total,
	          selectedRowKeys = _state.selectedRowKeys,
	          isLoading = _state.isLoading;
	
	      var pagination = {
	        total: total,
	        showSizeChanger: false,
	        pageSize: 15,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadDate(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      var tH = _util2.default.pageHeight() - 288;
	      var rowSelection = {
	        selectedRowKeys: selectedRowKeys,
	        onChange: this.onSelectChange
	      };
	      var _state2 = this.state,
	          useModalVisible = _state2.useModalVisible,
	          addModalVisible = _state2.addModalVisible,
	          tipModalVisible1 = _state2.tipModalVisible1,
	          useEditModalVisible = _state2.useEditModalVisible,
	          recordModalVisible = _state2.recordModalVisible,
	          tipModalVisible2 = _state2.tipModalVisible2,
	          tipModalVisible3 = _state2.tipModalVisible3,
	          tipModalVisible4 = _state2.tipModalVisible4;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'fixed-box' },
	        _react2.default.createElement(
	          'div',
	          { className: 'fixed-header' },
	          _react2.default.createElement(
	            _antd.Row,
	            { type: 'flex', className: 'btn-group' },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 16 },
	              _react2.default.createElement(
	                'ul',
	                { className: 'table-menu' },
	                _react2.default.createElement(
	                  'li',
	                  { onClick: function onClick() {
	                      return _this2.showModal(2);
	                    } },
	                  _react2.default.createElement(_antd.Icon, { type: 'addc' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u6DFB\u52A0'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { onClick: this.showTipModal4 },
	                  _react2.default.createElement(_antd.Icon, { type: 'recover' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u6062\u590D'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { onClick: this.showTipModal1 },
	                  _react2.default.createElement(_antd.Icon, { type: 'deletec' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u5220\u9664'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { onClick: this.showTipModal2 },
	                  _react2.default.createElement(_antd.Icon, { type: 'cancel' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u4F5C\u5E9F'
	                  )
	                ),
	                _react2.default.createElement(
	                  'li',
	                  { onClick: this.showTipModal3 },
	                  _react2.default.createElement(_antd.Icon, { type: 'lose' }),
	                  _react2.default.createElement(
	                    'span',
	                    null,
	                    '\u51B2\u7EA2'
	                  )
	                )
	              )
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 8 },
	              _react2.default.createElement(
	                _antd.Row,
	                { type: 'flex', justify: 'end', className: 'btn-group' },
	                _react2.default.createElement(
	                  _antd.Col,
	                  null,
	                  _react2.default.createElement(
	                    _antd.Button,
	                    { onClick: this.exportContract },
	                    '\u5BFC\u51FA'
	                  )
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'space-between', type: 'flex', style: { marginBottom: '16px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_FormSearch2.default, { search: this.search })
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, {
	          rowKey: 'uuid',
	          rowSelection: rowSelection,
	          columns: this.columns(),
	          dataSource: data,
	          loading: isLoading,
	          pagination: pagination,
	          style: { paddingTop: '113px' },
	          scroll: { x: 3600, y: tH }
	        }),
	        useModalVisible ? _react2.default.createElement(_ModalUse2.default, { cancel: this.cancel, handSubmit: this.useInvoice, record: this.record }) : '',
	        useEditModalVisible ? _react2.default.createElement(_ModalUse2.default, { cancel: this.cancel, handSubmit: this.useInvoiceEdit, record: this.record }) : '',
	        addModalVisible ? _react2.default.createElement(_ModalAdd2.default, { cancel: this.cancel, loadDate: this.loadDate }) : '',
	        tipModalVisible1 ? _react2.default.createElement(_ModalTip2.default, { cancel: this.cancel, handSubmit: this.deleteInvoice }) : '',
	        tipModalVisible2 ? _react2.default.createElement(_ModalTip2.default, { cancel: this.cancel, handSubmit: this.invalidInvoice }) : '',
	        tipModalVisible3 ? _react2.default.createElement(_ModalTip2.default, { cancel: this.cancel, handSubmit: this.redInvoice }) : '',
	        tipModalVisible4 ? _react2.default.createElement(_ModalTip2.default, { cancel: this.cancel, handSubmit: this.restoreInvoice }) : '',
	        recordModalVisible ? _react2.default.createElement(_ModalRecord2.default, { cancel: this.cancel, contractUuid: this.state.contractUuid }) : ''
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    list: state.contract_type,
	    account_info: state.account_info
	  };
	})(Index);

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _invoice = __webpack_require__(422);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.setCompany = function (value, option) {
	      _this.companyName = option.props.children;
	    };
	
	    _this.loadCompanyList = function () {
	      (0, _invoice.queryXxOrg)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            companyList: res.data
	          });
	        }
	      });
	    };
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      _this.props.form.validateFields(function (err) {
	        if (!err) {
	          (0, _invoice.querySaveInvoice)(data).then(function (res) {
	            if (res.statusCode === 200) {
	              _antd.message.success(res.message);
	              _this.props.loadDate();
	              _this.props.cancel();
	            } else {
	              _antd.message.error(res.message);
	            }
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      companyList: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadCompanyList();
	    }
	
	    /**
	     * 获取公司列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var companyList = this.state.companyList;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u6DFB\u52A0\u53D1\u7968',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u53D1\u7968\u7C7B\u578B' }, formItemLayout),
	              getFieldDecorator('invoiceType', {
	                rules: [{ required: true, message: '发票类型不能为空！' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                _react2.default.createElement(
	                  Option,
	                  { key: '1' },
	                  '\u56FD\u7A0E\u7F51\u7EDC\u5728\u7EBF\u53D1\u7968'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { key: '2' },
	                  '\u589E\u503C\u7A0E\u4E13\u7528\u53D1\u7968'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { key: '3' },
	                  '\u589E\u503C\u7A0E\u666E\u901A\u53D1\u7968'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5F00\u7968\u516C\u53F8' }, formItemLayout),
	              getFieldDecorator('company', {
	                rules: [{ required: true, message: '开票公司不能为空！' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                { onSelect: this.setCompany },
	                companyList.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.uuid },
	                    item.name
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u53D1\u7968\u53F7\u524D\u7F00' }, formItemLayout),
	              getFieldDecorator('noPrefix', {
	                rules: [{ required: true, message: '发票号前缀不能为空！' }]
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u6570\u5B57\u4F4D\u6570' }, formItemLayout),
	              getFieldDecorator('digits', {
	                rules: [{ required: true, message: '数字位数不能为空' }]
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8D77\u59CB\u7F16\u53F7' }, formItemLayout),
	              getFieldDecorator('beginNo', {
	                rules: [{ required: true, message: '起始编号不能为空！' }]
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u751F\u6210\u4E2A\u6570' }, formItemLayout),
	              getFieldDecorator('num', {
	                rules: [{ required: true, message: '生成个数不能为空！' }]
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create()(Index));

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _contract = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadLog = function (uuid) {
	      (0, _contract.queryContractLog)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            log: res.data
	          });
	        }
	      });
	    };
	
	    _this.state = {
	      log: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadLog(this.props.contractUuid);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var log = this.state.log;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u53D1\u7968\u64CD\u4F5C\u8BB0\u5F55',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          footer: false,
	          maskClosable: false
	        },
	        log.length > 0 ? _react2.default.createElement(
	          _antd.Timeline,
	          null,
	          log.map(function (item) {
	            return _react2.default.createElement(
	              _antd.Timeline.Item,
	              { key: item.uuid },
	              _moment2.default.unix(item.cdate / 1000).format('YYYY-MM-DD H:mm:ss'),
	              ' ',
	              item.operator,
	              ' ',
	              item.action
	            );
	          })
	        ) : _react2.default.createElement(
	          'p',
	          { style: { textAlign: 'center', lineHeight: '30px' } },
	          '\u6682\u65E0\u64CD\u4F5C\u8BB0\u5F55'
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {}
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u63D0\u793A',
	          width: 400,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.props.handSubmit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          'p',
	          null,
	          '\u786E\u8BA4\u5BF9\u6240\u9009\u53D1\u7968\u8FDB\u884C\u8BE5\u64CD\u4F5C\u5417\uFF1F'
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _invoice = __webpack_require__(422);
	
	var _user = __webpack_require__(54);
	
	var _org = __webpack_require__(53);
	
	var _base = __webpack_require__(328);
	
	var _base2 = _interopRequireDefault(_base);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadAccount = function (orgUuid, flag) {
	      var uuid = orgUuid || '';
	      (0, _user.queryAccountList)({ orgUuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            accountList: res.data
	          });
	          if (!flag) {
	            _this.props.form.setFieldsValue({
	              cusr: undefined
	            });
	          }
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadCompanyList = function () {
	      (0, _invoice.queryXxOrg)().then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            companyList: res.data
	          });
	        }
	      });
	    };
	
	    _this.onChange = function (orgUuid, label) {
	      _this.orgName = label[label.length - 1];
	      if (orgUuid !== _this.orgUuid) {
	        _this.orgUuid = orgUuid;
	        _this.loadAccount(orgUuid);
	      }
	    };
	
	    _this.loadOrg = function () {
	      var params = {};
	      params.uuid = '19F83BB0108B4255AA38D457E3FFF223';
	      (0, _org.queryOrgList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var options = [];
	          res.data.map(function (item) {
	            var optionItem = {};
	            optionItem.label = item.name;
	            optionItem.value = item.uuid;
	            optionItem.key = item.uuid;
	            options.push(optionItem);
	            return options;
	          });
	          _this.setState({
	            treeData: options
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.onLoadData = function (treeNode) {
	      var arr = [];
	      var key = treeNode.props.eventKey;
	      var params = {};
	      params.uuid = key.split('-')[key.split('-').length - 1];
	      return new Promise(function (resolve) {
	        (0, _org.queryOrgList)(params).then(function (res) {
	          if (res.statusCode === 200) {
	            res.data.map(function (item) {
	              var optionItem = {};
	              optionItem.label = item.name;
	              optionItem.value = item.uuid;
	              optionItem.key = key + '-' + item.uuid;
	              arr.push(optionItem);
	              return arr;
	            });
	            var treeData = [].concat(_toConsumableArray(_this.state.treeData));
	            var loop = function loop(data) {
	              data.forEach(function (item) {
	                if (key.indexOf(item.key) === 0) {
	                  if (item.children) {
	                    resolve();
	                    loop(item.children);
	                  } else if (item.key === key) {
	                    if (arr.length > 0) {
	                      item.children = arr;
	                      _this.setState({ treeData: treeData }, function () {
	                        resolve();
	                      });
	                    } else if (arr.length === 0) {
	                      item.isLeaf = true;
	                      _this.setState({ treeData: treeData }, function () {
	                        resolve();
	                      });
	                    } else {
	                      resolve();
	                    }
	                  }
	                }
	              });
	            };
	            loop(treeData);
	          }
	        });
	      });
	    };
	
	    _this.setCusrName = function (value, option) {
	      _this.cusrName = option.props.children;
	    };
	
	    _this.submit = function () {
	      var data = _this.props.form.getFieldsValue();
	      data.orgName = _this.orgName;
	      data.cusrName = _this.cusrName;
	      data.invoiceTop = data.name;
	      _this.props.form.validateFields(function (err) {
	        _this.props.handSubmit(data);
	      });
	    };
	
	    _this.state = {
	      treeData: [],
	      accountList: [],
	      companyList: [],
	      data: _this.props.record || {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var data = this.state.data;
	
	      this.companyName = data.companyName || '';
	      this.orgName = data.orgName || '';
	      this.cusrName = data.cusrName || '';
	      var orgUuid = this.state.data.orgUuid;
	
	      this.loadOrg();
	      this.loadCompanyList();
	      if (orgUuid) {
	        this.loadAccount(orgUuid, true);
	      } else {
	        this.loadAccount();
	      }
	    }
	
	    /**
	     *获取用户列表
	     */
	
	
	    /**
	     * 获取公司列表
	     */
	
	
	    /**
	     *获取组织列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	
	      var _state = this.state,
	          accountList = _state.accountList,
	          companyList = _state.companyList,
	          data = _state.data;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u53D1\u7968\u4F7F\u7528',
	          width: 420,
	          style: { paddingBottom: '0' },
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false
	        },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline', style: { height: '400px', overflowY: 'scroll' } },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5F00\u7968\u7C7B\u578B' }, formItemLayout),
	              getFieldDecorator('submitType', {
	                rules: [{ required: true, message: '开票类型不能为空！' }],
	                initialValue: data.submitType ? '' + data.submitType : undefined
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                _react2.default.createElement(
	                  Option,
	                  { value: '1' },
	                  '\u63D0\u524D\u5F00\u7968'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '2' },
	                  '\u5230\u8D26\u5F00\u7968'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5F00\u7968\u65E5\u671F' }, formItemLayout),
	              getFieldDecorator('useTime', {
	                rules: [{ required: true, message: '开票日期不能为空！' }],
	                initialValue: data.useTime ? (0, _moment2.default)(data.useTime) : data.useTime
	              })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5408\u540C\u7F16\u53F7' }, formItemLayout),
	              getFieldDecorator('contractNo', {
	                rules: [{
	                  required: true,
	                  message: '合同编号不合法！',
	                  pattern: /(^LXCRM\d+$)|([1-9]{2})(((0[13578]|1[02])(0[1-9]|[12]\d|3[01]))|((0[469]|11)(0[1-9]|[12]\d|30))|(02(0[1-9]|1\d|2\d)))\d{2,3}$/
	                }],
	                initialValue: data.contractNo
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5F00\u7968\u516C\u53F8' }, formItemLayout),
	              getFieldDecorator('company', {
	                rules: [{ required: true, message: '开票公司不能为空！' }],
	                initialValue: data.company && data.company !== '0' ? '' + data.company : undefined
	              })(_react2.default.createElement(
	                _antd.Select,
	                { disabled: true },
	                companyList.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.uuid },
	                    item.name
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8D2D\u65B9\u540D\u79F0' }, formItemLayout),
	              getFieldDecorator('name', {
	                rules: [{ required: true, message: '购方名称不能为空！' }],
	                initialValue: data.name
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u91D1\u989D' }, formItemLayout),
	              getFieldDecorator('price', {
	                rules: [{ required: true, message: '金额不合法！' }],
	                initialValue: data.price || ''
	              })(_react2.default.createElement(_antd.Input, { type: 'number' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8D2D\u65B9\u7A0E\u53F7' }, formItemLayout),
	              getFieldDecorator('taxId', {
	                initialValue: data.taxId
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u4E0D\u542B\u7A0E\u91D1\u989D' }, formItemLayout),
	              getFieldDecorator('noTaxPrice', {
	                initialValue: data.noTaxPrice
	              })(_react2.default.createElement(_antd.Input, { type: 'number' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u7A0E\u7387' }, formItemLayout),
	              getFieldDecorator('taxRate', {
	                initialValue: data.taxRate
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u4EF7\u7A0E\u5408\u8BA1' }, formItemLayout),
	              getFieldDecorator('totalPrice', {
	                initialValue: data.totalPrice
	              })(_react2.default.createElement(_antd.Input, { type: 'number' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5230\u8D26\u65E5\u671F' }, formItemLayout),
	              getFieldDecorator('collectDate', {
	                initialValue: data.collectDate ? (0, _moment2.default)(data.collectDate) : data.collectDate
	              })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u6536\u6B3E\u65B9\u5F0F' }, formItemLayout),
	              getFieldDecorator('collectWay', {
	                rules: [{ required: true, message: '收款方式不能为空！' }],
	                initialValue: data.collectWay ? '' + data.collectWay : data.collectWay
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                _react2.default.createElement(
	                  Option,
	                  { value: '1' },
	                  '\u6C47\u6B3E'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '2' },
	                  '\u73B0\u91D1'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u6536\u6B3E\u94F6\u884C' }, formItemLayout),
	              getFieldDecorator('collectBank', {
	                rules: [{ required: true, message: '收款银行不能为空！' }],
	                initialValue: data.collectBank ? '' + data.collectBank : data.collectBank
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                _base2.default.bank.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.key },
	                    item.name
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { className: 'label-wrap' },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u672C\u6708\u5F00\u7968\u91D1\u989D\u4E0E\u5230\u8D26\u91D1\u989D\u662F\u5426\u76F8\u7B26' }, formItemLayout),
	              getFieldDecorator('isCorrect', {
	                rules: [{ required: true, message: '不能为空！' }],
	                initialValue: data.isCorrect ? '' + data.isCorrect : data.isCorrect
	              })(_react2.default.createElement(
	                _antd.Select,
	                null,
	                _react2.default.createElement(
	                  Option,
	                  { value: '0' },
	                  '\u662F'
	                ),
	                _react2.default.createElement(
	                  Option,
	                  { value: '1' },
	                  '\u5426'
	                )
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u9996\u6B3E\u91D1\u989D' }, formItemLayout),
	              getFieldDecorator('firstPrice', {
	                initialValue: data.firstPrice
	              })(_react2.default.createElement(_antd.Input, { type: 'number' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5C3E\u6B3E\u91D1\u989D' }, formItemLayout),
	              getFieldDecorator('balancePrice', {
	                initialValue: data.balancePrice
	              })(_react2.default.createElement(_antd.Input, { type: 'number' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u56DE\u6267\u5355\u56DE\u6536\u65E5\u671F' }, formItemLayout),
	              getFieldDecorator('recoverDate', {
	                rules: [{ required: true, message: '回执单回收日期不能为空！' }],
	                initialValue: data.recoverDate ? (0, _moment2.default)(data.recoverDate) : data.recoverDate
	              })(_react2.default.createElement(_antd.DatePicker, { style: { width: '100%' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u7533\u8BF7\u4EBA\u90E8\u95E8' }, formItemLayout),
	              getFieldDecorator('orgUuid', {
	                rules: [{ required: true, message: '部门不能为空！' }],
	                initialValue: data.orgUuid
	              })(_react2.default.createElement(_antd.TreeSelect, {
	                treeData: this.state.treeData,
	                onChange: this.onChange,
	                loadData: this.onLoadData,
	                dropdownStyle: { maxHeight: '300px', overflowY: 'scroll' }
	              }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u7533\u8BF7\u4EBA' }, formItemLayout),
	              getFieldDecorator('cusr', {
	                rules: [{ required: true, message: '申请人不能为空！' }],
	                initialValue: data.cusr
	              })(_react2.default.createElement(
	                _antd.Select,
	                { onSelect: this.setCusrName },
	                accountList.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.uuid },
	                    item.name
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u9886\u53D6\u4EBA' }, formItemLayout),
	              getFieldDecorator('receiveUserName', {
	                initialValue: data.receiveUserName
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u5907\u6CE8' }, formItemLayout),
	              getFieldDecorator('remark', {
	                initialValue: data.remark
	              })(_react2.default.createElement(_antd.Input, null))
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Index);

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _user = __webpack_require__(54);
	
	var _org = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function (e) {
	      e.preventDefault();
	      var data = _this.props.form.getFieldsValue();
	      _this.props.search(data);
	    };
	
	    _this.onChange = function (value) {
	      _this.setState({
	        orgUuid: value.length - 1
	      });
	      var data = _this.props.form.getFieldsValue();
	      data.orgUuid = _this.state.orgUuid;
	      _this.loadAccount(value[value.length - 1]);
	      _this.props.form.setFieldsValue({ userUuid: '' });
	    };
	
	    _this.loadOrg = function () {
	      var params = {};
	      params.uuid = '19F83BB0108B4255AA38D457E3FFF223';
	      (0, _org.queryOrgList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var options = [{
	            label: '全部',
	            value: '-1'
	          }];
	          res.data.map(function (item) {
	            var optionItem = {};
	            optionItem.label = item.name;
	            optionItem.value = item.uuid;
	            optionItem.isLeaf = false;
	            options.push(optionItem);
	            return options;
	          });
	          _this.setState({
	            options: options
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadAccount = function (orgUuid) {
	      var uuid = orgUuid || '';
	      (0, _user.queryAccountList)({ orgUuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            accountList: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.loadData = function (selectedOptions) {
	      var targetOption = selectedOptions[selectedOptions.length - 1];
	      targetOption.loading = true;
	      var params = {};
	      params.uuid = targetOption.value;
	      (0, _org.queryOrgList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          var options = [];
	          if (res.data.length < 1) {
	            targetOption.isLeaf = true;
	          } else {
	            res.data.map(function (item) {
	              var optionItem = {};
	              optionItem.label = item.name;
	              optionItem.value = item.uuid;
	              optionItem.isLeaf = false;
	              options.push(optionItem);
	              return options;
	            });
	            targetOption.children = options;
	          }
	
	          targetOption.loading = false;
	
	          _this.setState({
	            options: [].concat(options)
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.reset = function (e) {
	      e.preventDefault();
	      _this.props.form.setFieldsValue({
	        condition: undefined,
	        cdate: undefined,
	        orgUuid: undefined,
	        userUuid: undefined
	      });
	      var data = _this.props.form.getFieldsValue();
	      _this.props.search(data);
	    };
	
	    _this.showLable = function (label) {
	      var text = label[label.length - 1];
	      return text;
	    };
	
	    _this.state = {
	      accountList: [],
	      options: [],
	      orgUuid: ''
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadOrg();
	      this.loadAccount();
	    }
	
	    /**
	     *获取组织列表
	     */
	
	
	    /**
	     *获取用户列表
	     */
	
	
	    /**
	     * 部门显示最后一级
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var accountList = this.state.accountList;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { className: 'search-form', layout: 'horizontal', onSubmit: this.submit },
	        _react2.default.createElement(
	          _antd.Row,
	          { justify: 'space-between', type: 'flex' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 5 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('condition')(_react2.default.createElement(_antd.Input, { placeholder: '\u8BA2\u5355\u7F16\u53F7/\u5408\u540C\u7F16\u53F7' }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              getFieldDecorator('cdate')(_react2.default.createElement(_antd.DatePicker, { placeholder: '\u8BA2\u5355\u521B\u5EFA\u65F6\u95F4', style: { width: '100%' } }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 7 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u6240\u5C5E\u4EBA' }, formItemLayout),
	              getFieldDecorator('orgUuid')(_react2.default.createElement(_antd.Cascader, {
	                options: this.state.options,
	                loadData: this.loadData,
	                onChange: this.onChange,
	                placeholder: '\u90E8\u95E8',
	                changeOnSelect: true,
	                displayRender: this.showLable
	              }))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 2 },
	            _react2.default.createElement(
	              FormItem,
	              { style: { width: '100%' } },
	              getFieldDecorator('userUuid', {
	                rules: [{ message: '姓名不能为空！' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  placeholder: '\u59D3\u540D',
	                  showSearch: true,
	                  filterOption: function filterOption(input, option) {
	                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  }
	                },
	                _react2.default.createElement(
	                  Option,
	                  { key: '-1' },
	                  '\u5168\u90E8'
	                ),
	                accountList.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.uuid },
	                    item.name
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              _react2.default.createElement(
	                _antd.Row,
	                { type: 'flex', justify: 'end' },
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary', htmlType: 'submit', style: { marginRight: '10px' } },
	                  '\u641C\u7D22'
	                ),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { onClick: this.reset, style: { marginRight: '10px' } },
	                  '\u91CD\u7F6E'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create()(Index));

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _order = __webpack_require__(423);
	
	var _util = __webpack_require__(22);
	
	var _util2 = _interopRequireDefault(_util);
	
	var _ModalStep = __webpack_require__(1794);
	
	var _ModalStep2 = _interopRequireDefault(_ModalStep);
	
	var _ModalService = __webpack_require__(1793);
	
	var _ModalService2 = _interopRequireDefault(_ModalService);
	
	var _FormSearch = __webpack_require__(1791);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadDate = function (pageNo) {
	      _this.setState({
	        isLoading: true
	      });
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.condition = _this.condition || '';
	      // params.cdate = this.cdate ? moment(this.cdate).format('YYYY-MM-DD') : ""
	      params.cdate = _this.cdate || '';
	      params.orgUuid = _this.orgUuid || '';
	      params.userUuid = _this.userUuid || '';
	      if (!params.cdate) {
	        delete params.cdate;
	      }
	      _this.setState({
	        pageNo: current
	      });
	      (0, _order.queryOrderList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            isLoading: false
	          });
	        }
	      });
	    };
	
	    _this.search = function (condition) {
	      _this.condition = condition.condition ? condition.condition : '';
	      _this.cdate = condition.cdate;
	      _this.orgUuid = condition.orgUuid;
	      _this.userUuid = condition.userUuid;
	      _this.loadDate(1, 15);
	    };
	
	    _this.showStep = function () {
	      _this.setState({
	        stepVisible: true
	      });
	    };
	
	    _this.showService = function () {
	      _this.setState({
	        serviceVisible: true
	      });
	    };
	
	    _this.cancel = function () {
	      _this.setState({
	        stepVisible: false,
	        serviceVisible: false
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '订单编号',
	        dataIndex: 'orderNo',
	        key: 'orderNo',
	        width: 150
	      }, {
	        title: '创建时间',
	        dataIndex: 'createTime',
	        key: 'createTime',
	        width: 150,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '合同号',
	        dataIndex: 'contractNo',
	        key: 'contractNo',
	        width: 180
	      }, {
	        title: '客户名',
	        dataIndex: 'orderName',
	        key: 'orderName',
	        width: 350,
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text,
	            '(',
	            record.orderWay,
	            ')'
	          );
	        }
	      }, {
	        title: '合同金额',
	        dataIndex: 'contractPrice',
	        key: 'contractPrice',
	        width: 150
	      }, {
	        title: '所属人',
	        dataIndex: 'createUserName',
	        key: 'createUserName',
	        width: 150
	      }, {
	        title: '发票',
	        dataIndex: 'isInvoice',
	        key: 'isInvoice',
	        width: 150,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 0 ? '未开票' : '已开票'
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'status',
	        key: 'status',
	        width: 150,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 0 ? '未完成' : '已完成'
	          );
	        }
	      }, {
	        title: '提交审核',
	        dataIndex: 'isReview',
	        key: 'isReview',
	        width: 150,
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 0 ? '未提单' : '已提单'
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        width: 200,
	        render: function render(rext, record) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            _react2.default.createElement(
	              _reactRouter.Link,
	              { to: '/xianxing/order/' + record.uuid + '/detail' },
	              '\u8BE6\u60C5'
	            )
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      isLoading: false,
	      pageNo: 1,
	      total: 0,
	      stepVisible: false,
	      serviceVisible: false
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.cdate = '';
	      this.condition = '';
	      this.orgUuid = '';
	      this.userUuid = '';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadDate(1, 15);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    /**
	     * 获取订单列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total,
	          isLoading = _state.isLoading;
	
	      var pagination = {
	        total: total,
	        showSizeChanger: false,
	        pageSize: 15,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadDate(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      var tH = _util2.default.pageHeight() - 218;
	      var _state2 = this.state,
	          stepVisible = _state2.stepVisible,
	          serviceVisible = _state2.serviceVisible;
	
	      return _react2.default.createElement(
	        _antd.Layout,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'fixed-header' },
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'space-between', type: 'flex', style: { marginBottom: '16px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_FormSearch2.default, { search: this.search })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_antd.Table, {
	            rowKey: 'orderNo',
	            rowSelection: {},
	            columns: this.columns(),
	            loading: isLoading,
	            dataSource: data,
	            pagination: pagination,
	            style: { paddingTop: '70px' },
	            scroll: { x: 1300, y: tH }
	          }),
	          stepVisible ? _react2.default.createElement(_ModalStep2.default, { cancel: this.cancel }) : '',
	          serviceVisible ? _react2.default.createElement(_ModalService2.default, { cancel: this.cancel }) : ''
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    list: state.contract_type,
	    account_info: state.account_info
	  };
	})(Index);

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u5BA2\u670D',
	          width: 300,
	          visible: true,
	          onCancel: this.props.cancel,
	          maskClosable: false,
	          footer: false
	        },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u5BA2\u6237\u540D\u79F0:',
	              _react2.default.createElement(
	                'a',
	                { style: { marginLeft: '10px' } },
	                '\u676D\u5DDE\u5148\u884C\u79D1\u6280'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u7EF4\u62A4\u5BA2\u670D:',
	              _react2.default.createElement(
	                'a',
	                { style: { marginLeft: '10px' } },
	                '\u950B\u950B'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u7B7E\u5355\u5458\u5DE5:',
	              _react2.default.createElement(
	                'a',
	                { style: { marginLeft: '10px' } },
	                '\u4F01\u4E1AQQ'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 24 },
	            _react2.default.createElement(
	              'p',
	              null,
	              '\u5206\u914D\u65F6\u95F4:',
	              _react2.default.createElement(
	                'a',
	                { style: { marginLeft: '10px' } },
	                '2017-12-05'
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { list: state.contract_type };
	})(Index);

/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _contract = __webpack_require__(89);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.findContractType = function (id) {
	      var list = _this.props.list;
	
	      var type = list.map(function (item) {
	        if (parseInt(item.value, 10) === parseInt(id, 10)) {
	          return item.key;
	        }
	        return type;
	      });
	      for (var i = 0; i < list.length; i++) {
	        if (parseInt(list[i].value, 10) === parseInt(id, 10)) {
	          return list[i].key;
	        }
	      }
	      return type;
	    };
	
	    _this.loadDate = function (limit, type) {
	      var params = {};
	      var context = _this;
	      params.start = 0;
	      params.type = type || '';
	      params.status = 0;
	      params.limit = 10;
	      (0, _contract.queryContractList)(params).then(function (res) {
	        var selectedRowKeys = [];
	        if (res.statusCode === 200) {
	          res.data.map(function (item) {
	            item.type = _this.findContractType(item.type);
	            selectedRowKeys.push(item.uuid);
	            return selectedRowKeys;
	          });
	          context.setState({
	            data: res.data,
	            total: res.totalSize,
	            selectedRowKeys: selectedRowKeys
	          });
	        }
	      });
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '序号',
	        dataIndex: 'no',
	        key: 'no'
	      }, {
	        title: '步骤',
	        dataIndex: 'status',
	        key: 'status',
	        render: function render(text) {
	          var status = '';
	          if (text === 0) {
	            status = '未使用';
	          } else if (text === 1) {
	            status = '已使用';
	          } else if (text === 2) {
	            status = '遗失';
	          } else if (text === 3) {
	            status = '作废';
	          } else if (text === 4) {
	            status = '已分配';
	          } else if (text === 5) {
	            status = '待审核';
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            status
	          );
	        }
	      }, {
	        title: '执行角色',
	        dataIndex: 'type',
	        key: 'type',
	        render: function render(text) {
	          // let type = this.find_contract_type(text)
	          return _react2.default.createElement(
	            'span',
	            null,
	            text
	          );
	        }
	      }, {
	        title: '审核人',
	        dataIndex: 'cdate',
	        key: 'cdate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '审核时间',
	        dataIndex: 'maturityDate',
	        key: 'maturityDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '停留',
	        dataIndex: 'allocateDate',
	        key: 'allocateDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '状态',
	        dataIndex: 'allocateDate1',
	        key: 'allocateDate1',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '审核备注',
	        dataIndex: 'allocateDate2',
	        key: 'allocateDate2',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }];
	    };
	
	    _this.onSelectChange = function (selectedRowKeys) {
	      _this.setState({
	        selectedRowKeys: selectedRowKeys
	      });
	    };
	
	    _this.submit = function () {
	      var _this$props = _this.props,
	          record = _this$props.record,
	          cancel = _this$props.cancel,
	          loadDate = _this$props.loadDate;
	
	      var data = {};
	      data.uuid = record.uuid;
	      data.contractUuids = _this.state.selectedRowKeys;
	      if (data.contractUuids < 1) {
	        _antd.message.error('暂时没有可分配的合同！');
	        return;
	      }
	      (0, _contract.queryAllotApplyContract)(data).then(function (res) {
	        if (res.statusCode === 200) {
	          _antd.message.success(res.message);
	          cancel();
	          loadDate();
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      data: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadDate();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        _antd.Modal,
	        {
	          title: '\u6B65\u9AA4',
	          width: 800,
	          visible: true,
	          onCancel: cancel,
	          onOk: this.submit,
	          maskClosable: false,
	          footer: false
	        },
	        _react2.default.createElement(
	          _antd.Row,
	          null,
	          _react2.default.createElement(_antd.Table, {
	            columns: this.columns(),
	            dataSource: data,
	            pagination: false,
	            bordered: true,
	            rowKey: 'uuid'
	          })
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return { list: state.contract_type };
	})(Index);

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _order = __webpack_require__(423);
	
	var _base = __webpack_require__(328);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _BackBtn = __webpack_require__(12);
	
	__webpack_require__(1185);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	var _Pro = __webpack_require__(1796);
	
	var _Pro2 = _interopRequireDefault(_Pro);
	
	var _ProAd = __webpack_require__(1797);
	
	var _ProAd2 = _interopRequireDefault(_ProAd);
	
	var _ProCRM = __webpack_require__(1798);
	
	var _ProCRM2 = _interopRequireDefault(_ProCRM);
	
	var _ProDomain = __webpack_require__(1799);
	
	var _ProDomain2 = _interopRequireDefault(_ProDomain);
	
	var _ProEmail = __webpack_require__(1800);
	
	var _ProEmail2 = _interopRequireDefault(_ProEmail);
	
	var _ProFans = __webpack_require__(1801);
	
	var _ProFans2 = _interopRequireDefault(_ProFans);
	
	var _ProMom = __webpack_require__(1802);
	
	var _ProMom2 = _interopRequireDefault(_ProMom);
	
	var _ProQqNew = __webpack_require__(1803);
	
	var _ProQqNew2 = _interopRequireDefault(_ProQqNew);
	
	var _ProQqNew3 = __webpack_require__(1804);
	
	var _ProQqNew4 = _interopRequireDefault(_ProQqNew3);
	
	var _ProQqSequel = __webpack_require__(1805);
	
	var _ProQqSequel2 = _interopRequireDefault(_ProQqSequel);
	
	var _ProWxWebsite = __webpack_require__(1806);
	
	var _ProWxWebsite2 = _interopRequireDefault(_ProWxWebsite);
	
	var _ProYoudao = __webpack_require__(1807);
	
	var _ProYoudao2 = _interopRequireDefault(_ProYoudao);
	
	var _ProZone = __webpack_require__(1808);
	
	var _ProZone2 = _interopRequireDefault(_ProZone);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // 4.空间
	// 6+8.400电话
	// 15.广告下单
	// 12.爱上班+13.爱客-CRM+14.爱客-钉钉
	// 3.域名
	// 5.邮箱
	// 16.微信吸粉
	// 18.妈妈去哪儿
	// 1.2月企业QQ新开
	// 7.5月企业QQ新开
	// 2.企业QQ续费
	// 9.网站+10.微信网站（微客来）+11.微信网站（赢客来
	// 17.有道云
	
	
	var TabPane = _antd.Tabs.TabPane;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.callback = function () {};
	
	    _this.loadOrderDetail = function (uuid) {
	      (0, _order.queryOrderInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data
	          });
	        }
	      });
	    };
	
	    _this.goBack = function () {
	      _this.props.router.go(-1);
	    };
	
	    _this.judgeInvoiceType = function (type) {
	      var invoiceType = '';
	      if (type === '1') {
	        invoiceType = '国税网络在线发票';
	      } else if (type === '2') {
	        invoiceType = '增值税专用发票';
	      } else if (type === '3') {
	        invoiceType = '增值税普通发票';
	      }
	      return invoiceType;
	    };
	
	    _this.judgeSubmitType = function (type) {
	      var submitType = '';
	      if (type === '1') {
	        submitType = '提前开票';
	      } else if (type === '2') {
	        submitType = '到账开票';
	      }
	      return submitType;
	    };
	
	    _this.judgeBank = function (id) {
	      var bank = '';
	      _base2.default.bank.map(function (item) {
	        if (item.key === id) {
	          bank = item.name;
	          return bank;
	        }
	        return item;
	      });
	      return bank;
	    };
	
	    _this.state = {
	      data: {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {}
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var uuid = this.props.params.orderUuid;
	      this.loadOrderDetail(uuid);
	    }
	
	    /**
	     * 获取订单详情
	     */
	
	
	    /**
	     * 发票类型
	     */
	
	
	    /**
	     * 申请类型
	     */
	
	
	    /**
	     * 判断开户银行
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'description' },
	        _react2.default.createElement(
	          _antd.Row,
	          { justify: 'start', type: 'flex', style: { marginBottom: '16px' } },
	          _react2.default.createElement(_BackBtn.BackBtn, null)
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u57FA\u672C\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u7B7E\u5355\u540D\u79F0', col: 24 },
	              _react2.default.createElement(
	                'span',
	                null,
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  data.orderName || ''
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  data.orderNo ? '(' + data.orderNo + ')' : ''
	                ),
	                _react2.default.createElement(
	                  'span',
	                  null,
	                  data.orderObject ? '[' + data.orderObject + ']' : ''
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u6253\u6B3E\u540D\u79F0' },
	              data.recieveName
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u7B7E\u5355\u65E5\u671F' },
	              data.createTime ? _moment2.default.unix(data.createTime / 1000).format('YYYY-MM-DD') : ''
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u5408\u540C\u53F7' },
	              data.contractNo
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u7B7E\u5355\u9500\u552E' },
	              data.cusrName
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u8425\u4E1A\u6267\u7167\u56FE' },
	              data.companyPic ? _react2.default.createElement(
	                'a',
	                { href: data.companyPic },
	                '\u67E5\u770B'
	              ) : ''
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u5408\u540C\u9644\u4EF6' },
	              data.contractPic ? _react2.default.createElement(
	                'a',
	                { href: data.contractPic },
	                '\u67E5\u770B'
	              ) : ''
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(
	                _antd.Row,
	                { type: 'flex' },
	                _react2.default.createElement(
	                  _antd.Col,
	                  { style: { width: '90px' } },
	                  _react2.default.createElement(
	                    'span',
	                    { className: 'title' },
	                    '\u7B7E\u5355\u5907\u6CE8\u4FE1\u606F\uFF1A'
	                  )
	                ),
	                _react2.default.createElement(
	                  _antd.Col,
	                  { style: { width: '80%' } },
	                  _react2.default.createElement('span', { dangerouslySetInnerHTML: { __html: data.orderRemark } })
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u7B7E\u5355\u8D39\u7528\u660E\u7EC6' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u4E3B\u8981\u8D39\u7528' },
	              data.mainPrice
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u8D2D\u4E70\u5E74\u9650' },
	              data.years
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u53C2\u52A0\u6D3B\u52A8' },
	              '\u4E0D\u53C2\u52A0\u6D3B\u52A8'
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u6C47\u6B3E\u5E95\u5355' },
	              data.payPic ? _react2.default.createElement(
	                'a',
	                { href: data.payPic },
	                '\u67E5\u770B'
	              ) : ''
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u8D39\u7528\u603B\u8BA1' },
	              data.totalPrice
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u5DF2\u6536\u6B3E' },
	              data.recievedPrice
	            )
	          )
	        ),
	        data.projectType === 1 ? _react2.default.createElement(_ProQqNew2.default, { proinfo: data.project, title: '2\u6708\u4F01\u4E1AQQ\u65B0\u5F00' }) : '',
	        data.projectType === 2 ? _react2.default.createElement(_ProQqSequel2.default, { proinfo: data.project, title: '\u4F01\u4E1AQQ\u7EED\u8D39' }) : '',
	        data.projectType === 3 ? _react2.default.createElement(_ProDomain2.default, { proinfo: data.project, title: '\u57DF\u540D' }) : '',
	        data.projectType === 4 ? _react2.default.createElement(_ProZone2.default, { proinfo: data.project, title: '\u7A7A\u95F4' }) : '',
	        data.projectType === 5 ? _react2.default.createElement(_ProEmail2.default, { proinfo: data.project, title: '\u90AE\u7BB1' }) : '',
	        data.projectType === 6 || data.projectType === 8 ? _react2.default.createElement(_Pro2.default, { proinfo: data.project, title: '\u7535\u8BDD400' }) : '',
	        data.projectType === 7 ? _react2.default.createElement(_ProQqNew4.default, { proinfo: data.project, title: '5\u6708\u4F01\u4E1AQQ\u65B0\u5F00' }) : '',
	        data.projectType === 9 ? _react2.default.createElement(_ProWxWebsite2.default, { proinfo: data.project, title: '\u7F51\u7AD9' }) : '',
	        data.projectType === 10 ? _react2.default.createElement(_ProWxWebsite2.default, { proinfo: data.project, title: '\u5FAE\u4FE1\u7F51\u7AD9\uFF08\u5FAE\u5BA2\u6765\uFF09' }) : '',
	        data.projectType === 11 ? _react2.default.createElement(_ProWxWebsite2.default, { proinfo: data.project, title: '\u5FAE\u4FE1\u7F51\u7AD9\uFF08\u8D62\u5BA2\u6765\uFF09' }) : '',
	        data.projectType === 12 ? _react2.default.createElement(_ProCRM2.default, { proinfo: data.project, title: '\u7231\u4E0A\u73ED' }) : '',
	        data.projectType === 13 ? _react2.default.createElement(_ProCRM2.default, { proinfo: data.project, title: '\u7231\u5BA2-CRM' }) : '',
	        data.projectType === 14 ? _react2.default.createElement(_ProCRM2.default, { proinfo: data.project, title: '\u7231\u5BA2-\u9489\u9489' }) : '',
	        data.projectType === 15 ? _react2.default.createElement(_ProAd2.default, { proinfo: data.project, title: '\u5E7F\u544A\u4E0B\u5355' }) : '',
	        data.projectType === 16 ? _react2.default.createElement(_ProFans2.default, { proinfo: data.project, title: '\u5FAE\u4FE1\u5438\u7C89' }) : '',
	        data.projectType === 17 ? _react2.default.createElement(_ProYoudao2.default, { proinfo: data.project, title: '\u6709\u9053\u4E91' }) : '',
	        data.projectType === 18 ? _react2.default.createElement(_ProMom2.default, { proinfo: data.project, title: '\u5988\u5988\u53BB\u54EA\u513F' }) : '',
	        data.invoices && data.invoices.length > 0 ? _react2.default.createElement(
	          _antd.Card,
	          { title: '\u5F00\u7968\u4FE1\u606F', className: 'invoices' },
	          _react2.default.createElement(
	            _antd.Tabs,
	            { onChange: this.callback },
	            data.invoices.map(function (item, index) {
	              return _react2.default.createElement(
	                TabPane,
	                { tab: '\u53D1\u7968' + (index + 1), key: item.uuid },
	                _react2.default.createElement(
	                  _antd.Row,
	                  { gutter: 25 },
	                  _react2.default.createElement(
	                    _antd.Col,
	                    { span: 11, offset: 1 },
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u5DF2\u5F00\u53D1\u7968', col: 24 },
	                      item.no
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u7533\u8BF7\u7C7B\u578B', col: 24 },
	                      function () {
	                        return _this2.judgeSubmitType(item.submitType);
	                      }
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u53D1\u7968\u62AC\u5934', col: 24 },
	                      item.invoiceTop
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u53D1\u7968\u7C7B\u578B', col: 24 },
	                      function () {
	                        return _this2.judgeInvoiceType(item.invoiceType);
	                      }
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u91D1\u989D', col: 24 },
	                      item.price
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u5F00\u6237\u94F6\u884C', col: 24 },
	                      function () {
	                        return _this2.judgeBank(item.bank);
	                      }
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u6CE8\u518C\u7535\u8BDD', col: 24 },
	                      item.mobile
	                    )
	                  ),
	                  _react2.default.createElement(
	                    _antd.Col,
	                    { span: 11 },
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u5F00\u7968\u516C\u53F8', col: 24 },
	                      item.companyName
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u5F00\u7968\u4EBA', col: 24 },
	                      item.cusrName
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u4F01\u4E1A\u7A0E\u53F7', col: 24 },
	                      item.taxId
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u7A0E\u52A1\u767B\u8BB0\u8BC1\u526F\u672C', col: 24 },
	                      item.taxCert ? _react2.default.createElement(
	                        'a',
	                        { href: item.taxCert },
	                        '\u67E5\u770B'
	                      ) : ''
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u94F6\u884C\u8D26\u6237', col: 24 },
	                      item.account
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u6CE8\u518C\u5730\u5740', col: 24 },
	                      item.regAddr
	                    ),
	                    _react2.default.createElement(
	                      _Description2.default,
	                      { term: '\u5907\u6CE8', col: 24 },
	                      item.remark
	                    )
	                  )
	                )
	              );
	            })
	          )
	        ) : '',
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u8054\u7CFB\u4EBA\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u8054\u7CFB\u4EBA' },
	              data.contactName
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u804C\u4F4D' },
	              data.contactPosition
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u5EA7\u673A' },
	              data.contactPhone
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _Description2.default,
	              { term: 'E-mail' },
	              data.contactEmail
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u624B\u673A\u53F7' },
	              data.contactMobile
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: 'QQ' },
	              data.contactQq
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _antd.Card,
	          { title: '\u4F01\u4E1A\u8D1F\u8D23\u4EBA\u4FE1\u606F' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u8054\u7CFB\u4EBA' },
	              data.principalName
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u804C\u4F4D' },
	              data.principalPosition
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u5EA7\u673A' },
	              data.principalPhone
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              _Description2.default,
	              { term: 'E-mail' },
	              data.principalEmail
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: '\u624B\u673A\u53F7' },
	              data.principalPhone
	            ),
	            _react2.default.createElement(
	              _Description2.default,
	              { term: 'QQ' },
	              data.principalQq
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u53F7\u7801" },
	          data.c_400_account
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u6700\u4F4E\u6D88\u8D39(\u5143/\u6708)" },
	          data.c_lowest_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u8BDD\u8D39\u5145\u503C\u91D1\u989D" },
	          data.c_recharge_momey
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProQqNew2;

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7C7B\u578B" },
	          data.c_wei_advtype
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u9884\u5B58\u8D39" },
	          data.c_storefee
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u670D\u52A1\u8D39" },
	          data.c_servicefee
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u6253\u6B3E\u91D1\u989D" },
	          data.c_playmoney
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5907\u6CE8" },
	          data.c_advmark
	        )
	      )
	    )
	  );
	}; // 广告下单
	exports.default = ProQqNew2;

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      null,
	      "\u5FAE\u4FE1\u7F51\u7AD9(\u5FAE\u5BA2\u6765)"
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5DE5\u53F7" },
	          data.c_num
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D60\u9001\u5E74\u9650" },
	          data.c_free
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5E74\u6570" },
	          data.c_years
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4EF7\u683C" },
	          data.c_money
	        )
	      )
	    )
	  );
	}; // 爱上班、爱客-CRM、爱客-钉钉
	exports.default = ProQqNew2;

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4F9B\u5E94\u5546" },
	          data.c_provider
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4E3B\u57DF\u540D" },
	          data.c_main_domain
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5E74\u6570" },
	          data.c_years
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D60\u9001\u5E74\u9650" },
	          data.c_free
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4EF7\u683C" },
	          data.c_money
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProQqNew2;

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4F9B\u5E94\u5546" },
	          data.c_provider
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7A7A\u95F4\u5927\u5C0F" },
	          data.c_size
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7528\u6237\u6570" },
	          data.c_num
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4E3B\u57DF\u540D" },
	          data.c_main_domain
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5E74\u6570" },
	          data.c_years
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D60\u9001\u5E74\u9650" },
	          data.c_free
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4EF7\u683C" },
	          data.c_money
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProQqNew2;

/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5438\u7C89\u6570\u91CF" },
	          data.c_suckfans
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u6253\u6B3E\u91D1\u989D" },
	          data.c_playmoney
	        )
	      )
	    )
	  );
	}; // 微信吸粉
	exports.default = ProQqNew2;

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4EA7\u54C1\u7C7B\u578B" },
	          data.mon_type
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u670D\u52A1\u533A\u57DF" },
	          data.mon_area
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u670D\u52A1\u671F\u9650" },
	          data.mom_time
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5355\u4EF7" },
	          data.mom_unit
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u603B\u91D1\u989D" },
	          data.mom_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u603B\u91D1\u989D\u5927\u5199" },
	          data.mom_name
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4FE1\u606F\u8BE6\u60C5" },
	          data.mom_market
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProQqNew2;

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u4F01\u4E1AQQ\u53F7\u7801" },
	          data.bq400_account
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u7C7B\u578B" },
	          data.bq400v
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u5DE5\u53F7\u6570" },
	          data.bq400_enum
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u8D2D\u4E70\u5E74\u9650" },
	          data.bq400_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u8D60\u9001\u5E74\u9650" },
	          data.bq400_free
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u670D\u52A1\u8D39" },
	          data.bq400_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u4F01\u4E1AQQ\u53F7\u7801" },
	          data.bq800_account
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u7C7B\u578B" },
	          data.bq800v
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u5DE5\u53F7\u6570" },
	          data.bq800_enum
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u8D2D\u4E70\u5E74\u9650" },
	          data.bq800_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u8D60\u9001\u5E74\u9650" },
	          data.bq800_free
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u670D\u52A1\u8D39" },
	          data.bq800_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u529E\u516C\u4F01\u4E1AQQ\u5957\u9910\u7C7B\u578B" },
	          data.bqv
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u529E\u516C\u4F01\u4E1AQQ\u5F00\u5934" },
	          data.bqh
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u529E\u516C\u4F01\u4E1AQQ\u5DE5\u53F7\u6570" },
	          data.bq_enum
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u529E\u516C\u4F01\u4E1AQQ\u8D2D\u4E70\u5E74\u9650" },
	          data.bq_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u8D60\u9001\u5E74\u9650" },
	          data.bq_free
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u529E\u516C\u4F01\u4E1AQQ\u9001\u5E74\u9650" },
	          data.bq800_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u529E\u516C\u4F01\u4E1AQQ\u670D\u52A1\u8D39" },
	          data.bq_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u503C\u670D\u52A1\u7FA4\u53D1\u5145\u503C" },
	          data.ad_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u503C\u670D\u52A1\u77ED\u4FE1\u5145\u503C" },
	          data.msg_message
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u503C\u670D\u52A1\u79BB\u7EBF\u6D88\u606F\u8F6C\u53D1" },
	          data.offmsg_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u503C\u670D\u52A1\u5FAE\u4FE1\u8BA4\u8BC1" },
	          data.weixin_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u90AE\u7BB1\u7248\u672C" },
	          data.email_version
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u90AE\u7BB1\u7528\u6237\u6570" },
	          data.email_num
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u90AE\u7BB1\u8D2D\u4E70\u5E74\u9650" },
	          data.email_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u90AE\u7BB1\u670D\u52A1\u8D39" },
	          data.email_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u539F\u53F7\u7801" },
	          data.bq_old_account
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u539F\u7248\u672C" },
	          data.bq_oldv
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u5DE5\u53F7\u6570" },
	          data.bq_old_enum
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u8D2D\u4E70\u5E74\u9650" },
	          data.bq_old_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u73B0\u53F7\u7801" },
	          data.bq_new_account
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u73B0\u7248\u672C" },
	          data.bq_newv
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u5DE5\u53F7\u6570" },
	          data.bq_new_enum
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u8D2D\u4E70\u5E74\u9650" },
	          data.bq_new_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u66F4\u6362\u91D1\u989D" },
	          data.bq_change_money
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProQqNew2;

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u670D\u52A1\u7C7B\u578B" },
	          data.qq_service
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u670D\u52A1\u8D39" },
	          data.qq_service_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u4F01\u4E1AQQ\u53F7\u7801" },
	          data.bq400_account
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u7C7B\u578B" },
	          data.bq400v
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u5DE5\u53F7\u6570" },
	          data.bq400_enum
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u8D2D\u4E70\u5E74\u9650" },
	          data.bq400_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u8D60\u9001\u5E74\u9650" },
	          data.bq400_free
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "400\u5957\u9910\u670D\u52A1\u8D39" },
	          data.bq400_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u4F01\u4E1AQQ\u53F7\u7801" },
	          data.bq800_account
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u7C7B\u578B" },
	          data.bq800v
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u5DE5\u53F7\u6570" },
	          data.bq800_enum
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u8D2D\u4E70\u5E74\u9650" },
	          data.bq800_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u8D60\u9001\u5E74\u9650" },
	          data.bq800_free
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u670D\u52A1\u8D39" },
	          data.bq800_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u529E\u516C\u4F01\u4E1AQQ\u5957\u9910\u7C7B\u578B" },
	          data.bqv
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u529E\u516C\u4F01\u4E1AQQ\u5F00\u5934" },
	          data.bqh
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u529E\u516C\u4F01\u4E1AQQ\u5DE5\u53F7\u6570" },
	          data.bq_enum
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u529E\u516C\u4F01\u4E1AQQ\u8D2D\u4E70\u5E74\u9650" },
	          data.bq_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "800\u5957\u9910\u8D60\u9001\u5E74\u9650" },
	          data.bq_free
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u5DE5\u53F7\u6570" },
	          data.bq_new_enum
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u529E\u516C\u4F01\u4E1AQQ\u670D\u52A1\u8D39" },
	          data.bq_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u8D2D\u4E70\u5E74\u9650" },
	          data.bq_new_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u66F4\u6362\u91D1\u989D" },
	          data.bq_change_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4F01\u70B9\u670D\u52A1QQ" },
	          data.bq900v
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4F01\u70B9\u670D\u52A1QQ\u9753\u53F7\u53F7\u7801" },
	          data.bq900_account
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4F01\u70B9\u670D\u52A1QQ\u5DE5\u4F4D\u53F7" },
	          data.bq900_enum
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4F01\u70B9\u670D\u52A1QQ\u8D2D\u4E70\u5E74\u9650" },
	          data.bq900_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4F01\u70B9\u670D\u52A1QQ\u8D60\u9001\u5E74\u9650" },
	          data.bq900_freet
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4F01\u70B9\u670D\u52A1QQ\u8D39\u7528" },
	          data.bq900_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u516C\u4F17\u53F7" },
	          data.weixin
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5FAE\u4FE1\u5236\u4F5C\u8D39\u7528" },
	          data.weixin_make_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u662F\u5426\u8BA4\u8BC1" },
	          data.weixin_attest
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8BA4\u8BC1\u8D39" },
	          data.weixin_attest_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D2D\u4E70\u5E74\u9650" },
	          data.weixin_years
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D60\u9001\u5E74\u9650" },
	          data.weixin_free_years
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5FAE\u4FE1\u7248\u672C" },
	          data.weixin_version
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7248\u672C\u8D39\u7528" },
	          data.weixin_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u503C\u670D\u52A1\u7FA4\u53D1\u5145\u503C" },
	          data.ad_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u503C\u670D\u52A1\u77ED\u4FE1\u5145\u503C" },
	          data.msg_message
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u503C\u670D\u52A1\u79BB\u7EBF\u6D88\u606F\u8F6C\u53D1" },
	          data.offmsg_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u90AE\u7BB1\u7248\u672C" },
	          data.email_version
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u90AE\u7BB1\u7528\u6237\u6570" },
	          data.email_num
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u90AE\u7BB1\u8D2D\u4E70\u5E74\u9650" },
	          data.email_years
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u90AE\u7BB1\u670D\u52A1\u8D39" },
	          data.email_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u539F\u53F7\u7801" },
	          data.bq_old_account
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u539F\u7248\u672C" },
	          data.bq_oldv
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u5DE5\u53F7\u6570" },
	          data.bq_old_enum
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u8D2D\u4E70\u5E74\u9650" },
	          data.bq_old_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u73B0\u53F7\u7801" },
	          data.bq_new_account
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u66F4\u6362\u7248\u672C\u73B0\u7248\u672C" },
	          data.bq_newv
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProQqNew2;

/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7248\u672C" },
	          data.c_pdtversion
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "qq\u4E3B\u5E10\u53F7" },
	          data.c_account_main
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5F00\u901A\u65F6\u95F4" },
	          data.c_open_time
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5230\u671F\u65F6\u95F4" },
	          data.c_end_time
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5DE5\u4F4D" },
	          data.c_account_num
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u670D\u52A1\u7C7B\u578B" },
	          data.qq_service
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u670D\u52A1\u8D39" },
	          data.qq_service_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7FA4\u53D1\u5145\u503C" },
	          data.qq_message
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u77ED\u4FE1\u5145\u503C" },
	          data.message
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7C7B\u578B" },
	          data.c_type
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u52A0\u51CF\u5DE5\u53F7" },
	          data.add_qq
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u53D8\u66F4\u5DE5\u53F7" },
	          data.c_add_num
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D39\u7528" },
	          data.c_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7EED\u8D39\u5E74\u9650" },
	          data.c_years
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D60\u9001\u5E74\u9650" },
	          data.c_free
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4FDD\u53F7\u8D39" },
	          data.c_protect
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D39\u7528" },
	          data.c_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5FAE\u4FE1\u5236\u4F5C\u8D39\u7528" },
	          data.weixinx_make_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u662F\u5426\u8BA4\u8BC1" },
	          data.wei_attest
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D77\u59CB\u7248\u672C" },
	          data.wei_version
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5347\u7EA7\u7248\u672C" },
	          data.wei_version_up
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7528\u6237\u6570" },
	          data.c_email_num
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5E74\u6570" },
	          data.c_years
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D39\u7528" },
	          data.email_money
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProQqNew2;

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7248\u672C" },
	          data.c_wei_version
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5E74\u6570" },
	          data.c_years
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D60\u9001\u5E74\u9650" },
	          data.c_free
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4EF7\u683C" },
	          data.c_money
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProQqNew2;

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7532\u65B9\u4E3B\u8D26\u53F7" },
	          data.b_user
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5BB9\u7EB3\u8D26\u6237" },
	          data.b_oldv
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u670D\u52A1\u671F" },
	          data.b_year
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5E10\u53F7\u5355\u4EF7(\u5143/\u4EBA/\u6708)" },
	          data.b_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D60\u9001\u7A7A\u95F4(TB)" },
	          data.b_memory
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7A7A\u95F4\u52A0\u8D2D(\u5143/TB)" },
	          data.b_moneys
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u603B\u91D1\u989D\u5927\u5199" },
	          data.b_name
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u603B\u91D1\u989D" },
	          data.bs_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5927\u5BA2\u6237\u7532\u65B9\u4E3B\u8D26\u53F7" },
	          data.d_user
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5927\u5BA2\u6237\u5BB9\u7EB3\u8D26\u6237" },
	          data.d_oldv
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5927\u5BA2\u6237\u670D\u52A1\u671F" },
	          data.d_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5927\u5BA2\u6237\u5E10\u53F7\u5355\u4EF7(\u5143/\u4EBA/\u6708)" },
	          data.d_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5927\u5BA2\u6237\u8D60\u9001\u7A7A\u95F4(TB)" },
	          data.d_memory
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5927\u5BA2\u6237\u7A7A\u95F4\u52A0\u8D2D(\u5143/TB)" },
	          data.d_moneys
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5927\u5BA2\u6237\u603B\u91D1\u989D\u5927\u5199" },
	          data.d_name
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5927\u5BA2\u6237\u603B\u91D1\u989D" },
	          data.ds_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u5BA2\u6237\u7532\u65B9\u4E3B\u8D26\u53F7" },
	          data.z_user
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u5BA2\u6237\u589E\u52A0\u6570\u91CF" },
	          data.z_num
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u5BA2\u6237\u5E10\u53F7\u5355\u4EF7(\u5143/\u4EBA/\u6708)" },
	          data.z_money
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u5BA2\u6237\u8D77\u59CB\u65E5\u671F\u5E74" },
	          data.z_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u5BA2\u6237\u8D77\u59CB\u65E5\u671F\u6708" },
	          data.z_month
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u5BA2\u6237\u8D77\u59CB\u65E5\u671F\u65E5" },
	          data.z_day
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u5BA2\u6237\u603B\u91D1\u989D\u5927\u5199" },
	          data.z_name
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u5BA2\u6237\u603B\u91D1\u989D" },
	          data.zs_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u7A7A\u95F4\u7532\u65B9\u4E3B\u8D26\u53F7" },
	          data.add_user
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u7A7A\u95F4\u589E\u52A0\u5BB9\u91CF(0:GB;1:TB)" },
	          data.add_bytes
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u7A7A\u95F4\u5E10\u53F7\u5355\u4EF7(\u5143/\u4EBA/\u6708)" },
	          data.add_money
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u7A7A\u95F4\u8D77\u59CB\u65E5\u671F\u5E74" },
	          data.add_year
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u7A7A\u95F4\u8D77\u59CB\u65E5\u671F\u6708" },
	          data.add_month
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u7A7A\u95F4\u8D77\u59CB\u65E5\u671F\u65E5" },
	          data.add_day
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u7A7A\u95F4\u603B\u91D1\u989D\u5927\u5199" },
	          data.add_name
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u589E\u52A0\u7A7A\u95F4\u603B\u91D1\u989D" },
	          data.adds_money
	        )
	      )
	    )
	  );
	}; // 有道云
	exports.default = ProQqNew2;

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _Description = __webpack_require__(91);
	
	var _Description2 = _interopRequireDefault(_Description);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ProQqNew2 = function ProQqNew2(_ref) {
	  var proinfo = _ref.proinfo,
	      title = _ref.title;
	
	  var data = proinfo || {};
	  return _react2.default.createElement(
	    _antd.Card,
	    { title: "\u4EA7\u54C1\u660E\u7EC6" },
	    _react2.default.createElement(
	      "h3",
	      { className: "order_pro_title" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { style: { paddingLeft: "50px" } },
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4F9B\u5E94\u5546" },
	          data.c_provider
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7A7A\u95F4\u5927\u5C0F" },
	          data.c_size
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7C7B\u578B" },
	          data.c_spacev
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u7ED1\u5B9A\u57DF\u540D" },
	          data.c_main_domain
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u5E74\u6570" },
	          data.c_years
	        ),
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u8D60\u9001\u5E74\u9650" },
	          data.c_free
	        )
	      ),
	      _react2.default.createElement(
	        _antd.Row,
	        null,
	        _react2.default.createElement(
	          _Description2.default,
	          { term: "\u4EF7\u683C" },
	          data.c_money
	        )
	      )
	    )
	  );
	};
	
	exports.default = ProQqNew2;

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _protect = __webpack_require__(231);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.loadDetail = function (uuid) {
	      (0, _protect.queryProtectionInfo)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            data: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.state = {
	      data: {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadDetail(this.props.protectUuid);
	    }
	
	    /**
	     * 获取客户保护详情
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var cancel = this.props.cancel;
	      var data = this.state.data;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      return _react2.default.createElement(
	        _antd.Modal,
	        { title: '\u67E5\u770B', width: 400, visible: true, onCancel: cancel, footer: false },
	        _react2.default.createElement(
	          _antd.Form,
	          { className: 'modal', layout: 'inline' },
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u516C\u53F8\u540D\u79F0' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                data.name
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8054\u7CFB\u4EBA\u59D3\u540D' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                data.contactName
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8054\u7CFB\u4EBA\u7535\u8BDD' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                data.phone
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8054\u7CFB\u4EBA\u624B\u673A' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                data.mobile
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u884C\u4E1A' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                data.industry
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u516C\u53F8\u7F51\u5740' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                { className: 'word-wrap' },
	                data.url
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u6CD5\u4EBA\u59D3\u540D' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                data.legal
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u516C\u53F8\u5730\u5740' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                data.area
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            null,
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u8BE6\u7EC6\u5730\u5740' }, formItemLayout),
	              _react2.default.createElement(
	                'p',
	                null,
	                data.addr
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = _antd.Form.create()(Index);

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRedux = __webpack_require__(5);
	
	var _user = __webpack_require__(54);
	
	var _SelectOrg = __webpack_require__(324);
	
	var _SelectOrg2 = _interopRequireDefault(_SelectOrg);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var FormItem = _antd.Form.Item;
	var Option = _antd.Select.Option;
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.submit = function (e) {
	      e.preventDefault();
	      var data = _this.props.form.getFieldsValue();
	      data.orgUuid = _this.state.orgUuid;
	      _this.props.search(data);
	    };
	
	    _this.onChangeOrg = function (value) {
	      _this.setState({
	        orgUuid: value
	      });
	      _this.loadAccount(value);
	      _this.props.form.setFieldsValue({ userUuid: '' });
	    };
	
	    _this.loadAccount = function (orgUuid) {
	      var uuid = orgUuid || '';
	      (0, _user.queryAccountList)({ orgUuid: uuid }).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.setState({
	            accountList: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.reset = function (e) {
	      e.preventDefault();
	      _this.props.form.resetFields();
	      _this.setState({
	        orgUuid: undefined
	      });
	      var data = _this.props.form.getFieldsValue();
	      _this.props.search(data);
	    };
	
	    _this.state = {
	      accountList: [],
	      orgUuid: ''
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.loadAccount();
	    }
	
	    /**
	     *获取用户列表
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var getFieldDecorator = this.props.form.getFieldDecorator;
	
	      var formItemLayout = {
	        labelCol: { span: 8 },
	        wrapperCol: { span: 16 }
	      };
	      var accountList = this.state.accountList;
	
	      return _react2.default.createElement(
	        _antd.Form,
	        { className: 'search-form', layout: 'horizontal', onSubmit: this.submit },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({}, formItemLayout, { label: '\u5BA2\u6237\u540D\u79F0' }),
	              getFieldDecorator('name')(_react2.default.createElement(_antd.Input, null))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 8 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u4FDD\u62A4\u4EBA\u90E8\u95E8' }, formItemLayout),
	              _react2.default.createElement(_SelectOrg2.default, {
	                onChange: this.onChangeOrg,
	                orgUuid: this.state.orgUuid,
	                placeholder: '\u4FDD\u62A4\u4EBA\u90E8\u95E8'
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 6 },
	            _react2.default.createElement(
	              FormItem,
	              Object.assign({ label: '\u4FDD\u62A4\u4EBA' }, formItemLayout),
	              getFieldDecorator('userUuid', {
	                rules: [{ message: '姓名不能为空！' }]
	              })(_react2.default.createElement(
	                _antd.Select,
	                {
	                  showSearch: true,
	                  optionFilterProp: 'children',
	                  placeholder: '\u4FDD\u62A4\u4EBA\u59D3\u540D',
	                  filterOption: function filterOption(input, option) {
	                    return option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
	                  }
	                },
	                accountList.map(function (item) {
	                  return _react2.default.createElement(
	                    Option,
	                    { key: item.uuid },
	                    item.name
	                  );
	                })
	              ))
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 4 },
	            _react2.default.createElement(
	              FormItem,
	              null,
	              _react2.default.createElement(
	                _antd.Row,
	                { type: 'flex', justify: 'end' },
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary', htmlType: 'submit', style: { marginRight: '10px' } },
	                  '\u641C\u7D22'
	                ),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { onClick: this.reset, style: { marginRight: '10px' } },
	                  '\u91CD\u7F6E'
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return state;
	})(_antd.Form.create()(Index));

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _reactRouter = __webpack_require__(8);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _protect = __webpack_require__(231);
	
	var _industry_list = __webpack_require__(438);
	
	var _FormAddCus = __webpack_require__(728);
	
	var _FormAddCus2 = _interopRequireDefault(_FormAddCus);
	
	var _DetailCus = __webpack_require__(1809);
	
	var _DetailCus2 = _interopRequireDefault(_DetailCus);
	
	var _FormSearch = __webpack_require__(1810);
	
	var _FormSearch2 = _interopRequireDefault(_FormSearch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.judge = function (accountInfo) {
	      var role = accountInfo.roles;
	      var permission = {};
	      role.map(function (sign) {
	        if (sign === '[XxSales]' || sign === '[XxSalesManager]' || sign === '[FinanceMenber]' || sign === '[XZManager]') {
	          permission.add = true;
	        } else {
	          permission.add = false;
	        }
	        return permission;
	      });
	    };
	
	    _this.loadDate = function (pageNo) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.name = _this.name ? _this.name : '';
	      params.userUuid = _this.userUuid ? _this.userUuid : '';
	      params.orgUuid = _this.orgUuid ? _this.orgUuid : '';
	      _this.setState({
	        pageNo: current
	      });
	      (0, _protect.queryProtectionList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.protectionRenewal = function (uuid) {
	      (0, _protect.queryProtectionRenewal)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadDate();
	          _antd.message.success(res.message);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.protectionCancel = function (uuid) {
	      (0, _protect.queryCancelProtection)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadDate();
	          _antd.message.success(res.message);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleChange = function () {};
	
	    _this.hideModal = function () {
	      _this.setState({
	        addModalVisible: false,
	        detailModalVisible: false
	      });
	    };
	
	    _this.search = function (condition) {
	      _this.name = condition.name;
	      _this.userUuid = condition.userUuid;
	      _this.loadDate(_this.state.pageNo);
	    };
	
	    _this.showModal = function (type, uuid) {
	      if (type === 'add') {
	        _this.setState({
	          addModalVisible: true,
	          title: '添加保护客户'
	        });
	      } else if (type === 'detail') {
	        _this.setState({
	          detailModalVisible: true
	        });
	      } else if (type === 'edit') {
	        _this.setState({
	          addModalVisible: true,
	          title: '修改保护客户'
	        });
	      }
	      _this.protectUuid = uuid;
	    };
	
	    _this.columns = function () {
	      var accountInfo = _this.state.account_info;
	
	      return [{
	        title: '客户名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '公司地址',
	        dataIndex: 'area',
	        key: 'area'
	      }, {
	        title: '行业',
	        dataIndex: 'industry',
	        key: 'industry'
	      }, {
	        title: '保护人',
	        dataIndex: 'protectName',
	        key: 'protectName'
	      }, {
	        title: '保护时间',
	        dataIndex: 'protectDate',
	        key: 'protectDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '到期时间',
	        dataIndex: 'maturityDate',
	        key: 'maturityDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(text, record) {
	          var date = new Date();
	          var time = date.getTime();
	          var expireDate = parseInt(parseInt(record.maturityDate / 86400000, 10) * 86400000, 10);
	          var renewalDate = parseInt((expireDate - time) / 86400000, 10);
	          var canRenewal = '';
	          if (renewalDate <= 5) {
	            canRenewal = true;
	          } else {
	            canRenewal = false;
	          }
	          return _react2.default.createElement(
	            'span',
	            null,
	            record.protectUser === accountInfo.userUuid ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'ant-dropdown-link',
	                  onClick: function onClick() {
	                    return _this.showModal('detail', record.uuid);
	                  }
	                },
	                '\u67E5\u770B'
	              ),
	              '\u4E28'
	            ) : '',
	            record.protectUser !== accountInfo.userUuid ? _react2.default.createElement(
	              'a',
	              {
	                className: 'ant-dropdown-link',
	                onClick: function onClick() {
	                  return _this.showModal('detail', record.uuid);
	                }
	              },
	              '\u67E5\u770B'
	            ) : '',
	            record.protectUser === accountInfo.userUuid ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                {
	                  className: 'ant-dropdown-link',
	                  onClick: function onClick() {
	                    return _this.showModal('edit', record.uuid);
	                  }
	                },
	                '\u4FEE\u6539'
	              ),
	              '\u4E28'
	            ) : '',
	            record.isRenewal !== 1 && record.protectUser === accountInfo.userUuid && canRenewal ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                _antd.Popconfirm,
	                {
	                  title: '\u60A8\u786E\u5B9A\u8981\u7EED\u4FDD\uFF1F',
	                  placement: 'topRight',
	                  overlayStyle: { width: 200 },
	                  onConfirm: function onConfirm() {
	                    return _this.protectionRenewal(record.uuid);
	                  }
	                },
	                _react2.default.createElement(
	                  'a',
	                  { className: 'ant-dropdown-link' },
	                  '\u7EED\u4FDD'
	                )
	              ),
	              '\u4E28'
	            ) : '',
	            record.isRenewal !== 1 && record.protectUser === accountInfo.userUuid && !canRenewal ? _react2.default.createElement(
	              'span',
	              null,
	              _react2.default.createElement(
	                'a',
	                { className: 'ant-dropdown-link', style: { color: 'gray', cursor: 'default' } },
	                '\u7EED\u4FDD'
	              ),
	              '\u4E28'
	            ) : '',
	            record.protectUser === accountInfo.userUuid ? _react2.default.createElement(
	              _antd.Popconfirm,
	              {
	                title: '\u60A8\u786E\u5B9A\u8981\u53D6\u6D88\u4FDD\u62A4\uFF1F',
	                placement: 'topRight',
	                overlayStyle: { width: 200 },
	                onConfirm: function onConfirm() {
	                  return _this.protectionCancel(record.uuid);
	                }
	              },
	              _react2.default.createElement(
	                'a',
	                { className: 'ant-dropdown-link' },
	                '\u53D6\u6D88\u4FDD\u62A4'
	              )
	            ) : ''
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: [],
	      addModalVisible: false,
	      title: '',
	      pageNo: 1,
	      total: 0,
	      account_info: _this.props.account_info || {}
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.name = '';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dispatch = this.props.dispatch;
	      // dispatch(getAccountInfo());
	
	      dispatch((0, _industry_list.getindustryList)());
	      this.loadDate(1);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.setState({
	          account_info: nextProps.account_info
	        });
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    /**
	     * 依据角色判断权限
	     */
	
	
	    /**
	     * 续保
	     */
	
	
	    /**
	     * 取消保护
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total;
	
	
	      var pagination = {
	        total: total,
	        pageSize: 15,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadDate(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      var _state2 = this.state,
	          addModalVisible = _state2.addModalVisible,
	          detailModalVisible = _state2.detailModalVisible,
	          title = _state2.title;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'fixed-header' },
	          _react2.default.createElement(
	            _antd.Row,
	            {
	              type: 'flex',
	              className: 'protect_search',
	              style: { marginBottom: '16px' },
	              justify: 'space-between'
	            },
	            _react2.default.createElement(_antd.Col, { span: 12 }),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12, style: { textAlign: 'right' } },
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/xianxing/protect/record' },
	                _react2.default.createElement(
	                  _antd.Button,
	                  null,
	                  '\u4FDD\u62A4\u8BB0\u5F55'
	                )
	              ),
	              _react2.default.createElement(
	                _reactRouter.Link,
	                { to: '/xianxing/protect/sql' },
	                _react2.default.createElement(
	                  _antd.Button,
	                  { style: { margin: '0 8px' } },
	                  '\u4FDD\u62A4\u5BA2\u6237\u67E5\u8BE2'
	                )
	              ),
	              _react2.default.createElement(
	                _antd.Button,
	                { onClick: function onClick() {
	                    return _this2.showModal('add', '');
	                  } },
	                '\u6DFB\u52A0\u4FDD\u62A4\u5BA2\u6237'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _antd.Row,
	            { justify: 'space-between', type: 'flex', style: { marginBottom: '16px' } },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 24 },
	              _react2.default.createElement(_FormSearch2.default, { search: this.search })
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { paddingTop: '125px' } },
	          _react2.default.createElement(_antd.Table, {
	            rowKey: 'uuid',
	            rowSelection: {},
	            columns: this.columns(),
	            dataSource: data,
	            pagination: pagination
	          })
	        ),
	        addModalVisible ? _react2.default.createElement(_FormAddCus2.default, {
	          cancel: this.hideModal,
	          title: title,
	          loadDate: this.loadDate,
	          protectUuid: this.protectUuid
	        }) : '',
	        detailModalVisible ? _react2.default.createElement(_DetailCus2.default, { cancel: this.hideModal, protectUuid: this.protectUuid }) : ''
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    list: state.industry_list,
	    account_info: state.account_info
	  };
	})(Index);

/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _reactRedux = __webpack_require__(5);
	
	var _protect = __webpack_require__(231);
	
	var _BackBtn = __webpack_require__(12);
	
	var _industry_list = __webpack_require__(438);
	
	var _FormAddCus = __webpack_require__(728);
	
	var _FormAddCus2 = _interopRequireDefault(_FormAddCus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	// import { getAccountInfo } from "../../../store/modules/account_info";
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.judge = function (accountInfo) {
	      var role = accountInfo.roles;
	      var permission = {};
	      role.map(function (sign) {
	        permission.add = sign === '[XxSales]' || sign === '[XxSalesManager]' || sign === '[FinanceMenber]' || sign === '[XZManager]';
	        return permission;
	      });
	    };
	
	    _this.loadDate = function (pageNo) {
	      var params = {};
	      var context = _this;
	      var no = _this.state.pageNo;
	      var current = pageNo || no;
	      params.limit = 15;
	      params.start = current;
	      params.name = _this.name;
	      _this.setState({
	        pageNo: current
	      });
	      (0, _protect.queryProtectionHistoryList)(params).then(function (res) {
	        if (res.statusCode === 200) {
	          context.setState({
	            data: res.data,
	            total: res.totalSize
	          });
	        }
	      });
	    };
	
	    _this.protectionRenewal = function (uuid) {
	      (0, _protect.queryProtectionRenewal)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadDate();
	          _antd.message.success(res.message);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.protectionCancel = function (uuid) {
	      (0, _protect.queryCancelProtection)(uuid).then(function (res) {
	        if (res.statusCode === 200) {
	          _this.loadDate();
	          _antd.message.success(res.message);
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.handleChange = function (e) {
	      _this.setState({
	        userName: e.target.value.replace(/\s+/g, '')
	      });
	    };
	
	    _this.hideModal = function () {
	      _this.setState({
	        addModalVisible: false
	      });
	    };
	
	    _this.search = function () {
	      _this.name = _this.state.userName;
	      _this.loadDate(_this.state.pageNo);
	    };
	
	    _this.showModal = function (type, uuid) {
	      if (type === 'add') {
	        _this.setState({
	          addModalVisible: true,
	          title: '添加保护客户'
	        });
	      } else if (type === 'edit') {
	        _this.setState({
	          addModalVisible: true,
	          title: '修改保护客户'
	        });
	      }
	      _this.protectUuid = uuid;
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '客户名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '公司地址',
	        dataIndex: 'area',
	        key: 'area'
	      }, {
	        title: '行业',
	        dataIndex: 'industry',
	        key: 'industry'
	      }, {
	        title: '保护人',
	        dataIndex: 'protectName',
	        key: 'protectName'
	      }, {
	        title: '保护时间',
	        dataIndex: 'protectDate',
	        key: 'protectDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '到期时间',
	        dataIndex: 'maturityDate',
	        key: 'maturityDate',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text ? _moment2.default.unix(text / 1000).format('YYYY-MM-DD') : ''
	          );
	        }
	      }, {
	        title: '操作',
	        key: 'done',
	        render: function render(text, record) {
	          return _react2.default.createElement(
	            'a',
	            { className: 'ant-dropdown-link', onClick: function onClick() {
	                return _this.showModal('edit', record.uuid);
	              } },
	            '\u7EE7\u7EED\u4FDD\u62A4'
	          );
	        }
	      }];
	    };
	
	    _this.goBack = function () {
	      _this.props.router.go(-1);
	    };
	
	    _this.state = {
	      data: [],
	      userName: '',
	      addModalVisible: false,
	      title: '',
	      pageNo: 1,
	      total: 0
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.name = '';
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var dispatch = this.props.dispatch;
	      // dispatch(getAccountInfo());
	
	      dispatch((0, _industry_list.getindustryList)());
	      this.loadDate(1);
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.account_info !== nextProps.account_info) {
	        this.judge(nextProps.account_info);
	      }
	    }
	
	    /**
	     * 依据角色判断权限
	     */
	
	
	    /**
	     * 续保
	     */
	
	
	    /**
	     * 取消保护
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _state = this.state,
	          data = _state.data,
	          total = _state.total;
	
	
	      var pagination = {
	        total: total,
	        pageSize: 15,
	        current: this.state.pageNo,
	        onChange: function onChange(current) {
	          _this2.loadDate(current);
	        },
	        showTotal: function showTotal(_showTotal) {
	          return '\u5171 ' + _showTotal + ' \u6761';
	        }
	      };
	      var _state2 = this.state,
	          addModalVisible = _state2.addModalVisible,
	          title = _state2.title;
	
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: 'fixed-header' },
	          _react2.default.createElement(
	            _antd.Row,
	            {
	              type: 'flex',
	              className: 'protect_search',
	              style: { marginBottom: '16px' },
	              justify: 'space-between'
	            },
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12, style: { textAlign: 'left' } },
	              _react2.default.createElement(_BackBtn.BackBtn, null)
	            ),
	            _react2.default.createElement(
	              _antd.Col,
	              { span: 12, style: { textAlign: 'right' } },
	              _react2.default.createElement(_antd.Input, {
	                placeholder: '\u8BF7\u8F93\u5165\u5BA2\u6237\u540D\u79F0',
	                value: this.state.userName,
	                onChange: this.handleChange,
	                onPressEnter: this.search,
	                style: { width: '300px' }
	              }),
	              _react2.default.createElement(
	                _antd.Button,
	                { type: 'primary', onClick: this.search, style: { marginLeft: '10px' } },
	                '\u641C\u7D22'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { paddingTop: '44px' } },
	          _react2.default.createElement(_antd.Table, {
	            rowKey: 'uuid',
	            rowSelection: {},
	            columns: this.columns(),
	            dataSource: data,
	            pagination: pagination
	          })
	        ),
	        addModalVisible ? _react2.default.createElement(_FormAddCus2.default, {
	          cancel: this.hideModal,
	          title: title,
	          loadDate: this.loadDate,
	          protectUuid: this.protectUuid
	        }) : ''
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = (0, _reactRedux.connect)(function (state) {
	  return {
	    list: state.industry_list,
	    account_info: state.account_info
	  };
	})(Index);

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _antd = __webpack_require__(2);
	
	var _protect = __webpack_require__(231);
	
	var _BackBtn = __webpack_require__(12);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Index = function (_Component) {
	  _inherits(Index, _Component);
	
	  function Index(props) {
	    _classCallCheck(this, Index);
	
	    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));
	
	    _this.handleChange = function (e) {
	      _this.setState({
	        userName: e.target.value.replace(/\s+/g, '')
	      });
	    };
	
	    _this.search = function () {
	      _this.name = _this.state.userName;
	      (0, _protect.queryProtectionSearch)(_this.name).then(function (res) {
	        if (res.statusCode === 200) {
	          if (res.data.length < 1) {
	            var info = {};
	            var data = [];
	            info.name = _this.name;
	            info.isProtected = 0;
	            data[0] = info;
	            _this.setState({
	              data: data
	            });
	            return;
	          }
	          _this.setState({
	            data: res.data
	          });
	        } else {
	          _antd.message.error(res.message);
	        }
	      });
	    };
	
	    _this.goBack = function () {
	      _this.props.router.go(-1);
	    };
	
	    _this.columns = function () {
	      return [{
	        title: '客户名称',
	        dataIndex: 'name',
	        key: 'name'
	      }, {
	        title: '保护人',
	        dataIndex: 'protectName',
	        key: 'protectName'
	      }, {
	        title: '状态',
	        dataIndex: 'isProtected',
	        key: 'isProtected',
	        render: function render(text) {
	          return _react2.default.createElement(
	            'span',
	            null,
	            text === 1 ? '已保护' : '未保护'
	          );
	        }
	      }];
	    };
	
	    _this.state = {
	      data: []
	    };
	    return _this;
	  }
	
	  _createClass(Index, [{
	    key: 'render',
	    value: function render() {
	      var data = this.state.data;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'protect-sql' },
	        _react2.default.createElement(
	          _antd.Row,
	          { type: 'flex', justify: 'space-between' },
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 3 },
	            _react2.default.createElement(_BackBtn.BackBtn, null)
	          ),
	          _react2.default.createElement(
	            _antd.Col,
	            { span: 21 },
	            _react2.default.createElement(
	              _antd.Row,
	              {
	                type: 'flex',
	                className: 'protect_search',
	                justify: 'end',
	                style: { marginBottom: '16px' }
	              },
	              _react2.default.createElement(
	                _antd.Col,
	                null,
	                _react2.default.createElement(_antd.Input, {
	                  placeholder: '\u8BF7\u8F93\u5165\u5BA2\u6237\u540D\u79F0',
	                  style: { width: '300px' },
	                  value: this.state.userName,
	                  onChange: this.handleChange,
	                  onPressEnter: this.search
	                }),
	                _react2.default.createElement(
	                  _antd.Button,
	                  { type: 'primary', onClick: this.search, style: { marginLeft: '10px' } },
	                  '\u641C\u7D22'
	                )
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_antd.Table, { rowKey: 'uuid', columns: this.columns(), dataSource: data, pagination: false })
	      );
	    }
	  }]);
	
	  return Index;
	}(_react.Component);
	
	exports.default = Index;

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Index = __webpack_require__(1811);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _ProtectSql = __webpack_require__(1813);
	
	var _ProtectSql2 = _interopRequireDefault(_ProtectSql);
	
	var _PageRecord = __webpack_require__(1812);
	
	var _PageRecord2 = _interopRequireDefault(_PageRecord);
	
	var _Index3 = __webpack_require__(1768);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _Index5 = __webpack_require__(1786);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _Index7 = __webpack_require__(1792);
	
	var _Index8 = _interopRequireDefault(_Index7);
	
	var _PageDetail = __webpack_require__(1795);
	
	var _PageDetail2 = _interopRequireDefault(_PageDetail);
	
	var _Index9 = __webpack_require__(1784);
	
	var _Index10 = _interopRequireDefault(_Index9);
	
	var _PageApplyList = __webpack_require__(1782);
	
	var _PageApplyList2 = _interopRequireDefault(_PageApplyList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var router = {
	  path: 'xianxing',
	  breadcrumbName: '先行',
	  childRoutes: [{
	    path: 'protect',
	    breadcrumbName: '客户保护',
	    indexRoute: { component: _Index2.default },
	    childRoutes: [{
	      path: 'sql',
	      breadcrumbName: '保护查询',
	      indexRoute: { component: _ProtectSql2.default }
	    }, {
	      path: 'record',
	      breadcrumbName: '保护记录',
	      indexRoute: { component: _PageRecord2.default }
	    }]
	  }, {
	    path: 'contract',
	    breadcrumbName: '合同管理',
	    indexRoute: { component: _Index4.default },
	    childRoutes: [{
	      path: 'apply',
	      breadcrumbName: '合同申请列表',
	      indexRoute: { component: _PageApplyList2.default }
	    }]
	  }, {
	    path: 'invoice',
	    breadcrumbName: '发票管理',
	    indexRoute: { component: _Index6.default }
	  }, {
	    path: 'order',
	    breadcrumbName: '订单查询',
	    indexRoute: { component: _Index8.default },
	    childRoutes: [{
	      path: ':orderUuid/detail',
	      breadcrumbName: '订单详情',
	      indexRoute: { component: _PageDetail2.default }
	    }]
	  }, {
	    path: 'custom',
	    breadcrumbName: '意向客户查询',
	    indexRoute: { component: _Index10.default }
	  }]
	};
	
	exports.default = router;

/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1826);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactRouter = __webpack_require__(8);
	
	var _reactRedux = __webpack_require__(5);
	
	var _antd = __webpack_require__(2);
	
	var _zh_CN = __webpack_require__(1286);
	
	var _zh_CN2 = _interopRequireDefault(_zh_CN);
	
	__webpack_require__(551);
	
	__webpack_require__(2945);
	
	__webpack_require__(2946);
	
	var _routers = __webpack_require__(1816);
	
	var _routers2 = _interopRequireDefault(_routers);
	
	var _store = __webpack_require__(1820);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Main Resources
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRedux.Provider,
	  { store: _store.store },
	  _react2.default.createElement(
	    _antd.LocaleProvider,
	    { locale: _zh_CN2.default },
	    _react2.default.createElement(_reactRouter.Router, { history: _store.history, routes: _routers2.default })
	  )
	), document.getElementById('root'));
	
	// Redux

/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _interceptor = __webpack_require__(738);
	
	var _App = __webpack_require__(1398);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _Index = __webpack_require__(1400);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Login = __webpack_require__(1401);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _Try = __webpack_require__(1404);
	
	var _Try2 = _interopRequireDefault(_Try);
	
	var _Test = __webpack_require__(1403);
	
	var _Test2 = _interopRequireDefault(_Test);
	
	var _router = __webpack_require__(1688);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _router3 = __webpack_require__(1444);
	
	var _router4 = _interopRequireDefault(_router3);
	
	var _router5 = __webpack_require__(1752);
	
	var _router6 = _interopRequireDefault(_router5);
	
	var _router7 = __webpack_require__(1711);
	
	var _router8 = _interopRequireDefault(_router7);
	
	var _router9 = __webpack_require__(1466);
	
	var _router10 = _interopRequireDefault(_router9);
	
	var _router11 = __webpack_require__(1693);
	
	var _router12 = _interopRequireDefault(_router11);
	
	var _router13 = __webpack_require__(1567);
	
	var _router14 = _interopRequireDefault(_router13);
	
	var _NotFound = __webpack_require__(1402);
	
	var _NotFound2 = _interopRequireDefault(_NotFound);
	
	var _router15 = __webpack_require__(1814);
	
	var _router16 = _interopRequireDefault(_router15);
	
	var _router17 = __webpack_require__(1552);
	
	var _router18 = _interopRequireDefault(_router17);
	
	var _router19 = __webpack_require__(1496);
	
	var _router20 = _interopRequireDefault(_router19);
	
	var _router21 = __webpack_require__(1476);
	
	var _router22 = _interopRequireDefault(_router21);
	
	var _router23 = __webpack_require__(1734);
	
	var _router24 = _interopRequireDefault(_router23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 工作流
	
	// 帮实客户管理
	// 先行管理
	// 孵化器中心
	// 开发者中心
	// 任务
	// 财务
	var routers = {
	  path: '/',
	  onEnter: _interceptor.auth,
	  component: _App2.default,
	  breadcrumbName: '主页',
	  indexRoute: {
	    component: _Index2.default
	  },
	  childRoutes: [{
	    path: 'login',
	    component: _Login2.default
	  }, {
	    path: 'try',
	    component: _Try2.default
	  }, {
	    path: 'test',
	    component: _Test2.default
	  }, {
	    path: '',
	    component: _Index2.default,
	    breadcrumbName: '决策系统',
	    childRoutes: [_router12.default, _router6.default, _router2.default, _router8.default, _router10.default, _router14.default, _router16.default, _router18.default, _router20.default, _router22.default, _router24.default, _router4.default]
	  }, {
	    path: '*',
	    component: _NotFound2.default
	  }]
	}; // 工作流
	// 华夏客户管理
	// 个人中心
	// 人力资源
	// 行政
	/**
	 * routers
	 * 更多关于Router的使用，请参考以下教程
	 * https://github.com/ReactTraining/react-router/blob/master/docs/guides/RouteConfiguration.md
	 */
	exports.default = routers;

/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reduxDevtools = __webpack_require__(593);
	
	var _reduxDevtoolsLogMonitor = __webpack_require__(2913);
	
	var _reduxDevtoolsLogMonitor2 = _interopRequireDefault(_reduxDevtoolsLogMonitor);
	
	var _reduxDevtoolsDockMonitor = __webpack_require__(2900);
	
	var _reduxDevtoolsDockMonitor2 = _interopRequireDefault(_reduxDevtoolsDockMonitor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// eslint-disable-next-line import/no-extraneous-dependencies
	exports.default = (0, _reduxDevtools.createDevTools)(_react2.default.createElement(
	  _reduxDevtoolsDockMonitor2.default,
	  { toggleVisibilityKey: 'ctrl-h', changePositionKey: 'ctrl-w' },
	  _react2.default.createElement(_reduxDevtoolsLogMonitor2.default, null)
	));
	// eslint-disable-next-line import/no-extraneous-dependencies
	
	// eslint-disable-next-line import/no-extraneous-dependencies

/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(312);
	
	var _reduxThunk = __webpack_require__(1177);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reduxLogger = __webpack_require__(2931);
	
	var _reduxLogger2 = _interopRequireDefault(_reduxLogger);
	
	var _reduxDevtoolsExtension = __webpack_require__(2905);
	
	var _DevTools = __webpack_require__(1817);
	
	var _DevTools2 = _interopRequireDefault(_DevTools);
	
	var _reducers = __webpack_require__(737);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// configureStore dev
	function configureStore(initialState) {
	  var composeEnhancers = (0, _reduxDevtoolsExtension.composeWithDevTools)({
	    // Specify name here, actionsBlacklist, actionsCreators and other options if needed
	  });
	
	  var store = (0, _redux.createStore)(_reducers2.default, initialState, composeEnhancers((0, _redux.applyMiddleware)(_reduxThunk2.default, (0, _reduxLogger2.default)())
	  // other store enhancers if any
	  ), _DevTools2.default.instrument());
	  if (false) {
	    module.hot.accept('./reducers', function () {
	      store.replaceReducer(_reducers2.default);
	    });
	  }
	
	  return store;
	}
	
	// eslint-disable-next-line import/no-extraneous-dependencies

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = configureStore;
	
	var _redux = __webpack_require__(312);
	
	var _reduxThunk = __webpack_require__(1177);
	
	var _reduxThunk2 = _interopRequireDefault(_reduxThunk);
	
	var _reducers = __webpack_require__(737);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function configureStore(initialState) {
	  var stroe = (0, _redux.createStore)(_reducers2.default, initialState, (0, _redux.applyMiddleware)(_reduxThunk2.default));
	
	  return stroe;
	} // configureStore production

/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.history = exports.store = undefined;
	
	var _reactRouterRedux = __webpack_require__(1154);
	
	var _reactRouter = __webpack_require__(8);
	
	var configureStore = void 0;
	var isProduction = false;
	
	if (isProduction) {
	  // eslint-disable-next-line global-require
	  configureStore = __webpack_require__(1819);
	} else {
	  // eslint-disable-next-line global-require
	  configureStore = __webpack_require__(1818);
	}
	
	var store = configureStore.default();
	var history = (0, _reactRouterRedux.syncHistoryWithStore)(_reactRouter.browserHistory, store);
	
	exports.store = store;
	exports.history = history;

/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getAllUser = getAllUser;
	exports.allUser = allUser;
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	var _user = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// 按模块的action, reducer整合体
	var ALL_USER = 'ALL_USER';
	
	function getAllUser() {
	  return function (dispatch) {
	    return (0, _user.queryAdminAccountList)().then(function (res) {
	      if (res.statusCode === 200) {
	        _localDb2.default.set(ALL_USER, res.data.result);
	        return dispatch({
	          type: ALL_USER,
	          data: res.data.result
	        });
	      }
	    });
	  };
	}
	
	// Reducer
	function allUser() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case ALL_USER:
	      return action.data;
	    default:
	      return _localDb2.default.get(ALL_USER);
	  }
	}

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _expend_type = __webpack_require__(80);
	
	var _income_type = __webpack_require__(437);
	
	var _adjust_data = __webpack_require__(436);
	
	var _all_company = __webpack_require__(732);
	
	exports.default = {
	  expend_type: _expend_type.expendType,
	  income_type: _income_type.incomeType,
	  adjust_data: _adjust_data.adjustData,
	  all_company: _all_company.allCompany
	};

/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getHrSearch = getHrSearch;
	exports.hrSearch = hrSearch;
	
	var _hr = __webpack_require__(167);
	
	// 按模块的action, reducer整合体
	var HR_SEARCH = 'HR_SEARCH'; // 全部用户
	function getHrSearch(params) {
	  return function (dispatch, getState) {
	    var _getState = getState(),
	        search = _getState.hr_search;
	
	    if (search.length > 0) {
	      return dispatch({
	        type: HR_SEARCH,
	        data: search
	      });
	    }
	    return (0, _hr.queryHrList)(Object.assign({}, params, { status: 1 })).then(function (res) {
	      if (res.statusCode === 200) {
	        return dispatch({
	          type: HR_SEARCH,
	          data: res.data
	        });
	      }
	    });
	  };
	}
	
	function hrSearch() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case HR_SEARCH:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getRecoupInfo = getRecoupInfo;
	exports.recoupInfo = recoupInfo;
	
	var _recoup = __webpack_require__(133);
	
	// 按模块的action, reducer整合体
	var RECOUP_INFO = 'RECOUP_INFO';
	
	function getRecoupInfo(uuid) {
	  return function (dispatch) {
	    return (0, _recoup.queryRecoupInfo)(uuid).then(function (res) {
	      if (res.statusCode === 200) {
	        return dispatch({
	          type: RECOUP_INFO,
	          data: Object.assign({}, res.data)
	        });
	      }
	    });
	  };
	}
	
	function recoupInfo() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var action = arguments[1];
	
	  switch (action.type) {
	    case RECOUP_INFO:
	      return action.data;
	    default:
	      return state;
	  }
	}

/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _localDb = __webpack_require__(28);
	
	var _localDb2 = _interopRequireDefault(_localDb);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var LOGIN_USER = "LOGIN_USER"; /**
	                                * The main api service
	                                */
	exports.default = {
	  /**
	   * 保存登陆用户信息
	   */
	  setUser: function setUser(user) {
	    return _localDb2.default.set(LOGIN_USER, user);
	  },
	
	
	  /**
	   * 获取登陆角色信息
	   */
	  getUser: function getUser() {
	    return _localDb2.default.get(LOGIN_USER);
	  },
	
	
	  /**
	   * 清空登陆用户信息
	   */
	  clearUser: function clearUser() {
	    _localDb2.default.set(LOGIN_USER);
	  }
	};

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	__webpack_require__(2125);
	
	__webpack_require__(1181);
	
	__webpack_require__(1876);
	
	if (global._babelPolyfill) {
	  throw new Error("only one instance of babel-polyfill is allowed");
	}
	global._babelPolyfill = true;
	
	var DEFINE_PROPERTY = "defineProperty";
	function define(O, key, value) {
	  O[key] || Object[DEFINE_PROPERTY](O, key, {
	    writable: true,
	    configurable: true,
	    value: value
	  });
	}
	
	define(String.prototype, "padLeft", "".padStart);
	define(String.prototype, "padRight", "".padEnd);
	
	"pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	  [][key] && define(Array, key, Function.call.bind([][key]));
	});
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1877), __esModule: true };

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1879), __esModule: true };

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1880), __esModule: true };

/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1881), __esModule: true };

/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1882), __esModule: true };

/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1884), __esModule: true };

/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1886), __esModule: true };

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1888), __esModule: true };

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(1889), __esModule: true };

/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _getPrototypeOf = __webpack_require__(1833);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _getOwnPropertyDescriptor = __webpack_require__(1832);
	
	var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function get(object, property, receiver) {
	  if (object === null) object = Function.prototype;
	  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);
	
	  if (desc === undefined) {
	    var parent = (0, _getPrototypeOf2.default)(object);
	
	    if (parent === null) {
	      return undefined;
	    } else {
	      return get(parent, property, receiver);
	    }
	  } else if ("value" in desc) {
	    return desc.value;
	  } else {
	    var getter = desc.get;
	
	    if (getter === undefined) {
	      return undefined;
	    }
	
	    return getter.call(receiver);
	  }
	};

/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(1828);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(442);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 1838 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'apathy',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#031A16',
	  base01: '#0B342D',
	  base02: '#184E45',
	  base03: '#2B685E',
	  base04: '#5F9C92',
	  base05: '#81B5AC',
	  base06: '#A7CEC8',
	  base07: '#D2E7E4',
	  base08: '#3E9688',
	  base09: '#3E7996',
	  base0A: '#3E4C96',
	  base0B: '#883E96',
	  base0C: '#963E4C',
	  base0D: '#96883E',
	  base0E: '#4C963E',
	  base0F: '#3E965B'
	};
	module.exports = exports['default'];

/***/ },
/* 1839 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'ashes',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#1C2023',
	  base01: '#393F45',
	  base02: '#565E65',
	  base03: '#747C84',
	  base04: '#ADB3BA',
	  base05: '#C7CCD1',
	  base06: '#DFE2E5',
	  base07: '#F3F4F5',
	  base08: '#C7AE95',
	  base09: '#C7C795',
	  base0A: '#AEC795',
	  base0B: '#95C7AE',
	  base0C: '#95AEC7',
	  base0D: '#AE95C7',
	  base0E: '#C795AE',
	  base0F: '#C79595'
	};
	module.exports = exports['default'];

/***/ },
/* 1840 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier dune',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/dune)',
	  base00: '#20201d',
	  base01: '#292824',
	  base02: '#6e6b5e',
	  base03: '#7d7a68',
	  base04: '#999580',
	  base05: '#a6a28c',
	  base06: '#e8e4cf',
	  base07: '#fefbec',
	  base08: '#d73737',
	  base09: '#b65611',
	  base0A: '#cfb017',
	  base0B: '#60ac39',
	  base0C: '#1fad83',
	  base0D: '#6684e1',
	  base0E: '#b854d4',
	  base0F: '#d43552'
	};
	module.exports = exports['default'];

/***/ },
/* 1841 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier forest',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/forest)',
	  base00: '#1b1918',
	  base01: '#2c2421',
	  base02: '#68615e',
	  base03: '#766e6b',
	  base04: '#9c9491',
	  base05: '#a8a19f',
	  base06: '#e6e2e0',
	  base07: '#f1efee',
	  base08: '#f22c40',
	  base09: '#df5320',
	  base0A: '#d5911a',
	  base0B: '#5ab738',
	  base0C: '#00ad9c',
	  base0D: '#407ee7',
	  base0E: '#6666ea',
	  base0F: '#c33ff3'
	};
	module.exports = exports['default'];

/***/ },
/* 1842 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier heath',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/heath)',
	  base00: '#1b181b',
	  base01: '#292329',
	  base02: '#695d69',
	  base03: '#776977',
	  base04: '#9e8f9e',
	  base05: '#ab9bab',
	  base06: '#d8cad8',
	  base07: '#f7f3f7',
	  base08: '#ca402b',
	  base09: '#a65926',
	  base0A: '#bb8a35',
	  base0B: '#379a37',
	  base0C: '#159393',
	  base0D: '#516aec',
	  base0E: '#7b59c0',
	  base0F: '#cc33cc'
	};
	module.exports = exports['default'];

/***/ },
/* 1843 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier lakeside',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/lakeside/)',
	  base00: '#161b1d',
	  base01: '#1f292e',
	  base02: '#516d7b',
	  base03: '#5a7b8c',
	  base04: '#7195a8',
	  base05: '#7ea2b4',
	  base06: '#c1e4f6',
	  base07: '#ebf8ff',
	  base08: '#d22d72',
	  base09: '#935c25',
	  base0A: '#8a8a0f',
	  base0B: '#568c3b',
	  base0C: '#2d8f6f',
	  base0D: '#257fad',
	  base0E: '#5d5db1',
	  base0F: '#b72dd2'
	};
	module.exports = exports['default'];

/***/ },
/* 1844 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'atelier seaside',
	  author: 'bram de haan (http://atelierbram.github.io/syntax-highlighting/atelier-schemes/seaside/)',
	  base00: '#131513',
	  base01: '#242924',
	  base02: '#5e6e5e',
	  base03: '#687d68',
	  base04: '#809980',
	  base05: '#8ca68c',
	  base06: '#cfe8cf',
	  base07: '#f0fff0',
	  base08: '#e6193c',
	  base09: '#87711d',
	  base0A: '#c3c322',
	  base0B: '#29a329',
	  base0C: '#1999b3',
	  base0D: '#3d62f5',
	  base0E: '#ad2bee',
	  base0F: '#e619c3'
	};
	module.exports = exports['default'];

/***/ },
/* 1845 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'bespin',
	  author: 'jan t. sott',
	  base00: '#28211c',
	  base01: '#36312e',
	  base02: '#5e5d5c',
	  base03: '#666666',
	  base04: '#797977',
	  base05: '#8a8986',
	  base06: '#9d9b97',
	  base07: '#baae9e',
	  base08: '#cf6a4c',
	  base09: '#cf7d34',
	  base0A: '#f9ee98',
	  base0B: '#54be0d',
	  base0C: '#afc4db',
	  base0D: '#5ea6ea',
	  base0E: '#9b859d',
	  base0F: '#937121'
	};
	module.exports = exports['default'];

/***/ },
/* 1846 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'brewer',
	  author: 'timothée poisot (http://github.com/tpoisot)',
	  base00: '#0c0d0e',
	  base01: '#2e2f30',
	  base02: '#515253',
	  base03: '#737475',
	  base04: '#959697',
	  base05: '#b7b8b9',
	  base06: '#dadbdc',
	  base07: '#fcfdfe',
	  base08: '#e31a1c',
	  base09: '#e6550d',
	  base0A: '#dca060',
	  base0B: '#31a354',
	  base0C: '#80b1d3',
	  base0D: '#3182bd',
	  base0E: '#756bb1',
	  base0F: '#b15928'
	};
	module.exports = exports['default'];

/***/ },
/* 1847 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'bright',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#000000',
	  base01: '#303030',
	  base02: '#505050',
	  base03: '#b0b0b0',
	  base04: '#d0d0d0',
	  base05: '#e0e0e0',
	  base06: '#f5f5f5',
	  base07: '#ffffff',
	  base08: '#fb0120',
	  base09: '#fc6d24',
	  base0A: '#fda331',
	  base0B: '#a1c659',
	  base0C: '#76c7b7',
	  base0D: '#6fb3d2',
	  base0E: '#d381c3',
	  base0F: '#be643c'
	};
	module.exports = exports['default'];

/***/ },
/* 1848 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'chalk',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#151515',
	  base01: '#202020',
	  base02: '#303030',
	  base03: '#505050',
	  base04: '#b0b0b0',
	  base05: '#d0d0d0',
	  base06: '#e0e0e0',
	  base07: '#f5f5f5',
	  base08: '#fb9fb1',
	  base09: '#eda987',
	  base0A: '#ddb26f',
	  base0B: '#acc267',
	  base0C: '#12cfc0',
	  base0D: '#6fc2ef',
	  base0E: '#e1a3ee',
	  base0F: '#deaf8f'
	};
	module.exports = exports['default'];

/***/ },
/* 1849 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'codeschool',
	  author: 'brettof86',
	  base00: '#232c31',
	  base01: '#1c3657',
	  base02: '#2a343a',
	  base03: '#3f4944',
	  base04: '#84898c',
	  base05: '#9ea7a6',
	  base06: '#a7cfa3',
	  base07: '#b5d8f6',
	  base08: '#2a5491',
	  base09: '#43820d',
	  base0A: '#a03b1e',
	  base0B: '#237986',
	  base0C: '#b02f30',
	  base0D: '#484d79',
	  base0E: '#c59820',
	  base0F: '#c98344'
	};
	module.exports = exports['default'];

/***/ },
/* 1850 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'colors',
	  author: 'mrmrs (http://clrs.cc)',
	  base00: '#111111',
	  base01: '#333333',
	  base02: '#555555',
	  base03: '#777777',
	  base04: '#999999',
	  base05: '#bbbbbb',
	  base06: '#dddddd',
	  base07: '#ffffff',
	  base08: '#ff4136',
	  base09: '#ff851b',
	  base0A: '#ffdc00',
	  base0B: '#2ecc40',
	  base0C: '#7fdbff',
	  base0D: '#0074d9',
	  base0E: '#b10dc9',
	  base0F: '#85144b'
	};
	module.exports = exports['default'];

/***/ },
/* 1851 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'default',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#181818',
	  base01: '#282828',
	  base02: '#383838',
	  base03: '#585858',
	  base04: '#b8b8b8',
	  base05: '#d8d8d8',
	  base06: '#e8e8e8',
	  base07: '#f8f8f8',
	  base08: '#ab4642',
	  base09: '#dc9656',
	  base0A: '#f7ca88',
	  base0B: '#a1b56c',
	  base0C: '#86c1b9',
	  base0D: '#7cafc2',
	  base0E: '#ba8baf',
	  base0F: '#a16946'
	};
	module.exports = exports['default'];

/***/ },
/* 1852 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'eighties',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#2d2d2d',
	  base01: '#393939',
	  base02: '#515151',
	  base03: '#747369',
	  base04: '#a09f93',
	  base05: '#d3d0c8',
	  base06: '#e8e6df',
	  base07: '#f2f0ec',
	  base08: '#f2777a',
	  base09: '#f99157',
	  base0A: '#ffcc66',
	  base0B: '#99cc99',
	  base0C: '#66cccc',
	  base0D: '#6699cc',
	  base0E: '#cc99cc',
	  base0F: '#d27b53'
	};
	module.exports = exports['default'];

/***/ },
/* 1853 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'embers',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#16130F',
	  base01: '#2C2620',
	  base02: '#433B32',
	  base03: '#5A5047',
	  base04: '#8A8075',
	  base05: '#A39A90',
	  base06: '#BEB6AE',
	  base07: '#DBD6D1',
	  base08: '#826D57',
	  base09: '#828257',
	  base0A: '#6D8257',
	  base0B: '#57826D',
	  base0C: '#576D82',
	  base0D: '#6D5782',
	  base0E: '#82576D',
	  base0F: '#825757'
	};
	module.exports = exports['default'];

/***/ },
/* 1854 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'flat',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#2C3E50',
	  base01: '#34495E',
	  base02: '#7F8C8D',
	  base03: '#95A5A6',
	  base04: '#BDC3C7',
	  base05: '#e0e0e0',
	  base06: '#f5f5f5',
	  base07: '#ECF0F1',
	  base08: '#E74C3C',
	  base09: '#E67E22',
	  base0A: '#F1C40F',
	  base0B: '#2ECC71',
	  base0C: '#1ABC9C',
	  base0D: '#3498DB',
	  base0E: '#9B59B6',
	  base0F: '#be643c'
	};
	module.exports = exports['default'];

/***/ },
/* 1855 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'google',
	  author: 'seth wright (http://sethawright.com)',
	  base00: '#1d1f21',
	  base01: '#282a2e',
	  base02: '#373b41',
	  base03: '#969896',
	  base04: '#b4b7b4',
	  base05: '#c5c8c6',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#CC342B',
	  base09: '#F96A38',
	  base0A: '#FBA922',
	  base0B: '#198844',
	  base0C: '#3971ED',
	  base0D: '#3971ED',
	  base0E: '#A36AC7',
	  base0F: '#3971ED'
	};
	module.exports = exports['default'];

/***/ },
/* 1856 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'grayscale',
	  author: 'alexandre gavioli (https://github.com/alexx2/)',
	  base00: '#101010',
	  base01: '#252525',
	  base02: '#464646',
	  base03: '#525252',
	  base04: '#ababab',
	  base05: '#b9b9b9',
	  base06: '#e3e3e3',
	  base07: '#f7f7f7',
	  base08: '#7c7c7c',
	  base09: '#999999',
	  base0A: '#a0a0a0',
	  base0B: '#8e8e8e',
	  base0C: '#868686',
	  base0D: '#686868',
	  base0E: '#747474',
	  base0F: '#5e5e5e'
	};
	module.exports = exports['default'];

/***/ },
/* 1857 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'green screen',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#001100',
	  base01: '#003300',
	  base02: '#005500',
	  base03: '#007700',
	  base04: '#009900',
	  base05: '#00bb00',
	  base06: '#00dd00',
	  base07: '#00ff00',
	  base08: '#007700',
	  base09: '#009900',
	  base0A: '#007700',
	  base0B: '#00bb00',
	  base0C: '#005500',
	  base0D: '#009900',
	  base0E: '#00bb00',
	  base0F: '#005500'
	};
	module.exports = exports['default'];

/***/ },
/* 1858 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'harmonic16',
	  author: 'jannik siebert (https://github.com/janniks)',
	  base00: '#0b1c2c',
	  base01: '#223b54',
	  base02: '#405c79',
	  base03: '#627e99',
	  base04: '#aabcce',
	  base05: '#cbd6e2',
	  base06: '#e5ebf1',
	  base07: '#f7f9fb',
	  base08: '#bf8b56',
	  base09: '#bfbf56',
	  base0A: '#8bbf56',
	  base0B: '#56bf8b',
	  base0C: '#568bbf',
	  base0D: '#8b56bf',
	  base0E: '#bf568b',
	  base0F: '#bf5656'
	};
	module.exports = exports['default'];

/***/ },
/* 1859 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'hopscotch',
	  author: 'jan t. sott',
	  base00: '#322931',
	  base01: '#433b42',
	  base02: '#5c545b',
	  base03: '#797379',
	  base04: '#989498',
	  base05: '#b9b5b8',
	  base06: '#d5d3d5',
	  base07: '#ffffff',
	  base08: '#dd464c',
	  base09: '#fd8b19',
	  base0A: '#fdcc59',
	  base0B: '#8fc13e',
	  base0C: '#149b93',
	  base0D: '#1290bf',
	  base0E: '#c85e7c',
	  base0F: '#b33508'
	};
	module.exports = exports['default'];

/***/ },
/* 1860 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'isotope',
	  author: 'jan t. sott',
	  base00: '#000000',
	  base01: '#404040',
	  base02: '#606060',
	  base03: '#808080',
	  base04: '#c0c0c0',
	  base05: '#d0d0d0',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#ff0000',
	  base09: '#ff9900',
	  base0A: '#ff0099',
	  base0B: '#33ff00',
	  base0C: '#00ffff',
	  base0D: '#0066ff',
	  base0E: '#cc00ff',
	  base0F: '#3300ff'
	};
	module.exports = exports['default'];

/***/ },
/* 1861 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'marrakesh',
	  author: 'alexandre gavioli (http://github.com/alexx2/)',
	  base00: '#201602',
	  base01: '#302e00',
	  base02: '#5f5b17',
	  base03: '#6c6823',
	  base04: '#86813b',
	  base05: '#948e48',
	  base06: '#ccc37a',
	  base07: '#faf0a5',
	  base08: '#c35359',
	  base09: '#b36144',
	  base0A: '#a88339',
	  base0B: '#18974e',
	  base0C: '#75a738',
	  base0D: '#477ca1',
	  base0E: '#8868b3',
	  base0F: '#b3588e'
	};
	module.exports = exports['default'];

/***/ },
/* 1862 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'mocha',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#3B3228',
	  base01: '#534636',
	  base02: '#645240',
	  base03: '#7e705a',
	  base04: '#b8afad',
	  base05: '#d0c8c6',
	  base06: '#e9e1dd',
	  base07: '#f5eeeb',
	  base08: '#cb6077',
	  base09: '#d28b71',
	  base0A: '#f4bc87',
	  base0B: '#beb55b',
	  base0C: '#7bbda4',
	  base0D: '#8ab3b5',
	  base0E: '#a89bb9',
	  base0F: '#bb9584'
	};
	module.exports = exports['default'];

/***/ },
/* 1863 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'monokai',
	  author: 'wimer hazenberg (http://www.monokai.nl)',
	  base00: '#272822',
	  base01: '#383830',
	  base02: '#49483e',
	  base03: '#75715e',
	  base04: '#a59f85',
	  base05: '#f8f8f2',
	  base06: '#f5f4f1',
	  base07: '#f9f8f5',
	  base08: '#f92672',
	  base09: '#fd971f',
	  base0A: '#f4bf75',
	  base0B: '#a6e22e',
	  base0C: '#a1efe4',
	  base0D: '#66d9ef',
	  base0E: '#ae81ff',
	  base0F: '#cc6633'
	};
	module.exports = exports['default'];

/***/ },
/* 1864 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'ocean',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#2b303b',
	  base01: '#343d46',
	  base02: '#4f5b66',
	  base03: '#65737e',
	  base04: '#a7adba',
	  base05: '#c0c5ce',
	  base06: '#dfe1e8',
	  base07: '#eff1f5',
	  base08: '#bf616a',
	  base09: '#d08770',
	  base0A: '#ebcb8b',
	  base0B: '#a3be8c',
	  base0C: '#96b5b4',
	  base0D: '#8fa1b3',
	  base0E: '#b48ead',
	  base0F: '#ab7967'
	};
	module.exports = exports['default'];

/***/ },
/* 1865 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'paraiso',
	  author: 'jan t. sott',
	  base00: '#2f1e2e',
	  base01: '#41323f',
	  base02: '#4f424c',
	  base03: '#776e71',
	  base04: '#8d8687',
	  base05: '#a39e9b',
	  base06: '#b9b6b0',
	  base07: '#e7e9db',
	  base08: '#ef6155',
	  base09: '#f99b15',
	  base0A: '#fec418',
	  base0B: '#48b685',
	  base0C: '#5bc4bf',
	  base0D: '#06b6ef',
	  base0E: '#815ba4',
	  base0F: '#e96ba8'
	};
	module.exports = exports['default'];

/***/ },
/* 1866 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'pop',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#000000',
	  base01: '#202020',
	  base02: '#303030',
	  base03: '#505050',
	  base04: '#b0b0b0',
	  base05: '#d0d0d0',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#eb008a',
	  base09: '#f29333',
	  base0A: '#f8ca12',
	  base0B: '#37b349',
	  base0C: '#00aabb',
	  base0D: '#0e5a94',
	  base0E: '#b31e8d',
	  base0F: '#7a2d00'
	};
	module.exports = exports['default'];

/***/ },
/* 1867 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'railscasts',
	  author: 'ryan bates (http://railscasts.com)',
	  base00: '#2b2b2b',
	  base01: '#272935',
	  base02: '#3a4055',
	  base03: '#5a647e',
	  base04: '#d4cfc9',
	  base05: '#e6e1dc',
	  base06: '#f4f1ed',
	  base07: '#f9f7f3',
	  base08: '#da4939',
	  base09: '#cc7833',
	  base0A: '#ffc66d',
	  base0B: '#a5c261',
	  base0C: '#519f50',
	  base0D: '#6d9cbe',
	  base0E: '#b6b3eb',
	  base0F: '#bc9458'
	};
	module.exports = exports['default'];

/***/ },
/* 1868 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'shapeshifter',
	  author: 'tyler benziger (http://tybenz.com)',
	  base00: '#000000',
	  base01: '#040404',
	  base02: '#102015',
	  base03: '#343434',
	  base04: '#555555',
	  base05: '#ababab',
	  base06: '#e0e0e0',
	  base07: '#f9f9f9',
	  base08: '#e92f2f',
	  base09: '#e09448',
	  base0A: '#dddd13',
	  base0B: '#0ed839',
	  base0C: '#23edda',
	  base0D: '#3b48e3',
	  base0E: '#f996e2',
	  base0F: '#69542d'
	};
	module.exports = exports['default'];

/***/ },
/* 1869 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'solarized',
	  author: 'ethan schoonover (http://ethanschoonover.com/solarized)',
	  base00: '#002b36',
	  base01: '#073642',
	  base02: '#586e75',
	  base03: '#657b83',
	  base04: '#839496',
	  base05: '#93a1a1',
	  base06: '#eee8d5',
	  base07: '#fdf6e3',
	  base08: '#dc322f',
	  base09: '#cb4b16',
	  base0A: '#b58900',
	  base0B: '#859900',
	  base0C: '#2aa198',
	  base0D: '#268bd2',
	  base0E: '#6c71c4',
	  base0F: '#d33682'
	};
	module.exports = exports['default'];

/***/ },
/* 1870 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'summerfruit',
	  author: 'christopher corley (http://cscorley.github.io/)',
	  base00: '#151515',
	  base01: '#202020',
	  base02: '#303030',
	  base03: '#505050',
	  base04: '#B0B0B0',
	  base05: '#D0D0D0',
	  base06: '#E0E0E0',
	  base07: '#FFFFFF',
	  base08: '#FF0086',
	  base09: '#FD8900',
	  base0A: '#ABA800',
	  base0B: '#00C918',
	  base0C: '#1faaaa',
	  base0D: '#3777E6',
	  base0E: '#AD00A1',
	  base0F: '#cc6633'
	};
	module.exports = exports['default'];

/***/ },
/* 1871 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'threezerotwofour',
	  author: 'jan t. sott (http://github.com/idleberg)',
	  base00: '#090300',
	  base01: '#3a3432',
	  base02: '#4a4543',
	  base03: '#5c5855',
	  base04: '#807d7c',
	  base05: '#a5a2a2',
	  base06: '#d6d5d4',
	  base07: '#f7f7f7',
	  base08: '#db2d20',
	  base09: '#e8bbd0',
	  base0A: '#fded02',
	  base0B: '#01a252',
	  base0C: '#b5e4f4',
	  base0D: '#01a0e4',
	  base0E: '#a16a94',
	  base0F: '#cdab53'
	};
	module.exports = exports['default'];

/***/ },
/* 1872 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'tomorrow',
	  author: 'chris kempson (http://chriskempson.com)',
	  base00: '#1d1f21',
	  base01: '#282a2e',
	  base02: '#373b41',
	  base03: '#969896',
	  base04: '#b4b7b4',
	  base05: '#c5c8c6',
	  base06: '#e0e0e0',
	  base07: '#ffffff',
	  base08: '#cc6666',
	  base09: '#de935f',
	  base0A: '#f0c674',
	  base0B: '#b5bd68',
	  base0C: '#8abeb7',
	  base0D: '#81a2be',
	  base0E: '#b294bb',
	  base0F: '#a3685a'
	};
	module.exports = exports['default'];

/***/ },
/* 1873 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'london tube',
	  author: 'jan t. sott',
	  base00: '#231f20',
	  base01: '#1c3f95',
	  base02: '#5a5758',
	  base03: '#737171',
	  base04: '#959ca1',
	  base05: '#d9d8d8',
	  base06: '#e7e7e8',
	  base07: '#ffffff',
	  base08: '#ee2e24',
	  base09: '#f386a1',
	  base0A: '#ffd204',
	  base0B: '#00853e',
	  base0C: '#85cebc',
	  base0D: '#009ddc',
	  base0E: '#98005d',
	  base0F: '#b06110'
	};
	module.exports = exports['default'];

/***/ },
/* 1874 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'twilight',
	  author: 'david hart (http://hart-dev.com)',
	  base00: '#1e1e1e',
	  base01: '#323537',
	  base02: '#464b50',
	  base03: '#5f5a60',
	  base04: '#838184',
	  base05: '#a7a7a7',
	  base06: '#c3c3c3',
	  base07: '#ffffff',
	  base08: '#cf6a4c',
	  base09: '#cda869',
	  base0A: '#f9ee98',
	  base0B: '#8f9d6a',
	  base0C: '#afc4db',
	  base0D: '#7587a6',
	  base0E: '#9b859d',
	  base0F: '#9b703f'
	};
	module.exports = exports['default'];

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var deselectCurrent = __webpack_require__(2943);
	
	var clipboardToIE11Formatting = {
	  "text/plain": "Text",
	  "text/html": "Url",
	  "default": "Text"
	}
	
	var defaultMessage = "Copy to clipboard: #{key}, Enter";
	
	function format(message) {
	  var copyKey = (/mac os x/i.test(navigator.userAgent) ? "⌘" : "Ctrl") + "+C";
	  return message.replace(/#{\s*key\s*}/g, copyKey);
	}
	
	function copy(text, options) {
	  var debug,
	    message,
	    reselectPrevious,
	    range,
	    selection,
	    mark,
	    success = false;
	  if (!options) {
	    options = {};
	  }
	  debug = options.debug || false;
	  try {
	    reselectPrevious = deselectCurrent();
	
	    range = document.createRange();
	    selection = document.getSelection();
	
	    mark = document.createElement("span");
	    mark.textContent = text;
	    // avoid screen readers from reading out loud the text
	    mark.ariaHidden = "true"
	    // reset user styles for span element
	    mark.style.all = "unset";
	    // prevents scrolling to the end of the page
	    mark.style.position = "fixed";
	    mark.style.top = 0;
	    mark.style.clip = "rect(0, 0, 0, 0)";
	    // used to preserve spaces and line breaks
	    mark.style.whiteSpace = "pre";
	    // do not inherit user-select (it may be `none`)
	    mark.style.webkitUserSelect = "text";
	    mark.style.MozUserSelect = "text";
	    mark.style.msUserSelect = "text";
	    mark.style.userSelect = "text";
	    mark.addEventListener("copy", function(e) {
	      e.stopPropagation();
	      if (options.format) {
	        e.preventDefault();
	        if (typeof e.clipboardData === "undefined") { // IE 11
	          debug && console.warn("unable to use e.clipboardData");
	          debug && console.warn("trying IE specific stuff");
	          window.clipboardData.clearData();
	          var format = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"]
	          window.clipboardData.setData(format, text);
	        } else { // all other browsers
	          e.clipboardData.clearData();
	          e.clipboardData.setData(options.format, text);
	        }
	      }
	      if (options.onCopy) {
	        e.preventDefault();
	        options.onCopy(e.clipboardData);
	      }
	    });
	
	    document.body.appendChild(mark);
	
	    range.selectNodeContents(mark);
	    selection.addRange(range);
	
	    var successful = document.execCommand("copy");
	    if (!successful) {
	      throw new Error("copy command was unsuccessful");
	    }
	    success = true;
	  } catch (err) {
	    debug && console.error("unable to copy using execCommand: ", err);
	    debug && console.warn("trying IE specific stuff");
	    try {
	      window.clipboardData.setData(options.format || "text", text);
	      options.onCopy && options.onCopy(window.clipboardData);
	      success = true;
	    } catch (err) {
	      debug && console.error("unable to copy using clipboardData: ", err);
	      debug && console.error("falling back to prompt");
	      message = format("message" in options ? options.message : defaultMessage);
	      window.prompt(message, text);
	    }
	  } finally {
	    if (selection) {
	      if (typeof selection.removeRange == "function") {
	        selection.removeRange(range);
	      } else {
	        selection.removeAllRanges();
	      }
	    }
	
	    if (mark) {
	      document.body.removeChild(mark);
	    }
	    reselectPrevious();
	  }
	
	  return success;
	}
	
	module.exports = copy;


/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1933);
	module.exports = __webpack_require__(117).RegExp.escape;


/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(335);
	__webpack_require__(1912);
	module.exports = __webpack_require__(78).Array.from;


/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(459);
	__webpack_require__(335);
	module.exports = __webpack_require__(1910);


/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(459);
	__webpack_require__(335);
	module.exports = __webpack_require__(1911);


/***/ },
/* 1880 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1914);
	module.exports = __webpack_require__(78).Number.isSafeInteger;


/***/ },
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1915);
	module.exports = __webpack_require__(78).Object.assign;


/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1916);
	var $Object = __webpack_require__(78).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1917);
	var $Object = __webpack_require__(78).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1918);
	var $Object = __webpack_require__(78).Object;
	module.exports = function getOwnPropertyDescriptor(it, key) {
	  return $Object.getOwnPropertyDescriptor(it, key);
	};


/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1919);
	var $Object = __webpack_require__(78).Object;
	module.exports = function getOwnPropertyNames(it) {
	  return $Object.getOwnPropertyNames(it);
	};


/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1920);
	module.exports = __webpack_require__(78).Object.getPrototypeOf;


/***/ },
/* 1887 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1921);
	module.exports = __webpack_require__(78).Object.keys;


/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1922);
	module.exports = __webpack_require__(78).Object.setPrototypeOf;


/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1924);
	__webpack_require__(1923);
	__webpack_require__(1925);
	__webpack_require__(1926);
	module.exports = __webpack_require__(78).Symbol;


/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(335);
	__webpack_require__(459);
	module.exports = __webpack_require__(458).f('iterator');


/***/ },
/* 1891 */
84,
/* 1892 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 1893 */
[3005, 196, 755, 1909],
/* 1894 */
[3007, 171, 275],
/* 1895 */
[3011, 274, 451, 332],
/* 1896 */
[3013, 170],
/* 1897 */
[3016, 238, 115],
/* 1898 */
[3017, 445],
/* 1899 */
[3018, 195],
/* 1900 */
[3019, 193],
/* 1901 */
[3020, 449, 275, 452, 237, 115],
/* 1902 */
[3022, 115],
/* 1903 */
770,
/* 1904 */
[3023, 334, 195, 194, 171, 236],
/* 1905 */
[3024, 169, 274, 451, 332, 239, 748, 236],
/* 1906 */
[3027, 171, 193, 274, 169],
/* 1907 */
[3035, 195, 193, 446, 450],
/* 1908 */
[3039, 455, 447],
/* 1909 */
[3040, 455],
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(193);
	var get = __webpack_require__(756);
	module.exports = __webpack_require__(78).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 1911 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(745);
	var ITERATOR = __webpack_require__(115)('iterator');
	var Iterators = __webpack_require__(238);
	module.exports = __webpack_require__(78).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 1912 */
[3049, 446, 155, 239, 1900, 1897, 755, 1894, 756, 1902],
/* 1913 */
[3050, 1892, 1903, 238, 196, 749],
/* 1914 */
[3051, 155, 1899],
/* 1915 */
[3052, 155, 1905],
/* 1916 */
[3053, 155, 449],
/* 1917 */
[3054, 155, 169, 171],
/* 1918 */
[3055, 196, 450, 333],
/* 1919 */
[3056, 333, 750],
/* 1920 */
[3057, 239, 752, 333],
/* 1921 */
[3058, 239, 274, 333],
/* 1922 */
[3059, 155, 1907],
/* 1923 */
/***/ function(module, exports) {



/***/ },
/* 1924 */
[3061, 170, 194, 169, 155, 754, 1904, 236, 454, 452, 334, 115, 458, 457, 1895, 1898, 193, 195, 239, 196, 456, 275, 449, 750, 450, 451, 171, 274, 751, 332, 331, 237],
/* 1925 */
[3062, 457],
/* 1926 */
[3063, 457],
/* 1927 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(45);
	var isArray = __webpack_require__(339);
	var SPECIES = __webpack_require__(58)('species');
	
	module.exports = function (original) {
	  var C;
	  if (isArray(original)) {
	    C = original.constructor;
	    // cross-realm fallback
	    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	    if (isObject(C)) {
	      C = C[SPECIES];
	      if (C === null) C = undefined;
	    }
	  } return C === undefined ? Array : C;
	};


/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var fails = __webpack_require__(43);
	var getTime = Date.prototype.getTime;
	var $toISOString = Date.prototype.toISOString;
	
	var lz = function (num) {
	  return num > 9 ? num : '0' + num;
	};
	
	// PhantomJS / old WebKit has a broken implementations
	module.exports = (fails(function () {
	  return $toISOString.call(new Date(-5e13 - 1)) != '0385-07-25T07:06:39.999Z';
	}) || !fails(function () {
	  $toISOString.call(new Date(NaN));
	})) ? function toISOString() {
	  if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	  var d = this;
	  var y = d.getUTCFullYear();
	  var m = d.getUTCMilliseconds();
	  var s = y < 0 ? '-' : y > 9999 ? '+' : '';
	  return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) +
	    '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) +
	    'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) +
	    ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	} : $toISOString;


/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var anObject = __webpack_require__(31);
	var toPrimitive = __webpack_require__(138);
	var NUMBER = 'number';
	
	module.exports = function (hint) {
	  if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	  return toPrimitive(anObject(this), hint != NUMBER);
	};


/***/ },
/* 1930 */
[3011, 201, 343, 278],
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(279)('native-function-to-string', Function.toString);


/***/ },
/* 1932 */
/***/ function(module, exports) {

	module.exports = function (regExp, replace) {
	  var replacer = replace === Object(replace) ? function (part) {
	    return replace[part];
	  } : replace;
	  return function (it) {
	    return String(it).replace(regExp, replacer);
	  };
	};


/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/benjamingr/RexExp.escape
	var $export = __webpack_require__(7);
	var $re = __webpack_require__(1932)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	$export($export.S, 'RegExp', { escape: function escape(it) { return $re(it); } });


/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	var $export = __webpack_require__(7);
	
	$export($export.P, 'Array', { copyWithin: __webpack_require__(758) });
	
	__webpack_require__(172)('copyWithin');


/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $every = __webpack_require__(135)(4);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].every, true), 'Array', {
	  // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	  every: function every(callbackfn /* , thisArg */) {
	    return $every(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	var $export = __webpack_require__(7);
	
	$export($export.P, 'Array', { fill: __webpack_require__(461) });
	
	__webpack_require__(172)('fill');


/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $filter = __webpack_require__(135)(2);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].filter, true), 'Array', {
	  // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	  filter: function filter(callbackfn /* , thisArg */) {
	    return $filter(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	var $export = __webpack_require__(7);
	var $find = __webpack_require__(135)(6);
	var KEY = 'findIndex';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  findIndex: function findIndex(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(172)(KEY);


/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	var $export = __webpack_require__(7);
	var $find = __webpack_require__(135)(5);
	var KEY = 'find';
	var forced = true;
	// Shouldn't skip holes
	if (KEY in []) Array(1)[KEY](function () { forced = false; });
	$export($export.P + $export.F * forced, 'Array', {
	  find: function find(callbackfn /* , that = undefined */) {
	    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	__webpack_require__(172)(KEY);


/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $forEach = __webpack_require__(135)(0);
	var STRICT = __webpack_require__(119)([].forEach, true);
	
	$export($export.P + $export.F * !STRICT, 'Array', {
	  // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	  forEach: function forEach(callbackfn /* , thisArg */) {
	    return $forEach(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1941 */
[3049, 118, 7, 75, 769, 469, 63, 463, 485, 341],
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $indexOf = __webpack_require__(336)(false);
	var $native = [].indexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(119)($native)), 'Array', {
	  // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
	    return NEGATIVE_ZERO
	      // convert -0 to +0
	      ? $native.apply(this, arguments) || 0
	      : $indexOf(this, searchElement, arguments[1]);
	  }
	});


/***/ },
/* 1943 */
/***/ function(module, exports, __webpack_require__) {

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Array', { isArray: __webpack_require__(339) });


/***/ },
/* 1944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 22.1.3.13 Array.prototype.join(separator)
	var $export = __webpack_require__(7);
	var toIObject = __webpack_require__(107);
	var arrayJoin = [].join;
	
	// fallback for not array-like strings
	$export($export.P + $export.F * (__webpack_require__(277) != Object || !__webpack_require__(119)(arrayJoin)), 'Array', {
	  join: function join(separator) {
	    return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	  }
	});


/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toIObject = __webpack_require__(107);
	var toInteger = __webpack_require__(120);
	var toLength = __webpack_require__(63);
	var $native = [].lastIndexOf;
	var NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	$export($export.P + $export.F * (NEGATIVE_ZERO || !__webpack_require__(119)($native)), 'Array', {
	  // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	  lastIndexOf: function lastIndexOf(searchElement /* , fromIndex = @[*-1] */) {
	    // convert -0 to +0
	    if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	    var O = toIObject(this);
	    var length = toLength(O.length);
	    var index = length - 1;
	    if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	    if (index < 0) index = length + index;
	    for (;index >= 0; index--) if (index in O) if (O[index] === searchElement) return index || 0;
	    return -1;
	  }
	});


/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $map = __webpack_require__(135)(1);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].map, true), 'Array', {
	  // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	  map: function map(callbackfn /* , thisArg */) {
	    return $map(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var createProperty = __webpack_require__(463);
	
	// WebKit Array.of isn't generic
	$export($export.S + $export.F * __webpack_require__(43)(function () {
	  function F() { /* empty */ }
	  return !(Array.of.call(F) instanceof F);
	}), 'Array', {
	  // 22.1.2.3 Array.of( ...items)
	  of: function of(/* ...args */) {
	    var index = 0;
	    var aLen = arguments.length;
	    var result = new (typeof this == 'function' ? this : Array)(aLen);
	    while (aLen > index) createProperty(result, index, arguments[index++]);
	    result.length = aLen;
	    return result;
	  }
	});


/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $reduce = __webpack_require__(760);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].reduceRight, true), 'Array', {
	  // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	  reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	  }
	});


/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $reduce = __webpack_require__(760);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].reduce, true), 'Array', {
	  // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	  reduce: function reduce(callbackfn /* , initialValue */) {
	    return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	  }
	});


/***/ },
/* 1950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var html = __webpack_require__(467);
	var cof = __webpack_require__(116);
	var toAbsoluteIndex = __webpack_require__(205);
	var toLength = __webpack_require__(63);
	var arraySlice = [].slice;
	
	// fallback for not array-like ES3 strings and DOM objects
	$export($export.P + $export.F * __webpack_require__(43)(function () {
	  if (html) arraySlice.call(html);
	}), 'Array', {
	  slice: function slice(begin, end) {
	    var len = toLength(this.length);
	    var klass = cof(this);
	    end = end === undefined ? len : end;
	    if (klass == 'Array') return arraySlice.call(this, begin, end);
	    var start = toAbsoluteIndex(begin, len);
	    var upTo = toAbsoluteIndex(end, len);
	    var size = toLength(upTo - start);
	    var cloned = new Array(size);
	    var i = 0;
	    for (; i < size; i++) cloned[i] = klass == 'String'
	      ? this.charAt(start + i)
	      : this[start + i];
	    return cloned;
	  }
	});


/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $some = __webpack_require__(135)(3);
	
	$export($export.P + $export.F * !__webpack_require__(119)([].some, true), 'Array', {
	  // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	  some: function some(callbackfn /* , thisArg */) {
	    return $some(this, callbackfn, arguments[1]);
	  }
	});


/***/ },
/* 1952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var aFunction = __webpack_require__(84);
	var toObject = __webpack_require__(75);
	var fails = __webpack_require__(43);
	var $sort = [].sort;
	var test = [1, 2, 3];
	
	$export($export.P + $export.F * (fails(function () {
	  // IE8-
	  test.sort(undefined);
	}) || !fails(function () {
	  // V8 bug
	  test.sort(null);
	  // Old WebKit
	}) || !__webpack_require__(119)($sort)), 'Array', {
	  // 22.1.3.25 Array.prototype.sort(comparefn)
	  sort: function sort(comparefn) {
	    return comparefn === undefined
	      ? $sort.call(toObject(this))
	      : $sort.call(toObject(this), aFunction(comparefn));
	  }
	});


/***/ },
/* 1953 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(204)('Array');


/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.3.1 / 15.9.4.4 Date.now()
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Date', { now: function () { return new Date().getTime(); } });


/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	// 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	var $export = __webpack_require__(7);
	var toISOString = __webpack_require__(1928);
	
	// PhantomJS / old WebKit has a broken implementations
	$export($export.P + $export.F * (Date.prototype.toISOString !== toISOString), 'Date', {
	  toISOString: toISOString
	});


/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toObject = __webpack_require__(75);
	var toPrimitive = __webpack_require__(138);
	
	$export($export.P + $export.F * __webpack_require__(43)(function () {
	  return new Date(NaN).toJSON() !== null
	    || Date.prototype.toJSON.call({ toISOString: function () { return 1; } }) !== 1;
	}), 'Date', {
	  // eslint-disable-next-line no-unused-vars
	  toJSON: function toJSON(key) {
	    var O = toObject(this);
	    var pv = toPrimitive(O);
	    return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	  }
	});


/***/ },
/* 1957 */
/***/ function(module, exports, __webpack_require__) {

	var TO_PRIMITIVE = __webpack_require__(58)('toPrimitive');
	var proto = Date.prototype;
	
	if (!(TO_PRIMITIVE in proto)) __webpack_require__(97)(proto, TO_PRIMITIVE, __webpack_require__(1929));


/***/ },
/* 1958 */
/***/ function(module, exports, __webpack_require__) {

	var DateProto = Date.prototype;
	var INVALID_DATE = 'Invalid Date';
	var TO_STRING = 'toString';
	var $toString = DateProto[TO_STRING];
	var getTime = DateProto.getTime;
	if (new Date(NaN) + '' != INVALID_DATE) {
	  __webpack_require__(98)(DateProto, TO_STRING, function toString() {
	    var value = getTime.call(this);
	    // eslint-disable-next-line no-self-compare
	    return value === value ? $toString.call(this) : INVALID_DATE;
	  });
	}


/***/ },
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	// 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	var $export = __webpack_require__(7);
	
	$export($export.P, 'Function', { bind: __webpack_require__(761) });


/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var isObject = __webpack_require__(45);
	var getPrototypeOf = __webpack_require__(106);
	var HAS_INSTANCE = __webpack_require__(58)('hasInstance');
	var FunctionProto = Function.prototype;
	// 19.2.3.6 Function.prototype[@@hasInstance](V)
	if (!(HAS_INSTANCE in FunctionProto)) __webpack_require__(69).f(FunctionProto, HAS_INSTANCE, { value: function (O) {
	  if (typeof this != 'function' || !isObject(O)) return false;
	  if (!isObject(this.prototype)) return O instanceof this;
	  // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	  while (O = getPrototypeOf(O)) if (this.prototype === O) return true;
	  return false;
	} });


/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(69).f;
	var FProto = Function.prototype;
	var nameRE = /^\s*function ([^ (]*)/;
	var NAME = 'name';
	
	// 19.2.4.2 name
	NAME in FProto || __webpack_require__(65) && dP(FProto, NAME, {
	  configurable: true,
	  get: function () {
	    try {
	      return ('' + this).match(nameRE)[1];
	    } catch (e) {
	      return '';
	    }
	  }
	});


/***/ },
/* 1962 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.3 Math.acosh(x)
	var $export = __webpack_require__(7);
	var log1p = __webpack_require__(772);
	var sqrt = Math.sqrt;
	var $acosh = Math.acosh;
	
	$export($export.S + $export.F * !($acosh
	  // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	  && Math.floor($acosh(Number.MAX_VALUE)) == 710
	  // Tor Browser bug: Math.acosh(Infinity) -> NaN
	  && $acosh(Infinity) == Infinity
	), 'Math', {
	  acosh: function acosh(x) {
	    return (x = +x) < 1 ? NaN : x > 94906265.62425156
	      ? Math.log(x) + Math.LN2
	      : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	  }
	});


/***/ },
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.5 Math.asinh(x)
	var $export = __webpack_require__(7);
	var $asinh = Math.asinh;
	
	function asinh(x) {
	  return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	}
	
	// Tor Browser bug: Math.asinh(0) -> -0
	$export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });


/***/ },
/* 1964 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.7 Math.atanh(x)
	var $export = __webpack_require__(7);
	var $atanh = Math.atanh;
	
	// Tor Browser bug: Math.atanh(-0) -> 0
	$export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	  atanh: function atanh(x) {
	    return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	  }
	});


/***/ },
/* 1965 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.9 Math.cbrt(x)
	var $export = __webpack_require__(7);
	var sign = __webpack_require__(473);
	
	$export($export.S, 'Math', {
	  cbrt: function cbrt(x) {
	    return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	  }
	});


/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.11 Math.clz32(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  clz32: function clz32(x) {
	    return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	  }
	});


/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.12 Math.cosh(x)
	var $export = __webpack_require__(7);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  cosh: function cosh(x) {
	    return (exp(x = +x) + exp(-x)) / 2;
	  }
	});


/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.14 Math.expm1(x)
	var $export = __webpack_require__(7);
	var $expm1 = __webpack_require__(472);
	
	$export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });


/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.16 Math.fround(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { fround: __webpack_require__(771) });


/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	var $export = __webpack_require__(7);
	var abs = Math.abs;
	
	$export($export.S, 'Math', {
	  hypot: function hypot(value1, value2) { // eslint-disable-line no-unused-vars
	    var sum = 0;
	    var i = 0;
	    var aLen = arguments.length;
	    var larg = 0;
	    var arg, div;
	    while (i < aLen) {
	      arg = abs(arguments[i++]);
	      if (larg < arg) {
	        div = larg / arg;
	        sum = sum * div * div + 1;
	        larg = arg;
	      } else if (arg > 0) {
	        div = arg / larg;
	        sum += div * div;
	      } else sum += arg;
	    }
	    return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	  }
	});


/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.18 Math.imul(x, y)
	var $export = __webpack_require__(7);
	var $imul = Math.imul;
	
	// some WebKit versions fails with big numbers, some has wrong arity
	$export($export.S + $export.F * __webpack_require__(43)(function () {
	  return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	}), 'Math', {
	  imul: function imul(x, y) {
	    var UINT16 = 0xffff;
	    var xn = +x;
	    var yn = +y;
	    var xl = UINT16 & xn;
	    var yl = UINT16 & yn;
	    return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	  }
	});


/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.21 Math.log10(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  log10: function log10(x) {
	    return Math.log(x) * Math.LOG10E;
	  }
	});


/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.20 Math.log1p(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { log1p: __webpack_require__(772) });


/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.22 Math.log2(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  log2: function log2(x) {
	    return Math.log(x) / Math.LN2;
	  }
	});


/***/ },
/* 1975 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.28 Math.sign(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { sign: __webpack_require__(473) });


/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.30 Math.sinh(x)
	var $export = __webpack_require__(7);
	var expm1 = __webpack_require__(472);
	var exp = Math.exp;
	
	// V8 near Chromium 38 has a problem with very small numbers
	$export($export.S + $export.F * __webpack_require__(43)(function () {
	  return !Math.sinh(-2e-17) != -2e-17;
	}), 'Math', {
	  sinh: function sinh(x) {
	    return Math.abs(x = +x) < 1
	      ? (expm1(x) - expm1(-x)) / 2
	      : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	  }
	});


/***/ },
/* 1977 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.33 Math.tanh(x)
	var $export = __webpack_require__(7);
	var expm1 = __webpack_require__(472);
	var exp = Math.exp;
	
	$export($export.S, 'Math', {
	  tanh: function tanh(x) {
	    var a = expm1(x = +x);
	    var b = expm1(-x);
	    return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	  }
	});


/***/ },
/* 1978 */
/***/ function(module, exports, __webpack_require__) {

	// 20.2.2.34 Math.trunc(x)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  trunc: function trunc(it) {
	    return (it > 0 ? Math.floor : Math.ceil)(it);
	  }
	});


/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var global = __webpack_require__(42);
	var has = __webpack_require__(104);
	var cof = __webpack_require__(116);
	var inheritIfRequired = __webpack_require__(468);
	var toPrimitive = __webpack_require__(138);
	var fails = __webpack_require__(43);
	var gOPN = __webpack_require__(200).f;
	var gOPD = __webpack_require__(105).f;
	var dP = __webpack_require__(69).f;
	var $trim = __webpack_require__(243).trim;
	var NUMBER = 'Number';
	var $Number = global[NUMBER];
	var Base = $Number;
	var proto = $Number.prototype;
	// Opera ~12 has broken Object#toString
	var BROKEN_COF = cof(__webpack_require__(199)(proto)) == NUMBER;
	var TRIM = 'trim' in String.prototype;
	
	// 7.1.3 ToNumber(argument)
	var toNumber = function (argument) {
	  var it = toPrimitive(argument, false);
	  if (typeof it == 'string' && it.length > 2) {
	    it = TRIM ? it.trim() : $trim(it, 3);
	    var first = it.charCodeAt(0);
	    var third, radix, maxCode;
	    if (first === 43 || first === 45) {
	      third = it.charCodeAt(2);
	      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	    } else if (first === 48) {
	      switch (it.charCodeAt(1)) {
	        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal /^0b[01]+$/i
	        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal /^0o[0-7]+$/i
	        default: return +it;
	      }
	      for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	        code = digits.charCodeAt(i);
	        // parseInt parses a string to a first unavailable symbol
	        // but ToNumber should return NaN if a string contains unavailable symbols
	        if (code < 48 || code > maxCode) return NaN;
	      } return parseInt(digits, radix);
	    }
	  } return +it;
	};
	
	if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	  $Number = function Number(value) {
	    var it = arguments.length < 1 ? 0 : value;
	    var that = this;
	    return that instanceof $Number
	      // check on 1..constructor(foo) case
	      && (BROKEN_COF ? fails(function () { proto.valueOf.call(that); }) : cof(that) != NUMBER)
	        ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	  };
	  for (var keys = __webpack_require__(65) ? gOPN(Base) : (
	    // ES3:
	    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	    // ES6 (in case, if modules with ES6 Number statics required before):
	    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
	    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger'
	  ).split(','), j = 0, key; keys.length > j; j++) {
	    if (has(Base, key = keys[j]) && !has($Number, key)) {
	      dP($Number, key, gOPD(Base, key));
	    }
	  }
	  $Number.prototype = proto;
	  proto.constructor = $Number;
	  __webpack_require__(98)(global, NUMBER, $Number);
	}


/***/ },
/* 1980 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.1 Number.EPSILON
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });


/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.2 Number.isFinite(number)
	var $export = __webpack_require__(7);
	var _isFinite = __webpack_require__(42).isFinite;
	
	$export($export.S, 'Number', {
	  isFinite: function isFinite(it) {
	    return typeof it == 'number' && _isFinite(it);
	  }
	});


/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.3 Number.isInteger(number)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Number', { isInteger: __webpack_require__(768) });


/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.4 Number.isNaN(number)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Number', {
	  isNaN: function isNaN(number) {
	    // eslint-disable-next-line no-self-compare
	    return number != number;
	  }
	});


/***/ },
/* 1984 */
[3051, 7, 768],
/* 1985 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.6 Number.MAX_SAFE_INTEGER
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });


/***/ },
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	// 20.1.2.10 Number.MIN_SAFE_INTEGER
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });


/***/ },
/* 1987 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var $parseFloat = __webpack_require__(780);
	// 20.1.2.12 Number.parseFloat(string)
	$export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });


/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var $parseInt = __webpack_require__(781);
	// 20.1.2.13 Number.parseInt(string, radix)
	$export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });


/***/ },
/* 1989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toInteger = __webpack_require__(120);
	var aNumberValue = __webpack_require__(757);
	var repeat = __webpack_require__(480);
	var $toFixed = 1.0.toFixed;
	var floor = Math.floor;
	var data = [0, 0, 0, 0, 0, 0];
	var ERROR = 'Number.toFixed: incorrect invocation!';
	var ZERO = '0';
	
	var multiply = function (n, c) {
	  var i = -1;
	  var c2 = c;
	  while (++i < 6) {
	    c2 += n * data[i];
	    data[i] = c2 % 1e7;
	    c2 = floor(c2 / 1e7);
	  }
	};
	var divide = function (n) {
	  var i = 6;
	  var c = 0;
	  while (--i >= 0) {
	    c += data[i];
	    data[i] = floor(c / n);
	    c = (c % n) * 1e7;
	  }
	};
	var numToString = function () {
	  var i = 6;
	  var s = '';
	  while (--i >= 0) {
	    if (s !== '' || i === 0 || data[i] !== 0) {
	      var t = String(data[i]);
	      s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	    }
	  } return s;
	};
	var pow = function (x, n, acc) {
	  return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	};
	var log = function (x) {
	  var n = 0;
	  var x2 = x;
	  while (x2 >= 4096) {
	    n += 12;
	    x2 /= 4096;
	  }
	  while (x2 >= 2) {
	    n += 1;
	    x2 /= 2;
	  } return n;
	};
	
	$export($export.P + $export.F * (!!$toFixed && (
	  0.00008.toFixed(3) !== '0.000' ||
	  0.9.toFixed(0) !== '1' ||
	  1.255.toFixed(2) !== '1.25' ||
	  1000000000000000128.0.toFixed(0) !== '1000000000000000128'
	) || !__webpack_require__(43)(function () {
	  // V8 ~ Android 4.3-
	  $toFixed.call({});
	})), 'Number', {
	  toFixed: function toFixed(fractionDigits) {
	    var x = aNumberValue(this, ERROR);
	    var f = toInteger(fractionDigits);
	    var s = '';
	    var m = ZERO;
	    var e, z, j, k;
	    if (f < 0 || f > 20) throw RangeError(ERROR);
	    // eslint-disable-next-line no-self-compare
	    if (x != x) return 'NaN';
	    if (x <= -1e21 || x >= 1e21) return String(x);
	    if (x < 0) {
	      s = '-';
	      x = -x;
	    }
	    if (x > 1e-21) {
	      e = log(x * pow(2, 69, 1)) - 69;
	      z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	      z *= 0x10000000000000;
	      e = 52 - e;
	      if (e > 0) {
	        multiply(0, z);
	        j = f;
	        while (j >= 7) {
	          multiply(1e7, 0);
	          j -= 7;
	        }
	        multiply(pow(10, j, 1), 0);
	        j = e - 1;
	        while (j >= 23) {
	          divide(1 << 23);
	          j -= 23;
	        }
	        divide(1 << j);
	        multiply(1, 1);
	        divide(2);
	        m = numToString();
	      } else {
	        multiply(0, z);
	        multiply(1 << -e, 0);
	        m = numToString() + repeat.call(ZERO, f);
	      }
	    }
	    if (f > 0) {
	      k = m.length;
	      m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	    } else {
	      m = s + m;
	    } return m;
	  }
	});


/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $fails = __webpack_require__(43);
	var aNumberValue = __webpack_require__(757);
	var $toPrecision = 1.0.toPrecision;
	
	$export($export.P + $export.F * ($fails(function () {
	  // IE7-
	  return $toPrecision.call(1, undefined) !== '1';
	}) || !$fails(function () {
	  // V8 ~ Android 4.3-
	  $toPrecision.call({});
	})), 'Number', {
	  toPrecision: function toPrecision(precision) {
	    var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	    return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	  }
	});


/***/ },
/* 1991 */
[3052, 7, 774],
/* 1992 */
[3053, 7, 199],
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	$export($export.S + $export.F * !__webpack_require__(65), 'Object', { defineProperties: __webpack_require__(775) });


/***/ },
/* 1994 */
[3054, 7, 65, 69],
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.5 Object.freeze(O)
	var isObject = __webpack_require__(45);
	var meta = __webpack_require__(174).onFreeze;
	
	__webpack_require__(137)('freeze', function ($freeze) {
	  return function freeze(it) {
	    return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	  };
	});


/***/ },
/* 1996 */
[3055, 107, 105, 137],
/* 1997 */
[3056, 137, 776],
/* 1998 */
[3057, 75, 106, 137],
/* 1999 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.11 Object.isExtensible(O)
	var isObject = __webpack_require__(45);
	
	__webpack_require__(137)('isExtensible', function ($isExtensible) {
	  return function isExtensible(it) {
	    return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	  };
	});


/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.12 Object.isFrozen(O)
	var isObject = __webpack_require__(45);
	
	__webpack_require__(137)('isFrozen', function ($isFrozen) {
	  return function isFrozen(it) {
	    return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	  };
	});


/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.13 Object.isSealed(O)
	var isObject = __webpack_require__(45);
	
	__webpack_require__(137)('isSealed', function ($isSealed) {
	  return function isSealed(it) {
	    return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	  };
	});


/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.10 Object.is(value1, value2)
	var $export = __webpack_require__(7);
	$export($export.S, 'Object', { is: __webpack_require__(784) });


/***/ },
/* 2003 */
[3058, 75, 201, 137],
/* 2004 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.15 Object.preventExtensions(O)
	var isObject = __webpack_require__(45);
	var meta = __webpack_require__(174).onFreeze;
	
	__webpack_require__(137)('preventExtensions', function ($preventExtensions) {
	  return function preventExtensions(it) {
	    return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	  };
	});


/***/ },
/* 2005 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.17 Object.seal(O)
	var isObject = __webpack_require__(45);
	var meta = __webpack_require__(174).onFreeze;
	
	__webpack_require__(137)('seal', function ($seal) {
	  return function seal(it) {
	    return $seal && isObject(it) ? $seal(meta(it)) : it;
	  };
	});


/***/ },
/* 2006 */
[3059, 7, 477],
/* 2007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.3.6 Object.prototype.toString()
	var classof = __webpack_require__(240);
	var test = {};
	test[__webpack_require__(58)('toStringTag')] = 'z';
	if (test + '' != '[object z]') {
	  __webpack_require__(98)(Object.prototype, 'toString', function toString() {
	    return '[object ' + classof(this) + ']';
	  }, true);
	}


/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var $parseFloat = __webpack_require__(780);
	// 18.2.4 parseFloat(string)
	$export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });


/***/ },
/* 2009 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var $parseInt = __webpack_require__(781);
	// 18.2.5 parseInt(string, radix)
	$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ },
/* 2010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(173);
	var global = __webpack_require__(42);
	var ctx = __webpack_require__(118);
	var classof = __webpack_require__(240);
	var $export = __webpack_require__(7);
	var isObject = __webpack_require__(45);
	var aFunction = __webpack_require__(84);
	var anInstance = __webpack_require__(197);
	var forOf = __webpack_require__(198);
	var speciesConstructor = __webpack_require__(280);
	var task = __webpack_require__(482).set;
	var microtask = __webpack_require__(474)();
	var newPromiseCapabilityModule = __webpack_require__(475);
	var perform = __webpack_require__(782);
	var userAgent = __webpack_require__(349);
	var promiseResolve = __webpack_require__(783);
	var PROMISE = 'Promise';
	var TypeError = global.TypeError;
	var process = global.process;
	var versions = process && process.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = global[PROMISE];
	var isNode = classof(process) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;
	
	var USE_NATIVE = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[__webpack_require__(58)('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();
	
	// helpers
	var isThenable = function (it) {
	  var then;
	  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = perform(function () {
	        if (isNode) {
	          process.emit('unhandledRejection', value, promise);
	        } else if (handler = global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(global, function () {
	    var handler;
	    if (isNode) {
	      process.emit('rejectionHandled', promise);
	    } else if (handler = global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};
	
	// constructor polyfill
	if (!USE_NATIVE) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    anInstance(this, $Promise, PROMISE, '_h');
	    aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = __webpack_require__(203)($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode ? process.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = ctx($resolve, promise, 1);
	    this.reject = ctx($reject, promise, 1);
	  };
	  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	__webpack_require__(242)($Promise, PROMISE);
	__webpack_require__(204)(PROMISE);
	Wrapper = __webpack_require__(117)[PROMISE];
	
	// statics
	$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
	  }
	});
	$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(341)(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = perform(function () {
	      forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});


/***/ },
/* 2011 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	var $export = __webpack_require__(7);
	var aFunction = __webpack_require__(84);
	var anObject = __webpack_require__(31);
	var rApply = (__webpack_require__(42).Reflect || {}).apply;
	var fApply = Function.apply;
	// MS Edge argumentsList argument is optional
	$export($export.S + $export.F * !__webpack_require__(43)(function () {
	  rApply(function () { /* empty */ });
	}), 'Reflect', {
	  apply: function apply(target, thisArgument, argumentsList) {
	    var T = aFunction(target);
	    var L = anObject(argumentsList);
	    return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	  }
	});


/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	var $export = __webpack_require__(7);
	var create = __webpack_require__(199);
	var aFunction = __webpack_require__(84);
	var anObject = __webpack_require__(31);
	var isObject = __webpack_require__(45);
	var fails = __webpack_require__(43);
	var bind = __webpack_require__(761);
	var rConstruct = (__webpack_require__(42).Reflect || {}).construct;
	
	// MS Edge supports only 2 arguments and argumentsList argument is optional
	// FF Nightly sets third argument as `new.target`, but does not create `this` from it
	var NEW_TARGET_BUG = fails(function () {
	  function F() { /* empty */ }
	  return !(rConstruct(function () { /* empty */ }, [], F) instanceof F);
	});
	var ARGS_BUG = !fails(function () {
	  rConstruct(function () { /* empty */ });
	});
	
	$export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	  construct: function construct(Target, args /* , newTarget */) {
	    aFunction(Target);
	    anObject(args);
	    var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	    if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	    if (Target == newTarget) {
	      // w/o altered newTarget, optimization for 0-4 arguments
	      switch (args.length) {
	        case 0: return new Target();
	        case 1: return new Target(args[0]);
	        case 2: return new Target(args[0], args[1]);
	        case 3: return new Target(args[0], args[1], args[2]);
	        case 4: return new Target(args[0], args[1], args[2], args[3]);
	      }
	      // w/o altered newTarget, lot of arguments case
	      var $args = [null];
	      $args.push.apply($args, args);
	      return new (bind.apply(Target, $args))();
	    }
	    // with altered newTarget, not support built-in constructors
	    var proto = newTarget.prototype;
	    var instance = create(isObject(proto) ? proto : Object.prototype);
	    var result = Function.apply.call(Target, instance, args);
	    return isObject(result) ? result : instance;
	  }
	});


/***/ },
/* 2013 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	var dP = __webpack_require__(69);
	var $export = __webpack_require__(7);
	var anObject = __webpack_require__(31);
	var toPrimitive = __webpack_require__(138);
	
	// MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	$export($export.S + $export.F * __webpack_require__(43)(function () {
	  // eslint-disable-next-line no-undef
	  Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	}), 'Reflect', {
	  defineProperty: function defineProperty(target, propertyKey, attributes) {
	    anObject(target);
	    propertyKey = toPrimitive(propertyKey, true);
	    anObject(attributes);
	    try {
	      dP.f(target, propertyKey, attributes);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.4 Reflect.deleteProperty(target, propertyKey)
	var $export = __webpack_require__(7);
	var gOPD = __webpack_require__(105).f;
	var anObject = __webpack_require__(31);
	
	$export($export.S, 'Reflect', {
	  deleteProperty: function deleteProperty(target, propertyKey) {
	    var desc = gOPD(anObject(target), propertyKey);
	    return desc && !desc.configurable ? false : delete target[propertyKey];
	  }
	});


/***/ },
/* 2015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 26.1.5 Reflect.enumerate(target)
	var $export = __webpack_require__(7);
	var anObject = __webpack_require__(31);
	var Enumerate = function (iterated) {
	  this._t = anObject(iterated); // target
	  this._i = 0;                  // next index
	  var keys = this._k = [];      // keys
	  var key;
	  for (key in iterated) keys.push(key);
	};
	__webpack_require__(470)(Enumerate, 'Object', function () {
	  var that = this;
	  var keys = that._k;
	  var key;
	  do {
	    if (that._i >= keys.length) return { value: undefined, done: true };
	  } while (!((key = keys[that._i++]) in that._t));
	  return { value: key, done: false };
	});
	
	$export($export.S, 'Reflect', {
	  enumerate: function enumerate(target) {
	    return new Enumerate(target);
	  }
	});


/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	var gOPD = __webpack_require__(105);
	var $export = __webpack_require__(7);
	var anObject = __webpack_require__(31);
	
	$export($export.S, 'Reflect', {
	  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	    return gOPD.f(anObject(target), propertyKey);
	  }
	});


/***/ },
/* 2017 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.8 Reflect.getPrototypeOf(target)
	var $export = __webpack_require__(7);
	var getProto = __webpack_require__(106);
	var anObject = __webpack_require__(31);
	
	$export($export.S, 'Reflect', {
	  getPrototypeOf: function getPrototypeOf(target) {
	    return getProto(anObject(target));
	  }
	});


/***/ },
/* 2018 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.6 Reflect.get(target, propertyKey [, receiver])
	var gOPD = __webpack_require__(105);
	var getPrototypeOf = __webpack_require__(106);
	var has = __webpack_require__(104);
	var $export = __webpack_require__(7);
	var isObject = __webpack_require__(45);
	var anObject = __webpack_require__(31);
	
	function get(target, propertyKey /* , receiver */) {
	  var receiver = arguments.length < 3 ? target : arguments[2];
	  var desc, proto;
	  if (anObject(target) === receiver) return target[propertyKey];
	  if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value')
	    ? desc.value
	    : desc.get !== undefined
	      ? desc.get.call(receiver)
	      : undefined;
	  if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	}
	
	$export($export.S, 'Reflect', { get: get });


/***/ },
/* 2019 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.9 Reflect.has(target, propertyKey)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Reflect', {
	  has: function has(target, propertyKey) {
	    return propertyKey in target;
	  }
	});


/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.10 Reflect.isExtensible(target)
	var $export = __webpack_require__(7);
	var anObject = __webpack_require__(31);
	var $isExtensible = Object.isExtensible;
	
	$export($export.S, 'Reflect', {
	  isExtensible: function isExtensible(target) {
	    anObject(target);
	    return $isExtensible ? $isExtensible(target) : true;
	  }
	});


/***/ },
/* 2021 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.11 Reflect.ownKeys(target)
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Reflect', { ownKeys: __webpack_require__(779) });


/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.12 Reflect.preventExtensions(target)
	var $export = __webpack_require__(7);
	var anObject = __webpack_require__(31);
	var $preventExtensions = Object.preventExtensions;
	
	$export($export.S, 'Reflect', {
	  preventExtensions: function preventExtensions(target) {
	    anObject(target);
	    try {
	      if ($preventExtensions) $preventExtensions(target);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 2023 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.14 Reflect.setPrototypeOf(target, proto)
	var $export = __webpack_require__(7);
	var setProto = __webpack_require__(477);
	
	if (setProto) $export($export.S, 'Reflect', {
	  setPrototypeOf: function setPrototypeOf(target, proto) {
	    setProto.check(target, proto);
	    try {
	      setProto.set(target, proto);
	      return true;
	    } catch (e) {
	      return false;
	    }
	  }
	});


/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	// 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	var dP = __webpack_require__(69);
	var gOPD = __webpack_require__(105);
	var getPrototypeOf = __webpack_require__(106);
	var has = __webpack_require__(104);
	var $export = __webpack_require__(7);
	var createDesc = __webpack_require__(202);
	var anObject = __webpack_require__(31);
	var isObject = __webpack_require__(45);
	
	function set(target, propertyKey, V /* , receiver */) {
	  var receiver = arguments.length < 4 ? target : arguments[3];
	  var ownDesc = gOPD.f(anObject(target), propertyKey);
	  var existingDescriptor, proto;
	  if (!ownDesc) {
	    if (isObject(proto = getPrototypeOf(target))) {
	      return set(proto, propertyKey, V, receiver);
	    }
	    ownDesc = createDesc(0);
	  }
	  if (has(ownDesc, 'value')) {
	    if (ownDesc.writable === false || !isObject(receiver)) return false;
	    if (existingDescriptor = gOPD.f(receiver, propertyKey)) {
	      if (existingDescriptor.get || existingDescriptor.set || existingDescriptor.writable === false) return false;
	      existingDescriptor.value = V;
	      dP.f(receiver, propertyKey, existingDescriptor);
	    } else dP.f(receiver, propertyKey, createDesc(0, V));
	    return true;
	  }
	  return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	}
	
	$export($export.S, 'Reflect', { set: set });


/***/ },
/* 2025 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(42);
	var inheritIfRequired = __webpack_require__(468);
	var dP = __webpack_require__(69).f;
	var gOPN = __webpack_require__(200).f;
	var isRegExp = __webpack_require__(340);
	var $flags = __webpack_require__(276);
	var $RegExp = global.RegExp;
	var Base = $RegExp;
	var proto = $RegExp.prototype;
	var re1 = /a/g;
	var re2 = /a/g;
	// "new" creates a new object, old webkit buggy here
	var CORRECT_NEW = new $RegExp(re1) !== re1;
	
	if (__webpack_require__(65) && (!CORRECT_NEW || __webpack_require__(43)(function () {
	  re2[__webpack_require__(58)('match')] = false;
	  // RegExp constructor can alter flags and IsRegExp works correct with @@match
	  return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	}))) {
	  $RegExp = function RegExp(p, f) {
	    var tiRE = this instanceof $RegExp;
	    var piRE = isRegExp(p);
	    var fiU = f === undefined;
	    return !tiRE && piRE && p.constructor === $RegExp && fiU ? p
	      : inheritIfRequired(CORRECT_NEW
	        ? new Base(piRE && !fiU ? p.source : p, f)
	        : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f)
	      , tiRE ? this : proto, $RegExp);
	  };
	  var proxy = function (key) {
	    key in $RegExp || dP($RegExp, key, {
	      configurable: true,
	      get: function () { return Base[key]; },
	      set: function (it) { Base[key] = it; }
	    });
	  };
	  for (var keys = gOPN(Base), i = 0; keys.length > i;) proxy(keys[i++]);
	  proto.constructor = $RegExp;
	  $RegExp.prototype = proto;
	  __webpack_require__(98)(global, 'RegExp', $RegExp);
	}
	
	__webpack_require__(204)('RegExp');


/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(31);
	var toLength = __webpack_require__(63);
	var advanceStringIndex = __webpack_require__(460);
	var regExpExec = __webpack_require__(344);
	
	// @@match logic
	__webpack_require__(338)('match', 1, function (defined, MATCH, $match, maybeCallNative) {
	  return [
	    // `String.prototype.match` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.match
	    function match(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[MATCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	    },
	    // `RegExp.prototype[@@match]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@match
	    function (regexp) {
	      var res = maybeCallNative($match, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      if (!rx.global) return regExpExec(rx, S);
	      var fullUnicode = rx.unicode;
	      rx.lastIndex = 0;
	      var A = [];
	      var n = 0;
	      var result;
	      while ((result = regExpExec(rx, S)) !== null) {
	        var matchStr = String(result[0]);
	        A[n] = matchStr;
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	        n++;
	      }
	      return n === 0 ? null : A;
	    }
	  ];
	});


/***/ },
/* 2027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(31);
	var toObject = __webpack_require__(75);
	var toLength = __webpack_require__(63);
	var toInteger = __webpack_require__(120);
	var advanceStringIndex = __webpack_require__(460);
	var regExpExec = __webpack_require__(344);
	var max = Math.max;
	var min = Math.min;
	var floor = Math.floor;
	var SUBSTITUTION_SYMBOLS = /\$([$&`']|\d\d?|<[^>]*>)/g;
	var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&`']|\d\d?)/g;
	
	var maybeToString = function (it) {
	  return it === undefined ? it : String(it);
	};
	
	// @@replace logic
	__webpack_require__(338)('replace', 2, function (defined, REPLACE, $replace, maybeCallNative) {
	  return [
	    // `String.prototype.replace` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.replace
	    function replace(searchValue, replaceValue) {
	      var O = defined(this);
	      var fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	      return fn !== undefined
	        ? fn.call(searchValue, O, replaceValue)
	        : $replace.call(String(O), searchValue, replaceValue);
	    },
	    // `RegExp.prototype[@@replace]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@replace
	    function (regexp, replaceValue) {
	      var res = maybeCallNative($replace, regexp, this, replaceValue);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var functionalReplace = typeof replaceValue === 'function';
	      if (!functionalReplace) replaceValue = String(replaceValue);
	      var global = rx.global;
	      if (global) {
	        var fullUnicode = rx.unicode;
	        rx.lastIndex = 0;
	      }
	      var results = [];
	      while (true) {
	        var result = regExpExec(rx, S);
	        if (result === null) break;
	        results.push(result);
	        if (!global) break;
	        var matchStr = String(result[0]);
	        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
	      }
	      var accumulatedResult = '';
	      var nextSourcePosition = 0;
	      for (var i = 0; i < results.length; i++) {
	        result = results[i];
	        var matched = String(result[0]);
	        var position = max(min(toInteger(result.index), S.length), 0);
	        var captures = [];
	        // NOTE: This is equivalent to
	        //   captures = result.slice(1).map(maybeToString)
	        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
	        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
	        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
	        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
	        var namedCaptures = result.groups;
	        if (functionalReplace) {
	          var replacerArgs = [matched].concat(captures, position, S);
	          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
	          var replacement = String(replaceValue.apply(undefined, replacerArgs));
	        } else {
	          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
	        }
	        if (position >= nextSourcePosition) {
	          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
	          nextSourcePosition = position + matched.length;
	        }
	      }
	      return accumulatedResult + S.slice(nextSourcePosition);
	    }
	  ];
	
	    // https://tc39.github.io/ecma262/#sec-getsubstitution
	  function getSubstitution(matched, str, position, captures, namedCaptures, replacement) {
	    var tailPos = position + matched.length;
	    var m = captures.length;
	    var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
	    if (namedCaptures !== undefined) {
	      namedCaptures = toObject(namedCaptures);
	      symbols = SUBSTITUTION_SYMBOLS;
	    }
	    return $replace.call(replacement, symbols, function (match, ch) {
	      var capture;
	      switch (ch.charAt(0)) {
	        case '$': return '$';
	        case '&': return matched;
	        case '`': return str.slice(0, position);
	        case "'": return str.slice(tailPos);
	        case '<':
	          capture = namedCaptures[ch.slice(1, -1)];
	          break;
	        default: // \d\d?
	          var n = +ch;
	          if (n === 0) return match;
	          if (n > m) {
	            var f = floor(n / 10);
	            if (f === 0) return match;
	            if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
	            return match;
	          }
	          capture = captures[n - 1];
	      }
	      return capture === undefined ? '' : capture;
	    });
	  }
	});


/***/ },
/* 2028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var anObject = __webpack_require__(31);
	var sameValue = __webpack_require__(784);
	var regExpExec = __webpack_require__(344);
	
	// @@search logic
	__webpack_require__(338)('search', 1, function (defined, SEARCH, $search, maybeCallNative) {
	  return [
	    // `String.prototype.search` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.search
	    function search(regexp) {
	      var O = defined(this);
	      var fn = regexp == undefined ? undefined : regexp[SEARCH];
	      return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	    },
	    // `RegExp.prototype[@@search]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@search
	    function (regexp) {
	      var res = maybeCallNative($search, regexp, this);
	      if (res.done) return res.value;
	      var rx = anObject(regexp);
	      var S = String(this);
	      var previousLastIndex = rx.lastIndex;
	      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
	      var result = regExpExec(rx, S);
	      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
	      return result === null ? -1 : result.index;
	    }
	  ];
	});


/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isRegExp = __webpack_require__(340);
	var anObject = __webpack_require__(31);
	var speciesConstructor = __webpack_require__(280);
	var advanceStringIndex = __webpack_require__(460);
	var toLength = __webpack_require__(63);
	var callRegExpExec = __webpack_require__(344);
	var regexpExec = __webpack_require__(476);
	var fails = __webpack_require__(43);
	var $min = Math.min;
	var $push = [].push;
	var $SPLIT = 'split';
	var LENGTH = 'length';
	var LAST_INDEX = 'lastIndex';
	var MAX_UINT32 = 0xffffffff;
	
	// babel-minify transpiles RegExp('x', 'y') -> /x/y and it causes SyntaxError
	var SUPPORTS_Y = !fails(function () { RegExp(MAX_UINT32, 'y'); });
	
	// @@split logic
	__webpack_require__(338)('split', 2, function (defined, SPLIT, $split, maybeCallNative) {
	  var internalSplit;
	  if (
	    'abbc'[$SPLIT](/(b)*/)[1] == 'c' ||
	    'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 ||
	    'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 ||
	    '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 ||
	    '.'[$SPLIT](/()()/)[LENGTH] > 1 ||
	    ''[$SPLIT](/.?/)[LENGTH]
	  ) {
	    // based on es5-shim implementation, need to rework it
	    internalSplit = function (separator, limit) {
	      var string = String(this);
	      if (separator === undefined && limit === 0) return [];
	      // If `separator` is not a regex, use native split
	      if (!isRegExp(separator)) return $split.call(string, separator, limit);
	      var output = [];
	      var flags = (separator.ignoreCase ? 'i' : '') +
	                  (separator.multiline ? 'm' : '') +
	                  (separator.unicode ? 'u' : '') +
	                  (separator.sticky ? 'y' : '');
	      var lastLastIndex = 0;
	      var splitLimit = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      // Make `global` and avoid `lastIndex` issues by working with a copy
	      var separatorCopy = new RegExp(separator.source, flags + 'g');
	      var match, lastIndex, lastLength;
	      while (match = regexpExec.call(separatorCopy, string)) {
	        lastIndex = separatorCopy[LAST_INDEX];
	        if (lastIndex > lastLastIndex) {
	          output.push(string.slice(lastLastIndex, match.index));
	          if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	          lastLength = match[0][LENGTH];
	          lastLastIndex = lastIndex;
	          if (output[LENGTH] >= splitLimit) break;
	        }
	        if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	      }
	      if (lastLastIndex === string[LENGTH]) {
	        if (lastLength || !separatorCopy.test('')) output.push('');
	      } else output.push(string.slice(lastLastIndex));
	      return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	    };
	  // Chakra, V8
	  } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	    internalSplit = function (separator, limit) {
	      return separator === undefined && limit === 0 ? [] : $split.call(this, separator, limit);
	    };
	  } else {
	    internalSplit = $split;
	  }
	
	  return [
	    // `String.prototype.split` method
	    // https://tc39.github.io/ecma262/#sec-string.prototype.split
	    function split(separator, limit) {
	      var O = defined(this);
	      var splitter = separator == undefined ? undefined : separator[SPLIT];
	      return splitter !== undefined
	        ? splitter.call(separator, O, limit)
	        : internalSplit.call(String(O), separator, limit);
	    },
	    // `RegExp.prototype[@@split]` method
	    // https://tc39.github.io/ecma262/#sec-regexp.prototype-@@split
	    //
	    // NOTE: This cannot be properly polyfilled in engines that don't support
	    // the 'y' flag.
	    function (regexp, limit) {
	      var res = maybeCallNative(internalSplit, regexp, this, limit, internalSplit !== $split);
	      if (res.done) return res.value;
	
	      var rx = anObject(regexp);
	      var S = String(this);
	      var C = speciesConstructor(rx, RegExp);
	
	      var unicodeMatching = rx.unicode;
	      var flags = (rx.ignoreCase ? 'i' : '') +
	                  (rx.multiline ? 'm' : '') +
	                  (rx.unicode ? 'u' : '') +
	                  (SUPPORTS_Y ? 'y' : 'g');
	
	      // ^(? + rx + ) is needed, in combination with some S slicing, to
	      // simulate the 'y' flag.
	      var splitter = new C(SUPPORTS_Y ? rx : '^(?:' + rx.source + ')', flags);
	      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
	      if (lim === 0) return [];
	      if (S.length === 0) return callRegExpExec(splitter, S) === null ? [S] : [];
	      var p = 0;
	      var q = 0;
	      var A = [];
	      while (q < S.length) {
	        splitter.lastIndex = SUPPORTS_Y ? q : 0;
	        var z = callRegExpExec(splitter, SUPPORTS_Y ? S : S.slice(q));
	        var e;
	        if (
	          z === null ||
	          (e = $min(toLength(splitter.lastIndex + (SUPPORTS_Y ? 0 : q)), S.length)) === p
	        ) {
	          q = advanceStringIndex(S, q, unicodeMatching);
	        } else {
	          A.push(S.slice(p, q));
	          if (A.length === lim) return A;
	          for (var i = 1; i <= z.length - 1; i++) {
	            A.push(z[i]);
	            if (A.length === lim) return A;
	          }
	          q = p = e;
	        }
	      }
	      A.push(S.slice(p));
	      return A;
	    }
	  ];
	});


/***/ },
/* 2030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	__webpack_require__(790);
	var anObject = __webpack_require__(31);
	var $flags = __webpack_require__(276);
	var DESCRIPTORS = __webpack_require__(65);
	var TO_STRING = 'toString';
	var $toString = /./[TO_STRING];
	
	var define = function (fn) {
	  __webpack_require__(98)(RegExp.prototype, TO_STRING, fn, true);
	};
	
	// 21.2.5.14 RegExp.prototype.toString()
	if (__webpack_require__(43)(function () { return $toString.call({ source: 'a', flags: 'b' }) != '/a/b'; })) {
	  define(function toString() {
	    var R = anObject(this);
	    return '/'.concat(R.source, '/',
	      'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	  });
	// FF44- RegExp#toString has a wrong name
	} else if ($toString.name != TO_STRING) {
	  define(function toString() {
	    return $toString.call(this);
	  });
	}


/***/ },
/* 2031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.2 String.prototype.anchor(name)
	__webpack_require__(99)('anchor', function (createHTML) {
	  return function anchor(name) {
	    return createHTML(this, 'a', 'name', name);
	  };
	});


/***/ },
/* 2032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.3 String.prototype.big()
	__webpack_require__(99)('big', function (createHTML) {
	  return function big() {
	    return createHTML(this, 'big', '', '');
	  };
	});


/***/ },
/* 2033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.4 String.prototype.blink()
	__webpack_require__(99)('blink', function (createHTML) {
	  return function blink() {
	    return createHTML(this, 'blink', '', '');
	  };
	});


/***/ },
/* 2034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.5 String.prototype.bold()
	__webpack_require__(99)('bold', function (createHTML) {
	  return function bold() {
	    return createHTML(this, 'b', '', '');
	  };
	});


/***/ },
/* 2035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $at = __webpack_require__(347)(false);
	$export($export.P, 'String', {
	  // 21.1.3.3 String.prototype.codePointAt(pos)
	  codePointAt: function codePointAt(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 2036 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	'use strict';
	var $export = __webpack_require__(7);
	var toLength = __webpack_require__(63);
	var context = __webpack_require__(479);
	var ENDS_WITH = 'endsWith';
	var $endsWith = ''[ENDS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(466)(ENDS_WITH), 'String', {
	  endsWith: function endsWith(searchString /* , endPosition = @length */) {
	    var that = context(this, searchString, ENDS_WITH);
	    var endPosition = arguments.length > 1 ? arguments[1] : undefined;
	    var len = toLength(that.length);
	    var end = endPosition === undefined ? len : Math.min(toLength(endPosition), len);
	    var search = String(searchString);
	    return $endsWith
	      ? $endsWith.call(that, search, end)
	      : that.slice(end - search.length, end) === search;
	  }
	});


/***/ },
/* 2037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.6 String.prototype.fixed()
	__webpack_require__(99)('fixed', function (createHTML) {
	  return function fixed() {
	    return createHTML(this, 'tt', '', '');
	  };
	});


/***/ },
/* 2038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.7 String.prototype.fontcolor(color)
	__webpack_require__(99)('fontcolor', function (createHTML) {
	  return function fontcolor(color) {
	    return createHTML(this, 'font', 'color', color);
	  };
	});


/***/ },
/* 2039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.8 String.prototype.fontsize(size)
	__webpack_require__(99)('fontsize', function (createHTML) {
	  return function fontsize(size) {
	    return createHTML(this, 'font', 'size', size);
	  };
	});


/***/ },
/* 2040 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var toAbsoluteIndex = __webpack_require__(205);
	var fromCharCode = String.fromCharCode;
	var $fromCodePoint = String.fromCodePoint;
	
	// length should be 1, old FF problem
	$export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	  // 21.1.2.2 String.fromCodePoint(...codePoints)
	  fromCodePoint: function fromCodePoint(x) { // eslint-disable-line no-unused-vars
	    var res = [];
	    var aLen = arguments.length;
	    var i = 0;
	    var code;
	    while (aLen > i) {
	      code = +arguments[i++];
	      if (toAbsoluteIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	      res.push(code < 0x10000
	        ? fromCharCode(code)
	        : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00)
	      );
	    } return res.join('');
	  }
	});


/***/ },
/* 2041 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.7 String.prototype.includes(searchString, position = 0)
	'use strict';
	var $export = __webpack_require__(7);
	var context = __webpack_require__(479);
	var INCLUDES = 'includes';
	
	$export($export.P + $export.F * __webpack_require__(466)(INCLUDES), 'String', {
	  includes: function includes(searchString /* , position = 0 */) {
	    return !!~context(this, searchString, INCLUDES)
	      .indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});


/***/ },
/* 2042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.9 String.prototype.italics()
	__webpack_require__(99)('italics', function (createHTML) {
	  return function italics() {
	    return createHTML(this, 'i', '', '');
	  };
	});


/***/ },
/* 2043 */
[3060, 347, 471],
/* 2044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.10 String.prototype.link(url)
	__webpack_require__(99)('link', function (createHTML) {
	  return function link(url) {
	    return createHTML(this, 'a', 'href', url);
	  };
	});


/***/ },
/* 2045 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var toIObject = __webpack_require__(107);
	var toLength = __webpack_require__(63);
	
	$export($export.S, 'String', {
	  // 21.1.2.4 String.raw(callSite, ...substitutions)
	  raw: function raw(callSite) {
	    var tpl = toIObject(callSite.raw);
	    var len = toLength(tpl.length);
	    var aLen = arguments.length;
	    var res = [];
	    var i = 0;
	    while (len > i) {
	      res.push(String(tpl[i++]));
	      if (i < aLen) res.push(String(arguments[i]));
	    } return res.join('');
	  }
	});


/***/ },
/* 2046 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	
	$export($export.P, 'String', {
	  // 21.1.3.13 String.prototype.repeat(count)
	  repeat: __webpack_require__(480)
	});


/***/ },
/* 2047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.11 String.prototype.small()
	__webpack_require__(99)('small', function (createHTML) {
	  return function small() {
	    return createHTML(this, 'small', '', '');
	  };
	});


/***/ },
/* 2048 */
/***/ function(module, exports, __webpack_require__) {

	// 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	'use strict';
	var $export = __webpack_require__(7);
	var toLength = __webpack_require__(63);
	var context = __webpack_require__(479);
	var STARTS_WITH = 'startsWith';
	var $startsWith = ''[STARTS_WITH];
	
	$export($export.P + $export.F * __webpack_require__(466)(STARTS_WITH), 'String', {
	  startsWith: function startsWith(searchString /* , position = 0 */) {
	    var that = context(this, searchString, STARTS_WITH);
	    var index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length));
	    var search = String(searchString);
	    return $startsWith
	      ? $startsWith.call(that, search, index)
	      : that.slice(index, index + search.length) === search;
	  }
	});


/***/ },
/* 2049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.12 String.prototype.strike()
	__webpack_require__(99)('strike', function (createHTML) {
	  return function strike() {
	    return createHTML(this, 'strike', '', '');
	  };
	});


/***/ },
/* 2050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.13 String.prototype.sub()
	__webpack_require__(99)('sub', function (createHTML) {
	  return function sub() {
	    return createHTML(this, 'sub', '', '');
	  };
	});


/***/ },
/* 2051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// B.2.3.14 String.prototype.sup()
	__webpack_require__(99)('sup', function (createHTML) {
	  return function sup() {
	    return createHTML(this, 'sup', '', '');
	  };
	});


/***/ },
/* 2052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 21.1.3.25 String.prototype.trim()
	__webpack_require__(243)('trim', function ($trim) {
	  return function trim() {
	    return $trim(this, 3);
	  };
	});


/***/ },
/* 2053 */
[3061, 42, 104, 65, 7, 98, 174, 43, 279, 242, 206, 58, 787, 484, 1930, 339, 31, 45, 75, 107, 138, 202, 199, 776, 105, 343, 69, 201, 200, 278, 173, 97],
/* 2054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var $typed = __webpack_require__(348);
	var buffer = __webpack_require__(483);
	var anObject = __webpack_require__(31);
	var toAbsoluteIndex = __webpack_require__(205);
	var toLength = __webpack_require__(63);
	var isObject = __webpack_require__(45);
	var ArrayBuffer = __webpack_require__(42).ArrayBuffer;
	var speciesConstructor = __webpack_require__(280);
	var $ArrayBuffer = buffer.ArrayBuffer;
	var $DataView = buffer.DataView;
	var $isView = $typed.ABV && ArrayBuffer.isView;
	var $slice = $ArrayBuffer.prototype.slice;
	var VIEW = $typed.VIEW;
	var ARRAY_BUFFER = 'ArrayBuffer';
	
	$export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	$export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	  // 24.1.3.1 ArrayBuffer.isView(arg)
	  isView: function isView(it) {
	    return $isView && $isView(it) || isObject(it) && VIEW in it;
	  }
	});
	
	$export($export.P + $export.U + $export.F * __webpack_require__(43)(function () {
	  return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	}), ARRAY_BUFFER, {
	  // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	  slice: function slice(start, end) {
	    if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	    var len = anObject(this).byteLength;
	    var first = toAbsoluteIndex(start, len);
	    var fin = toAbsoluteIndex(end === undefined ? len : end, len);
	    var result = new (speciesConstructor(this, $ArrayBuffer))(toLength(fin - first));
	    var viewS = new $DataView(this);
	    var viewT = new $DataView(result);
	    var index = 0;
	    while (first < fin) {
	      viewT.setUint8(index++, viewS.getUint8(first++));
	    } return result;
	  }
	});
	
	__webpack_require__(204)(ARRAY_BUFFER);


/***/ },
/* 2055 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	$export($export.G + $export.W + $export.F * !__webpack_require__(348).ABV, {
	  DataView: __webpack_require__(483).DataView
	});


/***/ },
/* 2056 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157)('Float32', 4, function (init) {
	  return function Float32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 2057 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157)('Float64', 8, function (init) {
	  return function Float64Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 2058 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157)('Int16', 2, function (init) {
	  return function Int16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 2059 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157)('Int32', 4, function (init) {
	  return function Int32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 2060 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157)('Int8', 1, function (init) {
	  return function Int8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 2061 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157)('Uint16', 2, function (init) {
	  return function Uint16Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 2062 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157)('Uint32', 4, function (init) {
	  return function Uint32Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 2063 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157)('Uint8', 1, function (init) {
	  return function Uint8Array(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	});


/***/ },
/* 2064 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(157)('Uint8', 1, function (init) {
	  return function Uint8ClampedArray(data, byteOffset, length) {
	    return init(this, data, byteOffset, length);
	  };
	}, true);


/***/ },
/* 2065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var weak = __webpack_require__(764);
	var validate = __webpack_require__(207);
	var WEAK_SET = 'WeakSet';
	
	// 23.4 WeakSet Objects
	__webpack_require__(337)(WEAK_SET, function (get) {
	  return function WeakSet() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
	}, {
	  // 23.4.3.1 WeakSet.prototype.add(value)
	  add: function add(value) {
	    return weak.def(validate(this, WEAK_SET), value, true);
	  }
	}, weak, false, true);


/***/ },
/* 2066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatMap
	var $export = __webpack_require__(7);
	var flattenIntoArray = __webpack_require__(765);
	var toObject = __webpack_require__(75);
	var toLength = __webpack_require__(63);
	var aFunction = __webpack_require__(84);
	var arraySpeciesCreate = __webpack_require__(462);
	
	$export($export.P, 'Array', {
	  flatMap: function flatMap(callbackfn /* , thisArg */) {
	    var O = toObject(this);
	    var sourceLen, A;
	    aFunction(callbackfn);
	    sourceLen = toLength(O.length);
	    A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments[1]);
	    return A;
	  }
	});
	
	__webpack_require__(172)('flatMap');


/***/ },
/* 2067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/proposal-flatMap/#sec-Array.prototype.flatten
	var $export = __webpack_require__(7);
	var flattenIntoArray = __webpack_require__(765);
	var toObject = __webpack_require__(75);
	var toLength = __webpack_require__(63);
	var toInteger = __webpack_require__(120);
	var arraySpeciesCreate = __webpack_require__(462);
	
	$export($export.P, 'Array', {
	  flatten: function flatten(/* depthArg = 1 */) {
	    var depthArg = arguments[0];
	    var O = toObject(this);
	    var sourceLen = toLength(O.length);
	    var A = arraySpeciesCreate(O, 0);
	    flattenIntoArray(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
	    return A;
	  }
	});
	
	__webpack_require__(172)('flatten');


/***/ },
/* 2068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/Array.prototype.includes
	var $export = __webpack_require__(7);
	var $includes = __webpack_require__(336)(true);
	
	$export($export.P, 'Array', {
	  includes: function includes(el /* , fromIndex = 0 */) {
	    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	  }
	});
	
	__webpack_require__(172)('includes');


/***/ },
/* 2069 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	var $export = __webpack_require__(7);
	var microtask = __webpack_require__(474)();
	var process = __webpack_require__(42).process;
	var isNode = __webpack_require__(116)(process) == 'process';
	
	$export($export.G, {
	  asap: function asap(fn) {
	    var domain = isNode && process.domain;
	    microtask(domain ? domain.bind(fn) : fn);
	  }
	});


/***/ },
/* 2070 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/ljharb/proposal-is-error
	var $export = __webpack_require__(7);
	var cof = __webpack_require__(116);
	
	$export($export.S, 'Error', {
	  isError: function isError(it) {
	    return cof(it) === 'Error';
	  }
	});


/***/ },
/* 2071 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(7);
	
	$export($export.G, { global: __webpack_require__(42) });


/***/ },
/* 2072 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.from
	__webpack_require__(345)('Map');


/***/ },
/* 2073 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-map.of
	__webpack_require__(346)('Map');


/***/ },
/* 2074 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(7);
	
	$export($export.P + $export.R, 'Map', { toJSON: __webpack_require__(763)('Map') });


/***/ },
/* 2075 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  clamp: function clamp(x, lower, upper) {
	    return Math.min(upper, Math.max(lower, x));
	  }
	});


/***/ },
/* 2076 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { DEG_PER_RAD: Math.PI / 180 });


/***/ },
/* 2077 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	var RAD_PER_DEG = 180 / Math.PI;
	
	$export($export.S, 'Math', {
	  degrees: function degrees(radians) {
	    return radians * RAD_PER_DEG;
	  }
	});


/***/ },
/* 2078 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	var scale = __webpack_require__(773);
	var fround = __webpack_require__(771);
	
	$export($export.S, 'Math', {
	  fscale: function fscale(x, inLow, inHigh, outLow, outHigh) {
	    return fround(scale(x, inLow, inHigh, outLow, outHigh));
	  }
	});


/***/ },
/* 2079 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  iaddh: function iaddh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	  }
	});


/***/ },
/* 2080 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  imulh: function imulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >> 16;
	    var v1 = $v >> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	  }
	});


/***/ },
/* 2081 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  isubh: function isubh(x0, x1, y0, y1) {
	    var $x0 = x0 >>> 0;
	    var $x1 = x1 >>> 0;
	    var $y0 = y0 >>> 0;
	    return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	  }
	});


/***/ },
/* 2082 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { RAD_PER_DEG: 180 / Math.PI });


/***/ },
/* 2083 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	var DEG_PER_RAD = Math.PI / 180;
	
	$export($export.S, 'Math', {
	  radians: function radians(degrees) {
	    return degrees * DEG_PER_RAD;
	  }
	});


/***/ },
/* 2084 */
/***/ function(module, exports, __webpack_require__) {

	// https://rwaldron.github.io/proposal-math-extensions/
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { scale: __webpack_require__(773) });


/***/ },
/* 2085 */
/***/ function(module, exports, __webpack_require__) {

	// http://jfbastien.github.io/papers/Math.signbit.html
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', { signbit: function signbit(x) {
	  // eslint-disable-next-line no-self-compare
	  return (x = +x) != x ? x : x == 0 ? 1 / x == Infinity : x > 0;
	} });


/***/ },
/* 2086 */
/***/ function(module, exports, __webpack_require__) {

	// https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	var $export = __webpack_require__(7);
	
	$export($export.S, 'Math', {
	  umulh: function umulh(u, v) {
	    var UINT16 = 0xffff;
	    var $u = +u;
	    var $v = +v;
	    var u0 = $u & UINT16;
	    var v0 = $v & UINT16;
	    var u1 = $u >>> 16;
	    var v1 = $v >>> 16;
	    var t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	    return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	  }
	});


/***/ },
/* 2087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toObject = __webpack_require__(75);
	var aFunction = __webpack_require__(84);
	var $defineProperty = __webpack_require__(69);
	
	// B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	__webpack_require__(65) && $export($export.P + __webpack_require__(342), 'Object', {
	  __defineGetter__: function __defineGetter__(P, getter) {
	    $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 2088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toObject = __webpack_require__(75);
	var aFunction = __webpack_require__(84);
	var $defineProperty = __webpack_require__(69);
	
	// B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	__webpack_require__(65) && $export($export.P + __webpack_require__(342), 'Object', {
	  __defineSetter__: function __defineSetter__(P, setter) {
	    $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	  }
	});


/***/ },
/* 2089 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(7);
	var $entries = __webpack_require__(778)(true);
	
	$export($export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});


/***/ },
/* 2090 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-getownpropertydescriptors
	var $export = __webpack_require__(7);
	var ownKeys = __webpack_require__(779);
	var toIObject = __webpack_require__(107);
	var gOPD = __webpack_require__(105);
	var createProperty = __webpack_require__(463);
	
	$export($export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = toIObject(object);
	    var getDesc = gOPD.f;
	    var keys = ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) createProperty(result, key, desc);
	    }
	    return result;
	  }
	});


/***/ },
/* 2091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toObject = __webpack_require__(75);
	var toPrimitive = __webpack_require__(138);
	var getPrototypeOf = __webpack_require__(106);
	var getOwnPropertyDescriptor = __webpack_require__(105).f;
	
	// B.2.2.4 Object.prototype.__lookupGetter__(P)
	__webpack_require__(65) && $export($export.P + __webpack_require__(342), 'Object', {
	  __lookupGetter__: function __lookupGetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 2092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $export = __webpack_require__(7);
	var toObject = __webpack_require__(75);
	var toPrimitive = __webpack_require__(138);
	var getPrototypeOf = __webpack_require__(106);
	var getOwnPropertyDescriptor = __webpack_require__(105).f;
	
	// B.2.2.5 Object.prototype.__lookupSetter__(P)
	__webpack_require__(65) && $export($export.P + __webpack_require__(342), 'Object', {
	  __lookupSetter__: function __lookupSetter__(P) {
	    var O = toObject(this);
	    var K = toPrimitive(P, true);
	    var D;
	    do {
	      if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	    } while (O = getPrototypeOf(O));
	  }
	});


/***/ },
/* 2093 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-object-values-entries
	var $export = __webpack_require__(7);
	var $values = __webpack_require__(778)(false);
	
	$export($export.S, 'Object', {
	  values: function values(it) {
	    return $values(it);
	  }
	});


/***/ },
/* 2094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/zenparsing/es-observable
	var $export = __webpack_require__(7);
	var global = __webpack_require__(42);
	var core = __webpack_require__(117);
	var microtask = __webpack_require__(474)();
	var OBSERVABLE = __webpack_require__(58)('observable');
	var aFunction = __webpack_require__(84);
	var anObject = __webpack_require__(31);
	var anInstance = __webpack_require__(197);
	var redefineAll = __webpack_require__(203);
	var hide = __webpack_require__(97);
	var forOf = __webpack_require__(198);
	var RETURN = forOf.RETURN;
	
	var getMethod = function (fn) {
	  return fn == null ? undefined : aFunction(fn);
	};
	
	var cleanupSubscription = function (subscription) {
	  var cleanup = subscription._c;
	  if (cleanup) {
	    subscription._c = undefined;
	    cleanup();
	  }
	};
	
	var subscriptionClosed = function (subscription) {
	  return subscription._o === undefined;
	};
	
	var closeSubscription = function (subscription) {
	  if (!subscriptionClosed(subscription)) {
	    subscription._o = undefined;
	    cleanupSubscription(subscription);
	  }
	};
	
	var Subscription = function (observer, subscriber) {
	  anObject(observer);
	  this._c = undefined;
	  this._o = observer;
	  observer = new SubscriptionObserver(this);
	  try {
	    var cleanup = subscriber(observer);
	    var subscription = cleanup;
	    if (cleanup != null) {
	      if (typeof cleanup.unsubscribe === 'function') cleanup = function () { subscription.unsubscribe(); };
	      else aFunction(cleanup);
	      this._c = cleanup;
	    }
	  } catch (e) {
	    observer.error(e);
	    return;
	  } if (subscriptionClosed(this)) cleanupSubscription(this);
	};
	
	Subscription.prototype = redefineAll({}, {
	  unsubscribe: function unsubscribe() { closeSubscription(this); }
	});
	
	var SubscriptionObserver = function (subscription) {
	  this._s = subscription;
	};
	
	SubscriptionObserver.prototype = redefineAll({}, {
	  next: function next(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      try {
	        var m = getMethod(observer.next);
	        if (m) return m.call(observer, value);
	      } catch (e) {
	        try {
	          closeSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      }
	    }
	  },
	  error: function error(value) {
	    var subscription = this._s;
	    if (subscriptionClosed(subscription)) throw value;
	    var observer = subscription._o;
	    subscription._o = undefined;
	    try {
	      var m = getMethod(observer.error);
	      if (!m) throw value;
	      value = m.call(observer, value);
	    } catch (e) {
	      try {
	        cleanupSubscription(subscription);
	      } finally {
	        throw e;
	      }
	    } cleanupSubscription(subscription);
	    return value;
	  },
	  complete: function complete(value) {
	    var subscription = this._s;
	    if (!subscriptionClosed(subscription)) {
	      var observer = subscription._o;
	      subscription._o = undefined;
	      try {
	        var m = getMethod(observer.complete);
	        value = m ? m.call(observer, value) : undefined;
	      } catch (e) {
	        try {
	          cleanupSubscription(subscription);
	        } finally {
	          throw e;
	        }
	      } cleanupSubscription(subscription);
	      return value;
	    }
	  }
	});
	
	var $Observable = function Observable(subscriber) {
	  anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	};
	
	redefineAll($Observable.prototype, {
	  subscribe: function subscribe(observer) {
	    return new Subscription(observer, this._f);
	  },
	  forEach: function forEach(fn) {
	    var that = this;
	    return new (core.Promise || global.Promise)(function (resolve, reject) {
	      aFunction(fn);
	      var subscription = that.subscribe({
	        next: function (value) {
	          try {
	            return fn(value);
	          } catch (e) {
	            reject(e);
	            subscription.unsubscribe();
	          }
	        },
	        error: reject,
	        complete: resolve
	      });
	    });
	  }
	});
	
	redefineAll($Observable, {
	  from: function from(x) {
	    var C = typeof this === 'function' ? this : $Observable;
	    var method = getMethod(anObject(x)[OBSERVABLE]);
	    if (method) {
	      var observable = anObject(method.call(x));
	      return observable.constructor === C ? observable : new C(function (observer) {
	        return observable.subscribe(observer);
	      });
	    }
	    return new C(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          try {
	            if (forOf(x, false, function (it) {
	              observer.next(it);
	              if (done) return RETURN;
	            }) === RETURN) return;
	          } catch (e) {
	            if (done) throw e;
	            observer.error(e);
	            return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  },
	  of: function of() {
	    for (var i = 0, l = arguments.length, items = new Array(l); i < l;) items[i] = arguments[i++];
	    return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	      var done = false;
	      microtask(function () {
	        if (!done) {
	          for (var j = 0; j < items.length; ++j) {
	            observer.next(items[j]);
	            if (done) return;
	          } observer.complete();
	        }
	      });
	      return function () { done = true; };
	    });
	  }
	});
	
	hide($Observable.prototype, OBSERVABLE, function () { return this; });
	
	$export($export.G, { Observable: $Observable });
	
	__webpack_require__(204)('Observable');


/***/ },
/* 2095 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-promise-finally
	'use strict';
	var $export = __webpack_require__(7);
	var core = __webpack_require__(117);
	var global = __webpack_require__(42);
	var speciesConstructor = __webpack_require__(280);
	var promiseResolve = __webpack_require__(783);
	
	$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = speciesConstructor(this, core.Promise || global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });


/***/ },
/* 2096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-promise-try
	var $export = __webpack_require__(7);
	var newPromiseCapability = __webpack_require__(475);
	var perform = __webpack_require__(782);
	
	$export($export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = newPromiseCapability.f(this);
	  var result = perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });


/***/ },
/* 2097 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(156);
	var anObject = __webpack_require__(31);
	var toMetaKey = metadata.key;
	var ordinaryDefineOwnMetadata = metadata.set;
	
	metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	  ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	} });


/***/ },
/* 2098 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(156);
	var anObject = __webpack_require__(31);
	var toMetaKey = metadata.key;
	var getOrCreateMetadataMap = metadata.map;
	var store = metadata.store;
	
	metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /* , targetKey */) {
	  var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]);
	  var metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	  if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	  if (metadataMap.size) return true;
	  var targetMetadata = store.get(target);
	  targetMetadata['delete'](targetKey);
	  return !!targetMetadata.size || store['delete'](target);
	} });


/***/ },
/* 2099 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(791);
	var from = __webpack_require__(759);
	var metadata = __webpack_require__(156);
	var anObject = __webpack_require__(31);
	var getPrototypeOf = __webpack_require__(106);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	var ordinaryMetadataKeys = function (O, P) {
	  var oKeys = ordinaryOwnMetadataKeys(O, P);
	  var parent = getPrototypeOf(O);
	  if (parent === null) return oKeys;
	  var pKeys = ordinaryMetadataKeys(parent, P);
	  return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	};
	
	metadata.exp({ getMetadataKeys: function getMetadataKeys(target /* , targetKey */) {
	  return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 2100 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(156);
	var anObject = __webpack_require__(31);
	var getPrototypeOf = __webpack_require__(106);
	var ordinaryHasOwnMetadata = metadata.has;
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	var ordinaryGetMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	};
	
	metadata.exp({ getMetadata: function getMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 2101 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(156);
	var anObject = __webpack_require__(31);
	var ordinaryOwnMetadataKeys = metadata.keys;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /* , targetKey */) {
	  return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	} });


/***/ },
/* 2102 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(156);
	var anObject = __webpack_require__(31);
	var ordinaryGetOwnMetadata = metadata.get;
	var toMetaKey = metadata.key;
	
	metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryGetOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 2103 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(156);
	var anObject = __webpack_require__(31);
	var getPrototypeOf = __webpack_require__(106);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	var ordinaryHasMetadata = function (MetadataKey, O, P) {
	  var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	  if (hasOwn) return true;
	  var parent = getPrototypeOf(O);
	  return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	};
	
	metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 2104 */
/***/ function(module, exports, __webpack_require__) {

	var metadata = __webpack_require__(156);
	var anObject = __webpack_require__(31);
	var ordinaryHasOwnMetadata = metadata.has;
	var toMetaKey = metadata.key;
	
	metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /* , targetKey */) {
	  return ordinaryHasOwnMetadata(metadataKey, anObject(target)
	    , arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	} });


/***/ },
/* 2105 */
/***/ function(module, exports, __webpack_require__) {

	var $metadata = __webpack_require__(156);
	var anObject = __webpack_require__(31);
	var aFunction = __webpack_require__(84);
	var toMetaKey = $metadata.key;
	var ordinaryDefineOwnMetadata = $metadata.set;
	
	$metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	  return function decorator(target, targetKey) {
	    ordinaryDefineOwnMetadata(
	      metadataKey, metadataValue,
	      (targetKey !== undefined ? anObject : aFunction)(target),
	      toMetaKey(targetKey)
	    );
	  };
	} });


/***/ },
/* 2106 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.from
	__webpack_require__(345)('Set');


/***/ },
/* 2107 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-set.of
	__webpack_require__(346)('Set');


/***/ },
/* 2108 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/DavidBruant/Map-Set.prototype.toJSON
	var $export = __webpack_require__(7);
	
	$export($export.P + $export.R, 'Set', { toJSON: __webpack_require__(763)('Set') });


/***/ },
/* 2109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/mathiasbynens/String.prototype.at
	var $export = __webpack_require__(7);
	var $at = __webpack_require__(347)(true);
	var $fails = __webpack_require__(43);
	
	var FORCED = $fails(function () {
	  return '𠮷'.at(0) !== '𠮷';
	});
	
	$export($export.P + $export.F * FORCED, 'String', {
	  at: function at(pos) {
	    return $at(this, pos);
	  }
	});


/***/ },
/* 2110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://tc39.github.io/String.prototype.matchAll/
	var $export = __webpack_require__(7);
	var defined = __webpack_require__(136);
	var toLength = __webpack_require__(63);
	var isRegExp = __webpack_require__(340);
	var getFlags = __webpack_require__(276);
	var RegExpProto = RegExp.prototype;
	
	var $RegExpStringIterator = function (regexp, string) {
	  this._r = regexp;
	  this._s = string;
	};
	
	__webpack_require__(470)($RegExpStringIterator, 'RegExp String', function next() {
	  var match = this._r.exec(this._s);
	  return { value: match, done: match === null };
	});
	
	$export($export.P, 'String', {
	  matchAll: function matchAll(regexp) {
	    defined(this);
	    if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	    var S = String(this);
	    var flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp);
	    var rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	    rx.lastIndex = toLength(regexp.lastIndex);
	    return new $RegExpStringIterator(rx, S);
	  }
	});


/***/ },
/* 2111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(7);
	var $pad = __webpack_require__(785);
	var userAgent = __webpack_require__(349);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padEnd: function padEnd(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	  }
	});


/***/ },
/* 2112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/tc39/proposal-string-pad-start-end
	var $export = __webpack_require__(7);
	var $pad = __webpack_require__(785);
	var userAgent = __webpack_require__(349);
	
	// https://github.com/zloirock/core-js/issues/280
	var WEBKIT_BUG = /Version\/10\.\d+(\.\d+)?( Mobile\/\w+)? Safari\//.test(userAgent);
	
	$export($export.P + $export.F * WEBKIT_BUG, 'String', {
	  padStart: function padStart(maxLength /* , fillString = ' ' */) {
	    return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	  }
	});


/***/ },
/* 2113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(243)('trimLeft', function ($trim) {
	  return function trimLeft() {
	    return $trim(this, 1);
	  };
	}, 'trimStart');


/***/ },
/* 2114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	__webpack_require__(243)('trimRight', function ($trim) {
	  return function trimRight() {
	    return $trim(this, 2);
	  };
	}, 'trimEnd');


/***/ },
/* 2115 */
[3062, 484],
/* 2116 */
[3063, 484],
/* 2117 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/tc39/proposal-global
	var $export = __webpack_require__(7);
	
	$export($export.S, 'System', { global: __webpack_require__(42) });


/***/ },
/* 2118 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.from
	__webpack_require__(345)('WeakMap');


/***/ },
/* 2119 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakmap.of
	__webpack_require__(346)('WeakMap');


/***/ },
/* 2120 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.from
	__webpack_require__(345)('WeakSet');


/***/ },
/* 2121 */
/***/ function(module, exports, __webpack_require__) {

	// https://tc39.github.io/proposal-setmap-offrom/#sec-weakset.of
	__webpack_require__(346)('WeakSet');


/***/ },
/* 2122 */
/***/ function(module, exports, __webpack_require__) {

	var $iterators = __webpack_require__(486);
	var getKeys = __webpack_require__(201);
	var redefine = __webpack_require__(98);
	var global = __webpack_require__(42);
	var hide = __webpack_require__(97);
	var Iterators = __webpack_require__(241);
	var wks = __webpack_require__(58);
	var ITERATOR = wks('iterator');
	var TO_STRING_TAG = wks('toStringTag');
	var ArrayValues = Iterators.Array;
	
	var DOMIterables = {
	  CSSRuleList: true, // TODO: Not spec compliant, should be false.
	  CSSStyleDeclaration: false,
	  CSSValueList: false,
	  ClientRectList: false,
	  DOMRectList: false,
	  DOMStringList: false,
	  DOMTokenList: true,
	  DataTransferItemList: false,
	  FileList: false,
	  HTMLAllCollection: false,
	  HTMLCollection: false,
	  HTMLFormElement: false,
	  HTMLSelectElement: false,
	  MediaList: true, // TODO: Not spec compliant, should be false.
	  MimeTypeArray: false,
	  NamedNodeMap: false,
	  NodeList: true,
	  PaintRequestList: false,
	  Plugin: false,
	  PluginArray: false,
	  SVGLengthList: false,
	  SVGNumberList: false,
	  SVGPathSegList: false,
	  SVGPointList: false,
	  SVGStringList: false,
	  SVGTransformList: false,
	  SourceBufferList: false,
	  StyleSheetList: true, // TODO: Not spec compliant, should be false.
	  TextTrackCueList: false,
	  TextTrackList: false,
	  TouchList: false
	};
	
	for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
	  var NAME = collections[i];
	  var explicit = DOMIterables[NAME];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  var key;
	  if (proto) {
	    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	    Iterators[NAME] = ArrayValues;
	    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
	  }
	}


/***/ },
/* 2123 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(7);
	var $task = __webpack_require__(482);
	$export($export.G + $export.B, {
	  setImmediate: $task.set,
	  clearImmediate: $task.clear
	});


/***/ },
/* 2124 */
/***/ function(module, exports, __webpack_require__) {

	// ie9- setTimeout & setInterval additional parameters fix
	var global = __webpack_require__(42);
	var $export = __webpack_require__(7);
	var userAgent = __webpack_require__(349);
	var slice = [].slice;
	var MSIE = /MSIE .\./.test(userAgent); // <- dirty ie9- check
	var wrap = function (set) {
	  return function (fn, time /* , ...args */) {
	    var boundArgs = arguments.length > 2;
	    var args = boundArgs ? slice.call(arguments, 2) : false;
	    return set(boundArgs ? function () {
	      // eslint-disable-next-line no-new-func
	      (typeof fn == 'function' ? fn : Function(fn)).apply(this, args);
	    } : fn, time);
	  };
	};
	$export($export.G + $export.B + $export.F * MSIE, {
	  setTimeout: wrap(global.setTimeout),
	  setInterval: wrap(global.setInterval)
	});


/***/ },
/* 2125 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(2053);
	__webpack_require__(1992);
	__webpack_require__(1994);
	__webpack_require__(1993);
	__webpack_require__(1996);
	__webpack_require__(1998);
	__webpack_require__(2003);
	__webpack_require__(1997);
	__webpack_require__(1995);
	__webpack_require__(2005);
	__webpack_require__(2004);
	__webpack_require__(2000);
	__webpack_require__(2001);
	__webpack_require__(1999);
	__webpack_require__(1991);
	__webpack_require__(2002);
	__webpack_require__(2006);
	__webpack_require__(2007);
	__webpack_require__(1959);
	__webpack_require__(1961);
	__webpack_require__(1960);
	__webpack_require__(2009);
	__webpack_require__(2008);
	__webpack_require__(1979);
	__webpack_require__(1989);
	__webpack_require__(1990);
	__webpack_require__(1980);
	__webpack_require__(1981);
	__webpack_require__(1982);
	__webpack_require__(1983);
	__webpack_require__(1984);
	__webpack_require__(1985);
	__webpack_require__(1986);
	__webpack_require__(1987);
	__webpack_require__(1988);
	__webpack_require__(1962);
	__webpack_require__(1963);
	__webpack_require__(1964);
	__webpack_require__(1965);
	__webpack_require__(1966);
	__webpack_require__(1967);
	__webpack_require__(1968);
	__webpack_require__(1969);
	__webpack_require__(1970);
	__webpack_require__(1971);
	__webpack_require__(1972);
	__webpack_require__(1973);
	__webpack_require__(1974);
	__webpack_require__(1975);
	__webpack_require__(1976);
	__webpack_require__(1977);
	__webpack_require__(1978);
	__webpack_require__(2040);
	__webpack_require__(2045);
	__webpack_require__(2052);
	__webpack_require__(2043);
	__webpack_require__(2035);
	__webpack_require__(2036);
	__webpack_require__(2041);
	__webpack_require__(2046);
	__webpack_require__(2048);
	__webpack_require__(2031);
	__webpack_require__(2032);
	__webpack_require__(2033);
	__webpack_require__(2034);
	__webpack_require__(2037);
	__webpack_require__(2038);
	__webpack_require__(2039);
	__webpack_require__(2042);
	__webpack_require__(2044);
	__webpack_require__(2047);
	__webpack_require__(2049);
	__webpack_require__(2050);
	__webpack_require__(2051);
	__webpack_require__(1954);
	__webpack_require__(1956);
	__webpack_require__(1955);
	__webpack_require__(1958);
	__webpack_require__(1957);
	__webpack_require__(1943);
	__webpack_require__(1941);
	__webpack_require__(1947);
	__webpack_require__(1944);
	__webpack_require__(1950);
	__webpack_require__(1952);
	__webpack_require__(1940);
	__webpack_require__(1946);
	__webpack_require__(1937);
	__webpack_require__(1951);
	__webpack_require__(1935);
	__webpack_require__(1949);
	__webpack_require__(1948);
	__webpack_require__(1942);
	__webpack_require__(1945);
	__webpack_require__(1934);
	__webpack_require__(1936);
	__webpack_require__(1939);
	__webpack_require__(1938);
	__webpack_require__(1953);
	__webpack_require__(486);
	__webpack_require__(2025);
	__webpack_require__(789);
	__webpack_require__(2030);
	__webpack_require__(790);
	__webpack_require__(2026);
	__webpack_require__(2027);
	__webpack_require__(2028);
	__webpack_require__(2029);
	__webpack_require__(2010);
	__webpack_require__(788);
	__webpack_require__(791);
	__webpack_require__(792);
	__webpack_require__(2065);
	__webpack_require__(2054);
	__webpack_require__(2055);
	__webpack_require__(2060);
	__webpack_require__(2063);
	__webpack_require__(2064);
	__webpack_require__(2058);
	__webpack_require__(2061);
	__webpack_require__(2059);
	__webpack_require__(2062);
	__webpack_require__(2056);
	__webpack_require__(2057);
	__webpack_require__(2011);
	__webpack_require__(2012);
	__webpack_require__(2013);
	__webpack_require__(2014);
	__webpack_require__(2015);
	__webpack_require__(2018);
	__webpack_require__(2016);
	__webpack_require__(2017);
	__webpack_require__(2019);
	__webpack_require__(2020);
	__webpack_require__(2021);
	__webpack_require__(2022);
	__webpack_require__(2024);
	__webpack_require__(2023);
	__webpack_require__(2068);
	__webpack_require__(2066);
	__webpack_require__(2067);
	__webpack_require__(2109);
	__webpack_require__(2112);
	__webpack_require__(2111);
	__webpack_require__(2113);
	__webpack_require__(2114);
	__webpack_require__(2110);
	__webpack_require__(2115);
	__webpack_require__(2116);
	__webpack_require__(2090);
	__webpack_require__(2093);
	__webpack_require__(2089);
	__webpack_require__(2087);
	__webpack_require__(2088);
	__webpack_require__(2091);
	__webpack_require__(2092);
	__webpack_require__(2074);
	__webpack_require__(2108);
	__webpack_require__(2073);
	__webpack_require__(2107);
	__webpack_require__(2119);
	__webpack_require__(2121);
	__webpack_require__(2072);
	__webpack_require__(2106);
	__webpack_require__(2118);
	__webpack_require__(2120);
	__webpack_require__(2071);
	__webpack_require__(2117);
	__webpack_require__(2070);
	__webpack_require__(2075);
	__webpack_require__(2076);
	__webpack_require__(2077);
	__webpack_require__(2078);
	__webpack_require__(2079);
	__webpack_require__(2081);
	__webpack_require__(2080);
	__webpack_require__(2082);
	__webpack_require__(2083);
	__webpack_require__(2084);
	__webpack_require__(2086);
	__webpack_require__(2085);
	__webpack_require__(2095);
	__webpack_require__(2096);
	__webpack_require__(2097);
	__webpack_require__(2098);
	__webpack_require__(2100);
	__webpack_require__(2099);
	__webpack_require__(2102);
	__webpack_require__(2101);
	__webpack_require__(2103);
	__webpack_require__(2104);
	__webpack_require__(2105);
	__webpack_require__(2069);
	__webpack_require__(2094);
	__webpack_require__(2124);
	__webpack_require__(2123);
	__webpack_require__(2122);
	module.exports = __webpack_require__(117);


/***/ },
/* 2126 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 2127 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * deep-diff.
	 * Licensed under the MIT License.
	 */
	;(function(root, factory) {
	  'use strict';
	  if (true) {
	    // AMD. Register as an anonymous module.
	    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return factory();
	    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  } else if (typeof exports === 'object') {
	    // Node. Does not work with strict CommonJS, but
	    // only CommonJS-like environments that support module.exports,
	    // like Node.
	    module.exports = factory();
	  } else {
	    // Browser globals (root is window)
	    root.DeepDiff = factory();
	  }
	}(this, function(undefined) {
	  'use strict';
	
	  var $scope, conflict, conflictResolution = [];
	  if (typeof global === 'object' && global) {
	    $scope = global;
	  } else if (typeof window !== 'undefined') {
	    $scope = window;
	  } else {
	    $scope = {};
	  }
	  conflict = $scope.DeepDiff;
	  if (conflict) {
	    conflictResolution.push(
	      function() {
	        if ('undefined' !== typeof conflict && $scope.DeepDiff === accumulateDiff) {
	          $scope.DeepDiff = conflict;
	          conflict = undefined;
	        }
	      });
	  }
	
	  // nodejs compatible on server side and in the browser.
	  function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor;
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  }
	
	  function Diff(kind, path) {
	    Object.defineProperty(this, 'kind', {
	      value: kind,
	      enumerable: true
	    });
	    if (path && path.length) {
	      Object.defineProperty(this, 'path', {
	        value: path,
	        enumerable: true
	      });
	    }
	  }
	
	  function DiffEdit(path, origin, value) {
	    DiffEdit.super_.call(this, 'E', path);
	    Object.defineProperty(this, 'lhs', {
	      value: origin,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffEdit, Diff);
	
	  function DiffNew(path, value) {
	    DiffNew.super_.call(this, 'N', path);
	    Object.defineProperty(this, 'rhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffNew, Diff);
	
	  function DiffDeleted(path, value) {
	    DiffDeleted.super_.call(this, 'D', path);
	    Object.defineProperty(this, 'lhs', {
	      value: value,
	      enumerable: true
	    });
	  }
	  inherits(DiffDeleted, Diff);
	
	  function DiffArray(path, index, item) {
	    DiffArray.super_.call(this, 'A', path);
	    Object.defineProperty(this, 'index', {
	      value: index,
	      enumerable: true
	    });
	    Object.defineProperty(this, 'item', {
	      value: item,
	      enumerable: true
	    });
	  }
	  inherits(DiffArray, Diff);
	
	  function arrayRemove(arr, from, to) {
	    var rest = arr.slice((to || from) + 1 || arr.length);
	    arr.length = from < 0 ? arr.length + from : from;
	    arr.push.apply(arr, rest);
	    return arr;
	  }
	
	  function realTypeOf(subject) {
	    var type = typeof subject;
	    if (type !== 'object') {
	      return type;
	    }
	
	    if (subject === Math) {
	      return 'math';
	    } else if (subject === null) {
	      return 'null';
	    } else if (Array.isArray(subject)) {
	      return 'array';
	    } else if (Object.prototype.toString.call(subject) === '[object Date]') {
	      return 'date';
	    } else if (typeof subject.toString !== 'undefined' && /^\/.*\//.test(subject.toString())) {
	      return 'regexp';
	    }
	    return 'object';
	  }
	
	  function deepDiff(lhs, rhs, changes, prefilter, path, key, stack) {
	    path = path || [];
	    var currentPath = path.slice(0);
	    if (typeof key !== 'undefined') {
	      if (prefilter) {
	        if (typeof(prefilter) === 'function' && prefilter(currentPath, key)) { return; }
	        else if (typeof(prefilter) === 'object') {
	          if (prefilter.prefilter && prefilter.prefilter(currentPath, key)) { return; }
	          if (prefilter.normalize) {
	            var alt = prefilter.normalize(currentPath, key, lhs, rhs);
	            if (alt) {
	              lhs = alt[0];
	              rhs = alt[1];
	            }
	          }
	        }
	      }
	      currentPath.push(key);
	    }
	
	    // Use string comparison for regexes
	    if (realTypeOf(lhs) === 'regexp' && realTypeOf(rhs) === 'regexp') {
	      lhs = lhs.toString();
	      rhs = rhs.toString();
	    }
	
	    var ltype = typeof lhs;
	    var rtype = typeof rhs;
	    if (ltype === 'undefined') {
	      if (rtype !== 'undefined') {
	        changes(new DiffNew(currentPath, rhs));
	      }
	    } else if (rtype === 'undefined') {
	      changes(new DiffDeleted(currentPath, lhs));
	    } else if (realTypeOf(lhs) !== realTypeOf(rhs)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (Object.prototype.toString.call(lhs) === '[object Date]' && Object.prototype.toString.call(rhs) === '[object Date]' && ((lhs - rhs) !== 0)) {
	      changes(new DiffEdit(currentPath, lhs, rhs));
	    } else if (ltype === 'object' && lhs !== null && rhs !== null) {
	      stack = stack || [];
	      if (stack.indexOf(lhs) < 0) {
	        stack.push(lhs);
	        if (Array.isArray(lhs)) {
	          var i, len = lhs.length;
	          for (i = 0; i < lhs.length; i++) {
	            if (i >= rhs.length) {
	              changes(new DiffArray(currentPath, i, new DiffDeleted(undefined, lhs[i])));
	            } else {
	              deepDiff(lhs[i], rhs[i], changes, prefilter, currentPath, i, stack);
	            }
	          }
	          while (i < rhs.length) {
	            changes(new DiffArray(currentPath, i, new DiffNew(undefined, rhs[i++])));
	          }
	        } else {
	          var akeys = Object.keys(lhs);
	          var pkeys = Object.keys(rhs);
	          akeys.forEach(function(k, i) {
	            var other = pkeys.indexOf(k);
	            if (other >= 0) {
	              deepDiff(lhs[k], rhs[k], changes, prefilter, currentPath, k, stack);
	              pkeys = arrayRemove(pkeys, other);
	            } else {
	              deepDiff(lhs[k], undefined, changes, prefilter, currentPath, k, stack);
	            }
	          });
	          pkeys.forEach(function(k) {
	            deepDiff(undefined, rhs[k], changes, prefilter, currentPath, k, stack);
	          });
	        }
	        stack.length = stack.length - 1;
	      }
	    } else if (lhs !== rhs) {
	      if (!(ltype === 'number' && isNaN(lhs) && isNaN(rhs))) {
	        changes(new DiffEdit(currentPath, lhs, rhs));
	      }
	    }
	  }
	
	  function accumulateDiff(lhs, rhs, prefilter, accum) {
	    accum = accum || [];
	    deepDiff(lhs, rhs,
	      function(diff) {
	        if (diff) {
	          accum.push(diff);
	        }
	      },
	      prefilter);
	    return (accum.length) ? accum : undefined;
	  }
	
	  function applyArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    } else {
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr = arrayRemove(arr, index);
	          break;
	        case 'E':
	        case 'N':
	          arr[index] = change.rhs;
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function applyChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i = -1,
	          last = change.path ? change.path.length - 1 : 0;
	      while (++i < last) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = (typeof change.path[i] === 'number') ? [] : {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          applyArrayChange(change.path ? it[change.path[i]] : it, change.index, change.item);
	          break;
	        case 'D':
	          delete it[change.path[i]];
	          break;
	        case 'E':
	        case 'N':
	          it[change.path[i]] = change.rhs;
	          break;
	      }
	    }
	  }
	
	  function revertArrayChange(arr, index, change) {
	    if (change.path && change.path.length) {
	      // the structure of the object at the index has changed...
	      var it = arr[index],
	          i, u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          delete it[change.path[i]];
	          break;
	      }
	    } else {
	      // the array item is different...
	      switch (change.kind) {
	        case 'A':
	          revertArrayChange(arr[index], change.index, change.item);
	          break;
	        case 'D':
	          arr[index] = change.lhs;
	          break;
	        case 'E':
	          arr[index] = change.lhs;
	          break;
	        case 'N':
	          arr = arrayRemove(arr, index);
	          break;
	      }
	    }
	    return arr;
	  }
	
	  function revertChange(target, source, change) {
	    if (target && source && change && change.kind) {
	      var it = target,
	          i, u;
	      u = change.path.length - 1;
	      for (i = 0; i < u; i++) {
	        if (typeof it[change.path[i]] === 'undefined') {
	          it[change.path[i]] = {};
	        }
	        it = it[change.path[i]];
	      }
	      switch (change.kind) {
	        case 'A':
	          // Array was modified...
	          // it will be an array...
	          revertArrayChange(it[change.path[i]], change.index, change.item);
	          break;
	        case 'D':
	          // Item was deleted...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'E':
	          // Item was edited...
	          it[change.path[i]] = change.lhs;
	          break;
	        case 'N':
	          // Item is new...
	          delete it[change.path[i]];
	          break;
	      }
	    }
	  }
	
	  function applyDiff(target, source, filter) {
	    if (target && source) {
	      var onChange = function(change) {
	        if (!filter || filter(target, source, change)) {
	          applyChange(target, source, change);
	        }
	      };
	      deepDiff(target, source, onChange);
	    }
	  }
	
	  Object.defineProperties(accumulateDiff, {
	
	    diff: {
	      value: accumulateDiff,
	      enumerable: true
	    },
	    observableDiff: {
	      value: deepDiff,
	      enumerable: true
	    },
	    applyDiff: {
	      value: applyDiff,
	      enumerable: true
	    },
	    applyChange: {
	      value: applyChange,
	      enumerable: true
	    },
	    revertChange: {
	      value: revertChange,
	      enumerable: true
	    },
	    isConflict: {
	      value: function() {
	        return 'undefined' !== typeof conflict;
	      },
	      enumerable: true
	    },
	    noConflict: {
	      value: function() {
	        if (conflictResolution) {
	          conflictResolution.forEach(function(it) {
	            it();
	          });
	          conflictResolution = null;
	        }
	        return accumulateDiff;
	      },
	      enumerable: true
	    }
	  });
	
	  return accumulateDiff;
	}));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2128 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendorPrefix;
	var jsCssMap = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  // IE did it wrong again ...
	  ms: '-ms-',
	  O: '-o-'
	};
	
	function getVendorPrefix() {
	  if (vendorPrefix !== undefined) {
	    return vendorPrefix;
	  }
	
	  vendorPrefix = '';
	  var style = document.createElement('p').style;
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      vendorPrefix = key;
	    }
	  }
	
	  return vendorPrefix;
	}
	
	function getTransitionName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "TransitionProperty") : 'transitionProperty';
	}
	
	function getTransformName() {
	  return getVendorPrefix() ? "".concat(getVendorPrefix(), "Transform") : 'transform';
	}
	function setTransitionProperty(node, value) {
	  var name = getTransitionName();
	
	  if (name) {
	    node.style[name] = value;
	
	    if (name !== 'transitionProperty') {
	      node.style.transitionProperty = value;
	    }
	  }
	}
	
	function setTransform(node, value) {
	  var name = getTransformName();
	
	  if (name) {
	    node.style[name] = value;
	
	    if (name !== 'transform') {
	      node.style.transform = value;
	    }
	  }
	}
	
	function getTransitionProperty(node) {
	  return node.style.transitionProperty || node.style[getTransitionName()];
	}
	function getTransformXY(node) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	
	  if (transform && transform !== 'none') {
	    var matrix = transform.replace(/[^0-9\-.,]/g, '').split(',');
	    return {
	      x: parseFloat(matrix[12] || matrix[4], 0),
	      y: parseFloat(matrix[13] || matrix[5], 0)
	    };
	  }
	
	  return {
	    x: 0,
	    y: 0
	  };
	}
	var matrix2d = /matrix\((.*)\)/;
	var matrix3d = /matrix3d\((.*)\)/;
	function setTransformXY(node, xy) {
	  var style = window.getComputedStyle(node, null);
	  var transform = style.getPropertyValue('transform') || style.getPropertyValue(getTransformName());
	
	  if (transform && transform !== 'none') {
	    var arr;
	    var match2d = transform.match(matrix2d);
	
	    if (match2d) {
	      match2d = match2d[1];
	      arr = match2d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[4] = xy.x;
	      arr[5] = xy.y;
	      setTransform(node, "matrix(".concat(arr.join(','), ")"));
	    } else {
	      var match3d = transform.match(matrix3d)[1];
	      arr = match3d.split(',').map(function (item) {
	        return parseFloat(item, 10);
	      });
	      arr[12] = xy.x;
	      arr[13] = xy.y;
	      setTransform(node, "matrix3d(".concat(arr.join(','), ")"));
	    }
	  } else {
	    setTransform(node, "translateX(".concat(xy.x, "px) translateY(").concat(xy.y, "px) translateZ(0)"));
	  }
	}
	
	function _typeof(obj) {
	  "@babel/helpers - typeof";
	
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	var getComputedStyleX; // https://stackoverflow.com/a/3485654/3040605
	
	function forceRelayout(elem) {
	  var originalStyle = elem.style.display;
	  elem.style.display = 'none';
	  elem.offsetHeight; // eslint-disable-line
	
	  elem.style.display = originalStyle;
	}
	
	function css(el, name, v) {
	  var value = v;
	
	  if (_typeof(name) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	
	    return undefined;
	  }
	
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value = "".concat(value, "px");
	    }
	
	    el.style[name] = value;
	    return undefined;
	  }
	
	  return getComputedStyleX(el, name);
	}
	
	function getClientPosition(elem) {
	  var box;
	  var x;
	  var y;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement; // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	
	  box = elem.getBoundingClientRect(); // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = Math.floor(box.left);
	  y = Math.floor(box.top); // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w["page".concat(top ? 'Y' : 'X', "Offset")];
	  var method = "scroll".concat(top ? 'Top' : 'Left');
	
	  if (typeof ret !== 'number') {
	    var d = w.document; // ie6,7,8 standard mode
	
	    ret = d.documentElement[method];
	
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	
	
	function isWindow(obj) {
	  // must use == for ie8
	
	  /* eslint eqeqeq:0 */
	  return obj !== null && obj !== undefined && obj == obj.window;
	}
	
	function getDocument(node) {
	  if (isWindow(node)) {
	    return node.document;
	  }
	
	  if (node.nodeType === 9) {
	    return node;
	  }
	
	  return node.ownerDocument;
	}
	
	function _getComputedStyle(elem, name, cs) {
	  var computedStyle = cs;
	  var val = '';
	  var d = getDocument(elem);
	  computedStyle = computedStyle || d.defaultView.getComputedStyle(elem, null); // https://github.com/kissyteam/kissy/issues/61
	
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp("^(".concat(RE_NUM, ")(?!px)[a-z%]+$"), 'i');
	
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name]; // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT]; // prevent flashing of content
	
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT]; // Put in the new values to get a computed value out
	
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX; // Revert the changed values
	
	    style[LEFT] = left;
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	
	  return ret === '' ? 'auto' : ret;
	}
	
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function getOffsetDirection(dir, option) {
	  if (dir === 'left') {
	    return option.useCssRight ? 'right' : dir;
	  }
	
	  return option.useCssBottom ? 'bottom' : dir;
	}
	
	function oppositeOffsetDirection(dir) {
	  if (dir === 'left') {
	    return 'right';
	  } else if (dir === 'right') {
	    return 'left';
	  } else if (dir === 'top') {
	    return 'bottom';
	  } else if (dir === 'bottom') {
	    return 'top';
	  }
	} // 设置 elem 相对 elem.ownerDocument 的坐标
	
	
	function setLeftTop(elem, offset, option) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	
	  var presetH = -999;
	  var presetV = -999;
	  var horizontalProperty = getOffsetDirection('left', option);
	  var verticalProperty = getOffsetDirection('top', option);
	  var oppositeHorizontalProperty = oppositeOffsetDirection(horizontalProperty);
	  var oppositeVerticalProperty = oppositeOffsetDirection(verticalProperty);
	
	  if (horizontalProperty !== 'left') {
	    presetH = 999;
	  }
	
	  if (verticalProperty !== 'top') {
	    presetV = 999;
	  }
	
	  var originalTransition = '';
	  var originalOffset = getOffset(elem);
	
	  if ('left' in offset || 'top' in offset) {
	    originalTransition = getTransitionProperty(elem) || '';
	    setTransitionProperty(elem, 'none');
	  }
	
	  if ('left' in offset) {
	    elem.style[oppositeHorizontalProperty] = '';
	    elem.style[horizontalProperty] = "".concat(presetH, "px");
	  }
	
	  if ('top' in offset) {
	    elem.style[oppositeVerticalProperty] = '';
	    elem.style[verticalProperty] = "".concat(presetV, "px");
	  } // force relayout
	
	
	  forceRelayout(elem);
	  var old = getOffset(elem);
	  var originalStyle = {};
	
	  for (var key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      var dir = getOffsetDirection(key, option);
	      var preset = key === 'left' ? presetH : presetV;
	      var off = originalOffset[key] - old[key];
	
	      if (dir === key) {
	        originalStyle[dir] = preset + off;
	      } else {
	        originalStyle[dir] = preset - off;
	      }
	    }
	  }
	
	  css(elem, originalStyle); // force relayout
	
	  forceRelayout(elem);
	
	  if ('left' in offset || 'top' in offset) {
	    setTransitionProperty(elem, originalTransition);
	  }
	
	  var ret = {};
	
	  for (var _key in offset) {
	    if (offset.hasOwnProperty(_key)) {
	      var _dir = getOffsetDirection(_key, option);
	
	      var _off = offset[_key] - originalOffset[_key];
	
	      if (_key === _dir) {
	        ret[_dir] = originalStyle[_dir] + _off;
	      } else {
	        ret[_dir] = originalStyle[_dir] - _off;
	      }
	    }
	  }
	
	  css(elem, ret);
	}
	
	function setTransform$1(elem, offset) {
	  var originalOffset = getOffset(elem);
	  var originalXY = getTransformXY(elem);
	  var resultXY = {
	    x: originalXY.x,
	    y: originalXY.y
	  };
	
	  if ('left' in offset) {
	    resultXY.x = originalXY.x + offset.left - originalOffset.left;
	  }
	
	  if ('top' in offset) {
	    resultXY.y = originalXY.y + offset.top - originalOffset.top;
	  }
	
	  setTransformXY(elem, resultXY);
	}
	
	function setOffset(elem, offset, option) {
	  if (option.ignoreShake) {
	    var oriOffset = getOffset(elem);
	    var oLeft = oriOffset.left.toFixed(0);
	    var oTop = oriOffset.top.toFixed(0);
	    var tLeft = offset.left.toFixed(0);
	    var tTop = offset.top.toFixed(0);
	
	    if (oLeft === tLeft && oTop === tTop) {
	      return;
	    }
	  }
	
	  if (option.useCssRight || option.useCssBottom) {
	    setLeftTop(elem, offset, option);
	  } else if (option.useCssTransform && getTransformName() in document.body.style) {
	    setTransform$1(elem, offset);
	  } else {
	    setLeftTop(elem, offset, option);
	  }
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name; // Remember the old values, and insert the new ones
	
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem); // Revert the old values
	
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop;
	  var j;
	  var i;
	
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = void 0;
	
	        if (prop === 'border') {
	          cssProp = "".concat(prop).concat(which[i], "Width");
	        } else {
	          cssProp = prop + which[i];
	        }
	
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	
	  return value;
	}
	
	var domUtils = {
	  getParent: function getParent(element) {
	    var parent = element;
	
	    do {
	      if (parent.nodeType === 11 && parent.host) {
	        parent = parent.host;
	      } else {
	        parent = parent.parentNode;
	      }
	    } while (parent && parent.nodeType !== 1 && parent.nodeType !== 9);
	
	    return parent;
	  }
	};
	each(['Width', 'Height'], function (name) {
	  domUtils["doc".concat(name)] = function (refWin) {
	    var d = refWin.document;
	    return Math.max( // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement["scroll".concat(name)], // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body["scroll".concat(name)], domUtils["viewport".concat(name)](d));
	  };
	
	  domUtils["viewport".concat(name)] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = "client".concat(name);
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop]; // 标准模式取 documentElement
	    // backcompat 取 body
	
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	
	function getWH(elem, name, ex) {
	  var extra = ex;
	
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? Math.floor(elem.getBoundingClientRect().width) : Math.floor(elem.getBoundingClientRect().height);
	  var isBorderBox = isBorderBoxFn(elem);
	  var cssBoxValue = 0;
	
	  if (borderBoxValue === null || borderBoxValue === undefined || borderBoxValue <= 0) {
	    borderBoxValue = undefined; // Fall back to computed then un computed css if necessary
	
	    cssBoxValue = getComputedStyleX(elem, name);
	
	    if (cssBoxValue === null || cssBoxValue === undefined || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    } // Normalize '', auto, and prepare for extra
	
	
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which);
	    }
	
	    return cssBoxValue;
	  } else if (borderBoxValueOrIsBorderBox) {
	    if (extra === BORDER_INDEX) {
	      return val;
	    }
	
	    return val + (extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which) : getPBMWidth(elem, ['margin'], which));
	  }
	
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	}; // fix #119 : https://github.com/kissyteam/kissy/issues/119
	
	function getWHIgnoreDisplay() {
	  for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
	    args[_key2] = arguments[_key2];
	  }
	
	  var val;
	  var elem = args[0]; // in case elem is window
	  // elem.offsetWidth === undefined
	
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	
	  return val;
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	
	  domUtils["outer".concat(first)] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, v) {
	    var val = v;
	
	    if (val !== undefined) {
	      if (elem) {
	        var isBorderBox = isBorderBoxFn(elem);
	
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which);
	        }
	
	        return css(elem, name, val);
	      }
	
	      return undefined;
	    }
	
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	function mix(to, from) {
	  for (var i in from) {
	    if (from.hasOwnProperty(i)) {
	      to[i] = from[i];
	    }
	  }
	
	  return to;
	}
	
	var utils = {
	  getWindow: function getWindow(node) {
	    if (node && node.document && node.setTimeout) {
	      return node;
	    }
	
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  getDocument: getDocument,
	  offset: function offset(el, value, option) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value, option || {});
	    } else {
	      return getOffset(el);
	    }
	  },
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var i;
	    var ret = {};
	
	    for (i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	
	    var overflow = obj.overflow;
	
	    if (overflow) {
	      for (i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	
	    return ret;
	  },
	  mix: mix,
	  getWindowScrollLeft: function getWindowScrollLeft(w) {
	    return getScrollLeft(w);
	  },
	  getWindowScrollTop: function getWindowScrollTop(w) {
	    return getScrollTop(w);
	  },
	  merge: function merge() {
	    var ret = {};
	
	    for (var i = 0; i < arguments.length; i++) {
	      utils.mix(ret, i < 0 || arguments.length <= i ? undefined : arguments[i]);
	    }
	
	    return ret;
	  },
	  viewportWidth: 0,
	  viewportHeight: 0
	};
	mix(utils, domUtils);
	
	/**
	 * 得到会导致元素显示不全的祖先元素
	 */
	
	var getParent = utils.getParent;
	
	function getOffsetParent(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return null;
	  } // ie 这个也不是完全可行
	
	  /*
	   <div style="width: 50px;height: 100px;overflow: hidden">
	   <div style="width: 50px;height: 100px;position: relative;" id="d6">
	   元素 6 高 100px 宽 50px<br/>
	   </div>
	   </div>
	   */
	  // element.offsetParent does the right thing in ie7 and below. Return parent with layout!
	  //  In other browsers it only includes elements with position absolute, relative or
	  // fixed, not elements with overflow set to auto or scroll.
	  //        if (UA.ie && ieMode < 8) {
	  //            return element.offsetParent;
	  //        }
	  // 统一的 offsetParent 方法
	
	
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent;
	  var positionStyle = utils.css(element, 'position');
	  var skipStatic = positionStyle === 'fixed' || positionStyle === 'absolute';
	
	  if (!skipStatic) {
	    return element.nodeName.toLowerCase() === 'html' ? null : getParent(element);
	  }
	
	  for (parent = getParent(element); parent && parent !== body && parent.nodeType !== 9; parent = getParent(parent)) {
	    positionStyle = utils.css(parent, 'position');
	
	    if (positionStyle !== 'static') {
	      return parent;
	    }
	  }
	
	  return null;
	}
	
	var getParent$1 = utils.getParent;
	function isAncestorFixed(element) {
	  if (utils.isWindow(element) || element.nodeType === 9) {
	    return false;
	  }
	
	  var doc = utils.getDocument(element);
	  var body = doc.body;
	  var parent = null;
	
	  for (parent = getParent$1(element); // 修复元素位于 document.documentElement 下导致崩溃问题
	  parent && parent !== body && parent !== doc; parent = getParent$1(parent)) {
	    var positionStyle = utils.css(parent, 'position');
	
	    if (positionStyle === 'fixed') {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * 获得元素的显示部分的区域
	 */
	
	function getVisibleRectForElement(element, alwaysByViewport) {
	  var visibleRect = {
	    left: 0,
	    right: Infinity,
	    top: 0,
	    bottom: Infinity
	  };
	  var el = getOffsetParent(element);
	  var doc = utils.getDocument(element);
	  var win = doc.defaultView || doc.parentWindow;
	  var body = doc.body;
	  var documentElement = doc.documentElement; // Determine the size of the visible rect by climbing the dom accounting for
	  // all scrollable containers.
	
	  while (el) {
	    // clientWidth is zero for inline block elements in ie.
	    if ((navigator.userAgent.indexOf('MSIE') === -1 || el.clientWidth !== 0) && // body may have overflow set on it, yet we still get the entire
	    // viewport. In some browsers, el.offsetParent may be
	    // document.documentElement, so check for that too.
	    el !== body && el !== documentElement && utils.css(el, 'overflow') !== 'visible') {
	      var pos = utils.offset(el); // add border
	
	      pos.left += el.clientLeft;
	      pos.top += el.clientTop;
	      visibleRect.top = Math.max(visibleRect.top, pos.top);
	      visibleRect.right = Math.min(visibleRect.right, // consider area without scrollBar
	      pos.left + el.clientWidth);
	      visibleRect.bottom = Math.min(visibleRect.bottom, pos.top + el.clientHeight);
	      visibleRect.left = Math.max(visibleRect.left, pos.left);
	    } else if (el === body || el === documentElement) {
	      break;
	    }
	
	    el = getOffsetParent(el);
	  } // Set element position to fixed
	  // make sure absolute element itself don't affect it's visible area
	  // https://github.com/ant-design/ant-design/issues/7601
	
	
	  var originalPosition = null;
	
	  if (!utils.isWindow(element) && element.nodeType !== 9) {
	    originalPosition = element.style.position;
	    var position = utils.css(element, 'position');
	
	    if (position === 'absolute') {
	      element.style.position = 'fixed';
	    }
	  }
	
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	  var documentWidth = documentElement.scrollWidth;
	  var documentHeight = documentElement.scrollHeight; // scrollXXX on html is sync with body which means overflow: hidden on body gets wrong scrollXXX.
	  // We should cut this ourself.
	
	  var bodyStyle = window.getComputedStyle(body);
	
	  if (bodyStyle.overflowX === 'hidden') {
	    documentWidth = win.innerWidth;
	  }
	
	  if (bodyStyle.overflowY === 'hidden') {
	    documentHeight = win.innerHeight;
	  } // Reset element position after calculate the visible area
	
	
	  if (element.style) {
	    element.style.position = originalPosition;
	  }
	
	  if (alwaysByViewport || isAncestorFixed(element)) {
	    // Clip by viewport's size.
	    visibleRect.left = Math.max(visibleRect.left, scrollX);
	    visibleRect.top = Math.max(visibleRect.top, scrollY);
	    visibleRect.right = Math.min(visibleRect.right, scrollX + viewportWidth);
	    visibleRect.bottom = Math.min(visibleRect.bottom, scrollY + viewportHeight);
	  } else {
	    // Clip by document's size.
	    var maxVisibleWidth = Math.max(documentWidth, scrollX + viewportWidth);
	    visibleRect.right = Math.min(visibleRect.right, maxVisibleWidth);
	    var maxVisibleHeight = Math.max(documentHeight, scrollY + viewportHeight);
	    visibleRect.bottom = Math.min(visibleRect.bottom, maxVisibleHeight);
	  }
	
	  return visibleRect.top >= 0 && visibleRect.left >= 0 && visibleRect.bottom > visibleRect.top && visibleRect.right > visibleRect.left ? visibleRect : null;
	}
	
	function adjustForViewport(elFuturePos, elRegion, visibleRect, overflow) {
	  var pos = utils.clone(elFuturePos);
	  var size = {
	    width: elRegion.width,
	    height: elRegion.height
	  };
	
	  if (overflow.adjustX && pos.left < visibleRect.left) {
	    pos.left = visibleRect.left;
	  } // Left edge inside and right edge outside viewport, try to resize it.
	
	
	  if (overflow.resizeWidth && pos.left >= visibleRect.left && pos.left + size.width > visibleRect.right) {
	    size.width -= pos.left + size.width - visibleRect.right;
	  } // Right edge outside viewport, try to move it.
	
	
	  if (overflow.adjustX && pos.left + size.width > visibleRect.right) {
	    // 保证左边界和可视区域左边界对齐
	    pos.left = Math.max(visibleRect.right - size.width, visibleRect.left);
	  } // Top edge outside viewport, try to move it.
	
	
	  if (overflow.adjustY && pos.top < visibleRect.top) {
	    pos.top = visibleRect.top;
	  } // Top edge inside and bottom edge outside viewport, try to resize it.
	
	
	  if (overflow.resizeHeight && pos.top >= visibleRect.top && pos.top + size.height > visibleRect.bottom) {
	    size.height -= pos.top + size.height - visibleRect.bottom;
	  } // Bottom edge outside viewport, try to move it.
	
	
	  if (overflow.adjustY && pos.top + size.height > visibleRect.bottom) {
	    // 保证上边界和可视区域上边界对齐
	    pos.top = Math.max(visibleRect.bottom - size.height, visibleRect.top);
	  }
	
	  return utils.mix(pos, size);
	}
	
	function getRegion(node) {
	  var offset;
	  var w;
	  var h;
	
	  if (!utils.isWindow(node) && node.nodeType !== 9) {
	    offset = utils.offset(node);
	    w = utils.outerWidth(node);
	    h = utils.outerHeight(node);
	  } else {
	    var win = utils.getWindow(node);
	    offset = {
	      left: utils.getWindowScrollLeft(win),
	      top: utils.getWindowScrollTop(win)
	    };
	    w = utils.viewportWidth(win);
	    h = utils.viewportHeight(win);
	  }
	
	  offset.width = w;
	  offset.height = h;
	  return offset;
	}
	
	/**
	 * 获取 node 上的 align 对齐点 相对于页面的坐标
	 */
	function getAlignOffset(region, align) {
	  var V = align.charAt(0);
	  var H = align.charAt(1);
	  var w = region.width;
	  var h = region.height;
	  var x = region.left;
	  var y = region.top;
	
	  if (V === 'c') {
	    y += h / 2;
	  } else if (V === 'b') {
	    y += h;
	  }
	
	  if (H === 'c') {
	    x += w / 2;
	  } else if (H === 'r') {
	    x += w;
	  }
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getElFuturePos(elRegion, refNodeRegion, points, offset, targetOffset) {
	  var p1 = getAlignOffset(refNodeRegion, points[1]);
	  var p2 = getAlignOffset(elRegion, points[0]);
	  var diff = [p2.left - p1.left, p2.top - p1.top];
	  return {
	    left: Math.round(elRegion.left - diff[0] + offset[0] - targetOffset[0]),
	    top: Math.round(elRegion.top - diff[1] + offset[1] - targetOffset[1])
	  };
	}
	
	/**
	 * align dom node flexibly
	 * @author yiminghe@gmail.com
	 */
	
	function isFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left < visibleRect.left || elFuturePos.left + elRegion.width > visibleRect.right;
	}
	
	function isFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top < visibleRect.top || elFuturePos.top + elRegion.height > visibleRect.bottom;
	}
	
	function isCompleteFailX(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.left > visibleRect.right || elFuturePos.left + elRegion.width < visibleRect.left;
	}
	
	function isCompleteFailY(elFuturePos, elRegion, visibleRect) {
	  return elFuturePos.top > visibleRect.bottom || elFuturePos.top + elRegion.height < visibleRect.top;
	}
	
	function flip(points, reg, map) {
	  var ret = [];
	  utils.each(points, function (p) {
	    ret.push(p.replace(reg, function (m) {
	      return map[m];
	    }));
	  });
	  return ret;
	}
	
	function flipOffset(offset, index) {
	  offset[index] = -offset[index];
	  return offset;
	}
	
	function convertOffset(str, offsetLen) {
	  var n;
	
	  if (/%$/.test(str)) {
	    n = parseInt(str.substring(0, str.length - 1), 10) / 100 * offsetLen;
	  } else {
	    n = parseInt(str, 10);
	  }
	
	  return n || 0;
	}
	
	function normalizeOffset(offset, el) {
	  offset[0] = convertOffset(offset[0], el.width);
	  offset[1] = convertOffset(offset[1], el.height);
	}
	/**
	 * @param el
	 * @param tgtRegion 参照节点所占的区域: { left, top, width, height }
	 * @param align
	 */
	
	
	function doAlign(el, tgtRegion, align, isTgtRegionVisible) {
	  var points = align.points;
	  var offset = align.offset || [0, 0];
	  var targetOffset = align.targetOffset || [0, 0];
	  var overflow = align.overflow;
	  var source = align.source || el;
	  offset = [].concat(offset);
	  targetOffset = [].concat(targetOffset);
	  overflow = overflow || {};
	  var newOverflowCfg = {};
	  var fail = 0;
	  var alwaysByViewport = !!(overflow && overflow.alwaysByViewport); // 当前节点可以被放置的显示区域
	
	  var visibleRect = getVisibleRectForElement(source, alwaysByViewport); // 当前节点所占的区域, left/top/width/height
	
	  var elRegion = getRegion(source); // 将 offset 转换成数值，支持百分比
	
	  normalizeOffset(offset, elRegion);
	  normalizeOffset(targetOffset, tgtRegion); // 当前节点将要被放置的位置
	
	  var elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset); // 当前节点将要所处的区域
	
	  var newElRegion = utils.merge(elRegion, elFuturePos); // 如果可视区域不能完全放置当前节点时允许调整
	
	  if (visibleRect && (overflow.adjustX || overflow.adjustY) && isTgtRegionVisible) {
	    if (overflow.adjustX) {
	      // 如果横向不能放下
	      if (isFailX(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var newPoints = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        }); // 偏移量也反下
	
	        var newOffset = flipOffset(offset, 0);
	        var newTargetOffset = flipOffset(targetOffset, 0);
	        var newElFuturePos = getElFuturePos(elRegion, tgtRegion, newPoints, newOffset, newTargetOffset);
	
	        if (!isCompleteFailX(newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = newPoints;
	          offset = newOffset;
	          targetOffset = newTargetOffset;
	        }
	      }
	    }
	
	    if (overflow.adjustY) {
	      // 如果纵向不能放下
	      if (isFailY(elFuturePos, elRegion, visibleRect)) {
	        // 对齐位置反下
	        var _newPoints = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        }); // 偏移量也反下
	
	
	        var _newOffset = flipOffset(offset, 1);
	
	        var _newTargetOffset = flipOffset(targetOffset, 1);
	
	        var _newElFuturePos = getElFuturePos(elRegion, tgtRegion, _newPoints, _newOffset, _newTargetOffset);
	
	        if (!isCompleteFailY(_newElFuturePos, elRegion, visibleRect)) {
	          fail = 1;
	          points = _newPoints;
	          offset = _newOffset;
	          targetOffset = _newTargetOffset;
	        }
	      }
	    } // 如果失败，重新计算当前节点将要被放置的位置
	
	
	    if (fail) {
	      elFuturePos = getElFuturePos(elRegion, tgtRegion, points, offset, targetOffset);
	      utils.mix(newElRegion, elFuturePos);
	    }
	
	    var isStillFailX = isFailX(elFuturePos, elRegion, visibleRect);
	    var isStillFailY = isFailY(elFuturePos, elRegion, visibleRect); // 检查反下后的位置是否可以放下了，如果仍然放不下：
	    // 1. 复原修改过的定位参数
	
	    if (isStillFailX || isStillFailY) {
	      var _newPoints2 = points; // 重置对应部分的翻转逻辑
	
	      if (isStillFailX) {
	        _newPoints2 = flip(points, /[lr]/gi, {
	          l: 'r',
	          r: 'l'
	        });
	      }
	
	      if (isStillFailY) {
	        _newPoints2 = flip(points, /[tb]/gi, {
	          t: 'b',
	          b: 't'
	        });
	      }
	
	      points = _newPoints2;
	      offset = align.offset || [0, 0];
	      targetOffset = align.targetOffset || [0, 0];
	    } // 2. 只有指定了可以调整当前方向才调整
	
	
	    newOverflowCfg.adjustX = overflow.adjustX && isStillFailX;
	    newOverflowCfg.adjustY = overflow.adjustY && isStillFailY; // 确实要调整，甚至可能会调整高度宽度
	
	    if (newOverflowCfg.adjustX || newOverflowCfg.adjustY) {
	      newElRegion = adjustForViewport(elFuturePos, elRegion, visibleRect, newOverflowCfg);
	    }
	  } // need judge to in case set fixed with in css on height auto element
	
	
	  if (newElRegion.width !== elRegion.width) {
	    utils.css(source, 'width', utils.width(source) + newElRegion.width - elRegion.width);
	  }
	
	  if (newElRegion.height !== elRegion.height) {
	    utils.css(source, 'height', utils.height(source) + newElRegion.height - elRegion.height);
	  } // https://github.com/kissyteam/kissy/issues/190
	  // 相对于屏幕位置没变，而 left/top 变了
	  // 例如 <div 'relative'><el absolute></div>
	
	
	  utils.offset(source, {
	    left: newElRegion.left,
	    top: newElRegion.top
	  }, {
	    useCssRight: align.useCssRight,
	    useCssBottom: align.useCssBottom,
	    useCssTransform: align.useCssTransform,
	    ignoreShake: align.ignoreShake
	  });
	  return {
	    points: points,
	    offset: offset,
	    targetOffset: targetOffset,
	    overflow: newOverflowCfg
	  };
	}
	/**
	 *  2012-04-26 yiminghe@gmail.com
	 *   - 优化智能对齐算法
	 *   - 慎用 resizeXX
	 *
	 *  2011-07-13 yiminghe@gmail.com note:
	 *   - 增加智能对齐，以及大小调整选项
	 **/
	
	function isOutOfVisibleRect(target, alwaysByViewport) {
	  var visibleRect = getVisibleRectForElement(target, alwaysByViewport);
	  var targetRegion = getRegion(target);
	  return !visibleRect || targetRegion.left + targetRegion.width <= visibleRect.left || targetRegion.top + targetRegion.height <= visibleRect.top || targetRegion.left >= visibleRect.right || targetRegion.top >= visibleRect.bottom;
	}
	
	function alignElement(el, refNode, align) {
	  var target = align.target || refNode;
	  var refNodeRegion = getRegion(target);
	  var isTargetNotOutOfVisible = !isOutOfVisibleRect(target, align.overflow && align.overflow.alwaysByViewport);
	  return doAlign(el, refNodeRegion, align, isTargetNotOutOfVisible);
	}
	
	alignElement.__getOffsetParent = getOffsetParent;
	alignElement.__getVisibleRectForElement = getVisibleRectForElement;
	
	function ownKeys(object, enumerableOnly) {
	  var keys = Object.keys(object);
	
	  if (Object.getOwnPropertySymbols) {
	    var symbols = Object.getOwnPropertySymbols(object);
	
	    if (enumerableOnly) {
	      symbols = symbols.filter(function (sym) {
	        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
	      });
	    }
	
	    keys.push.apply(keys, symbols);
	  }
	
	  return keys;
	}
	
	function _objectSpread(target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i] != null ? arguments[i] : {};
	
	    if (i % 2) {
	      ownKeys(Object(source), true).forEach(function (key) {
	        _defineProperty(target, key, source[key]);
	      });
	    } else if (Object.getOwnPropertyDescriptors) {
	      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
	    } else {
	      ownKeys(Object(source)).forEach(function (key) {
	        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
	      });
	    }
	  }
	
	  return target;
	}
	
	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	/**
	 * `tgtPoint`: { pageX, pageY } or { clientX, clientY }.
	 * If client position provided, will internal convert to page position.
	 */
	
	function alignPoint(el, tgtPoint, align) {
	  var pageX;
	  var pageY;
	  var doc = utils.getDocument(el);
	  var win = doc.defaultView || doc.parentWindow;
	  var scrollX = utils.getWindowScrollLeft(win);
	  var scrollY = utils.getWindowScrollTop(win);
	  var viewportWidth = utils.viewportWidth(win);
	  var viewportHeight = utils.viewportHeight(win);
	
	  if ('pageX' in tgtPoint) {
	    pageX = tgtPoint.pageX;
	  } else {
	    pageX = scrollX + tgtPoint.clientX;
	  }
	
	  if ('pageY' in tgtPoint) {
	    pageY = tgtPoint.pageY;
	  } else {
	    pageY = scrollY + tgtPoint.clientY;
	  }
	
	  var tgtRegion = {
	    left: pageX,
	    top: pageY,
	    width: 0,
	    height: 0
	  };
	  var pointInView = pageX >= 0 && pageX <= scrollX + viewportWidth && pageY >= 0 && pageY <= scrollY + viewportHeight; // Provide default target point
	
	  var points = [align.points[0], 'cc'];
	  return doAlign(el, tgtRegion, _objectSpread(_objectSpread({}, align), {}, {
	    points: points
	  }), pointInView);
	}
	
	exports.alignElement = alignElement;
	exports.alignPoint = alignPoint;
	exports.default = alignElement;
	//# sourceMappingURL=index.js.map


/***/ },
/* 2129 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var matches = __webpack_require__(2130);
	
	/**
	 * @param element {Element}
	 * @param selector {String}
	 * @param context {Element}
	 * @return {Element}
	 */
	module.exports = function (element, selector, context) {
	  context = context || document;
	  // guard against orphans
	  element = { parentNode: element };
	
	  while ((element = element.parentNode) && element !== context) {
	    if (matches(element, selector)) {
	      return element;
	    }
	  }
	};


/***/ },
/* 2130 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Determine if a DOM element matches a CSS selector
	 *
	 * @param {Element} elem
	 * @param {String} selector
	 * @return {Boolean}
	 * @api public
	 */
	
	function matches(elem, selector) {
	  // Vendor-specific implementations of `Element.prototype.matches()`.
	  var proto = window.Element.prototype;
	  var nativeMatches = proto.matches ||
	      proto.mozMatchesSelector ||
	      proto.msMatchesSelector ||
	      proto.oMatchesSelector ||
	      proto.webkitMatchesSelector;
	
	  if (!elem || elem.nodeType !== 1) {
	    return false;
	  }
	
	  var parentElem = elem.parentNode;
	
	  // use native 'matches'
	  if (nativeMatches) {
	    return nativeMatches.call(elem, selector);
	  }
	
	  // native support for `matches` is missing and a fallback is required
	  var nodes = parentElem.querySelectorAll(selector);
	  var len = nodes.length;
	
	  for (var i = 0; i < len; i++) {
	    if (nodes[i] === elem) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Expose `matches`
	 */
	
	module.exports = matches;


/***/ },
/* 2131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var util = __webpack_require__(2132);
	
	function scrollIntoView(elem, container, config) {
	  config = config || {};
	  // document 归一化到 window
	  if (container.nodeType === 9) {
	    container = util.getWindow(container);
	  }
	
	  var allowHorizontalScroll = config.allowHorizontalScroll;
	  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
	  var alignWithTop = config.alignWithTop;
	  var alignWithLeft = config.alignWithLeft;
	  var offsetTop = config.offsetTop || 0;
	  var offsetLeft = config.offsetLeft || 0;
	  var offsetBottom = config.offsetBottom || 0;
	  var offsetRight = config.offsetRight || 0;
	
	  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;
	
	  var isWin = util.isWindow(container);
	  var elemOffset = util.offset(elem);
	  var eh = util.outerHeight(elem);
	  var ew = util.outerWidth(elem);
	  var containerOffset = undefined;
	  var ch = undefined;
	  var cw = undefined;
	  var containerScroll = undefined;
	  var diffTop = undefined;
	  var diffBottom = undefined;
	  var win = undefined;
	  var winScroll = undefined;
	  var ww = undefined;
	  var wh = undefined;
	
	  if (isWin) {
	    win = container;
	    wh = util.height(win);
	    ww = util.width(win);
	    winScroll = {
	      left: util.scrollLeft(win),
	      top: util.scrollTop(win)
	    };
	    // elem 相对 container 可视视窗的距离
	    diffTop = {
	      left: elemOffset.left - winScroll.left - offsetLeft,
	      top: elemOffset.top - winScroll.top - offsetTop
	    };
	    diffBottom = {
	      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
	      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
	    };
	    containerScroll = winScroll;
	  } else {
	    containerOffset = util.offset(container);
	    ch = container.clientHeight;
	    cw = container.clientWidth;
	    containerScroll = {
	      left: container.scrollLeft,
	      top: container.scrollTop
	    };
	    // elem 相对 container 可视视窗的距离
	    // 注意边框, offset 是边框到根节点
	    diffTop = {
	      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
	      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
	    };
	    diffBottom = {
	      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
	      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
	    };
	  }
	
	  if (diffTop.top < 0 || diffBottom.top > 0) {
	    // 强制向上
	    if (alignWithTop === true) {
	      util.scrollTop(container, containerScroll.top + diffTop.top);
	    } else if (alignWithTop === false) {
	      util.scrollTop(container, containerScroll.top + diffBottom.top);
	    } else {
	      // 自动调整
	      if (diffTop.top < 0) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  } else {
	    if (!onlyScrollIfNeeded) {
	      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
	      if (alignWithTop) {
	        util.scrollTop(container, containerScroll.top + diffTop.top);
	      } else {
	        util.scrollTop(container, containerScroll.top + diffBottom.top);
	      }
	    }
	  }
	
	  if (allowHorizontalScroll) {
	    if (diffTop.left < 0 || diffBottom.left > 0) {
	      // 强制向上
	      if (alignWithLeft === true) {
	        util.scrollLeft(container, containerScroll.left + diffTop.left);
	      } else if (alignWithLeft === false) {
	        util.scrollLeft(container, containerScroll.left + diffBottom.left);
	      } else {
	        // 自动调整
	        if (diffTop.left < 0) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    } else {
	      if (!onlyScrollIfNeeded) {
	        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
	        if (alignWithLeft) {
	          util.scrollLeft(container, containerScroll.left + diffTop.left);
	        } else {
	          util.scrollLeft(container, containerScroll.left + diffBottom.left);
	        }
	      }
	    }
	  }
	}
	
	module.exports = scrollIntoView;

/***/ },
/* 2132 */
/***/ function(module, exports) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };
	
	var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;
	
	function getClientPosition(elem) {
	  var box = undefined;
	  var x = undefined;
	  var y = undefined;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
	  box = elem.getBoundingClientRect();
	
	  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
	  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
	  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin
	
	  x = box.left;
	  y = box.top;
	
	  // In IE, most of the time, 2 extra pixels are added to the top and left
	  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
	  // IE6 standards mode, this border can be overridden by setting the
	  // document element's border to zero -- thus, we cannot rely on the
	  // offset always being 2 pixels.
	
	  // In quirks mode, the offset can be determined by querying the body's
	  // clientLeft/clientTop, but in standards mode, it is found by querying
	  // the document element's clientLeft/clientTop.  Since we already called
	  // getClientBoundingRect we have already forced a reflow, so it is not
	  // too expensive just to query them all.
	
	  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
	  // 窗口边框标准是设 documentElement ,quirks 时设置 body
	  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
	  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
	  // 标准 ie 下 docElem.clientTop 就是 border-top
	  // ie7 html 即窗口边框改变不了。永远为 2
	  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0
	
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getScroll(w, top) {
	  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	  var method = 'scroll' + (top ? 'Top' : 'Left');
	  if (typeof ret !== 'number') {
	    var d = w.document;
	    // ie6,7,8 standard mode
	    ret = d.documentElement[method];
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	  return ret;
	}
	
	function getScrollLeft(w) {
	  return getScroll(w);
	}
	
	function getScrollTop(w) {
	  return getScroll(w, true);
	}
	
	function getOffset(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScrollLeft(w);
	  pos.top += getScrollTop(w);
	  return pos;
	}
	function _getComputedStyle(elem, name, computedStyle_) {
	  var val = '';
	  var d = elem.ownerDocument;
	  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);
	
	  // https://github.com/kissyteam/kissy/issues/61
	  if (computedStyle) {
	    val = computedStyle.getPropertyValue(name) || computedStyle[name];
	  }
	
	  return val;
	}
	
	var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
	var RE_POS = /^(top|right|bottom|left)$/;
	var CURRENT_STYLE = 'currentStyle';
	var RUNTIME_STYLE = 'runtimeStyle';
	var LEFT = 'left';
	var PX = 'px';
	
	function _getComputedStyleIE(elem, name) {
	  // currentStyle maybe null
	  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
	  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];
	
	  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
	  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
	  // 在 ie 下不对，需要直接用 offset 方式
	  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了
	
	  // From the awesome hack by Dean Edwards
	  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
	  // If we're not dealing with a regular pixel number
	  // but a number that has a weird ending, we need to convert it to pixels
	  // exclude left right for relativity
	  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
	    // Remember the original values
	    var style = elem.style;
	    var left = style[LEFT];
	    var rsLeft = elem[RUNTIME_STYLE][LEFT];
	
	    // prevent flashing of content
	    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];
	
	    // Put in the new values to get a computed value out
	    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
	    ret = style.pixelLeft + PX;
	
	    // Revert the changed values
	    style[LEFT] = left;
	
	    elem[RUNTIME_STYLE][LEFT] = rsLeft;
	  }
	  return ret === '' ? 'auto' : ret;
	}
	
	var getComputedStyleX = undefined;
	if (typeof window !== 'undefined') {
	  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
	}
	
	function each(arr, fn) {
	  for (var i = 0; i < arr.length; i++) {
	    fn(arr[i]);
	  }
	}
	
	function isBorderBoxFn(elem) {
	  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
	}
	
	var BOX_MODELS = ['margin', 'border', 'padding'];
	var CONTENT_INDEX = -1;
	var PADDING_INDEX = 2;
	var BORDER_INDEX = 1;
	var MARGIN_INDEX = 0;
	
	function swap(elem, options, callback) {
	  var old = {};
	  var style = elem.style;
	  var name = undefined;
	
	  // Remember the old values, and insert the new ones
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      old[name] = style[name];
	      style[name] = options[name];
	    }
	  }
	
	  callback.call(elem);
	
	  // Revert the old values
	  for (name in options) {
	    if (options.hasOwnProperty(name)) {
	      style[name] = old[name];
	    }
	  }
	}
	
	function getPBMWidth(elem, props, which) {
	  var value = 0;
	  var prop = undefined;
	  var j = undefined;
	  var i = undefined;
	  for (j = 0; j < props.length; j++) {
	    prop = props[j];
	    if (prop) {
	      for (i = 0; i < which.length; i++) {
	        var cssProp = undefined;
	        if (prop === 'border') {
	          cssProp = prop + which[i] + 'Width';
	        } else {
	          cssProp = prop + which[i];
	        }
	        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
	      }
	    }
	  }
	  return value;
	}
	
	/**
	 * A crude way of determining if an object is a window
	 * @member util
	 */
	function isWindow(obj) {
	  // must use == for ie8
	  /* eslint eqeqeq:0 */
	  return obj != null && obj == obj.window;
	}
	
	var domUtils = {};
	
	each(['Width', 'Height'], function (name) {
	  domUtils['doc' + name] = function (refWin) {
	    var d = refWin.document;
	    return Math.max(
	    // firefox chrome documentElement.scrollHeight< body.scrollHeight
	    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
	    d.documentElement['scroll' + name],
	    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
	    d.body['scroll' + name], domUtils['viewport' + name](d));
	  };
	
	  domUtils['viewport' + name] = function (win) {
	    // pc browser includes scrollbar in window.innerWidth
	    var prop = 'client' + name;
	    var doc = win.document;
	    var body = doc.body;
	    var documentElement = doc.documentElement;
	    var documentElementProp = documentElement[prop];
	    // 标准模式取 documentElement
	    // backcompat 取 body
	    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
	  };
	});
	
	/*
	 得到元素的大小信息
	 @param elem
	 @param name
	 @param {String} [extra]  'padding' : (css width) + padding
	 'border' : (css width) + padding + border
	 'margin' : (css width) + padding + border + margin
	 */
	function getWH(elem, name, extra) {
	  if (isWindow(elem)) {
	    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
	  } else if (elem.nodeType === 9) {
	    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
	  }
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
	  var computedStyle = getComputedStyleX(elem);
	  var isBorderBox = isBorderBoxFn(elem, computedStyle);
	  var cssBoxValue = 0;
	  if (borderBoxValue == null || borderBoxValue <= 0) {
	    borderBoxValue = undefined;
	    // Fall back to computed then un computed css if necessary
	    cssBoxValue = getComputedStyleX(elem, name);
	    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
	      cssBoxValue = elem.style[name] || 0;
	    }
	    // Normalize '', auto, and prepare for extra
	    cssBoxValue = parseFloat(cssBoxValue) || 0;
	  }
	  if (extra === undefined) {
	    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
	  }
	  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
	  var val = borderBoxValue || cssBoxValue;
	  if (extra === CONTENT_INDEX) {
	    if (borderBoxValueOrIsBorderBox) {
	      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
	    }
	    return cssBoxValue;
	  }
	  if (borderBoxValueOrIsBorderBox) {
	    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
	    return val + (extra === BORDER_INDEX ? 0 : padding);
	  }
	  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
	}
	
	var cssShow = {
	  position: 'absolute',
	  visibility: 'hidden',
	  display: 'block'
	};
	
	// fix #119 : https://github.com/kissyteam/kissy/issues/119
	function getWHIgnoreDisplay(elem) {
	  var val = undefined;
	  var args = arguments;
	  // in case elem is window
	  // elem.offsetWidth === undefined
	  if (elem.offsetWidth !== 0) {
	    val = getWH.apply(undefined, args);
	  } else {
	    swap(elem, cssShow, function () {
	      val = getWH.apply(undefined, args);
	    });
	  }
	  return val;
	}
	
	function css(el, name, v) {
	  var value = v;
	  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	    for (var i in name) {
	      if (name.hasOwnProperty(i)) {
	        css(el, i, name[i]);
	      }
	    }
	    return undefined;
	  }
	  if (typeof value !== 'undefined') {
	    if (typeof value === 'number') {
	      value += 'px';
	    }
	    el.style[name] = value;
	    return undefined;
	  }
	  return getComputedStyleX(el, name);
	}
	
	each(['width', 'height'], function (name) {
	  var first = name.charAt(0).toUpperCase() + name.slice(1);
	  domUtils['outer' + first] = function (el, includeMargin) {
	    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
	  };
	  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
	
	  domUtils[name] = function (elem, val) {
	    if (val !== undefined) {
	      if (elem) {
	        var computedStyle = getComputedStyleX(elem);
	        var isBorderBox = isBorderBoxFn(elem);
	        if (isBorderBox) {
	          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
	        }
	        return css(elem, name, val);
	      }
	      return undefined;
	    }
	    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
	  };
	});
	
	// 设置 elem 相对 elem.ownerDocument 的坐标
	function setOffset(elem, offset) {
	  // set position first, in-case top/left are set even on static elem
	  if (css(elem, 'position') === 'static') {
	    elem.style.position = 'relative';
	  }
	
	  var old = getOffset(elem);
	  var ret = {};
	  var current = undefined;
	  var key = undefined;
	
	  for (key in offset) {
	    if (offset.hasOwnProperty(key)) {
	      current = parseFloat(css(elem, key)) || 0;
	      ret[key] = current + offset[key] - old[key];
	    }
	  }
	  css(elem, ret);
	}
	
	module.exports = _extends({
	  getWindow: function getWindow(node) {
	    var doc = node.ownerDocument || node;
	    return doc.defaultView || doc.parentWindow;
	  },
	  offset: function offset(el, value) {
	    if (typeof value !== 'undefined') {
	      setOffset(el, value);
	    } else {
	      return getOffset(el);
	    }
	  },
	
	  isWindow: isWindow,
	  each: each,
	  css: css,
	  clone: function clone(obj) {
	    var ret = {};
	    for (var i in obj) {
	      if (obj.hasOwnProperty(i)) {
	        ret[i] = obj[i];
	      }
	    }
	    var overflow = obj.overflow;
	    if (overflow) {
	      for (var i in obj) {
	        if (obj.hasOwnProperty(i)) {
	          ret.overflow[i] = obj.overflow[i];
	        }
	      }
	    }
	    return ret;
	  },
	  scrollLeft: function scrollLeft(w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollLeft(w);
	      }
	      window.scrollTo(v, getScrollTop(w));
	    } else {
	      if (v === undefined) {
	        return w.scrollLeft;
	      }
	      w.scrollLeft = v;
	    }
	  },
	  scrollTop: function scrollTop(w, v) {
	    if (isWindow(w)) {
	      if (v === undefined) {
	        return getScrollTop(w);
	      }
	      window.scrollTo(getScrollLeft(w), v);
	    } else {
	      if (v === undefined) {
	        return w.scrollTop;
	      }
	      w.scrollTop = v;
	    }
	  },
	
	  viewportWidth: 0,
	  viewportHeight: 0
	}, domUtils);

/***/ },
/* 2133 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule AtomicBlockUtils
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var BlockMapBuilder = __webpack_require__(282);
	var CharacterMetadata = __webpack_require__(100);
	var ContentBlock = __webpack_require__(208);
	var ContentBlockNode = __webpack_require__(108);
	var DraftFeatureFlags = __webpack_require__(176);
	var DraftModifier = __webpack_require__(92);
	var EditorState = __webpack_require__(52);
	var Immutable = __webpack_require__(39);
	var SelectionState = __webpack_require__(244);
	
	var generateRandomKey = __webpack_require__(158);
	var moveBlockInContentState = __webpack_require__(2193);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat;
	
	
	var AtomicBlockUtils = {
	  insertAtomicBlock: function insertAtomicBlock(editorState, entityKey, character) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	
	    var afterRemoval = DraftModifier.removeRange(contentState, selectionState, 'backward');
	
	    var targetSelection = afterRemoval.getSelectionAfter();
	    var afterSplit = DraftModifier.splitBlock(afterRemoval, targetSelection);
	    var insertionTarget = afterSplit.getSelectionAfter();
	
	    var asAtomicBlock = DraftModifier.setBlockType(afterSplit, insertionTarget, 'atomic');
	
	    var charData = CharacterMetadata.create({ entity: entityKey });
	
	    var atomicBlockConfig = {
	      key: generateRandomKey(),
	      type: 'atomic',
	      text: character,
	      characterList: List(Repeat(charData, character.length))
	    };
	
	    var atomicDividerBlockConfig = {
	      key: generateRandomKey(),
	      type: 'unstyled'
	    };
	
	    if (experimentalTreeDataSupport) {
	      atomicBlockConfig = _extends({}, atomicBlockConfig, {
	        nextSibling: atomicDividerBlockConfig.key
	      });
	      atomicDividerBlockConfig = _extends({}, atomicDividerBlockConfig, {
	        prevSibling: atomicBlockConfig.key
	      });
	    }
	
	    var fragmentArray = [new ContentBlockRecord(atomicBlockConfig), new ContentBlockRecord(atomicDividerBlockConfig)];
	
	    var fragment = BlockMapBuilder.createFromArray(fragmentArray);
	
	    var withAtomicBlock = DraftModifier.replaceWithFragment(asAtomicBlock, insertionTarget, fragment);
	
	    var newContent = withAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  },
	
	  moveAtomicBlock: function moveAtomicBlock(editorState, atomicBlock, targetRange, insertionMode) {
	    var contentState = editorState.getCurrentContent();
	    var selectionState = editorState.getSelection();
	
	    var withMovedAtomicBlock = void 0;
	
	    if (insertionMode === 'before' || insertionMode === 'after') {
	      var targetBlock = contentState.getBlockForKey(insertionMode === 'before' ? targetRange.getStartKey() : targetRange.getEndKey());
	
	      withMovedAtomicBlock = moveBlockInContentState(contentState, atomicBlock, targetBlock, insertionMode);
	    } else {
	      var afterRemoval = DraftModifier.removeRange(contentState, targetRange, 'backward');
	
	      var selectionAfterRemoval = afterRemoval.getSelectionAfter();
	      var _targetBlock = afterRemoval.getBlockForKey(selectionAfterRemoval.getFocusKey());
	
	      if (selectionAfterRemoval.getStartOffset() === 0) {
	        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'before');
	      } else if (selectionAfterRemoval.getEndOffset() === _targetBlock.getLength()) {
	        withMovedAtomicBlock = moveBlockInContentState(afterRemoval, atomicBlock, _targetBlock, 'after');
	      } else {
	        var afterSplit = DraftModifier.splitBlock(afterRemoval, selectionAfterRemoval);
	
	        var selectionAfterSplit = afterSplit.getSelectionAfter();
	        var _targetBlock2 = afterSplit.getBlockForKey(selectionAfterSplit.getFocusKey());
	
	        withMovedAtomicBlock = moveBlockInContentState(afterSplit, atomicBlock, _targetBlock2, 'before');
	      }
	    }
	
	    var newContent = withMovedAtomicBlock.merge({
	      selectionBefore: selectionState,
	      selectionAfter: withMovedAtomicBlock.getSelectionAfter().set('hasFocus', true)
	    });
	
	    return EditorState.push(editorState, newContent, 'move-block');
	  }
	};
	
	module.exports = AtomicBlockUtils;

/***/ },
/* 2134 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule CompositeDraftDecorator
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Immutable = __webpack_require__(39);
	
	var List = Immutable.List;
	
	
	var DELIMITER = '.';
	
	/**
	 * A CompositeDraftDecorator traverses through a list of DraftDecorator
	 * instances to identify sections of a ContentBlock that should be rendered
	 * in a "decorated" manner. For example, hashtags, mentions, and links may
	 * be intended to stand out visually, be rendered as anchors, etc.
	 *
	 * The list of decorators supplied to the constructor will be used in the
	 * order they are provided. This allows the caller to specify a priority for
	 * string matching, in case of match collisions among decorators.
	 *
	 * For instance, I may have a link with a `#` in its text. Though this section
	 * of text may match our hashtag decorator, it should not be treated as a
	 * hashtag. I should therefore list my link DraftDecorator
	 * before my hashtag DraftDecorator when constructing this composite
	 * decorator instance.
	 *
	 * Thus, when a collision like this is encountered, the earlier match is
	 * preserved and the new match is discarded.
	 */
	
	var CompositeDraftDecorator = function () {
	  function CompositeDraftDecorator(decorators) {
	    _classCallCheck(this, CompositeDraftDecorator);
	
	    // Copy the decorator array, since we use this array order to determine
	    // precedence of decoration matching. If the array is mutated externally,
	    // we don't want to be affected here.
	    this._decorators = decorators.slice();
	  }
	
	  CompositeDraftDecorator.prototype.getDecorations = function getDecorations(block, contentState) {
	    var decorations = Array(block.getText().length).fill(null);
	
	    this._decorators.forEach(function ( /*object*/decorator, /*number*/ii) {
	      var counter = 0;
	      var strategy = decorator.strategy;
	      var callback = function callback( /*number*/start, /*number*/end) {
	        // Find out if any of our matching range is already occupied
	        // by another decorator. If so, discard the match. Otherwise, store
	        // the component key for rendering.
	        if (canOccupySlice(decorations, start, end)) {
	          occupySlice(decorations, start, end, ii + DELIMITER + counter);
	          counter++;
	        }
	      };
	      strategy(block, callback, contentState);
	    });
	
	    return List(decorations);
	  };
	
	  CompositeDraftDecorator.prototype.getComponentForKey = function getComponentForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].component;
	  };
	
	  CompositeDraftDecorator.prototype.getPropsForKey = function getPropsForKey(key) {
	    var componentKey = parseInt(key.split(DELIMITER)[0], 10);
	    return this._decorators[componentKey].props;
	  };
	
	  return CompositeDraftDecorator;
	}();
	
	/**
	 * Determine whether we can occupy the specified slice of the decorations
	 * array.
	 */
	
	
	function canOccupySlice(decorations, start, end) {
	  for (var ii = start; ii < end; ii++) {
	    if (decorations[ii] != null) {
	      return false;
	    }
	  }
	  return true;
	}
	
	/**
	 * Splice the specified component into our decoration array at the desired
	 * range.
	 */
	function occupySlice(targetArr, start, end, componentKey) {
	  for (var ii = start; ii < end; ii++) {
	    targetArr[ii] = componentKey;
	  }
	}
	
	module.exports = CompositeDraftDecorator;

/***/ },
/* 2135 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule ContentStateInlineStyle
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(100);
	
	var _require = __webpack_require__(39),
	    Map = _require.Map;
	
	var ContentStateInlineStyle = {
	  add: function add(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, true);
	  },
	
	  remove: function remove(contentState, selectionState, inlineStyle) {
	    return modifyInlineStyle(contentState, selectionState, inlineStyle, false);
	  }
	};
	
	function modifyInlineStyle(contentState, selectionState, inlineStyle, addOrRemove) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart;
	    var sliceEnd;
	
	    if (startKey === endKey) {
	      sliceStart = startOffset;
	      sliceEnd = endOffset;
	    } else {
	      sliceStart = blockKey === startKey ? startOffset : 0;
	      sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    }
	
	    var chars = block.getCharacterList();
	    var current;
	    while (sliceStart < sliceEnd) {
	      current = chars.get(sliceStart);
	      chars = chars.set(sliceStart, addOrRemove ? CharacterMetadata.applyStyle(current, inlineStyle) : CharacterMetadata.removeStyle(current, inlineStyle));
	      sliceStart++;
	    }
	
	    return block.set('characterList', chars);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = ContentStateInlineStyle;

/***/ },
/* 2136 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditor.react
	 * @format
	 * 
	 * @preventMunge
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DefaultDraftBlockRenderMap = __webpack_require__(489);
	var DefaultDraftInlineStyle = __webpack_require__(796);
	var DraftEditorCompositionHandler = __webpack_require__(2137);
	var DraftEditorContents = __webpack_require__(2139);
	var DraftEditorDragHandler = __webpack_require__(2140);
	var DraftEditorEditHandler = __webpack_require__(2141);
	var DraftEditorPlaceholder = __webpack_require__(2143);
	var EditorState = __webpack_require__(52);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(23);
	var Scroll = __webpack_require__(883);
	var Style = __webpack_require__(520);
	var UserAgent = __webpack_require__(142);
	
	var cx = __webpack_require__(253);
	var emptyFunction = __webpack_require__(101);
	var generateRandomKey = __webpack_require__(158);
	var getDefaultKeyBinding = __webpack_require__(803);
	var getScrollPosition = __webpack_require__(523);
	var invariant = __webpack_require__(18);
	var nullthrows = __webpack_require__(123);
	
	var isIE = UserAgent.isBrowser('IE');
	
	// IE does not support the `input` event on contentEditable, so we can't
	// observe spellcheck behavior.
	var allowSpellCheck = !isIE;
	
	// Define a set of handler objects to correspond to each possible `mode`
	// of editor behavior.
	var handlerMap = {
	  edit: DraftEditorEditHandler,
	  composite: DraftEditorCompositionHandler,
	  drag: DraftEditorDragHandler,
	  cut: null,
	  render: null
	};
	
	/**
	 * `DraftEditor` is the root editor component. It composes a `contentEditable`
	 * div, and provides a wide variety of useful function props for managing the
	 * state of the editor. See `DraftEditorProps` for details.
	 */
	var DraftEditor = function (_React$Component) {
	  _inherits(DraftEditor, _React$Component);
	
	  function DraftEditor(props) {
	    _classCallCheck(this, DraftEditor);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.focus = function (scrollPosition) {
	      var editorState = _this.props.editorState;
	
	      var alreadyHasFocus = editorState.getSelection().getHasFocus();
	      var editorNode = ReactDOM.findDOMNode(_this.editor);
	
	      if (!editorNode) {
	        // once in a while people call 'focus' in a setTimeout, and the node has
	        // been deleted, so it can be null in that case.
	        return;
	      }
	
	      var scrollParent = Style.getScrollParent(editorNode);
	
	      var _ref = scrollPosition || getScrollPosition(scrollParent),
	          x = _ref.x,
	          y = _ref.y;
	
	      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
	      editorNode.focus();
	
	      // Restore scroll position
	      if (scrollParent === window) {
	        window.scrollTo(x, y);
	      } else {
	        Scroll.setTop(scrollParent, y);
	      }
	
	      // On Chrome and Safari, calling focus on contenteditable focuses the
	      // cursor at the first character. This is something you don't expect when
	      // you're clicking on an input element but not directly on a character.
	      // Put the cursor back where it was before the blur.
	      if (!alreadyHasFocus) {
	        _this.update(EditorState.forceSelection(editorState, editorState.getSelection()));
	      }
	    };
	
	    _this.blur = function () {
	      var editorNode = ReactDOM.findDOMNode(_this.editor);
	      !(editorNode instanceof HTMLElement) ?  false ? invariant(false, 'editorNode is not an HTMLElement') : invariant(false) : void 0;
	      editorNode.blur();
	    };
	
	    _this.setMode = function (mode) {
	      _this._handler = handlerMap[mode];
	    };
	
	    _this.exitCurrentMode = function () {
	      _this.setMode('edit');
	    };
	
	    _this.restoreEditorDOM = function (scrollPosition) {
	      _this.setState({ contentsKey: _this.state.contentsKey + 1 }, function () {
	        _this.focus(scrollPosition);
	      });
	    };
	
	    _this.setClipboard = function (clipboard) {
	      _this._clipboard = clipboard;
	    };
	
	    _this.getClipboard = function () {
	      return _this._clipboard;
	    };
	
	    _this.update = function (editorState) {
	      _this._latestEditorState = editorState;
	      _this.props.onChange(editorState);
	    };
	
	    _this.onDragEnter = function () {
	      _this._dragCount++;
	    };
	
	    _this.onDragLeave = function () {
	      _this._dragCount--;
	      if (_this._dragCount === 0) {
	        _this.exitCurrentMode();
	      }
	    };
	
	    _this._blockSelectEvents = false;
	    _this._clipboard = null;
	    _this._handler = null;
	    _this._dragCount = 0;
	    _this._editorKey = props.editorKey || generateRandomKey();
	    _this._placeholderAccessibilityID = 'placeholder-' + _this._editorKey;
	    _this._latestEditorState = props.editorState;
	    _this._latestCommittedEditorState = props.editorState;
	
	    _this._onBeforeInput = _this._buildHandler('onBeforeInput');
	    _this._onBlur = _this._buildHandler('onBlur');
	    _this._onCharacterData = _this._buildHandler('onCharacterData');
	    _this._onCompositionEnd = _this._buildHandler('onCompositionEnd');
	    _this._onCompositionStart = _this._buildHandler('onCompositionStart');
	    _this._onCopy = _this._buildHandler('onCopy');
	    _this._onCut = _this._buildHandler('onCut');
	    _this._onDragEnd = _this._buildHandler('onDragEnd');
	    _this._onDragOver = _this._buildHandler('onDragOver');
	    _this._onDragStart = _this._buildHandler('onDragStart');
	    _this._onDrop = _this._buildHandler('onDrop');
	    _this._onInput = _this._buildHandler('onInput');
	    _this._onFocus = _this._buildHandler('onFocus');
	    _this._onKeyDown = _this._buildHandler('onKeyDown');
	    _this._onKeyPress = _this._buildHandler('onKeyPress');
	    _this._onKeyUp = _this._buildHandler('onKeyUp');
	    _this._onMouseDown = _this._buildHandler('onMouseDown');
	    _this._onMouseUp = _this._buildHandler('onMouseUp');
	    _this._onPaste = _this._buildHandler('onPaste');
	    _this._onSelect = _this._buildHandler('onSelect');
	
	    _this.getEditorKey = function () {
	      return _this._editorKey;
	    };
	
	    // See `restoreEditorDOM()`.
	    _this.state = { contentsKey: 0 };
	    return _this;
	  }
	
	  /**
	   * Build a method that will pass the event to the specified handler method.
	   * This allows us to look up the correct handler function for the current
	   * editor mode, if any has been specified.
	   */
	
	
	  /**
	   * Define proxies that can route events to the current handler.
	   */
	
	
	  DraftEditor.prototype._buildHandler = function _buildHandler(eventName) {
	    var _this2 = this;
	
	    return function (e) {
	      if (!_this2.props.readOnly) {
	        var method = _this2._handler && _this2._handler[eventName];
	        method && method(_this2, e);
	      }
	    };
	  };
	
	  DraftEditor.prototype._showPlaceholder = function _showPlaceholder() {
	    return !!this.props.placeholder && !this.props.editorState.isInCompositionMode() && !this.props.editorState.getCurrentContent().hasText();
	  };
	
	  DraftEditor.prototype._renderPlaceholder = function _renderPlaceholder() {
	    if (this._showPlaceholder()) {
	      var placeHolderProps = {
	        text: nullthrows(this.props.placeholder),
	        editorState: this.props.editorState,
	        textAlignment: this.props.textAlignment,
	        accessibilityID: this._placeholderAccessibilityID
	      };
	
	      return React.createElement(DraftEditorPlaceholder, placeHolderProps);
	    }
	    return null;
	  };
	
	  DraftEditor.prototype.render = function render() {
	    var _this3 = this;
	
	    var _props = this.props,
	        blockRenderMap = _props.blockRenderMap,
	        blockRendererFn = _props.blockRendererFn,
	        blockStyleFn = _props.blockStyleFn,
	        customStyleFn = _props.customStyleFn,
	        customStyleMap = _props.customStyleMap,
	        editorState = _props.editorState,
	        readOnly = _props.readOnly,
	        textAlignment = _props.textAlignment,
	        textDirectionality = _props.textDirectionality;
	
	
	    var rootClass = cx({
	      'DraftEditor/root': true,
	      'DraftEditor/alignLeft': textAlignment === 'left',
	      'DraftEditor/alignRight': textAlignment === 'right',
	      'DraftEditor/alignCenter': textAlignment === 'center'
	    });
	
	    var contentStyle = {
	      outline: 'none',
	      // fix parent-draggable Safari bug. #1326
	      userSelect: 'text',
	      WebkitUserSelect: 'text',
	      whiteSpace: 'pre-wrap',
	      wordWrap: 'break-word'
	    };
	
	    // The aria-expanded and aria-haspopup properties should only be rendered
	    // for a combobox.
	    var ariaRole = this.props.role || 'textbox';
	    var ariaExpanded = ariaRole === 'combobox' ? !!this.props.ariaExpanded : null;
	
	    var editorContentsProps = {
	      blockRenderMap: blockRenderMap,
	      blockRendererFn: blockRendererFn,
	      blockStyleFn: blockStyleFn,
	      customStyleMap: _extends({}, DefaultDraftInlineStyle, customStyleMap),
	      customStyleFn: customStyleFn,
	      editorKey: this._editorKey,
	      editorState: editorState,
	      key: 'contents' + this.state.contentsKey,
	      textDirectionality: textDirectionality
	    };
	
	    return React.createElement(
	      'div',
	      { className: rootClass },
	      this._renderPlaceholder(),
	      React.createElement(
	        'div',
	        {
	          className: cx('DraftEditor/editorContainer'),
	          ref: function ref(_ref3) {
	            return _this3.editorContainer = _ref3;
	          } },
	        React.createElement(
	          'div',
	          {
	            'aria-activedescendant': readOnly ? null : this.props.ariaActiveDescendantID,
	            'aria-autocomplete': readOnly ? null : this.props.ariaAutoComplete,
	            'aria-controls': readOnly ? null : this.props.ariaControls,
	            'aria-describedby': this.props.ariaDescribedBy || this._placeholderAccessibilityID,
	            'aria-expanded': readOnly ? null : ariaExpanded,
	            'aria-label': this.props.ariaLabel,
	            'aria-labelledby': this.props.ariaLabelledBy,
	            'aria-multiline': this.props.ariaMultiline,
	            autoCapitalize: this.props.autoCapitalize,
	            autoComplete: this.props.autoComplete,
	            autoCorrect: this.props.autoCorrect,
	            className: cx({
	              // Chrome's built-in translation feature mutates the DOM in ways
	              // that Draft doesn't expect (ex: adding <font> tags inside
	              // DraftEditorLeaf spans) and causes problems. We add notranslate
	              // here which makes its autotranslation skip over this subtree.
	              notranslate: !readOnly,
	              'public/DraftEditor/content': true
	            }),
	            contentEditable: !readOnly,
	            'data-testid': this.props.webDriverTestID,
	            onBeforeInput: this._onBeforeInput,
	            onBlur: this._onBlur,
	            onCompositionEnd: this._onCompositionEnd,
	            onCompositionStart: this._onCompositionStart,
	            onCopy: this._onCopy,
	            onCut: this._onCut,
	            onDragEnd: this._onDragEnd,
	            onDragEnter: this.onDragEnter,
	            onDragLeave: this.onDragLeave,
	            onDragOver: this._onDragOver,
	            onDragStart: this._onDragStart,
	            onDrop: this._onDrop,
	            onFocus: this._onFocus,
	            onInput: this._onInput,
	            onKeyDown: this._onKeyDown,
	            onKeyPress: this._onKeyPress,
	            onKeyUp: this._onKeyUp,
	            onMouseUp: this._onMouseUp,
	            onPaste: this._onPaste,
	            onSelect: this._onSelect,
	            ref: function ref(_ref2) {
	              return _this3.editor = _ref2;
	            },
	            role: readOnly ? null : ariaRole,
	            spellCheck: allowSpellCheck && this.props.spellCheck,
	            style: contentStyle,
	            suppressContentEditableWarning: true,
	            tabIndex: this.props.tabIndex },
	          React.createElement(DraftEditorContents, editorContentsProps)
	        )
	      )
	    );
	  };
	
	  DraftEditor.prototype.componentDidMount = function componentDidMount() {
	    this.setMode('edit');
	
	    /**
	     * IE has a hardcoded "feature" that attempts to convert link text into
	     * anchors in contentEditable DOM. This breaks the editor's expectations of
	     * the DOM, and control is lost. Disable it to make IE behave.
	     * See: http://blogs.msdn.com/b/ieinternals/archive/2010/09/15/
	     * ie9-beta-minor-change-list.aspx
	     */
	    if (isIE) {
	      document.execCommand('AutoUrlDetect', false, false);
	    }
	  };
	
	  /**
	   * Prevent selection events from affecting the current editor state. This
	   * is mostly intended to defend against IE, which fires off `selectionchange`
	   * events regardless of whether the selection is set via the browser or
	   * programmatically. We only care about selection events that occur because
	   * of browser interaction, not re-renders and forced selections.
	   */
	
	
	  DraftEditor.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
	    this._blockSelectEvents = true;
	    this._latestEditorState = nextProps.editorState;
	  };
	
	  DraftEditor.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._blockSelectEvents = false;
	    this._latestCommittedEditorState = this.props.editorState;
	  };
	
	  /**
	   * Used via `this.focus()`.
	   *
	   * Force focus back onto the editor node.
	   *
	   * We attempt to preserve scroll position when focusing. You can also pass
	   * a specified scroll position (for cases like `cut` behavior where it should
	   * be restored to a known position).
	   */
	
	
	  /**
	   * Used via `this.setMode(...)`.
	   *
	   * Set the behavior mode for the editor component. This switches the current
	   * handler module to ensure that DOM events are managed appropriately for
	   * the active mode.
	   */
	
	
	  /**
	   * Used via `this.restoreEditorDOM()`.
	   *
	   * Force a complete re-render of the DraftEditorContents based on the current
	   * EditorState. This is useful when we know we are going to lose control of
	   * the DOM state (cut command, IME) and we want to make sure that
	   * reconciliation occurs on a version of the DOM that is synchronized with
	   * our EditorState.
	   */
	
	
	  /**
	   * Used via `this.setClipboard(...)`.
	   *
	   * Set the clipboard state for a cut/copy event.
	   */
	
	
	  /**
	   * Used via `this.getClipboard()`.
	   *
	   * Retrieve the clipboard state for a cut/copy event.
	   */
	
	
	  /**
	   * Used via `this.update(...)`.
	   *
	   * Propagate a new `EditorState` object to higher-level components. This is
	   * the method by which event handlers inform the `DraftEditor` component of
	   * state changes. A component that composes a `DraftEditor` **must** provide
	   * an `onChange` prop to receive state updates passed along from this
	   * function.
	   */
	
	
	  /**
	   * Used in conjunction with `onDragLeave()`, by counting the number of times
	   * a dragged element enters and leaves the editor (or any of its children),
	   * to determine when the dragged element absolutely leaves the editor.
	   */
	
	
	  /**
	   * See `onDragEnter()`.
	   */
	
	
	  return DraftEditor;
	}(React.Component);
	
	DraftEditor.defaultProps = {
	  blockRenderMap: DefaultDraftBlockRenderMap,
	  blockRendererFn: emptyFunction.thatReturnsNull,
	  blockStyleFn: emptyFunction.thatReturns(''),
	  keyBindingFn: getDefaultKeyBinding,
	  readOnly: false,
	  spellCheck: false,
	  stripPastedStyles: false
	};
	
	
	module.exports = DraftEditor;

/***/ },
/* 2137 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorCompositionHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(176);
	var DraftModifier = __webpack_require__(92);
	var EditorState = __webpack_require__(52);
	var Keys = __webpack_require__(519);
	
	var getEntityKeyForSelection = __webpack_require__(492);
	var isEventHandled = __webpack_require__(285);
	var isSelectionAtLeafStart = __webpack_require__(813);
	
	/**
	 * Millisecond delay to allow `compositionstart` to fire again upon
	 * `compositionend`.
	 *
	 * This is used for Korean input to ensure that typing can continue without
	 * the editor trying to render too quickly. More specifically, Safari 7.1+
	 * triggers `compositionstart` a little slower than Chrome/FF, which
	 * leads to composed characters being resolved and re-render occurring
	 * sooner than we want.
	 */
	var RESOLVE_DELAY = 20;
	
	/**
	 * A handful of variables used to track the current composition and its
	 * resolution status. These exist at the module level because it is not
	 * possible to have compositions occurring in multiple editors simultaneously,
	 * and it simplifies state management with respect to the DraftEditor component.
	 */
	var resolved = false;
	var stillComposing = false;
	var textInputData = '';
	
	var DraftEditorCompositionHandler = {
	  onBeforeInput: function onBeforeInput(editor, e) {
	    textInputData = (textInputData || '') + e.data;
	  },
	
	  /**
	   * A `compositionstart` event has fired while we're still in composition
	   * mode. Continue the current composition session to prevent a re-render.
	   */
	  onCompositionStart: function onCompositionStart(editor) {
	    stillComposing = true;
	  },
	
	  /**
	   * Attempt to end the current composition session.
	   *
	   * Defer handling because browser will still insert the chars into active
	   * element after `compositionend`. If a `compositionstart` event fires
	   * before `resolveComposition` executes, our composition session will
	   * continue.
	   *
	   * The `resolved` flag is useful because certain IME interfaces fire the
	   * `compositionend` event multiple times, thus queueing up multiple attempts
	   * at handling the composition. Since handling the same composition event
	   * twice could break the DOM, we only use the first event. Example: Arabic
	   * Google Input Tools on Windows 8.1 fires `compositionend` three times.
	   */
	  onCompositionEnd: function onCompositionEnd(editor) {
	    resolved = false;
	    stillComposing = false;
	    setTimeout(function () {
	      if (!resolved) {
	        DraftEditorCompositionHandler.resolveComposition(editor);
	      }
	    }, RESOLVE_DELAY);
	  },
	
	  /**
	   * In Safari, keydown events may fire when committing compositions. If
	   * the arrow keys are used to commit, prevent default so that the cursor
	   * doesn't move, otherwise it will jump back noticeably on re-render.
	   */
	  onKeyDown: function onKeyDown(editor, e) {
	    if (!stillComposing) {
	      // If a keydown event is received after compositionend but before the
	      // 20ms timer expires (ex: type option-E then backspace, or type A then
	      // backspace in 2-Set Korean), we should immediately resolve the
	      // composition and reinterpret the key press in edit mode.
	      DraftEditorCompositionHandler.resolveComposition(editor);
	      editor._onKeyDown(e);
	      return;
	    }
	    if (e.which === Keys.RIGHT || e.which === Keys.LEFT) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Keypress events may fire when committing compositions. In Firefox,
	   * pressing RETURN commits the composition and inserts extra newline
	   * characters that we do not want. `preventDefault` allows the composition
	   * to be committed while preventing the extra characters.
	   */
	  onKeyPress: function onKeyPress(editor, e) {
	    if (e.which === Keys.RETURN) {
	      e.preventDefault();
	    }
	  },
	
	  /**
	   * Attempt to insert composed characters into the document.
	   *
	   * If we are still in a composition session, do nothing. Otherwise, insert
	   * the characters into the document and terminate the composition session.
	   *
	   * If no characters were composed -- for instance, the user
	   * deleted all composed characters and committed nothing new --
	   * force a re-render. We also re-render when the composition occurs
	   * at the beginning of a leaf, to ensure that if the browser has
	   * created a new text node for the composition, we will discard it.
	   *
	   * Resetting innerHTML will move focus to the beginning of the editor,
	   * so we update to force it back to the correct place.
	   */
	  resolveComposition: function resolveComposition(editor) {
	    if (stillComposing) {
	      return;
	    }
	
	    resolved = true;
	    var composedChars = textInputData;
	    textInputData = '';
	
	    var editorState = EditorState.set(editor._latestEditorState, {
	      inCompositionMode: false
	    });
	
	    var currentStyle = editorState.getCurrentInlineStyle();
	    var entityKey = getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection());
	
	    var mustReset = !composedChars || isSelectionAtLeafStart(editorState) || currentStyle.size > 0 || entityKey !== null;
	
	    if (mustReset) {
	      editor.restoreEditorDOM();
	    }
	
	    editor.exitCurrentMode();
	
	    if (composedChars) {
	      if (DraftFeatureFlags.draft_handlebeforeinput_composed_text && editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(composedChars, editorState))) {
	        return;
	      }
	      // If characters have been composed, re-rendering with the update
	      // is sufficient to reset the editor.
	      var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), composedChars, currentStyle, entityKey);
	      editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
	      return;
	    }
	
	    if (mustReset) {
	      editor.update(EditorState.set(editorState, {
	        nativelyRenderedContent: null,
	        forceSelection: true
	      }));
	    }
	  }
	};
	
	module.exports = DraftEditorCompositionHandler;

/***/ },
/* 2138 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorContents-core.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorBlock = __webpack_require__(797);
	var DraftOffsetKey = __webpack_require__(283);
	var EditorState = __webpack_require__(52);
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(253);
	var joinClasses = __webpack_require__(2479);
	var nullthrows = __webpack_require__(123);
	
	/**
	 * Provide default styling for list items. This way, lists will be styled with
	 * proper counters and indentation even if the caller does not specify
	 * their own styling at all. If more than five levels of nesting are needed,
	 * the necessary CSS classes can be provided via `blockStyleFn` configuration.
	 */
	var getListItemClasses = function getListItemClasses(type, depth, shouldResetCount, direction) {
	  return cx({
	    'public/DraftStyleDefault/unorderedListItem': type === 'unordered-list-item',
	    'public/DraftStyleDefault/orderedListItem': type === 'ordered-list-item',
	    'public/DraftStyleDefault/reset': shouldResetCount,
	    'public/DraftStyleDefault/depth0': depth === 0,
	    'public/DraftStyleDefault/depth1': depth === 1,
	    'public/DraftStyleDefault/depth2': depth === 2,
	    'public/DraftStyleDefault/depth3': depth === 3,
	    'public/DraftStyleDefault/depth4': depth === 4,
	    'public/DraftStyleDefault/listLTR': direction === 'LTR',
	    'public/DraftStyleDefault/listRTL': direction === 'RTL'
	  });
	};
	
	/**
	 * `DraftEditorContents` is the container component for all block components
	 * rendered for a `DraftEditor`. It is optimized to aggressively avoid
	 * re-rendering blocks whenever possible.
	 *
	 * This component is separate from `DraftEditor` because certain props
	 * (for instance, ARIA props) must be allowed to update without affecting
	 * the contents of the editor.
	 */
	
	var DraftEditorContents = function (_React$Component) {
	  _inherits(DraftEditorContents, _React$Component);
	
	  function DraftEditorContents() {
	    _classCallCheck(this, DraftEditorContents);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorContents.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var prevEditorState = this.props.editorState;
	    var nextEditorState = nextProps.editorState;
	
	    var prevDirectionMap = prevEditorState.getDirectionMap();
	    var nextDirectionMap = nextEditorState.getDirectionMap();
	
	    // Text direction has changed for one or more blocks. We must re-render.
	    if (prevDirectionMap !== nextDirectionMap) {
	      return true;
	    }
	
	    var didHaveFocus = prevEditorState.getSelection().getHasFocus();
	    var nowHasFocus = nextEditorState.getSelection().getHasFocus();
	
	    if (didHaveFocus !== nowHasFocus) {
	      return true;
	    }
	
	    var nextNativeContent = nextEditorState.getNativelyRenderedContent();
	
	    var wasComposing = prevEditorState.isInCompositionMode();
	    var nowComposing = nextEditorState.isInCompositionMode();
	
	    // If the state is unchanged or we're currently rendering a natively
	    // rendered state, there's nothing new to be done.
	    if (prevEditorState === nextEditorState || nextNativeContent !== null && nextEditorState.getCurrentContent() === nextNativeContent || wasComposing && nowComposing) {
	      return false;
	    }
	
	    var prevContent = prevEditorState.getCurrentContent();
	    var nextContent = nextEditorState.getCurrentContent();
	    var prevDecorator = prevEditorState.getDecorator();
	    var nextDecorator = nextEditorState.getDecorator();
	    return wasComposing !== nowComposing || prevContent !== nextContent || prevDecorator !== nextDecorator || nextEditorState.mustForceSelection();
	  };
	
	  DraftEditorContents.prototype.render = function render() {
	    var _props = this.props,
	        blockRenderMap = _props.blockRenderMap,
	        blockRendererFn = _props.blockRendererFn,
	        blockStyleFn = _props.blockStyleFn,
	        customStyleMap = _props.customStyleMap,
	        customStyleFn = _props.customStyleFn,
	        editorState = _props.editorState,
	        editorKey = _props.editorKey,
	        textDirectionality = _props.textDirectionality;
	
	
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var forceSelection = editorState.mustForceSelection();
	    var decorator = editorState.getDecorator();
	    var directionMap = nullthrows(editorState.getDirectionMap());
	
	    var blocksAsArray = content.getBlocksAsArray();
	    var processedBlocks = [];
	
	    var currentDepth = null;
	    var lastWrapperTemplate = null;
	
	    for (var ii = 0; ii < blocksAsArray.length; ii++) {
	      var _block = blocksAsArray[ii];
	      var key = _block.getKey();
	      var blockType = _block.getType();
	
	      var customRenderer = blockRendererFn(_block);
	      var CustomComponent = void 0,
	          customProps = void 0,
	          customEditable = void 0;
	      if (customRenderer) {
	        CustomComponent = customRenderer.component;
	        customProps = customRenderer.props;
	        customEditable = customRenderer.editable;
	      }
	
	      var direction = textDirectionality ? textDirectionality : directionMap.get(key);
	      var offsetKey = DraftOffsetKey.encode(key, 0, 0);
	      var componentProps = {
	        contentState: content,
	        block: _block,
	        blockProps: customProps,
	        blockStyleFn: blockStyleFn,
	        customStyleMap: customStyleMap,
	        customStyleFn: customStyleFn,
	        decorator: decorator,
	        direction: direction,
	        forceSelection: forceSelection,
	        key: key,
	        offsetKey: offsetKey,
	        selection: selection,
	        tree: editorState.getBlockTree(key)
	      };
	
	      var configForType = blockRenderMap.get(blockType) || blockRenderMap.get('unstyled');
	      var wrapperTemplate = configForType.wrapper;
	
	      var Element = configForType.element || blockRenderMap.get('unstyled').element;
	
	      var depth = _block.getDepth();
	      var className = '';
	      if (blockStyleFn) {
	        className = blockStyleFn(_block);
	      }
	
	      // List items are special snowflakes, since we handle nesting and
	      // counters manually.
	      if (Element === 'li') {
	        var shouldResetCount = lastWrapperTemplate !== wrapperTemplate || currentDepth === null || depth > currentDepth;
	        className = joinClasses(className, getListItemClasses(blockType, depth, shouldResetCount, direction));
	      }
	
	      var Component = CustomComponent || DraftEditorBlock;
	      var childProps = {
	        className: className,
	        'data-block': true,
	        'data-editor': editorKey,
	        'data-offset-key': offsetKey,
	        key: key
	      };
	      if (customEditable !== undefined) {
	        childProps = _extends({}, childProps, {
	          contentEditable: customEditable,
	          suppressContentEditableWarning: true
	        });
	      }
	
	      var child = React.createElement(Element, childProps, React.createElement(Component, componentProps));
	
	      processedBlocks.push({
	        block: child,
	        wrapperTemplate: wrapperTemplate,
	        key: key,
	        offsetKey: offsetKey
	      });
	
	      if (wrapperTemplate) {
	        currentDepth = _block.getDepth();
	      } else {
	        currentDepth = null;
	      }
	      lastWrapperTemplate = wrapperTemplate;
	    }
	
	    // Group contiguous runs of blocks that have the same wrapperTemplate
	    var outputBlocks = [];
	    for (var _ii = 0; _ii < processedBlocks.length;) {
	      var info = processedBlocks[_ii];
	      if (info.wrapperTemplate) {
	        var blocks = [];
	        do {
	          blocks.push(processedBlocks[_ii].block);
	          _ii++;
	        } while (_ii < processedBlocks.length && processedBlocks[_ii].wrapperTemplate === info.wrapperTemplate);
	        var wrapperElement = React.cloneElement(info.wrapperTemplate, {
	          key: info.key + '-wrap',
	          'data-offset-key': info.offsetKey
	        }, blocks);
	        outputBlocks.push(wrapperElement);
	      } else {
	        outputBlocks.push(info.block);
	        _ii++;
	      }
	    }
	
	    return React.createElement(
	      'div',
	      { 'data-contents': 'true' },
	      outputBlocks
	    );
	  };
	
	  return DraftEditorContents;
	}(React.Component);
	
	module.exports = DraftEditorContents;

/***/ },
/* 2139 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorContents.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftEditorContents = __webpack_require__(2138);
	
	module.exports = DraftEditorContents;

/***/ },
/* 2140 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorDragHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DataTransfer = __webpack_require__(881);
	var DraftModifier = __webpack_require__(92);
	var EditorState = __webpack_require__(52);
	
	var findAncestorOffsetKey = __webpack_require__(491);
	var getTextContentFromFiles = __webpack_require__(810);
	var getUpdatedSelectionState = __webpack_require__(811);
	var isEventHandled = __webpack_require__(285);
	var nullthrows = __webpack_require__(123);
	
	/**
	 * Get a SelectionState for the supplied mouse event.
	 */
	function getSelectionForEvent(event, editorState) {
	  var node = null;
	  var offset = null;
	
	  if (typeof document.caretRangeFromPoint === 'function') {
	    var dropRange = document.caretRangeFromPoint(event.x, event.y);
	    node = dropRange.startContainer;
	    offset = dropRange.startOffset;
	  } else if (event.rangeParent) {
	    node = event.rangeParent;
	    offset = event.rangeOffset;
	  } else {
	    return null;
	  }
	
	  node = nullthrows(node);
	  offset = nullthrows(offset);
	  var offsetKey = nullthrows(findAncestorOffsetKey(node));
	
	  return getUpdatedSelectionState(editorState, offsetKey, offset, offsetKey, offset);
	}
	
	var DraftEditorDragHandler = {
	  /**
	   * Drag originating from input terminated.
	   */
	  onDragEnd: function onDragEnd(editor) {
	    editor.exitCurrentMode();
	  },
	
	  /**
	   * Handle data being dropped.
	   */
	  onDrop: function onDrop(editor, e) {
	    var data = new DataTransfer(e.nativeEvent.dataTransfer);
	
	    var editorState = editor._latestEditorState;
	    var dropSelection = getSelectionForEvent(e.nativeEvent, editorState);
	
	    e.preventDefault();
	    editor.exitCurrentMode();
	
	    if (dropSelection == null) {
	      return;
	    }
	
	    var files = data.getFiles();
	    if (files.length > 0) {
	      if (editor.props.handleDroppedFiles && isEventHandled(editor.props.handleDroppedFiles(dropSelection, files))) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function (fileText) {
	        fileText && editor.update(insertTextAtSelection(editorState, dropSelection, fileText));
	      });
	      return;
	    }
	
	    var dragType = editor._internalDrag ? 'internal' : 'external';
	    if (editor.props.handleDrop && isEventHandled(editor.props.handleDrop(dropSelection, data, dragType))) {
	      return;
	    }
	
	    if (editor._internalDrag) {
	      editor.update(moveText(editorState, dropSelection));
	      return;
	    }
	
	    editor.update(insertTextAtSelection(editorState, dropSelection, data.getText()));
	  }
	};
	
	function moveText(editorState, targetSelection) {
	  var newContentState = DraftModifier.moveText(editorState.getCurrentContent(), editorState.getSelection(), targetSelection);
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	/**
	 * Insert text at a specified selection.
	 */
	function insertTextAtSelection(editorState, selection, text) {
	  var newContentState = DraftModifier.insertText(editorState.getCurrentContent(), selection, text, editorState.getCurrentInlineStyle());
	  return EditorState.push(editorState, newContentState, 'insert-fragment');
	}
	
	module.exports = DraftEditorDragHandler;

/***/ },
/* 2141 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorEditHandler
	 * @format
	 * 
	 */
	
	'use strict';
	
	var onBeforeInput = __webpack_require__(2160);
	var onBlur = __webpack_require__(2161);
	var onCompositionStart = __webpack_require__(2162);
	var onCopy = __webpack_require__(2163);
	var onCut = __webpack_require__(2164);
	var onDragOver = __webpack_require__(2165);
	var onDragStart = __webpack_require__(2166);
	var onFocus = __webpack_require__(2167);
	var onInput = __webpack_require__(2168);
	var onKeyDown = __webpack_require__(2169);
	var onPaste = __webpack_require__(2170);
	var onSelect = __webpack_require__(2171);
	
	var DraftEditorEditHandler = {
	  onBeforeInput: onBeforeInput,
	  onBlur: onBlur,
	  onCompositionStart: onCompositionStart,
	  onCopy: onCopy,
	  onCut: onCut,
	  onDragOver: onDragOver,
	  onDragStart: onDragStart,
	  onFocus: onFocus,
	  onInput: onInput,
	  onKeyDown: onKeyDown,
	  onPaste: onPaste,
	  onSelect: onSelect
	};
	
	module.exports = DraftEditorEditHandler;

/***/ },
/* 2142 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorLeaf.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DraftEditorTextNode = __webpack_require__(2144);
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(23);
	
	var invariant = __webpack_require__(18);
	var setDraftEditorSelection = __webpack_require__(2195);
	
	/**
	 * All leaf nodes in the editor are spans with single text nodes. Leaf
	 * elements are styled based on the merging of an optional custom style map
	 * and a default style map.
	 *
	 * `DraftEditorLeaf` also provides a wrapper for calling into the imperative
	 * DOM Selection API. In this way, top-level components can declaratively
	 * maintain the selection state.
	 */
	var DraftEditorLeaf = function (_React$Component) {
	  _inherits(DraftEditorLeaf, _React$Component);
	
	  function DraftEditorLeaf() {
	    _classCallCheck(this, DraftEditorLeaf);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorLeaf.prototype._setSelection = function _setSelection() {
	    var selection = this.props.selection;
	
	    // If selection state is irrelevant to the parent block, no-op.
	
	    if (selection == null || !selection.getHasFocus()) {
	      return;
	    }
	
	    var _props = this.props,
	        block = _props.block,
	        start = _props.start,
	        text = _props.text;
	
	    var blockKey = block.getKey();
	    var end = start + text.length;
	    if (!selection.hasEdgeWithin(blockKey, start, end)) {
	      return;
	    }
	
	    // Determine the appropriate target node for selection. If the child
	    // is not a text node, it is a <br /> spacer. In this case, use the
	    // <span> itself as the selection target.
	    var node = ReactDOM.findDOMNode(this);
	    !node ?  false ? invariant(false, 'Missing node') : invariant(false) : void 0;
	    var child = node.firstChild;
	    !child ?  false ? invariant(false, 'Missing child') : invariant(false) : void 0;
	    var targetNode = void 0;
	
	    if (child.nodeType === Node.TEXT_NODE) {
	      targetNode = child;
	    } else if (child.tagName === 'BR') {
	      targetNode = node;
	    } else {
	      targetNode = child.firstChild;
	      !targetNode ?  false ? invariant(false, 'Missing targetNode') : invariant(false) : void 0;
	    }
	
	    setDraftEditorSelection(selection, targetNode, blockKey, start, end);
	  };
	  /**
	   * By making individual leaf instances aware of their context within
	   * the text of the editor, we can set our selection range more
	   * easily than we could in the non-React world.
	   *
	   * Note that this depends on our maintaining tight control over the
	   * DOM structure of the DraftEditor component. If leaves had multiple
	   * text nodes, this would be harder.
	   */
	
	  DraftEditorLeaf.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var leafNode = ReactDOM.findDOMNode(this.leaf);
	    !leafNode ?  false ? invariant(false, 'Missing leafNode') : invariant(false) : void 0;
	    return leafNode.textContent !== nextProps.text || nextProps.styleSet !== this.props.styleSet || nextProps.forceSelection;
	  };
	
	  DraftEditorLeaf.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.componentDidMount = function componentDidMount() {
	    this._setSelection();
	  };
	
	  DraftEditorLeaf.prototype.render = function render() {
	    var _this2 = this;
	
	    var block = this.props.block;
	    var text = this.props.text;
	
	    // If the leaf is at the end of its block and ends in a soft newline, append
	    // an extra line feed character. Browsers collapse trailing newline
	    // characters, which leaves the cursor in the wrong place after a
	    // shift+enter. The extra character repairs this.
	
	    if (text.endsWith('\n') && this.props.isLast) {
	      text += '\n';
	    }
	
	    var _props2 = this.props,
	        customStyleMap = _props2.customStyleMap,
	        customStyleFn = _props2.customStyleFn,
	        offsetKey = _props2.offsetKey,
	        styleSet = _props2.styleSet;
	
	    var styleObj = styleSet.reduce(function (map, styleName) {
	      var mergedStyles = {};
	      var style = customStyleMap[styleName];
	
	      if (style !== undefined && map.textDecoration !== style.textDecoration) {
	        // .trim() is necessary for IE9/10/11 and Edge
	        mergedStyles.textDecoration = [map.textDecoration, style.textDecoration].join(' ').trim();
	      }
	
	      return _assign(map, style, mergedStyles);
	    }, {});
	
	    if (customStyleFn) {
	      var newStyles = customStyleFn(styleSet, block);
	      styleObj = _assign(styleObj, newStyles);
	    }
	
	    return React.createElement(
	      'span',
	      {
	        'data-offset-key': offsetKey,
	        ref: function ref(_ref) {
	          return _this2.leaf = _ref;
	        },
	        style: styleObj },
	      React.createElement(
	        DraftEditorTextNode,
	        null,
	        text
	      )
	    );
	  };
	
	  return DraftEditorLeaf;
	}(React.Component);
	
	module.exports = DraftEditorLeaf;

/***/ },
/* 2143 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorPlaceholder.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	
	var cx = __webpack_require__(253);
	
	/**
	 * This component is responsible for rendering placeholder text for the
	 * `DraftEditor` component.
	 *
	 * Override placeholder style via CSS.
	 */
	var DraftEditorPlaceholder = function (_React$Component) {
	  _inherits(DraftEditorPlaceholder, _React$Component);
	
	  function DraftEditorPlaceholder() {
	    _classCallCheck(this, DraftEditorPlaceholder);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  DraftEditorPlaceholder.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    return this.props.text !== nextProps.text || this.props.editorState.getSelection().getHasFocus() !== nextProps.editorState.getSelection().getHasFocus();
	  };
	
	  DraftEditorPlaceholder.prototype.render = function render() {
	    var hasFocus = this.props.editorState.getSelection().getHasFocus();
	
	    var className = cx({
	      'public/DraftEditorPlaceholder/root': true,
	      'public/DraftEditorPlaceholder/hasFocus': hasFocus
	    });
	
	    var contentStyle = {
	      whiteSpace: 'pre-wrap'
	    };
	
	    return React.createElement(
	      'div',
	      { className: className },
	      React.createElement(
	        'div',
	        {
	          className: cx('public/DraftEditorPlaceholder/inner'),
	          id: this.props.accessibilityID,
	          style: contentStyle },
	        this.props.text
	      )
	    );
	  };
	
	  return DraftEditorPlaceholder;
	}(React.Component);
	
	module.exports = DraftEditorPlaceholder;

/***/ },
/* 2144 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEditorTextNode.react
	 * @format
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var React = __webpack_require__(1);
	var ReactDOM = __webpack_require__(23);
	var UserAgent = __webpack_require__(142);
	
	var invariant = __webpack_require__(18);
	
	// In IE, spans with <br> tags render as two newlines. By rendering a span
	// with only a newline character, we can be sure to render a single line.
	var useNewlineChar = UserAgent.isBrowser('IE <= 11');
	
	/**
	 * Check whether the node should be considered a newline.
	 */
	function isNewline(node) {
	  return useNewlineChar ? node.textContent === '\n' : node.tagName === 'BR';
	}
	
	/**
	 * Placeholder elements for empty text content.
	 *
	 * What is this `data-text` attribute, anyway? It turns out that we need to
	 * put an attribute on the lowest-level text node in order to preserve correct
	 * spellcheck handling. If the <span> is naked, Chrome and Safari may do
	 * bizarre things to do the DOM -- split text nodes, create extra spans, etc.
	 * If the <span> has an attribute, this appears not to happen.
	 * See http://jsfiddle.net/9khdavod/ for the failure case, and
	 * http://jsfiddle.net/7pg143f7/ for the fixed case.
	 */
	var NEWLINE_A = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'A', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'A', 'data-text': 'true' });
	
	var NEWLINE_B = useNewlineChar ? React.createElement(
	  'span',
	  { key: 'B', 'data-text': 'true' },
	  '\n'
	) : React.createElement('br', { key: 'B', 'data-text': 'true' });
	
	/**
	 * The lowest-level component in a `DraftEditor`, the text node component
	 * replaces the default React text node implementation. This allows us to
	 * perform custom handling of newline behavior and avoid re-rendering text
	 * nodes with DOM state that already matches the expectations of our immutable
	 * editor state.
	 */
	var DraftEditorTextNode = function (_React$Component) {
	  _inherits(DraftEditorTextNode, _React$Component);
	
	  function DraftEditorTextNode(props) {
	    _classCallCheck(this, DraftEditorTextNode);
	
	    // By flipping this flag, we also keep flipping keys which forces
	    // React to remount this node every time it rerenders.
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this._forceFlag = false;
	    return _this;
	  }
	
	  DraftEditorTextNode.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	    var node = ReactDOM.findDOMNode(this);
	    var shouldBeNewline = nextProps.children === '';
	    !(node instanceof Element) ?  false ? invariant(false, 'node is not an Element') : invariant(false) : void 0;
	    if (shouldBeNewline) {
	      return !isNewline(node);
	    }
	    return node.textContent !== nextProps.children;
	  };
	
	  DraftEditorTextNode.prototype.componentDidMount = function componentDidMount() {
	    this._forceFlag = !this._forceFlag;
	  };
	
	  DraftEditorTextNode.prototype.componentDidUpdate = function componentDidUpdate() {
	    this._forceFlag = !this._forceFlag;
	  };
	
	  DraftEditorTextNode.prototype.render = function render() {
	    if (this.props.children === '') {
	      return this._forceFlag ? NEWLINE_A : NEWLINE_B;
	    }
	    return React.createElement(
	      'span',
	      { key: this._forceFlag ? 'A' : 'B', 'data-text': 'true' },
	      this.props.children
	    );
	  };
	
	  return DraftEditorTextNode;
	}(React.Component);
	
	module.exports = DraftEditorTextNode;

/***/ },
/* 2145 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftEntitySegments
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Identify the range to delete from a segmented entity.
	 *
	 * Rules:
	 *
	 *  Example: 'John F. Kennedy'
	 *
	 *   - Deletion from within any non-whitespace (i.e. ['John', 'F.', 'Kennedy'])
	 *     will return the range of that text.
	 *
	 *       'John F. Kennedy' -> 'John F.'
	 *                  ^
	 *
	 *   - Forward deletion of whitespace will remove the following section:
	 *
	 *       'John F. Kennedy' -> 'John Kennedy'
	 *            ^
	 *
	 *   - Backward deletion of whitespace will remove the previous section:
	 *
	 *       'John F. Kennedy' -> 'F. Kennedy'
	 *            ^
	 */
	var DraftEntitySegments = {
	  getRemovalRange: function getRemovalRange(selectionStart, selectionEnd, text, entityStart, direction) {
	    var segments = text.split(' ');
	    segments = segments.map(function ( /*string*/segment, /*number*/ii) {
	      if (direction === 'forward') {
	        if (ii > 0) {
	          return ' ' + segment;
	        }
	      } else if (ii < segments.length - 1) {
	        return segment + ' ';
	      }
	      return segment;
	    });
	
	    var segmentStart = entityStart;
	    var segmentEnd;
	    var segment;
	    var removalStart = null;
	    var removalEnd = null;
	
	    for (var jj = 0; jj < segments.length; jj++) {
	      segment = segments[jj];
	      segmentEnd = segmentStart + segment.length;
	
	      // Our selection overlaps this segment.
	      if (selectionStart < segmentEnd && segmentStart < selectionEnd) {
	        if (removalStart !== null) {
	          removalEnd = segmentEnd;
	        } else {
	          removalStart = segmentStart;
	          removalEnd = segmentEnd;
	        }
	      } else if (removalStart !== null) {
	        break;
	      }
	
	      segmentStart = segmentEnd;
	    }
	
	    var entityEnd = entityStart + text.length;
	    var atStart = removalStart === entityStart;
	    var atEnd = removalEnd === entityEnd;
	
	    if (!atStart && atEnd || atStart && !atEnd) {
	      if (direction === 'forward') {
	        if (removalEnd !== entityEnd) {
	          removalEnd++;
	        }
	      } else if (removalStart !== entityStart) {
	        removalStart--;
	      }
	    }
	
	    return {
	      start: removalStart,
	      end: removalEnd
	    };
	  }
	};
	
	module.exports = DraftEntitySegments;

/***/ },
/* 2146 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftFeatureFlags-core
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = {
	  draft_killswitch_allow_nontextnodes: false,
	  draft_segmented_entities_behavior: false,
	  draft_handlebeforeinput_composed_text: false,
	  draft_tree_data_support: false
	};
	
	module.exports = DraftFeatureFlags;

/***/ },
/* 2147 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftJsDebugLogging
	 */
	
	'use strict';
	
	module.exports = {
	  logSelectionStateFailure: function logSelectionStateFailure() {
	    return null;
	  }
	};

/***/ },
/* 2148 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftPasteProcessor
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var CharacterMetadata = __webpack_require__(100);
	var ContentBlock = __webpack_require__(208);
	var ContentBlockNode = __webpack_require__(108);
	var DraftFeatureFlags = __webpack_require__(176);
	var Immutable = __webpack_require__(39);
	
	var convertFromHTMLtoContentBlocks = __webpack_require__(802);
	var generateRandomKey = __webpack_require__(158);
	var getSafeBodyFromHTML = __webpack_require__(808);
	var sanitizeDraftText = __webpack_require__(494);
	
	var List = Immutable.List,
	    Repeat = Immutable.Repeat;
	
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	var ContentBlockRecord = experimentalTreeDataSupport ? ContentBlockNode : ContentBlock;
	
	var DraftPasteProcessor = {
	  processHTML: function processHTML(html, blockRenderMap) {
	    return convertFromHTMLtoContentBlocks(html, getSafeBodyFromHTML, blockRenderMap);
	  },
	  processText: function processText(textBlocks, character, type) {
	    return textBlocks.reduce(function (acc, textLine, index) {
	      textLine = sanitizeDraftText(textLine);
	      var key = generateRandomKey();
	
	      var blockNodeConfig = {
	        key: key,
	        type: type,
	        text: textLine,
	        characterList: List(Repeat(character, textLine.length))
	      };
	
	      // next block updates previous block
	      if (experimentalTreeDataSupport && index !== 0) {
	        var prevSiblingIndex = index - 1;
	        // update previous block
	        var previousBlock = acc[prevSiblingIndex] = acc[prevSiblingIndex].merge({
	          nextSibling: key
	        });
	        blockNodeConfig = _extends({}, blockNodeConfig, {
	          prevSibling: previousBlock.getKey()
	        });
	      }
	
	      acc.push(new ContentBlockRecord(blockNodeConfig));
	
	      return acc;
	    }, []);
	  }
	};
	
	module.exports = DraftPasteProcessor;

/***/ },
/* 2149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule DraftTreeAdapter
	 * @format
	 * 
	 *
	 * This is unstable and not part of the public API and should not be used by
	 * production systems. This file may be update/removed without notice.
	 */
	
	var invariant = __webpack_require__(18);
	
	var traverseInDepthOrder = function traverseInDepthOrder(blocks, fn) {
	  var stack = [].concat(blocks).reverse();
	  while (stack.length) {
	    var _block = stack.pop();
	
	    fn(_block);
	
	    var children = _block.children;
	
	    !Array.isArray(children) ?  false ? invariant(false, 'Invalid tree raw block') : invariant(false) : void 0;
	
	    stack = stack.concat([].concat(children.reverse()));
	  }
	};
	
	var isListBlock = function isListBlock(block) {
	  if (!(block && block.type)) {
	    return false;
	  }
	  var type = block.type;
	
	  return type === 'unordered-list-item' || type === 'ordered-list-item';
	};
	
	var addDepthToChildren = function addDepthToChildren(block) {
	  if (Array.isArray(block.children)) {
	    block.children = block.children.map(function (child) {
	      return child.type === block.type ? _extends({}, child, { depth: (block.depth || 0) + 1 }) : child;
	    });
	  }
	};
	
	/**
	 * This adapter is intended to be be used as an adapter to draft tree data
	 *
	 * draft state <=====> draft tree state
	 */
	var DraftTreeAdapter = {
	  /**
	   * Converts from a tree raw state back to  draft raw state
	   */
	  fromRawTreeStateToRawState: function fromRawTreeStateToRawState(draftTreeState) {
	    var blocks = draftTreeState.blocks;
	
	    var transformedBlocks = [];
	
	    !Array.isArray(blocks) ?  false ? invariant(false, 'Invalid raw state') : invariant(false) : void 0;
	
	    if (!Array.isArray(blocks) || !blocks.length) {
	      return draftTreeState;
	    }
	
	    traverseInDepthOrder(blocks, function (block) {
	      var newBlock = _extends({}, block);
	
	      if (isListBlock(block)) {
	        newBlock.depth = newBlock.depth || 0;
	        addDepthToChildren(block);
	      }
	
	      delete newBlock.children;
	
	      transformedBlocks.push(newBlock);
	    });
	
	    draftTreeState.blocks = transformedBlocks;
	
	    return _extends({}, draftTreeState, {
	      blocks: transformedBlocks
	    });
	  },
	
	
	  /**
	   * Converts from draft raw state to tree draft state
	   */
	  fromRawStateToRawTreeState: function fromRawStateToRawTreeState(draftState) {
	    var lastListDepthCacheRef = {};
	    var transformedBlocks = [];
	
	    draftState.blocks.forEach(function (block) {
	      var isList = isListBlock(block);
	      var depth = block.depth || 0;
	      var treeBlock = _extends({}, block, {
	        children: []
	      });
	
	      if (!isList) {
	        // reset the cache path
	        lastListDepthCacheRef = {};
	        transformedBlocks.push(treeBlock);
	        return;
	      }
	
	      // update our depth cache reference path
	      lastListDepthCacheRef[depth] = treeBlock;
	
	      // if we are greater than zero we must have seen a parent already
	      if (depth > 0) {
	        var parent = lastListDepthCacheRef[depth - 1];
	
	        !parent ?  false ? invariant(false, 'Invalid depth for RawDraftContentBlock') : invariant(false) : void 0;
	
	        // push nested list blocks
	        parent.children.push(treeBlock);
	        return;
	      }
	
	      // push root list blocks
	      transformedBlocks.push(treeBlock);
	    });
	
	    return _extends({}, draftState, {
	      blocks: transformedBlocks
	    });
	  }
	};
	
	module.exports = DraftTreeAdapter;

/***/ },
/* 2150 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule EditorBidiService
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(39);
	var UnicodeBidiService = __webpack_require__(2465);
	
	var nullthrows = __webpack_require__(123);
	
	var OrderedMap = Immutable.OrderedMap;
	
	
	var bidiService;
	
	var EditorBidiService = {
	  getDirectionMap: function getDirectionMap(content, prevBidiMap) {
	    if (!bidiService) {
	      bidiService = new UnicodeBidiService();
	    } else {
	      bidiService.reset();
	    }
	
	    var blockMap = content.getBlockMap();
	    var nextBidi = blockMap.valueSeq().map(function (block) {
	      return nullthrows(bidiService).getDirection(block.getText());
	    });
	    var bidiMap = OrderedMap(blockMap.keySeq().zip(nextBidi));
	
	    if (prevBidiMap != null && Immutable.is(prevBidiMap, bidiMap)) {
	      return prevBidiMap;
	    }
	
	    return bidiMap;
	  }
	};
	
	module.exports = EditorBidiService;

/***/ },
/* 2151 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule SecondaryClipboard
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(92);
	var EditorState = __webpack_require__(52);
	
	var getContentStateFragment = __webpack_require__(351);
	var nullthrows = __webpack_require__(123);
	
	var clipboard = null;
	
	/**
	 * Some systems offer a "secondary" clipboard to allow quick internal cut
	 * and paste behavior. For instance, Ctrl+K (cut) and Ctrl+Y (paste).
	 */
	var SecondaryClipboard = {
	  cut: function cut(editorState) {
	    var content = editorState.getCurrentContent();
	    var selection = editorState.getSelection();
	    var targetRange = null;
	
	    if (selection.isCollapsed()) {
	      var anchorKey = selection.getAnchorKey();
	      var blockEnd = content.getBlockForKey(anchorKey).getLength();
	
	      if (blockEnd === selection.getAnchorOffset()) {
	        return editorState;
	      }
	
	      targetRange = selection.set('focusOffset', blockEnd);
	    } else {
	      targetRange = selection;
	    }
	
	    targetRange = nullthrows(targetRange);
	    clipboard = getContentStateFragment(content, targetRange);
	
	    var afterRemoval = DraftModifier.removeRange(content, targetRange, 'forward');
	
	    if (afterRemoval === content) {
	      return editorState;
	    }
	
	    return EditorState.push(editorState, afterRemoval, 'remove-range');
	  },
	
	  paste: function paste(editorState) {
	    if (!clipboard) {
	      return editorState;
	    }
	
	    var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), clipboard);
	
	    return EditorState.push(editorState, newContent, 'insert-fragment');
	  }
	};
	
	module.exports = SecondaryClipboard;

/***/ },
/* 2152 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule adjustBlockDepthForContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	function adjustBlockDepthForContentState(contentState, selectionState, adjustment, maxDepth) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var blocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat([[endKey, blockMap.get(endKey)]]).map(function (block) {
	    var depth = block.getDepth() + adjustment;
	    depth = Math.max(0, Math.min(depth, maxDepth));
	    return block.set('depth', depth);
	  });
	
	  blockMap = blockMap.merge(blocks);
	
	  return contentState.merge({
	    blockMap: blockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = adjustBlockDepthForContentState;

/***/ },
/* 2153 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(100);
	
	function applyEntityToContentBlock(contentBlock, start, end, entityKey) {
	  var characterList = contentBlock.getCharacterList();
	  while (start < end) {
	    characterList = characterList.set(start, CharacterMetadata.applyEntity(characterList.get(start), entityKey));
	    start++;
	  }
	  return contentBlock.set('characterList', characterList);
	}
	
	module.exports = applyEntityToContentBlock;

/***/ },
/* 2154 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule applyEntityToContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(39);
	
	var applyEntityToContentBlock = __webpack_require__(2153);
	
	function applyEntityToContentState(contentState, selectionState, entityKey) {
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var newBlocks = blockMap.skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).toOrderedMap().merge(Immutable.OrderedMap([[endKey, blockMap.get(endKey)]])).map(function (block, blockKey) {
	    var sliceStart = blockKey === startKey ? startOffset : 0;
	    var sliceEnd = blockKey === endKey ? endOffset : block.getLength();
	    return applyEntityToContentBlock(block, sliceStart, sliceEnd, entityKey);
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = applyEntityToContentState;

/***/ },
/* 2155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromDraftStateToRaw
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ContentBlock = __webpack_require__(208);
	var ContentBlockNode = __webpack_require__(108);
	var DraftStringKey = __webpack_require__(800);
	
	var encodeEntityRanges = __webpack_require__(2172);
	var encodeInlineStyleRanges = __webpack_require__(2173);
	var invariant = __webpack_require__(18);
	
	var createRawBlock = function createRawBlock(block, entityStorageMap) {
	  return {
	    key: block.getKey(),
	    text: block.getText(),
	    type: block.getType(),
	    depth: block.getDepth(),
	    inlineStyleRanges: encodeInlineStyleRanges(block),
	    entityRanges: encodeEntityRanges(block, entityStorageMap),
	    data: block.getData().toObject()
	  };
	};
	
	var insertRawBlock = function insertRawBlock(block, entityMap, rawBlocks, blockCacheRef) {
	  if (block instanceof ContentBlock) {
	    rawBlocks.push(createRawBlock(block, entityMap));
	    return;
	  }
	
	  !(block instanceof ContentBlockNode) ?  false ? invariant(false, 'block is not a BlockNode') : invariant(false) : void 0;
	
	  var parentKey = block.getParentKey();
	  var rawBlock = blockCacheRef[block.getKey()] = _extends({}, createRawBlock(block, entityMap), {
	    children: []
	  });
	
	  if (parentKey) {
	    blockCacheRef[parentKey].children.push(rawBlock);
	    return;
	  }
	
	  rawBlocks.push(rawBlock);
	};
	
	var encodeRawBlocks = function encodeRawBlocks(contentState, rawState) {
	  var entityMap = rawState.entityMap;
	
	
	  var rawBlocks = [];
	
	  var blockCacheRef = {};
	  var entityCacheRef = {};
	  var entityStorageKey = 0;
	
	  contentState.getBlockMap().forEach(function (block) {
	    block.findEntityRanges(function (character) {
	      return character.getEntity() !== null;
	    }, function (start) {
	      var entityKey = block.getEntityAt(start);
	      // Stringify to maintain order of otherwise numeric keys.
	      var stringifiedEntityKey = DraftStringKey.stringify(entityKey);
	      // This makes this function resilient to two entities
	      // erroneously having the same key
	      if (entityCacheRef[stringifiedEntityKey]) {
	        return;
	      }
	      entityCacheRef[stringifiedEntityKey] = entityKey;
	      // we need the `any` casting here since this is a temporary state
	      // where we will later on flip the entity map and populate it with
	      // real entity, at this stage we just need to map back the entity
	      // key used by the BlockNode
	      entityMap[stringifiedEntityKey] = '' + entityStorageKey;
	      entityStorageKey++;
	    });
	
	    insertRawBlock(block, entityMap, rawBlocks, blockCacheRef);
	  });
	
	  return {
	    blocks: rawBlocks,
	    entityMap: entityMap
	  };
	};
	
	// Flip storage map so that our storage keys map to global
	// DraftEntity keys.
	var encodeRawEntityMap = function encodeRawEntityMap(contentState, rawState) {
	  var blocks = rawState.blocks,
	      entityMap = rawState.entityMap;
	
	
	  var rawEntityMap = {};
	
	  Object.keys(entityMap).forEach(function (key, index) {
	    var entity = contentState.getEntity(DraftStringKey.unstringify(key));
	    rawEntityMap[index] = {
	      type: entity.getType(),
	      mutability: entity.getMutability(),
	      data: entity.getData()
	    };
	  });
	
	  return {
	    blocks: blocks,
	    entityMap: rawEntityMap
	  };
	};
	
	var convertFromDraftStateToRaw = function convertFromDraftStateToRaw(contentState) {
	  var rawDraftContentState = {
	    entityMap: {},
	    blocks: []
	  };
	
	  // add blocks
	  rawDraftContentState = encodeRawBlocks(contentState, rawDraftContentState);
	
	  // add entities
	  rawDraftContentState = encodeRawEntityMap(contentState, rawDraftContentState);
	
	  return rawDraftContentState;
	};
	
	module.exports = convertFromDraftStateToRaw;

/***/ },
/* 2156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule convertFromRawToDraftState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var _extends = _assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var ContentBlock = __webpack_require__(208);
	var ContentBlockNode = __webpack_require__(108);
	var ContentState = __webpack_require__(488);
	var DraftEntity = __webpack_require__(350);
	var DraftFeatureFlags = __webpack_require__(176);
	var DraftTreeAdapter = __webpack_require__(2149);
	var Immutable = __webpack_require__(39);
	var SelectionState = __webpack_require__(244);
	
	var createCharacterList = __webpack_require__(2157);
	var decodeEntityRanges = __webpack_require__(2158);
	var decodeInlineStyleRanges = __webpack_require__(2159);
	var generateRandomKey = __webpack_require__(158);
	var invariant = __webpack_require__(18);
	
	var experimentalTreeDataSupport = DraftFeatureFlags.draft_tree_data_support;
	
	var List = Immutable.List,
	    Map = Immutable.Map,
	    OrderedMap = Immutable.OrderedMap;
	
	
	var decodeBlockNodeConfig = function decodeBlockNodeConfig(block, entityMap) {
	  var key = block.key,
	      type = block.type,
	      data = block.data,
	      text = block.text,
	      depth = block.depth;
	
	
	  var blockNodeConfig = {
	    text: text,
	    depth: depth || 0,
	    type: type || 'unstyled',
	    key: key || generateRandomKey(),
	    data: Map(data),
	    characterList: decodeCharacterList(block, entityMap)
	  };
	
	  return blockNodeConfig;
	};
	
	var decodeCharacterList = function decodeCharacterList(block, entityMap) {
	  var text = block.text,
	      rawEntityRanges = block.entityRanges,
	      rawInlineStyleRanges = block.inlineStyleRanges;
	
	
	  var entityRanges = rawEntityRanges || [];
	  var inlineStyleRanges = rawInlineStyleRanges || [];
	
	  // Translate entity range keys to the DraftEntity map.
	  return createCharacterList(decodeInlineStyleRanges(text, inlineStyleRanges), decodeEntityRanges(text, entityRanges.filter(function (range) {
	    return entityMap.hasOwnProperty(range.key);
	  }).map(function (range) {
	    return _extends({}, range, { key: entityMap[range.key] });
	  })));
	};
	
	var addKeyIfMissing = function addKeyIfMissing(block) {
	  return _extends({}, block, {
	    key: block.key || generateRandomKey()
	  });
	};
	
	/**
	 * Node stack is responsible to ensure we traverse the tree only once
	 * in depth order, while also providing parent refs to inner nodes to
	 * construct their links.
	 */
	var updateNodeStack = function updateNodeStack(stack, nodes, parentRef) {
	  var nodesWithParentRef = nodes.map(function (block) {
	    return _extends({}, block, {
	      parentRef: parentRef
	    });
	  });
	
	  // since we pop nodes from the stack we need to insert them in reverse
	  return stack.concat(nodesWithParentRef.reverse());
	};
	
	/**
	 * This will build a tree draft content state by creating the node
	 * reference links into a single tree walk. Each node has a link
	 * reference to "parent", "children", "nextSibling" and "prevSibling"
	 * blockMap will be created using depth ordering.
	 */
	var decodeContentBlockNodes = function decodeContentBlockNodes(blocks, entityMap) {
	  return blocks
	  // ensure children have valid keys to enable sibling links
	  .map(addKeyIfMissing).reduce(function (blockMap, block, index) {
	    !Array.isArray(block.children) ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
	
	    // ensure children have valid keys to enable sibling links
	    var children = block.children.map(addKeyIfMissing);
	
	    // root level nodes
	    var contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(block, entityMap), {
	      prevSibling: index === 0 ? null : blocks[index - 1].key,
	      nextSibling: index === blocks.length - 1 ? null : blocks[index + 1].key,
	      children: List(children.map(function (child) {
	        return child.key;
	      }))
	    }));
	
	    // push root node to blockMap
	    blockMap = blockMap.set(contentBlockNode.getKey(), contentBlockNode);
	
	    // this stack is used to ensure we visit all nodes respecting depth ordering
	    var stack = updateNodeStack([], children, contentBlockNode);
	
	    // start computing children nodes
	    while (stack.length > 0) {
	      // we pop from the stack and start processing this node
	      var node = stack.pop();
	
	      // parentRef already points to a converted ContentBlockNode
	      var parentRef = node.parentRef;
	      var siblings = parentRef.getChildKeys();
	      var _index = siblings.indexOf(node.key);
	      var isValidBlock = Array.isArray(node.children);
	
	      if (!isValidBlock) {
	        !isValidBlock ?  false ? invariant(false, 'invalid RawDraftContentBlock can not be converted to ContentBlockNode') : invariant(false) : void 0;
	        break;
	      }
	
	      // ensure children have valid keys to enable sibling links
	      var _children = node.children.map(addKeyIfMissing);
	
	      var _contentBlockNode = new ContentBlockNode(_extends({}, decodeBlockNodeConfig(node, entityMap), {
	        parent: parentRef.getKey(),
	        children: List(_children.map(function (child) {
	          return child.key;
	        })),
	        prevSibling: _index === 0 ? null : siblings.get(_index - 1),
	        nextSibling: _index === siblings.size - 1 ? null : siblings.get(_index + 1)
	      }));
	
	      // push node to blockMap
	      blockMap = blockMap.set(_contentBlockNode.getKey(), _contentBlockNode);
	
	      // this stack is used to ensure we visit all nodes respecting depth ordering
	      stack = updateNodeStack(stack, _children, _contentBlockNode);
	    }
	
	    return blockMap;
	  }, OrderedMap());
	};
	
	var decodeContentBlocks = function decodeContentBlocks(blocks, entityMap) {
	  return OrderedMap(blocks.map(function (block) {
	    var contentBlock = new ContentBlock(decodeBlockNodeConfig(block, entityMap));
	    return [contentBlock.getKey(), contentBlock];
	  }));
	};
	
	var decodeRawBlocks = function decodeRawBlocks(rawState, entityMap) {
	  var isTreeRawBlock = Array.isArray(rawState.blocks[0].children);
	  var rawBlocks = experimentalTreeDataSupport && !isTreeRawBlock ? DraftTreeAdapter.fromRawStateToRawTreeState(rawState).blocks : rawState.blocks;
	
	  if (!experimentalTreeDataSupport) {
	    return decodeContentBlocks(isTreeRawBlock ? DraftTreeAdapter.fromRawTreeStateToRawState(rawState).blocks : rawBlocks, entityMap);
	  }
	
	  return decodeContentBlockNodes(rawBlocks, entityMap);
	};
	
	var decodeRawEntityMap = function decodeRawEntityMap(rawState) {
	  var rawEntityMap = rawState.entityMap;
	
	  var entityMap = {};
	
	  // TODO: Update this once we completely remove DraftEntity
	  Object.keys(rawEntityMap).forEach(function (rawEntityKey) {
	    var _rawEntityMap$rawEnti = rawEntityMap[rawEntityKey],
	        type = _rawEntityMap$rawEnti.type,
	        mutability = _rawEntityMap$rawEnti.mutability,
	        data = _rawEntityMap$rawEnti.data;
	
	    // get the key reference to created entity
	
	    entityMap[rawEntityKey] = DraftEntity.__create(type, mutability, data || {});
	  });
	
	  return entityMap;
	};
	
	var convertFromRawToDraftState = function convertFromRawToDraftState(rawState) {
	  !Array.isArray(rawState.blocks) ?  false ? invariant(false, 'invalid RawDraftContentState') : invariant(false) : void 0;
	
	  // decode entities
	  var entityMap = decodeRawEntityMap(rawState);
	
	  // decode blockMap
	  var blockMap = decodeRawBlocks(rawState, entityMap);
	
	  // create initial selection
	  var selectionState = blockMap.isEmpty() ? new SelectionState() : SelectionState.createEmpty(blockMap.first().getKey());
	
	  return new ContentState({
	    blockMap: blockMap,
	    entityMap: entityMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	};
	
	module.exports = convertFromRawToDraftState;

/***/ },
/* 2157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule createCharacterList
	 * @format
	 * 
	 */
	
	'use strict';
	
	var CharacterMetadata = __webpack_require__(100);
	var Immutable = __webpack_require__(39);
	
	var List = Immutable.List;
	
	
	function createCharacterList(inlineStyles, entities) {
	  var characterArray = inlineStyles.map(function (style, ii) {
	    var entity = entities[ii];
	    return CharacterMetadata.create({ style: style, entity: entity });
	  });
	  return List(characterArray);
	}
	
	module.exports = createCharacterList;

/***/ },
/* 2158 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeEntityRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(215);
	
	var substr = UnicodeUtils.substr;
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	
	function decodeEntityRanges(text, ranges) {
	  var entities = Array(text.length).fill(null);
	  if (ranges) {
	    ranges.forEach(function (range) {
	      // Using Unicode-enabled substrings converted to JavaScript lengths,
	      // fill the output array with entity keys.
	      var start = substr(text, 0, range.offset).length;
	      var end = start + substr(text, range.offset, range.length).length;
	      for (var ii = start; ii < end; ii++) {
	        entities[ii] = range.key;
	      }
	    });
	  }
	  return entities;
	}
	
	module.exports = decodeEntityRanges;

/***/ },
/* 2159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule decodeInlineStyleRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var _require = __webpack_require__(39),
	    OrderedSet = _require.OrderedSet;
	
	var UnicodeUtils = __webpack_require__(215);
	
	var substr = UnicodeUtils.substr;
	
	
	var EMPTY_SET = OrderedSet();
	
	/**
	 * Convert to native JavaScript string lengths to determine ranges.
	 */
	function decodeInlineStyleRanges(text, ranges) {
	  var styles = Array(text.length).fill(EMPTY_SET);
	  if (ranges) {
	    ranges.forEach(function ( /*object*/range) {
	      var cursor = substr(text, 0, range.offset).length;
	      var end = cursor + substr(text, range.offset, range.length).length;
	      while (cursor < end) {
	        styles[cursor] = styles[cursor].add(range.style);
	        cursor++;
	      }
	    });
	  }
	  return styles;
	}
	
	module.exports = decodeInlineStyleRanges;

/***/ },
/* 2160 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBeforeInput
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockTree = __webpack_require__(795);
	var DraftModifier = __webpack_require__(92);
	var EditorState = __webpack_require__(52);
	var UserAgent = __webpack_require__(142);
	
	var getEntityKeyForSelection = __webpack_require__(492);
	var isEventHandled = __webpack_require__(285);
	var isSelectionAtLeafStart = __webpack_require__(813);
	var nullthrows = __webpack_require__(123);
	var setImmediate = __webpack_require__(2481);
	
	// When nothing is focused, Firefox regards two characters, `'` and `/`, as
	// commands that should open and focus the "quickfind" search bar. This should
	// *never* happen while a contenteditable is focused, but as of v28, it
	// sometimes does, even when the keypress event target is the contenteditable.
	// This breaks the input. Special case these characters to ensure that when
	// they are typed, we prevent default on the event to make sure not to
	// trigger quickfind.
	var FF_QUICKFIND_CHAR = "'";
	var FF_QUICKFIND_LINK_CHAR = '/';
	var isFirefox = UserAgent.isBrowser('Firefox');
	
	function mustPreventDefaultForCharacter(character) {
	  return isFirefox && (character == FF_QUICKFIND_CHAR || character == FF_QUICKFIND_LINK_CHAR);
	}
	
	/**
	 * Replace the current selection with the specified text string, with the
	 * inline style and entity key applied to the newly inserted text.
	 */
	function replaceText(editorState, text, inlineStyle, entityKey) {
	  var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), text, inlineStyle, entityKey);
	  return EditorState.push(editorState, contentState, 'insert-characters');
	}
	
	/**
	 * When `onBeforeInput` executes, the browser is attempting to insert a
	 * character into the editor. Apply this character data to the document,
	 * allowing native insertion if possible.
	 *
	 * Native insertion is encouraged in order to limit re-rendering and to
	 * preserve spellcheck highlighting, which disappears or flashes if re-render
	 * occurs on the relevant text nodes.
	 */
	function editOnBeforeInput(editor, e) {
	  if (editor._pendingStateFromBeforeInput !== undefined) {
	    editor.update(editor._pendingStateFromBeforeInput);
	    editor._pendingStateFromBeforeInput = undefined;
	  }
	
	  var editorState = editor._latestEditorState;
	
	  var chars = e.data;
	
	  // In some cases (ex: IE ideographic space insertion) no character data
	  // is provided. There's nothing to do when this happens.
	  if (!chars) {
	    return;
	  }
	
	  // Allow the top-level component to handle the insertion manually. This is
	  // useful when triggering interesting behaviors for a character insertion,
	  // Simple examples: replacing a raw text ':)' with a smile emoji or image
	  // decorator, or setting a block to be a list item after typing '- ' at the
	  // start of the block.
	  if (editor.props.handleBeforeInput && isEventHandled(editor.props.handleBeforeInput(chars, editorState))) {
	    e.preventDefault();
	    return;
	  }
	
	  // If selection is collapsed, conditionally allow native behavior. This
	  // reduces re-renders and preserves spellcheck highlighting. If the selection
	  // is not collapsed, we will re-render.
	  var selection = editorState.getSelection();
	  var selectionStart = selection.getStartOffset();
	  var selectionEnd = selection.getEndOffset();
	  var anchorKey = selection.getAnchorKey();
	
	  if (!selection.isCollapsed()) {
	    e.preventDefault();
	
	    // If the currently selected text matches what the user is trying to
	    // replace it with, let's just update the `SelectionState`. If not, update
	    // the `ContentState` with the new text.
	    var currentlySelectedChars = editorState.getCurrentContent().getPlainText().slice(selectionStart, selectionEnd);
	    if (chars === currentlySelectedChars) {
	      editor.update(EditorState.forceSelection(editorState, selection.merge({
	        focusOffset: selectionEnd
	      })));
	    } else {
	      editor.update(replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())));
	    }
	    return;
	  }
	
	  var newEditorState = replaceText(editorState, chars, editorState.getCurrentInlineStyle(), getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection()));
	
	  // Bunch of different cases follow where we need to prevent native insertion.
	  var mustPreventNative = false;
	  if (!mustPreventNative) {
	    // Browsers tend to insert text in weird places in the DOM when typing at
	    // the start of a leaf, so we'll handle it ourselves.
	    mustPreventNative = isSelectionAtLeafStart(editor._latestCommittedEditorState);
	  }
	  if (!mustPreventNative) {
	    // Chrome will also split up a node into two pieces if it contains a Tab
	    // char, for no explicable reason. Seemingly caused by this commit:
	    // https://chromium.googlesource.com/chromium/src/+/013ac5eaf3%5E%21/
	    var nativeSelection = global.getSelection();
	    // Selection is necessarily collapsed at this point due to earlier check.
	    if (nativeSelection.anchorNode && nativeSelection.anchorNode.nodeType === Node.TEXT_NODE) {
	      // See isTabHTMLSpanElement in chromium EditingUtilities.cpp.
	      var parentNode = nativeSelection.anchorNode.parentNode;
	      mustPreventNative = parentNode.nodeName === 'SPAN' && parentNode.firstChild.nodeType === Node.TEXT_NODE && parentNode.firstChild.nodeValue.indexOf('\t') !== -1;
	    }
	  }
	  if (!mustPreventNative) {
	    // Check the old and new "fingerprints" of the current block to determine
	    // whether this insertion requires any addition or removal of text nodes,
	    // in which case we would prevent the native character insertion.
	    var originalFingerprint = BlockTree.getFingerprint(editorState.getBlockTree(anchorKey));
	    var newFingerprint = BlockTree.getFingerprint(newEditorState.getBlockTree(anchorKey));
	    mustPreventNative = originalFingerprint !== newFingerprint;
	  }
	  if (!mustPreventNative) {
	    mustPreventNative = mustPreventDefaultForCharacter(chars);
	  }
	  if (!mustPreventNative) {
	    mustPreventNative = nullthrows(newEditorState.getDirectionMap()).get(anchorKey) !== nullthrows(editorState.getDirectionMap()).get(anchorKey);
	  }
	
	  if (mustPreventNative) {
	    e.preventDefault();
	    editor.update(newEditorState);
	    return;
	  }
	
	  // We made it all the way! Let the browser do its thing and insert the char.
	  newEditorState = EditorState.set(newEditorState, {
	    nativelyRenderedContent: newEditorState.getCurrentContent()
	  });
	  // The native event is allowed to occur. To allow user onChange handlers to
	  // change the inserted text, we wait until the text is actually inserted
	  // before we actually update our state. That way when we rerender, the text
	  // we see in the DOM will already have been inserted properly.
	  editor._pendingStateFromBeforeInput = newEditorState;
	  setImmediate(function () {
	    if (editor._pendingStateFromBeforeInput !== undefined) {
	      editor.update(editor._pendingStateFromBeforeInput);
	      editor._pendingStateFromBeforeInput = undefined;
	    }
	  });
	}
	
	module.exports = editOnBeforeInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2161 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnBlur
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(52);
	
	var containsNode = __webpack_require__(365);
	var getActiveElement = __webpack_require__(366);
	
	function editOnBlur(editor, e) {
	  // In a contentEditable element, when you select a range and then click
	  // another active element, this does trigger a `blur` event but will not
	  // remove the DOM selection from the contenteditable.
	  // This is consistent across all browsers, but we prefer that the editor
	  // behave like a textarea, where a `blur` event clears the DOM selection.
	  // We therefore force the issue to be certain, checking whether the active
	  // element is `body` to force it when blurring occurs within the window (as
	  // opposed to clicking to another tab or window).
	  if (getActiveElement() === document.body) {
	    var _selection = global.getSelection();
	    var editorNode = editor.editor;
	    if (_selection.rangeCount === 1 && containsNode(editorNode, _selection.anchorNode) && containsNode(editorNode, _selection.focusNode)) {
	      _selection.removeAllRanges();
	    }
	  }
	
	  var editorState = editor._latestEditorState;
	  var currentSelection = editorState.getSelection();
	  if (!currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', false);
	  editor.props.onBlur && editor.props.onBlur(e);
	  editor.update(EditorState.acceptSelection(editorState, selection));
	}
	
	module.exports = editOnBlur;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2162 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCompositionStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(52);
	
	/**
	 * The user has begun using an IME input system. Switching to `composite` mode
	 * allows handling composition input and disables other edit behavior.
	 */
	function editOnCompositionStart(editor, e) {
	  editor.setMode('composite');
	  editor.update(EditorState.set(editor._latestEditorState, { inCompositionMode: true }));
	  // Allow composition handler to interpret the compositionstart event
	  editor._onCompositionStart(e);
	}
	
	module.exports = editOnCompositionStart;

/***/ },
/* 2163 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCopy
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getFragmentFromSelection = __webpack_require__(805);
	
	/**
	 * If we have a selection, create a ContentState fragment and store
	 * it in our internal clipboard. Subsequent paste events will use this
	 * fragment if no external clipboard data is supplied.
	 */
	function editOnCopy(editor, e) {
	  var editorState = editor._latestEditorState;
	  var selection = editorState.getSelection();
	
	  // No selection, so there's nothing to copy.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  editor.setClipboard(getFragmentFromSelection(editor._latestEditorState));
	}
	
	module.exports = editOnCopy;

/***/ },
/* 2164 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnCut
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(92);
	var EditorState = __webpack_require__(52);
	var Style = __webpack_require__(520);
	
	var getFragmentFromSelection = __webpack_require__(805);
	var getScrollPosition = __webpack_require__(523);
	
	/**
	 * On `cut` events, native behavior is allowed to occur so that the system
	 * clipboard is set properly. This means that we need to take steps to recover
	 * the editor DOM state after the `cut` has occurred in order to maintain
	 * control of the component.
	 *
	 * In addition, we can keep a copy of the removed fragment, including all
	 * styles and entities, for use as an internal paste.
	 */
	function editOnCut(editor, e) {
	  var editorState = editor._latestEditorState;
	  var selection = editorState.getSelection();
	  var element = e.target;
	  var scrollPosition = void 0;
	
	  // No selection, so there's nothing to cut.
	  if (selection.isCollapsed()) {
	    e.preventDefault();
	    return;
	  }
	
	  // Track the current scroll position so that it can be forced back in place
	  // after the editor regains control of the DOM.
	  if (element instanceof Node) {
	    scrollPosition = getScrollPosition(Style.getScrollParent(element));
	  }
	
	  var fragment = getFragmentFromSelection(editorState);
	  editor.setClipboard(fragment);
	
	  // Set `cut` mode to disable all event handling temporarily.
	  editor.setMode('cut');
	
	  // Let native `cut` behavior occur, then recover control.
	  setTimeout(function () {
	    editor.restoreEditorDOM(scrollPosition);
	    editor.exitCurrentMode();
	    editor.update(removeFragment(editorState));
	  }, 0);
	}
	
	function removeFragment(editorState) {
	  var newContent = DraftModifier.removeRange(editorState.getCurrentContent(), editorState.getSelection(), 'forward');
	  return EditorState.push(editorState, newContent, 'remove-range');
	}
	
	module.exports = editOnCut;

/***/ },
/* 2165 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragOver
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * Drag behavior has begun from outside the editor element.
	 */
	function editOnDragOver(editor, e) {
	  editor._internalDrag = false;
	  editor.setMode('drag');
	  e.preventDefault();
	}
	
	module.exports = editOnDragOver;

/***/ },
/* 2166 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnDragStart
	 * @format
	 * 
	 */
	
	'use strict';
	
	/**
	 * A `dragstart` event has begun within the text editor component.
	 */
	function editOnDragStart(editor) {
	  editor._internalDrag = true;
	  editor.setMode('drag');
	}
	
	module.exports = editOnDragStart;

/***/ },
/* 2167 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnFocus
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(52);
	var UserAgent = __webpack_require__(142);
	
	function editOnFocus(editor, e) {
	  var editorState = editor._latestEditorState;
	  var currentSelection = editorState.getSelection();
	  if (currentSelection.getHasFocus()) {
	    return;
	  }
	
	  var selection = currentSelection.set('hasFocus', true);
	  editor.props.onFocus && editor.props.onFocus(e);
	
	  // When the tab containing this text editor is hidden and the user does a
	  // find-in-page in a _different_ tab, Chrome on Mac likes to forget what the
	  // selection was right after sending this focus event and (if you let it)
	  // moves the cursor back to the beginning of the editor, so we force the
	  // selection here instead of simply accepting it in order to preserve the
	  // old cursor position. See https://crbug.com/540004.
	  // But it looks like this is fixed in Chrome 60.0.3081.0.
	  // Other browsers also don't have this bug, so we prefer to acceptSelection
	  // when possible, to ensure that unfocusing and refocusing a Draft editor
	  // doesn't preserve the selection, matching how textareas work.
	  if (UserAgent.isBrowser('Chrome < 60.0.3081.0')) {
	    editor.update(EditorState.forceSelection(editorState, selection));
	  } else {
	    editor.update(EditorState.acceptSelection(editorState, selection));
	  }
	}
	
	module.exports = editOnFocus;

/***/ },
/* 2168 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnInput
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftFeatureFlags = __webpack_require__(176);
	var DraftModifier = __webpack_require__(92);
	var DraftOffsetKey = __webpack_require__(283);
	var EditorState = __webpack_require__(52);
	var UserAgent = __webpack_require__(142);
	
	var findAncestorOffsetKey = __webpack_require__(491);
	var nullthrows = __webpack_require__(123);
	
	var isGecko = UserAgent.isEngine('Gecko');
	
	var DOUBLE_NEWLINE = '\n\n';
	
	/**
	 * This function is intended to handle spellcheck and autocorrect changes,
	 * which occur in the DOM natively without any opportunity to observe or
	 * interpret the changes before they occur.
	 *
	 * The `input` event fires in contentEditable elements reliably for non-IE
	 * browsers, immediately after changes occur to the editor DOM. Since our other
	 * handlers override or otherwise handle cover other varieties of text input,
	 * the DOM state should match the model in all controlled input cases. Thus,
	 * when an `input` change leads to a DOM/model mismatch, the change should be
	 * due to a spellcheck change, and we can incorporate it into our model.
	 */
	function editOnInput(editor) {
	  if (editor._pendingStateFromBeforeInput !== undefined) {
	    editor.update(editor._pendingStateFromBeforeInput);
	    editor._pendingStateFromBeforeInput = undefined;
	  }
	
	  var domSelection = global.getSelection();
	
	  var anchorNode = domSelection.anchorNode,
	      isCollapsed = domSelection.isCollapsed;
	
	  var isNotTextNode = anchorNode.nodeType !== Node.TEXT_NODE;
	  var isNotTextOrElementNode = anchorNode.nodeType !== Node.TEXT_NODE && anchorNode.nodeType !== Node.ELEMENT_NODE;
	
	  if (DraftFeatureFlags.draft_killswitch_allow_nontextnodes) {
	    if (isNotTextNode) {
	      return;
	    }
	  } else {
	    if (isNotTextOrElementNode) {
	      // TODO: (t16149272) figure out context for this change
	      return;
	    }
	  }
	
	  if (anchorNode.nodeType === Node.TEXT_NODE && (anchorNode.previousSibling !== null || anchorNode.nextSibling !== null)) {
	    // When typing at the beginning of a visual line, Chrome splits the text
	    // nodes into two. Why? No one knows. This commit is suspicious:
	    // https://chromium.googlesource.com/chromium/src/+/a3b600981286b135632371477f902214c55a1724
	    // To work around, we'll merge the sibling text nodes back into this one.
	    var span = anchorNode.parentNode;
	    anchorNode.nodeValue = span.textContent;
	    for (var child = span.firstChild; child !== null; child = child.nextSibling) {
	      if (child !== anchorNode) {
	        span.removeChild(child);
	      }
	    }
	  }
	
	  var domText = anchorNode.textContent;
	  var editorState = editor._latestEditorState;
	  var offsetKey = nullthrows(findAncestorOffsetKey(anchorNode));
	
	  var _DraftOffsetKey$decod = DraftOffsetKey.decode(offsetKey),
	      blockKey = _DraftOffsetKey$decod.blockKey,
	      decoratorKey = _DraftOffsetKey$decod.decoratorKey,
	      leafKey = _DraftOffsetKey$decod.leafKey;
	
	  var _editorState$getBlock = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]),
	      start = _editorState$getBlock.start,
	      end = _editorState$getBlock.end;
	
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var modelText = block.getText().slice(start, end);
	
	  // Special-case soft newlines here. If the DOM text ends in a soft newline,
	  // we will have manually inserted an extra soft newline in DraftEditorLeaf.
	  // We want to remove this extra newline for the purpose of our comparison
	  // of DOM and model text.
	  if (domText.endsWith(DOUBLE_NEWLINE)) {
	    domText = domText.slice(0, -1);
	  }
	
	  // No change -- the DOM is up to date. Nothing to do here.
	  if (domText === modelText) {
	    // This can be buggy for some Android keyboards because they don't fire
	    // standard onkeydown/pressed events and only fired editOnInput
	    // so domText is already changed by the browser and ends up being equal
	    // to modelText unexpectedly
	    return;
	  }
	
	  var selection = editorState.getSelection();
	
	  // We'll replace the entire leaf with the text content of the target.
	  var targetRange = selection.merge({
	    anchorOffset: start,
	    focusOffset: end,
	    isBackward: false
	  });
	
	  var entityKey = block.getEntityAt(start);
	  var entity = entityKey && content.getEntity(entityKey);
	  var entityType = entity && entity.getMutability();
	  var preserveEntity = entityType === 'MUTABLE';
	
	  // Immutable or segmented entities cannot properly be handled by the
	  // default browser undo, so we have to use a different change type to
	  // force using our internal undo method instead of falling through to the
	  // native browser undo.
	  var changeType = preserveEntity ? 'spellcheck-change' : 'apply-entity';
	
	  var newContent = DraftModifier.replaceText(content, targetRange, domText, block.getInlineStyleAt(start), preserveEntity ? block.getEntityAt(start) : null);
	
	  var anchorOffset, focusOffset, startOffset, endOffset;
	
	  if (isGecko) {
	    // Firefox selection does not change while the context menu is open, so
	    // we preserve the anchor and focus values of the DOM selection.
	    anchorOffset = domSelection.anchorOffset;
	    focusOffset = domSelection.focusOffset;
	    startOffset = start + Math.min(anchorOffset, focusOffset);
	    endOffset = startOffset + Math.abs(anchorOffset - focusOffset);
	    anchorOffset = startOffset;
	    focusOffset = endOffset;
	  } else {
	    // Browsers other than Firefox may adjust DOM selection while the context
	    // menu is open, and Safari autocorrect is prone to providing an inaccurate
	    // DOM selection. Don't trust it. Instead, use our existing SelectionState
	    // and adjust it based on the number of characters changed during the
	    // mutation.
	    var charDelta = domText.length - modelText.length;
	    startOffset = selection.getStartOffset();
	    endOffset = selection.getEndOffset();
	
	    anchorOffset = isCollapsed ? endOffset + charDelta : startOffset;
	    focusOffset = endOffset + charDelta;
	  }
	
	  // Segmented entities are completely or partially removed when their
	  // text content changes. For this case we do not want any text to be selected
	  // after the change, so we are not merging the selection.
	  var contentWithAdjustedDOMSelection = newContent.merge({
	    selectionBefore: content.getSelectionAfter(),
	    selectionAfter: selection.merge({ anchorOffset: anchorOffset, focusOffset: focusOffset })
	  });
	
	  editor.update(EditorState.push(editorState, contentWithAdjustedDOMSelection, changeType));
	}
	
	module.exports = editOnInput;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2169 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnKeyDown
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(92);
	var EditorState = __webpack_require__(52);
	var KeyBindingUtil = __webpack_require__(490);
	var Keys = __webpack_require__(519);
	var SecondaryClipboard = __webpack_require__(2151);
	var UserAgent = __webpack_require__(142);
	
	var isEventHandled = __webpack_require__(285);
	var keyCommandBackspaceToStartOfLine = __webpack_require__(2182);
	var keyCommandBackspaceWord = __webpack_require__(2183);
	var keyCommandDeleteWord = __webpack_require__(2184);
	var keyCommandInsertNewline = __webpack_require__(2185);
	var keyCommandMoveSelectionToEndOfBlock = __webpack_require__(2186);
	var keyCommandMoveSelectionToStartOfBlock = __webpack_require__(2187);
	var keyCommandPlainBackspace = __webpack_require__(2188);
	var keyCommandPlainDelete = __webpack_require__(2189);
	var keyCommandTransposeCharacters = __webpack_require__(2190);
	var keyCommandUndo = __webpack_require__(2191);
	
	var isOptionKeyCommand = KeyBindingUtil.isOptionKeyCommand;
	
	var isChrome = UserAgent.isBrowser('Chrome');
	
	/**
	 * Map a `DraftEditorCommand` command value to a corresponding function.
	 */
	function onKeyCommand(command, editorState) {
	  switch (command) {
	    case 'redo':
	      return EditorState.redo(editorState);
	    case 'delete':
	      return keyCommandPlainDelete(editorState);
	    case 'delete-word':
	      return keyCommandDeleteWord(editorState);
	    case 'backspace':
	      return keyCommandPlainBackspace(editorState);
	    case 'backspace-word':
	      return keyCommandBackspaceWord(editorState);
	    case 'backspace-to-start-of-line':
	      return keyCommandBackspaceToStartOfLine(editorState);
	    case 'split-block':
	      return keyCommandInsertNewline(editorState);
	    case 'transpose-characters':
	      return keyCommandTransposeCharacters(editorState);
	    case 'move-selection-to-start-of-block':
	      return keyCommandMoveSelectionToStartOfBlock(editorState);
	    case 'move-selection-to-end-of-block':
	      return keyCommandMoveSelectionToEndOfBlock(editorState);
	    case 'secondary-cut':
	      return SecondaryClipboard.cut(editorState);
	    case 'secondary-paste':
	      return SecondaryClipboard.paste(editorState);
	    default:
	      return editorState;
	  }
	}
	
	/**
	 * Intercept keydown behavior to handle keys and commands manually, if desired.
	 *
	 * Keydown combinations may be mapped to `DraftCommand` values, which may
	 * correspond to command functions that modify the editor or its contents.
	 *
	 * See `getDefaultKeyBinding` for defaults. Alternatively, the top-level
	 * component may provide a custom mapping via the `keyBindingFn` prop.
	 */
	function editOnKeyDown(editor, e) {
	  var keyCode = e.which;
	  var editorState = editor._latestEditorState;
	
	  switch (keyCode) {
	    case Keys.RETURN:
	      e.preventDefault();
	      // The top-level component may manually handle newline insertion. If
	      // no special handling is performed, fall through to command handling.
	      if (editor.props.handleReturn && isEventHandled(editor.props.handleReturn(e, editorState))) {
	        return;
	      }
	      break;
	    case Keys.ESC:
	      e.preventDefault();
	      editor.props.onEscape && editor.props.onEscape(e);
	      return;
	    case Keys.TAB:
	      editor.props.onTab && editor.props.onTab(e);
	      return;
	    case Keys.UP:
	      editor.props.onUpArrow && editor.props.onUpArrow(e);
	      return;
	    case Keys.RIGHT:
	      editor.props.onRightArrow && editor.props.onRightArrow(e);
	      return;
	    case Keys.DOWN:
	      editor.props.onDownArrow && editor.props.onDownArrow(e);
	      return;
	    case Keys.LEFT:
	      editor.props.onLeftArrow && editor.props.onLeftArrow(e);
	      return;
	    case Keys.SPACE:
	      // Handling for OSX where option + space scrolls.
	      if (isChrome && isOptionKeyCommand(e)) {
	        e.preventDefault();
	        // Insert a nbsp into the editor.
	        var contentState = DraftModifier.replaceText(editorState.getCurrentContent(), editorState.getSelection(), '\xA0');
	        editor.update(EditorState.push(editorState, contentState, 'insert-characters'));
	        return;
	      }
	  }
	
	  var command = editor.props.keyBindingFn(e);
	
	  // If no command is specified, allow keydown event to continue.
	  if (!command) {
	    return;
	  }
	
	  if (command === 'undo') {
	    // Since undo requires some special updating behavior to keep the editor
	    // in sync, handle it separately.
	    keyCommandUndo(e, editorState, editor.update);
	    return;
	  }
	
	  // At this point, we know that we're handling a command of some kind, so
	  // we don't want to insert a character following the keydown.
	  e.preventDefault();
	
	  // Allow components higher up the tree to handle the command first.
	  if (editor.props.handleKeyCommand && isEventHandled(editor.props.handleKeyCommand(command, editorState))) {
	    return;
	  }
	
	  var newState = onKeyCommand(command, editorState);
	  if (newState !== editorState) {
	    editor.update(newState);
	  }
	}
	
	module.exports = editOnKeyDown;

/***/ },
/* 2170 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnPaste
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(282);
	var CharacterMetadata = __webpack_require__(100);
	var DataTransfer = __webpack_require__(881);
	var DraftModifier = __webpack_require__(92);
	var DraftPasteProcessor = __webpack_require__(2148);
	var EditorState = __webpack_require__(52);
	var RichTextEditorUtil = __webpack_require__(801);
	
	var getEntityKeyForSelection = __webpack_require__(492);
	var getTextContentFromFiles = __webpack_require__(810);
	var isEventHandled = __webpack_require__(285);
	var splitTextIntoTextBlocks = __webpack_require__(2197);
	
	/**
	 * Paste content.
	 */
	function editOnPaste(editor, e) {
	  e.preventDefault();
	  var data = new DataTransfer(e.clipboardData);
	
	  // Get files, unless this is likely to be a string the user wants inline.
	  if (!data.isRichText()) {
	    var files = data.getFiles();
	    var defaultFileText = data.getText();
	    if (files.length > 0) {
	      // Allow customized paste handling for images, etc. Otherwise, fall
	      // through to insert text contents into the editor.
	      if (editor.props.handlePastedFiles && isEventHandled(editor.props.handlePastedFiles(files))) {
	        return;
	      }
	
	      getTextContentFromFiles(files, function ( /*string*/fileText) {
	        fileText = fileText || defaultFileText;
	        if (!fileText) {
	          return;
	        }
	
	        var editorState = editor._latestEditorState;
	        var blocks = splitTextIntoTextBlocks(fileText);
	        var character = CharacterMetadata.create({
	          style: editorState.getCurrentInlineStyle(),
	          entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	        });
	        var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
	
	        var text = DraftPasteProcessor.processText(blocks, character, currentBlockType);
	        var fragment = BlockMapBuilder.createFromArray(text);
	
	        var withInsertedText = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	
	        editor.update(EditorState.push(editorState, withInsertedText, 'insert-fragment'));
	      });
	
	      return;
	    }
	  }
	
	  var textBlocks = [];
	  var text = data.getText();
	  var html = data.getHTML();
	  var editorState = editor._latestEditorState;
	
	  if (editor.props.handlePastedText && isEventHandled(editor.props.handlePastedText(text, html, editorState))) {
	    return;
	  }
	
	  if (text) {
	    textBlocks = splitTextIntoTextBlocks(text);
	  }
	
	  if (!editor.props.stripPastedStyles) {
	    // If the text from the paste event is rich content that matches what we
	    // already have on the internal clipboard, assume that we should just use
	    // the clipboard fragment for the paste. This will allow us to preserve
	    // styling and entities, if any are present. Note that newlines are
	    // stripped during comparison -- this is because copy/paste within the
	    // editor in Firefox and IE will not include empty lines. The resulting
	    // paste will preserve the newlines correctly.
	    var internalClipboard = editor.getClipboard();
	    if (data.isRichText() && internalClipboard) {
	      if (
	      // If the editorKey is present in the pasted HTML, it should be safe to
	      // assume this is an internal paste.
	      html.indexOf(editor.getEditorKey()) !== -1 ||
	      // The copy may have been made within a single block, in which case the
	      // editor key won't be part of the paste. In this case, just check
	      // whether the pasted text matches the internal clipboard.
	      textBlocks.length === 1 && internalClipboard.size === 1 && internalClipboard.first().getText() === text) {
	        editor.update(insertFragment(editor._latestEditorState, internalClipboard));
	        return;
	      }
	    } else if (internalClipboard && data.types.includes('com.apple.webarchive') && !data.types.includes('text/html') && areTextBlocksAndClipboardEqual(textBlocks, internalClipboard)) {
	      // Safari does not properly store text/html in some cases.
	      // Use the internalClipboard if present and equal to what is on
	      // the clipboard. See https://bugs.webkit.org/show_bug.cgi?id=19893.
	      editor.update(insertFragment(editor._latestEditorState, internalClipboard));
	      return;
	    }
	
	    // If there is html paste data, try to parse that.
	    if (html) {
	      var htmlFragment = DraftPasteProcessor.processHTML(html, editor.props.blockRenderMap);
	      if (htmlFragment) {
	        var contentBlocks = htmlFragment.contentBlocks,
	            entityMap = htmlFragment.entityMap;
	
	        if (contentBlocks) {
	          var htmlMap = BlockMapBuilder.createFromArray(contentBlocks);
	          editor.update(insertFragment(editor._latestEditorState, htmlMap, entityMap));
	          return;
	        }
	      }
	    }
	
	    // Otherwise, create a new fragment from our pasted text. Also
	    // empty the internal clipboard, since it's no longer valid.
	    editor.setClipboard(null);
	  }
	
	  if (textBlocks.length) {
	    var character = CharacterMetadata.create({
	      style: editorState.getCurrentInlineStyle(),
	      entity: getEntityKeyForSelection(editorState.getCurrentContent(), editorState.getSelection())
	    });
	
	    var currentBlockType = RichTextEditorUtil.getCurrentBlockType(editorState);
	
	    var textFragment = DraftPasteProcessor.processText(textBlocks, character, currentBlockType);
	
	    var textMap = BlockMapBuilder.createFromArray(textFragment);
	    editor.update(insertFragment(editor._latestEditorState, textMap));
	  }
	}
	
	function insertFragment(editorState, fragment, entityMap) {
	  var newContent = DraftModifier.replaceWithFragment(editorState.getCurrentContent(), editorState.getSelection(), fragment);
	  // TODO: merge the entity map once we stop using DraftEntity
	  // like this:
	  // const mergedEntityMap = newContent.getEntityMap().merge(entityMap);
	
	  return EditorState.push(editorState, newContent.set('entityMap', entityMap), 'insert-fragment');
	}
	
	function areTextBlocksAndClipboardEqual(textBlocks, blockMap) {
	  return textBlocks.length === blockMap.size && blockMap.valueSeq().every(function (block, ii) {
	    return block.getText() === textBlocks[ii];
	  });
	}
	
	module.exports = editOnPaste;

/***/ },
/* 2171 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule editOnSelect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(52);
	var ReactDOM = __webpack_require__(23);
	
	var getDraftEditorSelection = __webpack_require__(2176);
	var invariant = __webpack_require__(18);
	
	function editOnSelect(editor) {
	  if (editor._blockSelectEvents || editor._latestEditorState !== editor.props.editorState) {
	    return;
	  }
	
	  var editorState = editor.props.editorState;
	  var editorNode = ReactDOM.findDOMNode(editor.editorContainer);
	  !editorNode ?  false ? invariant(false, 'Missing editorNode') : invariant(false) : void 0;
	  !(editorNode.firstChild instanceof HTMLElement) ?  false ? invariant(false, 'editorNode.firstChild is not an HTMLElement') : invariant(false) : void 0;
	  var documentSelection = getDraftEditorSelection(editorState, editorNode.firstChild);
	  var updatedSelectionState = documentSelection.selectionState;
	
	  if (updatedSelectionState !== editorState.getSelection()) {
	    if (documentSelection.needsRecovery) {
	      editorState = EditorState.forceSelection(editorState, updatedSelectionState);
	    } else {
	      editorState = EditorState.acceptSelection(editorState, updatedSelectionState);
	    }
	    editor.update(editorState);
	  }
	}
	
	module.exports = editOnSelect;

/***/ },
/* 2172 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeEntityRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftStringKey = __webpack_require__(800);
	var UnicodeUtils = __webpack_require__(215);
	
	var strlen = UnicodeUtils.strlen;
	
	/**
	 * Convert to UTF-8 character counts for storage.
	 */
	
	function encodeEntityRanges(block, storageMap) {
	  var encoded = [];
	  block.findEntityRanges(function (character) {
	    return !!character.getEntity();
	  }, function ( /*number*/start, /*number*/end) {
	    var text = block.getText();
	    var key = block.getEntityAt(start);
	    encoded.push({
	      offset: strlen(text.slice(0, start)),
	      length: strlen(text.slice(start, end)),
	      // Encode the key as a number for range storage.
	      key: Number(storageMap[DraftStringKey.stringify(key)])
	    });
	  });
	  return encoded;
	}
	
	module.exports = encodeEntityRanges;

/***/ },
/* 2173 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule encodeInlineStyleRanges
	 * @format
	 * 
	 */
	
	'use strict';
	
	var UnicodeUtils = __webpack_require__(215);
	
	var findRangesImmutable = __webpack_require__(284);
	
	var areEqual = function areEqual(a, b) {
	  return a === b;
	};
	var isTruthy = function isTruthy(a) {
	  return !!a;
	};
	var EMPTY_ARRAY = [];
	
	/**
	 * Helper function for getting encoded styles for each inline style. Convert
	 * to UTF-8 character counts for storage.
	 */
	function getEncodedInlinesForType(block, styleList, styleToEncode) {
	  var ranges = [];
	
	  // Obtain an array with ranges for only the specified style.
	  var filteredInlines = styleList.map(function (style) {
	    return style.has(styleToEncode);
	  }).toList();
	
	  findRangesImmutable(filteredInlines, areEqual,
	  // We only want to keep ranges with nonzero style values.
	  isTruthy, function (start, end) {
	    var text = block.getText();
	    ranges.push({
	      offset: UnicodeUtils.strlen(text.slice(0, start)),
	      length: UnicodeUtils.strlen(text.slice(start, end)),
	      style: styleToEncode
	    });
	  });
	
	  return ranges;
	}
	
	/*
	 * Retrieve the encoded arrays of inline styles, with each individual style
	 * treated separately.
	 */
	function encodeInlineStyleRanges(block) {
	  var styleList = block.getCharacterList().map(function (c) {
	    return c.getStyle();
	  }).toList();
	  var ranges = styleList.flatten().toSet().map(function (style) {
	    return getEncodedInlinesForType(block, styleList, style);
	  });
	
	  return Array.prototype.concat.apply(EMPTY_ARRAY, ranges.toJS());
	}
	
	module.exports = encodeInlineStyleRanges;

/***/ },
/* 2174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule expandRangeToStartOfLine
	 * @format
	 * 
	 */
	
	var UnicodeUtils = __webpack_require__(215);
	
	var getRangeClientRects = __webpack_require__(807);
	var invariant = __webpack_require__(18);
	
	/**
	 * Return the computed line height, in pixels, for the provided element.
	 */
	function getLineHeightPx(element) {
	  var computed = getComputedStyle(element);
	  var div = document.createElement('div');
	  div.style.fontFamily = computed.fontFamily;
	  div.style.fontSize = computed.fontSize;
	  div.style.fontStyle = computed.fontStyle;
	  div.style.fontWeight = computed.fontWeight;
	  div.style.lineHeight = computed.lineHeight;
	  div.style.position = 'absolute';
	  div.textContent = 'M';
	
	  var documentBody = document.body;
	  !documentBody ?  false ? invariant(false, 'Missing document.body') : invariant(false) : void 0;
	
	  // forced layout here
	  documentBody.appendChild(div);
	  var rect = div.getBoundingClientRect();
	  documentBody.removeChild(div);
	
	  return rect.height;
	}
	
	/**
	 * Return whether every ClientRect in the provided list lies on the same line.
	 *
	 * We assume that the rects on the same line all contain the baseline, so the
	 * lowest top line needs to be above the highest bottom line (i.e., if you were
	 * to project the rects onto the y-axis, their intersection would be nonempty).
	 *
	 * In addition, we require that no two boxes are lineHeight (or more) apart at
	 * either top or bottom, which helps protect against false positives for fonts
	 * with extremely large glyph heights (e.g., with a font size of 17px, Zapfino
	 * produces rects of height 58px!).
	 */
	function areRectsOnOneLine(rects, lineHeight) {
	  var minTop = Infinity;
	  var minBottom = Infinity;
	  var maxTop = -Infinity;
	  var maxBottom = -Infinity;
	
	  for (var ii = 0; ii < rects.length; ii++) {
	    var rect = rects[ii];
	    if (rect.width === 0 || rect.width === 1) {
	      // When a range starts or ends a soft wrap, many browsers (Chrome, IE,
	      // Safari) include an empty rect on the previous or next line. When the
	      // text lies in a container whose position is not integral (e.g., from
	      // margin: auto), Safari makes these empty rects have width 1 (instead of
	      // 0). Having one-pixel-wide characters seems unlikely (and most browsers
	      // report widths in subpixel precision anyway) so it's relatively safe to
	      // skip over them.
	      continue;
	    }
	    minTop = Math.min(minTop, rect.top);
	    minBottom = Math.min(minBottom, rect.bottom);
	    maxTop = Math.max(maxTop, rect.top);
	    maxBottom = Math.max(maxBottom, rect.bottom);
	  }
	
	  return maxTop <= minBottom && maxTop - minTop < lineHeight && maxBottom - minBottom < lineHeight;
	}
	
	/**
	 * Return the length of a node, as used by Range offsets.
	 */
	function getNodeLength(node) {
	  // http://www.w3.org/TR/dom/#concept-node-length
	  switch (node.nodeType) {
	    case Node.DOCUMENT_TYPE_NODE:
	      return 0;
	    case Node.TEXT_NODE:
	    case Node.PROCESSING_INSTRUCTION_NODE:
	    case Node.COMMENT_NODE:
	      return node.length;
	    default:
	      return node.childNodes.length;
	  }
	}
	
	/**
	 * Given a collapsed range, move the start position backwards as far as
	 * possible while the range still spans only a single line.
	 */
	function expandRangeToStartOfLine(range) {
	  !range.collapsed ?  false ? invariant(false, 'expandRangeToStartOfLine: Provided range is not collapsed.') : invariant(false) : void 0;
	  range = range.cloneRange();
	
	  var containingElement = range.startContainer;
	  if (containingElement.nodeType !== 1) {
	    containingElement = containingElement.parentNode;
	  }
	  var lineHeight = getLineHeightPx(containingElement);
	
	  // Imagine our text looks like:
	  //   <div><span>once upon a time, there was a <em>boy
	  //   who lived</em> </span><q><strong>under^ the
	  //   stairs</strong> in a small closet.</q></div>
	  // where the caret represents the cursor. First, we crawl up the tree until
	  // the range spans multiple lines (setting the start point to before
	  // "<strong>", then before "<div>"), then at each level we do a search to
	  // find the latest point which is still on a previous line. We'll find that
	  // the break point is inside the span, then inside the <em>, then in its text
	  // node child, the actual break point before "who".
	
	  var bestContainer = range.endContainer;
	  var bestOffset = range.endOffset;
	  range.setStart(range.startContainer, 0);
	
	  while (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	    bestContainer = range.startContainer;
	    bestOffset = range.startOffset;
	    !bestContainer.parentNode ?  false ? invariant(false, 'Found unexpected detached subtree when traversing.') : invariant(false) : void 0;
	    range.setStartBefore(bestContainer);
	    if (bestContainer.nodeType === 1 && getComputedStyle(bestContainer).display !== 'inline') {
	      // The start of the line is never in a different block-level container.
	      break;
	    }
	  }
	
	  // In the above example, range now spans from "<div>" to "under",
	  // bestContainer is <div>, and bestOffset is 1 (index of <q> inside <div>)].
	  // Picking out which child to recurse into here is a special case since we
	  // don't want to check past <q> -- once we find that the final range starts
	  // in <span>, we can look at all of its children (and all of their children)
	  // to find the break point.
	
	  // At all times, (bestContainer, bestOffset) is the latest single-line start
	  // point that we know of.
	  var currentContainer = bestContainer;
	  var maxIndexToConsider = bestOffset - 1;
	
	  do {
	    var nodeValue = currentContainer.nodeValue;
	
	    for (var ii = maxIndexToConsider; ii >= 0; ii--) {
	      if (nodeValue != null && ii > 0 && UnicodeUtils.isSurrogatePair(nodeValue, ii - 1)) {
	        // We're in the middle of a surrogate pair -- skip over so we never
	        // return a range with an endpoint in the middle of a code point.
	        continue;
	      }
	
	      range.setStart(currentContainer, ii);
	      if (areRectsOnOneLine(getRangeClientRects(range), lineHeight)) {
	        bestContainer = currentContainer;
	        bestOffset = ii;
	      } else {
	        break;
	      }
	    }
	
	    if (ii === -1 || currentContainer.childNodes.length === 0) {
	      // If ii === -1, then (bestContainer, bestOffset), which is equal to
	      // (currentContainer, 0), was a single-line start point but a start
	      // point before currentContainer wasn't, so the line break seems to
	      // have occurred immediately after currentContainer's start tag
	      //
	      // If currentContainer.childNodes.length === 0, we're already at a
	      // terminal node (e.g., text node) and should return our current best.
	      break;
	    }
	
	    currentContainer = currentContainer.childNodes[ii];
	    maxIndexToConsider = getNodeLength(currentContainer);
	  } while (true);
	
	  range.setStart(bestContainer, bestOffset);
	  return range;
	}
	
	module.exports = expandRangeToStartOfLine;

/***/ },
/* 2175 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getCharacterRemovalRange
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftEntitySegments = __webpack_require__(2145);
	
	var getRangesForDraftEntity = __webpack_require__(2178);
	var invariant = __webpack_require__(18);
	
	/**
	 * Given a SelectionState and a removal direction, determine the entire range
	 * that should be removed from a ContentState. This is based on any entities
	 * within the target, with their `mutability` values taken into account.
	 *
	 * For instance, if we are attempting to remove part of an "immutable" entity
	 * range, the entire entity must be removed. The returned `SelectionState`
	 * will be adjusted accordingly.
	 */
	function getCharacterRemovalRange(entityMap, startBlock, endBlock, selectionState, direction) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var startEntityKey = startBlock.getEntityAt(start);
	  var endEntityKey = endBlock.getEntityAt(end - 1);
	  if (!startEntityKey && !endEntityKey) {
	    return selectionState;
	  }
	  var newSelectionState = selectionState;
	  if (startEntityKey && startEntityKey === endEntityKey) {
	    newSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, true, true);
	  } else if (startEntityKey && endEntityKey) {
	    var startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
	    var endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
	    newSelectionState = newSelectionState.merge({
	      anchorOffset: startSelectionState.getAnchorOffset(),
	      focusOffset: endSelectionState.getFocusOffset(),
	      isBackward: false
	    });
	  } else if (startEntityKey) {
	    var _startSelectionState = getEntityRemovalRange(entityMap, startBlock, newSelectionState, direction, startEntityKey, false, true);
	    newSelectionState = newSelectionState.merge({
	      anchorOffset: _startSelectionState.getStartOffset(),
	      isBackward: false
	    });
	  } else if (endEntityKey) {
	    var _endSelectionState = getEntityRemovalRange(entityMap, endBlock, newSelectionState, direction, endEntityKey, false, false);
	    newSelectionState = newSelectionState.merge({
	      focusOffset: _endSelectionState.getEndOffset(),
	      isBackward: false
	    });
	  }
	  return newSelectionState;
	}
	
	function getEntityRemovalRange(entityMap, block, selectionState, direction, entityKey, isEntireSelectionWithinEntity, isEntityAtStart) {
	  var start = selectionState.getStartOffset();
	  var end = selectionState.getEndOffset();
	  var entity = entityMap.__get(entityKey);
	  var mutability = entity.getMutability();
	  var sideToConsider = isEntityAtStart ? start : end;
	
	  // `MUTABLE` entities can just have the specified range of text removed
	  // directly. No adjustments are needed.
	  if (mutability === 'MUTABLE') {
	    return selectionState;
	  }
	
	  // Find the entity range that overlaps with our removal range.
	  var entityRanges = getRangesForDraftEntity(block, entityKey).filter(function (range) {
	    return sideToConsider <= range.end && sideToConsider >= range.start;
	  });
	
	  !(entityRanges.length == 1) ?  false ? invariant(false, 'There should only be one entity range within this removal range.') : invariant(false) : void 0;
	
	  var entityRange = entityRanges[0];
	
	  // For `IMMUTABLE` entity types, we will remove the entire entity range.
	  if (mutability === 'IMMUTABLE') {
	    return selectionState.merge({
	      anchorOffset: entityRange.start,
	      focusOffset: entityRange.end,
	      isBackward: false
	    });
	  }
	
	  // For `SEGMENTED` entity types, determine the appropriate segment to
	  // remove.
	  if (!isEntireSelectionWithinEntity) {
	    if (isEntityAtStart) {
	      end = entityRange.end;
	    } else {
	      start = entityRange.start;
	    }
	  }
	
	  var removalRange = DraftEntitySegments.getRemovalRange(start, end, block.getText().slice(entityRange.start, entityRange.end), entityRange.start, direction);
	
	  return selectionState.merge({
	    anchorOffset: removalRange.start,
	    focusOffset: removalRange.end,
	    isBackward: false
	  });
	}
	
	module.exports = getCharacterRemovalRange;

/***/ },
/* 2176 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getDraftEditorSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getDraftEditorSelectionWithNodes = __webpack_require__(804);
	
	/**
	 * Convert the current selection range to an anchor/focus pair of offset keys
	 * and values that can be interpreted by components.
	 */
	function getDraftEditorSelection(editorState, root) {
	  var selection = global.getSelection();
	
	  // No active selection.
	  if (selection.rangeCount === 0) {
	    return {
	      selectionState: editorState.getSelection().set('hasFocus', false),
	      needsRecovery: false
	    };
	  }
	
	  return getDraftEditorSelectionWithNodes(editorState, root, selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	}
	
	module.exports = getDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2177 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangeBoundingClientRect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getRangeClientRects = __webpack_require__(807);
	
	/**
	 * Like range.getBoundingClientRect() but normalizes for browser bugs.
	 */
	function getRangeBoundingClientRect(range) {
	  // "Return a DOMRect object describing the smallest rectangle that includes
	  // the first rectangle in list and all of the remaining rectangles of which
	  // the height or width is not zero."
	  // http://www.w3.org/TR/cssom-view/#dom-range-getboundingclientrect
	  var rects = getRangeClientRects(range);
	  var top = 0;
	  var right = 0;
	  var bottom = 0;
	  var left = 0;
	
	  if (rects.length) {
	    // If the first rectangle has 0 width, we use the second, this is needed
	    // because Chrome renders a 0 width rectangle when the selection contains
	    // a line break.
	    if (rects.length > 1 && rects[0].width === 0) {
	      var _rects$ = rects[1];
	      top = _rects$.top;
	      right = _rects$.right;
	      bottom = _rects$.bottom;
	      left = _rects$.left;
	    } else {
	      var _rects$2 = rects[0];
	      top = _rects$2.top;
	      right = _rects$2.right;
	      bottom = _rects$2.bottom;
	      left = _rects$2.left;
	    }
	
	    for (var ii = 1; ii < rects.length; ii++) {
	      var rect = rects[ii];
	      if (rect.height !== 0 && rect.width !== 0) {
	        top = Math.min(top, rect.top);
	        right = Math.max(right, rect.right);
	        bottom = Math.max(bottom, rect.bottom);
	        left = Math.min(left, rect.left);
	      }
	    }
	  }
	
	  return {
	    top: top,
	    right: right,
	    bottom: bottom,
	    left: left,
	    width: right - left,
	    height: bottom - top
	  };
	}
	
	module.exports = getRangeBoundingClientRect;

/***/ },
/* 2178 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getRangesForDraftEntity
	 * @format
	 * 
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Obtain the start and end positions of the range that has the
	 * specified entity applied to it.
	 *
	 * Entity keys are applied only to contiguous stretches of text, so this
	 * method searches for the first instance of the entity key and returns
	 * the subsequent range.
	 */
	function getRangesForDraftEntity(block, key) {
	  var ranges = [];
	  block.findEntityRanges(function (c) {
	    return c.getEntity() === key;
	  }, function (start, end) {
	    ranges.push({ start: start, end: end });
	  });
	
	  !!!ranges.length ?  false ? invariant(false, 'Entity key not found in this range.') : invariant(false) : void 0;
	
	  return ranges;
	}
	
	module.exports = getRangesForDraftEntity;

/***/ },
/* 2179 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule getVisibleSelectionRect
	 * @format
	 * 
	 */
	
	'use strict';
	
	var getRangeBoundingClientRect = __webpack_require__(2177);
	
	/**
	 * Return the bounding ClientRect for the visible DOM selection, if any.
	 * In cases where there are no selected ranges or the bounding rect is
	 * temporarily invalid, return null.
	 */
	function getVisibleSelectionRect(global) {
	  var selection = global.getSelection();
	  if (!selection.rangeCount) {
	    return null;
	  }
	
	  var range = selection.getRangeAt(0);
	  var boundingRect = getRangeBoundingClientRect(range);
	  var top = boundingRect.top,
	      right = boundingRect.right,
	      bottom = boundingRect.bottom,
	      left = boundingRect.left;
	
	  // When a re-render leads to a node being removed, the DOM selection will
	  // temporarily be placed on an ancestor node, which leads to an invalid
	  // bounding rect. Discard this state.
	
	  if (top === 0 && right === 0 && bottom === 0 && left === 0) {
	    return null;
	  }
	
	  return boundingRect;
	}
	
	module.exports = getVisibleSelectionRect;

/***/ },
/* 2180 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertFragmentIntoContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var BlockMapBuilder = __webpack_require__(282);
	var ContentBlockNode = __webpack_require__(108);
	var Immutable = __webpack_require__(39);
	
	var insertIntoList = __webpack_require__(812);
	var invariant = __webpack_require__(18);
	var randomizeBlockMapKeys = __webpack_require__(815);
	
	var List = Immutable.List;
	
	
	var updateExistingBlock = function updateExistingBlock(contentState, selectionState, blockMap, fragmentBlock, targetKey, targetOffset) {
	  var targetBlock = blockMap.get(targetKey);
	  var text = targetBlock.getText();
	  var chars = targetBlock.getCharacterList();
	  var finalKey = targetKey;
	  var finalOffset = targetOffset + fragmentBlock.getText().length;
	
	  var newBlock = targetBlock.merge({
	    text: text.slice(0, targetOffset) + fragmentBlock.getText() + text.slice(targetOffset),
	    characterList: insertIntoList(chars, fragmentBlock.getCharacterList(), targetOffset),
	    data: fragmentBlock.getData()
	  });
	
	  return contentState.merge({
	    blockMap: blockMap.set(targetKey, newBlock),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	};
	
	/**
	 * Appends text/characterList from the fragment first block to
	 * target block.
	 */
	var updateHead = function updateHead(block, targetOffset, fragment) {
	  var text = block.getText();
	  var chars = block.getCharacterList();
	
	  // Modify head portion of block.
	  var headText = text.slice(0, targetOffset);
	  var headCharacters = chars.slice(0, targetOffset);
	  var appendToHead = fragment.first();
	
	  return block.merge({
	    text: headText + appendToHead.getText(),
	    characterList: headCharacters.concat(appendToHead.getCharacterList()),
	    type: headText ? block.getType() : appendToHead.getType(),
	    data: appendToHead.getData()
	  });
	};
	
	/**
	 * Appends offset text/characterList from the target block to the last
	 * fragment block.
	 */
	var updateTail = function updateTail(block, targetOffset, fragment) {
	  // Modify tail portion of block.
	  var text = block.getText();
	  var chars = block.getCharacterList();
	
	  // Modify head portion of block.
	  var blockSize = text.length;
	  var tailText = text.slice(targetOffset, blockSize);
	  var tailCharacters = chars.slice(targetOffset, blockSize);
	  var prependToTail = fragment.last();
	
	  return prependToTail.merge({
	    text: prependToTail.getText() + tailText,
	    characterList: prependToTail.getCharacterList().concat(tailCharacters),
	    data: prependToTail.getData()
	  });
	};
	
	var getRootBlocks = function getRootBlocks(block, blockMap) {
	  var headKey = block.getKey();
	  var rootBlock = block;
	  var rootBlocks = [];
	
	  // sometimes the fragment head block will not be part of the blockMap itself this can happen when
	  // the fragment head is used to update the target block, however when this does not happen we need
	  // to make sure that we include it on the rootBlocks since the first block of a fragment is always a
	  // fragment root block
	  if (blockMap.get(headKey)) {
	    rootBlocks.push(headKey);
	  }
	
	  while (rootBlock && rootBlock.getNextSiblingKey()) {
	    var lastSiblingKey = rootBlock.getNextSiblingKey();
	
	    if (!lastSiblingKey) {
	      break;
	    }
	
	    rootBlocks.push(lastSiblingKey);
	    rootBlock = blockMap.get(lastSiblingKey);
	  }
	
	  return rootBlocks;
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockMap, targetBlock, fragmentHeadBlock) {
	  return blockMap.withMutations(function (blockMapState) {
	    var targetKey = targetBlock.getKey();
	    var headKey = fragmentHeadBlock.getKey();
	    var targetNextKey = targetBlock.getNextSiblingKey();
	    var targetParentKey = targetBlock.getParentKey();
	    var fragmentRootBlocks = getRootBlocks(fragmentHeadBlock, blockMap);
	    var lastRootFragmentBlockKey = fragmentRootBlocks[fragmentRootBlocks.length - 1];
	
	    if (blockMapState.get(headKey)) {
	      // update the fragment head when it is part of the blockMap otherwise
	      blockMapState.setIn([targetKey, 'nextSibling'], headKey);
	      blockMapState.setIn([headKey, 'prevSibling'], targetKey);
	    } else {
	      // update the target block that had the fragment head contents merged into it
	      blockMapState.setIn([targetKey, 'nextSibling'], fragmentHeadBlock.getNextSiblingKey());
	      blockMapState.setIn([fragmentHeadBlock.getNextSiblingKey(), 'prevSibling'], targetKey);
	    }
	
	    // update the last root block fragment
	    blockMapState.setIn([lastRootFragmentBlockKey, 'nextSibling'], targetNextKey);
	
	    // update the original target next block
	    if (targetNextKey) {
	      blockMapState.setIn([targetNextKey, 'prevSibling'], lastRootFragmentBlockKey);
	    }
	
	    // update fragment parent links
	    fragmentRootBlocks.forEach(function (blockKey) {
	      return blockMapState.setIn([blockKey, 'parent'], targetParentKey);
	    });
	
	    // update targetBlock parent child links
	    if (targetParentKey) {
	      var targetParent = blockMap.get(targetParentKey);
	      var originalTargetParentChildKeys = targetParent.getChildKeys();
	
	      var targetBlockIndex = originalTargetParentChildKeys.indexOf(targetKey);
	      var insertionIndex = targetBlockIndex + 1;
	
	      var newChildrenKeysArray = originalTargetParentChildKeys.toArray();
	
	      // insert fragment children
	      newChildrenKeysArray.splice.apply(newChildrenKeysArray, [insertionIndex, 0].concat(fragmentRootBlocks));
	
	      blockMapState.setIn([targetParentKey, 'children'], List(newChildrenKeysArray));
	    }
	  });
	};
	
	var insertFragment = function insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset) {
	  var isTreeBasedBlockMap = blockMap.first() instanceof ContentBlockNode;
	  var newBlockArr = [];
	  var fragmentSize = fragment.size;
	  var target = blockMap.get(targetKey);
	  var head = fragment.first();
	  var tail = fragment.last();
	  var finalOffset = tail.getLength();
	  var finalKey = tail.getKey();
	  var shouldNotUpdateFromFragmentBlock = isTreeBasedBlockMap && (!target.getChildKeys().isEmpty() || !head.getChildKeys().isEmpty());
	
	  blockMap.forEach(function (block, blockKey) {
	    if (blockKey !== targetKey) {
	      newBlockArr.push(block);
	      return;
	    }
	
	    if (shouldNotUpdateFromFragmentBlock) {
	      newBlockArr.push(block);
	    } else {
	      newBlockArr.push(updateHead(block, targetOffset, fragment));
	    }
	
	    // Insert fragment blocks after the head and before the tail.
	    fragment
	    // when we are updating the target block with the head fragment block we skip the first fragment
	    // head since its contents have already been merged with the target block otherwise we include
	    // the whole fragment
	    .slice(shouldNotUpdateFromFragmentBlock ? 0 : 1, fragmentSize - 1).forEach(function (fragmentBlock) {
	      return newBlockArr.push(fragmentBlock);
	    });
	
	    // update tail
	    newBlockArr.push(updateTail(block, targetOffset, fragment));
	  });
	
	  var updatedBlockMap = BlockMapBuilder.createFromArray(newBlockArr);
	
	  if (isTreeBasedBlockMap) {
	    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, blockMap, target, head);
	  }
	
	  return contentState.merge({
	    blockMap: updatedBlockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: finalKey,
	      anchorOffset: finalOffset,
	      focusKey: finalKey,
	      focusOffset: finalOffset,
	      isBackward: false
	    })
	  });
	};
	
	var insertFragmentIntoContentState = function insertFragmentIntoContentState(contentState, selectionState, fragmentBlockMap) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertFragment` should only be called with a collapsed selection state.') : invariant(false) : void 0;
	
	  var blockMap = contentState.getBlockMap();
	  var fragment = randomizeBlockMapKeys(fragmentBlockMap);
	  var targetKey = selectionState.getStartKey();
	  var targetOffset = selectionState.getStartOffset();
	
	  var targetBlock = blockMap.get(targetKey);
	
	  if (targetBlock instanceof ContentBlockNode) {
	    !targetBlock.getChildKeys().isEmpty() ?  false ? invariant(false, '`insertFragment` should not be called when a container node is selected.') : invariant(false) : void 0;
	  }
	
	  // When we insert a fragment with a single block we simply update the target block
	  // with the contents of the inserted fragment block
	  if (fragment.size === 1) {
	    return updateExistingBlock(contentState, selectionState, blockMap, fragment.first(), targetKey, targetOffset);
	  }
	
	  return insertFragment(contentState, selectionState, blockMap, fragment, targetKey, targetOffset);
	};
	
	module.exports = insertFragmentIntoContentState;

/***/ },
/* 2181 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule insertTextIntoContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(39);
	
	var insertIntoList = __webpack_require__(812);
	var invariant = __webpack_require__(18);
	
	var Repeat = Immutable.Repeat;
	
	
	function insertTextIntoContentState(contentState, selectionState, text, characterMetadata) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, '`insertText` should only be called with a collapsed range.') : invariant(false) : void 0;
	
	  var len = text.length;
	  if (!len) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var key = selectionState.getStartKey();
	  var offset = selectionState.getStartOffset();
	  var block = blockMap.get(key);
	  var blockText = block.getText();
	
	  var newBlock = block.merge({
	    text: blockText.slice(0, offset) + text + blockText.slice(offset, block.getLength()),
	    characterList: insertIntoList(block.getCharacterList(), Repeat(characterMetadata, len).toList(), offset)
	  });
	
	  var newOffset = offset + len;
	
	  return contentState.merge({
	    blockMap: blockMap.set(key, newBlock),
	    selectionAfter: selectionState.merge({
	      anchorOffset: newOffset,
	      focusOffset: newOffset
	    })
	  });
	}
	
	module.exports = insertTextIntoContentState;

/***/ },
/* 2182 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceToStartOfLine
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(52);
	
	var expandRangeToStartOfLine = __webpack_require__(2174);
	var getDraftEditorSelectionWithNodes = __webpack_require__(804);
	var moveSelectionBackward = __webpack_require__(493);
	var removeTextWithStrategy = __webpack_require__(286);
	
	function keyCommandBackspaceToStartOfLine(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    if (selection.isCollapsed() && selection.getAnchorOffset() === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	
	    var domSelection = global.getSelection();
	    var range = domSelection.getRangeAt(0);
	    range = expandRangeToStartOfLine(range);
	
	    return getDraftEditorSelectionWithNodes(strategyState, null, range.endContainer, range.endOffset, range.startContainer, range.startOffset).selectionState;
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceToStartOfLine;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2183 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandBackspaceWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(799);
	var EditorState = __webpack_require__(52);
	
	var moveSelectionBackward = __webpack_require__(493);
	var removeTextWithStrategy = __webpack_require__(286);
	
	/**
	 * Delete the word that is left of the cursor, as well as any spaces or
	 * punctuation after the word.
	 */
	function keyCommandBackspaceWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    // If there are no words before the cursor, remove the preceding newline.
	    if (offset === 0) {
	      return moveSelectionBackward(strategyState, 1);
	    }
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(0, offset);
	    var toRemove = DraftRemovableWord.getBackward(text);
	    return moveSelectionBackward(strategyState, toRemove.length || 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandBackspaceWord;

/***/ },
/* 2184 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandDeleteWord
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftRemovableWord = __webpack_require__(799);
	var EditorState = __webpack_require__(52);
	
	var moveSelectionForward = __webpack_require__(814);
	var removeTextWithStrategy = __webpack_require__(286);
	
	/**
	 * Delete the word that is right of the cursor, as well as any spaces or
	 * punctuation before the word.
	 */
	function keyCommandDeleteWord(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var offset = selection.getStartOffset();
	    var key = selection.getStartKey();
	    var content = strategyState.getCurrentContent();
	    var text = content.getBlockForKey(key).getText().slice(offset);
	    var toRemove = DraftRemovableWord.getForward(text);
	
	    // If there are no words in front of the cursor, remove the newline.
	    return moveSelectionForward(strategyState, toRemove.length || 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  return EditorState.push(editorState, afterRemoval, 'remove-range');
	}
	
	module.exports = keyCommandDeleteWord;

/***/ },
/* 2185 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandInsertNewline
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(92);
	var EditorState = __webpack_require__(52);
	
	function keyCommandInsertNewline(editorState) {
	  var contentState = DraftModifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());
	  return EditorState.push(editorState, contentState, 'split-block');
	}
	
	module.exports = keyCommandInsertNewline;

/***/ },
/* 2186 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToEndOfBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(52);
	
	/**
	 * See comment for `moveSelectionToStartOfBlock`.
	 */
	function keyCommandMoveSelectionToEndOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var endKey = selection.getEndKey();
	  var content = editorState.getCurrentContent();
	  var textLength = content.getBlockForKey(endKey).getLength();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: endKey,
	      anchorOffset: textLength,
	      focusKey: endKey,
	      focusOffset: textLength,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToEndOfBlock;

/***/ },
/* 2187 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandMoveSelectionToStartOfBlock
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(52);
	
	/**
	 * Collapse selection at the start of the first selected block. This is used
	 * for Firefox versions that attempt to navigate forward/backward instead of
	 * moving the cursor. Other browsers are able to move the cursor natively.
	 */
	function keyCommandMoveSelectionToStartOfBlock(editorState) {
	  var selection = editorState.getSelection();
	  var startKey = selection.getStartKey();
	  return EditorState.set(editorState, {
	    selection: selection.merge({
	      anchorKey: startKey,
	      anchorOffset: 0,
	      focusKey: startKey,
	      focusOffset: 0,
	      isBackward: false
	    }),
	    forceSelection: true
	  });
	}
	
	module.exports = keyCommandMoveSelectionToStartOfBlock;

/***/ },
/* 2188 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainBackspace
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(52);
	var UnicodeUtils = __webpack_require__(215);
	
	var moveSelectionBackward = __webpack_require__(493);
	var removeTextWithStrategy = __webpack_require__(286);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the preceding
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainBackspace(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charBehind = content.getBlockForKey(key).getText()[offset - 1];
	    return moveSelectionBackward(strategyState, charBehind ? UnicodeUtils.getUTF16Length(charBehind, 0) : 1);
	  }, 'backward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'backspace-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainBackspace;

/***/ },
/* 2189 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandPlainDelete
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(52);
	var UnicodeUtils = __webpack_require__(215);
	
	var moveSelectionForward = __webpack_require__(814);
	var removeTextWithStrategy = __webpack_require__(286);
	
	/**
	 * Remove the selected range. If the cursor is collapsed, remove the following
	 * character. This operation is Unicode-aware, so removing a single character
	 * will remove a surrogate pair properly as well.
	 */
	function keyCommandPlainDelete(editorState) {
	  var afterRemoval = removeTextWithStrategy(editorState, function (strategyState) {
	    var selection = strategyState.getSelection();
	    var content = strategyState.getCurrentContent();
	    var key = selection.getAnchorKey();
	    var offset = selection.getAnchorOffset();
	    var charAhead = content.getBlockForKey(key).getText()[offset];
	    return moveSelectionForward(strategyState, charAhead ? UnicodeUtils.getUTF16Length(charAhead, 0) : 1);
	  }, 'forward');
	
	  if (afterRemoval === editorState.getCurrentContent()) {
	    return editorState;
	  }
	
	  var selection = editorState.getSelection();
	
	  return EditorState.push(editorState, afterRemoval.set('selectionBefore', selection), selection.isCollapsed() ? 'delete-character' : 'remove-range');
	}
	
	module.exports = keyCommandPlainDelete;

/***/ },
/* 2190 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandTransposeCharacters
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftModifier = __webpack_require__(92);
	var EditorState = __webpack_require__(52);
	
	var getContentStateFragment = __webpack_require__(351);
	
	/**
	 * Transpose the characters on either side of a collapsed cursor, or
	 * if the cursor is at the end of the block, transpose the last two
	 * characters.
	 */
	function keyCommandTransposeCharacters(editorState) {
	  var selection = editorState.getSelection();
	  if (!selection.isCollapsed()) {
	    return editorState;
	  }
	
	  var offset = selection.getAnchorOffset();
	  if (offset === 0) {
	    return editorState;
	  }
	
	  var blockKey = selection.getAnchorKey();
	  var content = editorState.getCurrentContent();
	  var block = content.getBlockForKey(blockKey);
	  var length = block.getLength();
	
	  // Nothing to transpose if there aren't two characters.
	  if (length <= 1) {
	    return editorState;
	  }
	
	  var removalRange;
	  var finalSelection;
	
	  if (offset === length) {
	    // The cursor is at the end of the block. Swap the last two characters.
	    removalRange = selection.set('anchorOffset', offset - 1);
	    finalSelection = selection;
	  } else {
	    removalRange = selection.set('focusOffset', offset + 1);
	    finalSelection = removalRange.set('anchorOffset', offset + 1);
	  }
	
	  // Extract the character to move as a fragment. This preserves its
	  // styling and entity, if any.
	  var movedFragment = getContentStateFragment(content, removalRange);
	  var afterRemoval = DraftModifier.removeRange(content, removalRange, 'backward');
	
	  // After the removal, the insertion target is one character back.
	  var selectionAfter = afterRemoval.getSelectionAfter();
	  var targetOffset = selectionAfter.getAnchorOffset() - 1;
	  var targetRange = selectionAfter.merge({
	    anchorOffset: targetOffset,
	    focusOffset: targetOffset
	  });
	
	  var afterInsert = DraftModifier.replaceWithFragment(afterRemoval, targetRange, movedFragment);
	
	  var newEditorState = EditorState.push(editorState, afterInsert, 'insert-fragment');
	
	  return EditorState.acceptSelection(newEditorState, finalSelection);
	}
	
	module.exports = keyCommandTransposeCharacters;

/***/ },
/* 2191 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule keyCommandUndo
	 * @format
	 * 
	 */
	
	'use strict';
	
	var EditorState = __webpack_require__(52);
	
	function keyCommandUndo(e, editorState, updateFn) {
	  var undoneState = EditorState.undo(editorState);
	
	  // If the last change to occur was a spellcheck change, allow the undo
	  // event to fall through to the browser. This allows the browser to record
	  // the unwanted change, which should soon lead it to learn not to suggest
	  // the correction again.
	  if (editorState.getLastChangeType() === 'spellcheck-change') {
	    var nativelyRenderedContent = undoneState.getCurrentContent();
	    updateFn(EditorState.set(undoneState, { nativelyRenderedContent: nativelyRenderedContent }));
	    return;
	  }
	
	  // Otheriwse, manage the undo behavior manually.
	  e.preventDefault();
	  if (!editorState.getNativelyRenderedContent()) {
	    updateFn(undoneState);
	    return;
	  }
	
	  // Trigger a re-render with the current content state to ensure that the
	  // component tree has up-to-date props for comparison.
	  updateFn(EditorState.set(editorState, { nativelyRenderedContent: null }));
	
	  // Wait to ensure that the re-render has occurred before performing
	  // the undo action.
	  setTimeout(function () {
	    updateFn(undoneState);
	  }, 0);
	}
	
	module.exports = keyCommandUndo;

/***/ },
/* 2192 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule modifyBlockForContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var Immutable = __webpack_require__(39);
	
	var Map = Immutable.Map;
	
	
	function modifyBlockForContentState(contentState, selectionState, operation) {
	  var startKey = selectionState.getStartKey();
	  var endKey = selectionState.getEndKey();
	  var blockMap = contentState.getBlockMap();
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).concat(Map([[endKey, blockMap.get(endKey)]])).map(operation);
	
	  return contentState.merge({
	    blockMap: blockMap.merge(newBlocks),
	    selectionBefore: selectionState,
	    selectionAfter: selectionState
	  });
	}
	
	module.exports = modifyBlockForContentState;

/***/ },
/* 2193 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule moveBlockInContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(108);
	var Immutable = __webpack_require__(39);
	
	var getNextDelimiterBlockKey = __webpack_require__(806);
	var invariant = __webpack_require__(18);
	
	var OrderedMap = Immutable.OrderedMap,
	    List = Immutable.List;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlockToBeMoved, originalTargetBlock, insertionMode, isExperimentalTreeBlock) {
	  if (!isExperimentalTreeBlock) {
	    return blockMap;
	  }
	  // possible values of 'insertionMode' are: 'after', 'before'
	  var isInsertedAfterTarget = insertionMode === 'after';
	
	  var originalBlockKey = originalBlockToBeMoved.getKey();
	  var originalTargetKey = originalTargetBlock.getKey();
	  var originalParentKey = originalBlockToBeMoved.getParentKey();
	  var originalNextSiblingKey = originalBlockToBeMoved.getNextSiblingKey();
	  var originalPrevSiblingKey = originalBlockToBeMoved.getPrevSiblingKey();
	  var newParentKey = originalTargetBlock.getParentKey();
	  var newNextSiblingKey = isInsertedAfterTarget ? originalTargetBlock.getNextSiblingKey() : originalTargetKey;
	  var newPrevSiblingKey = isInsertedAfterTarget ? originalTargetKey : originalTargetBlock.getPrevSiblingKey();
	
	  return blockMap.withMutations(function (blocks) {
	    // update old parent
	    transformBlock(originalParentKey, blocks, function (block) {
	      var parentChildrenList = block.getChildKeys();
	      return block.merge({
	        children: parentChildrenList['delete'](parentChildrenList.indexOf(originalBlockKey))
	      });
	    });
	
	    // update old prev
	    transformBlock(originalPrevSiblingKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: originalNextSiblingKey
	      });
	    });
	
	    // update old next
	    transformBlock(originalNextSiblingKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalPrevSiblingKey
	      });
	    });
	
	    // update new next
	    transformBlock(newNextSiblingKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalBlockKey
	      });
	    });
	
	    // update new prev
	    transformBlock(newPrevSiblingKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: originalBlockKey
	      });
	    });
	
	    // update new parent
	    transformBlock(newParentKey, blocks, function (block) {
	      var newParentChildrenList = block.getChildKeys();
	      var targetBlockIndex = newParentChildrenList.indexOf(originalTargetKey);
	
	      var insertionIndex = isInsertedAfterTarget ? targetBlockIndex + 1 : targetBlockIndex !== 0 ? targetBlockIndex - 1 : 0;
	
	      var newChildrenArray = newParentChildrenList.toArray();
	      newChildrenArray.splice(insertionIndex, 0, originalBlockKey);
	
	      return block.merge({
	        children: List(newChildrenArray)
	      });
	    });
	
	    // update block
	    transformBlock(originalBlockKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: newNextSiblingKey,
	        prevSibling: newPrevSiblingKey,
	        parent: newParentKey
	      });
	    });
	  });
	};
	
	var moveBlockInContentState = function moveBlockInContentState(contentState, blockToBeMoved, targetBlock, insertionMode) {
	  !(insertionMode !== 'replace') ?  false ? invariant(false, 'Replacing blocks is not supported.') : invariant(false) : void 0;
	
	  var targetKey = targetBlock.getKey();
	  var blockKey = blockToBeMoved.getKey();
	
	  !(blockKey !== targetKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	  var blockMap = contentState.getBlockMap();
	  var isExperimentalTreeBlock = blockToBeMoved instanceof ContentBlockNode;
	
	  var blocksToBeMoved = [blockToBeMoved];
	  var blockMapWithoutBlocksToBeMoved = blockMap['delete'](blockKey);
	
	  if (isExperimentalTreeBlock) {
	    blocksToBeMoved = [];
	    blockMapWithoutBlocksToBeMoved = blockMap.withMutations(function (blocks) {
	      var nextSiblingKey = blockToBeMoved.getNextSiblingKey();
	      var nextDelimiterBlockKey = getNextDelimiterBlockKey(blockToBeMoved, blocks);
	
	      blocks.toSeq().skipUntil(function (block) {
	        return block.getKey() === blockKey;
	      }).takeWhile(function (block) {
	        var key = block.getKey();
	        var isBlockToBeMoved = key === blockKey;
	        var hasNextSiblingAndIsNotNextSibling = nextSiblingKey && key !== nextSiblingKey;
	        var doesNotHaveNextSiblingAndIsNotDelimiter = !nextSiblingKey && block.getParentKey() && (!nextDelimiterBlockKey || key !== nextDelimiterBlockKey);
	
	        return !!(isBlockToBeMoved || hasNextSiblingAndIsNotNextSibling || doesNotHaveNextSiblingAndIsNotDelimiter);
	      }).forEach(function (block) {
	        blocksToBeMoved.push(block);
	        blocks['delete'](block.getKey());
	      });
	    });
	  }
	
	  var blocksBefore = blockMapWithoutBlocksToBeMoved.toSeq().takeUntil(function (v) {
	    return v === targetBlock;
	  });
	
	  var blocksAfter = blockMapWithoutBlocksToBeMoved.toSeq().skipUntil(function (v) {
	    return v === targetBlock;
	  }).skip(1);
	
	  var slicedBlocks = blocksToBeMoved.map(function (block) {
	    return [block.getKey(), block];
	  });
	
	  var newBlocks = OrderedMap();
	
	  if (insertionMode === 'before') {
	    var blockBefore = contentState.getBlockBefore(targetKey);
	
	    !(!blockBefore || blockBefore.getKey() !== blockToBeMoved.getKey()) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	    newBlocks = blocksBefore.concat([].concat(slicedBlocks, [[targetKey, targetBlock]]), blocksAfter).toOrderedMap();
	  } else if (insertionMode === 'after') {
	    var blockAfter = contentState.getBlockAfter(targetKey);
	
	    !(!blockAfter || blockAfter.getKey() !== blockKey) ?  false ? invariant(false, 'Block cannot be moved next to itself.') : invariant(false) : void 0;
	
	    newBlocks = blocksBefore.concat([[targetKey, targetBlock]].concat(slicedBlocks), blocksAfter).toOrderedMap();
	  }
	
	  return contentState.merge({
	    blockMap: updateBlockMapLinks(newBlocks, blockToBeMoved, targetBlock, insertionMode, isExperimentalTreeBlock),
	    selectionBefore: contentState.getSelectionAfter(),
	    selectionAfter: contentState.getSelectionAfter().merge({
	      anchorKey: blockKey,
	      focusKey: blockKey
	    })
	  });
	};
	
	module.exports = moveBlockInContentState;

/***/ },
/* 2194 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule removeRangeFromContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(108);
	var Immutable = __webpack_require__(39);
	
	var getNextDelimiterBlockKey = __webpack_require__(806);
	
	var List = Immutable.List,
	    Map = Immutable.Map;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	/**
	 * Ancestors needs to be preserved when there are non selected
	 * children to make sure we do not leave any orphans behind
	 */
	var getAncestorsKeys = function getAncestorsKeys(blockKey, blockMap) {
	  var parents = [];
	
	  if (!blockKey) {
	    return parents;
	  }
	
	  var blockNode = blockMap.get(blockKey);
	  while (blockNode && blockNode.getParentKey()) {
	    var parentKey = blockNode.getParentKey();
	    if (parentKey) {
	      parents.push(parentKey);
	    }
	    blockNode = parentKey ? blockMap.get(parentKey) : null;
	  }
	
	  return parents;
	};
	
	/**
	 * Get all next delimiter keys until we hit a root delimiter and return
	 * an array of key references
	 */
	var getNextDelimitersBlockKeys = function getNextDelimitersBlockKeys(block, blockMap) {
	  var nextDelimiters = [];
	
	  if (!block) {
	    return nextDelimiters;
	  }
	
	  var nextDelimiter = getNextDelimiterBlockKey(block, blockMap);
	  while (nextDelimiter && blockMap.get(nextDelimiter)) {
	    var _block = blockMap.get(nextDelimiter);
	    nextDelimiters.push(nextDelimiter);
	
	    // we do not need to keep checking all root node siblings, just the first occurance
	    nextDelimiter = _block.getParentKey() ? getNextDelimiterBlockKey(_block, blockMap) : null;
	  }
	
	  return nextDelimiters;
	};
	
	var getNextValidSibling = function getNextValidSibling(block, blockMap, originalBlockMap) {
	  if (!block) {
	    return null;
	  }
	
	  // note that we need to make sure we refer to the original block since this
	  // function is called within a withMutations
	  var nextValidSiblingKey = originalBlockMap.get(block.getKey()).getNextSiblingKey();
	
	  while (nextValidSiblingKey && !blockMap.get(nextValidSiblingKey)) {
	    nextValidSiblingKey = originalBlockMap.get(nextValidSiblingKey).getNextSiblingKey() || null;
	  }
	
	  return nextValidSiblingKey;
	};
	
	var getPrevValidSibling = function getPrevValidSibling(block, blockMap, originalBlockMap) {
	  if (!block) {
	    return null;
	  }
	
	  // note that we need to make sure we refer to the original block since this
	  // function is called within a withMutations
	  var prevValidSiblingKey = originalBlockMap.get(block.getKey()).getPrevSiblingKey();
	
	  while (prevValidSiblingKey && !blockMap.get(prevValidSiblingKey)) {
	    prevValidSiblingKey = originalBlockMap.get(prevValidSiblingKey).getPrevSiblingKey() || null;
	  }
	
	  return prevValidSiblingKey;
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, startBlock, endBlock, originalBlockMap) {
	  return blockMap.withMutations(function (blocks) {
	    // update start block if its retained
	    transformBlock(startBlock.getKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap),
	        prevSibling: getPrevValidSibling(startBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update endblock if its retained
	    transformBlock(endBlock.getKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(endBlock, blocks, originalBlockMap),
	        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update start block parent ancestors
	    getAncestorsKeys(startBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
	      return transformBlock(parentKey, blocks, function (block) {
	        return block.merge({
	          children: block.getChildKeys().filter(function (key) {
	            return blocks.get(key);
	          }),
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	
	    // update start block next - can only happen if startBlock == endBlock
	    transformBlock(startBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: startBlock.getPrevSiblingKey()
	      });
	    });
	
	    // update start block prev
	    transformBlock(startBlock.getPrevSiblingKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: getNextValidSibling(startBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update end block next
	    transformBlock(endBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: getPrevValidSibling(endBlock, blocks, originalBlockMap)
	      });
	    });
	
	    // update end block prev
	    transformBlock(endBlock.getPrevSiblingKey(), blocks, function (block) {
	      return block.merge({
	        nextSibling: endBlock.getNextSiblingKey()
	      });
	    });
	
	    // update end block parent ancestors
	    getAncestorsKeys(endBlock.getKey(), originalBlockMap).forEach(function (parentKey) {
	      transformBlock(parentKey, blocks, function (block) {
	        return block.merge({
	          children: block.getChildKeys().filter(function (key) {
	            return blocks.get(key);
	          }),
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	
	    // update next delimiters all the way to a root delimiter
	    getNextDelimitersBlockKeys(endBlock, originalBlockMap).forEach(function (delimiterKey) {
	      return transformBlock(delimiterKey, blocks, function (block) {
	        return block.merge({
	          nextSibling: getNextValidSibling(block, blocks, originalBlockMap),
	          prevSibling: getPrevValidSibling(block, blocks, originalBlockMap)
	        });
	      });
	    });
	  });
	};
	
	var removeRangeFromContentState = function removeRangeFromContentState(contentState, selectionState) {
	  if (selectionState.isCollapsed()) {
	    return contentState;
	  }
	
	  var blockMap = contentState.getBlockMap();
	  var startKey = selectionState.getStartKey();
	  var startOffset = selectionState.getStartOffset();
	  var endKey = selectionState.getEndKey();
	  var endOffset = selectionState.getEndOffset();
	
	  var startBlock = blockMap.get(startKey);
	  var endBlock = blockMap.get(endKey);
	
	  // we assume that ContentBlockNode and ContentBlocks are not mixed together
	  var isExperimentalTreeBlock = startBlock instanceof ContentBlockNode;
	
	  // used to retain blocks that should not be deleted to avoid orphan children
	  var parentAncestors = [];
	
	  if (isExperimentalTreeBlock) {
	    var endBlockchildrenKeys = endBlock.getChildKeys();
	    var endBlockAncestors = getAncestorsKeys(endKey, blockMap);
	
	    // endBlock has unselected sibblings so we can not remove its ancestors parents
	    if (endBlock.getNextSiblingKey()) {
	      parentAncestors = parentAncestors.concat(endBlockAncestors);
	    }
	
	    // endBlock has children so can not remove this block or any of its ancestors
	    if (!endBlockchildrenKeys.isEmpty()) {
	      parentAncestors = parentAncestors.concat(endBlockAncestors.concat([endKey]));
	    }
	
	    // we need to retain all ancestors of the next delimiter block
	    parentAncestors = parentAncestors.concat(getAncestorsKeys(getNextDelimiterBlockKey(endBlock, blockMap), blockMap));
	  }
	
	  var characterList = void 0;
	
	  if (startBlock === endBlock) {
	    characterList = removeFromList(startBlock.getCharacterList(), startOffset, endOffset);
	  } else {
	    characterList = startBlock.getCharacterList().slice(0, startOffset).concat(endBlock.getCharacterList().slice(endOffset));
	  }
	
	  var modifiedStart = startBlock.merge({
	    text: startBlock.getText().slice(0, startOffset) + endBlock.getText().slice(endOffset),
	    characterList: characterList
	  });
	
	  var newBlocks = blockMap.toSeq().skipUntil(function (_, k) {
	    return k === startKey;
	  }).takeUntil(function (_, k) {
	    return k === endKey;
	  }).filter(function (_, k) {
	    return parentAncestors.indexOf(k) === -1;
	  }).concat(Map([[endKey, null]])).map(function (_, k) {
	    return k === startKey ? modifiedStart : null;
	  });
	
	  var updatedBlockMap = blockMap.merge(newBlocks).filter(function (block) {
	    return !!block;
	  });
	
	  if (isExperimentalTreeBlock) {
	    updatedBlockMap = updateBlockMapLinks(updatedBlockMap, startBlock, endBlock, blockMap);
	  }
	
	  return contentState.merge({
	    blockMap: updatedBlockMap,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: startKey,
	      anchorOffset: startOffset,
	      focusKey: startKey,
	      focusOffset: startOffset,
	      isBackward: false
	    })
	  });
	};
	
	/**
	 * Maintain persistence for target list when removing characters on the
	 * head and tail of the character list.
	 */
	var removeFromList = function removeFromList(targetList, startOffset, endOffset) {
	  if (startOffset === 0) {
	    while (startOffset < endOffset) {
	      targetList = targetList.shift();
	      startOffset++;
	    }
	  } else if (endOffset === targetList.count()) {
	    while (endOffset > startOffset) {
	      targetList = targetList.pop();
	      endOffset--;
	    }
	  } else {
	    var head = targetList.slice(0, startOffset);
	    var tail = targetList.slice(endOffset);
	    targetList = head.concat(tail).toList();
	  }
	  return targetList;
	};
	
	module.exports = removeRangeFromContentState;

/***/ },
/* 2195 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule setDraftEditorSelection
	 * @format
	 * 
	 */
	
	'use strict';
	
	var DraftJsDebugLogging = __webpack_require__(2147);
	
	var containsNode = __webpack_require__(365);
	var getActiveElement = __webpack_require__(366);
	var invariant = __webpack_require__(18);
	
	function getAnonymizedDOM(node, getNodeLabels) {
	  if (!node) {
	    return '[empty]';
	  }
	
	  var anonymized = anonymizeTextWithin(node, getNodeLabels);
	  if (anonymized.nodeType === Node.TEXT_NODE) {
	    return anonymized.textContent;
	  }
	
	  !(anonymized instanceof Element) ?  false ? invariant(false, 'Node must be an Element if it is not a text node.') : invariant(false) : void 0;
	  return anonymized.outerHTML;
	}
	
	function anonymizeTextWithin(node, getNodeLabels) {
	  var labels = getNodeLabels !== undefined ? getNodeLabels(node) : [];
	
	  if (node.nodeType === Node.TEXT_NODE) {
	    var length = node.textContent.length;
	    return document.createTextNode('[text ' + length + (labels.length ? ' | ' + labels.join(', ') : '') + ']');
	  }
	
	  var clone = node.cloneNode();
	  if (clone.nodeType === 1 && labels.length) {
	    clone.setAttribute('data-labels', labels.join(', '));
	  }
	  var childNodes = node.childNodes;
	  for (var ii = 0; ii < childNodes.length; ii++) {
	    clone.appendChild(anonymizeTextWithin(childNodes[ii], getNodeLabels));
	  }
	
	  return clone;
	}
	
	function getAnonymizedEditorDOM(node, getNodeLabels) {
	  // grabbing the DOM content of the Draft editor
	  var currentNode = node;
	  while (currentNode) {
	    if (currentNode instanceof Element && currentNode.hasAttribute('contenteditable')) {
	      // found the Draft editor container
	      return getAnonymizedDOM(currentNode, getNodeLabels);
	    } else {
	      currentNode = currentNode.parentNode;
	    }
	  }
	  return 'Could not find contentEditable parent of node';
	}
	
	function getNodeLength(node) {
	  return node.nodeValue === null ? node.childNodes.length : node.nodeValue.length;
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 */
	function setDraftEditorSelection(selectionState, node, blockKey, nodeStart, nodeEnd) {
	  // It's possible that the editor has been removed from the DOM but
	  // our selection code doesn't know it yet. Forcing selection in
	  // this case may lead to errors, so just bail now.
	  if (!containsNode(document.documentElement, node)) {
	    return;
	  }
	
	  var selection = global.getSelection();
	  var anchorKey = selectionState.getAnchorKey();
	  var anchorOffset = selectionState.getAnchorOffset();
	  var focusKey = selectionState.getFocusKey();
	  var focusOffset = selectionState.getFocusOffset();
	  var isBackward = selectionState.getIsBackward();
	
	  // IE doesn't support backward selection. Swap key/offset pairs.
	  if (!selection.extend && isBackward) {
	    var tempKey = anchorKey;
	    var tempOffset = anchorOffset;
	    anchorKey = focusKey;
	    anchorOffset = focusOffset;
	    focusKey = tempKey;
	    focusOffset = tempOffset;
	    isBackward = false;
	  }
	
	  var hasAnchor = anchorKey === blockKey && nodeStart <= anchorOffset && nodeEnd >= anchorOffset;
	
	  var hasFocus = focusKey === blockKey && nodeStart <= focusOffset && nodeEnd >= focusOffset;
	
	  // If the selection is entirely bound within this node, set the selection
	  // and be done.
	  if (hasAnchor && hasFocus) {
	    selection.removeAllRanges();
	    addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	    addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    return;
	  }
	
	  if (!isBackward) {
	    // If the anchor is within this node, set the range start.
	    if (hasAnchor) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	    }
	
	    // If the focus is within this node, we can assume that we have
	    // already set the appropriate start range on the selection, and
	    // can simply extend the selection.
	    if (hasFocus) {
	      addFocusToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    }
	  } else {
	    // If this node has the focus, set the selection range to be a
	    // collapsed range beginning here. Later, when we encounter the anchor,
	    // we'll use this information to extend the selection.
	    if (hasFocus) {
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, focusOffset - nodeStart, selectionState);
	    }
	
	    // If this node has the anchor, we may assume that the correct
	    // focus information is already stored on the selection object.
	    // We keep track of it, reset the selection range, and extend it
	    // back to the focus point.
	    if (hasAnchor) {
	      var storedFocusNode = selection.focusNode;
	      var storedFocusOffset = selection.focusOffset;
	
	      selection.removeAllRanges();
	      addPointToSelection(selection, node, anchorOffset - nodeStart, selectionState);
	      addFocusToSelection(selection, storedFocusNode, storedFocusOffset, selectionState);
	    }
	  }
	}
	
	/**
	 * Extend selection towards focus point.
	 */
	function addFocusToSelection(selection, node, offset, selectionState) {
	  var activeElement = getActiveElement();
	  if (selection.extend && containsNode(activeElement, node)) {
	    // If `extend` is called while another element has focus, an error is
	    // thrown. We therefore disable `extend` if the active element is somewhere
	    // other than the node we are selecting. This should only occur in Firefox,
	    // since it is the only browser to support multiple selections.
	    // See https://bugzilla.mozilla.org/show_bug.cgi?id=921444.
	
	    // logging to catch bug that is being reported in t16250795
	    if (offset > getNodeLength(node)) {
	      // the call to 'selection.extend' is about to throw
	      DraftJsDebugLogging.logSelectionStateFailure({
	        anonymizedDom: getAnonymizedEditorDOM(node),
	        extraParams: JSON.stringify({ offset: offset }),
	        selectionState: JSON.stringify(selectionState.toJS())
	      });
	    }
	
	    // logging to catch bug that is being reported in t18110632
	    var nodeWasFocus = node === selection.focusNode;
	    try {
	      selection.extend(node, offset);
	    } catch (e) {
	      DraftJsDebugLogging.logSelectionStateFailure({
	        anonymizedDom: getAnonymizedEditorDOM(node, function (n) {
	          var labels = [];
	          if (n === activeElement) {
	            labels.push('active element');
	          }
	          if (n === selection.anchorNode) {
	            labels.push('selection anchor node');
	          }
	          if (n === selection.focusNode) {
	            labels.push('selection focus node');
	          }
	          return labels;
	        }),
	        extraParams: JSON.stringify({
	          activeElementName: activeElement ? activeElement.nodeName : null,
	          nodeIsFocus: node === selection.focusNode,
	          nodeWasFocus: nodeWasFocus,
	          selectionRangeCount: selection.rangeCount,
	          selectionAnchorNodeName: selection.anchorNode ? selection.anchorNode.nodeName : null,
	          selectionAnchorOffset: selection.anchorOffset,
	          selectionFocusNodeName: selection.focusNode ? selection.focusNode.nodeName : null,
	          selectionFocusOffset: selection.focusOffset,
	          message: e ? '' + e : null,
	          offset: offset
	        }, null, 2),
	        selectionState: JSON.stringify(selectionState.toJS(), null, 2)
	      });
	      // allow the error to be thrown -
	      // better than continuing in a broken state
	      throw e;
	    }
	  } else {
	    // IE doesn't support extend. This will mean no backward selection.
	    // Extract the existing selection range and add focus to it.
	    // Additionally, clone the selection range. IE11 throws an
	    // InvalidStateError when attempting to access selection properties
	    // after the range is detached.
	    var range = selection.getRangeAt(0);
	    range.setEnd(node, offset);
	    selection.addRange(range.cloneRange());
	  }
	}
	
	function addPointToSelection(selection, node, offset, selectionState) {
	  var range = document.createRange();
	  // logging to catch bug that is being reported in t16250795
	  if (offset > getNodeLength(node)) {
	    // in this case we know that the call to 'range.setStart' is about to throw
	    DraftJsDebugLogging.logSelectionStateFailure({
	      anonymizedDom: getAnonymizedEditorDOM(node),
	      extraParams: JSON.stringify({ offset: offset }),
	      selectionState: JSON.stringify(selectionState.toJS())
	    });
	  }
	  range.setStart(node, offset);
	  selection.addRange(range);
	}
	
	module.exports = setDraftEditorSelection;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2196 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitBlockInContentState
	 * @format
	 * 
	 */
	
	'use strict';
	
	var ContentBlockNode = __webpack_require__(108);
	var Immutable = __webpack_require__(39);
	
	var generateRandomKey = __webpack_require__(158);
	var invariant = __webpack_require__(18);
	
	var List = Immutable.List,
	    Map = Immutable.Map;
	
	
	var transformBlock = function transformBlock(key, blockMap, func) {
	  if (!key) {
	    return;
	  }
	
	  var block = blockMap.get(key);
	
	  if (!block) {
	    return;
	  }
	
	  blockMap.set(key, func(block));
	};
	
	var updateBlockMapLinks = function updateBlockMapLinks(blockMap, originalBlock, belowBlock) {
	  return blockMap.withMutations(function (blocks) {
	    var originalBlockKey = originalBlock.getKey();
	    var belowBlockKey = belowBlock.getKey();
	
	    // update block parent
	    transformBlock(originalBlock.getParentKey(), blocks, function (block) {
	      var parentChildrenList = block.getChildKeys();
	      var insertionIndex = parentChildrenList.indexOf(originalBlockKey) + 1;
	      var newChildrenArray = parentChildrenList.toArray();
	
	      newChildrenArray.splice(insertionIndex, 0, belowBlockKey);
	
	      return block.merge({
	        children: List(newChildrenArray)
	      });
	    });
	
	    // update original next block
	    transformBlock(originalBlock.getNextSiblingKey(), blocks, function (block) {
	      return block.merge({
	        prevSibling: belowBlockKey
	      });
	    });
	
	    // update original block
	    transformBlock(originalBlockKey, blocks, function (block) {
	      return block.merge({
	        nextSibling: belowBlockKey
	      });
	    });
	
	    // update below block
	    transformBlock(belowBlockKey, blocks, function (block) {
	      return block.merge({
	        prevSibling: originalBlockKey
	      });
	    });
	  });
	};
	
	var splitBlockInContentState = function splitBlockInContentState(contentState, selectionState) {
	  !selectionState.isCollapsed() ?  false ? invariant(false, 'Selection range must be collapsed.') : invariant(false) : void 0;
	
	  var key = selectionState.getAnchorKey();
	  var offset = selectionState.getAnchorOffset();
	  var blockMap = contentState.getBlockMap();
	  var blockToSplit = blockMap.get(key);
	  var text = blockToSplit.getText();
	  var chars = blockToSplit.getCharacterList();
	  var keyBelow = generateRandomKey();
	  var isExperimentalTreeBlock = blockToSplit instanceof ContentBlockNode;
	
	  var blockAbove = blockToSplit.merge({
	    text: text.slice(0, offset),
	    characterList: chars.slice(0, offset)
	  });
	  var blockBelow = blockAbove.merge({
	    key: keyBelow,
	    text: text.slice(offset),
	    characterList: chars.slice(offset),
	    data: Map()
	  });
	
	  var blocksBefore = blockMap.toSeq().takeUntil(function (v) {
	    return v === blockToSplit;
	  });
	  var blocksAfter = blockMap.toSeq().skipUntil(function (v) {
	    return v === blockToSplit;
	  }).rest();
	  var newBlocks = blocksBefore.concat([[key, blockAbove], [keyBelow, blockBelow]], blocksAfter).toOrderedMap();
	
	  if (isExperimentalTreeBlock) {
	    !blockToSplit.getChildKeys().isEmpty() ?  false ? invariant(false, 'ContentBlockNode must not have children') : invariant(false) : void 0;
	
	    newBlocks = updateBlockMapLinks(newBlocks, blockAbove, blockBelow);
	  }
	
	  return contentState.merge({
	    blockMap: newBlocks,
	    selectionBefore: selectionState,
	    selectionAfter: selectionState.merge({
	      anchorKey: keyBelow,
	      anchorOffset: 0,
	      focusKey: keyBelow,
	      focusOffset: 0,
	      isBackward: false
	    })
	  });
	};
	
	module.exports = splitBlockInContentState;

/***/ },
/* 2197 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 *
	 * @providesModule splitTextIntoTextBlocks
	 * @format
	 * 
	 */
	
	'use strict';
	
	var NEWLINE_REGEX = /\r\n?|\n/g;
	
	function splitTextIntoTextBlocks(text) {
	  return text.split(NEWLINE_REGEX);
	}
	
	module.exports = splitTextIntoTextBlocks;

/***/ },
/* 2198 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var _barGrid = __webpack_require__(359);
	
	var layout = _barGrid.layout;
	var largeLayout = _barGrid.largeLayout;
	
	__webpack_require__(512);
	
	__webpack_require__(2199);
	
	__webpack_require__(2200);
	
	__webpack_require__(290);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerLayout(echarts.PRIORITY.VISUAL.LAYOUT, zrUtil.curry(layout, 'bar')); // Use higher prority to avoid to be blocked by other overall layout, which do not
	// only exist in this module, but probably also exist in other modules, like `barPolar`.
	
	echarts.registerLayout(echarts.PRIORITY.VISUAL.PROGRESSIVE_LAYOUT, largeLayout);
	echarts.registerVisual({
	  seriesType: 'bar',
	  reset: function (seriesModel) {
	    // Visual coding for legend
	    seriesModel.getData().setVisual('legendSymbol', 'roundRect');
	  }
	});

/***/ },
/* 2199 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseBarSeries = __webpack_require__(821);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = BaseBarSeries.extend({
	  type: 'series.bar',
	  dependencies: ['grid', 'polar'],
	  brushSelector: 'rect',
	
	  /**
	   * @override
	   */
	  getProgressive: function () {
	    // Do not support progressive in normal mode.
	    return this.get('large') ? this.get('progressive') : false;
	  },
	
	  /**
	   * @override
	   */
	  getProgressiveThreshold: function () {
	    // Do not support progressive in normal mode.
	    var progressiveThreshold = this.get('progressiveThreshold');
	    var largeThreshold = this.get('largeThreshold');
	
	    if (largeThreshold > progressiveThreshold) {
	      progressiveThreshold = largeThreshold;
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    // If clipped
	    // Only available on cartesian2d
	    clip: true,
	    // If use caps on two sides of bars
	    // Only available on tangential polar bar
	    roundCap: false,
	    showBackground: false,
	    backgroundStyle: {
	      color: 'rgba(180, 180, 180, 0.2)',
	      borderColor: null,
	      borderWidth: 0,
	      borderType: 'solid',
	      borderRadius: 0,
	      shadowBlur: 0,
	      shadowColor: null,
	      shadowOffsetX: 0,
	      shadowOffsetY: 0,
	      opacity: 1
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2200 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var _helper = __webpack_require__(822);
	
	var setLabel = _helper.setLabel;
	
	var Model = __webpack_require__(70);
	
	var barItemStyle = __webpack_require__(2203);
	
	var Path = __webpack_require__(67);
	
	var Group = __webpack_require__(223);
	
	var _throttle = __webpack_require__(181);
	
	var throttle = _throttle.throttle;
	
	var _createClipPathFromCoordSys = __webpack_require__(288);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	var Sausage = __webpack_require__(2455);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'barBorderWidth'];
	var _eventPos = [0, 0]; // FIXME
	// Just for compatible with ec2.
	
	zrUtil.extend(Model.prototype, barItemStyle);
	
	function getClipArea(coord, data) {
	  var coordSysClipArea = coord.getArea && coord.getArea();
	
	  if (coord.type === 'cartesian2d') {
	    var baseAxis = coord.getBaseAxis(); // When boundaryGap is false or using time axis. bar may exceed the grid.
	    // We should not clip this part.
	    // See test/bar2.html
	
	    if (baseAxis.type !== 'category' || !baseAxis.onBand) {
	      var expandWidth = data.getLayout('bandWidth');
	
	      if (baseAxis.isHorizontal()) {
	        coordSysClipArea.x -= expandWidth;
	        coordSysClipArea.width += expandWidth * 2;
	      } else {
	        coordSysClipArea.y -= expandWidth;
	        coordSysClipArea.height += expandWidth * 2;
	      }
	    }
	  }
	
	  return coordSysClipArea;
	}
	
	var _default = echarts.extendChartView({
	  type: 'bar',
	  render: function (seriesModel, ecModel, api) {
	    this._updateDrawMode(seriesModel);
	
	    var coordinateSystemType = seriesModel.get('coordinateSystem');
	
	    if (coordinateSystemType === 'cartesian2d' || coordinateSystemType === 'polar') {
	      this._isLargeDraw ? this._renderLarge(seriesModel, ecModel, api) : this._renderNormal(seriesModel, ecModel, api);
	    } else {}
	
	    return this.group;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    this._updateDrawMode(seriesModel);
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    // Do not support progressive in normal mode.
	    this._incrementalRenderLarge(params, seriesModel);
	  },
	  _updateDrawMode: function (seriesModel) {
	    var isLargeDraw = seriesModel.pipelineContext.large;
	
	    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
	      this._isLargeDraw = isLargeDraw;
	
	      this._clear();
	    }
	  },
	  _renderNormal: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coord = seriesModel.coordinateSystem;
	    var baseAxis = coord.getBaseAxis();
	    var isHorizontalOrRadial;
	
	    if (coord.type === 'cartesian2d') {
	      isHorizontalOrRadial = baseAxis.isHorizontal();
	    } else if (coord.type === 'polar') {
	      isHorizontalOrRadial = baseAxis.dim === 'angle';
	    }
	
	    var animationModel = seriesModel.isAnimationEnabled() ? seriesModel : null;
	    var needsClip = seriesModel.get('clip', true);
	    var coordSysClipArea = getClipArea(coord, data); // If there is clipPath created in large mode. Remove it.
	
	    group.removeClipPath(); // We don't use clipPath in normal mode because we needs a perfect animation
	    // And don't want the label are clipped.
	
	    var roundCap = seriesModel.get('roundCap', true);
	    var drawBackground = seriesModel.get('showBackground', true);
	    var backgroundModel = seriesModel.getModel('backgroundStyle');
	    var barBorderRadius = backgroundModel.get('barBorderRadius') || 0;
	    var bgEls = [];
	    var oldBgEls = this._backgroundEls || [];
	
	    var createBackground = function (dataIndex) {
	      var bgLayout = getLayout[coord.type](data, dataIndex);
	      var bgEl = createBackgroundEl(coord, isHorizontalOrRadial, bgLayout);
	      bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.
	
	      if (coord.type === 'cartesian2d') {
	        bgEl.setShape('r', barBorderRadius);
	      }
	
	      bgEls[dataIndex] = bgEl;
	      return bgEl;
	    };
	
	    data.diff(oldData).add(function (dataIndex) {
	      var itemModel = data.getItemModel(dataIndex);
	      var layout = getLayout[coord.type](data, dataIndex, itemModel);
	
	      if (drawBackground) {
	        createBackground(dataIndex);
	      } // If dataZoom in filteMode: 'empty', the baseValue can be set as NaN in "axisProxy".
	
	
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      if (needsClip) {
	        // Clip will modify the layout params.
	        // And return a boolean to determine if the shape are fully clipped.
	        var isClipped = clip[coord.type](coordSysClipArea, layout);
	
	        if (isClipped) {
	          group.remove(el);
	          return;
	        }
	      }
	
	      var el = elementCreator[coord.type](dataIndex, layout, isHorizontalOrRadial, animationModel, false, roundCap);
	      data.setItemGraphicEl(dataIndex, el);
	      group.add(el);
	      updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).update(function (newIndex, oldIndex) {
	      var itemModel = data.getItemModel(newIndex);
	      var layout = getLayout[coord.type](data, newIndex, itemModel);
	
	      if (drawBackground) {
	        var bgEl;
	
	        if (oldBgEls.length === 0) {
	          bgEl = createBackground(oldIndex);
	        } else {
	          bgEl = oldBgEls[oldIndex];
	          bgEl.useStyle(backgroundModel.getBarItemStyle()); // Only cartesian2d support borderRadius.
	
	          if (coord.type === 'cartesian2d') {
	            bgEl.setShape('r', barBorderRadius);
	          }
	
	          bgEls[newIndex] = bgEl;
	        }
	
	        var bgLayout = getLayout[coord.type](data, newIndex);
	        var shape = createBackgroundShape(isHorizontalOrRadial, bgLayout, coord);
	        graphic.updateProps(bgEl, {
	          shape: shape
	        }, animationModel, newIndex);
	      }
	
	      var el = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(el);
	        return;
	      }
	
	      if (needsClip) {
	        var isClipped = clip[coord.type](coordSysClipArea, layout);
	
	        if (isClipped) {
	          group.remove(el);
	          return;
	        }
	      }
	
	      if (el) {
	        graphic.updateProps(el, {
	          shape: layout
	        }, animationModel, newIndex);
	      } else {
	        el = elementCreator[coord.type](newIndex, layout, isHorizontalOrRadial, animationModel, true, roundCap);
	      }
	
	      data.setItemGraphicEl(newIndex, el); // Add back
	
	      group.add(el);
	      updateStyle(el, data, newIndex, itemModel, layout, seriesModel, isHorizontalOrRadial, coord.type === 'polar');
	    }).remove(function (dataIndex) {
	      var el = oldData.getItemGraphicEl(dataIndex);
	
	      if (coord.type === 'cartesian2d') {
	        el && removeRect(dataIndex, animationModel, el);
	      } else {
	        el && removeSector(dataIndex, animationModel, el);
	      }
	    }).execute();
	    var bgGroup = this._backgroundGroup || (this._backgroundGroup = new Group());
	    bgGroup.removeAll();
	
	    for (var i = 0; i < bgEls.length; ++i) {
	      bgGroup.add(bgEls[i]);
	    }
	
	    group.add(bgGroup);
	    this._backgroundEls = bgEls;
	    this._data = data;
	  },
	  _renderLarge: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    createLarge(seriesModel, this.group); // Use clipPath in large mode.
	
	    var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	  },
	  _incrementalRenderLarge: function (params, seriesModel) {
	    this._removeBackground();
	
	    createLarge(seriesModel, this.group, true);
	  },
	  dispose: zrUtil.noop,
	  remove: function (ecModel) {
	    this._clear(ecModel);
	  },
	  _clear: function (ecModel) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel && ecModel.get('animation') && data && !this._isLargeDraw) {
	      this._removeBackground();
	
	      this._backgroundEls = [];
	      data.eachItemGraphicEl(function (el) {
	        if (el.type === 'sector') {
	          removeSector(el.dataIndex, ecModel, el);
	        } else {
	          removeRect(el.dataIndex, ecModel, el);
	        }
	      });
	    } else {
	      group.removeAll();
	    }
	
	    this._data = null;
	  },
	  _removeBackground: function () {
	    this.group.remove(this._backgroundGroup);
	    this._backgroundGroup = null;
	  }
	});
	
	var mathMax = Math.max;
	var mathMin = Math.min;
	var clip = {
	  cartesian2d: function (coordSysBoundingRect, layout) {
	    var signWidth = layout.width < 0 ? -1 : 1;
	    var signHeight = layout.height < 0 ? -1 : 1; // Needs positive width and height
	
	    if (signWidth < 0) {
	      layout.x += layout.width;
	      layout.width = -layout.width;
	    }
	
	    if (signHeight < 0) {
	      layout.y += layout.height;
	      layout.height = -layout.height;
	    }
	
	    var x = mathMax(layout.x, coordSysBoundingRect.x);
	    var x2 = mathMin(layout.x + layout.width, coordSysBoundingRect.x + coordSysBoundingRect.width);
	    var y = mathMax(layout.y, coordSysBoundingRect.y);
	    var y2 = mathMin(layout.y + layout.height, coordSysBoundingRect.y + coordSysBoundingRect.height);
	    layout.x = x;
	    layout.y = y;
	    layout.width = x2 - x;
	    layout.height = y2 - y;
	    var clipped = layout.width < 0 || layout.height < 0; // Reverse back
	
	    if (signWidth < 0) {
	      layout.x += layout.width;
	      layout.width = -layout.width;
	    }
	
	    if (signHeight < 0) {
	      layout.y += layout.height;
	      layout.height = -layout.height;
	    }
	
	    return clipped;
	  },
	  polar: function (coordSysClipArea, layout) {
	    var signR = layout.r0 <= layout.r ? 1 : -1; // Make sure r is larger than r0
	
	    if (signR < 0) {
	      var r = layout.r;
	      layout.r = layout.r0;
	      layout.r0 = r;
	    }
	
	    var r = mathMin(layout.r, coordSysClipArea.r);
	    var r0 = mathMax(layout.r0, coordSysClipArea.r0);
	    layout.r = r;
	    layout.r0 = r0;
	    var clipped = r - r0 < 0; // Reverse back
	
	    if (signR < 0) {
	      var r = layout.r;
	      layout.r = layout.r0;
	      layout.r0 = r;
	    }
	
	    return clipped;
	  }
	};
	var elementCreator = {
	  cartesian2d: function (dataIndex, layout, isHorizontal, animationModel, isUpdate) {
	    var rect = new graphic.Rect({
	      shape: zrUtil.extend({}, layout),
	      z2: 1
	    });
	    rect.name = 'item'; // Animation
	
	    if (animationModel) {
	      var rectShape = rect.shape;
	      var animateProperty = isHorizontal ? 'height' : 'width';
	      var animateTarget = {};
	      rectShape[animateProperty] = 0;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](rect, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return rect;
	  },
	  polar: function (dataIndex, layout, isRadial, animationModel, isUpdate, roundCap) {
	    // Keep the same logic with bar in catesion: use end value to control
	    // direction. Notice that if clockwise is true (by default), the sector
	    // will always draw clockwisely, no matter whether endAngle is greater
	    // or less than startAngle.
	    var clockwise = layout.startAngle < layout.endAngle;
	    var ShapeClass = !isRadial && roundCap ? Sausage : graphic.Sector;
	    var sector = new ShapeClass({
	      shape: zrUtil.defaults({
	        clockwise: clockwise
	      }, layout),
	      z2: 1
	    });
	    sector.name = 'item'; // Animation
	
	    if (animationModel) {
	      var sectorShape = sector.shape;
	      var animateProperty = isRadial ? 'r' : 'endAngle';
	      var animateTarget = {};
	      sectorShape[animateProperty] = isRadial ? 0 : layout.startAngle;
	      animateTarget[animateProperty] = layout[animateProperty];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](sector, {
	        shape: animateTarget
	      }, animationModel, dataIndex);
	    }
	
	    return sector;
	  }
	};
	
	function removeRect(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      width: 0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	function removeSector(dataIndex, animationModel, el) {
	  // Not show text when animating
	  el.style.text = null;
	  graphic.updateProps(el, {
	    shape: {
	      r: el.shape.r0
	    }
	  }, animationModel, dataIndex, function () {
	    el.parent && el.parent.remove(el);
	  });
	}
	
	var getLayout = {
	  // itemModel is only used to get borderWidth, which is not needed
	  // when calculating bar background layout.
	  cartesian2d: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    var fixedLineWidth = itemModel ? getLineWidth(itemModel, layout) : 0; // fix layout with lineWidth
	
	    var signX = layout.width > 0 ? 1 : -1;
	    var signY = layout.height > 0 ? 1 : -1;
	    return {
	      x: layout.x + signX * fixedLineWidth / 2,
	      y: layout.y + signY * fixedLineWidth / 2,
	      width: layout.width - signX * fixedLineWidth,
	      height: layout.height - signY * fixedLineWidth
	    };
	  },
	  polar: function (data, dataIndex, itemModel) {
	    var layout = data.getItemLayout(dataIndex);
	    return {
	      cx: layout.cx,
	      cy: layout.cy,
	      r0: layout.r0,
	      r: layout.r,
	      startAngle: layout.startAngle,
	      endAngle: layout.endAngle
	    };
	  }
	};
	
	function isZeroOnPolar(layout) {
	  return layout.startAngle != null && layout.endAngle != null && layout.startAngle === layout.endAngle;
	}
	
	function updateStyle(el, data, dataIndex, itemModel, layout, seriesModel, isHorizontal, isPolar) {
	  var color = data.getItemVisual(dataIndex, 'color');
	  var opacity = data.getItemVisual(dataIndex, 'opacity');
	  var stroke = data.getVisual('borderColor');
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getBarItemStyle();
	
	  if (!isPolar) {
	    el.setShape('r', itemStyleModel.get('barBorderRadius') || 0);
	  }
	
	  el.useStyle(zrUtil.defaults({
	    stroke: isZeroOnPolar(layout) ? 'none' : stroke,
	    fill: isZeroOnPolar(layout) ? 'none' : color,
	    opacity: opacity
	  }, itemStyleModel.getBarItemStyle()));
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && el.attr('cursor', cursorStyle);
	  var labelPositionOutside = isHorizontal ? layout.height > 0 ? 'bottom' : 'top' : layout.width > 0 ? 'left' : 'right';
	
	  if (!isPolar) {
	    setLabel(el.style, hoverStyle, itemModel, color, seriesModel, dataIndex, labelPositionOutside);
	  }
	
	  if (isZeroOnPolar(layout)) {
	    hoverStyle.fill = hoverStyle.stroke = 'none';
	  }
	
	  graphic.setHoverStyle(el, hoverStyle);
	} // In case width or height are too small.
	
	
	function getLineWidth(itemModel, rawLayout) {
	  var lineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0; // width or height may be NaN for empty data
	
	  var width = isNaN(rawLayout.width) ? Number.MAX_VALUE : Math.abs(rawLayout.width);
	  var height = isNaN(rawLayout.height) ? Number.MAX_VALUE : Math.abs(rawLayout.height);
	  return Math.min(lineWidth, width, height);
	}
	
	var LargePath = Path.extend({
	  type: 'largeBar',
	  shape: {
	    points: []
	  },
	  buildPath: function (ctx, shape) {
	    // Drawing lines is more efficient than drawing
	    // a whole line or drawing rects.
	    var points = shape.points;
	    var startPoint = this.__startPoint;
	    var baseDimIdx = this.__baseDimIdx;
	
	    for (var i = 0; i < points.length; i += 2) {
	      startPoint[baseDimIdx] = points[i + baseDimIdx];
	      ctx.moveTo(startPoint[0], startPoint[1]);
	      ctx.lineTo(points[i], points[i + 1]);
	    }
	  }
	});
	
	function createLarge(seriesModel, group, incremental) {
	  // TODO support polar
	  var data = seriesModel.getData();
	  var startPoint = [];
	  var baseDimIdx = data.getLayout('valueAxisHorizontal') ? 1 : 0;
	  startPoint[1 - baseDimIdx] = data.getLayout('valueAxisStart');
	  var largeDataIndices = data.getLayout('largeDataIndices');
	  var barWidth = data.getLayout('barWidth');
	  var backgroundModel = seriesModel.getModel('backgroundStyle');
	  var drawBackground = seriesModel.get('showBackground', true);
	
	  if (drawBackground) {
	    var points = data.getLayout('largeBackgroundPoints');
	    var backgroundStartPoint = [];
	    backgroundStartPoint[1 - baseDimIdx] = data.getLayout('backgroundStart');
	    var bgEl = new LargePath({
	      shape: {
	        points: points
	      },
	      incremental: !!incremental,
	      __startPoint: backgroundStartPoint,
	      __baseDimIdx: baseDimIdx,
	      __largeDataIndices: largeDataIndices,
	      __barWidth: barWidth,
	      silent: true,
	      z2: 0
	    });
	    setLargeBackgroundStyle(bgEl, backgroundModel, data);
	    group.add(bgEl);
	  }
	
	  var el = new LargePath({
	    shape: {
	      points: data.getLayout('largePoints')
	    },
	    incremental: !!incremental,
	    __startPoint: startPoint,
	    __baseDimIdx: baseDimIdx,
	    __largeDataIndices: largeDataIndices,
	    __barWidth: barWidth
	  });
	  group.add(el);
	  setLargeStyle(el, seriesModel, data); // Enable tooltip and user mouse/touch event handlers.
	
	  el.seriesIndex = seriesModel.seriesIndex;
	
	  if (!seriesModel.get('silent')) {
	    el.on('mousedown', largePathUpdateDataIndex);
	    el.on('mousemove', largePathUpdateDataIndex);
	  }
	} // Use throttle to avoid frequently traverse to find dataIndex.
	
	
	var largePathUpdateDataIndex = throttle(function (event) {
	  var largePath = this;
	  var dataIndex = largePathFindDataIndex(largePath, event.offsetX, event.offsetY);
	  largePath.dataIndex = dataIndex >= 0 ? dataIndex : null;
	}, 30, false);
	
	function largePathFindDataIndex(largePath, x, y) {
	  var baseDimIdx = largePath.__baseDimIdx;
	  var valueDimIdx = 1 - baseDimIdx;
	  var points = largePath.shape.points;
	  var largeDataIndices = largePath.__largeDataIndices;
	  var barWidthHalf = Math.abs(largePath.__barWidth / 2);
	  var startValueVal = largePath.__startPoint[valueDimIdx];
	  _eventPos[0] = x;
	  _eventPos[1] = y;
	  var pointerBaseVal = _eventPos[baseDimIdx];
	  var pointerValueVal = _eventPos[1 - baseDimIdx];
	  var baseLowerBound = pointerBaseVal - barWidthHalf;
	  var baseUpperBound = pointerBaseVal + barWidthHalf;
	
	  for (var i = 0, len = points.length / 2; i < len; i++) {
	    var ii = i * 2;
	    var barBaseVal = points[ii + baseDimIdx];
	    var barValueVal = points[ii + valueDimIdx];
	
	    if (barBaseVal >= baseLowerBound && barBaseVal <= baseUpperBound && (startValueVal <= barValueVal ? pointerValueVal >= startValueVal && pointerValueVal <= barValueVal : pointerValueVal >= barValueVal && pointerValueVal <= startValueVal)) {
	      return largeDataIndices[i];
	    }
	  }
	
	  return -1;
	}
	
	function setLargeStyle(el, seriesModel, data) {
	  var borderColor = data.getVisual('borderColor') || data.getVisual('color');
	  var itemStyle = seriesModel.getModel('itemStyle').getItemStyle(['color', 'borderColor']);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor;
	  el.style.lineWidth = data.getLayout('barWidth');
	}
	
	function setLargeBackgroundStyle(el, backgroundModel, data) {
	  var borderColor = backgroundModel.get('borderColor') || backgroundModel.get('color');
	  var itemStyle = backgroundModel.getItemStyle(['color', 'borderColor']);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor;
	  el.style.lineWidth = data.getLayout('barWidth');
	}
	
	function createBackgroundShape(isHorizontalOrRadial, layout, coord) {
	  var coordLayout;
	  var isPolar = coord.type === 'polar';
	
	  if (isPolar) {
	    coordLayout = coord.getArea();
	  } else {
	    coordLayout = coord.grid.getRect();
	  }
	
	  if (isPolar) {
	    return {
	      cx: coordLayout.cx,
	      cy: coordLayout.cy,
	      r0: isHorizontalOrRadial ? coordLayout.r0 : layout.r0,
	      r: isHorizontalOrRadial ? coordLayout.r : layout.r,
	      startAngle: isHorizontalOrRadial ? layout.startAngle : 0,
	      endAngle: isHorizontalOrRadial ? layout.endAngle : Math.PI * 2
	    };
	  } else {
	    return {
	      x: isHorizontalOrRadial ? layout.x : coordLayout.x,
	      y: isHorizontalOrRadial ? coordLayout.y : layout.y,
	      width: isHorizontalOrRadial ? layout.width : coordLayout.width,
	      height: isHorizontalOrRadial ? coordLayout.height : layout.height
	    };
	  }
	}
	
	function createBackgroundEl(coord, isHorizontalOrRadial, layout) {
	  var ElementClz = coord.type === 'polar' ? graphic.Sector : graphic.Rect;
	  return new ElementClz({
	    shape: createBackgroundShape(isHorizontalOrRadial, layout, coord),
	    silent: true,
	    z2: 0
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2201 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseBarSeries = __webpack_require__(821);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PictorialBarSeries = BaseBarSeries.extend({
	  type: 'series.pictorialBar',
	  dependencies: ['grid'],
	  defaultOption: {
	    symbol: 'circle',
	    // Customized bar shape
	    symbolSize: null,
	    // Can be ['100%', '100%'], null means auto.
	    symbolRotate: null,
	    symbolPosition: null,
	    // 'start' or 'end' or 'center', null means auto.
	    symbolOffset: null,
	    symbolMargin: null,
	    // start margin and end margin. Can be a number or a percent string.
	    // Auto margin by default.
	    symbolRepeat: false,
	    // false/null/undefined, means no repeat.
	    // Can be true, means auto calculate repeat times and cut by data.
	    // Can be a number, specifies repeat times, and do not cut by data.
	    // Can be 'fixed', means auto calculate repeat times but do not cut by data.
	    symbolRepeatDirection: 'end',
	    // 'end' means from 'start' to 'end'.
	    symbolClip: false,
	    symbolBoundingData: null,
	    // Can be 60 or -40 or [-40, 60]
	    symbolPatternSize: 400,
	    // 400 * 400 px
	    barGap: '-100%',
	    // In most case, overlap is needed.
	    // z can be set in data item, which is z2 actually.
	    // Disable progressive
	    progressive: 0,
	    hoverAnimation: false // Open only when needed.
	
	  },
	  getInitialData: function (option) {
	    // Disable stack.
	    option.stack = null;
	    return PictorialBarSeries.superApply(this, 'getInitialData', arguments);
	  }
	});
	var _default = PictorialBarSeries;
	module.exports = _default;

/***/ },
/* 2202 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var _symbol = __webpack_require__(110);
	
	var createSymbol = _symbol.createSymbol;
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	var isNumeric = _number.isNumeric;
	
	var _helper = __webpack_require__(822);
	
	var setLabel = _helper.setLabel;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BAR_BORDER_WIDTH_QUERY = ['itemStyle', 'borderWidth']; // index: +isHorizontal
	
	var LAYOUT_ATTRS = [{
	  xy: 'x',
	  wh: 'width',
	  index: 0,
	  posDesc: ['left', 'right']
	}, {
	  xy: 'y',
	  wh: 'height',
	  index: 1,
	  posDesc: ['top', 'bottom']
	}];
	var pathForLineWidth = new graphic.Circle();
	var BarView = echarts.extendChartView({
	  type: 'pictorialBar',
	  render: function (seriesModel, ecModel, api) {
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var cartesian = seriesModel.coordinateSystem;
	    var baseAxis = cartesian.getBaseAxis();
	    var isHorizontal = !!baseAxis.isHorizontal();
	    var coordSysRect = cartesian.grid.getRect();
	    var opt = {
	      ecSize: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      seriesModel: seriesModel,
	      coordSys: cartesian,
	      coordSysExtent: [[coordSysRect.x, coordSysRect.x + coordSysRect.width], [coordSysRect.y, coordSysRect.y + coordSysRect.height]],
	      isHorizontal: isHorizontal,
	      valueDim: LAYOUT_ATTRS[+isHorizontal],
	      categoryDim: LAYOUT_ATTRS[1 - isHorizontal]
	    };
	    data.diff(oldData).add(function (dataIndex) {
	      if (!data.hasValue(dataIndex)) {
	        return;
	      }
	
	      var itemModel = getItemModel(data, dataIndex);
	      var symbolMeta = getSymbolMeta(data, dataIndex, itemModel, opt);
	      var bar = createBar(data, opt, symbolMeta);
	      data.setItemGraphicEl(dataIndex, bar);
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).update(function (newIndex, oldIndex) {
	      var bar = oldData.getItemGraphicEl(oldIndex);
	
	      if (!data.hasValue(newIndex)) {
	        group.remove(bar);
	        return;
	      }
	
	      var itemModel = getItemModel(data, newIndex);
	      var symbolMeta = getSymbolMeta(data, newIndex, itemModel, opt);
	      var pictorialShapeStr = getShapeStr(data, symbolMeta);
	
	      if (bar && pictorialShapeStr !== bar.__pictorialShapeStr) {
	        group.remove(bar);
	        data.setItemGraphicEl(newIndex, null);
	        bar = null;
	      }
	
	      if (bar) {
	        updateBar(bar, opt, symbolMeta);
	      } else {
	        bar = createBar(data, opt, symbolMeta, true);
	      }
	
	      data.setItemGraphicEl(newIndex, bar);
	      bar.__pictorialSymbolMeta = symbolMeta; // Add back
	
	      group.add(bar);
	      updateCommon(bar, opt, symbolMeta);
	    }).remove(function (dataIndex) {
	      var bar = oldData.getItemGraphicEl(dataIndex);
	      bar && removeBar(oldData, dataIndex, bar.__pictorialSymbolMeta.animationModel, bar);
	    }).execute();
	    this._data = data;
	    return this.group;
	  },
	  dispose: zrUtil.noop,
	  remove: function (ecModel, api) {
	    var group = this.group;
	    var data = this._data;
	
	    if (ecModel.get('animation')) {
	      if (data) {
	        data.eachItemGraphicEl(function (bar) {
	          removeBar(data, bar.dataIndex, ecModel, bar);
	        });
	      }
	    } else {
	      group.removeAll();
	    }
	  }
	}); // Set or calculate default value about symbol, and calculate layout info.
	
	function getSymbolMeta(data, dataIndex, itemModel, opt) {
	  var layout = data.getItemLayout(dataIndex);
	  var symbolRepeat = itemModel.get('symbolRepeat');
	  var symbolClip = itemModel.get('symbolClip');
	  var symbolPosition = itemModel.get('symbolPosition') || 'start';
	  var symbolRotate = itemModel.get('symbolRotate');
	  var rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  var symbolPatternSize = itemModel.get('symbolPatternSize') || 2;
	  var isAnimationEnabled = itemModel.isAnimationEnabled();
	  var symbolMeta = {
	    dataIndex: dataIndex,
	    layout: layout,
	    itemModel: itemModel,
	    symbolType: data.getItemVisual(dataIndex, 'symbol') || 'circle',
	    color: data.getItemVisual(dataIndex, 'color'),
	    symbolClip: symbolClip,
	    symbolRepeat: symbolRepeat,
	    symbolRepeatDirection: itemModel.get('symbolRepeatDirection'),
	    symbolPatternSize: symbolPatternSize,
	    rotation: rotation,
	    animationModel: isAnimationEnabled ? itemModel : null,
	    hoverAnimation: isAnimationEnabled && itemModel.get('hoverAnimation'),
	    z2: itemModel.getShallow('z', true) || 0
	  };
	  prepareBarLength(itemModel, symbolRepeat, layout, opt, symbolMeta);
	  prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, symbolMeta.boundingLength, symbolMeta.pxSign, symbolPatternSize, opt, symbolMeta);
	  prepareLineWidth(itemModel, symbolMeta.symbolScale, rotation, opt, symbolMeta);
	  var symbolSize = symbolMeta.symbolSize;
	  var symbolOffset = itemModel.get('symbolOffset');
	
	  if (zrUtil.isArray(symbolOffset)) {
	    symbolOffset = [parsePercent(symbolOffset[0], symbolSize[0]), parsePercent(symbolOffset[1], symbolSize[1])];
	  }
	
	  prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, symbolMeta.valueLineWidth, symbolMeta.boundingLength, symbolMeta.repeatCutLength, opt, symbolMeta);
	  return symbolMeta;
	} // bar length can be negative.
	
	
	function prepareBarLength(itemModel, symbolRepeat, layout, opt, output) {
	  var valueDim = opt.valueDim;
	  var symbolBoundingData = itemModel.get('symbolBoundingData');
	  var valueAxis = opt.coordSys.getOtherAxis(opt.coordSys.getBaseAxis());
	  var zeroPx = valueAxis.toGlobalCoord(valueAxis.dataToCoord(0));
	  var pxSignIdx = 1 - +(layout[valueDim.wh] <= 0);
	  var boundingLength;
	
	  if (zrUtil.isArray(symbolBoundingData)) {
	    var symbolBoundingExtent = [convertToCoordOnAxis(valueAxis, symbolBoundingData[0]) - zeroPx, convertToCoordOnAxis(valueAxis, symbolBoundingData[1]) - zeroPx];
	    symbolBoundingExtent[1] < symbolBoundingExtent[0] && symbolBoundingExtent.reverse();
	    boundingLength = symbolBoundingExtent[pxSignIdx];
	  } else if (symbolBoundingData != null) {
	    boundingLength = convertToCoordOnAxis(valueAxis, symbolBoundingData) - zeroPx;
	  } else if (symbolRepeat) {
	    boundingLength = opt.coordSysExtent[valueDim.index][pxSignIdx] - zeroPx;
	  } else {
	    boundingLength = layout[valueDim.wh];
	  }
	
	  output.boundingLength = boundingLength;
	
	  if (symbolRepeat) {
	    output.repeatCutLength = layout[valueDim.wh];
	  }
	
	  output.pxSign = boundingLength > 0 ? 1 : boundingLength < 0 ? -1 : 0;
	}
	
	function convertToCoordOnAxis(axis, value) {
	  return axis.toGlobalCoord(axis.dataToCoord(axis.scale.parse(value)));
	} // Support ['100%', '100%']
	
	
	function prepareSymbolSize(data, dataIndex, layout, symbolRepeat, symbolClip, boundingLength, pxSign, symbolPatternSize, opt, output) {
	  var valueDim = opt.valueDim;
	  var categoryDim = opt.categoryDim;
	  var categorySize = Math.abs(layout[categoryDim.wh]);
	  var symbolSize = data.getItemVisual(dataIndex, 'symbolSize');
	
	  if (zrUtil.isArray(symbolSize)) {
	    symbolSize = symbolSize.slice();
	  } else {
	    if (symbolSize == null) {
	      symbolSize = '100%';
	    }
	
	    symbolSize = [symbolSize, symbolSize];
	  } // Note: percentage symbolSize (like '100%') do not consider lineWidth, because it is
	  // to complicated to calculate real percent value if considering scaled lineWidth.
	  // So the actual size will bigger than layout size if lineWidth is bigger than zero,
	  // which can be tolerated in pictorial chart.
	
	
	  symbolSize[categoryDim.index] = parsePercent(symbolSize[categoryDim.index], categorySize);
	  symbolSize[valueDim.index] = parsePercent(symbolSize[valueDim.index], symbolRepeat ? categorySize : Math.abs(boundingLength));
	  output.symbolSize = symbolSize; // If x or y is less than zero, show reversed shape.
	
	  var symbolScale = output.symbolScale = [symbolSize[0] / symbolPatternSize, symbolSize[1] / symbolPatternSize]; // Follow convention, 'right' and 'top' is the normal scale.
	
	  symbolScale[valueDim.index] *= (opt.isHorizontal ? -1 : 1) * pxSign;
	}
	
	function prepareLineWidth(itemModel, symbolScale, rotation, opt, output) {
	  // In symbols are drawn with scale, so do not need to care about the case that width
	  // or height are too small. But symbol use strokeNoScale, where acture lineWidth should
	  // be calculated.
	  var valueLineWidth = itemModel.get(BAR_BORDER_WIDTH_QUERY) || 0;
	
	  if (valueLineWidth) {
	    pathForLineWidth.attr({
	      scale: symbolScale.slice(),
	      rotation: rotation
	    });
	    pathForLineWidth.updateTransform();
	    valueLineWidth /= pathForLineWidth.getLineScale();
	    valueLineWidth *= symbolScale[opt.valueDim.index];
	  }
	
	  output.valueLineWidth = valueLineWidth;
	}
	
	function prepareLayoutInfo(itemModel, symbolSize, layout, symbolRepeat, symbolClip, symbolOffset, symbolPosition, valueLineWidth, boundingLength, repeatCutLength, opt, output) {
	  var categoryDim = opt.categoryDim;
	  var valueDim = opt.valueDim;
	  var pxSign = output.pxSign;
	  var unitLength = Math.max(symbolSize[valueDim.index] + valueLineWidth, 0);
	  var pathLen = unitLength; // Note: rotation will not effect the layout of symbols, because user may
	  // want symbols to rotate on its center, which should not be translated
	  // when rotating.
	
	  if (symbolRepeat) {
	    var absBoundingLength = Math.abs(boundingLength);
	    var symbolMargin = zrUtil.retrieve(itemModel.get('symbolMargin'), '15%') + '';
	    var hasEndGap = false;
	
	    if (symbolMargin.lastIndexOf('!') === symbolMargin.length - 1) {
	      hasEndGap = true;
	      symbolMargin = symbolMargin.slice(0, symbolMargin.length - 1);
	    }
	
	    symbolMargin = parsePercent(symbolMargin, symbolSize[valueDim.index]);
	    var uLenWithMargin = Math.max(unitLength + symbolMargin * 2, 0); // When symbol margin is less than 0, margin at both ends will be subtracted
	    // to ensure that all of the symbols will not be overflow the given area.
	
	    var endFix = hasEndGap ? 0 : symbolMargin * 2; // Both final repeatTimes and final symbolMargin area calculated based on
	    // boundingLength.
	
	    var repeatSpecified = isNumeric(symbolRepeat);
	    var repeatTimes = repeatSpecified ? symbolRepeat : toIntTimes((absBoundingLength + endFix) / uLenWithMargin); // Adjust calculate margin, to ensure each symbol is displayed
	    // entirely in the given layout area.
	
	    var mDiff = absBoundingLength - repeatTimes * unitLength;
	    symbolMargin = mDiff / 2 / (hasEndGap ? repeatTimes : repeatTimes - 1);
	    uLenWithMargin = unitLength + symbolMargin * 2;
	    endFix = hasEndGap ? 0 : symbolMargin * 2; // Update repeatTimes when not all symbol will be shown.
	
	    if (!repeatSpecified && symbolRepeat !== 'fixed') {
	      repeatTimes = repeatCutLength ? toIntTimes((Math.abs(repeatCutLength) + endFix) / uLenWithMargin) : 0;
	    }
	
	    pathLen = repeatTimes * uLenWithMargin - endFix;
	    output.repeatTimes = repeatTimes;
	    output.symbolMargin = symbolMargin;
	  }
	
	  var sizeFix = pxSign * (pathLen / 2);
	  var pathPosition = output.pathPosition = [];
	  pathPosition[categoryDim.index] = layout[categoryDim.wh] / 2;
	  pathPosition[valueDim.index] = symbolPosition === 'start' ? sizeFix : symbolPosition === 'end' ? boundingLength - sizeFix : boundingLength / 2; // 'center'
	
	  if (symbolOffset) {
	    pathPosition[0] += symbolOffset[0];
	    pathPosition[1] += symbolOffset[1];
	  }
	
	  var bundlePosition = output.bundlePosition = [];
	  bundlePosition[categoryDim.index] = layout[categoryDim.xy];
	  bundlePosition[valueDim.index] = layout[valueDim.xy];
	  var barRectShape = output.barRectShape = zrUtil.extend({}, layout);
	  barRectShape[valueDim.wh] = pxSign * Math.max(Math.abs(layout[valueDim.wh]), Math.abs(pathPosition[valueDim.index] + sizeFix));
	  barRectShape[categoryDim.wh] = layout[categoryDim.wh];
	  var clipShape = output.clipShape = {}; // Consider that symbol may be overflow layout rect.
	
	  clipShape[categoryDim.xy] = -layout[categoryDim.xy];
	  clipShape[categoryDim.wh] = opt.ecSize[categoryDim.wh];
	  clipShape[valueDim.xy] = 0;
	  clipShape[valueDim.wh] = layout[valueDim.wh];
	}
	
	function createPath(symbolMeta) {
	  var symbolPatternSize = symbolMeta.symbolPatternSize;
	  var path = createSymbol( // Consider texture img, make a big size.
	  symbolMeta.symbolType, -symbolPatternSize / 2, -symbolPatternSize / 2, symbolPatternSize, symbolPatternSize, symbolMeta.color);
	  path.attr({
	    culling: true
	  });
	  path.type !== 'image' && path.setStyle({
	    strokeNoScale: true
	  });
	  return path;
	}
	
	function createOrUpdateRepeatSymbols(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var symbolSize = symbolMeta.symbolSize;
	  var valueLineWidth = symbolMeta.valueLineWidth;
	  var pathPosition = symbolMeta.pathPosition;
	  var valueDim = opt.valueDim;
	  var repeatTimes = symbolMeta.repeatTimes || 0;
	  var index = 0;
	  var unit = symbolSize[opt.valueDim.index] + valueLineWidth + symbolMeta.symbolMargin * 2;
	  eachPath(bar, function (path) {
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	
	    if (index < repeatTimes) {
	      updateAttr(path, null, makeTarget(index), symbolMeta, isUpdate);
	    } else {
	      updateAttr(path, null, {
	        scale: [0, 0]
	      }, symbolMeta, isUpdate, function () {
	        bundle.remove(path);
	      });
	    }
	
	    updateHoverAnimation(path, symbolMeta);
	    index++;
	  });
	
	  for (; index < repeatTimes; index++) {
	    var path = createPath(symbolMeta);
	    path.__pictorialAnimationIndex = index;
	    path.__pictorialRepeatTimes = repeatTimes;
	    bundle.add(path);
	    var target = makeTarget(index);
	    updateAttr(path, {
	      position: target.position,
	      scale: [0, 0]
	    }, {
	      scale: target.scale,
	      rotation: target.rotation
	    }, symbolMeta, isUpdate); // FIXME
	    // If all emphasis/normal through action.
	
	    path.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	    updateHoverAnimation(path, symbolMeta);
	  }
	
	  function makeTarget(index) {
	    var position = pathPosition.slice(); // (start && pxSign > 0) || (end && pxSign < 0): i = repeatTimes - index
	    // Otherwise: i = index;
	
	    var pxSign = symbolMeta.pxSign;
	    var i = index;
	
	    if (symbolMeta.symbolRepeatDirection === 'start' ? pxSign > 0 : pxSign < 0) {
	      i = repeatTimes - 1 - index;
	    }
	
	    position[valueDim.index] = unit * (i - repeatTimes / 2 + 0.5) + pathPosition[valueDim.index];
	    return {
	      position: position,
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    };
	  }
	
	  function onMouseOver() {
	    eachPath(bar, function (path) {
	      path.trigger('emphasis');
	    });
	  }
	
	  function onMouseOut() {
	    eachPath(bar, function (path) {
	      path.trigger('normal');
	    });
	  }
	}
	
	function createOrUpdateSingleSymbol(bar, opt, symbolMeta, isUpdate) {
	  var bundle = bar.__pictorialBundle;
	  var mainPath = bar.__pictorialMainPath;
	
	  if (!mainPath) {
	    mainPath = bar.__pictorialMainPath = createPath(symbolMeta);
	    bundle.add(mainPath);
	    updateAttr(mainPath, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: [0, 0],
	      rotation: symbolMeta.rotation
	    }, {
	      scale: symbolMeta.symbolScale.slice()
	    }, symbolMeta, isUpdate);
	    mainPath.on('mouseover', onMouseOver).on('mouseout', onMouseOut);
	  } else {
	    updateAttr(mainPath, null, {
	      position: symbolMeta.pathPosition.slice(),
	      scale: symbolMeta.symbolScale.slice(),
	      rotation: symbolMeta.rotation
	    }, symbolMeta, isUpdate);
	  }
	
	  updateHoverAnimation(mainPath, symbolMeta);
	
	  function onMouseOver() {
	    this.trigger('emphasis');
	  }
	
	  function onMouseOut() {
	    this.trigger('normal');
	  }
	} // bar rect is used for label.
	
	
	function createOrUpdateBarRect(bar, symbolMeta, isUpdate) {
	  var rectShape = zrUtil.extend({}, symbolMeta.barRectShape);
	  var barRect = bar.__pictorialBarRect;
	
	  if (!barRect) {
	    barRect = bar.__pictorialBarRect = new graphic.Rect({
	      z2: 2,
	      shape: rectShape,
	      silent: true,
	      style: {
	        stroke: 'transparent',
	        fill: 'transparent',
	        lineWidth: 0
	      }
	    });
	    bar.add(barRect);
	  } else {
	    updateAttr(barRect, null, {
	      shape: rectShape
	    }, symbolMeta, isUpdate);
	  }
	}
	
	function createOrUpdateClip(bar, opt, symbolMeta, isUpdate) {
	  // If not clip, symbol will be remove and rebuilt.
	  if (symbolMeta.symbolClip) {
	    var clipPath = bar.__pictorialClipPath;
	    var clipShape = zrUtil.extend({}, symbolMeta.clipShape);
	    var valueDim = opt.valueDim;
	    var animationModel = symbolMeta.animationModel;
	    var dataIndex = symbolMeta.dataIndex;
	
	    if (clipPath) {
	      graphic.updateProps(clipPath, {
	        shape: clipShape
	      }, animationModel, dataIndex);
	    } else {
	      clipShape[valueDim.wh] = 0;
	      clipPath = new graphic.Rect({
	        shape: clipShape
	      });
	
	      bar.__pictorialBundle.setClipPath(clipPath);
	
	      bar.__pictorialClipPath = clipPath;
	      var target = {};
	      target[valueDim.wh] = symbolMeta.clipShape[valueDim.wh];
	      graphic[isUpdate ? 'updateProps' : 'initProps'](clipPath, {
	        shape: target
	      }, animationModel, dataIndex);
	    }
	  }
	}
	
	function getItemModel(data, dataIndex) {
	  var itemModel = data.getItemModel(dataIndex);
	  itemModel.getAnimationDelayParams = getAnimationDelayParams;
	  itemModel.isAnimationEnabled = isAnimationEnabled;
	  return itemModel;
	}
	
	function getAnimationDelayParams(path) {
	  // The order is the same as the z-order, see `symbolRepeatDiretion`.
	  return {
	    index: path.__pictorialAnimationIndex,
	    count: path.__pictorialRepeatTimes
	  };
	}
	
	function isAnimationEnabled() {
	  // `animation` prop can be set on itemModel in pictorial bar chart.
	  return this.parentModel.isAnimationEnabled() && !!this.getShallow('animation');
	}
	
	function updateHoverAnimation(path, symbolMeta) {
	  path.off('emphasis').off('normal');
	  var scale = symbolMeta.symbolScale.slice();
	  symbolMeta.hoverAnimation && path.on('emphasis', function () {
	    this.animateTo({
	      scale: [scale[0] * 1.1, scale[1] * 1.1]
	    }, 400, 'elasticOut');
	  }).on('normal', function () {
	    this.animateTo({
	      scale: scale.slice()
	    }, 400, 'elasticOut');
	  });
	}
	
	function createBar(data, opt, symbolMeta, isUpdate) {
	  // bar is the main element for each data.
	  var bar = new graphic.Group(); // bundle is used for location and clip.
	
	  var bundle = new graphic.Group();
	  bar.add(bundle);
	  bar.__pictorialBundle = bundle;
	  bundle.attr('position', symbolMeta.bundlePosition.slice());
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, isUpdate);
	  createOrUpdateClip(bar, opt, symbolMeta, isUpdate);
	  bar.__pictorialShapeStr = getShapeStr(data, symbolMeta);
	  bar.__pictorialSymbolMeta = symbolMeta;
	  return bar;
	}
	
	function updateBar(bar, opt, symbolMeta) {
	  var animationModel = symbolMeta.animationModel;
	  var dataIndex = symbolMeta.dataIndex;
	  var bundle = bar.__pictorialBundle;
	  graphic.updateProps(bundle, {
	    position: symbolMeta.bundlePosition.slice()
	  }, animationModel, dataIndex);
	
	  if (symbolMeta.symbolRepeat) {
	    createOrUpdateRepeatSymbols(bar, opt, symbolMeta, true);
	  } else {
	    createOrUpdateSingleSymbol(bar, opt, symbolMeta, true);
	  }
	
	  createOrUpdateBarRect(bar, symbolMeta, true);
	  createOrUpdateClip(bar, opt, symbolMeta, true);
	}
	
	function removeBar(data, dataIndex, animationModel, bar) {
	  // Not show text when animating
	  var labelRect = bar.__pictorialBarRect;
	  labelRect && (labelRect.style.text = null);
	  var pathes = [];
	  eachPath(bar, function (path) {
	    pathes.push(path);
	  });
	  bar.__pictorialMainPath && pathes.push(bar.__pictorialMainPath); // I do not find proper remove animation for clip yet.
	
	  bar.__pictorialClipPath && (animationModel = null);
	  zrUtil.each(pathes, function (path) {
	    graphic.updateProps(path, {
	      scale: [0, 0]
	    }, animationModel, dataIndex, function () {
	      bar.parent && bar.parent.remove(bar);
	    });
	  });
	  data.setItemGraphicEl(dataIndex, null);
	}
	
	function getShapeStr(data, symbolMeta) {
	  return [data.getItemVisual(symbolMeta.dataIndex, 'symbol') || 'none', !!symbolMeta.symbolRepeat, !!symbolMeta.symbolClip].join(':');
	}
	
	function eachPath(bar, cb, context) {
	  // Do not use Group#eachChild, because it do not support remove.
	  zrUtil.each(bar.__pictorialBundle.children(), function (el) {
	    el !== bar.__pictorialBarRect && cb.call(context, el);
	  });
	}
	
	function updateAttr(el, immediateAttrs, animationAttrs, symbolMeta, isUpdate, cb) {
	  immediateAttrs && el.attr(immediateAttrs); // when symbolCip used, only clip path has init animation, otherwise it would be weird effect.
	
	  if (symbolMeta.symbolClip && !isUpdate) {
	    animationAttrs && el.attr(animationAttrs);
	  } else {
	    animationAttrs && graphic[isUpdate ? 'updateProps' : 'initProps'](el, animationAttrs, symbolMeta.animationModel, symbolMeta.dataIndex, cb);
	  }
	}
	
	function updateCommon(bar, opt, symbolMeta) {
	  var color = symbolMeta.color;
	  var dataIndex = symbolMeta.dataIndex;
	  var itemModel = symbolMeta.itemModel; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var normalStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
	  var hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  eachPath(bar, function (path) {
	    // PENDING setColor should be before setStyle!!!
	    path.setColor(color);
	    path.setStyle(zrUtil.defaults({
	      fill: color,
	      opacity: symbolMeta.opacity
	    }, normalStyle));
	    graphic.setHoverStyle(path, hoverStyle);
	    cursorStyle && (path.cursor = cursorStyle);
	    path.z2 = symbolMeta.z2;
	  });
	  var barRectHoverStyle = {};
	  var barPositionOutside = opt.valueDim.posDesc[+(symbolMeta.boundingLength > 0)];
	  var barRect = bar.__pictorialBarRect;
	  setLabel(barRect.style, barRectHoverStyle, itemModel, color, opt.seriesModel, dataIndex, barPositionOutside);
	  graphic.setHoverStyle(barRect, barRectHoverStyle);
	}
	
	function toIntTimes(times) {
	  var roundedTimes = Math.round(times); // Escapse accurate error
	
	  return Math.abs(times - roundedTimes) < 1e-4 ? roundedTimes : Math.ceil(times);
	}
	
	var _default = BarView;
	module.exports = _default;

/***/ },
/* 2203 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(252);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getBarItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], // Compatitable with 2
	['stroke', 'barBorderColor'], ['lineWidth', 'barBorderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getBarItemStyle: function (excludes) {
	    var style = getBarItemStyle(this, excludes);
	
	    if (this.getBorderLineDash) {
	      var lineDash = this.getBorderLineDash();
	      lineDash && (style.lineDash = lineDash);
	    }
	
	    return style;
	  }
	};
	module.exports = _default;

/***/ },
/* 2204 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2205);
	
	__webpack_require__(2206);
	
	var boxplotVisual = __webpack_require__(2208);
	
	var boxplotLayout = __webpack_require__(2207);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(boxplotVisual);
	echarts.registerLayout(boxplotLayout);

/***/ },
/* 2205 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var SeriesModel = __webpack_require__(77);
	
	var _whiskerBoxCommon = __webpack_require__(829);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var BoxplotSeries = SeriesModel.extend({
	  type: 'series.boxplot',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	  // TODO
	  // box width represents group size, so dimension should have 'size'.
	
	  /**
	   * @see <https://en.wikipedia.org/wiki/Box_plot>
	   * The meanings of 'min' and 'max' depend on user,
	   * and echarts do not need to know it.
	   * @readOnly
	   */
	  defaultValueDimensions: [{
	    name: 'min',
	    defaultTooltip: true
	  }, {
	    name: 'Q1',
	    defaultTooltip: true
	  }, {
	    name: 'median',
	    defaultTooltip: true
	  }, {
	    name: 'Q3',
	    defaultTooltip: true
	  }, {
	    name: 'max',
	    defaultTooltip: true
	  }],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    boxWidth: [7, 50],
	    // [min, max] can be percent of band width.
	    itemStyle: {
	      color: '#fff',
	      borderWidth: 1
	    },
	    emphasis: {
	      itemStyle: {
	        borderWidth: 2,
	        shadowBlur: 5,
	        shadowOffsetX: 2,
	        shadowOffsetY: 2,
	        shadowColor: 'rgba(0,0,0,0.4)'
	      }
	    },
	    animationEasing: 'elasticOut',
	    animationDuration: 800
	  }
	});
	zrUtil.mixin(BoxplotSeries, seriesModelMixin, true);
	var _default = BoxplotSeries;
	module.exports = _default;

/***/ },
/* 2206 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var ChartView = __webpack_require__(141);
	
	var graphic = __webpack_require__(14);
	
	var Path = __webpack_require__(67);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Update common properties
	var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
	var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
	var BoxplotView = ChartView.extend({
	  type: 'boxplot',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var group = this.group;
	    var oldData = this._data; // There is no old data only when first rendering or switching from
	    // stream mode to normal mode, where previous elements should be removed.
	
	    if (!this._data) {
	      group.removeAll();
	    }
	
	    var constDim = seriesModel.get('layout') === 'horizontal' ? 1 : 0;
	    data.diff(oldData).add(function (newIdx) {
	      if (data.hasValue(newIdx)) {
	        var itemLayout = data.getItemLayout(newIdx);
	        var symbolEl = createNormalBox(itemLayout, data, newIdx, constDim, true);
	        data.setItemGraphicEl(newIdx, symbolEl);
	        group.add(symbolEl);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	      if (!data.hasValue(newIdx)) {
	        group.remove(symbolEl);
	        return;
	      }
	
	      var itemLayout = data.getItemLayout(newIdx);
	
	      if (!symbolEl) {
	        symbolEl = createNormalBox(itemLayout, data, newIdx, constDim);
	      } else {
	        updateNormalBoxData(itemLayout, symbolEl, data, newIdx);
	      }
	
	      group.add(symbolEl);
	      data.setItemGraphicEl(newIdx, symbolEl);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	  remove: function (ecModel) {
	    var group = this.group;
	    var data = this._data;
	    this._data = null;
	    data && data.eachItemGraphicEl(function (el) {
	      el && group.remove(el);
	    });
	  },
	  dispose: zrUtil.noop
	});
	var BoxPath = Path.extend({
	  type: 'boxplotBoxPath',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    var ends = shape.points;
	    var i = 0;
	    ctx.moveTo(ends[i][0], ends[i][1]);
	    i++;
	
	    for (; i < 4; i++) {
	      ctx.lineTo(ends[i][0], ends[i][1]);
	    }
	
	    ctx.closePath();
	
	    for (; i < ends.length; i++) {
	      ctx.moveTo(ends[i][0], ends[i][1]);
	      i++;
	      ctx.lineTo(ends[i][0], ends[i][1]);
	    }
	  }
	});
	
	function createNormalBox(itemLayout, data, dataIndex, constDim, isInit) {
	  var ends = itemLayout.ends;
	  var el = new BoxPath({
	    shape: {
	      points: isInit ? transInit(ends, constDim, itemLayout) : ends
	    }
	  });
	  updateNormalBoxData(itemLayout, el, data, dataIndex, isInit);
	  return el;
	}
	
	function updateNormalBoxData(itemLayout, el, data, dataIndex, isInit) {
	  var seriesModel = data.hostModel;
	  var updateMethod = graphic[isInit ? 'initProps' : 'updateProps'];
	  updateMethod(el, {
	    shape: {
	      points: itemLayout.ends
	    }
	  }, seriesModel, dataIndex);
	  var itemModel = data.getItemModel(dataIndex);
	  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
	  var borderColor = data.getItemVisual(dataIndex, 'color'); // Exclude borderColor.
	
	  var itemStyle = normalItemStyleModel.getItemStyle(['borderColor']);
	  itemStyle.stroke = borderColor;
	  itemStyle.strokeNoScale = true;
	  el.useStyle(itemStyle);
	  el.z2 = 100;
	  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
	  graphic.setHoverStyle(el, hoverStyle);
	}
	
	function transInit(points, dim, itemLayout) {
	  return zrUtil.map(points, function (point) {
	    point = point.slice();
	    point[dim] = itemLayout.initBaseline;
	    return point;
	  });
	}
	
	var _default = BoxplotView;
	module.exports = _default;

/***/ },
/* 2207 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	
	function _default(ecModel) {
	  var groupResult = groupSeriesByAxis(ecModel);
	  each(groupResult, function (groupItem) {
	    var seriesModels = groupItem.seriesModels;
	
	    if (!seriesModels.length) {
	      return;
	    }
	
	    calculateBase(groupItem);
	    each(seriesModels, function (seriesModel, idx) {
	      layoutSingleSeries(seriesModel, groupItem.boxOffsetList[idx], groupItem.boxWidthList[idx]);
	    });
	  });
	}
	/**
	 * Group series by axis.
	 */
	
	
	function groupSeriesByAxis(ecModel) {
	  var result = [];
	  var axisList = [];
	  ecModel.eachSeriesByType('boxplot', function (seriesModel) {
	    var baseAxis = seriesModel.getBaseAxis();
	    var idx = zrUtil.indexOf(axisList, baseAxis);
	
	    if (idx < 0) {
	      idx = axisList.length;
	      axisList[idx] = baseAxis;
	      result[idx] = {
	        axis: baseAxis,
	        seriesModels: []
	      };
	    }
	
	    result[idx].seriesModels.push(seriesModel);
	  });
	  return result;
	}
	/**
	 * Calculate offset and box width for each series.
	 */
	
	
	function calculateBase(groupItem) {
	  var extent;
	  var baseAxis = groupItem.axis;
	  var seriesModels = groupItem.seriesModels;
	  var seriesCount = seriesModels.length;
	  var boxWidthList = groupItem.boxWidthList = [];
	  var boxOffsetList = groupItem.boxOffsetList = [];
	  var boundList = [];
	  var bandWidth;
	
	  if (baseAxis.type === 'category') {
	    bandWidth = baseAxis.getBandWidth();
	  } else {
	    var maxDataCount = 0;
	    each(seriesModels, function (seriesModel) {
	      maxDataCount = Math.max(maxDataCount, seriesModel.getData().count());
	    });
	    extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / maxDataCount;
	  }
	
	  each(seriesModels, function (seriesModel) {
	    var boxWidthBound = seriesModel.get('boxWidth');
	
	    if (!zrUtil.isArray(boxWidthBound)) {
	      boxWidthBound = [boxWidthBound, boxWidthBound];
	    }
	
	    boundList.push([parsePercent(boxWidthBound[0], bandWidth) || 0, parsePercent(boxWidthBound[1], bandWidth) || 0]);
	  });
	  var availableWidth = bandWidth * 0.8 - 2;
	  var boxGap = availableWidth / seriesCount * 0.3;
	  var boxWidth = (availableWidth - boxGap * (seriesCount - 1)) / seriesCount;
	  var base = boxWidth / 2 - availableWidth / 2;
	  each(seriesModels, function (seriesModel, idx) {
	    boxOffsetList.push(base);
	    base += boxGap + boxWidth;
	    boxWidthList.push(Math.min(Math.max(boxWidth, boundList[idx][0]), boundList[idx][1]));
	  });
	}
	/**
	 * Calculate points location for each series.
	 */
	
	
	function layoutSingleSeries(seriesModel, offset, boxWidth) {
	  var coordSys = seriesModel.coordinateSystem;
	  var data = seriesModel.getData();
	  var halfWidth = boxWidth / 2;
	  var cDimIdx = seriesModel.get('layout') === 'horizontal' ? 0 : 1;
	  var vDimIdx = 1 - cDimIdx;
	  var coordDims = ['x', 'y'];
	  var cDim = data.mapDimension(coordDims[cDimIdx]);
	  var vDims = data.mapDimension(coordDims[vDimIdx], true);
	
	  if (cDim == null || vDims.length < 5) {
	    return;
	  }
	
	  for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
	    var axisDimVal = data.get(cDim, dataIndex);
	    var median = getPoint(axisDimVal, vDims[2], dataIndex);
	    var end1 = getPoint(axisDimVal, vDims[0], dataIndex);
	    var end2 = getPoint(axisDimVal, vDims[1], dataIndex);
	    var end4 = getPoint(axisDimVal, vDims[3], dataIndex);
	    var end5 = getPoint(axisDimVal, vDims[4], dataIndex);
	    var ends = [];
	    addBodyEnd(ends, end2, 0);
	    addBodyEnd(ends, end4, 1);
	    ends.push(end1, end2, end5, end4);
	    layEndLine(ends, end1);
	    layEndLine(ends, end5);
	    layEndLine(ends, median);
	    data.setItemLayout(dataIndex, {
	      initBaseline: median[vDimIdx],
	      ends: ends
	    });
	  }
	
	  function getPoint(axisDimVal, dimIdx, dataIndex) {
	    var val = data.get(dimIdx, dataIndex);
	    var p = [];
	    p[cDimIdx] = axisDimVal;
	    p[vDimIdx] = val;
	    var point;
	
	    if (isNaN(axisDimVal) || isNaN(val)) {
	      point = [NaN, NaN];
	    } else {
	      point = coordSys.dataToPoint(p);
	      point[cDimIdx] += offset;
	    }
	
	    return point;
	  }
	
	  function addBodyEnd(ends, point, start) {
	    var point1 = point.slice();
	    var point2 = point.slice();
	    point1[cDimIdx] += halfWidth;
	    point2[cDimIdx] -= halfWidth;
	    start ? ends.push(point1, point2) : ends.push(point2, point1);
	  }
	
	  function layEndLine(ends, endCenter) {
	    var from = endCenter.slice();
	    var to = endCenter.slice();
	    from[cDimIdx] -= halfWidth;
	    to[cDimIdx] += halfWidth;
	    ends.push(from, to);
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2208 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var borderColorQuery = ['itemStyle', 'borderColor'];
	
	function _default(ecModel, api) {
	  var globalColors = ecModel.get('color');
	  ecModel.eachRawSeriesByType('boxplot', function (seriesModel) {
	    var defaulColor = globalColors[seriesModel.seriesIndex % globalColors.length];
	    var data = seriesModel.getData();
	    data.setVisual({
	      legendSymbol: 'roundRect',
	      // Use name 'color' but not 'borderColor' for legend usage and
	      // visual coding from other component like dataRange.
	      color: seriesModel.get(borderColorQuery) || defaulColor
	    }); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      data.each(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        data.setItemVisual(idx, {
	          color: itemModel.get(borderColorQuery, true)
	        });
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2209 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2210);
	
	__webpack_require__(2211);
	
	var preprocessor = __webpack_require__(2214);
	
	var candlestickVisual = __webpack_require__(2213);
	
	var candlestickLayout = __webpack_require__(2212);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(preprocessor);
	echarts.registerVisual(candlestickVisual);
	echarts.registerLayout(candlestickLayout);

/***/ },
/* 2210 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var SeriesModel = __webpack_require__(77);
	
	var _whiskerBoxCommon = __webpack_require__(829);
	
	var seriesModelMixin = _whiskerBoxCommon.seriesModelMixin;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CandlestickSeries = SeriesModel.extend({
	  type: 'series.candlestick',
	  dependencies: ['xAxis', 'yAxis', 'grid'],
	
	  /**
	   * @readOnly
	   */
	  defaultValueDimensions: [{
	    name: 'open',
	    defaultTooltip: true
	  }, {
	    name: 'close',
	    defaultTooltip: true
	  }, {
	    name: 'lowest',
	    defaultTooltip: true
	  }, {
	    name: 'highest',
	    defaultTooltip: true
	  }],
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * @override
	   */
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    layout: null,
	    // 'horizontal' or 'vertical'
	    clip: true,
	    itemStyle: {
	      color: '#c23531',
	      // 阳线 positive
	      color0: '#314656',
	      // 阴线 negative     '#c23531', '#314656'
	      borderWidth: 1,
	      // FIXME
	      // ec2中使用的是lineStyle.color 和 lineStyle.color0
	      borderColor: '#c23531',
	      borderColor0: '#314656'
	    },
	    emphasis: {
	      itemStyle: {
	        borderWidth: 2
	      }
	    },
	    barMaxWidth: null,
	    barMinWidth: null,
	    barWidth: null,
	    large: true,
	    largeThreshold: 600,
	    progressive: 3e3,
	    progressiveThreshold: 1e4,
	    progressiveChunkMode: 'mod',
	    animationUpdate: false,
	    animationEasing: 'linear',
	    animationDuration: 300
	  },
	
	  /**
	   * Get dimension for shadow in dataZoom
	   * @return {string} dimension name
	   */
	  getShadowDim: function () {
	    return 'open';
	  },
	  brushSelector: function (dataIndex, data, selectors) {
	    var itemLayout = data.getItemLayout(dataIndex);
	    return itemLayout && selectors.rect(itemLayout.brushRect);
	  }
	});
	zrUtil.mixin(CandlestickSeries, seriesModelMixin, true);
	var _default = CandlestickSeries;
	module.exports = _default;

/***/ },
/* 2211 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var ChartView = __webpack_require__(141);
	
	var graphic = __webpack_require__(14);
	
	var Path = __webpack_require__(67);
	
	var _createClipPathFromCoordSys = __webpack_require__(288);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NORMAL_ITEM_STYLE_PATH = ['itemStyle'];
	var EMPHASIS_ITEM_STYLE_PATH = ['emphasis', 'itemStyle'];
	var SKIP_PROPS = ['color', 'color0', 'borderColor', 'borderColor0'];
	var CandlestickView = ChartView.extend({
	  type: 'candlestick',
	  render: function (seriesModel, ecModel, api) {
	    // If there is clipPath created in large mode. Remove it.
	    this.group.removeClipPath();
	
	    this._updateDrawMode(seriesModel);
	
	    this._isLargeDraw ? this._renderLarge(seriesModel) : this._renderNormal(seriesModel);
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._clear();
	
	    this._updateDrawMode(seriesModel);
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    this._isLargeDraw ? this._incrementalRenderLarge(params, seriesModel) : this._incrementalRenderNormal(params, seriesModel);
	  },
	  _updateDrawMode: function (seriesModel) {
	    var isLargeDraw = seriesModel.pipelineContext.large;
	
	    if (this._isLargeDraw == null || isLargeDraw ^ this._isLargeDraw) {
	      this._isLargeDraw = isLargeDraw;
	
	      this._clear();
	    }
	  },
	  _renderNormal: function (seriesModel) {
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    var isSimpleBox = data.getLayout('isSimpleBox');
	    var needsClip = seriesModel.get('clip', true);
	    var coord = seriesModel.coordinateSystem;
	    var clipArea = coord.getArea && coord.getArea(); // There is no old data only when first rendering or switching from
	    // stream mode to normal mode, where previous elements should be removed.
	
	    if (!this._data) {
	      group.removeAll();
	    }
	
	    data.diff(oldData).add(function (newIdx) {
	      if (data.hasValue(newIdx)) {
	        var el;
	        var itemLayout = data.getItemLayout(newIdx);
	
	        if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
	          return;
	        }
	
	        el = createNormalBox(itemLayout, newIdx, true);
	        graphic.initProps(el, {
	          shape: {
	            points: itemLayout.ends
	          }
	        }, seriesModel, newIdx);
	        setBoxCommon(el, data, newIdx, isSimpleBox);
	        group.add(el);
	        data.setItemGraphicEl(newIdx, el);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx); // Empty data
	
	      if (!data.hasValue(newIdx)) {
	        group.remove(el);
	        return;
	      }
	
	      var itemLayout = data.getItemLayout(newIdx);
	
	      if (needsClip && isNormalBoxClipped(clipArea, itemLayout)) {
	        group.remove(el);
	        return;
	      }
	
	      if (!el) {
	        el = createNormalBox(itemLayout, newIdx);
	      } else {
	        graphic.updateProps(el, {
	          shape: {
	            points: itemLayout.ends
	          }
	        }, seriesModel, newIdx);
	      }
	
	      setBoxCommon(el, data, newIdx, isSimpleBox);
	      group.add(el);
	      data.setItemGraphicEl(newIdx, el);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute();
	    this._data = data;
	  },
	  _renderLarge: function (seriesModel) {
	    this._clear();
	
	    createLarge(seriesModel, this.group);
	    var clipPath = seriesModel.get('clip', true) ? createClipPath(seriesModel.coordinateSystem, false, seriesModel) : null;
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	  },
	  _incrementalRenderNormal: function (params, seriesModel) {
	    var data = seriesModel.getData();
	    var isSimpleBox = data.getLayout('isSimpleBox');
	    var dataIndex;
	
	    while ((dataIndex = params.next()) != null) {
	      var el;
	      var itemLayout = data.getItemLayout(dataIndex);
	      el = createNormalBox(itemLayout, dataIndex);
	      setBoxCommon(el, data, dataIndex, isSimpleBox);
	      el.incremental = true;
	      this.group.add(el);
	    }
	  },
	  _incrementalRenderLarge: function (params, seriesModel) {
	    createLarge(seriesModel, this.group, true);
	  },
	  remove: function (ecModel) {
	    this._clear();
	  },
	  _clear: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: zrUtil.noop
	});
	var NormalBoxPath = Path.extend({
	  type: 'normalCandlestickBox',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    var ends = shape.points;
	
	    if (this.__simpleBox) {
	      ctx.moveTo(ends[4][0], ends[4][1]);
	      ctx.lineTo(ends[6][0], ends[6][1]);
	    } else {
	      ctx.moveTo(ends[0][0], ends[0][1]);
	      ctx.lineTo(ends[1][0], ends[1][1]);
	      ctx.lineTo(ends[2][0], ends[2][1]);
	      ctx.lineTo(ends[3][0], ends[3][1]);
	      ctx.closePath();
	      ctx.moveTo(ends[4][0], ends[4][1]);
	      ctx.lineTo(ends[5][0], ends[5][1]);
	      ctx.moveTo(ends[6][0], ends[6][1]);
	      ctx.lineTo(ends[7][0], ends[7][1]);
	    }
	  }
	});
	
	function createNormalBox(itemLayout, dataIndex, isInit) {
	  var ends = itemLayout.ends;
	  return new NormalBoxPath({
	    shape: {
	      points: isInit ? transInit(ends, itemLayout) : ends
	    },
	    z2: 100
	  });
	}
	
	function isNormalBoxClipped(clipArea, itemLayout) {
	  var clipped = true;
	
	  for (var i = 0; i < itemLayout.ends.length; i++) {
	    // If any point are in the region.
	    if (clipArea.contain(itemLayout.ends[i][0], itemLayout.ends[i][1])) {
	      clipped = false;
	      break;
	    }
	  }
	
	  return clipped;
	}
	
	function setBoxCommon(el, data, dataIndex, isSimpleBox) {
	  var itemModel = data.getItemModel(dataIndex);
	  var normalItemStyleModel = itemModel.getModel(NORMAL_ITEM_STYLE_PATH);
	  var color = data.getItemVisual(dataIndex, 'color');
	  var borderColor = data.getItemVisual(dataIndex, 'borderColor') || color; // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var itemStyle = normalItemStyleModel.getItemStyle(SKIP_PROPS);
	  el.useStyle(itemStyle);
	  el.style.strokeNoScale = true;
	  el.style.fill = color;
	  el.style.stroke = borderColor;
	  el.__simpleBox = isSimpleBox;
	  var hoverStyle = itemModel.getModel(EMPHASIS_ITEM_STYLE_PATH).getItemStyle();
	  graphic.setHoverStyle(el, hoverStyle);
	}
	
	function transInit(points, itemLayout) {
	  return zrUtil.map(points, function (point) {
	    point = point.slice();
	    point[1] = itemLayout.initBaseline;
	    return point;
	  });
	}
	
	var LargeBoxPath = Path.extend({
	  type: 'largeCandlestickBox',
	  shape: {},
	  buildPath: function (ctx, shape) {
	    // Drawing lines is more efficient than drawing
	    // a whole line or drawing rects.
	    var points = shape.points;
	
	    for (var i = 0; i < points.length;) {
	      if (this.__sign === points[i++]) {
	        var x = points[i++];
	        ctx.moveTo(x, points[i++]);
	        ctx.lineTo(x, points[i++]);
	      } else {
	        i += 3;
	      }
	    }
	  }
	});
	
	function createLarge(seriesModel, group, incremental) {
	  var data = seriesModel.getData();
	  var largePoints = data.getLayout('largePoints');
	  var elP = new LargeBoxPath({
	    shape: {
	      points: largePoints
	    },
	    __sign: 1
	  });
	  group.add(elP);
	  var elN = new LargeBoxPath({
	    shape: {
	      points: largePoints
	    },
	    __sign: -1
	  });
	  group.add(elN);
	  setLargeStyle(1, elP, seriesModel, data);
	  setLargeStyle(-1, elN, seriesModel, data);
	
	  if (incremental) {
	    elP.incremental = true;
	    elN.incremental = true;
	  }
	}
	
	function setLargeStyle(sign, el, seriesModel, data) {
	  var suffix = sign > 0 ? 'P' : 'N';
	  var borderColor = data.getVisual('borderColor' + suffix) || data.getVisual('color' + suffix); // Color must be excluded.
	  // Because symbol provide setColor individually to set fill and stroke
	
	  var itemStyle = seriesModel.getModel(NORMAL_ITEM_STYLE_PATH).getItemStyle(SKIP_PROPS);
	  el.useStyle(itemStyle);
	  el.style.fill = null;
	  el.style.stroke = borderColor; // No different
	  // el.style.lineWidth = .5;
	}
	
	var _default = CandlestickView;
	module.exports = _default;

/***/ },
/* 2212 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _graphic = __webpack_require__(14);
	
	var subPixelOptimize = _graphic.subPixelOptimize;
	
	var createRenderPlanner = __webpack_require__(246);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	var _util = __webpack_require__(4);
	
	var retrieve2 = _util.retrieve2;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	var LargeArr = typeof Float32Array !== 'undefined' ? Float32Array : Array;
	var _default = {
	  seriesType: 'candlestick',
	  plan: createRenderPlanner(),
	  reset: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var candleWidth = calculateCandleWidth(seriesModel, data);
	    var cDimIdx = 0;
	    var vDimIdx = 1;
	    var coordDims = ['x', 'y'];
	    var cDim = data.mapDimension(coordDims[cDimIdx]);
	    var vDims = data.mapDimension(coordDims[vDimIdx], true);
	    var openDim = vDims[0];
	    var closeDim = vDims[1];
	    var lowestDim = vDims[2];
	    var highestDim = vDims[3];
	    data.setLayout({
	      candleWidth: candleWidth,
	      // The value is experimented visually.
	      isSimpleBox: candleWidth <= 1.3
	    });
	
	    if (cDim == null || vDims.length < 4) {
	      return;
	    }
	
	    return {
	      progress: seriesModel.pipelineContext.large ? largeProgress : normalProgress
	    };
	
	    function normalProgress(params, data) {
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var axisDimVal = data.get(cDim, dataIndex);
	        var openVal = data.get(openDim, dataIndex);
	        var closeVal = data.get(closeDim, dataIndex);
	        var lowestVal = data.get(lowestDim, dataIndex);
	        var highestVal = data.get(highestDim, dataIndex);
	        var ocLow = Math.min(openVal, closeVal);
	        var ocHigh = Math.max(openVal, closeVal);
	        var ocLowPoint = getPoint(ocLow, axisDimVal);
	        var ocHighPoint = getPoint(ocHigh, axisDimVal);
	        var lowestPoint = getPoint(lowestVal, axisDimVal);
	        var highestPoint = getPoint(highestVal, axisDimVal);
	        var ends = [];
	        addBodyEnd(ends, ocHighPoint, 0);
	        addBodyEnd(ends, ocLowPoint, 1);
	        ends.push(subPixelOptimizePoint(highestPoint), subPixelOptimizePoint(ocHighPoint), subPixelOptimizePoint(lowestPoint), subPixelOptimizePoint(ocLowPoint));
	        data.setItemLayout(dataIndex, {
	          sign: getSign(data, dataIndex, openVal, closeVal, closeDim),
	          initBaseline: openVal > closeVal ? ocHighPoint[vDimIdx] : ocLowPoint[vDimIdx],
	          // open point.
	          ends: ends,
	          brushRect: makeBrushRect(lowestVal, highestVal, axisDimVal)
	        });
	      }
	
	      function getPoint(val, axisDimVal) {
	        var p = [];
	        p[cDimIdx] = axisDimVal;
	        p[vDimIdx] = val;
	        return isNaN(axisDimVal) || isNaN(val) ? [NaN, NaN] : coordSys.dataToPoint(p);
	      }
	
	      function addBodyEnd(ends, point, start) {
	        var point1 = point.slice();
	        var point2 = point.slice();
	        point1[cDimIdx] = subPixelOptimize(point1[cDimIdx] + candleWidth / 2, 1, false);
	        point2[cDimIdx] = subPixelOptimize(point2[cDimIdx] - candleWidth / 2, 1, true);
	        start ? ends.push(point1, point2) : ends.push(point2, point1);
	      }
	
	      function makeBrushRect(lowestVal, highestVal, axisDimVal) {
	        var pmin = getPoint(lowestVal, axisDimVal);
	        var pmax = getPoint(highestVal, axisDimVal);
	        pmin[cDimIdx] -= candleWidth / 2;
	        pmax[cDimIdx] -= candleWidth / 2;
	        return {
	          x: pmin[0],
	          y: pmin[1],
	          width: vDimIdx ? candleWidth : pmax[0] - pmin[0],
	          height: vDimIdx ? pmax[1] - pmin[1] : candleWidth
	        };
	      }
	
	      function subPixelOptimizePoint(point) {
	        point[cDimIdx] = subPixelOptimize(point[cDimIdx], 1);
	        return point;
	      }
	    }
	
	    function largeProgress(params, data) {
	      // Structure: [sign, x, yhigh, ylow, sign, x, yhigh, ylow, ...]
	      var points = new LargeArr(params.count * 4);
	      var offset = 0;
	      var point;
	      var tmpIn = [];
	      var tmpOut = [];
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var axisDimVal = data.get(cDim, dataIndex);
	        var openVal = data.get(openDim, dataIndex);
	        var closeVal = data.get(closeDim, dataIndex);
	        var lowestVal = data.get(lowestDim, dataIndex);
	        var highestVal = data.get(highestDim, dataIndex);
	
	        if (isNaN(axisDimVal) || isNaN(lowestVal) || isNaN(highestVal)) {
	          points[offset++] = NaN;
	          offset += 3;
	          continue;
	        }
	
	        points[offset++] = getSign(data, dataIndex, openVal, closeVal, closeDim);
	        tmpIn[cDimIdx] = axisDimVal;
	        tmpIn[vDimIdx] = lowestVal;
	        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	        points[offset++] = point ? point[0] : NaN;
	        points[offset++] = point ? point[1] : NaN;
	        tmpIn[vDimIdx] = highestVal;
	        point = coordSys.dataToPoint(tmpIn, null, tmpOut);
	        points[offset++] = point ? point[1] : NaN;
	      }
	
	      data.setLayout('largePoints', points);
	    }
	  }
	};
	
	function getSign(data, dataIndex, openVal, closeVal, closeDim) {
	  var sign;
	
	  if (openVal > closeVal) {
	    sign = -1;
	  } else if (openVal < closeVal) {
	    sign = 1;
	  } else {
	    sign = dataIndex > 0 // If close === open, compare with close of last record
	    ? data.get(closeDim, dataIndex - 1) <= closeVal ? 1 : -1 : // No record of previous, set to be positive
	    1;
	  }
	
	  return sign;
	}
	
	function calculateCandleWidth(seriesModel, data) {
	  var baseAxis = seriesModel.getBaseAxis();
	  var extent;
	  var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : (extent = baseAxis.getExtent(), Math.abs(extent[1] - extent[0]) / data.count());
	  var barMaxWidth = parsePercent(retrieve2(seriesModel.get('barMaxWidth'), bandWidth), bandWidth);
	  var barMinWidth = parsePercent(retrieve2(seriesModel.get('barMinWidth'), 1), bandWidth);
	  var barWidth = seriesModel.get('barWidth');
	  return barWidth != null ? parsePercent(barWidth, bandWidth) // Put max outer to ensure bar visible in spite of overlap.
	  : Math.max(Math.min(bandWidth / 2, barMaxWidth), barMinWidth);
	}
	
	module.exports = _default;

/***/ },
/* 2213 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createRenderPlanner = __webpack_require__(246);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var positiveBorderColorQuery = ['itemStyle', 'borderColor'];
	var negativeBorderColorQuery = ['itemStyle', 'borderColor0'];
	var positiveColorQuery = ['itemStyle', 'color'];
	var negativeColorQuery = ['itemStyle', 'color0'];
	var _default = {
	  seriesType: 'candlestick',
	  plan: createRenderPlanner(),
	  // For legend.
	  performRawSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    data.setVisual({
	      legendSymbol: 'roundRect',
	      colorP: getColor(1, seriesModel),
	      colorN: getColor(-1, seriesModel),
	      borderColorP: getBorderColor(1, seriesModel),
	      borderColorN: getBorderColor(-1, seriesModel)
	    }); // Only visible series has each data be visual encoded
	
	    if (ecModel.isSeriesFiltered(seriesModel)) {
	      return;
	    }
	
	    var isLargeRender = seriesModel.pipelineContext.large;
	    return !isLargeRender && {
	      progress: progress
	    };
	
	    function progress(params, data) {
	      var dataIndex;
	
	      while ((dataIndex = params.next()) != null) {
	        var itemModel = data.getItemModel(dataIndex);
	        var sign = data.getItemLayout(dataIndex).sign;
	        data.setItemVisual(dataIndex, {
	          color: getColor(sign, itemModel),
	          borderColor: getBorderColor(sign, itemModel)
	        });
	      }
	    }
	
	    function getColor(sign, model) {
	      return model.get(sign > 0 ? positiveColorQuery : negativeColorQuery);
	    }
	
	    function getBorderColor(sign, model) {
	      return model.get(sign > 0 ? positiveBorderColorQuery : negativeBorderColorQuery);
	    }
	  }
	};
	module.exports = _default;

/***/ },
/* 2214 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  if (!option || !zrUtil.isArray(option.series)) {
	    return;
	  } // Translate 'k' to 'candlestick'.
	
	
	  zrUtil.each(option.series, function (seriesItem) {
	    if (zrUtil.isObject(seriesItem) && seriesItem.type === 'k') {
	      seriesItem.type = 'candlestick';
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2215 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(4);
	
	var graphicUtil = __webpack_require__(14);
	
	var _labelHelper = __webpack_require__(499);
	
	var getDefaultLabel = _labelHelper.getDefaultLabel;
	
	var createListFromArray = __webpack_require__(159);
	
	var _barGrid = __webpack_require__(359);
	
	var getLayoutOnAxis = _barGrid.getLayoutOnAxis;
	
	var DataDiffer = __webpack_require__(211);
	
	var SeriesModel = __webpack_require__(77);
	
	var Model = __webpack_require__(70);
	
	var ChartView = __webpack_require__(141);
	
	var _createClipPathFromCoordSys = __webpack_require__(288);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	var prepareCartesian2d = __webpack_require__(2404);
	
	var prepareGeo = __webpack_require__(2413);
	
	var prepareSingleAxis = __webpack_require__(2431);
	
	var preparePolar = __webpack_require__(2424);
	
	var prepareCalendar = __webpack_require__(2399);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CACHED_LABEL_STYLE_PROPERTIES = graphicUtil.CACHED_LABEL_STYLE_PROPERTIES;
	var ITEM_STYLE_NORMAL_PATH = ['itemStyle'];
	var ITEM_STYLE_EMPHASIS_PATH = ['emphasis', 'itemStyle'];
	var LABEL_NORMAL = ['label'];
	var LABEL_EMPHASIS = ['emphasis', 'label']; // Use prefix to avoid index to be the same as el.name,
	// which will cause weird udpate animation.
	
	var GROUP_DIFF_PREFIX = 'e\0\0';
	/**
	 * To reduce total package size of each coordinate systems, the modules `prepareCustom`
	 * of each coordinate systems are not required by each coordinate systems directly, but
	 * required by the module `custom`.
	 *
	 * prepareInfoForCustomSeries {Function}: optional
	 *     @return {Object} {coordSys: {...}, api: {
	 *         coord: function (data, clamp) {}, // return point in global.
	 *         size: function (dataSize, dataItem) {} // return size of each axis in coordSys.
	 *     }}
	 */
	
	var prepareCustoms = {
	  cartesian2d: prepareCartesian2d,
	  geo: prepareGeo,
	  singleAxis: prepareSingleAxis,
	  polar: preparePolar,
	  calendar: prepareCalendar
	}; // ------
	// Model
	// ------
	
	SeriesModel.extend({
	  type: 'series.custom',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    // Can be set as 'none'
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    useTransform: true,
	    // Custom series will not clip by default.
	    // Some case will use custom series to draw label
	    // For example https://echarts.apache.org/examples/en/editor.html?c=custom-gantt-flight
	    // Only works on polar and cartesian2d coordinate system.
	    clip: false // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // label: {}
	    // itemStyle: {}
	
	  },
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this);
	  },
	
	  /**
	   * @override
	   */
	  getDataParams: function (dataIndex, dataType, el) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    el && (params.info = el.info);
	    return params;
	  }
	}); // -----
	// View
	// -----
	
	ChartView.extend({
	  type: 'custom',
	
	  /**
	   * @private
	   * @type {module:echarts/data/List}
	   */
	  _data: null,
	
	  /**
	   * @override
	   */
	  render: function (customSeries, ecModel, api, payload) {
	    var oldData = this._data;
	    var data = customSeries.getData();
	    var group = this.group;
	    var renderItem = makeRenderItem(customSeries, data, ecModel, api); // By default, merge mode is applied. In most cases, custom series is
	    // used in the scenario that data amount is not large but graphic elements
	    // is complicated, where merge mode is probably necessary for optimization.
	    // For example, reuse graphic elements and only update the transform when
	    // roam or data zoom according to `actionType`.
	
	    data.diff(oldData).add(function (newIdx) {
	      createOrUpdate(null, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	    }).update(function (newIdx, oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      createOrUpdate(el, newIdx, renderItem(newIdx, payload), customSeries, group, data);
	    }).remove(function (oldIdx) {
	      var el = oldData.getItemGraphicEl(oldIdx);
	      el && group.remove(el);
	    }).execute(); // Do clipping
	
	    var clipPath = customSeries.get('clip', true) ? createClipPath(customSeries.coordinateSystem, false, customSeries) : null;
	
	    if (clipPath) {
	      group.setClipPath(clipPath);
	    } else {
	      group.removeClipPath();
	    }
	
	    this._data = data;
	  },
	  incrementalPrepareRender: function (customSeries, ecModel, api) {
	    this.group.removeAll();
	    this._data = null;
	  },
	  incrementalRender: function (params, customSeries, ecModel, api, payload) {
	    var data = customSeries.getData();
	    var renderItem = makeRenderItem(customSeries, data, ecModel, api);
	
	    function setIncrementalAndHoverLayer(el) {
	      if (!el.isGroup) {
	        el.incremental = true;
	        el.useHoverLayer = true;
	      }
	    }
	
	    for (var idx = params.start; idx < params.end; idx++) {
	      var el = createOrUpdate(null, idx, renderItem(idx, payload), customSeries, this.group, data);
	      el.traverse(setIncrementalAndHoverLayer);
	    }
	  },
	
	  /**
	   * @override
	   */
	  dispose: zrUtil.noop,
	
	  /**
	   * @override
	   */
	  filterForExposedEvent: function (eventType, query, targetEl, packedEvent) {
	    var elementName = query.element;
	
	    if (elementName == null || targetEl.name === elementName) {
	      return true;
	    } // Enable to give a name on a group made by `renderItem`, and listen
	    // events that triggerd by its descendents.
	
	
	    while ((targetEl = targetEl.parent) && targetEl !== this.group) {
	      if (targetEl.name === elementName) {
	        return true;
	      }
	    }
	
	    return false;
	  }
	});
	
	function createEl(elOption) {
	  var graphicType = elOption.type;
	  var el; // Those graphic elements are not shapes. They should not be
	  // overwritten by users, so do them first.
	
	  if (graphicType === 'path') {
	    var shape = elOption.shape; // Using pathRect brings convenience to users sacle svg path.
	
	    var pathRect = shape.width != null && shape.height != null ? {
	      x: shape.x || 0,
	      y: shape.y || 0,
	      width: shape.width,
	      height: shape.height
	    } : null;
	    var pathData = getPathData(shape); // Path is also used for icon, so layout 'center' by default.
	
	    el = graphicUtil.makePath(pathData, null, pathRect, shape.layout || 'center');
	    el.__customPathData = pathData;
	  } else if (graphicType === 'image') {
	    el = new graphicUtil.Image({});
	    el.__customImagePath = elOption.style.image;
	  } else if (graphicType === 'text') {
	    el = new graphicUtil.Text({});
	    el.__customText = elOption.style.text;
	  } else if (graphicType === 'group') {
	    el = new graphicUtil.Group();
	  } else if (graphicType === 'compoundPath') {
	    throw new Error('"compoundPath" is not supported yet.');
	  } else {
	    var Clz = graphicUtil.getShapeClass(graphicType);
	    el = new Clz();
	  }
	
	  el.__customGraphicType = graphicType;
	  el.name = elOption.name;
	  return el;
	}
	
	function updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot) {
	  var transitionProps = {};
	  var elOptionStyle = elOption.style || {};
	  elOption.shape && (transitionProps.shape = zrUtil.clone(elOption.shape));
	  elOption.position && (transitionProps.position = elOption.position.slice());
	  elOption.scale && (transitionProps.scale = elOption.scale.slice());
	  elOption.origin && (transitionProps.origin = elOption.origin.slice());
	  elOption.rotation && (transitionProps.rotation = elOption.rotation);
	
	  if (el.type === 'image' && elOption.style) {
	    var targetStyle = transitionProps.style = {};
	    zrUtil.each(['x', 'y', 'width', 'height'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    });
	  }
	
	  if (el.type === 'text' && elOption.style) {
	    var targetStyle = transitionProps.style = {};
	    zrUtil.each(['x', 'y'], function (prop) {
	      prepareStyleTransition(prop, targetStyle, elOptionStyle, el.style, isInit);
	    }); // Compatible with previous: both support
	    // textFill and fill, textStroke and stroke in 'text' element.
	
	    !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	    !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	  }
	
	  if (el.type !== 'group') {
	    el.useStyle(elOptionStyle); // Init animation.
	
	    if (isInit) {
	      el.style.opacity = 0;
	      var targetOpacity = elOptionStyle.opacity;
	      targetOpacity == null && (targetOpacity = 1);
	      graphicUtil.initProps(el, {
	        style: {
	          opacity: targetOpacity
	        }
	      }, animatableModel, dataIndex);
	    }
	  }
	
	  if (isInit) {
	    el.attr(transitionProps);
	  } else {
	    graphicUtil.updateProps(el, transitionProps, animatableModel, dataIndex);
	  } // Merge by default.
	  // z2 must not be null/undefined, otherwise sort error may occur.
	
	
	  elOption.hasOwnProperty('z2') && el.attr('z2', elOption.z2 || 0);
	  elOption.hasOwnProperty('silent') && el.attr('silent', elOption.silent);
	  elOption.hasOwnProperty('invisible') && el.attr('invisible', elOption.invisible);
	  elOption.hasOwnProperty('ignore') && el.attr('ignore', elOption.ignore); // `elOption.info` enables user to mount some info on
	  // elements and use them in event handlers.
	  // Update them only when user specified, otherwise, remain.
	
	  elOption.hasOwnProperty('info') && el.attr('info', elOption.info); // If `elOption.styleEmphasis` is `false`, remove hover style. The
	  // logic is ensured by `graphicUtil.setElementHoverStyle`.
	
	  var styleEmphasis = elOption.styleEmphasis; // hoverStyle should always be set here, because if the hover style
	  // may already be changed, where the inner cache should be reset.
	
	  graphicUtil.setElementHoverStyle(el, styleEmphasis);
	
	  if (isRoot) {
	    graphicUtil.setAsHighDownDispatcher(el, styleEmphasis !== false);
	  }
	}
	
	function prepareStyleTransition(prop, targetStyle, elOptionStyle, oldElStyle, isInit) {
	  if (elOptionStyle[prop] != null && !isInit) {
	    targetStyle[prop] = elOptionStyle[prop];
	    elOptionStyle[prop] = oldElStyle[prop];
	  }
	}
	
	function makeRenderItem(customSeries, data, ecModel, api) {
	  var renderItem = customSeries.get('renderItem');
	  var coordSys = customSeries.coordinateSystem;
	  var prepareResult = {};
	
	  if (coordSys) {
	    prepareResult = coordSys.prepareCustoms ? coordSys.prepareCustoms() : prepareCustoms[coordSys.type](coordSys);
	  }
	
	  var userAPI = zrUtil.defaults({
	    getWidth: api.getWidth,
	    getHeight: api.getHeight,
	    getZr: api.getZr,
	    getDevicePixelRatio: api.getDevicePixelRatio,
	    value: value,
	    style: style,
	    styleEmphasis: styleEmphasis,
	    visual: visual,
	    barLayout: barLayout,
	    currentSeriesIndices: currentSeriesIndices,
	    font: font
	  }, prepareResult.api || {});
	  var userParams = {
	    // The life cycle of context: current round of rendering.
	    // The global life cycle is probably not necessary, because
	    // user can store global status by themselves.
	    context: {},
	    seriesId: customSeries.id,
	    seriesName: customSeries.name,
	    seriesIndex: customSeries.seriesIndex,
	    coordSys: prepareResult.coordSys,
	    dataInsideLength: data.count(),
	    encode: wrapEncodeDef(customSeries.getData())
	  }; // Do not support call `api` asynchronously without dataIndexInside input.
	
	  var currDataIndexInside;
	  var currDirty = true;
	  var currItemModel;
	  var currLabelNormalModel;
	  var currLabelEmphasisModel;
	  var currVisualColor;
	  return function (dataIndexInside, payload) {
	    currDataIndexInside = dataIndexInside;
	    currDirty = true;
	    return renderItem && renderItem(zrUtil.defaults({
	      dataIndexInside: dataIndexInside,
	      dataIndex: data.getRawIndex(dataIndexInside),
	      // Can be used for optimization when zoom or roam.
	      actionType: payload ? payload.type : null
	    }, userParams), userAPI);
	  }; // Do not update cache until api called.
	
	  function updateCache(dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	
	    if (currDirty) {
	      currItemModel = data.getItemModel(dataIndexInside);
	      currLabelNormalModel = currItemModel.getModel(LABEL_NORMAL);
	      currLabelEmphasisModel = currItemModel.getModel(LABEL_EMPHASIS);
	      currVisualColor = data.getItemVisual(dataIndexInside, 'color');
	      currDirty = false;
	    }
	  }
	  /**
	   * @public
	   * @param {number|string} dim
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   * @return {number|string} value
	   */
	
	
	  function value(dim, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.get(data.getDimension(dim || 0), dataIndexInside);
	  }
	  /**
	   * By default, `visual` is applied to style (to support visualMap).
	   * `visual.color` is applied at `fill`. If user want apply visual.color on `stroke`,
	   * it can be implemented as:
	   * `api.style({stroke: api.visual('color'), fill: null})`;
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function style(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_NORMAL_PATH).getItemStyle();
	    currVisualColor != null && (itemStyle.fill = currVisualColor);
	    var opacity = data.getItemVisual(dataIndexInside, 'opacity');
	    opacity != null && (itemStyle.opacity = opacity);
	    var labelModel = extra ? applyExtraBefore(extra, currLabelNormalModel) : currLabelNormalModel;
	    graphicUtil.setTextStyle(itemStyle, labelModel, null, {
	      autoColor: currVisualColor,
	      isRectText: true
	    });
	    itemStyle.text = labelModel.getShallow('show') ? zrUtil.retrieve2(customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
	    extra && applyExtraAfter(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {Object} [extra]
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function styleEmphasis(extra, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    updateCache(dataIndexInside);
	    var itemStyle = currItemModel.getModel(ITEM_STYLE_EMPHASIS_PATH).getItemStyle();
	    var labelModel = extra ? applyExtraBefore(extra, currLabelEmphasisModel) : currLabelEmphasisModel;
	    graphicUtil.setTextStyle(itemStyle, labelModel, null, {
	      isRectText: true
	    }, true);
	    itemStyle.text = labelModel.getShallow('show') ? zrUtil.retrieve3(customSeries.getFormattedLabel(dataIndexInside, 'emphasis'), customSeries.getFormattedLabel(dataIndexInside, 'normal'), getDefaultLabel(data, dataIndexInside)) : null;
	    extra && applyExtraAfter(itemStyle, extra);
	    return itemStyle;
	  }
	  /**
	   * @public
	   * @param {string} visualType
	   * @param {number} [dataIndexInside=currDataIndexInside]
	   */
	
	
	  function visual(visualType, dataIndexInside) {
	    dataIndexInside == null && (dataIndexInside = currDataIndexInside);
	    return data.getItemVisual(dataIndexInside, visualType);
	  }
	  /**
	   * @public
	   * @param {number} opt.count Positive interger.
	   * @param {number} [opt.barWidth]
	   * @param {number} [opt.barMaxWidth]
	   * @param {number} [opt.barMinWidth]
	   * @param {number} [opt.barGap]
	   * @param {number} [opt.barCategoryGap]
	   * @return {Object} {width, offset, offsetCenter} is not support, return undefined.
	   */
	
	
	  function barLayout(opt) {
	    if (coordSys.getBaseAxis) {
	      var baseAxis = coordSys.getBaseAxis();
	      return getLayoutOnAxis(zrUtil.defaults({
	        axis: baseAxis
	      }, opt), api);
	    }
	  }
	  /**
	   * @public
	   * @return {Array.<number>}
	   */
	
	
	  function currentSeriesIndices() {
	    return ecModel.getCurrentSeriesIndices();
	  }
	  /**
	   * @public
	   * @param {Object} opt
	   * @param {string} [opt.fontStyle]
	   * @param {number} [opt.fontWeight]
	   * @param {number} [opt.fontSize]
	   * @param {string} [opt.fontFamily]
	   * @return {string} font string
	   */
	
	
	  function font(opt) {
	    return graphicUtil.getFont(opt, ecModel);
	  }
	}
	
	function wrapEncodeDef(data) {
	  var encodeDef = {};
	  zrUtil.each(data.dimensions, function (dimName, dataDimIndex) {
	    var dimInfo = data.getDimensionInfo(dimName);
	
	    if (!dimInfo.isExtraCoord) {
	      var coordDim = dimInfo.coordDim;
	      var dataDims = encodeDef[coordDim] = encodeDef[coordDim] || [];
	      dataDims[dimInfo.coordDimIndex] = dataDimIndex;
	    }
	  });
	  return encodeDef;
	}
	
	function createOrUpdate(el, dataIndex, elOption, animatableModel, group, data) {
	  el = doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, true);
	  el && data.setItemGraphicEl(dataIndex, el);
	  return el;
	}
	
	function doCreateOrUpdate(el, dataIndex, elOption, animatableModel, group, data, isRoot) {
	  // [Rule]
	  // By default, follow merge mode.
	  //     (It probably brings benifit for performance in some cases of large data, where
	  //     user program can be optimized to that only updated props needed to be re-calculated,
	  //     or according to `actionType` some calculation can be skipped.)
	  // If `renderItem` returns `null`/`undefined`/`false`, remove the previous el if existing.
	  //     (It seems that violate the "merge" principle, but most of users probably intuitively
	  //     regard "return;" as "show nothing element whatever", so make a exception to meet the
	  //     most cases.)
	  var simplyRemove = !elOption; // `null`/`undefined`/`false`
	
	  elOption = elOption || {};
	  var elOptionType = elOption.type;
	  var elOptionShape = elOption.shape;
	  var elOptionStyle = elOption.style;
	
	  if (el && (simplyRemove // || elOption.$merge === false
	  // If `elOptionType` is `null`, follow the merge principle.
	  || elOptionType != null && elOptionType !== el.__customGraphicType || elOptionType === 'path' && hasOwnPathData(elOptionShape) && getPathData(elOptionShape) !== el.__customPathData || elOptionType === 'image' && hasOwn(elOptionStyle, 'image') && elOptionStyle.image !== el.__customImagePath // FIXME test and remove this restriction?
	  || elOptionType === 'text' && hasOwn(elOptionShape, 'text') && elOptionStyle.text !== el.__customText)) {
	    group.remove(el);
	    el = null;
	  } // `elOption.type` is undefined when `renderItem` returns nothing.
	
	
	  if (simplyRemove) {
	    return;
	  }
	
	  var isInit = !el;
	  !el && (el = createEl(elOption));
	  updateEl(el, dataIndex, elOption, animatableModel, data, isInit, isRoot);
	
	  if (elOptionType === 'group') {
	    mergeChildren(el, dataIndex, elOption, animatableModel, data);
	  } // Always add whatever already added to ensure sequence.
	
	
	  group.add(el);
	  return el;
	} // Usage:
	// (1) By default, `elOption.$mergeChildren` is `'byIndex'`, which indicates that
	//     the existing children will not be removed, and enables the feature that
	//     update some of the props of some of the children simply by construct
	//     the returned children of `renderItem` like:
	//     `var children = group.children = []; children[3] = {opacity: 0.5};`
	// (2) If `elOption.$mergeChildren` is `'byName'`, add/update/remove children
	//     by child.name. But that might be lower performance.
	// (3) If `elOption.$mergeChildren` is `false`, the existing children will be
	//     replaced totally.
	// (4) If `!elOption.children`, following the "merge" principle, nothing will happen.
	//
	// For implementation simpleness, do not provide a direct way to remove sinlge
	// child (otherwise the total indicies of the children array have to be modified).
	// User can remove a single child by set its `ignore` as `true` or replace
	// it by another element, where its `$merge` can be set as `true` if necessary.
	
	
	function mergeChildren(el, dataIndex, elOption, animatableModel, data) {
	  var newChildren = elOption.children;
	  var newLen = newChildren ? newChildren.length : 0;
	  var mergeChildren = elOption.$mergeChildren; // `diffChildrenByName` has been deprecated.
	
	  var byName = mergeChildren === 'byName' || elOption.diffChildrenByName;
	  var notMerge = mergeChildren === false; // For better performance on roam update, only enter if necessary.
	
	  if (!newLen && !byName && !notMerge) {
	    return;
	  }
	
	  if (byName) {
	    diffGroupChildren({
	      oldChildren: el.children() || [],
	      newChildren: newChildren || [],
	      dataIndex: dataIndex,
	      animatableModel: animatableModel,
	      group: el,
	      data: data
	    });
	    return;
	  }
	
	  notMerge && el.removeAll(); // Mapping children of a group simply by index, which
	  // might be better performance.
	
	  var index = 0;
	
	  for (; index < newLen; index++) {
	    newChildren[index] && doCreateOrUpdate(el.childAt(index), dataIndex, newChildren[index], animatableModel, el, data);
	  }
	}
	
	function diffGroupChildren(context) {
	  new DataDiffer(context.oldChildren, context.newChildren, getKey, getKey, context).add(processAddUpdate).update(processAddUpdate).remove(processRemove).execute();
	}
	
	function getKey(item, idx) {
	  var name = item && item.name;
	  return name != null ? name : GROUP_DIFF_PREFIX + idx;
	}
	
	function processAddUpdate(newIndex, oldIndex) {
	  var context = this.context;
	  var childOption = newIndex != null ? context.newChildren[newIndex] : null;
	  var child = oldIndex != null ? context.oldChildren[oldIndex] : null;
	  doCreateOrUpdate(child, context.dataIndex, childOption, context.animatableModel, context.group, context.data);
	} // `graphic#applyDefaultTextStyle` will cache
	// textFill, textStroke, textStrokeWidth.
	// We have to do this trick.
	
	
	function applyExtraBefore(extra, model) {
	  var dummyModel = new Model({}, model);
	  zrUtil.each(CACHED_LABEL_STYLE_PROPERTIES, function (stylePropName, modelPropName) {
	    if (extra.hasOwnProperty(stylePropName)) {
	      dummyModel.option[modelPropName] = extra[stylePropName];
	    }
	  });
	  return dummyModel;
	}
	
	function applyExtraAfter(itemStyle, extra) {
	  for (var key in extra) {
	    if (extra.hasOwnProperty(key) || !CACHED_LABEL_STYLE_PROPERTIES.hasOwnProperty(key)) {
	      itemStyle[key] = extra[key];
	    }
	  }
	}
	
	function processRemove(oldIndex) {
	  var context = this.context;
	  var child = context.oldChildren[oldIndex];
	  child && context.group.remove(child);
	}
	
	function getPathData(shape) {
	  // "d" follows the SVG convention.
	  return shape && (shape.pathData || shape.d);
	}
	
	function hasOwnPathData(shape) {
	  return shape && (shape.hasOwnProperty('pathData') || shape.hasOwnProperty('d'));
	}
	
	function hasOwn(host, prop) {
	  return host && host.hasOwnProperty(prop);
	}

/***/ },
/* 2216 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2217);
	
	__webpack_require__(2218);
	
	var visualSymbol = __webpack_require__(214);
	
	var layoutPoints = __webpack_require__(295);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(visualSymbol('effectScatter', 'circle'));
	echarts.registerLayout(layoutPoints('effectScatter'));

/***/ },
/* 2217 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListFromArray = __webpack_require__(159);
	
	var SeriesModel = __webpack_require__(77);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.effectScatter',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  brushSelector: 'point',
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    effectType: 'ripple',
	    progressive: 0,
	    // When to show the effect, option: 'render'|'emphasis'
	    showEffectOn: 'render',
	    // Ripple effect config
	    rippleEffect: {
	      period: 4,
	      // Scale of ripple
	      scale: 2.5,
	      // Brush type can be fill or stroke
	      brushType: 'fill'
	    },
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10 // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    // large: false,
	    // Available when large is true
	    // largeThreshold: 2000,
	    // itemStyle: {
	    //     opacity: 1
	    // }
	
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2218 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var SymbolDraw = __webpack_require__(287);
	
	var EffectSymbol = __webpack_require__(2245);
	
	var matrix = __webpack_require__(86);
	
	var pointsLayout = __webpack_require__(295);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'effectScatter',
	  init: function () {
	    this._symbolDraw = new SymbolDraw(EffectSymbol);
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var effectSymbolDraw = this._symbolDraw;
	    effectSymbolDraw.updateData(data);
	    this.group.add(effectSymbolDraw.group);
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    this.group.dirty();
	    var res = pointsLayout().reset(seriesModel);
	
	    if (res.progress) {
	      res.progress({
	        start: 0,
	        end: data.count()
	      }, data);
	    }
	
	    this._symbolDraw.updateLayout(data);
	  },
	  _updateGroupTransform: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.getRoamTransform) {
	      this.group.transform = matrix.clone(coordSys.getRoamTransform());
	      this.group.decomposeTransform();
	    }
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(api);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ },
/* 2219 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2220);
	
	__webpack_require__(2221);
	
	var dataColor = __webpack_require__(363);
	
	var funnelLayout = __webpack_require__(2222);
	
	var dataFilter = __webpack_require__(296);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(dataColor('funnel'));
	echarts.registerLayout(funnelLayout);
	echarts.registerProcessor(dataFilter('funnel'));

/***/ },
/* 2220 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var createListSimply = __webpack_require__(245);
	
	var _model = __webpack_require__(29);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	var _sourceHelper = __webpack_require__(160);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	var LegendVisualProvider = __webpack_require__(298);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var FunnelSeries = echarts.extendSeriesModel({
	  type: 'series.funnel',
	  init: function (option) {
	    FunnelSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this)); // Extend labelLine emphasis
	
	    this._defaultLabelLine(option);
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    defaultEmphasis(option, 'labelLine', ['show']);
	    var labelLineNormalOpt = option.labelLine;
	    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = FunnelSeries.superCall(this, 'getDataParams', dataIndex);
	    var valueDim = data.mapDimension('value');
	    var sum = data.getSum(valueDim); // Percent is 0 if sum is 0
	
	    params.percent = !sum ? 0 : +(data.get(valueDim, dataIndex) / sum * 100).toFixed(2);
	    params.$vars.push('percent');
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    legendHoverLink: true,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    // 默认取数据最小最大值
	    // min: 0,
	    // max: 100,
	    minSize: '0%',
	    maxSize: '100%',
	    sort: 'descending',
	    // 'ascending', 'descending'
	    orient: 'vertical',
	    gap: 0,
	    funnelAlign: 'center',
	    label: {
	      show: true,
	      position: 'outer' // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	    },
	    labelLine: {
	      show: true,
	      length: 20,
	      lineStyle: {
	        // color: 各异,
	        width: 1,
	        type: 'solid'
	      }
	    },
	    itemStyle: {
	      // color: 各异,
	      borderColor: '#fff',
	      borderWidth: 1
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = FunnelSeries;
	module.exports = _default;

/***/ },
/* 2221 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var zrUtil = __webpack_require__(4);
	
	var ChartView = __webpack_require__(141);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	function FunnelPiece(data, idx) {
	  graphic.Group.call(this);
	  var polygon = new graphic.Polygon();
	  var labelLine = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(polygon);
	  this.add(labelLine);
	  this.add(text);
	
	  this.highDownOnUpdate = function (fromState, toState) {
	    if (toState === 'emphasis') {
	      labelLine.ignore = labelLine.hoverIgnore;
	      text.ignore = text.hoverIgnore;
	    } else {
	      labelLine.ignore = labelLine.normalIgnore;
	      text.ignore = text.normalIgnore;
	    }
	  };
	
	  this.updateData(data, idx, true);
	}
	
	var funnelPieceProto = FunnelPiece.prototype;
	var opacityAccessPath = ['itemStyle', 'opacity'];
	
	funnelPieceProto.updateData = function (data, idx, firstCreate) {
	  var polygon = this.childAt(0);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var opacity = data.getItemModel(idx).get(opacityAccessPath);
	  opacity = opacity == null ? 1 : opacity; // Reset style
	
	  polygon.useStyle({});
	
	  if (firstCreate) {
	    polygon.setShape({
	      points: layout.points
	    });
	    polygon.setStyle({
	      opacity: 0
	    });
	    graphic.initProps(polygon, {
	      style: {
	        opacity: opacity
	      }
	    }, seriesModel, idx);
	  } else {
	    graphic.updateProps(polygon, {
	      style: {
	        opacity: opacity
	      },
	      shape: {
	        points: layout.points
	      }
	    }, seriesModel, idx);
	  } // Update common style
	
	
	  var itemStyleModel = itemModel.getModel('itemStyle');
	  var visualColor = data.getItemVisual(idx, 'color');
	  polygon.setStyle(zrUtil.defaults({
	    lineJoin: 'round',
	    fill: visualColor
	  }, itemStyleModel.getItemStyle(['opacity'])));
	  polygon.hoverStyle = itemStyleModel.getModel('emphasis').getItemStyle();
	
	  this._updateLabel(data, idx);
	
	  graphic.setHoverStyle(this);
	};
	
	funnelPieceProto._updateLabel = function (data, idx) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.updateProps(labelLine, {
	    shape: {
	      points: labelLayout.linePoints || labelLayout.linePoints
	    }
	  }, seriesModel, idx);
	  graphic.updateProps(labelText, {
	    style: {
	      x: labelLayout.x,
	      y: labelLayout.y
	    }
	  }, seriesModel, idx);
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelLineModel = itemModel.getModel('labelLine');
	  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: data.getName(idx),
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	};
	
	zrUtil.inherits(FunnelPiece, graphic.Group);
	var FunnelView = ChartView.extend({
	  type: 'funnel',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    data.diff(oldData).add(function (idx) {
	      var funnelPiece = new FunnelPiece(data, idx);
	      data.setItemGraphicEl(idx, funnelPiece);
	      group.add(funnelPiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	      piePiece.updateData(data, newIdx);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	var _default = FunnelView;
	module.exports = _default;

/***/ },
/* 2222 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var layout = __webpack_require__(46);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function getSortedIndices(data, sort) {
	  var valueDim = data.mapDimension('value');
	  var valueArr = data.mapArray(valueDim, function (val) {
	    return val;
	  });
	  var indices = [];
	  var isAscending = sort === 'ascending';
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    indices[i] = i;
	  } // Add custom sortable function & none sortable opetion by "options.sort"
	
	
	  if (typeof sort === 'function') {
	    indices.sort(sort);
	  } else if (sort !== 'none') {
	    indices.sort(function (a, b) {
	      return isAscending ? valueArr[a] - valueArr[b] : valueArr[b] - valueArr[a];
	    });
	  }
	
	  return indices;
	}
	
	function labelLayout(data) {
	  data.each(function (idx) {
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label');
	    var labelPosition = labelModel.get('position');
	    var orient = itemModel.get('orient');
	    var labelLineModel = itemModel.getModel('labelLine');
	    var layout = data.getItemLayout(idx);
	    var points = layout.points;
	    var isLabelInside = labelPosition === 'inner' || labelPosition === 'inside' || labelPosition === 'center' || labelPosition === 'insideLeft' || labelPosition === 'insideRight';
	    var textAlign;
	    var textX;
	    var textY;
	    var linePoints;
	
	    if (isLabelInside) {
	      if (labelPosition === 'insideLeft') {
	        textX = (points[0][0] + points[3][0]) / 2 + 5;
	        textY = (points[0][1] + points[3][1]) / 2;
	        textAlign = 'left';
	      } else if (labelPosition === 'insideRight') {
	        textX = (points[1][0] + points[2][0]) / 2 - 5;
	        textY = (points[1][1] + points[2][1]) / 2;
	        textAlign = 'right';
	      } else {
	        textX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4;
	        textY = (points[0][1] + points[1][1] + points[2][1] + points[3][1]) / 4;
	        textAlign = 'center';
	      }
	
	      linePoints = [[textX, textY], [textX, textY]];
	    } else {
	      var x1;
	      var y1;
	      var x2;
	      var y2;
	      var labelLineLen = labelLineModel.get('length');
	
	      if (labelPosition === 'left') {
	        // Left side
	        x1 = (points[3][0] + points[0][0]) / 2;
	        y1 = (points[3][1] + points[0][1]) / 2;
	        x2 = x1 - labelLineLen;
	        textX = x2 - 5;
	        textAlign = 'right';
	      } else if (labelPosition === 'right') {
	        // Right side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	        x2 = x1 + labelLineLen;
	        textX = x2 + 5;
	        textAlign = 'left';
	      } else if (labelPosition === 'top') {
	        // Top side
	        x1 = (points[3][0] + points[0][0]) / 2;
	        y1 = (points[3][1] + points[0][1]) / 2;
	        y2 = y1 - labelLineLen;
	        textY = y2 - 5;
	        textAlign = 'center';
	      } else if (labelPosition === 'bottom') {
	        // Bottom side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	        y2 = y1 + labelLineLen;
	        textY = y2 + 5;
	        textAlign = 'center';
	      } else if (labelPosition === 'rightTop') {
	        // RightTop side
	        x1 = orient === 'horizontal' ? points[3][0] : points[1][0];
	        y1 = orient === 'horizontal' ? points[3][1] : points[1][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 - labelLineLen;
	          textY = y2 - 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'top';
	        }
	      } else if (labelPosition === 'rightBottom') {
	        // RightBottom side
	        x1 = points[2][0];
	        y1 = points[2][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'bottom';
	        }
	      } else if (labelPosition === 'leftTop') {
	        // LeftTop side
	        x1 = points[0][0];
	        y1 = orient === 'horizontal' ? points[0][1] : points[1][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 - labelLineLen;
	          textY = y2 - 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 - labelLineLen;
	          textX = x2 - 5;
	          textAlign = 'right';
	        }
	      } else if (labelPosition === 'leftBottom') {
	        // LeftBottom side
	        x1 = orient === 'horizontal' ? points[1][0] : points[3][0];
	        y1 = orient === 'horizontal' ? points[1][1] : points[2][1];
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 - labelLineLen;
	          textX = x2 - 5;
	          textAlign = 'right';
	        }
	      } else {
	        // Right side or Bottom side
	        x1 = (points[1][0] + points[2][0]) / 2;
	        y1 = (points[1][1] + points[2][1]) / 2;
	
	        if (orient === 'horizontal') {
	          y2 = y1 + labelLineLen;
	          textY = y2 + 5;
	          textAlign = 'center';
	        } else {
	          x2 = x1 + labelLineLen;
	          textX = x2 + 5;
	          textAlign = 'left';
	        }
	      }
	
	      if (orient === 'horizontal') {
	        x2 = x1;
	        textX = x2;
	      } else {
	        y2 = y1;
	        textY = y2;
	      }
	
	      linePoints = [[x1, y1], [x2, y2]];
	    }
	
	    layout.label = {
	      linePoints: linePoints,
	      x: textX,
	      y: textY,
	      verticalAlign: 'middle',
	      textAlign: textAlign,
	      inside: isLabelInside
	    };
	  });
	}
	
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('funnel', function (seriesModel) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var sort = seriesModel.get('sort');
	    var viewRect = getViewRect(seriesModel, api);
	    var indices = getSortedIndices(data, sort);
	    var orient = seriesModel.get('orient');
	    var viewWidth = viewRect.width;
	    var viewHeight = viewRect.height;
	    var x = viewRect.x;
	    var y = viewRect.y;
	    var sizeExtent = orient === 'horizontal' ? [parsePercent(seriesModel.get('minSize'), viewHeight), parsePercent(seriesModel.get('maxSize'), viewHeight)] : [parsePercent(seriesModel.get('minSize'), viewWidth), parsePercent(seriesModel.get('maxSize'), viewWidth)];
	    var dataExtent = data.getDataExtent(valueDim);
	    var min = seriesModel.get('min');
	    var max = seriesModel.get('max');
	
	    if (min == null) {
	      min = Math.min(dataExtent[0], 0);
	    }
	
	    if (max == null) {
	      max = dataExtent[1];
	    }
	
	    var funnelAlign = seriesModel.get('funnelAlign');
	    var gap = seriesModel.get('gap');
	    var viewSize = orient === 'horizontal' ? viewWidth : viewHeight;
	    var itemSize = (viewSize - gap * (data.count() - 1)) / data.count();
	
	    var getLinePoints = function (idx, offset) {
	      // End point index is data.count() and we assign it 0
	      if (orient === 'horizontal') {
	        var val = data.get(valueDim, idx) || 0;
	        var itemHeight = linearMap(val, [min, max], sizeExtent, true);
	        var y0;
	
	        switch (funnelAlign) {
	          case 'top':
	            y0 = y;
	            break;
	
	          case 'center':
	            y0 = y + (viewHeight - itemHeight) / 2;
	            break;
	
	          case 'bottom':
	            y0 = y + (viewHeight - itemHeight);
	            break;
	        }
	
	        return [[offset, y0], [offset, y0 + itemHeight]];
	      }
	
	      var val = data.get(valueDim, idx) || 0;
	      var itemWidth = linearMap(val, [min, max], sizeExtent, true);
	      var x0;
	
	      switch (funnelAlign) {
	        case 'left':
	          x0 = x;
	          break;
	
	        case 'center':
	          x0 = x + (viewWidth - itemWidth) / 2;
	          break;
	
	        case 'right':
	          x0 = x + viewWidth - itemWidth;
	          break;
	      }
	
	      return [[x0, offset], [x0 + itemWidth, offset]];
	    };
	
	    if (sort === 'ascending') {
	      // From bottom to top
	      itemSize = -itemSize;
	      gap = -gap;
	
	      if (orient === 'horizontal') {
	        x += viewWidth;
	      } else {
	        y += viewHeight;
	      }
	
	      indices = indices.reverse();
	    }
	
	    for (var i = 0; i < indices.length; i++) {
	      var idx = indices[i];
	      var nextIdx = indices[i + 1];
	      var itemModel = data.getItemModel(idx);
	
	      if (orient === 'horizontal') {
	        var width = itemModel.get('itemStyle.width');
	
	        if (width == null) {
	          width = itemSize;
	        } else {
	          width = parsePercent(width, viewWidth);
	
	          if (sort === 'ascending') {
	            width = -width;
	          }
	        }
	
	        var start = getLinePoints(idx, x);
	        var end = getLinePoints(nextIdx, x + width);
	        x += width + gap;
	        data.setItemLayout(idx, {
	          points: start.concat(end.slice().reverse())
	        });
	      } else {
	        var height = itemModel.get('itemStyle.height');
	
	        if (height == null) {
	          height = itemSize;
	        } else {
	          height = parsePercent(height, viewHeight);
	
	          if (sort === 'ascending') {
	            height = -height;
	          }
	        }
	
	        var start = orient === 'horizontal' ? getLinePoints(idx, x) : getLinePoints(idx, y);
	        var end = orient === 'horizontal' ? getLinePoints(nextIdx, x + width) : getLinePoints(nextIdx, y + height);
	        y += height + gap;
	        data.setItemLayout(idx, {
	          points: start.concat(end.slice().reverse())
	        });
	      }
	    }
	
	    labelLayout(data);
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2223 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(2224);
	
	__webpack_require__(2225);

/***/ },
/* 2224 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListSimply = __webpack_require__(245);
	
	var SeriesModel = __webpack_require__(77);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GaugeSeries = SeriesModel.extend({
	  type: 'series.gauge',
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, ['value']);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    legendHoverLink: true,
	    radius: '75%',
	    startAngle: 225,
	    endAngle: -45,
	    clockwise: true,
	    // 最小值
	    min: 0,
	    // 最大值
	    max: 100,
	    // 分割段数，默认为10
	    splitNumber: 10,
	    // 坐标轴线
	    axisLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      lineStyle: {
	        // 属性lineStyle控制线条样式
	        color: [[0.2, '#91c7ae'], [0.8, '#63869e'], [1, '#c23531']],
	        width: 30
	      }
	    },
	    // 分隔线
	    splitLine: {
	      // 默认显示，属性show控制显示与否
	      show: true,
	      // 属性length控制线长
	      length: 30,
	      // 属性lineStyle（详见lineStyle）控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 2,
	        type: 'solid'
	      }
	    },
	    // 坐标轴小标记
	    axisTick: {
	      // 属性show控制显示与否，默认不显示
	      show: true,
	      // 每份split细分多少段
	      splitNumber: 5,
	      // 属性length控制线长
	      length: 8,
	      // 属性lineStyle控制线条样式
	      lineStyle: {
	        color: '#eee',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    axisLabel: {
	      show: true,
	      distance: 5,
	      // formatter: null,
	      color: 'auto'
	    },
	    pointer: {
	      show: true,
	      length: '80%',
	      width: 8
	    },
	    itemStyle: {
	      color: 'auto'
	    },
	    title: {
	      show: true,
	      // x, y，单位px
	      offsetCenter: [0, '-40%'],
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: '#333',
	      fontSize: 15
	    },
	    detail: {
	      show: true,
	      backgroundColor: 'rgba(0,0,0,0)',
	      borderWidth: 0,
	      borderColor: '#ccc',
	      width: 100,
	      height: null,
	      // self-adaption
	      padding: [5, 10],
	      // x, y，单位px
	      offsetCenter: [0, '40%'],
	      // formatter: null,
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: 'auto',
	      fontSize: 30
	    }
	  }
	});
	var _default = GaugeSeries;
	module.exports = _default;

/***/ },
/* 2225 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var PointerPath = __webpack_require__(2226);
	
	var graphic = __webpack_require__(14);
	
	var ChartView = __webpack_require__(141);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	var round = _number.round;
	var linearMap = _number.linearMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function parsePosition(seriesModel, api) {
	  var center = seriesModel.get('center');
	  var width = api.getWidth();
	  var height = api.getHeight();
	  var size = Math.min(width, height);
	  var cx = parsePercent(center[0], api.getWidth());
	  var cy = parsePercent(center[1], api.getHeight());
	  var r = parsePercent(seriesModel.get('radius'), size / 2);
	  return {
	    cx: cx,
	    cy: cy,
	    r: r
	  };
	}
	
	function formatLabel(label, labelFormatter) {
	  if (labelFormatter) {
	    if (typeof labelFormatter === 'string') {
	      label = labelFormatter.replace('{value}', label != null ? label : '');
	    } else if (typeof labelFormatter === 'function') {
	      label = labelFormatter(label);
	    }
	  }
	
	  return label;
	}
	
	var PI2 = Math.PI * 2;
	var GaugeView = ChartView.extend({
	  type: 'gauge',
	  render: function (seriesModel, ecModel, api) {
	    this.group.removeAll();
	    var colorList = seriesModel.get('axisLine.lineStyle.color');
	    var posInfo = parsePosition(seriesModel, api);
	
	    this._renderMain(seriesModel, ecModel, api, colorList, posInfo);
	  },
	  dispose: function () {},
	  _renderMain: function (seriesModel, ecModel, api, colorList, posInfo) {
	    var group = this.group;
	    var axisLineModel = seriesModel.getModel('axisLine');
	    var lineStyleModel = axisLineModel.getModel('lineStyle');
	    var clockwise = seriesModel.get('clockwise');
	    var startAngle = -seriesModel.get('startAngle') / 180 * Math.PI;
	    var endAngle = -seriesModel.get('endAngle') / 180 * Math.PI;
	    var angleRangeSpan = (endAngle - startAngle) % PI2;
	    var prevEndAngle = startAngle;
	    var axisLineWidth = lineStyleModel.get('width');
	    var showAxis = axisLineModel.get('show');
	
	    for (var i = 0; showAxis && i < colorList.length; i++) {
	      // Clamp
	      var percent = Math.min(Math.max(colorList[i][0], 0), 1);
	      var endAngle = startAngle + angleRangeSpan * percent;
	      var sector = new graphic.Sector({
	        shape: {
	          startAngle: prevEndAngle,
	          endAngle: endAngle,
	          cx: posInfo.cx,
	          cy: posInfo.cy,
	          clockwise: clockwise,
	          r0: posInfo.r - axisLineWidth,
	          r: posInfo.r
	        },
	        silent: true
	      });
	      sector.setStyle({
	        fill: colorList[i][1]
	      });
	      sector.setStyle(lineStyleModel.getLineStyle( // Because we use sector to simulate arc
	      // so the properties for stroking are useless
	      ['color', 'borderWidth', 'borderColor']));
	      group.add(sector);
	      prevEndAngle = endAngle;
	    }
	
	    var getColor = function (percent) {
	      // Less than 0
	      if (percent <= 0) {
	        return colorList[0][1];
	      }
	
	      for (var i = 0; i < colorList.length; i++) {
	        if (colorList[i][0] >= percent && (i === 0 ? 0 : colorList[i - 1][0]) < percent) {
	          return colorList[i][1];
	        }
	      } // More than 1
	
	
	      return colorList[i - 1][1];
	    };
	
	    if (!clockwise) {
	      var tmp = startAngle;
	      startAngle = endAngle;
	      endAngle = tmp;
	    }
	
	    this._renderTicks(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderPointer(seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise);
	
	    this._renderTitle(seriesModel, ecModel, api, getColor, posInfo);
	
	    this._renderDetail(seriesModel, ecModel, api, getColor, posInfo);
	  },
	  _renderTicks: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var cx = posInfo.cx;
	    var cy = posInfo.cy;
	    var r = posInfo.r;
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	    var splitLineModel = seriesModel.getModel('splitLine');
	    var tickModel = seriesModel.getModel('axisTick');
	    var labelModel = seriesModel.getModel('axisLabel');
	    var splitNumber = seriesModel.get('splitNumber');
	    var subSplitNumber = tickModel.get('splitNumber');
	    var splitLineLen = parsePercent(splitLineModel.get('length'), r);
	    var tickLen = parsePercent(tickModel.get('length'), r);
	    var angle = startAngle;
	    var step = (endAngle - startAngle) / splitNumber;
	    var subStep = step / subSplitNumber;
	    var splitLineStyle = splitLineModel.getModel('lineStyle').getLineStyle();
	    var tickLineStyle = tickModel.getModel('lineStyle').getLineStyle();
	
	    for (var i = 0; i <= splitNumber; i++) {
	      var unitX = Math.cos(angle);
	      var unitY = Math.sin(angle); // Split line
	
	      if (splitLineModel.get('show')) {
	        var splitLine = new graphic.Line({
	          shape: {
	            x1: unitX * r + cx,
	            y1: unitY * r + cy,
	            x2: unitX * (r - splitLineLen) + cx,
	            y2: unitY * (r - splitLineLen) + cy
	          },
	          style: splitLineStyle,
	          silent: true
	        });
	
	        if (splitLineStyle.stroke === 'auto') {
	          splitLine.setStyle({
	            stroke: getColor(i / splitNumber)
	          });
	        }
	
	        group.add(splitLine);
	      } // Label
	
	
	      if (labelModel.get('show')) {
	        var label = formatLabel(round(i / splitNumber * (maxVal - minVal) + minVal), labelModel.get('formatter'));
	        var distance = labelModel.get('distance');
	        var autoColor = getColor(i / splitNumber);
	        group.add(new graphic.Text({
	          style: graphic.setTextStyle({}, labelModel, {
	            text: label,
	            x: unitX * (r - splitLineLen - distance) + cx,
	            y: unitY * (r - splitLineLen - distance) + cy,
	            textVerticalAlign: unitY < -0.4 ? 'top' : unitY > 0.4 ? 'bottom' : 'middle',
	            textAlign: unitX < -0.4 ? 'left' : unitX > 0.4 ? 'right' : 'center'
	          }, {
	            autoColor: autoColor
	          }),
	          silent: true
	        }));
	      } // Axis tick
	
	
	      if (tickModel.get('show') && i !== splitNumber) {
	        for (var j = 0; j <= subSplitNumber; j++) {
	          var unitX = Math.cos(angle);
	          var unitY = Math.sin(angle);
	          var tickLine = new graphic.Line({
	            shape: {
	              x1: unitX * r + cx,
	              y1: unitY * r + cy,
	              x2: unitX * (r - tickLen) + cx,
	              y2: unitY * (r - tickLen) + cy
	            },
	            silent: true,
	            style: tickLineStyle
	          });
	
	          if (tickLineStyle.stroke === 'auto') {
	            tickLine.setStyle({
	              stroke: getColor((i + j / subSplitNumber) / splitNumber)
	            });
	          }
	
	          group.add(tickLine);
	          angle += subStep;
	        }
	
	        angle -= subStep;
	      } else {
	        angle += step;
	      }
	    }
	  },
	  _renderPointer: function (seriesModel, ecModel, api, getColor, posInfo, startAngle, endAngle, clockwise) {
	    var group = this.group;
	    var oldData = this._data;
	
	    if (!seriesModel.get('pointer.show')) {
	      // Remove old element
	      oldData && oldData.eachItemGraphicEl(function (el) {
	        group.remove(el);
	      });
	      return;
	    }
	
	    var valueExtent = [+seriesModel.get('min'), +seriesModel.get('max')];
	    var angleExtent = [startAngle, endAngle];
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    data.diff(oldData).add(function (idx) {
	      var pointer = new PointerPath({
	        shape: {
	          angle: startAngle
	        }
	      });
	      graphic.initProps(pointer, {
	        shape: {
	          angle: linearMap(data.get(valueDim, idx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(idx, pointer);
	    }).update(function (newIdx, oldIdx) {
	      var pointer = oldData.getItemGraphicEl(oldIdx);
	      graphic.updateProps(pointer, {
	        shape: {
	          angle: linearMap(data.get(valueDim, newIdx), valueExtent, angleExtent, true)
	        }
	      }, seriesModel);
	      group.add(pointer);
	      data.setItemGraphicEl(newIdx, pointer);
	    }).remove(function (idx) {
	      var pointer = oldData.getItemGraphicEl(idx);
	      group.remove(pointer);
	    }).execute();
	    data.eachItemGraphicEl(function (pointer, idx) {
	      var itemModel = data.getItemModel(idx);
	      var pointerModel = itemModel.getModel('pointer');
	      pointer.setShape({
	        x: posInfo.cx,
	        y: posInfo.cy,
	        width: parsePercent(pointerModel.get('width'), posInfo.r),
	        r: parsePercent(pointerModel.get('length'), posInfo.r)
	      });
	      pointer.useStyle(itemModel.getModel('itemStyle').getItemStyle());
	
	      if (pointer.style.fill === 'auto') {
	        pointer.setStyle('fill', getColor(linearMap(data.get(valueDim, idx), valueExtent, [0, 1], true)));
	      }
	
	      graphic.setHoverStyle(pointer, itemModel.getModel('emphasis.itemStyle').getItemStyle());
	    });
	    this._data = data;
	  },
	  _renderTitle: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var titleModel = seriesModel.getModel('title');
	
	    if (titleModel.get('show')) {
	      var offsetCenter = titleModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var minVal = +seriesModel.get('min');
	      var maxVal = +seriesModel.get('max');
	      var value = seriesModel.getData().get(valueDim, 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, titleModel, {
	          x: x,
	          y: y,
	          // FIXME First data name ?
	          text: data.getName(0),
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  },
	  _renderDetail: function (seriesModel, ecModel, api, getColor, posInfo) {
	    var detailModel = seriesModel.getModel('detail');
	    var minVal = +seriesModel.get('min');
	    var maxVal = +seriesModel.get('max');
	
	    if (detailModel.get('show')) {
	      var offsetCenter = detailModel.get('offsetCenter');
	      var x = posInfo.cx + parsePercent(offsetCenter[0], posInfo.r);
	      var y = posInfo.cy + parsePercent(offsetCenter[1], posInfo.r);
	      var width = parsePercent(detailModel.get('width'), posInfo.r);
	      var height = parsePercent(detailModel.get('height'), posInfo.r);
	      var data = seriesModel.getData();
	      var value = data.get(data.mapDimension('value'), 0);
	      var autoColor = getColor(linearMap(value, [minVal, maxVal], [0, 1], true));
	      this.group.add(new graphic.Text({
	        silent: true,
	        style: graphic.setTextStyle({}, detailModel, {
	          x: x,
	          y: y,
	          text: formatLabel( // FIXME First data name ?
	          value, detailModel.get('formatter')),
	          textWidth: isNaN(width) ? null : width,
	          textHeight: isNaN(height) ? null : height,
	          textAlign: 'center',
	          textVerticalAlign: 'middle'
	        }, {
	          autoColor: autoColor,
	          forceRich: true
	        })
	      }));
	    }
	  }
	});
	var _default = GaugeView;
	module.exports = _default;

/***/ },
/* 2226 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Path = __webpack_require__(67);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = Path.extend({
	  type: 'echartsGaugePointer',
	  shape: {
	    angle: 0,
	    width: 10,
	    r: 10,
	    x: 0,
	    y: 0
	  },
	  buildPath: function (ctx, shape) {
	    var mathCos = Math.cos;
	    var mathSin = Math.sin;
	    var r = shape.r;
	    var width = shape.width;
	    var angle = shape.angle;
	    var x = shape.x - mathCos(angle) * width * (width >= r / 3 ? 1 : 2);
	    var y = shape.y - mathSin(angle) * width * (width >= r / 3 ? 1 : 2);
	    angle = shape.angle - Math.PI / 2;
	    ctx.moveTo(x, y);
	    ctx.lineTo(shape.x + mathCos(angle) * width, shape.y + mathSin(angle) * width);
	    ctx.lineTo(shape.x + mathCos(shape.angle) * r, shape.y + mathSin(shape.angle) * r);
	    ctx.lineTo(shape.x - mathCos(angle) * width, shape.y - mathSin(angle) * width);
	    ctx.lineTo(x, y);
	    return;
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2227 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2228);
	
	__webpack_require__(2229);
	
	__webpack_require__(2238);
	
	var categoryFilter = __webpack_require__(2231);
	
	var visualSymbol = __webpack_require__(214);
	
	var categoryVisual = __webpack_require__(2232);
	
	var edgeVisual = __webpack_require__(2235);
	
	var simpleLayout = __webpack_require__(2239);
	
	var circularLayout = __webpack_require__(2233);
	
	var forceLayout = __webpack_require__(2237);
	
	var createView = __webpack_require__(2234);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerProcessor(categoryFilter);
	echarts.registerVisual(visualSymbol('graph', 'circle', null));
	echarts.registerVisual(categoryVisual);
	echarts.registerVisual(edgeVisual);
	echarts.registerLayout(simpleLayout);
	echarts.registerLayout(echarts.PRIORITY.VISUAL.POST_CHART_LAYOUT, circularLayout);
	echarts.registerLayout(forceLayout); // Graph view coordinate system
	
	echarts.registerCoordinateSystem('graphView', {
	  create: createView
	});

/***/ },
/* 2228 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var List = __webpack_require__(109);
	
	var zrUtil = __webpack_require__(4);
	
	var _model = __webpack_require__(29);
	
	var defaultEmphasis = _model.defaultEmphasis;
	
	var Model = __webpack_require__(70);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var createGraphFromNodeEdge = __webpack_require__(827);
	
	var LegendVisualProvider = __webpack_require__(298);
	
	var _multipleGraphEdgeHelper = __webpack_require__(353);
	
	var initCurvenessList = _multipleGraphEdgeHelper.initCurvenessList;
	var createEdgeMapForCurveness = _multipleGraphEdgeHelper.createEdgeMapForCurveness;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GraphSeries = echarts.extendSeriesModel({
	  type: 'series.graph',
	  init: function (option) {
	    GraphSeries.superApply(this, 'init', arguments);
	    var self = this;
	
	    function getCategoriesData() {
	      return self._categoriesData;
	    } // Provide data for legend select
	
	
	    this.legendVisualProvider = new LegendVisualProvider(getCategoriesData, getCategoriesData);
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeOption: function (option) {
	    GraphSeries.superApply(this, 'mergeOption', arguments);
	    this.fillDataTextStyle(option.edges || option.links);
	
	    this._updateCategoriesData();
	  },
	  mergeDefaultAndTheme: function (option) {
	    GraphSeries.superApply(this, 'mergeDefaultAndTheme', arguments);
	    defaultEmphasis(option, ['edgeLabel'], ['show']);
	  },
	  getInitialData: function (option, ecModel) {
	    var edges = option.edges || option.links || [];
	    var nodes = option.data || option.nodes || [];
	    var self = this;
	
	    if (nodes && edges) {
	      // auto curveness
	      initCurvenessList(this);
	      var graph = createGraphFromNodeEdge(nodes, edges, this, true, beforeLink);
	      zrUtil.each(graph.edges, function (edge) {
	        createEdgeMapForCurveness(edge.node1, edge.node2, this, edge.dataIndex);
	      }, this);
	      return graph.data;
	    }
	
	    function beforeLink(nodeData, edgeData) {
	      // Overwrite nodeData.getItemModel to
	      nodeData.wrapMethod('getItemModel', function (model) {
	        var categoriesModels = self._categoriesModels;
	        var categoryIdx = model.getShallow('category');
	        var categoryModel = categoriesModels[categoryIdx];
	
	        if (categoryModel) {
	          categoryModel.parentModel = model.parentModel;
	          model.parentModel = categoryModel;
	        }
	
	        return model;
	      });
	      var edgeLabelModel = self.getModel('edgeLabel'); // For option `edgeLabel` can be found by label.xxx.xxx on item mode.
	
	      var fakeSeriesModel = new Model({
	        label: edgeLabelModel.option
	      }, edgeLabelModel.parentModel, ecModel);
	      var emphasisEdgeLabelModel = self.getModel('emphasis.edgeLabel');
	      var emphasisFakeSeriesModel = new Model({
	        emphasis: {
	          label: emphasisEdgeLabelModel.option
	        }
	      }, emphasisEdgeLabelModel.parentModel, ecModel);
	      edgeData.wrapMethod('getItemModel', function (model) {
	        model.customizeGetParent(edgeGetParent);
	        return model;
	      });
	
	      function edgeGetParent(path) {
	        path = this.parsePath(path);
	        return path && path[0] === 'label' ? fakeSeriesModel : path && path[0] === 'emphasis' && path[1] === 'label' ? emphasisFakeSeriesModel : this.parentModel;
	      }
	    }
	  },
	
	  /**
	   * @return {module:echarts/data/Graph}
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @return {module:echarts/data/List}
	   */
	  getCategoriesData: function () {
	    return this._categoriesData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    if (dataType === 'edge') {
	      var nodeData = this.getData();
	      var params = this.getDataParams(dataIndex, dataType);
	      var edge = nodeData.graph.getEdgeByIndex(dataIndex);
	      var sourceName = nodeData.getName(edge.node1.dataIndex);
	      var targetName = nodeData.getName(edge.node2.dataIndex);
	      var html = [];
	      sourceName != null && html.push(sourceName);
	      targetName != null && html.push(targetName);
	      html = encodeHTML(html.join(' > '));
	
	      if (params.value) {
	        html += ' : ' + encodeHTML(params.value);
	      }
	
	      return html;
	    } else {
	      // dataType === 'node' or empty
	      return GraphSeries.superApply(this, 'formatTooltip', arguments);
	    }
	  },
	  _updateCategoriesData: function () {
	    var categories = zrUtil.map(this.option.categories || [], function (category) {
	      // Data must has value
	      return category.value != null ? category : zrUtil.extend({
	        value: 0
	      }, category);
	    });
	    var categoriesData = new List(['value'], this);
	    categoriesData.initData(categories);
	    this._categoriesData = categoriesData;
	    this._categoriesModels = categoriesData.mapArray(function (idx) {
	      return categoriesData.getItemModel(idx, true);
	    });
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  isAnimationEnabled: function () {
	    return GraphSeries.superCall(this, 'isAnimationEnabled') // Not enable animation when do force layout
	    && !(this.get('layout') === 'force' && this.get('force.layoutAnimation'));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    // Default option for all coordinate systems
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // geoIndex: 0,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    layout: null,
	    focusNodeAdjacency: false,
	    // Configuration of circular layout
	    circular: {
	      rotateLabel: false
	    },
	    // Configuration of force directed layout
	    force: {
	      initLayout: null,
	      // Node repulsion. Can be an array to represent range.
	      repulsion: [0, 50],
	      gravity: 0.1,
	      // Initial friction
	      friction: 0.6,
	      // Edge length. Can be an array to represent range.
	      edgeLength: 30,
	      layoutAnimation: true
	    },
	    left: 'center',
	    top: 'center',
	    // right: null,
	    // bottom: null,
	    // width: '80%',
	    // height: '80%',
	    symbol: 'circle',
	    symbolSize: 10,
	    edgeSymbol: ['none', 'none'],
	    edgeSymbolSize: 10,
	    edgeLabel: {
	      position: 'middle',
	      distance: 5
	    },
	    draggable: false,
	    roam: false,
	    // Default on center of graph
	    center: null,
	    zoom: 1,
	    // Symbol size scale ratio in roam
	    nodeScaleRatio: 0.6,
	    // cursor: null,
	    // categories: [],
	    // data: []
	    // Or
	    // nodes: []
	    //
	    // links: []
	    // Or
	    // edges: []
	    label: {
	      show: false,
	      formatter: '{b}'
	    },
	    itemStyle: {},
	    lineStyle: {
	      color: '#aaa',
	      width: 1,
	      opacity: 0.5
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = GraphSeries;
	module.exports = _default;

/***/ },
/* 2229 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var SymbolDraw = __webpack_require__(287);
	
	var LineDraw = __webpack_require__(498);
	
	var RoamController = __webpack_require__(291);
	
	var roamHelper = __webpack_require__(506);
	
	var _cursorHelper = __webpack_require__(356);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var graphic = __webpack_require__(14);
	
	var adjustEdge = __webpack_require__(2230);
	
	var _graphHelper = __webpack_require__(496);
	
	var getNodeGlobalScale = _graphHelper.getNodeGlobalScale;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var FOCUS_ADJACENCY = '__focusNodeAdjacency';
	var UNFOCUS_ADJACENCY = '__unfocusNodeAdjacency';
	var nodeOpacityPath = ['itemStyle', 'opacity'];
	var lineOpacityPath = ['lineStyle', 'opacity'];
	
	function getItemOpacity(item, opacityPath) {
	  var opacity = item.getVisual('opacity');
	  return opacity != null ? opacity : item.getModel().get(opacityPath);
	}
	
	function fadeOutItem(item, opacityPath, opacityRatio) {
	  var el = item.getGraphicEl();
	  var opacity = getItemOpacity(item, opacityPath);
	
	  if (opacityRatio != null) {
	    opacity == null && (opacity = 1);
	    opacity *= opacityRatio;
	  }
	
	  el.downplay && el.downplay();
	  el.traverse(function (child) {
	    if (!child.isGroup) {
	      var opct = child.lineLabelOriginalOpacity;
	
	      if (opct == null || opacityRatio != null) {
	        opct = opacity;
	      }
	
	      child.setStyle('opacity', opct);
	    }
	  });
	}
	
	function fadeInItem(item, opacityPath) {
	  var opacity = getItemOpacity(item, opacityPath);
	  var el = item.getGraphicEl(); // Should go back to normal opacity first, consider hoverLayer,
	  // where current state is copied to elMirror, and support
	  // emphasis opacity here.
	
	  el.traverse(function (child) {
	    !child.isGroup && child.setStyle('opacity', opacity);
	  });
	  el.highlight && el.highlight();
	}
	
	var _default = echarts.extendChartView({
	  type: 'graph',
	  init: function (ecModel, api) {
	    var symbolDraw = new SymbolDraw();
	    var lineDraw = new LineDraw();
	    var group = this.group;
	    this._controller = new RoamController(api.getZr());
	    this._controllerHost = {
	      target: group
	    };
	    group.add(symbolDraw.group);
	    group.add(lineDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineDraw = lineDraw;
	    this._firstRender = true;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var graphView = this;
	    var coordSys = seriesModel.coordinateSystem;
	    this._model = seriesModel;
	    var symbolDraw = this._symbolDraw;
	    var lineDraw = this._lineDraw;
	    var group = this.group;
	
	    if (coordSys.type === 'view') {
	      var groupNewProp = {
	        position: coordSys.position,
	        scale: coordSys.scale
	      };
	
	      if (this._firstRender) {
	        group.attr(groupNewProp);
	      } else {
	        graphic.updateProps(group, groupNewProp, seriesModel);
	      }
	    } // Fix edge contact point with node
	
	
	    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	    var data = seriesModel.getData();
	    symbolDraw.updateData(data);
	    var edgeData = seriesModel.getEdgeData();
	    lineDraw.updateData(edgeData);
	
	    this._updateNodeAndLinkScale();
	
	    this._updateController(seriesModel, ecModel, api);
	
	    clearTimeout(this._layoutTimeout);
	    var forceLayout = seriesModel.forceLayout;
	    var layoutAnimation = seriesModel.get('force.layoutAnimation');
	
	    if (forceLayout) {
	      this._startForceLayoutIteration(forceLayout, layoutAnimation);
	    }
	
	    data.eachItemGraphicEl(function (el, idx) {
	      var itemModel = data.getItemModel(idx); // Update draggable
	
	      el.off('drag').off('dragend');
	      var draggable = itemModel.get('draggable');
	
	      if (draggable) {
	        el.on('drag', function () {
	          if (forceLayout) {
	            forceLayout.warmUp();
	            !this._layouting && this._startForceLayoutIteration(forceLayout, layoutAnimation);
	            forceLayout.setFixed(idx); // Write position back to layout
	
	            data.setItemLayout(idx, el.position);
	          }
	        }, this).on('dragend', function () {
	          if (forceLayout) {
	            forceLayout.setUnfixed(idx);
	          }
	        }, this);
	      }
	
	      el.setDraggable(draggable && forceLayout);
	      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
	      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);
	
	      if (itemModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
	          graphView._clearTimer();
	
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            dataIndex: el.dataIndex
	          });
	        });
	        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
	          graphView._dispatchUnfocus(api);
	        });
	      }
	    }, this);
	    data.graph.eachEdge(function (edge) {
	      var el = edge.getGraphicEl();
	      el[FOCUS_ADJACENCY] && el.off('mouseover', el[FOCUS_ADJACENCY]);
	      el[UNFOCUS_ADJACENCY] && el.off('mouseout', el[UNFOCUS_ADJACENCY]);
	
	      if (edge.getModel().get('focusNodeAdjacency')) {
	        el.on('mouseover', el[FOCUS_ADJACENCY] = function () {
	          graphView._clearTimer();
	
	          api.dispatchAction({
	            type: 'focusNodeAdjacency',
	            seriesId: seriesModel.id,
	            edgeDataIndex: edge.dataIndex
	          });
	        });
	        el.on('mouseout', el[UNFOCUS_ADJACENCY] = function () {
	          graphView._dispatchUnfocus(api);
	        });
	      }
	    });
	    var circularRotateLabel = seriesModel.get('layout') === 'circular' && seriesModel.get('circular.rotateLabel');
	    var cx = data.getLayout('cx');
	    var cy = data.getLayout('cy');
	    data.eachItemGraphicEl(function (el, idx) {
	      var itemModel = data.getItemModel(idx);
	      var labelRotate = itemModel.get('label.rotate') || 0;
	      var symbolPath = el.getSymbolPath();
	
	      if (circularRotateLabel) {
	        var pos = data.getItemLayout(idx);
	        var rad = Math.atan2(pos[1] - cy, pos[0] - cx);
	
	        if (rad < 0) {
	          rad = Math.PI * 2 + rad;
	        }
	
	        var isLeft = pos[0] < cx;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	
	        var textPosition = isLeft ? 'left' : 'right';
	        graphic.modifyLabelStyle(symbolPath, {
	          textRotation: -rad,
	          textPosition: textPosition,
	          textOrigin: 'center'
	        }, {
	          textPosition: textPosition
	        });
	      } else {
	        graphic.modifyLabelStyle(symbolPath, {
	          textRotation: labelRotate *= Math.PI / 180
	        });
	      }
	    });
	    this._firstRender = false;
	  },
	  dispose: function () {
	    this._controller && this._controller.dispose();
	    this._controllerHost = {};
	
	    this._clearTimer();
	  },
	  _dispatchUnfocus: function (api, opt) {
	    var self = this;
	
	    this._clearTimer();
	
	    this._unfocusDelayTimer = setTimeout(function () {
	      self._unfocusDelayTimer = null;
	      api.dispatchAction({
	        type: 'unfocusNodeAdjacency',
	        seriesId: self._model.id
	      });
	    }, 500);
	  },
	  _clearTimer: function () {
	    if (this._unfocusDelayTimer) {
	      clearTimeout(this._unfocusDelayTimer);
	      this._unfocusDelayTimer = null;
	    }
	  },
	  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var graph = data.graph;
	    var dataIndex = payload.dataIndex;
	    var edgeDataIndex = payload.edgeDataIndex;
	    var node = graph.getNodeByIndex(dataIndex);
	    var edge = graph.getEdgeByIndex(edgeDataIndex);
	
	    if (!node && !edge) {
	      return;
	    }
	
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath, 0.1);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath, 0.1);
	    });
	
	    if (node) {
	      fadeInItem(node, nodeOpacityPath);
	      zrUtil.each(node.edges, function (adjacentEdge) {
	        if (adjacentEdge.dataIndex < 0) {
	          return;
	        }
	
	        fadeInItem(adjacentEdge, lineOpacityPath);
	        fadeInItem(adjacentEdge.node1, nodeOpacityPath);
	        fadeInItem(adjacentEdge.node2, nodeOpacityPath);
	      });
	    }
	
	    if (edge) {
	      fadeInItem(edge, lineOpacityPath);
	      fadeInItem(edge.node1, nodeOpacityPath);
	      fadeInItem(edge.node2, nodeOpacityPath);
	    }
	  },
	  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var graph = seriesModel.getData().graph;
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath);
	    });
	  },
	  _startForceLayoutIteration: function (forceLayout, layoutAnimation) {
	    var self = this;
	
	    (function step() {
	      forceLayout.step(function (stopped) {
	        self.updateLayout(self._model);
	        (self._layouting = !stopped) && (layoutAnimation ? self._layoutTimeout = setTimeout(step, 16) : step());
	      });
	    })();
	  },
	  _updateController: function (seriesModel, ecModel, api) {
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    var group = this.group;
	    controller.setPointerChecker(function (e, x, y) {
	      var rect = group.getBoundingRect();
	      rect.applyTransform(group.transform);
	      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	    });
	
	    if (seriesModel.coordinateSystem.type !== 'view') {
	      controller.disable();
	      return;
	    }
	
	    controller.enable(seriesModel.get('roam'));
	    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	    controller.off('pan').off('zoom').on('pan', function (e) {
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        dx: e.dx,
	        dy: e.dy
	      });
	    }).on('zoom', function (e) {
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'graphRoam',
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      });
	
	      this._updateNodeAndLinkScale();
	
	      adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	
	      this._lineDraw.updateLayout();
	    }, this);
	  },
	  _updateNodeAndLinkScale: function () {
	    var seriesModel = this._model;
	    var data = seriesModel.getData();
	    var nodeScale = getNodeGlobalScale(seriesModel);
	    var invScale = [nodeScale, nodeScale];
	    data.eachItemGraphicEl(function (el, idx) {
	      el.attr('scale', invScale);
	    });
	  },
	  updateLayout: function (seriesModel) {
	    adjustEdge(seriesModel.getGraph(), getNodeGlobalScale(seriesModel));
	
	    this._symbolDraw.updateLayout();
	
	    this._lineDraw.updateLayout();
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove();
	    this._lineDraw && this._lineDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2230 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var curveTool = __webpack_require__(188);
	
	var vec2 = __webpack_require__(55);
	
	var _graphHelper = __webpack_require__(496);
	
	var getSymbolSize = _graphHelper.getSymbolSize;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var v1 = [];
	var v2 = [];
	var v3 = [];
	var quadraticAt = curveTool.quadraticAt;
	var v2DistSquare = vec2.distSquare;
	var mathAbs = Math.abs;
	
	function intersectCurveCircle(curvePoints, center, radius) {
	  var p0 = curvePoints[0];
	  var p1 = curvePoints[1];
	  var p2 = curvePoints[2];
	  var d = Infinity;
	  var t;
	  var radiusSquare = radius * radius;
	  var interval = 0.1;
	
	  for (var _t = 0.1; _t <= 0.9; _t += 0.1) {
	    v1[0] = quadraticAt(p0[0], p1[0], p2[0], _t);
	    v1[1] = quadraticAt(p0[1], p1[1], p2[1], _t);
	    var diff = mathAbs(v2DistSquare(v1, center) - radiusSquare);
	
	    if (diff < d) {
	      d = diff;
	      t = _t;
	    }
	  } // Assume the segment is monotone，Find root through Bisection method
	  // At most 32 iteration
	
	
	  for (var i = 0; i < 32; i++) {
	    // var prev = t - interval;
	    var next = t + interval; // v1[0] = quadraticAt(p0[0], p1[0], p2[0], prev);
	    // v1[1] = quadraticAt(p0[1], p1[1], p2[1], prev);
	
	    v2[0] = quadraticAt(p0[0], p1[0], p2[0], t);
	    v2[1] = quadraticAt(p0[1], p1[1], p2[1], t);
	    v3[0] = quadraticAt(p0[0], p1[0], p2[0], next);
	    v3[1] = quadraticAt(p0[1], p1[1], p2[1], next);
	    var diff = v2DistSquare(v2, center) - radiusSquare;
	
	    if (mathAbs(diff) < 1e-2) {
	      break;
	    } // var prevDiff = v2DistSquare(v1, center) - radiusSquare;
	
	
	    var nextDiff = v2DistSquare(v3, center) - radiusSquare;
	    interval /= 2;
	
	    if (diff < 0) {
	      if (nextDiff >= 0) {
	        t = t + interval;
	      } else {
	        t = t - interval;
	      }
	    } else {
	      if (nextDiff >= 0) {
	        t = t - interval;
	      } else {
	        t = t + interval;
	      }
	    }
	  }
	
	  return t;
	} // Adjust edge to avoid
	
	
	function _default(graph, scale) {
	  var tmp0 = [];
	  var quadraticSubdivide = curveTool.quadraticSubdivide;
	  var pts = [[], [], []];
	  var pts2 = [[], []];
	  var v = [];
	  scale /= 2;
	  graph.eachEdge(function (edge, idx) {
	    var linePoints = edge.getLayout();
	    var fromSymbol = edge.getVisual('fromSymbol');
	    var toSymbol = edge.getVisual('toSymbol');
	
	    if (!linePoints.__original) {
	      linePoints.__original = [vec2.clone(linePoints[0]), vec2.clone(linePoints[1])];
	
	      if (linePoints[2]) {
	        linePoints.__original.push(vec2.clone(linePoints[2]));
	      }
	    }
	
	    var originalPoints = linePoints.__original; // Quadratic curve
	
	    if (linePoints[2] != null) {
	      vec2.copy(pts[0], originalPoints[0]);
	      vec2.copy(pts[1], originalPoints[2]);
	      vec2.copy(pts[2], originalPoints[1]);
	
	      if (fromSymbol && fromSymbol !== 'none') {
	        var symbolSize = getSymbolSize(edge.node1);
	        var t = intersectCurveCircle(pts, originalPoints[0], symbolSize * scale); // Subdivide and get the second
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[0][0] = tmp0[3];
	        pts[1][0] = tmp0[4];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[0][1] = tmp0[3];
	        pts[1][1] = tmp0[4];
	      }
	
	      if (toSymbol && toSymbol !== 'none') {
	        var symbolSize = getSymbolSize(edge.node2);
	        var t = intersectCurveCircle(pts, originalPoints[1], symbolSize * scale); // Subdivide and get the first
	
	        quadraticSubdivide(pts[0][0], pts[1][0], pts[2][0], t, tmp0);
	        pts[1][0] = tmp0[1];
	        pts[2][0] = tmp0[2];
	        quadraticSubdivide(pts[0][1], pts[1][1], pts[2][1], t, tmp0);
	        pts[1][1] = tmp0[1];
	        pts[2][1] = tmp0[2];
	      } // Copy back to layout
	
	
	      vec2.copy(linePoints[0], pts[0]);
	      vec2.copy(linePoints[1], pts[2]);
	      vec2.copy(linePoints[2], pts[1]);
	    } // Line
	    else {
	        vec2.copy(pts2[0], originalPoints[0]);
	        vec2.copy(pts2[1], originalPoints[1]);
	        vec2.sub(v, pts2[1], pts2[0]);
	        vec2.normalize(v, v);
	
	        if (fromSymbol && fromSymbol !== 'none') {
	          var symbolSize = getSymbolSize(edge.node1);
	          vec2.scaleAndAdd(pts2[0], pts2[0], v, symbolSize * scale);
	        }
	
	        if (toSymbol && toSymbol !== 'none') {
	          var symbolSize = getSymbolSize(edge.node2);
	          vec2.scaleAndAdd(pts2[1], pts2[1], v, -symbolSize * scale);
	        }
	
	        vec2.copy(linePoints[0], pts2[0]);
	        vec2.copy(linePoints[1], pts2[1]);
	      }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2231 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (!legendModels || !legendModels.length) {
	    return;
	  }
	
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var categoriesData = graphSeries.getCategoriesData();
	    var graph = graphSeries.getGraph();
	    var data = graph.data;
	    var categoryNames = categoriesData.mapArray(categoriesData.getName);
	    data.filterSelf(function (idx) {
	      var model = data.getItemModel(idx);
	      var category = model.getShallow('category');
	
	      if (category != null) {
	        if (typeof category === 'number') {
	          category = categoryNames[category];
	        } // If in any legend component the status is not selected.
	
	
	        for (var i = 0; i < legendModels.length; i++) {
	          if (!legendModels[i].isSelected(category)) {
	            return false;
	          }
	        }
	      }
	
	      return true;
	    });
	  }, this);
	}
	
	module.exports = _default;

/***/ },
/* 2232 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var paletteScope = {};
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var categoriesData = seriesModel.getCategoriesData();
	    var data = seriesModel.getData();
	    var categoryNameIdxMap = {};
	    categoriesData.each(function (idx) {
	      var name = categoriesData.getName(idx); // Add prefix to avoid conflict with Object.prototype.
	
	      categoryNameIdxMap['ec-' + name] = idx;
	      var itemModel = categoriesData.getItemModel(idx);
	      var color = itemModel.get('itemStyle.color') || seriesModel.getColorFromPalette(name, paletteScope);
	      categoriesData.setItemVisual(idx, 'color', color);
	      var itemStyleList = ['opacity', 'symbol', 'symbolSize', 'symbolKeepAspect'];
	
	      for (var i = 0; i < itemStyleList.length; i++) {
	        var itemStyle = itemModel.getShallow(itemStyleList[i], true);
	
	        if (itemStyle != null) {
	          categoriesData.setItemVisual(idx, itemStyleList[i], itemStyle);
	        }
	      }
	    }); // Assign category color to visual
	
	    if (categoriesData.count()) {
	      data.each(function (idx) {
	        var model = data.getItemModel(idx);
	        var category = model.getShallow('category');
	
	        if (category != null) {
	          if (typeof category === 'string') {
	            category = categoryNameIdxMap['ec-' + category];
	          }
	
	          var itemStyleList = ['color', 'opacity', 'symbol', 'symbolSize', 'symbolKeepAspect'];
	
	          for (var i = 0; i < itemStyleList.length; i++) {
	            if (data.getItemVisual(idx, itemStyleList[i], true) == null) {
	              data.setItemVisual(idx, itemStyleList[i], categoriesData.getItemVisual(category, itemStyleList[i]));
	            }
	          }
	        }
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2233 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _circularLayoutHelper = __webpack_require__(823);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    if (seriesModel.get('layout') === 'circular') {
	      circularLayout(seriesModel, 'symbolSize');
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2234 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var View = __webpack_require__(511);
	
	var _layout = __webpack_require__(46);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var bbox = __webpack_require__(314);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME Where to create the simple view coordinate system
	function getViewRect(seriesModel, api, aspect) {
	  var option = seriesModel.getBoxLayoutParams();
	  option.aspect = aspect;
	  return getLayoutRect(option, {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function _default(ecModel, api) {
	  var viewList = [];
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var coordSysType = seriesModel.get('coordinateSystem');
	
	    if (!coordSysType || coordSysType === 'view') {
	      var data = seriesModel.getData();
	      var positions = data.mapArray(function (idx) {
	        var itemModel = data.getItemModel(idx);
	        return [+itemModel.get('x'), +itemModel.get('y')];
	      });
	      var min = [];
	      var max = [];
	      bbox.fromPoints(positions, min, max); // If width or height is 0
	
	      if (max[0] - min[0] === 0) {
	        max[0] += 1;
	        min[0] -= 1;
	      }
	
	      if (max[1] - min[1] === 0) {
	        max[1] += 1;
	        min[1] -= 1;
	      }
	
	      var aspect = (max[0] - min[0]) / (max[1] - min[1]); // FIXME If get view rect after data processed?
	
	      var viewRect = getViewRect(seriesModel, api, aspect); // Position may be NaN, use view rect instead
	
	      if (isNaN(aspect)) {
	        min = [viewRect.x, viewRect.y];
	        max = [viewRect.x + viewRect.width, viewRect.y + viewRect.height];
	      }
	
	      var bbWidth = max[0] - min[0];
	      var bbHeight = max[1] - min[1];
	      var viewWidth = viewRect.width;
	      var viewHeight = viewRect.height;
	      var viewCoordSys = seriesModel.coordinateSystem = new View();
	      viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	      viewCoordSys.setBoundingRect(min[0], min[1], bbWidth, bbHeight);
	      viewCoordSys.setViewRect(viewRect.x, viewRect.y, viewWidth, viewHeight); // Update roam info
	
	      viewCoordSys.setCenter(seriesModel.get('center'));
	      viewCoordSys.setZoom(seriesModel.get('zoom'));
	      viewList.push(viewCoordSys);
	    }
	  });
	  return viewList;
	}
	
	module.exports = _default;

/***/ },
/* 2235 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var edgeData = seriesModel.getEdgeData();
	    var symbolType = normalize(seriesModel.get('edgeSymbol'));
	    var symbolSize = normalize(seriesModel.get('edgeSymbolSize'));
	    var colorQuery = 'lineStyle.color'.split('.');
	    var opacityQuery = 'lineStyle.opacity'.split('.');
	    edgeData.setVisual('fromSymbol', symbolType && symbolType[0]);
	    edgeData.setVisual('toSymbol', symbolType && symbolType[1]);
	    edgeData.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    edgeData.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    edgeData.setVisual('color', seriesModel.get(colorQuery));
	    edgeData.setVisual('opacity', seriesModel.get(opacityQuery));
	    edgeData.each(function (idx) {
	      var itemModel = edgeData.getItemModel(idx);
	      var edge = graph.getEdgeByIndex(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true)); // Edge visual must after node visual
	
	      var color = itemModel.get(colorQuery);
	      var opacity = itemModel.get(opacityQuery);
	
	      switch (color) {
	        case 'source':
	          color = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          color = edge.node2.getVisual('color');
	          break;
	      }
	
	      symbolType[0] && edge.setVisual('fromSymbol', symbolType[0]);
	      symbolType[1] && edge.setVisual('toSymbol', symbolType[1]);
	      symbolSize[0] && edge.setVisual('fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && edge.setVisual('toSymbolSize', symbolSize[1]);
	      edge.setVisual('color', color);
	      edge.setVisual('opacity', opacity);
	    });
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2236 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var vec2 = __webpack_require__(55);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* Some formulas were originally copied from "d3.js" with some
	* modifications made for this project.
	* (See more details in the comment of the method "step" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var scaleAndAdd = vec2.scaleAndAdd; // function adjacentNode(n, e) {
	//     return e.n1 === n ? e.n2 : e.n1;
	// }
	
	function forceLayout(nodes, edges, opts) {
	  var rect = opts.rect;
	  var width = rect.width;
	  var height = rect.height;
	  var center = [rect.x + width / 2, rect.y + height / 2]; // var scale = opts.scale || 1;
	
	  var gravity = opts.gravity == null ? 0.1 : opts.gravity; // for (var i = 0; i < edges.length; i++) {
	  //     var e = edges[i];
	  //     var n1 = e.n1;
	  //     var n2 = e.n2;
	  //     n1.edges = n1.edges || [];
	  //     n2.edges = n2.edges || [];
	  //     n1.edges.push(e);
	  //     n2.edges.push(e);
	  // }
	  // Init position
	
	  for (var i = 0; i < nodes.length; i++) {
	    var n = nodes[i];
	
	    if (!n.p) {
	      n.p = vec2.create(width * (Math.random() - 0.5) + center[0], height * (Math.random() - 0.5) + center[1]);
	    }
	
	    n.pp = vec2.clone(n.p);
	    n.edges = null;
	  } // Formula in 'Graph Drawing by Force-directed Placement'
	  // var k = scale * Math.sqrt(width * height / nodes.length);
	  // var k2 = k * k;
	
	
	  var initialFriction = opts.friction == null ? 0.6 : opts.friction;
	  var friction = initialFriction;
	  return {
	    warmUp: function () {
	      friction = initialFriction * 0.8;
	    },
	    setFixed: function (idx) {
	      nodes[idx].fixed = true;
	    },
	    setUnfixed: function (idx) {
	      nodes[idx].fixed = false;
	    },
	
	    /**
	     * Some formulas were originally copied from "d3.js"
	     * https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/layout/force.js
	     * with some modifications made for this project.
	     * See the license statement at the head of this file.
	     */
	    step: function (cb) {
	      var v12 = [];
	      var nLen = nodes.length;
	
	      for (var i = 0; i < edges.length; i++) {
	        var e = edges[i];
	
	        if (e.ignoreForceLayout) {
	          continue;
	        }
	
	        var n1 = e.n1;
	        var n2 = e.n2;
	        vec2.sub(v12, n2.p, n1.p);
	        var d = vec2.len(v12) - e.d;
	        var w = n2.w / (n1.w + n2.w);
	
	        if (isNaN(w)) {
	          w = 0;
	        }
	
	        vec2.normalize(v12, v12);
	        !n1.fixed && scaleAndAdd(n1.p, n1.p, v12, w * d * friction);
	        !n2.fixed && scaleAndAdd(n2.p, n2.p, v12, -(1 - w) * d * friction);
	      } // Gravity
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v12, center, n.p); // var d = vec2.len(v12);
	          // vec2.scale(v12, v12, 1 / d);
	          // var gravityFactor = gravity;
	
	          scaleAndAdd(n.p, n.p, v12, gravity * friction);
	        }
	      } // Repulsive
	      // PENDING
	
	
	      for (var i = 0; i < nLen; i++) {
	        var n1 = nodes[i];
	
	        for (var j = i + 1; j < nLen; j++) {
	          var n2 = nodes[j];
	          vec2.sub(v12, n2.p, n1.p);
	          var d = vec2.len(v12);
	
	          if (d === 0) {
	            // Random repulse
	            vec2.set(v12, Math.random() - 0.5, Math.random() - 0.5);
	            d = 1;
	          }
	
	          var repFact = (n1.rep + n2.rep) / d / d;
	          !n1.fixed && scaleAndAdd(n1.pp, n1.pp, v12, repFact);
	          !n2.fixed && scaleAndAdd(n2.pp, n2.pp, v12, -repFact);
	        }
	      }
	
	      var v = [];
	
	      for (var i = 0; i < nLen; i++) {
	        var n = nodes[i];
	
	        if (!n.fixed) {
	          vec2.sub(v, n.p, n.pp);
	          scaleAndAdd(n.p, n.p, v, friction);
	          vec2.copy(n.pp, n.p);
	        }
	      }
	
	      friction = friction * 0.992;
	      cb && cb(nodes, edges, friction < 0.01);
	    }
	  };
	}
	
	exports.forceLayout = forceLayout;

/***/ },
/* 2237 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _forceHelper = __webpack_require__(2236);
	
	var forceLayout = _forceHelper.forceLayout;
	
	var _simpleLayoutHelper = __webpack_require__(824);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	
	var _circularLayoutHelper = __webpack_require__(823);
	
	var circularLayout = _circularLayoutHelper.circularLayout;
	
	var _number = __webpack_require__(25);
	
	var linearMap = _number.linearMap;
	
	var vec2 = __webpack_require__(55);
	
	var zrUtil = __webpack_require__(4);
	
	var _multipleGraphEdgeHelper = __webpack_require__(353);
	
	var getCurvenessForEdge = _multipleGraphEdgeHelper.getCurvenessForEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('graph', function (graphSeries) {
	    var coordSys = graphSeries.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      return;
	    }
	
	    if (graphSeries.get('layout') === 'force') {
	      var preservedPoints = graphSeries.preservedPoints || {};
	      var graph = graphSeries.getGraph();
	      var nodeData = graph.data;
	      var edgeData = graph.edgeData;
	      var forceModel = graphSeries.getModel('force');
	      var initLayout = forceModel.get('initLayout');
	
	      if (graphSeries.preservedPoints) {
	        nodeData.each(function (idx) {
	          var id = nodeData.getId(idx);
	          nodeData.setItemLayout(idx, preservedPoints[id] || [NaN, NaN]);
	        });
	      } else if (!initLayout || initLayout === 'none') {
	        simpleLayout(graphSeries);
	      } else if (initLayout === 'circular') {
	        circularLayout(graphSeries, 'value');
	      }
	
	      var nodeDataExtent = nodeData.getDataExtent('value');
	      var edgeDataExtent = edgeData.getDataExtent('value'); // var edgeDataExtent = edgeData.getDataExtent('value');
	
	      var repulsion = forceModel.get('repulsion');
	      var edgeLength = forceModel.get('edgeLength');
	
	      if (!zrUtil.isArray(repulsion)) {
	        repulsion = [repulsion, repulsion];
	      }
	
	      if (!zrUtil.isArray(edgeLength)) {
	        edgeLength = [edgeLength, edgeLength];
	      } // Larger value has smaller length
	
	
	      edgeLength = [edgeLength[1], edgeLength[0]];
	      var nodes = nodeData.mapArray('value', function (value, idx) {
	        var point = nodeData.getItemLayout(idx);
	        var rep = linearMap(value, nodeDataExtent, repulsion);
	
	        if (isNaN(rep)) {
	          rep = (repulsion[0] + repulsion[1]) / 2;
	        }
	
	        return {
	          w: rep,
	          rep: rep,
	          fixed: nodeData.getItemModel(idx).get('fixed'),
	          p: !point || isNaN(point[0]) || isNaN(point[1]) ? null : point
	        };
	      });
	      var edges = edgeData.mapArray('value', function (value, idx) {
	        var edge = graph.getEdgeByIndex(idx);
	        var d = linearMap(value, edgeDataExtent, edgeLength);
	
	        if (isNaN(d)) {
	          d = (edgeLength[0] + edgeLength[1]) / 2;
	        }
	
	        var edgeModel = edge.getModel();
	        var curveness = zrUtil.retrieve3(edgeModel.get('lineStyle.curveness'), -getCurvenessForEdge(edge, graphSeries, idx, true), 0);
	        return {
	          n1: nodes[edge.node1.dataIndex],
	          n2: nodes[edge.node2.dataIndex],
	          d: d,
	          curveness: curveness,
	          ignoreForceLayout: edgeModel.get('ignoreForceLayout')
	        };
	      });
	      var coordSys = graphSeries.coordinateSystem;
	      var rect = coordSys.getBoundingRect();
	      var forceInstance = forceLayout(nodes, edges, {
	        rect: rect,
	        gravity: forceModel.get('gravity'),
	        friction: forceModel.get('friction')
	      });
	      var oldStep = forceInstance.step;
	
	      forceInstance.step = function (cb) {
	        for (var i = 0, l = nodes.length; i < l; i++) {
	          if (nodes[i].fixed) {
	            // Write back to layout instance
	            vec2.copy(nodes[i].p, graph.getNodeByIndex(i).getLayout());
	          }
	        }
	
	        oldStep(function (nodes, edges, stopped) {
	          for (var i = 0, l = nodes.length; i < l; i++) {
	            if (!nodes[i].fixed) {
	              graph.getNodeByIndex(i).setLayout(nodes[i].p);
	            }
	
	            preservedPoints[nodeData.getId(i)] = nodes[i].p;
	          }
	
	          for (var i = 0, l = edges.length; i < l; i++) {
	            var e = edges[i];
	            var edge = graph.getEdgeByIndex(i);
	            var p1 = e.n1.p;
	            var p2 = e.n2.p;
	            var points = edge.getLayout();
	            points = points ? points.slice() : [];
	            points[0] = points[0] || [];
	            points[1] = points[1] || [];
	            vec2.copy(points[0], p1);
	            vec2.copy(points[1], p2);
	
	            if (+e.curveness) {
	              points[2] = [(p1[0] + p2[0]) / 2 - (p1[1] - p2[1]) * e.curveness, (p1[1] + p2[1]) / 2 - (p2[0] - p1[0]) * e.curveness];
	            }
	
	            edge.setLayout(points);
	          } // Update layout
	
	
	          cb && cb(stopped);
	        });
	      };
	
	      graphSeries.forceLayout = forceInstance;
	      graphSeries.preservedPoints = preservedPoints; // Step to get the layout
	
	      forceInstance.step();
	    } else {
	      // Remove prev injected forceLayout instance
	      graphSeries.forceLayout = null;
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2238 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var _roamHelper = __webpack_require__(495);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	__webpack_require__(828);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var actionInfo = {
	  type: 'graphRoam',
	  event: 'graphRoam',
	  update: 'none'
	};
	/**
	 * @payload
	 * @property {string} name Series name
	 * @property {number} [dx]
	 * @property {number} [dy]
	 * @property {number} [zoom]
	 * @property {number} [originX]
	 * @property {number} [originY]
	 */
	
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: payload
	  }, function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var res = updateCenterAndZoom(coordSys, payload);
	    seriesModel.setCenter && seriesModel.setCenter(res.center);
	    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	  });
	});

/***/ },
/* 2239 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	
	var _simpleLayoutHelper = __webpack_require__(824);
	
	var simpleLayout = _simpleLayoutHelper.simpleLayout;
	var simpleLayoutEdge = _simpleLayoutHelper.simpleLayoutEdge;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('graph', function (seriesModel) {
	    var layout = seriesModel.get('layout');
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type !== 'view') {
	      var data = seriesModel.getData();
	      var dimensions = [];
	      each(coordSys.dimensions, function (coordDim) {
	        dimensions = dimensions.concat(data.mapDimension(coordDim, true));
	      });
	
	      for (var dataIndex = 0; dataIndex < data.count(); dataIndex++) {
	        var value = [];
	        var hasValue = false;
	
	        for (var i = 0; i < dimensions.length; i++) {
	          var val = data.get(dimensions[i], dataIndex);
	
	          if (!isNaN(val)) {
	            hasValue = true;
	          }
	
	          value.push(val);
	        }
	
	        if (hasValue) {
	          data.setItemLayout(dataIndex, coordSys.dataToPoint(value));
	        } else {
	          // Also {Array.<number>}, not undefined to avoid if...else... statement
	          data.setItemLayout(dataIndex, [NaN, NaN]);
	        }
	      }
	
	      simpleLayoutEdge(data.graph, seriesModel);
	    } else if (!layout || layout === 'none') {
	      simpleLayout(seriesModel);
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2240 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(2242);
	
	__webpack_require__(2243);

/***/ },
/* 2241 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint8ClampedArray */
	var GRADIENT_LEVELS = 256;
	/**
	 * Heatmap Chart
	 *
	 * @class
	 */
	
	function Heatmap() {
	  var canvas = zrUtil.createCanvas();
	  this.canvas = canvas;
	  this.blurSize = 30;
	  this.pointSize = 20;
	  this.maxOpacity = 1;
	  this.minOpacity = 0;
	  this._gradientPixels = {};
	}
	
	Heatmap.prototype = {
	  /**
	   * Renders Heatmap and returns the rendered canvas
	   * @param {Array} data array of data, each has x, y, value
	   * @param {number} width canvas width
	   * @param {number} height canvas height
	   */
	  update: function (data, width, height, normalize, colorFunc, isInRange) {
	    var brush = this._getBrush();
	
	    var gradientInRange = this._getGradient(data, colorFunc, 'inRange');
	
	    var gradientOutOfRange = this._getGradient(data, colorFunc, 'outOfRange');
	
	    var r = this.pointSize + this.blurSize;
	    var canvas = this.canvas;
	    var ctx = canvas.getContext('2d');
	    var len = data.length;
	    canvas.width = width;
	    canvas.height = height;
	
	    for (var i = 0; i < len; ++i) {
	      var p = data[i];
	      var x = p[0];
	      var y = p[1];
	      var value = p[2]; // calculate alpha using value
	
	      var alpha = normalize(value); // draw with the circle brush with alpha
	
	      ctx.globalAlpha = alpha;
	      ctx.drawImage(brush, x - r, y - r);
	    }
	
	    if (!canvas.width || !canvas.height) {
	      // Avoid "Uncaught DOMException: Failed to execute 'getImageData' on
	      // 'CanvasRenderingContext2D': The source height is 0."
	      return canvas;
	    } // colorize the canvas using alpha value and set with gradient
	
	
	    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
	    var pixels = imageData.data;
	    var offset = 0;
	    var pixelLen = pixels.length;
	    var minOpacity = this.minOpacity;
	    var maxOpacity = this.maxOpacity;
	    var diffOpacity = maxOpacity - minOpacity;
	
	    while (offset < pixelLen) {
	      var alpha = pixels[offset + 3] / 256;
	      var gradientOffset = Math.floor(alpha * (GRADIENT_LEVELS - 1)) * 4; // Simple optimize to ignore the empty data
	
	      if (alpha > 0) {
	        var gradient = isInRange(alpha) ? gradientInRange : gradientOutOfRange; // Any alpha > 0 will be mapped to [minOpacity, maxOpacity]
	
	        alpha > 0 && (alpha = alpha * diffOpacity + minOpacity);
	        pixels[offset++] = gradient[gradientOffset];
	        pixels[offset++] = gradient[gradientOffset + 1];
	        pixels[offset++] = gradient[gradientOffset + 2];
	        pixels[offset++] = gradient[gradientOffset + 3] * alpha * 256;
	      } else {
	        offset += 4;
	      }
	    }
	
	    ctx.putImageData(imageData, 0, 0);
	    return canvas;
	  },
	
	  /**
	   * get canvas of a black circle brush used for canvas to draw later
	   * @private
	   * @returns {Object} circle brush canvas
	   */
	  _getBrush: function () {
	    var brushCanvas = this._brushCanvas || (this._brushCanvas = zrUtil.createCanvas()); // set brush size
	
	    var r = this.pointSize + this.blurSize;
	    var d = r * 2;
	    brushCanvas.width = d;
	    brushCanvas.height = d;
	    var ctx = brushCanvas.getContext('2d');
	    ctx.clearRect(0, 0, d, d); // in order to render shadow without the distinct circle,
	    // draw the distinct circle in an invisible place,
	    // and use shadowOffset to draw shadow in the center of the canvas
	
	    ctx.shadowOffsetX = d;
	    ctx.shadowBlur = this.blurSize; // draw the shadow in black, and use alpha and shadow blur to generate
	    // color in color map
	
	    ctx.shadowColor = '#000'; // draw circle in the left to the canvas
	
	    ctx.beginPath();
	    ctx.arc(-r, r, this.pointSize, 0, Math.PI * 2, true);
	    ctx.closePath();
	    ctx.fill();
	    return brushCanvas;
	  },
	
	  /**
	   * get gradient color map
	   * @private
	   */
	  _getGradient: function (data, colorFunc, state) {
	    var gradientPixels = this._gradientPixels;
	    var pixelsSingleState = gradientPixels[state] || (gradientPixels[state] = new Uint8ClampedArray(256 * 4));
	    var color = [0, 0, 0, 0];
	    var off = 0;
	
	    for (var i = 0; i < 256; i++) {
	      colorFunc[state](i / 255, true, color);
	      pixelsSingleState[off++] = color[0];
	      pixelsSingleState[off++] = color[1];
	      pixelsSingleState[off++] = color[2];
	      pixelsSingleState[off++] = color[3];
	    }
	
	    return pixelsSingleState;
	  }
	};
	var _default = Heatmap;
	module.exports = _default;

/***/ },
/* 2242 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(77);
	
	var createListFromArray = __webpack_require__(159);
	
	var CoordinateSystem = __webpack_require__(121);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.heatmap',
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      generateCoord: 'value'
	    });
	  },
	  preventIncremental: function () {
	    var coordSysCreator = CoordinateSystem.get(this.get('coordinateSystem'));
	
	    if (coordSysCreator && coordSysCreator.dimensions) {
	      return coordSysCreator.dimensions[0] === 'lng' && coordSysCreator.dimensions[1] === 'lat';
	    }
	  },
	  defaultOption: {
	    // Cartesian2D or geo
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Geo coordinate system
	    geoIndex: 0,
	    blurSize: 30,
	    pointSize: 20,
	    maxOpacity: 1,
	    minOpacity: 0
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2243 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(10);
	
	var graphic = __webpack_require__(14);
	
	var HeatmapLayer = __webpack_require__(2241);
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getIsInPiecewiseRange(dataExtent, pieceList, selected) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  pieceList = zrUtil.map(pieceList, function (piece) {
	    return {
	      interval: [(piece.interval[0] - dataExtent[0]) / dataSpan, (piece.interval[1] - dataExtent[0]) / dataSpan]
	    };
	  });
	  var len = pieceList.length;
	  var lastIndex = 0;
	  return function (val) {
	    // Try to find in the location of the last found
	    for (var i = lastIndex; i < len; i++) {
	      var interval = pieceList[i].interval;
	
	      if (interval[0] <= val && val <= interval[1]) {
	        lastIndex = i;
	        break;
	      }
	    }
	
	    if (i === len) {
	      // Not found, back interation
	      for (var i = lastIndex - 1; i >= 0; i--) {
	        var interval = pieceList[i].interval;
	
	        if (interval[0] <= val && val <= interval[1]) {
	          lastIndex = i;
	          break;
	        }
	      }
	    }
	
	    return i >= 0 && i < len && selected[i];
	  };
	}
	
	function getIsInContinuousRange(dataExtent, range) {
	  var dataSpan = dataExtent[1] - dataExtent[0];
	  range = [(range[0] - dataExtent[0]) / dataSpan, (range[1] - dataExtent[0]) / dataSpan];
	  return function (val) {
	    return val >= range[0] && val <= range[1];
	  };
	}
	
	function isGeoCoordSys(coordSys) {
	  var dimensions = coordSys.dimensions; // Not use coorSys.type === 'geo' because coordSys maybe extended
	
	  return dimensions[0] === 'lng' && dimensions[1] === 'lat';
	}
	
	var _default = echarts.extendChartView({
	  type: 'heatmap',
	  render: function (seriesModel, ecModel, api) {
	    var visualMapOfThisSeries;
	    ecModel.eachComponent('visualMap', function (visualMap) {
	      visualMap.eachTargetSeries(function (targetSeries) {
	        if (targetSeries === seriesModel) {
	          visualMapOfThisSeries = visualMap;
	        }
	      });
	    });
	    this.group.removeAll();
	    this._incrementalDisplayable = null;
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type === 'cartesian2d' || coordSys.type === 'calendar') {
	      this._renderOnCartesianAndCalendar(seriesModel, api, 0, seriesModel.getData().count());
	    } else if (isGeoCoordSys(coordSys)) {
	      this._renderOnGeo(coordSys, seriesModel, visualMapOfThisSeries, api);
	    }
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this.group.removeAll();
	  },
	  incrementalRender: function (params, seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys) {
	      this._renderOnCartesianAndCalendar(seriesModel, api, params.start, params.end, true);
	    }
	  },
	  _renderOnCartesianAndCalendar: function (seriesModel, api, start, end, incremental) {
	    var coordSys = seriesModel.coordinateSystem;
	    var width;
	    var height;
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      width = xAxis.getBandWidth();
	      height = yAxis.getBandWidth();
	    }
	
	    var group = this.group;
	    var data = seriesModel.getData();
	    var itemStyleQuery = 'itemStyle';
	    var hoverItemStyleQuery = 'emphasis.itemStyle';
	    var labelQuery = 'label';
	    var hoverLabelQuery = 'emphasis.label';
	    var style = seriesModel.getModel(itemStyleQuery).getItemStyle(['color']);
	    var hoverStl = seriesModel.getModel(hoverItemStyleQuery).getItemStyle();
	    var labelModel = seriesModel.getModel(labelQuery);
	    var hoverLabelModel = seriesModel.getModel(hoverLabelQuery);
	    var coordSysType = coordSys.type;
	    var dataDims = coordSysType === 'cartesian2d' ? [data.mapDimension('x'), data.mapDimension('y'), data.mapDimension('value')] : [data.mapDimension('time'), data.mapDimension('value')];
	
	    for (var idx = start; idx < end; idx++) {
	      var rect;
	
	      if (coordSysType === 'cartesian2d') {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[2], idx))) {
	          continue;
	        }
	
	        var point = coordSys.dataToPoint([data.get(dataDims[0], idx), data.get(dataDims[1], idx)]);
	        rect = new graphic.Rect({
	          shape: {
	            x: Math.floor(Math.round(point[0]) - width / 2),
	            y: Math.floor(Math.round(point[1]) - height / 2),
	            width: Math.ceil(width),
	            height: Math.ceil(height)
	          },
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      } else {
	        // Ignore empty data
	        if (isNaN(data.get(dataDims[1], idx))) {
	          continue;
	        }
	
	        rect = new graphic.Rect({
	          z2: 1,
	          shape: coordSys.dataToRect([data.get(dataDims[0], idx)]).contentShape,
	          style: {
	            fill: data.getItemVisual(idx, 'color'),
	            opacity: data.getItemVisual(idx, 'opacity')
	          }
	        });
	      }
	
	      var itemModel = data.getItemModel(idx); // Optimization for large datset
	
	      if (data.hasItemOption) {
	        style = itemModel.getModel(itemStyleQuery).getItemStyle(['color']);
	        hoverStl = itemModel.getModel(hoverItemStyleQuery).getItemStyle();
	        labelModel = itemModel.getModel(labelQuery);
	        hoverLabelModel = itemModel.getModel(hoverLabelQuery);
	      }
	
	      var rawValue = seriesModel.getRawValue(idx);
	      var defaultText = '-';
	
	      if (rawValue && rawValue[2] != null) {
	        defaultText = rawValue[2];
	      }
	
	      graphic.setLabelStyle(style, hoverStl, labelModel, hoverLabelModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: idx,
	        defaultText: defaultText,
	        isRectText: true
	      });
	      rect.setStyle(style);
	      graphic.setHoverStyle(rect, data.hasItemOption ? hoverStl : zrUtil.extend({}, hoverStl));
	      rect.incremental = incremental; // PENDING
	
	      if (incremental) {
	        // Rect must use hover layer if it's incremental.
	        rect.useHoverLayer = true;
	      }
	
	      group.add(rect);
	      data.setItemGraphicEl(idx, rect);
	    }
	  },
	  _renderOnGeo: function (geo, seriesModel, visualMapModel, api) {
	    var inRangeVisuals = visualMapModel.targetVisuals.inRange;
	    var outOfRangeVisuals = visualMapModel.targetVisuals.outOfRange; // if (!visualMapping) {
	    //     throw new Error('Data range must have color visuals');
	    // }
	
	    var data = seriesModel.getData();
	    var hmLayer = this._hmLayer || this._hmLayer || new HeatmapLayer();
	    hmLayer.blurSize = seriesModel.get('blurSize');
	    hmLayer.pointSize = seriesModel.get('pointSize');
	    hmLayer.minOpacity = seriesModel.get('minOpacity');
	    hmLayer.maxOpacity = seriesModel.get('maxOpacity');
	    var rect = geo.getViewRect().clone();
	    var roamTransform = geo.getRoamTransform();
	    rect.applyTransform(roamTransform); // Clamp on viewport
	
	    var x = Math.max(rect.x, 0);
	    var y = Math.max(rect.y, 0);
	    var x2 = Math.min(rect.width + rect.x, api.getWidth());
	    var y2 = Math.min(rect.height + rect.y, api.getHeight());
	    var width = x2 - x;
	    var height = y2 - y;
	    var dims = [data.mapDimension('lng'), data.mapDimension('lat'), data.mapDimension('value')];
	    var points = data.mapArray(dims, function (lng, lat, value) {
	      var pt = geo.dataToPoint([lng, lat]);
	      pt[0] -= x;
	      pt[1] -= y;
	      pt.push(value);
	      return pt;
	    });
	    var dataExtent = visualMapModel.getExtent();
	    var isInRange = visualMapModel.type === 'visualMap.continuous' ? getIsInContinuousRange(dataExtent, visualMapModel.option.range) : getIsInPiecewiseRange(dataExtent, visualMapModel.getPieceList(), visualMapModel.option.selected);
	    hmLayer.update(points, width, height, inRangeVisuals.color.getNormalizer(), {
	      inRange: inRangeVisuals.color.getColorMapper(),
	      outOfRange: outOfRangeVisuals.color.getColorMapper()
	    }, isInRange);
	    var img = new graphic.Image({
	      style: {
	        width: width,
	        height: height,
	        x: x,
	        y: y,
	        image: hmLayer.canvas
	      },
	      silent: true
	    });
	    this.group.add(img);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ },
/* 2244 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Polyline = __webpack_require__(826);
	
	var zrUtil = __webpack_require__(4);
	
	var EffectLine = __webpack_require__(825);
	
	var vec2 = __webpack_require__(55);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Provide effect for line
	 * @module echarts/chart/helper/EffectLine
	 */
	
	/**
	 * @constructor
	 * @extends {module:echarts/chart/helper/EffectLine}
	 * @alias {module:echarts/chart/helper/Polyline}
	 */
	function EffectPolyline(lineData, idx, seriesScope) {
	  EffectLine.call(this, lineData, idx, seriesScope);
	  this._lastFrame = 0;
	  this._lastFramePercent = 0;
	}
	
	var effectPolylineProto = EffectPolyline.prototype; // Overwrite
	
	effectPolylineProto.createLine = function (lineData, idx, seriesScope) {
	  return new Polyline(lineData, idx, seriesScope);
	}; // Overwrite
	
	
	effectPolylineProto.updateAnimationPoints = function (symbol, points) {
	  this._points = points;
	  var accLenArr = [0];
	  var len = 0;
	
	  for (var i = 1; i < points.length; i++) {
	    var p1 = points[i - 1];
	    var p2 = points[i];
	    len += vec2.dist(p1, p2);
	    accLenArr.push(len);
	  }
	
	  if (len === 0) {
	    return;
	  }
	
	  for (var i = 0; i < accLenArr.length; i++) {
	    accLenArr[i] /= len;
	  }
	
	  this._offsets = accLenArr;
	  this._length = len;
	}; // Overwrite
	
	
	effectPolylineProto.getLineLength = function (symbol) {
	  return this._length;
	}; // Overwrite
	
	
	effectPolylineProto.updateSymbolPosition = function (symbol) {
	  var t = symbol.__t;
	  var points = this._points;
	  var offsets = this._offsets;
	  var len = points.length;
	
	  if (!offsets) {
	    // Has length 0
	    return;
	  }
	
	  var lastFrame = this._lastFrame;
	  var frame;
	
	  if (t < this._lastFramePercent) {
	    // Start from the next frame
	    // PENDING start from lastFrame ?
	    var start = Math.min(lastFrame + 1, len - 1);
	
	    for (frame = start; frame >= 0; frame--) {
	      if (offsets[frame] <= t) {
	        break;
	      }
	    } // PENDING really need to do this ?
	
	
	    frame = Math.min(frame, len - 2);
	  } else {
	    for (var frame = lastFrame; frame < len; frame++) {
	      if (offsets[frame] > t) {
	        break;
	      }
	    }
	
	    frame = Math.min(frame - 1, len - 2);
	  }
	
	  vec2.lerp(symbol.position, points[frame], points[frame + 1], (t - offsets[frame]) / (offsets[frame + 1] - offsets[frame]));
	  var tx = points[frame + 1][0] - points[frame][0];
	  var ty = points[frame + 1][1] - points[frame][1];
	  symbol.rotation = -Math.atan2(ty, tx) - Math.PI / 2;
	  this._lastFrame = frame;
	  this._lastFramePercent = t;
	  symbol.ignore = false;
	};
	
	zrUtil.inherits(EffectPolyline, EffectLine);
	var _default = EffectPolyline;
	module.exports = _default;

/***/ },
/* 2245 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var _symbol = __webpack_require__(110);
	
	var createSymbol = _symbol.createSymbol;
	
	var _graphic = __webpack_require__(14);
	
	var Group = _graphic.Group;
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	var SymbolClz = __webpack_require__(352);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Symbol with ripple effect
	 * @module echarts/chart/helper/EffectSymbol
	 */
	var EFFECT_RIPPLE_NUMBER = 3;
	
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	function updateRipplePath(rippleGroup, effectCfg) {
	  var color = effectCfg.rippleEffectColor || effectCfg.color;
	  rippleGroup.eachChild(function (ripplePath) {
	    ripplePath.attr({
	      z: effectCfg.z,
	      zlevel: effectCfg.zlevel,
	      style: {
	        stroke: effectCfg.brushType === 'stroke' ? color : null,
	        fill: effectCfg.brushType === 'fill' ? color : null
	      }
	    });
	  });
	}
	/**
	 * @constructor
	 * @param {module:echarts/data/List} data
	 * @param {number} idx
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function EffectSymbol(data, idx) {
	  Group.call(this);
	  var symbol = new SymbolClz(data, idx);
	  var rippleGroup = new Group();
	  this.add(symbol);
	  this.add(rippleGroup);
	
	  rippleGroup.beforeUpdate = function () {
	    this.attr(symbol.getScale());
	  };
	
	  this.updateData(data, idx);
	}
	
	var effectSymbolProto = EffectSymbol.prototype;
	
	effectSymbolProto.stopEffectAnimation = function () {
	  this.childAt(1).removeAll();
	};
	
	effectSymbolProto.startEffectAnimation = function (effectCfg) {
	  var symbolType = effectCfg.symbolType;
	  var color = effectCfg.color;
	  var rippleGroup = this.childAt(1);
	
	  for (var i = 0; i < EFFECT_RIPPLE_NUMBER; i++) {
	    // If width/height are set too small (e.g., set to 1) on ios10
	    // and macOS Sierra, a circle stroke become a rect, no matter what
	    // the scale is set. So we set width/height as 2. See #4136.
	    var ripplePath = createSymbol(symbolType, -1, -1, 2, 2, color);
	    ripplePath.attr({
	      style: {
	        strokeNoScale: true
	      },
	      z2: 99,
	      silent: true,
	      scale: [0.5, 0.5]
	    });
	    var delay = -i / EFFECT_RIPPLE_NUMBER * effectCfg.period + effectCfg.effectOffset; // TODO Configurable effectCfg.period
	
	    ripplePath.animate('', true).when(effectCfg.period, {
	      scale: [effectCfg.rippleScale / 2, effectCfg.rippleScale / 2]
	    }).delay(delay).start();
	    ripplePath.animateStyle(true).when(effectCfg.period, {
	      opacity: 0
	    }).delay(delay).start();
	    rippleGroup.add(ripplePath);
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Update effect symbol
	 */
	
	
	effectSymbolProto.updateEffectAnimation = function (effectCfg) {
	  var oldEffectCfg = this._effectCfg;
	  var rippleGroup = this.childAt(1); // Must reinitialize effect if following configuration changed
	
	  var DIFFICULT_PROPS = ['symbolType', 'period', 'rippleScale'];
	
	  for (var i = 0; i < DIFFICULT_PROPS.length; i++) {
	    var propName = DIFFICULT_PROPS[i];
	
	    if (oldEffectCfg[propName] !== effectCfg[propName]) {
	      this.stopEffectAnimation();
	      this.startEffectAnimation(effectCfg);
	      return;
	    }
	  }
	
	  updateRipplePath(rippleGroup, effectCfg);
	};
	/**
	 * Highlight symbol
	 */
	
	
	effectSymbolProto.highlight = function () {
	  this.trigger('emphasis');
	};
	/**
	 * Downplay symbol
	 */
	
	
	effectSymbolProto.downplay = function () {
	  this.trigger('normal');
	};
	/**
	 * Update symbol properties
	 * @param  {module:echarts/data/List} data
	 * @param  {number} idx
	 */
	
	
	effectSymbolProto.updateData = function (data, idx) {
	  var seriesModel = data.hostModel;
	  this.childAt(0).updateData(data, idx);
	  var rippleGroup = this.childAt(1);
	  var itemModel = data.getItemModel(idx);
	  var symbolType = data.getItemVisual(idx, 'symbol');
	  var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	  var color = data.getItemVisual(idx, 'color');
	  rippleGroup.attr('scale', symbolSize);
	  rippleGroup.traverse(function (ripplePath) {
	    ripplePath.attr({
	      fill: color
	    });
	  });
	  var symbolOffset = itemModel.getShallow('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = rippleGroup.position;
	    pos[0] = parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] = parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  var symbolRotate = data.getItemVisual(idx, 'symbolRotate');
	  rippleGroup.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  var effectCfg = {};
	  effectCfg.showEffectOn = seriesModel.get('showEffectOn');
	  effectCfg.rippleScale = itemModel.get('rippleEffect.scale');
	  effectCfg.brushType = itemModel.get('rippleEffect.brushType');
	  effectCfg.period = itemModel.get('rippleEffect.period') * 1000;
	  effectCfg.effectOffset = idx / data.count();
	  effectCfg.z = itemModel.getShallow('z') || 0;
	  effectCfg.zlevel = itemModel.getShallow('zlevel') || 0;
	  effectCfg.symbolType = symbolType;
	  effectCfg.color = color;
	  effectCfg.rippleEffectColor = itemModel.get('rippleEffect.color');
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	
	  if (effectCfg.showEffectOn === 'render') {
	    this._effectCfg ? this.updateEffectAnimation(effectCfg) : this.startEffectAnimation(effectCfg);
	    this._effectCfg = effectCfg;
	  } else {
	    // Not keep old effect config
	    this._effectCfg = null;
	    this.stopEffectAnimation();
	    var symbol = this.childAt(0);
	
	    var onEmphasis = function () {
	      symbol.highlight();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.startEffectAnimation(effectCfg);
	      }
	    };
	
	    var onNormal = function () {
	      symbol.downplay();
	
	      if (effectCfg.showEffectOn !== 'render') {
	        this.stopEffectAnimation();
	      }
	    };
	
	    this.on('mouseover', onEmphasis, this).on('mouseout', onNormal, this).on('emphasis', onEmphasis, this).on('normal', onNormal, this);
	  }
	
	  this._effectCfg = effectCfg;
	};
	
	effectSymbolProto.fadeOut = function (cb) {
	  this.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  cb && cb();
	};
	
	zrUtil.inherits(EffectSymbol, Group);
	var _default = EffectSymbol;
	module.exports = _default;

/***/ },
/* 2246 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var IncrementalDisplayable = __webpack_require__(601);
	
	var lineContain = __webpack_require__(1190);
	
	var quadraticContain = __webpack_require__(1192);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Batch by color
	var LargeLineShape = graphic.extendShape({
	  shape: {
	    polyline: false,
	    curveness: 0,
	    segs: []
	  },
	  buildPath: function (path, shape) {
	    var segs = shape.segs;
	    var curveness = shape.curveness;
	
	    if (shape.polyline) {
	      for (var i = 0; i < segs.length;) {
	        var count = segs[i++];
	
	        if (count > 0) {
	          path.moveTo(segs[i++], segs[i++]);
	
	          for (var k = 1; k < count; k++) {
	            path.lineTo(segs[i++], segs[i++]);
	          }
	        }
	      }
	    } else {
	      for (var i = 0; i < segs.length;) {
	        var x0 = segs[i++];
	        var y0 = segs[i++];
	        var x1 = segs[i++];
	        var y1 = segs[i++];
	        path.moveTo(x0, y0);
	
	        if (curveness > 0) {
	          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	          path.quadraticCurveTo(x2, y2, x1, y1);
	        } else {
	          path.lineTo(x1, y1);
	        }
	      }
	    }
	  },
	  findDataIndex: function (x, y) {
	    var shape = this.shape;
	    var segs = shape.segs;
	    var curveness = shape.curveness;
	
	    if (shape.polyline) {
	      var dataIndex = 0;
	
	      for (var i = 0; i < segs.length;) {
	        var count = segs[i++];
	
	        if (count > 0) {
	          var x0 = segs[i++];
	          var y0 = segs[i++];
	
	          for (var k = 1; k < count; k++) {
	            var x1 = segs[i++];
	            var y1 = segs[i++];
	
	            if (lineContain.containStroke(x0, y0, x1, y1)) {
	              return dataIndex;
	            }
	          }
	        }
	
	        dataIndex++;
	      }
	    } else {
	      var dataIndex = 0;
	
	      for (var i = 0; i < segs.length;) {
	        var x0 = segs[i++];
	        var y0 = segs[i++];
	        var x1 = segs[i++];
	        var y1 = segs[i++];
	
	        if (curveness > 0) {
	          var x2 = (x0 + x1) / 2 - (y0 - y1) * curveness;
	          var y2 = (y0 + y1) / 2 - (x1 - x0) * curveness;
	
	          if (quadraticContain.containStroke(x0, y0, x2, y2, x1, y1)) {
	            return dataIndex;
	          }
	        } else {
	          if (lineContain.containStroke(x0, y0, x1, y1)) {
	            return dataIndex;
	          }
	        }
	
	        dataIndex++;
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeLineDraw() {
	  this.group = new graphic.Group();
	}
	
	var largeLineProto = LargeLineDraw.prototype;
	
	largeLineProto.isPersistent = function () {
	  return !this._incremental;
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 */
	
	
	largeLineProto.updateData = function (data) {
	  this.group.removeAll();
	  var lineEl = new LargeLineShape({
	    rectHover: true,
	    cursor: 'default'
	  });
	  lineEl.setShape({
	    segs: data.getLayout('linesPoints')
	  });
	
	  this._setCommon(lineEl, data); // Add back
	
	
	  this.group.add(lineEl);
	  this._incremental = null;
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.incrementalPrepareUpdate = function (data) {
	  this.group.removeAll();
	
	  this._clearIncremental();
	
	  if (data.count() > 5e5) {
	    if (!this._incremental) {
	      this._incremental = new IncrementalDisplayable({
	        silent: true
	      });
	    }
	
	    this.group.add(this._incremental);
	  } else {
	    this._incremental = null;
	  }
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.incrementalUpdate = function (taskParams, data) {
	  var lineEl = new LargeLineShape();
	  lineEl.setShape({
	    segs: data.getLayout('linesPoints')
	  });
	
	  this._setCommon(lineEl, data, !!this._incremental);
	
	  if (!this._incremental) {
	    lineEl.rectHover = true;
	    lineEl.cursor = 'default';
	    lineEl.__startIndex = taskParams.start;
	    this.group.add(lineEl);
	  } else {
	    this._incremental.addDisplayable(lineEl, true);
	  }
	};
	/**
	 * @override
	 */
	
	
	largeLineProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	largeLineProto._setCommon = function (lineEl, data, isIncremental) {
	  var hostModel = data.hostModel;
	  lineEl.setShape({
	    polyline: hostModel.get('polyline'),
	    curveness: hostModel.get('lineStyle.curveness')
	  });
	  lineEl.useStyle(hostModel.getModel('lineStyle').getLineStyle());
	  lineEl.style.strokeNoScale = true;
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    lineEl.setStyle('stroke', visualColor);
	  }
	
	  lineEl.setStyle('fill');
	
	  if (!isIncremental) {
	    // Enable tooltip
	    // PENDING May have performance issue when path is extremely large
	    lineEl.seriesIndex = hostModel.seriesIndex;
	    lineEl.on('mousemove', function (e) {
	      lineEl.dataIndex = null;
	      var dataIndex = lineEl.findDataIndex(e.offsetX, e.offsetY);
	
	      if (dataIndex > 0) {
	        // Provide dataIndex for tooltip
	        lineEl.dataIndex = dataIndex + lineEl.__startIndex;
	      }
	    });
	  }
	};
	
	largeLineProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	var _default = LargeLineDraw;
	module.exports = _default;

/***/ },
/* 2247 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var _symbol = __webpack_require__(110);
	
	var createSymbol = _symbol.createSymbol;
	
	var IncrementalDisplayable = __webpack_require__(601);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Float32Array */
	// TODO Batch by color
	var BOOST_SIZE_THRESHOLD = 4;
	var LargeSymbolPath = graphic.extendShape({
	  shape: {
	    points: null
	  },
	  symbolProxy: null,
	  softClipShape: null,
	  buildPath: function (path, shape) {
	    var points = shape.points;
	    var size = shape.size;
	    var symbolProxy = this.symbolProxy;
	    var symbolProxyShape = symbolProxy.shape;
	    var ctx = path.getContext ? path.getContext() : path;
	    var canBoost = ctx && size[0] < BOOST_SIZE_THRESHOLD; // Do draw in afterBrush.
	
	    if (canBoost) {
	      return;
	    }
	
	    for (var i = 0; i < points.length;) {
	      var x = points[i++];
	      var y = points[i++];
	
	      if (isNaN(x) || isNaN(y)) {
	        continue;
	      }
	
	      if (this.softClipShape && !this.softClipShape.contain(x, y)) {
	        continue;
	      }
	
	      symbolProxyShape.x = x - size[0] / 2;
	      symbolProxyShape.y = y - size[1] / 2;
	      symbolProxyShape.width = size[0];
	      symbolProxyShape.height = size[1];
	      symbolProxy.buildPath(path, symbolProxyShape, true);
	    }
	  },
	  afterBrush: function (ctx) {
	    var shape = this.shape;
	    var points = shape.points;
	    var size = shape.size;
	    var canBoost = size[0] < BOOST_SIZE_THRESHOLD;
	
	    if (!canBoost) {
	      return;
	    }
	
	    this.setTransform(ctx); // PENDING If style or other canvas status changed?
	
	    for (var i = 0; i < points.length;) {
	      var x = points[i++];
	      var y = points[i++];
	
	      if (isNaN(x) || isNaN(y)) {
	        continue;
	      }
	
	      if (this.softClipShape && !this.softClipShape.contain(x, y)) {
	        continue;
	      } // fillRect is faster than building a rect path and draw.
	      // And it support light globalCompositeOperation.
	
	
	      ctx.fillRect(x - size[0] / 2, y - size[1] / 2, size[0], size[1]);
	    }
	
	    this.restoreTransform(ctx);
	  },
	  findDataIndex: function (x, y) {
	    // TODO ???
	    // Consider transform
	    var shape = this.shape;
	    var points = shape.points;
	    var size = shape.size;
	    var w = Math.max(size[0], 4);
	    var h = Math.max(size[1], 4); // Not consider transform
	    // Treat each element as a rect
	    // top down traverse
	
	    for (var idx = points.length / 2 - 1; idx >= 0; idx--) {
	      var i = idx * 2;
	      var x0 = points[i] - w / 2;
	      var y0 = points[i + 1] - h / 2;
	
	      if (x >= x0 && y >= y0 && x <= x0 + w && y <= y0 + h) {
	        return idx;
	      }
	    }
	
	    return -1;
	  }
	});
	
	function LargeSymbolDraw() {
	  this.group = new graphic.Group();
	}
	
	var largeSymbolProto = LargeSymbolDraw.prototype;
	
	largeSymbolProto.isPersistent = function () {
	  return !this._incremental;
	};
	/**
	 * Update symbols draw by new data
	 * @param {module:echarts/data/List} data
	 * @param {Object} opt
	 * @param {Object} [opt.clipShape]
	 */
	
	
	largeSymbolProto.updateData = function (data, opt) {
	  this.group.removeAll();
	  var symbolEl = new LargeSymbolPath({
	    rectHover: true,
	    cursor: 'default'
	  });
	  symbolEl.setShape({
	    points: data.getLayout('symbolPoints')
	  });
	
	  this._setCommon(symbolEl, data, false, opt);
	
	  this.group.add(symbolEl);
	  this._incremental = null;
	};
	
	largeSymbolProto.updateLayout = function (data) {
	  if (this._incremental) {
	    return;
	  }
	
	  var points = data.getLayout('symbolPoints');
	  this.group.eachChild(function (child) {
	    if (child.startIndex != null) {
	      var len = (child.endIndex - child.startIndex) * 2;
	      var byteOffset = child.startIndex * 4 * 2;
	      points = new Float32Array(points.buffer, byteOffset, len);
	    }
	
	    child.setShape('points', points);
	  });
	};
	
	largeSymbolProto.incrementalPrepareUpdate = function (data) {
	  this.group.removeAll();
	
	  this._clearIncremental(); // Only use incremental displayables when data amount is larger than 2 million.
	  // PENDING Incremental data?
	
	
	  if (data.count() > 2e6) {
	    if (!this._incremental) {
	      this._incremental = new IncrementalDisplayable({
	        silent: true
	      });
	    }
	
	    this.group.add(this._incremental);
	  } else {
	    this._incremental = null;
	  }
	};
	
	largeSymbolProto.incrementalUpdate = function (taskParams, data, opt) {
	  var symbolEl;
	
	  if (this._incremental) {
	    symbolEl = new LargeSymbolPath();
	
	    this._incremental.addDisplayable(symbolEl, true);
	  } else {
	    symbolEl = new LargeSymbolPath({
	      rectHover: true,
	      cursor: 'default',
	      startIndex: taskParams.start,
	      endIndex: taskParams.end
	    });
	    symbolEl.incremental = true;
	    this.group.add(symbolEl);
	  }
	
	  symbolEl.setShape({
	    points: data.getLayout('symbolPoints')
	  });
	
	  this._setCommon(symbolEl, data, !!this._incremental, opt);
	};
	
	largeSymbolProto._setCommon = function (symbolEl, data, isIncremental, opt) {
	  var hostModel = data.hostModel;
	  opt = opt || {}; // TODO
	  // if (data.hasItemVisual.symbolSize) {
	  //     // TODO typed array?
	  //     symbolEl.setShape('sizes', data.mapArray(
	  //         function (idx) {
	  //             var size = data.getItemVisual(idx, 'symbolSize');
	  //             return (size instanceof Array) ? size : [size, size];
	  //         }
	  //     ));
	  // }
	  // else {
	
	  var size = data.getVisual('symbolSize');
	  symbolEl.setShape('size', size instanceof Array ? size : [size, size]); // }
	
	  symbolEl.softClipShape = opt.clipShape || null; // Create symbolProxy to build path for each data
	
	  symbolEl.symbolProxy = createSymbol(data.getVisual('symbol'), 0, 0, 0, 0); // Use symbolProxy setColor method
	
	  symbolEl.setColor = symbolEl.symbolProxy.setColor;
	  var extrudeShadow = symbolEl.shape.size[0] < BOOST_SIZE_THRESHOLD;
	  symbolEl.useStyle( // Draw shadow when doing fillRect is extremely slow.
	  hostModel.getModel('itemStyle').getItemStyle(extrudeShadow ? ['color', 'shadowBlur', 'shadowColor'] : ['color']));
	  var visualColor = data.getVisual('color');
	
	  if (visualColor) {
	    symbolEl.setColor(visualColor);
	  }
	
	  if (!isIncremental) {
	    // Enable tooltip
	    // PENDING May have performance issue when path is extremely large
	    symbolEl.seriesIndex = hostModel.seriesIndex;
	    symbolEl.on('mousemove', function (e) {
	      symbolEl.dataIndex = null;
	      var dataIndex = symbolEl.findDataIndex(e.offsetX, e.offsetY);
	
	      if (dataIndex >= 0) {
	        // Provide dataIndex for tooltip
	        symbolEl.dataIndex = dataIndex + (symbolEl.startIndex || 0);
	      }
	    });
	  }
	};
	
	largeSymbolProto.remove = function () {
	  this._clearIncremental();
	
	  this._incremental = null;
	  this.group.removeAll();
	};
	
	largeSymbolProto._clearIncremental = function () {
	  var incremental = this._incremental;
	
	  if (incremental) {
	    incremental.clearDisplaybles();
	  }
	};
	
	var _default = LargeSymbolDraw;
	module.exports = _default;

/***/ },
/* 2248 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var vec2 = __webpack_require__(55);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Line path for bezier and straight line draw
	 */
	var straightLineProto = graphic.Line.prototype;
	var bezierCurveProto = graphic.BezierCurve.prototype;
	
	function isLine(shape) {
	  return isNaN(+shape.cpx1) || isNaN(+shape.cpy1);
	}
	
	var _default = graphic.extendShape({
	  type: 'ec-line',
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    percent: 1,
	    cpx1: null,
	    cpy1: null
	  },
	  buildPath: function (ctx, shape) {
	    this[isLine(shape) ? '_buildPathLine' : '_buildPathCurve'](ctx, shape);
	  },
	  _buildPathLine: straightLineProto.buildPath,
	  _buildPathCurve: bezierCurveProto.buildPath,
	  pointAt: function (t) {
	    return this[isLine(this.shape) ? '_pointAtLine' : '_pointAtCurve'](t);
	  },
	  _pointAtLine: straightLineProto.pointAt,
	  _pointAtCurve: bezierCurveProto.pointAt,
	  tangentAt: function (t) {
	    var shape = this.shape;
	    var p = isLine(shape) ? [shape.x2 - shape.x1, shape.y2 - shape.y1] : this._tangentAtCurve(t);
	    return vec2.normalize(p, p);
	  },
	  _tangentAtCurve: bezierCurveProto.tangentAt
	});
	
	module.exports = _default;

/***/ },
/* 2249 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2250);
	
	__webpack_require__(2251);
	
	var visualSymbol = __webpack_require__(214);
	
	var layoutPoints = __webpack_require__(295);
	
	var dataSample = __webpack_require__(2447);
	
	__webpack_require__(290);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerVisual(visualSymbol('line', 'circle', 'line'));
	echarts.registerLayout(layoutPoints('line')); // Down sample after filter
	
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, dataSample('line'));

/***/ },
/* 2250 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var createListFromArray = __webpack_require__(159);
	
	var SeriesModel = __webpack_require__(77);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.line',
	  dependencies: ['grid', 'polar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'cartesian2d',
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // stack: null
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // polarIndex: 0,
	    // If clip the overflow value
	    clip: true,
	    // cursor: null,
	    label: {
	      position: 'top'
	    },
	    // itemStyle: {
	    // },
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    },
	    // areaStyle: {
	    // origin of areaStyle. Valid values:
	    // `'auto'/null/undefined`: from axisLine to data
	    // `'start'`: from min to data
	    // `'end'`: from data to max
	    // origin: 'auto'
	    // },
	    // false, 'start', 'end', 'middle'
	    step: false,
	    // Disabled if step is true
	    smooth: false,
	    smoothMonotone: null,
	    symbol: 'emptyCircle',
	    symbolSize: 4,
	    symbolRotate: null,
	    showSymbol: true,
	    // `false`: follow the label interval strategy.
	    // `true`: show all symbols.
	    // `'auto'`: If possible, show all symbols, otherwise
	    //           follow the label interval strategy.
	    showAllSymbol: 'auto',
	    // Whether to connect break point.
	    connectNulls: false,
	    // Sampling for large data. Can be: 'average', 'max', 'min', 'sum'.
	    sampling: 'none',
	    animationEasing: 'linear',
	    // Disable progressive
	    progressive: 0,
	    hoverLayerThreshold: Infinity
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2251 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(4);
	
	var _bbox = __webpack_require__(314);
	
	var fromPoints = _bbox.fromPoints;
	
	var SymbolDraw = __webpack_require__(287);
	
	var SymbolClz = __webpack_require__(352);
	
	var lineAnimationDiff = __webpack_require__(2252);
	
	var graphic = __webpack_require__(14);
	
	var modelUtil = __webpack_require__(29);
	
	var _poly = __webpack_require__(831);
	
	var Polyline = _poly.Polyline;
	var Polygon = _poly.Polygon;
	
	var ChartView = __webpack_require__(141);
	
	var _helper = __webpack_require__(830);
	
	var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
	var getStackedOnPoint = _helper.getStackedOnPoint;
	
	var _createClipPathFromCoordSys = __webpack_require__(288);
	
	var createGridClipPath = _createClipPathFromCoordSys.createGridClipPath;
	var createPolarClipPath = _createClipPathFromCoordSys.createPolarClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME step not support polar
	function isPointsSame(points1, points2) {
	  if (points1.length !== points2.length) {
	    return;
	  }
	
	  for (var i = 0; i < points1.length; i++) {
	    var p1 = points1[i];
	    var p2 = points2[i];
	
	    if (p1[0] !== p2[0] || p1[1] !== p2[1]) {
	      return;
	    }
	  }
	
	  return true;
	}
	
	function getBoundingDiff(points1, points2) {
	  var min1 = [];
	  var max1 = [];
	  var min2 = [];
	  var max2 = [];
	  fromPoints(points1, min1, max1);
	  fromPoints(points2, min2, max2); // Get a max value from each corner of two boundings.
	
	  return Math.max(Math.abs(min1[0] - min2[0]), Math.abs(min1[1] - min2[1]), Math.abs(max1[0] - max2[0]), Math.abs(max1[1] - max2[1]));
	}
	
	function getSmooth(smooth) {
	  return typeof smooth === 'number' ? smooth : smooth ? 0.5 : 0;
	}
	/**
	 * @param {module:echarts/coord/cartesian/Cartesian2D|module:echarts/coord/polar/Polar} coordSys
	 * @param {module:echarts/data/List} data
	 * @param {Object} dataCoordInfo
	 * @param {Array.<Array.<number>>} points
	 */
	
	
	function getStackedOnPoints(coordSys, data, dataCoordInfo) {
	  if (!dataCoordInfo.valueDim) {
	    return [];
	  }
	
	  var points = [];
	
	  for (var idx = 0, len = data.count(); idx < len; idx++) {
	    points.push(getStackedOnPoint(dataCoordInfo, coordSys, data, idx));
	  }
	
	  return points;
	}
	
	function turnPointsIntoStep(points, coordSys, stepTurnAt) {
	  var baseAxis = coordSys.getBaseAxis();
	  var baseIndex = baseAxis.dim === 'x' || baseAxis.dim === 'radius' ? 0 : 1;
	  var stepPoints = [];
	
	  for (var i = 0; i < points.length - 1; i++) {
	    var nextPt = points[i + 1];
	    var pt = points[i];
	    stepPoints.push(pt);
	    var stepPt = [];
	
	    switch (stepTurnAt) {
	      case 'end':
	        stepPt[baseIndex] = nextPt[baseIndex];
	        stepPt[1 - baseIndex] = pt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	        break;
	
	      case 'middle':
	        // default is start
	        var middle = (pt[baseIndex] + nextPt[baseIndex]) / 2;
	        var stepPt2 = [];
	        stepPt[baseIndex] = stepPt2[baseIndex] = middle;
	        stepPt[1 - baseIndex] = pt[1 - baseIndex];
	        stepPt2[1 - baseIndex] = nextPt[1 - baseIndex];
	        stepPoints.push(stepPt);
	        stepPoints.push(stepPt2);
	        break;
	
	      default:
	        stepPt[baseIndex] = pt[baseIndex];
	        stepPt[1 - baseIndex] = nextPt[1 - baseIndex]; // default is start
	
	        stepPoints.push(stepPt);
	    }
	  } // Last points
	
	
	  points[i] && stepPoints.push(points[i]);
	  return stepPoints;
	}
	
	function getVisualGradient(data, coordSys) {
	  var visualMetaList = data.getVisual('visualMeta');
	
	  if (!visualMetaList || !visualMetaList.length || !data.count()) {
	    // When data.count() is 0, gradient range can not be calculated.
	    return;
	  }
	
	  if (coordSys.type !== 'cartesian2d') {
	    return;
	  }
	
	  var coordDim;
	  var visualMeta;
	
	  for (var i = visualMetaList.length - 1; i >= 0; i--) {
	    var dimIndex = visualMetaList[i].dimension;
	    var dimName = data.dimensions[dimIndex];
	    var dimInfo = data.getDimensionInfo(dimName);
	    coordDim = dimInfo && dimInfo.coordDim; // Can only be x or y
	
	    if (coordDim === 'x' || coordDim === 'y') {
	      visualMeta = visualMetaList[i];
	      break;
	    }
	  }
	
	  if (!visualMeta) {
	    return;
	  } // If the area to be rendered is bigger than area defined by LinearGradient,
	  // the canvas spec prescribes that the color of the first stop and the last
	  // stop should be used. But if two stops are added at offset 0, in effect
	  // browsers use the color of the second stop to render area outside
	  // LinearGradient. So we can only infinitesimally extend area defined in
	  // LinearGradient to render `outerColors`.
	
	
	  var axis = coordSys.getAxis(coordDim); // dataToCoor mapping may not be linear, but must be monotonic.
	
	  var colorStops = zrUtil.map(visualMeta.stops, function (stop) {
	    return {
	      coord: axis.toGlobalCoord(axis.dataToCoord(stop.value)),
	      color: stop.color
	    };
	  });
	  var stopLen = colorStops.length;
	  var outerColors = visualMeta.outerColors.slice();
	
	  if (stopLen && colorStops[0].coord > colorStops[stopLen - 1].coord) {
	    colorStops.reverse();
	    outerColors.reverse();
	  }
	
	  var tinyExtent = 10; // Arbitrary value: 10px
	
	  var minCoord = colorStops[0].coord - tinyExtent;
	  var maxCoord = colorStops[stopLen - 1].coord + tinyExtent;
	  var coordSpan = maxCoord - minCoord;
	
	  if (coordSpan < 1e-3) {
	    return 'transparent';
	  }
	
	  zrUtil.each(colorStops, function (stop) {
	    stop.offset = (stop.coord - minCoord) / coordSpan;
	  });
	  colorStops.push({
	    offset: stopLen ? colorStops[stopLen - 1].offset : 0.5,
	    color: outerColors[1] || 'transparent'
	  });
	  colorStops.unshift({
	    // notice colorStops.length have been changed.
	    offset: stopLen ? colorStops[0].offset : 0.5,
	    color: outerColors[0] || 'transparent'
	  }); // zrUtil.each(colorStops, function (colorStop) {
	  //     // Make sure each offset has rounded px to avoid not sharp edge
	  //     colorStop.offset = (Math.round(colorStop.offset * (end - start) + start) - start) / (end - start);
	  // });
	
	  var gradient = new graphic.LinearGradient(0, 0, 0, 0, colorStops, true);
	  gradient[coordDim] = minCoord;
	  gradient[coordDim + '2'] = maxCoord;
	  return gradient;
	}
	
	function getIsIgnoreFunc(seriesModel, data, coordSys) {
	  var showAllSymbol = seriesModel.get('showAllSymbol');
	  var isAuto = showAllSymbol === 'auto';
	
	  if (showAllSymbol && !isAuto) {
	    return;
	  }
	
	  var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	  if (!categoryAxis) {
	    return;
	  } // Note that category label interval strategy might bring some weird effect
	  // in some scenario: users may wonder why some of the symbols are not
	  // displayed. So we show all symbols as possible as we can.
	
	
	  if (isAuto // Simplify the logic, do not determine label overlap here.
	  && canShowAllSymbolForCategory(categoryAxis, data)) {
	    return;
	  } // Otherwise follow the label interval strategy on category axis.
	
	
	  var categoryDataDim = data.mapDimension(categoryAxis.dim);
	  var labelMap = {};
	  zrUtil.each(categoryAxis.getViewLabels(), function (labelItem) {
	    labelMap[labelItem.tickValue] = 1;
	  });
	  return function (dataIndex) {
	    return !labelMap.hasOwnProperty(data.get(categoryDataDim, dataIndex));
	  };
	}
	
	function canShowAllSymbolForCategory(categoryAxis, data) {
	  // In mose cases, line is monotonous on category axis, and the label size
	  // is close with each other. So we check the symbol size and some of the
	  // label size alone with the category axis to estimate whether all symbol
	  // can be shown without overlap.
	  var axisExtent = categoryAxis.getExtent();
	  var availSize = Math.abs(axisExtent[1] - axisExtent[0]) / categoryAxis.scale.count();
	  isNaN(availSize) && (availSize = 0); // 0/0 is NaN.
	  // Sampling some points, max 5.
	
	  var dataLen = data.count();
	  var step = Math.max(1, Math.round(dataLen / 5));
	
	  for (var dataIndex = 0; dataIndex < dataLen; dataIndex += step) {
	    if (SymbolClz.getSymbolSize(data, dataIndex // Only for cartesian, where `isHorizontal` exists.
	    )[categoryAxis.isHorizontal() ? 1 : 0] // Empirical number
	    * 1.5 > availSize) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	function createLineClipPath(coordSys, hasAnimation, seriesModel) {
	  if (coordSys.type === 'cartesian2d') {
	    var isHorizontal = coordSys.getBaseAxis().isHorizontal();
	    var clipPath = createGridClipPath(coordSys, hasAnimation, seriesModel); // Expand clip shape to avoid clipping when line value exceeds axis
	
	    if (!seriesModel.get('clip', true)) {
	      var rectShape = clipPath.shape;
	      var expandSize = Math.max(rectShape.width, rectShape.height);
	
	      if (isHorizontal) {
	        rectShape.y -= expandSize;
	        rectShape.height += expandSize * 2;
	      } else {
	        rectShape.x -= expandSize;
	        rectShape.width += expandSize * 2;
	      }
	    }
	
	    return clipPath;
	  } else {
	    return createPolarClipPath(coordSys, hasAnimation, seriesModel);
	  }
	}
	
	var _default = ChartView.extend({
	  type: 'line',
	  init: function () {
	    var lineGroup = new graphic.Group();
	    var symbolDraw = new SymbolDraw();
	    this.group.add(symbolDraw.group);
	    this._symbolDraw = symbolDraw;
	    this._lineGroup = lineGroup;
	  },
	  render: function (seriesModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var lineStyleModel = seriesModel.getModel('lineStyle');
	    var areaStyleModel = seriesModel.getModel('areaStyle');
	    var points = data.mapArray(data.getItemLayout);
	    var isCoordSysPolar = coordSys.type === 'polar';
	    var prevCoordSys = this._coordSys;
	    var symbolDraw = this._symbolDraw;
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var lineGroup = this._lineGroup;
	    var hasAnimation = seriesModel.get('animation');
	    var isAreaChart = !areaStyleModel.isEmpty();
	    var valueOrigin = areaStyleModel.get('origin');
	    var dataCoordInfo = prepareDataCoordInfo(coordSys, data, valueOrigin);
	    var stackedOnPoints = getStackedOnPoints(coordSys, data, dataCoordInfo);
	    var showSymbol = seriesModel.get('showSymbol');
	    var isIgnoreFunc = showSymbol && !isCoordSysPolar && getIsIgnoreFunc(seriesModel, data, coordSys); // Remove temporary symbols
	
	    var oldData = this._data;
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    }); // Remove previous created symbols if showSymbol changed to false
	
	    if (!showSymbol) {
	      symbolDraw.remove();
	    }
	
	    group.add(lineGroup); // FIXME step not support polar
	
	    var step = !isCoordSysPolar && seriesModel.get('step');
	    var clipShapeForSymbol;
	
	    if (coordSys && coordSys.getArea && seriesModel.get('clip', true)) {
	      clipShapeForSymbol = coordSys.getArea(); // Avoid float number rounding error for symbol on the edge of axis extent.
	      // See #7913 and `test/dataZoom-clip.html`.
	
	      if (clipShapeForSymbol.width != null) {
	        clipShapeForSymbol.x -= 0.1;
	        clipShapeForSymbol.y -= 0.1;
	        clipShapeForSymbol.width += 0.2;
	        clipShapeForSymbol.height += 0.2;
	      } else if (clipShapeForSymbol.r0) {
	        clipShapeForSymbol.r0 -= 0.5;
	        clipShapeForSymbol.r1 += 0.5;
	      }
	    }
	
	    this._clipShapeForSymbol = clipShapeForSymbol; // Initialization animation or coordinate system changed
	
	    if (!(polyline && prevCoordSys.type === coordSys.type && step === this._step)) {
	      showSymbol && symbolDraw.updateData(data, {
	        isIgnore: isIgnoreFunc,
	        clipShape: clipShapeForSymbol
	      });
	
	      if (step) {
	        // TODO If stacked series is not step
	        points = turnPointsIntoStep(points, coordSys, step);
	        stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	      }
	
	      polyline = this._newPolyline(points, coordSys, hasAnimation);
	
	      if (isAreaChart) {
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      }
	
	      lineGroup.setClipPath(createLineClipPath(coordSys, true, seriesModel));
	    } else {
	      if (isAreaChart && !polygon) {
	        // If areaStyle is added
	        polygon = this._newPolygon(points, stackedOnPoints, coordSys, hasAnimation);
	      } else if (polygon && !isAreaChart) {
	        // If areaStyle is removed
	        lineGroup.remove(polygon);
	        polygon = this._polygon = null;
	      } // Update clipPath
	
	
	      lineGroup.setClipPath(createLineClipPath(coordSys, false, seriesModel)); // Always update, or it is wrong in the case turning on legend
	      // because points are not changed
	
	      showSymbol && symbolDraw.updateData(data, {
	        isIgnore: isIgnoreFunc,
	        clipShape: clipShapeForSymbol
	      }); // Stop symbol animation and sync with line points
	      // FIXME performance?
	
	      data.eachItemGraphicEl(function (el) {
	        el.stopAnimation(true);
	      }); // In the case data zoom triggerred refreshing frequently
	      // Data may not change if line has a category axis. So it should animate nothing
	
	      if (!isPointsSame(this._stackedOnPoints, stackedOnPoints) || !isPointsSame(this._points, points)) {
	        if (hasAnimation) {
	          this._updateAnimation(data, stackedOnPoints, coordSys, api, step, valueOrigin);
	        } else {
	          // Not do it in update with animation
	          if (step) {
	            // TODO If stacked series is not step
	            points = turnPointsIntoStep(points, coordSys, step);
	            stackedOnPoints = turnPointsIntoStep(stackedOnPoints, coordSys, step);
	          }
	
	          polyline.setShape({
	            points: points
	          });
	          polygon && polygon.setShape({
	            points: points,
	            stackedOnPoints: stackedOnPoints
	          });
	        }
	      }
	    }
	
	    var visualColor = getVisualGradient(data, coordSys) || data.getVisual('color');
	    polyline.useStyle(zrUtil.defaults( // Use color in lineStyle first
	    lineStyleModel.getLineStyle(), {
	      fill: 'none',
	      stroke: visualColor,
	      lineJoin: 'bevel'
	    }));
	    var smooth = seriesModel.get('smooth');
	    smooth = getSmooth(seriesModel.get('smooth'));
	    polyline.setShape({
	      smooth: smooth,
	      smoothMonotone: seriesModel.get('smoothMonotone'),
	      connectNulls: seriesModel.get('connectNulls')
	    });
	
	    if (polygon) {
	      var stackedOnSeries = data.getCalculationInfo('stackedOnSeries');
	      var stackedOnSmooth = 0;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: visualColor,
	        opacity: 0.7,
	        lineJoin: 'bevel'
	      }));
	
	      if (stackedOnSeries) {
	        stackedOnSmooth = getSmooth(stackedOnSeries.get('smooth'));
	      }
	
	      polygon.setShape({
	        smooth: smooth,
	        stackedOnSmooth: stackedOnSmooth,
	        smoothMonotone: seriesModel.get('smoothMonotone'),
	        connectNulls: seriesModel.get('connectNulls')
	      });
	    }
	
	    this._data = data; // Save the coordinate system for transition animation when data changed
	
	    this._coordSys = coordSys;
	    this._stackedOnPoints = stackedOnPoints;
	    this._points = points;
	    this._step = step;
	    this._valueOrigin = valueOrigin;
	  },
	  dispose: function () {},
	  highlight: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (!(dataIndex instanceof Array) && dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (!symbol) {
	        // Create a temporary symbol if it is not exists
	        var pt = data.getItemLayout(dataIndex);
	
	        if (!pt) {
	          // Null data
	          return;
	        } // fix #11360: should't draw symbol outside clipShapeForSymbol
	
	
	        if (this._clipShapeForSymbol && !this._clipShapeForSymbol.contain(pt[0], pt[1])) {
	          return;
	        }
	
	        symbol = new SymbolClz(data, dataIndex);
	        symbol.position = pt;
	        symbol.setZ(seriesModel.get('zlevel'), seriesModel.get('z'));
	        symbol.ignore = isNaN(pt[0]) || isNaN(pt[1]);
	        symbol.__temp = true;
	        data.setItemGraphicEl(dataIndex, symbol); // Stop scale animation
	
	        symbol.stopSymbolAnimation(true);
	        this.group.add(symbol);
	      }
	
	      symbol.highlight();
	    } else {
	      // Highlight whole series
	      ChartView.prototype.highlight.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	  downplay: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var dataIndex = modelUtil.queryDataIndex(data, payload);
	
	    if (dataIndex != null && dataIndex >= 0) {
	      var symbol = data.getItemGraphicEl(dataIndex);
	
	      if (symbol) {
	        if (symbol.__temp) {
	          data.setItemGraphicEl(dataIndex, null);
	          this.group.remove(symbol);
	        } else {
	          symbol.downplay();
	        }
	      }
	    } else {
	      // FIXME
	      // can not downplay completely.
	      // Downplay whole series
	      ChartView.prototype.downplay.call(this, seriesModel, ecModel, api, payload);
	    }
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolyline: function (points) {
	    var polyline = this._polyline; // Remove previous created polyline
	
	    if (polyline) {
	      this._lineGroup.remove(polyline);
	    }
	
	    polyline = new Polyline({
	      shape: {
	        points: points
	      },
	      silent: true,
	      z2: 10
	    });
	
	    this._lineGroup.add(polyline);
	
	    this._polyline = polyline;
	    return polyline;
	  },
	
	  /**
	   * @param {module:zrender/container/Group} group
	   * @param {Array.<Array.<number>>} stackedOnPoints
	   * @param {Array.<Array.<number>>} points
	   * @private
	   */
	  _newPolygon: function (points, stackedOnPoints) {
	    var polygon = this._polygon; // Remove previous created polygon
	
	    if (polygon) {
	      this._lineGroup.remove(polygon);
	    }
	
	    polygon = new Polygon({
	      shape: {
	        points: points,
	        stackedOnPoints: stackedOnPoints
	      },
	      silent: true
	    });
	
	    this._lineGroup.add(polygon);
	
	    this._polygon = polygon;
	    return polygon;
	  },
	
	  /**
	   * @private
	   */
	  // FIXME Two value axis
	  _updateAnimation: function (data, stackedOnPoints, coordSys, api, step, valueOrigin) {
	    var polyline = this._polyline;
	    var polygon = this._polygon;
	    var seriesModel = data.hostModel;
	    var diff = lineAnimationDiff(this._data, data, this._stackedOnPoints, stackedOnPoints, this._coordSys, coordSys, this._valueOrigin, valueOrigin);
	    var current = diff.current;
	    var stackedOnCurrent = diff.stackedOnCurrent;
	    var next = diff.next;
	    var stackedOnNext = diff.stackedOnNext;
	
	    if (step) {
	      // TODO If stacked series is not step
	      current = turnPointsIntoStep(diff.current, coordSys, step);
	      stackedOnCurrent = turnPointsIntoStep(diff.stackedOnCurrent, coordSys, step);
	      next = turnPointsIntoStep(diff.next, coordSys, step);
	      stackedOnNext = turnPointsIntoStep(diff.stackedOnNext, coordSys, step);
	    } // Don't apply animation if diff is large.
	    // For better result and avoid memory explosion problems like
	    // https://github.com/apache/incubator-echarts/issues/12229
	
	
	    if (getBoundingDiff(current, next) > 3000 || polygon && getBoundingDiff(stackedOnCurrent, stackedOnNext) > 3000) {
	      polyline.setShape({
	        points: next
	      });
	
	      if (polygon) {
	        polygon.setShape({
	          points: next,
	          stackedOnPoints: stackedOnNext
	        });
	      }
	
	      return;
	    } // `diff.current` is subset of `current` (which should be ensured by
	    // turnPointsIntoStep), so points in `__points` can be updated when
	    // points in `current` are update during animation.
	
	
	    polyline.shape.__points = diff.current;
	    polyline.shape.points = current;
	    graphic.updateProps(polyline, {
	      shape: {
	        points: next
	      }
	    }, seriesModel);
	
	    if (polygon) {
	      polygon.setShape({
	        points: current,
	        stackedOnPoints: stackedOnCurrent
	      });
	      graphic.updateProps(polygon, {
	        shape: {
	          points: next,
	          stackedOnPoints: stackedOnNext
	        }
	      }, seriesModel);
	    }
	
	    var updatedDataInfo = [];
	    var diffStatus = diff.status;
	
	    for (var i = 0; i < diffStatus.length; i++) {
	      var cmd = diffStatus[i].cmd;
	
	      if (cmd === '=') {
	        var el = data.getItemGraphicEl(diffStatus[i].idx1);
	
	        if (el) {
	          updatedDataInfo.push({
	            el: el,
	            ptIdx: i // Index of points
	
	          });
	        }
	      }
	    }
	
	    if (polyline.animators && polyline.animators.length) {
	      polyline.animators[0].during(function () {
	        for (var i = 0; i < updatedDataInfo.length; i++) {
	          var el = updatedDataInfo[i].el;
	          el.attr('position', polyline.shape.__points[updatedDataInfo[i].ptIdx]);
	        }
	      });
	    }
	  },
	  remove: function (ecModel) {
	    var group = this.group;
	    var oldData = this._data;
	
	    this._lineGroup.removeAll();
	
	    this._symbolDraw.remove(true); // Remove temporary created elements when highlighting
	
	
	    oldData && oldData.eachItemGraphicEl(function (el, idx) {
	      if (el.__temp) {
	        group.remove(el);
	        oldData.setItemGraphicEl(idx, null);
	      }
	    });
	    this._polyline = this._polygon = this._coordSys = this._points = this._stackedOnPoints = this._data = null;
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2252 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _helper = __webpack_require__(830);
	
	var prepareDataCoordInfo = _helper.prepareDataCoordInfo;
	var getStackedOnPoint = _helper.getStackedOnPoint;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// var arrayDiff = require('zrender/src/core/arrayDiff');
	// 'zrender/src/core/arrayDiff' has been used before, but it did
	// not do well in performance when roam with fixed dataZoom window.
	// function convertToIntId(newIdList, oldIdList) {
	//     // Generate int id instead of string id.
	//     // Compare string maybe slow in score function of arrDiff
	//     // Assume id in idList are all unique
	//     var idIndicesMap = {};
	//     var idx = 0;
	//     for (var i = 0; i < newIdList.length; i++) {
	//         idIndicesMap[newIdList[i]] = idx;
	//         newIdList[i] = idx++;
	//     }
	//     for (var i = 0; i < oldIdList.length; i++) {
	//         var oldId = oldIdList[i];
	//         // Same with newIdList
	//         if (idIndicesMap[oldId]) {
	//             oldIdList[i] = idIndicesMap[oldId];
	//         }
	//         else {
	//             oldIdList[i] = idx++;
	//         }
	//     }
	// }
	function diffData(oldData, newData) {
	  var diffResult = [];
	  newData.diff(oldData).add(function (idx) {
	    diffResult.push({
	      cmd: '+',
	      idx: idx
	    });
	  }).update(function (newIdx, oldIdx) {
	    diffResult.push({
	      cmd: '=',
	      idx: oldIdx,
	      idx1: newIdx
	    });
	  }).remove(function (idx) {
	    diffResult.push({
	      cmd: '-',
	      idx: idx
	    });
	  }).execute();
	  return diffResult;
	}
	
	function _default(oldData, newData, oldStackedOnPoints, newStackedOnPoints, oldCoordSys, newCoordSys, oldValueOrigin, newValueOrigin) {
	  var diff = diffData(oldData, newData); // var newIdList = newData.mapArray(newData.getId);
	  // var oldIdList = oldData.mapArray(oldData.getId);
	  // convertToIntId(newIdList, oldIdList);
	  // // FIXME One data ?
	  // diff = arrayDiff(oldIdList, newIdList);
	
	  var currPoints = [];
	  var nextPoints = []; // Points for stacking base line
	
	  var currStackedPoints = [];
	  var nextStackedPoints = [];
	  var status = [];
	  var sortedIndices = [];
	  var rawIndices = [];
	  var newDataOldCoordInfo = prepareDataCoordInfo(oldCoordSys, newData, oldValueOrigin);
	  var oldDataNewCoordInfo = prepareDataCoordInfo(newCoordSys, oldData, newValueOrigin);
	
	  for (var i = 0; i < diff.length; i++) {
	    var diffItem = diff[i];
	    var pointAdded = true; // FIXME, animation is not so perfect when dataZoom window moves fast
	    // Which is in case remvoing or add more than one data in the tail or head
	
	    switch (diffItem.cmd) {
	      case '=':
	        var currentPt = oldData.getItemLayout(diffItem.idx);
	        var nextPt = newData.getItemLayout(diffItem.idx1); // If previous data is NaN, use next point directly
	
	        if (isNaN(currentPt[0]) || isNaN(currentPt[1])) {
	          currentPt = nextPt.slice();
	        }
	
	        currPoints.push(currentPt);
	        nextPoints.push(nextPt);
	        currStackedPoints.push(oldStackedOnPoints[diffItem.idx]);
	        nextStackedPoints.push(newStackedOnPoints[diffItem.idx1]);
	        rawIndices.push(newData.getRawIndex(diffItem.idx1));
	        break;
	
	      case '+':
	        var idx = diffItem.idx;
	        currPoints.push(oldCoordSys.dataToPoint([newData.get(newDataOldCoordInfo.dataDimsForPoint[0], idx), newData.get(newDataOldCoordInfo.dataDimsForPoint[1], idx)]));
	        nextPoints.push(newData.getItemLayout(idx).slice());
	        currStackedPoints.push(getStackedOnPoint(newDataOldCoordInfo, oldCoordSys, newData, idx));
	        nextStackedPoints.push(newStackedOnPoints[idx]);
	        rawIndices.push(newData.getRawIndex(idx));
	        break;
	
	      case '-':
	        var idx = diffItem.idx;
	        var rawIndex = oldData.getRawIndex(idx); // Data is replaced. In the case of dynamic data queue
	        // FIXME FIXME FIXME
	
	        if (rawIndex !== idx) {
	          currPoints.push(oldData.getItemLayout(idx));
	          nextPoints.push(newCoordSys.dataToPoint([oldData.get(oldDataNewCoordInfo.dataDimsForPoint[0], idx), oldData.get(oldDataNewCoordInfo.dataDimsForPoint[1], idx)]));
	          currStackedPoints.push(oldStackedOnPoints[idx]);
	          nextStackedPoints.push(getStackedOnPoint(oldDataNewCoordInfo, newCoordSys, oldData, idx));
	          rawIndices.push(rawIndex);
	        } else {
	          pointAdded = false;
	        }
	
	    } // Original indices
	
	
	    if (pointAdded) {
	      status.push(diffItem);
	      sortedIndices.push(sortedIndices.length);
	    }
	  } // Diff result may be crossed if all items are changed
	  // Sort by data index
	
	
	  sortedIndices.sort(function (a, b) {
	    return rawIndices[a] - rawIndices[b];
	  });
	  var sortedCurrPoints = [];
	  var sortedNextPoints = [];
	  var sortedCurrStackedPoints = [];
	  var sortedNextStackedPoints = [];
	  var sortedStatus = [];
	
	  for (var i = 0; i < sortedIndices.length; i++) {
	    var idx = sortedIndices[i];
	    sortedCurrPoints[i] = currPoints[idx];
	    sortedNextPoints[i] = nextPoints[idx];
	    sortedCurrStackedPoints[i] = currStackedPoints[idx];
	    sortedNextStackedPoints[i] = nextStackedPoints[idx];
	    sortedStatus[i] = status[idx];
	  }
	
	  return {
	    current: sortedCurrPoints,
	    next: sortedNextPoints,
	    stackedOnCurrent: sortedCurrStackedPoints,
	    stackedOnNext: sortedNextStackedPoints,
	    status: sortedStatus
	  };
	}
	
	module.exports = _default;

/***/ },
/* 2253 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2254);
	
	__webpack_require__(2255);
	
	var linesLayout = __webpack_require__(832);
	
	var linesVisual = __webpack_require__(2256);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(linesLayout);
	echarts.registerVisual(linesVisual);

/***/ },
/* 2254 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var SeriesModel = __webpack_require__(77);
	
	var List = __webpack_require__(109);
	
	var _util = __webpack_require__(4);
	
	var concatArray = _util.concatArray;
	var mergeAll = _util.mergeAll;
	var map = _util.map;
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var CoordinateSystem = __webpack_require__(121);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint32Array, Float64Array, Float32Array */
	var Uint32Arr = typeof Uint32Array === 'undefined' ? Array : Uint32Array;
	var Float64Arr = typeof Float64Array === 'undefined' ? Array : Float64Array;
	
	function compatEc2(seriesOpt) {
	  var data = seriesOpt.data;
	
	  if (data && data[0] && data[0][0] && data[0][0].coord) {
	    seriesOpt.data = map(data, function (itemOpt) {
	      var coords = [itemOpt[0].coord, itemOpt[1].coord];
	      var target = {
	        coords: coords
	      };
	
	      if (itemOpt[0].name) {
	        target.fromName = itemOpt[0].name;
	      }
	
	      if (itemOpt[1].name) {
	        target.toName = itemOpt[1].name;
	      }
	
	      return mergeAll([target, itemOpt[0], itemOpt[1]]);
	    });
	  }
	}
	
	var LinesSeries = SeriesModel.extend({
	  type: 'series.lines',
	  dependencies: ['grid', 'polar'],
	  visualColorAccessPath: 'lineStyle.color',
	  init: function (option) {
	    // The input data may be null/undefined.
	    option.data = option.data || []; // Not using preprocessor because mergeOption may not have series.type
	
	    compatEc2(option);
	
	    var result = this._processFlatCoordsArray(option.data);
	
	    this._flatCoords = result.flatCoords;
	    this._flatCoordsOffset = result.flatCoordsOffset;
	
	    if (result.flatCoords) {
	      option.data = new Float32Array(result.count);
	    }
	
	    LinesSeries.superApply(this, 'init', arguments);
	  },
	  mergeOption: function (option) {
	    compatEc2(option);
	
	    if (option.data) {
	      // Only update when have option data to merge.
	      var result = this._processFlatCoordsArray(option.data);
	
	      this._flatCoords = result.flatCoords;
	      this._flatCoordsOffset = result.flatCoordsOffset;
	
	      if (result.flatCoords) {
	        option.data = new Float32Array(result.count);
	      }
	    }
	
	    LinesSeries.superApply(this, 'mergeOption', arguments);
	  },
	  appendData: function (params) {
	    var result = this._processFlatCoordsArray(params.data);
	
	    if (result.flatCoords) {
	      if (!this._flatCoords) {
	        this._flatCoords = result.flatCoords;
	        this._flatCoordsOffset = result.flatCoordsOffset;
	      } else {
	        this._flatCoords = concatArray(this._flatCoords, result.flatCoords);
	        this._flatCoordsOffset = concatArray(this._flatCoordsOffset, result.flatCoordsOffset);
	      }
	
	      params.data = new Float32Array(result.count);
	    }
	
	    this.getRawData().appendData(params.data);
	  },
	  _getCoordsFromItemModel: function (idx) {
	    var itemModel = this.getData().getItemModel(idx);
	    var coords = itemModel.option instanceof Array ? itemModel.option : itemModel.getShallow('coords');
	    return coords;
	  },
	  getLineCoordsCount: function (idx) {
	    if (this._flatCoordsOffset) {
	      return this._flatCoordsOffset[idx * 2 + 1];
	    } else {
	      return this._getCoordsFromItemModel(idx).length;
	    }
	  },
	  getLineCoords: function (idx, out) {
	    if (this._flatCoordsOffset) {
	      var offset = this._flatCoordsOffset[idx * 2];
	      var len = this._flatCoordsOffset[idx * 2 + 1];
	
	      for (var i = 0; i < len; i++) {
	        out[i] = out[i] || [];
	        out[i][0] = this._flatCoords[offset + i * 2];
	        out[i][1] = this._flatCoords[offset + i * 2 + 1];
	      }
	
	      return len;
	    } else {
	      var coords = this._getCoordsFromItemModel(idx);
	
	      for (var i = 0; i < coords.length; i++) {
	        out[i] = out[i] || [];
	        out[i][0] = coords[i][0];
	        out[i][1] = coords[i][1];
	      }
	
	      return coords.length;
	    }
	  },
	  _processFlatCoordsArray: function (data) {
	    var startOffset = 0;
	
	    if (this._flatCoords) {
	      startOffset = this._flatCoords.length;
	    } // Stored as a typed array. In format
	    // Points Count(2) | x | y | x | y | Points Count(3) | x |  y | x | y | x | y |
	
	
	    if (typeof data[0] === 'number') {
	      var len = data.length; // Store offset and len of each segment
	
	      var coordsOffsetAndLenStorage = new Uint32Arr(len);
	      var coordsStorage = new Float64Arr(len);
	      var coordsCursor = 0;
	      var offsetCursor = 0;
	      var dataCount = 0;
	
	      for (var i = 0; i < len;) {
	        dataCount++;
	        var count = data[i++]; // Offset
	
	        coordsOffsetAndLenStorage[offsetCursor++] = coordsCursor + startOffset; // Len
	
	        coordsOffsetAndLenStorage[offsetCursor++] = count;
	
	        for (var k = 0; k < count; k++) {
	          var x = data[i++];
	          var y = data[i++];
	          coordsStorage[coordsCursor++] = x;
	          coordsStorage[coordsCursor++] = y;
	
	          if (i > len) {}
	        }
	      }
	
	      return {
	        flatCoordsOffset: new Uint32Array(coordsOffsetAndLenStorage.buffer, 0, offsetCursor),
	        flatCoords: coordsStorage,
	        count: dataCount
	      };
	    }
	
	    return {
	      flatCoordsOffset: null,
	      flatCoords: null,
	      count: data.length
	    };
	  },
	  getInitialData: function (option, ecModel) {
	    var lineData = new List(['value'], this);
	    lineData.hasItemOption = false;
	    lineData.initData(option.data, [], function (dataItem, dimName, dataIndex, dimIndex) {
	      // dataItem is simply coords
	      if (dataItem instanceof Array) {
	        return NaN;
	      } else {
	        lineData.hasItemOption = true;
	        var value = dataItem.value;
	
	        if (value != null) {
	          return value instanceof Array ? value[dimIndex] : value;
	        }
	      }
	    });
	    return lineData;
	  },
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var itemModel = data.getItemModel(dataIndex);
	    var name = itemModel.get('name');
	
	    if (name) {
	      return name;
	    }
	
	    var fromName = itemModel.get('fromName');
	    var toName = itemModel.get('toName');
	    var html = [];
	    fromName != null && html.push(fromName);
	    toName != null && html.push(toName);
	    return encodeHTML(html.join(' > '));
	  },
	  preventIncremental: function () {
	    return !!this.get('effect.show');
	  },
	  getProgressive: function () {
	    var progressive = this.option.progressive;
	
	    if (progressive == null) {
	      return this.option.large ? 1e4 : this.get('progressive');
	    }
	
	    return progressive;
	  },
	  getProgressiveThreshold: function () {
	    var progressiveThreshold = this.option.progressiveThreshold;
	
	    if (progressiveThreshold == null) {
	      return this.option.large ? 2e4 : this.get('progressiveThreshold');
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    coordinateSystem: 'geo',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    xAxisIndex: 0,
	    yAxisIndex: 0,
	    symbol: ['none', 'none'],
	    symbolSize: [10, 10],
	    // Geo coordinate system
	    geoIndex: 0,
	    effect: {
	      show: false,
	      period: 4,
	      // Animation delay. support callback
	      // delay: 0,
	      // If move with constant speed px/sec
	      // period will be ignored if this property is > 0,
	      constantSpeed: 0,
	      symbol: 'circle',
	      symbolSize: 3,
	      loop: true,
	      // Length of trail, 0 - 1
	      trailLength: 0.2 // Same with lineStyle.color
	      // color
	
	    },
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // If lines are polyline
	    // polyline not support curveness, label, animation
	    polyline: false,
	    // If clip the overflow.
	    // Available when coordinateSystem is cartesian or polar.
	    clip: true,
	    label: {
	      show: false,
	      position: 'end' // distance: 5,
	      // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	
	    },
	    lineStyle: {
	      opacity: 0.5
	    }
	  }
	});
	var _default = LinesSeries;
	module.exports = _default;

/***/ },
/* 2255 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(10);
	
	var LineDraw = __webpack_require__(498);
	
	var EffectLine = __webpack_require__(825);
	
	var Line = __webpack_require__(497);
	
	var Polyline = __webpack_require__(826);
	
	var EffectPolyline = __webpack_require__(2244);
	
	var LargeLineDraw = __webpack_require__(2246);
	
	var linesLayout = __webpack_require__(832);
	
	var _createClipPathFromCoordSys = __webpack_require__(288);
	
	var createClipPath = _createClipPathFromCoordSys.createClipPath;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'lines',
	  init: function () {},
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var lineDraw = this._updateLineDraw(data, seriesModel);
	
	    var zlevel = seriesModel.get('zlevel');
	    var trailLength = seriesModel.get('effect.trailLength');
	    var zr = api.getZr(); // Avoid the drag cause ghost shadow
	    // FIXME Better way ?
	    // SVG doesn't support
	
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg) {
	      zr.painter.getLayer(zlevel).clear(true);
	    } // Config layer with motion blur
	
	
	    if (this._lastZlevel != null && !isSvg) {
	      zr.configLayer(this._lastZlevel, {
	        motionBlur: false
	      });
	    }
	
	    if (this._showEffect(seriesModel) && trailLength) {
	      if (!isSvg) {
	        zr.configLayer(zlevel, {
	          motionBlur: true,
	          lastFrameAlpha: Math.max(Math.min(trailLength / 10 + 0.9, 1), 0)
	        });
	      }
	    }
	
	    lineDraw.updateData(data);
	    var clipPath = seriesModel.get('clip', true) && createClipPath(seriesModel.coordinateSystem, false, seriesModel);
	
	    if (clipPath) {
	      this.group.setClipPath(clipPath);
	    } else {
	      this.group.removeClipPath();
	    }
	
	    this._lastZlevel = zlevel;
	    this._finished = true;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var lineDraw = this._updateLineDraw(data, seriesModel);
	
	    lineDraw.incrementalPrepareUpdate(data);
	
	    this._clearLayer(api);
	
	    this._finished = false;
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    this._lineDraw.incrementalUpdate(taskParams, seriesModel.getData());
	
	    this._finished = taskParams.end === seriesModel.getData().count();
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var pipelineContext = seriesModel.pipelineContext;
	
	    if (!this._finished || pipelineContext.large || pipelineContext.progressiveRender) {
	      // TODO Don't have to do update in large mode. Only do it when there are millions of data.
	      return {
	        update: true
	      };
	    } else {
	      // TODO Use same logic with ScatterView.
	      // Manually update layout
	      var res = linesLayout.reset(seriesModel);
	
	      if (res.progress) {
	        res.progress({
	          start: 0,
	          end: data.count()
	        }, data);
	      }
	
	      this._lineDraw.updateLayout();
	
	      this._clearLayer(api);
	    }
	  },
	  _updateLineDraw: function (data, seriesModel) {
	    var lineDraw = this._lineDraw;
	
	    var hasEffect = this._showEffect(seriesModel);
	
	    var isPolyline = !!seriesModel.get('polyline');
	    var pipelineContext = seriesModel.pipelineContext;
	    var isLargeDraw = pipelineContext.large;
	
	    if (!lineDraw || hasEffect !== this._hasEffet || isPolyline !== this._isPolyline || isLargeDraw !== this._isLargeDraw) {
	      if (lineDraw) {
	        lineDraw.remove();
	      }
	
	      lineDraw = this._lineDraw = isLargeDraw ? new LargeLineDraw() : new LineDraw(isPolyline ? hasEffect ? EffectPolyline : Polyline : hasEffect ? EffectLine : Line);
	      this._hasEffet = hasEffect;
	      this._isPolyline = isPolyline;
	      this._isLargeDraw = isLargeDraw;
	      this.group.removeAll();
	    }
	
	    this.group.add(lineDraw.group);
	    return lineDraw;
	  },
	  _showEffect: function (seriesModel) {
	    return !!seriesModel.get('effect.show');
	  },
	  _clearLayer: function (api) {
	    // Not use motion when dragging or zooming
	    var zr = api.getZr();
	    var isSvg = zr.painter.getType() === 'svg';
	
	    if (!isSvg && this._lastZlevel != null) {
	      zr.painter.getLayer(this._lastZlevel).clear(true);
	    }
	  },
	  remove: function (ecModel, api) {
	    this._lineDraw && this._lineDraw.remove();
	    this._lineDraw = null; // Clear motion when lineDraw is removed
	
	    this._clearLayer(api);
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ },
/* 2256 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalize(a) {
	  if (!(a instanceof Array)) {
	    a = [a, a];
	  }
	
	  return a;
	}
	
	var opacityQuery = 'lineStyle.opacity'.split('.');
	var _default = {
	  seriesType: 'lines',
	  reset: function (seriesModel, ecModel, api) {
	    var symbolType = normalize(seriesModel.get('symbol'));
	    var symbolSize = normalize(seriesModel.get('symbolSize'));
	    var data = seriesModel.getData();
	    data.setVisual('fromSymbol', symbolType && symbolType[0]);
	    data.setVisual('toSymbol', symbolType && symbolType[1]);
	    data.setVisual('fromSymbolSize', symbolSize && symbolSize[0]);
	    data.setVisual('toSymbolSize', symbolSize && symbolSize[1]);
	    data.setVisual('opacity', seriesModel.get(opacityQuery));
	
	    function dataEach(data, idx) {
	      var itemModel = data.getItemModel(idx);
	      var symbolType = normalize(itemModel.getShallow('symbol', true));
	      var symbolSize = normalize(itemModel.getShallow('symbolSize', true));
	      var opacity = itemModel.get(opacityQuery);
	      symbolType[0] && data.setItemVisual(idx, 'fromSymbol', symbolType[0]);
	      symbolType[1] && data.setItemVisual(idx, 'toSymbol', symbolType[1]);
	      symbolSize[0] && data.setItemVisual(idx, 'fromSymbolSize', symbolSize[0]);
	      symbolSize[1] && data.setItemVisual(idx, 'toSymbolSize', symbolSize[1]);
	      data.setItemVisual(idx, 'opacity', opacity);
	    }
	
	    return {
	      dataEach: data.hasItemOption ? dataEach : null
	    };
	  }
	};
	module.exports = _default;

/***/ },
/* 2257 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2258);
	
	__webpack_require__(2259);
	
	__webpack_require__(820);
	
	__webpack_require__(513);
	
	var mapSymbolLayout = __webpack_require__(2262);
	
	var mapVisual = __webpack_require__(2263);
	
	var mapDataStatistic = __webpack_require__(2261);
	
	var backwardCompat = __webpack_require__(2260);
	
	var createDataSelectAction = __webpack_require__(819);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(mapSymbolLayout);
	echarts.registerVisual(mapVisual);
	echarts.registerProcessor(echarts.PRIORITY.PROCESSOR.STATISTIC, mapDataStatistic);
	echarts.registerPreprocessor(backwardCompat);
	createDataSelectAction('map', [{
	  type: 'mapToggleSelect',
	  event: 'mapselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'mapSelect',
	  event: 'mapselected',
	  method: 'select'
	}, {
	  type: 'mapUnSelect',
	  event: 'mapunselected',
	  method: 'unSelect'
	}]);

/***/ },
/* 2258 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var createListSimply = __webpack_require__(245);
	
	var SeriesModel = __webpack_require__(77);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var dataSelectableMixin = __webpack_require__(507);
	
	var _dataProvider = __webpack_require__(212);
	
	var retrieveRawAttr = _dataProvider.retrieveRawAttr;
	
	var geoSourceManager = __webpack_require__(358);
	
	var _sourceHelper = __webpack_require__(160);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var MapSeries = SeriesModel.extend({
	  type: 'series.map',
	  dependencies: ['geo'],
	  layoutMode: 'box',
	
	  /**
	   * Only first map series of same mapType will drawMap
	   * @type {boolean}
	   */
	  needsDrawMap: false,
	
	  /**
	   * Group of all map series with same mapType
	   * @type {boolean}
	   */
	  seriesGroup: [],
	  getInitialData: function (option) {
	    var data = createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	    var valueDim = data.mapDimension('value');
	    var dataNameMap = zrUtil.createHashMap();
	    var selectTargetList = [];
	    var toAppendNames = [];
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      var name = data.getName(i);
	      dataNameMap.set(name, true);
	      selectTargetList.push({
	        name: name,
	        value: data.get(valueDim, i),
	        selected: retrieveRawAttr(data, i, 'selected')
	      });
	    }
	
	    var geoSource = geoSourceManager.load(this.getMapType(), this.option.nameMap, this.option.nameProperty);
	    zrUtil.each(geoSource.regions, function (region) {
	      var name = region.name;
	
	      if (!dataNameMap.get(name)) {
	        selectTargetList.push({
	          name: name
	        });
	        toAppendNames.push(name);
	      }
	    });
	    this.updateSelectedMap(selectTargetList); // Complete data with missing regions. The consequent processes (like visual
	    // map and render) can not be performed without a "full data". For example,
	    // find `dataIndex` by name.
	
	    data.appendValues([], toAppendNames);
	    return data;
	  },
	
	  /**
	   * If no host geo model, return null, which means using a
	   * inner exclusive geo model.
	   */
	  getHostGeoModel: function () {
	    var geoIndex = this.option.geoIndex;
	    return geoIndex != null ? this.dependentModels.geo[geoIndex] : null;
	  },
	  getMapType: function () {
	    return (this.getHostGeoModel() || this).option.map;
	  },
	  // _fillOption: function (option, mapName) {
	  // Shallow clone
	  // option = zrUtil.extend({}, option);
	  // option.data = geoCreator.getFilledRegions(option.data, mapName, option.nameMap);
	  // return option;
	  // },
	  getRawValue: function (dataIndex) {
	    // Use value stored in data instead because it is calculated from multiple series
	    // FIXME Provide all value of multiple series ?
	    var data = this.getData();
	    return data.get(data.mapDimension('value'), dataIndex);
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (regionName) {
	    var data = this.getData();
	    return data.getItemModel(data.indexOfName(regionName));
	  },
	
	  /**
	   * Map tooltip formatter
	   *
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    // FIXME orignalData and data is a bit confusing
	    var data = this.getData();
	    var formattedValue = addCommas(this.getRawValue(dataIndex));
	    var name = data.getName(dataIndex);
	    var seriesGroup = this.seriesGroup;
	    var seriesNames = [];
	
	    for (var i = 0; i < seriesGroup.length; i++) {
	      var otherIndex = seriesGroup[i].originalData.indexOfName(name);
	      var valueDim = data.mapDimension('value');
	
	      if (!isNaN(seriesGroup[i].originalData.get(valueDim, otherIndex))) {
	        seriesNames.push(encodeHTML(seriesGroup[i].name));
	      }
	    }
	
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    return seriesNames.join(', ') + newLine + encodeHTML(name + ' : ' + formattedValue);
	  },
	
	  /**
	   * @implement
	   */
	  getTooltipPosition: function (dataIndex) {
	    if (dataIndex != null) {
	      var name = this.getData().getName(dataIndex);
	      var geo = this.coordinateSystem;
	      var region = geo.getRegion(name);
	      return region && geo.dataToPoint(region.center);
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 2,
	    coordinateSystem: 'geo',
	    // map should be explicitly specified since ec3.
	    map: '',
	    // If `geoIndex` is not specified, a exclusive geo will be
	    // created. Otherwise use the specified geo component, and
	    // `map` and `mapType` are ignored.
	    // geoIndex: 0,
	    // 'center' | 'left' | 'right' | 'x%' | {number}
	    left: 'center',
	    // 'center' | 'top' | 'bottom' | 'x%' | {number}
	    top: 'center',
	    // right
	    // bottom
	    // width:
	    // height
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    aspectScale: 0.75,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    // 数值合并方式，默认加和，可选为：
	    // 'sum' | 'average' | 'max' | 'min'
	    // mapValueCalculation: 'sum',
	    // 地图数值计算结果小数精度
	    // mapValuePrecision: 0,
	    // 显示图例颜色标识（系列标识的小圆点），图例开启时有效
	    showLegendSymbol: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    dataRangeHoverLink: true,
	    // 是否开启缩放及漫游模式
	    // roam: false,
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ],
	    // higher priority than center and zoom
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    label: {
	      show: false,
	      color: '#000'
	    },
	    // scaleLimit: null,
	    itemStyle: {
	      borderWidth: 0.5,
	      borderColor: '#444',
	      areaColor: '#eee'
	    },
	    emphasis: {
	      label: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      },
	      itemStyle: {
	        areaColor: 'rgba(255,215,0,0.8)'
	      }
	    },
	    nameProperty: 'name'
	  }
	});
	zrUtil.mixin(MapSeries, dataSelectableMixin);
	var _default = MapSeries;
	module.exports = _default;

/***/ },
/* 2259 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var MapDraw = __webpack_require__(844);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var HIGH_DOWN_PROP = '__seriesMapHighDown';
	var RECORD_VERSION_PROP = '__seriesMapCallKey';
	
	var _default = echarts.extendChartView({
	  type: 'map',
	  render: function (mapModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'mapToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var group = this.group;
	    group.removeAll();
	
	    if (mapModel.getHostGeoModel()) {
	      return;
	    } // Not update map if it is an roam action from self
	
	
	    if (!(payload && payload.type === 'geoRoam' && payload.componentType === 'series' && payload.seriesId === mapModel.id)) {
	      if (mapModel.needsDrawMap) {
	        var mapDraw = this._mapDraw || new MapDraw(api, true);
	        group.add(mapDraw.group);
	        mapDraw.draw(mapModel, ecModel, api, this, payload);
	        this._mapDraw = mapDraw;
	      } else {
	        // Remove drawed map
	        this._mapDraw && this._mapDraw.remove();
	        this._mapDraw = null;
	      }
	    } else {
	      var mapDraw = this._mapDraw;
	      mapDraw && group.add(mapDraw.group);
	    }
	
	    mapModel.get('showLegendSymbol') && ecModel.getComponent('legend') && this._renderSymbols(mapModel, ecModel, api);
	  },
	  remove: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	    this.group.removeAll();
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	    this._mapDraw = null;
	  },
	  _renderSymbols: function (mapModel, ecModel, api) {
	    var originalData = mapModel.originalData;
	    var group = this.group;
	    originalData.each(originalData.mapDimension('value'), function (value, originalDataIndex) {
	      if (isNaN(value)) {
	        return;
	      }
	
	      var layout = originalData.getItemLayout(originalDataIndex);
	
	      if (!layout || !layout.point) {
	        // Not exists in map
	        return;
	      }
	
	      var point = layout.point;
	      var offset = layout.offset;
	      var circle = new graphic.Circle({
	        style: {
	          // Because the special of map draw.
	          // Which needs statistic of multiple series and draw on one map.
	          // And each series also need a symbol with legend color
	          //
	          // Layout and visual are put one the different data
	          fill: mapModel.getData().getVisual('color')
	        },
	        shape: {
	          cx: point[0] + offset * 9,
	          cy: point[1],
	          r: 3
	        },
	        silent: true,
	        // Do not overlap the first series, on which labels are displayed.
	        z2: 8 + (!offset ? graphic.Z2_EMPHASIS_LIFT + 1 : 0)
	      }); // Only the series that has the first value on the same region is in charge of rendering the label.
	      // But consider the case:
	      // series: [
	      //     {id: 'X', type: 'map', map: 'm', {data: [{name: 'A', value: 11}, {name: 'B', {value: 22}]},
	      //     {id: 'Y', type: 'map', map: 'm', {data: [{name: 'A', value: 21}, {name: 'C', {value: 33}]}
	      // ]
	      // The offset `0` of item `A` is at series `X`, but of item `C` is at series `Y`.
	      // For backward compatibility, we follow the rule that render label `A` by the
	      // settings on series `X` but render label `C` by the settings on series `Y`.
	
	      if (!offset) {
	        var fullData = mapModel.mainSeries.getData();
	        var name = originalData.getName(originalDataIndex);
	        var fullIndex = fullData.indexOfName(name);
	        var itemModel = originalData.getItemModel(originalDataIndex);
	        var labelModel = itemModel.getModel('label');
	        var hoverLabelModel = itemModel.getModel('emphasis.label');
	        var regionGroup = fullData.getItemGraphicEl(fullIndex); // `getFormattedLabel` needs to use `getData` inside. Here
	        // `mapModel.getData()` is shallow cloned from `mainSeries.getData()`.
	        // FIXME
	        // If this is not the `mainSeries`, the item model (like label formatter)
	        // set on original data item will never get. But it has been working
	        // like that from the begining, and this scenario is rarely encountered.
	        // So it won't be fixed until have to.
	
	        var normalText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'normal'), name);
	        var emphasisText = zrUtil.retrieve2(mapModel.getFormattedLabel(fullIndex, 'emphasis'), normalText);
	        var highDownRecord = regionGroup[HIGH_DOWN_PROP];
	        var recordVersion = Math.random(); // Prevent from register listeners duplicatedly when roaming.
	
	        if (!highDownRecord) {
	          highDownRecord = regionGroup[HIGH_DOWN_PROP] = {};
	          var onEmphasis = zrUtil.curry(onRegionHighDown, true);
	          var onNormal = zrUtil.curry(onRegionHighDown, false);
	          regionGroup.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal);
	        } // Prevent removed regions effect current grapics.
	
	
	        regionGroup[RECORD_VERSION_PROP] = recordVersion;
	        zrUtil.extend(highDownRecord, {
	          recordVersion: recordVersion,
	          circle: circle,
	          labelModel: labelModel,
	          hoverLabelModel: hoverLabelModel,
	          emphasisText: emphasisText,
	          normalText: normalText
	        }); // FIXME
	        // Consider set option when emphasis.
	
	        enterRegionHighDown(highDownRecord, false);
	      }
	
	      group.add(circle);
	    });
	  }
	});
	
	function onRegionHighDown(toHighOrDown) {
	  var highDownRecord = this[HIGH_DOWN_PROP];
	
	  if (highDownRecord && highDownRecord.recordVersion === this[RECORD_VERSION_PROP]) {
	    enterRegionHighDown(highDownRecord, toHighOrDown);
	  }
	}
	
	function enterRegionHighDown(highDownRecord, toHighOrDown) {
	  var circle = highDownRecord.circle;
	  var labelModel = highDownRecord.labelModel;
	  var hoverLabelModel = highDownRecord.hoverLabelModel;
	  var emphasisText = highDownRecord.emphasisText;
	  var normalText = highDownRecord.normalText;
	
	  if (toHighOrDown) {
	    circle.style.extendFrom(graphic.setTextStyle({}, hoverLabelModel, {
	      text: hoverLabelModel.get('show') ? emphasisText : null
	    }, {
	      isRectText: true,
	      useInsideStyle: false
	    }, true)); // Make label upper than others if overlaps.
	
	    circle.__mapOriginalZ2 = circle.z2;
	    circle.z2 += graphic.Z2_EMPHASIS_LIFT;
	  } else {
	    graphic.setTextStyle(circle.style, labelModel, {
	      text: labelModel.get('show') ? normalText : null,
	      textPosition: labelModel.getShallow('position') || 'bottom'
	    }, {
	      isRectText: true,
	      useInsideStyle: false
	    }); // Trigger normalize style like padding.
	
	    circle.dirty(false);
	
	    if (circle.__mapOriginalZ2 != null) {
	      circle.z2 = circle.__mapOriginalZ2;
	      circle.__mapOriginalZ2 = null;
	    }
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2260 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  // Save geoCoord
	  var mapSeries = [];
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'map') {
	      mapSeries.push(seriesOpt);
	      seriesOpt.map = seriesOpt.map || seriesOpt.mapType; // Put x, y, width, height, x2, y2 in the top level
	
	      zrUtil.defaults(seriesOpt, seriesOpt.mapLocation);
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2261 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME 公用？
	
	/**
	 * @param {Array.<module:echarts/data/List>} datas
	 * @param {string} statisticType 'average' 'sum'
	 * @inner
	 */
	function dataStatistics(datas, statisticType) {
	  var dataNameMap = {};
	  zrUtil.each(datas, function (data) {
	    data.each(data.mapDimension('value'), function (value, idx) {
	      // Add prefix to avoid conflict with Object.prototype.
	      var mapKey = 'ec-' + data.getName(idx);
	      dataNameMap[mapKey] = dataNameMap[mapKey] || [];
	
	      if (!isNaN(value)) {
	        dataNameMap[mapKey].push(value);
	      }
	    });
	  });
	  return datas[0].map(datas[0].mapDimension('value'), function (value, idx) {
	    var mapKey = 'ec-' + datas[0].getName(idx);
	    var sum = 0;
	    var min = Infinity;
	    var max = -Infinity;
	    var len = dataNameMap[mapKey].length;
	
	    for (var i = 0; i < len; i++) {
	      min = Math.min(min, dataNameMap[mapKey][i]);
	      max = Math.max(max, dataNameMap[mapKey][i]);
	      sum += dataNameMap[mapKey][i];
	    }
	
	    var result;
	
	    if (statisticType === 'min') {
	      result = min;
	    } else if (statisticType === 'max') {
	      result = max;
	    } else if (statisticType === 'average') {
	      result = sum / len;
	    } else {
	      result = sum;
	    }
	
	    return len === 0 ? NaN : result;
	  });
	}
	
	function _default(ecModel) {
	  var seriesGroups = {};
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var hostGeoModel = seriesModel.getHostGeoModel();
	    var key = hostGeoModel ? 'o' + hostGeoModel.id : 'i' + seriesModel.getMapType();
	    (seriesGroups[key] = seriesGroups[key] || []).push(seriesModel);
	  });
	  zrUtil.each(seriesGroups, function (seriesList, key) {
	    var data = dataStatistics(zrUtil.map(seriesList, function (seriesModel) {
	      return seriesModel.getData();
	    }), seriesList[0].get('mapValueCalculation'));
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].originalData = seriesList[i].getData();
	    } // FIXME Put where?
	
	
	    for (var i = 0; i < seriesList.length; i++) {
	      seriesList[i].seriesGroup = seriesList;
	      seriesList[i].needsDrawMap = i === 0 && !seriesList[i].getHostGeoModel();
	      seriesList[i].setData(data.cloneShallow());
	      seriesList[i].mainSeries = seriesList[0];
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2262 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var processedMapType = {};
	  ecModel.eachSeriesByType('map', function (mapSeries) {
	    var mapType = mapSeries.getMapType();
	
	    if (mapSeries.getHostGeoModel() || processedMapType[mapType]) {
	      return;
	    }
	
	    var mapSymbolOffsets = {};
	    zrUtil.each(mapSeries.seriesGroup, function (subMapSeries) {
	      var geo = subMapSeries.coordinateSystem;
	      var data = subMapSeries.originalData;
	
	      if (subMapSeries.get('showLegendSymbol') && ecModel.getComponent('legend')) {
	        data.each(data.mapDimension('value'), function (value, idx) {
	          var name = data.getName(idx);
	          var region = geo.getRegion(name); // If input series.data is [11, 22, '-'/null/undefined, 44],
	          // it will be filled with NaN: [11, 22, NaN, 44] and NaN will
	          // not be drawn. So here must validate if value is NaN.
	
	          if (!region || isNaN(value)) {
	            return;
	          }
	
	          var offset = mapSymbolOffsets[name] || 0;
	          var point = geo.dataToPoint(region.center);
	          mapSymbolOffsets[name] = offset + 1;
	          data.setItemLayout(idx, {
	            point: point,
	            offset: offset
	          });
	        });
	      }
	    }); // Show label of those region not has legendSymbol(which is offset 0)
	
	    var data = mapSeries.getData();
	    data.each(function (idx) {
	      var name = data.getName(idx);
	      var layout = data.getItemLayout(idx) || {};
	      layout.showLabel = !mapSymbolOffsets[name];
	      data.setItemLayout(idx, layout);
	    });
	    processedMapType[mapType] = true;
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2263 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('map', function (seriesModel) {
	    var colorList = seriesModel.get('color');
	    var itemStyleModel = seriesModel.getModel('itemStyle');
	    var areaColor = itemStyleModel.get('areaColor');
	    var color = itemStyleModel.get('color') || colorList[seriesModel.seriesIndex % colorList.length];
	    seriesModel.getData().setVisual({
	      'areaColor': areaColor,
	      'color': color
	    });
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2264 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(851);
	
	__webpack_require__(2265);
	
	__webpack_require__(2266);
	
	var parallelVisual = __webpack_require__(2267);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(parallelVisual);

/***/ },
/* 2265 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	var createHashMap = _util.createHashMap;
	
	var SeriesModel = __webpack_require__(77);
	
	var createListFromArray = __webpack_require__(159);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.parallel',
	  dependencies: ['parallel'],
	  visualColorAccessPath: 'lineStyle.color',
	  getInitialData: function (option, ecModel) {
	    var source = this.getSource();
	    setEncodeAndDimensions(source, this);
	    return createListFromArray(source, this);
	  },
	
	  /**
	   * User can get data raw indices on 'axisAreaSelected' event received.
	   *
	   * @public
	   * @param {string} activeState 'active' or 'inactive' or 'normal'
	   * @return {Array.<number>} Raw indices
	   */
	  getRawIndicesByActiveState: function (activeState) {
	    var coordSys = this.coordinateSystem;
	    var data = this.getData();
	    var indices = [];
	    coordSys.eachActiveState(data, function (theActiveState, dataIndex) {
	      if (activeState === theActiveState) {
	        indices.push(data.getRawIndex(dataIndex));
	      }
	    });
	    return indices;
	  },
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 2,
	    // 二级层叠
	    coordinateSystem: 'parallel',
	    parallelIndex: 0,
	    label: {
	      show: false
	    },
	    inactiveOpacity: 0.05,
	    activeOpacity: 1,
	    lineStyle: {
	      width: 1,
	      opacity: 0.45,
	      type: 'solid'
	    },
	    emphasis: {
	      label: {
	        show: false
	      }
	    },
	    progressive: 500,
	    smooth: false,
	    // true | false | number
	    animationEasing: 'linear'
	  }
	});
	
	function setEncodeAndDimensions(source, seriesModel) {
	  // The mapping of parallelAxis dimension to data dimension can
	  // be specified in parallelAxis.option.dim. For example, if
	  // parallelAxis.option.dim is 'dim3', it mapping to the third
	  // dimension of data. But `data.encode` has higher priority.
	  // Moreover, parallelModel.dimension should not be regarded as data
	  // dimensions. Consider dimensions = ['dim4', 'dim2', 'dim6'];
	  if (source.encodeDefine) {
	    return;
	  }
	
	  var parallelModel = seriesModel.ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	
	  if (!parallelModel) {
	    return;
	  }
	
	  var encodeDefine = source.encodeDefine = createHashMap();
	  each(parallelModel.dimensions, function (axisDim) {
	    var dataDimIndex = convertDimNameToNumber(axisDim);
	    encodeDefine.set(axisDim, dataDimIndex);
	  });
	}
	
	function convertDimNameToNumber(dimName) {
	  return +dimName.replace('dim', '');
	}
	
	module.exports = _default;

/***/ },
/* 2266 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var ChartView = __webpack_require__(141);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_SMOOTH = 0.3;
	var ParallelView = ChartView.extend({
	  type: 'parallel',
	  init: function () {
	    /**
	     * @type {module:zrender/container/Group}
	     * @private
	     */
	    this._dataGroup = new graphic.Group();
	    this.group.add(this._dataGroup);
	    /**
	     * @type {module:echarts/data/List}
	     */
	
	    this._data;
	    /**
	     * @type {boolean}
	     */
	
	    this._initialized;
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    var dataGroup = this._dataGroup;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var coordSys = seriesModel.coordinateSystem;
	    var dimensions = coordSys.dimensions;
	    var seriesScope = makeSeriesScope(seriesModel);
	    data.diff(oldData).add(add).update(update).remove(remove).execute();
	
	    function add(newDataIndex) {
	      var line = addEl(data, dataGroup, newDataIndex, dimensions, coordSys);
	      updateElCommon(line, data, newDataIndex, seriesScope);
	    }
	
	    function update(newDataIndex, oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      var points = createLinePoints(data, newDataIndex, dimensions, coordSys);
	      data.setItemGraphicEl(newDataIndex, line);
	      var animationModel = payload && payload.animation === false ? null : seriesModel;
	      graphic.updateProps(line, {
	        shape: {
	          points: points
	        }
	      }, animationModel, newDataIndex);
	      updateElCommon(line, data, newDataIndex, seriesScope);
	    }
	
	    function remove(oldDataIndex) {
	      var line = oldData.getItemGraphicEl(oldDataIndex);
	      dataGroup.remove(line);
	    } // First create
	
	
	    if (!this._initialized) {
	      this._initialized = true;
	      var clipPath = createGridClipShape(coordSys, seriesModel, function () {
	        // Callback will be invoked immediately if there is no animation
	        setTimeout(function () {
	          dataGroup.removeClipPath();
	        });
	      });
	      dataGroup.setClipPath(clipPath);
	    }
	
	    this._data = data;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    this._initialized = true;
	    this._data = null;
	
	    this._dataGroup.removeAll();
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var coordSys = seriesModel.coordinateSystem;
	    var dimensions = coordSys.dimensions;
	    var seriesScope = makeSeriesScope(seriesModel);
	
	    for (var dataIndex = taskParams.start; dataIndex < taskParams.end; dataIndex++) {
	      var line = addEl(data, this._dataGroup, dataIndex, dimensions, coordSys);
	      line.incremental = true;
	      updateElCommon(line, data, dataIndex, seriesScope);
	    }
	  },
	  dispose: function () {},
	  // _renderForProgressive: function (seriesModel) {
	  //     var dataGroup = this._dataGroup;
	  //     var data = seriesModel.getData();
	  //     var oldData = this._data;
	  //     var coordSys = seriesModel.coordinateSystem;
	  //     var dimensions = coordSys.dimensions;
	  //     var option = seriesModel.option;
	  //     var progressive = option.progressive;
	  //     var smooth = option.smooth ? SMOOTH : null;
	  //     // In progressive animation is disabled, so use simple data diff,
	  //     // which effects performance less.
	  //     // (Typically performance for data with length 7000+ like:
	  //     // simpleDiff: 60ms, addEl: 184ms,
	  //     // in RMBP 2.4GHz intel i7, OSX 10.9 chrome 50.0.2661.102 (64-bit))
	  //     if (simpleDiff(oldData, data, dimensions)) {
	  //         dataGroup.removeAll();
	  //         data.each(function (dataIndex) {
	  //             addEl(data, dataGroup, dataIndex, dimensions, coordSys);
	  //         });
	  //     }
	  //     updateElCommon(data, progressive, smooth);
	  //     // Consider switch between progressive and not.
	  //     data.__plProgressive = true;
	  //     this._data = data;
	  // },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._dataGroup && this._dataGroup.removeAll();
	    this._data = null;
	  }
	});
	
	function createGridClipShape(coordSys, seriesModel, cb) {
	  var parallelModel = coordSys.model;
	  var rect = coordSys.getRect();
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    }
	  });
	  var dim = parallelModel.get('layout') === 'horizontal' ? 'width' : 'height';
	  rectEl.setShape(dim, 0);
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width,
	      height: rect.height
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	function createLinePoints(data, dataIndex, dimensions, coordSys) {
	  var points = [];
	
	  for (var i = 0; i < dimensions.length; i++) {
	    var dimName = dimensions[i];
	    var value = data.get(data.mapDimension(dimName), dataIndex);
	
	    if (!isEmptyValue(value, coordSys.getAxis(dimName).type)) {
	      points.push(coordSys.dataToPoint(value, dimName));
	    }
	  }
	
	  return points;
	}
	
	function addEl(data, dataGroup, dataIndex, dimensions, coordSys) {
	  var points = createLinePoints(data, dataIndex, dimensions, coordSys);
	  var line = new graphic.Polyline({
	    shape: {
	      points: points
	    },
	    silent: true,
	    z2: 10
	  });
	  dataGroup.add(line);
	  data.setItemGraphicEl(dataIndex, line);
	  return line;
	}
	
	function makeSeriesScope(seriesModel) {
	  var smooth = seriesModel.get('smooth', true);
	  smooth === true && (smooth = DEFAULT_SMOOTH);
	  return {
	    lineStyle: seriesModel.getModel('lineStyle').getLineStyle(),
	    smooth: smooth != null ? smooth : DEFAULT_SMOOTH
	  };
	}
	
	function updateElCommon(el, data, dataIndex, seriesScope) {
	  var lineStyle = seriesScope.lineStyle;
	
	  if (data.hasItemOption) {
	    var lineStyleModel = data.getItemModel(dataIndex).getModel('lineStyle');
	    lineStyle = lineStyleModel.getLineStyle();
	  }
	
	  el.useStyle(lineStyle);
	  var elStyle = el.style;
	  elStyle.fill = null; // lineStyle.color have been set to itemVisual in module:echarts/visual/seriesColor.
	
	  elStyle.stroke = data.getItemVisual(dataIndex, 'color'); // lineStyle.opacity have been set to itemVisual in parallelVisual.
	
	  elStyle.opacity = data.getItemVisual(dataIndex, 'opacity');
	  seriesScope.smooth && (el.shape.smooth = seriesScope.smooth);
	} // function simpleDiff(oldData, newData, dimensions) {
	//     var oldLen;
	//     if (!oldData
	//         || !oldData.__plProgressive
	//         || (oldLen = oldData.count()) !== newData.count()
	//     ) {
	//         return true;
	//     }
	//     var dimLen = dimensions.length;
	//     for (var i = 0; i < oldLen; i++) {
	//         for (var j = 0; j < dimLen; j++) {
	//             if (oldData.get(dimensions[j], i) !== newData.get(dimensions[j], i)) {
	//                 return true;
	//             }
	//         }
	//     }
	//     return false;
	// }
	// FIXME
	// 公用方法?
	
	
	function isEmptyValue(val, axisType) {
	  return axisType === 'category' ? val == null : val == null || isNaN(val); // axisType === 'value'
	}
	
	var _default = ParallelView;
	module.exports = _default;

/***/ },
/* 2267 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var opacityAccessPath = ['lineStyle', 'normal', 'opacity'];
	var _default = {
	  seriesType: 'parallel',
	  reset: function (seriesModel, ecModel, api) {
	    var itemStyleModel = seriesModel.getModel('itemStyle');
	    var lineStyleModel = seriesModel.getModel('lineStyle');
	    var globalColors = ecModel.get('color');
	    var color = lineStyleModel.get('color') || itemStyleModel.get('color') || globalColors[seriesModel.seriesIndex % globalColors.length];
	    var inactiveOpacity = seriesModel.get('inactiveOpacity');
	    var activeOpacity = seriesModel.get('activeOpacity');
	    var lineStyle = seriesModel.getModel('lineStyle').getLineStyle();
	    var coordSys = seriesModel.coordinateSystem;
	    var data = seriesModel.getData();
	    var opacityMap = {
	      normal: lineStyle.opacity,
	      active: activeOpacity,
	      inactive: inactiveOpacity
	    };
	    data.setVisual('color', color);
	
	    function progress(params, data) {
	      coordSys.eachActiveState(data, function (activeState, dataIndex) {
	        var opacity = opacityMap[activeState];
	
	        if (activeState === 'normal' && data.hasItemOption) {
	          var itemOpacity = data.getItemModel(dataIndex).get(opacityAccessPath, true);
	          itemOpacity != null && (opacity = itemOpacity);
	        }
	
	        data.setItemVisual(dataIndex, 'opacity', opacity);
	      }, params.start, params.end);
	    }
	
	    return {
	      progress: progress
	    };
	  }
	};
	module.exports = _default;

/***/ },
/* 2268 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	__webpack_require__(512);
	
	__webpack_require__(2201);
	
	__webpack_require__(2202);
	
	var _barGrid = __webpack_require__(359);
	
	var layout = _barGrid.layout;
	
	var visualSymbol = __webpack_require__(214);
	
	__webpack_require__(290);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// In case developer forget to include grid component
	echarts.registerLayout(zrUtil.curry(layout, 'pictorialBar'));
	echarts.registerVisual(visualSymbol('pictorialBar', 'roundRect'));

/***/ },
/* 2269 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	__webpack_require__(2270);
	
	__webpack_require__(2271);
	
	var createDataSelectAction = __webpack_require__(819);
	
	var dataColor = __webpack_require__(363);
	
	var pieLayout = __webpack_require__(2273);
	
	var dataFilter = __webpack_require__(296);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	createDataSelectAction('pie', [{
	  type: 'pieToggleSelect',
	  event: 'pieselectchanged',
	  method: 'toggleSelected'
	}, {
	  type: 'pieSelect',
	  event: 'pieselected',
	  method: 'select'
	}, {
	  type: 'pieUnSelect',
	  event: 'pieunselected',
	  method: 'unSelect'
	}]);
	echarts.registerVisual(dataColor('pie'));
	echarts.registerLayout(zrUtil.curry(pieLayout, 'pie'));
	echarts.registerProcessor(dataFilter('pie'));

/***/ },
/* 2270 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var createListSimply = __webpack_require__(245);
	
	var zrUtil = __webpack_require__(4);
	
	var modelUtil = __webpack_require__(29);
	
	var _number = __webpack_require__(25);
	
	var getPercentWithPrecision = _number.getPercentWithPrecision;
	
	var dataSelectableMixin = __webpack_require__(507);
	
	var _dataProvider = __webpack_require__(212);
	
	var retrieveRawAttr = _dataProvider.retrieveRawAttr;
	
	var _sourceHelper = __webpack_require__(160);
	
	var makeSeriesEncodeForNameBased = _sourceHelper.makeSeriesEncodeForNameBased;
	
	var LegendVisualProvider = __webpack_require__(298);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PieSeries = echarts.extendSeriesModel({
	  type: 'series.pie',
	  // Overwrite
	  init: function (option) {
	    PieSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	    this.updateSelectedMap(this._createSelectableList());
	
	    this._defaultLabelLine(option);
	  },
	  // Overwrite
	  mergeOption: function (newOption) {
	    PieSeries.superCall(this, 'mergeOption', newOption);
	    this.updateSelectedMap(this._createSelectableList());
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      coordDimensions: ['value'],
	      encodeDefaulter: zrUtil.curry(makeSeriesEncodeForNameBased, this)
	    });
	  },
	  _createSelectableList: function () {
	    var data = this.getRawData();
	    var valueDim = data.mapDimension('value');
	    var targetList = [];
	
	    for (var i = 0, len = data.count(); i < len; i++) {
	      targetList.push({
	        name: data.getName(i),
	        value: data.get(valueDim, i),
	        selected: retrieveRawAttr(data, i, 'selected')
	      });
	    }
	
	    return targetList;
	  },
	  // Overwrite
	  getDataParams: function (dataIndex) {
	    var data = this.getData();
	    var params = PieSeries.superCall(this, 'getDataParams', dataIndex); // FIXME toFixed?
	
	    var valueList = [];
	    data.each(data.mapDimension('value'), function (value) {
	      valueList.push(value);
	    });
	    params.percent = getPercentWithPrecision(valueList, dataIndex, data.hostModel.get('percentPrecision'));
	    params.$vars.push('percent');
	    return params;
	  },
	  _defaultLabelLine: function (option) {
	    // Extend labelLine emphasis
	    modelUtil.defaultEmphasis(option, 'labelLine', ['show']);
	    var labelLineNormalOpt = option.labelLine;
	    var labelLineEmphasisOpt = option.emphasis.labelLine; // Not show label line if `label.normal.show = false`
	
	    labelLineNormalOpt.show = labelLineNormalOpt.show && option.label.show;
	    labelLineEmphasisOpt.show = labelLineEmphasisOpt.show && option.emphasis.label.show;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    radius: [0, '75%'],
	    // 默认顺时针
	    clockwise: true,
	    startAngle: 90,
	    // 最小角度改为0
	    minAngle: 0,
	    // If the angle of a sector less than `minShowLabelAngle`,
	    // the label will not be displayed.
	    minShowLabelAngle: 0,
	    // 选中时扇区偏移量
	    selectedOffset: 10,
	    // 高亮扇区偏移量
	    hoverOffset: 10,
	    // If use strategy to avoid label overlapping
	    avoidLabelOverlap: true,
	    // 选择模式，默认关闭，可选single，multiple
	    // selectedMode: false,
	    // 南丁格尔玫瑰图模式，'radius'（半径） | 'area'（面积）
	    // roseType: null,
	    percentPrecision: 2,
	    // If still show when all data zero.
	    stillShowZeroSum: true,
	    // cursor: null,
	    left: 0,
	    top: 0,
	    right: 0,
	    bottom: 0,
	    width: null,
	    height: null,
	    label: {
	      // If rotate around circle
	      rotate: false,
	      show: true,
	      // 'outer', 'inside', 'center'
	      position: 'outer',
	      // 'none', 'labelLine', 'edge'. Works only when position is 'outer'
	      alignTo: 'none',
	      // Closest distance between label and chart edge.
	      // Works only position is 'outer' and alignTo is 'edge'.
	      margin: '25%',
	      // Works only position is 'outer' and alignTo is not 'edge'.
	      bleedMargin: 10,
	      // Distance between text and label line.
	      distanceToLabelLine: 5 // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	      // 默认使用全局文本样式，详见TEXTSTYLE
	      // distance: 当position为inner时有效，为label位置到圆心的距离与圆半径(环状图为内外半径和)的比例系数
	
	    },
	    // Enabled when label.normal.position is 'outer'
	    labelLine: {
	      show: true,
	      // 引导线两段中的第一段长度
	      length: 15,
	      // 引导线两段中的第二段长度
	      length2: 15,
	      smooth: false,
	      lineStyle: {
	        // color: 各异,
	        width: 1,
	        type: 'solid'
	      }
	    },
	    itemStyle: {
	      borderWidth: 1
	    },
	    // Animation type. Valid values: expansion, scale
	    animationType: 'expansion',
	    // Animation type when update. Valid values: transition, expansion
	    animationTypeUpdate: 'transition',
	    animationEasing: 'cubicOut'
	  }
	});
	zrUtil.mixin(PieSeries, dataSelectableMixin);
	var _default = PieSeries;
	module.exports = _default;

/***/ },
/* 2271 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var ChartView = __webpack_require__(141);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	function updateDataSelected(uid, seriesModel, hasAnimation, api) {
	  var data = seriesModel.getData();
	  var dataIndex = this.dataIndex;
	  var name = data.getName(dataIndex);
	  var selectedOffset = seriesModel.get('selectedOffset');
	  api.dispatchAction({
	    type: 'pieToggleSelect',
	    from: uid,
	    name: name,
	    seriesId: seriesModel.id
	  });
	  data.each(function (idx) {
	    toggleItemSelected(data.getItemGraphicEl(idx), data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), selectedOffset, hasAnimation);
	  });
	}
	/**
	 * @param {module:zrender/graphic/Sector} el
	 * @param {Object} layout
	 * @param {boolean} isSelected
	 * @param {number} selectedOffset
	 * @param {boolean} hasAnimation
	 * @inner
	 */
	
	
	function toggleItemSelected(el, layout, isSelected, selectedOffset, hasAnimation) {
	  var midAngle = (layout.startAngle + layout.endAngle) / 2;
	  var dx = Math.cos(midAngle);
	  var dy = Math.sin(midAngle);
	  var offset = isSelected ? selectedOffset : 0;
	  var position = [dx * offset, dy * offset];
	  hasAnimation // animateTo will stop revious animation like update transition
	  ? el.animate().when(200, {
	    position: position
	  }).start('bounceOut') : el.attr('position', position);
	}
	/**
	 * Piece of pie including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	
	
	function PiePiece(data, idx) {
	  graphic.Group.call(this);
	  var sector = new graphic.Sector({
	    z2: 2
	  });
	  var polyline = new graphic.Polyline();
	  var text = new graphic.Text();
	  this.add(sector);
	  this.add(polyline);
	  this.add(text);
	  this.updateData(data, idx, true);
	}
	
	var piePieceProto = PiePiece.prototype;
	
	piePieceProto.updateData = function (data, idx, firstCreate) {
	  var sector = this.childAt(0);
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var sectorShape = zrUtil.extend({}, layout);
	  sectorShape.label = null;
	  var animationTypeUpdate = seriesModel.getShallow('animationTypeUpdate');
	
	  if (firstCreate) {
	    sector.setShape(sectorShape);
	    var animationType = seriesModel.getShallow('animationType');
	
	    if (animationType === 'scale') {
	      sector.shape.r = layout.r0;
	      graphic.initProps(sector, {
	        shape: {
	          r: layout.r
	        }
	      }, seriesModel, idx);
	    } // Expansion
	    else {
	        sector.shape.endAngle = layout.startAngle;
	        graphic.updateProps(sector, {
	          shape: {
	            endAngle: layout.endAngle
	          }
	        }, seriesModel, idx);
	      }
	  } else {
	    if (animationTypeUpdate === 'expansion') {
	      // Sectors are set to be target shape and an overlaying clipPath is used for animation
	      sector.setShape(sectorShape);
	    } else {
	      // Transition animation from the old shape
	      graphic.updateProps(sector, {
	        shape: sectorShape
	      }, seriesModel, idx);
	    }
	  } // Update common style
	
	
	  var visualColor = data.getItemVisual(idx, 'color');
	  sector.useStyle(zrUtil.defaults({
	    lineJoin: 'bevel',
	    fill: visualColor
	  }, itemModel.getModel('itemStyle').getItemStyle()));
	  sector.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && sector.attr('cursor', cursorStyle); // Toggle selected
	
	  toggleItemSelected(this, data.getItemLayout(idx), seriesModel.isSelected(data.getName(idx)), seriesModel.get('selectedOffset'), seriesModel.get('animation')); // Label and text animation should be applied only for transition type animation when update
	
	  var withAnimation = !firstCreate && animationTypeUpdate === 'transition';
	
	  this._updateLabel(data, idx, withAnimation);
	
	  this.highDownOnUpdate = !seriesModel.get('silent') ? function (fromState, toState) {
	    var hasAnimation = seriesModel.isAnimationEnabled() && itemModel.get('hoverAnimation');
	
	    if (toState === 'emphasis') {
	      labelLine.ignore = labelLine.hoverIgnore;
	      labelText.ignore = labelText.hoverIgnore; // Sector may has animation of updating data. Force to move to the last frame
	      // Or it may stopped on the wrong shape
	
	      if (hasAnimation) {
	        sector.stopAnimation(true);
	        sector.animateTo({
	          shape: {
	            r: layout.r + seriesModel.get('hoverOffset')
	          }
	        }, 300, 'elasticOut');
	      }
	    } else {
	      labelLine.ignore = labelLine.normalIgnore;
	      labelText.ignore = labelText.normalIgnore;
	
	      if (hasAnimation) {
	        sector.stopAnimation(true);
	        sector.animateTo({
	          shape: {
	            r: layout.r
	          }
	        }, 300, 'elasticOut');
	      }
	    }
	  } : null;
	  graphic.setHoverStyle(this);
	};
	
	piePieceProto._updateLabel = function (data, idx, withAnimation) {
	  var labelLine = this.childAt(1);
	  var labelText = this.childAt(2);
	  var seriesModel = data.hostModel;
	  var itemModel = data.getItemModel(idx);
	  var layout = data.getItemLayout(idx);
	  var labelLayout = layout.label;
	  var visualColor = data.getItemVisual(idx, 'color');
	
	  if (!labelLayout || isNaN(labelLayout.x) || isNaN(labelLayout.y)) {
	    labelText.ignore = labelText.normalIgnore = labelText.hoverIgnore = labelLine.ignore = labelLine.normalIgnore = labelLine.hoverIgnore = true;
	    return;
	  }
	
	  var targetLineShape = {
	    points: labelLayout.linePoints || [[labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y], [labelLayout.x, labelLayout.y]]
	  };
	  var targetTextStyle = {
	    x: labelLayout.x,
	    y: labelLayout.y
	  };
	
	  if (withAnimation) {
	    graphic.updateProps(labelLine, {
	      shape: targetLineShape
	    }, seriesModel, idx);
	    graphic.updateProps(labelText, {
	      style: targetTextStyle
	    }, seriesModel, idx);
	  } else {
	    labelLine.attr({
	      shape: targetLineShape
	    });
	    labelText.attr({
	      style: targetTextStyle
	    });
	  }
	
	  labelText.attr({
	    rotation: labelLayout.rotation,
	    origin: [labelLayout.x, labelLayout.y],
	    z2: 10
	  });
	  var labelModel = itemModel.getModel('label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelLineModel = itemModel.getModel('labelLine');
	  var labelLineHoverModel = itemModel.getModel('emphasis.labelLine');
	  var visualColor = data.getItemVisual(idx, 'color');
	  graphic.setLabelStyle(labelText.style, labelText.hoverStyle = {}, labelModel, labelHoverModel, {
	    labelFetcher: data.hostModel,
	    labelDataIndex: idx,
	    defaultText: labelLayout.text,
	    autoColor: visualColor,
	    useInsideStyle: !!labelLayout.inside
	  }, {
	    textAlign: labelLayout.textAlign,
	    textVerticalAlign: labelLayout.verticalAlign,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelText.ignore = labelText.normalIgnore = !labelModel.get('show');
	  labelText.hoverIgnore = !labelHoverModel.get('show');
	  labelLine.ignore = labelLine.normalIgnore = !labelLineModel.get('show');
	  labelLine.hoverIgnore = !labelLineHoverModel.get('show'); // Default use item visual color
	
	  labelLine.setStyle({
	    stroke: visualColor,
	    opacity: data.getItemVisual(idx, 'opacity')
	  });
	  labelLine.setStyle(labelLineModel.getModel('lineStyle').getLineStyle());
	  labelLine.hoverStyle = labelLineHoverModel.getModel('lineStyle').getLineStyle();
	  var smooth = labelLineModel.get('smooth');
	
	  if (smooth && smooth === true) {
	    smooth = 0.4;
	  }
	
	  labelLine.setShape({
	    smooth: smooth
	  });
	};
	
	zrUtil.inherits(PiePiece, graphic.Group); // Pie view
	
	var PieView = ChartView.extend({
	  type: 'pie',
	  init: function () {
	    var sectorGroup = new graphic.Group();
	    this._sectorGroup = sectorGroup;
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    if (payload && payload.from === this.uid) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var oldData = this._data;
	    var group = this.group;
	    var hasAnimation = ecModel.get('animation');
	    var isFirstRender = !oldData;
	    var animationType = seriesModel.get('animationType');
	    var animationTypeUpdate = seriesModel.get('animationTypeUpdate');
	    var onSectorClick = zrUtil.curry(updateDataSelected, this.uid, seriesModel, hasAnimation, api);
	    var selectedMode = seriesModel.get('selectedMode');
	    data.diff(oldData).add(function (idx) {
	      var piePiece = new PiePiece(data, idx); // Default expansion animation
	
	      if (isFirstRender && animationType !== 'scale') {
	        piePiece.eachChild(function (child) {
	          child.stopAnimation(true);
	        });
	      }
	
	      selectedMode && piePiece.on('click', onSectorClick);
	      data.setItemGraphicEl(idx, piePiece);
	      group.add(piePiece);
	    }).update(function (newIdx, oldIdx) {
	      var piePiece = oldData.getItemGraphicEl(oldIdx);
	
	      if (!isFirstRender && animationTypeUpdate !== 'transition') {
	        piePiece.eachChild(function (child) {
	          child.stopAnimation(true);
	        });
	      }
	
	      piePiece.updateData(data, newIdx);
	      piePiece.off('click');
	      selectedMode && piePiece.on('click', onSectorClick);
	      group.add(piePiece);
	      data.setItemGraphicEl(newIdx, piePiece);
	    }).remove(function (idx) {
	      var piePiece = oldData.getItemGraphicEl(idx);
	      group.remove(piePiece);
	    }).execute();
	
	    if (hasAnimation && data.count() > 0 && (isFirstRender ? animationType !== 'scale' : animationTypeUpdate !== 'transition')) {
	      var shape = data.getItemLayout(0);
	
	      for (var s = 1; isNaN(shape.startAngle) && s < data.count(); ++s) {
	        shape = data.getItemLayout(s);
	      }
	
	      var r = Math.max(api.getWidth(), api.getHeight()) / 2;
	      var removeClipPath = zrUtil.bind(group.removeClipPath, group);
	      group.setClipPath(this._createClipPath(shape.cx, shape.cy, r, shape.startAngle, shape.clockwise, removeClipPath, seriesModel, isFirstRender));
	    } else {
	      // clipPath is used in first-time animation, so remove it when otherwise. See: #8994
	      group.removeClipPath();
	    }
	
	    this._data = data;
	  },
	  dispose: function () {},
	  _createClipPath: function (cx, cy, r, startAngle, clockwise, cb, seriesModel, isFirstRender) {
	    var clipPath = new graphic.Sector({
	      shape: {
	        cx: cx,
	        cy: cy,
	        r0: 0,
	        r: r,
	        startAngle: startAngle,
	        endAngle: startAngle,
	        clockwise: clockwise
	      }
	    });
	    var initOrUpdate = isFirstRender ? graphic.initProps : graphic.updateProps;
	    initOrUpdate(clipPath, {
	      shape: {
	        endAngle: startAngle + (clockwise ? 1 : -1) * Math.PI * 2
	      }
	    }, seriesModel, cb);
	    return clipPath;
	  },
	
	  /**
	   * @implement
	   */
	  containPoint: function (point, seriesModel) {
	    var data = seriesModel.getData();
	    var itemLayout = data.getItemLayout(0);
	
	    if (itemLayout) {
	      var dx = point[0] - itemLayout.cx;
	      var dy = point[1] - itemLayout.cy;
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      return radius <= itemLayout.r && radius >= itemLayout.r0;
	    }
	  }
	});
	var _default = PieView;
	module.exports = _default;

/***/ },
/* 2272 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var textContain = __webpack_require__(102);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME emphasis label position is not same with normal label position
	var RADIAN = Math.PI / 180;
	
	function adjustSingleSide(list, cx, cy, r, dir, viewWidth, viewHeight, viewLeft, viewTop, farthestX) {
	  list.sort(function (a, b) {
	    return a.y - b.y;
	  });
	
	  function shiftDown(start, end, delta, dir) {
	    for (var j = start; j < end; j++) {
	      if (list[j].y + delta > viewTop + viewHeight) {
	        break;
	      }
	
	      list[j].y += delta;
	
	      if (j > start && j + 1 < end && list[j + 1].y > list[j].y + list[j].height) {
	        shiftUp(j, delta / 2);
	        return;
	      }
	    }
	
	    shiftUp(end - 1, delta / 2);
	  }
	
	  function shiftUp(end, delta) {
	    for (var j = end; j >= 0; j--) {
	      if (list[j].y - delta < viewTop) {
	        break;
	      }
	
	      list[j].y -= delta;
	
	      if (j > 0 && list[j].y > list[j - 1].y + list[j - 1].height) {
	        break;
	      }
	    }
	  }
	
	  function changeX(list, isDownList, cx, cy, r, dir) {
	    var lastDeltaX = dir > 0 ? isDownList // right-side
	    ? Number.MAX_VALUE // down
	    : 0 // up
	    : isDownList // left-side
	    ? Number.MAX_VALUE // down
	    : 0; // up
	
	    for (var i = 0, l = list.length; i < l; i++) {
	      if (list[i].labelAlignTo !== 'none') {
	        continue;
	      }
	
	      var deltaY = Math.abs(list[i].y - cy);
	      var length = list[i].len;
	      var length2 = list[i].len2;
	      var deltaX = deltaY < r + length ? Math.sqrt((r + length + length2) * (r + length + length2) - deltaY * deltaY) : Math.abs(list[i].x - cx);
	
	      if (isDownList && deltaX >= lastDeltaX) {
	        // right-down, left-down
	        deltaX = lastDeltaX - 10;
	      }
	
	      if (!isDownList && deltaX <= lastDeltaX) {
	        // right-up, left-up
	        deltaX = lastDeltaX + 10;
	      }
	
	      list[i].x = cx + deltaX * dir;
	      lastDeltaX = deltaX;
	    }
	  }
	
	  var lastY = 0;
	  var delta;
	  var len = list.length;
	  var upList = [];
	  var downList = [];
	
	  for (var i = 0; i < len; i++) {
	    if (list[i].position === 'outer' && list[i].labelAlignTo === 'labelLine') {
	      var dx = list[i].x - farthestX;
	      list[i].linePoints[1][0] += dx;
	      list[i].x = farthestX;
	    }
	
	    delta = list[i].y - lastY;
	
	    if (delta < 0) {
	      shiftDown(i, len, -delta, dir);
	    }
	
	    lastY = list[i].y + list[i].height;
	  }
	
	  if (viewHeight - lastY < 0) {
	    shiftUp(len - 1, lastY - viewHeight);
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (list[i].y >= cy) {
	      downList.push(list[i]);
	    } else {
	      upList.push(list[i]);
	    }
	  }
	
	  changeX(upList, false, cx, cy, r, dir);
	  changeX(downList, true, cx, cy, r, dir);
	}
	
	function avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop) {
	  var leftList = [];
	  var rightList = [];
	  var leftmostX = Number.MAX_VALUE;
	  var rightmostX = -Number.MAX_VALUE;
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    if (isPositionCenter(labelLayoutList[i])) {
	      continue;
	    }
	
	    if (labelLayoutList[i].x < cx) {
	      leftmostX = Math.min(leftmostX, labelLayoutList[i].x);
	      leftList.push(labelLayoutList[i]);
	    } else {
	      rightmostX = Math.max(rightmostX, labelLayoutList[i].x);
	      rightList.push(labelLayoutList[i]);
	    }
	  }
	
	  adjustSingleSide(rightList, cx, cy, r, 1, viewWidth, viewHeight, viewLeft, viewTop, rightmostX);
	  adjustSingleSide(leftList, cx, cy, r, -1, viewWidth, viewHeight, viewLeft, viewTop, leftmostX);
	
	  for (var i = 0; i < labelLayoutList.length; i++) {
	    var layout = labelLayoutList[i];
	
	    if (isPositionCenter(layout)) {
	      continue;
	    }
	
	    var linePoints = layout.linePoints;
	
	    if (linePoints) {
	      var isAlignToEdge = layout.labelAlignTo === 'edge';
	      var realTextWidth = layout.textRect.width;
	      var targetTextWidth;
	
	      if (isAlignToEdge) {
	        if (layout.x < cx) {
	          targetTextWidth = linePoints[2][0] - layout.labelDistance - viewLeft - layout.labelMargin;
	        } else {
	          targetTextWidth = viewLeft + viewWidth - layout.labelMargin - linePoints[2][0] - layout.labelDistance;
	        }
	      } else {
	        if (layout.x < cx) {
	          targetTextWidth = layout.x - viewLeft - layout.bleedMargin;
	        } else {
	          targetTextWidth = viewLeft + viewWidth - layout.x - layout.bleedMargin;
	        }
	      }
	
	      if (targetTextWidth < layout.textRect.width) {
	        layout.text = textContain.truncateText(layout.text, targetTextWidth, layout.font);
	
	        if (layout.labelAlignTo === 'edge') {
	          realTextWidth = textContain.getWidth(layout.text, layout.font);
	        }
	      }
	
	      var dist = linePoints[1][0] - linePoints[2][0];
	
	      if (isAlignToEdge) {
	        if (layout.x < cx) {
	          linePoints[2][0] = viewLeft + layout.labelMargin + realTextWidth + layout.labelDistance;
	        } else {
	          linePoints[2][0] = viewLeft + viewWidth - layout.labelMargin - realTextWidth - layout.labelDistance;
	        }
	      } else {
	        if (layout.x < cx) {
	          linePoints[2][0] = layout.x + layout.labelDistance;
	        } else {
	          linePoints[2][0] = layout.x - layout.labelDistance;
	        }
	
	        linePoints[1][0] = linePoints[2][0] + dist;
	      }
	
	      linePoints[1][1] = linePoints[2][1] = layout.y;
	    }
	  }
	}
	
	function isPositionCenter(layout) {
	  // Not change x for center label
	  return layout.position === 'center';
	}
	
	function _default(seriesModel, r, viewWidth, viewHeight, viewLeft, viewTop) {
	  var data = seriesModel.getData();
	  var labelLayoutList = [];
	  var cx;
	  var cy;
	  var hasLabelRotate = false;
	  var minShowLabelRadian = (seriesModel.get('minShowLabelAngle') || 0) * RADIAN;
	  data.each(function (idx) {
	    var layout = data.getItemLayout(idx);
	    var itemModel = data.getItemModel(idx);
	    var labelModel = itemModel.getModel('label'); // Use position in normal or emphasis
	
	    var labelPosition = labelModel.get('position') || itemModel.get('emphasis.label.position');
	    var labelDistance = labelModel.get('distanceToLabelLine');
	    var labelAlignTo = labelModel.get('alignTo');
	    var labelMargin = parsePercent(labelModel.get('margin'), viewWidth);
	    var bleedMargin = labelModel.get('bleedMargin');
	    var font = labelModel.getFont();
	    var labelLineModel = itemModel.getModel('labelLine');
	    var labelLineLen = labelLineModel.get('length');
	    labelLineLen = parsePercent(labelLineLen, viewWidth);
	    var labelLineLen2 = labelLineModel.get('length2');
	    labelLineLen2 = parsePercent(labelLineLen2, viewWidth);
	
	    if (layout.angle < minShowLabelRadian) {
	      return;
	    }
	
	    var midAngle = (layout.startAngle + layout.endAngle) / 2;
	    var dx = Math.cos(midAngle);
	    var dy = Math.sin(midAngle);
	    var textX;
	    var textY;
	    var linePoints;
	    var textAlign;
	    cx = layout.cx;
	    cy = layout.cy;
	    var text = seriesModel.getFormattedLabel(idx, 'normal') || data.getName(idx);
	    var textRect = textContain.getBoundingRect(text, font, textAlign, 'top');
	    var isLabelInside = labelPosition === 'inside' || labelPosition === 'inner';
	
	    if (labelPosition === 'center') {
	      textX = layout.cx;
	      textY = layout.cy;
	      textAlign = 'center';
	    } else {
	      var x1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dx : layout.r * dx) + cx;
	      var y1 = (isLabelInside ? (layout.r + layout.r0) / 2 * dy : layout.r * dy) + cy;
	      textX = x1 + dx * 3;
	      textY = y1 + dy * 3;
	
	      if (!isLabelInside) {
	        // For roseType
	        var x2 = x1 + dx * (labelLineLen + r - layout.r);
	        var y2 = y1 + dy * (labelLineLen + r - layout.r);
	        var x3 = x2 + (dx < 0 ? -1 : 1) * labelLineLen2;
	        var y3 = y2;
	
	        if (labelAlignTo === 'edge') {
	          // Adjust textX because text align of edge is opposite
	          textX = dx < 0 ? viewLeft + labelMargin : viewLeft + viewWidth - labelMargin;
	        } else {
	          textX = x3 + (dx < 0 ? -labelDistance : labelDistance);
	        }
	
	        textY = y3;
	        linePoints = [[x1, y1], [x2, y2], [x3, y3]];
	      }
	
	      textAlign = isLabelInside ? 'center' : labelAlignTo === 'edge' ? dx > 0 ? 'right' : 'left' : dx > 0 ? 'left' : 'right';
	    }
	
	    var labelRotate;
	    var rotate = labelModel.get('rotate');
	
	    if (typeof rotate === 'number') {
	      labelRotate = rotate * (Math.PI / 180);
	    } else {
	      labelRotate = rotate ? dx < 0 ? -midAngle + Math.PI : -midAngle : 0;
	    }
	
	    hasLabelRotate = !!labelRotate;
	    layout.label = {
	      x: textX,
	      y: textY,
	      position: labelPosition,
	      height: textRect.height,
	      len: labelLineLen,
	      len2: labelLineLen2,
	      linePoints: linePoints,
	      textAlign: textAlign,
	      verticalAlign: 'middle',
	      rotation: labelRotate,
	      inside: isLabelInside,
	      labelDistance: labelDistance,
	      labelAlignTo: labelAlignTo,
	      labelMargin: labelMargin,
	      bleedMargin: bleedMargin,
	      textRect: textRect,
	      text: text,
	      font: font
	    }; // Not layout the inside label
	
	    if (!isLabelInside) {
	      labelLayoutList.push(layout.label);
	    }
	  });
	
	  if (!hasLabelRotate && seriesModel.get('avoidLabelOverlap')) {
	    avoidOverlap(labelLayoutList, cx, cy, r, viewWidth, viewHeight, viewLeft, viewTop);
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2273 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	var linearMap = _number.linearMap;
	
	var layout = __webpack_require__(46);
	
	var labelLayout = __webpack_require__(2272);
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI2 = Math.PI * 2;
	var RADIAN = Math.PI / 180;
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function _default(seriesType, ecModel, api, payload) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var data = seriesModel.getData();
	    var valueDim = data.mapDimension('value');
	    var viewRect = getViewRect(seriesModel, api);
	    var center = seriesModel.get('center');
	    var radius = seriesModel.get('radius');
	
	    if (!zrUtil.isArray(radius)) {
	      radius = [0, radius];
	    }
	
	    if (!zrUtil.isArray(center)) {
	      center = [center, center];
	    }
	
	    var width = parsePercent(viewRect.width, api.getWidth());
	    var height = parsePercent(viewRect.height, api.getHeight());
	    var size = Math.min(width, height);
	    var cx = parsePercent(center[0], width) + viewRect.x;
	    var cy = parsePercent(center[1], height) + viewRect.y;
	    var r0 = parsePercent(radius[0], size / 2);
	    var r = parsePercent(radius[1], size / 2);
	    var startAngle = -seriesModel.get('startAngle') * RADIAN;
	    var minAngle = seriesModel.get('minAngle') * RADIAN;
	    var validDataCount = 0;
	    data.each(valueDim, function (value) {
	      !isNaN(value) && validDataCount++;
	    });
	    var sum = data.getSum(valueDim); // Sum may be 0
	
	    var unitRadian = Math.PI / (sum || validDataCount) * 2;
	    var clockwise = seriesModel.get('clockwise');
	    var roseType = seriesModel.get('roseType');
	    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // [0...max]
	
	    var extent = data.getDataExtent(valueDim);
	    extent[0] = 0; // In the case some sector angle is smaller than minAngle
	
	    var restAngle = PI2;
	    var valueSumLargerThanMinAngle = 0;
	    var currentAngle = startAngle;
	    var dir = clockwise ? 1 : -1;
	    data.each(valueDim, function (value, idx) {
	      var angle;
	
	      if (isNaN(value)) {
	        data.setItemLayout(idx, {
	          angle: NaN,
	          startAngle: NaN,
	          endAngle: NaN,
	          clockwise: clockwise,
	          cx: cx,
	          cy: cy,
	          r0: r0,
	          r: roseType ? NaN : r,
	          viewRect: viewRect
	        });
	        return;
	      } // FIXME 兼容 2.0 但是 roseType 是 area 的时候才是这样？
	
	
	      if (roseType !== 'area') {
	        angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	      } else {
	        angle = PI2 / validDataCount;
	      }
	
	      if (angle < minAngle) {
	        angle = minAngle;
	        restAngle -= minAngle;
	      } else {
	        valueSumLargerThanMinAngle += value;
	      }
	
	      var endAngle = currentAngle + dir * angle;
	      data.setItemLayout(idx, {
	        angle: angle,
	        startAngle: currentAngle,
	        endAngle: endAngle,
	        clockwise: clockwise,
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: roseType ? linearMap(value, extent, [r0, r]) : r,
	        viewRect: viewRect
	      });
	      currentAngle = endAngle;
	    }); // Some sector is constrained by minAngle
	    // Rest sectors needs recalculate angle
	
	    if (restAngle < PI2 && validDataCount) {
	      // Average the angle if rest angle is not enough after all angles is
	      // Constrained by minAngle
	      if (restAngle <= 1e-3) {
	        var angle = PI2 / validDataCount;
	        data.each(valueDim, function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            layout.angle = angle;
	            layout.startAngle = startAngle + dir * idx * angle;
	            layout.endAngle = startAngle + dir * (idx + 1) * angle;
	          }
	        });
	      } else {
	        unitRadian = restAngle / valueSumLargerThanMinAngle;
	        currentAngle = startAngle;
	        data.each(valueDim, function (value, idx) {
	          if (!isNaN(value)) {
	            var layout = data.getItemLayout(idx);
	            var angle = layout.angle === minAngle ? minAngle : value * unitRadian;
	            layout.startAngle = currentAngle;
	            layout.endAngle = currentAngle + dir * angle;
	            currentAngle += dir * angle;
	          }
	        });
	      }
	    }
	
	    labelLayout(seriesModel, r, viewRect.width, viewRect.height, viewRect.x, viewRect.y);
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2274 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2364);
	
	__webpack_require__(2275);
	
	__webpack_require__(2276);
	
	var dataColor = __webpack_require__(363);
	
	var visualSymbol = __webpack_require__(214);
	
	var radarLayout = __webpack_require__(2278);
	
	var dataFilter = __webpack_require__(296);
	
	var backwardCompat = __webpack_require__(2277);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Must use radar component
	echarts.registerVisual(dataColor('radar'));
	echarts.registerVisual(visualSymbol('radar', 'circle'));
	echarts.registerLayout(radarLayout);
	echarts.registerProcessor(dataFilter('radar'));
	echarts.registerPreprocessor(backwardCompat);

/***/ },
/* 2275 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(77);
	
	var createListSimply = __webpack_require__(245);
	
	var zrUtil = __webpack_require__(4);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var LegendVisualProvider = __webpack_require__(298);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var RadarSeries = SeriesModel.extend({
	  type: 'series.radar',
	  dependencies: ['radar'],
	  // Overwrite
	  init: function (option) {
	    RadarSeries.superApply(this, 'init', arguments); // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	  },
	  getInitialData: function (option, ecModel) {
	    return createListSimply(this, {
	      generateCoord: 'indicator_',
	      generateCoordCount: Infinity
	    });
	  },
	  formatTooltip: function (dataIndex, multipleSeries, dataType, renderMode) {
	    var data = this.getData();
	    var coordSys = this.coordinateSystem;
	    var indicatorAxes = coordSys.getIndicatorAxes();
	    var name = this.getData().getName(dataIndex);
	    var newLine = renderMode === 'html' ? '<br/>' : '\n';
	    return encodeHTML(name === '' ? this.name : name) + newLine + zrUtil.map(indicatorAxes, function (axis, idx) {
	      var val = data.get(data.mapDimension(axis.dim), dataIndex);
	      return encodeHTML(axis.name + ' : ' + val);
	    }).join(newLine);
	  },
	
	  /**
	   * @implement
	   */
	  getTooltipPosition: function (dataIndex) {
	    if (dataIndex != null) {
	      var data = this.getData();
	      var coordSys = this.coordinateSystem;
	      var values = data.getValues(zrUtil.map(coordSys.dimensions, function (dim) {
	        return data.mapDimension(dim);
	      }), dataIndex, true);
	
	      for (var i = 0, len = values.length; i < len; i++) {
	        if (!isNaN(values[i])) {
	          var indicatorAxes = coordSys.getIndicatorAxes();
	          return coordSys.coordToPoint(indicatorAxes[i].dataToCoord(values[i]), i);
	        }
	      }
	    }
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'radar',
	    legendHoverLink: true,
	    radarIndex: 0,
	    lineStyle: {
	      width: 2,
	      type: 'solid'
	    },
	    label: {
	      position: 'top'
	    },
	    // areaStyle: {
	    // },
	    // itemStyle: {}
	    symbol: 'emptyCircle',
	    symbolSize: 4 // symbolRotate: null
	
	  }
	});
	var _default = RadarSeries;
	module.exports = _default;

/***/ },
/* 2276 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var graphic = __webpack_require__(14);
	
	var zrUtil = __webpack_require__(4);
	
	var symbolUtil = __webpack_require__(110);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function normalizeSymbolSize(symbolSize) {
	  if (!zrUtil.isArray(symbolSize)) {
	    symbolSize = [+symbolSize, +symbolSize];
	  }
	
	  return symbolSize;
	}
	
	var _default = echarts.extendChartView({
	  type: 'radar',
	  render: function (seriesModel, ecModel, api) {
	    var polar = seriesModel.coordinateSystem;
	    var group = this.group;
	    var data = seriesModel.getData();
	    var oldData = this._data;
	
	    function createSymbol(data, idx) {
	      var symbolType = data.getItemVisual(idx, 'symbol') || 'circle';
	      var color = data.getItemVisual(idx, 'color');
	
	      if (symbolType === 'none') {
	        return;
	      }
	
	      var symbolSize = normalizeSymbolSize(data.getItemVisual(idx, 'symbolSize'));
	      var symbolPath = symbolUtil.createSymbol(symbolType, -1, -1, 2, 2, color);
	      var symbolRotate = data.getItemVisual(idx, 'symbolRotate') || 0;
	      symbolPath.attr({
	        style: {
	          strokeNoScale: true
	        },
	        z2: 100,
	        scale: [symbolSize[0] / 2, symbolSize[1] / 2],
	        rotation: symbolRotate * Math.PI / 180 || 0
	      });
	      return symbolPath;
	    }
	
	    function updateSymbols(oldPoints, newPoints, symbolGroup, data, idx, isInit) {
	      // Simply rerender all
	      symbolGroup.removeAll();
	
	      for (var i = 0; i < newPoints.length - 1; i++) {
	        var symbolPath = createSymbol(data, idx);
	
	        if (symbolPath) {
	          symbolPath.__dimIdx = i;
	
	          if (oldPoints[i]) {
	            symbolPath.attr('position', oldPoints[i]);
	            graphic[isInit ? 'initProps' : 'updateProps'](symbolPath, {
	              position: newPoints[i]
	            }, seriesModel, idx);
	          } else {
	            symbolPath.attr('position', newPoints[i]);
	          }
	
	          symbolGroup.add(symbolPath);
	        }
	      }
	    }
	
	    function getInitialPoints(points) {
	      return zrUtil.map(points, function (pt) {
	        return [polar.cx, polar.cy];
	      });
	    }
	
	    data.diff(oldData).add(function (idx) {
	      var points = data.getItemLayout(idx);
	
	      if (!points) {
	        return;
	      }
	
	      var polygon = new graphic.Polygon();
	      var polyline = new graphic.Polyline();
	      var target = {
	        shape: {
	          points: points
	        }
	      };
	      polygon.shape.points = getInitialPoints(points);
	      polyline.shape.points = getInitialPoints(points);
	      graphic.initProps(polygon, target, seriesModel, idx);
	      graphic.initProps(polyline, target, seriesModel, idx);
	      var itemGroup = new graphic.Group();
	      var symbolGroup = new graphic.Group();
	      itemGroup.add(polyline);
	      itemGroup.add(polygon);
	      itemGroup.add(symbolGroup);
	      updateSymbols(polyline.shape.points, points, symbolGroup, data, idx, true);
	      data.setItemGraphicEl(idx, itemGroup);
	    }).update(function (newIdx, oldIdx) {
	      var itemGroup = oldData.getItemGraphicEl(oldIdx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var target = {
	        shape: {
	          points: data.getItemLayout(newIdx)
	        }
	      };
	
	      if (!target.shape.points) {
	        return;
	      }
	
	      updateSymbols(polyline.shape.points, target.shape.points, symbolGroup, data, newIdx, false);
	      graphic.updateProps(polyline, target, seriesModel);
	      graphic.updateProps(polygon, target, seriesModel);
	      data.setItemGraphicEl(newIdx, itemGroup);
	    }).remove(function (idx) {
	      group.remove(oldData.getItemGraphicEl(idx));
	    }).execute();
	    data.eachItemGraphicEl(function (itemGroup, idx) {
	      var itemModel = data.getItemModel(idx);
	      var polyline = itemGroup.childAt(0);
	      var polygon = itemGroup.childAt(1);
	      var symbolGroup = itemGroup.childAt(2);
	      var color = data.getItemVisual(idx, 'color');
	      group.add(itemGroup);
	      polyline.useStyle(zrUtil.defaults(itemModel.getModel('lineStyle').getLineStyle(), {
	        fill: 'none',
	        stroke: color
	      }));
	      polyline.hoverStyle = itemModel.getModel('emphasis.lineStyle').getLineStyle();
	      var areaStyleModel = itemModel.getModel('areaStyle');
	      var hoverAreaStyleModel = itemModel.getModel('emphasis.areaStyle');
	      var polygonIgnore = areaStyleModel.isEmpty() && areaStyleModel.parentModel.isEmpty();
	      var hoverPolygonIgnore = hoverAreaStyleModel.isEmpty() && hoverAreaStyleModel.parentModel.isEmpty();
	      hoverPolygonIgnore = hoverPolygonIgnore && polygonIgnore;
	      polygon.ignore = polygonIgnore;
	      polygon.useStyle(zrUtil.defaults(areaStyleModel.getAreaStyle(), {
	        fill: color,
	        opacity: 0.7
	      }));
	      polygon.hoverStyle = hoverAreaStyleModel.getAreaStyle();
	      var itemStyle = itemModel.getModel('itemStyle').getItemStyle(['color']);
	      var itemHoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      symbolGroup.eachChild(function (symbolPath) {
	        symbolPath.setStyle(itemStyle);
	        symbolPath.hoverStyle = zrUtil.clone(itemHoverStyle);
	        var defaultText = data.get(data.dimensions[symbolPath.__dimIdx], idx);
	        (defaultText == null || isNaN(defaultText)) && (defaultText = '');
	        graphic.setLabelStyle(symbolPath.style, symbolPath.hoverStyle, labelModel, labelHoverModel, {
	          labelFetcher: data.hostModel,
	          labelDataIndex: idx,
	          labelDimIndex: symbolPath.__dimIdx,
	          defaultText: defaultText,
	          autoColor: color,
	          isRectText: true
	        });
	      });
	
	      itemGroup.highDownOnUpdate = function (fromState, toState) {
	        polygon.attr('ignore', toState === 'emphasis' ? hoverPolygonIgnore : polygonIgnore);
	      };
	
	      graphic.setHoverStyle(itemGroup);
	    });
	    this._data = data;
	  },
	  remove: function () {
	    this.group.removeAll();
	    this._data = null;
	  },
	  dispose: function () {}
	});
	
	module.exports = _default;

/***/ },
/* 2277 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Backward compat for radar chart in 2
	function _default(option) {
	  var polarOptArr = option.polar;
	
	  if (polarOptArr) {
	    if (!zrUtil.isArray(polarOptArr)) {
	      polarOptArr = [polarOptArr];
	    }
	
	    var polarNotRadar = [];
	    zrUtil.each(polarOptArr, function (polarOpt, idx) {
	      if (polarOpt.indicator) {
	        if (polarOpt.type && !polarOpt.shape) {
	          polarOpt.shape = polarOpt.type;
	        }
	
	        option.radar = option.radar || [];
	
	        if (!zrUtil.isArray(option.radar)) {
	          option.radar = [option.radar];
	        }
	
	        option.radar.push(polarOpt);
	      } else {
	        polarNotRadar.push(polarOpt);
	      }
	    });
	    option.polar = polarNotRadar;
	  }
	
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'radar' && seriesOpt.polarIndex) {
	      seriesOpt.radarIndex = seriesOpt.polarIndex;
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2278 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('radar', function (seriesModel) {
	    var data = seriesModel.getData();
	    var points = [];
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (!coordSys) {
	      return;
	    }
	
	    var axes = coordSys.getIndicatorAxes();
	    zrUtil.each(axes, function (axis, axisIndex) {
	      data.each(data.mapDimension(axes[axisIndex].dim), function (val, dataIndex) {
	        points[dataIndex] = points[dataIndex] || [];
	        var point = coordSys.dataToPoint(val, axisIndex);
	        points[dataIndex][axisIndex] = isValidPoint(point) ? point : getValueMissingPoint(coordSys);
	      });
	    }); // Close polygon
	
	    data.each(function (idx) {
	      // TODO
	      // Is it appropriate to connect to the next data when some data is missing?
	      // Or, should trade it like `connectNull` in line chart?
	      var firstPoint = zrUtil.find(points[idx], function (point) {
	        return isValidPoint(point);
	      }) || getValueMissingPoint(coordSys); // Copy the first actual point to the end of the array
	
	      points[idx].push(firstPoint.slice());
	      data.setItemLayout(idx, points[idx]);
	    });
	  });
	}
	
	function isValidPoint(point) {
	  return !isNaN(point[0]) && !isNaN(point[1]);
	}
	
	function getValueMissingPoint(coordSys) {
	  // It is error-prone to input [NaN, NaN] into polygon, polygon.
	  // (probably cause problem when refreshing or animating)
	  return [coordSys.cx, coordSys.cy];
	}
	
	module.exports = _default;

/***/ },
/* 2279 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2280);
	
	__webpack_require__(2281);
	
	__webpack_require__(2282);
	
	var sankeyLayout = __webpack_require__(2283);
	
	var sankeyVisual = __webpack_require__(2284);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(sankeyLayout);
	echarts.registerVisual(sankeyVisual);

/***/ },
/* 2280 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(77);
	
	var createGraphFromNodeEdge = __webpack_require__(827);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var Model = __webpack_require__(70);
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SankeySeries = SeriesModel.extend({
	  type: 'series.sankey',
	  layoutInfo: null,
	  levelModels: null,
	
	  /**
	   * Init a graph data structure from data in option series
	   *
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option, ecModel) {
	    var links = option.edges || option.links;
	    var nodes = option.data || option.nodes;
	    var levels = option.levels;
	    var levelModels = this.levelModels = {};
	
	    for (var i = 0; i < levels.length; i++) {
	      if (levels[i].depth != null && levels[i].depth >= 0) {
	        levelModels[levels[i].depth] = new Model(levels[i], this, ecModel);
	      } else {}
	    }
	
	    if (nodes && links) {
	      var graph = createGraphFromNodeEdge(nodes, links, this, true, beforeLink);
	      return graph.data;
	    }
	
	    function beforeLink(nodeData, edgeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        model.customizeGetParent(function (path) {
	          var parentModel = this.parentModel;
	          var nodeDepth = parentModel.getData().getItemLayout(idx).depth;
	          var levelModel = parentModel.levelModels[nodeDepth];
	          return levelModel || this.parentModel;
	        });
	        return model;
	      });
	      edgeData.wrapMethod('getItemModel', function (model, idx) {
	        model.customizeGetParent(function (path) {
	          var parentModel = this.parentModel;
	          var edge = parentModel.getGraph().getEdgeByIndex(idx);
	          var depth = edge.node1.getLayout().depth;
	          var levelModel = parentModel.levelModels[depth];
	          return levelModel || this.parentModel;
	        });
	        return model;
	      });
	    }
	  },
	  setNodePosition: function (dataIndex, localPosition) {
	    var dataItem = this.option.data[dataIndex];
	    dataItem.localX = localPosition[0];
	    dataItem.localY = localPosition[1];
	  },
	
	  /**
	   * Return the graphic data structure
	   *
	   * @return {module:echarts/data/Graph} graphic data structure
	   */
	  getGraph: function () {
	    return this.getData().graph;
	  },
	
	  /**
	   * Get edge data of graphic data structure
	   *
	   * @return {module:echarts/data/List} data structure of list
	   */
	  getEdgeData: function () {
	    return this.getGraph().edgeData;
	  },
	
	  /**
	   * @override
	   */
	  formatTooltip: function (dataIndex, multipleSeries, dataType) {
	    // dataType === 'node' or empty do not show tooltip by default
	    if (dataType === 'edge') {
	      var params = this.getDataParams(dataIndex, dataType);
	      var rawDataOpt = params.data;
	      var html = rawDataOpt.source + ' -- ' + rawDataOpt.target;
	
	      if (params.value) {
	        html += ' : ' + params.value;
	      }
	
	      return encodeHTML(html);
	    } else if (dataType === 'node') {
	      var node = this.getGraph().getNodeByIndex(dataIndex);
	      var value = node.getLayout().value;
	      var name = this.getDataParams(dataIndex, dataType).data.name;
	
	      if (value) {
	        var html = name + ' : ' + value;
	      }
	
	      return encodeHTML(html);
	    }
	
	    return SankeySeries.superCall(this, 'formatTooltip', dataIndex, multipleSeries);
	  },
	  optionUpdated: function () {
	    var option = this.option;
	
	    if (option.focusNodeAdjacency === true) {
	      option.focusNodeAdjacency = 'allEdges';
	    }
	  },
	  // Override Series.getDataParams()
	  getDataParams: function (dataIndex, dataType) {
	    var params = SankeySeries.superCall(this, 'getDataParams', dataIndex, dataType);
	
	    if (params.value == null && dataType === 'node') {
	      var node = this.getGraph().getNodeByIndex(dataIndex);
	      var nodeValue = node.getLayout().value;
	      params.value = nodeValue;
	    }
	
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    layout: null,
	    // The position of the whole view
	    left: '5%',
	    top: '5%',
	    right: '20%',
	    bottom: '5%',
	    // Value can be 'vertical'
	    orient: 'horizontal',
	    // The dx of the node
	    nodeWidth: 20,
	    // The vertical distance between two nodes
	    nodeGap: 8,
	    // Control if the node can move or not
	    draggable: true,
	    // Value can be 'inEdges', 'outEdges', 'allEdges', true (the same as 'allEdges').
	    focusNodeAdjacency: false,
	    // The number of iterations to change the position of the node
	    layoutIterations: 32,
	    label: {
	      show: true,
	      position: 'right',
	      color: '#000',
	      fontSize: 12
	    },
	    levels: [],
	    // Value can be 'left' or 'right'
	    nodeAlign: 'justify',
	    itemStyle: {
	      borderWidth: 1,
	      borderColor: '#333'
	    },
	    lineStyle: {
	      color: '#314656',
	      opacity: 0.2,
	      curveness: 0.5
	    },
	    emphasis: {
	      label: {
	        show: true
	      },
	      lineStyle: {
	        opacity: 0.5
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 1000
	  }
	});
	var _default = SankeySeries;
	module.exports = _default;

/***/ },
/* 2281 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var nodeOpacityPath = ['itemStyle', 'opacity'];
	var hoverNodeOpacityPath = ['emphasis', 'itemStyle', 'opacity'];
	var lineOpacityPath = ['lineStyle', 'opacity'];
	var hoverLineOpacityPath = ['emphasis', 'lineStyle', 'opacity'];
	
	function getItemOpacity(item, opacityPath) {
	  return item.getVisual('opacity') || item.getModel().get(opacityPath);
	}
	
	function fadeOutItem(item, opacityPath, opacityRatio) {
	  var el = item.getGraphicEl();
	  var opacity = getItemOpacity(item, opacityPath);
	
	  if (opacityRatio != null) {
	    opacity == null && (opacity = 1);
	    opacity *= opacityRatio;
	  }
	
	  el.downplay && el.downplay();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  });
	}
	
	function fadeInItem(item, opacityPath) {
	  var opacity = getItemOpacity(item, opacityPath);
	  var el = item.getGraphicEl();
	  el.traverse(function (child) {
	    if (child.type !== 'group') {
	      child.setStyle('opacity', opacity);
	    }
	  }); // Support emphasis here.
	
	  el.highlight && el.highlight();
	}
	
	var SankeyShape = graphic.extendShape({
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    cpx2: 0,
	    cpy2: 0,
	    extent: 0,
	    orient: ''
	  },
	  buildPath: function (ctx, shape) {
	    var extent = shape.extent;
	    ctx.moveTo(shape.x1, shape.y1);
	    ctx.bezierCurveTo(shape.cpx1, shape.cpy1, shape.cpx2, shape.cpy2, shape.x2, shape.y2);
	
	    if (shape.orient === 'vertical') {
	      ctx.lineTo(shape.x2 + extent, shape.y2);
	      ctx.bezierCurveTo(shape.cpx2 + extent, shape.cpy2, shape.cpx1 + extent, shape.cpy1, shape.x1 + extent, shape.y1);
	    } else {
	      ctx.lineTo(shape.x2, shape.y2 + extent);
	      ctx.bezierCurveTo(shape.cpx2, shape.cpy2 + extent, shape.cpx1, shape.cpy1 + extent, shape.x1, shape.y1 + extent);
	    }
	
	    ctx.closePath();
	  },
	  highlight: function () {
	    this.trigger('emphasis');
	  },
	  downplay: function () {
	    this.trigger('normal');
	  }
	});
	
	var _default = echarts.extendChartView({
	  type: 'sankey',
	
	  /**
	   * @private
	   * @type {module:echarts/chart/sankey/SankeySeries}
	   */
	  _model: null,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _focusAdjacencyDisabled: false,
	  render: function (seriesModel, ecModel, api) {
	    var sankeyView = this;
	    var graph = seriesModel.getGraph();
	    var group = this.group;
	    var layoutInfo = seriesModel.layoutInfo; // view width
	
	    var width = layoutInfo.width; // view height
	
	    var height = layoutInfo.height;
	    var nodeData = seriesModel.getData();
	    var edgeData = seriesModel.getData('edge');
	    var orient = seriesModel.get('orient');
	    this._model = seriesModel;
	    group.removeAll();
	    group.attr('position', [layoutInfo.x, layoutInfo.y]); // generate a bezire Curve for each edge
	
	    graph.eachEdge(function (edge) {
	      var curve = new SankeyShape();
	      curve.dataIndex = edge.dataIndex;
	      curve.seriesIndex = seriesModel.seriesIndex;
	      curve.dataType = 'edge';
	      var lineStyleModel = edge.getModel('lineStyle');
	      var curvature = lineStyleModel.get('curveness');
	      var n1Layout = edge.node1.getLayout();
	      var node1Model = edge.node1.getModel();
	      var dragX1 = node1Model.get('localX');
	      var dragY1 = node1Model.get('localY');
	      var n2Layout = edge.node2.getLayout();
	      var node2Model = edge.node2.getModel();
	      var dragX2 = node2Model.get('localX');
	      var dragY2 = node2Model.get('localY');
	      var edgeLayout = edge.getLayout();
	      var x1;
	      var y1;
	      var x2;
	      var y2;
	      var cpx1;
	      var cpy1;
	      var cpx2;
	      var cpy2;
	      curve.shape.extent = Math.max(1, edgeLayout.dy);
	      curve.shape.orient = orient;
	
	      if (orient === 'vertical') {
	        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + edgeLayout.sy;
	        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + n1Layout.dy;
	        x2 = (dragX2 != null ? dragX2 * width : n2Layout.x) + edgeLayout.ty;
	        y2 = dragY2 != null ? dragY2 * height : n2Layout.y;
	        cpx1 = x1;
	        cpy1 = y1 * (1 - curvature) + y2 * curvature;
	        cpx2 = x2;
	        cpy2 = y1 * curvature + y2 * (1 - curvature);
	      } else {
	        x1 = (dragX1 != null ? dragX1 * width : n1Layout.x) + n1Layout.dx;
	        y1 = (dragY1 != null ? dragY1 * height : n1Layout.y) + edgeLayout.sy;
	        x2 = dragX2 != null ? dragX2 * width : n2Layout.x;
	        y2 = (dragY2 != null ? dragY2 * height : n2Layout.y) + edgeLayout.ty;
	        cpx1 = x1 * (1 - curvature) + x2 * curvature;
	        cpy1 = y1;
	        cpx2 = x1 * curvature + x2 * (1 - curvature);
	        cpy2 = y2;
	      }
	
	      curve.setShape({
	        x1: x1,
	        y1: y1,
	        x2: x2,
	        y2: y2,
	        cpx1: cpx1,
	        cpy1: cpy1,
	        cpx2: cpx2,
	        cpy2: cpy2
	      });
	      curve.setStyle(lineStyleModel.getItemStyle()); // Special color, use source node color or target node color
	
	      switch (curve.style.fill) {
	        case 'source':
	          curve.style.fill = edge.node1.getVisual('color');
	          break;
	
	        case 'target':
	          curve.style.fill = edge.node2.getVisual('color');
	          break;
	      }
	
	      graphic.setHoverStyle(curve, edge.getModel('emphasis.lineStyle').getItemStyle());
	      group.add(curve);
	      edgeData.setItemGraphicEl(edge.dataIndex, curve);
	    }); // Generate a rect for each node
	
	    graph.eachNode(function (node) {
	      var layout = node.getLayout();
	      var itemModel = node.getModel();
	      var dragX = itemModel.get('localX');
	      var dragY = itemModel.get('localY');
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      var rect = new graphic.Rect({
	        shape: {
	          x: dragX != null ? dragX * width : layout.x,
	          y: dragY != null ? dragY * height : layout.y,
	          width: layout.dx,
	          height: layout.dy
	        },
	        style: itemModel.getModel('itemStyle').getItemStyle()
	      });
	      var hoverStyle = node.getModel('emphasis.itemStyle').getItemStyle();
	      graphic.setLabelStyle(rect.style, hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: seriesModel,
	        labelDataIndex: node.dataIndex,
	        defaultText: node.id,
	        isRectText: true
	      });
	      rect.setStyle('fill', node.getVisual('color'));
	      graphic.setHoverStyle(rect, hoverStyle);
	      group.add(rect);
	      nodeData.setItemGraphicEl(node.dataIndex, rect);
	      rect.dataType = 'node';
	    });
	    nodeData.eachItemGraphicEl(function (el, dataIndex) {
	      var itemModel = nodeData.getItemModel(dataIndex);
	
	      if (itemModel.get('draggable')) {
	        el.drift = function (dx, dy) {
	          sankeyView._focusAdjacencyDisabled = true;
	          this.shape.x += dx;
	          this.shape.y += dy;
	          this.dirty();
	          api.dispatchAction({
	            type: 'dragNode',
	            seriesId: seriesModel.id,
	            dataIndex: nodeData.getRawIndex(dataIndex),
	            localX: this.shape.x / width,
	            localY: this.shape.y / height
	          });
	        };
	
	        el.ondragend = function () {
	          sankeyView._focusAdjacencyDisabled = false;
	        };
	
	        el.draggable = true;
	        el.cursor = 'move';
	      }
	
	      el.highlight = function () {
	        this.trigger('emphasis');
	      };
	
	      el.downplay = function () {
	        this.trigger('normal');
	      };
	
	      el.focusNodeAdjHandler && el.off('mouseover', el.focusNodeAdjHandler);
	      el.unfocusNodeAdjHandler && el.off('mouseout', el.unfocusNodeAdjHandler);
	
	      if (itemModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el.focusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._clearTimer();
	
	            api.dispatchAction({
	              type: 'focusNodeAdjacency',
	              seriesId: seriesModel.id,
	              dataIndex: el.dataIndex
	            });
	          }
	        });
	        el.on('mouseout', el.unfocusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._dispatchUnfocus(api);
	          }
	        });
	      }
	    });
	    edgeData.eachItemGraphicEl(function (el, dataIndex) {
	      var edgeModel = edgeData.getItemModel(dataIndex);
	      el.focusNodeAdjHandler && el.off('mouseover', el.focusNodeAdjHandler);
	      el.unfocusNodeAdjHandler && el.off('mouseout', el.unfocusNodeAdjHandler);
	
	      if (edgeModel.get('focusNodeAdjacency')) {
	        el.on('mouseover', el.focusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._clearTimer();
	
	            api.dispatchAction({
	              type: 'focusNodeAdjacency',
	              seriesId: seriesModel.id,
	              edgeDataIndex: el.dataIndex
	            });
	          }
	        });
	        el.on('mouseout', el.unfocusNodeAdjHandler = function () {
	          if (!sankeyView._focusAdjacencyDisabled) {
	            sankeyView._dispatchUnfocus(api);
	          }
	        });
	      }
	    });
	
	    if (!this._data && seriesModel.get('animation')) {
	      group.setClipPath(createGridClipShape(group.getBoundingRect(), seriesModel, function () {
	        group.removeClipPath();
	      }));
	    }
	
	    this._data = seriesModel.getData();
	  },
	  dispose: function () {
	    this._clearTimer();
	  },
	  _dispatchUnfocus: function (api) {
	    var self = this;
	
	    this._clearTimer();
	
	    this._unfocusDelayTimer = setTimeout(function () {
	      self._unfocusDelayTimer = null;
	      api.dispatchAction({
	        type: 'unfocusNodeAdjacency',
	        seriesId: self._model.id
	      });
	    }, 500);
	  },
	  _clearTimer: function () {
	    if (this._unfocusDelayTimer) {
	      clearTimeout(this._unfocusDelayTimer);
	      this._unfocusDelayTimer = null;
	    }
	  },
	  focusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var graph = data.graph;
	    var dataIndex = payload.dataIndex;
	    var itemModel = data.getItemModel(dataIndex);
	    var edgeDataIndex = payload.edgeDataIndex;
	
	    if (dataIndex == null && edgeDataIndex == null) {
	      return;
	    }
	
	    var node = graph.getNodeByIndex(dataIndex);
	    var edge = graph.getEdgeByIndex(edgeDataIndex);
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath, 0.1);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath, 0.1);
	    });
	
	    if (node) {
	      fadeInItem(node, hoverNodeOpacityPath);
	      var focusNodeAdj = itemModel.get('focusNodeAdjacency');
	
	      if (focusNodeAdj === 'outEdges') {
	        zrUtil.each(node.outEdges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          fadeInItem(edge.node2, hoverNodeOpacityPath);
	        });
	      } else if (focusNodeAdj === 'inEdges') {
	        zrUtil.each(node.inEdges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          fadeInItem(edge.node1, hoverNodeOpacityPath);
	        });
	      } else if (focusNodeAdj === 'allEdges') {
	        zrUtil.each(node.edges, function (edge) {
	          if (edge.dataIndex < 0) {
	            return;
	          }
	
	          fadeInItem(edge, hoverLineOpacityPath);
	          edge.node1 !== node && fadeInItem(edge.node1, hoverNodeOpacityPath);
	          edge.node2 !== node && fadeInItem(edge.node2, hoverNodeOpacityPath);
	        });
	      }
	    }
	
	    if (edge) {
	      fadeInItem(edge, hoverLineOpacityPath);
	      fadeInItem(edge.node1, hoverNodeOpacityPath);
	      fadeInItem(edge.node2, hoverNodeOpacityPath);
	    }
	  },
	  unfocusNodeAdjacency: function (seriesModel, ecModel, api, payload) {
	    var graph = seriesModel.getGraph();
	    graph.eachNode(function (node) {
	      fadeOutItem(node, nodeOpacityPath);
	    });
	    graph.eachEdge(function (edge) {
	      fadeOutItem(edge, lineOpacityPath);
	    });
	  }
	}); // Add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;

/***/ },
/* 2282 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(828);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'dragNode',
	  event: 'dragnode',
	  // here can only use 'update' now, other value is not support in echarts.
	  update: 'update'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sankey',
	    query: payload
	  }, function (seriesModel) {
	    seriesModel.setNodePosition(payload.dataIndex, [payload.localX, payload.localY]);
	  });
	});

/***/ },
/* 2283 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var layout = __webpack_require__(46);
	
	var zrUtil = __webpack_require__(4);
	
	var _model = __webpack_require__(29);
	
	var groupData = _model.groupData;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var nodeWidth = seriesModel.get('nodeWidth');
	    var nodeGap = seriesModel.get('nodeGap');
	    var layoutInfo = getViewRect(seriesModel, api);
	    seriesModel.layoutInfo = layoutInfo;
	    var width = layoutInfo.width;
	    var height = layoutInfo.height;
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	    var edges = graph.edges;
	    computeNodeValues(nodes);
	    var filteredNodes = zrUtil.filter(nodes, function (node) {
	      return node.getLayout().value === 0;
	    });
	    var iterations = filteredNodes.length !== 0 ? 0 : seriesModel.get('layoutIterations');
	    var orient = seriesModel.get('orient');
	    var nodeAlign = seriesModel.get('nodeAlign');
	    layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign);
	  });
	}
	/**
	 * Get the layout position of the whole view
	 *
	 * @param {module:echarts/model/Series} seriesModel  the model object of sankey series
	 * @param {module:echarts/ExtensionAPI} api  provide the API list that the developer can call
	 * @return {module:zrender/core/BoundingRect}  size of rect to draw the sankey view
	 */
	
	
	function getViewRect(seriesModel, api) {
	  return layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  });
	}
	
	function layoutSankey(nodes, edges, nodeWidth, nodeGap, width, height, iterations, orient, nodeAlign) {
	  computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign);
	  computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient);
	  computeEdgeDepths(nodes, orient);
	}
	/**
	 * Compute the value of each node by summing the associated edge's value
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeNodeValues(nodes) {
	  zrUtil.each(nodes, function (node) {
	    var value1 = sum(node.outEdges, getEdgeValue);
	    var value2 = sum(node.inEdges, getEdgeValue);
	    var nodeRawValue = node.getValue() || 0;
	    var value = Math.max(value1, value2, nodeRawValue);
	    node.setLayout({
	      value: value
	    }, true);
	  });
	}
	/**
	 * Compute the x-position for each node.
	 *
	 * Here we use Kahn algorithm to detect cycle when we traverse
	 * the node to computer the initial x position.
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param  {number} nodeWidth  the dx of the node
	 * @param  {number} width  the whole width of the area to draw the view
	 */
	
	
	function computeNodeBreadths(nodes, edges, nodeWidth, width, height, orient, nodeAlign) {
	  // Used to mark whether the edge is deleted. if it is deleted,
	  // the value is 0, otherwise it is 1.
	  var remainEdges = []; // Storage each node's indegree.
	
	  var indegreeArr = []; //Used to storage the node with indegree is equal to 0.
	
	  var zeroIndegrees = [];
	  var nextTargetNode = [];
	  var x = 0;
	  var kx = 0;
	
	  for (var i = 0; i < edges.length; i++) {
	    remainEdges[i] = 1;
	  }
	
	  for (i = 0; i < nodes.length; i++) {
	    indegreeArr[i] = nodes[i].inEdges.length;
	
	    if (indegreeArr[i] === 0) {
	      zeroIndegrees.push(nodes[i]);
	    }
	  }
	
	  var maxNodeDepth = -1; // Traversing nodes using topological sorting to calculate the
	  // horizontal(if orient === 'horizontal') or vertical(if orient === 'vertical')
	  // position of the nodes.
	
	  while (zeroIndegrees.length) {
	    for (var idx = 0; idx < zeroIndegrees.length; idx++) {
	      var node = zeroIndegrees[idx];
	      var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
	      var isItemDepth = item.depth != null && item.depth >= 0;
	
	      if (isItemDepth && item.depth > maxNodeDepth) {
	        maxNodeDepth = item.depth;
	      }
	
	      node.setLayout({
	        depth: isItemDepth ? item.depth : x
	      }, true);
	      orient === 'vertical' ? node.setLayout({
	        dy: nodeWidth
	      }, true) : node.setLayout({
	        dx: nodeWidth
	      }, true);
	
	      for (var edgeIdx = 0; edgeIdx < node.outEdges.length; edgeIdx++) {
	        var edge = node.outEdges[edgeIdx];
	        var indexEdge = edges.indexOf(edge);
	        remainEdges[indexEdge] = 0;
	        var targetNode = edge.node2;
	        var nodeIndex = nodes.indexOf(targetNode);
	
	        if (--indegreeArr[nodeIndex] === 0 && nextTargetNode.indexOf(targetNode) < 0) {
	          nextTargetNode.push(targetNode);
	        }
	      }
	    }
	
	    ++x;
	    zeroIndegrees = nextTargetNode;
	    nextTargetNode = [];
	  }
	
	  for (i = 0; i < remainEdges.length; i++) {
	    if (remainEdges[i] === 1) {
	      throw new Error('Sankey is a DAG, the original data has cycle!');
	    }
	  }
	
	  var maxDepth = maxNodeDepth > x - 1 ? maxNodeDepth : x - 1;
	
	  if (nodeAlign && nodeAlign !== 'left') {
	    adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth);
	  }
	
	  var kx = orient === 'vertical' ? (height - nodeWidth) / maxDepth : (width - nodeWidth) / maxDepth;
	  scaleNodeBreadths(nodes, kx, orient);
	}
	
	function isNodeDepth(node) {
	  var item = node.hostGraph.data.getRawDataItem(node.dataIndex);
	  return item.depth != null && item.depth >= 0;
	}
	
	function adjustNodeWithNodeAlign(nodes, nodeAlign, orient, maxDepth) {
	  if (nodeAlign === 'right') {
	    var nextSourceNode = [];
	    var remainNodes = nodes;
	    var nodeHeight = 0;
	
	    while (remainNodes.length) {
	      for (var i = 0; i < remainNodes.length; i++) {
	        var node = remainNodes[i];
	        node.setLayout({
	          skNodeHeight: nodeHeight
	        }, true);
	
	        for (var j = 0; j < node.inEdges.length; j++) {
	          var edge = node.inEdges[j];
	
	          if (nextSourceNode.indexOf(edge.node1) < 0) {
	            nextSourceNode.push(edge.node1);
	          }
	        }
	      }
	
	      remainNodes = nextSourceNode;
	      nextSourceNode = [];
	      ++nodeHeight;
	    }
	
	    zrUtil.each(nodes, function (node) {
	      if (!isNodeDepth(node)) {
	        node.setLayout({
	          depth: Math.max(0, maxDepth - node.getLayout().skNodeHeight)
	        }, true);
	      }
	    });
	  } else if (nodeAlign === 'justify') {
	    moveSinksRight(nodes, maxDepth);
	  }
	}
	/**
	 * All the node without outEgdes are assigned maximum x-position and
	 *     be aligned in the last column.
	 *
	 * @param {module:echarts/data/Graph~Node} nodes.  node of sankey view.
	 * @param {number} maxDepth.  use to assign to node without outEdges as x-position.
	 */
	
	
	function moveSinksRight(nodes, maxDepth) {
	  zrUtil.each(nodes, function (node) {
	    if (!isNodeDepth(node) && !node.outEdges.length) {
	      node.setLayout({
	        depth: maxDepth
	      }, true);
	    }
	  });
	}
	/**
	 * Scale node x-position to the width
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {number} kx   multiple used to scale nodes
	 */
	
	
	function scaleNodeBreadths(nodes, kx, orient) {
	  zrUtil.each(nodes, function (node) {
	    var nodeDepth = node.getLayout().depth * kx;
	    orient === 'vertical' ? node.setLayout({
	      y: nodeDepth
	    }, true) : node.setLayout({
	      x: nodeDepth
	    }, true);
	  });
	}
	/**
	 * Using Gauss-Seidel iterations method to compute the node depth(y-position)
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 *     in the same column.
	 * @param {number} iterations  the number of iterations for the algorithm
	 */
	
	
	function computeNodeDepths(nodes, edges, height, width, nodeGap, iterations, orient) {
	  var nodesByBreadth = prepareNodesByBreadth(nodes, orient);
	  initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient);
	  resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	
	  for (var alpha = 1; iterations > 0; iterations--) {
	    // 0.99 is a experience parameter, ensure that each iterations of
	    // changes as small as possible.
	    alpha *= 0.99;
	    relaxRightToLeft(nodesByBreadth, alpha, orient);
	    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	    relaxLeftToRight(nodesByBreadth, alpha, orient);
	    resolveCollisions(nodesByBreadth, nodeGap, height, width, orient);
	  }
	}
	
	function prepareNodesByBreadth(nodes, orient) {
	  var nodesByBreadth = [];
	  var keyAttr = orient === 'vertical' ? 'y' : 'x';
	  var groupResult = groupData(nodes, function (node) {
	    return node.getLayout()[keyAttr];
	  });
	  groupResult.keys.sort(function (a, b) {
	    return a - b;
	  });
	  zrUtil.each(groupResult.keys, function (key) {
	    nodesByBreadth.push(groupResult.buckets.get(key));
	  });
	  return nodesByBreadth;
	}
	/**
	 * Compute the original y-position for each node
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {module:echarts/data/Graph~Edge} edges  edge of sankey view
	 * @param {number} height  the whole height of the area to draw the view
	 * @param {number} nodeGap  the vertical distance between two nodes
	 */
	
	
	function initializeNodeDepth(nodesByBreadth, edges, height, width, nodeGap, orient) {
	  var minKy = Infinity;
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    var n = nodes.length;
	    var sum = 0;
	    zrUtil.each(nodes, function (node) {
	      sum += node.getLayout().value;
	    });
	    var ky = orient === 'vertical' ? (width - (n - 1) * nodeGap) / sum : (height - (n - 1) * nodeGap) / sum;
	
	    if (ky < minKy) {
	      minKy = ky;
	    }
	  });
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node, i) {
	      var nodeDy = node.getLayout().value * minKy;
	
	      if (orient === 'vertical') {
	        node.setLayout({
	          x: i
	        }, true);
	        node.setLayout({
	          dx: nodeDy
	        }, true);
	      } else {
	        node.setLayout({
	          y: i
	        }, true);
	        node.setLayout({
	          dy: nodeDy
	        }, true);
	      }
	    });
	  });
	  zrUtil.each(edges, function (edge) {
	    var edgeDy = +edge.getValue() * minKy;
	    edge.setLayout({
	      dy: edgeDy
	    }, true);
	  });
	}
	/**
	 * Resolve the collision of initialized depth (y-position)
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the nodes x-position.
	 * @param {number} nodeGap  the vertical distance between two nodes
	 * @param {number} height  the whole height of the area to draw the view
	 */
	
	
	function resolveCollisions(nodesByBreadth, nodeGap, height, width, orient) {
	  var keyAttr = orient === 'vertical' ? 'x' : 'y';
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    nodes.sort(function (a, b) {
	      return a.getLayout()[keyAttr] - b.getLayout()[keyAttr];
	    });
	    var nodeX;
	    var node;
	    var dy;
	    var y0 = 0;
	    var n = nodes.length;
	    var nodeDyAttr = orient === 'vertical' ? 'dx' : 'dy';
	
	    for (var i = 0; i < n; i++) {
	      node = nodes[i];
	      dy = y0 - node.getLayout()[keyAttr];
	
	      if (dy > 0) {
	        nodeX = node.getLayout()[keyAttr] + dy;
	        orient === 'vertical' ? node.setLayout({
	          x: nodeX
	        }, true) : node.setLayout({
	          y: nodeX
	        }, true);
	      }
	
	      y0 = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap;
	    }
	
	    var viewWidth = orient === 'vertical' ? width : height; // If the bottommost node goes outside the bounds, push it back up
	
	    dy = y0 - nodeGap - viewWidth;
	
	    if (dy > 0) {
	      nodeX = node.getLayout()[keyAttr] - dy;
	      orient === 'vertical' ? node.setLayout({
	        x: nodeX
	      }, true) : node.setLayout({
	        y: nodeX
	      }, true);
	      y0 = nodeX;
	
	      for (i = n - 2; i >= 0; --i) {
	        node = nodes[i];
	        dy = node.getLayout()[keyAttr] + node.getLayout()[nodeDyAttr] + nodeGap - y0;
	
	        if (dy > 0) {
	          nodeX = node.getLayout()[keyAttr] - dy;
	          orient === 'vertical' ? node.setLayout({
	            x: nodeX
	          }, true) : node.setLayout({
	            y: nodeX
	          }, true);
	        }
	
	        y0 = node.getLayout()[keyAttr];
	      }
	    }
	  });
	}
	/**
	 * Change the y-position of the nodes, except most the right side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxRightToLeft(nodesByBreadth, alpha, orient) {
	  zrUtil.each(nodesByBreadth.slice().reverse(), function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.outEdges.length) {
	        var y = sum(node.outEdges, weightedTarget, orient) / sum(node.outEdges, getEdgeValue, orient);
	
	        if (isNaN(y)) {
	          var len = node.outEdges.length;
	          y = len ? sum(node.outEdges, centerTarget, orient) / len : 0;
	        }
	
	        if (orient === 'vertical') {
	          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            x: nodeX
	          }, true);
	        } else {
	          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	      }
	    });
	  });
	}
	
	function weightedTarget(edge, orient) {
	  return center(edge.node2, orient) * edge.getValue();
	}
	
	function centerTarget(edge, orient) {
	  return center(edge.node2, orient);
	}
	
	function weightedSource(edge, orient) {
	  return center(edge.node1, orient) * edge.getValue();
	}
	
	function centerSource(edge, orient) {
	  return center(edge.node1, orient);
	}
	
	function center(node, orient) {
	  return orient === 'vertical' ? node.getLayout().x + node.getLayout().dx / 2 : node.getLayout().y + node.getLayout().dy / 2;
	}
	
	function getEdgeValue(edge) {
	  return edge.getValue();
	}
	
	function sum(array, cb, orient) {
	  var sum = 0;
	  var len = array.length;
	  var i = -1;
	
	  while (++i < len) {
	    var value = +cb.call(array, array[i], orient);
	
	    if (!isNaN(value)) {
	      sum += value;
	    }
	  }
	
	  return sum;
	}
	/**
	 * Change the y-position of the nodes, except most the left side nodes
	 *
	 * @param {Array.<Array.<module:echarts/data/Graph~Node>>} nodesByBreadth
	 *     group by the array of all sankey nodes based on the node x-position.
	 * @param {number} alpha  parameter used to adjust the nodes y-position
	 */
	
	
	function relaxLeftToRight(nodesByBreadth, alpha, orient) {
	  zrUtil.each(nodesByBreadth, function (nodes) {
	    zrUtil.each(nodes, function (node) {
	      if (node.inEdges.length) {
	        var y = sum(node.inEdges, weightedSource, orient) / sum(node.inEdges, getEdgeValue, orient);
	
	        if (isNaN(y)) {
	          var len = node.inEdges.length;
	          y = len ? sum(node.inEdges, centerSource, orient) / len : 0;
	        }
	
	        if (orient === 'vertical') {
	          var nodeX = node.getLayout().x + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            x: nodeX
	          }, true);
	        } else {
	          var nodeY = node.getLayout().y + (y - center(node, orient)) * alpha;
	          node.setLayout({
	            y: nodeY
	          }, true);
	        }
	      }
	    });
	  });
	}
	/**
	 * Compute the depth(y-position) of each edge
	 *
	 * @param {module:echarts/data/Graph~Node} nodes  node of sankey view
	 */
	
	
	function computeEdgeDepths(nodes, orient) {
	  var keyAttr = orient === 'vertical' ? 'x' : 'y';
	  zrUtil.each(nodes, function (node) {
	    node.outEdges.sort(function (a, b) {
	      return a.node2.getLayout()[keyAttr] - b.node2.getLayout()[keyAttr];
	    });
	    node.inEdges.sort(function (a, b) {
	      return a.node1.getLayout()[keyAttr] - b.node1.getLayout()[keyAttr];
	    });
	  });
	  zrUtil.each(nodes, function (node) {
	    var sy = 0;
	    var ty = 0;
	    zrUtil.each(node.outEdges, function (edge) {
	      edge.setLayout({
	        sy: sy
	      }, true);
	      sy += edge.getLayout().dy;
	    });
	    zrUtil.each(node.inEdges, function (edge) {
	      edge.setLayout({
	        ty: ty
	      }, true);
	      ty += edge.getLayout().dy;
	    });
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2284 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var VisualMapping = __webpack_require__(213);
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, payload) {
	  ecModel.eachSeriesByType('sankey', function (seriesModel) {
	    var graph = seriesModel.getGraph();
	    var nodes = graph.nodes;
	
	    if (nodes.length) {
	      var minValue = Infinity;
	      var maxValue = -Infinity;
	      zrUtil.each(nodes, function (node) {
	        var nodeValue = node.getLayout().value;
	
	        if (nodeValue < minValue) {
	          minValue = nodeValue;
	        }
	
	        if (nodeValue > maxValue) {
	          maxValue = nodeValue;
	        }
	      });
	      zrUtil.each(nodes, function (node) {
	        var mapping = new VisualMapping({
	          type: 'color',
	          mappingMethod: 'linear',
	          dataExtent: [minValue, maxValue],
	          visual: seriesModel.get('color')
	        });
	        var mapValueToColor = mapping.mapValueToVisual(node.getLayout().value);
	        var customColor = node.getModel().get('itemStyle.color');
	        customColor != null ? node.setVisual('color', customColor) : node.setVisual('color', mapValueToColor);
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2285 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2286);
	
	__webpack_require__(2287);
	
	var visualSymbol = __webpack_require__(214);
	
	var layoutPoints = __webpack_require__(295);
	
	__webpack_require__(290);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import * as zrUtil from 'zrender/src/core/util';
	// In case developer forget to include grid component
	echarts.registerVisual(visualSymbol('scatter', 'circle'));
	echarts.registerLayout(layoutPoints('scatter')); // echarts.registerProcessor(function (ecModel, api) {
	//     ecModel.eachSeriesByType('scatter', function (seriesModel) {
	//         var data = seriesModel.getData();
	//         var coordSys = seriesModel.coordinateSystem;
	//         if (coordSys.type !== 'geo') {
	//             return;
	//         }
	//         var startPt = coordSys.pointToData([0, 0]);
	//         var endPt = coordSys.pointToData([api.getWidth(), api.getHeight()]);
	//         var dims = zrUtil.map(coordSys.dimensions, function (dim) {
	//             return data.mapDimension(dim);
	//         });
	//         var range = {};
	//         range[dims[0]] = [Math.min(startPt[0], endPt[0]), Math.max(startPt[0], endPt[0])];
	//         range[dims[1]] = [Math.min(startPt[1], endPt[1]), Math.max(startPt[1], endPt[1])];
	//         data.selectRange(range);
	//     });
	// });

/***/ },
/* 2286 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var createListFromArray = __webpack_require__(159);
	
	var SeriesModel = __webpack_require__(77);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.scatter',
	  dependencies: ['grid', 'polar', 'geo', 'singleAxis', 'calendar'],
	  getInitialData: function (option, ecModel) {
	    return createListFromArray(this.getSource(), this, {
	      useEncodeDefaulter: true
	    });
	  },
	  brushSelector: 'point',
	  getProgressive: function () {
	    var progressive = this.option.progressive;
	
	    if (progressive == null) {
	      // PENDING
	      return this.option.large ? 5e3 : this.get('progressive');
	    }
	
	    return progressive;
	  },
	  getProgressiveThreshold: function () {
	    var progressiveThreshold = this.option.progressiveThreshold;
	
	    if (progressiveThreshold == null) {
	      // PENDING
	      return this.option.large ? 1e4 : this.get('progressiveThreshold');
	    }
	
	    return progressiveThreshold;
	  },
	  defaultOption: {
	    coordinateSystem: 'cartesian2d',
	    zlevel: 0,
	    z: 2,
	    legendHoverLink: true,
	    hoverAnimation: true,
	    // Cartesian coordinate system
	    // xAxisIndex: 0,
	    // yAxisIndex: 0,
	    // Polar coordinate system
	    // polarIndex: 0,
	    // Geo coordinate system
	    // geoIndex: 0,
	    // symbol: null,        // 图形类型
	    symbolSize: 10,
	    // 图形大小，半宽（半径）参数，当图形为方向或菱形则总宽度为symbolSize * 2
	    // symbolRotate: null,  // 图形旋转控制
	    large: false,
	    // Available when large is true
	    largeThreshold: 2000,
	    // cursor: null,
	    // label: {
	    // show: false
	    // distance: 5,
	    // formatter: 标签文本格式器，同Tooltip.formatter，不支持异步回调
	    // position: 默认自适应，水平布局为'top'，垂直布局为'right'，可选为
	    //           'inside'|'left'|'right'|'top'|'bottom'
	    // 默认使用全局文本样式，详见TEXTSTYLE
	    // },
	    itemStyle: {
	      opacity: 0.8 // color: 各异
	
	    },
	    // If clip the overflow graphics
	    // Works on cartesian / polar series
	    clip: true // progressive: null
	
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2287 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var SymbolDraw = __webpack_require__(287);
	
	var LargeSymbolDraw = __webpack_require__(2247);
	
	var pointsLayout = __webpack_require__(295);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.extendChartView({
	  type: 'scatter',
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	    symbolDraw.updateData(data, {
	      // TODO
	      // If this parameter should be a shape or a bounding volume
	      // shape will be more general.
	      // But bounding volume like bounding rect will be much faster in the contain calculation
	      clipShape: this._getClipShape(seriesModel)
	    });
	    this._finished = true;
	  },
	  incrementalPrepareRender: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	
	    var symbolDraw = this._updateSymbolDraw(data, seriesModel);
	
	    symbolDraw.incrementalPrepareUpdate(data);
	    this._finished = false;
	  },
	  incrementalRender: function (taskParams, seriesModel, ecModel) {
	    this._symbolDraw.incrementalUpdate(taskParams, seriesModel.getData(), {
	      clipShape: this._getClipShape(seriesModel)
	    });
	
	    this._finished = taskParams.end === seriesModel.getData().count();
	  },
	  updateTransform: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData(); // Must mark group dirty and make sure the incremental layer will be cleared
	    // PENDING
	
	    this.group.dirty();
	
	    if (!this._finished || data.count() > 1e4 || !this._symbolDraw.isPersistent()) {
	      return {
	        update: true
	      };
	    } else {
	      var res = pointsLayout().reset(seriesModel);
	
	      if (res.progress) {
	        res.progress({
	          start: 0,
	          end: data.count()
	        }, data);
	      }
	
	      this._symbolDraw.updateLayout(data);
	    }
	  },
	  _getClipShape: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var clipArea = coordSys && coordSys.getArea && coordSys.getArea();
	    return seriesModel.get('clip', true) ? clipArea : null;
	  },
	  _updateSymbolDraw: function (data, seriesModel) {
	    var symbolDraw = this._symbolDraw;
	    var pipelineContext = seriesModel.pipelineContext;
	    var isLargeDraw = pipelineContext.large;
	
	    if (!symbolDraw || isLargeDraw !== this._isLargeDraw) {
	      symbolDraw && symbolDraw.remove();
	      symbolDraw = this._symbolDraw = isLargeDraw ? new LargeSymbolDraw() : new SymbolDraw();
	      this._isLargeDraw = isLargeDraw;
	      this.group.removeAll();
	    }
	
	    this.group.add(symbolDraw.group);
	    return symbolDraw;
	  },
	  remove: function (ecModel, api) {
	    this._symbolDraw && this._symbolDraw.remove(true);
	    this._symbolDraw = null;
	  },
	  dispose: function () {}
	});

/***/ },
/* 2288 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	__webpack_require__(2290);
	
	__webpack_require__(2291);
	
	__webpack_require__(2292);
	
	var dataColor = __webpack_require__(363);
	
	var sunburstLayout = __webpack_require__(2293);
	
	var dataFilter = __webpack_require__(296);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(zrUtil.curry(dataColor, 'sunburst'));
	echarts.registerLayout(zrUtil.curry(sunburstLayout, 'sunburst'));
	echarts.registerProcessor(zrUtil.curry(dataFilter, 'sunburst'));

/***/ },
/* 2289 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var NodeHighlightPolicy = {
	  NONE: 'none',
	  // not downplay others
	  DESCENDANT: 'descendant',
	  ANCESTOR: 'ancestor',
	  SELF: 'self'
	};
	var DEFAULT_SECTOR_Z = 2;
	var DEFAULT_TEXT_Z = 4;
	/**
	 * Sunburstce of Sunburst including Sector, Label, LabelLine
	 * @constructor
	 * @extends {module:zrender/graphic/Group}
	 */
	
	function SunburstPiece(node, seriesModel, ecModel) {
	  graphic.Group.call(this);
	  var sector = new graphic.Sector({
	    z2: DEFAULT_SECTOR_Z
	  });
	  sector.seriesIndex = seriesModel.seriesIndex;
	  var text = new graphic.Text({
	    z2: DEFAULT_TEXT_Z,
	    silent: node.getModel('label').get('silent')
	  });
	  this.add(sector);
	  this.add(text);
	  this.updateData(true, node, 'normal', seriesModel, ecModel); // Hover to change label and labelLine
	
	  function onEmphasis() {
	    text.ignore = text.hoverIgnore;
	  }
	
	  function onNormal() {
	    text.ignore = text.normalIgnore;
	  }
	
	  this.on('emphasis', onEmphasis).on('normal', onNormal).on('mouseover', onEmphasis).on('mouseout', onNormal);
	}
	
	var SunburstPieceProto = SunburstPiece.prototype;
	
	SunburstPieceProto.updateData = function (firstCreate, node, state, seriesModel, ecModel) {
	  this.node = node;
	  node.piece = this;
	  seriesModel = seriesModel || this._seriesModel;
	  ecModel = ecModel || this._ecModel;
	  var sector = this.childAt(0);
	  sector.dataIndex = node.dataIndex;
	  var itemModel = node.getModel();
	  var layout = node.getLayout(); // if (!layout) {
	  //     console.log(node.getLayout());
	  // }
	
	  var sectorShape = zrUtil.extend({}, layout);
	  sectorShape.label = null;
	  var visualColor = getNodeColor(node, seriesModel, ecModel);
	  fillDefaultColor(node, seriesModel, visualColor);
	  var normalStyle = itemModel.getModel('itemStyle').getItemStyle();
	  var style;
	
	  if (state === 'normal') {
	    style = normalStyle;
	  } else {
	    var stateStyle = itemModel.getModel(state + '.itemStyle').getItemStyle();
	    style = zrUtil.merge(stateStyle, normalStyle);
	  }
	
	  style = zrUtil.defaults({
	    lineJoin: 'bevel',
	    fill: style.fill || visualColor
	  }, style);
	
	  if (firstCreate) {
	    sector.setShape(sectorShape);
	    sector.shape.r = layout.r0;
	    graphic.updateProps(sector, {
	      shape: {
	        r: layout.r
	      }
	    }, seriesModel, node.dataIndex);
	    sector.useStyle(style);
	  } else if (typeof style.fill === 'object' && style.fill.type || typeof sector.style.fill === 'object' && sector.style.fill.type) {
	    // Disable animation for gradient since no interpolation method
	    // is supported for gradient
	    graphic.updateProps(sector, {
	      shape: sectorShape
	    }, seriesModel);
	    sector.useStyle(style);
	  } else {
	    graphic.updateProps(sector, {
	      shape: sectorShape,
	      style: style
	    }, seriesModel);
	  }
	
	  this._updateLabel(seriesModel, visualColor, state);
	
	  var cursorStyle = itemModel.getShallow('cursor');
	  cursorStyle && sector.attr('cursor', cursorStyle);
	
	  if (firstCreate) {
	    var highlightPolicy = seriesModel.getShallow('highlightPolicy');
	
	    this._initEvents(sector, node, seriesModel, highlightPolicy);
	  }
	
	  this._seriesModel = seriesModel || this._seriesModel;
	  this._ecModel = ecModel || this._ecModel;
	  graphic.setHoverStyle(this);
	};
	
	SunburstPieceProto.onEmphasis = function (highlightPolicy) {
	  var that = this;
	  this.node.hostTree.root.eachNode(function (n) {
	    if (n.piece) {
	      if (that.node === n) {
	        n.piece.updateData(false, n, 'emphasis');
	      } else if (isNodeHighlighted(n, that.node, highlightPolicy)) {
	        n.piece.childAt(0).trigger('highlight');
	      } else if (highlightPolicy !== NodeHighlightPolicy.NONE) {
	        n.piece.childAt(0).trigger('downplay');
	      }
	    }
	  });
	};
	
	SunburstPieceProto.onNormal = function () {
	  this.node.hostTree.root.eachNode(function (n) {
	    if (n.piece) {
	      n.piece.updateData(false, n, 'normal');
	    }
	  });
	};
	
	SunburstPieceProto.onHighlight = function () {
	  this.updateData(false, this.node, 'highlight');
	};
	
	SunburstPieceProto.onDownplay = function () {
	  this.updateData(false, this.node, 'downplay');
	};
	
	SunburstPieceProto._updateLabel = function (seriesModel, visualColor, state) {
	  var itemModel = this.node.getModel();
	  var normalModel = itemModel.getModel('label');
	  var labelModel = state === 'normal' || state === 'emphasis' ? normalModel : itemModel.getModel(state + '.label');
	  var labelHoverModel = itemModel.getModel('emphasis.label');
	  var labelFormatter = labelModel.get('formatter'); // Use normal formatter if no state formatter is defined
	
	  var labelState = labelFormatter ? state : 'normal';
	  var text = zrUtil.retrieve(seriesModel.getFormattedLabel(this.node.dataIndex, labelState, null, null, 'label'), this.node.name);
	
	  if (getLabelAttr('show') === false) {
	    text = '';
	  }
	
	  var layout = this.node.getLayout();
	  var labelMinAngle = labelModel.get('minAngle');
	
	  if (labelMinAngle == null) {
	    labelMinAngle = normalModel.get('minAngle');
	  }
	
	  labelMinAngle = labelMinAngle / 180 * Math.PI;
	  var angle = layout.endAngle - layout.startAngle;
	
	  if (labelMinAngle != null && Math.abs(angle) < labelMinAngle) {
	    // Not displaying text when angle is too small
	    text = '';
	  }
	
	  var label = this.childAt(1);
	  graphic.setLabelStyle(label.style, label.hoverStyle || {}, normalModel, labelHoverModel, {
	    defaultText: labelModel.getShallow('show') ? text : null,
	    autoColor: visualColor,
	    useInsideStyle: true
	  });
	  var midAngle = (layout.startAngle + layout.endAngle) / 2;
	  var dx = Math.cos(midAngle);
	  var dy = Math.sin(midAngle);
	  var r;
	  var labelPosition = getLabelAttr('position');
	  var labelPadding = getLabelAttr('distance') || 0;
	  var textAlign = getLabelAttr('align');
	
	  if (labelPosition === 'outside') {
	    r = layout.r + labelPadding;
	    textAlign = midAngle > Math.PI / 2 ? 'right' : 'left';
	  } else {
	    if (!textAlign || textAlign === 'center') {
	      r = (layout.r + layout.r0) / 2;
	      textAlign = 'center';
	    } else if (textAlign === 'left') {
	      r = layout.r0 + labelPadding;
	
	      if (midAngle > Math.PI / 2) {
	        textAlign = 'right';
	      }
	    } else if (textAlign === 'right') {
	      r = layout.r - labelPadding;
	
	      if (midAngle > Math.PI / 2) {
	        textAlign = 'left';
	      }
	    }
	  }
	
	  label.attr('style', {
	    text: text,
	    textAlign: textAlign,
	    textVerticalAlign: getLabelAttr('verticalAlign') || 'middle',
	    opacity: getLabelAttr('opacity')
	  });
	  var textX = r * dx + layout.cx;
	  var textY = r * dy + layout.cy;
	  label.attr('position', [textX, textY]);
	  var rotateType = getLabelAttr('rotate');
	  var rotate = 0;
	
	  if (rotateType === 'radial') {
	    rotate = -midAngle;
	
	    if (rotate < -Math.PI / 2) {
	      rotate += Math.PI;
	    }
	  } else if (rotateType === 'tangential') {
	    rotate = Math.PI / 2 - midAngle;
	
	    if (rotate > Math.PI / 2) {
	      rotate -= Math.PI;
	    } else if (rotate < -Math.PI / 2) {
	      rotate += Math.PI;
	    }
	  } else if (typeof rotateType === 'number') {
	    rotate = rotateType * Math.PI / 180;
	  }
	
	  label.attr('rotation', rotate);
	
	  function getLabelAttr(name) {
	    var stateAttr = labelModel.get(name);
	
	    if (stateAttr == null) {
	      return normalModel.get(name);
	    } else {
	      return stateAttr;
	    }
	  }
	};
	
	SunburstPieceProto._initEvents = function (sector, node, seriesModel, highlightPolicy) {
	  sector.off('mouseover').off('mouseout').off('emphasis').off('normal');
	  var that = this;
	
	  var onEmphasis = function () {
	    that.onEmphasis(highlightPolicy);
	  };
	
	  var onNormal = function () {
	    that.onNormal();
	  };
	
	  var onDownplay = function () {
	    that.onDownplay();
	  };
	
	  var onHighlight = function () {
	    that.onHighlight();
	  };
	
	  if (seriesModel.isAnimationEnabled()) {
	    sector.on('mouseover', onEmphasis).on('mouseout', onNormal).on('emphasis', onEmphasis).on('normal', onNormal).on('downplay', onDownplay).on('highlight', onHighlight);
	  }
	};
	
	zrUtil.inherits(SunburstPiece, graphic.Group);
	var _default = SunburstPiece;
	/**
	 * Get node color
	 *
	 * @param {TreeNode} node the node to get color
	 * @param {module:echarts/model/Series} seriesModel series
	 * @param {module:echarts/model/Global} ecModel echarts defaults
	 */
	
	function getNodeColor(node, seriesModel, ecModel) {
	  // Color from visualMap
	  var visualColor = node.getVisual('color');
	  var visualMetaList = node.getVisual('visualMeta');
	
	  if (!visualMetaList || visualMetaList.length === 0) {
	    // Use first-generation color if has no visualMap
	    visualColor = null;
	  } // Self color or level color
	
	
	  var color = node.getModel('itemStyle').get('color');
	
	  if (color) {
	    return color;
	  } else if (visualColor) {
	    // Color mapping
	    return visualColor;
	  } else if (node.depth === 0) {
	    // Virtual root node
	    return ecModel.option.color[0];
	  } else {
	    // First-generation color
	    var length = ecModel.option.color.length;
	    color = ecModel.option.color[getRootId(node) % length];
	  }
	
	  return color;
	}
	/**
	 * Get index of root in sorted order
	 *
	 * @param {TreeNode} node current node
	 * @return {number} index in root
	 */
	
	
	function getRootId(node) {
	  var ancestor = node;
	
	  while (ancestor.depth > 1) {
	    ancestor = ancestor.parentNode;
	  }
	
	  var virtualRoot = node.getAncestors()[0];
	  return zrUtil.indexOf(virtualRoot.children, ancestor);
	}
	
	function isNodeHighlighted(node, activeNode, policy) {
	  if (policy === NodeHighlightPolicy.NONE) {
	    return false;
	  } else if (policy === NodeHighlightPolicy.SELF) {
	    return node === activeNode;
	  } else if (policy === NodeHighlightPolicy.ANCESTOR) {
	    return node === activeNode || node.isAncestorOf(activeNode);
	  } else {
	    return node === activeNode || node.isDescendantOf(activeNode);
	  }
	} // Fix tooltip callback function params.color incorrect when pick a default color
	
	
	function fillDefaultColor(node, seriesModel, color) {
	  var data = seriesModel.getData();
	  data.setItemVisual(node.dataIndex, 'color', color);
	}
	
	module.exports = _default;

/***/ },
/* 2290 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var SeriesModel = __webpack_require__(77);
	
	var Tree = __webpack_require__(516);
	
	var Model = __webpack_require__(70);
	
	var _treeHelper = __webpack_require__(209);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.sunburst',
	
	  /**
	   * @type {module:echarts/data/Tree~Node}
	   */
	  _viewRoot: null,
	  getInitialData: function (option, ecModel) {
	    // Create a virtual root.
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    completeTreeValue(root);
	    var levelModels = zrUtil.map(option.levels || [], function (levelDefine) {
	      return new Model(levelDefine, this, ecModel);
	    }, this); // Make sure always a new tree is created when setOption,
	    // in TreemapView, we check whether oldTree === newTree
	    // to choose mappings approach among old shapes and new shapes.
	
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	        var levelModel = levelModels[node.depth];
	        levelModel && (model.parentModel = levelModel);
	        return model;
	      });
	    }
	
	    return tree.data;
	  },
	  optionUpdated: function () {
	    this.resetViewRoot();
	  },
	
	  /*
	   * @override
	   */
	  getDataParams: function (dataIndex) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	    params.treePathInfo = wrapTreePathInfo(node, this);
	    return params;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    // 默认全局居中
	    center: ['50%', '50%'],
	    radius: [0, '75%'],
	    // 默认顺时针
	    clockwise: true,
	    startAngle: 90,
	    // 最小角度改为0
	    minAngle: 0,
	    percentPrecision: 2,
	    // If still show when all data zero.
	    stillShowZeroSum: true,
	    // Policy of highlighting pieces when hover on one
	    // Valid values: 'none' (for not downplay others), 'descendant',
	    // 'ancestor', 'self'
	    highlightPolicy: 'descendant',
	    // 'rootToNode', 'link', or false
	    nodeClick: 'rootToNode',
	    renderLabelForZeroData: false,
	    label: {
	      // could be: 'radial', 'tangential', or 'none'
	      rotate: 'radial',
	      show: true,
	      opacity: 1,
	      // 'left' is for inner side of inside, and 'right' is for outter
	      // side for inside
	      align: 'center',
	      position: 'inside',
	      distance: 5,
	      silent: true
	    },
	    itemStyle: {
	      borderWidth: 1,
	      borderColor: 'white',
	      borderType: 'solid',
	      shadowBlur: 0,
	      shadowColor: 'rgba(0, 0, 0, 0.2)',
	      shadowOffsetX: 0,
	      shadowOffsetY: 0,
	      opacity: 1
	    },
	    highlight: {
	      itemStyle: {
	        opacity: 1
	      }
	    },
	    downplay: {
	      itemStyle: {
	        opacity: 0.5
	      },
	      label: {
	        opacity: 0.6
	      }
	    },
	    // Animation type canbe expansion, scale
	    animationType: 'expansion',
	    animationDuration: 1000,
	    animationDurationUpdate: 500,
	    animationEasing: 'cubicOut',
	    data: [],
	    levels: [],
	
	    /**
	     * Sort order.
	     *
	     * Valid values: 'desc', 'asc', null, or callback function.
	     * 'desc' and 'asc' for descend and ascendant order;
	     * null for not sorting;
	     * example of callback function:
	     * function(nodeA, nodeB) {
	     *     return nodeA.getValue() - nodeB.getValue();
	     * }
	     */
	    sort: 'desc'
	  },
	  getViewRoot: function () {
	    return this._viewRoot;
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~Node} [viewRoot]
	   */
	  resetViewRoot: function (viewRoot) {
	    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	    var root = this.getRawData().tree.root;
	
	    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	      this._viewRoot = root;
	    }
	  }
	});
	/**
	 * @param {Object} dataNode
	 */
	
	
	function completeTreeValue(dataNode) {
	  // Postorder travel tree.
	  // If value of none-leaf node is not set,
	  // calculate it by suming up the value of all children.
	  var sum = 0;
	  zrUtil.each(dataNode.children, function (child) {
	    completeTreeValue(child);
	    var childValue = child.value;
	    zrUtil.isArray(childValue) && (childValue = childValue[0]);
	    sum += childValue;
	  });
	  var thisValue = dataNode.value;
	
	  if (zrUtil.isArray(thisValue)) {
	    thisValue = thisValue[0];
	  }
	
	  if (thisValue == null || isNaN(thisValue)) {
	    thisValue = sum;
	  } // Value should not less than 0.
	
	
	  if (thisValue < 0) {
	    thisValue = 0;
	  }
	
	  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	}
	
	module.exports = _default;

/***/ },
/* 2291 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var ChartView = __webpack_require__(141);
	
	var SunburstPiece = __webpack_require__(2289);
	
	var DataDiffer = __webpack_require__(211);
	
	var _format = __webpack_require__(48);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
	var SunburstView = ChartView.extend({
	  type: 'sunburst',
	  init: function () {},
	  render: function (seriesModel, ecModel, api, payload) {
	    var that = this;
	    this.seriesModel = seriesModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    var data = seriesModel.getData();
	    var virtualRoot = data.tree.root;
	    var newRoot = seriesModel.getViewRoot();
	    var group = this.group;
	    var renderLabelForZeroData = seriesModel.get('renderLabelForZeroData');
	    var newChildren = [];
	    newRoot.eachNode(function (node) {
	      newChildren.push(node);
	    });
	    var oldChildren = this._oldChildren || [];
	    dualTravel(newChildren, oldChildren);
	    renderRollUp(virtualRoot, newRoot);
	
	    if (payload && payload.highlight && payload.highlight.piece) {
	      var highlightPolicy = seriesModel.getShallow('highlightPolicy');
	      payload.highlight.piece.onEmphasis(highlightPolicy);
	    } else if (payload && payload.unhighlight) {
	      var piece = this.virtualPiece;
	
	      if (!piece && virtualRoot.children.length) {
	        piece = virtualRoot.children[0].piece;
	      }
	
	      if (piece) {
	        piece.onNormal();
	      }
	    }
	
	    this._initEvents();
	
	    this._oldChildren = newChildren;
	
	    function dualTravel(newChildren, oldChildren) {
	      if (newChildren.length === 0 && oldChildren.length === 0) {
	        return;
	      }
	
	      new DataDiffer(oldChildren, newChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
	
	      function getKey(node) {
	        return node.getId();
	      }
	
	      function processNode(newId, oldId) {
	        var newNode = newId == null ? null : newChildren[newId];
	        var oldNode = oldId == null ? null : oldChildren[oldId];
	        doRenderNode(newNode, oldNode);
	      }
	    }
	
	    function doRenderNode(newNode, oldNode) {
	      if (!renderLabelForZeroData && newNode && !newNode.getValue()) {
	        // Not render data with value 0
	        newNode = null;
	      }
	
	      if (newNode !== virtualRoot && oldNode !== virtualRoot) {
	        if (oldNode && oldNode.piece) {
	          if (newNode) {
	            // Update
	            oldNode.piece.updateData(false, newNode, 'normal', seriesModel, ecModel); // For tooltip
	
	            data.setItemGraphicEl(newNode.dataIndex, oldNode.piece);
	          } else {
	            // Remove
	            removeNode(oldNode);
	          }
	        } else if (newNode) {
	          // Add
	          var piece = new SunburstPiece(newNode, seriesModel, ecModel);
	          group.add(piece); // For tooltip
	
	          data.setItemGraphicEl(newNode.dataIndex, piece);
	        }
	      }
	    }
	
	    function removeNode(node) {
	      if (!node) {
	        return;
	      }
	
	      if (node.piece) {
	        group.remove(node.piece);
	        node.piece = null;
	      }
	    }
	
	    function renderRollUp(virtualRoot, viewRoot) {
	      if (viewRoot.depth > 0) {
	        // Render
	        if (that.virtualPiece) {
	          // Update
	          that.virtualPiece.updateData(false, virtualRoot, 'normal', seriesModel, ecModel);
	        } else {
	          // Add
	          that.virtualPiece = new SunburstPiece(virtualRoot, seriesModel, ecModel);
	          group.add(that.virtualPiece);
	        }
	
	        if (viewRoot.piece._onclickEvent) {
	          viewRoot.piece.off('click', viewRoot.piece._onclickEvent);
	        }
	
	        var event = function (e) {
	          that._rootToNode(viewRoot.parentNode);
	        };
	
	        viewRoot.piece._onclickEvent = event;
	        that.virtualPiece.on('click', event);
	      } else if (that.virtualPiece) {
	        // Remove
	        group.remove(that.virtualPiece);
	        that.virtualPiece = null;
	      }
	    }
	  },
	  dispose: function () {},
	
	  /**
	   * @private
	   */
	  _initEvents: function () {
	    var that = this;
	
	    var event = function (e) {
	      var targetFound = false;
	      var viewRoot = that.seriesModel.getViewRoot();
	      viewRoot.eachNode(function (node) {
	        if (!targetFound && node.piece && node.piece.childAt(0) === e.target) {
	          var nodeClick = node.getModel().get('nodeClick');
	
	          if (nodeClick === 'rootToNode') {
	            that._rootToNode(node);
	          } else if (nodeClick === 'link') {
	            var itemModel = node.getModel();
	            var link = itemModel.get('link');
	
	            if (link) {
	              var linkTarget = itemModel.get('target', true) || '_blank';
	              windowOpen(link, linkTarget);
	            }
	          }
	
	          targetFound = true;
	        }
	      });
	    };
	
	    if (this.group._onclickEvent) {
	      this.group.off('click', this.group._onclickEvent);
	    }
	
	    this.group.on('click', event);
	    this.group._onclickEvent = event;
	  },
	
	  /**
	   * @private
	   */
	  _rootToNode: function (node) {
	    if (node !== this.seriesModel.getViewRoot()) {
	      this.api.dispatchAction({
	        type: ROOT_TO_NODE_ACTION,
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        targetNode: node
	      });
	    }
	  },
	
	  /**
	   * @implement
	   */
	  containPoint: function (point, seriesModel) {
	    var treeRoot = seriesModel.getData();
	    var itemLayout = treeRoot.getItemLayout(0);
	
	    if (itemLayout) {
	      var dx = point[0] - itemLayout.cx;
	      var dy = point[1] - itemLayout.cy;
	      var radius = Math.sqrt(dx * dx + dy * dy);
	      return radius <= itemLayout.r && radius >= itemLayout.r0;
	    }
	  }
	});
	var _default = SunburstView;
	module.exports = _default;

/***/ },
/* 2292 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var helper = __webpack_require__(209);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Sunburst action
	 */
	var ROOT_TO_NODE_ACTION = 'sunburstRootToNode';
	echarts.registerAction({
	  type: ROOT_TO_NODE_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleRootToNode);
	
	  function handleRootToNode(model, index) {
	    var targetInfo = helper.retrieveTargetInfo(payload, [ROOT_TO_NODE_ACTION], model);
	
	    if (targetInfo) {
	      var originViewRoot = model.getViewRoot();
	
	      if (originViewRoot) {
	        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	      }
	
	      model.resetViewRoot(targetInfo.node);
	    }
	  }
	});
	var HIGHLIGHT_ACTION = 'sunburstHighlight';
	echarts.registerAction({
	  type: HIGHLIGHT_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleHighlight);
	
	  function handleHighlight(model, index) {
	    var targetInfo = helper.retrieveTargetInfo(payload, [HIGHLIGHT_ACTION], model);
	
	    if (targetInfo) {
	      payload.highlight = targetInfo.node;
	    }
	  }
	});
	var UNHIGHLIGHT_ACTION = 'sunburstUnhighlight';
	echarts.registerAction({
	  type: UNHIGHLIGHT_ACTION,
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'sunburst',
	    query: payload
	  }, handleUnhighlight);
	
	  function handleUnhighlight(model, index) {
	    payload.unhighlight = true;
	  }
	});

/***/ },
/* 2293 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// var PI2 = Math.PI * 2;
	var RADIAN = Math.PI / 180;
	
	function _default(seriesType, ecModel, api, payload) {
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    var center = seriesModel.get('center');
	    var radius = seriesModel.get('radius');
	
	    if (!zrUtil.isArray(radius)) {
	      radius = [0, radius];
	    }
	
	    if (!zrUtil.isArray(center)) {
	      center = [center, center];
	    }
	
	    var width = api.getWidth();
	    var height = api.getHeight();
	    var size = Math.min(width, height);
	    var cx = parsePercent(center[0], width);
	    var cy = parsePercent(center[1], height);
	    var r0 = parsePercent(radius[0], size / 2);
	    var r = parsePercent(radius[1], size / 2);
	    var startAngle = -seriesModel.get('startAngle') * RADIAN;
	    var minAngle = seriesModel.get('minAngle') * RADIAN;
	    var virtualRoot = seriesModel.getData().tree.root;
	    var treeRoot = seriesModel.getViewRoot();
	    var rootDepth = treeRoot.depth;
	    var sort = seriesModel.get('sort');
	
	    if (sort != null) {
	      initChildren(treeRoot, sort);
	    }
	
	    var validDataCount = 0;
	    zrUtil.each(treeRoot.children, function (child) {
	      !isNaN(child.getValue()) && validDataCount++;
	    });
	    var sum = treeRoot.getValue(); // Sum may be 0
	
	    var unitRadian = Math.PI / (sum || validDataCount) * 2;
	    var renderRollupNode = treeRoot.depth > 0;
	    var levels = treeRoot.height - (renderRollupNode ? -1 : 1);
	    var rPerLevel = (r - r0) / (levels || 1);
	    var clockwise = seriesModel.get('clockwise');
	    var stillShowZeroSum = seriesModel.get('stillShowZeroSum'); // In the case some sector angle is smaller than minAngle
	    // var restAngle = PI2;
	    // var valueSumLargerThanMinAngle = 0;
	
	    var dir = clockwise ? 1 : -1;
	    /**
	     * Render a tree
	     * @return increased angle
	     */
	
	    var renderNode = function (node, startAngle) {
	      if (!node) {
	        return;
	      }
	
	      var endAngle = startAngle; // Render self
	
	      if (node !== virtualRoot) {
	        // Tree node is virtual, so it doesn't need to be drawn
	        var value = node.getValue();
	        var angle = sum === 0 && stillShowZeroSum ? unitRadian : value * unitRadian;
	
	        if (angle < minAngle) {
	          angle = minAngle; // restAngle -= minAngle;
	        } // else {
	        //     valueSumLargerThanMinAngle += value;
	        // }
	
	
	        endAngle = startAngle + dir * angle;
	        var depth = node.depth - rootDepth - (renderRollupNode ? -1 : 1);
	        var rStart = r0 + rPerLevel * depth;
	        var rEnd = r0 + rPerLevel * (depth + 1);
	        var itemModel = node.getModel();
	
	        if (itemModel.get('r0') != null) {
	          rStart = parsePercent(itemModel.get('r0'), size / 2);
	        }
	
	        if (itemModel.get('r') != null) {
	          rEnd = parsePercent(itemModel.get('r'), size / 2);
	        }
	
	        node.setLayout({
	          angle: angle,
	          startAngle: startAngle,
	          endAngle: endAngle,
	          clockwise: clockwise,
	          cx: cx,
	          cy: cy,
	          r0: rStart,
	          r: rEnd
	        });
	      } // Render children
	
	
	      if (node.children && node.children.length) {
	        // currentAngle = startAngle;
	        var siblingAngle = 0;
	        zrUtil.each(node.children, function (node) {
	          siblingAngle += renderNode(node, startAngle + siblingAngle);
	        });
	      }
	
	      return endAngle - startAngle;
	    }; // Virtual root node for roll up
	
	
	    if (renderRollupNode) {
	      var rStart = r0;
	      var rEnd = r0 + rPerLevel;
	      var angle = Math.PI * 2;
	      virtualRoot.setLayout({
	        angle: angle,
	        startAngle: startAngle,
	        endAngle: startAngle + angle,
	        clockwise: clockwise,
	        cx: cx,
	        cy: cy,
	        r0: rStart,
	        r: rEnd
	      });
	    }
	
	    renderNode(treeRoot, startAngle);
	  });
	}
	/**
	 * Init node children by order and update visual
	 *
	 * @param {TreeNode} node  root node
	 * @param {boolean}  isAsc if is in ascendant order
	 */
	
	
	function initChildren(node, isAsc) {
	  var children = node.children || [];
	  node.children = sort(children, isAsc); // Init children recursively
	
	  if (children.length) {
	    zrUtil.each(node.children, function (child) {
	      initChildren(child, isAsc);
	    });
	  }
	}
	/**
	 * Sort children nodes
	 *
	 * @param {TreeNode[]}               children children of node to be sorted
	 * @param {string | function | null} sort sort method
	 *                                   See SunburstSeries.js for details.
	 */
	
	
	function sort(children, sortOrder) {
	  if (typeof sortOrder === 'function') {
	    return children.sort(sortOrder);
	  } else {
	    var isAsc = sortOrder === 'asc';
	    return children.sort(function (a, b) {
	      var diff = (a.getValue() - b.getValue()) * (isAsc ? 1 : -1);
	      return diff === 0 ? (a.dataIndex - b.dataIndex) * (isAsc ? -1 : 1) : diff;
	    });
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2294 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(852);
	
	__webpack_require__(2295);
	
	__webpack_require__(2296);
	
	var themeRiverLayout = __webpack_require__(2297);
	
	var themeRiverVisual = __webpack_require__(2298);
	
	var dataFilter = __webpack_require__(296);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerLayout(themeRiverLayout);
	echarts.registerVisual(themeRiverVisual);
	echarts.registerProcessor(dataFilter('themeRiver'));

/***/ },
/* 2295 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(77);
	
	var createDimensions = __webpack_require__(251);
	
	var _dimensionHelper = __webpack_require__(293);
	
	var getDimensionTypeByAxis = _dimensionHelper.getDimensionTypeByAxis;
	
	var List = __webpack_require__(109);
	
	var zrUtil = __webpack_require__(4);
	
	var _model = __webpack_require__(29);
	
	var groupData = _model.groupData;
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var LegendVisualProvider = __webpack_require__(298);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DATA_NAME_INDEX = 2;
	var ThemeRiverSeries = SeriesModel.extend({
	  type: 'series.themeRiver',
	  dependencies: ['singleAxis'],
	
	  /**
	   * @readOnly
	   * @type {module:zrender/core/util#HashMap}
	   */
	  nameMap: null,
	
	  /**
	   * @override
	   */
	  init: function (option) {
	    // eslint-disable-next-line
	    ThemeRiverSeries.superApply(this, 'init', arguments); // Put this function here is for the sake of consistency of code style.
	    // Enable legend selection for each data item
	    // Use a function instead of direct access because data reference may changed
	
	    this.legendVisualProvider = new LegendVisualProvider(zrUtil.bind(this.getData, this), zrUtil.bind(this.getRawData, this));
	  },
	
	  /**
	   * If there is no value of a certain point in the time for some event,set it value to 0.
	   *
	   * @param {Array} data  initial data in the option
	   * @return {Array}
	   */
	  fixData: function (data) {
	    var rawDataLength = data.length;
	    /**
	     * Make sure every layer data get the same keys.
	     * The value index tells which layer has visited.
	     * {
	     *  2014/01/01: -1
	     * }
	     */
	
	    var timeValueKeys = {}; // grouped data by name
	
	    var groupResult = groupData(data, function (item) {
	      if (!timeValueKeys.hasOwnProperty(item[0])) {
	        timeValueKeys[item[0]] = -1;
	      }
	
	      return item[2];
	    });
	    var layData = [];
	    groupResult.buckets.each(function (items, key) {
	      layData.push({
	        name: key,
	        dataList: items
	      });
	    });
	    var layerNum = layData.length;
	
	    for (var k = 0; k < layerNum; ++k) {
	      var name = layData[k].name;
	
	      for (var j = 0; j < layData[k].dataList.length; ++j) {
	        var timeValue = layData[k].dataList[j][0];
	        timeValueKeys[timeValue] = k;
	      }
	
	      for (var timeValue in timeValueKeys) {
	        if (timeValueKeys.hasOwnProperty(timeValue) && timeValueKeys[timeValue] !== k) {
	          timeValueKeys[timeValue] = k;
	          data[rawDataLength] = [];
	          data[rawDataLength][0] = timeValue;
	          data[rawDataLength][1] = 0;
	          data[rawDataLength][2] = name;
	          rawDataLength++;
	        }
	      }
	    }
	
	    return data;
	  },
	
	  /**
	   * @override
	   * @param  {Object} option  the initial option that user gived
	   * @param  {module:echarts/model/Model} ecModel  the model object for themeRiver option
	   * @return {module:echarts/data/List}
	   */
	  getInitialData: function (option, ecModel) {
	    var singleAxisModel = ecModel.queryComponents({
	      mainType: 'singleAxis',
	      index: this.get('singleAxisIndex'),
	      id: this.get('singleAxisId')
	    })[0];
	    var axisType = singleAxisModel.get('type'); // filter the data item with the value of label is undefined
	
	    var filterData = zrUtil.filter(option.data, function (dataItem) {
	      return dataItem[2] !== undefined;
	    }); // ??? TODO design a stage to transfer data for themeRiver and lines?
	
	    var data = this.fixData(filterData || []);
	    var nameList = [];
	    var nameMap = this.nameMap = zrUtil.createHashMap();
	    var count = 0;
	
	    for (var i = 0; i < data.length; ++i) {
	      nameList.push(data[i][DATA_NAME_INDEX]);
	
	      if (!nameMap.get(data[i][DATA_NAME_INDEX])) {
	        nameMap.set(data[i][DATA_NAME_INDEX], count);
	        count++;
	      }
	    }
	
	    var dimensionsInfo = createDimensions(data, {
	      coordDimensions: ['single'],
	      dimensionsDefine: [{
	        name: 'time',
	        type: getDimensionTypeByAxis(axisType)
	      }, {
	        name: 'value',
	        type: 'float'
	      }, {
	        name: 'name',
	        type: 'ordinal'
	      }],
	      encodeDefine: {
	        single: 0,
	        value: 1,
	        itemName: 2
	      }
	    });
	    var list = new List(dimensionsInfo, this);
	    list.initData(data);
	    return list;
	  },
	
	  /**
	   * The raw data is divided into multiple layers and each layer
	   *     has same name.
	   *
	   * @return {Array.<Array.<number>>}
	   */
	  getLayerSeries: function () {
	    var data = this.getData();
	    var lenCount = data.count();
	    var indexArr = [];
	
	    for (var i = 0; i < lenCount; ++i) {
	      indexArr[i] = i;
	    }
	
	    var timeDim = data.mapDimension('single'); // data group by name
	
	    var groupResult = groupData(indexArr, function (index) {
	      return data.get('name', index);
	    });
	    var layerSeries = [];
	    groupResult.buckets.each(function (items, key) {
	      items.sort(function (index1, index2) {
	        return data.get(timeDim, index1) - data.get(timeDim, index2);
	      });
	      layerSeries.push({
	        name: key,
	        indices: items
	      });
	    });
	    return layerSeries;
	  },
	
	  /**
	   * Get data indices for show tooltip content
	    * @param {Array.<string>|string} dim  single coordinate dimension
	   * @param {number} value axis value
	   * @param {module:echarts/coord/single/SingleAxis} baseAxis  single Axis used
	   *     the themeRiver.
	   * @return {Object} {dataIndices, nestestValue}
	   */
	  getAxisTooltipData: function (dim, value, baseAxis) {
	    if (!zrUtil.isArray(dim)) {
	      dim = dim ? [dim] : [];
	    }
	
	    var data = this.getData();
	    var layerSeries = this.getLayerSeries();
	    var indices = [];
	    var layerNum = layerSeries.length;
	    var nestestValue;
	
	    for (var i = 0; i < layerNum; ++i) {
	      var minDist = Number.MAX_VALUE;
	      var nearestIdx = -1;
	      var pointNum = layerSeries[i].indices.length;
	
	      for (var j = 0; j < pointNum; ++j) {
	        var theValue = data.get(dim[0], layerSeries[i].indices[j]);
	        var dist = Math.abs(theValue - value);
	
	        if (dist <= minDist) {
	          nestestValue = theValue;
	          minDist = dist;
	          nearestIdx = layerSeries[i].indices[j];
	        }
	      }
	
	      indices.push(nearestIdx);
	    }
	
	    return {
	      dataIndices: indices,
	      nestestValue: nestestValue
	    };
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex  index of data
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var htmlName = data.getName(dataIndex);
	    var htmlValue = data.get(data.mapDimension('value'), dataIndex);
	
	    if (isNaN(htmlValue) || htmlValue == null) {
	      htmlValue = '-';
	    }
	
	    return encodeHTML(htmlName + ' : ' + htmlValue);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'singleAxis',
	    // gap in axis's orthogonal orientation
	    boundaryGap: ['10%', '10%'],
	    // legendHoverLink: true,
	    singleAxisIndex: 0,
	    animationEasing: 'linear',
	    label: {
	      margin: 4,
	      show: true,
	      position: 'left',
	      color: '#000',
	      fontSize: 11
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	var _default = ThemeRiverSeries;
	module.exports = _default;

/***/ },
/* 2296 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var _poly = __webpack_require__(831);
	
	var Polygon = _poly.Polygon;
	
	var graphic = __webpack_require__(14);
	
	var _util = __webpack_require__(4);
	
	var bind = _util.bind;
	var extend = _util.extend;
	
	var DataDiffer = __webpack_require__(211);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendChartView({
	  type: 'themeRiver',
	  init: function () {
	    this._layers = [];
	  },
	  render: function (seriesModel, ecModel, api) {
	    var data = seriesModel.getData();
	    var group = this.group;
	    var layerSeries = seriesModel.getLayerSeries();
	    var layoutInfo = data.getLayout('layoutInfo');
	    var rect = layoutInfo.rect;
	    var boundaryGap = layoutInfo.boundaryGap;
	    group.attr('position', [0, rect.y + boundaryGap[0]]);
	
	    function keyGetter(item) {
	      return item.name;
	    }
	
	    var dataDiffer = new DataDiffer(this._layersSeries || [], layerSeries, keyGetter, keyGetter);
	    var newLayersGroups = {};
	    dataDiffer.add(bind(process, this, 'add')).update(bind(process, this, 'update')).remove(bind(process, this, 'remove')).execute();
	
	    function process(status, idx, oldIdx) {
	      var oldLayersGroups = this._layers;
	
	      if (status === 'remove') {
	        group.remove(oldLayersGroups[idx]);
	        return;
	      }
	
	      var points0 = [];
	      var points1 = [];
	      var color;
	      var indices = layerSeries[idx].indices;
	
	      for (var j = 0; j < indices.length; j++) {
	        var layout = data.getItemLayout(indices[j]);
	        var x = layout.x;
	        var y0 = layout.y0;
	        var y = layout.y;
	        points0.push([x, y0]);
	        points1.push([x, y0 + y]);
	        color = data.getItemVisual(indices[j], 'color');
	      }
	
	      var polygon;
	      var text;
	      var textLayout = data.getItemLayout(indices[0]);
	      var itemModel = data.getItemModel(indices[j - 1]);
	      var labelModel = itemModel.getModel('label');
	      var margin = labelModel.get('margin');
	
	      if (status === 'add') {
	        var layerGroup = newLayersGroups[idx] = new graphic.Group();
	        polygon = new Polygon({
	          shape: {
	            points: points0,
	            stackedOnPoints: points1,
	            smooth: 0.4,
	            stackedOnSmooth: 0.4,
	            smoothConstraint: false
	          },
	          z2: 0
	        });
	        text = new graphic.Text({
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        });
	        layerGroup.add(polygon);
	        layerGroup.add(text);
	        group.add(layerGroup);
	        polygon.setClipPath(createGridClipShape(polygon.getBoundingRect(), seriesModel, function () {
	          polygon.removeClipPath();
	        }));
	      } else {
	        var layerGroup = oldLayersGroups[oldIdx];
	        polygon = layerGroup.childAt(0);
	        text = layerGroup.childAt(1);
	        group.add(layerGroup);
	        newLayersGroups[idx] = layerGroup;
	        graphic.updateProps(polygon, {
	          shape: {
	            points: points0,
	            stackedOnPoints: points1
	          }
	        }, seriesModel);
	        graphic.updateProps(text, {
	          style: {
	            x: textLayout.x - margin,
	            y: textLayout.y0 + textLayout.y / 2
	          }
	        }, seriesModel);
	      }
	
	      var hoverItemStyleModel = itemModel.getModel('emphasis.itemStyle');
	      var itemStyleModel = itemModel.getModel('itemStyle');
	      graphic.setTextStyle(text.style, labelModel, {
	        text: labelModel.get('show') ? seriesModel.getFormattedLabel(indices[j - 1], 'normal') || data.getName(indices[j - 1]) : null,
	        textVerticalAlign: 'middle'
	      });
	      polygon.setStyle(extend({
	        fill: color
	      }, itemStyleModel.getItemStyle(['color'])));
	      graphic.setHoverStyle(polygon, hoverItemStyleModel.getItemStyle());
	    }
	
	    this._layersSeries = layerSeries;
	    this._layers = newLayersGroups;
	  },
	  dispose: function () {}
	}); // add animation to the view
	
	
	function createGridClipShape(rect, seriesModel, cb) {
	  var rectEl = new graphic.Rect({
	    shape: {
	      x: rect.x - 10,
	      y: rect.y - 10,
	      width: 0,
	      height: rect.height + 20
	    }
	  });
	  graphic.initProps(rectEl, {
	    shape: {
	      width: rect.width + 20,
	      height: rect.height + 20
	    }
	  }, seriesModel, cb);
	  return rectEl;
	}
	
	module.exports = _default;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ },
/* 2297 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var numberUtil = __webpack_require__(25);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var single = seriesModel.coordinateSystem;
	    var layoutInfo = {}; // use the axis boundingRect for view
	
	    var rect = single.getRect();
	    layoutInfo.rect = rect;
	    var boundaryGap = seriesModel.get('boundaryGap');
	    var axis = single.getAxis();
	    layoutInfo.boundaryGap = boundaryGap;
	
	    if (axis.orient === 'horizontal') {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.height);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.height);
	      var height = rect.height - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, height);
	    } else {
	      boundaryGap[0] = numberUtil.parsePercent(boundaryGap[0], rect.width);
	      boundaryGap[1] = numberUtil.parsePercent(boundaryGap[1], rect.width);
	      var width = rect.width - boundaryGap[0] - boundaryGap[1];
	      themeRiverLayout(data, seriesModel, width);
	    }
	
	    data.setLayout('layoutInfo', layoutInfo);
	  });
	}
	/**
	 * The layout information about themeriver
	 *
	 * @param {module:echarts/data/List} data  data in the series
	 * @param {module:echarts/model/Series} seriesModel  the model object of themeRiver series
	 * @param {number} height  value used to compute every series height
	 */
	
	
	function themeRiverLayout(data, seriesModel, height) {
	  if (!data.count()) {
	    return;
	  }
	
	  var coordSys = seriesModel.coordinateSystem; // the data in each layer are organized into a series.
	
	  var layerSeries = seriesModel.getLayerSeries(); // the points in each layer.
	
	  var timeDim = data.mapDimension('single');
	  var valueDim = data.mapDimension('value');
	  var layerPoints = zrUtil.map(layerSeries, function (singleLayer) {
	    return zrUtil.map(singleLayer.indices, function (idx) {
	      var pt = coordSys.dataToPoint(data.get(timeDim, idx));
	      pt[1] = data.get(valueDim, idx);
	      return pt;
	    });
	  });
	  var base = computeBaseline(layerPoints);
	  var baseLine = base.y0;
	  var ky = height / base.max; // set layout information for each item.
	
	  var n = layerSeries.length;
	  var m = layerSeries[0].indices.length;
	  var baseY0;
	
	  for (var j = 0; j < m; ++j) {
	    baseY0 = baseLine[j] * ky;
	    data.setItemLayout(layerSeries[0].indices[j], {
	      layerIndex: 0,
	      x: layerPoints[0][j][0],
	      y0: baseY0,
	      y: layerPoints[0][j][1] * ky
	    });
	
	    for (var i = 1; i < n; ++i) {
	      baseY0 += layerPoints[i - 1][j][1] * ky;
	      data.setItemLayout(layerSeries[i].indices[j], {
	        layerIndex: i,
	        x: layerPoints[i][j][0],
	        y0: baseY0,
	        y: layerPoints[i][j][1] * ky
	      });
	    }
	  }
	}
	/**
	 * Compute the baseLine of the rawdata
	 * Inspired by Lee Byron's paper Stacked Graphs - Geometry & Aesthetics
	 *
	 * @param  {Array.<Array>} data  the points in each layer
	 * @return {Object}
	 */
	
	
	function computeBaseline(data) {
	  var layerNum = data.length;
	  var pointNum = data[0].length;
	  var sums = [];
	  var y0 = [];
	  var max = 0;
	  var temp;
	  var base = {};
	
	  for (var i = 0; i < pointNum; ++i) {
	    for (var j = 0, temp = 0; j < layerNum; ++j) {
	      temp += data[j][i][1];
	    }
	
	    if (temp > max) {
	      max = temp;
	    }
	
	    sums.push(temp);
	  }
	
	  for (var k = 0; k < pointNum; ++k) {
	    y0[k] = (max - sums[k]) / 2;
	  }
	
	  max = 0;
	
	  for (var l = 0; l < pointNum; ++l) {
	    var sum = sums[l] + y0[l];
	
	    if (sum > max) {
	      max = sum;
	    }
	  }
	
	  base.y0 = y0;
	  base.max = max;
	  return base;
	}
	
	module.exports = _default;

/***/ },
/* 2298 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var createHashMap = _util.createHashMap;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  ecModel.eachSeriesByType('themeRiver', function (seriesModel) {
	    var data = seriesModel.getData();
	    var rawData = seriesModel.getRawData();
	    var colorList = seriesModel.get('color');
	    var idxMap = createHashMap();
	    data.each(function (idx) {
	      idxMap.set(data.getRawIndex(idx), idx);
	    });
	    rawData.each(function (rawIndex) {
	      var name = rawData.getName(rawIndex);
	      var color = colorList[(seriesModel.nameMap.get(name) - 1) % colorList.length];
	      rawData.setItemVisual(rawIndex, 'color', color);
	      var idx = idxMap.get(rawIndex);
	
	      if (idx != null) {
	        data.setItemVisual(idx, 'color', color);
	      }
	    });
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2299 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2300);
	
	__webpack_require__(2301);
	
	__webpack_require__(2303);
	
	var visualSymbol = __webpack_require__(214);
	
	var treeLayout = __webpack_require__(2304);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(visualSymbol('tree', 'circle'));
	echarts.registerLayout(treeLayout);

/***/ },
/* 2300 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SeriesModel = __webpack_require__(77);
	
	var Tree = __webpack_require__(516);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	var Model = __webpack_require__(70);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.tree',
	  layoutInfo: null,
	  // can support the position parameters 'left', 'top','right','bottom', 'width',
	  // 'height' in the setOption() with 'merge' mode normal.
	  layoutMode: 'box',
	
	  /**
	   * Init a tree data structure from data in option series
	   * @param  {Object} option  the object used to config echarts view
	   * @return {module:echarts/data/List} storage initial data
	   */
	  getInitialData: function (option) {
	    //create an virtual root
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    var leaves = option.leaves || {};
	    var leavesModel = new Model(leaves, this, this.ecModel);
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	
	        if (!node.children.length || !node.isExpand) {
	          model.parentModel = leavesModel;
	        }
	
	        return model;
	      });
	    }
	
	    var treeDepth = 0;
	    tree.eachNode('preorder', function (node) {
	      if (node.depth > treeDepth) {
	        treeDepth = node.depth;
	      }
	    });
	    var expandAndCollapse = option.expandAndCollapse;
	    var expandTreeDepth = expandAndCollapse && option.initialTreeDepth >= 0 ? option.initialTreeDepth : treeDepth;
	    tree.root.eachNode('preorder', function (node) {
	      var item = node.hostTree.data.getRawDataItem(node.dataIndex); // Add item.collapsed != null, because users can collapse node original in the series.data.
	
	      node.isExpand = item && item.collapsed != null ? !item.collapsed : node.depth <= expandTreeDepth;
	    });
	    return tree.data;
	  },
	
	  /**
	   * Make the configuration 'orient' backward compatibly, with 'horizontal = LR', 'vertical = TB'.
	   * @returns {string} orient
	   */
	  getOrient: function () {
	    var orient = this.get('orient');
	
	    if (orient === 'horizontal') {
	      orient = 'LR';
	    } else if (orient === 'vertical') {
	      orient = 'TB';
	    }
	
	    return orient;
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   */
	  formatTooltip: function (dataIndex) {
	    var tree = this.getData().tree;
	    var realRoot = tree.root.children[0];
	    var node = tree.getNodeByDataIndex(dataIndex);
	    var value = node.getValue();
	    var name = node.name;
	
	    while (node && node !== realRoot) {
	      name = node.parentNode.name + '.' + name;
	      node = node.parentNode;
	    }
	
	    return encodeHTML(name + (isNaN(value) || value == null ? '' : ' : ' + value));
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    coordinateSystem: 'view',
	    // the position of the whole view
	    left: '12%',
	    top: '12%',
	    right: '12%',
	    bottom: '12%',
	    // the layout of the tree, two value can be selected, 'orthogonal' or 'radial'
	    layout: 'orthogonal',
	    // value can be 'polyline'
	    edgeShape: 'curve',
	    edgeForkPosition: '50%',
	    // true | false | 'move' | 'scale', see module:component/helper/RoamController.
	    roam: false,
	    // Symbol size scale ratio in roam
	    nodeScaleRatio: 0.4,
	    // Default on center of graph
	    center: null,
	    zoom: 1,
	    // The orient of orthoginal layout, can be setted to 'LR', 'TB', 'RL', 'BT'.
	    // and the backward compatibility configuration 'horizontal = LR', 'vertical = TB'.
	    orient: 'LR',
	    symbol: 'emptyCircle',
	    symbolSize: 7,
	    expandAndCollapse: true,
	    initialTreeDepth: 2,
	    lineStyle: {
	      color: '#ccc',
	      width: 1.5,
	      curveness: 0.5
	    },
	    itemStyle: {
	      color: 'lightsteelblue',
	      borderColor: '#c23531',
	      borderWidth: 1.5
	    },
	    label: {
	      show: true,
	      color: '#555'
	    },
	    leaves: {
	      label: {
	        show: true
	      }
	    },
	    animationEasing: 'linear',
	    animationDuration: 700,
	    animationDurationUpdate: 1000
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2301 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var SymbolClz = __webpack_require__(352);
	
	var _layoutHelper = __webpack_require__(833);
	
	var radialCoordinate = _layoutHelper.radialCoordinate;
	
	var echarts = __webpack_require__(10);
	
	var bbox = __webpack_require__(314);
	
	var View = __webpack_require__(511);
	
	var roamHelper = __webpack_require__(506);
	
	var RoamController = __webpack_require__(291);
	
	var _cursorHelper = __webpack_require__(356);
	
	var onIrrelevantElement = _cursorHelper.onIrrelevantElement;
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TreeShape = graphic.extendShape({
	  shape: {
	    parentPoint: [],
	    childPoints: [],
	    orient: '',
	    forkPosition: ''
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var childPoints = shape.childPoints;
	    var childLen = childPoints.length;
	    var parentPoint = shape.parentPoint;
	    var firstChildPos = childPoints[0];
	    var lastChildPos = childPoints[childLen - 1];
	
	    if (childLen === 1) {
	      ctx.moveTo(parentPoint[0], parentPoint[1]);
	      ctx.lineTo(firstChildPos[0], firstChildPos[1]);
	      return;
	    }
	
	    var orient = shape.orient;
	    var forkDim = orient === 'TB' || orient === 'BT' ? 0 : 1;
	    var otherDim = 1 - forkDim;
	    var forkPosition = parsePercent(shape.forkPosition, 1);
	    var tmpPoint = [];
	    tmpPoint[forkDim] = parentPoint[forkDim];
	    tmpPoint[otherDim] = parentPoint[otherDim] + (lastChildPos[otherDim] - parentPoint[otherDim]) * forkPosition;
	    ctx.moveTo(parentPoint[0], parentPoint[1]);
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    ctx.moveTo(firstChildPos[0], firstChildPos[1]);
	    tmpPoint[forkDim] = firstChildPos[forkDim];
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    tmpPoint[forkDim] = lastChildPos[forkDim];
	    ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    ctx.lineTo(lastChildPos[0], lastChildPos[1]);
	
	    for (var i = 1; i < childLen - 1; i++) {
	      var point = childPoints[i];
	      ctx.moveTo(point[0], point[1]);
	      tmpPoint[forkDim] = point[forkDim];
	      ctx.lineTo(tmpPoint[0], tmpPoint[1]);
	    }
	  }
	});
	
	var _default = echarts.extendChartView({
	  type: 'tree',
	
	  /**
	   * Init the chart
	   * @override
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup = new graphic.Group();
	    /**
	     * @private
	     * @type {module:echarts/componet/helper/RoamController}
	     */
	
	    this._controller = new RoamController(api.getZr());
	    this._controllerHost = {
	      target: this.group
	    };
	    this.group.add(this._mainGroup);
	  },
	  render: function (seriesModel, ecModel, api, payload) {
	    var data = seriesModel.getData();
	    var layoutInfo = seriesModel.layoutInfo;
	    var group = this._mainGroup;
	    var layout = seriesModel.get('layout');
	
	    if (layout === 'radial') {
	      group.attr('position', [layoutInfo.x + layoutInfo.width / 2, layoutInfo.y + layoutInfo.height / 2]);
	    } else {
	      group.attr('position', [layoutInfo.x, layoutInfo.y]);
	    }
	
	    this._updateViewCoordSys(seriesModel, layoutInfo, layout);
	
	    this._updateController(seriesModel, ecModel, api);
	
	    var oldData = this._data;
	    var seriesScope = {
	      expandAndCollapse: seriesModel.get('expandAndCollapse'),
	      layout: layout,
	      edgeShape: seriesModel.get('edgeShape'),
	      edgeForkPosition: seriesModel.get('edgeForkPosition'),
	      orient: seriesModel.getOrient(),
	      curvature: seriesModel.get('lineStyle.curveness'),
	      symbolRotate: seriesModel.get('symbolRotate'),
	      symbolOffset: seriesModel.get('symbolOffset'),
	      hoverAnimation: seriesModel.get('hoverAnimation'),
	      useNameLabel: true,
	      fadeIn: true
	    };
	    data.diff(oldData).add(function (newIdx) {
	      if (symbolNeedsDraw(data, newIdx)) {
	        // Create node and edge
	        updateNode(data, newIdx, null, group, seriesModel, seriesScope);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx);
	
	      if (!symbolNeedsDraw(data, newIdx)) {
	        symbolEl && removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
	        return;
	      } // Update node and edge
	
	
	      updateNode(data, newIdx, symbolEl, group, seriesModel, seriesScope);
	    }).remove(function (oldIdx) {
	      var symbolEl = oldData.getItemGraphicEl(oldIdx); // When remove a collapsed node of subtree, since the collapsed
	      // node haven't been initialized with a symbol element,
	      // you can't found it's symbol element through index.
	      // so if we want to remove the symbol element we should insure
	      // that the symbol element is not null.
	
	      if (symbolEl) {
	        removeNode(oldData, oldIdx, symbolEl, group, seriesModel, seriesScope);
	      }
	    }).execute();
	    this._nodeScaleRatio = seriesModel.get('nodeScaleRatio');
	
	    this._updateNodeAndLinkScale(seriesModel);
	
	    if (seriesScope.expandAndCollapse === true) {
	      data.eachItemGraphicEl(function (el, dataIndex) {
	        el.off('click').on('click', function () {
	          api.dispatchAction({
	            type: 'treeExpandAndCollapse',
	            seriesId: seriesModel.id,
	            dataIndex: dataIndex
	          });
	        });
	      });
	    }
	
	    this._data = data;
	  },
	  _updateViewCoordSys: function (seriesModel) {
	    var data = seriesModel.getData();
	    var points = [];
	    data.each(function (idx) {
	      var layout = data.getItemLayout(idx);
	
	      if (layout && !isNaN(layout.x) && !isNaN(layout.y)) {
	        points.push([+layout.x, +layout.y]);
	      }
	    });
	    var min = [];
	    var max = [];
	    bbox.fromPoints(points, min, max); // If don't Store min max when collapse the root node after roam,
	    // the root node will disappear.
	
	    var oldMin = this._min;
	    var oldMax = this._max; // If width or height is 0
	
	    if (max[0] - min[0] === 0) {
	      min[0] = oldMin ? oldMin[0] : min[0] - 1;
	      max[0] = oldMax ? oldMax[0] : max[0] + 1;
	    }
	
	    if (max[1] - min[1] === 0) {
	      min[1] = oldMin ? oldMin[1] : min[1] - 1;
	      max[1] = oldMax ? oldMax[1] : max[1] + 1;
	    }
	
	    var viewCoordSys = seriesModel.coordinateSystem = new View();
	    viewCoordSys.zoomLimit = seriesModel.get('scaleLimit');
	    viewCoordSys.setBoundingRect(min[0], min[1], max[0] - min[0], max[1] - min[1]);
	    viewCoordSys.setCenter(seriesModel.get('center'));
	    viewCoordSys.setZoom(seriesModel.get('zoom')); // Here we use viewCoordSys just for computing the 'position' and 'scale' of the group
	
	    this.group.attr({
	      position: viewCoordSys.position,
	      scale: viewCoordSys.scale
	    });
	    this._viewCoordSys = viewCoordSys;
	    this._min = min;
	    this._max = max;
	  },
	  _updateController: function (seriesModel, ecModel, api) {
	    var controller = this._controller;
	    var controllerHost = this._controllerHost;
	    var group = this.group;
	    controller.setPointerChecker(function (e, x, y) {
	      var rect = group.getBoundingRect();
	      rect.applyTransform(group.transform);
	      return rect.contain(x, y) && !onIrrelevantElement(e, api, seriesModel);
	    });
	    controller.enable(seriesModel.get('roam'));
	    controllerHost.zoomLimit = seriesModel.get('scaleLimit');
	    controllerHost.zoom = seriesModel.coordinateSystem.getZoom();
	    controller.off('pan').off('zoom').on('pan', function (e) {
	      roamHelper.updateViewOnPan(controllerHost, e.dx, e.dy);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'treeRoam',
	        dx: e.dx,
	        dy: e.dy
	      });
	    }, this).on('zoom', function (e) {
	      roamHelper.updateViewOnZoom(controllerHost, e.scale, e.originX, e.originY);
	      api.dispatchAction({
	        seriesId: seriesModel.id,
	        type: 'treeRoam',
	        zoom: e.scale,
	        originX: e.originX,
	        originY: e.originY
	      });
	
	      this._updateNodeAndLinkScale(seriesModel);
	    }, this);
	  },
	  _updateNodeAndLinkScale: function (seriesModel) {
	    var data = seriesModel.getData();
	
	    var nodeScale = this._getNodeGlobalScale(seriesModel);
	
	    var invScale = [nodeScale, nodeScale];
	    data.eachItemGraphicEl(function (el, idx) {
	      el.attr('scale', invScale);
	    });
	  },
	  _getNodeGlobalScale: function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys.type !== 'view') {
	      return 1;
	    }
	
	    var nodeScaleRatio = this._nodeScaleRatio;
	    var groupScale = coordSys.scale;
	    var groupZoom = groupScale && groupScale[0] || 1; // Scale node when zoom changes
	
	    var roamZoom = coordSys.getZoom();
	    var nodeScale = (roamZoom - 1) * nodeScaleRatio + 1;
	    return nodeScale / groupZoom;
	  },
	  dispose: function () {
	    this._controller && this._controller.dispose();
	    this._controllerHost = {};
	  },
	  remove: function () {
	    this._mainGroup.removeAll();
	
	    this._data = null;
	  }
	});
	
	function symbolNeedsDraw(data, dataIndex) {
	  var layout = data.getItemLayout(dataIndex);
	  return layout && !isNaN(layout.x) && !isNaN(layout.y) && data.getItemVisual(dataIndex, 'symbol') !== 'none';
	}
	
	function getTreeNodeStyle(node, itemModel, seriesScope) {
	  seriesScope.itemModel = itemModel;
	  seriesScope.itemStyle = itemModel.getModel('itemStyle').getItemStyle();
	  seriesScope.hoverItemStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	  seriesScope.lineStyle = itemModel.getModel('lineStyle').getLineStyle();
	  seriesScope.labelModel = itemModel.getModel('label');
	  seriesScope.hoverLabelModel = itemModel.getModel('emphasis.label');
	
	  if (node.isExpand === false && node.children.length !== 0) {
	    seriesScope.symbolInnerColor = seriesScope.itemStyle.fill;
	  } else {
	    seriesScope.symbolInnerColor = '#fff';
	  }
	
	  return seriesScope;
	}
	
	function updateNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var isInit = !symbolEl;
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var virtualRoot = data.tree.root;
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	  var sourceLayout = source.getLayout();
	  var sourceOldLayout = sourceSymbolEl ? {
	    x: sourceSymbolEl.position[0],
	    y: sourceSymbolEl.position[1],
	    rawX: sourceSymbolEl.__radialOldRawX,
	    rawY: sourceSymbolEl.__radialOldRawY
	  } : sourceLayout;
	  var targetLayout = node.getLayout();
	
	  if (isInit) {
	    symbolEl = new SymbolClz(data, dataIndex, seriesScope);
	    symbolEl.attr('position', [sourceOldLayout.x, sourceOldLayout.y]);
	  } else {
	    symbolEl.updateData(data, dataIndex, seriesScope);
	  }
	
	  symbolEl.__radialOldRawX = symbolEl.__radialRawX;
	  symbolEl.__radialOldRawY = symbolEl.__radialRawY;
	  symbolEl.__radialRawX = targetLayout.rawX;
	  symbolEl.__radialRawY = targetLayout.rawY;
	  group.add(symbolEl);
	  data.setItemGraphicEl(dataIndex, symbolEl);
	  graphic.updateProps(symbolEl, {
	    position: [targetLayout.x, targetLayout.y]
	  }, seriesModel);
	  var symbolPath = symbolEl.getSymbolPath();
	
	  if (seriesScope.layout === 'radial') {
	    var realRoot = virtualRoot.children[0];
	    var rootLayout = realRoot.getLayout();
	    var length = realRoot.children.length;
	    var rad;
	    var isLeft;
	
	    if (targetLayout.x === rootLayout.x && node.isExpand === true) {
	      var center = {};
	      center.x = (realRoot.children[0].getLayout().x + realRoot.children[length - 1].getLayout().x) / 2;
	      center.y = (realRoot.children[0].getLayout().y + realRoot.children[length - 1].getLayout().y) / 2;
	      rad = Math.atan2(center.y - rootLayout.y, center.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      isLeft = center.x < rootLayout.x;
	
	      if (isLeft) {
	        rad = rad - Math.PI;
	      }
	    } else {
	      rad = Math.atan2(targetLayout.y - rootLayout.y, targetLayout.x - rootLayout.x);
	
	      if (rad < 0) {
	        rad = Math.PI * 2 + rad;
	      }
	
	      if (node.children.length === 0 || node.children.length !== 0 && node.isExpand === false) {
	        isLeft = targetLayout.x < rootLayout.x;
	
	        if (isLeft) {
	          rad = rad - Math.PI;
	        }
	      } else {
	        isLeft = targetLayout.x > rootLayout.x;
	
	        if (!isLeft) {
	          rad = rad - Math.PI;
	        }
	      }
	    }
	
	    var textPosition = isLeft ? 'left' : 'right';
	    var rotate = seriesScope.labelModel.get('rotate');
	    var labelRotateRadian = rotate * (Math.PI / 180);
	    symbolPath.setStyle({
	      textPosition: seriesScope.labelModel.get('position') || textPosition,
	      textRotation: rotate == null ? -rad : labelRotateRadian,
	      textOrigin: 'center',
	      verticalAlign: 'middle'
	    });
	  }
	
	  drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope);
	}
	
	function drawEdge(seriesModel, node, virtualRoot, symbolEl, sourceOldLayout, sourceLayout, targetLayout, group, seriesScope) {
	  var edgeShape = seriesScope.edgeShape;
	  var edge = symbolEl.__edge;
	
	  if (edgeShape === 'curve') {
	    if (node.parentNode && node.parentNode !== virtualRoot) {
	      if (!edge) {
	        edge = symbolEl.__edge = new graphic.BezierCurve({
	          shape: getEdgeShape(seriesScope, sourceOldLayout, sourceOldLayout),
	          style: zrUtil.defaults({
	            opacity: 0,
	            strokeNoScale: true
	          }, seriesScope.lineStyle)
	        });
	      }
	
	      graphic.updateProps(edge, {
	        shape: getEdgeShape(seriesScope, sourceLayout, targetLayout),
	        style: zrUtil.defaults({
	          opacity: 1
	        }, seriesScope.lineStyle)
	      }, seriesModel);
	    }
	  } else if (edgeShape === 'polyline') {
	    if (seriesScope.layout === 'orthogonal') {
	      if (node !== virtualRoot && node.children && node.children.length !== 0 && node.isExpand === true) {
	        var children = node.children;
	        var childPoints = [];
	
	        for (var i = 0; i < children.length; i++) {
	          var childLayout = children[i].getLayout();
	          childPoints.push([childLayout.x, childLayout.y]);
	        }
	
	        if (!edge) {
	          edge = symbolEl.__edge = new TreeShape({
	            shape: {
	              parentPoint: [targetLayout.x, targetLayout.y],
	              childPoints: [[targetLayout.x, targetLayout.y]],
	              orient: seriesScope.orient,
	              forkPosition: seriesScope.edgeForkPosition
	            },
	            style: zrUtil.defaults({
	              opacity: 0,
	              strokeNoScale: true
	            }, seriesScope.lineStyle)
	          });
	        }
	
	        graphic.updateProps(edge, {
	          shape: {
	            parentPoint: [targetLayout.x, targetLayout.y],
	            childPoints: childPoints
	          },
	          style: zrUtil.defaults({
	            opacity: 1
	          }, seriesScope.lineStyle)
	        }, seriesModel);
	      }
	    } else {}
	  }
	
	  group.add(edge);
	}
	
	function removeNode(data, dataIndex, symbolEl, group, seriesModel, seriesScope) {
	  var node = data.tree.getNodeByDataIndex(dataIndex);
	  var virtualRoot = data.tree.root;
	  var itemModel = node.getModel();
	  var seriesScope = getTreeNodeStyle(node, itemModel, seriesScope);
	  var source = node.parentNode === virtualRoot ? node : node.parentNode || node;
	  var edgeShape = seriesScope.edgeShape;
	  var sourceLayout;
	
	  while (sourceLayout = source.getLayout(), sourceLayout == null) {
	    source = source.parentNode === virtualRoot ? source : source.parentNode || source;
	  }
	
	  graphic.updateProps(symbolEl, {
	    position: [sourceLayout.x + 1, sourceLayout.y + 1]
	  }, seriesModel, function () {
	    group.remove(symbolEl);
	    data.setItemGraphicEl(dataIndex, null);
	  });
	  symbolEl.fadeOut(null, {
	    keepLabel: true
	  });
	  var sourceSymbolEl = data.getItemGraphicEl(source.dataIndex);
	  var sourceEdge = sourceSymbolEl.__edge; // 1. when expand the sub tree, delete the children node should delete the edge of
	  // the source at the same time. because the polyline edge shape is only owned by the source.
	  // 2.when the node is the only children of the source, delete the node should delete the edge of
	  // the source at the same time. the same reason as above.
	
	  var edge = symbolEl.__edge || (source.isExpand === false || source.children.length === 1 ? sourceEdge : undefined);
	  var edgeShape = seriesScope.edgeShape;
	
	  if (edge) {
	    if (edgeShape === 'curve') {
	      graphic.updateProps(edge, {
	        shape: getEdgeShape(seriesScope, sourceLayout, sourceLayout),
	        style: {
	          opacity: 0
	        }
	      }, seriesModel, function () {
	        group.remove(edge);
	      });
	    } else if (edgeShape === 'polyline' && seriesScope.layout === 'orthogonal') {
	      graphic.updateProps(edge, {
	        shape: {
	          parentPoint: [sourceLayout.x, sourceLayout.y],
	          childPoints: [[sourceLayout.x, sourceLayout.y]]
	        },
	        style: {
	          opacity: 0
	        }
	      }, seriesModel, function () {
	        group.remove(edge);
	      });
	    }
	  }
	}
	
	function getEdgeShape(seriesScope, sourceLayout, targetLayout) {
	  var cpx1;
	  var cpy1;
	  var cpx2;
	  var cpy2;
	  var orient = seriesScope.orient;
	  var x1;
	  var x2;
	  var y1;
	  var y2;
	
	  if (seriesScope.layout === 'radial') {
	    x1 = sourceLayout.rawX;
	    y1 = sourceLayout.rawY;
	    x2 = targetLayout.rawX;
	    y2 = targetLayout.rawY;
	    var radialCoor1 = radialCoordinate(x1, y1);
	    var radialCoor2 = radialCoordinate(x1, y1 + (y2 - y1) * seriesScope.curvature);
	    var radialCoor3 = radialCoordinate(x2, y2 + (y1 - y2) * seriesScope.curvature);
	    var radialCoor4 = radialCoordinate(x2, y2);
	    return {
	      x1: radialCoor1.x,
	      y1: radialCoor1.y,
	      x2: radialCoor4.x,
	      y2: radialCoor4.y,
	      cpx1: radialCoor2.x,
	      cpy1: radialCoor2.y,
	      cpx2: radialCoor3.x,
	      cpy2: radialCoor3.y
	    };
	  } else {
	    x1 = sourceLayout.x;
	    y1 = sourceLayout.y;
	    x2 = targetLayout.x;
	    y2 = targetLayout.y;
	
	    if (orient === 'LR' || orient === 'RL') {
	      cpx1 = x1 + (x2 - x1) * seriesScope.curvature;
	      cpy1 = y1;
	      cpx2 = x2 + (x1 - x2) * seriesScope.curvature;
	      cpy2 = y2;
	    }
	
	    if (orient === 'TB' || orient === 'BT') {
	      cpx1 = x1;
	      cpy1 = y1 + (y2 - y1) * seriesScope.curvature;
	      cpx2 = x2;
	      cpy2 = y2 + (y1 - y2) * seriesScope.curvature;
	    }
	  }
	
	  return {
	    x1: x1,
	    y1: y1,
	    x2: x2,
	    y2: y2,
	    cpx1: cpx1,
	    cpy1: cpy1,
	    cpx2: cpx2,
	    cpy2: cpy2
	  };
	}
	
	module.exports = _default;

/***/ },
/* 2302 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Traverse the tree from bottom to top and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	function eachAfter(root, callback, separation) {
	  var nodes = [root];
	  var next = [];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    next.push(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = 0; i < children.length; i++) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	
	  while (node = next.pop()) {
	    // jshint ignore:line
	    callback(node, separation);
	  }
	}
	/**
	 * Traverse the tree from top to bottom and do something
	 * @param  {module:echarts/data/Tree~TreeNode} root  The real root of the tree
	 * @param  {Function} callback
	 */
	
	
	function eachBefore(root, callback) {
	  var nodes = [root];
	  var node;
	
	  while (node = nodes.pop()) {
	    // jshint ignore:line
	    callback(node);
	
	    if (node.isExpand) {
	      var children = node.children;
	
	      if (children.length) {
	        for (var i = children.length - 1; i >= 0; i--) {
	          nodes.push(children[i]);
	        }
	      }
	    }
	  }
	}
	
	exports.eachAfter = eachAfter;
	exports.eachBefore = eachBefore;

/***/ },
/* 2303 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var _roamHelper = __webpack_require__(495);
	
	var updateCenterAndZoom = _roamHelper.updateCenterAndZoom;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'treeExpandAndCollapse',
	  event: 'treeExpandAndCollapse',
	  update: 'update'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'tree',
	    query: payload
	  }, function (seriesModel) {
	    var dataIndex = payload.dataIndex;
	    var tree = seriesModel.getData().tree;
	    var node = tree.getNodeByDataIndex(dataIndex);
	    node.isExpand = !node.isExpand;
	  });
	});
	echarts.registerAction({
	  type: 'treeRoam',
	  event: 'treeRoam',
	  // Here we set 'none' instead of 'update', because roam action
	  // just need to update the transform matrix without having to recalculate
	  // the layout. So don't need to go through the whole update process, such
	  // as 'dataPrcocess', 'coordSystemUpdate', 'layout' and so on.
	  update: 'none'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'tree',
	    query: payload
	  }, function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	    var res = updateCenterAndZoom(coordSys, payload);
	    seriesModel.setCenter && seriesModel.setCenter(res.center);
	    seriesModel.setZoom && seriesModel.setZoom(res.zoom);
	  });
	});

/***/ },
/* 2304 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _traversalHelper = __webpack_require__(2302);
	
	var eachAfter = _traversalHelper.eachAfter;
	var eachBefore = _traversalHelper.eachBefore;
	
	var _layoutHelper = __webpack_require__(833);
	
	var init = _layoutHelper.init;
	var firstWalk = _layoutHelper.firstWalk;
	var secondWalk = _layoutHelper.secondWalk;
	var sep = _layoutHelper.separation;
	var radialCoordinate = _layoutHelper.radialCoordinate;
	var getViewRect = _layoutHelper.getViewRect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel, api) {
	  ecModel.eachSeriesByType('tree', function (seriesModel) {
	    commonLayout(seriesModel, api);
	  });
	}
	
	function commonLayout(seriesModel, api) {
	  var layoutInfo = getViewRect(seriesModel, api);
	  seriesModel.layoutInfo = layoutInfo;
	  var layout = seriesModel.get('layout');
	  var width = 0;
	  var height = 0;
	  var separation = null;
	
	  if (layout === 'radial') {
	    width = 2 * Math.PI;
	    height = Math.min(layoutInfo.height, layoutInfo.width) / 2;
	    separation = sep(function (node1, node2) {
	      return (node1.parentNode === node2.parentNode ? 1 : 2) / node1.depth;
	    });
	  } else {
	    width = layoutInfo.width;
	    height = layoutInfo.height;
	    separation = sep();
	  }
	
	  var virtualRoot = seriesModel.getData().tree.root;
	  var realRoot = virtualRoot.children[0];
	
	  if (realRoot) {
	    init(virtualRoot);
	    eachAfter(realRoot, firstWalk, separation);
	    virtualRoot.hierNode.modifier = -realRoot.hierNode.prelim;
	    eachBefore(realRoot, secondWalk);
	    var left = realRoot;
	    var right = realRoot;
	    var bottom = realRoot;
	    eachBefore(realRoot, function (node) {
	      var x = node.getLayout().x;
	
	      if (x < left.getLayout().x) {
	        left = node;
	      }
	
	      if (x > right.getLayout().x) {
	        right = node;
	      }
	
	      if (node.depth > bottom.depth) {
	        bottom = node;
	      }
	    });
	    var delta = left === right ? 1 : separation(left, right) / 2;
	    var tx = delta - left.getLayout().x;
	    var kx = 0;
	    var ky = 0;
	    var coorX = 0;
	    var coorY = 0;
	
	    if (layout === 'radial') {
	      kx = width / (right.getLayout().x + delta + tx); // here we use (node.depth - 1), bucause the real root's depth is 1
	
	      ky = height / (bottom.depth - 1 || 1);
	      eachBefore(realRoot, function (node) {
	        coorX = (node.getLayout().x + tx) * kx;
	        coorY = (node.depth - 1) * ky;
	        var finalCoor = radialCoordinate(coorX, coorY);
	        node.setLayout({
	          x: finalCoor.x,
	          y: finalCoor.y,
	          rawX: coorX,
	          rawY: coorY
	        }, true);
	      });
	    } else {
	      var orient = seriesModel.getOrient();
	
	      if (orient === 'RL' || orient === 'LR') {
	        ky = height / (right.getLayout().x + delta + tx);
	        kx = width / (bottom.depth - 1 || 1);
	        eachBefore(realRoot, function (node) {
	          coorY = (node.getLayout().x + tx) * ky;
	          coorX = orient === 'LR' ? (node.depth - 1) * kx : width - (node.depth - 1) * kx;
	          node.setLayout({
	            x: coorX,
	            y: coorY
	          }, true);
	        });
	      } else if (orient === 'TB' || orient === 'BT') {
	        kx = width / (right.getLayout().x + delta + tx);
	        ky = height / (bottom.depth - 1 || 1);
	        eachBefore(realRoot, function (node) {
	          coorX = (node.getLayout().x + tx) * kx;
	          coorY = orient === 'TB' ? (node.depth - 1) * ky : height - (node.depth - 1) * ky;
	          node.setLayout({
	            x: coorX,
	            y: coorY
	          }, true);
	        });
	      }
	    }
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2305 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2307);
	
	__webpack_require__(2308);
	
	__webpack_require__(2309);
	
	var treemapVisual = __webpack_require__(2311);
	
	var treemapLayout = __webpack_require__(2310);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerVisual(treemapVisual);
	echarts.registerLayout(treemapLayout);

/***/ },
/* 2306 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var graphic = __webpack_require__(14);
	
	var layout = __webpack_require__(46);
	
	var zrUtil = __webpack_require__(4);
	
	var _treeHelper = __webpack_require__(209);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TEXT_PADDING = 8;
	var ITEM_GAP = 8;
	var ARRAY_LENGTH = 5;
	
	function Breadcrumb(containerGroup) {
	  /**
	   * @private
	   * @type {module:zrender/container/Group}
	   */
	  this.group = new graphic.Group();
	  containerGroup.add(this.group);
	}
	
	Breadcrumb.prototype = {
	  constructor: Breadcrumb,
	  render: function (seriesModel, api, targetNode, onSelect) {
	    var model = seriesModel.getModel('breadcrumb');
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    if (!model.get('show') || !targetNode) {
	      return;
	    }
	
	    var normalStyleModel = model.getModel('itemStyle'); // var emphasisStyleModel = model.getModel('emphasis.itemStyle');
	
	    var textStyleModel = normalStyleModel.getModel('textStyle');
	    var layoutParam = {
	      pos: {
	        left: model.get('left'),
	        right: model.get('right'),
	        top: model.get('top'),
	        bottom: model.get('bottom')
	      },
	      box: {
	        width: api.getWidth(),
	        height: api.getHeight()
	      },
	      emptyItemWidth: model.get('emptyItemWidth'),
	      totalWidth: 0,
	      renderList: []
	    };
	
	    this._prepare(targetNode, layoutParam, textStyleModel);
	
	    this._renderContent(seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect);
	
	    layout.positionElement(thisGroup, layoutParam.pos, layoutParam.box);
	  },
	
	  /**
	   * Prepare render list and total width
	   * @private
	   */
	  _prepare: function (targetNode, layoutParam, textStyleModel) {
	    for (var node = targetNode; node; node = node.parentNode) {
	      var text = node.getModel().get('name');
	      var textRect = textStyleModel.getTextRect(text);
	      var itemWidth = Math.max(textRect.width + TEXT_PADDING * 2, layoutParam.emptyItemWidth);
	      layoutParam.totalWidth += itemWidth + ITEM_GAP;
	      layoutParam.renderList.push({
	        node: node,
	        text: text,
	        width: itemWidth
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderContent: function (seriesModel, layoutParam, normalStyleModel, textStyleModel, onSelect) {
	    // Start rendering.
	    var lastX = 0;
	    var emptyItemWidth = layoutParam.emptyItemWidth;
	    var height = seriesModel.get('breadcrumb.height');
	    var availableSize = layout.getAvailableSize(layoutParam.pos, layoutParam.box);
	    var totalWidth = layoutParam.totalWidth;
	    var renderList = layoutParam.renderList;
	
	    for (var i = renderList.length - 1; i >= 0; i--) {
	      var item = renderList[i];
	      var itemNode = item.node;
	      var itemWidth = item.width;
	      var text = item.text; // Hdie text and shorten width if necessary.
	
	      if (totalWidth > availableSize.width) {
	        totalWidth -= itemWidth - emptyItemWidth;
	        itemWidth = emptyItemWidth;
	        text = null;
	      }
	
	      var el = new graphic.Polygon({
	        shape: {
	          points: makeItemPoints(lastX, 0, itemWidth, height, i === renderList.length - 1, i === 0)
	        },
	        style: zrUtil.defaults(normalStyleModel.getItemStyle(), {
	          lineJoin: 'bevel',
	          text: text,
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        }),
	        z: 10,
	        onclick: zrUtil.curry(onSelect, itemNode)
	      });
	      this.group.add(el);
	      packEventData(el, seriesModel, itemNode);
	      lastX += itemWidth + ITEM_GAP;
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this.group.removeAll();
	  }
	};
	
	function makeItemPoints(x, y, itemWidth, itemHeight, head, tail) {
	  var points = [[head ? x : x - ARRAY_LENGTH, y], [x + itemWidth, y], [x + itemWidth, y + itemHeight], [head ? x : x - ARRAY_LENGTH, y + itemHeight]];
	  !tail && points.splice(2, 0, [x + itemWidth + ARRAY_LENGTH, y + itemHeight / 2]);
	  !head && points.push([x, y + itemHeight / 2]);
	  return points;
	} // Package custom mouse event.
	
	
	function packEventData(el, seriesModel, itemNode) {
	  el.eventData = {
	    componentType: 'series',
	    componentSubType: 'treemap',
	    componentIndex: seriesModel.componentIndex,
	    seriesIndex: seriesModel.componentIndex,
	    seriesName: seriesModel.name,
	    seriesType: 'treemap',
	    selfType: 'breadcrumb',
	    // Distinguish with click event on treemap node.
	    nodeData: {
	      dataIndex: itemNode && itemNode.dataIndex,
	      name: itemNode && itemNode.name
	    },
	    treePathInfo: itemNode && wrapTreePathInfo(itemNode, seriesModel)
	  };
	}
	
	var _default = Breadcrumb;
	module.exports = _default;

/***/ },
/* 2307 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var SeriesModel = __webpack_require__(77);
	
	var Tree = __webpack_require__(516);
	
	var Model = __webpack_require__(70);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	var addCommas = _format.addCommas;
	
	var _treeHelper = __webpack_require__(209);
	
	var wrapTreePathInfo = _treeHelper.wrapTreePathInfo;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = SeriesModel.extend({
	  type: 'series.treemap',
	  layoutMode: 'box',
	  dependencies: ['grid', 'polar'],
	  preventUsingHoverLayer: true,
	
	  /**
	   * @type {module:echarts/data/Tree~Node}
	   */
	  _viewRoot: null,
	  defaultOption: {
	    // Disable progressive rendering
	    progressive: 0,
	    // center: ['50%', '50%'],          // not supported in ec3.
	    // size: ['80%', '80%'],            // deprecated, compatible with ec2.
	    left: 'center',
	    top: 'middle',
	    right: null,
	    bottom: null,
	    width: '80%',
	    height: '80%',
	    sort: true,
	    // Can be null or false or true
	    // (order by desc default, asc not supported yet (strange effect))
	    clipWindow: 'origin',
	    // Size of clipped window when zooming. 'origin' or 'fullscreen'
	    squareRatio: 0.5 * (1 + Math.sqrt(5)),
	    // golden ratio
	    leafDepth: null,
	    // Nodes on depth from root are regarded as leaves.
	    // Count from zero (zero represents only view root).
	    drillDownIcon: '▶',
	    // Use html character temporarily because it is complicated
	    // to align specialized icon. ▷▶❒❐▼✚
	    zoomToNodeRatio: 0.32 * 0.32,
	    // Be effective when using zoomToNode. Specify the proportion of the
	    // target node area in the view area.
	    roam: true,
	    // true, false, 'scale' or 'zoom', 'move'.
	    nodeClick: 'zoomToNode',
	    // Leaf node click behaviour: 'zoomToNode', 'link', false.
	    // If leafDepth is set and clicking a node which has children but
	    // be on left depth, the behaviour would be changing root. Otherwise
	    // use behavious defined above.
	    animation: true,
	    animationDurationUpdate: 900,
	    animationEasing: 'quinticInOut',
	    breadcrumb: {
	      show: true,
	      height: 22,
	      left: 'center',
	      top: 'bottom',
	      // right
	      // bottom
	      emptyItemWidth: 25,
	      // Width of empty node.
	      itemStyle: {
	        color: 'rgba(0,0,0,0.7)',
	        //'#5793f3',
	        borderColor: 'rgba(255,255,255,0.7)',
	        borderWidth: 1,
	        shadowColor: 'rgba(150,150,150,1)',
	        shadowBlur: 3,
	        shadowOffsetX: 0,
	        shadowOffsetY: 0,
	        textStyle: {
	          color: '#fff'
	        }
	      },
	      emphasis: {
	        textStyle: {}
	      }
	    },
	    label: {
	      show: true,
	      // Do not use textDistance, for ellipsis rect just the same as treemap node rect.
	      distance: 0,
	      padding: 5,
	      position: 'inside',
	      // Can be [5, '5%'] or position stirng like 'insideTopLeft', ...
	      // formatter: null,
	      color: '#fff',
	      ellipsis: true // align
	      // verticalAlign
	
	    },
	    upperLabel: {
	      // Label when node is parent.
	      show: false,
	      position: [0, '50%'],
	      height: 20,
	      // formatter: null,
	      color: '#fff',
	      ellipsis: true,
	      // align: null,
	      verticalAlign: 'middle'
	    },
	    itemStyle: {
	      color: null,
	      // Can be 'none' if not necessary.
	      colorAlpha: null,
	      // Can be 'none' if not necessary.
	      colorSaturation: null,
	      // Can be 'none' if not necessary.
	      borderWidth: 0,
	      gapWidth: 0,
	      borderColor: '#fff',
	      borderColorSaturation: null // If specified, borderColor will be ineffective, and the
	      // border color is evaluated by color of current node and
	      // borderColorSaturation.
	
	    },
	    emphasis: {
	      upperLabel: {
	        show: true,
	        position: [0, '50%'],
	        color: '#fff',
	        ellipsis: true,
	        verticalAlign: 'middle'
	      }
	    },
	    visualDimension: 0,
	    // Can be 0, 1, 2, 3.
	    visualMin: null,
	    visualMax: null,
	    color: [],
	    // + treemapSeries.color should not be modified. Please only modified
	    // level[n].color (if necessary).
	    // + Specify color list of each level. level[0].color would be global
	    // color list if not specified. (see method `setDefault`).
	    // + But set as a empty array to forbid fetch color from global palette
	    // when using nodeModel.get('color'), otherwise nodes on deep level
	    // will always has color palette set and are not able to inherit color
	    // from parent node.
	    // + TreemapSeries.color can not be set as 'none', otherwise effect
	    // legend color fetching (see seriesColor.js).
	    colorAlpha: null,
	    // Array. Specify color alpha range of each level, like [0.2, 0.8]
	    colorSaturation: null,
	    // Array. Specify color saturation of each level, like [0.2, 0.5]
	    colorMappingBy: 'index',
	    // 'value' or 'index' or 'id'.
	    visibleMin: 10,
	    // If area less than this threshold (unit: pixel^2), node will not
	    // be rendered. Only works when sort is 'asc' or 'desc'.
	    childrenVisibleMin: null,
	    // If area of a node less than this threshold (unit: pixel^2),
	    // grandchildren will not show.
	    // Why grandchildren? If not grandchildren but children,
	    // some siblings show children and some not,
	    // the appearance may be mess and not consistent,
	    levels: [] // Each item: {
	    //     visibleMin, itemStyle, visualDimension, label
	    // }
	    // data: {
	    //      value: [],
	    //      children: [],
	    //      link: 'http://xxx.xxx.xxx',
	    //      target: 'blank' or 'self'
	    // }
	
	  },
	
	  /**
	   * @override
	   */
	  getInitialData: function (option, ecModel) {
	    // Create a virtual root.
	    var root = {
	      name: option.name,
	      children: option.data
	    };
	    completeTreeValue(root);
	    var levels = option.levels || []; // Used in "visual priority" in `treemapVisual.js`.
	    // This way is a little tricky, must satisfy the precondition:
	    //   1. There is no `treeNode.getModel('itemStyle.xxx')` used.
	    //   2. The `Model.prototype.getModel()` will not use any clone-like way.
	
	    var designatedVisualItemStyle = this.designatedVisualItemStyle = {};
	    var designatedVisualModel = new Model({
	      itemStyle: designatedVisualItemStyle
	    }, this, ecModel);
	    levels = option.levels = setDefault(levels, ecModel);
	    var levelModels = zrUtil.map(levels || [], function (levelDefine) {
	      return new Model(levelDefine, designatedVisualModel, ecModel);
	    }, this); // Make sure always a new tree is created when setOption,
	    // in TreemapView, we check whether oldTree === newTree
	    // to choose mappings approach among old shapes and new shapes.
	
	    var tree = Tree.createTree(root, this, beforeLink);
	
	    function beforeLink(nodeData) {
	      nodeData.wrapMethod('getItemModel', function (model, idx) {
	        var node = tree.getNodeByDataIndex(idx);
	        var levelModel = levelModels[node.depth]; // If no levelModel, we also need `designatedVisualModel`.
	
	        model.parentModel = levelModel || designatedVisualModel;
	        return model;
	      });
	    }
	
	    return tree.data;
	  },
	  optionUpdated: function () {
	    this.resetViewRoot();
	  },
	
	  /**
	   * @override
	   * @param {number} dataIndex
	   * @param {boolean} [mutipleSeries=false]
	   */
	  formatTooltip: function (dataIndex) {
	    var data = this.getData();
	    var value = this.getRawValue(dataIndex);
	    var formattedValue = zrUtil.isArray(value) ? addCommas(value[0]) : addCommas(value);
	    var name = data.getName(dataIndex);
	    return encodeHTML(name + ': ' + formattedValue);
	  },
	
	  /**
	   * Add tree path to tooltip param
	   *
	   * @override
	   * @param {number} dataIndex
	   * @return {Object}
	   */
	  getDataParams: function (dataIndex) {
	    var params = SeriesModel.prototype.getDataParams.apply(this, arguments);
	    var node = this.getData().tree.getNodeByDataIndex(dataIndex);
	    params.treePathInfo = wrapTreePathInfo(node, this);
	    return params;
	  },
	
	  /**
	   * @public
	   * @param {Object} layoutInfo {
	   *                                x: containerGroup x
	   *                                y: containerGroup y
	   *                                width: containerGroup width
	   *                                height: containerGroup height
	   *                            }
	   */
	  setLayoutInfo: function (layoutInfo) {
	    /**
	     * @readOnly
	     * @type {Object}
	     */
	    this.layoutInfo = this.layoutInfo || {};
	    zrUtil.extend(this.layoutInfo, layoutInfo);
	  },
	
	  /**
	   * @param  {string} id
	   * @return {number} index
	   */
	  mapIdToIndex: function (id) {
	    // A feature is implemented:
	    // index is monotone increasing with the sequence of
	    // input id at the first time.
	    // This feature can make sure that each data item and its
	    // mapped color have the same index between data list and
	    // color list at the beginning, which is useful for user
	    // to adjust data-color mapping.
	
	    /**
	     * @private
	     * @type {Object}
	     */
	    var idIndexMap = this._idIndexMap;
	
	    if (!idIndexMap) {
	      idIndexMap = this._idIndexMap = zrUtil.createHashMap();
	      /**
	       * @private
	       * @type {number}
	       */
	
	      this._idIndexMapCount = 0;
	    }
	
	    var index = idIndexMap.get(id);
	
	    if (index == null) {
	      idIndexMap.set(id, index = this._idIndexMapCount++);
	    }
	
	    return index;
	  },
	  getViewRoot: function () {
	    return this._viewRoot;
	  },
	
	  /**
	   * @param {module:echarts/data/Tree~Node} [viewRoot]
	   */
	  resetViewRoot: function (viewRoot) {
	    viewRoot ? this._viewRoot = viewRoot : viewRoot = this._viewRoot;
	    var root = this.getRawData().tree.root;
	
	    if (!viewRoot || viewRoot !== root && !root.contains(viewRoot)) {
	      this._viewRoot = root;
	    }
	  }
	});
	/**
	 * @param {Object} dataNode
	 */
	
	
	function completeTreeValue(dataNode) {
	  // Postorder travel tree.
	  // If value of none-leaf node is not set,
	  // calculate it by suming up the value of all children.
	  var sum = 0;
	  zrUtil.each(dataNode.children, function (child) {
	    completeTreeValue(child);
	    var childValue = child.value;
	    zrUtil.isArray(childValue) && (childValue = childValue[0]);
	    sum += childValue;
	  });
	  var thisValue = dataNode.value;
	
	  if (zrUtil.isArray(thisValue)) {
	    thisValue = thisValue[0];
	  }
	
	  if (thisValue == null || isNaN(thisValue)) {
	    thisValue = sum;
	  } // Value should not less than 0.
	
	
	  if (thisValue < 0) {
	    thisValue = 0;
	  }
	
	  zrUtil.isArray(dataNode.value) ? dataNode.value[0] = thisValue : dataNode.value = thisValue;
	}
	/**
	 * set default to level configuration
	 */
	
	
	function setDefault(levels, ecModel) {
	  var globalColorList = ecModel.get('color');
	
	  if (!globalColorList) {
	    return;
	  }
	
	  levels = levels || [];
	  var hasColorDefine;
	  zrUtil.each(levels, function (levelDefine) {
	    var model = new Model(levelDefine);
	    var modelColor = model.get('color');
	
	    if (model.get('itemStyle.color') || modelColor && modelColor !== 'none') {
	      hasColorDefine = true;
	    }
	  });
	
	  if (!hasColorDefine) {
	    var level0 = levels[0] || (levels[0] = {});
	    level0.color = globalColorList.slice();
	  }
	
	  return levels;
	}
	
	module.exports = _default;

/***/ },
/* 2308 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var DataDiffer = __webpack_require__(211);
	
	var helper = __webpack_require__(209);
	
	var Breadcrumb = __webpack_require__(2306);
	
	var RoamController = __webpack_require__(291);
	
	var BoundingRect = __webpack_require__(60);
	
	var matrix = __webpack_require__(86);
	
	var animationUtil = __webpack_require__(2454);
	
	var makeStyleMapper = __webpack_require__(252);
	
	var _format = __webpack_require__(48);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var Group = graphic.Group;
	var Rect = graphic.Rect;
	var each = zrUtil.each;
	var DRAG_THRESHOLD = 3;
	var PATH_LABEL_NOAMAL = ['label'];
	var PATH_LABEL_EMPHASIS = ['emphasis', 'label'];
	var PATH_UPPERLABEL_NORMAL = ['upperLabel'];
	var PATH_UPPERLABEL_EMPHASIS = ['emphasis', 'upperLabel'];
	var Z_BASE = 10; // Should bigger than every z.
	
	var Z_BG = 1;
	var Z_CONTENT = 2;
	var getItemStyleEmphasis = makeStyleMapper([['fill', 'color'], // `borderColor` and `borderWidth` has been occupied,
	// so use `stroke` to indicate the stroke of the rect.
	['stroke', 'strokeColor'], ['lineWidth', 'strokeWidth'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	
	var getItemStyleNormal = function (model) {
	  // Normal style props should include emphasis style props.
	  var itemStyle = getItemStyleEmphasis(model); // Clear styles set by emphasis.
	
	  itemStyle.stroke = itemStyle.fill = itemStyle.lineWidth = null;
	  return itemStyle;
	};
	
	var _default = echarts.extendChartView({
	  type: 'treemap',
	
	  /**
	   * @override
	   */
	  init: function (o, api) {
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	    this._containerGroup;
	    /**
	     * @private
	     * @type {Object.<string, Array.<module:zrender/container/Group>>}
	     */
	
	    this._storage = createStorage();
	    /**
	     * @private
	     * @type {module:echarts/data/Tree}
	     */
	
	    this._oldTree;
	    /**
	     * @private
	     * @type {module:echarts/chart/treemap/Breadcrumb}
	     */
	
	    this._breadcrumb;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/RoamController}
	     */
	
	    this._controller;
	    /**
	     * 'ready', 'animating'
	     * @private
	     */
	
	    this._state = 'ready';
	  },
	
	  /**
	   * @override
	   */
	  render: function (seriesModel, ecModel, api, payload) {
	    var models = ecModel.findComponents({
	      mainType: 'series',
	      subType: 'treemap',
	      query: payload
	    });
	
	    if (zrUtil.indexOf(models, seriesModel) < 0) {
	      return;
	    }
	
	    this.seriesModel = seriesModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
	    var payloadType = payload && payload.type;
	    var layoutInfo = seriesModel.layoutInfo;
	    var isInit = !this._oldTree;
	    var thisStorage = this._storage; // Mark new root when action is treemapRootToNode.
	
	    var reRoot = payloadType === 'treemapRootToNode' && targetInfo && thisStorage ? {
	      rootNodeGroup: thisStorage.nodeGroup[targetInfo.node.getRawIndex()],
	      direction: payload.direction
	    } : null;
	
	    var containerGroup = this._giveContainerGroup(layoutInfo);
	
	    var renderResult = this._doRender(containerGroup, seriesModel, reRoot);
	
	    !isInit && (!payloadType || payloadType === 'treemapZoomToNode' || payloadType === 'treemapRootToNode') ? this._doAnimation(containerGroup, renderResult, seriesModel, reRoot) : renderResult.renderFinally();
	
	    this._resetController(api);
	
	    this._renderBreadcrumb(seriesModel, api, targetInfo);
	  },
	
	  /**
	   * @private
	   */
	  _giveContainerGroup: function (layoutInfo) {
	    var containerGroup = this._containerGroup;
	
	    if (!containerGroup) {
	      // FIXME
	      // 加一层containerGroup是为了clip，但是现在clip功能并没有实现。
	      containerGroup = this._containerGroup = new Group();
	
	      this._initEvents(containerGroup);
	
	      this.group.add(containerGroup);
	    }
	
	    containerGroup.attr('position', [layoutInfo.x, layoutInfo.y]);
	    return containerGroup;
	  },
	
	  /**
	   * @private
	   */
	  _doRender: function (containerGroup, seriesModel, reRoot) {
	    var thisTree = seriesModel.getData().tree;
	    var oldTree = this._oldTree; // Clear last shape records.
	
	    var lastsForAnimation = createStorage();
	    var thisStorage = createStorage();
	    var oldStorage = this._storage;
	    var willInvisibleEls = [];
	    var doRenderNode = zrUtil.curry(renderNode, seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls); // Notice: when thisTree and oldTree are the same tree (see list.cloneShallow),
	    // the oldTree is actually losted, so we can not find all of the old graphic
	    // elements from tree. So we use this stragegy: make element storage, move
	    // from old storage to new storage, clear old storage.
	
	    dualTravel(thisTree.root ? [thisTree.root] : [], oldTree && oldTree.root ? [oldTree.root] : [], containerGroup, thisTree === oldTree || !oldTree, 0); // Process all removing.
	
	    var willDeleteEls = clearStorage(oldStorage);
	    this._oldTree = thisTree;
	    this._storage = thisStorage;
	    return {
	      lastsForAnimation: lastsForAnimation,
	      willDeleteEls: willDeleteEls,
	      renderFinally: renderFinally
	    };
	
	    function dualTravel(thisViewChildren, oldViewChildren, parentGroup, sameTree, depth) {
	      // When 'render' is triggered by action,
	      // 'this' and 'old' may be the same tree,
	      // we use rawIndex in that case.
	      if (sameTree) {
	        oldViewChildren = thisViewChildren;
	        each(thisViewChildren, function (child, index) {
	          !child.isRemoved() && processNode(index, index);
	        });
	      } // Diff hierarchically (diff only in each subtree, but not whole).
	      // because, consistency of view is important.
	      else {
	          new DataDiffer(oldViewChildren, thisViewChildren, getKey, getKey).add(processNode).update(processNode).remove(zrUtil.curry(processNode, null)).execute();
	        }
	
	      function getKey(node) {
	        // Identify by name or raw index.
	        return node.getId();
	      }
	
	      function processNode(newIndex, oldIndex) {
	        var thisNode = newIndex != null ? thisViewChildren[newIndex] : null;
	        var oldNode = oldIndex != null ? oldViewChildren[oldIndex] : null;
	        var group = doRenderNode(thisNode, oldNode, parentGroup, depth);
	        group && dualTravel(thisNode && thisNode.viewChildren || [], oldNode && oldNode.viewChildren || [], group, sameTree, depth + 1);
	      }
	    }
	
	    function clearStorage(storage) {
	      var willDeleteEls = createStorage();
	      storage && each(storage, function (store, storageName) {
	        var delEls = willDeleteEls[storageName];
	        each(store, function (el) {
	          el && (delEls.push(el), el.__tmWillDelete = 1);
	        });
	      });
	      return willDeleteEls;
	    }
	
	    function renderFinally() {
	      each(willDeleteEls, function (els) {
	        each(els, function (el) {
	          el.parent && el.parent.remove(el);
	        });
	      });
	      each(willInvisibleEls, function (el) {
	        el.invisible = true; // Setting invisible is for optimizing, so no need to set dirty,
	        // just mark as invisible.
	
	        el.dirty();
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doAnimation: function (containerGroup, renderResult, seriesModel, reRoot) {
	    if (!seriesModel.get('animation')) {
	      return;
	    }
	
	    var duration = seriesModel.get('animationDurationUpdate');
	    var easing = seriesModel.get('animationEasing');
	    var animationWrap = animationUtil.createWrap(); // Make delete animations.
	
	    each(renderResult.willDeleteEls, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        if (el.invisible) {
	          return;
	        }
	
	        var parent = el.parent; // Always has parent, and parent is nodeGroup.
	
	        var target;
	
	        if (reRoot && reRoot.direction === 'drillDown') {
	          target = parent === reRoot.rootNodeGroup // This is the content element of view root.
	          // Only `content` will enter this branch, because
	          // `background` and `nodeGroup` will not be deleted.
	          ? {
	            shape: {
	              x: 0,
	              y: 0,
	              width: parent.__tmNodeWidth,
	              height: parent.__tmNodeHeight
	            },
	            style: {
	              opacity: 0
	            } // Others.
	
	          } : {
	            style: {
	              opacity: 0
	            }
	          };
	        } else {
	          var targetX = 0;
	          var targetY = 0;
	
	          if (!parent.__tmWillDelete) {
	            // Let node animate to right-bottom corner, cooperating with fadeout,
	            // which is appropriate for user understanding.
	            // Divided by 2 for reRoot rolling up effect.
	            targetX = parent.__tmNodeWidth / 2;
	            targetY = parent.__tmNodeHeight / 2;
	          }
	
	          target = storageName === 'nodeGroup' ? {
	            position: [targetX, targetY],
	            style: {
	              opacity: 0
	            }
	          } : {
	            shape: {
	              x: targetX,
	              y: targetY,
	              width: 0,
	              height: 0
	            },
	            style: {
	              opacity: 0
	            }
	          };
	        }
	
	        target && animationWrap.add(el, target, duration, easing);
	      });
	    }); // Make other animations
	
	    each(this._storage, function (store, storageName) {
	      each(store, function (el, rawIndex) {
	        var last = renderResult.lastsForAnimation[storageName][rawIndex];
	        var target = {};
	
	        if (!last) {
	          return;
	        }
	
	        if (storageName === 'nodeGroup') {
	          if (last.old) {
	            target.position = el.position.slice();
	            el.attr('position', last.old);
	          }
	        } else {
	          if (last.old) {
	            target.shape = zrUtil.extend({}, el.shape);
	            el.setShape(last.old);
	          }
	
	          if (last.fadein) {
	            el.setStyle('opacity', 0);
	            target.style = {
	              opacity: 1
	            };
	          } // When animation is stopped for succedent animation starting,
	          // el.style.opacity might not be 1
	          else if (el.style.opacity !== 1) {
	              target.style = {
	                opacity: 1
	              };
	            }
	        }
	
	        animationWrap.add(el, target, duration, easing);
	      });
	    }, this);
	    this._state = 'animating';
	    animationWrap.done(bind(function () {
	      this._state = 'ready';
	      renderResult.renderFinally();
	    }, this)).start();
	  },
	
	  /**
	   * @private
	   */
	  _resetController: function (api) {
	    var controller = this._controller; // Init controller.
	
	    if (!controller) {
	      controller = this._controller = new RoamController(api.getZr());
	      controller.enable(this.seriesModel.get('roam'));
	      controller.on('pan', bind(this._onPan, this));
	      controller.on('zoom', bind(this._onZoom, this));
	    }
	
	    var rect = new BoundingRect(0, 0, api.getWidth(), api.getHeight());
	    controller.setPointerChecker(function (e, x, y) {
	      return rect.contain(x, y);
	    });
	  },
	
	  /**
	   * @private
	   */
	  _clearController: function () {
	    var controller = this._controller;
	
	    if (controller) {
	      controller.dispose();
	      controller = null;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onPan: function (e) {
	    if (this._state !== 'animating' && (Math.abs(e.dx) > DRAG_THRESHOLD || Math.abs(e.dy) > DRAG_THRESHOLD)) {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      this.api.dispatchAction({
	        type: 'treemapMove',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rootLayout.x + e.dx,
	          y: rootLayout.y + e.dy,
	          width: rootLayout.width,
	          height: rootLayout.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _onZoom: function (e) {
	    var mouseX = e.originX;
	    var mouseY = e.originY;
	
	    if (this._state !== 'animating') {
	      // These param must not be cached.
	      var root = this.seriesModel.getData().tree.root;
	
	      if (!root) {
	        return;
	      }
	
	      var rootLayout = root.getLayout();
	
	      if (!rootLayout) {
	        return;
	      }
	
	      var rect = new BoundingRect(rootLayout.x, rootLayout.y, rootLayout.width, rootLayout.height);
	      var layoutInfo = this.seriesModel.layoutInfo; // Transform mouse coord from global to containerGroup.
	
	      mouseX -= layoutInfo.x;
	      mouseY -= layoutInfo.y; // Scale root bounding rect.
	
	      var m = matrix.create();
	      matrix.translate(m, m, [-mouseX, -mouseY]);
	      matrix.scale(m, m, [e.scale, e.scale]);
	      matrix.translate(m, m, [mouseX, mouseY]);
	      rect.applyTransform(m);
	      this.api.dispatchAction({
	        type: 'treemapRender',
	        from: this.uid,
	        seriesId: this.seriesModel.id,
	        rootRect: {
	          x: rect.x,
	          y: rect.y,
	          width: rect.width,
	          height: rect.height
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _initEvents: function (containerGroup) {
	    containerGroup.on('click', function (e) {
	      if (this._state !== 'ready') {
	        return;
	      }
	
	      var nodeClick = this.seriesModel.get('nodeClick', true);
	
	      if (!nodeClick) {
	        return;
	      }
	
	      var targetInfo = this.findTarget(e.offsetX, e.offsetY);
	
	      if (!targetInfo) {
	        return;
	      }
	
	      var node = targetInfo.node;
	
	      if (node.getLayout().isLeafRoot) {
	        this._rootToNode(targetInfo);
	      } else {
	        if (nodeClick === 'zoomToNode') {
	          this._zoomToNode(targetInfo);
	        } else if (nodeClick === 'link') {
	          var itemModel = node.hostTree.data.getItemModel(node.dataIndex);
	          var link = itemModel.get('link', true);
	          var linkTarget = itemModel.get('target', true) || 'blank';
	          link && windowOpen(link, linkTarget);
	        }
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderBreadcrumb: function (seriesModel, api, targetInfo) {
	    if (!targetInfo) {
	      targetInfo = seriesModel.get('leafDepth', true) != null ? {
	        node: seriesModel.getViewRoot() // FIXME
	        // better way?
	        // Find breadcrumb tail on center of containerGroup.
	
	      } : this.findTarget(api.getWidth() / 2, api.getHeight() / 2);
	
	      if (!targetInfo) {
	        targetInfo = {
	          node: seriesModel.getData().tree.root
	        };
	      }
	    }
	
	    (this._breadcrumb || (this._breadcrumb = new Breadcrumb(this.group))).render(seriesModel, api, targetInfo.node, bind(onSelect, this));
	
	    function onSelect(node) {
	      if (this._state !== 'animating') {
	        helper.aboveViewRoot(seriesModel.getViewRoot(), node) ? this._rootToNode({
	          node: node
	        }) : this._zoomToNode({
	          node: node
	        });
	      }
	    }
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearController();
	
	    this._containerGroup && this._containerGroup.removeAll();
	    this._storage = createStorage();
	    this._state = 'ready';
	    this._breadcrumb && this._breadcrumb.remove();
	  },
	  dispose: function () {
	    this._clearController();
	  },
	
	  /**
	   * @private
	   */
	  _zoomToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapZoomToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @private
	   */
	  _rootToNode: function (targetInfo) {
	    this.api.dispatchAction({
	      type: 'treemapRootToNode',
	      from: this.uid,
	      seriesId: this.seriesModel.id,
	      targetNode: targetInfo.node
	    });
	  },
	
	  /**
	   * @public
	   * @param {number} x Global coord x.
	   * @param {number} y Global coord y.
	   * @return {Object} info If not found, return undefined;
	   * @return {number} info.node Target node.
	   * @return {number} info.offsetX x refer to target node.
	   * @return {number} info.offsetY y refer to target node.
	   */
	  findTarget: function (x, y) {
	    var targetInfo;
	    var viewRoot = this.seriesModel.getViewRoot();
	    viewRoot.eachNode({
	      attr: 'viewChildren',
	      order: 'preorder'
	    }, function (node) {
	      var bgEl = this._storage.background[node.getRawIndex()]; // If invisible, there might be no element.
	
	
	      if (bgEl) {
	        var point = bgEl.transformCoordToLocal(x, y);
	        var shape = bgEl.shape; // For performance consideration, dont use 'getBoundingRect'.
	
	        if (shape.x <= point[0] && point[0] <= shape.x + shape.width && shape.y <= point[1] && point[1] <= shape.y + shape.height) {
	          targetInfo = {
	            node: node,
	            offsetX: point[0],
	            offsetY: point[1]
	          };
	        } else {
	          return false; // Suppress visit subtree.
	        }
	      }
	    }, this);
	    return targetInfo;
	  }
	});
	/**
	 * @inner
	 */
	
	
	function createStorage() {
	  return {
	    nodeGroup: [],
	    background: [],
	    content: []
	  };
	}
	/**
	 * @inner
	 * @return Return undefined means do not travel further.
	 */
	
	
	function renderNode(seriesModel, thisStorage, oldStorage, reRoot, lastsForAnimation, willInvisibleEls, thisNode, oldNode, parentGroup, depth) {
	  // Whether under viewRoot.
	  if (!thisNode) {
	    // Deleting nodes will be performed finally. This method just find
	    // element from old storage, or create new element, set them to new
	    // storage, and set styles.
	    return;
	  } // -------------------------------------------------------------------
	  // Start of closure variables available in "Procedures in renderNode".
	
	
	  var thisLayout = thisNode.getLayout();
	  var data = seriesModel.getData(); // Only for enabling highlight/downplay. Clear firstly.
	  // Because some node will not be rendered.
	
	  data.setItemGraphicEl(thisNode.dataIndex, null);
	
	  if (!thisLayout || !thisLayout.isInView) {
	    return;
	  }
	
	  var thisWidth = thisLayout.width;
	  var thisHeight = thisLayout.height;
	  var borderWidth = thisLayout.borderWidth;
	  var thisInvisible = thisLayout.invisible;
	  var thisRawIndex = thisNode.getRawIndex();
	  var oldRawIndex = oldNode && oldNode.getRawIndex();
	  var thisViewChildren = thisNode.viewChildren;
	  var upperHeight = thisLayout.upperHeight;
	  var isParent = thisViewChildren && thisViewChildren.length;
	  var itemStyleNormalModel = thisNode.getModel('itemStyle');
	  var itemStyleEmphasisModel = thisNode.getModel('emphasis.itemStyle'); // End of closure ariables available in "Procedures in renderNode".
	  // -----------------------------------------------------------------
	  // Node group
	
	  var group = giveGraphic('nodeGroup', Group);
	
	  if (!group) {
	    return;
	  }
	
	  parentGroup.add(group); // x,y are not set when el is above view root.
	
	  group.attr('position', [thisLayout.x || 0, thisLayout.y || 0]);
	  group.__tmNodeWidth = thisWidth;
	  group.__tmNodeHeight = thisHeight;
	
	  if (thisLayout.isAboveViewRoot) {
	    return group;
	  }
	
	  var nodeModel = thisNode.getModel(); // Background
	
	  var bg = giveGraphic('background', Rect, depth, Z_BG);
	  bg && renderBackground(group, bg, isParent && thisLayout.upperLabelHeight); // No children, render content.
	
	  if (isParent) {
	    // Because of the implementation about "traverse" in graphic hover style, we
	    // can not set hover listener on the "group" of non-leaf node. Otherwise the
	    // hover event from the descendents will be listenered.
	    if (graphic.isHighDownDispatcher(group)) {
	      graphic.setAsHighDownDispatcher(group, false);
	    }
	
	    if (bg) {
	      graphic.setAsHighDownDispatcher(bg, true); // Only for enabling highlight/downplay.
	
	      data.setItemGraphicEl(thisNode.dataIndex, bg);
	    }
	  } else {
	    var content = giveGraphic('content', Rect, depth, Z_CONTENT);
	    content && renderContent(group, content);
	
	    if (bg && graphic.isHighDownDispatcher(bg)) {
	      graphic.setAsHighDownDispatcher(bg, false);
	    }
	
	    graphic.setAsHighDownDispatcher(group, true); // Only for enabling highlight/downplay.
	
	    data.setItemGraphicEl(thisNode.dataIndex, group);
	  }
	
	  return group; // ----------------------------
	  // | Procedures in renderNode |
	  // ----------------------------
	
	  function renderBackground(group, bg, useUpperLabel) {
	    // For tooltip.
	    bg.dataIndex = thisNode.dataIndex;
	    bg.seriesIndex = seriesModel.seriesIndex;
	    bg.setShape({
	      x: 0,
	      y: 0,
	      width: thisWidth,
	      height: thisHeight
	    });
	
	    if (thisInvisible) {
	      // If invisible, do not set visual, otherwise the element will
	      // change immediately before animation. We think it is OK to
	      // remain its origin color when moving out of the view window.
	      processInvisible(bg);
	    } else {
	      bg.invisible = false;
	      var visualBorderColor = thisNode.getVisual('borderColor', true);
	      var emphasisBorderColor = itemStyleEmphasisModel.get('borderColor');
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualBorderColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      emphasisStyle.fill = emphasisBorderColor;
	
	      if (useUpperLabel) {
	        var upperLabelWidth = thisWidth - 2 * borderWidth;
	        prepareText(normalStyle, emphasisStyle, visualBorderColor, upperLabelWidth, upperHeight, {
	          x: borderWidth,
	          y: 0,
	          width: upperLabelWidth,
	          height: upperHeight
	        });
	      } // For old bg.
	      else {
	          normalStyle.text = emphasisStyle.text = null;
	        }
	
	      bg.setStyle(normalStyle);
	      graphic.setElementHoverStyle(bg, emphasisStyle);
	    }
	
	    group.add(bg);
	  }
	
	  function renderContent(group, content) {
	    // For tooltip.
	    content.dataIndex = thisNode.dataIndex;
	    content.seriesIndex = seriesModel.seriesIndex;
	    var contentWidth = Math.max(thisWidth - 2 * borderWidth, 0);
	    var contentHeight = Math.max(thisHeight - 2 * borderWidth, 0);
	    content.culling = true;
	    content.setShape({
	      x: borderWidth,
	      y: borderWidth,
	      width: contentWidth,
	      height: contentHeight
	    });
	
	    if (thisInvisible) {
	      // If invisible, do not set visual, otherwise the element will
	      // change immediately before animation. We think it is OK to
	      // remain its origin color when moving out of the view window.
	      processInvisible(content);
	    } else {
	      content.invisible = false;
	      var visualColor = thisNode.getVisual('color', true);
	      var normalStyle = getItemStyleNormal(itemStyleNormalModel);
	      normalStyle.fill = visualColor;
	      var emphasisStyle = getItemStyleEmphasis(itemStyleEmphasisModel);
	      prepareText(normalStyle, emphasisStyle, visualColor, contentWidth, contentHeight);
	      content.setStyle(normalStyle);
	      graphic.setElementHoverStyle(content, emphasisStyle);
	    }
	
	    group.add(content);
	  }
	
	  function processInvisible(element) {
	    // Delay invisible setting utill animation finished,
	    // avoid element vanish suddenly before animation.
	    !element.invisible && willInvisibleEls.push(element);
	  }
	
	  function prepareText(normalStyle, emphasisStyle, visualColor, width, height, upperLabelRect) {
	    var defaultText = nodeModel.get('name');
	    var normalLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_NORMAL : PATH_LABEL_NOAMAL);
	    var emphasisLabelModel = nodeModel.getModel(upperLabelRect ? PATH_UPPERLABEL_EMPHASIS : PATH_LABEL_EMPHASIS);
	    var isShow = normalLabelModel.getShallow('show');
	    graphic.setLabelStyle(normalStyle, emphasisStyle, normalLabelModel, emphasisLabelModel, {
	      defaultText: isShow ? defaultText : null,
	      autoColor: visualColor,
	      isRectText: true,
	      labelFetcher: seriesModel,
	      labelDataIndex: thisNode.dataIndex,
	      labelProp: upperLabelRect ? 'upperLabel' : 'label'
	    });
	    addDrillDownIcon(normalStyle, upperLabelRect, thisLayout);
	    addDrillDownIcon(emphasisStyle, upperLabelRect, thisLayout);
	    upperLabelRect && (normalStyle.textRect = zrUtil.clone(upperLabelRect));
	    normalStyle.truncate = isShow && normalLabelModel.get('ellipsis') ? {
	      outerWidth: width,
	      outerHeight: height,
	      minChar: 2
	    } : null;
	  }
	
	  function addDrillDownIcon(style, upperLabelRect, thisLayout) {
	    var text = style.text;
	
	    if (!upperLabelRect && thisLayout.isLeafRoot && text != null) {
	      var iconChar = seriesModel.get('drillDownIcon', true);
	      style.text = iconChar ? iconChar + ' ' + text : text;
	    }
	  }
	
	  function giveGraphic(storageName, Ctor, depth, z) {
	    var element = oldRawIndex != null && oldStorage[storageName][oldRawIndex];
	    var lasts = lastsForAnimation[storageName];
	
	    if (element) {
	      // Remove from oldStorage
	      oldStorage[storageName][oldRawIndex] = null;
	      prepareAnimationWhenHasOld(lasts, element, storageName);
	    } // If invisible and no old element, do not create new element (for optimizing).
	    else if (!thisInvisible) {
	        element = new Ctor({
	          z: calculateZ(depth, z)
	        });
	        element.__tmDepth = depth;
	        element.__tmStorageName = storageName;
	        prepareAnimationWhenNoOld(lasts, element, storageName);
	      } // Set to thisStorage
	
	
	    return thisStorage[storageName][thisRawIndex] = element;
	  }
	
	  function prepareAnimationWhenHasOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    lastCfg.old = storageName === 'nodeGroup' ? element.position.slice() : zrUtil.extend({}, element.shape);
	  } // If a element is new, we need to find the animation start point carefully,
	  // otherwise it will looks strange when 'zoomToNode'.
	
	
	  function prepareAnimationWhenNoOld(lasts, element, storageName) {
	    var lastCfg = lasts[thisRawIndex] = {};
	    var parentNode = thisNode.parentNode;
	
	    if (parentNode && (!reRoot || reRoot.direction === 'drillDown')) {
	      var parentOldX = 0;
	      var parentOldY = 0; // New nodes appear from right-bottom corner in 'zoomToNode' animation.
	      // For convenience, get old bounding rect from background.
	
	      var parentOldBg = lastsForAnimation.background[parentNode.getRawIndex()];
	
	      if (!reRoot && parentOldBg && parentOldBg.old) {
	        parentOldX = parentOldBg.old.width;
	        parentOldY = parentOldBg.old.height;
	      } // When no parent old shape found, its parent is new too,
	      // so we can just use {x:0, y:0}.
	
	
	      lastCfg.old = storageName === 'nodeGroup' ? [0, parentOldY] : {
	        x: parentOldX,
	        y: parentOldY,
	        width: 0,
	        height: 0
	      };
	    } // Fade in, user can be aware that these nodes are new.
	
	
	    lastCfg.fadein = storageName !== 'nodeGroup';
	  }
	} // We can not set all backgroud with the same z, Because the behaviour of
	// drill down and roll up differ background creation sequence from tree
	// hierarchy sequence, which cause that lowser background element overlap
	// upper ones. So we calculate z based on depth.
	// Moreover, we try to shrink down z interval to [0, 1] to avoid that
	// treemap with large z overlaps other components.
	
	
	function calculateZ(depth, zInLevel) {
	  var zb = depth * Z_BASE + zInLevel;
	  return (zb - 1) / zb;
	}
	
	module.exports = _default;

/***/ },
/* 2309 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var helper = __webpack_require__(209);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @file Treemap action
	 */
	var noop = function () {};
	
	var actionTypes = ['treemapZoomToNode', 'treemapRender', 'treemapMove'];
	
	for (var i = 0; i < actionTypes.length; i++) {
	  echarts.registerAction({
	    type: actionTypes[i],
	    update: 'updateView'
	  }, noop);
	}
	
	echarts.registerAction({
	  type: 'treemapRootToNode',
	  update: 'updateView'
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'series',
	    subType: 'treemap',
	    query: payload
	  }, handleRootToNode);
	
	  function handleRootToNode(model, index) {
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, model);
	
	    if (targetInfo) {
	      var originViewRoot = model.getViewRoot();
	
	      if (originViewRoot) {
	        payload.direction = helper.aboveViewRoot(originViewRoot, targetInfo.node) ? 'rollUp' : 'drillDown';
	      }
	
	      model.resetViewRoot(targetInfo.node);
	    }
	  }
	});

/***/ },
/* 2310 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var BoundingRect = __webpack_require__(60);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	var MAX_SAFE_INTEGER = _number.MAX_SAFE_INTEGER;
	
	var layout = __webpack_require__(46);
	
	var helper = __webpack_require__(209);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The treemap layout implementation was originally copied from
	* "d3.js" with some modifications made for this project.
	* (See more details in the comment of the method "squarify" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	var mathMax = Math.max;
	var mathMin = Math.min;
	var retrieveValue = zrUtil.retrieve;
	var each = zrUtil.each;
	var PATH_BORDER_WIDTH = ['itemStyle', 'borderWidth'];
	var PATH_GAP_WIDTH = ['itemStyle', 'gapWidth'];
	var PATH_UPPER_LABEL_SHOW = ['upperLabel', 'show'];
	var PATH_UPPER_LABEL_HEIGHT = ['upperLabel', 'height'];
	/**
	 * @public
	 */
	
	var _default = {
	  seriesType: 'treemap',
	  reset: function (seriesModel, ecModel, api, payload) {
	    // Layout result in each node:
	    // {x, y, width, height, area, borderWidth}
	    var ecWidth = api.getWidth();
	    var ecHeight = api.getHeight();
	    var seriesOption = seriesModel.option;
	    var layoutInfo = layout.getLayoutRect(seriesModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	    var size = seriesOption.size || []; // Compatible with ec2.
	
	    var containerWidth = parsePercent(retrieveValue(layoutInfo.width, size[0]), ecWidth);
	    var containerHeight = parsePercent(retrieveValue(layoutInfo.height, size[1]), ecHeight); // Fetch payload info.
	
	    var payloadType = payload && payload.type;
	    var types = ['treemapZoomToNode', 'treemapRootToNode'];
	    var targetInfo = helper.retrieveTargetInfo(payload, types, seriesModel);
	    var rootRect = payloadType === 'treemapRender' || payloadType === 'treemapMove' ? payload.rootRect : null;
	    var viewRoot = seriesModel.getViewRoot();
	    var viewAbovePath = helper.getPathToRoot(viewRoot);
	
	    if (payloadType !== 'treemapMove') {
	      var rootSize = payloadType === 'treemapZoomToNode' ? estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) : rootRect ? [rootRect.width, rootRect.height] : [containerWidth, containerHeight];
	      var sort = seriesOption.sort;
	
	      if (sort && sort !== 'asc' && sort !== 'desc') {
	        sort = 'desc';
	      }
	
	      var options = {
	        squareRatio: seriesOption.squareRatio,
	        sort: sort,
	        leafDepth: seriesOption.leafDepth
	      }; // layout should be cleared because using updateView but not update.
	
	      viewRoot.hostTree.clearLayouts(); // TODO
	      // optimize: if out of view clip, do not layout.
	      // But take care that if do not render node out of view clip,
	      // how to calculate start po
	
	      var viewRootLayout = {
	        x: 0,
	        y: 0,
	        width: rootSize[0],
	        height: rootSize[1],
	        area: rootSize[0] * rootSize[1]
	      };
	      viewRoot.setLayout(viewRootLayout);
	      squarify(viewRoot, options, false, 0); // Supplement layout.
	
	      var viewRootLayout = viewRoot.getLayout();
	      each(viewAbovePath, function (node, index) {
	        var childValue = (viewAbovePath[index + 1] || viewRoot).getValue();
	        node.setLayout(zrUtil.extend({
	          dataExtent: [childValue, childValue],
	          borderWidth: 0,
	          upperHeight: 0
	        }, viewRootLayout));
	      });
	    }
	
	    var treeRoot = seriesModel.getData().tree.root;
	    treeRoot.setLayout(calculateRootPosition(layoutInfo, rootRect, targetInfo), true);
	    seriesModel.setLayoutInfo(layoutInfo); // FIXME
	    // 现在没有clip功能，暂时取ec高宽。
	
	    prunning(treeRoot, // Transform to base element coordinate system.
	    new BoundingRect(-layoutInfo.x, -layoutInfo.y, ecWidth, ecHeight), viewAbovePath, viewRoot, 0);
	  }
	};
	/**
	 * Layout treemap with squarify algorithm.
	 * The original presentation of this algorithm
	 * was made by Mark Bruls, Kees Huizing, and Jarke J. van Wijk
	 * <https://graphics.ethz.ch/teaching/scivis_common/Literature/squarifiedTreeMaps.pdf>.
	 * The implementation of this algorithm was originally copied from "d3.js"
	 * <https://github.com/d3/d3/blob/9cc9a875e636a1dcf36cc1e07bdf77e1ad6e2c74/src/layout/treemap.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 *
	 * @protected
	 * @param {module:echarts/data/Tree~TreeNode} node
	 * @param {Object} options
	 * @param {string} options.sort 'asc' or 'desc'
	 * @param {number} options.squareRatio
	 * @param {boolean} hideChildren
	 * @param {number} depth
	 */
	
	function squarify(node, options, hideChildren, depth) {
	  var width;
	  var height;
	
	  if (node.isRemoved()) {
	    return;
	  }
	
	  var thisLayout = node.getLayout();
	  width = thisLayout.width;
	  height = thisLayout.height; // Considering border and gap
	
	  var nodeModel = node.getModel();
	  var borderWidth = nodeModel.get(PATH_BORDER_WIDTH);
	  var halfGapWidth = nodeModel.get(PATH_GAP_WIDTH) / 2;
	  var upperLabelHeight = getUpperLabelHeight(nodeModel);
	  var upperHeight = Math.max(borderWidth, upperLabelHeight);
	  var layoutOffset = borderWidth - halfGapWidth;
	  var layoutOffsetUpper = upperHeight - halfGapWidth;
	  var nodeModel = node.getModel();
	  node.setLayout({
	    borderWidth: borderWidth,
	    upperHeight: upperHeight,
	    upperLabelHeight: upperLabelHeight
	  }, true);
	  width = mathMax(width - 2 * layoutOffset, 0);
	  height = mathMax(height - layoutOffset - layoutOffsetUpper, 0);
	  var totalArea = width * height;
	  var viewChildren = initChildren(node, nodeModel, totalArea, options, hideChildren, depth);
	
	  if (!viewChildren.length) {
	    return;
	  }
	
	  var rect = {
	    x: layoutOffset,
	    y: layoutOffsetUpper,
	    width: width,
	    height: height
	  };
	  var rowFixedLength = mathMin(width, height);
	  var best = Infinity; // the best row score so far
	
	  var row = [];
	  row.area = 0;
	
	  for (var i = 0, len = viewChildren.length; i < len;) {
	    var child = viewChildren[i];
	    row.push(child);
	    row.area += child.getLayout().area;
	    var score = worst(row, rowFixedLength, options.squareRatio); // continue with this orientation
	
	    if (score <= best) {
	      i++;
	      best = score;
	    } // abort, and try a different orientation
	    else {
	        row.area -= row.pop().getLayout().area;
	        position(row, rowFixedLength, rect, halfGapWidth, false);
	        rowFixedLength = mathMin(rect.width, rect.height);
	        row.length = row.area = 0;
	        best = Infinity;
	      }
	  }
	
	  if (row.length) {
	    position(row, rowFixedLength, rect, halfGapWidth, true);
	  }
	
	  if (!hideChildren) {
	    var childrenVisibleMin = nodeModel.get('childrenVisibleMin');
	
	    if (childrenVisibleMin != null && totalArea < childrenVisibleMin) {
	      hideChildren = true;
	    }
	  }
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    squarify(viewChildren[i], options, hideChildren, depth + 1);
	  }
	}
	/**
	 * Set area to each child, and calculate data extent for visual coding.
	 */
	
	
	function initChildren(node, nodeModel, totalArea, options, hideChildren, depth) {
	  var viewChildren = node.children || [];
	  var orderBy = options.sort;
	  orderBy !== 'asc' && orderBy !== 'desc' && (orderBy = null);
	  var overLeafDepth = options.leafDepth != null && options.leafDepth <= depth; // leafDepth has higher priority.
	
	  if (hideChildren && !overLeafDepth) {
	    return node.viewChildren = [];
	  } // Sort children, order by desc.
	
	
	  viewChildren = zrUtil.filter(viewChildren, function (child) {
	    return !child.isRemoved();
	  });
	  sort(viewChildren, orderBy);
	  var info = statistic(nodeModel, viewChildren, orderBy);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  }
	
	  info.sum = filterByThreshold(nodeModel, totalArea, info.sum, orderBy, viewChildren);
	
	  if (info.sum === 0) {
	    return node.viewChildren = [];
	  } // Set area to each child.
	
	
	  for (var i = 0, len = viewChildren.length; i < len; i++) {
	    var area = viewChildren[i].getValue() / info.sum * totalArea; // Do not use setLayout({...}, true), because it is needed to clear last layout.
	
	    viewChildren[i].setLayout({
	      area: area
	    });
	  }
	
	  if (overLeafDepth) {
	    viewChildren.length && node.setLayout({
	      isLeafRoot: true
	    }, true);
	    viewChildren.length = 0;
	  }
	
	  node.viewChildren = viewChildren;
	  node.setLayout({
	    dataExtent: info.dataExtent
	  }, true);
	  return viewChildren;
	}
	/**
	 * Consider 'visibleMin'. Modify viewChildren and get new sum.
	 */
	
	
	function filterByThreshold(nodeModel, totalArea, sum, orderBy, orderedChildren) {
	  // visibleMin is not supported yet when no option.sort.
	  if (!orderBy) {
	    return sum;
	  }
	
	  var visibleMin = nodeModel.get('visibleMin');
	  var len = orderedChildren.length;
	  var deletePoint = len; // Always travel from little value to big value.
	
	  for (var i = len - 1; i >= 0; i--) {
	    var value = orderedChildren[orderBy === 'asc' ? len - i - 1 : i].getValue();
	
	    if (value / sum * totalArea < visibleMin) {
	      deletePoint = i;
	      sum -= value;
	    }
	  }
	
	  orderBy === 'asc' ? orderedChildren.splice(0, len - deletePoint) : orderedChildren.splice(deletePoint, len - deletePoint);
	  return sum;
	}
	/**
	 * Sort
	 */
	
	
	function sort(viewChildren, orderBy) {
	  if (orderBy) {
	    viewChildren.sort(function (a, b) {
	      var diff = orderBy === 'asc' ? a.getValue() - b.getValue() : b.getValue() - a.getValue();
	      return diff === 0 ? orderBy === 'asc' ? a.dataIndex - b.dataIndex : b.dataIndex - a.dataIndex : diff;
	    });
	  }
	
	  return viewChildren;
	}
	/**
	 * Statistic
	 */
	
	
	function statistic(nodeModel, children, orderBy) {
	  // Calculate sum.
	  var sum = 0;
	
	  for (var i = 0, len = children.length; i < len; i++) {
	    sum += children[i].getValue();
	  } // Statistic data extent for latter visual coding.
	  // Notice: data extent should be calculate based on raw children
	  // but not filtered view children, otherwise visual mapping will not
	  // be stable when zoom (where children is filtered by visibleMin).
	
	
	  var dimension = nodeModel.get('visualDimension');
	  var dataExtent; // The same as area dimension.
	
	  if (!children || !children.length) {
	    dataExtent = [NaN, NaN];
	  } else if (dimension === 'value' && orderBy) {
	    dataExtent = [children[children.length - 1].getValue(), children[0].getValue()];
	    orderBy === 'asc' && dataExtent.reverse();
	  } // Other dimension.
	  else {
	      var dataExtent = [Infinity, -Infinity];
	      each(children, function (child) {
	        var value = child.getValue(dimension);
	        value < dataExtent[0] && (dataExtent[0] = value);
	        value > dataExtent[1] && (dataExtent[1] = value);
	      });
	    }
	
	  return {
	    sum: sum,
	    dataExtent: dataExtent
	  };
	}
	/**
	 * Computes the score for the specified row,
	 * as the worst aspect ratio.
	 */
	
	
	function worst(row, rowFixedLength, ratio) {
	  var areaMax = 0;
	  var areaMin = Infinity;
	
	  for (var i = 0, area, len = row.length; i < len; i++) {
	    area = row[i].getLayout().area;
	
	    if (area) {
	      area < areaMin && (areaMin = area);
	      area > areaMax && (areaMax = area);
	    }
	  }
	
	  var squareArea = row.area * row.area;
	  var f = rowFixedLength * rowFixedLength * ratio;
	  return squareArea ? mathMax(f * areaMax / squareArea, squareArea / (f * areaMin)) : Infinity;
	}
	/**
	 * Positions the specified row of nodes. Modifies `rect`.
	 */
	
	
	function position(row, rowFixedLength, rect, halfGapWidth, flush) {
	  // When rowFixedLength === rect.width,
	  // it is horizontal subdivision,
	  // rowFixedLength is the width of the subdivision,
	  // rowOtherLength is the height of the subdivision,
	  // and nodes will be positioned from left to right.
	  // wh[idx0WhenH] means: when horizontal,
	  //      wh[idx0WhenH] => wh[0] => 'width'.
	  //      xy[idx1WhenH] => xy[1] => 'y'.
	  var idx0WhenH = rowFixedLength === rect.width ? 0 : 1;
	  var idx1WhenH = 1 - idx0WhenH;
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  var last = rect[xy[idx0WhenH]];
	  var rowOtherLength = rowFixedLength ? row.area / rowFixedLength : 0;
	
	  if (flush || rowOtherLength > rect[wh[idx1WhenH]]) {
	    rowOtherLength = rect[wh[idx1WhenH]]; // over+underflow
	  }
	
	  for (var i = 0, rowLen = row.length; i < rowLen; i++) {
	    var node = row[i];
	    var nodeLayout = {};
	    var step = rowOtherLength ? node.getLayout().area / rowOtherLength : 0;
	    var wh1 = nodeLayout[wh[idx1WhenH]] = mathMax(rowOtherLength - 2 * halfGapWidth, 0); // We use Math.max/min to avoid negative width/height when considering gap width.
	
	    var remain = rect[xy[idx0WhenH]] + rect[wh[idx0WhenH]] - last;
	    var modWH = i === rowLen - 1 || remain < step ? remain : step;
	    var wh0 = nodeLayout[wh[idx0WhenH]] = mathMax(modWH - 2 * halfGapWidth, 0);
	    nodeLayout[xy[idx1WhenH]] = rect[xy[idx1WhenH]] + mathMin(halfGapWidth, wh1 / 2);
	    nodeLayout[xy[idx0WhenH]] = last + mathMin(halfGapWidth, wh0 / 2);
	    last += modWH;
	    node.setLayout(nodeLayout, true);
	  }
	
	  rect[xy[idx1WhenH]] += rowOtherLength;
	  rect[wh[idx1WhenH]] -= rowOtherLength;
	} // Return [containerWidth, containerHeight] as default.
	
	
	function estimateRootSize(seriesModel, targetInfo, viewRoot, containerWidth, containerHeight) {
	  // If targetInfo.node exists, we zoom to the node,
	  // so estimate whold width and heigth by target node.
	  var currNode = (targetInfo || {}).node;
	  var defaultSize = [containerWidth, containerHeight];
	
	  if (!currNode || currNode === viewRoot) {
	    return defaultSize;
	  }
	
	  var parent;
	  var viewArea = containerWidth * containerHeight;
	  var area = viewArea * seriesModel.option.zoomToNodeRatio;
	
	  while (parent = currNode.parentNode) {
	    // jshint ignore:line
	    var sum = 0;
	    var siblings = parent.children;
	
	    for (var i = 0, len = siblings.length; i < len; i++) {
	      sum += siblings[i].getValue();
	    }
	
	    var currNodeValue = currNode.getValue();
	
	    if (currNodeValue === 0) {
	      return defaultSize;
	    }
	
	    area *= sum / currNodeValue; // Considering border, suppose aspect ratio is 1.
	
	    var parentModel = parent.getModel();
	    var borderWidth = parentModel.get(PATH_BORDER_WIDTH);
	    var upperHeight = Math.max(borderWidth, getUpperLabelHeight(parentModel, borderWidth));
	    area += 4 * borderWidth * borderWidth + (3 * borderWidth + upperHeight) * Math.pow(area, 0.5);
	    area > MAX_SAFE_INTEGER && (area = MAX_SAFE_INTEGER);
	    currNode = parent;
	  }
	
	  area < viewArea && (area = viewArea);
	  var scale = Math.pow(area / viewArea, 0.5);
	  return [containerWidth * scale, containerHeight * scale];
	} // Root postion base on coord of containerGroup
	
	
	function calculateRootPosition(layoutInfo, rootRect, targetInfo) {
	  if (rootRect) {
	    return {
	      x: rootRect.x,
	      y: rootRect.y
	    };
	  }
	
	  var defaultPosition = {
	    x: 0,
	    y: 0
	  };
	
	  if (!targetInfo) {
	    return defaultPosition;
	  } // If targetInfo is fetched by 'retrieveTargetInfo',
	  // old tree and new tree are the same tree,
	  // so the node still exists and we can visit it.
	
	
	  var targetNode = targetInfo.node;
	  var layout = targetNode.getLayout();
	
	  if (!layout) {
	    return defaultPosition;
	  } // Transform coord from local to container.
	
	
	  var targetCenter = [layout.width / 2, layout.height / 2];
	  var node = targetNode;
	
	  while (node) {
	    var nodeLayout = node.getLayout();
	    targetCenter[0] += nodeLayout.x;
	    targetCenter[1] += nodeLayout.y;
	    node = node.parentNode;
	  }
	
	  return {
	    x: layoutInfo.width / 2 - targetCenter[0],
	    y: layoutInfo.height / 2 - targetCenter[1]
	  };
	} // Mark nodes visible for prunning when visual coding and rendering.
	// Prunning depends on layout and root position, so we have to do it after layout.
	
	
	function prunning(node, clipRect, viewAbovePath, viewRoot, depth) {
	  var nodeLayout = node.getLayout();
	  var nodeInViewAbovePath = viewAbovePath[depth];
	  var isAboveViewRoot = nodeInViewAbovePath && nodeInViewAbovePath === node;
	
	  if (nodeInViewAbovePath && !isAboveViewRoot || depth === viewAbovePath.length && node !== viewRoot) {
	    return;
	  }
	
	  node.setLayout({
	    // isInView means: viewRoot sub tree + viewAbovePath
	    isInView: true,
	    // invisible only means: outside view clip so that the node can not
	    // see but still layout for animation preparation but not render.
	    invisible: !isAboveViewRoot && !clipRect.intersect(nodeLayout),
	    isAboveViewRoot: isAboveViewRoot
	  }, true); // Transform to child coordinate.
	
	  var childClipRect = new BoundingRect(clipRect.x - nodeLayout.x, clipRect.y - nodeLayout.y, clipRect.width, clipRect.height);
	  each(node.viewChildren || [], function (child) {
	    prunning(child, childClipRect, viewAbovePath, viewRoot, depth + 1);
	  });
	}
	
	function getUpperLabelHeight(model) {
	  return model.get(PATH_UPPER_LABEL_SHOW) ? model.get(PATH_UPPER_LABEL_HEIGHT) : 0;
	}
	
	module.exports = _default;

/***/ },
/* 2311 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var VisualMapping = __webpack_require__(213);
	
	var zrColor = __webpack_require__(148);
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var isArray = zrUtil.isArray;
	var ITEM_STYLE_NORMAL = 'itemStyle';
	var _default = {
	  seriesType: 'treemap',
	  reset: function (seriesModel, ecModel, api, payload) {
	    var tree = seriesModel.getData().tree;
	    var root = tree.root;
	
	    if (root.isRemoved()) {
	      return;
	    }
	
	    travelTree(root, // Visual should calculate from tree root but not view root.
	    {}, seriesModel.getViewRoot().getAncestors(), seriesModel);
	  }
	};
	
	function travelTree(node, designatedVisual, viewRootAncestors, seriesModel) {
	  var nodeModel = node.getModel();
	  var nodeLayout = node.getLayout(); // Optimize
	
	  if (!nodeLayout || nodeLayout.invisible || !nodeLayout.isInView) {
	    return;
	  }
	
	  var nodeItemStyleModel = node.getModel(ITEM_STYLE_NORMAL);
	  var visuals = buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel); // calculate border color
	
	  var borderColor = nodeItemStyleModel.get('borderColor');
	  var borderColorSaturation = nodeItemStyleModel.get('borderColorSaturation');
	  var thisNodeColor;
	
	  if (borderColorSaturation != null) {
	    // For performance, do not always execute 'calculateColor'.
	    thisNodeColor = calculateColor(visuals, node);
	    borderColor = calculateBorderColor(borderColorSaturation, thisNodeColor);
	  }
	
	  node.setVisual('borderColor', borderColor);
	  var viewChildren = node.viewChildren;
	
	  if (!viewChildren || !viewChildren.length) {
	    thisNodeColor = calculateColor(visuals, node); // Apply visual to this node.
	
	    node.setVisual('color', thisNodeColor);
	  } else {
	    var mapping = buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren); // Designate visual to children.
	
	    zrUtil.each(viewChildren, function (child, index) {
	      // If higher than viewRoot, only ancestors of viewRoot is needed to visit.
	      if (child.depth >= viewRootAncestors.length || child === viewRootAncestors[child.depth]) {
	        var childVisual = mapVisual(nodeModel, visuals, child, index, mapping, seriesModel);
	        travelTree(child, childVisual, viewRootAncestors, seriesModel);
	      }
	    });
	  }
	}
	
	function buildVisuals(nodeItemStyleModel, designatedVisual, seriesModel) {
	  var visuals = zrUtil.extend({}, designatedVisual);
	  var designatedVisualItemStyle = seriesModel.designatedVisualItemStyle;
	  zrUtil.each(['color', 'colorAlpha', 'colorSaturation'], function (visualName) {
	    // Priority: thisNode > thisLevel > parentNodeDesignated > seriesModel
	    designatedVisualItemStyle[visualName] = designatedVisual[visualName];
	    var val = nodeItemStyleModel.get(visualName);
	    designatedVisualItemStyle[visualName] = null;
	    val != null && (visuals[visualName] = val);
	  });
	  return visuals;
	}
	
	function calculateColor(visuals) {
	  var color = getValueVisualDefine(visuals, 'color');
	
	  if (color) {
	    var colorAlpha = getValueVisualDefine(visuals, 'colorAlpha');
	    var colorSaturation = getValueVisualDefine(visuals, 'colorSaturation');
	
	    if (colorSaturation) {
	      color = zrColor.modifyHSL(color, null, null, colorSaturation);
	    }
	
	    if (colorAlpha) {
	      color = zrColor.modifyAlpha(color, colorAlpha);
	    }
	
	    return color;
	  }
	}
	
	function calculateBorderColor(borderColorSaturation, thisNodeColor) {
	  return thisNodeColor != null ? zrColor.modifyHSL(thisNodeColor, null, null, borderColorSaturation) : null;
	}
	
	function getValueVisualDefine(visuals, name) {
	  var value = visuals[name];
	
	  if (value != null && value !== 'none') {
	    return value;
	  }
	}
	
	function buildVisualMapping(node, nodeModel, nodeLayout, nodeItemStyleModel, visuals, viewChildren) {
	  if (!viewChildren || !viewChildren.length) {
	    return;
	  }
	
	  var rangeVisual = getRangeVisual(nodeModel, 'color') || visuals.color != null && visuals.color !== 'none' && (getRangeVisual(nodeModel, 'colorAlpha') || getRangeVisual(nodeModel, 'colorSaturation'));
	
	  if (!rangeVisual) {
	    return;
	  }
	
	  var visualMin = nodeModel.get('visualMin');
	  var visualMax = nodeModel.get('visualMax');
	  var dataExtent = nodeLayout.dataExtent.slice();
	  visualMin != null && visualMin < dataExtent[0] && (dataExtent[0] = visualMin);
	  visualMax != null && visualMax > dataExtent[1] && (dataExtent[1] = visualMax);
	  var colorMappingBy = nodeModel.get('colorMappingBy');
	  var opt = {
	    type: rangeVisual.name,
	    dataExtent: dataExtent,
	    visual: rangeVisual.range
	  };
	
	  if (opt.type === 'color' && (colorMappingBy === 'index' || colorMappingBy === 'id')) {
	    opt.mappingMethod = 'category';
	    opt.loop = true; // categories is ordinal, so do not set opt.categories.
	  } else {
	    opt.mappingMethod = 'linear';
	  }
	
	  var mapping = new VisualMapping(opt);
	  mapping.__drColorMappingBy = colorMappingBy;
	  return mapping;
	} // Notice: If we dont have the attribute 'colorRange', but only use
	// attribute 'color' to represent both concepts of 'colorRange' and 'color',
	// (It means 'colorRange' when 'color' is Array, means 'color' when not array),
	// this problem will be encountered:
	// If a level-1 node dont have children, and its siblings has children,
	// and colorRange is set on level-1, then the node can not be colored.
	// So we separate 'colorRange' and 'color' to different attributes.
	
	
	function getRangeVisual(nodeModel, name) {
	  // 'colorRange', 'colorARange', 'colorSRange'.
	  // If not exsits on this node, fetch from levels and series.
	  var range = nodeModel.get(name);
	  return isArray(range) && range.length ? {
	    name: name,
	    range: range
	  } : null;
	}
	
	function mapVisual(nodeModel, visuals, child, index, mapping, seriesModel) {
	  var childVisuals = zrUtil.extend({}, visuals);
	
	  if (mapping) {
	    var mappingType = mapping.type;
	    var colorMappingBy = mappingType === 'color' && mapping.__drColorMappingBy;
	    var value = colorMappingBy === 'index' ? index : colorMappingBy === 'id' ? seriesModel.mapIdToIndex(child.getId()) : child.getValue(nodeModel.get('visualDimension'));
	    childVisuals[mappingType] = mapping.mapValueToVisual(value);
	  }
	
	  return childVisuals;
	}
	
	module.exports = _default;

/***/ },
/* 2312 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(515);
	
	__webpack_require__(2314);

/***/ },
/* 2313 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(863);
	
	__webpack_require__(2315);

/***/ },
/* 2314 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var Model = __webpack_require__(70);
	
	var AxisView = __webpack_require__(210);
	
	var AxisBuilder = __webpack_require__(177);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var elementList = ['axisLine', 'axisLabel', 'axisTick', 'minorTick', 'splitLine', 'minorSplitLine', 'splitArea'];
	
	function getAxisLineShape(polar, rExtent, angle) {
	  rExtent[1] > rExtent[0] && (rExtent = rExtent.slice().reverse());
	  var start = polar.coordToPoint([rExtent[0], angle]);
	  var end = polar.coordToPoint([rExtent[1], angle]);
	  return {
	    x1: start[0],
	    y1: start[1],
	    x2: end[0],
	    y2: end[1]
	  };
	}
	
	function getRadiusIdx(polar) {
	  var radiusAxis = polar.getRadiusAxis();
	  return radiusAxis.inverse ? 0 : 1;
	} // Remove the last tick which will overlap the first tick
	
	
	function fixAngleOverlap(list) {
	  var firstItem = list[0];
	  var lastItem = list[list.length - 1];
	
	  if (firstItem && lastItem && Math.abs(Math.abs(firstItem.coord - lastItem.coord) - 360) < 1e-4) {
	    list.pop();
	  }
	}
	
	var _default = AxisView.extend({
	  type: 'angleAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (angleAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!angleAxisModel.get('show')) {
	      return;
	    }
	
	    var angleAxis = angleAxisModel.axis;
	    var polar = angleAxis.polar;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var ticksAngles = angleAxis.getTicksCoords();
	    var minorTickAngles = angleAxis.getMinorTicksCoords();
	    var labels = zrUtil.map(angleAxis.getViewLabels(), function (labelItem) {
	      var labelItem = zrUtil.clone(labelItem);
	      labelItem.coord = angleAxis.dataToCoord(labelItem.tickValue);
	      return labelItem;
	    });
	    fixAngleOverlap(labels);
	    fixAngleOverlap(ticksAngles);
	    zrUtil.each(elementList, function (name) {
	      if (angleAxisModel.get(name + '.show') && (!angleAxis.scale.isBlank() || name === 'axisLine')) {
	        this['_' + name](angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _axisLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var lineStyleModel = angleAxisModel.getModel('axisLine.lineStyle'); // extent id of the axis radius (r0 and r)
	
	    var rId = getRadiusIdx(polar);
	    var r0Id = rId ? 0 : 1;
	    var shape;
	
	    if (radiusExtent[r0Id] === 0) {
	      shape = new graphic.Circle({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: radiusExtent[rId]
	        },
	        style: lineStyleModel.getLineStyle(),
	        z2: 1,
	        silent: true
	      });
	    } else {
	      shape = new graphic.Ring({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: radiusExtent[rId],
	          r0: radiusExtent[r0Id]
	        },
	        style: lineStyleModel.getLineStyle(),
	        z2: 1,
	        silent: true
	      });
	    }
	
	    shape.style.fill = null;
	    this.group.add(shape);
	  },
	
	  /**
	   * @private
	   */
	  _axisTick: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var tickModel = angleAxisModel.getModel('axisTick');
	    var tickLen = (tickModel.get('inside') ? -1 : 1) * tickModel.get('length');
	    var radius = radiusExtent[getRadiusIdx(polar)];
	    var lines = zrUtil.map(ticksAngles, function (tickAngleItem) {
	      return new graphic.Line({
	        shape: getAxisLineShape(polar, [radius, radius + tickLen], tickAngleItem.coord)
	      });
	    });
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults(tickModel.getModel('lineStyle').getLineStyle(), {
	        stroke: angleAxisModel.get('axisLine.lineStyle.color')
	      })
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _minorTick: function (angleAxisModel, polar, tickAngles, minorTickAngles, radiusExtent) {
	    if (!minorTickAngles.length) {
	      return;
	    }
	
	    var tickModel = angleAxisModel.getModel('axisTick');
	    var minorTickModel = angleAxisModel.getModel('minorTick');
	    var tickLen = (tickModel.get('inside') ? -1 : 1) * minorTickModel.get('length');
	    var radius = radiusExtent[getRadiusIdx(polar)];
	    var lines = [];
	
	    for (var i = 0; i < minorTickAngles.length; i++) {
	      for (var k = 0; k < minorTickAngles[i].length; k++) {
	        lines.push(new graphic.Line({
	          shape: getAxisLineShape(polar, [radius, radius + tickLen], minorTickAngles[i][k].coord)
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults(minorTickModel.getModel('lineStyle').getLineStyle(), zrUtil.defaults(tickModel.getLineStyle(), {
	        stroke: angleAxisModel.get('axisLine.lineStyle.color')
	      }))
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _axisLabel: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent, labels) {
	    var rawCategoryData = angleAxisModel.getCategories(true);
	    var commonLabelModel = angleAxisModel.getModel('axisLabel');
	    var labelMargin = commonLabelModel.get('margin');
	    var triggerEvent = angleAxisModel.get('triggerEvent'); // Use length of ticksAngles because it may remove the last tick to avoid overlapping
	
	    zrUtil.each(labels, function (labelItem, idx) {
	      var labelModel = commonLabelModel;
	      var tickValue = labelItem.tickValue;
	      var r = radiusExtent[getRadiusIdx(polar)];
	      var p = polar.coordToPoint([r + labelMargin, labelItem.coord]);
	      var cx = polar.cx;
	      var cy = polar.cy;
	      var labelTextAlign = Math.abs(p[0] - cx) / r < 0.3 ? 'center' : p[0] > cx ? 'left' : 'right';
	      var labelTextVerticalAlign = Math.abs(p[1] - cy) / r < 0.3 ? 'middle' : p[1] > cy ? 'top' : 'bottom';
	
	      if (rawCategoryData && rawCategoryData[tickValue] && rawCategoryData[tickValue].textStyle) {
	        labelModel = new Model(rawCategoryData[tickValue].textStyle, commonLabelModel, commonLabelModel.ecModel);
	      }
	
	      var textEl = new graphic.Text({
	        silent: AxisBuilder.isLabelSilent(angleAxisModel)
	      });
	      this.group.add(textEl);
	      graphic.setTextStyle(textEl.style, labelModel, {
	        x: p[0],
	        y: p[1],
	        textFill: labelModel.getTextColor() || angleAxisModel.get('axisLine.lineStyle.color'),
	        text: labelItem.formattedLabel,
	        textAlign: labelTextAlign,
	        textVerticalAlign: labelTextVerticalAlign
	      }); // Pack data for mouse event
	
	      if (triggerEvent) {
	        textEl.eventData = AxisBuilder.makeAxisEventDataBase(angleAxisModel);
	        textEl.eventData.targetType = 'axisLabel';
	        textEl.eventData.value = labelItem.rawLabel;
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    var splitLineModel = angleAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line({
	        shape: getAxisLineShape(polar, radiusExtent, ticksAngles[i].coord)
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length]
	        }, lineStyleModel.getLineStyle()),
	        silent: true,
	        z: angleAxisModel.get('z')
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _minorSplitLine: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    if (!minorTickAngles.length) {
	      return;
	    }
	
	    var minorSplitLineModel = angleAxisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var lines = [];
	
	    for (var i = 0; i < minorTickAngles.length; i++) {
	      for (var k = 0; k < minorTickAngles[i].length; k++) {
	        lines.push(new graphic.Line({
	          shape: getAxisLineShape(polar, radiusExtent, minorTickAngles[i][k].coord)
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: lineStyleModel.getLineStyle(),
	      silent: true,
	      z: angleAxisModel.get('z')
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (angleAxisModel, polar, ticksAngles, minorTickAngles, radiusExtent) {
	    if (!ticksAngles.length) {
	      return;
	    }
	
	    var splitAreaModel = angleAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var RADIAN = Math.PI / 180;
	    var prevAngle = -ticksAngles[0].coord * RADIAN;
	    var r0 = Math.min(radiusExtent[0], radiusExtent[1]);
	    var r1 = Math.max(radiusExtent[0], radiusExtent[1]);
	    var clockwise = angleAxisModel.get('clockwise');
	
	    for (var i = 1; i < ticksAngles.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: r0,
	          r: r1,
	          startAngle: prevAngle,
	          endAngle: -ticksAngles[i].coord * RADIAN,
	          clockwise: clockwise
	        },
	        silent: true
	      }));
	      prevAngle = -ticksAngles[i].coord * RADIAN;
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2315 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var AxisBuilder = __webpack_require__(177);
	
	var AxisView = __webpack_require__(210);
	
	var cartesianAxisHelper = __webpack_require__(864);
	
	var _axisSplitHelper = __webpack_require__(834);
	
	var rectCoordAxisBuildSplitArea = _axisSplitHelper.rectCoordAxisBuildSplitArea;
	var rectCoordAxisHandleRemove = _axisSplitHelper.rectCoordAxisHandleRemove;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitArea', 'splitLine', 'minorSplitLine'];
	var CartesianAxisView = AxisView.extend({
	  type: 'cartesianAxis',
	  axisPointerClass: 'CartesianAxisPointer',
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var gridModel = axisModel.getCoordSysModel();
	    var layout = cartesianAxisHelper.layout(gridModel, axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (axisModel.get(name + '.show')) {
	        this['_' + name](axisModel, gridModel);
	      }
	    }, this);
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	    CartesianAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	  remove: function () {
	    rectCoordAxisHandleRemove(this);
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _splitLine: function (axisModel, gridModel) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    lineColors = zrUtil.isArray(lineColors) ? lineColors : [lineColors];
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords({
	      tickModel: splitLineModel
	    });
	    var p1 = [];
	    var p2 = [];
	    var lineStyle = lineStyleModel.getLineStyle();
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	      var tickValue = ticksCoords[i].tickValue;
	
	      this._axisGroup.add(new graphic.Line({
	        anid: tickValue != null ? 'line_' + ticksCoords[i].tickValue : null,
	        subPixelOptimize: true,
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: zrUtil.defaults({
	          stroke: lineColors[colorIndex]
	        }, lineStyle),
	        silent: true
	      }));
	    }
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _minorSplitLine: function (axisModel, gridModel) {
	    var axis = axisModel.axis;
	    var minorSplitLineModel = axisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var gridRect = gridModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var minorTicksCoords = axis.getMinorTicksCoords();
	
	    if (!minorTicksCoords.length) {
	      return;
	    }
	
	    var p1 = [];
	    var p2 = [];
	    var lineStyle = lineStyleModel.getLineStyle();
	
	    for (var i = 0; i < minorTicksCoords.length; i++) {
	      for (var k = 0; k < minorTicksCoords[i].length; k++) {
	        var tickCoord = axis.toGlobalCoord(minorTicksCoords[i][k].coord);
	
	        if (isHorizontal) {
	          p1[0] = tickCoord;
	          p1[1] = gridRect.y;
	          p2[0] = tickCoord;
	          p2[1] = gridRect.y + gridRect.height;
	        } else {
	          p1[0] = gridRect.x;
	          p1[1] = tickCoord;
	          p2[0] = gridRect.x + gridRect.width;
	          p2[1] = tickCoord;
	        }
	
	        this._axisGroup.add(new graphic.Line({
	          anid: 'minor_line_' + minorTicksCoords[i][k].tickValue,
	          subPixelOptimize: true,
	          shape: {
	            x1: p1[0],
	            y1: p1[1],
	            x2: p2[0],
	            y2: p2[1]
	          },
	          style: lineStyle,
	          silent: true
	        }));
	      }
	    }
	  },
	
	  /**
	   * @param {module:echarts/coord/cartesian/AxisModel} axisModel
	   * @param {module:echarts/coord/cartesian/GridModel} gridModel
	   * @private
	   */
	  _splitArea: function (axisModel, gridModel) {
	    rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, gridModel);
	  }
	});
	CartesianAxisView.extend({
	  type: 'xAxis'
	});
	CartesianAxisView.extend({
	  type: 'yAxis'
	});

/***/ },
/* 2316 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var AxisBuilder = __webpack_require__(177);
	
	var BrushController = __webpack_require__(505);
	
	var brushHelper = __webpack_require__(845);
	
	var graphic = __webpack_require__(14);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var elementList = ['axisLine', 'axisTickLabel', 'axisName'];
	var AxisView = echarts.extendComponentView({
	  type: 'parallelAxis',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    AxisView.superApply(this, 'init', arguments);
	    /**
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this));
	  },
	
	  /**
	   * @override
	   */
	  render: function (axisModel, ecModel, api, payload) {
	    if (fromAxisAreaSelect(axisModel, ecModel, payload)) {
	      return;
	    }
	
	    this.axisModel = axisModel;
	    this.api = api;
	    this.group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    this.group.add(this._axisGroup);
	
	    if (!axisModel.get('show')) {
	      return;
	    }
	
	    var coordSysModel = getCoordSysModel(axisModel, ecModel);
	    var coordSys = coordSysModel.coordinateSystem;
	    var areaSelectStyle = axisModel.getAreaSelectStyle();
	    var areaWidth = areaSelectStyle.width;
	    var dim = axisModel.axis.dim;
	    var axisLayout = coordSys.getAxisLayout(dim);
	    var builderOpt = zrUtil.extend({
	      strokeContainThreshold: areaWidth
	    }, axisLayout);
	    var axisBuilder = new AxisBuilder(axisModel, builderOpt);
	    zrUtil.each(elementList, axisBuilder.add, axisBuilder);
	
	    this._axisGroup.add(axisBuilder.getGroup());
	
	    this._refreshBrushController(builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api);
	
	    var animationModel = payload && payload.animation === false ? null : axisModel;
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, animationModel);
	  },
	  // /**
	  //  * @override
	  //  */
	  // updateVisual: function (axisModel, ecModel, api, payload) {
	  //     this._brushController && this._brushController
	  //         .updateCovers(getCoverInfoList(axisModel));
	  // },
	  _refreshBrushController: function (builderOpt, areaSelectStyle, axisModel, coordSysModel, areaWidth, api) {
	    // After filtering, axis may change, select area needs to be update.
	    var extent = axisModel.axis.getExtent();
	    var extentLen = extent[1] - extent[0];
	    var extra = Math.min(30, Math.abs(extentLen) * 0.1); // Arbitrary value.
	    // width/height might be negative, which will be
	    // normalized in BoundingRect.
	
	    var rect = graphic.BoundingRect.create({
	      x: extent[0],
	      y: -areaWidth / 2,
	      width: extentLen,
	      height: areaWidth
	    });
	    rect.x -= extra;
	    rect.width += 2 * extra;
	
	    this._brushController.mount({
	      enableGlobalPan: true,
	      rotation: builderOpt.rotation,
	      position: builderOpt.position
	    }).setPanels([{
	      panelId: 'pl',
	      clipPath: brushHelper.makeRectPanelClipPath(rect),
	      isTargetByCursor: brushHelper.makeRectIsTargetByCursor(rect, api, coordSysModel),
	      getLinearBrushOtherExtent: brushHelper.makeLinearBrushOtherExtent(rect, 0)
	    }]).enableBrush({
	      brushType: 'lineX',
	      brushStyle: areaSelectStyle,
	      removeOnClick: true
	    }).updateCovers(getCoverInfoList(axisModel));
	  },
	  _onBrush: function (coverInfoList, opt) {
	    // Do not cache these object, because the mey be changed.
	    var axisModel = this.axisModel;
	    var axis = axisModel.axis;
	    var intervals = zrUtil.map(coverInfoList, function (coverInfo) {
	      return [axis.coordToData(coverInfo.range[0], true), axis.coordToData(coverInfo.range[1], true)];
	    }); // If realtime is true, action is not dispatched on drag end, because
	    // the drag end emits the same params with the last drag move event,
	    // and may have some delay when using touch pad.
	
	    if (!axisModel.option.realtime === opt.isEnd || opt.removeOnClick) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'axisAreaSelect',
	        parallelAxisId: axisModel.id,
	        intervals: intervals
	      });
	    }
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  }
	});
	
	function fromAxisAreaSelect(axisModel, ecModel, payload) {
	  return payload && payload.type === 'axisAreaSelect' && ecModel.findComponents({
	    mainType: 'parallelAxis',
	    query: payload
	  })[0] === axisModel;
	}
	
	function getCoverInfoList(axisModel) {
	  var axis = axisModel.axis;
	  return zrUtil.map(axisModel.activeIntervals, function (interval) {
	    return {
	      brushType: 'lineX',
	      panelId: 'pl',
	      range: [axis.dataToCoord(interval[0], true), axis.dataToCoord(interval[1], true)]
	    };
	  });
	}
	
	function getCoordSysModel(axisModel, ecModel) {
	  return ecModel.getComponent('parallel', axisModel.get('parallelIndex'));
	}
	
	var _default = AxisView;
	module.exports = _default;

/***/ },
/* 2317 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var AxisBuilder = __webpack_require__(177);
	
	var AxisView = __webpack_require__(210);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitLine', 'splitArea', 'minorSplitLine'];
	
	var _default = AxisView.extend({
	  type: 'radiusAxis',
	  axisPointerClass: 'PolarAxisPointer',
	  render: function (radiusAxisModel, ecModel) {
	    this.group.removeAll();
	
	    if (!radiusAxisModel.get('show')) {
	      return;
	    }
	
	    var radiusAxis = radiusAxisModel.axis;
	    var polar = radiusAxis.polar;
	    var angleAxis = polar.getAngleAxis();
	    var ticksCoords = radiusAxis.getTicksCoords();
	    var minorTicksCoords = radiusAxis.getMinorTicksCoords();
	    var axisAngle = angleAxis.getExtent()[0];
	    var radiusExtent = radiusAxis.getExtent();
	    var layout = layoutAxis(polar, radiusAxisModel, axisAngle);
	    var axisBuilder = new AxisBuilder(radiusAxisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    this.group.add(axisBuilder.getGroup());
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (radiusAxisModel.get(name + '.show') && !radiusAxis.scale.isBlank()) {
	        this['_' + name](radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords);
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _splitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    var splitLineModel = radiusAxisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineColors = lineStyleModel.get('color');
	    var lineCount = 0;
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var splitLines = [];
	
	    for (var i = 0; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Circle({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r: ticksCoords[i].coord
	        }
	      }));
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitLines.length; i++) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: zrUtil.defaults({
	          stroke: lineColors[i % lineColors.length],
	          fill: null
	        }, lineStyleModel.getLineStyle()),
	        silent: true
	      }));
	    }
	  },
	
	  /**
	   * @private
	   */
	  _minorSplitLine: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords, minorTicksCoords) {
	    if (!minorTicksCoords.length) {
	      return;
	    }
	
	    var minorSplitLineModel = radiusAxisModel.getModel('minorSplitLine');
	    var lineStyleModel = minorSplitLineModel.getModel('lineStyle');
	    var lines = [];
	
	    for (var i = 0; i < minorTicksCoords.length; i++) {
	      for (var k = 0; k < minorTicksCoords[i].length; k++) {
	        lines.push(new graphic.Circle({
	          shape: {
	            cx: polar.cx,
	            cy: polar.cy,
	            r: minorTicksCoords[i][k].coord
	          }
	        }));
	      }
	    }
	
	    this.group.add(graphic.mergePath(lines, {
	      style: zrUtil.defaults({
	        fill: null
	      }, lineStyleModel.getLineStyle()),
	      silent: true
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _splitArea: function (radiusAxisModel, polar, axisAngle, radiusExtent, ticksCoords) {
	    if (!ticksCoords.length) {
	      return;
	    }
	
	    var splitAreaModel = radiusAxisModel.getModel('splitArea');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var areaColors = areaStyleModel.get('color');
	    var lineCount = 0;
	    areaColors = areaColors instanceof Array ? areaColors : [areaColors];
	    var splitAreas = [];
	    var prevRadius = ticksCoords[0].coord;
	
	    for (var i = 1; i < ticksCoords.length; i++) {
	      var colorIndex = lineCount++ % areaColors.length;
	      splitAreas[colorIndex] = splitAreas[colorIndex] || [];
	      splitAreas[colorIndex].push(new graphic.Sector({
	        shape: {
	          cx: polar.cx,
	          cy: polar.cy,
	          r0: prevRadius,
	          r: ticksCoords[i].coord,
	          startAngle: 0,
	          endAngle: Math.PI * 2
	        },
	        silent: true
	      }));
	      prevRadius = ticksCoords[i].coord;
	    } // Simple optimization
	    // Batching the lines if color are the same
	
	
	    for (var i = 0; i < splitAreas.length; i++) {
	      this.group.add(graphic.mergePath(splitAreas[i], {
	        style: zrUtil.defaults({
	          fill: areaColors[i % areaColors.length]
	        }, areaStyleModel.getAreaStyle()),
	        silent: true
	      }));
	    }
	  }
	});
	/**
	 * @inner
	 */
	
	
	function layoutAxis(polar, radiusAxisModel, axisAngle) {
	  return {
	    position: [polar.cx, polar.cy],
	    rotation: axisAngle / 180 * Math.PI,
	    labelDirection: -1,
	    tickDirection: -1,
	    nameDirection: 1,
	    labelRotate: radiusAxisModel.getModel('axisLabel').get('rotate'),
	    // Over splitLine and splitArea
	    z2: 1
	  };
	}
	
	module.exports = _default;

/***/ },
/* 2318 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var AxisBuilder = __webpack_require__(177);
	
	var graphic = __webpack_require__(14);
	
	var singleAxisHelper = __webpack_require__(868);
	
	var AxisView = __webpack_require__(210);
	
	var _axisSplitHelper = __webpack_require__(834);
	
	var rectCoordAxisBuildSplitArea = _axisSplitHelper.rectCoordAxisBuildSplitArea;
	var rectCoordAxisHandleRemove = _axisSplitHelper.rectCoordAxisHandleRemove;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	var selfBuilderAttrs = ['splitArea', 'splitLine'];
	var SingleAxisView = AxisView.extend({
	  type: 'singleAxis',
	  axisPointerClass: 'SingleAxisPointer',
	  render: function (axisModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	    var oldAxisGroup = this._axisGroup;
	    this._axisGroup = new graphic.Group();
	    var layout = singleAxisHelper.layout(axisModel);
	    var axisBuilder = new AxisBuilder(axisModel, layout);
	    zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	    group.add(this._axisGroup);
	    group.add(axisBuilder.getGroup());
	    zrUtil.each(selfBuilderAttrs, function (name) {
	      if (axisModel.get(name + '.show')) {
	        this['_' + name](axisModel);
	      }
	    }, this);
	    graphic.groupTransition(oldAxisGroup, this._axisGroup, axisModel);
	    SingleAxisView.superCall(this, 'render', axisModel, ecModel, api, payload);
	  },
	  remove: function () {
	    rectCoordAxisHandleRemove(this);
	  },
	  _splitLine: function (axisModel) {
	    var axis = axisModel.axis;
	
	    if (axis.scale.isBlank()) {
	      return;
	    }
	
	    var splitLineModel = axisModel.getModel('splitLine');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var lineWidth = lineStyleModel.get('width');
	    var lineColors = lineStyleModel.get('color');
	    lineColors = lineColors instanceof Array ? lineColors : [lineColors];
	    var gridRect = axisModel.coordinateSystem.getRect();
	    var isHorizontal = axis.isHorizontal();
	    var splitLines = [];
	    var lineCount = 0;
	    var ticksCoords = axis.getTicksCoords({
	      tickModel: splitLineModel
	    });
	    var p1 = [];
	    var p2 = [];
	
	    for (var i = 0; i < ticksCoords.length; ++i) {
	      var tickCoord = axis.toGlobalCoord(ticksCoords[i].coord);
	
	      if (isHorizontal) {
	        p1[0] = tickCoord;
	        p1[1] = gridRect.y;
	        p2[0] = tickCoord;
	        p2[1] = gridRect.y + gridRect.height;
	      } else {
	        p1[0] = gridRect.x;
	        p1[1] = tickCoord;
	        p2[0] = gridRect.x + gridRect.width;
	        p2[1] = tickCoord;
	      }
	
	      var colorIndex = lineCount++ % lineColors.length;
	      splitLines[colorIndex] = splitLines[colorIndex] || [];
	      splitLines[colorIndex].push(new graphic.Line({
	        subPixelOptimize: true,
	        shape: {
	          x1: p1[0],
	          y1: p1[1],
	          x2: p2[0],
	          y2: p2[1]
	        },
	        style: {
	          lineWidth: lineWidth
	        },
	        silent: true
	      }));
	    }
	
	    for (var i = 0; i < splitLines.length; ++i) {
	      this.group.add(graphic.mergePath(splitLines[i], {
	        style: {
	          stroke: lineColors[i % lineColors.length],
	          lineDash: lineStyleModel.getLineDash(lineWidth),
	          lineWidth: lineWidth
	        },
	        silent: true
	      }));
	    }
	  },
	  _splitArea: function (axisModel) {
	    rectCoordAxisBuildSplitArea(this, this._axisGroup, axisModel, axisModel);
	  }
	});
	var _default = SingleAxisView;
	module.exports = _default;

/***/ },
/* 2319 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @payload
	 * @property {string} parallelAxisId
	 * @property {Array.<Array.<number>>} intervals
	 */
	var actionInfo = {
	  type: 'axisAreaSelect',
	  event: 'axisAreaSelected' // update: 'updateVisual'
	
	};
	echarts.registerAction(actionInfo, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallelAxis',
	    query: payload
	  }, function (parallelAxisModel) {
	    parallelAxisModel.axis.model.setActiveIntervals(payload.intervals);
	  });
	});
	/**
	 * @payload
	 */
	
	echarts.registerAction('parallelAxisExpand', function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'parallel',
	    query: payload
	  }, function (parallelModel) {
	    parallelModel.setAxisExpand(payload);
	  });
	});

/***/ },
/* 2320 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisPointerModel = echarts.extendComponentModel({
	  type: 'axisPointer',
	  coordSysAxesInfo: null,
	  defaultOption: {
	    // 'auto' means that show when triggered by tooltip or handle.
	    show: 'auto',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: null,
	    // set default in AxisPonterView.js
	    zlevel: 0,
	    z: 50,
	    type: 'line',
	    // 'line' 'shadow' 'cross' 'none'.
	    // axispointer triggered by tootip determine snap automatically,
	    // see `modelHelper`.
	    snap: false,
	    triggerTooltip: true,
	    value: null,
	    status: null,
	    // Init value depends on whether handle is used.
	    // [group0, group1, ...]
	    // Each group can be: {
	    //      mapper: function () {},
	    //      singleTooltip: 'multiple',  // 'multiple' or 'single'
	    //      xAxisId: ...,
	    //      yAxisName: ...,
	    //      angleAxisIndex: ...
	    // }
	    // mapper: can be ignored.
	    //      input: {axisInfo, value}
	    //      output: {axisInfo, value}
	    link: [],
	    // Do not set 'auto' here, otherwise global animation: false
	    // will not effect at this axispointer.
	    animation: null,
	    animationDurationUpdate: 200,
	    lineStyle: {
	      color: '#aaa',
	      width: 1,
	      type: 'solid'
	    },
	    shadowStyle: {
	      color: 'rgba(150,150,150,0.3)'
	    },
	    label: {
	      show: true,
	      formatter: null,
	      // string | Function
	      precision: 'auto',
	      // Or a number like 0, 1, 2 ...
	      margin: 3,
	      color: '#fff',
	      padding: [5, 7, 5, 7],
	      backgroundColor: 'auto',
	      // default: axis line color
	      borderColor: null,
	      borderWidth: 0,
	      shadowBlur: 3,
	      shadowColor: '#aaa' // Considering applicability, common style should
	      // better not have shadowOffset.
	      // shadowOffsetX: 0,
	      // shadowOffsetY: 2
	
	    },
	    handle: {
	      show: false,
	
	      /* eslint-disable */
	      icon: 'M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7v-1.2h6.6z M13.3,22H6.7v-1.2h6.6z M13.3,19.6H6.7v-1.2h6.6z',
	      // jshint ignore:line
	
	      /* eslint-enable */
	      size: 45,
	      // handle margin is from symbol center to axis, which is stable when circular move.
	      margin: 50,
	      // color: '#1b8bbd'
	      // color: '#2f4554'
	      color: '#333',
	      shadowBlur: 3,
	      shadowColor: '#aaa',
	      shadowOffsetX: 0,
	      shadowOffsetY: 2,
	      // For mobile performance
	      throttle: 40
	    }
	  }
	});
	var _default = AxisPointerModel;
	module.exports = _default;

/***/ },
/* 2321 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var globalListener = __webpack_require__(837);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisPointerView = echarts.extendComponentView({
	  type: 'axisPointer',
	  render: function (globalAxisPointerModel, ecModel, api) {
	    var globalTooltipModel = ecModel.getComponent('tooltip');
	    var triggerOn = globalAxisPointerModel.get('triggerOn') || globalTooltipModel && globalTooltipModel.get('triggerOn') || 'mousemove|click'; // Register global listener in AxisPointerView to enable
	    // AxisPointerView to be independent to Tooltip.
	
	    globalListener.register('axisPointer', api, function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none' && (currTrigger === 'leave' || triggerOn.indexOf(currTrigger) >= 0)) {
	        dispatchAction({
	          type: 'updateAxisPointer',
	          currTrigger: currTrigger,
	          x: e && e.offsetX,
	          y: e && e.offsetY
	        });
	      }
	    });
	  },
	
	  /**
	   * @override
	   */
	  remove: function (ecModel, api) {
	    globalListener.unregister(api.getZr(), 'axisPointer');
	    AxisPointerView.superApply(this._model, 'remove', arguments);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function (ecModel, api) {
	    globalListener.unregister('axisPointer', api);
	    AxisPointerView.superApply(this._model, 'dispose', arguments);
	  }
	});
	var _default = AxisPointerView;
	module.exports = _default;

/***/ },
/* 2322 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var formatUtil = __webpack_require__(48);
	
	var BaseAxisPointer = __webpack_require__(500);
	
	var graphic = __webpack_require__(14);
	
	var viewHelper = __webpack_require__(355);
	
	var matrix = __webpack_require__(86);
	
	var AxisBuilder = __webpack_require__(177);
	
	var AxisView = __webpack_require__(210);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PolarAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	
	    if (axis.dim === 'angle') {
	      this.animationThreshold = Math.PI / 18;
	    }
	
	    var polar = axis.polar;
	    var otherAxis = polar.getOtherAxis(axis);
	    var otherExtent = otherAxis.getExtent();
	    var coordValue;
	    coordValue = axis['dataTo' + formatUtil.capitalFirst(axis.dim)](value);
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, polar, coordValue, otherExtent, elStyle);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var labelMargin = axisPointerModel.get('label.margin');
	    var labelPos = getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin);
	    viewHelper.buildLabelElOption(elOption, axisModel, axisPointerModel, api, labelPos);
	  } // Do not support handle, utill any user requires it.
	
	});
	
	function getLabelPosition(value, axisModel, axisPointerModel, polar, labelMargin) {
	  var axis = axisModel.axis;
	  var coord = axis.dataToCoord(value);
	  var axisAngle = polar.getAngleAxis().getExtent()[0];
	  axisAngle = axisAngle / 180 * Math.PI;
	  var radiusExtent = polar.getRadiusAxis().getExtent();
	  var position;
	  var align;
	  var verticalAlign;
	
	  if (axis.dim === 'radius') {
	    var transform = matrix.create();
	    matrix.rotate(transform, transform, axisAngle);
	    matrix.translate(transform, transform, [polar.cx, polar.cy]);
	    position = graphic.applyTransform([coord, -labelMargin], transform);
	    var labelRotation = axisModel.getModel('axisLabel').get('rotate') || 0;
	    var labelLayout = AxisBuilder.innerTextLayout(axisAngle, labelRotation * Math.PI / 180, -1);
	    align = labelLayout.textAlign;
	    verticalAlign = labelLayout.textVerticalAlign;
	  } else {
	    // angle axis
	    var r = radiusExtent[1];
	    position = polar.coordToPoint([r + labelMargin, coord]);
	    var cx = polar.cx;
	    var cy = polar.cy;
	    align = Math.abs(position[0] - cx) / r < 0.3 ? 'center' : position[0] > cx ? 'left' : 'right';
	    verticalAlign = Math.abs(position[1] - cy) / r < 0.3 ? 'middle' : position[1] > cy ? 'top' : 'bottom';
	  }
	
	  return {
	    position: position,
	    align: align,
	    verticalAlign: verticalAlign
	  };
	}
	
	var pointerShapeBuilder = {
	  line: function (axis, polar, coordValue, otherExtent, elStyle) {
	    return axis.dim === 'angle' ? {
	      type: 'Line',
	      shape: viewHelper.makeLineShape(polar.coordToPoint([otherExtent[0], coordValue]), polar.coordToPoint([otherExtent[1], coordValue]))
	    } : {
	      type: 'Circle',
	      shape: {
	        cx: polar.cx,
	        cy: polar.cy,
	        r: coordValue
	      }
	    };
	  },
	  shadow: function (axis, polar, coordValue, otherExtent, elStyle) {
	    var bandWidth = Math.max(1, axis.getBandWidth());
	    var radian = Math.PI / 180;
	    return axis.dim === 'angle' ? {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, otherExtent[0], otherExtent[1], // In ECharts y is negative if angle is positive
	      (-coordValue - bandWidth / 2) * radian, (-coordValue + bandWidth / 2) * radian)
	    } : {
	      type: 'Sector',
	      shape: viewHelper.makeSectorShape(polar.cx, polar.cy, coordValue - bandWidth / 2, coordValue + bandWidth / 2, 0, Math.PI * 2)
	    };
	  }
	};
	AxisView.registerAxisPointerClass('PolarAxisPointer', PolarAxisPointer);
	var _default = PolarAxisPointer;
	module.exports = _default;

/***/ },
/* 2323 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var BaseAxisPointer = __webpack_require__(500);
	
	var viewHelper = __webpack_require__(355);
	
	var singleAxisHelper = __webpack_require__(868);
	
	var AxisView = __webpack_require__(210);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var XY = ['x', 'y'];
	var WH = ['width', 'height'];
	var SingleAxisPointer = BaseAxisPointer.extend({
	  /**
	   * @override
	   */
	  makeElOption: function (elOption, value, axisModel, axisPointerModel, api) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var otherExtent = getGlobalExtent(coordSys, 1 - getPointDimIndex(axis));
	    var pixelValue = coordSys.dataToPoint(value)[0];
	    var axisPointerType = axisPointerModel.get('type');
	
	    if (axisPointerType && axisPointerType !== 'none') {
	      var elStyle = viewHelper.buildElStyle(axisPointerModel);
	      var pointerOption = pointerShapeBuilder[axisPointerType](axis, pixelValue, otherExtent);
	      pointerOption.style = elStyle;
	      elOption.graphicKey = pointerOption.type;
	      elOption.pointer = pointerOption;
	    }
	
	    var layoutInfo = singleAxisHelper.layout(axisModel);
	    viewHelper.buildCartesianSingleLabelElOption(value, elOption, layoutInfo, axisModel, axisPointerModel, api);
	  },
	
	  /**
	   * @override
	   */
	  getHandleTransform: function (value, axisModel, axisPointerModel) {
	    var layoutInfo = singleAxisHelper.layout(axisModel, {
	      labelInside: false
	    });
	    layoutInfo.labelMargin = axisPointerModel.get('handle.margin');
	    return {
	      position: viewHelper.getTransformedPosition(axisModel.axis, value, layoutInfo),
	      rotation: layoutInfo.rotation + (layoutInfo.labelDirection < 0 ? Math.PI : 0)
	    };
	  },
	
	  /**
	   * @override
	   */
	  updateHandleTransform: function (transform, delta, axisModel, axisPointerModel) {
	    var axis = axisModel.axis;
	    var coordSys = axis.coordinateSystem;
	    var dimIndex = getPointDimIndex(axis);
	    var axisExtent = getGlobalExtent(coordSys, dimIndex);
	    var currPosition = transform.position;
	    currPosition[dimIndex] += delta[dimIndex];
	    currPosition[dimIndex] = Math.min(axisExtent[1], currPosition[dimIndex]);
	    currPosition[dimIndex] = Math.max(axisExtent[0], currPosition[dimIndex]);
	    var otherExtent = getGlobalExtent(coordSys, 1 - dimIndex);
	    var cursorOtherValue = (otherExtent[1] + otherExtent[0]) / 2;
	    var cursorPoint = [cursorOtherValue, cursorOtherValue];
	    cursorPoint[dimIndex] = currPosition[dimIndex];
	    return {
	      position: currPosition,
	      rotation: transform.rotation,
	      cursorPoint: cursorPoint,
	      tooltipOption: {
	        verticalAlign: 'middle'
	      }
	    };
	  }
	});
	var pointerShapeBuilder = {
	  line: function (axis, pixelValue, otherExtent) {
	    var targetShape = viewHelper.makeLineShape([pixelValue, otherExtent[0]], [pixelValue, otherExtent[1]], getPointDimIndex(axis));
	    return {
	      type: 'Line',
	      subPixelOptimize: true,
	      shape: targetShape
	    };
	  },
	  shadow: function (axis, pixelValue, otherExtent) {
	    var bandWidth = axis.getBandWidth();
	    var span = otherExtent[1] - otherExtent[0];
	    return {
	      type: 'Rect',
	      shape: viewHelper.makeRectShape([pixelValue - bandWidth / 2, otherExtent[0]], [bandWidth, span], getPointDimIndex(axis))
	    };
	  }
	};
	
	function getPointDimIndex(axis) {
	  return axis.isHorizontal() ? 0 : 1;
	}
	
	function getGlobalExtent(coordSys, dimIndex) {
	  var rect = coordSys.getRect();
	  return [rect[XY[dimIndex]], rect[XY[dimIndex]] + rect[WH[dimIndex]]];
	}
	
	AxisView.registerAxisPointerClass('SingleAxisPointer', SingleAxisPointer);
	var _default = SingleAxisPointer;
	module.exports = _default;

/***/ },
/* 2324 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	
	var modelHelper = __webpack_require__(354);
	
	var findPointFromSeries = __webpack_require__(836);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var curry = zrUtil.curry;
	var inner = makeInner();
	/**
	 * Basic logic: check all axis, if they do not demand show/highlight,
	 * then hide/downplay them.
	 *
	 * @param {Object} coordSysAxesInfo
	 * @param {Object} payload
	 * @param {string} [payload.currTrigger] 'click' | 'mousemove' | 'leave'
	 * @param {Array.<number>} [payload.x] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Array.<number>} [payload.y] x and y, which are mandatory, specify a point to
	 *              trigger axisPointer and tooltip.
	 * @param {Object} [payload.seriesIndex] finder, optional, restrict target axes.
	 * @param {Object} [payload.dataIndex] finder, restrict target axes.
	 * @param {Object} [payload.axesInfo] finder, restrict target axes.
	 *        [{
	 *          axisDim: 'x'|'y'|'angle'|...,
	 *          axisIndex: ...,
	 *          value: ...
	 *        }, ...]
	 * @param {Function} [payload.dispatchAction]
	 * @param {Object} [payload.tooltipOption]
	 * @param {Object|Array.<number>|Function} [payload.position] Tooltip position,
	 *        which can be specified in dispatchAction
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Object} content of event obj for echarts.connect.
	 */
	
	function _default(payload, ecModel, api) {
	  var currTrigger = payload.currTrigger;
	  var point = [payload.x, payload.y];
	  var finder = payload;
	  var dispatchAction = payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	  var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo; // Pending
	  // See #6121. But we are not able to reproduce it yet.
	
	  if (!coordSysAxesInfo) {
	    return;
	  }
	
	  if (illegalPoint(point)) {
	    // Used in the default behavior of `connection`: use the sample seriesIndex
	    // and dataIndex. And also used in the tooltipView trigger.
	    point = findPointFromSeries({
	      seriesIndex: finder.seriesIndex,
	      // Do not use dataIndexInside from other ec instance.
	      // FIXME: auto detect it?
	      dataIndex: finder.dataIndex
	    }, ecModel).point;
	  }
	
	  var isIllegalPoint = illegalPoint(point); // Axis and value can be specified when calling dispatchAction({type: 'updateAxisPointer'}).
	  // Notice: In this case, it is difficult to get the `point` (which is necessary to show
	  // tooltip, so if point is not given, we just use the point found by sample seriesIndex
	  // and dataIndex.
	
	  var inputAxesInfo = finder.axesInfo;
	  var axesInfo = coordSysAxesInfo.axesInfo;
	  var shouldHide = currTrigger === 'leave' || illegalPoint(point);
	  var outputFinder = {};
	  var showValueMap = {};
	  var dataByCoordSys = {
	    list: [],
	    map: {}
	  };
	  var updaters = {
	    showPointer: curry(showPointer, showValueMap),
	    showTooltip: curry(showTooltip, dataByCoordSys)
	  }; // Process for triggered axes.
	
	  each(coordSysAxesInfo.coordSysMap, function (coordSys, coordSysKey) {
	    // If a point given, it must be contained by the coordinate system.
	    var coordSysContainsPoint = isIllegalPoint || coordSys.containPoint(point);
	    each(coordSysAxesInfo.coordSysAxesInfo[coordSysKey], function (axisInfo, key) {
	      var axis = axisInfo.axis;
	      var inputAxisInfo = findInputAxisInfo(inputAxesInfo, axisInfo); // If no inputAxesInfo, no axis is restricted.
	
	      if (!shouldHide && coordSysContainsPoint && (!inputAxesInfo || inputAxisInfo)) {
	        var val = inputAxisInfo && inputAxisInfo.value;
	
	        if (val == null && !isIllegalPoint) {
	          val = axis.pointToData(point);
	        }
	
	        val != null && processOnAxis(axisInfo, val, updaters, false, outputFinder);
	      }
	    });
	  }); // Process for linked axes.
	
	  var linkTriggers = {};
	  each(axesInfo, function (tarAxisInfo, tarKey) {
	    var linkGroup = tarAxisInfo.linkGroup; // If axis has been triggered in the previous stage, it should not be triggered by link.
	
	    if (linkGroup && !showValueMap[tarKey]) {
	      each(linkGroup.axesInfo, function (srcAxisInfo, srcKey) {
	        var srcValItem = showValueMap[srcKey]; // If srcValItem exist, source axis is triggered, so link to target axis.
	
	        if (srcAxisInfo !== tarAxisInfo && srcValItem) {
	          var val = srcValItem.value;
	          linkGroup.mapper && (val = tarAxisInfo.axis.scale.parse(linkGroup.mapper(val, makeMapperParam(srcAxisInfo), makeMapperParam(tarAxisInfo))));
	          linkTriggers[tarAxisInfo.key] = val;
	        }
	      });
	    }
	  });
	  each(linkTriggers, function (val, tarKey) {
	    processOnAxis(axesInfo[tarKey], val, updaters, true, outputFinder);
	  });
	  updateModelActually(showValueMap, axesInfo, outputFinder);
	  dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction);
	  dispatchHighDownActually(axesInfo, dispatchAction, api);
	  return outputFinder;
	}
	
	function processOnAxis(axisInfo, newValue, updaters, dontSnap, outputFinder) {
	  var axis = axisInfo.axis;
	
	  if (axis.scale.isBlank() || !axis.containData(newValue)) {
	    return;
	  }
	
	  if (!axisInfo.involveSeries) {
	    updaters.showPointer(axisInfo, newValue);
	    return;
	  } // Heavy calculation. So put it after axis.containData checking.
	
	
	  var payloadInfo = buildPayloadsBySeries(newValue, axisInfo);
	  var payloadBatch = payloadInfo.payloadBatch;
	  var snapToValue = payloadInfo.snapToValue; // Fill content of event obj for echarts.connect.
	  // By default use the first involved series data as a sample to connect.
	
	  if (payloadBatch[0] && outputFinder.seriesIndex == null) {
	    zrUtil.extend(outputFinder, payloadBatch[0]);
	  } // If no linkSource input, this process is for collecting link
	  // target, where snap should not be accepted.
	
	
	  if (!dontSnap && axisInfo.snap) {
	    if (axis.containData(snapToValue) && snapToValue != null) {
	      newValue = snapToValue;
	    }
	  }
	
	  updaters.showPointer(axisInfo, newValue, payloadBatch, outputFinder); // Tooltip should always be snapToValue, otherwise there will be
	  // incorrect "axis value ~ series value" mapping displayed in tooltip.
	
	  updaters.showTooltip(axisInfo, payloadInfo, snapToValue);
	}
	
	function buildPayloadsBySeries(value, axisInfo) {
	  var axis = axisInfo.axis;
	  var dim = axis.dim;
	  var snapToValue = value;
	  var payloadBatch = [];
	  var minDist = Number.MAX_VALUE;
	  var minDiff = -1;
	  each(axisInfo.seriesModels, function (series, idx) {
	    var dataDim = series.getData().mapDimension(dim, true);
	    var seriesNestestValue;
	    var dataIndices;
	
	    if (series.getAxisTooltipData) {
	      var result = series.getAxisTooltipData(dataDim, value, axis);
	      dataIndices = result.dataIndices;
	      seriesNestestValue = result.nestestValue;
	    } else {
	      dataIndices = series.getData().indicesOfNearest(dataDim[0], value, // Add a threshold to avoid find the wrong dataIndex
	      // when data length is not same.
	      // false,
	      axis.type === 'category' ? 0.5 : null);
	
	      if (!dataIndices.length) {
	        return;
	      }
	
	      seriesNestestValue = series.getData().get(dataDim[0], dataIndices[0]);
	    }
	
	    if (seriesNestestValue == null || !isFinite(seriesNestestValue)) {
	      return;
	    }
	
	    var diff = value - seriesNestestValue;
	    var dist = Math.abs(diff); // Consider category case
	
	    if (dist <= minDist) {
	      if (dist < minDist || diff >= 0 && minDiff < 0) {
	        minDist = dist;
	        minDiff = diff;
	        snapToValue = seriesNestestValue;
	        payloadBatch.length = 0;
	      }
	
	      each(dataIndices, function (dataIndex) {
	        payloadBatch.push({
	          seriesIndex: series.seriesIndex,
	          dataIndexInside: dataIndex,
	          dataIndex: series.getData().getRawIndex(dataIndex)
	        });
	      });
	    }
	  });
	  return {
	    payloadBatch: payloadBatch,
	    snapToValue: snapToValue
	  };
	}
	
	function showPointer(showValueMap, axisInfo, value, payloadBatch) {
	  showValueMap[axisInfo.key] = {
	    value: value,
	    payloadBatch: payloadBatch
	  };
	}
	
	function showTooltip(dataByCoordSys, axisInfo, payloadInfo, value) {
	  var payloadBatch = payloadInfo.payloadBatch;
	  var axis = axisInfo.axis;
	  var axisModel = axis.model;
	  var axisPointerModel = axisInfo.axisPointerModel; // If no data, do not create anything in dataByCoordSys,
	  // whose length will be used to judge whether dispatch action.
	
	  if (!axisInfo.triggerTooltip || !payloadBatch.length) {
	    return;
	  }
	
	  var coordSysModel = axisInfo.coordSys.model;
	  var coordSysKey = modelHelper.makeKey(coordSysModel);
	  var coordSysItem = dataByCoordSys.map[coordSysKey];
	
	  if (!coordSysItem) {
	    coordSysItem = dataByCoordSys.map[coordSysKey] = {
	      coordSysId: coordSysModel.id,
	      coordSysIndex: coordSysModel.componentIndex,
	      coordSysType: coordSysModel.type,
	      coordSysMainType: coordSysModel.mainType,
	      dataByAxis: []
	    };
	    dataByCoordSys.list.push(coordSysItem);
	  }
	
	  coordSysItem.dataByAxis.push({
	    axisDim: axis.dim,
	    axisIndex: axisModel.componentIndex,
	    axisType: axisModel.type,
	    axisId: axisModel.id,
	    value: value,
	    // Caustion: viewHelper.getValueLabel is actually on "view stage", which
	    // depends that all models have been updated. So it should not be performed
	    // here. Considering axisPointerModel used here is volatile, which is hard
	    // to be retrieve in TooltipView, we prepare parameters here.
	    valueLabelOpt: {
	      precision: axisPointerModel.get('label.precision'),
	      formatter: axisPointerModel.get('label.formatter')
	    },
	    seriesDataIndices: payloadBatch.slice()
	  });
	}
	
	function updateModelActually(showValueMap, axesInfo, outputFinder) {
	  var outputAxesInfo = outputFinder.axesInfo = []; // Basic logic: If no 'show' required, 'hide' this axisPointer.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    var valItem = showValueMap[key];
	
	    if (valItem) {
	      !axisInfo.useHandle && (option.status = 'show');
	      option.value = valItem.value; // For label formatter param and highlight.
	
	      option.seriesDataIndices = (valItem.payloadBatch || []).slice();
	    } // When always show (e.g., handle used), remain
	    // original value and status.
	    else {
	        // If hide, value still need to be set, consider
	        // click legend to toggle axis blank.
	        !axisInfo.useHandle && (option.status = 'hide');
	      } // If status is 'hide', should be no info in payload.
	
	
	    option.status === 'show' && outputAxesInfo.push({
	      axisDim: axisInfo.axis.dim,
	      axisIndex: axisInfo.axis.model.componentIndex,
	      value: option.value
	    });
	  });
	}
	
	function dispatchTooltipActually(dataByCoordSys, point, payload, dispatchAction) {
	  // Basic logic: If no showTip required, hideTip will be dispatched.
	  if (illegalPoint(point) || !dataByCoordSys.list.length) {
	    dispatchAction({
	      type: 'hideTip'
	    });
	    return;
	  } // In most case only one axis (or event one series is used). It is
	  // convinient to fetch payload.seriesIndex and payload.dataIndex
	  // dirtectly. So put the first seriesIndex and dataIndex of the first
	  // axis on the payload.
	
	
	  var sampleItem = ((dataByCoordSys.list[0].dataByAxis[0] || {}).seriesDataIndices || [])[0] || {};
	  dispatchAction({
	    type: 'showTip',
	    escapeConnect: true,
	    x: point[0],
	    y: point[1],
	    tooltipOption: payload.tooltipOption,
	    position: payload.position,
	    dataIndexInside: sampleItem.dataIndexInside,
	    dataIndex: sampleItem.dataIndex,
	    seriesIndex: sampleItem.seriesIndex,
	    dataByCoordSys: dataByCoordSys.list
	  });
	}
	
	function dispatchHighDownActually(axesInfo, dispatchAction, api) {
	  // FIXME
	  // highlight status modification shoule be a stage of main process?
	  // (Consider confilct (e.g., legend and axisPointer) and setOption)
	  var zr = api.getZr();
	  var highDownKey = 'axisPointerLastHighlights';
	  var lastHighlights = inner(zr)[highDownKey] || {};
	  var newHighlights = inner(zr)[highDownKey] = {}; // Update highlight/downplay status according to axisPointer model.
	  // Build hash map and remove duplicate incidentally.
	
	  each(axesInfo, function (axisInfo, key) {
	    var option = axisInfo.axisPointerModel.option;
	    option.status === 'show' && each(option.seriesDataIndices, function (batchItem) {
	      var key = batchItem.seriesIndex + ' | ' + batchItem.dataIndex;
	      newHighlights[key] = batchItem;
	    });
	  }); // Diff.
	
	  var toHighlight = [];
	  var toDownplay = [];
	  zrUtil.each(lastHighlights, function (batchItem, key) {
	    !newHighlights[key] && toDownplay.push(batchItem);
	  });
	  zrUtil.each(newHighlights, function (batchItem, key) {
	    !lastHighlights[key] && toHighlight.push(batchItem);
	  });
	  toDownplay.length && api.dispatchAction({
	    type: 'downplay',
	    escapeConnect: true,
	    batch: toDownplay
	  });
	  toHighlight.length && api.dispatchAction({
	    type: 'highlight',
	    escapeConnect: true,
	    batch: toHighlight
	  });
	}
	
	function findInputAxisInfo(inputAxesInfo, axisInfo) {
	  for (var i = 0; i < (inputAxesInfo || []).length; i++) {
	    var inputAxisInfo = inputAxesInfo[i];
	
	    if (axisInfo.axis.dim === inputAxisInfo.axisDim && axisInfo.axis.model.componentIndex === inputAxisInfo.axisIndex) {
	      return inputAxisInfo;
	    }
	  }
	}
	
	function makeMapperParam(axisInfo) {
	  var axisModel = axisInfo.axis.model;
	  var item = {};
	  var dim = item.axisDim = axisInfo.axis.dim;
	  item.axisIndex = item[dim + 'AxisIndex'] = axisModel.componentIndex;
	  item.axisName = item[dim + 'AxisName'] = axisModel.name;
	  item.axisId = item[dim + 'AxisId'] = axisModel.id;
	  return item;
	}
	
	function illegalPoint(point) {
	  return !point || point[0] == null || isNaN(point[0]) || point[1] == null || isNaN(point[1]);
	}
	
	module.exports = _default;

/***/ },
/* 2325 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var preprocessor = __webpack_require__(2329);
	
	__webpack_require__(838);
	
	__webpack_require__(2326);
	
	__webpack_require__(2327);
	
	__webpack_require__(2328);
	
	__webpack_require__(2380);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Brush component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ },
/* 2326 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var visualSolution = __webpack_require__(364);
	
	var Model = __webpack_require__(70);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_OUT_OF_BRUSH_COLOR = ['#ddd'];
	var BrushModel = echarts.extendComponentModel({
	  type: 'brush',
	  dependencies: ['geo', 'grid', 'xAxis', 'yAxis', 'parallel', 'series'],
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    // inBrush: null,
	    // outOfBrush: null,
	    toolbox: null,
	    // Default value see preprocessor.
	    brushLink: null,
	    // Series indices array, broadcast using dataIndex.
	    // or 'all', which means all series. 'none' or null means no series.
	    seriesIndex: 'all',
	    // seriesIndex array, specify series controlled by this brush component.
	    geoIndex: null,
	    //
	    xAxisIndex: null,
	    yAxisIndex: null,
	    brushType: 'rect',
	    // Default brushType, see BrushController.
	    brushMode: 'single',
	    // Default brushMode, 'single' or 'multiple'
	    transformable: true,
	    // Default transformable.
	    brushStyle: {
	      // Default brushStyle
	      borderWidth: 1,
	      color: 'rgba(120,140,180,0.3)',
	      borderColor: 'rgba(120,140,180,0.8)'
	    },
	    throttleType: 'fixRate',
	    // Throttle in brushSelected event. 'fixRate' or 'debounce'.
	    // If null, no throttle. Valid only in the first brush component
	    throttleDelay: 0,
	    // Unit: ms, 0 means every event will be triggered.
	    // FIXME
	    // 试验效果
	    removeOnClick: true,
	    z: 10000
	  },
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  areas: [],
	
	  /**
	   * Current activated brush type.
	   * If null, brush is inactived.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {string}
	   */
	  brushType: null,
	
	  /**
	   * Current brush opt.
	   * see module:echarts/component/helper/BrushController
	   * @readOnly
	   * @type {Object}
	   */
	  brushOption: {},
	
	  /**
	   * @readOnly
	   * @type {Array.<Object>}
	   */
	  coordInfoList: [],
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    !isInit && visualSolution.replaceVisualOption(thisOption, newOption, ['inBrush', 'outOfBrush']);
	    var inBrush = thisOption.inBrush = thisOption.inBrush || {}; // Always give default visual, consider setOption at the second time.
	
	    thisOption.outOfBrush = thisOption.outOfBrush || {
	      color: DEFAULT_OUT_OF_BRUSH_COLOR
	    };
	
	    if (!inBrush.hasOwnProperty('liftZ')) {
	      // Bigger than the highlight z lift, otherwise it will
	      // be effected by the highlight z when brush.
	      inBrush.liftZ = 5;
	    }
	  },
	
	  /**
	   * If ranges is null/undefined, range state remain.
	   *
	   * @param {Array.<Object>} [ranges]
	   */
	  setAreas: function (areas) {
	    // If ranges is null/undefined, range state remain.
	    // This helps user to dispatchAction({type: 'brush'}) with no areas
	    // set but just want to get the current brush select info from a `brush` event.
	    if (!areas) {
	      return;
	    }
	
	    this.areas = zrUtil.map(areas, function (area) {
	      return generateBrushOption(this.option, area);
	    }, this);
	  },
	
	  /**
	   * see module:echarts/component/helper/BrushController
	   * @param {Object} brushOption
	   */
	  setBrushOption: function (brushOption) {
	    this.brushOption = generateBrushOption(this.option, brushOption);
	    this.brushType = this.brushOption.brushType;
	  }
	});
	
	function generateBrushOption(option, brushOption) {
	  return zrUtil.merge({
	    brushType: option.brushType,
	    brushMode: option.brushMode,
	    transformable: option.transformable,
	    brushStyle: new Model(option.brushStyle).getItemStyle(),
	    removeOnClick: option.removeOnClick,
	    z: option.z
	  }, brushOption, true);
	}
	
	var _default = BrushModel;
	module.exports = _default;

/***/ },
/* 2327 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var BrushController = __webpack_require__(505);
	
	var _visualEncoding = __webpack_require__(838);
	
	var layoutCovers = _visualEncoding.layoutCovers;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'brush',
	  init: function (ecModel, api) {
	    /**
	     * @readOnly
	     * @type {module:echarts/model/Global}
	     */
	    this.ecModel = ecModel;
	    /**
	     * @readOnly
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this.api = api;
	    /**
	     * @readOnly
	     * @type {module:echarts/component/brush/BrushModel}
	     */
	
	    this.model;
	    /**
	     * @private
	     * @type {module:echarts/component/helper/BrushController}
	     */
	
	    (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  },
	
	  /**
	   * @override
	   */
	  render: function (brushModel) {
	    this.model = brushModel;
	    return updateController.apply(this, arguments);
	  },
	
	  /**
	   * @override
	   */
	  updateTransform: function (brushModel, ecModel) {
	    // PENDING: `updateTransform` is a little tricky, whose layout need
	    // to be calculate mandatorily and other stages will not be performed.
	    // Take care the correctness of the logic. See #11754 .
	    layoutCovers(ecModel);
	    return updateController.apply(this, arguments);
	  },
	
	  /**
	   * @override
	   */
	  updateView: updateController,
	  // /**
	  //  * @override
	  //  */
	  // updateLayout: updateController,
	  // /**
	  //  * @override
	  //  */
	  // updateVisual: updateController,
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._brushController.dispose();
	  },
	
	  /**
	   * @private
	   */
	  _onBrush: function (areas, opt) {
	    var modelId = this.model.id;
	    this.model.brushTargetManager.setOutputRanges(areas, this.ecModel); // Action is not dispatched on drag end, because the drag end
	    // emits the same params with the last drag move event, and
	    // may have some delay when using touch pad, which makes
	    // animation not smooth (when using debounce).
	
	    (!opt.isEnd || opt.removeOnClick) && this.api.dispatchAction({
	      type: 'brush',
	      brushId: modelId,
	      areas: zrUtil.clone(areas),
	      $from: modelId
	    });
	    opt.isEnd && this.api.dispatchAction({
	      type: 'brushEnd',
	      brushId: modelId,
	      areas: zrUtil.clone(areas),
	      $from: modelId
	    });
	  }
	});
	
	function updateController(brushModel, ecModel, api, payload) {
	  // Do not update controller when drawing.
	  (!payload || payload.$from !== brushModel.id) && this._brushController.setPanels(brushModel.brushTargetManager.makePanelOpts(api)).enableBrush(brushModel.brushOption).updateCovers(brushModel.areas.slice());
	}
	
	module.exports = _default;

/***/ },
/* 2328 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * payload: {
	 *      brushIndex: number, or,
	 *      brushId: string, or,
	 *      brushName: string,
	 *      globalRanges: Array
	 * }
	 */
	echarts.registerAction({
	  type: 'brush',
	  event: 'brush'
	  /*, update: 'updateView' */
	
	}, function (payload, ecModel) {
	  ecModel.eachComponent({
	    mainType: 'brush',
	    query: payload
	  }, function (brushModel) {
	    brushModel.setAreas(payload.areas);
	  });
	});
	/**
	 * payload: {
	 *      brushComponents: [
	 *          {
	 *              brushId,
	 *              brushIndex,
	 *              brushName,
	 *              series: [
	 *                  {
	 *                      seriesId,
	 *                      seriesIndex,
	 *                      seriesName,
	 *                      rawIndices: [21, 34, ...]
	 *                  },
	 *                  ...
	 *              ]
	 *          },
	 *          ...
	 *      ]
	 * }
	 */
	
	echarts.registerAction({
	  type: 'brushSelect',
	  event: 'brushSelected',
	  update: 'none'
	}, function () {});
	echarts.registerAction({
	  type: 'brushEnd',
	  event: 'brushEnd',
	  update: 'none'
	}, function () {});

/***/ },
/* 2329 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var DEFAULT_TOOLBOX_BTNS = ['rect', 'polygon', 'keep', 'clear'];
	
	function _default(option, isNew) {
	  var brushComponents = option && option.brush;
	
	  if (!zrUtil.isArray(brushComponents)) {
	    brushComponents = brushComponents ? [brushComponents] : [];
	  }
	
	  if (!brushComponents.length) {
	    return;
	  }
	
	  var brushComponentSpecifiedBtns = [];
	  zrUtil.each(brushComponents, function (brushOpt) {
	    var tbs = brushOpt.hasOwnProperty('toolbox') ? brushOpt.toolbox : [];
	
	    if (tbs instanceof Array) {
	      brushComponentSpecifiedBtns = brushComponentSpecifiedBtns.concat(tbs);
	    }
	  });
	  var toolbox = option && option.toolbox;
	
	  if (zrUtil.isArray(toolbox)) {
	    toolbox = toolbox[0];
	  }
	
	  if (!toolbox) {
	    toolbox = {
	      feature: {}
	    };
	    option.toolbox = [toolbox];
	  }
	
	  var toolboxFeature = toolbox.feature || (toolbox.feature = {});
	  var toolboxBrush = toolboxFeature.brush || (toolboxFeature.brush = {});
	  var brushTypes = toolboxBrush.type || (toolboxBrush.type = []);
	  brushTypes.push.apply(brushTypes, brushComponentSpecifiedBtns);
	  removeDuplicate(brushTypes);
	
	  if (isNew && !brushTypes.length) {
	    brushTypes.push.apply(brushTypes, DEFAULT_TOOLBOX_BTNS);
	  }
	}
	
	function removeDuplicate(arr) {
	  var map = {};
	  zrUtil.each(arr, function (val) {
	    map[val] = 1;
	  });
	  arr.length = 0;
	  zrUtil.each(map, function (flag, val) {
	    arr.push(val);
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2330 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var polygonContain = __webpack_require__(1191);
	
	var BoundingRect = __webpack_require__(60);
	
	var _graphic = __webpack_require__(14);
	
	var linePolygonIntersect = _graphic.linePolygonIntersect;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Key of the first level is brushType: `line`, `rect`, `polygon`.
	// Key of the second level is chart element type: `point`, `rect`.
	// See moudule:echarts/component/helper/BrushController
	// function param:
	//      {Object} itemLayout fetch from data.getItemLayout(dataIndex)
	//      {Object} selectors {point: selector, rect: selector, ...}
	//      {Object} area {range: [[], [], ..], boudingRect}
	// function return:
	//      {boolean} Whether in the given brush.
	var selector = {
	  lineX: getLineSelectors(0),
	  lineY: getLineSelectors(1),
	  rect: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.intersect(itemLayout);
	    }
	  },
	  polygon: {
	    point: function (itemLayout, selectors, area) {
	      return itemLayout && area.boundingRect.contain(itemLayout[0], itemLayout[1]) && polygonContain.contain(area.range, itemLayout[0], itemLayout[1]);
	    },
	    rect: function (itemLayout, selectors, area) {
	      var points = area.range;
	
	      if (!itemLayout || points.length <= 1) {
	        return false;
	      }
	
	      var x = itemLayout.x;
	      var y = itemLayout.y;
	      var width = itemLayout.width;
	      var height = itemLayout.height;
	      var p = points[0];
	
	      if (polygonContain.contain(points, x, y) || polygonContain.contain(points, x + width, y) || polygonContain.contain(points, x, y + height) || polygonContain.contain(points, x + width, y + height) || BoundingRect.create(itemLayout).contain(p[0], p[1]) || linePolygonIntersect(x, y, x + width, y, points) || linePolygonIntersect(x, y, x, y + height, points) || linePolygonIntersect(x + width, y, x + width, y + height, points) || linePolygonIntersect(x, y + height, x + width, y + height, points)) {
	        return true;
	      }
	    }
	  }
	};
	
	function getLineSelectors(xyIndex) {
	  var xy = ['x', 'y'];
	  var wh = ['width', 'height'];
	  return {
	    point: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var p = itemLayout[xyIndex];
	        return inLineRange(p, range);
	      }
	    },
	    rect: function (itemLayout, selectors, area) {
	      if (itemLayout) {
	        var range = area.range;
	        var layoutRange = [itemLayout[xy[xyIndex]], itemLayout[xy[xyIndex]] + itemLayout[wh[xyIndex]]];
	        layoutRange[1] < layoutRange[0] && layoutRange.reverse();
	        return inLineRange(layoutRange[0], range) || inLineRange(layoutRange[1], range) || inLineRange(range[0], layoutRange) || inLineRange(range[1], layoutRange);
	      }
	    }
	  };
	}
	
	function inLineRange(p, range) {
	  return range[0] <= p && p <= range[1];
	}
	
	var _default = selector;
	module.exports = _default;

/***/ },
/* 2331 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(2397);
	
	__webpack_require__(2398);
	
	__webpack_require__(2332);

/***/ },
/* 2332 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var formatUtil = __webpack_require__(48);
	
	var numberUtil = __webpack_require__(25);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var MONTH_TEXT = {
	  EN: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
	  CN: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月']
	};
	var WEEK_TEXT = {
	  EN: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
	  CN: ['日', '一', '二', '三', '四', '五', '六']
	};
	
	var _default = echarts.extendComponentView({
	  type: 'calendar',
	
	  /**
	   * top/left line points
	   *  @private
	   */
	  _tlpoints: null,
	
	  /**
	   * bottom/right line points
	   *  @private
	   */
	  _blpoints: null,
	
	  /**
	   * first day of month
	   *  @private
	   */
	  _firstDayOfMonth: null,
	
	  /**
	   * first day point of month
	   *  @private
	   */
	  _firstDayPoints: null,
	  render: function (calendarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	    var coordSys = calendarModel.coordinateSystem; // range info
	
	    var rangeData = coordSys.getRangeInfo();
	    var orient = coordSys.getOrient();
	
	    this._renderDayRect(calendarModel, rangeData, group); // _renderLines must be called prior to following function
	
	
	    this._renderLines(calendarModel, rangeData, orient, group);
	
	    this._renderYearText(calendarModel, rangeData, orient, group);
	
	    this._renderMonthText(calendarModel, orient, group);
	
	    this._renderWeekText(calendarModel, rangeData, orient, group);
	  },
	  // render day rect
	  _renderDayRect: function (calendarModel, rangeData, group) {
	    var coordSys = calendarModel.coordinateSystem;
	    var itemRectStyleModel = calendarModel.getModel('itemStyle').getItemStyle();
	    var sw = coordSys.getCellWidth();
	    var sh = coordSys.getCellHeight();
	
	    for (var i = rangeData.start.time; i <= rangeData.end.time; i = coordSys.getNextNDay(i, 1).time) {
	      var point = coordSys.dataToRect([i], false).tl; // every rect
	
	      var rect = new graphic.Rect({
	        shape: {
	          x: point[0],
	          y: point[1],
	          width: sw,
	          height: sh
	        },
	        cursor: 'default',
	        style: itemRectStyleModel
	      });
	      group.add(rect);
	    }
	  },
	  // render separate line
	  _renderLines: function (calendarModel, rangeData, orient, group) {
	    var self = this;
	    var coordSys = calendarModel.coordinateSystem;
	    var lineStyleModel = calendarModel.getModel('splitLine.lineStyle').getLineStyle();
	    var show = calendarModel.get('splitLine.show');
	    var lineWidth = lineStyleModel.lineWidth;
	    this._tlpoints = [];
	    this._blpoints = [];
	    this._firstDayOfMonth = [];
	    this._firstDayPoints = [];
	    var firstDay = rangeData.start;
	
	    for (var i = 0; firstDay.time <= rangeData.end.time; i++) {
	      addPoints(firstDay.formatedDate);
	
	      if (i === 0) {
	        firstDay = coordSys.getDateInfo(rangeData.start.y + '-' + rangeData.start.m);
	      }
	
	      var date = firstDay.date;
	      date.setMonth(date.getMonth() + 1);
	      firstDay = coordSys.getDateInfo(date);
	    }
	
	    addPoints(coordSys.getNextNDay(rangeData.end.time, 1).formatedDate);
	
	    function addPoints(date) {
	      self._firstDayOfMonth.push(coordSys.getDateInfo(date));
	
	      self._firstDayPoints.push(coordSys.dataToRect([date], false).tl);
	
	      var points = self._getLinePointsOfOneWeek(calendarModel, date, orient);
	
	      self._tlpoints.push(points[0]);
	
	      self._blpoints.push(points[points.length - 1]);
	
	      show && self._drawSplitline(points, lineStyleModel, group);
	    } // render top/left line
	
	
	    show && this._drawSplitline(self._getEdgesPoints(self._tlpoints, lineWidth, orient), lineStyleModel, group); // render bottom/right line
	
	    show && this._drawSplitline(self._getEdgesPoints(self._blpoints, lineWidth, orient), lineStyleModel, group);
	  },
	  // get points at both ends
	  _getEdgesPoints: function (points, lineWidth, orient) {
	    var rs = [points[0].slice(), points[points.length - 1].slice()];
	    var idx = orient === 'horizontal' ? 0 : 1; // both ends of the line are extend half lineWidth
	
	    rs[0][idx] = rs[0][idx] - lineWidth / 2;
	    rs[1][idx] = rs[1][idx] + lineWidth / 2;
	    return rs;
	  },
	  // render split line
	  _drawSplitline: function (points, lineStyleModel, group) {
	    var poyline = new graphic.Polyline({
	      z2: 20,
	      shape: {
	        points: points
	      },
	      style: lineStyleModel
	    });
	    group.add(poyline);
	  },
	  // render month line of one week points
	  _getLinePointsOfOneWeek: function (calendarModel, date, orient) {
	    var coordSys = calendarModel.coordinateSystem;
	    date = coordSys.getDateInfo(date);
	    var points = [];
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(date.time, i);
	      var point = coordSys.dataToRect([tmpD.time], false);
	      points[2 * tmpD.day] = point.tl;
	      points[2 * tmpD.day + 1] = point[orient === 'horizontal' ? 'bl' : 'tr'];
	    }
	
	    return points;
	  },
	  _formatterLabel: function (formatter, params) {
	    if (typeof formatter === 'string' && formatter) {
	      return formatUtil.formatTplSimple(formatter, params);
	    }
	
	    if (typeof formatter === 'function') {
	      return formatter(params);
	    }
	
	    return params.nameMap;
	  },
	  _yearTextPositionControl: function (textEl, point, orient, position, margin) {
	    point = point.slice();
	    var aligns = ['center', 'bottom'];
	
	    if (position === 'bottom') {
	      point[1] += margin;
	      aligns = ['center', 'top'];
	    } else if (position === 'left') {
	      point[0] -= margin;
	    } else if (position === 'right') {
	      point[0] += margin;
	      aligns = ['center', 'top'];
	    } else {
	      // top
	      point[1] -= margin;
	    }
	
	    var rotate = 0;
	
	    if (position === 'left' || position === 'right') {
	      rotate = Math.PI / 2;
	    }
	
	    return {
	      rotation: rotate,
	      position: point,
	      style: {
	        textAlign: aligns[0],
	        textVerticalAlign: aligns[1]
	      }
	    };
	  },
	  // render year
	  _renderYearText: function (calendarModel, rangeData, orient, group) {
	    var yearLabel = calendarModel.getModel('yearLabel');
	
	    if (!yearLabel.get('show')) {
	      return;
	    }
	
	    var margin = yearLabel.get('margin');
	    var pos = yearLabel.get('position');
	
	    if (!pos) {
	      pos = orient !== 'horizontal' ? 'top' : 'left';
	    }
	
	    var points = [this._tlpoints[this._tlpoints.length - 1], this._blpoints[0]];
	    var xc = (points[0][0] + points[1][0]) / 2;
	    var yc = (points[0][1] + points[1][1]) / 2;
	    var idx = orient === 'horizontal' ? 0 : 1;
	    var posPoints = {
	      top: [xc, points[idx][1]],
	      bottom: [xc, points[1 - idx][1]],
	      left: [points[1 - idx][0], yc],
	      right: [points[idx][0], yc]
	    };
	    var name = rangeData.start.y;
	
	    if (+rangeData.end.y > +rangeData.start.y) {
	      name = name + '-' + rangeData.end.y;
	    }
	
	    var formatter = yearLabel.get('formatter');
	    var params = {
	      start: rangeData.start.y,
	      end: rangeData.end.y,
	      nameMap: name
	    };
	
	    var content = this._formatterLabel(formatter, params);
	
	    var yearText = new graphic.Text({
	      z2: 30
	    });
	    graphic.setTextStyle(yearText.style, yearLabel, {
	      text: content
	    }), yearText.attr(this._yearTextPositionControl(yearText, posPoints[pos], orient, pos, margin));
	    group.add(yearText);
	  },
	  _monthTextPositionControl: function (point, isCenter, orient, position, margin) {
	    var align = 'left';
	    var vAlign = 'top';
	    var x = point[0];
	    var y = point[1];
	
	    if (orient === 'horizontal') {
	      y = y + margin;
	
	      if (isCenter) {
	        align = 'center';
	      }
	
	      if (position === 'start') {
	        vAlign = 'bottom';
	      }
	    } else {
	      x = x + margin;
	
	      if (isCenter) {
	        vAlign = 'middle';
	      }
	
	      if (position === 'start') {
	        align = 'right';
	      }
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render month and year text
	  _renderMonthText: function (calendarModel, orient, group) {
	    var monthLabel = calendarModel.getModel('monthLabel');
	
	    if (!monthLabel.get('show')) {
	      return;
	    }
	
	    var nameMap = monthLabel.get('nameMap');
	    var margin = monthLabel.get('margin');
	    var pos = monthLabel.get('position');
	    var align = monthLabel.get('align');
	    var termPoints = [this._tlpoints, this._blpoints];
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = MONTH_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var idx = pos === 'start' ? 0 : 1;
	    var axis = orient === 'horizontal' ? 0 : 1;
	    margin = pos === 'start' ? -margin : margin;
	    var isCenter = align === 'center';
	
	    for (var i = 0; i < termPoints[idx].length - 1; i++) {
	      var tmp = termPoints[idx][i].slice();
	      var firstDay = this._firstDayOfMonth[i];
	
	      if (isCenter) {
	        var firstDayPoints = this._firstDayPoints[i];
	        tmp[axis] = (firstDayPoints[axis] + termPoints[0][i + 1][axis]) / 2;
	      }
	
	      var formatter = monthLabel.get('formatter');
	      var name = nameMap[+firstDay.m - 1];
	      var params = {
	        yyyy: firstDay.y,
	        yy: (firstDay.y + '').slice(2),
	        MM: firstDay.m,
	        M: +firstDay.m,
	        nameMap: name
	      };
	
	      var content = this._formatterLabel(formatter, params);
	
	      var monthText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(monthText.style, monthLabel, {
	        text: content
	      }), this._monthTextPositionControl(tmp, isCenter, orient, pos, margin));
	      group.add(monthText);
	    }
	  },
	  _weekTextPositionControl: function (point, orient, position, margin, cellSize) {
	    var align = 'center';
	    var vAlign = 'middle';
	    var x = point[0];
	    var y = point[1];
	    var isStart = position === 'start';
	
	    if (orient === 'horizontal') {
	      x = x + margin + (isStart ? 1 : -1) * cellSize[0] / 2;
	      align = isStart ? 'right' : 'left';
	    } else {
	      y = y + margin + (isStart ? 1 : -1) * cellSize[1] / 2;
	      vAlign = isStart ? 'bottom' : 'top';
	    }
	
	    return {
	      x: x,
	      y: y,
	      textAlign: align,
	      textVerticalAlign: vAlign
	    };
	  },
	  // render weeks
	  _renderWeekText: function (calendarModel, rangeData, orient, group) {
	    var dayLabel = calendarModel.getModel('dayLabel');
	
	    if (!dayLabel.get('show')) {
	      return;
	    }
	
	    var coordSys = calendarModel.coordinateSystem;
	    var pos = dayLabel.get('position');
	    var nameMap = dayLabel.get('nameMap');
	    var margin = dayLabel.get('margin');
	    var firstDayOfWeek = coordSys.getFirstDayOfWeek();
	
	    if (zrUtil.isString(nameMap)) {
	      nameMap = WEEK_TEXT[nameMap.toUpperCase()] || [];
	    }
	
	    var start = coordSys.getNextNDay(rangeData.end.time, 7 - rangeData.lweek).time;
	    var cellSize = [coordSys.getCellWidth(), coordSys.getCellHeight()];
	    margin = numberUtil.parsePercent(margin, cellSize[orient === 'horizontal' ? 0 : 1]);
	
	    if (pos === 'start') {
	      start = coordSys.getNextNDay(rangeData.start.time, -(7 + rangeData.fweek)).time;
	      margin = -margin;
	    }
	
	    for (var i = 0; i < 7; i++) {
	      var tmpD = coordSys.getNextNDay(start, i);
	      var point = coordSys.dataToRect([tmpD.time], false).center;
	      var day = i;
	      day = Math.abs((i + firstDayOfWeek) % 7);
	      var weekText = new graphic.Text({
	        z2: 30
	      });
	      zrUtil.extend(graphic.setTextStyle(weekText.style, dayLabel, {
	        text: nameMap[day]
	      }), this._weekTextPositionControl(point, orient, pos, margin, cellSize));
	      group.add(weekText);
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2333 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(841);
	
	__webpack_require__(840);

/***/ },
/* 2334 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var numberUtil = __webpack_require__(25);
	
	var helper = __webpack_require__(503);
	
	var sliderMove = __webpack_require__(249);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var asc = numberUtil.asc;
	/**
	 * Operate single axis.
	 * One axis can only operated by one axis operator.
	 * Different dataZoomModels may be defined to operate the same axis.
	 * (i.e. 'inside' data zoom and 'slider' data zoom components)
	 * So dataZoomModels share one axisProxy in that case.
	 *
	 * @class
	 */
	
	var AxisProxy = function (dimName, axisIndex, dataZoomModel, ecModel) {
	  /**
	   * @private
	   * @type {string}
	   */
	  this._dimName = dimName;
	  /**
	   * @private
	   */
	
	  this._axisIndex = axisIndex;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._valueWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._percentWindow;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._dataExtent;
	  /**
	   * {minSpan, maxSpan, minValueSpan, maxValueSpan}
	   * @private
	   * @type {Object}
	   */
	
	  this._minMaxSpan;
	  /**
	   * @readOnly
	   * @type {module: echarts/model/Global}
	   */
	
	  this.ecModel = ecModel;
	  /**
	   * @private
	   * @type {module: echarts/component/dataZoom/DataZoomModel}
	   */
	
	  this._dataZoomModel = dataZoomModel; // /**
	  //  * @readOnly
	  //  * @private
	  //  */
	  // this.hasSeriesStacked;
	};
	
	AxisProxy.prototype = {
	  constructor: AxisProxy,
	
	  /**
	   * Whether the axisProxy is hosted by dataZoomModel.
	   *
	   * @public
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   * @return {boolean}
	   */
	  hostedBy: function (dataZoomModel) {
	    return this._dataZoomModel === dataZoomModel;
	  },
	
	  /**
	   * @return {Array.<number>} Value can only be NaN or finite value.
	   */
	  getDataValueWindow: function () {
	    return this._valueWindow.slice();
	  },
	
	  /**
	   * @return {Array.<number>}
	   */
	  getDataPercentWindow: function () {
	    return this._percentWindow.slice();
	  },
	
	  /**
	   * @public
	   * @param {number} axisIndex
	   * @return {Array} seriesModels
	   */
	  getTargetSeriesModels: function () {
	    var seriesModels = [];
	    var ecModel = this.ecModel;
	    ecModel.eachSeries(function (seriesModel) {
	      if (helper.isCoordSupported(seriesModel.get('coordinateSystem'))) {
	        var dimName = this._dimName;
	        var axisModel = ecModel.queryComponents({
	          mainType: dimName + 'Axis',
	          index: seriesModel.get(dimName + 'AxisIndex'),
	          id: seriesModel.get(dimName + 'AxisId')
	        })[0];
	
	        if (this._axisIndex === (axisModel && axisModel.componentIndex)) {
	          seriesModels.push(seriesModel);
	        }
	      }
	    }, this);
	    return seriesModels;
	  },
	  getAxisModel: function () {
	    return this.ecModel.getComponent(this._dimName + 'Axis', this._axisIndex);
	  },
	  getOtherAxisModel: function () {
	    var axisDim = this._dimName;
	    var ecModel = this.ecModel;
	    var axisModel = this.getAxisModel();
	    var isCartesian = axisDim === 'x' || axisDim === 'y';
	    var otherAxisDim;
	    var coordSysIndexName;
	
	    if (isCartesian) {
	      coordSysIndexName = 'gridIndex';
	      otherAxisDim = axisDim === 'x' ? 'y' : 'x';
	    } else {
	      coordSysIndexName = 'polarIndex';
	      otherAxisDim = axisDim === 'angle' ? 'radius' : 'angle';
	    }
	
	    var foundOtherAxisModel;
	    ecModel.eachComponent(otherAxisDim + 'Axis', function (otherAxisModel) {
	      if ((otherAxisModel.get(coordSysIndexName) || 0) === (axisModel.get(coordSysIndexName) || 0)) {
	        foundOtherAxisModel = otherAxisModel;
	      }
	    });
	    return foundOtherAxisModel;
	  },
	  getMinMaxSpan: function () {
	    return zrUtil.clone(this._minMaxSpan);
	  },
	
	  /**
	   * Only calculate by given range and this._dataExtent, do not change anything.
	   *
	   * @param {Object} opt
	   * @param {number} [opt.start]
	   * @param {number} [opt.end]
	   * @param {number} [opt.startValue]
	   * @param {number} [opt.endValue]
	   */
	  calculateDataWindow: function (opt) {
	    var dataExtent = this._dataExtent;
	    var axisModel = this.getAxisModel();
	    var scale = axisModel.axis.scale;
	
	    var rangePropMode = this._dataZoomModel.getRangePropMode();
	
	    var percentExtent = [0, 100];
	    var percentWindow = [];
	    var valueWindow = [];
	    var hasPropModeValue;
	    each(['start', 'end'], function (prop, idx) {
	      var boundPercent = opt[prop];
	      var boundValue = opt[prop + 'Value']; // Notice: dataZoom is based either on `percentProp` ('start', 'end') or
	      // on `valueProp` ('startValue', 'endValue'). (They are based on the data extent
	      // but not min/max of axis, which will be calculated by data window then).
	      // The former one is suitable for cases that a dataZoom component controls multiple
	      // axes with different unit or extent, and the latter one is suitable for accurate
	      // zoom by pixel (e.g., in dataZoomSelect).
	      // we use `getRangePropMode()` to mark which prop is used. `rangePropMode` is updated
	      // only when setOption or dispatchAction, otherwise it remains its original value.
	      // (Why not only record `percentProp` and always map to `valueProp`? Because
	      // the map `valueProp` -> `percentProp` -> `valueProp` probably not the original
	      // `valueProp`. consider two axes constrolled by one dataZoom. They have different
	      // data extent. All of values that are overflow the `dataExtent` will be calculated
	      // to percent '100%').
	
	      if (rangePropMode[idx] === 'percent') {
	        boundPercent == null && (boundPercent = percentExtent[idx]); // Use scale.parse to math round for category or time axis.
	
	        boundValue = scale.parse(numberUtil.linearMap(boundPercent, percentExtent, dataExtent));
	      } else {
	        hasPropModeValue = true;
	        boundValue = boundValue == null ? dataExtent[idx] : scale.parse(boundValue); // Calculating `percent` from `value` may be not accurate, because
	        // This calculation can not be inversed, because all of values that
	        // are overflow the `dataExtent` will be calculated to percent '100%'
	
	        boundPercent = numberUtil.linearMap(boundValue, dataExtent, percentExtent);
	      } // valueWindow[idx] = round(boundValue);
	      // percentWindow[idx] = round(boundPercent);
	
	
	      valueWindow[idx] = boundValue;
	      percentWindow[idx] = boundPercent;
	    });
	    asc(valueWindow);
	    asc(percentWindow); // The windows from user calling of `dispatchAction` might be out of the extent,
	    // or do not obey the `min/maxSpan`, `min/maxValueSpan`. But we dont restrict window
	    // by `zoomLock` here, because we see `zoomLock` just as a interaction constraint,
	    // where API is able to initialize/modify the window size even though `zoomLock`
	    // specified.
	
	    var spans = this._minMaxSpan;
	    hasPropModeValue ? restrictSet(valueWindow, percentWindow, dataExtent, percentExtent, false) : restrictSet(percentWindow, valueWindow, percentExtent, dataExtent, true);
	
	    function restrictSet(fromWindow, toWindow, fromExtent, toExtent, toValue) {
	      var suffix = toValue ? 'Span' : 'ValueSpan';
	      sliderMove(0, fromWindow, fromExtent, 'all', spans['min' + suffix], spans['max' + suffix]);
	
	      for (var i = 0; i < 2; i++) {
	        toWindow[i] = numberUtil.linearMap(fromWindow[i], fromExtent, toExtent, true);
	        toValue && (toWindow[i] = scale.parse(toWindow[i]));
	      }
	    }
	
	    return {
	      valueWindow: valueWindow,
	      percentWindow: percentWindow
	    };
	  },
	
	  /**
	   * Notice: reset should not be called before series.restoreData() called,
	   * so it is recommanded to be called in "process stage" but not "model init
	   * stage".
	   *
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  reset: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    var targetSeries = this.getTargetSeriesModels(); // Culculate data window and data extent, and record them.
	
	    this._dataExtent = calculateDataExtent(this, this._dimName, targetSeries); // this.hasSeriesStacked = false;
	    // each(targetSeries, function (series) {
	    // var data = series.getData();
	    // var dataDim = data.mapDimension(this._dimName);
	    // var stackedDimension = data.getCalculationInfo('stackedDimension');
	    // if (stackedDimension && stackedDimension === dataDim) {
	    // this.hasSeriesStacked = true;
	    // }
	    // }, this);
	    // `calculateDataWindow` uses min/maxSpan.
	
	    setMinMaxSpan(this);
	    var dataWindow = this.calculateDataWindow(dataZoomModel.settledOption);
	    this._valueWindow = dataWindow.valueWindow;
	    this._percentWindow = dataWindow.percentWindow; // Update axis setting then.
	
	    setAxisModel(this);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  restore: function (dataZoomModel) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    this._valueWindow = this._percentWindow = null;
	    setAxisModel(this, true);
	  },
	
	  /**
	   * @param {module: echarts/component/dataZoom/DataZoomModel} dataZoomModel
	   */
	  filterData: function (dataZoomModel, api) {
	    if (dataZoomModel !== this._dataZoomModel) {
	      return;
	    }
	
	    var axisDim = this._dimName;
	    var seriesModels = this.getTargetSeriesModels();
	    var filterMode = dataZoomModel.get('filterMode');
	    var valueWindow = this._valueWindow;
	
	    if (filterMode === 'none') {
	      return;
	    } // FIXME
	    // Toolbox may has dataZoom injected. And if there are stacked bar chart
	    // with NaN data, NaN will be filtered and stack will be wrong.
	    // So we need to force the mode to be set empty.
	    // In fect, it is not a big deal that do not support filterMode-'filter'
	    // when using toolbox#dataZoom, utill tooltip#dataZoom support "single axis
	    // selection" some day, which might need "adapt to data extent on the
	    // otherAxis", which is disabled by filterMode-'empty'.
	    // But currently, stack has been fixed to based on value but not index,
	    // so this is not an issue any more.
	    // var otherAxisModel = this.getOtherAxisModel();
	    // if (dataZoomModel.get('$fromToolbox')
	    //     && otherAxisModel
	    //     && otherAxisModel.hasSeriesStacked
	    // ) {
	    //     filterMode = 'empty';
	    // }
	    // TODO
	    // filterMode 'weakFilter' and 'empty' is not optimized for huge data yet.
	
	
	    each(seriesModels, function (seriesModel) {
	      var seriesData = seriesModel.getData();
	      var dataDims = seriesData.mapDimension(axisDim, true);
	
	      if (!dataDims.length) {
	        return;
	      }
	
	      if (filterMode === 'weakFilter') {
	        seriesData.filterSelf(function (dataIndex) {
	          var leftOut;
	          var rightOut;
	          var hasValue;
	
	          for (var i = 0; i < dataDims.length; i++) {
	            var value = seriesData.get(dataDims[i], dataIndex);
	            var thisHasValue = !isNaN(value);
	            var thisLeftOut = value < valueWindow[0];
	            var thisRightOut = value > valueWindow[1];
	
	            if (thisHasValue && !thisLeftOut && !thisRightOut) {
	              return true;
	            }
	
	            thisHasValue && (hasValue = true);
	            thisLeftOut && (leftOut = true);
	            thisRightOut && (rightOut = true);
	          } // If both left out and right out, do not filter.
	
	
	          return hasValue && leftOut && rightOut;
	        });
	      } else {
	        each(dataDims, function (dim) {
	          if (filterMode === 'empty') {
	            seriesModel.setData(seriesData = seriesData.map(dim, function (value) {
	              return !isInWindow(value) ? NaN : value;
	            }));
	          } else {
	            var range = {};
	            range[dim] = valueWindow; // console.time('select');
	
	            seriesData.selectRange(range); // console.timeEnd('select');
	          }
	        });
	      }
	
	      each(dataDims, function (dim) {
	        seriesData.setApproximateExtent(valueWindow, dim);
	      });
	    });
	
	    function isInWindow(value) {
	      return value >= valueWindow[0] && value <= valueWindow[1];
	    }
	  }
	};
	
	function calculateDataExtent(axisProxy, axisDim, seriesModels) {
	  var dataExtent = [Infinity, -Infinity];
	  each(seriesModels, function (seriesModel) {
	    var seriesData = seriesModel.getData();
	
	    if (seriesData) {
	      each(seriesData.mapDimension(axisDim, true), function (dim) {
	        var seriesExtent = seriesData.getApproximateExtent(dim);
	        seriesExtent[0] < dataExtent[0] && (dataExtent[0] = seriesExtent[0]);
	        seriesExtent[1] > dataExtent[1] && (dataExtent[1] = seriesExtent[1]);
	      });
	    }
	  });
	
	  if (dataExtent[1] < dataExtent[0]) {
	    dataExtent = [NaN, NaN];
	  } // It is important to get "consistent" extent when more then one axes is
	  // controlled by a `dataZoom`, otherwise those axes will not be synchronized
	  // when zooming. But it is difficult to know what is "consistent", considering
	  // axes have different type or even different meanings (For example, two
	  // time axes are used to compare data of the same date in different years).
	  // So basically dataZoom just obtains extent by series.data (in category axis
	  // extent can be obtained from axis.data).
	  // Nevertheless, user can set min/max/scale on axes to make extent of axes
	  // consistent.
	
	
	  fixExtentByAxis(axisProxy, dataExtent);
	  return dataExtent;
	}
	
	function fixExtentByAxis(axisProxy, dataExtent) {
	  var axisModel = axisProxy.getAxisModel();
	  var min = axisModel.getMin(true); // For category axis, if min/max/scale are not set, extent is determined
	  // by axis.data by default.
	
	  var isCategoryAxis = axisModel.get('type') === 'category';
	  var axisDataLen = isCategoryAxis && axisModel.getCategories().length;
	
	  if (min != null && min !== 'dataMin' && typeof min !== 'function') {
	    dataExtent[0] = min;
	  } else if (isCategoryAxis) {
	    dataExtent[0] = axisDataLen > 0 ? 0 : NaN;
	  }
	
	  var max = axisModel.getMax(true);
	
	  if (max != null && max !== 'dataMax' && typeof max !== 'function') {
	    dataExtent[1] = max;
	  } else if (isCategoryAxis) {
	    dataExtent[1] = axisDataLen > 0 ? axisDataLen - 1 : NaN;
	  }
	
	  if (!axisModel.get('scale', true)) {
	    dataExtent[0] > 0 && (dataExtent[0] = 0);
	    dataExtent[1] < 0 && (dataExtent[1] = 0);
	  } // For value axis, if min/max/scale are not set, we just use the extent obtained
	  // by series data, which may be a little different from the extent calculated by
	  // `axisHelper.getScaleExtent`. But the different just affects the experience a
	  // little when zooming. So it will not be fixed until some users require it strongly.
	
	
	  return dataExtent;
	}
	
	function setAxisModel(axisProxy, isRestore) {
	  var axisModel = axisProxy.getAxisModel();
	  var percentWindow = axisProxy._percentWindow;
	  var valueWindow = axisProxy._valueWindow;
	
	  if (!percentWindow) {
	    return;
	  } // [0, 500]: arbitrary value, guess axis extent.
	
	
	  var precision = numberUtil.getPixelPrecision(valueWindow, [0, 500]);
	  precision = Math.min(precision, 20); // isRestore or isFull
	
	  var useOrigin = isRestore || percentWindow[0] === 0 && percentWindow[1] === 100;
	  axisModel.setRange(useOrigin ? null : +valueWindow[0].toFixed(precision), useOrigin ? null : +valueWindow[1].toFixed(precision));
	}
	
	function setMinMaxSpan(axisProxy) {
	  var minMaxSpan = axisProxy._minMaxSpan = {};
	  var dataZoomModel = axisProxy._dataZoomModel;
	  var dataExtent = axisProxy._dataExtent;
	  each(['min', 'max'], function (minMax) {
	    var percentSpan = dataZoomModel.get(minMax + 'Span');
	    var valueSpan = dataZoomModel.get(minMax + 'ValueSpan');
	    valueSpan != null && (valueSpan = axisProxy.getAxisModel().axis.scale.parse(valueSpan)); // minValueSpan and maxValueSpan has higher priority than minSpan and maxSpan
	
	    if (valueSpan != null) {
	      percentSpan = numberUtil.linearMap(dataExtent[0] + valueSpan, dataExtent, [0, 100], true);
	    } else if (percentSpan != null) {
	      valueSpan = numberUtil.linearMap(percentSpan, [0, 100], dataExtent, true) - dataExtent[0];
	    }
	
	    minMaxSpan[minMax + 'Span'] = percentSpan;
	    minMaxSpan[minMax + 'ValueSpan'] = valueSpan;
	  });
	}
	
	var _default = AxisProxy;
	module.exports = _default;

/***/ },
/* 2335 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(247);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    disabled: false,
	    // Whether disable this inside zoom.
	    zoomLock: false,
	    // Whether disable zoom but only pan.
	    zoomOnMouseWheel: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    moveOnMouseMove: true,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    moveOnMouseWheel: false,
	    // Can be: true / false / 'shift' / 'ctrl' / 'alt'.
	    preventDefaultMouseMove: true
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2336 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var DataZoomView = __webpack_require__(248);
	
	var sliderMove = __webpack_require__(249);
	
	var roams = __webpack_require__(2341);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var InsideZoomView = DataZoomView.extend({
	  type: 'dataZoom.inside',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * 'throttle' is used in this.dispatchAction, so we save range
	     * to avoid missing some 'pan' info.
	     * @private
	     * @type {Array.<number>}
	     */
	    this._range;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    InsideZoomView.superApply(this, 'render', arguments); // Hence the `throttle` util ensures to preserve command order,
	    // here simply updating range all the time will not cause missing
	    // any of the the roam change.
	
	    this._range = dataZoomModel.getPercentRange(); // Reset controllers.
	
	    zrUtil.each(this.getTargetCoordInfo(), function (coordInfoList, coordSysName) {
	      var allCoordIds = zrUtil.map(coordInfoList, function (coordInfo) {
	        return roams.generateCoordId(coordInfo.model);
	      });
	      zrUtil.each(coordInfoList, function (coordInfo) {
	        var coordModel = coordInfo.model;
	        var getRange = {};
	        zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
	          getRange[eventName] = bind(roamHandlers[eventName], this, coordInfo, coordSysName);
	        }, this);
	        roams.register(api, {
	          coordId: roams.generateCoordId(coordModel),
	          allCoordIds: allCoordIds,
	          containsPoint: function (e, x, y) {
	            return coordModel.coordinateSystem.containPoint([x, y]);
	          },
	          dataZoomId: dataZoomModel.id,
	          dataZoomModel: dataZoomModel,
	          getRange: getRange
	        });
	      }, this);
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    roams.unregister(this.api, this.dataZoomModel.id);
	    InsideZoomView.superApply(this, 'dispose', arguments);
	    this._range = null;
	  }
	});
	var roamHandlers = {
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  zoom: function (coordInfo, coordSysName, controller, e) {
	    var lastRange = this._range;
	    var range = lastRange.slice(); // Calculate transform by the first axis.
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var directionInfo = getDirectionInfo[coordSysName](null, [e.originX, e.originY], axisModel, controller, coordInfo);
	    var percentPoint = (directionInfo.signal > 0 ? directionInfo.pixelStart + directionInfo.pixelLength - directionInfo.pixel : directionInfo.pixel - directionInfo.pixelStart) / directionInfo.pixelLength * (range[1] - range[0]) + range[0];
	    var scale = Math.max(1 / e.scale, 0);
	    range[0] = (range[0] - percentPoint) * scale + percentPoint;
	    range[1] = (range[1] - percentPoint) * scale + percentPoint; // Restrict range.
	
	    var minMaxSpan = this.dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    sliderMove(0, range, [0, 100], 0, minMaxSpan.minSpan, minMaxSpan.maxSpan);
	    this._range = range;
	
	    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	      return range;
	    }
	  },
	
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  pan: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
	    var directionInfo = getDirectionInfo[coordSysName]([e.oldX, e.oldY], [e.newX, e.newY], axisModel, controller, coordInfo);
	    return directionInfo.signal * (range[1] - range[0]) * directionInfo.pixel / directionInfo.pixelLength;
	  }),
	
	  /**
	   * @this {module:echarts/component/dataZoom/InsideZoomView}
	   */
	  scrollMove: makeMover(function (range, axisModel, coordInfo, coordSysName, controller, e) {
	    var directionInfo = getDirectionInfo[coordSysName]([0, 0], [e.scrollDelta, e.scrollDelta], axisModel, controller, coordInfo);
	    return directionInfo.signal * (range[1] - range[0]) * e.scrollDelta;
	  })
	};
	
	function makeMover(getPercentDelta) {
	  return function (coordInfo, coordSysName, controller, e) {
	    var lastRange = this._range;
	    var range = lastRange.slice(); // Calculate transform by the first axis.
	
	    var axisModel = coordInfo.axisModels[0];
	
	    if (!axisModel) {
	      return;
	    }
	
	    var percentDelta = getPercentDelta(range, axisModel, coordInfo, coordSysName, controller, e);
	    sliderMove(percentDelta, range, [0, 100], 'all');
	    this._range = range;
	
	    if (lastRange[0] !== range[0] || lastRange[1] !== range[1]) {
	      return range;
	    }
	  };
	}
	
	var getDirectionInfo = {
	  grid: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.dim === 'x') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // axis.dim === 'y'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  polar: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var ret = {};
	    var polar = coordInfo.model.coordinateSystem;
	    var radiusExtent = polar.getRadiusAxis().getExtent();
	    var angleExtent = polar.getAngleAxis().getExtent();
	    oldPoint = oldPoint ? polar.pointToCoord(oldPoint) : [0, 0];
	    newPoint = polar.pointToCoord(newPoint);
	
	    if (axisModel.mainType === 'radiusAxis') {
	      ret.pixel = newPoint[0] - oldPoint[0]; // ret.pixelLength = Math.abs(radiusExtent[1] - radiusExtent[0]);
	      // ret.pixelStart = Math.min(radiusExtent[0], radiusExtent[1]);
	
	      ret.pixelLength = radiusExtent[1] - radiusExtent[0];
	      ret.pixelStart = radiusExtent[0];
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'angleAxis'
	      ret.pixel = newPoint[1] - oldPoint[1]; // ret.pixelLength = Math.abs(angleExtent[1] - angleExtent[0]);
	      // ret.pixelStart = Math.min(angleExtent[0], angleExtent[1]);
	
	      ret.pixelLength = angleExtent[1] - angleExtent[0];
	      ret.pixelStart = angleExtent[0];
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  },
	  singleAxis: function (oldPoint, newPoint, axisModel, controller, coordInfo) {
	    var axis = axisModel.axis;
	    var rect = coordInfo.model.coordinateSystem.getRect();
	    var ret = {};
	    oldPoint = oldPoint || [0, 0];
	
	    if (axis.orient === 'horizontal') {
	      ret.pixel = newPoint[0] - oldPoint[0];
	      ret.pixelLength = rect.width;
	      ret.pixelStart = rect.x;
	      ret.signal = axis.inverse ? 1 : -1;
	    } else {
	      // 'vertical'
	      ret.pixel = newPoint[1] - oldPoint[1];
	      ret.pixelLength = rect.height;
	      ret.pixelStart = rect.y;
	      ret.signal = axis.inverse ? -1 : 1;
	    }
	
	    return ret;
	  }
	};
	var _default = InsideZoomView;
	module.exports = _default;

/***/ },
/* 2337 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(247);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomModel.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ },
/* 2338 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomView = __webpack_require__(248);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = DataZoomView.extend({
	  type: 'dataZoom.select'
	});
	
	module.exports = _default;

/***/ },
/* 2339 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var DataZoomModel = __webpack_require__(247);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SliderZoomModel = DataZoomModel.extend({
	  type: 'dataZoom.slider',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    show: true,
	    // ph => placeholder. Using placehoder here because
	    // deault value can only be drived in view stage.
	    right: 'ph',
	    // Default align to grid rect.
	    top: 'ph',
	    // Default align to grid rect.
	    width: 'ph',
	    // Default align to grid rect.
	    height: 'ph',
	    // Default align to grid rect.
	    left: null,
	    // Default align to grid rect.
	    bottom: null,
	    // Default align to grid rect.
	    backgroundColor: 'rgba(47,69,84,0)',
	    // Background of slider zoom component.
	    // dataBackgroundColor: '#ddd',         // Background coor of data shadow and border of box,
	    // highest priority, remain for compatibility of
	    // previous version, but not recommended any more.
	    dataBackground: {
	      lineStyle: {
	        color: '#2f4554',
	        width: 0.5,
	        opacity: 0.3
	      },
	      areaStyle: {
	        color: 'rgba(47,69,84,0.3)',
	        opacity: 0.3
	      }
	    },
	    borderColor: '#ddd',
	    // border color of the box. For compatibility,
	    // if dataBackgroundColor is set, borderColor
	    // is ignored.
	    fillerColor: 'rgba(167,183,204,0.4)',
	    // Color of selected area.
	    // handleColor: 'rgba(89,170,216,0.95)',     // Color of handle.
	    // handleIcon: 'path://M4.9,17.8c0-1.4,4.5-10.5,5.5-12.4c0-0.1,0.6-1.1,0.9-1.1c0.4,0,0.9,1,0.9,1.1c1.1,2.2,5.4,11,5.4,12.4v17.8c0,1.5-0.6,2.1-1.3,2.1H6.1c-0.7,0-1.3-0.6-1.3-2.1V17.8z',
	
	    /* eslint-disable */
	    handleIcon: 'M8.2,13.6V3.9H6.3v9.7H3.1v14.9h3.3v9.7h1.8v-9.7h3.3V13.6H8.2z M9.7,24.4H4.8v-1.4h4.9V24.4z M9.7,19.1H4.8v-1.4h4.9V19.1z',
	
	    /* eslint-enable */
	    // Percent of the slider height
	    handleSize: '100%',
	    handleStyle: {
	      color: '#a7b7cc'
	    },
	    labelPrecision: null,
	    labelFormatter: null,
	    showDetail: true,
	    showDataShadow: 'auto',
	    // Default auto decision.
	    realtime: true,
	    zoomLock: false,
	    // Whether disable zoom.
	    textStyle: {
	      color: '#333'
	    }
	  }
	});
	var _default = SliderZoomModel;
	module.exports = _default;

/***/ },
/* 2340 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var eventTool = __webpack_require__(147);
	
	var graphic = __webpack_require__(14);
	
	var throttle = __webpack_require__(181);
	
	var DataZoomView = __webpack_require__(248);
	
	var numberUtil = __webpack_require__(25);
	
	var layout = __webpack_require__(46);
	
	var sliderMove = __webpack_require__(249);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var Rect = graphic.Rect;
	var linearMap = numberUtil.linearMap;
	var asc = numberUtil.asc;
	var bind = zrUtil.bind;
	var each = zrUtil.each; // Constants
	
	var DEFAULT_LOCATION_EDGE_GAP = 7;
	var DEFAULT_FRAME_BORDER_WIDTH = 1;
	var DEFAULT_FILLER_SIZE = 30;
	var HORIZONTAL = 'horizontal';
	var VERTICAL = 'vertical';
	var LABEL_GAP = 5;
	var SHOW_DATA_SHADOW_SERIES_TYPE = ['line', 'bar', 'candlestick', 'scatter'];
	var SliderZoomView = DataZoomView.extend({
	  type: 'dataZoom.slider',
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {Object}
	     */
	    this._displayables = {};
	    /**
	     * @private
	     * @type {string}
	     */
	
	    this._orient;
	    /**
	     * [0, 100]
	     * @private
	     */
	
	    this._range;
	    /**
	     * [coord of the first handle, coord of the second handle]
	     * @private
	     */
	
	    this._handleEnds;
	    /**
	     * [length, thick]
	     * @private
	     * @type {Array.<number>}
	     */
	
	    this._size;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleWidth;
	    /**
	     * @private
	     * @type {number}
	     */
	
	    this._handleHeight;
	    /**
	     * @private
	     */
	
	    this._location;
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._dataShadowInfo;
	    this.api = api;
	  },
	
	  /**
	   * @override
	   */
	  render: function (dataZoomModel, ecModel, api, payload) {
	    SliderZoomView.superApply(this, 'render', arguments);
	    throttle.createOrUpdate(this, '_dispatchZoomAction', this.dataZoomModel.get('throttle'), 'fixRate');
	    this._orient = dataZoomModel.get('orient');
	
	    if (this.dataZoomModel.get('show') === false) {
	      this.group.removeAll();
	      return;
	    } // Notice: this._resetInterval() should not be executed when payload.type
	    // is 'dataZoom', origin this._range should be maintained, otherwise 'pan'
	    // or 'zoom' info will be missed because of 'throttle' of this.dispatchAction,
	
	
	    if (!payload || payload.type !== 'dataZoom' || payload.from !== this.uid) {
	      this._buildView();
	    }
	
	    this._updateView();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    SliderZoomView.superApply(this, 'remove', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    SliderZoomView.superApply(this, 'dispose', arguments);
	    throttle.clear(this, '_dispatchZoomAction');
	  },
	  _buildView: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	
	    this._resetLocation();
	
	    this._resetInterval();
	
	    var barGroup = this._displayables.barGroup = new graphic.Group();
	
	    this._renderBackground();
	
	    this._renderHandle();
	
	    this._renderDataShadow();
	
	    thisGroup.add(barGroup);
	
	    this._positionGroup();
	  },
	
	  /**
	   * @private
	   */
	  _resetLocation: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var api = this.api; // If some of x/y/width/height are not specified,
	    // auto-adapt according to target grid.
	
	    var coordRect = this._findCoordRect();
	
	    var ecSize = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }; // Default align by coordinate system rect.
	
	    var positionInfo = this._orient === HORIZONTAL ? {
	      // Why using 'right', because right should be used in vertical,
	      // and it is better to be consistent for dealing with position param merge.
	      right: ecSize.width - coordRect.x - coordRect.width,
	      top: ecSize.height - DEFAULT_FILLER_SIZE - DEFAULT_LOCATION_EDGE_GAP,
	      width: coordRect.width,
	      height: DEFAULT_FILLER_SIZE
	    } : {
	      // vertical
	      right: DEFAULT_LOCATION_EDGE_GAP,
	      top: coordRect.y,
	      width: DEFAULT_FILLER_SIZE,
	      height: coordRect.height
	    }; // Do not write back to option and replace value 'ph', because
	    // the 'ph' value should be recalculated when resize.
	
	    var layoutParams = layout.getLayoutParams(dataZoomModel.option); // Replace the placeholder value.
	
	    zrUtil.each(['right', 'top', 'width', 'height'], function (name) {
	      if (layoutParams[name] === 'ph') {
	        layoutParams[name] = positionInfo[name];
	      }
	    });
	    var layoutRect = layout.getLayoutRect(layoutParams, ecSize, dataZoomModel.padding);
	    this._location = {
	      x: layoutRect.x,
	      y: layoutRect.y
	    };
	    this._size = [layoutRect.width, layoutRect.height];
	    this._orient === VERTICAL && this._size.reverse();
	  },
	
	  /**
	   * @private
	   */
	  _positionGroup: function () {
	    var thisGroup = this.group;
	    var location = this._location;
	    var orient = this._orient; // Just use the first axis to determine mapping.
	
	    var targetAxisModel = this.dataZoomModel.getFirstTargetAxisModel();
	    var inverse = targetAxisModel && targetAxisModel.get('inverse');
	    var barGroup = this._displayables.barGroup;
	    var otherAxisInverse = (this._dataShadowInfo || {}).otherAxisInverse; // Transform barGroup.
	
	    barGroup.attr(orient === HORIZONTAL && !inverse ? {
	      scale: otherAxisInverse ? [1, 1] : [1, -1]
	    } : orient === HORIZONTAL && inverse ? {
	      scale: otherAxisInverse ? [-1, 1] : [-1, -1]
	    } : orient === VERTICAL && !inverse ? {
	      scale: otherAxisInverse ? [1, -1] : [1, 1],
	      rotation: Math.PI / 2 // Dont use Math.PI, considering shadow direction.
	
	    } : {
	      scale: otherAxisInverse ? [-1, -1] : [-1, 1],
	      rotation: Math.PI / 2
	    }); // Position barGroup
	
	    var rect = thisGroup.getBoundingRect([barGroup]);
	    thisGroup.attr('position', [location.x - rect.x, location.y - rect.y]);
	  },
	
	  /**
	   * @private
	   */
	  _getViewExtent: function () {
	    return [0, this._size[0]];
	  },
	  _renderBackground: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var size = this._size;
	    var barGroup = this._displayables.barGroup;
	    barGroup.add(new Rect({
	      silent: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: dataZoomModel.get('backgroundColor')
	      },
	      z2: -40
	    })); // Click panel, over shadow, below handles.
	
	    barGroup.add(new Rect({
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        fill: 'transparent'
	      },
	      z2: 0,
	      onclick: zrUtil.bind(this._onClickPanelClick, this)
	    }));
	  },
	  _renderDataShadow: function () {
	    var info = this._dataShadowInfo = this._prepareDataShadowInfo();
	
	    if (!info) {
	      return;
	    }
	
	    var size = this._size;
	    var seriesModel = info.series;
	    var data = seriesModel.getRawData();
	    var otherDim = seriesModel.getShadowDim ? seriesModel.getShadowDim() // @see candlestick
	    : info.otherDim;
	
	    if (otherDim == null) {
	      return;
	    }
	
	    var otherDataExtent = data.getDataExtent(otherDim); // Nice extent.
	
	    var otherOffset = (otherDataExtent[1] - otherDataExtent[0]) * 0.3;
	    otherDataExtent = [otherDataExtent[0] - otherOffset, otherDataExtent[1] + otherOffset];
	    var otherShadowExtent = [0, size[1]];
	    var thisShadowExtent = [0, size[0]];
	    var areaPoints = [[size[0], 0], [0, 0]];
	    var linePoints = [];
	    var step = thisShadowExtent[1] / (data.count() - 1);
	    var thisCoord = 0; // Optimize for large data shadow
	
	    var stride = Math.round(data.count() / size[0]);
	    var lastIsEmpty;
	    data.each([otherDim], function (value, index) {
	      if (stride > 0 && index % stride) {
	        thisCoord += step;
	        return;
	      } // FIXME
	      // Should consider axis.min/axis.max when drawing dataShadow.
	      // FIXME
	      // 应该使用统一的空判断？还是在list里进行空判断？
	
	
	      var isEmpty = value == null || isNaN(value) || value === ''; // See #4235.
	
	      var otherCoord = isEmpty ? 0 : linearMap(value, otherDataExtent, otherShadowExtent, true); // Attempt to draw data shadow precisely when there are empty value.
	
	      if (isEmpty && !lastIsEmpty && index) {
	        areaPoints.push([areaPoints[areaPoints.length - 1][0], 0]);
	        linePoints.push([linePoints[linePoints.length - 1][0], 0]);
	      } else if (!isEmpty && lastIsEmpty) {
	        areaPoints.push([thisCoord, 0]);
	        linePoints.push([thisCoord, 0]);
	      }
	
	      areaPoints.push([thisCoord, otherCoord]);
	      linePoints.push([thisCoord, otherCoord]);
	      thisCoord += step;
	      lastIsEmpty = isEmpty;
	    });
	    var dataZoomModel = this.dataZoomModel; // var dataBackgroundModel = dataZoomModel.getModel('dataBackground');
	
	    this._displayables.barGroup.add(new graphic.Polygon({
	      shape: {
	        points: areaPoints
	      },
	      style: zrUtil.defaults({
	        fill: dataZoomModel.get('dataBackgroundColor')
	      }, dataZoomModel.getModel('dataBackground.areaStyle').getAreaStyle()),
	      silent: true,
	      z2: -20
	    }));
	
	    this._displayables.barGroup.add(new graphic.Polyline({
	      shape: {
	        points: linePoints
	      },
	      style: dataZoomModel.getModel('dataBackground.lineStyle').getLineStyle(),
	      silent: true,
	      z2: -19
	    }));
	  },
	  _prepareDataShadowInfo: function () {
	    var dataZoomModel = this.dataZoomModel;
	    var showDataShadow = dataZoomModel.get('showDataShadow');
	
	    if (showDataShadow === false) {
	      return;
	    } // Find a representative series.
	
	
	    var result;
	    var ecModel = this.ecModel;
	    dataZoomModel.eachTargetAxis(function (dimNames, axisIndex) {
	      var seriesModels = dataZoomModel.getAxisProxy(dimNames.name, axisIndex).getTargetSeriesModels();
	      zrUtil.each(seriesModels, function (seriesModel) {
	        if (result) {
	          return;
	        }
	
	        if (showDataShadow !== true && zrUtil.indexOf(SHOW_DATA_SHADOW_SERIES_TYPE, seriesModel.get('type')) < 0) {
	          return;
	        }
	
	        var thisAxis = ecModel.getComponent(dimNames.axis, axisIndex).axis;
	        var otherDim = getOtherDim(dimNames.name);
	        var otherAxisInverse;
	        var coordSys = seriesModel.coordinateSystem;
	
	        if (otherDim != null && coordSys.getOtherAxis) {
	          otherAxisInverse = coordSys.getOtherAxis(thisAxis).inverse;
	        }
	
	        otherDim = seriesModel.getData().mapDimension(otherDim);
	        result = {
	          thisAxis: thisAxis,
	          series: seriesModel,
	          thisDim: dimNames.name,
	          otherDim: otherDim,
	          otherAxisInverse: otherAxisInverse
	        };
	      }, this);
	    }, this);
	    return result;
	  },
	  _renderHandle: function () {
	    var displaybles = this._displayables;
	    var handles = displaybles.handles = [];
	    var handleLabels = displaybles.handleLabels = [];
	    var barGroup = this._displayables.barGroup;
	    var size = this._size;
	    var dataZoomModel = this.dataZoomModel;
	    barGroup.add(displaybles.filler = new Rect({
	      draggable: true,
	      cursor: getCursor(this._orient),
	      drift: bind(this._onDragMove, this, 'all'),
	      ondragstart: bind(this._showDataInfo, this, true),
	      ondragend: bind(this._onDragEnd, this),
	      onmouseover: bind(this._showDataInfo, this, true),
	      onmouseout: bind(this._showDataInfo, this, false),
	      style: {
	        fill: dataZoomModel.get('fillerColor'),
	        textPosition: 'inside'
	      }
	    })); // Frame border.
	
	    barGroup.add(new Rect({
	      silent: true,
	      subPixelOptimize: true,
	      shape: {
	        x: 0,
	        y: 0,
	        width: size[0],
	        height: size[1]
	      },
	      style: {
	        stroke: dataZoomModel.get('dataBackgroundColor') || dataZoomModel.get('borderColor'),
	        lineWidth: DEFAULT_FRAME_BORDER_WIDTH,
	        fill: 'rgba(0,0,0,0)'
	      }
	    }));
	    each([0, 1], function (handleIndex) {
	      var path = graphic.createIcon(dataZoomModel.get('handleIcon'), {
	        cursor: getCursor(this._orient),
	        draggable: true,
	        drift: bind(this._onDragMove, this, handleIndex),
	        ondragend: bind(this._onDragEnd, this),
	        onmouseover: bind(this._showDataInfo, this, true),
	        onmouseout: bind(this._showDataInfo, this, false)
	      }, {
	        x: -1,
	        y: 0,
	        width: 2,
	        height: 2
	      });
	      var bRect = path.getBoundingRect();
	      this._handleHeight = numberUtil.parsePercent(dataZoomModel.get('handleSize'), this._size[1]);
	      this._handleWidth = bRect.width / bRect.height * this._handleHeight;
	      path.setStyle(dataZoomModel.getModel('handleStyle').getItemStyle());
	      var handleColor = dataZoomModel.get('handleColor'); // Compatitable with previous version
	
	      if (handleColor != null) {
	        path.style.fill = handleColor;
	      }
	
	      barGroup.add(handles[handleIndex] = path);
	      var textStyleModel = dataZoomModel.textStyleModel;
	      this.group.add(handleLabels[handleIndex] = new graphic.Text({
	        silent: true,
	        invisible: true,
	        style: {
	          x: 0,
	          y: 0,
	          text: '',
	          textVerticalAlign: 'middle',
	          textAlign: 'center',
	          textFill: textStyleModel.getTextColor(),
	          textFont: textStyleModel.getFont()
	        },
	        z2: 10
	      }));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var range = this._range = this.dataZoomModel.getPercentRange();
	
	    var viewExtent = this._getViewExtent();
	
	    this._handleEnds = [linearMap(range[0], [0, 100], viewExtent, true), linearMap(range[1], [0, 100], viewExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} delta
	   * @return {boolean} changed
	   */
	  _updateInterval: function (handleIndex, delta) {
	    var dataZoomModel = this.dataZoomModel;
	    var handleEnds = this._handleEnds;
	
	    var viewExtend = this._getViewExtent();
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy().getMinMaxSpan();
	    var percentExtent = [0, 100];
	    sliderMove(delta, handleEnds, viewExtend, dataZoomModel.get('zoomLock') ? 'all' : handleIndex, minMaxSpan.minSpan != null ? linearMap(minMaxSpan.minSpan, percentExtent, viewExtend, true) : null, minMaxSpan.maxSpan != null ? linearMap(minMaxSpan.maxSpan, percentExtent, viewExtend, true) : null);
	    var lastRange = this._range;
	    var range = this._range = asc([linearMap(handleEnds[0], viewExtend, percentExtent, true), linearMap(handleEnds[1], viewExtend, percentExtent, true)]);
	    return !lastRange || lastRange[0] !== range[0] || lastRange[1] !== range[1];
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (nonRealtime) {
	    var displaybles = this._displayables;
	    var handleEnds = this._handleEnds;
	    var handleInterval = asc(handleEnds.slice());
	    var size = this._size;
	    each([0, 1], function (handleIndex) {
	      // Handles
	      var handle = displaybles.handles[handleIndex];
	      var handleHeight = this._handleHeight;
	      handle.attr({
	        scale: [handleHeight / 2, handleHeight / 2],
	        position: [handleEnds[handleIndex], size[1] / 2 - handleHeight / 2]
	      });
	    }, this); // Filler
	
	    displaybles.filler.setShape({
	      x: handleInterval[0],
	      y: 0,
	      width: handleInterval[1] - handleInterval[0],
	      height: size[1]
	    });
	
	    this._updateDataInfo(nonRealtime);
	  },
	
	  /**
	   * @private
	   */
	  _updateDataInfo: function (nonRealtime) {
	    var dataZoomModel = this.dataZoomModel;
	    var displaybles = this._displayables;
	    var handleLabels = displaybles.handleLabels;
	    var orient = this._orient;
	    var labelTexts = ['', '']; // FIXME
	    // date型，支持formatter，autoformatter（ec2 date.getAutoFormatter）
	
	    if (dataZoomModel.get('showDetail')) {
	      var axisProxy = dataZoomModel.findRepresentativeAxisProxy();
	
	      if (axisProxy) {
	        var axis = axisProxy.getAxisModel().axis;
	        var range = this._range;
	        var dataInterval = nonRealtime // See #4434, data and axis are not processed and reset yet in non-realtime mode.
	        ? axisProxy.calculateDataWindow({
	          start: range[0],
	          end: range[1]
	        }).valueWindow : axisProxy.getDataValueWindow();
	        labelTexts = [this._formatLabel(dataInterval[0], axis), this._formatLabel(dataInterval[1], axis)];
	      }
	    }
	
	    var orderedHandleEnds = asc(this._handleEnds.slice());
	    setLabel.call(this, 0);
	    setLabel.call(this, 1);
	
	    function setLabel(handleIndex) {
	      // Label
	      // Text should not transform by barGroup.
	      // Ignore handlers transform
	      var barTransform = graphic.getTransform(displaybles.handles[handleIndex].parent, this.group);
	      var direction = graphic.transformDirection(handleIndex === 0 ? 'right' : 'left', barTransform);
	      var offset = this._handleWidth / 2 + LABEL_GAP;
	      var textPoint = graphic.applyTransform([orderedHandleEnds[handleIndex] + (handleIndex === 0 ? -offset : offset), this._size[1] / 2], barTransform);
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        textVerticalAlign: orient === HORIZONTAL ? 'middle' : direction,
	        textAlign: orient === HORIZONTAL ? direction : 'center',
	        text: labelTexts[handleIndex]
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _formatLabel: function (value, axis) {
	    var dataZoomModel = this.dataZoomModel;
	    var labelFormatter = dataZoomModel.get('labelFormatter');
	    var labelPrecision = dataZoomModel.get('labelPrecision');
	
	    if (labelPrecision == null || labelPrecision === 'auto') {
	      labelPrecision = axis.getPixelPrecision();
	    }
	
	    var valueStr = value == null || isNaN(value) ? '' // FIXME Glue code
	    : axis.type === 'category' || axis.type === 'time' ? axis.scale.getLabel(Math.round(value)) // param of toFixed should less then 20.
	    : value.toFixed(Math.min(labelPrecision, 20));
	    return zrUtil.isFunction(labelFormatter) ? labelFormatter(value, valueStr) : zrUtil.isString(labelFormatter) ? labelFormatter.replace('{value}', valueStr) : valueStr;
	  },
	
	  /**
	   * @private
	   * @param {boolean} showOrHide true: show, false: hide
	   */
	  _showDataInfo: function (showOrHide) {
	    // Always show when drgging.
	    showOrHide = this._dragging || showOrHide;
	    var handleLabels = this._displayables.handleLabels;
	    handleLabels[0].attr('invisible', !showOrHide);
	    handleLabels[1].attr('invisible', !showOrHide);
	  },
	  _onDragMove: function (handleIndex, dx, dy, event) {
	    this._dragging = true; // For mobile device, prevent screen slider on the button.
	
	    eventTool.stop(event.event); // Transform dx, dy to bar coordination.
	
	    var barTransform = this._displayables.barGroup.getLocalTransform();
	
	    var vertex = graphic.applyTransform([dx, dy], barTransform, true);
	
	    var changed = this._updateInterval(handleIndex, vertex[0]);
	
	    var realtime = this.dataZoomModel.get('realtime');
	
	    this._updateView(!realtime); // Avoid dispatch dataZoom repeatly but range not changed,
	    // which cause bad visual effect when progressive enabled.
	
	
	    changed && realtime && this._dispatchZoomAction();
	  },
	  _onDragEnd: function () {
	    this._dragging = false;
	
	    this._showDataInfo(false); // While in realtime mode and stream mode, dispatch action when
	    // drag end will cause the whole view rerender, which is unnecessary.
	
	
	    var realtime = this.dataZoomModel.get('realtime');
	    !realtime && this._dispatchZoomAction();
	  },
	  _onClickPanelClick: function (e) {
	    var size = this._size;
	
	    var localPoint = this._displayables.barGroup.transformCoordToLocal(e.offsetX, e.offsetY);
	
	    if (localPoint[0] < 0 || localPoint[0] > size[0] || localPoint[1] < 0 || localPoint[1] > size[1]) {
	      return;
	    }
	
	    var handleEnds = this._handleEnds;
	    var center = (handleEnds[0] + handleEnds[1]) / 2;
	
	    var changed = this._updateInterval('all', localPoint[0] - center);
	
	    this._updateView();
	
	    changed && this._dispatchZoomAction();
	  },
	
	  /**
	   * This action will be throttled.
	   * @private
	   */
	  _dispatchZoomAction: function () {
	    var range = this._range;
	    this.api.dispatchAction({
	      type: 'dataZoom',
	      from: this.uid,
	      dataZoomId: this.dataZoomModel.id,
	      start: range[0],
	      end: range[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _findCoordRect: function () {
	    // Find the grid coresponding to the first axis referred by dataZoom.
	    var rect;
	    each(this.getTargetCoordInfo(), function (coordInfoList) {
	      if (!rect && coordInfoList.length) {
	        var coordSys = coordInfoList[0].model.coordinateSystem;
	        rect = coordSys.getRect && coordSys.getRect();
	      }
	    });
	
	    if (!rect) {
	      var width = this.api.getWidth();
	      var height = this.api.getHeight();
	      rect = {
	        x: width * 0.2,
	        y: height * 0.2,
	        width: width * 0.6,
	        height: height * 0.6
	      };
	    }
	
	    return rect;
	  }
	});
	
	function getOtherDim(thisDim) {
	  // FIXME
	  // 这个逻辑和getOtherAxis里一致，但是写在这里是否不好
	  var map = {
	    x: 'y',
	    y: 'x',
	    radius: 'angle',
	    angle: 'radius'
	  };
	  return map[thisDim];
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = SliderZoomView;
	module.exports = _default;

/***/ },
/* 2341 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var RoamController = __webpack_require__(291);
	
	var throttleUtil = __webpack_require__(181);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Only create one roam controller for each coordinate system.
	// one roam controller might be refered by two inside data zoom
	// components (for example, one for x and one for y). When user
	// pan or zoom, only dispatch one action for those data zoom
	// components.
	var ATTR = '\0_ec_dataZoom_roams';
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} dataZoomInfo
	 * @param {string} dataZoomInfo.coordId
	 * @param {Function} dataZoomInfo.containsPoint
	 * @param {Array.<string>} dataZoomInfo.allCoordIds
	 * @param {string} dataZoomInfo.dataZoomId
	 * @param {Object} dataZoomInfo.getRange
	 * @param {Function} dataZoomInfo.getRange.pan
	 * @param {Function} dataZoomInfo.getRange.zoom
	 * @param {Function} dataZoomInfo.getRange.scrollMove
	 * @param {boolean} dataZoomInfo.dataZoomModel
	 */
	
	function register(api, dataZoomInfo) {
	  var store = giveStore(api);
	  var theDataZoomId = dataZoomInfo.dataZoomId;
	  var theCoordId = dataZoomInfo.coordId; // Do clean when a dataZoom changes its target coordnate system.
	  // Avoid memory leak, dispose all not-used-registered.
	
	  zrUtil.each(store, function (record, coordId) {
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[theDataZoomId] && zrUtil.indexOf(dataZoomInfo.allCoordIds, theCoordId) < 0) {
	      delete dataZoomInfos[theDataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	  var record = store[theCoordId]; // Create if needed.
	
	  if (!record) {
	    record = store[theCoordId] = {
	      coordId: theCoordId,
	      dataZoomInfos: {},
	      count: 0
	    };
	    record.controller = createController(api, record);
	    record.dispatchAction = zrUtil.curry(dispatchAction, api);
	  } // Update reference of dataZoom.
	
	
	  !record.dataZoomInfos[theDataZoomId] && record.count++;
	  record.dataZoomInfos[theDataZoomId] = dataZoomInfo;
	  var controllerParams = mergeControllerParams(record.dataZoomInfos);
	  record.controller.enable(controllerParams.controlType, controllerParams.opt); // Consider resize, area should be always updated.
	
	  record.controller.setPointerChecker(dataZoomInfo.containsPoint); // Update throttle.
	
	  throttleUtil.createOrUpdate(record, 'dispatchAction', dataZoomInfo.dataZoomModel.get('throttle', true), 'fixRate');
	}
	/**
	 * @public
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {string} dataZoomId
	 */
	
	
	function unregister(api, dataZoomId) {
	  var store = giveStore(api);
	  zrUtil.each(store, function (record) {
	    record.controller.dispose();
	    var dataZoomInfos = record.dataZoomInfos;
	
	    if (dataZoomInfos[dataZoomId]) {
	      delete dataZoomInfos[dataZoomId];
	      record.count--;
	    }
	  });
	  cleanStore(store);
	}
	/**
	 * @public
	 */
	
	
	function generateCoordId(coordModel) {
	  return coordModel.type + '\0_' + coordModel.id;
	}
	/**
	 * Key: coordId, value: {dataZoomInfos: [], count, controller}
	 * @type {Array.<Object>}
	 */
	
	
	function giveStore(api) {
	  // Mount store on zrender instance, so that we do not
	  // need to worry about dispose.
	  var zr = api.getZr();
	  return zr[ATTR] || (zr[ATTR] = {});
	}
	
	function createController(api, newRecord) {
	  var controller = new RoamController(api.getZr());
	  zrUtil.each(['pan', 'zoom', 'scrollMove'], function (eventName) {
	    controller.on(eventName, function (event) {
	      var batch = [];
	      zrUtil.each(newRecord.dataZoomInfos, function (info) {
	        // Check whether the behaviors (zoomOnMouseWheel, moveOnMouseMove,
	        // moveOnMouseWheel, ...) enabled.
	        if (!event.isAvailableBehavior(info.dataZoomModel.option)) {
	          return;
	        }
	
	        var method = (info.getRange || {})[eventName];
	        var range = method && method(newRecord.controller, event);
	        !info.dataZoomModel.get('disabled', true) && range && batch.push({
	          dataZoomId: info.dataZoomId,
	          start: range[0],
	          end: range[1]
	        });
	      });
	      batch.length && newRecord.dispatchAction(batch);
	    });
	  });
	  return controller;
	}
	
	function cleanStore(store) {
	  zrUtil.each(store, function (record, coordId) {
	    if (!record.count) {
	      record.controller.dispose();
	      delete store[coordId];
	    }
	  });
	}
	/**
	 * This action will be throttled.
	 */
	
	
	function dispatchAction(api, batch) {
	  api.dispatchAction({
	    type: 'dataZoom',
	    batch: batch
	  });
	}
	/**
	 * Merge roamController settings when multiple dataZooms share one roamController.
	 */
	
	
	function mergeControllerParams(dataZoomInfos) {
	  var controlType; // DO NOT use reserved word (true, false, undefined) as key literally. Even if encapsulated
	  // as string, it is probably revert to reserved word by compress tool. See #7411.
	
	  var prefix = 'type_';
	  var typePriority = {
	    'type_true': 2,
	    'type_move': 1,
	    'type_false': 0,
	    'type_undefined': -1
	  };
	  var preventDefaultMouseMove = true;
	  zrUtil.each(dataZoomInfos, function (dataZoomInfo) {
	    var dataZoomModel = dataZoomInfo.dataZoomModel;
	    var oneType = dataZoomModel.get('disabled', true) ? false : dataZoomModel.get('zoomLock', true) ? 'move' : true;
	
	    if (typePriority[prefix + oneType] > typePriority[prefix + controlType]) {
	      controlType = oneType;
	    } // Prevent default move event by default. If one false, do not prevent. Otherwise
	    // users may be confused why it does not work when multiple insideZooms exist.
	
	
	    preventDefaultMouseMove &= dataZoomModel.get('preventDefaultMouseMove', true);
	  });
	  return {
	    controlType: controlType,
	    opt: {
	      // RoamController will enable all of these functionalities,
	      // and the final behavior is determined by its event listener
	      // provided by each inside zoom.
	      zoomOnMouseWheel: true,
	      moveOnMouseMove: true,
	      moveOnMouseWheel: true,
	      preventDefaultMouseMove: !!preventDefaultMouseMove
	    }
	  };
	}
	
	exports.register = register;
	exports.unregister = unregister;
	exports.generateCoordId = generateCoordId;

/***/ },
/* 2342 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(504);
	
	__webpack_require__(247);
	
	__webpack_require__(248);
	
	__webpack_require__(2337);
	
	__webpack_require__(2338);
	
	__webpack_require__(502);
	
	__webpack_require__(501);

/***/ },
/* 2343 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	__webpack_require__(2406);
	
	__webpack_require__(513);
	
	__webpack_require__(2344);
	
	__webpack_require__(820);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function makeAction(method, actionInfo) {
	  actionInfo.update = 'updateView';
	  echarts.registerAction(actionInfo, function (payload, ecModel) {
	    var selected = {};
	    ecModel.eachComponent({
	      mainType: 'geo',
	      query: payload
	    }, function (geoModel) {
	      geoModel[method](payload.name);
	      var geo = geoModel.coordinateSystem;
	      zrUtil.each(geo.regions, function (region) {
	        selected[region.name] = geoModel.isSelected(region.name) || false;
	      });
	    });
	    return {
	      selected: selected,
	      name: payload.name
	    };
	  });
	}
	
	makeAction('toggleSelected', {
	  type: 'geoToggleSelect',
	  event: 'geoselectchanged'
	});
	makeAction('select', {
	  type: 'geoSelect',
	  event: 'geoselected'
	});
	makeAction('unSelect', {
	  type: 'geoUnSelect',
	  event: 'geounselected'
	});

/***/ },
/* 2344 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MapDraw = __webpack_require__(844);
	
	var echarts = __webpack_require__(10);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'geo',
	  init: function (ecModel, api) {
	    var mapDraw = new MapDraw(api, true);
	    this._mapDraw = mapDraw;
	    this.group.add(mapDraw.group);
	  },
	  render: function (geoModel, ecModel, api, payload) {
	    // Not render if it is an toggleSelect action from self
	    if (payload && payload.type === 'geoToggleSelect' && payload.from === this.uid) {
	      return;
	    }
	
	    var mapDraw = this._mapDraw;
	
	    if (geoModel.get('show')) {
	      mapDraw.draw(geoModel, ecModel, api, this, payload);
	    } else {
	      this._mapDraw.group.removeAll();
	    }
	
	    this.group.silent = geoModel.get('silent');
	  },
	  dispose: function () {
	    this._mapDraw && this._mapDraw.remove();
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2345 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var modelUtil = __webpack_require__(29);
	
	var graphicUtil = __webpack_require__(14);
	
	var layoutUtil = __webpack_require__(46);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _nonShapeGraphicElements = {
	  // Reserved but not supported in graphic component.
	  path: null,
	  compoundPath: null,
	  // Supported in graphic component.
	  group: graphicUtil.Group,
	  image: graphicUtil.Image,
	  text: graphicUtil.Text
	}; // -------------
	// Preprocessor
	// -------------
	
	echarts.registerPreprocessor(function (option) {
	  var graphicOption = option.graphic; // Convert
	  // {graphic: [{left: 10, type: 'circle'}, ...]}
	  // or
	  // {graphic: {left: 10, type: 'circle'}}
	  // to
	  // {graphic: [{elements: [{left: 10, type: 'circle'}, ...]}]}
	
	  if (zrUtil.isArray(graphicOption)) {
	    if (!graphicOption[0] || !graphicOption[0].elements) {
	      option.graphic = [{
	        elements: graphicOption
	      }];
	    } else {
	      // Only one graphic instance can be instantiated. (We dont
	      // want that too many views are created in echarts._viewMap)
	      option.graphic = [option.graphic[0]];
	    }
	  } else if (graphicOption && !graphicOption.elements) {
	    option.graphic = [{
	      elements: [graphicOption]
	    }];
	  }
	}); // ------
	// Model
	// ------
	
	var GraphicModel = echarts.extendComponentModel({
	  type: 'graphic',
	  defaultOption: {
	    // Extra properties for each elements:
	    //
	    // left/right/top/bottom: (like 12, '22%', 'center', default undefined)
	    //      If left/rigth is set, shape.x/shape.cx/position will not be used.
	    //      If top/bottom is set, shape.y/shape.cy/position will not be used.
	    //      This mechanism is useful when you want to position a group/element
	    //      against the right side or the center of this container.
	    //
	    // width/height: (can only be pixel value, default 0)
	    //      Only be used to specify contianer(group) size, if needed. And
	    //      can not be percentage value (like '33%'). See the reason in the
	    //      layout algorithm below.
	    //
	    // bounding: (enum: 'all' (default) | 'raw')
	    //      Specify how to calculate boundingRect when locating.
	    //      'all': Get uioned and transformed boundingRect
	    //          from both itself and its descendants.
	    //          This mode simplies confining a group of elements in the bounding
	    //          of their ancester container (e.g., using 'right: 0').
	    //      'raw': Only use the boundingRect of itself and before transformed.
	    //          This mode is similar to css behavior, which is useful when you
	    //          want an element to be able to overflow its container. (Consider
	    //          a rotated circle needs to be located in a corner.)
	    // info: custom info. enables user to mount some info on elements and use them
	    //      in event handlers. Update them only when user specified, otherwise, remain.
	    // Note: elements is always behind its ancestors in this elements array.
	    elements: [],
	    parentId: null
	  },
	
	  /**
	   * Save el options for the sake of the performance (only update modified graphics).
	   * The order is the same as those in option. (ancesters -> descendants)
	   *
	   * @private
	   * @type {Array.<Object>}
	   */
	  _elOptionsToUpdate: null,
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    // Prevent default merge to elements
	    var elements = this.option.elements;
	    this.option.elements = null;
	    GraphicModel.superApply(this, 'mergeOption', arguments);
	    this.option.elements = elements;
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    var thisOption = this.option;
	    var newList = (isInit ? thisOption : newOption).elements;
	    var existList = thisOption.elements = isInit ? [] : thisOption.elements;
	    var flattenedList = [];
	
	    this._flatten(newList, flattenedList);
	
	    var mappingResult = modelUtil.mappingToExists(existList, flattenedList);
	    modelUtil.makeIdAndName(mappingResult); // Clear elOptionsToUpdate
	
	    var elOptionsToUpdate = this._elOptionsToUpdate = [];
	    zrUtil.each(mappingResult, function (resultItem, index) {
	      var newElOption = resultItem.option;
	
	      if (!newElOption) {
	        return;
	      }
	
	      elOptionsToUpdate.push(newElOption);
	      setKeyInfoToNewElOption(resultItem, newElOption);
	      mergeNewElOptionToExist(existList, index, newElOption);
	      setLayoutInfoToExist(existList[index], newElOption);
	    }, this); // Clean
	
	    for (var i = existList.length - 1; i >= 0; i--) {
	      if (existList[i] == null) {
	        existList.splice(i, 1);
	      } else {
	        // $action should be volatile, otherwise option gotten from
	        // `getOption` will contain unexpected $action.
	        delete existList[i].$action;
	      }
	    }
	  },
	
	  /**
	   * Convert
	   * [{
	   *  type: 'group',
	   *  id: 'xx',
	   *  children: [{type: 'circle'}, {type: 'polygon'}]
	   * }]
	   * to
	   * [
	   *  {type: 'group', id: 'xx'},
	   *  {type: 'circle', parentId: 'xx'},
	   *  {type: 'polygon', parentId: 'xx'}
	   * ]
	   *
	   * @private
	   * @param {Array.<Object>} optionList option list
	   * @param {Array.<Object>} result result of flatten
	   * @param {Object} parentOption parent option
	   */
	  _flatten: function (optionList, result, parentOption) {
	    zrUtil.each(optionList, function (option) {
	      if (!option) {
	        return;
	      }
	
	      if (parentOption) {
	        option.parentOption = parentOption;
	      }
	
	      result.push(option);
	      var children = option.children;
	
	      if (option.type === 'group' && children) {
	        this._flatten(children, result, option);
	      } // Deleting for JSON output, and for not affecting group creation.
	
	
	      delete option.children;
	    }, this);
	  },
	  // FIXME
	  // Pass to view using payload? setOption has a payload?
	  useElOptionsToUpdate: function () {
	    var els = this._elOptionsToUpdate; // Clear to avoid render duplicately when zooming.
	
	    this._elOptionsToUpdate = null;
	    return els;
	  }
	}); // -----
	// View
	// -----
	
	echarts.extendComponentView({
	  type: 'graphic',
	
	  /**
	   * @override
	   */
	  init: function (ecModel, api) {
	    /**
	     * @private
	     * @type {module:zrender/core/util.HashMap}
	     */
	    this._elMap = zrUtil.createHashMap();
	    /**
	     * @private
	     * @type {module:echarts/graphic/GraphicModel}
	     */
	
	    this._lastGraphicModel;
	  },
	
	  /**
	   * @override
	   */
	  render: function (graphicModel, ecModel, api) {
	    // Having leveraged between use cases and algorithm complexity, a very
	    // simple layout mechanism is used:
	    // The size(width/height) can be determined by itself or its parent (not
	    // implemented yet), but can not by its children. (Top-down travel)
	    // The location(x/y) can be determined by the bounding rect of itself
	    // (can including its descendants or not) and the size of its parent.
	    // (Bottom-up travel)
	    // When `chart.clear()` or `chart.setOption({...}, true)` with the same id,
	    // view will be reused.
	    if (graphicModel !== this._lastGraphicModel) {
	      this._clear();
	    }
	
	    this._lastGraphicModel = graphicModel;
	
	    this._updateElements(graphicModel);
	
	    this._relocate(graphicModel, api);
	  },
	
	  /**
	   * Update graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   */
	  _updateElements: function (graphicModel) {
	    var elOptionsToUpdate = graphicModel.useElOptionsToUpdate();
	
	    if (!elOptionsToUpdate) {
	      return;
	    }
	
	    var elMap = this._elMap;
	    var rootGroup = this.group; // Top-down tranverse to assign graphic settings to each elements.
	
	    zrUtil.each(elOptionsToUpdate, function (elOption) {
	      var $action = elOption.$action;
	      var id = elOption.id;
	      var existEl = elMap.get(id);
	      var parentId = elOption.parentId;
	      var targetElParent = parentId != null ? elMap.get(parentId) : rootGroup;
	      var elOptionStyle = elOption.style;
	
	      if (elOption.type === 'text' && elOptionStyle) {
	        // In top/bottom mode, textVerticalAlign should not be used, which cause
	        // inaccurately locating.
	        if (elOption.hv && elOption.hv[1]) {
	          elOptionStyle.textVerticalAlign = elOptionStyle.textBaseline = null;
	        } // Compatible with previous setting: both support fill and textFill,
	        // stroke and textStroke.
	
	
	        !elOptionStyle.hasOwnProperty('textFill') && elOptionStyle.fill && (elOptionStyle.textFill = elOptionStyle.fill);
	        !elOptionStyle.hasOwnProperty('textStroke') && elOptionStyle.stroke && (elOptionStyle.textStroke = elOptionStyle.stroke);
	      } // Remove unnecessary props to avoid potential problems.
	
	
	      var elOptionCleaned = getCleanedElOption(elOption); // For simple, do not support parent change, otherwise reorder is needed.
	
	      if (!$action || $action === 'merge') {
	        existEl ? existEl.attr(elOptionCleaned) : createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'replace') {
	        removeEl(existEl, elMap);
	        createEl(id, targetElParent, elOptionCleaned, elMap);
	      } else if ($action === 'remove') {
	        removeEl(existEl, elMap);
	      }
	
	      var el = elMap.get(id);
	
	      if (el) {
	        el.__ecGraphicWidthOption = elOption.width;
	        el.__ecGraphicHeightOption = elOption.height;
	        setEventData(el, graphicModel, elOption);
	      }
	    });
	  },
	
	  /**
	   * Locate graphic elements.
	   *
	   * @private
	   * @param {Object} graphicModel graphic model
	   * @param {module:echarts/ExtensionAPI} api extension API
	   */
	  _relocate: function (graphicModel, api) {
	    var elOptions = graphicModel.option.elements;
	    var rootGroup = this.group;
	    var elMap = this._elMap;
	    var apiWidth = api.getWidth();
	    var apiHeight = api.getHeight(); // Top-down to calculate percentage width/height of group
	
	    for (var i = 0; i < elOptions.length; i++) {
	      var elOption = elOptions[i];
	      var el = elMap.get(elOption.id);
	
	      if (!el || !el.isGroup) {
	        continue;
	      }
	
	      var parentEl = el.parent;
	      var isParentRoot = parentEl === rootGroup; // Like 'position:absolut' in css, default 0.
	
	      el.__ecGraphicWidth = parsePercent(el.__ecGraphicWidthOption, isParentRoot ? apiWidth : parentEl.__ecGraphicWidth) || 0;
	      el.__ecGraphicHeight = parsePercent(el.__ecGraphicHeightOption, isParentRoot ? apiHeight : parentEl.__ecGraphicHeight) || 0;
	    } // Bottom-up tranvese all elements (consider ec resize) to locate elements.
	
	
	    for (var i = elOptions.length - 1; i >= 0; i--) {
	      var elOption = elOptions[i];
	      var el = elMap.get(elOption.id);
	
	      if (!el) {
	        continue;
	      }
	
	      var parentEl = el.parent;
	      var containerInfo = parentEl === rootGroup ? {
	        width: apiWidth,
	        height: apiHeight
	      } : {
	        width: parentEl.__ecGraphicWidth,
	        height: parentEl.__ecGraphicHeight
	      }; // PENDING
	      // Currently, when `bounding: 'all'`, the union bounding rect of the group
	      // does not include the rect of [0, 0, group.width, group.height], which
	      // is probably weird for users. Should we make a break change for it?
	
	      layoutUtil.positionElement(el, elOption, containerInfo, null, {
	        hv: elOption.hv,
	        boundingMode: elOption.bounding
	      });
	    }
	  },
	
	  /**
	   * Clear all elements.
	   *
	   * @private
	   */
	  _clear: function () {
	    var elMap = this._elMap;
	    elMap.each(function (el) {
	      removeEl(el, elMap);
	    });
	    this._elMap = zrUtil.createHashMap();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clear();
	  }
	});
	
	function createEl(id, targetElParent, elOption, elMap) {
	  var graphicType = elOption.type;
	  var Clz = _nonShapeGraphicElements.hasOwnProperty(graphicType) // Those graphic elements are not shapes. They should not be
	  // overwritten by users, so do them first.
	  ? _nonShapeGraphicElements[graphicType] : graphicUtil.getShapeClass(graphicType);
	  var el = new Clz(elOption);
	  targetElParent.add(el);
	  elMap.set(id, el);
	  el.__ecGraphicId = id;
	}
	
	function removeEl(existEl, elMap) {
	  var existElParent = existEl && existEl.parent;
	
	  if (existElParent) {
	    existEl.type === 'group' && existEl.traverse(function (el) {
	      removeEl(el, elMap);
	    });
	    elMap.removeKey(existEl.__ecGraphicId);
	    existElParent.remove(existEl);
	  }
	} // Remove unnecessary props to avoid potential problems.
	
	
	function getCleanedElOption(elOption) {
	  elOption = zrUtil.extend({}, elOption);
	  zrUtil.each(['id', 'parentId', '$action', 'hv', 'bounding'].concat(layoutUtil.LOCATION_PARAMS), function (name) {
	    delete elOption[name];
	  });
	  return elOption;
	}
	
	function isSetLoc(obj, props) {
	  var isSet;
	  zrUtil.each(props, function (prop) {
	    obj[prop] != null && obj[prop] !== 'auto' && (isSet = true);
	  });
	  return isSet;
	}
	
	function setKeyInfoToNewElOption(resultItem, newElOption) {
	  var existElOption = resultItem.exist; // Set id and type after id assigned.
	
	  newElOption.id = resultItem.keyInfo.id;
	  !newElOption.type && existElOption && (newElOption.type = existElOption.type); // Set parent id if not specified
	
	  if (newElOption.parentId == null) {
	    var newElParentOption = newElOption.parentOption;
	
	    if (newElParentOption) {
	      newElOption.parentId = newElParentOption.id;
	    } else if (existElOption) {
	      newElOption.parentId = existElOption.parentId;
	    }
	  } // Clear
	
	
	  newElOption.parentOption = null;
	}
	
	function mergeNewElOptionToExist(existList, index, newElOption) {
	  // Update existing options, for `getOption` feature.
	  var newElOptCopy = zrUtil.extend({}, newElOption);
	  var existElOption = existList[index];
	  var $action = newElOption.$action || 'merge';
	
	  if ($action === 'merge') {
	    if (existElOption) {
	      // We can ensure that newElOptCopy and existElOption are not
	      // the same object, so `merge` will not change newElOptCopy.
	      zrUtil.merge(existElOption, newElOptCopy, true); // Rigid body, use ignoreSize.
	
	      layoutUtil.mergeLayoutParam(existElOption, newElOptCopy, {
	        ignoreSize: true
	      }); // Will be used in render.
	
	      layoutUtil.copyLayoutParams(newElOption, existElOption);
	    } else {
	      existList[index] = newElOptCopy;
	    }
	  } else if ($action === 'replace') {
	    existList[index] = newElOptCopy;
	  } else if ($action === 'remove') {
	    // null will be cleaned later.
	    existElOption && (existList[index] = null);
	  }
	}
	
	function setLayoutInfoToExist(existItem, newElOption) {
	  if (!existItem) {
	    return;
	  }
	
	  existItem.hv = newElOption.hv = [// Rigid body, dont care `width`.
	  isSetLoc(newElOption, ['left', 'right']), // Rigid body, dont care `height`.
	  isSetLoc(newElOption, ['top', 'bottom'])]; // Give default group size. Otherwise layout error may occur.
	
	  if (existItem.type === 'group') {
	    existItem.width == null && (existItem.width = newElOption.width = 0);
	    existItem.height == null && (existItem.height = newElOption.height = 0);
	  }
	}
	
	function setEventData(el, graphicModel, elOption) {
	  var eventData = el.eventData; // Simple optimize for large amount of elements that no need event.
	
	  if (!el.silent && !el.ignore && !eventData) {
	    eventData = el.eventData = {
	      componentType: 'graphic',
	      componentIndex: graphicModel.componentIndex,
	      name: el.name
	    };
	  } // `elOption.info` enables user to mount some info on
	  // elements and use them in event handlers.
	
	
	  if (eventData) {
	    eventData.info = el.info;
	  }
	}

/***/ },
/* 2346 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(290);
	
	__webpack_require__(835);
	
	__webpack_require__(289);

/***/ },
/* 2347 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var LegendModel = __webpack_require__(849);
	
	var _layout = __webpack_require__(46);
	
	var mergeLayoutParam = _layout.mergeLayoutParam;
	var getLayoutParams = _layout.getLayoutParams;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ScrollableLegendModel = LegendModel.extend({
	  type: 'legend.scroll',
	
	  /**
	   * @param {number} scrollDataIndex
	   */
	  setScrollDataIndex: function (scrollDataIndex) {
	    this.option.scrollDataIndex = scrollDataIndex;
	  },
	  defaultOption: {
	    scrollDataIndex: 0,
	    pageButtonItemGap: 5,
	    pageButtonGap: null,
	    pageButtonPosition: 'end',
	    // 'start' or 'end'
	    pageFormatter: '{current}/{total}',
	    // If null/undefined, do not show page.
	    pageIcons: {
	      horizontal: ['M0,0L12,-10L12,10z', 'M0,0L-12,-10L-12,10z'],
	      vertical: ['M0,0L20,0L10,-20z', 'M0,0L20,0L10,20z']
	    },
	    pageIconColor: '#2f4554',
	    pageIconInactiveColor: '#aaa',
	    pageIconSize: 15,
	    // Can be [10, 3], which represents [width, height]
	    pageTextStyle: {
	      color: '#333'
	    },
	    animationDurationUpdate: 800
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    ScrollableLegendModel.superCall(this, 'init', option, parentModel, ecModel, extraOpt);
	    mergeAndNormalizeLayoutParams(this, option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    ScrollableLegendModel.superCall(this, 'mergeOption', option, extraOpt);
	    mergeAndNormalizeLayoutParams(this, this.option, option);
	  }
	}); // Do not `ignoreSize` to enable setting {left: 10, right: 10}.
	
	function mergeAndNormalizeLayoutParams(legendModel, target, raw) {
	  var orient = legendModel.getOrient();
	  var ignoreSize = [1, 1];
	  ignoreSize[orient.index] = 0;
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = ScrollableLegendModel;
	module.exports = _default;

/***/ },
/* 2348 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var layoutUtil = __webpack_require__(46);
	
	var LegendView = __webpack_require__(850);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Separate legend and scrollable legend to reduce package size.
	 */
	var Group = graphic.Group;
	var WH = ['width', 'height'];
	var XY = ['x', 'y'];
	var ScrollableLegendView = LegendView.extend({
	  type: 'legend.scroll',
	  newlineDisabled: true,
	  init: function () {
	    ScrollableLegendView.superCall(this, 'init');
	    /**
	     * @private
	     * @type {number} For `scroll`.
	     */
	
	    this._currentIndex = 0;
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	    this.group.add(this._containerGroup = new Group());
	
	    this._containerGroup.add(this.getContentGroup());
	    /**
	     * @private
	     * @type {module:zrender/container/Group}
	     */
	
	
	    this.group.add(this._controllerGroup = new Group());
	    /**
	     *
	     * @private
	     */
	
	    this._showController;
	  },
	
	  /**
	   * @override
	   */
	  resetInner: function () {
	    ScrollableLegendView.superCall(this, 'resetInner');
	
	    this._controllerGroup.removeAll();
	
	    this._containerGroup.removeClipPath();
	
	    this._containerGroup.__rectSize = null;
	  },
	
	  /**
	   * @override
	   */
	  renderInner: function (itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition) {
	    var me = this; // Render content items.
	
	    ScrollableLegendView.superCall(this, 'renderInner', itemAlign, legendModel, ecModel, api, selector, orient, selectorPosition);
	    var controllerGroup = this._controllerGroup; // FIXME: support be 'auto' adapt to size number text length,
	    // e.g., '3/12345' should not overlap with the control arrow button.
	
	    var pageIconSize = legendModel.get('pageIconSize', true);
	
	    if (!zrUtil.isArray(pageIconSize)) {
	      pageIconSize = [pageIconSize, pageIconSize];
	    }
	
	    createPageButton('pagePrev', 0);
	    var pageTextStyleModel = legendModel.getModel('pageTextStyle');
	    controllerGroup.add(new graphic.Text({
	      name: 'pageText',
	      style: {
	        textFill: pageTextStyleModel.getTextColor(),
	        font: pageTextStyleModel.getFont(),
	        textVerticalAlign: 'middle',
	        textAlign: 'center'
	      },
	      silent: true
	    }));
	    createPageButton('pageNext', 1);
	
	    function createPageButton(name, iconIdx) {
	      var pageDataIndexName = name + 'DataIndex';
	      var icon = graphic.createIcon(legendModel.get('pageIcons', true)[legendModel.getOrient().name][iconIdx], {
	        // Buttons will be created in each render, so we do not need
	        // to worry about avoiding using legendModel kept in scope.
	        onclick: zrUtil.bind(me._pageGo, me, pageDataIndexName, legendModel, api)
	      }, {
	        x: -pageIconSize[0] / 2,
	        y: -pageIconSize[1] / 2,
	        width: pageIconSize[0],
	        height: pageIconSize[1]
	      });
	      icon.name = name;
	      controllerGroup.add(icon);
	    }
	  },
	
	  /**
	   * @override
	   */
	  layoutInner: function (legendModel, itemAlign, maxSize, isFirstRender, selector, selectorPosition) {
	    var selectorGroup = this.getSelectorGroup();
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var xy = XY[orientIdx];
	    var hw = WH[1 - orientIdx];
	    var yx = XY[1 - orientIdx];
	    selector && layoutUtil.box( // Buttons in selectorGroup always layout horizontally
	    'horizontal', selectorGroup, legendModel.get('selectorItemGap', true));
	    var selectorButtonGap = legendModel.get('selectorButtonGap', true);
	    var selectorRect = selectorGroup.getBoundingRect();
	    var selectorPos = [-selectorRect.x, -selectorRect.y];
	    var processMaxSize = zrUtil.clone(maxSize);
	    selector && (processMaxSize[wh] = maxSize[wh] - selectorRect[wh] - selectorButtonGap);
	
	    var mainRect = this._layoutContentAndController(legendModel, isFirstRender, processMaxSize, orientIdx, wh, hw, yx);
	
	    if (selector) {
	      if (selectorPosition === 'end') {
	        selectorPos[orientIdx] += mainRect[wh] + selectorButtonGap;
	      } else {
	        var offset = selectorRect[wh] + selectorButtonGap;
	        selectorPos[orientIdx] -= offset;
	        mainRect[xy] -= offset;
	      }
	
	      mainRect[wh] += selectorRect[wh] + selectorButtonGap;
	      selectorPos[1 - orientIdx] += mainRect[yx] + mainRect[hw] / 2 - selectorRect[hw] / 2;
	      mainRect[hw] = Math.max(mainRect[hw], selectorRect[hw]);
	      mainRect[yx] = Math.min(mainRect[yx], selectorRect[yx] + selectorPos[1 - orientIdx]);
	      selectorGroup.attr('position', selectorPos);
	    }
	
	    return mainRect;
	  },
	  _layoutContentAndController: function (legendModel, isFirstRender, maxSize, orientIdx, wh, hw, yx) {
	    var contentGroup = this.getContentGroup();
	    var containerGroup = this._containerGroup;
	    var controllerGroup = this._controllerGroup; // Place items in contentGroup.
	
	    layoutUtil.box(legendModel.get('orient'), contentGroup, legendModel.get('itemGap'), !orientIdx ? null : maxSize.width, orientIdx ? null : maxSize.height);
	    layoutUtil.box( // Buttons in controller are layout always horizontally.
	    'horizontal', controllerGroup, legendModel.get('pageButtonItemGap', true));
	    var contentRect = contentGroup.getBoundingRect();
	    var controllerRect = controllerGroup.getBoundingRect();
	    var showController = this._showController = contentRect[wh] > maxSize[wh];
	    var contentPos = [-contentRect.x, -contentRect.y]; // Remain contentPos when scroll animation perfroming.
	    // If first rendering, `contentGroup.position` is [0, 0], which
	    // does not make sense and may cause unexepcted animation if adopted.
	
	    if (!isFirstRender) {
	      contentPos[orientIdx] = contentGroup.position[orientIdx];
	    } // Layout container group based on 0.
	
	
	    var containerPos = [0, 0];
	    var controllerPos = [-controllerRect.x, -controllerRect.y];
	    var pageButtonGap = zrUtil.retrieve2(legendModel.get('pageButtonGap', true), legendModel.get('itemGap', true)); // Place containerGroup and controllerGroup and contentGroup.
	
	    if (showController) {
	      var pageButtonPosition = legendModel.get('pageButtonPosition', true); // controller is on the right / bottom.
	
	      if (pageButtonPosition === 'end') {
	        controllerPos[orientIdx] += maxSize[wh] - controllerRect[wh];
	      } // controller is on the left / top.
	      else {
	          containerPos[orientIdx] += controllerRect[wh] + pageButtonGap;
	        }
	    } // Always align controller to content as 'middle'.
	
	
	    controllerPos[1 - orientIdx] += contentRect[hw] / 2 - controllerRect[hw] / 2;
	    contentGroup.attr('position', contentPos);
	    containerGroup.attr('position', containerPos);
	    controllerGroup.attr('position', controllerPos); // Calculate `mainRect` and set `clipPath`.
	    // mainRect should not be calculated by `this.group.getBoundingRect()`
	    // for sake of the overflow.
	
	    var mainRect = {
	      x: 0,
	      y: 0
	    }; // Consider content may be overflow (should be clipped).
	
	    mainRect[wh] = showController ? maxSize[wh] : contentRect[wh];
	    mainRect[hw] = Math.max(contentRect[hw], controllerRect[hw]); // `containerRect[yx] + containerPos[1 - orientIdx]` is 0.
	
	    mainRect[yx] = Math.min(0, controllerRect[yx] + controllerPos[1 - orientIdx]);
	    containerGroup.__rectSize = maxSize[wh];
	
	    if (showController) {
	      var clipShape = {
	        x: 0,
	        y: 0
	      };
	      clipShape[wh] = Math.max(maxSize[wh] - controllerRect[wh] - pageButtonGap, 0);
	      clipShape[hw] = mainRect[hw];
	      containerGroup.setClipPath(new graphic.Rect({
	        shape: clipShape
	      })); // Consider content may be larger than container, container rect
	      // can not be obtained from `containerGroup.getBoundingRect()`.
	
	      containerGroup.__rectSize = clipShape[wh];
	    } else {
	      // Do not remove or ignore controller. Keep them set as placeholders.
	      controllerGroup.eachChild(function (child) {
	        child.attr({
	          invisible: true,
	          silent: true
	        });
	      });
	    } // Content translate animation.
	
	
	    var pageInfo = this._getPageInfo(legendModel);
	
	    pageInfo.pageIndex != null && graphic.updateProps(contentGroup, {
	      position: pageInfo.contentPosition
	    }, // When switch from "show controller" to "not show controller", view should be
	    // updated immediately without animation, otherwise causes weird effect.
	    showController ? legendModel : false);
	
	    this._updatePageInfoView(legendModel, pageInfo);
	
	    return mainRect;
	  },
	  _pageGo: function (to, legendModel, api) {
	    var scrollDataIndex = this._getPageInfo(legendModel)[to];
	
	    scrollDataIndex != null && api.dispatchAction({
	      type: 'legendScroll',
	      scrollDataIndex: scrollDataIndex,
	      legendId: legendModel.id
	    });
	  },
	  _updatePageInfoView: function (legendModel, pageInfo) {
	    var controllerGroup = this._controllerGroup;
	    zrUtil.each(['pagePrev', 'pageNext'], function (name) {
	      var canJump = pageInfo[name + 'DataIndex'] != null;
	      var icon = controllerGroup.childOfName(name);
	
	      if (icon) {
	        icon.setStyle('fill', canJump ? legendModel.get('pageIconColor', true) : legendModel.get('pageIconInactiveColor', true));
	        icon.cursor = canJump ? 'pointer' : 'default';
	      }
	    });
	    var pageText = controllerGroup.childOfName('pageText');
	    var pageFormatter = legendModel.get('pageFormatter');
	    var pageIndex = pageInfo.pageIndex;
	    var current = pageIndex != null ? pageIndex + 1 : 0;
	    var total = pageInfo.pageCount;
	    pageText && pageFormatter && pageText.setStyle('text', zrUtil.isString(pageFormatter) ? pageFormatter.replace('{current}', current).replace('{total}', total) : pageFormatter({
	      current: current,
	      total: total
	    }));
	  },
	
	  /**
	   * @param {module:echarts/model/Model} legendModel
	   * @return {Object} {
	   *  contentPosition: Array.<number>, null when data item not found.
	   *  pageIndex: number, null when data item not found.
	   *  pageCount: number, always be a number, can be 0.
	   *  pagePrevDataIndex: number, null when no previous page.
	   *  pageNextDataIndex: number, null when no next page.
	   * }
	   */
	  _getPageInfo: function (legendModel) {
	    var scrollDataIndex = legendModel.get('scrollDataIndex', true);
	    var contentGroup = this.getContentGroup();
	    var containerRectSize = this._containerGroup.__rectSize;
	    var orientIdx = legendModel.getOrient().index;
	    var wh = WH[orientIdx];
	    var xy = XY[orientIdx];
	
	    var targetItemIndex = this._findTargetItemIndex(scrollDataIndex);
	
	    var children = contentGroup.children();
	    var targetItem = children[targetItemIndex];
	    var itemCount = children.length;
	    var pCount = !itemCount ? 0 : 1;
	    var result = {
	      contentPosition: contentGroup.position.slice(),
	      pageCount: pCount,
	      pageIndex: pCount - 1,
	      pagePrevDataIndex: null,
	      pageNextDataIndex: null
	    };
	
	    if (!targetItem) {
	      return result;
	    }
	
	    var targetItemInfo = getItemInfo(targetItem);
	    result.contentPosition[orientIdx] = -targetItemInfo.s; // Strategy:
	    // (1) Always align based on the left/top most item.
	    // (2) It is user-friendly that the last item shown in the
	    // current window is shown at the begining of next window.
	    // Otherwise if half of the last item is cut by the window,
	    // it will have no chance to display entirely.
	    // (3) Consider that item size probably be different, we
	    // have calculate pageIndex by size rather than item index,
	    // and we can not get page index directly by division.
	    // (4) The window is to narrow to contain more than
	    // one item, we should make sure that the page can be fliped.
	
	    for (var i = targetItemIndex + 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i <= itemCount; ++i) {
	      currItemInfo = getItemInfo(children[i]);
	
	      if ( // Half of the last item is out of the window.
	      !currItemInfo && winEndItemInfo.e > winStartItemInfo.s + containerRectSize || // If the current item does not intersect with the window, the new page
	      // can be started at the current item or the last item.
	      currItemInfo && !intersect(currItemInfo, winStartItemInfo.s)) {
	        if (winEndItemInfo.i > winStartItemInfo.i) {
	          winStartItemInfo = winEndItemInfo;
	        } else {
	          // e.g., when page size is smaller than item size.
	          winStartItemInfo = currItemInfo;
	        }
	
	        if (winStartItemInfo) {
	          if (result.pageNextDataIndex == null) {
	            result.pageNextDataIndex = winStartItemInfo.i;
	          }
	
	          ++result.pageCount;
	        }
	      }
	
	      winEndItemInfo = currItemInfo;
	    }
	
	    for (var i = targetItemIndex - 1, winStartItemInfo = targetItemInfo, winEndItemInfo = targetItemInfo, currItemInfo = null; i >= -1; --i) {
	      currItemInfo = getItemInfo(children[i]);
	
	      if ( // If the the end item does not intersect with the window started
	      // from the current item, a page can be settled.
	      (!currItemInfo || !intersect(winEndItemInfo, currItemInfo.s)) && // e.g., when page size is smaller than item size.
	      winStartItemInfo.i < winEndItemInfo.i) {
	        winEndItemInfo = winStartItemInfo;
	
	        if (result.pagePrevDataIndex == null) {
	          result.pagePrevDataIndex = winStartItemInfo.i;
	        }
	
	        ++result.pageCount;
	        ++result.pageIndex;
	      }
	
	      winStartItemInfo = currItemInfo;
	    }
	
	    return result;
	
	    function getItemInfo(el) {
	      if (el) {
	        var itemRect = el.getBoundingRect();
	        var start = itemRect[xy] + el.position[orientIdx];
	        return {
	          s: start,
	          e: start + itemRect[wh],
	          i: el.__legendDataIndex
	        };
	      }
	    }
	
	    function intersect(itemInfo, winStart) {
	      return itemInfo.e >= winStart && itemInfo.s <= winStart + containerRectSize;
	    }
	  },
	  _findTargetItemIndex: function (targetDataIndex) {
	    if (!this._showController) {
	      return 0;
	    }
	
	    var index;
	    var contentGroup = this.getContentGroup();
	    var defaultIndex;
	    contentGroup.eachChild(function (child, idx) {
	      var legendDataIdx = child.__legendDataIndex; // FIXME
	      // If the given targetDataIndex (from model) is illegal,
	      // we use defaultIndex. But the index on the legend model and
	      // action payload is still illegal. That case will not be
	      // changed until some scenario requires.
	
	      if (defaultIndex == null && legendDataIdx != null) {
	        defaultIndex = idx;
	      }
	
	      if (legendDataIdx === targetDataIndex) {
	        index = idx;
	      }
	    });
	    return index != null ? index : defaultIndex;
	  }
	});
	var _default = ScrollableLegendView;
	module.exports = _default;

/***/ },
/* 2349 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function legendSelectActionHandler(methodName, payload, ecModel) {
	  var selectedMap = {};
	  var isToggleSelect = methodName === 'toggleSelected';
	  var isSelected; // Update all legend components
	
	  ecModel.eachComponent('legend', function (legendModel) {
	    if (isToggleSelect && isSelected != null) {
	      // Force other legend has same selected status
	      // Or the first is toggled to true and other are toggled to false
	      // In the case one legend has some item unSelected in option. And if other legend
	      // doesn't has the item, they will assume it is selected.
	      legendModel[isSelected ? 'select' : 'unSelect'](payload.name);
	    } else if (methodName === 'allSelect' || methodName === 'inverseSelect') {
	      legendModel[methodName]();
	    } else {
	      legendModel[methodName](payload.name);
	      isSelected = legendModel.isSelected(payload.name);
	    }
	
	    var legendData = legendModel.getData();
	    zrUtil.each(legendData, function (model) {
	      var name = model.get('name'); // Wrap element
	
	      if (name === '\n' || name === '') {
	        return;
	      }
	
	      var isItemSelected = legendModel.isSelected(name);
	
	      if (selectedMap.hasOwnProperty(name)) {
	        // Unselected if any legend is unselected
	        selectedMap[name] = selectedMap[name] && isItemSelected;
	      } else {
	        selectedMap[name] = isItemSelected;
	      }
	    });
	  }); // Return the event explicitly
	
	  return methodName === 'allSelect' || methodName === 'inverseSelect' ? {
	    selected: selectedMap
	  } : {
	    name: payload.name,
	    selected: selectedMap
	  };
	}
	/**
	 * @event legendToggleSelect
	 * @type {Object}
	 * @property {string} type 'legendToggleSelect'
	 * @property {string} [from]
	 * @property {string} name Series name or data item name
	 */
	
	
	echarts.registerAction('legendToggleSelect', 'legendselectchanged', zrUtil.curry(legendSelectActionHandler, 'toggleSelected'));
	echarts.registerAction('legendAllSelect', 'legendselectall', zrUtil.curry(legendSelectActionHandler, 'allSelect'));
	echarts.registerAction('legendInverseSelect', 'legendinverseselect', zrUtil.curry(legendSelectActionHandler, 'inverseSelect'));
	/**
	 * @event legendSelect
	 * @type {Object}
	 * @property {string} type 'legendSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendSelect', 'legendselected', zrUtil.curry(legendSelectActionHandler, 'select'));
	/**
	 * @event legendUnSelect
	 * @type {Object}
	 * @property {string} type 'legendUnSelect'
	 * @property {string} name Series name or data item name
	 */
	
	echarts.registerAction('legendUnSelect', 'legendunselected', zrUtil.curry(legendSelectActionHandler, 'unSelect'));

/***/ },
/* 2350 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(ecModel) {
	  var legendModels = ecModel.findComponents({
	    mainType: 'legend'
	  });
	
	  if (legendModels && legendModels.length) {
	    ecModel.filterSeries(function (series) {
	      // If in any legend component the status is not selected.
	      // Because in legend series is assumed selected when it is not in the legend data.
	      for (var i = 0; i < legendModels.length; i++) {
	        if (!legendModels[i].isSelected(series.name)) {
	          return false;
	        }
	      }
	
	      return true;
	    });
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2351 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @event legendScroll
	 * @type {Object}
	 * @property {string} type 'legendScroll'
	 * @property {string} scrollDataIndex
	 */
	echarts.registerAction('legendScroll', 'legendscroll', function (payload, ecModel) {
	  var scrollDataIndex = payload.scrollDataIndex;
	  scrollDataIndex != null && ecModel.eachComponent({
	    mainType: 'legend',
	    subType: 'scroll',
	    query: payload
	  }, function (legendModel) {
	    legendModel.setScrollDataIndex(scrollDataIndex);
	  });
	});

/***/ },
/* 2352 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(848);
	
	__webpack_require__(2347);
	
	__webpack_require__(2348);
	
	__webpack_require__(2351);

/***/ },
/* 2353 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2356);
	
	__webpack_require__(2357);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markArea component is enabled
	  opt.markArea = opt.markArea || {};
	});

/***/ },
/* 2354 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2358);
	
	__webpack_require__(2359);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markLine component is enabled
	  opt.markLine = opt.markLine || {};
	});

/***/ },
/* 2355 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2360);
	
	__webpack_require__(2361);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// HINT Markpoint can't be used too much
	echarts.registerPreprocessor(function (opt) {
	  // Make sure markPoint component is enabled
	  opt.markPoint = opt.markPoint || {};
	});

/***/ },
/* 2356 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(508);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markArea',
	  defaultOption: {
	    zlevel: 0,
	    // PENDING
	    z: 1,
	    tooltip: {
	      trigger: 'item'
	    },
	    // markArea should fixed on the coordinate system
	    animation: false,
	    label: {
	      show: true,
	      position: 'top'
	    },
	    itemStyle: {
	      // color and borderColor default to use color from series
	      // color: 'auto'
	      // borderColor: 'auto'
	      borderWidth: 0
	    },
	    emphasis: {
	      label: {
	        show: true,
	        position: 'top'
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2357 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var colorUtil = __webpack_require__(148);
	
	var List = __webpack_require__(109);
	
	var numberUtil = __webpack_require__(25);
	
	var graphic = __webpack_require__(14);
	
	var markerHelper = __webpack_require__(510);
	
	var MarkerView = __webpack_require__(509);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO Better on polar
	var markAreaTransform = function (seriesModel, coordSys, maModel, item) {
	  var lt = markerHelper.dataTransform(seriesModel, item[0]);
	  var rb = markerHelper.dataTransform(seriesModel, item[1]);
	  var retrieve = zrUtil.retrieve; // FIXME make sure lt is less than rb
	
	  var ltCoord = lt.coord;
	  var rbCoord = rb.coord;
	  ltCoord[0] = retrieve(ltCoord[0], -Infinity);
	  ltCoord[1] = retrieve(ltCoord[1], -Infinity);
	  rbCoord[0] = retrieve(rbCoord[0], Infinity);
	  rbCoord[1] = retrieve(rbCoord[1], Infinity); // Merge option into one
	
	  var result = zrUtil.mergeAll([{}, lt, rb]);
	  result.coord = [lt.coord, rb.coord];
	  result.x0 = lt.x;
	  result.y0 = lt.y;
	  result.x1 = rb.x;
	  result.y1 = rb.y;
	  return result;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markArea has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]);
	}
	
	function markAreaFilter(coordSys, item) {
	  var fromCoord = item.coord[0];
	  var toCoord = item.coord[1];
	
	  if (coordSys.type === 'cartesian2d') {
	    // In case
	    // {
	    //  markArea: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, {
	    coord: fromCoord,
	    x: item.x0,
	    y: item.y0
	  }) || markerHelper.dataFilter(coordSys, {
	    coord: toCoord,
	    x: item.x1,
	    y: item.y1
	  });
	} // dims can be ['x0', 'y0'], ['x1', 'y1'], ['x0', 'y1'], ['x1', 'y0']
	
	
	function getSingleMarkerEndPoint(data, idx, dims, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get(dims[0]), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get(dims[1]), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(dims, idx));
	    } else {
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      var pt = [x, y];
	      coordSys.clampData && coordSys.clampData(pt, pt);
	      point = coordSys.dataToPoint(pt, true);
	    }
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	
	      if (isInifinity(x)) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[dims[0] === 'x0' ? 0 : 1]);
	      } else if (isInifinity(y)) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[dims[1] === 'y0' ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  return point;
	}
	
	var dimPermutations = [['x0', 'y0'], ['x1', 'y0'], ['x1', 'y1'], ['x0', 'y1']];
	MarkerView.extend({
	  type: 'markArea',
	  // updateLayout: function (markAreaModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var maModel = seriesModel.markAreaModel;
	  //         if (maModel) {
	  //             var areaData = maModel.getData();
	  //             areaData.each(function (idx) {
	  //                 var points = zrUtil.map(dimPermutations, function (dim) {
	  //                     return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	  //                 });
	  //                 // Layout
	  //                 areaData.setItemLayout(idx, points);
	  //                 var el = areaData.getItemGraphicEl(idx);
	  //                 el.setShape('points', points);
	  //             });
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markAreaModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var maModel = seriesModel.markAreaModel;
	
	      if (maModel) {
	        var areaData = maModel.getData();
	        areaData.each(function (idx) {
	          var points = zrUtil.map(dimPermutations, function (dim) {
	            return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	          }); // Layout
	
	          areaData.setItemLayout(idx, points);
	          var el = areaData.getItemGraphicEl(idx);
	          el.setShape('points', points);
	        });
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, maModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var areaGroupMap = this.markerGroupMap;
	    var polygonGroup = areaGroupMap.get(seriesId) || areaGroupMap.set(seriesId, {
	      group: new graphic.Group()
	    });
	    this.group.add(polygonGroup.group);
	    polygonGroup.__keep = true;
	    var areaData = createList(coordSys, seriesModel, maModel); // Line data for tooltip and formatter
	
	    maModel.setData(areaData); // Update visual and layout of line
	
	    areaData.each(function (idx) {
	      // Layout
	      var points = zrUtil.map(dimPermutations, function (dim) {
	        return getSingleMarkerEndPoint(areaData, idx, dim, seriesModel, api);
	      }); // If none of the area is inside coordSys, allClipped is set to be true
	      // in layout so that label will not be displayed. See #12591
	
	      var allClipped = true;
	      zrUtil.each(dimPermutations, function (dim) {
	        if (!allClipped) {
	          return;
	        }
	
	        var xValue = areaData.get(dim[0], idx);
	        var yValue = areaData.get(dim[1], idx); // If is infinity, the axis should be considered not clipped
	
	        if ((isInifinity(xValue) || coordSys.getAxis('x').containData(xValue)) && (isInifinity(yValue) || coordSys.getAxis('y').containData(yValue))) {
	          allClipped = false;
	        }
	      });
	      areaData.setItemLayout(idx, {
	        points: points,
	        allClipped: allClipped
	      }); // Visual
	
	      areaData.setItemVisual(idx, {
	        color: seriesData.getVisual('color')
	      });
	    });
	    areaData.diff(polygonGroup.__data).add(function (idx) {
	      var layout = areaData.getItemLayout(idx);
	
	      if (!layout.allClipped) {
	        var polygon = new graphic.Polygon({
	          shape: {
	            points: layout.points
	          }
	        });
	        areaData.setItemGraphicEl(idx, polygon);
	        polygonGroup.group.add(polygon);
	      }
	    }).update(function (newIdx, oldIdx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(oldIdx);
	
	      var layout = areaData.getItemLayout(newIdx);
	
	      if (!layout.allClipped) {
	        if (polygon) {
	          graphic.updateProps(polygon, {
	            shape: {
	              points: layout.points
	            }
	          }, maModel, newIdx);
	        } else {
	          polygon = new graphic.Polygon({
	            shape: {
	              points: layout.points
	            }
	          });
	        }
	
	        areaData.setItemGraphicEl(newIdx, polygon);
	        polygonGroup.group.add(polygon);
	      } else if (polygon) {
	        polygonGroup.group.remove(polygon);
	      }
	    }).remove(function (idx) {
	      var polygon = polygonGroup.__data.getItemGraphicEl(idx);
	
	      polygonGroup.group.remove(polygon);
	    }).execute();
	    areaData.eachItemGraphicEl(function (polygon, idx) {
	      var itemModel = areaData.getItemModel(idx);
	      var labelModel = itemModel.getModel('label');
	      var labelHoverModel = itemModel.getModel('emphasis.label');
	      var color = areaData.getItemVisual(idx, 'color');
	      polygon.useStyle(zrUtil.defaults(itemModel.getModel('itemStyle').getItemStyle(), {
	        fill: colorUtil.modifyAlpha(color, 0.4),
	        stroke: color
	      }));
	      polygon.hoverStyle = itemModel.getModel('emphasis.itemStyle').getItemStyle();
	      graphic.setLabelStyle(polygon.style, polygon.hoverStyle, labelModel, labelHoverModel, {
	        labelFetcher: maModel,
	        labelDataIndex: idx,
	        defaultText: areaData.getName(idx) || '',
	        isRectText: true,
	        autoColor: color
	      });
	      graphic.setHoverStyle(polygon, {});
	      polygon.dataModel = maModel;
	    });
	    polygonGroup.__data = areaData;
	    polygonGroup.group.silent = maModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	function createList(coordSys, seriesModel, maModel) {
	  var coordDimsInfos;
	  var areaData;
	  var dims = ['x0', 'y0', 'x1', 'y1'];
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var data = seriesModel.getData();
	      var info = data.getDimensionInfo(data.mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	    areaData = new List(zrUtil.map(dims, function (dim, idx) {
	      return {
	        name: dim,
	        type: coordDimsInfos[idx % 2].type
	      };
	    }), maModel);
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	    areaData = new List(coordDimsInfos, maModel);
	  }
	
	  var optData = zrUtil.map(maModel.get('data'), zrUtil.curry(markAreaTransform, seriesModel, coordSys, maModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markAreaFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? function (item, dimName, dataIndex, dimIndex) {
	    return item.coord[Math.floor(dimIndex / 2)][dimIndex % 2];
	  } : function (item) {
	    return item.value;
	  };
	  areaData.initData(optData, null, dimValueGetter);
	  areaData.hasItemOption = true;
	  return areaData;
	}

/***/ },
/* 2358 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(508);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markLine',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: ['circle', 'arrow'],
	    symbolSize: [8, 16],
	    //symbolRotate: 0,
	    precision: 2,
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      show: true,
	      position: 'end',
	      distance: 5
	    },
	    lineStyle: {
	      type: 'dashed'
	    },
	    emphasis: {
	      label: {
	        show: true
	      },
	      lineStyle: {
	        width: 3
	      }
	    },
	    animationEasing: 'linear'
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2359 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var List = __webpack_require__(109);
	
	var numberUtil = __webpack_require__(25);
	
	var markerHelper = __webpack_require__(510);
	
	var LineDraw = __webpack_require__(498);
	
	var MarkerView = __webpack_require__(509);
	
	var _dataStackHelper = __webpack_require__(140);
	
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var markLineTransform = function (seriesModel, coordSys, mlModel, item) {
	  var data = seriesModel.getData(); // Special type markLine like 'min', 'max', 'average', 'median'
	
	  var mlType = item.type;
	
	  if (!zrUtil.isArray(item) && (mlType === 'min' || mlType === 'max' || mlType === 'average' || mlType === 'median' // In case
	  // data: [{
	  //   yAxis: 10
	  // }]
	  || item.xAxis != null || item.yAxis != null)) {
	    var valueAxis;
	    var value;
	
	    if (item.yAxis != null || item.xAxis != null) {
	      valueAxis = coordSys.getAxis(item.yAxis != null ? 'y' : 'x');
	      value = zrUtil.retrieve(item.yAxis, item.xAxis);
	    } else {
	      var axisInfo = markerHelper.getAxisInfo(item, data, coordSys, seriesModel);
	      valueAxis = axisInfo.valueAxis;
	      var valueDataDim = getStackedDimension(data, axisInfo.valueDataDim);
	      value = markerHelper.numCalculate(data, valueDataDim, mlType);
	    }
	
	    var valueIndex = valueAxis.dim === 'x' ? 0 : 1;
	    var baseIndex = 1 - valueIndex;
	    var mlFrom = zrUtil.clone(item);
	    var mlTo = {};
	    mlFrom.type = null;
	    mlFrom.coord = [];
	    mlTo.coord = [];
	    mlFrom.coord[baseIndex] = -Infinity;
	    mlTo.coord[baseIndex] = Infinity;
	    var precision = mlModel.get('precision');
	
	    if (precision >= 0 && typeof value === 'number') {
	      value = +value.toFixed(Math.min(precision, 20));
	    }
	
	    mlFrom.coord[valueIndex] = mlTo.coord[valueIndex] = value;
	    item = [mlFrom, mlTo, {
	      // Extra option for tooltip and label
	      type: mlType,
	      valueIndex: item.valueIndex,
	      // Force to use the value of calculated value.
	      value: value
	    }];
	  }
	
	  item = [markerHelper.dataTransform(seriesModel, item[0]), markerHelper.dataTransform(seriesModel, item[1]), zrUtil.extend({}, item[2])]; // Avoid line data type is extended by from(to) data type
	
	  item[2].type = item[2].type || ''; // Merge from option and to option into line option
	
	  zrUtil.merge(item[2], item[0]);
	  zrUtil.merge(item[2], item[1]);
	  return item;
	};
	
	function isInifinity(val) {
	  return !isNaN(val) && !isFinite(val);
	} // If a markLine has one dim
	
	
	function ifMarkLineHasOnlyDim(dimIndex, fromCoord, toCoord, coordSys) {
	  var otherDimIndex = 1 - dimIndex;
	  var dimName = coordSys.dimensions[dimIndex];
	  return isInifinity(fromCoord[otherDimIndex]) && isInifinity(toCoord[otherDimIndex]) && fromCoord[dimIndex] === toCoord[dimIndex] && coordSys.getAxis(dimName).containData(fromCoord[dimIndex]);
	}
	
	function markLineFilter(coordSys, item) {
	  if (coordSys.type === 'cartesian2d') {
	    var fromCoord = item[0].coord;
	    var toCoord = item[1].coord; // In case
	    // {
	    //  markLine: {
	    //    data: [{ yAxis: 2 }]
	    //  }
	    // }
	
	    if (fromCoord && toCoord && (ifMarkLineHasOnlyDim(1, fromCoord, toCoord, coordSys) || ifMarkLineHasOnlyDim(0, fromCoord, toCoord, coordSys))) {
	      return true;
	    }
	  }
	
	  return markerHelper.dataFilter(coordSys, item[0]) && markerHelper.dataFilter(coordSys, item[1]);
	}
	
	function updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  var itemModel = data.getItemModel(idx);
	  var point;
	  var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	  var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	  if (!isNaN(xPx) && !isNaN(yPx)) {
	    point = [xPx, yPx];
	  } else {
	    // Chart like bar may have there own marker positioning logic
	    if (seriesModel.getMarkerPosition) {
	      // Use the getMarkerPoisition
	      point = seriesModel.getMarkerPosition(data.getValues(data.dimensions, idx));
	    } else {
	      var dims = coordSys.dimensions;
	      var x = data.get(dims[0], idx);
	      var y = data.get(dims[1], idx);
	      point = coordSys.dataToPoint([x, y]);
	    } // Expand line to the edge of grid if value on one axis is Inifnity
	    // In case
	    //  markLine: {
	    //    data: [{
	    //      yAxis: 2
	    //      // or
	    //      type: 'average'
	    //    }]
	    //  }
	
	
	    if (coordSys.type === 'cartesian2d') {
	      var xAxis = coordSys.getAxis('x');
	      var yAxis = coordSys.getAxis('y');
	      var dims = coordSys.dimensions;
	
	      if (isInifinity(data.get(dims[0], idx))) {
	        point[0] = xAxis.toGlobalCoord(xAxis.getExtent()[isFrom ? 0 : 1]);
	      } else if (isInifinity(data.get(dims[1], idx))) {
	        point[1] = yAxis.toGlobalCoord(yAxis.getExtent()[isFrom ? 0 : 1]);
	      }
	    } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	  }
	
	  data.setItemLayout(idx, point);
	}
	
	var _default = MarkerView.extend({
	  type: 'markLine',
	  // updateLayout: function (markLineModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var mlModel = seriesModel.markLineModel;
	  //         if (mlModel) {
	  //             var mlData = mlModel.getData();
	  //             var fromData = mlModel.__from;
	  //             var toData = mlModel.__to;
	  //             // Update visual and layout of from symbol and to symbol
	  //             fromData.each(function (idx) {
	  //                 updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
	  //                 updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
	  //             });
	  //             // Update layout of line
	  //             mlData.each(function (idx) {
	  //                 mlData.setItemLayout(idx, [
	  //                     fromData.getItemLayout(idx),
	  //                     toData.getItemLayout(idx)
	  //                 ]);
	  //             });
	  //             this.markerGroupMap.get(seriesModel.id).updateLayout();
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markLineModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mlModel = seriesModel.markLineModel;
	
	      if (mlModel) {
	        var mlData = mlModel.getData();
	        var fromData = mlModel.__from;
	        var toData = mlModel.__to; // Update visual and layout of from symbol and to symbol
	
	        fromData.each(function (idx) {
	          updateSingleMarkerEndLayout(fromData, idx, true, seriesModel, api);
	          updateSingleMarkerEndLayout(toData, idx, false, seriesModel, api);
	        }); // Update layout of line
	
	        mlData.each(function (idx) {
	          mlData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	        });
	        this.markerGroupMap.get(seriesModel.id).updateLayout();
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mlModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var lineDrawMap = this.markerGroupMap;
	    var lineDraw = lineDrawMap.get(seriesId) || lineDrawMap.set(seriesId, new LineDraw());
	    this.group.add(lineDraw.group);
	    var mlData = createList(coordSys, seriesModel, mlModel);
	    var fromData = mlData.from;
	    var toData = mlData.to;
	    var lineData = mlData.line;
	    mlModel.__from = fromData;
	    mlModel.__to = toData; // Line data for tooltip and formatter
	
	    mlModel.setData(lineData);
	    var symbolType = mlModel.get('symbol');
	    var symbolSize = mlModel.get('symbolSize');
	
	    if (!zrUtil.isArray(symbolType)) {
	      symbolType = [symbolType, symbolType];
	    }
	
	    if (typeof symbolSize === 'number') {
	      symbolSize = [symbolSize, symbolSize];
	    } // Update visual and layout of from symbol and to symbol
	
	
	    mlData.from.each(function (idx) {
	      updateDataVisualAndLayout(fromData, idx, true);
	      updateDataVisualAndLayout(toData, idx, false);
	    }); // Update visual and layout of line
	
	    lineData.each(function (idx) {
	      var lineColor = lineData.getItemModel(idx).get('lineStyle.color');
	      lineData.setItemVisual(idx, {
	        color: lineColor || fromData.getItemVisual(idx, 'color')
	      });
	      lineData.setItemLayout(idx, [fromData.getItemLayout(idx), toData.getItemLayout(idx)]);
	      lineData.setItemVisual(idx, {
	        'fromSymbolRotate': fromData.getItemVisual(idx, 'symbolRotate'),
	        'fromSymbolSize': fromData.getItemVisual(idx, 'symbolSize'),
	        'fromSymbol': fromData.getItemVisual(idx, 'symbol'),
	        'toSymbolRotate': toData.getItemVisual(idx, 'symbolRotate'),
	        'toSymbolSize': toData.getItemVisual(idx, 'symbolSize'),
	        'toSymbol': toData.getItemVisual(idx, 'symbol')
	      });
	    });
	    lineDraw.updateData(lineData); // Set host model for tooltip
	    // FIXME
	
	    mlData.line.eachItemGraphicEl(function (el, idx) {
	      el.traverse(function (child) {
	        child.dataModel = mlModel;
	      });
	    });
	
	    function updateDataVisualAndLayout(data, idx, isFrom) {
	      var itemModel = data.getItemModel(idx);
	      updateSingleMarkerEndLayout(data, idx, isFrom, seriesModel, api);
	      data.setItemVisual(idx, {
	        symbolRotate: itemModel.get('symbolRotate'),
	        symbolSize: itemModel.get('symbolSize') || symbolSize[isFrom ? 0 : 1],
	        symbol: itemModel.get('symbol', true) || symbolType[isFrom ? 0 : 1],
	        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color')
	      });
	    }
	
	    lineDraw.__keep = true;
	    lineDraw.group.silent = mlModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} coordSys
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mlModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var fromData = new List(coordDimsInfos, mlModel);
	  var toData = new List(coordDimsInfos, mlModel); // No dimensions
	
	  var lineData = new List([], mlModel);
	  var optData = zrUtil.map(mlModel.get('data'), zrUtil.curry(markLineTransform, seriesModel, coordSys, mlModel));
	
	  if (coordSys) {
	    optData = zrUtil.filter(optData, zrUtil.curry(markLineFilter, coordSys));
	  }
	
	  var dimValueGetter = coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  };
	  fromData.initData(zrUtil.map(optData, function (item) {
	    return item[0];
	  }), null, dimValueGetter);
	  toData.initData(zrUtil.map(optData, function (item) {
	    return item[1];
	  }), null, dimValueGetter);
	  lineData.initData(zrUtil.map(optData, function (item) {
	    return item[2];
	  }));
	  lineData.hasItemOption = true;
	  return {
	    from: fromData,
	    to: toData,
	    line: lineData
	  };
	}
	
	module.exports = _default;

/***/ },
/* 2360 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var MarkerModel = __webpack_require__(508);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = MarkerModel.extend({
	  type: 'markPoint',
	  defaultOption: {
	    zlevel: 0,
	    z: 5,
	    symbol: 'pin',
	    symbolSize: 50,
	    //symbolRotate: 0,
	    //symbolOffset: [0, 0]
	    tooltip: {
	      trigger: 'item'
	    },
	    label: {
	      show: true,
	      position: 'inside'
	    },
	    itemStyle: {
	      borderWidth: 2
	    },
	    emphasis: {
	      label: {
	        show: true
	      }
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2361 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var SymbolDraw = __webpack_require__(287);
	
	var numberUtil = __webpack_require__(25);
	
	var List = __webpack_require__(109);
	
	var markerHelper = __webpack_require__(510);
	
	var MarkerView = __webpack_require__(509);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function updateMarkerLayout(mpData, seriesModel, api) {
	  var coordSys = seriesModel.coordinateSystem;
	  mpData.each(function (idx) {
	    var itemModel = mpData.getItemModel(idx);
	    var point;
	    var xPx = numberUtil.parsePercent(itemModel.get('x'), api.getWidth());
	    var yPx = numberUtil.parsePercent(itemModel.get('y'), api.getHeight());
	
	    if (!isNaN(xPx) && !isNaN(yPx)) {
	      point = [xPx, yPx];
	    } // Chart like bar may have there own marker positioning logic
	    else if (seriesModel.getMarkerPosition) {
	        // Use the getMarkerPoisition
	        point = seriesModel.getMarkerPosition(mpData.getValues(mpData.dimensions, idx));
	      } else if (coordSys) {
	        var x = mpData.get(coordSys.dimensions[0], idx);
	        var y = mpData.get(coordSys.dimensions[1], idx);
	        point = coordSys.dataToPoint([x, y]);
	      } // Use x, y if has any
	
	
	    if (!isNaN(xPx)) {
	      point[0] = xPx;
	    }
	
	    if (!isNaN(yPx)) {
	      point[1] = yPx;
	    }
	
	    mpData.setItemLayout(idx, point);
	  });
	}
	
	var _default = MarkerView.extend({
	  type: 'markPoint',
	  // updateLayout: function (markPointModel, ecModel, api) {
	  //     ecModel.eachSeries(function (seriesModel) {
	  //         var mpModel = seriesModel.markPointModel;
	  //         if (mpModel) {
	  //             updateMarkerLayout(mpModel.getData(), seriesModel, api);
	  //             this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
	  //         }
	  //     }, this);
	  // },
	  updateTransform: function (markPointModel, ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      var mpModel = seriesModel.markPointModel;
	
	      if (mpModel) {
	        updateMarkerLayout(mpModel.getData(), seriesModel, api);
	        this.markerGroupMap.get(seriesModel.id).updateLayout(mpModel);
	      }
	    }, this);
	  },
	  renderSeries: function (seriesModel, mpModel, ecModel, api) {
	    var coordSys = seriesModel.coordinateSystem;
	    var seriesId = seriesModel.id;
	    var seriesData = seriesModel.getData();
	    var symbolDrawMap = this.markerGroupMap;
	    var symbolDraw = symbolDrawMap.get(seriesId) || symbolDrawMap.set(seriesId, new SymbolDraw());
	    var mpData = createList(coordSys, seriesModel, mpModel); // FIXME
	
	    mpModel.setData(mpData);
	    updateMarkerLayout(mpModel.getData(), seriesModel, api);
	    mpData.each(function (idx) {
	      var itemModel = mpData.getItemModel(idx);
	      var symbol = itemModel.getShallow('symbol');
	      var symbolSize = itemModel.getShallow('symbolSize');
	      var symbolRotate = itemModel.getShallow('symbolRotate');
	      var isFnSymbol = zrUtil.isFunction(symbol);
	      var isFnSymbolSize = zrUtil.isFunction(symbolSize);
	      var isFnSymbolRotate = zrUtil.isFunction(symbolRotate);
	
	      if (isFnSymbol || isFnSymbolSize || isFnSymbolRotate) {
	        var rawIdx = mpModel.getRawValue(idx);
	        var dataParams = mpModel.getDataParams(idx);
	
	        if (isFnSymbol) {
	          symbol = symbol(rawIdx, dataParams);
	        }
	
	        if (isFnSymbolSize) {
	          // FIXME 这里不兼容 ECharts 2.x，2.x 貌似参数是整个数据？
	          symbolSize = symbolSize(rawIdx, dataParams);
	        }
	
	        if (isFnSymbolRotate) {
	          symbolRotate = symbolRotate(rawIdx, dataParams);
	        }
	      }
	
	      mpData.setItemVisual(idx, {
	        symbol: symbol,
	        symbolSize: symbolSize,
	        symbolRotate: symbolRotate,
	        color: itemModel.get('itemStyle.color') || seriesData.getVisual('color')
	      });
	    }); // TODO Text are wrong
	
	    symbolDraw.updateData(mpData);
	    this.group.add(symbolDraw.group); // Set host model for tooltip
	    // FIXME
	
	    mpData.eachItemGraphicEl(function (el) {
	      el.traverse(function (child) {
	        child.dataModel = mpModel;
	      });
	    });
	    symbolDraw.__keep = true;
	    symbolDraw.group.silent = mpModel.get('silent') || seriesModel.get('silent');
	  }
	});
	/**
	 * @inner
	 * @param {module:echarts/coord/*} [coordSys]
	 * @param {module:echarts/model/Series} seriesModel
	 * @param {module:echarts/model/Model} mpModel
	 */
	
	
	function createList(coordSys, seriesModel, mpModel) {
	  var coordDimsInfos;
	
	  if (coordSys) {
	    coordDimsInfos = zrUtil.map(coordSys && coordSys.dimensions, function (coordDim) {
	      var info = seriesModel.getData().getDimensionInfo(seriesModel.getData().mapDimension(coordDim)) || {}; // In map series data don't have lng and lat dimension. Fallback to same with coordSys
	
	      return zrUtil.defaults({
	        name: coordDim
	      }, info);
	    });
	  } else {
	    coordDimsInfos = [{
	      name: 'value',
	      type: 'float'
	    }];
	  }
	
	  var mpData = new List(coordDimsInfos, mpModel);
	  var dataOpt = zrUtil.map(mpModel.get('data'), zrUtil.curry(markerHelper.dataTransform, seriesModel));
	
	  if (coordSys) {
	    dataOpt = zrUtil.filter(dataOpt, zrUtil.curry(markerHelper.dataFilter, coordSys));
	  }
	
	  mpData.initData(dataOpt, null, coordSys ? markerHelper.dimValueGetter : function (item) {
	    return item.value;
	  });
	  return mpData;
	}
	
	module.exports = _default;

/***/ },
/* 2362 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(867);
	
	__webpack_require__(2319);
	
	__webpack_require__(2316);

/***/ },
/* 2363 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var barPolar = __webpack_require__(2435);
	
	__webpack_require__(515);
	
	__webpack_require__(2312);
	
	__webpack_require__(2366);
	
	__webpack_require__(289);
	
	__webpack_require__(2322);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// For reducing size of echarts.min, barLayoutPolar is required by polar.
	echarts.registerLayout(zrUtil.curry(barPolar, 'bar')); // Polar view
	
	echarts.extendComponentView({
	  type: 'polar'
	});

/***/ },
/* 2364 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(2426);
	
	__webpack_require__(2427);
	
	__webpack_require__(2365);

/***/ },
/* 2365 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var AxisBuilder = __webpack_require__(177);
	
	var graphic = __webpack_require__(14);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var axisBuilderAttrs = ['axisLine', 'axisTickLabel', 'axisName'];
	
	var _default = echarts.extendComponentView({
	  type: 'radar',
	  render: function (radarModel, ecModel, api) {
	    var group = this.group;
	    group.removeAll();
	
	    this._buildAxes(radarModel);
	
	    this._buildSplitLineAndArea(radarModel);
	  },
	  _buildAxes: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	    var axisBuilders = zrUtil.map(indicatorAxes, function (indicatorAxis) {
	      var axisBuilder = new AxisBuilder(indicatorAxis.model, {
	        position: [radar.cx, radar.cy],
	        rotation: indicatorAxis.angle,
	        labelDirection: -1,
	        tickDirection: -1,
	        nameDirection: 1
	      });
	      return axisBuilder;
	    });
	    zrUtil.each(axisBuilders, function (axisBuilder) {
	      zrUtil.each(axisBuilderAttrs, axisBuilder.add, axisBuilder);
	      this.group.add(axisBuilder.getGroup());
	    }, this);
	  },
	  _buildSplitLineAndArea: function (radarModel) {
	    var radar = radarModel.coordinateSystem;
	    var indicatorAxes = radar.getIndicatorAxes();
	
	    if (!indicatorAxes.length) {
	      return;
	    }
	
	    var shape = radarModel.get('shape');
	    var splitLineModel = radarModel.getModel('splitLine');
	    var splitAreaModel = radarModel.getModel('splitArea');
	    var lineStyleModel = splitLineModel.getModel('lineStyle');
	    var areaStyleModel = splitAreaModel.getModel('areaStyle');
	    var showSplitLine = splitLineModel.get('show');
	    var showSplitArea = splitAreaModel.get('show');
	    var splitLineColors = lineStyleModel.get('color');
	    var splitAreaColors = areaStyleModel.get('color');
	    splitLineColors = zrUtil.isArray(splitLineColors) ? splitLineColors : [splitLineColors];
	    splitAreaColors = zrUtil.isArray(splitAreaColors) ? splitAreaColors : [splitAreaColors];
	    var splitLines = [];
	    var splitAreas = [];
	
	    function getColorIndex(areaOrLine, areaOrLineColorList, idx) {
	      var colorIndex = idx % areaOrLineColorList.length;
	      areaOrLine[colorIndex] = areaOrLine[colorIndex] || [];
	      return colorIndex;
	    }
	
	    if (shape === 'circle') {
	      var ticksRadius = indicatorAxes[0].getTicksCoords();
	      var cx = radar.cx;
	      var cy = radar.cy;
	
	      for (var i = 0; i < ticksRadius.length; i++) {
	        if (showSplitLine) {
	          var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	          splitLines[colorIndex].push(new graphic.Circle({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r: ticksRadius[i].coord
	            }
	          }));
	        }
	
	        if (showSplitArea && i < ticksRadius.length - 1) {
	          var colorIndex = getColorIndex(splitAreas, splitAreaColors, i);
	          splitAreas[colorIndex].push(new graphic.Ring({
	            shape: {
	              cx: cx,
	              cy: cy,
	              r0: ticksRadius[i].coord,
	              r: ticksRadius[i + 1].coord
	            }
	          }));
	        }
	      }
	    } // Polyyon
	    else {
	        var realSplitNumber;
	        var axesTicksPoints = zrUtil.map(indicatorAxes, function (indicatorAxis, idx) {
	          var ticksCoords = indicatorAxis.getTicksCoords();
	          realSplitNumber = realSplitNumber == null ? ticksCoords.length - 1 : Math.min(ticksCoords.length - 1, realSplitNumber);
	          return zrUtil.map(ticksCoords, function (tickCoord) {
	            return radar.coordToPoint(tickCoord.coord, idx);
	          });
	        });
	        var prevPoints = [];
	
	        for (var i = 0; i <= realSplitNumber; i++) {
	          var points = [];
	
	          for (var j = 0; j < indicatorAxes.length; j++) {
	            points.push(axesTicksPoints[j][i]);
	          } // Close
	
	
	          if (points[0]) {
	            points.push(points[0].slice());
	          } else {}
	
	          if (showSplitLine) {
	            var colorIndex = getColorIndex(splitLines, splitLineColors, i);
	            splitLines[colorIndex].push(new graphic.Polyline({
	              shape: {
	                points: points
	              }
	            }));
	          }
	
	          if (showSplitArea && prevPoints) {
	            var colorIndex = getColorIndex(splitAreas, splitAreaColors, i - 1);
	            splitAreas[colorIndex].push(new graphic.Polygon({
	              shape: {
	                points: points.concat(prevPoints)
	              }
	            }));
	          }
	
	          prevPoints = points.slice().reverse();
	        }
	      }
	
	    var lineStyle = lineStyleModel.getLineStyle();
	    var areaStyle = areaStyleModel.getAreaStyle(); // Add splitArea before splitLine
	
	    zrUtil.each(splitAreas, function (splitAreas, idx) {
	      this.group.add(graphic.mergePath(splitAreas, {
	        style: zrUtil.defaults({
	          stroke: 'none',
	          fill: splitAreaColors[idx % splitAreaColors.length]
	        }, areaStyle),
	        silent: true
	      }));
	    }, this);
	    zrUtil.each(splitLines, function (splitLines, idx) {
	      this.group.add(graphic.mergePath(splitLines, {
	        style: zrUtil.defaults({
	          fill: 'none',
	          stroke: splitLineColors[idx % splitLineColors.length]
	        }, lineStyle),
	        silent: true
	      }));
	    }, this);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2366 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(515);
	
	__webpack_require__(2317);

/***/ },
/* 2367 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var preprocessor = __webpack_require__(2373);
	
	__webpack_require__(2375);
	
	__webpack_require__(2374);
	
	__webpack_require__(2368);
	
	__webpack_require__(2369);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * DataZoom component entry
	 */
	echarts.registerPreprocessor(preprocessor);

/***/ },
/* 2368 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var TimelineModel = __webpack_require__(2371);
	
	var dataFormatMixin = __webpack_require__(517);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var SliderTimelineModel = TimelineModel.extend({
	  type: 'timeline.slider',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 时间轴背景颜色
	    borderColor: '#ccc',
	    // 时间轴边框颜色
	    borderWidth: 0,
	    // 时间轴边框线宽，单位px，默认为0（无边框）
	    orient: 'horizontal',
	    // 'vertical'
	    inverse: false,
	    tooltip: {
	      // boolean or Object
	      trigger: 'item' // data item may also have tootip attr.
	
	    },
	    symbol: 'emptyCircle',
	    symbolSize: 10,
	    lineStyle: {
	      show: true,
	      width: 2,
	      color: '#304654'
	    },
	    label: {
	      // 文本标签
	      position: 'auto',
	      // auto left right top bottom
	      // When using number, label position is not
	      // restricted by viewRect.
	      // positive: right/bottom, negative: left/top
	      show: true,
	      interval: 'auto',
	      rotate: 0,
	      // formatter: null,
	      // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	      color: '#304654'
	    },
	    itemStyle: {
	      color: '#304654',
	      borderWidth: 1
	    },
	    checkpointStyle: {
	      symbol: 'circle',
	      symbolSize: 13,
	      color: '#c23531',
	      borderWidth: 5,
	      borderColor: 'rgba(194,53,49, 0.5)',
	      animation: true,
	      animationDuration: 300,
	      animationEasing: 'quinticInOut'
	    },
	    controlStyle: {
	      show: true,
	      showPlayBtn: true,
	      showPrevBtn: true,
	      showNextBtn: true,
	      itemSize: 22,
	      itemGap: 12,
	      position: 'left',
	      // 'left' 'right' 'top' 'bottom'
	      playIcon: 'path://M31.6,53C17.5,53,6,41.5,6,27.4S17.5,1.8,31.6,1.8C45.7,1.8,57.2,13.3,57.2,27.4S45.7,53,31.6,53z M31.6,3.3 C18.4,3.3,7.5,14.1,7.5,27.4c0,13.3,10.8,24.1,24.1,24.1C44.9,51.5,55.7,40.7,55.7,27.4C55.7,14.1,44.9,3.3,31.6,3.3z M24.9,21.3 c0-2.2,1.6-3.1,3.5-2l10.5,6.1c1.899,1.1,1.899,2.9,0,4l-10.5,6.1c-1.9,1.1-3.5,0.2-3.5-2V21.3z',
	      // jshint ignore:line
	      stopIcon: 'path://M30.9,53.2C16.8,53.2,5.3,41.7,5.3,27.6S16.8,2,30.9,2C45,2,56.4,13.5,56.4,27.6S45,53.2,30.9,53.2z M30.9,3.5C17.6,3.5,6.8,14.4,6.8,27.6c0,13.3,10.8,24.1,24.101,24.1C44.2,51.7,55,40.9,55,27.6C54.9,14.4,44.1,3.5,30.9,3.5z M36.9,35.8c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H36c0.5,0,0.9,0.4,0.9,1V35.8z M27.8,35.8 c0,0.601-0.4,1-0.9,1h-1.3c-0.5,0-0.9-0.399-0.9-1V19.5c0-0.6,0.4-1,0.9-1H27c0.5,0,0.9,0.4,0.9,1L27.8,35.8L27.8,35.8z',
	      // jshint ignore:line
	      nextIcon: 'path://M18.6,50.8l22.5-22.5c0.2-0.2,0.3-0.4,0.3-0.7c0-0.3-0.1-0.5-0.3-0.7L18.7,4.4c-0.1-0.1-0.2-0.3-0.2-0.5 c0-0.4,0.3-0.8,0.8-0.8c0.2,0,0.5,0.1,0.6,0.3l23.5,23.5l0,0c0.2,0.2,0.3,0.4,0.3,0.7c0,0.3-0.1,0.5-0.3,0.7l-0.1,0.1L19.7,52 c-0.1,0.1-0.3,0.2-0.5,0.2c-0.4,0-0.8-0.3-0.8-0.8C18.4,51.2,18.5,51,18.6,50.8z',
	      // jshint ignore:line
	      prevIcon: 'path://M43,52.8L20.4,30.3c-0.2-0.2-0.3-0.4-0.3-0.7c0-0.3,0.1-0.5,0.3-0.7L42.9,6.4c0.1-0.1,0.2-0.3,0.2-0.5 c0-0.4-0.3-0.8-0.8-0.8c-0.2,0-0.5,0.1-0.6,0.3L18.3,28.8l0,0c-0.2,0.2-0.3,0.4-0.3,0.7c0,0.3,0.1,0.5,0.3,0.7l0.1,0.1L41.9,54 c0.1,0.1,0.3,0.2,0.5,0.2c0.4,0,0.8-0.3,0.8-0.8C43.2,53.2,43.1,53,43,52.8z',
	      // jshint ignore:line
	      color: '#304654',
	      borderColor: '#304654',
	      borderWidth: 1
	    },
	    emphasis: {
	      label: {
	        show: true,
	        // 其余属性默认使用全局文本样式，详见TEXTSTYLE
	        color: '#c23531'
	      },
	      itemStyle: {
	        color: '#c23531'
	      },
	      controlStyle: {
	        color: '#c23531',
	        borderColor: '#c23531',
	        borderWidth: 2
	      }
	    },
	    data: []
	  }
	});
	zrUtil.mixin(SliderTimelineModel, dataFormatMixin);
	var _default = SliderTimelineModel;
	module.exports = _default;

/***/ },
/* 2369 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var BoundingRect = __webpack_require__(60);
	
	var matrix = __webpack_require__(86);
	
	var graphic = __webpack_require__(14);
	
	var layout = __webpack_require__(46);
	
	var TimelineView = __webpack_require__(2372);
	
	var TimelineAxis = __webpack_require__(2370);
	
	var _symbol = __webpack_require__(110);
	
	var createSymbol = _symbol.createSymbol;
	
	var axisHelper = __webpack_require__(122);
	
	var numberUtil = __webpack_require__(25);
	
	var _format = __webpack_require__(48);
	
	var encodeHTML = _format.encodeHTML;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var PI = Math.PI;
	
	var _default = TimelineView.extend({
	  type: 'timeline.slider',
	  init: function (ecModel, api) {
	    this.api = api;
	    /**
	     * @private
	     * @type {module:echarts/component/timeline/TimelineAxis}
	     */
	
	    this._axis;
	    /**
	     * @private
	     * @type {module:zrender/core/BoundingRect}
	     */
	
	    this._viewRect;
	    /**
	     * @type {number}
	     */
	
	    this._timer;
	    /**
	     * @type {module:zrender/Element}
	     */
	
	    this._currentPointer;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._mainGroup;
	    /**
	     * @type {module:zrender/container/Group}
	     */
	
	    this._labelGroup;
	  },
	
	  /**
	   * @override
	   */
	  render: function (timelineModel, ecModel, api, payload) {
	    this.model = timelineModel;
	    this.api = api;
	    this.ecModel = ecModel;
	    this.group.removeAll();
	
	    if (timelineModel.get('show', true)) {
	      var layoutInfo = this._layout(timelineModel, api);
	
	      var mainGroup = this._createGroup('mainGroup');
	
	      var labelGroup = this._createGroup('labelGroup');
	      /**
	       * @private
	       * @type {module:echarts/component/timeline/TimelineAxis}
	       */
	
	
	      var axis = this._axis = this._createAxis(layoutInfo, timelineModel);
	
	      timelineModel.formatTooltip = function (dataIndex) {
	        return encodeHTML(axis.scale.getLabel(dataIndex));
	      };
	
	      each(['AxisLine', 'AxisTick', 'Control', 'CurrentPointer'], function (name) {
	        this['_render' + name](layoutInfo, mainGroup, axis, timelineModel);
	      }, this);
	
	      this._renderAxisLabel(layoutInfo, labelGroup, axis, timelineModel);
	
	      this._position(layoutInfo, timelineModel);
	    }
	
	    this._doPlayStop();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearTimer();
	
	    this.group.removeAll();
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearTimer();
	  },
	  _layout: function (timelineModel, api) {
	    var labelPosOpt = timelineModel.get('label.position');
	    var orient = timelineModel.get('orient');
	    var viewRect = getViewRect(timelineModel, api); // Auto label offset.
	
	    if (labelPosOpt == null || labelPosOpt === 'auto') {
	      labelPosOpt = orient === 'horizontal' ? viewRect.y + viewRect.height / 2 < api.getHeight() / 2 ? '-' : '+' : viewRect.x + viewRect.width / 2 < api.getWidth() / 2 ? '+' : '-';
	    } else if (isNaN(labelPosOpt)) {
	      labelPosOpt = {
	        horizontal: {
	          top: '-',
	          bottom: '+'
	        },
	        vertical: {
	          left: '-',
	          right: '+'
	        }
	      }[orient][labelPosOpt];
	    }
	
	    var labelAlignMap = {
	      horizontal: 'center',
	      vertical: labelPosOpt >= 0 || labelPosOpt === '+' ? 'left' : 'right'
	    };
	    var labelBaselineMap = {
	      horizontal: labelPosOpt >= 0 || labelPosOpt === '+' ? 'top' : 'bottom',
	      vertical: 'middle'
	    };
	    var rotationMap = {
	      horizontal: 0,
	      vertical: PI / 2
	    }; // Position
	
	    var mainLength = orient === 'vertical' ? viewRect.height : viewRect.width;
	    var controlModel = timelineModel.getModel('controlStyle');
	    var showControl = controlModel.get('show', true);
	    var controlSize = showControl ? controlModel.get('itemSize') : 0;
	    var controlGap = showControl ? controlModel.get('itemGap') : 0;
	    var sizePlusGap = controlSize + controlGap; // Special label rotate.
	
	    var labelRotation = timelineModel.get('label.rotate') || 0;
	    labelRotation = labelRotation * PI / 180; // To radian.
	
	    var playPosition;
	    var prevBtnPosition;
	    var nextBtnPosition;
	    var axisExtent;
	    var controlPosition = controlModel.get('position', true);
	    var showPlayBtn = showControl && controlModel.get('showPlayBtn', true);
	    var showPrevBtn = showControl && controlModel.get('showPrevBtn', true);
	    var showNextBtn = showControl && controlModel.get('showNextBtn', true);
	    var xLeft = 0;
	    var xRight = mainLength; // position[0] means left, position[1] means middle.
	
	    if (controlPosition === 'left' || controlPosition === 'bottom') {
	      showPlayBtn && (playPosition = [0, 0], xLeft += sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [xLeft, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    } else {
	      // 'top' 'right'
	      showPlayBtn && (playPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	      showPrevBtn && (prevBtnPosition = [0, 0], xLeft += sizePlusGap);
	      showNextBtn && (nextBtnPosition = [xRight - controlSize, 0], xRight -= sizePlusGap);
	    }
	
	    axisExtent = [xLeft, xRight];
	
	    if (timelineModel.get('inverse')) {
	      axisExtent.reverse();
	    }
	
	    return {
	      viewRect: viewRect,
	      mainLength: mainLength,
	      orient: orient,
	      rotation: rotationMap[orient],
	      labelRotation: labelRotation,
	      labelPosOpt: labelPosOpt,
	      labelAlign: timelineModel.get('label.align') || labelAlignMap[orient],
	      labelBaseline: timelineModel.get('label.verticalAlign') || timelineModel.get('label.baseline') || labelBaselineMap[orient],
	      // Based on mainGroup.
	      playPosition: playPosition,
	      prevBtnPosition: prevBtnPosition,
	      nextBtnPosition: nextBtnPosition,
	      axisExtent: axisExtent,
	      controlSize: controlSize,
	      controlGap: controlGap
	    };
	  },
	  _position: function (layoutInfo, timelineModel) {
	    // Position is be called finally, because bounding rect is needed for
	    // adapt content to fill viewRect (auto adapt offset).
	    // Timeline may be not all in the viewRect when 'offset' is specified
	    // as a number, because it is more appropriate that label aligns at
	    // 'offset' but not the other edge defined by viewRect.
	    var mainGroup = this._mainGroup;
	    var labelGroup = this._labelGroup;
	    var viewRect = layoutInfo.viewRect;
	
	    if (layoutInfo.orient === 'vertical') {
	      // transform to horizontal, inverse rotate by left-top point.
	      var m = matrix.create();
	      var rotateOriginX = viewRect.x;
	      var rotateOriginY = viewRect.y + viewRect.height;
	      matrix.translate(m, m, [-rotateOriginX, -rotateOriginY]);
	      matrix.rotate(m, m, -PI / 2);
	      matrix.translate(m, m, [rotateOriginX, rotateOriginY]);
	      viewRect = viewRect.clone();
	      viewRect.applyTransform(m);
	    }
	
	    var viewBound = getBound(viewRect);
	    var mainBound = getBound(mainGroup.getBoundingRect());
	    var labelBound = getBound(labelGroup.getBoundingRect());
	    var mainPosition = mainGroup.position;
	    var labelsPosition = labelGroup.position;
	    labelsPosition[0] = mainPosition[0] = viewBound[0][0];
	    var labelPosOpt = layoutInfo.labelPosOpt;
	
	    if (isNaN(labelPosOpt)) {
	      // '+' or '-'
	      var mainBoundIdx = labelPosOpt === '+' ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      toBound(labelsPosition, labelBound, viewBound, 1, 1 - mainBoundIdx);
	    } else {
	      var mainBoundIdx = labelPosOpt >= 0 ? 0 : 1;
	      toBound(mainPosition, mainBound, viewBound, 1, mainBoundIdx);
	      labelsPosition[1] = mainPosition[1] + labelPosOpt;
	    }
	
	    mainGroup.attr('position', mainPosition);
	    labelGroup.attr('position', labelsPosition);
	    mainGroup.rotation = labelGroup.rotation = layoutInfo.rotation;
	    setOrigin(mainGroup);
	    setOrigin(labelGroup);
	
	    function setOrigin(targetGroup) {
	      var pos = targetGroup.position;
	      targetGroup.origin = [viewBound[0][0] - pos[0], viewBound[1][0] - pos[1]];
	    }
	
	    function getBound(rect) {
	      // [[xmin, xmax], [ymin, ymax]]
	      return [[rect.x, rect.x + rect.width], [rect.y, rect.y + rect.height]];
	    }
	
	    function toBound(fromPos, from, to, dimIdx, boundIdx) {
	      fromPos[dimIdx] += to[dimIdx][boundIdx] - from[dimIdx][boundIdx];
	    }
	  },
	  _createAxis: function (layoutInfo, timelineModel) {
	    var data = timelineModel.getData();
	    var axisType = timelineModel.get('axisType');
	    var scale = axisHelper.createScaleByModel(timelineModel, axisType); // Customize scale. The `tickValue` is `dataIndex`.
	
	    scale.getTicks = function () {
	      return data.mapArray(['value'], function (value) {
	        return value;
	      });
	    };
	
	    var dataExtent = data.getDataExtent('value');
	    scale.setExtent(dataExtent[0], dataExtent[1]);
	    scale.niceTicks();
	    var axis = new TimelineAxis('value', scale, layoutInfo.axisExtent, axisType);
	    axis.model = timelineModel;
	    return axis;
	  },
	  _createGroup: function (name) {
	    var newGroup = this['_' + name] = new graphic.Group();
	    this.group.add(newGroup);
	    return newGroup;
	  },
	  _renderAxisLine: function (layoutInfo, group, axis, timelineModel) {
	    var axisExtent = axis.getExtent();
	
	    if (!timelineModel.get('lineStyle.show')) {
	      return;
	    }
	
	    group.add(new graphic.Line({
	      shape: {
	        x1: axisExtent[0],
	        y1: 0,
	        x2: axisExtent[1],
	        y2: 0
	      },
	      style: zrUtil.extend({
	        lineCap: 'round'
	      }, timelineModel.getModel('lineStyle').getLineStyle()),
	      silent: true,
	      z2: 1
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisTick: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData(); // Show all ticks, despite ignoring strategy.
	
	    var ticks = axis.scale.getTicks(); // The value is dataIndex, see the costomized scale.
	
	    each(ticks, function (value) {
	      var tickCoord = axis.dataToCoord(value);
	      var itemModel = data.getItemModel(value);
	      var itemStyleModel = itemModel.getModel('itemStyle');
	      var hoverStyleModel = itemModel.getModel('emphasis.itemStyle');
	      var symbolOpt = {
	        position: [tickCoord, 0],
	        onclick: bind(this._changeTimeline, this, value)
	      };
	      var el = giveSymbol(itemModel, itemStyleModel, group, symbolOpt);
	      graphic.setHoverStyle(el, hoverStyleModel.getItemStyle());
	
	      if (itemModel.get('tooltip')) {
	        el.dataIndex = value;
	        el.dataModel = timelineModel;
	      } else {
	        el.dataIndex = el.dataModel = null;
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderAxisLabel: function (layoutInfo, group, axis, timelineModel) {
	    var labelModel = axis.getLabelModel();
	
	    if (!labelModel.get('show')) {
	      return;
	    }
	
	    var data = timelineModel.getData();
	    var labels = axis.getViewLabels();
	    each(labels, function (labelItem) {
	      // The tickValue is dataIndex, see the costomized scale.
	      var dataIndex = labelItem.tickValue;
	      var itemModel = data.getItemModel(dataIndex);
	      var normalLabelModel = itemModel.getModel('label');
	      var hoverLabelModel = itemModel.getModel('emphasis.label');
	      var tickCoord = axis.dataToCoord(labelItem.tickValue);
	      var textEl = new graphic.Text({
	        position: [tickCoord, 0],
	        rotation: layoutInfo.labelRotation - layoutInfo.rotation,
	        onclick: bind(this._changeTimeline, this, dataIndex),
	        silent: false
	      });
	      graphic.setTextStyle(textEl.style, normalLabelModel, {
	        text: labelItem.formattedLabel,
	        textAlign: layoutInfo.labelAlign,
	        textVerticalAlign: layoutInfo.labelBaseline
	      });
	      group.add(textEl);
	      graphic.setHoverStyle(textEl, graphic.setTextStyle({}, hoverLabelModel));
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _renderControl: function (layoutInfo, group, axis, timelineModel) {
	    var controlSize = layoutInfo.controlSize;
	    var rotation = layoutInfo.rotation;
	    var itemStyle = timelineModel.getModel('controlStyle').getItemStyle();
	    var hoverStyle = timelineModel.getModel('emphasis.controlStyle').getItemStyle();
	    var rect = [0, -controlSize / 2, controlSize, controlSize];
	    var playState = timelineModel.getPlayState();
	    var inverse = timelineModel.get('inverse', true);
	    makeBtn(layoutInfo.nextBtnPosition, 'controlStyle.nextIcon', bind(this._changeTimeline, this, inverse ? '-' : '+'));
	    makeBtn(layoutInfo.prevBtnPosition, 'controlStyle.prevIcon', bind(this._changeTimeline, this, inverse ? '+' : '-'));
	    makeBtn(layoutInfo.playPosition, 'controlStyle.' + (playState ? 'stopIcon' : 'playIcon'), bind(this._handlePlayClick, this, !playState), true);
	
	    function makeBtn(position, iconPath, onclick, willRotate) {
	      if (!position) {
	        return;
	      }
	
	      var opt = {
	        position: position,
	        origin: [controlSize / 2, 0],
	        rotation: willRotate ? -rotation : 0,
	        rectHover: true,
	        style: itemStyle,
	        onclick: onclick
	      };
	      var btn = makeIcon(timelineModel, iconPath, rect, opt);
	      group.add(btn);
	      graphic.setHoverStyle(btn, hoverStyle);
	    }
	  },
	  _renderCurrentPointer: function (layoutInfo, group, axis, timelineModel) {
	    var data = timelineModel.getData();
	    var currentIndex = timelineModel.getCurrentIndex();
	    var pointerModel = data.getItemModel(currentIndex).getModel('checkpointStyle');
	    var me = this;
	    var callback = {
	      onCreate: function (pointer) {
	        pointer.draggable = true;
	        pointer.drift = bind(me._handlePointerDrag, me);
	        pointer.ondragend = bind(me._handlePointerDragend, me);
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel, true);
	      },
	      onUpdate: function (pointer) {
	        pointerMoveTo(pointer, currentIndex, axis, timelineModel);
	      }
	    }; // Reuse when exists, for animation and drag.
	
	    this._currentPointer = giveSymbol(pointerModel, pointerModel, this._mainGroup, {}, this._currentPointer, callback);
	  },
	  _handlePlayClick: function (nextState) {
	    this._clearTimer();
	
	    this.api.dispatchAction({
	      type: 'timelinePlayChange',
	      playState: nextState,
	      from: this.uid
	    });
	  },
	  _handlePointerDrag: function (dx, dy, e) {
	    this._clearTimer();
	
	    this._pointerChangeTimeline([e.offsetX, e.offsetY]);
	  },
	  _handlePointerDragend: function (e) {
	    this._pointerChangeTimeline([e.offsetX, e.offsetY], true);
	  },
	  _pointerChangeTimeline: function (mousePos, trigger) {
	    var toCoord = this._toAxisCoord(mousePos)[0];
	
	    var axis = this._axis;
	    var axisExtent = numberUtil.asc(axis.getExtent().slice());
	    toCoord > axisExtent[1] && (toCoord = axisExtent[1]);
	    toCoord < axisExtent[0] && (toCoord = axisExtent[0]);
	    this._currentPointer.position[0] = toCoord;
	
	    this._currentPointer.dirty();
	
	    var targetDataIndex = this._findNearestTick(toCoord);
	
	    var timelineModel = this.model;
	
	    if (trigger || targetDataIndex !== timelineModel.getCurrentIndex() && timelineModel.get('realtime')) {
	      this._changeTimeline(targetDataIndex);
	    }
	  },
	  _doPlayStop: function () {
	    this._clearTimer();
	
	    if (this.model.getPlayState()) {
	      this._timer = setTimeout(bind(handleFrame, this), this.model.get('playInterval'));
	    }
	
	    function handleFrame() {
	      // Do not cache
	      var timelineModel = this.model;
	
	      this._changeTimeline(timelineModel.getCurrentIndex() + (timelineModel.get('rewind', true) ? -1 : 1));
	    }
	  },
	  _toAxisCoord: function (vertex) {
	    var trans = this._mainGroup.getLocalTransform();
	
	    return graphic.applyTransform(vertex, trans, true);
	  },
	  _findNearestTick: function (axisCoord) {
	    var data = this.model.getData();
	    var dist = Infinity;
	    var targetDataIndex;
	    var axis = this._axis;
	    data.each(['value'], function (value, dataIndex) {
	      var coord = axis.dataToCoord(value);
	      var d = Math.abs(coord - axisCoord);
	
	      if (d < dist) {
	        dist = d;
	        targetDataIndex = dataIndex;
	      }
	    });
	    return targetDataIndex;
	  },
	  _clearTimer: function () {
	    if (this._timer) {
	      clearTimeout(this._timer);
	      this._timer = null;
	    }
	  },
	  _changeTimeline: function (nextIndex) {
	    var currentIndex = this.model.getCurrentIndex();
	
	    if (nextIndex === '+') {
	      nextIndex = currentIndex + 1;
	    } else if (nextIndex === '-') {
	      nextIndex = currentIndex - 1;
	    }
	
	    this.api.dispatchAction({
	      type: 'timelineChange',
	      currentIndex: nextIndex,
	      from: this.uid
	    });
	  }
	});
	
	function getViewRect(model, api) {
	  return layout.getLayoutRect(model.getBoxLayoutParams(), {
	    width: api.getWidth(),
	    height: api.getHeight()
	  }, model.get('padding'));
	}
	
	function makeIcon(timelineModel, objPath, rect, opts) {
	  var style = opts.style;
	  var icon = graphic.createIcon(timelineModel.get(objPath), opts || {}, new BoundingRect(rect[0], rect[1], rect[2], rect[3])); // TODO createIcon won't use style in opt.
	
	  if (style) {
	    icon.setStyle(style);
	  }
	
	  return icon;
	}
	/**
	 * Create symbol or update symbol
	 * opt: basic position and event handlers
	 */
	
	
	function giveSymbol(hostModel, itemStyleModel, group, opt, symbol, callback) {
	  var color = itemStyleModel.get('color');
	
	  if (!symbol) {
	    var symbolType = hostModel.get('symbol');
	    symbol = createSymbol(symbolType, -1, -1, 2, 2, color);
	    symbol.setStyle('strokeNoScale', true);
	    group.add(symbol);
	    callback && callback.onCreate(symbol);
	  } else {
	    symbol.setColor(color);
	    group.add(symbol); // Group may be new, also need to add.
	
	    callback && callback.onUpdate(symbol);
	  } // Style
	
	
	  var itemStyle = itemStyleModel.getItemStyle(['color', 'symbol', 'symbolSize']);
	  symbol.setStyle(itemStyle); // Transform and events.
	
	  opt = zrUtil.merge({
	    rectHover: true,
	    z2: 100
	  }, opt, true);
	  var symbolSize = hostModel.get('symbolSize');
	  symbolSize = symbolSize instanceof Array ? symbolSize.slice() : [+symbolSize, +symbolSize];
	  symbolSize[0] /= 2;
	  symbolSize[1] /= 2;
	  opt.scale = symbolSize;
	  var symbolOffset = hostModel.get('symbolOffset');
	
	  if (symbolOffset) {
	    var pos = opt.position = opt.position || [0, 0];
	    pos[0] += numberUtil.parsePercent(symbolOffset[0], symbolSize[0]);
	    pos[1] += numberUtil.parsePercent(symbolOffset[1], symbolSize[1]);
	  }
	
	  var symbolRotate = hostModel.get('symbolRotate');
	  opt.rotation = (symbolRotate || 0) * Math.PI / 180 || 0;
	  symbol.attr(opt); // FIXME
	  // (1) When symbol.style.strokeNoScale is true and updateTransform is not performed,
	  // getBoundingRect will return wrong result.
	  // (This is supposed to be resolved in zrender, but it is a little difficult to
	  // leverage performance and auto updateTransform)
	  // (2) All of ancesters of symbol do not scale, so we can just updateTransform symbol.
	
	  symbol.updateTransform();
	  return symbol;
	}
	
	function pointerMoveTo(pointer, dataIndex, axis, timelineModel, noAnimation) {
	  if (pointer.dragging) {
	    return;
	  }
	
	  var pointerModel = timelineModel.getModel('checkpointStyle');
	  var toCoord = axis.dataToCoord(timelineModel.getData().get(['value'], dataIndex));
	
	  if (noAnimation || !pointerModel.get('animation', true)) {
	    pointer.attr({
	      position: [toCoord, 0]
	    });
	  } else {
	    pointer.stopAnimation(true);
	    pointer.animateTo({
	      position: [toCoord, 0]
	    }, pointerModel.get('animationDuration', true), pointerModel.get('animationEasing', true));
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2370 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Axis = __webpack_require__(179);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var TimelineAxis = function (dim, scale, coordExtent, axisType) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis model
	   * @param {module:echarts/component/TimelineModel}
	   */
	
	  this.model = null;
	};
	
	TimelineAxis.prototype = {
	  constructor: TimelineAxis,
	
	  /**
	   * @override
	   */
	  getLabelModel: function () {
	    return this.model.getModel('label');
	  },
	
	  /**
	   * @override
	   */
	  isHorizontal: function () {
	    return this.model.get('orient') === 'horizontal';
	  }
	};
	zrUtil.inherits(TimelineAxis, Axis);
	var _default = TimelineAxis;
	module.exports = _default;

/***/ },
/* 2371 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var ComponentModel = __webpack_require__(76);
	
	var List = __webpack_require__(109);
	
	var modelUtil = __webpack_require__(29);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var TimelineModel = ComponentModel.extend({
	  type: 'timeline',
	  layoutMode: 'box',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    zlevel: 0,
	    // 一级层叠
	    z: 4,
	    // 二级层叠
	    show: true,
	    axisType: 'time',
	    // 模式是时间类型，支持 value, category
	    realtime: true,
	    left: '20%',
	    top: null,
	    right: '20%',
	    bottom: 0,
	    width: null,
	    height: 40,
	    padding: 5,
	    controlPosition: 'left',
	    // 'left' 'right' 'top' 'bottom' 'none'
	    autoPlay: false,
	    rewind: false,
	    // 反向播放
	    loop: true,
	    playInterval: 2000,
	    // 播放时间间隔，单位ms
	    currentIndex: 0,
	    itemStyle: {},
	    label: {
	      color: '#000'
	    },
	    data: []
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel) {
	    /**
	     * @private
	     * @type {module:echarts/data/List}
	     */
	    this._data;
	    /**
	     * @private
	     * @type {Array.<string>}
	     */
	
	    this._names;
	    this.mergeDefaultAndTheme(option, ecModel);
	
	    this._initData();
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option) {
	    TimelineModel.superApply(this, 'mergeOption', arguments);
	
	    this._initData();
	  },
	
	  /**
	   * @param {number} [currentIndex]
	   */
	  setCurrentIndex: function (currentIndex) {
	    if (currentIndex == null) {
	      currentIndex = this.option.currentIndex;
	    }
	
	    var count = this._data.count();
	
	    if (this.option.loop) {
	      currentIndex = (currentIndex % count + count) % count;
	    } else {
	      currentIndex >= count && (currentIndex = count - 1);
	      currentIndex < 0 && (currentIndex = 0);
	    }
	
	    this.option.currentIndex = currentIndex;
	  },
	
	  /**
	   * @return {number} currentIndex
	   */
	  getCurrentIndex: function () {
	    return this.option.currentIndex;
	  },
	
	  /**
	   * @return {boolean}
	   */
	  isIndexMax: function () {
	    return this.getCurrentIndex() >= this._data.count() - 1;
	  },
	
	  /**
	   * @param {boolean} state true: play, false: stop
	   */
	  setPlayState: function (state) {
	    this.option.autoPlay = !!state;
	  },
	
	  /**
	   * @return {boolean} true: play, false: stop
	   */
	  getPlayState: function () {
	    return !!this.option.autoPlay;
	  },
	
	  /**
	   * @private
	   */
	  _initData: function () {
	    var thisOption = this.option;
	    var dataArr = thisOption.data || [];
	    var axisType = thisOption.axisType;
	    var names = this._names = [];
	
	    if (axisType === 'category') {
	      var idxArr = [];
	      zrUtil.each(dataArr, function (item, index) {
	        var value = modelUtil.getDataItemValue(item);
	        var newItem;
	
	        if (zrUtil.isObject(item)) {
	          newItem = zrUtil.clone(item);
	          newItem.value = index;
	        } else {
	          newItem = index;
	        }
	
	        idxArr.push(newItem);
	
	        if (!zrUtil.isString(value) && (value == null || isNaN(value))) {
	          value = '';
	        }
	
	        names.push(value + '');
	      });
	      dataArr = idxArr;
	    }
	
	    var dimType = {
	      category: 'ordinal',
	      time: 'time'
	    }[axisType] || 'number';
	    var data = this._data = new List([{
	      name: 'value',
	      type: dimType
	    }], this);
	    data.initData(dataArr, names);
	  },
	  getData: function () {
	    return this._data;
	  },
	
	  /**
	   * @public
	   * @return {Array.<string>} categoreis
	   */
	  getCategories: function () {
	    if (this.get('axisType') === 'category') {
	      return this._names.slice();
	    }
	  }
	});
	var _default = TimelineModel;
	module.exports = _default;

/***/ },
/* 2372 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var ComponentView = __webpack_require__(362);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = ComponentView.extend({
	  type: 'timeline'
	});
	
	module.exports = _default;

/***/ },
/* 2373 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  var timelineOpt = option && option.timeline;
	
	  if (!zrUtil.isArray(timelineOpt)) {
	    timelineOpt = timelineOpt ? [timelineOpt] : [];
	  }
	
	  zrUtil.each(timelineOpt, function (opt) {
	    if (!opt) {
	      return;
	    }
	
	    compatibleEC2(opt);
	  });
	}
	
	function compatibleEC2(opt) {
	  var type = opt.type;
	  var ec2Types = {
	    'number': 'value',
	    'time': 'time'
	  }; // Compatible with ec2
	
	  if (ec2Types[type]) {
	    opt.axisType = ec2Types[type];
	    delete opt.type;
	  }
	
	  transferItem(opt);
	
	  if (has(opt, 'controlPosition')) {
	    var controlStyle = opt.controlStyle || (opt.controlStyle = {});
	
	    if (!has(controlStyle, 'position')) {
	      controlStyle.position = opt.controlPosition;
	    }
	
	    if (controlStyle.position === 'none' && !has(controlStyle, 'show')) {
	      controlStyle.show = false;
	      delete controlStyle.position;
	    }
	
	    delete opt.controlPosition;
	  }
	
	  zrUtil.each(opt.data || [], function (dataItem) {
	    if (zrUtil.isObject(dataItem) && !zrUtil.isArray(dataItem)) {
	      if (!has(dataItem, 'value') && has(dataItem, 'name')) {
	        // In ec2, using name as value.
	        dataItem.value = dataItem.name;
	      }
	
	      transferItem(dataItem);
	    }
	  });
	}
	
	function transferItem(opt) {
	  var itemStyle = opt.itemStyle || (opt.itemStyle = {});
	  var itemStyleEmphasis = itemStyle.emphasis || (itemStyle.emphasis = {}); // Transfer label out
	
	  var label = opt.label || opt.label || {};
	  var labelNormal = label.normal || (label.normal = {});
	  var excludeLabelAttr = {
	    normal: 1,
	    emphasis: 1
	  };
	  zrUtil.each(label, function (value, name) {
	    if (!excludeLabelAttr[name] && !has(labelNormal, name)) {
	      labelNormal[name] = value;
	    }
	  });
	
	  if (itemStyleEmphasis.label && !has(label, 'emphasis')) {
	    label.emphasis = itemStyleEmphasis.label;
	    delete itemStyleEmphasis.label;
	  }
	}
	
	function has(obj, attr) {
	  return obj.hasOwnProperty(attr);
	}
	
	module.exports = _default;

/***/ },
/* 2374 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	echarts.registerAction({
	  type: 'timelineChange',
	  event: 'timelineChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.currentIndex != null) {
	    timelineModel.setCurrentIndex(payload.currentIndex);
	
	    if (!timelineModel.get('loop', true) && timelineModel.isIndexMax()) {
	      timelineModel.setPlayState(false);
	    }
	  } // Set normalized currentIndex to payload.
	
	
	  ecModel.resetOption('timeline');
	  return zrUtil.defaults({
	    currentIndex: timelineModel.option.currentIndex
	  }, payload);
	});
	echarts.registerAction({
	  type: 'timelinePlayChange',
	  event: 'timelinePlayChanged',
	  update: 'update'
	}, function (payload, ecModel) {
	  var timelineModel = ecModel.getComponent('timeline');
	
	  if (timelineModel && payload.playState != null) {
	    timelineModel.setPlayState(payload.playState);
	  }
	});

/***/ },
/* 2375 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Component = __webpack_require__(76);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	Component.registerSubTypeDefaulter('timeline', function () {
	  // Only slider now.
	  return 'slider';
	});

/***/ },
/* 2376 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var echarts = __webpack_require__(10);
	
	var graphic = __webpack_require__(14);
	
	var _layout = __webpack_require__(46);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _format = __webpack_require__(48);
	
	var windowOpen = _format.windowOpen;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Model
	echarts.extendComponentModel({
	  type: 'title',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  defaultOption: {
	    // 一级层叠
	    zlevel: 0,
	    // 二级层叠
	    z: 6,
	    show: true,
	    text: '',
	    // 超链接跳转
	    // link: null,
	    // 仅支持self | blank
	    target: 'blank',
	    subtext: '',
	    // 超链接跳转
	    // sublink: null,
	    // 仅支持self | blank
	    subtarget: 'blank',
	    // 'center' ¦ 'left' ¦ 'right'
	    // ¦ {number}（x坐标，单位px）
	    left: 0,
	    // 'top' ¦ 'bottom' ¦ 'center'
	    // ¦ {number}（y坐标，单位px）
	    top: 0,
	    // 水平对齐
	    // 'auto' | 'left' | 'right' | 'center'
	    // 默认根据 left 的位置判断是左对齐还是右对齐
	    // textAlign: null
	    //
	    // 垂直对齐
	    // 'auto' | 'top' | 'bottom' | 'middle'
	    // 默认根据 top 位置判断是上对齐还是下对齐
	    // textVerticalAlign: null
	    // textBaseline: null // The same as textVerticalAlign.
	    backgroundColor: 'rgba(0,0,0,0)',
	    // 标题边框颜色
	    borderColor: '#ccc',
	    // 标题边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 标题内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // 主副标题纵向间隔，单位px，默认为10，
	    itemGap: 10,
	    textStyle: {
	      fontSize: 18,
	      fontWeight: 'bolder',
	      color: '#333'
	    },
	    subtextStyle: {
	      color: '#aaa'
	    }
	  }
	}); // View
	
	echarts.extendComponentView({
	  type: 'title',
	  render: function (titleModel, ecModel, api) {
	    this.group.removeAll();
	
	    if (!titleModel.get('show')) {
	      return;
	    }
	
	    var group = this.group;
	    var textStyleModel = titleModel.getModel('textStyle');
	    var subtextStyleModel = titleModel.getModel('subtextStyle');
	    var textAlign = titleModel.get('textAlign');
	    var textVerticalAlign = zrUtil.retrieve2(titleModel.get('textBaseline'), titleModel.get('textVerticalAlign'));
	    var textEl = new graphic.Text({
	      style: graphic.setTextStyle({}, textStyleModel, {
	        text: titleModel.get('text'),
	        textFill: textStyleModel.getTextColor()
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var textRect = textEl.getBoundingRect();
	    var subText = titleModel.get('subtext');
	    var subTextEl = new graphic.Text({
	      style: graphic.setTextStyle({}, subtextStyleModel, {
	        text: subText,
	        textFill: subtextStyleModel.getTextColor(),
	        y: textRect.height + titleModel.get('itemGap'),
	        textVerticalAlign: 'top'
	      }, {
	        disableBox: true
	      }),
	      z2: 10
	    });
	    var link = titleModel.get('link');
	    var sublink = titleModel.get('sublink');
	    var triggerEvent = titleModel.get('triggerEvent', true);
	    textEl.silent = !link && !triggerEvent;
	    subTextEl.silent = !sublink && !triggerEvent;
	
	    if (link) {
	      textEl.on('click', function () {
	        windowOpen(link, '_' + titleModel.get('target'));
	      });
	    }
	
	    if (sublink) {
	      subTextEl.on('click', function () {
	        windowOpen(sublink, '_' + titleModel.get('subtarget'));
	      });
	    }
	
	    textEl.eventData = subTextEl.eventData = triggerEvent ? {
	      componentType: 'title',
	      componentIndex: titleModel.componentIndex
	    } : null;
	    group.add(textEl);
	    subText && group.add(subTextEl); // If no subText, but add subTextEl, there will be an empty line.
	
	    var groupRect = group.getBoundingRect();
	    var layoutOption = titleModel.getBoxLayoutParams();
	    layoutOption.width = groupRect.width;
	    layoutOption.height = groupRect.height;
	    var layoutRect = getLayoutRect(layoutOption, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    }, titleModel.get('padding')); // Adjust text align based on position
	
	    if (!textAlign) {
	      // Align left if title is on the left. center and right is same
	      textAlign = titleModel.get('left') || titleModel.get('right');
	
	      if (textAlign === 'middle') {
	        textAlign = 'center';
	      } // Adjust layout by text align
	
	
	      if (textAlign === 'right') {
	        layoutRect.x += layoutRect.width;
	      } else if (textAlign === 'center') {
	        layoutRect.x += layoutRect.width / 2;
	      }
	    }
	
	    if (!textVerticalAlign) {
	      textVerticalAlign = titleModel.get('top') || titleModel.get('bottom');
	
	      if (textVerticalAlign === 'center') {
	        textVerticalAlign = 'middle';
	      }
	
	      if (textVerticalAlign === 'bottom') {
	        layoutRect.y += layoutRect.height;
	      } else if (textVerticalAlign === 'middle') {
	        layoutRect.y += layoutRect.height / 2;
	      }
	
	      textVerticalAlign = textVerticalAlign || 'top';
	    }
	
	    group.attr('position', [layoutRect.x, layoutRect.y]);
	    var alignStyle = {
	      textAlign: textAlign,
	      textVerticalAlign: textVerticalAlign
	    };
	    textEl.setStyle(alignStyle);
	    subTextEl.setStyle(alignStyle); // Render background
	    // Get groupRect again because textAlign has been changed
	
	    groupRect = group.getBoundingRect();
	    var padding = layoutRect.margin;
	    var style = titleModel.getItemStyle(['color', 'opacity']);
	    style.fill = titleModel.get('backgroundColor');
	    var rect = new graphic.Rect({
	      shape: {
	        x: groupRect.x - padding[3],
	        y: groupRect.y - padding[0],
	        width: groupRect.width + padding[1] + padding[3],
	        height: groupRect.height + padding[0] + padding[2],
	        r: titleModel.get('borderRadius')
	      },
	      style: style,
	      subPixelOptimize: true,
	      silent: true
	    });
	    group.add(rect);
	  }
	});

/***/ },
/* 2377 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(2378);
	
	__webpack_require__(2379);
	
	__webpack_require__(2385);
	
	__webpack_require__(2383);
	
	__webpack_require__(2381);
	
	__webpack_require__(2382);
	
	__webpack_require__(2384);

/***/ },
/* 2378 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var featureManager = __webpack_require__(178);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var ToolboxModel = echarts.extendComponentModel({
	  type: 'toolbox',
	  layoutMode: {
	    type: 'box',
	    ignoreSize: true
	  },
	  optionUpdated: function () {
	    ToolboxModel.superApply(this, 'optionUpdated', arguments);
	    zrUtil.each(this.option.feature, function (featureOpt, featureName) {
	      var Feature = featureManager.get(featureName);
	      Feature && zrUtil.merge(featureOpt, Feature.defaultOption);
	    });
	  },
	  defaultOption: {
	    show: true,
	    z: 6,
	    zlevel: 0,
	    orient: 'horizontal',
	    left: 'right',
	    top: 'top',
	    // right
	    // bottom
	    backgroundColor: 'transparent',
	    borderColor: '#ccc',
	    borderRadius: 0,
	    borderWidth: 0,
	    padding: 5,
	    itemSize: 15,
	    itemGap: 8,
	    showTitle: true,
	    iconStyle: {
	      borderColor: '#666',
	      color: 'none'
	    },
	    emphasis: {
	      iconStyle: {
	        borderColor: '#3E98C5'
	      }
	    },
	    // textStyle: {},
	    // feature
	    tooltip: {
	      show: false
	    }
	  }
	});
	var _default = ToolboxModel;
	module.exports = _default;

/***/ },
/* 2379 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var textContain = __webpack_require__(102);
	
	var featureManager = __webpack_require__(178);
	
	var graphic = __webpack_require__(14);
	
	var Model = __webpack_require__(70);
	
	var DataDiffer = __webpack_require__(211);
	
	var listComponentHelper = __webpack_require__(847);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentView({
	  type: 'toolbox',
	  render: function (toolboxModel, ecModel, api, payload) {
	    var group = this.group;
	    group.removeAll();
	
	    if (!toolboxModel.get('show')) {
	      return;
	    }
	
	    var itemSize = +toolboxModel.get('itemSize');
	    var featureOpts = toolboxModel.get('feature') || {};
	    var features = this._features || (this._features = {});
	    var featureNames = [];
	    zrUtil.each(featureOpts, function (opt, name) {
	      featureNames.push(name);
	    });
	    new DataDiffer(this._featureNames || [], featureNames).add(processFeature).update(processFeature).remove(zrUtil.curry(processFeature, null)).execute(); // Keep for diff.
	
	    this._featureNames = featureNames;
	
	    function processFeature(newIndex, oldIndex) {
	      var featureName = featureNames[newIndex];
	      var oldName = featureNames[oldIndex];
	      var featureOpt = featureOpts[featureName];
	      var featureModel = new Model(featureOpt, toolboxModel, toolboxModel.ecModel);
	      var feature; // FIX#11236, merge feature title from MagicType newOption. TODO: consider seriesIndex ?
	
	      if (payload && payload.newTitle != null && payload.featureName === featureName) {
	        featureOpt.title = payload.newTitle;
	      }
	
	      if (featureName && !oldName) {
	        // Create
	        if (isUserFeatureName(featureName)) {
	          feature = {
	            model: featureModel,
	            onclick: featureModel.option.onclick,
	            featureName: featureName
	          };
	        } else {
	          var Feature = featureManager.get(featureName);
	
	          if (!Feature) {
	            return;
	          }
	
	          feature = new Feature(featureModel, ecModel, api);
	        }
	
	        features[featureName] = feature;
	      } else {
	        feature = features[oldName]; // If feature does not exsit.
	
	        if (!feature) {
	          return;
	        }
	
	        feature.model = featureModel;
	        feature.ecModel = ecModel;
	        feature.api = api;
	      }
	
	      if (!featureName && oldName) {
	        feature.dispose && feature.dispose(ecModel, api);
	        return;
	      }
	
	      if (!featureModel.get('show') || feature.unusable) {
	        feature.remove && feature.remove(ecModel, api);
	        return;
	      }
	
	      createIconPaths(featureModel, feature, featureName);
	
	      featureModel.setIconStatus = function (iconName, status) {
	        var option = this.option;
	        var iconPaths = this.iconPaths;
	        option.iconStatus = option.iconStatus || {};
	        option.iconStatus[iconName] = status; // FIXME
	
	        iconPaths[iconName] && iconPaths[iconName].trigger(status);
	      };
	
	      if (feature.render) {
	        feature.render(featureModel, ecModel, api, payload);
	      }
	    }
	
	    function createIconPaths(featureModel, feature, featureName) {
	      var iconStyleModel = featureModel.getModel('iconStyle');
	      var iconStyleEmphasisModel = featureModel.getModel('emphasis.iconStyle'); // If one feature has mutiple icon. they are orginaized as
	      // {
	      //     icon: {
	      //         foo: '',
	      //         bar: ''
	      //     },
	      //     title: {
	      //         foo: '',
	      //         bar: ''
	      //     }
	      // }
	
	      var icons = feature.getIcons ? feature.getIcons() : featureModel.get('icon');
	      var titles = featureModel.get('title') || {};
	
	      if (typeof icons === 'string') {
	        var icon = icons;
	        var title = titles;
	        icons = {};
	        titles = {};
	        icons[featureName] = icon;
	        titles[featureName] = title;
	      }
	
	      var iconPaths = featureModel.iconPaths = {};
	      zrUtil.each(icons, function (iconStr, iconName) {
	        var path = graphic.createIcon(iconStr, {}, {
	          x: -itemSize / 2,
	          y: -itemSize / 2,
	          width: itemSize,
	          height: itemSize
	        });
	        path.setStyle(iconStyleModel.getItemStyle());
	        path.hoverStyle = iconStyleEmphasisModel.getItemStyle(); // Text position calculation
	
	        path.setStyle({
	          text: titles[iconName],
	          textAlign: iconStyleEmphasisModel.get('textAlign'),
	          textBorderRadius: iconStyleEmphasisModel.get('textBorderRadius'),
	          textPadding: iconStyleEmphasisModel.get('textPadding'),
	          textFill: null
	        });
	        var tooltipModel = toolboxModel.getModel('tooltip');
	
	        if (tooltipModel && tooltipModel.get('show')) {
	          path.attr('tooltip', zrUtil.extend({
	            content: titles[iconName],
	            formatter: tooltipModel.get('formatter', true) || function () {
	              return titles[iconName];
	            },
	            formatterParams: {
	              componentType: 'toolbox',
	              name: iconName,
	              title: titles[iconName],
	              $vars: ['name', 'title']
	            },
	            position: tooltipModel.get('position', true) || 'bottom'
	          }, tooltipModel.option));
	        }
	
	        graphic.setHoverStyle(path);
	
	        if (toolboxModel.get('showTitle')) {
	          path.__title = titles[iconName];
	          path.on('mouseover', function () {
	            // Should not reuse above hoverStyle, which might be modified.
	            var hoverStyle = iconStyleEmphasisModel.getItemStyle();
	            var defaultTextPosition = toolboxModel.get('orient') === 'vertical' ? toolboxModel.get('right') == null ? 'right' : 'left' : toolboxModel.get('bottom') == null ? 'bottom' : 'top';
	            path.setStyle({
	              textFill: iconStyleEmphasisModel.get('textFill') || hoverStyle.fill || hoverStyle.stroke || '#000',
	              textBackgroundColor: iconStyleEmphasisModel.get('textBackgroundColor'),
	              textPosition: iconStyleEmphasisModel.get('textPosition') || defaultTextPosition
	            });
	          }).on('mouseout', function () {
	            path.setStyle({
	              textFill: null,
	              textBackgroundColor: null
	            });
	          });
	        }
	
	        path.trigger(featureModel.get('iconStatus.' + iconName) || 'normal');
	        group.add(path);
	        path.on('click', zrUtil.bind(feature.onclick, feature, ecModel, api, iconName));
	        iconPaths[iconName] = path;
	      });
	    }
	
	    listComponentHelper.layout(group, toolboxModel, api); // Render background after group is layout
	    // FIXME
	
	    group.add(listComponentHelper.makeBackground(group.getBoundingRect(), toolboxModel)); // Adjust icon title positions to avoid them out of screen
	
	    group.eachChild(function (icon) {
	      var titleText = icon.__title;
	      var hoverStyle = icon.hoverStyle; // May be background element
	
	      if (hoverStyle && titleText) {
	        var rect = textContain.getBoundingRect(titleText, textContain.makeFont(hoverStyle));
	        var offsetX = icon.position[0] + group.position[0];
	        var offsetY = icon.position[1] + group.position[1] + itemSize;
	        var needPutOnTop = false;
	
	        if (offsetY + rect.height > api.getHeight()) {
	          hoverStyle.textPosition = 'top';
	          needPutOnTop = true;
	        }
	
	        var topOffset = needPutOnTop ? -5 - rect.height : itemSize + 8;
	
	        if (offsetX + rect.width / 2 > api.getWidth()) {
	          hoverStyle.textPosition = ['100%', topOffset];
	          hoverStyle.textAlign = 'right';
	        } else if (offsetX - rect.width / 2 < 0) {
	          hoverStyle.textPosition = [0, topOffset];
	          hoverStyle.textAlign = 'left';
	        }
	      }
	    });
	  },
	  updateView: function (toolboxModel, ecModel, api, payload) {
	    zrUtil.each(this._features, function (feature) {
	      feature.updateView && feature.updateView(feature.model, ecModel, api, payload);
	    });
	  },
	  // updateLayout: function (toolboxModel, ecModel, api, payload) {
	  //     zrUtil.each(this._features, function (feature) {
	  //         feature.updateLayout && feature.updateLayout(feature.model, ecModel, api, payload);
	  //     });
	  // },
	  remove: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.remove && feature.remove(ecModel, api);
	    });
	    this.group.removeAll();
	  },
	  dispose: function (ecModel, api) {
	    zrUtil.each(this._features, function (feature) {
	      feature.dispose && feature.dispose(ecModel, api);
	    });
	  }
	});
	
	function isUserFeatureName(featureName) {
	  return featureName.indexOf('my') === 0;
	}
	
	module.exports = _default;

/***/ },
/* 2380 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var featureManager = __webpack_require__(178);
	
	var lang = __webpack_require__(180);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var brushLang = lang.toolbox.brush;
	
	function Brush(model, ecModel, api) {
	  this.model = model;
	  this.ecModel = ecModel;
	  this.api = api;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushType;
	  /**
	   * @private
	   * @type {string}
	   */
	
	  this._brushMode;
	}
	
	Brush.defaultOption = {
	  show: true,
	  type: ['rect', 'polygon', 'lineX', 'lineY', 'keep', 'clear'],
	  icon: {
	    /* eslint-disable */
	    rect: 'M7.3,34.7 M0.4,10V-0.2h9.8 M89.6,10V-0.2h-9.8 M0.4,60v10.2h9.8 M89.6,60v10.2h-9.8 M12.3,22.4V10.5h13.1 M33.6,10.5h7.8 M49.1,10.5h7.8 M77.5,22.4V10.5h-13 M12.3,31.1v8.2 M77.7,31.1v8.2 M12.3,47.6v11.9h13.1 M33.6,59.5h7.6 M49.1,59.5 h7.7 M77.5,47.6v11.9h-13',
	    // jshint ignore:line
	    polygon: 'M55.2,34.9c1.7,0,3.1,1.4,3.1,3.1s-1.4,3.1-3.1,3.1 s-3.1-1.4-3.1-3.1S53.5,34.9,55.2,34.9z M50.4,51c1.7,0,3.1,1.4,3.1,3.1c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1 C47.3,52.4,48.7,51,50.4,51z M55.6,37.1l1.5-7.8 M60.1,13.5l1.6-8.7l-7.8,4 M59,19l-1,5.3 M24,16.1l6.4,4.9l6.4-3.3 M48.5,11.6 l-5.9,3.1 M19.1,12.8L9.7,5.1l1.1,7.7 M13.4,29.8l1,7.3l6.6,1.6 M11.6,18.4l1,6.1 M32.8,41.9 M26.6,40.4 M27.3,40.2l6.1,1.6 M49.9,52.1l-5.6-7.6l-4.9-1.2',
	    // jshint ignore:line
	    lineX: 'M15.2,30 M19.7,15.6V1.9H29 M34.8,1.9H40.4 M55.3,15.6V1.9H45.9 M19.7,44.4V58.1H29 M34.8,58.1H40.4 M55.3,44.4 V58.1H45.9 M12.5,20.3l-9.4,9.6l9.6,9.8 M3.1,29.9h16.5 M62.5,20.3l9.4,9.6L62.3,39.7 M71.9,29.9H55.4',
	    // jshint ignore:line
	    lineY: 'M38.8,7.7 M52.7,12h13.2v9 M65.9,26.6V32 M52.7,46.3h13.2v-9 M24.9,12H11.8v9 M11.8,26.6V32 M24.9,46.3H11.8v-9 M48.2,5.1l-9.3-9l-9.4,9.2 M38.9-3.9V12 M48.2,53.3l-9.3,9l-9.4-9.2 M38.9,62.3V46.4',
	    // jshint ignore:line
	    keep: 'M4,10.5V1h10.3 M20.7,1h6.1 M33,1h6.1 M55.4,10.5V1H45.2 M4,17.3v6.6 M55.6,17.3v6.6 M4,30.5V40h10.3 M20.7,40 h6.1 M33,40h6.1 M55.4,30.5V40H45.2 M21,18.9h62.9v48.6H21V18.9z',
	    // jshint ignore:line
	    clear: 'M22,14.7l30.9,31 M52.9,14.7L22,45.7 M4.7,16.8V4.2h13.1 M26,4.2h7.8 M41.6,4.2h7.8 M70.3,16.8V4.2H57.2 M4.7,25.9v8.6 M70.3,25.9v8.6 M4.7,43.2v12.6h13.1 M26,55.8h7.8 M41.6,55.8h7.8 M70.3,43.2v12.6H57.2' // jshint ignore:line
	
	    /* eslint-enable */
	
	  },
	  // `rect`, `polygon`, `lineX`, `lineY`, `keep`, `clear`
	  title: zrUtil.clone(brushLang.title)
	};
	var proto = Brush.prototype; // proto.updateLayout = function (featureModel, ecModel, api) {
	
	/* eslint-disable */
	
	proto.render =
	/* eslint-enable */
	proto.updateView = function (featureModel, ecModel, api) {
	  var brushType;
	  var brushMode;
	  var isBrushed;
	  ecModel.eachComponent({
	    mainType: 'brush'
	  }, function (brushModel) {
	    brushType = brushModel.brushType;
	    brushMode = brushModel.brushOption.brushMode || 'single';
	    isBrushed |= brushModel.areas.length;
	  });
	  this._brushType = brushType;
	  this._brushMode = brushMode;
	  zrUtil.each(featureModel.get('type', true), function (type) {
	    featureModel.setIconStatus(type, (type === 'keep' ? brushMode === 'multiple' : type === 'clear' ? isBrushed : type === brushType) ? 'emphasis' : 'normal');
	  });
	};
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon', true);
	  var icons = {};
	  zrUtil.each(model.get('type', true), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	proto.onclick = function (ecModel, api, type) {
	  var brushType = this._brushType;
	  var brushMode = this._brushMode;
	
	  if (type === 'clear') {
	    // Trigger parallel action firstly
	    api.dispatchAction({
	      type: 'axisAreaSelect',
	      intervals: []
	    });
	    api.dispatchAction({
	      type: 'brush',
	      command: 'clear',
	      // Clear all areas of all brush components.
	      areas: []
	    });
	  } else {
	    api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'brush',
	      brushOption: {
	        brushType: type === 'keep' ? brushType : brushType === type ? false : type,
	        brushMode: type === 'keep' ? brushMode === 'multiple' ? 'single' : 'multiple' : brushMode
	      }
	    });
	  }
	};
	
	featureManager.register('brush', Brush);
	var _default = Brush;
	module.exports = _default;

/***/ },
/* 2381 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var eventTool = __webpack_require__(147);
	
	var lang = __webpack_require__(180);
	
	var featureManager = __webpack_require__(178);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var dataViewLang = lang.toolbox.dataView;
	var BLOCK_SPLITER = new Array(60).join('-');
	var ITEM_SPLITER = '\t';
	/**
	 * Group series into two types
	 *  1. on category axis, like line, bar
	 *  2. others, like scatter, pie
	 * @param {module:echarts/model/Global} ecModel
	 * @return {Object}
	 * @inner
	 */
	
	function groupSeries(ecModel) {
	  var seriesGroupByCategoryAxis = {};
	  var otherSeries = [];
	  var meta = [];
	  ecModel.eachRawSeries(function (seriesModel) {
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && (coordSys.type === 'cartesian2d' || coordSys.type === 'polar')) {
	      var baseAxis = coordSys.getBaseAxis();
	
	      if (baseAxis.type === 'category') {
	        var key = baseAxis.dim + '_' + baseAxis.index;
	
	        if (!seriesGroupByCategoryAxis[key]) {
	          seriesGroupByCategoryAxis[key] = {
	            categoryAxis: baseAxis,
	            valueAxis: coordSys.getOtherAxis(baseAxis),
	            series: []
	          };
	          meta.push({
	            axisDim: baseAxis.dim,
	            axisIndex: baseAxis.index
	          });
	        }
	
	        seriesGroupByCategoryAxis[key].series.push(seriesModel);
	      } else {
	        otherSeries.push(seriesModel);
	      }
	    } else {
	      otherSeries.push(seriesModel);
	    }
	  });
	  return {
	    seriesGroupByCategoryAxis: seriesGroupByCategoryAxis,
	    other: otherSeries,
	    meta: meta
	  };
	}
	/**
	 * Assemble content of series on cateogory axis
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleSeriesWithCategoryAxis(series) {
	  var tables = [];
	  zrUtil.each(series, function (group, key) {
	    var categoryAxis = group.categoryAxis;
	    var valueAxis = group.valueAxis;
	    var valueAxisDim = valueAxis.dim;
	    var headers = [' '].concat(zrUtil.map(group.series, function (series) {
	      return series.name;
	    }));
	    var columns = [categoryAxis.model.getCategories()];
	    zrUtil.each(group.series, function (series) {
	      var rawData = series.getRawData();
	      columns.push(series.getRawData().mapArray(rawData.mapDimension(valueAxisDim), function (val) {
	        return val;
	      }));
	    }); // Assemble table content
	
	    var lines = [headers.join(ITEM_SPLITER)];
	
	    for (var i = 0; i < columns[0].length; i++) {
	      var items = [];
	
	      for (var j = 0; j < columns.length; j++) {
	        items.push(columns[j][i]);
	      }
	
	      lines.push(items.join(ITEM_SPLITER));
	    }
	
	    tables.push(lines.join('\n'));
	  });
	  return tables.join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * Assemble content of other series
	 * @param {Array.<module:echarts/model/Series>} series
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleOtherSeries(series) {
	  return zrUtil.map(series, function (series) {
	    var data = series.getRawData();
	    var lines = [series.name];
	    var vals = [];
	    data.each(data.dimensions, function () {
	      var argLen = arguments.length;
	      var dataIndex = arguments[argLen - 1];
	      var name = data.getName(dataIndex);
	
	      for (var i = 0; i < argLen - 1; i++) {
	        vals[i] = arguments[i];
	      }
	
	      lines.push((name ? name + ITEM_SPLITER : '') + vals.join(ITEM_SPLITER));
	    });
	    return lines.join('\n');
	  }).join('\n\n' + BLOCK_SPLITER + '\n\n');
	}
	/**
	 * @param {module:echarts/model/Global}
	 * @return {Object}
	 * @inner
	 */
	
	
	function getContentFromModel(ecModel) {
	  var result = groupSeries(ecModel);
	  return {
	    value: zrUtil.filter([assembleSeriesWithCategoryAxis(result.seriesGroupByCategoryAxis), assembleOtherSeries(result.other)], function (str) {
	      return str.replace(/[\n\t\s]/g, '');
	    }).join('\n\n' + BLOCK_SPLITER + '\n\n'),
	    meta: result.meta
	  };
	}
	
	function trim(str) {
	  return str.replace(/^\s\s*/, '').replace(/\s\s*$/, '');
	}
	/**
	 * If a block is tsv format
	 */
	
	
	function isTSVFormat(block) {
	  // Simple method to find out if a block is tsv format
	  var firstLine = block.slice(0, block.indexOf('\n'));
	
	  if (firstLine.indexOf(ITEM_SPLITER) >= 0) {
	    return true;
	  }
	}
	
	var itemSplitRegex = new RegExp('[' + ITEM_SPLITER + ']+', 'g');
	/**
	 * @param {string} tsv
	 * @return {Object}
	 */
	
	function parseTSVContents(tsv) {
	  var tsvLines = tsv.split(/\n+/g);
	  var headers = trim(tsvLines.shift()).split(itemSplitRegex);
	  var categories = [];
	  var series = zrUtil.map(headers, function (header) {
	    return {
	      name: header,
	      data: []
	    };
	  });
	
	  for (var i = 0; i < tsvLines.length; i++) {
	    var items = trim(tsvLines[i]).split(itemSplitRegex);
	    categories.push(items.shift());
	
	    for (var j = 0; j < items.length; j++) {
	      series[j] && (series[j].data[i] = items[j]);
	    }
	  }
	
	  return {
	    series: series,
	    categories: categories
	  };
	}
	/**
	 * @param {string} str
	 * @return {Array.<Object>}
	 * @inner
	 */
	
	
	function parseListContents(str) {
	  var lines = str.split(/\n+/g);
	  var seriesName = trim(lines.shift());
	  var data = [];
	
	  for (var i = 0; i < lines.length; i++) {
	    // if line is empty, ignore it.
	    // there is a case that a user forgot to delete `\n`.
	    var line = trim(lines[i]);
	
	    if (!line) {
	      continue;
	    }
	
	    var items = line.split(itemSplitRegex);
	    var name = '';
	    var value;
	    var hasName = false;
	
	    if (isNaN(items[0])) {
	      // First item is name
	      hasName = true;
	      name = items[0];
	      items = items.slice(1);
	      data[i] = {
	        name: name,
	        value: []
	      };
	      value = data[i].value;
	    } else {
	      value = data[i] = [];
	    }
	
	    for (var j = 0; j < items.length; j++) {
	      value.push(+items[j]);
	    }
	
	    if (value.length === 1) {
	      hasName ? data[i].value = value[0] : data[i] = value[0];
	    }
	  }
	
	  return {
	    name: seriesName,
	    data: data
	  };
	}
	/**
	 * @param {string} str
	 * @param {Array.<Object>} blockMetaList
	 * @return {Object}
	 * @inner
	 */
	
	
	function parseContents(str, blockMetaList) {
	  var blocks = str.split(new RegExp('\n*' + BLOCK_SPLITER + '\n*', 'g'));
	  var newOption = {
	    series: []
	  };
	  zrUtil.each(blocks, function (block, idx) {
	    if (isTSVFormat(block)) {
	      var result = parseTSVContents(block);
	      var blockMeta = blockMetaList[idx];
	      var axisKey = blockMeta.axisDim + 'Axis';
	
	      if (blockMeta) {
	        newOption[axisKey] = newOption[axisKey] || [];
	        newOption[axisKey][blockMeta.axisIndex] = {
	          data: result.categories
	        };
	        newOption.series = newOption.series.concat(result.series);
	      }
	    } else {
	      var result = parseListContents(block);
	      newOption.series.push(result);
	    }
	  });
	  return newOption;
	}
	/**
	 * @alias {module:echarts/component/toolbox/feature/DataView}
	 * @constructor
	 * @param {module:echarts/model/Model} model
	 */
	
	
	function DataView(model) {
	  this._dom = null;
	  this.model = model;
	}
	
	DataView.defaultOption = {
	  show: true,
	  readOnly: false,
	  optionToContent: null,
	  contentToOption: null,
	  icon: 'M17.5,17.3H33 M17.5,17.3H33 M45.4,29.5h-28 M11.5,2v56H51V14.8L38.4,2H11.5z M38.4,2.2v12.7H51 M45.4,41.7h-28',
	  title: zrUtil.clone(dataViewLang.title),
	  lang: zrUtil.clone(dataViewLang.lang),
	  backgroundColor: '#fff',
	  textColor: '#000',
	  textareaColor: '#fff',
	  textareaBorderColor: '#333',
	  buttonColor: '#c23531',
	  buttonTextColor: '#fff'
	};
	
	DataView.prototype.onclick = function (ecModel, api) {
	  var container = api.getDom();
	  var model = this.model;
	
	  if (this._dom) {
	    container.removeChild(this._dom);
	  }
	
	  var root = document.createElement('div');
	  root.style.cssText = 'position:absolute;left:5px;top:5px;bottom:5px;right:5px;';
	  root.style.backgroundColor = model.get('backgroundColor') || '#fff'; // Create elements
	
	  var header = document.createElement('h4');
	  var lang = model.get('lang') || [];
	  header.innerHTML = lang[0] || model.get('title');
	  header.style.cssText = 'margin: 10px 20px;';
	  header.style.color = model.get('textColor');
	  var viewMain = document.createElement('div');
	  var textarea = document.createElement('textarea');
	  viewMain.style.cssText = 'display:block;width:100%;overflow:auto;';
	  var optionToContent = model.get('optionToContent');
	  var contentToOption = model.get('contentToOption');
	  var result = getContentFromModel(ecModel);
	
	  if (typeof optionToContent === 'function') {
	    var htmlOrDom = optionToContent(api.getOption());
	
	    if (typeof htmlOrDom === 'string') {
	      viewMain.innerHTML = htmlOrDom;
	    } else if (zrUtil.isDom(htmlOrDom)) {
	      viewMain.appendChild(htmlOrDom);
	    }
	  } else {
	    // Use default textarea
	    viewMain.appendChild(textarea);
	    textarea.readOnly = model.get('readOnly');
	    textarea.style.cssText = 'width:100%;height:100%;font-family:monospace;font-size:14px;line-height:1.6rem;';
	    textarea.style.color = model.get('textColor');
	    textarea.style.borderColor = model.get('textareaBorderColor');
	    textarea.style.backgroundColor = model.get('textareaColor');
	    textarea.value = result.value;
	  }
	
	  var blockMetaList = result.meta;
	  var buttonContainer = document.createElement('div');
	  buttonContainer.style.cssText = 'position:absolute;bottom:0;left:0;right:0;';
	  var buttonStyle = 'float:right;margin-right:20px;border:none;' + 'cursor:pointer;padding:2px 5px;font-size:12px;border-radius:3px';
	  var closeButton = document.createElement('div');
	  var refreshButton = document.createElement('div');
	  buttonStyle += ';background-color:' + model.get('buttonColor');
	  buttonStyle += ';color:' + model.get('buttonTextColor');
	  var self = this;
	
	  function close() {
	    container.removeChild(root);
	    self._dom = null;
	  }
	
	  eventTool.addEventListener(closeButton, 'click', close);
	  eventTool.addEventListener(refreshButton, 'click', function () {
	    var newOption;
	
	    try {
	      if (typeof contentToOption === 'function') {
	        newOption = contentToOption(viewMain, api.getOption());
	      } else {
	        newOption = parseContents(textarea.value, blockMetaList);
	      }
	    } catch (e) {
	      close();
	      throw new Error('Data view format error ' + e);
	    }
	
	    if (newOption) {
	      api.dispatchAction({
	        type: 'changeDataView',
	        newOption: newOption
	      });
	    }
	
	    close();
	  });
	  closeButton.innerHTML = lang[1];
	  refreshButton.innerHTML = lang[2];
	  refreshButton.style.cssText = buttonStyle;
	  closeButton.style.cssText = buttonStyle;
	  !model.get('readOnly') && buttonContainer.appendChild(refreshButton);
	  buttonContainer.appendChild(closeButton);
	  root.appendChild(header);
	  root.appendChild(viewMain);
	  root.appendChild(buttonContainer);
	  viewMain.style.height = container.clientHeight - 80 + 'px';
	  container.appendChild(root);
	  this._dom = root;
	};
	
	DataView.prototype.remove = function (ecModel, api) {
	  this._dom && api.getDom().removeChild(this._dom);
	};
	
	DataView.prototype.dispose = function (ecModel, api) {
	  this.remove(ecModel, api);
	};
	/**
	 * @inner
	 */
	
	
	function tryMergeDataOption(newData, originalData) {
	  return zrUtil.map(newData, function (newVal, idx) {
	    var original = originalData && originalData[idx];
	
	    if (zrUtil.isObject(original) && !zrUtil.isArray(original)) {
	      var newValIsObject = zrUtil.isObject(newVal) && !zrUtil.isArray(newVal);
	
	      if (!newValIsObject) {
	        newVal = {
	          value: newVal
	        };
	      } // original data has name but new data has no name
	
	
	      var shouldDeleteName = original.name != null && newVal.name == null; // Original data has option
	
	      newVal = zrUtil.defaults(newVal, original);
	      shouldDeleteName && delete newVal.name;
	      return newVal;
	    } else {
	      return newVal;
	    }
	  });
	}
	
	featureManager.register('dataView', DataView);
	echarts.registerAction({
	  type: 'changeDataView',
	  event: 'dataViewChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  var newSeriesOptList = [];
	  zrUtil.each(payload.newOption.series, function (seriesOpt) {
	    var seriesModel = ecModel.getSeriesByName(seriesOpt.name)[0];
	
	    if (!seriesModel) {
	      // New created series
	      // Geuss the series type
	      newSeriesOptList.push(zrUtil.extend({
	        // Default is scatter
	        type: 'scatter'
	      }, seriesOpt));
	    } else {
	      var originalData = seriesModel.get('data');
	      newSeriesOptList.push({
	        name: seriesOpt.name,
	        data: tryMergeDataOption(seriesOpt.data, originalData)
	      });
	    }
	  });
	  ecModel.mergeOption(zrUtil.defaults({
	    series: newSeriesOptList
	  }, payload.newOption));
	});
	var _default = DataView;
	module.exports = _default;

/***/ },
/* 2382 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var BrushController = __webpack_require__(505);
	
	var BrushTargetManager = __webpack_require__(843);
	
	var history = __webpack_require__(839);
	
	var sliderMove = __webpack_require__(249);
	
	var lang = __webpack_require__(180);
	
	var featureManager = __webpack_require__(178);
	
	__webpack_require__(2342);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Use dataZoomSelect
	var dataZoomLang = lang.toolbox.dataZoom;
	var each = zrUtil.each; // Spectial component id start with \0ec\0, see echarts/model/Global.js~hasInnerId
	
	var DATA_ZOOM_ID_BASE = '\0_ec_\0toolbox-dataZoom_';
	
	function DataZoom(model, ecModel, api) {
	  /**
	   * @private
	   * @type {module:echarts/component/helper/BrushController}
	   */
	  (this._brushController = new BrushController(api.getZr())).on('brush', zrUtil.bind(this._onBrush, this)).mount();
	  /**
	   * @private
	   * @type {boolean}
	   */
	
	  this._isZoomActive;
	}
	
	DataZoom.defaultOption = {
	  show: true,
	  filterMode: 'filter',
	  // Icon group
	  icon: {
	    zoom: 'M0,13.5h26.9 M13.5,26.9V0 M32.1,13.5H58V58H13.5 V32.1',
	    back: 'M22,1.4L9.9,13.5l12.3,12.3 M10.3,13.5H54.9v44.6 H10.3v-26'
	  },
	  // `zoom`, `back`
	  title: zrUtil.clone(dataZoomLang.title),
	  brushStyle: {
	    borderWidth: 0,
	    color: 'rgba(0,0,0,0.2)'
	  }
	};
	var proto = DataZoom.prototype;
	
	proto.render = function (featureModel, ecModel, api, payload) {
	  this.model = featureModel;
	  this.ecModel = ecModel;
	  this.api = api;
	  updateZoomBtnStatus(featureModel, ecModel, this, payload, api);
	  updateBackBtnStatus(featureModel, ecModel);
	};
	
	proto.onclick = function (ecModel, api, type) {
	  handlers[type].call(this);
	};
	
	proto.remove = function (ecModel, api) {
	  this._brushController.unmount();
	};
	
	proto.dispose = function (ecModel, api) {
	  this._brushController.dispose();
	};
	/**
	 * @private
	 */
	
	
	var handlers = {
	  zoom: function () {
	    var nextActive = !this._isZoomActive;
	    this.api.dispatchAction({
	      type: 'takeGlobalCursor',
	      key: 'dataZoomSelect',
	      dataZoomSelectActive: nextActive
	    });
	  },
	  back: function () {
	    this._dispatchZoomAction(history.pop(this.ecModel));
	  }
	};
	/**
	 * @private
	 */
	
	proto._onBrush = function (areas, opt) {
	  if (!opt.isEnd || !areas.length) {
	    return;
	  }
	
	  var snapshot = {};
	  var ecModel = this.ecModel;
	
	  this._brushController.updateCovers([]); // remove cover
	
	
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(this.model.option), ecModel, {
	    include: ['grid']
	  });
	  brushTargetManager.matchOutputRanges(areas, ecModel, function (area, coordRange, coordSys) {
	    if (coordSys.type !== 'cartesian2d') {
	      return;
	    }
	
	    var brushType = area.brushType;
	
	    if (brushType === 'rect') {
	      setBatch('x', coordSys, coordRange[0]);
	      setBatch('y', coordSys, coordRange[1]);
	    } else {
	      setBatch({
	        lineX: 'x',
	        lineY: 'y'
	      }[brushType], coordSys, coordRange);
	    }
	  });
	  history.push(ecModel, snapshot);
	
	  this._dispatchZoomAction(snapshot);
	
	  function setBatch(dimName, coordSys, minMax) {
	    var axis = coordSys.getAxis(dimName);
	    var axisModel = axis.model;
	    var dataZoomModel = findDataZoom(dimName, axisModel, ecModel); // Restrict range.
	
	    var minMaxSpan = dataZoomModel.findRepresentativeAxisProxy(axisModel).getMinMaxSpan();
	
	    if (minMaxSpan.minValueSpan != null || minMaxSpan.maxValueSpan != null) {
	      minMax = sliderMove(0, minMax.slice(), axis.scale.getExtent(), 0, minMaxSpan.minValueSpan, minMaxSpan.maxValueSpan);
	    }
	
	    dataZoomModel && (snapshot[dataZoomModel.id] = {
	      dataZoomId: dataZoomModel.id,
	      startValue: minMax[0],
	      endValue: minMax[1]
	    });
	  }
	
	  function findDataZoom(dimName, axisModel, ecModel) {
	    var found;
	    ecModel.eachComponent({
	      mainType: 'dataZoom',
	      subType: 'select'
	    }, function (dzModel) {
	      var has = dzModel.getAxisModel(dimName, axisModel.componentIndex);
	      has && (found = dzModel);
	    });
	    return found;
	  }
	};
	/**
	 * @private
	 */
	
	
	proto._dispatchZoomAction = function (snapshot) {
	  var batch = []; // Convert from hash map to array.
	
	  each(snapshot, function (batchItem, dataZoomId) {
	    batch.push(zrUtil.clone(batchItem));
	  });
	  batch.length && this.api.dispatchAction({
	    type: 'dataZoom',
	    from: this.uid,
	    batch: batch
	  });
	};
	
	function retrieveAxisSetting(option) {
	  var setting = {}; // Compatible with previous setting: null => all axis, false => no axis.
	
	  zrUtil.each(['xAxisIndex', 'yAxisIndex'], function (name) {
	    setting[name] = option[name];
	    setting[name] == null && (setting[name] = 'all');
	    (setting[name] === false || setting[name] === 'none') && (setting[name] = []);
	  });
	  return setting;
	}
	
	function updateBackBtnStatus(featureModel, ecModel) {
	  featureModel.setIconStatus('back', history.count(ecModel) > 1 ? 'emphasis' : 'normal');
	}
	
	function updateZoomBtnStatus(featureModel, ecModel, view, payload, api) {
	  var zoomActive = view._isZoomActive;
	
	  if (payload && payload.type === 'takeGlobalCursor') {
	    zoomActive = payload.key === 'dataZoomSelect' ? payload.dataZoomSelectActive : false;
	  }
	
	  view._isZoomActive = zoomActive;
	  featureModel.setIconStatus('zoom', zoomActive ? 'emphasis' : 'normal');
	  var brushTargetManager = new BrushTargetManager(retrieveAxisSetting(featureModel.option), ecModel, {
	    include: ['grid']
	  });
	
	  view._brushController.setPanels(brushTargetManager.makePanelOpts(api, function (targetInfo) {
	    return targetInfo.xAxisDeclared && !targetInfo.yAxisDeclared ? 'lineX' : !targetInfo.xAxisDeclared && targetInfo.yAxisDeclared ? 'lineY' : 'rect';
	  })).enableBrush(zoomActive ? {
	    brushType: 'auto',
	    brushStyle: featureModel.getModel('brushStyle').getItemStyle()
	  } : false);
	}
	
	featureManager.register('dataZoom', DataZoom); // Create special dataZoom option for select
	// FIXME consider the case of merge option, where axes options are not exists.
	
	echarts.registerPreprocessor(function (option) {
	  if (!option) {
	    return;
	  }
	
	  var dataZoomOpts = option.dataZoom || (option.dataZoom = []);
	
	  if (!zrUtil.isArray(dataZoomOpts)) {
	    option.dataZoom = dataZoomOpts = [dataZoomOpts];
	  }
	
	  var toolboxOpt = option.toolbox;
	
	  if (toolboxOpt) {
	    // Assume there is only one toolbox
	    if (zrUtil.isArray(toolboxOpt)) {
	      toolboxOpt = toolboxOpt[0];
	    }
	
	    if (toolboxOpt && toolboxOpt.feature) {
	      var dataZoomOpt = toolboxOpt.feature.dataZoom; // FIXME: If add dataZoom when setOption in merge mode,
	      // no axis info to be added. See `test/dataZoom-extreme.html`
	
	      addForAxis('xAxis', dataZoomOpt);
	      addForAxis('yAxis', dataZoomOpt);
	    }
	  }
	
	  function addForAxis(axisName, dataZoomOpt) {
	    if (!dataZoomOpt) {
	      return;
	    } // Try not to modify model, because it is not merged yet.
	
	
	    var axisIndicesName = axisName + 'Index';
	    var givenAxisIndices = dataZoomOpt[axisIndicesName];
	
	    if (givenAxisIndices != null && givenAxisIndices !== 'all' && !zrUtil.isArray(givenAxisIndices)) {
	      givenAxisIndices = givenAxisIndices === false || givenAxisIndices === 'none' ? [] : [givenAxisIndices];
	    }
	
	    forEachComponent(axisName, function (axisOpt, axisIndex) {
	      if (givenAxisIndices != null && givenAxisIndices !== 'all' && zrUtil.indexOf(givenAxisIndices, axisIndex) === -1) {
	        return;
	      }
	
	      var newOpt = {
	        type: 'select',
	        $fromToolbox: true,
	        // Default to be filter
	        filterMode: dataZoomOpt.filterMode || 'filter',
	        // Id for merge mapping.
	        id: DATA_ZOOM_ID_BASE + axisName + axisIndex
	      }; // FIXME
	      // Only support one axis now.
	
	      newOpt[axisIndicesName] = axisIndex;
	      dataZoomOpts.push(newOpt);
	    });
	  }
	
	  function forEachComponent(mainType, cb) {
	    var opts = option[mainType];
	
	    if (!zrUtil.isArray(opts)) {
	      opts = opts ? [opts] : [];
	    }
	
	    each(opts, cb);
	  }
	});
	var _default = DataZoom;
	module.exports = _default;

/***/ },
/* 2383 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var lang = __webpack_require__(180);
	
	var featureManager = __webpack_require__(178);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var magicTypeLang = lang.toolbox.magicType;
	var INNER_STACK_KEYWORD = '__ec_magicType_stack__';
	
	function MagicType(model) {
	  this.model = model;
	}
	
	MagicType.defaultOption = {
	  show: true,
	  type: [],
	  // Icon group
	  icon: {
	    /* eslint-disable */
	    line: 'M4.1,28.9h7.1l9.3-22l7.4,38l9.7-19.7l3,12.8h14.9M4.1,58h51.4',
	    bar: 'M6.7,22.9h10V48h-10V22.9zM24.9,13h10v35h-10V13zM43.2,2h10v46h-10V2zM3.1,58h53.7',
	    stack: 'M8.2,38.4l-8.4,4.1l30.6,15.3L60,42.5l-8.1-4.1l-21.5,11L8.2,38.4z M51.9,30l-8.1,4.2l-13.4,6.9l-13.9-6.9L8.2,30l-8.4,4.2l8.4,4.2l22.2,11l21.5-11l8.1-4.2L51.9,30z M51.9,21.7l-8.1,4.2L35.7,30l-5.3,2.8L24.9,30l-8.4-4.1l-8.3-4.2l-8.4,4.2L8.2,30l8.3,4.2l13.9,6.9l13.4-6.9l8.1-4.2l8.1-4.1L51.9,21.7zM30.4,2.2L-0.2,17.5l8.4,4.1l8.3,4.2l8.4,4.2l5.5,2.7l5.3-2.7l8.1-4.2l8.1-4.2l8.1-4.1L30.4,2.2z' // jshint ignore:line
	
	    /* eslint-enable */
	
	  },
	  // `line`, `bar`, `stack`, `tiled`
	  title: zrUtil.clone(magicTypeLang.title),
	  option: {},
	  seriesIndex: {}
	};
	var proto = MagicType.prototype;
	
	proto.getIcons = function () {
	  var model = this.model;
	  var availableIcons = model.get('icon');
	  var icons = {};
	  zrUtil.each(model.get('type'), function (type) {
	    if (availableIcons[type]) {
	      icons[type] = availableIcons[type];
	    }
	  });
	  return icons;
	};
	
	var seriesOptGenreator = {
	  'line': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'bar') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'line',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.line') || {}, true);
	    }
	  },
	  'bar': function (seriesType, seriesId, seriesModel, model) {
	    if (seriesType === 'line') {
	      return zrUtil.merge({
	        id: seriesId,
	        type: 'bar',
	        // Preserve data related option
	        data: seriesModel.get('data'),
	        stack: seriesModel.get('stack'),
	        markPoint: seriesModel.get('markPoint'),
	        markLine: seriesModel.get('markLine')
	      }, model.get('option.bar') || {}, true);
	    }
	  },
	  'stack': function (seriesType, seriesId, seriesModel, model) {
	    var isStack = seriesModel.get('stack') === INNER_STACK_KEYWORD;
	
	    if (seriesType === 'line' || seriesType === 'bar') {
	      model.setIconStatus('stack', isStack ? 'normal' : 'emphasis');
	      return zrUtil.merge({
	        id: seriesId,
	        stack: isStack ? '' : INNER_STACK_KEYWORD
	      }, model.get('option.stack') || {}, true);
	    }
	  }
	};
	var radioTypes = [['line', 'bar'], ['stack']];
	
	proto.onclick = function (ecModel, api, type) {
	  var model = this.model;
	  var seriesIndex = model.get('seriesIndex.' + type); // Not supported magicType
	
	  if (!seriesOptGenreator[type]) {
	    return;
	  }
	
	  var newOption = {
	    series: []
	  };
	
	  var generateNewSeriesTypes = function (seriesModel) {
	    var seriesType = seriesModel.subType;
	    var seriesId = seriesModel.id;
	    var newSeriesOpt = seriesOptGenreator[type](seriesType, seriesId, seriesModel, model);
	
	    if (newSeriesOpt) {
	      // PENDING If merge original option?
	      zrUtil.defaults(newSeriesOpt, seriesModel.option);
	      newOption.series.push(newSeriesOpt);
	    } // Modify boundaryGap
	
	
	    var coordSys = seriesModel.coordinateSystem;
	
	    if (coordSys && coordSys.type === 'cartesian2d' && (type === 'line' || type === 'bar')) {
	      var categoryAxis = coordSys.getAxesByScale('ordinal')[0];
	
	      if (categoryAxis) {
	        var axisDim = categoryAxis.dim;
	        var axisType = axisDim + 'Axis';
	        var axisModel = ecModel.queryComponents({
	          mainType: axisType,
	          index: seriesModel.get(name + 'Index'),
	          id: seriesModel.get(name + 'Id')
	        })[0];
	        var axisIndex = axisModel.componentIndex;
	        newOption[axisType] = newOption[axisType] || [];
	
	        for (var i = 0; i <= axisIndex; i++) {
	          newOption[axisType][axisIndex] = newOption[axisType][axisIndex] || {};
	        }
	
	        newOption[axisType][axisIndex].boundaryGap = type === 'bar';
	      }
	    }
	  };
	
	  zrUtil.each(radioTypes, function (radio) {
	    if (zrUtil.indexOf(radio, type) >= 0) {
	      zrUtil.each(radio, function (item) {
	        model.setIconStatus(item, 'normal');
	      });
	    }
	  });
	  model.setIconStatus(type, 'emphasis');
	  ecModel.eachComponent({
	    mainType: 'series',
	    query: seriesIndex == null ? null : {
	      seriesIndex: seriesIndex
	    }
	  }, generateNewSeriesTypes);
	  var newTitle; // Change title of stack
	
	  if (type === 'stack') {
	    var isStack = newOption.series && newOption.series[0] && newOption.series[0].stack === INNER_STACK_KEYWORD;
	    newTitle = isStack ? zrUtil.merge({
	      stack: magicTypeLang.title.tiled
	    }, magicTypeLang.title) : zrUtil.clone(magicTypeLang.title);
	  }
	
	  api.dispatchAction({
	    type: 'changeMagicType',
	    currentType: type,
	    newOption: newOption,
	    newTitle: newTitle,
	    featureName: 'magicType'
	  });
	};
	
	echarts.registerAction({
	  type: 'changeMagicType',
	  event: 'magicTypeChanged',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.mergeOption(payload.newOption);
	});
	featureManager.register('magicType', MagicType);
	var _default = MagicType;
	module.exports = _default;

/***/ },
/* 2384 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var history = __webpack_require__(839);
	
	var lang = __webpack_require__(180);
	
	var featureManager = __webpack_require__(178);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var restoreLang = lang.toolbox.restore;
	
	function Restore(model) {
	  this.model = model;
	}
	
	Restore.defaultOption = {
	  show: true,
	
	  /* eslint-disable */
	  icon: 'M3.8,33.4 M47,18.9h9.8V8.7 M56.3,20.1 C52.1,9,40.5,0.6,26.8,2.1C12.6,3.7,1.6,16.2,2.1,30.6 M13,41.1H3.1v10.2 M3.7,39.9c4.2,11.1,15.8,19.5,29.5,18 c14.2-1.6,25.2-14.1,24.7-28.5',
	
	  /* eslint-enable */
	  title: restoreLang.title
	};
	var proto = Restore.prototype;
	
	proto.onclick = function (ecModel, api, type) {
	  history.clear(ecModel);
	  api.dispatchAction({
	    type: 'restore',
	    from: this.uid
	  });
	};
	
	featureManager.register('restore', Restore);
	echarts.registerAction({
	  type: 'restore',
	  event: 'restore',
	  update: 'prepareAndUpdate'
	}, function (payload, ecModel) {
	  ecModel.resetOption('recreate');
	});
	var _default = Restore;
	module.exports = _default;

/***/ },
/* 2385 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var env = __webpack_require__(73);
	
	var lang = __webpack_require__(180);
	
	var featureManager = __webpack_require__(178);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/* global Uint8Array */
	var saveAsImageLang = lang.toolbox.saveAsImage;
	
	function SaveAsImage(model) {
	  this.model = model;
	}
	
	SaveAsImage.defaultOption = {
	  show: true,
	  icon: 'M4.7,22.9L29.3,45.5L54.7,23.4M4.6,43.6L4.6,58L53.8,58L53.8,43.6M29.2,45.1L29.2,0',
	  title: saveAsImageLang.title,
	  type: 'png',
	  // Default use option.backgroundColor
	  // backgroundColor: '#fff',
	  connectedBackgroundColor: '#fff',
	  name: '',
	  excludeComponents: ['toolbox'],
	  pixelRatio: 1,
	  lang: saveAsImageLang.lang.slice()
	};
	SaveAsImage.prototype.unusable = !env.canvasSupported;
	var proto = SaveAsImage.prototype;
	
	proto.onclick = function (ecModel, api) {
	  var model = this.model;
	  var title = model.get('name') || ecModel.get('title.0.text') || 'echarts';
	  var isSvg = api.getZr().painter.getType() === 'svg';
	  var type = isSvg ? 'svg' : model.get('type', true) || 'png';
	  var url = api.getConnectedDataURL({
	    type: type,
	    backgroundColor: model.get('backgroundColor', true) || ecModel.get('backgroundColor') || '#fff',
	    connectedBackgroundColor: model.get('connectedBackgroundColor'),
	    excludeComponents: model.get('excludeComponents'),
	    pixelRatio: model.get('pixelRatio')
	  }); // Chrome and Firefox
	
	  if (typeof MouseEvent === 'function' && !env.browser.ie && !env.browser.edge) {
	    var $a = document.createElement('a');
	    $a.download = title + '.' + type;
	    $a.target = '_blank';
	    $a.href = url;
	    var evt = new MouseEvent('click', {
	      // some micro front-end framework， window maybe is a Proxy
	      view: document.defaultView,
	      bubbles: true,
	      cancelable: false
	    });
	    $a.dispatchEvent(evt);
	  } // IE
	  else {
	      if (window.navigator.msSaveOrOpenBlob) {
	        var bstr = atob(url.split(',')[1]);
	        var n = bstr.length;
	        var u8arr = new Uint8Array(n);
	
	        while (n--) {
	          u8arr[n] = bstr.charCodeAt(n);
	        }
	
	        var blob = new Blob([u8arr]);
	        window.navigator.msSaveOrOpenBlob(blob, title + '.' + type);
	      } else {
	        var lang = model.get('lang');
	        var html = '' + '<body style="margin:0;">' + '<img src="' + url + '" style="max-width:100%;" title="' + (lang && lang[0] || '') + '" />' + '</body>';
	        var tab = window.open();
	        tab.document.write(html);
	      }
	    }
	};
	
	featureManager.register('saveAsImage', SaveAsImage);
	var _default = SaveAsImage;
	module.exports = _default;

/***/ },
/* 2386 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(289);
	
	__webpack_require__(2388);
	
	__webpack_require__(2390);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// FIXME Better way to pack data in graphic element
	
	/**
	 * @action
	 * @property {string} type
	 * @property {number} seriesIndex
	 * @property {number} dataIndex
	 * @property {number} [x]
	 * @property {number} [y]
	 */
	echarts.registerAction({
	  type: 'showTip',
	  event: 'showTip',
	  update: 'tooltip:manuallyShowTip'
	}, // noop
	function () {});
	echarts.registerAction({
	  type: 'hideTip',
	  event: 'hideTip',
	  update: 'tooltip:manuallyHideTip'
	}, // noop
	function () {});

/***/ },
/* 2387 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var zrColor = __webpack_require__(148);
	
	var eventUtil = __webpack_require__(147);
	
	var domUtil = __webpack_require__(1196);
	
	var env = __webpack_require__(73);
	
	var formatUtil = __webpack_require__(48);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var toCamelCase = formatUtil.toCamelCase;
	var vendors = ['', '-webkit-', '-moz-', '-o-'];
	var gCssText = 'position:absolute;display:block;border-style:solid;white-space:nowrap;z-index:9999999;';
	/**
	 * @param {number} duration
	 * @return {string}
	 * @inner
	 */
	
	function assembleTransition(duration) {
	  var transitionCurve = 'cubic-bezier(0.23, 1, 0.32, 1)';
	  var transitionText = 'left ' + duration + 's ' + transitionCurve + ',' + 'top ' + duration + 's ' + transitionCurve;
	  return zrUtil.map(vendors, function (vendorPrefix) {
	    return vendorPrefix + 'transition:' + transitionText;
	  }).join(';');
	}
	/**
	 * @param {Object} textStyle
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleFont(textStyleModel) {
	  var cssText = [];
	  var fontSize = textStyleModel.get('fontSize');
	  var color = textStyleModel.getTextColor();
	  color && cssText.push('color:' + color);
	  cssText.push('font:' + textStyleModel.getFont());
	  var lineHeight = textStyleModel.get('lineHeight');
	
	  if (lineHeight == null) {
	    lineHeight = Math.round(fontSize * 3 / 2);
	  }
	
	  fontSize && cssText.push('line-height:' + lineHeight + 'px');
	  var shadowColor = textStyleModel.get('textShadowColor');
	  var shadowBlur = textStyleModel.get('textShadowBlur') || 0;
	  var shadowOffsetX = textStyleModel.get('textShadowOffsetX') || 0;
	  var shadowOffsetY = textStyleModel.get('textShadowOffsetY') || 0;
	  shadowBlur && cssText.push('text-shadow:' + shadowOffsetX + 'px ' + shadowOffsetY + 'px ' + shadowBlur + 'px ' + shadowColor);
	  each(['decoration', 'align'], function (name) {
	    var val = textStyleModel.get(name);
	    val && cssText.push('text-' + name + ':' + val);
	  });
	  return cssText.join(';');
	}
	/**
	 * @param {Object} tooltipModel
	 * @return {string}
	 * @inner
	 */
	
	
	function assembleCssText(tooltipModel) {
	  var cssText = [];
	  var transitionDuration = tooltipModel.get('transitionDuration');
	  var backgroundColor = tooltipModel.get('backgroundColor');
	  var textStyleModel = tooltipModel.getModel('textStyle');
	  var padding = tooltipModel.get('padding'); // Animation transition. Do not animate when transitionDuration is 0.
	
	  transitionDuration && cssText.push(assembleTransition(transitionDuration));
	
	  if (backgroundColor) {
	    if (env.canvasSupported) {
	      cssText.push('background-Color:' + backgroundColor);
	    } else {
	      // for ie
	      cssText.push('background-Color:#' + zrColor.toHex(backgroundColor));
	      cssText.push('filter:alpha(opacity=70)');
	    }
	  } // Border style
	
	
	  each(['width', 'color', 'radius'], function (name) {
	    var borderName = 'border-' + name;
	    var camelCase = toCamelCase(borderName);
	    var val = tooltipModel.get(camelCase);
	    val != null && cssText.push(borderName + ':' + val + (name === 'color' ? '' : 'px'));
	  }); // Text style
	
	  cssText.push(assembleFont(textStyleModel)); // Padding
	
	  if (padding != null) {
	    cssText.push('padding:' + formatUtil.normalizeCssArray(padding).join('px ') + 'px');
	  }
	
	  return cssText.join(';') + ';';
	} // If not able to make, do not modify the input `out`.
	
	
	function makeStyleCoord(out, zr, appendToBody, zrX, zrY) {
	  var zrPainter = zr && zr.painter;
	
	  if (appendToBody) {
	    var zrViewportRoot = zrPainter && zrPainter.getViewportRoot();
	
	    if (zrViewportRoot) {
	      // Some APPs might use scale on body, so we support CSS transform here.
	      domUtil.transformLocalCoord(out, zrViewportRoot, document.body, zrX, zrY);
	    }
	  } else {
	    out[0] = zrX;
	    out[1] = zrY; // xy should be based on canvas root. But tooltipContent is
	    // the sibling of canvas root. So padding of ec container
	    // should be considered here.
	
	    var viewportRootOffset = zrPainter && zrPainter.getViewportRootOffset();
	
	    if (viewportRootOffset) {
	      out[0] += viewportRootOffset.offsetLeft;
	      out[1] += viewportRootOffset.offsetTop;
	    }
	  }
	
	  out[2] = out[0] / zr.getWidth(); // The ratio of left to width
	
	  out[3] = out[1] / zr.getHeight(); // The ratio of top to height
	}
	/**
	 * @alias module:echarts/component/tooltip/TooltipContent
	 * @param {HTMLElement} container
	 * @param {ExtensionAPI} api
	 * @param {Object} [opt]
	 * @param {boolean} [opt.appendToBody]
	 *        `false`: the DOM element will be inside the container. Default value.
	 *        `true`: the DOM element will be appended to HTML body, which avoid
	 *                some overflow clip but intrude outside of the container.
	 * @constructor
	 */
	
	
	function TooltipContent(container, api, opt) {
	  if (env.wxa) {
	    return null;
	  }
	
	  var el = document.createElement('div');
	  el.domBelongToZr = true;
	  this.el = el;
	  var zr = this._zr = api.getZr();
	  var appendToBody = this._appendToBody = opt && opt.appendToBody;
	  this._styleCoord = [0, 0, 0, 0]; // [left, top, left/width, top/height]
	
	  makeStyleCoord(this._styleCoord, zr, appendToBody, api.getWidth() / 2, api.getHeight() / 2);
	
	  if (appendToBody) {
	    document.body.appendChild(el);
	  } else {
	    container.appendChild(el);
	  }
	
	  this._container = container;
	  this._show = false;
	  /**
	   * @private
	   */
	
	  this._hideTimeout; // FIXME
	  // Is it needed to trigger zr event manually if
	  // the browser do not support `pointer-events: none`.
	
	  var self = this;
	
	  el.onmouseenter = function () {
	    // clear the timeout in hideLater and keep showing tooltip
	    if (self._enterable) {
	      clearTimeout(self._hideTimeout);
	      self._show = true;
	    }
	
	    self._inContent = true;
	  };
	
	  el.onmousemove = function (e) {
	    e = e || window.event;
	
	    if (!self._enterable) {
	      // `pointer-events: none` is set to tooltip content div
	      // if `enterable` is set as `false`, and `el.onmousemove`
	      // can not be triggered. But in browser that do not
	      // support `pointer-events`, we need to do this:
	      // Try trigger zrender event to avoid mouse
	      // in and out shape too frequently
	      var handler = zr.handler;
	      var zrViewportRoot = zr.painter.getViewportRoot();
	      eventUtil.normalizeEvent(zrViewportRoot, e, true);
	      handler.dispatch('mousemove', e);
	    }
	  };
	
	  el.onmouseleave = function () {
	    if (self._enterable) {
	      if (self._show) {
	        self.hideLater(self._hideDelay);
	      }
	    }
	
	    self._inContent = false;
	  };
	}
	
	TooltipContent.prototype = {
	  constructor: TooltipContent,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _enterable: true,
	
	  /**
	   * Update when tooltip is rendered
	   */
	  update: function (tooltipModel) {
	    // FIXME
	    // Move this logic to ec main?
	    var container = this._container;
	    var stl = container.currentStyle || document.defaultView.getComputedStyle(container);
	    var domStyle = container.style;
	
	    if (domStyle.position !== 'absolute' && stl.position !== 'absolute') {
	      domStyle.position = 'relative';
	    }
	
	    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    alwaysShowContent && this._moveTooltipIfResized(); // Hide the tooltip
	    // PENDING
	    // this.hide();
	  },
	
	  /**
	   * when `alwaysShowContent` is true,
	   * we should move the tooltip after chart resized
	   */
	  _moveTooltipIfResized: function () {
	    var ratioX = this._styleCoord[2]; // The ratio of left to width
	
	    var ratioY = this._styleCoord[3]; // The ratio of top to height
	
	    var realX = ratioX * this._zr.getWidth();
	
	    var realY = ratioY * this._zr.getHeight();
	
	    this.moveTo(realX, realY);
	  },
	  show: function (tooltipModel) {
	    clearTimeout(this._hideTimeout);
	    var el = this.el;
	    var styleCoord = this._styleCoord;
	    el.style.cssText = gCssText + assembleCssText(tooltipModel) // Because of the reason described in:
	    // http://stackoverflow.com/questions/21125587/css3-transition-not-working-in-chrome-anymore
	    // we should set initial value to `left` and `top`.
	    + ';left:' + styleCoord[0] + 'px;top:' + styleCoord[1] + 'px;' + (tooltipModel.get('extraCssText') || '');
	    el.style.display = el.innerHTML ? 'block' : 'none'; // If mouse occasionally move over the tooltip, a mouseout event will be
	    // triggered by canvas, and cause some unexpectable result like dragging
	    // stop, "unfocusAdjacency". Here `pointer-events: none` is used to solve
	    // it. Although it is not supported by IE8~IE10, fortunately it is a rare
	    // scenario.
	
	    el.style.pointerEvents = this._enterable ? 'auto' : 'none';
	    this._show = true;
	  },
	  setContent: function (content) {
	    this.el.innerHTML = content == null ? '' : content;
	  },
	  setEnterable: function (enterable) {
	    this._enterable = enterable;
	  },
	  getSize: function () {
	    var el = this.el;
	    return [el.clientWidth, el.clientHeight];
	  },
	  moveTo: function (zrX, zrY) {
	    var styleCoord = this._styleCoord;
	    makeStyleCoord(styleCoord, this._zr, this._appendToBody, zrX, zrY);
	    var style = this.el.style;
	    style.left = styleCoord[0] + 'px';
	    style.top = styleCoord[1] + 'px';
	  },
	  hide: function () {
	    this.el.style.display = 'none';
	    this._show = false;
	  },
	  hideLater: function (time) {
	    if (this._show && !(this._inContent && this._enterable)) {
	      if (time) {
	        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
	
	        this._show = false;
	        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
	      } else {
	        this.hide();
	      }
	    }
	  },
	  isShow: function () {
	    return this._show;
	  },
	  dispose: function () {
	    this.el.parentNode.removeChild(this.el);
	  },
	  getOuterSize: function () {
	    var width = this.el.clientWidth;
	    var height = this.el.clientHeight; // Consider browser compatibility.
	    // IE8 does not support getComputedStyle.
	
	    if (document.defaultView && document.defaultView.getComputedStyle) {
	      var stl = document.defaultView.getComputedStyle(this.el);
	
	      if (stl) {
	        width += parseInt(stl.borderLeftWidth, 10) + parseInt(stl.borderRightWidth, 10);
	        height += parseInt(stl.borderTopWidth, 10) + parseInt(stl.borderBottomWidth, 10);
	      }
	    }
	
	    return {
	      width: width,
	      height: height
	    };
	  }
	};
	var _default = TooltipContent;
	module.exports = _default;

/***/ },
/* 2388 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentModel({
	  type: 'tooltip',
	  dependencies: ['axisPointer'],
	  defaultOption: {
	    zlevel: 0,
	    z: 60,
	    show: true,
	    // tooltip主体内容
	    showContent: true,
	    // 'trigger' only works on coordinate system.
	    // 'item' | 'axis' | 'none'
	    trigger: 'item',
	    // 'click' | 'mousemove' | 'none'
	    triggerOn: 'mousemove|click',
	    alwaysShowContent: false,
	    displayMode: 'single',
	    // 'single' | 'multipleByCoordSys'
	    renderMode: 'auto',
	    // 'auto' | 'html' | 'richText'
	    // 'auto': use html by default, and use non-html if `document` is not defined
	    // 'html': use html for tooltip
	    // 'richText': use canvas, svg, and etc. for tooltip
	    // 位置 {Array} | {Function}
	    // position: null
	    // Consider triggered from axisPointer handle, verticalAlign should be 'middle'
	    // align: null,
	    // verticalAlign: null,
	    // 是否约束 content 在 viewRect 中。默认 false 是为了兼容以前版本。
	    confine: false,
	    // 内容格式器：{string}（Template） ¦ {Function}
	    // formatter: null
	    showDelay: 0,
	    // 隐藏延迟，单位ms
	    hideDelay: 100,
	    // 动画变换时间，单位s
	    transitionDuration: 0.4,
	    enterable: false,
	    // 提示背景颜色，默认为透明度为0.7的黑色
	    backgroundColor: 'rgba(50,50,50,0.7)',
	    // 提示边框颜色
	    borderColor: '#333',
	    // 提示边框圆角，单位px，默认为4
	    borderRadius: 4,
	    // 提示边框线宽，单位px，默认为0（无边框）
	    borderWidth: 0,
	    // 提示内边距，单位px，默认各方向内边距为5，
	    // 接受数组分别设定上右下左边距，同css
	    padding: 5,
	    // Extra css text
	    extraCssText: '',
	    // 坐标轴指示器，坐标轴触发有效
	    axisPointer: {
	      // 默认为直线
	      // 可选为：'line' | 'shadow' | 'cross'
	      type: 'line',
	      // type 为 line 的时候有效，指定 tooltip line 所在的轴，可选
	      // 可选 'x' | 'y' | 'angle' | 'radius' | 'auto'
	      // 默认 'auto'，会选择类型为 category 的轴，对于双数值轴，笛卡尔坐标系会默认选择 x 轴
	      // 极坐标系会默认选择 angle 轴
	      axis: 'auto',
	      animation: 'auto',
	      animationDurationUpdate: 200,
	      animationEasingUpdate: 'exponentialOut',
	      crossStyle: {
	        color: '#999',
	        width: 1,
	        type: 'dashed',
	        // TODO formatter
	        textStyle: {} // lineStyle and shadowStyle should not be specified here,
	        // otherwise it will always override those styles on option.axisPointer.
	
	      }
	    },
	    textStyle: {
	      color: '#fff',
	      fontSize: 14
	    }
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2389 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Text = __webpack_require__(224);
	
	var graphicUtil = __webpack_require__(14);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import Group from 'zrender/src/container/Group';
	function makeStyleCoord(out, zr, zrX, zrY) {
	  out[0] = zrX;
	  out[1] = zrY;
	  out[2] = out[0] / zr.getWidth(); // The ratio of left to width
	
	  out[3] = out[1] / zr.getHeight(); // The ratio of top to height
	}
	/**
	 * @alias module:echarts/component/tooltip/TooltipRichContent
	 * @constructor
	 */
	
	
	function TooltipRichContent(api) {
	  var zr = this._zr = api.getZr();
	  this._styleCoord = [0, 0, 0, 0]; // [left, top, left/width, top/height]
	
	  makeStyleCoord(this._styleCoord, zr, api.getWidth() / 2, api.getHeight() / 2);
	  this._show = false;
	  /**
	   * @private
	   */
	
	  this._hideTimeout;
	}
	
	TooltipRichContent.prototype = {
	  constructor: TooltipRichContent,
	
	  /**
	   * @private
	   * @type {boolean}
	   */
	  _enterable: true,
	
	  /**
	   * Update when tooltip is rendered
	   */
	  update: function (tooltipModel) {
	    var alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    alwaysShowContent && this._moveTooltipIfResized();
	  },
	
	  /**
	   * when `alwaysShowContent` is true,
	   * we should move the tooltip after chart resized
	   */
	  _moveTooltipIfResized: function () {
	    var ratioX = this._styleCoord[2]; // The ratio of left to width
	
	    var ratioY = this._styleCoord[3]; // The ratio of top to height
	
	    var realX = ratioX * this._zr.getWidth();
	
	    var realY = ratioY * this._zr.getHeight();
	
	    this.moveTo(realX, realY);
	  },
	  show: function (tooltipModel) {
	    if (this._hideTimeout) {
	      clearTimeout(this._hideTimeout);
	    }
	
	    this.el.attr('show', true);
	    this._show = true;
	  },
	
	  /**
	   * Set tooltip content
	   *
	   * @param {string} content rich text string of content
	   * @param {Object} markerRich rich text style
	   * @param {Object} tooltipModel tooltip model
	   */
	  setContent: function (content, markerRich, tooltipModel) {
	    if (this.el) {
	      this._zr.remove(this.el);
	    }
	
	    var markers = {};
	    var text = content;
	    var prefix = '{marker';
	    var suffix = '|}';
	    var startId = text.indexOf(prefix);
	
	    while (startId >= 0) {
	      var endId = text.indexOf(suffix);
	      var name = text.substr(startId + prefix.length, endId - startId - prefix.length);
	
	      if (name.indexOf('sub') > -1) {
	        markers['marker' + name] = {
	          textWidth: 4,
	          textHeight: 4,
	          textBorderRadius: 2,
	          textBackgroundColor: markerRich[name],
	          // TODO: textOffset is not implemented for rich text
	          textOffset: [3, 0]
	        };
	      } else {
	        markers['marker' + name] = {
	          textWidth: 10,
	          textHeight: 10,
	          textBorderRadius: 5,
	          textBackgroundColor: markerRich[name]
	        };
	      }
	
	      text = text.substr(endId + 1);
	      startId = text.indexOf('{marker');
	    }
	
	    var textStyleModel = tooltipModel.getModel('textStyle');
	    var fontSize = textStyleModel.get('fontSize');
	    var lineHeight = tooltipModel.get('textLineHeight');
	
	    if (lineHeight == null) {
	      lineHeight = Math.round(fontSize * 3 / 2);
	    }
	
	    this.el = new Text({
	      style: graphicUtil.setTextStyle({}, textStyleModel, {
	        rich: markers,
	        text: content,
	        textBackgroundColor: tooltipModel.get('backgroundColor'),
	        textBorderRadius: tooltipModel.get('borderRadius'),
	        textFill: tooltipModel.get('textStyle.color'),
	        textPadding: tooltipModel.get('padding'),
	        textLineHeight: lineHeight
	      }),
	      z: tooltipModel.get('z')
	    });
	
	    this._zr.add(this.el);
	
	    var self = this;
	    this.el.on('mouseover', function () {
	      // clear the timeout in hideLater and keep showing tooltip
	      if (self._enterable) {
	        clearTimeout(self._hideTimeout);
	        self._show = true;
	      }
	
	      self._inContent = true;
	    });
	    this.el.on('mouseout', function () {
	      if (self._enterable) {
	        if (self._show) {
	          self.hideLater(self._hideDelay);
	        }
	      }
	
	      self._inContent = false;
	    });
	  },
	  setEnterable: function (enterable) {
	    this._enterable = enterable;
	  },
	  getSize: function () {
	    var bounding = this.el.getBoundingRect();
	    return [bounding.width, bounding.height];
	  },
	  moveTo: function (x, y) {
	    if (this.el) {
	      var styleCoord = this._styleCoord;
	      makeStyleCoord(styleCoord, this._zr, x, y);
	      this.el.attr('position', [styleCoord[0], styleCoord[1]]);
	    }
	  },
	  hide: function () {
	    if (this.el) {
	      this.el.hide();
	    }
	
	    this._show = false;
	  },
	  hideLater: function (time) {
	    if (this._show && !(this._inContent && this._enterable)) {
	      if (time) {
	        this._hideDelay = time; // Set show false to avoid invoke hideLater multiple times
	
	        this._show = false;
	        this._hideTimeout = setTimeout(zrUtil.bind(this.hide, this), time);
	      } else {
	        this.hide();
	      }
	    }
	  },
	  isShow: function () {
	    return this._show;
	  },
	  dispose: function () {
	    clearTimeout(this._hideTimeout);
	
	    if (this.el) {
	      this._zr.remove(this.el);
	    }
	  },
	  getOuterSize: function () {
	    var size = this.getSize();
	    return {
	      width: size[0],
	      height: size[1]
	    };
	  }
	};
	var _default = TooltipRichContent;
	module.exports = _default;

/***/ },
/* 2390 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var env = __webpack_require__(73);
	
	var TooltipContent = __webpack_require__(2387);
	
	var TooltipRichContent = __webpack_require__(2389);
	
	var formatUtil = __webpack_require__(48);
	
	var numberUtil = __webpack_require__(25);
	
	var graphic = __webpack_require__(14);
	
	var findPointFromSeries = __webpack_require__(836);
	
	var layoutUtil = __webpack_require__(46);
	
	var Model = __webpack_require__(70);
	
	var globalListener = __webpack_require__(837);
	
	var axisHelper = __webpack_require__(122);
	
	var axisPointerViewHelper = __webpack_require__(355);
	
	var _model = __webpack_require__(29);
	
	var getTooltipRenderMode = _model.getTooltipRenderMode;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var bind = zrUtil.bind;
	var each = zrUtil.each;
	var parsePercent = numberUtil.parsePercent;
	var proxyRect = new graphic.Rect({
	  shape: {
	    x: -1,
	    y: -1,
	    width: 2,
	    height: 2
	  }
	});
	
	var _default = echarts.extendComponentView({
	  type: 'tooltip',
	  init: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    var tooltipModel = ecModel.getComponent('tooltip');
	    var renderMode = tooltipModel.get('renderMode');
	    this._renderMode = getTooltipRenderMode(renderMode);
	    var tooltipContent;
	
	    if (this._renderMode === 'html') {
	      tooltipContent = new TooltipContent(api.getDom(), api, {
	        appendToBody: tooltipModel.get('appendToBody', true)
	      });
	      this._newLine = '<br/>';
	    } else {
	      tooltipContent = new TooltipRichContent(api);
	      this._newLine = '\n';
	    }
	
	    this._tooltipContent = tooltipContent;
	  },
	  render: function (tooltipModel, ecModel, api) {
	    if (env.node) {
	      return;
	    } // Reset
	
	
	    this.group.removeAll();
	    /**
	     * @private
	     * @type {module:echarts/component/tooltip/TooltipModel}
	     */
	
	    this._tooltipModel = tooltipModel;
	    /**
	     * @private
	     * @type {module:echarts/model/Global}
	     */
	
	    this._ecModel = ecModel;
	    /**
	     * @private
	     * @type {module:echarts/ExtensionAPI}
	     */
	
	    this._api = api;
	    /**
	     * Should be cleaned when render.
	     * @private
	     * @type {Array.<Array.<Object>>}
	     */
	
	    this._lastDataByCoordSys = null;
	    /**
	     * @private
	     * @type {boolean}
	     */
	
	    this._alwaysShowContent = tooltipModel.get('alwaysShowContent');
	    var tooltipContent = this._tooltipContent;
	    tooltipContent.update(tooltipModel);
	    tooltipContent.setEnterable(tooltipModel.get('enterable'));
	
	    this._initGlobalListener();
	
	    this._keepShow();
	  },
	  _initGlobalListener: function () {
	    var tooltipModel = this._tooltipModel;
	    var triggerOn = tooltipModel.get('triggerOn');
	    globalListener.register('itemTooltip', this._api, bind(function (currTrigger, e, dispatchAction) {
	      // If 'none', it is not controlled by mouse totally.
	      if (triggerOn !== 'none') {
	        if (triggerOn.indexOf(currTrigger) >= 0) {
	          this._tryShow(e, dispatchAction);
	        } else if (currTrigger === 'leave') {
	          this._hide(dispatchAction);
	        }
	      }
	    }, this));
	  },
	  _keepShow: function () {
	    var tooltipModel = this._tooltipModel;
	    var ecModel = this._ecModel;
	    var api = this._api; // Try to keep the tooltip show when refreshing
	
	    if (this._lastX != null && this._lastY != null // When user is willing to control tooltip totally using API,
	    // self.manuallyShowTip({x, y}) might cause tooltip hide,
	    // which is not expected.
	    && tooltipModel.get('triggerOn') !== 'none') {
	      var self = this;
	      clearTimeout(this._refreshUpdateTimeout);
	      this._refreshUpdateTimeout = setTimeout(function () {
	        // Show tip next tick after other charts are rendered
	        // In case highlight action has wrong result
	        // FIXME
	        !api.isDisposed() && self.manuallyShowTip(tooltipModel, ecModel, api, {
	          x: self._lastX,
	          y: self._lastY
	        });
	      });
	    }
	  },
	
	  /**
	   * Show tip manually by
	   * dispatchAction({
	   *     type: 'showTip',
	   *     x: 10,
	   *     y: 10
	   * });
	   * Or
	   * dispatchAction({
	   *      type: 'showTip',
	   *      seriesIndex: 0,
	   *      dataIndex or dataIndexInside or name
	   * });
	   *
	   *  TODO Batch
	   */
	  manuallyShowTip: function (tooltipModel, ecModel, api, payload) {
	    if (payload.from === this.uid || env.node) {
	      return;
	    }
	
	    var dispatchAction = makeDispatchAction(payload, api); // Reset ticket
	
	    this._ticket = ''; // When triggered from axisPointer.
	
	    var dataByCoordSys = payload.dataByCoordSys;
	
	    if (payload.tooltip && payload.x != null && payload.y != null) {
	      var el = proxyRect;
	      el.position = [payload.x, payload.y];
	      el.update();
	      el.tooltip = payload.tooltip; // Manually show tooltip while view is not using zrender elements.
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        target: el
	      }, dispatchAction);
	    } else if (dataByCoordSys) {
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        dataByCoordSys: payload.dataByCoordSys,
	        tooltipOption: payload.tooltipOption
	      }, dispatchAction);
	    } else if (payload.seriesIndex != null) {
	      if (this._manuallyAxisShowTip(tooltipModel, ecModel, api, payload)) {
	        return;
	      }
	
	      var pointInfo = findPointFromSeries(payload, ecModel);
	      var cx = pointInfo.point[0];
	      var cy = pointInfo.point[1];
	
	      if (cx != null && cy != null) {
	        this._tryShow({
	          offsetX: cx,
	          offsetY: cy,
	          position: payload.position,
	          target: pointInfo.el
	        }, dispatchAction);
	      }
	    } else if (payload.x != null && payload.y != null) {
	      // FIXME
	      // should wrap dispatchAction like `axisPointer/globalListener` ?
	      api.dispatchAction({
	        type: 'updateAxisPointer',
	        x: payload.x,
	        y: payload.y
	      });
	
	      this._tryShow({
	        offsetX: payload.x,
	        offsetY: payload.y,
	        position: payload.position,
	        target: api.getZr().findHover(payload.x, payload.y).target
	      }, dispatchAction);
	    }
	  },
	  manuallyHideTip: function (tooltipModel, ecModel, api, payload) {
	    var tooltipContent = this._tooltipContent;
	
	    if (!this._alwaysShowContent && this._tooltipModel) {
	      tooltipContent.hideLater(this._tooltipModel.get('hideDelay'));
	    }
	
	    this._lastX = this._lastY = null;
	
	    if (payload.from !== this.uid) {
	      this._hide(makeDispatchAction(payload, api));
	    }
	  },
	  // Be compatible with previous design, that is, when tooltip.type is 'axis' and
	  // dispatchAction 'showTip' with seriesIndex and dataIndex will trigger axis pointer
	  // and tooltip.
	  _manuallyAxisShowTip: function (tooltipModel, ecModel, api, payload) {
	    var seriesIndex = payload.seriesIndex;
	    var dataIndex = payload.dataIndex;
	    var coordSysAxesInfo = ecModel.getComponent('axisPointer').coordSysAxesInfo;
	
	    if (seriesIndex == null || dataIndex == null || coordSysAxesInfo == null) {
	      return;
	    }
	
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex);
	
	    if (!seriesModel) {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), seriesModel, (seriesModel.coordinateSystem || {}).model, tooltipModel]);
	
	    if (tooltipModel.get('trigger') !== 'axis') {
	      return;
	    }
	
	    api.dispatchAction({
	      type: 'updateAxisPointer',
	      seriesIndex: seriesIndex,
	      dataIndex: dataIndex,
	      position: payload.position
	    });
	    return true;
	  },
	  _tryShow: function (e, dispatchAction) {
	    var el = e.target;
	    var tooltipModel = this._tooltipModel;
	
	    if (!tooltipModel) {
	      return;
	    } // Save mouse x, mouse y. So we can try to keep showing the tip if chart is refreshed
	
	
	    this._lastX = e.offsetX;
	    this._lastY = e.offsetY;
	    var dataByCoordSys = e.dataByCoordSys;
	
	    if (dataByCoordSys && dataByCoordSys.length) {
	      this._showAxisTooltip(dataByCoordSys, e);
	    } // Always show item tooltip if mouse is on the element with dataIndex
	    else if (el && el.dataIndex != null) {
	        this._lastDataByCoordSys = null;
	
	        this._showSeriesItemTooltip(e, el, dispatchAction);
	      } // Tooltip provided directly. Like legend.
	      else if (el && el.tooltip) {
	          this._lastDataByCoordSys = null;
	
	          this._showComponentItemTooltip(e, el, dispatchAction);
	        } else {
	          this._lastDataByCoordSys = null;
	
	          this._hide(dispatchAction);
	        }
	  },
	  _showOrMove: function (tooltipModel, cb) {
	    // showDelay is used in this case: tooltip.enterable is set
	    // as true. User intent to move mouse into tooltip and click
	    // something. `showDelay` makes it easier to enter the content
	    // but tooltip do not move immediately.
	    var delay = tooltipModel.get('showDelay');
	    cb = zrUtil.bind(cb, this);
	    clearTimeout(this._showTimout);
	    delay > 0 ? this._showTimout = setTimeout(cb, delay) : cb();
	  },
	  _showAxisTooltip: function (dataByCoordSys, e) {
	    var ecModel = this._ecModel;
	    var globalTooltipModel = this._tooltipModel;
	    var point = [e.offsetX, e.offsetY];
	    var singleDefaultHTML = [];
	    var singleParamsList = [];
	    var singleTooltipModel = buildTooltipModel([e.tooltipOption, globalTooltipModel]);
	    var renderMode = this._renderMode;
	    var newLine = this._newLine;
	    var markers = {};
	    each(dataByCoordSys, function (itemCoordSys) {
	      // var coordParamList = [];
	      // var coordDefaultHTML = [];
	      // var coordTooltipModel = buildTooltipModel([
	      //     e.tooltipOption,
	      //     itemCoordSys.tooltipOption,
	      //     ecModel.getComponent(itemCoordSys.coordSysMainType, itemCoordSys.coordSysIndex),
	      //     globalTooltipModel
	      // ]);
	      // var displayMode = coordTooltipModel.get('displayMode');
	      // var paramsList = displayMode === 'single' ? singleParamsList : [];
	      each(itemCoordSys.dataByAxis, function (item) {
	        var axisModel = ecModel.getComponent(item.axisDim + 'Axis', item.axisIndex);
	        var axisValue = item.value;
	        var seriesDefaultHTML = [];
	
	        if (!axisModel || axisValue == null) {
	          return;
	        }
	
	        var valueLabel = axisPointerViewHelper.getValueLabel(axisValue, axisModel.axis, ecModel, item.seriesDataIndices, item.valueLabelOpt);
	        zrUtil.each(item.seriesDataIndices, function (idxItem) {
	          var series = ecModel.getSeriesByIndex(idxItem.seriesIndex);
	          var dataIndex = idxItem.dataIndexInside;
	          var dataParams = series && series.getDataParams(dataIndex);
	          dataParams.axisDim = item.axisDim;
	          dataParams.axisIndex = item.axisIndex;
	          dataParams.axisType = item.axisType;
	          dataParams.axisId = item.axisId;
	          dataParams.axisValue = axisHelper.getAxisRawValue(axisModel.axis, axisValue);
	          dataParams.axisValueLabel = valueLabel;
	
	          if (dataParams) {
	            singleParamsList.push(dataParams);
	            var seriesTooltip = series.formatTooltip(dataIndex, true, null, renderMode);
	            var html;
	
	            if (zrUtil.isObject(seriesTooltip)) {
	              html = seriesTooltip.html;
	              var newMarkers = seriesTooltip.markers;
	              zrUtil.merge(markers, newMarkers);
	            } else {
	              html = seriesTooltip;
	            }
	
	            seriesDefaultHTML.push(html);
	          }
	        }); // Default tooltip content
	        // FIXME
	        // (1) should be the first data which has name?
	        // (2) themeRiver, firstDataIndex is array, and first line is unnecessary.
	
	        var firstLine = valueLabel;
	
	        if (renderMode !== 'html') {
	          singleDefaultHTML.push(seriesDefaultHTML.join(newLine));
	        } else {
	          singleDefaultHTML.push((firstLine ? formatUtil.encodeHTML(firstLine) + newLine : '') + seriesDefaultHTML.join(newLine));
	        }
	      });
	    }, this); // In most case, the second axis is shown upper than the first one.
	
	    singleDefaultHTML.reverse();
	    singleDefaultHTML = singleDefaultHTML.join(this._newLine + this._newLine);
	    var positionExpr = e.position;
	
	    this._showOrMove(singleTooltipModel, function () {
	      if (this._updateContentNotChangedOnAxis(dataByCoordSys)) {
	        this._updatePosition(singleTooltipModel, positionExpr, point[0], point[1], this._tooltipContent, singleParamsList);
	      } else {
	        this._showTooltipContent(singleTooltipModel, singleDefaultHTML, singleParamsList, Math.random(), point[0], point[1], positionExpr, undefined, markers);
	      }
	    }); // Do not trigger events here, because this branch only be entered
	    // from dispatchAction.
	
	  },
	  _showSeriesItemTooltip: function (e, el, dispatchAction) {
	    var ecModel = this._ecModel; // Use dataModel in element if possible
	    // Used when mouseover on a element like markPoint or edge
	    // In which case, the data is not main data in series.
	
	    var seriesIndex = el.seriesIndex;
	    var seriesModel = ecModel.getSeriesByIndex(seriesIndex); // For example, graph link.
	
	    var dataModel = el.dataModel || seriesModel;
	    var dataIndex = el.dataIndex;
	    var dataType = el.dataType;
	    var data = dataModel.getData(dataType);
	    var tooltipModel = buildTooltipModel([data.getItemModel(dataIndex), dataModel, seriesModel && (seriesModel.coordinateSystem || {}).model, this._tooltipModel]);
	    var tooltipTrigger = tooltipModel.get('trigger');
	
	    if (tooltipTrigger != null && tooltipTrigger !== 'item') {
	      return;
	    }
	
	    var params = dataModel.getDataParams(dataIndex, dataType);
	    var seriesTooltip = dataModel.formatTooltip(dataIndex, false, dataType, this._renderMode);
	    var defaultHtml;
	    var markers;
	
	    if (zrUtil.isObject(seriesTooltip)) {
	      defaultHtml = seriesTooltip.html;
	      markers = seriesTooltip.markers;
	    } else {
	      defaultHtml = seriesTooltip;
	      markers = null;
	    }
	
	    var asyncTicket = 'item_' + dataModel.name + '_' + dataIndex;
	
	    this._showOrMove(tooltipModel, function () {
	      this._showTooltipContent(tooltipModel, defaultHtml, params, asyncTicket, e.offsetX, e.offsetY, e.position, e.target, markers);
	    }); // FIXME
	    // duplicated showtip if manuallyShowTip is called from dispatchAction.
	
	
	    dispatchAction({
	      type: 'showTip',
	      dataIndexInside: dataIndex,
	      dataIndex: data.getRawIndex(dataIndex),
	      seriesIndex: seriesIndex,
	      from: this.uid
	    });
	  },
	  _showComponentItemTooltip: function (e, el, dispatchAction) {
	    var tooltipOpt = el.tooltip;
	
	    if (typeof tooltipOpt === 'string') {
	      var content = tooltipOpt;
	      tooltipOpt = {
	        content: content,
	        // Fixed formatter
	        formatter: content
	      };
	    }
	
	    var subTooltipModel = new Model(tooltipOpt, this._tooltipModel, this._ecModel);
	    var defaultHtml = subTooltipModel.get('content');
	    var asyncTicket = Math.random(); // Do not check whether `trigger` is 'none' here, because `trigger`
	    // only works on coordinate system. In fact, we have not found case
	    // that requires setting `trigger` nothing on component yet.
	
	    this._showOrMove(subTooltipModel, function () {
	      this._showTooltipContent(subTooltipModel, defaultHtml, subTooltipModel.get('formatterParams') || {}, asyncTicket, e.offsetX, e.offsetY, e.position, el);
	    }); // If not dispatch showTip, tip may be hide triggered by axis.
	
	
	    dispatchAction({
	      type: 'showTip',
	      from: this.uid
	    });
	  },
	  _showTooltipContent: function (tooltipModel, defaultHtml, params, asyncTicket, x, y, positionExpr, el, markers) {
	    // Reset ticket
	    this._ticket = '';
	
	    if (!tooltipModel.get('showContent') || !tooltipModel.get('show')) {
	      return;
	    }
	
	    var tooltipContent = this._tooltipContent;
	    var formatter = tooltipModel.get('formatter');
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var html = defaultHtml;
	
	    if (formatter && typeof formatter === 'string') {
	      html = formatUtil.formatTpl(formatter, params, true);
	    } else if (typeof formatter === 'function') {
	      var callback = bind(function (cbTicket, html) {
	        if (cbTicket === this._ticket) {
	          tooltipContent.setContent(html, markers, tooltipModel);
	
	          this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	        }
	      }, this);
	      this._ticket = asyncTicket;
	      html = formatter(params, asyncTicket, callback);
	    }
	
	    tooltipContent.setContent(html, markers, tooltipModel);
	    tooltipContent.show(tooltipModel);
	
	    this._updatePosition(tooltipModel, positionExpr, x, y, tooltipContent, params, el);
	  },
	
	  /**
	   * @param  {string|Function|Array.<number>|Object} positionExpr
	   * @param  {number} x Mouse x
	   * @param  {number} y Mouse y
	   * @param  {boolean} confine Whether confine tooltip content in view rect.
	   * @param  {Object|<Array.<Object>} params
	   * @param  {module:zrender/Element} el target element
	   * @param  {module:echarts/ExtensionAPI} api
	   * @return {Array.<number>}
	   */
	  _updatePosition: function (tooltipModel, positionExpr, x, y, content, params, el) {
	    var viewWidth = this._api.getWidth();
	
	    var viewHeight = this._api.getHeight();
	
	    positionExpr = positionExpr || tooltipModel.get('position');
	    var contentSize = content.getSize();
	    var align = tooltipModel.get('align');
	    var vAlign = tooltipModel.get('verticalAlign');
	    var rect = el && el.getBoundingRect().clone();
	    el && rect.applyTransform(el.transform);
	
	    if (typeof positionExpr === 'function') {
	      // Callback of position can be an array or a string specify the position
	      positionExpr = positionExpr([x, y], params, content.el, rect, {
	        viewSize: [viewWidth, viewHeight],
	        contentSize: contentSize.slice()
	      });
	    }
	
	    if (zrUtil.isArray(positionExpr)) {
	      x = parsePercent(positionExpr[0], viewWidth);
	      y = parsePercent(positionExpr[1], viewHeight);
	    } else if (zrUtil.isObject(positionExpr)) {
	      positionExpr.width = contentSize[0];
	      positionExpr.height = contentSize[1];
	      var layoutRect = layoutUtil.getLayoutRect(positionExpr, {
	        width: viewWidth,
	        height: viewHeight
	      });
	      x = layoutRect.x;
	      y = layoutRect.y;
	      align = null; // When positionExpr is left/top/right/bottom,
	      // align and verticalAlign will not work.
	
	      vAlign = null;
	    } // Specify tooltip position by string 'top' 'bottom' 'left' 'right' around graphic element
	    else if (typeof positionExpr === 'string' && el) {
	        var pos = calcTooltipPosition(positionExpr, rect, contentSize);
	        x = pos[0];
	        y = pos[1];
	      } else {
	        var pos = refixTooltipPosition(x, y, content, viewWidth, viewHeight, align ? null : 20, vAlign ? null : 20);
	        x = pos[0];
	        y = pos[1];
	      }
	
	    align && (x -= isCenterAlign(align) ? contentSize[0] / 2 : align === 'right' ? contentSize[0] : 0);
	    vAlign && (y -= isCenterAlign(vAlign) ? contentSize[1] / 2 : vAlign === 'bottom' ? contentSize[1] : 0);
	
	    if (tooltipModel.get('confine')) {
	      var pos = confineTooltipPosition(x, y, content, viewWidth, viewHeight);
	      x = pos[0];
	      y = pos[1];
	    }
	
	    content.moveTo(x, y);
	  },
	  // FIXME
	  // Should we remove this but leave this to user?
	  _updateContentNotChangedOnAxis: function (dataByCoordSys) {
	    var lastCoordSys = this._lastDataByCoordSys;
	    var contentNotChanged = !!lastCoordSys && lastCoordSys.length === dataByCoordSys.length;
	    contentNotChanged && each(lastCoordSys, function (lastItemCoordSys, indexCoordSys) {
	      var lastDataByAxis = lastItemCoordSys.dataByAxis || {};
	      var thisItemCoordSys = dataByCoordSys[indexCoordSys] || {};
	      var thisDataByAxis = thisItemCoordSys.dataByAxis || [];
	      contentNotChanged &= lastDataByAxis.length === thisDataByAxis.length;
	      contentNotChanged && each(lastDataByAxis, function (lastItem, indexAxis) {
	        var thisItem = thisDataByAxis[indexAxis] || {};
	        var lastIndices = lastItem.seriesDataIndices || [];
	        var newIndices = thisItem.seriesDataIndices || [];
	        contentNotChanged &= lastItem.value === thisItem.value && lastItem.axisType === thisItem.axisType && lastItem.axisId === thisItem.axisId && lastIndices.length === newIndices.length;
	        contentNotChanged && each(lastIndices, function (lastIdxItem, j) {
	          var newIdxItem = newIndices[j];
	          contentNotChanged &= lastIdxItem.seriesIndex === newIdxItem.seriesIndex && lastIdxItem.dataIndex === newIdxItem.dataIndex;
	        });
	      });
	    });
	    this._lastDataByCoordSys = dataByCoordSys;
	    return !!contentNotChanged;
	  },
	  _hide: function (dispatchAction) {
	    // Do not directly hideLater here, because this behavior may be prevented
	    // in dispatchAction when showTip is dispatched.
	    // FIXME
	    // duplicated hideTip if manuallyHideTip is called from dispatchAction.
	    this._lastDataByCoordSys = null;
	    dispatchAction({
	      type: 'hideTip',
	      from: this.uid
	    });
	  },
	  dispose: function (ecModel, api) {
	    if (env.node) {
	      return;
	    }
	
	    this._tooltipContent.dispose();
	
	    globalListener.unregister('itemTooltip', api);
	  }
	});
	/**
	 * @param {Array.<Object|module:echarts/model/Model>} modelCascade
	 * From top to bottom. (the last one should be globalTooltipModel);
	 */
	
	
	function buildTooltipModel(modelCascade) {
	  var resultModel = modelCascade.pop();
	
	  while (modelCascade.length) {
	    var tooltipOpt = modelCascade.pop();
	
	    if (tooltipOpt) {
	      if (Model.isInstance(tooltipOpt)) {
	        tooltipOpt = tooltipOpt.get('tooltip', true);
	      } // In each data item tooltip can be simply write:
	      // {
	      //  value: 10,
	      //  tooltip: 'Something you need to know'
	      // }
	
	
	      if (typeof tooltipOpt === 'string') {
	        tooltipOpt = {
	          formatter: tooltipOpt
	        };
	      }
	
	      resultModel = new Model(tooltipOpt, resultModel, resultModel.ecModel);
	    }
	  }
	
	  return resultModel;
	}
	
	function makeDispatchAction(payload, api) {
	  return payload.dispatchAction || zrUtil.bind(api.dispatchAction, api);
	}
	
	function refixTooltipPosition(x, y, content, viewWidth, viewHeight, gapH, gapV) {
	  var size = content.getOuterSize();
	  var width = size.width;
	  var height = size.height;
	
	  if (gapH != null) {
	    if (x + width + gapH > viewWidth) {
	      x -= width + gapH;
	    } else {
	      x += gapH;
	    }
	  }
	
	  if (gapV != null) {
	    if (y + height + gapV > viewHeight) {
	      y -= height + gapV;
	    } else {
	      y += gapV;
	    }
	  }
	
	  return [x, y];
	}
	
	function confineTooltipPosition(x, y, content, viewWidth, viewHeight) {
	  var size = content.getOuterSize();
	  var width = size.width;
	  var height = size.height;
	  x = Math.min(x + width, viewWidth) - width;
	  y = Math.min(y + height, viewHeight) - height;
	  x = Math.max(x, 0);
	  y = Math.max(y, 0);
	  return [x, y];
	}
	
	function calcTooltipPosition(position, rect, contentSize) {
	  var domWidth = contentSize[0];
	  var domHeight = contentSize[1];
	  var gap = 5;
	  var x = 0;
	  var y = 0;
	  var rectWidth = rect.width;
	  var rectHeight = rect.height;
	
	  switch (position) {
	    case 'inside':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'top':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y - domHeight - gap;
	      break;
	
	    case 'bottom':
	      x = rect.x + rectWidth / 2 - domWidth / 2;
	      y = rect.y + rectHeight + gap;
	      break;
	
	    case 'left':
	      x = rect.x - domWidth - gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	      break;
	
	    case 'right':
	      x = rect.x + rectWidth + gap;
	      y = rect.y + rectHeight / 2 - domHeight / 2;
	  }
	
	  return [x, y];
	}
	
	function isCenterAlign(align) {
	  return align === 'center' || align === 'middle';
	}
	
	module.exports = _default;

/***/ },
/* 2391 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(860);
	
	__webpack_require__(861);

/***/ },
/* 2392 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var VisualMapModel = __webpack_require__(853);
	
	var numberUtil = __webpack_require__(25);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Constant
	var DEFAULT_BAR_BOUND = [20, 140];
	var ContinuousModel = VisualMapModel.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    align: 'auto',
	    // 'auto', 'left', 'right', 'top', 'bottom'
	    calculable: false,
	    // This prop effect default component type determine,
	    // See echarts/component/visualMap/typeDefaulter.
	    range: null,
	    // selected range. In default case `range` is [min, max]
	    // and can auto change along with modification of min max,
	    // util use specifid a range.
	    realtime: true,
	    // Whether realtime update.
	    itemHeight: null,
	    // The length of the range control edge.
	    itemWidth: null,
	    // The length of the other side.
	    hoverLink: true,
	    // Enable hover highlight.
	    hoverLinkDataSize: null,
	    // The size of hovered data.
	    hoverLinkOnHandle: null // Whether trigger hoverLink when hover handle.
	    // If not specified, follow the value of `realtime`.
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    ContinuousModel.superApply(this, 'optionUpdated', arguments);
	    this.resetExtent();
	    this.resetVisual(function (mappingOption) {
	      mappingOption.mappingMethod = 'linear';
	      mappingOption.dataExtent = this.getExtent();
	    });
	
	    this._resetRange();
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  resetItemSize: function () {
	    ContinuousModel.superApply(this, 'resetItemSize', arguments);
	    var itemSize = this.itemSize;
	    this._orient === 'horizontal' && itemSize.reverse();
	    (itemSize[0] == null || isNaN(itemSize[0])) && (itemSize[0] = DEFAULT_BAR_BOUND[0]);
	    (itemSize[1] == null || isNaN(itemSize[1])) && (itemSize[1] = DEFAULT_BAR_BOUND[1]);
	  },
	
	  /**
	   * @private
	   */
	  _resetRange: function () {
	    var dataExtent = this.getExtent();
	    var range = this.option.range;
	
	    if (!range || range.auto) {
	      // `range` should always be array (so we dont use other
	      // value like 'auto') for user-friend. (consider getOption).
	      dataExtent.auto = 1;
	      this.option.range = dataExtent;
	    } else if (zrUtil.isArray(range)) {
	      if (range[0] > range[1]) {
	        range.reverse();
	      }
	
	      range[0] = Math.max(range[0], dataExtent[0]);
	      range[1] = Math.min(range[1], dataExtent[1]);
	    }
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	    zrUtil.each(this.stateList, function (state) {
	      var symbolSize = this.option.controller[state].symbolSize;
	
	      if (symbolSize && symbolSize[0] !== symbolSize[1]) {
	        symbolSize[0] = 0; // For good looking.
	      }
	    }, this);
	  },
	
	  /**
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.range = selected.slice();
	
	    this._resetRange();
	  },
	
	  /**
	   * @public
	   */
	  getSelected: function () {
	    var dataExtent = this.getExtent();
	    var dataInterval = numberUtil.asc((this.get('range') || []).slice()); // Clamp
	
	    dataInterval[0] > dataExtent[1] && (dataInterval[0] = dataExtent[1]);
	    dataInterval[1] > dataExtent[1] && (dataInterval[1] = dataExtent[1]);
	    dataInterval[0] < dataExtent[0] && (dataInterval[0] = dataExtent[0]);
	    dataInterval[1] < dataExtent[0] && (dataInterval[1] = dataExtent[0]);
	    return dataInterval;
	  },
	
	  /**
	   * @override
	   */
	  getValueState: function (value) {
	    var range = this.option.range;
	    var dataExtent = this.getExtent(); // When range[0] === dataExtent[0], any value larger than dataExtent[0] maps to 'inRange'.
	    // range[1] is processed likewise.
	
	    return (range[0] <= dataExtent[0] || range[0] <= value) && (range[1] >= dataExtent[1] || value <= range[1]) ? 'inRange' : 'outOfRange';
	  },
	
	  /**
	   * @params {Array.<number>} range target value: range[0] <= value && value <= range[1]
	   * @return {Array.<Object>} [{seriesId, dataIndices: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (range) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        range[0] <= value && value <= range[1] && dataIndices.push(dataIndex);
	      }, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @implement
	   */
	  getVisualMeta: function (getColorVisual) {
	    var oVals = getColorStopValues(this, 'outOfRange', this.getExtent());
	    var iVals = getColorStopValues(this, 'inRange', this.option.range.slice());
	    var stops = [];
	
	    function setStop(value, valueState) {
	      stops.push({
	        value: value,
	        color: getColorVisual(value, valueState)
	      });
	    } // Format to: outOfRange -- inRange -- outOfRange.
	
	
	    var iIdx = 0;
	    var oIdx = 0;
	    var iLen = iVals.length;
	    var oLen = oVals.length;
	
	    for (; oIdx < oLen && (!iVals.length || oVals[oIdx] <= iVals[0]); oIdx++) {
	      // If oVal[oIdx] === iVals[iIdx], oVal[oIdx] should be ignored.
	      if (oVals[oIdx] < iVals[iIdx]) {
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    for (var first = 1; iIdx < iLen; iIdx++, first = 0) {
	      // If range is full, value beyond min, max will be clamped.
	      // make a singularity
	      first && stops.length && setStop(iVals[iIdx], 'outOfRange');
	      setStop(iVals[iIdx], 'inRange');
	    }
	
	    for (var first = 1; oIdx < oLen; oIdx++) {
	      if (!iVals.length || iVals[iVals.length - 1] < oVals[oIdx]) {
	        // make a singularity
	        if (first) {
	          stops.length && setStop(stops[stops.length - 1].value, 'outOfRange');
	          first = 0;
	        }
	
	        setStop(oVals[oIdx], 'outOfRange');
	      }
	    }
	
	    var stopsLen = stops.length;
	    return {
	      stops: stops,
	      outerColors: [stopsLen ? stops[0].color : 'transparent', stopsLen ? stops[stopsLen - 1].color : 'transparent']
	    };
	  }
	});
	
	function getColorStopValues(visualMapModel, valueState, dataExtent) {
	  if (dataExtent[0] === dataExtent[1]) {
	    return dataExtent.slice();
	  } // When using colorHue mapping, it is not linear color any more.
	  // Moreover, canvas gradient seems not to be accurate linear.
	  // FIXME
	  // Should be arbitrary value 100? or based on pixel size?
	
	
	  var count = 200;
	  var step = (dataExtent[1] - dataExtent[0]) / count;
	  var value = dataExtent[0];
	  var stopValues = [];
	
	  for (var i = 0; i <= count && value < dataExtent[1]; i++) {
	    stopValues.push(value);
	    value += step;
	  }
	
	  stopValues.push(dataExtent[1]);
	  return stopValues;
	}
	
	var _default = ContinuousModel;
	module.exports = _default;

/***/ },
/* 2393 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var LinearGradient = __webpack_require__(602);
	
	var eventTool = __webpack_require__(147);
	
	var VisualMapView = __webpack_require__(854);
	
	var graphic = __webpack_require__(14);
	
	var numberUtil = __webpack_require__(25);
	
	var sliderMove = __webpack_require__(249);
	
	var helper = __webpack_require__(855);
	
	var modelUtil = __webpack_require__(29);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var linearMap = numberUtil.linearMap;
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max; // Arbitrary value
	
	var HOVER_LINK_SIZE = 12;
	var HOVER_LINK_OUT = 6; // Notice:
	// Any "interval" should be by the order of [low, high].
	// "handle0" (handleIndex === 0) maps to
	// low data value: this._dataInterval[0] and has low coord.
	// "handle1" (handleIndex === 1) maps to
	// high data value: this._dataInterval[1] and has high coord.
	// The logic of transform is implemented in this._createBarGroup.
	
	var ContinuousView = VisualMapView.extend({
	  type: 'visualMap.continuous',
	
	  /**
	   * @override
	   */
	  init: function () {
	    ContinuousView.superApply(this, 'init', arguments);
	    /**
	     * @private
	     */
	
	    this._shapes = {};
	    /**
	     * @private
	     */
	
	    this._dataInterval = [];
	    /**
	     * @private
	     */
	
	    this._handleEnds = [];
	    /**
	     * @private
	     */
	
	    this._orient;
	    /**
	     * @private
	     */
	
	    this._useHandle;
	    /**
	     * @private
	     */
	
	    this._hoverLinkDataIndices = [];
	    /**
	     * @private
	     */
	
	    this._dragging;
	    /**
	     * @private
	     */
	
	    this._hovering;
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function (visualMapModel, ecModel, api, payload) {
	    if (!payload || payload.type !== 'selectDataRange' || payload.from !== this.uid) {
	      this._buildView();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _buildView: function () {
	    this.group.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var thisGroup = this.group;
	    this._orient = visualMapModel.get('orient');
	    this._useHandle = visualMapModel.get('calculable');
	
	    this._resetInterval();
	
	    this._renderBar(thisGroup);
	
	    var dataRangeText = visualMapModel.get('text');
	
	    this._renderEndsText(thisGroup, dataRangeText, 0);
	
	    this._renderEndsText(thisGroup, dataRangeText, 1); // Do this for background size calculation.
	
	
	    this._updateView(true); // After updating view, inner shapes is built completely,
	    // and then background can be rendered.
	
	
	    this.renderBackground(thisGroup); // Real update view
	
	    this._updateView();
	
	    this._enableHoverLinkToSeries();
	
	    this._enableHoverLinkFromSeries();
	
	    this.positionGroup(thisGroup);
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, dataRangeText, endsIndex) {
	    if (!dataRangeText) {
	      return;
	    } // Compatible with ec2, text[0] map to high value, text[1] map low value.
	
	
	    var text = dataRangeText[1 - endsIndex];
	    text = text != null ? text + '' : '';
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var itemSize = visualMapModel.itemSize;
	    var barGroup = this._shapes.barGroup;
	
	    var position = this._applyTransform([itemSize[0] / 2, endsIndex === 0 ? -textGap : itemSize[1] + textGap], barGroup);
	
	    var align = this._applyTransform(endsIndex === 0 ? 'bottom' : 'top', barGroup);
	
	    var orient = this._orient;
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    this.group.add(new graphic.Text({
	      style: {
	        x: position[0],
	        y: position[1],
	        textVerticalAlign: orient === 'horizontal' ? 'middle' : align,
	        textAlign: orient === 'horizontal' ? align : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	  },
	
	  /**
	   * @private
	   */
	  _renderBar: function (targetGroup) {
	    var visualMapModel = this.visualMapModel;
	    var shapes = this._shapes;
	    var itemSize = visualMapModel.itemSize;
	    var orient = this._orient;
	    var useHandle = this._useHandle;
	    var itemAlign = helper.getItemAlign(visualMapModel, this.api, itemSize);
	
	    var barGroup = shapes.barGroup = this._createBarGroup(itemAlign); // Bar
	
	
	    barGroup.add(shapes.outOfRange = createPolygon());
	    barGroup.add(shapes.inRange = createPolygon(null, useHandle ? getCursor(this._orient) : null, zrUtil.bind(this._dragHandle, this, 'all', false), zrUtil.bind(this._dragHandle, this, 'all', true)));
	    var textRect = visualMapModel.textStyleModel.getTextRect('国');
	    var textSize = mathMax(textRect.width, textRect.height); // Handle
	
	    if (useHandle) {
	      shapes.handleThumbs = [];
	      shapes.handleLabels = [];
	      shapes.handleLabelPoints = [];
	
	      this._createHandle(barGroup, 0, itemSize, textSize, orient, itemAlign);
	
	      this._createHandle(barGroup, 1, itemSize, textSize, orient, itemAlign);
	    }
	
	    this._createIndicator(barGroup, itemSize, textSize, orient);
	
	    targetGroup.add(barGroup);
	  },
	
	  /**
	   * @private
	   */
	  _createHandle: function (barGroup, handleIndex, itemSize, textSize, orient) {
	    var onDrift = zrUtil.bind(this._dragHandle, this, handleIndex, false);
	    var onDragEnd = zrUtil.bind(this._dragHandle, this, handleIndex, true);
	    var handleThumb = createPolygon(createHandlePoints(handleIndex, textSize), getCursor(this._orient), onDrift, onDragEnd);
	    handleThumb.position[0] = itemSize[0];
	    barGroup.add(handleThumb); // Text is always horizontal layout but should not be effected by
	    // transform (orient/inverse). So label is built separately but not
	    // use zrender/graphic/helper/RectText, and is located based on view
	    // group (according to handleLabelPoint) but not barGroup.
	
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var handleLabel = new graphic.Text({
	      draggable: true,
	      drift: onDrift,
	      onmousemove: function (e) {
	        // Fot mobile devicem, prevent screen slider on the button.
	        eventTool.stop(e.event);
	      },
	      ondragend: onDragEnd,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(handleLabel);
	    var handleLabelPoint = [orient === 'horizontal' ? textSize / 2 : textSize * 1.5, orient === 'horizontal' ? handleIndex === 0 ? -(textSize * 1.5) : textSize * 1.5 : handleIndex === 0 ? -textSize / 2 : textSize / 2];
	    var shapes = this._shapes;
	    shapes.handleThumbs[handleIndex] = handleThumb;
	    shapes.handleLabelPoints[handleIndex] = handleLabelPoint;
	    shapes.handleLabels[handleIndex] = handleLabel;
	  },
	
	  /**
	   * @private
	   */
	  _createIndicator: function (barGroup, itemSize, textSize, orient) {
	    var indicator = createPolygon([[0, 0]], 'move');
	    indicator.position[0] = itemSize[0];
	    indicator.attr({
	      invisible: true,
	      silent: true
	    });
	    barGroup.add(indicator);
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    var indicatorLabel = new graphic.Text({
	      silent: true,
	      invisible: true,
	      style: {
	        x: 0,
	        y: 0,
	        text: '',
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    });
	    this.group.add(indicatorLabel);
	    var indicatorLabelPoint = [orient === 'horizontal' ? textSize / 2 : HOVER_LINK_OUT + 3, 0];
	    var shapes = this._shapes;
	    shapes.indicator = indicator;
	    shapes.indicatorLabel = indicatorLabel;
	    shapes.indicatorLabelPoint = indicatorLabelPoint;
	  },
	
	  /**
	   * @private
	   */
	  _dragHandle: function (handleIndex, isEnd, dx, dy) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    this._dragging = !isEnd;
	
	    if (!isEnd) {
	      // Transform dx, dy to bar coordination.
	      var vertex = this._applyTransform([dx, dy], this._shapes.barGroup, true);
	
	      this._updateInterval(handleIndex, vertex[1]); // Considering realtime, update view should be executed
	      // before dispatch action.
	
	
	      this._updateView();
	    } // dragEnd do not dispatch action when realtime.
	
	
	    if (isEnd === !this.visualMapModel.get('realtime')) {
	      // jshint ignore:line
	      this.api.dispatchAction({
	        type: 'selectDataRange',
	        from: this.uid,
	        visualMapId: this.visualMapModel.id,
	        selected: this._dataInterval.slice()
	      });
	    }
	
	    if (isEnd) {
	      !this._hovering && this._clearHoverLinkToSeries();
	    } else if (useHoverLinkOnHandle(this.visualMapModel)) {
	      this._doHoverLinkToSeries(this._handleEnds[handleIndex], false);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _resetInterval: function () {
	    var visualMapModel = this.visualMapModel;
	    var dataInterval = this._dataInterval = visualMapModel.getSelected();
	    var dataExtent = visualMapModel.getExtent();
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    this._handleEnds = [linearMap(dataInterval[0], dataExtent, sizeExtent, true), linearMap(dataInterval[1], dataExtent, sizeExtent, true)];
	  },
	
	  /**
	   * @private
	   * @param {(number|string)} handleIndex 0 or 1 or 'all'
	   * @param {number} dx
	   * @param {number} dy
	   */
	  _updateInterval: function (handleIndex, delta) {
	    delta = delta || 0;
	    var visualMapModel = this.visualMapModel;
	    var handleEnds = this._handleEnds;
	    var sizeExtent = [0, visualMapModel.itemSize[1]];
	    sliderMove(delta, handleEnds, sizeExtent, handleIndex, // cross is forbiden
	    0);
	    var dataExtent = visualMapModel.getExtent(); // Update data interval.
	
	    this._dataInterval = [linearMap(handleEnds[0], sizeExtent, dataExtent, true), linearMap(handleEnds[1], sizeExtent, dataExtent, true)];
	  },
	
	  /**
	   * @private
	   */
	  _updateView: function (forSketch) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var shapes = this._shapes;
	    var outOfRangeHandleEnds = [0, visualMapModel.itemSize[1]];
	    var inRangeHandleEnds = forSketch ? outOfRangeHandleEnds : this._handleEnds;
	
	    var visualInRange = this._createBarVisual(this._dataInterval, dataExtent, inRangeHandleEnds, 'inRange');
	
	    var visualOutOfRange = this._createBarVisual(dataExtent, dataExtent, outOfRangeHandleEnds, 'outOfRange');
	
	    shapes.inRange.setStyle({
	      fill: visualInRange.barColor,
	      opacity: visualInRange.opacity
	    }).setShape('points', visualInRange.barPoints);
	    shapes.outOfRange.setStyle({
	      fill: visualOutOfRange.barColor,
	      opacity: visualOutOfRange.opacity
	    }).setShape('points', visualOutOfRange.barPoints);
	
	    this._updateHandle(inRangeHandleEnds, visualInRange);
	  },
	
	  /**
	   * @private
	   */
	  _createBarVisual: function (dataInterval, dataExtent, handleEnds, forceState) {
	    var opts = {
	      forceState: forceState,
	      convertOpacityToAlpha: true
	    };
	
	    var colorStops = this._makeColorGradient(dataInterval, opts);
	
	    var symbolSizes = [this.getControllerVisual(dataInterval[0], 'symbolSize', opts), this.getControllerVisual(dataInterval[1], 'symbolSize', opts)];
	
	    var barPoints = this._createBarPoints(handleEnds, symbolSizes);
	
	    return {
	      barColor: new LinearGradient(0, 0, 0, 1, colorStops),
	      barPoints: barPoints,
	      handlesColor: [colorStops[0].color, colorStops[colorStops.length - 1].color]
	    };
	  },
	
	  /**
	   * @private
	   */
	  _makeColorGradient: function (dataInterval, opts) {
	    // Considering colorHue, which is not linear, so we have to sample
	    // to calculate gradient color stops, but not only caculate head
	    // and tail.
	    var sampleNumber = 100; // Arbitrary value.
	
	    var colorStops = [];
	    var step = (dataInterval[1] - dataInterval[0]) / sampleNumber;
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[0], 'color', opts),
	      offset: 0
	    });
	
	    for (var i = 1; i < sampleNumber; i++) {
	      var currValue = dataInterval[0] + step * i;
	
	      if (currValue > dataInterval[1]) {
	        break;
	      }
	
	      colorStops.push({
	        color: this.getControllerVisual(currValue, 'color', opts),
	        offset: i / sampleNumber
	      });
	    }
	
	    colorStops.push({
	      color: this.getControllerVisual(dataInterval[1], 'color', opts),
	      offset: 1
	    });
	    return colorStops;
	  },
	
	  /**
	   * @private
	   */
	  _createBarPoints: function (handleEnds, symbolSizes) {
	    var itemSize = this.visualMapModel.itemSize;
	    return [[itemSize[0] - symbolSizes[0], handleEnds[0]], [itemSize[0], handleEnds[0]], [itemSize[0], handleEnds[1]], [itemSize[0] - symbolSizes[1], handleEnds[1]]];
	  },
	
	  /**
	   * @private
	   */
	  _createBarGroup: function (itemAlign) {
	    var orient = this._orient;
	    var inverse = this.visualMapModel.get('inverse');
	    return new graphic.Group(orient === 'horizontal' && !inverse ? {
	      scale: itemAlign === 'bottom' ? [1, 1] : [-1, 1],
	      rotation: Math.PI / 2
	    } : orient === 'horizontal' && inverse ? {
	      scale: itemAlign === 'bottom' ? [-1, 1] : [1, 1],
	      rotation: -Math.PI / 2
	    } : orient === 'vertical' && !inverse ? {
	      scale: itemAlign === 'left' ? [1, -1] : [-1, -1]
	    } : {
	      scale: itemAlign === 'left' ? [1, 1] : [-1, 1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _updateHandle: function (handleEnds, visualInRange) {
	    if (!this._useHandle) {
	      return;
	    }
	
	    var shapes = this._shapes;
	    var visualMapModel = this.visualMapModel;
	    var handleThumbs = shapes.handleThumbs;
	    var handleLabels = shapes.handleLabels;
	    each([0, 1], function (handleIndex) {
	      var handleThumb = handleThumbs[handleIndex];
	      handleThumb.setStyle('fill', visualInRange.handlesColor[handleIndex]);
	      handleThumb.position[1] = handleEnds[handleIndex]; // Update handle label position.
	
	      var textPoint = graphic.applyTransform(shapes.handleLabelPoints[handleIndex], graphic.getTransform(handleThumb, this.group));
	      handleLabels[handleIndex].setStyle({
	        x: textPoint[0],
	        y: textPoint[1],
	        text: visualMapModel.formatValueText(this._dataInterval[handleIndex]),
	        textVerticalAlign: 'middle',
	        textAlign: this._applyTransform(this._orient === 'horizontal' ? handleIndex === 0 ? 'bottom' : 'top' : 'left', shapes.barGroup)
	      });
	    }, this);
	  },
	
	  /**
	   * @private
	   * @param {number} cursorValue
	   * @param {number} textValue
	   * @param {string} [rangeSymbol]
	   * @param {number} [halfHoverLinkSize]
	   */
	  _showIndicator: function (cursorValue, textValue, rangeSymbol, halfHoverLinkSize) {
	    var visualMapModel = this.visualMapModel;
	    var dataExtent = visualMapModel.getExtent();
	    var itemSize = visualMapModel.itemSize;
	    var sizeExtent = [0, itemSize[1]];
	    var pos = linearMap(cursorValue, dataExtent, sizeExtent, true);
	    var shapes = this._shapes;
	    var indicator = shapes.indicator;
	
	    if (!indicator) {
	      return;
	    }
	
	    indicator.position[1] = pos;
	    indicator.attr('invisible', false);
	    indicator.setShape('points', createIndicatorPoints(!!rangeSymbol, halfHoverLinkSize, pos, itemSize[1]));
	    var opts = {
	      convertOpacityToAlpha: true
	    };
	    var color = this.getControllerVisual(cursorValue, 'color', opts);
	    indicator.setStyle('fill', color); // Update handle label position.
	
	    var textPoint = graphic.applyTransform(shapes.indicatorLabelPoint, graphic.getTransform(indicator, this.group));
	    var indicatorLabel = shapes.indicatorLabel;
	    indicatorLabel.attr('invisible', false);
	
	    var align = this._applyTransform('left', shapes.barGroup);
	
	    var orient = this._orient;
	    indicatorLabel.setStyle({
	      text: (rangeSymbol ? rangeSymbol : '') + visualMapModel.formatValueText(textValue),
	      textVerticalAlign: orient === 'horizontal' ? align : 'middle',
	      textAlign: orient === 'horizontal' ? 'center' : align,
	      x: textPoint[0],
	      y: textPoint[1]
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkToSeries: function () {
	    var self = this;
	
	    this._shapes.barGroup.on('mousemove', function (e) {
	      self._hovering = true;
	
	      if (!self._dragging) {
	        var itemSize = self.visualMapModel.itemSize;
	
	        var pos = self._applyTransform([e.offsetX, e.offsetY], self._shapes.barGroup, true, true); // For hover link show when hover handle, which might be
	        // below or upper than sizeExtent.
	
	
	        pos[1] = mathMin(mathMax(0, pos[1]), itemSize[1]);
	
	        self._doHoverLinkToSeries(pos[1], 0 <= pos[0] && pos[0] <= itemSize[0]);
	      }
	    }).on('mouseout', function () {
	      // When mouse is out of handle, hoverLink still need
	      // to be displayed when realtime is set as false.
	      self._hovering = false;
	      !self._dragging && self._clearHoverLinkToSeries();
	    });
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLinkFromSeries: function () {
	    var zr = this.api.getZr();
	
	    if (this.visualMapModel.option.hoverLink) {
	      zr.on('mouseover', this._hoverLinkFromSeriesMouseOver, this);
	      zr.on('mouseout', this._hideIndicator, this);
	    } else {
	      this._clearHoverLinkFromSeries();
	    }
	  },
	
	  /**
	   * @private
	   */
	  _doHoverLinkToSeries: function (cursorPos, hoverOnBar) {
	    var visualMapModel = this.visualMapModel;
	    var itemSize = visualMapModel.itemSize;
	
	    if (!visualMapModel.option.hoverLink) {
	      return;
	    }
	
	    var sizeExtent = [0, itemSize[1]];
	    var dataExtent = visualMapModel.getExtent(); // For hover link show when hover handle, which might be below or upper than sizeExtent.
	
	    cursorPos = mathMin(mathMax(sizeExtent[0], cursorPos), sizeExtent[1]);
	    var halfHoverLinkSize = getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent);
	    var hoverRange = [cursorPos - halfHoverLinkSize, cursorPos + halfHoverLinkSize];
	    var cursorValue = linearMap(cursorPos, sizeExtent, dataExtent, true);
	    var valueRange = [linearMap(hoverRange[0], sizeExtent, dataExtent, true), linearMap(hoverRange[1], sizeExtent, dataExtent, true)]; // Consider data range is out of visualMap range, see test/visualMap-continuous.html,
	    // where china and india has very large population.
	
	    hoverRange[0] < sizeExtent[0] && (valueRange[0] = -Infinity);
	    hoverRange[1] > sizeExtent[1] && (valueRange[1] = Infinity); // Do not show indicator when mouse is over handle,
	    // otherwise labels overlap, especially when dragging.
	
	    if (hoverOnBar) {
	      if (valueRange[0] === -Infinity) {
	        this._showIndicator(cursorValue, valueRange[1], '< ', halfHoverLinkSize);
	      } else if (valueRange[1] === Infinity) {
	        this._showIndicator(cursorValue, valueRange[0], '> ', halfHoverLinkSize);
	      } else {
	        this._showIndicator(cursorValue, cursorValue, '≈ ', halfHoverLinkSize);
	      }
	    } // When realtime is set as false, handles, which are in barGroup,
	    // also trigger hoverLink, which help user to realize where they
	    // focus on when dragging. (see test/heatmap-large.html)
	    // When realtime is set as true, highlight will not show when hover
	    // handle, because the label on handle, which displays a exact value
	    // but not range, might mislead users.
	
	
	    var oldBatch = this._hoverLinkDataIndices;
	    var newBatch = [];
	
	    if (hoverOnBar || useHoverLinkOnHandle(visualMapModel)) {
	      newBatch = this._hoverLinkDataIndices = visualMapModel.findTargetDataIndices(valueRange);
	    }
	
	    var resultBatches = modelUtil.compressBatches(oldBatch, newBatch);
	
	    this._dispatchHighDown('downplay', helper.makeHighDownBatch(resultBatches[0], visualMapModel));
	
	    this._dispatchHighDown('highlight', helper.makeHighDownBatch(resultBatches[1], visualMapModel));
	  },
	
	  /**
	   * @private
	   */
	  _hoverLinkFromSeriesMouseOver: function (e) {
	    var el = e.target;
	    var visualMapModel = this.visualMapModel;
	
	    if (!el || el.dataIndex == null) {
	      return;
	    }
	
	    var dataModel = this.ecModel.getSeriesByIndex(el.seriesIndex);
	
	    if (!visualMapModel.isTargetSeries(dataModel)) {
	      return;
	    }
	
	    var data = dataModel.getData(el.dataType);
	    var value = data.get(visualMapModel.getDataDimension(data), el.dataIndex, true);
	
	    if (!isNaN(value)) {
	      this._showIndicator(value, value);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _hideIndicator: function () {
	    var shapes = this._shapes;
	    shapes.indicator && shapes.indicator.attr('invisible', true);
	    shapes.indicatorLabel && shapes.indicatorLabel.attr('invisible', true);
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkToSeries: function () {
	    this._hideIndicator();
	
	    var indices = this._hoverLinkDataIndices;
	
	    this._dispatchHighDown('downplay', helper.makeHighDownBatch(indices, this.visualMapModel));
	
	    indices.length = 0;
	  },
	
	  /**
	   * @private
	   */
	  _clearHoverLinkFromSeries: function () {
	    this._hideIndicator();
	
	    var zr = this.api.getZr();
	    zr.off('mouseover', this._hoverLinkFromSeriesMouseOver);
	    zr.off('mouseout', this._hideIndicator);
	  },
	
	  /**
	   * @private
	   */
	  _applyTransform: function (vertex, element, inverse, global) {
	    var transform = graphic.getTransform(element, global ? null : this.group);
	    return graphic[zrUtil.isArray(vertex) ? 'applyTransform' : 'transformDirection'](vertex, transform, inverse);
	  },
	
	  /**
	   * @private
	   */
	  _dispatchHighDown: function (type, batch) {
	    batch && batch.length && this.api.dispatchAction({
	      type: type,
	      batch: batch
	    });
	  },
	
	  /**
	   * @override
	   */
	  dispose: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  },
	
	  /**
	   * @override
	   */
	  remove: function () {
	    this._clearHoverLinkFromSeries();
	
	    this._clearHoverLinkToSeries();
	  }
	});
	
	function createPolygon(points, cursor, onDrift, onDragEnd) {
	  return new graphic.Polygon({
	    shape: {
	      points: points
	    },
	    draggable: !!onDrift,
	    cursor: cursor,
	    drift: onDrift,
	    onmousemove: function (e) {
	      // Fot mobile devicem, prevent screen slider on the button.
	      eventTool.stop(e.event);
	    },
	    ondragend: onDragEnd
	  });
	}
	
	function createHandlePoints(handleIndex, textSize) {
	  return handleIndex === 0 ? [[0, 0], [textSize, 0], [textSize, -textSize]] : [[0, 0], [textSize, 0], [textSize, textSize]];
	}
	
	function createIndicatorPoints(isRange, halfHoverLinkSize, pos, extentMax) {
	  return isRange ? [// indicate range
	  [0, -mathMin(halfHoverLinkSize, mathMax(pos, 0))], [HOVER_LINK_OUT, 0], [0, mathMin(halfHoverLinkSize, mathMax(extentMax - pos, 0))]] : [// indicate single value
	  [0, 0], [5, -5], [5, 5]];
	}
	
	function getHalfHoverLinkSize(visualMapModel, dataExtent, sizeExtent) {
	  var halfHoverLinkSize = HOVER_LINK_SIZE / 2;
	  var hoverLinkDataSize = visualMapModel.get('hoverLinkDataSize');
	
	  if (hoverLinkDataSize) {
	    halfHoverLinkSize = linearMap(hoverLinkDataSize, dataExtent, sizeExtent, true) / 2;
	  }
	
	  return halfHoverLinkSize;
	}
	
	function useHoverLinkOnHandle(visualMapModel) {
	  var hoverLinkOnHandle = visualMapModel.get('hoverLinkOnHandle');
	  return !!(hoverLinkOnHandle == null ? visualMapModel.get('realtime') : hoverLinkOnHandle);
	}
	
	function getCursor(orient) {
	  return orient === 'vertical' ? 'ns-resize' : 'ew-resize';
	}
	
	var _default = ContinuousView;
	module.exports = _default;

/***/ },
/* 2394 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(4);
	
	var VisualMapModel = __webpack_require__(853);
	
	var VisualMapping = __webpack_require__(213);
	
	var visualDefault = __webpack_require__(878);
	
	var _number = __webpack_require__(25);
	
	var reformIntervals = _number.reformIntervals;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PiecewiseModel = VisualMapModel.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * Order Rule:
	   *
	   * option.categories / option.pieces / option.text / option.selected:
	   *     If !option.inverse,
	   *     Order when vertical: ['top', ..., 'bottom'].
	   *     Order when horizontal: ['left', ..., 'right'].
	   *     If option.inverse, the meaning of
	   *     the order should be reversed.
	   *
	   * this._pieceList:
	   *     The order is always [low, ..., high].
	   *
	   * Mapping from location to low-high:
	   *     If !option.inverse
	   *     When vertical, top is high.
	   *     When horizontal, right is high.
	   *     If option.inverse, reverse.
	   */
	
	  /**
	   * @protected
	   */
	  defaultOption: {
	    selected: null,
	    // Object. If not specified, means selected.
	    // When pieces and splitNumber: {'0': true, '5': true}
	    // When categories: {'cate1': false, 'cate3': true}
	    // When selected === false, means all unselected.
	    minOpen: false,
	    // Whether include values that smaller than `min`.
	    maxOpen: false,
	    // Whether include values that bigger than `max`.
	    align: 'auto',
	    // 'auto', 'left', 'right'
	    itemWidth: 20,
	    // When put the controller vertically, it is the length of
	    // horizontal side of each item. Otherwise, vertical side.
	    itemHeight: 14,
	    // When put the controller vertically, it is the length of
	    // vertical side of each item. Otherwise, horizontal side.
	    itemSymbol: 'roundRect',
	    pieceList: null,
	    // Each item is Object, with some of those attrs:
	    // {min, max, lt, gt, lte, gte, value,
	    // color, colorSaturation, colorAlpha, opacity,
	    // symbol, symbolSize}, which customize the range or visual
	    // coding of the certain piece. Besides, see "Order Rule".
	    categories: null,
	    // category names, like: ['some1', 'some2', 'some3'].
	    // Attr min/max are ignored when categories set. See "Order Rule"
	    splitNumber: 5,
	    // If set to 5, auto split five pieces equally.
	    // If set to 0 and component type not set, component type will be
	    // determined as "continuous". (It is less reasonable but for ec2
	    // compatibility, see echarts/component/visualMap/typeDefaulter)
	    selectedMode: 'multiple',
	    // Can be 'multiple' or 'single'.
	    itemGap: 10,
	    // The gap between two items, in px.
	    hoverLink: true,
	    // Enable hover highlight.
	    showLabel: null // By default, when text is used, label will hide (the logic
	    // is remained for compatibility reason)
	
	  },
	
	  /**
	   * @override
	   */
	  optionUpdated: function (newOption, isInit) {
	    PiecewiseModel.superApply(this, 'optionUpdated', arguments);
	    /**
	     * The order is always [low, ..., high].
	     * [{text: string, interval: Array.<number>}, ...]
	     * @private
	     * @type {Array.<Object>}
	     */
	
	    this._pieceList = [];
	    this.resetExtent();
	    /**
	     * 'pieces', 'categories', 'splitNumber'
	     * @type {string}
	     */
	
	    var mode = this._mode = this._determineMode();
	
	    resetMethods[this._mode].call(this);
	
	    this._resetSelected(newOption, isInit);
	
	    var categories = this.option.categories;
	    this.resetVisual(function (mappingOption, state) {
	      if (mode === 'categories') {
	        mappingOption.mappingMethod = 'category';
	        mappingOption.categories = zrUtil.clone(categories);
	      } else {
	        mappingOption.dataExtent = this.getExtent();
	        mappingOption.mappingMethod = 'piecewise';
	        mappingOption.pieceList = zrUtil.map(this._pieceList, function (piece) {
	          var piece = zrUtil.clone(piece);
	
	          if (state !== 'inRange') {
	            // FIXME
	            // outOfRange do not support special visual in pieces.
	            piece.visual = null;
	          }
	
	          return piece;
	        });
	      }
	    });
	  },
	
	  /**
	   * @protected
	   * @override
	   */
	  completeVisualOption: function () {
	    // Consider this case:
	    // visualMap: {
	    //      pieces: [{symbol: 'circle', lt: 0}, {symbol: 'rect', gte: 0}]
	    // }
	    // where no inRange/outOfRange set but only pieces. So we should make
	    // default inRange/outOfRange for this case, otherwise visuals that only
	    // appear in `pieces` will not be taken into account in visual encoding.
	    var option = this.option;
	    var visualTypesInPieces = {};
	    var visualTypes = VisualMapping.listVisualTypes();
	    var isCategory = this.isCategory();
	    zrUtil.each(option.pieces, function (piece) {
	      zrUtil.each(visualTypes, function (visualType) {
	        if (piece.hasOwnProperty(visualType)) {
	          visualTypesInPieces[visualType] = 1;
	        }
	      });
	    });
	    zrUtil.each(visualTypesInPieces, function (v, visualType) {
	      var exists = 0;
	      zrUtil.each(this.stateList, function (state) {
	        exists |= has(option, state, visualType) || has(option.target, state, visualType);
	      }, this);
	      !exists && zrUtil.each(this.stateList, function (state) {
	        (option[state] || (option[state] = {}))[visualType] = visualDefault.get(visualType, state === 'inRange' ? 'active' : 'inactive', isCategory);
	      });
	    }, this);
	
	    function has(obj, state, visualType) {
	      return obj && obj[state] && (zrUtil.isObject(obj[state]) ? obj[state].hasOwnProperty(visualType) : obj[state] === visualType // e.g., inRange: 'symbol'
	      );
	    }
	
	    VisualMapModel.prototype.completeVisualOption.apply(this, arguments);
	  },
	  _resetSelected: function (newOption, isInit) {
	    var thisOption = this.option;
	    var pieceList = this._pieceList; // Selected do not merge but all override.
	
	    var selected = (isInit ? thisOption : newOption).selected || {};
	    thisOption.selected = selected; // Consider 'not specified' means true.
	
	    zrUtil.each(pieceList, function (piece, index) {
	      var key = this.getSelectedMapKey(piece);
	
	      if (!selected.hasOwnProperty(key)) {
	        selected[key] = true;
	      }
	    }, this);
	
	    if (thisOption.selectedMode === 'single') {
	      // Ensure there is only one selected.
	      var hasSel = false;
	      zrUtil.each(pieceList, function (piece, index) {
	        var key = this.getSelectedMapKey(piece);
	
	        if (selected[key]) {
	          hasSel ? selected[key] = false : hasSel = true;
	        }
	      }, this);
	    } // thisOption.selectedMode === 'multiple', default: all selected.
	
	  },
	
	  /**
	   * @public
	   */
	  getSelectedMapKey: function (piece) {
	    return this._mode === 'categories' ? piece.value + '' : piece.index + '';
	  },
	
	  /**
	   * @public
	   */
	  getPieceList: function () {
	    return this._pieceList;
	  },
	
	  /**
	   * @private
	   * @return {string}
	   */
	  _determineMode: function () {
	    var option = this.option;
	    return option.pieces && option.pieces.length > 0 ? 'pieces' : this.option.categories ? 'categories' : 'splitNumber';
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  setSelected: function (selected) {
	    this.option.selected = zrUtil.clone(selected);
	  },
	
	  /**
	   * @public
	   * @override
	   */
	  getValueState: function (value) {
	    var index = VisualMapping.findPieceIndex(value, this._pieceList);
	    return index != null ? this.option.selected[this.getSelectedMapKey(this._pieceList[index])] ? 'inRange' : 'outOfRange' : 'outOfRange';
	  },
	
	  /**
	   * @public
	   * @params {number} pieceIndex piece index in visualMapModel.getPieceList()
	   * @return {Array.<Object>} [{seriesId, dataIndex: <Array.<number>>}, ...]
	   */
	  findTargetDataIndices: function (pieceIndex) {
	    var result = [];
	    this.eachTargetSeries(function (seriesModel) {
	      var dataIndices = [];
	      var data = seriesModel.getData();
	      data.each(this.getDataDimension(data), function (value, dataIndex) {
	        // Should always base on model pieceList, because it is order sensitive.
	        var pIdx = VisualMapping.findPieceIndex(value, this._pieceList);
	        pIdx === pieceIndex && dataIndices.push(dataIndex);
	      }, this);
	      result.push({
	        seriesId: seriesModel.id,
	        dataIndex: dataIndices
	      });
	    }, this);
	    return result;
	  },
	
	  /**
	   * @private
	   * @param {Object} piece piece.value or piece.interval is required.
	   * @return {number} Can be Infinity or -Infinity
	   */
	  getRepresentValue: function (piece) {
	    var representValue;
	
	    if (this.isCategory()) {
	      representValue = piece.value;
	    } else {
	      if (piece.value != null) {
	        representValue = piece.value;
	      } else {
	        var pieceInterval = piece.interval || [];
	        representValue = pieceInterval[0] === -Infinity && pieceInterval[1] === Infinity ? 0 : (pieceInterval[0] + pieceInterval[1]) / 2;
	      }
	    }
	
	    return representValue;
	  },
	  getVisualMeta: function (getColorVisual) {
	    // Do not support category. (category axis is ordinal, numerical)
	    if (this.isCategory()) {
	      return;
	    }
	
	    var stops = [];
	    var outerColors = [];
	    var visualMapModel = this;
	
	    function setStop(interval, valueState) {
	      var representValue = visualMapModel.getRepresentValue({
	        interval: interval
	      });
	
	      if (!valueState) {
	        valueState = visualMapModel.getValueState(representValue);
	      }
	
	      var color = getColorVisual(representValue, valueState);
	
	      if (interval[0] === -Infinity) {
	        outerColors[0] = color;
	      } else if (interval[1] === Infinity) {
	        outerColors[1] = color;
	      } else {
	        stops.push({
	          value: interval[0],
	          color: color
	        }, {
	          value: interval[1],
	          color: color
	        });
	      }
	    } // Suplement
	
	
	    var pieceList = this._pieceList.slice();
	
	    if (!pieceList.length) {
	      pieceList.push({
	        interval: [-Infinity, Infinity]
	      });
	    } else {
	      var edge = pieceList[0].interval[0];
	      edge !== -Infinity && pieceList.unshift({
	        interval: [-Infinity, edge]
	      });
	      edge = pieceList[pieceList.length - 1].interval[1];
	      edge !== Infinity && pieceList.push({
	        interval: [edge, Infinity]
	      });
	    }
	
	    var curr = -Infinity;
	    zrUtil.each(pieceList, function (piece) {
	      var interval = piece.interval;
	
	      if (interval) {
	        // Fulfill gap.
	        interval[0] > curr && setStop([curr, interval[0]], 'outOfRange');
	        setStop(interval.slice());
	        curr = interval[1];
	      }
	    }, this);
	    return {
	      stops: stops,
	      outerColors: outerColors
	    };
	  }
	});
	/**
	 * Key is this._mode
	 * @type {Object}
	 * @this {module:echarts/component/viusalMap/PiecewiseMode}
	 */
	
	var resetMethods = {
	  splitNumber: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    var precision = Math.min(thisOption.precision, 20);
	    var dataExtent = this.getExtent();
	    var splitNumber = thisOption.splitNumber;
	    splitNumber = Math.max(parseInt(splitNumber, 10), 1);
	    thisOption.splitNumber = splitNumber;
	    var splitStep = (dataExtent[1] - dataExtent[0]) / splitNumber; // Precision auto-adaption
	
	    while (+splitStep.toFixed(precision) !== splitStep && precision < 5) {
	      precision++;
	    }
	
	    thisOption.precision = precision;
	    splitStep = +splitStep.toFixed(precision);
	
	    if (thisOption.minOpen) {
	      pieceList.push({
	        interval: [-Infinity, dataExtent[0]],
	        close: [0, 0]
	      });
	    }
	
	    for (var index = 0, curr = dataExtent[0]; index < splitNumber; curr += splitStep, index++) {
	      var max = index === splitNumber - 1 ? dataExtent[1] : curr + splitStep;
	      pieceList.push({
	        interval: [curr, max],
	        close: [1, 1]
	      });
	    }
	
	    if (thisOption.maxOpen) {
	      pieceList.push({
	        interval: [dataExtent[1], Infinity],
	        close: [0, 0]
	      });
	    }
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece, index) {
	      piece.index = index;
	      piece.text = this.formatValueText(piece.interval);
	    }, this);
	  },
	  categories: function () {
	    var thisOption = this.option;
	    zrUtil.each(thisOption.categories, function (cate) {
	      // FIXME category模式也使用pieceList，但在visualMapping中不是使用pieceList。
	      // 是否改一致。
	      this._pieceList.push({
	        text: this.formatValueText(cate, true),
	        value: cate
	      });
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, this._pieceList);
	  },
	  pieces: function () {
	    var thisOption = this.option;
	    var pieceList = this._pieceList;
	    zrUtil.each(thisOption.pieces, function (pieceListItem, index) {
	      if (!zrUtil.isObject(pieceListItem)) {
	        pieceListItem = {
	          value: pieceListItem
	        };
	      }
	
	      var item = {
	        text: '',
	        index: index
	      };
	
	      if (pieceListItem.label != null) {
	        item.text = pieceListItem.label;
	      }
	
	      if (pieceListItem.hasOwnProperty('value')) {
	        var value = item.value = pieceListItem.value;
	        item.interval = [value, value];
	        item.close = [1, 1];
	      } else {
	        // `min` `max` is legacy option.
	        // `lt` `gt` `lte` `gte` is recommanded.
	        var interval = item.interval = [];
	        var close = item.close = [0, 0];
	        var closeList = [1, 0, 1];
	        var infinityList = [-Infinity, Infinity];
	        var useMinMax = [];
	
	        for (var lg = 0; lg < 2; lg++) {
	          var names = [['gte', 'gt', 'min'], ['lte', 'lt', 'max']][lg];
	
	          for (var i = 0; i < 3 && interval[lg] == null; i++) {
	            interval[lg] = pieceListItem[names[i]];
	            close[lg] = closeList[i];
	            useMinMax[lg] = i === 2;
	          }
	
	          interval[lg] == null && (interval[lg] = infinityList[lg]);
	        }
	
	        useMinMax[0] && interval[1] === Infinity && (close[0] = 0);
	        useMinMax[1] && interval[0] === -Infinity && (close[1] = 0);
	
	        if (interval[0] === interval[1] && close[0] && close[1]) {
	          // Consider: [{min: 5, max: 5, visual: {...}}, {min: 0, max: 5}],
	          // we use value to lift the priority when min === max
	          item.value = interval[0];
	        }
	      }
	
	      item.visual = VisualMapping.retrieveVisuals(pieceListItem);
	      pieceList.push(item);
	    }, this); // See "Order Rule".
	
	    normalizeReverse(thisOption, pieceList); // Only pieces
	
	    reformIntervals(pieceList);
	    zrUtil.each(pieceList, function (piece) {
	      var close = piece.close;
	      var edgeSymbols = [['<', '≤'][close[1]], ['>', '≥'][close[0]]];
	      piece.text = piece.text || this.formatValueText(piece.value != null ? piece.value : piece.interval, false, edgeSymbols);
	    }, this);
	  }
	};
	
	function normalizeReverse(thisOption, pieceList) {
	  var inverse = thisOption.inverse;
	
	  if (thisOption.orient === 'vertical' ? !inverse : inverse) {
	    pieceList.reverse();
	  }
	}
	
	var _default = PiecewiseModel;
	module.exports = _default;

/***/ },
/* 2395 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var VisualMapView = __webpack_require__(854);
	
	var graphic = __webpack_require__(14);
	
	var _symbol = __webpack_require__(110);
	
	var createSymbol = _symbol.createSymbol;
	
	var layout = __webpack_require__(46);
	
	var helper = __webpack_require__(855);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PiecewiseVisualMapView = VisualMapView.extend({
	  type: 'visualMap.piecewise',
	
	  /**
	   * @protected
	   * @override
	   */
	  doRender: function () {
	    var thisGroup = this.group;
	    thisGroup.removeAll();
	    var visualMapModel = this.visualMapModel;
	    var textGap = visualMapModel.get('textGap');
	    var textStyleModel = visualMapModel.textStyleModel;
	    var textFont = textStyleModel.getFont();
	    var textFill = textStyleModel.getTextColor();
	
	    var itemAlign = this._getItemAlign();
	
	    var itemSize = visualMapModel.itemSize;
	
	    var viewData = this._getViewData();
	
	    var endsText = viewData.endsText;
	    var showLabel = zrUtil.retrieve(visualMapModel.get('showLabel', true), !endsText);
	    endsText && this._renderEndsText(thisGroup, endsText[0], itemSize, showLabel, itemAlign);
	    zrUtil.each(viewData.viewPieceList, renderItem, this);
	    endsText && this._renderEndsText(thisGroup, endsText[1], itemSize, showLabel, itemAlign);
	    layout.box(visualMapModel.get('orient'), thisGroup, visualMapModel.get('itemGap'));
	    this.renderBackground(thisGroup);
	    this.positionGroup(thisGroup);
	
	    function renderItem(item) {
	      var piece = item.piece;
	      var itemGroup = new graphic.Group();
	      itemGroup.onclick = zrUtil.bind(this._onItemClick, this, piece);
	
	      this._enableHoverLink(itemGroup, item.indexInModelPieceList);
	
	      var representValue = visualMapModel.getRepresentValue(piece);
	
	      this._createItemSymbol(itemGroup, representValue, [0, 0, itemSize[0], itemSize[1]]);
	
	      if (showLabel) {
	        var visualState = this.visualMapModel.getValueState(representValue);
	        itemGroup.add(new graphic.Text({
	          style: {
	            x: itemAlign === 'right' ? -textGap : itemSize[0] + textGap,
	            y: itemSize[1] / 2,
	            text: piece.text,
	            textVerticalAlign: 'middle',
	            textAlign: itemAlign,
	            textFont: textFont,
	            textFill: textFill,
	            opacity: visualState === 'outOfRange' ? 0.5 : 1
	          }
	        }));
	      }
	
	      thisGroup.add(itemGroup);
	    }
	  },
	
	  /**
	   * @private
	   */
	  _enableHoverLink: function (itemGroup, pieceIndex) {
	    itemGroup.on('mouseover', zrUtil.bind(onHoverLink, this, 'highlight')).on('mouseout', zrUtil.bind(onHoverLink, this, 'downplay'));
	
	    function onHoverLink(method) {
	      var visualMapModel = this.visualMapModel;
	      visualMapModel.option.hoverLink && this.api.dispatchAction({
	        type: method,
	        batch: helper.makeHighDownBatch(visualMapModel.findTargetDataIndices(pieceIndex), visualMapModel)
	      });
	    }
	  },
	
	  /**
	   * @private
	   */
	  _getItemAlign: function () {
	    var visualMapModel = this.visualMapModel;
	    var modelOption = visualMapModel.option;
	
	    if (modelOption.orient === 'vertical') {
	      return helper.getItemAlign(visualMapModel, this.api, visualMapModel.itemSize);
	    } else {
	      // horizontal, most case left unless specifying right.
	      var align = modelOption.align;
	
	      if (!align || align === 'auto') {
	        align = 'left';
	      }
	
	      return align;
	    }
	  },
	
	  /**
	   * @private
	   */
	  _renderEndsText: function (group, text, itemSize, showLabel, itemAlign) {
	    if (!text) {
	      return;
	    }
	
	    var itemGroup = new graphic.Group();
	    var textStyleModel = this.visualMapModel.textStyleModel;
	    itemGroup.add(new graphic.Text({
	      style: {
	        x: showLabel ? itemAlign === 'right' ? itemSize[0] : 0 : itemSize[0] / 2,
	        y: itemSize[1] / 2,
	        textVerticalAlign: 'middle',
	        textAlign: showLabel ? itemAlign : 'center',
	        text: text,
	        textFont: textStyleModel.getFont(),
	        textFill: textStyleModel.getTextColor()
	      }
	    }));
	    group.add(itemGroup);
	  },
	
	  /**
	   * @private
	   * @return {Object} {peiceList, endsText} The order is the same as screen pixel order.
	   */
	  _getViewData: function () {
	    var visualMapModel = this.visualMapModel;
	    var viewPieceList = zrUtil.map(visualMapModel.getPieceList(), function (piece, index) {
	      return {
	        piece: piece,
	        indexInModelPieceList: index
	      };
	    });
	    var endsText = visualMapModel.get('text'); // Consider orient and inverse.
	
	    var orient = visualMapModel.get('orient');
	    var inverse = visualMapModel.get('inverse'); // Order of model pieceList is always [low, ..., high]
	
	    if (orient === 'horizontal' ? inverse : !inverse) {
	      viewPieceList.reverse();
	    } // Origin order of endsText is [high, low]
	    else if (endsText) {
	        endsText = endsText.slice().reverse();
	      }
	
	    return {
	      viewPieceList: viewPieceList,
	      endsText: endsText
	    };
	  },
	
	  /**
	   * @private
	   */
	  _createItemSymbol: function (group, representValue, shapeParam) {
	    group.add(createSymbol(this.getControllerVisual(representValue, 'symbol'), shapeParam[0], shapeParam[1], shapeParam[2], shapeParam[3], this.getControllerVisual(representValue, 'color')));
	  },
	
	  /**
	   * @private
	   */
	  _onItemClick: function (piece) {
	    var visualMapModel = this.visualMapModel;
	    var option = visualMapModel.option;
	    var selected = zrUtil.clone(option.selected);
	    var newKey = visualMapModel.getSelectedMapKey(piece);
	
	    if (option.selectedMode === 'single') {
	      selected[newKey] = true;
	      zrUtil.each(selected, function (o, key) {
	        selected[key] = key === newKey;
	      });
	    } else {
	      selected[newKey] = !selected[newKey];
	    }
	
	    this.api.dispatchAction({
	      type: 'selectDataRange',
	      from: this.uid,
	      visualMapId: this.visualMapModel.id,
	      selected: selected
	    });
	  }
	});
	var _default = PiecewiseVisualMapView;
	module.exports = _default;

/***/ },
/* 2396 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var textContain = __webpack_require__(102);
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	
	var _axisHelper = __webpack_require__(122);
	
	var makeLabelFormatter = _axisHelper.makeLabelFormatter;
	var getOptionCategoryInterval = _axisHelper.getOptionCategoryInterval;
	var shouldShowAllLabels = _axisHelper.shouldShowAllLabels;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	/**
	 * @param {module:echats/coord/Axis} axis
	 * @return {Object} {
	 *     labels: [{
	 *         formattedLabel: string,
	 *         rawLabel: string,
	 *         tickValue: number
	 *     }, ...],
	 *     labelCategoryInterval: number
	 * }
	 */
	
	function createAxisLabels(axis) {
	  // Only ordinal scale support tick interval
	  return axis.type === 'category' ? makeCategoryLabels(axis) : makeRealNumberLabels(axis);
	}
	/**
	 * @param {module:echats/coord/Axis} axis
	 * @param {module:echarts/model/Model} tickModel For example, can be axisTick, splitLine, splitArea.
	 * @return {Object} {
	 *     ticks: Array.<number>
	 *     tickCategoryInterval: number
	 * }
	 */
	
	
	function createAxisTicks(axis, tickModel) {
	  // Only ordinal scale support tick interval
	  return axis.type === 'category' ? makeCategoryTicks(axis, tickModel) : {
	    ticks: axis.scale.getTicks()
	  };
	}
	
	function makeCategoryLabels(axis) {
	  var labelModel = axis.getLabelModel();
	  var result = makeCategoryLabelsActually(axis, labelModel);
	  return !labelModel.get('show') || axis.scale.isBlank() ? {
	    labels: [],
	    labelCategoryInterval: result.labelCategoryInterval
	  } : result;
	}
	
	function makeCategoryLabelsActually(axis, labelModel) {
	  var labelsCache = getListCache(axis, 'labels');
	  var optionLabelInterval = getOptionCategoryInterval(labelModel);
	  var result = listCacheGet(labelsCache, optionLabelInterval);
	
	  if (result) {
	    return result;
	  }
	
	  var labels;
	  var numericLabelInterval;
	
	  if (zrUtil.isFunction(optionLabelInterval)) {
	    labels = makeLabelsByCustomizedCategoryInterval(axis, optionLabelInterval);
	  } else {
	    numericLabelInterval = optionLabelInterval === 'auto' ? makeAutoCategoryInterval(axis) : optionLabelInterval;
	    labels = makeLabelsByNumericCategoryInterval(axis, numericLabelInterval);
	  } // Cache to avoid calling interval function repeatly.
	
	
	  return listCacheSet(labelsCache, optionLabelInterval, {
	    labels: labels,
	    labelCategoryInterval: numericLabelInterval
	  });
	}
	
	function makeCategoryTicks(axis, tickModel) {
	  var ticksCache = getListCache(axis, 'ticks');
	  var optionTickInterval = getOptionCategoryInterval(tickModel);
	  var result = listCacheGet(ticksCache, optionTickInterval);
	
	  if (result) {
	    return result;
	  }
	
	  var ticks;
	  var tickCategoryInterval; // Optimize for the case that large category data and no label displayed,
	  // we should not return all ticks.
	
	  if (!tickModel.get('show') || axis.scale.isBlank()) {
	    ticks = [];
	  }
	
	  if (zrUtil.isFunction(optionTickInterval)) {
	    ticks = makeLabelsByCustomizedCategoryInterval(axis, optionTickInterval, true);
	  } // Always use label interval by default despite label show. Consider this
	  // scenario, Use multiple grid with the xAxis sync, and only one xAxis shows
	  // labels. `splitLine` and `axisTick` should be consistent in this case.
	  else if (optionTickInterval === 'auto') {
	      var labelsResult = makeCategoryLabelsActually(axis, axis.getLabelModel());
	      tickCategoryInterval = labelsResult.labelCategoryInterval;
	      ticks = zrUtil.map(labelsResult.labels, function (labelItem) {
	        return labelItem.tickValue;
	      });
	    } else {
	      tickCategoryInterval = optionTickInterval;
	      ticks = makeLabelsByNumericCategoryInterval(axis, tickCategoryInterval, true);
	    } // Cache to avoid calling interval function repeatly.
	
	
	  return listCacheSet(ticksCache, optionTickInterval, {
	    ticks: ticks,
	    tickCategoryInterval: tickCategoryInterval
	  });
	}
	
	function makeRealNumberLabels(axis) {
	  var ticks = axis.scale.getTicks();
	  var labelFormatter = makeLabelFormatter(axis);
	  return {
	    labels: zrUtil.map(ticks, function (tickValue, idx) {
	      return {
	        formattedLabel: labelFormatter(tickValue, idx),
	        rawLabel: axis.scale.getLabel(tickValue),
	        tickValue: tickValue
	      };
	    })
	  };
	} // Large category data calculation is performence sensitive, and ticks and label
	// probably be fetched by multiple times. So we cache the result.
	// axis is created each time during a ec process, so we do not need to clear cache.
	
	
	function getListCache(axis, prop) {
	  // Because key can be funciton, and cache size always be small, we use array cache.
	  return inner(axis)[prop] || (inner(axis)[prop] = []);
	}
	
	function listCacheGet(cache, key) {
	  for (var i = 0; i < cache.length; i++) {
	    if (cache[i].key === key) {
	      return cache[i].value;
	    }
	  }
	}
	
	function listCacheSet(cache, key, value) {
	  cache.push({
	    key: key,
	    value: value
	  });
	  return value;
	}
	
	function makeAutoCategoryInterval(axis) {
	  var result = inner(axis).autoInterval;
	  return result != null ? result : inner(axis).autoInterval = axis.calculateCategoryInterval();
	}
	/**
	 * Calculate interval for category axis ticks and labels.
	 * To get precise result, at least one of `getRotate` and `isHorizontal`
	 * should be implemented in axis.
	 */
	
	
	function calculateCategoryInterval(axis) {
	  var params = fetchAutoCategoryIntervalCalculationParams(axis);
	  var labelFormatter = makeLabelFormatter(axis);
	  var rotation = (params.axisRotate - params.labelRotate) / 180 * Math.PI;
	  var ordinalScale = axis.scale;
	  var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	  // avoid generating a long array by `getTicks`
	  // in large category data case.
	
	  var tickCount = ordinalScale.count();
	
	  if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	    return 0;
	  }
	
	  var step = 1; // Simple optimization. Empirical value: tick count should less than 40.
	
	  if (tickCount > 40) {
	    step = Math.max(1, Math.floor(tickCount / 40));
	  }
	
	  var tickValue = ordinalExtent[0];
	  var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	  var unitW = Math.abs(unitSpan * Math.cos(rotation));
	  var unitH = Math.abs(unitSpan * Math.sin(rotation));
	  var maxW = 0;
	  var maxH = 0; // Caution: Performance sensitive for large category data.
	  // Consider dataZoom, we should make appropriate step to avoid O(n) loop.
	
	  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	    var width = 0;
	    var height = 0; // Not precise, do not consider align and vertical align
	    // and each distance from axis line yet.
	
	    var rect = textContain.getBoundingRect(labelFormatter(tickValue), params.font, 'center', 'top'); // Magic number
	
	    width = rect.width * 1.3;
	    height = rect.height * 1.3; // Min size, void long loop.
	
	    maxW = Math.max(maxW, width, 7);
	    maxH = Math.max(maxH, height, 7);
	  }
	
	  var dw = maxW / unitW;
	  var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	  isNaN(dw) && (dw = Infinity);
	  isNaN(dh) && (dh = Infinity);
	  var interval = Math.max(0, Math.floor(Math.min(dw, dh)));
	  var cache = inner(axis.model);
	  var axisExtent = axis.getExtent();
	  var lastAutoInterval = cache.lastAutoInterval;
	  var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	  // otherwise the calculated interval might jitter when the zoom
	  // window size is close to the interval-changing size.
	  // For example, if all of the axis labels are `a, b, c, d, e, f, g`.
	  // The jitter will cause that sometimes the displayed labels are
	  // `a, d, g` (interval: 2) sometimes `a, c, e`(interval: 1).
	
	  if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	  // point is not the same when zooming in or zooming out.
	  && lastAutoInterval > interval // If the axis change is caused by chart resize, the cache should not
	  // be used. Otherwise some hiden labels might not be shown again.
	  && cache.axisExtend0 === axisExtent[0] && cache.axisExtend1 === axisExtent[1]) {
	    interval = lastAutoInterval;
	  } // Only update cache if cache not used, otherwise the
	  // changing of interval is too insensitive.
	  else {
	      cache.lastTickCount = tickCount;
	      cache.lastAutoInterval = interval;
	      cache.axisExtend0 = axisExtent[0];
	      cache.axisExtend1 = axisExtent[1];
	    }
	
	  return interval;
	}
	
	function fetchAutoCategoryIntervalCalculationParams(axis) {
	  var labelModel = axis.getLabelModel();
	  return {
	    axisRotate: axis.getRotate ? axis.getRotate() : axis.isHorizontal && !axis.isHorizontal() ? 90 : 0,
	    labelRotate: labelModel.get('rotate') || 0,
	    font: labelModel.getFont()
	  };
	}
	
	function makeLabelsByNumericCategoryInterval(axis, categoryInterval, onlyTick) {
	  var labelFormatter = makeLabelFormatter(axis);
	  var ordinalScale = axis.scale;
	  var ordinalExtent = ordinalScale.getExtent();
	  var labelModel = axis.getLabelModel();
	  var result = []; // TODO: axisType: ordinalTime, pick the tick from each month/day/year/...
	
	  var step = Math.max((categoryInterval || 0) + 1, 1);
	  var startTick = ordinalExtent[0];
	  var tickCount = ordinalScale.count(); // Calculate start tick based on zero if possible to keep label consistent
	  // while zooming and moving while interval > 0. Otherwise the selection
	  // of displayable ticks and symbols probably keep changing.
	  // 3 is empirical value.
	
	  if (startTick !== 0 && step > 1 && tickCount / step > 2) {
	    startTick = Math.round(Math.ceil(startTick / step) * step);
	  } // (1) Only add min max label here but leave overlap checking
	  // to render stage, which also ensure the returned list
	  // suitable for splitLine and splitArea rendering.
	  // (2) Scales except category always contain min max label so
	  // do not need to perform this process.
	
	
	  var showAllLabel = shouldShowAllLabels(axis);
	  var includeMinLabel = labelModel.get('showMinLabel') || showAllLabel;
	  var includeMaxLabel = labelModel.get('showMaxLabel') || showAllLabel;
	
	  if (includeMinLabel && startTick !== ordinalExtent[0]) {
	    addItem(ordinalExtent[0]);
	  } // Optimize: avoid generating large array by `ordinalScale.getTicks()`.
	
	
	  var tickValue = startTick;
	
	  for (; tickValue <= ordinalExtent[1]; tickValue += step) {
	    addItem(tickValue);
	  }
	
	  if (includeMaxLabel && tickValue - step !== ordinalExtent[1]) {
	    addItem(ordinalExtent[1]);
	  }
	
	  function addItem(tVal) {
	    result.push(onlyTick ? tVal : {
	      formattedLabel: labelFormatter(tVal),
	      rawLabel: ordinalScale.getLabel(tVal),
	      tickValue: tVal
	    });
	  }
	
	  return result;
	} // When interval is function, the result `false` means ignore the tick.
	// It is time consuming for large category data.
	
	
	function makeLabelsByCustomizedCategoryInterval(axis, categoryInterval, onlyTick) {
	  var ordinalScale = axis.scale;
	  var labelFormatter = makeLabelFormatter(axis);
	  var result = [];
	  zrUtil.each(ordinalScale.getTicks(), function (tickValue) {
	    var rawLabel = ordinalScale.getLabel(tickValue);
	
	    if (categoryInterval(tickValue, rawLabel)) {
	      result.push(onlyTick ? tickValue : {
	        formattedLabel: labelFormatter(tickValue),
	        rawLabel: rawLabel,
	        tickValue: tickValue
	      });
	    }
	  });
	  return result;
	}
	
	exports.createAxisLabels = createAxisLabels;
	exports.createAxisTicks = createAxisTicks;
	exports.calculateCategoryInterval = calculateCategoryInterval;

/***/ },
/* 2397 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var layout = __webpack_require__(46);
	
	var numberUtil = __webpack_require__(25);
	
	var CoordinateSystem = __webpack_require__(121);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (24*60*60*1000)
	var PROXIMATE_ONE_DAY = 86400000;
	/**
	 * Calendar
	 *
	 * @constructor
	 *
	 * @param {Object} calendarModel calendarModel
	 * @param {Object} ecModel       ecModel
	 * @param {Object} api           api
	 */
	
	function Calendar(calendarModel, ecModel, api) {
	  this._model = calendarModel;
	}
	
	Calendar.prototype = {
	  constructor: Calendar,
	  type: 'calendar',
	  dimensions: ['time', 'value'],
	  // Required in createListFromData
	  getDimensionsInfo: function () {
	    return [{
	      name: 'time',
	      type: 'time'
	    }, 'value'];
	  },
	  getRangeInfo: function () {
	    return this._rangeInfo;
	  },
	  getModel: function () {
	    return this._model;
	  },
	  getRect: function () {
	    return this._rect;
	  },
	  getCellWidth: function () {
	    return this._sw;
	  },
	  getCellHeight: function () {
	    return this._sh;
	  },
	  getOrient: function () {
	    return this._orient;
	  },
	
	  /**
	   * getFirstDayOfWeek
	   *
	   * @example
	   *     0 : start at Sunday
	   *     1 : start at Monday
	   *
	   * @return {number}
	   */
	  getFirstDayOfWeek: function () {
	    return this._firstDayOfWeek;
	  },
	
	  /**
	   * get date info
	   *
	   * @param  {string|number} date date
	   * @return {Object}
	   * {
	   *      y: string, local full year, eg., '1940',
	   *      m: string, local month, from '01' ot '12',
	   *      d: string, local date, from '01' to '31' (if exists),
	   *      day: It is not date.getDay(). It is the location of the cell in a week, from 0 to 6,
	   *      time: timestamp,
	   *      formatedDate: string, yyyy-MM-dd,
	   *      date: original date object.
	   * }
	   */
	  getDateInfo: function (date) {
	    date = numberUtil.parseDate(date);
	    var y = date.getFullYear();
	    var m = date.getMonth() + 1;
	    m = m < 10 ? '0' + m : m;
	    var d = date.getDate();
	    d = d < 10 ? '0' + d : d;
	    var day = date.getDay();
	    day = Math.abs((day + 7 - this.getFirstDayOfWeek()) % 7);
	    return {
	      y: y,
	      m: m,
	      d: d,
	      day: day,
	      time: date.getTime(),
	      formatedDate: y + '-' + m + '-' + d,
	      date: date
	    };
	  },
	  getNextNDay: function (date, n) {
	    n = n || 0;
	
	    if (n === 0) {
	      return this.getDateInfo(date);
	    }
	
	    date = new Date(this.getDateInfo(date).time);
	    date.setDate(date.getDate() + n);
	    return this.getDateInfo(date);
	  },
	  update: function (ecModel, api) {
	    this._firstDayOfWeek = +this._model.getModel('dayLabel').get('firstDay');
	    this._orient = this._model.get('orient');
	    this._lineWidth = this._model.getModel('itemStyle').getItemStyle().lineWidth || 0;
	    this._rangeInfo = this._getRangeInfo(this._initRangeOption());
	    var weeks = this._rangeInfo.weeks || 1;
	    var whNames = ['width', 'height'];
	
	    var cellSize = this._model.get('cellSize').slice();
	
	    var layoutParams = this._model.getBoxLayoutParams();
	
	    var cellNumbers = this._orient === 'horizontal' ? [weeks, 7] : [7, weeks];
	    zrUtil.each([0, 1], function (idx) {
	      if (cellSizeSpecified(cellSize, idx)) {
	        layoutParams[whNames[idx]] = cellSize[idx] * cellNumbers[idx];
	      }
	    });
	    var whGlobal = {
	      width: api.getWidth(),
	      height: api.getHeight()
	    };
	    var calendarRect = this._rect = layout.getLayoutRect(layoutParams, whGlobal);
	    zrUtil.each([0, 1], function (idx) {
	      if (!cellSizeSpecified(cellSize, idx)) {
	        cellSize[idx] = calendarRect[whNames[idx]] / cellNumbers[idx];
	      }
	    });
	
	    function cellSizeSpecified(cellSize, idx) {
	      return cellSize[idx] != null && cellSize[idx] !== 'auto';
	    }
	
	    this._sw = cellSize[0];
	    this._sh = cellSize[1];
	  },
	
	  /**
	   * Convert a time data(time, value) item to (x, y) point.
	   *
	   * @override
	   * @param  {Array|number} data data
	   * @param  {boolean} [clamp=true] out of range
	   * @return {Array} point
	   */
	  dataToPoint: function (data, clamp) {
	    zrUtil.isArray(data) && (data = data[0]);
	    clamp == null && (clamp = true);
	    var dayInfo = this.getDateInfo(data);
	    var range = this._rangeInfo;
	    var date = dayInfo.formatedDate; // if not in range return [NaN, NaN]
	
	    if (clamp && !(dayInfo.time >= range.start.time && dayInfo.time < range.end.time + PROXIMATE_ONE_DAY)) {
	      return [NaN, NaN];
	    }
	
	    var week = dayInfo.day;
	
	    var nthWeek = this._getRangeInfo([range.start.time, date]).nthWeek;
	
	    if (this._orient === 'vertical') {
	      return [this._rect.x + week * this._sw + this._sw / 2, this._rect.y + nthWeek * this._sh + this._sh / 2];
	    }
	
	    return [this._rect.x + nthWeek * this._sw + this._sw / 2, this._rect.y + week * this._sh + this._sh / 2];
	  },
	
	  /**
	   * Convert a (x, y) point to time data
	   *
	   * @override
	   * @param  {string} point point
	   * @return {string}       data
	   */
	  pointToData: function (point) {
	    var date = this.pointToDate(point);
	    return date && date.time;
	  },
	
	  /**
	   * Convert a time date item to (x, y) four point.
	   *
	   * @param  {Array} data  date[0] is date
	   * @param  {boolean} [clamp=true]  out of range
	   * @return {Object}       point
	   */
	  dataToRect: function (data, clamp) {
	    var point = this.dataToPoint(data, clamp);
	    return {
	      contentShape: {
	        x: point[0] - (this._sw - this._lineWidth) / 2,
	        y: point[1] - (this._sh - this._lineWidth) / 2,
	        width: this._sw - this._lineWidth,
	        height: this._sh - this._lineWidth
	      },
	      center: point,
	      tl: [point[0] - this._sw / 2, point[1] - this._sh / 2],
	      tr: [point[0] + this._sw / 2, point[1] - this._sh / 2],
	      br: [point[0] + this._sw / 2, point[1] + this._sh / 2],
	      bl: [point[0] - this._sw / 2, point[1] + this._sh / 2]
	    };
	  },
	
	  /**
	   * Convert a (x, y) point to time date
	   *
	   * @param  {Array} point point
	   * @return {Object}       date
	   */
	  pointToDate: function (point) {
	    var nthX = Math.floor((point[0] - this._rect.x) / this._sw) + 1;
	    var nthY = Math.floor((point[1] - this._rect.y) / this._sh) + 1;
	    var range = this._rangeInfo.range;
	
	    if (this._orient === 'vertical') {
	      return this._getDateByWeeksAndDay(nthY, nthX - 1, range);
	    }
	
	    return this._getDateByWeeksAndDay(nthX, nthY - 1, range);
	  },
	
	  /**
	   * @inheritDoc
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @inheritDoc
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData'),
	
	  /**
	   * initRange
	   *
	   * @private
	   * @return {Array} [start, end]
	   */
	  _initRangeOption: function () {
	    var range = this._model.get('range');
	
	    var rg = range;
	
	    if (zrUtil.isArray(rg) && rg.length === 1) {
	      rg = rg[0];
	    }
	
	    if (/^\d{4}$/.test(rg)) {
	      range = [rg + '-01-01', rg + '-12-31'];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}$/.test(rg)) {
	      var start = this.getDateInfo(rg);
	      var firstDay = start.date;
	      firstDay.setMonth(firstDay.getMonth() + 1);
	      var end = this.getNextNDay(firstDay, -1);
	      range = [start.formatedDate, end.formatedDate];
	    }
	
	    if (/^\d{4}[\/|-]\d{1,2}[\/|-]\d{1,2}$/.test(rg)) {
	      range = [rg, rg];
	    }
	
	    var tmp = this._getRangeInfo(range);
	
	    if (tmp.start.time > tmp.end.time) {
	      range.reverse();
	    }
	
	    return range;
	  },
	
	  /**
	   * range info
	   *
	   * @private
	   * @param  {Array} range range ['2017-01-01', '2017-07-08']
	   *  If range[0] > range[1], they will not be reversed.
	   * @return {Object}       obj
	   */
	  _getRangeInfo: function (range) {
	    range = [this.getDateInfo(range[0]), this.getDateInfo(range[1])];
	    var reversed;
	
	    if (range[0].time > range[1].time) {
	      reversed = true;
	      range.reverse();
	    }
	
	    var allDay = Math.floor(range[1].time / PROXIMATE_ONE_DAY) - Math.floor(range[0].time / PROXIMATE_ONE_DAY) + 1; // Consider case1 (#11677 #10430):
	    // Set the system timezone as "UK", set the range to `['2016-07-01', '2016-12-31']`
	    // Consider case2:
	    // Firstly set system timezone as "Time Zone: America/Toronto",
	    // ```
	    // var first = new Date(1478412000000 - 3600 * 1000 * 2.5);
	    // var second = new Date(1478412000000);
	    // var allDays = Math.floor(second / ONE_DAY) - Math.floor(first / ONE_DAY) + 1;
	    // ```
	    // will get wrong result because of DST. So we should fix it.
	
	    var date = new Date(range[0].time);
	    var startDateNum = date.getDate();
	    var endDateNum = range[1].date.getDate();
	    date.setDate(startDateNum + allDay - 1); // The bias can not over a month, so just compare date.
	
	    var dateNum = date.getDate();
	
	    if (dateNum !== endDateNum) {
	      var sign = date.getTime() - range[1].time > 0 ? 1 : -1;
	
	      while ((dateNum = date.getDate()) !== endDateNum && (date.getTime() - range[1].time) * sign > 0) {
	        allDay -= sign;
	        date.setDate(dateNum - sign);
	      }
	    }
	
	    var weeks = Math.floor((allDay + range[0].day + 6) / 7);
	    var nthWeek = reversed ? -weeks + 1 : weeks - 1;
	    reversed && range.reverse();
	    return {
	      range: [range[0].formatedDate, range[1].formatedDate],
	      start: range[0],
	      end: range[1],
	      allDay: allDay,
	      weeks: weeks,
	      // From 0.
	      nthWeek: nthWeek,
	      fweek: range[0].day,
	      lweek: range[1].day
	    };
	  },
	
	  /**
	   * get date by nthWeeks and week day in range
	   *
	   * @private
	   * @param  {number} nthWeek the week
	   * @param  {number} day   the week day
	   * @param  {Array} range [d1, d2]
	   * @return {Object}
	   */
	  _getDateByWeeksAndDay: function (nthWeek, day, range) {
	    var rangeInfo = this._getRangeInfo(range);
	
	    if (nthWeek > rangeInfo.weeks || nthWeek === 0 && day < rangeInfo.fweek || nthWeek === rangeInfo.weeks && day > rangeInfo.lweek) {
	      return false;
	    }
	
	    var nthDay = (nthWeek - 1) * 7 - rangeInfo.fweek + day;
	    var date = new Date(rangeInfo.start.time);
	    date.setDate(rangeInfo.start.d + nthDay);
	    return this.getDateInfo(date);
	  }
	};
	Calendar.dimensions = Calendar.prototype.dimensions;
	Calendar.getDimensionsInfo = Calendar.prototype.getDimensionsInfo;
	
	Calendar.create = function (ecModel, api) {
	  var calendarList = [];
	  ecModel.eachComponent('calendar', function (calendarModel) {
	    var calendar = new Calendar(calendarModel, ecModel, api);
	    calendarList.push(calendar);
	    calendarModel.coordinateSystem = calendar;
	  });
	  ecModel.eachSeries(function (calendarSeries) {
	    if (calendarSeries.get('coordinateSystem') === 'calendar') {
	      // Inject coordinate system
	      calendarSeries.coordinateSystem = calendarList[calendarSeries.get('calendarIndex') || 0];
	    }
	  });
	  return calendarList;
	};
	
	function doConvert(methodName, ecModel, finder, value) {
	  var calendarModel = finder.calendarModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = calendarModel ? calendarModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	CoordinateSystem.register('calendar', Calendar);
	var _default = Calendar;
	module.exports = _default;

/***/ },
/* 2398 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var ComponentModel = __webpack_require__(76);
	
	var _layout = __webpack_require__(46);
	
	var getLayoutParams = _layout.getLayoutParams;
	var sizeCalculable = _layout.sizeCalculable;
	var mergeLayoutParam = _layout.mergeLayoutParam;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var CalendarModel = ComponentModel.extend({
	  type: 'calendar',
	
	  /**
	   * @type {module:echarts/coord/calendar/Calendar}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    zlevel: 0,
	    z: 2,
	    left: 80,
	    top: 60,
	    cellSize: 20,
	    // horizontal vertical
	    orient: 'horizontal',
	    // month separate line style
	    splitLine: {
	      show: true,
	      lineStyle: {
	        color: '#000',
	        width: 1,
	        type: 'solid'
	      }
	    },
	    // rect style  temporarily unused emphasis
	    itemStyle: {
	      color: '#fff',
	      borderWidth: 1,
	      borderColor: '#ccc'
	    },
	    // week text style
	    dayLabel: {
	      show: true,
	      // a week first day
	      firstDay: 0,
	      // start end
	      position: 'start',
	      margin: '50%',
	      // 50% of cellSize
	      nameMap: 'en',
	      color: '#000'
	    },
	    // month text style
	    monthLabel: {
	      show: true,
	      // start end
	      position: 'start',
	      margin: 5,
	      // center or left
	      align: 'center',
	      // cn en []
	      nameMap: 'en',
	      formatter: null,
	      color: '#000'
	    },
	    // year text style
	    yearLabel: {
	      show: true,
	      // top bottom left right
	      position: null,
	      margin: 30,
	      formatter: null,
	      color: '#ccc',
	      fontFamily: 'sans-serif',
	      fontWeight: 'bolder',
	      fontSize: 20
	    }
	  },
	
	  /**
	   * @override
	   */
	  init: function (option, parentModel, ecModel, extraOpt) {
	    var inputPositionParams = getLayoutParams(option);
	    CalendarModel.superApply(this, 'init', arguments);
	    mergeAndNormalizeLayoutParams(option, inputPositionParams);
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (option, extraOpt) {
	    CalendarModel.superApply(this, 'mergeOption', arguments);
	    mergeAndNormalizeLayoutParams(this.option, option);
	  }
	});
	
	function mergeAndNormalizeLayoutParams(target, raw) {
	  // Normalize cellSize
	  var cellSize = target.cellSize;
	
	  if (!zrUtil.isArray(cellSize)) {
	    cellSize = target.cellSize = [cellSize, cellSize];
	  } else if (cellSize.length === 1) {
	    cellSize[1] = cellSize[0];
	  }
	
	  var ignoreSize = zrUtil.map([0, 1], function (hvIdx) {
	    // If user have set `width` or both `left` and `right`, cellSize
	    // will be automatically set to 'auto', otherwise the default
	    // setting of cellSize will make `width` setting not work.
	    if (sizeCalculable(raw, hvIdx)) {
	      cellSize[hvIdx] = 'auto';
	    }
	
	    return cellSize[hvIdx] != null && cellSize[hvIdx] !== 'auto';
	  });
	  mergeLayoutParam(target, raw, {
	    type: 'box',
	    ignoreSize: ignoreSize
	  });
	}
	
	var _default = CalendarModel;
	module.exports = _default;

/***/ },
/* 2399 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  var rangeInfo = coordSys.getRangeInfo();
	  return {
	    coordSys: {
	      type: 'calendar',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height,
	      cellWidth: coordSys.getCellWidth(),
	      cellHeight: coordSys.getCellHeight(),
	      rangeInfo: {
	        start: rangeInfo.start,
	        end: rangeInfo.end,
	        weeks: rangeInfo.weeks,
	        dayCount: rangeInfo.allDay
	      }
	    },
	    api: {
	      coord: function (data, clamp) {
	        return coordSys.dataToPoint(data, clamp);
	      }
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 2400 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Axis = __webpack_require__(179);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Extend axis 2d
	 * @constructor module:echarts/coord/cartesian/Axis2D
	 * @extends {module:echarts/coord/cartesian/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var Axis2D = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   */
	
	  this.position = position || 'bottom';
	};
	
	Axis2D.prototype = {
	  constructor: Axis2D,
	
	  /**
	   * Index of axis, can be used as key
	   */
	  index: 0,
	
	  /**
	   * Implemented in <module:echarts/coord/cartesian/Grid>.
	   * @return {Array.<module:echarts/coord/cartesian/Axis2D>}
	   *         If not on zero of other axis, return null/undefined.
	   *         If no axes, return an empty array.
	   */
	  getAxesOnZeroOf: null,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/cartesian/AxisModel}
	   */
	  model: null,
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * Each item cooresponds to this.getExtent(), which
	   * means globalExtent[0] may greater than globalExtent[1],
	   * unless `asc` is input.
	   *
	   * @param {boolean} [asc]
	   * @return {Array.<number>}
	   */
	  getGlobalExtent: function (asc) {
	    var ret = this.getExtent();
	    ret[0] = this.toGlobalCoord(ret[0]);
	    ret[1] = this.toGlobalCoord(ret[1]);
	    asc && ret[0] > ret[1] && ret.reverse();
	    return ret;
	  },
	  getOtherAxis: function () {
	    this.grid.getOtherAxis();
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordToData(this.toLocalCoord(point[this.dim === 'x' ? 0 : 1]), clamp);
	  },
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var localCoord = axis.toLocalCoord(80);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toLocalCoord: null,
	
	  /**
	   * Transform global coord to local coord,
	   * i.e. var globalCoord = axis.toLocalCoord(40);
	   * designate by module:echarts/coord/cartesian/Grid.
	   * @type {Function}
	   */
	  toGlobalCoord: null
	};
	zrUtil.inherits(Axis2D, Axis);
	var _default = Axis2D;
	module.exports = _default;

/***/ },
/* 2401 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Cartesian coordinate system
	 * @module  echarts/coord/Cartesian
	 *
	 */
	function dimAxisMapper(dim) {
	  return this._axes[dim];
	}
	/**
	 * @alias module:echarts/coord/Cartesian
	 * @constructor
	 */
	
	
	var Cartesian = function (name) {
	  this._axes = {};
	  this._dimList = [];
	  /**
	   * @type {string}
	   */
	
	  this.name = name || '';
	};
	
	Cartesian.prototype = {
	  constructor: Cartesian,
	  type: 'cartesian',
	
	  /**
	   * Get axis
	   * @param  {number|string} dim
	   * @return {module:echarts/coord/Cartesian~Axis}
	   */
	  getAxis: function (dim) {
	    return this._axes[dim];
	  },
	
	  /**
	   * Get axes list
	   * @return {Array.<module:echarts/coord/Cartesian~Axis>}
	   */
	  getAxes: function () {
	    return zrUtil.map(this._dimList, dimAxisMapper, this);
	  },
	
	  /**
	   * Get axes list by given scale type
	   */
	  getAxesByScale: function (scaleType) {
	    scaleType = scaleType.toLowerCase();
	    return zrUtil.filter(this.getAxes(), function (axis) {
	      return axis.scale.type === scaleType;
	    });
	  },
	
	  /**
	   * Add axis
	   * @param {module:echarts/coord/Cartesian.Axis}
	   */
	  addAxis: function (axis) {
	    var dim = axis.dim;
	    this._axes[dim] = axis;
	
	    this._dimList.push(dim);
	  },
	
	  /**
	   * Convert data to coord in nd space
	   * @param {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  dataToCoord: function (val) {
	    return this._dataCoordConvert(val, 'dataToCoord');
	  },
	
	  /**
	   * Convert coord in nd space to data
	   * @param  {Array.<number>|Object.<string, number>} val
	   * @return {Array.<number>|Object.<string, number>}
	   */
	  coordToData: function (val) {
	    return this._dataCoordConvert(val, 'coordToData');
	  },
	  _dataCoordConvert: function (input, method) {
	    var dimList = this._dimList;
	    var output = input instanceof Array ? [] : {};
	
	    for (var i = 0; i < dimList.length; i++) {
	      var dim = dimList[i];
	      var axis = this._axes[dim];
	      output[dim] = axis[method](input[dim]);
	    }
	
	    return output;
	  }
	};
	var _default = Cartesian;
	module.exports = _default;

/***/ },
/* 2402 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var BoundingRect = __webpack_require__(60);
	
	var Cartesian = __webpack_require__(2401);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function Cartesian2D(name) {
	  Cartesian.call(this, name);
	}
	
	Cartesian2D.prototype = {
	  constructor: Cartesian2D,
	  type: 'cartesian2d',
	
	  /**
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['x', 'y'],
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/cartesian/Axis2D}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAxis('x');
	  },
	
	  /**
	   * If contain point
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var axisX = this.getAxis('x');
	    var axisY = this.getAxis('y');
	    return axisX.contain(axisX.toLocalCoord(point[0])) && axisY.contain(axisY.toLocalCoord(point[1]));
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this.getAxis('x').containData(data[0]) && this.getAxis('y').containData(data[1]);
	  },
	
	  /**
	   * @param {Array.<number>} data
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, reserved, out) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    out = out || [];
	    out[0] = xAxis.toGlobalCoord(xAxis.dataToCoord(data[0]));
	    out[1] = yAxis.toGlobalCoord(yAxis.dataToCoord(data[1]));
	    return out;
	  },
	
	  /**
	   * @param {Array.<number>} data
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  clampData: function (data, out) {
	    var xScale = this.getAxis('x').scale;
	    var yScale = this.getAxis('y').scale;
	    var xAxisExtent = xScale.getExtent();
	    var yAxisExtent = yScale.getExtent();
	    var x = xScale.parse(data[0]);
	    var y = yScale.parse(data[1]);
	    out = out || [];
	    out[0] = Math.min(Math.max(Math.min(xAxisExtent[0], xAxisExtent[1]), x), Math.max(xAxisExtent[0], xAxisExtent[1]));
	    out[1] = Math.min(Math.max(Math.min(yAxisExtent[0], yAxisExtent[1]), y), Math.max(yAxisExtent[0], yAxisExtent[1]));
	    return out;
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @param {Array.<number>} out
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, out) {
	    var xAxis = this.getAxis('x');
	    var yAxis = this.getAxis('y');
	    out = out || [];
	    out[0] = xAxis.coordToData(xAxis.toLocalCoord(point[0]));
	    out[1] = yAxis.coordToData(yAxis.toLocalCoord(point[1]));
	    return out;
	  },
	
	  /**
	   * Get other axis
	   * @param {module:echarts/coord/cartesian/Axis2D} axis
	   */
	  getOtherAxis: function (axis) {
	    return this.getAxis(axis.dim === 'x' ? 'y' : 'x');
	  },
	
	  /**
	   * Get rect area of cartesian.
	   * Area will have a contain function to determine if a point is in the coordinate system.
	   * @return {BoundingRect}
	   */
	  getArea: function () {
	    var xExtent = this.getAxis('x').getGlobalExtent();
	    var yExtent = this.getAxis('y').getGlobalExtent();
	    var x = Math.min(xExtent[0], xExtent[1]);
	    var y = Math.min(yExtent[0], yExtent[1]);
	    var width = Math.max(xExtent[0], xExtent[1]) - x;
	    var height = Math.max(yExtent[0], yExtent[1]) - y;
	    var rect = new BoundingRect(x, y, width, height);
	    return rect;
	  }
	};
	zrUtil.inherits(Cartesian2D, Cartesian);
	var _default = Cartesian2D;
	module.exports = _default;

/***/ },
/* 2403 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	__webpack_require__(863);
	
	var ComponentModel = __webpack_require__(76);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Grid 是在有直角坐标系的时候必须要存在的
	// 所以这里也要被 Cartesian2D 依赖
	var _default = ComponentModel.extend({
	  type: 'grid',
	  dependencies: ['xAxis', 'yAxis'],
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/cartesian/Grid}
	   */
	  coordinateSystem: null,
	  defaultOption: {
	    show: false,
	    zlevel: 0,
	    z: 0,
	    left: '10%',
	    top: 60,
	    right: '10%',
	    bottom: 60,
	    // If grid size contain label
	    containLabel: false,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    backgroundColor: 'rgba(0,0,0,0)',
	    borderWidth: 1,
	    borderColor: '#ccc'
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2404 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map(['x', 'y'], function (dim, dimIdx) {
	    var axis = this.getAxis(dim);
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.grid.getRect();
	  return {
	    coordSys: {
	      // The name exposed to user is always 'cartesian2d' but not 'grid'.
	      type: 'cartesian2d',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: function (data) {
	        // do not provide "out" param
	        return coordSys.dataToPoint(data);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 2405 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var BoundingRect = __webpack_require__(60);
	
	var View = __webpack_require__(511);
	
	var geoSourceManager = __webpack_require__(358);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * [Geo description]
	 * For backward compatibility, the orginal interface:
	 * `name, map, geoJson, specialAreas, nameMap` is kept.
	 *
	 * @param {string|Object} name
	 * @param {string} map Map type
	 *        Specify the positioned areas by left, top, width, height
	 * @param {Object.<string, string>} [nameMap]
	 *        Specify name alias
	 * @param {boolean} [invertLongitute=true]
	 */
	function Geo(name, map, nameMap, invertLongitute) {
	  View.call(this, name);
	  /**
	   * Map type
	   * @type {string}
	   */
	
	  this.map = map;
	  var source = geoSourceManager.load(map, nameMap);
	  this._nameCoordMap = source.nameCoordMap;
	  this._regionsMap = source.regionsMap;
	  this._invertLongitute = invertLongitute == null ? true : invertLongitute;
	  /**
	   * @readOnly
	   */
	
	  this.regions = source.regions;
	  /**
	   * @type {module:zrender/src/core/BoundingRect}
	   */
	
	  this._rect = source.boundingRect;
	}
	
	Geo.prototype = {
	  constructor: Geo,
	  type: 'geo',
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['lng', 'lat'],
	
	  /**
	   * If contain given lng,lat coord
	   * @param {Array.<number>}
	   * @readOnly
	   */
	  containCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return true;
	      }
	    }
	
	    return false;
	  },
	
	  /**
	   * @override
	   */
	  transformTo: function (x, y, width, height) {
	    var rect = this.getBoundingRect();
	    var invertLongitute = this._invertLongitute;
	    rect = rect.clone();
	
	    if (invertLongitute) {
	      // Longitute is inverted
	      rect.y = -rect.y - rect.height;
	    }
	
	    var rawTransformable = this._rawTransformable;
	    rawTransformable.transform = rect.calculateTransform(new BoundingRect(x, y, width, height));
	    rawTransformable.decomposeTransform();
	
	    if (invertLongitute) {
	      var scale = rawTransformable.scale;
	      scale[1] = -scale[1];
	    }
	
	    rawTransformable.updateTransform();
	
	    this._updateTransform();
	  },
	
	  /**
	   * @param {string} name
	   * @return {module:echarts/coord/geo/Region}
	   */
	  getRegion: function (name) {
	    return this._regionsMap.get(name);
	  },
	  getRegionByCoord: function (coord) {
	    var regions = this.regions;
	
	    for (var i = 0; i < regions.length; i++) {
	      if (regions[i].contain(coord)) {
	        return regions[i];
	      }
	    }
	  },
	
	  /**
	   * Add geoCoord for indexing by name
	   * @param {string} name
	   * @param {Array.<number>} geoCoord
	   */
	  addGeoCoord: function (name, geoCoord) {
	    this._nameCoordMap.set(name, geoCoord);
	  },
	
	  /**
	   * Get geoCoord by name
	   * @param {string} name
	   * @return {Array.<number>}
	   */
	  getGeoCoord: function (name) {
	    return this._nameCoordMap.get(name);
	  },
	
	  /**
	   * @override
	   */
	  getBoundingRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @param {string|Array.<number>} data
	   * @param {boolean} noRoam
	   * @param {Array.<number>} [out]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, noRoam, out) {
	    if (typeof data === 'string') {
	      // Map area name to geoCoord
	      data = this.getGeoCoord(data);
	    }
	
	    if (data) {
	      return View.prototype.dataToPoint.call(this, data, noRoam, out);
	    }
	  },
	
	  /**
	   * @override
	   */
	  convertToPixel: zrUtil.curry(doConvert, 'dataToPoint'),
	
	  /**
	   * @override
	   */
	  convertFromPixel: zrUtil.curry(doConvert, 'pointToData')
	};
	zrUtil.mixin(Geo, View);
	
	function doConvert(methodName, ecModel, finder, value) {
	  var geoModel = finder.geoModel;
	  var seriesModel = finder.seriesModel;
	  var coordSys = geoModel ? geoModel.coordinateSystem : seriesModel ? seriesModel.coordinateSystem // For map.
	  || (seriesModel.getReferringComponents('geo')[0] || {}).coordinateSystem : null;
	  return coordSys === this ? coordSys[methodName](value) : null;
	}
	
	var _default = Geo;
	module.exports = _default;

/***/ },
/* 2406 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var modelUtil = __webpack_require__(29);
	
	var ComponentModel = __webpack_require__(76);
	
	var Model = __webpack_require__(70);
	
	var selectableMixin = __webpack_require__(507);
	
	var geoCreator = __webpack_require__(513);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var GeoModel = ComponentModel.extend({
	  type: 'geo',
	
	  /**
	   * @type {module:echarts/coord/geo/Geo}
	   */
	  coordinateSystem: null,
	  layoutMode: 'box',
	  init: function (option) {
	    ComponentModel.prototype.init.apply(this, arguments); // Default label emphasis `show`
	
	    modelUtil.defaultEmphasis(option, 'label', ['show']);
	  },
	  optionUpdated: function () {
	    var option = this.option;
	    var self = this;
	    option.regions = geoCreator.getFilledRegions(option.regions, option.map, option.nameMap);
	    this._optionModelMap = zrUtil.reduce(option.regions || [], function (optionModelMap, regionOpt) {
	      if (regionOpt.name) {
	        optionModelMap.set(regionOpt.name, new Model(regionOpt, self));
	      }
	
	      return optionModelMap;
	    }, zrUtil.createHashMap());
	    this.updateSelectedMap(option.regions);
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    show: true,
	    left: 'center',
	    top: 'center',
	    // width:,
	    // height:,
	    // right
	    // bottom
	    // Aspect is width / height. Inited to be geoJson bbox aspect
	    // This parameter is used for scale this aspect
	    // If svg used, aspectScale is 1 by default.
	    // aspectScale: 0.75,
	    aspectScale: null,
	    ///// Layout with center and size
	    // If you wan't to put map in a fixed size box with right aspect ratio
	    // This two properties may more conveninet
	    // layoutCenter: [50%, 50%]
	    // layoutSize: 100
	    silent: false,
	    // Map type
	    map: '',
	    // Define left-top, right-bottom coords to control view
	    // For example, [ [180, 90], [-180, -90] ]
	    boundingCoords: null,
	    // Default on center of map
	    center: null,
	    zoom: 1,
	    scaleLimit: null,
	    // selectedMode: false
	    label: {
	      show: false,
	      color: '#000'
	    },
	    itemStyle: {
	      // color: 各异,
	      borderWidth: 0.5,
	      borderColor: '#444',
	      color: '#eee'
	    },
	    emphasis: {
	      label: {
	        show: true,
	        color: 'rgb(100,0,0)'
	      },
	      itemStyle: {
	        color: 'rgba(255,215,0,0.8)'
	      }
	    },
	    regions: []
	  },
	
	  /**
	   * Get model of region
	   * @param  {string} name
	   * @return {module:echarts/model/Model}
	   */
	  getRegionModel: function (name) {
	    return this._optionModelMap.get(name) || new Model(null, this, this.ecModel);
	  },
	
	  /**
	   * Format label
	   * @param {string} name Region name
	   * @param {string} [status='normal'] 'normal' or 'emphasis'
	   * @return {string}
	   */
	  getFormattedLabel: function (name, status) {
	    status = status || 'normal';
	    var regionModel = this.getRegionModel(name);
	    var formatter = regionModel.get((status === 'normal' ? '' : status + '.') + 'label.formatter');
	    var params = {
	      name: name
	    };
	
	    if (typeof formatter === 'function') {
	      params.status = status;
	      return formatter(params);
	    } else if (typeof formatter === 'string') {
	      return formatter.replace('{a}', name != null ? name : '');
	    }
	  },
	  setZoom: function (zoom) {
	    this.option.zoom = zoom;
	  },
	  setCenter: function (center) {
	    this.option.center = center;
	  }
	});
	zrUtil.mixin(GeoModel, selectableMixin);
	var _default = GeoModel;
	module.exports = _default;

/***/ },
/* 2407 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Fix for 钓鱼岛
	// var Region = require('../Region');
	// var zrUtil = require('zrender/src/core/util');
	// var geoCoord = [126, 25];
	var points = [[[123.45165252685547, 25.73527164402261], [123.49731445312499, 25.73527164402261], [123.49731445312499, 25.750734064600884], [123.45165252685547, 25.750734064600884], [123.45165252685547, 25.73527164402261]]];
	
	function _default(mapType, region) {
	  if (mapType === 'china' && region.name === '台湾') {
	    region.geometries.push({
	      type: 'polygon',
	      exterior: points[0]
	    });
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2408 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var geoCoordMap = {
	  'Russia': [100, 60],
	  'United States': [-99, 38],
	  'United States of America': [-99, 38]
	};
	
	function _default(mapType, region) {
	  if (mapType === 'world') {
	    var geoCoord = geoCoordMap[region.name];
	
	    if (geoCoord) {
	      var cp = region.center;
	      cp[0] = geoCoord[0];
	      cp[1] = geoCoord[1];
	    }
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2409 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Region = __webpack_require__(865);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Fix for 南海诸岛
	var geoCoord = [126, 25];
	var points = [[[0, 3.5], [7, 11.2], [15, 11.9], [30, 7], [42, 0.7], [52, 0.7], [56, 7.7], [59, 0.7], [64, 0.7], [64, 0], [5, 0], [0, 3.5]], [[13, 16.1], [19, 14.7], [16, 21.7], [11, 23.1], [13, 16.1]], [[12, 32.2], [14, 38.5], [15, 38.5], [13, 32.2], [12, 32.2]], [[16, 47.6], [12, 53.2], [13, 53.2], [18, 47.6], [16, 47.6]], [[6, 64.4], [8, 70], [9, 70], [8, 64.4], [6, 64.4]], [[23, 82.6], [29, 79.8], [30, 79.8], [25, 82.6], [23, 82.6]], [[37, 70.7], [43, 62.3], [44, 62.3], [39, 70.7], [37, 70.7]], [[48, 51.1], [51, 45.5], [53, 45.5], [50, 51.1], [48, 51.1]], [[51, 35], [51, 28.7], [53, 28.7], [53, 35], [51, 35]], [[52, 22.4], [55, 17.5], [56, 17.5], [53, 22.4], [52, 22.4]], [[58, 12.6], [62, 7], [63, 7], [60, 12.6], [58, 12.6]], [[0, 3.5], [0, 93.1], [64, 93.1], [64, 0], [63, 0], [63, 92.4], [1, 92.4], [1, 3.5], [0, 3.5]]];
	
	for (var i = 0; i < points.length; i++) {
	  for (var k = 0; k < points[i].length; k++) {
	    points[i][k][0] /= 10.5;
	    points[i][k][1] /= -10.5 / 0.75;
	    points[i][k][0] += geoCoord[0];
	    points[i][k][1] += geoCoord[1];
	  }
	}
	
	function _default(mapType, regions) {
	  if (mapType === 'china') {
	    regions.push(new Region('南海诸岛', zrUtil.map(points, function (exterior) {
	      return {
	        type: 'polygon',
	        exterior: exterior
	      };
	    }), geoCoord));
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2410 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var coordsOffsetMap = {
	  '南海诸岛': [32, 80],
	  // 全国
	  '广东': [0, -10],
	  '香港': [10, 5],
	  '澳门': [-10, 10],
	  //'北京': [-10, 0],
	  '天津': [5, 5]
	};
	
	function _default(mapType, region) {
	  if (mapType === 'china') {
	    var coordFix = coordsOffsetMap[region.name];
	
	    if (coordFix) {
	      var cp = region.center;
	      cp[0] += coordFix[0] / 10.5;
	      cp[1] += -coordFix[1] / (10.5 / 0.75);
	    }
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2411 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	
	var parseGeoJson = __webpack_require__(866);
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	
	var fixNanhai = __webpack_require__(2409);
	
	var fixTextCoord = __webpack_require__(2410);
	
	var fixGeoCoord = __webpack_require__(2408);
	
	var fixDiaoyuIsland = __webpack_require__(2407);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Built-in GEO fixer.
	var inner = makeInner();
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} mapRecord {specialAreas, geoJSON}
	   * @param {string} nameProperty
	   * @return {Object} {regions, boundingRect}
	   */
	  load: function (mapName, mapRecord, nameProperty) {
	    var parsed = inner(mapRecord).parsed;
	
	    if (parsed) {
	      return parsed;
	    }
	
	    var specialAreas = mapRecord.specialAreas || {};
	    var geoJSON = mapRecord.geoJSON;
	    var regions; // https://jsperf.com/try-catch-performance-overhead
	
	    try {
	      regions = geoJSON ? parseGeoJson(geoJSON, nameProperty) : [];
	    } catch (e) {
	      throw new Error('Invalid geoJson format\n' + e.message);
	    }
	
	    fixNanhai(mapName, regions);
	    each(regions, function (region) {
	      var regionName = region.name;
	      fixTextCoord(mapName, region);
	      fixGeoCoord(mapName, region);
	      fixDiaoyuIsland(mapName, region); // Some area like Alaska in USA map needs to be tansformed
	      // to look better
	
	      var specialArea = specialAreas[regionName];
	
	      if (specialArea) {
	        region.transformTo(specialArea.left, specialArea.top, specialArea.width, specialArea.height);
	      }
	    });
	    return inner(mapRecord).parsed = {
	      regions: regions,
	      boundingRect: getBoundingRect(regions)
	    };
	  }
	};
	
	function getBoundingRect(regions) {
	  var rect;
	
	  for (var i = 0; i < regions.length; i++) {
	    var regionRect = regions[i].getBoundingRect();
	    rect = rect || regionRect.clone();
	    rect.union(regionRect);
	  }
	
	  return rect;
	}
	
	module.exports = _default;

/***/ },
/* 2412 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _parseSVG = __webpack_require__(1208);
	
	var parseSVG = _parseSVG.parseSVG;
	var makeViewBoxTransform = _parseSVG.makeViewBoxTransform;
	
	var Group = __webpack_require__(223);
	
	var Rect = __webpack_require__(606);
	
	var _util = __webpack_require__(4);
	
	var assert = _util.assert;
	var createHashMap = _util.createHashMap;
	
	var BoundingRect = __webpack_require__(60);
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	var _default = {
	  /**
	   * @param {string} mapName
	   * @param {Object} mapRecord {specialAreas, geoJSON}
	   * @return {Object} {root, boundingRect}
	   */
	  load: function (mapName, mapRecord) {
	    var originRoot = inner(mapRecord).originRoot;
	
	    if (originRoot) {
	      return {
	        root: originRoot,
	        boundingRect: inner(mapRecord).boundingRect
	      };
	    }
	
	    var graphic = buildGraphic(mapRecord);
	    inner(mapRecord).originRoot = graphic.root;
	    inner(mapRecord).boundingRect = graphic.boundingRect;
	    return graphic;
	  },
	  makeGraphic: function (mapName, mapRecord, hostKey) {
	    // For performance consideration (in large SVG), graphic only maked
	    // when necessary and reuse them according to hostKey.
	    var field = inner(mapRecord);
	    var rootMap = field.rootMap || (field.rootMap = createHashMap());
	    var root = rootMap.get(hostKey);
	
	    if (root) {
	      return root;
	    }
	
	    var originRoot = field.originRoot;
	    var boundingRect = field.boundingRect; // For performance, if originRoot is not used by a view,
	    // assign it to a view, but not reproduce graphic elements.
	
	    if (!field.originRootHostKey) {
	      field.originRootHostKey = hostKey;
	      root = originRoot;
	    } else {
	      root = buildGraphic(mapRecord, boundingRect).root;
	    }
	
	    return rootMap.set(hostKey, root);
	  },
	  removeGraphic: function (mapName, mapRecord, hostKey) {
	    var field = inner(mapRecord);
	    var rootMap = field.rootMap;
	    rootMap && rootMap.removeKey(hostKey);
	
	    if (hostKey === field.originRootHostKey) {
	      field.originRootHostKey = null;
	    }
	  }
	};
	
	function buildGraphic(mapRecord, boundingRect) {
	  var svgXML = mapRecord.svgXML;
	  var result;
	  var root;
	
	  try {
	    result = svgXML && parseSVG(svgXML, {
	      ignoreViewBox: true,
	      ignoreRootClip: true
	    }) || {};
	    root = result.root;
	    assert(root != null);
	  } catch (e) {
	    throw new Error('Invalid svg format\n' + e.message);
	  }
	
	  var svgWidth = result.width;
	  var svgHeight = result.height;
	  var viewBoxRect = result.viewBoxRect;
	
	  if (!boundingRect) {
	    boundingRect = svgWidth == null || svgHeight == null ? // If svg width / height not specified, calculate
	    // bounding rect as the width / height
	    root.getBoundingRect() : new BoundingRect(0, 0, 0, 0);
	
	    if (svgWidth != null) {
	      boundingRect.width = svgWidth;
	    }
	
	    if (svgHeight != null) {
	      boundingRect.height = svgHeight;
	    }
	  }
	
	  if (viewBoxRect) {
	    var viewBoxTransform = makeViewBoxTransform(viewBoxRect, boundingRect.width, boundingRect.height);
	    var elRoot = root;
	    root = new Group();
	    root.add(elRoot);
	    elRoot.scale = viewBoxTransform.scale;
	    elRoot.position = viewBoxTransform.position;
	  }
	
	  root.setClipPath(new Rect({
	    shape: boundingRect.plain()
	  }));
	  return {
	    root: root,
	    boundingRect: boundingRect
	  };
	}
	
	module.exports = _default;

/***/ },
/* 2413 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  dataItem = dataItem || [0, 0];
	  return zrUtil.map([0, 1], function (dimIdx) {
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var p1 = [];
	    var p2 = [];
	    p1[dimIdx] = val - halfSize;
	    p2[dimIdx] = val + halfSize;
	    p1[1 - dimIdx] = p2[1 - dimIdx] = dataItem[1 - dimIdx];
	    return Math.abs(this.dataToPoint(p1)[dimIdx] - this.dataToPoint(p2)[dimIdx]);
	  }, this);
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getBoundingRect();
	  return {
	    coordSys: {
	      type: 'geo',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height,
	      zoom: coordSys.getZoom()
	    },
	    api: {
	      coord: function (data) {
	        // do not provide "out" and noRoam param,
	        // Compatible with this usage:
	        // echarts.util.map(item.points, api.coord)
	        return coordSys.dataToPoint(data);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 2414 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var ComponentModel = __webpack_require__(76);
	
	var makeStyleMapper = __webpack_require__(252);
	
	var axisModelCreator = __webpack_require__(357);
	
	var numberUtil = __webpack_require__(25);
	
	var axisModelCommonMixin = __webpack_require__(250);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'baseParallelAxis',
	
	  /**
	   * @type {module:echarts/coord/parallel/Axis}
	   */
	  axis: null,
	
	  /**
	   * @type {Array.<Array.<number>}
	   * @readOnly
	   */
	  activeIntervals: [],
	
	  /**
	   * @return {Object}
	   */
	  getAreaSelectStyle: function () {
	    return makeStyleMapper([['fill', 'color'], ['lineWidth', 'borderWidth'], ['stroke', 'borderColor'], ['width', 'width'], ['opacity', 'opacity']])(this.getModel('areaSelectStyle'));
	  },
	
	  /**
	   * The code of this feature is put on AxisModel but not ParallelAxis,
	   * because axisModel can be alive after echarts updating but instance of
	   * ParallelAxis having been disposed. this._activeInterval should be kept
	   * when action dispatched (i.e. legend click).
	   *
	   * @param {Array.<Array<number>>} intervals interval.length === 0
	   *                                          means set all active.
	   * @public
	   */
	  setActiveIntervals: function (intervals) {
	    var activeIntervals = this.activeIntervals = zrUtil.clone(intervals); // Normalize
	
	    if (activeIntervals) {
	      for (var i = activeIntervals.length - 1; i >= 0; i--) {
	        numberUtil.asc(activeIntervals[i]);
	      }
	    }
	  },
	
	  /**
	   * @param {number|string} [value] When attempting to detect 'no activeIntervals set',
	   *                         value can not be input.
	   * @return {string} 'normal': no activeIntervals set,
	   *                  'active',
	   *                  'inactive'.
	   * @public
	   */
	  getActiveState: function (value) {
	    var activeIntervals = this.activeIntervals;
	
	    if (!activeIntervals.length) {
	      return 'normal';
	    }
	
	    if (value == null || isNaN(value)) {
	      return 'inactive';
	    } // Simple optimization
	
	
	    if (activeIntervals.length === 1) {
	      var interval = activeIntervals[0];
	
	      if (interval[0] <= value && value <= interval[1]) {
	        return 'active';
	      }
	    } else {
	      for (var i = 0, len = activeIntervals.length; i < len; i++) {
	        if (activeIntervals[i][0] <= value && value <= activeIntervals[i][1]) {
	          return 'active';
	        }
	      }
	    }
	
	    return 'inactive';
	  }
	});
	var defaultOption = {
	  type: 'value',
	
	  /**
	   * @type {Array.<number>}
	   */
	  dim: null,
	  // 0, 1, 2, ...
	  // parallelIndex: null,
	  areaSelectStyle: {
	    width: 20,
	    borderWidth: 1,
	    borderColor: 'rgba(160,197,232)',
	    color: 'rgba(160,197,232)',
	    opacity: 0.3
	  },
	  realtime: true,
	  // Whether realtime update view when select.
	  z: 10
	};
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('parallel', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ },
/* 2415 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var matrix = __webpack_require__(86);
	
	var layoutUtil = __webpack_require__(46);
	
	var axisHelper = __webpack_require__(122);
	
	var ParallelAxis = __webpack_require__(2416);
	
	var graphic = __webpack_require__(14);
	
	var numberUtil = __webpack_require__(25);
	
	var sliderMove = __webpack_require__(249);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Parallel Coordinates
	 * <https://en.wikipedia.org/wiki/Parallel_coordinates>
	 */
	var each = zrUtil.each;
	var mathMin = Math.min;
	var mathMax = Math.max;
	var mathFloor = Math.floor;
	var mathCeil = Math.ceil;
	var round = numberUtil.round;
	var PI = Math.PI;
	
	function Parallel(parallelModel, ecModel, api) {
	  /**
	   * key: dimension
	   * @type {Object.<string, module:echarts/coord/parallel/Axis>}
	   * @private
	   */
	  this._axesMap = zrUtil.createHashMap();
	  /**
	   * key: dimension
	   * value: {position: [], rotation, }
	   * @type {Object.<string, Object>}
	   * @private
	   */
	
	  this._axesLayout = {};
	  /**
	   * Always follow axis order.
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = parallelModel.dimensions;
	  /**
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	  /**
	   * @type {module:echarts/coord/parallel/ParallelModel}
	   */
	
	  this._model = parallelModel;
	
	  this._init(parallelModel, ecModel, api);
	}
	
	Parallel.prototype = {
	  type: 'parallel',
	  constructor: Parallel,
	
	  /**
	   * Initialize cartesian coordinate systems
	   * @private
	   */
	  _init: function (parallelModel, ecModel, api) {
	    var dimensions = parallelModel.dimensions;
	    var parallelAxisIndex = parallelModel.parallelAxisIndex;
	    each(dimensions, function (dim, idx) {
	      var axisIndex = parallelAxisIndex[idx];
	      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	
	      var axis = this._axesMap.set(dim, new ParallelAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisIndex));
	
	      var isCategory = axis.type === 'category';
	      axis.onBand = isCategory && axisModel.get('boundaryGap');
	      axis.inverse = axisModel.get('inverse'); // Injection
	
	      axisModel.axis = axis;
	      axis.model = axisModel;
	      axis.coordinateSystem = axisModel.coordinateSystem = this;
	    }, this);
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    this._updateAxesFromSeries(this._model, ecModel);
	  },
	
	  /**
	   * @override
	   */
	  containPoint: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var axisBase = layoutInfo.axisBase;
	    var layoutBase = layoutInfo.layoutBase;
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var pAxis = point[1 - pixelDimIndex];
	    var pLayout = point[pixelDimIndex];
	    return pAxis >= axisBase && pAxis <= axisBase + layoutInfo.axisLength && pLayout >= layoutBase && pLayout <= layoutBase + layoutInfo.layoutLength;
	  },
	  getModel: function () {
	    return this._model;
	  },
	
	  /**
	   * Update properties from series
	   * @private
	   */
	  _updateAxesFromSeries: function (parallelModel, ecModel) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (!parallelModel.contains(seriesModel, ecModel)) {
	        return;
	      }
	
	      var data = seriesModel.getData();
	      each(this.dimensions, function (dim) {
	        var axis = this._axesMap.get(dim);
	
	        axis.scale.unionExtentFromData(data, data.mapDimension(dim));
	        axisHelper.niceScaleExtent(axis.scale, axis.model);
	      }, this);
	    }, this);
	  },
	
	  /**
	   * Resize the parallel coordinate system.
	   * @param {module:echarts/coord/parallel/ParallelModel} parallelModel
	   * @param {module:echarts/ExtensionAPI} api
	   */
	  resize: function (parallelModel, api) {
	    this._rect = layoutUtil.getLayoutRect(parallelModel.getBoxLayoutParams(), {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._layoutAxes();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _makeLayoutInfo: function () {
	    var parallelModel = this._model;
	    var rect = this._rect;
	    var xy = ['x', 'y'];
	    var wh = ['width', 'height'];
	    var layout = parallelModel.get('layout');
	    var pixelDimIndex = layout === 'horizontal' ? 0 : 1;
	    var layoutLength = rect[wh[pixelDimIndex]];
	    var layoutExtent = [0, layoutLength];
	    var axisCount = this.dimensions.length;
	    var axisExpandWidth = restrict(parallelModel.get('axisExpandWidth'), layoutExtent);
	    var axisExpandCount = restrict(parallelModel.get('axisExpandCount') || 0, [0, axisCount]);
	    var axisExpandable = parallelModel.get('axisExpandable') && axisCount > 3 && axisCount > axisExpandCount && axisExpandCount > 1 && axisExpandWidth > 0 && layoutLength > 0; // `axisExpandWindow` is According to the coordinates of [0, axisExpandLength],
	    // for sake of consider the case that axisCollapseWidth is 0 (when screen is narrow),
	    // where collapsed axes should be overlapped.
	
	    var axisExpandWindow = parallelModel.get('axisExpandWindow');
	    var winSize;
	
	    if (!axisExpandWindow) {
	      winSize = restrict(axisExpandWidth * (axisExpandCount - 1), layoutExtent);
	      var axisExpandCenter = parallelModel.get('axisExpandCenter') || mathFloor(axisCount / 2);
	      axisExpandWindow = [axisExpandWidth * axisExpandCenter - winSize / 2];
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    } else {
	      winSize = restrict(axisExpandWindow[1] - axisExpandWindow[0], layoutExtent);
	      axisExpandWindow[1] = axisExpandWindow[0] + winSize;
	    }
	
	    var axisCollapseWidth = (layoutLength - winSize) / (axisCount - axisExpandCount); // Avoid axisCollapseWidth is too small.
	
	    axisCollapseWidth < 3 && (axisCollapseWidth = 0); // Find the first and last indices > ewin[0] and < ewin[1].
	
	    var winInnerIndices = [mathFloor(round(axisExpandWindow[0] / axisExpandWidth, 1)) + 1, mathCeil(round(axisExpandWindow[1] / axisExpandWidth, 1)) - 1]; // Pos in ec coordinates.
	
	    var axisExpandWindow0Pos = axisCollapseWidth / axisExpandWidth * axisExpandWindow[0];
	    return {
	      layout: layout,
	      pixelDimIndex: pixelDimIndex,
	      layoutBase: rect[xy[pixelDimIndex]],
	      layoutLength: layoutLength,
	      axisBase: rect[xy[1 - pixelDimIndex]],
	      axisLength: rect[wh[1 - pixelDimIndex]],
	      axisExpandable: axisExpandable,
	      axisExpandWidth: axisExpandWidth,
	      axisCollapseWidth: axisCollapseWidth,
	      axisExpandWindow: axisExpandWindow,
	      axisCount: axisCount,
	      winInnerIndices: winInnerIndices,
	      axisExpandWindow0Pos: axisExpandWindow0Pos
	    };
	  },
	
	  /**
	   * @private
	   */
	  _layoutAxes: function () {
	    var rect = this._rect;
	    var axes = this._axesMap;
	    var dimensions = this.dimensions;
	
	    var layoutInfo = this._makeLayoutInfo();
	
	    var layout = layoutInfo.layout;
	    axes.each(function (axis) {
	      var axisExtent = [0, layoutInfo.axisLength];
	      var idx = axis.inverse ? 1 : 0;
	      axis.setExtent(axisExtent[idx], axisExtent[1 - idx]);
	    });
	    each(dimensions, function (dim, idx) {
	      var posInfo = (layoutInfo.axisExpandable ? layoutAxisWithExpand : layoutAxisWithoutExpand)(idx, layoutInfo);
	      var positionTable = {
	        horizontal: {
	          x: posInfo.position,
	          y: layoutInfo.axisLength
	        },
	        vertical: {
	          x: 0,
	          y: posInfo.position
	        }
	      };
	      var rotationTable = {
	        horizontal: PI / 2,
	        vertical: 0
	      };
	      var position = [positionTable[layout].x + rect.x, positionTable[layout].y + rect.y];
	      var rotation = rotationTable[layout];
	      var transform = matrix.create();
	      matrix.rotate(transform, transform, rotation);
	      matrix.translate(transform, transform, position); // TODO
	      // tick等排布信息。
	      // TODO
	      // 根据axis order 更新 dimensions顺序。
	
	      this._axesLayout[dim] = {
	        position: position,
	        rotation: rotation,
	        transform: transform,
	        axisNameAvailableWidth: posInfo.axisNameAvailableWidth,
	        axisLabelShow: posInfo.axisLabelShow,
	        nameTruncateMaxWidth: posInfo.nameTruncateMaxWidth,
	        tickDirection: 1,
	        labelDirection: 1
	      };
	    }, this);
	  },
	
	  /**
	   * Get axis by dim.
	   * @param {string} dim
	   * @return {module:echarts/coord/parallel/ParallelAxis} [description]
	   */
	  getAxis: function (dim) {
	    return this._axesMap.get(dim);
	  },
	
	  /**
	   * Convert a dim value of a single item of series data to Point.
	   * @param {*} value
	   * @param {string} dim
	   * @return {Array}
	   */
	  dataToPoint: function (value, dim) {
	    return this.axisCoordToPoint(this._axesMap.get(dim).dataToCoord(value), dim);
	  },
	
	  /**
	   * Travel data for one time, get activeState of each data item.
	   * @param {module:echarts/data/List} data
	   * @param {Functio} cb param: {string} activeState 'active' or 'inactive' or 'normal'
	   *                            {number} dataIndex
	   * @param {number} [start=0] the start dataIndex that travel from.
	   * @param {number} [end=data.count()] the next dataIndex of the last dataIndex will be travel.
	   */
	  eachActiveState: function (data, callback, start, end) {
	    start == null && (start = 0);
	    end == null && (end = data.count());
	    var axesMap = this._axesMap;
	    var dimensions = this.dimensions;
	    var dataDimensions = [];
	    var axisModels = [];
	    zrUtil.each(dimensions, function (axisDim) {
	      dataDimensions.push(data.mapDimension(axisDim));
	      axisModels.push(axesMap.get(axisDim).model);
	    });
	    var hasActiveSet = this.hasAxisBrushed();
	
	    for (var dataIndex = start; dataIndex < end; dataIndex++) {
	      var activeState;
	
	      if (!hasActiveSet) {
	        activeState = 'normal';
	      } else {
	        activeState = 'active';
	        var values = data.getValues(dataDimensions, dataIndex);
	
	        for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	          var state = axisModels[j].getActiveState(values[j]);
	
	          if (state === 'inactive') {
	            activeState = 'inactive';
	            break;
	          }
	        }
	      }
	
	      callback(activeState, dataIndex);
	    }
	  },
	
	  /**
	   * Whether has any activeSet.
	   * @return {boolean}
	   */
	  hasAxisBrushed: function () {
	    var dimensions = this.dimensions;
	    var axesMap = this._axesMap;
	    var hasActiveSet = false;
	
	    for (var j = 0, lenj = dimensions.length; j < lenj; j++) {
	      if (axesMap.get(dimensions[j]).model.getActiveState() !== 'normal') {
	        hasActiveSet = true;
	      }
	    }
	
	    return hasActiveSet;
	  },
	
	  /**
	   * Convert coords of each axis to Point.
	   *  Return point. For example: [10, 20]
	   * @param {Array.<number>} coords
	   * @param {string} dim
	   * @return {Array.<number>}
	   */
	  axisCoordToPoint: function (coord, dim) {
	    var axisLayout = this._axesLayout[dim];
	    return graphic.applyTransform([coord, 0], axisLayout.transform);
	  },
	
	  /**
	   * Get axis layout.
	   */
	  getAxisLayout: function (dim) {
	    return zrUtil.clone(this._axesLayout[dim]);
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Object} {axisExpandWindow, delta, behavior: 'jump' | 'slide' | 'none'}.
	   */
	  getSlidedAxisExpandWindow: function (point) {
	    var layoutInfo = this._makeLayoutInfo();
	
	    var pixelDimIndex = layoutInfo.pixelDimIndex;
	    var axisExpandWindow = layoutInfo.axisExpandWindow.slice();
	    var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	    var extent = [0, layoutInfo.axisExpandWidth * (layoutInfo.axisCount - 1)]; // Out of the area of coordinate system.
	
	    if (!this.containPoint(point)) {
	      return {
	        behavior: 'none',
	        axisExpandWindow: axisExpandWindow
	      };
	    } // Conver the point from global to expand coordinates.
	
	
	    var pointCoord = point[pixelDimIndex] - layoutInfo.layoutBase - layoutInfo.axisExpandWindow0Pos; // For dragging operation convenience, the window should not be
	    // slided when mouse is the center area of the window.
	
	    var delta;
	    var behavior = 'slide';
	    var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	
	    var triggerArea = this._model.get('axisExpandSlideTriggerArea'); // But consider touch device, jump is necessary.
	
	
	    var useJump = triggerArea[0] != null;
	
	    if (axisCollapseWidth) {
	      if (useJump && axisCollapseWidth && pointCoord < winSize * triggerArea[0]) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * triggerArea[2];
	      } else if (useJump && axisCollapseWidth && pointCoord > winSize * (1 - triggerArea[0])) {
	        behavior = 'jump';
	        delta = pointCoord - winSize * (1 - triggerArea[2]);
	      } else {
	        (delta = pointCoord - winSize * triggerArea[1]) >= 0 && (delta = pointCoord - winSize * (1 - triggerArea[1])) <= 0 && (delta = 0);
	      }
	
	      delta *= layoutInfo.axisExpandWidth / axisCollapseWidth;
	      delta ? sliderMove(delta, axisExpandWindow, extent, 'all') // Avoid nonsense triger on mousemove.
	      : behavior = 'none';
	    } // When screen is too narrow, make it visible and slidable, although it is hard to interact.
	    else {
	        var winSize = axisExpandWindow[1] - axisExpandWindow[0];
	        var pos = extent[1] * pointCoord / winSize;
	        axisExpandWindow = [mathMax(0, pos - winSize / 2)];
	        axisExpandWindow[1] = mathMin(extent[1], axisExpandWindow[0] + winSize);
	        axisExpandWindow[0] = axisExpandWindow[1] - winSize;
	      }
	
	    return {
	      axisExpandWindow: axisExpandWindow,
	      behavior: behavior
	    };
	  }
	};
	
	function restrict(len, extent) {
	  return mathMin(mathMax(len, extent[0]), extent[1]);
	}
	
	function layoutAxisWithoutExpand(axisIndex, layoutInfo) {
	  var step = layoutInfo.layoutLength / (layoutInfo.axisCount - 1);
	  return {
	    position: step * axisIndex,
	    axisNameAvailableWidth: step,
	    axisLabelShow: true
	  };
	}
	
	function layoutAxisWithExpand(axisIndex, layoutInfo) {
	  var layoutLength = layoutInfo.layoutLength;
	  var axisExpandWidth = layoutInfo.axisExpandWidth;
	  var axisCount = layoutInfo.axisCount;
	  var axisCollapseWidth = layoutInfo.axisCollapseWidth;
	  var winInnerIndices = layoutInfo.winInnerIndices;
	  var position;
	  var axisNameAvailableWidth = axisCollapseWidth;
	  var axisLabelShow = false;
	  var nameTruncateMaxWidth;
	
	  if (axisIndex < winInnerIndices[0]) {
	    position = axisIndex * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  } else if (axisIndex <= winInnerIndices[1]) {
	    position = layoutInfo.axisExpandWindow0Pos + axisIndex * axisExpandWidth - layoutInfo.axisExpandWindow[0];
	    axisNameAvailableWidth = axisExpandWidth;
	    axisLabelShow = true;
	  } else {
	    position = layoutLength - (axisCount - 1 - axisIndex) * axisCollapseWidth;
	    nameTruncateMaxWidth = axisCollapseWidth;
	  }
	
	  return {
	    position: position,
	    axisNameAvailableWidth: axisNameAvailableWidth,
	    axisLabelShow: axisLabelShow,
	    nameTruncateMaxWidth: nameTruncateMaxWidth
	  };
	}
	
	var _default = Parallel;
	module.exports = _default;

/***/ },
/* 2416 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Axis = __webpack_require__(179);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor module:echarts/coord/parallel/ParallelAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 */
	var ParallelAxis = function (dim, scale, coordExtent, axisType, axisIndex) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.axisIndex = axisIndex;
	};
	
	ParallelAxis.prototype = {
	  constructor: ParallelAxis,
	
	  /**
	   * Axis model
	   * @param {module:echarts/coord/parallel/AxisModel}
	   */
	  model: null,
	
	  /**
	   * @override
	   */
	  isHorizontal: function () {
	    return this.coordinateSystem.getModel().get('layout') !== 'horizontal';
	  }
	};
	zrUtil.inherits(ParallelAxis, Axis);
	var _default = ParallelAxis;
	module.exports = _default;

/***/ },
/* 2417 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Component = __webpack_require__(76);
	
	__webpack_require__(2414);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = Component.extend({
	  type: 'parallel',
	  dependencies: ['parallelAxis'],
	
	  /**
	   * @type {module:echarts/coord/parallel/Parallel}
	   */
	  coordinateSystem: null,
	
	  /**
	   * Each item like: 'dim0', 'dim1', 'dim2', ...
	   * @type {Array.<string>}
	   * @readOnly
	   */
	  dimensions: null,
	
	  /**
	   * Coresponding to dimensions.
	   * @type {Array.<number>}
	   * @readOnly
	   */
	  parallelAxisIndex: null,
	  layoutMode: 'box',
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    left: 80,
	    top: 60,
	    right: 80,
	    bottom: 60,
	    // width: {totalWidth} - left - right,
	    // height: {totalHeight} - top - bottom,
	    layout: 'horizontal',
	    // 'horizontal' or 'vertical'
	    // FIXME
	    // naming?
	    axisExpandable: false,
	    axisExpandCenter: null,
	    axisExpandCount: 0,
	    axisExpandWidth: 50,
	    // FIXME '10%' ?
	    axisExpandRate: 17,
	    axisExpandDebounce: 50,
	    // [out, in, jumpTarget]. In percentage. If use [null, 0.05], null means full.
	    // Do not doc to user until necessary.
	    axisExpandSlideTriggerArea: [-0.15, 0.05, 0.4],
	    axisExpandTriggerOn: 'click',
	    // 'mousemove' or 'click'
	    parallelAxisDefault: null
	  },
	
	  /**
	   * @override
	   */
	  init: function () {
	    Component.prototype.init.apply(this, arguments);
	    this.mergeOption({});
	  },
	
	  /**
	   * @override
	   */
	  mergeOption: function (newOption) {
	    var thisOption = this.option;
	    newOption && zrUtil.merge(thisOption, newOption, true);
	
	    this._initDimensions();
	  },
	
	  /**
	   * Whether series or axis is in this coordinate system.
	   * @param {module:echarts/model/Series|module:echarts/coord/parallel/AxisModel} model
	   * @param {module:echarts/model/Global} ecModel
	   */
	  contains: function (model, ecModel) {
	    var parallelIndex = model.get('parallelIndex');
	    return parallelIndex != null && ecModel.getComponent('parallel', parallelIndex) === this;
	  },
	  setAxisExpand: function (opt) {
	    zrUtil.each(['axisExpandable', 'axisExpandCenter', 'axisExpandCount', 'axisExpandWidth', 'axisExpandWindow'], function (name) {
	      if (opt.hasOwnProperty(name)) {
	        this.option[name] = opt[name];
	      }
	    }, this);
	  },
	
	  /**
	   * @private
	   */
	  _initDimensions: function () {
	    var dimensions = this.dimensions = [];
	    var parallelAxisIndex = this.parallelAxisIndex = [];
	    var axisModels = zrUtil.filter(this.dependentModels.parallelAxis, function (axisModel) {
	      // Can not use this.contains here, because
	      // initialization has not been completed yet.
	      return (axisModel.get('parallelIndex') || 0) === this.componentIndex;
	    }, this);
	    zrUtil.each(axisModels, function (axisModel) {
	      dimensions.push('dim' + axisModel.get('dim'));
	      parallelAxisIndex.push(axisModel.componentIndex);
	    });
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2418 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var modelUtil = __webpack_require__(29);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(option) {
	  createParallelIfNeeded(option);
	  mergeAxisOptionFromParallel(option);
	}
	/**
	 * Create a parallel coordinate if not exists.
	 * @inner
	 */
	
	
	function createParallelIfNeeded(option) {
	  if (option.parallel) {
	    return;
	  }
	
	  var hasParallelSeries = false;
	  zrUtil.each(option.series, function (seriesOpt) {
	    if (seriesOpt && seriesOpt.type === 'parallel') {
	      hasParallelSeries = true;
	    }
	  });
	
	  if (hasParallelSeries) {
	    option.parallel = [{}];
	  }
	}
	/**
	 * Merge aixs definition from parallel option (if exists) to axis option.
	 * @inner
	 */
	
	
	function mergeAxisOptionFromParallel(option) {
	  var axes = modelUtil.normalizeToArray(option.parallelAxis);
	  zrUtil.each(axes, function (axisOption) {
	    if (!zrUtil.isObject(axisOption)) {
	      return;
	    }
	
	    var parallelIndex = axisOption.parallelIndex || 0;
	    var parallelOption = modelUtil.normalizeToArray(option.parallel)[parallelIndex];
	
	    if (parallelOption && parallelOption.parallelAxisDefault) {
	      zrUtil.merge(axisOption, parallelOption.parallelAxisDefault, false);
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2419 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var textContain = __webpack_require__(102);
	
	var Axis = __webpack_require__(179);
	
	var _model = __webpack_require__(29);
	
	var makeInner = _model.makeInner;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var inner = makeInner();
	
	function AngleAxis(scale, angleExtent) {
	  angleExtent = angleExtent || [0, 360];
	  Axis.call(this, 'angle', scale, angleExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	AngleAxis.prototype = {
	  constructor: AngleAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToAngle: Axis.prototype.dataToCoord,
	  angleToData: Axis.prototype.coordToData,
	
	  /**
	   * Only be called in category axis.
	   * Angle axis uses text height to decide interval
	   *
	   * @override
	   * @return {number} Auto interval for cateogry axis tick and label
	   */
	  calculateCategoryInterval: function () {
	    var axis = this;
	    var labelModel = axis.getLabelModel();
	    var ordinalScale = axis.scale;
	    var ordinalExtent = ordinalScale.getExtent(); // Providing this method is for optimization:
	    // avoid generating a long array by `getTicks`
	    // in large category data case.
	
	    var tickCount = ordinalScale.count();
	
	    if (ordinalExtent[1] - ordinalExtent[0] < 1) {
	      return 0;
	    }
	
	    var tickValue = ordinalExtent[0];
	    var unitSpan = axis.dataToCoord(tickValue + 1) - axis.dataToCoord(tickValue);
	    var unitH = Math.abs(unitSpan); // Not precise, just use height as text width
	    // and each distance from axis line yet.
	
	    var rect = textContain.getBoundingRect(tickValue, labelModel.getFont(), 'center', 'top');
	    var maxH = Math.max(rect.height, 7);
	    var dh = maxH / unitH; // 0/0 is NaN, 1/0 is Infinity.
	
	    isNaN(dh) && (dh = Infinity);
	    var interval = Math.max(0, Math.floor(dh));
	    var cache = inner(axis.model);
	    var lastAutoInterval = cache.lastAutoInterval;
	    var lastTickCount = cache.lastTickCount; // Use cache to keep interval stable while moving zoom window,
	    // otherwise the calculated interval might jitter when the zoom
	    // window size is close to the interval-changing size.
	
	    if (lastAutoInterval != null && lastTickCount != null && Math.abs(lastAutoInterval - interval) <= 1 && Math.abs(lastTickCount - tickCount) <= 1 // Always choose the bigger one, otherwise the critical
	    // point is not the same when zooming in or zooming out.
	    && lastAutoInterval > interval) {
	      interval = lastAutoInterval;
	    } // Only update cache if cache not used, otherwise the
	    // changing of interval is too insensitive.
	    else {
	        cache.lastTickCount = tickCount;
	        cache.lastAutoInterval = interval;
	      }
	
	    return interval;
	  }
	};
	zrUtil.inherits(AngleAxis, Axis);
	var _default = AngleAxis;
	module.exports = _default;

/***/ },
/* 2420 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var ComponentModel = __webpack_require__(76);
	
	var axisModelCreator = __webpack_require__(357);
	
	var axisModelCommonMixin = __webpack_require__(250);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PolarAxisModel = ComponentModel.extend({
	  type: 'polarAxis',
	
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  axis: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this.ecModel.queryComponents({
	      mainType: 'polar',
	      index: this.option.polarIndex,
	      id: this.option.polarId
	    })[0];
	  }
	});
	zrUtil.merge(PolarAxisModel.prototype, axisModelCommonMixin);
	var polarAxisDefaultExtendedOption = {
	  angle: {
	    // polarIndex: 0,
	    // polarId: '',
	    startAngle: 90,
	    clockwise: true,
	    splitNumber: 12,
	    axisLabel: {
	      rotate: false
	    }
	  },
	  radius: {
	    // polarIndex: 0,
	    // polarId: '',
	    splitNumber: 5
	  }
	};
	
	function getAxisType(axisDim, option) {
	  // Default axis with data is category axis
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	axisModelCreator('angle', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.angle);
	axisModelCreator('radius', PolarAxisModel, getAxisType, polarAxisDefaultExtendedOption.radius);

/***/ },
/* 2421 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var RadiusAxis = __webpack_require__(2423);
	
	var AngleAxis = __webpack_require__(2419);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/coord/polar/Polar
	 */
	
	/**
	 * @alias {module:echarts/coord/polar/Polar}
	 * @constructor
	 * @param {string} name
	 */
	var Polar = function (name) {
	  /**
	   * @type {string}
	   */
	  this.name = name || '';
	  /**
	   * x of polar center
	   * @type {number}
	   */
	
	  this.cx = 0;
	  /**
	   * y of polar center
	   * @type {number}
	   */
	
	  this.cy = 0;
	  /**
	   * @type {module:echarts/coord/polar/RadiusAxis}
	   * @private
	   */
	
	  this._radiusAxis = new RadiusAxis();
	  /**
	   * @type {module:echarts/coord/polar/AngleAxis}
	   * @private
	   */
	
	  this._angleAxis = new AngleAxis();
	  this._radiusAxis.polar = this._angleAxis.polar = this;
	};
	
	Polar.prototype = {
	  type: 'polar',
	  axisPointerEnabled: true,
	  constructor: Polar,
	
	  /**
	   * @param {Array.<string>}
	   * @readOnly
	   */
	  dimensions: ['radius', 'angle'],
	
	  /**
	   * @type {module:echarts/coord/PolarModel}
	   */
	  model: null,
	
	  /**
	   * If contain coord
	   * @param {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var coord = this.pointToCoord(point);
	    return this._radiusAxis.contain(coord[0]) && this._angleAxis.contain(coord[1]);
	  },
	
	  /**
	   * If contain data
	   * @param {Array.<number>} data
	   * @return {boolean}
	   */
	  containData: function (data) {
	    return this._radiusAxis.containData(data[0]) && this._angleAxis.containData(data[1]);
	  },
	
	  /**
	   * @param {string} dim
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxis: function (dim) {
	    return this['_' + dim + 'Axis'];
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._radiusAxis, this._angleAxis];
	  },
	
	  /**
	   * Get axes by type of scale
	   * @param {string} scaleType
	   * @return {module:echarts/coord/polar/AngleAxis|module:echarts/coord/polar/RadiusAxis}
	   */
	  getAxesByScale: function (scaleType) {
	    var axes = [];
	    var angleAxis = this._angleAxis;
	    var radiusAxis = this._radiusAxis;
	    angleAxis.scale.type === scaleType && axes.push(angleAxis);
	    radiusAxis.scale.type === scaleType && axes.push(radiusAxis);
	    return axes;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/AngleAxis}
	   */
	  getAngleAxis: function () {
	    return this._angleAxis;
	  },
	
	  /**
	   * @return {module:echarts/coord/polar/RadiusAxis}
	   */
	  getRadiusAxis: function () {
	    return this._radiusAxis;
	  },
	
	  /**
	   * @param {module:echarts/coord/polar/Axis}
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getOtherAxis: function (axis) {
	    var angleAxis = this._angleAxis;
	    return axis === angleAxis ? this._radiusAxis : angleAxis;
	  },
	
	  /**
	   * Base axis will be used on stacking.
	   *
	   * @return {module:echarts/coord/polar/Axis}
	   */
	  getBaseAxis: function () {
	    return this.getAxesByScale('ordinal')[0] || this.getAxesByScale('time')[0] || this.getAngleAxis();
	  },
	
	  /**
	   * @param {string} [dim] 'radius' or 'angle' or 'auto' or null/undefined
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function (dim) {
	    var baseAxis = dim != null && dim !== 'auto' ? this.getAxis(dim) : this.getBaseAxis();
	    return {
	      baseAxes: [baseAxis],
	      otherAxes: [this.getOtherAxis(baseAxis)]
	    };
	  },
	
	  /**
	   * Convert a single data item to (x, y) point.
	   * Parameter data is an array which the first element is radius and the second is angle
	   * @param {Array.<number>} data
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (data, clamp) {
	    return this.coordToPoint([this._radiusAxis.dataToRadius(data[0], clamp), this._angleAxis.dataToAngle(data[1], clamp)]);
	  },
	
	  /**
	   * Convert a (x, y) point to data
	   * @param {Array.<number>} point
	   * @param {boolean} [clamp=false]
	   * @return {Array.<number>}
	   */
	  pointToData: function (point, clamp) {
	    var coord = this.pointToCoord(point);
	    return [this._radiusAxis.radiusToData(coord[0], clamp), this._angleAxis.angleToData(coord[1], clamp)];
	  },
	
	  /**
	   * Convert a (x, y) point to (radius, angle) coord
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToCoord: function (point) {
	    var dx = point[0] - this.cx;
	    var dy = point[1] - this.cy;
	    var angleAxis = this.getAngleAxis();
	    var extent = angleAxis.getExtent();
	    var minAngle = Math.min(extent[0], extent[1]);
	    var maxAngle = Math.max(extent[0], extent[1]); // Fix fixed extent in polarCreator
	    // FIXME
	
	    angleAxis.inverse ? minAngle = maxAngle - 360 : maxAngle = minAngle + 360;
	    var radius = Math.sqrt(dx * dx + dy * dy);
	    dx /= radius;
	    dy /= radius;
	    var radian = Math.atan2(-dy, dx) / Math.PI * 180; // move to angleExtent
	
	    var dir = radian < minAngle ? 1 : -1;
	
	    while (radian < minAngle || radian > maxAngle) {
	      radian += dir * 360;
	    }
	
	    return [radius, radian];
	  },
	
	  /**
	   * Convert a (radius, angle) coord to (x, y) point
	   * @param {Array.<number>} coord
	   * @return {Array.<number>}
	   */
	  coordToPoint: function (coord) {
	    var radius = coord[0];
	    var radian = coord[1] / 180 * Math.PI;
	    var x = Math.cos(radian) * radius + this.cx; // Inverse the y
	
	    var y = -Math.sin(radian) * radius + this.cy;
	    return [x, y];
	  },
	
	  /**
	   * Get ring area of cartesian.
	   * Area will have a contain function to determine if a point is in the coordinate system.
	   * @return {Ring}
	   */
	  getArea: function () {
	    var angleAxis = this.getAngleAxis();
	    var radiusAxis = this.getRadiusAxis();
	    var radiusExtent = radiusAxis.getExtent().slice();
	    radiusExtent[0] > radiusExtent[1] && radiusExtent.reverse();
	    var angleExtent = angleAxis.getExtent();
	    var RADIAN = Math.PI / 180;
	    return {
	      cx: this.cx,
	      cy: this.cy,
	      r0: radiusExtent[0],
	      r: radiusExtent[1],
	      startAngle: -angleExtent[0] * RADIAN,
	      endAngle: -angleExtent[1] * RADIAN,
	      clockwise: angleAxis.inverse,
	      contain: function (x, y) {
	        // It's a ring shape.
	        // Start angle and end angle don't matter
	        var dx = x - this.cx;
	        var dy = y - this.cy;
	        var d2 = dx * dx + dy * dy;
	        var r = this.r;
	        var r0 = this.r0;
	        return d2 <= r * r && d2 >= r0 * r0;
	      }
	    };
	  }
	};
	var _default = Polar;
	module.exports = _default;

/***/ },
/* 2422 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	__webpack_require__(2420);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = echarts.extendComponentModel({
	  type: 'polar',
	  dependencies: ['polarAxis', 'angleAxis'],
	
	  /**
	   * @type {module:echarts/coord/polar/Polar}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @param {string} axisType
	   * @return {module:echarts/coord/polar/AxisModel}
	   */
	  findAxisModel: function (axisType) {
	    var foundAxisModel;
	    var ecModel = this.ecModel;
	    ecModel.eachComponent(axisType, function (axisModel) {
	      if (axisModel.getCoordSysModel() === this) {
	        foundAxisModel = axisModel;
	      }
	    }, this);
	    return foundAxisModel;
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '80%'
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2423 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Axis = __webpack_require__(179);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function RadiusAxis(scale, radiusExtent) {
	  Axis.call(this, 'radius', scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'category';
	}
	
	RadiusAxis.prototype = {
	  constructor: RadiusAxis,
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.polar.pointToData(point, clamp)[this.dim === 'radius' ? 0 : 1];
	  },
	  dataToRadius: Axis.prototype.dataToCoord,
	  radiusToData: Axis.prototype.coordToData
	};
	zrUtil.inherits(RadiusAxis, Axis);
	var _default = RadiusAxis;
	module.exports = _default;

/***/ },
/* 2424 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  return zrUtil.map(['Radius', 'Angle'], function (dim, dimIdx) {
	    var axis = this['get' + dim + 'Axis']();
	    var val = dataItem[dimIdx];
	    var halfSize = dataSize[dimIdx] / 2;
	    var method = 'dataTo' + dim;
	    var result = axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis[method](val - halfSize) - axis[method](val + halfSize));
	
	    if (dim === 'Angle') {
	      result = result * Math.PI / 180;
	    }
	
	    return result;
	  }, this);
	}
	
	function _default(coordSys) {
	  var radiusAxis = coordSys.getRadiusAxis();
	  var angleAxis = coordSys.getAngleAxis();
	  var radius = radiusAxis.getExtent();
	  radius[0] > radius[1] && radius.reverse();
	  return {
	    coordSys: {
	      type: 'polar',
	      cx: coordSys.cx,
	      cy: coordSys.cy,
	      r: radius[1],
	      r0: radius[0]
	    },
	    api: {
	      coord: zrUtil.bind(function (data) {
	        var radius = radiusAxis.dataToRadius(data[0]);
	        var angle = angleAxis.dataToAngle(data[1]);
	        var coord = coordSys.coordToPoint([radius, angle]);
	        coord.push(radius, angle * Math.PI / 180);
	        return coord;
	      }),
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 2425 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Axis = __webpack_require__(179);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function IndicatorAxis(dim, scale, radiusExtent) {
	  Axis.call(this, dim, scale, radiusExtent);
	  /**
	   * Axis type
	   *  - 'category'
	   *  - 'value'
	   *  - 'time'
	   *  - 'log'
	   * @type {string}
	   */
	
	  this.type = 'value';
	  this.angle = 0;
	  /**
	   * Indicator name
	   * @type {string}
	   */
	
	  this.name = '';
	  /**
	   * @type {module:echarts/model/Model}
	   */
	
	  this.model;
	}
	
	zrUtil.inherits(IndicatorAxis, Axis);
	var _default = IndicatorAxis;
	module.exports = _default;

/***/ },
/* 2426 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var IndicatorAxis = __webpack_require__(2425);
	
	var IntervalScale = __webpack_require__(360);
	
	var numberUtil = __webpack_require__(25);
	
	var _axisHelper = __webpack_require__(122);
	
	var getScaleExtent = _axisHelper.getScaleExtent;
	var niceScaleExtent = _axisHelper.niceScaleExtent;
	
	var CoordinateSystem = __webpack_require__(121);
	
	var LogScale = __webpack_require__(876);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// TODO clockwise
	function Radar(radarModel, ecModel, api) {
	  this._model = radarModel;
	  /**
	   * Radar dimensions
	   * @type {Array.<string>}
	   */
	
	  this.dimensions = [];
	  this._indicatorAxes = zrUtil.map(radarModel.getIndicatorModels(), function (indicatorModel, idx) {
	    var dim = 'indicator_' + idx;
	    var indicatorAxis = new IndicatorAxis(dim, indicatorModel.get('axisType') === 'log' ? new LogScale() : new IntervalScale());
	    indicatorAxis.name = indicatorModel.get('name'); // Inject model and axis
	
	    indicatorAxis.model = indicatorModel;
	    indicatorModel.axis = indicatorAxis;
	    this.dimensions.push(dim);
	    return indicatorAxis;
	  }, this);
	  this.resize(radarModel, api);
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cx;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.cy;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.r;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.r0;
	  /**
	   * @type {number}
	   * @readOnly
	   */
	
	  this.startAngle;
	}
	
	Radar.prototype.getIndicatorAxes = function () {
	  return this._indicatorAxes;
	};
	
	Radar.prototype.dataToPoint = function (value, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  return this.coordToPoint(indicatorAxis.dataToCoord(value), indicatorIndex);
	};
	
	Radar.prototype.coordToPoint = function (coord, indicatorIndex) {
	  var indicatorAxis = this._indicatorAxes[indicatorIndex];
	  var angle = indicatorAxis.angle;
	  var x = this.cx + coord * Math.cos(angle);
	  var y = this.cy - coord * Math.sin(angle);
	  return [x, y];
	};
	
	Radar.prototype.pointToData = function (pt) {
	  var dx = pt[0] - this.cx;
	  var dy = pt[1] - this.cy;
	  var radius = Math.sqrt(dx * dx + dy * dy);
	  dx /= radius;
	  dy /= radius;
	  var radian = Math.atan2(-dy, dx); // Find the closest angle
	  // FIXME index can calculated directly
	
	  var minRadianDiff = Infinity;
	  var closestAxis;
	  var closestAxisIdx = -1;
	
	  for (var i = 0; i < this._indicatorAxes.length; i++) {
	    var indicatorAxis = this._indicatorAxes[i];
	    var diff = Math.abs(radian - indicatorAxis.angle);
	
	    if (diff < minRadianDiff) {
	      closestAxis = indicatorAxis;
	      closestAxisIdx = i;
	      minRadianDiff = diff;
	    }
	  }
	
	  return [closestAxisIdx, +(closestAxis && closestAxis.coordToData(radius))];
	};
	
	Radar.prototype.resize = function (radarModel, api) {
	  var center = radarModel.get('center');
	  var viewWidth = api.getWidth();
	  var viewHeight = api.getHeight();
	  var viewSize = Math.min(viewWidth, viewHeight) / 2;
	  this.cx = numberUtil.parsePercent(center[0], viewWidth);
	  this.cy = numberUtil.parsePercent(center[1], viewHeight);
	  this.startAngle = radarModel.get('startAngle') * Math.PI / 180; // radius may be single value like `20`, `'80%'`, or array like `[10, '80%']`
	
	  var radius = radarModel.get('radius');
	
	  if (typeof radius === 'string' || typeof radius === 'number') {
	    radius = [0, radius];
	  }
	
	  this.r0 = numberUtil.parsePercent(radius[0], viewSize);
	  this.r = numberUtil.parsePercent(radius[1], viewSize);
	  zrUtil.each(this._indicatorAxes, function (indicatorAxis, idx) {
	    indicatorAxis.setExtent(this.r0, this.r);
	    var angle = this.startAngle + idx * Math.PI * 2 / this._indicatorAxes.length; // Normalize to [-PI, PI]
	
	    angle = Math.atan2(Math.sin(angle), Math.cos(angle));
	    indicatorAxis.angle = angle;
	  }, this);
	};
	
	Radar.prototype.update = function (ecModel, api) {
	  var indicatorAxes = this._indicatorAxes;
	  var radarModel = this._model;
	  zrUtil.each(indicatorAxes, function (indicatorAxis) {
	    indicatorAxis.scale.setExtent(Infinity, -Infinity);
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries, idx) {
	    if (radarSeries.get('coordinateSystem') !== 'radar' || ecModel.getComponent('radar', radarSeries.get('radarIndex')) !== radarModel) {
	      return;
	    }
	
	    var data = radarSeries.getData();
	    zrUtil.each(indicatorAxes, function (indicatorAxis) {
	      indicatorAxis.scale.unionExtentFromData(data, data.mapDimension(indicatorAxis.dim));
	    });
	  }, this);
	  var splitNumber = radarModel.get('splitNumber');
	
	  function increaseInterval(interval) {
	    var exp10 = Math.pow(10, Math.floor(Math.log(interval) / Math.LN10)); // Increase interval
	
	    var f = interval / exp10;
	
	    if (f === 2) {
	      f = 5;
	    } else {
	      // f is 2 or 5
	      f *= 2;
	    }
	
	    return f * exp10;
	  } // Force all the axis fixing the maxSplitNumber.
	
	
	  zrUtil.each(indicatorAxes, function (indicatorAxis, idx) {
	    var rawExtent = getScaleExtent(indicatorAxis.scale, indicatorAxis.model).extent;
	    niceScaleExtent(indicatorAxis.scale, indicatorAxis.model);
	    var axisModel = indicatorAxis.model;
	    var scale = indicatorAxis.scale;
	    var fixedMin = axisModel.getMin();
	    var fixedMax = axisModel.getMax();
	    var interval = scale.getInterval();
	
	    if (fixedMin != null && fixedMax != null) {
	      // User set min, max, divide to get new interval
	      scale.setExtent(+fixedMin, +fixedMax);
	      scale.setInterval((fixedMax - fixedMin) / splitNumber);
	    } else if (fixedMin != null) {
	      var max; // User set min, expand extent on the other side
	
	      do {
	        max = fixedMin + interval * splitNumber;
	        scale.setExtent(+fixedMin, max); // Interval must been set after extent
	        // FIXME
	
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (max < rawExtent[1] && isFinite(max) && isFinite(rawExtent[1]));
	    } else if (fixedMax != null) {
	      var min; // User set min, expand extent on the other side
	
	      do {
	        min = fixedMax - interval * splitNumber;
	        scale.setExtent(min, +fixedMax);
	        scale.setInterval(interval);
	        interval = increaseInterval(interval);
	      } while (min > rawExtent[0] && isFinite(min) && isFinite(rawExtent[0]));
	    } else {
	      var nicedSplitNumber = scale.getTicks().length - 1;
	
	      if (nicedSplitNumber > splitNumber) {
	        interval = increaseInterval(interval);
	      } // TODO
	
	
	      var max = Math.ceil(rawExtent[1] / interval) * interval;
	      var min = numberUtil.round(max - interval * splitNumber);
	      scale.setExtent(min, max);
	      scale.setInterval(interval);
	    }
	  });
	};
	/**
	 * Radar dimensions is based on the data
	 * @type {Array}
	 */
	
	
	Radar.dimensions = [];
	
	Radar.create = function (ecModel, api) {
	  var radarList = [];
	  ecModel.eachComponent('radar', function (radarModel) {
	    var radar = new Radar(radarModel, ecModel, api);
	    radarList.push(radar);
	    radarModel.coordinateSystem = radar;
	  });
	  ecModel.eachSeriesByType('radar', function (radarSeries) {
	    if (radarSeries.get('coordinateSystem') === 'radar') {
	      // Inject coordinate system
	      radarSeries.coordinateSystem = radarList[radarSeries.get('radarIndex') || 0];
	    }
	  });
	  return radarList;
	};
	
	CoordinateSystem.register('radar', Radar);
	var _default = Radar;
	module.exports = _default;

/***/ },
/* 2427 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var echarts = __webpack_require__(10);
	
	var zrUtil = __webpack_require__(4);
	
	var axisDefault = __webpack_require__(862);
	
	var Model = __webpack_require__(70);
	
	var axisModelCommonMixin = __webpack_require__(250);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var valueAxisDefault = axisDefault.valueAxis;
	
	function defaultsShow(opt, show) {
	  return zrUtil.defaults({
	    show: show
	  }, opt);
	}
	
	var RadarModel = echarts.extendComponentModel({
	  type: 'radar',
	  optionUpdated: function () {
	    var boundaryGap = this.get('boundaryGap');
	    var splitNumber = this.get('splitNumber');
	    var scale = this.get('scale');
	    var axisLine = this.get('axisLine');
	    var axisTick = this.get('axisTick');
	    var axisType = this.get('axisType');
	    var axisLabel = this.get('axisLabel');
	    var nameTextStyle = this.get('name');
	    var showName = this.get('name.show');
	    var nameFormatter = this.get('name.formatter');
	    var nameGap = this.get('nameGap');
	    var triggerEvent = this.get('triggerEvent');
	    var indicatorModels = zrUtil.map(this.get('indicator') || [], function (indicatorOpt) {
	      // PENDING
	      if (indicatorOpt.max != null && indicatorOpt.max > 0 && !indicatorOpt.min) {
	        indicatorOpt.min = 0;
	      } else if (indicatorOpt.min != null && indicatorOpt.min < 0 && !indicatorOpt.max) {
	        indicatorOpt.max = 0;
	      }
	
	      var iNameTextStyle = nameTextStyle;
	
	      if (indicatorOpt.color != null) {
	        iNameTextStyle = zrUtil.defaults({
	          color: indicatorOpt.color
	        }, nameTextStyle);
	      } // Use same configuration
	
	
	      indicatorOpt = zrUtil.merge(zrUtil.clone(indicatorOpt), {
	        boundaryGap: boundaryGap,
	        splitNumber: splitNumber,
	        scale: scale,
	        axisLine: axisLine,
	        axisTick: axisTick,
	        axisType: axisType,
	        axisLabel: axisLabel,
	        // Compatible with 2 and use text
	        name: indicatorOpt.text,
	        nameLocation: 'end',
	        nameGap: nameGap,
	        // min: 0,
	        nameTextStyle: iNameTextStyle,
	        triggerEvent: triggerEvent
	      }, false);
	
	      if (!showName) {
	        indicatorOpt.name = '';
	      }
	
	      if (typeof nameFormatter === 'string') {
	        var indName = indicatorOpt.name;
	        indicatorOpt.name = nameFormatter.replace('{value}', indName != null ? indName : '');
	      } else if (typeof nameFormatter === 'function') {
	        indicatorOpt.name = nameFormatter(indicatorOpt.name, indicatorOpt);
	      }
	
	      var model = zrUtil.extend(new Model(indicatorOpt, null, this.ecModel), axisModelCommonMixin); // For triggerEvent.
	
	      model.mainType = 'radar';
	      model.componentIndex = this.componentIndex;
	      return model;
	    }, this);
	
	    this.getIndicatorModels = function () {
	      return indicatorModels;
	    };
	  },
	  defaultOption: {
	    zlevel: 0,
	    z: 0,
	    center: ['50%', '50%'],
	    radius: '75%',
	    startAngle: 90,
	    name: {
	      show: true // formatter: null
	      // textStyle: {}
	
	    },
	    boundaryGap: [0, 0],
	    splitNumber: 5,
	    nameGap: 15,
	    scale: false,
	    // Polygon or circle
	    shape: 'polygon',
	    axisLine: zrUtil.merge({
	      lineStyle: {
	        color: '#bbb'
	      }
	    }, valueAxisDefault.axisLine),
	    axisLabel: defaultsShow(valueAxisDefault.axisLabel, false),
	    axisTick: defaultsShow(valueAxisDefault.axisTick, false),
	    axisType: 'interval',
	    splitLine: defaultsShow(valueAxisDefault.splitLine, true),
	    splitArea: defaultsShow(valueAxisDefault.splitArea, true),
	    // {text, min, max}
	    indicator: []
	  }
	});
	var _default = RadarModel;
	module.exports = _default;

/***/ },
/* 2428 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var ComponentModel = __webpack_require__(76);
	
	var axisModelCreator = __webpack_require__(357);
	
	var axisModelCommonMixin = __webpack_require__(250);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var AxisModel = ComponentModel.extend({
	  type: 'singleAxis',
	  layoutMode: 'box',
	
	  /**
	   * @type {module:echarts/coord/single/SingleAxis}
	   */
	  axis: null,
	
	  /**
	   * @type {module:echarts/coord/single/Single}
	   */
	  coordinateSystem: null,
	
	  /**
	   * @override
	   */
	  getCoordSysModel: function () {
	    return this;
	  }
	});
	var defaultOption = {
	  left: '5%',
	  top: '5%',
	  right: '5%',
	  bottom: '5%',
	  type: 'value',
	  position: 'bottom',
	  orient: 'horizontal',
	  axisLine: {
	    show: true,
	    lineStyle: {
	      width: 1,
	      type: 'solid'
	    }
	  },
	  // Single coordinate system and single axis is the,
	  // which is used as the parent tooltip model.
	  // same model, so we set default tooltip show as true.
	  tooltip: {
	    show: true
	  },
	  axisTick: {
	    show: true,
	    length: 6,
	    lineStyle: {
	      width: 1
	    }
	  },
	  axisLabel: {
	    show: true,
	    interval: 'auto'
	  },
	  splitLine: {
	    show: true,
	    lineStyle: {
	      type: 'dashed',
	      opacity: 0.2
	    }
	  }
	};
	
	function getAxisType(axisName, option) {
	  return option.type || (option.data ? 'category' : 'value');
	}
	
	zrUtil.merge(AxisModel.prototype, axisModelCommonMixin);
	axisModelCreator('single', AxisModel, getAxisType, defaultOption);
	var _default = AxisModel;
	module.exports = _default;

/***/ },
/* 2429 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var SingleAxis = __webpack_require__(2430);
	
	var axisHelper = __webpack_require__(122);
	
	var _layout = __webpack_require__(46);
	
	var getLayoutRect = _layout.getLayoutRect;
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Single coordinates system.
	 */
	
	/**
	 * Create a single coordinates system.
	 *
	 * @param {module:echarts/coord/single/AxisModel} axisModel
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	function Single(axisModel, ecModel, api) {
	  /**
	   * @type {string}
	   * @readOnly
	   */
	  this.dimension = 'single';
	  /**
	   * Add it just for draw tooltip.
	   *
	   * @type {Array.<string>}
	   * @readOnly
	   */
	
	  this.dimensions = ['single'];
	  /**
	   * @private
	   * @type {module:echarts/coord/single/SingleAxis}.
	   */
	
	  this._axis = null;
	  /**
	   * @private
	   * @type {module:zrender/core/BoundingRect}
	   */
	
	  this._rect;
	
	  this._init(axisModel, ecModel, api);
	  /**
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	
	
	  this.model = axisModel;
	}
	
	Single.prototype = {
	  type: 'singleAxis',
	  axisPointerEnabled: true,
	  constructor: Single,
	
	  /**
	   * Initialize single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   * @private
	   */
	  _init: function (axisModel, ecModel, api) {
	    var dim = this.dimension;
	    var axis = new SingleAxis(dim, axisHelper.createScaleByModel(axisModel), [0, 0], axisModel.get('type'), axisModel.get('position'));
	    var isCategory = axis.type === 'category';
	    axis.onBand = isCategory && axisModel.get('boundaryGap');
	    axis.inverse = axisModel.get('inverse');
	    axis.orient = axisModel.get('orient');
	    axisModel.axis = axis;
	    axis.model = axisModel;
	    axis.coordinateSystem = this;
	    this._axis = axis;
	  },
	
	  /**
	   * Update axis scale after data processed
	   * @param  {module:echarts/model/Global} ecModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  update: function (ecModel, api) {
	    ecModel.eachSeries(function (seriesModel) {
	      if (seriesModel.coordinateSystem === this) {
	        var data = seriesModel.getData();
	        each(data.mapDimension(this.dimension, true), function (dim) {
	          this._axis.scale.unionExtentFromData(data, dim);
	        }, this);
	        axisHelper.niceScaleExtent(this._axis.scale, this._axis.model);
	      }
	    }, this);
	  },
	
	  /**
	   * Resize the single coordinate system.
	   *
	   * @param  {module:echarts/coord/single/AxisModel} axisModel
	   * @param  {module:echarts/ExtensionAPI} api
	   */
	  resize: function (axisModel, api) {
	    this._rect = getLayoutRect({
	      left: axisModel.get('left'),
	      top: axisModel.get('top'),
	      right: axisModel.get('right'),
	      bottom: axisModel.get('bottom'),
	      width: axisModel.get('width'),
	      height: axisModel.get('height')
	    }, {
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	
	    this._adjustAxis();
	  },
	
	  /**
	   * @return {module:zrender/core/BoundingRect}
	   */
	  getRect: function () {
	    return this._rect;
	  },
	
	  /**
	   * @private
	   */
	  _adjustAxis: function () {
	    var rect = this._rect;
	    var axis = this._axis;
	    var isHorizontal = axis.isHorizontal();
	    var extent = isHorizontal ? [0, rect.width] : [0, rect.height];
	    var idx = axis.reverse ? 1 : 0;
	    axis.setExtent(extent[idx], extent[1 - idx]);
	
	    this._updateAxisTransform(axis, isHorizontal ? rect.x : rect.y);
	  },
	
	  /**
	   * @param  {module:echarts/coord/single/SingleAxis} axis
	   * @param  {number} coordBase
	   */
	  _updateAxisTransform: function (axis, coordBase) {
	    var axisExtent = axis.getExtent();
	    var extentSum = axisExtent[0] + axisExtent[1];
	    var isHorizontal = axis.isHorizontal();
	    axis.toGlobalCoord = isHorizontal ? function (coord) {
	      return coord + coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	    axis.toLocalCoord = isHorizontal ? function (coord) {
	      return coord - coordBase;
	    } : function (coord) {
	      return extentSum - coord + coordBase;
	    };
	  },
	
	  /**
	   * Get axis.
	   *
	   * @return {module:echarts/coord/single/SingleAxis}
	   */
	  getAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * Get axis, add it just for draw tooltip.
	   *
	   * @return {[type]} [description]
	   */
	  getBaseAxis: function () {
	    return this._axis;
	  },
	
	  /**
	   * @return {Array.<module:echarts/coord/Axis>}
	   */
	  getAxes: function () {
	    return [this._axis];
	  },
	
	  /**
	   * @return {Object} {baseAxes: [], otherAxes: []}
	   */
	  getTooltipAxes: function () {
	    return {
	      baseAxes: [this.getAxis()]
	    };
	  },
	
	  /**
	   * If contain point.
	   *
	   * @param  {Array.<number>} point
	   * @return {boolean}
	   */
	  containPoint: function (point) {
	    var rect = this.getRect();
	    var axis = this.getAxis();
	    var orient = axis.orient;
	
	    if (orient === 'horizontal') {
	      return axis.contain(axis.toLocalCoord(point[0])) && point[1] >= rect.y && point[1] <= rect.y + rect.height;
	    } else {
	      return axis.contain(axis.toLocalCoord(point[1])) && point[0] >= rect.y && point[0] <= rect.y + rect.height;
	    }
	  },
	
	  /**
	   * @param {Array.<number>} point
	   * @return {Array.<number>}
	   */
	  pointToData: function (point) {
	    var axis = this.getAxis();
	    return [axis.coordToData(axis.toLocalCoord(point[axis.orient === 'horizontal' ? 0 : 1]))];
	  },
	
	  /**
	   * Convert the series data to concrete point.
	   *
	   * @param  {number|Array.<number>} val
	   * @return {Array.<number>}
	   */
	  dataToPoint: function (val) {
	    var axis = this.getAxis();
	    var rect = this.getRect();
	    var pt = [];
	    var idx = axis.orient === 'horizontal' ? 0 : 1;
	
	    if (val instanceof Array) {
	      val = val[0];
	    }
	
	    pt[idx] = axis.toGlobalCoord(axis.dataToCoord(+val));
	    pt[1 - idx] = idx === 0 ? rect.y + rect.height / 2 : rect.x + rect.width / 2;
	    return pt;
	  }
	};
	var _default = Single;
	module.exports = _default;

/***/ },
/* 2430 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Axis = __webpack_require__(179);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @constructor  module:echarts/coord/single/SingleAxis
	 * @extends {module:echarts/coord/Axis}
	 * @param {string} dim
	 * @param {*} scale
	 * @param {Array.<number>} coordExtent
	 * @param {string} axisType
	 * @param {string} position
	 */
	var SingleAxis = function (dim, scale, coordExtent, axisType, position) {
	  Axis.call(this, dim, scale, coordExtent);
	  /**
	   * Axis type
	   * - 'category'
	   * - 'value'
	   * - 'time'
	   * - 'log'
	   * @type {string}
	   */
	
	  this.type = axisType || 'value';
	  /**
	   * Axis position
	   *  - 'top'
	   *  - 'bottom'
	   *  - 'left'
	   *  - 'right'
	   *  @type {string}
	   */
	
	  this.position = position || 'bottom';
	  /**
	   * Axis orient
	   *  - 'horizontal'
	   *  - 'vertical'
	   * @type {[type]}
	   */
	
	  this.orient = null;
	};
	
	SingleAxis.prototype = {
	  constructor: SingleAxis,
	
	  /**
	   * Axis model
	   * @type {module:echarts/coord/single/AxisModel}
	   */
	  model: null,
	
	  /**
	   * Judge the orient of the axis.
	   * @return {boolean}
	   */
	  isHorizontal: function () {
	    var position = this.position;
	    return position === 'top' || position === 'bottom';
	  },
	
	  /**
	   * @override
	   */
	  pointToData: function (point, clamp) {
	    return this.coordinateSystem.pointToData(point, clamp)[0];
	  },
	
	  /**
	   * Convert the local coord(processed by dataToCoord())
	   * to global coord(concrete pixel coord).
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toGlobalCoord: null,
	
	  /**
	   * Convert the global coord to local coord.
	   * designated by module:echarts/coord/single/Single.
	   * @type {Function}
	   */
	  toLocalCoord: null
	};
	zrUtil.inherits(SingleAxis, Axis);
	var _default = SingleAxis;
	module.exports = _default;

/***/ },
/* 2431 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function dataToCoordSize(dataSize, dataItem) {
	  // dataItem is necessary in log axis.
	  var axis = this.getAxis();
	  var val = dataItem instanceof Array ? dataItem[0] : dataItem;
	  var halfSize = (dataSize instanceof Array ? dataSize[0] : dataSize) / 2;
	  return axis.type === 'category' ? axis.getBandWidth() : Math.abs(axis.dataToCoord(val - halfSize) - axis.dataToCoord(val + halfSize));
	}
	
	function _default(coordSys) {
	  var rect = coordSys.getRect();
	  return {
	    coordSys: {
	      type: 'singleAxis',
	      x: rect.x,
	      y: rect.y,
	      width: rect.width,
	      height: rect.height
	    },
	    api: {
	      coord: function (val) {
	        // do not provide "out" param
	        return coordSys.dataToPoint(val);
	      },
	      size: zrUtil.bind(dataToCoordSize, coordSys)
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 2432 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Single = __webpack_require__(2429);
	
	var CoordinateSystem = __webpack_require__(121);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Single coordinate system creator.
	 */
	
	/**
	 * Create single coordinate system and inject it into seriesModel.
	 *
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 * @return {Array.<module:echarts/coord/single/Single>}
	 */
	function create(ecModel, api) {
	  var singles = [];
	  ecModel.eachComponent('singleAxis', function (axisModel, idx) {
	    var single = new Single(axisModel, ecModel, api);
	    single.name = 'single_' + idx;
	    single.resize(axisModel, api);
	    axisModel.coordinateSystem = single;
	    singles.push(single);
	  });
	  ecModel.eachSeries(function (seriesModel) {
	    if (seriesModel.get('coordinateSystem') === 'singleAxis') {
	      var singleAxisModel = ecModel.queryComponents({
	        mainType: 'singleAxis',
	        index: seriesModel.get('singleAxisIndex'),
	        id: seriesModel.get('singleAxisId')
	      })[0];
	      seriesModel.coordinateSystem = singleAxisModel && singleAxisModel.coordinateSystem;
	    }
	  });
	  return singles;
	}
	
	CoordinateSystem.register('single', {
	  create: create,
	  dimensions: Single.prototype.dimensions
	});

/***/ },
/* 2433 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var zrUtil = __webpack_require__(4);
	
	var _clazz = __webpack_require__(161);
	
	var enableClassCheck = _clazz.enableClassCheck;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// id may be function name of Object, add a prefix to avoid this problem.
	function generateNodeKey(id) {
	  return '_EC_' + id;
	}
	/**
	 * @alias module:echarts/data/Graph
	 * @constructor
	 * @param {boolean} directed
	 */
	
	
	var Graph = function (directed) {
	  /**
	   * 是否是有向图
	   * @type {boolean}
	   * @private
	   */
	  this._directed = directed || false;
	  /**
	   * @type {Array.<module:echarts/data/Graph.Node>}
	   * @readOnly
	   */
	
	  this.nodes = [];
	  /**
	   * @type {Array.<module:echarts/data/Graph.Edge>}
	   * @readOnly
	   */
	
	  this.edges = [];
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Node>}
	   * @private
	   */
	
	  this._nodesMap = {};
	  /**
	   * @type {Object.<string, module:echarts/data/Graph.Edge>}
	   * @private
	   */
	
	  this._edgesMap = {};
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.data;
	  /**
	   * @type {module:echarts/data/List}
	   * @readOnly
	   */
	
	  this.edgeData;
	};
	
	var graphProto = Graph.prototype;
	/**
	 * @type {string}
	 */
	
	graphProto.type = 'graph';
	/**
	 * If is directed graph
	 * @return {boolean}
	 */
	
	graphProto.isDirected = function () {
	  return this._directed;
	};
	/**
	 * Add a new node
	 * @param {string} id
	 * @param {number} [dataIndex]
	 */
	
	
	graphProto.addNode = function (id, dataIndex) {
	  id = id == null ? '' + dataIndex : '' + id;
	  var nodesMap = this._nodesMap;
	
	  if (nodesMap[generateNodeKey(id)]) {
	    return;
	  }
	
	  var node = new Node(id, dataIndex);
	  node.hostGraph = this;
	  this.nodes.push(node);
	  nodesMap[generateNodeKey(id)] = node;
	  return node;
	};
	/**
	 * Get node by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getNodeByIndex = function (dataIndex) {
	  var rawIdx = this.data.getRawIndex(dataIndex);
	  return this.nodes[rawIdx];
	};
	/**
	 * Get node by id
	 * @param  {string} id
	 * @return {module:echarts/data/Graph.Node}
	 */
	
	
	graphProto.getNodeById = function (id) {
	  return this._nodesMap[generateNodeKey(id)];
	};
	/**
	 * Add a new edge
	 * @param {number|string|module:echarts/data/Graph.Node} n1
	 * @param {number|string|module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.addEdge = function (n1, n2, dataIndex) {
	  var nodesMap = this._nodesMap;
	  var edgesMap = this._edgesMap; // PNEDING
	
	  if (typeof n1 === 'number') {
	    n1 = this.nodes[n1];
	  }
	
	  if (typeof n2 === 'number') {
	    n2 = this.nodes[n2];
	  }
	
	  if (!Node.isInstance(n1)) {
	    n1 = nodesMap[generateNodeKey(n1)];
	  }
	
	  if (!Node.isInstance(n2)) {
	    n2 = nodesMap[generateNodeKey(n2)];
	  }
	
	  if (!n1 || !n2) {
	    return;
	  }
	
	  var key = n1.id + '-' + n2.id;
	  var edge = new Edge(n1, n2, dataIndex);
	  edge.hostGraph = this;
	
	  if (this._directed) {
	    n1.outEdges.push(edge);
	    n2.inEdges.push(edge);
	  }
	
	  n1.edges.push(edge);
	
	  if (n1 !== n2) {
	    n2.edges.push(edge);
	  }
	
	  this.edges.push(edge);
	  edgesMap[key] = edge;
	  return edge;
	};
	/**
	 * Get edge by data index
	 * @param  {number} dataIndex
	 * @return {module:echarts/data/Graph~Node}
	 */
	
	
	graphProto.getEdgeByIndex = function (dataIndex) {
	  var rawIdx = this.edgeData.getRawIndex(dataIndex);
	  return this.edges[rawIdx];
	};
	/**
	 * Get edge by two linked nodes
	 * @param  {module:echarts/data/Graph.Node|string} n1
	 * @param  {module:echarts/data/Graph.Node|string} n2
	 * @return {module:echarts/data/Graph.Edge}
	 */
	
	
	graphProto.getEdge = function (n1, n2) {
	  if (Node.isInstance(n1)) {
	    n1 = n1.id;
	  }
	
	  if (Node.isInstance(n2)) {
	    n2 = n2.id;
	  }
	
	  var edgesMap = this._edgesMap;
	
	  if (this._directed) {
	    return edgesMap[n1 + '-' + n2];
	  } else {
	    return edgesMap[n1 + '-' + n2] || edgesMap[n2 + '-' + n1];
	  }
	};
	/**
	 * Iterate all nodes
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachNode = function (cb, context) {
	  var nodes = this.nodes;
	  var len = nodes.length;
	
	  for (var i = 0; i < len; i++) {
	    if (nodes[i].dataIndex >= 0) {
	      cb.call(context, nodes[i], i);
	    }
	  }
	};
	/**
	 * Iterate all edges
	 * @param  {Function} cb
	 * @param  {*} [context]
	 */
	
	
	graphProto.eachEdge = function (cb, context) {
	  var edges = this.edges;
	  var len = edges.length;
	
	  for (var i = 0; i < len; i++) {
	    if (edges[i].dataIndex >= 0 && edges[i].node1.dataIndex >= 0 && edges[i].node2.dataIndex >= 0) {
	      cb.call(context, edges[i], i);
	    }
	  }
	};
	/**
	 * Breadth first traverse
	 * @param {Function} cb
	 * @param {module:echarts/data/Graph.Node} startNode
	 * @param {string} [direction='none'] 'none'|'in'|'out'
	 * @param {*} [context]
	 */
	
	
	graphProto.breadthFirstTraverse = function (cb, startNode, direction, context) {
	  if (!Node.isInstance(startNode)) {
	    startNode = this._nodesMap[generateNodeKey(startNode)];
	  }
	
	  if (!startNode) {
	    return;
	  }
	
	  var edgeType = direction === 'out' ? 'outEdges' : direction === 'in' ? 'inEdges' : 'edges';
	
	  for (var i = 0; i < this.nodes.length; i++) {
	    this.nodes[i].__visited = false;
	  }
	
	  if (cb.call(context, startNode, null)) {
	    return;
	  }
	
	  var queue = [startNode];
	
	  while (queue.length) {
	    var currentNode = queue.shift();
	    var edges = currentNode[edgeType];
	
	    for (var i = 0; i < edges.length; i++) {
	      var e = edges[i];
	      var otherNode = e.node1 === currentNode ? e.node2 : e.node1;
	
	      if (!otherNode.__visited) {
	        if (cb.call(context, otherNode, currentNode)) {
	          // Stop traversing
	          return;
	        }
	
	        queue.push(otherNode);
	        otherNode.__visited = true;
	      }
	    }
	  }
	}; // TODO
	// graphProto.depthFirstTraverse = function (
	//     cb, startNode, direction, context
	// ) {
	// };
	// Filter update
	
	
	graphProto.update = function () {
	  var data = this.data;
	  var edgeData = this.edgeData;
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0, len = nodes.length; i < len; i++) {
	    nodes[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = data.count(); i < len; i++) {
	    nodes[data.getRawIndex(i)].dataIndex = i;
	  }
	
	  edgeData.filterSelf(function (idx) {
	    var edge = edges[edgeData.getRawIndex(idx)];
	    return edge.node1.dataIndex >= 0 && edge.node2.dataIndex >= 0;
	  }); // Update edge
	
	  for (var i = 0, len = edges.length; i < len; i++) {
	    edges[i].dataIndex = -1;
	  }
	
	  for (var i = 0, len = edgeData.count(); i < len; i++) {
	    edges[edgeData.getRawIndex(i)].dataIndex = i;
	  }
	};
	/**
	 * @return {module:echarts/data/Graph}
	 */
	
	
	graphProto.clone = function () {
	  var graph = new Graph(this._directed);
	  var nodes = this.nodes;
	  var edges = this.edges;
	
	  for (var i = 0; i < nodes.length; i++) {
	    graph.addNode(nodes[i].id, nodes[i].dataIndex);
	  }
	
	  for (var i = 0; i < edges.length; i++) {
	    var e = edges[i];
	    graph.addEdge(e.node1.id, e.node2.id, e.dataIndex);
	  }
	
	  return graph;
	};
	/**
	 * @alias module:echarts/data/Graph.Node
	 */
	
	
	function Node(id, dataIndex) {
	  /**
	  * @type {string}
	  */
	  this.id = id == null ? '' : id;
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.inEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.outEdges = [];
	  /**
	  * @type {Array.<module:echarts/data/Graph.Edge>}
	  */
	
	  this.edges = [];
	  /**
	   * @type {module:echarts/data/Graph}
	   */
	
	  this.hostGraph;
	  /**
	   * @type {number}
	   */
	
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	
	Node.prototype = {
	  constructor: Node,
	
	  /**
	   * @return {number}
	   */
	  degree: function () {
	    return this.edges.length;
	  },
	
	  /**
	   * @return {number}
	   */
	  inDegree: function () {
	    return this.inEdges.length;
	  },
	
	  /**
	  * @return {number}
	  */
	  outDegree: function () {
	    return this.outEdges.length;
	  },
	
	  /**
	   * @param {string} [path]
	   * @return {module:echarts/model/Model}
	   */
	  getModel: function (path) {
	    if (this.dataIndex < 0) {
	      return;
	    }
	
	    var graph = this.hostGraph;
	    var itemModel = graph.data.getItemModel(this.dataIndex);
	    return itemModel.getModel(path);
	  }
	};
	/**
	 * 图边
	 * @alias module:echarts/data/Graph.Edge
	 * @param {module:echarts/data/Graph.Node} n1
	 * @param {module:echarts/data/Graph.Node} n2
	 * @param {number} [dataIndex=-1]
	 */
	
	function Edge(n1, n2, dataIndex) {
	  /**
	   * 节点1，如果是有向图则为源节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	  this.node1 = n1;
	  /**
	   * 节点2，如果是有向图则为目标节点
	   * @type {module:echarts/data/Graph.Node}
	   */
	
	  this.node2 = n2;
	  this.dataIndex = dataIndex == null ? -1 : dataIndex;
	}
	/**
	 * @param {string} [path]
	 * @return {module:echarts/model/Model}
	 */
	
	
	Edge.prototype.getModel = function (path) {
	  if (this.dataIndex < 0) {
	    return;
	  }
	
	  var graph = this.hostGraph;
	  var itemModel = graph.edgeData.getItemModel(this.dataIndex);
	  return itemModel.getModel(path);
	};
	
	var createGraphDataProxyMixin = function (hostName, dataName) {
	  return {
	    /**
	     * @param {string=} [dimension='value'] Default 'value'. can be 'a', 'b', 'c', 'd', 'e'.
	     * @return {number}
	     */
	    getValue: function (dimension) {
	      var data = this[hostName][dataName];
	      return data.get(data.getDimension(dimension || 'value'), this.dataIndex);
	    },
	
	    /**
	     * @param {Object|string} key
	     * @param {*} [value]
	     */
	    setVisual: function (key, value) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemVisual(this.dataIndex, key, value);
	    },
	
	    /**
	     * @param {string} key
	     * @return {boolean}
	     */
	    getVisual: function (key, ignoreParent) {
	      return this[hostName][dataName].getItemVisual(this.dataIndex, key, ignoreParent);
	    },
	
	    /**
	     * @param {Object} layout
	     * @return {boolean} [merge=false]
	     */
	    setLayout: function (layout, merge) {
	      this.dataIndex >= 0 && this[hostName][dataName].setItemLayout(this.dataIndex, layout, merge);
	    },
	
	    /**
	     * @return {Object}
	     */
	    getLayout: function () {
	      return this[hostName][dataName].getItemLayout(this.dataIndex);
	    },
	
	    /**
	     * @return {module:zrender/Element}
	     */
	    getGraphicEl: function () {
	      return this[hostName][dataName].getItemGraphicEl(this.dataIndex);
	    },
	
	    /**
	     * @return {number}
	     */
	    getRawIndex: function () {
	      return this[hostName][dataName].getRawIndex(this.dataIndex);
	    }
	  };
	};
	
	zrUtil.mixin(Node, createGraphDataProxyMixin('hostGraph', 'data'));
	zrUtil.mixin(Edge, createGraphDataProxyMixin('hostGraph', 'edgeData'));
	Graph.Node = Node;
	Graph.Edge = Edge;
	enableClassCheck(Node);
	enableClassCheck(Edge);
	var _default = Graph;
	module.exports = _default;

/***/ },
/* 2434 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var createListFromArray = __webpack_require__(159);
	
	var axisHelper = __webpack_require__(122);
	
	var axisModelCommonMixin = __webpack_require__(250);
	
	var Model = __webpack_require__(70);
	
	var _layout = __webpack_require__(46);
	
	var getLayoutRect = _layout.getLayoutRect;
	exports.getLayoutRect = _layout.getLayoutRect;
	
	var _dataStackHelper = __webpack_require__(140);
	
	var enableDataStack = _dataStackHelper.enableDataStack;
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	var getStackedDimension = _dataStackHelper.getStackedDimension;
	
	var _completeDimensions = __webpack_require__(871);
	
	exports.completeDimensions = _completeDimensions;
	
	var _createDimensions = __webpack_require__(251);
	
	exports.createDimensions = _createDimensions;
	
	var _symbol = __webpack_require__(110);
	
	exports.createSymbol = _symbol.createSymbol;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// import createGraphFromNodeEdge from './chart/helper/createGraphFromNodeEdge';
	
	/**
	 * Create a muti dimension List structure from seriesModel.
	 * @param  {module:echarts/model/Model} seriesModel
	 * @return {module:echarts/data/List} list
	 */
	function createList(seriesModel) {
	  return createListFromArray(seriesModel.getSource(), seriesModel);
	} // export function createGraph(seriesModel) {
	//     var nodes = seriesModel.get('data');
	//     var links = seriesModel.get('links');
	//     return createGraphFromNodeEdge(nodes, links, seriesModel);
	// }
	
	
	var dataStack = {
	  isDimensionStacked: isDimensionStacked,
	  enableDataStack: enableDataStack,
	  getStackedDimension: getStackedDimension
	};
	/**
	 * Create a symbol element with given symbol configuration: shape, x, y, width, height, color
	 * @param {string} symbolDesc
	 * @param {number} x
	 * @param {number} y
	 * @param {number} w
	 * @param {number} h
	 * @param {string} color
	 */
	
	/**
	 * Create scale
	 * @param {Array.<number>} dataExtent
	 * @param {Object|module:echarts/Model} option
	 */
	function createScale(dataExtent, option) {
	  var axisModel = option;
	
	  if (!Model.isInstance(option)) {
	    axisModel = new Model(option);
	    zrUtil.mixin(axisModel, axisModelCommonMixin);
	  }
	
	  var scale = axisHelper.createScaleByModel(axisModel);
	  scale.setExtent(dataExtent[0], dataExtent[1]);
	  axisHelper.niceScaleExtent(scale, axisModel);
	  return scale;
	}
	/**
	 * Mixin common methods to axis model,
	 *
	 * Inlcude methods
	 * `getFormattedLabels() => Array.<string>`
	 * `getCategories() => Array.<string>`
	 * `getMin(origin: boolean) => number`
	 * `getMax(origin: boolean) => number`
	 * `getNeedCrossZero() => boolean`
	 * `setRange(start: number, end: number)`
	 * `resetRange()`
	 */
	
	
	function mixinAxisModelCommonMethods(Model) {
	  zrUtil.mixin(Model, axisModelCommonMixin);
	}
	
	exports.createList = createList;
	exports.dataStack = dataStack;
	exports.createScale = createScale;
	exports.mixinAxisModelCommonMethods = mixinAxisModelCommonMethods;

/***/ },
/* 2435 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var _number = __webpack_require__(25);
	
	var parsePercent = _number.parsePercent;
	
	var _dataStackHelper = __webpack_require__(140);
	
	var isDimensionStacked = _dataStackHelper.isDimensionStacked;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function getSeriesStackId(seriesModel) {
	  return seriesModel.get('stack') || '__ec_stack_' + seriesModel.seriesIndex;
	}
	
	function getAxisKey(polar, axis) {
	  return axis.dim + polar.model.componentIndex;
	}
	/**
	 * @param {string} seriesType
	 * @param {module:echarts/model/Global} ecModel
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	
	function barLayoutPolar(seriesType, ecModel, api) {
	  var lastStackCoords = {};
	  var barWidthAndOffset = calRadialBar(zrUtil.filter(ecModel.getSeriesByType(seriesType), function (seriesModel) {
	    return !ecModel.isSeriesFiltered(seriesModel) && seriesModel.coordinateSystem && seriesModel.coordinateSystem.type === 'polar';
	  }));
	  ecModel.eachSeriesByType(seriesType, function (seriesModel) {
	    // Check series coordinate, do layout for polar only
	    if (seriesModel.coordinateSystem.type !== 'polar') {
	      return;
	    }
	
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var baseAxis = polar.getBaseAxis();
	    var axisKey = getAxisKey(polar, baseAxis);
	    var stackId = getSeriesStackId(seriesModel);
	    var columnLayoutInfo = barWidthAndOffset[axisKey][stackId];
	    var columnOffset = columnLayoutInfo.offset;
	    var columnWidth = columnLayoutInfo.width;
	    var valueAxis = polar.getOtherAxis(baseAxis);
	    var cx = seriesModel.coordinateSystem.cx;
	    var cy = seriesModel.coordinateSystem.cy;
	    var barMinHeight = seriesModel.get('barMinHeight') || 0;
	    var barMinAngle = seriesModel.get('barMinAngle') || 0;
	    lastStackCoords[stackId] = lastStackCoords[stackId] || [];
	    var valueDim = data.mapDimension(valueAxis.dim);
	    var baseDim = data.mapDimension(baseAxis.dim);
	    var stacked = isDimensionStacked(data, valueDim
	    /*, baseDim*/
	    );
	    var clampLayout = baseAxis.dim !== 'radius' || !seriesModel.get('roundCap', true);
	    var valueAxisStart = valueAxis.dim === 'radius' ? valueAxis.dataToRadius(0) : valueAxis.dataToAngle(0);
	
	    for (var idx = 0, len = data.count(); idx < len; idx++) {
	      var value = data.get(valueDim, idx);
	      var baseValue = data.get(baseDim, idx);
	      var sign = value >= 0 ? 'p' : 'n';
	      var baseCoord = valueAxisStart; // Because of the barMinHeight, we can not use the value in
	      // stackResultDimension directly.
	      // Only ordinal axis can be stacked.
	
	      if (stacked) {
	        if (!lastStackCoords[stackId][baseValue]) {
	          lastStackCoords[stackId][baseValue] = {
	            p: valueAxisStart,
	            // Positive stack
	            n: valueAxisStart // Negative stack
	
	          };
	        } // Should also consider #4243
	
	
	        baseCoord = lastStackCoords[stackId][baseValue][sign];
	      }
	
	      var r0;
	      var r;
	      var startAngle;
	      var endAngle; // radial sector
	
	      if (valueAxis.dim === 'radius') {
	        var radiusSpan = valueAxis.dataToRadius(value) - valueAxisStart;
	        var angle = baseAxis.dataToAngle(baseValue);
	
	        if (Math.abs(radiusSpan) < barMinHeight) {
	          radiusSpan = (radiusSpan < 0 ? -1 : 1) * barMinHeight;
	        }
	
	        r0 = baseCoord;
	        r = baseCoord + radiusSpan;
	        startAngle = angle - columnOffset;
	        endAngle = startAngle - columnWidth;
	        stacked && (lastStackCoords[stackId][baseValue][sign] = r);
	      } // tangential sector
	      else {
	          var angleSpan = valueAxis.dataToAngle(value, clampLayout) - valueAxisStart;
	          var radius = baseAxis.dataToRadius(baseValue);
	
	          if (Math.abs(angleSpan) < barMinAngle) {
	            angleSpan = (angleSpan < 0 ? -1 : 1) * barMinAngle;
	          }
	
	          r0 = radius + columnOffset;
	          r = r0 + columnWidth;
	          startAngle = baseCoord;
	          endAngle = baseCoord + angleSpan; // if the previous stack is at the end of the ring,
	          // add a round to differentiate it from origin
	          // var extent = angleAxis.getExtent();
	          // var stackCoord = angle;
	          // if (stackCoord === extent[0] && value > 0) {
	          //     stackCoord = extent[1];
	          // }
	          // else if (stackCoord === extent[1] && value < 0) {
	          //     stackCoord = extent[0];
	          // }
	
	          stacked && (lastStackCoords[stackId][baseValue][sign] = endAngle);
	        }
	
	      data.setItemLayout(idx, {
	        cx: cx,
	        cy: cy,
	        r0: r0,
	        r: r,
	        // Consider that positive angle is anti-clockwise,
	        // while positive radian of sector is clockwise
	        startAngle: -startAngle * Math.PI / 180,
	        endAngle: -endAngle * Math.PI / 180
	      });
	    }
	  }, this);
	}
	/**
	 * Calculate bar width and offset for radial bar charts
	 */
	
	
	function calRadialBar(barSeries, api) {
	  // Columns info on each category axis. Key is polar name
	  var columnsMap = {};
	  zrUtil.each(barSeries, function (seriesModel, idx) {
	    var data = seriesModel.getData();
	    var polar = seriesModel.coordinateSystem;
	    var baseAxis = polar.getBaseAxis();
	    var axisKey = getAxisKey(polar, baseAxis);
	    var axisExtent = baseAxis.getExtent();
	    var bandWidth = baseAxis.type === 'category' ? baseAxis.getBandWidth() : Math.abs(axisExtent[1] - axisExtent[0]) / data.count();
	    var columnsOnAxis = columnsMap[axisKey] || {
	      bandWidth: bandWidth,
	      remainedWidth: bandWidth,
	      autoWidthCount: 0,
	      categoryGap: '20%',
	      gap: '30%',
	      stacks: {}
	    };
	    var stacks = columnsOnAxis.stacks;
	    columnsMap[axisKey] = columnsOnAxis;
	    var stackId = getSeriesStackId(seriesModel);
	
	    if (!stacks[stackId]) {
	      columnsOnAxis.autoWidthCount++;
	    }
	
	    stacks[stackId] = stacks[stackId] || {
	      width: 0,
	      maxWidth: 0
	    };
	    var barWidth = parsePercent(seriesModel.get('barWidth'), bandWidth);
	    var barMaxWidth = parsePercent(seriesModel.get('barMaxWidth'), bandWidth);
	    var barGap = seriesModel.get('barGap');
	    var barCategoryGap = seriesModel.get('barCategoryGap');
	
	    if (barWidth && !stacks[stackId].width) {
	      barWidth = Math.min(columnsOnAxis.remainedWidth, barWidth);
	      stacks[stackId].width = barWidth;
	      columnsOnAxis.remainedWidth -= barWidth;
	    }
	
	    barMaxWidth && (stacks[stackId].maxWidth = barMaxWidth);
	    barGap != null && (columnsOnAxis.gap = barGap);
	    barCategoryGap != null && (columnsOnAxis.categoryGap = barCategoryGap);
	  });
	  var result = {};
	  zrUtil.each(columnsMap, function (columnsOnAxis, coordSysName) {
	    result[coordSysName] = {};
	    var stacks = columnsOnAxis.stacks;
	    var bandWidth = columnsOnAxis.bandWidth;
	    var categoryGap = parsePercent(columnsOnAxis.categoryGap, bandWidth);
	    var barGapPercent = parsePercent(columnsOnAxis.gap, 1);
	    var remainedWidth = columnsOnAxis.remainedWidth;
	    var autoWidthCount = columnsOnAxis.autoWidthCount;
	    var autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0); // Find if any auto calculated bar exceeded maxBarWidth
	
	    zrUtil.each(stacks, function (column, stack) {
	      var maxWidth = column.maxWidth;
	
	      if (maxWidth && maxWidth < autoWidth) {
	        maxWidth = Math.min(maxWidth, remainedWidth);
	
	        if (column.width) {
	          maxWidth = Math.min(maxWidth, column.width);
	        }
	
	        remainedWidth -= maxWidth;
	        column.width = maxWidth;
	        autoWidthCount--;
	      }
	    }); // Recalculate width again
	
	    autoWidth = (remainedWidth - categoryGap) / (autoWidthCount + (autoWidthCount - 1) * barGapPercent);
	    autoWidth = Math.max(autoWidth, 0);
	    var widthSum = 0;
	    var lastColumn;
	    zrUtil.each(stacks, function (column, idx) {
	      if (!column.width) {
	        column.width = autoWidth;
	      }
	
	      lastColumn = column;
	      widthSum += column.width * (1 + barGapPercent);
	    });
	
	    if (lastColumn) {
	      widthSum -= lastColumn.width * barGapPercent;
	    }
	
	    var offset = -widthSum / 2;
	    zrUtil.each(stacks, function (column, stackId) {
	      result[coordSysName][stackId] = result[coordSysName][stackId] || {
	        offset: offset,
	        width: column.width
	      };
	      offset += column.width * (1 + barGapPercent);
	    });
	  });
	  return result;
	}
	
	var _default = barLayoutPolar;
	module.exports = _default;

/***/ },
/* 2436 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var graphic = __webpack_require__(14);
	
	var textContain = __webpack_require__(102);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PI = Math.PI;
	/**
	 * @param {module:echarts/ExtensionAPI} api
	 * @param {Object} [opts]
	 * @param {string} [opts.text]
	 * @param {string} [opts.color]
	 * @param {string} [opts.textColor]
	 * @return {module:zrender/Element}
	 */
	
	function _default(api, opts) {
	  opts = opts || {};
	  zrUtil.defaults(opts, {
	    text: 'loading',
	    textColor: '#000',
	    fontSize: '12px',
	    maskColor: 'rgba(255, 255, 255, 0.8)',
	    showSpinner: true,
	    color: '#c23531',
	    spinnerRadius: 10,
	    lineWidth: 5,
	    zlevel: 0
	  });
	  var group = new graphic.Group();
	  var mask = new graphic.Rect({
	    style: {
	      fill: opts.maskColor
	    },
	    zlevel: opts.zlevel,
	    z: 10000
	  });
	  group.add(mask);
	  var font = opts.fontSize + ' sans-serif';
	  var labelRect = new graphic.Rect({
	    style: {
	      fill: 'none',
	      text: opts.text,
	      font: font,
	      textPosition: 'right',
	      textDistance: 10,
	      textFill: opts.textColor
	    },
	    zlevel: opts.zlevel,
	    z: 10001
	  });
	  group.add(labelRect);
	
	  if (opts.showSpinner) {
	    var arc = new graphic.Arc({
	      shape: {
	        startAngle: -PI / 2,
	        endAngle: -PI / 2 + 0.1,
	        r: opts.spinnerRadius
	      },
	      style: {
	        stroke: opts.color,
	        lineCap: 'round',
	        lineWidth: opts.lineWidth
	      },
	      zlevel: opts.zlevel,
	      z: 10001
	    });
	    arc.animateShape(true).when(1000, {
	      endAngle: PI * 3 / 2
	    }).start('circularInOut');
	    arc.animateShape(true).when(1000, {
	      startAngle: PI * 3 / 2
	    }).delay(300).start('circularInOut');
	    group.add(arc);
	  } // Inject resize
	
	
	  group.resize = function () {
	    var textWidth = textContain.getWidth(opts.text, font);
	    var r = opts.showSpinner ? opts.spinnerRadius : 0; // cx = (containerWidth - arcDiameter - textDistance - textWidth) / 2
	    // textDistance needs to be calculated when both animation and text exist
	
	    var cx = (api.getWidth() - r * 2 - (opts.showSpinner && textWidth ? 10 : 0) - textWidth) / 2 // only show the text
	    - (opts.showSpinner ? 0 : textWidth / 2);
	    var cy = api.getHeight() / 2;
	    opts.showSpinner && arc.setShape({
	      cx: cx,
	      cy: cy
	    });
	    labelRect.setShape({
	      x: cx - r,
	      y: cy - r,
	      width: r * 2,
	      height: r * 2
	    });
	    mask.setShape({
	      x: 0,
	      y: 0,
	      width: api.getWidth(),
	      height: api.getHeight()
	    });
	  };
	
	  group.resize();
	  return group;
	}
	
	module.exports = _default;

/***/ },
/* 2437 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var modelUtil = __webpack_require__(29);
	
	var ComponentModel = __webpack_require__(76);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * ECharts option manager
	 *
	 * @module {echarts/model/OptionManager}
	 */
	var each = zrUtil.each;
	var clone = zrUtil.clone;
	var map = zrUtil.map;
	var merge = zrUtil.merge;
	var QUERY_REG = /^(min|max)?(.+)$/;
	/**
	 * TERM EXPLANATIONS:
	 *
	 * [option]:
	 *
	 *     An object that contains definitions of components. For example:
	 *     var option = {
	 *         title: {...},
	 *         legend: {...},
	 *         visualMap: {...},
	 *         series: [
	 *             {data: [...]},
	 *             {data: [...]},
	 *             ...
	 *         ]
	 *     };
	 *
	 * [rawOption]:
	 *
	 *     An object input to echarts.setOption. 'rawOption' may be an
	 *     'option', or may be an object contains multi-options. For example:
	 *     var option = {
	 *         baseOption: {
	 *             title: {...},
	 *             legend: {...},
	 *             series: [
	 *                 {data: [...]},
	 *                 {data: [...]},
	 *                 ...
	 *             ]
	 *         },
	 *         timeline: {...},
	 *         options: [
	 *             {title: {...}, series: {data: [...]}},
	 *             {title: {...}, series: {data: [...]}},
	 *             ...
	 *         ],
	 *         media: [
	 *             {
	 *                 query: {maxWidth: 320},
	 *                 option: {series: {x: 20}, visualMap: {show: false}}
	 *             },
	 *             {
	 *                 query: {minWidth: 320, maxWidth: 720},
	 *                 option: {series: {x: 500}, visualMap: {show: true}}
	 *             },
	 *             {
	 *                 option: {series: {x: 1200}, visualMap: {show: true}}
	 *             }
	 *         ]
	 *     };
	 *
	 * @alias module:echarts/model/OptionManager
	 * @param {module:echarts/ExtensionAPI} api
	 */
	
	function OptionManager(api) {
	  /**
	   * @private
	   * @type {module:echarts/ExtensionAPI}
	   */
	  this._api = api;
	  /**
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._timelineOptions = [];
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	
	  this._mediaList = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._mediaDefault;
	  /**
	   * -1, means default.
	   * empty means no media.
	   * @private
	   * @type {Array.<number>}
	   */
	
	  this._currentMediaIndices = [];
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._optionBackup;
	  /**
	   * @private
	   * @type {Object}
	   */
	
	  this._newBaseOption;
	} // timeline.notMerge is not supported in ec3. Firstly there is rearly
	// case that notMerge is needed. Secondly supporting 'notMerge' requires
	// rawOption cloned and backuped when timeline changed, which does no
	// good to performance. What's more, that both timeline and setOption
	// method supply 'notMerge' brings complex and some problems.
	// Consider this case:
	// (step1) chart.setOption({timeline: {notMerge: false}, ...}, false);
	// (step2) chart.setOption({timeline: {notMerge: true}, ...}, false);
	
	
	OptionManager.prototype = {
	  constructor: OptionManager,
	
	  /**
	   * @public
	   * @param {Object} rawOption Raw option.
	   * @param {module:echarts/model/Global} ecModel
	   * @param {Array.<Function>} optionPreprocessorFuncs
	   * @return {Object} Init option
	   */
	  setOption: function (rawOption, optionPreprocessorFuncs) {
	    if (rawOption) {
	      // That set dat primitive is dangerous if user reuse the data when setOption again.
	      zrUtil.each(modelUtil.normalizeToArray(rawOption.series), function (series) {
	        series && series.data && zrUtil.isTypedArray(series.data) && zrUtil.setAsPrimitive(series.data);
	      });
	    } // Caution: some series modify option data, if do not clone,
	    // it should ensure that the repeat modify correctly
	    // (create a new object when modify itself).
	
	
	    rawOption = clone(rawOption); // FIXME
	    // 如果 timeline options 或者 media 中设置了某个属性，而baseOption中没有设置，则进行警告。
	
	    var oldOptionBackup = this._optionBackup;
	    var newParsedOption = parseRawOption.call(this, rawOption, optionPreprocessorFuncs, !oldOptionBackup);
	    this._newBaseOption = newParsedOption.baseOption; // For setOption at second time (using merge mode);
	
	    if (oldOptionBackup) {
	      // Only baseOption can be merged.
	      mergeOption(oldOptionBackup.baseOption, newParsedOption.baseOption); // For simplicity, timeline options and media options do not support merge,
	      // that is, if you `setOption` twice and both has timeline options, the latter
	      // timeline opitons will not be merged to the formers, but just substitude them.
	
	      if (newParsedOption.timelineOptions.length) {
	        oldOptionBackup.timelineOptions = newParsedOption.timelineOptions;
	      }
	
	      if (newParsedOption.mediaList.length) {
	        oldOptionBackup.mediaList = newParsedOption.mediaList;
	      }
	
	      if (newParsedOption.mediaDefault) {
	        oldOptionBackup.mediaDefault = newParsedOption.mediaDefault;
	      }
	    } else {
	      this._optionBackup = newParsedOption;
	    }
	  },
	
	  /**
	   * @param {boolean} isRecreate
	   * @return {Object}
	   */
	  mountOption: function (isRecreate) {
	    var optionBackup = this._optionBackup; // TODO
	    // 如果没有reset功能则不clone。
	
	    this._timelineOptions = map(optionBackup.timelineOptions, clone);
	    this._mediaList = map(optionBackup.mediaList, clone);
	    this._mediaDefault = clone(optionBackup.mediaDefault);
	    this._currentMediaIndices = [];
	    return clone(isRecreate // this._optionBackup.baseOption, which is created at the first `setOption`
	    // called, and is merged into every new option by inner method `mergeOption`
	    // each time `setOption` called, can be only used in `isRecreate`, because
	    // its reliability is under suspicion. In other cases option merge is
	    // performed by `model.mergeOption`.
	    ? optionBackup.baseOption : this._newBaseOption);
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Object}
	   */
	  getTimelineOption: function (ecModel) {
	    var option;
	    var timelineOptions = this._timelineOptions;
	
	    if (timelineOptions.length) {
	      // getTimelineOption can only be called after ecModel inited,
	      // so we can get currentIndex from timelineModel.
	      var timelineModel = ecModel.getComponent('timeline');
	
	      if (timelineModel) {
	        option = clone(timelineOptions[timelineModel.getCurrentIndex()], true);
	      }
	    }
	
	    return option;
	  },
	
	  /**
	   * @param {module:echarts/model/Global} ecModel
	   * @return {Array.<Object>}
	   */
	  getMediaOption: function (ecModel) {
	    var ecWidth = this._api.getWidth();
	
	    var ecHeight = this._api.getHeight();
	
	    var mediaList = this._mediaList;
	    var mediaDefault = this._mediaDefault;
	    var indices = [];
	    var result = []; // No media defined.
	
	    if (!mediaList.length && !mediaDefault) {
	      return result;
	    } // Multi media may be applied, the latter defined media has higher priority.
	
	
	    for (var i = 0, len = mediaList.length; i < len; i++) {
	      if (applyMediaQuery(mediaList[i].query, ecWidth, ecHeight)) {
	        indices.push(i);
	      }
	    } // FIXME
	    // 是否mediaDefault应该强制用户设置，否则可能修改不能回归。
	
	
	    if (!indices.length && mediaDefault) {
	      indices = [-1];
	    }
	
	    if (indices.length && !indicesEquals(indices, this._currentMediaIndices)) {
	      result = map(indices, function (index) {
	        return clone(index === -1 ? mediaDefault.option : mediaList[index].option);
	      });
	    } // Otherwise return nothing.
	
	
	    this._currentMediaIndices = indices;
	    return result;
	  }
	};
	
	function parseRawOption(rawOption, optionPreprocessorFuncs, isNew) {
	  var timelineOptions = [];
	  var mediaList = [];
	  var mediaDefault;
	  var baseOption; // Compatible with ec2.
	
	  var timelineOpt = rawOption.timeline;
	
	  if (rawOption.baseOption) {
	    baseOption = rawOption.baseOption;
	  } // For timeline
	
	
	  if (timelineOpt || rawOption.options) {
	    baseOption = baseOption || {};
	    timelineOptions = (rawOption.options || []).slice();
	  } // For media query
	
	
	  if (rawOption.media) {
	    baseOption = baseOption || {};
	    var media = rawOption.media;
	    each(media, function (singleMedia) {
	      if (singleMedia && singleMedia.option) {
	        if (singleMedia.query) {
	          mediaList.push(singleMedia);
	        } else if (!mediaDefault) {
	          // Use the first media default.
	          mediaDefault = singleMedia;
	        }
	      }
	    });
	  } // For normal option
	
	
	  if (!baseOption) {
	    baseOption = rawOption;
	  } // Set timelineOpt to baseOption in ec3,
	  // which is convenient for merge option.
	
	
	  if (!baseOption.timeline) {
	    baseOption.timeline = timelineOpt;
	  } // Preprocess.
	
	
	  each([baseOption].concat(timelineOptions).concat(zrUtil.map(mediaList, function (media) {
	    return media.option;
	  })), function (option) {
	    each(optionPreprocessorFuncs, function (preProcess) {
	      preProcess(option, isNew);
	    });
	  });
	  return {
	    baseOption: baseOption,
	    timelineOptions: timelineOptions,
	    mediaDefault: mediaDefault,
	    mediaList: mediaList
	  };
	}
	/**
	 * @see <http://www.w3.org/TR/css3-mediaqueries/#media1>
	 * Support: width, height, aspectRatio
	 * Can use max or min as prefix.
	 */
	
	
	function applyMediaQuery(query, ecWidth, ecHeight) {
	  var realMap = {
	    width: ecWidth,
	    height: ecHeight,
	    aspectratio: ecWidth / ecHeight // lowser case for convenientce.
	
	  };
	  var applicatable = true;
	  zrUtil.each(query, function (value, attr) {
	    var matched = attr.match(QUERY_REG);
	
	    if (!matched || !matched[1] || !matched[2]) {
	      return;
	    }
	
	    var operator = matched[1];
	    var realAttr = matched[2].toLowerCase();
	
	    if (!compare(realMap[realAttr], value, operator)) {
	      applicatable = false;
	    }
	  });
	  return applicatable;
	}
	
	function compare(real, expect, operator) {
	  if (operator === 'min') {
	    return real >= expect;
	  } else if (operator === 'max') {
	    return real <= expect;
	  } else {
	    // Equals
	    return real === expect;
	  }
	}
	
	function indicesEquals(indices1, indices2) {
	  // indices is always order by asc and has only finite number.
	  return indices1.join(',') === indices2.join(',');
	}
	/**
	 * Consider case:
	 * `chart.setOption(opt1);`
	 * Then user do some interaction like dataZoom, dataView changing.
	 * `chart.setOption(opt2);`
	 * Then user press 'reset button' in toolbox.
	 *
	 * After doing that all of the interaction effects should be reset, the
	 * chart should be the same as the result of invoke
	 * `chart.setOption(opt1); chart.setOption(opt2);`.
	 *
	 * Although it is not able ensure that
	 * `chart.setOption(opt1); chart.setOption(opt2);` is equivalents to
	 * `chart.setOption(merge(opt1, opt2));` exactly,
	 * this might be the only simple way to implement that feature.
	 *
	 * MEMO: We've considered some other approaches:
	 * 1. Each model handle its self restoration but not uniform treatment.
	 *     (Too complex in logic and error-prone)
	 * 2. Use a shadow ecModel. (Performace expensive)
	 */
	
	
	function mergeOption(oldOption, newOption) {
	  newOption = newOption || {};
	  each(newOption, function (newCptOpt, mainType) {
	    if (newCptOpt == null) {
	      return;
	    }
	
	    var oldCptOpt = oldOption[mainType];
	
	    if (!ComponentModel.hasClass(mainType)) {
	      oldOption[mainType] = merge(oldCptOpt, newCptOpt, true);
	    } else {
	      newCptOpt = modelUtil.normalizeToArray(newCptOpt);
	      oldCptOpt = modelUtil.normalizeToArray(oldCptOpt);
	      var mapResult = modelUtil.mappingToExists(oldCptOpt, newCptOpt);
	      oldOption[mainType] = map(mapResult, function (item) {
	        return item.option && item.exist ? merge(item.exist, item.option, true) : item.exist || item.option;
	      });
	    }
	  });
	}
	
	var _default = OptionManager;
	module.exports = _default;

/***/ },
/* 2438 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var platform = ''; // Navigator not exists in node
	
	if (typeof navigator !== 'undefined') {
	  platform = navigator.platform || '';
	}
	
	var _default = {
	  // backgroundColor: 'rgba(0,0,0,0)',
	  // https://dribbble.com/shots/1065960-Infographic-Pie-chart-visualization
	  // color: ['#5793f3', '#d14a61', '#fd9c35', '#675bba', '#fec42c', '#dd4444', '#d4df5a', '#cd4870'],
	  // Light colors:
	  // color: ['#bcd3bb', '#e88f70', '#edc1a5', '#9dc5c8', '#e1e8c8', '#7b7c68', '#e5b5b5', '#f0b489', '#928ea8', '#bda29a'],
	  // color: ['#cc5664', '#9bd6ec', '#ea946e', '#8acaaa', '#f1ec64', '#ee8686', '#a48dc1', '#5da6bc', '#b9dcae'],
	  // Dark colors:
	  color: ['#c23531', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
	  gradientColor: ['#f6efa6', '#d88273', '#bf444c'],
	  // If xAxis and yAxis declared, grid is created by default.
	  // grid: {},
	  textStyle: {
	    // color: '#000',
	    // decoration: 'none',
	    // PENDING
	    fontFamily: platform.match(/^Win/) ? 'Microsoft YaHei' : 'sans-serif',
	    // fontFamily: 'Arial, Verdana, sans-serif',
	    fontSize: 12,
	    fontStyle: 'normal',
	    fontWeight: 'normal'
	  },
	  // http://blogs.adobe.com/webplatform/2014/02/24/using-blend-modes-in-html-canvas/
	  // https://developer.mozilla.org/en-US/docs/Web/API/CanvasRenderingContext2D/globalCompositeOperation
	  // Default is source-over
	  blendMode: null,
	  animation: 'auto',
	  animationDuration: 1000,
	  animationDurationUpdate: 300,
	  animationEasing: 'exponentialOut',
	  animationEasingUpdate: 'cubicOut',
	  animationThreshold: 2000,
	  // Configuration for progressive/incremental rendering
	  progressiveThreshold: 3000,
	  progressive: 400,
	  // Threshold of if use single hover layer to optimize.
	  // It is recommended that `hoverLayerThreshold` is equivalent to or less than
	  // `progressiveThreshold`, otherwise hover will cause restart of progressive,
	  // which is unexpected.
	  // see example <echarts/test/heatmap-large.html>.
	  hoverLayerThreshold: 3000,
	  // See: module:echarts/scale/Time
	  useUTC: false
	};
	module.exports = _default;

/***/ },
/* 2439 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(252);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getAreaStyle = makeStyleMapper([['fill', 'color'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['opacity'], ['shadowColor']]);
	var _default = {
	  getAreaStyle: function (excludes, includes) {
	    return getAreaStyle(this, excludes, includes);
	  }
	};
	module.exports = _default;

/***/ },
/* 2440 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = {
	  getBoxLayoutParams: function () {
	    return {
	      left: this.get('left'),
	      top: this.get('top'),
	      right: this.get('right'),
	      bottom: this.get('bottom'),
	      width: this.get('width'),
	      height: this.get('height')
	    };
	  }
	};
	module.exports = _default;

/***/ },
/* 2441 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(252);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getItemStyle = makeStyleMapper([['fill', 'color'], ['stroke', 'borderColor'], ['lineWidth', 'borderWidth'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor'], ['textPosition'], ['textAlign']]);
	var _default = {
	  getItemStyle: function (excludes, includes) {
	    var style = getItemStyle(this, excludes, includes);
	    var lineDash = this.getBorderLineDash();
	    lineDash && (style.lineDash = lineDash);
	    return style;
	  },
	  getBorderLineDash: function () {
	    var lineType = this.get('borderType');
	    return lineType === 'solid' || lineType == null ? null : lineType === 'dashed' ? [5, 5] : [1, 1];
	  }
	};
	module.exports = _default;

/***/ },
/* 2442 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var makeStyleMapper = __webpack_require__(252);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var getLineStyle = makeStyleMapper([['lineWidth', 'width'], ['stroke', 'color'], ['opacity'], ['shadowBlur'], ['shadowOffsetX'], ['shadowOffsetY'], ['shadowColor']]);
	var _default = {
	  getLineStyle: function (excludes) {
	    var style = getLineStyle(this, excludes); // Always set lineDash whether dashed, otherwise we can not
	    // erase the previous style when assigning to el.style.
	
	    style.lineDash = this.getLineDash(style.lineWidth);
	    return style;
	  },
	  getLineDash: function (lineWidth) {
	    if (lineWidth == null) {
	      lineWidth = 1;
	    }
	
	    var lineType = this.get('type');
	    var dotSize = Math.max(lineWidth, 2);
	    var dashSize = lineWidth * 4;
	    return lineType === 'solid' || lineType == null ? // Use `false` but not `null` for the solid line here, because `null` might be
	    // ignored when assigning to `el.style`. e.g., when setting `lineStyle.type` as
	    // `'dashed'` and `emphasis.lineStyle.type` as `'solid'` in graph series, the
	    // `lineDash` gotten form the latter one is not able to erase that from the former
	    // one if using `null` here according to the emhpsis strategy in `util/graphic.js`.
	    false : lineType === 'dashed' ? [dashSize, dashSize] : [dotSize, dotSize];
	  }
	};
	module.exports = _default;

/***/ },
/* 2443 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var textContain = __webpack_require__(102);
	
	var graphicUtil = __webpack_require__(14);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var PATH_COLOR = ['textStyle', 'color'];
	var _default = {
	  /**
	   * Get color property or get color from option.textStyle.color
	   * @param {boolean} [isEmphasis]
	   * @return {string}
	   */
	  getTextColor: function (isEmphasis) {
	    var ecModel = this.ecModel;
	    return this.getShallow('color') || (!isEmphasis && ecModel ? ecModel.get(PATH_COLOR) : null);
	  },
	
	  /**
	   * Create font string from fontStyle, fontWeight, fontSize, fontFamily
	   * @return {string}
	   */
	  getFont: function () {
	    return graphicUtil.getFont({
	      fontStyle: this.getShallow('fontStyle'),
	      fontWeight: this.getShallow('fontWeight'),
	      fontSize: this.getShallow('fontSize'),
	      fontFamily: this.getShallow('fontFamily')
	    }, this.ecModel);
	  },
	  getTextRect: function (text) {
	    return textContain.getBoundingRect(text, this.getFont(), this.getShallow('align'), this.getShallow('verticalAlign') || this.getShallow('baseline'), this.getShallow('padding'), this.getShallow('lineHeight'), this.getShallow('rich'), this.getShallow('truncateText'));
	  }
	};
	module.exports = _default;

/***/ },
/* 2444 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _config = __webpack_require__(35);
	
	var __DEV__ = _config.__DEV__;
	
	var _util = __webpack_require__(4);
	
	var createHashMap = _util.createHashMap;
	var retrieve = _util.retrieve;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Helper for model references.
	 * There are many manners to refer axis/coordSys.
	 */
	// TODO
	// merge relevant logic to this file?
	// check: "modelHelper" of tooltip and "BrushTargetManager".
	
	/**
	 * @class
	 * For example:
	 * {
	 *     coordSysName: 'cartesian2d',
	 *     coordSysDims: ['x', 'y', ...],
	 *     axisMap: HashMap({
	 *         x: xAxisModel,
	 *         y: yAxisModel
	 *     }),
	 *     categoryAxisMap: HashMap({
	 *         x: xAxisModel,
	 *         y: undefined
	 *     }),
	 *     // The index of the first category axis in `coordSysDims`.
	 *     // `null/undefined` means no category axis exists.
	 *     firstCategoryDimIndex: 1,
	 *     // To replace user specified encode.
	 * }
	 */
	function CoordSysInfo(coordSysName) {
	  /**
	   * @type {string}
	   */
	  this.coordSysName = coordSysName;
	  /**
	   * @type {Array.<string>}
	   */
	
	  this.coordSysDims = [];
	  /**
	   * @type {module:zrender/core/util#HashMap}
	   */
	
	  this.axisMap = createHashMap();
	  /**
	   * @type {module:zrender/core/util#HashMap}
	   */
	
	  this.categoryAxisMap = createHashMap();
	  /**
	   * @type {number}
	   */
	
	  this.firstCategoryDimIndex = null;
	}
	/**
	 * @return {module:model/referHelper#CoordSysInfo}
	 */
	
	
	function getCoordSysInfoBySeries(seriesModel) {
	  var coordSysName = seriesModel.get('coordinateSystem');
	  var result = new CoordSysInfo(coordSysName);
	  var fetch = fetchers[coordSysName];
	
	  if (fetch) {
	    fetch(seriesModel, result, result.axisMap, result.categoryAxisMap);
	    return result;
	  }
	}
	
	var fetchers = {
	  cartesian2d: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var xAxisModel = seriesModel.getReferringComponents('xAxis')[0];
	    var yAxisModel = seriesModel.getReferringComponents('yAxis')[0];
	    result.coordSysDims = ['x', 'y'];
	    axisMap.set('x', xAxisModel);
	    axisMap.set('y', yAxisModel);
	
	    if (isCategory(xAxisModel)) {
	      categoryAxisMap.set('x', xAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	
	    if (isCategory(yAxisModel)) {
	      categoryAxisMap.set('y', yAxisModel);
	      result.firstCategoryDimIndex == null & (result.firstCategoryDimIndex = 1);
	    }
	  },
	  singleAxis: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var singleAxisModel = seriesModel.getReferringComponents('singleAxis')[0];
	    result.coordSysDims = ['single'];
	    axisMap.set('single', singleAxisModel);
	
	    if (isCategory(singleAxisModel)) {
	      categoryAxisMap.set('single', singleAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	  },
	  polar: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var polarModel = seriesModel.getReferringComponents('polar')[0];
	    var radiusAxisModel = polarModel.findAxisModel('radiusAxis');
	    var angleAxisModel = polarModel.findAxisModel('angleAxis');
	    result.coordSysDims = ['radius', 'angle'];
	    axisMap.set('radius', radiusAxisModel);
	    axisMap.set('angle', angleAxisModel);
	
	    if (isCategory(radiusAxisModel)) {
	      categoryAxisMap.set('radius', radiusAxisModel);
	      result.firstCategoryDimIndex = 0;
	    }
	
	    if (isCategory(angleAxisModel)) {
	      categoryAxisMap.set('angle', angleAxisModel);
	      result.firstCategoryDimIndex == null && (result.firstCategoryDimIndex = 1);
	    }
	  },
	  geo: function (seriesModel, result, axisMap, categoryAxisMap) {
	    result.coordSysDims = ['lng', 'lat'];
	  },
	  parallel: function (seriesModel, result, axisMap, categoryAxisMap) {
	    var ecModel = seriesModel.ecModel;
	    var parallelModel = ecModel.getComponent('parallel', seriesModel.get('parallelIndex'));
	    var coordSysDims = result.coordSysDims = parallelModel.dimensions.slice();
	    each(parallelModel.parallelAxisIndex, function (axisIndex, index) {
	      var axisModel = ecModel.getComponent('parallelAxis', axisIndex);
	      var axisDim = coordSysDims[index];
	      axisMap.set(axisDim, axisModel);
	
	      if (isCategory(axisModel) && result.firstCategoryDimIndex == null) {
	        categoryAxisMap.set(axisDim, axisModel);
	        result.firstCategoryDimIndex = index;
	      }
	    });
	  }
	};
	
	function isCategory(axisModel) {
	  return axisModel.get('type') === 'category';
	}
	
	exports.getCoordSysInfoBySeries = getCoordSysInfoBySeries;

/***/ },
/* 2445 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	var isArray = _util.isArray;
	var isObject = _util.isObject;
	
	var compatStyle = __webpack_require__(2446);
	
	var _model = __webpack_require__(29);
	
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// Compatitable with 2.0
	function get(opt, path) {
	  path = path.split(',');
	  var obj = opt;
	
	  for (var i = 0; i < path.length; i++) {
	    obj = obj && obj[path[i]];
	
	    if (obj == null) {
	      break;
	    }
	  }
	
	  return obj;
	}
	
	function set(opt, path, val, overwrite) {
	  path = path.split(',');
	  var obj = opt;
	  var key;
	
	  for (var i = 0; i < path.length - 1; i++) {
	    key = path[i];
	
	    if (obj[key] == null) {
	      obj[key] = {};
	    }
	
	    obj = obj[key];
	  }
	
	  if (overwrite || obj[path[i]] == null) {
	    obj[path[i]] = val;
	  }
	}
	
	function compatLayoutProperties(option) {
	  each(LAYOUT_PROPERTIES, function (prop) {
	    if (prop[0] in option && !(prop[1] in option)) {
	      option[prop[1]] = option[prop[0]];
	    }
	  });
	}
	
	var LAYOUT_PROPERTIES = [['x', 'left'], ['y', 'top'], ['x2', 'right'], ['y2', 'bottom']];
	var COMPATITABLE_COMPONENTS = ['grid', 'geo', 'parallel', 'legend', 'toolbox', 'title', 'visualMap', 'dataZoom', 'timeline'];
	
	function _default(option, isTheme) {
	  compatStyle(option, isTheme); // Make sure series array for model initialization.
	
	  option.series = normalizeToArray(option.series);
	  each(option.series, function (seriesOpt) {
	    if (!isObject(seriesOpt)) {
	      return;
	    }
	
	    var seriesType = seriesOpt.type;
	
	    if (seriesType === 'line') {
	      if (seriesOpt.clipOverflow != null) {
	        seriesOpt.clip = seriesOpt.clipOverflow;
	      }
	    } else if (seriesType === 'pie' || seriesType === 'gauge') {
	      if (seriesOpt.clockWise != null) {
	        seriesOpt.clockwise = seriesOpt.clockWise;
	      }
	    } else if (seriesType === 'gauge') {
	      var pointerColor = get(seriesOpt, 'pointer.color');
	      pointerColor != null && set(seriesOpt, 'itemStyle.color', pointerColor);
	    }
	
	    compatLayoutProperties(seriesOpt);
	  }); // dataRange has changed to visualMap
	
	  if (option.dataRange) {
	    option.visualMap = option.dataRange;
	  }
	
	  each(COMPATITABLE_COMPONENTS, function (componentName) {
	    var options = option[componentName];
	
	    if (options) {
	      if (!isArray(options)) {
	        options = [options];
	      }
	
	      each(options, function (option) {
	        compatLayoutProperties(option);
	      });
	    }
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2446 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var modelUtil = __webpack_require__(29);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var each = zrUtil.each;
	var isObject = zrUtil.isObject;
	var POSSIBLE_STYLES = ['areaStyle', 'lineStyle', 'nodeStyle', 'linkStyle', 'chordStyle', 'label', 'labelLine'];
	
	function compatEC2ItemStyle(opt) {
	  var itemStyleOpt = opt && opt.itemStyle;
	
	  if (!itemStyleOpt) {
	    return;
	  }
	
	  for (var i = 0, len = POSSIBLE_STYLES.length; i < len; i++) {
	    var styleName = POSSIBLE_STYLES[i];
	    var normalItemStyleOpt = itemStyleOpt.normal;
	    var emphasisItemStyleOpt = itemStyleOpt.emphasis;
	
	    if (normalItemStyleOpt && normalItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].normal) {
	        opt[styleName].normal = normalItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].normal, normalItemStyleOpt[styleName]);
	      }
	
	      normalItemStyleOpt[styleName] = null;
	    }
	
	    if (emphasisItemStyleOpt && emphasisItemStyleOpt[styleName]) {
	      opt[styleName] = opt[styleName] || {};
	
	      if (!opt[styleName].emphasis) {
	        opt[styleName].emphasis = emphasisItemStyleOpt[styleName];
	      } else {
	        zrUtil.merge(opt[styleName].emphasis, emphasisItemStyleOpt[styleName]);
	      }
	
	      emphasisItemStyleOpt[styleName] = null;
	    }
	  }
	}
	
	function convertNormalEmphasis(opt, optType, useExtend) {
	  if (opt && opt[optType] && (opt[optType].normal || opt[optType].emphasis)) {
	    var normalOpt = opt[optType].normal;
	    var emphasisOpt = opt[optType].emphasis;
	
	    if (normalOpt) {
	      // Timeline controlStyle has other properties besides normal and emphasis
	      if (useExtend) {
	        opt[optType].normal = opt[optType].emphasis = null;
	        zrUtil.defaults(opt[optType], normalOpt);
	      } else {
	        opt[optType] = normalOpt;
	      }
	    }
	
	    if (emphasisOpt) {
	      opt.emphasis = opt.emphasis || {};
	      opt.emphasis[optType] = emphasisOpt;
	    }
	  }
	}
	
	function removeEC3NormalStatus(opt) {
	  convertNormalEmphasis(opt, 'itemStyle');
	  convertNormalEmphasis(opt, 'lineStyle');
	  convertNormalEmphasis(opt, 'areaStyle');
	  convertNormalEmphasis(opt, 'label');
	  convertNormalEmphasis(opt, 'labelLine'); // treemap
	
	  convertNormalEmphasis(opt, 'upperLabel'); // graph
	
	  convertNormalEmphasis(opt, 'edgeLabel');
	}
	
	function compatTextStyle(opt, propName) {
	  // Check whether is not object (string\null\undefined ...)
	  var labelOptSingle = isObject(opt) && opt[propName];
	  var textStyle = isObject(labelOptSingle) && labelOptSingle.textStyle;
	
	  if (textStyle) {
	    for (var i = 0, len = modelUtil.TEXT_STYLE_OPTIONS.length; i < len; i++) {
	      var propName = modelUtil.TEXT_STYLE_OPTIONS[i];
	
	      if (textStyle.hasOwnProperty(propName)) {
	        labelOptSingle[propName] = textStyle[propName];
	      }
	    }
	  }
	}
	
	function compatEC3CommonStyles(opt) {
	  if (opt) {
	    removeEC3NormalStatus(opt);
	    compatTextStyle(opt, 'label');
	    opt.emphasis && compatTextStyle(opt.emphasis, 'label');
	  }
	}
	
	function processSeries(seriesOpt) {
	  if (!isObject(seriesOpt)) {
	    return;
	  }
	
	  compatEC2ItemStyle(seriesOpt);
	  removeEC3NormalStatus(seriesOpt);
	  compatTextStyle(seriesOpt, 'label'); // treemap
	
	  compatTextStyle(seriesOpt, 'upperLabel'); // graph
	
	  compatTextStyle(seriesOpt, 'edgeLabel');
	
	  if (seriesOpt.emphasis) {
	    compatTextStyle(seriesOpt.emphasis, 'label'); // treemap
	
	    compatTextStyle(seriesOpt.emphasis, 'upperLabel'); // graph
	
	    compatTextStyle(seriesOpt.emphasis, 'edgeLabel');
	  }
	
	  var markPoint = seriesOpt.markPoint;
	
	  if (markPoint) {
	    compatEC2ItemStyle(markPoint);
	    compatEC3CommonStyles(markPoint);
	  }
	
	  var markLine = seriesOpt.markLine;
	
	  if (markLine) {
	    compatEC2ItemStyle(markLine);
	    compatEC3CommonStyles(markLine);
	  }
	
	  var markArea = seriesOpt.markArea;
	
	  if (markArea) {
	    compatEC3CommonStyles(markArea);
	  }
	
	  var data = seriesOpt.data; // Break with ec3: if `setOption` again, there may be no `type` in option,
	  // then the backward compat based on option type will not be performed.
	
	  if (seriesOpt.type === 'graph') {
	    data = data || seriesOpt.nodes;
	    var edgeData = seriesOpt.links || seriesOpt.edges;
	
	    if (edgeData && !zrUtil.isTypedArray(edgeData)) {
	      for (var i = 0; i < edgeData.length; i++) {
	        compatEC3CommonStyles(edgeData[i]);
	      }
	    }
	
	    zrUtil.each(seriesOpt.categories, function (opt) {
	      removeEC3NormalStatus(opt);
	    });
	  }
	
	  if (data && !zrUtil.isTypedArray(data)) {
	    for (var i = 0; i < data.length; i++) {
	      compatEC3CommonStyles(data[i]);
	    }
	  } // mark point data
	
	
	  var markPoint = seriesOpt.markPoint;
	
	  if (markPoint && markPoint.data) {
	    var mpData = markPoint.data;
	
	    for (var i = 0; i < mpData.length; i++) {
	      compatEC3CommonStyles(mpData[i]);
	    }
	  } // mark line data
	
	
	  var markLine = seriesOpt.markLine;
	
	  if (markLine && markLine.data) {
	    var mlData = markLine.data;
	
	    for (var i = 0; i < mlData.length; i++) {
	      if (zrUtil.isArray(mlData[i])) {
	        compatEC3CommonStyles(mlData[i][0]);
	        compatEC3CommonStyles(mlData[i][1]);
	      } else {
	        compatEC3CommonStyles(mlData[i]);
	      }
	    }
	  } // Series
	
	
	  if (seriesOpt.type === 'gauge') {
	    compatTextStyle(seriesOpt, 'axisLabel');
	    compatTextStyle(seriesOpt, 'title');
	    compatTextStyle(seriesOpt, 'detail');
	  } else if (seriesOpt.type === 'treemap') {
	    convertNormalEmphasis(seriesOpt.breadcrumb, 'itemStyle');
	    zrUtil.each(seriesOpt.levels, function (opt) {
	      removeEC3NormalStatus(opt);
	    });
	  } else if (seriesOpt.type === 'tree') {
	    removeEC3NormalStatus(seriesOpt.leaves);
	  } // sunburst starts from ec4, so it does not need to compat levels.
	
	}
	
	function toArr(o) {
	  return zrUtil.isArray(o) ? o : o ? [o] : [];
	}
	
	function toObj(o) {
	  return (zrUtil.isArray(o) ? o[0] : o) || {};
	}
	
	function _default(option, isTheme) {
	  each(toArr(option.series), function (seriesOpt) {
	    isObject(seriesOpt) && processSeries(seriesOpt);
	  });
	  var axes = ['xAxis', 'yAxis', 'radiusAxis', 'angleAxis', 'singleAxis', 'parallelAxis', 'radar'];
	  isTheme && axes.push('valueAxis', 'categoryAxis', 'logAxis', 'timeAxis');
	  each(axes, function (axisName) {
	    each(toArr(option[axisName]), function (axisOpt) {
	      if (axisOpt) {
	        compatTextStyle(axisOpt, 'axisLabel');
	        compatTextStyle(axisOpt.axisPointer, 'label');
	      }
	    });
	  });
	  each(toArr(option.parallel), function (parallelOpt) {
	    var parallelAxisDefault = parallelOpt && parallelOpt.parallelAxisDefault;
	    compatTextStyle(parallelAxisDefault, 'axisLabel');
	    compatTextStyle(parallelAxisDefault && parallelAxisDefault.axisPointer, 'label');
	  });
	  each(toArr(option.calendar), function (calendarOpt) {
	    convertNormalEmphasis(calendarOpt, 'itemStyle');
	    compatTextStyle(calendarOpt, 'dayLabel');
	    compatTextStyle(calendarOpt, 'monthLabel');
	    compatTextStyle(calendarOpt, 'yearLabel');
	  }); // radar.name.textStyle
	
	  each(toArr(option.radar), function (radarOpt) {
	    compatTextStyle(radarOpt, 'name');
	  });
	  each(toArr(option.geo), function (geoOpt) {
	    if (isObject(geoOpt)) {
	      compatEC3CommonStyles(geoOpt);
	      each(toArr(geoOpt.regions), function (regionObj) {
	        compatEC3CommonStyles(regionObj);
	      });
	    }
	  });
	  each(toArr(option.timeline), function (timelineOpt) {
	    compatEC3CommonStyles(timelineOpt);
	    convertNormalEmphasis(timelineOpt, 'label');
	    convertNormalEmphasis(timelineOpt, 'itemStyle');
	    convertNormalEmphasis(timelineOpt, 'controlStyle', true);
	    var data = timelineOpt.data;
	    zrUtil.isArray(data) && zrUtil.each(data, function (item) {
	      if (zrUtil.isObject(item)) {
	        convertNormalEmphasis(item, 'label');
	        convertNormalEmphasis(item, 'itemStyle');
	      }
	    });
	  });
	  each(toArr(option.toolbox), function (toolboxOpt) {
	    convertNormalEmphasis(toolboxOpt, 'iconStyle');
	    each(toolboxOpt.feature, function (featureOpt) {
	      convertNormalEmphasis(featureOpt, 'iconStyle');
	    });
	  });
	  compatTextStyle(toObj(option.axisPointer), 'label');
	  compatTextStyle(toObj(option.tooltip).axisPointer, 'label');
	}
	
	module.exports = _default;

/***/ },
/* 2447 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var samplers = {
	  average: function (frame) {
	    var sum = 0;
	    var count = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      if (!isNaN(frame[i])) {
	        sum += frame[i];
	        count++;
	      }
	    } // Return NaN if count is 0
	
	
	    return count === 0 ? NaN : sum / count;
	  },
	  sum: function (frame) {
	    var sum = 0;
	
	    for (var i = 0; i < frame.length; i++) {
	      // Ignore NaN
	      sum += frame[i] || 0;
	    }
	
	    return sum;
	  },
	  max: function (frame) {
	    var max = -Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] > max && (max = frame[i]);
	    } // NaN will cause illegal axis extent.
	
	
	    return isFinite(max) ? max : NaN;
	  },
	  min: function (frame) {
	    var min = Infinity;
	
	    for (var i = 0; i < frame.length; i++) {
	      frame[i] < min && (min = frame[i]);
	    } // NaN will cause illegal axis extent.
	
	
	    return isFinite(min) ? min : NaN;
	  },
	  // TODO
	  // Median
	  nearest: function (frame) {
	    return frame[0];
	  }
	};
	
	var indexSampler = function (frame, value) {
	  return Math.round(frame.length / 2);
	};
	
	function _default(seriesType) {
	  return {
	    seriesType: seriesType,
	    modifyOutputEnd: true,
	    reset: function (seriesModel, ecModel, api) {
	      var data = seriesModel.getData();
	      var sampling = seriesModel.get('sampling');
	      var coordSys = seriesModel.coordinateSystem; // Only cartesian2d support down sampling
	
	      if (coordSys.type === 'cartesian2d' && sampling) {
	        var baseAxis = coordSys.getBaseAxis();
	        var valueAxis = coordSys.getOtherAxis(baseAxis);
	        var extent = baseAxis.getExtent(); // Coordinste system has been resized
	
	        var size = Math.abs(extent[1] - extent[0]);
	        var rate = Math.round(data.count() / size);
	
	        if (rate > 1) {
	          var sampler;
	
	          if (typeof sampling === 'string') {
	            sampler = samplers[sampling];
	          } else if (typeof sampling === 'function') {
	            sampler = sampling;
	          }
	
	          if (sampler) {
	            // Only support sample the first dim mapped from value axis.
	            seriesModel.setData(data.downSample(data.mapDimension(valueAxis.dim), 1 / rate, sampler, indexSampler));
	          }
	        }
	      }
	    }
	  };
	}
	
	module.exports = _default;

/***/ },
/* 2448 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var createHashMap = _util.createHashMap;
	var each = _util.each;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	// (1) [Caution]: the logic is correct based on the premises:
	//     data processing stage is blocked in stream.
	//     See <module:echarts/stream/Scheduler#performDataProcessorTasks>
	// (2) Only register once when import repeatly.
	//     Should be executed after series filtered and before stack calculation.
	function _default(ecModel) {
	  var stackInfoMap = createHashMap();
	  ecModel.eachSeries(function (seriesModel) {
	    var stack = seriesModel.get('stack'); // Compatibal: when `stack` is set as '', do not stack.
	
	    if (stack) {
	      var stackInfoList = stackInfoMap.get(stack) || stackInfoMap.set(stack, []);
	      var data = seriesModel.getData();
	      var stackInfo = {
	        // Used for calculate axis extent automatically.
	        stackResultDimension: data.getCalculationInfo('stackResultDimension'),
	        stackedOverDimension: data.getCalculationInfo('stackedOverDimension'),
	        stackedDimension: data.getCalculationInfo('stackedDimension'),
	        stackedByDimension: data.getCalculationInfo('stackedByDimension'),
	        isStackedByIndex: data.getCalculationInfo('isStackedByIndex'),
	        data: data,
	        seriesModel: seriesModel
	      }; // If stacked on axis that do not support data stack.
	
	      if (!stackInfo.stackedDimension || !(stackInfo.isStackedByIndex || stackInfo.stackedByDimension)) {
	        return;
	      }
	
	      stackInfoList.length && data.setCalculationInfo('stackedOnSeries', stackInfoList[stackInfoList.length - 1].seriesModel);
	      stackInfoList.push(stackInfo);
	    }
	  });
	  stackInfoMap.each(calculateStack);
	}
	
	function calculateStack(stackInfoList) {
	  each(stackInfoList, function (targetStackInfo, idxInStack) {
	    var resultVal = [];
	    var resultNaN = [NaN, NaN];
	    var dims = [targetStackInfo.stackResultDimension, targetStackInfo.stackedOverDimension];
	    var targetData = targetStackInfo.data;
	    var isStackedByIndex = targetStackInfo.isStackedByIndex; // Should not write on raw data, because stack series model list changes
	    // depending on legend selection.
	
	    var newData = targetData.map(dims, function (v0, v1, dataIndex) {
	      var sum = targetData.get(targetStackInfo.stackedDimension, dataIndex); // Consider `connectNulls` of line area, if value is NaN, stackedOver
	      // should also be NaN, to draw a appropriate belt area.
	
	      if (isNaN(sum)) {
	        return resultNaN;
	      }
	
	      var byValue;
	      var stackedDataRawIndex;
	
	      if (isStackedByIndex) {
	        stackedDataRawIndex = targetData.getRawIndex(dataIndex);
	      } else {
	        byValue = targetData.get(targetStackInfo.stackedByDimension, dataIndex);
	      } // If stackOver is NaN, chart view will render point on value start.
	
	
	      var stackedOver = NaN;
	
	      for (var j = idxInStack - 1; j >= 0; j--) {
	        var stackInfo = stackInfoList[j]; // Has been optimized by inverted indices on `stackedByDimension`.
	
	        if (!isStackedByIndex) {
	          stackedDataRawIndex = stackInfo.data.rawIndexOf(stackInfo.stackedByDimension, byValue);
	        }
	
	        if (stackedDataRawIndex >= 0) {
	          var val = stackInfo.data.getByRawIndex(stackInfo.stackResultDimension, stackedDataRawIndex); // Considering positive stack, negative stack and empty data
	
	          if (sum >= 0 && val > 0 || // Positive stack
	          sum <= 0 && val < 0 // Negative stack
	          ) {
	              sum += val;
	              stackedOver = val;
	              break;
	            }
	        }
	      }
	
	      resultVal[0] = sum;
	      resultVal[1] = stackedOver;
	      return resultVal;
	    });
	    targetData.hostModel.setData(newData); // Update for consequent calculation
	
	    targetStackInfo.data = newData;
	  });
	}
	
	module.exports = _default;

/***/ },
/* 2449 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var Scale = __webpack_require__(361);
	
	var OrdinalMeta = __webpack_require__(870);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Linear continuous scale
	 * @module echarts/coord/scale/Ordinal
	 *
	 * http://en.wikipedia.org/wiki/Level_of_measurement
	 */
	// FIXME only one data
	var scaleProto = Scale.prototype;
	var OrdinalScale = Scale.extend({
	  type: 'ordinal',
	
	  /**
	   * @param {module:echarts/data/OrdianlMeta|Array.<string>} ordinalMeta
	   */
	  init: function (ordinalMeta, extent) {
	    // Caution: Should not use instanceof, consider ec-extensions using
	    // import approach to get OrdinalMeta class.
	    if (!ordinalMeta || zrUtil.isArray(ordinalMeta)) {
	      ordinalMeta = new OrdinalMeta({
	        categories: ordinalMeta
	      });
	    }
	
	    this._ordinalMeta = ordinalMeta;
	    this._extent = extent || [0, ordinalMeta.categories.length - 1];
	  },
	  parse: function (val) {
	    return typeof val === 'string' ? this._ordinalMeta.getOrdinal(val) // val might be float.
	    : Math.round(val);
	  },
	  contain: function (rank) {
	    rank = this.parse(rank);
	    return scaleProto.contain.call(this, rank) && this._ordinalMeta.categories[rank] != null;
	  },
	
	  /**
	   * Normalize given rank or name to linear [0, 1]
	   * @param {number|string} [val]
	   * @return {number}
	   */
	  normalize: function (val) {
	    return scaleProto.normalize.call(this, this.parse(val));
	  },
	  scale: function (val) {
	    return Math.round(scaleProto.scale.call(this, val));
	  },
	
	  /**
	   * @return {Array}
	   */
	  getTicks: function () {
	    var ticks = [];
	    var extent = this._extent;
	    var rank = extent[0];
	
	    while (rank <= extent[1]) {
	      ticks.push(rank);
	      rank++;
	    }
	
	    return ticks;
	  },
	
	  /**
	   * Get item on rank n
	   * @param {number} n
	   * @return {string}
	   */
	  getLabel: function (n) {
	    if (!this.isBlank()) {
	      // Note that if no data, ordinalMeta.categories is an empty array.
	      return this._ordinalMeta.categories[n];
	    }
	  },
	
	  /**
	   * @return {number}
	   */
	  count: function () {
	    return this._extent[1] - this._extent[0] + 1;
	  },
	
	  /**
	   * @override
	   */
	  unionExtentFromData: function (data, dim) {
	    this.unionExtent(data.getApproximateExtent(dim));
	  },
	  getOrdinalMeta: function () {
	    return this._ordinalMeta;
	  },
	  niceTicks: zrUtil.noop,
	  niceExtent: zrUtil.noop
	});
	/**
	 * @return {module:echarts/scale/Time}
	 */
	
	OrdinalScale.create = function () {
	  return new OrdinalScale();
	};
	
	var _default = OrdinalScale;
	module.exports = _default;

/***/ },
/* 2450 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var numberUtil = __webpack_require__(25);
	
	var formatUtil = __webpack_require__(48);
	
	var scaleHelper = __webpack_require__(877);
	
	var IntervalScale = __webpack_require__(360);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* A third-party license is embeded for some of the code in this file:
	* The "scaleLevels" was originally copied from "d3.js" with some
	* modifications made for this project.
	* (See more details in the comment on the definition of "scaleLevels" below.)
	* The use of the source code of this file is also subject to the terms
	* and consitions of the license of "d3.js" (BSD-3Clause, see
	* </licenses/LICENSE-d3>).
	*/
	// [About UTC and local time zone]:
	// In most cases, `number.parseDate` will treat input data string as local time
	// (except time zone is specified in time string). And `format.formateTime` returns
	// local time by default. option.useUTC is false by default. This design have
	// concidered these common case:
	// (1) Time that is persistent in server is in UTC, but it is needed to be diplayed
	// in local time by default.
	// (2) By default, the input data string (e.g., '2011-01-02') should be displayed
	// as its original time, without any time difference.
	var intervalScaleProto = IntervalScale.prototype;
	var mathCeil = Math.ceil;
	var mathFloor = Math.floor;
	var ONE_SECOND = 1000;
	var ONE_MINUTE = ONE_SECOND * 60;
	var ONE_HOUR = ONE_MINUTE * 60;
	var ONE_DAY = ONE_HOUR * 24; // FIXME 公用？
	
	var bisect = function (a, x, lo, hi) {
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	
	    if (a[mid][1] < x) {
	      lo = mid + 1;
	    } else {
	      hi = mid;
	    }
	  }
	
	  return lo;
	};
	/**
	 * @alias module:echarts/coord/scale/Time
	 * @constructor
	 */
	
	
	var TimeScale = IntervalScale.extend({
	  type: 'time',
	
	  /**
	   * @override
	   */
	  getLabel: function (val) {
	    var stepLvl = this._stepLvl;
	    var date = new Date(val);
	    return formatUtil.formatTime(stepLvl[0], date, this.getSetting('useUTC'));
	  },
	
	  /**
	   * @override
	   */
	  niceExtent: function (opt) {
	    var extent = this._extent; // If extent start and end are same, expand them
	
	    if (extent[0] === extent[1]) {
	      // Expand extent
	      extent[0] -= ONE_DAY;
	      extent[1] += ONE_DAY;
	    } // If there are no data and extent are [Infinity, -Infinity]
	
	
	    if (extent[1] === -Infinity && extent[0] === Infinity) {
	      var d = new Date();
	      extent[1] = +new Date(d.getFullYear(), d.getMonth(), d.getDate());
	      extent[0] = extent[1] - ONE_DAY;
	    }
	
	    this.niceTicks(opt.splitNumber, opt.minInterval, opt.maxInterval); // var extent = this._extent;
	
	    var interval = this._interval;
	
	    if (!opt.fixMin) {
	      extent[0] = numberUtil.round(mathFloor(extent[0] / interval) * interval);
	    }
	
	    if (!opt.fixMax) {
	      extent[1] = numberUtil.round(mathCeil(extent[1] / interval) * interval);
	    }
	  },
	
	  /**
	   * @override
	   */
	  niceTicks: function (approxTickNum, minInterval, maxInterval) {
	    approxTickNum = approxTickNum || 10;
	    var extent = this._extent;
	    var span = extent[1] - extent[0];
	    var approxInterval = span / approxTickNum;
	
	    if (minInterval != null && approxInterval < minInterval) {
	      approxInterval = minInterval;
	    }
	
	    if (maxInterval != null && approxInterval > maxInterval) {
	      approxInterval = maxInterval;
	    }
	
	    var scaleLevelsLen = scaleLevels.length;
	    var idx = bisect(scaleLevels, approxInterval, 0, scaleLevelsLen);
	    var level = scaleLevels[Math.min(idx, scaleLevelsLen - 1)];
	    var interval = level[1]; // Same with interval scale if span is much larger than 1 year
	
	    if (level[0] === 'year') {
	      var yearSpan = span / interval; // From "Nice Numbers for Graph Labels" of Graphic Gems
	      // var niceYearSpan = numberUtil.nice(yearSpan, false);
	
	      var yearStep = numberUtil.nice(yearSpan / approxTickNum, true);
	      interval *= yearStep;
	    }
	
	    var timezoneOffset = this.getSetting('useUTC') ? 0 : new Date(+extent[0] || +extent[1]).getTimezoneOffset() * 60 * 1000;
	    var niceExtent = [Math.round(mathCeil((extent[0] - timezoneOffset) / interval) * interval + timezoneOffset), Math.round(mathFloor((extent[1] - timezoneOffset) / interval) * interval + timezoneOffset)];
	    scaleHelper.fixExtent(niceExtent, extent);
	    this._stepLvl = level; // Interval will be used in getTicks
	
	    this._interval = interval;
	    this._niceExtent = niceExtent;
	  },
	  parse: function (val) {
	    // val might be float.
	    return +numberUtil.parseDate(val);
	  }
	});
	zrUtil.each(['contain', 'normalize'], function (methodName) {
	  TimeScale.prototype[methodName] = function (val) {
	    return intervalScaleProto[methodName].call(this, this.parse(val));
	  };
	});
	/**
	 * This implementation was originally copied from "d3.js"
	 * <https://github.com/d3/d3/blob/b516d77fb8566b576088e73410437494717ada26/src/time/scale.js>
	 * with some modifications made for this program.
	 * See the license statement at the head of this file.
	 */
	
	var scaleLevels = [// Format              interval
	['hh:mm:ss', ONE_SECOND], // 1s
	['hh:mm:ss', ONE_SECOND * 5], // 5s
	['hh:mm:ss', ONE_SECOND * 10], // 10s
	['hh:mm:ss', ONE_SECOND * 15], // 15s
	['hh:mm:ss', ONE_SECOND * 30], // 30s
	['hh:mm\nMM-dd', ONE_MINUTE], // 1m
	['hh:mm\nMM-dd', ONE_MINUTE * 5], // 5m
	['hh:mm\nMM-dd', ONE_MINUTE * 10], // 10m
	['hh:mm\nMM-dd', ONE_MINUTE * 15], // 15m
	['hh:mm\nMM-dd', ONE_MINUTE * 30], // 30m
	['hh:mm\nMM-dd', ONE_HOUR], // 1h
	['hh:mm\nMM-dd', ONE_HOUR * 2], // 2h
	['hh:mm\nMM-dd', ONE_HOUR * 6], // 6h
	['hh:mm\nMM-dd', ONE_HOUR * 12], // 12h
	['MM-dd\nyyyy', ONE_DAY], // 1d
	['MM-dd\nyyyy', ONE_DAY * 2], // 2d
	['MM-dd\nyyyy', ONE_DAY * 3], // 3d
	['MM-dd\nyyyy', ONE_DAY * 4], // 4d
	['MM-dd\nyyyy', ONE_DAY * 5], // 5d
	['MM-dd\nyyyy', ONE_DAY * 6], // 6d
	['week', ONE_DAY * 7], // 7d
	['MM-dd\nyyyy', ONE_DAY * 10], // 10d
	['week', ONE_DAY * 14], // 2w
	['week', ONE_DAY * 21], // 3w
	['month', ONE_DAY * 31], // 1M
	['week', ONE_DAY * 42], // 6w
	['month', ONE_DAY * 62], // 2M
	['week', ONE_DAY * 70], // 10w
	['quarter', ONE_DAY * 95], // 3M
	['month', ONE_DAY * 31 * 4], // 4M
	['month', ONE_DAY * 31 * 5], // 5M
	['half-year', ONE_DAY * 380 / 2], // 6M
	['month', ONE_DAY * 31 * 8], // 8M
	['month', ONE_DAY * 31 * 10], // 10M
	['year', ONE_DAY * 380] // 1Y
	];
	/**
	 * @param {module:echarts/model/Model}
	 * @return {module:echarts/scale/Time}
	 */
	
	TimeScale.create = function (model) {
	  return new TimeScale({
	    useUTC: model.ecModel.get('useUTC')
	  });
	};
	
	var _default = TimeScale;
	module.exports = _default;

/***/ },
/* 2451 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	var map = _util.map;
	var isFunction = _util.isFunction;
	var createHashMap = _util.createHashMap;
	var noop = _util.noop;
	
	var _task = __webpack_require__(518);
	
	var createTask = _task.createTask;
	
	var _component = __webpack_require__(297);
	
	var getUID = _component.getUID;
	
	var GlobalModel = __webpack_require__(874);
	
	var ExtensionAPI = __webpack_require__(818);
	
	var _model = __webpack_require__(29);
	
	var normalizeToArray = _model.normalizeToArray;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @module echarts/stream/Scheduler
	 */
	
	/**
	 * @constructor
	 */
	function Scheduler(ecInstance, api, dataProcessorHandlers, visualHandlers) {
	  this.ecInstance = ecInstance;
	  this.api = api;
	  this.unfinished; // Fix current processors in case that in some rear cases that
	  // processors might be registered after echarts instance created.
	  // Register processors incrementally for a echarts instance is
	  // not supported by this stream architecture.
	
	  var dataProcessorHandlers = this._dataProcessorHandlers = dataProcessorHandlers.slice();
	  var visualHandlers = this._visualHandlers = visualHandlers.slice();
	  this._allHandlers = dataProcessorHandlers.concat(visualHandlers);
	  /**
	   * @private
	   * @type {
	   *     [handlerUID: string]: {
	   *         seriesTaskMap?: {
	   *             [seriesUID: string]: Task
	   *         },
	   *         overallTask?: Task
	   *     }
	   * }
	   */
	
	  this._stageTaskMap = createHashMap();
	}
	
	var proto = Scheduler.prototype;
	/**
	 * @param {module:echarts/model/Global} ecModel
	 * @param {Object} payload
	 */
	
	proto.restoreData = function (ecModel, payload) {
	  // TODO: Only restore needed series and components, but not all components.
	  // Currently `restoreData` of all of the series and component will be called.
	  // But some independent components like `title`, `legend`, `graphic`, `toolbox`,
	  // `tooltip`, `axisPointer`, etc, do not need series refresh when `setOption`,
	  // and some components like coordinate system, axes, dataZoom, visualMap only
	  // need their target series refresh.
	  // (1) If we are implementing this feature some day, we should consider these cases:
	  // if a data processor depends on a component (e.g., dataZoomProcessor depends
	  // on the settings of `dataZoom`), it should be re-performed if the component
	  // is modified by `setOption`.
	  // (2) If a processor depends on sevral series, speicified by its `getTargetSeries`,
	  // it should be re-performed when the result array of `getTargetSeries` changed.
	  // We use `dependencies` to cover these issues.
	  // (3) How to update target series when coordinate system related components modified.
	  // TODO: simply the dirty mechanism? Check whether only the case here can set tasks dirty,
	  // and this case all of the tasks will be set as dirty.
	  ecModel.restoreData(payload); // Theoretically an overall task not only depends on each of its target series, but also
	  // depends on all of the series.
	  // The overall task is not in pipeline, and `ecModel.restoreData` only set pipeline tasks
	  // dirty. If `getTargetSeries` of an overall task returns nothing, we should also ensure
	  // that the overall task is set as dirty and to be performed, otherwise it probably cause
	  // state chaos. So we have to set dirty of all of the overall tasks manually, otherwise it
	  // probably cause state chaos (consider `dataZoomProcessor`).
	
	  this._stageTaskMap.each(function (taskRecord) {
	    var overallTask = taskRecord.overallTask;
	    overallTask && overallTask.dirty();
	  });
	}; // If seriesModel provided, incremental threshold is check by series data.
	
	
	proto.getPerformArgs = function (task, isBlock) {
	  // For overall task
	  if (!task.__pipeline) {
	    return;
	  }
	
	  var pipeline = this._pipelineMap.get(task.__pipeline.id);
	
	  var pCtx = pipeline.context;
	  var incremental = !isBlock && pipeline.progressiveEnabled && (!pCtx || pCtx.progressiveRender) && task.__idxInPipeline > pipeline.blockIndex;
	  var step = incremental ? pipeline.step : null;
	  var modDataCount = pCtx && pCtx.modDataCount;
	  var modBy = modDataCount != null ? Math.ceil(modDataCount / step) : null;
	  return {
	    step: step,
	    modBy: modBy,
	    modDataCount: modDataCount
	  };
	};
	
	proto.getPipeline = function (pipelineId) {
	  return this._pipelineMap.get(pipelineId);
	};
	/**
	 * Current, progressive rendering starts from visual and layout.
	 * Always detect render mode in the same stage, avoiding that incorrect
	 * detection caused by data filtering.
	 * Caution:
	 * `updateStreamModes` use `seriesModel.getData()`.
	 */
	
	
	proto.updateStreamModes = function (seriesModel, view) {
	  var pipeline = this._pipelineMap.get(seriesModel.uid);
	
	  var data = seriesModel.getData();
	  var dataLen = data.count(); // `progressiveRender` means that can render progressively in each
	  // animation frame. Note that some types of series do not provide
	  // `view.incrementalPrepareRender` but support `chart.appendData`. We
	  // use the term `incremental` but not `progressive` to describe the
	  // case that `chart.appendData`.
	
	  var progressiveRender = pipeline.progressiveEnabled && view.incrementalPrepareRender && dataLen >= pipeline.threshold;
	  var large = seriesModel.get('large') && dataLen >= seriesModel.get('largeThreshold'); // TODO: modDataCount should not updated if `appendData`, otherwise cause whole repaint.
	  // see `test/candlestick-large3.html`
	
	  var modDataCount = seriesModel.get('progressiveChunkMode') === 'mod' ? dataLen : null;
	  seriesModel.pipelineContext = pipeline.context = {
	    progressiveRender: progressiveRender,
	    modDataCount: modDataCount,
	    large: large
	  };
	};
	
	proto.restorePipelines = function (ecModel) {
	  var scheduler = this;
	  var pipelineMap = scheduler._pipelineMap = createHashMap();
	  ecModel.eachSeries(function (seriesModel) {
	    var progressive = seriesModel.getProgressive();
	    var pipelineId = seriesModel.uid;
	    pipelineMap.set(pipelineId, {
	      id: pipelineId,
	      head: null,
	      tail: null,
	      threshold: seriesModel.getProgressiveThreshold(),
	      progressiveEnabled: progressive && !(seriesModel.preventIncremental && seriesModel.preventIncremental()),
	      blockIndex: -1,
	      step: Math.round(progressive || 700),
	      count: 0
	    });
	    pipe(scheduler, seriesModel, seriesModel.dataTask);
	  });
	};
	
	proto.prepareStageTasks = function () {
	  var stageTaskMap = this._stageTaskMap;
	  var ecModel = this.ecInstance.getModel();
	  var api = this.api;
	  each(this._allHandlers, function (handler) {
	    var record = stageTaskMap.get(handler.uid) || stageTaskMap.set(handler.uid, []);
	    handler.reset && createSeriesStageTask(this, handler, record, ecModel, api);
	    handler.overallReset && createOverallStageTask(this, handler, record, ecModel, api);
	  }, this);
	};
	
	proto.prepareView = function (view, model, ecModel, api) {
	  var renderTask = view.renderTask;
	  var context = renderTask.context;
	  context.model = model;
	  context.ecModel = ecModel;
	  context.api = api;
	  renderTask.__block = !view.incrementalPrepareRender;
	  pipe(this, model, renderTask);
	};
	
	proto.performDataProcessorTasks = function (ecModel, payload) {
	  // If we do not use `block` here, it should be considered when to update modes.
	  performStageTasks(this, this._dataProcessorHandlers, ecModel, payload, {
	    block: true
	  });
	}; // opt
	// opt.visualType: 'visual' or 'layout'
	// opt.setDirty
	
	
	proto.performVisualTasks = function (ecModel, payload, opt) {
	  performStageTasks(this, this._visualHandlers, ecModel, payload, opt);
	};
	
	function performStageTasks(scheduler, stageHandlers, ecModel, payload, opt) {
	  opt = opt || {};
	  var unfinished;
	  each(stageHandlers, function (stageHandler, idx) {
	    if (opt.visualType && opt.visualType !== stageHandler.visualType) {
	      return;
	    }
	
	    var stageHandlerRecord = scheduler._stageTaskMap.get(stageHandler.uid);
	
	    var seriesTaskMap = stageHandlerRecord.seriesTaskMap;
	    var overallTask = stageHandlerRecord.overallTask;
	
	    if (overallTask) {
	      var overallNeedDirty;
	      var agentStubMap = overallTask.agentStubMap;
	      agentStubMap.each(function (stub) {
	        if (needSetDirty(opt, stub)) {
	          stub.dirty();
	          overallNeedDirty = true;
	        }
	      });
	      overallNeedDirty && overallTask.dirty();
	      updatePayload(overallTask, payload);
	      var performArgs = scheduler.getPerformArgs(overallTask, opt.block); // Execute stubs firstly, which may set the overall task dirty,
	      // then execute the overall task. And stub will call seriesModel.setData,
	      // which ensures that in the overallTask seriesModel.getData() will not
	      // return incorrect data.
	
	      agentStubMap.each(function (stub) {
	        stub.perform(performArgs);
	      });
	      unfinished |= overallTask.perform(performArgs);
	    } else if (seriesTaskMap) {
	      seriesTaskMap.each(function (task, pipelineId) {
	        if (needSetDirty(opt, task)) {
	          task.dirty();
	        }
	
	        var performArgs = scheduler.getPerformArgs(task, opt.block); // FIXME
	        // if intending to decalare `performRawSeries` in handlers, only
	        // stream-independent (specifically, data item independent) operations can be
	        // performed. Because is a series is filtered, most of the tasks will not
	        // be performed. A stream-dependent operation probably cause wrong biz logic.
	        // Perhaps we should not provide a separate callback for this case instead
	        // of providing the config `performRawSeries`. The stream-dependent operaions
	        // and stream-independent operations should better not be mixed.
	
	        performArgs.skip = !stageHandler.performRawSeries && ecModel.isSeriesFiltered(task.context.model);
	        updatePayload(task, payload);
	        unfinished |= task.perform(performArgs);
	      });
	    }
	  });
	
	  function needSetDirty(opt, task) {
	    return opt.setDirty && (!opt.dirtyMap || opt.dirtyMap.get(task.__pipeline.id));
	  }
	
	  scheduler.unfinished |= unfinished;
	}
	
	proto.performSeriesTasks = function (ecModel) {
	  var unfinished;
	  ecModel.eachSeries(function (seriesModel) {
	    // Progress to the end for dataInit and dataRestore.
	    unfinished |= seriesModel.dataTask.perform();
	  });
	  this.unfinished |= unfinished;
	};
	
	proto.plan = function () {
	  // Travel pipelines, check block.
	  this._pipelineMap.each(function (pipeline) {
	    var task = pipeline.tail;
	
	    do {
	      if (task.__block) {
	        pipeline.blockIndex = task.__idxInPipeline;
	        break;
	      }
	
	      task = task.getUpstream();
	    } while (task);
	  });
	};
	
	var updatePayload = proto.updatePayload = function (task, payload) {
	  payload !== 'remain' && (task.context.payload = payload);
	};
	
	function createSeriesStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
	  var seriesTaskMap = stageHandlerRecord.seriesTaskMap || (stageHandlerRecord.seriesTaskMap = createHashMap());
	  var seriesType = stageHandler.seriesType;
	  var getTargetSeries = stageHandler.getTargetSeries; // If a stageHandler should cover all series, `createOnAllSeries` should be declared mandatorily,
	  // to avoid some typo or abuse. Otherwise if an extension do not specify a `seriesType`,
	  // it works but it may cause other irrelevant charts blocked.
	
	  if (stageHandler.createOnAllSeries) {
	    ecModel.eachRawSeries(create);
	  } else if (seriesType) {
	    ecModel.eachRawSeriesByType(seriesType, create);
	  } else if (getTargetSeries) {
	    getTargetSeries(ecModel, api).each(create);
	  }
	
	  function create(seriesModel) {
	    var pipelineId = seriesModel.uid; // Init tasks for each seriesModel only once.
	    // Reuse original task instance.
	
	    var task = seriesTaskMap.get(pipelineId) || seriesTaskMap.set(pipelineId, createTask({
	      plan: seriesTaskPlan,
	      reset: seriesTaskReset,
	      count: seriesTaskCount
	    }));
	    task.context = {
	      model: seriesModel,
	      ecModel: ecModel,
	      api: api,
	      useClearVisual: stageHandler.isVisual && !stageHandler.isLayout,
	      plan: stageHandler.plan,
	      reset: stageHandler.reset,
	      scheduler: scheduler
	    };
	    pipe(scheduler, seriesModel, task);
	  } // Clear unused series tasks.
	
	
	  var pipelineMap = scheduler._pipelineMap;
	  seriesTaskMap.each(function (task, pipelineId) {
	    if (!pipelineMap.get(pipelineId)) {
	      task.dispose();
	      seriesTaskMap.removeKey(pipelineId);
	    }
	  });
	}
	
	function createOverallStageTask(scheduler, stageHandler, stageHandlerRecord, ecModel, api) {
	  var overallTask = stageHandlerRecord.overallTask = stageHandlerRecord.overallTask // For overall task, the function only be called on reset stage.
	  || createTask({
	    reset: overallTaskReset
	  });
	  overallTask.context = {
	    ecModel: ecModel,
	    api: api,
	    overallReset: stageHandler.overallReset,
	    scheduler: scheduler
	  }; // Reuse orignal stubs.
	
	  var agentStubMap = overallTask.agentStubMap = overallTask.agentStubMap || createHashMap();
	  var seriesType = stageHandler.seriesType;
	  var getTargetSeries = stageHandler.getTargetSeries;
	  var overallProgress = true;
	  var modifyOutputEnd = stageHandler.modifyOutputEnd; // An overall task with seriesType detected or has `getTargetSeries`, we add
	  // stub in each pipelines, it will set the overall task dirty when the pipeline
	  // progress. Moreover, to avoid call the overall task each frame (too frequent),
	  // we set the pipeline block.
	
	  if (seriesType) {
	    ecModel.eachRawSeriesByType(seriesType, createStub);
	  } else if (getTargetSeries) {
	    getTargetSeries(ecModel, api).each(createStub);
	  } // Otherwise, (usually it is legancy case), the overall task will only be
	  // executed when upstream dirty. Otherwise the progressive rendering of all
	  // pipelines will be disabled unexpectedly. But it still needs stubs to receive
	  // dirty info from upsteam.
	  else {
	      overallProgress = false;
	      each(ecModel.getSeries(), createStub);
	    }
	
	  function createStub(seriesModel) {
	    var pipelineId = seriesModel.uid;
	    var stub = agentStubMap.get(pipelineId);
	
	    if (!stub) {
	      stub = agentStubMap.set(pipelineId, createTask({
	        reset: stubReset,
	        onDirty: stubOnDirty
	      })); // When the result of `getTargetSeries` changed, the overallTask
	      // should be set as dirty and re-performed.
	
	      overallTask.dirty();
	    }
	
	    stub.context = {
	      model: seriesModel,
	      overallProgress: overallProgress,
	      modifyOutputEnd: modifyOutputEnd
	    };
	    stub.agent = overallTask;
	    stub.__block = overallProgress;
	    pipe(scheduler, seriesModel, stub);
	  } // Clear unused stubs.
	
	
	  var pipelineMap = scheduler._pipelineMap;
	  agentStubMap.each(function (stub, pipelineId) {
	    if (!pipelineMap.get(pipelineId)) {
	      stub.dispose(); // When the result of `getTargetSeries` changed, the overallTask
	      // should be set as dirty and re-performed.
	
	      overallTask.dirty();
	      agentStubMap.removeKey(pipelineId);
	    }
	  });
	}
	
	function overallTaskReset(context) {
	  context.overallReset(context.ecModel, context.api, context.payload);
	}
	
	function stubReset(context, upstreamContext) {
	  return context.overallProgress && stubProgress;
	}
	
	function stubProgress() {
	  this.agent.dirty();
	  this.getDownstream().dirty();
	}
	
	function stubOnDirty() {
	  this.agent && this.agent.dirty();
	}
	
	function seriesTaskPlan(context) {
	  return context.plan && context.plan(context.model, context.ecModel, context.api, context.payload);
	}
	
	function seriesTaskReset(context) {
	  if (context.useClearVisual) {
	    context.data.clearAllVisual();
	  }
	
	  var resetDefines = context.resetDefines = normalizeToArray(context.reset(context.model, context.ecModel, context.api, context.payload));
	  return resetDefines.length > 1 ? map(resetDefines, function (v, idx) {
	    return makeSeriesTaskProgress(idx);
	  }) : singleSeriesTaskProgress;
	}
	
	var singleSeriesTaskProgress = makeSeriesTaskProgress(0);
	
	function makeSeriesTaskProgress(resetDefineIdx) {
	  return function (params, context) {
	    var data = context.data;
	    var resetDefine = context.resetDefines[resetDefineIdx];
	
	    if (resetDefine && resetDefine.dataEach) {
	      for (var i = params.start; i < params.end; i++) {
	        resetDefine.dataEach(data, i);
	      }
	    } else if (resetDefine && resetDefine.progress) {
	      resetDefine.progress(params, data);
	    }
	  };
	}
	
	function seriesTaskCount(context) {
	  return context.data.count();
	}
	
	function pipe(scheduler, seriesModel, task) {
	  var pipelineId = seriesModel.uid;
	
	  var pipeline = scheduler._pipelineMap.get(pipelineId);
	
	  !pipeline.head && (pipeline.head = task);
	  pipeline.tail && pipeline.tail.pipe(task);
	  pipeline.tail = task;
	  task.__idxInPipeline = pipeline.count++;
	  task.__pipeline = pipeline;
	}
	
	Scheduler.wrapStageHandler = function (stageHandler, visualType) {
	  if (isFunction(stageHandler)) {
	    stageHandler = {
	      overallReset: stageHandler,
	      seriesType: detectSeriseType(stageHandler)
	    };
	  }
	
	  stageHandler.uid = getUID('stageHandler');
	  visualType && (stageHandler.visualType = visualType);
	  return stageHandler;
	};
	/**
	 * Only some legacy stage handlers (usually in echarts extensions) are pure function.
	 * To ensure that they can work normally, they should work in block mode, that is,
	 * they should not be started util the previous tasks finished. So they cause the
	 * progressive rendering disabled. We try to detect the series type, to narrow down
	 * the block range to only the series type they concern, but not all series.
	 */
	
	
	function detectSeriseType(legacyFunc) {
	  seriesType = null;
	
	  try {
	    // Assume there is no async when calling `eachSeriesByType`.
	    legacyFunc(ecModelMock, apiMock);
	  } catch (e) {}
	
	  return seriesType;
	}
	
	var ecModelMock = {};
	var apiMock = {};
	var seriesType;
	mockMethods(ecModelMock, GlobalModel);
	mockMethods(apiMock, ExtensionAPI);
	
	ecModelMock.eachSeriesByType = ecModelMock.eachRawSeriesByType = function (type) {
	  seriesType = type;
	};
	
	ecModelMock.eachComponent = function (cond) {
	  if (cond.mainType === 'series' && cond.subType) {
	    seriesType = cond.subType;
	  }
	};
	
	function mockMethods(target, Clz) {
	  /* eslint-disable */
	  for (var name in Clz.prototype) {
	    // Do not use hasOwnProperty
	    target[name] = noop;
	  }
	  /* eslint-enable */
	
	}
	
	var _default = Scheduler;
	module.exports = _default;

/***/ },
/* 2452 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var contrastColor = '#eee';
	
	var axisCommon = function () {
	  return {
	    axisLine: {
	      lineStyle: {
	        color: contrastColor
	      }
	    },
	    axisTick: {
	      lineStyle: {
	        color: contrastColor
	      }
	    },
	    axisLabel: {
	      textStyle: {
	        color: contrastColor
	      }
	    },
	    splitLine: {
	      lineStyle: {
	        type: 'dashed',
	        color: '#aaa'
	      }
	    },
	    splitArea: {
	      areaStyle: {
	        color: contrastColor
	      }
	    }
	  };
	};
	
	var colorPalette = ['#dd6b66', '#759aa0', '#e69d87', '#8dc1a9', '#ea7e53', '#eedd78', '#73a373', '#73b9bc', '#7289ab', '#91ca8c', '#f49f42'];
	var theme = {
	  color: colorPalette,
	  backgroundColor: '#333',
	  tooltip: {
	    axisPointer: {
	      lineStyle: {
	        color: contrastColor
	      },
	      crossStyle: {
	        color: contrastColor
	      },
	      label: {
	        color: '#000'
	      }
	    }
	  },
	  legend: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  textStyle: {
	    color: contrastColor
	  },
	  title: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  toolbox: {
	    iconStyle: {
	      normal: {
	        borderColor: contrastColor
	      }
	    }
	  },
	  dataZoom: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  visualMap: {
	    textStyle: {
	      color: contrastColor
	    }
	  },
	  timeline: {
	    lineStyle: {
	      color: contrastColor
	    },
	    itemStyle: {
	      normal: {
	        color: colorPalette[1]
	      }
	    },
	    label: {
	      normal: {
	        textStyle: {
	          color: contrastColor
	        }
	      }
	    },
	    controlStyle: {
	      normal: {
	        color: contrastColor,
	        borderColor: contrastColor
	      }
	    }
	  },
	  timeAxis: axisCommon(),
	  logAxis: axisCommon(),
	  valueAxis: axisCommon(),
	  categoryAxis: axisCommon(),
	  line: {
	    symbol: 'circle'
	  },
	  graph: {
	    color: colorPalette
	  },
	  gauge: {
	    title: {
	      textStyle: {
	        color: contrastColor
	      }
	    }
	  },
	  candlestick: {
	    itemStyle: {
	      normal: {
	        color: '#FD1050',
	        color0: '#0CF49B',
	        borderColor: '#FD1050',
	        borderColor0: '#0CF49B'
	      }
	    }
	  }
	};
	theme.categoryAxis.splitLine.show = false;
	var _default = theme;
	module.exports = _default;

/***/ },
/* 2453 */
/***/ function(module, exports) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var colorAll = ['#37A2DA', '#32C5E9', '#67E0E3', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#E062AE', '#E690D1', '#e7bcf3', '#9d96f5', '#8378EA', '#96BFFF'];
	var _default = {
	  color: colorAll,
	  colorLayer: [['#37A2DA', '#ffd85c', '#fd7b5f'], ['#37A2DA', '#67E0E3', '#FFDB5C', '#ff9f7f', '#E062AE', '#9d96f5'], ['#37A2DA', '#32C5E9', '#9FE6B8', '#FFDB5C', '#ff9f7f', '#fb7293', '#e7bcf3', '#8378EA', '#96BFFF'], colorAll]
	};
	module.exports = _default;

/***/ },
/* 2454 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * @param {number} [time=500] Time in ms
	 * @param {string} [easing='linear']
	 * @param {number} [delay=0]
	 * @param {Function} [callback]
	 *
	 * @example
	 *  // Animate position
	 *  animation
	 *      .createWrap()
	 *      .add(el1, {position: [10, 10]})
	 *      .add(el2, {shape: {width: 500}, style: {fill: 'red'}}, 400)
	 *      .done(function () { // done })
	 *      .start('cubicOut');
	 */
	function createWrap() {
	  var storage = [];
	  var elExistsMap = {};
	  var doneCallback;
	  return {
	    /**
	     * Caution: a el can only be added once, otherwise 'done'
	     * might not be called. This method checks this (by el.id),
	     * suppresses adding and returns false when existing el found.
	     *
	     * @param {modele:zrender/Element} el
	     * @param {Object} target
	     * @param {number} [time=500]
	     * @param {number} [delay=0]
	     * @param {string} [easing='linear']
	     * @return {boolean} Whether adding succeeded.
	     *
	     * @example
	     *     add(el, target, time, delay, easing);
	     *     add(el, target, time, easing);
	     *     add(el, target, time);
	     *     add(el, target);
	     */
	    add: function (el, target, time, delay, easing) {
	      if (zrUtil.isString(delay)) {
	        easing = delay;
	        delay = 0;
	      }
	
	      if (elExistsMap[el.id]) {
	        return false;
	      }
	
	      elExistsMap[el.id] = 1;
	      storage.push({
	        el: el,
	        target: target,
	        time: time,
	        delay: delay,
	        easing: easing
	      });
	      return true;
	    },
	
	    /**
	     * Only execute when animation finished. Will not execute when any
	     * of 'stop' or 'stopAnimation' called.
	     *
	     * @param {Function} callback
	     */
	    done: function (callback) {
	      doneCallback = callback;
	      return this;
	    },
	
	    /**
	     * Will stop exist animation firstly.
	     */
	    start: function () {
	      var count = storage.length;
	
	      for (var i = 0, len = storage.length; i < len; i++) {
	        var item = storage[i];
	        item.el.animateTo(item.target, item.time, item.delay, item.easing, done);
	      }
	
	      return this;
	
	      function done() {
	        count--;
	
	        if (!count) {
	          storage.length = 0;
	          elExistsMap = {};
	          doneCallback && doneCallback();
	        }
	      }
	    }
	  };
	}
	
	exports.createWrap = createWrap;

/***/ },
/* 2455 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var _graphic = __webpack_require__(14);
	
	var extendShape = _graphic.extendShape;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	/**
	 * Sausage: similar to sector, but have half circle on both sides
	 * @public
	 */
	var _default = extendShape({
	  type: 'sausage',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r0: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r0 = Math.max(shape.r0 || 0, 0);
	    var r = Math.max(shape.r, 0);
	    var dr = (r - r0) * 0.5;
	    var rCenter = r0 + dr;
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitStartX = Math.cos(startAngle);
	    var unitStartY = Math.sin(startAngle);
	    var unitEndX = Math.cos(endAngle);
	    var unitEndY = Math.sin(endAngle);
	    var lessThanCircle = clockwise ? endAngle - startAngle < Math.PI * 2 : startAngle - endAngle < Math.PI * 2;
	
	    if (lessThanCircle) {
	      ctx.moveTo(unitStartX * r0 + x, unitStartY * r0 + y);
	      ctx.arc(unitStartX * rCenter + x, unitStartY * rCenter + y, dr, -Math.PI + startAngle, startAngle, !clockwise);
	    }
	
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	    ctx.moveTo(unitEndX * r + x, unitEndY * r + y);
	    ctx.arc(unitEndX * rCenter + x, unitEndY * rCenter + y, dr, endAngle - Math.PI * 2, endAngle - Math.PI, !clockwise);
	
	    if (r0 !== 0) {
	      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
	      ctx.moveTo(unitStartX * r0 + x, unitEndY * r0 + y);
	    }
	
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2456 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var zrUtil = __webpack_require__(4);
	
	var lang = __webpack_require__(180);
	
	var _dataProvider = __webpack_require__(212);
	
	var retrieveRawValue = _dataProvider.retrieveRawValue;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	function _default(dom, ecModel) {
	  var ariaModel = ecModel.getModel('aria');
	
	  if (!ariaModel.get('show')) {
	    return;
	  } else if (ariaModel.get('description')) {
	    dom.setAttribute('aria-label', ariaModel.get('description'));
	    return;
	  }
	
	  var seriesCnt = 0;
	  ecModel.eachSeries(function (seriesModel, idx) {
	    ++seriesCnt;
	  }, this);
	  var maxDataCnt = ariaModel.get('data.maxCount') || 10;
	  var maxSeriesCnt = ariaModel.get('series.maxCount') || 10;
	  var displaySeriesCnt = Math.min(seriesCnt, maxSeriesCnt);
	  var ariaLabel;
	
	  if (seriesCnt < 1) {
	    // No series, no aria label
	    return;
	  } else {
	    var title = getTitle();
	
	    if (title) {
	      ariaLabel = replace(getConfig('general.withTitle'), {
	        title: title
	      });
	    } else {
	      ariaLabel = getConfig('general.withoutTitle');
	    }
	
	    var seriesLabels = [];
	    var prefix = seriesCnt > 1 ? 'series.multiple.prefix' : 'series.single.prefix';
	    ariaLabel += replace(getConfig(prefix), {
	      seriesCount: seriesCnt
	    });
	    ecModel.eachSeries(function (seriesModel, idx) {
	      if (idx < displaySeriesCnt) {
	        var seriesLabel;
	        var seriesName = seriesModel.get('name');
	        var seriesTpl = 'series.' + (seriesCnt > 1 ? 'multiple' : 'single') + '.';
	        seriesLabel = getConfig(seriesName ? seriesTpl + 'withName' : seriesTpl + 'withoutName');
	        seriesLabel = replace(seriesLabel, {
	          seriesId: seriesModel.seriesIndex,
	          seriesName: seriesModel.get('name'),
	          seriesType: getSeriesTypeName(seriesModel.subType)
	        });
	        var data = seriesModel.getData();
	        window.data = data;
	
	        if (data.count() > maxDataCnt) {
	          // Show part of data
	          seriesLabel += replace(getConfig('data.partialData'), {
	            displayCnt: maxDataCnt
	          });
	        } else {
	          seriesLabel += getConfig('data.allData');
	        }
	
	        var dataLabels = [];
	
	        for (var i = 0; i < data.count(); i++) {
	          if (i < maxDataCnt) {
	            var name = data.getName(i);
	            var value = retrieveRawValue(data, i);
	            dataLabels.push(replace(name ? getConfig('data.withName') : getConfig('data.withoutName'), {
	              name: name,
	              value: value
	            }));
	          }
	        }
	
	        seriesLabel += dataLabels.join(getConfig('data.separator.middle')) + getConfig('data.separator.end');
	        seriesLabels.push(seriesLabel);
	      }
	    });
	    ariaLabel += seriesLabels.join(getConfig('series.multiple.separator.middle')) + getConfig('series.multiple.separator.end');
	    dom.setAttribute('aria-label', ariaLabel);
	  }
	
	  function replace(str, keyValues) {
	    if (typeof str !== 'string') {
	      return str;
	    }
	
	    var result = str;
	    zrUtil.each(keyValues, function (value, key) {
	      result = result.replace(new RegExp('\\{\\s*' + key + '\\s*\\}', 'g'), value);
	    });
	    return result;
	  }
	
	  function getConfig(path) {
	    var userConfig = ariaModel.get(path);
	
	    if (userConfig == null) {
	      var pathArr = path.split('.');
	      var result = lang.aria;
	
	      for (var i = 0; i < pathArr.length; ++i) {
	        result = result[pathArr[i]];
	      }
	
	      return result;
	    } else {
	      return userConfig;
	    }
	  }
	
	  function getTitle() {
	    var title = ecModel.getModel('title').option;
	
	    if (title && title.length) {
	      title = title[0];
	    }
	
	    return title && title.text;
	  }
	
	  function getSeriesTypeName(type) {
	    return lang.series.typeNames[type] || '自定义图';
	  }
	}
	
	module.exports = _default;

/***/ },
/* 2457 */
/***/ function(module, exports, __webpack_require__) {

	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	
	var Gradient = __webpack_require__(393);
	
	var _util = __webpack_require__(4);
	
	var isFunction = _util.isFunction;
	
	/*
	* Licensed to the Apache Software Foundation (ASF) under one
	* or more contributor license agreements.  See the NOTICE file
	* distributed with this work for additional information
	* regarding copyright ownership.  The ASF licenses this file
	* to you under the Apache License, Version 2.0 (the
	* "License"); you may not use this file except in compliance
	* with the License.  You may obtain a copy of the License at
	*
	*   http://www.apache.org/licenses/LICENSE-2.0
	*
	* Unless required by applicable law or agreed to in writing,
	* software distributed under the License is distributed on an
	* "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
	* KIND, either express or implied.  See the License for the
	* specific language governing permissions and limitations
	* under the License.
	*/
	var _default = {
	  createOnAllSeries: true,
	  performRawSeries: true,
	  reset: function (seriesModel, ecModel) {
	    var data = seriesModel.getData();
	    var colorAccessPath = (seriesModel.visualColorAccessPath || 'itemStyle.color').split('.'); // Set in itemStyle
	
	    var color = seriesModel.get(colorAccessPath);
	    var colorCallback = isFunction(color) && !(color instanceof Gradient) ? color : null; // Default color
	
	    if (!color || colorCallback) {
	      color = seriesModel.getColorFromPalette( // TODO series count changed.
	      seriesModel.name, null, ecModel.getSeriesCount());
	    }
	
	    data.setVisual('color', color);
	    var borderColorAccessPath = (seriesModel.visualBorderColorAccessPath || 'itemStyle.borderColor').split('.');
	    var borderColor = seriesModel.get(borderColorAccessPath);
	    data.setVisual('borderColor', borderColor); // Only visible series has each data be visual encoded
	
	    if (!ecModel.isSeriesFiltered(seriesModel)) {
	      if (colorCallback) {
	        data.each(function (idx) {
	          data.setItemVisual(idx, 'color', colorCallback(seriesModel.getDataParams(idx)));
	        });
	      } // itemStyle in each data item
	
	
	      var dataEach = function (data, idx) {
	        var itemModel = data.getItemModel(idx);
	        var color = itemModel.get(colorAccessPath, true);
	        var borderColor = itemModel.get(borderColorAccessPath, true);
	
	        if (color != null) {
	          data.setItemVisual(idx, 'color', color);
	        }
	
	        if (borderColor != null) {
	          data.setItemVisual(idx, 'borderColor', borderColor);
	        }
	      };
	
	      return {
	        dataEach: data.hasItemOption ? dataEach : null
	      };
	    }
	  }
	};
	module.exports = _default;

/***/ },
/* 2458 */
/***/ function(module, exports, __webpack_require__) {

	var QueryHandler = __webpack_require__(2460);
	var each = __webpack_require__(879).each;
	
	/**
	 * Represents a single media query, manages it's state and registered handlers for this query
	 *
	 * @constructor
	 * @param {string} query the media query string
	 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
	 */
	function MediaQuery(query, isUnconditional) {
	    this.query = query;
	    this.isUnconditional = isUnconditional;
	    this.handlers = [];
	    this.mql = window.matchMedia(query);
	
	    var self = this;
	    this.listener = function(mql) {
	        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
	        self.mql = mql.currentTarget || mql;
	        self.assess();
	    };
	    this.mql.addListener(this.listener);
	}
	
	MediaQuery.prototype = {
	
	    constuctor : MediaQuery,
	
	    /**
	     * add a handler for this query, triggering if already active
	     *
	     * @param {object} handler
	     * @param {function} handler.match callback for when query is activated
	     * @param {function} [handler.unmatch] callback for when query is deactivated
	     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
	     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
	     */
	    addHandler : function(handler) {
	        var qh = new QueryHandler(handler);
	        this.handlers.push(qh);
	
	        this.matches() && qh.on();
	    },
	
	    /**
	     * removes the given handler from the collection, and calls it's destroy methods
	     *
	     * @param {object || function} handler the handler to remove
	     */
	    removeHandler : function(handler) {
	        var handlers = this.handlers;
	        each(handlers, function(h, i) {
	            if(h.equals(handler)) {
	                h.destroy();
	                return !handlers.splice(i,1); //remove from array and exit each early
	            }
	        });
	    },
	
	    /**
	     * Determine whether the media query should be considered a match
	     *
	     * @return {Boolean} true if media query can be considered a match, false otherwise
	     */
	    matches : function() {
	        return this.mql.matches || this.isUnconditional;
	    },
	
	    /**
	     * Clears all handlers and unbinds events
	     */
	    clear : function() {
	        each(this.handlers, function(handler) {
	            handler.destroy();
	        });
	        this.mql.removeListener(this.listener);
	        this.handlers.length = 0; //clear array
	    },
	
	    /*
	        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
	        */
	    assess : function() {
	        var action = this.matches() ? 'on' : 'off';
	
	        each(this.handlers, function(handler) {
	            handler[action]();
	        });
	    }
	};
	
	module.exports = MediaQuery;


/***/ },
/* 2459 */
/***/ function(module, exports, __webpack_require__) {

	var MediaQuery = __webpack_require__(2458);
	var Util = __webpack_require__(879);
	var each = Util.each;
	var isFunction = Util.isFunction;
	var isArray = Util.isArray;
	
	/**
	 * Allows for registration of query handlers.
	 * Manages the query handler's state and is responsible for wiring up browser events
	 *
	 * @constructor
	 */
	function MediaQueryDispatch () {
	    if(!window.matchMedia) {
	        throw new Error('matchMedia not present, legacy browsers require a polyfill');
	    }
	
	    this.queries = {};
	    this.browserIsIncapable = !window.matchMedia('only all').matches;
	}
	
	MediaQueryDispatch.prototype = {
	
	    constructor : MediaQueryDispatch,
	
	    /**
	     * Registers a handler for the given media query
	     *
	     * @param {string} q the media query
	     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
	     * @param {function} options.match fired when query matched
	     * @param {function} [options.unmatch] fired when a query is no longer matched
	     * @param {function} [options.setup] fired when handler first triggered
	     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
	     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
	     */
	    register : function(q, options, shouldDegrade) {
	        var queries         = this.queries,
	            isUnconditional = shouldDegrade && this.browserIsIncapable;
	
	        if(!queries[q]) {
	            queries[q] = new MediaQuery(q, isUnconditional);
	        }
	
	        //normalise to object in an array
	        if(isFunction(options)) {
	            options = { match : options };
	        }
	        if(!isArray(options)) {
	            options = [options];
	        }
	        each(options, function(handler) {
	            if (isFunction(handler)) {
	                handler = { match : handler };
	            }
	            queries[q].addHandler(handler);
	        });
	
	        return this;
	    },
	
	    /**
	     * unregisters a query and all it's handlers, or a specific handler for a query
	     *
	     * @param {string} q the media query to target
	     * @param {object || function} [handler] specific handler to unregister
	     */
	    unregister : function(q, handler) {
	        var query = this.queries[q];
	
	        if(query) {
	            if(handler) {
	                query.removeHandler(handler);
	            }
	            else {
	                query.clear();
	                delete this.queries[q];
	            }
	        }
	
	        return this;
	    }
	};
	
	module.exports = MediaQueryDispatch;


/***/ },
/* 2460 */
/***/ function(module, exports) {

	/**
	 * Delegate to handle a media query being matched and unmatched.
	 *
	 * @param {object} options
	 * @param {function} options.match callback for when the media query is matched
	 * @param {function} [options.unmatch] callback for when the media query is unmatched
	 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
	 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
	 * @constructor
	 */
	function QueryHandler(options) {
	    this.options = options;
	    !options.deferSetup && this.setup();
	}
	
	QueryHandler.prototype = {
	
	    constructor : QueryHandler,
	
	    /**
	     * coordinates setup of the handler
	     *
	     * @function
	     */
	    setup : function() {
	        if(this.options.setup) {
	            this.options.setup();
	        }
	        this.initialised = true;
	    },
	
	    /**
	     * coordinates setup and triggering of the handler
	     *
	     * @function
	     */
	    on : function() {
	        !this.initialised && this.setup();
	        this.options.match && this.options.match();
	    },
	
	    /**
	     * coordinates the unmatch event for the handler
	     *
	     * @function
	     */
	    off : function() {
	        this.options.unmatch && this.options.unmatch();
	    },
	
	    /**
	     * called when a handler is to be destroyed.
	     * delegates to the destroy or unmatch callbacks, depending on availability.
	     *
	     * @function
	     */
	    destroy : function() {
	        this.options.destroy ? this.options.destroy() : this.off();
	    },
	
	    /**
	     * determines equality by reference.
	     * if object is supplied compare options, if function, compare match callback
	     *
	     * @function
	     * @param {object || function} [target] the target for comparison
	     */
	    equals : function(target) {
	        return this.options === target || this.options.match === target;
	    }
	
	};
	
	module.exports = QueryHandler;


/***/ },
/* 2461 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;(function(root,factory){
	    if (true) {
	        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	    } else if (typeof exports === 'object') {
	        module.exports = factory();
	    } else {
	        root.eventListener = factory();
	  }
	}(this, function () {
		function wrap(standard, fallback) {
			return function (el, evtName, listener, useCapture) {
				if (el[standard]) {
					el[standard](evtName, listener, useCapture);
				} else if (el[fallback]) {
					el[fallback]('on' + evtName, listener);
				}
			}
		}
	
	    return {
			add: wrap('addEventListener', 'attachEvent'),
			remove: wrap('removeEventListener', 'detachEvent')
		};
	}));

/***/ },
/* 2462 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	var PhotosMimeType = {
	  isImage: function isImage(mimeString) {
	    return getParts(mimeString)[0] === 'image';
	  },
	  isJpeg: function isJpeg(mimeString) {
	    var parts = getParts(mimeString);
	    return PhotosMimeType.isImage(mimeString) && (
	    // see http://fburl.com/10972194
	    parts[1] === 'jpeg' || parts[1] === 'pjpeg');
	  }
	};
	
	function getParts(mimeString) {
	  return mimeString.split('/');
	}
	
	module.exports = PhotosMimeType;

/***/ },
/* 2463 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * @stub
	 * 
	 */
	
	'use strict';
	
	// \u00a1-\u00b1\u00b4-\u00b8\u00ba\u00bb\u00bf
	//             is latin supplement punctuation except fractions and superscript
	//             numbers
	// \u2010-\u2027\u2030-\u205e
	//             is punctuation from the general punctuation block:
	//             weird quotes, commas, bullets, dashes, etc.
	// \u30fb\u3001\u3002\u3008-\u3011\u3014-\u301f
	//             is CJK punctuation
	// \uff1a-\uff1f\uff01-\uff0f\uff3b-\uff40\uff5b-\uff65
	//             is some full-width/half-width punctuation
	// \u2E2E\u061f\u066a-\u066c\u061b\u060c\u060d\uFD3e\uFD3F
	//             is some Arabic punctuation marks
	// \u1801\u0964\u104a\u104b
	//             is misc. other language punctuation marks
	
	var PUNCTUATION = '[.,+*?$|#{}()\'\\^\\-\\[\\]\\\\\\/!@%"~=<>_:;' + '\u30FB\u3001\u3002\u3008-\u3011\u3014-\u301F\uFF1A-\uFF1F\uFF01-\uFF0F' + '\uFF3B-\uFF40\uFF5B-\uFF65\u2E2E\u061F\u066A-\u066C\u061B\u060C\u060D' + '\uFD3E\uFD3F\u1801\u0964\u104A\u104B\u2010-\u2027\u2030-\u205E' + '\xA1-\xB1\xB4-\xB8\xBA\xBB\xBF]';
	
	module.exports = {
	  getPunctuation: function getPunctuation() {
	    return PUNCTUATION;
	  }
	};

/***/ },
/* 2464 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var URI = function () {
	  function URI(uri) {
	    _classCallCheck(this, URI);
	
	    this._uri = uri;
	  }
	
	  URI.prototype.toString = function toString() {
	    return this._uri;
	  };
	
	  return URI;
	}();
	
	module.exports = URI;

/***/ },
/* 2465 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/**
	 * Stateful API for text direction detection
	 *
	 * This class can be used in applications where you need to detect the
	 * direction of a sequence of text blocks, where each direction shall be used
	 * as the fallback direction for the next one.
	 *
	 * NOTE: A default direction, if not provided, is set based on the global
	 *       direction, as defined by `UnicodeBidiDirection`.
	 *
	 * == Example ==
	 * ```
	 * var UnicodeBidiService = require('UnicodeBidiService');
	 *
	 * var bidiService = new UnicodeBidiService();
	 *
	 * ...
	 *
	 * bidiService.reset();
	 * for (var para in paragraphs) {
	 *   var dir = bidiService.getDirection(para);
	 *   ...
	 * }
	 * ```
	 *
	 * Part of our implementation of Unicode Bidirectional Algorithm (UBA)
	 * Unicode Standard Annex #9 (UAX9)
	 * http://www.unicode.org/reports/tr9/
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var UnicodeBidi = __webpack_require__(884);
	var UnicodeBidiDirection = __webpack_require__(521);
	
	var invariant = __webpack_require__(18);
	
	var UnicodeBidiService = function () {
	
	  /**
	   * Stateful class for paragraph direction detection
	   *
	   * @param defaultDir  Default direction of the service
	   */
	  function UnicodeBidiService(defaultDir) {
	    _classCallCheck(this, UnicodeBidiService);
	
	    if (!defaultDir) {
	      defaultDir = UnicodeBidiDirection.getGlobalDir();
	    } else {
	      !UnicodeBidiDirection.isStrong(defaultDir) ?  false ? invariant(false, 'Default direction must be a strong direction (LTR or RTL)') : invariant(false) : void 0;
	    }
	    this._defaultDir = defaultDir;
	    this.reset();
	  }
	
	  /**
	   * Reset the internal state
	   *
	   * Instead of creating a new instance, you can just reset() your instance
	   * everytime you start a new loop.
	   */
	
	
	  UnicodeBidiService.prototype.reset = function reset() {
	    this._lastDir = this._defaultDir;
	  };
	
	  /**
	   * Returns the direction of a block of text, and remembers it as the
	   * fall-back direction for the next paragraph.
	   *
	   * @param str  A text block, e.g. paragraph, table cell, tag
	   * @return     The resolved direction
	   */
	
	
	  UnicodeBidiService.prototype.getDirection = function getDirection(str) {
	    this._lastDir = UnicodeBidi.getDirection(str, this._lastDir);
	    return this._lastDir;
	  };
	
	  return UnicodeBidiService;
	}();
	
	module.exports = UnicodeBidiService;

/***/ },
/* 2466 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Usage note:
	 * This module makes a best effort to export the same data we would internally.
	 * At Facebook we use a server-generated module that does the parsing and
	 * exports the data for the client to use. We can't rely on a server-side
	 * implementation in open source so instead we make use of an open source
	 * library to do the heavy lifting and then make some adjustments as necessary.
	 * It's likely there will be some differences. Some we can smooth over.
	 * Others are going to be harder.
	 */
	
	'use strict';
	
	var UAParser = __webpack_require__(2944);
	
	var UNKNOWN = 'Unknown';
	
	var PLATFORM_MAP = {
	  'Mac OS': 'Mac OS X'
	};
	
	/**
	 * Convert from UAParser platform name to what we expect.
	 */
	function convertPlatformName(name) {
	  return PLATFORM_MAP[name] || name;
	}
	
	/**
	 * Get the version number in parts. This is very naive. We actually get major
	 * version as a part of UAParser already, which is generally good enough, but
	 * let's get the minor just in case.
	 */
	function getBrowserVersion(version) {
	  if (!version) {
	    return {
	      major: '',
	      minor: ''
	    };
	  }
	  var parts = version.split('.');
	  return {
	    major: parts[0],
	    minor: parts[1]
	  };
	}
	
	/**
	 * Get the UA data fom UAParser and then convert it to the format we're
	 * expecting for our APIS.
	 */
	var parser = new UAParser();
	var results = parser.getResult();
	
	// Do some conversion first.
	var browserVersionData = getBrowserVersion(results.browser.version);
	var uaData = {
	  browserArchitecture: results.cpu.architecture || UNKNOWN,
	  browserFullVersion: results.browser.version || UNKNOWN,
	  browserMinorVersion: browserVersionData.minor || UNKNOWN,
	  browserName: results.browser.name || UNKNOWN,
	  browserVersion: results.browser.major || UNKNOWN,
	  deviceName: results.device.model || UNKNOWN,
	  engineName: results.engine.name || UNKNOWN,
	  engineVersion: results.engine.version || UNKNOWN,
	  platformArchitecture: results.cpu.architecture || UNKNOWN,
	  platformName: convertPlatformName(results.os.name) || UNKNOWN,
	  platformVersion: results.os.version || UNKNOWN,
	  platformFullVersion: results.os.version || UNKNOWN
	};
	
	module.exports = uaData;

/***/ },
/* 2467 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var invariant = __webpack_require__(18);
	
	var componentRegex = /\./;
	var orRegex = /\|\|/;
	var rangeRegex = /\s+\-\s+/;
	var modifierRegex = /^(<=|<|=|>=|~>|~|>|)?\s*(.+)/;
	var numericRegex = /^(\d*)(.*)/;
	
	/**
	 * Splits input `range` on "||" and returns true if any subrange matches
	 * `version`.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkOrExpression(range, version) {
	  var expressions = range.split(orRegex);
	
	  if (expressions.length > 1) {
	    return expressions.some(function (range) {
	      return VersionRange.contains(range, version);
	    });
	  } else {
	    range = expressions[0].trim();
	    return checkRangeExpression(range, version);
	  }
	}
	
	/**
	 * Splits input `range` on " - " (the surrounding whitespace is required) and
	 * returns true if version falls between the two operands.
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkRangeExpression(range, version) {
	  var expressions = range.split(rangeRegex);
	
	  !(expressions.length > 0 && expressions.length <= 2) ?  false ? invariant(false, 'the "-" operator expects exactly 2 operands') : invariant(false) : void 0;
	
	  if (expressions.length === 1) {
	    return checkSimpleExpression(expressions[0], version);
	  } else {
	    var startVersion = expressions[0],
	        endVersion = expressions[1];
	
	    !(isSimpleVersion(startVersion) && isSimpleVersion(endVersion)) ?  false ? invariant(false, 'operands to the "-" operator must be simple (no modifiers)') : invariant(false) : void 0;
	
	    return checkSimpleExpression('>=' + startVersion, version) && checkSimpleExpression('<=' + endVersion, version);
	  }
	}
	
	/**
	 * Checks if `range` matches `version`. `range` should be a "simple" range (ie.
	 * not a compound range using the " - " or "||" operators).
	 *
	 * @param {string} range
	 * @param {string} version
	 * @returns {boolean}
	 */
	function checkSimpleExpression(range, version) {
	  range = range.trim();
	  if (range === '') {
	    return true;
	  }
	
	  var versionComponents = version.split(componentRegex);
	
	  var _getModifierAndCompon = getModifierAndComponents(range),
	      modifier = _getModifierAndCompon.modifier,
	      rangeComponents = _getModifierAndCompon.rangeComponents;
	
	  switch (modifier) {
	    case '<':
	      return checkLessThan(versionComponents, rangeComponents);
	    case '<=':
	      return checkLessThanOrEqual(versionComponents, rangeComponents);
	    case '>=':
	      return checkGreaterThanOrEqual(versionComponents, rangeComponents);
	    case '>':
	      return checkGreaterThan(versionComponents, rangeComponents);
	    case '~':
	    case '~>':
	      return checkApproximateVersion(versionComponents, rangeComponents);
	    default:
	      return checkEqual(versionComponents, rangeComponents);
	  }
	}
	
	/**
	 * Checks whether `a` is less than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThan(a, b) {
	  return compareComponents(a, b) === -1;
	}
	
	/**
	 * Checks whether `a` is less than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkLessThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === -1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkEqual(a, b) {
	  return compareComponents(a, b) === 0;
	}
	
	/**
	 * Checks whether `a` is greater than or equal to `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThanOrEqual(a, b) {
	  var result = compareComponents(a, b);
	  return result === 1 || result === 0;
	}
	
	/**
	 * Checks whether `a` is greater than `b`.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkGreaterThan(a, b) {
	  return compareComponents(a, b) === 1;
	}
	
	/**
	 * Checks whether `a` is "reasonably close" to `b` (as described in
	 * https://www.npmjs.org/doc/misc/semver.html). For example, if `b` is "1.3.1"
	 * then "reasonably close" is defined as ">= 1.3.1 and < 1.4".
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {boolean}
	 */
	function checkApproximateVersion(a, b) {
	  var lowerBound = b.slice();
	  var upperBound = b.slice();
	
	  if (upperBound.length > 1) {
	    upperBound.pop();
	  }
	  var lastIndex = upperBound.length - 1;
	  var numeric = parseInt(upperBound[lastIndex], 10);
	  if (isNumber(numeric)) {
	    upperBound[lastIndex] = numeric + 1 + '';
	  }
	
	  return checkGreaterThanOrEqual(a, lowerBound) && checkLessThan(a, upperBound);
	}
	
	/**
	 * Extracts the optional modifier (<, <=, =, >=, >, ~, ~>) and version
	 * components from `range`.
	 *
	 * For example, given `range` ">= 1.2.3" returns an object with a `modifier` of
	 * `">="` and `components` of `[1, 2, 3]`.
	 *
	 * @param {string} range
	 * @returns {object}
	 */
	function getModifierAndComponents(range) {
	  var rangeComponents = range.split(componentRegex);
	  var matches = rangeComponents[0].match(modifierRegex);
	  !matches ?  false ? invariant(false, 'expected regex to match but it did not') : invariant(false) : void 0;
	
	  return {
	    modifier: matches[1],
	    rangeComponents: [matches[2]].concat(rangeComponents.slice(1))
	  };
	}
	
	/**
	 * Determines if `number` is a number.
	 *
	 * @param {mixed} number
	 * @returns {boolean}
	 */
	function isNumber(number) {
	  return !isNaN(number) && isFinite(number);
	}
	
	/**
	 * Tests whether `range` is a "simple" version number without any modifiers
	 * (">", "~" etc).
	 *
	 * @param {string} range
	 * @returns {boolean}
	 */
	function isSimpleVersion(range) {
	  return !getModifierAndComponents(range).modifier;
	}
	
	/**
	 * Zero-pads array `array` until it is at least `length` long.
	 *
	 * @param {array} array
	 * @param {number} length
	 */
	function zeroPad(array, length) {
	  for (var i = array.length; i < length; i++) {
	    array[i] = '0';
	  }
	}
	
	/**
	 * Normalizes `a` and `b` in preparation for comparison by doing the following:
	 *
	 * - zero-pads `a` and `b`
	 * - marks any "x", "X" or "*" component in `b` as equivalent by zero-ing it out
	 *   in both `a` and `b`
	 * - marks any final "*" component in `b` as a greedy wildcard by zero-ing it
	 *   and all of its successors in `a`
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {array<array<string>>}
	 */
	function normalizeVersions(a, b) {
	  a = a.slice();
	  b = b.slice();
	
	  zeroPad(a, b.length);
	
	  // mark "x" and "*" components as equal
	  for (var i = 0; i < b.length; i++) {
	    var matches = b[i].match(/^[x*]$/i);
	    if (matches) {
	      b[i] = a[i] = '0';
	
	      // final "*" greedily zeros all remaining components
	      if (matches[0] === '*' && i === b.length - 1) {
	        for (var j = i; j < a.length; j++) {
	          a[j] = '0';
	        }
	      }
	    }
	  }
	
	  zeroPad(b, a.length);
	
	  return [a, b];
	}
	
	/**
	 * Returns the numerical -- not the lexicographical -- ordering of `a` and `b`.
	 *
	 * For example, `10-alpha` is greater than `2-beta`.
	 *
	 * @param {string} a
	 * @param {string} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareNumeric(a, b) {
	  var aPrefix = a.match(numericRegex)[1];
	  var bPrefix = b.match(numericRegex)[1];
	  var aNumeric = parseInt(aPrefix, 10);
	  var bNumeric = parseInt(bPrefix, 10);
	
	  if (isNumber(aNumeric) && isNumber(bNumeric) && aNumeric !== bNumeric) {
	    return compare(aNumeric, bNumeric);
	  } else {
	    return compare(a, b);
	  }
	}
	
	/**
	 * Returns the ordering of `a` and `b`.
	 *
	 * @param {string|number} a
	 * @param {string|number} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compare(a, b) {
	  !(typeof a === typeof b) ?  false ? invariant(false, '"a" and "b" must be of the same type') : invariant(false) : void 0;
	
	  if (a > b) {
	    return 1;
	  } else if (a < b) {
	    return -1;
	  } else {
	    return 0;
	  }
	}
	
	/**
	 * Compares arrays of version components.
	 *
	 * @param {array<string>} a
	 * @param {array<string>} b
	 * @returns {number} -1, 0 or 1 to indicate whether `a` is less than, equal to,
	 * or greater than `b`, respectively
	 */
	function compareComponents(a, b) {
	  var _normalizeVersions = normalizeVersions(a, b),
	      aNormalized = _normalizeVersions[0],
	      bNormalized = _normalizeVersions[1];
	
	  for (var i = 0; i < bNormalized.length; i++) {
	    var result = compareNumeric(aNormalized[i], bNormalized[i]);
	    if (result) {
	      return result;
	    }
	  }
	
	  return 0;
	}
	
	var VersionRange = {
	  /**
	   * Checks whether `version` satisfies the `range` specification.
	   *
	   * We support a subset of the expressions defined in
	   * https://www.npmjs.org/doc/misc/semver.html:
	   *
	   *    version   Must match version exactly
	   *    =version  Same as just version
	   *    >version  Must be greater than version
	   *    >=version Must be greater than or equal to version
	   *    <version  Must be less than version
	   *    <=version Must be less than or equal to version
	   *    ~version  Must be at least version, but less than the next significant
	   *              revision above version:
	   *              "~1.2.3" is equivalent to ">= 1.2.3 and < 1.3"
	   *    ~>version Equivalent to ~version
	   *    1.2.x     Must match "1.2.x", where "x" is a wildcard that matches
	   *              anything
	   *    1.2.*     Similar to "1.2.x", but "*" in the trailing position is a
	   *              "greedy" wildcard, so will match any number of additional
	   *              components:
	   *              "1.2.*" will match "1.2.1", "1.2.1.1", "1.2.1.1.1" etc
	   *    *         Any version
	   *    ""        (Empty string) Same as *
	   *    v1 - v2   Equivalent to ">= v1 and <= v2"
	   *    r1 || r2  Passes if either r1 or r2 are satisfied
	   *
	   * @param {string} range
	   * @param {string} version
	   * @returns {boolean}
	   */
	  contains: function contains(range, version) {
	    return checkOrExpression(range.trim(), version.trim());
	  }
	};
	
	module.exports = VersionRange;

/***/ },
/* 2468 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(885);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 2469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(93);
	
	var createArrayFromMixed = __webpack_require__(886);
	var getMarkupWrap = __webpack_require__(2473);
	var invariant = __webpack_require__(18);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 2470 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var isWebkit = typeof navigator !== 'undefined' && navigator.userAgent.indexOf('AppleWebKit') > -1;
	
	/**
	 * Gets the element with the document scroll properties such as `scrollLeft` and
	 * `scrollHeight`. This may differ across different browsers.
	 *
	 * NOTE: The return value can be null if the DOM is not yet ready.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getDocumentScrollElement(doc) {
	  doc = doc || document;
	  if (doc.scrollingElement) {
	    return doc.scrollingElement;
	  }
	  return !isWebkit && doc.compatMode === 'CSS1Compat' ? doc.documentElement : doc.body;
	}
	
	module.exports = getDocumentScrollElement;

/***/ },
/* 2471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var getElementRect = __webpack_require__(2472);
	
	/**
	 * Gets an element's position in pixels relative to the viewport. The returned
	 * object represents the position of the element's top left corner.
	 *
	 * @param {DOMElement} element
	 * @return {object}
	 */
	function getElementPosition(element) {
	  var rect = getElementRect(element);
	  return {
	    x: rect.left,
	    y: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	}
	
	module.exports = getElementPosition;

/***/ },
/* 2472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var containsNode = __webpack_require__(365);
	
	/**
	 * Gets an element's bounding rect in pixels relative to the viewport.
	 *
	 * @param {DOMElement} elem
	 * @return {object}
	 */
	function getElementRect(elem) {
	  var docElem = elem.ownerDocument.documentElement;
	
	  // FF 2, Safari 3 and Opera 9.5- do not support getBoundingClientRect().
	  // IE9- will throw if the element is not in the document.
	  if (!('getBoundingClientRect' in elem) || !containsNode(docElem, elem)) {
	    return {
	      left: 0,
	      right: 0,
	      top: 0,
	      bottom: 0
	    };
	  }
	
	  // Subtracts clientTop/Left because IE8- added a 2px border to the
	  // <html> element (see http://fburl.com/1493213). IE 7 in
	  // Quicksmode does not report clientLeft/clientTop so there
	  // will be an unaccounted offset of 2px when in quirksmode
	  var rect = elem.getBoundingClientRect();
	
	  return {
	    left: Math.round(rect.left) - docElem.clientLeft,
	    right: Math.round(rect.right) - docElem.clientLeft,
	    top: Math.round(rect.top) - docElem.clientTop,
	    bottom: Math.round(rect.bottom) - docElem.clientTop
	  };
	}
	
	module.exports = getElementRect;

/***/ },
/* 2473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(93);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 2474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var camelize = __webpack_require__(885);
	var hyphenate = __webpack_require__(889);
	
	function asString(value) /*?string*/{
	  return value == null ? value : String(value);
	}
	
	function getStyleProperty( /*DOMNode*/node, /*string*/name) /*?string*/{
	  var computedStyle = void 0;
	
	  // W3C Standard
	  if (window.getComputedStyle) {
	    // In certain cases such as within an iframe in FF3, this returns null.
	    computedStyle = window.getComputedStyle(node, null);
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	  }
	  // Safari
	  if (document.defaultView && document.defaultView.getComputedStyle) {
	    computedStyle = document.defaultView.getComputedStyle(node, null);
	    // A Safari bug causes this to return null for `display: none` elements.
	    if (computedStyle) {
	      return asString(computedStyle.getPropertyValue(hyphenate(name)));
	    }
	    if (name === 'display') {
	      return 'none';
	    }
	  }
	  // Internet Explorer
	  if (node.currentStyle) {
	    if (name === 'float') {
	      return asString(node.currentStyle.cssFloat || node.currentStyle.styleFloat);
	    }
	    return asString(node.currentStyle[camelize(name)]);
	  }
	  return asString(node.style && node.style[camelize(name)]);
	}
	
	module.exports = getStyleProperty;

/***/ },
/* 2475 */
/***/ function(module, exports) {

	"use strict";
	
	function getViewportWidth() {
	  var width = void 0;
	  if (document.documentElement) {
	    width = document.documentElement.clientWidth;
	  }
	
	  if (!width && document.body) {
	    width = document.body.clientWidth;
	  }
	
	  return width || 0;
	} /**
	   * Copyright (c) 2013-present, Facebook, Inc.
	   *
	   * This source code is licensed under the MIT license found in the
	   * LICENSE file in the root directory of this source tree.
	   *
	   * 
	   * @typechecks
	   */
	
	function getViewportHeight() {
	  var height = void 0;
	  if (document.documentElement) {
	    height = document.documentElement.clientHeight;
	  }
	
	  if (!height && document.body) {
	    height = document.body.clientHeight;
	  }
	
	  return height || 0;
	}
	
	/**
	 * Gets the viewport dimensions including any scrollbars.
	 */
	function getViewportDimensions() {
	  return {
	    width: window.innerWidth || getViewportWidth(),
	    height: window.innerHeight || getViewportHeight()
	  };
	}
	
	/**
	 * Gets the viewport dimensions excluding any scrollbars.
	 */
	getViewportDimensions.withoutScrollbars = function () {
	  return {
	    width: getViewportWidth(),
	    height: getViewportHeight()
	  };
	};
	
	module.exports = getViewportDimensions;

/***/ },
/* 2476 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(889);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 2477 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 2478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(2477);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 2479 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Combines multiple className strings into one.
	 * http://jsperf.com/joinclasses-args-vs-array
	 *
	 * @param {...?string} className
	 * @return {string}
	 */
	
	function joinClasses(className /*, ... */) {
	  if (!className) {
	    className = '';
	  }
	  var nextClass = void 0;
	  var argLength = arguments.length;
	  if (argLength > 1) {
	    for (var ii = 1; ii < argLength; ii++) {
	      nextClass = arguments[ii];
	      if (nextClass) {
	        className = (className ? className + ' ' : '') + nextClass;
	      }
	    }
	  }
	  return className;
	}
	
	module.exports = joinClasses;

/***/ },
/* 2480 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * Executes the provided `callback` once for each enumerable own property in the
	 * object and constructs a new object from the results. The `callback` is
	 * invoked with three arguments:
	 *
	 *  - the property value
	 *  - the property name
	 *  - the object being traversed
	 *
	 * Properties that are added after the call to `mapObject` will not be visited
	 * by `callback`. If the values of existing properties are changed, the value
	 * passed to `callback` will be the value at the time `mapObject` visits them.
	 * Properties that are deleted before being visited are not visited.
	 *
	 * @grep function objectMap()
	 * @grep function objMap()
	 *
	 * @param {?object} object
	 * @param {function} callback
	 * @param {*} context
	 * @return {?object}
	 */
	function mapObject(object, callback, context) {
	  if (!object) {
	    return null;
	  }
	  var result = {};
	  for (var name in object) {
	    if (hasOwnProperty.call(object, name)) {
	      result[name] = callback.call(context, object[name], name, object);
	    }
	  }
	  return result;
	}
	
	module.exports = mapObject;

/***/ },
/* 2481 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	// setimmediate adds setImmediate to the global. We want to make sure we export
	// the actual function.
	
	__webpack_require__(594);
	module.exports = global.setImmediate;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2482 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2483 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var loopAsync = exports.loopAsync = function loopAsync(turns, work, callback) {
	  var currentTurn = 0,
	      isDone = false;
	  var isSync = false,
	      hasNext = false,
	      doneArgs = void 0;
	
	  var done = function done() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    isDone = true;
	
	    if (isSync) {
	      // Iterate instead of recursing if possible.
	      doneArgs = args;
	      return;
	    }
	
	    callback.apply(undefined, args);
	  };
	
	  var next = function next() {
	    if (isDone) return;
	
	    hasNext = true;
	
	    if (isSync) return; // Iterate instead of recursing if possible.
	
	    isSync = true;
	
	    while (!isDone && currentTurn < turns && hasNext) {
	      hasNext = false;
	      work(currentTurn++, next, done);
	    }
	
	    isSync = false;
	
	    if (isDone) {
	      // This means the loop finished synchronously.
	      callback.apply(undefined, doneArgs);
	      return;
	    }
	
	    if (currentTurn >= turns && hasNext) {
	      isDone = true;
	      callback();
	    }
	  };
	
	  next();
	};

/***/ },
/* 2484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.startListener = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(525);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _warning = __webpack_require__(216);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _LocationUtils = __webpack_require__(254);
	
	var _DOMUtils = __webpack_require__(368);
	
	var _DOMStateStorage = __webpack_require__(891);
	
	var _PathUtils = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation(pathCoder, queryKey) {
	  var path = pathCoder.decodePath(getHashPath());
	  var key = (0, _PathUtils.getQueryStringValueFromPath)(path, queryKey);
	
	  var state = void 0;
	  if (key) {
	    path = (0, _PathUtils.stripQueryStringValueFromPath)(path, queryKey);
	    state = (0, _DOMStateStorage.readState)(key);
	  }
	
	  var init = (0, _PathUtils.parsePath)(path);
	  init.state = state;
	
	  return (0, _LocationUtils.createLocation)(init, undefined, key);
	};
	
	var prevLocation = void 0;
	
	var startListener = exports.startListener = function startListener(listener, pathCoder, queryKey) {
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = pathCoder.encodePath(path);
	
	    if (path !== encodedPath) {
	      // Always be sure we have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var currentLocation = getCurrentLocation(pathCoder, queryKey);
	
	      if (prevLocation && currentLocation.key && prevLocation.key === currentLocation.key) return; // Ignore extraneous hashchange events
	
	      prevLocation = currentLocation;
	
	      listener(currentLocation);
	    }
	  };
	
	  // Ensure the hash is encoded properly.
	  var path = getHashPath();
	  var encodedPath = pathCoder.encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	
	  return function () {
	    return (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	  };
	};
	
	var updateLocation = function updateLocation(location, pathCoder, queryKey, updateHash) {
	  var state = location.state,
	      key = location.key;
	
	
	  var path = pathCoder.encodePath((0, _PathUtils.createPath)(location));
	
	  if (state !== undefined) {
	    path = (0, _PathUtils.addQueryStringValueToPath)(path, queryKey, key);
	    (0, _DOMStateStorage.saveState)(key, state);
	  }
	
	  prevLocation = location;
	
	  updateHash(path);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) {
	      pushHashPath(path);
	    } else {
	       false ? (0, _warning2.default)(false, 'You cannot PUSH the same path using hash history') : void 0;
	    }
	  });
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location, pathCoder, queryKey) {
	  return updateLocation(location, pathCoder, queryKey, function (path) {
	    if (getHashPath() !== path) replaceHashPath(path);
	  });
	};

/***/ },
/* 2485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.replaceLocation = exports.pushLocation = exports.getCurrentLocation = exports.go = exports.getUserConfirmation = undefined;
	
	var _BrowserProtocol = __webpack_require__(525);
	
	Object.defineProperty(exports, 'getUserConfirmation', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.getUserConfirmation;
	  }
	});
	Object.defineProperty(exports, 'go', {
	  enumerable: true,
	  get: function get() {
	    return _BrowserProtocol.go;
	  }
	});
	
	var _LocationUtils = __webpack_require__(254);
	
	var _PathUtils = __webpack_require__(182);
	
	var getCurrentLocation = exports.getCurrentLocation = function getCurrentLocation() {
	  return (0, _LocationUtils.createLocation)(window.location);
	};
	
	var pushLocation = exports.pushLocation = function pushLocation(location) {
	  window.location.href = (0, _PathUtils.createPath)(location);
	  return false; // Don't update location
	};
	
	var replaceLocation = exports.replaceLocation = function replaceLocation(location) {
	  window.location.replace((0, _PathUtils.createPath)(location));
	  return false; // Don't update location
	};

/***/ },
/* 2486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(526);
	
	var _BrowserProtocol = __webpack_require__(525);
	
	var BrowserProtocol = _interopRequireWildcard(_BrowserProtocol);
	
	var _RefreshProtocol = __webpack_require__(2485);
	
	var RefreshProtocol = _interopRequireWildcard(_RefreshProtocol);
	
	var _DOMUtils = __webpack_require__(368);
	
	var _createHistory = __webpack_require__(527);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates and returns a history object that uses HTML5's history API
	 * (pushState, replaceState, and the popstate event) to manage history.
	 * This is the recommended method of managing history in browsers because
	 * it provides the cleanest URLs.
	 *
	 * Note: In browsers that do not support the HTML5 history API full
	 * page reloads will be used to preserve clean URLs. You can force this
	 * behavior using { forceRefresh: true } in options.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Browser history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var useRefresh = options.forceRefresh || !(0, _DOMUtils.supportsHistory)();
	  var Protocol = useRefresh ? RefreshProtocol : BrowserProtocol;
	
	  var getUserConfirmation = Protocol.getUserConfirmation,
	      getCurrentLocation = Protocol.getCurrentLocation,
	      pushLocation = Protocol.pushLocation,
	      replaceLocation = Protocol.replaceLocation,
	      go = Protocol.go;
	
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = BrowserProtocol.startListener(history.transitionTo);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen
	  });
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 2487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(216);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _ExecutionEnvironment = __webpack_require__(526);
	
	var _DOMUtils = __webpack_require__(368);
	
	var _HashProtocol = __webpack_require__(2484);
	
	var HashProtocol = _interopRequireWildcard(_HashProtocol);
	
	var _createHistory = __webpack_require__(527);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DefaultQueryKey = '_k';
	
	var addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!' + path;
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substring(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '/' ? path.substring(1) : path;
	    },
	    decodePath: addLeadingSlash
	  },
	  slash: {
	    encodePath: addLeadingSlash,
	    decodePath: addLeadingSlash
	  }
	};
	
	var createHashHistory = function createHashHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'Hash history needs a DOM') : (0, _invariant2.default)(false) : void 0;
	
	  var queryKey = options.queryKey,
	      hashType = options.hashType;
	
	
	   false ? (0, _warning2.default)(queryKey !== false, 'Using { queryKey: false } no longer works. Instead, just don\'t ' + 'use location state if you don\'t want a key in your URL query string') : void 0;
	
	  if (typeof queryKey !== 'string') queryKey = DefaultQueryKey;
	
	  if (hashType == null) hashType = 'slash';
	
	  if (!(hashType in HashPathCoders)) {
	     false ? (0, _warning2.default)(false, 'Invalid hash type: %s', hashType) : void 0;
	
	    hashType = 'slash';
	  }
	
	  var pathCoder = HashPathCoders[hashType];
	
	  var getUserConfirmation = HashProtocol.getUserConfirmation;
	
	
	  var getCurrentLocation = function getCurrentLocation() {
	    return HashProtocol.getCurrentLocation(pathCoder, queryKey);
	  };
	
	  var pushLocation = function pushLocation(location) {
	    return HashProtocol.pushLocation(location, pathCoder, queryKey);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    return HashProtocol.replaceLocation(location, pathCoder, queryKey);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({
	    getUserConfirmation: getUserConfirmation }, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: HashProtocol.go
	  }));
	
	  var listenerCount = 0,
	      stopListener = void 0;
	
	  var startListener = function startListener(listener, before) {
	    if (++listenerCount === 1) stopListener = HashProtocol.startListener(history.transitionTo, pathCoder, queryKey);
	
	    var unlisten = before ? history.listenBefore(listener) : history.listen(listener);
	
	    return function () {
	      unlisten();
	
	      if (--listenerCount === 0) stopListener();
	    };
	  };
	
	  var listenBefore = function listenBefore(listener) {
	    return startListener(listener, true);
	  };
	
	  var listen = function listen(listener) {
	    return startListener(listener, false);
	  };
	
	  var goIsSupportedWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var go = function go(n) {
	     false ? (0, _warning2.default)(goIsSupportedWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
	
	    history.go(n);
	  };
	
	  var createHref = function createHref(path) {
	    return '#' + pathCoder.encodePath(history.createHref(path));
	  };
	
	  return _extends({}, history, {
	    listenBefore: listenBefore,
	    listen: listen,
	    go: go,
	    createHref: createHref
	  });
	};
	
	exports.default = createHashHistory;

/***/ },
/* 2488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(216);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(254);
	
	var _PathUtils = __webpack_require__(182);
	
	var _createHistory = __webpack_require__(527);
	
	var _createHistory2 = _interopRequireDefault(_createHistory);
	
	var _Actions = __webpack_require__(367);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createStateStorage = function createStateStorage(entries) {
	  return entries.filter(function (entry) {
	    return entry.state;
	  }).reduce(function (memo, entry) {
	    memo[entry.key] = entry.state;
	    return memo;
	  }, {});
	};
	
	var createMemoryHistory = function createMemoryHistory() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (Array.isArray(options)) {
	    options = { entries: options };
	  } else if (typeof options === 'string') {
	    options = { entries: [options] };
	  }
	
	  var getCurrentLocation = function getCurrentLocation() {
	    var entry = entries[current];
	    var path = (0, _PathUtils.createPath)(entry);
	
	    var key = void 0,
	        state = void 0;
	    if (entry.key) {
	      key = entry.key;
	      state = readState(key);
	    }
	
	    var init = (0, _PathUtils.parsePath)(path);
	
	    return (0, _LocationUtils.createLocation)(_extends({}, init, { state: state }), undefined, key);
	  };
	
	  var canGo = function canGo(n) {
	    var index = current + n;
	    return index >= 0 && index < entries.length;
	  };
	
	  var go = function go(n) {
	    if (!n) return;
	
	    if (!canGo(n)) {
	       false ? (0, _warning2.default)(false, 'Cannot go(%s) there is not enough history', n) : void 0;
	
	      return;
	    }
	
	    current += n;
	    var currentLocation = getCurrentLocation();
	
	    // Change action to POP
	    history.transitionTo(_extends({}, currentLocation, { action: _Actions.POP }));
	  };
	
	  var pushLocation = function pushLocation(location) {
	    current += 1;
	
	    if (current < entries.length) entries.splice(current);
	
	    entries.push(location);
	
	    saveState(location.key, location.state);
	  };
	
	  var replaceLocation = function replaceLocation(location) {
	    entries[current] = location;
	    saveState(location.key, location.state);
	  };
	
	  var history = (0, _createHistory2.default)(_extends({}, options, {
	    getCurrentLocation: getCurrentLocation,
	    pushLocation: pushLocation,
	    replaceLocation: replaceLocation,
	    go: go
	  }));
	
	  var _options = options,
	      entries = _options.entries,
	      current = _options.current;
	
	
	  if (typeof entries === 'string') {
	    entries = [entries];
	  } else if (!Array.isArray(entries)) {
	    entries = ['/'];
	  }
	
	  entries = entries.map(function (entry) {
	    return (0, _LocationUtils.createLocation)(entry);
	  });
	
	  if (current == null) {
	    current = entries.length - 1;
	  } else {
	    !(current >= 0 && current < entries.length) ?  false ? (0, _invariant2.default)(false, 'Current index must be >= 0 and < %s, was %s', entries.length, current) : (0, _invariant2.default)(false) : void 0;
	  }
	
	  var storage = createStateStorage(entries);
	
	  var saveState = function saveState(key, state) {
	    return storage[key] = state;
	  };
	
	  var readState = function readState(key) {
	    return storage[key];
	  };
	
	  return _extends({}, history, {
	    canGo: canGo
	  });
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 2489 */
/***/ function(module, exports) {

	'use strict'
	
	module.exports = isMobile
	module.exports.isMobile = isMobile
	module.exports.default = isMobile
	
	var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i
	
	var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i
	
	function isMobile (opts) {
	  if (!opts) opts = {}
	  var ua = opts.ua
	  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
	  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
	    ua = ua.headers['user-agent']
	  }
	  if (typeof ua !== 'string') return false
	
	  var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua)
	
	  if (
	    !result &&
	    opts.tablet &&
	    opts.featureDetect &&
	    navigator &&
	    navigator.maxTouchPoints > 1 &&
	    ua.indexOf('Macintosh') !== -1 &&
	    ua.indexOf('Safari') !== -1
	  ) {
	    result = true
	  }
	
	  return result
	}


/***/ },
/* 2490 */
/***/ function(module, exports) {

	module.exports = [
		{
			"code": "1101",
			"name": "市辖区",
			"provinceCode": "11"
		},
		{
			"code": "1201",
			"name": "市辖区",
			"provinceCode": "12"
		},
		{
			"code": "1301",
			"name": "石家庄市",
			"provinceCode": "13"
		},
		{
			"code": "1302",
			"name": "唐山市",
			"provinceCode": "13"
		},
		{
			"code": "1303",
			"name": "秦皇岛市",
			"provinceCode": "13"
		},
		{
			"code": "1304",
			"name": "邯郸市",
			"provinceCode": "13"
		},
		{
			"code": "1305",
			"name": "邢台市",
			"provinceCode": "13"
		},
		{
			"code": "1306",
			"name": "保定市",
			"provinceCode": "13"
		},
		{
			"code": "1307",
			"name": "张家口市",
			"provinceCode": "13"
		},
		{
			"code": "1308",
			"name": "承德市",
			"provinceCode": "13"
		},
		{
			"code": "1309",
			"name": "沧州市",
			"provinceCode": "13"
		},
		{
			"code": "1310",
			"name": "廊坊市",
			"provinceCode": "13"
		},
		{
			"code": "1311",
			"name": "衡水市",
			"provinceCode": "13"
		},
		{
			"code": "1401",
			"name": "太原市",
			"provinceCode": "14"
		},
		{
			"code": "1402",
			"name": "大同市",
			"provinceCode": "14"
		},
		{
			"code": "1403",
			"name": "阳泉市",
			"provinceCode": "14"
		},
		{
			"code": "1404",
			"name": "长治市",
			"provinceCode": "14"
		},
		{
			"code": "1405",
			"name": "晋城市",
			"provinceCode": "14"
		},
		{
			"code": "1406",
			"name": "朔州市",
			"provinceCode": "14"
		},
		{
			"code": "1407",
			"name": "晋中市",
			"provinceCode": "14"
		},
		{
			"code": "1408",
			"name": "运城市",
			"provinceCode": "14"
		},
		{
			"code": "1409",
			"name": "忻州市",
			"provinceCode": "14"
		},
		{
			"code": "1410",
			"name": "临汾市",
			"provinceCode": "14"
		},
		{
			"code": "1411",
			"name": "吕梁市",
			"provinceCode": "14"
		},
		{
			"code": "1501",
			"name": "呼和浩特市",
			"provinceCode": "15"
		},
		{
			"code": "1502",
			"name": "包头市",
			"provinceCode": "15"
		},
		{
			"code": "1503",
			"name": "乌海市",
			"provinceCode": "15"
		},
		{
			"code": "1504",
			"name": "赤峰市",
			"provinceCode": "15"
		},
		{
			"code": "1505",
			"name": "通辽市",
			"provinceCode": "15"
		},
		{
			"code": "1506",
			"name": "鄂尔多斯市",
			"provinceCode": "15"
		},
		{
			"code": "1507",
			"name": "呼伦贝尔市",
			"provinceCode": "15"
		},
		{
			"code": "1508",
			"name": "巴彦淖尔市",
			"provinceCode": "15"
		},
		{
			"code": "1509",
			"name": "乌兰察布市",
			"provinceCode": "15"
		},
		{
			"code": "1522",
			"name": "兴安盟",
			"provinceCode": "15"
		},
		{
			"code": "1525",
			"name": "锡林郭勒盟",
			"provinceCode": "15"
		},
		{
			"code": "1529",
			"name": "阿拉善盟",
			"provinceCode": "15"
		},
		{
			"code": "2101",
			"name": "沈阳市",
			"provinceCode": "21"
		},
		{
			"code": "2102",
			"name": "大连市",
			"provinceCode": "21"
		},
		{
			"code": "2103",
			"name": "鞍山市",
			"provinceCode": "21"
		},
		{
			"code": "2104",
			"name": "抚顺市",
			"provinceCode": "21"
		},
		{
			"code": "2105",
			"name": "本溪市",
			"provinceCode": "21"
		},
		{
			"code": "2106",
			"name": "丹东市",
			"provinceCode": "21"
		},
		{
			"code": "2107",
			"name": "锦州市",
			"provinceCode": "21"
		},
		{
			"code": "2108",
			"name": "营口市",
			"provinceCode": "21"
		},
		{
			"code": "2109",
			"name": "阜新市",
			"provinceCode": "21"
		},
		{
			"code": "2110",
			"name": "辽阳市",
			"provinceCode": "21"
		},
		{
			"code": "2111",
			"name": "盘锦市",
			"provinceCode": "21"
		},
		{
			"code": "2112",
			"name": "铁岭市",
			"provinceCode": "21"
		},
		{
			"code": "2113",
			"name": "朝阳市",
			"provinceCode": "21"
		},
		{
			"code": "2114",
			"name": "葫芦岛市",
			"provinceCode": "21"
		},
		{
			"code": "2201",
			"name": "长春市",
			"provinceCode": "22"
		},
		{
			"code": "2202",
			"name": "吉林市",
			"provinceCode": "22"
		},
		{
			"code": "2203",
			"name": "四平市",
			"provinceCode": "22"
		},
		{
			"code": "2204",
			"name": "辽源市",
			"provinceCode": "22"
		},
		{
			"code": "2205",
			"name": "通化市",
			"provinceCode": "22"
		},
		{
			"code": "2206",
			"name": "白山市",
			"provinceCode": "22"
		},
		{
			"code": "2207",
			"name": "松原市",
			"provinceCode": "22"
		},
		{
			"code": "2208",
			"name": "白城市",
			"provinceCode": "22"
		},
		{
			"code": "2224",
			"name": "延边朝鲜族自治州",
			"provinceCode": "22"
		},
		{
			"code": "2301",
			"name": "哈尔滨市",
			"provinceCode": "23"
		},
		{
			"code": "2302",
			"name": "齐齐哈尔市",
			"provinceCode": "23"
		},
		{
			"code": "2303",
			"name": "鸡西市",
			"provinceCode": "23"
		},
		{
			"code": "2304",
			"name": "鹤岗市",
			"provinceCode": "23"
		},
		{
			"code": "2305",
			"name": "双鸭山市",
			"provinceCode": "23"
		},
		{
			"code": "2306",
			"name": "大庆市",
			"provinceCode": "23"
		},
		{
			"code": "2307",
			"name": "伊春市",
			"provinceCode": "23"
		},
		{
			"code": "2308",
			"name": "佳木斯市",
			"provinceCode": "23"
		},
		{
			"code": "2309",
			"name": "七台河市",
			"provinceCode": "23"
		},
		{
			"code": "2310",
			"name": "牡丹江市",
			"provinceCode": "23"
		},
		{
			"code": "2311",
			"name": "黑河市",
			"provinceCode": "23"
		},
		{
			"code": "2312",
			"name": "绥化市",
			"provinceCode": "23"
		},
		{
			"code": "2327",
			"name": "大兴安岭地区",
			"provinceCode": "23"
		},
		{
			"code": "3101",
			"name": "市辖区",
			"provinceCode": "31"
		},
		{
			"code": "3201",
			"name": "南京市",
			"provinceCode": "32"
		},
		{
			"code": "3202",
			"name": "无锡市",
			"provinceCode": "32"
		},
		{
			"code": "3203",
			"name": "徐州市",
			"provinceCode": "32"
		},
		{
			"code": "3204",
			"name": "常州市",
			"provinceCode": "32"
		},
		{
			"code": "3205",
			"name": "苏州市",
			"provinceCode": "32"
		},
		{
			"code": "3206",
			"name": "南通市",
			"provinceCode": "32"
		},
		{
			"code": "3207",
			"name": "连云港市",
			"provinceCode": "32"
		},
		{
			"code": "3208",
			"name": "淮安市",
			"provinceCode": "32"
		},
		{
			"code": "3209",
			"name": "盐城市",
			"provinceCode": "32"
		},
		{
			"code": "3210",
			"name": "扬州市",
			"provinceCode": "32"
		},
		{
			"code": "3211",
			"name": "镇江市",
			"provinceCode": "32"
		},
		{
			"code": "3212",
			"name": "泰州市",
			"provinceCode": "32"
		},
		{
			"code": "3213",
			"name": "宿迁市",
			"provinceCode": "32"
		},
		{
			"code": "3301",
			"name": "杭州市",
			"provinceCode": "33"
		},
		{
			"code": "3302",
			"name": "宁波市",
			"provinceCode": "33"
		},
		{
			"code": "3303",
			"name": "温州市",
			"provinceCode": "33"
		},
		{
			"code": "3304",
			"name": "嘉兴市",
			"provinceCode": "33"
		},
		{
			"code": "3305",
			"name": "湖州市",
			"provinceCode": "33"
		},
		{
			"code": "3306",
			"name": "绍兴市",
			"provinceCode": "33"
		},
		{
			"code": "3307",
			"name": "金华市",
			"provinceCode": "33"
		},
		{
			"code": "3308",
			"name": "衢州市",
			"provinceCode": "33"
		},
		{
			"code": "3309",
			"name": "舟山市",
			"provinceCode": "33"
		},
		{
			"code": "3310",
			"name": "台州市",
			"provinceCode": "33"
		},
		{
			"code": "3311",
			"name": "丽水市",
			"provinceCode": "33"
		},
		{
			"code": "3401",
			"name": "合肥市",
			"provinceCode": "34"
		},
		{
			"code": "3402",
			"name": "芜湖市",
			"provinceCode": "34"
		},
		{
			"code": "3403",
			"name": "蚌埠市",
			"provinceCode": "34"
		},
		{
			"code": "3404",
			"name": "淮南市",
			"provinceCode": "34"
		},
		{
			"code": "3405",
			"name": "马鞍山市",
			"provinceCode": "34"
		},
		{
			"code": "3406",
			"name": "淮北市",
			"provinceCode": "34"
		},
		{
			"code": "3407",
			"name": "铜陵市",
			"provinceCode": "34"
		},
		{
			"code": "3408",
			"name": "安庆市",
			"provinceCode": "34"
		},
		{
			"code": "3410",
			"name": "黄山市",
			"provinceCode": "34"
		},
		{
			"code": "3411",
			"name": "滁州市",
			"provinceCode": "34"
		},
		{
			"code": "3412",
			"name": "阜阳市",
			"provinceCode": "34"
		},
		{
			"code": "3413",
			"name": "宿州市",
			"provinceCode": "34"
		},
		{
			"code": "3415",
			"name": "六安市",
			"provinceCode": "34"
		},
		{
			"code": "3416",
			"name": "亳州市",
			"provinceCode": "34"
		},
		{
			"code": "3417",
			"name": "池州市",
			"provinceCode": "34"
		},
		{
			"code": "3418",
			"name": "宣城市",
			"provinceCode": "34"
		},
		{
			"code": "3501",
			"name": "福州市",
			"provinceCode": "35"
		},
		{
			"code": "3502",
			"name": "厦门市",
			"provinceCode": "35"
		},
		{
			"code": "3503",
			"name": "莆田市",
			"provinceCode": "35"
		},
		{
			"code": "3504",
			"name": "三明市",
			"provinceCode": "35"
		},
		{
			"code": "3505",
			"name": "泉州市",
			"provinceCode": "35"
		},
		{
			"code": "3506",
			"name": "漳州市",
			"provinceCode": "35"
		},
		{
			"code": "3507",
			"name": "南平市",
			"provinceCode": "35"
		},
		{
			"code": "3508",
			"name": "龙岩市",
			"provinceCode": "35"
		},
		{
			"code": "3509",
			"name": "宁德市",
			"provinceCode": "35"
		},
		{
			"code": "3601",
			"name": "南昌市",
			"provinceCode": "36"
		},
		{
			"code": "3602",
			"name": "景德镇市",
			"provinceCode": "36"
		},
		{
			"code": "3603",
			"name": "萍乡市",
			"provinceCode": "36"
		},
		{
			"code": "3604",
			"name": "九江市",
			"provinceCode": "36"
		},
		{
			"code": "3605",
			"name": "新余市",
			"provinceCode": "36"
		},
		{
			"code": "3606",
			"name": "鹰潭市",
			"provinceCode": "36"
		},
		{
			"code": "3607",
			"name": "赣州市",
			"provinceCode": "36"
		},
		{
			"code": "3608",
			"name": "吉安市",
			"provinceCode": "36"
		},
		{
			"code": "3609",
			"name": "宜春市",
			"provinceCode": "36"
		},
		{
			"code": "3610",
			"name": "抚州市",
			"provinceCode": "36"
		},
		{
			"code": "3611",
			"name": "上饶市",
			"provinceCode": "36"
		},
		{
			"code": "3701",
			"name": "济南市",
			"provinceCode": "37"
		},
		{
			"code": "3702",
			"name": "青岛市",
			"provinceCode": "37"
		},
		{
			"code": "3703",
			"name": "淄博市",
			"provinceCode": "37"
		},
		{
			"code": "3704",
			"name": "枣庄市",
			"provinceCode": "37"
		},
		{
			"code": "3705",
			"name": "东营市",
			"provinceCode": "37"
		},
		{
			"code": "3706",
			"name": "烟台市",
			"provinceCode": "37"
		},
		{
			"code": "3707",
			"name": "潍坊市",
			"provinceCode": "37"
		},
		{
			"code": "3708",
			"name": "济宁市",
			"provinceCode": "37"
		},
		{
			"code": "3709",
			"name": "泰安市",
			"provinceCode": "37"
		},
		{
			"code": "3710",
			"name": "威海市",
			"provinceCode": "37"
		},
		{
			"code": "3711",
			"name": "日照市",
			"provinceCode": "37"
		},
		{
			"code": "3713",
			"name": "临沂市",
			"provinceCode": "37"
		},
		{
			"code": "3714",
			"name": "德州市",
			"provinceCode": "37"
		},
		{
			"code": "3715",
			"name": "聊城市",
			"provinceCode": "37"
		},
		{
			"code": "3716",
			"name": "滨州市",
			"provinceCode": "37"
		},
		{
			"code": "3717",
			"name": "菏泽市",
			"provinceCode": "37"
		},
		{
			"code": "4101",
			"name": "郑州市",
			"provinceCode": "41"
		},
		{
			"code": "4102",
			"name": "开封市",
			"provinceCode": "41"
		},
		{
			"code": "4103",
			"name": "洛阳市",
			"provinceCode": "41"
		},
		{
			"code": "4104",
			"name": "平顶山市",
			"provinceCode": "41"
		},
		{
			"code": "4105",
			"name": "安阳市",
			"provinceCode": "41"
		},
		{
			"code": "4106",
			"name": "鹤壁市",
			"provinceCode": "41"
		},
		{
			"code": "4107",
			"name": "新乡市",
			"provinceCode": "41"
		},
		{
			"code": "4108",
			"name": "焦作市",
			"provinceCode": "41"
		},
		{
			"code": "4109",
			"name": "濮阳市",
			"provinceCode": "41"
		},
		{
			"code": "4110",
			"name": "许昌市",
			"provinceCode": "41"
		},
		{
			"code": "4111",
			"name": "漯河市",
			"provinceCode": "41"
		},
		{
			"code": "4112",
			"name": "三门峡市",
			"provinceCode": "41"
		},
		{
			"code": "4113",
			"name": "南阳市",
			"provinceCode": "41"
		},
		{
			"code": "4114",
			"name": "商丘市",
			"provinceCode": "41"
		},
		{
			"code": "4115",
			"name": "信阳市",
			"provinceCode": "41"
		},
		{
			"code": "4116",
			"name": "周口市",
			"provinceCode": "41"
		},
		{
			"code": "4117",
			"name": "驻马店市",
			"provinceCode": "41"
		},
		{
			"code": "4190",
			"name": "省直辖县级行政区划",
			"provinceCode": "41"
		},
		{
			"code": "4201",
			"name": "武汉市",
			"provinceCode": "42"
		},
		{
			"code": "4202",
			"name": "黄石市",
			"provinceCode": "42"
		},
		{
			"code": "4203",
			"name": "十堰市",
			"provinceCode": "42"
		},
		{
			"code": "4205",
			"name": "宜昌市",
			"provinceCode": "42"
		},
		{
			"code": "4206",
			"name": "襄阳市",
			"provinceCode": "42"
		},
		{
			"code": "4207",
			"name": "鄂州市",
			"provinceCode": "42"
		},
		{
			"code": "4208",
			"name": "荆门市",
			"provinceCode": "42"
		},
		{
			"code": "4209",
			"name": "孝感市",
			"provinceCode": "42"
		},
		{
			"code": "4210",
			"name": "荆州市",
			"provinceCode": "42"
		},
		{
			"code": "4211",
			"name": "黄冈市",
			"provinceCode": "42"
		},
		{
			"code": "4212",
			"name": "咸宁市",
			"provinceCode": "42"
		},
		{
			"code": "4213",
			"name": "随州市",
			"provinceCode": "42"
		},
		{
			"code": "4228",
			"name": "恩施土家族苗族自治州",
			"provinceCode": "42"
		},
		{
			"code": "4290",
			"name": "省直辖县级行政区划",
			"provinceCode": "42"
		},
		{
			"code": "4301",
			"name": "长沙市",
			"provinceCode": "43"
		},
		{
			"code": "4302",
			"name": "株洲市",
			"provinceCode": "43"
		},
		{
			"code": "4303",
			"name": "湘潭市",
			"provinceCode": "43"
		},
		{
			"code": "4304",
			"name": "衡阳市",
			"provinceCode": "43"
		},
		{
			"code": "4305",
			"name": "邵阳市",
			"provinceCode": "43"
		},
		{
			"code": "4306",
			"name": "岳阳市",
			"provinceCode": "43"
		},
		{
			"code": "4307",
			"name": "常德市",
			"provinceCode": "43"
		},
		{
			"code": "4308",
			"name": "张家界市",
			"provinceCode": "43"
		},
		{
			"code": "4309",
			"name": "益阳市",
			"provinceCode": "43"
		},
		{
			"code": "4310",
			"name": "郴州市",
			"provinceCode": "43"
		},
		{
			"code": "4311",
			"name": "永州市",
			"provinceCode": "43"
		},
		{
			"code": "4312",
			"name": "怀化市",
			"provinceCode": "43"
		},
		{
			"code": "4313",
			"name": "娄底市",
			"provinceCode": "43"
		},
		{
			"code": "4331",
			"name": "湘西土家族苗族自治州",
			"provinceCode": "43"
		},
		{
			"code": "4401",
			"name": "广州市",
			"provinceCode": "44"
		},
		{
			"code": "4402",
			"name": "韶关市",
			"provinceCode": "44"
		},
		{
			"code": "4403",
			"name": "深圳市",
			"provinceCode": "44"
		},
		{
			"code": "4404",
			"name": "珠海市",
			"provinceCode": "44"
		},
		{
			"code": "4405",
			"name": "汕头市",
			"provinceCode": "44"
		},
		{
			"code": "4406",
			"name": "佛山市",
			"provinceCode": "44"
		},
		{
			"code": "4407",
			"name": "江门市",
			"provinceCode": "44"
		},
		{
			"code": "4408",
			"name": "湛江市",
			"provinceCode": "44"
		},
		{
			"code": "4409",
			"name": "茂名市",
			"provinceCode": "44"
		},
		{
			"code": "4412",
			"name": "肇庆市",
			"provinceCode": "44"
		},
		{
			"code": "4413",
			"name": "惠州市",
			"provinceCode": "44"
		},
		{
			"code": "4414",
			"name": "梅州市",
			"provinceCode": "44"
		},
		{
			"code": "4415",
			"name": "汕尾市",
			"provinceCode": "44"
		},
		{
			"code": "4416",
			"name": "河源市",
			"provinceCode": "44"
		},
		{
			"code": "4417",
			"name": "阳江市",
			"provinceCode": "44"
		},
		{
			"code": "4418",
			"name": "清远市",
			"provinceCode": "44"
		},
		{
			"code": "4419",
			"name": "东莞市",
			"provinceCode": "44"
		},
		{
			"code": "4420",
			"name": "中山市",
			"provinceCode": "44"
		},
		{
			"code": "4451",
			"name": "潮州市",
			"provinceCode": "44"
		},
		{
			"code": "4452",
			"name": "揭阳市",
			"provinceCode": "44"
		},
		{
			"code": "4453",
			"name": "云浮市",
			"provinceCode": "44"
		},
		{
			"code": "4501",
			"name": "南宁市",
			"provinceCode": "45"
		},
		{
			"code": "4502",
			"name": "柳州市",
			"provinceCode": "45"
		},
		{
			"code": "4503",
			"name": "桂林市",
			"provinceCode": "45"
		},
		{
			"code": "4504",
			"name": "梧州市",
			"provinceCode": "45"
		},
		{
			"code": "4505",
			"name": "北海市",
			"provinceCode": "45"
		},
		{
			"code": "4506",
			"name": "防城港市",
			"provinceCode": "45"
		},
		{
			"code": "4507",
			"name": "钦州市",
			"provinceCode": "45"
		},
		{
			"code": "4508",
			"name": "贵港市",
			"provinceCode": "45"
		},
		{
			"code": "4509",
			"name": "玉林市",
			"provinceCode": "45"
		},
		{
			"code": "4510",
			"name": "百色市",
			"provinceCode": "45"
		},
		{
			"code": "4511",
			"name": "贺州市",
			"provinceCode": "45"
		},
		{
			"code": "4512",
			"name": "河池市",
			"provinceCode": "45"
		},
		{
			"code": "4513",
			"name": "来宾市",
			"provinceCode": "45"
		},
		{
			"code": "4514",
			"name": "崇左市",
			"provinceCode": "45"
		},
		{
			"code": "4601",
			"name": "海口市",
			"provinceCode": "46"
		},
		{
			"code": "4602",
			"name": "三亚市",
			"provinceCode": "46"
		},
		{
			"code": "4603",
			"name": "三沙市",
			"provinceCode": "46"
		},
		{
			"code": "4604",
			"name": "儋州市",
			"provinceCode": "46"
		},
		{
			"code": "4690",
			"name": "省直辖县级行政区划",
			"provinceCode": "46"
		},
		{
			"code": "5001",
			"name": "市辖区",
			"provinceCode": "50"
		},
		{
			"code": "5002",
			"name": "县",
			"provinceCode": "50"
		},
		{
			"code": "5101",
			"name": "成都市",
			"provinceCode": "51"
		},
		{
			"code": "5103",
			"name": "自贡市",
			"provinceCode": "51"
		},
		{
			"code": "5104",
			"name": "攀枝花市",
			"provinceCode": "51"
		},
		{
			"code": "5105",
			"name": "泸州市",
			"provinceCode": "51"
		},
		{
			"code": "5106",
			"name": "德阳市",
			"provinceCode": "51"
		},
		{
			"code": "5107",
			"name": "绵阳市",
			"provinceCode": "51"
		},
		{
			"code": "5108",
			"name": "广元市",
			"provinceCode": "51"
		},
		{
			"code": "5109",
			"name": "遂宁市",
			"provinceCode": "51"
		},
		{
			"code": "5110",
			"name": "内江市",
			"provinceCode": "51"
		},
		{
			"code": "5111",
			"name": "乐山市",
			"provinceCode": "51"
		},
		{
			"code": "5113",
			"name": "南充市",
			"provinceCode": "51"
		},
		{
			"code": "5114",
			"name": "眉山市",
			"provinceCode": "51"
		},
		{
			"code": "5115",
			"name": "宜宾市",
			"provinceCode": "51"
		},
		{
			"code": "5116",
			"name": "广安市",
			"provinceCode": "51"
		},
		{
			"code": "5117",
			"name": "达州市",
			"provinceCode": "51"
		},
		{
			"code": "5118",
			"name": "雅安市",
			"provinceCode": "51"
		},
		{
			"code": "5119",
			"name": "巴中市",
			"provinceCode": "51"
		},
		{
			"code": "5120",
			"name": "资阳市",
			"provinceCode": "51"
		},
		{
			"code": "5132",
			"name": "阿坝藏族羌族自治州",
			"provinceCode": "51"
		},
		{
			"code": "5133",
			"name": "甘孜藏族自治州",
			"provinceCode": "51"
		},
		{
			"code": "5134",
			"name": "凉山彝族自治州",
			"provinceCode": "51"
		},
		{
			"code": "5201",
			"name": "贵阳市",
			"provinceCode": "52"
		},
		{
			"code": "5202",
			"name": "六盘水市",
			"provinceCode": "52"
		},
		{
			"code": "5203",
			"name": "遵义市",
			"provinceCode": "52"
		},
		{
			"code": "5204",
			"name": "安顺市",
			"provinceCode": "52"
		},
		{
			"code": "5205",
			"name": "毕节市",
			"provinceCode": "52"
		},
		{
			"code": "5206",
			"name": "铜仁市",
			"provinceCode": "52"
		},
		{
			"code": "5223",
			"name": "黔西南布依族苗族自治州",
			"provinceCode": "52"
		},
		{
			"code": "5226",
			"name": "黔东南苗族侗族自治州",
			"provinceCode": "52"
		},
		{
			"code": "5227",
			"name": "黔南布依族苗族自治州",
			"provinceCode": "52"
		},
		{
			"code": "5301",
			"name": "昆明市",
			"provinceCode": "53"
		},
		{
			"code": "5303",
			"name": "曲靖市",
			"provinceCode": "53"
		},
		{
			"code": "5304",
			"name": "玉溪市",
			"provinceCode": "53"
		},
		{
			"code": "5305",
			"name": "保山市",
			"provinceCode": "53"
		},
		{
			"code": "5306",
			"name": "昭通市",
			"provinceCode": "53"
		},
		{
			"code": "5307",
			"name": "丽江市",
			"provinceCode": "53"
		},
		{
			"code": "5308",
			"name": "普洱市",
			"provinceCode": "53"
		},
		{
			"code": "5309",
			"name": "临沧市",
			"provinceCode": "53"
		},
		{
			"code": "5323",
			"name": "楚雄彝族自治州",
			"provinceCode": "53"
		},
		{
			"code": "5325",
			"name": "红河哈尼族彝族自治州",
			"provinceCode": "53"
		},
		{
			"code": "5326",
			"name": "文山壮族苗族自治州",
			"provinceCode": "53"
		},
		{
			"code": "5328",
			"name": "西双版纳傣族自治州",
			"provinceCode": "53"
		},
		{
			"code": "5329",
			"name": "大理白族自治州",
			"provinceCode": "53"
		},
		{
			"code": "5331",
			"name": "德宏傣族景颇族自治州",
			"provinceCode": "53"
		},
		{
			"code": "5333",
			"name": "怒江傈僳族自治州",
			"provinceCode": "53"
		},
		{
			"code": "5334",
			"name": "迪庆藏族自治州",
			"provinceCode": "53"
		},
		{
			"code": "5401",
			"name": "拉萨市",
			"provinceCode": "54"
		},
		{
			"code": "5402",
			"name": "日喀则市",
			"provinceCode": "54"
		},
		{
			"code": "5403",
			"name": "昌都市",
			"provinceCode": "54"
		},
		{
			"code": "5404",
			"name": "林芝市",
			"provinceCode": "54"
		},
		{
			"code": "5405",
			"name": "山南市",
			"provinceCode": "54"
		},
		{
			"code": "5406",
			"name": "那曲市",
			"provinceCode": "54"
		},
		{
			"code": "5425",
			"name": "阿里地区",
			"provinceCode": "54"
		},
		{
			"code": "6101",
			"name": "西安市",
			"provinceCode": "61"
		},
		{
			"code": "6102",
			"name": "铜川市",
			"provinceCode": "61"
		},
		{
			"code": "6103",
			"name": "宝鸡市",
			"provinceCode": "61"
		},
		{
			"code": "6104",
			"name": "咸阳市",
			"provinceCode": "61"
		},
		{
			"code": "6105",
			"name": "渭南市",
			"provinceCode": "61"
		},
		{
			"code": "6106",
			"name": "延安市",
			"provinceCode": "61"
		},
		{
			"code": "6107",
			"name": "汉中市",
			"provinceCode": "61"
		},
		{
			"code": "6108",
			"name": "榆林市",
			"provinceCode": "61"
		},
		{
			"code": "6109",
			"name": "安康市",
			"provinceCode": "61"
		},
		{
			"code": "6110",
			"name": "商洛市",
			"provinceCode": "61"
		},
		{
			"code": "6201",
			"name": "兰州市",
			"provinceCode": "62"
		},
		{
			"code": "6202",
			"name": "嘉峪关市",
			"provinceCode": "62"
		},
		{
			"code": "6203",
			"name": "金昌市",
			"provinceCode": "62"
		},
		{
			"code": "6204",
			"name": "白银市",
			"provinceCode": "62"
		},
		{
			"code": "6205",
			"name": "天水市",
			"provinceCode": "62"
		},
		{
			"code": "6206",
			"name": "武威市",
			"provinceCode": "62"
		},
		{
			"code": "6207",
			"name": "张掖市",
			"provinceCode": "62"
		},
		{
			"code": "6208",
			"name": "平凉市",
			"provinceCode": "62"
		},
		{
			"code": "6209",
			"name": "酒泉市",
			"provinceCode": "62"
		},
		{
			"code": "6210",
			"name": "庆阳市",
			"provinceCode": "62"
		},
		{
			"code": "6211",
			"name": "定西市",
			"provinceCode": "62"
		},
		{
			"code": "6212",
			"name": "陇南市",
			"provinceCode": "62"
		},
		{
			"code": "6229",
			"name": "临夏回族自治州",
			"provinceCode": "62"
		},
		{
			"code": "6230",
			"name": "甘南藏族自治州",
			"provinceCode": "62"
		},
		{
			"code": "6301",
			"name": "西宁市",
			"provinceCode": "63"
		},
		{
			"code": "6302",
			"name": "海东市",
			"provinceCode": "63"
		},
		{
			"code": "6322",
			"name": "海北藏族自治州",
			"provinceCode": "63"
		},
		{
			"code": "6323",
			"name": "黄南藏族自治州",
			"provinceCode": "63"
		},
		{
			"code": "6325",
			"name": "海南藏族自治州",
			"provinceCode": "63"
		},
		{
			"code": "6326",
			"name": "果洛藏族自治州",
			"provinceCode": "63"
		},
		{
			"code": "6327",
			"name": "玉树藏族自治州",
			"provinceCode": "63"
		},
		{
			"code": "6328",
			"name": "海西蒙古族藏族自治州",
			"provinceCode": "63"
		},
		{
			"code": "6401",
			"name": "银川市",
			"provinceCode": "64"
		},
		{
			"code": "6402",
			"name": "石嘴山市",
			"provinceCode": "64"
		},
		{
			"code": "6403",
			"name": "吴忠市",
			"provinceCode": "64"
		},
		{
			"code": "6404",
			"name": "固原市",
			"provinceCode": "64"
		},
		{
			"code": "6405",
			"name": "中卫市",
			"provinceCode": "64"
		},
		{
			"code": "6501",
			"name": "乌鲁木齐市",
			"provinceCode": "65"
		},
		{
			"code": "6502",
			"name": "克拉玛依市",
			"provinceCode": "65"
		},
		{
			"code": "6504",
			"name": "吐鲁番市",
			"provinceCode": "65"
		},
		{
			"code": "6505",
			"name": "哈密市",
			"provinceCode": "65"
		},
		{
			"code": "6523",
			"name": "昌吉回族自治州",
			"provinceCode": "65"
		},
		{
			"code": "6527",
			"name": "博尔塔拉蒙古自治州",
			"provinceCode": "65"
		},
		{
			"code": "6528",
			"name": "巴音郭楞蒙古自治州",
			"provinceCode": "65"
		},
		{
			"code": "6529",
			"name": "阿克苏地区",
			"provinceCode": "65"
		},
		{
			"code": "6530",
			"name": "克孜勒苏柯尔克孜自治州",
			"provinceCode": "65"
		},
		{
			"code": "6531",
			"name": "喀什地区",
			"provinceCode": "65"
		},
		{
			"code": "6532",
			"name": "和田地区",
			"provinceCode": "65"
		},
		{
			"code": "6540",
			"name": "伊犁哈萨克自治州",
			"provinceCode": "65"
		},
		{
			"code": "6542",
			"name": "塔城地区",
			"provinceCode": "65"
		},
		{
			"code": "6543",
			"name": "阿勒泰地区",
			"provinceCode": "65"
		},
		{
			"code": "6590",
			"name": "自治区直辖县级行政区划",
			"provinceCode": "65"
		}
	];

/***/ },
/* 2491 */
/***/ function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(2940);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ },
/* 2492 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256,
	    FLIP_FLAG = 512;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', ARY_FLAG],
	  ['bind', BIND_FLAG],
	  ['bindKey', BIND_KEY_FLAG],
	  ['curry', CURRY_FLAG],
	  ['curryRight', CURRY_RIGHT_FLAG],
	  ['flip', FLIP_FLAG],
	  ['partial', PARTIAL_FLAG],
	  ['partialRight', PARTIAL_RIGHT_FLAG],
	  ['rearg', REARG_FLAG]
	];
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      result++;
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/* Used to set `toString` methods. */
	var defineProperty = (function() {
	  var func = getNative(Object, 'defineProperty'),
	      name = getNative.name;
	
	  return (name && name.length > 2) ? func : undefined;
	}());
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	      isFlip = bitmask & FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	  if (!(bitmask & CURRY_BOUND_FLAG)) {
	    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	  }
	
	  var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 *   512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] == null
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  return setWrapToString(result, func, bitmask);
	}
	
	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length,
	      lastIndex = length - 1;
	
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return defineProperty(wrapper, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
	  });
	};
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	/**
	 * Creates a function that accepts arguments of `func` and either invokes
	 * `func` returning its result, if at least `arity` number of arguments have
	 * been provided, or returns a function that accepts the remaining `func`
	 * arguments, and so on. The arity of `func` may be specified if `func.length`
	 * is not sufficient.
	 *
	 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for provided arguments.
	 *
	 * **Note:** This method doesn't set the "length" property of curried functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Function
	 * @param {Function} func The function to curry.
	 * @param {number} [arity=func.length] The arity of `func`.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {Function} Returns the new curried function.
	 * @example
	 *
	 * var abc = function(a, b, c) {
	 *   return [a, b, c];
	 * };
	 *
	 * var curried = _.curry(abc);
	 *
	 * curried(1)(2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2)(3);
	 * // => [1, 2, 3]
	 *
	 * curried(1, 2, 3);
	 * // => [1, 2, 3]
	 *
	 * // Curried with placeholders.
	 * curried(1)(_, 3)(2);
	 * // => [1, 2, 3]
	 */
	function curry(func, arity, guard) {
	  arity = guard ? undefined : arity;
	  var result = createWrap(func, CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	  result.placeholder = curry.placeholder;
	  return result;
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	// Assign default placeholders.
	curry.placeholder = {};
	
	module.exports = curry;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2493 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates a `_.flow` or `_.flowRight` function.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new flow function.
	 */
	function createFlow(fromRight) {
	  return baseRest(function(funcs) {
	    funcs = baseFlatten(funcs, 1);
	
	    var length = funcs.length,
	        index = length;
	
	    if (fromRight) {
	      funcs.reverse();
	    }
	    while (index--) {
	      if (typeof funcs[index] != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	    }
	    return function() {
	      var index = 0,
	          result = length ? funcs[index].apply(this, arguments) : arguments[0];
	
	      while (++index < length) {
	        result = funcs[index].call(this, result);
	      }
	      return result;
	    };
	  });
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates a function that returns the result of invoking the given functions
	 * with the `this` binding of the created function, where each successive
	 * invocation is supplied the return value of the previous.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Util
	 * @param {...(Function|Function[])} [funcs] The functions to invoke.
	 * @returns {Function} Returns the new composite function.
	 * @see _.flowRight
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * var addSquare = _.flow([_.add, square]);
	 * addSquare(1, 2);
	 * // => 9
	 */
	var flow = createFlow();
	
	module.exports = flow;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2494 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2495 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(218),
	    root = __webpack_require__(124);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 2496 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(2547),
	    hashDelete = __webpack_require__(2548),
	    hashGet = __webpack_require__(2549),
	    hashHas = __webpack_require__(2550),
	    hashSet = __webpack_require__(2551);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 2497 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(218),
	    root = __webpack_require__(124);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 2498 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(218),
	    root = __webpack_require__(124);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 2499 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 2500 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 2501 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 2502 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(908);
	
	/**
	 * Gets the size of an ASCII `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	var asciiSize = baseProperty('length');
	
	module.exports = asciiSize;


/***/ },
/* 2503 */
/***/ function(module, exports) {

	/**
	 * Converts an ASCII `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function asciiToArray(string) {
	  return string.split('');
	}
	
	module.exports = asciiToArray;


/***/ },
/* 2504 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(126);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 2505 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(532),
	    arrayIncludes = __webpack_require__(897),
	    arrayIncludesWith = __webpack_require__(898),
	    arrayMap = __webpack_require__(534),
	    baseUnary = __webpack_require__(910),
	    cacheHas = __webpack_require__(537);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * The base implementation of methods like `_.difference` without support
	 * for excluding multiple arrays or iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Array} values The values to exclude.
	 * @param {Function} [iteratee] The iteratee invoked per element.
	 * @param {Function} [comparator] The comparator invoked per element.
	 * @returns {Array} Returns the new array of filtered values.
	 */
	function baseDifference(array, values, iteratee, comparator) {
	  var index = -1,
	      includes = arrayIncludes,
	      isCommon = true,
	      length = array.length,
	      result = [],
	      valuesLength = values.length;
	
	  if (!length) {
	    return result;
	  }
	  if (iteratee) {
	    values = arrayMap(values, baseUnary(iteratee));
	  }
	  if (comparator) {
	    includes = arrayIncludesWith;
	    isCommon = false;
	  }
	  else if (values.length >= LARGE_ARRAY_SIZE) {
	    includes = cacheHas;
	    isCommon = false;
	    values = new SetCache(values);
	  }
	  outer:
	  while (++index < length) {
	    var value = array[index],
	        computed = iteratee == null ? value : iteratee(value);
	
	    value = (comparator || value !== 0) ? value : 0;
	    if (isCommon && computed === computed) {
	      var valuesIndex = valuesLength;
	      while (valuesIndex--) {
	        if (values[valuesIndex] === computed) {
	          continue outer;
	        }
	      }
	      result.push(value);
	    }
	    else if (!includes(values, computed, comparator)) {
	      result.push(value);
	    }
	  }
	  return result;
	}
	
	module.exports = baseDifference;


/***/ },
/* 2506 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(905),
	    keys = __webpack_require__(381);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 2507 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(900),
	    isArray = __webpack_require__(125);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 2508 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ },
/* 2509 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 2510 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(903),
	    baseIsNaN = __webpack_require__(2514),
	    strictIndexOf = __webpack_require__(2583);
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  return value === value
	    ? strictIndexOf(array, value, fromIndex)
	    : baseFindIndex(array, baseIsNaN, fromIndex);
	}
	
	module.exports = baseIndexOf;


/***/ },
/* 2511 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(217),
	    isObjectLike = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 2512 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(533),
	    equalArrays = __webpack_require__(915),
	    equalByTag = __webpack_require__(2540),
	    equalObjects = __webpack_require__(2541),
	    getTag = __webpack_require__(918),
	    isArray = __webpack_require__(125),
	    isBuffer = __webpack_require__(545),
	    isTypedArray = __webpack_require__(548);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 2513 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(533),
	    baseIsEqual = __webpack_require__(907);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 2514 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	module.exports = baseIsNaN;


/***/ },
/* 2515 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(546),
	    isMasked = __webpack_require__(2556),
	    isObject = __webpack_require__(126),
	    toSource = __webpack_require__(926);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 2516 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(217),
	    isLength = __webpack_require__(547),
	    isObjectLike = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 2517 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(541),
	    nativeKeys = __webpack_require__(2569);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 2518 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(126),
	    isPrototype = __webpack_require__(541),
	    nativeKeysIn = __webpack_require__(2570);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 2519 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(2513),
	    getMatchData = __webpack_require__(2543),
	    matchesStrictComparable = __webpack_require__(922);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 2520 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(907),
	    get = __webpack_require__(543),
	    hasIn = __webpack_require__(2592),
	    isKey = __webpack_require__(540),
	    isStrictComparable = __webpack_require__(920),
	    matchesStrictComparable = __webpack_require__(922),
	    toKey = __webpack_require__(299);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 2521 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(533),
	    assignMergeValue = __webpack_require__(901),
	    baseFor = __webpack_require__(905),
	    baseMergeDeep = __webpack_require__(2522),
	    isObject = __webpack_require__(126),
	    keysIn = __webpack_require__(927),
	    safeGet = __webpack_require__(924);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    stack || (stack = new Stack);
	    if (isObject(srcValue)) {
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 2522 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(901),
	    cloneBuffer = __webpack_require__(2533),
	    cloneTypedArray = __webpack_require__(2534),
	    copyArray = __webpack_require__(912),
	    initCloneObject = __webpack_require__(2552),
	    isArguments = __webpack_require__(378),
	    isArray = __webpack_require__(125),
	    isArrayLikeObject = __webpack_require__(544),
	    isBuffer = __webpack_require__(545),
	    isFunction = __webpack_require__(546),
	    isObject = __webpack_require__(126),
	    isPlainObject = __webpack_require__(379),
	    isTypedArray = __webpack_require__(548),
	    safeGet = __webpack_require__(924),
	    toPlainObject = __webpack_require__(2606);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = safeGet(object, key),
	      srcValue = safeGet(source, key),
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || isFunction(objValue)) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 2523 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(906);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 2524 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor;
	
	/**
	 * The base implementation of `_.repeat` which doesn't coerce arguments.
	 *
	 * @private
	 * @param {string} string The string to repeat.
	 * @param {number} n The number of times to repeat the string.
	 * @returns {string} Returns the repeated string.
	 */
	function baseRepeat(string, n) {
	  var result = '';
	  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	    return result;
	  }
	  // Leverage the exponentiation by squaring algorithm for a faster repeat.
	  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	  do {
	    if (n % 2) {
	      result += string;
	    }
	    n = nativeFloor(n / 2);
	    if (n) {
	      string += string;
	    }
	  } while (n);
	
	  return result;
	}
	
	module.exports = baseRepeat;


/***/ },
/* 2525 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(902),
	    castPath = __webpack_require__(538),
	    isIndex = __webpack_require__(374),
	    isObject = __webpack_require__(126),
	    toKey = __webpack_require__(299);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
	      return object;
	    }
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 2526 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(2588),
	    defineProperty = __webpack_require__(914),
	    identity = __webpack_require__(377);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 2527 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 2528 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 2529 */
/***/ function(module, exports, __webpack_require__) {

	var trimmedEndIndex = __webpack_require__(2585);
	
	/** Used to match leading whitespace. */
	var reTrimStart = /^\s+/;
	
	/**
	 * The base implementation of `_.trim`.
	 *
	 * @private
	 * @param {string} string The string to trim.
	 * @returns {string} Returns the trimmed string.
	 */
	function baseTrim(string) {
	  return string
	    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
	    : string;
	}
	
	module.exports = baseTrim;


/***/ },
/* 2530 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(534);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 2531 */
/***/ function(module, exports, __webpack_require__) {

	var baseSlice = __webpack_require__(2527);
	
	/**
	 * Casts `array` to a slice if it's needed.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {number} start The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the cast slice.
	 */
	function castSlice(array, start, end) {
	  var length = array.length;
	  end = end === undefined ? length : end;
	  return (!start && end >= length) ? array : baseSlice(array, start, end);
	}
	
	module.exports = castSlice;


/***/ },
/* 2532 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(896);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 2533 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(124);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)(module)))

/***/ },
/* 2534 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(2532);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 2535 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(902),
	    baseAssignValue = __webpack_require__(372);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 2536 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(124);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 2537 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(536),
	    isIterateeCall = __webpack_require__(2554);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 2538 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 2539 */
/***/ function(module, exports, __webpack_require__) {

	var Set = __webpack_require__(895),
	    noop = __webpack_require__(2597),
	    setToArray = __webpack_require__(376);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Creates a set object of `values`.
	 *
	 * @private
	 * @param {Array} values The values to add to the set.
	 * @returns {Object} Returns the new set.
	 */
	var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	  return new Set(values);
	};
	
	module.exports = createSet;


/***/ },
/* 2540 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(255),
	    Uint8Array = __webpack_require__(896),
	    eq = __webpack_require__(256),
	    equalArrays = __webpack_require__(915),
	    mapToArray = __webpack_require__(921),
	    setToArray = __webpack_require__(376);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 2541 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(2542);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Check that cyclic values are equal.
	  var objStacked = stack.get(object);
	  var othStacked = stack.get(other);
	  if (objStacked && othStacked) {
	    return objStacked == other && othStacked == object;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 2542 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(2507),
	    getSymbols = __webpack_require__(2545),
	    keys = __webpack_require__(381);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 2543 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(920),
	    keys = __webpack_require__(381);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 2544 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(255);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 2545 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(2500),
	    stubArray = __webpack_require__(2602);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 2546 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 2547 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(375);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 2548 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 2549 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(375);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 2550 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(375);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 2551 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(375);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 2552 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(2504),
	    getPrototype = __webpack_require__(917),
	    isPrototype = __webpack_require__(541);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 2553 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(255),
	    isArguments = __webpack_require__(378),
	    isArray = __webpack_require__(125);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 2554 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(256),
	    isArrayLike = __webpack_require__(301),
	    isIndex = __webpack_require__(374),
	    isObject = __webpack_require__(126);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 2555 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 2556 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(2536);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 2557 */
/***/ function(module, exports) {

	/**
	 * Converts `iterator` to an array.
	 *
	 * @private
	 * @param {Object} iterator The iterator to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function iteratorToArray(iterator) {
	  var data,
	      result = [];
	
	  while (!(data = iterator.next()).done) {
	    result.push(data.value);
	  }
	  return result;
	}
	
	module.exports = iteratorToArray;


/***/ },
/* 2558 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 2559 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(371);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 2560 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(371);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 2561 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(371);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 2562 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(371);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 2563 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(2496),
	    ListCache = __webpack_require__(370),
	    Map = __webpack_require__(530);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 2564 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(373);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 2565 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(373);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 2566 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(373);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 2567 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(373);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 2568 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(2595);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 2569 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(923);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 2570 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 2571 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(916);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    // Use `util.types` for Node.js 10+.
	    var types = freeModule && freeModule.require && freeModule.require('util').types;
	
	    if (types) {
	      return types;
	    }
	
	    // Legacy `process.binding('util')` for Node.js < 10.
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)(module)))

/***/ },
/* 2572 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 2573 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(2499);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 2574 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 2575 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 2576 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(2526),
	    shortOut = __webpack_require__(2577);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 2577 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 2578 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(370);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 2579 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 2580 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 2581 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 2582 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(370),
	    Map = __webpack_require__(530),
	    MapCache = __webpack_require__(531);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 2583 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	module.exports = strictIndexOf;


/***/ },
/* 2584 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(2568);
	
	/** Used to match property names within property paths. */
	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (string.charCodeAt(0) === 46 /* . */) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 2585 */
/***/ function(module, exports) {

	/** Used to match a single whitespace character. */
	var reWhitespace = /\s/;
	
	/**
	 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
	 * character of `string`.
	 *
	 * @private
	 * @param {string} string The string to inspect.
	 * @returns {number} Returns the index of the last non-whitespace character.
	 */
	function trimmedEndIndex(string) {
	  var index = string.length;
	
	  while (index-- && reWhitespace.test(string.charAt(index))) {}
	  return index;
	}
	
	module.exports = trimmedEndIndex;


/***/ },
/* 2586 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Gets the size of a Unicode `string`.
	 *
	 * @private
	 * @param {string} string The string inspect.
	 * @returns {number} Returns the string size.
	 */
	function unicodeSize(string) {
	  var result = reUnicode.lastIndex = 0;
	  while (reUnicode.test(string)) {
	    ++result;
	  }
	  return result;
	}
	
	module.exports = unicodeSize;


/***/ },
/* 2587 */
/***/ function(module, exports) {

	/** Used to compose unicode character classes. */
	var rsAstralRange = '\\ud800-\\udfff',
	    rsComboMarksRange = '\\u0300-\\u036f',
	    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	    rsComboSymbolsRange = '\\u20d0-\\u20ff',
	    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	    rsVarRange = '\\ufe0e\\ufe0f';
	
	/** Used to compose unicode capture groups. */
	var rsAstral = '[' + rsAstralRange + ']',
	    rsCombo = '[' + rsComboRange + ']',
	    rsFitz = '\\ud83c[\\udffb-\\udfff]',
	    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	    rsNonAstral = '[^' + rsAstralRange + ']',
	    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	    rsZWJ = '\\u200d';
	
	/** Used to compose unicode regexes. */
	var reOptMod = rsModifier + '?',
	    rsOptVar = '[' + rsVarRange + ']?',
	    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	    rsSeq = rsOptVar + reOptMod + rsOptJoin,
	    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	/**
	 * Converts a Unicode `string` to an array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the converted array.
	 */
	function unicodeToArray(string) {
	  return string.match(reUnicode) || [];
	}
	
	module.exports = unicodeToArray;


/***/ },
/* 2588 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 2589 */
/***/ function(module, exports, __webpack_require__) {

	var baseDifference = __webpack_require__(2505),
	    baseFlatten = __webpack_require__(904),
	    baseRest = __webpack_require__(536),
	    isArrayLikeObject = __webpack_require__(544);
	
	/**
	 * Creates an array of `array` values not included in the other given arrays
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons. The order and references of result values are
	 * determined by the first array.
	 *
	 * **Note:** Unlike `_.pullAll`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {...Array} [values] The values to exclude.
	 * @returns {Array} Returns the new array of filtered values.
	 * @see _.without, _.xor
	 * @example
	 *
	 * _.difference([2, 1], [2, 3]);
	 * // => [1]
	 */
	var difference = baseRest(function(array, values) {
	  return isArrayLikeObject(array)
	    ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	    : [];
	});
	
	module.exports = difference;


/***/ },
/* 2590 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindIndex = __webpack_require__(903),
	    baseIteratee = __webpack_require__(535),
	    toInteger = __webpack_require__(549);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * This method is like `_.find` except that it returns the index of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @returns {number} Returns the index of the found element, else `-1`.
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney',  'active': false },
	 *   { 'user': 'fred',    'active': false },
	 *   { 'user': 'pebbles', 'active': true }
	 * ];
	 *
	 * _.findIndex(users, function(o) { return o.user == 'barney'; });
	 * // => 0
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findIndex(users, { 'user': 'fred', 'active': false });
	 * // => 1
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findIndex(users, ['active', false]);
	 * // => 0
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findIndex(users, 'active');
	 * // => 2
	 */
	function findIndex(array, predicate, fromIndex) {
	  var length = array == null ? 0 : array.length;
	  if (!length) {
	    return -1;
	  }
	  var index = fromIndex == null ? 0 : toInteger(fromIndex);
	  if (index < 0) {
	    index = nativeMax(length + index, 0);
	  }
	  return baseFindIndex(array, baseIteratee(predicate, 3), index);
	}
	
	module.exports = findIndex;


/***/ },
/* 2591 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(2508),
	    hasPath = __webpack_require__(919);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ },
/* 2592 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(2509),
	    hasPath = __webpack_require__(919);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 2593 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(217),
	    isArray = __webpack_require__(125),
	    isObjectLike = __webpack_require__(183);
	
	/** `Object#toString` result references. */
	var stringTag = '[object String]';
	
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */
	function isString(value) {
	  return typeof value == 'string' ||
	    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	}
	
	module.exports = isString;


/***/ },
/* 2594 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(372),
	    baseForOwn = __webpack_require__(2506),
	    baseIteratee = __webpack_require__(535);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 2595 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(531);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 2596 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(2521),
	    createAssigner = __webpack_require__(2537);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 2597 */
/***/ function(module, exports) {

	/**
	 * This method returns `undefined`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Util
	 * @example
	 *
	 * _.times(2, _.noop);
	 * // => [undefined, undefined]
	 */
	function noop() {
	  // No operation performed.
	}
	
	module.exports = noop;


/***/ },
/* 2598 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(124);
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	module.exports = now;


/***/ },
/* 2599 */
/***/ function(module, exports, __webpack_require__) {

	var createPadding = __webpack_require__(913),
	    stringSize = __webpack_require__(542),
	    toInteger = __webpack_require__(549),
	    toString = __webpack_require__(550);
	
	/**
	 * Pads `string` on the right side if it's shorter than `length`. Padding
	 * characters are truncated if they exceed `length`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to pad.
	 * @param {number} [length=0] The padding length.
	 * @param {string} [chars=' '] The string used as padding.
	 * @returns {string} Returns the padded string.
	 * @example
	 *
	 * _.padEnd('abc', 6);
	 * // => 'abc   '
	 *
	 * _.padEnd('abc', 6, '_-');
	 * // => 'abc_-_'
	 *
	 * _.padEnd('abc', 3);
	 * // => 'abc'
	 */
	function padEnd(string, length, chars) {
	  string = toString(string);
	  length = toInteger(length);
	
	  var strLength = length ? stringSize(string) : 0;
	  return (length && strLength < length)
	    ? (string + createPadding(length - strLength, chars))
	    : string;
	}
	
	module.exports = padEnd;


/***/ },
/* 2600 */
/***/ function(module, exports, __webpack_require__) {

	var createPadding = __webpack_require__(913),
	    stringSize = __webpack_require__(542),
	    toInteger = __webpack_require__(549),
	    toString = __webpack_require__(550);
	
	/**
	 * Pads `string` on the left side if it's shorter than `length`. Padding
	 * characters are truncated if they exceed `length`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category String
	 * @param {string} [string=''] The string to pad.
	 * @param {number} [length=0] The padding length.
	 * @param {string} [chars=' '] The string used as padding.
	 * @returns {string} Returns the padded string.
	 * @example
	 *
	 * _.padStart('abc', 6);
	 * // => '   abc'
	 *
	 * _.padStart('abc', 6, '_-');
	 * // => '_-_abc'
	 *
	 * _.padStart('abc', 3);
	 * // => 'abc'
	 */
	function padStart(string, length, chars) {
	  string = toString(string);
	  length = toInteger(length);
	
	  var strLength = length ? stringSize(string) : 0;
	  return (length && strLength < length)
	    ? (createPadding(length - strLength, chars) + string)
	    : string;
	}
	
	module.exports = padStart;


/***/ },
/* 2601 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(908),
	    basePropertyDeep = __webpack_require__(2523),
	    isKey = __webpack_require__(540),
	    toKey = __webpack_require__(299);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 2602 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 2603 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 2604 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(255),
	    copyArray = __webpack_require__(912),
	    getTag = __webpack_require__(918),
	    isArrayLike = __webpack_require__(301),
	    isString = __webpack_require__(2593),
	    iteratorToArray = __webpack_require__(2557),
	    mapToArray = __webpack_require__(921),
	    setToArray = __webpack_require__(376),
	    stringToArray = __webpack_require__(925),
	    values = __webpack_require__(2609);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/** Built-in value references. */
	var symIterator = Symbol ? Symbol.iterator : undefined;
	
	/**
	 * Converts `value` to an array.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Array} Returns the converted array.
	 * @example
	 *
	 * _.toArray({ 'a': 1, 'b': 2 });
	 * // => [1, 2]
	 *
	 * _.toArray('abc');
	 * // => ['a', 'b', 'c']
	 *
	 * _.toArray(1);
	 * // => []
	 *
	 * _.toArray(null);
	 * // => []
	 */
	function toArray(value) {
	  if (!value) {
	    return [];
	  }
	  if (isArrayLike(value)) {
	    return isString(value) ? stringToArray(value) : copyArray(value);
	  }
	  if (symIterator && value[symIterator]) {
	    return iteratorToArray(value[symIterator]());
	  }
	  var tag = getTag(value),
	      func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	  return func(value);
	}
	
	module.exports = toArray;


/***/ },
/* 2605 */
/***/ function(module, exports, __webpack_require__) {

	var toNumber = __webpack_require__(929);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	module.exports = toFinite;


/***/ },
/* 2606 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(2535),
	    keysIn = __webpack_require__(927);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 2607 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(904),
	    baseRest = __webpack_require__(536),
	    baseUniq = __webpack_require__(911),
	    isArrayLikeObject = __webpack_require__(544);
	
	/**
	 * Creates an array of unique values, in order, from all given arrays using
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {...Array} [arrays] The arrays to inspect.
	 * @returns {Array} Returns the new array of combined values.
	 * @example
	 *
	 * _.union([2], [1, 2]);
	 * // => [2, 1]
	 */
	var union = baseRest(function(arrays) {
	  return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	});
	
	module.exports = union;


/***/ },
/* 2608 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(535),
	    baseUniq = __webpack_require__(911);
	
	/**
	 * This method is like `_.uniq` except that it accepts `iteratee` which is
	 * invoked for each element in `array` to generate the criterion by which
	 * uniqueness is computed. The order of result values is determined by the
	 * order they occur in the array. The iteratee is invoked with one argument:
	 * (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Array
	 * @param {Array} array The array to inspect.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Array} Returns the new duplicate free array.
	 * @example
	 *
	 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	 * // => [2.1, 1.2]
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	 * // => [{ 'x': 1 }, { 'x': 2 }]
	 */
	function uniqBy(array, iteratee) {
	  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
	}
	
	module.exports = uniqBy;


/***/ },
/* 2609 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(2530),
	    keys = __webpack_require__(381);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 2610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _PropTypes = __webpack_require__(930);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Provider = function (_Component) {
	  _inherits(Provider, _Component);
	
	  function Provider() {
	    _classCallCheck(this, Provider);
	
	    return _possibleConstructorReturn(this, (Provider.__proto__ || Object.getPrototypeOf(Provider)).apply(this, arguments));
	  }
	
	  _createClass(Provider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        miniStore: this.props.store
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react.Children.only(this.props.children);
	    }
	  }]);
	
	  return Provider;
	}(_react.Component);
	
	Provider.propTypes = {
	  store: _PropTypes.storeShape.isRequired
	};
	Provider.childContextTypes = {
	  miniStore: _PropTypes.storeShape.isRequired
	};
	exports.default = Provider;

/***/ },
/* 2611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = connect;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _shallowequal = __webpack_require__(79);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _hoistNonReactStatics = __webpack_require__(2613);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _PropTypes = __webpack_require__(930);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function isStateless(Component) {
	  return !Component.prototype.render;
	}
	
	var defaultMapStateToProps = function defaultMapStateToProps() {
	  return {};
	};
	
	function connect(mapStateToProps) {
	  var shouldSubscribe = !!mapStateToProps;
	  var finnalMapStateToProps = mapStateToProps || defaultMapStateToProps;
	
	  return function wrapWithConnect(WrappedComponent) {
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      _createClass(Connect, null, [{
	        key: 'getDerivedStateFromProps',
	        value: function getDerivedStateFromProps(props, prevState) {
	          // using ownProps
	          if (mapStateToProps && mapStateToProps.length === 2 && props !== prevState.props) {
	            return {
	              subscribed: finnalMapStateToProps(prevState.store.getState(), props),
	              props: props
	            };
	          }
	          return { props: props };
	        }
	      }]);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, (Connect.__proto__ || Object.getPrototypeOf(Connect)).call(this, props, context));
	
	        _this.handleChange = function () {
	          if (!_this.unsubscribe) {
	            return;
	          }
	          var nextState = finnalMapStateToProps(_this.store.getState(), _this.props);
	          _this.setState({ subscribed: nextState });
	        };
	
	        _this.store = context.miniStore;
	        _this.state = {
	          subscribed: finnalMapStateToProps(_this.store.getState(), props),
	          store: _this.store,
	          props: props
	        };
	        return _this;
	      }
	
	      _createClass(Connect, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.trySubscribe();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          this.tryUnsubscribe();
	        }
	      }, {
	        key: 'shouldComponentUpdate',
	        value: function shouldComponentUpdate(nextProps, nextState) {
	          return !(0, _shallowequal2.default)(this.props, nextProps) || !(0, _shallowequal2.default)(this.state.subscribed, nextState.subscribed);
	        }
	      }, {
	        key: 'trySubscribe',
	        value: function trySubscribe() {
	          if (shouldSubscribe) {
	            this.unsubscribe = this.store.subscribe(this.handleChange);
	            this.handleChange();
	          }
	        }
	      }, {
	        key: 'tryUnsubscribe',
	        value: function tryUnsubscribe() {
	          if (this.unsubscribe) {
	            this.unsubscribe();
	            this.unsubscribe = null;
	          }
	        }
	      }, {
	        key: 'getWrappedInstance',
	        value: function getWrappedInstance() {
	          return this.wrappedInstance;
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var _this2 = this;
	
	          var props = _extends({}, this.props, this.state.subscribed, {
	            store: this.store
	          });
	
	          if (!isStateless(WrappedComponent)) {
	            props = _extends({}, props, {
	              ref: function ref(c) {
	                return _this2.wrappedInstance = c;
	              }
	            });
	          }
	
	          return _react2.default.createElement(WrappedComponent, props);
	        }
	      }]);
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.displayName = 'Connect(' + getDisplayName(WrappedComponent) + ')';
	    Connect.contextTypes = {
	      miniStore: _PropTypes.storeShape.isRequired
	    };
	
	
	    (0, _reactLifecyclesCompat.polyfill)(Connect);
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 2612 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = create;
	function create(initialState) {
	  var state = initialState;
	  var listeners = [];
	
	  function setState(partial) {
	    state = _extends({}, state, partial);
	    for (var i = 0; i < listeners.length; i++) {
	      listeners[i]();
	    }
	  }
	
	  function getState() {
	    return state;
	  }
	
	  function subscribe(listener) {
	    listeners.push(listener);
	
	    return function unsubscribe() {
	      var index = listeners.indexOf(listener);
	      listeners.splice(index, 1);
	    };
	  }
	
	  return {
	    setState: setState,
	    getState: getState,
	    subscribe: subscribe
	  };
	}

/***/ },
/* 2613 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    getDerivedStateFromProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	    name: true,
	    length: true,
	    prototype: true,
	    caller: true,
	    callee: true,
	    arguments: true,
	    arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 2614 */
/***/ function(module, exports, __webpack_require__) {

	var map = {
		"./af": 931,
		"./af.js": 931,
		"./ar": 938,
		"./ar-dz": 932,
		"./ar-dz.js": 932,
		"./ar-kw": 933,
		"./ar-kw.js": 933,
		"./ar-ly": 934,
		"./ar-ly.js": 934,
		"./ar-ma": 935,
		"./ar-ma.js": 935,
		"./ar-sa": 936,
		"./ar-sa.js": 936,
		"./ar-tn": 937,
		"./ar-tn.js": 937,
		"./ar.js": 938,
		"./az": 939,
		"./az.js": 939,
		"./be": 940,
		"./be.js": 940,
		"./bg": 941,
		"./bg.js": 941,
		"./bm": 942,
		"./bm.js": 942,
		"./bn": 944,
		"./bn-bd": 943,
		"./bn-bd.js": 943,
		"./bn.js": 944,
		"./bo": 945,
		"./bo.js": 945,
		"./br": 946,
		"./br.js": 946,
		"./bs": 947,
		"./bs.js": 947,
		"./ca": 948,
		"./ca.js": 948,
		"./cs": 949,
		"./cs.js": 949,
		"./cv": 950,
		"./cv.js": 950,
		"./cy": 951,
		"./cy.js": 951,
		"./da": 952,
		"./da.js": 952,
		"./de": 955,
		"./de-at": 953,
		"./de-at.js": 953,
		"./de-ch": 954,
		"./de-ch.js": 954,
		"./de.js": 955,
		"./dv": 956,
		"./dv.js": 956,
		"./el": 957,
		"./el.js": 957,
		"./en-au": 958,
		"./en-au.js": 958,
		"./en-ca": 959,
		"./en-ca.js": 959,
		"./en-gb": 960,
		"./en-gb.js": 960,
		"./en-ie": 961,
		"./en-ie.js": 961,
		"./en-il": 962,
		"./en-il.js": 962,
		"./en-in": 963,
		"./en-in.js": 963,
		"./en-nz": 964,
		"./en-nz.js": 964,
		"./en-sg": 965,
		"./en-sg.js": 965,
		"./eo": 966,
		"./eo.js": 966,
		"./es": 970,
		"./es-do": 967,
		"./es-do.js": 967,
		"./es-mx": 968,
		"./es-mx.js": 968,
		"./es-us": 969,
		"./es-us.js": 969,
		"./es.js": 970,
		"./et": 971,
		"./et.js": 971,
		"./eu": 972,
		"./eu.js": 972,
		"./fa": 973,
		"./fa.js": 973,
		"./fi": 974,
		"./fi.js": 974,
		"./fil": 975,
		"./fil.js": 975,
		"./fo": 976,
		"./fo.js": 976,
		"./fr": 979,
		"./fr-ca": 977,
		"./fr-ca.js": 977,
		"./fr-ch": 978,
		"./fr-ch.js": 978,
		"./fr.js": 979,
		"./fy": 980,
		"./fy.js": 980,
		"./ga": 981,
		"./ga.js": 981,
		"./gd": 982,
		"./gd.js": 982,
		"./gl": 983,
		"./gl.js": 983,
		"./gom-deva": 984,
		"./gom-deva.js": 984,
		"./gom-latn": 985,
		"./gom-latn.js": 985,
		"./gu": 986,
		"./gu.js": 986,
		"./he": 987,
		"./he.js": 987,
		"./hi": 988,
		"./hi.js": 988,
		"./hr": 989,
		"./hr.js": 989,
		"./hu": 990,
		"./hu.js": 990,
		"./hy-am": 991,
		"./hy-am.js": 991,
		"./id": 992,
		"./id.js": 992,
		"./is": 993,
		"./is.js": 993,
		"./it": 995,
		"./it-ch": 994,
		"./it-ch.js": 994,
		"./it.js": 995,
		"./ja": 996,
		"./ja.js": 996,
		"./jv": 997,
		"./jv.js": 997,
		"./ka": 998,
		"./ka.js": 998,
		"./kk": 999,
		"./kk.js": 999,
		"./km": 1000,
		"./km.js": 1000,
		"./kn": 1001,
		"./kn.js": 1001,
		"./ko": 1002,
		"./ko.js": 1002,
		"./ku": 1003,
		"./ku.js": 1003,
		"./ky": 1004,
		"./ky.js": 1004,
		"./lb": 1005,
		"./lb.js": 1005,
		"./lo": 1006,
		"./lo.js": 1006,
		"./lt": 1007,
		"./lt.js": 1007,
		"./lv": 1008,
		"./lv.js": 1008,
		"./me": 1009,
		"./me.js": 1009,
		"./mi": 1010,
		"./mi.js": 1010,
		"./mk": 1011,
		"./mk.js": 1011,
		"./ml": 1012,
		"./ml.js": 1012,
		"./mn": 1013,
		"./mn.js": 1013,
		"./mr": 1014,
		"./mr.js": 1014,
		"./ms": 1016,
		"./ms-my": 1015,
		"./ms-my.js": 1015,
		"./ms.js": 1016,
		"./mt": 1017,
		"./mt.js": 1017,
		"./my": 1018,
		"./my.js": 1018,
		"./nb": 1019,
		"./nb.js": 1019,
		"./ne": 1020,
		"./ne.js": 1020,
		"./nl": 1022,
		"./nl-be": 1021,
		"./nl-be.js": 1021,
		"./nl.js": 1022,
		"./nn": 1023,
		"./nn.js": 1023,
		"./oc-lnc": 1024,
		"./oc-lnc.js": 1024,
		"./pa-in": 1025,
		"./pa-in.js": 1025,
		"./pl": 1026,
		"./pl.js": 1026,
		"./pt": 1028,
		"./pt-br": 1027,
		"./pt-br.js": 1027,
		"./pt.js": 1028,
		"./ro": 1029,
		"./ro.js": 1029,
		"./ru": 1030,
		"./ru.js": 1030,
		"./sd": 1031,
		"./sd.js": 1031,
		"./se": 1032,
		"./se.js": 1032,
		"./si": 1033,
		"./si.js": 1033,
		"./sk": 1034,
		"./sk.js": 1034,
		"./sl": 1035,
		"./sl.js": 1035,
		"./sq": 1036,
		"./sq.js": 1036,
		"./sr": 1038,
		"./sr-cyrl": 1037,
		"./sr-cyrl.js": 1037,
		"./sr.js": 1038,
		"./ss": 1039,
		"./ss.js": 1039,
		"./sv": 1040,
		"./sv.js": 1040,
		"./sw": 1041,
		"./sw.js": 1041,
		"./ta": 1042,
		"./ta.js": 1042,
		"./te": 1043,
		"./te.js": 1043,
		"./tet": 1044,
		"./tet.js": 1044,
		"./tg": 1045,
		"./tg.js": 1045,
		"./th": 1046,
		"./th.js": 1046,
		"./tk": 1047,
		"./tk.js": 1047,
		"./tl-ph": 1048,
		"./tl-ph.js": 1048,
		"./tlh": 1049,
		"./tlh.js": 1049,
		"./tr": 1050,
		"./tr.js": 1050,
		"./tzl": 1051,
		"./tzl.js": 1051,
		"./tzm": 1053,
		"./tzm-latn": 1052,
		"./tzm-latn.js": 1052,
		"./tzm.js": 1053,
		"./ug-cn": 1054,
		"./ug-cn.js": 1054,
		"./uk": 1055,
		"./uk.js": 1055,
		"./ur": 1056,
		"./ur.js": 1056,
		"./uz": 1058,
		"./uz-latn": 1057,
		"./uz-latn.js": 1057,
		"./uz.js": 1058,
		"./vi": 1059,
		"./vi.js": 1059,
		"./x-pseudo": 1060,
		"./x-pseudo.js": 1060,
		"./yo": 1061,
		"./yo.js": 1061,
		"./zh-cn": 551,
		"./zh-cn.js": 551,
		"./zh-hk": 1062,
		"./zh-hk.js": 1062,
		"./zh-mo": 1063,
		"./zh-mo.js": 1063,
		"./zh-tw": 1064,
		"./zh-tw.js": 1064
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 2614;


/***/ },
/* 2615 */
/***/ function(module, exports) {

	// mutationobserver-shim v0.3.3 (github.com/megawac/MutationObserver.js)
	// Authors: Graeme Yeates (github.com/megawac) 
	/*
	 Shim for MutationObserver interface
	 Author: Graeme Yeates (github.com/megawac)
	 Repository: https://github.com/megawac/MutationObserver.js
	 License: WTFPL V2, 2004 (wtfpl.net).
	 Though credit and staring the repo will make me feel pretty, you can modify and redistribute as you please.
	 Attempts to follow spec (https://www.w3.org/TR/dom/#mutation-observers) as closely as possible for native javascript
	 See https://github.com/WebKit/webkit/blob/master/Source/WebCore/dom/MutationObserver.cpp for current webkit source c++ implementation
	*/
	window.MutationObserver||(window.MutationObserver=function(y){function z(a){this.i=[];this.m=a}function K(a){(function c(){var d=a.takeRecords();d.length&&a.m(d,a);a.h=setTimeout(c,z._period)})()}function r(a){var b={type:null,target:null,addedNodes:[],removedNodes:[],previousSibling:null,nextSibling:null,attributeName:null,attributeNamespace:null,oldValue:null},c;for(c in a)b[c]!==y&&a[c]!==y&&(b[c]=a[c]);return b}function L(a,b){var c=E(a,b);return function(d){var f=d.length;b.a&&3===a.nodeType&&
	a.nodeValue!==c.a&&d.push(new r({type:"characterData",target:a,oldValue:c.a}));b.b&&c.b&&C(d,a,c.b,b.f);if(b.c||b.g)var m=M(d,a,c,b);if(m||d.length!==f)c=E(a,b)}}function N(a,b){return b.value}function O(a,b){return"style"!==b.name?b.value:a.style.cssText}function C(a,b,c,d){for(var f={},m=b.attributes,k,g,p=m.length;p--;)k=m[p],g=k.name,d&&d[g]===y||(F(b,k)!==c[g]&&a.push(r({type:"attributes",target:b,attributeName:g,oldValue:c[g],attributeNamespace:k.namespaceURI})),f[g]=!0);for(g in c)f[g]||a.push(r({target:b,
	type:"attributes",attributeName:g,oldValue:c[g]}))}function M(a,b,c,d){function f(g,p,t,q,x){var A=g.length-1;x=-~((A-x)/2);for(var h,l,e;e=g.pop();)h=t[e.j],l=q[e.l],d.c&&x&&Math.abs(e.j-e.l)>=A&&(a.push(r({type:"childList",target:p,addedNodes:[h],removedNodes:[h],nextSibling:h.nextSibling,previousSibling:h.previousSibling})),x--),d.b&&l.b&&C(a,h,l.b,d.f),d.a&&3===h.nodeType&&h.nodeValue!==l.a&&a.push(r({type:"characterData",target:h,oldValue:l.a})),d.g&&m(h,l)}function m(g,p){for(var t=g.childNodes,
	q=p.c,x=t.length,A=q?q.length:0,h,l,e,n,v,B=0,w=0,u=0;w<x||u<A;)n=t[w],v=(e=q[u])&&e.node,n===v?(d.b&&e.b&&C(a,n,e.b,d.f),d.a&&e.a!==y&&n.nodeValue!==e.a&&a.push(r({type:"characterData",target:n,oldValue:e.a})),l&&f(l,g,t,q,B),d.g&&(n.childNodes.length||e.c&&e.c.length)&&m(n,e),w++,u++):(k=!0,h||(h={},l=[]),n&&(h[e=G(n)]||(h[e]=!0,-1===(e=H(q,n,u,"node"))?d.c&&(a.push(r({type:"childList",target:g,addedNodes:[n],nextSibling:n.nextSibling,previousSibling:n.previousSibling})),B++):l.push({j:w,l:e})),
	w++),v&&v!==t[w]&&(h[e=G(v)]||(h[e]=!0,-1===(e=H(t,v,w))?d.c&&(a.push(r({type:"childList",target:p.node,removedNodes:[v],nextSibling:q[u+1],previousSibling:q[u-1]})),B--):l.push({j:e,l:u})),u++));l&&f(l,g,t,q,B)}var k;m(b,c);return k}function E(a,b){var c=!0;return function m(f){var k={node:f};!b.a||3!==f.nodeType&&8!==f.nodeType?(b.b&&c&&1===f.nodeType&&(k.b=I(f.attributes,function(g,p){if(!b.f||b.f[p.name])g[p.name]=F(f,p);return g},{})),c&&(b.c||b.a||b.b&&b.g)&&(k.c=P(f.childNodes,m)),c=b.g):k.a=
	f.nodeValue;return k}(a)}function G(a){try{return a.id||(a.mo_id=a.mo_id||J++)}catch(b){try{return a.nodeValue}catch(c){return J++}}}function P(a,b){for(var c=[],d=0;d<a.length;d++)c[d]=b(a[d],d,a);return c}function I(a,b,c){for(var d=0;d<a.length;d++)c=b(c,a[d],d,a);return c}function H(a,b,c,d){for(;c<a.length;c++)if((d?a[c][d]:a[c])===b)return c;return-1}z._period=30;z.prototype={observe:function(a,b){for(var c={b:!!(b.attributes||b.attributeFilter||b.attributeOldValue),c:!!b.childList,g:!!b.subtree,
	a:!(!b.characterData&&!b.characterDataOldValue)},d=this.i,f=0;f<d.length;f++)d[f].s===a&&d.splice(f,1);b.attributeFilter&&(c.f=I(b.attributeFilter,function(m,k){m[k]=!0;return m},{}));d.push({s:a,o:L(a,c)});this.h||K(this)},takeRecords:function(){for(var a=[],b=this.i,c=0;c<b.length;c++)b[c].o(a);return a},disconnect:function(){this.i=[];clearTimeout(this.h);this.h=null}};var D=document.createElement("i");D.style.top=0;var F=(D="null"!=D.attributes.style.value)?N:O,J=1;return z}(void 0));
	//# sourceMappingURL=mutationobserver.map


/***/ },
/* 2616 */
/***/ function(module, exports) {

	// Most of these are according to this table: http://www.ssicom.org/js/x171166.htm
	// However where nodejs readline diverges, they are adjusted to conform to it
	module.exports = {
	  nomod: {
	      escape: '\u001b'
	    , space: ' ' // actually '\u0020'
	    }
	  , ctrl: {
	        ' ': '\u0000'
	      , 'a': '\u0001'
	      , 'b': '\u0002'
	      , 'c': '\u0003'
	      , 'd': '\u0004'
	      , 'e': '\u0005'
	      , 'f': '\u0006'
	      , 'g': '\u0007'
	      , 'h': '\u0008'
	      , 'i': '\u0009'
	      , 'j': '\u000a'
	      , 'k': '\u000b'
	      , 'm': '\u000c'
	      , 'n': '\u000d'
	      , 'l': '\u000e'
	      , 'o': '\u000f'
	      , 'p': '\u0010'
	      , 'q': '\u0011'
	      , 'r': '\u0012'
	      , 's': '\u0013'
	      , 't': '\u0014'
	      , 'u': '\u0015'
	      , 'v': '\u0016'
	      , 'w': '\u0017'
	      , 'x': '\u0018'
	      , 'y': '\u0019'
	      , 'z': '\u001a'
	      , '[': '\u001b'
	      , '\\':'\u001c'
	      , ']': '\u001d'
	      , '^': '\u001e'
	      , '_': '\u001f'
	
	      , 'space': '\u0000'
	    }
	};


/***/ },
/* 2617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var keycodes = __webpack_require__(2616);
	
	function assertKeyString(s) {
	  if (!/^(ctrl-|shift-|alt-|meta-){0,4}\w+$/.test(s))
	    throw new Error('The string to parse needs to be of the format "c", "ctrl-c", "shift-ctrl-c".');
	}
	
	module.exports = function parse(s) {
	  var keyString = s.trim().toLowerCase();
	
	  assertKeyString(keyString);
	
	  var key = {
	      name     :  undefined
	    , ctrl     :  false
	    , meta     :  false
	    , shift    :  false
	    , alt      :  false
	    , sequence :  undefined
	  }
	  , parts = keyString.split('-')
	  , c;
	
	  key.name = parts.pop();
	  while((c = parts.pop())) key[c] = true;
	  key.sequence = key.ctrl 
	    ? keycodes.ctrl[key.name] || key.name
	    : keycodes.nomod[key.name] || key.name;
	
	  // uppercase sequence for single chars when shift was pressed
	  if (key.shift && key.sequence && key.sequence.length === 1)
	    key.sequence = key.sequence.toUpperCase();
	
	  return key;
	};


/***/ },
/* 2618 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// resolves . and .. elements in a path array with directory names there
	// must be no slashes, empty elements, or device names (c:\) in the array
	// (so also no leading and trailing slashes - it does not distinguish
	// relative and absolute paths)
	function normalizeArray(parts, allowAboveRoot) {
	  // if the path tries to go above the root, `up` ends up > 0
	  var up = 0;
	  for (var i = parts.length - 1; i >= 0; i--) {
	    var last = parts[i];
	    if (last === '.') {
	      parts.splice(i, 1);
	    } else if (last === '..') {
	      parts.splice(i, 1);
	      up++;
	    } else if (up) {
	      parts.splice(i, 1);
	      up--;
	    }
	  }
	
	  // if the path is allowed to go above the root, restore leading ..s
	  if (allowAboveRoot) {
	    for (; up--; up) {
	      parts.unshift('..');
	    }
	  }
	
	  return parts;
	}
	
	// Split a filename into [root, dir, basename, ext], unix version
	// 'root' is just a slash, or nothing.
	var splitPathRe =
	    /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
	var splitPath = function(filename) {
	  return splitPathRe.exec(filename).slice(1);
	};
	
	// path.resolve([from ...], to)
	// posix version
	exports.resolve = function() {
	  var resolvedPath = '',
	      resolvedAbsolute = false;
	
	  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
	    var path = (i >= 0) ? arguments[i] : process.cwd();
	
	    // Skip empty and invalid entries
	    if (typeof path !== 'string') {
	      throw new TypeError('Arguments to path.resolve must be strings');
	    } else if (!path) {
	      continue;
	    }
	
	    resolvedPath = path + '/' + resolvedPath;
	    resolvedAbsolute = path.charAt(0) === '/';
	  }
	
	  // At this point the path should be resolved to a full absolute path, but
	  // handle relative paths to be safe (might happen when process.cwd() fails)
	
	  // Normalize the path
	  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
	    return !!p;
	  }), !resolvedAbsolute).join('/');
	
	  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
	};
	
	// path.normalize(path)
	// posix version
	exports.normalize = function(path) {
	  var isAbsolute = exports.isAbsolute(path),
	      trailingSlash = substr(path, -1) === '/';
	
	  // Normalize the path
	  path = normalizeArray(filter(path.split('/'), function(p) {
	    return !!p;
	  }), !isAbsolute).join('/');
	
	  if (!path && !isAbsolute) {
	    path = '.';
	  }
	  if (path && trailingSlash) {
	    path += '/';
	  }
	
	  return (isAbsolute ? '/' : '') + path;
	};
	
	// posix version
	exports.isAbsolute = function(path) {
	  return path.charAt(0) === '/';
	};
	
	// posix version
	exports.join = function() {
	  var paths = Array.prototype.slice.call(arguments, 0);
	  return exports.normalize(filter(paths, function(p, index) {
	    if (typeof p !== 'string') {
	      throw new TypeError('Arguments to path.join must be strings');
	    }
	    return p;
	  }).join('/'));
	};
	
	
	// path.relative(from, to)
	// posix version
	exports.relative = function(from, to) {
	  from = exports.resolve(from).substr(1);
	  to = exports.resolve(to).substr(1);
	
	  function trim(arr) {
	    var start = 0;
	    for (; start < arr.length; start++) {
	      if (arr[start] !== '') break;
	    }
	
	    var end = arr.length - 1;
	    for (; end >= 0; end--) {
	      if (arr[end] !== '') break;
	    }
	
	    if (start > end) return [];
	    return arr.slice(start, end - start + 1);
	  }
	
	  var fromParts = trim(from.split('/'));
	  var toParts = trim(to.split('/'));
	
	  var length = Math.min(fromParts.length, toParts.length);
	  var samePartsLength = length;
	  for (var i = 0; i < length; i++) {
	    if (fromParts[i] !== toParts[i]) {
	      samePartsLength = i;
	      break;
	    }
	  }
	
	  var outputParts = [];
	  for (var i = samePartsLength; i < fromParts.length; i++) {
	    outputParts.push('..');
	  }
	
	  outputParts = outputParts.concat(toParts.slice(samePartsLength));
	
	  return outputParts.join('/');
	};
	
	exports.sep = '/';
	exports.delimiter = ':';
	
	exports.dirname = function(path) {
	  var result = splitPath(path),
	      root = result[0],
	      dir = result[1];
	
	  if (!root && !dir) {
	    // No dirname whatsoever
	    return '.';
	  }
	
	  if (dir) {
	    // It has a dirname, strip trailing slash
	    dir = dir.substr(0, dir.length - 1);
	  }
	
	  return root + dir;
	};
	
	
	exports.basename = function(path, ext) {
	  var f = splitPath(path)[2];
	  // TODO: make this comparison case-insensitive on windows?
	  if (ext && f.substr(-1 * ext.length) === ext) {
	    f = f.substr(0, f.length - ext.length);
	  }
	  return f;
	};
	
	
	exports.extname = function(path) {
	  return splitPath(path)[3];
	};
	
	function filter (xs, f) {
	    if (xs.filter) return xs.filter(f);
	    var res = [];
	    for (var i = 0; i < xs.length; i++) {
	        if (f(xs[i], i, xs)) res.push(xs[i]);
	    }
	    return res;
	}
	
	// String.prototype.substr - negative index don't work in IE8
	var substr = 'ab'.substr(-1) === 'b'
	    ? function (str, start, len) { return str.substr(start, len) }
	    : function (str, start, len) {
	        if (start < 0) start = str.length + start;
	        return str.substr(start, len);
	    }
	;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ },
/* 2619 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ },
/* 2620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(1065);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 2621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(1065);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 2622 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var printWarning = function() {};
	
	if (false) {
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	  var has = require('./lib/has');
	
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}
	
	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (false) {
	    loggedTypeFailures = {};
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 2623 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(1067);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2624 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactIs = __webpack_require__(222);
	var assign = __webpack_require__(2626);
	
	var ReactPropTypesSecret = __webpack_require__(1067);
	var has = __webpack_require__(2625);
	var checkPropTypes = __webpack_require__(2622);
	
	var printWarning = function() {};
	
	if (false) {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}
	
	function emptyFunctionThatReturnsNull() {
	  return null;
	}
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (false) {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 2625 */
/***/ function(module, exports) {

	module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ },
/* 2626 */
2126,
/* 2627 */
/***/ function(module, exports) {

	function hsl2rgb(hsl) {
	  var h = hsl[0] / 360,
	      s = hsl[1] / 100,
	      l = hsl[2] / 100,
	      t1, t2, t3, rgb, val;
	
	  if (s == 0) {
	    val = l * 255;
	    return [val, val, val];
	  }
	
	  if (l < 0.5)
	    t2 = l * (1 + s);
	  else
	    t2 = l + s - l * s;
	  t1 = 2 * l - t2;
	
	  rgb = [0, 0, 0];
	  for (var i = 0; i < 3; i++) {
	    t3 = h + 1 / 3 * - (i - 1);
	    t3 < 0 && t3++;
	    t3 > 1 && t3--;
	
	    if (6 * t3 < 1)
	      val = t1 + (t2 - t1) * 6 * t3;
	    else if (2 * t3 < 1)
	      val = t2;
	    else if (3 * t3 < 2)
	      val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
	    else
	      val = t1;
	
	    rgb[i] = val * 255;
	  }
	
	  return rgb;
	}
	
	module.exports = hsl2rgb;

/***/ },
/* 2628 */
/***/ function(module, exports, __webpack_require__) {

	var clamp = __webpack_require__(552);
	
	function componentToHex(c) {
	  var value = Math.round(clamp(c, 0, 255));
	  var hex   = value.toString(16);
	
	  return hex.length == 1 ? "0" + hex : hex;
	}
	
	function rgb2hex(rgb) {
	  var alpha = rgb.length === 4 ? componentToHex(rgb[3] * 255) : "";
	
	  return "#" + componentToHex(rgb[0]) + componentToHex(rgb[1]) + componentToHex(rgb[2]) + alpha;
	}
	
	module.exports = rgb2hex;

/***/ },
/* 2629 */
/***/ function(module, exports) {

	function expand(hex) {
	  var result = "#";
	
	  for (var i = 1; i < hex.length; i++) {
	    var val = hex.charAt(i);
	    result += val + val;
	  }
	
	  return result;
	}
	
	function hex(hex) {
	  // #RGB or #RGBA
	  if(hex.length === 4 || hex.length === 5) {
	    hex = expand(hex);
	  }
	
	  var rgb = [
	    parseInt(hex.substring(1,3), 16),
	    parseInt(hex.substring(3,5), 16),
	    parseInt(hex.substring(5,7), 16)
	  ];
	
	  // #RRGGBBAA
	  if (hex.length === 9) {
	    var alpha = parseFloat((parseInt(hex.substring(7,9), 16) / 255).toFixed(2));
	    rgb.push(alpha);
	  }
	
	  return rgb;
	}
	
	module.exports = hex;

/***/ },
/* 2630 */
/***/ function(module, exports, __webpack_require__) {

	var extractComponents = __webpack_require__(1068);
	var clamp = __webpack_require__(552);
	
	function parseHslComponent(component, i) {
	  component = parseFloat(component);
	
	  switch(i) {
	    case 0:
	      return clamp(component, 0, 360);
	    case 1:
	    case 2:
	      return clamp(component, 0, 100);
	    case 3:
	      return clamp(component, 0, 1);
	  }
	}
	
	function hsl(color) {
	  return extractComponents(color).map(parseHslComponent);
	}
	
	module.exports = hsl;

/***/ },
/* 2631 */
/***/ function(module, exports, __webpack_require__) {

	var hsl = __webpack_require__(2630);
	var hex = __webpack_require__(2629);
	var rgb = __webpack_require__(2632);
	var hsl2rgb = __webpack_require__(2627);
	
	function hsl2rgbParse(color) {
	  var h = hsl(color);
	  var r = hsl2rgb(h);
	
	  // handle alpha since hsl2rgb doesn't know (or care!) about it
	  if(h.length === 4) {
	    r.push(h[3]);
	  }
	
	  return r;
	}
	
	var space2parser = {
	  "#" : hex,
	  "hsl" : hsl2rgbParse,
	  "rgb" : rgb
	};
	
	function parse(color) {
	  for(var scheme in space2parser) {
	    if(color.indexOf(scheme) === 0) {
	      return space2parser[scheme](color);
	    }
	  }
	}
	
	parse.rgb = rgb;
	parse.hsl = hsl;
	parse.hex = hex;
	
	module.exports = parse;

/***/ },
/* 2632 */
/***/ function(module, exports, __webpack_require__) {

	var extractComponents = __webpack_require__(1068);
	var clamp = __webpack_require__(552);
	
	function parseRgbComponent(component, i) {
	  if (i < 3) {
	    if (component.indexOf('%') != -1) {
	      return Math.round(255 * clamp(parseInt(component, 10), 0, 100)/100);
	    } else {
	      return clamp(parseInt(component, 10), 0, 255);
	    }
	  } else {
	    return clamp(parseFloat(component), 0, 1);
	  } 
	}
	
	function rgb(color) {
	  return extractComponents(color).map(parseRgbComponent);
	}
	
	module.exports = rgb;

/***/ },
/* 2633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(2939);
	var objectAssign = __webpack_require__(40);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	exports.extract = function (str) {
		return str.split('?')[1] || '';
	};
	
	exports.parse = function (str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^(\?|#|&)/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeURIComponent(val);
	
			formatter(decodeURIComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	};
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort().map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};


/***/ },
/* 2634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domAlign = __webpack_require__(2128);
	
	var _addEventListener = __webpack_require__(145);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _util = __webpack_require__(2635);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getElement(func) {
	  if (typeof func !== 'function' || !func) return null;
	  return func();
	}
	
	function getPoint(point) {
	  if (typeof point !== 'object' || !point) return null;
	  return point;
	}
	
	var Align = function (_Component) {
	  (0, _inherits3['default'])(Align, _Component);
	
	  function Align() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Align);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Align.__proto__ || Object.getPrototypeOf(Align)).call.apply(_ref, [this].concat(args))), _this), _this.forceAlign = function () {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          target = _this$props.target,
	          align = _this$props.align,
	          onAlign = _this$props.onAlign;
	
	      if (!disabled && target) {
	        var source = _reactDom2['default'].findDOMNode(_this);
	
	        var result = void 0;
	        var element = getElement(target);
	        var point = getPoint(target);
	
	        // IE lose focus after element realign
	        // We should record activeElement and restore later
	        var activeElement = document.activeElement;
	
	        if (element) {
	          result = (0, _domAlign.alignElement)(source, element, align);
	        } else if (point) {
	          result = (0, _domAlign.alignPoint)(source, point, align);
	        }
	
	        (0, _util.restoreFocus)(activeElement, source);
	
	        if (onAlign) {
	          onAlign(source, result);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Align, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var props = this.props;
	      // if parent ref not attached .... use document.getElementById
	      this.forceAlign();
	      if (!props.disabled && props.monitorWindowResize) {
	        this.startMonitorWindowResize();
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var reAlign = false;
	      var props = this.props;
	
	      if (!props.disabled) {
	        var source = _reactDom2['default'].findDOMNode(this);
	        var sourceRect = source ? source.getBoundingClientRect() : null;
	
	        if (prevProps.disabled) {
	          reAlign = true;
	        } else {
	          var lastElement = getElement(prevProps.target);
	          var currentElement = getElement(props.target);
	          var lastPoint = getPoint(prevProps.target);
	          var currentPoint = getPoint(props.target);
	
	          if ((0, _util.isWindow)(lastElement) && (0, _util.isWindow)(currentElement)) {
	            // Skip if is window
	            reAlign = false;
	          } else if (lastElement !== currentElement || // Element change
	          lastElement && !currentElement && currentPoint || // Change from element to point
	          lastPoint && currentPoint && currentElement || // Change from point to element
	          currentPoint && !(0, _util.isSamePoint)(lastPoint, currentPoint)) {
	            reAlign = true;
	          }
	
	          // If source element size changed
	          var preRect = this.sourceRect || {};
	          if (!reAlign && source && (!(0, _util.isSimilarValue)(preRect.width, sourceRect.width) || !(0, _util.isSimilarValue)(preRect.height, sourceRect.height))) {
	            reAlign = true;
	          }
	        }
	
	        this.sourceRect = sourceRect;
	      }
	
	      if (reAlign) {
	        this.forceAlign();
	      }
	
	      if (props.monitorWindowResize && !props.disabled) {
	        this.startMonitorWindowResize();
	      } else {
	        this.stopMonitorWindowResize();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stopMonitorWindowResize();
	    }
	  }, {
	    key: 'startMonitorWindowResize',
	    value: function startMonitorWindowResize() {
	      if (!this.resizeHandler) {
	        this.bufferMonitor = (0, _util.buffer)(this.forceAlign, this.props.monitorBufferTime);
	        this.resizeHandler = (0, _addEventListener2['default'])(window, 'resize', this.bufferMonitor);
	      }
	    }
	  }, {
	    key: 'stopMonitorWindowResize',
	    value: function stopMonitorWindowResize() {
	      if (this.resizeHandler) {
	        this.bufferMonitor.clear();
	        this.resizeHandler.remove();
	        this.resizeHandler = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          childrenProps = _props.childrenProps,
	          children = _props.children;
	
	      var child = _react2['default'].Children.only(children);
	      if (childrenProps) {
	        var newProps = {};
	        var propList = Object.keys(childrenProps);
	        propList.forEach(function (prop) {
	          newProps[prop] = _this2.props[childrenProps[prop]];
	        });
	
	        return _react2['default'].cloneElement(child, newProps);
	      }
	      return child;
	    }
	  }]);
	  return Align;
	}(_react.Component);
	
	Align.propTypes = {
	  childrenProps: _propTypes2['default'].object,
	  align: _propTypes2['default'].object.isRequired,
	  target: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].shape({
	    clientX: _propTypes2['default'].number,
	    clientY: _propTypes2['default'].number,
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })]),
	  onAlign: _propTypes2['default'].func,
	  monitorBufferTime: _propTypes2['default'].number,
	  monitorWindowResize: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any
	};
	Align.defaultProps = {
	  target: function target() {
	    return window;
	  },
	  monitorBufferTime: 50,
	  monitorWindowResize: false,
	  disabled: false
	};
	exports['default'] = Align;
	module.exports = exports['default'];

/***/ },
/* 2635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.buffer = buffer;
	exports.isSamePoint = isSamePoint;
	exports.isWindow = isWindow;
	exports.isSimilarValue = isSimilarValue;
	exports.restoreFocus = restoreFocus;
	
	var _contains = __webpack_require__(383);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function buffer(fn, ms) {
	  var timer = void 0;
	
	  function clear() {
	    if (timer) {
	      clearTimeout(timer);
	      timer = null;
	    }
	  }
	
	  function bufferFn() {
	    clear();
	    timer = setTimeout(fn, ms);
	  }
	
	  bufferFn.clear = clear;
	
	  return bufferFn;
	}
	
	function isSamePoint(prev, next) {
	  if (prev === next) return true;
	  if (!prev || !next) return false;
	
	  if ('pageX' in next && 'pageY' in next) {
	    return prev.pageX === next.pageX && prev.pageY === next.pageY;
	  }
	
	  if ('clientX' in next && 'clientY' in next) {
	    return prev.clientX === next.clientX && prev.clientY === next.clientY;
	  }
	
	  return false;
	}
	
	function isWindow(obj) {
	  return obj && typeof obj === 'object' && obj.window === obj;
	}
	
	function isSimilarValue(val1, val2) {
	  var int1 = Math.floor(val1);
	  var int2 = Math.floor(val2);
	  return Math.abs(int1 - int2) <= 1;
	}
	
	function restoreFocus(activeElement, container) {
	  // Focus back if is in the container
	  if (activeElement !== document.activeElement && (0, _contains2['default'])(container, activeElement)) {
	    activeElement.focus();
	  }
	}

/***/ },
/* 2636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _cssAnimation = __webpack_require__(487);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _animate = __webpack_require__(1070);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  (0, _inherits3['default'])(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    (0, _classCallCheck3['default'])(this, AnimateChild);
	    return (0, _possibleConstructorReturn3['default'])(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_animate2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_animate2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_animate2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = typeof transitionName === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return AnimateChild;
	}(_react2['default'].Component);
	
	AnimateChild.propTypes = {
	  children: _propTypes2['default'].any,
	  animation: _propTypes2['default'].any,
	  transitionName: _propTypes2['default'].any
	};
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ },
/* 2637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.genCSSMotionList = genCSSMotionList;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CSSMotion = __webpack_require__(553);
	
	var _CSSMotion2 = _interopRequireDefault(_CSSMotion);
	
	var _motion = __webpack_require__(1071);
	
	var _diff = __webpack_require__(2639);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MOTION_PROP_NAMES = Object.keys(_CSSMotion.MotionPropTypes);
	
	function genCSSMotionList(transitionSupport) {
	  var CSSMotion = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _CSSMotion2['default'];
	
	  var CSSMotionList = function (_React$Component) {
	    (0, _inherits3['default'])(CSSMotionList, _React$Component);
	
	    function CSSMotionList() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3['default'])(this, CSSMotionList);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = CSSMotionList.__proto__ || Object.getPrototypeOf(CSSMotionList)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	        keyEntities: []
	      }, _this.removeKey = function (removeKey) {
	        _this.setState(function (_ref2) {
	          var keyEntities = _ref2.keyEntities;
	          return {
	            keyEntities: keyEntities.map(function (entity) {
	              if (entity.key !== removeKey) return entity;
	              return (0, _extends3['default'])({}, entity, {
	                status: _diff.STATUS_REMOVED
	              });
	            })
	          };
	        });
	      }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	    }
	
	    (0, _createClass3['default'])(CSSMotionList, [{
	      key: 'render',
	      value: function render() {
	        var _this2 = this;
	
	        var keyEntities = this.state.keyEntities;
	        var _props = this.props,
	            component = _props.component,
	            children = _props.children,
	            restProps = (0, _objectWithoutProperties3['default'])(_props, ['component', 'children']);
	
	
	        var Component = component || _react2['default'].Fragment;
	
	        var motionProps = {};
	        MOTION_PROP_NAMES.forEach(function (prop) {
	          motionProps[prop] = restProps[prop];
	          delete restProps[prop];
	        });
	        delete restProps.keys;
	
	        return _react2['default'].createElement(
	          Component,
	          restProps,
	          keyEntities.map(function (_ref3) {
	            var status = _ref3.status,
	                eventProps = (0, _objectWithoutProperties3['default'])(_ref3, ['status']);
	
	            var visible = status === _diff.STATUS_ADD || status === _diff.STATUS_KEEP;
	            return _react2['default'].createElement(
	              CSSMotion,
	              (0, _extends3['default'])({}, motionProps, {
	                key: eventProps.key,
	                visible: visible,
	                eventProps: eventProps,
	                onLeaveEnd: function onLeaveEnd() {
	                  if (motionProps.onLeaveEnd) {
	                    motionProps.onLeaveEnd.apply(motionProps, arguments);
	                  }
	                  _this2.removeKey(eventProps.key);
	                }
	              }),
	              children
	            );
	          })
	        );
	      }
	    }], [{
	      key: 'getDerivedStateFromProps',
	      value: function getDerivedStateFromProps(_ref4, _ref5) {
	        var keys = _ref4.keys;
	        var keyEntities = _ref5.keyEntities;
	
	        var parsedKeyObjects = (0, _diff.parseKeys)(keys);
	
	        // Always as keep when motion not support
	        if (!transitionSupport) {
	          return {
	            keyEntities: parsedKeyObjects.map(function (obj) {
	              return (0, _extends3['default'])({}, obj, { status: _diff.STATUS_KEEP });
	            })
	          };
	        }
	
	        var mixedKeyEntities = (0, _diff.diffKeys)(keyEntities, parsedKeyObjects);
	
	        var keyEntitiesLen = keyEntities.length;
	        return {
	          keyEntities: mixedKeyEntities.filter(function (entity) {
	            // IE 9 not support Array.prototype.find
	            var prevEntity = null;
	            for (var i = 0; i < keyEntitiesLen; i += 1) {
	              var currentEntity = keyEntities[i];
	              if (currentEntity.key === entity.key) {
	                prevEntity = currentEntity;
	                break;
	              }
	            }
	
	            // Remove if already mark as removed
	            if (prevEntity && prevEntity.status === _diff.STATUS_REMOVED && entity.status === _diff.STATUS_REMOVE) {
	              return false;
	            }
	            return true;
	          })
	        };
	      }
	    }]);
	    return CSSMotionList;
	  }(_react2['default'].Component);
	
	  CSSMotionList.propTypes = (0, _extends3['default'])({}, CSSMotion.propTypes, {
	    component: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].bool]),
	    keys: _propTypes2['default'].array
	  });
	  CSSMotionList.defaultProps = {
	    component: 'div'
	  };
	
	
	  (0, _reactLifecyclesCompat.polyfill)(CSSMotionList);
	
	  return CSSMotionList;
	}
	
	exports['default'] = genCSSMotionList(_motion.supportTransition);

/***/ },
/* 2638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.toArrayChildren = toArrayChildren;
	exports.findChildInChildrenByKey = findChildInChildrenByKey;
	exports.findShownChildInChildrenByKey = findShownChildInChildrenByKey;
	exports.findHiddenChildInChildrenByKey = findHiddenChildInChildrenByKey;
	exports.isSameChildren = isSameChildren;
	exports.mergeChildren = mergeChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toArrayChildren(children) {
	  var ret = [];
	  _react2['default'].Children.forEach(children, function (child) {
	    ret.push(child);
	  });
	  return ret;
	}
	
	function findChildInChildrenByKey(children, key) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (ret) {
	        return;
	      }
	      if (child && child.key === key) {
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findShownChildInChildrenByKey(children, key, showProp) {
	  var ret = null;
	  if (children) {
	    children.forEach(function (child) {
	      if (child && child.key === key && child.props[showProp]) {
	        if (ret) {
	          throw new Error('two child with same key for <rc-animate> children');
	        }
	        ret = child;
	      }
	    });
	  }
	  return ret;
	}
	
	function findHiddenChildInChildrenByKey(children, key, showProp) {
	  var found = 0;
	  if (children) {
	    children.forEach(function (child) {
	      if (found) {
	        return;
	      }
	      found = child && child.key === key && !child.props[showProp];
	    });
	  }
	  return found;
	}
	
	function isSameChildren(c1, c2, showProp) {
	  var same = c1.length === c2.length;
	  if (same) {
	    c1.forEach(function (child, index) {
	      var child2 = c2[index];
	      if (child && child2) {
	        if (child && !child2 || !child && child2) {
	          same = false;
	        } else if (child.key !== child2.key) {
	          same = false;
	        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
	          same = false;
	        }
	      }
	    });
	  }
	  return same;
	}
	
	function mergeChildren(prev, next) {
	  var ret = [];
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextChildrenPending = {};
	  var pendingChildren = [];
	  prev.forEach(function (child) {
	    if (child && findChildInChildrenByKey(next, child.key)) {
	      if (pendingChildren.length) {
	        nextChildrenPending[child.key] = pendingChildren;
	        pendingChildren = [];
	      }
	    } else {
	      pendingChildren.push(child);
	    }
	  });
	
	  next.forEach(function (child) {
	    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
	      ret = ret.concat(nextChildrenPending[child.key]);
	    }
	    ret.push(child);
	  });
	
	  ret = ret.concat(pendingChildren);
	
	  return ret;
	}

/***/ },
/* 2639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.STATUS_REMOVED = exports.STATUS_REMOVE = exports.STATUS_KEEP = exports.STATUS_ADD = undefined;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports.wrapKeyToObject = wrapKeyToObject;
	exports.parseKeys = parseKeys;
	exports.diffKeys = diffKeys;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var STATUS_ADD = exports.STATUS_ADD = 'add';
	var STATUS_KEEP = exports.STATUS_KEEP = 'keep';
	var STATUS_REMOVE = exports.STATUS_REMOVE = 'remove';
	var STATUS_REMOVED = exports.STATUS_REMOVED = 'removed';
	
	function wrapKeyToObject(key) {
	  var keyObj = void 0;
	  if (key && typeof key === 'object' && 'key' in key) {
	    keyObj = key;
	  } else {
	    keyObj = { key: key };
	  }
	  return (0, _extends3['default'])({}, keyObj, {
	    key: String(keyObj.key)
	  });
	}
	
	function parseKeys() {
	  var keys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	
	  return keys.map(wrapKeyToObject);
	}
	
	function diffKeys() {
	  var prevKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var currentKeys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  var list = [];
	  var currentIndex = 0;
	  var currentLen = currentKeys.length;
	
	  var prevKeyObjects = parseKeys(prevKeys);
	  var currentKeyObjects = parseKeys(currentKeys);
	
	  // Check prev keys to insert or keep
	  prevKeyObjects.forEach(function (keyObj) {
	    var hit = false;
	
	    for (var i = currentIndex; i < currentLen; i += 1) {
	      var currentKeyObj = currentKeyObjects[i];
	      if (currentKeyObj.key === keyObj.key) {
	        // New added keys should add before current key
	        if (currentIndex < i) {
	          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function (obj) {
	            return (0, _extends3['default'])({}, obj, { status: STATUS_ADD });
	          }));
	          currentIndex = i;
	        }
	        list.push((0, _extends3['default'])({}, currentKeyObj, {
	          status: STATUS_KEEP
	        }));
	        currentIndex += 1;
	
	        hit = true;
	        break;
	      }
	    }
	
	    // If not hit, it means key is removed
	    if (!hit) {
	      list.push((0, _extends3['default'])({}, keyObj, {
	        status: STATUS_REMOVE
	      }));
	    }
	  });
	
	  // Add rest to the list
	  if (currentIndex < currentLen) {
	    list = list.concat(currentKeyObjects.slice(currentIndex).map(function (obj) {
	      return (0, _extends3['default'])({}, obj, { status: STATUS_ADD });
	    }));
	  }
	
	  /**
	   * Merge same key when it remove and add again:
	   *    [1 - add, 2 - keep, 1 - remove] -> [1 - keep, 2 - keep]
	   */
	  var keys = {};
	  list.forEach(function (_ref) {
	    var key = _ref.key;
	
	    keys[key] = (keys[key] || 0) + 1;
	  });
	  var duplicatedKeys = Object.keys(keys).filter(function (key) {
	    return keys[key] > 1;
	  });
	  duplicatedKeys.forEach(function (matchKey) {
	    // Remove `STATUS_REMOVE` node.
	    list = list.filter(function (_ref2) {
	      var key = _ref2.key,
	          status = _ref2.status;
	      return key !== matchKey || status !== STATUS_REMOVE;
	    });
	
	    // Update `STATUS_ADD` to `STATUS_KEEP`
	    list.forEach(function (node) {
	      if (node.key === matchKey) {
	        node.status = STATUS_KEEP;
	      }
	    });
	  });
	
	  return list;
	}

/***/ },
/* 2640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(71);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _DateTable = __webpack_require__(556);
	
	var _DateTable2 = _interopRequireDefault(_DateTable);
	
	var _CalendarHeader = __webpack_require__(555);
	
	var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	var _CalendarFooter = __webpack_require__(1073);
	
	var _CalendarFooter2 = _interopRequireDefault(_CalendarFooter);
	
	var _CalendarMixin = __webpack_require__(557);
	
	var _CommonMixin = __webpack_require__(382);
	
	var _DateInput = __webpack_require__(1078);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _util = __webpack_require__(162);
	
	var _toTime = __webpack_require__(1082);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	var getMomentObjectIfValid = function getMomentObjectIfValid(date) {
	  if (_moment2['default'].isMoment(date) && date.isValid()) {
	    return date;
	  }
	  return false;
	};
	
	var Calendar = function (_React$Component) {
	  (0, _inherits3['default'])(Calendar, _React$Component);
	
	  function Calendar(props) {
	    (0, _classCallCheck3['default'])(this, Calendar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      mode: _this.props.mode || 'date',
	      value: getMomentObjectIfValid(props.value) || getMomentObjectIfValid(props.defaultValue) || (0, _moment2['default'])(),
	      selectedValue: props.selectedValue || props.defaultSelectedValue
	    };
	    return _this;
	  }
	
	  Calendar.prototype.componentDidMount = function componentDidMount() {
	    if (this.props.showDateInput) {
	      this.saveFocusElement(_DateInput2['default'].getInstance());
	    }
	  };
	
	  Calendar.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
	    var value = nextProps.value,
	        selectedValue = nextProps.selectedValue;
	
	    var newState = {};
	
	    if ('mode' in nextProps && state.mode !== nextProps.mode) {
	      newState = { mode: nextProps.mode };
	    }
	    if ('value' in nextProps) {
	      newState.value = getMomentObjectIfValid(value) || getMomentObjectIfValid(nextProps.defaultValue) || (0, _CalendarMixin.getNowByCurrentStateValue)(state.value);
	    }
	    if ('selectedValue' in nextProps) {
	      newState.selectedValue = selectedValue;
	    }
	
	    return newState;
	  };
	
	  Calendar.prototype.render = function render() {
	    var props = this.props,
	        state = this.state;
	    var locale = props.locale,
	        prefixCls = props.prefixCls,
	        disabledDate = props.disabledDate,
	        dateInputPlaceholder = props.dateInputPlaceholder,
	        timePicker = props.timePicker,
	        disabledTime = props.disabledTime,
	        clearIcon = props.clearIcon,
	        renderFooter = props.renderFooter,
	        inputMode = props.inputMode,
	        monthCellRender = props.monthCellRender,
	        monthCellContentRender = props.monthCellContentRender;
	    var value = state.value,
	        selectedValue = state.selectedValue,
	        mode = state.mode;
	
	    var showTimePicker = mode === 'time';
	    var disabledTimeConfig = showTimePicker && disabledTime && timePicker ? (0, _util.getTimeConfig)(selectedValue, disabledTime) : null;
	
	    var timePickerEle = null;
	
	    if (timePicker && showTimePicker) {
	      var timePickerProps = (0, _extends3['default'])({
	        showHour: true,
	        showSecond: true,
	        showMinute: true
	      }, timePicker.props, disabledTimeConfig, {
	        onChange: this.onDateInputChange,
	        value: selectedValue,
	        disabledTime: disabledTime
	      });
	
	      if (timePicker.props.defaultValue !== undefined) {
	        timePickerProps.defaultOpenValue = timePicker.props.defaultValue;
	      }
	
	      timePickerEle = _react2['default'].cloneElement(timePicker, timePickerProps);
	    }
	
	    var dateInputElement = props.showDateInput ? _react2['default'].createElement(_DateInput2['default'], {
	      format: this.getFormat(),
	      key: 'date-input',
	      value: value,
	      locale: locale,
	      placeholder: dateInputPlaceholder,
	      showClear: true,
	      disabledTime: disabledTime,
	      disabledDate: disabledDate,
	      onClear: this.onClear,
	      prefixCls: prefixCls,
	      selectedValue: selectedValue,
	      onChange: this.onDateInputChange,
	      onSelect: this.onDateInputSelect,
	      clearIcon: clearIcon,
	      inputMode: inputMode
	    }) : null;
	
	    var children = [];
	    if (props.renderSidebar) {
	      children.push(props.renderSidebar());
	    }
	    children.push(_react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-panel', key: 'panel' },
	      dateInputElement,
	      _react2['default'].createElement(
	        'div',
	        {
	          tabIndex: this.props.focusablePanel ? 0 : undefined,
	          className: prefixCls + '-date-panel'
	        },
	        _react2['default'].createElement(_CalendarHeader2['default'], {
	          locale: locale,
	          mode: mode,
	          value: value,
	          onValueChange: this.setValue,
	          onPanelChange: this.onPanelChange,
	          renderFooter: renderFooter,
	          showTimePicker: showTimePicker,
	          prefixCls: prefixCls,
	          monthCellRender: monthCellRender,
	          monthCellContentRender: monthCellContentRender
	        }),
	        timePicker && showTimePicker ? _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-time-picker' },
	          _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-time-picker-panel' },
	            timePickerEle
	          )
	        ) : null,
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-body' },
	          _react2['default'].createElement(_DateTable2['default'], {
	            locale: locale,
	            value: value,
	            selectedValue: selectedValue,
	            prefixCls: prefixCls,
	            dateRender: props.dateRender,
	            onSelect: this.onDateTableSelect,
	            disabledDate: disabledDate,
	            showWeekNumber: props.showWeekNumber
	          })
	        ),
	        _react2['default'].createElement(_CalendarFooter2['default'], {
	          showOk: props.showOk,
	          mode: mode,
	          renderFooter: props.renderFooter,
	          locale: locale,
	          prefixCls: prefixCls,
	          showToday: props.showToday,
	          disabledTime: disabledTime,
	          showTimePicker: showTimePicker,
	          showDateInput: props.showDateInput,
	          timePicker: timePicker,
	          selectedValue: selectedValue,
	          timePickerDisabled: !selectedValue,
	          value: value,
	          disabledDate: disabledDate,
	          okDisabled: props.showOk !== false && (!selectedValue || !this.isAllowedDate(selectedValue)),
	          onOk: this.onOk,
	          onSelect: this.onSelect,
	          onToday: this.onToday,
	          onOpenTimePicker: this.openTimePicker,
	          onCloseTimePicker: this.closeTimePicker
	        })
	      )
	    ));
	
	    return this.renderRoot({
	      children: children,
	      className: props.showWeekNumber ? prefixCls + '-week-number' : ''
	    });
	  };
	
	  return Calendar;
	}(_react2['default'].Component);
	
	Calendar.propTypes = (0, _extends3['default'])({}, _CalendarMixin.calendarMixinPropTypes, _CommonMixin.propType, {
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  defaultValue: _propTypes2['default'].object,
	  value: _propTypes2['default'].object,
	  selectedValue: _propTypes2['default'].object,
	  defaultSelectedValue: _propTypes2['default'].object,
	  mode: _propTypes2['default'].oneOf(['time', 'date', 'month', 'year', 'decade']),
	  locale: _propTypes2['default'].object,
	  showDateInput: _propTypes2['default'].bool,
	  showWeekNumber: _propTypes2['default'].bool,
	  showToday: _propTypes2['default'].bool,
	  showOk: _propTypes2['default'].bool,
	  onSelect: _propTypes2['default'].func,
	  onOk: _propTypes2['default'].func,
	  onKeyDown: _propTypes2['default'].func,
	  timePicker: _propTypes2['default'].element,
	  dateInputPlaceholder: _propTypes2['default'].any,
	  onClear: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  onPanelChange: _propTypes2['default'].func,
	  disabledDate: _propTypes2['default'].func,
	  disabledTime: _propTypes2['default'].any,
	  dateRender: _propTypes2['default'].func,
	  renderFooter: _propTypes2['default'].func,
	  renderSidebar: _propTypes2['default'].func,
	  clearIcon: _propTypes2['default'].node,
	  focusablePanel: _propTypes2['default'].bool,
	  inputMode: _propTypes2['default'].string,
	  onBlur: _propTypes2['default'].func
	});
	Calendar.defaultProps = (0, _extends3['default'])({}, _CalendarMixin.calendarMixinDefaultProps, _CommonMixin.defaultProp, {
	  showToday: true,
	  showDateInput: true,
	  timePicker: null,
	  onOk: noop,
	  onPanelChange: noop,
	  focusablePanel: true
	});
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onPanelChange = function (value, mode) {
	    var props = _this2.props,
	        state = _this2.state;
	
	    if (!('mode' in props)) {
	      _this2.setState({ mode: mode });
	    }
	    props.onPanelChange(value || state.value, mode);
	  };
	
	  this.onKeyDown = function (event) {
	    if (event.target.nodeName.toLowerCase() === 'input') {
	      return undefined;
	    }
	    var keyCode = event.keyCode;
	    // mac
	    var ctrlKey = event.ctrlKey || event.metaKey;
	    var disabledDate = _this2.props.disabledDate;
	    var value = _this2.state.value;
	
	    switch (keyCode) {
	      case _KeyCode2['default'].DOWN:
	        _this2.goTime(1, 'weeks');
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].UP:
	        _this2.goTime(-1, 'weeks');
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].LEFT:
	        if (ctrlKey) {
	          _this2.goTime(-1, 'years');
	        } else {
	          _this2.goTime(-1, 'days');
	        }
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].RIGHT:
	        if (ctrlKey) {
	          _this2.goTime(1, 'years');
	        } else {
	          _this2.goTime(1, 'days');
	        }
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].HOME:
	        _this2.setValue((0, _toTime.goStartMonth)(_this2.state.value));
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].END:
	        _this2.setValue((0, _toTime.goEndMonth)(_this2.state.value));
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].PAGE_DOWN:
	        _this2.goTime(1, 'month');
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].PAGE_UP:
	        _this2.goTime(-1, 'month');
	        event.preventDefault();
	        return 1;
	      case _KeyCode2['default'].ENTER:
	        if (!disabledDate || !disabledDate(value)) {
	          _this2.onSelect(value, {
	            source: 'keyboard'
	          });
	        }
	        event.preventDefault();
	        return 1;
	      default:
	        _this2.props.onKeyDown(event);
	        return 1;
	    }
	  };
	
	  this.onClear = function () {
	    _this2.onSelect(null);
	    _this2.props.onClear();
	  };
	
	  this.onOk = function () {
	    var selectedValue = _this2.state.selectedValue;
	
	    if (_this2.isAllowedDate(selectedValue)) {
	      _this2.props.onOk(selectedValue);
	    }
	  };
	
	  this.onDateInputChange = function (value) {
	    _this2.onSelect(value, {
	      source: 'dateInput'
	    });
	  };
	
	  this.onDateInputSelect = function (value) {
	    _this2.onSelect(value, {
	      source: 'dateInputSelect'
	    });
	  };
	
	  this.onDateTableSelect = function (value) {
	    var timePicker = _this2.props.timePicker;
	    var selectedValue = _this2.state.selectedValue;
	
	    if (!selectedValue && timePicker) {
	      var timePickerDefaultValue = timePicker.props.defaultValue;
	      if (timePickerDefaultValue) {
	        (0, _util.syncTime)(timePickerDefaultValue, value);
	      }
	    }
	    _this2.onSelect(value);
	  };
	
	  this.onToday = function () {
	    var value = _this2.state.value;
	
	    var now = (0, _util.getTodayTime)(value);
	    _this2.onSelect(now, {
	      source: 'todayButton'
	    });
	  };
	
	  this.onBlur = function (event) {
	    setTimeout(function () {
	      var dateInput = _DateInput2['default'].getInstance();
	      var rootInstance = _this2.rootInstance;
	
	      if (!rootInstance || rootInstance.contains(document.activeElement) || dateInput && dateInput.contains(document.activeElement)) {
	        // focused element is still part of Calendar
	        return;
	      }
	
	      if (_this2.props.onBlur) {
	        _this2.props.onBlur(event);
	      }
	    }, 0);
	  };
	
	  this.getRootDOMNode = function () {
	    return _reactDom2['default'].findDOMNode(_this2);
	  };
	
	  this.openTimePicker = function () {
	    _this2.onPanelChange(null, 'time');
	  };
	
	  this.closeTimePicker = function () {
	    _this2.onPanelChange(null, 'date');
	  };
	
	  this.goTime = function (direction, unit) {
	    _this2.setValue((0, _toTime.goTime)(_this2.state.value, direction, unit));
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Calendar);
	
	exports['default'] = (0, _CalendarMixin.calendarMixinWrapper)((0, _CommonMixin.commonMixinWrapper)(Calendar));
	module.exports = exports['default'];

/***/ },
/* 2641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _DateTable = __webpack_require__(556);
	
	var _DateTable2 = _interopRequireDefault(_DateTable);
	
	var _MonthTable = __webpack_require__(1081);
	
	var _MonthTable2 = _interopRequireDefault(_MonthTable);
	
	var _CalendarMixin = __webpack_require__(557);
	
	var _CommonMixin = __webpack_require__(382);
	
	var _CalendarHeader = __webpack_require__(2646);
	
	var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var FullCalendar = function (_React$Component) {
	  (0, _inherits3['default'])(FullCalendar, _React$Component);
	
	  function FullCalendar(props) {
	    (0, _classCallCheck3['default'])(this, FullCalendar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var type = void 0;
	    if ('type' in props) {
	      type = props.type;
	    } else {
	      type = props.defaultType;
	    }
	
	    _this.state = {
	      type: type,
	      value: props.value || props.defaultValue || (0, _moment2['default'])(),
	      selectedValue: props.selectedValue || props.defaultSelectedValue
	    };
	    return _this;
	  }
	
	  FullCalendar.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
	    var newState = {};
	    var value = nextProps.value,
	        selectedValue = nextProps.selectedValue;
	
	
	    if ('type' in nextProps) {
	      newState = {
	        type: nextProps.type
	      };
	    }
	    if ('value' in nextProps) {
	      newState.value = value || nextProps.defaultValue || (0, _CalendarMixin.getNowByCurrentStateValue)(state.value);
	    }
	    if ('selectedValue' in nextProps) {
	      newState.selectedValue = selectedValue;
	    }
	
	    return newState;
	  };
	
	  FullCalendar.prototype.render = function render() {
	    var props = this.props;
	    var locale = props.locale,
	        prefixCls = props.prefixCls,
	        fullscreen = props.fullscreen,
	        showHeader = props.showHeader,
	        headerComponent = props.headerComponent,
	        headerRender = props.headerRender,
	        disabledDate = props.disabledDate;
	    var _state = this.state,
	        value = _state.value,
	        type = _state.type;
	
	
	    var header = null;
	    if (showHeader) {
	      if (headerRender) {
	        header = headerRender(value, type, locale);
	      } else {
	        var TheHeader = headerComponent || _CalendarHeader2['default'];
	        header = _react2['default'].createElement(TheHeader, (0, _extends3['default'])({
	          key: 'calendar-header'
	        }, props, {
	          prefixCls: prefixCls + '-full',
	          type: type,
	          value: value,
	          onTypeChange: this.setType,
	          onValueChange: this.setValue
	        }));
	      }
	    }
	
	    var table = type === 'date' ? _react2['default'].createElement(_DateTable2['default'], {
	      dateRender: props.dateCellRender,
	      contentRender: props.dateCellContentRender,
	      locale: locale,
	      prefixCls: prefixCls,
	      onSelect: this.onSelect,
	      value: value,
	      disabledDate: disabledDate
	    }) : _react2['default'].createElement(_MonthTable2['default'], {
	      cellRender: props.monthCellRender,
	      contentRender: props.monthCellContentRender,
	      locale: locale,
	      onSelect: this.onMonthSelect,
	      prefixCls: prefixCls + '-month-panel',
	      value: value,
	      disabledDate: disabledDate
	    });
	
	    var children = [header, _react2['default'].createElement(
	      'div',
	      { key: 'calendar-body', className: prefixCls + '-calendar-body' },
	      table
	    )];
	
	    var className = [prefixCls + '-full'];
	
	    if (fullscreen) {
	      className.push(prefixCls + '-fullscreen');
	    }
	
	    return this.renderRoot({
	      children: children,
	      className: className.join(' ')
	    });
	  };
	
	  return FullCalendar;
	}(_react2['default'].Component);
	
	FullCalendar.propTypes = (0, _extends3['default'])({}, _CalendarMixin.calendarMixinPropTypes, _CommonMixin.propType, {
	  defaultType: _propTypes2['default'].string,
	  type: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  locale: _propTypes2['default'].object,
	  onTypeChange: _propTypes2['default'].func,
	  fullscreen: _propTypes2['default'].bool,
	  monthCellRender: _propTypes2['default'].func,
	  dateCellRender: _propTypes2['default'].func,
	  showTypeSwitch: _propTypes2['default'].bool,
	  Select: _propTypes2['default'].func.isRequired,
	  headerComponents: _propTypes2['default'].array,
	  headerComponent: _propTypes2['default'].object, // The whole header component
	  headerRender: _propTypes2['default'].func,
	  showHeader: _propTypes2['default'].bool,
	  disabledDate: _propTypes2['default'].func,
	  value: _propTypes2['default'].object,
	  defaultValue: _propTypes2['default'].object,
	  selectedValue: _propTypes2['default'].object,
	  defaultSelectedValue: _propTypes2['default'].object
	});
	FullCalendar.defaultProps = (0, _extends3['default'])({}, _CalendarMixin.calendarMixinDefaultProps, _CommonMixin.defaultProp, {
	  defaultType: 'date',
	  fullscreen: false,
	  showTypeSwitch: true,
	  showHeader: true,
	  onTypeChange: function onTypeChange() {}
	});
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onMonthSelect = function (value) {
	    _this2.onSelect(value, {
	      target: 'month'
	    });
	  };
	
	  this.setType = function (type) {
	    if (!('type' in _this2.props)) {
	      _this2.setState({
	        type: type
	      });
	    }
	    _this2.props.onTypeChange(type);
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(FullCalendar);
	
	exports['default'] = (0, _CalendarMixin.calendarMixinWrapper)((0, _CommonMixin.commonMixinWrapper)(FullCalendar));
	module.exports = exports['default'];

/***/ },
/* 2642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _KeyCode = __webpack_require__(71);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _CalendarPart = __webpack_require__(2650);
	
	var _CalendarPart2 = _interopRequireDefault(_CalendarPart);
	
	var _TodayButton = __webpack_require__(1076);
	
	var _TodayButton2 = _interopRequireDefault(_TodayButton);
	
	var _OkButton = __webpack_require__(1074);
	
	var _OkButton2 = _interopRequireDefault(_OkButton);
	
	var _TimePickerButton = __webpack_require__(1075);
	
	var _TimePickerButton2 = _interopRequireDefault(_TimePickerButton);
	
	var _CommonMixin = __webpack_require__(382);
	
	var _util = __webpack_require__(162);
	
	var _toTime = __webpack_require__(1082);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function isEmptyArray(arr) {
	  return Array.isArray(arr) && (arr.length === 0 || arr.every(function (i) {
	    return !i;
	  }));
	}
	
	function isArraysEqual(a, b) {
	  if (a === b) return true;
	  if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
	    return false;
	  }
	  if (a.length !== b.length) return false;
	
	  for (var i = 0; i < a.length; ++i) {
	    if (a[i] !== b[i]) return false;
	  }
	  return true;
	}
	
	function getValueFromSelectedValue(selectedValue) {
	  var start = selectedValue[0],
	      end = selectedValue[1];
	
	  if (end && (start === undefined || start === null)) {
	    start = end.clone().subtract(1, 'month');
	  }
	
	  if (start && (end === undefined || end === null)) {
	    end = start.clone().add(1, 'month');
	  }
	  return [start, end];
	}
	
	function normalizeAnchor(props, init) {
	  var selectedValue = props.selectedValue || init && props.defaultSelectedValue;
	  var value = props.value || init && props.defaultValue;
	  var normalizedValue = value ? getValueFromSelectedValue(value) : getValueFromSelectedValue(selectedValue);
	  return !isEmptyArray(normalizedValue) ? normalizedValue : init && [(0, _moment2['default'])(), (0, _moment2['default'])().add(1, 'months')];
	}
	
	function generateOptions(length, extraOptionGen) {
	  var arr = extraOptionGen ? extraOptionGen().concat() : [];
	  for (var value = 0; value < length; value++) {
	    if (arr.indexOf(value) === -1) {
	      arr.push(value);
	    }
	  }
	  return arr;
	}
	
	function onInputSelect(direction, value, cause) {
	  if (!value) {
	    return;
	  }
	  var originalValue = this.state.selectedValue;
	  var selectedValue = originalValue.concat();
	  var index = direction === 'left' ? 0 : 1;
	  selectedValue[index] = value;
	  if (selectedValue[0] && this.compare(selectedValue[0], selectedValue[1]) > 0) {
	    selectedValue[1 - index] = this.state.showTimePicker ? selectedValue[index] : undefined;
	  }
	  this.props.onInputSelect(selectedValue);
	  this.fireSelectValueChange(selectedValue, null, cause || { source: 'dateInput' });
	}
	
	var RangeCalendar = function (_React$Component) {
	  (0, _inherits3['default'])(RangeCalendar, _React$Component);
	
	  function RangeCalendar(props) {
	    (0, _classCallCheck3['default'])(this, RangeCalendar);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var selectedValue = props.selectedValue || props.defaultSelectedValue;
	    var value = normalizeAnchor(props, 1);
	    _this.state = {
	      selectedValue: selectedValue,
	      prevSelectedValue: selectedValue,
	      firstSelectedValue: null,
	      hoverValue: props.hoverValue || [],
	      value: value,
	      showTimePicker: false,
	      mode: props.mode || ['date', 'date'],
	      panelTriggerSource: '' // Trigger by which picker panel: 'start' & 'end'
	    };
	    return _this;
	  }
	
	  RangeCalendar.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, state) {
	    var newState = {};
	    if ('value' in nextProps) {
	      newState.value = normalizeAnchor(nextProps, 0);
	    }
	    if ('hoverValue' in nextProps && !isArraysEqual(state.hoverValue, nextProps.hoverValue)) {
	      newState.hoverValue = nextProps.hoverValue;
	    }
	    if ('selectedValue' in nextProps) {
	      newState.selectedValue = nextProps.selectedValue;
	      newState.prevSelectedValue = nextProps.selectedValue;
	    }
	    if ('mode' in nextProps && !isArraysEqual(state.mode, nextProps.mode)) {
	      newState.mode = nextProps.mode;
	    }
	    return newState;
	  };
	
	  // get disabled hours for second picker
	
	
	  RangeCalendar.prototype.render = function render() {
	    var _className, _classnames;
	
	    var props = this.props,
	        state = this.state;
	    var prefixCls = props.prefixCls,
	        dateInputPlaceholder = props.dateInputPlaceholder,
	        seperator = props.seperator,
	        timePicker = props.timePicker,
	        showOk = props.showOk,
	        locale = props.locale,
	        showClear = props.showClear,
	        showToday = props.showToday,
	        type = props.type,
	        clearIcon = props.clearIcon;
	    var hoverValue = state.hoverValue,
	        selectedValue = state.selectedValue,
	        mode = state.mode,
	        showTimePicker = state.showTimePicker;
	
	    var className = (_className = {}, _className[props.className] = !!props.className, _className[prefixCls] = 1, _className[prefixCls + '-hidden'] = !props.visible, _className[prefixCls + '-range'] = 1, _className[prefixCls + '-show-time-picker'] = showTimePicker, _className[prefixCls + '-week-number'] = props.showWeekNumber, _className);
	    var classes = (0, _classnames3['default'])(className);
	    var newProps = {
	      selectedValue: state.selectedValue,
	      onSelect: this.onSelect,
	      onDayHover: type === 'start' && selectedValue[1] || type === 'end' && selectedValue[0] || !!hoverValue.length ? this.onDayHover : undefined
	    };
	
	    var placeholder1 = void 0;
	    var placeholder2 = void 0;
	
	    if (dateInputPlaceholder) {
	      if (Array.isArray(dateInputPlaceholder)) {
	        placeholder1 = dateInputPlaceholder[0];
	        placeholder2 = dateInputPlaceholder[1];
	      } else {
	        placeholder1 = placeholder2 = dateInputPlaceholder;
	      }
	    }
	    var showOkButton = showOk === true || showOk !== false && !!timePicker;
	    var cls = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-footer'] = true, _classnames[prefixCls + '-range-bottom'] = true, _classnames[prefixCls + '-footer-show-ok'] = showOkButton, _classnames));
	
	    var startValue = this.getStartValue();
	    var endValue = this.getEndValue();
	    var todayTime = (0, _util.getTodayTime)(startValue);
	    var thisMonth = todayTime.month();
	    var thisYear = todayTime.year();
	    var isTodayInView = startValue.year() === thisYear && startValue.month() === thisMonth || endValue.year() === thisYear && endValue.month() === thisMonth;
	    var nextMonthOfStart = startValue.clone().add(1, 'months');
	    var isClosestMonths = nextMonthOfStart.year() === endValue.year() && nextMonthOfStart.month() === endValue.month();
	
	    var extraFooter = props.renderFooter();
	
	    return _react2['default'].createElement(
	      'div',
	      {
	        ref: this.saveRoot,
	        className: classes,
	        style: props.style,
	        tabIndex: '0',
	        onKeyDown: this.onKeyDown
	      },
	      props.renderSidebar(),
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-panel' },
	        showClear && selectedValue[0] && selectedValue[1] ? _react2['default'].createElement(
	          'a',
	          {
	            role: 'button',
	            title: locale.clear,
	            onClick: this.clear
	          },
	          clearIcon || _react2['default'].createElement('span', { className: prefixCls + '-clear-btn' })
	        ) : null,
	        _react2['default'].createElement(
	          'div',
	          {
	            className: prefixCls + '-date-panel',
	            onMouseLeave: type !== 'both' ? this.onDatePanelLeave : undefined,
	            onMouseEnter: type !== 'both' ? this.onDatePanelEnter : undefined
	          },
	          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
	            hoverValue: hoverValue,
	            direction: 'left',
	            disabledTime: this.disabledStartTime,
	            disabledMonth: this.disabledStartMonth,
	            format: this.getFormat(),
	            value: startValue,
	            mode: mode[0],
	            placeholder: placeholder1,
	            onInputChange: this.onStartInputChange,
	            onInputSelect: this.onStartInputSelect,
	            onValueChange: this.onStartValueChange,
	            onPanelChange: this.onStartPanelChange,
	            showDateInput: this.props.showDateInput,
	            timePicker: timePicker,
	            showTimePicker: showTimePicker || mode[0] === 'time',
	            enablePrev: true,
	            enableNext: !isClosestMonths || this.isMonthYearPanelShow(mode[1]),
	            clearIcon: clearIcon
	          })),
	          _react2['default'].createElement(
	            'span',
	            { className: prefixCls + '-range-middle' },
	            seperator
	          ),
	          _react2['default'].createElement(_CalendarPart2['default'], (0, _extends3['default'])({}, props, newProps, {
	            hoverValue: hoverValue,
	            direction: 'right',
	            format: this.getFormat(),
	            timePickerDisabledTime: this.getEndDisableTime(),
	            placeholder: placeholder2,
	            value: endValue,
	            mode: mode[1],
	            onInputChange: this.onEndInputChange,
	            onInputSelect: this.onEndInputSelect,
	            onValueChange: this.onEndValueChange,
	            onPanelChange: this.onEndPanelChange,
	            showDateInput: this.props.showDateInput,
	            timePicker: timePicker,
	            showTimePicker: showTimePicker || mode[1] === 'time',
	            disabledTime: this.disabledEndTime,
	            disabledMonth: this.disabledEndMonth,
	            enablePrev: !isClosestMonths || this.isMonthYearPanelShow(mode[0]),
	            enableNext: true,
	            clearIcon: clearIcon
	          }))
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: cls },
	          showToday || props.timePicker || showOkButton || extraFooter ? _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-footer-btn' },
	            extraFooter,
	            showToday ? _react2['default'].createElement(_TodayButton2['default'], (0, _extends3['default'])({}, props, {
	              disabled: isTodayInView,
	              value: state.value[0],
	              onToday: this.onToday,
	              text: locale.backToToday
	            })) : null,
	            props.timePicker ? _react2['default'].createElement(_TimePickerButton2['default'], (0, _extends3['default'])({}, props, {
	              showTimePicker: showTimePicker || mode[0] === 'time' && mode[1] === 'time',
	              onOpenTimePicker: this.onOpenTimePicker,
	              onCloseTimePicker: this.onCloseTimePicker,
	              timePickerDisabled: !this.hasSelectedValue() || hoverValue.length
	            })) : null,
	            showOkButton ? _react2['default'].createElement(_OkButton2['default'], (0, _extends3['default'])({}, props, {
	              onOk: this.onOk,
	              okDisabled: !this.isAllowedDateAndTime(selectedValue) || !this.hasSelectedValue() || hoverValue.length
	            })) : null
	          ) : null
	        )
	      )
	    );
	  };
	
	  return RangeCalendar;
	}(_react2['default'].Component);
	
	RangeCalendar.propTypes = (0, _extends3['default'])({}, _CommonMixin.propType, {
	  prefixCls: _propTypes2['default'].string,
	  dateInputPlaceholder: _propTypes2['default'].any,
	  seperator: _propTypes2['default'].string,
	  defaultValue: _propTypes2['default'].any,
	  value: _propTypes2['default'].any,
	  hoverValue: _propTypes2['default'].any,
	  mode: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOf(['time', 'date', 'month', 'year', 'decade'])),
	  showDateInput: _propTypes2['default'].bool,
	  timePicker: _propTypes2['default'].any,
	  showOk: _propTypes2['default'].bool,
	  showToday: _propTypes2['default'].bool,
	  defaultSelectedValue: _propTypes2['default'].array,
	  selectedValue: _propTypes2['default'].array,
	  onOk: _propTypes2['default'].func,
	  showClear: _propTypes2['default'].bool,
	  locale: _propTypes2['default'].object,
	  onChange: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  onValueChange: _propTypes2['default'].func,
	  onHoverChange: _propTypes2['default'].func,
	  onPanelChange: _propTypes2['default'].func,
	  format: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  onClear: _propTypes2['default'].func,
	  type: _propTypes2['default'].any,
	  disabledDate: _propTypes2['default'].func,
	  disabledTime: _propTypes2['default'].func,
	  clearIcon: _propTypes2['default'].node,
	  onKeyDown: _propTypes2['default'].func
	});
	RangeCalendar.defaultProps = (0, _extends3['default'])({}, _CommonMixin.defaultProp, {
	  type: 'both',
	  seperator: '~',
	  defaultSelectedValue: [],
	  onValueChange: noop,
	  onHoverChange: noop,
	  onPanelChange: noop,
	  disabledTime: noop,
	  onInputSelect: noop,
	  showToday: true,
	  showDateInput: true
	});
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onDatePanelEnter = function () {
	    if (_this2.hasSelectedValue()) {
	      _this2.fireHoverValueChange(_this2.state.selectedValue.concat());
	    }
	  };
	
	  this.onDatePanelLeave = function () {
	    if (_this2.hasSelectedValue()) {
	      _this2.fireHoverValueChange([]);
	    }
	  };
	
	  this.onSelect = function (value) {
	    var type = _this2.props.type;
	    var _state = _this2.state,
	        selectedValue = _state.selectedValue,
	        prevSelectedValue = _state.prevSelectedValue,
	        firstSelectedValue = _state.firstSelectedValue;
	
	    var nextSelectedValue = void 0;
	    if (type === 'both') {
	      if (!firstSelectedValue) {
	        (0, _util.syncTime)(prevSelectedValue[0], value);
	        nextSelectedValue = [value];
	      } else if (_this2.compare(firstSelectedValue, value) < 0) {
	        (0, _util.syncTime)(prevSelectedValue[1], value);
	        nextSelectedValue = [firstSelectedValue, value];
	      } else {
	        (0, _util.syncTime)(prevSelectedValue[0], value);
	        (0, _util.syncTime)(prevSelectedValue[1], firstSelectedValue);
	        nextSelectedValue = [value, firstSelectedValue];
	      }
	    } else if (type === 'start') {
	      (0, _util.syncTime)(prevSelectedValue[0], value);
	      var endValue = selectedValue[1];
	      nextSelectedValue = endValue && _this2.compare(endValue, value) > 0 ? [value, endValue] : [value];
	    } else {
	      // type === 'end'
	      var startValue = selectedValue[0];
	      if (startValue && _this2.compare(startValue, value) <= 0) {
	        (0, _util.syncTime)(prevSelectedValue[1], value);
	        nextSelectedValue = [startValue, value];
	      } else {
	        (0, _util.syncTime)(prevSelectedValue[0], value);
	        nextSelectedValue = [value];
	      }
	    }
	
	    _this2.fireSelectValueChange(nextSelectedValue);
	  };
	
	  this.onKeyDown = function (event) {
	    if (event.target.nodeName.toLowerCase() === 'input') {
	      return;
	    }
	
	    var keyCode = event.keyCode;
	
	    var ctrlKey = event.ctrlKey || event.metaKey;
	
	    var _state2 = _this2.state,
	        selectedValue = _state2.selectedValue,
	        hoverValue = _state2.hoverValue,
	        firstSelectedValue = _state2.firstSelectedValue,
	        value = _state2.value;
	    var _props = _this2.props,
	        onKeyDown = _props.onKeyDown,
	        disabledDate = _props.disabledDate;
	
	    // Update last time of the picker
	
	    var updateHoverPoint = function updateHoverPoint(func) {
	      // Change hover to make focus in UI
	      var currentHoverTime = void 0;
	      var nextHoverTime = void 0;
	      var nextHoverValue = void 0;
	
	      if (!firstSelectedValue) {
	        currentHoverTime = hoverValue[0] || selectedValue[0] || value[0] || (0, _moment2['default'])();
	        nextHoverTime = func(currentHoverTime);
	        nextHoverValue = [nextHoverTime];
	        _this2.fireHoverValueChange(nextHoverValue);
	      } else {
	        if (hoverValue.length === 1) {
	          currentHoverTime = hoverValue[0].clone();
	          nextHoverTime = func(currentHoverTime);
	          nextHoverValue = _this2.onDayHover(nextHoverTime);
	        } else {
	          currentHoverTime = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
	          nextHoverTime = func(currentHoverTime);
	          nextHoverValue = _this2.onDayHover(nextHoverTime);
	        }
	      }
	
	      // Find origin hover time on value index
	      if (nextHoverValue.length >= 2) {
	        var miss = nextHoverValue.some(function (ht) {
	          return !(0, _toTime.includesTime)(value, ht, 'month');
	        });
	        if (miss) {
	          var newValue = nextHoverValue.slice().sort(function (t1, t2) {
	            return t1.valueOf() - t2.valueOf();
	          });
	          if (newValue[0].isSame(newValue[1], 'month')) {
	            newValue[1] = newValue[0].clone().add(1, 'month');
	          }
	          _this2.fireValueChange(newValue);
	        }
	      } else if (nextHoverValue.length === 1) {
	        // If only one value, let's keep the origin panel
	        var oriValueIndex = value.findIndex(function (time) {
	          return time.isSame(currentHoverTime, 'month');
	        });
	        if (oriValueIndex === -1) oriValueIndex = 0;
	
	        if (value.every(function (time) {
	          return !time.isSame(nextHoverTime, 'month');
	        })) {
	          var _newValue = value.slice();
	          _newValue[oriValueIndex] = nextHoverTime.clone();
	          _this2.fireValueChange(_newValue);
	        }
	      }
	
	      event.preventDefault();
	
	      return nextHoverTime;
	    };
	
	    switch (keyCode) {
	      case _KeyCode2['default'].DOWN:
	        updateHoverPoint(function (time) {
	          return (0, _toTime.goTime)(time, 1, 'weeks');
	        });
	        return;
	      case _KeyCode2['default'].UP:
	        updateHoverPoint(function (time) {
	          return (0, _toTime.goTime)(time, -1, 'weeks');
	        });
	        return;
	      case _KeyCode2['default'].LEFT:
	        if (ctrlKey) {
	          updateHoverPoint(function (time) {
	            return (0, _toTime.goTime)(time, -1, 'years');
	          });
	        } else {
	          updateHoverPoint(function (time) {
	            return (0, _toTime.goTime)(time, -1, 'days');
	          });
	        }
	        return;
	      case _KeyCode2['default'].RIGHT:
	        if (ctrlKey) {
	          updateHoverPoint(function (time) {
	            return (0, _toTime.goTime)(time, 1, 'years');
	          });
	        } else {
	          updateHoverPoint(function (time) {
	            return (0, _toTime.goTime)(time, 1, 'days');
	          });
	        }
	        return;
	      case _KeyCode2['default'].HOME:
	        updateHoverPoint(function (time) {
	          return (0, _toTime.goStartMonth)(time);
	        });
	        return;
	      case _KeyCode2['default'].END:
	        updateHoverPoint(function (time) {
	          return (0, _toTime.goEndMonth)(time);
	        });
	        return;
	      case _KeyCode2['default'].PAGE_DOWN:
	        updateHoverPoint(function (time) {
	          return (0, _toTime.goTime)(time, 1, 'month');
	        });
	        return;
	      case _KeyCode2['default'].PAGE_UP:
	        updateHoverPoint(function (time) {
	          return (0, _toTime.goTime)(time, -1, 'month');
	        });
	        return;
	      case _KeyCode2['default'].ENTER:
	        {
	          var lastValue = void 0;
	          if (hoverValue.length === 0) {
	            lastValue = updateHoverPoint(function (time) {
	              return time;
	            });
	          } else if (hoverValue.length === 1) {
	            lastValue = hoverValue[0];
	          } else {
	            lastValue = hoverValue[0].isSame(firstSelectedValue, 'day') ? hoverValue[1] : hoverValue[0];
	          }
	          if (lastValue && (!disabledDate || !disabledDate(lastValue))) {
	            _this2.onSelect(lastValue);
	          }
	          event.preventDefault();
	          return;
	        }
	      default:
	        if (onKeyDown) {
	          onKeyDown(event);
	        }
	    }
	  };
	
	  this.onDayHover = function (value) {
	    var hoverValue = [];
	    var _state3 = _this2.state,
	        selectedValue = _state3.selectedValue,
	        firstSelectedValue = _state3.firstSelectedValue;
	    var type = _this2.props.type;
	
	    if (type === 'start' && selectedValue[1]) {
	      hoverValue = _this2.compare(value, selectedValue[1]) < 0 ? [value, selectedValue[1]] : [value];
	    } else if (type === 'end' && selectedValue[0]) {
	      hoverValue = _this2.compare(value, selectedValue[0]) > 0 ? [selectedValue[0], value] : [];
	    } else {
	      if (!firstSelectedValue) {
	        if (_this2.state.hoverValue.length) {
	          _this2.setState({ hoverValue: [] });
	        }
	        return hoverValue;
	      }
	      hoverValue = _this2.compare(value, firstSelectedValue) < 0 ? [value, firstSelectedValue] : [firstSelectedValue, value];
	    }
	    _this2.fireHoverValueChange(hoverValue);
	
	    return hoverValue;
	  };
	
	  this.onToday = function () {
	    var startValue = (0, _util.getTodayTime)(_this2.state.value[0]);
	    var endValue = startValue.clone().add(1, 'months');
	    _this2.setState({ value: [startValue, endValue] });
	  };
	
	  this.onOpenTimePicker = function () {
	    _this2.setState({
	      showTimePicker: true
	    });
	  };
	
	  this.onCloseTimePicker = function () {
	    _this2.setState({
	      showTimePicker: false
	    });
	  };
	
	  this.onOk = function () {
	    var selectedValue = _this2.state.selectedValue;
	
	    if (_this2.isAllowedDateAndTime(selectedValue)) {
	      _this2.props.onOk(_this2.state.selectedValue);
	    }
	  };
	
	  this.onStartInputChange = function () {
	    for (var _len = arguments.length, oargs = Array(_len), _key = 0; _key < _len; _key++) {
	      oargs[_key] = arguments[_key];
	    }
	
	    var args = ['left'].concat(oargs);
	    return onInputSelect.apply(_this2, args);
	  };
	
	  this.onEndInputChange = function () {
	    for (var _len2 = arguments.length, oargs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      oargs[_key2] = arguments[_key2];
	    }
	
	    var args = ['right'].concat(oargs);
	    return onInputSelect.apply(_this2, args);
	  };
	
	  this.onStartInputSelect = function (value) {
	    var args = ['left', value, { source: 'dateInputSelect' }];
	    return onInputSelect.apply(_this2, args);
	  };
	
	  this.onEndInputSelect = function (value) {
	    var args = ['right', value, { source: 'dateInputSelect' }];
	    return onInputSelect.apply(_this2, args);
	  };
	
	  this.onStartValueChange = function (leftValue) {
	    var value = [].concat(_this2.state.value);
	    value[0] = leftValue;
	    return _this2.fireValueChange(value);
	  };
	
	  this.onEndValueChange = function (rightValue) {
	    var value = [].concat(_this2.state.value);
	    value[1] = rightValue;
	    return _this2.fireValueChange(value);
	  };
	
	  this.onStartPanelChange = function (value, mode) {
	    var props = _this2.props,
	        state = _this2.state;
	
	    var newMode = [mode, state.mode[1]];
	    var newState = {
	      panelTriggerSource: 'start'
	    };
	    if (!('mode' in props)) {
	      newState.mode = newMode;
	    }
	    _this2.setState(newState);
	    var newValue = [value || state.value[0], state.value[1]];
	    props.onPanelChange(newValue, newMode);
	  };
	
	  this.onEndPanelChange = function (value, mode) {
	    var props = _this2.props,
	        state = _this2.state;
	
	    var newMode = [state.mode[0], mode];
	    var newState = {
	      panelTriggerSource: 'end'
	    };
	    if (!('mode' in props)) {
	      newState.mode = newMode;
	    }
	    _this2.setState(newState);
	    var newValue = [state.value[0], value || state.value[1]];
	    props.onPanelChange(newValue, newMode);
	  };
	
	  this.getStartValue = function () {
	    var _state4 = _this2.state,
	        selectedValue = _state4.selectedValue,
	        showTimePicker = _state4.showTimePicker,
	        value = _state4.value,
	        mode = _state4.mode,
	        panelTriggerSource = _state4.panelTriggerSource;
	
	    var startValue = value[0];
	    // keep selectedTime when select date
	    if (selectedValue[0] && _this2.props.timePicker) {
	      startValue = startValue.clone();
	      (0, _util.syncTime)(selectedValue[0], startValue);
	    }
	    if (showTimePicker && selectedValue[0]) {
	      startValue = selectedValue[0];
	    }
	
	    // Adjust month if date not align
	    if (panelTriggerSource === 'end' && mode[0] === 'date' && mode[1] === 'date' && startValue.isSame(value[1], 'month')) {
	      startValue = startValue.clone().subtract(1, 'month');
	    }
	
	    return startValue;
	  };
	
	  this.getEndValue = function () {
	    var _state5 = _this2.state,
	        value = _state5.value,
	        selectedValue = _state5.selectedValue,
	        showTimePicker = _state5.showTimePicker,
	        mode = _state5.mode,
	        panelTriggerSource = _state5.panelTriggerSource;
	
	    var endValue = value[1] ? value[1].clone() : value[0].clone().add(1, 'month');
	    // keep selectedTime when select date
	    if (selectedValue[1] && _this2.props.timePicker) {
	      (0, _util.syncTime)(selectedValue[1], endValue);
	    }
	    if (showTimePicker) {
	      endValue = selectedValue[1] ? selectedValue[1] : _this2.getStartValue();
	    }
	
	    // Adjust month if date not align
	    if (!showTimePicker && panelTriggerSource !== 'end' && mode[0] === 'date' && mode[1] === 'date' && endValue.isSame(value[0], 'month')) {
	      endValue = endValue.clone().add(1, 'month');
	    }
	
	    return endValue;
	  };
	
	  this.getEndDisableTime = function () {
	    var _state6 = _this2.state,
	        selectedValue = _state6.selectedValue,
	        value = _state6.value;
	    var disabledTime = _this2.props.disabledTime;
	
	    var userSettingDisabledTime = disabledTime(selectedValue, 'end') || {};
	    var startValue = selectedValue && selectedValue[0] || value[0].clone();
	    // if startTime and endTime is same day..
	    // the second time picker will not able to pick time before first time picker
	    if (!selectedValue[1] || startValue.isSame(selectedValue[1], 'day')) {
	      var hours = startValue.hour();
	      var minutes = startValue.minute();
	      var second = startValue.second();
	      var _disabledHours = userSettingDisabledTime.disabledHours,
	          _disabledMinutes = userSettingDisabledTime.disabledMinutes,
	          _disabledSeconds = userSettingDisabledTime.disabledSeconds;
	
	      var oldDisabledMinutes = _disabledMinutes ? _disabledMinutes() : [];
	      var olddisabledSeconds = _disabledSeconds ? _disabledSeconds() : [];
	      _disabledHours = generateOptions(hours, _disabledHours);
	      _disabledMinutes = generateOptions(minutes, _disabledMinutes);
	      _disabledSeconds = generateOptions(second, _disabledSeconds);
	      return {
	        disabledHours: function disabledHours() {
	          return _disabledHours;
	        },
	        disabledMinutes: function disabledMinutes(hour) {
	          if (hour === hours) {
	            return _disabledMinutes;
	          }
	          return oldDisabledMinutes;
	        },
	        disabledSeconds: function disabledSeconds(hour, minute) {
	          if (hour === hours && minute === minutes) {
	            return _disabledSeconds;
	          }
	          return olddisabledSeconds;
	        }
	      };
	    }
	    return userSettingDisabledTime;
	  };
	
	  this.isAllowedDateAndTime = function (selectedValue) {
	    return (0, _util.isAllowedDate)(selectedValue[0], _this2.props.disabledDate, _this2.disabledStartTime) && (0, _util.isAllowedDate)(selectedValue[1], _this2.props.disabledDate, _this2.disabledEndTime);
	  };
	
	  this.isMonthYearPanelShow = function (mode) {
	    return ['month', 'year', 'decade'].indexOf(mode) > -1;
	  };
	
	  this.hasSelectedValue = function () {
	    var selectedValue = _this2.state.selectedValue;
	
	    return !!selectedValue[1] && !!selectedValue[0];
	  };
	
	  this.compare = function (v1, v2) {
	    if (_this2.props.timePicker) {
	      return v1.diff(v2);
	    }
	    return v1.diff(v2, 'days');
	  };
	
	  this.fireSelectValueChange = function (selectedValue, direct, cause) {
	    var timePicker = _this2.props.timePicker;
	    var prevSelectedValue = _this2.state.prevSelectedValue;
	
	    if (timePicker && timePicker.props.defaultValue) {
	      var timePickerDefaultValue = timePicker.props.defaultValue;
	      if (!prevSelectedValue[0] && selectedValue[0]) {
	        (0, _util.syncTime)(timePickerDefaultValue[0], selectedValue[0]);
	      }
	      if (!prevSelectedValue[1] && selectedValue[1]) {
	        (0, _util.syncTime)(timePickerDefaultValue[1], selectedValue[1]);
	      }
	    }
	
	    if (!('selectedValue' in _this2.props)) {
	      _this2.setState({
	        selectedValue: selectedValue
	      });
	    }
	
	    // 尚未选择过时间，直接输入的话
	    if (!_this2.state.selectedValue[0] || !_this2.state.selectedValue[1]) {
	      var startValue = selectedValue[0] || (0, _moment2['default'])();
	      var endValue = selectedValue[1] || startValue.clone().add(1, 'months');
	      _this2.setState({
	        selectedValue: selectedValue,
	        value: getValueFromSelectedValue([startValue, endValue])
	      });
	    }
	
	    if (selectedValue[0] && !selectedValue[1]) {
	      _this2.setState({ firstSelectedValue: selectedValue[0] });
	      _this2.fireHoverValueChange(selectedValue.concat());
	    }
	    _this2.props.onChange(selectedValue);
	    if (direct || selectedValue[0] && selectedValue[1]) {
	      _this2.setState({
	        prevSelectedValue: selectedValue,
	        firstSelectedValue: null
	      });
	      _this2.fireHoverValueChange([]);
	      _this2.props.onSelect(selectedValue, cause);
	    }
	  };
	
	  this.fireValueChange = function (value) {
	    var props = _this2.props;
	    if (!('value' in props)) {
	      _this2.setState({
	        value: value
	      });
	    }
	    props.onValueChange(value);
	  };
	
	  this.fireHoverValueChange = function (hoverValue) {
	    var props = _this2.props;
	    if (!('hoverValue' in props)) {
	      _this2.setState({ hoverValue: hoverValue });
	    }
	    props.onHoverChange(hoverValue);
	  };
	
	  this.clear = function () {
	    _this2.fireSelectValueChange([], true);
	    _this2.props.onClear();
	  };
	
	  this.disabledStartTime = function (time) {
	    return _this2.props.disabledTime(time, 'start');
	  };
	
	  this.disabledEndTime = function (time) {
	    return _this2.props.disabledTime(time, 'end');
	  };
	
	  this.disabledStartMonth = function (month) {
	    var value = _this2.state.value;
	
	    return month.isAfter(value[1], 'month');
	  };
	
	  this.disabledEndMonth = function (month) {
	    var value = _this2.state.value;
	
	    return month.isBefore(value[0], 'month');
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(RangeCalendar);
	
	exports['default'] = (0, _CommonMixin.commonMixinWrapper)(RangeCalendar);
	module.exports = exports['default'];

/***/ },
/* 2643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _DateConstants = __webpack_require__(1077);
	
	var _DateConstants2 = _interopRequireDefault(_DateConstants);
	
	var _util = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function isSameDay(one, two) {
	  return one && two && one.isSame(two, 'day');
	}
	
	function beforeCurrentMonthYear(current, today) {
	  if (current.year() < today.year()) {
	    return 1;
	  }
	  return current.year() === today.year() && current.month() < today.month();
	}
	
	function afterCurrentMonthYear(current, today) {
	  if (current.year() > today.year()) {
	    return 1;
	  }
	  return current.year() === today.year() && current.month() > today.month();
	}
	
	function getIdFromDate(date) {
	  return 'rc-calendar-' + date.year() + '-' + date.month() + '-' + date.date();
	}
	
	var DateTBody = function (_React$Component) {
	  (0, _inherits3['default'])(DateTBody, _React$Component);
	
	  function DateTBody() {
	    (0, _classCallCheck3['default'])(this, DateTBody);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DateTBody.prototype.render = function render() {
	    var props = this.props;
	    var contentRender = props.contentRender,
	        prefixCls = props.prefixCls,
	        selectedValue = props.selectedValue,
	        value = props.value,
	        showWeekNumber = props.showWeekNumber,
	        dateRender = props.dateRender,
	        disabledDate = props.disabledDate,
	        hoverValue = props.hoverValue;
	
	    var iIndex = void 0;
	    var jIndex = void 0;
	    var current = void 0;
	    var dateTable = [];
	    var today = (0, _util.getTodayTime)(value);
	    var cellClass = prefixCls + '-cell';
	    var weekNumberCellClass = prefixCls + '-week-number-cell';
	    var dateClass = prefixCls + '-date';
	    var todayClass = prefixCls + '-today';
	    var selectedClass = prefixCls + '-selected-day';
	    var selectedDateClass = prefixCls + '-selected-date'; // do not move with mouse operation
	    var selectedStartDateClass = prefixCls + '-selected-start-date';
	    var selectedEndDateClass = prefixCls + '-selected-end-date';
	    var inRangeClass = prefixCls + '-in-range-cell';
	    var lastMonthDayClass = prefixCls + '-last-month-cell';
	    var nextMonthDayClass = prefixCls + '-next-month-btn-day';
	    var disabledClass = prefixCls + '-disabled-cell';
	    var firstDisableClass = prefixCls + '-disabled-cell-first-of-row';
	    var lastDisableClass = prefixCls + '-disabled-cell-last-of-row';
	    var lastDayOfMonthClass = prefixCls + '-last-day-of-month';
	    var month1 = value.clone();
	    month1.date(1);
	    var day = month1.day();
	    var lastMonthDiffDay = (day + 7 - value.localeData().firstDayOfWeek()) % 7;
	    // calculate last month
	    var lastMonth1 = month1.clone();
	    lastMonth1.add(0 - lastMonthDiffDay, 'days');
	    var passed = 0;
	
	    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
	      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
	        current = lastMonth1;
	        if (passed) {
	          current = current.clone();
	          current.add(passed, 'days');
	        }
	        dateTable.push(current);
	        passed++;
	      }
	    }
	    var tableHtml = [];
	    passed = 0;
	
	    for (iIndex = 0; iIndex < _DateConstants2['default'].DATE_ROW_COUNT; iIndex++) {
	      var _cx;
	
	      var isCurrentWeek = void 0;
	      var weekNumberCell = void 0;
	      var isActiveWeek = false;
	      var dateCells = [];
	      if (showWeekNumber) {
	        weekNumberCell = _react2['default'].createElement(
	          'td',
	          {
	            key: dateTable[passed].week(),
	            role: 'gridcell',
	            className: weekNumberCellClass
	          },
	          dateTable[passed].week()
	        );
	      }
	      for (jIndex = 0; jIndex < _DateConstants2['default'].DATE_COL_COUNT; jIndex++) {
	        var next = null;
	        var last = null;
	        current = dateTable[passed];
	        if (jIndex < _DateConstants2['default'].DATE_COL_COUNT - 1) {
	          next = dateTable[passed + 1];
	        }
	        if (jIndex > 0) {
	          last = dateTable[passed - 1];
	        }
	        var cls = cellClass;
	        var disabled = false;
	        var selected = false;
	
	        if (isSameDay(current, today)) {
	          cls += ' ' + todayClass;
	          isCurrentWeek = true;
	        }
	
	        var isBeforeCurrentMonthYear = beforeCurrentMonthYear(current, value);
	        var isAfterCurrentMonthYear = afterCurrentMonthYear(current, value);
	
	        if (selectedValue && Array.isArray(selectedValue)) {
	          var rangeValue = hoverValue.length ? hoverValue : selectedValue;
	          if (!isBeforeCurrentMonthYear && !isAfterCurrentMonthYear) {
	            var startValue = rangeValue[0];
	            var endValue = rangeValue[1];
	            if (startValue) {
	              if (isSameDay(current, startValue)) {
	                selected = true;
	                isActiveWeek = true;
	                cls += ' ' + selectedStartDateClass;
	              }
	            }
	            if (startValue || endValue) {
	              if (isSameDay(current, endValue)) {
	                selected = true;
	                isActiveWeek = true;
	                cls += ' ' + selectedEndDateClass;
	              } else if ((startValue === null || startValue === undefined) && current.isBefore(endValue, 'day')) {
	                cls += ' ' + inRangeClass;
	              } else if ((endValue === null || endValue === undefined) && current.isAfter(startValue, 'day')) {
	                cls += ' ' + inRangeClass;
	              } else if (current.isAfter(startValue, 'day') && current.isBefore(endValue, 'day')) {
	                cls += ' ' + inRangeClass;
	              }
	            }
	          }
	        } else if (isSameDay(current, value)) {
	          // keyboard change value, highlight works
	          selected = true;
	          isActiveWeek = true;
	        }
	
	        if (isSameDay(current, selectedValue)) {
	          cls += ' ' + selectedDateClass;
	        }
	
	        if (isBeforeCurrentMonthYear) {
	          cls += ' ' + lastMonthDayClass;
	        }
	
	        if (isAfterCurrentMonthYear) {
	          cls += ' ' + nextMonthDayClass;
	        }
	
	        if (current.clone().endOf('month').date() === current.date()) {
	          cls += ' ' + lastDayOfMonthClass;
	        }
	
	        if (disabledDate) {
	          if (disabledDate(current, value)) {
	            disabled = true;
	
	            if (!last || !disabledDate(last, value)) {
	              cls += ' ' + firstDisableClass;
	            }
	
	            if (!next || !disabledDate(next, value)) {
	              cls += ' ' + lastDisableClass;
	            }
	          }
	        }
	
	        if (selected) {
	          cls += ' ' + selectedClass;
	        }
	
	        if (disabled) {
	          cls += ' ' + disabledClass;
	        }
	
	        var dateHtml = void 0;
	        if (dateRender) {
	          dateHtml = dateRender(current, value);
	        } else {
	          var content = contentRender ? contentRender(current, value) : current.date();
	          dateHtml = _react2['default'].createElement(
	            'div',
	            {
	              key: getIdFromDate(current),
	              className: dateClass,
	              'aria-selected': selected,
	              'aria-disabled': disabled
	            },
	            content
	          );
	        }
	
	        dateCells.push(_react2['default'].createElement(
	          'td',
	          {
	            key: passed,
	            onClick: disabled ? undefined : props.onSelect.bind(null, current),
	            onMouseEnter: disabled ? undefined : props.onDayHover && props.onDayHover.bind(null, current) || undefined,
	            role: 'gridcell',
	            title: (0, _util.getTitleString)(current),
	            className: cls
	          },
	          dateHtml
	        ));
	
	        passed++;
	      }
	
	      tableHtml.push(_react2['default'].createElement(
	        'tr',
	        {
	          key: iIndex,
	          role: 'row',
	          className: (0, _classnames2['default'])((_cx = {}, _cx[prefixCls + '-current-week'] = isCurrentWeek, _cx[prefixCls + '-active-week'] = isActiveWeek, _cx))
	        },
	        weekNumberCell,
	        dateCells
	      ));
	    }
	    return _react2['default'].createElement(
	      'tbody',
	      { className: prefixCls + '-tbody' },
	      tableHtml
	    );
	  };
	
	  return DateTBody;
	}(_react2['default'].Component);
	
	DateTBody.propTypes = {
	  contentRender: _propTypes2['default'].func,
	  dateRender: _propTypes2['default'].func,
	  disabledDate: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  selectedValue: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].arrayOf(_propTypes2['default'].object)]),
	  value: _propTypes2['default'].object,
	  hoverValue: _propTypes2['default'].any,
	  showWeekNumber: _propTypes2['default'].bool
	};
	DateTBody.defaultProps = {
	  hoverValue: []
	};
	exports['default'] = DateTBody;
	module.exports = exports['default'];

/***/ },
/* 2644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DateConstants = __webpack_require__(1077);
	
	var _DateConstants2 = _interopRequireDefault(_DateConstants);
	
	var _moment = __webpack_require__(3);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var DateTHead = function (_React$Component) {
	  (0, _inherits3['default'])(DateTHead, _React$Component);
	
	  function DateTHead() {
	    (0, _classCallCheck3['default'])(this, DateTHead);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  DateTHead.prototype.render = function render() {
	    var props = this.props;
	    var value = props.value;
	    var localeData = value.localeData();
	    var prefixCls = props.prefixCls;
	    var veryShortWeekdays = [];
	    var weekDays = [];
	    var firstDayOfWeek = localeData.firstDayOfWeek();
	    var showWeekNumberEl = void 0;
	    var now = (0, _moment2['default'])();
	    for (var dateColIndex = 0; dateColIndex < _DateConstants2['default'].DATE_COL_COUNT; dateColIndex++) {
	      var index = (firstDayOfWeek + dateColIndex) % _DateConstants2['default'].DATE_COL_COUNT;
	      now.day(index);
	      veryShortWeekdays[dateColIndex] = localeData.weekdaysMin(now);
	      weekDays[dateColIndex] = localeData.weekdaysShort(now);
	    }
	
	    if (props.showWeekNumber) {
	      showWeekNumberEl = _react2['default'].createElement(
	        'th',
	        {
	          role: 'columnheader',
	          className: prefixCls + '-column-header ' + prefixCls + '-week-number-header'
	        },
	        _react2['default'].createElement(
	          'span',
	          { className: prefixCls + '-column-header-inner' },
	          'x'
	        )
	      );
	    }
	    var weekDaysEls = weekDays.map(function (day, xindex) {
	      return _react2['default'].createElement(
	        'th',
	        {
	          key: xindex,
	          role: 'columnheader',
	          title: day,
	          className: prefixCls + '-column-header'
	        },
	        _react2['default'].createElement(
	          'span',
	          { className: prefixCls + '-column-header-inner' },
	          veryShortWeekdays[xindex]
	        )
	      );
	    });
	    return _react2['default'].createElement(
	      'thead',
	      null,
	      _react2['default'].createElement(
	        'tr',
	        { role: 'row' },
	        showWeekNumberEl,
	        weekDaysEls
	      )
	    );
	  };
	
	  return DateTHead;
	}(_react2['default'].Component);
	
	exports['default'] = DateTHead;
	module.exports = exports['default'];

/***/ },
/* 2645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROW = 4;
	var COL = 3;
	
	
	function goYear(direction) {
	  var next = this.state.value.clone();
	  next.add(direction, 'years');
	  this.setState({
	    value: next
	  });
	}
	
	function chooseDecade(year, event) {
	  var next = this.state.value.clone();
	  next.year(year);
	  next.month(this.state.value.month());
	  this.props.onSelect(next);
	  event.preventDefault();
	}
	
	var DecadePanel = function (_React$Component) {
	  (0, _inherits3['default'])(DecadePanel, _React$Component);
	
	  function DecadePanel(props) {
	    (0, _classCallCheck3['default'])(this, DecadePanel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.state = {
	      value: props.value || props.defaultValue
	    };
	
	    // bind methods
	    _this.prefixCls = props.rootPrefixCls + '-decade-panel';
	    _this.nextCentury = goYear.bind(_this, 100);
	    _this.previousCentury = goYear.bind(_this, -100);
	    return _this;
	  }
	
	  DecadePanel.prototype.render = function render() {
	    var _this2 = this;
	
	    var value = this.state.value;
	    var _props = this.props,
	        locale = _props.locale,
	        renderFooter = _props.renderFooter;
	
	    var currentYear = value.year();
	    var startYear = parseInt(currentYear / 100, 10) * 100;
	    var preYear = startYear - 10;
	    var endYear = startYear + 99;
	    var decades = [];
	    var index = 0;
	    var prefixCls = this.prefixCls;
	
	    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
	      decades[rowIndex] = [];
	      for (var colIndex = 0; colIndex < COL; colIndex++) {
	        var startDecade = preYear + index * 10;
	        var endDecade = preYear + index * 10 + 9;
	        decades[rowIndex][colIndex] = {
	          startDecade: startDecade,
	          endDecade: endDecade
	        };
	        index++;
	      }
	    }
	
	    var footer = renderFooter && renderFooter('decade');
	
	    var decadesEls = decades.map(function (row, decadeIndex) {
	      var tds = row.map(function (decadeData) {
	        var _classNameMap;
	
	        var dStartDecade = decadeData.startDecade;
	        var dEndDecade = decadeData.endDecade;
	        var isLast = dStartDecade < startYear;
	        var isNext = dEndDecade > endYear;
	        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = dStartDecade <= currentYear && currentYear <= dEndDecade, _classNameMap[prefixCls + '-last-century-cell'] = isLast, _classNameMap[prefixCls + '-next-century-cell'] = isNext, _classNameMap);
	        var content = dStartDecade + '-' + dEndDecade;
	        var clickHandler = void 0;
	        if (isLast) {
	          clickHandler = _this2.previousCentury;
	        } else if (isNext) {
	          clickHandler = _this2.nextCentury;
	        } else {
	          clickHandler = chooseDecade.bind(_this2, dStartDecade);
	        }
	        return _react2['default'].createElement(
	          'td',
	          {
	            key: dStartDecade,
	            onClick: clickHandler,
	            role: 'gridcell',
	            className: (0, _classnames2['default'])(classNameMap)
	          },
	          _react2['default'].createElement(
	            'a',
	            {
	              className: prefixCls + '-decade'
	            },
	            content
	          )
	        );
	      });
	      return _react2['default'].createElement(
	        'tr',
	        { key: decadeIndex, role: 'row' },
	        tds
	      );
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      { className: this.prefixCls },
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-header' },
	        _react2['default'].createElement('a', {
	          className: prefixCls + '-prev-century-btn',
	          role: 'button',
	          onClick: this.previousCentury,
	          title: locale.previousCentury
	        }),
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-century' },
	          startYear,
	          '-',
	          endYear
	        ),
	        _react2['default'].createElement('a', {
	          className: prefixCls + '-next-century-btn',
	          role: 'button',
	          onClick: this.nextCentury,
	          title: locale.nextCentury
	        })
	      ),
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-body' },
	        _react2['default'].createElement(
	          'table',
	          { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
	          _react2['default'].createElement(
	            'tbody',
	            { className: prefixCls + '-tbody' },
	            decadesEls
	          )
	        )
	      ),
	      footer && _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-footer' },
	        footer
	      )
	    );
	  };
	
	  return DecadePanel;
	}(_react2['default'].Component);
	
	exports['default'] = DecadePanel;
	
	
	DecadePanel.propTypes = {
	  locale: _propTypes2['default'].object,
	  value: _propTypes2['default'].object,
	  defaultValue: _propTypes2['default'].object,
	  rootPrefixCls: _propTypes2['default'].string,
	  renderFooter: _propTypes2['default'].func
	};
	
	DecadePanel.defaultProps = {
	  onSelect: function onSelect() {}
	};
	module.exports = exports['default'];

/***/ },
/* 2646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _util = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	var CalendarHeader = function (_Component) {
	  (0, _inherits3['default'])(CalendarHeader, _Component);
	
	  function CalendarHeader() {
	    (0, _classCallCheck3['default'])(this, CalendarHeader);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  CalendarHeader.prototype.onYearChange = function onYearChange(year) {
	    var newValue = this.props.value.clone();
	    newValue.year(parseInt(year, 10));
	    this.props.onValueChange(newValue);
	  };
	
	  CalendarHeader.prototype.onMonthChange = function onMonthChange(month) {
	    var newValue = this.props.value.clone();
	    newValue.month(parseInt(month, 10));
	    this.props.onValueChange(newValue);
	  };
	
	  CalendarHeader.prototype.yearSelectElement = function yearSelectElement(year) {
	    var _props = this.props,
	        yearSelectOffset = _props.yearSelectOffset,
	        yearSelectTotal = _props.yearSelectTotal,
	        prefixCls = _props.prefixCls,
	        Select = _props.Select;
	
	    var start = year - yearSelectOffset;
	    var end = start + yearSelectTotal;
	
	    var options = [];
	    for (var index = start; index < end; index++) {
	      options.push(_react2['default'].createElement(
	        Select.Option,
	        { key: '' + index },
	        index
	      ));
	    }
	    return _react2['default'].createElement(
	      Select,
	      {
	        className: prefixCls + '-header-year-select',
	        onChange: this.onYearChange.bind(this),
	        dropdownStyle: { zIndex: 2000 },
	        dropdownMenuStyle: { maxHeight: 250, overflow: 'auto', fontSize: 12 },
	        optionLabelProp: 'children',
	        value: String(year),
	        showSearch: false
	      },
	      options
	    );
	  };
	
	  CalendarHeader.prototype.monthSelectElement = function monthSelectElement(month) {
	    var props = this.props;
	    var t = props.value.clone();
	    var prefixCls = props.prefixCls;
	
	    var options = [];
	    var Select = props.Select;
	
	    for (var index = 0; index < 12; index++) {
	      t.month(index);
	      options.push(_react2['default'].createElement(
	        Select.Option,
	        { key: '' + index },
	        (0, _util.getMonthName)(t)
	      ));
	    }
	
	    return _react2['default'].createElement(
	      Select,
	      {
	        className: prefixCls + '-header-month-select',
	        dropdownStyle: { zIndex: 2000 },
	        dropdownMenuStyle: { maxHeight: 250, overflow: 'auto', overflowX: 'hidden', fontSize: 12 },
	        optionLabelProp: 'children',
	        value: String(month),
	        showSearch: false,
	        onChange: this.onMonthChange.bind(this)
	      },
	      options
	    );
	  };
	
	  CalendarHeader.prototype.changeTypeToDate = function changeTypeToDate() {
	    this.props.onTypeChange('date');
	  };
	
	  CalendarHeader.prototype.changeTypeToMonth = function changeTypeToMonth() {
	    this.props.onTypeChange('month');
	  };
	
	  CalendarHeader.prototype.render = function render() {
	    var _props2 = this.props,
	        value = _props2.value,
	        locale = _props2.locale,
	        prefixCls = _props2.prefixCls,
	        type = _props2.type,
	        showTypeSwitch = _props2.showTypeSwitch,
	        headerComponents = _props2.headerComponents;
	
	    var year = value.year();
	    var month = value.month();
	    var yearSelect = this.yearSelectElement(year);
	    var monthSelect = type === 'month' ? null : this.monthSelectElement(month);
	    var switchCls = prefixCls + '-header-switcher';
	    var typeSwitcher = showTypeSwitch ? _react2['default'].createElement(
	      'span',
	      { className: switchCls },
	      type === 'date' ? _react2['default'].createElement(
	        'span',
	        { className: switchCls + '-focus' },
	        locale.month
	      ) : _react2['default'].createElement(
	        'span',
	        {
	          onClick: this.changeTypeToDate.bind(this),
	          className: switchCls + '-normal'
	        },
	        locale.month
	      ),
	      type === 'month' ? _react2['default'].createElement(
	        'span',
	        { className: switchCls + '-focus' },
	        locale.year
	      ) : _react2['default'].createElement(
	        'span',
	        {
	          onClick: this.changeTypeToMonth.bind(this),
	          className: switchCls + '-normal'
	        },
	        locale.year
	      )
	    ) : null;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-header' },
	      typeSwitcher,
	      monthSelect,
	      yearSelect,
	      headerComponents
	    );
	  };
	
	  return CalendarHeader;
	}(_react.Component);
	
	CalendarHeader.propTypes = {
	  value: _propTypes2['default'].object,
	  locale: _propTypes2['default'].object,
	  yearSelectOffset: _propTypes2['default'].number,
	  yearSelectTotal: _propTypes2['default'].number,
	  onValueChange: _propTypes2['default'].func,
	  onTypeChange: _propTypes2['default'].func,
	  Select: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  type: _propTypes2['default'].string,
	  showTypeSwitch: _propTypes2['default'].bool,
	  headerComponents: _propTypes2['default'].array
	};
	CalendarHeader.defaultProps = {
	  yearSelectOffset: 10,
	  yearSelectTotal: 20,
	  onValueChange: noop,
	  onTypeChange: noop
	};
	
	exports['default'] = CalendarHeader;
	module.exports = exports['default'];

/***/ },
/* 2647 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  today: '今天',
	  now: '此刻',
	  backToToday: '返回今天',
	  ok: '确定',
	  timeSelect: '选择时间',
	  dateSelect: '选择日期',
	  weekSelect: '选择周',
	  clear: '清除',
	  month: '月',
	  year: '年',
	  previousMonth: '上个月 (翻页上键)',
	  nextMonth: '下个月 (翻页下键)',
	  monthSelect: '选择月份',
	  yearSelect: '选择年份',
	  decadeSelect: '选择年代',
	  yearFormat: 'YYYY年',
	  dayFormat: 'D日',
	  dateFormat: 'YYYY年M月D日',
	  dateTimeFormat: 'YYYY年M月D日 HH时mm分ss秒',
	  previousYear: '上一年 (Control键加左方向键)',
	  nextYear: '下一年 (Control键加右方向键)',
	  previousDecade: '上一年代',
	  nextDecade: '下一年代',
	  previousCentury: '上一世纪',
	  nextCentury: '下一世纪'
	};
	module.exports = exports['default'];

/***/ },
/* 2648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _MonthTable = __webpack_require__(1081);
	
	var _MonthTable2 = _interopRequireDefault(_MonthTable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function goYear(direction) {
	  this.props.changeYear(direction);
	}
	
	function noop() {}
	
	var MonthPanel = function (_React$Component) {
	  (0, _inherits3['default'])(MonthPanel, _React$Component);
	
	  function MonthPanel(props) {
	    (0, _classCallCheck3['default'])(this, MonthPanel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.setAndSelectValue = function (value) {
	      _this.setValue(value);
	      _this.props.onSelect(value);
	    };
	
	    _this.setValue = function (value) {
	      if ('value' in _this.props) {
	        _this.setState({
	          value: value
	        });
	      }
	    };
	
	    _this.nextYear = goYear.bind(_this, 1);
	    _this.previousYear = goYear.bind(_this, -1);
	    _this.prefixCls = props.rootPrefixCls + '-month-panel';
	
	    _this.state = {
	      value: props.value || props.defaultValue
	    };
	    return _this;
	  }
	
	  MonthPanel.getDerivedStateFromProps = function getDerivedStateFromProps(props) {
	    var newState = {};
	
	    if ('value' in props) {
	      newState = {
	        value: props.value
	      };
	    }
	
	    return newState;
	  };
	
	  MonthPanel.prototype.render = function render() {
	    var props = this.props;
	    var value = this.state.value;
	    var locale = props.locale,
	        cellRender = props.cellRender,
	        contentRender = props.contentRender,
	        renderFooter = props.renderFooter;
	
	    var year = value.year();
	    var prefixCls = this.prefixCls;
	
	    var footer = renderFooter && renderFooter('month');
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls, style: props.style },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-header' },
	          _react2['default'].createElement('a', {
	            className: prefixCls + '-prev-year-btn',
	            role: 'button',
	            onClick: this.previousYear,
	            title: locale.previousYear
	          }),
	          _react2['default'].createElement(
	            'a',
	            {
	              className: prefixCls + '-year-select',
	              role: 'button',
	              onClick: props.onYearPanelShow,
	              title: locale.yearSelect
	            },
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-year-select-content' },
	              year
	            ),
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-year-select-arrow' },
	              'x'
	            )
	          ),
	          _react2['default'].createElement('a', {
	            className: prefixCls + '-next-year-btn',
	            role: 'button',
	            onClick: this.nextYear,
	            title: locale.nextYear
	          })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-body' },
	          _react2['default'].createElement(_MonthTable2['default'], {
	            disabledDate: props.disabledDate,
	            onSelect: this.setAndSelectValue,
	            locale: locale,
	            value: value,
	            cellRender: cellRender,
	            contentRender: contentRender,
	            prefixCls: prefixCls
	          })
	        ),
	        footer && _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-footer' },
	          footer
	        )
	      )
	    );
	  };
	
	  return MonthPanel;
	}(_react2['default'].Component);
	
	MonthPanel.propTypes = {
	  onChange: _propTypes2['default'].func,
	  disabledDate: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  renderFooter: _propTypes2['default'].func,
	  rootPrefixCls: _propTypes2['default'].string,
	  value: _propTypes2['default'].object,
	  defaultValue: _propTypes2['default'].object
	};
	MonthPanel.defaultProps = {
	  onChange: noop,
	  onSelect: noop
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(MonthPanel);
	
	exports['default'] = MonthPanel;
	module.exports = exports['default'];

/***/ },
/* 2649 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = {
	  bottomLeft: {
	    points: ['tl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -3],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -3],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 3],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 3],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;
	module.exports = exports['default'];

/***/ },
/* 2650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _CalendarHeader = __webpack_require__(555);
	
	var _CalendarHeader2 = _interopRequireDefault(_CalendarHeader);
	
	var _DateTable = __webpack_require__(556);
	
	var _DateTable2 = _interopRequireDefault(_DateTable);
	
	var _DateInput = __webpack_require__(1078);
	
	var _DateInput2 = _interopRequireDefault(_DateInput);
	
	var _index = __webpack_require__(162);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var CalendarPart = function (_React$Component) {
	  (0, _inherits3['default'])(CalendarPart, _React$Component);
	
	  function CalendarPart() {
	    (0, _classCallCheck3['default'])(this, CalendarPart);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  CalendarPart.prototype.render = function render() {
	    var props = this.props;
	    var prefixCls = props.prefixCls,
	        value = props.value,
	        hoverValue = props.hoverValue,
	        selectedValue = props.selectedValue,
	        mode = props.mode,
	        direction = props.direction,
	        locale = props.locale,
	        format = props.format,
	        placeholder = props.placeholder,
	        disabledDate = props.disabledDate,
	        timePicker = props.timePicker,
	        disabledTime = props.disabledTime,
	        timePickerDisabledTime = props.timePickerDisabledTime,
	        showTimePicker = props.showTimePicker,
	        onInputChange = props.onInputChange,
	        onInputSelect = props.onInputSelect,
	        enablePrev = props.enablePrev,
	        enableNext = props.enableNext,
	        clearIcon = props.clearIcon,
	        showClear = props.showClear,
	        inputMode = props.inputMode;
	
	    var shouldShowTimePicker = showTimePicker && timePicker;
	    var disabledTimeConfig = shouldShowTimePicker && disabledTime ? (0, _index.getTimeConfig)(selectedValue, disabledTime) : null;
	    var rangeClassName = prefixCls + '-range';
	    var newProps = {
	      locale: locale,
	      value: value,
	      prefixCls: prefixCls,
	      showTimePicker: showTimePicker
	    };
	    var index = direction === 'left' ? 0 : 1;
	    var timePickerEle = shouldShowTimePicker && _react2['default'].cloneElement(timePicker, (0, _extends3['default'])({
	      showHour: true,
	      showMinute: true,
	      showSecond: true
	    }, timePicker.props, disabledTimeConfig, timePickerDisabledTime, {
	      onChange: onInputChange,
	      defaultOpenValue: value,
	      value: selectedValue[index]
	    }));
	
	    var dateInputElement = props.showDateInput && _react2['default'].createElement(_DateInput2['default'], {
	      format: format,
	      locale: locale,
	      prefixCls: prefixCls,
	      timePicker: timePicker,
	      disabledDate: disabledDate,
	      placeholder: placeholder,
	      disabledTime: disabledTime,
	      value: value,
	      showClear: showClear || false,
	      selectedValue: selectedValue[index],
	      onChange: onInputChange,
	      onSelect: onInputSelect,
	      clearIcon: clearIcon,
	      inputMode: inputMode
	    });
	
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: rangeClassName + '-part ' + rangeClassName + '-' + direction
	      },
	      dateInputElement,
	      _react2['default'].createElement(
	        'div',
	        { style: { outline: 'none' } },
	        _react2['default'].createElement(_CalendarHeader2['default'], (0, _extends3['default'])({}, newProps, {
	          mode: mode,
	          enableNext: enableNext,
	          enablePrev: enablePrev,
	          onValueChange: props.onValueChange,
	          onPanelChange: props.onPanelChange,
	          disabledMonth: props.disabledMonth
	        })),
	        showTimePicker ? _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-time-picker' },
	          _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-time-picker-panel' },
	            timePickerEle
	          )
	        ) : null,
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-body' },
	          _react2['default'].createElement(_DateTable2['default'], (0, _extends3['default'])({}, newProps, {
	            hoverValue: hoverValue,
	            selectedValue: selectedValue,
	            dateRender: props.dateRender,
	            onSelect: props.onSelect,
	            onDayHover: props.onDayHover,
	            disabledDate: disabledDate,
	            showWeekNumber: props.showWeekNumber
	          }))
	        )
	      )
	    );
	  };
	
	  return CalendarPart;
	}(_react2['default'].Component);
	
	CalendarPart.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  value: _propTypes2['default'].any,
	  hoverValue: _propTypes2['default'].any,
	  selectedValue: _propTypes2['default'].any,
	  direction: _propTypes2['default'].any,
	  locale: _propTypes2['default'].any,
	  showDateInput: _propTypes2['default'].bool,
	  showTimePicker: _propTypes2['default'].bool,
	  format: _propTypes2['default'].any,
	  placeholder: _propTypes2['default'].any,
	  disabledDate: _propTypes2['default'].any,
	  timePicker: _propTypes2['default'].any,
	  disabledTime: _propTypes2['default'].any,
	  onInputChange: _propTypes2['default'].func,
	  onInputSelect: _propTypes2['default'].func,
	  timePickerDisabledTime: _propTypes2['default'].object,
	  enableNext: _propTypes2['default'].any,
	  enablePrev: _propTypes2['default'].any,
	  clearIcon: _propTypes2['default'].node,
	  dateRender: _propTypes2['default'].func,
	  inputMode: _propTypes2['default'].string
	};
	exports['default'] = CalendarPart;
	module.exports = exports['default'];

/***/ },
/* 2651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ROW = 4;
	var COL = 3;
	
	function goYear(direction) {
	  var value = this.state.value.clone();
	  value.add(direction, 'year');
	  this.setState({
	    value: value
	  });
	}
	
	function chooseYear(year) {
	  var value = this.state.value.clone();
	  value.year(year);
	  value.month(this.state.value.month());
	  this.setState({
	    value: value
	  });
	  this.props.onSelect(value);
	}
	
	var YearPanel = function (_React$Component) {
	  (0, _inherits3['default'])(YearPanel, _React$Component);
	
	  function YearPanel(props) {
	    (0, _classCallCheck3['default'])(this, YearPanel);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.prefixCls = props.rootPrefixCls + '-year-panel';
	    _this.state = {
	      value: props.value || props.defaultValue
	    };
	    _this.nextDecade = goYear.bind(_this, 10);
	    _this.previousDecade = goYear.bind(_this, -10);
	    return _this;
	  }
	
	  YearPanel.prototype.years = function years() {
	    var value = this.state.value;
	    var currentYear = value.year();
	    var startYear = parseInt(currentYear / 10, 10) * 10;
	    var previousYear = startYear - 1;
	    var years = [];
	    var index = 0;
	    for (var rowIndex = 0; rowIndex < ROW; rowIndex++) {
	      years[rowIndex] = [];
	      for (var colIndex = 0; colIndex < COL; colIndex++) {
	        var year = previousYear + index;
	        var content = String(year);
	        years[rowIndex][colIndex] = {
	          content: content,
	          year: year,
	          title: content
	        };
	        index++;
	      }
	    }
	    return years;
	  };
	
	  YearPanel.prototype.render = function render() {
	    var _this2 = this;
	
	    var props = this.props;
	    var value = this.state.value;
	    var locale = props.locale,
	        renderFooter = props.renderFooter;
	
	    var years = this.years();
	    var currentYear = value.year();
	    var startYear = parseInt(currentYear / 10, 10) * 10;
	    var endYear = startYear + 9;
	    var prefixCls = this.prefixCls;
	
	    var yeasEls = years.map(function (row, index) {
	      var tds = row.map(function (yearData) {
	        var _classNameMap;
	
	        var classNameMap = (_classNameMap = {}, _classNameMap[prefixCls + '-cell'] = 1, _classNameMap[prefixCls + '-selected-cell'] = yearData.year === currentYear, _classNameMap[prefixCls + '-last-decade-cell'] = yearData.year < startYear, _classNameMap[prefixCls + '-next-decade-cell'] = yearData.year > endYear, _classNameMap);
	        var clickHandler = void 0;
	        if (yearData.year < startYear) {
	          clickHandler = _this2.previousDecade;
	        } else if (yearData.year > endYear) {
	          clickHandler = _this2.nextDecade;
	        } else {
	          clickHandler = chooseYear.bind(_this2, yearData.year);
	        }
	        return _react2['default'].createElement(
	          'td',
	          {
	            role: 'gridcell',
	            title: yearData.title,
	            key: yearData.content,
	            onClick: clickHandler,
	            className: (0, _classnames2['default'])(classNameMap)
	          },
	          _react2['default'].createElement(
	            'a',
	            {
	              className: prefixCls + '-year'
	            },
	            yearData.content
	          )
	        );
	      });
	      return _react2['default'].createElement(
	        'tr',
	        { key: index, role: 'row' },
	        tds
	      );
	    });
	
	    var footer = renderFooter && renderFooter('year');
	
	    return _react2['default'].createElement(
	      'div',
	      { className: this.prefixCls },
	      _react2['default'].createElement(
	        'div',
	        null,
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-header' },
	          _react2['default'].createElement('a', {
	            className: prefixCls + '-prev-decade-btn',
	            role: 'button',
	            onClick: this.previousDecade,
	            title: locale.previousDecade
	          }),
	          _react2['default'].createElement(
	            'a',
	            {
	              className: prefixCls + '-decade-select',
	              role: 'button',
	              onClick: props.onDecadePanelShow,
	              title: locale.decadeSelect
	            },
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-decade-select-content' },
	              startYear,
	              '-',
	              endYear
	            ),
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-decade-select-arrow' },
	              'x'
	            )
	          ),
	          _react2['default'].createElement('a', {
	            className: prefixCls + '-next-decade-btn',
	            role: 'button',
	            onClick: this.nextDecade,
	            title: locale.nextDecade
	          })
	        ),
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-body' },
	          _react2['default'].createElement(
	            'table',
	            { className: prefixCls + '-table', cellSpacing: '0', role: 'grid' },
	            _react2['default'].createElement(
	              'tbody',
	              { className: prefixCls + '-tbody' },
	              yeasEls
	            )
	          )
	        ),
	        footer && _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-footer' },
	          footer
	        )
	      )
	    );
	  };
	
	  return YearPanel;
	}(_react2['default'].Component);
	
	exports['default'] = YearPanel;
	
	
	YearPanel.propTypes = {
	  rootPrefixCls: _propTypes2['default'].string,
	  value: _propTypes2['default'].object,
	  defaultValue: _propTypes2['default'].object,
	  renderFooter: _propTypes2['default'].func
	};
	
	YearPanel.defaultProps = {
	  onSelect: function onSelect() {}
	};
	module.exports = exports['default'];

/***/ },
/* 2652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTrigger = __webpack_require__(185);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _warning = __webpack_require__(94);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _KeyCode = __webpack_require__(71);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _arrayTreeFilter = __webpack_require__(418);
	
	var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);
	
	var _arrays = __webpack_require__(2938);
	
	var _arrays2 = _interopRequireDefault(_arrays);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _Menus = __webpack_require__(2653);
	
	var _Menus2 = _interopRequireDefault(_Menus);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BUILT_IN_PLACEMENTS = {
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    offset: [0, 4],
	    overflow: {
	      adjustX: 1,
	      adjustY: 1
	    }
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    offset: [0, -4],
	    overflow: {
	      adjustX: 1,
	      adjustY: 1
	    }
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    offset: [0, 4],
	    overflow: {
	      adjustX: 1,
	      adjustY: 1
	    }
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    offset: [0, -4],
	    overflow: {
	      adjustX: 1,
	      adjustY: 1
	    }
	  }
	};
	
	var Cascader = function (_Component) {
	  _inherits(Cascader, _Component);
	
	  function Cascader(props) {
	    _classCallCheck(this, Cascader);
	
	    var _this = _possibleConstructorReturn(this, (Cascader.__proto__ || Object.getPrototypeOf(Cascader)).call(this, props));
	
	    _this.setPopupVisible = function (popupVisible) {
	      if (!('popupVisible' in _this.props)) {
	        _this.setState({ popupVisible: popupVisible });
	      }
	      // sync activeValue with value when panel open
	      if (popupVisible && !_this.state.popupVisible) {
	        _this.setState({
	          activeValue: _this.state.value
	        });
	      }
	      _this.props.onPopupVisibleChange(popupVisible);
	    };
	
	    _this.handleChange = function (options, setProps, e) {
	      if (e.type !== 'keydown' || e.keyCode === _KeyCode2['default'].ENTER) {
	        _this.props.onChange(options.map(function (o) {
	          return o[_this.getFieldName('value')];
	        }), options);
	        _this.setPopupVisible(setProps.visible);
	      }
	    };
	
	    _this.handlePopupVisibleChange = function (popupVisible) {
	      _this.setPopupVisible(popupVisible);
	    };
	
	    _this.handleMenuSelect = function (targetOption, menuIndex, e) {
	      // Keep focused state for keyboard support
	      var triggerNode = _this.trigger.getRootDomNode();
	      if (triggerNode && triggerNode.focus) {
	        triggerNode.focus();
	      }
	      var _this$props = _this.props,
	          changeOnSelect = _this$props.changeOnSelect,
	          loadData = _this$props.loadData,
	          expandTrigger = _this$props.expandTrigger;
	
	      if (!targetOption || targetOption.disabled) {
	        return;
	      }
	      var activeValue = _this.state.activeValue;
	
	      activeValue = activeValue.slice(0, menuIndex + 1);
	      activeValue[menuIndex] = targetOption[_this.getFieldName('value')];
	      var activeOptions = _this.getActiveOptions(activeValue);
	      if (targetOption.isLeaf === false && !targetOption[_this.getFieldName('children')] && loadData) {
	        if (changeOnSelect) {
	          _this.handleChange(activeOptions, { visible: true }, e);
	        }
	        _this.setState({ activeValue: activeValue });
	        loadData(activeOptions);
	        return;
	      }
	      var newState = {};
	      if (!targetOption[_this.getFieldName('children')] || !targetOption[_this.getFieldName('children')].length) {
	        _this.handleChange(activeOptions, { visible: false }, e);
	        // set value to activeValue when select leaf option
	        newState.value = activeValue;
	        // add e.type judgement to prevent `onChange` being triggered by mouseEnter
	      } else if (changeOnSelect && (e.type === 'click' || e.type === 'keydown')) {
	        if (expandTrigger === 'hover') {
	          _this.handleChange(activeOptions, { visible: false }, e);
	        } else {
	          _this.handleChange(activeOptions, { visible: true }, e);
	        }
	        // set value to activeValue on every select
	        newState.value = activeValue;
	      }
	      newState.activeValue = activeValue;
	      //  not change the value by keyboard
	      if ('value' in _this.props || e.type === 'keydown' && e.keyCode !== _KeyCode2['default'].ENTER) {
	        delete newState.value;
	      }
	      _this.setState(newState);
	    };
	
	    _this.handleItemDoubleClick = function () {
	      var changeOnSelect = _this.props.changeOnSelect;
	
	      if (changeOnSelect) {
	        _this.setPopupVisible(false);
	      }
	    };
	
	    _this.handleKeyDown = function (e) {
	      var children = _this.props.children;
	      // https://github.com/ant-design/ant-design/issues/6717
	      // Don't bind keyboard support when children specify the onKeyDown
	
	      if (children && children.props.onKeyDown) {
	        children.props.onKeyDown(e);
	        return;
	      }
	      var activeValue = [].concat(_toConsumableArray(_this.state.activeValue));
	      var currentLevel = activeValue.length - 1 < 0 ? 0 : activeValue.length - 1;
	      var currentOptions = _this.getCurrentLevelOptions();
	      var currentIndex = currentOptions.map(function (o) {
	        return o[_this.getFieldName('value')];
	      }).indexOf(activeValue[currentLevel]);
	      if (e.keyCode !== _KeyCode2['default'].DOWN && e.keyCode !== _KeyCode2['default'].UP && e.keyCode !== _KeyCode2['default'].LEFT && e.keyCode !== _KeyCode2['default'].RIGHT && e.keyCode !== _KeyCode2['default'].ENTER && e.keyCode !== _KeyCode2['default'].SPACE && e.keyCode !== _KeyCode2['default'].BACKSPACE && e.keyCode !== _KeyCode2['default'].ESC && e.keyCode !== _KeyCode2['default'].TAB) {
	        return;
	      }
	      // Press any keys above to reopen menu
	      if (!_this.state.popupVisible && e.keyCode !== _KeyCode2['default'].BACKSPACE && e.keyCode !== _KeyCode2['default'].LEFT && e.keyCode !== _KeyCode2['default'].RIGHT && e.keyCode !== _KeyCode2['default'].ESC && e.keyCode !== _KeyCode2['default'].TAB) {
	        _this.setPopupVisible(true);
	        return;
	      }
	      if (e.keyCode === _KeyCode2['default'].DOWN || e.keyCode === _KeyCode2['default'].UP) {
	        e.preventDefault();
	        var nextIndex = currentIndex;
	        if (nextIndex !== -1) {
	          if (e.keyCode === _KeyCode2['default'].DOWN) {
	            nextIndex += 1;
	            nextIndex = nextIndex >= currentOptions.length ? 0 : nextIndex;
	          } else {
	            nextIndex -= 1;
	            nextIndex = nextIndex < 0 ? currentOptions.length - 1 : nextIndex;
	          }
	        } else {
	          nextIndex = 0;
	        }
	        activeValue[currentLevel] = currentOptions[nextIndex][_this.getFieldName('value')];
	      } else if (e.keyCode === _KeyCode2['default'].LEFT || e.keyCode === _KeyCode2['default'].BACKSPACE) {
	        e.preventDefault();
	        activeValue.splice(activeValue.length - 1, 1);
	      } else if (e.keyCode === _KeyCode2['default'].RIGHT) {
	        e.preventDefault();
	        if (currentOptions[currentIndex] && currentOptions[currentIndex][_this.getFieldName('children')]) {
	          activeValue.push(currentOptions[currentIndex][_this.getFieldName('children')][0][_this.getFieldName('value')]);
	        }
	      } else if (e.keyCode === _KeyCode2['default'].ESC || e.keyCode === _KeyCode2['default'].TAB) {
	        _this.setPopupVisible(false);
	        return;
	      }
	      if (!activeValue || activeValue.length === 0) {
	        _this.setPopupVisible(false);
	      }
	      var activeOptions = _this.getActiveOptions(activeValue);
	      var targetOption = activeOptions[activeOptions.length - 1];
	      _this.handleMenuSelect(targetOption, activeOptions.length - 1, e);
	
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	    };
	
	    _this.saveTrigger = function (node) {
	      _this.trigger = node;
	    };
	
	    var initialValue = [];
	    if ('value' in props) {
	      initialValue = props.value || [];
	    } else if ('defaultValue' in props) {
	      initialValue = props.defaultValue || [];
	    }
	
	    (0, _warning2['default'])(!('filedNames' in props), '`filedNames` of Cascader is a typo usage and deprecated, please use `fieldNames` instead.');
	
	    _this.state = {
	      popupVisible: props.popupVisible,
	      activeValue: initialValue,
	      value: initialValue,
	      prevProps: props
	    };
	    _this.defaultFieldNames = { label: 'label', value: 'value', children: 'children' };
	    return _this;
	  }
	
	  _createClass(Cascader, [{
	    key: 'getPopupDOMNode',
	    value: function getPopupDOMNode() {
	      return this.trigger.getPopupDomNode();
	    }
	  }, {
	    key: 'getFieldName',
	    value: function getFieldName(name) {
	      var defaultFieldNames = this.defaultFieldNames;
	      var _props = this.props,
	          fieldNames = _props.fieldNames,
	          filedNames = _props.filedNames;
	
	      if ('filedNames' in this.props) {
	        return filedNames[name] || defaultFieldNames[name]; // For old compatibility
	      }
	      return fieldNames[name] || defaultFieldNames[name];
	    }
	  }, {
	    key: 'getFieldNames',
	    value: function getFieldNames() {
	      var _props2 = this.props,
	          fieldNames = _props2.fieldNames,
	          filedNames = _props2.filedNames;
	
	      if ('filedNames' in this.props) {
	        return filedNames; // For old compatibility
	      }
	      return fieldNames;
	    }
	  }, {
	    key: 'getCurrentLevelOptions',
	    value: function getCurrentLevelOptions() {
	      var _this2 = this;
	
	      var _props$options = this.props.options,
	          options = _props$options === undefined ? [] : _props$options;
	      var _state$activeValue = this.state.activeValue,
	          activeValue = _state$activeValue === undefined ? [] : _state$activeValue;
	
	      var result = (0, _arrayTreeFilter2['default'])(options, function (o, level) {
	        return o[_this2.getFieldName('value')] === activeValue[level];
	      }, { childrenKeyName: this.getFieldName('children') });
	      if (result[result.length - 2]) {
	        return result[result.length - 2][this.getFieldName('children')];
	      }
	      return [].concat(_toConsumableArray(options)).filter(function (o) {
	        return !o.disabled;
	      });
	    }
	  }, {
	    key: 'getActiveOptions',
	    value: function getActiveOptions(activeValue) {
	      var _this3 = this;
	
	      return (0, _arrayTreeFilter2['default'])(this.props.options || [], function (o, level) {
	        return o[_this3.getFieldName('value')] === activeValue[level];
	      }, { childrenKeyName: this.getFieldName('children') });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          prefixCls = _props3.prefixCls,
	          transitionName = _props3.transitionName,
	          popupClassName = _props3.popupClassName,
	          _props3$options = _props3.options,
	          options = _props3$options === undefined ? [] : _props3$options,
	          disabled = _props3.disabled,
	          builtinPlacements = _props3.builtinPlacements,
	          popupPlacement = _props3.popupPlacement,
	          children = _props3.children,
	          restProps = _objectWithoutProperties(_props3, ['prefixCls', 'transitionName', 'popupClassName', 'options', 'disabled', 'builtinPlacements', 'popupPlacement', 'children']);
	      // Did not show popup when there is no options
	
	
	      var menus = _react2['default'].createElement('div', null);
	      var emptyMenuClassName = '';
	      if (options && options.length > 0) {
	        menus = _react2['default'].createElement(_Menus2['default'], _extends({}, this.props, {
	          fieldNames: this.getFieldNames(),
	          defaultFieldNames: this.defaultFieldNames,
	          activeValue: this.state.activeValue,
	          onSelect: this.handleMenuSelect,
	          onItemDoubleClick: this.handleItemDoubleClick,
	          visible: this.state.popupVisible
	        }));
	      } else {
	        emptyMenuClassName = ' ' + prefixCls + '-menus-empty';
	      }
	      return _react2['default'].createElement(
	        _rcTrigger2['default'],
	        _extends({
	          ref: this.saveTrigger
	        }, restProps, {
	          options: options,
	          disabled: disabled,
	          popupPlacement: popupPlacement,
	          builtinPlacements: builtinPlacements,
	          popupTransitionName: transitionName,
	          action: disabled ? [] : ['click'],
	          popupVisible: disabled ? false : this.state.popupVisible,
	          onPopupVisibleChange: this.handlePopupVisibleChange,
	          prefixCls: prefixCls + '-menus',
	          popupClassName: popupClassName + emptyMenuClassName,
	          popup: menus
	        }),
	        (0, _react.cloneElement)(children, {
	          onKeyDown: this.handleKeyDown,
	          tabIndex: disabled ? undefined : 0
	        })
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var _prevState$prevProps = prevState.prevProps,
	          prevProps = _prevState$prevProps === undefined ? {} : _prevState$prevProps;
	
	      var newState = {
	        prevProps: nextProps
	      };
	
	      if ('value' in nextProps && !(0, _arrays2['default'])(prevProps.value, nextProps.value)) {
	        newState.value = nextProps.value || [];
	
	        // allow activeValue diff from value
	        // https://github.com/ant-design/ant-design/issues/2767
	        if (!('loadData' in nextProps)) {
	          newState.activeValue = nextProps.value || [];
	        }
	      }
	      if ('popupVisible' in nextProps) {
	        newState.popupVisible = nextProps.popupVisible;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Cascader;
	}(_react.Component);
	
	Cascader.defaultProps = {
	  onChange: function onChange() {},
	  onPopupVisibleChange: function onPopupVisibleChange() {},
	
	  disabled: false,
	  transitionName: '',
	  prefixCls: 'rc-cascader',
	  popupClassName: '',
	  popupPlacement: 'bottomLeft',
	  builtinPlacements: BUILT_IN_PLACEMENTS,
	  expandTrigger: 'click',
	  fieldNames: { label: 'label', value: 'value', children: 'children' },
	  expandIcon: '>'
	};
	
	Cascader.propTypes = {
	  value: _propTypes2['default'].array,
	  defaultValue: _propTypes2['default'].array,
	  options: _propTypes2['default'].array.isRequired,
	  onChange: _propTypes2['default'].func,
	  onPopupVisibleChange: _propTypes2['default'].func,
	  popupVisible: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  transitionName: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  popupPlacement: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  dropdownMenuColumnStyle: _propTypes2['default'].object,
	  builtinPlacements: _propTypes2['default'].object,
	  loadData: _propTypes2['default'].func,
	  changeOnSelect: _propTypes2['default'].bool,
	  children: _propTypes2['default'].node,
	  onKeyDown: _propTypes2['default'].func,
	  expandTrigger: _propTypes2['default'].string,
	  fieldNames: _propTypes2['default'].object,
	  filedNames: _propTypes2['default'].object, // typo but for compatibility
	  expandIcon: _propTypes2['default'].node,
	  loadingIcon: _propTypes2['default'].node
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Cascader);
	
	exports['default'] = Cascader;
	module.exports = exports['default'];

/***/ },
/* 2653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _arrayTreeFilter = __webpack_require__(418);
	
	var _arrayTreeFilter2 = _interopRequireDefault(_arrayTreeFilter);
	
	var _reactDom = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Menus = function (_React$Component) {
	  _inherits(Menus, _React$Component);
	
	  function Menus(props) {
	    _classCallCheck(this, Menus);
	
	    var _this = _possibleConstructorReturn(this, (Menus.__proto__ || Object.getPrototypeOf(Menus)).call(this, props));
	
	    _this.saveMenuItem = function (index) {
	      return function (node) {
	        _this.menuItems[index] = node;
	      };
	    };
	
	    _this.menuItems = {};
	    return _this;
	  }
	
	  _createClass(Menus, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollActiveItemToView();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (!prevProps.visible && this.props.visible) {
	        this.scrollActiveItemToView();
	      }
	    }
	  }, {
	    key: 'getFieldName',
	    value: function getFieldName(name) {
	      var _props = this.props,
	          fieldNames = _props.fieldNames,
	          defaultFieldNames = _props.defaultFieldNames;
	      // 防止只设置单个属性的名字
	
	      return fieldNames[name] || defaultFieldNames[name];
	    }
	  }, {
	    key: 'getOption',
	    value: function getOption(option, menuIndex) {
	      var _props2 = this.props,
	          prefixCls = _props2.prefixCls,
	          expandTrigger = _props2.expandTrigger,
	          expandIcon = _props2.expandIcon,
	          loadingIcon = _props2.loadingIcon;
	
	      var onSelect = this.props.onSelect.bind(this, option, menuIndex);
	      var onItemDoubleClick = this.props.onItemDoubleClick.bind(this, option, menuIndex);
	      var expandProps = {
	        onClick: onSelect,
	        onDoubleClick: onItemDoubleClick
	      };
	      var menuItemCls = prefixCls + '-menu-item';
	      var expandIconNode = null;
	      var hasChildren = option[this.getFieldName('children')] && option[this.getFieldName('children')].length > 0;
	      if (hasChildren || option.isLeaf === false) {
	        menuItemCls += ' ' + prefixCls + '-menu-item-expand';
	        if (!option.loading) {
	          expandIconNode = _react2['default'].createElement(
	            'span',
	            { className: prefixCls + '-menu-item-expand-icon' },
	            expandIcon
	          );
	        }
	      }
	      if (expandTrigger === 'hover' && (hasChildren || option.isLeaf === false)) {
	        expandProps = {
	          onMouseEnter: this.delayOnSelect.bind(this, onSelect),
	          onMouseLeave: this.delayOnSelect.bind(this),
	          onClick: onSelect
	        };
	      }
	      if (this.isActiveOption(option, menuIndex)) {
	        menuItemCls += ' ' + prefixCls + '-menu-item-active';
	        expandProps.ref = this.saveMenuItem(menuIndex);
	      }
	      if (option.disabled) {
	        menuItemCls += ' ' + prefixCls + '-menu-item-disabled';
	      }
	
	      var loadingIconNode = null;
	      if (option.loading) {
	        menuItemCls += ' ' + prefixCls + '-menu-item-loading';
	        loadingIconNode = loadingIcon || null;
	      }
	
	      var title = '';
	      if ('title' in option) {
	        title = option.title;
	      } else if (typeof option[this.getFieldName('label')] === 'string') {
	        title = option[this.getFieldName('label')];
	      }
	
	      return _react2['default'].createElement(
	        'li',
	        _extends({
	          key: option[this.getFieldName('value')],
	          className: menuItemCls,
	          title: title
	        }, expandProps, {
	          role: 'menuitem',
	          onMouseDown: function onMouseDown(e) {
	            return e.preventDefault();
	          }
	        }),
	        option[this.getFieldName('label')],
	        expandIconNode,
	        loadingIconNode
	      );
	    }
	  }, {
	    key: 'getActiveOptions',
	    value: function getActiveOptions(values) {
	      var _this2 = this;
	
	      var activeValue = values || this.props.activeValue;
	      var options = this.props.options;
	      return (0, _arrayTreeFilter2['default'])(options, function (o, level) {
	        return o[_this2.getFieldName('value')] === activeValue[level];
	      }, { childrenKeyName: this.getFieldName('children') });
	    }
	  }, {
	    key: 'getShowOptions',
	    value: function getShowOptions() {
	      var _this3 = this;
	
	      var options = this.props.options;
	
	      var result = this.getActiveOptions().map(function (activeOption) {
	        return activeOption[_this3.getFieldName('children')];
	      }).filter(function (activeOption) {
	        return !!activeOption;
	      });
	      result.unshift(options);
	      return result;
	    }
	  }, {
	    key: 'delayOnSelect',
	    value: function delayOnSelect(onSelect) {
	      var _this4 = this;
	
	      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        args[_key - 1] = arguments[_key];
	      }
	
	      if (this.delayTimer) {
	        clearTimeout(this.delayTimer);
	        this.delayTimer = null;
	      }
	      if (typeof onSelect === 'function') {
	        this.delayTimer = setTimeout(function () {
	          onSelect(args);
	          _this4.delayTimer = null;
	        }, 150);
	      }
	    }
	  }, {
	    key: 'scrollActiveItemToView',
	    value: function scrollActiveItemToView() {
	      // scroll into view
	      var optionsLength = this.getShowOptions().length;
	      for (var i = 0; i < optionsLength; i++) {
	        var itemComponent = this.menuItems[i];
	        if (itemComponent) {
	          var target = (0, _reactDom.findDOMNode)(itemComponent);
	          target.parentNode.scrollTop = target.offsetTop;
	        }
	      }
	    }
	  }, {
	    key: 'isActiveOption',
	    value: function isActiveOption(option, menuIndex) {
	      var _props$activeValue = this.props.activeValue,
	          activeValue = _props$activeValue === undefined ? [] : _props$activeValue;
	
	      return activeValue[menuIndex] === option[this.getFieldName('value')];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this5 = this;
	
	      var _props3 = this.props,
	          prefixCls = _props3.prefixCls,
	          dropdownMenuColumnStyle = _props3.dropdownMenuColumnStyle;
	
	      return _react2['default'].createElement(
	        'div',
	        null,
	        this.getShowOptions().map(function (options, menuIndex) {
	          return _react2['default'].createElement(
	            'ul',
	            { className: prefixCls + '-menu', key: menuIndex, style: dropdownMenuColumnStyle },
	            options.map(function (option) {
	              return _this5.getOption(option, menuIndex);
	            })
	          );
	        })
	      );
	    }
	  }]);
	
	  return Menus;
	}(_react2['default'].Component);
	
	Menus.defaultProps = {
	  options: [],
	  value: [],
	  activeValue: [],
	  onSelect: function onSelect() {},
	
	  prefixCls: 'rc-cascader-menus',
	  visible: false,
	  expandTrigger: 'click'
	};
	
	Menus.propTypes = {
	  value: _propTypes2['default'].array,
	  activeValue: _propTypes2['default'].array,
	  options: _propTypes2['default'].array,
	  prefixCls: _propTypes2['default'].string,
	  expandTrigger: _propTypes2['default'].string,
	  onSelect: _propTypes2['default'].func,
	  visible: _propTypes2['default'].bool,
	  dropdownMenuColumnStyle: _propTypes2['default'].object,
	  defaultFieldNames: _propTypes2['default'].object,
	  fieldNames: _propTypes2['default'].object,
	  expandIcon: _propTypes2['default'].node,
	  loadingIcon: _propTypes2['default'].node,
	  onItemDoubleClick: _propTypes2['default'].func
	};
	
	exports['default'] = Menus;
	module.exports = exports['default'];

/***/ },
/* 2654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Cascader = __webpack_require__(2652);
	
	var _Cascader2 = _interopRequireDefault(_Cascader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Cascader2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 2655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Checkbox = function (_Component) {
	  (0, _inherits3['default'])(Checkbox, _Component);
	
	  function Checkbox(props) {
	    (0, _classCallCheck3['default'])(this, Checkbox);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _this.handleChange = function (e) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onChange = _this$props.onChange;
	
	      if (disabled) {
	        return;
	      }
	      if (!('checked' in _this.props)) {
	        _this.setState({
	          checked: e.target.checked
	        });
	      }
	      if (onChange) {
	        onChange({
	          target: (0, _extends3['default'])({}, _this.props, {
	            checked: e.target.checked
	          }),
	          stopPropagation: function stopPropagation() {
	            e.stopPropagation();
	          },
	          preventDefault: function preventDefault() {
	            e.preventDefault();
	          },
	
	          nativeEvent: e.nativeEvent
	        });
	      }
	    };
	
	    _this.saveInput = function (node) {
	      _this.input = node;
	    };
	
	    var checked = 'checked' in props ? props.checked : props.defaultChecked;
	
	    _this.state = {
	      checked: checked
	    };
	    return _this;
	  }
	
	  Checkbox.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if ('checked' in props) {
	      return (0, _extends3['default'])({}, state, {
	        checked: props.checked
	      });
	    }
	    return null;
	  };
	
	  Checkbox.prototype.focus = function focus() {
	    this.input.focus();
	  };
	
	  Checkbox.prototype.blur = function blur() {
	    this.input.blur();
	  };
	
	  Checkbox.prototype.render = function render() {
	    var _classNames;
	
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        className = _props.className,
	        style = _props.style,
	        name = _props.name,
	        id = _props.id,
	        type = _props.type,
	        disabled = _props.disabled,
	        readOnly = _props.readOnly,
	        tabIndex = _props.tabIndex,
	        onClick = _props.onClick,
	        onFocus = _props.onFocus,
	        onBlur = _props.onBlur,
	        autoFocus = _props.autoFocus,
	        value = _props.value,
	        others = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'className', 'style', 'name', 'id', 'type', 'disabled', 'readOnly', 'tabIndex', 'onClick', 'onFocus', 'onBlur', 'autoFocus', 'value']);
	
	
	    var globalProps = Object.keys(others).reduce(function (prev, key) {
	      if (key.substr(0, 5) === 'aria-' || key.substr(0, 5) === 'data-' || key === 'role') {
	        prev[key] = others[key];
	      }
	      return prev;
	    }, {});
	
	    var checked = this.state.checked;
	
	    var classString = (0, _classnames2['default'])(prefixCls, className, (_classNames = {}, _classNames[prefixCls + '-checked'] = checked, _classNames[prefixCls + '-disabled'] = disabled, _classNames));
	
	    return _react2['default'].createElement(
	      'span',
	      { className: classString, style: style },
	      _react2['default'].createElement('input', (0, _extends3['default'])({
	        name: name,
	        id: id,
	        type: type,
	        readOnly: readOnly,
	        disabled: disabled,
	        tabIndex: tabIndex,
	        className: prefixCls + '-input',
	        checked: !!checked,
	        onClick: onClick,
	        onFocus: onFocus,
	        onBlur: onBlur,
	        onChange: this.handleChange,
	        autoFocus: autoFocus,
	        ref: this.saveInput,
	        value: value
	      }, globalProps)),
	      _react2['default'].createElement('span', { className: prefixCls + '-inner' })
	    );
	  };
	
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  name: _propTypes2['default'].string,
	  id: _propTypes2['default'].string,
	  type: _propTypes2['default'].string,
	  defaultChecked: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].bool]),
	  checked: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].bool]),
	  disabled: _propTypes2['default'].bool,
	  onFocus: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  onClick: _propTypes2['default'].func,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  readOnly: _propTypes2['default'].bool,
	  autoFocus: _propTypes2['default'].bool,
	  value: _propTypes2['default'].any
	};
	Checkbox.defaultProps = {
	  prefixCls: 'rc-checkbox',
	  className: '',
	  style: {},
	  type: 'checkbox',
	  defaultChecked: false,
	  onFocus: function onFocus() {},
	  onBlur: function onBlur() {},
	  onChange: function onChange() {}
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Checkbox);
	
	exports['default'] = Checkbox;
	module.exports = exports['default'];

/***/ },
/* 2656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Panel = __webpack_require__(2657);
	
	var _Panel2 = _interopRequireDefault(_Panel);
	
	var _openAnimationFactory = __webpack_require__(2659);
	
	var _openAnimationFactory2 = _interopRequireDefault(_openAnimationFactory);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactIs = __webpack_require__(222);
	
	var _shallowequal = __webpack_require__(79);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function toArray(activeKey) {
	  var currentActiveKey = activeKey;
	  if (!Array.isArray(currentActiveKey)) {
	    currentActiveKey = currentActiveKey ? [currentActiveKey] : [];
	  }
	  return currentActiveKey.map(function (key) {
	    return String(key);
	  });
	}
	
	var Collapse = function (_Component) {
	  _inherits(Collapse, _Component);
	
	  function Collapse(props) {
	    _classCallCheck(this, Collapse);
	
	    var _this = _possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var activeKey = props.activeKey,
	        defaultActiveKey = props.defaultActiveKey;
	
	    var currentActiveKey = defaultActiveKey;
	    if ('activeKey' in props) {
	      currentActiveKey = activeKey;
	    }
	
	    _this.state = {
	      openAnimation: props.openAnimation || (0, _openAnimationFactory2['default'])(props.prefixCls),
	      activeKey: toArray(currentActiveKey)
	    };
	    return _this;
	  }
	
	  _createClass(Collapse, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowequal2['default'])(this.props, nextProps) || !(0, _shallowequal2['default'])(this.state, nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          className = _props.className,
	          style = _props.style,
	          accordion = _props.accordion;
	
	      var collapseClassName = (0, _classnames2['default'])((_classNames = {}, _defineProperty(_classNames, prefixCls, true), _defineProperty(_classNames, className, !!className), _classNames));
	      return _react2['default'].createElement(
	        'div',
	        { className: collapseClassName, style: style, role: accordion ? 'tablist' : null },
	        this.getItems()
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps) {
	      var newState = {};
	      if ('activeKey' in nextProps) {
	        newState.activeKey = toArray(nextProps.activeKey);
	      }
	      if ('openAnimation' in nextProps) {
	        newState.openAnimation = nextProps.openAnimation;
	      }
	      return newState.activeKey || newState.openAnimation ? newState : null;
	    }
	  }]);
	
	  return Collapse;
	}(_react.Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onClickItem = function (key) {
	    var activeKey = _this2.state.activeKey;
	    if (_this2.props.accordion) {
	      activeKey = activeKey[0] === key ? [] : [key];
	    } else {
	      activeKey = [].concat(_toConsumableArray(activeKey));
	      var index = activeKey.indexOf(key);
	      var isActive = index > -1;
	      if (isActive) {
	        // remove active state
	        activeKey.splice(index, 1);
	      } else {
	        activeKey.push(key);
	      }
	    }
	    _this2.setActiveKey(activeKey);
	  };
	
	  this.getNewChild = function (child, index) {
	    if (!child) return null;
	
	    var activeKey = _this2.state.activeKey;
	    var _props2 = _this2.props,
	        prefixCls = _props2.prefixCls,
	        accordion = _props2.accordion,
	        destroyInactivePanel = _props2.destroyInactivePanel,
	        expandIcon = _props2.expandIcon;
	    // If there is no key provide, use the panel order as default key
	
	    var key = child.key || String(index);
	    var _child$props = child.props,
	        header = _child$props.header,
	        headerClass = _child$props.headerClass,
	        disabled = _child$props.disabled;
	
	    var isActive = false;
	    if (accordion) {
	      isActive = activeKey[0] === key;
	    } else {
	      isActive = activeKey.indexOf(key) > -1;
	    }
	
	    var props = {
	      key: key,
	      panelKey: key,
	      header: header,
	      headerClass: headerClass,
	      isActive: isActive,
	      prefixCls: prefixCls,
	      destroyInactivePanel: destroyInactivePanel,
	      openAnimation: _this2.state.openAnimation,
	      accordion: accordion,
	      children: child.props.children,
	      onItemClick: disabled ? null : _this2.onClickItem,
	      expandIcon: expandIcon
	    };
	
	    // https://github.com/ant-design/ant-design/issues/20479
	    if (typeof child.type === 'string') {
	      return child;
	    }
	
	    return _react2['default'].cloneElement(child, props);
	  };
	
	  this.getItems = function () {
	    var children = _this2.props.children;
	
	    var childList = (0, _reactIs.isFragment)(children) ? children.props.children : children;
	    var newChildren = _react.Children.map(childList, _this2.getNewChild);
	
	    //  ref: https://github.com/ant-design/ant-design/issues/13884
	    if ((0, _reactIs.isFragment)(children)) {
	      return _react2['default'].createElement(
	        _react2['default'].Fragment,
	        null,
	        newChildren
	      );
	    }
	
	    return newChildren;
	  };
	
	  this.setActiveKey = function (activeKey) {
	    if (!('activeKey' in _this2.props)) {
	      _this2.setState({ activeKey: activeKey });
	    }
	    _this2.props.onChange(_this2.props.accordion ? activeKey[0] : activeKey);
	  };
	};
	
	Collapse.propTypes = {
	  children: _propTypes2['default'].any,
	  prefixCls: _propTypes2['default'].string,
	  activeKey: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]))]),
	  defaultActiveKey: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]))]),
	  openAnimation: _propTypes2['default'].object,
	  onChange: _propTypes2['default'].func,
	  accordion: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  destroyInactivePanel: _propTypes2['default'].bool,
	  expandIcon: _propTypes2['default'].func
	};
	
	Collapse.defaultProps = {
	  prefixCls: 'rc-collapse',
	  onChange: function onChange() {},
	
	  accordion: false,
	  destroyInactivePanel: false
	};
	
	Collapse.Panel = _Panel2['default'];
	
	(0, _reactLifecyclesCompat.polyfill)(Collapse);
	
	exports['default'] = Collapse;
	module.exports = exports['default'];

/***/ },
/* 2657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _PanelContent = __webpack_require__(2658);
	
	var _PanelContent2 = _interopRequireDefault(_PanelContent);
	
	var _rcAnimate = __webpack_require__(111);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _shallowequal = __webpack_require__(79);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CollapsePanel = function (_Component) {
	  _inherits(CollapsePanel, _Component);
	
	  function CollapsePanel() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, CollapsePanel);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CollapsePanel.__proto__ || Object.getPrototypeOf(CollapsePanel)).call.apply(_ref, [this].concat(args))), _this), _this.handleItemClick = function () {
	      var _this$props = _this.props,
	          onItemClick = _this$props.onItemClick,
	          panelKey = _this$props.panelKey;
	
	
	      if (typeof onItemClick === 'function') {
	        onItemClick(panelKey);
	      }
	    }, _this.handleKeyPress = function (e) {
	      if (e.key === 'Enter' || e.keyCode === 13 || e.which === 13) {
	        _this.handleItemClick();
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  _createClass(CollapsePanel, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowequal2['default'])(this.props, nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames2;
	
	      var _props = this.props,
	          className = _props.className,
	          id = _props.id,
	          style = _props.style,
	          prefixCls = _props.prefixCls,
	          header = _props.header,
	          headerClass = _props.headerClass,
	          children = _props.children,
	          isActive = _props.isActive,
	          showArrow = _props.showArrow,
	          destroyInactivePanel = _props.destroyInactivePanel,
	          disabled = _props.disabled,
	          accordion = _props.accordion,
	          forceRender = _props.forceRender,
	          expandIcon = _props.expandIcon,
	          extra = _props.extra;
	
	      var headerCls = (0, _classnames2['default'])(prefixCls + '-header', _defineProperty({}, headerClass, headerClass));
	      var itemCls = (0, _classnames2['default'])((_classNames2 = {}, _defineProperty(_classNames2, prefixCls + '-item', true), _defineProperty(_classNames2, prefixCls + '-item-active', isActive), _defineProperty(_classNames2, prefixCls + '-item-disabled', disabled), _classNames2), className);
	
	      var icon = _react2['default'].createElement('i', { className: 'arrow' });
	      if (showArrow && typeof expandIcon === 'function') {
	        icon = expandIcon(this.props);
	      }
	      return _react2['default'].createElement(
	        'div',
	        { className: itemCls, style: style, id: id },
	        _react2['default'].createElement(
	          'div',
	          {
	            className: headerCls,
	            onClick: this.handleItemClick,
	            role: accordion ? 'tab' : 'button',
	            tabIndex: disabled ? -1 : 0,
	            'aria-expanded': '' + isActive,
	            onKeyPress: this.handleKeyPress
	          },
	          showArrow && icon,
	          header,
	          extra && _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-extra' },
	            extra
	          )
	        ),
	        _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            showProp: 'isActive',
	            exclusive: true,
	            component: '',
	            animation: this.props.openAnimation
	          },
	          _react2['default'].createElement(
	            _PanelContent2['default'],
	            {
	              prefixCls: prefixCls,
	              isActive: isActive,
	              destroyInactivePanel: destroyInactivePanel,
	              forceRender: forceRender,
	              role: accordion ? 'tabpanel' : null
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	
	  return CollapsePanel;
	}(_react.Component);
	
	CollapsePanel.propTypes = {
	  className: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  id: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  openAnimation: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  header: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number, _propTypes2['default'].node]),
	  headerClass: _propTypes2['default'].string,
	  showArrow: _propTypes2['default'].bool,
	  isActive: _propTypes2['default'].bool,
	  onItemClick: _propTypes2['default'].func,
	  style: _propTypes2['default'].object,
	  destroyInactivePanel: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  accordion: _propTypes2['default'].bool,
	  forceRender: _propTypes2['default'].bool,
	  expandIcon: _propTypes2['default'].func,
	  extra: _propTypes2['default'].node,
	  panelKey: _propTypes2['default'].any
	};
	
	CollapsePanel.defaultProps = {
	  showArrow: true,
	  isActive: false,
	  destroyInactivePanel: false,
	  onItemClick: function onItemClick() {},
	
	  headerClass: '',
	  forceRender: false
	};
	
	exports['default'] = CollapsePanel;
	module.exports = exports['default'];

/***/ },
/* 2658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _shallowequal = __webpack_require__(79);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PanelContent = function (_Component) {
	  _inherits(PanelContent, _Component);
	
	  function PanelContent() {
	    _classCallCheck(this, PanelContent);
	
	    return _possibleConstructorReturn(this, (PanelContent.__proto__ || Object.getPrototypeOf(PanelContent)).apply(this, arguments));
	  }
	
	  _createClass(PanelContent, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return this.props.forceRender || !(0, _shallowequal2['default'])(this.props, nextProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      this._isActived = this.props.forceRender || this._isActived || this.props.isActive;
	      if (!this._isActived) {
	        return null;
	      }
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          isActive = _props.isActive,
	          children = _props.children,
	          destroyInactivePanel = _props.destroyInactivePanel,
	          forceRender = _props.forceRender,
	          role = _props.role;
	
	      var contentCls = (0, _classnames3['default'])((_classnames = {}, _defineProperty(_classnames, prefixCls + '-content', true), _defineProperty(_classnames, prefixCls + '-content-active', isActive), _defineProperty(_classnames, prefixCls + '-content-inactive', !isActive), _classnames));
	      var child = !forceRender && !isActive && destroyInactivePanel ? null : _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-content-box' },
	        children
	      );
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: contentCls,
	          role: role
	        },
	        child
	      );
	    }
	  }]);
	
	  return PanelContent;
	}(_react.Component);
	
	PanelContent.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  isActive: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any,
	  destroyInactivePanel: _propTypes2['default'].bool,
	  forceRender: _propTypes2['default'].bool,
	  role: _propTypes2['default'].string
	};
	
	exports['default'] = PanelContent;
	module.exports = exports['default'];

/***/ },
/* 2659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _cssAnimation = __webpack_require__(487);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function animate(node, show, transitionName, done) {
	  var height = void 0;
	  return (0, _cssAnimation2['default'])(node, transitionName, {
	    start: function start() {
	      if (!show) {
	        node.style.height = node.offsetHeight + 'px';
	      } else {
	        height = node.offsetHeight;
	        node.style.height = 0;
	      }
	    },
	    active: function active() {
	      node.style.height = (show ? height : 0) + 'px';
	    },
	    end: function end() {
	      node.style.height = '';
	      done();
	    }
	  });
	}
	
	function animation(prefixCls) {
	  return {
	    enter: function enter(node, done) {
	      return animate(node, true, prefixCls + '-anim', done);
	    },
	    leave: function leave(node, done) {
	      return animate(node, false, prefixCls + '-anim', done);
	    }
	  };
	}
	
	exports['default'] = animation;
	module.exports = exports['default'];

/***/ },
/* 2660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var ReactDOM = _interopRequireWildcard(_reactDom);
	
	var _KeyCode = __webpack_require__(71);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _contains = __webpack_require__(383);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _rcAnimate = __webpack_require__(111);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _LazyRenderBox = __webpack_require__(2662);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var uuid = 0;
	/* eslint react/no-is-mounted:0 */
	function getScroll(w, top) {
	    var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
	    var method = 'scroll' + (top ? 'Top' : 'Left');
	    if (typeof ret !== 'number') {
	        var d = w.document;
	        ret = d.documentElement[method];
	        if (typeof ret !== 'number') {
	            ret = d.body[method];
	        }
	    }
	    return ret;
	}
	function setTransformOrigin(node, value) {
	    var style = node.style;
	    ['Webkit', 'Moz', 'Ms', 'ms'].forEach(function (prefix) {
	        style[prefix + 'TransformOrigin'] = value;
	    });
	    style['transformOrigin'] = value;
	}
	function offset(el) {
	    var rect = el.getBoundingClientRect();
	    var pos = {
	        left: rect.left,
	        top: rect.top
	    };
	    var doc = el.ownerDocument;
	    var w = doc.defaultView || doc.parentWindow;
	    pos.left += getScroll(w);
	    pos.top += getScroll(w, true);
	    return pos;
	}
	
	var Dialog = function (_React$Component) {
	    (0, _inherits3['default'])(Dialog, _React$Component);
	
	    function Dialog(props) {
	        (0, _classCallCheck3['default'])(this, Dialog);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	        _this.inTransition = false;
	        _this.onAnimateLeave = function () {
	            var afterClose = _this.props.afterClose;
	            // need demo?
	            // https://github.com/react-component/dialog/pull/28
	
	            if (_this.wrap) {
	                _this.wrap.style.display = 'none';
	            }
	            _this.inTransition = false;
	            _this.switchScrollingEffect();
	            if (afterClose) {
	                afterClose();
	            }
	        };
	        _this.onDialogMouseDown = function () {
	            _this.dialogMouseDown = true;
	        };
	        _this.onMaskMouseUp = function () {
	            if (_this.dialogMouseDown) {
	                _this.timeoutId = setTimeout(function () {
	                    _this.dialogMouseDown = false;
	                }, 0);
	            }
	        };
	        _this.onMaskClick = function (e) {
	            // android trigger click on open (fastclick??)
	            if (Date.now() - _this.openTime < 300) {
	                return;
	            }
	            if (e.target === e.currentTarget && !_this.dialogMouseDown) {
	                _this.close(e);
	            }
	        };
	        _this.onKeyDown = function (e) {
	            var props = _this.props;
	            if (props.keyboard && e.keyCode === _KeyCode2['default'].ESC) {
	                e.stopPropagation();
	                _this.close(e);
	                return;
	            }
	            // keep focus inside dialog
	            if (props.visible) {
	                if (e.keyCode === _KeyCode2['default'].TAB) {
	                    var activeElement = document.activeElement;
	                    var sentinelStart = _this.sentinelStart;
	                    if (e.shiftKey) {
	                        if (activeElement === sentinelStart) {
	                            _this.sentinelEnd.focus();
	                        }
	                    } else if (activeElement === _this.sentinelEnd) {
	                        sentinelStart.focus();
	                    }
	                }
	            }
	        };
	        _this.getDialogElement = function () {
	            var props = _this.props;
	            var closable = props.closable;
	            var prefixCls = props.prefixCls;
	            var dest = {};
	            if (props.width !== undefined) {
	                dest.width = props.width;
	            }
	            if (props.height !== undefined) {
	                dest.height = props.height;
	            }
	            var footer = void 0;
	            if (props.footer) {
	                footer = React.createElement("div", { className: prefixCls + '-footer', ref: _this.saveRef('footer') }, props.footer);
	            }
	            var header = void 0;
	            if (props.title) {
	                header = React.createElement("div", { className: prefixCls + '-header', ref: _this.saveRef('header') }, React.createElement("div", { className: prefixCls + '-title', id: _this.titleId }, props.title));
	            }
	            var closer = void 0;
	            if (closable) {
	                closer = React.createElement("button", { type: "button", onClick: _this.close, "aria-label": "Close", className: prefixCls + '-close' }, props.closeIcon || React.createElement("span", { className: prefixCls + '-close-x' }));
	            }
	            var style = (0, _extends3['default'])({}, props.style, dest);
	            var sentinelStyle = { width: 0, height: 0, overflow: 'hidden', outline: 'none' };
	            var transitionName = _this.getTransitionName();
	            var dialogElement = React.createElement(_LazyRenderBox2['default'], { key: "dialog-element", role: "document", ref: _this.saveRef('dialog'), style: style, className: prefixCls + ' ' + (props.className || ''), visible: props.visible, forceRender: props.forceRender, onMouseDown: _this.onDialogMouseDown }, React.createElement("div", { tabIndex: 0, ref: _this.saveRef('sentinelStart'), style: sentinelStyle, "aria-hidden": "true" }), React.createElement("div", { className: prefixCls + '-content' }, closer, header, React.createElement("div", (0, _extends3['default'])({ className: prefixCls + '-body', style: props.bodyStyle, ref: _this.saveRef('body') }, props.bodyProps), props.children), footer), React.createElement("div", { tabIndex: 0, ref: _this.saveRef('sentinelEnd'), style: sentinelStyle, "aria-hidden": "true" }));
	            return React.createElement(_rcAnimate2['default'], { key: "dialog", showProp: "visible", onLeave: _this.onAnimateLeave, transitionName: transitionName, component: "", transitionAppear: true }, props.visible || !props.destroyOnClose ? dialogElement : null);
	        };
	        _this.getZIndexStyle = function () {
	            var style = {};
	            var props = _this.props;
	            if (props.zIndex !== undefined) {
	                style.zIndex = props.zIndex;
	            }
	            return style;
	        };
	        _this.getWrapStyle = function () {
	            return (0, _extends3['default'])({}, _this.getZIndexStyle(), _this.props.wrapStyle);
	        };
	        _this.getMaskStyle = function () {
	            return (0, _extends3['default'])({}, _this.getZIndexStyle(), _this.props.maskStyle);
	        };
	        _this.getMaskElement = function () {
	            var props = _this.props;
	            var maskElement = void 0;
	            if (props.mask) {
	                var maskTransition = _this.getMaskTransitionName();
	                maskElement = React.createElement(_LazyRenderBox2['default'], (0, _extends3['default'])({ style: _this.getMaskStyle(), key: "mask", className: props.prefixCls + '-mask', hiddenClassName: props.prefixCls + '-mask-hidden', visible: props.visible }, props.maskProps));
	                if (maskTransition) {
	                    maskElement = React.createElement(_rcAnimate2['default'], { key: "mask", showProp: "visible", transitionAppear: true, component: "", transitionName: maskTransition }, maskElement);
	                }
	            }
	            return maskElement;
	        };
	        _this.getMaskTransitionName = function () {
	            var props = _this.props;
	            var transitionName = props.maskTransitionName;
	            var animation = props.maskAnimation;
	            if (!transitionName && animation) {
	                transitionName = props.prefixCls + '-' + animation;
	            }
	            return transitionName;
	        };
	        _this.getTransitionName = function () {
	            var props = _this.props;
	            var transitionName = props.transitionName;
	            var animation = props.animation;
	            if (!transitionName && animation) {
	                transitionName = props.prefixCls + '-' + animation;
	            }
	            return transitionName;
	        };
	        _this.close = function (e) {
	            var onClose = _this.props.onClose;
	
	            if (onClose) {
	                onClose(e);
	            }
	        };
	        _this.saveRef = function (name) {
	            return function (node) {
	                _this[name] = node;
	            };
	        };
	        _this.titleId = 'rcDialogTitle' + uuid++;
	        _this.switchScrollingEffect = props.switchScrollingEffect || function () {};
	        return _this;
	    }
	
	    Dialog.prototype.componentDidMount = function componentDidMount() {
	        this.componentDidUpdate({});
	        // if forceRender is true, set element style display to be none;
	        if ((this.props.forceRender || this.props.getContainer === false && !this.props.visible) && this.wrap) {
	            this.wrap.style.display = 'none';
	        }
	    };
	
	    Dialog.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	        var _props = this.props,
	            visible = _props.visible,
	            mask = _props.mask,
	            focusTriggerAfterClose = _props.focusTriggerAfterClose;
	
	        var mousePosition = this.props.mousePosition;
	        if (visible) {
	            // first show
	            if (!prevProps.visible) {
	                this.openTime = Date.now();
	                this.switchScrollingEffect();
	                this.tryFocus();
	                var dialogNode = ReactDOM.findDOMNode(this.dialog);
	                if (mousePosition) {
	                    var elOffset = offset(dialogNode);
	                    setTransformOrigin(dialogNode, mousePosition.x - elOffset.left + 'px ' + (mousePosition.y - elOffset.top) + 'px');
	                } else {
	                    setTransformOrigin(dialogNode, '');
	                }
	            }
	        } else if (prevProps.visible) {
	            this.inTransition = true;
	            if (mask && this.lastOutSideFocusNode && focusTriggerAfterClose) {
	                try {
	                    this.lastOutSideFocusNode.focus();
	                } catch (e) {
	                    this.lastOutSideFocusNode = null;
	                }
	                this.lastOutSideFocusNode = null;
	            }
	        }
	    };
	
	    Dialog.prototype.componentWillUnmount = function componentWillUnmount() {
	        var _props2 = this.props,
	            visible = _props2.visible,
	            getOpenCount = _props2.getOpenCount;
	
	        if ((visible || this.inTransition) && !getOpenCount()) {
	            this.switchScrollingEffect();
	        }
	        clearTimeout(this.timeoutId);
	    };
	
	    Dialog.prototype.tryFocus = function tryFocus() {
	        if (!(0, _contains2['default'])(this.wrap, document.activeElement)) {
	            this.lastOutSideFocusNode = document.activeElement;
	            this.sentinelStart.focus();
	        }
	    };
	
	    Dialog.prototype.render = function render() {
	        var props = this.props;
	        var prefixCls = props.prefixCls,
	            maskClosable = props.maskClosable;
	
	        var style = this.getWrapStyle();
	        // clear hide display
	        // and only set display after async anim, not here for hide
	        if (props.visible) {
	            style.display = null;
	        }
	        return React.createElement("div", { className: prefixCls + '-root' }, this.getMaskElement(), React.createElement("div", (0, _extends3['default'])({ tabIndex: -1, onKeyDown: this.onKeyDown, className: prefixCls + '-wrap ' + (props.wrapClassName || ''), ref: this.saveRef('wrap'), onClick: maskClosable ? this.onMaskClick : null, onMouseUp: maskClosable ? this.onMaskMouseUp : null, role: "dialog", "aria-labelledby": props.title ? this.titleId : null, style: style }, props.wrapProps), this.getDialogElement()));
	    };
	
	    return Dialog;
	}(React.Component);
	
	exports['default'] = Dialog;
	
	Dialog.defaultProps = {
	    className: '',
	    mask: true,
	    visible: false,
	    keyboard: true,
	    closable: true,
	    maskClosable: true,
	    destroyOnClose: false,
	    prefixCls: 'rc-dialog',
	    focusTriggerAfterClose: true
	};
	module.exports = exports['default'];

/***/ },
/* 2661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	var _Dialog = __webpack_require__(2660);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _PortalWrapper = __webpack_require__(1123);
	
	var _PortalWrapper2 = _interopRequireDefault(_PortalWrapper);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// fix issue #10656
	/*
	* getContainer remarks
	* Custom container should not be return, because in the Portal component, it will remove the
	* return container element here, if the custom container is the only child of it's component,
	* like issue #10656, It will has a conflict with removeChild method in react-dom.
	* So here should add a child (div element) to custom container.
	* */
	exports['default'] = function (props) {
	    var visible = props.visible,
	        getContainer = props.getContainer,
	        forceRender = props.forceRender;
	    // 渲染在当前 dom 里；
	
	    if (getContainer === false) {
	        return React.createElement(_Dialog2['default'], (0, _extends3['default'])({}, props, { getOpenCount: function getOpenCount() {
	                return 2;
	            } }));
	    }
	    return React.createElement(_PortalWrapper2['default'], { visible: visible, forceRender: forceRender, getContainer: getContainer }, function (childProps) {
	        return React.createElement(_Dialog2['default'], (0, _extends3['default'])({}, props, childProps));
	    });
	};
	
	module.exports = exports['default'];

/***/ },
/* 2662 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var React = _interopRequireWildcard(_react);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj["default"] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var __rest = undefined && undefined.__rest || function (s, e) {
	    var t = {};
	    for (var p in s) {
	        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	        if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
	    }return t;
	};
	
	var LazyRenderBox = function (_React$Component) {
	    (0, _inherits3["default"])(LazyRenderBox, _React$Component);
	
	    function LazyRenderBox() {
	        (0, _classCallCheck3["default"])(this, LazyRenderBox);
	        return (0, _possibleConstructorReturn3["default"])(this, _React$Component.apply(this, arguments));
	    }
	
	    LazyRenderBox.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        if (nextProps.forceRender) {
	            return true;
	        }
	        return !!nextProps.hiddenClassName || !!nextProps.visible;
	    };
	
	    LazyRenderBox.prototype.render = function render() {
	        var _a = this.props,
	            className = _a.className,
	            hiddenClassName = _a.hiddenClassName,
	            visible = _a.visible,
	            forceRender = _a.forceRender,
	            restProps = __rest(_a, ["className", "hiddenClassName", "visible", "forceRender"]);
	        var useClassName = className;
	        if (!!hiddenClassName && !visible) {
	            useClassName += " " + hiddenClassName;
	        }
	        return React.createElement("div", (0, _extends3["default"])({}, restProps, { className: useClassName }));
	    };
	
	    return LazyRenderBox;
	}(React.Component);
	
	exports["default"] = LazyRenderBox;
	module.exports = exports['default'];

/***/ },
/* 2663 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classnames2 = _interopRequireDefault(__webpack_require__(20));
	
	var _getScrollBarSize = _interopRequireDefault(__webpack_require__(1125));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(71));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _utils = __webpack_require__(2666);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var currentDrawer = {};
	
	var DrawerChild =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(DrawerChild, _React$Component);
	
	  function DrawerChild(props) {
	    var _this;
	
	    _classCallCheck(this, DrawerChild);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DrawerChild).call(this, props));
	
	    _this.domFocus = function () {
	      if (_this.dom) {
	        _this.dom.focus();
	      }
	    };
	
	    _this.removeStartHandler = function (e) {
	      if (e.touches.length > 1) {
	        return;
	      }
	
	      _this.startPos = {
	        x: e.touches[0].clientX,
	        y: e.touches[0].clientY
	      };
	    };
	
	    _this.removeMoveHandler = function (e) {
	      if (e.changedTouches.length > 1) {
	        return;
	      }
	
	      var currentTarget = e.currentTarget;
	      var differX = e.changedTouches[0].clientX - _this.startPos.x;
	      var differY = e.changedTouches[0].clientY - _this.startPos.y;
	
	      if (currentTarget === _this.maskDom || currentTarget === _this.handlerDom || currentTarget === _this.contentDom && (0, _utils.getTouchParentScroll)(currentTarget, e.target, differX, differY)) {
	        e.preventDefault();
	      }
	    };
	
	    _this.transitionEnd = function (e) {
	      var dom = e.target;
	      (0, _utils.removeEventListener)(dom, _utils.transitionEnd, _this.transitionEnd);
	      dom.style.transition = '';
	    };
	
	    _this.onKeyDown = function (e) {
	      if (e.keyCode === _KeyCode.default.ESC) {
	        var onClose = _this.props.onClose;
	        e.stopPropagation();
	
	        if (onClose) {
	          onClose(e);
	        }
	      }
	    };
	
	    _this.onWrapperTransitionEnd = function (e) {
	      var _this$props = _this.props,
	          open = _this$props.open,
	          afterVisibleChange = _this$props.afterVisibleChange;
	
	      if (e.target === _this.contentWrapper && e.propertyName.match(/transform$/)) {
	        _this.dom.style.transition = '';
	
	        if (!open && _this.getCurrentDrawerSome()) {
	          document.body.style.overflowX = '';
	
	          if (_this.maskDom) {
	            _this.maskDom.style.left = '';
	            _this.maskDom.style.width = '';
	          }
	        }
	
	        if (afterVisibleChange) {
	          afterVisibleChange(!!open);
	        }
	      }
	    };
	
	    _this.openLevelTransition = function () {
	      var _this$props2 = _this.props,
	          open = _this$props2.open,
	          width = _this$props2.width,
	          height = _this$props2.height;
	
	      var _this$getHorizontalBo = _this.getHorizontalBoolAndPlacementName(),
	          isHorizontal = _this$getHorizontalBo.isHorizontal,
	          placementName = _this$getHorizontalBo.placementName;
	
	      var contentValue = _this.contentDom ? _this.contentDom.getBoundingClientRect()[isHorizontal ? 'width' : 'height'] : 0;
	      var value = (isHorizontal ? width : height) || contentValue;
	
	      _this.setLevelAndScrolling(open, placementName, value);
	    };
	
	    _this.setLevelTransform = function (open, placementName, value, right) {
	      var _this$props3 = _this.props,
	          placement = _this$props3.placement,
	          levelMove = _this$props3.levelMove,
	          duration = _this$props3.duration,
	          ease = _this$props3.ease,
	          showMask = _this$props3.showMask; // router 切换时可能会导至页面失去滚动条，所以需要时时获取。
	
	      _this.levelDom.forEach(function (dom) {
	        dom.style.transition = "transform ".concat(duration, " ").concat(ease);
	        (0, _utils.addEventListener)(dom, _utils.transitionEnd, _this.transitionEnd);
	        var levelValue = open ? value : 0;
	
	        if (levelMove) {
	          var $levelMove = (0, _utils.transformArguments)(levelMove, {
	            target: dom,
	            open: open
	          });
	          levelValue = open ? $levelMove[0] : $levelMove[1] || 0;
	        }
	
	        var $value = typeof levelValue === 'number' ? "".concat(levelValue, "px") : levelValue;
	        var placementPos = placement === 'left' || placement === 'top' ? $value : "-".concat($value);
	        placementPos = showMask && placement === 'right' && right ? "calc(".concat(placementPos, " + ").concat(right, "px)") : placementPos;
	        dom.style.transform = levelValue ? "".concat(placementName, "(").concat(placementPos, ")") : '';
	      });
	    };
	
	    _this.setLevelAndScrolling = function (open, placementName, value) {
	      var onChange = _this.props.onChange;
	
	      if (!_utils.windowIsUndefined) {
	        var right = document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth ? (0, _getScrollBarSize.default)(true) : 0;
	
	        _this.setLevelTransform(open, placementName, value, right);
	
	        _this.toggleScrollingToDrawerAndBody(right);
	      }
	
	      if (onChange) {
	        onChange(open);
	      }
	    };
	
	    _this.toggleScrollingToDrawerAndBody = function (right) {
	      var _this$props4 = _this.props,
	          getOpenCount = _this$props4.getOpenCount,
	          getContainer = _this$props4.getContainer,
	          showMask = _this$props4.showMask,
	          open = _this$props4.open;
	      var container = getContainer && getContainer();
	      var openCount = getOpenCount && getOpenCount(); // 处理 body 滚动
	
	      if (container && container.parentNode === document.body && showMask) {
	        var eventArray = ['touchstart'];
	        var domArray = [document.body, _this.maskDom, _this.handlerDom, _this.contentDom];
	
	        if (open && document.body.style.overflow !== 'hidden') {
	          if (right) {
	            _this.addScrollingEffect(right);
	          }
	
	          if (openCount === 1) {
	            document.body.style.overflow = 'hidden';
	          }
	
	          document.body.style.touchAction = 'none'; // 手机禁滚
	
	          domArray.forEach(function (item, i) {
	            if (!item) {
	              return;
	            }
	
	            (0, _utils.addEventListener)(item, eventArray[i] || 'touchmove', i ? _this.removeMoveHandler : _this.removeStartHandler, _this.passive);
	          });
	        } else if (_this.getCurrentDrawerSome()) {
	          // 没有弹框的状态下清除 overflow;
	          if (!openCount) {
	            document.body.style.overflow = '';
	          }
	
	          document.body.style.touchAction = '';
	
	          if (right) {
	            _this.remScrollingEffect(right);
	          } // 恢复事件
	
	
	          domArray.forEach(function (item, i) {
	            if (!item) {
	              return;
	            }
	
	            (0, _utils.removeEventListener)(item, eventArray[i] || 'touchmove', i ? _this.removeMoveHandler : _this.removeStartHandler, _this.passive);
	          });
	        }
	      }
	    };
	
	    _this.addScrollingEffect = function (right) {
	      var _this$props5 = _this.props,
	          placement = _this$props5.placement,
	          duration = _this$props5.duration,
	          ease = _this$props5.ease,
	          getOpenCount = _this$props5.getOpenCount,
	          switchScrollingEffect = _this$props5.switchScrollingEffect;
	      var openCount = getOpenCount && getOpenCount();
	
	      if (openCount === 1) {
	        switchScrollingEffect();
	      }
	
	      var widthTransition = "width ".concat(duration, " ").concat(ease);
	      var transformTransition = "transform ".concat(duration, " ").concat(ease);
	      _this.dom.style.transition = 'none';
	
	      switch (placement) {
	        case 'right':
	          _this.dom.style.transform = "translateX(-".concat(right, "px)");
	          break;
	
	        case 'top':
	        case 'bottom':
	          _this.dom.style.width = "calc(100% - ".concat(right, "px)");
	          _this.dom.style.transform = 'translateZ(0)';
	          break;
	
	        default:
	          break;
	      }
	
	      clearTimeout(_this.timeout);
	      _this.timeout = setTimeout(function () {
	        if (_this.dom) {
	          _this.dom.style.transition = "".concat(transformTransition, ",").concat(widthTransition);
	          _this.dom.style.width = '';
	          _this.dom.style.transform = '';
	        }
	      });
	    };
	
	    _this.remScrollingEffect = function (right) {
	      var _this$props6 = _this.props,
	          placement = _this$props6.placement,
	          duration = _this$props6.duration,
	          ease = _this$props6.ease,
	          getOpenCount = _this$props6.getOpenCount,
	          switchScrollingEffect = _this$props6.switchScrollingEffect;
	      var openCount = getOpenCount && getOpenCount();
	
	      if (!openCount) {
	        switchScrollingEffect(true);
	      }
	
	      if (_utils.transitionStr) {
	        document.body.style.overflowX = 'hidden';
	      }
	
	      _this.dom.style.transition = 'none';
	      var heightTransition;
	      var widthTransition = "width ".concat(duration, " ").concat(ease);
	      var transformTransition = "transform ".concat(duration, " ").concat(ease);
	
	      switch (placement) {
	        case 'left':
	          {
	            _this.dom.style.width = '100%';
	            widthTransition = "width 0s ".concat(ease, " ").concat(duration);
	            break;
	          }
	
	        case 'right':
	          {
	            _this.dom.style.transform = "translateX(".concat(right, "px)");
	            _this.dom.style.width = '100%';
	            widthTransition = "width 0s ".concat(ease, " ").concat(duration);
	
	            if (_this.maskDom) {
	              _this.maskDom.style.left = "-".concat(right, "px");
	              _this.maskDom.style.width = "calc(100% + ".concat(right, "px)");
	            }
	
	            break;
	          }
	
	        case 'top':
	        case 'bottom':
	          {
	            _this.dom.style.width = "calc(100% + ".concat(right, "px)");
	            _this.dom.style.height = '100%';
	            _this.dom.style.transform = 'translateZ(0)';
	            heightTransition = "height 0s ".concat(ease, " ").concat(duration);
	            break;
	          }
	
	        default:
	          break;
	      }
	
	      clearTimeout(_this.timeout);
	      _this.timeout = setTimeout(function () {
	        if (_this.dom) {
	          _this.dom.style.transition = "".concat(transformTransition, ",").concat(heightTransition ? "".concat(heightTransition, ",") : '').concat(widthTransition);
	          _this.dom.style.transform = '';
	          _this.dom.style.width = '';
	          _this.dom.style.height = '';
	        }
	      });
	    };
	
	    _this.getCurrentDrawerSome = function () {
	      return !Object.keys(currentDrawer).some(function (key) {
	        return currentDrawer[key];
	      });
	    };
	
	    _this.getLevelDom = function (_ref) {
	      var level = _ref.level,
	          getContainer = _ref.getContainer;
	
	      if (_utils.windowIsUndefined) {
	        return;
	      }
	
	      var container = getContainer && getContainer();
	      var parent = container ? container.parentNode : null;
	      _this.levelDom = [];
	
	      if (level === 'all') {
	        var children = parent ? Array.prototype.slice.call(parent.children) : [];
	        children.forEach(function (child) {
	          if (child.nodeName !== 'SCRIPT' && child.nodeName !== 'STYLE' && child.nodeName !== 'LINK' && child !== container) {
	            _this.levelDom.push(child);
	          }
	        });
	      } else if (level) {
	        (0, _utils.dataToArray)(level).forEach(function (key) {
	          document.querySelectorAll(key).forEach(function (item) {
	            _this.levelDom.push(item);
	          });
	        });
	      }
	    };
	
	    _this.getHorizontalBoolAndPlacementName = function () {
	      var placement = _this.props.placement;
	      var isHorizontal = placement === 'left' || placement === 'right';
	      var placementName = "translate".concat(isHorizontal ? 'X' : 'Y');
	      return {
	        isHorizontal: isHorizontal,
	        placementName: placementName
	      };
	    };
	
	    _this.state = {
	      _self: _assertThisInitialized(_this)
	    };
	    return _this;
	  }
	
	  _createClass(DrawerChild, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (!_utils.windowIsUndefined) {
	        var passiveSupported = false;
	
	        try {
	          window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
	            get: function get() {
	              passiveSupported = true;
	              return null;
	            }
	          }));
	        } catch (err) {}
	
	        this.passive = passiveSupported ? {
	          passive: false
	        } : false;
	      }
	
	      var open = this.props.open;
	      this.drawerId = "drawer_id_".concat(Number((Date.now() + Math.random()).toString().replace('.', Math.round(Math.random() * 9).toString())).toString(16));
	      this.getLevelDom(this.props);
	
	      if (open) {
	        currentDrawer[this.drawerId] = open; // 默认打开状态时推出 level;
	
	        this.openLevelTransition();
	        this.forceUpdate(function () {
	          _this2.domFocus();
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var open = this.props.open;
	
	      if (open !== prevProps.open) {
	        if (open) {
	          this.domFocus();
	        }
	
	        currentDrawer[this.drawerId] = !!open;
	        this.openLevelTransition();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var _this$props7 = this.props,
	          getOpenCount = _this$props7.getOpenCount,
	          open = _this$props7.open,
	          switchScrollingEffect = _this$props7.switchScrollingEffect;
	      var openCount = typeof getOpenCount === 'function' && getOpenCount();
	      delete currentDrawer[this.drawerId];
	
	      if (open) {
	        this.setLevelTransform(false);
	        document.body.style.touchAction = '';
	      }
	
	      if (!openCount) {
	        document.body.style.overflow = '';
	        switchScrollingEffect(true);
	      }
	    } // tslint:disable-next-line:member-ordering
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _classnames,
	          _this3 = this;
	
	      var _this$props8 = this.props,
	          className = _this$props8.className,
	          children = _this$props8.children,
	          style = _this$props8.style,
	          width = _this$props8.width,
	          height = _this$props8.height,
	          defaultOpen = _this$props8.defaultOpen,
	          $open = _this$props8.open,
	          prefixCls = _this$props8.prefixCls,
	          placement = _this$props8.placement,
	          level = _this$props8.level,
	          levelMove = _this$props8.levelMove,
	          ease = _this$props8.ease,
	          duration = _this$props8.duration,
	          getContainer = _this$props8.getContainer,
	          handler = _this$props8.handler,
	          onChange = _this$props8.onChange,
	          afterVisibleChange = _this$props8.afterVisibleChange,
	          showMask = _this$props8.showMask,
	          maskClosable = _this$props8.maskClosable,
	          maskStyle = _this$props8.maskStyle,
	          onClose = _this$props8.onClose,
	          onHandleClick = _this$props8.onHandleClick,
	          keyboard = _this$props8.keyboard,
	          getOpenCount = _this$props8.getOpenCount,
	          switchScrollingEffect = _this$props8.switchScrollingEffect,
	          props = _objectWithoutProperties(_this$props8, ["className", "children", "style", "width", "height", "defaultOpen", "open", "prefixCls", "placement", "level", "levelMove", "ease", "duration", "getContainer", "handler", "onChange", "afterVisibleChange", "showMask", "maskClosable", "maskStyle", "onClose", "onHandleClick", "keyboard", "getOpenCount", "switchScrollingEffect"]); // 首次渲染都将是关闭状态。
	
	
	      var open = this.dom ? $open : false;
	      var wrapperClassName = (0, _classnames2.default)(prefixCls, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-").concat(placement), true), _defineProperty(_classnames, "".concat(prefixCls, "-open"), open), _defineProperty(_classnames, className || '', !!className), _defineProperty(_classnames, 'no-mask', !showMask), _classnames));
	
	      var _this$getHorizontalBo2 = this.getHorizontalBoolAndPlacementName(),
	          placementName = _this$getHorizontalBo2.placementName; // 百分比与像素动画不同步，第一次打用后全用像素动画。
	      // const defaultValue = !this.contentDom || !level ? '100%' : `${value}px`;
	
	
	      var placementPos = placement === 'left' || placement === 'top' ? '-100%' : '100%';
	      var transform = open ? '' : "".concat(placementName, "(").concat(placementPos, ")");
	      var handlerChildren = handler && React.cloneElement(handler, {
	        onClick: function onClick(e) {
	          if (handler.props.onClick) {
	            handler.props.onClick();
	          }
	
	          if (onHandleClick) {
	            onHandleClick(e);
	          }
	        },
	        ref: function ref(c) {
	          _this3.handlerDom = c;
	        }
	      });
	      return React.createElement("div", Object.assign({}, props, {
	        tabIndex: -1,
	        className: wrapperClassName,
	        style: style,
	        ref: function ref(c) {
	          _this3.dom = c;
	        },
	        onKeyDown: open && keyboard ? this.onKeyDown : undefined,
	        onTransitionEnd: this.onWrapperTransitionEnd
	      }), showMask && React.createElement("div", {
	        className: "".concat(prefixCls, "-mask"),
	        onClick: maskClosable ? onClose : undefined,
	        style: maskStyle,
	        ref: function ref(c) {
	          _this3.maskDom = c;
	        }
	      }), React.createElement("div", {
	        className: "".concat(prefixCls, "-content-wrapper"),
	        style: {
	          transform: transform,
	          msTransform: transform,
	          width: (0, _utils.isNumeric)(width) ? "".concat(width, "px") : width,
	          height: (0, _utils.isNumeric)(height) ? "".concat(height, "px") : height
	        },
	        ref: function ref(c) {
	          _this3.contentWrapper = c;
	        }
	      }, React.createElement("div", {
	        className: "".concat(prefixCls, "-content"),
	        ref: function ref(c) {
	          _this3.contentDom = c;
	        },
	        onTouchStart: open && showMask ? this.removeStartHandler : undefined,
	        onTouchMove: open && showMask ? this.removeMoveHandler : undefined
	      }, children), handlerChildren));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, _ref2) {
	      var prevProps = _ref2.prevProps,
	          _self = _ref2._self;
	      var nextState = {
	        prevProps: props
	      };
	
	      if (prevProps !== undefined) {
	        var placement = props.placement,
	            level = props.level;
	
	        if (placement !== prevProps.placement) {
	          // test 的 bug, 有动画过场，删除 dom
	          _self.contentDom = null;
	        }
	
	        if (level !== prevProps.level) {
	          _self.getLevelDom(props);
	        }
	      }
	
	      return nextState;
	    }
	  }]);
	
	  return DrawerChild;
	}(React.Component);
	
	DrawerChild.defaultProps = {
	  switchScrollingEffect: function switchScrollingEffect() {}
	};
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(DrawerChild);
	
	exports.default = _default;

/***/ },
/* 2664 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _PortalWrapper = _interopRequireDefault(__webpack_require__(1123));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _DrawerChild = _interopRequireDefault(__webpack_require__(2663));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var DrawerWrapper =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(DrawerWrapper, _React$Component);
	
	  function DrawerWrapper(props) {
	    var _this;
	
	    _classCallCheck(this, DrawerWrapper);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DrawerWrapper).call(this, props));
	
	    _this.onHandleClick = function (e) {
	      var _this$props = _this.props,
	          onHandleClick = _this$props.onHandleClick,
	          $open = _this$props.open;
	
	      if (onHandleClick) {
	        onHandleClick(e);
	      }
	
	      if (typeof $open === 'undefined') {
	        var _open = _this.state.open;
	
	        _this.setState({
	          open: !_open
	        });
	      }
	    };
	
	    _this.onClose = function (e) {
	      var _this$props2 = _this.props,
	          onClose = _this$props2.onClose,
	          open = _this$props2.open;
	
	      if (onClose) {
	        onClose(e);
	      }
	
	      if (typeof open === 'undefined') {
	        _this.setState({
	          open: false
	        });
	      }
	    };
	
	    var open = typeof props.open !== 'undefined' ? props.open : !!props.defaultOpen;
	    _this.state = {
	      open: open
	    };
	
	    if ('onMaskClick' in props) {
	      console.warn('`onMaskClick` are removed, please use `onClose` instead.');
	    }
	
	    return _this;
	  }
	
	  _createClass(DrawerWrapper, [{
	    key: "render",
	    // tslint:disable-next-line:member-ordering
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props3 = this.props,
	          defaultOpen = _this$props3.defaultOpen,
	          getContainer = _this$props3.getContainer,
	          wrapperClassName = _this$props3.wrapperClassName,
	          forceRender = _this$props3.forceRender,
	          handler = _this$props3.handler,
	          props = _objectWithoutProperties(_this$props3, ["defaultOpen", "getContainer", "wrapperClassName", "forceRender", "handler"]);
	
	      var open = this.state.open; // 渲染在当前 dom 里；
	
	      if (!getContainer) {
	        return React.createElement("div", {
	          className: wrapperClassName,
	          ref: function ref(c) {
	            _this2.dom = c;
	          }
	        }, React.createElement(_DrawerChild.default, Object.assign({}, props, {
	          open: open,
	          handler: handler,
	          getContainer: function getContainer() {
	            return _this2.dom;
	          },
	          onClose: this.onClose,
	          onHandleClick: this.onHandleClick
	        })));
	      } // 如果有 handler 为内置强制渲染；
	
	
	      var $forceRender = !!handler || forceRender;
	      return React.createElement(_PortalWrapper.default, {
	        visible: open,
	        forceRender: $forceRender,
	        getContainer: getContainer,
	        wrapperClassName: wrapperClassName
	      }, function (_ref) {
	        var visible = _ref.visible,
	            afterClose = _ref.afterClose,
	            rest = _objectWithoutProperties(_ref, ["visible", "afterClose"]);
	
	        return (// react 15，componentWillUnmount 时 Portal 返回 afterClose, visible.
	          React.createElement(_DrawerChild.default, Object.assign({}, props, rest, {
	            open: visible !== undefined ? visible : open,
	            afterVisibleChange: afterClose !== undefined ? afterClose : props.afterVisibleChange,
	            handler: handler,
	            onClose: _this2.onClose,
	            onHandleClick: _this2.onHandleClick
	          }))
	        );
	      });
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, _ref2) {
	      var prevProps = _ref2.prevProps;
	      var newState = {
	        prevProps: props
	      };
	
	      if (typeof prevProps !== 'undefined' && props.open !== prevProps.open) {
	        newState.open = props.open;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return DrawerWrapper;
	}(React.Component);
	
	DrawerWrapper.defaultProps = {
	  prefixCls: 'drawer',
	  placement: 'left',
	  getContainer: 'body',
	  defaultOpen: false,
	  level: 'all',
	  duration: '.3s',
	  ease: 'cubic-bezier(0.78, 0.14, 0.15, 0.86)',
	  onChange: function onChange() {},
	  afterVisibleChange: function afterVisibleChange() {},
	  handler: React.createElement("div", {
	    className: "drawer-handle"
	  }, React.createElement("i", {
	    className: "drawer-handle-icon"
	  })),
	  showMask: true,
	  maskClosable: true,
	  maskStyle: {},
	  wrapperClassName: '',
	  className: '',
	  keyboard: true,
	  forceRender: false
	};
	
	var _default = (0, _reactLifecyclesCompat.polyfill)(DrawerWrapper);
	
	exports.default = _default;

/***/ },
/* 2665 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _DrawerWrapper = _interopRequireDefault(__webpack_require__(2664));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// export this package's api
	var _default = _DrawerWrapper.default;
	exports.default = _default;

/***/ },
/* 2666 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.dataToArray = dataToArray;
	exports.addEventListener = addEventListener;
	exports.removeEventListener = removeEventListener;
	exports.transformArguments = transformArguments;
	exports.getTouchParentScroll = exports.windowIsUndefined = exports.isNumeric = exports.transitionEnd = exports.transitionStr = void 0;
	
	function dataToArray(vars) {
	  if (Array.isArray(vars)) {
	    return vars;
	  }
	
	  return [vars];
	}
	
	var transitionEndObject = {
	  transition: 'transitionend',
	  WebkitTransition: 'webkitTransitionEnd',
	  MozTransition: 'transitionend',
	  OTransition: 'oTransitionEnd otransitionend'
	};
	var transitionStr = Object.keys(transitionEndObject).filter(function (key) {
	  if (typeof document === 'undefined') {
	    return false;
	  }
	
	  var html = document.getElementsByTagName('html')[0];
	  return key in (html ? html.style : {});
	})[0];
	exports.transitionStr = transitionStr;
	var transitionEnd = transitionEndObject[transitionStr];
	exports.transitionEnd = transitionEnd;
	
	function addEventListener(target, eventType, callback, options) {
	  if (target.addEventListener) {
	    target.addEventListener(eventType, callback, options);
	  } else if (target.attachEvent) {
	    // tslint:disable-line
	    target.attachEvent("on".concat(eventType), callback); // tslint:disable-line
	  }
	}
	
	function removeEventListener(target, eventType, callback, options) {
	  if (target.removeEventListener) {
	    target.removeEventListener(eventType, callback, options);
	  } else if (target.attachEvent) {
	    // tslint:disable-line
	    target.detachEvent("on".concat(eventType), callback); // tslint:disable-line
	  }
	}
	
	function transformArguments(arg, cb) {
	  var result = typeof arg === 'function' ? arg(cb) : arg;
	
	  if (Array.isArray(result)) {
	    if (result.length === 2) {
	      return result;
	    }
	
	    return [result[0], result[1]];
	  }
	
	  return [result];
	}
	
	var isNumeric = function isNumeric(value) {
	  return !isNaN(parseFloat(value)) && isFinite(value);
	};
	
	exports.isNumeric = isNumeric;
	var windowIsUndefined = !(typeof window !== 'undefined' && window.document && window.document.createElement);
	exports.windowIsUndefined = windowIsUndefined;
	
	var getTouchParentScroll = function getTouchParentScroll(root, currentTarget, differX, differY) {
	  if (!currentTarget || currentTarget === document || currentTarget instanceof Document) {
	    return false;
	  } // root 为 drawer-content 设定了 overflow, 判断为 root 的 parent 时结束滚动；
	
	
	  if (currentTarget === root.parentNode) {
	    return true;
	  }
	
	  var isY = Math.max(Math.abs(differX), Math.abs(differY)) === Math.abs(differY);
	  var isX = Math.max(Math.abs(differX), Math.abs(differY)) === Math.abs(differX);
	  var scrollY = currentTarget.scrollHeight - currentTarget.clientHeight;
	  var scrollX = currentTarget.scrollWidth - currentTarget.clientWidth;
	  var style = document.defaultView.getComputedStyle(currentTarget);
	  var overflowY = style.overflowY === 'auto' || style.overflowY === 'scroll';
	  var overflowX = style.overflowX === 'auto' || style.overflowX === 'scroll';
	  var y = scrollY && overflowY;
	  var x = scrollX && overflowX;
	
	  if (isY && (!y || y && (currentTarget.scrollTop >= scrollY && differY < 0 || currentTarget.scrollTop <= 0 && differY > 0)) || isX && (!x || x && (currentTarget.scrollLeft >= scrollX && scrollX < 0 || currentTarget.scrollLeft <= 0 && scrollX > 0))) {
	    return getTouchParentScroll(root, currentTarget.parentNode, differX, differY);
	  }
	
	  return false;
	};
	
	exports.getTouchParentScroll = getTouchParentScroll;

/***/ },
/* 2667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcTrigger = __webpack_require__(185);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _placements = __webpack_require__(2669);
	
	var _placements2 = _interopRequireDefault(_placements);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Dropdown = function (_Component) {
	  _inherits(Dropdown, _Component);
	
	  function Dropdown(props) {
	    _classCallCheck(this, Dropdown);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    if ('visible' in props) {
	      _this.state = {
	        visible: props.visible
	      };
	    } else {
	      _this.state = {
	        visible: props.defaultVisible
	      };
	    }
	    return _this;
	  }
	
	  Dropdown.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps) {
	    if ('visible' in nextProps) {
	      return {
	        visible: nextProps.visible
	      };
	    }
	    return null;
	  };
	
	  Dropdown.prototype.getOverlayElement = function getOverlayElement() {
	    var overlay = this.props.overlay;
	
	    var overlayElement = void 0;
	    if (typeof overlay === 'function') {
	      overlayElement = overlay();
	    } else {
	      overlayElement = overlay;
	    }
	    return overlayElement;
	  };
	
	  Dropdown.prototype.getMenuElementOrLambda = function getMenuElementOrLambda() {
	    var overlay = this.props.overlay;
	
	    if (typeof overlay === 'function') {
	      return this.getMenuElement;
	    }
	    return this.getMenuElement();
	  };
	
	  Dropdown.prototype.getPopupDomNode = function getPopupDomNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  Dropdown.prototype.getOpenClassName = function getOpenClassName() {
	    var _props = this.props,
	        openClassName = _props.openClassName,
	        prefixCls = _props.prefixCls;
	
	    if (openClassName !== undefined) {
	      return openClassName;
	    }
	    return prefixCls + '-open';
	  };
	
	  Dropdown.prototype.renderChildren = function renderChildren() {
	    var children = this.props.children;
	    var visible = this.state.visible;
	
	    var childrenProps = children.props ? children.props : {};
	    var childClassName = (0, _classnames2['default'])(childrenProps.className, this.getOpenClassName());
	    return visible && children ? (0, _react.cloneElement)(children, { className: childClassName }) : children;
	  };
	
	  Dropdown.prototype.render = function render() {
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        transitionName = _props2.transitionName,
	        animation = _props2.animation,
	        align = _props2.align,
	        placement = _props2.placement,
	        getPopupContainer = _props2.getPopupContainer,
	        showAction = _props2.showAction,
	        hideAction = _props2.hideAction,
	        overlayClassName = _props2.overlayClassName,
	        overlayStyle = _props2.overlayStyle,
	        trigger = _props2.trigger,
	        otherProps = _objectWithoutProperties(_props2, ['prefixCls', 'transitionName', 'animation', 'align', 'placement', 'getPopupContainer', 'showAction', 'hideAction', 'overlayClassName', 'overlayStyle', 'trigger']);
	
	    var triggerHideAction = hideAction;
	    if (!triggerHideAction && trigger.indexOf('contextMenu') !== -1) {
	      triggerHideAction = ['click'];
	    }
	
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      _extends({}, otherProps, {
	        prefixCls: prefixCls,
	        ref: this.saveTrigger,
	        popupClassName: overlayClassName,
	        popupStyle: overlayStyle,
	        builtinPlacements: _placements2['default'],
	        action: trigger,
	        showAction: showAction,
	        hideAction: triggerHideAction || [],
	        popupPlacement: placement,
	        popupAlign: align,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        popupVisible: this.state.visible,
	        afterPopupVisibleChange: this.afterVisibleChange,
	        popup: this.getMenuElementOrLambda(),
	        onPopupVisibleChange: this.onVisibleChange,
	        getPopupContainer: getPopupContainer
	      }),
	      this.renderChildren()
	    );
	  };
	
	  return Dropdown;
	}(_react.Component);
	
	Dropdown.propTypes = {
	  minOverlayWidthMatchTrigger: _propTypes2['default'].bool,
	  onVisibleChange: _propTypes2['default'].func,
	  onOverlayClick: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  transitionName: _propTypes2['default'].string,
	  overlayClassName: _propTypes2['default'].string,
	  openClassName: _propTypes2['default'].string,
	  animation: _propTypes2['default'].any,
	  align: _propTypes2['default'].object,
	  overlayStyle: _propTypes2['default'].object,
	  placement: _propTypes2['default'].string,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]),
	  trigger: _propTypes2['default'].array,
	  alignPoint: _propTypes2['default'].bool,
	  showAction: _propTypes2['default'].array,
	  hideAction: _propTypes2['default'].array,
	  getPopupContainer: _propTypes2['default'].func,
	  visible: _propTypes2['default'].bool,
	  defaultVisible: _propTypes2['default'].bool
	};
	Dropdown.defaultProps = {
	  prefixCls: 'rc-dropdown',
	  trigger: ['hover'],
	  showAction: [],
	  overlayClassName: '',
	  overlayStyle: {},
	  defaultVisible: false,
	  onVisibleChange: function onVisibleChange() {},
	
	  placement: 'bottomLeft'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.onClick = function (e) {
	    var props = _this2.props;
	    var overlayProps = _this2.getOverlayElement().props;
	    // do no call onVisibleChange, if you need click to hide, use onClick and control visible
	    if (!('visible' in props)) {
	      _this2.setState({
	        visible: false
	      });
	    }
	    if (props.onOverlayClick) {
	      props.onOverlayClick(e);
	    }
	    if (overlayProps.onClick) {
	      overlayProps.onClick(e);
	    }
	  };
	
	  this.onVisibleChange = function (visible) {
	    var props = _this2.props;
	    if (!('visible' in props)) {
	      _this2.setState({
	        visible: visible
	      });
	    }
	    props.onVisibleChange(visible);
	  };
	
	  this.getMinOverlayWidthMatchTrigger = function () {
	    var _props3 = _this2.props,
	        minOverlayWidthMatchTrigger = _props3.minOverlayWidthMatchTrigger,
	        alignPoint = _props3.alignPoint;
	
	    if ('minOverlayWidthMatchTrigger' in _this2.props) {
	      return minOverlayWidthMatchTrigger;
	    }
	
	    return !alignPoint;
	  };
	
	  this.getMenuElement = function () {
	    var prefixCls = _this2.props.prefixCls;
	
	    var overlayElement = _this2.getOverlayElement();
	    var extraOverlayProps = {
	      prefixCls: prefixCls + '-menu',
	      onClick: _this2.onClick
	    };
	    if (typeof overlayElement.type === 'string') {
	      delete extraOverlayProps.prefixCls;
	    }
	    return _react2['default'].cloneElement(overlayElement, extraOverlayProps);
	  };
	
	  this.afterVisibleChange = function (visible) {
	    if (visible && _this2.getMinOverlayWidthMatchTrigger()) {
	      var overlayNode = _this2.getPopupDomNode();
	      var rootNode = _reactDom2['default'].findDOMNode(_this2);
	      if (rootNode && overlayNode && rootNode.offsetWidth > overlayNode.offsetWidth) {
	        overlayNode.style.minWidth = rootNode.offsetWidth + 'px';
	        if (_this2.trigger && _this2.trigger._component && _this2.trigger._component.alignInstance) {
	          _this2.trigger._component.alignInstance.forceAlign();
	        }
	      }
	    }
	  };
	
	  this.saveTrigger = function (node) {
	    _this2.trigger = node;
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Dropdown);
	
	exports['default'] = Dropdown;
	module.exports = exports['default'];

/***/ },
/* 2668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Dropdown = __webpack_require__(2667);
	
	var _Dropdown2 = _interopRequireDefault(_Dropdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Dropdown2['default'];
	module.exports = exports['default'];

/***/ },
/* 2669 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	
	var targetOffset = [0, 0];
	
	var placements = exports.placements = {
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  topCenter: {
	    points: ['bc', 'tc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -4],
	    targetOffset: targetOffset
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  bottomCenter: {
	    points: ['tc', 'bc'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 4],
	    targetOffset: targetOffset
	  }
	};
	
	exports['default'] = placements;

/***/ },
/* 2670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _immutable = __webpack_require__(39);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ConfigStore = function () {
	    function ConfigStore() {
	        _classCallCheck(this, ConfigStore);
	
	        this._store = (0, _immutable.Map)();
	    }
	
	    ConfigStore.prototype.set = function set(key, value) {
	        this._store = this._store.set(key, value);
	    };
	
	    ConfigStore.prototype.get = function get(key) {
	        return this._store.get(key);
	    };
	
	    return ConfigStore;
	}();
	
	exports['default'] = ConfigStore;
	module.exports = exports['default'];

/***/ },
/* 2671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = customHTML2Content;
	
	var _draftJs = __webpack_require__(175);
	
	var _toArray = __webpack_require__(2604);
	
	var _toArray2 = _interopRequireDefault(_toArray);
	
	var _immutable = __webpack_require__(39);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function compose() {
	    for (var _len = arguments.length, argument = Array(_len), _key = 0; _key < _len; _key++) {
	        argument[_key] = arguments[_key];
	    }
	
	    var args = arguments;
	    var start = args.length - 1;
	    return function () {
	        var i = start;
	        var result = args[start].apply(this, arguments);
	        while (i--) {
	            result = args[i].call(this, result);
	        }return result;
	    };
	}
	;
	/*
	 * Helpers
	 */
	// Prepares img meta data object based on img attributes
	var getBlockSpecForElement = function getBlockSpecForElement(imgElement) {
	    return {
	        contentType: 'image',
	        src: imgElement.getAttribute('src'),
	        width: imgElement.getAttribute('width'),
	        height: imgElement.getAttribute('height'),
	        align: imgElement.style.cssFloat
	    };
	};
	// Wraps meta data in HTML element which is 'understandable' by Draft, I used <blockquote />.
	var wrapBlockSpec = function wrapBlockSpec(blockSpec) {
	    if (blockSpec == null) {
	        return null;
	    }
	    var tempEl = document.createElement('blockquote');
	    // stringify meta data and insert it as text content of temp HTML element. We will later extract
	    // and parse it.
	    tempEl.innerText = JSON.stringify(blockSpec);
	    return tempEl;
	};
	// Replaces <img> element with our temp element
	var replaceElement = function replaceElement(oldEl, newEl) {
	    if (!(newEl instanceof HTMLElement)) {
	        return;
	    }
	    var parentNode = oldEl.parentNode;
	    return parentNode.replaceChild(newEl, oldEl);
	};
	var elementToBlockSpecElement = compose(wrapBlockSpec, getBlockSpecForElement);
	var imgReplacer = function imgReplacer(imgElement) {
	    return replaceElement(imgElement, elementToBlockSpecElement(imgElement));
	};
	// creates ContentBlock based on provided spec
	var createContentBlock = function createContentBlock(blockData, contentState) {
	    var key = blockData.key,
	        type = blockData.type,
	        text = blockData.text,
	        data = blockData.data,
	        inlineStyles = blockData.inlineStyles,
	        entityData = blockData.entityData;
	
	    var blockSpec = {
	        type: type != null ? type : 'unstyled',
	        text: text != null ? text : '',
	        key: key != null ? key : (0, _draftJs.genKey)(),
	        data: null,
	        characterList: (0, _immutable.List)([])
	    };
	    if (data) {
	        blockSpec.data = (0, _immutable.fromJS)(data);
	    }
	    if (inlineStyles || entityData) {
	        var entityKey = void 0;
	        if (entityData) {
	            var _type = entityData.type,
	                mutability = entityData.mutability,
	                _data = entityData.data;
	
	            contentState.createEntity(_type, mutability, _data);
	            entityKey = contentState.getLastCreatedEntityKey();
	        } else {
	            entityKey = null;
	        }
	        var style = (0, _immutable.OrderedSet)(inlineStyles || []);
	        var charData = _draftJs.CharacterMetadata.create({ style: style, entityKey: entityKey });
	        blockSpec.characterList = (0, _immutable.List)((0, _immutable.Repeat)(charData, text.length));
	    }
	    return new _draftJs.ContentBlock(blockSpec);
	};
	// takes HTML string and returns DraftJS ContentState
	function customHTML2Content(HTML, contentState) {
	    var tempDoc = new DOMParser().parseFromString(HTML, 'text/html');
	    // replace all <img /> with <blockquote /> elements
	    (0, _toArray2['default'])(tempDoc.querySelectorAll('img')).forEach(imgReplacer);
	    // use DraftJS converter to do initial conversion. I don't provide DOMBuilder and
	    // blockRenderMap arguments here since it should fall back to its default ones, which are fine
	
	    var _convertFromHTML = (0, _draftJs.convertFromHTML)(tempDoc.body.innerHTML),
	        contentBlocks = _convertFromHTML.contentBlocks;
	    // now replace <blockquote /> ContentBlocks with 'atomic' ones
	
	
	    contentBlocks = contentBlocks.reduce(function (contentBlocks, block) {
	        if (block.getType() !== 'blockquote') {
	            return contentBlocks.concat(block);
	        }
	        var image = JSON.parse(block.getText());
	        contentState.createEntity('IMAGE-ENTITY', 'IMMUTABLE', image);
	        var entityKey = contentState.getLastCreatedEntityKey();
	        var charData = _draftJs.CharacterMetadata.create({ entity: entityKey });
	        // const blockSpec = Object.assign({ type: 'atomic', text: ' ' }, { entityData })
	        // const atomicBlock = createContentBlock(blockSpec)
	        // const spacerBlock = createContentBlock({});
	        var fragmentArray = [new _draftJs.ContentBlock({
	            key: (0, _draftJs.genKey)(),
	            type: 'image-block',
	            text: ' ',
	            characterList: (0, _immutable.List)((0, _immutable.Repeat)(charData, charData.count()))
	        }), new _draftJs.ContentBlock({
	            key: (0, _draftJs.genKey)(),
	            type: 'unstyled',
	            text: '',
	            characterList: (0, _immutable.List)()
	        })];
	        return contentBlocks.concat(fragmentArray);
	    }, []);
	    // console.log('>> customHTML2Content contentBlocks', contentBlocks);
	    tempDoc = null;
	    return _draftJs.BlockMapBuilder.createFromArray(contentBlocks);
	}
	module.exports = exports['default'];

/***/ },
/* 2672 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.encodeContent = encodeContent;
	exports.decodeContent = decodeContent;
	exports['default'] = exportText;
	function encodeContent(text) {
	    return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join('<br />' + '\n');
	}
	function decodeContent(text) {
	    return text.split('<br />' + '\n').join('\n');
	}
	function exportText(editorState) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { encode: false };
	
	    var content = editorState.getCurrentContent();
	    var blockMap = content.getBlockMap();
	    var encode = options.encode;
	
	    return blockMap.map(function (block) {
	        var resultText = '';
	        var lastPosition = 0;
	        var text = block.getText();
	        block.findEntityRanges(function (character) {
	            return !!character.getEntity();
	        }, function (start, end) {
	            var key = block.getEntityAt(start);
	            var entityData = content.getEntity(key).getData();
	            resultText += text.slice(lastPosition, start);
	            resultText += entityData && entityData['export'] ? entityData['export'](entityData) : text.slice(start, end);
	            lastPosition = end;
	        });
	        resultText += text.slice(lastPosition);
	        return encode ? encodeContent(resultText) : resultText;
	    }).join(encode ? '<br />\n' : '\n');
	}

/***/ },
/* 2673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.DEFAULT_INLINE_STYLE = exports.DEFAULT_ELEMENT = exports.EMPTY_SET = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = GetHTML;
	
	var _draftJs = __webpack_require__(175);
	
	var _immutable = __webpack_require__(39);
	
	var _isUnitlessNumber = __webpack_require__(2674);
	
	var _isUnitlessNumber2 = _interopRequireDefault(_isUnitlessNumber);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var EMPTY_SET = exports.EMPTY_SET = (0, _immutable.OrderedSet)();
	var DEFAULT_ELEMENT = exports.DEFAULT_ELEMENT = 'span';
	var DEFAULT_INLINE_STYLE = exports.DEFAULT_INLINE_STYLE = _draftJs.DefaultDraftInlineStyle;
	function encodeContent(text) {
	    return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('\xA0').join('&nbsp;').split('\n').join('<br >' + '\n');
	}
	function encodeAttr(text) {
	    return text.split('&').join('&amp;').split('<').join('&lt;').split('>').join('&gt;').split('"').join('&quot;');
	}
	var VENDOR_PREFIX = /^(moz|ms|o|webkit)-/;
	var NUMERIC_STRING = /^\d+$/;
	var UPPERCASE_PATTERN = /([A-Z])/g;
	// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/CSSPropertyOperations.js
	function processStyleName(name) {
	    return name.replace(UPPERCASE_PATTERN, '-$1').toLowerCase().replace(VENDOR_PREFIX, '-$1-');
	}
	// Lifted from: https://github.com/facebook/react/blob/master/src/renderers/dom/shared/dangerousStyleValue.js
	function processStyleValue(name, value) {
	    var isNumeric = void 0;
	    if (typeof value === 'string') {
	        isNumeric = NUMERIC_STRING.test(value);
	    } else {
	        isNumeric = true;
	        value = String(value);
	    }
	    if (!isNumeric || value === '0' || _isUnitlessNumber2['default'][name] === true) {
	        return value;
	    } else {
	        return value + 'px';
	    }
	}
	function getStyleText(styleObject) {
	    if (!styleObject) {
	        return '';
	    }
	    return Object.keys(styleObject).map(function (name) {
	        var styleName = processStyleName(name);
	        var styleValue = processStyleValue(name, styleObject[name]);
	        return styleName + ':' + styleValue;
	    }).join(';');
	}
	function getEntityContent(contentState, entityKey, content) {
	    if (entityKey) {
	        var entity = contentState.getEntity(entityKey);
	        var entityData = entity.getData();
	        if (entityData && entityData['export']) {
	            return entityData['export'](content, entityData);
	        }
	    }
	    return content;
	}
	function GetHTML(configStore) {
	    return function exportHtml(editorState) {
	        var contentState = editorState.getCurrentContent();
	        var blockMap = contentState.getBlockMap();
	        var customStyleMap = configStore.get('customStyleMap') || {};
	        var customBlockRenderMap = configStore.get('blockRenderMap') || {};
	        var customStyleFn = configStore.get('customStyleFn');
	        var toHTMLList = configStore.get('toHTMLList');
	        _extends(customStyleMap, DEFAULT_INLINE_STYLE);
	        return blockMap.map(function (block) {
	            var resultText = '<div>';
	            var closeTag = '</div>';
	            var lastPosition = 0;
	            var text = block.getText();
	            var blockType = block.getType();
	            var blockRender = customBlockRenderMap.get(blockType);
	            if (blockRender) {
	                var element = typeof blockRender.element === 'function' ? blockRender.elementTag || 'div' : 'div';
	                resultText = '<' + (element || 'div') + ' style="' + getStyleText(customBlockRenderMap.get(blockType).style || {}) + '">';
	                closeTag = '</' + (element || 'div') + '>';
	            }
	            var charMetaList = block.getCharacterList();
	            var charEntity = null;
	            var prevCharEntity = null;
	            var ranges = [];
	            var rangeStart = 0;
	            for (var i = 0, len = text.length; i < len; i++) {
	                prevCharEntity = charEntity;
	                var meta = charMetaList.get(i);
	                charEntity = meta ? meta.getEntity() : null;
	                if (i > 0 && charEntity !== prevCharEntity) {
	                    ranges.push([prevCharEntity, getStyleRanges(text.slice(rangeStart, i), charMetaList.slice(rangeStart, i))]);
	                    rangeStart = i;
	                }
	            }
	            ranges.push([charEntity, getStyleRanges(text.slice(rangeStart), charMetaList.slice(rangeStart))]);
	            ranges.map(function (_ref) {
	                var entityKey = _ref[0],
	                    stylePieces = _ref[1];
	
	                var element = DEFAULT_ELEMENT;
	                var rawContent = stylePieces.map(function (_ref2) {
	                    var text = _ref2[0];
	                    return text;
	                }).join('');
	                var content = stylePieces.map(function (_ref3) {
	                    var text = _ref3[0],
	                        styleSet = _ref3[1];
	
	                    var encodedContent = encodeContent(text);
	                    if (styleSet.size) {
	                        var inlineStyle = {};
	                        styleSet.forEach(function (item) {
	                            if (customStyleMap.hasOwnProperty(item)) {
	                                var currentStyle = customStyleMap[item];
	                                inlineStyle = _extends(inlineStyle, currentStyle);
	                            }
	                        });
	                        var customedStyle = customStyleFn(styleSet);
	                        inlineStyle = _extends(inlineStyle, customedStyle);
	                        return '<span style="' + getStyleText(inlineStyle) + '">' + encodedContent + '</span>';
	                    }
	                    return '<span>' + encodedContent + '</span>';
	                }).join('');
	                if (entityKey) {
	                    var entity = contentState.getEntity(entityKey);
	                    var entityData = entity.getData();
	                    if (entityData && entityData['export']) {
	                        resultText += entityData['export'](content, entityData);
	                    } else {
	                        var HTMLText = '';
	                        toHTMLList.forEach(function (toHTML) {
	                            var text = toHTML(rawContent, entity, contentState);
	                            if (text) {
	                                HTMLText = text;
	                            }
	                        });
	                        if (HTMLText) {
	                            resultText += HTMLText;
	                        }
	                    }
	                } else {
	                    resultText += content;
	                }
	            });
	            resultText += closeTag;
	            return resultText;
	        }).join('\n');
	    };
	}
	function getStyleRanges(text, charMetaList) {
	    var charStyle = EMPTY_SET;
	    var prevCharStyle = EMPTY_SET;
	    var ranges = [];
	    var rangeStart = 0;
	    for (var i = 0, len = text.length; i < len; i++) {
	        prevCharStyle = charStyle;
	        var meta = charMetaList.get(i);
	        charStyle = meta ? meta.getStyle() : EMPTY_SET;
	        if (i > 0 && !(0, _immutable.is)(charStyle, prevCharStyle)) {
	            ranges.push([text.slice(rangeStart, i), prevCharStyle]);
	            rangeStart = i;
	        }
	    }
	    ranges.push([text.slice(rangeStart), charStyle]);
	    return ranges;
	}

/***/ },
/* 2674 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var isUnitlessNumber = {
	    animationIterationCount: true,
	    borderImageOutset: true,
	    borderImageSlice: true,
	    borderImageWidth: true,
	    boxFlex: true,
	    boxFlexGroup: true,
	    boxOrdinalGroup: true,
	    columnCount: true,
	    flex: true,
	    flexGrow: true,
	    flexPositive: true,
	    flexShrink: true,
	    flexNegative: true,
	    flexOrder: true,
	    gridRow: true,
	    gridColumn: true,
	    fontWeight: true,
	    lineClamp: true,
	    lineHeight: true,
	    opacity: true,
	    order: true,
	    orphans: true,
	    tabSize: true,
	    widows: true,
	    zIndex: true,
	    zoom: true,
	    // SVG-related properties
	    fillOpacity: true,
	    floodOpacity: true,
	    stopOpacity: true,
	    strokeDasharray: true,
	    strokeDashoffset: true,
	    strokeMiterlimit: true,
	    strokeOpacity: true,
	    strokeWidth: true
	};
	function prefixKey(prefix, key) {
	    return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	    prefixes.forEach(function (prefix) {
	        isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	    });
	});
	exports['default'] = isUnitlessNumber;
	module.exports = exports['default'];

/***/ },
/* 2675 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(clearImmediate, setImmediate) {'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _draftJs = __webpack_require__(175);
	
	var _immutable = __webpack_require__(39);
	
	__webpack_require__(594);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _Toolbar = __webpack_require__(2678);
	
	var _ConfigStore = __webpack_require__(2670);
	
	var _ConfigStore2 = _interopRequireDefault(_ConfigStore);
	
	var _getHTML = __webpack_require__(2673);
	
	var _getHTML2 = _interopRequireDefault(_getHTML);
	
	var _exportText = __webpack_require__(2672);
	
	var _exportText2 = _interopRequireDefault(_exportText);
	
	var _customHTML2Content = __webpack_require__(2671);
	
	var _customHTML2Content2 = _interopRequireDefault(_customHTML2Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* tslint:disable:member-ordering interface-name */
	
	
	var hasCommandModifier = _draftJs.KeyBindingUtil.hasCommandModifier;
	
	function noop() {}
	;
	var defaultPluginConfig = {};
	var focusDummyStyle = {
	    width: 0,
	    opacity: 0,
	    border: 0,
	    position: 'absolute',
	    left: 0,
	    top: 0
	};
	var toolbar = (0, _Toolbar.createToolbar)();
	var configStore = new _ConfigStore2['default']();
	
	var EditorCore = function (_React$Component) {
	    _inherits(EditorCore, _React$Component);
	
	    function EditorCore(props) {
	        _classCallCheck(this, EditorCore);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        _this.cancelForceUpdateImmediate = function () {
	            clearImmediate(_this.forceUpdateImmediate);
	            _this.forceUpdateImmediate = null;
	        };
	        _this.handlePastedText = function (text, html) {
	            var editorState = _this.state.editorState;
	
	            if (html) {
	                var contentState = editorState.getCurrentContent();
	                var selection = editorState.getSelection();
	                var fragment = (0, _customHTML2Content2['default'])(html, contentState);
	                var pastedContent = _draftJs.Modifier.replaceWithFragment(contentState, selection, fragment);
	                var newContent = pastedContent.merge({
	                    selectionBefore: selection,
	                    selectionAfter: pastedContent.getSelectionAfter().set('hasFocus', true)
	                });
	                _this.setEditorState(_draftJs.EditorState.push(editorState, newContent, 'insert-fragment'), true);
	                return 'handled';
	            }
	            return 'not-handled';
	        };
	        _this.plugins = (0, _immutable.List)((0, _immutable.List)(props.plugins).flatten(true));
	        var editorState = void 0;
	        if (props.value !== undefined) {
	            if (props.value instanceof _draftJs.EditorState) {
	                editorState = props.value || _draftJs.EditorState.createEmpty();
	            } else {
	                editorState = _draftJs.EditorState.createEmpty();
	            }
	        } else {
	            editorState = _draftJs.EditorState.createEmpty();
	        }
	        editorState = _this.generatorDefaultValue(editorState);
	        _this.state = {
	            plugins: _this.reloadPlugins(),
	            editorState: editorState,
	            customStyleMap: {},
	            customBlockStyleMap: {},
	            compositeDecorator: null
	        };
	        if (props.value !== undefined) {
	            _this.controlledMode = true;
	        }
	        return _this;
	    }
	
	    EditorCore.ToEditorState = function ToEditorState(text) {
	        var createEmptyContentState = _draftJs.ContentState.createFromText((0, _exportText.decodeContent)(text) || '');
	        var editorState = _draftJs.EditorState.createWithContent(createEmptyContentState);
	        return _draftJs.EditorState.forceSelection(editorState, createEmptyContentState.getSelectionAfter());
	    };
	
	    EditorCore.prototype.getDefaultValue = function getDefaultValue() {
	        var _props = this.props,
	            defaultValue = _props.defaultValue,
	            value = _props.value;
	
	        return value || defaultValue;
	    };
	
	    EditorCore.prototype.Reset = function Reset() {
	        var defaultValue = this.getDefaultValue();
	        var contentState = defaultValue ? defaultValue.getCurrentContent() : _draftJs.ContentState.createFromText('');
	        var updatedEditorState = _draftJs.EditorState.push(this.state.editorState, contentState, 'remove-range');
	        this.setEditorState(_draftJs.EditorState.forceSelection(updatedEditorState, contentState.getSelectionBefore()));
	    };
	
	    EditorCore.prototype.SetText = function SetText(text) {
	        var createTextContentState = _draftJs.ContentState.createFromText(text || '');
	        var editorState = _draftJs.EditorState.push(this.state.editorState, createTextContentState, 'change-block-data');
	        this.setEditorState(_draftJs.EditorState.moveFocusToEnd(editorState), true);
	    };
	
	    EditorCore.prototype.getChildContext = function getChildContext() {
	        return {
	            getEditorState: this.getEditorState,
	            setEditorState: this.setEditorState
	        };
	    };
	
	    EditorCore.prototype.reloadPlugins = function reloadPlugins() {
	        var _this2 = this;
	
	        return this.plugins && this.plugins.size ? this.plugins.map(function (plugin) {
	            // 如果插件有 callbacks 方法,则认为插件已经加载。
	            if (plugin.callbacks) {
	                return plugin;
	            }
	            // 如果插件有 constructor 方法,则构造插件
	            if (plugin.hasOwnProperty('constructor')) {
	                var pluginConfig = _extends(_this2.props.pluginConfig, plugin.config || {}, defaultPluginConfig);
	                return plugin.constructor(pluginConfig);
	            }
	            // else 无效插件
	            console.warn('>> 插件: [', plugin.name, '] 无效。插件或许已经过期。');
	            return false;
	        }).filter(function (plugin) {
	            return plugin;
	        }).toArray() : [];
	    };
	
	    EditorCore.prototype.componentWillMount = function componentWillMount() {
	        var plugins = this.initPlugins().concat([toolbar]);
	        var customStyleMap = {};
	        var customBlockStyleMap = {};
	        var customBlockRenderMap = (0, _immutable.Map)(_draftJs.DefaultDraftBlockRenderMap);
	        var toHTMLList = (0, _immutable.List)([]);
	        // initialize compositeDecorator
	        var compositeDecorator = new _draftJs.CompositeDecorator(plugins.filter(function (plugin) {
	            return plugin.decorators !== undefined;
	        }).map(function (plugin) {
	            return plugin.decorators;
	        }).reduce(function (prev, curr) {
	            return prev.concat(curr);
	        }, []));
	        // initialize Toolbar
	        var toolbarPlugins = (0, _immutable.List)(plugins.filter(function (plugin) {
	            return !!plugin.component && plugin.name !== 'toolbar';
	        }));
	        // load inline styles...
	        plugins.forEach(function (plugin) {
	            var styleMap = plugin.styleMap,
	                blockStyleMap = plugin.blockStyleMap,
	                blockRenderMap = plugin.blockRenderMap,
	                toHtml = plugin.toHtml;
	
	            if (styleMap) {
	                for (var key in styleMap) {
	                    if (styleMap.hasOwnProperty(key)) {
	                        customStyleMap[key] = styleMap[key];
	                    }
	                }
	            }
	            if (blockStyleMap) {
	                for (var _key in blockStyleMap) {
	                    if (blockStyleMap.hasOwnProperty(_key)) {
	                        customBlockStyleMap[_key] = blockStyleMap[_key];
	                        customBlockRenderMap = customBlockRenderMap.set(_key, {
	                            element: null
	                        });
	                    }
	                }
	            }
	            if (toHtml) {
	                toHTMLList = toHTMLList.push(toHtml);
	            }
	            if (blockRenderMap) {
	                for (var _key2 in blockRenderMap) {
	                    if (blockRenderMap.hasOwnProperty(_key2)) {
	                        customBlockRenderMap = customBlockRenderMap.set(_key2, blockRenderMap[_key2]);
	                    }
	                }
	            }
	        });
	        configStore.set('customStyleMap', customStyleMap);
	        configStore.set('customBlockStyleMap', customBlockStyleMap);
	        configStore.set('blockRenderMap', customBlockRenderMap);
	        configStore.set('customStyleFn', this.customStyleFn.bind(this));
	        configStore.set('toHTMLList', toHTMLList);
	        this.setState({
	            toolbarPlugins: toolbarPlugins,
	            compositeDecorator: compositeDecorator
	        });
	        this.setEditorState(_draftJs.EditorState.set(this.state.editorState, { decorator: compositeDecorator }), false, false);
	    };
	
	    EditorCore.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        if (this.forceUpdateImmediate) {
	            this.cancelForceUpdateImmediate();
	        }
	        if (this.controlledMode) {
	            var decorators = nextProps.value.getDecorator();
	            var editorState = decorators ? nextProps.value : _draftJs.EditorState.set(nextProps.value, { decorator: this.state.compositeDecorator });
	            this.setState({
	                editorState: editorState
	            });
	        }
	    };
	
	    EditorCore.prototype.componentWillUnmount = function componentWillUnmount() {
	        this.cancelForceUpdateImmediate();
	    };
	    // 处理 value
	
	
	    EditorCore.prototype.generatorDefaultValue = function generatorDefaultValue(editorState) {
	        var defaultValue = this.getDefaultValue();
	        if (defaultValue) {
	            return defaultValue;
	        }
	        return editorState;
	    };
	
	    EditorCore.prototype.getStyleMap = function getStyleMap() {
	        return configStore.get('customStyleMap');
	    };
	
	    EditorCore.prototype.setStyleMap = function setStyleMap(customStyleMap) {
	        configStore.set('customStyleMap', customStyleMap);
	        this.render();
	    };
	
	    EditorCore.prototype.initPlugins = function initPlugins() {
	        var _this3 = this;
	
	        var enableCallbacks = ['focus', 'getEditorState', 'setEditorState', 'getStyleMap', 'setStyleMap'];
	        return this.getPlugins().map(function (plugin) {
	            enableCallbacks.forEach(function (callbackName) {
	                if (plugin.callbacks.hasOwnProperty(callbackName)) {
	                    plugin.callbacks[callbackName] = _this3[callbackName].bind(_this3);
	                }
	            });
	            return plugin;
	        });
	    };
	
	    EditorCore.prototype.focusEditor = function focusEditor(ev) {
	        this.refs.editor.focus(ev);
	        if (this.props.readOnly) {
	            this._focusDummy.focus();
	        }
	        if (this.props.onFocus) {
	            this.props.onFocus(ev);
	        }
	    };
	
	    EditorCore.prototype._focus = function _focus(ev) {
	        if (!ev || !ev.nativeEvent || !ev.nativeEvent.target) {
	            return;
	        }
	        if (document.activeElement && document.activeElement.getAttribute('contenteditable') === 'true') {
	            return;
	        }
	        return this.focus(ev);
	    };
	
	    EditorCore.prototype.focus = function focus(ev) {
	        var _this4 = this;
	
	        var event = ev && ev.nativeEvent;
	        if (event && event.target === this._editorWrapper) {
	            var editorState = this.state.editorState;
	
	            var selection = editorState.getSelection();
	            if (!selection.getHasFocus()) {
	                if (selection.isCollapsed()) {
	                    return this.setState({
	                        editorState: _draftJs.EditorState.moveSelectionToEnd(editorState)
	                    }, function () {
	                        _this4.focusEditor(ev);
	                    });
	                }
	            }
	        }
	        this.focusEditor(ev);
	    };
	
	    EditorCore.prototype.getPlugins = function getPlugins() {
	        return this.state.plugins.slice();
	    };
	
	    EditorCore.prototype.getEventHandler = function getEventHandler() {
	        var _this5 = this;
	
	        var enabledEvents = ['onUpArrow', 'onDownArrow', 'handleReturn', 'onFocus', 'onBlur', 'onTab', 'handlePastedText'];
	        var eventHandler = {};
	        enabledEvents.forEach(function (event) {
	            eventHandler[event] = _this5.generatorEventHandler(event);
	        });
	        return eventHandler;
	    };
	
	    EditorCore.prototype.getEditorState = function getEditorState() {
	        var needFocus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	        if (needFocus) {
	            this.refs.editor.focus();
	        }
	        return this.state.editorState;
	    };
	
	    EditorCore.prototype.setEditorState = function setEditorState(editorState) {
	        var _this6 = this;
	
	        var focusEditor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	        var triggerChange = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	        var newEditorState = editorState;
	        this.getPlugins().forEach(function (plugin) {
	            if (plugin.onChange) {
	                var updatedEditorState = plugin.onChange(newEditorState);
	                if (updatedEditorState) {
	                    newEditorState = updatedEditorState;
	                }
	            }
	        });
	        if (this.props.onChange && triggerChange) {
	            this.props.onChange(newEditorState);
	            // close this issue https://github.com/ant-design/ant-design/issues/5788
	            // when onChange not take any effect
	            // `<Editor />` won't rerender cause no props is changed.
	            // add an timeout here,
	            // if props.onChange not trigger componentWillReceiveProps,
	            // we will force render Editor with previous editorState,
	            if (this.controlledMode) {
	                this.forceUpdateImmediate = setImmediate(function () {
	                    return _this6.setState({
	                        editorState: new _draftJs.EditorState(_this6.state.editorState.getImmutable())
	                    });
	                });
	            }
	        }
	        if (!this.controlledMode) {
	            this.setState({ editorState: newEditorState }, focusEditor ? function () {
	                return setImmediate(function () {
	                    return _this6.refs.editor.focus();
	                });
	            } : noop);
	        }
	    };
	
	    EditorCore.prototype.handleKeyBinding = function handleKeyBinding(ev) {
	        if (this.props.onKeyDown) {
	            ev.ctrlKey = hasCommandModifier(ev);
	            var keyDownResult = this.props.onKeyDown(ev);
	            if (keyDownResult) {
	                return keyDownResult;
	            }
	            return (0, _draftJs.getDefaultKeyBinding)(ev);
	        }
	        return (0, _draftJs.getDefaultKeyBinding)(ev);
	    };
	
	    EditorCore.prototype.handleKeyCommand = function handleKeyCommand(command) {
	        if (this.props.multiLines) {
	            return this.eventHandle('handleKeyBinding', command);
	        }
	        return command === 'split-block' ? 'handled' : 'not-handled';
	    };
	
	    EditorCore.prototype.getBlockStyle = function getBlockStyle(contentBlock) {
	        var customBlockStyleMap = configStore.get('customBlockStyleMap');
	        var type = contentBlock.getType();
	        if (customBlockStyleMap.hasOwnProperty(type)) {
	            return customBlockStyleMap[type];
	        }
	        return '';
	    };
	
	    EditorCore.prototype.blockRendererFn = function blockRendererFn(contentBlock) {
	        var blockRenderResult = null;
	        this.getPlugins().forEach(function (plugin) {
	            if (plugin.blockRendererFn) {
	                var result = plugin.blockRendererFn(contentBlock);
	                if (result) {
	                    blockRenderResult = result;
	                }
	            }
	        });
	        return blockRenderResult;
	    };
	
	    EditorCore.prototype.eventHandle = function eventHandle(eventName) {
	        var _props2;
	
	        var plugins = this.getPlugins();
	
	        for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key3 = 1; _key3 < _len; _key3++) {
	            args[_key3 - 1] = arguments[_key3];
	        }
	
	        for (var i = 0; i < plugins.length; i++) {
	            var plugin = plugins[i];
	            if (plugin.callbacks[eventName] && typeof plugin.callbacks[eventName] === 'function') {
	                var _plugin$callbacks;
	
	                var result = (_plugin$callbacks = plugin.callbacks)[eventName].apply(_plugin$callbacks, args);
	                if (result === true) {
	                    return 'handled';
	                }
	            }
	        }
	        return this.props.hasOwnProperty(eventName) && (_props2 = this.props)[eventName].apply(_props2, args) === true ? 'handled' : 'not-handled';
	    };
	
	    EditorCore.prototype.generatorEventHandler = function generatorEventHandler(eventName) {
	        var _this7 = this;
	
	        return function () {
	            for (var _len2 = arguments.length, args = Array(_len2), _key4 = 0; _key4 < _len2; _key4++) {
	                args[_key4] = arguments[_key4];
	            }
	
	            return _this7.eventHandle.apply(_this7, [eventName].concat(args));
	        };
	    };
	
	    EditorCore.prototype.customStyleFn = function customStyleFn(styleSet) {
	        if (styleSet.size === 0) {
	            return {};
	        }
	        var plugins = this.getPlugins();
	        var resultStyle = {};
	        for (var i = 0; i < plugins.length; i++) {
	            if (plugins[i].customStyleFn) {
	                var styled = plugins[i].customStyleFn(styleSet);
	                if (styled) {
	                    _extends(resultStyle, styled);
	                }
	            }
	        }
	        return resultStyle;
	    };
	
	    EditorCore.prototype.render = function render() {
	        var _classnames,
	            _this8 = this;
	
	        var _props3 = this.props,
	            prefixCls = _props3.prefixCls,
	            toolbars = _props3.toolbars,
	            style = _props3.style,
	            readOnly = _props3.readOnly,
	            multiLines = _props3.multiLines;
	        var _state = this.state,
	            editorState = _state.editorState,
	            toolbarPlugins = _state.toolbarPlugins;
	
	        var customStyleMap = configStore.get('customStyleMap');
	        var blockRenderMap = configStore.get('blockRenderMap');
	        var eventHandler = this.getEventHandler();
	        var Toolbar = toolbar.component;
	        var cls = (0, _classnames3['default'])((_classnames = {}, _classnames[prefixCls + '-editor'] = true, _classnames.readonly = readOnly, _classnames.oneline = !multiLines, _classnames));
	        return _react2['default'].createElement(
	            'div',
	            { style: style, className: cls, onClick: this._focus.bind(this) },
	            _react2['default'].createElement(Toolbar, { editorState: editorState, prefixCls: prefixCls, className: prefixCls + '-toolbar', plugins: toolbarPlugins, toolbars: toolbars }),
	            _react2['default'].createElement(
	                'div',
	                { className: prefixCls + '-editor-wrapper', ref: function ref(ele) {
	                        return _this8._editorWrapper = ele;
	                    }, style: style, onClick: function onClick(ev) {
	                        return ev.preventDefault();
	                    } },
	                _react2['default'].createElement(_draftJs.Editor, _extends({}, this.props, eventHandler, { ref: 'editor', customStyleMap: customStyleMap, customStyleFn: this.customStyleFn.bind(this), editorState: editorState, handleKeyCommand: this.handleKeyCommand.bind(this), keyBindingFn: this.handleKeyBinding.bind(this), onChange: this.setEditorState.bind(this), blockStyleFn: this.getBlockStyle.bind(this), blockRenderMap: blockRenderMap, handlePastedText: this.handlePastedText, blockRendererFn: this.blockRendererFn.bind(this) })),
	                readOnly ? _react2['default'].createElement('input', { style: focusDummyStyle, ref: function ref(ele) {
	                        return _this8._focusDummy = ele;
	                    }, onBlur: eventHandler.onBlur }) : null,
	                this.props.children
	            )
	        );
	    };
	
	    return EditorCore;
	}(_react2['default'].Component);
	
	EditorCore.GetText = _exportText2['default'];
	EditorCore.GetHTML = (0, _getHTML2['default'])(configStore);
	EditorCore.defaultProps = {
	    multiLines: true,
	    plugins: [],
	    prefixCls: 'rc-editor-core',
	    pluginConfig: {},
	    toolbars: [],
	    spilitLine: 'enter'
	};
	EditorCore.childContextTypes = {
	    getEditorState: _propTypes2['default'].func,
	    setEditorState: _propTypes2['default'].func
	};
	exports['default'] = EditorCore;
	module.exports = exports['default'];
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1183).clearImmediate, __webpack_require__(1183).setImmediate))

/***/ },
/* 2676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _immutable = __webpack_require__(39);
	
	var _ToolbarLine = __webpack_require__(2677);
	
	var _ToolbarLine2 = _interopRequireDefault(_ToolbarLine);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* tslint:disable:interface-name */
	
	
	function noop() {}
	
	var Toolbar = function (_React$Component) {
	    _inherits(Toolbar, _React$Component);
	
	    function Toolbar(props) {
	        _classCallCheck(this, Toolbar);
	
	        var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	        var map = {};
	        props.plugins.forEach(function (plugin) {
	            map[plugin.name] = plugin;
	        });
	        _this.pluginsMap = (0, _immutable.Map)(map);
	        _this.state = {
	            editorState: props.editorState,
	            toolbars: []
	        };
	        return _this;
	    }
	
	    Toolbar.prototype.renderToolbarItem = function renderToolbarItem(pluginName, idx) {
	        var element = this.pluginsMap.get(pluginName);
	        if (element && element.component) {
	            var component = element.component;
	
	            var props = {
	                key: 'toolbar-item-' + idx,
	                onClick: component.props ? component.props.onClick : noop
	            };
	            if (_react2['default'].isValidElement(component)) {
	                return _react2['default'].cloneElement(component, props);
	            }
	            return _react2['default'].createElement(component, props);
	        }
	        return null;
	    };
	
	    Toolbar.prototype.conpomentWillReceiveProps = function conpomentWillReceiveProps(nextProps) {
	        this.render();
	    };
	
	    Toolbar.prototype.render = function render() {
	        var _this2 = this;
	
	        var _props = this.props,
	            toolbars = _props.toolbars,
	            prefixCls = _props.prefixCls;
	
	        return _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-toolbar' },
	            toolbars.map(function (toolbar, idx) {
	                var children = _react2['default'].Children.map(toolbar, _this2.renderToolbarItem.bind(_this2));
	                return _react2['default'].createElement(
	                    _ToolbarLine2['default'],
	                    { key: 'toolbar-' + idx },
	                    children
	                );
	            })
	        );
	    };
	
	    return Toolbar;
	}(_react2['default'].Component);
	
	exports['default'] = Toolbar;
	module.exports = exports['default'];

/***/ },
/* 2677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ToolbarLine = function (_React$Component) {
	    _inherits(ToolbarLine, _React$Component);
	
	    function ToolbarLine() {
	        _classCallCheck(this, ToolbarLine);
	
	        return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	    }
	
	    ToolbarLine.prototype.render = function render() {
	        return _react2['default'].createElement(
	            'div',
	            null,
	            this.props.children
	        );
	    };
	
	    return ToolbarLine;
	}(_react2['default'].Component);
	
	exports['default'] = ToolbarLine;
	module.exports = exports['default'];

/***/ },
/* 2678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createToolbar = createToolbar;
	
	var _Toolbar = __webpack_require__(2676);
	
	var _Toolbar2 = _interopRequireDefault(_Toolbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop(_) {}
	;
	function createToolbar() {
	    var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    function editorStateChange(editorState) {
	        // console.log('>> editorStateChange', editorState);
	    }
	    var callbacks = {
	        onChange: editorStateChange,
	        onUpArrow: noop,
	        onDownArrow: noop,
	        getEditorState: noop,
	        setEditorState: noop,
	        handleReturn: noop
	    };
	    return {
	        name: 'toolbar',
	        decorators: [],
	        callbacks: callbacks,
	        onChange: function onChange(editorState) {
	            return callbacks.onChange ? callbacks.onChange(editorState) : editorState;
	        },
	
	        component: _Toolbar2['default']
	    };
	}

/***/ },
/* 2679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.toEditorState = exports.GetHTML = exports.GetText = exports.EditorCore = undefined;
	
	var _EditorCore = __webpack_require__(2675);
	
	var _EditorCore2 = _interopRequireDefault(_EditorCore);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var GetText = _EditorCore2['default'].GetText,
	    GetHTML = _EditorCore2['default'].GetHTML;
	
	var toEditorState = _EditorCore2['default'].ToEditorState;
	var EditorCorePublic = {
	    EditorCore: _EditorCore2['default'],
	    GetText: GetText,
	    GetHTML: GetHTML,
	    toEditorState: toEditorState
	};
	exports.EditorCore = _EditorCore2['default'];
	exports.GetText = GetText;
	exports.GetHTML = GetHTML;
	exports.toEditorState = toEditorState;
	exports['default'] = EditorCorePublic;

/***/ },
/* 2680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _rcEditorCore = __webpack_require__(2679);
	
	var _draftJs = __webpack_require__(175);
	
	var _createMention = __webpack_require__(2688);
	
	var _createMention2 = _interopRequireDefault(_createMention);
	
	var _exportContent = __webpack_require__(558);
	
	var _exportContent2 = _interopRequireDefault(_exportContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Mention = function (_React$Component) {
	  (0, _inherits3['default'])(Mention, _React$Component);
	
	  function Mention(props) {
	    (0, _classCallCheck3['default'])(this, Mention);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.onEditorChange = function (editorState) {
	      var selection = editorState.getSelection();
	      _this._decorator = editorState.getDecorator();
	      var content = editorState.getCurrentContent();
	
	      if (_this.props.onChange) {
	        _this.setState({
	          selection: selection
	        }, function () {
	          _this.props.onChange(content, (0, _exportContent2['default'])(content));
	        });
	      } else {
	        _this.setState({
	          editorState: editorState,
	          selection: selection
	        });
	      }
	    };
	
	    _this.onFocus = function (e) {
	      if (_this.props.onFocus) {
	        _this.props.onFocus(e);
	      }
	    };
	
	    _this.onBlur = function (e) {
	      if (_this.props.onBlur) {
	        _this.props.onBlur(e);
	      }
	    };
	
	    _this.onKeyDown = function (e) {
	      if (_this.props.onKeyDown) {
	        _this.props.onKeyDown(e);
	      }
	    };
	
	    _this.reset = function () {
	      /*eslint-disable*/
	      _this._editor.Reset();
	      /*eslint-enable*/
	    };
	
	    _this.mention = (0, _createMention2['default'])({
	      prefix: _this.getPrefix(props),
	      tag: props.tag,
	      mode: props.mode,
	      mentionStyle: props.mentionStyle
	    });
	
	    _this.Suggestions = _this.mention.Suggestions;
	    _this.plugins = [_this.mention];
	
	    _this.state = {
	      suggestions: props.suggestions,
	      value: props.value && _draftJs.EditorState.createWithContent(props.value, new _draftJs.CompositeDecorator(_this.mention.decorators)),
	      selection: _draftJs.SelectionState.createEmpty()
	    };
	
	    if (typeof props.defaultValue === 'string') {
	      // eslint-disable-next-line
	      console.warn('The property `defaultValue` now allow `EditorState` only, see http://react-component.github.io/editor-mention/examples/defaultValue.html ');
	    }
	    if (props.value !== undefined) {
	      _this.controlledMode = true;
	    }
	    return _this;
	  }
	
	  Mention.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var suggestions = nextProps.suggestions;
	    var selection = this.state.selection;
	
	    var value = nextProps.value;
	    if (value && selection) {
	      value = _draftJs.EditorState.acceptSelection(_draftJs.EditorState.createWithContent(value, this._decorator), selection);
	    }
	    this.setState({
	      suggestions: suggestions,
	      value: value
	    });
	  };
	
	  Mention.prototype.getPrefix = function getPrefix() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	    return Array.isArray(props.prefix) ? props.prefix : [props.prefix];
	  };
	
	  Mention.prototype.render = function render() {
	    var _classnames,
	        _this2 = this;
	
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        style = _props.style,
	        tag = _props.tag,
	        multiLines = _props.multiLines,
	        editorKey = _props.editorKey,
	        suggestionStyle = _props.suggestionStyle,
	        placeholder = _props.placeholder,
	        defaultValue = _props.defaultValue,
	        className = _props.className,
	        notFoundContent = _props.notFoundContent,
	        getSuggestionContainer = _props.getSuggestionContainer,
	        readOnly = _props.readOnly,
	        disabled = _props.disabled,
	        placement = _props.placement,
	        mode = _props.mode;
	    var suggestions = this.state.suggestions;
	    var Suggestions = this.Suggestions;
	
	    var editorClass = (0, _classnames3['default'])(className, (_classnames = {}, _classnames[prefixCls + '-wrapper'] = true, _classnames.readonly = readOnly, _classnames.disabled = disabled, _classnames.multilines = multiLines, _classnames));
	    var editorProps = this.controlledMode ? { value: this.state.value } : {};
	    var defaultValueState = defaultValue && _draftJs.EditorState.createWithContent(typeof defaultValue === 'string' ? _draftJs.ContentState.createFromText(defaultValue) : defaultValue, this._decorator);
	    return _react2['default'].createElement(
	      'div',
	      { className: editorClass, style: style, ref: function ref(wrapper) {
	          return _this2._wrapper = wrapper;
	        } },
	      _react2['default'].createElement(
	        _rcEditorCore.EditorCore,
	        (0, _extends3['default'])({
	          ref: function ref(editor) {
	            return _this2._editor = editor;
	          },
	          prefixCls: prefixCls,
	          style: style,
	          multiLines: multiLines,
	          editorKey: editorKey,
	          plugins: this.plugins,
	          defaultValue: defaultValueState,
	          placeholder: placeholder,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          onKeyDown: this.onKeyDown,
	          onChange: this.onEditorChange
	        }, editorProps, {
	          readOnly: readOnly || disabled
	        }),
	        _react2['default'].createElement(Suggestions, {
	          mode: tag ? 'immutable' : mode,
	          prefix: this.getPrefix(),
	          prefixCls: prefixCls,
	          style: suggestionStyle,
	          placement: placement,
	          notFoundContent: notFoundContent,
	          suggestions: suggestions,
	          getSuggestionContainer: getSuggestionContainer ? function () {
	            return getSuggestionContainer(_this2._wrapper);
	          } : null,
	          onSearchChange: this.props.onSearchChange,
	          onSelect: this.props.onSelect,
	          noRedup: this.props.noRedup
	        })
	      )
	    );
	  };
	
	  return Mention;
	}(_react2['default'].Component);
	
	Mention.propTypes = {
	  value: _propTypes2['default'].object,
	  suggestions: _propTypes2['default'].array,
	  prefix: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  prefixCls: _propTypes2['default'].string,
	  tag: _propTypes2['default'].oneOfType([_propTypes2['default'].element, _propTypes2['default'].func]),
	  style: _propTypes2['default'].object,
	  className: _propTypes2['default'].string,
	  onSearchChange: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  mode: _propTypes2['default'].string,
	  multiLines: _propTypes2['default'].bool,
	  suggestionStyle: _propTypes2['default'].object,
	  placeholder: _propTypes2['default'].string,
	  defaultValue: _propTypes2['default'].object,
	  notFoundContent: _propTypes2['default'].any,
	  position: _propTypes2['default'].string,
	  onFocus: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  onSelect: _propTypes2['default'].func,
	  onKeyDown: _propTypes2['default'].func,
	  getSuggestionContainer: _propTypes2['default'].func,
	  noRedup: _propTypes2['default'].bool,
	  mentionStyle: _propTypes2['default'].object,
	  placement: _propTypes2['default'].string,
	  editorKey: _propTypes2['default'].string
	};
	Mention.controlledMode = false;
	
	
	Mention.defaultProps = {
	  prefixCls: 'rc-editor-mention',
	  prefix: '@',
	  mode: 'mutable',
	  suggestions: [],
	  multiLines: false,
	  className: '',
	  suggestionStyle: {},
	  notFoundContent: '无法找到',
	  position: 'absolute',
	  placement: 'bottom', // top, bottom
	  mentionStyle: {}
	};
	
	exports['default'] = Mention;
	module.exports = exports['default'];

/***/ },
/* 2681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var MentionContent = function MentionContent(_ref) {
	  var children = _ref.children;
	  return _react2['default'].createElement(
	    'span',
	    { style: { backgroundColor: '#e6f3ff' } },
	    children
	  );
	};
	
	exports['default'] = MentionContent;
	module.exports = exports['default'];

/***/ },
/* 2682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getOffset = __webpack_require__(1087);
	
	var _getOffset2 = _interopRequireDefault(_getOffset);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SuggestionPortal = function (_React$Component) {
	  (0, _inherits3['default'])(SuggestionPortal, _React$Component);
	
	  function SuggestionPortal() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, SuggestionPortal);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.matchDecorates = function (props) {
	      var callbacks = props.callbacks,
	          suggestionRegex = props.suggestionRegex,
	          decoratedText = props.decoratedText;
	
	      var matches = suggestionRegex.exec(decoratedText);
	      _this.trigger = matches[2];
	      _this.updatePortalPosition(_this.props);
	      callbacks.setEditorState(callbacks.getEditorState());
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  SuggestionPortal.prototype.componentWillMount = function componentWillMount() {
	    this.matchDecorates(this.props);
	  };
	
	  SuggestionPortal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.decoratedText !== this.props.decoratedText) {
	      this.matchDecorates(nextProps);
	    }
	    this.updatePortalPosition(nextProps);
	  };
	
	  SuggestionPortal.prototype.componentWillUnmount = function componentWillUnmount() {
	    var _props = this.props,
	        offsetKey = _props.offsetKey,
	        mentionStore = _props.mentionStore;
	
	    mentionStore.inActiveSuggestion({ offsetKey: offsetKey });
	  };
	
	  SuggestionPortal.prototype.updatePortalPosition = function updatePortalPosition(props) {
	    var _this2 = this;
	
	    var offsetKey = props.offsetKey,
	        mentionStore = props.mentionStore;
	
	    mentionStore.updateSuggestion({
	      offsetKey: offsetKey,
	      trigger: this.trigger,
	      position: function position() {
	        var element = _this2.searchPortal;
	        var rect = (0, _getOffset2['default'])(element);
	        return {
	          left: rect.left,
	          top: rect.top,
	          width: element.offsetWidth,
	          height: element.offsetHeight
	        };
	      }
	    });
	  };
	
	  SuggestionPortal.prototype.render = function render() {
	    var _this3 = this;
	
	    return _react2['default'].createElement(
	      'span',
	      { ref: function ref(node) {
	          _this3.searchPortal = node;
	        }, style: this.props.style },
	      this.props.children
	    );
	  };
	
	  return SuggestionPortal;
	}(_react2['default'].Component);
	
	SuggestionPortal.propTypes = {
	  offsetKey: _propTypes2['default'].any,
	  mentionStore: _propTypes2['default'].object,
	  decoratedText: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  callbacks: _propTypes2['default'].any,
	  suggestionRegex: _propTypes2['default'].any
	};
	exports['default'] = SuggestionPortal;
	module.exports = exports['default'];

/***/ },
/* 2683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var IS_REACT_16 = !!_reactDom.createPortal;
	
	var SuggestionWrapper = function (_React$Component) {
	  (0, _inherits3['default'])(SuggestionWrapper, _React$Component);
	
	  function SuggestionWrapper() {
	    (0, _classCallCheck3['default'])(this, SuggestionWrapper);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  SuggestionWrapper.prototype.componentDidMount = function componentDidMount() {
	    this.renderOrReady();
	  };
	
	  SuggestionWrapper.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.renderOrReady();
	  };
	
	  SuggestionWrapper.prototype.renderOrReady = function renderOrReady() {
	    if (IS_REACT_16) {
	      this.props.renderReady();
	    } else {
	      this.renderComponent();
	    }
	  };
	
	  SuggestionWrapper.prototype.renderComponent = function renderComponent() {
	    var _props = this.props,
	        children = _props.children,
	        container = _props.container,
	        renderReady = _props.renderReady;
	
	    (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, children, container, function callback() {
	      if (renderReady) {
	        renderReady.call(this);
	      }
	    });
	  };
	
	  SuggestionWrapper.prototype.render = function render() {
	    if (IS_REACT_16) {
	      var _props2 = this.props,
	          children = _props2.children,
	          container = _props2.container;
	
	      return (0, _reactDom.createPortal)(children, container);
	    }
	    return null;
	  };
	
	  return SuggestionWrapper;
	}(_react2['default'].Component);
	
	exports['default'] = SuggestionWrapper;
	
	
	SuggestionWrapper.propTypes = {
	  children: _propTypes2['default'].any,
	  renderReady: _propTypes2['default'].func,
	  container: _propTypes2['default'].any
	};
	module.exports = exports['default'];

/***/ },
/* 2684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends3 = __webpack_require__(21);
	
	var _extends4 = _interopRequireDefault(_extends3);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _DraftOffsetKey = __webpack_require__(283);
	
	var _rcAnimate = __webpack_require__(111);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _domScrollIntoView = __webpack_require__(281);
	
	var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);
	
	var _Nav = __webpack_require__(1085);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	var _SuggestionWrapper = __webpack_require__(2683);
	
	var _SuggestionWrapper2 = _interopRequireDefault(_SuggestionWrapper);
	
	var _insertMention = __webpack_require__(2689);
	
	var _insertMention2 = _interopRequireDefault(_insertMention);
	
	var _clearMention = __webpack_require__(2687);
	
	var _clearMention2 = _interopRequireDefault(_clearMention);
	
	var _getOffset = __webpack_require__(1087);
	
	var _getOffset2 = _interopRequireDefault(_getOffset);
	
	var _getMentions = __webpack_require__(1086);
	
	var _getMentions2 = _interopRequireDefault(_getMentions);
	
	var _getSearchWord2 = __webpack_require__(559);
	
	var _getSearchWord3 = _interopRequireDefault(_getSearchWord2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var isNotFalse = function isNotFalse(i) {
	  return i !== false;
	};
	
	var Suggestions = function (_React$Component) {
	  (0, _inherits3['default'])(Suggestions, _React$Component);
	
	  function Suggestions() {
	    (0, _classCallCheck3['default'])(this, Suggestions);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this));
	
	    _this.onEditorStateChange = function (editorState) {
	      var offset = _this.props.store.getOffset();
	      if (offset.size === 0) {
	        _this.closeDropDown();
	        return editorState;
	      }
	      var selection = editorState.getSelection();
	
	      // 修复: 焦点移出再移入时, dropdown 会闪动一下
	      // 原因: https://github.com/facebook/draft-js/blob/67c5e69499e3b0c149ce83b004872afdf4180463/src/component/handlers/edit/editOnFocus.js#L33
	      // 此处强制 update 了一下,因此 onEditorStateChange 会 call 两次
	      if (!_this.props.callbacks.getEditorState().getSelection().getHasFocus() && selection.getHasFocus()) {
	        return editorState;
	      }
	
	      var _getSearchWord = (0, _getSearchWord3['default'])(editorState, selection),
	          word = _getSearchWord.word;
	
	      if (!word) {
	        _this.closeDropDown();
	        return editorState;
	      }
	      var selectionInsideMention = offset.map(function (_ref) {
	        var offsetKey = _ref.offsetKey;
	
	        var _decode = (0, _DraftOffsetKey.decode)(offsetKey),
	            blockKey = _decode.blockKey,
	            decoratorKey = _decode.decoratorKey,
	            leafKey = _decode.leafKey;
	
	        if (blockKey !== selection.anchorKey) {
	          return false;
	        }
	        var leaf = editorState.getBlockTree(blockKey).getIn([decoratorKey, 'leaves', leafKey]);
	        if (!leaf) {
	          return false;
	        }
	        var startKey = leaf.get('start');
	        var endKey = leaf.get('end');
	        // 处理只有一个 `@` 符号时的情况
	        if (!word) {
	          return false;
	        }
	        if (startKey === endKey - 1) {
	          return selection.anchorOffset >= startKey + 1 && selection.anchorOffset <= endKey ? offsetKey : false;
	        }
	        return selection.anchorOffset > startKey + 1 && selection.anchorOffset <= endKey ? offsetKey : false;
	      });
	
	      var selectionInText = selectionInsideMention.some(isNotFalse);
	      _this.activeOffsetKey = selectionInsideMention.find(isNotFalse) || _this.activeOffsetKey;
	      var trigger = _this.props.store.getTrigger(_this.activeOffsetKey);
	
	      if (!selectionInText || !selection.getHasFocus()) {
	        _this.closeDropDown();
	        return editorState;
	      }
	      var searchValue = word.substring(trigger.length, word.length);
	      if (_this.lastSearchValue !== searchValue || _this.lastTrigger !== trigger) {
	        _this.lastSearchValue = searchValue;
	        _this.lastTrigger = trigger;
	        _this.props.onSearchChange(searchValue, trigger);
	      }
	      if (!_this.state.active) {
	        // 特例处理 https://github.com/ant-design/ant-design/issues/7838
	        // 暂时没有更优雅的方法
	        if (!trigger || word.indexOf(trigger) !== -1) {
	          _this.openDropDown();
	        }
	      }
	      return editorState;
	    };
	
	    _this.onUpArrow = function (ev) {
	      ev.preventDefault();
	      if (_this.props.suggestions.length > 0) {
	        var newIndex = _this.state.focusedIndex - 1;
	        _this.setState({
	          focusedIndex: Math.max(newIndex, 0)
	        });
	      }
	    };
	
	    _this.onBlur = function (ev) {
	      ev.preventDefault();
	      _this.closeDropDown();
	    };
	
	    _this.onDownArrow = function (ev) {
	      ev.preventDefault();
	      var newIndex = _this.state.focusedIndex + 1;
	      _this.setState({
	        focusedIndex: newIndex >= _this.props.suggestions.length ? 0 : newIndex
	      });
	    };
	
	    _this.getContainer = function () {
	      var popupContainer = document.createElement('div');
	      var mountNode = void 0;
	      if (_this.props.getSuggestionContainer) {
	        mountNode = _this.props.getSuggestionContainer();
	        popupContainer.style.position = 'relative';
	      } else {
	        mountNode = document.body;
	      }
	      mountNode.appendChild(popupContainer);
	      return popupContainer;
	    };
	
	    _this.handleKeyBinding = function (command) {
	      return command === 'split-block';
	    };
	
	    _this.handleReturn = function (ev) {
	      ev.preventDefault();
	      var selectedSuggestion = _this.props.suggestions[_this.state.focusedIndex];
	      if (selectedSuggestion) {
	        if (_react2['default'].isValidElement(selectedSuggestion)) {
	          _this.onMentionSelect(selectedSuggestion.props.value, selectedSuggestion.props.data);
	        } else {
	          _this.onMentionSelect(selectedSuggestion);
	        }
	        _this.lastSearchValue = null;
	        _this.lastTrigger = null;
	        return true;
	      }
	      return false;
	    };
	
	    _this.renderReady = function () {
	      var container = _this.dropdownContainer;
	      if (!container) {
	        return;
	      }
	      var active = _this.state.active;
	      var activeOffsetKey = _this.activeOffsetKey;
	
	      var offset = _this.props.store.getOffset();
	      var dropDownPosition = offset.get(activeOffsetKey);
	
	      if (active && dropDownPosition) {
	        var placement = _this.props.placement;
	        var dropDownStyle = _this.getPositionStyle(true, dropDownPosition.position());
	
	        // Check if the above space is crowded
	        var isTopCrowded = parseFloat(dropDownStyle.top) - window.scrollY - container.offsetHeight < 0;
	        // Check if the under space is crowded
	        var isBottomCrowded = (window.innerHeight || document.documentElement.clientHeight) - (parseFloat(dropDownStyle.top) - window.scrollY) - container.offsetHeight < 0;
	
	        if (placement === 'top' && !isTopCrowded) {
	          // The above space isn't crowded
	          dropDownStyle.top = (parseFloat(dropDownStyle.top) - container.offsetHeight || 0) + 'px';
	        }
	
	        if (placement === 'bottom' && isBottomCrowded && !isTopCrowded) {
	          // The above space isn't crowded and the under space is crowded.
	          dropDownStyle.top = (parseFloat(dropDownStyle.top) - container.offsetHeight || 0) + 'px';
	        }
	
	        Object.keys(dropDownStyle).forEach(function (key) {
	          container.style[key] = dropDownStyle[key];
	        });
	      }
	
	      if (!_this.focusItem) {
	        return;
	      }
	      (0, _domScrollIntoView2['default'])(_reactDom2['default'].findDOMNode(_this.focusItem), container, {
	        onlyScrollIfNeeded: true
	      });
	    };
	
	    _this.getNavigations = function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          suggestions = _this$props.suggestions;
	      var focusedIndex = _this.state.focusedIndex;
	
	      return suggestions.length ? _react2['default'].Children.map(suggestions, function (element, index) {
	        var focusItem = index === focusedIndex;
	        var ref = focusItem ? function (node) {
	          _this.focusItem = node;
	        } : null;
	        var mentionClass = (0, _classnames2['default'])(prefixCls + '-dropdown-item', {
	          focus: focusItem
	        });
	        if (_react2['default'].isValidElement(element)) {
	          return _react2['default'].cloneElement(element, {
	            className: mentionClass,
	            onMouseDown: function onMouseDown() {
	              return _this.onDropdownMentionSelect(element.props.value, element.props.data);
	            },
	            ref: ref
	          });
	        }
	        return _react2['default'].createElement(
	          _Nav2['default'],
	          {
	            ref: ref,
	            className: mentionClass,
	            onMouseDown: function onMouseDown() {
	              return _this.onDropdownMentionSelect(element);
	            }
	          },
	          element
	        );
	      }, _this) : _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-dropdown-notfound ' + prefixCls + '-dropdown-item' },
	        _this.props.notFoundContent
	      );
	    };
	
	    _this.state = {
	      isActive: false,
	      focusedIndex: 0,
	      container: false
	    };
	    return _this;
	  }
	
	  Suggestions.prototype.componentDidMount = function componentDidMount() {
	    this.props.callbacks.onChange = this.onEditorStateChange;
	  };
	
	  Suggestions.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.suggestions.length !== this.props.suggestions.length) {
	      this.setState({
	        focusedIndex: 0
	      });
	    }
	  };
	
	  Suggestions.prototype.onDropdownMentionSelect = function onDropdownMentionSelect(mention, data) {
	    var _this2 = this;
	
	    setTimeout(function () {
	      _this2.onMentionSelect(mention, data);
	    }, 100);
	  };
	
	  Suggestions.prototype.onMentionSelect = function onMentionSelect(mention, data) {
	    var editorState = this.props.callbacks.getEditorState();
	    var _props = this.props,
	        store = _props.store,
	        onSelect = _props.onSelect;
	
	    var trigger = store.getTrigger(this.activeOffsetKey);
	    if (onSelect) {
	      onSelect(mention, data || mention);
	    }
	    if (this.props.noRedup) {
	      var mentions = (0, _getMentions2['default'])(editorState.getCurrentContent(), trigger);
	      if (mentions.indexOf('' + trigger + mention) !== -1) {
	        // eslint-disable-next-line
	        console.warn('you have specified `noRedup` props but have duplicated mentions.');
	        this.closeDropDown();
	        this.props.callbacks.setEditorState((0, _clearMention2['default'])(editorState));
	        return;
	      }
	    }
	    this.props.callbacks.setEditorState((0, _insertMention2['default'])(editorState, '' + trigger + mention, data, this.props.mode), true);
	    this.closeDropDown();
	  };
	
	  Suggestions.prototype.getPositionStyle = function getPositionStyle(isActive, position) {
	    if (this.props.getSuggestionStyle) {
	      return this.props.getSuggestionStyle(isActive, position);
	    }
	    var container = this.props.getSuggestionContainer ? this.state.container : document.body;
	    var offset = (0, _getOffset2['default'])(container);
	    return position ? (0, _extends4['default'])({
	      position: 'absolute',
	      left: position.left - offset.left + 'px',
	      top: position.top - offset.top + 'px'
	    }, this.props.style) : {};
	  };
	
	  Suggestions.prototype.openDropDown = function openDropDown() {
	    this.props.callbacks.onUpArrow = this.onUpArrow;
	    this.props.callbacks.handleReturn = this.handleReturn;
	    this.props.callbacks.handleKeyBinding = this.handleKeyBinding;
	    this.props.callbacks.onDownArrow = this.onDownArrow;
	    this.props.callbacks.onBlur = this.onBlur;
	    this.setState({
	      active: true,
	      container: this.state.container || this.getContainer()
	    });
	  };
	
	  Suggestions.prototype.closeDropDown = function closeDropDown() {
	    this.props.callbacks.onUpArrow = null;
	    this.props.callbacks.handleReturn = null;
	    this.props.callbacks.handleKeyBinding = null;
	    this.props.callbacks.onDownArrow = null;
	    this.props.callbacks.onBlur = null;
	    this.setState({
	      active: false
	    });
	  };
	
	  Suggestions.prototype.render = function render() {
	    var _extends2,
	        _this3 = this;
	
	    var _props2 = this.props,
	        prefixCls = _props2.prefixCls,
	        className = _props2.className,
	        placement = _props2.placement;
	    var _state = this.state,
	        container = _state.container,
	        active = _state.active;
	
	    var cls = (0, _classnames2['default'])((0, _extends4['default'])((_extends2 = {}, _extends2[prefixCls + '-dropdown'] = true, _extends2[prefixCls + '-dropdown-placement-' + placement] = true, _extends2), className));
	    var transitionName = placement === 'top' ? 'slide-down' : 'slide-up';
	
	    var navigations = this.getNavigations();
	
	    return container ? _react2['default'].createElement(
	      _SuggestionWrapper2['default'],
	      { renderReady: this.renderReady, container: container },
	      _react2['default'].createElement(
	        _rcAnimate2['default'],
	        { transitionName: transitionName },
	        active ? _react2['default'].createElement(
	          'div',
	          { className: cls, ref: function ref(node) {
	              _this3.dropdownContainer = node;
	            } },
	          navigations
	        ) : null
	      )
	    ) : null;
	  };
	
	  return Suggestions;
	}(_react2['default'].Component);
	
	exports['default'] = Suggestions;
	
	
	Suggestions.propTypes = {
	  callbacks: _propTypes2['default'].object,
	  suggestions: _propTypes2['default'].array,
	  store: _propTypes2['default'].object,
	  onSearchChange: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  mode: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  onSelect: _propTypes2['default'].func,
	  getSuggestionContainer: _propTypes2['default'].func,
	  notFoundContent: _propTypes2['default'].any,
	  getSuggestionStyle: _propTypes2['default'].func,
	  className: _propTypes2['default'].string,
	  noRedup: _propTypes2['default'].bool,
	  placement: _propTypes2['default'].string
	};
	module.exports = exports['default'];

/***/ },
/* 2685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getMentions = exports.toEditorState = exports.toString = exports.Nav = undefined;
	
	var _draftJs = __webpack_require__(175);
	
	var _Mention = __webpack_require__(2680);
	
	var _Mention2 = _interopRequireDefault(_Mention);
	
	var _exportContent = __webpack_require__(558);
	
	var _exportContent2 = _interopRequireDefault(_exportContent);
	
	var _getMentions = __webpack_require__(1086);
	
	var _getMentions2 = _interopRequireDefault(_getMentions);
	
	var _Nav = __webpack_require__(1085);
	
	var _Nav2 = _interopRequireDefault(_Nav);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function toEditorState(text) {
	  return _draftJs.ContentState.createFromText(text);
	} // export this package's api
	
	
	_Mention2['default'].Nav = _Nav2['default'];
	_Mention2['default'].toString = _exportContent2['default'];
	_Mention2['default'].toEditorState = toEditorState;
	_Mention2['default'].getMentions = _getMentions2['default'];
	
	exports.Nav = _Nav2['default'];
	exports.toString = _exportContent2['default'];
	exports.toEditorState = toEditorState;
	exports.getMentions = _getMentions2['default'];
	exports['default'] = _Mention2['default'];

/***/ },
/* 2686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _immutable = __webpack_require__(39);
	
	var offset = (0, _immutable.Map)(); /* eslint new-cap: [2, {capIsNewExceptions: ["Map"]}] */
	
	var mentionStore = {
	  offset: (0, _immutable.Map)(),
	  getOffset: function getOffset() {
	    return offset;
	  },
	  getTrigger: function getTrigger(offsetKey) {
	    var currentOffset = offset.get(offsetKey);
	    return currentOffset && currentOffset.trigger;
	  },
	  activeSuggestion: function activeSuggestion(_ref) {
	    var offsetKey = _ref.offsetKey;
	
	    offset = offset.set(offsetKey, {
	      offsetKey: offsetKey
	    });
	  },
	  inActiveSuggestion: function inActiveSuggestion(_ref2) {
	    var offsetKey = _ref2.offsetKey;
	
	    offset = offset['delete'](offsetKey);
	  },
	  updateSuggestion: function updateSuggestion(_ref3) {
	    var offsetKey = _ref3.offsetKey,
	        position = _ref3.position,
	        trigger = _ref3.trigger;
	
	    offset = offset.set(offsetKey, {
	      offsetKey: offsetKey,
	      position: position,
	      trigger: trigger
	    });
	  }
	};
	
	exports['default'] = mentionStore;
	module.exports = exports['default'];

/***/ },
/* 2687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = clearMention;
	
	var _draftJs = __webpack_require__(175);
	
	var _getSearchWord = __webpack_require__(559);
	
	var _getSearchWord2 = _interopRequireDefault(_getSearchWord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function clearMention(editorState) {
	  var selection = editorState.getSelection();
	  var searchWord = (0, _getSearchWord2['default'])(editorState, selection);
	  var begin = searchWord.begin,
	      end = searchWord.end;
	
	  var replacedContent = _draftJs.Modifier.replaceText(editorState.getCurrentContent(), selection.merge({
	    anchorOffset: begin,
	    focusOffset: end
	  }), '', null);
	
	  var InsertSpaceContent = _draftJs.Modifier.insertText(replacedContent, replacedContent.getSelectionAfter(), ' ');
	
	  var newEditorState = _draftJs.EditorState.push(editorState, InsertSpaceContent, 'insert-mention');
	  return _draftJs.EditorState.forceSelection(newEditorState, InsertSpaceContent.getSelectionAfter());
	}
	module.exports = exports['default'];

/***/ },
/* 2688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	exports['default'] = createMention;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Suggestions2 = __webpack_require__(2684);
	
	var _Suggestions3 = _interopRequireDefault(_Suggestions2);
	
	var _SuggestionPortal = __webpack_require__(2682);
	
	var _SuggestionPortal2 = _interopRequireDefault(_SuggestionPortal);
	
	var _MentionContent = __webpack_require__(2681);
	
	var _MentionContent2 = _interopRequireDefault(_MentionContent);
	
	var _mentionStore = __webpack_require__(2686);
	
	var _mentionStore2 = _interopRequireDefault(_mentionStore);
	
	var _exportContent = __webpack_require__(558);
	
	var _exportContent2 = _interopRequireDefault(_exportContent);
	
	var _getRegExp = __webpack_require__(1088);
	
	var _getRegExp2 = _interopRequireDefault(_getRegExp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function findWithRegex(regex, contentBlock, callback) {
	  // Get the text from the contentBlock
	  var text = contentBlock.getText();
	  var matchArr = void 0;
	  var start = void 0; // eslint-disable-line
	  var end = void 0;
	  // Go through all matches in the text and return the indizes to the callback
	  while ((matchArr = regex.exec(text)) !== null) {
	    // eslint-disable-line
	    start = matchArr.index;
	    end = start + matchArr[0].length;
	    callback(start, end);
	    if (start === end) break;
	  }
	}
	
	function mentionContentStrategy(contentBlock, callback, contentState) {
	  contentBlock.findEntityRanges(function (character) {
	    var entityKey = character.getEntity();
	    return entityKey && contentState.getEntity(entityKey).getType() === 'mention';
	  }, callback);
	}
	
	function noop() {}
	
	var MentionContentComponent = function MentionContentComponent(props) {
	  var entityKey = props.entityKey,
	      tag = props.tag,
	      callbacks = props.callbacks;
	
	  var contentState = callbacks.getEditorState().getCurrentContent();
	  var data = contentState.getEntity(entityKey).getData();
	  return _react2['default'].createElement(tag, (0, _extends3['default'])({}, props, { data: data }));
	};
	
	function createMention() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var callbacks = {
	    onChange: noop,
	    onUpArrow: noop,
	    onDownArrow: noop,
	    getEditorState: noop,
	    setEditorState: noop,
	    handleReturn: noop,
	    onBlur: noop
	  };
	  var componentProps = {
	    callbacks: callbacks,
	    mentionStore: _mentionStore2['default']
	  };
	  var suggestionRegex = (0, _getRegExp2['default'])(config.prefix);
	
	  var tag = config.tag || _MentionContent2['default'];
	  var decorators = [{
	    strategy: function strategy(contentBlock, callback) {
	      findWithRegex(suggestionRegex, contentBlock, callback);
	    },
	    component: function component(props) {
	      return _react2['default'].createElement(_SuggestionPortal2['default'], (0, _extends3['default'])({}, props, componentProps, {
	        style: config.mentionStyle,
	        suggestionRegex: (0, _getRegExp2['default'])(config.prefix)
	      }));
	    }
	  }];
	  if (config.mode === 'immutable') {
	    decorators.unshift({
	      strategy: mentionContentStrategy,
	      component: function component(props) {
	        return _react2['default'].createElement(MentionContentComponent, (0, _extends3['default'])({ tag: tag }, props, { callbacks: callbacks }));
	      }
	    });
	  }
	
	  return {
	    name: 'mention',
	    Suggestions: function Suggestions(props) {
	      return _react2['default'].createElement(_Suggestions3['default'], (0, _extends3['default'])({}, props, componentProps, {
	        store: _mentionStore2['default']
	      }));
	    },
	    decorators: decorators,
	    onChange: function onChange(editorState) {
	      return callbacks.onChange ? callbacks.onChange(editorState) : editorState;
	    },
	    callbacks: callbacks,
	    'export': _exportContent2['default']
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 2689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = insertMention;
	
	var _draftJs = __webpack_require__(175);
	
	var _getSearchWord = __webpack_require__(559);
	
	var _getSearchWord2 = _interopRequireDefault(_getSearchWord);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function insertMention(editorState, mention, data, mode) {
	  var entityMode = mode === 'immutable' ? 'IMMUTABLE' : 'MUTABLE';
	  var selection = editorState.getSelection();
	  var contentState = editorState.getCurrentContent();
	
	  contentState.createEntity('mention', entityMode, data || mention);
	  var searchWord = (0, _getSearchWord2['default'])(editorState, selection);
	  var begin = searchWord.begin,
	      end = searchWord.end;
	
	  var replacedContent = _draftJs.Modifier.replaceText(contentState, selection.merge({
	    anchorOffset: begin,
	    focusOffset: end
	  }), mention, null, contentState.getLastCreatedEntityKey());
	
	  var InsertSpaceContent = _draftJs.Modifier.insertText(replacedContent, replacedContent.getSelectionAfter(), ' ');
	
	  var newEditorState = _draftJs.EditorState.push(editorState, InsertSpaceContent, 'insert-mention');
	  return _draftJs.EditorState.forceSelection(newEditorState, InsertSpaceContent.getSelectionAfter());
	}
	module.exports = exports['default'];

/***/ },
/* 2690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var FieldElemWrapper = function (_React$Component) {
	  (0, _inherits3['default'])(FieldElemWrapper, _React$Component);
	
	  function FieldElemWrapper() {
	    (0, _classCallCheck3['default'])(this, FieldElemWrapper);
	    return (0, _possibleConstructorReturn3['default'])(this, (FieldElemWrapper.__proto__ || Object.getPrototypeOf(FieldElemWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(FieldElemWrapper, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          name = _props.name,
	          form = _props.form;
	
	      form.domFields[name] = true;
	      form.recoverClearedField(name);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      var _props2 = this.props,
	          name = _props2.name,
	          form = _props2.form;
	
	      var fieldMeta = form.fieldsStore.getFieldMeta(name);
	      if (!fieldMeta.preserve) {
	        // after destroy, delete data
	        form.clearedFieldMetaCache[name] = {
	          field: form.fieldsStore.getField(name),
	          meta: fieldMeta
	        };
	        form.clearField(name);
	      }
	      delete form.domFields[name];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return FieldElemWrapper;
	}(_react2['default'].Component);
	
	exports['default'] = FieldElemWrapper;
	
	
	FieldElemWrapper.propTypes = {
	  name: _propTypes2['default'].string,
	  form: _propTypes2['default'].shape({
	    domFields: _propTypes2['default'].objectOf(_propTypes2['default'].bool),
	    recoverClearedField: _propTypes2['default'].func,
	    fieldsStore: _propTypes2['default'].shape({
	      getFieldMeta: _propTypes2['default'].func,
	      getField: _propTypes2['default'].func
	    }),
	    clearedFieldMetaCache: _propTypes2['default'].objectOf(_propTypes2['default'].shape({
	      field: _propTypes2['default'].object,
	      meta: _propTypes2['default'].object
	    })),
	    clearField: _propTypes2['default'].func
	  }),
	  children: _propTypes2['default'].node
	};
	module.exports = exports['default'];

/***/ },
/* 2691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _domScrollIntoView = __webpack_require__(281);
	
	var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);
	
	var _has = __webpack_require__(2591);
	
	var _has2 = _interopRequireDefault(_has);
	
	var _createBaseForm = __webpack_require__(1089);
	
	var _createBaseForm2 = _interopRequireDefault(_createBaseForm);
	
	var _createForm = __webpack_require__(2693);
	
	var _utils = __webpack_require__(560);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function computedStyle(el, prop) {
	  var getComputedStyle = window.getComputedStyle;
	  var style =
	  // If we have getComputedStyle
	  getComputedStyle ?
	  // Query it
	  // TODO: From CSS-Query notes, we might need (node, null) for FF
	  getComputedStyle(el) :
	
	  // Otherwise, we are in IE and use currentStyle
	  el.currentStyle;
	  if (style) {
	    return style[
	    // Switch to camelCase for CSSOM
	    // DEV: Grabbed from jQuery
	    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
	    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
	    prop.replace(/-(\w)/gi, function (word, letter) {
	      return letter.toUpperCase();
	    })];
	  }
	  return undefined;
	}
	
	function getScrollableContainer(n) {
	  var node = n;
	  var nodeName = void 0;
	  /* eslint no-cond-assign:0 */
	  while ((nodeName = node.nodeName.toLowerCase()) !== 'body') {
	    var overflowY = computedStyle(node, 'overflowY');
	    // https://stackoverflow.com/a/36900407/3040605
	    if (node !== n && (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
	      return node;
	    }
	    node = node.parentNode;
	  }
	  return nodeName === 'body' ? node.ownerDocument : node;
	}
	
	var mixin = {
	  getForm: function getForm() {
	    return (0, _extends3['default'])({}, _createForm.mixin.getForm.call(this), {
	      validateFieldsAndScroll: this.validateFieldsAndScroll
	    });
	  },
	  validateFieldsAndScroll: function validateFieldsAndScroll(ns, opt, cb) {
	    var _this = this;
	
	    var _getParams = (0, _utils.getParams)(ns, opt, cb),
	        names = _getParams.names,
	        callback = _getParams.callback,
	        options = _getParams.options;
	
	    var newCb = function newCb(error, values) {
	      if (error) {
	        var validNames = _this.fieldsStore.getValidFieldsName();
	        var firstNode = void 0;
	        var firstTop = void 0;
	
	        validNames.forEach(function (name) {
	          if ((0, _has2['default'])(error, name)) {
	            var instance = _this.getFieldInstance(name);
	            if (instance) {
	              var node = _reactDom2['default'].findDOMNode(instance);
	              var top = node.getBoundingClientRect().top;
	              if (node.type !== 'hidden' && (firstTop === undefined || firstTop > top)) {
	                firstTop = top;
	                firstNode = node;
	              }
	            }
	          }
	        });
	
	        if (firstNode) {
	          var c = options.container || getScrollableContainer(firstNode);
	          (0, _domScrollIntoView2['default'])(firstNode, c, (0, _extends3['default'])({
	            onlyScrollIfNeeded: true
	          }, options.scroll));
	        }
	      }
	
	      if (typeof callback === 'function') {
	        callback(error, values);
	      }
	    };
	
	    return this.validateFields(names, options, newCb);
	  }
	};
	
	function createDOMForm(option) {
	  return (0, _createBaseForm2['default'])((0, _extends3['default'])({}, option), [mixin]);
	}
	
	exports['default'] = createDOMForm;
	module.exports = exports['default'];

/***/ },
/* 2692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	exports['default'] = createFieldsStore;
	
	var _set = __webpack_require__(928);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _createFormField = __webpack_require__(1090);
	
	var _createFormField2 = _interopRequireDefault(_createFormField);
	
	var _utils = __webpack_require__(560);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function partOf(a, b) {
	  return b.indexOf(a) === 0 && ['.', '['].indexOf(b[a.length]) !== -1;
	}
	
	function internalFlattenFields(fields) {
	  return (0, _utils.flattenFields)(fields, function (_, node) {
	    return (0, _createFormField.isFormField)(node);
	  }, 'You must wrap field data with `createFormField`.');
	}
	
	var FieldsStore = function () {
	  function FieldsStore(fields) {
	    (0, _classCallCheck3['default'])(this, FieldsStore);
	
	    _initialiseProps.call(this);
	
	    this.fields = internalFlattenFields(fields);
	    this.fieldsMeta = {};
	  }
	
	  (0, _createClass3['default'])(FieldsStore, [{
	    key: 'updateFields',
	    value: function updateFields(fields) {
	      this.fields = internalFlattenFields(fields);
	    }
	  }, {
	    key: 'flattenRegisteredFields',
	    value: function flattenRegisteredFields(fields) {
	      var validFieldsName = this.getAllFieldsName();
	      return (0, _utils.flattenFields)(fields, function (path) {
	        return validFieldsName.indexOf(path) >= 0;
	      }, 'You cannot set a form field before rendering a field associated with the value.');
	    }
	  }, {
	    key: 'setFields',
	    value: function setFields(fields) {
	      var _this = this;
	
	      var fieldsMeta = this.fieldsMeta;
	      var nowFields = (0, _extends3['default'])({}, this.fields, fields);
	      var nowValues = {};
	      Object.keys(fieldsMeta).forEach(function (f) {
	        nowValues[f] = _this.getValueFromFields(f, nowFields);
	      });
	      Object.keys(nowValues).forEach(function (f) {
	        var value = nowValues[f];
	        var fieldMeta = _this.getFieldMeta(f);
	        if (fieldMeta && fieldMeta.normalize) {
	          var nowValue = fieldMeta.normalize(value, _this.getValueFromFields(f, _this.fields), nowValues);
	          if (nowValue !== value) {
	            nowFields[f] = (0, _extends3['default'])({}, nowFields[f], {
	              value: nowValue
	            });
	          }
	        }
	      });
	      this.fields = nowFields;
	    }
	  }, {
	    key: 'resetFields',
	    value: function resetFields(ns) {
	      var fields = this.fields;
	
	      var names = ns ? this.getValidFieldsFullName(ns) : this.getAllFieldsName();
	      return names.reduce(function (acc, name) {
	        var field = fields[name];
	        if (field && 'value' in field) {
	          acc[name] = {};
	        }
	        return acc;
	      }, {});
	    }
	  }, {
	    key: 'setFieldMeta',
	    value: function setFieldMeta(name, meta) {
	      this.fieldsMeta[name] = meta;
	    }
	  }, {
	    key: 'setFieldsAsDirty',
	    value: function setFieldsAsDirty() {
	      var _this2 = this;
	
	      Object.keys(this.fields).forEach(function (name) {
	        var field = _this2.fields[name];
	        var fieldMeta = _this2.fieldsMeta[name];
	        if (field && fieldMeta && (0, _utils.hasRules)(fieldMeta.validate)) {
	          _this2.fields[name] = (0, _extends3['default'])({}, field, {
	            dirty: true
	          });
	        }
	      });
	    }
	  }, {
	    key: 'getFieldMeta',
	    value: function getFieldMeta(name) {
	      this.fieldsMeta[name] = this.fieldsMeta[name] || {};
	      return this.fieldsMeta[name];
	    }
	  }, {
	    key: 'getValueFromFields',
	    value: function getValueFromFields(name, fields) {
	      var field = fields[name];
	      if (field && 'value' in field) {
	        return field.value;
	      }
	      var fieldMeta = this.getFieldMeta(name);
	      return fieldMeta && fieldMeta.initialValue;
	    }
	  }, {
	    key: 'getValidFieldsName',
	    value: function getValidFieldsName() {
	      var _this3 = this;
	
	      var fieldsMeta = this.fieldsMeta;
	
	      return fieldsMeta ? Object.keys(fieldsMeta).filter(function (name) {
	        return !_this3.getFieldMeta(name).hidden;
	      }) : [];
	    }
	  }, {
	    key: 'getAllFieldsName',
	    value: function getAllFieldsName() {
	      var fieldsMeta = this.fieldsMeta;
	
	      return fieldsMeta ? Object.keys(fieldsMeta) : [];
	    }
	  }, {
	    key: 'getValidFieldsFullName',
	    value: function getValidFieldsFullName(maybePartialName) {
	      var maybePartialNames = Array.isArray(maybePartialName) ? maybePartialName : [maybePartialName];
	      return this.getValidFieldsName().filter(function (fullName) {
	        return maybePartialNames.some(function (partialName) {
	          return fullName === partialName || (0, _utils.startsWith)(fullName, partialName) && ['.', '['].indexOf(fullName[partialName.length]) >= 0;
	        });
	      });
	    }
	  }, {
	    key: 'getFieldValuePropValue',
	    value: function getFieldValuePropValue(fieldMeta) {
	      var name = fieldMeta.name,
	          getValueProps = fieldMeta.getValueProps,
	          valuePropName = fieldMeta.valuePropName;
	
	      var field = this.getField(name);
	      var fieldValue = 'value' in field ? field.value : fieldMeta.initialValue;
	      if (getValueProps) {
	        return getValueProps(fieldValue);
	      }
	      return (0, _defineProperty3['default'])({}, valuePropName, fieldValue);
	    }
	  }, {
	    key: 'getField',
	    value: function getField(name) {
	      return (0, _extends3['default'])({}, this.fields[name], {
	        name: name
	      });
	    }
	  }, {
	    key: 'getNotCollectedFields',
	    value: function getNotCollectedFields() {
	      var _this4 = this;
	
	      var fieldsName = this.getValidFieldsName();
	      return fieldsName.filter(function (name) {
	        return !_this4.fields[name];
	      }).map(function (name) {
	        return {
	          name: name,
	          dirty: false,
	          value: _this4.getFieldMeta(name).initialValue
	        };
	      }).reduce(function (acc, field) {
	        return (0, _set2['default'])(acc, field.name, (0, _createFormField2['default'])(field));
	      }, {});
	    }
	  }, {
	    key: 'getNestedAllFields',
	    value: function getNestedAllFields() {
	      var _this5 = this;
	
	      return Object.keys(this.fields).reduce(function (acc, name) {
	        return (0, _set2['default'])(acc, name, (0, _createFormField2['default'])(_this5.fields[name]));
	      }, this.getNotCollectedFields());
	    }
	  }, {
	    key: 'getFieldMember',
	    value: function getFieldMember(name, member) {
	      return this.getField(name)[member];
	    }
	  }, {
	    key: 'getNestedFields',
	    value: function getNestedFields(names, getter) {
	      var fields = names || this.getValidFieldsName();
	      return fields.reduce(function (acc, f) {
	        return (0, _set2['default'])(acc, f, getter(f));
	      }, {});
	    }
	  }, {
	    key: 'getNestedField',
	    value: function getNestedField(name, getter) {
	      var fullNames = this.getValidFieldsFullName(name);
	      if (fullNames.length === 0 || // Not registered
	      fullNames.length === 1 && fullNames[0] === name // Name already is full name.
	      ) {
	          return getter(name);
	        }
	      var isArrayValue = fullNames[0][name.length] === '[';
	      var suffixNameStartIndex = isArrayValue ? name.length : name.length + 1;
	      return fullNames.reduce(function (acc, fullName) {
	        return (0, _set2['default'])(acc, fullName.slice(suffixNameStartIndex), getter(fullName));
	      }, isArrayValue ? [] : {});
	    }
	  }, {
	    key: 'isValidNestedFieldName',
	
	
	    // @private
	    // BG: `a` and `a.b` cannot be use in the same form
	    value: function isValidNestedFieldName(name) {
	      var names = this.getAllFieldsName();
	      return names.every(function (n) {
	        return !partOf(n, name) && !partOf(name, n);
	      });
	    }
	  }, {
	    key: 'clearField',
	    value: function clearField(name) {
	      delete this.fields[name];
	      delete this.fieldsMeta[name];
	    }
	  }]);
	  return FieldsStore;
	}();
	
	var _initialiseProps = function _initialiseProps() {
	  var _this6 = this;
	
	  this.setFieldsInitialValue = function (initialValues) {
	    var flattenedInitialValues = _this6.flattenRegisteredFields(initialValues);
	    var fieldsMeta = _this6.fieldsMeta;
	    Object.keys(flattenedInitialValues).forEach(function (name) {
	      if (fieldsMeta[name]) {
	        _this6.setFieldMeta(name, (0, _extends3['default'])({}, _this6.getFieldMeta(name), {
	          initialValue: flattenedInitialValues[name]
	        }));
	      }
	    });
	  };
	
	  this.getAllValues = function () {
	    var fieldsMeta = _this6.fieldsMeta,
	        fields = _this6.fields;
	
	    return Object.keys(fieldsMeta).reduce(function (acc, name) {
	      return (0, _set2['default'])(acc, name, _this6.getValueFromFields(name, fields));
	    }, {});
	  };
	
	  this.getFieldsValue = function (names) {
	    return _this6.getNestedFields(names, _this6.getFieldValue);
	  };
	
	  this.getFieldValue = function (name) {
	    var fields = _this6.fields;
	
	    return _this6.getNestedField(name, function (fullName) {
	      return _this6.getValueFromFields(fullName, fields);
	    });
	  };
	
	  this.getFieldsError = function (names) {
	    return _this6.getNestedFields(names, _this6.getFieldError);
	  };
	
	  this.getFieldError = function (name) {
	    return _this6.getNestedField(name, function (fullName) {
	      return (0, _utils.getErrorStrs)(_this6.getFieldMember(fullName, 'errors'));
	    });
	  };
	
	  this.isFieldValidating = function (name) {
	    return _this6.getFieldMember(name, 'validating');
	  };
	
	  this.isFieldsValidating = function (ns) {
	    var names = ns || _this6.getValidFieldsName();
	    return names.some(function (n) {
	      return _this6.isFieldValidating(n);
	    });
	  };
	
	  this.isFieldTouched = function (name) {
	    return _this6.getFieldMember(name, 'touched');
	  };
	
	  this.isFieldsTouched = function (ns) {
	    var names = ns || _this6.getValidFieldsName();
	    return names.some(function (n) {
	      return _this6.isFieldTouched(n);
	    });
	  };
	};
	
	function createFieldsStore(fields) {
	  return new FieldsStore(fields);
	}
	module.exports = exports['default'];

/***/ },
/* 2693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.mixin = undefined;
	
	var _createBaseForm = __webpack_require__(1089);
	
	var _createBaseForm2 = _interopRequireDefault(_createBaseForm);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var mixin = exports.mixin = {
	  getForm: function getForm() {
	    return {
	      getFieldsValue: this.fieldsStore.getFieldsValue,
	      getFieldValue: this.fieldsStore.getFieldValue,
	      getFieldInstance: this.getFieldInstance,
	      setFieldsValue: this.setFieldsValue,
	      setFields: this.setFields,
	      setFieldsInitialValue: this.fieldsStore.setFieldsInitialValue,
	      getFieldDecorator: this.getFieldDecorator,
	      getFieldProps: this.getFieldProps,
	      getFieldsError: this.fieldsStore.getFieldsError,
	      getFieldError: this.fieldsStore.getFieldError,
	      isFieldValidating: this.fieldsStore.isFieldValidating,
	      isFieldsValidating: this.fieldsStore.isFieldsValidating,
	      isFieldsTouched: this.fieldsStore.isFieldsTouched,
	      isFieldTouched: this.fieldsStore.isFieldTouched,
	      isSubmitting: this.isSubmitting,
	      submit: this.submit,
	      validateFields: this.validateFields,
	      resetFields: this.resetFields
	    };
	  }
	};
	
	function createForm(options) {
	  return (0, _createBaseForm2['default'])(options, [mixin]);
	}
	
	exports['default'] = createForm;

/***/ },
/* 2694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rmcFeedback = __webpack_require__(2937);
	
	var _rmcFeedback2 = _interopRequireDefault(_rmcFeedback);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var InputHandler = function (_Component) {
	  (0, _inherits3['default'])(InputHandler, _Component);
	
	  function InputHandler() {
	    (0, _classCallCheck3['default'])(this, InputHandler);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  InputHandler.prototype.render = function render() {
	    var _props = this.props,
	        prefixCls = _props.prefixCls,
	        disabled = _props.disabled,
	        otherProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'disabled']);
	
	    return _react2['default'].createElement(
	      _rmcFeedback2['default'],
	      {
	        disabled: disabled,
	        activeClassName: prefixCls + '-handler-active'
	      },
	      _react2['default'].createElement('span', otherProps)
	    );
	  };
	
	  return InputHandler;
	}(_react.Component);
	
	InputHandler.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  disabled: _propTypes2['default'].bool,
	  onTouchStart: _propTypes2['default'].func,
	  onTouchEnd: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onMouseUp: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func
	};
	
	exports['default'] = InputHandler;
	module.exports = exports['default'];

/***/ },
/* 2695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _KeyCode = __webpack_require__(71);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _InputHandler = __webpack_require__(2694);
	
	var _InputHandler2 = _interopRequireDefault(_InputHandler);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function preventDefault(e) {
	  e.preventDefault();
	}
	
	function defaultParser(input) {
	  return input.replace(/[^\w\.-]+/g, '');
	}
	
	/**
	 * When click and hold on a button - the speed of auto changin the value.
	 */
	var SPEED = 200;
	
	/**
	 * When click and hold on a button - the delay before auto changin the value.
	 */
	var DELAY = 600;
	
	/**
	 * Max Safe Integer -- on IE this is not available, so manually set the number in that case.
	 * The reason this is used, instead of Infinity is because numbers above the MSI are unstable
	 */
	var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || Math.pow(2, 53) - 1;
	
	var isValidProps = function isValidProps(value) {
	  return value !== undefined && value !== null;
	};
	
	var isEqual = function isEqual(oldValue, newValue) {
	  return newValue === oldValue || typeof newValue === 'number' && typeof oldValue === 'number' && isNaN(newValue) && isNaN(oldValue);
	};
	
	var InputNumber = function (_React$Component) {
	  (0, _inherits3['default'])(InputNumber, _React$Component);
	
	  function InputNumber(props) {
	    (0, _classCallCheck3['default'])(this, InputNumber);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var value = void 0;
	    if ('value' in props) {
	      value = props.value;
	    } else {
	      value = props.defaultValue;
	    }
	    _this.state = {
	      focused: props.autoFocus
	    };
	    var validValue = _this.getValidValue(_this.toNumber(value));
	    _this.state = (0, _extends3['default'])({}, _this.state, {
	      inputValue: _this.toPrecisionAsStep(validValue),
	      value: validValue
	    });
	    return _this;
	  }
	
	  InputNumber.prototype.componentDidMount = function componentDidMount() {
	    this.componentDidUpdate();
	  };
	
	  InputNumber.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var _props = this.props,
	        value = _props.value,
	        onChange = _props.onChange,
	        max = _props.max,
	        min = _props.min;
	    var focused = this.state.focused;
	
	    // Don't trigger in componentDidMount
	
	    if (prevProps) {
	      if (!isEqual(prevProps.value, value) || !isEqual(prevProps.max, max) || !isEqual(prevProps.min, min)) {
	        var validValue = focused ? value : this.getValidValue(value);
	        var nextInputValue = void 0;
	        if (this.pressingUpOrDown) {
	          nextInputValue = validValue;
	        } else if (this.inputting) {
	          nextInputValue = this.rawInput;
	        } else {
	          nextInputValue = this.toPrecisionAsStep(validValue);
	        }
	        this.setState({ // eslint-disable-line
	          value: validValue,
	          inputValue: nextInputValue
	        });
	      }
	
	      // Trigger onChange when max or min change
	      // https://github.com/ant-design/ant-design/issues/11574
	      var nextValue = 'value' in this.props ? value : this.state.value;
	      // ref: null < 20 === true
	      // https://github.com/ant-design/ant-design/issues/14277
	      if ('max' in this.props && prevProps.max !== max && typeof nextValue === 'number' && nextValue > max && onChange) {
	        onChange(max);
	      }
	      if ('min' in this.props && prevProps.min !== min && typeof nextValue === 'number' && nextValue < min && onChange) {
	        onChange(min);
	      }
	    }
	
	    // Restore cursor
	    try {
	      // Firefox set the input cursor after it get focused.
	      // This caused that if an input didn't init with the selection,
	      // set will cause cursor not correct when first focus.
	      // Safari will focus input if set selection. We need skip this.
	      if (this.cursorStart !== undefined && this.state.focused) {
	        // In most cases, the string after cursor is stable.
	        // We can move the cursor before it
	
	        if (
	        // If not match full str, try to match part of str
	        !this.partRestoreByAfter(this.cursorAfter) && this.state.value !== this.props.value) {
	          // If not match any of then, let's just keep the position
	          // TODO: Logic should not reach here, need check if happens
	          var pos = this.cursorStart + 1;
	
	          // If not have last string, just position to the end
	          if (!this.cursorAfter) {
	            pos = this.input.value.length;
	          } else if (this.lastKeyCode === _KeyCode2['default'].BACKSPACE) {
	            pos = this.cursorStart - 1;
	          } else if (this.lastKeyCode === _KeyCode2['default'].DELETE) {
	            pos = this.cursorStart;
	          }
	          this.fixCaret(pos, pos);
	        } else if (this.currentValue === this.input.value) {
	          // Handle some special key code
	          switch (this.lastKeyCode) {
	            case _KeyCode2['default'].BACKSPACE:
	              this.fixCaret(this.cursorStart - 1, this.cursorStart - 1);
	              break;
	            case _KeyCode2['default'].DELETE:
	              this.fixCaret(this.cursorStart + 1, this.cursorStart + 1);
	              break;
	            default:
	            // Do nothing
	          }
	        }
	      }
	    } catch (e) {}
	    // Do nothing
	
	
	    // Reset last key
	    this.lastKeyCode = null;
	
	    // pressingUpOrDown is true means that someone just click up or down button
	    if (!this.pressingUpOrDown) {
	      return;
	    }
	    if (this.props.focusOnUpDown && this.state.focused) {
	      if (document.activeElement !== this.input) {
	        this.focus();
	      }
	    }
	
	    this.pressingUpOrDown = false;
	  };
	
	  InputNumber.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.stop();
	  };
	
	  InputNumber.prototype.getCurrentValidValue = function getCurrentValidValue(value) {
	    var val = value;
	    if (val === '') {
	      val = '';
	    } else if (!this.isNotCompleteNumber(parseFloat(val, 10))) {
	      val = this.getValidValue(val);
	    } else {
	      val = this.state.value;
	    }
	    return this.toNumber(val);
	  };
	
	  InputNumber.prototype.getRatio = function getRatio(e) {
	    var ratio = 1;
	    if (e.metaKey || e.ctrlKey) {
	      ratio = 0.1;
	    } else if (e.shiftKey) {
	      ratio = 10;
	    }
	    return ratio;
	  };
	
	  InputNumber.prototype.getValueFromEvent = function getValueFromEvent(e) {
	    // optimize for chinese input expierence
	    // https://github.com/ant-design/ant-design/issues/8196
	    var value = e.target.value.trim().replace(/。/g, '.');
	
	    if (isValidProps(this.props.decimalSeparator)) {
	      value = value.replace(this.props.decimalSeparator, '.');
	    }
	
	    return value;
	  };
	
	  InputNumber.prototype.getValidValue = function getValidValue(value) {
	    var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.props.min;
	    var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : this.props.max;
	
	    var val = parseFloat(value, 10);
	    // https://github.com/ant-design/ant-design/issues/7358
	    if (isNaN(val)) {
	      return value;
	    }
	    if (val < min) {
	      val = min;
	    }
	    if (val > max) {
	      val = max;
	    }
	    return val;
	  };
	
	  InputNumber.prototype.setValue = function setValue(v, callback) {
	    // trigger onChange
	    var precision = this.props.precision;
	
	    var newValue = this.isNotCompleteNumber(parseFloat(v, 10)) ? null : parseFloat(v, 10);
	    var _state = this.state,
	        _state$value = _state.value,
	        value = _state$value === undefined ? null : _state$value,
	        _state$inputValue = _state.inputValue,
	        inputValue = _state$inputValue === undefined ? null : _state$inputValue;
	    // https://github.com/ant-design/ant-design/issues/7363
	    // https://github.com/ant-design/ant-design/issues/16622
	
	    var newValueInString = typeof newValue === 'number' ? newValue.toFixed(precision) : '' + newValue;
	    var changed = newValue !== value || newValueInString !== '' + inputValue;
	    if (!('value' in this.props)) {
	      this.setState({
	        value: newValue,
	        inputValue: this.toPrecisionAsStep(v)
	      }, callback);
	    } else {
	      // always set input value same as value
	      this.setState({
	        inputValue: this.toPrecisionAsStep(this.state.value)
	      }, callback);
	    }
	    if (changed) {
	      this.props.onChange(newValue);
	    }
	
	    return newValue;
	  };
	
	  InputNumber.prototype.getPrecision = function getPrecision(value) {
	    if (isValidProps(this.props.precision)) {
	      return this.props.precision;
	    }
	    var valueString = value.toString();
	    if (valueString.indexOf('e-') >= 0) {
	      return parseInt(valueString.slice(valueString.indexOf('e-') + 2), 10);
	    }
	    var precision = 0;
	    if (valueString.indexOf('.') >= 0) {
	      precision = valueString.length - valueString.indexOf('.') - 1;
	    }
	    return precision;
	  };
	
	  // step={1.0} value={1.51}
	  // press +
	  // then value should be 2.51, rather than 2.5
	  // if this.props.precision is undefined
	  // https://github.com/react-component/input-number/issues/39
	
	
	  InputNumber.prototype.getMaxPrecision = function getMaxPrecision(currentValue) {
	    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	    var _props2 = this.props,
	        precision = _props2.precision,
	        step = _props2.step;
	
	    if (isValidProps(precision)) {
	      return precision;
	    }
	    var ratioPrecision = this.getPrecision(ratio);
	    var stepPrecision = this.getPrecision(step);
	    var currentValuePrecision = this.getPrecision(currentValue);
	    if (!currentValue) {
	      return ratioPrecision + stepPrecision;
	    }
	    return Math.max(currentValuePrecision, ratioPrecision + stepPrecision);
	  };
	
	  InputNumber.prototype.getPrecisionFactor = function getPrecisionFactor(currentValue) {
	    var ratio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	
	    var precision = this.getMaxPrecision(currentValue, ratio);
	    return Math.pow(10, precision);
	  };
	
	  InputNumber.prototype.fixCaret = function fixCaret(start, end) {
	    if (start === undefined || end === undefined || !this.input || !this.input.value) {
	      return;
	    }
	
	    try {
	      var currentStart = this.input.selectionStart;
	      var currentEnd = this.input.selectionEnd;
	
	      if (start !== currentStart || end !== currentEnd) {
	        this.input.setSelectionRange(start, end);
	      }
	    } catch (e) {
	      // Fix error in Chrome:
	      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
	      // http://stackoverflow.com/q/21177489/3040605
	    }
	  };
	
	  InputNumber.prototype.focus = function focus() {
	    this.input.focus();
	    this.recordCursorPosition();
	  };
	
	  InputNumber.prototype.blur = function blur() {
	    this.input.blur();
	  };
	
	  InputNumber.prototype.select = function select() {
	    this.input.select();
	  };
	
	  InputNumber.prototype.formatWrapper = function formatWrapper(num) {
	    // http://2ality.com/2012/03/signedzero.html
	    // https://github.com/ant-design/ant-design/issues/9439
	    if (this.props.formatter) {
	      return this.props.formatter(num);
	    }
	    return num;
	  };
	
	  InputNumber.prototype.toPrecisionAsStep = function toPrecisionAsStep(num) {
	    if (this.isNotCompleteNumber(num) || num === '') {
	      return num;
	    }
	    var precision = Math.abs(this.getMaxPrecision(num));
	    if (!isNaN(precision)) {
	      return Number(num).toFixed(precision);
	    }
	    return num.toString();
	  };
	
	  // '1.' '1x' 'xx' '' => are not complete numbers
	
	
	  InputNumber.prototype.isNotCompleteNumber = function isNotCompleteNumber(num) {
	    return isNaN(num) || num === '' || num === null || num && num.toString().indexOf('.') === num.toString().length - 1;
	  };
	
	  InputNumber.prototype.toNumber = function toNumber(num) {
	    var precision = this.props.precision;
	    var focused = this.state.focused;
	    // num.length > 16 => This is to prevent input of large numbers
	
	    var numberIsTooLarge = num && num.length > 16 && focused;
	    if (this.isNotCompleteNumber(num) || numberIsTooLarge) {
	      return num;
	    }
	    if (isValidProps(precision)) {
	      return Math.round(num * Math.pow(10, precision)) / Math.pow(10, precision);
	    }
	    return Number(num);
	  };
	
	  InputNumber.prototype.upStep = function upStep(val, rat) {
	    var step = this.props.step;
	
	    var precisionFactor = this.getPrecisionFactor(val, rat);
	    var precision = Math.abs(this.getMaxPrecision(val, rat));
	    var result = ((precisionFactor * val + precisionFactor * step * rat) / precisionFactor).toFixed(precision);
	    return this.toNumber(result);
	  };
	
	  InputNumber.prototype.downStep = function downStep(val, rat) {
	    var step = this.props.step;
	
	    var precisionFactor = this.getPrecisionFactor(val, rat);
	    var precision = Math.abs(this.getMaxPrecision(val, rat));
	    var result = ((precisionFactor * val - precisionFactor * step * rat) / precisionFactor).toFixed(precision);
	    return this.toNumber(result);
	  };
	
	  InputNumber.prototype.step = function step(type, e) {
	    var _this2 = this;
	
	    var ratio = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	    var recursive = arguments[3];
	
	    this.stop();
	    if (e) {
	      e.persist();
	      e.preventDefault();
	    }
	    var props = this.props;
	    if (props.disabled) {
	      return;
	    }
	    var value = this.getCurrentValidValue(this.state.inputValue) || 0;
	    if (this.isNotCompleteNumber(value)) {
	      return;
	    }
	    var val = this[type + 'Step'](value, ratio);
	    var outOfRange = val > props.max || val < props.min;
	    if (val > props.max) {
	      val = props.max;
	    } else if (val < props.min) {
	      val = props.min;
	    }
	    this.setValue(val);
	    this.setState({
	      focused: true
	    });
	    if (outOfRange) {
	      return;
	    }
	    this.autoStepTimer = setTimeout(function () {
	      _this2[type](e, ratio, true);
	    }, recursive ? SPEED : DELAY);
	  };
	
	  InputNumber.prototype.render = function render() {
	    var _classNames;
	
	    var props = (0, _extends3['default'])({}, this.props);
	    var prefixCls = props.prefixCls,
	        disabled = props.disabled,
	        readOnly = props.readOnly,
	        useTouch = props.useTouch,
	        autoComplete = props.autoComplete,
	        upHandler = props.upHandler,
	        downHandler = props.downHandler,
	        rest = (0, _objectWithoutProperties3['default'])(props, ['prefixCls', 'disabled', 'readOnly', 'useTouch', 'autoComplete', 'upHandler', 'downHandler']);
	
	    var classes = (0, _classnames2['default'])((_classNames = {}, _classNames[prefixCls] = true, _classNames[props.className] = !!props.className, _classNames[prefixCls + '-disabled'] = disabled, _classNames[prefixCls + '-focused'] = this.state.focused, _classNames));
	    var upDisabledClass = '';
	    var downDisabledClass = '';
	    var _state2 = this.state,
	        value = _state2.value,
	        inputValue = _state2.inputValue;
	
	    if (value || value === 0) {
	      if (!isNaN(value)) {
	        var val = Number(value);
	        if (val >= props.max) {
	          upDisabledClass = prefixCls + '-handler-up-disabled';
	        }
	        if (val <= props.min) {
	          downDisabledClass = prefixCls + '-handler-down-disabled';
	        }
	      } else {
	        upDisabledClass = prefixCls + '-handler-up-disabled';
	        downDisabledClass = prefixCls + '-handler-down-disabled';
	      }
	    }
	
	    var dataOrAriaAttributeProps = {};
	    for (var key in props) {
	      if (props.hasOwnProperty(key) && (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')) {
	        dataOrAriaAttributeProps[key] = props[key];
	      }
	    }
	
	    var editable = !props.readOnly && !props.disabled;
	
	    // focus state, show input value
	    // unfocus state, show valid value
	    var inputDisplayValue = this.composing ? inputValue : this.getInputDisplayValue();
	
	    var upEvents = void 0;
	    var downEvents = void 0;
	    if (useTouch) {
	      upEvents = {
	        onTouchStart: editable && !upDisabledClass ? this.up : noop,
	        onTouchEnd: this.stop
	      };
	      downEvents = {
	        onTouchStart: editable && !downDisabledClass ? this.down : noop,
	        onTouchEnd: this.stop
	      };
	    } else {
	      upEvents = {
	        onMouseDown: editable && !upDisabledClass ? this.up : noop,
	        onMouseUp: this.stop,
	        onMouseLeave: this.stop
	      };
	      downEvents = {
	        onMouseDown: editable && !downDisabledClass ? this.down : noop,
	        onMouseUp: this.stop,
	        onMouseLeave: this.stop
	      };
	    }
	
	    var isUpDisabled = !!upDisabledClass || disabled || readOnly;
	    var isDownDisabled = !!downDisabledClass || disabled || readOnly;
	    // ref for test
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: classes,
	        style: props.style,
	        title: props.title,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        onMouseOver: props.onMouseOver,
	        onMouseOut: props.onMouseOut,
	        onCompositionStart: this.onComposition,
	        onCompositionEnd: this.onComposition
	      },
	      _react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-handler-wrap' },
	        _react2['default'].createElement(
	          _InputHandler2['default'],
	          (0, _extends3['default'])({
	            ref: this.saveUp,
	            disabled: isUpDisabled,
	            prefixCls: prefixCls,
	            unselectable: 'unselectable'
	          }, upEvents, {
	            role: 'button',
	            'aria-label': 'Increase Value',
	            'aria-disabled': !!isUpDisabled,
	            className: prefixCls + '-handler ' + prefixCls + '-handler-up ' + upDisabledClass
	          }),
	          upHandler || _react2['default'].createElement('span', {
	            unselectable: 'unselectable',
	            className: prefixCls + '-handler-up-inner',
	            onClick: preventDefault
	          })
	        ),
	        _react2['default'].createElement(
	          _InputHandler2['default'],
	          (0, _extends3['default'])({
	            ref: this.saveDown,
	            disabled: isDownDisabled,
	            prefixCls: prefixCls,
	            unselectable: 'unselectable'
	          }, downEvents, {
	            role: 'button',
	            'aria-label': 'Decrease Value',
	            'aria-disabled': !!isDownDisabled,
	            className: prefixCls + '-handler ' + prefixCls + '-handler-down ' + downDisabledClass
	          }),
	          downHandler || _react2['default'].createElement('span', {
	            unselectable: 'unselectable',
	            className: prefixCls + '-handler-down-inner',
	            onClick: preventDefault
	          })
	        )
	      ),
	      _react2['default'].createElement(
	        'div',
	        {
	          className: prefixCls + '-input-wrap'
	        },
	        _react2['default'].createElement('input', (0, _extends3['default'])({
	          role: 'spinbutton',
	          'aria-valuemin': props.min,
	          'aria-valuemax': props.max,
	          'aria-valuenow': value,
	          required: props.required,
	          type: props.type,
	          placeholder: props.placeholder,
	          onClick: props.onClick,
	          onMouseUp: this.onMouseUp,
	          className: prefixCls + '-input',
	          tabIndex: props.tabIndex,
	          autoComplete: autoComplete,
	          onFocus: this.onFocus,
	          onBlur: this.onBlur,
	          onKeyDown: editable ? this.onKeyDown : noop,
	          onKeyUp: editable ? this.onKeyUp : noop,
	          autoFocus: props.autoFocus,
	          maxLength: props.maxLength,
	          readOnly: props.readOnly,
	          disabled: props.disabled,
	          max: props.max,
	          min: props.min,
	          step: props.step,
	          name: props.name,
	          title: props.title,
	          id: props.id,
	          onChange: this.onChange,
	          ref: this.saveInput,
	          value: inputDisplayValue,
	          pattern: props.pattern,
	          inputMode: props.inputMode
	        }, dataOrAriaAttributeProps))
	      )
	    );
	  };
	
	  return InputNumber;
	}(_react2['default'].Component);
	
	InputNumber.propTypes = {
	  value: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  defaultValue: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  focusOnUpDown: _propTypes2['default'].bool,
	  autoFocus: _propTypes2['default'].bool,
	  onChange: _propTypes2['default'].func,
	  onPressEnter: _propTypes2['default'].func,
	  onKeyDown: _propTypes2['default'].func,
	  onKeyUp: _propTypes2['default'].func,
	  prefixCls: _propTypes2['default'].string,
	  tabIndex: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number]),
	  disabled: _propTypes2['default'].bool,
	  onFocus: _propTypes2['default'].func,
	  onBlur: _propTypes2['default'].func,
	  readOnly: _propTypes2['default'].bool,
	  max: _propTypes2['default'].number,
	  min: _propTypes2['default'].number,
	  step: _propTypes2['default'].oneOfType([_propTypes2['default'].number, _propTypes2['default'].string]),
	  upHandler: _propTypes2['default'].node,
	  downHandler: _propTypes2['default'].node,
	  useTouch: _propTypes2['default'].bool,
	  formatter: _propTypes2['default'].func,
	  parser: _propTypes2['default'].func,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseOver: _propTypes2['default'].func,
	  onMouseOut: _propTypes2['default'].func,
	  onMouseUp: _propTypes2['default'].func,
	  precision: _propTypes2['default'].number,
	  required: _propTypes2['default'].bool,
	  pattern: _propTypes2['default'].string,
	  decimalSeparator: _propTypes2['default'].string,
	  inputMode: _propTypes2['default'].string
	};
	InputNumber.defaultProps = {
	  focusOnUpDown: true,
	  useTouch: false,
	  prefixCls: 'rc-input-number',
	  min: -MAX_SAFE_INTEGER,
	  step: 1,
	  style: {},
	  onChange: noop,
	  onKeyDown: noop,
	  onPressEnter: noop,
	  onFocus: noop,
	  onBlur: noop,
	  parser: defaultParser,
	  required: false,
	  autoComplete: 'off'
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onKeyDown = function (e) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var _props3 = _this3.props,
	        onKeyDown = _props3.onKeyDown,
	        onPressEnter = _props3.onPressEnter;
	
	
	    if (e.keyCode === _KeyCode2['default'].UP) {
	      var ratio = _this3.getRatio(e);
	      _this3.up(e, ratio);
	      _this3.stop();
	    } else if (e.keyCode === _KeyCode2['default'].DOWN) {
	      var _ratio = _this3.getRatio(e);
	      _this3.down(e, _ratio);
	      _this3.stop();
	    } else if (e.keyCode === _KeyCode2['default'].ENTER && onPressEnter) {
	      onPressEnter(e);
	    }
	
	    // Trigger user key down
	    _this3.recordCursorPosition();
	    _this3.lastKeyCode = e.keyCode;
	    if (onKeyDown) {
	      onKeyDown.apply(undefined, [e].concat(args));
	    }
	  };
	
	  this.onKeyUp = function (e) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	      args[_key2 - 1] = arguments[_key2];
	    }
	
	    var onKeyUp = _this3.props.onKeyUp;
	
	
	    _this3.stop();
	
	    _this3.recordCursorPosition();
	
	    // Trigger user key up
	    if (onKeyUp) {
	      onKeyUp.apply(undefined, [e].concat(args));
	    }
	  };
	
	  this.onChange = function (e) {
	    var onChange = _this3.props.onChange;
	
	    if (_this3.state.focused) {
	      _this3.inputting = true;
	    }
	    _this3.rawInput = _this3.props.parser(_this3.getValueFromEvent(e));
	    if (_this3.composing) {
	      _this3.setState({ inputValue: _this3.getValueFromEvent(e) });
	    } else {
	      _this3.setState({ inputValue: _this3.rawInput });
	      onChange(_this3.toNumber(_this3.rawInput)); // valid number or invalid string
	    }
	  };
	
	  this.onMouseUp = function () {
	    var onMouseUp = _this3.props.onMouseUp;
	
	
	    _this3.recordCursorPosition();
	
	    if (onMouseUp) {
	      onMouseUp.apply(undefined, arguments);
	    }
	  };
	
	  this.onFocus = function () {
	    var _props4;
	
	    _this3.setState({
	      focused: true
	    });
	    (_props4 = _this3.props).onFocus.apply(_props4, arguments);
	  };
	
	  this.onBlur = function () {
	    var onBlur = _this3.props.onBlur;
	
	    _this3.inputting = false;
	    _this3.setState({
	      focused: false
	    });
	    var value = _this3.getCurrentValidValue(_this3.state.inputValue);
	    var newValue = _this3.setValue(value);
	
	    if (onBlur) {
	      var originValue = _this3.input.value;
	      var inputValue = _this3.getInputDisplayValue({ focus: false, value: newValue });
	      _this3.input.value = inputValue;
	      onBlur.apply(undefined, arguments);
	      _this3.input.value = originValue;
	    }
	  };
	
	  this.onComposition = function (e) {
	    if (e.type === 'compositionstart') {
	      _this3.composing = true;
	    } else if (e.type === 'compositionend') {
	      _this3.composing = false;
	      _this3.onChange(e);
	    }
	  };
	
	  this.getInputDisplayValue = function (state) {
	    var _ref = state || _this3.state,
	        focused = _ref.focused,
	        inputValue = _ref.inputValue,
	        value = _ref.value;
	
	    var inputDisplayValue = void 0;
	    if (focused) {
	      inputDisplayValue = inputValue;
	    } else {
	      inputDisplayValue = _this3.toPrecisionAsStep(value);
	    }
	
	    if (inputDisplayValue === undefined || inputDisplayValue === null) {
	      inputDisplayValue = '';
	    }
	
	    var inputDisplayValueFormat = _this3.formatWrapper(inputDisplayValue);
	    if (isValidProps(_this3.props.decimalSeparator)) {
	      inputDisplayValueFormat = inputDisplayValueFormat.toString().replace('.', _this3.props.decimalSeparator);
	    }
	
	    return inputDisplayValueFormat;
	  };
	
	  this.recordCursorPosition = function () {
	    // Record position
	    try {
	      _this3.cursorStart = _this3.input.selectionStart;
	      _this3.cursorEnd = _this3.input.selectionEnd;
	      _this3.currentValue = _this3.input.value;
	      _this3.cursorBefore = _this3.input.value.substring(0, _this3.cursorStart);
	      _this3.cursorAfter = _this3.input.value.substring(_this3.cursorEnd);
	    } catch (e) {
	      // Fix error in Chrome:
	      // Failed to read the 'selectionStart' property from 'HTMLInputElement'
	      // http://stackoverflow.com/q/21177489/3040605
	    }
	  };
	
	  this.restoreByAfter = function (str) {
	    if (str === undefined) return false;
	
	    var fullStr = _this3.input.value;
	    var index = fullStr.lastIndexOf(str);
	
	    if (index === -1) return false;
	
	    var prevCursorPos = _this3.cursorBefore.length;
	    if (_this3.lastKeyCode === _KeyCode2['default'].DELETE && _this3.cursorBefore.charAt(prevCursorPos - 1) === str[0]) {
	      _this3.fixCaret(prevCursorPos, prevCursorPos);
	      return true;
	    }
	
	    if (index + str.length === fullStr.length) {
	      _this3.fixCaret(index, index);
	
	      return true;
	    }
	    return false;
	  };
	
	  this.partRestoreByAfter = function (str) {
	    if (str === undefined) return false;
	
	    // For loop from full str to the str with last char to map. e.g. 123
	    // -> 123
	    // -> 23
	    // -> 3
	    return Array.prototype.some.call(str, function (_, start) {
	      var partStr = str.substring(start);
	
	      return _this3.restoreByAfter(partStr);
	    });
	  };
	
	  this.stop = function () {
	    if (_this3.autoStepTimer) {
	      clearTimeout(_this3.autoStepTimer);
	    }
	  };
	
	  this.down = function (e, ratio, recursive) {
	    _this3.pressingUpOrDown = true;
	    _this3.step('down', e, ratio, recursive);
	  };
	
	  this.up = function (e, ratio, recursive) {
	    _this3.pressingUpOrDown = true;
	    _this3.step('up', e, ratio, recursive);
	  };
	
	  this.saveUp = function (node) {
	    _this3.upHandler = node;
	  };
	
	  this.saveDown = function (node) {
	    _this3.downHandler = node;
	  };
	
	  this.saveInput = function (node) {
	    _this3.input = node;
	  };
	};
	
	exports['default'] = InputNumber;
	module.exports = exports['default'];

/***/ },
/* 2696 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rcMenu = _interopRequireWildcard(__webpack_require__(219));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _MentionsContext = __webpack_require__(1091);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	/**
	 * We only use Menu to display the candidate.
	 * The focus is controlled by textarea to make accessibility easy.
	 */
	var DropdownMenu =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(DropdownMenu, _React$Component);
	
	  function DropdownMenu() {
	    var _this;
	
	    _classCallCheck(this, DropdownMenu);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownMenu).apply(this, arguments));
	
	    _this.renderDropdown = function (_ref) {
	      var notFoundContent = _ref.notFoundContent,
	          activeIndex = _ref.activeIndex,
	          setActiveIndex = _ref.setActiveIndex,
	          selectOption = _ref.selectOption,
	          onFocus = _ref.onFocus,
	          onBlur = _ref.onBlur;
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          options = _this$props.options;
	      var activeOption = options[activeIndex] || {};
	      return React.createElement(_rcMenu.default, {
	        prefixCls: "".concat(prefixCls, "-menu"),
	        activeKey: activeOption.value,
	        onSelect: function onSelect(_ref2) {
	          var key = _ref2.key;
	          var option = options.find(function (_ref3) {
	            var value = _ref3.value;
	            return value === key;
	          });
	          selectOption(option);
	        },
	        onFocus: onFocus,
	        onBlur: onBlur
	      }, options.map(function (option, index) {
	        var value = option.value,
	            disabled = option.disabled,
	            children = option.children,
	            className = option.className,
	            style = option.style;
	        return React.createElement(_rcMenu.MenuItem, {
	          key: value,
	          disabled: disabled,
	          className: className,
	          style: style,
	          onMouseEnter: function onMouseEnter() {
	            setActiveIndex(index);
	          }
	        }, children);
	      }), !options.length && React.createElement(_rcMenu.MenuItem, {
	        disabled: true
	      }, notFoundContent));
	    };
	
	    return _this;
	  }
	
	  _createClass(DropdownMenu, [{
	    key: "render",
	    value: function render() {
	      return React.createElement(_MentionsContext.MentionsContextConsumer, null, this.renderDropdown);
	    }
	  }]);
	
	  return DropdownMenu;
	}(React.Component);
	
	var _default = DropdownMenu;
	exports.default = _default;

/***/ },
/* 2697 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _rcTrigger = _interopRequireDefault(__webpack_require__(185));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _DropdownMenu = _interopRequireDefault(__webpack_require__(2696));
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var BUILT_IN_PLACEMENTS = {
	  bottomRight: {
	    points: ['tl', 'br'],
	    offset: [0, 4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    }
	  },
	  topRight: {
	    points: ['bl', 'tr'],
	    offset: [0, -4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    }
	  }
	};
	
	var KeywordTrigger =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(KeywordTrigger, _React$Component);
	
	  function KeywordTrigger() {
	    var _this;
	
	    _classCallCheck(this, KeywordTrigger);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(KeywordTrigger).apply(this, arguments));
	
	    _this.getDropdownPrefix = function () {
	      return "".concat(_this.props.prefixCls, "-dropdown");
	    };
	
	    _this.getDropdownElement = function () {
	      var options = _this.props.options;
	      return React.createElement(_DropdownMenu.default, {
	        prefixCls: _this.getDropdownPrefix(),
	        options: options
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(KeywordTrigger, [{
	    key: "render",
	    value: function render() {
	      var _this$props = this.props,
	          children = _this$props.children,
	          visible = _this$props.visible,
	          placement = _this$props.placement,
	          transitionName = _this$props.transitionName,
	          getPopupContainer = _this$props.getPopupContainer;
	      var popupElement = this.getDropdownElement();
	      return React.createElement(_rcTrigger.default, {
	        prefixCls: this.getDropdownPrefix(),
	        popupVisible: visible,
	        popup: popupElement,
	        popupPlacement: placement === 'top' ? 'topRight' : 'bottomRight',
	        popupTransitionName: transitionName,
	        builtinPlacements: BUILT_IN_PLACEMENTS,
	        getPopupContainer: getPopupContainer
	      }, children);
	    }
	  }]);
	
	  return KeywordTrigger;
	}(React.Component);
	
	var _default = KeywordTrigger;
	exports.default = _default;

/***/ },
/* 2698 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _toArray = _interopRequireDefault(__webpack_require__(112));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(71));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _KeywordTrigger = _interopRequireDefault(__webpack_require__(2697));
	
	var _MentionsContext = __webpack_require__(1091);
	
	var _Option = _interopRequireDefault(__webpack_require__(2699));
	
	var _util = __webpack_require__(2701);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Mentions =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Mentions, _React$Component);
	
	  function Mentions(props) {
	    var _this;
	
	    _classCallCheck(this, Mentions);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Mentions).call(this, props));
	    _this.focusId = undefined;
	
	    _this.triggerChange = function (value) {
	      var onChange = _this.props.onChange;
	
	      if (!('value' in _this.props)) {
	        _this.setState({
	          value: value
	        });
	      }
	
	      if (onChange) {
	        onChange(value);
	      }
	    };
	
	    _this.onChange = function (_ref) {
	      var value = _ref.target.value;
	
	      _this.triggerChange(value);
	    }; // Check if hit the measure keyword
	
	
	    _this.onKeyDown = function (event) {
	      var which = event.which;
	      var _this$state = _this.state,
	          activeIndex = _this$state.activeIndex,
	          measuring = _this$state.measuring; // Skip if not measuring
	
	      if (!measuring) {
	        return;
	      }
	
	      if (which === _KeyCode.default.UP || which === _KeyCode.default.DOWN) {
	        // Control arrow function
	        var optionLen = _this.getOptions().length;
	
	        var offset = which === _KeyCode.default.UP ? -1 : 1;
	        var newActiveIndex = (activeIndex + offset + optionLen) % optionLen;
	
	        _this.setState({
	          activeIndex: newActiveIndex
	        });
	
	        event.preventDefault();
	      } else if (which === _KeyCode.default.ESC) {
	        _this.stopMeasure();
	      } else if (which === _KeyCode.default.ENTER) {
	        // Measure hit
	        var option = _this.getOptions()[activeIndex];
	
	        _this.selectOption(option);
	
	        event.preventDefault();
	      }
	    };
	    /**
	     * When to start measure:
	     * 1. When user press `prefix`
	     * 2. When measureText !== prevMeasureText
	     *  - If measure hit
	     *  - If measuring
	     *
	     * When to stop measure:
	     * 1. Selection is out of range
	     * 2. Contains `space`
	     * 3. ESC or select one
	     */
	
	
	    _this.onKeyUp = function (event) {
	      var key = event.key,
	          which = event.which;
	      var _this$state2 = _this.state,
	          prevMeasureText = _this$state2.measureText,
	          measuring = _this$state2.measuring;
	      var _this$props = _this.props,
	          _this$props$prefix = _this$props.prefix,
	          prefix = _this$props$prefix === void 0 ? '' : _this$props$prefix,
	          onSearch = _this$props.onSearch,
	          validateSearch = _this$props.validateSearch;
	      var target = event.target;
	      var selectionStartText = (0, _util.getBeforeSelectionText)(target);
	
	      var _getLastMeasureIndex = (0, _util.getLastMeasureIndex)(selectionStartText, prefix),
	          measureIndex = _getLastMeasureIndex.location,
	          measurePrefix = _getLastMeasureIndex.prefix; // Skip if match the white key list
	
	
	      if ([_KeyCode.default.ESC, _KeyCode.default.UP, _KeyCode.default.DOWN, _KeyCode.default.ENTER].indexOf(which) !== -1) {
	        return;
	      }
	
	      if (measureIndex !== -1) {
	        var measureText = selectionStartText.slice(measureIndex + measurePrefix.length);
	        var validateMeasure = validateSearch(measureText, _this.props);
	        var matchOption = !!_this.getOptions(measureText).length;
	
	        if (validateMeasure) {
	          if (key === measurePrefix || measuring || measureText !== prevMeasureText && matchOption) {
	            _this.startMeasure(measureText, measurePrefix, measureIndex);
	          }
	        } else if (measuring) {
	          // Stop if measureText is invalidate
	          _this.stopMeasure();
	        }
	        /**
	         * We will trigger `onSearch` to developer since they may use for async update.
	         * If met `space` means user finished searching.
	         */
	
	
	        if (onSearch && validateMeasure) {
	          onSearch(measureText, measurePrefix);
	        }
	      } else if (measuring) {
	        _this.stopMeasure();
	      }
	    };
	
	    _this.onInputFocus = function (event) {
	      _this.onFocus(event);
	    };
	
	    _this.onInputBlur = function (event) {
	      _this.onBlur(event);
	    };
	
	    _this.onDropdownFocus = function () {
	      _this.onFocus();
	    };
	
	    _this.onDropdownBlur = function () {
	      _this.onBlur();
	    };
	
	    _this.onFocus = function (event) {
	      window.clearTimeout(_this.focusId);
	      var isFocus = _this.state.isFocus;
	      var onFocus = _this.props.onFocus;
	
	      if (!isFocus && event && onFocus) {
	        onFocus(event);
	      }
	
	      _this.setState({
	        isFocus: true
	      });
	    };
	
	    _this.onBlur = function (event) {
	      _this.focusId = window.setTimeout(function () {
	        var onBlur = _this.props.onBlur;
	
	        _this.setState({
	          isFocus: false
	        });
	
	        _this.stopMeasure();
	
	        if (onBlur) {
	          onBlur(event);
	        }
	      }, 0);
	    };
	
	    _this.selectOption = function (option) {
	      var _this$state3 = _this.state,
	          value = _this$state3.value,
	          measureLocation = _this$state3.measureLocation,
	          measurePrefix = _this$state3.measurePrefix;
	      var _this$props2 = _this.props,
	          split = _this$props2.split,
	          onSelect = _this$props2.onSelect;
	      var _option$value = option.value,
	          mentionValue = _option$value === void 0 ? '' : _option$value;
	
	      var _replaceWithMeasure = (0, _util.replaceWithMeasure)(value, {
	        measureLocation: measureLocation,
	        targetText: mentionValue,
	        prefix: measurePrefix,
	        selectionStart: _this.textarea.selectionStart,
	        split: split
	      }),
	          text = _replaceWithMeasure.text,
	          selectionLocation = _replaceWithMeasure.selectionLocation;
	
	      _this.triggerChange(text);
	
	      _this.stopMeasure(function () {
	        // We need restore the selection position
	        (0, _util.setInputSelection)(_this.textarea, selectionLocation);
	      });
	
	      if (onSelect) {
	        onSelect(option, measurePrefix);
	      }
	    };
	
	    _this.setActiveIndex = function (activeIndex) {
	      _this.setState({
	        activeIndex: activeIndex
	      });
	    };
	
	    _this.setTextAreaRef = function (element) {
	      _this.textarea = element;
	    };
	
	    _this.setMeasureRef = function (element) {
	      _this.measure = element;
	    };
	
	    _this.getOptions = function (measureText) {
	      var targetMeasureText = measureText || _this.state.measureText || '';
	      var _this$props3 = _this.props,
	          children = _this$props3.children,
	          filterOption = _this$props3.filterOption;
	      var list = (0, _toArray.default)(children).map(function (_ref2) {
	        var props = _ref2.props;
	        return props;
	      }).filter(function (option) {
	        /** Return all result if `filterOption` is false. */
	        if (filterOption === false) {
	          return true;
	        }
	
	        return filterOption(targetMeasureText, option);
	      });
	      return list;
	    };
	
	    _this.state = {
	      value: props.defaultValue || props.value || '',
	      measuring: false,
	      measureLocation: 0,
	      measureText: null,
	      measurePrefix: '',
	      activeIndex: 0,
	      isFocus: false
	    };
	    return _this;
	  }
	
	  _createClass(Mentions, [{
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      var measuring = this.state.measuring; // Sync measure div top with textarea for rc-trigger usage
	
	      if (measuring) {
	        this.measure.scrollTop = this.textarea.scrollTop;
	      }
	    }
	  }, {
	    key: "startMeasure",
	    value: function startMeasure(measureText, measurePrefix, measureLocation) {
	      this.setState({
	        measuring: true,
	        measureText: measureText,
	        measurePrefix: measurePrefix,
	        measureLocation: measureLocation,
	        activeIndex: 0
	      });
	    }
	  }, {
	    key: "stopMeasure",
	    value: function stopMeasure(callback) {
	      this.setState({
	        measuring: false,
	        measureLocation: 0,
	        measureText: null
	      }, callback);
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.textarea.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.textarea.blur();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$state4 = this.state,
	          value = _this$state4.value,
	          measureLocation = _this$state4.measureLocation,
	          measurePrefix = _this$state4.measurePrefix,
	          measuring = _this$state4.measuring,
	          activeIndex = _this$state4.activeIndex;
	
	      var _this$props4 = this.props,
	          prefixCls = _this$props4.prefixCls,
	          placement = _this$props4.placement,
	          transitionName = _this$props4.transitionName,
	          className = _this$props4.className,
	          style = _this$props4.style,
	          autoFocus = _this$props4.autoFocus,
	          notFoundContent = _this$props4.notFoundContent,
	          getPopupContainer = _this$props4.getPopupContainer,
	          restProps = _objectWithoutProperties(_this$props4, ["prefixCls", "placement", "transitionName", "className", "style", "autoFocus", "notFoundContent", "getPopupContainer"]);
	
	      var inputProps = (0, _util.omit)(restProps, 'value', 'defaultValue', 'prefix', 'split', 'children', 'validateSearch', 'filterOption', 'onSelect', 'onSearch');
	      var options = measuring ? this.getOptions() : [];
	      return React.createElement("div", {
	        className: (0, _classnames.default)(prefixCls, className),
	        style: style
	      }, React.createElement("textarea", Object.assign({
	        autoFocus: autoFocus,
	        ref: this.setTextAreaRef,
	        value: value
	      }, inputProps, {
	        onChange: this.onChange,
	        onKeyDown: this.onKeyDown,
	        onKeyUp: this.onKeyUp,
	        onFocus: this.onInputFocus,
	        onBlur: this.onInputBlur
	      })), measuring && React.createElement("div", {
	        ref: this.setMeasureRef,
	        className: "".concat(prefixCls, "-measure")
	      }, value.slice(0, measureLocation), React.createElement(_MentionsContext.MentionsContextProvider, {
	        value: {
	          notFoundContent: notFoundContent,
	          activeIndex: activeIndex,
	          setActiveIndex: this.setActiveIndex,
	          selectOption: this.selectOption,
	          onFocus: this.onDropdownFocus,
	          onBlur: this.onDropdownBlur
	        }
	      }, React.createElement(_KeywordTrigger.default, {
	        prefixCls: prefixCls,
	        transitionName: transitionName,
	        placement: placement,
	        options: options,
	        visible: true,
	        getPopupContainer: getPopupContainer
	      }, React.createElement("span", null, measurePrefix))), value.slice(measureLocation + measurePrefix.length)));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, prevState) {
	      var newState = {};
	
	      if ('value' in props && props.value !== prevState.value) {
	        newState.value = props.value || '';
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Mentions;
	}(React.Component);
	
	Mentions.Option = _Option.default;
	Mentions.defaultProps = {
	  prefixCls: 'rc-mentions',
	  prefix: '@',
	  split: ' ',
	  validateSearch: _util.validateSearch,
	  filterOption: _util.filterOption,
	  notFoundContent: 'Not Found',
	  rows: 1
	};
	(0, _reactLifecyclesCompat.polyfill)(Mentions);
	var _default = Mentions;
	exports.default = _default;

/***/ },
/* 2699 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var Option = function Option() {
	  return null;
	};
	
	var _default = Option;
	exports.default = _default;

/***/ },
/* 2700 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _Mentions = _interopRequireDefault(__webpack_require__(2698));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _Mentions.default;
	exports.default = _default;

/***/ },
/* 2701 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getBeforeSelectionText = getBeforeSelectionText;
	exports.getLastMeasureIndex = getLastMeasureIndex;
	exports.replaceWithMeasure = replaceWithMeasure;
	exports.setInputSelection = setInputSelection;
	exports.validateSearch = validateSearch;
	exports.filterOption = filterOption;
	exports.omit = void 0;
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var omit = function omit(obj) {
	  var clone = _objectSpread({}, obj);
	
	  for (var _len = arguments.length, keys = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    keys[_key - 1] = arguments[_key];
	  }
	
	  keys.forEach(function (key) {
	    delete clone[key];
	  });
	  return clone;
	};
	/**
	 * Cut input selection into 2 part and return text before selection start
	 */
	
	
	exports.omit = omit;
	
	function getBeforeSelectionText(input) {
	  var selectionStart = input.selectionStart;
	  return input.value.slice(0, selectionStart);
	}
	/**
	 * Find the last match prefix index
	 */
	
	
	function getLastMeasureIndex(text) {
	  var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var prefixList = Array.isArray(prefix) ? prefix : [prefix];
	  return prefixList.reduce(function (lastMatch, prefixStr) {
	    var lastIndex = text.lastIndexOf(prefixStr);
	
	    if (lastIndex > lastMatch.location) {
	      return {
	        location: lastIndex,
	        prefix: prefixStr
	      };
	    }
	
	    return lastMatch;
	  }, {
	    location: -1,
	    prefix: ''
	  });
	}
	
	function lower(char) {
	  return (char || '').toLowerCase();
	}
	
	function reduceText(text, targetText, split) {
	  var firstChar = text[0];
	
	  if (!firstChar || firstChar === split) {
	    return text;
	  } // Reuse rest text as it can
	
	
	  var restText = text;
	  var targetTextLen = targetText.length;
	
	  for (var i = 0; i < targetTextLen; i += 1) {
	    if (lower(restText[i]) !== lower(targetText[i])) {
	      restText = restText.slice(i);
	      break;
	    } else if (i === targetTextLen - 1) {
	      restText = restText.slice(targetTextLen);
	    }
	  }
	
	  return restText;
	}
	/**
	 * Paint targetText into current text:
	 *  text: little@litest
	 *  targetText: light
	 *  => little @light test
	 */
	
	
	function replaceWithMeasure(text, measureConfig) {
	  var measureLocation = measureConfig.measureLocation,
	      prefix = measureConfig.prefix,
	      targetText = measureConfig.targetText,
	      selectionStart = measureConfig.selectionStart,
	      split = measureConfig.split; // Before text will append one space if have other text
	
	  var beforeMeasureText = text.slice(0, measureLocation);
	
	  if (beforeMeasureText[beforeMeasureText.length - split.length] === split) {
	    beforeMeasureText = beforeMeasureText.slice(0, beforeMeasureText.length - split.length);
	  }
	
	  if (beforeMeasureText) {
	    beforeMeasureText = "".concat(beforeMeasureText).concat(split);
	  } // Cut duplicate string with current targetText
	
	
	  var restText = reduceText(text.slice(selectionStart), targetText.slice(selectionStart - measureLocation - prefix.length), split);
	
	  if (restText.slice(0, split.length) === split) {
	    restText = restText.slice(split.length);
	  }
	
	  var connectedStartText = "".concat(beforeMeasureText).concat(prefix).concat(targetText).concat(split);
	  return {
	    text: "".concat(connectedStartText).concat(restText),
	    selectionLocation: connectedStartText.length
	  };
	}
	
	function setInputSelection(input, location) {
	  input.setSelectionRange(location, location);
	  /**
	   * Reset caret into view.
	   * Since this function always called by user control, it's safe to focus element.
	   */
	
	  input.blur();
	  input.focus();
	}
	
	function validateSearch(text, props) {
	  var split = props.split;
	  return !split || text.indexOf(split) === -1;
	}
	
	function filterOption(input, _ref) {
	  var _ref$value = _ref.value,
	      value = _ref$value === void 0 ? '' : _ref$value;
	  var lowerCase = input.toLowerCase();
	  return value.toLowerCase().indexOf(lowerCase) !== -1;
	}

/***/ },
/* 2702 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(391));
	
	var _SubMenu = _interopRequireDefault(__webpack_require__(1092));
	
	var _util = __webpack_require__(257);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	var MENUITEM_OVERFLOWED_CLASSNAME = 'menuitem-overflowed';
	var FLOAT_PRECISION_ADJUST = 0.5; // Fix ssr
	
	if (canUseDOM) {
	  // eslint-disable-next-line global-require
	  __webpack_require__(2615);
	}
	
	var DOMWrap =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(DOMWrap, _React$Component);
	
	  function DOMWrap() {
	    var _this;
	
	    _classCallCheck(this, DOMWrap);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DOMWrap).apply(this, arguments));
	    _this.resizeObserver = null;
	    _this.mutationObserver = null; // original scroll size of the list
	
	    _this.originalTotalWidth = 0; // copy of overflowed items
	
	    _this.overflowedItems = []; // cache item of the original items (so we can track the size and order)
	
	    _this.menuItemSizes = [];
	    _this.state = {
	      lastVisibleIndex: undefined
	    }; // get all valid menuItem nodes
	
	    _this.getMenuItemNodes = function () {
	      var prefixCls = _this.props.prefixCls;
	      var ul = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	
	      if (!ul) {
	        return [];
	      } // filter out all overflowed indicator placeholder
	
	
	      return [].slice.call(ul.children).filter(function (node) {
	        return node.className.split(' ').indexOf("".concat(prefixCls, "-overflowed-submenu")) < 0;
	      });
	    };
	
	    _this.getOverflowedSubMenuItem = function (keyPrefix, overflowedItems, renderPlaceholder) {
	      var _this$props = _this.props,
	          overflowedIndicator = _this$props.overflowedIndicator,
	          level = _this$props.level,
	          mode = _this$props.mode,
	          prefixCls = _this$props.prefixCls,
	          theme = _this$props.theme;
	
	      if (level !== 1 || mode !== 'horizontal') {
	        return null;
	      } // put all the overflowed item inside a submenu
	      // with a title of overflow indicator ('...')
	
	
	      var copy = _this.props.children[0];
	
	      var _copy$props = copy.props,
	          throwAway = _copy$props.children,
	          title = _copy$props.title,
	          propStyle = _copy$props.style,
	          rest = _objectWithoutProperties(_copy$props, ["children", "title", "style"]);
	
	      var style = _objectSpread({}, propStyle);
	
	      var key = "".concat(keyPrefix, "-overflowed-indicator");
	      var eventKey = "".concat(keyPrefix, "-overflowed-indicator");
	
	      if (overflowedItems.length === 0 && renderPlaceholder !== true) {
	        style = _objectSpread({}, style, {
	          display: 'none'
	        });
	      } else if (renderPlaceholder) {
	        style = _objectSpread({}, style, {
	          visibility: 'hidden',
	          // prevent from taking normal dom space
	          position: 'absolute'
	        });
	        key = "".concat(key, "-placeholder");
	        eventKey = "".concat(eventKey, "-placeholder");
	      }
	
	      var popupClassName = theme ? "".concat(prefixCls, "-").concat(theme) : '';
	      var props = {};
	
	      _util.menuAllProps.forEach(function (k) {
	        if (rest[k] !== undefined) {
	          props[k] = rest[k];
	        }
	      });
	
	      return React.createElement(_SubMenu.default, Object.assign({
	        title: overflowedIndicator,
	        className: "".concat(prefixCls, "-overflowed-submenu"),
	        popupClassName: popupClassName
	      }, props, {
	        key: key,
	        eventKey: eventKey,
	        disabled: false,
	        style: style
	      }), overflowedItems);
	    }; // memorize rendered menuSize
	
	
	    _this.setChildrenWidthAndResize = function () {
	      if (_this.props.mode !== 'horizontal') {
	        return;
	      }
	
	      var ul = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	
	      if (!ul) {
	        return;
	      }
	
	      var ulChildrenNodes = ul.children;
	
	      if (!ulChildrenNodes || ulChildrenNodes.length === 0) {
	        return;
	      }
	
	      var lastOverflowedIndicatorPlaceholder = ul.children[ulChildrenNodes.length - 1]; // need last overflowed indicator for calculating length;
	
	      (0, _util.setStyle)(lastOverflowedIndicatorPlaceholder, 'display', 'inline-block');
	
	      var menuItemNodes = _this.getMenuItemNodes(); // reset display attribute for all hidden elements caused by overflow to calculate updated width
	      // and then reset to original state after width calculation
	
	
	      var overflowedItems = menuItemNodes.filter(function (c) {
	        return c.className.split(' ').indexOf(MENUITEM_OVERFLOWED_CLASSNAME) >= 0;
	      });
	      overflowedItems.forEach(function (c) {
	        (0, _util.setStyle)(c, 'display', 'inline-block');
	      });
	      _this.menuItemSizes = menuItemNodes.map(function (c) {
	        return (0, _util.getWidth)(c);
	      });
	      overflowedItems.forEach(function (c) {
	        (0, _util.setStyle)(c, 'display', 'none');
	      });
	      _this.overflowedIndicatorWidth = (0, _util.getWidth)(ul.children[ul.children.length - 1]);
	      _this.originalTotalWidth = _this.menuItemSizes.reduce(function (acc, cur) {
	        return acc + cur;
	      }, 0);
	
	      _this.handleResize(); // prevent the overflowed indicator from taking space;
	
	
	      (0, _util.setStyle)(lastOverflowedIndicatorPlaceholder, 'display', 'none');
	    };
	
	    _this.handleResize = function () {
	      if (_this.props.mode !== 'horizontal') {
	        return;
	      }
	
	      var ul = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	
	      if (!ul) {
	        return;
	      }
	
	      var width = (0, _util.getWidth)(ul);
	      _this.overflowedItems = [];
	      var currentSumWidth = 0; // index for last visible child in horizontal mode
	
	      var lastVisibleIndex; // float number comparison could be problematic
	      // e.g. 0.1 + 0.2 > 0.3 =====> true
	      // thus using FLOAT_PRECISION_ADJUST as buffer to help the situation
	
	      if (_this.originalTotalWidth > width + FLOAT_PRECISION_ADJUST) {
	        lastVisibleIndex = -1;
	
	        _this.menuItemSizes.forEach(function (liWidth) {
	          currentSumWidth += liWidth;
	
	          if (currentSumWidth + _this.overflowedIndicatorWidth <= width) {
	            lastVisibleIndex += 1;
	          }
	        });
	      }
	
	      _this.setState({
	        lastVisibleIndex: lastVisibleIndex
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(DOMWrap, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.setChildrenWidthAndResize();
	
	      if (this.props.level === 1 && this.props.mode === 'horizontal') {
	        var menuUl = ReactDOM.findDOMNode(this);
	
	        if (!menuUl) {
	          return;
	        }
	
	        this.resizeObserver = new _resizeObserverPolyfill.default(function (entries) {
	          entries.forEach(_this2.setChildrenWidthAndResize);
	        });
	        [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
	          _this2.resizeObserver.observe(el);
	        });
	
	        if (typeof MutationObserver !== 'undefined') {
	          this.mutationObserver = new MutationObserver(function () {
	            _this2.resizeObserver.disconnect();
	
	            [].slice.call(menuUl.children).concat(menuUl).forEach(function (el) {
	              _this2.resizeObserver.observe(el);
	            });
	
	            _this2.setChildrenWidthAndResize();
	          });
	          this.mutationObserver.observe(menuUl, {
	            attributes: false,
	            childList: true,
	            subTree: false
	          });
	        }
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.resizeObserver) {
	        this.resizeObserver.disconnect();
	      }
	
	      if (this.mutationObserver) {
	        this.mutationObserver.disconnect();
	      }
	    }
	  }, {
	    key: "renderChildren",
	    value: function renderChildren(children) {
	      var _this3 = this;
	
	      // need to take care of overflowed items in horizontal mode
	      var lastVisibleIndex = this.state.lastVisibleIndex;
	      return (children || []).reduce(function (acc, childNode, index) {
	        var item = childNode;
	
	        if (_this3.props.mode === 'horizontal') {
	          var overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, []);
	
	          if (lastVisibleIndex !== undefined && _this3.props.className.indexOf("".concat(_this3.props.prefixCls, "-root")) !== -1) {
	            if (index > lastVisibleIndex) {
	              item = React.cloneElement(childNode, // 这里修改 eventKey 是为了防止隐藏状态下还会触发 openkeys 事件
	              {
	                style: {
	                  display: 'none'
	                },
	                eventKey: "".concat(childNode.props.eventKey, "-hidden"),
	
	                /**
	                 * Legacy code. Here `className` never used:
	                 * https://github.com/react-component/menu/commit/4cd6b49fce9d116726f4ea00dda85325d6f26500#diff-e2fa48f75c2dd2318295cde428556a76R240
	                 */
	                className: "".concat(MENUITEM_OVERFLOWED_CLASSNAME)
	              });
	            }
	
	            if (index === lastVisibleIndex + 1) {
	              _this3.overflowedItems = children.slice(lastVisibleIndex + 1).map(function (c) {
	                return React.cloneElement(c, // children[index].key will become '.$key' in clone by default,
	                // we have to overwrite with the correct key explicitly
	                {
	                  key: c.props.eventKey,
	                  mode: 'vertical-left'
	                });
	              });
	              overflowed = _this3.getOverflowedSubMenuItem(childNode.props.eventKey, _this3.overflowedItems);
	            }
	          }
	
	          var ret = [].concat(_toConsumableArray(acc), [overflowed, item]);
	
	          if (index === children.length - 1) {
	            // need a placeholder for calculating overflowed indicator width
	            ret.push(_this3.getOverflowedSubMenuItem(childNode.props.eventKey, [], true));
	          }
	
	          return ret;
	        }
	
	        return [].concat(_toConsumableArray(acc), [item]);
	      }, []);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          visible = _this$props2.visible,
	          prefixCls = _this$props2.prefixCls,
	          overflowedIndicator = _this$props2.overflowedIndicator,
	          mode = _this$props2.mode,
	          level = _this$props2.level,
	          tag = _this$props2.tag,
	          children = _this$props2.children,
	          theme = _this$props2.theme,
	          rest = _objectWithoutProperties(_this$props2, ["visible", "prefixCls", "overflowedIndicator", "mode", "level", "tag", "children", "theme"]);
	
	      var Tag = tag;
	      return React.createElement(Tag, Object.assign({}, rest), this.renderChildren(children));
	    }
	  }]);
	
	  return DOMWrap;
	}(React.Component);
	
	DOMWrap.defaultProps = {
	  tag: 'div',
	  className: ''
	};
	var _default = DOMWrap;
	exports.default = _default;

/***/ },
/* 2703 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	var Divider = function Divider(_ref) {
	  var className = _ref.className,
	      rootPrefixCls = _ref.rootPrefixCls,
	      style = _ref.style;
	  return React.createElement("li", {
	    className: "".concat(className, " ").concat(rootPrefixCls, "-item-divider"),
	    style: style
	  });
	};
	
	Divider.defaultProps = {
	  // To fix keyboard UX.
	  disabled: true,
	  className: '',
	  style: {}
	};
	var _default = Divider;
	exports.default = _default;

/***/ },
/* 2704 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _miniStore = __webpack_require__(143);
	
	var _SubPopupMenu = _interopRequireWildcard(__webpack_require__(1093));
	
	var _util = __webpack_require__(257);
	
	var _legacyUtil = __webpack_require__(2709);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var Menu =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Menu, _React$Component);
	
	  function Menu(props) {
	    var _this;
	
	    _classCallCheck(this, Menu);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Menu).call(this, props));
	
	    _this.onSelect = function (selectInfo) {
	      var _assertThisInitialize = _assertThisInitialized(_this),
	          props = _assertThisInitialize.props;
	
	      if (props.selectable) {
	        // root menu
	        var _this$store$getState = _this.store.getState(),
	            _selectedKeys = _this$store$getState.selectedKeys;
	
	        var selectedKey = selectInfo.key;
	
	        if (props.multiple) {
	          _selectedKeys = _selectedKeys.concat([selectedKey]);
	        } else {
	          _selectedKeys = [selectedKey];
	        }
	
	        if (!('selectedKeys' in props)) {
	          _this.store.setState({
	            selectedKeys: _selectedKeys
	          });
	        }
	
	        props.onSelect(_objectSpread({}, selectInfo, {
	          selectedKeys: _selectedKeys
	        }));
	      }
	    };
	
	    _this.onClick = function (e) {
	      _this.props.onClick(e);
	    }; // onKeyDown needs to be exposed as a instance method
	    // e.g., in rc-select, we need to navigate menu item while
	    // current active item is rc-select input box rather than the menu itself
	
	
	    _this.onKeyDown = function (e, callback) {
	      _this.innerMenu.getWrappedInstance().onKeyDown(e, callback);
	    };
	
	    _this.onOpenChange = function (event) {
	      var _assertThisInitialize2 = _assertThisInitialized(_this),
	          props = _assertThisInitialize2.props;
	
	      var openKeys = _this.store.getState().openKeys.concat();
	
	      var changed = false;
	
	      var processSingle = function processSingle(e) {
	        var oneChanged = false;
	
	        if (e.open) {
	          oneChanged = openKeys.indexOf(e.key) === -1;
	
	          if (oneChanged) {
	            openKeys.push(e.key);
	          }
	        } else {
	          var index = openKeys.indexOf(e.key);
	          oneChanged = index !== -1;
	
	          if (oneChanged) {
	            openKeys.splice(index, 1);
	          }
	        }
	
	        changed = changed || oneChanged;
	      };
	
	      if (Array.isArray(event)) {
	        // batch change call
	        event.forEach(processSingle);
	      } else {
	        processSingle(event);
	      }
	
	      if (changed) {
	        if (!('openKeys' in _this.props)) {
	          _this.store.setState({
	            openKeys: openKeys
	          });
	        }
	
	        props.onOpenChange(openKeys);
	      }
	    };
	
	    _this.onDeselect = function (selectInfo) {
	      var _assertThisInitialize3 = _assertThisInitialized(_this),
	          props = _assertThisInitialize3.props;
	
	      if (props.selectable) {
	        var _selectedKeys2 = _this.store.getState().selectedKeys.concat();
	
	        var selectedKey = selectInfo.key;
	
	        var index = _selectedKeys2.indexOf(selectedKey);
	
	        if (index !== -1) {
	          _selectedKeys2.splice(index, 1);
	        }
	
	        if (!('selectedKeys' in props)) {
	          _this.store.setState({
	            selectedKeys: _selectedKeys2
	          });
	        }
	
	        props.onDeselect(_objectSpread({}, selectInfo, {
	          selectedKeys: _selectedKeys2
	        }));
	      }
	    };
	
	    _this.getOpenTransitionName = function () {
	      var _assertThisInitialize4 = _assertThisInitialized(_this),
	          props = _assertThisInitialize4.props;
	
	      var transitionName = props.openTransitionName;
	      var animationName = props.openAnimation;
	
	      if (!transitionName && typeof animationName === 'string') {
	        transitionName = "".concat(props.prefixCls, "-open-").concat(animationName);
	      }
	
	      return transitionName;
	    };
	
	    _this.setInnerMenu = function (node) {
	      _this.innerMenu = node;
	    };
	
	    _this.isRootMenu = true;
	    var selectedKeys = props.defaultSelectedKeys;
	    var openKeys = props.defaultOpenKeys;
	
	    if ('selectedKeys' in props) {
	      selectedKeys = props.selectedKeys || [];
	    }
	
	    if ('openKeys' in props) {
	      openKeys = props.openKeys || [];
	    }
	
	    _this.store = (0, _miniStore.create)({
	      selectedKeys: selectedKeys,
	      openKeys: openKeys,
	      activeKey: {
	        '0-menu-': (0, _SubPopupMenu.getActiveKey)(props, props.activeKey)
	      }
	    });
	    return _this;
	  }
	
	  _createClass(Menu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.updateMiniStore();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.updateMiniStore();
	    }
	  }, {
	    key: "updateMiniStore",
	    value: function updateMiniStore() {
	      if ('selectedKeys' in this.props) {
	        this.store.setState({
	          selectedKeys: this.props.selectedKeys || []
	        });
	      }
	
	      if ('openKeys' in this.props) {
	        this.store.setState({
	          openKeys: this.props.openKeys || []
	        });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var props = _objectSpread({}, this.props);
	
	      props.className += " ".concat(props.prefixCls, "-root");
	      props = _objectSpread({}, props, {
	        onClick: this.onClick,
	        onOpenChange: this.onOpenChange,
	        onDeselect: this.onDeselect,
	        onSelect: this.onSelect,
	        parentMenu: this,
	        motion: (0, _legacyUtil.getMotion)(this.props)
	      });
	      delete props.openAnimation;
	      delete props.openTransitionName;
	      return React.createElement(_miniStore.Provider, {
	        store: this.store
	      }, React.createElement(_SubPopupMenu.default, Object.assign({}, props, {
	        ref: this.setInnerMenu
	      }), this.props.children));
	    }
	  }]);
	
	  return Menu;
	}(React.Component);
	
	Menu.defaultProps = {
	  selectable: true,
	  onClick: _util.noop,
	  onSelect: _util.noop,
	  onOpenChange: _util.noop,
	  onDeselect: _util.noop,
	  defaultSelectedKeys: [],
	  defaultOpenKeys: [],
	  subMenuOpenDelay: 0.1,
	  subMenuCloseDelay: 0.1,
	  triggerSubMenuAction: 'hover',
	  prefixCls: 'rc-menu',
	  className: '',
	  mode: 'vertical',
	  style: {},
	  builtinPlacements: {},
	  overflowedIndicator: React.createElement("span", null, "\xB7\xB7\xB7")
	};
	var _default = Menu;
	exports.default = _default;

/***/ },
/* 2705 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(71));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _domScrollIntoView = _interopRequireDefault(__webpack_require__(281));
	
	var _miniStore = __webpack_require__(143);
	
	var _util = __webpack_require__(257);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var MenuItem =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(MenuItem, _React$Component);
	
	  function MenuItem() {
	    var _this;
	
	    _classCallCheck(this, MenuItem);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItem).apply(this, arguments));
	
	    _this.onKeyDown = function (e) {
	      var keyCode = e.keyCode;
	
	      if (keyCode === _KeyCode.default.ENTER) {
	        _this.onClick(e);
	
	        return true;
	      }
	
	      return undefined;
	    };
	
	    _this.onMouseLeave = function (e) {
	      var _this$props = _this.props,
	          eventKey = _this$props.eventKey,
	          onItemHover = _this$props.onItemHover,
	          onMouseLeave = _this$props.onMouseLeave;
	      onItemHover({
	        key: eventKey,
	        hover: false
	      });
	      onMouseLeave({
	        key: eventKey,
	        domEvent: e
	      });
	    };
	
	    _this.onMouseEnter = function (e) {
	      var _this$props2 = _this.props,
	          eventKey = _this$props2.eventKey,
	          onItemHover = _this$props2.onItemHover,
	          onMouseEnter = _this$props2.onMouseEnter;
	      onItemHover({
	        key: eventKey,
	        hover: true
	      });
	      onMouseEnter({
	        key: eventKey,
	        domEvent: e
	      });
	    };
	
	    _this.onClick = function (e) {
	      var _this$props3 = _this.props,
	          eventKey = _this$props3.eventKey,
	          multiple = _this$props3.multiple,
	          onClick = _this$props3.onClick,
	          onSelect = _this$props3.onSelect,
	          onDeselect = _this$props3.onDeselect,
	          isSelected = _this$props3.isSelected;
	      var info = {
	        key: eventKey,
	        keyPath: [eventKey],
	        item: _assertThisInitialized(_this),
	        domEvent: e
	      };
	      onClick(info);
	
	      if (multiple) {
	        if (isSelected) {
	          onDeselect(info);
	        } else {
	          onSelect(info);
	        }
	      } else if (!isSelected) {
	        onSelect(info);
	      }
	    };
	
	    _this.saveNode = function (node) {
	      _this.node = node;
	    };
	
	    return _this;
	  }
	
	  _createClass(MenuItem, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // invoke customized ref to expose component to mixin
	      this.callRef();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props4 = this.props,
	          active = _this$props4.active,
	          parentMenu = _this$props4.parentMenu,
	          eventKey = _this$props4.eventKey; // 在 parentMenu 上层保存滚动状态，避免重复的 MenuItem key 导致滚动跳动
	      // https://github.com/ant-design/ant-design/issues/16181
	
	      if (!prevProps.active && active && (!parentMenu || !parentMenu["scrolled-".concat(eventKey)])) {
	        if (this.node) {
	          (0, _domScrollIntoView.default)(this.node, ReactDOM.findDOMNode(parentMenu), {
	            onlyScrollIfNeeded: true
	          });
	          parentMenu["scrolled-".concat(eventKey)] = true;
	        }
	      } else if (parentMenu && parentMenu["scrolled-".concat(eventKey)]) {
	        delete parentMenu["scrolled-".concat(eventKey)];
	      }
	
	      this.callRef();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      var props = this.props;
	
	      if (props.onDestroy) {
	        props.onDestroy(props.eventKey);
	      }
	    }
	  }, {
	    key: "getPrefixCls",
	    value: function getPrefixCls() {
	      return "".concat(this.props.rootPrefixCls, "-item");
	    }
	  }, {
	    key: "getActiveClassName",
	    value: function getActiveClassName() {
	      return "".concat(this.getPrefixCls(), "-active");
	    }
	  }, {
	    key: "getSelectedClassName",
	    value: function getSelectedClassName() {
	      return "".concat(this.getPrefixCls(), "-selected");
	    }
	  }, {
	    key: "getDisabledClassName",
	    value: function getDisabledClassName() {
	      return "".concat(this.getPrefixCls(), "-disabled");
	    }
	  }, {
	    key: "callRef",
	    value: function callRef() {
	      if (this.props.manualRef) {
	        this.props.manualRef(this);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var props = _objectSpread({}, this.props);
	
	      var className = (0, _classnames.default)(this.getPrefixCls(), props.className, (_classNames = {}, _defineProperty(_classNames, this.getActiveClassName(), !props.disabled && props.active), _defineProperty(_classNames, this.getSelectedClassName(), props.isSelected), _defineProperty(_classNames, this.getDisabledClassName(), props.disabled), _classNames));
	
	      var attrs = _objectSpread({}, props.attribute, {
	        title: props.title,
	        className: className,
	        // set to menuitem by default
	        role: props.role || 'menuitem',
	        'aria-disabled': props.disabled
	      });
	
	      if (props.role === 'option') {
	        // overwrite to option
	        attrs = _objectSpread({}, attrs, {
	          role: 'option',
	          'aria-selected': props.isSelected
	        });
	      } else if (props.role === null || props.role === 'none') {
	        // sometimes we want to specify role inside <li/> element
	        // <li><a role='menuitem'>Link</a></li> would be a good example
	        // in this case the role on <li/> should be "none" to
	        // remove the implied listitem role.
	        // https://www.w3.org/TR/wai-aria-practices-1.1/examples/menubar/menubar-1/menubar-1.html
	        attrs.role = 'none';
	      } // In case that onClick/onMouseLeave/onMouseEnter is passed down from owner
	
	
	      var mouseEvent = {
	        onClick: props.disabled ? null : this.onClick,
	        onMouseLeave: props.disabled ? null : this.onMouseLeave,
	        onMouseEnter: props.disabled ? null : this.onMouseEnter
	      };
	
	      var style = _objectSpread({}, props.style);
	
	      if (props.mode === 'inline') {
	        style.paddingLeft = props.inlineIndent * props.level;
	      }
	
	      _util.menuAllProps.forEach(function (key) {
	        return delete props[key];
	      });
	
	      var icon = this.props.itemIcon;
	
	      if (typeof this.props.itemIcon === 'function') {
	        // TODO: This is a bug which should fixed after TS refactor
	        icon = React.createElement(this.props.itemIcon, this.props);
	      }
	
	      return React.createElement("li", Object.assign({}, props, attrs, mouseEvent, {
	        style: style,
	        ref: this.saveNode
	      }), props.children, icon);
	    }
	  }]);
	
	  return MenuItem;
	}(React.Component);
	
	exports.MenuItem = MenuItem;
	MenuItem.isMenuItem = true;
	MenuItem.defaultProps = {
	  onSelect: _util.noop,
	  onMouseEnter: _util.noop,
	  onMouseLeave: _util.noop,
	  manualRef: _util.noop
	};
	var connected = (0, _miniStore.connect)(function (_ref, _ref2) {
	  var activeKey = _ref.activeKey,
	      selectedKeys = _ref.selectedKeys;
	  var eventKey = _ref2.eventKey,
	      subMenuKey = _ref2.subMenuKey;
	  return {
	    active: activeKey[subMenuKey] === eventKey,
	    isSelected: selectedKeys.indexOf(eventKey) !== -1
	  };
	})(MenuItem);
	var _default = connected;
	exports.default = _default;

/***/ },
/* 2706 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _util = __webpack_require__(257);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var MenuItemGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(MenuItemGroup, _React$Component);
	
	  function MenuItemGroup() {
	    var _this;
	
	    _classCallCheck(this, MenuItemGroup);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(MenuItemGroup).apply(this, arguments));
	
	    _this.renderInnerMenuItem = function (item) {
	      var _this$props = _this.props,
	          renderMenuItem = _this$props.renderMenuItem,
	          index = _this$props.index;
	      return renderMenuItem(item, index, _this.props.subMenuKey);
	    };
	
	    return _this;
	  }
	
	  _createClass(MenuItemGroup, [{
	    key: "render",
	    value: function render() {
	      var props = _extends({}, this.props);
	
	      var _props$className = props.className,
	          className = _props$className === void 0 ? '' : _props$className,
	          rootPrefixCls = props.rootPrefixCls;
	      var titleClassName = "".concat(rootPrefixCls, "-item-group-title");
	      var listClassName = "".concat(rootPrefixCls, "-item-group-list");
	      var title = props.title,
	          children = props.children;
	
	      _util.menuAllProps.forEach(function (key) {
	        return delete props[key];
	      }); // Set onClick to null, to ignore propagated onClick event
	
	
	      delete props.onClick;
	      return React.createElement("li", Object.assign({}, props, {
	        className: "".concat(className, " ").concat(rootPrefixCls, "-item-group")
	      }), React.createElement("div", {
	        className: titleClassName,
	        title: typeof title === 'string' ? title : undefined
	      }, title), React.createElement("ul", {
	        className: listClassName
	      }, React.Children.map(children, this.renderInnerMenuItem)));
	    }
	  }]);
	
	  return MenuItemGroup;
	}(React.Component);
	
	MenuItemGroup.isMenuItemGroup = true;
	MenuItemGroup.defaultProps = {
	  disabled: true
	};
	var _default = MenuItemGroup;
	exports.default = _default;

/***/ },
/* 2707 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.placements = void 0;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	var placements = {
	  topLeft: {
	    points: ['bl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -7]
	  },
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 7]
	  },
	  leftTop: {
	    points: ['tr', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [-4, 0]
	  },
	  rightTop: {
	    points: ['tl', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [4, 0]
	  }
	};
	exports.placements = placements;
	var _default = placements;
	exports.default = _default;

/***/ },
/* 2708 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }
	
	function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }
	
	function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
	
	function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
	
	// MIT License from https://github.com/kaimallea/isMobile
	var applePhone = /iPhone/i;
	var appleIpod = /iPod/i;
	var appleTablet = /iPad/i;
	var androidPhone = /\bAndroid(?:.+)Mobile\b/i; // Match 'Android' AND 'Mobile'
	
	var androidTablet = /Android/i;
	var amazonPhone = /\bAndroid(?:.+)SD4930UR\b/i;
	var amazonTablet = /\bAndroid(?:.+)(?:KF[A-Z]{2,4})\b/i;
	var windowsPhone = /Windows Phone/i;
	var windowsTablet = /\bWindows(?:.+)ARM\b/i; // Match 'Windows' AND 'ARM'
	
	var otherBlackberry = /BlackBerry/i;
	var otherBlackberry10 = /BB10/i;
	var otherOpera = /Opera Mini/i;
	var otherChrome = /\b(CriOS|Chrome)(?:.+)Mobile/i;
	var otherFirefox = /Mobile(?:.+)Firefox\b/i; // Match 'Mobile' AND 'Firefox'
	
	function match(regex, userAgent) {
	  return regex.test(userAgent);
	}
	
	function isMobile(userAgent) {
	  var ua = userAgent || (typeof navigator !== 'undefined' ? navigator.userAgent : ''); // Facebook mobile app's integrated browser adds a bunch of strings that
	  // match everything. Strip it out if it exists.
	
	  var tmp = ua.split('[FBAN');
	
	  if (typeof tmp[1] !== 'undefined') {
	    var _tmp = tmp;
	
	    var _tmp2 = _slicedToArray(_tmp, 1);
	
	    ua = _tmp2[0];
	  } // Twitter mobile app's integrated browser on iPad adds a "Twitter for
	  // iPhone" string. Same probably happens on other tablet platforms.
	  // This will confuse detection so strip it out if it exists.
	
	
	  tmp = ua.split('Twitter');
	
	  if (typeof tmp[1] !== 'undefined') {
	    var _tmp3 = tmp;
	
	    var _tmp4 = _slicedToArray(_tmp3, 1);
	
	    ua = _tmp4[0];
	  }
	
	  var result = {
	    apple: {
	      phone: match(applePhone, ua) && !match(windowsPhone, ua),
	      ipod: match(appleIpod, ua),
	      tablet: !match(applePhone, ua) && match(appleTablet, ua) && !match(windowsPhone, ua),
	      device: (match(applePhone, ua) || match(appleIpod, ua) || match(appleTablet, ua)) && !match(windowsPhone, ua)
	    },
	    amazon: {
	      phone: match(amazonPhone, ua),
	      tablet: !match(amazonPhone, ua) && match(amazonTablet, ua),
	      device: match(amazonPhone, ua) || match(amazonTablet, ua)
	    },
	    android: {
	      phone: !match(windowsPhone, ua) && match(amazonPhone, ua) || !match(windowsPhone, ua) && match(androidPhone, ua),
	      tablet: !match(windowsPhone, ua) && !match(amazonPhone, ua) && !match(androidPhone, ua) && (match(amazonTablet, ua) || match(androidTablet, ua)),
	      device: !match(windowsPhone, ua) && (match(amazonPhone, ua) || match(amazonTablet, ua) || match(androidPhone, ua) || match(androidTablet, ua)) || match(/\bokhttp\b/i, ua)
	    },
	    windows: {
	      phone: match(windowsPhone, ua),
	      tablet: match(windowsTablet, ua),
	      device: match(windowsPhone, ua) || match(windowsTablet, ua)
	    },
	    other: {
	      blackberry: match(otherBlackberry, ua),
	      blackberry10: match(otherBlackberry10, ua),
	      opera: match(otherOpera, ua),
	      firefox: match(otherFirefox, ua),
	      chrome: match(otherChrome, ua),
	      device: match(otherBlackberry, ua) || match(otherBlackberry10, ua) || match(otherOpera, ua) || match(otherFirefox, ua) || match(otherChrome, ua)
	    },
	    // Additional
	    any: null,
	    phone: null,
	    tablet: null
	  };
	  result.any = result.apple.device || result.android.device || result.windows.device || result.other.device; // excludes 'other' devices and ipods, targeting touchscreen phones
	
	  result.phone = result.apple.phone || result.android.phone || result.windows.phone;
	  result.tablet = result.apple.tablet || result.android.tablet || result.windows.tablet;
	  return result;
	}
	
	var defaultResult = _objectSpread({}, isMobile(), {
	  isMobile: isMobile
	});
	
	var _default = defaultResult;
	exports.default = _default;

/***/ },
/* 2709 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getMotion = getMotion;
	
	var _warning = _interopRequireDefault(__webpack_require__(303));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function getMotion(_ref) {
	  var prefixCls = _ref.prefixCls,
	      motion = _ref.motion,
	      openAnimation = _ref.openAnimation,
	      openTransitionName = _ref.openTransitionName;
	
	  if (motion) {
	    return motion;
	  }
	
	  if (_typeof(openAnimation) === 'object' && openAnimation) {
	    (0, _warning.default)(false, 'Object type of `openAnimation` is removed. Please use `motion` instead.');
	  } else if (typeof openAnimation === 'string') {
	    return {
	      motionName: "".concat(prefixCls, "-open-").concat(openAnimation)
	    };
	  }
	
	  if (openTransitionName) {
	    return {
	      motionName: openTransitionName
	    };
	  }
	
	  return null;
	}

/***/ },
/* 2710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Notice = function (_Component) {
	  (0, _inherits3['default'])(Notice, _Component);
	
	  function Notice() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Notice);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Notice.__proto__ || Object.getPrototypeOf(Notice)).call.apply(_ref, [this].concat(args))), _this), _this.close = function (e) {
	      if (e) {
	        e.stopPropagation();
	      }
	      _this.clearCloseTimer();
	      _this.props.onClose();
	    }, _this.startCloseTimer = function () {
	      if (_this.props.duration) {
	        _this.closeTimer = setTimeout(function () {
	          _this.close();
	        }, _this.props.duration * 1000);
	      }
	    }, _this.clearCloseTimer = function () {
	      if (_this.closeTimer) {
	        clearTimeout(_this.closeTimer);
	        _this.closeTimer = null;
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Notice, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.startCloseTimer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props.duration !== prevProps.duration || this.props.update) {
	        this.restartCloseTimer();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.clearCloseTimer();
	    }
	  }, {
	    key: 'restartCloseTimer',
	    value: function restartCloseTimer() {
	      this.clearCloseTimer();
	      this.startCloseTimer();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _className;
	
	      var props = this.props;
	      var componentClass = props.prefixCls + '-notice';
	      var className = (_className = {}, (0, _defineProperty3['default'])(_className, '' + componentClass, 1), (0, _defineProperty3['default'])(_className, componentClass + '-closable', props.closable), (0, _defineProperty3['default'])(_className, props.className, !!props.className), _className);
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: (0, _classnames2['default'])(className),
	          style: props.style,
	          onMouseEnter: this.clearCloseTimer,
	          onMouseLeave: this.startCloseTimer,
	          onClick: props.onClick
	        },
	        _react2['default'].createElement(
	          'div',
	          { className: componentClass + '-content' },
	          props.children
	        ),
	        props.closable ? _react2['default'].createElement(
	          'a',
	          { tabIndex: '0', onClick: this.close, className: componentClass + '-close' },
	          props.closeIcon || _react2['default'].createElement('span', { className: componentClass + '-close-x' })
	        ) : null
	      );
	    }
	  }]);
	  return Notice;
	}(_react.Component);
	
	Notice.propTypes = {
	  duration: _propTypes2['default'].number,
	  onClose: _propTypes2['default'].func,
	  children: _propTypes2['default'].any,
	  update: _propTypes2['default'].bool,
	  closeIcon: _propTypes2['default'].node
	};
	Notice.defaultProps = {
	  onEnd: function onEnd() {},
	  onClose: function onClose() {},
	
	  duration: 1.5,
	  style: {
	    right: '50%'
	  }
	};
	exports['default'] = Notice;
	module.exports = exports['default'];

/***/ },
/* 2711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAnimate = __webpack_require__(111);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _createChainedFunction = __webpack_require__(570);
	
	var _createChainedFunction2 = _interopRequireDefault(_createChainedFunction);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _Notice = __webpack_require__(2710);
	
	var _Notice2 = _interopRequireDefault(_Notice);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var seed = 0;
	var now = Date.now();
	
	function getUuid() {
	  return 'rcNotification_' + now + '_' + seed++;
	}
	
	var Notification = function (_Component) {
	  (0, _inherits3['default'])(Notification, _Component);
	
	  function Notification() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Notification);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Notification.__proto__ || Object.getPrototypeOf(Notification)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      notices: []
	    }, _this.add = function (notice) {
	      var key = notice.key = notice.key || getUuid();
	      var maxCount = _this.props.maxCount;
	
	      _this.setState(function (previousState) {
	        var notices = previousState.notices;
	        var noticeIndex = notices.map(function (v) {
	          return v.key;
	        }).indexOf(key);
	        var updatedNotices = notices.concat();
	        if (noticeIndex !== -1) {
	          updatedNotices.splice(noticeIndex, 1, notice);
	        } else {
	          if (maxCount && notices.length >= maxCount) {
	            // XXX, use key of first item to update new added (let React to move exsiting
	            // instead of remove and mount). Same key was used before for both a) external
	            // manual control and b) internal react 'key' prop , which is not that good.
	            notice.updateKey = updatedNotices[0].updateKey || updatedNotices[0].key;
	            updatedNotices.shift();
	          }
	          updatedNotices.push(notice);
	        }
	        return {
	          notices: updatedNotices
	        };
	      });
	    }, _this.remove = function (key) {
	      _this.setState(function (previousState) {
	        return {
	          notices: previousState.notices.filter(function (notice) {
	            return notice.key !== key;
	          })
	        };
	      });
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Notification, [{
	    key: 'getTransitionName',
	    value: function getTransitionName() {
	      var props = this.props;
	      var transitionName = props.transitionName;
	      if (!transitionName && props.animation) {
	        transitionName = props.prefixCls + '-' + props.animation;
	      }
	      return transitionName;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this,
	          _className;
	
	      var props = this.props;
	      var notices = this.state.notices;
	
	      var noticeNodes = notices.map(function (notice, index) {
	        var update = Boolean(index === notices.length - 1 && notice.updateKey);
	        var key = notice.updateKey ? notice.updateKey : notice.key;
	        var onClose = (0, _createChainedFunction2['default'])(_this2.remove.bind(_this2, notice.key), notice.onClose);
	        return _react2['default'].createElement(
	          _Notice2['default'],
	          (0, _extends3['default'])({
	            prefixCls: props.prefixCls
	          }, notice, {
	            key: key,
	            update: update,
	            onClose: onClose,
	            onClick: notice.onClick,
	            closeIcon: props.closeIcon
	          }),
	          notice.content
	        );
	      });
	      var className = (_className = {}, (0, _defineProperty3['default'])(_className, props.prefixCls, 1), (0, _defineProperty3['default'])(_className, props.className, !!props.className), _className);
	      return _react2['default'].createElement(
	        'div',
	        { className: (0, _classnames2['default'])(className), style: props.style },
	        _react2['default'].createElement(
	          _rcAnimate2['default'],
	          { transitionName: this.getTransitionName() },
	          noticeNodes
	        )
	      );
	    }
	  }]);
	  return Notification;
	}(_react.Component);
	
	Notification.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  transitionName: _propTypes2['default'].string,
	  animation: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  style: _propTypes2['default'].object,
	  maxCount: _propTypes2['default'].number,
	  closeIcon: _propTypes2['default'].node
	};
	Notification.defaultProps = {
	  prefixCls: 'rc-notification',
	  animation: 'fade',
	  style: {
	    top: 65,
	    left: '50%'
	  }
	};
	
	
	Notification.newInstance = function newNotificationInstance(properties, callback) {
	  var _ref2 = properties || {},
	      getContainer = _ref2.getContainer,
	      props = (0, _objectWithoutProperties3['default'])(_ref2, ['getContainer']);
	
	  var div = document.createElement('div');
	  if (getContainer) {
	    var root = getContainer();
	    root.appendChild(div);
	  } else {
	    document.body.appendChild(div);
	  }
	  var called = false;
	  function ref(notification) {
	    if (called) {
	      return;
	    }
	    called = true;
	    callback({
	      notice: function notice(noticeProps) {
	        notification.add(noticeProps);
	      },
	      removeNotice: function removeNotice(key) {
	        notification.remove(key);
	      },
	
	      component: notification,
	      destroy: function destroy() {
	        _reactDom2['default'].unmountComponentAtNode(div);
	        div.parentNode.removeChild(div);
	      }
	    });
	  }
	  _reactDom2['default'].render(_react2['default'].createElement(Notification, (0, _extends3['default'])({}, props, { ref: ref })), div);
	};
	
	exports['default'] = Notification;
	module.exports = exports['default'];

/***/ },
/* 2712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _KeyCode = __webpack_require__(1095);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Options = function (_React$Component) {
	  (0, _inherits3['default'])(Options, _React$Component);
	
	  function Options() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Options);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Options.__proto__ || Object.getPrototypeOf(Options)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      goInputText: ''
	    }, _this.buildOptionText = function (value) {
	      return value + ' ' + _this.props.locale.items_per_page;
	    }, _this.changeSize = function (value) {
	      _this.props.changeSize(Number(value));
	    }, _this.handleChange = function (e) {
	      _this.setState({
	        goInputText: e.target.value
	      });
	    }, _this.handleBlur = function (e) {
	      var _this$props = _this.props,
	          goButton = _this$props.goButton,
	          quickGo = _this$props.quickGo,
	          rootPrefixCls = _this$props.rootPrefixCls;
	
	      if (goButton) {
	        return;
	      }
	      if (e.relatedTarget && (e.relatedTarget.className.indexOf(rootPrefixCls + '-prev') >= 0 || e.relatedTarget.className.indexOf(rootPrefixCls + '-next') >= 0)) {
	        return;
	      }
	      quickGo(_this.getValidValue());
	    }, _this.go = function (e) {
	      var goInputText = _this.state.goInputText;
	
	      if (goInputText === '') {
	        return;
	      }
	      if (e.keyCode === _KeyCode2['default'].ENTER || e.type === 'click') {
	        _this.setState({
	          goInputText: ''
	        });
	        _this.props.quickGo(_this.getValidValue());
	      }
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Options, [{
	    key: 'getValidValue',
	    value: function getValidValue() {
	      var _state = this.state,
	          goInputText = _state.goInputText,
	          current = _state.current;
	
	      return !goInputText || isNaN(goInputText) ? current : Number(goInputText);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          pageSize = _props.pageSize,
	          pageSizeOptions = _props.pageSizeOptions,
	          locale = _props.locale,
	          rootPrefixCls = _props.rootPrefixCls,
	          changeSize = _props.changeSize,
	          quickGo = _props.quickGo,
	          goButton = _props.goButton,
	          selectComponentClass = _props.selectComponentClass,
	          buildOptionText = _props.buildOptionText,
	          selectPrefixCls = _props.selectPrefixCls,
	          disabled = _props.disabled;
	      var goInputText = this.state.goInputText;
	
	      var prefixCls = rootPrefixCls + '-options';
	      var Select = selectComponentClass;
	      var changeSelect = null;
	      var goInput = null;
	      var gotoButton = null;
	
	      if (!changeSize && !quickGo) {
	        return null;
	      }
	
	      if (changeSize && Select) {
	        var options = pageSizeOptions.map(function (opt, i) {
	          return _react2['default'].createElement(
	            Select.Option,
	            { key: i, value: opt },
	            (buildOptionText || _this2.buildOptionText)(opt)
	          );
	        });
	
	        changeSelect = _react2['default'].createElement(
	          Select,
	          {
	            disabled: disabled,
	            prefixCls: selectPrefixCls,
	            showSearch: false,
	            className: prefixCls + '-size-changer',
	            optionLabelProp: 'children',
	            dropdownMatchSelectWidth: false,
	            value: (pageSize || pageSizeOptions[0]).toString(),
	            onChange: this.changeSize,
	            getPopupContainer: function getPopupContainer(triggerNode) {
	              return triggerNode.parentNode;
	            }
	          },
	          options
	        );
	      }
	
	      if (quickGo) {
	        if (goButton) {
	          gotoButton = typeof goButton === 'boolean' ? _react2['default'].createElement(
	            'button',
	            {
	              type: 'button',
	              onClick: this.go,
	              onKeyUp: this.go,
	              disabled: disabled
	            },
	            locale.jump_to_confirm
	          ) : _react2['default'].createElement(
	            'span',
	            {
	              onClick: this.go,
	              onKeyUp: this.go
	            },
	            goButton
	          );
	        }
	        goInput = _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-quick-jumper' },
	          locale.jump_to,
	          _react2['default'].createElement('input', {
	            disabled: disabled,
	            type: 'text',
	            value: goInputText,
	            onChange: this.handleChange,
	            onKeyUp: this.go,
	            onBlur: this.handleBlur
	          }),
	          locale.page,
	          gotoButton
	        );
	      }
	
	      return _react2['default'].createElement(
	        'li',
	        { className: '' + prefixCls },
	        changeSelect,
	        goInput
	      );
	    }
	  }]);
	  return Options;
	}(_react2['default'].Component);
	
	Options.propTypes = {
	  disabled: _propTypes2['default'].bool,
	  changeSize: _propTypes2['default'].func,
	  quickGo: _propTypes2['default'].func,
	  selectComponentClass: _propTypes2['default'].func,
	  current: _propTypes2['default'].number,
	  pageSizeOptions: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  pageSize: _propTypes2['default'].number,
	  buildOptionText: _propTypes2['default'].func,
	  locale: _propTypes2['default'].object,
	  rootPrefixCls: _propTypes2['default'].string,
	  selectPrefixCls: _propTypes2['default'].string,
	  goButton: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].node])
	};
	Options.defaultProps = {
	  pageSizeOptions: ['10', '20', '30', '40']
	};
	exports['default'] = Options;
	module.exports = exports['default'];

/***/ },
/* 2713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Pager = function Pager(props) {
	  var _classNames;
	
	  var prefixCls = props.rootPrefixCls + '-item';
	  var cls = (0, _classnames2['default'])(prefixCls, prefixCls + '-' + props.page, (_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-active', props.active), (0, _defineProperty3['default'])(_classNames, props.className, !!props.className), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', !props.page), _classNames));
	
	  var handleClick = function handleClick() {
	    props.onClick(props.page);
	  };
	
	  var handleKeyPress = function handleKeyPress(e) {
	    props.onKeyPress(e, props.onClick, props.page);
	  };
	
	  return _react2['default'].createElement(
	    'li',
	    {
	      title: props.showTitle ? props.page : null,
	      className: cls,
	      onClick: handleClick,
	      onKeyPress: handleKeyPress,
	      tabIndex: '0'
	    },
	    props.itemRender(props.page, 'page', _react2['default'].createElement(
	      'a',
	      null,
	      props.page
	    ))
	  );
	};
	
	Pager.propTypes = {
	  page: _propTypes2['default'].number,
	  active: _propTypes2['default'].bool,
	  last: _propTypes2['default'].bool,
	  locale: _propTypes2['default'].object,
	  className: _propTypes2['default'].string,
	  showTitle: _propTypes2['default'].bool,
	  rootPrefixCls: _propTypes2['default'].string,
	  onClick: _propTypes2['default'].func,
	  onKeyPress: _propTypes2['default'].func,
	  itemRender: _propTypes2['default'].func
	};
	
	exports['default'] = Pager;
	module.exports = exports['default'];

/***/ },
/* 2714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Pager = __webpack_require__(2713);
	
	var _Pager2 = _interopRequireDefault(_Pager);
	
	var _Options = __webpack_require__(2712);
	
	var _Options2 = _interopRequireDefault(_Options);
	
	var _KeyCode = __webpack_require__(1095);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _zh_CN = __webpack_require__(1097);
	
	var _zh_CN2 = _interopRequireDefault(_zh_CN);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function isInteger(value) {
	  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
	}
	
	function defaultItemRender(page, type, element) {
	  return element;
	}
	
	function calculatePage(p, state, props) {
	  var pageSize = p;
	  if (typeof pageSize === 'undefined') {
	    pageSize = state.pageSize;
	  }
	  return Math.floor((props.total - 1) / pageSize) + 1;
	}
	
	var Pagination = function (_React$Component) {
	  (0, _inherits3['default'])(Pagination, _React$Component);
	
	  function Pagination(props) {
	    (0, _classCallCheck3['default'])(this, Pagination);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var hasOnChange = props.onChange !== noop;
	    var hasCurrent = 'current' in props;
	    if (hasCurrent && !hasOnChange) {
	      console.warn('Warning: You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.'); // eslint-disable-line
	    }
	
	    var current = props.defaultCurrent;
	    if ('current' in props) {
	      current = props.current;
	    }
	
	    var pageSize = props.defaultPageSize;
	    if ('pageSize' in props) {
	      pageSize = props.pageSize;
	    }
	
	    current = Math.min(current, calculatePage(pageSize, undefined, props));
	
	    _this.state = {
	      current: current,
	      currentInputValue: current,
	      pageSize: pageSize
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Pagination, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      // When current page change, fix focused style of prev item
	      // A hacky solution of https://github.com/ant-design/ant-design/issues/8948
	      var prefixCls = this.props.prefixCls;
	
	      if (prevState.current !== this.state.current && this.paginationNode) {
	        var lastCurrentNode = this.paginationNode.querySelector('.' + prefixCls + '-item-' + prevState.current);
	        if (lastCurrentNode && document.activeElement === lastCurrentNode) {
	          lastCurrentNode.blur();
	        }
	      }
	    }
	  }, {
	    key: 'getValidValue',
	    value: function getValidValue(e) {
	      var inputValue = e.target.value;
	      var allPages = calculatePage(undefined, this.state, this.props);
	      var currentInputValue = this.state.currentInputValue;
	
	      var value = void 0;
	      if (inputValue === '') {
	        value = inputValue;
	      } else if (isNaN(Number(inputValue))) {
	        value = currentInputValue;
	      } else if (inputValue >= allPages) {
	        value = allPages;
	      } else {
	        value = Number(inputValue);
	      }
	      return value;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          className = _props.className,
	          disabled = _props.disabled;
	
	      // When hideOnSinglePage is true and there is only 1 page, hide the pager
	
	      if (this.props.hideOnSinglePage === true && this.props.total <= this.state.pageSize) {
	        return null;
	      }
	
	      var props = this.props;
	      var locale = props.locale;
	
	      var allPages = calculatePage(undefined, this.state, this.props);
	      var pagerList = [];
	      var jumpPrev = null;
	      var jumpNext = null;
	      var firstPager = null;
	      var lastPager = null;
	      var gotoButton = null;
	
	      var goButton = props.showQuickJumper && props.showQuickJumper.goButton;
	      var pageBufferSize = props.showLessItems ? 1 : 2;
	      var _state = this.state,
	          current = _state.current,
	          pageSize = _state.pageSize;
	
	
	      var prevPage = current - 1 > 0 ? current - 1 : 0;
	      var nextPage = current + 1 < allPages ? current + 1 : allPages;
	
	      var dataOrAriaAttributeProps = Object.keys(props).reduce(function (prev, key) {
	        if (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role') {
	          prev[key] = props[key];
	        }
	        return prev;
	      }, {});
	
	      if (props.simple) {
	        if (goButton) {
	          if (typeof goButton === 'boolean') {
	            gotoButton = _react2['default'].createElement(
	              'button',
	              {
	                type: 'button',
	                onClick: this.handleGoTO,
	                onKeyUp: this.handleGoTO
	              },
	              locale.jump_to_confirm
	            );
	          } else {
	            gotoButton = _react2['default'].createElement(
	              'span',
	              {
	                onClick: this.handleGoTO,
	                onKeyUp: this.handleGoTO
	              },
	              goButton
	            );
	          }
	          gotoButton = _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? '' + locale.jump_to + this.state.current + '/' + allPages : null,
	              className: prefixCls + '-simple-pager'
	            },
	            gotoButton
	          );
	        }
	
	        return _react2['default'].createElement(
	          'ul',
	          (0, _extends3['default'])({
	            className: prefixCls + ' ' + prefixCls + '-simple ' + props.className,
	            style: props.style,
	            ref: this.savePaginationNode
	          }, dataOrAriaAttributeProps),
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? locale.prev_page : null,
	              onClick: this.prev,
	              tabIndex: this.hasPrev() ? 0 : null,
	              onKeyPress: this.runIfEnterPrev,
	              className: (this.hasPrev() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
	              'aria-disabled': !this.hasPrev()
	            },
	            props.itemRender(prevPage, 'prev', this.getItemIcon(props.prevIcon))
	          ),
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? this.state.current + '/' + allPages : null,
	              className: prefixCls + '-simple-pager'
	            },
	            _react2['default'].createElement('input', {
	              type: 'text',
	              value: this.state.currentInputValue,
	              onKeyDown: this.handleKeyDown,
	              onKeyUp: this.handleKeyUp,
	              onChange: this.handleKeyUp,
	              size: '3'
	            }),
	            _react2['default'].createElement(
	              'span',
	              { className: prefixCls + '-slash' },
	              '/'
	            ),
	            allPages
	          ),
	          _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? locale.next_page : null,
	              onClick: this.next,
	              tabIndex: this.hasPrev() ? 0 : null,
	              onKeyPress: this.runIfEnterNext,
	              className: (this.hasNext() ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
	              'aria-disabled': !this.hasNext()
	            },
	            props.itemRender(nextPage, 'next', this.getItemIcon(props.nextIcon))
	          ),
	          gotoButton
	        );
	      }
	
	      if (allPages <= 5 + pageBufferSize * 2) {
	        var pagerProps = {
	          locale: locale,
	          rootPrefixCls: prefixCls,
	          onClick: this.handleChange,
	          onKeyPress: this.runIfEnter,
	          showTitle: props.showTitle,
	          itemRender: props.itemRender
	        };
	        if (!allPages) {
	          pagerList.push(_react2['default'].createElement(_Pager2['default'], (0, _extends3['default'])({}, pagerProps, {
	            key: 'noPager',
	            page: allPages,
	            className: prefixCls + '-disabled'
	          })));
	        }
	        for (var i = 1; i <= allPages; i++) {
	          var active = this.state.current === i;
	          pagerList.push(_react2['default'].createElement(_Pager2['default'], (0, _extends3['default'])({}, pagerProps, {
	            key: i,
	            page: i,
	            active: active
	          })));
	        }
	      } else {
	        var prevItemTitle = props.showLessItems ? locale.prev_3 : locale.prev_5;
	        var nextItemTitle = props.showLessItems ? locale.next_3 : locale.next_5;
	        if (props.showPrevNextJumpers) {
	          var jumpPrevClassString = prefixCls + '-jump-prev';
	          if (props.jumpPrevIcon) {
	            jumpPrevClassString += ' ' + prefixCls + '-jump-prev-custom-icon';
	          }
	          jumpPrev = _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? prevItemTitle : null,
	              key: 'prev',
	              onClick: this.jumpPrev,
	              tabIndex: '0',
	              onKeyPress: this.runIfEnterJumpPrev,
	              className: jumpPrevClassString
	            },
	            props.itemRender(this.getJumpPrevPage(), 'jump-prev', this.getItemIcon(props.jumpPrevIcon))
	          );
	          var jumpNextClassString = prefixCls + '-jump-next';
	          if (props.jumpNextIcon) {
	            jumpNextClassString += ' ' + prefixCls + '-jump-next-custom-icon';
	          }
	          jumpNext = _react2['default'].createElement(
	            'li',
	            {
	              title: props.showTitle ? nextItemTitle : null,
	              key: 'next',
	              tabIndex: '0',
	              onClick: this.jumpNext,
	              onKeyPress: this.runIfEnterJumpNext,
	              className: jumpNextClassString
	            },
	            props.itemRender(this.getJumpNextPage(), 'jump-next', this.getItemIcon(props.jumpNextIcon))
	          );
	        }
	        lastPager = _react2['default'].createElement(_Pager2['default'], {
	          locale: props.locale,
	          last: true,
	          rootPrefixCls: prefixCls,
	          onClick: this.handleChange,
	          onKeyPress: this.runIfEnter,
	          key: allPages,
	          page: allPages,
	          active: false,
	          showTitle: props.showTitle,
	          itemRender: props.itemRender
	        });
	        firstPager = _react2['default'].createElement(_Pager2['default'], {
	          locale: props.locale,
	          rootPrefixCls: prefixCls,
	          onClick: this.handleChange,
	          onKeyPress: this.runIfEnter,
	          key: 1,
	          page: 1,
	          active: false,
	          showTitle: props.showTitle,
	          itemRender: props.itemRender
	        });
	
	        var left = Math.max(1, current - pageBufferSize);
	        var right = Math.min(current + pageBufferSize, allPages);
	
	        if (current - 1 <= pageBufferSize) {
	          right = 1 + pageBufferSize * 2;
	        }
	
	        if (allPages - current <= pageBufferSize) {
	          left = allPages - pageBufferSize * 2;
	        }
	
	        for (var _i = left; _i <= right; _i++) {
	          var _active = current === _i;
	          pagerList.push(_react2['default'].createElement(_Pager2['default'], {
	            locale: props.locale,
	            rootPrefixCls: prefixCls,
	            onClick: this.handleChange,
	            onKeyPress: this.runIfEnter,
	            key: _i,
	            page: _i,
	            active: _active,
	            showTitle: props.showTitle,
	            itemRender: props.itemRender
	          }));
	        }
	
	        if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
	          pagerList[0] = _react2['default'].cloneElement(pagerList[0], {
	            className: prefixCls + '-item-after-jump-prev'
	          });
	          pagerList.unshift(jumpPrev);
	        }
	        if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
	          pagerList[pagerList.length - 1] = _react2['default'].cloneElement(pagerList[pagerList.length - 1], {
	            className: prefixCls + '-item-before-jump-next'
	          });
	          pagerList.push(jumpNext);
	        }
	
	        if (left !== 1) {
	          pagerList.unshift(firstPager);
	        }
	        if (right !== allPages) {
	          pagerList.push(lastPager);
	        }
	      }
	
	      var totalText = null;
	
	      if (props.showTotal) {
	        totalText = _react2['default'].createElement(
	          'li',
	          { className: prefixCls + '-total-text' },
	          props.showTotal(props.total, [props.total === 0 ? 0 : (current - 1) * pageSize + 1, current * pageSize > props.total ? props.total : current * pageSize])
	        );
	      }
	      var prevDisabled = !this.hasPrev() || !allPages;
	      var nextDisabled = !this.hasNext() || !allPages;
	      return _react2['default'].createElement(
	        'ul',
	        (0, _extends3['default'])({
	          className: (0, _classnames2['default'])(prefixCls, className, (0, _defineProperty3['default'])({}, prefixCls + '-disabled', disabled)),
	          style: props.style,
	          unselectable: 'unselectable',
	          ref: this.savePaginationNode
	        }, dataOrAriaAttributeProps),
	        totalText,
	        _react2['default'].createElement(
	          'li',
	          {
	            title: props.showTitle ? locale.prev_page : null,
	            onClick: this.prev,
	            tabIndex: prevDisabled ? null : 0,
	            onKeyPress: this.runIfEnterPrev,
	            className: (!prevDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-prev',
	            'aria-disabled': prevDisabled
	          },
	          props.itemRender(prevPage, 'prev', this.getItemIcon(props.prevIcon))
	        ),
	        pagerList,
	        _react2['default'].createElement(
	          'li',
	          {
	            title: props.showTitle ? locale.next_page : null,
	            onClick: this.next,
	            tabIndex: nextDisabled ? null : 0,
	            onKeyPress: this.runIfEnterNext,
	            className: (!nextDisabled ? '' : prefixCls + '-disabled') + ' ' + prefixCls + '-next',
	            'aria-disabled': nextDisabled
	          },
	          props.itemRender(nextPage, 'next', this.getItemIcon(props.nextIcon))
	        ),
	        _react2['default'].createElement(_Options2['default'], {
	          disabled: disabled,
	          locale: props.locale,
	          rootPrefixCls: prefixCls,
	          selectComponentClass: props.selectComponentClass,
	          selectPrefixCls: props.selectPrefixCls,
	          changeSize: this.props.showSizeChanger ? this.changePageSize : null,
	          current: this.state.current,
	          pageSize: this.state.pageSize,
	          pageSizeOptions: this.props.pageSizeOptions,
	          quickGo: this.shouldDisplayQuickJumper() ? this.handleChange : null,
	          goButton: goButton
	        })
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(props, prevState) {
	      var newState = {};
	
	      if ('current' in props) {
	        newState.current = props.current;
	
	        if (props.current !== prevState.current) {
	          newState.currentInputValue = newState.current;
	        }
	      }
	
	      if ('pageSize' in props && props.pageSize !== prevState.pageSize) {
	        var current = prevState.current;
	        var newCurrent = calculatePage(props.pageSize, prevState, props);
	        current = current > newCurrent ? newCurrent : current;
	
	        if (!('current' in props)) {
	          newState.current = current;
	          newState.currentInputValue = current;
	        }
	        newState.pageSize = props.pageSize;
	      }
	
	      return newState;
	    }
	
	    /**
	     * computed icon node that need to be rendered.
	     * @param {React.ReactNode | React.ComponentType<PaginationProps>} icon received icon.
	     * @returns {React.ReactNode}
	     */
	
	  }]);
	  return Pagination;
	}(_react2['default'].Component);
	
	Pagination.propTypes = {
	  disabled: _propTypes2['default'].bool,
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  current: _propTypes2['default'].number,
	  defaultCurrent: _propTypes2['default'].number,
	  total: _propTypes2['default'].number,
	  pageSize: _propTypes2['default'].number,
	  defaultPageSize: _propTypes2['default'].number,
	  onChange: _propTypes2['default'].func,
	  hideOnSinglePage: _propTypes2['default'].bool,
	  showSizeChanger: _propTypes2['default'].bool,
	  showLessItems: _propTypes2['default'].bool,
	  onShowSizeChange: _propTypes2['default'].func,
	  selectComponentClass: _propTypes2['default'].func,
	  showPrevNextJumpers: _propTypes2['default'].bool,
	  showQuickJumper: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].object]),
	  showTitle: _propTypes2['default'].bool,
	  pageSizeOptions: _propTypes2['default'].arrayOf(_propTypes2['default'].string),
	  showTotal: _propTypes2['default'].func,
	  locale: _propTypes2['default'].object,
	  style: _propTypes2['default'].object,
	  itemRender: _propTypes2['default'].func,
	  prevIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].node]),
	  nextIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].node]),
	  jumpPrevIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].node]),
	  jumpNextIcon: _propTypes2['default'].oneOfType([_propTypes2['default'].func, _propTypes2['default'].node])
	};
	Pagination.defaultProps = {
	  defaultCurrent: 1,
	  total: 0,
	  defaultPageSize: 10,
	  onChange: noop,
	  className: '',
	  selectPrefixCls: 'rc-select',
	  prefixCls: 'rc-pagination',
	  selectComponentClass: null,
	  hideOnSinglePage: false,
	  showPrevNextJumpers: true,
	  showQuickJumper: false,
	  showSizeChanger: false,
	  showLessItems: false,
	  showTitle: true,
	  onShowSizeChange: noop,
	  locale: _zh_CN2['default'],
	  style: {},
	  itemRender: defaultItemRender
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this2 = this;
	
	  this.getJumpPrevPage = function () {
	    return Math.max(1, _this2.state.current - (_this2.props.showLessItems ? 3 : 5));
	  };
	
	  this.getJumpNextPage = function () {
	    return Math.min(calculatePage(undefined, _this2.state, _this2.props), _this2.state.current + (_this2.props.showLessItems ? 3 : 5));
	  };
	
	  this.getItemIcon = function (icon) {
	    var prefixCls = _this2.props.prefixCls;
	
	    var iconNode = icon || _react2['default'].createElement('a', { className: prefixCls + '-item-link' });
	    if (typeof icon === 'function') {
	      iconNode = _react2['default'].createElement(icon, (0, _extends3['default'])({}, _this2.props));
	    }
	    return iconNode;
	  };
	
	  this.savePaginationNode = function (node) {
	    _this2.paginationNode = node;
	  };
	
	  this.isValid = function (page) {
	    return isInteger(page) && page !== _this2.state.current;
	  };
	
	  this.shouldDisplayQuickJumper = function () {
	    var _props2 = _this2.props,
	        showQuickJumper = _props2.showQuickJumper,
	        pageSize = _props2.pageSize,
	        total = _props2.total;
	
	    if (total <= pageSize) {
	      return false;
	    }
	    return showQuickJumper;
	  };
	
	  this.handleKeyDown = function (e) {
	    if (e.keyCode === _KeyCode2['default'].ARROW_UP || e.keyCode === _KeyCode2['default'].ARROW_DOWN) {
	      e.preventDefault();
	    }
	  };
	
	  this.handleKeyUp = function (e) {
	    var value = _this2.getValidValue(e);
	    var currentInputValue = _this2.state.currentInputValue;
	
	    if (value !== currentInputValue) {
	      _this2.setState({
	        currentInputValue: value
	      });
	    }
	    if (e.keyCode === _KeyCode2['default'].ENTER) {
	      _this2.handleChange(value);
	    } else if (e.keyCode === _KeyCode2['default'].ARROW_UP) {
	      _this2.handleChange(value - 1);
	    } else if (e.keyCode === _KeyCode2['default'].ARROW_DOWN) {
	      _this2.handleChange(value + 1);
	    }
	  };
	
	  this.changePageSize = function (size) {
	    var current = _this2.state.current;
	    var newCurrent = calculatePage(size, _this2.state, _this2.props);
	    current = current > newCurrent ? newCurrent : current;
	    // fix the issue:
	    // Once 'total' is 0, 'current' in 'onShowSizeChange' is 0, which is not correct.
	    if (newCurrent === 0) {
	      current = _this2.state.current;
	    }
	
	    if (typeof size === 'number') {
	      if (!('pageSize' in _this2.props)) {
	        _this2.setState({
	          pageSize: size
	        });
	      }
	      if (!('current' in _this2.props)) {
	        _this2.setState({
	          current: current,
	          currentInputValue: current
	        });
	      }
	    }
	    _this2.props.onShowSizeChange(current, size);
	  };
	
	  this.handleChange = function (p) {
	    var disabled = _this2.props.disabled;
	
	
	    var page = p;
	    if (_this2.isValid(page) && !disabled) {
	      var currentPage = calculatePage(undefined, _this2.state, _this2.props);
	      if (page > currentPage) {
	        page = currentPage;
	      } else if (page < 1) {
	        page = 1;
	      }
	
	      if (!('current' in _this2.props)) {
	        _this2.setState({
	          current: page,
	          currentInputValue: page
	        });
	      }
	
	      var pageSize = _this2.state.pageSize;
	      _this2.props.onChange(page, pageSize);
	
	      return page;
	    }
	
	    return _this2.state.current;
	  };
	
	  this.prev = function () {
	    if (_this2.hasPrev()) {
	      _this2.handleChange(_this2.state.current - 1);
	    }
	  };
	
	  this.next = function () {
	    if (_this2.hasNext()) {
	      _this2.handleChange(_this2.state.current + 1);
	    }
	  };
	
	  this.jumpPrev = function () {
	    _this2.handleChange(_this2.getJumpPrevPage());
	  };
	
	  this.jumpNext = function () {
	    _this2.handleChange(_this2.getJumpNextPage());
	  };
	
	  this.hasPrev = function () {
	    return _this2.state.current > 1;
	  };
	
	  this.hasNext = function () {
	    return _this2.state.current < calculatePage(undefined, _this2.state, _this2.props);
	  };
	
	  this.runIfEnter = function (event, callback) {
	    for (var _len = arguments.length, restParams = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      restParams[_key - 2] = arguments[_key];
	    }
	
	    if (event.key === 'Enter' || event.charCode === 13) {
	      callback.apply(undefined, restParams);
	    }
	  };
	
	  this.runIfEnterPrev = function (e) {
	    _this2.runIfEnter(e, _this2.prev);
	  };
	
	  this.runIfEnterNext = function (e) {
	    _this2.runIfEnter(e, _this2.next);
	  };
	
	  this.runIfEnterJumpPrev = function (e) {
	    _this2.runIfEnter(e, _this2.jumpPrev);
	  };
	
	  this.runIfEnterJumpNext = function (e) {
	    _this2.runIfEnter(e, _this2.jumpNext);
	  };
	
	  this.handleGoTO = function (e) {
	    if (e.keyCode === _KeyCode2['default'].ENTER || e.type === 'click') {
	      _this2.handleChange(_this2.state.currentInputValue);
	    }
	  };
	};
	
	(0, _reactLifecyclesCompat.polyfill)(Pagination);
	
	exports['default'] = Pagination;
	module.exports = exports['default'];

/***/ },
/* 2715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Pagination = __webpack_require__(2714);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_Pagination)['default'];
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 2716 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _enhancer = _interopRequireDefault(__webpack_require__(1098));
	
	var _types = __webpack_require__(1099);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var gradientSeed = 0;
	
	function stripPercentToNumber(percent) {
	  return +percent.replace('%', '');
	}
	
	function toArray(symArray) {
	  return Array.isArray(symArray) ? symArray : [symArray];
	}
	
	function getPathStyles(offset, percent, strokeColor, strokeWidth) {
	  var gapDegree = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	  var gapPosition = arguments.length > 5 ? arguments[5] : undefined;
	  var radius = 50 - strokeWidth / 2;
	  var beginPositionX = 0;
	  var beginPositionY = -radius;
	  var endPositionX = 0;
	  var endPositionY = -2 * radius;
	
	  switch (gapPosition) {
	    case 'left':
	      beginPositionX = -radius;
	      beginPositionY = 0;
	      endPositionX = 2 * radius;
	      endPositionY = 0;
	      break;
	
	    case 'right':
	      beginPositionX = radius;
	      beginPositionY = 0;
	      endPositionX = -2 * radius;
	      endPositionY = 0;
	      break;
	
	    case 'bottom':
	      beginPositionY = radius;
	      endPositionY = 2 * radius;
	      break;
	
	    default:
	  }
	
	  var pathString = "M 50,50 m ".concat(beginPositionX, ",").concat(beginPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(endPositionX, ",").concat(-endPositionY, "\n   a ").concat(radius, ",").concat(radius, " 0 1 1 ").concat(-endPositionX, ",").concat(endPositionY);
	  var len = Math.PI * 2 * radius;
	  var pathStyle = {
	    stroke: strokeColor,
	    strokeDasharray: "".concat(percent / 100 * (len - gapDegree), "px ").concat(len, "px"),
	    strokeDashoffset: "-".concat(gapDegree / 2 + offset / 100 * (len - gapDegree), "px"),
	    transition: 'stroke-dashoffset .3s ease 0s, stroke-dasharray .3s ease 0s, stroke .3s, stroke-width .06s ease .3s' // eslint-disable-line
	
	  };
	  return {
	    pathString: pathString,
	    pathStyle: pathStyle
	  };
	}
	
	var Circle = /*#__PURE__*/function (_Component) {
	  _inherits(Circle, _Component);
	
	  var _super = _createSuper(Circle);
	
	  function Circle() {
	    var _this;
	
	    _classCallCheck(this, Circle);
	
	    _this = _super.call(this);
	
	    _defineProperty(_assertThisInitialized(_this), "paths", {});
	
	    _defineProperty(_assertThisInitialized(_this), "gradientId", 0);
	
	    _this.gradientId = gradientSeed;
	    gradientSeed += 1;
	    return _this;
	  }
	
	  _createClass(Circle, [{
	    key: "getStokeList",
	    value: function getStokeList() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          prefixCls = _this$props.prefixCls,
	          percent = _this$props.percent,
	          strokeColor = _this$props.strokeColor,
	          strokeWidth = _this$props.strokeWidth,
	          strokeLinecap = _this$props.strokeLinecap,
	          gapDegree = _this$props.gapDegree,
	          gapPosition = _this$props.gapPosition;
	      var percentList = toArray(percent);
	      var strokeColorList = toArray(strokeColor);
	      var stackPtg = 0;
	      return percentList.map(function (ptg, index) {
	        var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
	        var stroke = Object.prototype.toString.call(color) === '[object Object]' ? "url(#".concat(prefixCls, "-gradient-").concat(_this2.gradientId, ")") : '';
	
	        var _getPathStyles = getPathStyles(stackPtg, ptg, color, strokeWidth, gapDegree, gapPosition),
	            pathString = _getPathStyles.pathString,
	            pathStyle = _getPathStyles.pathStyle;
	
	        stackPtg += ptg;
	        return /*#__PURE__*/_react["default"].createElement("path", {
	          key: index,
	          className: "".concat(prefixCls, "-circle-path"),
	          d: pathString,
	          stroke: stroke,
	          strokeLinecap: strokeLinecap,
	          strokeWidth: strokeWidth,
	          opacity: ptg === 0 ? 0 : 1,
	          fillOpacity: "0",
	          style: pathStyle,
	          ref: function ref(path) {
	            _this2.paths[index] = path;
	          }
	        });
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          strokeWidth = _this$props2.strokeWidth,
	          trailWidth = _this$props2.trailWidth,
	          gapDegree = _this$props2.gapDegree,
	          gapPosition = _this$props2.gapPosition,
	          trailColor = _this$props2.trailColor,
	          strokeLinecap = _this$props2.strokeLinecap,
	          style = _this$props2.style,
	          className = _this$props2.className,
	          strokeColor = _this$props2.strokeColor,
	          restProps = _objectWithoutProperties(_this$props2, ["prefixCls", "strokeWidth", "trailWidth", "gapDegree", "gapPosition", "trailColor", "strokeLinecap", "style", "className", "strokeColor"]);
	
	      var _getPathStyles2 = getPathStyles(0, 100, trailColor, strokeWidth, gapDegree, gapPosition),
	          pathString = _getPathStyles2.pathString,
	          pathStyle = _getPathStyles2.pathStyle;
	
	      delete restProps.percent;
	      var strokeColorList = toArray(strokeColor);
	      var gradient = strokeColorList.find(function (color) {
	        return Object.prototype.toString.call(color) === '[object Object]';
	      });
	      return /*#__PURE__*/_react["default"].createElement("svg", _extends({
	        className: "".concat(prefixCls, "-circle ").concat(className),
	        viewBox: "0 0 100 100",
	        style: style
	      }, restProps), gradient && /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("linearGradient", {
	        id: "".concat(prefixCls, "-gradient-").concat(this.gradientId),
	        x1: "100%",
	        y1: "0%",
	        x2: "0%",
	        y2: "0%"
	      }, Object.keys(gradient).sort(function (a, b) {
	        return stripPercentToNumber(a) - stripPercentToNumber(b);
	      }).map(function (key, index) {
	        return /*#__PURE__*/_react["default"].createElement("stop", {
	          key: index,
	          offset: key,
	          stopColor: gradient[key]
	        });
	      }))), /*#__PURE__*/_react["default"].createElement("path", {
	        className: "".concat(prefixCls, "-circle-trail"),
	        d: pathString,
	        stroke: trailColor,
	        strokeLinecap: strokeLinecap,
	        strokeWidth: trailWidth || strokeWidth,
	        fillOpacity: "0",
	        style: pathStyle
	      }), this.getStokeList().reverse());
	    }
	  }]);
	
	  return Circle;
	}(_react.Component);
	
	Circle.propTypes = _objectSpread(_objectSpread({}, _types.propTypes), {}, {
	  gapPosition: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'right'])
	});
	Circle.defaultProps = _objectSpread(_objectSpread({}, _types.defaultProps), {}, {
	  gapPosition: 'top'
	});
	
	var _default = (0, _enhancer["default"])(Circle);
	
	exports["default"] = _default;

/***/ },
/* 2717 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _enhancer = _interopRequireDefault(__webpack_require__(1098));
	
	var _types = __webpack_require__(1099);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Line = /*#__PURE__*/function (_Component) {
	  _inherits(Line, _Component);
	
	  var _super = _createSuper(Line);
	
	  function Line() {
	    var _this;
	
	    _classCallCheck(this, Line);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "paths", {});
	
	    return _this;
	  }
	
	  _createClass(Line, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          className = _this$props.className,
	          percent = _this$props.percent,
	          prefixCls = _this$props.prefixCls,
	          strokeColor = _this$props.strokeColor,
	          strokeLinecap = _this$props.strokeLinecap,
	          strokeWidth = _this$props.strokeWidth,
	          style = _this$props.style,
	          trailColor = _this$props.trailColor,
	          trailWidth = _this$props.trailWidth,
	          transition = _this$props.transition,
	          restProps = _objectWithoutProperties(_this$props, ["className", "percent", "prefixCls", "strokeColor", "strokeLinecap", "strokeWidth", "style", "trailColor", "trailWidth", "transition"]);
	
	      delete restProps.gapPosition;
	      var percentList = Array.isArray(percent) ? percent : [percent];
	      var strokeColorList = Array.isArray(strokeColor) ? strokeColor : [strokeColor];
	      var center = strokeWidth / 2;
	      var right = 100 - strokeWidth / 2;
	      var pathString = "M ".concat(strokeLinecap === 'round' ? center : 0, ",").concat(center, "\n           L ").concat(strokeLinecap === 'round' ? right : 100, ",").concat(center);
	      var viewBoxString = "0 0 100 ".concat(strokeWidth);
	      var stackPtg = 0;
	      return /*#__PURE__*/_react["default"].createElement("svg", _extends({
	        className: "".concat(prefixCls, "-line ").concat(className),
	        viewBox: viewBoxString,
	        preserveAspectRatio: "none",
	        style: style
	      }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
	        className: "".concat(prefixCls, "-line-trail"),
	        d: pathString,
	        strokeLinecap: strokeLinecap,
	        stroke: trailColor,
	        strokeWidth: trailWidth || strokeWidth,
	        fillOpacity: "0"
	      }), percentList.map(function (ptg, index) {
	        var pathStyle = {
	          strokeDasharray: "".concat(ptg, "px, 100px"),
	          strokeDashoffset: "-".concat(stackPtg, "px"),
	          transition: transition || 'stroke-dashoffset 0.3s ease 0s, stroke-dasharray .3s ease 0s, stroke 0.3s linear'
	        };
	        var color = strokeColorList[index] || strokeColorList[strokeColorList.length - 1];
	        stackPtg += ptg;
	        return /*#__PURE__*/_react["default"].createElement("path", {
	          key: index,
	          className: "".concat(prefixCls, "-line-path"),
	          d: pathString,
	          strokeLinecap: strokeLinecap,
	          stroke: color,
	          strokeWidth: strokeWidth,
	          fillOpacity: "0",
	          ref: function ref(path) {
	            _this2.paths[index] = path;
	          },
	          style: pathStyle
	        });
	      }));
	    }
	  }]);
	
	  return Line;
	}(_react.Component);
	
	Line.propTypes = _types.propTypes;
	Line.defaultProps = _types.defaultProps;
	
	var _default = (0, _enhancer["default"])(Line);
	
	exports["default"] = _default;

/***/ },
/* 2718 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Line", {
	  enumerable: true,
	  get: function get() {
	    return _Line["default"];
	  }
	});
	Object.defineProperty(exports, "Circle", {
	  enumerable: true,
	  get: function get() {
	    return _Circle["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _Line = _interopRequireDefault(__webpack_require__(2717));
	
	var _Circle = _interopRequireDefault(__webpack_require__(2716));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = {
	  Line: _Line["default"],
	  Circle: _Circle["default"]
	};
	exports["default"] = _default;

/***/ },
/* 2719 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(71));
	
	var _util = __webpack_require__(2722);
	
	var _Star = _interopRequireDefault(__webpack_require__(2720));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function noop() {}
	
	var Rate =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Rate, _React$Component);
	
	  function Rate(props) {
	    var _this;
	
	    _classCallCheck(this, Rate);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Rate).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "onHover", function (event, index) {
	      var onHoverChange = _this.props.onHoverChange;
	
	      var hoverValue = _this.getStarValue(index, event.pageX);
	
	      var cleanedValue = _this.state.cleanedValue;
	
	      if (hoverValue !== cleanedValue) {
	        _this.setState({
	          hoverValue: hoverValue,
	          cleanedValue: null
	        });
	      }
	
	      onHoverChange(hoverValue);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
	      var onHoverChange = _this.props.onHoverChange;
	
	      _this.setState({
	        hoverValue: undefined,
	        cleanedValue: null
	      });
	
	      onHoverChange(undefined);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onClick", function (event, index) {
	      var allowClear = _this.props.allowClear;
	      var value = _this.state.value;
	
	      var newValue = _this.getStarValue(index, event.pageX);
	
	      var isReset = false;
	
	      if (allowClear) {
	        isReset = newValue === value;
	      }
	
	      _this.onMouseLeave(true);
	
	      _this.changeValue(isReset ? 0 : newValue);
	
	      _this.setState({
	        cleanedValue: isReset ? newValue : null
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onFocus", function () {
	      var onFocus = _this.props.onFocus;
	
	      _this.setState({
	        focused: true
	      });
	
	      if (onFocus) {
	        onFocus();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onBlur", function () {
	      var onBlur = _this.props.onBlur;
	
	      _this.setState({
	        focused: false
	      });
	
	      if (onBlur) {
	        onBlur();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (event) {
	      var keyCode = event.keyCode;
	      var _this$props = _this.props,
	          count = _this$props.count,
	          allowHalf = _this$props.allowHalf,
	          onKeyDown = _this$props.onKeyDown;
	      var value = _this.state.value;
	
	      if (keyCode === _KeyCode["default"].RIGHT && value < count) {
	        if (allowHalf) {
	          value += 0.5;
	        } else {
	          value += 1;
	        }
	
	        _this.changeValue(value);
	
	        event.preventDefault();
	      } else if (keyCode === _KeyCode["default"].LEFT && value > 0) {
	        if (allowHalf) {
	          value -= 0.5;
	        } else {
	          value -= 1;
	        }
	
	        _this.changeValue(value);
	
	        event.preventDefault();
	      }
	
	      if (onKeyDown) {
	        onKeyDown(event);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "saveRef", function (index) {
	      return function (node) {
	        _this.stars[index] = node;
	      };
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "saveRate", function (node) {
	      _this.rate = node;
	    });
	
	    var _value = props.value;
	
	    if (_value === undefined) {
	      _value = props.defaultValue;
	    }
	
	    _this.stars = {};
	    _this.state = {
	      value: _value,
	      focused: false,
	      cleanedValue: null
	    };
	    return _this;
	  }
	
	  _createClass(Rate, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props2 = this.props,
	          autoFocus = _this$props2.autoFocus,
	          disabled = _this$props2.disabled;
	
	      if (autoFocus && !disabled) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "getStarDOM",
	    value: function getStarDOM(index) {
	      return _reactDom["default"].findDOMNode(this.stars[index]);
	    }
	  }, {
	    key: "getStarValue",
	    value: function getStarValue(index, x) {
	      var allowHalf = this.props.allowHalf;
	      var value = index + 1;
	
	      if (allowHalf) {
	        var starEle = this.getStarDOM(index);
	        var leftDis = (0, _util.getOffsetLeft)(starEle);
	        var width = starEle.clientWidth;
	
	        if (x - leftDis < width / 2) {
	          value -= 0.5;
	        }
	      }
	
	      return value;
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      var disabled = this.props.disabled;
	
	      if (!disabled) {
	        this.rate.focus();
	      }
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      var disabled = this.props.disabled;
	
	      if (!disabled) {
	        this.rate.blur();
	      }
	    }
	  }, {
	    key: "changeValue",
	    value: function changeValue(value) {
	      var onChange = this.props.onChange;
	
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        });
	      }
	
	      onChange(value);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          count = _this$props3.count,
	          allowHalf = _this$props3.allowHalf,
	          style = _this$props3.style,
	          prefixCls = _this$props3.prefixCls,
	          disabled = _this$props3.disabled,
	          className = _this$props3.className,
	          character = _this$props3.character,
	          characterRender = _this$props3.characterRender,
	          tabIndex = _this$props3.tabIndex;
	      var _this$state = this.state,
	          value = _this$state.value,
	          hoverValue = _this$state.hoverValue,
	          focused = _this$state.focused;
	      var stars = [];
	      var disabledClass = disabled ? "".concat(prefixCls, "-disabled") : '';
	
	      for (var index = 0; index < count; index++) {
	        stars.push(_react["default"].createElement(_Star["default"], {
	          ref: this.saveRef(index),
	          index: index,
	          count: count,
	          disabled: disabled,
	          prefixCls: "".concat(prefixCls, "-star"),
	          allowHalf: allowHalf,
	          value: hoverValue === undefined ? value : hoverValue,
	          onClick: this.onClick,
	          onHover: this.onHover,
	          key: index,
	          character: character,
	          characterRender: characterRender,
	          focused: focused
	        }));
	      }
	
	      return _react["default"].createElement("ul", {
	        className: (0, _classnames["default"])(prefixCls, disabledClass, className),
	        style: style,
	        onMouseLeave: disabled ? null : this.onMouseLeave,
	        tabIndex: disabled ? -1 : tabIndex,
	        onFocus: disabled ? null : this.onFocus,
	        onBlur: disabled ? null : this.onBlur,
	        onKeyDown: disabled ? null : this.onKeyDown,
	        ref: this.saveRate,
	        role: "radiogroup"
	      }, stars);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, state) {
	      if ('value' in nextProps && nextProps.value !== undefined) {
	        return _objectSpread({}, state, {
	          value: nextProps.value
	        });
	      }
	
	      return state;
	    }
	  }]);
	
	  return Rate;
	}(_react["default"].Component);
	
	_defineProperty(Rate, "propTypes", {
	  disabled: _propTypes["default"].bool,
	  value: _propTypes["default"].number,
	  defaultValue: _propTypes["default"].number,
	  count: _propTypes["default"].number,
	  allowHalf: _propTypes["default"].bool,
	  allowClear: _propTypes["default"].bool,
	  style: _propTypes["default"].object,
	  prefixCls: _propTypes["default"].string,
	  onChange: _propTypes["default"].func,
	  onHoverChange: _propTypes["default"].func,
	  className: _propTypes["default"].string,
	  character: _propTypes["default"].node,
	  characterRender: _propTypes["default"].func,
	  tabIndex: _propTypes["default"].number,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  onKeyDown: _propTypes["default"].func,
	  autoFocus: _propTypes["default"].bool
	});
	
	_defineProperty(Rate, "defaultProps", {
	  defaultValue: 0,
	  count: 5,
	  allowHalf: false,
	  allowClear: true,
	  style: {},
	  prefixCls: 'rc-rate',
	  onChange: noop,
	  character: '★',
	  onHoverChange: noop,
	  tabIndex: 0
	});
	
	(0, _reactLifecyclesCompat.polyfill)(Rate);
	var _default = Rate;
	exports["default"] = _default;

/***/ },
/* 2720 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Star =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Star, _React$Component);
	
	  function Star() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Star);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Star)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "onHover", function (e) {
	      var _this$props = _this.props,
	          onHover = _this$props.onHover,
	          index = _this$props.index;
	      onHover(e, index);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
	      var _this$props2 = _this.props,
	          onClick = _this$props2.onClick,
	          index = _this$props2.index;
	      onClick(e, index);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
	      var _this$props3 = _this.props,
	          onClick = _this$props3.onClick,
	          index = _this$props3.index;
	
	      if (e.keyCode === 13) {
	        onClick(e, index);
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(Star, [{
	    key: "getClassName",
	    value: function getClassName() {
	      var _this$props4 = this.props,
	          prefixCls = _this$props4.prefixCls,
	          index = _this$props4.index,
	          value = _this$props4.value,
	          allowHalf = _this$props4.allowHalf,
	          focused = _this$props4.focused;
	      var starValue = index + 1;
	      var className = prefixCls;
	
	      if (value === 0 && index === 0 && focused) {
	        className += " ".concat(prefixCls, "-focused");
	      } else if (allowHalf && value + 0.5 === starValue) {
	        className += " ".concat(prefixCls, "-half ").concat(prefixCls, "-active");
	
	        if (focused) {
	          className += " ".concat(prefixCls, "-focused");
	        }
	      } else {
	        className += starValue <= value ? " ".concat(prefixCls, "-full") : " ".concat(prefixCls, "-zero");
	
	        if (starValue === value && focused) {
	          className += " ".concat(prefixCls, "-focused");
	        }
	      }
	
	      return className;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var onHover = this.onHover,
	          onClick = this.onClick,
	          onKeyDown = this.onKeyDown;
	      var _this$props5 = this.props,
	          disabled = _this$props5.disabled,
	          prefixCls = _this$props5.prefixCls,
	          character = _this$props5.character,
	          characterRender = _this$props5.characterRender,
	          index = _this$props5.index,
	          count = _this$props5.count,
	          value = _this$props5.value;
	
	      var start = _react["default"].createElement("li", {
	        className: this.getClassName()
	      }, _react["default"].createElement("div", {
	        onClick: disabled ? null : onClick,
	        onKeyDown: disabled ? null : onKeyDown,
	        onMouseMove: disabled ? null : onHover,
	        role: "radio",
	        "aria-checked": value > index ? 'true' : 'false',
	        "aria-posinset": index + 1,
	        "aria-setsize": count,
	        tabIndex: 0
	      }, _react["default"].createElement("div", {
	        className: "".concat(prefixCls, "-first")
	      }, character), _react["default"].createElement("div", {
	        className: "".concat(prefixCls, "-second")
	      }, character)));
	
	      if (characterRender) {
	        start = characterRender(start, this.props);
	      }
	
	      return start;
	    }
	  }]);
	
	  return Star;
	}(_react["default"].Component);
	
	exports["default"] = Star;
	
	_defineProperty(Star, "propTypes", {
	  value: _propTypes["default"].number,
	  index: _propTypes["default"].number,
	  prefixCls: _propTypes["default"].string,
	  allowHalf: _propTypes["default"].bool,
	  disabled: _propTypes["default"].bool,
	  onHover: _propTypes["default"].func,
	  onClick: _propTypes["default"].func,
	  character: _propTypes["default"].node,
	  characterRender: _propTypes["default"].func,
	  focused: _propTypes["default"].bool,
	  count: _propTypes["default"].number
	});

/***/ },
/* 2721 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Rate = _interopRequireDefault(__webpack_require__(2719));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _Rate["default"];
	exports["default"] = _default;

/***/ },
/* 2722 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOffsetLeft = getOffsetLeft;
	
	/* eslint-disable import/prefer-default-export */
	function getScroll(w, top) {
	  var ret = top ? w.pageYOffset : w.pageXOffset;
	  var method = top ? 'scrollTop' : 'scrollLeft';
	
	  if (typeof ret !== 'number') {
	    var d = w.document; // ie6,7,8 standard mode
	
	    ret = d.documentElement[method];
	
	    if (typeof ret !== 'number') {
	      // quirks mode
	      ret = d.body[method];
	    }
	  }
	
	  return ret;
	}
	
	function getClientPosition(elem) {
	  var x;
	  var y;
	  var doc = elem.ownerDocument;
	  var body = doc.body;
	  var docElem = doc && doc.documentElement;
	  var box = elem.getBoundingClientRect();
	  x = box.left;
	  y = box.top;
	  x -= docElem.clientLeft || body.clientLeft || 0;
	  y -= docElem.clientTop || body.clientTop || 0;
	  return {
	    left: x,
	    top: y
	  };
	}
	
	function getOffsetLeft(el) {
	  var pos = getClientPosition(el);
	  var doc = el.ownerDocument;
	  var w = doc.defaultView || doc.parentWindow;
	  pos.left += getScroll(w);
	  return pos.left;
	}

/***/ },
/* 2723 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _domScrollIntoView = _interopRequireDefault(__webpack_require__(281));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _raf = _interopRequireDefault(__webpack_require__(127));
	
	var _rcMenu = _interopRequireDefault(__webpack_require__(219));
	
	var _toArray = _interopRequireDefault(__webpack_require__(112));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(23);
	
	var _util = __webpack_require__(561);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var DropdownMenu =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(DropdownMenu, _React$Component);
	
	  function DropdownMenu(props) {
	    var _this;
	
	    _classCallCheck(this, DropdownMenu);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropdownMenu).call(this, props));
	    _this.rafInstance = null;
	    _this.lastVisible = false;
	
	    _this.scrollActiveItemToView = function () {
	      // scroll into view
	      var itemComponent = (0, _reactDom.findDOMNode)(_this.firstActiveItem);
	      var _this$props = _this.props,
	          visible = _this$props.visible,
	          firstActiveValue = _this$props.firstActiveValue;
	      var value = _this.props.value;
	
	      if (!itemComponent || !visible) {
	        return;
	      }
	
	      var scrollIntoViewOpts = {
	        onlyScrollIfNeeded: true
	      };
	
	      if ((!value || value.length === 0) && firstActiveValue) {
	        scrollIntoViewOpts.alignWithTop = true;
	      } // Delay to scroll since current frame item position is not ready when pre view is by filter
	      // https://github.com/ant-design/ant-design/issues/11268#issuecomment-406634462
	
	
	      _this.rafInstance = (0, _raf["default"])(function () {
	        (0, _domScrollIntoView["default"])(itemComponent, (0, _reactDom.findDOMNode)(_this.menuRef), scrollIntoViewOpts);
	      });
	    };
	
	    _this.renderMenu = function () {
	      var _this$props2 = _this.props,
	          menuItems = _this$props2.menuItems,
	          menuItemSelectedIcon = _this$props2.menuItemSelectedIcon,
	          defaultActiveFirstOption = _this$props2.defaultActiveFirstOption,
	          prefixCls = _this$props2.prefixCls,
	          multiple = _this$props2.multiple,
	          onMenuSelect = _this$props2.onMenuSelect,
	          inputValue = _this$props2.inputValue,
	          backfillValue = _this$props2.backfillValue,
	          onMenuDeselect = _this$props2.onMenuDeselect,
	          visible = _this$props2.visible;
	      var firstActiveValue = _this.props.firstActiveValue;
	
	      if (menuItems && menuItems.length) {
	        var menuProps = {};
	
	        if (multiple) {
	          menuProps.onDeselect = onMenuDeselect;
	          menuProps.onSelect = onMenuSelect;
	        } else {
	          menuProps.onClick = onMenuSelect;
	        }
	
	        var value = _this.props.value;
	        var selectedKeys = (0, _util.getSelectKeys)(menuItems, value);
	        var activeKeyProps = {};
	        var defaultActiveFirst = defaultActiveFirstOption;
	        var clonedMenuItems = menuItems;
	
	        if (selectedKeys.length || firstActiveValue) {
	          if (visible && !_this.lastVisible) {
	            activeKeyProps.activeKey = selectedKeys[0] || firstActiveValue;
	          } else if (!visible) {
	            // Do not trigger auto active since we already have selectedKeys
	            if (selectedKeys[0]) {
	              defaultActiveFirst = false;
	            }
	
	            activeKeyProps.activeKey = undefined;
	          }
	
	          var foundFirst = false; // set firstActiveItem via cloning menus
	          // for scroll into view
	
	          var clone = function clone(item) {
	            var key = item.key;
	
	            if (!foundFirst && selectedKeys.indexOf(key) !== -1 || !foundFirst && !selectedKeys.length && firstActiveValue.indexOf(item.key) !== -1) {
	              foundFirst = true;
	              return React.cloneElement(item, {
	                ref: function ref(_ref) {
	                  _this.firstActiveItem = _ref;
	                }
	              });
	            }
	
	            return item;
	          };
	
	          clonedMenuItems = menuItems.map(function (item) {
	            if (item.type.isMenuItemGroup) {
	              var children = (0, _toArray["default"])(item.props.children).map(clone);
	              return React.cloneElement(item, {}, children);
	            }
	
	            return clone(item);
	          });
	        } else {
	          // Clear firstActiveItem when dropdown menu items was empty
	          // Avoid `Unable to find node on an unmounted component`
	          // https://github.com/ant-design/ant-design/issues/10774
	          _this.firstActiveItem = null;
	        } // clear activeKey when inputValue change
	
	
	        var lastValue = value && value[value.length - 1];
	
	        if (inputValue !== _this.lastInputValue && (!lastValue || lastValue !== backfillValue)) {
	          activeKeyProps.activeKey = '';
	        }
	
	        return React.createElement(_rcMenu["default"], _extends({
	          ref: _this.saveMenuRef,
	          style: _this.props.dropdownMenuStyle,
	          defaultActiveFirst: defaultActiveFirst,
	          role: "listbox",
	          itemIcon: multiple ? menuItemSelectedIcon : null
	        }, activeKeyProps, {
	          multiple: multiple
	        }, menuProps, {
	          selectedKeys: selectedKeys,
	          prefixCls: "".concat(prefixCls, "-menu")
	        }), clonedMenuItems);
	      }
	
	      return null;
	    };
	
	    _this.lastInputValue = props.inputValue;
	    _this.saveMenuRef = (0, _util.saveRef)(_assertThisInitialized(_this), 'menuRef');
	    return _this;
	  }
	
	  _createClass(DropdownMenu, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.scrollActiveItemToView();
	      this.lastVisible = this.props.visible;
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps) {
	      if (!nextProps.visible) {
	        this.lastVisible = false;
	      } // freeze when hide
	
	
	      return this.props.visible && !nextProps.visible || nextProps.visible || nextProps.inputValue !== this.props.inputValue;
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var props = this.props;
	
	      if (!prevProps.visible && props.visible) {
	        this.scrollActiveItemToView();
	      }
	
	      this.lastVisible = props.visible;
	      this.lastInputValue = props.inputValue;
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.rafInstance) {
	        _raf["default"].cancel(this.rafInstance);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var renderMenu = this.renderMenu();
	      return renderMenu ? React.createElement("div", {
	        style: {
	          overflow: 'auto',
	          transform: 'translateZ(0)'
	        },
	        id: this.props.ariaId,
	        onFocus: this.props.onPopupFocus,
	        onMouseDown: _util.preventDefaultEvent,
	        onScroll: this.props.onPopupScroll
	      }, renderMenu) : null;
	    }
	  }]);
	
	  return DropdownMenu;
	}(React.Component);
	
	exports["default"] = DropdownMenu;
	DropdownMenu.displayName = 'DropdownMenu';
	DropdownMenu.propTypes = {
	  ariaId: PropTypes.string,
	  defaultActiveFirstOption: PropTypes.bool,
	  value: PropTypes.any,
	  dropdownMenuStyle: PropTypes.object,
	  multiple: PropTypes.bool,
	  onPopupFocus: PropTypes.func,
	  onPopupScroll: PropTypes.func,
	  onMenuDeSelect: PropTypes.func,
	  onMenuSelect: PropTypes.func,
	  prefixCls: PropTypes.string,
	  menuItems: PropTypes.any,
	  inputValue: PropTypes.string,
	  visible: PropTypes.bool,
	  firstActiveValue: PropTypes.string,
	  menuItemSelectedIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.node])
	};

/***/ },
/* 2724 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = __webpack_require__(1);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var OptGroup =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(OptGroup, _Component);
	
	  function OptGroup() {
	    _classCallCheck(this, OptGroup);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(OptGroup).apply(this, arguments));
	  }
	
	  return OptGroup;
	}(_react.Component);
	
	exports["default"] = OptGroup;
	OptGroup.isSelectOptGroup = true;

/***/ },
/* 2725 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classnames2 = _interopRequireDefault(__webpack_require__(20));
	
	var _componentClasses = _interopRequireDefault(__webpack_require__(444));
	
	var _rcAnimate = _interopRequireDefault(__webpack_require__(111));
	
	var _rcMenu = __webpack_require__(219);
	
	var _toArray = _interopRequireDefault(__webpack_require__(112));
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(71));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _warning = _interopRequireDefault(__webpack_require__(94));
	
	var _Option = _interopRequireDefault(__webpack_require__(1100));
	
	var _PropTypes = _interopRequireDefault(__webpack_require__(1101));
	
	var _SelectTrigger = _interopRequireDefault(__webpack_require__(2726));
	
	var _util = __webpack_require__(561);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	// Where el is the DOM element you'd like to test for visibility
	function isHidden(node) {
	  return !node || node.offsetParent === null;
	}
	
	var SELECT_EMPTY_VALUE_KEY = 'RC_SELECT_EMPTY_VALUE_KEY';
	
	var noop = function noop() {
	  return null;
	};
	
	function chaining() {
	  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
	    fns[_key] = arguments[_key];
	  }
	
	  return function () {
	    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    // tslint:disable-next-line:prefer-for-of
	    for (var i = 0; i < fns.length; i++) {
	      if (fns[i] && typeof fns[i] === 'function') {
	        fns[i].apply(chaining, args);
	      }
	    }
	  };
	}
	
	var Select =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  function Select(props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, props));
	    _this.inputRef = null;
	    _this.inputMirrorRef = null;
	    _this.topCtrlRef = null;
	    _this.selectTriggerRef = null;
	    _this.rootRef = null;
	    _this.selectionRef = null;
	    _this.dropdownContainer = null;
	    _this.blurTimer = null;
	    _this.focusTimer = null;
	    _this.comboboxTimer = null; // tslint:disable-next-line:variable-name
	
	    _this._focused = false; // tslint:disable-next-line:variable-name
	
	    _this._mouseDown = false; // tslint:disable-next-line:variable-name
	
	    _this._options = []; // tslint:disable-next-line:variable-name
	
	    _this._empty = false;
	
	    _this.onInputChange = function (event) {
	      var tokenSeparators = _this.props.tokenSeparators;
	      var val = event.target.value;
	
	      if ((0, _util.isMultipleOrTags)(_this.props) && tokenSeparators.length && (0, _util.includesSeparators)(val, tokenSeparators)) {
	        var nextValue = _this.getValueByInput(val);
	
	        if (nextValue !== undefined) {
	          _this.fireChange(nextValue);
	        }
	
	        _this.setOpenState(false, {
	          needFocus: true
	        });
	
	        _this.setInputValue('', false);
	
	        return;
	      }
	
	      _this.setInputValue(val);
	
	      _this.setState({
	        open: true
	      });
	
	      if ((0, _util.isCombobox)(_this.props)) {
	        _this.fireChange([val]);
	      }
	    };
	
	    _this.onDropdownVisibleChange = function (open) {
	      if (open && !_this._focused) {
	        _this.clearBlurTime();
	
	        _this.timeoutFocus();
	
	        _this._focused = true;
	
	        _this.updateFocusClassName();
	      }
	
	      _this.setOpenState(open);
	    }; // combobox ignore
	
	
	    _this.onKeyDown = function (event) {
	      var open = _this.state.open;
	      var disabled = _this.props.disabled;
	
	      if (disabled) {
	        return;
	      }
	
	      var keyCode = event.keyCode;
	
	      if (open && !_this.getInputDOMNode()) {
	        _this.onInputKeyDown(event);
	      } else if (keyCode === _KeyCode["default"].ENTER || keyCode === _KeyCode["default"].DOWN) {
	        if (!open) {
	          _this.setOpenState(true);
	        }
	
	        event.preventDefault();
	      } else if (keyCode === _KeyCode["default"].SPACE) {
	        // Not block space if popup is shown
	        if (!open) {
	          _this.setOpenState(true);
	
	          event.preventDefault();
	        }
	      }
	    };
	
	    _this.onInputKeyDown = function (event) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          combobox = _this$props.combobox,
	          defaultActiveFirstOption = _this$props.defaultActiveFirstOption;
	
	      if (disabled) {
	        return;
	      }
	
	      var state = _this.state;
	
	      var isRealOpen = _this.getRealOpenState(state); // magic code
	
	
	      var keyCode = event.keyCode;
	
	      if ((0, _util.isMultipleOrTags)(_this.props) && !event.target.value && keyCode === _KeyCode["default"].BACKSPACE) {
	        event.preventDefault();
	        var value = state.value;
	
	        if (value.length) {
	          _this.removeSelected(value[value.length - 1]);
	        }
	
	        return;
	      }
	
	      if (keyCode === _KeyCode["default"].DOWN) {
	        if (!state.open) {
	          _this.openIfHasChildren();
	
	          event.preventDefault();
	          event.stopPropagation();
	          return;
	        }
	      } else if (keyCode === _KeyCode["default"].ENTER && state.open) {
	        // Aviod trigger form submit when select item
	        // https://github.com/ant-design/ant-design/issues/10861
	        // https://github.com/ant-design/ant-design/issues/14544
	        if (isRealOpen || !combobox) {
	          event.preventDefault();
	        } // Hard close popup to avoid lock of non option in combobox mode
	
	
	        if (isRealOpen && combobox && defaultActiveFirstOption === false) {
	          _this.comboboxTimer = setTimeout(function () {
	            _this.setOpenState(false);
	          });
	        }
	      } else if (keyCode === _KeyCode["default"].ESC) {
	        if (state.open) {
	          _this.setOpenState(false);
	
	          event.preventDefault();
	          event.stopPropagation();
	        }
	
	        return;
	      }
	
	      if (isRealOpen && _this.selectTriggerRef) {
	        var menu = _this.selectTriggerRef.getInnerMenu();
	
	        if (menu && menu.onKeyDown(event, _this.handleBackfill)) {
	          event.preventDefault();
	          event.stopPropagation();
	        }
	      }
	    };
	
	    _this.onMenuSelect = function (_ref) {
	      var item = _ref.item;
	
	      if (!item) {
	        return;
	      }
	
	      var value = _this.state.value;
	      var props = _this.props;
	      var selectedValue = (0, _util.getValuePropValue)(item);
	      var lastValue = value[value.length - 1];
	      var skipTrigger = false;
	
	      if ((0, _util.isMultipleOrTags)(props)) {
	        if ((0, _util.findIndexInValueBySingleValue)(value, selectedValue) !== -1) {
	          skipTrigger = true;
	        } else {
	          value = value.concat([selectedValue]);
	        }
	      } else {
	        if (!(0, _util.isCombobox)(props) && lastValue !== undefined && lastValue === selectedValue && selectedValue !== _this.state.backfillValue) {
	          _this.setOpenState(false, {
	            needFocus: true,
	            fireSearch: false
	          });
	
	          skipTrigger = true;
	        } else {
	          value = [selectedValue];
	
	          _this.setOpenState(false, {
	            needFocus: true,
	            fireSearch: false
	          });
	        }
	      }
	
	      if (!skipTrigger) {
	        _this.fireChange(value);
	      }
	
	      _this.fireSelect(selectedValue);
	
	      if (!skipTrigger) {
	        var inputValue = (0, _util.isCombobox)(props) ? (0, _util.getPropValue)(item, props.optionLabelProp) : '';
	
	        if (props.autoClearSearchValue) {
	          _this.setInputValue(inputValue, false);
	        }
	      }
	    };
	
	    _this.onMenuDeselect = function (_ref2) {
	      var item = _ref2.item,
	          domEvent = _ref2.domEvent;
	
	      if (domEvent.type === 'keydown' && domEvent.keyCode === _KeyCode["default"].ENTER) {
	        var menuItemDomNode = ReactDOM.findDOMNode(item); // https://github.com/ant-design/ant-design/issues/20465#issuecomment-569033796
	
	        if (!isHidden(menuItemDomNode)) {
	          _this.removeSelected((0, _util.getValuePropValue)(item));
	        }
	
	        return;
	      }
	
	      if (domEvent.type === 'click') {
	        _this.removeSelected((0, _util.getValuePropValue)(item));
	      }
	
	      var props = _this.props;
	
	      if (props.autoClearSearchValue) {
	        _this.setInputValue('');
	      }
	    };
	
	    _this.onArrowClick = function (e) {
	      e.stopPropagation();
	      e.preventDefault();
	
	      if (!_this.props.disabled) {
	        _this.setOpenState(!_this.state.open, {
	          needFocus: !_this.state.open
	        });
	      }
	    };
	
	    _this.onPlaceholderClick = function () {
	      if (_this.getInputDOMNode && _this.getInputDOMNode()) {
	        _this.getInputDOMNode().focus();
	      }
	    };
	
	    _this.onOuterFocus = function (e) {
	      if (_this.props.disabled) {
	        e.preventDefault();
	        return;
	      }
	
	      _this.clearBlurTime(); // In IE11, onOuterFocus will be trigger twice when focus input
	      // First one: e.target is div
	      // Second one: e.target is input
	      // other browser only trigger second one
	      // https://github.com/ant-design/ant-design/issues/15942
	      // Here we ignore the first one when e.target is div
	
	
	      var inputNode = _this.getInputDOMNode();
	
	      if (inputNode && e.target === _this.rootRef) {
	        return;
	      }
	
	      if (!(0, _util.isMultipleOrTagsOrCombobox)(_this.props) && e.target === inputNode) {
	        return;
	      }
	
	      if (_this._focused) {
	        return;
	      }
	
	      _this._focused = true;
	
	      _this.updateFocusClassName(); // only effect multiple or tag mode
	
	
	      if (!(0, _util.isMultipleOrTags)(_this.props) || !_this._mouseDown) {
	        _this.timeoutFocus();
	      }
	    };
	
	    _this.onPopupFocus = function () {
	      // fix ie scrollbar, focus element again
	      _this.maybeFocus(true, true);
	    };
	
	    _this.onOuterBlur = function (e) {
	      if (_this.props.disabled) {
	        e.preventDefault();
	        return;
	      }
	
	      _this.blurTimer = window.setTimeout(function () {
	        _this._focused = false;
	
	        _this.updateFocusClassName();
	
	        var props = _this.props;
	        var value = _this.state.value;
	        var inputValue = _this.state.inputValue;
	
	        if ((0, _util.isSingleMode)(props) && props.showSearch && inputValue && props.defaultActiveFirstOption) {
	          var options = _this._options || [];
	
	          if (options.length) {
	            var firstOption = (0, _util.findFirstMenuItem)(options);
	
	            if (firstOption) {
	              value = [(0, _util.getValuePropValue)(firstOption)];
	
	              _this.fireChange(value);
	            }
	          }
	        } else if ((0, _util.isMultipleOrTags)(props) && inputValue) {
	          if (_this._mouseDown) {
	            // need update dropmenu when not blur
	            _this.setInputValue('');
	          } else {
	            // why not use setState?
	            // https://github.com/ant-design/ant-design/issues/14262
	            _this.state.inputValue = '';
	
	            if (_this.getInputDOMNode && _this.getInputDOMNode()) {
	              _this.getInputDOMNode().value = '';
	            }
	          }
	
	          var tmpValue = _this.getValueByInput(inputValue);
	
	          if (tmpValue !== undefined) {
	            value = tmpValue;
	
	            _this.fireChange(value);
	          }
	        } // if click the rest space of Select in multiple mode
	
	
	        if ((0, _util.isMultipleOrTags)(props) && _this._mouseDown) {
	          _this.maybeFocus(true, true);
	
	          _this._mouseDown = false;
	          return;
	        }
	
	        _this.setOpenState(false);
	
	        if (props.onBlur) {
	          props.onBlur(_this.getVLForOnChange(value));
	        }
	      }, 10);
	    };
	
	    _this.onClearSelection = function (event) {
	      var props = _this.props;
	      var state = _this.state;
	
	      if (props.disabled) {
	        return;
	      }
	
	      var inputValue = state.inputValue;
	      var value = state.value;
	      event.stopPropagation();
	
	      if (inputValue || value.length) {
	        if (value.length) {
	          _this.fireChange([]);
	        }
	
	        _this.setOpenState(false, {
	          needFocus: true
	        });
	
	        if (inputValue) {
	          _this.setInputValue('');
	        }
	      }
	    };
	
	    _this.onChoiceAnimationLeave = function () {
	      _this.forcePopupAlign();
	    };
	
	    _this.getOptionInfoBySingleValue = function (value, optionsInfo) {
	      var info;
	      optionsInfo = optionsInfo || _this.state.optionsInfo;
	
	      if (optionsInfo[(0, _util.getMapKey)(value)]) {
	        info = optionsInfo[(0, _util.getMapKey)(value)];
	      }
	
	      if (info) {
	        return info;
	      }
	
	      var defaultLabel = value;
	
	      if (_this.props.labelInValue) {
	        var valueLabel = (0, _util.getLabelFromPropsValue)(_this.props.value, value);
	        var defaultValueLabel = (0, _util.getLabelFromPropsValue)(_this.props.defaultValue, value);
	
	        if (valueLabel !== undefined) {
	          defaultLabel = valueLabel;
	        } else if (defaultValueLabel !== undefined) {
	          defaultLabel = defaultValueLabel;
	        }
	      }
	
	      var defaultInfo = {
	        option: React.createElement(_Option["default"], {
	          value: value,
	          key: value
	        }, value),
	        value: value,
	        label: defaultLabel
	      };
	      return defaultInfo;
	    };
	
	    _this.getOptionBySingleValue = function (value) {
	      var _this$getOptionInfoBy = _this.getOptionInfoBySingleValue(value),
	          option = _this$getOptionInfoBy.option;
	
	      return option;
	    };
	
	    _this.getOptionsBySingleValue = function (values) {
	      return values.map(function (value) {
	        return _this.getOptionBySingleValue(value);
	      });
	    };
	
	    _this.getValueByLabel = function (label) {
	      if (label === undefined) {
	        return null;
	      }
	
	      var value = null;
	      Object.keys(_this.state.optionsInfo).forEach(function (key) {
	        var info = _this.state.optionsInfo[key];
	        var disabled = info.disabled;
	
	        if (disabled) {
	          return;
	        }
	
	        var oldLable = (0, _util.toArray)(info.label);
	
	        if (oldLable && oldLable.join('') === label) {
	          value = info.value;
	        }
	      });
	      return value;
	    };
	
	    _this.getVLBySingleValue = function (value) {
	      if (_this.props.labelInValue) {
	        return {
	          key: value,
	          label: _this.getLabelBySingleValue(value)
	        };
	      }
	
	      return value;
	    };
	
	    _this.getVLForOnChange = function (vlsS) {
	      var vls = vlsS;
	
	      if (vls !== undefined) {
	        if (!_this.props.labelInValue) {
	          vls = vls.map(function (v) {
	            return v;
	          });
	        } else {
	          vls = vls.map(function (vl) {
	            return {
	              key: vl,
	              label: _this.getLabelBySingleValue(vl)
	            };
	          });
	        }
	
	        return (0, _util.isMultipleOrTags)(_this.props) ? vls : vls[0];
	      }
	
	      return vls;
	    };
	
	    _this.getLabelBySingleValue = function (value, optionsInfo) {
	      var _this$getOptionInfoBy2 = _this.getOptionInfoBySingleValue(value, optionsInfo),
	          label = _this$getOptionInfoBy2.label;
	
	      return label;
	    };
	
	    _this.getDropdownContainer = function () {
	      if (!_this.dropdownContainer) {
	        _this.dropdownContainer = document.createElement('div');
	        document.body.appendChild(_this.dropdownContainer);
	      }
	
	      return _this.dropdownContainer;
	    };
	
	    _this.getPlaceholderElement = function () {
	      var props = _this.props;
	      var state = _this.state;
	      var hidden = false;
	
	      if (state.inputValue) {
	        hidden = true;
	      }
	
	      var value = state.value;
	
	      if (value.length) {
	        hidden = true;
	      }
	
	      if ((0, _util.isCombobox)(props) && value.length === 1 && state.value && !state.value[0]) {
	        hidden = false;
	      }
	
	      var placeholder = props.placeholder;
	
	      if (placeholder) {
	        return React.createElement("div", _extends({
	          onMouseDown: _util.preventDefaultEvent,
	          style: _extends({
	            display: hidden ? 'none' : 'block'
	          }, _util.UNSELECTABLE_STYLE)
	        }, _util.UNSELECTABLE_ATTRIBUTE, {
	          onClick: _this.onPlaceholderClick,
	          className: "".concat(props.prefixCls, "-selection__placeholder")
	        }), placeholder);
	      }
	
	      return null;
	    };
	
	    _this.getInputElement = function () {
	      var props = _this.props;
	      var defaultInput = React.createElement("input", {
	        id: props.id,
	        autoComplete: "off"
	      }); // tslint:disable-next-line:typedef-whitespace
	
	      var inputElement = props.getInputElement ? props.getInputElement() : defaultInput;
	      var inputCls = (0, _classnames2["default"])(inputElement.props.className, _defineProperty({}, "".concat(props.prefixCls, "-search__field"), true)); // https://github.com/ant-design/ant-design/issues/4992#issuecomment-281542159
	      // Add space to the end of the inputValue as the width measurement tolerance
	
	      return React.createElement("div", {
	        className: "".concat(props.prefixCls, "-search__field__wrap")
	      }, React.cloneElement(inputElement, {
	        ref: _this.saveInputRef,
	        onChange: _this.onInputChange,
	        onKeyDown: chaining(_this.onInputKeyDown, inputElement.props.onKeyDown, _this.props.onInputKeyDown),
	        value: _this.state.inputValue,
	        disabled: props.disabled,
	        className: inputCls
	      }), React.createElement("span", {
	        ref: _this.saveInputMirrorRef,
	        className: "".concat(props.prefixCls, "-search__field__mirror")
	      }, _this.state.inputValue, "\xA0"));
	    };
	
	    _this.getInputDOMNode = function () {
	      return _this.topCtrlRef ? _this.topCtrlRef.querySelector('input,textarea,div[contentEditable]') : _this.inputRef;
	    };
	
	    _this.getInputMirrorDOMNode = function () {
	      return _this.inputMirrorRef;
	    };
	
	    _this.getPopupDOMNode = function () {
	      if (_this.selectTriggerRef) {
	        return _this.selectTriggerRef.getPopupDOMNode();
	      }
	    };
	
	    _this.getPopupMenuComponent = function () {
	      if (_this.selectTriggerRef) {
	        return _this.selectTriggerRef.getInnerMenu();
	      }
	    };
	
	    _this.setOpenState = function (open) {
	      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var needFocus = config.needFocus,
	          fireSearch = config.fireSearch;
	      var props = _this.props;
	      var state = _this.state;
	
	      if (state.open === open) {
	        _this.maybeFocus(open, !!needFocus);
	
	        return;
	      }
	
	      if (_this.props.onDropdownVisibleChange) {
	        _this.props.onDropdownVisibleChange(open);
	      }
	
	      var nextState = {
	        open: open,
	        backfillValue: ''
	      }; // clear search input value when open is false in singleMode.
	      // https://github.com/ant-design/ant-design/issues/16572
	
	      if (!open && (0, _util.isSingleMode)(props) && props.showSearch) {
	        _this.setInputValue('', fireSearch);
	      }
	
	      if (!open) {
	        _this.maybeFocus(open, !!needFocus);
	      }
	
	      _this.setState(_extends({
	        open: open
	      }, nextState), function () {
	        if (open) {
	          _this.maybeFocus(open, !!needFocus);
	        }
	      });
	    };
	
	    _this.setInputValue = function (inputValue) {
	      var fireSearch = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	      var onSearch = _this.props.onSearch;
	
	      if (inputValue !== _this.state.inputValue) {
	        _this.setState(function (prevState) {
	          // Additional check if `inputValue` changed in latest state.
	          if (fireSearch && inputValue !== prevState.inputValue && onSearch) {
	            onSearch(inputValue);
	          }
	
	          return {
	            inputValue: inputValue
	          };
	        }, _this.forcePopupAlign);
	      }
	    };
	
	    _this.getValueByInput = function (str) {
	      var _this$props2 = _this.props,
	          multiple = _this$props2.multiple,
	          tokenSeparators = _this$props2.tokenSeparators;
	      var nextValue = _this.state.value;
	      var hasNewValue = false;
	      (0, _util.splitBySeparators)(str, tokenSeparators).forEach(function (label) {
	        var selectedValue = [label];
	
	        if (multiple) {
	          var value = _this.getValueByLabel(label);
	
	          if (value && (0, _util.findIndexInValueBySingleValue)(nextValue, value) === -1) {
	            nextValue = nextValue.concat(value);
	            hasNewValue = true;
	
	            _this.fireSelect(value);
	          }
	        } else if ((0, _util.findIndexInValueBySingleValue)(nextValue, label) === -1) {
	          nextValue = nextValue.concat(selectedValue);
	          hasNewValue = true;
	
	          _this.fireSelect(label);
	        }
	      });
	      return hasNewValue ? nextValue : undefined;
	    };
	
	    _this.getRealOpenState = function (state) {
	      // tslint:disable-next-line:variable-name
	      var _open = _this.props.open;
	
	      if (typeof _open === 'boolean') {
	        return _open;
	      }
	
	      var open = (state || _this.state).open;
	      var options = _this._options || [];
	
	      if ((0, _util.isMultipleOrTagsOrCombobox)(_this.props) || !_this.props.showSearch) {
	        if (open && !options.length) {
	          open = false;
	        }
	      }
	
	      return open;
	    };
	
	    _this.markMouseDown = function () {
	      _this._mouseDown = true;
	    };
	
	    _this.markMouseLeave = function () {
	      _this._mouseDown = false;
	    };
	
	    _this.handleBackfill = function (item) {
	      if (!_this.props.backfill || !((0, _util.isSingleMode)(_this.props) || (0, _util.isCombobox)(_this.props))) {
	        return;
	      }
	
	      var key = (0, _util.getValuePropValue)(item);
	
	      if ((0, _util.isCombobox)(_this.props)) {
	        _this.setInputValue(key, false);
	      }
	
	      _this.setState({
	        value: [key],
	        backfillValue: key
	      });
	    };
	
	    _this.filterOption = function (input, child) {
	      var defaultFilter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _util.defaultFilterFn;
	      var value = _this.state.value;
	      var lastValue = value[value.length - 1];
	
	      if (!input || lastValue && lastValue === _this.state.backfillValue) {
	        return true;
	      }
	
	      var filterFn = _this.props.filterOption;
	
	      if ('filterOption' in _this.props) {
	        if (filterFn === true) {
	          filterFn = defaultFilter.bind(_assertThisInitialized(_this));
	        }
	      } else {
	        filterFn = defaultFilter.bind(_assertThisInitialized(_this));
	      }
	
	      if (!filterFn) {
	        return true;
	      } else if (typeof filterFn === 'function') {
	        return filterFn.call(_assertThisInitialized(_this), input, child);
	      } else if (child.props.disabled) {
	        return false;
	      }
	
	      return true;
	    };
	
	    _this.timeoutFocus = function () {
	      var onFocus = _this.props.onFocus;
	
	      if (_this.focusTimer) {
	        _this.clearFocusTime();
	      }
	
	      _this.focusTimer = window.setTimeout(function () {
	        if (onFocus) {
	          onFocus();
	        }
	      }, 10);
	    };
	
	    _this.clearFocusTime = function () {
	      if (_this.focusTimer) {
	        clearTimeout(_this.focusTimer);
	        _this.focusTimer = null;
	      }
	    };
	
	    _this.clearBlurTime = function () {
	      if (_this.blurTimer) {
	        clearTimeout(_this.blurTimer);
	        _this.blurTimer = null;
	      }
	    };
	
	    _this.clearComboboxTime = function () {
	      if (_this.comboboxTimer) {
	        clearTimeout(_this.comboboxTimer);
	        _this.comboboxTimer = null;
	      }
	    };
	
	    _this.updateFocusClassName = function () {
	      var rootRef = _this.rootRef;
	      var props = _this.props; // avoid setState and its side effect
	
	      if (_this._focused) {
	        (0, _componentClasses["default"])(rootRef).add("".concat(props.prefixCls, "-focused"));
	      } else {
	        (0, _componentClasses["default"])(rootRef).remove("".concat(props.prefixCls, "-focused"));
	      }
	    };
	
	    _this.maybeFocus = function (open, needFocus) {
	      if (needFocus || open) {
	        var input = _this.getInputDOMNode();
	
	        var _document = document,
	            activeElement = _document.activeElement;
	
	        if (input && (open || (0, _util.isMultipleOrTagsOrCombobox)(_this.props))) {
	          if (activeElement !== input) {
	            input.focus();
	            _this._focused = true;
	          }
	        } else if (activeElement !== _this.selectionRef && _this.selectionRef) {
	          _this.selectionRef.focus();
	
	          _this._focused = true;
	        }
	      }
	    };
	
	    _this.removeSelected = function (selectedKey, e) {
	      var props = _this.props;
	
	      if (props.disabled || _this.isChildDisabled(selectedKey)) {
	        return;
	      } // Do not trigger Trigger popup
	
	
	      if (e && e.stopPropagation) {
	        e.stopPropagation();
	      }
	
	      var oldValue = _this.state.value;
	      var value = oldValue.filter(function (singleValue) {
	        return singleValue !== selectedKey;
	      });
	      var canMultiple = (0, _util.isMultipleOrTags)(props);
	
	      if (canMultiple) {
	        var event = selectedKey;
	
	        if (props.labelInValue) {
	          event = {
	            key: selectedKey,
	            label: _this.getLabelBySingleValue(selectedKey)
	          };
	        }
	
	        if (props.onDeselect) {
	          props.onDeselect(event, _this.getOptionBySingleValue(selectedKey));
	        }
	      }
	
	      _this.fireChange(value);
	    };
	
	    _this.openIfHasChildren = function () {
	      var props = _this.props;
	
	      if (React.Children.count(props.children) || (0, _util.isSingleMode)(props)) {
	        _this.setOpenState(true);
	      }
	    };
	
	    _this.fireSelect = function (value) {
	      if (_this.props.onSelect) {
	        _this.props.onSelect(_this.getVLBySingleValue(value), _this.getOptionBySingleValue(value));
	      }
	    };
	
	    _this.fireChange = function (value) {
	      var props = _this.props;
	
	      if (!('value' in props)) {
	        _this.setState({
	          value: value
	        }, _this.forcePopupAlign);
	      }
	
	      var vls = _this.getVLForOnChange(value);
	
	      var options = _this.getOptionsBySingleValue(value);
	
	      if (props.onChange) {
	        props.onChange(vls, (0, _util.isMultipleOrTags)(_this.props) ? options : options[0]);
	      }
	    };
	
	    _this.isChildDisabled = function (key) {
	      return (0, _toArray["default"])(_this.props.children).some(function (child) {
	        var childValue = (0, _util.getValuePropValue)(child);
	        return childValue === key && child.props && child.props.disabled;
	      });
	    };
	
	    _this.forcePopupAlign = function () {
	      if (!_this.state.open) {
	        return;
	      }
	
	      if (_this.selectTriggerRef && _this.selectTriggerRef.triggerRef) {
	        _this.selectTriggerRef.triggerRef.forcePopupAlign();
	      }
	    };
	
	    _this.renderFilterOptions = function () {
	      var inputValue = _this.state.inputValue;
	      var _this$props3 = _this.props,
	          children = _this$props3.children,
	          tags = _this$props3.tags,
	          notFoundContent = _this$props3.notFoundContent;
	      var menuItems = [];
	      var childrenKeys = [];
	      var empty = false;
	
	      var options = _this.renderFilterOptionsFromChildren(children, childrenKeys, menuItems);
	
	      if (tags) {
	        // tags value must be string
	        var value = _this.state.value;
	        value = value.filter(function (singleValue) {
	          return childrenKeys.indexOf(singleValue) === -1 && (!inputValue || String(singleValue).indexOf(String(inputValue)) > -1);
	        }); // sort by length
	
	        value.sort(function (val1, val2) {
	          return val1.length - val2.length;
	        });
	        value.forEach(function (singleValue) {
	          var key = singleValue;
	          var menuItem = React.createElement(_rcMenu.Item, {
	            style: _util.UNSELECTABLE_STYLE,
	            role: "option",
	            attribute: _util.UNSELECTABLE_ATTRIBUTE,
	            value: key,
	            key: key
	          }, key);
	          options.push(menuItem);
	          menuItems.push(menuItem);
	        }); // ref: https://github.com/ant-design/ant-design/issues/14090
	
	        if (inputValue && menuItems.every(function (option) {
	          return (0, _util.getValuePropValue)(option) !== inputValue;
	        })) {
	          options.unshift(React.createElement(_rcMenu.Item, {
	            style: _util.UNSELECTABLE_STYLE,
	            role: "option",
	            attribute: _util.UNSELECTABLE_ATTRIBUTE,
	            value: inputValue,
	            key: inputValue
	          }, inputValue));
	        }
	      }
	
	      if (!options.length && notFoundContent) {
	        empty = true;
	        options = [React.createElement(_rcMenu.Item, {
	          style: _util.UNSELECTABLE_STYLE,
	          attribute: _util.UNSELECTABLE_ATTRIBUTE,
	          disabled: true,
	          role: "option",
	          value: "NOT_FOUND",
	          key: "NOT_FOUND"
	        }, notFoundContent)];
	      }
	
	      return {
	        empty: empty,
	        options: options
	      };
	    };
	
	    _this.renderFilterOptionsFromChildren = function (children, childrenKeys, menuItems) {
	      var sel = [];
	      var props = _this.props;
	      var inputValue = _this.state.inputValue;
	      var tags = props.tags;
	      React.Children.forEach(children, function (child) {
	        if (!child) {
	          return;
	        }
	
	        var type = child.type;
	
	        if (type.isSelectOptGroup) {
	          var label = child.props.label;
	          var key = child.key;
	
	          if (!key && typeof label === 'string') {
	            key = label;
	          } else if (!label && key) {
	            label = key;
	          } // Match option group label
	
	
	          if (inputValue && _this.filterOption(inputValue, child)) {
	            var innerItems = (0, _toArray["default"])(child.props.children).map(function (subChild) {
	              var childValueSub = (0, _util.getValuePropValue)(subChild) || subChild.key;
	              return React.createElement(_rcMenu.Item, _extends({
	                key: childValueSub,
	                value: childValueSub
	              }, subChild.props));
	            });
	            sel.push(React.createElement(_rcMenu.ItemGroup, {
	              key: key,
	              title: label
	            }, innerItems)); // Not match
	          } else {
	            var _innerItems = _this.renderFilterOptionsFromChildren(child.props.children, childrenKeys, menuItems);
	
	            if (_innerItems.length) {
	              sel.push(React.createElement(_rcMenu.ItemGroup, {
	                key: key,
	                title: label
	              }, _innerItems));
	            }
	          }
	
	          return;
	        }
	
	        (0, _warning["default"])(type.isSelectOption, 'the children of `Select` should be `Select.Option` or `Select.OptGroup`, ' + "instead of `".concat(type.name || type.displayName || child.type, "`."));
	        var childValue = (0, _util.getValuePropValue)(child);
	        (0, _util.validateOptionValue)(childValue, _this.props);
	
	        if (_this.filterOption(inputValue, child)) {
	          var menuItem = React.createElement(_rcMenu.Item, _extends({
	            style: _util.UNSELECTABLE_STYLE,
	            attribute: _util.UNSELECTABLE_ATTRIBUTE,
	            value: childValue,
	            key: childValue,
	            role: "option"
	          }, child.props));
	          sel.push(menuItem);
	          menuItems.push(menuItem);
	        }
	
	        if (tags) {
	          childrenKeys.push(childValue);
	        }
	      });
	      return sel;
	    };
	
	    _this.renderTopControlNode = function () {
	      var _this$state = _this.state,
	          open = _this$state.open,
	          inputValue = _this$state.inputValue;
	      var value = _this.state.value;
	      var props = _this.props;
	      var choiceTransitionName = props.choiceTransitionName,
	          prefixCls = props.prefixCls,
	          maxTagTextLength = props.maxTagTextLength,
	          maxTagCount = props.maxTagCount,
	          showSearch = props.showSearch,
	          removeIcon = props.removeIcon;
	      var maxTagPlaceholder = props.maxTagPlaceholder;
	      var className = "".concat(prefixCls, "-selection__rendered"); // search input is inside topControlNode in single, multiple & combobox. 2016/04/13
	
	      var innerNode = null;
	
	      if ((0, _util.isSingleMode)(props)) {
	        var selectedValue = null;
	
	        if (value.length) {
	          var showSelectedValue = false;
	          var opacity = 1;
	
	          if (!showSearch) {
	            showSelectedValue = true;
	          } else if (open) {
	            showSelectedValue = !inputValue;
	
	            if (showSelectedValue) {
	              opacity = 0.4;
	            }
	          } else {
	            showSelectedValue = true;
	          }
	
	          var singleValue = value[0];
	
	          var _this$getOptionInfoBy3 = _this.getOptionInfoBySingleValue(singleValue),
	              label = _this$getOptionInfoBy3.label,
	              title = _this$getOptionInfoBy3.title;
	
	          selectedValue = React.createElement("div", {
	            key: "value",
	            className: "".concat(prefixCls, "-selection-selected-value"),
	            title: (0, _util.toTitle)(title || label),
	            style: {
	              display: showSelectedValue ? 'block' : 'none',
	              opacity: opacity
	            }
	          }, label);
	        }
	
	        if (!showSearch) {
	          innerNode = [selectedValue];
	        } else {
	          innerNode = [selectedValue, React.createElement("div", {
	            className: "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline"),
	            key: "input",
	            style: {
	              display: open ? 'block' : 'none'
	            }
	          }, _this.getInputElement())];
	        }
	      } else {
	        var selectedValueNodes = [];
	        var limitedCountValue = value;
	        var maxTagPlaceholderEl;
	
	        if (maxTagCount !== undefined && value.length > maxTagCount) {
	          limitedCountValue = limitedCountValue.slice(0, maxTagCount);
	
	          var omittedValues = _this.getVLForOnChange(value.slice(maxTagCount, value.length));
	
	          var content = "+ ".concat(value.length - maxTagCount, " ...");
	
	          if (maxTagPlaceholder) {
	            content = typeof maxTagPlaceholder === 'function' ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
	          }
	
	          maxTagPlaceholderEl = React.createElement("li", _extends({
	            style: _util.UNSELECTABLE_STYLE
	          }, _util.UNSELECTABLE_ATTRIBUTE, {
	            role: "presentation",
	            onMouseDown: _util.preventDefaultEvent,
	            className: "".concat(prefixCls, "-selection__choice ").concat(prefixCls, "-selection__choice__disabled"),
	            key: "maxTagPlaceholder",
	            title: (0, _util.toTitle)(content)
	          }), React.createElement("div", {
	            className: "".concat(prefixCls, "-selection__choice__content")
	          }, content));
	        }
	
	        if ((0, _util.isMultipleOrTags)(props)) {
	          selectedValueNodes = limitedCountValue.map(function (singleValue) {
	            var info = _this.getOptionInfoBySingleValue(singleValue);
	
	            var content = info.label;
	            var title = info.title || content;
	
	            if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
	              content = "".concat(content.slice(0, maxTagTextLength), "...");
	            }
	
	            var disabled = _this.isChildDisabled(singleValue);
	
	            var choiceClassName = disabled ? "".concat(prefixCls, "-selection__choice ").concat(prefixCls, "-selection__choice__disabled") : "".concat(prefixCls, "-selection__choice");
	            return React.createElement("li", _extends({
	              style: _util.UNSELECTABLE_STYLE
	            }, _util.UNSELECTABLE_ATTRIBUTE, {
	              onMouseDown: _util.preventDefaultEvent,
	              className: choiceClassName,
	              role: "presentation",
	              key: singleValue || SELECT_EMPTY_VALUE_KEY,
	              title: (0, _util.toTitle)(title)
	            }), React.createElement("div", {
	              className: "".concat(prefixCls, "-selection__choice__content")
	            }, content), disabled ? null : React.createElement("span", {
	              onClick: function onClick(event) {
	                _this.removeSelected(singleValue, event);
	              },
	              className: "".concat(prefixCls, "-selection__choice__remove")
	            }, removeIcon || React.createElement("i", {
	              className: "".concat(prefixCls, "-selection__choice__remove-icon")
	            }, "\xD7")));
	          });
	        }
	
	        if (maxTagPlaceholderEl) {
	          selectedValueNodes.push(maxTagPlaceholderEl);
	        }
	
	        selectedValueNodes.push(React.createElement("li", {
	          className: "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline"),
	          key: "__input"
	        }, _this.getInputElement()));
	
	        if ((0, _util.isMultipleOrTags)(props) && choiceTransitionName) {
	          innerNode = React.createElement(_rcAnimate["default"], {
	            onLeave: _this.onChoiceAnimationLeave,
	            component: "ul",
	            transitionName: choiceTransitionName
	          }, selectedValueNodes);
	        } else {
	          innerNode = React.createElement("ul", null, selectedValueNodes);
	        }
	      }
	
	      return React.createElement("div", {
	        className: className,
	        ref: _this.saveTopCtrlRef
	      }, _this.getPlaceholderElement(), innerNode);
	    };
	
	    var optionsInfo = Select.getOptionsInfoFromProps(props);
	
	    if (props.tags && typeof props.filterOption !== 'function') {
	      var isDisabledExist = Object.keys(optionsInfo).some(function (key) {
	        return optionsInfo[key].disabled;
	      });
	      (0, _warning["default"])(!isDisabledExist, 'Please avoid setting option to disabled in tags mode since user can always type text as tag.');
	    }
	
	    _this.state = {
	      value: Select.getValueFromProps(props, true),
	      inputValue: props.combobox ? Select.getInputValueForCombobox(props, optionsInfo, true) : '',
	      open: props.defaultOpen,
	      optionsInfo: optionsInfo,
	      backfillValue: '',
	      // a flag for aviod redundant getOptionsInfoFromProps call
	      skipBuildOptionsInfo: true,
	      ariaId: ''
	    };
	    _this.saveInputRef = (0, _util.saveRef)(_assertThisInitialized(_this), 'inputRef');
	    _this.saveInputMirrorRef = (0, _util.saveRef)(_assertThisInitialized(_this), 'inputMirrorRef');
	    _this.saveTopCtrlRef = (0, _util.saveRef)(_assertThisInitialized(_this), 'topCtrlRef');
	    _this.saveSelectTriggerRef = (0, _util.saveRef)(_assertThisInitialized(_this), 'selectTriggerRef');
	    _this.saveRootRef = (0, _util.saveRef)(_assertThisInitialized(_this), 'rootRef');
	    _this.saveSelectionRef = (0, _util.saveRef)(_assertThisInitialized(_this), 'selectionRef');
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // when defaultOpen is true, we should auto focus search input
	      // https://github.com/ant-design/ant-design/issues/14254
	      if (this.props.autoFocus || this.state.open) {
	        this.focus();
	      }
	
	      this.setState({
	        ariaId: (0, _util.generateUUID)()
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      if ((0, _util.isMultipleOrTags)(this.props)) {
	        var inputNode = this.getInputDOMNode();
	        var mirrorNode = this.getInputMirrorDOMNode();
	
	        if (inputNode && inputNode.value && mirrorNode) {
	          inputNode.style.width = '';
	          inputNode.style.width = "".concat(mirrorNode.clientWidth, "px");
	        } else if (inputNode) {
	          inputNode.style.width = '';
	        }
	      }
	
	      this.forcePopupAlign();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.clearFocusTime();
	      this.clearBlurTime();
	      this.clearComboboxTime();
	
	      if (this.dropdownContainer) {
	        ReactDOM.unmountComponentAtNode(this.dropdownContainer);
	        document.body.removeChild(this.dropdownContainer);
	        this.dropdownContainer = null;
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      if ((0, _util.isSingleMode)(this.props) && this.selectionRef) {
	        this.selectionRef.focus();
	      } else if (this.getInputDOMNode()) {
	        this.getInputDOMNode().focus();
	      }
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      if ((0, _util.isSingleMode)(this.props) && this.selectionRef) {
	        this.selectionRef.blur();
	      } else if (this.getInputDOMNode()) {
	        this.getInputDOMNode().blur();
	      }
	    }
	  }, {
	    key: "renderArrow",
	    value: function renderArrow(multiple) {
	      // showArrow : Set to true if not multiple by default but keep set value.
	      var _this$props4 = this.props,
	          _this$props4$showArro = _this$props4.showArrow,
	          showArrow = _this$props4$showArro === void 0 ? !multiple : _this$props4$showArro,
	          loading = _this$props4.loading,
	          inputIcon = _this$props4.inputIcon,
	          prefixCls = _this$props4.prefixCls;
	
	      if (!showArrow && !loading) {
	        return null;
	      } // if loading  have loading icon
	
	
	      var defaultIcon = loading ? React.createElement("i", {
	        className: "".concat(prefixCls, "-arrow-loading")
	      }) : React.createElement("i", {
	        className: "".concat(prefixCls, "-arrow-icon")
	      });
	      return React.createElement("span", _extends({
	        key: "arrow",
	        className: "".concat(prefixCls, "-arrow"),
	        style: _util.UNSELECTABLE_STYLE
	      }, _util.UNSELECTABLE_ATTRIBUTE, {
	        onClick: this.onArrowClick
	      }), inputIcon || defaultIcon);
	    }
	  }, {
	    key: "renderClear",
	    value: function renderClear() {
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          allowClear = _this$props5.allowClear,
	          clearIcon = _this$props5.clearIcon;
	      var inputValue = this.state.inputValue;
	      var value = this.state.value;
	      var clear = React.createElement("span", _extends({
	        key: "clear",
	        className: "".concat(prefixCls, "-selection__clear"),
	        onMouseDown: _util.preventDefaultEvent,
	        style: _util.UNSELECTABLE_STYLE
	      }, _util.UNSELECTABLE_ATTRIBUTE, {
	        onClick: this.onClearSelection
	      }), clearIcon || React.createElement("i", {
	        className: "".concat(prefixCls, "-selection__clear-icon")
	      }, "\xD7"));
	
	      if (!allowClear) {
	        return null;
	      }
	
	      if ((0, _util.isCombobox)(this.props)) {
	        if (inputValue) {
	          return clear;
	        }
	
	        return null;
	      }
	
	      if (inputValue || value.length) {
	        return clear;
	      }
	
	      return null;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _rootCls;
	
	      var props = this.props;
	      var multiple = (0, _util.isMultipleOrTags)(props); // Default set showArrow to true if not set (not set directly in defaultProps to handle multiple case)
	
	      var _props$showArrow = props.showArrow,
	          showArrow = _props$showArrow === void 0 ? true : _props$showArrow;
	      var state = this.state;
	      var className = props.className,
	          disabled = props.disabled,
	          prefixCls = props.prefixCls,
	          loading = props.loading;
	      var ctrlNode = this.renderTopControlNode();
	      var _this$state2 = this.state,
	          open = _this$state2.open,
	          ariaId = _this$state2.ariaId;
	
	      if (open) {
	        var filterOptions = this.renderFilterOptions();
	        this._empty = filterOptions.empty;
	        this._options = filterOptions.options;
	      }
	
	      var realOpen = this.getRealOpenState();
	      var empty = this._empty;
	      var options = this._options || [];
	      var dataOrAriaAttributeProps = {};
	      Object.keys(props).forEach(function (key) {
	        if (Object.prototype.hasOwnProperty.call(props, key) && (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')) {
	          dataOrAriaAttributeProps[key] = props[key];
	        }
	      }); // for (const key in props) {
	      //   if (
	      //     Object.prototype.hasOwnProperty.call(props, key) &&
	      //     (key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role')
	      //   ) {
	      //     dataOrAriaAttributeProps[key] = props[key];
	      //   }
	      // }
	
	      var extraSelectionProps = _extends({}, dataOrAriaAttributeProps);
	
	      if (!(0, _util.isMultipleOrTagsOrCombobox)(props)) {
	        extraSelectionProps = _extends(_extends({}, extraSelectionProps), {
	          onKeyDown: this.onKeyDown,
	          tabIndex: props.disabled ? -1 : props.tabIndex
	        });
	      }
	
	      var rootCls = (_rootCls = {}, _defineProperty(_rootCls, className, !!className), _defineProperty(_rootCls, prefixCls, 1), _defineProperty(_rootCls, "".concat(prefixCls, "-open"), open), _defineProperty(_rootCls, "".concat(prefixCls, "-focused"), open || !!this._focused), _defineProperty(_rootCls, "".concat(prefixCls, "-combobox"), (0, _util.isCombobox)(props)), _defineProperty(_rootCls, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_rootCls, "".concat(prefixCls, "-enabled"), !disabled), _defineProperty(_rootCls, "".concat(prefixCls, "-allow-clear"), !!props.allowClear), _defineProperty(_rootCls, "".concat(prefixCls, "-no-arrow"), !showArrow), _defineProperty(_rootCls, "".concat(prefixCls, "-loading"), !!loading), _rootCls);
	      return React.createElement(_SelectTrigger["default"], {
	        onPopupFocus: this.onPopupFocus,
	        onMouseEnter: this.props.onMouseEnter,
	        onMouseLeave: this.props.onMouseLeave,
	        dropdownAlign: props.dropdownAlign,
	        dropdownClassName: props.dropdownClassName,
	        dropdownMatchSelectWidth: props.dropdownMatchSelectWidth,
	        defaultActiveFirstOption: props.defaultActiveFirstOption,
	        dropdownMenuStyle: props.dropdownMenuStyle,
	        transitionName: props.transitionName,
	        animation: props.animation,
	        prefixCls: props.prefixCls,
	        dropdownStyle: props.dropdownStyle,
	        combobox: props.combobox,
	        showSearch: props.showSearch,
	        options: options,
	        empty: empty,
	        multiple: multiple,
	        disabled: disabled,
	        visible: realOpen,
	        inputValue: state.inputValue,
	        value: state.value,
	        backfillValue: state.backfillValue,
	        firstActiveValue: props.firstActiveValue,
	        onDropdownVisibleChange: this.onDropdownVisibleChange,
	        getPopupContainer: props.getPopupContainer,
	        onMenuSelect: this.onMenuSelect,
	        onMenuDeselect: this.onMenuDeselect,
	        onPopupScroll: props.onPopupScroll,
	        showAction: props.showAction,
	        ref: this.saveSelectTriggerRef,
	        menuItemSelectedIcon: props.menuItemSelectedIcon,
	        dropdownRender: props.dropdownRender,
	        ariaId: ariaId
	      }, React.createElement("div", {
	        id: props.id,
	        style: props.style,
	        ref: this.saveRootRef,
	        onBlur: this.onOuterBlur,
	        onFocus: this.onOuterFocus,
	        className: (0, _classnames2["default"])(rootCls),
	        onMouseDown: this.markMouseDown,
	        onMouseUp: this.markMouseLeave,
	        onMouseOut: this.markMouseLeave
	      }, React.createElement("div", _extends({
	        ref: this.saveSelectionRef,
	        key: "selection",
	        className: "".concat(prefixCls, "-selection\n            ").concat(prefixCls, "-selection--").concat(multiple ? 'multiple' : 'single'),
	        role: "combobox",
	        "aria-autocomplete": "list",
	        "aria-haspopup": "true",
	        "aria-controls": ariaId,
	        "aria-expanded": realOpen
	      }, extraSelectionProps), ctrlNode, this.renderClear(), this.renderArrow(!!multiple))));
	    }
	  }]);
	
	  return Select;
	}(React.Component);
	
	Select.propTypes = _PropTypes["default"];
	Select.defaultProps = {
	  prefixCls: 'rc-select',
	  defaultOpen: false,
	  labelInValue: false,
	  defaultActiveFirstOption: true,
	  showSearch: true,
	  allowClear: false,
	  placeholder: '',
	  onChange: noop,
	  onFocus: noop,
	  onBlur: noop,
	  onSelect: noop,
	  onSearch: noop,
	  onDeselect: noop,
	  onInputKeyDown: noop,
	  dropdownMatchSelectWidth: true,
	  dropdownStyle: {},
	  dropdownMenuStyle: {},
	  optionFilterProp: 'value',
	  optionLabelProp: 'value',
	  notFoundContent: 'Not Found',
	  backfill: false,
	  showAction: ['click'],
	  tokenSeparators: [],
	  autoClearSearchValue: true,
	  tabIndex: 0,
	  dropdownRender: function dropdownRender(menu) {
	    return menu;
	  }
	};
	
	Select.getDerivedStateFromProps = function (nextProps, prevState) {
	  var optionsInfo = prevState.skipBuildOptionsInfo ? prevState.optionsInfo : Select.getOptionsInfoFromProps(nextProps, prevState);
	  var newState = {
	    optionsInfo: optionsInfo,
	    skipBuildOptionsInfo: false
	  };
	
	  if ('open' in nextProps) {
	    newState.open = nextProps.open;
	  }
	
	  if (nextProps.disabled && prevState.open) {
	    newState.open = false;
	  }
	
	  if ('value' in nextProps) {
	    var value = Select.getValueFromProps(nextProps);
	    newState.value = value;
	
	    if (nextProps.combobox) {
	      newState.inputValue = Select.getInputValueForCombobox(nextProps, optionsInfo);
	    }
	  }
	
	  return newState;
	};
	
	Select.getOptionsFromChildren = function (children) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  React.Children.forEach(children, function (child) {
	    if (!child) {
	      return;
	    }
	
	    var type = child.type;
	
	    if (type.isSelectOptGroup) {
	      Select.getOptionsFromChildren(child.props.children, options);
	    } else {
	      options.push(child);
	    }
	  });
	  return options;
	};
	
	Select.getInputValueForCombobox = function (props, optionsInfo, useDefaultValue) {
	  var value = [];
	
	  if ('value' in props && !useDefaultValue) {
	    value = (0, _util.toArray)(props.value);
	  }
	
	  if ('defaultValue' in props && useDefaultValue) {
	    value = (0, _util.toArray)(props.defaultValue);
	  }
	
	  if (value.length) {
	    value = value[0];
	  } else {
	    return '';
	  }
	
	  var label = value;
	
	  if (props.labelInValue) {
	    label = value.label;
	  } else if (optionsInfo[(0, _util.getMapKey)(value)]) {
	    label = optionsInfo[(0, _util.getMapKey)(value)].label;
	  }
	
	  if (label === undefined) {
	    label = '';
	  }
	
	  return label;
	};
	
	Select.getLabelFromOption = function (props, option) {
	  return (0, _util.getPropValue)(option, props.optionLabelProp);
	};
	
	Select.getOptionsInfoFromProps = function (props, preState) {
	  var options = Select.getOptionsFromChildren(props.children);
	  var optionsInfo = {};
	  options.forEach(function (option) {
	    var singleValue = (0, _util.getValuePropValue)(option);
	    optionsInfo[(0, _util.getMapKey)(singleValue)] = {
	      option: option,
	      value: singleValue,
	      label: Select.getLabelFromOption(props, option),
	      title: option.props.title,
	      disabled: option.props.disabled
	    };
	  });
	
	  if (preState) {
	    // keep option info in pre state value.
	    var oldOptionsInfo = preState.optionsInfo;
	    var value = preState.value;
	
	    if (value) {
	      value.forEach(function (v) {
	        var key = (0, _util.getMapKey)(v);
	
	        if (!optionsInfo[key] && oldOptionsInfo[key] !== undefined) {
	          optionsInfo[key] = oldOptionsInfo[key];
	        }
	      });
	    }
	  }
	
	  return optionsInfo;
	};
	
	Select.getValueFromProps = function (props, useDefaultValue) {
	  var value = [];
	
	  if ('value' in props && !useDefaultValue) {
	    value = (0, _util.toArray)(props.value);
	  }
	
	  if ('defaultValue' in props && useDefaultValue) {
	    value = (0, _util.toArray)(props.defaultValue);
	  }
	
	  if (props.labelInValue) {
	    value = value.map(function (v) {
	      return v.key;
	    });
	  }
	
	  return value;
	};
	
	Select.displayName = 'Select';
	(0, _reactLifecyclesCompat.polyfill)(Select);
	var _default = Select;
	exports["default"] = _default;

/***/ },
/* 2726 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(6));
	
	var _raf = _interopRequireDefault(__webpack_require__(127));
	
	var _rcTrigger = _interopRequireDefault(__webpack_require__(185));
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(23));
	
	var _DropdownMenu = _interopRequireDefault(__webpack_require__(2723));
	
	var _util = __webpack_require__(561);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var __rest = void 0 && (void 0).__rest || function (s, e) {
	  var t = {};
	
	  for (var p in s) {
	    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
	  }
	
	  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
	    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
	  }
	  return t;
	};
	
	_rcTrigger["default"].displayName = 'Trigger';
	var BUILT_IN_PLACEMENTS = {
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    offset: [0, 4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    }
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    offset: [0, -4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    }
	  }
	};
	
	var SelectTrigger =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(SelectTrigger, _React$Component);
	
	  function SelectTrigger(props) {
	    var _this;
	
	    _classCallCheck(this, SelectTrigger);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectTrigger).call(this, props));
	    _this.dropdownMenuRef = null;
	    _this.rafInstance = null;
	
	    _this.setDropdownWidth = function () {
	      _this.cancelRafInstance();
	
	      _this.rafInstance = (0, _raf["default"])(function () {
	        var dom = ReactDOM.findDOMNode(_assertThisInitialized(_this));
	        var width = dom.offsetWidth;
	
	        if (width !== _this.state.dropdownWidth) {
	          _this.setState({
	            dropdownWidth: width
	          });
	        }
	      });
	    };
	
	    _this.cancelRafInstance = function () {
	      if (_this.rafInstance) {
	        _raf["default"].cancel(_this.rafInstance);
	      }
	    };
	
	    _this.getInnerMenu = function () {
	      return _this.dropdownMenuRef && _this.dropdownMenuRef.menuRef;
	    };
	
	    _this.getPopupDOMNode = function () {
	      return _this.triggerRef.getPopupDomNode();
	    };
	
	    _this.getDropdownElement = function (newProps) {
	      var props = _this.props;
	      var dropdownRender = props.dropdownRender,
	          ariaId = props.ariaId;
	      var menuNode = React.createElement(_DropdownMenu["default"], _extends({
	        ref: _this.saveDropdownMenuRef
	      }, newProps, {
	        ariaId: ariaId,
	        prefixCls: _this.getDropdownPrefixCls(),
	        onMenuSelect: props.onMenuSelect,
	        onMenuDeselect: props.onMenuDeselect,
	        onPopupScroll: props.onPopupScroll,
	        value: props.value,
	        backfillValue: props.backfillValue,
	        firstActiveValue: props.firstActiveValue,
	        defaultActiveFirstOption: props.defaultActiveFirstOption,
	        dropdownMenuStyle: props.dropdownMenuStyle,
	        menuItemSelectedIcon: props.menuItemSelectedIcon
	      }));
	
	      if (dropdownRender) {
	        return dropdownRender(menuNode, props);
	      }
	
	      return null;
	    };
	
	    _this.getDropdownTransitionName = function () {
	      var props = _this.props;
	      var transitionName = props.transitionName;
	
	      if (!transitionName && props.animation) {
	        transitionName = "".concat(_this.getDropdownPrefixCls(), "-").concat(props.animation);
	      }
	
	      return transitionName;
	    };
	
	    _this.getDropdownPrefixCls = function () {
	      return "".concat(_this.props.prefixCls, "-dropdown");
	    };
	
	    _this.saveDropdownMenuRef = (0, _util.saveRef)(_assertThisInitialized(_this), 'dropdownMenuRef');
	    _this.saveTriggerRef = (0, _util.saveRef)(_assertThisInitialized(_this), 'triggerRef');
	    _this.state = {
	      dropdownWidth: 0
	    };
	    return _this;
	  }
	
	  _createClass(SelectTrigger, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.setDropdownWidth();
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.setDropdownWidth();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.cancelRafInstance();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _popupClassName;
	
	      var _a = this.props,
	          onPopupFocus = _a.onPopupFocus,
	          empty = _a.empty,
	          props = __rest(_a, ["onPopupFocus", "empty"]);
	
	      var multiple = props.multiple,
	          visible = props.visible,
	          inputValue = props.inputValue,
	          dropdownAlign = props.dropdownAlign,
	          disabled = props.disabled,
	          showSearch = props.showSearch,
	          dropdownClassName = props.dropdownClassName,
	          dropdownStyle = props.dropdownStyle,
	          dropdownMatchSelectWidth = props.dropdownMatchSelectWidth;
	      var dropdownPrefixCls = this.getDropdownPrefixCls();
	      var popupClassName = (_popupClassName = {}, _defineProperty(_popupClassName, dropdownClassName, !!dropdownClassName), _defineProperty(_popupClassName, "".concat(dropdownPrefixCls, "--").concat(multiple ? 'multiple' : 'single'), 1), _defineProperty(_popupClassName, "".concat(dropdownPrefixCls, "--empty"), empty), _popupClassName);
	      var popupElement = this.getDropdownElement({
	        menuItems: props.options,
	        onPopupFocus: onPopupFocus,
	        multiple: multiple,
	        inputValue: inputValue,
	        visible: visible
	      });
	      var hideAction;
	
	      if (disabled) {
	        hideAction = [];
	      } else if ((0, _util.isSingleMode)(props) && !showSearch) {
	        hideAction = ['click'];
	      } else {
	        hideAction = ['blur'];
	      }
	
	      var popupStyle = _extends({}, dropdownStyle);
	
	      var widthProp = dropdownMatchSelectWidth ? 'width' : 'minWidth';
	
	      if (this.state.dropdownWidth) {
	        popupStyle[widthProp] = "".concat(this.state.dropdownWidth, "px");
	      }
	
	      return React.createElement(_rcTrigger["default"], _extends({}, props, {
	        showAction: disabled ? [] : this.props.showAction,
	        hideAction: hideAction,
	        ref: this.saveTriggerRef,
	        popupPlacement: "bottomLeft",
	        builtinPlacements: BUILT_IN_PLACEMENTS,
	        prefixCls: dropdownPrefixCls,
	        popupTransitionName: this.getDropdownTransitionName(),
	        onPopupVisibleChange: props.onDropdownVisibleChange,
	        popup: popupElement,
	        popupAlign: dropdownAlign,
	        popupVisible: visible,
	        getPopupContainer: props.getPopupContainer,
	        popupClassName: (0, _classnames["default"])(popupClassName),
	        popupStyle: popupStyle
	      }), props.children);
	    }
	  }]);
	
	  return SelectTrigger;
	}(React.Component);
	
	exports["default"] = SelectTrigger;
	SelectTrigger.defaultProps = {
	  dropdownRender: function dropdownRender(menu) {
	    return menu;
	  }
	};
	SelectTrigger.propTypes = {
	  onPopupFocus: PropTypes.func,
	  onPopupScroll: PropTypes.func,
	  dropdownMatchSelectWidth: PropTypes.bool,
	  dropdownAlign: PropTypes.object,
	  visible: PropTypes.bool,
	  disabled: PropTypes.bool,
	  showSearch: PropTypes.bool,
	  dropdownClassName: PropTypes.string,
	  multiple: PropTypes.bool,
	  inputValue: PropTypes.string,
	  filterOption: PropTypes.any,
	  options: PropTypes.any,
	  prefixCls: PropTypes.string,
	  popupClassName: PropTypes.string,
	  children: PropTypes.any,
	  showAction: PropTypes.arrayOf(PropTypes.string),
	  menuItemSelectedIcon: PropTypes.oneOfType([PropTypes.func, PropTypes.node]),
	  dropdownRender: PropTypes.func,
	  ariaId: PropTypes.string
	};
	SelectTrigger.displayName = 'SelectTrigger';

/***/ },
/* 2727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(443);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _shallowequal = __webpack_require__(79);
	
	var _shallowequal2 = _interopRequireDefault(_shallowequal);
	
	var _Track = __webpack_require__(1104);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _createSlider = __webpack_require__(1105);
	
	var _createSlider2 = _interopRequireDefault(_createSlider);
	
	var _utils = __webpack_require__(562);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint-disable react/prop-types */
	var _trimAlignValue = function _trimAlignValue(_ref) {
	  var value = _ref.value,
	      handle = _ref.handle,
	      bounds = _ref.bounds,
	      props = _ref.props;
	  var allowCross = props.allowCross,
	      pushable = props.pushable;
	
	  var thershold = Number(pushable);
	  var valInRange = utils.ensureValueInRange(value, props);
	  var valNotConflict = valInRange;
	  if (!allowCross && handle != null && bounds !== undefined) {
	    if (handle > 0 && valInRange <= bounds[handle - 1] + thershold) {
	      valNotConflict = bounds[handle - 1] + thershold;
	    }
	    if (handle < bounds.length - 1 && valInRange >= bounds[handle + 1] - thershold) {
	      valNotConflict = bounds[handle + 1] - thershold;
	    }
	  }
	  return utils.ensureValuePrecision(valNotConflict, props);
	};
	
	var Range = function (_React$Component) {
	  (0, _inherits3['default'])(Range, _React$Component);
	
	  function Range(props) {
	    (0, _classCallCheck3['default'])(this, Range);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Range.__proto__ || Object.getPrototypeOf(Range)).call(this, props));
	
	    _this.onEnd = function (force) {
	      var handle = _this.state.handle;
	
	      _this.removeDocumentEvents();
	
	      if (handle !== null || force) {
	        _this.props.onAfterChange(_this.getValue());
	      }
	
	      _this.setState({
	        handle: null
	      });
	    };
	
	    var count = props.count,
	        min = props.min,
	        max = props.max;
	
	    var initialValue = Array.apply(undefined, (0, _toConsumableArray3['default'])(Array(count + 1))).map(function () {
	      return min;
	    });
	    var defaultValue = 'defaultValue' in props ? props.defaultValue : initialValue;
	    var value = props.value !== undefined ? props.value : defaultValue;
	    var bounds = value.map(function (v, i) {
	      return _trimAlignValue({
	        value: v,
	        handle: i,
	        props: props
	      });
	    });
	    var recent = bounds[0] === max ? 0 : bounds.length - 1;
	
	    _this.state = {
	      handle: null,
	      recent: recent,
	      bounds: bounds
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Range, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      var _this2 = this;
	
	      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
	        return;
	      }
	      if (this.props.min === prevProps.min && this.props.max === prevProps.max && (0, _shallowequal2['default'])(this.props.value, prevProps.value)) {
	        return;
	      }
	      var _props = this.props,
	          onChange = _props.onChange,
	          value = _props.value;
	
	      var currentValue = value || prevState.bounds;
	      if (currentValue.some(function (v) {
	        return utils.isValueOutOfRange(v, _this2.props);
	      })) {
	        var newValues = currentValue.map(function (v) {
	          return utils.ensureValueInRange(v, _this2.props);
	        });
	        onChange(newValues);
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(state) {
	      var props = this.props;
	      var isNotControlled = !('value' in props);
	      if (isNotControlled) {
	        this.setState(state);
	      } else {
	        var controlledState = {};
	
	        ['handle', 'recent'].forEach(function (item) {
	          if (state[item] !== undefined) {
	            controlledState[item] = state[item];
	          }
	        });
	
	        if (Object.keys(controlledState).length) {
	          this.setState(controlledState);
	        }
	      }
	
	      var data = (0, _extends3['default'])({}, this.state, state);
	      var changedValue = data.bounds;
	      props.onChange(changedValue);
	    }
	  }, {
	    key: 'onStart',
	    value: function onStart(position) {
	      var props = this.props;
	      var state = this.state;
	      var bounds = this.getValue();
	      props.onBeforeChange(bounds);
	
	      var value = this.calcValueByPos(position);
	      this.startValue = value;
	      this.startPosition = position;
	
	      var closestBound = this.getClosestBound(value);
	      this.prevMovedHandleIndex = this.getBoundNeedMoving(value, closestBound);
	
	      this.setState({
	        handle: this.prevMovedHandleIndex,
	        recent: this.prevMovedHandleIndex
	      });
	
	      var prevValue = bounds[this.prevMovedHandleIndex];
	      if (value === prevValue) return;
	
	      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
	      nextBounds[this.prevMovedHandleIndex] = value;
	      this.onChange({ bounds: nextBounds });
	    }
	  }, {
	    key: 'onMove',
	    value: function onMove(e, position) {
	      utils.pauseEvent(e);
	      var state = this.state;
	
	      var value = this.calcValueByPos(position);
	      var oldValue = state.bounds[state.handle];
	      if (value === oldValue) return;
	
	      this.moveTo(value);
	    }
	  }, {
	    key: 'onKeyboard',
	    value: function onKeyboard(e) {
	      var _props2 = this.props,
	          reverse = _props2.reverse,
	          vertical = _props2.vertical;
	
	      var valueMutator = utils.getKeyboardValueMutator(e, vertical, reverse);
	
	      if (valueMutator) {
	        utils.pauseEvent(e);
	        var state = this.state,
	            props = this.props;
	        var bounds = state.bounds,
	            handle = state.handle;
	
	        var oldValue = bounds[handle === null ? state.recent : handle];
	        var mutatedValue = valueMutator(oldValue, props);
	        var value = _trimAlignValue({
	          value: mutatedValue,
	          handle: handle,
	          bounds: state.bounds,
	          props: props
	        });
	        if (value === oldValue) return;
	        var isFromKeyboardEvent = true;
	        this.moveTo(value, isFromKeyboardEvent);
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.state.bounds;
	    }
	  }, {
	    key: 'getClosestBound',
	    value: function getClosestBound(value) {
	      var bounds = this.state.bounds;
	
	      var closestBound = 0;
	      for (var i = 1; i < bounds.length - 1; ++i) {
	        if (value >= bounds[i]) {
	          closestBound = i;
	        }
	      }
	      if (Math.abs(bounds[closestBound + 1] - value) < Math.abs(bounds[closestBound] - value)) {
	        closestBound += 1;
	      }
	      return closestBound;
	    }
	  }, {
	    key: 'getBoundNeedMoving',
	    value: function getBoundNeedMoving(value, closestBound) {
	      var _state = this.state,
	          bounds = _state.bounds,
	          recent = _state.recent;
	
	      var boundNeedMoving = closestBound;
	      var isAtTheSamePoint = bounds[closestBound + 1] === bounds[closestBound];
	
	      if (isAtTheSamePoint && bounds[recent] === bounds[closestBound]) {
	        boundNeedMoving = recent;
	      }
	
	      if (isAtTheSamePoint && value !== bounds[closestBound + 1]) {
	        boundNeedMoving = value < bounds[closestBound + 1] ? closestBound : closestBound + 1;
	      }
	      return boundNeedMoving;
	    }
	  }, {
	    key: 'getLowerBound',
	    value: function getLowerBound() {
	      return this.state.bounds[0];
	    }
	  }, {
	    key: 'getUpperBound',
	    value: function getUpperBound() {
	      var bounds = this.state.bounds;
	
	      return bounds[bounds.length - 1];
	    }
	
	    /**
	     * Returns an array of possible slider points, taking into account both
	     * `marks` and `step`. The result is cached.
	     */
	
	  }, {
	    key: 'getPoints',
	    value: function getPoints() {
	      var _props3 = this.props,
	          marks = _props3.marks,
	          step = _props3.step,
	          min = _props3.min,
	          max = _props3.max;
	
	      var cache = this._getPointsCache;
	      if (!cache || cache.marks !== marks || cache.step !== step) {
	        var pointsObject = (0, _extends3['default'])({}, marks);
	        if (step !== null) {
	          for (var point = min; point <= max; point += step) {
	            pointsObject[point] = point;
	          }
	        }
	        var points = Object.keys(pointsObject).map(parseFloat);
	        points.sort(function (a, b) {
	          return a - b;
	        });
	        this._getPointsCache = { marks: marks, step: step, points: points };
	      }
	      return this._getPointsCache.points;
	    }
	  }, {
	    key: 'moveTo',
	    value: function moveTo(value, isFromKeyboardEvent) {
	      var _this3 = this;
	
	      var state = this.state,
	          props = this.props;
	
	      var nextBounds = [].concat((0, _toConsumableArray3['default'])(state.bounds));
	      var handle = state.handle === null ? state.recent : state.handle;
	      nextBounds[handle] = value;
	      var nextHandle = handle;
	      if (props.pushable !== false) {
	        this.pushSurroundingHandles(nextBounds, nextHandle);
	      } else if (props.allowCross) {
	        nextBounds.sort(function (a, b) {
	          return a - b;
	        });
	        nextHandle = nextBounds.indexOf(value);
	      }
	      this.onChange({
	        recent: nextHandle,
	        handle: nextHandle,
	        bounds: nextBounds
	      });
	      if (isFromKeyboardEvent) {
	        // known problem: because setState is async,
	        // so trigger focus will invoke handler's onEnd and another handler's onStart too early,
	        // cause onBeforeChange and onAfterChange receive wrong value.
	        // here use setState callback to hack，but not elegant
	        this.props.onAfterChange(nextBounds);
	        this.setState({}, function () {
	          _this3.handlesRefs[nextHandle].focus();
	        });
	        this.onEnd();
	      }
	    }
	  }, {
	    key: 'pushSurroundingHandles',
	    value: function pushSurroundingHandles(bounds, handle) {
	      var value = bounds[handle];
	      var threshold = this.props.pushable;
	
	      threshold = Number(threshold);
	
	      var direction = 0;
	      if (bounds[handle + 1] - value < threshold) {
	        direction = +1; // push to right
	      }
	      if (value - bounds[handle - 1] < threshold) {
	        direction = -1; // push to left
	      }
	
	      if (direction === 0) {
	        return;
	      }
	
	      var nextHandle = handle + direction;
	      var diffToNext = direction * (bounds[nextHandle] - value);
	      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	        // revert to original value if pushing is impossible
	        bounds[handle] = bounds[nextHandle] - direction * threshold;
	      }
	    }
	  }, {
	    key: 'pushHandle',
	    value: function pushHandle(bounds, handle, direction, amount) {
	      var originalValue = bounds[handle];
	      var currentValue = bounds[handle];
	      while (direction * (currentValue - originalValue) < amount) {
	        if (!this.pushHandleOnePoint(bounds, handle, direction)) {
	          // can't push handle enough to create the needed `amount` gap, so we
	          // revert its position to the original value
	          bounds[handle] = originalValue;
	          return false;
	        }
	        currentValue = bounds[handle];
	      }
	      // the handle was pushed enough to create the needed `amount` gap
	      return true;
	    }
	  }, {
	    key: 'pushHandleOnePoint',
	    value: function pushHandleOnePoint(bounds, handle, direction) {
	      var points = this.getPoints();
	      var pointIndex = points.indexOf(bounds[handle]);
	      var nextPointIndex = pointIndex + direction;
	      if (nextPointIndex >= points.length || nextPointIndex < 0) {
	        // reached the minimum or maximum available point, can't push anymore
	        return false;
	      }
	      var nextHandle = handle + direction;
	      var nextValue = points[nextPointIndex];
	      var threshold = this.props.pushable;
	
	      var diffToNext = direction * (bounds[nextHandle] - nextValue);
	      if (!this.pushHandle(bounds, nextHandle, direction, threshold - diffToNext)) {
	        // couldn't push next handle, so we won't push this one either
	        return false;
	      }
	      // push the handle
	      bounds[handle] = nextValue;
	      return true;
	    }
	  }, {
	    key: 'trimAlignValue',
	    value: function trimAlignValue(value) {
	      var _state2 = this.state,
	          handle = _state2.handle,
	          bounds = _state2.bounds;
	
	      return _trimAlignValue({
	        value: value,
	        handle: handle,
	        bounds: bounds,
	        props: this.props
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _state3 = this.state,
	          handle = _state3.handle,
	          bounds = _state3.bounds;
	      var _props4 = this.props,
	          prefixCls = _props4.prefixCls,
	          vertical = _props4.vertical,
	          included = _props4.included,
	          disabled = _props4.disabled,
	          min = _props4.min,
	          max = _props4.max,
	          reverse = _props4.reverse,
	          handleGenerator = _props4.handle,
	          trackStyle = _props4.trackStyle,
	          handleStyle = _props4.handleStyle,
	          tabIndex = _props4.tabIndex;
	
	
	      var offsets = bounds.map(function (v) {
	        return _this4.calcOffset(v);
	      });
	
	      var handleClassName = prefixCls + '-handle';
	      var handles = bounds.map(function (v, i) {
	        var _classNames;
	
	        var _tabIndex = tabIndex[i] || 0;
	        if (disabled || tabIndex[i] === null) {
	          _tabIndex = null;
	        }
	        return handleGenerator({
	          className: (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, handleClassName, true), (0, _defineProperty3['default'])(_classNames, handleClassName + '-' + (i + 1), true), _classNames)),
	          prefixCls: prefixCls,
	          vertical: vertical,
	          offset: offsets[i],
	          value: v,
	          dragging: handle === i,
	          index: i,
	          tabIndex: _tabIndex,
	          min: min,
	          max: max,
	          reverse: reverse,
	          disabled: disabled,
	          style: handleStyle[i],
	          ref: function ref(h) {
	            return _this4.saveHandle(i, h);
	          }
	        });
	      });
	
	      var tracks = bounds.slice(0, -1).map(function (_, index) {
	        var _classNames2;
	
	        var i = index + 1;
	        var trackClassName = (0, _classnames2['default'])((_classNames2 = {}, (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track', true), (0, _defineProperty3['default'])(_classNames2, prefixCls + '-track-' + i, true), _classNames2));
	        return _react2['default'].createElement(_Track2['default'], {
	          className: trackClassName,
	          vertical: vertical,
	          reverse: reverse,
	          included: included,
	          offset: offsets[i - 1],
	          length: offsets[i] - offsets[i - 1],
	          style: trackStyle[index],
	          key: i
	        });
	      });
	
	      return { tracks: tracks, handles: handles };
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(props, state) {
	      if ('value' in props || 'min' in props || 'max' in props) {
	        var value = props.value || state.bounds;
	        var nextBounds = value.map(function (v, i) {
	          return _trimAlignValue({
	            value: v,
	            handle: i,
	            bounds: state.bounds,
	            props: props
	          });
	        });
	        if (nextBounds.length === state.bounds.length && nextBounds.every(function (v, i) {
	          return v === state.bounds[i];
	        })) {
	          return null;
	        }
	        return (0, _extends3['default'])({}, state, {
	          bounds: nextBounds
	        });
	      }
	      return null;
	    }
	  }]);
	  return Range;
	}(_react2['default'].Component);
	
	Range.displayName = 'Range';
	Range.propTypes = {
	  autoFocus: _propTypes2['default'].bool,
	  defaultValue: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
	  value: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
	  count: _propTypes2['default'].number,
	  pushable: _propTypes2['default'].oneOfType([_propTypes2['default'].bool, _propTypes2['default'].number]),
	  allowCross: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  reverse: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].arrayOf(_propTypes2['default'].number),
	  min: _propTypes2['default'].number,
	  max: _propTypes2['default'].number
	};
	Range.defaultProps = {
	  count: 1,
	  allowCross: true,
	  pushable: false,
	  tabIndex: []
	};
	
	
	(0, _reactLifecyclesCompat.polyfill)(Range);
	
	exports['default'] = (0, _createSlider2['default'])(Range);
	module.exports = exports['default'];

/***/ },
/* 2728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(94);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _Track = __webpack_require__(1104);
	
	var _Track2 = _interopRequireDefault(_Track);
	
	var _createSlider = __webpack_require__(1105);
	
	var _createSlider2 = _interopRequireDefault(_createSlider);
	
	var _utils = __webpack_require__(562);
	
	var utils = _interopRequireWildcard(_utils);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint-disable react/prop-types */
	var Slider = function (_React$Component) {
	  (0, _inherits3['default'])(Slider, _React$Component);
	
	  function Slider(props) {
	    (0, _classCallCheck3['default'])(this, Slider);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).call(this, props));
	
	    _this.onEnd = function (force) {
	      var dragging = _this.state.dragging;
	
	      _this.removeDocumentEvents();
	      if (dragging || force) {
	        _this.props.onAfterChange(_this.getValue());
	      }
	      _this.setState({ dragging: false });
	    };
	
	    var defaultValue = props.defaultValue !== undefined ? props.defaultValue : props.min;
	    var value = props.value !== undefined ? props.value : defaultValue;
	
	    _this.state = {
	      value: _this.trimAlignValue(value),
	      dragging: false
	    };
	
	    (0, _warning2['default'])(!('minimumTrackStyle' in props), 'minimumTrackStyle will be deprecated, please use trackStyle instead.');
	    (0, _warning2['default'])(!('maximumTrackStyle' in props), 'maximumTrackStyle will be deprecated, please use railStyle instead.');
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Slider, [{
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (!('value' in this.props || 'min' in this.props || 'max' in this.props)) {
	        return;
	      }
	      var _props = this.props,
	          value = _props.value,
	          onChange = _props.onChange;
	
	      var theValue = value !== undefined ? value : prevState.value;
	      var nextValue = this.trimAlignValue(theValue, this.props);
	      if (nextValue !== prevState.value) {
	        // eslint-disable-next-line
	        this.setState({ value: nextValue });
	        if (utils.isValueOutOfRange(theValue, this.props)) {
	          onChange(nextValue);
	        }
	      }
	    }
	  }, {
	    key: 'onChange',
	    value: function onChange(state) {
	      var props = this.props;
	      var isNotControlled = !('value' in props);
	      var nextState = state.value > this.props.max ? (0, _extends3['default'])({}, state, { value: this.props.max }) : state;
	      if (isNotControlled) {
	        this.setState(nextState);
	      }
	
	      var changedValue = nextState.value;
	      props.onChange(changedValue);
	    }
	  }, {
	    key: 'onStart',
	    value: function onStart(position) {
	      this.setState({ dragging: true });
	      var props = this.props;
	      var prevValue = this.getValue();
	      props.onBeforeChange(prevValue);
	
	      var value = this.calcValueByPos(position);
	      this.startValue = value;
	      this.startPosition = position;
	
	      if (value === prevValue) return;
	
	      this.prevMovedHandleIndex = 0;
	
	      this.onChange({ value: value });
	    }
	  }, {
	    key: 'onMove',
	    value: function onMove(e, position) {
	      utils.pauseEvent(e);
	      var oldValue = this.state.value;
	
	      var value = this.calcValueByPos(position);
	      if (value === oldValue) return;
	
	      this.onChange({ value: value });
	    }
	  }, {
	    key: 'onKeyboard',
	    value: function onKeyboard(e) {
	      var _props2 = this.props,
	          reverse = _props2.reverse,
	          vertical = _props2.vertical;
	
	      var valueMutator = utils.getKeyboardValueMutator(e, vertical, reverse);
	      if (valueMutator) {
	        utils.pauseEvent(e);
	        var state = this.state;
	        var oldValue = state.value;
	        var mutatedValue = valueMutator(oldValue, this.props);
	        var value = this.trimAlignValue(mutatedValue);
	        if (value === oldValue) return;
	
	        this.onChange({ value: value });
	        this.props.onAfterChange(value);
	        this.onEnd();
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.state.value;
	    }
	  }, {
	    key: 'getLowerBound',
	    value: function getLowerBound() {
	      return this.props.min;
	    }
	  }, {
	    key: 'getUpperBound',
	    value: function getUpperBound() {
	      return this.state.value;
	    }
	  }, {
	    key: 'trimAlignValue',
	    value: function trimAlignValue(v) {
	      var nextProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      if (v === null) {
	        return null;
	      }
	
	      var mergedProps = (0, _extends3['default'])({}, this.props, nextProps);
	      var val = utils.ensureValueInRange(v, mergedProps);
	      return utils.ensureValuePrecision(val, mergedProps);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          prefixCls = _props3.prefixCls,
	          vertical = _props3.vertical,
	          included = _props3.included,
	          disabled = _props3.disabled,
	          minimumTrackStyle = _props3.minimumTrackStyle,
	          trackStyle = _props3.trackStyle,
	          handleStyle = _props3.handleStyle,
	          tabIndex = _props3.tabIndex,
	          min = _props3.min,
	          max = _props3.max,
	          reverse = _props3.reverse,
	          handleGenerator = _props3.handle;
	      var _state = this.state,
	          value = _state.value,
	          dragging = _state.dragging;
	
	      var offset = this.calcOffset(value);
	      var handle = handleGenerator({
	        className: prefixCls + '-handle',
	        prefixCls: prefixCls,
	        vertical: vertical,
	        offset: offset,
	        value: value,
	        dragging: dragging,
	        disabled: disabled,
	        min: min,
	        max: max,
	        reverse: reverse,
	        index: 0,
	        tabIndex: tabIndex,
	        style: handleStyle[0] || handleStyle,
	        ref: function ref(h) {
	          return _this2.saveHandle(0, h);
	        }
	      });
	
	      var _trackStyle = trackStyle[0] || trackStyle;
	      var track = _react2['default'].createElement(_Track2['default'], {
	        className: prefixCls + '-track',
	        vertical: vertical,
	        included: included,
	        offset: 0,
	        reverse: reverse,
	        length: offset,
	        style: (0, _extends3['default'])({}, minimumTrackStyle, _trackStyle)
	      });
	
	      return { tracks: track, handles: handle };
	    }
	  }]);
	  return Slider;
	}(_react2['default'].Component);
	
	Slider.propTypes = {
	  defaultValue: _propTypes2['default'].number,
	  value: _propTypes2['default'].number,
	  disabled: _propTypes2['default'].bool,
	  autoFocus: _propTypes2['default'].bool,
	  tabIndex: _propTypes2['default'].number,
	  reverse: _propTypes2['default'].bool,
	  min: _propTypes2['default'].number,
	  max: _propTypes2['default'].number
	};
	exports['default'] = (0, _createSlider2['default'])(Slider);
	module.exports = exports['default'];

/***/ },
/* 2729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Marks = function Marks(_ref) {
	  var className = _ref.className,
	      vertical = _ref.vertical,
	      reverse = _ref.reverse,
	      marks = _ref.marks,
	      included = _ref.included,
	      upperBound = _ref.upperBound,
	      lowerBound = _ref.lowerBound,
	      max = _ref.max,
	      min = _ref.min,
	      onClickLabel = _ref.onClickLabel;
	
	  var marksKeys = Object.keys(marks);
	
	  var range = max - min;
	  var elements = marksKeys.map(parseFloat).sort(function (a, b) {
	    return a - b;
	  }).map(function (point) {
	    var _classNames;
	
	    var markPoint = marks[point];
	    var markPointIsObject = typeof markPoint === 'object' && !_react2['default'].isValidElement(markPoint);
	    var markLabel = markPointIsObject ? markPoint.label : markPoint;
	    if (!markLabel && markLabel !== 0) {
	      return null;
	    }
	
	    var isActive = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var markClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, className + '-text', true), (0, _defineProperty3['default'])(_classNames, className + '-text-active', isActive), _classNames));
	
	    var bottomStyle = (0, _defineProperty3['default'])({
	      marginBottom: '-50%'
	    }, reverse ? 'top' : 'bottom', (point - min) / range * 100 + '%');
	
	    var leftStyle = (0, _defineProperty3['default'])({
	      transform: 'translateX(-50%)',
	      msTransform: 'translateX(-50%)'
	    }, reverse ? 'right' : 'left', reverse ? (point - min / 4) / range * 100 + '%' : (point - min) / range * 100 + '%');
	
	    var style = vertical ? bottomStyle : leftStyle;
	    var markStyle = markPointIsObject ? (0, _extends3['default'])({}, style, markPoint.style) : style;
	    return _react2['default'].createElement(
	      'span',
	      {
	        className: markClassName,
	        style: markStyle,
	        key: point,
	        onMouseDown: function onMouseDown(e) {
	          return onClickLabel(e, point);
	        },
	        onTouchStart: function onTouchStart(e) {
	          return onClickLabel(e, point);
	        }
	      },
	      markLabel
	    );
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: className },
	    elements
	  );
	};
	
	Marks.propTypes = {
	  className: _propTypes2['default'].string,
	  vertical: _propTypes2['default'].bool,
	  reverse: _propTypes2['default'].bool,
	  marks: _propTypes2['default'].object,
	  included: _propTypes2['default'].bool,
	  upperBound: _propTypes2['default'].number,
	  lowerBound: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  min: _propTypes2['default'].number,
	  onClickLabel: _propTypes2['default'].func
	};
	
	exports['default'] = Marks;
	module.exports = exports['default'];

/***/ },
/* 2730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends4 = __webpack_require__(21);
	
	var _extends5 = _interopRequireDefault(_extends4);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _warning = __webpack_require__(94);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var calcPoints = function calcPoints(vertical, marks, dots, step, min, max) {
	  (0, _warning2['default'])(dots ? step > 0 : true, '`Slider[step]` should be a positive number in order to make Slider[dots] work.');
	  var points = Object.keys(marks).map(parseFloat).sort(function (a, b) {
	    return a - b;
	  });
	  if (dots && step) {
	    for (var i = min; i <= max; i += step) {
	      if (points.indexOf(i) === -1) {
	        points.push(i);
	      }
	    }
	  }
	  return points;
	};
	
	var Steps = function Steps(_ref) {
	  var prefixCls = _ref.prefixCls,
	      vertical = _ref.vertical,
	      reverse = _ref.reverse,
	      marks = _ref.marks,
	      dots = _ref.dots,
	      step = _ref.step,
	      included = _ref.included,
	      lowerBound = _ref.lowerBound,
	      upperBound = _ref.upperBound,
	      max = _ref.max,
	      min = _ref.min,
	      dotStyle = _ref.dotStyle,
	      activeDotStyle = _ref.activeDotStyle;
	
	  var range = max - min;
	  var elements = calcPoints(vertical, marks, dots, step, min, max).map(function (point) {
	    var _classNames;
	
	    var offset = Math.abs(point - min) / range * 100 + '%';
	
	    var isActived = !included && point === upperBound || included && point <= upperBound && point >= lowerBound;
	    var style = vertical ? (0, _extends5['default'])({}, dotStyle, (0, _defineProperty3['default'])({}, reverse ? 'top' : 'bottom', offset)) : (0, _extends5['default'])({}, dotStyle, (0, _defineProperty3['default'])({}, reverse ? 'right' : 'left', offset));
	    if (isActived) {
	      style = (0, _extends5['default'])({}, style, activeDotStyle);
	    }
	
	    var pointClassName = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot', true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-active', isActived), (0, _defineProperty3['default'])(_classNames, prefixCls + '-dot-reverse', reverse), _classNames));
	
	    return _react2['default'].createElement('span', { className: pointClassName, style: style, key: point });
	  });
	
	  return _react2['default'].createElement(
	    'div',
	    { className: prefixCls + '-step' },
	    elements
	  );
	};
	
	Steps.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  activeDotStyle: _propTypes2['default'].object,
	  dotStyle: _propTypes2['default'].object,
	  min: _propTypes2['default'].number,
	  max: _propTypes2['default'].number,
	  upperBound: _propTypes2['default'].number,
	  lowerBound: _propTypes2['default'].number,
	  included: _propTypes2['default'].bool,
	  dots: _propTypes2['default'].bool,
	  step: _propTypes2['default'].number,
	  marks: _propTypes2['default'].object,
	  vertical: _propTypes2['default'].bool,
	  reverse: _propTypes2['default'].bool
	};
	
	exports['default'] = Steps;
	module.exports = exports['default'];

/***/ },
/* 2731 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function isString(str) {
	  return typeof str === 'string';
	}
	
	var Step =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Step, _React$Component);
	
	  function Step() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Step);
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Step)).call.apply(_getPrototypeOf2, [this].concat(_args)));
	
	    _defineProperty(_assertThisInitialized(_this), "onClick", function () {
	      var _this$props = _this.props,
	          onClick = _this$props.onClick,
	          onStepClick = _this$props.onStepClick,
	          stepIndex = _this$props.stepIndex;
	
	      if (onClick) {
	        onClick.apply(void 0, arguments);
	      }
	
	      onStepClick(stepIndex);
	    });
	
	    return _this;
	  }
	
	  _createClass(Step, [{
	    key: "renderIconNode",
	    value: function renderIconNode() {
	      var _classNames;
	
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          progressDot = _this$props2.progressDot,
	          stepNumber = _this$props2.stepNumber,
	          status = _this$props2.status,
	          title = _this$props2.title,
	          description = _this$props2.description,
	          icon = _this$props2.icon,
	          iconPrefix = _this$props2.iconPrefix,
	          icons = _this$props2.icons;
	      var iconNode;
	      var iconClassName = (0, _classnames["default"])("".concat(prefixCls, "-icon"), "".concat(iconPrefix, "icon"), (_classNames = {}, _defineProperty(_classNames, "".concat(iconPrefix, "icon-").concat(icon), icon && isString(icon)), _defineProperty(_classNames, "".concat(iconPrefix, "icon-check"), !icon && status === 'finish' && icons && !icons.finish), _defineProperty(_classNames, "".concat(iconPrefix, "icon-close"), !icon && status === 'error' && icons && !icons.error), _classNames));
	
	      var iconDot = _react["default"].createElement("span", {
	        className: "".concat(prefixCls, "-icon-dot")
	      }); // `progressDot` enjoy the highest priority
	
	
	      if (progressDot) {
	        if (typeof progressDot === 'function') {
	          iconNode = _react["default"].createElement("span", {
	            className: "".concat(prefixCls, "-icon")
	          }, progressDot(iconDot, {
	            index: stepNumber - 1,
	            status: status,
	            title: title,
	            description: description
	          }));
	        } else {
	          iconNode = _react["default"].createElement("span", {
	            className: "".concat(prefixCls, "-icon")
	          }, iconDot);
	        }
	      } else if (icon && !isString(icon)) {
	        iconNode = _react["default"].createElement("span", {
	          className: "".concat(prefixCls, "-icon")
	        }, icon);
	      } else if (icons && icons.finish && status === 'finish') {
	        iconNode = _react["default"].createElement("span", {
	          className: "".concat(prefixCls, "-icon")
	        }, icons.finish);
	      } else if (icons && icons.error && status === 'error') {
	        iconNode = _react["default"].createElement("span", {
	          className: "".concat(prefixCls, "-icon")
	        }, icons.error);
	      } else if (icon || status === 'finish' || status === 'error') {
	        iconNode = _react["default"].createElement("span", {
	          className: iconClassName
	        });
	      } else {
	        iconNode = _react["default"].createElement("span", {
	          className: "".concat(prefixCls, "-icon")
	        }, stepNumber);
	      }
	
	      return iconNode;
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames2;
	
	      var _this$props3 = this.props,
	          className = _this$props3.className,
	          prefixCls = _this$props3.prefixCls,
	          style = _this$props3.style,
	          itemWidth = _this$props3.itemWidth,
	          active = _this$props3.active,
	          _this$props3$status = _this$props3.status,
	          status = _this$props3$status === void 0 ? 'wait' : _this$props3$status,
	          iconPrefix = _this$props3.iconPrefix,
	          icon = _this$props3.icon,
	          wrapperStyle = _this$props3.wrapperStyle,
	          adjustMarginRight = _this$props3.adjustMarginRight,
	          stepNumber = _this$props3.stepNumber,
	          disabled = _this$props3.disabled,
	          description = _this$props3.description,
	          title = _this$props3.title,
	          subTitle = _this$props3.subTitle,
	          progressDot = _this$props3.progressDot,
	          tailContent = _this$props3.tailContent,
	          icons = _this$props3.icons,
	          stepIndex = _this$props3.stepIndex,
	          onStepClick = _this$props3.onStepClick,
	          onClick = _this$props3.onClick,
	          restProps = _objectWithoutProperties(_this$props3, ["className", "prefixCls", "style", "itemWidth", "active", "status", "iconPrefix", "icon", "wrapperStyle", "adjustMarginRight", "stepNumber", "disabled", "description", "title", "subTitle", "progressDot", "tailContent", "icons", "stepIndex", "onStepClick", "onClick"]);
	
	      var classString = (0, _classnames["default"])("".concat(prefixCls, "-item"), "".concat(prefixCls, "-item-").concat(status), className, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-item-custom"), icon), _defineProperty(_classNames2, "".concat(prefixCls, "-item-active"), active), _defineProperty(_classNames2, "".concat(prefixCls, "-item-disabled"), disabled === true), _classNames2));
	
	      var stepItemStyle = _objectSpread({}, style);
	
	      if (itemWidth) {
	        stepItemStyle.width = itemWidth;
	      }
	
	      if (adjustMarginRight) {
	        stepItemStyle.marginRight = adjustMarginRight;
	      }
	
	      var accessibilityProps = {};
	
	      if (onStepClick && !disabled) {
	        accessibilityProps.role = 'button';
	        accessibilityProps.tabIndex = 0;
	        accessibilityProps.onClick = this.onClick;
	      }
	
	      return _react["default"].createElement("div", _extends({}, restProps, {
	        className: classString,
	        style: stepItemStyle
	      }), _react["default"].createElement("div", _extends({
	        onClick: onClick
	      }, accessibilityProps, {
	        className: "".concat(prefixCls, "-item-container")
	      }), _react["default"].createElement("div", {
	        className: "".concat(prefixCls, "-item-tail")
	      }, tailContent), _react["default"].createElement("div", {
	        className: "".concat(prefixCls, "-item-icon")
	      }, this.renderIconNode()), _react["default"].createElement("div", {
	        className: "".concat(prefixCls, "-item-content")
	      }, _react["default"].createElement("div", {
	        className: "".concat(prefixCls, "-item-title")
	      }, title, subTitle && _react["default"].createElement("div", {
	        title: subTitle,
	        className: "".concat(prefixCls, "-item-subtitle")
	      }, subTitle)), description && _react["default"].createElement("div", {
	        className: "".concat(prefixCls, "-item-description")
	      }, description))));
	    }
	  }]);
	
	  return Step;
	}(_react["default"].Component);
	
	exports["default"] = Step;
	
	_defineProperty(Step, "propTypes", {
	  className: _propTypes["default"].string,
	  prefixCls: _propTypes["default"].string,
	  style: _propTypes["default"].object,
	  wrapperStyle: _propTypes["default"].object,
	  itemWidth: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  active: _propTypes["default"].bool,
	  disabled: _propTypes["default"].bool,
	  status: _propTypes["default"].string,
	  iconPrefix: _propTypes["default"].string,
	  icon: _propTypes["default"].node,
	  adjustMarginRight: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
	  stepNumber: _propTypes["default"].string,
	  stepIndex: _propTypes["default"].number,
	  description: _propTypes["default"].any,
	  title: _propTypes["default"].any,
	  subTitle: _propTypes["default"].any,
	  progressDot: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func]),
	  tailContent: _propTypes["default"].any,
	  icons: _propTypes["default"].shape({
	    finish: _propTypes["default"].node,
	    error: _propTypes["default"].node
	  }),
	  onClick: _propTypes["default"].func,
	  onStepClick: _propTypes["default"].func
	});

/***/ },
/* 2732 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactDom = __webpack_require__(23);
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _debounce = _interopRequireDefault(__webpack_require__(300));
	
	var _utils = __webpack_require__(2734);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; return newObj; } }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Steps =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Steps, _Component);
	
	  function Steps(props) {
	    var _this;
	
	    _classCallCheck(this, Steps);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Steps).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "onStepClick", function (next) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          current = _this$props.current;
	
	      if (onChange && current !== next) {
	        onChange(next);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "calcStepOffsetWidth", function () {
	      if ((0, _utils.isFlexSupported)()) {
	        return;
	      }
	
	      var lastStepOffsetWidth = _this.state.lastStepOffsetWidth; // Just for IE9
	
	      var domNode = (0, _reactDom.findDOMNode)(_assertThisInitialized(_this));
	
	      if (domNode.children.length > 0) {
	        if (_this.calcTimeout) {
	          clearTimeout(_this.calcTimeout);
	        }
	
	        _this.calcTimeout = setTimeout(function () {
	          // +1 for fit edge bug of digit width, like 35.4px
	          var offsetWidth = (domNode.lastChild.offsetWidth || 0) + 1; // Reduce shake bug
	
	          if (lastStepOffsetWidth === offsetWidth || Math.abs(lastStepOffsetWidth - offsetWidth) <= 3) {
	            return;
	          }
	
	          _this.setState({
	            lastStepOffsetWidth: offsetWidth
	          });
	        });
	      }
	    });
	
	    _this.state = {
	      flexSupported: true,
	      lastStepOffsetWidth: 0
	    };
	    _this.calcStepOffsetWidth = (0, _debounce["default"])(_this.calcStepOffsetWidth, 150);
	    return _this;
	  }
	
	  _createClass(Steps, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.calcStepOffsetWidth();
	
	      if (!(0, _utils.isFlexSupported)()) {
	        this.setState({
	          flexSupported: false
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      this.calcStepOffsetWidth();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      if (this.calcTimeout) {
	        clearTimeout(this.calcTimeout);
	      }
	
	      if (this.calcStepOffsetWidth && this.calcStepOffsetWidth.cancel) {
	        this.calcStepOffsetWidth.cancel();
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _classNames,
	          _this2 = this;
	
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          _this$props2$style = _this$props2.style,
	          style = _this$props2$style === void 0 ? {} : _this$props2$style,
	          className = _this$props2.className,
	          children = _this$props2.children,
	          direction = _this$props2.direction,
	          type = _this$props2.type,
	          labelPlacement = _this$props2.labelPlacement,
	          iconPrefix = _this$props2.iconPrefix,
	          status = _this$props2.status,
	          size = _this$props2.size,
	          current = _this$props2.current,
	          progressDot = _this$props2.progressDot,
	          initial = _this$props2.initial,
	          icons = _this$props2.icons,
	          onChange = _this$props2.onChange,
	          restProps = _objectWithoutProperties(_this$props2, ["prefixCls", "style", "className", "children", "direction", "type", "labelPlacement", "iconPrefix", "status", "size", "current", "progressDot", "initial", "icons", "onChange"]);
	
	      var isNav = type === 'navigation';
	      var _this$state = this.state,
	          lastStepOffsetWidth = _this$state.lastStepOffsetWidth,
	          flexSupported = _this$state.flexSupported;
	
	      var filteredChildren = _react["default"].Children.toArray(children).filter(function (c) {
	        return !!c;
	      });
	
	      var lastIndex = filteredChildren.length - 1;
	      var adjustedlabelPlacement = progressDot ? 'vertical' : labelPlacement;
	      var classString = (0, _classnames["default"])(prefixCls, "".concat(prefixCls, "-").concat(direction), className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), size), _defineProperty(_classNames, "".concat(prefixCls, "-label-").concat(adjustedlabelPlacement), direction === 'horizontal'), _defineProperty(_classNames, "".concat(prefixCls, "-dot"), !!progressDot), _defineProperty(_classNames, "".concat(prefixCls, "-navigation"), isNav), _defineProperty(_classNames, "".concat(prefixCls, "-flex-not-supported"), !flexSupported), _classNames));
	      return _react["default"].createElement("div", _extends({
	        className: classString,
	        style: style
	      }, restProps), _react.Children.map(filteredChildren, function (child, index) {
	        if (!child) {
	          return null;
	        }
	
	        var stepNumber = initial + index;
	
	        var childProps = _objectSpread({
	          stepNumber: "".concat(stepNumber + 1),
	          stepIndex: stepNumber,
	          prefixCls: prefixCls,
	          iconPrefix: iconPrefix,
	          wrapperStyle: style,
	          progressDot: progressDot,
	          icons: icons,
	          onStepClick: onChange && _this2.onStepClick
	        }, child.props);
	
	        if (!flexSupported && direction !== 'vertical') {
	          if (isNav) {
	            childProps.itemWidth = "".concat(100 / (lastIndex + 1), "%");
	            childProps.adjustMarginRight = 0;
	          } else if (index !== lastIndex) {
	            childProps.itemWidth = "".concat(100 / lastIndex, "%");
	            childProps.adjustMarginRight = -Math.round(lastStepOffsetWidth / lastIndex + 1);
	          }
	        } // fix tail color
	
	
	        if (status === 'error' && index === current - 1) {
	          childProps.className = "".concat(prefixCls, "-next-error");
	        }
	
	        if (!child.props.status) {
	          if (stepNumber === current) {
	            childProps.status = status;
	          } else if (stepNumber < current) {
	            childProps.status = 'finish';
	          } else {
	            childProps.status = 'wait';
	          }
	        }
	
	        childProps.active = stepNumber === current;
	        return (0, _react.cloneElement)(child, childProps);
	      }));
	    }
	  }]);
	
	  return Steps;
	}(_react.Component);
	
	exports["default"] = Steps;
	
	_defineProperty(Steps, "propTypes", {
	  type: _propTypes["default"].string,
	  prefixCls: _propTypes["default"].string,
	  className: _propTypes["default"].string,
	  iconPrefix: _propTypes["default"].string,
	  direction: _propTypes["default"].string,
	  labelPlacement: _propTypes["default"].string,
	  children: _propTypes["default"].any,
	  status: _propTypes["default"].string,
	  size: _propTypes["default"].string,
	  progressDot: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].func]),
	  style: _propTypes["default"].object,
	  initial: _propTypes["default"].number,
	  current: _propTypes["default"].number,
	  icons: _propTypes["default"].shape({
	    finish: _propTypes["default"].node,
	    error: _propTypes["default"].node
	  }),
	  onChange: _propTypes["default"].func
	});
	
	_defineProperty(Steps, "defaultProps", {
	  type: 'default',
	  prefixCls: 'rc-steps',
	  iconPrefix: 'rc',
	  direction: 'horizontal',
	  labelPlacement: 'horizontal',
	  initial: 0,
	  current: 0,
	  status: 'process',
	  size: '',
	  progressDot: false
	});

/***/ },
/* 2733 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "Step", {
	  enumerable: true,
	  get: function get() {
	    return _Step["default"];
	  }
	});
	exports["default"] = void 0;
	
	var _Steps = _interopRequireDefault(__webpack_require__(2732));
	
	var _Step = _interopRequireDefault(__webpack_require__(2731));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	_Steps["default"].Step = _Step["default"];
	var _default = _Steps["default"];
	exports["default"] = _default;

/***/ },
/* 2734 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isFlexSupported = isFlexSupported;
	
	// eslint-disable-next-line import/prefer-default-export
	function isFlexSupported() {
	  if (typeof window !== 'undefined' && window.document && window.document.documentElement) {
	    var documentElement = window.document.documentElement;
	    return 'flex' in documentElement.style || 'webkitFlex' in documentElement.style || 'Flex' in documentElement.style || 'msFlex' in documentElement.style;
	  }
	
	  return false;
	}

/***/ },
/* 2735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _utils = __webpack_require__(220);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _componentDidUpdate(component, init) {
	  var _component$props = component.props,
	      styles = _component$props.styles,
	      panels = _component$props.panels,
	      activeKey = _component$props.activeKey,
	      direction = _component$props.direction;
	
	  var rootNode = component.props.getRef('root');
	  var wrapNode = component.props.getRef('nav') || rootNode;
	  var inkBarNode = component.props.getRef('inkBar');
	  var activeTab = component.props.getRef('activeTab');
	  var inkBarNodeStyle = inkBarNode.style;
	  var tabBarPosition = component.props.tabBarPosition;
	  var activeIndex = (0, _utils.getActiveIndex)(panels, activeKey);
	  if (init) {
	    // prevent mount animation
	    inkBarNodeStyle.display = 'none';
	  }
	  if (activeTab) {
	    var tabNode = activeTab;
	    var transformSupported = (0, _utils.isTransform3dSupported)(inkBarNodeStyle);
	
	    // Reset current style
	    (0, _utils.setTransform)(inkBarNodeStyle, '');
	    inkBarNodeStyle.width = '';
	    inkBarNodeStyle.height = '';
	    inkBarNodeStyle.left = '';
	    inkBarNodeStyle.top = '';
	    inkBarNodeStyle.bottom = '';
	    inkBarNodeStyle.right = '';
	
	    if (tabBarPosition === 'top' || tabBarPosition === 'bottom') {
	      var left = (0, _utils.getLeft)(tabNode, wrapNode);
	      var width = tabNode.offsetWidth;
	
	      // If tabNode'width width equal to wrapNode'width when tabBarPosition is top or bottom
	      // It means no css working, then ink bar should not have width until css is loaded
	      // Fix https://github.com/ant-design/ant-design/issues/7564
	      if (width === rootNode.offsetWidth) {
	        width = 0;
	      } else if (styles.inkBar && styles.inkBar.width !== undefined) {
	        width = parseFloat(styles.inkBar.width, 10);
	        if (width) {
	          left += (tabNode.offsetWidth - width) / 2;
	        }
	      }
	      if (direction === 'rtl') {
	        left = (0, _utils.getStyle)(tabNode, 'margin-left') - left;
	      }
	      // use 3d gpu to optimize render
	      if (transformSupported) {
	        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(' + left + 'px,0,0)');
	      } else {
	        inkBarNodeStyle.left = left + 'px';
	      }
	      inkBarNodeStyle.width = width + 'px';
	    } else {
	      var top = (0, _utils.getTop)(tabNode, wrapNode, true);
	      var height = tabNode.offsetHeight;
	      if (styles.inkBar && styles.inkBar.height !== undefined) {
	        height = parseFloat(styles.inkBar.height, 10);
	        if (height) {
	          top += (tabNode.offsetHeight - height) / 2;
	        }
	      }
	      if (transformSupported) {
	        (0, _utils.setTransform)(inkBarNodeStyle, 'translate3d(0,' + top + 'px,0)');
	        inkBarNodeStyle.top = '0';
	      } else {
	        inkBarNodeStyle.top = top + 'px';
	      }
	      inkBarNodeStyle.height = height + 'px';
	    }
	  }
	  inkBarNodeStyle.display = activeIndex !== -1 ? 'block' : 'none';
	}
	
	var InkTabBarNode = function (_React$Component) {
	  (0, _inherits3['default'])(InkTabBarNode, _React$Component);
	
	  function InkTabBarNode() {
	    (0, _classCallCheck3['default'])(this, InkTabBarNode);
	    return (0, _possibleConstructorReturn3['default'])(this, (InkTabBarNode.__proto__ || Object.getPrototypeOf(InkTabBarNode)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(InkTabBarNode, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      // ref https://github.com/ant-design/ant-design/issues/8678
	      // ref https://github.com/react-component/tabs/issues/135
	      // InkTabBarNode need parent/root ref for calculating position
	      // since parent componentDidMount triggered after child componentDidMount
	      // we're doing a quick fix here to use setTimeout to calculate position
	      // after parent/root component mounted
	      this.timeout = setTimeout(function () {
	        _componentDidUpdate(_this2, true);
	      }, 0);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      _componentDidUpdate(this);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          styles = _props.styles,
	          inkBarAnimated = _props.inkBarAnimated;
	
	      var className = prefixCls + '-ink-bar';
	      var classes = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, className, true), (0, _defineProperty3['default'])(_classnames, inkBarAnimated ? className + '-animated' : className + '-no-animated', true), _classnames));
	      return _react2['default'].createElement('div', {
	        style: styles.inkBar,
	        className: classes,
	        key: 'inkBar',
	        ref: this.props.saveRef('inkBar')
	      });
	    }
	  }]);
	  return InkTabBarNode;
	}(_react2['default'].Component);
	
	exports['default'] = InkTabBarNode;
	
	
	InkTabBarNode.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  styles: _propTypes2['default'].object,
	  inkBarAnimated: _propTypes2['default'].bool,
	  saveRef: _propTypes2['default'].func,
	  direction: _propTypes2['default'].string
	};
	
	InkTabBarNode.defaultProps = {
	  prefixCls: '',
	  inkBarAnimated: true,
	  styles: {},
	  saveRef: function saveRef() {}
	};
	module.exports = exports['default'];

/***/ },
/* 2736 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = {
	  /**
	   * LEFT
	   */
	  LEFT: 37, // also NUM_WEST
	  /**
	   * UP
	   */
	  UP: 38, // also NUM_NORTH
	  /**
	   * RIGHT
	   */
	  RIGHT: 39, // also NUM_EAST
	  /**
	   * DOWN
	   */
	  DOWN: 40 // also NUM_SOUTH
	};
	module.exports = exports['default'];

/***/ },
/* 2737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var SaveRef = function (_React$Component) {
	  (0, _inherits3['default'])(SaveRef, _React$Component);
	
	  function SaveRef() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, SaveRef);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = SaveRef.__proto__ || Object.getPrototypeOf(SaveRef)).call.apply(_ref, [this].concat(args))), _this), _this.getRef = function (name) {
	      return _this[name];
	    }, _this.saveRef = function (name) {
	      return function (node) {
	        if (node) {
	          _this[name] = node;
	        }
	      };
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(SaveRef, [{
	    key: 'render',
	    value: function render() {
	      return this.props.children(this.saveRef, this.getRef);
	    }
	  }]);
	  return SaveRef;
	}(_react2['default'].Component);
	
	exports['default'] = SaveRef;
	
	
	SaveRef.propTypes = {
	  children: _propTypes2['default'].func
	};
	
	SaveRef.defaultProps = {
	  children: function children() {
	    return null;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 2738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _InkTabBarNode = __webpack_require__(2735);
	
	var _InkTabBarNode2 = _interopRequireDefault(_InkTabBarNode);
	
	var _TabBarTabsNode = __webpack_require__(2741);
	
	var _TabBarTabsNode2 = _interopRequireDefault(_TabBarTabsNode);
	
	var _TabBarRootNode = __webpack_require__(2740);
	
	var _TabBarRootNode2 = _interopRequireDefault(_TabBarRootNode);
	
	var _ScrollableTabBarNode = __webpack_require__(2739);
	
	var _ScrollableTabBarNode2 = _interopRequireDefault(_ScrollableTabBarNode);
	
	var _SaveRef = __webpack_require__(2737);
	
	var _SaveRef2 = _interopRequireDefault(_SaveRef);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ScrollableInkTabBar = function (_React$Component) {
	  (0, _inherits3['default'])(ScrollableInkTabBar, _React$Component);
	
	  function ScrollableInkTabBar() {
	    (0, _classCallCheck3['default'])(this, ScrollableInkTabBar);
	    return (0, _possibleConstructorReturn3['default'])(this, (ScrollableInkTabBar.__proto__ || Object.getPrototypeOf(ScrollableInkTabBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(ScrollableInkTabBar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          renderTabBarNode = _props.children,
	          restProps = (0, _objectWithoutProperties3['default'])(_props, ['children']);
	
	
	      return _react2['default'].createElement(
	        _SaveRef2['default'],
	        null,
	        function (saveRef, getRef) {
	          return _react2['default'].createElement(
	            _TabBarRootNode2['default'],
	            (0, _extends3['default'])({ saveRef: saveRef }, restProps),
	            _react2['default'].createElement(
	              _ScrollableTabBarNode2['default'],
	              (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, restProps),
	              _react2['default'].createElement(_TabBarTabsNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, renderTabBarNode: renderTabBarNode }, restProps)),
	              _react2['default'].createElement(_InkTabBarNode2['default'], (0, _extends3['default'])({ saveRef: saveRef, getRef: getRef }, restProps))
	            )
	          );
	        }
	      );
	    }
	  }]);
	  return ScrollableInkTabBar;
	}(_react2['default'].Component); /* eslint-disable react/prefer-stateless-function */
	
	
	exports['default'] = ScrollableInkTabBar;
	
	
	ScrollableInkTabBar.propTypes = {
	  children: _propTypes2['default'].func
	};
	module.exports = exports['default'];

/***/ },
/* 2739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames5 = __webpack_require__(20);
	
	var _classnames6 = _interopRequireDefault(_classnames5);
	
	var _debounce = __webpack_require__(300);
	
	var _debounce2 = _interopRequireDefault(_debounce);
	
	var _resizeObserverPolyfill = __webpack_require__(391);
	
	var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);
	
	var _utils = __webpack_require__(220);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ScrollableTabBarNode = function (_React$Component) {
	  (0, _inherits3['default'])(ScrollableTabBarNode, _React$Component);
	
	  function ScrollableTabBarNode(props) {
	    (0, _classCallCheck3['default'])(this, ScrollableTabBarNode);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (ScrollableTabBarNode.__proto__ || Object.getPrototypeOf(ScrollableTabBarNode)).call(this, props));
	
	    _this.prevTransitionEnd = function (e) {
	      if (e.propertyName !== 'opacity') {
	        return;
	      }
	      var container = _this.props.getRef('container');
	      _this.scrollToActiveTab({
	        target: container,
	        currentTarget: container
	      });
	    };
	
	    _this.scrollToActiveTab = function (e) {
	      var activeTab = _this.props.getRef('activeTab');
	      var navWrap = _this.props.getRef('navWrap');
	      if (e && e.target !== e.currentTarget || !activeTab) {
	        return;
	      }
	
	      // when not scrollable or enter scrollable first time, don't emit scrolling
	      var needToSroll = _this.isNextPrevShown() && _this.lastNextPrevShown;
	      _this.lastNextPrevShown = _this.isNextPrevShown();
	      if (!needToSroll) {
	        return;
	      }
	
	      var activeTabWH = _this.getScrollWH(activeTab);
	      var navWrapNodeWH = _this.getOffsetWH(navWrap);
	      var offset = _this.offset;
	
	      var wrapOffset = _this.getOffsetLT(navWrap);
	      var activeTabOffset = _this.getOffsetLT(activeTab);
	      if (wrapOffset > activeTabOffset) {
	        offset += wrapOffset - activeTabOffset;
	        _this.setOffset(offset);
	      } else if (wrapOffset + navWrapNodeWH < activeTabOffset + activeTabWH) {
	        offset -= activeTabOffset + activeTabWH - (wrapOffset + navWrapNodeWH);
	        _this.setOffset(offset);
	      }
	    };
	
	    _this.prev = function (e) {
	      _this.props.onPrevClick(e);
	      var navWrapNode = _this.props.getRef('navWrap');
	      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
	      var offset = _this.offset;
	
	      _this.setOffset(offset + navWrapNodeWH);
	    };
	
	    _this.next = function (e) {
	      _this.props.onNextClick(e);
	      var navWrapNode = _this.props.getRef('navWrap');
	      var navWrapNodeWH = _this.getOffsetWH(navWrapNode);
	      var offset = _this.offset;
	
	      _this.setOffset(offset - navWrapNodeWH);
	    };
	
	    _this.offset = 0;
	
	    _this.state = {
	      next: false,
	      prev: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(ScrollableTabBarNode, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.componentDidUpdate();
	      this.debouncedResize = (0, _debounce2['default'])(function () {
	        _this2.setNextPrev();
	        _this2.scrollToActiveTab();
	      }, 200);
	      this.resizeObserver = new _resizeObserverPolyfill2['default'](this.debouncedResize);
	      this.resizeObserver.observe(this.props.getRef('container'));
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      var props = this.props;
	      if (prevProps && prevProps.tabBarPosition !== props.tabBarPosition) {
	        this.setOffset(0);
	        return;
	      }
	      var nextPrev = this.setNextPrev();
	      // wait next, prev show hide
	      /* eslint react/no-did-update-set-state:0 */
	      if (this.isNextPrevShown(this.state) !== this.isNextPrevShown(nextPrev)) {
	        this.setState({}, this.scrollToActiveTab);
	      } else if (!prevProps || props.activeKey !== prevProps.activeKey) {
	        // can not use props.activeKey
	        this.scrollToActiveTab();
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.resizeObserver) {
	        this.resizeObserver.disconnect();
	      }
	      if (this.debouncedResize && this.debouncedResize.cancel) {
	        this.debouncedResize.cancel();
	      }
	    }
	  }, {
	    key: 'setNextPrev',
	    value: function setNextPrev() {
	      var navNode = this.props.getRef('nav');
	      var navTabsContainer = this.props.getRef('navTabsContainer');
	      var navNodeWH = this.getScrollWH(navTabsContainer || navNode);
	      // Add 1px to fix `offsetWidth` with decimal in Chrome not correct handle
	      // https://github.com/ant-design/ant-design/issues/13423
	      var containerWH = this.getOffsetWH(this.props.getRef('container')) + 1;
	      var navWrapNodeWH = this.getOffsetWH(this.props.getRef('navWrap'));
	      var offset = this.offset;
	
	      var minOffset = containerWH - navNodeWH;
	      var _state = this.state,
	          next = _state.next,
	          prev = _state.prev;
	
	      if (minOffset >= 0) {
	        next = false;
	        this.setOffset(0, false);
	        offset = 0;
	      } else if (minOffset < offset) {
	        next = true;
	      } else {
	        next = false;
	        // Fix https://github.com/ant-design/ant-design/issues/8861
	        // Test with container offset which is stable
	        // and set the offset of the nav wrap node
	        var realOffset = navWrapNodeWH - navNodeWH;
	        this.setOffset(realOffset, false);
	        offset = realOffset;
	      }
	
	      if (offset < 0) {
	        prev = true;
	      } else {
	        prev = false;
	      }
	
	      this.setNext(next);
	      this.setPrev(prev);
	      return {
	        next: next,
	        prev: prev
	      };
	    }
	  }, {
	    key: 'getOffsetWH',
	    value: function getOffsetWH(node) {
	      var tabBarPosition = this.props.tabBarPosition;
	      var prop = 'offsetWidth';
	      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	        prop = 'offsetHeight';
	      }
	      return node[prop];
	    }
	  }, {
	    key: 'getScrollWH',
	    value: function getScrollWH(node) {
	      var tabBarPosition = this.props.tabBarPosition;
	      var prop = 'scrollWidth';
	      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	        prop = 'scrollHeight';
	      }
	      return node[prop];
	    }
	  }, {
	    key: 'getOffsetLT',
	    value: function getOffsetLT(node) {
	      var tabBarPosition = this.props.tabBarPosition;
	      var prop = 'left';
	      if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	        prop = 'top';
	      }
	      return node.getBoundingClientRect()[prop];
	    }
	  }, {
	    key: 'setOffset',
	    value: function setOffset(offset) {
	      var checkNextPrev = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	
	      var target = Math.min(0, offset);
	      if (this.offset !== target) {
	        this.offset = target;
	        var navOffset = {};
	        var tabBarPosition = this.props.tabBarPosition;
	        var navStyle = this.props.getRef('nav').style;
	        var transformSupported = (0, _utils.isTransform3dSupported)(navStyle);
	        if (tabBarPosition === 'left' || tabBarPosition === 'right') {
	          if (transformSupported) {
	            navOffset = {
	              value: 'translate3d(0,' + target + 'px,0)'
	            };
	          } else {
	            navOffset = {
	              name: 'top',
	              value: target + 'px'
	            };
	          }
	        } else if (transformSupported) {
	          if (this.props.direction === 'rtl') {
	            target = -target;
	          }
	          navOffset = {
	            value: 'translate3d(' + target + 'px,0,0)'
	          };
	        } else {
	          navOffset = {
	            name: 'left',
	            value: target + 'px'
	          };
	        }
	        if (transformSupported) {
	          (0, _utils.setTransform)(navStyle, navOffset.value);
	        } else {
	          navStyle[navOffset.name] = navOffset.value;
	        }
	        if (checkNextPrev) {
	          this.setNextPrev();
	        }
	      }
	    }
	  }, {
	    key: 'setPrev',
	    value: function setPrev(v) {
	      if (this.state.prev !== v) {
	        this.setState({
	          prev: v
	        });
	      }
	    }
	  }, {
	    key: 'setNext',
	    value: function setNext(v) {
	      if (this.state.next !== v) {
	        this.setState({
	          next: v
	        });
	      }
	    }
	  }, {
	    key: 'isNextPrevShown',
	    value: function isNextPrevShown(state) {
	      if (state) {
	        return state.next || state.prev;
	      }
	      return this.state.next || this.state.prev;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames, _classnames2, _classnames3, _classnames4;
	
	      var _state2 = this.state,
	          next = _state2.next,
	          prev = _state2.prev;
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          scrollAnimated = _props.scrollAnimated,
	          navWrapper = _props.navWrapper,
	          prevIcon = _props.prevIcon,
	          nextIcon = _props.nextIcon;
	
	      var showNextPrev = prev || next;
	
	      var prevButton = _react2['default'].createElement(
	        'span',
	        {
	          onClick: prev ? this.prev : null,
	          unselectable: 'unselectable',
	          className: (0, _classnames6['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-prev', 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-btn-disabled', !prev), (0, _defineProperty3['default'])(_classnames, prefixCls + '-tab-arrow-show', showNextPrev), _classnames)),
	          onTransitionEnd: this.prevTransitionEnd
	        },
	        prevIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-prev-icon' })
	      );
	
	      var nextButton = _react2['default'].createElement(
	        'span',
	        {
	          onClick: next ? this.next : null,
	          unselectable: 'unselectable',
	          className: (0, _classnames6['default'])((_classnames2 = {}, (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-next', 1), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-btn-disabled', !next), (0, _defineProperty3['default'])(_classnames2, prefixCls + '-tab-arrow-show', showNextPrev), _classnames2))
	        },
	        nextIcon || _react2['default'].createElement('span', { className: prefixCls + '-tab-next-icon' })
	      );
	
	      var navClassName = prefixCls + '-nav';
	      var navClasses = (0, _classnames6['default'])((_classnames3 = {}, (0, _defineProperty3['default'])(_classnames3, navClassName, true), (0, _defineProperty3['default'])(_classnames3, scrollAnimated ? navClassName + '-animated' : navClassName + '-no-animated', true), _classnames3));
	
	      return _react2['default'].createElement(
	        'div',
	        {
	          className: (0, _classnames6['default'])((_classnames4 = {}, (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container', 1), (0, _defineProperty3['default'])(_classnames4, prefixCls + '-nav-container-scrolling', showNextPrev), _classnames4)),
	          key: 'container',
	          ref: this.props.saveRef('container')
	        },
	        prevButton,
	        nextButton,
	        _react2['default'].createElement(
	          'div',
	          { className: prefixCls + '-nav-wrap', ref: this.props.saveRef('navWrap') },
	          _react2['default'].createElement(
	            'div',
	            { className: prefixCls + '-nav-scroll' },
	            _react2['default'].createElement(
	              'div',
	              { className: navClasses, ref: this.props.saveRef('nav') },
	              navWrapper(this.props.children)
	            )
	          )
	        )
	      );
	    }
	  }]);
	  return ScrollableTabBarNode;
	}(_react2['default'].Component);
	
	exports['default'] = ScrollableTabBarNode;
	
	
	ScrollableTabBarNode.propTypes = {
	  activeKey: _propTypes2['default'].string,
	  getRef: _propTypes2['default'].func.isRequired,
	  saveRef: _propTypes2['default'].func.isRequired,
	  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
	  prefixCls: _propTypes2['default'].string,
	  scrollAnimated: _propTypes2['default'].bool,
	  onPrevClick: _propTypes2['default'].func,
	  onNextClick: _propTypes2['default'].func,
	  navWrapper: _propTypes2['default'].func,
	  children: _propTypes2['default'].node,
	  prevIcon: _propTypes2['default'].node,
	  nextIcon: _propTypes2['default'].node,
	  direction: _propTypes2['default'].node
	};
	
	ScrollableTabBarNode.defaultProps = {
	  tabBarPosition: 'left',
	  prefixCls: '',
	  scrollAnimated: true,
	  onPrevClick: function onPrevClick() {},
	  onNextClick: function onNextClick() {},
	  navWrapper: function navWrapper(ele) {
	    return ele;
	  }
	};
	module.exports = exports['default'];

/***/ },
/* 2740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _utils = __webpack_require__(220);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabBarRootNode = function (_React$Component) {
	  (0, _inherits3['default'])(TabBarRootNode, _React$Component);
	
	  function TabBarRootNode() {
	    (0, _classCallCheck3['default'])(this, TabBarRootNode);
	    return (0, _possibleConstructorReturn3['default'])(this, (TabBarRootNode.__proto__ || Object.getPrototypeOf(TabBarRootNode)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(TabBarRootNode, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          prefixCls = _props.prefixCls,
	          onKeyDown = _props.onKeyDown,
	          className = _props.className,
	          extraContent = _props.extraContent,
	          style = _props.style,
	          tabBarPosition = _props.tabBarPosition,
	          children = _props.children,
	          restProps = (0, _objectWithoutProperties3['default'])(_props, ['prefixCls', 'onKeyDown', 'className', 'extraContent', 'style', 'tabBarPosition', 'children']);
	
	      var cls = (0, _classnames3['default'])(prefixCls + '-bar', (0, _defineProperty3['default'])({}, className, !!className));
	      var topOrBottom = tabBarPosition === 'top' || tabBarPosition === 'bottom';
	      var tabBarExtraContentStyle = topOrBottom ? { float: 'right' } : {};
	      var extraContentStyle = extraContent && extraContent.props ? extraContent.props.style : {};
	      var newChildren = children;
	      if (extraContent) {
	        newChildren = [(0, _react.cloneElement)(extraContent, {
	          key: 'extra',
	          style: (0, _extends3['default'])({}, tabBarExtraContentStyle, extraContentStyle)
	        }), (0, _react.cloneElement)(children, { key: 'content' })];
	        newChildren = topOrBottom ? newChildren : newChildren.reverse();
	      }
	      return _react2['default'].createElement(
	        'div',
	        (0, _extends3['default'])({
	          role: 'tablist',
	          className: cls,
	          tabIndex: '0',
	          ref: this.props.saveRef('root'),
	          onKeyDown: onKeyDown,
	          style: style
	        }, (0, _utils.getDataAttr)(restProps)),
	        newChildren
	      );
	    }
	  }]);
	  return TabBarRootNode;
	}(_react2['default'].Component);
	
	exports['default'] = TabBarRootNode;
	
	
	TabBarRootNode.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  tabBarPosition: _propTypes2['default'].oneOf(['left', 'right', 'top', 'bottom']),
	  children: _propTypes2['default'].node,
	  extraContent: _propTypes2['default'].node,
	  onKeyDown: _propTypes2['default'].func,
	  saveRef: _propTypes2['default'].func
	};
	
	TabBarRootNode.defaultProps = {
	  prefixCls: '',
	  className: '',
	  style: {},
	  tabBarPosition: 'top',
	  extraContent: null,
	  children: null,
	  onKeyDown: function onKeyDown() {},
	  saveRef: function saveRef() {}
	};
	module.exports = exports['default'];

/***/ },
/* 2741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _warning = __webpack_require__(94);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _utils = __webpack_require__(220);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TabBarTabsNode = function (_React$Component) {
	  (0, _inherits3['default'])(TabBarTabsNode, _React$Component);
	
	  function TabBarTabsNode() {
	    (0, _classCallCheck3['default'])(this, TabBarTabsNode);
	    return (0, _possibleConstructorReturn3['default'])(this, (TabBarTabsNode.__proto__ || Object.getPrototypeOf(TabBarTabsNode)).apply(this, arguments));
	  }
	
	  (0, _createClass3['default'])(TabBarTabsNode, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.panels,
	          activeKey = _props.activeKey,
	          prefixCls = _props.prefixCls,
	          tabBarGutter = _props.tabBarGutter,
	          saveRef = _props.saveRef,
	          tabBarPosition = _props.tabBarPosition,
	          renderTabBarNode = _props.renderTabBarNode,
	          direction = _props.direction;
	
	      var rst = [];
	
	      _react2['default'].Children.forEach(children, function (child, index) {
	        if (!child) {
	          return;
	        }
	        var key = child.key;
	        var cls = activeKey === key ? prefixCls + '-tab-active' : '';
	        cls += ' ' + prefixCls + '-tab';
	        var events = {};
	        if (child.props.disabled) {
	          cls += ' ' + prefixCls + '-tab-disabled';
	        } else {
	          events = {
	            onClick: _this2.props.onTabClick.bind(_this2, key)
	          };
	        }
	        var ref = {};
	        if (activeKey === key) {
	          ref.ref = saveRef('activeTab');
	        }
	
	        var gutter = tabBarGutter && index === children.length - 1 ? 0 : tabBarGutter;
	
	        var marginProperty = direction === 'rtl' ? 'marginLeft' : 'marginRight';
	        var style = (0, _defineProperty3['default'])({}, (0, _utils.isVertical)(tabBarPosition) ? 'marginBottom' : marginProperty, gutter);
	        (0, _warning2['default'])('tab' in child.props, 'There must be `tab` property on children of Tabs.');
	
	        var node = _react2['default'].createElement(
	          'div',
	          (0, _extends3['default'])({
	            role: 'tab',
	            'aria-disabled': child.props.disabled ? 'true' : 'false',
	            'aria-selected': activeKey === key ? 'true' : 'false'
	          }, events, {
	            className: cls,
	            key: key,
	            style: style
	          }, ref),
	          child.props.tab
	        );
	
	        if (renderTabBarNode) {
	          node = renderTabBarNode(node);
	        }
	
	        rst.push(node);
	      });
	
	      return _react2['default'].createElement(
	        'div',
	        { ref: saveRef('navTabsContainer') },
	        rst
	      );
	    }
	  }]);
	  return TabBarTabsNode;
	}(_react2['default'].Component);
	
	exports['default'] = TabBarTabsNode;
	
	
	TabBarTabsNode.propTypes = {
	  activeKey: _propTypes2['default'].string,
	  panels: _propTypes2['default'].node,
	  prefixCls: _propTypes2['default'].string,
	  tabBarGutter: _propTypes2['default'].number,
	  onTabClick: _propTypes2['default'].func,
	  saveRef: _propTypes2['default'].func,
	  renderTabBarNode: _propTypes2['default'].func,
	  tabBarPosition: _propTypes2['default'].string,
	  direction: _propTypes2['default'].string
	};
	
	TabBarTabsNode.defaultProps = {
	  panels: [],
	  prefixCls: [],
	  tabBarGutter: null,
	  onTabClick: function onTabClick() {},
	  saveRef: function saveRef() {}
	};
	module.exports = exports['default'];

/***/ },
/* 2742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames2 = __webpack_require__(20);
	
	var _classnames3 = _interopRequireDefault(_classnames2);
	
	var _raf = __webpack_require__(127);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _KeyCode = __webpack_require__(2736);
	
	var _KeyCode2 = _interopRequireDefault(_KeyCode);
	
	var _TabPane = __webpack_require__(1108);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	var _utils = __webpack_require__(220);
	
	var _Sentinel = __webpack_require__(1106);
	
	var _Sentinel2 = _interopRequireDefault(_Sentinel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function getDefaultActiveKey(props) {
	  var activeKey = void 0;
	  _react2['default'].Children.forEach(props.children, function (child) {
	    if (child && !activeKey && !child.props.disabled) {
	      activeKey = child.key;
	    }
	  });
	  return activeKey;
	}
	
	function activeKeyIsValid(props, key) {
	  var keys = _react2['default'].Children.map(props.children, function (child) {
	    return child && child.key;
	  });
	  return keys.indexOf(key) >= 0;
	}
	
	var Tabs = function (_React$Component) {
	  (0, _inherits3['default'])(Tabs, _React$Component);
	
	  function Tabs(props) {
	    (0, _classCallCheck3['default'])(this, Tabs);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, (Tabs.__proto__ || Object.getPrototypeOf(Tabs)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var activeKey = void 0;
	    if ('activeKey' in props) {
	      activeKey = props.activeKey;
	    } else if ('defaultActiveKey' in props) {
	      activeKey = props.defaultActiveKey;
	    } else {
	      activeKey = getDefaultActiveKey(props);
	    }
	
	    _this.state = {
	      activeKey: activeKey
	    };
	    return _this;
	  }
	
	  (0, _createClass3['default'])(Tabs, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.destroy = true;
	      _raf2['default'].cancel(this.sentinelId);
	    }
	
	    // Sentinel for tab index
	
	  }, {
	    key: 'updateSentinelContext',
	    value: function updateSentinelContext() {
	      var _this2 = this;
	
	      if (this.destroy) return;
	
	      _raf2['default'].cancel(this.sentinelId);
	      this.sentinelId = (0, _raf2['default'])(function () {
	        if (_this2.destroy) return;
	        _this2.forceUpdate();
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classnames;
	
	      var props = this.props;
	      var prefixCls = props.prefixCls,
	          navWrapper = props.navWrapper,
	          tabBarPosition = props.tabBarPosition,
	          className = props.className,
	          renderTabContent = props.renderTabContent,
	          renderTabBar = props.renderTabBar,
	          destroyInactiveTabPane = props.destroyInactiveTabPane,
	          direction = props.direction,
	          restProps = (0, _objectWithoutProperties3['default'])(props, ['prefixCls', 'navWrapper', 'tabBarPosition', 'className', 'renderTabContent', 'renderTabBar', 'destroyInactiveTabPane', 'direction']);
	
	      var cls = (0, _classnames3['default'])((_classnames = {}, (0, _defineProperty3['default'])(_classnames, prefixCls, 1), (0, _defineProperty3['default'])(_classnames, prefixCls + '-' + tabBarPosition, 1), (0, _defineProperty3['default'])(_classnames, className, !!className), (0, _defineProperty3['default'])(_classnames, prefixCls + '-rtl', direction === 'rtl'), _classnames));
	
	      this.tabBar = renderTabBar();
	
	      var tabBar = _react2['default'].cloneElement(this.tabBar, {
	        prefixCls: prefixCls,
	        navWrapper: navWrapper,
	        key: 'tabBar',
	        onKeyDown: this.onNavKeyDown,
	        tabBarPosition: tabBarPosition,
	        onTabClick: this.onTabClick,
	        panels: props.children,
	        activeKey: this.state.activeKey,
	        direction: this.props.direction
	      });
	
	      var tabContent = _react2['default'].cloneElement(renderTabContent(), {
	        prefixCls: prefixCls,
	        tabBarPosition: tabBarPosition,
	        activeKey: this.state.activeKey,
	        destroyInactiveTabPane: destroyInactiveTabPane,
	        children: props.children,
	        onChange: this.setActiveKey,
	        key: 'tabContent',
	        direction: this.props.direction
	      });
	
	      var sentinelStart = _react2['default'].createElement(_Sentinel2['default'], {
	        key: 'sentinelStart',
	        setRef: this.setSentinelStart,
	        nextElement: this.panelSentinelStart
	      });
	      var sentinelEnd = _react2['default'].createElement(_Sentinel2['default'], {
	        key: 'sentinelEnd',
	        setRef: this.setSentinelEnd,
	        prevElement: this.panelSentinelEnd
	      });
	
	      var contents = [];
	      if (tabBarPosition === 'bottom') {
	        contents.push(sentinelStart, tabContent, sentinelEnd, tabBar);
	      } else {
	        contents.push(tabBar, sentinelStart, tabContent, sentinelEnd);
	      }
	
	      return _react2['default'].createElement(
	        _Sentinel.SentinelProvider,
	        {
	          value: {
	            sentinelStart: this.sentinelStart,
	            sentinelEnd: this.sentinelEnd,
	            setPanelSentinelStart: this.setPanelSentinelStart,
	            setPanelSentinelEnd: this.setPanelSentinelEnd
	          }
	        },
	        _react2['default'].createElement(
	          'div',
	          (0, _extends3['default'])({
	            className: cls,
	            style: props.style
	          }, (0, _utils.getDataAttr)(restProps), {
	            onScroll: this.onScroll
	          }),
	          contents
	        )
	      );
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(props, state) {
	      var newState = {};
	      if ('activeKey' in props) {
	        newState.activeKey = props.activeKey;
	      } else if (!activeKeyIsValid(props, state.activeKey)) {
	        newState.activeKey = getDefaultActiveKey(props);
	      }
	      if (Object.keys(newState).length > 0) {
	        return newState;
	      }
	      return null;
	    }
	  }]);
	  return Tabs;
	}(_react2['default'].Component);
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onTabClick = function (activeKey, e) {
	    if (_this3.tabBar.props.onTabClick) {
	      _this3.tabBar.props.onTabClick(activeKey, e);
	    }
	    _this3.setActiveKey(activeKey);
	  };
	
	  this.onNavKeyDown = function (e) {
	    var eventKeyCode = e.keyCode;
	    if (eventKeyCode === _KeyCode2['default'].RIGHT || eventKeyCode === _KeyCode2['default'].DOWN) {
	      e.preventDefault();
	      var nextKey = _this3.getNextActiveKey(true);
	      _this3.onTabClick(nextKey);
	    } else if (eventKeyCode === _KeyCode2['default'].LEFT || eventKeyCode === _KeyCode2['default'].UP) {
	      e.preventDefault();
	      var previousKey = _this3.getNextActiveKey(false);
	      _this3.onTabClick(previousKey);
	    }
	  };
	
	  this.onScroll = function (_ref) {
	    var target = _ref.target,
	        currentTarget = _ref.currentTarget;
	
	    if (target === currentTarget && target.scrollLeft > 0) {
	      target.scrollLeft = 0;
	    }
	  };
	
	  this.setSentinelStart = function (node) {
	    _this3.sentinelStart = node;
	  };
	
	  this.setSentinelEnd = function (node) {
	    _this3.sentinelEnd = node;
	  };
	
	  this.setPanelSentinelStart = function (node) {
	    if (node !== _this3.panelSentinelStart) {
	      _this3.updateSentinelContext();
	    }
	    _this3.panelSentinelStart = node;
	  };
	
	  this.setPanelSentinelEnd = function (node) {
	    if (node !== _this3.panelSentinelEnd) {
	      _this3.updateSentinelContext();
	    }
	    _this3.panelSentinelEnd = node;
	  };
	
	  this.setActiveKey = function (activeKey) {
	    if (_this3.state.activeKey !== activeKey) {
	      if (!('activeKey' in _this3.props)) {
	        _this3.setState({
	          activeKey: activeKey
	        });
	      }
	      _this3.props.onChange(activeKey);
	    }
	  };
	
	  this.getNextActiveKey = function (next) {
	    var activeKey = _this3.state.activeKey;
	    var children = [];
	    _react2['default'].Children.forEach(_this3.props.children, function (c) {
	      if (c && !c.props.disabled) {
	        if (next) {
	          children.push(c);
	        } else {
	          children.unshift(c);
	        }
	      }
	    });
	    var length = children.length;
	    var ret = length && children[0].key;
	    children.forEach(function (child, i) {
	      if (child.key === activeKey) {
	        if (i === length - 1) {
	          ret = children[0].key;
	        } else {
	          ret = children[i + 1].key;
	        }
	      }
	    });
	    return ret;
	  };
	};
	
	Tabs.propTypes = {
	  destroyInactiveTabPane: _propTypes2['default'].bool,
	  renderTabBar: _propTypes2['default'].func.isRequired,
	  renderTabContent: _propTypes2['default'].func.isRequired,
	  navWrapper: _propTypes2['default'].func,
	  onChange: _propTypes2['default'].func,
	  children: _propTypes2['default'].node,
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  tabBarPosition: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  activeKey: _propTypes2['default'].string,
	  defaultActiveKey: _propTypes2['default'].string,
	  direction: _propTypes2['default'].string
	};
	
	Tabs.defaultProps = {
	  prefixCls: 'rc-tabs',
	  destroyInactiveTabPane: false,
	  onChange: noop,
	  navWrapper: function navWrapper(arg) {
	    return arg;
	  },
	  tabBarPosition: 'top',
	  children: null,
	  style: {},
	  direction: 'ltr'
	};
	
	Tabs.TabPane = _TabPane2['default'];
	
	(0, _reactLifecyclesCompat.polyfill)(Tabs);
	
	exports['default'] = Tabs;
	module.exports = exports['default'];

/***/ },
/* 2743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.TabContent = exports.TabPane = undefined;
	
	var _Tabs = __webpack_require__(2742);
	
	var _Tabs2 = _interopRequireDefault(_Tabs);
	
	var _TabPane = __webpack_require__(1108);
	
	var _TabPane2 = _interopRequireDefault(_TabPane);
	
	var _TabContent = __webpack_require__(1107);
	
	var _TabContent2 = _interopRequireDefault(_TabContent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Tabs2['default'];
	exports.TabPane = _TabPane2['default'];
	exports.TabContent = _TabContent2['default'];

/***/ },
/* 2744 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _Select = _interopRequireDefault(__webpack_require__(2746));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var formatOption = function formatOption(option, disabledOptions) {
	  var value = "".concat(option);
	
	  if (option < 10) {
	    value = "0".concat(option);
	  }
	
	  var disabled = false;
	
	  if (disabledOptions && disabledOptions.indexOf(option) >= 0) {
	    disabled = true;
	  }
	
	  return {
	    value: value,
	    disabled: disabled
	  };
	};
	
	var Combobox =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Combobox, _Component);
	
	  function Combobox() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Combobox);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Combobox)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "onItemChange", function (type, itemValue) {
	      var _this$props = _this.props,
	          onChange = _this$props.onChange,
	          defaultOpenValue = _this$props.defaultOpenValue,
	          use12Hours = _this$props.use12Hours,
	          propValue = _this$props.value,
	          isAM = _this$props.isAM,
	          onAmPmChange = _this$props.onAmPmChange;
	      var value = (propValue || defaultOpenValue).clone();
	
	      if (type === 'hour') {
	        if (use12Hours) {
	          if (isAM) {
	            value.hour(+itemValue % 12);
	          } else {
	            value.hour(+itemValue % 12 + 12);
	          }
	        } else {
	          value.hour(+itemValue);
	        }
	      } else if (type === 'minute') {
	        value.minute(+itemValue);
	      } else if (type === 'ampm') {
	        var ampm = itemValue.toUpperCase();
	
	        if (use12Hours) {
	          if (ampm === 'PM' && value.hour() < 12) {
	            value.hour(value.hour() % 12 + 12);
	          }
	
	          if (ampm === 'AM') {
	            if (value.hour() >= 12) {
	              value.hour(value.hour() - 12);
	            }
	          }
	        }
	
	        onAmPmChange(ampm);
	      } else {
	        value.second(+itemValue);
	      }
	
	      onChange(value);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onEnterSelectPanel", function (range) {
	      var onCurrentSelectPanelChange = _this.props.onCurrentSelectPanelChange;
	      onCurrentSelectPanelChange(range);
	    });
	
	    return _this;
	  }
	
	  _createClass(Combobox, [{
	    key: "getHourSelect",
	    value: function getHourSelect(hour) {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          hourOptions = _this$props2.hourOptions,
	          disabledHours = _this$props2.disabledHours,
	          showHour = _this$props2.showHour,
	          use12Hours = _this$props2.use12Hours,
	          onEsc = _this$props2.onEsc;
	
	      if (!showHour) {
	        return null;
	      }
	
	      var disabledOptions = disabledHours();
	      var hourOptionsAdj;
	      var hourAdj;
	
	      if (use12Hours) {
	        hourOptionsAdj = [12].concat(hourOptions.filter(function (h) {
	          return h < 12 && h > 0;
	        }));
	        hourAdj = hour % 12 || 12;
	      } else {
	        hourOptionsAdj = hourOptions;
	        hourAdj = hour;
	      }
	
	      return _react["default"].createElement(_Select["default"], {
	        prefixCls: prefixCls,
	        options: hourOptionsAdj.map(function (option) {
	          return formatOption(option, disabledOptions);
	        }),
	        selectedIndex: hourOptionsAdj.indexOf(hourAdj),
	        type: "hour",
	        onSelect: this.onItemChange,
	        onMouseEnter: function onMouseEnter() {
	          return _this2.onEnterSelectPanel('hour');
	        },
	        onEsc: onEsc
	      });
	    }
	  }, {
	    key: "getMinuteSelect",
	    value: function getMinuteSelect(minute) {
	      var _this3 = this;
	
	      var _this$props3 = this.props,
	          prefixCls = _this$props3.prefixCls,
	          minuteOptions = _this$props3.minuteOptions,
	          disabledMinutes = _this$props3.disabledMinutes,
	          defaultOpenValue = _this$props3.defaultOpenValue,
	          showMinute = _this$props3.showMinute,
	          propValue = _this$props3.value,
	          onEsc = _this$props3.onEsc;
	
	      if (!showMinute) {
	        return null;
	      }
	
	      var value = propValue || defaultOpenValue;
	      var disabledOptions = disabledMinutes(value.hour());
	      return _react["default"].createElement(_Select["default"], {
	        prefixCls: prefixCls,
	        options: minuteOptions.map(function (option) {
	          return formatOption(option, disabledOptions);
	        }),
	        selectedIndex: minuteOptions.indexOf(minute),
	        type: "minute",
	        onSelect: this.onItemChange,
	        onMouseEnter: function onMouseEnter() {
	          return _this3.onEnterSelectPanel('minute');
	        },
	        onEsc: onEsc
	      });
	    }
	  }, {
	    key: "getSecondSelect",
	    value: function getSecondSelect(second) {
	      var _this4 = this;
	
	      var _this$props4 = this.props,
	          prefixCls = _this$props4.prefixCls,
	          secondOptions = _this$props4.secondOptions,
	          disabledSeconds = _this$props4.disabledSeconds,
	          showSecond = _this$props4.showSecond,
	          defaultOpenValue = _this$props4.defaultOpenValue,
	          propValue = _this$props4.value,
	          onEsc = _this$props4.onEsc;
	
	      if (!showSecond) {
	        return null;
	      }
	
	      var value = propValue || defaultOpenValue;
	      var disabledOptions = disabledSeconds(value.hour(), value.minute());
	      return _react["default"].createElement(_Select["default"], {
	        prefixCls: prefixCls,
	        options: secondOptions.map(function (option) {
	          return formatOption(option, disabledOptions);
	        }),
	        selectedIndex: secondOptions.indexOf(second),
	        type: "second",
	        onSelect: this.onItemChange,
	        onMouseEnter: function onMouseEnter() {
	          return _this4.onEnterSelectPanel('second');
	        },
	        onEsc: onEsc
	      });
	    }
	  }, {
	    key: "getAMPMSelect",
	    value: function getAMPMSelect() {
	      var _this5 = this;
	
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          use12Hours = _this$props5.use12Hours,
	          format = _this$props5.format,
	          isAM = _this$props5.isAM,
	          onEsc = _this$props5.onEsc;
	
	      if (!use12Hours) {
	        return null;
	      }
	
	      var AMPMOptions = ['am', 'pm'] // If format has A char, then we should uppercase AM/PM
	      .map(function (c) {
	        return format.match(/\sA/) ? c.toUpperCase() : c;
	      }).map(function (c) {
	        return {
	          value: c
	        };
	      });
	      var selected = isAM ? 0 : 1;
	      return _react["default"].createElement(_Select["default"], {
	        prefixCls: prefixCls,
	        options: AMPMOptions,
	        selectedIndex: selected,
	        type: "ampm",
	        onSelect: this.onItemChange,
	        onMouseEnter: function onMouseEnter() {
	          return _this5.onEnterSelectPanel('ampm');
	        },
	        onEsc: onEsc
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          prefixCls = _this$props6.prefixCls,
	          defaultOpenValue = _this$props6.defaultOpenValue,
	          propValue = _this$props6.value;
	      var value = propValue || defaultOpenValue;
	      return _react["default"].createElement("div", {
	        className: "".concat(prefixCls, "-combobox")
	      }, this.getHourSelect(value.hour()), this.getMinuteSelect(value.minute()), this.getSecondSelect(value.second()), this.getAMPMSelect(value.hour()));
	    }
	  }]);
	
	  return Combobox;
	}(_react.Component);
	
	_defineProperty(Combobox, "propTypes", {
	  format: _propTypes["default"].string,
	  defaultOpenValue: _propTypes["default"].object,
	  prefixCls: _propTypes["default"].string,
	  value: _propTypes["default"].object,
	  onChange: _propTypes["default"].func,
	  onAmPmChange: _propTypes["default"].func,
	  showHour: _propTypes["default"].bool,
	  showMinute: _propTypes["default"].bool,
	  showSecond: _propTypes["default"].bool,
	  hourOptions: _propTypes["default"].array,
	  minuteOptions: _propTypes["default"].array,
	  secondOptions: _propTypes["default"].array,
	  disabledHours: _propTypes["default"].func,
	  disabledMinutes: _propTypes["default"].func,
	  disabledSeconds: _propTypes["default"].func,
	  onCurrentSelectPanelChange: _propTypes["default"].func,
	  use12Hours: _propTypes["default"].bool,
	  onEsc: _propTypes["default"].func,
	  isAM: _propTypes["default"].bool
	});
	
	var _default = Combobox;
	exports["default"] = _default;

/***/ },
/* 2745 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _moment = _interopRequireDefault(__webpack_require__(3));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Header =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Header, _Component);
	
	  function Header(props) {
	    var _this;
	
	    _classCallCheck(this, Header);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Header).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "onInputChange", function (event) {
	      var str = event.target.value;
	
	      _this.setState({
	        str: str
	      });
	
	      var _this$props = _this.props,
	          format = _this$props.format,
	          hourOptions = _this$props.hourOptions,
	          minuteOptions = _this$props.minuteOptions,
	          secondOptions = _this$props.secondOptions,
	          disabledHours = _this$props.disabledHours,
	          disabledMinutes = _this$props.disabledMinutes,
	          disabledSeconds = _this$props.disabledSeconds,
	          onChange = _this$props.onChange;
	
	      if (str) {
	        var originalValue = _this.props.value;
	
	        var value = _this.getProtoValue().clone();
	
	        var parsed = (0, _moment["default"])(str, format, true);
	
	        if (!parsed.isValid()) {
	          _this.setState({
	            invalid: true
	          });
	
	          return;
	        }
	
	        value.hour(parsed.hour()).minute(parsed.minute()).second(parsed.second()); // if time value not allowed, response warning.
	
	        if (hourOptions.indexOf(value.hour()) < 0 || minuteOptions.indexOf(value.minute()) < 0 || secondOptions.indexOf(value.second()) < 0) {
	          _this.setState({
	            invalid: true
	          });
	
	          return;
	        } // if time value is disabled, response warning.
	
	
	        var disabledHourOptions = disabledHours();
	        var disabledMinuteOptions = disabledMinutes(value.hour());
	        var disabledSecondOptions = disabledSeconds(value.hour(), value.minute());
	
	        if (disabledHourOptions && disabledHourOptions.indexOf(value.hour()) >= 0 || disabledMinuteOptions && disabledMinuteOptions.indexOf(value.minute()) >= 0 || disabledSecondOptions && disabledSecondOptions.indexOf(value.second()) >= 0) {
	          _this.setState({
	            invalid: true
	          });
	
	          return;
	        }
	
	        if (originalValue) {
	          if (originalValue.hour() !== value.hour() || originalValue.minute() !== value.minute() || originalValue.second() !== value.second()) {
	            // keep other fields for rc-calendar
	            var changedValue = originalValue.clone();
	            changedValue.hour(value.hour());
	            changedValue.minute(value.minute());
	            changedValue.second(value.second());
	            onChange(changedValue);
	          }
	        } else if (originalValue !== value) {
	          onChange(value);
	        }
	      } else {
	        onChange(null);
	      }
	
	      _this.setState({
	        invalid: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
	      var _this$props2 = _this.props,
	          onEsc = _this$props2.onEsc,
	          onKeyDown = _this$props2.onKeyDown;
	
	      if (e.keyCode === 27) {
	        onEsc();
	      }
	
	      onKeyDown(e);
	    });
	
	    var _value = props.value,
	        _format = props.format;
	    _this.state = {
	      str: _value && _value.format(_format) || '',
	      invalid: false
	    };
	    return _this;
	  }
	
	  _createClass(Header, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var focusOnOpen = this.props.focusOnOpen;
	
	      if (focusOnOpen) {
	        // Wait one frame for the panel to be positioned before focusing
	        var requestAnimationFrame = window.requestAnimationFrame || window.setTimeout;
	        requestAnimationFrame(function () {
	          _this2.refInput.focus();
	
	          _this2.refInput.select();
	        });
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this$props3 = this.props,
	          value = _this$props3.value,
	          format = _this$props3.format;
	
	      if (value !== prevProps.value) {
	        // eslint-disable-next-line react/no-did-update-set-state
	        this.setState({
	          str: value && value.format(format) || '',
	          invalid: false
	        });
	      }
	    }
	  }, {
	    key: "getProtoValue",
	    value: function getProtoValue() {
	      var _this$props4 = this.props,
	          value = _this$props4.value,
	          defaultOpenValue = _this$props4.defaultOpenValue;
	      return value || defaultOpenValue;
	    }
	  }, {
	    key: "getInput",
	    value: function getInput() {
	      var _this3 = this;
	
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          placeholder = _this$props5.placeholder,
	          inputReadOnly = _this$props5.inputReadOnly;
	      var _this$state = this.state,
	          invalid = _this$state.invalid,
	          str = _this$state.str;
	      var invalidClass = invalid ? "".concat(prefixCls, "-input-invalid") : '';
	      return _react["default"].createElement("input", {
	        className: (0, _classnames["default"])("".concat(prefixCls, "-input"), invalidClass),
	        ref: function ref(_ref) {
	          _this3.refInput = _ref;
	        },
	        onKeyDown: this.onKeyDown,
	        value: str,
	        placeholder: placeholder,
	        onChange: this.onInputChange,
	        readOnly: !!inputReadOnly
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prefixCls = this.props.prefixCls;
	      return _react["default"].createElement("div", {
	        className: "".concat(prefixCls, "-input-wrap")
	      }, this.getInput());
	    }
	  }]);
	
	  return Header;
	}(_react.Component);
	
	_defineProperty(Header, "propTypes", {
	  format: _propTypes["default"].string,
	  prefixCls: _propTypes["default"].string,
	  disabledDate: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  clearText: _propTypes["default"].string,
	  value: _propTypes["default"].object,
	  inputReadOnly: _propTypes["default"].bool,
	  hourOptions: _propTypes["default"].array,
	  minuteOptions: _propTypes["default"].array,
	  secondOptions: _propTypes["default"].array,
	  disabledHours: _propTypes["default"].func,
	  disabledMinutes: _propTypes["default"].func,
	  disabledSeconds: _propTypes["default"].func,
	  onChange: _propTypes["default"].func,
	  onEsc: _propTypes["default"].func,
	  defaultOpenValue: _propTypes["default"].object,
	  currentSelectPanel: _propTypes["default"].string,
	  focusOnOpen: _propTypes["default"].bool,
	  onKeyDown: _propTypes["default"].func,
	  clearIcon: _propTypes["default"].node
	});
	
	_defineProperty(Header, "defaultProps", {
	  inputReadOnly: false
	});
	
	var _default = Header;
	exports["default"] = _default;

/***/ },
/* 2746 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _raf = _interopRequireDefault(__webpack_require__(127));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var scrollTo = function scrollTo(element, to, duration) {
	  // jump to target if duration zero
	  if (duration <= 0) {
	    (0, _raf["default"])(function () {
	      element.scrollTop = to;
	    });
	    return;
	  }
	
	  var difference = to - element.scrollTop;
	  var perTick = difference / duration * 10;
	  (0, _raf["default"])(function () {
	    element.scrollTop += perTick;
	    if (element.scrollTop === to) return;
	    scrollTo(element, to, duration - 10);
	  });
	};
	
	var Select =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Select, _Component);
	
	  function Select() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Select)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      active: false
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSelect", function (value) {
	      var _this$props = _this.props,
	          onSelect = _this$props.onSelect,
	          type = _this$props.type;
	      onSelect(type, value);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleMouseEnter", function (e) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      _this.setState({
	        active: true
	      });
	
	      onMouseEnter(e);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleMouseLeave", function () {
	      _this.setState({
	        active: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "saveList", function (node) {
	      _this.list = node;
	    });
	
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // jump to selected option
	      this.scrollToSelected(0);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var selectedIndex = this.props.selectedIndex; // smooth scroll to selected option
	
	      if (prevProps.selectedIndex !== selectedIndex) {
	        this.scrollToSelected(120);
	      }
	    }
	  }, {
	    key: "getOptions",
	    value: function getOptions() {
	      var _this2 = this;
	
	      var _this$props2 = this.props,
	          options = _this$props2.options,
	          selectedIndex = _this$props2.selectedIndex,
	          prefixCls = _this$props2.prefixCls,
	          onEsc = _this$props2.onEsc;
	      return options.map(function (item, index) {
	        var _classNames;
	
	        var cls = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-select-option-selected"), selectedIndex === index), _defineProperty(_classNames, "".concat(prefixCls, "-select-option-disabled"), item.disabled), _classNames));
	        var onClick = item.disabled ? undefined : function () {
	          _this2.onSelect(item.value);
	        };
	
	        var onKeyDown = function onKeyDown(e) {
	          if (e.keyCode === 13) onClick();else if (e.keyCode === 27) onEsc();
	        };
	
	        return _react["default"].createElement("li", {
	          role: "button",
	          onClick: onClick,
	          className: cls,
	          key: index,
	          disabled: item.disabled,
	          tabIndex: "0",
	          onKeyDown: onKeyDown
	        }, item.value);
	      });
	    }
	  }, {
	    key: "scrollToSelected",
	    value: function scrollToSelected(duration) {
	      // move to selected item
	      var selectedIndex = this.props.selectedIndex;
	
	      var select = _reactDom["default"].findDOMNode(this);
	
	      var list = _reactDom["default"].findDOMNode(this.list);
	
	      if (!list) {
	        return;
	      }
	
	      var index = selectedIndex;
	
	      if (index < 0) {
	        index = 0;
	      }
	
	      var topOption = list.children[index];
	      var to = topOption.offsetTop;
	      scrollTo(select, to, duration);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props3 = this.props,
	          prefixCls = _this$props3.prefixCls,
	          options = _this$props3.options;
	      var active = this.state.active;
	
	      if (options.length === 0) {
	        return null;
	      }
	
	      var cls = (0, _classnames["default"])("".concat(prefixCls, "-select"), _defineProperty({}, "".concat(prefixCls, "-select-active"), active));
	      return _react["default"].createElement("div", {
	        className: cls,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave
	      }, _react["default"].createElement("ul", {
	        ref: this.saveList
	      }, this.getOptions()));
	    }
	  }]);
	
	  return Select;
	}(_react.Component);
	
	_defineProperty(Select, "propTypes", {
	  prefixCls: _propTypes["default"].string,
	  options: _propTypes["default"].array,
	  selectedIndex: _propTypes["default"].number,
	  type: _propTypes["default"].string,
	  onSelect: _propTypes["default"].func,
	  onMouseEnter: _propTypes["default"].func,
	  onEsc: _propTypes["default"].func
	});
	
	var _default = Select;
	exports["default"] = _default;

/***/ },
/* 2747 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _rcTrigger = _interopRequireDefault(__webpack_require__(185));
	
	var _moment = _interopRequireDefault(__webpack_require__(3));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _Panel = _interopRequireDefault(__webpack_require__(1109));
	
	var _placements = _interopRequireDefault(__webpack_require__(2748));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function noop() {}
	
	function refFn(field, component) {
	  this[field] = component;
	}
	
	var Picker =
	/*#__PURE__*/
	function (_Component) {
	  _inherits(Picker, _Component);
	
	  function Picker(props) {
	    var _this;
	
	    _classCallCheck(this, Picker);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Picker).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "onPanelChange", function (value) {
	      _this.setValue(value);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onAmPmChange", function (ampm) {
	      var onAmPmChange = _this.props.onAmPmChange;
	      onAmPmChange(ampm);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onClear", function (event) {
	      event.stopPropagation();
	
	      _this.setValue(null);
	
	      _this.setOpen(false);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onVisibleChange", function (open) {
	      _this.setOpen(open);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onEsc", function () {
	      _this.setOpen(false);
	
	      _this.focus();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
	      if (e.keyCode === 40) {
	        _this.setOpen(true);
	      }
	    });
	
	    _this.saveInputRef = refFn.bind(_assertThisInitialized(_this), 'picker');
	    _this.savePanelRef = refFn.bind(_assertThisInitialized(_this), 'panelInstance');
	
	    var defaultOpen = props.defaultOpen,
	        defaultValue = props.defaultValue,
	        _props$open = props.open,
	        _open = _props$open === void 0 ? defaultOpen : _props$open,
	        _props$value = props.value,
	        _value = _props$value === void 0 ? defaultValue : _props$value;
	
	    _this.state = {
	      open: _open,
	      value: _value
	    };
	    return _this;
	  }
	
	  _createClass(Picker, [{
	    key: "setValue",
	    value: function setValue(value) {
	      var onChange = this.props.onChange;
	
	      if (!('value' in this.props)) {
	        this.setState({
	          value: value
	        });
	      }
	
	      onChange(value);
	    }
	  }, {
	    key: "getFormat",
	    value: function getFormat() {
	      var _this$props = this.props,
	          format = _this$props.format,
	          showHour = _this$props.showHour,
	          showMinute = _this$props.showMinute,
	          showSecond = _this$props.showSecond,
	          use12Hours = _this$props.use12Hours;
	
	      if (format) {
	        return format;
	      }
	
	      if (use12Hours) {
	        var fmtString = [showHour ? 'h' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
	          return !!item;
	        }).join(':');
	        return fmtString.concat(' a');
	      }
	
	      return [showHour ? 'HH' : '', showMinute ? 'mm' : '', showSecond ? 'ss' : ''].filter(function (item) {
	        return !!item;
	      }).join(':');
	    }
	  }, {
	    key: "getPanelElement",
	    value: function getPanelElement() {
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          placeholder = _this$props2.placeholder,
	          disabledHours = _this$props2.disabledHours,
	          disabledMinutes = _this$props2.disabledMinutes,
	          disabledSeconds = _this$props2.disabledSeconds,
	          hideDisabledOptions = _this$props2.hideDisabledOptions,
	          inputReadOnly = _this$props2.inputReadOnly,
	          showHour = _this$props2.showHour,
	          showMinute = _this$props2.showMinute,
	          showSecond = _this$props2.showSecond,
	          defaultOpenValue = _this$props2.defaultOpenValue,
	          clearText = _this$props2.clearText,
	          addon = _this$props2.addon,
	          use12Hours = _this$props2.use12Hours,
	          focusOnOpen = _this$props2.focusOnOpen,
	          onKeyDown = _this$props2.onKeyDown,
	          hourStep = _this$props2.hourStep,
	          minuteStep = _this$props2.minuteStep,
	          secondStep = _this$props2.secondStep,
	          clearIcon = _this$props2.clearIcon;
	      var value = this.state.value;
	      return _react["default"].createElement(_Panel["default"], {
	        clearText: clearText,
	        prefixCls: "".concat(prefixCls, "-panel"),
	        ref: this.savePanelRef,
	        value: value,
	        inputReadOnly: inputReadOnly,
	        onChange: this.onPanelChange,
	        onAmPmChange: this.onAmPmChange,
	        defaultOpenValue: defaultOpenValue,
	        showHour: showHour,
	        showMinute: showMinute,
	        showSecond: showSecond,
	        onEsc: this.onEsc,
	        format: this.getFormat(),
	        placeholder: placeholder,
	        disabledHours: disabledHours,
	        disabledMinutes: disabledMinutes,
	        disabledSeconds: disabledSeconds,
	        hideDisabledOptions: hideDisabledOptions,
	        use12Hours: use12Hours,
	        hourStep: hourStep,
	        minuteStep: minuteStep,
	        secondStep: secondStep,
	        addon: addon,
	        focusOnOpen: focusOnOpen,
	        onKeyDown: onKeyDown,
	        clearIcon: clearIcon
	      });
	    }
	  }, {
	    key: "getPopupClassName",
	    value: function getPopupClassName() {
	      var _this$props3 = this.props,
	          showHour = _this$props3.showHour,
	          showMinute = _this$props3.showMinute,
	          showSecond = _this$props3.showSecond,
	          use12Hours = _this$props3.use12Hours,
	          prefixCls = _this$props3.prefixCls,
	          popupClassName = _this$props3.popupClassName;
	      var selectColumnCount = 0;
	
	      if (showHour) {
	        selectColumnCount += 1;
	      }
	
	      if (showMinute) {
	        selectColumnCount += 1;
	      }
	
	      if (showSecond) {
	        selectColumnCount += 1;
	      }
	
	      if (use12Hours) {
	        selectColumnCount += 1;
	      } // Keep it for old compatibility
	
	
	      return (0, _classnames["default"])(popupClassName, _defineProperty({}, "".concat(prefixCls, "-panel-narrow"), (!showHour || !showMinute || !showSecond) && !use12Hours), "".concat(prefixCls, "-panel-column-").concat(selectColumnCount));
	    }
	  }, {
	    key: "setOpen",
	    value: function setOpen(open) {
	      var _this$props4 = this.props,
	          onOpen = _this$props4.onOpen,
	          onClose = _this$props4.onClose;
	      var currentOpen = this.state.open;
	
	      if (currentOpen !== open) {
	        if (!('open' in this.props)) {
	          this.setState({
	            open: open
	          });
	        }
	
	        if (open) {
	          onOpen({
	            open: open
	          });
	        } else {
	          onClose({
	            open: open
	          });
	        }
	      }
	    }
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.picker.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.picker.blur();
	    }
	  }, {
	    key: "renderClearButton",
	    value: function renderClearButton() {
	      var _this2 = this;
	
	      var value = this.state.value;
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          allowEmpty = _this$props5.allowEmpty,
	          clearIcon = _this$props5.clearIcon,
	          clearText = _this$props5.clearText,
	          disabled = _this$props5.disabled;
	
	      if (!allowEmpty || !value || disabled) {
	        return null;
	      }
	
	      if (_react["default"].isValidElement(clearIcon)) {
	        var _ref = clearIcon.props || {},
	            _onClick = _ref.onClick;
	
	        return _react["default"].cloneElement(clearIcon, {
	          onClick: function onClick() {
	            if (_onClick) _onClick.apply(void 0, arguments);
	
	            _this2.onClear.apply(_this2, arguments);
	          }
	        });
	      }
	
	      return _react["default"].createElement("a", {
	        role: "button",
	        className: "".concat(prefixCls, "-clear"),
	        title: clearText,
	        onClick: this.onClear,
	        tabIndex: 0
	      }, clearIcon || _react["default"].createElement("i", {
	        className: "".concat(prefixCls, "-clear-icon")
	      }));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props6 = this.props,
	          prefixCls = _this$props6.prefixCls,
	          placeholder = _this$props6.placeholder,
	          placement = _this$props6.placement,
	          align = _this$props6.align,
	          id = _this$props6.id,
	          disabled = _this$props6.disabled,
	          transitionName = _this$props6.transitionName,
	          style = _this$props6.style,
	          className = _this$props6.className,
	          getPopupContainer = _this$props6.getPopupContainer,
	          name = _this$props6.name,
	          autoComplete = _this$props6.autoComplete,
	          onFocus = _this$props6.onFocus,
	          onBlur = _this$props6.onBlur,
	          autoFocus = _this$props6.autoFocus,
	          inputReadOnly = _this$props6.inputReadOnly,
	          inputIcon = _this$props6.inputIcon,
	          popupStyle = _this$props6.popupStyle;
	      var _this$state = this.state,
	          open = _this$state.open,
	          value = _this$state.value;
	      var popupClassName = this.getPopupClassName();
	      return _react["default"].createElement(_rcTrigger["default"], {
	        prefixCls: "".concat(prefixCls, "-panel"),
	        popupClassName: popupClassName,
	        popupStyle: popupStyle,
	        popup: this.getPanelElement(),
	        popupAlign: align,
	        builtinPlacements: _placements["default"],
	        popupPlacement: placement,
	        action: disabled ? [] : ['click'],
	        destroyPopupOnHide: true,
	        getPopupContainer: getPopupContainer,
	        popupTransitionName: transitionName,
	        popupVisible: open,
	        onPopupVisibleChange: this.onVisibleChange
	      }, _react["default"].createElement("span", {
	        className: (0, _classnames["default"])(prefixCls, className),
	        style: style
	      }, _react["default"].createElement("input", {
	        className: "".concat(prefixCls, "-input"),
	        ref: this.saveInputRef,
	        type: "text",
	        placeholder: placeholder,
	        name: name,
	        onKeyDown: this.onKeyDown,
	        disabled: disabled,
	        value: value && value.format(this.getFormat()) || '',
	        autoComplete: autoComplete,
	        onFocus: onFocus,
	        onBlur: onBlur,
	        autoFocus: autoFocus,
	        onChange: noop,
	        readOnly: !!inputReadOnly,
	        id: id
	      }), inputIcon || _react["default"].createElement("span", {
	        className: "".concat(prefixCls, "-icon")
	      }), this.renderClearButton()));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, state) {
	      var newState = {};
	
	      if ('value' in props) {
	        newState.value = props.value;
	      }
	
	      if (props.open !== undefined) {
	        newState.open = props.open;
	      }
	
	      return Object.keys(newState).length > 0 ? _objectSpread({}, state, {}, newState) : null;
	    }
	  }]);
	
	  return Picker;
	}(_react.Component);
	
	_defineProperty(Picker, "propTypes", {
	  prefixCls: _propTypes["default"].string,
	  clearText: _propTypes["default"].string,
	  value: _propTypes["default"].object,
	  defaultOpenValue: _propTypes["default"].object,
	  inputReadOnly: _propTypes["default"].bool,
	  disabled: _propTypes["default"].bool,
	  allowEmpty: _propTypes["default"].bool,
	  defaultValue: _propTypes["default"].object,
	  open: _propTypes["default"].bool,
	  defaultOpen: _propTypes["default"].bool,
	  align: _propTypes["default"].object,
	  placement: _propTypes["default"].any,
	  transitionName: _propTypes["default"].string,
	  getPopupContainer: _propTypes["default"].func,
	  placeholder: _propTypes["default"].string,
	  format: _propTypes["default"].string,
	  showHour: _propTypes["default"].bool,
	  showMinute: _propTypes["default"].bool,
	  showSecond: _propTypes["default"].bool,
	  style: _propTypes["default"].object,
	  className: _propTypes["default"].string,
	  popupClassName: _propTypes["default"].string,
	  popupStyle: _propTypes["default"].object,
	  disabledHours: _propTypes["default"].func,
	  disabledMinutes: _propTypes["default"].func,
	  disabledSeconds: _propTypes["default"].func,
	  hideDisabledOptions: _propTypes["default"].bool,
	  onChange: _propTypes["default"].func,
	  onAmPmChange: _propTypes["default"].func,
	  onOpen: _propTypes["default"].func,
	  onClose: _propTypes["default"].func,
	  onFocus: _propTypes["default"].func,
	  onBlur: _propTypes["default"].func,
	  addon: _propTypes["default"].func,
	  name: _propTypes["default"].string,
	  autoComplete: _propTypes["default"].string,
	  use12Hours: _propTypes["default"].bool,
	  hourStep: _propTypes["default"].number,
	  minuteStep: _propTypes["default"].number,
	  secondStep: _propTypes["default"].number,
	  focusOnOpen: _propTypes["default"].bool,
	  onKeyDown: _propTypes["default"].func,
	  autoFocus: _propTypes["default"].bool,
	  id: _propTypes["default"].string,
	  inputIcon: _propTypes["default"].node,
	  clearIcon: _propTypes["default"].node
	});
	
	_defineProperty(Picker, "defaultProps", {
	  clearText: 'clear',
	  prefixCls: 'rc-time-picker',
	  defaultOpen: false,
	  inputReadOnly: false,
	  style: {},
	  className: '',
	  popupClassName: '',
	  popupStyle: {},
	  align: {},
	  defaultOpenValue: (0, _moment["default"])(),
	  allowEmpty: true,
	  showHour: true,
	  showMinute: true,
	  showSecond: true,
	  disabledHours: noop,
	  disabledMinutes: noop,
	  disabledSeconds: noop,
	  hideDisabledOptions: false,
	  placement: 'bottomLeft',
	  onChange: noop,
	  onAmPmChange: noop,
	  onOpen: noop,
	  onClose: noop,
	  onFocus: noop,
	  onBlur: noop,
	  addon: noop,
	  use12Hours: false,
	  focusOnOpen: false,
	  onKeyDown: noop
	});
	
	(0, _reactLifecyclesCompat.polyfill)(Picker);
	var _default = Picker;
	exports["default"] = _default;

/***/ },
/* 2748 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var autoAdjustOverflow = {
	  adjustX: 1,
	  adjustY: 1
	};
	var targetOffset = [0, 0];
	var placements = {
	  bottomLeft: {
	    points: ['tl', 'tl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -3],
	    targetOffset: targetOffset
	  },
	  bottomRight: {
	    points: ['tr', 'tr'],
	    overflow: autoAdjustOverflow,
	    offset: [0, -3],
	    targetOffset: targetOffset
	  },
	  topRight: {
	    points: ['br', 'br'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 3],
	    targetOffset: targetOffset
	  },
	  topLeft: {
	    points: ['bl', 'bl'],
	    overflow: autoAdjustOverflow,
	    offset: [0, 3],
	    targetOffset: targetOffset
	  }
	};
	var _default = placements;
	exports["default"] = _default;

/***/ },
/* 2749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Content = function (_React$Component) {
	  (0, _inherits3['default'])(Content, _React$Component);
	
	  function Content() {
	    (0, _classCallCheck3['default'])(this, Content);
	    return (0, _possibleConstructorReturn3['default'])(this, _React$Component.apply(this, arguments));
	  }
	
	  Content.prototype.componentDidUpdate = function componentDidUpdate() {
	    var trigger = this.props.trigger;
	
	    if (trigger) {
	      trigger.forcePopupAlign();
	    }
	  };
	
	  Content.prototype.render = function render() {
	    var _props = this.props,
	        overlay = _props.overlay,
	        prefixCls = _props.prefixCls,
	        id = _props.id;
	
	    return _react2['default'].createElement(
	      'div',
	      { className: prefixCls + '-inner', id: id, role: 'tooltip' },
	      typeof overlay === 'function' ? overlay() : overlay
	    );
	  };
	
	  return Content;
	}(_react2['default'].Component);
	
	Content.propTypes = {
	  prefixCls: _propTypes2['default'].string,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  id: _propTypes2['default'].string,
	  trigger: _propTypes2['default'].any
	};
	exports['default'] = Content;
	module.exports = exports['default'];

/***/ },
/* 2750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _rcTrigger = __webpack_require__(185);
	
	var _rcTrigger2 = _interopRequireDefault(_rcTrigger);
	
	var _placements = __webpack_require__(1110);
	
	var _Content = __webpack_require__(2749);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Tooltip = function (_Component) {
	  (0, _inherits3['default'])(Tooltip, _Component);
	
	  function Tooltip() {
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getPopupElement = function () {
	      var _this$props = _this.props,
	          arrowContent = _this$props.arrowContent,
	          overlay = _this$props.overlay,
	          prefixCls = _this$props.prefixCls,
	          id = _this$props.id;
	
	      return [_react2['default'].createElement(
	        'div',
	        { className: prefixCls + '-arrow', key: 'arrow' },
	        arrowContent
	      ), _react2['default'].createElement(_Content2['default'], {
	        key: 'content',
	        trigger: _this.trigger,
	        prefixCls: prefixCls,
	        id: id,
	        overlay: overlay
	      })];
	    }, _this.saveTrigger = function (node) {
	      _this.trigger = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  Tooltip.prototype.getPopupDomNode = function getPopupDomNode() {
	    return this.trigger.getPopupDomNode();
	  };
	
	  Tooltip.prototype.render = function render() {
	    var _props = this.props,
	        overlayClassName = _props.overlayClassName,
	        trigger = _props.trigger,
	        mouseEnterDelay = _props.mouseEnterDelay,
	        mouseLeaveDelay = _props.mouseLeaveDelay,
	        overlayStyle = _props.overlayStyle,
	        prefixCls = _props.prefixCls,
	        children = _props.children,
	        onVisibleChange = _props.onVisibleChange,
	        afterVisibleChange = _props.afterVisibleChange,
	        transitionName = _props.transitionName,
	        animation = _props.animation,
	        placement = _props.placement,
	        align = _props.align,
	        destroyTooltipOnHide = _props.destroyTooltipOnHide,
	        defaultVisible = _props.defaultVisible,
	        getTooltipContainer = _props.getTooltipContainer,
	        restProps = (0, _objectWithoutProperties3['default'])(_props, ['overlayClassName', 'trigger', 'mouseEnterDelay', 'mouseLeaveDelay', 'overlayStyle', 'prefixCls', 'children', 'onVisibleChange', 'afterVisibleChange', 'transitionName', 'animation', 'placement', 'align', 'destroyTooltipOnHide', 'defaultVisible', 'getTooltipContainer']);
	
	    var extraProps = (0, _extends3['default'])({}, restProps);
	    if ('visible' in this.props) {
	      extraProps.popupVisible = this.props.visible;
	    }
	    return _react2['default'].createElement(
	      _rcTrigger2['default'],
	      (0, _extends3['default'])({
	        popupClassName: overlayClassName,
	        ref: this.saveTrigger,
	        prefixCls: prefixCls,
	        popup: this.getPopupElement,
	        action: trigger,
	        builtinPlacements: _placements.placements,
	        popupPlacement: placement,
	        popupAlign: align,
	        getPopupContainer: getTooltipContainer,
	        onPopupVisibleChange: onVisibleChange,
	        afterPopupVisibleChange: afterVisibleChange,
	        popupTransitionName: transitionName,
	        popupAnimation: animation,
	        defaultPopupVisible: defaultVisible,
	        destroyPopupOnHide: destroyTooltipOnHide,
	        mouseLeaveDelay: mouseLeaveDelay,
	        popupStyle: overlayStyle,
	        mouseEnterDelay: mouseEnterDelay
	      }, extraProps),
	      children
	    );
	  };
	
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.propTypes = {
	  trigger: _propTypes2['default'].any,
	  children: _propTypes2['default'].any,
	  defaultVisible: _propTypes2['default'].bool,
	  visible: _propTypes2['default'].bool,
	  placement: _propTypes2['default'].string,
	  transitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  animation: _propTypes2['default'].any,
	  onVisibleChange: _propTypes2['default'].func,
	  afterVisibleChange: _propTypes2['default'].func,
	  overlay: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  overlayStyle: _propTypes2['default'].object,
	  overlayClassName: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  getTooltipContainer: _propTypes2['default'].func,
	  destroyTooltipOnHide: _propTypes2['default'].bool,
	  align: _propTypes2['default'].object,
	  arrowContent: _propTypes2['default'].any,
	  id: _propTypes2['default'].string
	};
	Tooltip.defaultProps = {
	  prefixCls: 'rc-tooltip',
	  mouseEnterDelay: 0,
	  destroyTooltipOnHide: false,
	  mouseLeaveDelay: 0.1,
	  align: {},
	  placement: 'right',
	  trigger: ['hover'],
	  arrowContent: null
	};
	exports['default'] = Tooltip;
	module.exports = exports['default'];

/***/ },
/* 2751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Tooltip = __webpack_require__(2750);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Tooltip2['default'];
	module.exports = exports['default'];

/***/ },
/* 2752 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _BasePopup = _interopRequireDefault(__webpack_require__(563));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _BasePopup["default"];
	exports["default"] = _default;

/***/ },
/* 2753 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _BasePopup = _interopRequireDefault(__webpack_require__(563));
	
	var _SearchInput = _interopRequireDefault(__webpack_require__(1111));
	
	var _util = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var SinglePopup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(SinglePopup, _React$Component);
	
	  function SinglePopup() {
	    var _this;
	
	    _classCallCheck(this, SinglePopup);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SinglePopup).call(this));
	
	    _defineProperty(_assertThisInitialized(_this), "onPlaceholderClick", function () {
	      _this.inputRef.current.focus();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "getTree", function () {
	      return _this.popupRef.current && _this.popupRef.current.getTree();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderPlaceholder", function () {
	      var _this$props = _this.props,
	          searchPlaceholder = _this$props.searchPlaceholder,
	          searchValue = _this$props.searchValue,
	          prefixCls = _this$props.prefixCls;
	
	      if (!searchPlaceholder) {
	        return null;
	      }
	
	      return _react["default"].createElement("span", {
	        style: {
	          display: searchValue ? 'none' : 'block'
	        },
	        onClick: _this.onPlaceholderClick,
	        className: "".concat(prefixCls, "-search__field__placeholder")
	      }, searchPlaceholder);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderSearch", function () {
	      var _this$props2 = _this.props,
	          showSearch = _this$props2.showSearch,
	          dropdownPrefixCls = _this$props2.dropdownPrefixCls;
	
	      if (!showSearch) {
	        return null;
	      }
	
	      return _react["default"].createElement("span", {
	        ref: _this.searchRef,
	        className: "".concat(dropdownPrefixCls, "-search")
	      }, _react["default"].createElement(_SearchInput["default"], _extends({}, _this.props, {
	        ref: _this.inputRef,
	        renderPlaceholder: _this.renderPlaceholder
	      })));
	    });
	
	    _this.inputRef = (0, _util.createRef)();
	    _this.searchRef = (0, _util.createRef)();
	    _this.popupRef = (0, _util.createRef)();
	    return _this;
	  }
	
	  _createClass(SinglePopup, [{
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement(_BasePopup["default"], _extends({
	        ref: this.popupRef
	      }, this.props, {
	        renderSearch: this.renderSearch
	      }));
	    }
	  }]);
	
	  return SinglePopup;
	}(_react["default"].Component);
	
	_defineProperty(SinglePopup, "propTypes", _objectSpread({}, _BasePopup["default"].propTypes, {
	  searchValue: _propTypes["default"].string,
	  showSearch: _propTypes["default"].bool,
	  dropdownPrefixCls: _propTypes["default"].string,
	  disabled: _propTypes["default"].bool,
	  searchPlaceholder: _propTypes["default"].string
	}));
	
	var _default = SinglePopup;
	exports["default"] = _default;

/***/ },
/* 2754 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = __webpack_require__(23);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _KeyCode = _interopRequireDefault(__webpack_require__(71));
	
	var _shallowequal = _interopRequireDefault(__webpack_require__(79));
	
	var _raf = _interopRequireDefault(__webpack_require__(127));
	
	var _domScrollIntoView = _interopRequireDefault(__webpack_require__(281));
	
	var _SelectTrigger = _interopRequireDefault(__webpack_require__(2755));
	
	var _BaseSelector = __webpack_require__(564);
	
	var _BasePopup = __webpack_require__(563);
	
	var _SingleSelector = _interopRequireDefault(__webpack_require__(2759));
	
	var _MultipleSelector = _interopRequireWildcard(__webpack_require__(2758));
	
	var _SinglePopup = _interopRequireDefault(__webpack_require__(2753));
	
	var _MultiplePopup = _interopRequireDefault(__webpack_require__(2752));
	
	var _strategies = __webpack_require__(565);
	
	var _util = __webpack_require__(144);
	
	var _propTypes2 = __webpack_require__(1113);
	
	var _SelectNode = _interopRequireDefault(__webpack_require__(1112));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }
	
	function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Select =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Select, _React$Component);
	
	  function Select(_props) {
	    var _this;
	
	    _classCallCheck(this, Select);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Select).call(this, _props));
	
	    _defineProperty(_assertThisInitialized(_this), "onSelectorFocus", function () {
	      _this.setState({
	        focused: true
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSelectorBlur", function () {
	      _this.setState({
	        focused: false
	      }); // TODO: Close when Popup is also not focused
	      // this.setState({ open: false });
	
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onComponentKeyDown", function (event) {
	      var open = _this.state.open;
	      var keyCode = event.keyCode;
	
	      if (!open) {
	        if ([_KeyCode["default"].ENTER, _KeyCode["default"].DOWN].indexOf(keyCode) !== -1) {
	          _this.setOpenState(true);
	        }
	      } else if (_KeyCode["default"].ESC === keyCode) {
	        _this.setOpenState(false);
	      } else if ([_KeyCode["default"].UP, _KeyCode["default"].DOWN, _KeyCode["default"].LEFT, _KeyCode["default"].RIGHT].indexOf(keyCode) !== -1) {
	        // TODO: Handle `open` state
	        event.stopPropagation();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDeselect", function (wrappedValue, node, nodeEventInfo) {
	      var onDeselect = _this.props.onDeselect;
	      if (!onDeselect) return;
	      onDeselect(wrappedValue, node, nodeEventInfo);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSelectorClear", function (event) {
	      var disabled = _this.props.disabled;
	      if (disabled) return;
	
	      _this.triggerChange([], []);
	
	      if (!_this.isSearchValueControlled()) {
	        _this.setUncontrolledState({
	          searchValue: '',
	          filteredTreeNodes: null
	        });
	      }
	
	      event.stopPropagation();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onMultipleSelectorRemove", function (event, removeValue) {
	      event.stopPropagation();
	      var _this$state = _this.state,
	          valueList = _this$state.valueList,
	          missValueList = _this$state.missValueList,
	          valueEntities = _this$state.valueEntities;
	      var _this$props = _this.props,
	          treeCheckable = _this$props.treeCheckable,
	          treeCheckStrictly = _this$props.treeCheckStrictly,
	          treeNodeLabelProp = _this$props.treeNodeLabelProp,
	          disabled = _this$props.disabled;
	      if (disabled) return; // Find trigger entity
	
	      var triggerEntity = valueEntities[removeValue]; // Clean up value
	
	      var newValueList = valueList;
	
	      if (triggerEntity) {
	        // If value is in tree
	        if (treeCheckable && !treeCheckStrictly) {
	          newValueList = valueList.filter(function (_ref) {
	            var value = _ref.value;
	            var entity = valueEntities[value];
	            return !(0, _util.isPosRelated)(entity.pos, triggerEntity.pos);
	          });
	        } else {
	          newValueList = valueList.filter(function (_ref2) {
	            var value = _ref2.value;
	            return value !== removeValue;
	          });
	        }
	      }
	
	      var triggerNode = triggerEntity ? triggerEntity.node : null;
	      var extraInfo = {
	        triggerValue: removeValue,
	        triggerNode: triggerNode
	      };
	      var deselectInfo = {
	        node: triggerNode
	      }; // [Legacy] Little hack on this to make same action as `onCheck` event.
	
	      if (treeCheckable) {
	        var filteredEntityList = newValueList.map(function (_ref3) {
	          var value = _ref3.value;
	          return valueEntities[value];
	        });
	        deselectInfo.event = 'check';
	        deselectInfo.checked = false;
	        deselectInfo.checkedNodes = filteredEntityList.map(function (_ref4) {
	          var node = _ref4.node;
	          return node;
	        });
	        deselectInfo.checkedNodesPositions = filteredEntityList.map(function (_ref5) {
	          var node = _ref5.node,
	              pos = _ref5.pos;
	          return {
	            node: node,
	            pos: pos
	          };
	        });
	
	        if (treeCheckStrictly) {
	          extraInfo.allCheckedNodes = deselectInfo.checkedNodes;
	        } else {
	          // TODO: It's too expansive to get `halfCheckedKeys` in onDeselect. Not pass this.
	          extraInfo.allCheckedNodes = (0, _util.flatToHierarchy)(filteredEntityList).map(function (_ref6) {
	            var node = _ref6.node;
	            return node;
	          });
	        }
	      } else {
	        deselectInfo.event = 'select';
	        deselectInfo.selected = false;
	        deselectInfo.selectedNodes = newValueList.map(function (_ref7) {
	          var value = _ref7.value;
	          return (valueEntities[value] || {}).node;
	        });
	      } // Some value user pass prop is not in the tree, we also need clean it
	
	
	      var newMissValueList = missValueList.filter(function (_ref8) {
	        var value = _ref8.value;
	        return value !== removeValue;
	      });
	      var wrappedValue;
	
	      if (_this.isLabelInValue()) {
	        wrappedValue = {
	          label: triggerNode ? triggerNode.props[treeNodeLabelProp] : null,
	          value: removeValue
	        };
	      } else {
	        wrappedValue = removeValue;
	      }
	
	      _this.onDeselect(wrappedValue, triggerNode, deselectInfo);
	
	      _this.triggerChange(newMissValueList, newValueList, extraInfo);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onValueTrigger", function (isAdd, nodeList, nodeEventInfo, nodeExtraInfo) {
	      var node = nodeEventInfo.node;
	      var value = node.props.value;
	      var _this$state2 = _this.state,
	          missValueList = _this$state2.missValueList,
	          valueEntities = _this$state2.valueEntities,
	          keyEntities = _this$state2.keyEntities,
	          searchValue = _this$state2.searchValue;
	      var _this$props2 = _this.props,
	          disabled = _this$props2.disabled,
	          inputValue = _this$props2.inputValue,
	          treeNodeLabelProp = _this$props2.treeNodeLabelProp,
	          onSelect = _this$props2.onSelect,
	          onSearch = _this$props2.onSearch,
	          multiple = _this$props2.multiple,
	          treeCheckable = _this$props2.treeCheckable,
	          treeCheckStrictly = _this$props2.treeCheckStrictly,
	          autoClearSearchValue = _this$props2.autoClearSearchValue;
	      var label = node.props[treeNodeLabelProp];
	      if (disabled) return; // Wrap the return value for user
	
	      var wrappedValue;
	
	      if (_this.isLabelInValue()) {
	        wrappedValue = {
	          value: value,
	          label: label
	        };
	      } else {
	        wrappedValue = value;
	      } // [Legacy] Origin code not trigger `onDeselect` every time. Let's align the behaviour.
	
	
	      if (isAdd) {
	        if (onSelect) {
	          onSelect(wrappedValue, node, nodeEventInfo);
	        }
	      } else {
	        _this.onDeselect(wrappedValue, node, nodeEventInfo);
	      } // Get wrapped value list.
	      // This is a bit hack cause we use key to match the value.
	
	
	      var newValueList = nodeList.map(function (_ref9) {
	        var props = _ref9.props;
	        return {
	          value: props.value,
	          label: props[treeNodeLabelProp]
	        };
	      }); // When is `treeCheckable` and with `searchValue`, `valueList` is not full filled.
	      // We need calculate the missing nodes.
	
	      if (treeCheckable && !treeCheckStrictly) {
	        var keyList = newValueList.map(function (_ref10) {
	          var val = _ref10.value;
	          return valueEntities[val].key;
	        });
	
	        if (isAdd) {
	          keyList = (0, _util.conductCheck)(keyList, true, keyEntities).checkedKeys;
	        } else {
	          keyList = (0, _util.conductCheck)([valueEntities[value].key], false, keyEntities, {
	            checkedKeys: keyList
	          }).checkedKeys;
	        }
	
	        newValueList = keyList.map(function (key) {
	          var props = keyEntities[key].node.props;
	          return {
	            value: props.value,
	            label: props[treeNodeLabelProp]
	          };
	        });
	      } // Clean up `searchValue` when this prop is set
	
	
	      if (autoClearSearchValue || inputValue === null) {
	        // Clean state `searchValue` if uncontrolled
	        if (!_this.isSearchValueControlled() && (multiple || treeCheckable)) {
	          _this.setUncontrolledState({
	            searchValue: '',
	            filteredTreeNodes: null
	          });
	        } // Trigger onSearch if `searchValue` to be empty.
	        // We should also trigger onSearch with empty string here
	        // since if user use `treeExpandedKeys`, it need user have the ability to reset it.
	
	
	        if (onSearch && searchValue && searchValue.length) {
	          onSearch('');
	        }
	      } // [Legacy] Provide extra info
	
	
	      var extraInfo = _objectSpread({}, nodeExtraInfo, {
	        triggerValue: value,
	        triggerNode: node
	      });
	
	      _this.triggerChange(missValueList, newValueList, extraInfo);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTreeNodeSelect", function (_, nodeEventInfo) {
	      var _this$state3 = _this.state,
	          valueList = _this$state3.valueList,
	          valueEntities = _this$state3.valueEntities;
	      var _this$props3 = _this.props,
	          treeCheckable = _this$props3.treeCheckable,
	          multiple = _this$props3.multiple;
	      if (treeCheckable) return;
	
	      if (!multiple) {
	        _this.setOpenState(false);
	      }
	
	      var isAdd = nodeEventInfo.selected;
	      var selectedValue = nodeEventInfo.node.props.value;
	      var newValueList;
	
	      if (!multiple) {
	        newValueList = [{
	          value: selectedValue
	        }];
	      } else {
	        newValueList = valueList.filter(function (_ref11) {
	          var value = _ref11.value;
	          return value !== selectedValue;
	        });
	
	        if (isAdd) {
	          newValueList.push({
	            value: selectedValue
	          });
	        }
	      }
	
	      var selectedNodes = newValueList.map(function (_ref12) {
	        var value = _ref12.value;
	        return valueEntities[value];
	      }).filter(function (entity) {
	        return entity;
	      }).map(function (_ref13) {
	        var node = _ref13.node;
	        return node;
	      });
	
	      _this.onValueTrigger(isAdd, selectedNodes, nodeEventInfo, {
	        selected: isAdd
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTreeNodeCheck", function (_, nodeEventInfo) {
	      var _this$state4 = _this.state,
	          searchValue = _this$state4.searchValue,
	          keyEntities = _this$state4.keyEntities,
	          valueEntities = _this$state4.valueEntities,
	          valueList = _this$state4.valueList;
	      var treeCheckStrictly = _this.props.treeCheckStrictly;
	      var checkedNodes = nodeEventInfo.checkedNodes,
	          checkedNodesPositions = nodeEventInfo.checkedNodesPositions;
	      var isAdd = nodeEventInfo.checked;
	      var extraInfo = {
	        checked: isAdd
	      };
	      var checkedNodeList = checkedNodes; // [Legacy] Check event provide `allCheckedNodes`.
	      // When `treeCheckStrictly` or internal `searchValue` is set, TreeNode will be unrelated:
	      // - Related: Show the top checked nodes and has children prop.
	      // - Unrelated: Show all the checked nodes.
	
	      if (searchValue) {
	        var oriKeyList = valueList.map(function (_ref14) {
	          var value = _ref14.value;
	          return valueEntities[value];
	        }).filter(function (entity) {
	          return entity;
	        }).map(function (_ref15) {
	          var key = _ref15.key;
	          return key;
	        });
	        var keyList;
	
	        if (isAdd) {
	          keyList = Array.from(new Set([].concat(_toConsumableArray(oriKeyList), _toConsumableArray(checkedNodeList.map(function (_ref16) {
	            var value = _ref16.props.value;
	            return valueEntities[value].key;
	          })))));
	        } else {
	          keyList = (0, _util.conductCheck)([nodeEventInfo.node.props.eventKey], false, keyEntities, {
	            checkedKeys: oriKeyList
	          }).checkedKeys;
	        }
	
	        checkedNodeList = keyList.map(function (key) {
	          return keyEntities[key].node;
	        }); // Let's follow as not `treeCheckStrictly` format
	
	        extraInfo.allCheckedNodes = keyList.map(function (key) {
	          return (0, _util.cleanEntity)(keyEntities[key]);
	        });
	      } else if (treeCheckStrictly) {
	        extraInfo.allCheckedNodes = nodeEventInfo.checkedNodes;
	      } else {
	        extraInfo.allCheckedNodes = (0, _util.flatToHierarchy)(checkedNodesPositions);
	      }
	
	      _this.onValueTrigger(isAdd, checkedNodeList, nodeEventInfo, extraInfo);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDropdownVisibleChange", function (open) {
	      var _this$props4 = _this.props,
	          multiple = _this$props4.multiple,
	          treeCheckable = _this$props4.treeCheckable;
	      var searchValue = _this.state.searchValue; // When set open success and single mode,
	      // we will reset the input content.
	
	      if (open && !multiple && !treeCheckable && searchValue) {
	        _this.setUncontrolledState({
	          searchValue: '',
	          filteredTreeNodes: null
	        });
	      }
	
	      _this.setOpenState(open, true);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSearchInputChange", function (_ref17) {
	      var value = _ref17.target.value;
	      var _this$state5 = _this.state,
	          treeNodes = _this$state5.treeNodes,
	          valueEntities = _this$state5.valueEntities;
	      var _this$props5 = _this.props,
	          onSearch = _this$props5.onSearch,
	          filterTreeNode = _this$props5.filterTreeNode,
	          treeNodeFilterProp = _this$props5.treeNodeFilterProp;
	
	      if (onSearch) {
	        onSearch(value);
	      }
	
	      var isSet = false;
	
	      if (!_this.isSearchValueControlled()) {
	        isSet = _this.setUncontrolledState({
	          searchValue: value
	        });
	
	        _this.setOpenState(true);
	      }
	
	      if (isSet) {
	        // Do the search logic
	        var upperSearchValue = String(value).toUpperCase();
	        var filterTreeNodeFn = filterTreeNode;
	
	        if (filterTreeNode === false) {
	          // Don't filter if is false
	          filterTreeNodeFn = function filterTreeNodeFn() {
	            return true;
	          };
	        } else if (typeof filterTreeNodeFn !== 'function') {
	          // When is not function (true or undefined), use inner filter
	          filterTreeNodeFn = function filterTreeNodeFn(_, node) {
	            var nodeValue = String(node.props[treeNodeFilterProp]).toUpperCase();
	            return nodeValue.indexOf(upperSearchValue) !== -1;
	          };
	        }
	
	        _this.setState({
	          filteredTreeNodes: (0, _util.getFilterTree)(treeNodes, value, filterTreeNodeFn, valueEntities, _SelectNode["default"])
	        });
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSearchInputKeyDown", function (event) {
	      var _this$state6 = _this.state,
	          searchValue = _this$state6.searchValue,
	          valueList = _this$state6.valueList;
	      var keyCode = event.keyCode;
	
	      if (_KeyCode["default"].BACKSPACE === keyCode && _this.isMultiple() && !searchValue && valueList.length) {
	        var lastValue = valueList[valueList.length - 1].value;
	
	        _this.onMultipleSelectorRemove(event, lastValue);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onChoiceAnimationLeave", function () {
	      (0, _raf["default"])(function () {
	        _this.forcePopupAlign();
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setPopupRef", function (popup) {
	      _this.popup = popup;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setUncontrolledState", function (state) {
	      var needSync = false;
	      var newState = {};
	      Object.keys(state).forEach(function (name) {
	        if (name in _this.props) return;
	        needSync = true;
	        newState[name] = state[name];
	      });
	
	      if (needSync) {
	        _this.setState(newState);
	      }
	
	      return needSync;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "setOpenState", function (open) {
	      var byTrigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var onDropdownVisibleChange = _this.props.onDropdownVisibleChange;
	
	      if (onDropdownVisibleChange && onDropdownVisibleChange(open, {
	        documentClickClose: !open && byTrigger
	      }) === false) {
	        return;
	      }
	
	      _this.setUncontrolledState({
	        open: open
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "isMultiple", function () {
	      var _this$props6 = _this.props,
	          multiple = _this$props6.multiple,
	          treeCheckable = _this$props6.treeCheckable;
	      return !!(multiple || treeCheckable);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "isLabelInValue", function () {
	      return (0, _util.isLabelInValue)(_this.props);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "isSearchValueControlled", function () {
	      var inputValue = _this.props.inputValue;
	      if ('searchValue' in _this.props) return true;
	      return 'inputValue' in _this.props && inputValue !== null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "forcePopupAlign", function () {
	      var $trigger = _this.selectTriggerRef.current;
	
	      if ($trigger) {
	        $trigger.forcePopupAlign();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "delayForcePopupAlign", function () {
	      // Wait 2 frame to avoid dom update & dom algin in the same time
	      // https://github.com/ant-design/ant-design/issues/12031
	      (0, _raf["default"])(function () {
	        (0, _raf["default"])(_this.forcePopupAlign);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "triggerChange", function (missValueList, valueList) {
	      var extraInfo = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	      var _this$state7 = _this.state,
	          valueEntities = _this$state7.valueEntities,
	          searchValue = _this$state7.searchValue,
	          prevSelectorValueList = _this$state7.selectorValueList;
	      var _this$props7 = _this.props,
	          onChange = _this$props7.onChange,
	          disabled = _this$props7.disabled,
	          treeCheckable = _this$props7.treeCheckable,
	          treeCheckStrictly = _this$props7.treeCheckStrictly;
	      if (disabled) return; // Trigger
	
	      var extra = _objectSpread({
	        // [Legacy] Always return as array contains label & value
	        preValue: prevSelectorValueList.map(function (_ref18) {
	          var label = _ref18.label,
	              value = _ref18.value;
	          return {
	            label: label,
	            value: value
	          };
	        })
	      }, extraInfo); // Format value by `treeCheckStrictly`
	
	
	      var selectorValueList = (0, _util.formatSelectorValue)(valueList, _this.props, valueEntities);
	
	      if (!('value' in _this.props)) {
	        var newState = {
	          missValueList: missValueList,
	          valueList: valueList,
	          selectorValueList: selectorValueList
	        };
	
	        if (searchValue && treeCheckable && !treeCheckStrictly) {
	          newState.searchHalfCheckedKeys = (0, _util.getHalfCheckedKeys)(valueList, valueEntities);
	        }
	
	        _this.setState(newState);
	      } // Only do the logic when `onChange` function provided
	
	
	      if (onChange) {
	        var connectValueList; // Get value by mode
	
	        if (_this.isMultiple()) {
	          connectValueList = [].concat(_toConsumableArray(missValueList), _toConsumableArray(selectorValueList));
	        } else {
	          connectValueList = selectorValueList.slice(0, 1);
	        }
	
	        var labelList = null;
	        var returnValue;
	
	        if (_this.isLabelInValue()) {
	          returnValue = connectValueList.map(function (_ref19) {
	            var label = _ref19.label,
	                value = _ref19.value;
	            return {
	              label: label,
	              value: value
	            };
	          });
	        } else {
	          labelList = [];
	          returnValue = connectValueList.map(function (_ref20) {
	            var label = _ref20.label,
	                value = _ref20.value;
	            labelList.push(label);
	            return value;
	          });
	        }
	
	        if (!_this.isMultiple()) {
	          returnValue = returnValue[0];
	        }
	
	        onChange(returnValue, labelList, extra);
	      }
	    });
	
	    var prefixAria = _props.prefixAria,
	        defaultOpen = _props.defaultOpen,
	        _open = _props.open;
	    _this.state = {
	      open: _open || defaultOpen,
	      valueList: [],
	      searchHalfCheckedKeys: [],
	      missValueList: [],
	      // Contains the value not in the tree
	      selectorValueList: [],
	      // Used for multiple selector
	      valueEntities: {},
	      keyEntities: {},
	      searchValue: '',
	      init: true
	    };
	    _this.selectorRef = (0, _util.createRef)();
	    _this.selectTriggerRef = (0, _util.createRef)(); // ARIA need `aria-controls` props mapping
	    // Since this need user input. Let's generate ourselves
	
	    _this.ariaId = (0, _util.generateAriaId)("".concat(prefixAria, "-list"));
	    return _this;
	  }
	
	  _createClass(Select, [{
	    key: "getChildContext",
	    value: function getChildContext() {
	      return {
	        rcTreeSelect: {
	          onSelectorFocus: this.onSelectorFocus,
	          onSelectorBlur: this.onSelectorBlur,
	          onSelectorKeyDown: this.onComponentKeyDown,
	          onSelectorClear: this.onSelectorClear,
	          onMultipleSelectorRemove: this.onMultipleSelectorRemove,
	          onTreeNodeSelect: this.onTreeNodeSelect,
	          onTreeNodeCheck: this.onTreeNodeCheck,
	          onPopupKeyDown: this.onComponentKeyDown,
	          onSearchInputChange: this.onSearchInputChange,
	          onSearchInputKeyDown: this.onSearchInputKeyDown
	        }
	      };
	    }
	  }, {
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      var _this$props8 = this.props,
	          autoFocus = _this$props8.autoFocus,
	          disabled = _this$props8.disabled;
	
	      if (autoFocus && !disabled) {
	        this.focus();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(_, prevState) {
	      var _this2 = this;
	
	      var prefixCls = this.props.prefixCls;
	      var _this$state8 = this.state,
	          valueList = _this$state8.valueList,
	          open = _this$state8.open,
	          selectorValueList = _this$state8.selectorValueList,
	          valueEntities = _this$state8.valueEntities;
	      var isMultiple = this.isMultiple();
	
	      if (prevState.valueList !== valueList) {
	        this.forcePopupAlign();
	      } // Scroll to value position, only need sync on single mode
	
	
	      if (!isMultiple && selectorValueList.length && !prevState.open && open && this.popup) {
	        var value = selectorValueList[0].value;
	
	        var _this$popup$getTree = this.popup.getTree(),
	            domTreeNodes = _this$popup$getTree.domTreeNodes;
	
	        var _ref21 = valueEntities[value] || {},
	            key = _ref21.key;
	
	        var treeNode = domTreeNodes[key];
	
	        if (treeNode) {
	          var domNode = (0, _reactDom.findDOMNode)(treeNode);
	          (0, _raf["default"])(function () {
	            var popupNode = (0, _reactDom.findDOMNode)(_this2.popup);
	            var triggerContainer = (0, _util.findPopupContainer)(popupNode, "".concat(prefixCls, "-dropdown"));
	            var searchNode = _this2.popup.searchRef.current;
	
	            if (domNode && triggerContainer && searchNode) {
	              (0, _domScrollIntoView["default"])(domNode, triggerContainer, {
	                onlyScrollIfNeeded: true,
	                offsetTop: searchNode.offsetHeight
	              });
	            }
	          });
	        }
	      }
	    } // ==================== Selector ====================
	
	  }, {
	    key: "focus",
	    value: function focus() {
	      this.selectorRef.current.focus();
	    }
	  }, {
	    key: "blur",
	    value: function blur() {
	      this.selectorRef.current.blur();
	    } // ===================== Render =====================
	
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$state9 = this.state,
	          valueList = _this$state9.valueList,
	          missValueList = _this$state9.missValueList,
	          selectorValueList = _this$state9.selectorValueList,
	          searchHalfCheckedKeys = _this$state9.searchHalfCheckedKeys,
	          valueEntities = _this$state9.valueEntities,
	          keyEntities = _this$state9.keyEntities,
	          searchValue = _this$state9.searchValue,
	          open = _this$state9.open,
	          focused = _this$state9.focused,
	          treeNodes = _this$state9.treeNodes,
	          filteredTreeNodes = _this$state9.filteredTreeNodes;
	      var _this$props9 = this.props,
	          prefixCls = _this$props9.prefixCls,
	          treeExpandedKeys = _this$props9.treeExpandedKeys,
	          onTreeExpand = _this$props9.onTreeExpand;
	      var isMultiple = this.isMultiple();
	
	      var passProps = _objectSpread({}, this.props, {
	        isMultiple: isMultiple,
	        valueList: valueList,
	        searchHalfCheckedKeys: searchHalfCheckedKeys,
	        selectorValueList: [].concat(_toConsumableArray(missValueList), _toConsumableArray(selectorValueList)),
	        valueEntities: valueEntities,
	        keyEntities: keyEntities,
	        searchValue: searchValue,
	        upperSearchValue: (searchValue || '').toUpperCase(),
	        // Perf save
	        open: open,
	        focused: focused,
	        onChoiceAnimationLeave: this.onChoiceAnimationLeave,
	        dropdownPrefixCls: "".concat(prefixCls, "-dropdown"),
	        ariaId: this.ariaId
	      });
	
	      var Popup = isMultiple ? _MultiplePopup["default"] : _SinglePopup["default"];
	
	      var $popup = _react["default"].createElement(Popup, _extends({
	        ref: this.setPopupRef
	      }, passProps, {
	        onTreeExpanded: this.delayForcePopupAlign,
	        treeNodes: treeNodes,
	        filteredTreeNodes: filteredTreeNodes // Tree expanded control
	        ,
	        treeExpandedKeys: treeExpandedKeys,
	        onTreeExpand: onTreeExpand
	      }));
	
	      var Selector = isMultiple ? _MultipleSelector["default"] : _SingleSelector["default"];
	
	      var $selector = _react["default"].createElement(Selector, _extends({}, passProps, {
	        ref: this.selectorRef
	      }));
	
	      return _react["default"].createElement(_SelectTrigger["default"], _extends({}, passProps, {
	        ref: this.selectTriggerRef,
	        popupElement: $popup,
	        onKeyDown: this.onKeyDown,
	        onDropdownVisibleChange: this.onDropdownVisibleChange
	      }), $selector);
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var _prevState$prevProps = prevState.prevProps,
	          prevProps = _prevState$prevProps === void 0 ? {} : _prevState$prevProps;
	      var treeCheckable = nextProps.treeCheckable,
	          treeCheckStrictly = nextProps.treeCheckStrictly,
	          filterTreeNode = nextProps.filterTreeNode,
	          treeNodeFilterProp = nextProps.treeNodeFilterProp,
	          treeDataSimpleMode = nextProps.treeDataSimpleMode;
	      var newState = {
	        prevProps: nextProps,
	        init: false
	      }; // Process the state when props updated
	
	      function processState(propName, updater) {
	        if (prevProps[propName] !== nextProps[propName]) {
	          updater(nextProps[propName], prevProps[propName]);
	          return true;
	        }
	
	        return false;
	      }
	
	      var valueRefresh = false; // Open
	
	      processState('open', function (propValue) {
	        newState.open = propValue;
	      }); // Tree Nodes
	
	      var treeNodes;
	      var treeDataChanged = false;
	      var treeDataModeChanged = false;
	      processState('treeData', function (propValue) {
	        treeNodes = (0, _util.convertDataToTree)(propValue);
	        treeDataChanged = true;
	      });
	      processState('treeDataSimpleMode', function (propValue, prevValue) {
	        if (!propValue) return;
	        var prev = !prevValue || prevValue === true ? {} : prevValue; // Shallow equal to avoid dynamic prop object
	
	        if (!(0, _shallowequal["default"])(propValue, prev)) {
	          treeDataModeChanged = true;
	        }
	      }); // Parse by `treeDataSimpleMode`
	
	      if (treeDataSimpleMode && (treeDataChanged || treeDataModeChanged)) {
	        var simpleMapper = _objectSpread({
	          id: 'id',
	          pId: 'pId',
	          rootPId: null
	        }, treeDataSimpleMode !== true ? treeDataSimpleMode : {});
	
	        treeNodes = (0, _util.convertDataToTree)((0, _util.parseSimpleTreeData)(nextProps.treeData, simpleMapper));
	      } // If `treeData` not provide, use children TreeNodes
	
	
	      if (!nextProps.treeData) {
	        processState('children', function (propValue) {
	          treeNodes = Array.isArray(propValue) ? propValue : [propValue];
	        });
	      } // Convert `treeData` to entities
	
	
	      if (treeNodes) {
	        var entitiesMap = (0, _util.convertTreeToEntities)(treeNodes);
	        newState.treeNodes = treeNodes;
	        newState.posEntities = entitiesMap.posEntities;
	        newState.valueEntities = entitiesMap.valueEntities;
	        newState.keyEntities = entitiesMap.keyEntities;
	        valueRefresh = true;
	      } // Value List
	
	
	      if (prevState.init) {
	        processState('defaultValue', function (propValue) {
	          newState.valueList = (0, _util.formatInternalValue)(propValue, nextProps);
	          valueRefresh = true;
	        });
	      }
	
	      processState('value', function (propValue) {
	        newState.valueList = (0, _util.formatInternalValue)(propValue, nextProps);
	        valueRefresh = true;
	      }); // Selector Value List
	
	      if (valueRefresh) {
	        // Find out that value not exist in the tree
	        var missValueList = [];
	        var filteredValueList = [];
	        var keyList = []; // Get latest value list
	
	        var latestValueList = newState.valueList;
	
	        if (!latestValueList) {
	          // Also need add prev missValueList to avoid new treeNodes contains the value
	          latestValueList = [].concat(_toConsumableArray(prevState.valueList), _toConsumableArray(prevState.missValueList));
	        } // Get key by value
	
	
	        var valueLabels = {};
	        latestValueList.forEach(function (wrapperValue) {
	          var value = wrapperValue.value,
	              label = wrapperValue.label;
	          var entity = (newState.valueEntities || prevState.valueEntities)[value];
	          valueLabels[value] = label;
	
	          if (entity) {
	            keyList.push(entity.key);
	            filteredValueList.push(wrapperValue);
	            return;
	          } // If not match, it may caused by ajax load. We need keep this
	
	
	          missValueList.push(wrapperValue);
	        }); // We need calculate the value when tree is checked tree
	
	        if (treeCheckable && !treeCheckStrictly) {
	          // Calculate the keys need to be checked
	          var _conductCheck = (0, _util.conductCheck)(keyList, true, newState.keyEntities || prevState.keyEntities),
	              checkedKeys = _conductCheck.checkedKeys; // Format value list again for internal usage
	
	
	          newState.valueList = checkedKeys.map(function (key) {
	            var val = (newState.keyEntities || prevState.keyEntities)[key].value;
	            var wrappedValue = {
	              value: val
	            };
	
	            if (valueLabels[val] !== undefined) {
	              wrappedValue.label = valueLabels[val];
	            }
	
	            return wrappedValue;
	          });
	        } else {
	          newState.valueList = filteredValueList;
	        } // Fill the missValueList, we still need display in the selector
	
	
	        newState.missValueList = missValueList; // Calculate the value list for `Selector` usage
	
	        newState.selectorValueList = (0, _util.formatSelectorValue)(newState.valueList, nextProps, newState.valueEntities || prevState.valueEntities);
	      } // [Legacy] To align with `Select` component,
	      // We use `searchValue` instead of `inputValue` but still keep the api
	      // `inputValue` support `null` to work as `autoClearSearchValue`
	
	
	      processState('inputValue', function (propValue) {
	        if (propValue !== null) {
	          newState.searchValue = propValue;
	        }
	      }); // Search value
	
	      processState('searchValue', function (propValue) {
	        newState.searchValue = propValue;
	      }); // Do the search logic
	
	      if (newState.searchValue !== undefined || prevState.searchValue && treeNodes) {
	        var searchValue = newState.searchValue !== undefined ? newState.searchValue : prevState.searchValue;
	        var upperSearchValue = String(searchValue).toUpperCase();
	        var filterTreeNodeFn = filterTreeNode;
	
	        if (filterTreeNode === false) {
	          // Don't filter if is false
	          filterTreeNodeFn = function filterTreeNodeFn() {
	            return true;
	          };
	        } else if (typeof filterTreeNodeFn !== 'function') {
	          // When is not function (true or undefined), use inner filter
	          filterTreeNodeFn = function filterTreeNodeFn(_, node) {
	            var nodeValue = String(node.props[treeNodeFilterProp]).toUpperCase();
	            return nodeValue.indexOf(upperSearchValue) !== -1;
	          };
	        }
	
	        newState.filteredTreeNodes = (0, _util.getFilterTree)(newState.treeNodes || prevState.treeNodes, searchValue, filterTreeNodeFn, newState.valueEntities || prevState.valueEntities, _SelectNode["default"]);
	      } // We should re-calculate the halfCheckedKeys when in search mode
	
	
	      if (valueRefresh && treeCheckable && !treeCheckStrictly && (newState.searchValue || prevState.searchValue)) {
	        newState.searchHalfCheckedKeys = (0, _util.getHalfCheckedKeys)(newState.valueList, newState.valueEntities || prevState.valueEntities);
	      } // Checked Strategy
	
	
	      processState('showCheckedStrategy', function () {
	        newState.selectorValueList = newState.selectorValueList || (0, _util.formatSelectorValue)(newState.valueList || prevState.valueList, nextProps, newState.valueEntities || prevState.valueEntities);
	      });
	      return newState;
	    }
	  }]);
	
	  return Select;
	}(_react["default"].Component);
	
	_defineProperty(Select, "propTypes", {
	  prefixCls: _propTypes["default"].string,
	  prefixAria: _propTypes["default"].string,
	  multiple: _propTypes["default"].bool,
	  showArrow: _propTypes["default"].bool,
	  open: _propTypes["default"].bool,
	  value: _propTypes2.valueProp,
	  autoFocus: _propTypes["default"].bool,
	  defaultOpen: _propTypes["default"].bool,
	  defaultValue: _propTypes2.valueProp,
	  showSearch: _propTypes["default"].bool,
	  placeholder: _propTypes["default"].node,
	  inputValue: _propTypes["default"].string,
	  // [Legacy] Deprecated. Use `searchValue` instead.
	  searchValue: _propTypes["default"].string,
	  autoClearSearchValue: _propTypes["default"].bool,
	  searchPlaceholder: _propTypes["default"].node,
	  // [Legacy] Confuse with placeholder
	  disabled: _propTypes["default"].bool,
	  children: _propTypes["default"].node,
	  labelInValue: _propTypes["default"].bool,
	  maxTagCount: _propTypes["default"].number,
	  maxTagPlaceholder: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
	  maxTagTextLength: _propTypes["default"].number,
	  showCheckedStrategy: _propTypes["default"].oneOf([_strategies.SHOW_ALL, _strategies.SHOW_PARENT, _strategies.SHOW_CHILD]),
	  dropdownMatchSelectWidth: _propTypes["default"].bool,
	  treeData: _propTypes["default"].array,
	  treeDataSimpleMode: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].object]),
	  treeNodeFilterProp: _propTypes["default"].string,
	  treeNodeLabelProp: _propTypes["default"].string,
	  treeCheckable: _propTypes["default"].oneOfType([_propTypes["default"].bool, _propTypes["default"].node]),
	  treeCheckStrictly: _propTypes["default"].bool,
	  treeIcon: _propTypes["default"].bool,
	  treeLine: _propTypes["default"].bool,
	  treeDefaultExpandAll: _propTypes["default"].bool,
	  treeDefaultExpandedKeys: _propTypes["default"].array,
	  treeExpandedKeys: _propTypes["default"].array,
	  loadData: _propTypes["default"].func,
	  filterTreeNode: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
	  notFoundContent: _propTypes["default"].node,
	  onSearch: _propTypes["default"].func,
	  onSelect: _propTypes["default"].func,
	  onDeselect: _propTypes["default"].func,
	  onChange: _propTypes["default"].func,
	  onDropdownVisibleChange: _propTypes["default"].func,
	  onTreeExpand: _propTypes["default"].func,
	  inputIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
	  clearIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
	  removeIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
	  switcherIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func])
	});
	
	_defineProperty(Select, "childContextTypes", {
	  rcTreeSelect: _propTypes["default"].shape(_objectSpread({}, _BaseSelector.selectorContextTypes, {}, _MultipleSelector.multipleSelectorContextTypes, {}, _BasePopup.popupContextTypes, {
	    onSearchInputChange: _propTypes["default"].func,
	    onSearchInputKeyDown: _propTypes["default"].func
	  }))
	});
	
	_defineProperty(Select, "defaultProps", {
	  prefixCls: 'rc-tree-select',
	  prefixAria: 'rc-tree-select',
	  showArrow: true,
	  showSearch: true,
	  autoClearSearchValue: true,
	  showCheckedStrategy: _strategies.SHOW_CHILD,
	  // dropdownMatchSelectWidth change the origin design, set to false now
	  // ref: https://github.com/react-component/select/blob/4cad95e098a341a09de239ad6981067188842020/src/Select.jsx#L344
	  // ref: https://github.com/react-component/select/pull/71
	  treeNodeFilterProp: 'value',
	  treeNodeLabelProp: 'title',
	  treeIcon: false,
	  notFoundContent: 'Not Found'
	});
	
	Select.TreeNode = _SelectNode["default"];
	Select.SHOW_ALL = _strategies.SHOW_ALL;
	Select.SHOW_PARENT = _strategies.SHOW_PARENT;
	Select.SHOW_CHILD = _strategies.SHOW_CHILD; // Let warning show correct component name
	
	Select.displayName = 'TreeSelect';
	(0, _reactLifecyclesCompat.polyfill)(Select);
	var _default = Select;
	exports["default"] = _default;

/***/ },
/* 2755 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _rcTrigger = _interopRequireDefault(__webpack_require__(2763));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _util = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var BUILT_IN_PLACEMENTS = {
	  bottomLeft: {
	    points: ['tl', 'bl'],
	    offset: [0, 4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    },
	    ignoreShake: true
	  },
	  topLeft: {
	    points: ['bl', 'tl'],
	    offset: [0, -4],
	    overflow: {
	      adjustX: 0,
	      adjustY: 1
	    },
	    ignoreShake: true
	  }
	};
	
	var SelectTrigger =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(SelectTrigger, _React$Component);
	
	  function SelectTrigger() {
	    var _this;
	
	    _classCallCheck(this, SelectTrigger);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectTrigger).call(this));
	
	    _defineProperty(_assertThisInitialized(_this), "getDropdownTransitionName", function () {
	      var _this$props = _this.props,
	          transitionName = _this$props.transitionName,
	          animation = _this$props.animation,
	          dropdownPrefixCls = _this$props.dropdownPrefixCls;
	
	      if (!transitionName && animation) {
	        return "".concat(dropdownPrefixCls, "-").concat(animation);
	      }
	
	      return transitionName;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "forcePopupAlign", function () {
	      var $trigger = _this.triggerRef.current;
	
	      if ($trigger) {
	        $trigger.forcePopupAlign();
	      }
	    });
	
	    _this.triggerRef = (0, _util.createRef)();
	    return _this;
	  }
	
	  _createClass(SelectTrigger, [{
	    key: "render",
	    value: function render() {
	      var _classNames;
	
	      var _this$props2 = this.props,
	          disabled = _this$props2.disabled,
	          isMultiple = _this$props2.isMultiple,
	          dropdownPopupAlign = _this$props2.dropdownPopupAlign,
	          dropdownMatchSelectWidth = _this$props2.dropdownMatchSelectWidth,
	          dropdownClassName = _this$props2.dropdownClassName,
	          dropdownStyle = _this$props2.dropdownStyle,
	          onDropdownVisibleChange = _this$props2.onDropdownVisibleChange,
	          getPopupContainer = _this$props2.getPopupContainer,
	          dropdownPrefixCls = _this$props2.dropdownPrefixCls,
	          popupElement = _this$props2.popupElement,
	          open = _this$props2.open,
	          children = _this$props2.children; // TODO: [Legacy] Use new action when trigger fixed: https://github.com/react-component/trigger/pull/86
	      // When false do nothing with the width
	      // ref: https://github.com/ant-design/ant-design/issues/10927
	
	      var stretch;
	
	      if (dropdownMatchSelectWidth !== false) {
	        stretch = dropdownMatchSelectWidth ? 'width' : 'minWidth';
	      }
	
	      return _react["default"].createElement(_rcTrigger["default"], {
	        ref: this.triggerRef,
	        action: disabled ? [] : ['click'],
	        popupPlacement: "bottomLeft",
	        builtinPlacements: BUILT_IN_PLACEMENTS,
	        popupAlign: dropdownPopupAlign,
	        prefixCls: dropdownPrefixCls,
	        popupTransitionName: this.getDropdownTransitionName(),
	        onPopupVisibleChange: onDropdownVisibleChange,
	        popup: popupElement,
	        popupVisible: open,
	        getPopupContainer: getPopupContainer,
	        stretch: stretch,
	        popupClassName: (0, _classnames["default"])(dropdownClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(dropdownPrefixCls, "--multiple"), isMultiple), _defineProperty(_classNames, "".concat(dropdownPrefixCls, "--single"), !isMultiple), _classNames)),
	        popupStyle: dropdownStyle
	      }, children);
	    }
	  }]);
	
	  return SelectTrigger;
	}(_react["default"].Component);
	
	_defineProperty(SelectTrigger, "propTypes", {
	  // Pass by outside user props
	  disabled: _propTypes["default"].bool,
	  showSearch: _propTypes["default"].bool,
	  prefixCls: _propTypes["default"].string,
	  dropdownPopupAlign: _propTypes["default"].object,
	  dropdownClassName: _propTypes["default"].string,
	  dropdownStyle: _propTypes["default"].object,
	  transitionName: _propTypes["default"].string,
	  animation: _propTypes["default"].string,
	  getPopupContainer: _propTypes["default"].func,
	  children: _propTypes["default"].node,
	  dropdownMatchSelectWidth: _propTypes["default"].bool,
	  // Pass by Select
	  isMultiple: _propTypes["default"].bool,
	  dropdownPrefixCls: _propTypes["default"].string,
	  onDropdownVisibleChange: _propTypes["default"].func,
	  popupElement: _propTypes["default"].node,
	  open: _propTypes["default"].bool
	});
	
	(0, _reactLifecyclesCompat.polyfill)(SelectTrigger);
	var _default = SelectTrigger;
	exports["default"] = _default;

/***/ },
/* 2756 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _util = __webpack_require__(144);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Selection =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Selection, _React$Component);
	
	  function Selection() {
	    var _getPrototypeOf2;
	
	    var _this;
	
	    _classCallCheck(this, Selection);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Selection)).call.apply(_getPrototypeOf2, [this].concat(args)));
	
	    _defineProperty(_assertThisInitialized(_this), "onRemove", function (event) {
	      var _this$props = _this.props,
	          onRemove = _this$props.onRemove,
	          value = _this$props.value;
	      onRemove(event, value);
	      event.stopPropagation();
	    });
	
	    return _this;
	  }
	
	  _createClass(Selection, [{
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          prefixCls = _this$props2.prefixCls,
	          maxTagTextLength = _this$props2.maxTagTextLength,
	          className = _this$props2.className,
	          style = _this$props2.style,
	          label = _this$props2.label,
	          value = _this$props2.value,
	          onRemove = _this$props2.onRemove,
	          removeIcon = _this$props2.removeIcon;
	      var content = label || value;
	
	      if (maxTagTextLength && typeof content === 'string' && content.length > maxTagTextLength) {
	        content = "".concat(content.slice(0, maxTagTextLength), "...");
	      }
	
	      return _react["default"].createElement("li", _extends({
	        style: _objectSpread({}, _util.UNSELECTABLE_STYLE, {}, style)
	      }, _util.UNSELECTABLE_ATTRIBUTE, {
	        role: "menuitem",
	        className: (0, _classnames["default"])("".concat(prefixCls, "-selection__choice"), className),
	        title: (0, _util.toTitle)(label)
	      }), onRemove && _react["default"].createElement("span", {
	        className: "".concat(prefixCls, "-selection__choice__remove"),
	        onClick: this.onRemove
	      }, typeof removeIcon === 'function' ? _react["default"].createElement(removeIcon, _objectSpread({}, this.props)) : removeIcon), _react["default"].createElement("span", {
	        className: "".concat(prefixCls, "-selection__choice__content")
	      }, content));
	    }
	  }]);
	
	  return Selection;
	}(_react["default"].Component);
	
	_defineProperty(Selection, "propTypes", {
	  prefixCls: _propTypes["default"].string,
	  maxTagTextLength: _propTypes["default"].number,
	  onRemove: _propTypes["default"].func,
	  className: _propTypes["default"].string,
	  style: _propTypes["default"].object,
	  label: _propTypes["default"].node,
	  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
	  removeIcon: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func])
	});
	
	var _default = Selection;
	exports["default"] = _default;

/***/ },
/* 2757 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _CSSMotionList = _interopRequireDefault(__webpack_require__(2637));
	
	var _Selection = _interopRequireDefault(__webpack_require__(2756));
	
	var _SearchInput = _interopRequireDefault(__webpack_require__(1111));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	var NODE_SELECTOR = 'selector';
	var NODE_SEARCH = 'search';
	var TREE_SELECT_EMPTY_VALUE_KEY = 'RC_TREE_SELECT_EMPTY_VALUE_KEY';
	
	var SelectorList = function SelectorList(props) {
	  var selectorValueList = props.selectorValueList,
	      choiceTransitionName = props.choiceTransitionName,
	      prefixCls = props.prefixCls,
	      onChoiceAnimationLeave = props.onChoiceAnimationLeave,
	      labelInValue = props.labelInValue,
	      maxTagCount = props.maxTagCount,
	      maxTagPlaceholder = props.maxTagPlaceholder,
	      showSearch = props.showSearch,
	      valueEntities = props.valueEntities,
	      inputRef = props.inputRef,
	      onMultipleSelectorRemove = props.onMultipleSelectorRemove;
	  var nodeKeys = []; // Check if `maxTagCount` is set
	
	  var myValueList = selectorValueList;
	
	  if (maxTagCount >= 0) {
	    myValueList = selectorValueList.slice(0, maxTagCount);
	  } // Basic selectors
	
	
	  myValueList.forEach(function (_ref) {
	    var label = _ref.label,
	        value = _ref.value;
	
	    var _ref2 = (valueEntities[value] || {}).node || {},
	        _ref2$props = _ref2.props;
	
	    _ref2$props = _ref2$props === void 0 ? {} : _ref2$props;
	    var disabled = _ref2$props.disabled;
	    nodeKeys.push({
	      key: value,
	      type: NODE_SELECTOR,
	      label: label,
	      value: value,
	      disabled: disabled
	    });
	  }); // Rest node count
	
	  if (maxTagCount >= 0 && maxTagCount < selectorValueList.length) {
	    var content = "+ ".concat(selectorValueList.length - maxTagCount, " ...");
	
	    if (typeof maxTagPlaceholder === 'string') {
	      content = maxTagPlaceholder;
	    } else if (typeof maxTagPlaceholder === 'function') {
	      var restValueList = selectorValueList.slice(maxTagCount);
	      content = maxTagPlaceholder(labelInValue ? restValueList : restValueList.map(function (_ref3) {
	        var value = _ref3.value;
	        return value;
	      }));
	    }
	
	    nodeKeys.push({
	      key: 'rc-tree-select-internal-max-tag-counter',
	      type: NODE_SELECTOR,
	      label: content,
	      value: null,
	      disabled: true
	    });
	  } // Search node
	
	
	  if (showSearch !== false) {
	    nodeKeys.push({
	      key: '__input',
	      type: NODE_SEARCH
	    });
	  }
	
	  return _react["default"].createElement(_CSSMotionList["default"], {
	    keys: nodeKeys,
	    className: "".concat(prefixCls, "-selection__rendered"),
	    component: "ul",
	    role: "menubar",
	    motionName: choiceTransitionName,
	    onLeaveEnd: onChoiceAnimationLeave
	  }, function (_ref4) {
	    var type = _ref4.type,
	        label = _ref4.label,
	        value = _ref4.value,
	        disabled = _ref4.disabled,
	        className = _ref4.className,
	        style = _ref4.style;
	
	    if (type === NODE_SELECTOR) {
	      return _react["default"].createElement(_Selection["default"], _extends({}, props, {
	        className: className,
	        style: style,
	        key: value || TREE_SELECT_EMPTY_VALUE_KEY,
	        label: label,
	        value: value,
	        onRemove: disabled ? null : onMultipleSelectorRemove
	      }));
	    }
	
	    return _react["default"].createElement("li", {
	      className: "".concat(prefixCls, "-search ").concat(prefixCls, "-search--inline")
	    }, _react["default"].createElement(_SearchInput["default"], _extends({}, props, {
	      ref: inputRef,
	      needAlign: true
	    })));
	  });
	};
	
	SelectorList.propTypes = {
	  selectorValueList: _propTypes["default"].array,
	  choiceTransitionName: _propTypes["default"].string,
	  prefixCls: _propTypes["default"].string,
	  onChoiceAnimationLeave: _propTypes["default"].func,
	  labelInValue: _propTypes["default"].bool,
	  showSearch: _propTypes["default"].bool,
	  maxTagCount: _propTypes["default"].number,
	  maxTagPlaceholder: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
	  valueEntities: _propTypes["default"].object,
	  inputRef: _propTypes["default"].func,
	  onMultipleSelectorRemove: _propTypes["default"].func
	};
	var _default = SelectorList;
	exports["default"] = _default;

/***/ },
/* 2758 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = exports.multipleSelectorContextTypes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _BaseSelector = _interopRequireWildcard(__webpack_require__(564));
	
	var _util = __webpack_require__(144);
	
	var _SelectorList = _interopRequireDefault(__webpack_require__(2757));
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Selector = (0, _BaseSelector["default"])('multiple');
	var multipleSelectorContextTypes = {
	  onMultipleSelectorRemove: _propTypes["default"].func.isRequired
	};
	exports.multipleSelectorContextTypes = multipleSelectorContextTypes;
	
	var MultipleSelector =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(MultipleSelector, _React$Component);
	
	  function MultipleSelector() {
	    var _this;
	
	    _classCallCheck(this, MultipleSelector);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultipleSelector).call(this));
	
	    _defineProperty(_assertThisInitialized(_this), "onPlaceholderClick", function () {
	      _this.inputRef.current.focus();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "focus", function () {
	      _this.inputRef.current.focus();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "blur", function () {
	      _this.inputRef.current.blur();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderPlaceholder", function () {
	      var _this$props = _this.props,
	          prefixCls = _this$props.prefixCls,
	          placeholder = _this$props.placeholder,
	          searchPlaceholder = _this$props.searchPlaceholder,
	          searchValue = _this$props.searchValue,
	          selectorValueList = _this$props.selectorValueList;
	      var currentPlaceholder = placeholder || searchPlaceholder;
	      if (!currentPlaceholder) return null;
	      var hidden = searchValue || selectorValueList.length; // [Legacy] Not remove the placeholder
	
	      return _react["default"].createElement("span", {
	        style: {
	          display: hidden ? 'none' : 'block'
	        },
	        onClick: _this.onPlaceholderClick,
	        className: "".concat(prefixCls, "-search__field__placeholder")
	      }, currentPlaceholder);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderSelection", function () {
	      var onMultipleSelectorRemove = _this.context.rcTreeSelect.onMultipleSelectorRemove;
	      return _react["default"].createElement(_SelectorList["default"], _extends({}, _this.props, {
	        onMultipleSelectorRemove: onMultipleSelectorRemove,
	        inputRef: _this.inputRef
	      }));
	    });
	
	    _this.inputRef = (0, _util.createRef)();
	    return _this;
	  }
	
	  _createClass(MultipleSelector, [{
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement(Selector, _extends({}, this.props, {
	        tabIndex: -1,
	        showArrow: false,
	        renderSelection: this.renderSelection,
	        renderPlaceholder: this.renderPlaceholder
	      }));
	    }
	  }]);
	
	  return MultipleSelector;
	}(_react["default"].Component);
	
	_defineProperty(MultipleSelector, "propTypes", _objectSpread({}, _BaseSelector.selectorPropTypes, {
	  selectorValueList: _propTypes["default"].array,
	  disabled: _propTypes["default"].bool,
	  searchValue: _propTypes["default"].string,
	  labelInValue: _propTypes["default"].bool,
	  maxTagCount: _propTypes["default"].number,
	  maxTagPlaceholder: _propTypes["default"].oneOfType([_propTypes["default"].node, _propTypes["default"].func]),
	  onChoiceAnimationLeave: _propTypes["default"].func
	}));
	
	_defineProperty(MultipleSelector, "contextTypes", {
	  rcTreeSelect: _propTypes["default"].shape(_objectSpread({}, multipleSelectorContextTypes, {
	    onSearchInputChange: _propTypes["default"].func
	  }))
	});
	
	var _default = MultipleSelector;
	exports["default"] = _default;

/***/ },
/* 2759 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _BaseSelector = _interopRequireWildcard(__webpack_require__(564));
	
	var _util = __webpack_require__(144);
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (typeof call === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var Selector = (0, _BaseSelector["default"])('single');
	
	var SingleSelector =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(SingleSelector, _React$Component);
	
	  function SingleSelector() {
	    var _this;
	
	    _classCallCheck(this, SingleSelector);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleSelector).call(this));
	
	    _defineProperty(_assertThisInitialized(_this), "focus", function () {
	      _this.selectorRef.current.focus();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "blur", function () {
	      _this.selectorRef.current.blur();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "renderSelection", function () {
	      var _this$props = _this.props,
	          selectorValueList = _this$props.selectorValueList,
	          placeholder = _this$props.placeholder,
	          prefixCls = _this$props.prefixCls;
	      var innerNode;
	
	      if (selectorValueList.length) {
	        var _selectorValueList$ = selectorValueList[0],
	            label = _selectorValueList$.label,
	            value = _selectorValueList$.value;
	        innerNode = _react["default"].createElement("span", {
	          key: "value",
	          title: (0, _util.toTitle)(label),
	          className: "".concat(prefixCls, "-selection-selected-value")
	        }, label || value);
	      } else {
	        innerNode = _react["default"].createElement("span", {
	          key: "placeholder",
	          className: "".concat(prefixCls, "-selection__placeholder")
	        }, placeholder);
	      }
	
	      return _react["default"].createElement("span", {
	        className: "".concat(prefixCls, "-selection__rendered")
	      }, innerNode);
	    });
	
	    _this.selectorRef = (0, _util.createRef)();
	    return _this;
	  }
	
	  _createClass(SingleSelector, [{
	    key: "render",
	    value: function render() {
	      return _react["default"].createElement(Selector, _extends({}, this.props, {
	        ref: this.selectorRef,
	        renderSelection: this.renderSelection
	      }));
	    }
	  }]);
	
	  return SingleSelector;
	}(_react["default"].Component);
	
	_defineProperty(SingleSelector, "propTypes", _objectSpread({}, _BaseSelector.selectorPropTypes));
	
	var _default = SingleSelector;
	exports["default"] = _default;

/***/ },
/* 2760 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "SHOW_ALL", {
	  enumerable: true,
	  get: function get() {
	    return _strategies.SHOW_ALL;
	  }
	});
	Object.defineProperty(exports, "SHOW_CHILD", {
	  enumerable: true,
	  get: function get() {
	    return _strategies.SHOW_CHILD;
	  }
	});
	Object.defineProperty(exports, "SHOW_PARENT", {
	  enumerable: true,
	  get: function get() {
	    return _strategies.SHOW_PARENT;
	  }
	});
	exports["default"] = exports.TreeNode = void 0;
	
	var _Select = _interopRequireDefault(__webpack_require__(2754));
	
	var _SelectNode = _interopRequireDefault(__webpack_require__(1112));
	
	var _strategies = __webpack_require__(565);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var TreeNode = _SelectNode["default"];
	exports.TreeNode = TreeNode;
	var _default = _Select["default"];
	exports["default"] = _default;

/***/ },
/* 2761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(1069);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(2764);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _raf = __webpack_require__(127);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	var _PopupInner = __webpack_require__(2762);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(1114);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	var _utils = __webpack_require__(1115);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Popup = function (_Component) {
	  (0, _inherits3['default'])(Popup, _Component);
	
	  function Popup(props) {
	    (0, _classCallCheck3['default'])(this, Popup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      // Used for stretch
	      stretchChecked: false,
	      targetWidth: undefined,
	      targetHeight: undefined
	    };
	
	    _this.savePopupRef = _utils.saveRef.bind(_this, 'popupInstance');
	    _this.saveAlignRef = _utils.saveRef.bind(_this, 'alignInstance');
	    return _this;
	  }
	
	  Popup.prototype.componentDidMount = function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	    this.setStretchSize();
	  };
	
	  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.setStretchSize();
	  };
	
	  // Record size if stretch needed
	
	
	  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
	    return _reactDom2['default'].findDOMNode(this.popupInstance);
	  };
	
	  // `target` on `rc-align` can accept as a function to get the bind element or a point.
	  // ref: https://www.npmjs.com/package/rc-align
	
	
	  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getTransitionName = function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  };
	
	  Popup.prototype.getPopupElement = function getPopupElement() {
	    var _this2 = this;
	
	    var savePopupRef = this.savePopupRef;
	    var _state = this.state,
	        stretchChecked = _state.stretchChecked,
	        targetHeight = _state.targetHeight,
	        targetWidth = _state.targetWidth;
	    var _props = this.props,
	        align = _props.align,
	        visible = _props.visible,
	        prefixCls = _props.prefixCls,
	        style = _props.style,
	        getClassNameFromAlign = _props.getClassNameFromAlign,
	        destroyPopupOnHide = _props.destroyPopupOnHide,
	        stretch = _props.stretch,
	        children = _props.children,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseLeave = _props.onMouseLeave;
	
	    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	
	    var sizeStyle = {};
	    if (stretch) {
	      // Stretch with target
	      if (stretch.indexOf('height') !== -1) {
	        sizeStyle.height = targetHeight;
	      } else if (stretch.indexOf('minHeight') !== -1) {
	        sizeStyle.minHeight = targetHeight;
	      }
	      if (stretch.indexOf('width') !== -1) {
	        sizeStyle.width = targetWidth;
	      } else if (stretch.indexOf('minWidth') !== -1) {
	        sizeStyle.minWidth = targetWidth;
	      }
	
	      // Delay force align to makes ui smooth
	      if (!stretchChecked) {
	        sizeStyle.visibility = 'hidden';
	        (0, _raf2['default'])(function () {
	          if (_this2.alignInstance) {
	            _this2.alignInstance.forceAlign();
	          }
	        });
	      }
	    }
	
	    var newStyle = (0, _extends3['default'])({}, sizeStyle, style, this.getZIndexStyle());
	
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: savePopupRef,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      style: newStyle
	    };
	
	    if (destroyPopupOnHide) {
	      return _react2['default'].createElement(
	        _rcAnimate2['default'],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName(),
	          onLeave: this.onAnimateLeaved
	        },
	        visible ? _react2['default'].createElement(
	          _rcAlign2['default'],
	          {
	            target: this.getAlignTarget(),
	            key: 'popup',
	            ref: this.saveAlignRef,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2['default'].createElement(
	            _PopupInner2['default'],
	            (0, _extends3['default'])({
	              visible: true
	            }, popupInnerProps),
	            children
	          )
	        ) : null
	      );
	    }
	
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible',
	        onLeave: this.onAnimateLeaved
	      },
	      _react2['default'].createElement(
	        _rcAlign2['default'],
	        {
	          target: this.getAlignTarget(),
	          key: 'popup',
	          ref: this.saveAlignRef,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2['default'].createElement(
	          _PopupInner2['default'],
	          (0, _extends3['default'])({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          children
	        )
	      )
	    );
	  };
	
	  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  };
	
	  Popup.prototype.getMaskElement = function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2['default'].createElement(_LazyRenderBox2['default'], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  };
	
	  Popup.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  };
	
	  return Popup;
	}(_react.Component);
	
	Popup.propTypes = {
	  visible: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  getClassNameFromAlign: _propTypes2['default'].func,
	  onAlign: _propTypes2['default'].func,
	  getRootDomNode: _propTypes2['default'].func,
	  onMouseEnter: _propTypes2['default'].func,
	  align: _propTypes2['default'].any,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseLeave: _propTypes2['default'].func,
	  stretch: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  point: _propTypes2['default'].shape({
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onAlign = function (popupDomNode, align) {
	    var props = _this3.props;
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    // FIX: https://github.com/react-component/trigger/issues/56
	    // FIX: https://github.com/react-component/tooltip/issues/79
	    if (_this3.currentAlignClassName !== currentAlignClassName) {
	      _this3.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = _this3.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  };
	
	  this.onAnimateLeaved = function () {
	    var stretch = _this3.props.stretch;
	    var stretchChecked = _this3.state.stretchChecked;
	
	    if (stretch && stretchChecked) {
	      _this3.setState({ stretchChecked: false });
	    }
	  };
	
	  this.setStretchSize = function () {
	    var getRootDomNode = _this3.props.getRootDomNode;
	    var _state2 = _this3.state,
	        stretchChecked = _state2.stretchChecked,
	        targetHeight = _state2.targetHeight,
	        targetWidth = _state2.targetWidth;
	
	
	    var $ele = getRootDomNode();
	    if (!$ele) return;
	
	    var height = $ele.offsetHeight;
	    var width = $ele.offsetWidth;
	
	    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
	      _this3.setState({
	        stretchChecked: true,
	        targetHeight: height,
	        targetWidth: width
	      });
	    }
	  };
	
	  this.getTargetElement = function () {
	    return _this3.props.getRootDomNode();
	  };
	
	  this.getAlignTarget = function () {
	    var point = _this3.props.point;
	
	    if (point) {
	      return point;
	    }
	    return _this3.getTargetElement;
	  };
	};
	
	exports['default'] = Popup;
	module.exports = exports['default'];

/***/ },
/* 2762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LazyRenderBox = __webpack_require__(1114);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PopupInner = function (_Component) {
	  (0, _inherits3['default'])(PopupInner, _Component);
	
	  function PopupInner() {
	    (0, _classCallCheck3['default'])(this, PopupInner);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  PopupInner.prototype.render = function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        style: props.style
	      },
	      _react2['default'].createElement(
	        _LazyRenderBox2['default'],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  };
	
	  return PopupInner;
	}(_react.Component);
	
	PopupInner.propTypes = {
	  hiddenClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  children: _propTypes2['default'].any
	};
	exports['default'] = PopupInner;
	module.exports = exports['default'];

/***/ },
/* 2763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _contains = __webpack_require__(383);
	
	var _contains2 = _interopRequireDefault(_contains);
	
	var _addEventListener = __webpack_require__(145);
	
	var _addEventListener2 = _interopRequireDefault(_addEventListener);
	
	var _Popup = __webpack_require__(2761);
	
	var _Popup2 = _interopRequireDefault(_Popup);
	
	var _utils = __webpack_require__(1115);
	
	var _ContainerRender = __webpack_require__(567);
	
	var _ContainerRender2 = _interopRequireDefault(_ContainerRender);
	
	var _Portal = __webpack_require__(569);
	
	var _Portal2 = _interopRequireDefault(_Portal);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _unsafeLifecyclesPolyfill = __webpack_require__(384);
	
	var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function noop() {}
	
	function returnEmptyString() {
	  return '';
	}
	
	function returnDocument() {
	  return window.document;
	}
	
	var ALL_HANDLERS = ['onClick', 'onMouseDown', 'onTouchStart', 'onMouseEnter', 'onMouseLeave', 'onFocus', 'onBlur', 'onContextMenu'];
	
	var IS_REACT_16 = !!_reactDom.createPortal;
	
	var Trigger = function (_React$Component) {
	  (0, _inherits3['default'])(Trigger, _React$Component);
	
	  function Trigger(props) {
	    (0, _classCallCheck3['default'])(this, Trigger);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    var popupVisible = void 0;
	    if ('popupVisible' in props) {
	      popupVisible = !!props.popupVisible;
	    } else {
	      popupVisible = !!props.defaultPopupVisible;
	    }
	
	    _this.prevPopupVisible = popupVisible;
	
	    _this.state = {
	      popupVisible: popupVisible
	    };
	
	    ALL_HANDLERS.forEach(function (h) {
	      _this['fire' + h] = function (e) {
	        _this.fireEvents(h, e);
	      };
	    });
	    return _this;
	  }
	
	  Trigger.prototype.componentDidMount = function componentDidMount() {
	    this.componentDidUpdate({}, {
	      popupVisible: this.state.popupVisible
	    });
	  };
	
	  Trigger.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {
	    var popupVisible = _ref.popupVisible;
	
	    if (popupVisible !== undefined) {
	      this.setState({
	        popupVisible: popupVisible
	      });
	    }
	  };
	
	  Trigger.prototype.componentDidUpdate = function componentDidUpdate(_, prevState) {
	    var props = this.props;
	    var state = this.state;
	    var triggerAfterPopupVisibleChange = function triggerAfterPopupVisibleChange() {
	      if (prevState.popupVisible !== state.popupVisible) {
	        props.afterPopupVisibleChange(state.popupVisible);
	      }
	    };
	    if (!IS_REACT_16) {
	      this.renderComponent(null, triggerAfterPopupVisibleChange);
	    }
	
	    this.prevPopupVisible = prevState.popupVisible;
	
	    // We must listen to `mousedown` or `touchstart`, edge case:
	    // https://github.com/ant-design/ant-design/issues/5804
	    // https://github.com/react-component/calendar/issues/250
	    // https://github.com/react-component/trigger/issues/50
	    if (state.popupVisible) {
	      var currentDocument = void 0;
	      if (!this.clickOutsideHandler && (this.isClickToHide() || this.isContextMenuToShow())) {
	        currentDocument = props.getDocument();
	        this.clickOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'mousedown', this.onDocumentClick);
	      }
	      // always hide on mobile
	      if (!this.touchOutsideHandler) {
	        currentDocument = currentDocument || props.getDocument();
	        this.touchOutsideHandler = (0, _addEventListener2['default'])(currentDocument, 'touchstart', this.onDocumentClick);
	      }
	      // close popup when trigger type contains 'onContextMenu' and document is scrolling.
	      if (!this.contextMenuOutsideHandler1 && this.isContextMenuToShow()) {
	        currentDocument = currentDocument || props.getDocument();
	        this.contextMenuOutsideHandler1 = (0, _addEventListener2['default'])(currentDocument, 'scroll', this.onContextMenuClose);
	      }
	      // close popup when trigger type contains 'onContextMenu' and window is blur.
	      if (!this.contextMenuOutsideHandler2 && this.isContextMenuToShow()) {
	        this.contextMenuOutsideHandler2 = (0, _addEventListener2['default'])(window, 'blur', this.onContextMenuClose);
	      }
	      return;
	    }
	
	    this.clearOutsideHandler();
	  };
	
	  Trigger.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.clearDelayTimer();
	    this.clearOutsideHandler();
	  };
	
	  Trigger.prototype.getPopupDomNode = function getPopupDomNode() {
	    // for test
	    if (this._component && this._component.getPopupDomNode) {
	      return this._component.getPopupDomNode();
	    }
	    return null;
	  };
	
	  Trigger.prototype.getPopupAlign = function getPopupAlign() {
	    var props = this.props;
	    var popupPlacement = props.popupPlacement,
	        popupAlign = props.popupAlign,
	        builtinPlacements = props.builtinPlacements;
	
	    if (popupPlacement && builtinPlacements) {
	      return (0, _utils.getAlignFromPlacement)(builtinPlacements, popupPlacement, popupAlign);
	    }
	    return popupAlign;
	  };
	
	  /**
	   * @param popupVisible    Show or not the popup element
	   * @param event           SyntheticEvent, used for `pointAlign`
	   */
	  Trigger.prototype.setPopupVisible = function setPopupVisible(popupVisible, event) {
	    var alignPoint = this.props.alignPoint;
	
	
	    this.clearDelayTimer();
	
	    if (this.state.popupVisible !== popupVisible) {
	      if (!('popupVisible' in this.props)) {
	        this.setState({ popupVisible: popupVisible });
	      }
	      this.props.onPopupVisibleChange(popupVisible);
	    }
	
	    // Always record the point position since mouseEnterDelay will delay the show
	    if (alignPoint && event) {
	      this.setPoint(event);
	    }
	  };
	
	  Trigger.prototype.delaySetPopupVisible = function delaySetPopupVisible(visible, delayS, event) {
	    var _this2 = this;
	
	    var delay = delayS * 1000;
	    this.clearDelayTimer();
	    if (delay) {
	      var point = event ? { pageX: event.pageX, pageY: event.pageY } : null;
	      this.delayTimer = setTimeout(function () {
	        _this2.setPopupVisible(visible, point);
	        _this2.clearDelayTimer();
	      }, delay);
	    } else {
	      this.setPopupVisible(visible, event);
	    }
	  };
	
	  Trigger.prototype.clearDelayTimer = function clearDelayTimer() {
	    if (this.delayTimer) {
	      clearTimeout(this.delayTimer);
	      this.delayTimer = null;
	    }
	  };
	
	  Trigger.prototype.clearOutsideHandler = function clearOutsideHandler() {
	    if (this.clickOutsideHandler) {
	      this.clickOutsideHandler.remove();
	      this.clickOutsideHandler = null;
	    }
	
	    if (this.contextMenuOutsideHandler1) {
	      this.contextMenuOutsideHandler1.remove();
	      this.contextMenuOutsideHandler1 = null;
	    }
	
	    if (this.contextMenuOutsideHandler2) {
	      this.contextMenuOutsideHandler2.remove();
	      this.contextMenuOutsideHandler2 = null;
	    }
	
	    if (this.touchOutsideHandler) {
	      this.touchOutsideHandler.remove();
	      this.touchOutsideHandler = null;
	    }
	  };
	
	  Trigger.prototype.createTwoChains = function createTwoChains(event) {
	    var childPros = this.props.children.props;
	    var props = this.props;
	    if (childPros[event] && props[event]) {
	      return this['fire' + event];
	    }
	    return childPros[event] || props[event];
	  };
	
	  Trigger.prototype.isClickToShow = function isClickToShow() {
	    var _props = this.props,
	        action = _props.action,
	        showAction = _props.showAction;
	
	    return action.indexOf('click') !== -1 || showAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isContextMenuToShow = function isContextMenuToShow() {
	    var _props2 = this.props,
	        action = _props2.action,
	        showAction = _props2.showAction;
	
	    return action.indexOf('contextMenu') !== -1 || showAction.indexOf('contextMenu') !== -1;
	  };
	
	  Trigger.prototype.isClickToHide = function isClickToHide() {
	    var _props3 = this.props,
	        action = _props3.action,
	        hideAction = _props3.hideAction;
	
	    return action.indexOf('click') !== -1 || hideAction.indexOf('click') !== -1;
	  };
	
	  Trigger.prototype.isMouseEnterToShow = function isMouseEnterToShow() {
	    var _props4 = this.props,
	        action = _props4.action,
	        showAction = _props4.showAction;
	
	    return action.indexOf('hover') !== -1 || showAction.indexOf('mouseEnter') !== -1;
	  };
	
	  Trigger.prototype.isMouseLeaveToHide = function isMouseLeaveToHide() {
	    var _props5 = this.props,
	        action = _props5.action,
	        hideAction = _props5.hideAction;
	
	    return action.indexOf('hover') !== -1 || hideAction.indexOf('mouseLeave') !== -1;
	  };
	
	  Trigger.prototype.isFocusToShow = function isFocusToShow() {
	    var _props6 = this.props,
	        action = _props6.action,
	        showAction = _props6.showAction;
	
	    return action.indexOf('focus') !== -1 || showAction.indexOf('focus') !== -1;
	  };
	
	  Trigger.prototype.isBlurToHide = function isBlurToHide() {
	    var _props7 = this.props,
	        action = _props7.action,
	        hideAction = _props7.hideAction;
	
	    return action.indexOf('focus') !== -1 || hideAction.indexOf('blur') !== -1;
	  };
	
	  Trigger.prototype.forcePopupAlign = function forcePopupAlign() {
	    if (this.state.popupVisible && this._component && this._component.alignInstance) {
	      this._component.alignInstance.forceAlign();
	    }
	  };
	
	  Trigger.prototype.fireEvents = function fireEvents(type, e) {
	    var childCallback = this.props.children.props[type];
	    if (childCallback) {
	      childCallback(e);
	    }
	    var callback = this.props[type];
	    if (callback) {
	      callback(e);
	    }
	  };
	
	  Trigger.prototype.close = function close() {
	    this.setPopupVisible(false);
	  };
	
	  Trigger.prototype.render = function render() {
	    var _this3 = this;
	
	    var popupVisible = this.state.popupVisible;
	    var _props8 = this.props,
	        children = _props8.children,
	        forceRender = _props8.forceRender,
	        alignPoint = _props8.alignPoint,
	        className = _props8.className;
	
	    var child = _react2['default'].Children.only(children);
	    var newChildProps = { key: 'trigger' };
	
	    if (this.isContextMenuToShow()) {
	      newChildProps.onContextMenu = this.onContextMenu;
	    } else {
	      newChildProps.onContextMenu = this.createTwoChains('onContextMenu');
	    }
	
	    if (this.isClickToHide() || this.isClickToShow()) {
	      newChildProps.onClick = this.onClick;
	      newChildProps.onMouseDown = this.onMouseDown;
	      newChildProps.onTouchStart = this.onTouchStart;
	    } else {
	      newChildProps.onClick = this.createTwoChains('onClick');
	      newChildProps.onMouseDown = this.createTwoChains('onMouseDown');
	      newChildProps.onTouchStart = this.createTwoChains('onTouchStart');
	    }
	    if (this.isMouseEnterToShow()) {
	      newChildProps.onMouseEnter = this.onMouseEnter;
	      if (alignPoint) {
	        newChildProps.onMouseMove = this.onMouseMove;
	      }
	    } else {
	      newChildProps.onMouseEnter = this.createTwoChains('onMouseEnter');
	    }
	    if (this.isMouseLeaveToHide()) {
	      newChildProps.onMouseLeave = this.onMouseLeave;
	    } else {
	      newChildProps.onMouseLeave = this.createTwoChains('onMouseLeave');
	    }
	    if (this.isFocusToShow() || this.isBlurToHide()) {
	      newChildProps.onFocus = this.onFocus;
	      newChildProps.onBlur = this.onBlur;
	    } else {
	      newChildProps.onFocus = this.createTwoChains('onFocus');
	      newChildProps.onBlur = this.createTwoChains('onBlur');
	    }
	
	    var childrenClassName = (0, _classnames2['default'])(child && child.props && child.props.className, className);
	    if (childrenClassName) {
	      newChildProps.className = childrenClassName;
	    }
	    var trigger = _react2['default'].cloneElement(child, newChildProps);
	
	    if (!IS_REACT_16) {
	      return _react2['default'].createElement(
	        _ContainerRender2['default'],
	        {
	          parent: this,
	          visible: popupVisible,
	          autoMount: false,
	          forceRender: forceRender,
	          getComponent: this.getComponent,
	          getContainer: this.getContainer
	        },
	        function (_ref2) {
	          var renderComponent = _ref2.renderComponent;
	
	          _this3.renderComponent = renderComponent;
	          return trigger;
	        }
	      );
	    }
	
	    var portal = void 0;
	    // prevent unmounting after it's rendered
	    if (popupVisible || this._component || forceRender) {
	      portal = _react2['default'].createElement(
	        _Portal2['default'],
	        {
	          key: 'portal',
	          getContainer: this.getContainer,
	          didUpdate: this.handlePortalUpdate
	        },
	        this.getComponent()
	      );
	    }
	
	    return [trigger, portal];
	  };
	
	  return Trigger;
	}(_react2['default'].Component);
	
	Trigger.propTypes = {
	  children: _propTypes2['default'].any,
	  action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].arrayOf(_propTypes2['default'].string)]),
	  showAction: _propTypes2['default'].any,
	  hideAction: _propTypes2['default'].any,
	  getPopupClassNameFromAlign: _propTypes2['default'].any,
	  onPopupVisibleChange: _propTypes2['default'].func,
	  afterPopupVisibleChange: _propTypes2['default'].func,
	  popup: _propTypes2['default'].oneOfType([_propTypes2['default'].node, _propTypes2['default'].func]).isRequired,
	  popupStyle: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  popupClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  popupPlacement: _propTypes2['default'].string,
	  builtinPlacements: _propTypes2['default'].object,
	  popupTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  popupAnimation: _propTypes2['default'].any,
	  mouseEnterDelay: _propTypes2['default'].number,
	  mouseLeaveDelay: _propTypes2['default'].number,
	  zIndex: _propTypes2['default'].number,
	  focusDelay: _propTypes2['default'].number,
	  blurDelay: _propTypes2['default'].number,
	  getPopupContainer: _propTypes2['default'].func,
	  getDocument: _propTypes2['default'].func,
	  forceRender: _propTypes2['default'].bool,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  mask: _propTypes2['default'].bool,
	  maskClosable: _propTypes2['default'].bool,
	  onPopupAlign: _propTypes2['default'].func,
	  popupAlign: _propTypes2['default'].object,
	  popupVisible: _propTypes2['default'].bool,
	  defaultPopupVisible: _propTypes2['default'].bool,
	  maskTransitionName: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].object]),
	  maskAnimation: _propTypes2['default'].string,
	  stretch: _propTypes2['default'].string,
	  alignPoint: _propTypes2['default'].bool // Maybe we can support user pass position in the future
	};
	Trigger.defaultProps = {
	  prefixCls: 'rc-trigger-popup',
	  getPopupClassNameFromAlign: returnEmptyString,
	  getDocument: returnDocument,
	  onPopupVisibleChange: noop,
	  afterPopupVisibleChange: noop,
	  onPopupAlign: noop,
	  popupClassName: '',
	  mouseEnterDelay: 0,
	  mouseLeaveDelay: 0.1,
	  focusDelay: 0,
	  blurDelay: 0.15,
	  popupStyle: {},
	  destroyPopupOnHide: false,
	  popupAlign: {},
	  defaultPopupVisible: false,
	  mask: false,
	  maskClosable: true,
	  action: [],
	  showAction: [],
	  hideAction: []
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this4 = this;
	
	  this.onMouseEnter = function (e) {
	    var mouseEnterDelay = _this4.props.mouseEnterDelay;
	
	    _this4.fireEvents('onMouseEnter', e);
	    _this4.delaySetPopupVisible(true, mouseEnterDelay, mouseEnterDelay ? null : e);
	  };
	
	  this.onMouseMove = function (e) {
	    _this4.fireEvents('onMouseMove', e);
	    _this4.setPoint(e);
	  };
	
	  this.onMouseLeave = function (e) {
	    _this4.fireEvents('onMouseLeave', e);
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onPopupMouseEnter = function () {
	    _this4.clearDelayTimer();
	  };
	
	  this.onPopupMouseLeave = function (e) {
	    // https://github.com/react-component/trigger/pull/13
	    // react bug?
	    if (e.relatedTarget && !e.relatedTarget.setTimeout && _this4._component && _this4._component.getPopupDomNode && (0, _contains2['default'])(_this4._component.getPopupDomNode(), e.relatedTarget)) {
	      return;
	    }
	    _this4.delaySetPopupVisible(false, _this4.props.mouseLeaveDelay);
	  };
	
	  this.onFocus = function (e) {
	    _this4.fireEvents('onFocus', e);
	    // incase focusin and focusout
	    _this4.clearDelayTimer();
	    if (_this4.isFocusToShow()) {
	      _this4.focusTime = Date.now();
	      _this4.delaySetPopupVisible(true, _this4.props.focusDelay);
	    }
	  };
	
	  this.onMouseDown = function (e) {
	    _this4.fireEvents('onMouseDown', e);
	    _this4.preClickTime = Date.now();
	  };
	
	  this.onTouchStart = function (e) {
	    _this4.fireEvents('onTouchStart', e);
	    _this4.preTouchTime = Date.now();
	  };
	
	  this.onBlur = function (e) {
	    _this4.fireEvents('onBlur', e);
	    _this4.clearDelayTimer();
	    if (_this4.isBlurToHide()) {
	      _this4.delaySetPopupVisible(false, _this4.props.blurDelay);
	    }
	  };
	
	  this.onContextMenu = function (e) {
	    e.preventDefault();
	    _this4.fireEvents('onContextMenu', e);
	    _this4.setPopupVisible(true, e);
	  };
	
	  this.onContextMenuClose = function () {
	    if (_this4.isContextMenuToShow()) {
	      _this4.close();
	    }
	  };
	
	  this.onClick = function (event) {
	    _this4.fireEvents('onClick', event);
	    // focus will trigger click
	    if (_this4.focusTime) {
	      var preTime = void 0;
	      if (_this4.preClickTime && _this4.preTouchTime) {
	        preTime = Math.min(_this4.preClickTime, _this4.preTouchTime);
	      } else if (_this4.preClickTime) {
	        preTime = _this4.preClickTime;
	      } else if (_this4.preTouchTime) {
	        preTime = _this4.preTouchTime;
	      }
	      if (Math.abs(preTime - _this4.focusTime) < 20) {
	        return;
	      }
	      _this4.focusTime = 0;
	    }
	    _this4.preClickTime = 0;
	    _this4.preTouchTime = 0;
	    if (event && event.preventDefault) {
	      event.preventDefault();
	    }
	    var nextVisible = !_this4.state.popupVisible;
	    if (_this4.isClickToHide() && !nextVisible || nextVisible && _this4.isClickToShow()) {
	      _this4.setPopupVisible(!_this4.state.popupVisible, event);
	    }
	  };
	
	  this.onDocumentClick = function (event) {
	    if (_this4.props.mask && !_this4.props.maskClosable) {
	      return;
	    }
	    var target = event.target;
	    var root = (0, _reactDom.findDOMNode)(_this4);
	    var popupNode = _this4.getPopupDomNode();
	    if (!(0, _contains2['default'])(root, target) && !(0, _contains2['default'])(popupNode, target)) {
	      _this4.close();
	    }
	  };
	
	  this.getRootDomNode = function () {
	    return (0, _reactDom.findDOMNode)(_this4);
	  };
	
	  this.getPopupClassNameFromAlign = function (align) {
	    var className = [];
	    var _props9 = _this4.props,
	        popupPlacement = _props9.popupPlacement,
	        builtinPlacements = _props9.builtinPlacements,
	        prefixCls = _props9.prefixCls,
	        alignPoint = _props9.alignPoint,
	        getPopupClassNameFromAlign = _props9.getPopupClassNameFromAlign;
	
	    if (popupPlacement && builtinPlacements) {
	      className.push((0, _utils.getAlignPopupClassName)(builtinPlacements, prefixCls, align, alignPoint));
	    }
	    if (getPopupClassNameFromAlign) {
	      className.push(getPopupClassNameFromAlign(align));
	    }
	    return className.join(' ');
	  };
	
	  this.getComponent = function () {
	    var _props10 = _this4.props,
	        prefixCls = _props10.prefixCls,
	        destroyPopupOnHide = _props10.destroyPopupOnHide,
	        popupClassName = _props10.popupClassName,
	        action = _props10.action,
	        onPopupAlign = _props10.onPopupAlign,
	        popupAnimation = _props10.popupAnimation,
	        popupTransitionName = _props10.popupTransitionName,
	        popupStyle = _props10.popupStyle,
	        mask = _props10.mask,
	        maskAnimation = _props10.maskAnimation,
	        maskTransitionName = _props10.maskTransitionName,
	        zIndex = _props10.zIndex,
	        popup = _props10.popup,
	        stretch = _props10.stretch,
	        alignPoint = _props10.alignPoint;
	    var _state = _this4.state,
	        popupVisible = _state.popupVisible,
	        point = _state.point;
	
	
	    var align = _this4.getPopupAlign();
	
	    var mouseProps = {};
	    if (_this4.isMouseEnterToShow()) {
	      mouseProps.onMouseEnter = _this4.onPopupMouseEnter;
	    }
	    if (_this4.isMouseLeaveToHide()) {
	      mouseProps.onMouseLeave = _this4.onPopupMouseLeave;
	    }
	
	    return _react2['default'].createElement(
	      _Popup2['default'],
	      (0, _extends3['default'])({
	        prefixCls: prefixCls,
	        destroyPopupOnHide: destroyPopupOnHide,
	        visible: popupVisible,
	        point: alignPoint && point,
	        className: popupClassName,
	        action: action,
	        align: align,
	        onAlign: onPopupAlign,
	        animation: popupAnimation,
	        getClassNameFromAlign: _this4.getPopupClassNameFromAlign
	      }, mouseProps, {
	        stretch: stretch,
	        getRootDomNode: _this4.getRootDomNode,
	        style: popupStyle,
	        mask: mask,
	        zIndex: zIndex,
	        transitionName: popupTransitionName,
	        maskAnimation: maskAnimation,
	        maskTransitionName: maskTransitionName,
	        ref: _this4.savePopup
	      }),
	      typeof popup === 'function' ? popup() : popup
	    );
	  };
	
	  this.getContainer = function () {
	    var props = _this4.props;
	
	    var popupContainer = document.createElement('div');
	    // Make sure default popup container will never cause scrollbar appearing
	    // https://github.com/react-component/trigger/issues/41
	    popupContainer.style.position = 'absolute';
	    popupContainer.style.top = '0';
	    popupContainer.style.left = '0';
	    popupContainer.style.width = '100%';
	    var mountNode = props.getPopupContainer ? props.getPopupContainer((0, _reactDom.findDOMNode)(_this4)) : props.getDocument().body;
	    mountNode.appendChild(popupContainer);
	    return popupContainer;
	  };
	
	  this.setPoint = function (point) {
	    var alignPoint = _this4.props.alignPoint;
	
	    if (!alignPoint || !point) return;
	
	    _this4.setState({
	      point: {
	        pageX: point.pageX,
	        pageY: point.pageY
	      }
	    });
	  };
	
	  this.handlePortalUpdate = function () {
	    if (_this4.prevPopupVisible !== _this4.state.popupVisible) {
	      _this4.props.afterPopupVisibleChange(_this4.state.popupVisible);
	    }
	  };
	
	  this.savePopup = function (node) {
	    _this4._component = node;
	  };
	};
	
	exports['default'] = (0, _unsafeLifecyclesPolyfill2['default'])(Trigger);
	module.exports = exports['default'];

/***/ },
/* 2764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _unsafeLifecyclesPolyfill = __webpack_require__(384);
	
	var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);
	
	var _ChildrenUtils = __webpack_require__(2766);
	
	var _AnimateChild = __webpack_require__(2765);
	
	var _AnimateChild2 = _interopRequireDefault(_AnimateChild);
	
	var _animate = __webpack_require__(1116);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
	
	
	var defaultKey = 'rc_animate_' + Date.now();
	
	function getChildrenFromProps(props) {
	  var children = props.children;
	  if (_react2['default'].isValidElement(children)) {
	    if (!children.key) {
	      return _react2['default'].cloneElement(children, {
	        key: defaultKey
	      });
	    }
	  }
	  return children;
	}
	
	function noop() {}
	
	var Animate = function (_React$Component) {
	  _inherits(Animate, _React$Component);
	
	  function Animate(props) {
	    _classCallCheck(this, Animate);
	
	    var _this = _possibleConstructorReturn(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.currentlyAnimatingKeys = {};
	    _this.keysToEnter = [];
	    _this.keysToLeave = [];
	
	    _this.state = {
	      children: (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props))
	    };
	
	    _this.childrenRefs = {};
	    return _this;
	  } // eslint-disable-line
	
	  _createClass(Animate, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      var showProp = this.props.showProp;
	      var children = this.state.children;
	      if (showProp) {
	        children = children.filter(function (child) {
	          return !!child.props[showProp];
	        });
	      }
	      children.forEach(function (child) {
	        if (child) {
	          _this2.performAppear(child.key);
	        }
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this3 = this;
	
	      this.nextProps = nextProps;
	      var nextChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(nextProps));
	      var props = this.props;
	      // exclusive needs immediate response
	      if (props.exclusive) {
	        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
	          _this3.stop(key);
	        });
	      }
	      var showProp = props.showProp;
	      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
	      // last props children if exclusive
	      var currentChildren = props.exclusive ? (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props)) : this.state.children;
	      // in case destroy in showProp mode
	      var newChildren = [];
	      if (showProp) {
	        currentChildren.forEach(function (currentChild) {
	          var nextChild = currentChild && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, currentChild.key);
	          var newChild = void 0;
	          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
	            newChild = _react2['default'].cloneElement(nextChild || currentChild, _defineProperty({}, showProp, true));
	          } else {
	            newChild = nextChild;
	          }
	          if (newChild) {
	            newChildren.push(newChild);
	          }
	        });
	        nextChildren.forEach(function (nextChild) {
	          if (!nextChild || !(0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, nextChild.key)) {
	            newChildren.push(nextChild);
	          }
	        });
	      } else {
	        newChildren = (0, _ChildrenUtils.mergeChildren)(currentChildren, nextChildren);
	      }
	
	      // need render to avoid update
	      this.setState({
	        children: newChildren
	      });
	
	      nextChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasPrev = child && (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	        if (showProp) {
	          var showInNext = child.props[showProp];
	          if (hasPrev) {
	            var showInNow = (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	            if (!showInNow && showInNext) {
	              _this3.keysToEnter.push(key);
	            }
	          } else if (showInNext) {
	            _this3.keysToEnter.push(key);
	          }
	        } else if (!hasPrev) {
	          _this3.keysToEnter.push(key);
	        }
	      });
	
	      currentChildren.forEach(function (child) {
	        var key = child && child.key;
	        if (child && currentlyAnimatingKeys[key]) {
	          return;
	        }
	        var hasNext = child && (0, _ChildrenUtils.findChildInChildrenByKey)(nextChildren, key);
	        if (showProp) {
	          var showInNow = child.props[showProp];
	          if (hasNext) {
	            var showInNext = (0, _ChildrenUtils.findShownChildInChildrenByKey)(nextChildren, key, showProp);
	            if (!showInNext && showInNow) {
	              _this3.keysToLeave.push(key);
	            }
	          } else if (showInNow) {
	            _this3.keysToLeave.push(key);
	          }
	        } else if (!hasNext) {
	          _this3.keysToLeave.push(key);
	        }
	      });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      var keysToEnter = this.keysToEnter;
	      this.keysToEnter = [];
	      keysToEnter.forEach(this.performEnter);
	      var keysToLeave = this.keysToLeave;
	      this.keysToLeave = [];
	      keysToLeave.forEach(this.performLeave);
	    }
	  }, {
	    key: 'isValidChildByKey',
	    value: function isValidChildByKey(currentChildren, key) {
	      var showProp = this.props.showProp;
	      if (showProp) {
	        return (0, _ChildrenUtils.findShownChildInChildrenByKey)(currentChildren, key, showProp);
	      }
	      return (0, _ChildrenUtils.findChildInChildrenByKey)(currentChildren, key);
	    }
	  }, {
	    key: 'stop',
	    value: function stop(key) {
	      delete this.currentlyAnimatingKeys[key];
	      var component = this.childrenRefs[key];
	      if (component) {
	        component.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var props = this.props;
	      this.nextProps = props;
	      var stateChildren = this.state.children;
	      var children = null;
	      if (stateChildren) {
	        children = stateChildren.map(function (child) {
	          if (child === null || child === undefined) {
	            return child;
	          }
	          if (!child.key) {
	            throw new Error('must set key for <rc-animate> children');
	          }
	          return _react2['default'].createElement(
	            _AnimateChild2['default'],
	            {
	              key: child.key,
	              ref: function ref(node) {
	                _this4.childrenRefs[child.key] = node;
	              },
	              animation: props.animation,
	              transitionName: props.transitionName,
	              transitionEnter: props.transitionEnter,
	              transitionAppear: props.transitionAppear,
	              transitionLeave: props.transitionLeave
	            },
	            child
	          );
	        });
	      }
	      var Component = props.component;
	      if (Component) {
	        var passedProps = props;
	        if (typeof Component === 'string') {
	          passedProps = _extends({
	            className: props.className,
	            style: props.style
	          }, props.componentProps);
	        }
	        return _react2['default'].createElement(
	          Component,
	          passedProps,
	          children
	        );
	      }
	      return children[0] || null;
	    }
	  }]);
	
	  return Animate;
	}(_react2['default'].Component);
	
	Animate.isAnimate = true;
	Animate.defaultProps = {
	  animation: {},
	  component: 'span',
	  componentProps: {},
	  transitionEnter: true,
	  transitionLeave: true,
	  transitionAppear: false,
	  onEnd: noop,
	  onEnter: noop,
	  onLeave: noop,
	  onAppear: noop
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.performEnter = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
	    }
	  };
	
	  this.performAppear = function (key) {
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
	    }
	  };
	
	  this.handleDoneAdding = function (key, type) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    if (!_this5.isValidChildByKey(currentChildren, key)) {
	      // exclusive will not need this
	      _this5.performLeave(key);
	    } else if (type === 'appear') {
	      if (_animate2['default'].allowAppearCallback(props)) {
	        props.onAppear(key);
	        props.onEnd(key, true);
	      }
	    } else if (_animate2['default'].allowEnterCallback(props)) {
	      props.onEnter(key);
	      props.onEnd(key, true);
	    }
	  };
	
	  this.performLeave = function (key) {
	    // may already remove by exclusive
	    if (_this5.childrenRefs[key]) {
	      _this5.currentlyAnimatingKeys[key] = true;
	      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
	    }
	  };
	
	  this.handleDoneLeaving = function (key) {
	    var props = _this5.props;
	    delete _this5.currentlyAnimatingKeys[key];
	    // if update on exclusive mode, skip check
	    if (props.exclusive && props !== _this5.nextProps) {
	      return;
	    }
	    var currentChildren = (0, _ChildrenUtils.toArrayChildren)(getChildrenFromProps(props));
	    // in case state change is too fast
	    if (_this5.isValidChildByKey(currentChildren, key)) {
	      _this5.performEnter(key);
	    } else {
	      var end = function end() {
	        if (_animate2['default'].allowLeaveCallback(props)) {
	          props.onLeave(key);
	          props.onEnd(key, false);
	        }
	      };
	      if (!(0, _ChildrenUtils.isSameChildren)(_this5.state.children, currentChildren, props.showProp)) {
	        _this5.setState({
	          children: currentChildren
	        }, end);
	      } else {
	        end();
	      }
	    }
	  };
	};
	
	exports['default'] = (0, _unsafeLifecyclesPolyfill2['default'])(Animate);
	module.exports = exports['default'];

/***/ },
/* 2765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _cssAnimation = __webpack_require__(1216);
	
	var _cssAnimation2 = _interopRequireDefault(_cssAnimation);
	
	var _animate = __webpack_require__(1116);
	
	var _animate2 = _interopRequireDefault(_animate);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */
	
	
	var transitionMap = {
	  enter: 'transitionEnter',
	  appear: 'transitionAppear',
	  leave: 'transitionLeave'
	};
	
	var AnimateChild = function (_React$Component) {
	  _inherits(AnimateChild, _React$Component);
	
	  function AnimateChild() {
	    _classCallCheck(this, AnimateChild);
	
	    return _possibleConstructorReturn(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
	  }
	
	  _createClass(AnimateChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.stop();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(done) {
	      if (_animate2['default'].isEnterSupported(this.props)) {
	        this.transition('enter', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(done) {
	      if (_animate2['default'].isAppearSupported(this.props)) {
	        this.transition('appear', done);
	      } else {
	        done();
	      }
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(done) {
	      if (_animate2['default'].isLeaveSupported(this.props)) {
	        this.transition('leave', done);
	      } else {
	        // always sync, do not interupt with react component life cycle
	        // update hidden -> animate hidden ->
	        // didUpdate -> animate leave -> unmount (if animate is none)
	        done();
	      }
	    }
	  }, {
	    key: 'transition',
	    value: function transition(animationType, finishCallback) {
	      var _this2 = this;
	
	      var node = _reactDom2['default'].findDOMNode(this);
	      var props = this.props;
	      var transitionName = props.transitionName;
	      var nameIsObj = typeof transitionName === 'object';
	      this.stop();
	      var end = function end() {
	        _this2.stopper = null;
	        finishCallback();
	      };
	      if ((_cssAnimation.isCssAnimationSupported || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
	        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
	        var activeName = name + '-active';
	        if (nameIsObj && transitionName[animationType + 'Active']) {
	          activeName = transitionName[animationType + 'Active'];
	        }
	        this.stopper = (0, _cssAnimation2['default'])(node, {
	          name: name,
	          active: activeName
	        }, end);
	      } else {
	        this.stopper = props.animation[animationType](node, end);
	      }
	    }
	  }, {
	    key: 'stop',
	    value: function stop() {
	      var stopper = this.stopper;
	      if (stopper) {
	        this.stopper = null;
	        stopper.stop();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	
	  return AnimateChild;
	}(_react2['default'].Component);
	
	exports['default'] = AnimateChild;
	module.exports = exports['default'];

/***/ },
/* 2766 */
2638,
/* 2767 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _warning = _interopRequireDefault(__webpack_require__(94));
	
	var _toArray = _interopRequireDefault(__webpack_require__(112));
	
	var _reactLifecyclesCompat = __webpack_require__(15);
	
	var _contextTypes = __webpack_require__(1118);
	
	var _util = __webpack_require__(302);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { return function () { var Super = _getPrototypeOf(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	var Tree = /*#__PURE__*/function (_React$Component) {
	  _inherits(Tree, _React$Component);
	
	  var _super = _createSuper(Tree);
	
	  function Tree() {
	    var _this;
	
	    _classCallCheck(this, Tree);
	
	    _this = _super.apply(this, arguments);
	    /** Internal usage for `rc-tree-select`, we don't promise it will not change. */
	
	    _this.domTreeNodes = {};
	    _this.state = {
	      keyEntities: {},
	      selectedKeys: [],
	      checkedKeys: [],
	      halfCheckedKeys: [],
	      loadedKeys: [],
	      loadingKeys: [],
	      expandedKeys: [],
	      dragNodesKeys: [],
	      dragOverNodeKey: null,
	      dropPosition: null,
	      treeNode: [],
	      prevProps: null
	    };
	
	    _this.onNodeDragStart = function (event, node) {
	      var expandedKeys = _this.state.expandedKeys;
	      var onDragStart = _this.props.onDragStart;
	      var _node$props = node.props,
	          eventKey = _node$props.eventKey,
	          children = _node$props.children;
	      _this.dragNode = node;
	
	      _this.setState({
	        dragNodesKeys: (0, _util.getDragNodesKeys)(children, node),
	        expandedKeys: (0, _util.arrDel)(expandedKeys, eventKey)
	      });
	
	      if (onDragStart) {
	        onDragStart({
	          event: event,
	          node: node
	        });
	      }
	    };
	    /**
	     * [Legacy] Select handler is less small than node,
	     * so that this will trigger when drag enter node or select handler.
	     * This is a little tricky if customize css without padding.
	     * Better for use mouse move event to refresh drag state.
	     * But let's just keep it to avoid event trigger logic change.
	     */
	
	
	    _this.onNodeDragEnter = function (event, node) {
	      var _this$state = _this.state,
	          expandedKeys = _this$state.expandedKeys,
	          dragNodesKeys = _this$state.dragNodesKeys;
	      var onDragEnter = _this.props.onDragEnter;
	      var _node$props2 = node.props,
	          pos = _node$props2.pos,
	          eventKey = _node$props2.eventKey;
	      if (!_this.dragNode || dragNodesKeys.indexOf(eventKey) !== -1) return;
	      var dropPosition = (0, _util.calcDropPosition)(event, node); // Skip if drag node is self
	
	      if (_this.dragNode.props.eventKey === eventKey && dropPosition === 0) {
	        _this.setState({
	          dragOverNodeKey: '',
	          dropPosition: null
	        });
	
	        return;
	      } // Ref: https://github.com/react-component/tree/issues/132
	      // Add timeout to let onDragLevel fire before onDragEnter,
	      // so that we can clean drag props for onDragLeave node.
	      // Macro task for this:
	      // https://html.spec.whatwg.org/multipage/webappapis.html#clean-up-after-running-script
	
	
	      setTimeout(function () {
	        // Update drag over node
	        _this.setState({
	          dragOverNodeKey: eventKey,
	          dropPosition: dropPosition
	        }); // Side effect for delay drag
	
	
	        if (!_this.delayedDragEnterLogic) {
	          _this.delayedDragEnterLogic = {};
	        }
	
	        Object.keys(_this.delayedDragEnterLogic).forEach(function (key) {
	          clearTimeout(_this.delayedDragEnterLogic[key]);
	        });
	        _this.delayedDragEnterLogic[pos] = window.setTimeout(function () {
	          var newExpandedKeys = (0, _util.arrAdd)(expandedKeys, eventKey);
	
	          if (!('expandedKeys' in _this.props)) {
	            _this.setState({
	              expandedKeys: newExpandedKeys
	            });
	          }
	
	          if (onDragEnter) {
	            onDragEnter({
	              event: event,
	              node: node,
	              expandedKeys: newExpandedKeys
	            });
	          }
	        }, 400);
	      }, 0);
	    };
	
	    _this.onNodeDragOver = function (event, node) {
	      var dragNodesKeys = _this.state.dragNodesKeys;
	      var onDragOver = _this.props.onDragOver;
	      var eventKey = node.props.eventKey;
	
	      if (dragNodesKeys.indexOf(eventKey) !== -1) {
	        return;
	      } // Update drag position
	
	
	      if (_this.dragNode && eventKey === _this.state.dragOverNodeKey) {
	        var dropPosition = (0, _util.calcDropPosition)(event, node);
	        if (dropPosition === _this.state.dropPosition) return;
	
	        _this.setState({
	          dropPosition: dropPosition
	        });
	      }
	
	      if (onDragOver) {
	        onDragOver({
	          event: event,
	          node: node
	        });
	      }
	    };
	
	    _this.onNodeDragLeave = function (event, node) {
	      var onDragLeave = _this.props.onDragLeave;
	
	      _this.setState({
	        dragOverNodeKey: ''
	      });
	
	      if (onDragLeave) {
	        onDragLeave({
	          event: event,
	          node: node
	        });
	      }
	    };
	
	    _this.onNodeDragEnd = function (event, node) {
	      var onDragEnd = _this.props.onDragEnd;
	
	      _this.setState({
	        dragOverNodeKey: ''
	      });
	
	      if (onDragEnd) {
	        onDragEnd({
	          event: event,
	          node: node
	        });
	      }
	
	      _this.dragNode = null;
	    };
	
	    _this.onNodeDrop = function (event, node) {
	      var _this$state2 = _this.state,
	          _this$state2$dragNode = _this$state2.dragNodesKeys,
	          dragNodesKeys = _this$state2$dragNode === void 0 ? [] : _this$state2$dragNode,
	          dropPosition = _this$state2.dropPosition;
	      var onDrop = _this.props.onDrop;
	      var _node$props3 = node.props,
	          eventKey = _node$props3.eventKey,
	          pos = _node$props3.pos;
	
	      _this.setState({
	        dragOverNodeKey: ''
	      });
	
	      if (dragNodesKeys.indexOf(eventKey) !== -1) {
	        (0, _warning.default)(false, "Can not drop to dragNode(include it's children node)");
	        return;
	      }
	
	      var posArr = (0, _util.posToArr)(pos);
	      var dropResult = {
	        event: event,
	        node: node,
	        dragNode: _this.dragNode,
	        dragNodesKeys: dragNodesKeys.slice(),
	        dropPosition: dropPosition + Number(posArr[posArr.length - 1]),
	        dropToGap: false
	      };
	
	      if (dropPosition !== 0) {
	        dropResult.dropToGap = true;
	      }
	
	      if (onDrop) {
	        onDrop(dropResult);
	      }
	
	      _this.dragNode = null;
	    };
	
	    _this.onNodeClick = function (e, treeNode) {
	      var onClick = _this.props.onClick;
	
	      if (onClick) {
	        onClick(e, treeNode);
	      }
	    };
	
	    _this.onNodeDoubleClick = function (e, treeNode) {
	      var onDoubleClick = _this.props.onDoubleClick;
	
	      if (onDoubleClick) {
	        onDoubleClick(e, treeNode);
	      }
	    };
	
	    _this.onNodeSelect = function (e, treeNode) {
	      var selectedKeys = _this.state.selectedKeys;
	      var keyEntities = _this.state.keyEntities;
	      var _this$props = _this.props,
	          onSelect = _this$props.onSelect,
	          multiple = _this$props.multiple;
	      var _treeNode$props = treeNode.props,
	          selected = _treeNode$props.selected,
	          eventKey = _treeNode$props.eventKey;
	      var targetSelected = !selected; // Update selected keys
	
	      if (!targetSelected) {
	        selectedKeys = (0, _util.arrDel)(selectedKeys, eventKey);
	      } else if (!multiple) {
	        selectedKeys = [eventKey];
	      } else {
	        selectedKeys = (0, _util.arrAdd)(selectedKeys, eventKey);
	      } // [Legacy] Not found related usage in doc or upper libs
	
	
	      var selectedNodes = selectedKeys.map(function (key) {
	        var entity = keyEntities[key];
	        if (!entity) return null;
	        return entity.node;
	      }).filter(function (node) {
	        return node;
	      });
	
	      _this.setUncontrolledState({
	        selectedKeys: selectedKeys
	      });
	
	      if (onSelect) {
	        onSelect(selectedKeys, {
	          event: 'select',
	          selected: targetSelected,
	          node: treeNode,
	          selectedNodes: selectedNodes,
	          nativeEvent: e.nativeEvent
	        });
	      }
	    };
	
	    _this.onNodeCheck = function (e, treeNode, checked) {
	      var _this$state3 = _this.state,
	          keyEntities = _this$state3.keyEntities,
	          oriCheckedKeys = _this$state3.checkedKeys,
	          oriHalfCheckedKeys = _this$state3.halfCheckedKeys;
	      var _this$props2 = _this.props,
	          checkStrictly = _this$props2.checkStrictly,
	          onCheck = _this$props2.onCheck;
	      var eventKey = treeNode.props.eventKey; // Prepare trigger arguments
	
	      var checkedObj;
	      var eventObj = {
	        event: 'check',
	        node: treeNode,
	        checked: checked,
	        nativeEvent: e.nativeEvent
	      };
	
	      if (checkStrictly) {
	        var checkedKeys = checked ? (0, _util.arrAdd)(oriCheckedKeys, eventKey) : (0, _util.arrDel)(oriCheckedKeys, eventKey);
	        var halfCheckedKeys = (0, _util.arrDel)(oriHalfCheckedKeys, eventKey);
	        checkedObj = {
	          checked: checkedKeys,
	          halfChecked: halfCheckedKeys
	        };
	        eventObj.checkedNodes = checkedKeys.map(function (key) {
	          return keyEntities[key];
	        }).filter(function (entity) {
	          return entity;
	        }).map(function (entity) {
	          return entity.node;
	        });
	
	        _this.setUncontrolledState({
	          checkedKeys: checkedKeys
	        });
	      } else {
	        var _conductCheck = (0, _util.conductCheck)([eventKey], checked, keyEntities, {
	          checkedKeys: oriCheckedKeys,
	          halfCheckedKeys: oriHalfCheckedKeys
	        }),
	            _checkedKeys = _conductCheck.checkedKeys,
	            _halfCheckedKeys = _conductCheck.halfCheckedKeys;
	
	        checkedObj = _checkedKeys; // [Legacy] This is used for `rc-tree-select`
	
	        eventObj.checkedNodes = [];
	        eventObj.checkedNodesPositions = [];
	        eventObj.halfCheckedKeys = _halfCheckedKeys;
	
	        _checkedKeys.forEach(function (key) {
	          var entity = keyEntities[key];
	          if (!entity) return;
	          var node = entity.node,
	              pos = entity.pos;
	          eventObj.checkedNodes.push(node);
	          eventObj.checkedNodesPositions.push({
	            node: node,
	            pos: pos
	          });
	        });
	
	        _this.setUncontrolledState({
	          checkedKeys: _checkedKeys,
	          halfCheckedKeys: _halfCheckedKeys
	        });
	      }
	
	      if (onCheck) {
	        onCheck(checkedObj, eventObj);
	      }
	    };
	
	    _this.onNodeLoad = function (treeNode) {
	      return new Promise(function (resolve) {
	        // We need to get the latest state of loading/loaded keys
	        _this.setState(function (_ref) {
	          var _ref$loadedKeys = _ref.loadedKeys,
	              loadedKeys = _ref$loadedKeys === void 0 ? [] : _ref$loadedKeys,
	              _ref$loadingKeys = _ref.loadingKeys,
	              loadingKeys = _ref$loadingKeys === void 0 ? [] : _ref$loadingKeys;
	          var _this$props3 = _this.props,
	              loadData = _this$props3.loadData,
	              onLoad = _this$props3.onLoad;
	          var eventKey = treeNode.props.eventKey;
	
	          if (!loadData || loadedKeys.indexOf(eventKey) !== -1 || loadingKeys.indexOf(eventKey) !== -1) {
	            // react 15 will warn if return null
	            return {};
	          } // Process load data
	
	
	          var promise = loadData(treeNode);
	          promise.then(function () {
	            var _this$state4 = _this.state,
	                currentLoadedKeys = _this$state4.loadedKeys,
	                currentLoadingKeys = _this$state4.loadingKeys;
	            var newLoadedKeys = (0, _util.arrAdd)(currentLoadedKeys, eventKey);
	            var newLoadingKeys = (0, _util.arrDel)(currentLoadingKeys, eventKey); // onLoad should trigger before internal setState to avoid `loadData` trigger twice.
	            // https://github.com/ant-design/ant-design/issues/12464
	
	            if (onLoad) {
	              onLoad(newLoadedKeys, {
	                event: 'load',
	                node: treeNode
	              });
	            }
	
	            _this.setUncontrolledState({
	              loadedKeys: newLoadedKeys
	            });
	
	            _this.setState({
	              loadingKeys: newLoadingKeys
	            });
	
	            resolve();
	          });
	          return {
	            loadingKeys: (0, _util.arrAdd)(loadingKeys, eventKey)
	          };
	        });
	      });
	    };
	
	    _this.onNodeExpand = function (e, treeNode) {
	      var expandedKeys = _this.state.expandedKeys;
	      var _this$props4 = _this.props,
	          onExpand = _this$props4.onExpand,
	          loadData = _this$props4.loadData;
	      var _treeNode$props2 = treeNode.props,
	          eventKey = _treeNode$props2.eventKey,
	          expanded = _treeNode$props2.expanded; // Update selected keys
	
	      var index = expandedKeys.indexOf(eventKey);
	      var targetExpanded = !expanded;
	      (0, _warning.default)(expanded && index !== -1 || !expanded && index === -1, 'Expand state not sync with index check');
	
	      if (targetExpanded) {
	        expandedKeys = (0, _util.arrAdd)(expandedKeys, eventKey);
	      } else {
	        expandedKeys = (0, _util.arrDel)(expandedKeys, eventKey);
	      }
	
	      _this.setUncontrolledState({
	        expandedKeys: expandedKeys
	      });
	
	      if (onExpand) {
	        onExpand(expandedKeys, {
	          node: treeNode,
	          expanded: targetExpanded,
	          nativeEvent: e.nativeEvent
	        });
	      } // Async Load data
	
	
	      if (targetExpanded && loadData) {
	        var loadPromise = _this.onNodeLoad(treeNode);
	
	        return loadPromise ? loadPromise.then(function () {
	          // [Legacy] Refresh logic
	          _this.setUncontrolledState({
	            expandedKeys: expandedKeys
	          });
	        }) : null;
	      }
	
	      return null;
	    };
	
	    _this.onNodeMouseEnter = function (event, node) {
	      var onMouseEnter = _this.props.onMouseEnter;
	
	      if (onMouseEnter) {
	        onMouseEnter({
	          event: event,
	          node: node
	        });
	      }
	    };
	
	    _this.onNodeMouseLeave = function (event, node) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      if (onMouseLeave) {
	        onMouseLeave({
	          event: event,
	          node: node
	        });
	      }
	    };
	
	    _this.onNodeContextMenu = function (event, node) {
	      var onRightClick = _this.props.onRightClick;
	
	      if (onRightClick) {
	        event.preventDefault();
	        onRightClick({
	          event: event,
	          node: node
	        });
	      }
	    };
	    /**
	     * Only update the value which is not in props
	     */
	
	
	    _this.setUncontrolledState = function (state) {
	      var needSync = false;
	      var newState = {};
	      Object.keys(state).forEach(function (name) {
	        if (name in _this.props) return;
	        needSync = true;
	        newState[name] = state[name];
	      });
	
	      if (needSync) {
	        _this.setState(newState);
	      }
	    };
	
	    _this.registerTreeNode = function (key, node) {
	      if (node) {
	        _this.domTreeNodes[key] = node;
	      } else {
	        delete _this.domTreeNodes[key];
	      }
	    };
	
	    _this.isKeyChecked = function (key) {
	      var _this$state$checkedKe = _this.state.checkedKeys,
	          checkedKeys = _this$state$checkedKe === void 0 ? [] : _this$state$checkedKe;
	      return checkedKeys.indexOf(key) !== -1;
	    };
	    /**
	     * [Legacy] Original logic use `key` as tracking clue.
	     * We have to use `cloneElement` to pass `key`.
	     */
	
	
	    _this.renderTreeNode = function (child, index) {
	      var level = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
	      var _this$state5 = _this.state,
	          keyEntities = _this$state5.keyEntities,
	          _this$state5$expanded = _this$state5.expandedKeys,
	          expandedKeys = _this$state5$expanded === void 0 ? [] : _this$state5$expanded,
	          _this$state5$selected = _this$state5.selectedKeys,
	          selectedKeys = _this$state5$selected === void 0 ? [] : _this$state5$selected,
	          _this$state5$halfChec = _this$state5.halfCheckedKeys,
	          halfCheckedKeys = _this$state5$halfChec === void 0 ? [] : _this$state5$halfChec,
	          _this$state5$loadedKe = _this$state5.loadedKeys,
	          loadedKeys = _this$state5$loadedKe === void 0 ? [] : _this$state5$loadedKe,
	          _this$state5$loadingK = _this$state5.loadingKeys,
	          loadingKeys = _this$state5$loadingK === void 0 ? [] : _this$state5$loadingK,
	          dragOverNodeKey = _this$state5.dragOverNodeKey,
	          dropPosition = _this$state5.dropPosition;
	      var pos = (0, _util.getPosition)(level, index);
	      var key = child.key || pos;
	
	      if (!keyEntities[key]) {
	        (0, _util.warnOnlyTreeNode)();
	        return null;
	      }
	
	      return React.cloneElement(child, {
	        key: key,
	        eventKey: key,
	        expanded: expandedKeys.indexOf(key) !== -1,
	        selected: selectedKeys.indexOf(key) !== -1,
	        loaded: loadedKeys.indexOf(key) !== -1,
	        loading: loadingKeys.indexOf(key) !== -1,
	        checked: _this.isKeyChecked(key),
	        halfChecked: halfCheckedKeys.indexOf(key) !== -1,
	        pos: pos,
	        // [Legacy] Drag props
	        dragOver: dragOverNodeKey === key && dropPosition === 0,
	        dragOverGapTop: dragOverNodeKey === key && dropPosition === -1,
	        dragOverGapBottom: dragOverNodeKey === key && dropPosition === 1
	      });
	    };
	
	    return _this;
	  }
	
	  _createClass(Tree, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var treeNode = this.state.treeNode;
	      var _this$props5 = this.props,
	          prefixCls = _this$props5.prefixCls,
	          className = _this$props5.className,
	          focusable = _this$props5.focusable,
	          style = _this$props5.style,
	          showLine = _this$props5.showLine,
	          _this$props5$tabIndex = _this$props5.tabIndex,
	          tabIndex = _this$props5$tabIndex === void 0 ? 0 : _this$props5$tabIndex,
	          selectable = _this$props5.selectable,
	          showIcon = _this$props5.showIcon,
	          icon = _this$props5.icon,
	          switcherIcon = _this$props5.switcherIcon,
	          draggable = _this$props5.draggable,
	          checkable = _this$props5.checkable,
	          checkStrictly = _this$props5.checkStrictly,
	          disabled = _this$props5.disabled,
	          motion = _this$props5.motion,
	          loadData = _this$props5.loadData,
	          filterTreeNode = _this$props5.filterTreeNode;
	      var domProps = (0, _util.getDataAndAria)(this.props);
	
	      if (focusable) {
	        domProps.tabIndex = tabIndex;
	      }
	
	      return React.createElement(_contextTypes.TreeContext.Provider, {
	        value: {
	          prefixCls: prefixCls,
	          selectable: selectable,
	          showIcon: showIcon,
	          icon: icon,
	          switcherIcon: switcherIcon,
	          draggable: draggable,
	          checkable: checkable,
	          checkStrictly: checkStrictly,
	          disabled: disabled,
	          motion: motion,
	          loadData: loadData,
	          filterTreeNode: filterTreeNode,
	          renderTreeNode: this.renderTreeNode,
	          isKeyChecked: this.isKeyChecked,
	          onNodeClick: this.onNodeClick,
	          onNodeDoubleClick: this.onNodeDoubleClick,
	          onNodeExpand: this.onNodeExpand,
	          onNodeSelect: this.onNodeSelect,
	          onNodeCheck: this.onNodeCheck,
	          onNodeLoad: this.onNodeLoad,
	          onNodeMouseEnter: this.onNodeMouseEnter,
	          onNodeMouseLeave: this.onNodeMouseLeave,
	          onNodeContextMenu: this.onNodeContextMenu,
	          onNodeDragStart: this.onNodeDragStart,
	          onNodeDragEnter: this.onNodeDragEnter,
	          onNodeDragOver: this.onNodeDragOver,
	          onNodeDragLeave: this.onNodeDragLeave,
	          onNodeDragEnd: this.onNodeDragEnd,
	          onNodeDrop: this.onNodeDrop,
	          registerTreeNode: this.registerTreeNode
	        }
	      }, React.createElement("ul", Object.assign({}, domProps, {
	        className: (0, _classnames.default)(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-show-line"), showLine)),
	        style: style,
	        role: "tree",
	        unselectable: "on"
	      }), (0, _util.mapChildren)(treeNode, function (node, index) {
	        return _this2.renderTreeNode(node, index);
	      })));
	    }
	  }], [{
	    key: "getDerivedStateFromProps",
	    value: function getDerivedStateFromProps(props, prevState) {
	      var prevProps = prevState.prevProps;
	      var newState = {
	        prevProps: props
	      };
	
	      function needSync(name) {
	        return !prevProps && name in props || prevProps && prevProps[name] !== props[name];
	      } // ================== Tree Node ==================
	
	
	      var treeNode = null; // Check if `treeData` or `children` changed and save into the state.
	
	      if (needSync('treeData')) {
	        treeNode = (0, _util.convertDataToTree)(props.treeData);
	      } else if (needSync('children')) {
	        treeNode = (0, _toArray.default)(props.children);
	      } // Tree support filter function which will break the tree structure in the vdm.
	      // We cache the treeNodes in state so that we can return the treeNode in event trigger.
	
	
	      if (treeNode) {
	        newState.treeNode = treeNode; // Calculate the entities data for quick match
	
	        var entitiesMap = (0, _util.convertTreeToEntities)(treeNode);
	        newState.keyEntities = entitiesMap.keyEntities;
	      }
	
	      var keyEntities = newState.keyEntities || prevState.keyEntities; // ================ expandedKeys =================
	
	      if (needSync('expandedKeys') || prevProps && needSync('autoExpandParent')) {
	        newState.expandedKeys = props.autoExpandParent || !prevProps && props.defaultExpandParent ? (0, _util.conductExpandParent)(props.expandedKeys, keyEntities) : props.expandedKeys;
	      } else if (!prevProps && props.defaultExpandAll) {
	        newState.expandedKeys = Object.keys(keyEntities);
	      } else if (!prevProps && props.defaultExpandedKeys) {
	        newState.expandedKeys = props.autoExpandParent || props.defaultExpandParent ? (0, _util.conductExpandParent)(props.defaultExpandedKeys, keyEntities) : props.defaultExpandedKeys;
	      } // ================ selectedKeys =================
	
	
	      if (props.selectable) {
	        if (needSync('selectedKeys')) {
	          newState.selectedKeys = (0, _util.calcSelectedKeys)(props.selectedKeys, props);
	        } else if (!prevProps && props.defaultSelectedKeys) {
	          newState.selectedKeys = (0, _util.calcSelectedKeys)(props.defaultSelectedKeys, props);
	        }
	      } // ================= checkedKeys =================
	
	
	      if (props.checkable) {
	        var checkedKeyEntity;
	
	        if (needSync('checkedKeys')) {
	          checkedKeyEntity = (0, _util.parseCheckedKeys)(props.checkedKeys) || {};
	        } else if (!prevProps && props.defaultCheckedKeys) {
	          checkedKeyEntity = (0, _util.parseCheckedKeys)(props.defaultCheckedKeys) || {};
	        } else if (treeNode) {
	          // If treeNode changed, we also need check it
	          checkedKeyEntity = (0, _util.parseCheckedKeys)(props.checkedKeys) || {
	            checkedKeys: prevState.checkedKeys,
	            halfCheckedKeys: prevState.halfCheckedKeys
	          };
	        }
	
	        if (checkedKeyEntity) {
	          var _checkedKeyEntity = checkedKeyEntity,
	              _checkedKeyEntity$che = _checkedKeyEntity.checkedKeys,
	              checkedKeys = _checkedKeyEntity$che === void 0 ? [] : _checkedKeyEntity$che,
	              _checkedKeyEntity$hal = _checkedKeyEntity.halfCheckedKeys,
	              halfCheckedKeys = _checkedKeyEntity$hal === void 0 ? [] : _checkedKeyEntity$hal;
	
	          if (!props.checkStrictly) {
	            var conductKeys = (0, _util.conductCheck)(checkedKeys, true, keyEntities);
	            checkedKeys = conductKeys.checkedKeys;
	            halfCheckedKeys = conductKeys.halfCheckedKeys;
	          }
	
	          newState.checkedKeys = checkedKeys;
	          newState.halfCheckedKeys = halfCheckedKeys;
	        }
	      } // ================= loadedKeys ==================
	
	
	      if (needSync('loadedKeys')) {
	        newState.loadedKeys = props.loadedKeys;
	      }
	
	      return newState;
	    }
	  }]);
	
	  return Tree;
	}(React.Component);
	
	Tree.propTypes = {
	  prefixCls: _propTypes.default.string,
	  className: _propTypes.default.string,
	  style: _propTypes.default.object,
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
	  children: _propTypes.default.any,
	  treeData: _propTypes.default.array,
	  showLine: _propTypes.default.bool,
	  showIcon: _propTypes.default.bool,
	  icon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	  focusable: _propTypes.default.bool,
	  selectable: _propTypes.default.bool,
	  disabled: _propTypes.default.bool,
	  multiple: _propTypes.default.bool,
	  checkable: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.node]),
	  checkStrictly: _propTypes.default.bool,
	  draggable: _propTypes.default.bool,
	  defaultExpandParent: _propTypes.default.bool,
	  autoExpandParent: _propTypes.default.bool,
	  defaultExpandAll: _propTypes.default.bool,
	  defaultExpandedKeys: _propTypes.default.arrayOf(_propTypes.default.string),
	  expandedKeys: _propTypes.default.arrayOf(_propTypes.default.string),
	  defaultCheckedKeys: _propTypes.default.arrayOf(_propTypes.default.string),
	  checkedKeys: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])), _propTypes.default.object]),
	  defaultSelectedKeys: _propTypes.default.arrayOf(_propTypes.default.string),
	  selectedKeys: _propTypes.default.arrayOf(_propTypes.default.string),
	  onClick: _propTypes.default.func,
	  onDoubleClick: _propTypes.default.func,
	  onExpand: _propTypes.default.func,
	  onCheck: _propTypes.default.func,
	  onSelect: _propTypes.default.func,
	  onLoad: _propTypes.default.func,
	  loadData: _propTypes.default.func,
	  loadedKeys: _propTypes.default.arrayOf(_propTypes.default.string),
	  onMouseEnter: _propTypes.default.func,
	  onMouseLeave: _propTypes.default.func,
	  onRightClick: _propTypes.default.func,
	  onDragStart: _propTypes.default.func,
	  onDragEnter: _propTypes.default.func,
	  onDragOver: _propTypes.default.func,
	  onDragLeave: _propTypes.default.func,
	  onDragEnd: _propTypes.default.func,
	  onDrop: _propTypes.default.func,
	  filterTreeNode: _propTypes.default.func,
	  motion: _propTypes.default.object,
	  switcherIcon: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func])
	};
	Tree.defaultProps = {
	  prefixCls: 'rc-tree',
	  showLine: false,
	  showIcon: true,
	  selectable: true,
	  multiple: false,
	  checkable: false,
	  disabled: false,
	  checkStrictly: false,
	  draggable: false,
	  defaultExpandParent: true,
	  autoExpandParent: false,
	  defaultExpandAll: false,
	  defaultExpandedKeys: [],
	  defaultCheckedKeys: [],
	  defaultSelectedKeys: []
	};
	(0, _reactLifecyclesCompat.polyfill)(Tree);
	var _default = Tree;
	exports.default = _default;

/***/ },
/* 2768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _rcAlign = __webpack_require__(1069);
	
	var _rcAlign2 = _interopRequireDefault(_rcAlign);
	
	var _rcAnimate = __webpack_require__(111);
	
	var _rcAnimate2 = _interopRequireDefault(_rcAnimate);
	
	var _PopupInner = __webpack_require__(2769);
	
	var _PopupInner2 = _interopRequireDefault(_PopupInner);
	
	var _LazyRenderBox = __webpack_require__(1119);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	var _utils = __webpack_require__(1120);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var Popup = function (_Component) {
	  (0, _inherits3['default'])(Popup, _Component);
	
	  function Popup(props) {
	    (0, _classCallCheck3['default'])(this, Popup);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _Component.call(this, props));
	
	    _initialiseProps.call(_this);
	
	    _this.state = {
	      // Used for stretch
	      stretchChecked: false,
	      targetWidth: undefined,
	      targetHeight: undefined
	    };
	
	    _this.savePopupRef = _utils.saveRef.bind(_this, 'popupInstance');
	    _this.saveAlignRef = _utils.saveRef.bind(_this, 'alignInstance');
	    return _this;
	  }
	
	  Popup.prototype.componentDidMount = function componentDidMount() {
	    this.rootNode = this.getPopupDomNode();
	    this.setStretchSize();
	  };
	
	  Popup.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.setStretchSize();
	  };
	
	  // Record size if stretch needed
	
	
	  Popup.prototype.getPopupDomNode = function getPopupDomNode() {
	    return _reactDom2['default'].findDOMNode(this.popupInstance);
	  };
	
	  // `target` on `rc-align` can accept as a function to get the bind element or a point.
	  // ref: https://www.npmjs.com/package/rc-align
	
	
	  Popup.prototype.getMaskTransitionName = function getMaskTransitionName() {
	    var props = this.props;
	    var transitionName = props.maskTransitionName;
	    var animation = props.maskAnimation;
	    if (!transitionName && animation) {
	      transitionName = props.prefixCls + '-' + animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getTransitionName = function getTransitionName() {
	    var props = this.props;
	    var transitionName = props.transitionName;
	    if (!transitionName && props.animation) {
	      transitionName = props.prefixCls + '-' + props.animation;
	    }
	    return transitionName;
	  };
	
	  Popup.prototype.getClassName = function getClassName(currentAlignClassName) {
	    return this.props.prefixCls + ' ' + this.props.className + ' ' + currentAlignClassName;
	  };
	
	  Popup.prototype.getPopupElement = function getPopupElement() {
	    var _this2 = this;
	
	    var savePopupRef = this.savePopupRef;
	    var _state = this.state,
	        stretchChecked = _state.stretchChecked,
	        targetHeight = _state.targetHeight,
	        targetWidth = _state.targetWidth;
	    var _props = this.props,
	        align = _props.align,
	        visible = _props.visible,
	        prefixCls = _props.prefixCls,
	        style = _props.style,
	        getClassNameFromAlign = _props.getClassNameFromAlign,
	        destroyPopupOnHide = _props.destroyPopupOnHide,
	        stretch = _props.stretch,
	        children = _props.children,
	        onMouseEnter = _props.onMouseEnter,
	        onMouseLeave = _props.onMouseLeave,
	        onMouseDown = _props.onMouseDown,
	        onTouchStart = _props.onTouchStart;
	
	    var className = this.getClassName(this.currentAlignClassName || getClassNameFromAlign(align));
	    var hiddenClassName = prefixCls + '-hidden';
	
	    if (!visible) {
	      this.currentAlignClassName = null;
	    }
	
	    var sizeStyle = {};
	    if (stretch) {
	      // Stretch with target
	      if (stretch.indexOf('height') !== -1) {
	        sizeStyle.height = targetHeight;
	      } else if (stretch.indexOf('minHeight') !== -1) {
	        sizeStyle.minHeight = targetHeight;
	      }
	      if (stretch.indexOf('width') !== -1) {
	        sizeStyle.width = targetWidth;
	      } else if (stretch.indexOf('minWidth') !== -1) {
	        sizeStyle.minWidth = targetWidth;
	      }
	
	      // Delay force align to makes ui smooth
	      if (!stretchChecked) {
	        sizeStyle.visibility = 'hidden';
	        setTimeout(function () {
	          if (_this2.alignInstance) {
	            _this2.alignInstance.forceAlign();
	          }
	        }, 0);
	      }
	    }
	
	    var newStyle = (0, _extends3['default'])({}, sizeStyle, style, this.getZIndexStyle());
	
	    var popupInnerProps = {
	      className: className,
	      prefixCls: prefixCls,
	      ref: savePopupRef,
	      onMouseEnter: onMouseEnter,
	      onMouseLeave: onMouseLeave,
	      onMouseDown: onMouseDown,
	      onTouchStart: onTouchStart,
	      style: newStyle
	    };
	    if (destroyPopupOnHide) {
	      return _react2['default'].createElement(
	        _rcAnimate2['default'],
	        {
	          component: '',
	          exclusive: true,
	          transitionAppear: true,
	          transitionName: this.getTransitionName()
	        },
	        visible ? _react2['default'].createElement(
	          _rcAlign2['default'],
	          {
	            target: this.getAlignTarget(),
	            key: 'popup',
	            ref: this.saveAlignRef,
	            monitorWindowResize: true,
	            align: align,
	            onAlign: this.onAlign
	          },
	          _react2['default'].createElement(
	            _PopupInner2['default'],
	            (0, _extends3['default'])({
	              visible: true
	            }, popupInnerProps),
	            children
	          )
	        ) : null
	      );
	    }
	
	    return _react2['default'].createElement(
	      _rcAnimate2['default'],
	      {
	        component: '',
	        exclusive: true,
	        transitionAppear: true,
	        transitionName: this.getTransitionName(),
	        showProp: 'xVisible'
	      },
	      _react2['default'].createElement(
	        _rcAlign2['default'],
	        {
	          target: this.getAlignTarget(),
	          key: 'popup',
	          ref: this.saveAlignRef,
	          monitorWindowResize: true,
	          xVisible: visible,
	          childrenProps: { visible: 'xVisible' },
	          disabled: !visible,
	          align: align,
	          onAlign: this.onAlign
	        },
	        _react2['default'].createElement(
	          _PopupInner2['default'],
	          (0, _extends3['default'])({
	            hiddenClassName: hiddenClassName
	          }, popupInnerProps),
	          children
	        )
	      )
	    );
	  };
	
	  Popup.prototype.getZIndexStyle = function getZIndexStyle() {
	    var style = {};
	    var props = this.props;
	    if (props.zIndex !== undefined) {
	      style.zIndex = props.zIndex;
	    }
	    return style;
	  };
	
	  Popup.prototype.getMaskElement = function getMaskElement() {
	    var props = this.props;
	    var maskElement = void 0;
	    if (props.mask) {
	      var maskTransition = this.getMaskTransitionName();
	      maskElement = _react2['default'].createElement(_LazyRenderBox2['default'], {
	        style: this.getZIndexStyle(),
	        key: 'mask',
	        className: props.prefixCls + '-mask',
	        hiddenClassName: props.prefixCls + '-mask-hidden',
	        visible: props.visible
	      });
	      if (maskTransition) {
	        maskElement = _react2['default'].createElement(
	          _rcAnimate2['default'],
	          {
	            key: 'mask',
	            showProp: 'visible',
	            transitionAppear: true,
	            component: '',
	            transitionName: maskTransition
	          },
	          maskElement
	        );
	      }
	    }
	    return maskElement;
	  };
	
	  Popup.prototype.render = function render() {
	    return _react2['default'].createElement(
	      'div',
	      null,
	      this.getMaskElement(),
	      this.getPopupElement()
	    );
	  };
	
	  return Popup;
	}(_react.Component);
	
	Popup.propTypes = {
	  visible: _propTypes2['default'].bool,
	  style: _propTypes2['default'].object,
	  getClassNameFromAlign: _propTypes2['default'].func,
	  onAlign: _propTypes2['default'].func,
	  getRootDomNode: _propTypes2['default'].func,
	  align: _propTypes2['default'].any,
	  destroyPopupOnHide: _propTypes2['default'].bool,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  stretch: _propTypes2['default'].string,
	  children: _propTypes2['default'].node,
	  point: _propTypes2['default'].shape({
	    pageX: _propTypes2['default'].number,
	    pageY: _propTypes2['default'].number
	  })
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this3 = this;
	
	  this.onAlign = function (popupDomNode, align) {
	    var props = _this3.props;
	    var currentAlignClassName = props.getClassNameFromAlign(align);
	    // FIX: https://github.com/react-component/trigger/issues/56
	    // FIX: https://github.com/react-component/tooltip/issues/79
	    if (_this3.currentAlignClassName !== currentAlignClassName) {
	      _this3.currentAlignClassName = currentAlignClassName;
	      popupDomNode.className = _this3.getClassName(currentAlignClassName);
	    }
	    props.onAlign(popupDomNode, align);
	  };
	
	  this.setStretchSize = function () {
	    var _props2 = _this3.props,
	        stretch = _props2.stretch,
	        getRootDomNode = _props2.getRootDomNode,
	        visible = _props2.visible;
	    var _state2 = _this3.state,
	        stretchChecked = _state2.stretchChecked,
	        targetHeight = _state2.targetHeight,
	        targetWidth = _state2.targetWidth;
	
	
	    if (!stretch || !visible) {
	      if (stretchChecked) {
	        _this3.setState({ stretchChecked: false });
	      }
	      return;
	    }
	
	    var $ele = getRootDomNode();
	    if (!$ele) return;
	
	    var height = $ele.offsetHeight;
	    var width = $ele.offsetWidth;
	
	    if (targetHeight !== height || targetWidth !== width || !stretchChecked) {
	      _this3.setState({
	        stretchChecked: true,
	        targetHeight: height,
	        targetWidth: width
	      });
	    }
	  };
	
	  this.getTargetElement = function () {
	    return _this3.props.getRootDomNode();
	  };
	
	  this.getAlignTarget = function () {
	    var point = _this3.props.point;
	
	    if (point) {
	      return point;
	    }
	    return _this3.getTargetElement;
	  };
	};
	
	exports['default'] = Popup;
	module.exports = exports['default'];

/***/ },
/* 2769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LazyRenderBox = __webpack_require__(1119);
	
	var _LazyRenderBox2 = _interopRequireDefault(_LazyRenderBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var PopupInner = function (_Component) {
	  (0, _inherits3['default'])(PopupInner, _Component);
	
	  function PopupInner() {
	    (0, _classCallCheck3['default'])(this, PopupInner);
	    return (0, _possibleConstructorReturn3['default'])(this, _Component.apply(this, arguments));
	  }
	
	  PopupInner.prototype.render = function render() {
	    var props = this.props;
	    var className = props.className;
	    if (!props.visible) {
	      className += ' ' + props.hiddenClassName;
	    }
	    return _react2['default'].createElement(
	      'div',
	      {
	        className: className,
	        onMouseEnter: props.onMouseEnter,
	        onMouseLeave: props.onMouseLeave,
	        onMouseDown: props.onMouseDown,
	        onTouchStart: props.onTouchStart,
	        style: props.style
	      },
	      _react2['default'].createElement(
	        _LazyRenderBox2['default'],
	        { className: props.prefixCls + '-content', visible: props.visible },
	        props.children
	      )
	    );
	  };
	
	  return PopupInner;
	}(_react.Component);
	
	PopupInner.propTypes = {
	  hiddenClassName: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  prefixCls: _propTypes2['default'].string,
	  onMouseEnter: _propTypes2['default'].func,
	  onMouseLeave: _propTypes2['default'].func,
	  onMouseDown: _propTypes2['default'].func,
	  onTouchStart: _propTypes2['default'].func,
	  children: _propTypes2['default'].any
	};
	exports['default'] = PopupInner;
	module.exports = exports['default'];

/***/ },
/* 2770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _request = __webpack_require__(2775);
	
	var _request2 = _interopRequireDefault(_request);
	
	var _uid = __webpack_require__(1121);
	
	var _uid2 = _interopRequireDefault(_uid);
	
	var _attrAccept = __webpack_require__(2773);
	
	var _attrAccept2 = _interopRequireDefault(_attrAccept);
	
	var _traverseFileTree = __webpack_require__(2776);
	
	var _traverseFileTree2 = _interopRequireDefault(_traverseFileTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var AjaxUploader = function (_Component) {
	  (0, _inherits3['default'])(AjaxUploader, _Component);
	
	  function AjaxUploader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, AjaxUploader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = AjaxUploader.__proto__ || Object.getPrototypeOf(AjaxUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uid: (0, _uid2['default'])() }, _this.reqs = {}, _this.onChange = function (e) {
	      var files = e.target.files;
	      _this.uploadFiles(files);
	      _this.reset();
	    }, _this.onClick = function () {
	      var el = _this.fileInput;
	      if (!el) {
	        return;
	      }
	      el.click();
	    }, _this.onKeyDown = function (e) {
	      if (e.key === 'Enter') {
	        _this.onClick();
	      }
	    }, _this.onFileDrop = function (e) {
	      var multiple = _this.props.multiple;
	
	
	      e.preventDefault();
	
	      if (e.type === 'dragover') {
	        return;
	      }
	
	      if (_this.props.directory) {
	        (0, _traverseFileTree2['default'])(e.dataTransfer.items, _this.uploadFiles, function (_file) {
	          return (0, _attrAccept2['default'])(_file, _this.props.accept);
	        });
	      } else {
	        var files = Array.prototype.slice.call(e.dataTransfer.files).filter(function (file) {
	          return (0, _attrAccept2['default'])(file, _this.props.accept);
	        });
	
	        if (multiple === false) {
	          files = files.slice(0, 1);
	        }
	
	        _this.uploadFiles(files);
	      }
	    }, _this.uploadFiles = function (files) {
	      var postFiles = Array.prototype.slice.call(files);
	      postFiles.map(function (file) {
	        file.uid = (0, _uid2['default'])();
	        return file;
	      }).forEach(function (file) {
	        _this.upload(file, postFiles);
	      });
	    }, _this.saveFileInput = function (node) {
	      _this.fileInput = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(AjaxUploader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._isMounted = true;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._isMounted = false;
	      this.abort();
	    }
	  }, {
	    key: 'upload',
	    value: function upload(file, fileList) {
	      var _this2 = this;
	
	      var props = this.props;
	
	      if (!props.beforeUpload) {
	        // always async in case use react state to keep fileList
	        return setTimeout(function () {
	          return _this2.post(file);
	        }, 0);
	      }
	
	      var before = props.beforeUpload(file, fileList);
	      if (before && before.then) {
	        before.then(function (processedFile) {
	          var processedFileType = Object.prototype.toString.call(processedFile);
	          if (processedFileType === '[object File]' || processedFileType === '[object Blob]') {
	            return _this2.post(processedFile);
	          }
	          return _this2.post(file);
	        })['catch'](function (e) {
	          console && console.log(e); // eslint-disable-line
	        });
	      } else if (before !== false) {
	        setTimeout(function () {
	          return _this2.post(file);
	        }, 0);
	      }
	    }
	  }, {
	    key: 'post',
	    value: function post(file) {
	      var _this3 = this;
	
	      if (!this._isMounted) {
	        return;
	      }
	      var props = this.props;
	      var data = props.data;
	      var onStart = props.onStart,
	          onProgress = props.onProgress,
	          _props$transformFile = props.transformFile,
	          transformFile = _props$transformFile === undefined ? function (originFile) {
	        return originFile;
	      } : _props$transformFile;
	
	
	      new Promise(function (resolve) {
	        var action = props.action;
	
	        if (typeof action === 'function') {
	          return resolve(action(file));
	        }
	        resolve(action);
	      }).then(function (action) {
	        var uid = file.uid;
	
	        var request = props.customRequest || _request2['default'];
	        var transform = Promise.resolve(transformFile(file))['catch'](function (e) {
	          console.error(e); // eslint-disable-line no-console
	        });
	
	        transform.then(function (transformedFile) {
	          if (typeof data === 'function') {
	            data = data(file);
	          }
	
	          var requestOption = {
	            action: action,
	            filename: props.name,
	            data: data,
	            file: transformedFile,
	            headers: props.headers,
	            withCredentials: props.withCredentials,
	            method: props.method || 'post',
	            onProgress: onProgress ? function (e) {
	              onProgress(e, file);
	            } : null,
	            onSuccess: function onSuccess(ret, xhr) {
	              delete _this3.reqs[uid];
	              props.onSuccess(ret, file, xhr);
	            },
	            onError: function onError(err, ret) {
	              delete _this3.reqs[uid];
	              props.onError(err, ret, file);
	            }
	          };
	          _this3.reqs[uid] = request(requestOption);
	          onStart(file);
	        });
	      });
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.setState({
	        uid: (0, _uid2['default'])()
	      });
	    }
	  }, {
	    key: 'abort',
	    value: function abort(file) {
	      var reqs = this.reqs;
	
	      if (file) {
	        var uid = file;
	        if (file && file.uid) {
	          uid = file.uid;
	        }
	        if (reqs[uid] && reqs[uid].abort) {
	          reqs[uid].abort();
	        }
	        delete reqs[uid];
	      } else {
	        Object.keys(reqs).forEach(function (uid) {
	          if (reqs[uid] && reqs[uid].abort) {
	            reqs[uid].abort();
	          }
	          delete reqs[uid];
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          Tag = _props.component,
	          prefixCls = _props.prefixCls,
	          className = _props.className,
	          disabled = _props.disabled,
	          id = _props.id,
	          style = _props.style,
	          multiple = _props.multiple,
	          accept = _props.accept,
	          children = _props.children,
	          directory = _props.directory,
	          openFileDialogOnClick = _props.openFileDialogOnClick;
	
	      var cls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
	      var events = disabled ? {} : {
	        onClick: openFileDialogOnClick ? this.onClick : function () {},
	        onKeyDown: openFileDialogOnClick ? this.onKeyDown : function () {},
	        onDrop: this.onFileDrop,
	        onDragOver: this.onFileDrop,
	        tabIndex: '0'
	      };
	      return _react2['default'].createElement(
	        Tag,
	        (0, _extends3['default'])({}, events, {
	          className: cls,
	          role: 'button',
	          style: style
	        }),
	        _react2['default'].createElement('input', {
	          id: id,
	          type: 'file',
	          ref: this.saveFileInput,
	          onClick: function onClick(e) {
	            return e.stopPropagation();
	          } // https://github.com/ant-design/ant-design/issues/19948
	          , key: this.state.uid,
	          style: { display: 'none' },
	          accept: accept,
	          directory: directory ? 'directory' : null,
	          webkitdirectory: directory ? 'webkitdirectory' : null,
	          multiple: multiple,
	          onChange: this.onChange
	        }),
	        children
	      );
	    }
	  }]);
	  return AjaxUploader;
	}(_react.Component); /* eslint react/no-is-mounted:0 react/sort-comp:0 */
	
	AjaxUploader.propTypes = {
	  id: _propTypes2['default'].string,
	  component: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  multiple: _propTypes2['default'].bool,
	  directory: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  accept: _propTypes2['default'].string,
	  children: _propTypes2['default'].any,
	  onStart: _propTypes2['default'].func,
	  data: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].func]),
	  action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	  headers: _propTypes2['default'].object,
	  beforeUpload: _propTypes2['default'].func,
	  customRequest: _propTypes2['default'].func,
	  onProgress: _propTypes2['default'].func,
	  withCredentials: _propTypes2['default'].bool,
	  openFileDialogOnClick: _propTypes2['default'].bool,
	  transformFile: _propTypes2['default'].func
	};
	exports['default'] = AjaxUploader;
	module.exports = exports['default'];

/***/ },
/* 2771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty2 = __webpack_require__(57);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _uid = __webpack_require__(1121);
	
	var _uid2 = _interopRequireDefault(_uid);
	
	var _warning = __webpack_require__(94);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/* eslint react/sort-comp:0 */
	var IFRAME_STYLE = {
	  position: 'absolute',
	  top: 0,
	  opacity: 0,
	  filter: 'alpha(opacity=0)',
	  left: 0,
	  zIndex: 9999
	};
	
	// diferent from AjaxUpload, can only upload on at one time, serial seriously
	
	var IframeUploader = function (_Component) {
	  (0, _inherits3['default'])(IframeUploader, _Component);
	
	  function IframeUploader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, IframeUploader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = IframeUploader.__proto__ || Object.getPrototypeOf(IframeUploader)).call.apply(_ref, [this].concat(args))), _this), _this.state = { uploading: false }, _this.file = {}, _this.onLoad = function () {
	      if (!_this.state.uploading) {
	        return;
	      }
	      var _this2 = _this,
	          props = _this2.props,
	          file = _this2.file;
	
	      var response = void 0;
	      try {
	        var doc = _this.getIframeDocument();
	        var script = doc.getElementsByTagName('script')[0];
	        if (script && script.parentNode === doc.body) {
	          doc.body.removeChild(script);
	        }
	        response = doc.body.innerHTML;
	        props.onSuccess(response, file);
	      } catch (err) {
	        (0, _warning2['default'])(false, 'cross domain error for Upload. Maybe server should return document.domain script. see Note from https://github.com/react-component/upload');
	        response = 'cross-domain';
	        props.onError(err, null, file);
	      }
	      _this.endUpload();
	    }, _this.onChange = function () {
	      var target = _this.getFormInputNode();
	      // ie8/9 don't support FileList Object
	      // http://stackoverflow.com/questions/12830058/ie8-input-type-file-get-files
	      var file = _this.file = {
	        uid: (0, _uid2['default'])(),
	        name: target.value && target.value.substring(target.value.lastIndexOf('\\') + 1, target.value.length)
	      };
	      _this.startUpload();
	      var _this3 = _this,
	          props = _this3.props;
	
	      if (!props.beforeUpload) {
	        return _this.post(file);
	      }
	      var before = props.beforeUpload(file);
	      if (before && before.then) {
	        before.then(function () {
	          _this.post(file);
	        }, function () {
	          _this.endUpload();
	        });
	      } else if (before !== false) {
	        _this.post(file);
	      } else {
	        _this.endUpload();
	      }
	    }, _this.saveIframe = function (node) {
	      _this.iframe = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(IframeUploader, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.updateIframeWH();
	      this.initIframe();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.updateIframeWH();
	    }
	  }, {
	    key: 'getIframeNode',
	    value: function getIframeNode() {
	      return this.iframe;
	    }
	  }, {
	    key: 'getIframeDocument',
	    value: function getIframeDocument() {
	      return this.getIframeNode().contentDocument;
	    }
	  }, {
	    key: 'getFormNode',
	    value: function getFormNode() {
	      return this.getIframeDocument().getElementById('form');
	    }
	  }, {
	    key: 'getFormInputNode',
	    value: function getFormInputNode() {
	      return this.getIframeDocument().getElementById('input');
	    }
	  }, {
	    key: 'getFormDataNode',
	    value: function getFormDataNode() {
	      return this.getIframeDocument().getElementById('data');
	    }
	  }, {
	    key: 'getFileForMultiple',
	    value: function getFileForMultiple(file) {
	      return this.props.multiple ? [file] : file;
	    }
	  }, {
	    key: 'getIframeHTML',
	    value: function getIframeHTML(domain) {
	      var domainScript = '';
	      var domainInput = '';
	      if (domain) {
	        var script = 'script';
	        domainScript = '<' + script + '>document.domain="' + domain + '";</' + script + '>';
	        domainInput = '<input name="_documentDomain" value="' + domain + '" />';
	      }
	      return '\n    <!DOCTYPE html>\n    <html>\n    <head>\n    <meta http-equiv="X-UA-Compatible" content="IE=edge" />\n    <style>\n    body,html {padding:0;margin:0;border:0;overflow:hidden;}\n    </style>\n    ' + domainScript + '\n    </head>\n    <body>\n    <form method="post"\n    encType="multipart/form-data"\n    action="" id="form"\n    style="display:block;height:9999px;position:relative;overflow:hidden;">\n    <input id="input" type="file"\n     name="' + this.props.name + '"\n     style="position:absolute;top:0;right:0;height:9999px;font-size:9999px;cursor:pointer;"/>\n    ' + domainInput + '\n    <span id="data"></span>\n    </form>\n    </body>\n    </html>\n    ';
	    }
	  }, {
	    key: 'initIframeSrc',
	    value: function initIframeSrc() {
	      if (this.domain) {
	        this.getIframeNode().src = 'javascript:void((function(){\n        var d = document;\n        d.open();\n        d.domain=\'' + this.domain + '\';\n        d.write(\'\');\n        d.close();\n      })())';
	      }
	    }
	  }, {
	    key: 'initIframe',
	    value: function initIframe() {
	      var iframeNode = this.getIframeNode();
	      var win = iframeNode.contentWindow;
	      var doc = void 0;
	      this.domain = this.domain || '';
	      this.initIframeSrc();
	      try {
	        doc = win.document;
	      } catch (e) {
	        this.domain = document.domain;
	        this.initIframeSrc();
	        win = iframeNode.contentWindow;
	        doc = win.document;
	      }
	      doc.open('text/html', 'replace');
	      doc.write(this.getIframeHTML(this.domain));
	      doc.close();
	      this.getFormInputNode().onchange = this.onChange;
	    }
	  }, {
	    key: 'endUpload',
	    value: function endUpload() {
	      if (this.state.uploading) {
	        this.file = {};
	        // hack avoid batch
	        this.state.uploading = false;
	        this.setState({
	          uploading: false
	        });
	        this.initIframe();
	      }
	    }
	  }, {
	    key: 'startUpload',
	    value: function startUpload() {
	      if (!this.state.uploading) {
	        this.state.uploading = true;
	        this.setState({
	          uploading: true
	        });
	      }
	    }
	  }, {
	    key: 'updateIframeWH',
	    value: function updateIframeWH() {
	      var rootNode = _reactDom2['default'].findDOMNode(this);
	      var iframeNode = this.getIframeNode();
	      iframeNode.style.height = rootNode.offsetHeight + 'px';
	      iframeNode.style.width = rootNode.offsetWidth + 'px';
	    }
	  }, {
	    key: 'abort',
	    value: function abort(file) {
	      if (file) {
	        var uid = file;
	        if (file && file.uid) {
	          uid = file.uid;
	        }
	        if (uid === this.file.uid) {
	          this.endUpload();
	        }
	      } else {
	        this.endUpload();
	      }
	    }
	  }, {
	    key: 'post',
	    value: function post(file) {
	      var _this4 = this;
	
	      var formNode = this.getFormNode();
	      var dataSpan = this.getFormDataNode();
	      var data = this.props.data;
	      var onStart = this.props.onStart;
	
	      if (typeof data === 'function') {
	        data = data(file);
	      }
	      var inputs = document.createDocumentFragment();
	      for (var key in data) {
	        if (data.hasOwnProperty(key)) {
	          var input = document.createElement('input');
	          input.setAttribute('name', key);
	          input.value = data[key];
	          inputs.appendChild(input);
	        }
	      }
	      dataSpan.appendChild(inputs);
	      new Promise(function (resolve) {
	        var action = _this4.props.action;
	
	        if (typeof action === 'function') {
	          return resolve(action(file));
	        }
	        resolve(action);
	      }).then(function (action) {
	        formNode.setAttribute('action', action);
	        formNode.submit();
	        dataSpan.innerHTML = '';
	        onStart(file);
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _classNames;
	
	      var _props = this.props,
	          Tag = _props.component,
	          disabled = _props.disabled,
	          className = _props.className,
	          prefixCls = _props.prefixCls,
	          children = _props.children,
	          style = _props.style;
	
	      var iframeStyle = (0, _extends3['default'])({}, IFRAME_STYLE, {
	        display: this.state.uploading || disabled ? 'none' : ''
	      });
	      var cls = (0, _classnames2['default'])((_classNames = {}, (0, _defineProperty3['default'])(_classNames, prefixCls, true), (0, _defineProperty3['default'])(_classNames, prefixCls + '-disabled', disabled), (0, _defineProperty3['default'])(_classNames, className, className), _classNames));
	      return _react2['default'].createElement(
	        Tag,
	        {
	          className: cls,
	          style: (0, _extends3['default'])({ position: 'relative', zIndex: 0 }, style)
	        },
	        _react2['default'].createElement('iframe', {
	          ref: this.saveIframe,
	          onLoad: this.onLoad,
	          style: iframeStyle
	        }),
	        children
	      );
	    }
	  }]);
	  return IframeUploader;
	}(_react.Component);
	
	IframeUploader.propTypes = {
	  component: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  disabled: _propTypes2['default'].bool,
	  prefixCls: _propTypes2['default'].string,
	  className: _propTypes2['default'].string,
	  accept: _propTypes2['default'].string,
	  onStart: _propTypes2['default'].func,
	  multiple: _propTypes2['default'].bool,
	  children: _propTypes2['default'].any,
	  data: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].func]),
	  action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	  name: _propTypes2['default'].string
	};
	exports['default'] = IframeUploader;
	module.exports = exports['default'];

/***/ },
/* 2772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _AjaxUploader = __webpack_require__(2770);
	
	var _AjaxUploader2 = _interopRequireDefault(_AjaxUploader);
	
	var _IframeUploader = __webpack_require__(2771);
	
	var _IframeUploader2 = _interopRequireDefault(_IframeUploader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function empty() {}
	
	var Upload = function (_Component) {
	  (0, _inherits3['default'])(Upload, _Component);
	
	  function Upload() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3['default'])(this, Upload);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3['default'])(this, (_ref = Upload.__proto__ || Object.getPrototypeOf(Upload)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      Component: null
	    }, _this.saveUploader = function (node) {
	      _this.uploader = node;
	    }, _temp), (0, _possibleConstructorReturn3['default'])(_this, _ret);
	  }
	
	  (0, _createClass3['default'])(Upload, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.supportServerRender) {
	        /* eslint react/no-did-mount-set-state:0 */
	        this.setState({
	          Component: this.getComponent()
	        }, this.props.onReady);
	      }
	    }
	  }, {
	    key: 'getComponent',
	    value: function getComponent() {
	      return typeof File !== 'undefined' ? _AjaxUploader2['default'] : _IframeUploader2['default'];
	    }
	  }, {
	    key: 'abort',
	    value: function abort(file) {
	      this.uploader.abort(file);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.supportServerRender) {
	        var _ComponentUploader = this.state.Component;
	        if (_ComponentUploader) {
	          return _react2['default'].createElement(_ComponentUploader, (0, _extends3['default'])({}, this.props, { ref: this.saveUploader }));
	        }
	        return null;
	      }
	      var ComponentUploader = this.getComponent();
	      return _react2['default'].createElement(ComponentUploader, (0, _extends3['default'])({}, this.props, { ref: this.saveUploader }));
	    }
	  }]);
	  return Upload;
	}(_react.Component);
	
	Upload.propTypes = {
	  component: _propTypes2['default'].string,
	  style: _propTypes2['default'].object,
	  prefixCls: _propTypes2['default'].string,
	  action: _propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].func]),
	  name: _propTypes2['default'].string,
	  multipart: _propTypes2['default'].bool,
	  directory: _propTypes2['default'].bool,
	  onError: _propTypes2['default'].func,
	  onSuccess: _propTypes2['default'].func,
	  onProgress: _propTypes2['default'].func,
	  onStart: _propTypes2['default'].func,
	  data: _propTypes2['default'].oneOfType([_propTypes2['default'].object, _propTypes2['default'].func]),
	  headers: _propTypes2['default'].object,
	  accept: _propTypes2['default'].string,
	  multiple: _propTypes2['default'].bool,
	  disabled: _propTypes2['default'].bool,
	  beforeUpload: _propTypes2['default'].func,
	  customRequest: _propTypes2['default'].func,
	  onReady: _propTypes2['default'].func,
	  withCredentials: _propTypes2['default'].bool,
	  supportServerRender: _propTypes2['default'].bool,
	  openFileDialogOnClick: _propTypes2['default'].bool
	};
	Upload.defaultProps = {
	  component: 'span',
	  prefixCls: 'rc-upload',
	  data: {},
	  headers: {},
	  name: 'file',
	  multipart: false,
	  onReady: empty,
	  onStart: empty,
	  onError: empty,
	  onSuccess: empty,
	  supportServerRender: false,
	  multiple: false,
	  beforeUpload: null,
	  customRequest: null,
	  withCredentials: false,
	  openFileDialogOnClick: true
	};
	exports['default'] = Upload;
	module.exports = exports['default'];

/***/ },
/* 2773 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function endsWith(str, suffix) {
	  return str.indexOf(suffix, str.length - suffix.length) !== -1;
	}
	
	exports['default'] = function (file, acceptedFiles) {
	  if (file && acceptedFiles) {
	    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
	    var fileName = file.name || '';
	    var mimeType = file.type || '';
	    var baseMimeType = mimeType.replace(/\/.*$/, '');
	
	    return acceptedFilesArray.some(function (type) {
	      var validType = type.trim();
	      if (validType.charAt(0) === '.') {
	        return endsWith(fileName.toLowerCase(), validType.toLowerCase());
	      } else if (/\/\*$/.test(validType)) {
	        // This is something like a image/* mime type
	        return baseMimeType === validType.replace(/\/.*$/, '');
	      }
	      return mimeType === validType;
	    });
	  }
	  return true;
	};
	
	module.exports = exports['default'];

/***/ },
/* 2774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Upload = __webpack_require__(2772);
	
	var _Upload2 = _interopRequireDefault(_Upload);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	exports['default'] = _Upload2['default']; // export this package's api
	
	module.exports = exports['default'];

/***/ },
/* 2775 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = upload;
	function getError(option, xhr) {
	  var msg = 'cannot ' + option.method + ' ' + option.action + ' ' + xhr.status + '\'';
	  var err = new Error(msg);
	  err.status = xhr.status;
	  err.method = option.method;
	  err.url = option.action;
	  return err;
	}
	
	function getBody(xhr) {
	  var text = xhr.responseText || xhr.response;
	  if (!text) {
	    return text;
	  }
	
	  try {
	    return JSON.parse(text);
	  } catch (e) {
	    return text;
	  }
	}
	
	// option {
	//  onProgress: (event: { percent: number }): void,
	//  onError: (event: Error, body?: Object): void,
	//  onSuccess: (body: Object): void,
	//  data: Object,
	//  filename: String,
	//  file: File,
	//  withCredentials: Boolean,
	//  action: String,
	//  headers: Object,
	// }
	function upload(option) {
	  var xhr = new XMLHttpRequest();
	
	  if (option.onProgress && xhr.upload) {
	    xhr.upload.onprogress = function progress(e) {
	      if (e.total > 0) {
	        e.percent = e.loaded / e.total * 100;
	      }
	      option.onProgress(e);
	    };
	  }
	
	  var formData = new FormData();
	
	  if (option.data) {
	    Object.keys(option.data).forEach(function (key) {
	      var value = option.data[key];
	      // support key-value array data
	      if (Array.isArray(value)) {
	        value.forEach(function (item) {
	          // { list: [ 11, 22 ] }
	          // formData.append('list[]', 11);
	          formData.append(key + '[]', item);
	        });
	        return;
	      }
	
	      formData.append(key, option.data[key]);
	    });
	  }
	
	  formData.append(option.filename, option.file);
	
	  xhr.onerror = function error(e) {
	    option.onError(e);
	  };
	
	  xhr.onload = function onload() {
	    // allow success when 2xx status
	    // see https://github.com/react-component/upload/issues/34
	    if (xhr.status < 200 || xhr.status >= 300) {
	      return option.onError(getError(option, xhr), getBody(xhr));
	    }
	
	    option.onSuccess(getBody(xhr), xhr);
	  };
	
	  xhr.open(option.method, option.action, true);
	
	  // Has to be after `.open()`. See https://github.com/enyo/dropzone/issues/179
	  if (option.withCredentials && 'withCredentials' in xhr) {
	    xhr.withCredentials = true;
	  }
	
	  var headers = option.headers || {};
	
	  // when set headers['X-Requested-With'] = null , can close default XHR header
	  // see https://github.com/react-component/upload/issues/33
	  if (headers['X-Requested-With'] !== null) {
	    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	  }
	
	  for (var h in headers) {
	    if (headers.hasOwnProperty(h) && headers[h] !== null) {
	      xhr.setRequestHeader(h, headers[h]);
	    }
	  }
	  xhr.send(formData);
	
	  return {
	    abort: function abort() {
	      xhr.abort();
	    }
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 2776 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	function loopFiles(item, callback) {
	  var dirReader = item.createReader();
	  var fileList = [];
	
	  function sequence() {
	    dirReader.readEntries(function (entries) {
	      var entryList = Array.prototype.slice.apply(entries);
	      fileList = fileList.concat(entryList);
	
	      // Check if all the file has been viewed
	      var isFinished = !entryList.length;
	
	      if (isFinished) {
	        callback(fileList);
	      } else {
	        sequence();
	      }
	    });
	  }
	
	  sequence();
	}
	
	var traverseFileTree = function traverseFileTree(files, callback, isAccepted) {
	  var _traverseFileTree = function _traverseFileTree(item, path) {
	    path = path || '';
	    if (item.isFile) {
	      item.file(function (file) {
	        if (isAccepted(file)) {
	          // https://github.com/ant-design/ant-design/issues/16426
	          if (item.fullPath && !file.webkitRelativePath) {
	            Object.defineProperties(file, {
	              webkitRelativePath: {
	                writable: true
	              }
	            });
	            file.webkitRelativePath = item.fullPath.replace(/^\//, '');
	            Object.defineProperties(file, {
	              webkitRelativePath: {
	                writable: false
	              }
	            });
	          }
	          callback([file]);
	        }
	      });
	    } else if (item.isDirectory) {
	      loopFiles(item, function (entries) {
	        entries.forEach(function (entryItem) {
	          _traverseFileTree(entryItem, '' + path + item.name + '/');
	        });
	      });
	    }
	  };
	  var _iteratorNormalCompletion = true;
	  var _didIteratorError = false;
	  var _iteratorError = undefined;
	
	  try {
	    for (var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	      var file = _step.value;
	
	      _traverseFileTree(file.webkitGetAsEntry());
	    }
	  } catch (err) {
	    _didIteratorError = true;
	    _iteratorError = err;
	  } finally {
	    try {
	      if (!_iteratorNormalCompletion && _iterator['return']) {
	        _iterator['return']();
	      }
	    } finally {
	      if (_didIteratorError) {
	        throw _iteratorError;
	      }
	    }
	  }
	};
	
	exports['default'] = traverseFileTree;
	module.exports = exports['default'];

/***/ },
/* 2777 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasClass = hasClass;
	exports.addClass = addClass;
	exports.removeClass = removeClass;
	
	function hasClass(node, className) {
	  if (node.classList) {
	    return node.classList.contains(className);
	  }
	
	  var originClass = node.className;
	  return " ".concat(originClass, " ").indexOf(" ".concat(className, " ")) > -1;
	}
	
	function addClass(node, className) {
	  if (node.classList) {
	    node.classList.add(className);
	  } else {
	    if (!hasClass(node, className)) {
	      node.className = "".concat(node.className, " ").concat(className);
	    }
	  }
	}
	
	function removeClass(node, className) {
	  if (node.classList) {
	    node.classList.remove(className);
	  } else {
	    if (hasClass(node, className)) {
	      var originClass = node.className;
	      node.className = " ".concat(originClass, " ").replace(" ".concat(className, " "), ' ');
	    }
	  }
	}

/***/ },
/* 2778 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fillRef = fillRef;
	exports.composeRef = composeRef;
	exports.supportRef = supportRef;
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function fillRef(ref, node) {
	  if (typeof ref === 'function') {
	    ref(node);
	  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
	    ref.current = node;
	  }
	}
	/**
	 * Merge refs into one ref function to support ref passing.
	 */
	
	
	function composeRef() {
	  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
	    refs[_key] = arguments[_key];
	  }
	
	  return function (node) {
	    refs.forEach(function (ref) {
	      fillRef(ref, node);
	    });
	  };
	}
	
	function supportRef(nodeOrComponent) {
	  // Function component node
	  if (nodeOrComponent.type && nodeOrComponent.type.prototype && !nodeOrComponent.type.prototype.render) {
	    return false;
	  } // Class component
	
	
	  if (typeof nodeOrComponent === 'function' && nodeOrComponent.prototype && !nodeOrComponent.prototype.render) {
	    return false;
	  }
	
	  return true;
	}
	/* eslint-enable */

/***/ },
/* 2779 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _getScrollBarSize = _interopRequireDefault(__webpack_require__(1125));
	
	var _setStyle = _interopRequireDefault(__webpack_require__(1126));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function isBodyOverflowing() {
	  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
	}
	
	var cacheStyle = {};
	
	var _default = function _default(close) {
	  if (!isBodyOverflowing() && !close) {
	    return;
	  } // https://github.com/ant-design/ant-design/issues/19729
	
	
	  var scrollingEffectClassName = 'ant-scrolling-effect';
	  var scrollingEffectClassNameReg = new RegExp("".concat(scrollingEffectClassName), 'g');
	  var bodyClassName = document.body.className;
	
	  if (close) {
	    if (!scrollingEffectClassNameReg.test(bodyClassName)) return;
	    (0, _setStyle.default)(cacheStyle);
	    cacheStyle = {};
	    document.body.className = bodyClassName.replace(scrollingEffectClassNameReg, '').trim();
	    return;
	  }
	
	  var scrollBarSize = (0, _getScrollBarSize.default)();
	
	  if (scrollBarSize) {
	    cacheStyle = (0, _setStyle.default)({
	      position: 'relative',
	      width: "calc(100% - ".concat(scrollBarSize, "px)")
	    });
	
	    if (!scrollingEffectClassNameReg.test(bodyClassName)) {
	      var addClassName = "".concat(bodyClassName, " ").concat(scrollingEffectClassName);
	      document.body.className = addClassName.trim();
	    }
	  }
	};
	
	exports.default = _default;

/***/ },
/* 2780 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.yuv2rgb = yuv2rgb;
	exports.rgb2yuv = rgb2yuv;
	function yuv2rgb(yuv) {
	  var y = yuv[0],
	      u = yuv[1],
	      v = yuv[2],
	      r,
	      g,
	      b;
	
	  r = y * 1 + u * 0 + v * 1.13983;
	  g = y * 1 + u * -0.39465 + v * -0.58060;
	  b = y * 1 + u * 2.02311 + v * 0;
	
	  r = Math.min(Math.max(0, r), 1);
	  g = Math.min(Math.max(0, g), 1);
	  b = Math.min(Math.max(0, b), 1);
	
	  return [r * 255, g * 255, b * 255];
	}
	
	function rgb2yuv(rgb) {
	  var r = rgb[0] / 255,
	      g = rgb[1] / 255,
	      b = rgb[2] / 255;
	
	  var y = r * 0.299 + g * 0.587 + b * 0.114;
	  var u = r * -0.14713 + g * -0.28886 + b * 0.436;
	  var v = r * 0.615 + g * -0.51499 + b * -0.10001;
	
	  return [y, u, v];
	};

/***/ },
/* 2781 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 2782 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(72);
	
	var focusNode = __webpack_require__(887);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 2783 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(305);
	var ExecutionEnvironment = __webpack_require__(93);
	var FallbackCompositionState = __webpack_require__(2789);
	var SyntheticCompositionEvent = __webpack_require__(2826);
	var SyntheticInputEvent = __webpack_require__(2829);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 2784 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(1128);
	var ExecutionEnvironment = __webpack_require__(93);
	var ReactInstrumentation = __webpack_require__(128);
	
	var camelizeStyleName = __webpack_require__(2468);
	var dangerousStyleValue = __webpack_require__(2835);
	var hyphenateStyleName = __webpack_require__(2476);
	var memoizeStringOnly = __webpack_require__(890);
	var warning = __webpack_require__(49);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 2785 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(304);
	var EventPropagators = __webpack_require__(305);
	var ExecutionEnvironment = __webpack_require__(93);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactUpdates = __webpack_require__(146);
	var SyntheticEvent = __webpack_require__(163);
	
	var inputValueTracking = __webpack_require__(1144);
	var getEventTarget = __webpack_require__(583);
	var isEventSupported = __webpack_require__(584);
	var isTextInputElement = __webpack_require__(1146);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 2786 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var DOMLazyTree = __webpack_require__(258);
	var ExecutionEnvironment = __webpack_require__(93);
	
	var createNodesFromMarkup = __webpack_require__(2469);
	var emptyFunction = __webpack_require__(101);
	var invariant = __webpack_require__(18);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 2787 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 2788 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(305);
	var ReactDOMComponentTree = __webpack_require__(72);
	var SyntheticMouseEvent = __webpack_require__(386);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 2789 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var PooledClass = __webpack_require__(221);
	
	var getTextContentAccessor = __webpack_require__(1143);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 2790 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(259);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 2791 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(260);
	
	var instantiateReactComponent = __webpack_require__(1145);
	var KeyEscapeUtils = __webpack_require__(575);
	var shouldUpdateReactComponent = __webpack_require__(585);
	var traverseAllChildren = __webpack_require__(1148);
	var warning = __webpack_require__(49);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(1165);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ },
/* 2792 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(571);
	var ReactDOMIDOperations = __webpack_require__(2799);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 2793 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47),
	    _assign = __webpack_require__(40);
	
	var React = __webpack_require__(263);
	var ReactComponentEnvironment = __webpack_require__(577);
	var ReactCurrentOwner = __webpack_require__(164);
	var ReactErrorUtils = __webpack_require__(578);
	var ReactInstanceMap = __webpack_require__(306);
	var ReactInstrumentation = __webpack_require__(128);
	var ReactNodeTypes = __webpack_require__(1138);
	var ReactReconciler = __webpack_require__(260);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(522);
	var invariant = __webpack_require__(18);
	var shallowEqual = __webpack_require__(524);
	var shouldUpdateReactComponent = __webpack_require__(585);
	var warning = __webpack_require__(49);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 2794 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactDefaultInjection = __webpack_require__(2807);
	var ReactMount = __webpack_require__(1137);
	var ReactReconciler = __webpack_require__(260);
	var ReactUpdates = __webpack_require__(146);
	var ReactVersion = __webpack_require__(2820);
	
	var findDOMNode = __webpack_require__(2836);
	var getHostComponentFromComposite = __webpack_require__(1142);
	var renderSubtreeIntoContainer = __webpack_require__(2843);
	var warning = __webpack_require__(49);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 2795 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47),
	    _assign = __webpack_require__(40);
	
	var AutoFocusUtils = __webpack_require__(2782);
	var CSSPropertyOperations = __webpack_require__(2784);
	var DOMLazyTree = __webpack_require__(258);
	var DOMNamespaces = __webpack_require__(572);
	var DOMProperty = __webpack_require__(259);
	var DOMPropertyOperations = __webpack_require__(1130);
	var EventPluginHub = __webpack_require__(304);
	var EventPluginRegistry = __webpack_require__(573);
	var ReactBrowserEventEmitter = __webpack_require__(385);
	var ReactDOMComponentFlags = __webpack_require__(1131);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactDOMInput = __webpack_require__(2800);
	var ReactDOMOption = __webpack_require__(2801);
	var ReactDOMSelect = __webpack_require__(1132);
	var ReactDOMTextarea = __webpack_require__(2804);
	var ReactInstrumentation = __webpack_require__(128);
	var ReactMultiChild = __webpack_require__(2813);
	var ReactServerRenderingTransaction = __webpack_require__(2818);
	
	var emptyFunction = __webpack_require__(101);
	var escapeTextContentForBrowser = __webpack_require__(388);
	var invariant = __webpack_require__(18);
	var isEventSupported = __webpack_require__(584);
	var shallowEqual = __webpack_require__(524);
	var inputValueTracking = __webpack_require__(1144);
	var validateDOMNesting = __webpack_require__(586);
	var warning = __webpack_require__(49);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 2796 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(586);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 2797 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var DOMLazyTree = __webpack_require__(258);
	var ReactDOMComponentTree = __webpack_require__(72);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 2798 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 2799 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(571);
	var ReactDOMComponentTree = __webpack_require__(72);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 2800 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47),
	    _assign = __webpack_require__(40);
	
	var DOMPropertyOperations = __webpack_require__(1130);
	var LinkedValueUtils = __webpack_require__(576);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactUpdates = __webpack_require__(146);
	
	var invariant = __webpack_require__(18);
	var warning = __webpack_require__(49);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 2801 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var React = __webpack_require__(263);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactDOMSelect = __webpack_require__(1132);
	
	var warning = __webpack_require__(49);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 2802 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(93);
	
	var getNodeForCharacterOffset = __webpack_require__(2840);
	var getTextContentAccessor = __webpack_require__(1143);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 2803 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47),
	    _assign = __webpack_require__(40);
	
	var DOMChildrenOperations = __webpack_require__(571);
	var DOMLazyTree = __webpack_require__(258);
	var ReactDOMComponentTree = __webpack_require__(72);
	
	var escapeTextContentForBrowser = __webpack_require__(388);
	var invariant = __webpack_require__(18);
	var validateDOMNesting = __webpack_require__(586);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 2804 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47),
	    _assign = __webpack_require__(40);
	
	var LinkedValueUtils = __webpack_require__(576);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactUpdates = __webpack_require__(146);
	
	var invariant = __webpack_require__(18);
	var warning = __webpack_require__(49);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 2805 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 2806 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var ReactUpdates = __webpack_require__(146);
	var Transaction = __webpack_require__(387);
	
	var emptyFunction = __webpack_require__(101);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 2807 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(2781);
	var BeforeInputEventPlugin = __webpack_require__(2783);
	var ChangeEventPlugin = __webpack_require__(2785);
	var DefaultEventPluginOrder = __webpack_require__(2787);
	var EnterLeaveEventPlugin = __webpack_require__(2788);
	var HTMLDOMPropertyConfig = __webpack_require__(2790);
	var ReactComponentBrowserEnvironment = __webpack_require__(2792);
	var ReactDOMComponent = __webpack_require__(2795);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactDOMEmptyComponent = __webpack_require__(2797);
	var ReactDOMTreeTraversal = __webpack_require__(2805);
	var ReactDOMTextComponent = __webpack_require__(2803);
	var ReactDefaultBatchingStrategy = __webpack_require__(2806);
	var ReactEventListener = __webpack_require__(2810);
	var ReactInjection = __webpack_require__(2811);
	var ReactReconcileTransaction = __webpack_require__(2816);
	var SVGDOMPropertyConfig = __webpack_require__(2821);
	var SelectEventPlugin = __webpack_require__(2822);
	var SimpleEventPlugin = __webpack_require__(2823);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 2808 */
1166,
/* 2809 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(304);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 2810 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var EventListener = __webpack_require__(882);
	var ExecutionEnvironment = __webpack_require__(93);
	var PooledClass = __webpack_require__(221);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactUpdates = __webpack_require__(146);
	
	var getEventTarget = __webpack_require__(583);
	var getUnboundedScrollPosition = __webpack_require__(888);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 2811 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(259);
	var EventPluginHub = __webpack_require__(304);
	var EventPluginUtils = __webpack_require__(574);
	var ReactComponentEnvironment = __webpack_require__(577);
	var ReactEmptyComponent = __webpack_require__(1133);
	var ReactBrowserEventEmitter = __webpack_require__(385);
	var ReactHostComponent = __webpack_require__(1135);
	var ReactUpdates = __webpack_require__(146);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 2812 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(2834);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 2813 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactComponentEnvironment = __webpack_require__(577);
	var ReactInstanceMap = __webpack_require__(306);
	var ReactInstrumentation = __webpack_require__(128);
	
	var ReactCurrentOwner = __webpack_require__(164);
	var ReactReconciler = __webpack_require__(260);
	var ReactChildReconciler = __webpack_require__(2791);
	
	var emptyFunction = __webpack_require__(101);
	var flattenChildren = __webpack_require__(2837);
	var invariant = __webpack_require__(18);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 2814 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 2815 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 2816 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var CallbackQueue = __webpack_require__(1129);
	var PooledClass = __webpack_require__(221);
	var ReactBrowserEventEmitter = __webpack_require__(385);
	var ReactInputSelection = __webpack_require__(1136);
	var ReactInstrumentation = __webpack_require__(128);
	var Transaction = __webpack_require__(387);
	var ReactUpdateQueue = __webpack_require__(579);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 2817 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(2814);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 2818 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(40);
	
	var PooledClass = __webpack_require__(221);
	var Transaction = __webpack_require__(387);
	var ReactInstrumentation = __webpack_require__(128);
	var ReactServerUpdateQueue = __webpack_require__(2819);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 2819 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(579);
	
	var warning = __webpack_require__(49);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 2820 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 2821 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 2822 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(305);
	var ExecutionEnvironment = __webpack_require__(93);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactInputSelection = __webpack_require__(1136);
	var SyntheticEvent = __webpack_require__(163);
	
	var getActiveElement = __webpack_require__(366);
	var isTextInputElement = __webpack_require__(1146);
	var shallowEqual = __webpack_require__(524);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 2823 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var EventListener = __webpack_require__(882);
	var EventPropagators = __webpack_require__(305);
	var ReactDOMComponentTree = __webpack_require__(72);
	var SyntheticAnimationEvent = __webpack_require__(2824);
	var SyntheticClipboardEvent = __webpack_require__(2825);
	var SyntheticEvent = __webpack_require__(163);
	var SyntheticFocusEvent = __webpack_require__(2828);
	var SyntheticKeyboardEvent = __webpack_require__(2830);
	var SyntheticMouseEvent = __webpack_require__(386);
	var SyntheticDragEvent = __webpack_require__(2827);
	var SyntheticTouchEvent = __webpack_require__(2831);
	var SyntheticTransitionEvent = __webpack_require__(2832);
	var SyntheticUIEvent = __webpack_require__(307);
	var SyntheticWheelEvent = __webpack_require__(2833);
	
	var emptyFunction = __webpack_require__(101);
	var getEventCharCode = __webpack_require__(581);
	var invariant = __webpack_require__(18);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 2824 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(163);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 2825 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(163);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 2826 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(163);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 2827 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(386);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 2828 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(307);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 2829 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(163);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 2830 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(307);
	
	var getEventCharCode = __webpack_require__(581);
	var getEventKey = __webpack_require__(2838);
	var getEventModifierState = __webpack_require__(582);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 2831 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(307);
	
	var getEventModifierState = __webpack_require__(582);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 2832 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(163);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 2833 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(386);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 2834 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 2835 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(1128);
	var warning = __webpack_require__(49);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 2836 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(47);
	
	var ReactCurrentOwner = __webpack_require__(164);
	var ReactDOMComponentTree = __webpack_require__(72);
	var ReactInstanceMap = __webpack_require__(306);
	
	var getHostComponentFromComposite = __webpack_require__(1142);
	var invariant = __webpack_require__(18);
	var warning = __webpack_require__(49);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 2837 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(575);
	var traverseAllChildren = __webpack_require__(1148);
	var warning = __webpack_require__(49);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(1165);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(184)))

/***/ },
/* 2838 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(581);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 2839 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 2840 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 2841 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(93);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 2842 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(388);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 2843 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(1137);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 2844 */
/***/ function(module, exports) {

	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
	exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
	exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ },
/* 2845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(23);
	
	var _eventlistener = __webpack_require__(2461);
	
	var _lodash = __webpack_require__(369);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _lodash3 = __webpack_require__(2494);
	
	var _lodash4 = _interopRequireDefault(_lodash3);
	
	var _parentScroll = __webpack_require__(2848);
	
	var _parentScroll2 = _interopRequireDefault(_parentScroll);
	
	var _inViewport = __webpack_require__(2847);
	
	var _inViewport2 = _interopRequireDefault(_inViewport);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LazyLoad = function (_Component) {
	  _inherits(LazyLoad, _Component);
	
	  function LazyLoad(props) {
	    _classCallCheck(this, LazyLoad);
	
	    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));
	
	    _this.lazyLoadHandler = _this.lazyLoadHandler.bind(_this);
	
	    if (props.throttle > 0) {
	      if (props.debounce) {
	        _this.lazyLoadHandler = (0, _lodash2.default)(_this.lazyLoadHandler, props.throttle);
	      } else {
	        _this.lazyLoadHandler = (0, _lodash4.default)(_this.lazyLoadHandler, props.throttle);
	      }
	    }
	
	    _this.state = { visible: false };
	    return _this;
	  }
	
	  _createClass(LazyLoad, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this._mounted = true;
	      var eventNode = this.getEventNode();
	
	      this.lazyLoadHandler();
	
	      if (this.lazyLoadHandler.flush) {
	        this.lazyLoadHandler.flush();
	      }
	
	      (0, _eventlistener.add)(window, 'resize', this.lazyLoadHandler);
	      (0, _eventlistener.add)(eventNode, 'scroll', this.lazyLoadHandler);
	
	      if (eventNode !== window) (0, _eventlistener.add)(window, 'scroll', this.lazyLoadHandler);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (!this.state.visible) {
	        this.lazyLoadHandler();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(_nextProps, nextState) {
	      return nextState.visible;
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this._mounted = false;
	      if (this.lazyLoadHandler.cancel) {
	        this.lazyLoadHandler.cancel();
	      }
	
	      this.detachListeners();
	    }
	  }, {
	    key: 'getEventNode',
	    value: function getEventNode() {
	      return (0, _parentScroll2.default)((0, _reactDom.findDOMNode)(this));
	    }
	  }, {
	    key: 'getOffset',
	    value: function getOffset() {
	      var _props = this.props,
	          offset = _props.offset,
	          offsetVertical = _props.offsetVertical,
	          offsetHorizontal = _props.offsetHorizontal,
	          offsetTop = _props.offsetTop,
	          offsetBottom = _props.offsetBottom,
	          offsetLeft = _props.offsetLeft,
	          offsetRight = _props.offsetRight,
	          threshold = _props.threshold;
	
	
	      var _offsetAll = threshold || offset;
	      var _offsetVertical = offsetVertical || _offsetAll;
	      var _offsetHorizontal = offsetHorizontal || _offsetAll;
	
	      return {
	        top: offsetTop || _offsetVertical,
	        bottom: offsetBottom || _offsetVertical,
	        left: offsetLeft || _offsetHorizontal,
	        right: offsetRight || _offsetHorizontal
	      };
	    }
	  }, {
	    key: 'lazyLoadHandler',
	    value: function lazyLoadHandler() {
	      if (!this._mounted) {
	        return;
	      }
	      var offset = this.getOffset();
	      var node = (0, _reactDom.findDOMNode)(this);
	      var eventNode = this.getEventNode();
	
	      if ((0, _inViewport2.default)(node, eventNode, offset)) {
	        var onContentVisible = this.props.onContentVisible;
	
	
	        this.setState({ visible: true }, function () {
	          if (onContentVisible) {
	            onContentVisible();
	          }
	        });
	        this.detachListeners();
	      }
	    }
	  }, {
	    key: 'detachListeners',
	    value: function detachListeners() {
	      var eventNode = this.getEventNode();
	
	      (0, _eventlistener.remove)(window, 'resize', this.lazyLoadHandler);
	      (0, _eventlistener.remove)(eventNode, 'scroll', this.lazyLoadHandler);
	
	      if (eventNode !== window) (0, _eventlistener.remove)(window, 'scroll', this.lazyLoadHandler);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          height = _props2.height,
	          width = _props2.width;
	      var visible = this.state.visible;
	
	
	      var elStyles = { height: height, width: width };
	      var elClasses = 'LazyLoad' + (visible ? ' is-visible' : '') + (className ? ' ' + className : '');
	
	      return _react2.default.createElement(this.props.elementType, {
	        className: elClasses,
	        style: elStyles
	      }, visible && _react.Children.only(children));
	    }
	  }]);
	
	  return LazyLoad;
	}(_react.Component);
	
	exports.default = LazyLoad;
	
	
	LazyLoad.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  className: _propTypes2.default.string,
	  debounce: _propTypes2.default.bool,
	  elementType: _propTypes2.default.string,
	  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  offset: _propTypes2.default.number,
	  offsetBottom: _propTypes2.default.number,
	  offsetHorizontal: _propTypes2.default.number,
	  offsetLeft: _propTypes2.default.number,
	  offsetRight: _propTypes2.default.number,
	  offsetTop: _propTypes2.default.number,
	  offsetVertical: _propTypes2.default.number,
	  threshold: _propTypes2.default.number,
	  throttle: _propTypes2.default.number,
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  onContentVisible: _propTypes2.default.func
	};
	
	LazyLoad.defaultProps = {
	  elementType: 'div',
	  debounce: true,
	  offset: 0,
	  offsetBottom: 0,
	  offsetHorizontal: 0,
	  offsetLeft: 0,
	  offsetRight: 0,
	  offsetTop: 0,
	  offsetVertical: 0,
	  throttle: 250
	};

/***/ },
/* 2846 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getElementPosition;
	/*
	* Finds element's position relative to the whole document,
	* rather than to the viewport as it is the case with .getBoundingClientRect().
	*/
	function getElementPosition(element) {
	  var rect = element.getBoundingClientRect();
	
	  return {
	    top: rect.top + window.pageYOffset,
	    left: rect.left + window.pageXOffset
	  };
	}

/***/ },
/* 2847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = inViewport;
	
	var _getElementPosition = __webpack_require__(2846);
	
	var _getElementPosition2 = _interopRequireDefault(_getElementPosition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isHidden = function isHidden(element) {
	  return element.offsetParent === null;
	};
	
	function inViewport(element, container, customOffset) {
	  if (isHidden(element)) {
	    return false;
	  }
	
	  var top = void 0;
	  var bottom = void 0;
	  var left = void 0;
	  var right = void 0;
	
	  if (typeof container === 'undefined' || container === window) {
	    top = window.pageYOffset;
	    left = window.pageXOffset;
	    bottom = top + window.innerHeight;
	    right = left + window.innerWidth;
	  } else {
	    if (!inViewport(container, window, customOffset)) return false;
	
	    var containerPosition = (0, _getElementPosition2.default)(container);
	
	    top = containerPosition.top;
	    left = containerPosition.left;
	    bottom = top + container.offsetHeight;
	    right = left + container.offsetWidth;
	  }
	
	  var elementPosition = (0, _getElementPosition2.default)(element);
	
	  return top <= elementPosition.top + element.offsetHeight + customOffset.top && bottom >= elementPosition.top - customOffset.bottom && left <= elementPosition.left + element.offsetWidth + customOffset.left && right >= elementPosition.left - customOffset.right;
	}

/***/ },
/* 2848 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var style = function style(element, prop) {
	  return typeof getComputedStyle !== 'undefined' ? getComputedStyle(element, null).getPropertyValue(prop) : element.style[prop];
	};
	
	var overflow = function overflow(element) {
	  return style(element, 'overflow') + style(element, 'overflow-y') + style(element, 'overflow-x');
	};
	
	var scrollParent = function scrollParent(element) {
	  if (!(element instanceof HTMLElement)) {
	    return window;
	  }
	
	  var parent = element;
	
	  while (parent) {
	    if (parent === document.body || parent === document.documentElement) {
	      break;
	    }
	
	    if (!parent.parentNode) {
	      break;
	    }
	
	    if (/(scroll|auto)/.test(overflow(parent))) {
	      return parent;
	    }
	
	    parent = parent.parentNode;
	  }
	
	  return window;
	};
	
	exports.default = scrollParent;

/***/ },
/* 2849 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = shallowEqual;
	
	function shallowEqual(objA, objB) {
	  if (objA === objB) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
	  for (var i = 0; i < keysA.length; i++) {
	    if (!bHasOwnProperty(keysA[i]) || objA[keysA[i]] !== objB[keysA[i]]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = exports['default'];

/***/ },
/* 2850 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(399);
	
	var _interopRequireDefault = __webpack_require__(130);
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	exports.default = void 0;
	
	var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(610));
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _PropTypes = __webpack_require__(1151);
	
	var _warning = _interopRequireDefault(__webpack_require__(587));
	
	var prefixUnsafeLifecycleMethods = typeof _react.default.forwardRef !== "undefined";
	var didWarnAboutReceivingStore = false;
	
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	
	  didWarnAboutReceivingStore = true;
	  (0, _warning.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider(storeKey) {
	  var _Provider$childContex;
	
	  if (storeKey === void 0) {
	    storeKey = 'store';
	  }
	
	  var subscriptionKey = storeKey + "Subscription";
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    (0, _inheritsLoose2.default)(Provider, _Component);
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      var _this;
	
	      _this = _Component.call(this, props, context) || this;
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    _proto.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    // Use UNSAFE_ event name where supported
	    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';
	
	    Provider.prototype[eventName] = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	  return Provider;
	}
	
	var _default = createProvider();
	
	exports.default = _default;

/***/ },
/* 2851 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(130);
	
	exports.__esModule = true;
	exports.createConnect = createConnect;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(398));
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(400));
	
	var _connectAdvanced = _interopRequireDefault(__webpack_require__(1149));
	
	var _shallowEqual = _interopRequireDefault(__webpack_require__(2859));
	
	var _mapDispatchToProps = _interopRequireDefault(__webpack_require__(2852));
	
	var _mapStateToProps = _interopRequireDefault(__webpack_require__(2853));
	
	var _mergeProps = _interopRequireDefault(__webpack_require__(2854));
	
	var _selectorFactory = _interopRequireDefault(__webpack_require__(2855));
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	} // createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	
	
	function createConnect(_temp) {
	  var _ref = _temp === void 0 ? {} : _temp,
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === void 0 ? _connectAdvanced.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? _mapStateToProps.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? _mapDispatchToProps.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === void 0 ? _mergeProps.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === void 0 ? _selectorFactory.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
	    if (_ref2 === void 0) {
	      _ref2 = {};
	    }
	
	    var _ref3 = _ref2,
	        _ref3$pure = _ref3.pure,
	        pure = _ref3$pure === void 0 ? true : _ref3$pure,
	        _ref3$areStatesEqual = _ref3.areStatesEqual,
	        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
	        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
	        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? _shallowEqual.default : _ref3$areOwnPropsEqua,
	        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
	        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? _shallowEqual.default : _ref3$areStatePropsEq,
	        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
	        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? _shallowEqual.default : _ref3$areMergedPropsE,
	        extraOptions = (0, _objectWithoutPropertiesLoose2.default)(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	    return connectHOC(selectorFactory, (0, _extends2.default)({
	      // used in error messages
	      methodName: 'connect',
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return "Connect(" + name + ")";
	      },
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	    }, extraOptions));
	  };
	}
	
	var _default = createConnect();
	
	exports.default = _default;

/***/ },
/* 2852 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	exports.default = void 0;
	
	var _redux = __webpack_require__(312);
	
	var _wrapMapToProps = __webpack_require__(1150);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return {
	      dispatch: dispatch
	    };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	var _default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];
	exports.default = _default;

/***/ },
/* 2853 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	exports.default = void 0;
	
	var _wrapMapToProps = __webpack_require__(1150);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	var _default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];
	exports.default = _default;

/***/ },
/* 2854 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(130);
	
	exports.__esModule = true;
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(398));
	
	var _verifyPlainObject = _interopRequireDefault(__webpack_require__(1152));
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return (0, _extends2.default)({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	    var hasRunOnce = false;
	    var mergedProps;
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	        if (false) (0, _verifyPlainObject.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	var _default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];
	exports.default = _default;

/***/ },
/* 2855 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(130);
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(400));
	
	var _verifySubselectors = _interopRequireDefault(__webpack_require__(2856));
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	  var hasRunAtLeastOnce = false;
	  var state;
	  var ownProps;
	  var stateProps;
	  var dispatchProps;
	  var mergedProps;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	} // TODO: Add more comments
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = (0, _objectWithoutPropertiesLoose2.default)(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 2856 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(130);
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = _interopRequireDefault(__webpack_require__(587));
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 2857 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription =
	/*#__PURE__*/
	function () {
	  function Subscription(store, parentSub, onStateChange) {
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  var _proto = Subscription.prototype;
	
	  _proto.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  _proto.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  _proto.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  _proto.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  _proto.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 2858 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = isPlainObject;
	
	/**
	 * @param {any} obj The object to inspect.
	 * @returns {boolean} True if the argument appears to be a plain object.
	 */
	function isPlainObject(obj) {
	  if (typeof obj !== 'object' || obj === null) return false;
	  var proto = Object.getPrototypeOf(obj);
	  if (proto === null) return true;
	  var baseProto = proto;
	
	  while (Object.getPrototypeOf(baseProto) !== null) {
	    baseProto = Object.getPrototypeOf(baseProto);
	  }
	
	  return proto === baseProto;
	}

/***/ },
/* 2859 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 2860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = routerMiddleware;
	
	var _actions = __webpack_require__(1153);
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
	 * provided history object. This will prevent these actions from reaching your
	 * reducer or any middleware that comes after this one.
	 */
	function routerMiddleware(history) {
	  return function () {
	    return function (next) {
	      return function (action) {
	        if (action.type !== _actions.CALL_HISTORY_METHOD) {
	          return next(action);
	        }
	
	        var _action$payload = action.payload,
	            method = _action$payload.method,
	            args = _action$payload.args;
	
	        history[method].apply(history, _toConsumableArray(args));
	      };
	    };
	  };
	}

/***/ },
/* 2861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = syncHistoryWithStore;
	
	var _reducer = __webpack_require__(1155);
	
	var defaultSelectLocationState = function defaultSelectLocationState(state) {
	  return state.routing;
	};
	
	/**
	 * This function synchronizes your history state with the Redux store.
	 * Location changes flow from history to the store. An enhanced history is
	 * returned with a listen method that responds to store updates for location.
	 *
	 * When this history is provided to the router, this means the location data
	 * will flow like this:
	 * history.push -> store.dispatch -> enhancedHistory.listen -> router
	 * This ensures that when the store state changes due to a replay or other
	 * event, the router will be updated appropriately and can transition to the
	 * correct router state.
	 */
	function syncHistoryWithStore(history, store) {
	  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
	      _ref$selectLocationSt = _ref.selectLocationState,
	      selectLocationState = _ref$selectLocationSt === undefined ? defaultSelectLocationState : _ref$selectLocationSt,
	      _ref$adjustUrlOnRepla = _ref.adjustUrlOnReplay,
	      adjustUrlOnReplay = _ref$adjustUrlOnRepla === undefined ? true : _ref$adjustUrlOnRepla;
	
	  // Ensure that the reducer is mounted on the store and functioning properly.
	  if (typeof selectLocationState(store.getState()) === 'undefined') {
	    throw new Error('Expected the routing state to be available either as `state.routing` ' + 'or as the custom expression you can specify as `selectLocationState` ' + 'in the `syncHistoryWithStore()` options. ' + 'Ensure you have added the `routerReducer` to your store\'s ' + 'reducers via `combineReducers` or whatever method you use to isolate ' + 'your reducers.');
	  }
	
	  var initialLocation = void 0;
	  var isTimeTraveling = void 0;
	  var unsubscribeFromStore = void 0;
	  var unsubscribeFromHistory = void 0;
	  var currentLocation = void 0;
	
	  // What does the store say about current location?
	  var getLocationInStore = function getLocationInStore(useInitialIfEmpty) {
	    var locationState = selectLocationState(store.getState());
	    return locationState.locationBeforeTransitions || (useInitialIfEmpty ? initialLocation : undefined);
	  };
	
	  // Init initialLocation with potential location in store
	  initialLocation = getLocationInStore();
	
	  // If the store is replayed, update the URL in the browser to match.
	  if (adjustUrlOnReplay) {
	    var handleStoreChange = function handleStoreChange() {
	      var locationInStore = getLocationInStore(true);
	      if (currentLocation === locationInStore || initialLocation === locationInStore) {
	        return;
	      }
	
	      // Update address bar to reflect store state
	      isTimeTraveling = true;
	      currentLocation = locationInStore;
	      history.transitionTo(_extends({}, locationInStore, {
	        action: 'PUSH'
	      }));
	      isTimeTraveling = false;
	    };
	
	    unsubscribeFromStore = store.subscribe(handleStoreChange);
	    handleStoreChange();
	  }
	
	  // Whenever location changes, dispatch an action to get it in the store
	  var handleLocationChange = function handleLocationChange(location) {
	    // ... unless we just caused that location change
	    if (isTimeTraveling) {
	      return;
	    }
	
	    // Remember where we are
	    currentLocation = location;
	
	    // Are we being called for the first time?
	    if (!initialLocation) {
	      // Remember as a fallback in case state is reset
	      initialLocation = location;
	
	      // Respect persisted location, if any
	      if (getLocationInStore()) {
	        return;
	      }
	    }
	
	    // Tell the store to update by dispatching an action
	    store.dispatch({
	      type: _reducer.LOCATION_CHANGE,
	      payload: location
	    });
	  };
	  unsubscribeFromHistory = history.listen(handleLocationChange);
	
	  // History 3.x doesn't call listen synchronously, so fire the initial location change ourselves
	  if (history.getCurrentLocation) {
	    handleLocationChange(history.getCurrentLocation());
	  }
	
	  // The enhanced history uses store as source of truth
	  return _extends({}, history, {
	    // The listeners are subscribed to the store instead of history
	    listen: function listen(listener) {
	      // Copy of last location.
	      var lastPublishedLocation = getLocationInStore(true);
	
	      // Keep track of whether we unsubscribed, as Redux store
	      // only applies changes in subscriptions on next dispatch
	      var unsubscribed = false;
	      var unsubscribeFromStore = store.subscribe(function () {
	        var currentLocation = getLocationInStore(true);
	        if (currentLocation === lastPublishedLocation) {
	          return;
	        }
	        lastPublishedLocation = currentLocation;
	        if (!unsubscribed) {
	          listener(lastPublishedLocation);
	        }
	      });
	
	      // History 2.x listeners expect a synchronous call. Make the first call to the
	      // listener after subscribing to the store, in case the listener causes a
	      // location change (e.g. when it redirects)
	      if (!history.getCurrentLocation) {
	        listener(lastPublishedLocation);
	      }
	
	      // Let user unsubscribe later
	      return function () {
	        unsubscribed = true;
	        unsubscribeFromStore();
	      };
	    },
	
	
	    // It also provides a way to destroy internal listeners
	    unsubscribe: function unsubscribe() {
	      if (adjustUrlOnReplay) {
	        unsubscribeFromStore();
	      }
	      unsubscribeFromHistory();
	    }
	  });
	}

/***/ },
/* 2862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(139);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _Link = __webpack_require__(1156);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexLink> is used to link to an <IndexRoute>.
	 */
	var IndexLink = (0, _createReactClass2.default)({
	  displayName: 'IndexLink',
	
	  render: function render() {
	    return _react2.default.createElement(_Link2.default, _extends({}, this.props, { onlyActiveOnIndex: true }));
	  }
	});
	
	exports.default = IndexLink;
	module.exports = exports['default'];

/***/ },
/* 2863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(139);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(6);
	
	var _routerWarning = __webpack_require__(262);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _Redirect = __webpack_require__(1158);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	var _InternalPropTypes = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRedirect> is used to redirect from an indexRoute.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRedirect = (0, _createReactClass2.default)({
	  displayName: 'IndexRedirect',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = _Redirect2.default.createRouteFromReactElement(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRedirect> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    to: _propTypes.string.isRequired,
	    query: _propTypes.object,
	    state: _propTypes.object,
	    onEnter: _InternalPropTypes.falsy,
	    children: _InternalPropTypes.falsy
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRedirect> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRedirect;
	module.exports = exports['default'];

/***/ },
/* 2864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(139);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(6);
	
	var _routerWarning = __webpack_require__(262);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(186);
	
	var _InternalPropTypes = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * An <IndexRoute> is used to specify its parent's <Route indexRoute> in
	 * a JSX route config.
	 */
	/* eslint-disable react/require-render-return */
	var IndexRoute = (0, _createReactClass2.default)({
	  displayName: 'IndexRoute',
	
	  statics: {
	    createRouteFromReactElement: function createRouteFromReactElement(element, parentRoute) {
	      /* istanbul ignore else: sanity check */
	      if (parentRoute) {
	        parentRoute.indexRoute = (0, _RouteUtils.createRouteFromReactElement)(element);
	      } else {
	         false ? (0, _routerWarning2.default)(false, 'An <IndexRoute> does not make sense at the root of your route config') : void 0;
	      }
	    }
	  },
	
	  propTypes: {
	    path: _InternalPropTypes.falsy,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<IndexRoute> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = IndexRoute;
	module.exports = exports['default'];

/***/ },
/* 2865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createReactClass = __webpack_require__(139);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(6);
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _RouteUtils = __webpack_require__(186);
	
	var _InternalPropTypes = __webpack_require__(310);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * A <Route> is used to declare which components are rendered to the
	 * page when the URL matches a given pattern.
	 *
	 * Routes are arranged in a nested tree structure. When a new URL is
	 * requested, the tree is searched depth-first to find a route whose
	 * path matches the URL.  When one is found, all routes in the tree
	 * that lead to it are considered "active" and their components are
	 * rendered into the DOM, nested in the same order as in the tree.
	 */
	/* eslint-disable react/require-render-return */
	var Route = (0, _createReactClass2.default)({
	  displayName: 'Route',
	
	  statics: {
	    createRouteFromReactElement: _RouteUtils.createRouteFromReactElement
	  },
	
	  propTypes: {
	    path: _propTypes.string,
	    component: _InternalPropTypes.component,
	    components: _InternalPropTypes.components,
	    getComponent: _propTypes.func,
	    getComponents: _propTypes.func
	  },
	
	  /* istanbul ignore next: sanity check */
	  render: function render() {
	     true ?  false ? (0, _invariant2.default)(false, '<Route> elements are for router configuration only and should not be rendered') : (0, _invariant2.default)(false) : void 0;
	  }
	});
	
	exports.default = Route;
	module.exports = exports['default'];

/***/ },
/* 2866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(139);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _propTypes = __webpack_require__(6);
	
	var _createTransitionManager2 = __webpack_require__(1162);
	
	var _createTransitionManager3 = _interopRequireDefault(_createTransitionManager2);
	
	var _InternalPropTypes = __webpack_require__(310);
	
	var _RouterContext = __webpack_require__(591);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _RouteUtils = __webpack_require__(186);
	
	var _RouterUtils = __webpack_require__(1159);
	
	var _routerWarning = __webpack_require__(262);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var propTypes = {
	  history: _propTypes.object,
	  children: _InternalPropTypes.routes,
	  routes: _InternalPropTypes.routes, // alias for children
	  render: _propTypes.func,
	  createElement: _propTypes.func,
	  onError: _propTypes.func,
	  onUpdate: _propTypes.func,
	
	  // PRIVATE: For client-side rehydration of server match.
	  matchContext: _propTypes.object
	};
	
	var prefixUnsafeLifecycleMethods = typeof _react2.default.forwardRef !== 'undefined';
	
	/**
	 * A <Router> is a high-level API for automatically setting up
	 * a router that renders a <RouterContext> with all the props
	 * it needs each time the URL changes.
	 */
	var Router = (0, _createReactClass2.default)({
	  displayName: 'Router',
	
	  propTypes: propTypes,
	
	  getDefaultProps: function getDefaultProps() {
	    return {
	      render: function render(props) {
	        return _react2.default.createElement(_RouterContext2.default, props);
	      }
	    };
	  },
	  getInitialState: function getInitialState() {
	    return {
	      location: null,
	      routes: null,
	      params: null,
	      components: null
	    };
	  },
	  handleError: function handleError(error) {
	    if (this.props.onError) {
	      this.props.onError.call(this, error);
	    } else {
	      // Throw errors by default so we don't silently swallow them!
	      throw error; // This error probably occurred in getChildRoutes or getComponents.
	    }
	  },
	  createRouterObject: function createRouterObject(state) {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.router;
	    }
	
	    var history = this.props.history;
	
	    return (0, _RouterUtils.createRouterObject)(history, this.transitionManager, state);
	  },
	  createTransitionManager: function createTransitionManager() {
	    var matchContext = this.props.matchContext;
	
	    if (matchContext) {
	      return matchContext.transitionManager;
	    }
	
	    var history = this.props.history;
	    var _props = this.props,
	        routes = _props.routes,
	        children = _props.children;
	
	
	    !history.getCurrentLocation ?  false ? (0, _invariant2.default)(false, 'You have provided a history object created with history v4.x or v2.x ' + 'and earlier. This version of React Router is only compatible with v3 ' + 'history objects. Please change to history v3.x.') : (0, _invariant2.default)(false) : void 0;
	
	    return (0, _createTransitionManager3.default)(history, (0, _RouteUtils.createRoutes)(routes || children));
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillMount below for React versions >= 16.3
	  componentWillMount: function componentWillMount() {
	    var _this = this;
	
	    this.transitionManager = this.createTransitionManager();
	    this.router = this.createRouterObject(this.state);
	
	    this._unlisten = this.transitionManager.listen(function (error, state) {
	      if (error) {
	        _this.handleError(error);
	      } else {
	        // Keep the identity of this.router because of a caveat in ContextUtils:
	        // they only work if the object identity is preserved.
	        (0, _RouterUtils.assignRouterState)(_this.router, state);
	        _this.setState(state, _this.props.onUpdate);
	      }
	    });
	  },
	
	
	  // this method will be updated to UNSAFE_componentWillReceiveProps below for React versions >= 16.3
	  /* istanbul ignore next: sanity check */
	  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
	     false ? (0, _routerWarning2.default)(nextProps.history === this.props.history, 'You cannot change <Router history>; it will be ignored') : void 0;
	
	     false ? (0, _routerWarning2.default)((nextProps.routes || nextProps.children) === (this.props.routes || this.props.children), 'You cannot change <Router routes>; it will be ignored') : void 0;
	  },
	  componentWillUnmount: function componentWillUnmount() {
	    if (this._unlisten) this._unlisten();
	  },
	  render: function render() {
	    var _state = this.state,
	        location = _state.location,
	        routes = _state.routes,
	        params = _state.params,
	        components = _state.components;
	
	    var _props2 = this.props,
	        createElement = _props2.createElement,
	        render = _props2.render,
	        props = _objectWithoutProperties(_props2, ['createElement', 'render']);
	
	    if (location == null) return null; // Async match
	
	    // Only forward non-Router-specific props to routing context, as those are
	    // the only ones that might be custom routing context props.
	    Object.keys(propTypes).forEach(function (propType) {
	      return delete props[propType];
	    });
	
	    return render(_extends({}, props, {
	      router: this.router,
	      location: location,
	      routes: routes,
	      params: params,
	      components: components,
	      createElement: createElement
	    }));
	  }
	});
	
	if (prefixUnsafeLifecycleMethods) {
	  Router.prototype.UNSAFE_componentWillReceiveProps = Router.prototype.componentWillReceiveProps;
	  Router.prototype.UNSAFE_componentWillMount = Router.prototype.componentWillMount;
	  delete Router.prototype.componentWillReceiveProps;
	  delete Router.prototype.componentWillMount;
	}
	
	exports.default = Router;
	module.exports = exports['default'];

/***/ },
/* 2867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = getTransitionUtils;
	
	var _AsyncUtils = __webpack_require__(588);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PendingHooks = function PendingHooks() {
	  var _this = this;
	
	  _classCallCheck(this, PendingHooks);
	
	  this.hooks = [];
	
	  this.add = function (hook) {
	    return _this.hooks.push(hook);
	  };
	
	  this.remove = function (hook) {
	    return _this.hooks = _this.hooks.filter(function (h) {
	      return h !== hook;
	    });
	  };
	
	  this.has = function (hook) {
	    return _this.hooks.indexOf(hook) !== -1;
	  };
	
	  this.clear = function () {
	    return _this.hooks = [];
	  };
	};
	
	function getTransitionUtils() {
	  var enterHooks = new PendingHooks();
	  var changeHooks = new PendingHooks();
	
	  function createTransitionHook(hook, route, asyncArity, pendingHooks) {
	    var isSync = hook.length < asyncArity;
	
	    var transitionHook = function transitionHook() {
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      hook.apply(route, args);
	
	      if (isSync) {
	        var callback = args[args.length - 1];
	        // Assume hook executes synchronously and
	        // automatically call the callback.
	        callback();
	      }
	    };
	
	    pendingHooks.add(transitionHook);
	
	    return transitionHook;
	  }
	
	  function getEnterHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onEnter) hooks.push(createTransitionHook(route.onEnter, route, 3, enterHooks));
	      return hooks;
	    }, []);
	  }
	
	  function getChangeHooks(routes) {
	    return routes.reduce(function (hooks, route) {
	      if (route.onChange) hooks.push(createTransitionHook(route.onChange, route, 4, changeHooks));
	      return hooks;
	    }, []);
	  }
	
	  function runTransitionHooks(length, iter, callback) {
	    if (!length) {
	      callback();
	      return;
	    }
	
	    var redirectInfo = void 0;
	    function replace(location) {
	      redirectInfo = location;
	    }
	
	    (0, _AsyncUtils.loopAsync)(length, function (index, next, done) {
	      iter(index, replace, function (error) {
	        if (error || redirectInfo) {
	          done(error, redirectInfo); // No need to continue.
	        } else {
	          next();
	        }
	      });
	    }, callback);
	  }
	
	  /**
	   * Runs all onEnter hooks in the given array of routes in order
	   * with onEnter(nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runEnterHooks(routes, nextState, callback) {
	    enterHooks.clear();
	    var hooks = getEnterHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (enterHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          enterHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onChange hooks in the given array of routes in order
	   * with onChange(prevState, nextState, replace, callback) and calls
	   * callback(error, redirectInfo) when finished. The first hook
	   * to use replace short-circuits the loop.
	   *
	   * If a hook needs to run asynchronously, it may use the callback
	   * function. However, doing so will cause the transition to pause,
	   * which could lead to a non-responsive UI if the hook is slow.
	   */
	  function runChangeHooks(routes, state, nextState, callback) {
	    changeHooks.clear();
	    var hooks = getChangeHooks(routes);
	    return runTransitionHooks(hooks.length, function (index, replace, next) {
	      var wrappedNext = function wrappedNext() {
	        if (changeHooks.has(hooks[index])) {
	          next.apply(undefined, arguments);
	          changeHooks.remove(hooks[index]);
	        }
	      };
	      hooks[index](state, nextState, replace, wrappedNext);
	    }, callback);
	  }
	
	  /**
	   * Runs all onLeave hooks in the given array of routes in order.
	   */
	  function runLeaveHooks(routes, prevState) {
	    for (var i = 0, len = routes.length; i < len; ++i) {
	      if (routes[i].onLeave) routes[i].onLeave.call(routes[i], prevState);
	    }
	  }
	
	  return {
	    runEnterHooks: runEnterHooks,
	    runChangeHooks: runChangeHooks,
	    runLeaveHooks: runLeaveHooks
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 2868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _RouterContext = __webpack_require__(591);
	
	var _RouterContext2 = _interopRequireDefault(_RouterContext);
	
	var _routerWarning = __webpack_require__(262);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  if (false) {
	    middlewares.forEach(function (middleware, index) {
	      process.env.NODE_ENV !== 'production' ? (0, _routerWarning2.default)(middleware.renderRouterContext || middleware.renderRouteComponent, 'The middleware specified at index ' + index + ' does not appear to be ' + 'a valid React Router middleware.') : void 0;
	    });
	  }
	
	  var withContext = middlewares.map(function (middleware) {
	    return middleware.renderRouterContext;
	  }).filter(Boolean);
	  var withComponent = middlewares.map(function (middleware) {
	    return middleware.renderRouteComponent;
	  }).filter(Boolean);
	
	  var makeCreateElement = function makeCreateElement() {
	    var baseCreateElement = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _react.createElement;
	    return function (Component, props) {
	      return withComponent.reduceRight(function (previous, renderRouteComponent) {
	        return renderRouteComponent(previous, props);
	      }, baseCreateElement(Component, props));
	    };
	  };
	
	  return function (renderProps) {
	    return withContext.reduceRight(function (previous, renderRouterContext) {
	      return renderRouterContext(previous, renderProps);
	    }, _react2.default.createElement(_RouterContext2.default, _extends({}, renderProps, {
	      createElement: makeCreateElement(renderProps.createElement)
	    })));
	  };
	};
	
	module.exports = exports['default'];

/***/ },
/* 2869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createBrowserHistory = __webpack_require__(2486);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _createRouterHistory = __webpack_require__(1161);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createBrowserHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 2870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(261);
	
	function routeParamsChanged(route, prevState, nextState) {
	  if (!route.path) return false;
	
	  var paramNames = (0, _PatternUtils.getParamNames)(route.path);
	
	  return paramNames.some(function (paramName) {
	    return prevState.params[paramName] !== nextState.params[paramName];
	  });
	}
	
	/**
	 * Returns an object of { leaveRoutes, changeRoutes, enterRoutes } determined by
	 * the change from prevState to nextState. We leave routes if either
	 * 1) they are not in the next state or 2) they are in the next state
	 * but their params have changed (i.e. /users/123 => /users/456).
	 *
	 * leaveRoutes are ordered starting at the leaf route of the tree
	 * we're leaving up to the common parent route. enterRoutes are ordered
	 * from the top of the tree we're entering down to the leaf route.
	 *
	 * changeRoutes are any routes that didn't leave or enter during
	 * the transition.
	 */
	function computeChangedRoutes(prevState, nextState) {
	  var prevRoutes = prevState && prevState.routes;
	  var nextRoutes = nextState.routes;
	
	  var leaveRoutes = void 0,
	      changeRoutes = void 0,
	      enterRoutes = void 0;
	  if (prevRoutes) {
	    var parentIsLeaving = false;
	    leaveRoutes = prevRoutes.filter(function (route) {
	      if (parentIsLeaving) {
	        return true;
	      } else {
	        var isLeaving = nextRoutes.indexOf(route) === -1 || routeParamsChanged(route, prevState, nextState);
	        if (isLeaving) parentIsLeaving = true;
	        return isLeaving;
	      }
	    });
	
	    // onLeave hooks start at the leaf route.
	    leaveRoutes.reverse();
	
	    enterRoutes = [];
	    changeRoutes = [];
	
	    nextRoutes.forEach(function (route) {
	      var isNew = prevRoutes.indexOf(route) === -1;
	      var paramsChanged = leaveRoutes.indexOf(route) !== -1;
	
	      if (isNew || paramsChanged) enterRoutes.push(route);else changeRoutes.push(route);
	    });
	  } else {
	    leaveRoutes = [];
	    changeRoutes = [];
	    enterRoutes = nextRoutes;
	  }
	
	  return {
	    leaveRoutes: leaveRoutes,
	    changeRoutes: changeRoutes,
	    enterRoutes: enterRoutes
	  };
	}
	
	exports.default = computeChangedRoutes;
	module.exports = exports['default'];

/***/ },
/* 2871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _AsyncUtils = __webpack_require__(588);
	
	var _PromiseUtils = __webpack_require__(1157);
	
	function getComponentsForRoute(nextState, route, callback) {
	  if (route.component || route.components) {
	    callback(null, route.component || route.components);
	    return;
	  }
	
	  var getComponent = route.getComponent || route.getComponents;
	  if (getComponent) {
	    var componentReturn = getComponent.call(route, nextState, callback);
	    if ((0, _PromiseUtils.isPromise)(componentReturn)) componentReturn.then(function (component) {
	      return callback(null, component);
	    }, callback);
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously fetches all components needed for the given router
	 * state and calls callback(error, components) when finished.
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getComponents method.
	 */
	function getComponents(nextState, callback) {
	  (0, _AsyncUtils.mapAsync)(nextState.routes, function (route, index, callback) {
	    getComponentsForRoute(nextState, route, callback);
	  }, callback);
	}
	
	exports.default = getComponents;
	module.exports = exports['default'];

/***/ },
/* 2872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _PatternUtils = __webpack_require__(261);
	
	/**
	 * Extracts an object of params the given route cares about from
	 * the given params object.
	 */
	function getRouteParams(route, params) {
	  var routeParams = {};
	
	  if (!route.path) return routeParams;
	
	  (0, _PatternUtils.getParamNames)(route.path).forEach(function (p) {
	    if (Object.prototype.hasOwnProperty.call(params, p)) {
	      routeParams[p] = params[p];
	    }
	  });
	
	  return routeParams;
	}
	
	exports.default = getRouteParams;
	module.exports = exports['default'];

/***/ },
/* 2873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createHashHistory = __webpack_require__(2487);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _createRouterHistory = __webpack_require__(1161);
	
	var _createRouterHistory2 = _interopRequireDefault(_createRouterHistory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = (0, _createRouterHistory2.default)(_createHashHistory2.default);
	module.exports = exports['default'];

/***/ },
/* 2874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = isActive;
	
	var _PatternUtils = __webpack_require__(261);
	
	function deepEqual(a, b) {
	  if (a == b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return deepEqual(item, b[index]);
	    });
	  }
	
	  if ((typeof a === 'undefined' ? 'undefined' : _typeof(a)) === 'object') {
	    for (var p in a) {
	      if (!Object.prototype.hasOwnProperty.call(a, p)) {
	        continue;
	      }
	
	      if (a[p] === undefined) {
	        if (b[p] !== undefined) {
	          return false;
	        }
	      } else if (!Object.prototype.hasOwnProperty.call(b, p)) {
	        return false;
	      } else if (!deepEqual(a[p], b[p])) {
	        return false;
	      }
	    }
	
	    return true;
	  }
	
	  return String(a) === String(b);
	}
	
	/**
	 * Returns true if the current pathname matches the supplied one, net of
	 * leading and trailing slash normalization. This is sufficient for an
	 * indexOnly route match.
	 */
	function pathIsActive(pathname, currentPathname) {
	  // Normalize leading slash for consistency. Leading slash on pathname has
	  // already been normalized in isActive. See caveat there.
	  if (currentPathname.charAt(0) !== '/') {
	    currentPathname = '/' + currentPathname;
	  }
	
	  // Normalize the end of both path names too. Maybe `/foo/` shouldn't show
	  // `/foo` as active, but in this case, we would already have failed the
	  // match.
	  if (pathname.charAt(pathname.length - 1) !== '/') {
	    pathname += '/';
	  }
	  if (currentPathname.charAt(currentPathname.length - 1) !== '/') {
	    currentPathname += '/';
	  }
	
	  return currentPathname === pathname;
	}
	
	/**
	 * Returns true if the given pathname matches the active routes and params.
	 */
	function routeIsActive(pathname, routes, params) {
	  var remainingPathname = pathname,
	      paramNames = [],
	      paramValues = [];
	
	  // for...of would work here but it's probably slower post-transpilation.
	  for (var i = 0, len = routes.length; i < len; ++i) {
	    var route = routes[i];
	    var pattern = route.path || '';
	
	    if (pattern.charAt(0) === '/') {
	      remainingPathname = pathname;
	      paramNames = [];
	      paramValues = [];
	    }
	
	    if (remainingPathname !== null && pattern) {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	
	      if (remainingPathname === '') {
	        // We have an exact match on the route. Just check that all the params
	        // match.
	        // FIXME: This doesn't work on repeated params.
	        return paramNames.every(function (paramName, index) {
	          return String(paramValues[index]) === String(params[paramName]);
	        });
	      }
	    }
	  }
	
	  return false;
	}
	
	/**
	 * Returns true if all key/value pairs in the given query are
	 * currently active.
	 */
	function queryIsActive(query, activeQuery) {
	  if (activeQuery == null) return query == null;
	
	  if (query == null) return true;
	
	  return deepEqual(query, activeQuery);
	}
	
	/**
	 * Returns true if a <Link> to the given pathname/query combination is
	 * currently active.
	 */
	function isActive(_ref, indexOnly, currentLocation, routes, params) {
	  var pathname = _ref.pathname,
	      query = _ref.query;
	
	  if (currentLocation == null) return false;
	
	  // TODO: This is a bit ugly. It keeps around support for treating pathnames
	  // without preceding slashes as absolute paths, but possibly also works
	  // around the same quirks with basenames as in matchRoutes.
	  if (pathname.charAt(0) !== '/') {
	    pathname = '/' + pathname;
	  }
	
	  if (!pathIsActive(pathname, currentLocation.pathname)) {
	    // The path check is necessary and sufficient for indexOnly, but otherwise
	    // we still need to check the routes.
	    if (indexOnly || !routeIsActive(pathname, routes, params)) {
	      return false;
	    }
	  }
	
	  return queryIsActive(query, currentLocation.query);
	}
	module.exports = exports['default'];

/***/ },
/* 2875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _Actions = __webpack_require__(367);
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _createMemoryHistory = __webpack_require__(1160);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _createTransitionManager = __webpack_require__(1162);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _RouteUtils = __webpack_require__(186);
	
	var _RouterUtils = __webpack_require__(1159);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A high-level API to be used for server-side rendering.
	 *
	 * This function matches a location to a set of routes and calls
	 * callback(error, redirectLocation, renderProps) when finished.
	 *
	 * Note: You probably don't want to use this in a browser unless you're using
	 * server-side rendering with async routes.
	 */
	function match(_ref, callback) {
	  var history = _ref.history,
	      routes = _ref.routes,
	      location = _ref.location,
	      options = _objectWithoutProperties(_ref, ['history', 'routes', 'location']);
	
	  !(history || location) ?  false ? (0, _invariant2.default)(false, 'match needs a history or a location') : (0, _invariant2.default)(false) : void 0;
	
	  history = history ? history : (0, _createMemoryHistory2.default)(options);
	  var transitionManager = (0, _createTransitionManager2.default)(history, (0, _RouteUtils.createRoutes)(routes));
	
	  if (location) {
	    // Allow match({ location: '/the/path', ... })
	    location = history.createLocation(location);
	  } else {
	    location = history.getCurrentLocation();
	  }
	
	  transitionManager.match(location, function (error, redirectLocation, nextState) {
	    var renderProps = void 0;
	
	    if (nextState) {
	      var router = (0, _RouterUtils.createRouterObject)(history, transitionManager, nextState);
	      renderProps = _extends({}, nextState, {
	        router: router,
	        matchContext: { transitionManager: transitionManager, router: router }
	      });
	    }
	
	    callback(error, redirectLocation && history.createLocation(redirectLocation, _Actions.REPLACE), renderProps);
	  });
	}
	
	exports.default = match;
	module.exports = exports['default'];

/***/ },
/* 2876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = matchRoutes;
	
	var _AsyncUtils = __webpack_require__(588);
	
	var _PromiseUtils = __webpack_require__(1157);
	
	var _PatternUtils = __webpack_require__(261);
	
	var _routerWarning = __webpack_require__(262);
	
	var _routerWarning2 = _interopRequireDefault(_routerWarning);
	
	var _RouteUtils = __webpack_require__(186);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getChildRoutes(route, location, paramNames, paramValues, callback) {
	  if (route.childRoutes) {
	    return [null, route.childRoutes];
	  }
	  if (!route.getChildRoutes) {
	    return [];
	  }
	
	  var sync = true,
	      result = void 0;
	
	  var partialNextState = {
	    location: location,
	    params: createParams(paramNames, paramValues)
	  };
	
	  var childRoutesReturn = route.getChildRoutes(partialNextState, function (error, childRoutes) {
	    childRoutes = !error && (0, _RouteUtils.createRoutes)(childRoutes);
	    if (sync) {
	      result = [error, childRoutes];
	      return;
	    }
	
	    callback(error, childRoutes);
	  });
	
	  if ((0, _PromiseUtils.isPromise)(childRoutesReturn)) childRoutesReturn.then(function (childRoutes) {
	    return callback(null, (0, _RouteUtils.createRoutes)(childRoutes));
	  }, callback);
	
	  sync = false;
	  return result; // Might be undefined.
	}
	
	function getIndexRoute(route, location, paramNames, paramValues, callback) {
	  if (route.indexRoute) {
	    callback(null, route.indexRoute);
	  } else if (route.getIndexRoute) {
	    var partialNextState = {
	      location: location,
	      params: createParams(paramNames, paramValues)
	    };
	
	    var indexRoutesReturn = route.getIndexRoute(partialNextState, function (error, indexRoute) {
	      callback(error, !error && (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    });
	
	    if ((0, _PromiseUtils.isPromise)(indexRoutesReturn)) indexRoutesReturn.then(function (indexRoute) {
	      return callback(null, (0, _RouteUtils.createRoutes)(indexRoute)[0]);
	    }, callback);
	  } else if (route.childRoutes || route.getChildRoutes) {
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	        return;
	      }
	
	      var pathless = childRoutes.filter(function (childRoute) {
	        return !childRoute.path;
	      });
	
	      (0, _AsyncUtils.loopAsync)(pathless.length, function (index, next, done) {
	        getIndexRoute(pathless[index], location, paramNames, paramValues, function (error, indexRoute) {
	          if (error || indexRoute) {
	            var routes = [pathless[index]].concat(Array.isArray(indexRoute) ? indexRoute : [indexRoute]);
	            done(error, routes);
	          } else {
	            next();
	          }
	        });
	      }, function (err, routes) {
	        callback(null, routes);
	      });
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	function assignParams(params, paramNames, paramValues) {
	  return paramNames.reduce(function (params, paramName, index) {
	    var paramValue = paramValues && paramValues[index];
	
	    if (Array.isArray(params[paramName])) {
	      params[paramName].push(paramValue);
	    } else if (paramName in params) {
	      params[paramName] = [params[paramName], paramValue];
	    } else {
	      params[paramName] = paramValue;
	    }
	
	    return params;
	  }, params);
	}
	
	function createParams(paramNames, paramValues) {
	  return assignParams({}, paramNames, paramValues);
	}
	
	function matchRouteDeep(route, location, remainingPathname, paramNames, paramValues, callback) {
	  var pattern = route.path || '';
	
	  if (pattern.charAt(0) === '/') {
	    remainingPathname = location.pathname;
	    paramNames = [];
	    paramValues = [];
	  }
	
	  // Only try to match the path if the route actually has a pattern, and if
	  // we're not just searching for potential nested absolute paths.
	  if (remainingPathname !== null && pattern) {
	    try {
	      var matched = (0, _PatternUtils.matchPattern)(pattern, remainingPathname);
	      if (matched) {
	        remainingPathname = matched.remainingPathname;
	        paramNames = [].concat(paramNames, matched.paramNames);
	        paramValues = [].concat(paramValues, matched.paramValues);
	      } else {
	        remainingPathname = null;
	      }
	    } catch (error) {
	      callback(error);
	    }
	
	    // By assumption, pattern is non-empty here, which is the prerequisite for
	    // actually terminating a match.
	    if (remainingPathname === '') {
	      var match = {
	        routes: [route],
	        params: createParams(paramNames, paramValues)
	      };
	
	      getIndexRoute(route, location, paramNames, paramValues, function (error, indexRoute) {
	        if (error) {
	          callback(error);
	        } else {
	          if (Array.isArray(indexRoute)) {
	            var _match$routes;
	
	             false ? (0, _routerWarning2.default)(indexRoute.every(function (route) {
	              return !route.path;
	            }), 'Index routes should not have paths') : void 0;
	            (_match$routes = match.routes).push.apply(_match$routes, indexRoute);
	          } else if (indexRoute) {
	             false ? (0, _routerWarning2.default)(!indexRoute.path, 'Index routes should not have paths') : void 0;
	            match.routes.push(indexRoute);
	          }
	
	          callback(null, match);
	        }
	      });
	
	      return;
	    }
	  }
	
	  if (remainingPathname != null || route.childRoutes) {
	    // Either a) this route matched at least some of the path or b)
	    // we don't have to load this route's children asynchronously. In
	    // either case continue checking for matches in the subtree.
	    var onChildRoutes = function onChildRoutes(error, childRoutes) {
	      if (error) {
	        callback(error);
	      } else if (childRoutes) {
	        // Check the child routes to see if any of them match.
	        matchRoutes(childRoutes, location, function (error, match) {
	          if (error) {
	            callback(error);
	          } else if (match) {
	            // A child route matched! Augment the match and pass it up the stack.
	            match.routes.unshift(route);
	            callback(null, match);
	          } else {
	            callback();
	          }
	        }, remainingPathname, paramNames, paramValues);
	      } else {
	        callback();
	      }
	    };
	
	    var result = getChildRoutes(route, location, paramNames, paramValues, onChildRoutes);
	    if (result) {
	      onChildRoutes.apply(undefined, result);
	    }
	  } else {
	    callback();
	  }
	}
	
	/**
	 * Asynchronously matches the given location to a set of routes and calls
	 * callback(error, state) when finished. The state object will have the
	 * following properties:
	 *
	 * - routes       An array of routes that matched, in hierarchical order
	 * - params       An object of URL parameters
	 *
	 * Note: This operation may finish synchronously if no routes have an
	 * asynchronous getChildRoutes method.
	 */
	function matchRoutes(routes, location, callback, remainingPathname) {
	  var paramNames = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
	  var paramValues = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
	
	  if (remainingPathname === undefined) {
	    // TODO: This is a little bit ugly, but it works around a quirk in history
	    // that strips the leading slash from pathnames when using basenames with
	    // trailing slashes.
	    if (location.pathname.charAt(0) !== '/') {
	      location = _extends({}, location, {
	        pathname: '/' + location.pathname
	      });
	    }
	    remainingPathname = location.pathname;
	  }
	
	  (0, _AsyncUtils.loopAsync)(routes.length, function (index, next, done) {
	    matchRouteDeep(routes[index], location, remainingPathname, paramNames, paramValues, function (error, match) {
	      if (error || match) {
	        done(error, match);
	      } else {
	        next();
	      }
	    });
	  }, callback);
	}
	module.exports = exports['default'];

/***/ },
/* 2877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = withRouter;
	
	var _invariant = __webpack_require__(85);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _createReactClass = __webpack_require__(139);
	
	var _createReactClass2 = _interopRequireDefault(_createReactClass);
	
	var _hoistNonReactStatics = __webpack_require__(529);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _ContextUtils = __webpack_require__(589);
	
	var _PropTypes = __webpack_require__(590);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getDisplayName(WrappedComponent) {
	  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
	}
	
	function withRouter(WrappedComponent, options) {
	  var withRef = options && options.withRef;
	
	  var WithRouter = (0, _createReactClass2.default)({
	    displayName: 'WithRouter',
	
	    mixins: [(0, _ContextUtils.ContextSubscriber)('router')],
	
	    contextTypes: { router: _PropTypes.routerShape },
	    propTypes: { router: _PropTypes.routerShape },
	
	    getWrappedInstance: function getWrappedInstance() {
	      !withRef ?  false ? (0, _invariant2.default)(false, 'To access the wrapped instance, you need to specify ' + '`{ withRef: true }` as the second argument of the withRouter() call.') : (0, _invariant2.default)(false) : void 0;
	
	      return this.wrappedInstance;
	    },
	    render: function render() {
	      var _this = this;
	
	      var router = this.props.router || this.context.router;
	      if (!router) {
	        return _react2.default.createElement(WrappedComponent, this.props);
	      }
	
	      var params = router.params,
	          location = router.location,
	          routes = router.routes;
	
	      var props = _extends({}, this.props, { router: router, params: params, location: location, routes: routes });
	
	      if (withRef) {
	        props.ref = function (c) {
	          _this.wrappedInstance = c;
	        };
	      }
	
	      return _react2.default.createElement(WrappedComponent, props);
	    }
	  });
	
	  WithRouter.displayName = 'withRouter(' + getDisplayName(WrappedComponent) + ')';
	  WithRouter.WrappedComponent = WrappedComponent;
	
	  return (0, _hoistNonReactStatics2.default)(WithRouter, WrappedComponent);
	}
	module.exports = exports['default'];

/***/ },
/* 2878 */
216,
/* 2879 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.NextArrow = exports.PrevArrow = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _innerSliderUtils = __webpack_require__(390);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var PrevArrow =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(PrevArrow, _React$PureComponent);
	
	  function PrevArrow() {
	    _classCallCheck(this, PrevArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(PrevArrow).apply(this, arguments));
	  }
	
	  _createClass(PrevArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var prevClasses = {
	        "slick-arrow": true,
	        "slick-prev": true
	      };
	      var prevHandler = this.clickHandler.bind(this, {
	        message: "previous"
	      });
	
	      if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
	        prevClasses["slick-disabled"] = true;
	        prevHandler = null;
	      }
	
	      var prevArrowProps = {
	        key: "0",
	        "data-role": "none",
	        className: (0, _classnames["default"])(prevClasses),
	        style: {
	          display: "block"
	        },
	        onClick: prevHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var prevArrow;
	
	      if (this.props.prevArrow) {
	        prevArrow = _react["default"].cloneElement(this.props.prevArrow, _objectSpread({}, prevArrowProps, {}, customProps));
	      } else {
	        prevArrow = _react["default"].createElement("button", _extends({
	          key: "0",
	          type: "button"
	        }, prevArrowProps), " ", "Previous");
	      }
	
	      return prevArrow;
	    }
	  }]);
	
	  return PrevArrow;
	}(_react["default"].PureComponent);
	
	exports.PrevArrow = PrevArrow;
	
	var NextArrow =
	/*#__PURE__*/
	function (_React$PureComponent2) {
	  _inherits(NextArrow, _React$PureComponent2);
	
	  function NextArrow() {
	    _classCallCheck(this, NextArrow);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(NextArrow).apply(this, arguments));
	  }
	
	  _createClass(NextArrow, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      if (e) {
	        e.preventDefault();
	      }
	
	      this.props.clickHandler(options, e);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var nextClasses = {
	        "slick-arrow": true,
	        "slick-next": true
	      };
	      var nextHandler = this.clickHandler.bind(this, {
	        message: "next"
	      });
	
	      if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
	        nextClasses["slick-disabled"] = true;
	        nextHandler = null;
	      }
	
	      var nextArrowProps = {
	        key: "1",
	        "data-role": "none",
	        className: (0, _classnames["default"])(nextClasses),
	        style: {
	          display: "block"
	        },
	        onClick: nextHandler
	      };
	      var customProps = {
	        currentSlide: this.props.currentSlide,
	        slideCount: this.props.slideCount
	      };
	      var nextArrow;
	
	      if (this.props.nextArrow) {
	        nextArrow = _react["default"].cloneElement(this.props.nextArrow, _objectSpread({}, nextArrowProps, {}, customProps));
	      } else {
	        nextArrow = _react["default"].createElement("button", _extends({
	          key: "1",
	          type: "button"
	        }, nextArrowProps), " ", "Next");
	      }
	
	      return nextArrow;
	    }
	  }]);
	
	  return NextArrow;
	}(_react["default"].PureComponent);
	
	exports.NextArrow = NextArrow;

/***/ },
/* 2880 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var defaultProps = {
	  accessibility: true,
	  adaptiveHeight: false,
	  afterChange: null,
	  appendDots: function appendDots(dots) {
	    return _react["default"].createElement("ul", {
	      style: {
	        display: "block"
	      }
	    }, dots);
	  },
	  arrows: true,
	  autoplay: false,
	  autoplaySpeed: 3000,
	  beforeChange: null,
	  centerMode: false,
	  centerPadding: "50px",
	  className: "",
	  cssEase: "ease",
	  customPaging: function customPaging(i) {
	    return _react["default"].createElement("button", null, i + 1);
	  },
	  dots: false,
	  dotsClass: "slick-dots",
	  draggable: true,
	  easing: "linear",
	  edgeFriction: 0.35,
	  fade: false,
	  focusOnSelect: false,
	  infinite: true,
	  initialSlide: 0,
	  lazyLoad: null,
	  nextArrow: null,
	  onEdge: null,
	  onInit: null,
	  onLazyLoadError: null,
	  onReInit: null,
	  pauseOnDotsHover: false,
	  pauseOnFocus: false,
	  pauseOnHover: true,
	  prevArrow: null,
	  responsive: null,
	  rows: 1,
	  rtl: false,
	  slide: "div",
	  slidesPerRow: 1,
	  slidesToScroll: 1,
	  slidesToShow: 1,
	  speed: 500,
	  swipe: true,
	  swipeEvent: null,
	  swipeToSlide: false,
	  touchMove: true,
	  touchThreshold: 5,
	  useCSS: true,
	  useTransform: true,
	  variableWidth: false,
	  vertical: false,
	  waitForAnimate: true
	};
	var _default = defaultProps;
	exports["default"] = _default;

/***/ },
/* 2881 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Dots = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	var getDotCount = function getDotCount(spec) {
	  var dots;
	
	  if (spec.infinite) {
	    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
	  } else {
	    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
	  }
	
	  return dots;
	};
	
	var Dots =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Dots, _React$PureComponent);
	
	  function Dots() {
	    _classCallCheck(this, Dots);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Dots).apply(this, arguments));
	  }
	
	  _createClass(Dots, [{
	    key: "clickHandler",
	    value: function clickHandler(options, e) {
	      // In Autoplay the focus stays on clicked button even after transition
	      // to next slide. That only goes away by click somewhere outside
	      e.preventDefault();
	      this.props.clickHandler(options);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this = this;
	
	      var dotCount = getDotCount({
	        slideCount: this.props.slideCount,
	        slidesToScroll: this.props.slidesToScroll,
	        slidesToShow: this.props.slidesToShow,
	        infinite: this.props.infinite
	      }); // Apply join & split to Array to pre-fill it for IE8
	      //
	      // Credit: http://stackoverflow.com/a/13735425/1849458
	
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
	        var leftBound = i * _this.props.slidesToScroll;
	        var rightBound = i * _this.props.slidesToScroll + (_this.props.slidesToScroll - 1);
	        var className = (0, _classnames["default"])({
	          "slick-active": _this.props.currentSlide >= leftBound && _this.props.currentSlide <= rightBound
	        });
	        var dotOptions = {
	          message: "dots",
	          index: i,
	          slidesToScroll: _this.props.slidesToScroll,
	          currentSlide: _this.props.currentSlide
	        };
	
	        var onClick = _this.clickHandler.bind(_this, dotOptions);
	
	        return _react["default"].createElement("li", {
	          key: i,
	          className: className
	        }, _react["default"].cloneElement(_this.props.customPaging(i), {
	          onClick: onClick
	        }));
	      });
	      return _react["default"].cloneElement(this.props.appendDots(dots), _objectSpread({
	        className: this.props.dotsClass
	      }, mouseEvents));
	    }
	  }]);
	
	  return Dots;
	}(_react["default"].PureComponent);
	
	exports.Dots = Dots;

/***/ },
/* 2882 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _slider = _interopRequireDefault(__webpack_require__(2885));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _slider["default"];
	exports["default"] = _default;

/***/ },
/* 2883 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	var initialState = {
	  animating: false,
	  autoplaying: null,
	  currentDirection: 0,
	  currentLeft: null,
	  currentSlide: 0,
	  direction: 1,
	  dragging: false,
	  edgeDragged: false,
	  initialized: false,
	  lazyLoadedList: [],
	  listHeight: null,
	  listWidth: null,
	  scrolling: false,
	  slideCount: null,
	  slideHeight: null,
	  slideWidth: null,
	  swipeLeft: null,
	  swiped: false,
	  // used by swipeEvent. differentites between touch and swipe.
	  swiping: false,
	  touchObject: {
	    startX: 0,
	    startY: 0,
	    curX: 0,
	    curY: 0
	  },
	  trackStyle: {},
	  trackWidth: 0
	};
	var _default = initialState;
	exports["default"] = _default;

/***/ },
/* 2884 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.InnerSlider = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(23));
	
	var _initialState = _interopRequireDefault(__webpack_require__(2883));
	
	var _lodash = _interopRequireDefault(__webpack_require__(369));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _innerSliderUtils = __webpack_require__(390);
	
	var _track = __webpack_require__(2886);
	
	var _dots = __webpack_require__(2881);
	
	var _arrows = __webpack_require__(2879);
	
	var _resizeObserverPolyfill = _interopRequireDefault(__webpack_require__(391));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var InnerSlider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(InnerSlider, _React$Component);
	
	  function InnerSlider(props) {
	    var _this;
	
	    _classCallCheck(this, InnerSlider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(InnerSlider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "listRefHandler", function (ref) {
	      return _this.list = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "trackRefHandler", function (ref) {
	      return _this.track = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "adaptHeight", function () {
	      if (_this.props.adaptiveHeight && _this.list) {
	        var elem = _this.list.querySelector("[data-index=\"".concat(_this.state.currentSlide, "\"]"));
	
	        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillMount", function () {
	      _this.ssrInit();
	
	      _this.props.onInit && _this.props.onInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props);
	
	      _this.updateState(spec, true, function () {
	        _this.adaptHeight();
	
	        _this.props.autoplay && _this.autoPlay("update");
	      });
	
	      if (_this.props.lazyLoad === "progressive") {
	        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
	      }
	
	      _this.ro = new _resizeObserverPolyfill["default"](function () {
	        if (_this.state.animating) {
	          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
	
	
	          _this.callbackTimers.push(setTimeout(function () {
	            return _this.onWindowResized();
	          }, _this.props.speed));
	        } else {
	          _this.onWindowResized();
	        }
	      });
	
	      _this.ro.observe(_this.list);
	
	      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
	        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
	        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
	      }); // To support server-side rendering
	
	      if (!window) {
	        return;
	      }
	
	      if (window.addEventListener) {
	        window.addEventListener("resize", _this.onWindowResized);
	      } else {
	        window.attachEvent("onresize", _this.onWindowResized);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
	      if (_this.animationEndCallback) {
	        clearTimeout(_this.animationEndCallback);
	      }
	
	      if (_this.lazyLoadTimer) {
	        clearInterval(_this.lazyLoadTimer);
	      }
	
	      if (_this.callbackTimers.length) {
	        _this.callbackTimers.forEach(function (timer) {
	          return clearTimeout(timer);
	        });
	
	        _this.callbackTimers = [];
	      }
	
	      if (window.addEventListener) {
	        window.removeEventListener("resize", _this.onWindowResized);
	      } else {
	        window.detachEvent("onresize", _this.onWindowResized);
	      }
	
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "UNSAFE_componentWillReceiveProps", function (nextProps) {
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, nextProps, {}, _this.state);
	
	      var setTrackStyle = false;
	
	      for (var _i = 0, _Object$keys = Object.keys(_this.props); _i < _Object$keys.length; _i++) {
	        var key = _Object$keys[_i];
	
	        if (!nextProps.hasOwnProperty(key)) {
	          setTrackStyle = true;
	          break;
	        }
	
	        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
	          continue;
	        }
	
	        if (nextProps[key] !== _this.props[key]) {
	          setTrackStyle = true;
	          break;
	        }
	      }
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.state.currentSlide >= _react["default"].Children.count(nextProps.children)) {
	          _this.changeSlide({
	            message: "index",
	            index: _react["default"].Children.count(nextProps.children) - nextProps.slidesToShow,
	            currentSlide: _this.state.currentSlide
	          });
	        }
	
	        if (nextProps.autoplay) {
	          _this.autoPlay("update");
	        } else {
	          _this.pause("paused");
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function () {
	      _this.checkImagesLoad();
	
	      _this.props.onReInit && _this.props.onReInit();
	
	      if (_this.props.lazyLoad) {
	        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_objectSpread({}, _this.props, {}, _this.state));
	
	        if (slidesToLoad.length > 0) {
	          _this.setState(function (prevState) {
	            return {
	              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
	            };
	          });
	
	          if (_this.props.onLazyLoad) {
	            _this.props.onLazyLoad(slidesToLoad);
	          }
	        }
	      } // if (this.props.onLazyLoad) {
	      //   this.props.onLazyLoad([leftMostSlide])
	      // }
	
	
	      _this.adaptHeight();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onWindowResized", function (setTrackStyle) {
	      if (_this.debouncedResize) _this.debouncedResize.cancel();
	      _this.debouncedResize = (0, _lodash["default"])(function () {
	        return _this.resizeWindow(setTrackStyle);
	      }, 50);
	
	      _this.debouncedResize();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "resizeWindow", function () {
	      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	      if (!_reactDom["default"].findDOMNode(_this.track)) return;
	
	      var spec = _objectSpread({
	        listRef: _this.list,
	        trackRef: _this.track
	      }, _this.props, {}, _this.state);
	
	      _this.updateState(spec, setTrackStyle, function () {
	        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
	      }); // animating state should be cleared while resizing, otherwise autoplay stops working
	
	
	      _this.setState({
	        animating: false
	      });
	
	      clearTimeout(_this.animationEndCallback);
	      delete _this.animationEndCallback;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateState", function (spec, setTrackStyle, callback) {
	      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
	      spec = _objectSpread({}, spec, {}, updatedState, {
	        slideIndex: updatedState.currentSlide
	      });
	      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
	      spec = _objectSpread({}, spec, {
	        left: targetLeft
	      });
	      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
	
	      if (setTrackStyle || _react["default"].Children.count(_this.props.children) !== _react["default"].Children.count(spec.children)) {
	        updatedState["trackStyle"] = trackStyle;
	      }
	
	      _this.setState(updatedState, callback);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "ssrInit", function () {
	      if (_this.props.variableWidth) {
	        var _trackWidth = 0,
	            _trackLeft = 0;
	        var childrenWidths = [];
	        var preClones = (0, _innerSliderUtils.getPreClones)(_objectSpread({}, _this.props, {}, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	        var postClones = (0, _innerSliderUtils.getPostClones)(_objectSpread({}, _this.props, {}, _this.state, {
	          slideCount: _this.props.children.length
	        }));
	
	        _this.props.children.forEach(function (child) {
	          childrenWidths.push(child.props.style.width);
	          _trackWidth += child.props.style.width;
	        });
	
	        for (var i = 0; i < preClones; i++) {
	          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
	          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
	        }
	
	        for (var _i2 = 0; _i2 < postClones; _i2++) {
	          _trackWidth += childrenWidths[_i2];
	        }
	
	        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
	          _trackLeft += childrenWidths[_i3];
	        }
	
	        var _trackStyle = {
	          width: _trackWidth + "px",
	          left: -_trackLeft + "px"
	        };
	
	        if (_this.props.centerMode) {
	          var currentWidth = "".concat(childrenWidths[_this.state.currentSlide], "px");
	          _trackStyle.left = "calc(".concat(_trackStyle.left, " + (100% - ").concat(currentWidth, ") / 2 ) ");
	        }
	
	        _this.setState({
	          trackStyle: _trackStyle
	        });
	
	        return;
	      }
	
	      var childrenCount = _react["default"].Children.count(_this.props.children);
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state, {
	        slideCount: childrenCount
	      });
	
	      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
	      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
	      var slideWidth = 100 / slideCount;
	      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
	
	      if (_this.props.centerMode) {
	        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
	      }
	
	      var trackStyle = {
	        width: trackWidth + "%",
	        left: trackLeft + "%"
	      };
	
	      _this.setState({
	        slideWidth: slideWidth + "%",
	        trackStyle: trackStyle
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "checkImagesLoad", function () {
	      var images = document.querySelectorAll(".slick-slide img");
	      var imagesCount = images.length,
	          loadedCount = 0;
	      Array.prototype.forEach.call(images, function (image) {
	        var handler = function handler() {
	          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
	        };
	
	        if (!image.onclick) {
	          image.onclick = function () {
	            return image.parentNode.focus();
	          };
	        } else {
	          var prevClickHandler = image.onclick;
	
	          image.onclick = function () {
	            prevClickHandler();
	            image.parentNode.focus();
	          };
	        }
	
	        if (!image.onload) {
	          if (_this.props.lazyLoad) {
	            image.onload = function () {
	              _this.adaptHeight();
	
	              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
	            };
	          } else {
	            image.onload = handler;
	
	            image.onerror = function () {
	              handler();
	              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
	            };
	          }
	        }
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "progressiveLazyLoad", function () {
	      var slidesToLoad = [];
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state);
	
	      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
	        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
	          slidesToLoad.push(index);
	          break;
	        }
	      }
	
	      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
	        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
	          slidesToLoad.push(_index);
	          break;
	        }
	      }
	
	      if (slidesToLoad.length > 0) {
	        _this.setState(function (state) {
	          return {
	            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
	          };
	        });
	
	        if (_this.props.onLazyLoad) {
	          _this.props.onLazyLoad(slidesToLoad);
	        }
	      } else {
	        if (_this.lazyLoadTimer) {
	          clearInterval(_this.lazyLoadTimer);
	          delete _this.lazyLoadTimer;
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slideHandler", function (index) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      var _this$props = _this.props,
	          asNavFor = _this$props.asNavFor,
	          beforeChange = _this$props.beforeChange,
	          onLazyLoad = _this$props.onLazyLoad,
	          speed = _this$props.speed,
	          afterChange = _this$props.afterChange; // capture currentslide before state is updated
	
	      var currentSlide = _this.state.currentSlide;
	
	      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_objectSpread({
	        index: index
	      }, _this.props, {}, _this.state, {
	        trackRef: _this.track,
	        useCSS: _this.props.useCSS && !dontAnimate
	      })),
	          state = _slideHandler.state,
	          nextState = _slideHandler.nextState;
	
	      if (!state) return;
	      beforeChange && beforeChange(currentSlide, state.currentSlide);
	      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
	        return _this.state.lazyLoadedList.indexOf(value) < 0;
	      });
	      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
	
	      _this.setState(state, function () {
	        asNavFor && asNavFor.innerSlider.slideHandler(index);
	        if (!nextState) return;
	        _this.animationEndCallback = setTimeout(function () {
	          var animating = nextState.animating,
	              firstBatch = _objectWithoutProperties(nextState, ["animating"]);
	
	          _this.setState(firstBatch, function () {
	            _this.callbackTimers.push(setTimeout(function () {
	              return _this.setState({
	                animating: animating
	              });
	            }, 10));
	
	            afterChange && afterChange(state.currentSlide);
	            delete _this.animationEndCallback;
	          });
	        }, speed);
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "changeSlide", function (options) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state);
	
	      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
	      if (targetSlide !== 0 && !targetSlide) return;
	
	      if (dontAnimate === true) {
	        _this.slideHandler(targetSlide, dontAnimate);
	      } else {
	        _this.slideHandler(targetSlide);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "clickHandler", function (e) {
	      if (_this.clickable === false) {
	        e.stopPropagation();
	        e.preventDefault();
	      }
	
	      _this.clickable = true;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "keyHandler", function (e) {
	      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
	      dir !== "" && _this.changeSlide({
	        message: dir
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "selectHandler", function (options) {
	      _this.changeSlide(options);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "disableBodyScroll", function () {
	      var preventDefault = function preventDefault(e) {
	        e = e || window.event;
	        if (e.preventDefault) e.preventDefault();
	        e.returnValue = false;
	      };
	
	      window.ontouchmove = preventDefault;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "enableBodyScroll", function () {
	      window.ontouchmove = null;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeStart", function (e) {
	      if (_this.props.verticalSwiping) {
	        _this.disableBodyScroll();
	      }
	
	      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
	      state !== "" && _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeMove", function (e) {
	      var state = (0, _innerSliderUtils.swipeMove)(e, _objectSpread({}, _this.props, {}, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	
	      if (state["swiping"]) {
	        _this.clickable = false;
	      }
	
	      _this.setState(state);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "swipeEnd", function (e) {
	      var state = (0, _innerSliderUtils.swipeEnd)(e, _objectSpread({}, _this.props, {}, _this.state, {
	        trackRef: _this.track,
	        listRef: _this.list,
	        slideIndex: _this.state.currentSlide
	      }));
	      if (!state) return;
	      var triggerSlideHandler = state["triggerSlideHandler"];
	      delete state["triggerSlideHandler"];
	
	      _this.setState(state);
	
	      if (triggerSlideHandler === undefined) return;
	
	      _this.slideHandler(triggerSlideHandler);
	
	      if (_this.props.verticalSwiping) {
	        _this.enableBodyScroll();
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      // this and fellow methods are wrapped in setTimeout
	      // to make sure initialize setState has happened before
	      // any of such methods are called
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "previous"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "next"
	        });
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      slide = Number(slide);
	      if (isNaN(slide)) return "";
	
	      _this.callbackTimers.push(setTimeout(function () {
	        return _this.changeSlide({
	          message: "index",
	          index: slide,
	          currentSlide: _this.state.currentSlide
	        }, dontAnimate);
	      }, 0));
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "play", function () {
	      var nextIndex;
	
	      if (_this.props.rtl) {
	        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
	      } else {
	        if ((0, _innerSliderUtils.canGoNext)(_objectSpread({}, _this.props, {}, _this.state))) {
	          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
	        } else {
	          return false;
	        }
	      }
	
	      _this.slideHandler(nextIndex);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "autoPlay", function (playType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (playType === "update") {
	        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
	          return;
	        }
	      } else if (playType === "leave") {
	        if (autoplaying === "paused" || autoplaying === "focused") {
	          return;
	        }
	      } else if (playType === "blur") {
	        if (autoplaying === "paused" || autoplaying === "hovered") {
	          return;
	        }
	      }
	
	      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
	
	      _this.setState({
	        autoplaying: "playing"
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "pause", function (pauseType) {
	      if (_this.autoplayTimer) {
	        clearInterval(_this.autoplayTimer);
	        _this.autoplayTimer = null;
	      }
	
	      var autoplaying = _this.state.autoplaying;
	
	      if (pauseType === "paused") {
	        _this.setState({
	          autoplaying: "paused"
	        });
	      } else if (pauseType === "focused") {
	        if (autoplaying === "hovered" || autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "focused"
	          });
	        }
	      } else {
	        // pauseType  is 'hovered'
	        if (autoplaying === "playing") {
	          _this.setState({
	            autoplaying: "hovered"
	          });
	        }
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onDotsLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackOver", function () {
	      return _this.props.autoplay && _this.pause("hovered");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onTrackLeave", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideFocus", function () {
	      return _this.props.autoplay && _this.pause("focused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "onSlideBlur", function () {
	      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "render", function () {
	      var className = (0, _classnames["default"])("slick-slider", _this.props.className, {
	        "slick-vertical": _this.props.vertical,
	        "slick-initialized": true
	      });
	
	      var spec = _objectSpread({}, _this.props, {}, _this.state);
	
	      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
	      var pauseOnHover = _this.props.pauseOnHover;
	      trackProps = _objectSpread({}, trackProps, {
	        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
	        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
	        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
	        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
	      });
	      var dots;
	
	      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
	        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
	        var pauseOnDotsHover = _this.props.pauseOnDotsHover;
	        dotProps = _objectSpread({}, dotProps, {
	          clickHandler: _this.changeSlide,
	          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
	          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
	          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
	        });
	        dots = _react["default"].createElement(_dots.Dots, dotProps);
	      }
	
	      var prevArrow, nextArrow;
	      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
	      arrowProps.clickHandler = _this.changeSlide;
	
	      if (_this.props.arrows) {
	        prevArrow = _react["default"].createElement(_arrows.PrevArrow, arrowProps);
	        nextArrow = _react["default"].createElement(_arrows.NextArrow, arrowProps);
	      }
	
	      var verticalHeightStyle = null;
	
	      if (_this.props.vertical) {
	        verticalHeightStyle = {
	          height: _this.state.listHeight
	        };
	      }
	
	      var centerPaddingStyle = null;
	
	      if (_this.props.vertical === false) {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: "0px " + _this.props.centerPadding
	          };
	        }
	      } else {
	        if (_this.props.centerMode === true) {
	          centerPaddingStyle = {
	            padding: _this.props.centerPadding + " 0px"
	          };
	        }
	      }
	
	      var listStyle = _objectSpread({}, verticalHeightStyle, {}, centerPaddingStyle);
	
	      var touchMove = _this.props.touchMove;
	      var listProps = {
	        className: "slick-list",
	        style: listStyle,
	        onClick: _this.clickHandler,
	        onMouseDown: touchMove ? _this.swipeStart : null,
	        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onMouseUp: touchMove ? _this.swipeEnd : null,
	        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onTouchStart: touchMove ? _this.swipeStart : null,
	        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
	        onTouchEnd: touchMove ? _this.swipeEnd : null,
	        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
	        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
	      };
	      var innerSliderProps = {
	        className: className,
	        dir: "ltr",
	        style: _this.props.style
	      };
	
	      if (_this.props.unslick) {
	        listProps = {
	          className: "slick-list"
	        };
	        innerSliderProps = {
	          className: className
	        };
	      }
	
	      return _react["default"].createElement("div", innerSliderProps, !_this.props.unslick ? prevArrow : "", _react["default"].createElement("div", _extends({
	        ref: _this.listRefHandler
	      }, listProps), _react["default"].createElement(_track.Track, _extends({
	        ref: _this.trackRefHandler
	      }, trackProps), _this.props.children)), !_this.props.unslick ? nextArrow : "", !_this.props.unslick ? dots : "");
	    });
	
	    _this.list = null;
	    _this.track = null;
	    _this.state = _objectSpread({}, _initialState["default"], {
	      currentSlide: _this.props.initialSlide,
	      slideCount: _react["default"].Children.count(_this.props.children)
	    });
	    _this.callbackTimers = [];
	    _this.clickable = true;
	    _this.debouncedResize = null;
	    return _this;
	  }
	
	  return InnerSlider;
	}(_react["default"].Component);
	
	exports.InnerSlider = InnerSlider;

/***/ },
/* 2885 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _innerSlider = __webpack_require__(2884);
	
	var _json2mq = _interopRequireDefault(__webpack_require__(2491));
	
	var _defaultProps = _interopRequireDefault(__webpack_require__(2880));
	
	var _innerSliderUtils = __webpack_require__(390);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(880);
	
	var Slider =
	/*#__PURE__*/
	function (_React$Component) {
	  _inherits(Slider, _React$Component);
	
	  function Slider(props) {
	    var _this;
	
	    _classCallCheck(this, Slider);
	
	    _this = _possibleConstructorReturn(this, _getPrototypeOf(Slider).call(this, props));
	
	    _defineProperty(_assertThisInitialized(_this), "innerSliderRefHandler", function (ref) {
	      return _this.innerSlider = ref;
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPrev", function () {
	      return _this.innerSlider.slickPrev();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickNext", function () {
	      return _this.innerSlider.slickNext();
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickGoTo", function (slide) {
	      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	      return _this.innerSlider.slickGoTo(slide, dontAnimate);
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPause", function () {
	      return _this.innerSlider.pause("paused");
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "slickPlay", function () {
	      return _this.innerSlider.autoPlay("play");
	    });
	
	    _this.state = {
	      breakpoint: null
	    };
	    _this._responsiveMediaHandlers = [];
	    return _this;
	  }
	
	  _createClass(Slider, [{
	    key: "media",
	    value: function media(query, handler) {
	      // javascript handler for  css media query
	      enquire.register(query, handler);
	
	      this._responsiveMediaHandlers.push({
	        query: query,
	        handler: handler
	      });
	    } // handles responsive breakpoints
	
	  }, {
	    key: "UNSAFE_componentWillMount",
	    value: function UNSAFE_componentWillMount() {
	      var _this2 = this;
	
	      // performance monitoring
	      //if (process.env.NODE_ENV !== 'production') {
	      //const { whyDidYouUpdate } = require('why-did-you-update')
	      //whyDidYouUpdate(React)
	      //}
	      if (this.props.responsive) {
	        var breakpoints = this.props.responsive.map(function (breakpt) {
	          return breakpt.breakpoint;
	        }); // sort them in increasing order of their numerical value
	
	        breakpoints.sort(function (x, y) {
	          return x - y;
	        });
	        breakpoints.forEach(function (breakpoint, index) {
	          // media query for each breakpoint
	          var bQuery;
	
	          if (index === 0) {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: 0,
	              maxWidth: breakpoint
	            });
	          } else {
	            bQuery = (0, _json2mq["default"])({
	              minWidth: breakpoints[index - 1] + 1,
	              maxWidth: breakpoint
	            });
	          } // when not using server side rendering
	
	
	          (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
	            _this2.setState({
	              breakpoint: breakpoint
	            });
	          });
	        }); // Register media query for full screen. Need to support resize from small to large
	        // convert javascript object to media query string
	
	        var query = (0, _json2mq["default"])({
	          minWidth: breakpoints.slice(-1)[0]
	        });
	        (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
	          _this2.setState({
	            breakpoint: null
	          });
	        });
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this._responsiveMediaHandlers.forEach(function (obj) {
	        enquire.unregister(obj.query, obj.handler);
	      });
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this3 = this;
	
	      var settings;
	      var newProps;
	
	      if (this.state.breakpoint) {
	        newProps = this.props.responsive.filter(function (resp) {
	          return resp.breakpoint === _this3.state.breakpoint;
	        });
	        settings = newProps[0].settings === "unslick" ? "unslick" : _objectSpread({}, _defaultProps["default"], {}, this.props, {}, newProps[0].settings);
	      } else {
	        settings = _objectSpread({}, _defaultProps["default"], {}, this.props);
	      } // force scrolling by one if centerMode is on
	
	
	      if (settings.centerMode) {
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 in centerMode, you are using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToScroll = 1;
	      } // force showing one slide and scrolling by one if the fade mode is on
	
	
	      if (settings.fade) {
	        if (settings.slidesToShow > 1 && ("production") !== "production") {
	          console.warn("slidesToShow should be equal to 1 when fade is true, you're using ".concat(settings.slidesToShow));
	        }
	
	        if (settings.slidesToScroll > 1 && ("production") !== "production") {
	          console.warn("slidesToScroll should be equal to 1 when fade is true, you're using ".concat(settings.slidesToScroll));
	        }
	
	        settings.slidesToShow = 1;
	        settings.slidesToScroll = 1;
	      } // makes sure that children is an array, even when there is only 1 child
	
	
	      var children = _react["default"].Children.toArray(this.props.children); // Children may contain false or null, so we should filter them
	      // children may also contain string filled with spaces (in certain cases where we use jsx strings)
	
	
	      children = children.filter(function (child) {
	        if (typeof child === "string") {
	          return !!child.trim();
	        }
	
	        return !!child;
	      }); // rows and slidesPerRow logic is handled here
	
	      if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
	        console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
	        settings.variableWidth = false;
	      }
	
	      var newChildren = [];
	      var currentWidth = null;
	
	      for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
	        var newSlide = [];
	
	        for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
	          var row = [];
	
	          for (var k = j; k < j + settings.slidesPerRow; k += 1) {
	            if (settings.variableWidth && children[k].props.style) {
	              currentWidth = children[k].props.style.width;
	            }
	
	            if (k >= children.length) break;
	            row.push(_react["default"].cloneElement(children[k], {
	              key: 100 * i + 10 * j + k,
	              tabIndex: -1,
	              style: {
	                width: "".concat(100 / settings.slidesPerRow, "%"),
	                display: "inline-block"
	              }
	            }));
	          }
	
	          newSlide.push(_react["default"].createElement("div", {
	            key: 10 * i + j
	          }, row));
	        }
	
	        if (settings.variableWidth) {
	          newChildren.push(_react["default"].createElement("div", {
	            key: i,
	            style: {
	              width: currentWidth
	            }
	          }, newSlide));
	        } else {
	          newChildren.push(_react["default"].createElement("div", {
	            key: i
	          }, newSlide));
	        }
	      }
	
	      if (settings === "unslick") {
	        var className = "regular slider " + (this.props.className || "");
	        return _react["default"].createElement("div", {
	          className: className
	        }, newChildren);
	      } else if (newChildren.length <= settings.slidesToShow) {
	        settings.unslick = true;
	      }
	
	      return _react["default"].createElement(_innerSlider.InnerSlider, _extends({
	        style: this.props.style,
	        ref: this.innerSliderRefHandler
	      }, settings), newChildren);
	    }
	  }]);
	
	  return Slider;
	}(_react["default"].Component);
	
	exports["default"] = Slider;

/***/ },
/* 2886 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Track = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(1));
	
	var _classnames = _interopRequireDefault(__webpack_require__(20));
	
	var _innerSliderUtils = __webpack_require__(390);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
	var getSlideClasses = function getSlideClasses(spec) {
	  var slickActive, slickCenter, slickCloned;
	  var centerOffset, index;
	
	  if (spec.rtl) {
	    index = spec.slideCount - 1 - spec.index;
	  } else {
	    index = spec.index;
	  }
	
	  slickCloned = index < 0 || index >= spec.slideCount;
	
	  if (spec.centerMode) {
	    centerOffset = Math.floor(spec.slidesToShow / 2);
	    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
	
	    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
	      slickActive = true;
	    }
	  } else {
	    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
	  }
	
	  var slickCurrent = index === spec.currentSlide;
	  return {
	    "slick-slide": true,
	    "slick-active": slickActive,
	    "slick-center": slickCenter,
	    "slick-cloned": slickCloned,
	    "slick-current": slickCurrent // dubious in case of RTL
	
	  };
	};
	
	var getSlideStyle = function getSlideStyle(spec) {
	  var style = {};
	
	  if (spec.variableWidth === undefined || spec.variableWidth === false) {
	    style.width = spec.slideWidth;
	  }
	
	  if (spec.fade) {
	    style.position = "relative";
	
	    if (spec.vertical) {
	      style.top = -spec.index * parseInt(spec.slideHeight);
	    } else {
	      style.left = -spec.index * parseInt(spec.slideWidth);
	    }
	
	    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
	    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
	  }
	
	  return style;
	};
	
	var getKey = function getKey(child, fallbackKey) {
	  return child.key || fallbackKey;
	};
	
	var renderSlides = function renderSlides(spec) {
	  var key;
	  var slides = [];
	  var preCloneSlides = [];
	  var postCloneSlides = [];
	
	  var childrenCount = _react["default"].Children.count(spec.children);
	
	  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
	  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);
	
	  _react["default"].Children.forEach(spec.children, function (elem, index) {
	    var child;
	    var childOnClickOptions = {
	      message: "children",
	      index: index,
	      slidesToScroll: spec.slidesToScroll,
	      currentSlide: spec.currentSlide
	    }; // in case of lazyLoad, whether or not we want to fetch the slide
	
	    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
	      child = elem;
	    } else {
	      child = _react["default"].createElement("div", null);
	    }
	
	    var childStyle = getSlideStyle(_objectSpread({}, spec, {
	      index: index
	    }));
	    var slideClass = child.props.className || "";
	    var slideClasses = getSlideClasses(_objectSpread({}, spec, {
	      index: index
	    })); // push a cloned element of the desired slide
	
	    slides.push(_react["default"].cloneElement(child, {
	      key: "original" + getKey(child, index),
	      "data-index": index,
	      className: (0, _classnames["default"])(slideClasses, slideClass),
	      tabIndex: "-1",
	      "aria-hidden": !slideClasses["slick-active"],
	      style: _objectSpread({
	        outline: "none"
	      }, child.props.style || {}, {}, childStyle),
	      onClick: function onClick(e) {
	        child.props && child.props.onClick && child.props.onClick(e);
	
	        if (spec.focusOnSelect) {
	          spec.focusOnSelect(childOnClickOptions);
	        }
	      }
	    })); // if slide needs to be precloned or postcloned
	
	    if (spec.infinite && spec.fade === false) {
	      var preCloneNo = childrenCount - index;
	
	      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
	        key = -preCloneNo;
	
	        if (key >= startIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        preCloneSlides.push(_react["default"].cloneElement(child, {
	          key: "precloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	
	      if (childrenCount !== spec.slidesToShow) {
	        key = childrenCount + index;
	
	        if (key < endIndex) {
	          child = elem;
	        }
	
	        slideClasses = getSlideClasses(_objectSpread({}, spec, {
	          index: key
	        }));
	        postCloneSlides.push(_react["default"].cloneElement(child, {
	          key: "postcloned" + getKey(child, key),
	          "data-index": key,
	          tabIndex: "-1",
	          className: (0, _classnames["default"])(slideClasses, slideClass),
	          "aria-hidden": !slideClasses["slick-active"],
	          style: _objectSpread({}, child.props.style || {}, {}, childStyle),
	          onClick: function onClick(e) {
	            child.props && child.props.onClick && child.props.onClick(e);
	
	            if (spec.focusOnSelect) {
	              spec.focusOnSelect(childOnClickOptions);
	            }
	          }
	        }));
	      }
	    }
	  });
	
	  if (spec.rtl) {
	    return preCloneSlides.concat(slides, postCloneSlides).reverse();
	  } else {
	    return preCloneSlides.concat(slides, postCloneSlides);
	  }
	};
	
	var Track =
	/*#__PURE__*/
	function (_React$PureComponent) {
	  _inherits(Track, _React$PureComponent);
	
	  function Track() {
	    _classCallCheck(this, Track);
	
	    return _possibleConstructorReturn(this, _getPrototypeOf(Track).apply(this, arguments));
	  }
	
	  _createClass(Track, [{
	    key: "render",
	    value: function render() {
	      var slides = renderSlides(this.props);
	      var _this$props = this.props,
	          onMouseEnter = _this$props.onMouseEnter,
	          onMouseOver = _this$props.onMouseOver,
	          onMouseLeave = _this$props.onMouseLeave;
	      var mouseEvents = {
	        onMouseEnter: onMouseEnter,
	        onMouseOver: onMouseOver,
	        onMouseLeave: onMouseLeave
	      };
	      return _react["default"].createElement("div", _extends({
	        className: "slick-track",
	        style: this.props.trackStyle
	      }, mouseEvents), slides);
	    }
	  }]);
	
	  return Track;
	}(_react["default"].PureComponent);
	
	exports.Track = Track;

/***/ },
/* 2887 */
575,
/* 2888 */
[3064, 311],
/* 2889 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(2888);
	var ReactElement = __webpack_require__(264);
	
	var emptyFunction = __webpack_require__(101);
	var traverseAllChildren = __webpack_require__(2898);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 2890 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(264);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 2891 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(264),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(1066);
	
	module.exports = factory(isValidElement);

/***/ },
/* 2892 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.7.0';


/***/ },
/* 2893 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(1164),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(264),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(1167);
	var factory = __webpack_require__(793);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 2894 */
2839,
/* 2895 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 2896 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 2897 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(311);
	
	var ReactElement = __webpack_require__(264);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 2898 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(311);
	
	var ReactCurrentOwner = __webpack_require__(164);
	var REACT_ELEMENT_TYPE = __webpack_require__(1166);
	
	var getIteratorFn = __webpack_require__(2894);
	var invariant = __webpack_require__(18);
	var KeyEscapeUtils = __webpack_require__(2887);
	var warning = __webpack_require__(49);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 2899 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactDock = _interopRequireDefault(__webpack_require__(2904));
	
	var _constants = __webpack_require__(1170);
	
	var _actions = __webpack_require__(1169);
	
	var _reducers = _interopRequireDefault(__webpack_require__(2901));
	
	var _parseKey = _interopRequireDefault(__webpack_require__(2617));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var DockMonitor = /*#__PURE__*/function (_Component) {
	  _inherits(DockMonitor, _Component);
	
	  var _super = _createSuper(DockMonitor);
	
	  function DockMonitor(props) {
	    var _this;
	
	    _classCallCheck(this, DockMonitor);
	
	    _this = _super.call(this, props);
	
	    _defineProperty(_assertThisInitialized(_this), "handleKeyDown", function (e) {
	      // Ignore regular keys when focused on a field
	      // and no modifiers are active.
	      if (!e.ctrlKey && !e.metaKey && !e.altKey && (e.target.tagName === 'INPUT' || e.target.tagName === 'SELECT' || e.target.tagName === 'TEXTAREA' || e.target.isContentEditable)) {
	        return;
	      }
	
	      var visibilityKey = (0, _parseKey["default"])(_this.props.toggleVisibilityKey);
	      var positionKey = (0, _parseKey["default"])(_this.props.changePositionKey);
	      var monitorKey;
	
	      if (_this.props.changeMonitorKey) {
	        monitorKey = (0, _parseKey["default"])(_this.props.changeMonitorKey);
	      }
	
	      if (_this.matchesKey(visibilityKey, e)) {
	        e.preventDefault();
	
	        _this.props.dispatch((0, _actions.toggleVisibility)());
	      } else if (_this.matchesKey(positionKey, e)) {
	        e.preventDefault();
	
	        _this.props.dispatch((0, _actions.changePosition)());
	      } else if (_this.matchesKey(monitorKey, e)) {
	        e.preventDefault();
	
	        _this.props.dispatch((0, _actions.changeMonitor)());
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleSizeChange", function (requestedSize) {
	      _this.props.dispatch((0, _actions.changeSize)(requestedSize));
	    });
	
	    var childrenCount = _react.Children.count(props.children);
	
	    if (childrenCount === 0) {
	      // eslint-disable-next-line no-console
	      console.error('<DockMonitor> requires at least one monitor inside. ' + 'Why don’t you try <LogMonitor>? You can get it at ' + 'https://github.com/gaearon/redux-devtools-log-monitor.');
	    } else if (childrenCount > 1 && !props.changeMonitorKey) {
	      // eslint-disable-next-line no-console
	      console.error('You specified multiple monitors inside <DockMonitor> ' + 'but did not provide `changeMonitorKey` prop to change them. ' + 'Try specifying <DockMonitor changeMonitorKey="ctrl-m" /> ' + 'and then press Ctrl-M.');
	    }
	
	    return _this;
	  }
	
	  _createClass(DockMonitor, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      window.addEventListener('keydown', this.handleKeyDown);
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener('keydown', this.handleKeyDown);
	    }
	  }, {
	    key: "matchesKey",
	    value: function matchesKey(key, event) {
	      if (!key) {
	        return false;
	      }
	
	      var charCode = event.keyCode || event.which;
	
	      var _char = String.fromCharCode(charCode);
	
	      return key.name.toUpperCase() === _char.toUpperCase() && key.alt === event.altKey && key.ctrl === event.ctrlKey && key.meta === event.metaKey && key.shift === event.shiftKey;
	    }
	  }, {
	    key: "renderChild",
	    value: function renderChild(child, index, otherProps) {
	      var monitorState = this.props.monitorState;
	      var childMonitorIndex = monitorState.childMonitorIndex,
	          childMonitorStates = monitorState.childMonitorStates;
	
	      if (index !== childMonitorIndex) {
	        return null;
	      }
	
	      return /*#__PURE__*/(0, _react.cloneElement)(child, _objectSpread({
	        monitorState: childMonitorStates[index]
	      }, otherProps));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _this$props = this.props,
	          monitorState = _this$props.monitorState,
	          children = _this$props.children,
	          fluid = _this$props.fluid,
	          rest = _objectWithoutProperties(_this$props, ["monitorState", "children", "fluid"]);
	
	      var position = monitorState.position,
	          isVisible = monitorState.isVisible,
	          size = monitorState.size;
	      return /*#__PURE__*/_react["default"].createElement(_reactDock["default"], {
	        position: position,
	        isVisible: isVisible,
	        size: size,
	        fluid: fluid,
	        onSizeChange: this.handleSizeChange,
	        dimMode: "none"
	      }, _react.Children.map(children, function (child, index) {
	        return _this2.renderChild(child, index, rest);
	      }));
	    }
	  }]);
	
	  return DockMonitor;
	}(_react.Component);
	
	_defineProperty(DockMonitor, "update", _reducers["default"]);
	
	_defineProperty(DockMonitor, "propTypes", {
	  defaultPosition: _propTypes["default"].oneOf(_constants.POSITIONS),
	  defaultIsVisible: _propTypes["default"].bool.isRequired,
	  defaultSize: _propTypes["default"].number.isRequired,
	  toggleVisibilityKey: _propTypes["default"].string.isRequired,
	  changePositionKey: _propTypes["default"].string.isRequired,
	  changeMonitorKey: _propTypes["default"].string,
	  fluid: _propTypes["default"].bool,
	  dispatch: _propTypes["default"].func,
	  monitorState: _propTypes["default"].shape({
	    position: _propTypes["default"].oneOf(_constants.POSITIONS).isRequired,
	    size: _propTypes["default"].number.isRequired,
	    isVisible: _propTypes["default"].bool.isRequired,
	    childMonitorState: _propTypes["default"].any
	  })
	});
	
	_defineProperty(DockMonitor, "defaultProps", {
	  defaultIsVisible: true,
	  defaultPosition: 'right',
	  defaultSize: 0.3,
	  fluid: true
	});
	
	var _default = DockMonitor;
	exports["default"] = _default;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 2900 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _DockMonitor = _interopRequireDefault(__webpack_require__(2899));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var _default = _DockMonitor["default"];
	exports["default"] = _default;
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6WyJEb2NrTW9uaXRvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7O2VBQ2VBLHVCIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IERvY2tNb25pdG9yIGZyb20gJy4vRG9ja01vbml0b3InO1xuZXhwb3J0IGRlZmF1bHQgRG9ja01vbml0b3I7XG4iXX0=

/***/ },
/* 2901 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = reducer;
	
	var _react = __webpack_require__(1);
	
	var _actions = __webpack_require__(1169);
	
	var _constants = __webpack_require__(1170);
	
	function position(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultPosition;
	  var action = arguments.length > 2 ? arguments[2] : undefined;
	  return action.type === _actions.CHANGE_POSITION ? _constants.POSITIONS[(_constants.POSITIONS.indexOf(state) + 1) % _constants.POSITIONS.length] : state;
	}
	
	function size(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultSize;
	  var action = arguments.length > 2 ? arguments[2] : undefined;
	  return action.type === _actions.CHANGE_SIZE ? action.size : state;
	}
	
	function isVisible(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : props.defaultIsVisible;
	  var action = arguments.length > 2 ? arguments[2] : undefined;
	  return action.type === _actions.TOGGLE_VISIBILITY ? !state : state;
	}
	
	function childMonitorStates(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	  var action = arguments.length > 2 ? arguments[2] : undefined;
	  return _react.Children.map(props.children, function (child, index) {
	    return child.type.update(child.props, state[index], action);
	  });
	}
	
	function childMonitorIndex(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var action = arguments.length > 2 ? arguments[2] : undefined;
	
	  switch (action.type) {
	    case _actions.CHANGE_MONITOR:
	      return (state + 1) % _react.Children.count(props.children);
	
	    default:
	      return state;
	  }
	}
	
	function reducer(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var action = arguments.length > 2 ? arguments[2] : undefined;
	
	  if (!state.childMonitorStates) {
	    _react.Children.forEach(props.children, function (child, index) {
	      if (typeof child.type.update !== 'function') {
	        // eslint-disable-next-line no-console
	        console.error("Child of <DockMonitor> with the index ".concat(index, " ") + "(".concat(child.type.displayName || child.type.name || child.type, ") ") + 'does not appear to be a valid Redux DevTools monitor.');
	      }
	    });
	  }
	
	  return {
	    position: position(props, state.position, action),
	    isVisible: isVisible(props, state.isVisible, action),
	    size: size(props, state.size, action),
	    childMonitorIndex: childMonitorIndex(props, state.childMonitorIndex, action),
	    childMonitorStates: childMonitorStates(props, state.childMonitorStates, action)
	  };
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 2902 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _lodash = _interopRequireDefault(__webpack_require__(369));
	
	var _autoprefix = _interopRequireDefault(__webpack_require__(2903));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	(function () {
	  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
	  enterModule && enterModule(module);
	})();
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
	
	function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
	
	function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
	
	function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }
	
	function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
	
	function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
	
	var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
	  return a;
	};
	
	function autoprefixes(styles) {
	  return Object.keys(styles).reduce(function (obj, key) {
	    return obj[key] = (0, _autoprefix["default"])(styles[key]), obj;
	  }, {});
	}
	
	var styles = autoprefixes({
	  wrapper: {
	    position: 'fixed',
	    width: 0,
	    height: 0,
	    top: 0,
	    left: 0
	  },
	  dim: {
	    position: 'fixed',
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0,
	    zIndex: 0,
	    background: 'rgba(0, 0, 0, 0.2)',
	    opacity: 1
	  },
	  dimAppear: {
	    opacity: 0
	  },
	  dimTransparent: {
	    pointerEvents: 'none'
	  },
	  dimHidden: {
	    opacity: 0
	  },
	  dock: {
	    position: 'fixed',
	    zIndex: 1,
	    boxShadow: '0 0 4px rgba(0, 0, 0, 0.3)',
	    background: 'white',
	    left: 0,
	    top: 0,
	    width: '100%',
	    height: '100%'
	  },
	  dockHidden: {
	    opacity: 0
	  },
	  dockResizing: {
	    transition: 'none'
	  },
	  dockContent: {
	    width: '100%',
	    height: '100%',
	    overflow: 'auto'
	  },
	  resizer: {
	    position: 'absolute',
	    zIndex: 2,
	    opacity: 0
	  }
	});
	
	function getTransitions(duration) {
	  return ['left', 'top', 'width', 'height'].map(function (p) {
	    return "".concat(p, " ").concat(duration / 1000, "s ease-out");
	  });
	}
	
	function getDockStyles(_ref, _ref2) {
	  var fluid = _ref.fluid,
	      dockStyle = _ref.dockStyle,
	      dockHiddenStyle = _ref.dockHiddenStyle,
	      duration = _ref.duration,
	      position = _ref.position,
	      isVisible = _ref.isVisible;
	  var size = _ref2.size,
	      isResizing = _ref2.isResizing,
	      fullWidth = _ref2.fullWidth,
	      fullHeight = _ref2.fullHeight;
	  var posStyle;
	  var absSize = fluid ? "".concat(size * 100, "%") : "".concat(size, "px");
	
	  function getRestSize(fullSize) {
	    return fluid ? "".concat(100 - size * 100, "%") : "".concat(fullSize - size, "px");
	  }
	
	  switch (position) {
	    case 'left':
	      posStyle = {
	        width: absSize,
	        left: isVisible ? 0 : '-' + absSize
	      };
	      break;
	
	    case 'right':
	      posStyle = {
	        left: isVisible ? getRestSize(fullWidth) : fullWidth,
	        width: absSize
	      };
	      break;
	
	    case 'top':
	      posStyle = {
	        top: isVisible ? 0 : '-' + absSize,
	        height: absSize
	      };
	      break;
	
	    case 'bottom':
	      posStyle = {
	        top: isVisible ? getRestSize(fullHeight) : fullHeight,
	        height: absSize
	      };
	      break;
	  }
	
	  var transitions = getTransitions(duration);
	  return [styles.dock, (0, _autoprefix["default"])({
	    transition: [].concat(_toConsumableArray(transitions), [!isVisible && "opacity 0.01s linear ".concat(duration / 1000, "s")]).filter(function (t) {
	      return t;
	    }).join(',')
	  }), dockStyle, (0, _autoprefix["default"])(posStyle), isResizing && styles.dockResizing, !isVisible && styles.dockHidden, !isVisible && dockHiddenStyle];
	}
	
	function getDimStyles(_ref3, _ref4) {
	  var dimMode = _ref3.dimMode,
	      dimStyle = _ref3.dimStyle,
	      duration = _ref3.duration,
	      isVisible = _ref3.isVisible;
	  var isTransitionStarted = _ref4.isTransitionStarted;
	  return [styles.dim, (0, _autoprefix["default"])({
	    transition: "opacity ".concat(duration / 1000, "s ease-out")
	  }), dimStyle, dimMode === 'transparent' && styles.dimTransparent, !isVisible && styles.dimHidden, isTransitionStarted && isVisible && styles.dimAppear, isTransitionStarted && !isVisible && styles.dimDisappear];
	}
	
	function getResizerStyles(position) {
	  var resizerStyle;
	  var size = 10;
	
	  switch (position) {
	    case 'left':
	      resizerStyle = {
	        right: -size / 2,
	        width: size,
	        top: 0,
	        height: '100%',
	        cursor: 'col-resize'
	      };
	      break;
	
	    case 'right':
	      resizerStyle = {
	        left: -size / 2,
	        width: size,
	        top: 0,
	        height: '100%',
	        cursor: 'col-resize'
	      };
	      break;
	
	    case 'top':
	      resizerStyle = {
	        bottom: -size / 2,
	        height: size,
	        left: 0,
	        width: '100%',
	        cursor: 'row-resize'
	      };
	      break;
	
	    case 'bottom':
	      resizerStyle = {
	        top: -size / 2,
	        height: size,
	        left: 0,
	        width: '100%',
	        cursor: 'row-resize'
	      };
	      break;
	  }
	
	  return [styles.resizer, (0, _autoprefix["default"])(resizerStyle)];
	}
	
	function getFullSize(position, fullWidth, fullHeight) {
	  return position === 'left' || position === 'right' ? fullWidth : fullHeight;
	}
	
	var Dock = /*#__PURE__*/function (_Component) {
	  _inherits(Dock, _Component);
	
	  var _super = _createSuper(Dock);
	
	  function Dock() {
	    var _this;
	
	    _classCallCheck(this, Dock);
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _super.call.apply(_super, [this].concat(args));
	
	    _defineProperty(_assertThisInitialized(_this), "state", {
	      isControlled: typeof _this.props.size !== 'undefined',
	      size: _this.props.size || _this.props.defaultSize,
	      isDimHidden: !_this.props.isVisible,
	      fullWidth: window.innerWidth,
	      fullHeight: window.innerHeight,
	      isTransitionStarted: false,
	      isWindowResizing: false
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "transitionEnd", function () {
	      _this.setState({
	        isTransitionStarted: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "hideDim", function () {
	      if (!_this.props.isVisible) {
	        _this.setState({
	          isDimHidden: true
	        });
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleDimClick", function () {
	      if (_this.props.dimMode === 'opaque') {
	        _this.props.onVisibleChange && _this.props.onVisibleChange(false);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleResize", function () {
	      if (window.requestAnimationFrame) {
	        window.requestAnimationFrame(_this.updateWindowSize.bind(_assertThisInitialized(_this), true));
	      } else {
	        _this.updateWindowSize(true);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateWindowSize", function (windowResize) {
	      var sizeState = {
	        fullWidth: window.innerWidth,
	        fullHeight: window.innerHeight
	      };
	
	      if (windowResize) {
	        _this.setState(_objectSpread(_objectSpread({}, sizeState), {}, {
	          isResizing: true,
	          isWindowResizing: windowResize
	        }));
	
	        _this.debouncedUpdateWindowSizeEnd();
	      } else {
	        _this.setState(sizeState);
	      }
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "updateWindowSizeEnd", function () {
	      _this.setState({
	        isResizing: false,
	        isWindowResizing: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "debouncedUpdateWindowSizeEnd", (0, _lodash["default"])(_this.updateWindowSizeEnd, 30));
	
	    _defineProperty(_assertThisInitialized(_this), "handleWrapperLeave", function () {
	      _this.setState({
	        isResizing: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleMouseDown", function () {
	      _this.setState({
	        isResizing: true
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleMouseUp", function () {
	      _this.setState({
	        isResizing: false
	      });
	    });
	
	    _defineProperty(_assertThisInitialized(_this), "handleMouseMove", function (e) {
	      if (!_this.state.isResizing || _this.state.isWindowResizing) return;
	      if (!e.touches) e.preventDefault();
	      var _this$props = _this.props,
	          position = _this$props.position,
	          fluid = _this$props.fluid;
	      var _this$state = _this.state,
	          fullWidth = _this$state.fullWidth,
	          fullHeight = _this$state.fullHeight,
	          isControlled = _this$state.isControlled;
	      var _ref5 = e,
	          x = _ref5.clientX,
	          y = _ref5.clientY;
	
	      if (e.touches) {
	        x = e.touches[0].clientX;
	        y = e.touches[0].clientY;
	      }
	
	      var size;
	
	      switch (position) {
	        case 'left':
	          size = fluid ? x / fullWidth : x;
	          break;
	
	        case 'right':
	          size = fluid ? (fullWidth - x) / fullWidth : fullWidth - x;
	          break;
	
	        case 'top':
	          size = fluid ? y / fullHeight : y;
	          break;
	
	        case 'bottom':
	          size = fluid ? (fullHeight - y) / fullHeight : fullHeight - y;
	          break;
	      }
	
	      _this.props.onSizeChange && _this.props.onSizeChange(size);
	
	      if (!isControlled) {
	        _this.setState({
	          size: size
	        });
	      }
	    });
	
	    return _this;
	  }
	
	  _createClass(Dock, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      window.addEventListener('touchend', this.handleMouseUp);
	      window.addEventListener('mouseup', this.handleMouseUp);
	      window.addEventListener('touchmove', this.handleMouseMove);
	      window.addEventListener('mousemove', this.handleMouseMove);
	      window.addEventListener('resize', this.handleResize);
	      this.updateWindowSize();
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      window.removeEventListener('touchend', this.handleMouseUp);
	      window.removeEventListener('mouseup', this.handleMouseUp);
	      window.removeEventListener('touchmove', this.handleMouseMove);
	      window.removeEventListener('mousemove', this.handleMouseMove);
	      window.removeEventListener('resize', this.handleResize);
	    }
	  }, {
	    key: "UNSAFE_componentWillReceiveProps",
	    value: function UNSAFE_componentWillReceiveProps(nextProps) {
	      var isControlled = typeof nextProps.size !== 'undefined';
	      this.setState({
	        isControlled: isControlled
	      });
	
	      if (isControlled && nextProps.size && this.props.size !== nextProps.size) {
	        this.setState({
	          size: nextProps.size
	        });
	      } else if (this.props.fluid !== nextProps.fluid) {
	        this.updateSize(nextProps);
	      }
	
	      if (this.props.isVisible !== nextProps.isVisible) {
	        this.setState({
	          isTransitionStarted: true
	        });
	      }
	    }
	  }, {
	    key: "updateSize",
	    value: function updateSize(props) {
	      var _this$state2 = this.state,
	          fullWidth = _this$state2.fullWidth,
	          fullHeight = _this$state2.fullHeight;
	      this.setState({
	        size: props.fluid ? this.state.size / getFullSize(props.position, fullWidth, fullHeight) : getFullSize(props.position, fullWidth, fullHeight) * this.state.size
	      });
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var _this2 = this;
	
	      if (this.props.isVisible !== prevProps.isVisible) {
	        if (!this.props.isVisible) {
	          window.setTimeout(function () {
	            return _this2.hideDim();
	          }, this.props.duration);
	        } else {
	          this.setState({
	            isDimHidden: false
	          });
	        }
	
	        window.setTimeout(function () {
	          return _this2.setState({
	            isTransitionStarted: false
	          });
	        }, 0);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this$props2 = this.props,
	          children = _this$props2.children,
	          zIndex = _this$props2.zIndex,
	          dimMode = _this$props2.dimMode,
	          position = _this$props2.position,
	          isVisible = _this$props2.isVisible;
	      var _this$state3 = this.state,
	          isResizing = _this$state3.isResizing,
	          size = _this$state3.size,
	          isDimHidden = _this$state3.isDimHidden;
	      var dimStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getDimStyles(this.props, this.state))));
	      var dockStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getDockStyles(this.props, this.state))));
	      var resizerStyles = Object.assign.apply(Object, [{}].concat(_toConsumableArray(getResizerStyles(position))));
	      return /*#__PURE__*/_react["default"].createElement("div", {
	        style: Object.assign({}, styles.wrapper, {
	          zIndex: zIndex
	        })
	      }, dimMode !== 'none' && !isDimHidden && /*#__PURE__*/_react["default"].createElement("div", {
	        style: dimStyles,
	        onClick: this.handleDimClick
	      }), /*#__PURE__*/_react["default"].createElement("div", {
	        style: dockStyles
	      }, /*#__PURE__*/_react["default"].createElement("div", {
	        style: resizerStyles,
	        onMouseDown: this.handleMouseDown,
	        onTouchStart: this.handleMouseDown
	      }), /*#__PURE__*/_react["default"].createElement("div", {
	        style: styles.dockContent
	      }, typeof children === 'function' ? children({
	        position: position,
	        isResizing: isResizing,
	        size: size,
	        isVisible: isVisible
	      }) : children)));
	    }
	  }, {
	    key: "__reactstandin__regenerateByEval",
	    // @ts-ignore
	    value: function __reactstandin__regenerateByEval(key, code) {
	      // @ts-ignore
	      this[key] = eval(code);
	    }
	  }]);
	
	  return Dock;
	}(_react.Component);
	
	exports["default"] = Dock;
	
	_defineProperty(Dock, "propTypes", {
	  position: _propTypes["default"].oneOf(['left', 'right', 'top', 'bottom']),
	  zIndex: _propTypes["default"].number,
	  fluid: _propTypes["default"].bool,
	  size: _propTypes["default"].number,
	  defaultSize: _propTypes["default"].number,
	  dimMode: _propTypes["default"].oneOf(['none', 'transparent', 'opaque']),
	  isVisible: _propTypes["default"].bool,
	  onVisibleChange: _propTypes["default"].func,
	  onSizeChange: _propTypes["default"].func,
	  dimStyle: _propTypes["default"].object,
	  dockStyle: _propTypes["default"].object,
	  duration: _propTypes["default"].number
	});
	
	_defineProperty(Dock, "defaultProps", {
	  position: 'left',
	  zIndex: 99999999,
	  fluid: true,
	  defaultSize: 0.3,
	  dimMode: 'opaque',
	  duration: 200
	});
	
	;
	
	(function () {
	  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
	
	  if (!reactHotLoader) {
	    return;
	  }
	
	  reactHotLoader.register(autoprefixes, "autoprefixes", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\Dock.tsx");
	  reactHotLoader.register(styles, "styles", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\Dock.tsx");
	  reactHotLoader.register(getTransitions, "getTransitions", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\Dock.tsx");
	  reactHotLoader.register(getDockStyles, "getDockStyles", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\Dock.tsx");
	  reactHotLoader.register(getDimStyles, "getDimStyles", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\Dock.tsx");
	  reactHotLoader.register(getResizerStyles, "getResizerStyles", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\Dock.tsx");
	  reactHotLoader.register(getFullSize, "getFullSize", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\Dock.tsx");
	  reactHotLoader.register(Dock, "Dock", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\Dock.tsx");
	})();
	
	;
	
	(function () {
	  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
	  leaveModule && leaveModule(module);
	})();
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)(module)))

/***/ },
/* 2903 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = autoprefix;
	
	(function () {
	  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
	  enterModule && enterModule(module);
	})();
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
	  return a;
	};
	
	var vendorSpecificProperties = ['animation', 'animationDelay', 'animationDirection', 'animationDuration', 'animationFillMode', 'animationIterationCount', 'animationName', 'animationPlayState', 'animationTimingFunction', 'appearance', 'backfaceVisibility', 'backgroundClip', 'borderImage', 'borderImageSlice', 'boxSizing', 'boxShadow', 'contentColumns', 'transform', 'transformOrigin', 'transformStyle', 'transition', 'transitionDelay', 'transitionDuration', 'transitionProperty', 'transitionTimingFunction', 'perspective', 'perspectiveOrigin', 'userSelect'];
	var prefixes = ['Moz', 'Webkit', 'ms', 'O'];
	
	function prefixProp(key, value) {
	  return prefixes.reduce(function (obj, pre) {
	    return obj[pre + key[0].toUpperCase() + key.substr(1)] = value, obj;
	  }, {});
	}
	
	function autoprefix(style) {
	  return Object.keys(style).reduce(function (obj, key) {
	    return vendorSpecificProperties.indexOf(key) !== -1 ? _objectSpread(_objectSpread({}, obj), prefixProp(key, style[key])) : obj;
	  }, style);
	}
	
	;
	
	(function () {
	  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
	
	  if (!reactHotLoader) {
	    return;
	  }
	
	  reactHotLoader.register(vendorSpecificProperties, "vendorSpecificProperties", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\autoprefix.ts");
	  reactHotLoader.register(prefixes, "prefixes", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\autoprefix.ts");
	  reactHotLoader.register(prefixProp, "prefixProp", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\autoprefix.ts");
	  reactHotLoader.register(autoprefix, "autoprefix", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\autoprefix.ts");
	})();
	
	;
	
	(function () {
	  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
	  leaveModule && leaveModule(module);
	})();
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)(module)))

/***/ },
/* 2904 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = void 0;
	
	var _Dock = _interopRequireDefault(__webpack_require__(2902));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	(function () {
	  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
	  enterModule && enterModule(module);
	})();
	
	var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
	  return a;
	};
	
	var _default = _Dock["default"];
	var _default2 = _default;
	exports["default"] = _default2;
	;
	
	(function () {
	  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
	
	  if (!reactHotLoader) {
	    return;
	  }
	
	  reactHotLoader.register(_default, "default", "C:\\Users\\Nathan\\Documents\\redux-devtools\\packages\\react-dock\\src\\index.ts");
	})();
	
	;
	
	(function () {
	  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
	  leaveModule && leaveModule(module);
	})();
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9pbmRleC50cyJdLCJuYW1lcyI6WyJEb2NrIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQUE7Ozs7Ozs7Ozs7Ozs7ZUFDZUEsZ0IiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgRG9jayBmcm9tICcuL0RvY2snO1xuZXhwb3J0IGRlZmF1bHQgRG9jaztcbiJdfQ==
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(187)(module)))

/***/ },
/* 2905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var compose = __webpack_require__(312).compose;
	
	exports.__esModule = true;
	exports.composeWithDevTools =
	  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
	    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
	    : function () {
	        if (arguments.length === 0) return undefined;
	        if (typeof arguments[0] === 'object') return compose;
	        return compose.apply(null, arguments);
	      };
	
	exports.devToolsEnhancer =
	  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
	    ? window.__REDUX_DEVTOOLS_EXTENSION__
	    : function () {
	        return function (noop) {
	          return noop;
	        };
	      };


/***/ },
/* 2906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _function = __webpack_require__(309);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _reduxDevtoolsThemes = __webpack_require__(2924);
	
	var themes = _interopRequireWildcard(_reduxDevtoolsThemes);
	
	var _reduxDevtools = __webpack_require__(593);
	
	var _actions = __webpack_require__(1172);
	
	var _reducers = __webpack_require__(2914);
	
	var _reducers2 = _interopRequireDefault(_reducers);
	
	var _LogMonitorButtonBar = __webpack_require__(2908);
	
	var _LogMonitorButtonBar2 = _interopRequireDefault(_LogMonitorButtonBar);
	
	var _LogMonitorEntryList = __webpack_require__(2911);
	
	var _LogMonitorEntryList2 = _interopRequireDefault(_LogMonitorEntryList);
	
	var _lodash = __webpack_require__(369);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var toggleAction = _reduxDevtools.ActionCreators.toggleAction;
	var setActionsActive = _reduxDevtools.ActionCreators.setActionsActive;
	
	
	var styles = {
	  container: {
	    fontFamily: 'monaco, Consolas, Lucida Console, monospace',
	    position: 'relative',
	    overflowY: 'hidden',
	    width: '100%',
	    height: '100%',
	    minWidth: 300,
	    direction: 'ltr'
	  },
	  elements: {
	    position: 'absolute',
	    left: 0,
	    right: 0,
	    top: 0,
	    bottom: 0,
	    overflowX: 'hidden',
	    overflowY: 'auto'
	  }
	};
	
	var LogMonitor = function (_Component) {
	  _inherits(LogMonitor, _Component);
	
	  function LogMonitor(props) {
	    _classCallCheck(this, LogMonitor);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.shouldComponentUpdate = _function2.default;
	    _this.updateScrollTop = (0, _lodash2.default)(function () {
	      var node = _this.node;
	      _this.props.dispatch((0, _actions.updateScrollTop)(node ? node.scrollTop : 0));
	    }, 500);
	
	    _this.handleToggleAction = _this.handleToggleAction.bind(_this);
	    _this.handleToggleConsecutiveAction = _this.handleToggleConsecutiveAction.bind(_this);
	    _this.getRef = _this.getRef.bind(_this);
	    return _this;
	  }
	
	  LogMonitor.prototype.scroll = function scroll() {
	    var node = this.node;
	    if (!node) {
	      return;
	    }
	    if (this.scrollDown) {
	      var offsetHeight = node.offsetHeight;
	      var scrollHeight = node.scrollHeight;
	
	      node.scrollTop = scrollHeight - offsetHeight;
	      this.scrollDown = false;
	    }
	  };
	
	  LogMonitor.prototype.componentDidMount = function componentDidMount() {
	    var node = this.node;
	    if (!node || !this.props.monitorState) {
	      return;
	    }
	
	    if (this.props.preserveScrollTop) {
	      node.scrollTop = this.props.monitorState.initialScrollTop;
	      node.addEventListener('scroll', this.updateScrollTop);
	    } else {
	      this.scrollDown = true;
	      this.scroll();
	    }
	  };
	
	  LogMonitor.prototype.componentWillUnmount = function componentWillUnmount() {
	    var node = this.node;
	    if (node && this.props.preserveScrollTop) {
	      node.removeEventListener('scroll', this.updateScrollTop);
	    }
	  };
	
	  LogMonitor.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var node = this.node;
	    if (!node) {
	      this.scrollDown = true;
	    } else if (this.props.stagedActionIds.length < nextProps.stagedActionIds.length) {
	      var scrollTop = node.scrollTop;
	      var offsetHeight = node.offsetHeight;
	      var scrollHeight = node.scrollHeight;
	
	
	      this.scrollDown = Math.abs(scrollHeight - (scrollTop + offsetHeight)) < 20;
	    } else {
	      this.scrollDown = false;
	    }
	  };
	
	  LogMonitor.prototype.componentDidUpdate = function componentDidUpdate() {
	    this.scroll();
	  };
	
	  LogMonitor.prototype.handleToggleAction = function handleToggleAction(id) {
	    this.props.dispatch(toggleAction(id));
	  };
	
	  LogMonitor.prototype.handleToggleConsecutiveAction = function handleToggleConsecutiveAction(id) {
	    var _props = this.props;
	    var monitorState = _props.monitorState;
	    var actionsById = _props.actionsById;
	    var consecutiveToggleStartId = monitorState.consecutiveToggleStartId;
	
	    if (consecutiveToggleStartId && actionsById[consecutiveToggleStartId]) {
	      var skippedActionIds = this.props.skippedActionIds;
	
	      var start = Math.min(consecutiveToggleStartId, id);
	      var end = Math.max(consecutiveToggleStartId, id);
	      var active = skippedActionIds.indexOf(consecutiveToggleStartId) > -1;
	      this.props.dispatch(setActionsActive(start, end + 1, active));
	      this.props.dispatch((0, _actions.startConsecutiveToggle)(null));
	    } else if (id > 0) {
	      this.props.dispatch((0, _actions.startConsecutiveToggle)(id));
	    }
	  };
	
	  LogMonitor.prototype.getTheme = function getTheme() {
	    var theme = this.props.theme;
	
	    if (typeof theme !== 'string') {
	      return theme;
	    }
	
	    if (typeof themes[theme] !== 'undefined') {
	      return themes[theme];
	    }
	
	    console.warn('DevTools theme ' + theme + ' not found, defaulting to nicinabox');
	    return themes.nicinabox;
	  };
	
	  LogMonitor.prototype.getRef = function getRef(node) {
	    this.node = node;
	  };
	
	  LogMonitor.prototype.render = function render() {
	    var theme = this.getTheme();
	    var consecutiveToggleStartId = this.props.monitorState.consecutiveToggleStartId;
	    var _props2 = this.props;
	    var dispatch = _props2.dispatch;
	    var actionsById = _props2.actionsById;
	    var skippedActionIds = _props2.skippedActionIds;
	    var stagedActionIds = _props2.stagedActionIds;
	    var computedStates = _props2.computedStates;
	    var currentStateIndex = _props2.currentStateIndex;
	    var select = _props2.select;
	    var expandActionRoot = _props2.expandActionRoot;
	    var expandStateRoot = _props2.expandStateRoot;
	    var markStateDiff = _props2.markStateDiff;
	
	
	    var entryListProps = {
	      theme: theme,
	      actionsById: actionsById,
	      skippedActionIds: skippedActionIds,
	      stagedActionIds: stagedActionIds,
	      computedStates: computedStates,
	      currentStateIndex: currentStateIndex,
	      consecutiveToggleStartId: consecutiveToggleStartId,
	      select: select,
	      expandActionRoot: expandActionRoot,
	      expandStateRoot: expandStateRoot,
	      markStateDiff: markStateDiff,
	      onActionClick: this.handleToggleAction,
	      onActionShiftClick: this.handleToggleConsecutiveAction
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { style: _extends({}, styles.container, { backgroundColor: theme.base00 }) },
	      !this.props.hideMainButtons && _react2.default.createElement(_LogMonitorButtonBar2.default, {
	        theme: theme,
	        dispatch: dispatch,
	        hasStates: computedStates.length > 1,
	        hasSkippedActions: skippedActionIds.length > 0
	      }),
	      _react2.default.createElement(
	        'div',
	        {
	          style: this.props.hideMainButtons ? styles.elements : _extends({}, styles.elements, { top: 30 }),
	          ref: this.getRef
	        },
	        _react2.default.createElement(_LogMonitorEntryList2.default, entryListProps)
	      )
	    );
	  };
	
	  return LogMonitor;
	}(_react.Component);
	
	LogMonitor.update = _reducers2.default;
	LogMonitor.propTypes = {
	  dispatch: _propTypes2.default.func,
	  computedStates: _propTypes2.default.array,
	  actionsById: _propTypes2.default.object,
	  stagedActionIds: _propTypes2.default.array,
	  skippedActionIds: _propTypes2.default.array,
	  monitorState: _propTypes2.default.shape({
	    initialScrollTop: _propTypes2.default.number,
	    consecutiveToggleStartId: _propTypes2.default.number
	  }),
	
	  preserveScrollTop: _propTypes2.default.bool,
	  select: _propTypes2.default.func,
	  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  expandActionRoot: _propTypes2.default.bool,
	  expandStateRoot: _propTypes2.default.bool,
	  markStateDiff: _propTypes2.default.bool,
	  hideMainButtons: _propTypes2.default.bool
	};
	LogMonitor.defaultProps = {
	  select: function select(state) {
	    return state;
	  },
	  theme: 'nicinabox',
	  preserveScrollTop: true,
	  expandActionRoot: true,
	  expandStateRoot: true,
	  markStateDiff: false
	};
	exports.default = LogMonitor;

/***/ },
/* 2907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _brighten = __webpack_require__(2912);
	
	var _brighten2 = _interopRequireDefault(_brighten);
	
	var _function = __webpack_require__(309);
	
	var _function2 = _interopRequireDefault(_function);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  base: {
	    cursor: 'pointer',
	    fontWeight: 'bold',
	    borderRadius: 3,
	    padding: 4,
	    marginLeft: 3,
	    marginRight: 3,
	    marginTop: 5,
	    marginBottom: 5,
	    flexGrow: 1,
	    display: 'inline-block',
	    fontSize: '0.8em',
	    color: 'white',
	    textDecoration: 'none'
	  }
	};
	
	var LogMonitorButton = function (_React$Component) {
	  _inherits(LogMonitorButton, _React$Component);
	
	  function LogMonitorButton(props) {
	    _classCallCheck(this, LogMonitorButton);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.shouldComponentUpdate = _function2.default;
	
	
	    _this.handleMouseEnter = _this.handleMouseEnter.bind(_this);
	    _this.handleMouseLeave = _this.handleMouseLeave.bind(_this);
	    _this.handleMouseDown = _this.handleMouseDown.bind(_this);
	    _this.handleMouseUp = _this.handleMouseUp.bind(_this);
	    _this.onClick = _this.onClick.bind(_this);
	
	    _this.state = {
	      hovered: false,
	      active: false
	    };
	    return _this;
	  }
	
	  LogMonitorButton.prototype.handleMouseEnter = function handleMouseEnter() {
	    this.setState({ hovered: true });
	  };
	
	  LogMonitorButton.prototype.handleMouseLeave = function handleMouseLeave() {
	    this.setState({ hovered: false });
	  };
	
	  LogMonitorButton.prototype.handleMouseDown = function handleMouseDown() {
	    this.setState({ active: true });
	  };
	
	  LogMonitorButton.prototype.handleMouseUp = function handleMouseUp() {
	    this.setState({ active: false });
	  };
	
	  LogMonitorButton.prototype.onClick = function onClick() {
	    if (!this.props.enabled) {
	      return;
	    }
	    if (this.props.onClick) {
	      this.props.onClick();
	    }
	  };
	
	  LogMonitorButton.prototype.render = function render() {
	    var style = _extends({}, styles.base, {
	      backgroundColor: this.props.theme.base02
	    });
	    if (this.props.enabled && this.state.hovered) {
	      style = _extends({}, style, {
	        backgroundColor: (0, _brighten2.default)(this.props.theme.base02, 0.2)
	      });
	    }
	    if (!this.props.enabled) {
	      style = _extends({}, style, {
	        opacity: 0.2,
	        cursor: 'text',
	        backgroundColor: 'transparent'
	      });
	    }
	    return _react2.default.createElement(
	      'a',
	      { onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onClick: this.onClick,
	        style: style },
	      this.props.children
	    );
	  };
	
	  return LogMonitorButton;
	}(_react2.default.Component);
	
	exports.default = LogMonitorButton;

/***/ },
/* 2908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _function = __webpack_require__(309);
	
	var _function2 = _interopRequireDefault(_function);
	
	var _reduxDevtools = __webpack_require__(593);
	
	var _LogMonitorButton = __webpack_require__(2907);
	
	var _LogMonitorButton2 = _interopRequireDefault(_LogMonitorButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var reset = _reduxDevtools.ActionCreators.reset;
	var rollback = _reduxDevtools.ActionCreators.rollback;
	var commit = _reduxDevtools.ActionCreators.commit;
	var sweep = _reduxDevtools.ActionCreators.sweep;
	
	
	var style = {
	  textAlign: 'center',
	  borderBottomWidth: 1,
	  borderBottomStyle: 'solid',
	  borderColor: 'transparent',
	  zIndex: 1,
	  display: 'flex',
	  flexDirection: 'row'
	};
	
	var LogMonitorButtonBar = function (_Component) {
	  _inherits(LogMonitorButtonBar, _Component);
	
	  function LogMonitorButtonBar(props) {
	    _classCallCheck(this, LogMonitorButtonBar);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.shouldComponentUpdate = _function2.default;
	
	    _this.handleReset = _this.handleReset.bind(_this);
	    _this.handleRollback = _this.handleRollback.bind(_this);
	    _this.handleSweep = _this.handleSweep.bind(_this);
	    _this.handleCommit = _this.handleCommit.bind(_this);
	    return _this;
	  }
	
	  LogMonitorButtonBar.prototype.handleRollback = function handleRollback() {
	    this.props.dispatch(rollback());
	  };
	
	  LogMonitorButtonBar.prototype.handleSweep = function handleSweep() {
	    this.props.dispatch(sweep());
	  };
	
	  LogMonitorButtonBar.prototype.handleCommit = function handleCommit() {
	    this.props.dispatch(commit());
	  };
	
	  LogMonitorButtonBar.prototype.handleReset = function handleReset() {
	    this.props.dispatch(reset());
	  };
	
	  LogMonitorButtonBar.prototype.render = function render() {
	    var _props = this.props;
	    var theme = _props.theme;
	    var hasStates = _props.hasStates;
	    var hasSkippedActions = _props.hasSkippedActions;
	
	    return _react2.default.createElement(
	      'div',
	      { style: _extends({}, style, { borderColor: theme.base02 }) },
	      _react2.default.createElement(
	        _LogMonitorButton2.default,
	        {
	          theme: theme,
	          onClick: this.handleReset,
	          enabled: true },
	        'Reset'
	      ),
	      _react2.default.createElement(
	        _LogMonitorButton2.default,
	        {
	          theme: theme,
	          onClick: this.handleRollback,
	          enabled: hasStates },
	        'Revert'
	      ),
	      _react2.default.createElement(
	        _LogMonitorButton2.default,
	        {
	          theme: theme,
	          onClick: this.handleSweep,
	          enabled: hasSkippedActions },
	        'Sweep'
	      ),
	      _react2.default.createElement(
	        _LogMonitorButton2.default,
	        {
	          theme: theme,
	          onClick: this.handleCommit,
	          enabled: hasStates },
	        'Commit'
	      )
	    );
	  };
	
	  return LogMonitorButtonBar;
	}(_react.Component);
	
	LogMonitorButtonBar.propTypes = {
	  dispatch: _propTypes2.default.func,
	  theme: _propTypes2.default.object
	};
	exports.default = LogMonitorButtonBar;

/***/ },
/* 2909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactJsonTree = __webpack_require__(1175);
	
	var _reactJsonTree2 = _interopRequireDefault(_reactJsonTree);
	
	var _LogMonitorEntryAction = __webpack_require__(2910);
	
	var _LogMonitorEntryAction2 = _interopRequireDefault(_LogMonitorEntryAction);
	
	var _function = __webpack_require__(309);
	
	var _function2 = _interopRequireDefault(_function);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  entry: {
	    display: 'block',
	    WebkitUserSelect: 'none'
	  },
	
	  root: {
	    marginLeft: 0
	  }
	};
	
	var getDeepItem = function getDeepItem(data, path) {
	  return path.reduce(function (obj, key) {
	    return obj && obj[key];
	  }, data);
	};
	var dataIsEqual = function dataIsEqual(data, previousData, keyPath) {
	  var path = [].concat(keyPath).reverse().slice(1);
	
	  return getDeepItem(data, path) === getDeepItem(previousData, path);
	};
	
	var LogMonitorEntry = function (_Component) {
	  _inherits(LogMonitorEntry, _Component);
	
	  function LogMonitorEntry(props) {
	    _classCallCheck(this, LogMonitorEntry);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.shouldComponentUpdate = _function2.default;
	
	    _this.handleActionClick = _this.handleActionClick.bind(_this);
	    _this.shouldExpandNode = _this.shouldExpandNode.bind(_this);
	    return _this;
	  }
	
	  LogMonitorEntry.prototype.printState = function printState(state, error) {
	    var _this2 = this;
	
	    var errorText = error;
	    if (!errorText) {
	      try {
	        var _ret = function () {
	          var data = _this2.props.select(state);
	          var theme = void 0;
	
	          if (_this2.props.markStateDiff) {
	            (function () {
	              var previousData = typeof _this2.props.previousState !== 'undefined' ? _this2.props.select(_this2.props.previousState) : undefined;
	              var getValueStyle = function getValueStyle(_ref, nodeType, keyPath) {
	                var style = _ref.style;
	                return {
	                  style: _extends({}, style, {
	                    backgroundColor: dataIsEqual(data, previousData, keyPath) ? 'transparent' : _this2.props.theme.base01
	                  })
	                };
	              };
	              var getNestedNodeStyle = function getNestedNodeStyle(_ref2, keyPath) {
	                var style = _ref2.style;
	                return {
	                  style: _extends({}, style, keyPath.length > 1 ? {} : styles.root)
	                };
	              };
	              theme = {
	                extend: _this2.props.theme,
	                tree: styles.tree,
	                value: getValueStyle,
	                nestedNode: getNestedNodeStyle
	              };
	            })();
	          } else {
	            theme = _this2.props.theme;
	          }
	
	          return {
	            v: _react2.default.createElement(_reactJsonTree2.default, {
	              theme: theme,
	              data: data,
	              invertTheme: false,
	              keyPath: ['state'],
	              shouldExpandNode: _this2.shouldExpandNode })
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      } catch (err) {
	        errorText = 'Error selecting state.';
	      }
	    }
	
	    return _react2.default.createElement(
	      'div',
	      { style: {
	          color: this.props.theme.base08,
	          paddingTop: 20,
	          paddingLeft: 30,
	          paddingRight: 30,
	          paddingBottom: 35
	        } },
	      errorText
	    );
	  };
	
	  LogMonitorEntry.prototype.handleActionClick = function handleActionClick(e) {
	    var _props = this.props;
	    var actionId = _props.actionId;
	    var onActionClick = _props.onActionClick;
	    var onActionShiftClick = _props.onActionShiftClick;
	
	    if (actionId > 0) {
	      if (e.shiftKey) {
	        onActionShiftClick(actionId);
	      } else {
	        onActionClick(actionId);
	      }
	    }
	  };
	
	  LogMonitorEntry.prototype.shouldExpandNode = function shouldExpandNode(keyName, data, level) {
	    return this.props.expandStateRoot && level === 0;
	  };
	
	  LogMonitorEntry.prototype.render = function render() {
	    var _props2 = this.props;
	    var actionId = _props2.actionId;
	    var error = _props2.error;
	    var action = _props2.action;
	    var state = _props2.state;
	    var collapsed = _props2.collapsed;
	    var selected = _props2.selected;
	    var inFuture = _props2.inFuture;
	
	    var styleEntry = {
	      opacity: collapsed ? 0.5 : 1,
	      cursor: actionId > 0 ? 'pointer' : 'default'
	    };
	
	    return _react2.default.createElement(
	      'div',
	      { style: {
	          opacity: selected ? 0.4 : inFuture ? 0.6 : 1, // eslint-disable-line no-nested-ternary
	          textDecoration: collapsed ? 'line-through' : 'none',
	          color: this.props.theme.base06
	        } },
	      _react2.default.createElement(_LogMonitorEntryAction2.default, {
	        theme: this.props.theme,
	        collapsed: collapsed,
	        action: action,
	        expandActionRoot: this.props.expandActionRoot,
	        onClick: this.handleActionClick,
	        style: _extends({}, styles.entry, styleEntry) }),
	      !collapsed && _react2.default.createElement(
	        'div',
	        { style: { paddingLeft: 16 } },
	        this.printState(state, error)
	      )
	    );
	  };
	
	  return LogMonitorEntry;
	}(_react.Component);
	
	LogMonitorEntry.propTypes = {
	  state: _propTypes2.default.object.isRequired,
	  action: _propTypes2.default.object.isRequired,
	  actionId: _propTypes2.default.number.isRequired,
	  select: _propTypes2.default.func.isRequired,
	  inFuture: _propTypes2.default.bool,
	  error: _propTypes2.default.string,
	  onActionClick: _propTypes2.default.func.isRequired,
	  onActionShiftClick: _propTypes2.default.func.isRequired,
	  collapsed: _propTypes2.default.bool,
	  selected: _propTypes2.default.bool,
	  expandActionRoot: _propTypes2.default.bool,
	  expandStateRoot: _propTypes2.default.bool
	};
	exports.default = LogMonitorEntry;

/***/ },
/* 2910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactJsonTree = __webpack_require__(1175);
	
	var _reactJsonTree2 = _interopRequireDefault(_reactJsonTree);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var styles = {
	  actionBar: {
	    paddingTop: 8,
	    paddingBottom: 7,
	    paddingLeft: 16
	  },
	  payload: {
	    margin: 0,
	    paddingLeft: 16,
	    overflow: 'auto'
	  }
	};
	
	var LogMonitorAction = function (_Component) {
	  _inherits(LogMonitorAction, _Component);
	
	  function LogMonitorAction(props) {
	    _classCallCheck(this, LogMonitorAction);
	
	    var _this = _possibleConstructorReturn(this, _Component.call(this, props));
	
	    _this.shouldExpandNode = _this.shouldExpandNode.bind(_this);
	    return _this;
	  }
	
	  LogMonitorAction.prototype.renderPayload = function renderPayload(payload) {
	    return _react2.default.createElement(
	      'div',
	      { style: _extends({}, styles.payload, {
	          backgroundColor: this.props.theme.base00
	        }) },
	      Object.keys(payload).length > 0 ? _react2.default.createElement(_reactJsonTree2.default, { theme: this.props.theme,
	        invertTheme: false,
	        keyPath: ['action'],
	        data: payload,
	        shouldExpandNode: this.shouldExpandNode }) : ''
	    );
	  };
	
	  LogMonitorAction.prototype.shouldExpandNode = function shouldExpandNode(keyName, data, level) {
	    return this.props.expandActionRoot && level === 0;
	  };
	
	  LogMonitorAction.prototype.render = function render() {
	    var _props$action = this.props.action;
	    var type = _props$action.type;
	
	    var payload = _objectWithoutProperties(_props$action, ['type']);
	
	    return _react2.default.createElement(
	      'div',
	      { style: _extends({
	          backgroundColor: this.props.theme.base02,
	          color: this.props.theme.base06
	        }, this.props.style) },
	      _react2.default.createElement(
	        'div',
	        { style: styles.actionBar,
	          onClick: this.props.onClick },
	        type !== null && type.toString()
	      ),
	      !this.props.collapsed ? this.renderPayload(payload) : ''
	    );
	  };
	
	  return LogMonitorAction;
	}(_react.Component);
	
	exports.default = LogMonitorAction;

/***/ },
/* 2911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _LogMonitorEntry = __webpack_require__(2909);
	
	var _LogMonitorEntry2 = _interopRequireDefault(_LogMonitorEntry);
	
	var _function = __webpack_require__(309);
	
	var _function2 = _interopRequireDefault(_function);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var LogMonitorEntryList = function (_Component) {
	  _inherits(LogMonitorEntryList, _Component);
	
	  function LogMonitorEntryList() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, LogMonitorEntryList);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.shouldComponentUpdate = _function2.default, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  LogMonitorEntryList.prototype.render = function render() {
	    var elements = [];
	    var _props = this.props;
	    var theme = _props.theme;
	    var actionsById = _props.actionsById;
	    var computedStates = _props.computedStates;
	    var currentStateIndex = _props.currentStateIndex;
	    var consecutiveToggleStartId = _props.consecutiveToggleStartId;
	    var select = _props.select;
	    var skippedActionIds = _props.skippedActionIds;
	    var stagedActionIds = _props.stagedActionIds;
	    var expandActionRoot = _props.expandActionRoot;
	    var expandStateRoot = _props.expandStateRoot;
	    var markStateDiff = _props.markStateDiff;
	    var onActionClick = _props.onActionClick;
	    var onActionShiftClick = _props.onActionShiftClick;
	
	
	    for (var i = 0; i < stagedActionIds.length; i++) {
	      var actionId = stagedActionIds[i];
	      var action = actionsById[actionId].action;
	      var _computedStates$i = computedStates[i];
	      var state = _computedStates$i.state;
	      var error = _computedStates$i.error;
	
	      var previousState = void 0;
	      if (i > 0) {
	        previousState = computedStates[i - 1].state;
	      }
	      elements.push(_react2.default.createElement(_LogMonitorEntry2.default, { key: actionId,
	        theme: theme,
	        select: select,
	        action: action,
	        actionId: actionId,
	        state: state,
	        previousState: previousState,
	        collapsed: skippedActionIds.indexOf(actionId) > -1,
	        inFuture: i > currentStateIndex,
	        selected: consecutiveToggleStartId === i,
	        error: error,
	        expandActionRoot: expandActionRoot,
	        expandStateRoot: expandStateRoot,
	        markStateDiff: markStateDiff,
	        onActionClick: onActionClick,
	        onActionShiftClick: onActionShiftClick }));
	    }
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      elements
	    );
	  };
	
	  return LogMonitorEntryList;
	}(_react.Component);
	
	LogMonitorEntryList.propTypes = {
	  actionsById: _propTypes2.default.object,
	  computedStates: _propTypes2.default.array,
	  stagedActionIds: _propTypes2.default.array,
	  skippedActionIds: _propTypes2.default.array,
	  currentStateIndex: _propTypes2.default.number,
	  consecutiveToggleStartId: _propTypes2.default.number,
	
	  select: _propTypes2.default.func.isRequired,
	  onActionClick: _propTypes2.default.func.isRequired,
	  theme: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]),
	  expandActionRoot: _propTypes2.default.bool,
	  expandStateRoot: _propTypes2.default.bool
	};
	exports.default = LogMonitorEntryList;

/***/ },
/* 2912 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	exports.default = function (hexColor, lightness) {
	  var hex = String(hexColor).replace(/[^0-9a-f]/gi, '');
	  if (hex.length < 6) {
	    hex = hex.replace(/(.)/g, '$1$1');
	  }
	  var lum = lightness || 0;
	
	  var rgb = '#';
	  var c = void 0;
	  for (var i = 0; i < 3; ++i) {
	    c = parseInt(hex.substr(i * 2, 2), 16);
	    c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
	    rgb += ('00' + c).substr(c.length);
	  }
	  return rgb;
	};

/***/ },
/* 2913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = undefined;
	
	var _LogMonitor = __webpack_require__(2906);
	
	var _LogMonitor2 = _interopRequireDefault(_LogMonitor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LogMonitor2.default;

/***/ },
/* 2914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = reducer;
	
	var _actions = __webpack_require__(1172);
	
	function initialScrollTop(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var action = arguments[2];
	
	  if (!props.preserveScrollTop) {
	    return 0;
	  }
	
	  return action.type === _actions.UPDATE_SCROLL_TOP ? action.scrollTop : state;
	}
	
	function startConsecutiveToggle(props, state, action) {
	  return action.type === _actions.START_CONSECUTIVE_TOGGLE ? action.id : state;
	}
	
	function reducer(props) {
	  var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var action = arguments[2];
	
	  return {
	    initialScrollTop: initialScrollTop(props, state.initialScrollTop, action),
	    consecutiveToggleStartId: startConsecutiveToggle(props, state.consecutiveToggleStartId, action)
	  };
	}

/***/ },
/* 2915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _JSONArrow = __webpack_require__(1173);
	
	var _JSONArrow2 = _interopRequireDefault(_JSONArrow);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var ItemRange = function (_React$Component) {
	  (0, _inherits3['default'])(ItemRange, _React$Component);
	
	  function ItemRange(props) {
	    (0, _classCallCheck3['default'])(this, ItemRange);
	
	    var _this = (0, _possibleConstructorReturn3['default'])(this, _React$Component.call(this, props));
	
	    _this.state = { expanded: false };
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    return _this;
	  }
	
	  ItemRange.prototype.render = function render() {
	    var _props = this.props,
	        styling = _props.styling,
	        from = _props.from,
	        to = _props.to,
	        renderChildNodes = _props.renderChildNodes,
	        nodeType = _props.nodeType;
	
	
	    return this.state.expanded ? _react2['default'].createElement(
	      'div',
	      styling('itemRange', this.state.expanded),
	      renderChildNodes(this.props, from, to)
	    ) : _react2['default'].createElement(
	      'div',
	      (0, _extends3['default'])({}, styling('itemRange', this.state.expanded), {
	        onClick: this.handleClick
	      }),
	      _react2['default'].createElement(_JSONArrow2['default'], {
	        nodeType: nodeType,
	        styling: styling,
	        expanded: false,
	        onClick: this.handleClick,
	        arrowStyle: 'double'
	      }),
	      from + ' ... ' + to
	    );
	  };
	
	  ItemRange.prototype.handleClick = function handleClick() {
	    this.setState({ expanded: !this.state.expanded });
	  };
	
	  return ItemRange;
	}(_react2['default'].Component);
	
	ItemRange.propTypes = {
	  styling: _propTypes2['default'].func.isRequired,
	  from: _propTypes2['default'].number.isRequired,
	  to: _propTypes2['default'].number.isRequired,
	  renderChildNodes: _propTypes2['default'].func.isRequired,
	  nodeType: _propTypes2['default'].string.isRequired
	};
	exports['default'] = ItemRange;

/***/ },
/* 2916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _JSONNestedNode = __webpack_require__(592);
	
	var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Returns the "n Items" string for this node,
	// generating and caching it if it hasn't been created yet.
	function createItemString(data) {
	  return data.length + ' ' + (data.length !== 1 ? 'items' : 'item');
	}
	
	// Configures <JSONNestedNode> to render an Array
	var JSONArrayNode = function JSONArrayNode(_ref) {
	  var data = _ref.data,
	      props = (0, _objectWithoutProperties3['default'])(_ref, ['data']);
	  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
	    data: data,
	    nodeType: 'Array',
	    nodeTypeIndicator: '[]',
	    createItemString: createItemString,
	    expandable: data.length > 0
	  }));
	};
	
	JSONArrayNode.propTypes = {
	  data: _propTypes2['default'].array
	};
	
	exports['default'] = JSONArrayNode;

/***/ },
/* 2917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getIterator2 = __webpack_require__(442);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _isSafeInteger = __webpack_require__(1829);
	
	var _isSafeInteger2 = _interopRequireDefault(_isSafeInteger);
	
	exports['default'] = JSONIterableNode;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _JSONNestedNode = __webpack_require__(592);
	
	var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Returns the "n Items" string for this node,
	// generating and caching it if it hasn't been created yet.
	function createItemString(data, limit) {
	  var count = 0;
	  var hasMore = false;
	  if ((0, _isSafeInteger2['default'])(data.size)) {
	    count = data.size;
	  } else {
	    // eslint-disable-next-line no-unused-vars
	    for (var _iterator = data, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3['default'])(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var entry = _ref;
	
	      if (limit && count + 1 > limit) {
	        hasMore = true;
	        break;
	      }
	      count += 1;
	    }
	  }
	  return '' + (hasMore ? '>' : '') + count + ' ' + (count !== 1 ? 'entries' : 'entry');
	}
	
	// Configures <JSONNestedNode> to render an iterable
	function JSONIterableNode(_ref2) {
	  var props = (0, _objectWithoutProperties3['default'])(_ref2, []);
	
	  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
	    nodeType: 'Iterable',
	    nodeTypeIndicator: '()',
	    createItemString: createItemString
	  }));
	}

/***/ },
/* 2918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(68);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getOwnPropertyNames = __webpack_require__(740);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _JSONNestedNode = __webpack_require__(592);
	
	var _JSONNestedNode2 = _interopRequireDefault(_JSONNestedNode);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	// Returns the "n Items" string for this node,
	// generating and caching it if it hasn't been created yet.
	function createItemString(data) {
	  var len = (0, _getOwnPropertyNames2['default'])(data).length;
	  return len + ' ' + (len !== 1 ? 'keys' : 'key');
	}
	
	// Configures <JSONNestedNode> to render an Object
	var JSONObjectNode = function JSONObjectNode(_ref) {
	  var data = _ref.data,
	      props = (0, _objectWithoutProperties3['default'])(_ref, ['data']);
	  return _react2['default'].createElement(_JSONNestedNode2['default'], (0, _extends3['default'])({}, props, {
	    data: data,
	    nodeType: 'Object',
	    nodeTypeIndicator: props.nodeType === 'Error' ? 'Error()' : '{}',
	    createItemString: createItemString,
	    expandable: (0, _getOwnPropertyNames2['default'])(data).length > 0
	  }));
	};
	
	JSONObjectNode.propTypes = {
	  data: _propTypes2['default'].object,
	  nodeType: _propTypes2['default'].string
	};
	
	exports['default'] = JSONObjectNode;

/***/ },
/* 2919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(6);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Renders simple values (eg. strings, numbers, booleans, etc)
	 */
	
	var JSONValueNode = function JSONValueNode(_ref) {
	  var nodeType = _ref.nodeType,
	      styling = _ref.styling,
	      labelRenderer = _ref.labelRenderer,
	      keyPath = _ref.keyPath,
	      valueRenderer = _ref.valueRenderer,
	      value = _ref.value,
	      valueGetter = _ref.valueGetter;
	  return _react2['default'].createElement(
	    'li',
	    styling('value', nodeType, keyPath),
	    _react2['default'].createElement(
	      'label',
	      styling(['label', 'valueLabel'], nodeType, keyPath),
	      labelRenderer(keyPath, nodeType, false, false)
	    ),
	    _react2['default'].createElement(
	      'span',
	      styling('valueText', nodeType, keyPath),
	      valueRenderer.apply(undefined, [valueGetter(value), value].concat(keyPath))
	    )
	  );
	};
	
	JSONValueNode.propTypes = {
	  nodeType: _propTypes2['default'].string.isRequired,
	  styling: _propTypes2['default'].func.isRequired,
	  labelRenderer: _propTypes2['default'].func.isRequired,
	  keyPath: _propTypes2['default'].arrayOf(_propTypes2['default'].oneOfType([_propTypes2['default'].string, _propTypes2['default'].number])).isRequired,
	  valueRenderer: _propTypes2['default'].func.isRequired,
	  value: _propTypes2['default'].any,
	  valueGetter: _propTypes2['default'].func
	};
	
	JSONValueNode.defaultProps = {
	  valueGetter: function valueGetter(value) {
	    return value;
	  }
	};
	
	exports['default'] = JSONValueNode;

/***/ },
/* 2920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _reactBase16Styling = __webpack_require__(1127);
	
	var _solarized = __webpack_require__(2923);
	
	var _solarized2 = _interopRequireDefault(_solarized);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var colorMap = function colorMap(theme) {
	  return {
	    BACKGROUND_COLOR: theme.base00,
	    TEXT_COLOR: theme.base07,
	    STRING_COLOR: theme.base0B,
	    DATE_COLOR: theme.base0B,
	    NUMBER_COLOR: theme.base09,
	    BOOLEAN_COLOR: theme.base09,
	    NULL_COLOR: theme.base08,
	    UNDEFINED_COLOR: theme.base08,
	    FUNCTION_COLOR: theme.base08,
	    SYMBOL_COLOR: theme.base08,
	    LABEL_COLOR: theme.base0D,
	    ARROW_COLOR: theme.base0D,
	    ITEM_STRING_COLOR: theme.base0B,
	    ITEM_STRING_EXPANDED_COLOR: theme.base03
	  };
	};
	
	var valueColorMap = function valueColorMap(colors) {
	  return {
	    String: colors.STRING_COLOR,
	    Date: colors.DATE_COLOR,
	    Number: colors.NUMBER_COLOR,
	    Boolean: colors.BOOLEAN_COLOR,
	    Null: colors.NULL_COLOR,
	    Undefined: colors.UNDEFINED_COLOR,
	    Function: colors.FUNCTION_COLOR,
	    Symbol: colors.SYMBOL_COLOR
	  };
	};
	
	var getDefaultThemeStyling = function getDefaultThemeStyling(theme) {
	  var colors = colorMap(theme);
	
	  return {
	    tree: {
	      border: 0,
	      padding: 0,
	      marginTop: '0.5em',
	      marginBottom: '0.5em',
	      marginLeft: '0.125em',
	      marginRight: 0,
	      listStyle: 'none',
	      MozUserSelect: 'none',
	      WebkitUserSelect: 'none',
	      backgroundColor: colors.BACKGROUND_COLOR
	    },
	
	    value: function value(_ref, nodeType, keyPath) {
	      var style = _ref.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          paddingTop: '0.25em',
	          paddingRight: 0,
	          marginLeft: '0.875em',
	          WebkitUserSelect: 'text',
	          MozUserSelect: 'text',
	          wordWrap: 'break-word',
	          paddingLeft: keyPath.length > 1 ? '2.125em' : '1.25em',
	          textIndent: '-0.5em',
	          wordBreak: 'break-all'
	        })
	      };
	    },
	
	    label: {
	      display: 'inline-block',
	      color: colors.LABEL_COLOR
	    },
	
	    valueLabel: {
	      margin: '0 0.5em 0 0'
	    },
	
	    valueText: function valueText(_ref2, nodeType) {
	      var style = _ref2.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          color: valueColorMap(colors)[nodeType]
	        })
	      };
	    },
	
	    itemRange: function itemRange(styling, expanded) {
	      return {
	        style: {
	          paddingTop: expanded ? 0 : '0.25em',
	          cursor: 'pointer',
	          color: colors.LABEL_COLOR
	        }
	      };
	    },
	
	    arrow: function arrow(_ref3, nodeType, expanded) {
	      var style = _ref3.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          marginLeft: 0,
	          transition: '150ms',
	          WebkitTransition: '150ms',
	          MozTransition: '150ms',
	          WebkitTransform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
	          MozTransform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
	          transform: expanded ? 'rotateZ(90deg)' : 'rotateZ(0deg)',
	          transformOrigin: '45% 50%',
	          WebkitTransformOrigin: '45% 50%',
	          MozTransformOrigin: '45% 50%',
	          position: 'relative',
	          lineHeight: '1.1em',
	          fontSize: '0.75em'
	        })
	      };
	    },
	
	    arrowContainer: function arrowContainer(_ref4, arrowStyle) {
	      var style = _ref4.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          display: 'inline-block',
	          paddingRight: '0.5em',
	          paddingLeft: arrowStyle === 'double' ? '1em' : 0,
	          cursor: 'pointer'
	        })
	      };
	    },
	
	    arrowSign: {
	      color: colors.ARROW_COLOR
	    },
	
	    arrowSignInner: {
	      position: 'absolute',
	      top: 0,
	      left: '-0.4em'
	    },
	
	    nestedNode: function nestedNode(_ref5, keyPath, nodeType, expanded, expandable) {
	      var style = _ref5.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          position: 'relative',
	          paddingTop: '0.25em',
	          marginLeft: keyPath.length > 1 ? '0.875em' : 0,
	          paddingLeft: !expandable ? '1.125em' : 0
	        })
	      };
	    },
	
	    rootNode: {
	      padding: 0,
	      margin: 0
	    },
	
	    nestedNodeLabel: function nestedNodeLabel(_ref6, keyPath, nodeType, expanded, expandable) {
	      var style = _ref6.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          margin: 0,
	          padding: 0,
	          WebkitUserSelect: expandable ? 'inherit' : 'text',
	          MozUserSelect: expandable ? 'inherit' : 'text',
	          cursor: expandable ? 'pointer' : 'default'
	        })
	      };
	    },
	
	    nestedNodeItemString: function nestedNodeItemString(_ref7, keyPath, nodeType, expanded) {
	      var style = _ref7.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          paddingLeft: '0.5em',
	          cursor: 'default',
	          color: expanded ? colors.ITEM_STRING_EXPANDED_COLOR : colors.ITEM_STRING_COLOR
	        })
	      };
	    },
	
	    nestedNodeItemType: {
	      marginLeft: '0.3em',
	      marginRight: '0.3em'
	    },
	
	    nestedNodeChildren: function nestedNodeChildren(_ref8, nodeType, expanded) {
	      var style = _ref8.style;
	      return {
	        style: (0, _extends3['default'])({}, style, {
	          padding: 0,
	          margin: 0,
	          listStyle: 'none',
	          display: expanded ? 'block' : 'none'
	        })
	      };
	    },
	
	    rootNodeChildren: {
	      padding: 0,
	      margin: 0,
	      listStyle: 'none'
	    }
	  };
	};
	
	exports['default'] = (0, _reactBase16Styling.createStyling)(getDefaultThemeStyling, {
	  defaultBase16: _solarized2['default']
	});

/***/ },
/* 2921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getIterator2 = __webpack_require__(442);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _getOwnPropertyNames = __webpack_require__(740);
	
	var _getOwnPropertyNames2 = _interopRequireDefault(_getOwnPropertyNames);
	
	var _keys = __webpack_require__(329);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports['default'] = getCollectionEntries;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getLength(type, collection) {
	  if (type === 'Object') {
	    return (0, _keys2['default'])(collection).length;
	  } else if (type === 'Array') {
	    return collection.length;
	  }
	
	  return Infinity;
	}
	
	function isIterableMap(collection) {
	  return typeof collection.set === 'function';
	}
	
	function getEntries(type, collection, sortObjectKeys) {
	  var from = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
	  var to = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : Infinity;
	
	  var res = void 0;
	
	  if (type === 'Object') {
	    var keys = (0, _getOwnPropertyNames2['default'])(collection);
	
	    if (sortObjectKeys) {
	      keys.sort(sortObjectKeys === true ? undefined : sortObjectKeys);
	    }
	
	    keys = keys.slice(from, to + 1);
	
	    res = {
	      entries: keys.map(function (key) {
	        return { key: key, value: collection[key] };
	      })
	    };
	  } else if (type === 'Array') {
	    res = {
	      entries: collection.slice(from, to + 1).map(function (val, idx) {
	        return { key: idx + from, value: val };
	      })
	    };
	  } else {
	    var idx = 0;
	    var entries = [];
	    var done = true;
	
	    var isMap = isIterableMap(collection);
	
	    for (var _iterator = collection, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : (0, _getIterator3['default'])(_iterator);;) {
	      var _ref;
	
	      if (_isArray) {
	        if (_i >= _iterator.length) break;
	        _ref = _iterator[_i++];
	      } else {
	        _i = _iterator.next();
	        if (_i.done) break;
	        _ref = _i.value;
	      }
	
	      var item = _ref;
	
	      if (idx > to) {
	        done = false;
	        break;
	      }
	      if (from <= idx) {
	        if (isMap && Array.isArray(item)) {
	          if (typeof item[0] === 'string' || typeof item[0] === 'number') {
	            entries.push({ key: item[0], value: item[1] });
	          } else {
	            entries.push({
	              key: '[entry ' + idx + ']',
	              value: {
	                '[key]': item[0],
	                '[value]': item[1]
	              }
	            });
	          }
	        } else {
	          entries.push({ key: idx, value: item });
	        }
	      }
	      idx++;
	    }
	
	    res = {
	      hasMore: !done,
	      entries: entries
	    };
	  }
	
	  return res;
	}
	
	function getRanges(from, to, limit) {
	  var ranges = [];
	  while (to - from > limit * limit) {
	    limit = limit * limit;
	  }
	  for (var i = from; i <= to; i += limit) {
	    ranges.push({ from: i, to: Math.min(to, i + limit - 1) });
	  }
	
	  return ranges;
	}
	
	function getCollectionEntries(type, collection, sortObjectKeys, limit) {
	  var from = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
	  var to = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : Infinity;
	
	  var getEntriesBound = getEntries.bind(null, type, collection, sortObjectKeys);
	
	  if (!limit) {
	    return getEntriesBound().entries;
	  }
	
	  var isSubset = to < Infinity;
	  var length = Math.min(to - from, getLength(type, collection));
	
	  if (type !== 'Iterable') {
	    if (length <= limit || limit < 7) {
	      return getEntriesBound(from, to).entries;
	    }
	  } else {
	    if (length <= limit && !isSubset) {
	      return getEntriesBound(from, to).entries;
	    }
	  }
	
	  var limitedEntries = void 0;
	  if (type === 'Iterable') {
	    var _getEntriesBound = getEntriesBound(from, from + limit - 1),
	        hasMore = _getEntriesBound.hasMore,
	        entries = _getEntriesBound.entries;
	
	    limitedEntries = hasMore ? [].concat(entries, getRanges(from + limit, from + 2 * limit - 1, limit)) : entries;
	  } else {
	    limitedEntries = isSubset ? getRanges(from, to, limit) : [].concat(getEntriesBound(0, limit - 5).entries, getRanges(limit - 4, length - 5, limit), getEntriesBound(length - 4, length - 1).entries);
	  }
	
	  return limitedEntries;
	}

/***/ },
/* 2922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(741);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	exports['default'] = objType;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function objType(obj) {
	  var type = Object.prototype.toString.call(obj).slice(8, -1);
	  if (type === 'Object' && typeof obj[_iterator2['default']] === 'function') {
	    return 'Iterable';
	  }
	
	  if (type === 'Custom' && obj.constructor !== Object && obj instanceof Object) {
	    // For projects implementing objects overriding `.prototype[Symbol.toStringTag]`
	    return 'Object';
	  }
	
	  return type;
	}

/***/ },
/* 2923 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'solarized',
	  author: 'ethan schoonover (http://ethanschoonover.com/solarized)',
	  base00: '#002b36',
	  base01: '#073642',
	  base02: '#586e75',
	  base03: '#657b83',
	  base04: '#839496',
	  base05: '#93a1a1',
	  base06: '#eee8d5',
	  base07: '#fdf6e3',
	  base08: '#dc322f',
	  base09: '#cb4b16',
	  base0A: '#b58900',
	  base0B: '#859900',
	  base0C: '#2aa198',
	  base0D: '#268bd2',
	  base0E: '#6c71c4',
	  base0F: '#d33682'
	};

/***/ },
/* 2924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }
	
	function _interopExportWildcard(obj, defaults) { var newObj = defaults({}, obj); delete newObj['default']; return newObj; }
	
	function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }
	
	var _base16 = __webpack_require__(742);
	
	_defaults(exports, _interopExportWildcard(_base16, _defaults));
	
	var _nicinabox = __webpack_require__(2925);
	
	exports.nicinabox = _interopRequire(_nicinabox);

/***/ },
/* 2925 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = {
	  scheme: 'nicinabox',
	  author: 'nicinabox (http://github.com/nicinabox)',
	  base00: '#2A2F3A',
	  base01: '#3C444F',
	  base02: '#4F5A65',
	  base03: '#BEBEBE',
	  base04: '#b0b0b0', // based on ocean theme
	  base05: '#d0d0d0', // based on ocean theme
	  base06: '#FFFFFF',
	  base07: '#f5f5f5', // based on ocean theme
	  base08: '#fb9fb1', // based on ocean theme
	  base09: '#FC6D24',
	  base0A: '#ddb26f', // based on ocean theme
	  base0B: '#A1C659',
	  base0C: '#12cfc0', // based on ocean theme
	  base0D: '#6FB3D2',
	  base0E: '#D381C3',
	  base0F: '#deaf8f' // based on ocean theme
	};
	module.exports = exports['default'];

/***/ },
/* 2926 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = createDevTools;
	
	var _react = _interopRequireWildcard(__webpack_require__(1));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(6));
	
	var _reactRedux = __webpack_require__(5);
	
	var _reduxDevtoolsInstrument = _interopRequireDefault(__webpack_require__(1171));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
	
	function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
	
	function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
	
	function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
	
	function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
	
	function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function logError(type) {
	  if (type === 'NoStore') {
	    console.error('Redux DevTools could not render. You must pass the Redux store ' + 'to <DevTools> either as a "store" prop or by wrapping it in a ' + '<Provider store={store}>.');
	  } else {
	    console.error('Redux DevTools could not render. Did you forget to include ' + 'DevTools.instrument() in your store enhancer chain before ' + 'using createStore()?');
	  }
	}
	
	function createDevTools(children) {
	  var _class, _temp;
	
	  var monitorElement = _react.Children.only(children);
	
	  var monitorProps = monitorElement.props;
	  var Monitor = monitorElement.type;
	  var ConnectedMonitor = (0, _reactRedux.connect)(function (state) {
	    return state;
	  })(Monitor);
	  return _temp = _class = /*#__PURE__*/function (_Component) {
	    _inherits(DevTools, _Component);
	
	    var _super = _createSuper(DevTools);
	
	    function DevTools(props, context) {
	      var _this;
	
	      _classCallCheck(this, DevTools);
	
	      _this = _super.call(this, props, context);
	
	      _defineProperty(_assertThisInitialized(_this), "liftedStore", void 0);
	
	      if (_reactRedux.ReactReduxContext) {
	        if (_this.props.store && !_this.props.store.liftedStore) {
	          logError('NoLiftedStore');
	        }
	
	        return _possibleConstructorReturn(_this);
	      }
	
	      if (!props.store && !context.store) {
	        logError('NoStore');
	        return _possibleConstructorReturn(_this);
	      }
	
	      if (context.store) {
	        _this.liftedStore = context.store.liftedStore;
	      } else {
	        _this.liftedStore = props.store.liftedStore;
	      }
	
	      if (!_this.liftedStore) {
	        logError('NoLiftedStore');
	      }
	
	      return _this;
	    }
	
	    _createClass(DevTools, [{
	      key: "render",
	      value: function render() {
	        if (_reactRedux.ReactReduxContext) {
	          // For react-redux@6
	          if (this.props.store) {
	            if (!this.props.store.liftedStore) {
	              return null;
	            }
	
	            return /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
	              store: this.props.store.liftedStore
	            }, /*#__PURE__*/_react["default"].createElement(ConnectedMonitor, monitorProps));
	          }
	
	          return /*#__PURE__*/_react["default"].createElement(_reactRedux.ReactReduxContext.Consumer, null, function (props) {
	            if (!props || !props.store) {
	              logError('NoStore');
	              return null;
	            }
	
	            if (!props.store.liftedStore) {
	              logError('NoLiftedStore');
	              return null;
	            }
	
	            return /*#__PURE__*/_react["default"].createElement(_reactRedux.Provider, {
	              store: props.store.liftedStore
	            }, /*#__PURE__*/_react["default"].createElement(ConnectedMonitor, monitorProps));
	          });
	        }
	
	        if (!this.liftedStore) {
	          return null;
	        }
	
	        return /*#__PURE__*/_react["default"].createElement(ConnectedMonitor, _extends({}, monitorProps, {
	          store: this.liftedStore
	        }));
	      }
	    }]);
	
	    return DevTools;
	  }(_react.Component), _defineProperty(_class, "contextTypes", {
	    store: _propTypes["default"].object
	  }), _defineProperty(_class, "propTypes", {
	    store: _propTypes["default"].object
	  }), _defineProperty(_class, "instrument", function (options) {
	    return (0, _reduxDevtoolsInstrument["default"])(function (state, action) {
	      return Monitor.update(monitorProps, state, action);
	    }, options);
	  }), _temp;
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 2927 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = persistState;
	
	var _mapValues = _interopRequireDefault(__webpack_require__(2594));
	
	var _identity = _interopRequireDefault(__webpack_require__(377));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }
	
	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	function persistState(sessionId) {
	  var deserializeState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _identity["default"];
	  var deserializeAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity["default"];
	
	  if (!sessionId) {
	    return function (next) {
	      return function () {
	        return next.apply(void 0, arguments);
	      };
	    };
	  }
	
	  function deserialize(state) {
	    return _objectSpread(_objectSpread({}, state), {}, {
	      actionsById: (0, _mapValues["default"])(state.actionsById, function (liftedAction) {
	        return _objectSpread(_objectSpread({}, liftedAction), {}, {
	          action: deserializeAction(liftedAction.action)
	        });
	      }),
	      committedState: deserializeState(state.committedState),
	      computedStates: state.computedStates.map(function (computedState) {
	        return _objectSpread(_objectSpread({}, computedState), {}, {
	          state: deserializeState(computedState.state)
	        });
	      })
	    });
	  }
	
	  return function (next) {
	    return function (reducer, initialState) {
	      var key = "redux-dev-session-".concat(sessionId);
	      var finalInitialState;
	
	      try {
	        var json = localStorage.getItem(key);
	
	        if (json) {
	          finalInitialState = deserialize(JSON.parse(json)) || initialState;
	          next(reducer, initialState);
	        }
	      } catch (e) {
	        console.warn('Could not read debug session from localStorage:', e); // eslint-disable-line no-console
	
	        try {
	          localStorage.removeItem(key);
	        } finally {
	          finalInitialState = undefined;
	        }
	      }
	
	      var store = next(reducer, finalInitialState);
	      return _objectSpread(_objectSpread({}, store), {}, {
	        dispatch: function dispatch(action) {
	          store.dispatch(action);
	
	          try {
	            localStorage.setItem(key, JSON.stringify(store.getState()));
	          } catch (e) {
	            console.warn('Could not write debug session to localStorage:', e); // eslint-disable-line no-console
	          }
	
	          return action;
	        }
	      });
	    };
	  };
	}
	//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ },
/* 2928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.printBuffer = printBuffer;
	
	var _helpers = __webpack_require__(1176);
	
	var _diff = __webpack_require__(2930);
	
	var _diff2 = _interopRequireDefault(_diff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	/**
	 * Get log level string based on supplied params
	 *
	 * @param {string | function | object} level - console[level]
	 * @param {object} action - selected action
	 * @param {array} payload - selected payload
	 * @param {string} type - log entry type
	 *
	 * @returns {string} level
	 */
	function getLogLevel(level, action, payload, type) {
	  switch (typeof level === 'undefined' ? 'undefined' : _typeof(level)) {
	    case 'object':
	      return typeof level[type] === 'function' ? level[type].apply(level, _toConsumableArray(payload)) : level[type];
	    case 'function':
	      return level(action);
	    default:
	      return level;
	  }
	}
	
	function defaultTitleFormatter(options) {
	  var timestamp = options.timestamp,
	      duration = options.duration;
	
	
	  return function (action, time, took) {
	    var parts = ['action'];
	
	    parts.push('%c' + String(action.type));
	    if (timestamp) parts.push('%c@ ' + time);
	    if (duration) parts.push('%c(in ' + took.toFixed(2) + ' ms)');
	
	    return parts.join(' ');
	  };
	}
	
	function printBuffer(buffer, options) {
	  var logger = options.logger,
	      actionTransformer = options.actionTransformer,
	      _options$titleFormatt = options.titleFormatter,
	      titleFormatter = _options$titleFormatt === undefined ? defaultTitleFormatter(options) : _options$titleFormatt,
	      collapsed = options.collapsed,
	      colors = options.colors,
	      level = options.level,
	      diff = options.diff;
	
	
	  buffer.forEach(function (logEntry, key) {
	    var started = logEntry.started,
	        startedTime = logEntry.startedTime,
	        action = logEntry.action,
	        prevState = logEntry.prevState,
	        error = logEntry.error;
	    var took = logEntry.took,
	        nextState = logEntry.nextState;
	
	    var nextEntry = buffer[key + 1];
	
	    if (nextEntry) {
	      nextState = nextEntry.prevState;
	      took = nextEntry.started - started;
	    }
	
	    // Message
	    var formattedAction = actionTransformer(action);
	    var isCollapsed = typeof collapsed === 'function' ? collapsed(function () {
	      return nextState;
	    }, action, logEntry) : collapsed;
	
	    var formattedTime = (0, _helpers.formatTime)(startedTime);
	    var titleCSS = colors.title ? 'color: ' + colors.title(formattedAction) + ';' : '';
	    var headerCSS = ['color: gray; font-weight: lighter;'];
	    headerCSS.push(titleCSS);
	    if (options.timestamp) headerCSS.push('color: gray; font-weight: lighter;');
	    if (options.duration) headerCSS.push('color: gray; font-weight: lighter;');
	    var title = titleFormatter(formattedAction, formattedTime, took);
	
	    // Render
	    try {
	      if (isCollapsed) {
	        if (colors.title) logger.groupCollapsed.apply(logger, ['%c ' + title].concat(headerCSS));else logger.groupCollapsed(title);
	      } else {
	        if (colors.title) logger.group.apply(logger, ['%c ' + title].concat(headerCSS));else logger.group(title);
	      }
	    } catch (e) {
	      logger.log(title);
	    }
	
	    var prevStateLevel = getLogLevel(level, formattedAction, [prevState], 'prevState');
	    var actionLevel = getLogLevel(level, formattedAction, [formattedAction], 'action');
	    var errorLevel = getLogLevel(level, formattedAction, [error, prevState], 'error');
	    var nextStateLevel = getLogLevel(level, formattedAction, [nextState], 'nextState');
	
	    if (prevStateLevel) {
	      if (colors.prevState) logger[prevStateLevel]('%c prev state', 'color: ' + colors.prevState(prevState) + '; font-weight: bold', prevState);else logger[prevStateLevel]('prev state', prevState);
	    }
	
	    if (actionLevel) {
	      if (colors.action) logger[actionLevel]('%c action    ', 'color: ' + colors.action(formattedAction) + '; font-weight: bold', formattedAction);else logger[actionLevel]('action    ', formattedAction);
	    }
	
	    if (error && errorLevel) {
	      if (colors.error) logger[errorLevel]('%c error     ', 'color: ' + colors.error(error, prevState) + '; font-weight: bold;', error);else logger[errorLevel]('error     ', error);
	    }
	
	    if (nextStateLevel) {
	      if (colors.nextState) logger[nextStateLevel]('%c next state', 'color: ' + colors.nextState(nextState) + '; font-weight: bold', nextState);else logger[nextStateLevel]('next state', nextState);
	    }
	
	    if (diff) {
	      (0, _diff2.default)(prevState, nextState, logger, isCollapsed);
	    }
	
	    try {
	      logger.groupEnd();
	    } catch (e) {
	      logger.log('\u2014\u2014 log end \u2014\u2014');
	    }
	  });
	}

/***/ },
/* 2929 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  level: "log",
	  logger: console,
	  logErrors: true,
	  collapsed: undefined,
	  predicate: undefined,
	  duration: false,
	  timestamp: true,
	  stateTransformer: function stateTransformer(state) {
	    return state;
	  },
	  actionTransformer: function actionTransformer(action) {
	    return action;
	  },
	  errorTransformer: function errorTransformer(error) {
	    return error;
	  },
	  colors: {
	    title: function title() {
	      return "inherit";
	    },
	    prevState: function prevState() {
	      return "#9E9E9E";
	    },
	    action: function action() {
	      return "#03A9F4";
	    },
	    nextState: function nextState() {
	      return "#4CAF50";
	    },
	    error: function error() {
	      return "#F20404";
	    }
	  },
	  diff: false,
	  diffPredicate: undefined,
	
	  // Deprecated options
	  transformer: undefined
	};
	module.exports = exports["default"];

/***/ },
/* 2930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = diffLogger;
	
	var _deepDiff = __webpack_require__(2127);
	
	var _deepDiff2 = _interopRequireDefault(_deepDiff);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// https://github.com/flitbit/diff#differences
	var dictionary = {
	  'E': {
	    color: '#2196F3',
	    text: 'CHANGED:'
	  },
	  'N': {
	    color: '#4CAF50',
	    text: 'ADDED:'
	  },
	  'D': {
	    color: '#F44336',
	    text: 'DELETED:'
	  },
	  'A': {
	    color: '#2196F3',
	    text: 'ARRAY:'
	  }
	};
	
	function style(kind) {
	  return 'color: ' + dictionary[kind].color + '; font-weight: bold';
	}
	
	function render(diff) {
	  var kind = diff.kind,
	      path = diff.path,
	      lhs = diff.lhs,
	      rhs = diff.rhs,
	      index = diff.index,
	      item = diff.item;
	
	
	  switch (kind) {
	    case 'E':
	      return [path.join('.'), lhs, '\u2192', rhs];
	    case 'N':
	      return [path.join('.'), rhs];
	    case 'D':
	      return [path.join('.')];
	    case 'A':
	      return [path.join('.') + '[' + index + ']', item];
	    default:
	      return [];
	  }
	}
	
	function diffLogger(prevState, newState, logger, isCollapsed) {
	  var diff = (0, _deepDiff2.default)(prevState, newState);
	
	  try {
	    if (isCollapsed) {
	      logger.groupCollapsed('diff');
	    } else {
	      logger.group('diff');
	    }
	  } catch (e) {
	    logger.log('diff');
	  }
	
	  if (diff) {
	    diff.forEach(function (elem) {
	      var kind = elem.kind;
	
	      var output = render(elem);
	
	      logger.log.apply(logger, ['%c ' + dictionary[kind].text, style(kind)].concat(_toConsumableArray(output)));
	    });
	  } else {
	    logger.log('\u2014\u2014 no diff \u2014\u2014');
	  }
	
	  try {
	    logger.groupEnd();
	  } catch (e) {
	    logger.log('\u2014\u2014 diff end \u2014\u2014 ');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 2931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.logger = exports.defaults = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _core = __webpack_require__(2928);
	
	var _helpers = __webpack_require__(1176);
	
	var _defaults = __webpack_require__(2929);
	
	var _defaults2 = _interopRequireDefault(_defaults);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Creates logger with following options
	 *
	 * @namespace
	 * @param {object} options - options for logger
	 * @param {string | function | object} options.level - console[level]
	 * @param {boolean} options.duration - print duration of each action?
	 * @param {boolean} options.timestamp - print timestamp with each action?
	 * @param {object} options.colors - custom colors
	 * @param {object} options.logger - implementation of the `console` API
	 * @param {boolean} options.logErrors - should errors in action execution be caught, logged, and re-thrown?
	 * @param {boolean} options.collapsed - is group collapsed?
	 * @param {boolean} options.predicate - condition which resolves logger behavior
	 * @param {function} options.stateTransformer - transform state before print
	 * @param {function} options.actionTransformer - transform action before print
	 * @param {function} options.errorTransformer - transform error before print
	 *
	 * @returns {function} logger middleware
	 */
	function createLogger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  var loggerOptions = _extends({}, _defaults2.default, options);
	
	  var logger = loggerOptions.logger,
	      transformer = loggerOptions.transformer,
	      stateTransformer = loggerOptions.stateTransformer,
	      errorTransformer = loggerOptions.errorTransformer,
	      predicate = loggerOptions.predicate,
	      logErrors = loggerOptions.logErrors,
	      diffPredicate = loggerOptions.diffPredicate;
	
	  // Return if 'console' object is not defined
	
	  if (typeof logger === 'undefined') {
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  if (transformer) {
	    console.error('Option \'transformer\' is deprecated, use \'stateTransformer\' instead!'); // eslint-disable-line no-console
	  }
	
	  // Detect if 'createLogger' was passed directly to 'applyMiddleware'.
	  if (options.getState && options.dispatch) {
	    // eslint-disable-next-line no-console
	    console.error('[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n\n// Logger with default options\nimport { logger } from \'redux-logger\'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n\n\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from \'redux-logger\'\n\nconst logger = createLogger({\n  // ...options\n});\n\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n');
	
	    return function () {
	      return function (next) {
	        return function (action) {
	          return next(action);
	        };
	      };
	    };
	  }
	
	  var logBuffer = [];
	
	  return function (_ref) {
	    var getState = _ref.getState;
	    return function (next) {
	      return function (action) {
	        // Exit early if predicate function returns 'false'
	        if (typeof predicate === 'function' && !predicate(getState, action)) {
	          return next(action);
	        }
	
	        var logEntry = {};
	        logBuffer.push(logEntry);
	
	        logEntry.started = _helpers.timer.now();
	        logEntry.startedTime = new Date();
	        logEntry.prevState = stateTransformer(getState());
	        logEntry.action = action;
	
	        var returnedValue = void 0;
	        if (logErrors) {
	          try {
	            returnedValue = next(action);
	          } catch (e) {
	            logEntry.error = errorTransformer(e);
	          }
	        } else {
	          returnedValue = next(action);
	        }
	
	        logEntry.took = _helpers.timer.now() - logEntry.started;
	        logEntry.nextState = stateTransformer(getState());
	
	        var diff = loggerOptions.diff && typeof diffPredicate === 'function' ? diffPredicate(getState, action) : loggerOptions.diff;
	
	        (0, _core.printBuffer)(logBuffer, _extends({}, loggerOptions, { diff: diff }));
	        logBuffer.length = 0;
	
	        if (logEntry.error) throw logEntry.error;
	        return returnedValue;
	      };
	    };
	  };
	}
	
	var defaultLogger = createLogger();
	
	exports.defaults = _defaults2.default;
	exports.logger = defaultLogger;
	exports.default = createLogger;
	module.exports = exports['default'];


/***/ },
/* 2932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(1178);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 2933 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 2934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(1179);
	
	var _isPlainObject = __webpack_require__(379);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(1180);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 2935 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {// This method of obtaining a reference to the global object needs to be
	// kept identical to the way it is obtained in runtime.js
	var g =
	  typeof global === "object" ? global :
	  typeof window === "object" ? window :
	  typeof self === "object" ? self : this;
	
	// Use `getOwnPropertyNames` because not all browsers support calling
	// `hasOwnProperty` on the global `self` object in a worker. See #183.
	var hadRuntime = g.regeneratorRuntime &&
	  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;
	
	// Save the old regeneratorRuntime in case it needs to be restored later.
	var oldRuntime = hadRuntime && g.regeneratorRuntime;
	
	// Force reevalutation of runtime.js.
	g.regeneratorRuntime = undefined;
	
	module.exports = __webpack_require__(1181);
	
	if (hadRuntime) {
	  // Restore the original runtime.
	  g.regeneratorRuntime = oldRuntime;
	} else {
	  // Remove the global property added by runtime.js.
	  try {
	    delete g.regeneratorRuntime;
	  } catch(e) {
	    g.regeneratorRuntime = undefined;
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _extends2 = __webpack_require__(21);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _classCallCheck2 = __webpack_require__(13);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(44);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(17);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(16);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(20);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var TouchFeedback = function (_React$Component) {
	    (0, _inherits3['default'])(TouchFeedback, _React$Component);
	
	    function TouchFeedback() {
	        (0, _classCallCheck3['default'])(this, TouchFeedback);
	
	        var _this = (0, _possibleConstructorReturn3['default'])(this, (TouchFeedback.__proto__ || Object.getPrototypeOf(TouchFeedback)).apply(this, arguments));
	
	        _this.state = {
	            active: false
	        };
	        _this.onTouchStart = function (e) {
	            _this.triggerEvent('TouchStart', true, e);
	        };
	        _this.onTouchMove = function (e) {
	            _this.triggerEvent('TouchMove', false, e);
	        };
	        _this.onTouchEnd = function (e) {
	            _this.triggerEvent('TouchEnd', false, e);
	        };
	        _this.onTouchCancel = function (e) {
	            _this.triggerEvent('TouchCancel', false, e);
	        };
	        _this.onMouseDown = function (e) {
	            // pc simulate mobile
	            _this.triggerEvent('MouseDown', true, e);
	        };
	        _this.onMouseUp = function (e) {
	            _this.triggerEvent('MouseUp', false, e);
	        };
	        _this.onMouseLeave = function (e) {
	            _this.triggerEvent('MouseLeave', false, e);
	        };
	        return _this;
	    }
	
	    (0, _createClass3['default'])(TouchFeedback, [{
	        key: 'componentDidUpdate',
	        value: function componentDidUpdate() {
	            if (this.props.disabled && this.state.active) {
	                this.setState({
	                    active: false
	                });
	            }
	        }
	    }, {
	        key: 'triggerEvent',
	        value: function triggerEvent(type, isActive, ev) {
	            var eventType = 'on' + type;
	            var children = this.props.children;
	
	            if (children.props[eventType]) {
	                children.props[eventType](ev);
	            }
	            if (isActive !== this.state.active) {
	                this.setState({
	                    active: isActive
	                });
	            }
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _props = this.props,
	                children = _props.children,
	                disabled = _props.disabled,
	                activeClassName = _props.activeClassName,
	                activeStyle = _props.activeStyle;
	
	            var events = disabled ? undefined : {
	                onTouchStart: this.onTouchStart,
	                onTouchMove: this.onTouchMove,
	                onTouchEnd: this.onTouchEnd,
	                onTouchCancel: this.onTouchCancel,
	                onMouseDown: this.onMouseDown,
	                onMouseUp: this.onMouseUp,
	                onMouseLeave: this.onMouseLeave
	            };
	            var child = _react2['default'].Children.only(children);
	            if (!disabled && this.state.active) {
	                var _child$props = child.props,
	                    style = _child$props.style,
	                    className = _child$props.className;
	
	                if (activeStyle !== false) {
	                    if (activeStyle) {
	                        style = (0, _extends3['default'])({}, style, activeStyle);
	                    }
	                    className = (0, _classnames2['default'])(className, activeClassName);
	                }
	                return _react2['default'].cloneElement(child, (0, _extends3['default'])({ className: className,
	                    style: style }, events));
	            }
	            return _react2['default'].cloneElement(child, events);
	        }
	    }]);
	    return TouchFeedback;
	}(_react2['default'].Component);
	
	exports['default'] = TouchFeedback;
	
	TouchFeedback.defaultProps = {
	    disabled: false
	};
	module.exports = exports['default'];

/***/ },
/* 2937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _TouchFeedback = __webpack_require__(2936);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_TouchFeedback)['default'];
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	module.exports = exports['default'];

/***/ },
/* 2938 */
/***/ function(module, exports) {

	'use strict';
	
	function shallowEqualArrays(arrA, arrB) {
	  if (arrA === arrB) {
	    return true;
	  }
	
	  if (!arrA || !arrB) {
	    return false;
	  }
	
	  var len = arrA.length;
	
	  if (arrB.length !== len) {
	    return false;
	  }
	
	  for (var i = 0; i < len; i++) {
	    if (arrA[i] !== arrB[i]) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqualArrays;


/***/ },
/* 2939 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 2940 */
/***/ function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ },
/* 2941 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 2942 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;// TinyColor v1.4.2
	// https://github.com/bgrins/TinyColor
	// Brian Grinstead, MIT License
	
	(function(Math) {
	
	var trimLeft = /^\s+/,
	    trimRight = /\s+$/,
	    tinyCounter = 0,
	    mathRound = Math.round,
	    mathMin = Math.min,
	    mathMax = Math.max,
	    mathRandom = Math.random;
	
	function tinycolor (color, opts) {
	
	    color = (color) ? color : '';
	    opts = opts || { };
	
	    // If input is already a tinycolor, return itself
	    if (color instanceof tinycolor) {
	       return color;
	    }
	    // If we are called as a function, call using new instead
	    if (!(this instanceof tinycolor)) {
	        return new tinycolor(color, opts);
	    }
	
	    var rgb = inputToRGB(color);
	    this._originalInput = color,
	    this._r = rgb.r,
	    this._g = rgb.g,
	    this._b = rgb.b,
	    this._a = rgb.a,
	    this._roundA = mathRound(100*this._a) / 100,
	    this._format = opts.format || rgb.format;
	    this._gradientType = opts.gradientType;
	
	    // Don't let the range of [0,255] come back in [0,1].
	    // Potentially lose a little bit of precision here, but will fix issues where
	    // .5 gets interpreted as half of the total, instead of half of 1
	    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
	    if (this._r < 1) { this._r = mathRound(this._r); }
	    if (this._g < 1) { this._g = mathRound(this._g); }
	    if (this._b < 1) { this._b = mathRound(this._b); }
	
	    this._ok = rgb.ok;
	    this._tc_id = tinyCounter++;
	}
	
	tinycolor.prototype = {
	    isDark: function() {
	        return this.getBrightness() < 128;
	    },
	    isLight: function() {
	        return !this.isDark();
	    },
	    isValid: function() {
	        return this._ok;
	    },
	    getOriginalInput: function() {
	      return this._originalInput;
	    },
	    getFormat: function() {
	        return this._format;
	    },
	    getAlpha: function() {
	        return this._a;
	    },
	    getBrightness: function() {
	        //http://www.w3.org/TR/AERT#color-contrast
	        var rgb = this.toRgb();
	        return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
	    },
	    getLuminance: function() {
	        //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
	        var rgb = this.toRgb();
	        var RsRGB, GsRGB, BsRGB, R, G, B;
	        RsRGB = rgb.r/255;
	        GsRGB = rgb.g/255;
	        BsRGB = rgb.b/255;
	
	        if (RsRGB <= 0.03928) {R = RsRGB / 12.92;} else {R = Math.pow(((RsRGB + 0.055) / 1.055), 2.4);}
	        if (GsRGB <= 0.03928) {G = GsRGB / 12.92;} else {G = Math.pow(((GsRGB + 0.055) / 1.055), 2.4);}
	        if (BsRGB <= 0.03928) {B = BsRGB / 12.92;} else {B = Math.pow(((BsRGB + 0.055) / 1.055), 2.4);}
	        return (0.2126 * R) + (0.7152 * G) + (0.0722 * B);
	    },
	    setAlpha: function(value) {
	        this._a = boundAlpha(value);
	        this._roundA = mathRound(100*this._a) / 100;
	        return this;
	    },
	    toHsv: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this._a };
	    },
	    toHsvString: function() {
	        var hsv = rgbToHsv(this._r, this._g, this._b);
	        var h = mathRound(hsv.h * 360), s = mathRound(hsv.s * 100), v = mathRound(hsv.v * 100);
	        return (this._a == 1) ?
	          "hsv("  + h + ", " + s + "%, " + v + "%)" :
	          "hsva(" + h + ", " + s + "%, " + v + "%, "+ this._roundA + ")";
	    },
	    toHsl: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this._a };
	    },
	    toHslString: function() {
	        var hsl = rgbToHsl(this._r, this._g, this._b);
	        var h = mathRound(hsl.h * 360), s = mathRound(hsl.s * 100), l = mathRound(hsl.l * 100);
	        return (this._a == 1) ?
	          "hsl("  + h + ", " + s + "%, " + l + "%)" :
	          "hsla(" + h + ", " + s + "%, " + l + "%, "+ this._roundA + ")";
	    },
	    toHex: function(allow3Char) {
	        return rgbToHex(this._r, this._g, this._b, allow3Char);
	    },
	    toHexString: function(allow3Char) {
	        return '#' + this.toHex(allow3Char);
	    },
	    toHex8: function(allow4Char) {
	        return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
	    },
	    toHex8String: function(allow4Char) {
	        return '#' + this.toHex8(allow4Char);
	    },
	    toRgb: function() {
	        return { r: mathRound(this._r), g: mathRound(this._g), b: mathRound(this._b), a: this._a };
	    },
	    toRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ")" :
	          "rgba(" + mathRound(this._r) + ", " + mathRound(this._g) + ", " + mathRound(this._b) + ", " + this._roundA + ")";
	    },
	    toPercentageRgb: function() {
	        return { r: mathRound(bound01(this._r, 255) * 100) + "%", g: mathRound(bound01(this._g, 255) * 100) + "%", b: mathRound(bound01(this._b, 255) * 100) + "%", a: this._a };
	    },
	    toPercentageRgbString: function() {
	        return (this._a == 1) ?
	          "rgb("  + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%)" :
	          "rgba(" + mathRound(bound01(this._r, 255) * 100) + "%, " + mathRound(bound01(this._g, 255) * 100) + "%, " + mathRound(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
	    },
	    toName: function() {
	        if (this._a === 0) {
	            return "transparent";
	        }
	
	        if (this._a < 1) {
	            return false;
	        }
	
	        return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
	    },
	    toFilter: function(secondColor) {
	        var hex8String = '#' + rgbaToArgbHex(this._r, this._g, this._b, this._a);
	        var secondHex8String = hex8String;
	        var gradientType = this._gradientType ? "GradientType = 1, " : "";
	
	        if (secondColor) {
	            var s = tinycolor(secondColor);
	            secondHex8String = '#' + rgbaToArgbHex(s._r, s._g, s._b, s._a);
	        }
	
	        return "progid:DXImageTransform.Microsoft.gradient("+gradientType+"startColorstr="+hex8String+",endColorstr="+secondHex8String+")";
	    },
	    toString: function(format) {
	        var formatSet = !!format;
	        format = format || this._format;
	
	        var formattedString = false;
	        var hasAlpha = this._a < 1 && this._a >= 0;
	        var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
	
	        if (needsAlphaFormat) {
	            // Special case for "transparent", all other non-alpha formats
	            // will return rgba when there is transparency.
	            if (format === "name" && this._a === 0) {
	                return this.toName();
	            }
	            return this.toRgbString();
	        }
	        if (format === "rgb") {
	            formattedString = this.toRgbString();
	        }
	        if (format === "prgb") {
	            formattedString = this.toPercentageRgbString();
	        }
	        if (format === "hex" || format === "hex6") {
	            formattedString = this.toHexString();
	        }
	        if (format === "hex3") {
	            formattedString = this.toHexString(true);
	        }
	        if (format === "hex4") {
	            formattedString = this.toHex8String(true);
	        }
	        if (format === "hex8") {
	            formattedString = this.toHex8String();
	        }
	        if (format === "name") {
	            formattedString = this.toName();
	        }
	        if (format === "hsl") {
	            formattedString = this.toHslString();
	        }
	        if (format === "hsv") {
	            formattedString = this.toHsvString();
	        }
	
	        return formattedString || this.toHexString();
	    },
	    clone: function() {
	        return tinycolor(this.toString());
	    },
	
	    _applyModification: function(fn, args) {
	        var color = fn.apply(null, [this].concat([].slice.call(args)));
	        this._r = color._r;
	        this._g = color._g;
	        this._b = color._b;
	        this.setAlpha(color._a);
	        return this;
	    },
	    lighten: function() {
	        return this._applyModification(lighten, arguments);
	    },
	    brighten: function() {
	        return this._applyModification(brighten, arguments);
	    },
	    darken: function() {
	        return this._applyModification(darken, arguments);
	    },
	    desaturate: function() {
	        return this._applyModification(desaturate, arguments);
	    },
	    saturate: function() {
	        return this._applyModification(saturate, arguments);
	    },
	    greyscale: function() {
	        return this._applyModification(greyscale, arguments);
	    },
	    spin: function() {
	        return this._applyModification(spin, arguments);
	    },
	
	    _applyCombination: function(fn, args) {
	        return fn.apply(null, [this].concat([].slice.call(args)));
	    },
	    analogous: function() {
	        return this._applyCombination(analogous, arguments);
	    },
	    complement: function() {
	        return this._applyCombination(complement, arguments);
	    },
	    monochromatic: function() {
	        return this._applyCombination(monochromatic, arguments);
	    },
	    splitcomplement: function() {
	        return this._applyCombination(splitcomplement, arguments);
	    },
	    triad: function() {
	        return this._applyCombination(triad, arguments);
	    },
	    tetrad: function() {
	        return this._applyCombination(tetrad, arguments);
	    }
	};
	
	// If input is an object, force 1 into "1.0" to handle ratios properly
	// String input requires "1.0" as input, so 1 will be treated as 1
	tinycolor.fromRatio = function(color, opts) {
	    if (typeof color == "object") {
	        var newColor = {};
	        for (var i in color) {
	            if (color.hasOwnProperty(i)) {
	                if (i === "a") {
	                    newColor[i] = color[i];
	                }
	                else {
	                    newColor[i] = convertToPercentage(color[i]);
	                }
	            }
	        }
	        color = newColor;
	    }
	
	    return tinycolor(color, opts);
	};
	
	// Given a string or object, convert that input to RGB
	// Possible string inputs:
	//
	//     "red"
	//     "#f00" or "f00"
	//     "#ff0000" or "ff0000"
	//     "#ff000000" or "ff000000"
	//     "rgb 255 0 0" or "rgb (255, 0, 0)"
	//     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
	//     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
	//     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
	//     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
	//     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
	//     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
	//
	function inputToRGB(color) {
	
	    var rgb = { r: 0, g: 0, b: 0 };
	    var a = 1;
	    var s = null;
	    var v = null;
	    var l = null;
	    var ok = false;
	    var format = false;
	
	    if (typeof color == "string") {
	        color = stringInputToObject(color);
	    }
	
	    if (typeof color == "object") {
	        if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
	            rgb = rgbToRgb(color.r, color.g, color.b);
	            ok = true;
	            format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
	            s = convertToPercentage(color.s);
	            v = convertToPercentage(color.v);
	            rgb = hsvToRgb(color.h, s, v);
	            ok = true;
	            format = "hsv";
	        }
	        else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
	            s = convertToPercentage(color.s);
	            l = convertToPercentage(color.l);
	            rgb = hslToRgb(color.h, s, l);
	            ok = true;
	            format = "hsl";
	        }
	
	        if (color.hasOwnProperty("a")) {
	            a = color.a;
	        }
	    }
	
	    a = boundAlpha(a);
	
	    return {
	        ok: ok,
	        format: color.format || format,
	        r: mathMin(255, mathMax(rgb.r, 0)),
	        g: mathMin(255, mathMax(rgb.g, 0)),
	        b: mathMin(255, mathMax(rgb.b, 0)),
	        a: a
	    };
	}
	
	
	// Conversion Functions
	// --------------------
	
	// `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
	// <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>
	
	// `rgbToRgb`
	// Handle bounds / percentage checking to conform to CSS color spec
	// <http://www.w3.org/TR/css3-color/>
	// *Assumes:* r, g, b in [0, 255] or [0, 1]
	// *Returns:* { r, g, b } in [0, 255]
	function rgbToRgb(r, g, b){
	    return {
	        r: bound01(r, 255) * 255,
	        g: bound01(g, 255) * 255,
	        b: bound01(b, 255) * 255
	    };
	}
	
	// `rgbToHsl`
	// Converts an RGB color value to HSL.
	// *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
	// *Returns:* { h, s, l } in [0,1]
	function rgbToHsl(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, l = (max + min) / 2;
	
	    if(max == min) {
	        h = s = 0; // achromatic
	    }
	    else {
	        var d = max - min;
	        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	
	        h /= 6;
	    }
	
	    return { h: h, s: s, l: l };
	}
	
	// `hslToRgb`
	// Converts an HSL color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	function hslToRgb(h, s, l) {
	    var r, g, b;
	
	    h = bound01(h, 360);
	    s = bound01(s, 100);
	    l = bound01(l, 100);
	
	    function hue2rgb(p, q, t) {
	        if(t < 0) t += 1;
	        if(t > 1) t -= 1;
	        if(t < 1/6) return p + (q - p) * 6 * t;
	        if(t < 1/2) return q;
	        if(t < 2/3) return p + (q - p) * (2/3 - t) * 6;
	        return p;
	    }
	
	    if(s === 0) {
	        r = g = b = l; // achromatic
	    }
	    else {
	        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
	        var p = 2 * l - q;
	        r = hue2rgb(p, q, h + 1/3);
	        g = hue2rgb(p, q, h);
	        b = hue2rgb(p, q, h - 1/3);
	    }
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHsv`
	// Converts an RGB color value to HSV
	// *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
	// *Returns:* { h, s, v } in [0,1]
	function rgbToHsv(r, g, b) {
	
	    r = bound01(r, 255);
	    g = bound01(g, 255);
	    b = bound01(b, 255);
	
	    var max = mathMax(r, g, b), min = mathMin(r, g, b);
	    var h, s, v = max;
	
	    var d = max - min;
	    s = max === 0 ? 0 : d / max;
	
	    if(max == min) {
	        h = 0; // achromatic
	    }
	    else {
	        switch(max) {
	            case r: h = (g - b) / d + (g < b ? 6 : 0); break;
	            case g: h = (b - r) / d + 2; break;
	            case b: h = (r - g) / d + 4; break;
	        }
	        h /= 6;
	    }
	    return { h: h, s: s, v: v };
	}
	
	// `hsvToRgb`
	// Converts an HSV color value to RGB.
	// *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
	// *Returns:* { r, g, b } in the set [0, 255]
	 function hsvToRgb(h, s, v) {
	
	    h = bound01(h, 360) * 6;
	    s = bound01(s, 100);
	    v = bound01(v, 100);
	
	    var i = Math.floor(h),
	        f = h - i,
	        p = v * (1 - s),
	        q = v * (1 - f * s),
	        t = v * (1 - (1 - f) * s),
	        mod = i % 6,
	        r = [v, q, p, p, t, v][mod],
	        g = [t, v, v, q, p, p][mod],
	        b = [p, p, t, v, v, q][mod];
	
	    return { r: r * 255, g: g * 255, b: b * 255 };
	}
	
	// `rgbToHex`
	// Converts an RGB color to hex
	// Assumes r, g, and b are contained in the set [0, 255]
	// Returns a 3 or 6 character hex
	function rgbToHex(r, g, b, allow3Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    // Return a 3 character hex if possible
	    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToHex`
	// Converts an RGBA color plus alpha transparency to hex
	// Assumes r, g, b are contained in the set [0, 255] and
	// a in [0, 1]. Returns a 4 or 8 character rgba hex
	function rgbaToHex(r, g, b, a, allow4Char) {
	
	    var hex = [
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16)),
	        pad2(convertDecimalToHex(a))
	    ];
	
	    // Return a 4 character hex if possible
	    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
	        return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
	    }
	
	    return hex.join("");
	}
	
	// `rgbaToArgbHex`
	// Converts an RGBA color to an ARGB Hex8 string
	// Rarely used, but required for "toFilter()"
	function rgbaToArgbHex(r, g, b, a) {
	
	    var hex = [
	        pad2(convertDecimalToHex(a)),
	        pad2(mathRound(r).toString(16)),
	        pad2(mathRound(g).toString(16)),
	        pad2(mathRound(b).toString(16))
	    ];
	
	    return hex.join("");
	}
	
	// `equals`
	// Can be called with any tinycolor input
	tinycolor.equals = function (color1, color2) {
	    if (!color1 || !color2) { return false; }
	    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
	};
	
	tinycolor.random = function() {
	    return tinycolor.fromRatio({
	        r: mathRandom(),
	        g: mathRandom(),
	        b: mathRandom()
	    });
	};
	
	
	// Modification Functions
	// ----------------------
	// Thanks to less.js for some of the basics here
	// <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>
	
	function desaturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s -= amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function saturate(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.s += amount / 100;
	    hsl.s = clamp01(hsl.s);
	    return tinycolor(hsl);
	}
	
	function greyscale(color) {
	    return tinycolor(color).desaturate(100);
	}
	
	function lighten (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l += amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	function brighten(color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var rgb = tinycolor(color).toRgb();
	    rgb.r = mathMax(0, mathMin(255, rgb.r - mathRound(255 * - (amount / 100))));
	    rgb.g = mathMax(0, mathMin(255, rgb.g - mathRound(255 * - (amount / 100))));
	    rgb.b = mathMax(0, mathMin(255, rgb.b - mathRound(255 * - (amount / 100))));
	    return tinycolor(rgb);
	}
	
	function darken (color, amount) {
	    amount = (amount === 0) ? 0 : (amount || 10);
	    var hsl = tinycolor(color).toHsl();
	    hsl.l -= amount / 100;
	    hsl.l = clamp01(hsl.l);
	    return tinycolor(hsl);
	}
	
	// Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
	// Values outside of this range will be wrapped into this range.
	function spin(color, amount) {
	    var hsl = tinycolor(color).toHsl();
	    var hue = (hsl.h + amount) % 360;
	    hsl.h = hue < 0 ? 360 + hue : hue;
	    return tinycolor(hsl);
	}
	
	// Combination Functions
	// ---------------------
	// Thanks to jQuery xColor for some of the ideas behind these
	// <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>
	
	function complement(color) {
	    var hsl = tinycolor(color).toHsl();
	    hsl.h = (hsl.h + 180) % 360;
	    return tinycolor(hsl);
	}
	
	function triad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 120) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 240) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function tetrad(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 90) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 180) % 360, s: hsl.s, l: hsl.l }),
	        tinycolor({ h: (h + 270) % 360, s: hsl.s, l: hsl.l })
	    ];
	}
	
	function splitcomplement(color) {
	    var hsl = tinycolor(color).toHsl();
	    var h = hsl.h;
	    return [
	        tinycolor(color),
	        tinycolor({ h: (h + 72) % 360, s: hsl.s, l: hsl.l}),
	        tinycolor({ h: (h + 216) % 360, s: hsl.s, l: hsl.l})
	    ];
	}
	
	function analogous(color, results, slices) {
	    results = results || 6;
	    slices = slices || 30;
	
	    var hsl = tinycolor(color).toHsl();
	    var part = 360 / slices;
	    var ret = [tinycolor(color)];
	
	    for (hsl.h = ((hsl.h - (part * results >> 1)) + 720) % 360; --results; ) {
	        hsl.h = (hsl.h + part) % 360;
	        ret.push(tinycolor(hsl));
	    }
	    return ret;
	}
	
	function monochromatic(color, results) {
	    results = results || 6;
	    var hsv = tinycolor(color).toHsv();
	    var h = hsv.h, s = hsv.s, v = hsv.v;
	    var ret = [];
	    var modification = 1 / results;
	
	    while (results--) {
	        ret.push(tinycolor({ h: h, s: s, v: v}));
	        v = (v + modification) % 1;
	    }
	
	    return ret;
	}
	
	// Utility Functions
	// ---------------------
	
	tinycolor.mix = function(color1, color2, amount) {
	    amount = (amount === 0) ? 0 : (amount || 50);
	
	    var rgb1 = tinycolor(color1).toRgb();
	    var rgb2 = tinycolor(color2).toRgb();
	
	    var p = amount / 100;
	
	    var rgba = {
	        r: ((rgb2.r - rgb1.r) * p) + rgb1.r,
	        g: ((rgb2.g - rgb1.g) * p) + rgb1.g,
	        b: ((rgb2.b - rgb1.b) * p) + rgb1.b,
	        a: ((rgb2.a - rgb1.a) * p) + rgb1.a
	    };
	
	    return tinycolor(rgba);
	};
	
	
	// Readability Functions
	// ---------------------
	// <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)
	
	// `contrast`
	// Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
	tinycolor.readability = function(color1, color2) {
	    var c1 = tinycolor(color1);
	    var c2 = tinycolor(color2);
	    return (Math.max(c1.getLuminance(),c2.getLuminance())+0.05) / (Math.min(c1.getLuminance(),c2.getLuminance())+0.05);
	};
	
	// `isReadable`
	// Ensure that foreground and background color combinations meet WCAG2 guidelines.
	// The third argument is an optional Object.
	//      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
	//      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
	// If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.
	
	// *Example*
	//    tinycolor.isReadable("#000", "#111") => false
	//    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
	tinycolor.isReadable = function(color1, color2, wcag2) {
	    var readability = tinycolor.readability(color1, color2);
	    var wcag2Parms, out;
	
	    out = false;
	
	    wcag2Parms = validateWCAG2Parms(wcag2);
	    switch (wcag2Parms.level + wcag2Parms.size) {
	        case "AAsmall":
	        case "AAAlarge":
	            out = readability >= 4.5;
	            break;
	        case "AAlarge":
	            out = readability >= 3;
	            break;
	        case "AAAsmall":
	            out = readability >= 7;
	            break;
	    }
	    return out;
	
	};
	
	// `mostReadable`
	// Given a base color and a list of possible foreground or background
	// colors for that base, returns the most readable color.
	// Optionally returns Black or White if the most readable color is unreadable.
	// *Example*
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
	//    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
	//    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
	tinycolor.mostReadable = function(baseColor, colorList, args) {
	    var bestColor = null;
	    var bestScore = 0;
	    var readability;
	    var includeFallbackColors, level, size ;
	    args = args || {};
	    includeFallbackColors = args.includeFallbackColors ;
	    level = args.level;
	    size = args.size;
	
	    for (var i= 0; i < colorList.length ; i++) {
	        readability = tinycolor.readability(baseColor, colorList[i]);
	        if (readability > bestScore) {
	            bestScore = readability;
	            bestColor = tinycolor(colorList[i]);
	        }
	    }
	
	    if (tinycolor.isReadable(baseColor, bestColor, {"level":level,"size":size}) || !includeFallbackColors) {
	        return bestColor;
	    }
	    else {
	        args.includeFallbackColors=false;
	        return tinycolor.mostReadable(baseColor,["#fff", "#000"],args);
	    }
	};
	
	
	// Big List of Colors
	// ------------------
	// <http://www.w3.org/TR/css3-color/#svg-color>
	var names = tinycolor.names = {
	    aliceblue: "f0f8ff",
	    antiquewhite: "faebd7",
	    aqua: "0ff",
	    aquamarine: "7fffd4",
	    azure: "f0ffff",
	    beige: "f5f5dc",
	    bisque: "ffe4c4",
	    black: "000",
	    blanchedalmond: "ffebcd",
	    blue: "00f",
	    blueviolet: "8a2be2",
	    brown: "a52a2a",
	    burlywood: "deb887",
	    burntsienna: "ea7e5d",
	    cadetblue: "5f9ea0",
	    chartreuse: "7fff00",
	    chocolate: "d2691e",
	    coral: "ff7f50",
	    cornflowerblue: "6495ed",
	    cornsilk: "fff8dc",
	    crimson: "dc143c",
	    cyan: "0ff",
	    darkblue: "00008b",
	    darkcyan: "008b8b",
	    darkgoldenrod: "b8860b",
	    darkgray: "a9a9a9",
	    darkgreen: "006400",
	    darkgrey: "a9a9a9",
	    darkkhaki: "bdb76b",
	    darkmagenta: "8b008b",
	    darkolivegreen: "556b2f",
	    darkorange: "ff8c00",
	    darkorchid: "9932cc",
	    darkred: "8b0000",
	    darksalmon: "e9967a",
	    darkseagreen: "8fbc8f",
	    darkslateblue: "483d8b",
	    darkslategray: "2f4f4f",
	    darkslategrey: "2f4f4f",
	    darkturquoise: "00ced1",
	    darkviolet: "9400d3",
	    deeppink: "ff1493",
	    deepskyblue: "00bfff",
	    dimgray: "696969",
	    dimgrey: "696969",
	    dodgerblue: "1e90ff",
	    firebrick: "b22222",
	    floralwhite: "fffaf0",
	    forestgreen: "228b22",
	    fuchsia: "f0f",
	    gainsboro: "dcdcdc",
	    ghostwhite: "f8f8ff",
	    gold: "ffd700",
	    goldenrod: "daa520",
	    gray: "808080",
	    green: "008000",
	    greenyellow: "adff2f",
	    grey: "808080",
	    honeydew: "f0fff0",
	    hotpink: "ff69b4",
	    indianred: "cd5c5c",
	    indigo: "4b0082",
	    ivory: "fffff0",
	    khaki: "f0e68c",
	    lavender: "e6e6fa",
	    lavenderblush: "fff0f5",
	    lawngreen: "7cfc00",
	    lemonchiffon: "fffacd",
	    lightblue: "add8e6",
	    lightcoral: "f08080",
	    lightcyan: "e0ffff",
	    lightgoldenrodyellow: "fafad2",
	    lightgray: "d3d3d3",
	    lightgreen: "90ee90",
	    lightgrey: "d3d3d3",
	    lightpink: "ffb6c1",
	    lightsalmon: "ffa07a",
	    lightseagreen: "20b2aa",
	    lightskyblue: "87cefa",
	    lightslategray: "789",
	    lightslategrey: "789",
	    lightsteelblue: "b0c4de",
	    lightyellow: "ffffe0",
	    lime: "0f0",
	    limegreen: "32cd32",
	    linen: "faf0e6",
	    magenta: "f0f",
	    maroon: "800000",
	    mediumaquamarine: "66cdaa",
	    mediumblue: "0000cd",
	    mediumorchid: "ba55d3",
	    mediumpurple: "9370db",
	    mediumseagreen: "3cb371",
	    mediumslateblue: "7b68ee",
	    mediumspringgreen: "00fa9a",
	    mediumturquoise: "48d1cc",
	    mediumvioletred: "c71585",
	    midnightblue: "191970",
	    mintcream: "f5fffa",
	    mistyrose: "ffe4e1",
	    moccasin: "ffe4b5",
	    navajowhite: "ffdead",
	    navy: "000080",
	    oldlace: "fdf5e6",
	    olive: "808000",
	    olivedrab: "6b8e23",
	    orange: "ffa500",
	    orangered: "ff4500",
	    orchid: "da70d6",
	    palegoldenrod: "eee8aa",
	    palegreen: "98fb98",
	    paleturquoise: "afeeee",
	    palevioletred: "db7093",
	    papayawhip: "ffefd5",
	    peachpuff: "ffdab9",
	    peru: "cd853f",
	    pink: "ffc0cb",
	    plum: "dda0dd",
	    powderblue: "b0e0e6",
	    purple: "800080",
	    rebeccapurple: "663399",
	    red: "f00",
	    rosybrown: "bc8f8f",
	    royalblue: "4169e1",
	    saddlebrown: "8b4513",
	    salmon: "fa8072",
	    sandybrown: "f4a460",
	    seagreen: "2e8b57",
	    seashell: "fff5ee",
	    sienna: "a0522d",
	    silver: "c0c0c0",
	    skyblue: "87ceeb",
	    slateblue: "6a5acd",
	    slategray: "708090",
	    slategrey: "708090",
	    snow: "fffafa",
	    springgreen: "00ff7f",
	    steelblue: "4682b4",
	    tan: "d2b48c",
	    teal: "008080",
	    thistle: "d8bfd8",
	    tomato: "ff6347",
	    turquoise: "40e0d0",
	    violet: "ee82ee",
	    wheat: "f5deb3",
	    white: "fff",
	    whitesmoke: "f5f5f5",
	    yellow: "ff0",
	    yellowgreen: "9acd32"
	};
	
	// Make it easy to access colors via `hexNames[hex]`
	var hexNames = tinycolor.hexNames = flip(names);
	
	
	// Utilities
	// ---------
	
	// `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
	function flip(o) {
	    var flipped = { };
	    for (var i in o) {
	        if (o.hasOwnProperty(i)) {
	            flipped[o[i]] = i;
	        }
	    }
	    return flipped;
	}
	
	// Return a valid alpha value [0,1] with all invalid values being set to 1
	function boundAlpha(a) {
	    a = parseFloat(a);
	
	    if (isNaN(a) || a < 0 || a > 1) {
	        a = 1;
	    }
	
	    return a;
	}
	
	// Take input from [0, n] and return it as [0, 1]
	function bound01(n, max) {
	    if (isOnePointZero(n)) { n = "100%"; }
	
	    var processPercent = isPercentage(n);
	    n = mathMin(max, mathMax(0, parseFloat(n)));
	
	    // Automatically convert percentage into number
	    if (processPercent) {
	        n = parseInt(n * max, 10) / 100;
	    }
	
	    // Handle floating point rounding errors
	    if ((Math.abs(n - max) < 0.000001)) {
	        return 1;
	    }
	
	    // Convert into [0, 1] range if it isn't already
	    return (n % max) / parseFloat(max);
	}
	
	// Force a number between 0 and 1
	function clamp01(val) {
	    return mathMin(1, mathMax(0, val));
	}
	
	// Parse a base-16 hex value into a base-10 integer
	function parseIntFromHex(val) {
	    return parseInt(val, 16);
	}
	
	// Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
	// <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
	function isOnePointZero(n) {
	    return typeof n == "string" && n.indexOf('.') != -1 && parseFloat(n) === 1;
	}
	
	// Check to see if string passed in is a percentage
	function isPercentage(n) {
	    return typeof n === "string" && n.indexOf('%') != -1;
	}
	
	// Force a hex value to have 2 characters
	function pad2(c) {
	    return c.length == 1 ? '0' + c : '' + c;
	}
	
	// Replace a decimal with it's percentage value
	function convertToPercentage(n) {
	    if (n <= 1) {
	        n = (n * 100) + "%";
	    }
	
	    return n;
	}
	
	// Converts a decimal to a hex value
	function convertDecimalToHex(d) {
	    return Math.round(parseFloat(d) * 255).toString(16);
	}
	// Converts a hex value to a decimal
	function convertHexToDecimal(h) {
	    return (parseIntFromHex(h) / 255);
	}
	
	var matchers = (function() {
	
	    // <http://www.w3.org/TR/css3-values/#integers>
	    var CSS_INTEGER = "[-\\+]?\\d+%?";
	
	    // <http://www.w3.org/TR/css3-values/#number-value>
	    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
	
	    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
	    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";
	
	    // Actual matching.
	    // Parentheses and commas are optional, but not required.
	    // Whitespace can take the place of commas or opening paren
	    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
	
	    return {
	        CSS_UNIT: new RegExp(CSS_UNIT),
	        rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
	        rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
	        hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
	        hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
	        hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
	        hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
	        hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
	        hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
	        hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
	    };
	})();
	
	// `isValidCSSUnit`
	// Take in a single string / number and check to see if it looks like a CSS unit
	// (see `matchers` above for definition).
	function isValidCSSUnit(color) {
	    return !!matchers.CSS_UNIT.exec(color);
	}
	
	// `stringInputToObject`
	// Permissive string parsing.  Take in a number of formats, and output an object
	// based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
	function stringInputToObject(color) {
	
	    color = color.replace(trimLeft,'').replace(trimRight, '').toLowerCase();
	    var named = false;
	    if (names[color]) {
	        color = names[color];
	        named = true;
	    }
	    else if (color == 'transparent') {
	        return { r: 0, g: 0, b: 0, a: 0, format: "name" };
	    }
	
	    // Try to match string input using regular expressions.
	    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
	    // Just return an object and let the conversion functions handle that.
	    // This way the result will be the same whether the tinycolor is initialized with string or object.
	    var match;
	    if ((match = matchers.rgb.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3] };
	    }
	    if ((match = matchers.rgba.exec(color))) {
	        return { r: match[1], g: match[2], b: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsl.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3] };
	    }
	    if ((match = matchers.hsla.exec(color))) {
	        return { h: match[1], s: match[2], l: match[3], a: match[4] };
	    }
	    if ((match = matchers.hsv.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3] };
	    }
	    if ((match = matchers.hsva.exec(color))) {
	        return { h: match[1], s: match[2], v: match[3], a: match[4] };
	    }
	    if ((match = matchers.hex8.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            a: convertHexToDecimal(match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex6.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1]),
	            g: parseIntFromHex(match[2]),
	            b: parseIntFromHex(match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	    if ((match = matchers.hex4.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            a: convertHexToDecimal(match[4] + '' + match[4]),
	            format: named ? "name" : "hex8"
	        };
	    }
	    if ((match = matchers.hex3.exec(color))) {
	        return {
	            r: parseIntFromHex(match[1] + '' + match[1]),
	            g: parseIntFromHex(match[2] + '' + match[2]),
	            b: parseIntFromHex(match[3] + '' + match[3]),
	            format: named ? "name" : "hex"
	        };
	    }
	
	    return false;
	}
	
	function validateWCAG2Parms(parms) {
	    // return valid WCAG2 parms for isReadable.
	    // If input parms are invalid, return {"level":"AA", "size":"small"}
	    var level, size;
	    parms = parms || {"level":"AA", "size":"small"};
	    level = (parms.level || "AA").toUpperCase();
	    size = (parms.size || "small").toLowerCase();
	    if (level !== "AA" && level !== "AAA") {
	        level = "AA";
	    }
	    if (size !== "small" && size !== "large") {
	        size = "small";
	    }
	    return {"level":level, "size":size};
	}
	
	// Node: Export function
	if (typeof module !== "undefined" && module.exports) {
	    module.exports = tinycolor;
	}
	// AMD/requirejs: Define the module
	else if (true) {
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {return tinycolor;}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	}
	// Browser: Expose to window
	else {
	    window.tinycolor = tinycolor;
	}
	
	})(Math);


/***/ },
/* 2943 */
/***/ function(module, exports) {

	
	module.exports = function () {
	  var selection = document.getSelection();
	  if (!selection.rangeCount) {
	    return function () {};
	  }
	  var active = document.activeElement;
	
	  var ranges = [];
	  for (var i = 0; i < selection.rangeCount; i++) {
	    ranges.push(selection.getRangeAt(i));
	  }
	
	  switch (active.tagName.toUpperCase()) { // .toUpperCase handles XHTML
	    case 'INPUT':
	    case 'TEXTAREA':
	      active.blur();
	      break;
	
	    default:
	      active = null;
	      break;
	  }
	
	  selection.removeAllRanges();
	  return function () {
	    selection.type === 'Caret' &&
	    selection.removeAllRanges();
	
	    if (!selection.rangeCount) {
	      ranges.forEach(function(range) {
	        selection.addRange(range);
	      });
	    }
	
	    active &&
	    active.focus();
	  };
	};


/***/ },
/* 2944 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/////////////////////////////////////////////////////////////////////////////////
	/* UAParser.js v0.7.31
	   Copyright © 2012-2021 Faisal Salman <f@faisalman.com>
	   MIT License *//*
	   Detect Browser, Engine, OS, CPU, and Device type/model from User-Agent data.
	   Supports browser & node.js environment. 
	   Demo   : https://faisalman.github.io/ua-parser-js
	   Source : https://github.com/faisalman/ua-parser-js */
	/////////////////////////////////////////////////////////////////////////////////
	
	(function (window, undefined) {
	
	    'use strict';
	
	    //////////////
	    // Constants
	    /////////////
	
	
	    var LIBVERSION  = '0.7.31',
	        EMPTY       = '',
	        UNKNOWN     = '?',
	        FUNC_TYPE   = 'function',
	        UNDEF_TYPE  = 'undefined',
	        OBJ_TYPE    = 'object',
	        STR_TYPE    = 'string',
	        MAJOR       = 'major',
	        MODEL       = 'model',
	        NAME        = 'name',
	        TYPE        = 'type',
	        VENDOR      = 'vendor',
	        VERSION     = 'version',
	        ARCHITECTURE= 'architecture',
	        CONSOLE     = 'console',
	        MOBILE      = 'mobile',
	        TABLET      = 'tablet',
	        SMARTTV     = 'smarttv',
	        WEARABLE    = 'wearable',
	        EMBEDDED    = 'embedded',
	        UA_MAX_LENGTH = 255;
	
	    var AMAZON  = 'Amazon',
	        APPLE   = 'Apple',
	        ASUS    = 'ASUS',
	        BLACKBERRY = 'BlackBerry',
	        BROWSER = 'Browser',
	        CHROME  = 'Chrome',
	        EDGE    = 'Edge',
	        FIREFOX = 'Firefox',
	        GOOGLE  = 'Google',
	        HUAWEI  = 'Huawei',
	        LG      = 'LG',
	        MICROSOFT = 'Microsoft',
	        MOTOROLA  = 'Motorola',
	        OPERA   = 'Opera',
	        SAMSUNG = 'Samsung',
	        SONY    = 'Sony',
	        XIAOMI  = 'Xiaomi',
	        ZEBRA   = 'Zebra',
	        FACEBOOK   = 'Facebook';
	
	    ///////////
	    // Helper
	    //////////
	
	    var extend = function (regexes, extensions) {
	            var mergedRegexes = {};
	            for (var i in regexes) {
	                if (extensions[i] && extensions[i].length % 2 === 0) {
	                    mergedRegexes[i] = extensions[i].concat(regexes[i]);
	                } else {
	                    mergedRegexes[i] = regexes[i];
	                }
	            }
	            return mergedRegexes;
	        },
	        enumerize = function (arr) {
	            var enums = {};
	            for (var i=0; i<arr.length; i++) {
	                enums[arr[i].toUpperCase()] = arr[i];
	            }
	            return enums;
	        },
	        has = function (str1, str2) {
	            return typeof str1 === STR_TYPE ? lowerize(str2).indexOf(lowerize(str1)) !== -1 : false;
	        },
	        lowerize = function (str) {
	            return str.toLowerCase();
	        },
	        majorize = function (version) {
	            return typeof(version) === STR_TYPE ? version.replace(/[^\d\.]/g, EMPTY).split('.')[0] : undefined;
	        },
	        trim = function (str, len) {
	            if (typeof(str) === STR_TYPE) {
	                str = str.replace(/^\s\s*/, EMPTY).replace(/\s\s*$/, EMPTY);
	                return typeof(len) === UNDEF_TYPE ? str : str.substring(0, UA_MAX_LENGTH);
	            }
	    };
	
	    ///////////////
	    // Map helper
	    //////////////
	
	    var rgxMapper = function (ua, arrays) {
	
	            var i = 0, j, k, p, q, matches, match;
	
	            // loop through all regexes maps
	            while (i < arrays.length && !matches) {
	
	                var regex = arrays[i],       // even sequence (0,2,4,..)
	                    props = arrays[i + 1];   // odd sequence (1,3,5,..)
	                j = k = 0;
	
	                // try matching uastring with regexes
	                while (j < regex.length && !matches) {
	
	                    matches = regex[j++].exec(ua);
	
	                    if (!!matches) {
	                        for (p = 0; p < props.length; p++) {
	                            match = matches[++k];
	                            q = props[p];
	                            // check if given property is actually array
	                            if (typeof q === OBJ_TYPE && q.length > 0) {
	                                if (q.length === 2) {
	                                    if (typeof q[1] == FUNC_TYPE) {
	                                        // assign modified match
	                                        this[q[0]] = q[1].call(this, match);
	                                    } else {
	                                        // assign given value, ignore regex match
	                                        this[q[0]] = q[1];
	                                    }
	                                } else if (q.length === 3) {
	                                    // check whether function or regex
	                                    if (typeof q[1] === FUNC_TYPE && !(q[1].exec && q[1].test)) {
	                                        // call function (usually string mapper)
	                                        this[q[0]] = match ? q[1].call(this, match, q[2]) : undefined;
	                                    } else {
	                                        // sanitize match using given regex
	                                        this[q[0]] = match ? match.replace(q[1], q[2]) : undefined;
	                                    }
	                                } else if (q.length === 4) {
	                                        this[q[0]] = match ? q[3].call(this, match.replace(q[1], q[2])) : undefined;
	                                }
	                            } else {
	                                this[q] = match ? match : undefined;
	                            }
	                        }
	                    }
	                }
	                i += 2;
	            }
	        },
	
	        strMapper = function (str, map) {
	
	            for (var i in map) {
	                // check if current value is array
	                if (typeof map[i] === OBJ_TYPE && map[i].length > 0) {
	                    for (var j = 0; j < map[i].length; j++) {
	                        if (has(map[i][j], str)) {
	                            return (i === UNKNOWN) ? undefined : i;
	                        }
	                    }
	                } else if (has(map[i], str)) {
	                    return (i === UNKNOWN) ? undefined : i;
	                }
	            }
	            return str;
	    };
	
	    ///////////////
	    // String map
	    //////////////
	
	    // Safari < 3.0
	    var oldSafariMap = {
	            '1.0'   : '/8',
	            '1.2'   : '/1',
	            '1.3'   : '/3',
	            '2.0'   : '/412',
	            '2.0.2' : '/416',
	            '2.0.3' : '/417',
	            '2.0.4' : '/419',
	            '?'     : '/'
	        },
	        windowsVersionMap = {
	            'ME'        : '4.90',
	            'NT 3.11'   : 'NT3.51',
	            'NT 4.0'    : 'NT4.0',
	            '2000'      : 'NT 5.0',
	            'XP'        : ['NT 5.1', 'NT 5.2'],
	            'Vista'     : 'NT 6.0',
	            '7'         : 'NT 6.1',
	            '8'         : 'NT 6.2',
	            '8.1'       : 'NT 6.3',
	            '10'        : ['NT 6.4', 'NT 10.0'],
	            'RT'        : 'ARM'
	    };
	
	    //////////////
	    // Regex map
	    /////////////
	
	    var regexes = {
	
	        browser : [[
	
	            /\b(?:crmo|crios)\/([\w\.]+)/i                                      // Chrome for Android/iOS
	            ], [VERSION, [NAME, 'Chrome']], [
	            /edg(?:e|ios|a)?\/([\w\.]+)/i                                       // Microsoft Edge
	            ], [VERSION, [NAME, 'Edge']], [
	
	            // Presto based
	            /(opera mini)\/([-\w\.]+)/i,                                        // Opera Mini
	            /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i,                 // Opera Mobi/Tablet
	            /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i                           // Opera
	            ], [NAME, VERSION], [
	            /opios[\/ ]+([\w\.]+)/i                                             // Opera mini on iphone >= 8.0
	            ], [VERSION, [NAME, OPERA+' Mini']], [
	            /\bopr\/([\w\.]+)/i                                                 // Opera Webkit
	            ], [VERSION, [NAME, OPERA]], [
	
	            // Mixed
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(lunascape|maxthon|netfront|jasmine|blazer)[\/ ]?([\w\.]*)/i,      // Lunascape/Maxthon/Netfront/Jasmine/Blazer
	            // Trident based
	            /(avant |iemobile|slim)(?:browser)?[\/ ]?([\w\.]*)/i,               // Avant/IEMobile/SlimBrowser
	            /(ba?idubrowser)[\/ ]?([\w\.]+)/i,                                  // Baidu Browser
	            /(?:ms|\()(ie) ([\w\.]+)/i,                                         // Internet Explorer
	
	            // Webkit/KHTML based                                               // Flock/RockMelt/Midori/Epiphany/Silk/Skyfire/Bolt/Iron/Iridium/PhantomJS/Bowser/QupZilla/Falkon
	            /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|quark|qupzilla|falkon|rekonq|puffin|brave|whale|qqbrowserlite|qq)\/([-\w\.]+)/i,
	                                                                                // Rekonq/Puffin/Brave/Whale/QQBrowserLite/QQ, aka ShouQ
	            /(weibo)__([\d\.]+)/i                                               // Weibo
	            ], [NAME, VERSION], [
	            /(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i                 // UCBrowser
	            ], [VERSION, [NAME, 'UC'+BROWSER]], [
	            /\bqbcore\/([\w\.]+)/i                                              // WeChat Desktop for Windows Built-in Browser
	            ], [VERSION, [NAME, 'WeChat(Win) Desktop']], [
	            /micromessenger\/([\w\.]+)/i                                        // WeChat
	            ], [VERSION, [NAME, 'WeChat']], [
	            /konqueror\/([\w\.]+)/i                                             // Konqueror
	            ], [VERSION, [NAME, 'Konqueror']], [
	            /trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i                       // IE11
	            ], [VERSION, [NAME, 'IE']], [
	            /yabrowser\/([\w\.]+)/i                                             // Yandex
	            ], [VERSION, [NAME, 'Yandex']], [
	            /(avast|avg)\/([\w\.]+)/i                                           // Avast/AVG Secure Browser
	            ], [[NAME, /(.+)/, '$1 Secure '+BROWSER], VERSION], [
	            /\bfocus\/([\w\.]+)/i                                               // Firefox Focus
	            ], [VERSION, [NAME, FIREFOX+' Focus']], [
	            /\bopt\/([\w\.]+)/i                                                 // Opera Touch
	            ], [VERSION, [NAME, OPERA+' Touch']], [
	            /coc_coc\w+\/([\w\.]+)/i                                            // Coc Coc Browser
	            ], [VERSION, [NAME, 'Coc Coc']], [
	            /dolfin\/([\w\.]+)/i                                                // Dolphin
	            ], [VERSION, [NAME, 'Dolphin']], [
	            /coast\/([\w\.]+)/i                                                 // Opera Coast
	            ], [VERSION, [NAME, OPERA+' Coast']], [
	            /miuibrowser\/([\w\.]+)/i                                           // MIUI Browser
	            ], [VERSION, [NAME, 'MIUI '+BROWSER]], [
	            /fxios\/([-\w\.]+)/i                                                // Firefox for iOS
	            ], [VERSION, [NAME, FIREFOX]], [
	            /\bqihu|(qi?ho?o?|360)browser/i                                     // 360
	            ], [[NAME, '360 '+BROWSER]], [
	            /(oculus|samsung|sailfish)browser\/([\w\.]+)/i
	            ], [[NAME, /(.+)/, '$1 '+BROWSER], VERSION], [                      // Oculus/Samsung/Sailfish Browser
	            /(comodo_dragon)\/([\w\.]+)/i                                       // Comodo Dragon
	            ], [[NAME, /_/g, ' '], VERSION], [
	            /(electron)\/([\w\.]+) safari/i,                                    // Electron-based App
	            /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i,                   // Tesla
	            /m?(qqbrowser|baiduboxapp|2345Explorer)[\/ ]?([\w\.]+)/i            // QQBrowser/Baidu App/2345 Browser
	            ], [NAME, VERSION], [
	            /(metasr)[\/ ]?([\w\.]+)/i,                                         // SouGouBrowser
	            /(lbbrowser)/i                                                      // LieBao Browser
	            ], [NAME], [
	
	            // WebView
	            /((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i       // Facebook App for iOS & Android
	            ], [[NAME, FACEBOOK], VERSION], [
	            /safari (line)\/([\w\.]+)/i,                                        // Line App for iOS
	            /\b(line)\/([\w\.]+)\/iab/i,                                        // Line App for Android
	            /(chromium|instagram)[\/ ]([-\w\.]+)/i                              // Chromium/Instagram
	            ], [NAME, VERSION], [
	            /\bgsa\/([\w\.]+) .*safari\//i                                      // Google Search Appliance on iOS
	            ], [VERSION, [NAME, 'GSA']], [
	
	            /headlesschrome(?:\/([\w\.]+)| )/i                                  // Chrome Headless
	            ], [VERSION, [NAME, CHROME+' Headless']], [
	
	            / wv\).+(chrome)\/([\w\.]+)/i                                       // Chrome WebView
	            ], [[NAME, CHROME+' WebView'], VERSION], [
	
	            /droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i           // Android Browser
	            ], [VERSION, [NAME, 'Android '+BROWSER]], [
	
	            /(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i       // Chrome/OmniWeb/Arora/Tizen/Nokia
	            ], [NAME, VERSION], [
	
	            /version\/([\w\.]+) .*mobile\/\w+ (safari)/i                        // Mobile Safari
	            ], [VERSION, [NAME, 'Mobile Safari']], [
	            /version\/([\w\.]+) .*(mobile ?safari|safari)/i                     // Safari & Safari Mobile
	            ], [VERSION, NAME], [
	            /webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i                      // Safari < 3.0
	            ], [NAME, [VERSION, strMapper, oldSafariMap]], [
	
	            /(webkit|khtml)\/([\w\.]+)/i
	            ], [NAME, VERSION], [
	
	            // Gecko based
	            /(navigator|netscape\d?)\/([-\w\.]+)/i                              // Netscape
	            ], [[NAME, 'Netscape'], VERSION], [
	            /mobile vr; rv:([\w\.]+)\).+firefox/i                               // Firefox Reality
	            ], [VERSION, [NAME, FIREFOX+' Reality']], [
	            /ekiohf.+(flow)\/([\w\.]+)/i,                                       // Flow
	            /(swiftfox)/i,                                                      // Swiftfox
	            /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror|klar)[\/ ]?([\w\.\+]+)/i,
	                                                                                // IceDragon/Iceweasel/Camino/Chimera/Fennec/Maemo/Minimo/Conkeror/Klar
	            /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i,
	                                                                                // Firefox/SeaMonkey/K-Meleon/IceCat/IceApe/Firebird/Phoenix
	            /(firefox)\/([\w\.]+)/i,                                            // Other Firefox-based
	            /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i,                         // Mozilla
	
	            // Other
	            /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|sleipnir|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i,
	                                                                                // Polaris/Lynx/Dillo/iCab/Doris/Amaya/w3m/NetSurf/Sleipnir/Obigo/Mosaic/Go/ICE/UP.Browser
	            /(links) \(([\w\.]+)/i                                              // Links
	            ], [NAME, VERSION]
	        ],
	
	        cpu : [[
	
	            /(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i                     // AMD64 (x64)
	            ], [[ARCHITECTURE, 'amd64']], [
	
	            /(ia32(?=;))/i                                                      // IA32 (quicktime)
	            ], [[ARCHITECTURE, lowerize]], [
	
	            /((?:i[346]|x)86)[;\)]/i                                            // IA32 (x86)
	            ], [[ARCHITECTURE, 'ia32']], [
	
	            /\b(aarch64|arm(v?8e?l?|_?64))\b/i                                 // ARM64
	            ], [[ARCHITECTURE, 'arm64']], [
	
	            /\b(arm(?:v[67])?ht?n?[fl]p?)\b/i                                   // ARMHF
	            ], [[ARCHITECTURE, 'armhf']], [
	
	            // PocketPC mistakenly identified as PowerPC
	            /windows (ce|mobile); ppc;/i
	            ], [[ARCHITECTURE, 'arm']], [
	
	            /((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i                            // PowerPC
	            ], [[ARCHITECTURE, /ower/, EMPTY, lowerize]], [
	
	            /(sun4\w)[;\)]/i                                                    // SPARC
	            ], [[ARCHITECTURE, 'sparc']], [
	
	            /((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i
	                                                                                // IA64, 68K, ARM/64, AVR/32, IRIX/64, MIPS/64, SPARC/64, PA-RISC
	            ], [[ARCHITECTURE, lowerize]]
	        ],
	
	        device : [[
	
	            //////////////////////////
	            // MOBILES & TABLETS
	            // Ordered by popularity
	            /////////////////////////
	
	            // Samsung
	            /\b(sch-i[89]0\d|shw-m380s|sm-[pt]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i
	            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, TABLET]], [
	            /\b((?:s[cgp]h|gt|sm)-\w+|galaxy nexus)/i,
	            /samsung[- ]([-\w]+)/i,
	            /sec-(sgh\w+)/i
	            ], [MODEL, [VENDOR, SAMSUNG], [TYPE, MOBILE]], [
	
	            // Apple
	            /\((ip(?:hone|od)[\w ]*);/i                                         // iPod/iPhone
	            ], [MODEL, [VENDOR, APPLE], [TYPE, MOBILE]], [
	            /\((ipad);[-\w\),; ]+apple/i,                                       // iPad
	            /applecoremedia\/[\w\.]+ \((ipad)/i,
	            /\b(ipad)\d\d?,\d\d?[;\]].+ios/i
	            ], [MODEL, [VENDOR, APPLE], [TYPE, TABLET]], [
	
	            // Huawei
	            /\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i
	            ], [MODEL, [VENDOR, HUAWEI], [TYPE, TABLET]], [
	            /(?:huawei|honor)([-\w ]+)[;\)]/i,
	            /\b(nexus 6p|\w{2,4}-[atu]?[ln][01259x][012359][an]?)\b(?!.+d\/s)/i
	            ], [MODEL, [VENDOR, HUAWEI], [TYPE, MOBILE]], [
	
	            // Xiaomi
	            /\b(poco[\w ]+)(?: bui|\))/i,                                       // Xiaomi POCO
	            /\b; (\w+) build\/hm\1/i,                                           // Xiaomi Hongmi 'numeric' models
	            /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i,                             // Xiaomi Hongmi
	            /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i,                   // Xiaomi Redmi
	            /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite)?)(?: bui|\))/i // Xiaomi Mi
	            ], [[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, MOBILE]], [
	            /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i                        // Mi Pad tablets
	            ],[[MODEL, /_/g, ' '], [VENDOR, XIAOMI], [TYPE, TABLET]], [
	
	            // OPPO
	            /; (\w+) bui.+ oppo/i,
	            /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i
	            ], [MODEL, [VENDOR, 'OPPO'], [TYPE, MOBILE]], [
	
	            // Vivo
	            /vivo (\w+)(?: bui|\))/i,
	            /\b(v[12]\d{3}\w?[at])(?: bui|;)/i
	            ], [MODEL, [VENDOR, 'Vivo'], [TYPE, MOBILE]], [
	
	            // Realme
	            /\b(rmx[12]\d{3})(?: bui|;|\))/i
	            ], [MODEL, [VENDOR, 'Realme'], [TYPE, MOBILE]], [
	
	            // Motorola
	            /\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i,
	            /\bmot(?:orola)?[- ](\w*)/i,
	            /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i
	            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, MOBILE]], [
	            /\b(mz60\d|xoom[2 ]{0,2}) build\//i
	            ], [MODEL, [VENDOR, MOTOROLA], [TYPE, TABLET]], [
	
	            // LG
	            /((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i
	            ], [MODEL, [VENDOR, LG], [TYPE, TABLET]], [
	            /(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i,
	            /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i,
	            /\blg-?([\d\w]+) bui/i
	            ], [MODEL, [VENDOR, LG], [TYPE, MOBILE]], [
	
	            // Lenovo
	            /(ideatab[-\w ]+)/i,
	            /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i
	            ], [MODEL, [VENDOR, 'Lenovo'], [TYPE, TABLET]], [
	
	            // Nokia
	            /(?:maemo|nokia).*(n900|lumia \d+)/i,
	            /nokia[-_ ]?([-\w\.]*)/i
	            ], [[MODEL, /_/g, ' '], [VENDOR, 'Nokia'], [TYPE, MOBILE]], [
	
	            // Google
	            /(pixel c)\b/i                                                      // Google Pixel C
	            ], [MODEL, [VENDOR, GOOGLE], [TYPE, TABLET]], [
	            /droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i                         // Google Pixel
	            ], [MODEL, [VENDOR, GOOGLE], [TYPE, MOBILE]], [
	
	            // Sony
	            /droid.+ ([c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i
	            ], [MODEL, [VENDOR, SONY], [TYPE, MOBILE]], [
	            /sony tablet [ps]/i,
	            /\b(?:sony)?sgp\w+(?: bui|\))/i
	            ], [[MODEL, 'Xperia Tablet'], [VENDOR, SONY], [TYPE, TABLET]], [
	
	            // OnePlus
	            / (kb2005|in20[12]5|be20[12][59])\b/i,
	            /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i
	            ], [MODEL, [VENDOR, 'OnePlus'], [TYPE, MOBILE]], [
	
	            // Amazon
	            /(alexa)webm/i,
	            /(kf[a-z]{2}wi)( bui|\))/i,                                         // Kindle Fire without Silk
	            /(kf[a-z]+)( bui|\)).+silk\//i                                      // Kindle Fire HD
	            ], [MODEL, [VENDOR, AMAZON], [TYPE, TABLET]], [
	            /((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i                     // Fire Phone
	            ], [[MODEL, /(.+)/g, 'Fire Phone $1'], [VENDOR, AMAZON], [TYPE, MOBILE]], [
	
	            // BlackBerry
	            /(playbook);[-\w\),; ]+(rim)/i                                      // BlackBerry PlayBook
	            ], [MODEL, VENDOR, [TYPE, TABLET]], [
	            /\b((?:bb[a-f]|st[hv])100-\d)/i,
	            /\(bb10; (\w+)/i                                                    // BlackBerry 10
	            ], [MODEL, [VENDOR, BLACKBERRY], [TYPE, MOBILE]], [
	
	            // Asus
	            /(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i
	            ], [MODEL, [VENDOR, ASUS], [TYPE, TABLET]], [
	            / (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i
	            ], [MODEL, [VENDOR, ASUS], [TYPE, MOBILE]], [
	
	            // HTC
	            /(nexus 9)/i                                                        // HTC Nexus 9
	            ], [MODEL, [VENDOR, 'HTC'], [TYPE, TABLET]], [
	            /(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i,                         // HTC
	
	            // ZTE
	            /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i,
	            /(alcatel|geeksphone|nexian|panasonic|sony)[-_ ]?([-\w]*)/i         // Alcatel/GeeksPhone/Nexian/Panasonic/Sony
	            ], [VENDOR, [MODEL, /_/g, ' '], [TYPE, MOBILE]], [
	
	            // Acer
	            /droid.+; ([ab][1-7]-?[0178a]\d\d?)/i
	            ], [MODEL, [VENDOR, 'Acer'], [TYPE, TABLET]], [
	
	            // Meizu
	            /droid.+; (m[1-5] note) bui/i,
	            /\bmz-([-\w]{2,})/i
	            ], [MODEL, [VENDOR, 'Meizu'], [TYPE, MOBILE]], [
	
	            // Sharp
	            /\b(sh-?[altvz]?\d\d[a-ekm]?)/i
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, MOBILE]], [
	
	            // MIXED
	            /(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron)[-_ ]?([-\w]*)/i,
	                                                                                // BlackBerry/BenQ/Palm/Sony-Ericsson/Acer/Asus/Dell/Meizu/Motorola/Polytron
	            /(hp) ([\w ]+\w)/i,                                                 // HP iPAQ
	            /(asus)-?(\w+)/i,                                                   // Asus
	            /(microsoft); (lumia[\w ]+)/i,                                      // Microsoft Lumia
	            /(lenovo)[-_ ]?([-\w]+)/i,                                          // Lenovo
	            /(jolla)/i,                                                         // Jolla
	            /(oppo) ?([\w ]+) bui/i                                             // OPPO
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	
	            /(archos) (gamepad2?)/i,                                            // Archos
	            /(hp).+(touchpad(?!.+tablet)|tablet)/i,                             // HP TouchPad
	            /(kindle)\/([\w\.]+)/i,                                             // Kindle
	            /(nook)[\w ]+build\/(\w+)/i,                                        // Nook
	            /(dell) (strea[kpr\d ]*[\dko])/i,                                   // Dell Streak
	            /(le[- ]+pan)[- ]+(\w{1,9}) bui/i,                                  // Le Pan Tablets
	            /(trinity)[- ]*(t\d{3}) bui/i,                                      // Trinity Tablets
	            /(gigaset)[- ]+(q\w{1,9}) bui/i,                                    // Gigaset Tablets
	            /(vodafone) ([\w ]+)(?:\)| bui)/i                                   // Vodafone
	            ], [VENDOR, MODEL, [TYPE, TABLET]], [
	
	            /(surface duo)/i                                                    // Surface Duo
	            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, TABLET]], [
	            /droid [\d\.]+; (fp\du?)(?: b|\))/i                                 // Fairphone
	            ], [MODEL, [VENDOR, 'Fairphone'], [TYPE, MOBILE]], [
	            /(u304aa)/i                                                         // AT&T
	            ], [MODEL, [VENDOR, 'AT&T'], [TYPE, MOBILE]], [
	            /\bsie-(\w*)/i                                                      // Siemens
	            ], [MODEL, [VENDOR, 'Siemens'], [TYPE, MOBILE]], [
	            /\b(rct\w+) b/i                                                     // RCA Tablets
	            ], [MODEL, [VENDOR, 'RCA'], [TYPE, TABLET]], [
	            /\b(venue[\d ]{2,7}) b/i                                            // Dell Venue Tablets
	            ], [MODEL, [VENDOR, 'Dell'], [TYPE, TABLET]], [
	            /\b(q(?:mv|ta)\w+) b/i                                              // Verizon Tablet
	            ], [MODEL, [VENDOR, 'Verizon'], [TYPE, TABLET]], [
	            /\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i                       // Barnes & Noble Tablet
	            ], [MODEL, [VENDOR, 'Barnes & Noble'], [TYPE, TABLET]], [
	            /\b(tm\d{3}\w+) b/i
	            ], [MODEL, [VENDOR, 'NuVision'], [TYPE, TABLET]], [
	            /\b(k88) b/i                                                        // ZTE K Series Tablet
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, TABLET]], [
	            /\b(nx\d{3}j) b/i                                                   // ZTE Nubia
	            ], [MODEL, [VENDOR, 'ZTE'], [TYPE, MOBILE]], [
	            /\b(gen\d{3}) b.+49h/i                                              // Swiss GEN Mobile
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, MOBILE]], [
	            /\b(zur\d{3}) b/i                                                   // Swiss ZUR Tablet
	            ], [MODEL, [VENDOR, 'Swiss'], [TYPE, TABLET]], [
	            /\b((zeki)?tb.*\b) b/i                                              // Zeki Tablets
	            ], [MODEL, [VENDOR, 'Zeki'], [TYPE, TABLET]], [
	            /\b([yr]\d{2}) b/i,
	            /\b(dragon[- ]+touch |dt)(\w{5}) b/i                                // Dragon Touch Tablet
	            ], [[VENDOR, 'Dragon Touch'], MODEL, [TYPE, TABLET]], [
	            /\b(ns-?\w{0,9}) b/i                                                // Insignia Tablets
	            ], [MODEL, [VENDOR, 'Insignia'], [TYPE, TABLET]], [
	            /\b((nxa|next)-?\w{0,9}) b/i                                        // NextBook Tablets
	            ], [MODEL, [VENDOR, 'NextBook'], [TYPE, TABLET]], [
	            /\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i                  // Voice Xtreme Phones
	            ], [[VENDOR, 'Voice'], MODEL, [TYPE, MOBILE]], [
	            /\b(lvtel\-)?(v1[12]) b/i                                           // LvTel Phones
	            ], [[VENDOR, 'LvTel'], MODEL, [TYPE, MOBILE]], [
	            /\b(ph-1) /i                                                        // Essential PH-1
	            ], [MODEL, [VENDOR, 'Essential'], [TYPE, MOBILE]], [
	            /\b(v(100md|700na|7011|917g).*\b) b/i                               // Envizen Tablets
	            ], [MODEL, [VENDOR, 'Envizen'], [TYPE, TABLET]], [
	            /\b(trio[-\w\. ]+) b/i                                              // MachSpeed Tablets
	            ], [MODEL, [VENDOR, 'MachSpeed'], [TYPE, TABLET]], [
	            /\btu_(1491) b/i                                                    // Rotor Tablets
	            ], [MODEL, [VENDOR, 'Rotor'], [TYPE, TABLET]], [
	            /(shield[\w ]+) b/i                                                 // Nvidia Shield Tablets
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, TABLET]], [
	            /(sprint) (\w+)/i                                                   // Sprint Phones
	            ], [VENDOR, MODEL, [TYPE, MOBILE]], [
	            /(kin\.[onetw]{3})/i                                                // Microsoft Kin
	            ], [[MODEL, /\./g, ' '], [VENDOR, MICROSOFT], [TYPE, MOBILE]], [
	            /droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i             // Zebra
	            ], [MODEL, [VENDOR, ZEBRA], [TYPE, TABLET]], [
	            /droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i
	            ], [MODEL, [VENDOR, ZEBRA], [TYPE, MOBILE]], [
	
	            ///////////////////
	            // CONSOLES
	            ///////////////////
	
	            /(ouya)/i,                                                          // Ouya
	            /(nintendo) ([wids3utch]+)/i                                        // Nintendo
	            ], [VENDOR, MODEL, [TYPE, CONSOLE]], [
	            /droid.+; (shield) bui/i                                            // Nvidia
	            ], [MODEL, [VENDOR, 'Nvidia'], [TYPE, CONSOLE]], [
	            /(playstation [345portablevi]+)/i                                   // Playstation
	            ], [MODEL, [VENDOR, SONY], [TYPE, CONSOLE]], [
	            /\b(xbox(?: one)?(?!; xbox))[\); ]/i                                // Microsoft Xbox
	            ], [MODEL, [VENDOR, MICROSOFT], [TYPE, CONSOLE]], [
	
	            ///////////////////
	            // SMARTTVS
	            ///////////////////
	
	            /smart-tv.+(samsung)/i                                              // Samsung
	            ], [VENDOR, [TYPE, SMARTTV]], [
	            /hbbtv.+maple;(\d+)/i
	            ], [[MODEL, /^/, 'SmartTV'], [VENDOR, SAMSUNG], [TYPE, SMARTTV]], [
	            /(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i        // LG SmartTV
	            ], [[VENDOR, LG], [TYPE, SMARTTV]], [
	            /(apple) ?tv/i                                                      // Apple TV
	            ], [VENDOR, [MODEL, APPLE+' TV'], [TYPE, SMARTTV]], [
	            /crkey/i                                                            // Google Chromecast
	            ], [[MODEL, CHROME+'cast'], [VENDOR, GOOGLE], [TYPE, SMARTTV]], [
	            /droid.+aft(\w)( bui|\))/i                                          // Fire TV
	            ], [MODEL, [VENDOR, AMAZON], [TYPE, SMARTTV]], [
	            /\(dtv[\);].+(aquos)/i                                              // Sharp
	            ], [MODEL, [VENDOR, 'Sharp'], [TYPE, SMARTTV]], [
	            /\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i,                          // Roku
	            /hbbtv\/\d+\.\d+\.\d+ +\([\w ]*; *(\w[^;]*);([^;]*)/i               // HbbTV devices
	            ], [[VENDOR, trim], [MODEL, trim], [TYPE, SMARTTV]], [
	            /\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i                   // SmartTV from Unidentified Vendors
	            ], [[TYPE, SMARTTV]], [
	
	            ///////////////////
	            // WEARABLES
	            ///////////////////
	
	            /((pebble))app/i                                                    // Pebble
	            ], [VENDOR, MODEL, [TYPE, WEARABLE]], [
	            /droid.+; (glass) \d/i                                              // Google Glass
	            ], [MODEL, [VENDOR, GOOGLE], [TYPE, WEARABLE]], [
	            /droid.+; (wt63?0{2,3})\)/i
	            ], [MODEL, [VENDOR, ZEBRA], [TYPE, WEARABLE]], [
	            /(quest( 2)?)/i                                                     // Oculus Quest
	            ], [MODEL, [VENDOR, FACEBOOK], [TYPE, WEARABLE]], [
	
	            ///////////////////
	            // EMBEDDED
	            ///////////////////
	
	            /(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i                              // Tesla
	            ], [VENDOR, [TYPE, EMBEDDED]], [
	
	            ////////////////////
	            // MIXED (GENERIC)
	            ///////////////////
	
	            /droid .+?; ([^;]+?)(?: bui|\) applew).+? mobile safari/i           // Android Phones from Unidentified Vendors
	            ], [MODEL, [TYPE, MOBILE]], [
	            /droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i       // Android Tablets from Unidentified Vendors
	            ], [MODEL, [TYPE, TABLET]], [
	            /\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i                      // Unidentifiable Tablet
	            ], [[TYPE, TABLET]], [
	            /(phone|mobile(?:[;\/]| safari)|pda(?=.+windows ce))/i              // Unidentifiable Mobile
	            ], [[TYPE, MOBILE]], [
	            /(android[-\w\. ]{0,9});.+buil/i                                    // Generic Android Device
	            ], [MODEL, [VENDOR, 'Generic']]
	        ],
	
	        engine : [[
	
	            /windows.+ edge\/([\w\.]+)/i                                       // EdgeHTML
	            ], [VERSION, [NAME, EDGE+'HTML']], [
	
	            /webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i                         // Blink
	            ], [VERSION, [NAME, 'Blink']], [
	
	            /(presto)\/([\w\.]+)/i,                                             // Presto
	            /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna)\/([\w\.]+)/i, // WebKit/Trident/NetFront/NetSurf/Amaya/Lynx/w3m/Goanna
	            /ekioh(flow)\/([\w\.]+)/i,                                          // Flow
	            /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i,                           // KHTML/Tasman/Links
	            /(icab)[\/ ]([23]\.[\d\.]+)/i                                       // iCab
	            ], [NAME, VERSION], [
	
	            /rv\:([\w\.]{1,9})\b.+(gecko)/i                                     // Gecko
	            ], [VERSION, NAME]
	        ],
	
	        os : [[
	
	            // Windows
	            /microsoft (windows) (vista|xp)/i                                   // Windows (iTunes)
	            ], [NAME, VERSION], [
	            /(windows) nt 6\.2; (arm)/i,                                        // Windows RT
	            /(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i,            // Windows Phone
	            /(windows)[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i
	            ], [NAME, [VERSION, strMapper, windowsVersionMap]], [
	            /(win(?=3|9|n)|win 9x )([nt\d\.]+)/i
	            ], [[NAME, 'Windows'], [VERSION, strMapper, windowsVersionMap]], [
	
	            // iOS/macOS
	            /ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i,              // iOS
	            /cfnetwork\/.+darwin/i
	            ], [[VERSION, /_/g, '.'], [NAME, 'iOS']], [
	            /(mac os x) ?([\w\. ]*)/i,
	            /(macintosh|mac_powerpc\b)(?!.+haiku)/i                             // Mac OS
	            ], [[NAME, 'Mac OS'], [VERSION, /_/g, '.']], [
	
	            // Mobile OSes
	            /droid ([\w\.]+)\b.+(android[- ]x86)/i                              // Android-x86
	            ], [VERSION, NAME], [                                               // Android/WebOS/QNX/Bada/RIM/Maemo/MeeGo/Sailfish OS
	            /(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish)[-\/ ]?([\w\.]*)/i,
	            /(blackberry)\w*\/([\w\.]*)/i,                                      // Blackberry
	            /(tizen|kaios)[\/ ]([\w\.]+)/i,                                     // Tizen/KaiOS
	            /\((series40);/i                                                    // Series 40
	            ], [NAME, VERSION], [
	            /\(bb(10);/i                                                        // BlackBerry 10
	            ], [VERSION, [NAME, BLACKBERRY]], [
	            /(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i         // Symbian
	            ], [VERSION, [NAME, 'Symbian']], [
	            /mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i // Firefox OS
	            ], [VERSION, [NAME, FIREFOX+' OS']], [
	            /web0s;.+rt(tv)/i,
	            /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i                              // WebOS
	            ], [VERSION, [NAME, 'webOS']], [
	
	            // Google Chromecast
	            /crkey\/([\d\.]+)/i                                                 // Google Chromecast
	            ], [VERSION, [NAME, CHROME+'cast']], [
	            /(cros) [\w]+ ([\w\.]+\w)/i                                         // Chromium OS
	            ], [[NAME, 'Chromium OS'], VERSION],[
	
	            // Console
	            /(nintendo|playstation) ([wids345portablevuch]+)/i,                 // Nintendo/Playstation
	            /(xbox); +xbox ([^\);]+)/i,                                         // Microsoft Xbox (360, One, X, S, Series X, Series S)
	
	            // Other
	            /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i,                            // Joli/Palm
	            /(mint)[\/\(\) ]?(\w*)/i,                                           // Mint
	            /(mageia|vectorlinux)[; ]/i,                                        // Mageia/VectorLinux
	            /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i,
	                                                                                // Ubuntu/Debian/SUSE/Gentoo/Arch/Slackware/Fedora/Mandriva/CentOS/PCLinuxOS/RedHat/Zenwalk/Linpus/Raspbian/Plan9/Minix/RISCOS/Contiki/Deepin/Manjaro/elementary/Sabayon/Linspire
	            /(hurd|linux) ?([\w\.]*)/i,                                         // Hurd/Linux
	            /(gnu) ?([\w\.]*)/i,                                                // GNU
	            /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, // FreeBSD/NetBSD/OpenBSD/PC-BSD/GhostBSD/DragonFly
	            /(haiku) (\w+)/i                                                    // Haiku
	            ], [NAME, VERSION], [
	            /(sunos) ?([\w\.\d]*)/i                                             // Solaris
	            ], [[NAME, 'Solaris'], VERSION], [
	            /((?:open)?solaris)[-\/ ]?([\w\.]*)/i,                              // Solaris
	            /(aix) ((\d)(?=\.|\)| )[\w\.])*/i,                                  // AIX
	            /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux)/i,            // BeOS/OS2/AmigaOS/MorphOS/OpenVMS/Fuchsia/HP-UX
	            /(unix) ?([\w\.]*)/i                                                // UNIX
	            ], [NAME, VERSION]
	        ]
	    };
	
	    /////////////////
	    // Constructor
	    ////////////////
	
	    var UAParser = function (ua, extensions) {
	
	        if (typeof ua === OBJ_TYPE) {
	            extensions = ua;
	            ua = undefined;
	        }
	
	        if (!(this instanceof UAParser)) {
	            return new UAParser(ua, extensions).getResult();
	        }
	
	        var _ua = ua || ((typeof window !== UNDEF_TYPE && window.navigator && window.navigator.userAgent) ? window.navigator.userAgent : EMPTY);
	        var _rgxmap = extensions ? extend(regexes, extensions) : regexes;
	
	        this.getBrowser = function () {
	            var _browser = {};
	            _browser[NAME] = undefined;
	            _browser[VERSION] = undefined;
	            rgxMapper.call(_browser, _ua, _rgxmap.browser);
	            _browser.major = majorize(_browser.version);
	            return _browser;
	        };
	        this.getCPU = function () {
	            var _cpu = {};
	            _cpu[ARCHITECTURE] = undefined;
	            rgxMapper.call(_cpu, _ua, _rgxmap.cpu);
	            return _cpu;
	        };
	        this.getDevice = function () {
	            var _device = {};
	            _device[VENDOR] = undefined;
	            _device[MODEL] = undefined;
	            _device[TYPE] = undefined;
	            rgxMapper.call(_device, _ua, _rgxmap.device);
	            return _device;
	        };
	        this.getEngine = function () {
	            var _engine = {};
	            _engine[NAME] = undefined;
	            _engine[VERSION] = undefined;
	            rgxMapper.call(_engine, _ua, _rgxmap.engine);
	            return _engine;
	        };
	        this.getOS = function () {
	            var _os = {};
	            _os[NAME] = undefined;
	            _os[VERSION] = undefined;
	            rgxMapper.call(_os, _ua, _rgxmap.os);
	            return _os;
	        };
	        this.getResult = function () {
	            return {
	                ua      : this.getUA(),
	                browser : this.getBrowser(),
	                engine  : this.getEngine(),
	                os      : this.getOS(),
	                device  : this.getDevice(),
	                cpu     : this.getCPU()
	            };
	        };
	        this.getUA = function () {
	            return _ua;
	        };
	        this.setUA = function (ua) {
	            _ua = (typeof ua === STR_TYPE && ua.length > UA_MAX_LENGTH) ? trim(ua, UA_MAX_LENGTH) : ua;
	            return this;
	        };
	        this.setUA(_ua);
	        return this;
	    };
	
	    UAParser.VERSION = LIBVERSION;
	    UAParser.BROWSER =  enumerize([NAME, VERSION, MAJOR]);
	    UAParser.CPU = enumerize([ARCHITECTURE]);
	    UAParser.DEVICE = enumerize([MODEL, VENDOR, TYPE, CONSOLE, MOBILE, SMARTTV, TABLET, WEARABLE, EMBEDDED]);
	    UAParser.ENGINE = UAParser.OS = enumerize([NAME, VERSION]);
	
	    ///////////
	    // Export
	    //////////
	
	    // check js environment
	    if (typeof(exports) !== UNDEF_TYPE) {
	        // nodejs env
	        if (typeof module !== UNDEF_TYPE && module.exports) {
	            exports = module.exports = UAParser;
	        }
	        exports.UAParser = UAParser;
	    } else {
	        // requirejs env (optional)
	        if ("function" === FUNC_TYPE && __webpack_require__(2969)) {
	            !(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
	                return UAParser;
	            }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	        } else if (typeof window !== UNDEF_TYPE) {
	            // browser env
	            window.UAParser = UAParser;
	        }
	    }
	
	    // jQuery/Zepto specific (optional)
	    // Note:
	    //   In AMD env the global scope should be kept clean, but jQuery is an exception.
	    //   jQuery always exports to global scope, unless jQuery.noConflict(true) is used,
	    //   and we should catch that.
	    var $ = typeof window !== UNDEF_TYPE && (window.jQuery || window.Zepto);
	    if ($ && !$.ua) {
	        var parser = new UAParser();
	        $.ua = parser.getResult();
	        $.ua.get = function () {
	            return parser.getUA();
	        };
	        $.ua.set = function (ua) {
	            parser.setUA(ua);
	            var result = parser.getResult();
	            for (var prop in result) {
	                $.ua[prop] = result[prop];
	            }
	        };
	    }
	
	})(typeof window === 'object' ? window : this);


/***/ },
/* 2945 */
36,
/* 2946 */
36,
/* 2947 */
36,
/* 2948 */
36,
/* 2949 */
36,
/* 2950 */
36,
/* 2951 */
36,
/* 2952 */
36,
/* 2953 */
36,
/* 2954 */
36,
/* 2955 */
36,
/* 2956 */
36,
/* 2957 */
36,
/* 2958 */
36,
/* 2959 */
36,
/* 2960 */
36,
/* 2961 */
36,
/* 2962 */
36,
/* 2963 */
36,
/* 2964 */
36,
/* 2965 */
36,
/* 2966 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/login_banner.f9e0b25f.png";

/***/ },
/* 2967 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/login_pic.39f0e742.png";

/***/ },
/* 2968 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/media/logo.c61a514e.png";

/***/ },
/* 2969 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(__webpack_amd_options__) {module.exports = __webpack_amd_options__;
	
	/* WEBPACK VAR INJECTION */}.call(exports, {}))

/***/ },
/* 2970 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4);
	
	var vec2 = __webpack_require__(55);
	
	var Draggable = __webpack_require__(2994);
	
	var Eventful = __webpack_require__(225);
	
	var eventTool = __webpack_require__(147);
	
	var GestureMgr = __webpack_require__(2980);
	
	/**
	 * [The interface between `Handler` and `HandlerProxy`]:
	 *
	 * The default `HandlerProxy` only support the common standard web environment
	 * (e.g., standalone browser, headless browser, embed browser in mobild APP, ...).
	 * But `HandlerProxy` can be replaced to support more non-standard environment
	 * (e.g., mini app), or to support more feature that the default `HandlerProxy`
	 * not provided (like echarts-gl did).
	 * So the interface between `Handler` and `HandlerProxy` should be stable. Do not
	 * make break changes util inevitable. The interface include the public methods
	 * of `Handler` and the events listed in `handlerNames` below, by which `HandlerProxy`
	 * drives `Handler`.
	 */
	
	/**
	 * [Drag outside]:
	 *
	 * That is, triggering `mousemove` and `mouseup` event when the pointer is out of the
	 * zrender area when dragging. That is important for the improvement of the user experience
	 * when dragging something near the boundary without being terminated unexpectedly.
	 *
	 * We originally consider to introduce new events like `pagemovemove` and `pagemouseup`
	 * to resolve this issue. But some drawbacks of it is described in
	 * https://github.com/ecomfe/zrender/pull/536#issuecomment-560286899
	 *
	 * Instead, we referenced the specifications:
	 * https://www.w3.org/TR/touch-events/#the-touchmove-event
	 * https://www.w3.org/TR/2014/WD-DOM-Level-3-Events-20140925/#event-type-mousemove
	 * where the the mousemove/touchmove can be continue to fire if the user began a drag
	 * operation and the pointer has left the boundary. (for the mouse event, browsers
	 * only do it on `document` and when the pointer has left the boundary of the browser.)
	 *
	 * So the default `HandlerProxy` supports this feature similarly: if it is in the dragging
	 * state (see `pointerCapture` in `HandlerProxy`), the `mousemove` and `mouseup` continue
	 * to fire until release the pointer. That is implemented by listen to those event on
	 * `document`.
	 * If we implement some other `HandlerProxy` only for touch device, that would be easier.
	 * The touch event support this feature by default.
	 *
	 * Note:
	 * There might be some cases that the mouse event can not be
	 * received on `document`. For example,
	 * (A) `useCapture` is not supported and some user defined event listeners on the ancestor
	 * of zr dom throw Error .
	 * (B) `useCapture` is not supported Some user defined event listeners on the ancestor of
	 * zr dom call `stopPropagation`.
	 * In these cases, the `mousemove` event might be keep triggered event
	 * if the mouse is released. We try to reduce the side-effect in those cases.
	 * That is, do nothing (especially, `findHover`) in those cases. See `isOutsideBoundary`.
	 *
	 * Note:
	 * If `HandlerProxy` listens to `document` with `useCapture`, `HandlerProxy` needs to
	 * make sure `stopPropagation` and `preventDefault` doing nothing if and only if the event
	 * target is not zrender dom. Becuase it is dangerous to enable users to call them in
	 * `document` capture phase to prevent the propagation to any listener of the webpage.
	 * But they are needed to work when the pointer inside the zrender dom.
	 */
	var SILENT = 'silent';
	
	function makeEventPacket(eveType, targetInfo, event) {
	  return {
	    type: eveType,
	    event: event,
	    // target can only be an element that is not silent.
	    target: targetInfo.target,
	    // topTarget can be a silent element.
	    topTarget: targetInfo.topTarget,
	    cancelBubble: false,
	    offsetX: event.zrX,
	    offsetY: event.zrY,
	    gestureEvent: event.gestureEvent,
	    pinchX: event.pinchX,
	    pinchY: event.pinchY,
	    pinchScale: event.pinchScale,
	    wheelDelta: event.zrDelta,
	    zrByTouch: event.zrByTouch,
	    which: event.which,
	    stop: stopEvent
	  };
	}
	
	function stopEvent() {
	  eventTool.stop(this.event);
	}
	
	function EmptyProxy() {}
	
	EmptyProxy.prototype.dispose = function () {};
	
	var handlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	/**
	 * @alias module:zrender/Handler
	 * @constructor
	 * @extends module:zrender/mixin/Eventful
	 * @param {module:zrender/Storage} storage Storage instance.
	 * @param {module:zrender/Painter} painter Painter instance.
	 * @param {module:zrender/dom/HandlerProxy} proxy HandlerProxy instance.
	 * @param {HTMLElement} painterRoot painter.root (not painter.getViewportRoot()).
	 */
	
	var Handler = function (storage, painter, proxy, painterRoot) {
	  Eventful.call(this);
	  this.storage = storage;
	  this.painter = painter;
	  this.painterRoot = painterRoot;
	  proxy = proxy || new EmptyProxy();
	  /**
	   * Proxy of event. can be Dom, WebGLSurface, etc.
	   */
	
	  this.proxy = null;
	  /**
	   * {target, topTarget, x, y}
	   * @private
	   * @type {Object}
	   */
	
	  this._hovered = {};
	  /**
	   * @private
	   * @type {Date}
	   */
	
	  this._lastTouchMoment;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastX;
	  /**
	   * @private
	   * @type {number}
	   */
	
	  this._lastY;
	  /**
	   * @private
	   * @type {module:zrender/core/GestureMgr}
	   */
	
	  this._gestureMgr;
	  Draggable.call(this);
	  this.setHandlerProxy(proxy);
	};
	
	Handler.prototype = {
	  constructor: Handler,
	  setHandlerProxy: function (proxy) {
	    if (this.proxy) {
	      this.proxy.dispose();
	    }
	
	    if (proxy) {
	      util.each(handlerNames, function (name) {
	        proxy.on && proxy.on(name, this[name], this);
	      }, this); // Attach handler
	
	      proxy.handler = this;
	    }
	
	    this.proxy = proxy;
	  },
	  mousemove: function (event) {
	    var x = event.zrX;
	    var y = event.zrY;
	    var isOutside = isOutsideBoundary(this, x, y);
	    var lastHovered = this._hovered;
	    var lastHoveredTarget = lastHovered.target; // If lastHoveredTarget is removed from zr (detected by '__zr') by some API call
	    // (like 'setOption' or 'dispatchAction') in event handlers, we should find
	    // lastHovered again here. Otherwise 'mouseout' can not be triggered normally.
	    // See #6198.
	
	    if (lastHoveredTarget && !lastHoveredTarget.__zr) {
	      lastHovered = this.findHover(lastHovered.x, lastHovered.y);
	      lastHoveredTarget = lastHovered.target;
	    }
	
	    var hovered = this._hovered = isOutside ? {
	      x: x,
	      y: y
	    } : this.findHover(x, y);
	    var hoveredTarget = hovered.target;
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(hoveredTarget ? hoveredTarget.cursor : 'default'); // Mouse out on previous hovered element
	
	    if (lastHoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(lastHovered, 'mouseout', event);
	    } // Mouse moving on one element
	
	
	    this.dispatchToElement(hovered, 'mousemove', event); // Mouse over on a new element
	
	    if (hoveredTarget && hoveredTarget !== lastHoveredTarget) {
	      this.dispatchToElement(hovered, 'mouseover', event);
	    }
	  },
	  mouseout: function (event) {
	    var eventControl = event.zrEventControl;
	    var zrIsToLocalDOM = event.zrIsToLocalDOM;
	
	    if (eventControl !== 'only_globalout') {
	      this.dispatchToElement(this._hovered, 'mouseout', event);
	    }
	
	    if (eventControl !== 'no_globalout') {
	      // FIXME: if the pointer moving from the extra doms to realy "outside",
	      // the `globalout` should have been triggered. But currently not.
	      !zrIsToLocalDOM && this.trigger('globalout', {
	        type: 'globalout',
	        event: event
	      });
	    }
	  },
	
	  /**
	   * Resize
	   */
	  resize: function (event) {
	    this._hovered = {};
	  },
	
	  /**
	   * Dispatch event
	   * @param {string} eventName
	   * @param {event=} eventArgs
	   */
	  dispatch: function (eventName, eventArgs) {
	    var handler = this[eventName];
	    handler && handler.call(this, eventArgs);
	  },
	
	  /**
	   * Dispose
	   */
	  dispose: function () {
	    this.proxy.dispose();
	    this.storage = this.proxy = this.painter = null;
	  },
	
	  /**
	   * 设置默认的cursor style
	   * @param {string} [cursorStyle='default'] 例如 crosshair
	   */
	  setCursorStyle: function (cursorStyle) {
	    var proxy = this.proxy;
	    proxy.setCursor && proxy.setCursor(cursorStyle);
	  },
	
	  /**
	   * 事件分发代理
	   *
	   * @private
	   * @param {Object} targetInfo {target, topTarget} 目标图形元素
	   * @param {string} eventName 事件名称
	   * @param {Object} event 事件对象
	   */
	  dispatchToElement: function (targetInfo, eventName, event) {
	    targetInfo = targetInfo || {};
	    var el = targetInfo.target;
	
	    if (el && el.silent) {
	      return;
	    }
	
	    var eventHandler = 'on' + eventName;
	    var eventPacket = makeEventPacket(eventName, targetInfo, event);
	
	    while (el) {
	      el[eventHandler] && (eventPacket.cancelBubble = el[eventHandler].call(el, eventPacket));
	      el.trigger(eventName, eventPacket);
	      el = el.parent;
	
	      if (eventPacket.cancelBubble) {
	        break;
	      }
	    }
	
	    if (!eventPacket.cancelBubble) {
	      // 冒泡到顶级 zrender 对象
	      this.trigger(eventName, eventPacket); // 分发事件到用户自定义层
	      // 用户有可能在全局 click 事件中 dispose，所以需要判断下 painter 是否存在
	
	      this.painter && this.painter.eachOtherLayer(function (layer) {
	        if (typeof layer[eventHandler] === 'function') {
	          layer[eventHandler].call(layer, eventPacket);
	        }
	
	        if (layer.trigger) {
	          layer.trigger(eventName, eventPacket);
	        }
	      });
	    }
	  },
	
	  /**
	   * @private
	   * @param {number} x
	   * @param {number} y
	   * @param {module:zrender/graphic/Displayable} exclude
	   * @return {model:zrender/Element}
	   * @method
	   */
	  findHover: function (x, y, exclude) {
	    var list = this.storage.getDisplayList();
	    var out = {
	      x: x,
	      y: y
	    };
	
	    for (var i = list.length - 1; i >= 0; i--) {
	      var hoverCheckResult;
	
	      if (list[i] !== exclude // getDisplayList may include ignored item in VML mode
	      && !list[i].ignore && (hoverCheckResult = isHover(list[i], x, y))) {
	        !out.topTarget && (out.topTarget = list[i]);
	
	        if (hoverCheckResult !== SILENT) {
	          out.target = list[i];
	          break;
	        }
	      }
	    }
	
	    return out;
	  },
	  processGesture: function (event, stage) {
	    if (!this._gestureMgr) {
	      this._gestureMgr = new GestureMgr();
	    }
	
	    var gestureMgr = this._gestureMgr;
	    stage === 'start' && gestureMgr.clear();
	    var gestureInfo = gestureMgr.recognize(event, this.findHover(event.zrX, event.zrY, null).target, this.proxy.dom);
	    stage === 'end' && gestureMgr.clear(); // Do not do any preventDefault here. Upper application do that if necessary.
	
	    if (gestureInfo) {
	      var type = gestureInfo.type;
	      event.gestureEvent = type;
	      this.dispatchToElement({
	        target: gestureInfo.target
	      }, type, gestureInfo.event);
	    }
	  }
	}; // Common handlers
	
	util.each(['click', 'mousedown', 'mouseup', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  Handler.prototype[name] = function (event) {
	    var x = event.zrX;
	    var y = event.zrY;
	    var isOutside = isOutsideBoundary(this, x, y);
	    var hovered;
	    var hoveredTarget;
	
	    if (name !== 'mouseup' || !isOutside) {
	      // Find hover again to avoid click event is dispatched manually. Or click is triggered without mouseover
	      hovered = this.findHover(x, y);
	      hoveredTarget = hovered.target;
	    }
	
	    if (name === 'mousedown') {
	      this._downEl = hoveredTarget;
	      this._downPoint = [event.zrX, event.zrY]; // In case click triggered before mouseup
	
	      this._upEl = hoveredTarget;
	    } else if (name === 'mouseup') {
	      this._upEl = hoveredTarget;
	    } else if (name === 'click') {
	      if (this._downEl !== this._upEl // Original click event is triggered on the whole canvas element,
	      // including the case that `mousedown` - `mousemove` - `mouseup`,
	      // which should be filtered, otherwise it will bring trouble to
	      // pan and zoom.
	      || !this._downPoint // Arbitrary value
	      || vec2.dist(this._downPoint, [event.zrX, event.zrY]) > 4) {
	        return;
	      }
	
	      this._downPoint = null;
	    }
	
	    this.dispatchToElement(hovered, name, event);
	  };
	});
	
	function isHover(displayable, x, y) {
	  if (displayable[displayable.rectHover ? 'rectContain' : 'contain'](x, y)) {
	    var el = displayable;
	    var isSilent;
	
	    while (el) {
	      // If clipped by ancestor.
	      // FIXME: If clipPath has neither stroke nor fill,
	      // el.clipPath.contain(x, y) will always return false.
	      if (el.clipPath && !el.clipPath.contain(x, y)) {
	        return false;
	      }
	
	      if (el.silent) {
	        isSilent = true;
	      }
	
	      el = el.parent;
	    }
	
	    return isSilent ? SILENT : true;
	  }
	
	  return false;
	}
	/**
	 * See [Drag outside].
	 */
	
	
	function isOutsideBoundary(handlerInstance, x, y) {
	  var painter = handlerInstance.painter;
	  return x < 0 || x > painter.getWidth() || y < 0 || y > painter.getHeight();
	}
	
	util.mixin(Handler, Eventful);
	util.mixin(Handler, Draggable);
	var _default = Handler;
	module.exports = _default;

/***/ },
/* 2971 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4);
	
	var _config = __webpack_require__(392);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var Style = __webpack_require__(603);
	
	var Pattern = __webpack_require__(1198);
	
	/**
	 * @module zrender/Layer
	 * @author pissang(https://www.github.com/pissang)
	 */
	function returnFalse() {
	  return false;
	}
	/**
	 * 创建dom
	 *
	 * @inner
	 * @param {string} id dom id 待用
	 * @param {Painter} painter painter instance
	 * @param {number} number
	 */
	
	
	function createDom(id, painter, dpr) {
	  var newDom = util.createCanvas();
	  var width = painter.getWidth();
	  var height = painter.getHeight();
	  var newDomStyle = newDom.style;
	
	  if (newDomStyle) {
	    // In node or some other non-browser environment
	    newDomStyle.position = 'absolute';
	    newDomStyle.left = 0;
	    newDomStyle.top = 0;
	    newDomStyle.width = width + 'px';
	    newDomStyle.height = height + 'px';
	    newDom.setAttribute('data-zr-dom-id', id);
	  }
	
	  newDom.width = width * dpr;
	  newDom.height = height * dpr;
	  return newDom;
	}
	/**
	 * @alias module:zrender/Layer
	 * @constructor
	 * @extends module:zrender/mixin/Transformable
	 * @param {string} id
	 * @param {module:zrender/Painter} painter
	 * @param {number} [dpr]
	 */
	
	
	var Layer = function (id, painter, dpr) {
	  var dom;
	  dpr = dpr || devicePixelRatio;
	
	  if (typeof id === 'string') {
	    dom = createDom(id, painter, dpr);
	  } // Not using isDom because in node it will return false
	  else if (util.isObject(id)) {
	      dom = id;
	      id = dom.id;
	    }
	
	  this.id = id;
	  this.dom = dom;
	  var domStyle = dom.style;
	
	  if (domStyle) {
	    // Not in node
	    dom.onselectstart = returnFalse; // 避免页面选中的尴尬
	
	    domStyle['-webkit-user-select'] = 'none';
	    domStyle['user-select'] = 'none';
	    domStyle['-webkit-touch-callout'] = 'none';
	    domStyle['-webkit-tap-highlight-color'] = 'rgba(0,0,0,0)';
	    domStyle['padding'] = 0; // eslint-disable-line dot-notation
	
	    domStyle['margin'] = 0; // eslint-disable-line dot-notation
	
	    domStyle['border-width'] = 0;
	  }
	
	  this.domBack = null;
	  this.ctxBack = null;
	  this.painter = painter;
	  this.config = null; // Configs
	
	  /**
	   * 每次清空画布的颜色
	   * @type {string}
	   * @default 0
	   */
	
	  this.clearColor = 0;
	  /**
	   * 是否开启动态模糊
	   * @type {boolean}
	   * @default false
	   */
	
	  this.motionBlur = false;
	  /**
	   * 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   * @type {number}
	   * @default 0.7
	   */
	
	  this.lastFrameAlpha = 0.7;
	  /**
	   * Layer dpr
	   * @type {number}
	   */
	
	  this.dpr = dpr;
	};
	
	Layer.prototype = {
	  constructor: Layer,
	  __dirty: true,
	  __used: false,
	  __drawIndex: 0,
	  __startIndex: 0,
	  __endIndex: 0,
	  incremental: false,
	  getElementCount: function () {
	    return this.__endIndex - this.__startIndex;
	  },
	  initContext: function () {
	    this.ctx = this.dom.getContext('2d');
	    this.ctx.dpr = this.dpr;
	  },
	  createBackBuffer: function () {
	    var dpr = this.dpr;
	    this.domBack = createDom('back-' + this.id, this.painter, dpr);
	    this.ctxBack = this.domBack.getContext('2d');
	
	    if (dpr !== 1) {
	      this.ctxBack.scale(dpr, dpr);
	    }
	  },
	
	  /**
	   * @param  {number} width
	   * @param  {number} height
	   */
	  resize: function (width, height) {
	    var dpr = this.dpr;
	    var dom = this.dom;
	    var domStyle = dom.style;
	    var domBack = this.domBack;
	
	    if (domStyle) {
	      domStyle.width = width + 'px';
	      domStyle.height = height + 'px';
	    }
	
	    dom.width = width * dpr;
	    dom.height = height * dpr;
	
	    if (domBack) {
	      domBack.width = width * dpr;
	      domBack.height = height * dpr;
	
	      if (dpr !== 1) {
	        this.ctxBack.scale(dpr, dpr);
	      }
	    }
	  },
	
	  /**
	   * 清空该层画布
	   * @param {boolean} [clearAll]=false Clear all with out motion blur
	   * @param {Color} [clearColor]
	   */
	  clear: function (clearAll, clearColor) {
	    var dom = this.dom;
	    var ctx = this.ctx;
	    var width = dom.width;
	    var height = dom.height;
	    var clearColor = clearColor || this.clearColor;
	    var haveMotionBLur = this.motionBlur && !clearAll;
	    var lastFrameAlpha = this.lastFrameAlpha;
	    var dpr = this.dpr;
	
	    if (haveMotionBLur) {
	      if (!this.domBack) {
	        this.createBackBuffer();
	      }
	
	      this.ctxBack.globalCompositeOperation = 'copy';
	      this.ctxBack.drawImage(dom, 0, 0, width / dpr, height / dpr);
	    }
	
	    ctx.clearRect(0, 0, width, height);
	
	    if (clearColor && clearColor !== 'transparent') {
	      var clearColorGradientOrPattern; // Gradient
	
	      if (clearColor.colorStops) {
	        // Cache canvas gradient
	        clearColorGradientOrPattern = clearColor.__canvasGradient || Style.getGradient(ctx, clearColor, {
	          x: 0,
	          y: 0,
	          width: width,
	          height: height
	        });
	        clearColor.__canvasGradient = clearColorGradientOrPattern;
	      } // Pattern
	      else if (clearColor.image) {
	          clearColorGradientOrPattern = Pattern.prototype.getCanvasPattern.call(clearColor, ctx);
	        }
	
	      ctx.save();
	      ctx.fillStyle = clearColorGradientOrPattern || clearColor;
	      ctx.fillRect(0, 0, width, height);
	      ctx.restore();
	    }
	
	    if (haveMotionBLur) {
	      var domBack = this.domBack;
	      ctx.save();
	      ctx.globalAlpha = lastFrameAlpha;
	      ctx.drawImage(domBack, 0, 0, width, height);
	      ctx.restore();
	    }
	  }
	};
	var _default = Layer;
	module.exports = _default;

/***/ },
/* 2972 */
/***/ function(module, exports, __webpack_require__) {

	var _config = __webpack_require__(392);
	
	var devicePixelRatio = _config.devicePixelRatio;
	
	var util = __webpack_require__(4);
	
	var logError = __webpack_require__(315);
	
	var BoundingRect = __webpack_require__(60);
	
	var timsort = __webpack_require__(600);
	
	var Layer = __webpack_require__(2971);
	
	var requestAnimationFrame = __webpack_require__(1189);
	
	var Image = __webpack_require__(267);
	
	var env = __webpack_require__(73);
	
	var HOVER_LAYER_ZLEVEL = 1e5;
	var CANVAS_ZLEVEL = 314159;
	var EL_AFTER_INCREMENTAL_INC = 0.01;
	var INCREMENTAL_INC = 0.001;
	
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function isLayerValid(layer) {
	  if (!layer) {
	    return false;
	  }
	
	  if (layer.__builtin__) {
	    return true;
	  }
	
	  if (typeof layer.resize !== 'function' || typeof layer.refresh !== 'function') {
	    return false;
	  }
	
	  return true;
	}
	
	var tmpRect = new BoundingRect(0, 0, 0, 0);
	var viewRect = new BoundingRect(0, 0, 0, 0);
	
	function isDisplayableCulled(el, width, height) {
	  tmpRect.copy(el.getBoundingRect());
	
	  if (el.transform) {
	    tmpRect.applyTransform(el.transform);
	  }
	
	  viewRect.width = width;
	  viewRect.height = height;
	  return !tmpRect.intersect(viewRect);
	}
	
	function isClipPathChanged(clipPaths, prevClipPaths) {
	  // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
	  if (clipPaths === prevClipPaths) {
	    return false;
	  }
	
	  if (!clipPaths || !prevClipPaths || clipPaths.length !== prevClipPaths.length) {
	    return true;
	  }
	
	  for (var i = 0; i < clipPaths.length; i++) {
	    if (clipPaths[i] !== prevClipPaths[i]) {
	      return true;
	    }
	  }
	
	  return false;
	}
	
	function doClip(clipPaths, ctx) {
	  for (var i = 0; i < clipPaths.length; i++) {
	    var clipPath = clipPaths[i];
	    clipPath.setTransform(ctx);
	    ctx.beginPath();
	    clipPath.buildPath(ctx, clipPath.shape);
	    ctx.clip(); // Transform back
	
	    clipPath.restoreTransform(ctx);
	  }
	}
	
	function createRoot(width, height) {
	  var domRoot = document.createElement('div'); // domRoot.onselectstart = returnFalse; // Avoid page selected
	
	  domRoot.style.cssText = ['position:relative', // IOS13 safari probably has a compositing bug (z order of the canvas and the consequent
	  // dom does not act as expected) when some of the parent dom has
	  // `-webkit-overflow-scrolling: touch;` and the webpage is longer than one screen and
	  // the canvas is not at the top part of the page.
	  // Check `https://bugs.webkit.org/show_bug.cgi?id=203681` for more details. We remove
	  // this `overflow:hidden` to avoid the bug.
	  // 'overflow:hidden',
	  'width:' + width + 'px', 'height:' + height + 'px', 'padding:0', 'margin:0', 'border-width:0'].join(';') + ';';
	  return domRoot;
	}
	/**
	 * @alias module:zrender/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var Painter = function (root, storage, opts) {
	  this.type = 'canvas'; // In node environment using node-canvas
	
	  var singleCanvas = !root.nodeName // In node ?
	  || root.nodeName.toUpperCase() === 'CANVAS';
	  this._opts = opts = util.extend({}, opts || {});
	  /**
	   * @type {number}
	   */
	
	  this.dpr = opts.devicePixelRatio || devicePixelRatio;
	  /**
	   * @type {boolean}
	   * @private
	   */
	
	  this._singleCanvas = singleCanvas;
	  /**
	   * 绘图容器
	   * @type {HTMLElement}
	   */
	
	  this.root = root;
	  var rootStyle = root.style;
	
	  if (rootStyle) {
	    rootStyle['-webkit-tap-highlight-color'] = 'transparent';
	    rootStyle['-webkit-user-select'] = rootStyle['user-select'] = rootStyle['-webkit-touch-callout'] = 'none';
	    root.innerHTML = '';
	  }
	  /**
	   * @type {module:zrender/Storage}
	   */
	
	
	  this.storage = storage;
	  /**
	   * @type {Array.<number>}
	   * @private
	   */
	
	  var zlevelList = this._zlevelList = [];
	  /**
	   * @type {Object.<string, module:zrender/Layer>}
	   * @private
	   */
	
	  var layers = this._layers = {};
	  /**
	   * @type {Object.<string, Object>}
	   * @private
	   */
	
	  this._layerConfig = {};
	  /**
	   * zrender will do compositing when root is a canvas and have multiple zlevels.
	   */
	
	  this._needsManuallyCompositing = false;
	
	  if (!singleCanvas) {
	    this._width = this._getSize(0);
	    this._height = this._getSize(1);
	    var domRoot = this._domRoot = createRoot(this._width, this._height);
	    root.appendChild(domRoot);
	  } else {
	    var width = root.width;
	    var height = root.height;
	
	    if (opts.width != null) {
	      width = opts.width;
	    }
	
	    if (opts.height != null) {
	      height = opts.height;
	    }
	
	    this.dpr = opts.devicePixelRatio || 1; // Use canvas width and height directly
	
	    root.width = width * this.dpr;
	    root.height = height * this.dpr;
	    this._width = width;
	    this._height = height; // Create layer if only one given canvas
	    // Device can be specified to create a high dpi image.
	
	    var mainLayer = new Layer(root, this, this.dpr);
	    mainLayer.__builtin__ = true;
	    mainLayer.initContext(); // FIXME Use canvas width and height
	    // mainLayer.resize(width, height);
	
	    layers[CANVAS_ZLEVEL] = mainLayer;
	    mainLayer.zlevel = CANVAS_ZLEVEL; // Not use common zlevel.
	
	    zlevelList.push(CANVAS_ZLEVEL);
	    this._domRoot = root;
	  }
	  /**
	   * @type {module:zrender/Layer}
	   * @private
	   */
	
	
	  this._hoverlayer = null;
	  this._hoverElements = [];
	};
	
	Painter.prototype = {
	  constructor: Painter,
	  getType: function () {
	    return 'canvas';
	  },
	
	  /**
	   * If painter use a single canvas
	   * @return {boolean}
	   */
	  isSingleCanvas: function () {
	    return this._singleCanvas;
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._domRoot;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   * @param {boolean} [paintAll=false] 强制绘制所有displayable
	   */
	  refresh: function (paintAll) {
	    var list = this.storage.getDisplayList(true);
	    var zlevelList = this._zlevelList;
	    this._redrawId = Math.random();
	
	    this._paintList(list, paintAll, this._redrawId); // Paint custum layers
	
	
	    for (var i = 0; i < zlevelList.length; i++) {
	      var z = zlevelList[i];
	      var layer = this._layers[z];
	
	      if (!layer.__builtin__ && layer.refresh) {
	        var clearColor = i === 0 ? this._backgroundColor : null;
	        layer.refresh(clearColor);
	      }
	    }
	
	    this.refreshHover();
	    return this;
	  },
	  addHover: function (el, hoverStyle) {
	    if (el.__hoverMir) {
	      return;
	    }
	
	    var elMirror = new el.constructor({
	      style: el.style,
	      shape: el.shape,
	      z: el.z,
	      z2: el.z2,
	      silent: el.silent
	    });
	    elMirror.__from = el;
	    el.__hoverMir = elMirror;
	    hoverStyle && elMirror.setStyle(hoverStyle);
	
	    this._hoverElements.push(elMirror);
	
	    return elMirror;
	  },
	  removeHover: function (el) {
	    var elMirror = el.__hoverMir;
	    var hoverElements = this._hoverElements;
	    var idx = util.indexOf(hoverElements, elMirror);
	
	    if (idx >= 0) {
	      hoverElements.splice(idx, 1);
	    }
	
	    el.__hoverMir = null;
	  },
	  clearHover: function (el) {
	    var hoverElements = this._hoverElements;
	
	    for (var i = 0; i < hoverElements.length; i++) {
	      var from = hoverElements[i].__from;
	
	      if (from) {
	        from.__hoverMir = null;
	      }
	    }
	
	    hoverElements.length = 0;
	  },
	  refreshHover: function () {
	    var hoverElements = this._hoverElements;
	    var len = hoverElements.length;
	    var hoverLayer = this._hoverlayer;
	    hoverLayer && hoverLayer.clear();
	
	    if (!len) {
	      return;
	    }
	
	    timsort(hoverElements, this.storage.displayableSortFunc); // Use a extream large zlevel
	    // FIXME?
	
	    if (!hoverLayer) {
	      hoverLayer = this._hoverlayer = this.getLayer(HOVER_LAYER_ZLEVEL);
	    }
	
	    var scope = {};
	    hoverLayer.ctx.save();
	
	    for (var i = 0; i < len;) {
	      var el = hoverElements[i];
	      var originalEl = el.__from; // Original el is removed
	      // PENDING
	
	      if (!(originalEl && originalEl.__zr)) {
	        hoverElements.splice(i, 1);
	        originalEl.__hoverMir = null;
	        len--;
	        continue;
	      }
	
	      i++; // Use transform
	      // FIXME style and shape ?
	
	      if (!originalEl.invisible) {
	        el.transform = originalEl.transform;
	        el.invTransform = originalEl.invTransform;
	        el.__clipPaths = originalEl.__clipPaths; // el.
	
	        this._doPaintEl(el, hoverLayer, true, scope);
	      }
	    }
	
	    hoverLayer.ctx.restore();
	  },
	  getHoverLayer: function () {
	    return this.getLayer(HOVER_LAYER_ZLEVEL);
	  },
	  _paintList: function (list, paintAll, redrawId) {
	    if (this._redrawId !== redrawId) {
	      return;
	    }
	
	    paintAll = paintAll || false;
	
	    this._updateLayerStatus(list);
	
	    var finished = this._doPaintList(list, paintAll);
	
	    if (this._needsManuallyCompositing) {
	      this._compositeManually();
	    }
	
	    if (!finished) {
	      var self = this;
	      requestAnimationFrame(function () {
	        self._paintList(list, paintAll, redrawId);
	      });
	    }
	  },
	  _compositeManually: function () {
	    var ctx = this.getLayer(CANVAS_ZLEVEL).ctx;
	    var width = this._domRoot.width;
	    var height = this._domRoot.height;
	    ctx.clearRect(0, 0, width, height); // PENDING, If only builtin layer?
	
	    this.eachBuiltinLayer(function (layer) {
	      if (layer.virtual) {
	        ctx.drawImage(layer.dom, 0, 0, width, height);
	      }
	    });
	  },
	  _doPaintList: function (list, paintAll) {
	    var layerList = [];
	
	    for (var zi = 0; zi < this._zlevelList.length; zi++) {
	      var zlevel = this._zlevelList[zi];
	      var layer = this._layers[zlevel];
	
	      if (layer.__builtin__ && layer !== this._hoverlayer && (layer.__dirty || paintAll)) {
	        layerList.push(layer);
	      }
	    }
	
	    var finished = true;
	
	    for (var k = 0; k < layerList.length; k++) {
	      var layer = layerList[k];
	      var ctx = layer.ctx;
	      var scope = {};
	      ctx.save();
	      var start = paintAll ? layer.__startIndex : layer.__drawIndex;
	      var useTimer = !paintAll && layer.incremental && Date.now;
	      var startTime = useTimer && Date.now();
	      var clearColor = layer.zlevel === this._zlevelList[0] ? this._backgroundColor : null; // All elements in this layer are cleared.
	
	      if (layer.__startIndex === layer.__endIndex) {
	        layer.clear(false, clearColor);
	      } else if (start === layer.__startIndex) {
	        var firstEl = list[start];
	
	        if (!firstEl.incremental || !firstEl.notClear || paintAll) {
	          layer.clear(false, clearColor);
	        }
	      }
	
	      if (start === -1) {
	        console.error('For some unknown reason. drawIndex is -1');
	        start = layer.__startIndex;
	      }
	
	      for (var i = start; i < layer.__endIndex; i++) {
	        var el = list[i];
	
	        this._doPaintEl(el, layer, paintAll, scope);
	
	        el.__dirty = el.__dirtyText = false;
	
	        if (useTimer) {
	          // Date.now can be executed in 13,025,305 ops/second.
	          var dTime = Date.now() - startTime; // Give 15 millisecond to draw.
	          // The rest elements will be drawn in the next frame.
	
	          if (dTime > 15) {
	            break;
	          }
	        }
	      }
	
	      layer.__drawIndex = i;
	
	      if (layer.__drawIndex < layer.__endIndex) {
	        finished = false;
	      }
	
	      if (scope.prevElClipPaths) {
	        // Needs restore the state. If last drawn element is in the clipping area.
	        ctx.restore();
	      }
	
	      ctx.restore();
	    }
	
	    if (env.wxa) {
	      // Flush for weixin application
	      util.each(this._layers, function (layer) {
	        if (layer && layer.ctx && layer.ctx.draw) {
	          layer.ctx.draw();
	        }
	      });
	    }
	
	    return finished;
	  },
	  _doPaintEl: function (el, currentLayer, forcePaint, scope) {
	    var ctx = currentLayer.ctx;
	    var m = el.transform;
	
	    if ((currentLayer.__dirty || forcePaint) && // Ignore invisible element
	    !el.invisible // Ignore transparent element
	    && el.style.opacity !== 0 // Ignore scale 0 element, in some environment like node-canvas
	    // Draw a scale 0 element can cause all following draw wrong
	    // And setTransform with scale 0 will cause set back transform failed.
	    && !(m && !m[0] && !m[3]) // Ignore culled element
	    && !(el.culling && isDisplayableCulled(el, this._width, this._height))) {
	      var clipPaths = el.__clipPaths;
	      var prevElClipPaths = scope.prevElClipPaths; // Optimize when clipping on group with several elements
	
	      if (!prevElClipPaths || isClipPathChanged(clipPaths, prevElClipPaths)) {
	        // If has previous clipping state, restore from it
	        if (prevElClipPaths) {
	          ctx.restore();
	          scope.prevElClipPaths = null; // Reset prevEl since context has been restored
	
	          scope.prevEl = null;
	        } // New clipping state
	
	
	        if (clipPaths) {
	          ctx.save();
	          doClip(clipPaths, ctx);
	          scope.prevElClipPaths = clipPaths;
	        }
	      }
	
	      el.beforeBrush && el.beforeBrush(ctx);
	      el.brush(ctx, scope.prevEl || null);
	      scope.prevEl = el;
	      el.afterBrush && el.afterBrush(ctx);
	    }
	  },
	
	  /**
	   * 获取 zlevel 所在层，如果不存在则会创建一个新的层
	   * @param {number} zlevel
	   * @param {boolean} virtual Virtual layer will not be inserted into dom.
	   * @return {module:zrender/Layer}
	   */
	  getLayer: function (zlevel, virtual) {
	    if (this._singleCanvas && !this._needsManuallyCompositing) {
	      zlevel = CANVAS_ZLEVEL;
	    }
	
	    var layer = this._layers[zlevel];
	
	    if (!layer) {
	      // Create a new layer
	      layer = new Layer('zr_' + zlevel, this, this.dpr);
	      layer.zlevel = zlevel;
	      layer.__builtin__ = true;
	
	      if (this._layerConfig[zlevel]) {
	        util.merge(layer, this._layerConfig[zlevel], true);
	      } // TODO Remove EL_AFTER_INCREMENTAL_INC magic number
	      else if (this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC]) {
	          util.merge(layer, this._layerConfig[zlevel - EL_AFTER_INCREMENTAL_INC], true);
	        }
	
	      if (virtual) {
	        layer.virtual = virtual;
	      }
	
	      this.insertLayer(zlevel, layer); // Context is created after dom inserted to document
	      // Or excanvas will get 0px clientWidth and clientHeight
	
	      layer.initContext();
	    }
	
	    return layer;
	  },
	  insertLayer: function (zlevel, layer) {
	    var layersMap = this._layers;
	    var zlevelList = this._zlevelList;
	    var len = zlevelList.length;
	    var prevLayer = null;
	    var i = -1;
	    var domRoot = this._domRoot;
	
	    if (layersMap[zlevel]) {
	      logError('ZLevel ' + zlevel + ' has been used already');
	      return;
	    } // Check if is a valid layer
	
	
	    if (!isLayerValid(layer)) {
	      logError('Layer of zlevel ' + zlevel + ' is not valid');
	      return;
	    }
	
	    if (len > 0 && zlevel > zlevelList[0]) {
	      for (i = 0; i < len - 1; i++) {
	        if (zlevelList[i] < zlevel && zlevelList[i + 1] > zlevel) {
	          break;
	        }
	      }
	
	      prevLayer = layersMap[zlevelList[i]];
	    }
	
	    zlevelList.splice(i + 1, 0, zlevel);
	    layersMap[zlevel] = layer; // Vitual layer will not directly show on the screen.
	    // (It can be a WebGL layer and assigned to a ZImage element)
	    // But it still under management of zrender.
	
	    if (!layer.virtual) {
	      if (prevLayer) {
	        var prevDom = prevLayer.dom;
	
	        if (prevDom.nextSibling) {
	          domRoot.insertBefore(layer.dom, prevDom.nextSibling);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      } else {
	        if (domRoot.firstChild) {
	          domRoot.insertBefore(layer.dom, domRoot.firstChild);
	        } else {
	          domRoot.appendChild(layer.dom);
	        }
	      }
	    }
	  },
	  // Iterate each layer
	  eachLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      cb.call(context, this._layers[z], z);
	    }
	  },
	  // Iterate each buildin layer
	  eachBuiltinLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	  // Iterate each other layer except buildin layer
	  eachOtherLayer: function (cb, context) {
	    var zlevelList = this._zlevelList;
	    var layer;
	    var z;
	    var i;
	
	    for (i = 0; i < zlevelList.length; i++) {
	      z = zlevelList[i];
	      layer = this._layers[z];
	
	      if (!layer.__builtin__) {
	        cb.call(context, layer, z);
	      }
	    }
	  },
	
	  /**
	   * 获取所有已创建的层
	   * @param {Array.<module:zrender/Layer>} [prevLayer]
	   */
	  getLayers: function () {
	    return this._layers;
	  },
	  _updateLayerStatus: function (list) {
	    this.eachBuiltinLayer(function (layer, z) {
	      layer.__dirty = layer.__used = false;
	    });
	
	    function updatePrevLayer(idx) {
	      if (prevLayer) {
	        if (prevLayer.__endIndex !== idx) {
	          prevLayer.__dirty = true;
	        }
	
	        prevLayer.__endIndex = idx;
	      }
	    }
	
	    if (this._singleCanvas) {
	      for (var i = 1; i < list.length; i++) {
	        var el = list[i];
	
	        if (el.zlevel !== list[i - 1].zlevel || el.incremental) {
	          this._needsManuallyCompositing = true;
	          break;
	        }
	      }
	    }
	
	    var prevLayer = null;
	    var incrementalLayerCount = 0;
	    var prevZlevel;
	
	    for (var i = 0; i < list.length; i++) {
	      var el = list[i];
	      var zlevel = el.zlevel;
	      var layer;
	
	      if (prevZlevel !== zlevel) {
	        prevZlevel = zlevel;
	        incrementalLayerCount = 0;
	      } // TODO Not use magic number on zlevel.
	      // Each layer with increment element can be separated to 3 layers.
	      //          (Other Element drawn after incremental element)
	      // -----------------zlevel + EL_AFTER_INCREMENTAL_INC--------------------
	      //                      (Incremental element)
	      // ----------------------zlevel + INCREMENTAL_INC------------------------
	      //              (Element drawn before incremental element)
	      // --------------------------------zlevel--------------------------------
	
	
	      if (el.incremental) {
	        layer = this.getLayer(zlevel + INCREMENTAL_INC, this._needsManuallyCompositing);
	        layer.incremental = true;
	        incrementalLayerCount = 1;
	      } else {
	        layer = this.getLayer(zlevel + (incrementalLayerCount > 0 ? EL_AFTER_INCREMENTAL_INC : 0), this._needsManuallyCompositing);
	      }
	
	      if (!layer.__builtin__) {
	        logError('ZLevel ' + zlevel + ' has been used by unkown layer ' + layer.id);
	      }
	
	      if (layer !== prevLayer) {
	        layer.__used = true;
	
	        if (layer.__startIndex !== i) {
	          layer.__dirty = true;
	        }
	
	        layer.__startIndex = i;
	
	        if (!layer.incremental) {
	          layer.__drawIndex = i;
	        } else {
	          // Mark layer draw index needs to update.
	          layer.__drawIndex = -1;
	        }
	
	        updatePrevLayer(i);
	        prevLayer = layer;
	      }
	
	      if (el.__dirty) {
	        layer.__dirty = true;
	
	        if (layer.incremental && layer.__drawIndex < 0) {
	          // Start draw from the first dirty element.
	          layer.__drawIndex = i;
	        }
	      }
	    }
	
	    updatePrevLayer(i);
	    this.eachBuiltinLayer(function (layer, z) {
	      // Used in last frame but not in this frame. Needs clear
	      if (!layer.__used && layer.getElementCount() > 0) {
	        layer.__dirty = true;
	        layer.__startIndex = layer.__endIndex = layer.__drawIndex = 0;
	      } // For incremental layer. In case start index changed and no elements are dirty.
	
	
	      if (layer.__dirty && layer.__drawIndex < 0) {
	        layer.__drawIndex = layer.__startIndex;
	      }
	    });
	  },
	
	  /**
	   * 清除hover层外所有内容
	   */
	  clear: function () {
	    this.eachBuiltinLayer(this._clearLayer);
	    return this;
	  },
	  _clearLayer: function (layer) {
	    layer.clear();
	  },
	  setBackgroundColor: function (backgroundColor) {
	    this._backgroundColor = backgroundColor;
	  },
	
	  /**
	   * 修改指定zlevel的绘制参数
	   *
	   * @param {string} zlevel
	   * @param {Object} config 配置对象
	   * @param {string} [config.clearColor=0] 每次清空画布的颜色
	   * @param {string} [config.motionBlur=false] 是否开启动态模糊
	   * @param {number} [config.lastFrameAlpha=0.7]
	   *                 在开启动态模糊的时候使用，与上一帧混合的alpha值，值越大尾迹越明显
	   */
	  configLayer: function (zlevel, config) {
	    if (config) {
	      var layerConfig = this._layerConfig;
	
	      if (!layerConfig[zlevel]) {
	        layerConfig[zlevel] = config;
	      } else {
	        util.merge(layerConfig[zlevel], config, true);
	      }
	
	      for (var i = 0; i < this._zlevelList.length; i++) {
	        var _zlevel = this._zlevelList[i]; // TODO Remove EL_AFTER_INCREMENTAL_INC magic number
	
	        if (_zlevel === zlevel || _zlevel === zlevel + EL_AFTER_INCREMENTAL_INC) {
	          var layer = this._layers[_zlevel];
	          util.merge(layer, layerConfig[zlevel], true);
	        }
	      }
	    }
	  },
	
	  /**
	   * 删除指定层
	   * @param {number} zlevel 层所在的zlevel
	   */
	  delLayer: function (zlevel) {
	    var layers = this._layers;
	    var zlevelList = this._zlevelList;
	    var layer = layers[zlevel];
	
	    if (!layer) {
	      return;
	    }
	
	    layer.dom.parentNode.removeChild(layer.dom);
	    delete layers[zlevel];
	    zlevelList.splice(util.indexOf(zlevelList, zlevel), 1);
	  },
	
	  /**
	   * 区域大小变化后重绘
	   */
	  resize: function (width, height) {
	    if (!this._domRoot.style) {
	      // Maybe in node or worker
	      if (width == null || height == null) {
	        return;
	      }
	
	      this._width = width;
	      this._height = height;
	      this.getLayer(CANVAS_ZLEVEL).resize(width, height);
	    } else {
	      var domRoot = this._domRoot; // FIXME Why ?
	
	      domRoot.style.display = 'none'; // Save input w/h
	
	      var opts = this._opts;
	      width != null && (opts.width = width);
	      height != null && (opts.height = height);
	      width = this._getSize(0);
	      height = this._getSize(1);
	      domRoot.style.display = ''; // 优化没有实际改变的resize
	
	      if (this._width !== width || height !== this._height) {
	        domRoot.style.width = width + 'px';
	        domRoot.style.height = height + 'px';
	
	        for (var id in this._layers) {
	          if (this._layers.hasOwnProperty(id)) {
	            this._layers[id].resize(width, height);
	          }
	        }
	
	        util.each(this._progressiveLayers, function (layer) {
	          layer.resize(width, height);
	        });
	        this.refresh(true);
	      }
	
	      this._width = width;
	      this._height = height;
	    }
	
	    return this;
	  },
	
	  /**
	   * 清除单独的一个层
	   * @param {number} zlevel
	   */
	  clearLayer: function (zlevel) {
	    var layer = this._layers[zlevel];
	
	    if (layer) {
	      layer.clear();
	    }
	  },
	
	  /**
	   * 释放
	   */
	  dispose: function () {
	    this.root.innerHTML = '';
	    this.root = this.storage = this._domRoot = this._layers = null;
	  },
	
	  /**
	   * Get canvas which has all thing rendered
	   * @param {Object} opts
	   * @param {string} [opts.backgroundColor]
	   * @param {number} [opts.pixelRatio]
	   */
	  getRenderedCanvas: function (opts) {
	    opts = opts || {};
	
	    if (this._singleCanvas && !this._compositeManually) {
	      return this._layers[CANVAS_ZLEVEL].dom;
	    }
	
	    var imageLayer = new Layer('image', this, opts.pixelRatio || this.dpr);
	    imageLayer.initContext();
	    imageLayer.clear(false, opts.backgroundColor || this._backgroundColor);
	
	    if (opts.pixelRatio <= this.dpr) {
	      this.refresh();
	      var width = imageLayer.dom.width;
	      var height = imageLayer.dom.height;
	      var ctx = imageLayer.ctx;
	      this.eachLayer(function (layer) {
	        if (layer.__builtin__) {
	          ctx.drawImage(layer.dom, 0, 0, width, height);
	        } else if (layer.renderToCanvas) {
	          imageLayer.ctx.save();
	          layer.renderToCanvas(imageLayer.ctx);
	          imageLayer.ctx.restore();
	        }
	      });
	    } else {
	      // PENDING, echarts-gl and incremental rendering.
	      var scope = {};
	      var displayList = this.storage.getDisplayList(true);
	
	      for (var i = 0; i < displayList.length; i++) {
	        var el = displayList[i];
	
	        this._doPaintEl(el, imageLayer, true, scope);
	      }
	    }
	
	    return imageLayer.dom;
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  pathToImage: function (path, dpr) {
	    dpr = dpr || this.dpr;
	    var canvas = document.createElement('canvas');
	    var ctx = canvas.getContext('2d');
	    var rect = path.getBoundingRect();
	    var style = path.style;
	    var shadowBlurSize = style.shadowBlur * dpr;
	    var shadowOffsetX = style.shadowOffsetX * dpr;
	    var shadowOffsetY = style.shadowOffsetY * dpr;
	    var lineWidth = style.hasStroke() ? style.lineWidth : 0;
	    var leftMargin = Math.max(lineWidth / 2, -shadowOffsetX + shadowBlurSize);
	    var rightMargin = Math.max(lineWidth / 2, shadowOffsetX + shadowBlurSize);
	    var topMargin = Math.max(lineWidth / 2, -shadowOffsetY + shadowBlurSize);
	    var bottomMargin = Math.max(lineWidth / 2, shadowOffsetY + shadowBlurSize);
	    var width = rect.width + leftMargin + rightMargin;
	    var height = rect.height + topMargin + bottomMargin;
	    canvas.width = width * dpr;
	    canvas.height = height * dpr;
	    ctx.scale(dpr, dpr);
	    ctx.clearRect(0, 0, width, height);
	    ctx.dpr = dpr;
	    var pathTransform = {
	      position: path.position,
	      rotation: path.rotation,
	      scale: path.scale
	    };
	    path.position = [leftMargin - rect.x, topMargin - rect.y];
	    path.rotation = 0;
	    path.scale = [1, 1];
	    path.updateTransform();
	
	    if (path) {
	      path.brush(ctx);
	    }
	
	    var ImageShape = Image;
	    var imgShape = new ImageShape({
	      style: {
	        x: 0,
	        y: 0,
	        image: canvas
	      }
	    });
	
	    if (pathTransform.position != null) {
	      imgShape.position = path.position = pathTransform.position;
	    }
	
	    if (pathTransform.rotation != null) {
	      imgShape.rotation = path.rotation = pathTransform.rotation;
	    }
	
	    if (pathTransform.scale != null) {
	      imgShape.scale = path.scale = pathTransform.scale;
	    }
	
	    return imgShape;
	  }
	};
	var _default = Painter;
	module.exports = _default;

/***/ },
/* 2973 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4);
	
	var env = __webpack_require__(73);
	
	var Group = __webpack_require__(223);
	
	var timsort = __webpack_require__(600);
	
	// Use timsort because in most case elements are partially sorted
	// https://jsfiddle.net/pissang/jr4x7mdm/8/
	function shapeCompareFunc(a, b) {
	  if (a.zlevel === b.zlevel) {
	    if (a.z === b.z) {
	      // if (a.z2 === b.z2) {
	      //     // FIXME Slow has renderidx compare
	      //     // http://stackoverflow.com/questions/20883421/sorting-in-javascript-should-every-compare-function-have-a-return-0-statement
	      //     // https://github.com/v8/v8/blob/47cce544a31ed5577ffe2963f67acb4144ee0232/src/js/array.js#L1012
	      //     return a.__renderidx - b.__renderidx;
	      // }
	      return a.z2 - b.z2;
	    }
	
	    return a.z - b.z;
	  }
	
	  return a.zlevel - b.zlevel;
	}
	/**
	 * 内容仓库 (M)
	 * @alias module:zrender/Storage
	 * @constructor
	 */
	
	
	var Storage = function () {
	  // jshint ignore:line
	  this._roots = [];
	  this._displayList = [];
	  this._displayListLen = 0;
	};
	
	Storage.prototype = {
	  constructor: Storage,
	
	  /**
	   * @param  {Function} cb
	   *
	   */
	  traverse: function (cb, context) {
	    for (var i = 0; i < this._roots.length; i++) {
	      this._roots[i].traverse(cb, context);
	    }
	  },
	
	  /**
	   * 返回所有图形的绘制队列
	   * @param {boolean} [update=false] 是否在返回前更新该数组
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组, 在 update 为 true 的时候有效
	   *
	   * 详见{@link module:zrender/graphic/Displayable.prototype.updateDisplayList}
	   * @return {Array.<module:zrender/graphic/Displayable>}
	   */
	  getDisplayList: function (update, includeIgnore) {
	    includeIgnore = includeIgnore || false;
	
	    if (update) {
	      this.updateDisplayList(includeIgnore);
	    }
	
	    return this._displayList;
	  },
	
	  /**
	   * 更新图形的绘制队列。
	   * 每次绘制前都会调用，该方法会先深度优先遍历整个树，更新所有Group和Shape的变换并且把所有可见的Shape保存到数组中，
	   * 最后根据绘制的优先级（zlevel > z > 插入顺序）排序得到绘制队列
	   * @param {boolean} [includeIgnore=false] 是否包含 ignore 的数组
	   */
	  updateDisplayList: function (includeIgnore) {
	    this._displayListLen = 0;
	    var roots = this._roots;
	    var displayList = this._displayList;
	
	    for (var i = 0, len = roots.length; i < len; i++) {
	      this._updateAndAddDisplayable(roots[i], null, includeIgnore);
	    }
	
	    displayList.length = this._displayListLen;
	    env.canvasSupported && timsort(displayList, shapeCompareFunc);
	  },
	  _updateAndAddDisplayable: function (el, clipPaths, includeIgnore) {
	    if (el.ignore && !includeIgnore) {
	      return;
	    }
	
	    el.beforeUpdate();
	
	    if (el.__dirty) {
	      el.update();
	    }
	
	    el.afterUpdate();
	    var userSetClipPath = el.clipPath;
	
	    if (userSetClipPath) {
	      // FIXME 效率影响
	      if (clipPaths) {
	        clipPaths = clipPaths.slice();
	      } else {
	        clipPaths = [];
	      }
	
	      var currentClipPath = userSetClipPath;
	      var parentClipPath = el; // Recursively add clip path
	
	      while (currentClipPath) {
	        // clipPath 的变换是基于使用这个 clipPath 的元素
	        currentClipPath.parent = parentClipPath;
	        currentClipPath.updateTransform();
	        clipPaths.push(currentClipPath);
	        parentClipPath = currentClipPath;
	        currentClipPath = currentClipPath.clipPath;
	      }
	    }
	
	    if (el.isGroup) {
	      var children = el._children;
	
	      for (var i = 0; i < children.length; i++) {
	        var child = children[i]; // Force to mark as dirty if group is dirty
	        // FIXME __dirtyPath ?
	
	        if (el.__dirty) {
	          child.__dirty = true;
	        }
	
	        this._updateAndAddDisplayable(child, clipPaths, includeIgnore);
	      } // Mark group clean here
	
	
	      el.__dirty = false;
	    } else {
	      el.__clipPaths = clipPaths;
	      this._displayList[this._displayListLen++] = el;
	    }
	  },
	
	  /**
	   * 添加图形(Shape)或者组(Group)到根节点
	   * @param {module:zrender/Element} el
	   */
	  addRoot: function (el) {
	    if (el.__storage === this) {
	      return;
	    }
	
	    if (el instanceof Group) {
	      el.addChildrenToStorage(this);
	    }
	
	    this.addToStorage(el);
	
	    this._roots.push(el);
	  },
	
	  /**
	   * 删除指定的图形(Shape)或者组(Group)
	   * @param {string|Array.<string>} [el] 如果为空清空整个Storage
	   */
	  delRoot: function (el) {
	    if (el == null) {
	      // 不指定el清空
	      for (var i = 0; i < this._roots.length; i++) {
	        var root = this._roots[i];
	
	        if (root instanceof Group) {
	          root.delChildrenFromStorage(this);
	        }
	      }
	
	      this._roots = [];
	      this._displayList = [];
	      this._displayListLen = 0;
	      return;
	    }
	
	    if (el instanceof Array) {
	      for (var i = 0, l = el.length; i < l; i++) {
	        this.delRoot(el[i]);
	      }
	
	      return;
	    }
	
	    var idx = util.indexOf(this._roots, el);
	
	    if (idx >= 0) {
	      this.delFromStorage(el);
	
	      this._roots.splice(idx, 1);
	
	      if (el instanceof Group) {
	        el.delChildrenFromStorage(this);
	      }
	    }
	  },
	  addToStorage: function (el) {
	    if (el) {
	      el.__storage = this;
	      el.dirty(false);
	    }
	
	    return this;
	  },
	  delFromStorage: function (el) {
	    if (el) {
	      el.__storage = null;
	    }
	
	    return this;
	  },
	
	  /**
	   * 清空并且释放Storage
	   */
	  dispose: function () {
	    this._renderList = this._roots = null;
	  },
	  displayableSortFunc: shapeCompareFunc
	};
	var _default = Storage;
	module.exports = _default;

/***/ },
/* 2974 */
/***/ function(module, exports, __webpack_require__) {

	var util = __webpack_require__(4);
	
	var _event = __webpack_require__(147);
	
	var Dispatcher = _event.Dispatcher;
	
	var requestAnimationFrame = __webpack_require__(1189);
	
	var Animator = __webpack_require__(1188);
	
	/**
	 * Animation main class, dispatch and manage all animation controllers
	 *
	 * @module zrender/animation/Animation
	 * @author pissang(https://github.com/pissang)
	 */
	// TODO Additive animation
	// http://iosoteric.com/additive-animations-animatewithduration-in-ios-8/
	// https://developer.apple.com/videos/wwdc2014/#236
	
	/**
	 * @typedef {Object} IZRenderStage
	 * @property {Function} update
	 */
	
	/**
	 * @alias module:zrender/animation/Animation
	 * @constructor
	 * @param {Object} [options]
	 * @param {Function} [options.onframe]
	 * @param {IZRenderStage} [options.stage]
	 * @example
	 *     var animation = new Animation();
	 *     var obj = {
	 *         x: 100,
	 *         y: 100
	 *     };
	 *     animation.animate(node.position)
	 *         .when(1000, {
	 *             x: 500,
	 *             y: 500
	 *         })
	 *         .when(2000, {
	 *             x: 100,
	 *             y: 100
	 *         })
	 *         .start('spline');
	 */
	var Animation = function (options) {
	  options = options || {};
	  this.stage = options.stage || {};
	
	  this.onframe = options.onframe || function () {}; // private properties
	
	
	  this._clips = [];
	  this._running = false;
	  this._time;
	  this._pausedTime;
	  this._pauseStart;
	  this._paused = false;
	  Dispatcher.call(this);
	};
	
	Animation.prototype = {
	  constructor: Animation,
	
	  /**
	   * Add clip
	   * @param {module:zrender/animation/Clip} clip
	   */
	  addClip: function (clip) {
	    this._clips.push(clip);
	  },
	
	  /**
	   * Add animator
	   * @param {module:zrender/animation/Animator} animator
	   */
	  addAnimator: function (animator) {
	    animator.animation = this;
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.addClip(clips[i]);
	    }
	  },
	
	  /**
	   * Delete animation clip
	   * @param {module:zrender/animation/Clip} clip
	   */
	  removeClip: function (clip) {
	    var idx = util.indexOf(this._clips, clip);
	
	    if (idx >= 0) {
	      this._clips.splice(idx, 1);
	    }
	  },
	
	  /**
	   * Delete animation clip
	   * @param {module:zrender/animation/Animator} animator
	   */
	  removeAnimator: function (animator) {
	    var clips = animator.getClips();
	
	    for (var i = 0; i < clips.length; i++) {
	      this.removeClip(clips[i]);
	    }
	
	    animator.animation = null;
	  },
	  _update: function () {
	    var time = new Date().getTime() - this._pausedTime;
	
	    var delta = time - this._time;
	    var clips = this._clips;
	    var len = clips.length;
	    var deferredEvents = [];
	    var deferredClips = [];
	
	    for (var i = 0; i < len; i++) {
	      var clip = clips[i];
	      var e = clip.step(time, delta); // Throw out the events need to be called after
	      // stage.update, like destroy
	
	      if (e) {
	        deferredEvents.push(e);
	        deferredClips.push(clip);
	      }
	    } // Remove the finished clip
	
	
	    for (var i = 0; i < len;) {
	      if (clips[i]._needsRemove) {
	        clips[i] = clips[len - 1];
	        clips.pop();
	        len--;
	      } else {
	        i++;
	      }
	    }
	
	    len = deferredEvents.length;
	
	    for (var i = 0; i < len; i++) {
	      deferredClips[i].fire(deferredEvents[i]);
	    }
	
	    this._time = time;
	    this.onframe(delta); // 'frame' should be triggered before stage, because upper application
	    // depends on the sequence (e.g., echarts-stream and finish
	    // event judge)
	
	    this.trigger('frame', delta);
	
	    if (this.stage.update) {
	      this.stage.update();
	    }
	  },
	  _startLoop: function () {
	    var self = this;
	    this._running = true;
	
	    function step() {
	      if (self._running) {
	        requestAnimationFrame(step);
	        !self._paused && self._update();
	      }
	    }
	
	    requestAnimationFrame(step);
	  },
	
	  /**
	   * Start animation.
	   */
	  start: function () {
	    this._time = new Date().getTime();
	    this._pausedTime = 0;
	
	    this._startLoop();
	  },
	
	  /**
	   * Stop animation.
	   */
	  stop: function () {
	    this._running = false;
	  },
	
	  /**
	   * Pause animation.
	   */
	  pause: function () {
	    if (!this._paused) {
	      this._pauseStart = new Date().getTime();
	      this._paused = true;
	    }
	  },
	
	  /**
	   * Resume animation.
	   */
	  resume: function () {
	    if (this._paused) {
	      this._pausedTime += new Date().getTime() - this._pauseStart;
	      this._paused = false;
	    }
	  },
	
	  /**
	   * Clear animation.
	   */
	  clear: function () {
	    this._clips = [];
	  },
	
	  /**
	   * Whether animation finished.
	   */
	  isFinished: function () {
	    return !this._clips.length;
	  },
	
	  /**
	   * Creat animator for a target, whose props can be animated.
	   *
	   * @param  {Object} target
	   * @param  {Object} options
	   * @param  {boolean} [options.loop=false] Whether loop animation.
	   * @param  {Function} [options.getter=null] Get value from target.
	   * @param  {Function} [options.setter=null] Set value to target.
	   * @return {module:zrender/animation/Animation~Animator}
	   */
	  // TODO Gap
	  animate: function (target, options) {
	    options = options || {};
	    var animator = new Animator(target, options.loop, options.getter, options.setter);
	    this.addAnimator(animator);
	    return animator;
	  }
	};
	util.mixin(Animation, Dispatcher);
	var _default = Animation;
	module.exports = _default;

/***/ },
/* 2975 */
/***/ function(module, exports, __webpack_require__) {

	var easingFuncs = __webpack_require__(2976);
	
	/**
	 * 动画主控制器
	 * @config target 动画对象，可以是数组，如果是数组的话会批量分发onframe等事件
	 * @config life(1000) 动画时长
	 * @config delay(0) 动画延迟时间
	 * @config loop(true)
	 * @config gap(0) 循环的间隔时间
	 * @config onframe
	 * @config easing(optional)
	 * @config ondestroy(optional)
	 * @config onrestart(optional)
	 *
	 * TODO pause
	 */
	function Clip(options) {
	  this._target = options.target; // 生命周期
	
	  this._life = options.life || 1000; // 延时
	
	  this._delay = options.delay || 0; // 开始时间
	  // this._startTime = new Date().getTime() + this._delay;// 单位毫秒
	
	  this._initialized = false; // 是否循环
	
	  this.loop = options.loop == null ? false : options.loop;
	  this.gap = options.gap || 0;
	  this.easing = options.easing || 'Linear';
	  this.onframe = options.onframe;
	  this.ondestroy = options.ondestroy;
	  this.onrestart = options.onrestart;
	  this._pausedTime = 0;
	  this._paused = false;
	}
	
	Clip.prototype = {
	  constructor: Clip,
	  step: function (globalTime, deltaTime) {
	    // Set startTime on first step, or _startTime may has milleseconds different between clips
	    // PENDING
	    if (!this._initialized) {
	      this._startTime = globalTime + this._delay;
	      this._initialized = true;
	    }
	
	    if (this._paused) {
	      this._pausedTime += deltaTime;
	      return;
	    }
	
	    var percent = (globalTime - this._startTime - this._pausedTime) / this._life; // 还没开始
	
	    if (percent < 0) {
	      return;
	    }
	
	    percent = Math.min(percent, 1);
	    var easing = this.easing;
	    var easingFunc = typeof easing === 'string' ? easingFuncs[easing] : easing;
	    var schedule = typeof easingFunc === 'function' ? easingFunc(percent) : percent;
	    this.fire('frame', schedule); // 结束
	
	    if (percent === 1) {
	      if (this.loop) {
	        this.restart(globalTime); // 重新开始周期
	        // 抛出而不是直接调用事件直到 stage.update 后再统一调用这些事件
	
	        return 'restart';
	      } // 动画完成将这个控制器标识为待删除
	      // 在Animation.update中进行批量删除
	
	
	      this._needsRemove = true;
	      return 'destroy';
	    }
	
	    return null;
	  },
	  restart: function (globalTime) {
	    var remainder = (globalTime - this._startTime - this._pausedTime) % this._life;
	    this._startTime = globalTime - remainder + this.gap;
	    this._pausedTime = 0;
	    this._needsRemove = false;
	  },
	  fire: function (eventType, arg) {
	    eventType = 'on' + eventType;
	
	    if (this[eventType]) {
	      this[eventType](this._target, arg);
	    }
	  },
	  pause: function () {
	    this._paused = true;
	  },
	  resume: function () {
	    this._paused = false;
	  }
	};
	var _default = Clip;
	module.exports = _default;

/***/ },
/* 2976 */
/***/ function(module, exports) {

	/**
	 * 缓动代码来自 https://github.com/sole/tween.js/blob/master/src/Tween.js
	 * @see http://sole.github.io/tween.js/examples/03_graphs.html
	 * @exports zrender/animation/easing
	 */
	var easing = {
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  linear: function (k) {
	    return k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticIn: function (k) {
	    return k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticOut: function (k) {
	    return k * (2 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quadraticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k;
	    }
	
	    return -0.5 * (--k * (k - 2) - 1);
	  },
	  // 三次方的缓动（t^3）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicIn: function (k) {
	    return k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicOut: function (k) {
	    return --k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  cubicInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k + 2);
	  },
	  // 四次方的缓动（t^4）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticIn: function (k) {
	    return k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticOut: function (k) {
	    return 1 - --k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quarticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k;
	    }
	
	    return -0.5 * ((k -= 2) * k * k * k - 2);
	  },
	  // 五次方的缓动（t^5）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticIn: function (k) {
	    return k * k * k * k * k;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticOut: function (k) {
	    return --k * k * k * k * k + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  quinticInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return 0.5 * k * k * k * k * k;
	    }
	
	    return 0.5 * ((k -= 2) * k * k * k * k + 2);
	  },
	  // 正弦曲线的缓动（sin(t)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalIn: function (k) {
	    return 1 - Math.cos(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalOut: function (k) {
	    return Math.sin(k * Math.PI / 2);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  sinusoidalInOut: function (k) {
	    return 0.5 * (1 - Math.cos(Math.PI * k));
	  },
	  // 指数曲线的缓动（2^t）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialIn: function (k) {
	    return k === 0 ? 0 : Math.pow(1024, k - 1);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialOut: function (k) {
	    return k === 1 ? 1 : 1 - Math.pow(2, -10 * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  exponentialInOut: function (k) {
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if ((k *= 2) < 1) {
	      return 0.5 * Math.pow(1024, k - 1);
	    }
	
	    return 0.5 * (-Math.pow(2, -10 * (k - 1)) + 2);
	  },
	  // 圆形曲线的缓动（sqrt(1-t^2)）
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularIn: function (k) {
	    return 1 - Math.sqrt(1 - k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularOut: function (k) {
	    return Math.sqrt(1 - --k * k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  circularInOut: function (k) {
	    if ((k *= 2) < 1) {
	      return -0.5 * (Math.sqrt(1 - k * k) - 1);
	    }
	
	    return 0.5 * (Math.sqrt(1 - (k -= 2) * k) + 1);
	  },
	  // 创建类似于弹簧在停止前来回振荡的动画
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticIn: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return -(a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    return a * Math.pow(2, -10 * k) * Math.sin((k - s) * (2 * Math.PI) / p) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  elasticInOut: function (k) {
	    var s;
	    var a = 0.1;
	    var p = 0.4;
	
	    if (k === 0) {
	      return 0;
	    }
	
	    if (k === 1) {
	      return 1;
	    }
	
	    if (!a || a < 1) {
	      a = 1;
	      s = p / 4;
	    } else {
	      s = p * Math.asin(1 / a) / (2 * Math.PI);
	    }
	
	    if ((k *= 2) < 1) {
	      return -0.5 * (a * Math.pow(2, 10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p));
	    }
	
	    return a * Math.pow(2, -10 * (k -= 1)) * Math.sin((k - s) * (2 * Math.PI) / p) * 0.5 + 1;
	  },
	  // 在某一动画开始沿指示的路径进行动画处理前稍稍收回该动画的移动
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backIn: function (k) {
	    var s = 1.70158;
	    return k * k * ((s + 1) * k - s);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backOut: function (k) {
	    var s = 1.70158;
	    return --k * k * ((s + 1) * k + s) + 1;
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  backInOut: function (k) {
	    var s = 1.70158 * 1.525;
	
	    if ((k *= 2) < 1) {
	      return 0.5 * (k * k * ((s + 1) * k - s));
	    }
	
	    return 0.5 * ((k -= 2) * k * ((s + 1) * k + s) + 2);
	  },
	  // 创建弹跳效果
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceIn: function (k) {
	    return 1 - easing.bounceOut(1 - k);
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceOut: function (k) {
	    if (k < 1 / 2.75) {
	      return 7.5625 * k * k;
	    } else if (k < 2 / 2.75) {
	      return 7.5625 * (k -= 1.5 / 2.75) * k + 0.75;
	    } else if (k < 2.5 / 2.75) {
	      return 7.5625 * (k -= 2.25 / 2.75) * k + 0.9375;
	    } else {
	      return 7.5625 * (k -= 2.625 / 2.75) * k + 0.984375;
	    }
	  },
	
	  /**
	  * @param {number} k
	  * @return {number}
	  */
	  bounceInOut: function (k) {
	    if (k < 0.5) {
	      return easing.bounceIn(k * 2) * 0.5;
	    }
	
	    return easing.bounceOut(k * 2 - 1) * 0.5 + 0.5;
	  }
	};
	var _default = easing;
	module.exports = _default;

/***/ },
/* 2977 */
/***/ function(module, exports, __webpack_require__) {

	var _util = __webpack_require__(1193);
	
	var normalizeRadian = _util.normalizeRadian;
	var PI2 = Math.PI * 2;
	/**
	 * 圆弧描边包含判断
	 * @param  {number}  cx
	 * @param  {number}  cy
	 * @param  {number}  r
	 * @param  {number}  startAngle
	 * @param  {number}  endAngle
	 * @param  {boolean}  anticlockwise
	 * @param  {number} lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {Boolean}
	 */
	
	function containStroke(cx, cy, r, startAngle, endAngle, anticlockwise, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth;
	  x -= cx;
	  y -= cy;
	  var d = Math.sqrt(x * x + y * y);
	
	  if (d - _l > r || d + _l < r) {
	    return false;
	  }
	
	  if (Math.abs(startAngle - endAngle) % PI2 < 1e-4) {
	    // Is a circle
	    return true;
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var angle = Math.atan2(y, x);
	
	  if (angle < 0) {
	    angle += PI2;
	  }
	
	  return angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle;
	}
	
	exports.containStroke = containStroke;

/***/ },
/* 2978 */
/***/ function(module, exports, __webpack_require__) {

	var curve = __webpack_require__(188);
	
	/**
	 * 三次贝塞尔曲线描边包含判断
	 * @param  {number}  x0
	 * @param  {number}  y0
	 * @param  {number}  x1
	 * @param  {number}  y1
	 * @param  {number}  x2
	 * @param  {number}  y2
	 * @param  {number}  x3
	 * @param  {number}  y3
	 * @param  {number}  lineWidth
	 * @param  {number}  x
	 * @param  {number}  y
	 * @return {boolean}
	 */
	function containStroke(x0, y0, x1, y1, x2, y2, x3, y3, lineWidth, x, y) {
	  if (lineWidth === 0) {
	    return false;
	  }
	
	  var _l = lineWidth; // Quick reject
	
	  if (y > y0 + _l && y > y1 + _l && y > y2 + _l && y > y3 + _l || y < y0 - _l && y < y1 - _l && y < y2 - _l && y < y3 - _l || x > x0 + _l && x > x1 + _l && x > x2 + _l && x > x3 + _l || x < x0 - _l && x < x1 - _l && x < x2 - _l && x < x3 - _l) {
	    return false;
	  }
	
	  var d = curve.cubicProjectPoint(x0, y0, x1, y1, x2, y2, x3, y3, x, y, null);
	  return d <= _l / 2;
	}
	
	exports.containStroke = containStroke;

/***/ },
/* 2979 */
/***/ function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(266);
	
	var line = __webpack_require__(1190);
	
	var cubic = __webpack_require__(2978);
	
	var quadratic = __webpack_require__(1192);
	
	var arc = __webpack_require__(2977);
	
	var _util = __webpack_require__(1193);
	
	var normalizeRadian = _util.normalizeRadian;
	
	var curve = __webpack_require__(188);
	
	var windingLine = __webpack_require__(1194);
	
	var CMD = PathProxy.CMD;
	var PI2 = Math.PI * 2;
	var EPSILON = 1e-4;
	
	function isAroundEqual(a, b) {
	  return Math.abs(a - b) < EPSILON;
	} // 临时数组
	
	
	var roots = [-1, -1, -1];
	var extrema = [-1, -1];
	
	function swapExtrema() {
	  var tmp = extrema[0];
	  extrema[0] = extrema[1];
	  extrema[1] = tmp;
	}
	
	function windingCubic(x0, y0, x1, y1, x2, y2, x3, y3, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 && y > y3 || y < y0 && y < y1 && y < y2 && y < y3) {
	    return 0;
	  }
	
	  var nRoots = curve.cubicRootAt(y0, y1, y2, y3, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var w = 0;
	    var nExtrema = -1;
	    var y0_;
	    var y1_;
	
	    for (var i = 0; i < nRoots; i++) {
	      var t = roots[i]; // Avoid winding error when intersection point is the connect point of two line of polygon
	
	      var unit = t === 0 || t === 1 ? 0.5 : 1;
	      var x_ = curve.cubicAt(x0, x1, x2, x3, t);
	
	      if (x_ < x) {
	        // Quick reject
	        continue;
	      }
	
	      if (nExtrema < 0) {
	        nExtrema = curve.cubicExtrema(y0, y1, y2, y3, extrema);
	
	        if (extrema[1] < extrema[0] && nExtrema > 1) {
	          swapExtrema();
	        }
	
	        y0_ = curve.cubicAt(y0, y1, y2, y3, extrema[0]);
	
	        if (nExtrema > 1) {
	          y1_ = curve.cubicAt(y0, y1, y2, y3, extrema[1]);
	        }
	      }
	
	      if (nExtrema === 2) {
	        // 分成三段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else if (t < extrema[1]) {
	          w += y1_ < y0_ ? unit : -unit;
	        } else {
	          w += y3 < y1_ ? unit : -unit;
	        }
	      } else {
	        // 分成两段单调函数
	        if (t < extrema[0]) {
	          w += y0_ < y0 ? unit : -unit;
	        } else {
	          w += y3 < y0_ ? unit : -unit;
	        }
	      }
	    }
	
	    return w;
	  }
	}
	
	function windingQuadratic(x0, y0, x1, y1, x2, y2, x, y) {
	  // Quick reject
	  if (y > y0 && y > y1 && y > y2 || y < y0 && y < y1 && y < y2) {
	    return 0;
	  }
	
	  var nRoots = curve.quadraticRootAt(y0, y1, y2, y, roots);
	
	  if (nRoots === 0) {
	    return 0;
	  } else {
	    var t = curve.quadraticExtremum(y0, y1, y2);
	
	    if (t >= 0 && t <= 1) {
	      var w = 0;
	      var y_ = curve.quadraticAt(y0, y1, y2, t);
	
	      for (var i = 0; i < nRoots; i++) {
	        // Remove one endpoint.
	        var unit = roots[i] === 0 || roots[i] === 1 ? 0.5 : 1;
	        var x_ = curve.quadraticAt(x0, x1, x2, roots[i]);
	
	        if (x_ < x) {
	          // Quick reject
	          continue;
	        }
	
	        if (roots[i] < t) {
	          w += y_ < y0 ? unit : -unit;
	        } else {
	          w += y2 < y_ ? unit : -unit;
	        }
	      }
	
	      return w;
	    } else {
	      // Remove one endpoint.
	      var unit = roots[0] === 0 || roots[0] === 1 ? 0.5 : 1;
	      var x_ = curve.quadraticAt(x0, x1, x2, roots[0]);
	
	      if (x_ < x) {
	        // Quick reject
	        return 0;
	      }
	
	      return y2 < y0 ? unit : -unit;
	    }
	  }
	} // TODO
	// Arc 旋转
	
	
	function windingArc(cx, cy, r, startAngle, endAngle, anticlockwise, x, y) {
	  y -= cy;
	
	  if (y > r || y < -r) {
	    return 0;
	  }
	
	  var tmp = Math.sqrt(r * r - y * y);
	  roots[0] = -tmp;
	  roots[1] = tmp;
	  var diff = Math.abs(startAngle - endAngle);
	
	  if (diff < 1e-4) {
	    return 0;
	  }
	
	  if (diff % PI2 < 1e-4) {
	    // Is a circle
	    startAngle = 0;
	    endAngle = PI2;
	    var dir = anticlockwise ? 1 : -1;
	
	    if (x >= roots[0] + cx && x <= roots[1] + cx) {
	      return dir;
	    } else {
	      return 0;
	    }
	  }
	
	  if (anticlockwise) {
	    var tmp = startAngle;
	    startAngle = normalizeRadian(endAngle);
	    endAngle = normalizeRadian(tmp);
	  } else {
	    startAngle = normalizeRadian(startAngle);
	    endAngle = normalizeRadian(endAngle);
	  }
	
	  if (startAngle > endAngle) {
	    endAngle += PI2;
	  }
	
	  var w = 0;
	
	  for (var i = 0; i < 2; i++) {
	    var x_ = roots[i];
	
	    if (x_ + cx > x) {
	      var angle = Math.atan2(y, x_);
	      var dir = anticlockwise ? 1 : -1;
	
	      if (angle < 0) {
	        angle = PI2 + angle;
	      }
	
	      if (angle >= startAngle && angle <= endAngle || angle + PI2 >= startAngle && angle + PI2 <= endAngle) {
	        if (angle > Math.PI / 2 && angle < Math.PI * 1.5) {
	          dir = -dir;
	        }
	
	        w += dir;
	      }
	    }
	  }
	
	  return w;
	}
	
	function containPath(data, lineWidth, isStroke, x, y) {
	  var w = 0;
	  var xi = 0;
	  var yi = 0;
	  var x0 = 0;
	  var y0 = 0;
	
	  for (var i = 0; i < data.length;) {
	    var cmd = data[i++]; // Begin a new subpath
	
	    if (cmd === CMD.M && i > 1) {
	      // Close previous subpath
	      if (!isStroke) {
	        w += windingLine(xi, yi, x0, y0, x, y);
	      } // 如果被任何一个 subpath 包含
	      // if (w !== 0) {
	      //     return true;
	      // }
	
	    }
	
	    if (i === 1) {
	      // 如果第一个命令是 L, C, Q
	      // 则 previous point 同绘制命令的第一个 point
	      //
	      // 第一个命令为 Arc 的情况下会在后面特殊处理
	      xi = data[i];
	      yi = data[i + 1];
	      x0 = xi;
	      y0 = yi;
	    }
	
	    switch (cmd) {
	      case CMD.M:
	        // moveTo 命令重新创建一个新的 subpath, 并且更新新的起点
	        // 在 closePath 的时候使用
	        x0 = data[i++];
	        y0 = data[i++];
	        xi = x0;
	        yi = y0;
	        break;
	
	      case CMD.L:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // NOTE 在第一个命令为 L, C, Q 的时候会计算出 NaN
	          w += windingLine(xi, yi, data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.C:
	        if (isStroke) {
	          if (cubic.containStroke(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingCubic(xi, yi, data[i++], data[i++], data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.Q:
	        if (isStroke) {
	          if (quadratic.containStroke(xi, yi, data[i++], data[i++], data[i], data[i + 1], lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          w += windingQuadratic(xi, yi, data[i++], data[i++], data[i], data[i + 1], x, y) || 0;
	        }
	
	        xi = data[i++];
	        yi = data[i++];
	        break;
	
	      case CMD.A:
	        // TODO Arc 判断的开销比较大
	        var cx = data[i++];
	        var cy = data[i++];
	        var rx = data[i++];
	        var ry = data[i++];
	        var theta = data[i++];
	        var dTheta = data[i++]; // TODO Arc 旋转
	
	        i += 1;
	        var anticlockwise = 1 - data[i++];
	        var x1 = Math.cos(theta) * rx + cx;
	        var y1 = Math.sin(theta) * ry + cy; // 不是直接使用 arc 命令
	
	        if (i > 1) {
	          w += windingLine(xi, yi, x1, y1, x, y);
	        } else {
	          // 第一个命令起点还未定义
	          x0 = x1;
	          y0 = y1;
	        } // zr 使用scale来模拟椭圆, 这里也对x做一定的缩放
	
	
	        var _x = (x - cx) * ry / rx + cx;
	
	        if (isStroke) {
	          if (arc.containStroke(cx, cy, ry, theta, theta + dTheta, anticlockwise, lineWidth, _x, y)) {
	            return true;
	          }
	        } else {
	          w += windingArc(cx, cy, ry, theta, theta + dTheta, anticlockwise, _x, y);
	        }
	
	        xi = Math.cos(theta + dTheta) * rx + cx;
	        yi = Math.sin(theta + dTheta) * ry + cy;
	        break;
	
	      case CMD.R:
	        x0 = xi = data[i++];
	        y0 = yi = data[i++];
	        var width = data[i++];
	        var height = data[i++];
	        var x1 = x0 + width;
	        var y1 = y0 + height;
	
	        if (isStroke) {
	          if (line.containStroke(x0, y0, x1, y0, lineWidth, x, y) || line.containStroke(x1, y0, x1, y1, lineWidth, x, y) || line.containStroke(x1, y1, x0, y1, lineWidth, x, y) || line.containStroke(x0, y1, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // FIXME Clockwise ?
	          w += windingLine(x1, y0, x1, y1, x, y);
	          w += windingLine(x0, y1, x0, y0, x, y);
	        }
	
	        break;
	
	      case CMD.Z:
	        if (isStroke) {
	          if (line.containStroke(xi, yi, x0, y0, lineWidth, x, y)) {
	            return true;
	          }
	        } else {
	          // Close a subpath
	          w += windingLine(xi, yi, x0, y0, x, y); // 如果被任何一个 subpath 包含
	          // FIXME subpaths may overlap
	          // if (w !== 0) {
	          //     return true;
	          // }
	        }
	
	        xi = x0;
	        yi = y0;
	        break;
	    }
	  }
	
	  if (!isStroke && !isAroundEqual(yi, y0)) {
	    w += windingLine(xi, yi, x0, y0, x, y) || 0;
	  }
	
	  return w !== 0;
	}
	
	function contain(pathData, x, y) {
	  return containPath(pathData, 0, false, x, y);
	}
	
	function containStroke(pathData, lineWidth, x, y) {
	  return containPath(pathData, lineWidth, true, x, y);
	}
	
	exports.contain = contain;
	exports.containStroke = containStroke;

/***/ },
/* 2980 */
/***/ function(module, exports, __webpack_require__) {

	var eventUtil = __webpack_require__(147);
	
	/**
	 * Only implements needed gestures for mobile.
	 */
	var GestureMgr = function () {
	  /**
	   * @private
	   * @type {Array.<Object>}
	   */
	  this._track = [];
	};
	
	GestureMgr.prototype = {
	  constructor: GestureMgr,
	  recognize: function (event, target, root) {
	    this._doTrack(event, target, root);
	
	    return this._recognize(event);
	  },
	  clear: function () {
	    this._track.length = 0;
	    return this;
	  },
	  _doTrack: function (event, target, root) {
	    var touches = event.touches;
	
	    if (!touches) {
	      return;
	    }
	
	    var trackItem = {
	      points: [],
	      touches: [],
	      target: target,
	      event: event
	    };
	
	    for (var i = 0, len = touches.length; i < len; i++) {
	      var touch = touches[i];
	      var pos = eventUtil.clientToLocal(root, touch, {});
	      trackItem.points.push([pos.zrX, pos.zrY]);
	      trackItem.touches.push(touch);
	    }
	
	    this._track.push(trackItem);
	  },
	  _recognize: function (event) {
	    for (var eventName in recognizers) {
	      if (recognizers.hasOwnProperty(eventName)) {
	        var gestureInfo = recognizers[eventName](this._track, event);
	
	        if (gestureInfo) {
	          return gestureInfo;
	        }
	      }
	    }
	  }
	};
	
	function dist(pointPair) {
	  var dx = pointPair[1][0] - pointPair[0][0];
	  var dy = pointPair[1][1] - pointPair[0][1];
	  return Math.sqrt(dx * dx + dy * dy);
	}
	
	function center(pointPair) {
	  return [(pointPair[0][0] + pointPair[1][0]) / 2, (pointPair[0][1] + pointPair[1][1]) / 2];
	}
	
	var recognizers = {
	  pinch: function (track, event) {
	    var trackLen = track.length;
	
	    if (!trackLen) {
	      return;
	    }
	
	    var pinchEnd = (track[trackLen - 1] || {}).points;
	    var pinchPre = (track[trackLen - 2] || {}).points || pinchEnd;
	
	    if (pinchPre && pinchPre.length > 1 && pinchEnd && pinchEnd.length > 1) {
	      var pinchScale = dist(pinchEnd) / dist(pinchPre);
	      !isFinite(pinchScale) && (pinchScale = 1);
	      event.pinchScale = pinchScale;
	      var pinchCenter = center(pinchEnd);
	      event.pinchX = pinchCenter[0];
	      event.pinchY = pinchCenter[1];
	      return {
	        type: 'pinch',
	        target: track[0].target,
	        event: event
	      };
	    }
	  } // Only pinch currently.
	
	};
	var _default = GestureMgr;
	module.exports = _default;

/***/ },
/* 2981 */
/***/ function(module, exports) {

	// Myers' Diff Algorithm
	// Modified from https://github.com/kpdecker/jsdiff/blob/master/src/diff/base.js
	function Diff() {}
	
	Diff.prototype = {
	  diff: function (oldArr, newArr, equals) {
	    if (!equals) {
	      equals = function (a, b) {
	        return a === b;
	      };
	    }
	
	    this.equals = equals;
	    var self = this;
	    oldArr = oldArr.slice();
	    newArr = newArr.slice(); // Allow subclasses to massage the input prior to running
	
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var editLength = 1;
	    var maxEditLength = newLen + oldLen;
	    var bestPath = [{
	      newPos: -1,
	      components: []
	    }]; // Seed editLength = 0, i.e. the content starts with the same values
	
	    var oldPos = this.extractCommon(bestPath[0], newArr, oldArr, 0);
	
	    if (bestPath[0].newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	      var indices = [];
	
	      for (var i = 0; i < newArr.length; i++) {
	        indices.push(i);
	      } // Identity per the equality and tokenizer
	
	
	      return [{
	        indices: indices,
	        count: newArr.length
	      }];
	    } // Main worker method. checks all permutations of a given edit length for acceptance.
	
	
	    function execEditLength() {
	      for (var diagonalPath = -1 * editLength; diagonalPath <= editLength; diagonalPath += 2) {
	        var basePath;
	        var addPath = bestPath[diagonalPath - 1];
	        var removePath = bestPath[diagonalPath + 1];
	        var oldPos = (removePath ? removePath.newPos : 0) - diagonalPath;
	
	        if (addPath) {
	          // No one else is going to attempt to use this value, clear it
	          bestPath[diagonalPath - 1] = undefined;
	        }
	
	        var canAdd = addPath && addPath.newPos + 1 < newLen;
	        var canRemove = removePath && 0 <= oldPos && oldPos < oldLen;
	
	        if (!canAdd && !canRemove) {
	          // If this path is a terminal then prune
	          bestPath[diagonalPath] = undefined;
	          continue;
	        } // Select the diagonal that we want to branch from. We select the prior
	        // path whose position in the new string is the farthest from the origin
	        // and does not pass the bounds of the diff graph
	
	
	        if (!canAdd || canRemove && addPath.newPos < removePath.newPos) {
	          basePath = clonePath(removePath);
	          self.pushComponent(basePath.components, undefined, true);
	        } else {
	          basePath = addPath; // No need to clone, we've pulled it from the list
	
	          basePath.newPos++;
	          self.pushComponent(basePath.components, true, undefined);
	        }
	
	        oldPos = self.extractCommon(basePath, newArr, oldArr, diagonalPath); // If we have hit the end of both strings, then we are done
	
	        if (basePath.newPos + 1 >= newLen && oldPos + 1 >= oldLen) {
	          return buildValues(self, basePath.components, newArr, oldArr);
	        } else {
	          // Otherwise track this path as a potential candidate and continue.
	          bestPath[diagonalPath] = basePath;
	        }
	      }
	
	      editLength++;
	    }
	
	    while (editLength <= maxEditLength) {
	      var ret = execEditLength();
	
	      if (ret) {
	        return ret;
	      }
	    }
	  },
	  pushComponent: function (components, added, removed) {
	    var last = components[components.length - 1];
	
	    if (last && last.added === added && last.removed === removed) {
	      // We need to clone here as the component clone operation is just
	      // as shallow array clone
	      components[components.length - 1] = {
	        count: last.count + 1,
	        added: added,
	        removed: removed
	      };
	    } else {
	      components.push({
	        count: 1,
	        added: added,
	        removed: removed
	      });
	    }
	  },
	  extractCommon: function (basePath, newArr, oldArr, diagonalPath) {
	    var newLen = newArr.length;
	    var oldLen = oldArr.length;
	    var newPos = basePath.newPos;
	    var oldPos = newPos - diagonalPath;
	    var commonCount = 0;
	
	    while (newPos + 1 < newLen && oldPos + 1 < oldLen && this.equals(newArr[newPos + 1], oldArr[oldPos + 1])) {
	      newPos++;
	      oldPos++;
	      commonCount++;
	    }
	
	    if (commonCount) {
	      basePath.components.push({
	        count: commonCount
	      });
	    }
	
	    basePath.newPos = newPos;
	    return oldPos;
	  },
	  tokenize: function (value) {
	    return value.slice();
	  },
	  join: function (value) {
	    return value.slice();
	  }
	};
	
	function buildValues(diff, components, newArr, oldArr) {
	  var componentPos = 0;
	  var componentLen = components.length;
	  var newPos = 0;
	  var oldPos = 0;
	
	  for (; componentPos < componentLen; componentPos++) {
	    var component = components[componentPos];
	
	    if (!component.removed) {
	      var indices = [];
	
	      for (var i = newPos; i < newPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      newPos += component.count; // Common case
	
	      if (!component.added) {
	        oldPos += component.count;
	      }
	    } else {
	      var indices = [];
	
	      for (var i = oldPos; i < oldPos + component.count; i++) {
	        indices.push(i);
	      }
	
	      component.indices = indices;
	      oldPos += component.count;
	    }
	  }
	
	  return components;
	}
	
	function clonePath(path) {
	  return {
	    newPos: path.newPos,
	    components: path.components.slice(0)
	  };
	}
	
	var arrayDiff = new Diff();
	
	function _default(oldArr, newArr, callback) {
	  return arrayDiff.diff(oldArr, newArr, callback);
	}
	
	module.exports = _default;

/***/ },
/* 2982 */
/***/ function(module, exports) {

	/**
	 * The algoritm is learnt from
	 * https://franklinta.com/2014/09/08/computing-css-matrix3d-transforms/
	 * And we made some optimization for matrix inversion.
	 * Other similar approaches:
	 * "cv::getPerspectiveTransform", "Direct Linear Transformation".
	 */
	var LN2 = Math.log(2);
	
	function determinant(rows, rank, rowStart, rowMask, colMask, detCache) {
	  var cacheKey = rowMask + '-' + colMask;
	  var fullRank = rows.length;
	
	  if (detCache.hasOwnProperty(cacheKey)) {
	    return detCache[cacheKey];
	  }
	
	  if (rank === 1) {
	    // In this case the colMask must be like: `11101111`. We can find the place of `0`.
	    var colStart = Math.round(Math.log((1 << fullRank) - 1 & ~colMask) / LN2);
	    return rows[rowStart][colStart];
	  }
	
	  var subRowMask = rowMask | 1 << rowStart;
	  var subRowStart = rowStart + 1;
	
	  while (rowMask & 1 << subRowStart) {
	    subRowStart++;
	  }
	
	  var sum = 0;
	
	  for (var j = 0, colLocalIdx = 0; j < fullRank; j++) {
	    var colTag = 1 << j;
	
	    if (!(colTag & colMask)) {
	      sum += (colLocalIdx % 2 ? -1 : 1) * rows[rowStart][j] // det(subMatrix(0, j))
	      * determinant(rows, rank - 1, subRowStart, subRowMask, colMask | colTag, detCache);
	      colLocalIdx++;
	    }
	  }
	
	  detCache[cacheKey] = sum;
	  return sum;
	}
	/**
	 * Usage:
	 * ```js
	 * var transformer = buildTransformer(
	 *     [10, 44, 100, 44, 100, 300, 10, 300],
	 *     [50, 54, 130, 14, 140, 330, 14, 220]
	 * );
	 * var out = [];
	 * transformer && transformer([11, 33], out);
	 * ```
	 *
	 * Notice: `buildTransformer` may take more than 10ms in some Android device.
	 *
	 * @param {Array.<number>} src source four points, [x0, y0, x1, y1, x2, y2, x3, y3]
	 * @param {Array.<number>} dest destination four points, [x0, y0, x1, y1, x2, y2, x3, y3]
	 * @return {Function} transformer If fail, return null/undefined.
	 */
	
	
	function buildTransformer(src, dest) {
	  var mA = [[src[0], src[1], 1, 0, 0, 0, -dest[0] * src[0], -dest[0] * src[1]], [0, 0, 0, src[0], src[1], 1, -dest[1] * src[0], -dest[1] * src[1]], [src[2], src[3], 1, 0, 0, 0, -dest[2] * src[2], -dest[2] * src[3]], [0, 0, 0, src[2], src[3], 1, -dest[3] * src[2], -dest[3] * src[3]], [src[4], src[5], 1, 0, 0, 0, -dest[4] * src[4], -dest[4] * src[5]], [0, 0, 0, src[4], src[5], 1, -dest[5] * src[4], -dest[5] * src[5]], [src[6], src[7], 1, 0, 0, 0, -dest[6] * src[6], -dest[6] * src[7]], [0, 0, 0, src[6], src[7], 1, -dest[7] * src[6], -dest[7] * src[7]]];
	  var detCache = {};
	  var det = determinant(mA, 8, 0, 0, 0, detCache);
	
	  if (det === 0) {
	    // can not make transformer when and only when
	    // any three of the markers are collinear.
	    return;
	  } // `invert(mA) * dest`, that is, `adj(mA) / det * dest`.
	
	
	  var vh = [];
	
	  for (var i = 0; i < 8; i++) {
	    for (var j = 0; j < 8; j++) {
	      vh[j] == null && (vh[j] = 0);
	      vh[j] += ((i + j) % 2 ? -1 : 1) * // det(subMatrix(i, j))
	      determinant(mA, 7, i === 0 ? 1 : 0, 1 << i, 1 << j, detCache) / det * dest[i];
	    }
	  }
	
	  return function (out, srcPointX, srcPointY) {
	    var pk = srcPointX * vh[6] + srcPointY * vh[7] + 1;
	    out[0] = (srcPointX * vh[0] + srcPointY * vh[1] + vh[2]) / pk;
	    out[1] = (srcPointX * vh[3] + srcPointY * vh[4] + vh[5]) / pk;
	  };
	}
	
	exports.buildTransformer = buildTransformer;

/***/ },
/* 2983 */
/***/ function(module, exports, __webpack_require__) {

	var _event = __webpack_require__(147);
	
	var addEventListener = _event.addEventListener;
	var removeEventListener = _event.removeEventListener;
	var normalizeEvent = _event.normalizeEvent;
	var getNativeEvent = _event.getNativeEvent;
	
	var zrUtil = __webpack_require__(4);
	
	var Eventful = __webpack_require__(225);
	
	var env = __webpack_require__(73);
	
	/* global document */
	var TOUCH_CLICK_DELAY = 300;
	var globalEventSupported = env.domSupported;
	
	var localNativeListenerNames = function () {
	  var mouseHandlerNames = ['click', 'dblclick', 'mousewheel', 'mouseout', 'mouseup', 'mousedown', 'mousemove', 'contextmenu'];
	  var touchHandlerNames = ['touchstart', 'touchend', 'touchmove'];
	  var pointerEventNameMap = {
	    pointerdown: 1,
	    pointerup: 1,
	    pointermove: 1,
	    pointerout: 1
	  };
	  var pointerHandlerNames = zrUtil.map(mouseHandlerNames, function (name) {
	    var nm = name.replace('mouse', 'pointer');
	    return pointerEventNameMap.hasOwnProperty(nm) ? nm : name;
	  });
	  return {
	    mouse: mouseHandlerNames,
	    touch: touchHandlerNames,
	    pointer: pointerHandlerNames
	  };
	}();
	
	var globalNativeListenerNames = {
	  mouse: ['mousemove', 'mouseup'],
	  pointer: ['pointermove', 'pointerup']
	};
	
	function eventNameFix(name) {
	  return name === 'mousewheel' && env.browser.firefox ? 'DOMMouseScroll' : name;
	}
	
	function isPointerFromTouch(event) {
	  var pointerType = event.pointerType;
	  return pointerType === 'pen' || pointerType === 'touch';
	} // function useMSGuesture(handlerProxy, event) {
	//     return isPointerFromTouch(event) && !!handlerProxy._msGesture;
	// }
	// function onMSGestureChange(proxy, event) {
	//     if (event.translationX || event.translationY) {
	//         // mousemove is carried by MSGesture to reduce the sensitivity.
	//         proxy.handler.dispatchToElement(event.target, 'mousemove', event);
	//     }
	//     if (event.scale !== 1) {
	//         event.pinchX = event.offsetX;
	//         event.pinchY = event.offsetY;
	//         event.pinchScale = event.scale;
	//         proxy.handler.dispatchToElement(event.target, 'pinch', event);
	//     }
	// }
	
	/**
	 * Prevent mouse event from being dispatched after Touch Events action
	 * @see <https://github.com/deltakosh/handjs/blob/master/src/hand.base.js>
	 * 1. Mobile browsers dispatch mouse events 300ms after touchend.
	 * 2. Chrome for Android dispatch mousedown for long-touch about 650ms
	 * Result: Blocking Mouse Events for 700ms.
	 *
	 * @param {DOMHandlerScope} scope
	 */
	
	
	function setTouchTimer(scope) {
	  scope.touching = true;
	
	  if (scope.touchTimer != null) {
	    clearTimeout(scope.touchTimer);
	    scope.touchTimer = null;
	  }
	
	  scope.touchTimer = setTimeout(function () {
	    scope.touching = false;
	    scope.touchTimer = null;
	  }, 700);
	} // Mark touch, which is useful in distinguish touch and
	// mouse event in upper applicatoin.
	
	
	function markTouch(event) {
	  event && (event.zrByTouch = true);
	} // function markTriggeredFromLocal(event) {
	//     event && (event.__zrIsFromLocal = true);
	// }
	// function isTriggeredFromLocal(instance, event) {
	//     return !!(event && event.__zrIsFromLocal);
	// }
	
	
	function normalizeGlobalEvent(instance, event) {
	  // offsetX, offsetY still need to be calculated. They are necessary in the event
	  // handlers of the upper applications. Set `true` to force calculate them.
	  return normalizeEvent(instance.dom, new FakeGlobalEvent(instance, event), true);
	}
	/**
	 * Detect whether the given el is in `painterRoot`.
	 */
	
	
	function isLocalEl(instance, el) {
	  var elTmp = el;
	  var isLocal = false;
	
	  while (elTmp && elTmp.nodeType !== 9 && !(isLocal = elTmp.domBelongToZr || elTmp !== el && elTmp === instance.painterRoot)) {
	    elTmp = elTmp.parentNode;
	  }
	
	  return isLocal;
	}
	/**
	 * Make a fake event but not change the original event,
	 * becuase the global event probably be used by other
	 * listeners not belonging to zrender.
	 * @class
	 */
	
	
	function FakeGlobalEvent(instance, event) {
	  this.type = event.type;
	  this.target = this.currentTarget = instance.dom;
	  this.pointerType = event.pointerType; // Necessray for the force calculation of zrX, zrY
	
	  this.clientX = event.clientX;
	  this.clientY = event.clientY; // Because we do not mount global listeners to touch events,
	  // we do not copy `targetTouches` and `changedTouches` here.
	}
	
	var fakeGlobalEventProto = FakeGlobalEvent.prototype; // we make the default methods on the event do nothing,
	// otherwise it is dangerous. See more details in
	// [Drag outside] in `Handler.js`.
	
	fakeGlobalEventProto.stopPropagation = fakeGlobalEventProto.stopImmediatePropagation = fakeGlobalEventProto.preventDefault = zrUtil.noop;
	/**
	 * Local DOM Handlers
	 * @this {HandlerProxy}
	 */
	
	var localDOMHandlers = {
	  mousedown: function (event) {
	    event = normalizeEvent(this.dom, event);
	    this._mayPointerCapture = [event.zrX, event.zrY];
	    this.trigger('mousedown', event);
	  },
	  mousemove: function (event) {
	    event = normalizeEvent(this.dom, event);
	    var downPoint = this._mayPointerCapture;
	
	    if (downPoint && (event.zrX !== downPoint[0] || event.zrY !== downPoint[1])) {
	      togglePointerCapture(this, true);
	    }
	
	    this.trigger('mousemove', event);
	  },
	  mouseup: function (event) {
	    event = normalizeEvent(this.dom, event);
	    togglePointerCapture(this, false);
	    this.trigger('mouseup', event);
	  },
	  mouseout: function (event) {
	    event = normalizeEvent(this.dom, event); // Similarly to the browser did on `document` and touch event,
	    // `globalout` will be delayed to final pointer cature release.
	
	    if (this._pointerCapturing) {
	      event.zrEventControl = 'no_globalout';
	    } // There might be some doms created by upper layer application
	    // at the same level of painter.getViewportRoot() (e.g., tooltip
	    // dom created by echarts), where 'globalout' event should not
	    // be triggered when mouse enters these doms. (But 'mouseout'
	    // should be triggered at the original hovered element as usual).
	
	
	    var element = event.toElement || event.relatedTarget;
	    event.zrIsToLocalDOM = isLocalEl(this, element);
	    this.trigger('mouseout', event);
	  },
	  touchstart: function (event) {
	    // Default mouse behaviour should not be disabled here.
	    // For example, page may needs to be slided.
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this._lastTouchMoment = new Date();
	    this.handler.processGesture(event, 'start'); // For consistent event listener for both touch device and mouse device,
	    // we simulate "mouseover-->mousedown" in touch device. So we trigger
	    // `mousemove` here (to trigger `mouseover` inside), and then trigger
	    // `mousedown`.
	
	    localDOMHandlers.mousemove.call(this, event);
	    localDOMHandlers.mousedown.call(this, event);
	  },
	  touchmove: function (event) {
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this.handler.processGesture(event, 'change'); // Mouse move should always be triggered no matter whether
	    // there is gestrue event, because mouse move and pinch may
	    // be used at the same time.
	
	    localDOMHandlers.mousemove.call(this, event);
	  },
	  touchend: function (event) {
	    event = normalizeEvent(this.dom, event);
	    markTouch(event);
	    this.handler.processGesture(event, 'end');
	    localDOMHandlers.mouseup.call(this, event); // Do not trigger `mouseout` here, in spite of `mousemove`(`mouseover`) is
	    // triggered in `touchstart`. This seems to be illogical, but by this mechanism,
	    // we can conveniently implement "hover style" in both PC and touch device just
	    // by listening to `mouseover` to add "hover style" and listening to `mouseout`
	    // to remove "hover style" on an element, without any additional code for
	    // compatibility. (`mouseout` will not be triggered in `touchend`, so "hover
	    // style" will remain for user view)
	    // click event should always be triggered no matter whether
	    // there is gestrue event. System click can not be prevented.
	
	    if (+new Date() - this._lastTouchMoment < TOUCH_CLICK_DELAY) {
	      localDOMHandlers.click.call(this, event);
	    }
	  },
	  pointerdown: function (event) {
	    localDOMHandlers.mousedown.call(this, event); // if (useMSGuesture(this, event)) {
	    //     this._msGesture.addPointer(event.pointerId);
	    // }
	  },
	  pointermove: function (event) {
	    // FIXME
	    // pointermove is so sensitive that it always triggered when
	    // tap(click) on touch screen, which affect some judgement in
	    // upper application. So, we dont support mousemove on MS touch
	    // device yet.
	    if (!isPointerFromTouch(event)) {
	      localDOMHandlers.mousemove.call(this, event);
	    }
	  },
	  pointerup: function (event) {
	    localDOMHandlers.mouseup.call(this, event);
	  },
	  pointerout: function (event) {
	    // pointerout will be triggered when tap on touch screen
	    // (IE11+/Edge on MS Surface) after click event triggered,
	    // which is inconsistent with the mousout behavior we defined
	    // in touchend. So we unify them.
	    // (check localDOMHandlers.touchend for detailed explanation)
	    if (!isPointerFromTouch(event)) {
	      localDOMHandlers.mouseout.call(this, event);
	    }
	  }
	};
	/**
	 * Othere DOM UI Event handlers for zr dom.
	 * @this {HandlerProxy}
	 */
	
	zrUtil.each(['click', 'mousewheel', 'dblclick', 'contextmenu'], function (name) {
	  localDOMHandlers[name] = function (event) {
	    event = normalizeEvent(this.dom, event);
	    this.trigger(name, event);
	  };
	});
	/**
	 * DOM UI Event handlers for global page.
	 *
	 * [Caution]:
	 * those handlers should both support in capture phase and bubble phase!
	 *
	 * @this {HandlerProxy}
	 */
	
	var globalDOMHandlers = {
	  pointermove: function (event) {
	    // FIXME
	    // pointermove is so sensitive that it always triggered when
	    // tap(click) on touch screen, which affect some judgement in
	    // upper application. So, we dont support mousemove on MS touch
	    // device yet.
	    if (!isPointerFromTouch(event)) {
	      globalDOMHandlers.mousemove.call(this, event);
	    }
	  },
	  pointerup: function (event) {
	    globalDOMHandlers.mouseup.call(this, event);
	  },
	  mousemove: function (event) {
	    this.trigger('mousemove', event);
	  },
	  mouseup: function (event) {
	    var pointerCaptureReleasing = this._pointerCapturing;
	    togglePointerCapture(this, false);
	    this.trigger('mouseup', event);
	
	    if (pointerCaptureReleasing) {
	      event.zrEventControl = 'only_globalout';
	      this.trigger('mouseout', event);
	    }
	  }
	};
	/**
	 * @param {HandlerProxy} instance
	 * @param {DOMHandlerScope} scope
	 */
	
	function mountLocalDOMEventListeners(instance, scope) {
	  var domHandlers = scope.domHandlers;
	
	  if (env.pointerEventsSupported) {
	    // Only IE11+/Edge
	    // 1. On devices that both enable touch and mouse (e.g., MS Surface and lenovo X240),
	    // IE11+/Edge do not trigger touch event, but trigger pointer event and mouse event
	    // at the same time.
	    // 2. On MS Surface, it probablely only trigger mousedown but no mouseup when tap on
	    // screen, which do not occurs in pointer event.
	    // So we use pointer event to both detect touch gesture and mouse behavior.
	    zrUtil.each(localNativeListenerNames.pointer, function (nativeEventName) {
	      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	        // markTriggeredFromLocal(event);
	        domHandlers[nativeEventName].call(instance, event);
	      });
	    }); // FIXME
	    // Note: MS Gesture require CSS touch-action set. But touch-action is not reliable,
	    // which does not prevent defuault behavior occasionally (which may cause view port
	    // zoomed in but use can not zoom it back). And event.preventDefault() does not work.
	    // So we have to not to use MSGesture and not to support touchmove and pinch on MS
	    // touch screen. And we only support click behavior on MS touch screen now.
	    // MS Gesture Event is only supported on IE11+/Edge and on Windows 8+.
	    // We dont support touch on IE on win7.
	    // See <https://msdn.microsoft.com/en-us/library/dn433243(v=vs.85).aspx>
	    // if (typeof MSGesture === 'function') {
	    //     (this._msGesture = new MSGesture()).target = dom; // jshint ignore:line
	    //     dom.addEventListener('MSGestureChange', onMSGestureChange);
	    // }
	  } else {
	    if (env.touchEventsSupported) {
	      zrUtil.each(localNativeListenerNames.touch, function (nativeEventName) {
	        mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	          // markTriggeredFromLocal(event);
	          domHandlers[nativeEventName].call(instance, event);
	          setTouchTimer(scope);
	        });
	      }); // Handler of 'mouseout' event is needed in touch mode, which will be mounted below.
	      // addEventListener(root, 'mouseout', this._mouseoutHandler);
	    } // 1. Considering some devices that both enable touch and mouse event (like on MS Surface
	    // and lenovo X240, @see #2350), we make mouse event be always listened, otherwise
	    // mouse event can not be handle in those devices.
	    // 2. On MS Surface, Chrome will trigger both touch event and mouse event. How to prevent
	    // mouseevent after touch event triggered, see `setTouchTimer`.
	
	
	    zrUtil.each(localNativeListenerNames.mouse, function (nativeEventName) {
	      mountSingleDOMEventListener(scope, nativeEventName, function (event) {
	        event = getNativeEvent(event);
	
	        if (!scope.touching) {
	          // markTriggeredFromLocal(event);
	          domHandlers[nativeEventName].call(instance, event);
	        }
	      });
	    });
	  }
	}
	/**
	 * @param {HandlerProxy} instance
	 * @param {DOMHandlerScope} scope
	 */
	
	
	function mountGlobalDOMEventListeners(instance, scope) {
	  // Only IE11+/Edge. See the comment in `mountLocalDOMEventListeners`.
	  if (env.pointerEventsSupported) {
	    zrUtil.each(globalNativeListenerNames.pointer, mount);
	  } // Touch event has implemented "drag outside" so we do not mount global listener for touch event.
	  // (see https://www.w3.org/TR/touch-events/#the-touchmove-event)
	  // We do not consider "both-support-touch-and-mouse device" for this feature (see the comment of
	  // `mountLocalDOMEventListeners`) to avoid bugs util some requirements come.
	  else if (!env.touchEventsSupported) {
	      zrUtil.each(globalNativeListenerNames.mouse, mount);
	    }
	
	  function mount(nativeEventName) {
	    function nativeEventListener(event) {
	      event = getNativeEvent(event); // See the reason in [Drag outside] in `Handler.js`
	      // This checking supports both `useCapture` or not.
	      // PENDING: if there is performance issue in some devices,
	      // we probably can not use `useCapture` and change a easier
	      // to judes whether local (mark).
	
	      if (!isLocalEl(instance, event.target)) {
	        event = normalizeGlobalEvent(instance, event);
	        scope.domHandlers[nativeEventName].call(instance, event);
	      }
	    }
	
	    mountSingleDOMEventListener(scope, nativeEventName, nativeEventListener, {
	      capture: true
	    } // See [Drag Outside] in `Handler.js`
	    );
	  }
	}
	
	function mountSingleDOMEventListener(scope, nativeEventName, listener, opt) {
	  scope.mounted[nativeEventName] = listener;
	  scope.listenerOpts[nativeEventName] = opt;
	  addEventListener(scope.domTarget, eventNameFix(nativeEventName), listener, opt);
	}
	
	function unmountDOMEventListeners(scope) {
	  var mounted = scope.mounted;
	
	  for (var nativeEventName in mounted) {
	    if (mounted.hasOwnProperty(nativeEventName)) {
	      removeEventListener(scope.domTarget, eventNameFix(nativeEventName), mounted[nativeEventName], scope.listenerOpts[nativeEventName]);
	    }
	  }
	
	  scope.mounted = {};
	}
	/**
	 * See [Drag Outside] in `Handler.js`.
	 * @implement
	 * @param {boolean} isPointerCapturing Should never be `null`/`undefined`.
	 *        `true`: start to capture pointer if it is not capturing.
	 *        `false`: end the capture if it is capturing.
	 */
	
	
	function togglePointerCapture(instance, isPointerCapturing) {
	  instance._mayPointerCapture = null;
	
	  if (globalEventSupported && instance._pointerCapturing ^ isPointerCapturing) {
	    instance._pointerCapturing = isPointerCapturing;
	    var globalHandlerScope = instance._globalHandlerScope;
	    isPointerCapturing ? mountGlobalDOMEventListeners(instance, globalHandlerScope) : unmountDOMEventListeners(globalHandlerScope);
	  }
	}
	/**
	 * @inner
	 * @class
	 */
	
	
	function DOMHandlerScope(domTarget, domHandlers) {
	  this.domTarget = domTarget;
	  this.domHandlers = domHandlers; // Key: eventName, value: mounted handler funcitons.
	  // Used for unmount.
	
	  this.mounted = {};
	  this.listenerOpts = {};
	  this.touchTimer = null;
	  this.touching = false;
	}
	/**
	 * @public
	 * @class
	 */
	
	
	function HandlerDomProxy(dom, painterRoot) {
	  Eventful.call(this);
	  this.dom = dom;
	  this.painterRoot = painterRoot;
	  this._localHandlerScope = new DOMHandlerScope(dom, localDOMHandlers);
	
	  if (globalEventSupported) {
	    this._globalHandlerScope = new DOMHandlerScope(document, globalDOMHandlers);
	  }
	  /**
	   * @type {boolean}
	   */
	
	
	  this._pointerCapturing = false;
	  /**
	   * @type {Array.<number>} [x, y] or null.
	   */
	
	  this._mayPointerCapture = null;
	  mountLocalDOMEventListeners(this, this._localHandlerScope);
	}
	
	var handlerDomProxyProto = HandlerDomProxy.prototype;
	
	handlerDomProxyProto.dispose = function () {
	  unmountDOMEventListeners(this._localHandlerScope);
	
	  if (globalEventSupported) {
	    unmountDOMEventListeners(this._globalHandlerScope);
	  }
	};
	
	handlerDomProxyProto.setCursor = function (cursorStyle) {
	  this.dom.style && (this.dom.style.cursor = cursorStyle || 'default');
	};
	
	zrUtil.mixin(HandlerDomProxy, Eventful);
	var _default = HandlerDomProxy;
	module.exports = _default;

/***/ },
/* 2984 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	// CompoundPath to improve performance
	var _default = Path.extend({
	  type: 'compound',
	  shape: {
	    paths: null
	  },
	  _updatePathDirty: function () {
	    var dirtyPath = this.__dirtyPath;
	    var paths = this.shape.paths;
	
	    for (var i = 0; i < paths.length; i++) {
	      // Mark as dirty if any subpath is dirty
	      dirtyPath = dirtyPath || paths[i].__dirtyPath;
	    }
	
	    this.__dirtyPath = dirtyPath;
	    this.__dirty = this.__dirty || dirtyPath;
	  },
	  beforeBrush: function () {
	    this._updatePathDirty();
	
	    var paths = this.shape.paths || [];
	    var scale = this.getGlobalScale(); // Update path scale
	
	    for (var i = 0; i < paths.length; i++) {
	      if (!paths[i].path) {
	        paths[i].createPathProxy();
	      }
	
	      paths[i].path.setScale(scale[0], scale[1], paths[i].segmentIgnoreThreshold);
	    }
	  },
	  buildPath: function (ctx, shape) {
	    var paths = shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].buildPath(ctx, paths[i].shape, true);
	    }
	  },
	  afterBrush: function () {
	    var paths = this.shape.paths || [];
	
	    for (var i = 0; i < paths.length; i++) {
	      paths[i].__dirtyPath = false;
	    }
	  },
	  getBoundingRect: function () {
	    this._updatePathDirty();
	
	    return Path.prototype.getBoundingRect.call(this);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2985 */
/***/ function(module, exports, __webpack_require__) {

	var zrUtil = __webpack_require__(4);
	
	var Gradient = __webpack_require__(393);
	
	/**
	 * x, y, r are all percent from 0 to 1
	 * @param {number} [x=0.5]
	 * @param {number} [y=0.5]
	 * @param {number} [r=0.5]
	 * @param {Array.<Object>} [colorStops]
	 * @param {boolean} [globalCoord=false]
	 */
	var RadialGradient = function (x, y, r, colorStops, globalCoord) {
	  // Should do nothing more in this constructor. Because gradient can be
	  // declard by `color: {type: 'radial', colorStops: ...}`, where
	  // this constructor will not be called.
	  this.x = x == null ? 0.5 : x;
	  this.y = y == null ? 0.5 : y;
	  this.r = r == null ? 0.5 : r; // Can be cloned
	
	  this.type = 'radial'; // If use global coord
	
	  this.global = globalCoord || false;
	  Gradient.call(this, colorStops);
	};
	
	RadialGradient.prototype = {
	  constructor: RadialGradient
	};
	zrUtil.inherits(RadialGradient, Gradient);
	var _default = RadialGradient;
	module.exports = _default;

/***/ },
/* 2986 */
/***/ function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(55);
	
	var v2Min = _vector.min;
	var v2Max = _vector.max;
	var v2Scale = _vector.scale;
	var v2Distance = _vector.distance;
	var v2Add = _vector.add;
	var v2Clone = _vector.clone;
	var v2Sub = _vector.sub;
	
	/**
	 * 贝塞尔平滑曲线
	 * @module zrender/shape/util/smoothBezier
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * 贝塞尔平滑曲线
	 * @alias module:zrender/shape/util/smoothBezier
	 * @param {Array} points 线段顶点数组
	 * @param {number} smooth 平滑等级, 0-1
	 * @param {boolean} isLoop
	 * @param {Array} constraint 将计算出来的控制点约束在一个包围盒内
	 *                           比如 [[0, 0], [100, 100]], 这个包围盒会与
	 *                           整个折线的包围盒做一个并集用来约束控制点。
	 * @param {Array} 计算出来的控制点数组
	 */
	function _default(points, smooth, isLoop, constraint) {
	  var cps = [];
	  var v = [];
	  var v1 = [];
	  var v2 = [];
	  var prevPoint;
	  var nextPoint;
	  var min;
	  var max;
	
	  if (constraint) {
	    min = [Infinity, Infinity];
	    max = [-Infinity, -Infinity];
	
	    for (var i = 0, len = points.length; i < len; i++) {
	      v2Min(min, min, points[i]);
	      v2Max(max, max, points[i]);
	    } // 与指定的包围盒做并集
	
	
	    v2Min(min, min, constraint[0]);
	    v2Max(max, max, constraint[1]);
	  }
	
	  for (var i = 0, len = points.length; i < len; i++) {
	    var point = points[i];
	
	    if (isLoop) {
	      prevPoint = points[i ? i - 1 : len - 1];
	      nextPoint = points[(i + 1) % len];
	    } else {
	      if (i === 0 || i === len - 1) {
	        cps.push(v2Clone(points[i]));
	        continue;
	      } else {
	        prevPoint = points[i - 1];
	        nextPoint = points[i + 1];
	      }
	    }
	
	    v2Sub(v, nextPoint, prevPoint); // use degree to scale the handle length
	
	    v2Scale(v, v, smooth);
	    var d0 = v2Distance(point, prevPoint);
	    var d1 = v2Distance(point, nextPoint);
	    var sum = d0 + d1;
	
	    if (sum !== 0) {
	      d0 /= sum;
	      d1 /= sum;
	    }
	
	    v2Scale(v1, v, -d0);
	    v2Scale(v2, v, d1);
	    var cp0 = v2Add([], point, v1);
	    var cp1 = v2Add([], point, v2);
	
	    if (constraint) {
	      v2Max(cp0, cp0, min);
	      v2Min(cp0, cp0, max);
	      v2Max(cp1, cp1, min);
	      v2Min(cp1, cp1, max);
	    }
	
	    cps.push(cp0);
	    cps.push(cp1);
	  }
	
	  if (isLoop) {
	    cps.push(cps.shift());
	  }
	
	  return cps;
	}
	
	module.exports = _default;

/***/ },
/* 2987 */
/***/ function(module, exports, __webpack_require__) {

	var _vector = __webpack_require__(55);
	
	var v2Distance = _vector.distance;
	
	/**
	 * Catmull-Rom spline 插值折线
	 * @module zrender/shape/util/smoothSpline
	 * @author pissang (https://www.github.com/pissang)
	 *         Kener (@Kener-林峰, kener.linfeng@gmail.com)
	 *         errorrik (errorrik@gmail.com)
	 */
	
	/**
	 * @inner
	 */
	function interpolate(p0, p1, p2, p3, t, t2, t3) {
	  var v0 = (p2 - p0) * 0.5;
	  var v1 = (p3 - p1) * 0.5;
	  return (2 * (p1 - p2) + v0 + v1) * t3 + (-3 * (p1 - p2) - 2 * v0 - v1) * t2 + v0 * t + p1;
	}
	/**
	 * @alias module:zrender/shape/util/smoothSpline
	 * @param {Array} points 线段顶点数组
	 * @param {boolean} isLoop
	 * @return {Array}
	 */
	
	
	function _default(points, isLoop) {
	  var len = points.length;
	  var ret = [];
	  var distance = 0;
	
	  for (var i = 1; i < len; i++) {
	    distance += v2Distance(points[i - 1], points[i]);
	  }
	
	  var segs = distance / 2;
	  segs = segs < len ? len : segs;
	
	  for (var i = 0; i < segs; i++) {
	    var pos = i / (segs - 1) * (isLoop ? len : len - 1);
	    var idx = Math.floor(pos);
	    var w = pos - idx;
	    var p0;
	    var p1 = points[idx % len];
	    var p2;
	    var p3;
	
	    if (!isLoop) {
	      p0 = points[idx === 0 ? idx : idx - 1];
	      p2 = points[idx > len - 2 ? len - 1 : idx + 1];
	      p3 = points[idx > len - 3 ? len - 1 : idx + 2];
	    } else {
	      p0 = points[(idx - 1 + len) % len];
	      p2 = points[(idx + 1) % len];
	      p3 = points[(idx + 2) % len];
	    }
	
	    var w2 = w * w;
	    var w3 = w * w2;
	    ret.push([interpolate(p0[0], p1[0], p2[0], p3[0], w, w2, w3), interpolate(p0[1], p1[1], p2[1], p3[1], w, w2, w3)]);
	  }
	
	  return ret;
	}
	
	module.exports = _default;

/***/ },
/* 2988 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	/**
	 * 圆弧
	 * @module zrender/graphic/shape/Arc
	 */
	var _default = Path.extend({
	  type: 'arc',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2989 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	var vec2 = __webpack_require__(55);
	
	var _curve = __webpack_require__(188);
	
	var quadraticSubdivide = _curve.quadraticSubdivide;
	var cubicSubdivide = _curve.cubicSubdivide;
	var quadraticAt = _curve.quadraticAt;
	var cubicAt = _curve.cubicAt;
	var quadraticDerivativeAt = _curve.quadraticDerivativeAt;
	var cubicDerivativeAt = _curve.cubicDerivativeAt;
	
	/**
	 * 贝塞尔曲线
	 * @module zrender/shape/BezierCurve
	 */
	var out = [];
	
	function someVectorAt(shape, t, isTangent) {
	  var cpx2 = shape.cpx2;
	  var cpy2 = shape.cpy2;
	
	  if (cpx2 === null || cpy2 === null) {
	    return [(isTangent ? cubicDerivativeAt : cubicAt)(shape.x1, shape.cpx1, shape.cpx2, shape.x2, t), (isTangent ? cubicDerivativeAt : cubicAt)(shape.y1, shape.cpy1, shape.cpy2, shape.y2, t)];
	  } else {
	    return [(isTangent ? quadraticDerivativeAt : quadraticAt)(shape.x1, shape.cpx1, shape.x2, t), (isTangent ? quadraticDerivativeAt : quadraticAt)(shape.y1, shape.cpy1, shape.y2, t)];
	  }
	}
	
	var _default = Path.extend({
	  type: 'bezier-curve',
	  shape: {
	    x1: 0,
	    y1: 0,
	    x2: 0,
	    y2: 0,
	    cpx1: 0,
	    cpy1: 0,
	    // cpx2: 0,
	    // cpy2: 0
	    // Curve show percent, for animating
	    percent: 1
	  },
	  style: {
	    stroke: '#000',
	    fill: null
	  },
	  buildPath: function (ctx, shape) {
	    var x1 = shape.x1;
	    var y1 = shape.y1;
	    var x2 = shape.x2;
	    var y2 = shape.y2;
	    var cpx1 = shape.cpx1;
	    var cpy1 = shape.cpy1;
	    var cpx2 = shape.cpx2;
	    var cpy2 = shape.cpy2;
	    var percent = shape.percent;
	
	    if (percent === 0) {
	      return;
	    }
	
	    ctx.moveTo(x1, y1);
	
	    if (cpx2 == null || cpy2 == null) {
	      if (percent < 1) {
	        quadraticSubdivide(x1, cpx1, x2, percent, out);
	        cpx1 = out[1];
	        x2 = out[2];
	        quadraticSubdivide(y1, cpy1, y2, percent, out);
	        cpy1 = out[1];
	        y2 = out[2];
	      }
	
	      ctx.quadraticCurveTo(cpx1, cpy1, x2, y2);
	    } else {
	      if (percent < 1) {
	        cubicSubdivide(x1, cpx1, cpx2, x2, percent, out);
	        cpx1 = out[1];
	        cpx2 = out[2];
	        x2 = out[3];
	        cubicSubdivide(y1, cpy1, cpy2, y2, percent, out);
	        cpy1 = out[1];
	        cpy2 = out[2];
	        y2 = out[3];
	      }
	
	      ctx.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, x2, y2);
	    }
	  },
	
	  /**
	   * Get point at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  pointAt: function (t) {
	    return someVectorAt(this.shape, t, false);
	  },
	
	  /**
	   * Get tangent at percent
	   * @param  {number} t
	   * @return {Array.<number>}
	   */
	  tangentAt: function (t) {
	    var p = someVectorAt(this.shape, t, true);
	    return vec2.normalize(p, p);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2990 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	/**
	 * 椭圆形状
	 * @module zrender/graphic/shape/Ellipse
	 */
	var _default = Path.extend({
	  type: 'ellipse',
	  shape: {
	    cx: 0,
	    cy: 0,
	    rx: 0,
	    ry: 0
	  },
	  buildPath: function (ctx, shape) {
	    var k = 0.5522848;
	    var x = shape.cx;
	    var y = shape.cy;
	    var a = shape.rx;
	    var b = shape.ry;
	    var ox = a * k; // 水平控制点偏移量
	
	    var oy = b * k; // 垂直控制点偏移量
	    // 从椭圆的左端点开始顺时针绘制四条三次贝塞尔曲线
	
	    ctx.moveTo(x - a, y);
	    ctx.bezierCurveTo(x - a, y - oy, x - ox, y - b, x, y - b);
	    ctx.bezierCurveTo(x + ox, y - b, x + a, y - oy, x + a, y);
	    ctx.bezierCurveTo(x + a, y + oy, x + ox, y + b, x, y + b);
	    ctx.bezierCurveTo(x - ox, y + b, x - a, y + oy, x - a, y);
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2991 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	/**
	 * 圆环
	 * @module zrender/graphic/shape/Ring
	 */
	var _default = Path.extend({
	  type: 'ring',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r: 0,
	    r0: 0
	  },
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var PI2 = Math.PI * 2;
	    ctx.moveTo(x + shape.r, y);
	    ctx.arc(x, y, shape.r, 0, PI2, false);
	    ctx.moveTo(x + shape.r0, y);
	    ctx.arc(x, y, shape.r0, 0, PI2, true);
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2992 */
/***/ function(module, exports, __webpack_require__) {

	var Path = __webpack_require__(67);
	
	var fixClipWithShadow = __webpack_require__(1199);
	
	/**
	 * 扇形
	 * @module zrender/graphic/shape/Sector
	 */
	var _default = Path.extend({
	  type: 'sector',
	  shape: {
	    cx: 0,
	    cy: 0,
	    r0: 0,
	    r: 0,
	    startAngle: 0,
	    endAngle: Math.PI * 2,
	    clockwise: true
	  },
	  brush: fixClipWithShadow(Path.prototype.brush),
	  buildPath: function (ctx, shape) {
	    var x = shape.cx;
	    var y = shape.cy;
	    var r0 = Math.max(shape.r0 || 0, 0);
	    var r = Math.max(shape.r, 0);
	    var startAngle = shape.startAngle;
	    var endAngle = shape.endAngle;
	    var clockwise = shape.clockwise;
	    var unitX = Math.cos(startAngle);
	    var unitY = Math.sin(startAngle);
	    ctx.moveTo(unitX * r0 + x, unitY * r0 + y);
	    ctx.lineTo(unitX * r + x, unitY * r + y);
	    ctx.arc(x, y, r, startAngle, endAngle, !clockwise);
	    ctx.lineTo(Math.cos(endAngle) * r0 + x, Math.sin(endAngle) * r0 + y);
	
	    if (r0 !== 0) {
	      ctx.arc(x, y, r0, endAngle, startAngle, clockwise);
	    }
	
	    ctx.closePath();
	  }
	});
	
	module.exports = _default;

/***/ },
/* 2993 */
/***/ function(module, exports, __webpack_require__) {

	var Animator = __webpack_require__(1188);
	
	var logError = __webpack_require__(315);
	
	var _util = __webpack_require__(4);
	
	var isString = _util.isString;
	var isFunction = _util.isFunction;
	var isObject = _util.isObject;
	var isArrayLike = _util.isArrayLike;
	var indexOf = _util.indexOf;
	
	/**
	 * @alias module:zrender/mixin/Animatable
	 * @constructor
	 */
	var Animatable = function () {
	  /**
	   * @type {Array.<module:zrender/animation/Animator>}
	   * @readOnly
	   */
	  this.animators = [];
	};
	
	Animatable.prototype = {
	  constructor: Animatable,
	
	  /**
	   * 动画
	   *
	   * @param {string} path The path to fetch value from object, like 'a.b.c'.
	   * @param {boolean} [loop] Whether to loop animation.
	   * @return {module:zrender/animation/Animator}
	   * @example:
	   *     el.animate('style', false)
	   *         .when(1000, {x: 10} )
	   *         .done(function(){ // Animation done })
	   *         .start()
	   */
	  animate: function (path, loop) {
	    var target;
	    var animatingShape = false;
	    var el = this;
	    var zr = this.__zr;
	
	    if (path) {
	      var pathSplitted = path.split('.');
	      var prop = el; // If animating shape
	
	      animatingShape = pathSplitted[0] === 'shape';
	
	      for (var i = 0, l = pathSplitted.length; i < l; i++) {
	        if (!prop) {
	          continue;
	        }
	
	        prop = prop[pathSplitted[i]];
	      }
	
	      if (prop) {
	        target = prop;
	      }
	    } else {
	      target = el;
	    }
	
	    if (!target) {
	      logError('Property "' + path + '" is not existed in element ' + el.id);
	      return;
	    }
	
	    var animators = el.animators;
	    var animator = new Animator(target, loop);
	    animator.during(function (target) {
	      el.dirty(animatingShape);
	    }).done(function () {
	      // FIXME Animator will not be removed if use `Animator#stop` to stop animation
	      animators.splice(indexOf(animators, animator), 1);
	    });
	    animators.push(animator); // If animate after added to the zrender
	
	    if (zr) {
	      zr.animation.addAnimator(animator);
	    }
	
	    return animator;
	  },
	
	  /**
	   * 停止动画
	   * @param {boolean} forwardToLast If move to last frame before stop
	   */
	  stopAnimation: function (forwardToLast) {
	    var animators = this.animators;
	    var len = animators.length;
	
	    for (var i = 0; i < len; i++) {
	      animators[i].stop(forwardToLast);
	    }
	
	    animators.length = 0;
	    return this;
	  },
	
	  /**
	   * Caution: this method will stop previous animation.
	   * So do not use this method to one element twice before
	   * animation starts, unless you know what you are doing.
	   * @param {Object} target
	   * @param {number} [time=500] Time in ms
	   * @param {string} [easing='linear']
	   * @param {number} [delay=0]
	   * @param {Function} [callback]
	   * @param {Function} [forceAnimate] Prevent stop animation and callback
	   *        immediently when target values are the same as current values.
	   *
	   * @example
	   *  // Animate position
	   *  el.animateTo({
	   *      position: [10, 10]
	   *  }, function () { // done })
	   *
	   *  // Animate shape, style and position in 100ms, delayed 100ms, with cubicOut easing
	   *  el.animateTo({
	   *      shape: {
	   *          width: 500
	   *      },
	   *      style: {
	   *          fill: 'red'
	   *      }
	   *      position: [10, 10]
	   *  }, 100, 100, 'cubicOut', function () { // done })
	   */
	  // TODO Return animation key
	  animateTo: function (target, time, delay, easing, callback, forceAnimate) {
	    animateTo(this, target, time, delay, easing, callback, forceAnimate);
	  },
	
	  /**
	   * Animate from the target state to current state.
	   * The params and the return value are the same as `this.animateTo`.
	   */
	  animateFrom: function (target, time, delay, easing, callback, forceAnimate) {
	    animateTo(this, target, time, delay, easing, callback, forceAnimate, true);
	  }
	};
	
	function animateTo(animatable, target, time, delay, easing, callback, forceAnimate, reverse) {
	  // animateTo(target, time, easing, callback);
	  if (isString(delay)) {
	    callback = easing;
	    easing = delay;
	    delay = 0;
	  } // animateTo(target, time, delay, callback);
	  else if (isFunction(easing)) {
	      callback = easing;
	      easing = 'linear';
	      delay = 0;
	    } // animateTo(target, time, callback);
	    else if (isFunction(delay)) {
	        callback = delay;
	        delay = 0;
	      } // animateTo(target, callback)
	      else if (isFunction(time)) {
	          callback = time;
	          time = 500;
	        } // animateTo(target)
	        else if (!time) {
	            time = 500;
	          } // Stop all previous animations
	
	
	  animatable.stopAnimation();
	  animateToShallow(animatable, '', animatable, target, time, delay, reverse); // Animators may be removed immediately after start
	  // if there is nothing to animate
	
	  var animators = animatable.animators.slice();
	  var count = animators.length;
	
	  function done() {
	    count--;
	
	    if (!count) {
	      callback && callback();
	    }
	  } // No animators. This should be checked before animators[i].start(),
	  // because 'done' may be executed immediately if no need to animate.
	
	
	  if (!count) {
	    callback && callback();
	  } // Start after all animators created
	  // Incase any animator is done immediately when all animation properties are not changed
	
	
	  for (var i = 0; i < animators.length; i++) {
	    animators[i].done(done).start(easing, forceAnimate);
	  }
	}
	/**
	 * @param {string} path=''
	 * @param {Object} source=animatable
	 * @param {Object} target
	 * @param {number} [time=500]
	 * @param {number} [delay=0]
	 * @param {boolean} [reverse] If `true`, animate
	 *        from the `target` to current state.
	 *
	 * @example
	 *  // Animate position
	 *  el._animateToShallow({
	 *      position: [10, 10]
	 *  })
	 *
	 *  // Animate shape, style and position in 100ms, delayed 100ms
	 *  el._animateToShallow({
	 *      shape: {
	 *          width: 500
	 *      },
	 *      style: {
	 *          fill: 'red'
	 *      }
	 *      position: [10, 10]
	 *  }, 100, 100)
	 */
	
	
	function animateToShallow(animatable, path, source, target, time, delay, reverse) {
	  var objShallow = {};
	  var propertyCount = 0;
	
	  for (var name in target) {
	    if (!target.hasOwnProperty(name)) {
	      continue;
	    }
	
	    if (source[name] != null) {
	      if (isObject(target[name]) && !isArrayLike(target[name])) {
	        animateToShallow(animatable, path ? path + '.' + name : name, source[name], target[name], time, delay, reverse);
	      } else {
	        if (reverse) {
	          objShallow[name] = source[name];
	          setAttrByPath(animatable, path, name, target[name]);
	        } else {
	          objShallow[name] = target[name];
	        }
	
	        propertyCount++;
	      }
	    } else if (target[name] != null && !reverse) {
	      setAttrByPath(animatable, path, name, target[name]);
	    }
	  }
	
	  if (propertyCount > 0) {
	    animatable.animate(path, false).when(time == null ? 500 : time, objShallow).delay(delay || 0);
	  }
	}
	
	function setAttrByPath(el, path, name, value) {
	  // Attr directly if not has property
	  // FIXME, if some property not needed for element ?
	  if (!path) {
	    el.attr(name, value);
	  } else {
	    // Only support set shape or style
	    var props = {};
	    props[path] = {};
	    props[path][name] = value;
	    el.attr(props);
	  }
	}
	
	var _default = Animatable;
	module.exports = _default;

/***/ },
/* 2994 */
/***/ function(module, exports) {

	// TODO Draggable for group
	// FIXME Draggable on element which has parent rotation or scale
	function Draggable() {
	  this.on('mousedown', this._dragStart, this);
	  this.on('mousemove', this._drag, this);
	  this.on('mouseup', this._dragEnd, this); // `mosuemove` and `mouseup` can be continue to fire when dragging.
	  // See [Drag outside] in `Handler.js`. So we do not need to trigger
	  // `_dragEnd` when globalout. That would brings better user experience.
	  // this.on('globalout', this._dragEnd, this);
	  // this._dropTarget = null;
	  // this._draggingTarget = null;
	  // this._x = 0;
	  // this._y = 0;
	}
	
	Draggable.prototype = {
	  constructor: Draggable,
	  _dragStart: function (e) {
	    var draggingTarget = e.target; // Find if there is draggable in the ancestor
	
	    while (draggingTarget && !draggingTarget.draggable) {
	      draggingTarget = draggingTarget.parent;
	    }
	
	    if (draggingTarget) {
	      this._draggingTarget = draggingTarget;
	      draggingTarget.dragging = true;
	      this._x = e.offsetX;
	      this._y = e.offsetY;
	      this.dispatchToElement(param(draggingTarget, e), 'dragstart', e.event);
	    }
	  },
	  _drag: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      var x = e.offsetX;
	      var y = e.offsetY;
	      var dx = x - this._x;
	      var dy = y - this._y;
	      this._x = x;
	      this._y = y;
	      draggingTarget.drift(dx, dy, e);
	      this.dispatchToElement(param(draggingTarget, e), 'drag', e.event);
	      var dropTarget = this.findHover(x, y, draggingTarget).target;
	      var lastDropTarget = this._dropTarget;
	      this._dropTarget = dropTarget;
	
	      if (draggingTarget !== dropTarget) {
	        if (lastDropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(lastDropTarget, e), 'dragleave', e.event);
	        }
	
	        if (dropTarget && dropTarget !== lastDropTarget) {
	          this.dispatchToElement(param(dropTarget, e), 'dragenter', e.event);
	        }
	      }
	    }
	  },
	  _dragEnd: function (e) {
	    var draggingTarget = this._draggingTarget;
	
	    if (draggingTarget) {
	      draggingTarget.dragging = false;
	    }
	
	    this.dispatchToElement(param(draggingTarget, e), 'dragend', e.event);
	
	    if (this._dropTarget) {
	      this.dispatchToElement(param(this._dropTarget, e), 'drop', e.event);
	    }
	
	    this._draggingTarget = null;
	    this._dropTarget = null;
	  }
	};
	
	function param(target, e) {
	  return {
	    target: target,
	    topTarget: e && e.topTarget
	  };
	}
	
	var _default = Draggable;
	module.exports = _default;

/***/ },
/* 2995 */
/***/ function(module, exports, __webpack_require__) {

	var _core = __webpack_require__(607);
	
	var createElement = _core.createElement;
	
	var util = __webpack_require__(4);
	
	var logError = __webpack_require__(315);
	
	var Path = __webpack_require__(67);
	
	var ZImage = __webpack_require__(267);
	
	var ZText = __webpack_require__(224);
	
	var arrayDiff = __webpack_require__(2981);
	
	var GradientManager = __webpack_require__(2997);
	
	var ClippathManager = __webpack_require__(2996);
	
	var ShadowManager = __webpack_require__(2998);
	
	var _graphic = __webpack_require__(608);
	
	var svgPath = _graphic.path;
	var svgImage = _graphic.image;
	var svgText = _graphic.text;
	
	/**
	 * SVG Painter
	 * @module zrender/svg/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	
	function getSvgProxy(el) {
	  if (el instanceof Path) {
	    return svgPath;
	  } else if (el instanceof ZImage) {
	    return svgImage;
	  } else if (el instanceof ZText) {
	    return svgText;
	  } else {
	    return svgPath;
	  }
	}
	
	function checkParentAvailable(parent, child) {
	  return child && parent && child.parentNode !== parent;
	}
	
	function insertAfter(parent, child, prevSibling) {
	  if (checkParentAvailable(parent, child) && prevSibling) {
	    var nextSibling = prevSibling.nextSibling;
	    nextSibling ? parent.insertBefore(child, nextSibling) : parent.appendChild(child);
	  }
	}
	
	function prepend(parent, child) {
	  if (checkParentAvailable(parent, child)) {
	    var firstChild = parent.firstChild;
	    firstChild ? parent.insertBefore(child, firstChild) : parent.appendChild(child);
	  }
	} // function append(parent, child) {
	//     if (checkParentAvailable(parent, child)) {
	//         parent.appendChild(child);
	//     }
	// }
	
	
	function remove(parent, child) {
	  if (child && parent && child.parentNode === parent) {
	    parent.removeChild(child);
	  }
	}
	
	function getTextSvgElement(displayable) {
	  return displayable.__textSvgEl;
	}
	
	function getSvgElement(displayable) {
	  return displayable.__svgEl;
	}
	/**
	 * @alias module:zrender/svg/Painter
	 * @constructor
	 * @param {HTMLElement} root 绘图容器
	 * @param {module:zrender/Storage} storage
	 * @param {Object} opts
	 */
	
	
	var SVGPainter = function (root, storage, opts, zrId) {
	  this.root = root;
	  this.storage = storage;
	  this._opts = opts = util.extend({}, opts || {});
	  var svgDom = createElement('svg');
	  svgDom.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
	  svgDom.setAttribute('version', '1.1');
	  svgDom.setAttribute('baseProfile', 'full');
	  svgDom.style.cssText = 'user-select:none;position:absolute;left:0;top:0;';
	  var bgRoot = createElement('g');
	  svgDom.appendChild(bgRoot);
	  var svgRoot = createElement('g');
	  svgDom.appendChild(svgRoot);
	  this.gradientManager = new GradientManager(zrId, svgRoot);
	  this.clipPathManager = new ClippathManager(zrId, svgRoot);
	  this.shadowManager = new ShadowManager(zrId, svgRoot);
	  var viewport = document.createElement('div');
	  viewport.style.cssText = 'overflow:hidden;position:relative';
	  this._svgDom = svgDom;
	  this._svgRoot = svgRoot;
	  this._backgroundRoot = bgRoot;
	  this._viewport = viewport;
	  root.appendChild(viewport);
	  viewport.appendChild(svgDom);
	  this.resize(opts.width, opts.height);
	  this._visibleList = [];
	};
	
	SVGPainter.prototype = {
	  constructor: SVGPainter,
	  getType: function () {
	    return 'svg';
	  },
	  getViewportRoot: function () {
	    return this._viewport;
	  },
	  getSvgDom: function () {
	    return this._svgDom;
	  },
	  getSvgRoot: function () {
	    return this._svgRoot;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	  refresh: function () {
	    var list = this.storage.getDisplayList(true);
	
	    this._paintList(list);
	  },
	  setBackgroundColor: function (backgroundColor) {
	    // TODO gradient
	    // Insert a bg rect instead of setting background to viewport.
	    // Otherwise, the exported SVG don't have background.
	    if (this._backgroundRoot && this._backgroundNode) {
	      this._backgroundRoot.removeChild(this._backgroundNode);
	    }
	
	    var bgNode = createElement('rect');
	    bgNode.setAttribute('width', this.getWidth());
	    bgNode.setAttribute('height', this.getHeight());
	    bgNode.setAttribute('x', 0);
	    bgNode.setAttribute('y', 0);
	    bgNode.setAttribute('id', 0);
	    bgNode.style.fill = backgroundColor;
	
	    this._backgroundRoot.appendChild(bgNode);
	
	    this._backgroundNode = bgNode;
	  },
	  _paintList: function (list) {
	    this.gradientManager.markAllUnused();
	    this.clipPathManager.markAllUnused();
	    this.shadowManager.markAllUnused();
	    var svgRoot = this._svgRoot;
	    var visibleList = this._visibleList;
	    var listLen = list.length;
	    var newVisibleList = [];
	    var i;
	
	    for (i = 0; i < listLen; i++) {
	      var displayable = list[i];
	      var svgProxy = getSvgProxy(displayable);
	      var svgElement = getSvgElement(displayable) || getTextSvgElement(displayable);
	
	      if (!displayable.invisible) {
	        if (displayable.__dirty) {
	          svgProxy && svgProxy.brush(displayable); // Update clipPath
	
	          this.clipPathManager.update(displayable); // Update gradient and shadow
	
	          if (displayable.style) {
	            this.gradientManager.update(displayable.style.fill);
	            this.gradientManager.update(displayable.style.stroke);
	            this.shadowManager.update(svgElement, displayable);
	          }
	
	          displayable.__dirty = false;
	        }
	
	        newVisibleList.push(displayable);
	      }
	    }
	
	    var diff = arrayDiff(visibleList, newVisibleList);
	    var prevSvgElement; // First do remove, in case element moved to the head and do remove
	    // after add
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = visibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          remove(svgRoot, svgElement);
	          remove(svgRoot, textSvgElement);
	        }
	      }
	    }
	
	    for (i = 0; i < diff.length; i++) {
	      var item = diff[i];
	
	      if (item.added) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          prevSvgElement ? insertAfter(svgRoot, svgElement, prevSvgElement) : prepend(svgRoot, svgElement);
	
	          if (svgElement) {
	            insertAfter(svgRoot, textSvgElement, svgElement);
	          } else if (prevSvgElement) {
	            insertAfter(svgRoot, textSvgElement, prevSvgElement);
	          } else {
	            prepend(svgRoot, textSvgElement);
	          } // Insert text
	
	
	          insertAfter(svgRoot, textSvgElement, svgElement);
	          prevSvgElement = textSvgElement || svgElement || prevSvgElement; // zrender.Text only create textSvgElement.
	
	          this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	        }
	      } else if (!item.removed) {
	        for (var k = 0; k < item.count; k++) {
	          var displayable = newVisibleList[item.indices[k]];
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          var svgElement = getSvgElement(displayable);
	          var textSvgElement = getTextSvgElement(displayable);
	          this.gradientManager.markUsed(displayable);
	          this.gradientManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.shadowManager.markUsed(displayable);
	          this.shadowManager.addWithoutUpdate(svgElement || textSvgElement, displayable);
	          this.clipPathManager.markUsed(displayable);
	
	          if (textSvgElement) {
	            // Insert text.
	            insertAfter(svgRoot, textSvgElement, svgElement);
	          }
	
	          prevSvgElement = svgElement || textSvgElement || prevSvgElement;
	        }
	      }
	    }
	
	    this.gradientManager.removeUnused();
	    this.clipPathManager.removeUnused();
	    this.shadowManager.removeUnused();
	    this._visibleList = newVisibleList;
	  },
	  _getDefs: function (isForceCreating) {
	    var svgRoot = this._svgDom;
	    var defs = svgRoot.getElementsByTagName('defs');
	
	    if (defs.length === 0) {
	      // Not exist
	      if (isForceCreating) {
	        var defs = svgRoot.insertBefore(createElement('defs'), // Create new tag
	        svgRoot.firstChild // Insert in the front of svg
	        );
	
	        if (!defs.contains) {
	          // IE doesn't support contains method
	          defs.contains = function (el) {
	            var children = defs.children;
	
	            if (!children) {
	              return false;
	            }
	
	            for (var i = children.length - 1; i >= 0; --i) {
	              if (children[i] === el) {
	                return true;
	              }
	            }
	
	            return false;
	          };
	        }
	
	        return defs;
	      } else {
	        return null;
	      }
	    } else {
	      return defs[0];
	    }
	  },
	  resize: function (width, height) {
	    var viewport = this._viewport; // FIXME Why ?
	
	    viewport.style.display = 'none'; // Save input w/h
	
	    var opts = this._opts;
	    width != null && (opts.width = width);
	    height != null && (opts.height = height);
	    width = this._getSize(0);
	    height = this._getSize(1);
	    viewport.style.display = '';
	
	    if (this._width !== width || this._height !== height) {
	      this._width = width;
	      this._height = height;
	      var viewportStyle = viewport.style;
	      viewportStyle.width = width + 'px';
	      viewportStyle.height = height + 'px';
	      var svgRoot = this._svgDom; // Set width by 'svgRoot.width = width' is invalid
	
	      svgRoot.setAttribute('width', width);
	      svgRoot.setAttribute('height', height);
	    }
	
	    if (this._backgroundNode) {
	      this._backgroundNode.setAttribute('width', width);
	
	      this._backgroundNode.setAttribute('height', height);
	    }
	  },
	
	  /**
	   * 获取绘图区域宽度
	   */
	  getWidth: function () {
	    return this._width;
	  },
	
	  /**
	   * 获取绘图区域高度
	   */
	  getHeight: function () {
	    return this._height;
	  },
	  _getSize: function (whIdx) {
	    var opts = this._opts;
	    var wh = ['width', 'height'][whIdx];
	    var cwh = ['clientWidth', 'clientHeight'][whIdx];
	    var plt = ['paddingLeft', 'paddingTop'][whIdx];
	    var prb = ['paddingRight', 'paddingBottom'][whIdx];
	
	    if (opts[wh] != null && opts[wh] !== 'auto') {
	      return parseFloat(opts[wh]);
	    }
	
	    var root = this.root; // IE8 does not support getComputedStyle, but it use VML.
	
	    var stl = document.defaultView.getComputedStyle(root);
	    return (root[cwh] || parseInt10(stl[wh]) || parseInt10(root.style[wh])) - (parseInt10(stl[plt]) || 0) - (parseInt10(stl[prb]) || 0) | 0;
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._svgRoot = this._backgroundRoot = this._svgDom = this._backgroundNode = this._viewport = this.storage = null;
	  },
	  clear: function () {
	    if (this._viewport) {
	      this.root.removeChild(this._viewport);
	    }
	  },
	  toDataURL: function () {
	    this.refresh();
	    var html = encodeURIComponent(this._svgDom.outerHTML.replace(/></g, '>\n\r<'));
	    return 'data:image/svg+xml;charset=UTF-8,' + html;
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    logError('In SVG mode painter not support method "' + method + '"');
	  };
	} // Unsuppoted methods
	
	
	util.each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'pathToImage'], function (name) {
	  SVGPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = SVGPainter;
	module.exports = _default;

/***/ },
/* 2996 */
/***/ function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(609);
	
	var zrUtil = __webpack_require__(4);
	
	var matrix = __webpack_require__(86);
	
	/**
	 * @file Manages SVG clipPath elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG clipPath elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function ClippathManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, 'clipPath', '__clippath_in_use__');
	}
	
	zrUtil.inherits(ClippathManager, Definable);
	/**
	 * Update clipPath.
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	ClippathManager.prototype.update = function (displayable) {
	  var svgEl = this.getSvgElement(displayable);
	
	  if (svgEl) {
	    this.updateDom(svgEl, displayable.__clipPaths, false);
	  }
	
	  var textEl = this.getTextSvgElement(displayable);
	
	  if (textEl) {
	    // Make another clipPath for text, since it's transform
	    // matrix is not the same with svgElement
	    this.updateDom(textEl, displayable.__clipPaths, true);
	  }
	
	  this.markUsed(displayable);
	};
	/**
	 * Create an SVGElement of displayable and create a <clipPath> of its
	 * clipPath
	 *
	 * @param {Displayable} parentEl  parent element
	 * @param {ClipPath[]}  clipPaths clipPaths of parent element
	 * @param {boolean}     isText    if parent element is Text
	 */
	
	
	ClippathManager.prototype.updateDom = function (parentEl, clipPaths, isText) {
	  if (clipPaths && clipPaths.length > 0) {
	    // Has clipPath, create <clipPath> with the first clipPath
	    var defs = this.getDefs(true);
	    var clipPath = clipPaths[0];
	    var clipPathEl;
	    var id;
	    var dom = isText ? '_textDom' : '_dom';
	
	    if (clipPath[dom]) {
	      // Use a dom that is already in <defs>
	      id = clipPath[dom].getAttribute('id');
	      clipPathEl = clipPath[dom]; // Use a dom that is already in <defs>
	
	      if (!defs.contains(clipPathEl)) {
	        // This happens when set old clipPath that has
	        // been previously removed
	        defs.appendChild(clipPathEl);
	      }
	    } else {
	      // New <clipPath>
	      id = 'zr' + this._zrId + '-clip-' + this.nextId;
	      ++this.nextId;
	      clipPathEl = this.createElement('clipPath');
	      clipPathEl.setAttribute('id', id);
	      defs.appendChild(clipPathEl);
	      clipPath[dom] = clipPathEl;
	    } // Build path and add to <clipPath>
	
	
	    var svgProxy = this.getSvgProxy(clipPath);
	
	    if (clipPath.transform && clipPath.parent.invTransform && !isText) {
	      /**
	       * If a clipPath has a parent with transform, the transform
	       * of parent should not be considered when setting transform
	       * of clipPath. So we need to transform back from parent's
	       * transform, which is done by multiplying parent's inverse
	       * transform.
	       */
	      // Store old transform
	      var transform = Array.prototype.slice.call(clipPath.transform); // Transform back from parent, and brush path
	
	      matrix.mul(clipPath.transform, clipPath.parent.invTransform, clipPath.transform);
	      svgProxy.brush(clipPath); // Set back transform of clipPath
	
	      clipPath.transform = transform;
	    } else {
	      svgProxy.brush(clipPath);
	    }
	
	    var pathEl = this.getSvgElement(clipPath);
	    clipPathEl.innerHTML = '';
	    /**
	     * Use `cloneNode()` here to appendChild to multiple parents,
	     * which may happend when Text and other shapes are using the same
	     * clipPath. Since Text will create an extra clipPath DOM due to
	     * different transform rules.
	     */
	
	    clipPathEl.appendChild(pathEl.cloneNode());
	    parentEl.setAttribute('clip-path', 'url(#' + id + ')');
	
	    if (clipPaths.length > 1) {
	      // Make the other clipPaths recursively
	      this.updateDom(clipPathEl, clipPaths.slice(1), isText);
	    }
	  } else {
	    // No clipPath
	    if (parentEl) {
	      parentEl.setAttribute('clip-path', 'none');
	    }
	  }
	};
	/**
	 * Mark a single clipPath to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	ClippathManager.prototype.markUsed = function (displayable) {
	  var that = this; // displayable.__clipPaths can only be `null`/`undefined` or an non-empty array.
	
	  if (displayable.__clipPaths) {
	    zrUtil.each(displayable.__clipPaths, function (clipPath) {
	      if (clipPath._dom) {
	        Definable.prototype.markUsed.call(that, clipPath._dom);
	      }
	
	      if (clipPath._textDom) {
	        Definable.prototype.markUsed.call(that, clipPath._textDom);
	      }
	    });
	  }
	};
	
	var _default = ClippathManager;
	module.exports = _default;

/***/ },
/* 2997 */
/***/ function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(609);
	
	var zrUtil = __webpack_require__(4);
	
	var logError = __webpack_require__(315);
	
	var colorTool = __webpack_require__(148);
	
	/**
	 * @file Manages SVG gradient elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG gradient elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function GradientManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, ['linearGradient', 'radialGradient'], '__gradient_in_use__');
	}
	
	zrUtil.inherits(GradientManager, Definable);
	/**
	 * Create new gradient DOM for fill or stroke if not exist,
	 * but will not update gradient if exists.
	 *
	 * @param {SvgElement}  svgElement   SVG element to paint
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	GradientManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
	  if (displayable && displayable.style) {
	    var that = this;
	    zrUtil.each(['fill', 'stroke'], function (fillOrStroke) {
	      if (displayable.style[fillOrStroke] && (displayable.style[fillOrStroke].type === 'linear' || displayable.style[fillOrStroke].type === 'radial')) {
	        var gradient = displayable.style[fillOrStroke];
	        var defs = that.getDefs(true); // Create dom in <defs> if not exists
	
	        var dom;
	
	        if (gradient._dom) {
	          // Gradient exists
	          dom = gradient._dom;
	
	          if (!defs.contains(gradient._dom)) {
	            // _dom is no longer in defs, recreate
	            that.addDom(dom);
	          }
	        } else {
	          // New dom
	          dom = that.add(gradient);
	        }
	
	        that.markUsed(displayable);
	        var id = dom.getAttribute('id');
	        svgElement.setAttribute(fillOrStroke, 'url(#' + id + ')');
	      }
	    });
	  }
	};
	/**
	 * Add a new gradient tag in <defs>
	 *
	 * @param   {Gradient} gradient zr gradient instance
	 * @return {SVGLinearGradientElement | SVGRadialGradientElement}
	 *                            created DOM
	 */
	
	
	GradientManager.prototype.add = function (gradient) {
	  var dom;
	
	  if (gradient.type === 'linear') {
	    dom = this.createElement('linearGradient');
	  } else if (gradient.type === 'radial') {
	    dom = this.createElement('radialGradient');
	  } else {
	    logError('Illegal gradient type.');
	    return null;
	  } // Set dom id with gradient id, since each gradient instance
	  // will have no more than one dom element.
	  // id may exists before for those dirty elements, in which case
	  // id should remain the same, and other attributes should be
	  // updated.
	
	
	  gradient.id = gradient.id || this.nextId++;
	  dom.setAttribute('id', 'zr' + this._zrId + '-gradient-' + gradient.id);
	  this.updateDom(gradient, dom);
	  this.addDom(dom);
	  return dom;
	};
	/**
	 * Update gradient.
	 *
	 * @param {Gradient} gradient zr gradient instance
	 */
	
	
	GradientManager.prototype.update = function (gradient) {
	  var that = this;
	  Definable.prototype.update.call(this, gradient, function () {
	    var type = gradient.type;
	    var tagName = gradient._dom.tagName;
	
	    if (type === 'linear' && tagName === 'linearGradient' || type === 'radial' && tagName === 'radialGradient') {
	      // Gradient type is not changed, update gradient
	      that.updateDom(gradient, gradient._dom);
	    } else {
	      // Remove and re-create if type is changed
	      that.removeDom(gradient);
	      that.add(gradient);
	    }
	  });
	};
	/**
	 * Update gradient dom
	 *
	 * @param {Gradient} gradient zr gradient instance
	 * @param {SVGLinearGradientElement | SVGRadialGradientElement} dom
	 *                            DOM to update
	 */
	
	
	GradientManager.prototype.updateDom = function (gradient, dom) {
	  if (gradient.type === 'linear') {
	    dom.setAttribute('x1', gradient.x);
	    dom.setAttribute('y1', gradient.y);
	    dom.setAttribute('x2', gradient.x2);
	    dom.setAttribute('y2', gradient.y2);
	  } else if (gradient.type === 'radial') {
	    dom.setAttribute('cx', gradient.x);
	    dom.setAttribute('cy', gradient.y);
	    dom.setAttribute('r', gradient.r);
	  } else {
	    logError('Illegal gradient type.');
	    return;
	  }
	
	  if (gradient.global) {
	    // x1, x2, y1, y2 in range of 0 to canvas width or height
	    dom.setAttribute('gradientUnits', 'userSpaceOnUse');
	  } else {
	    // x1, x2, y1, y2 in range of 0 to 1
	    dom.setAttribute('gradientUnits', 'objectBoundingBox');
	  } // Remove color stops if exists
	
	
	  dom.innerHTML = ''; // Add color stops
	
	  var colors = gradient.colorStops;
	
	  for (var i = 0, len = colors.length; i < len; ++i) {
	    var stop = this.createElement('stop');
	    stop.setAttribute('offset', colors[i].offset * 100 + '%');
	    var color = colors[i].color;
	
	    if (color.indexOf('rgba') > -1) {
	      // Fix Safari bug that stop-color not recognizing alpha #9014
	      var opacity = colorTool.parse(color)[3];
	      var hex = colorTool.toHex(color); // stop-color cannot be color, since:
	      // The opacity value used for the gradient calculation is the
	      // *product* of the value of stop-opacity and the opacity of the
	      // value of stop-color.
	      // See https://www.w3.org/TR/SVG2/pservers.html#StopOpacityProperty
	
	      stop.setAttribute('stop-color', '#' + hex);
	      stop.setAttribute('stop-opacity', opacity);
	    } else {
	      stop.setAttribute('stop-color', colors[i].color);
	    }
	
	    dom.appendChild(stop);
	  } // Store dom element in gradient, to avoid creating multiple
	  // dom instances for the same gradient element
	
	
	  gradient._dom = dom;
	};
	/**
	 * Mark a single gradient to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	GradientManager.prototype.markUsed = function (displayable) {
	  if (displayable.style) {
	    var gradient = displayable.style.fill;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	
	    gradient = displayable.style.stroke;
	
	    if (gradient && gradient._dom) {
	      Definable.prototype.markUsed.call(this, gradient._dom);
	    }
	  }
	};
	
	var _default = GradientManager;
	module.exports = _default;

/***/ },
/* 2998 */
/***/ function(module, exports, __webpack_require__) {

	var Definable = __webpack_require__(609);
	
	var zrUtil = __webpack_require__(4);
	
	/**
	 * @file Manages SVG shadow elements.
	 * @author Zhang Wenli
	 */
	
	/**
	 * Manages SVG shadow elements.
	 *
	 * @class
	 * @extends Definable
	 * @param   {number}     zrId    zrender instance id
	 * @param   {SVGElement} svgRoot root of SVG document
	 */
	function ShadowManager(zrId, svgRoot) {
	  Definable.call(this, zrId, svgRoot, ['filter'], '__filter_in_use__', '_shadowDom');
	}
	
	zrUtil.inherits(ShadowManager, Definable);
	/**
	 * Create new shadow DOM for fill or stroke if not exist,
	 * but will not update shadow if exists.
	 *
	 * @param {SvgElement}  svgElement   SVG element to paint
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	ShadowManager.prototype.addWithoutUpdate = function (svgElement, displayable) {
	  if (displayable && hasShadow(displayable.style)) {
	    // Create dom in <defs> if not exists
	    var dom;
	
	    if (displayable._shadowDom) {
	      // Gradient exists
	      dom = displayable._shadowDom;
	      var defs = this.getDefs(true);
	
	      if (!defs.contains(displayable._shadowDom)) {
	        // _shadowDom is no longer in defs, recreate
	        this.addDom(dom);
	      }
	    } else {
	      // New dom
	      dom = this.add(displayable);
	    }
	
	    this.markUsed(displayable);
	    var id = dom.getAttribute('id');
	    svgElement.style.filter = 'url(#' + id + ')';
	  }
	};
	/**
	 * Add a new shadow tag in <defs>
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 * @return {SVGFilterElement} created DOM
	 */
	
	
	ShadowManager.prototype.add = function (displayable) {
	  var dom = this.createElement('filter'); // Set dom id with shadow id, since each shadow instance
	  // will have no more than one dom element.
	  // id may exists before for those dirty elements, in which case
	  // id should remain the same, and other attributes should be
	  // updated.
	
	  displayable._shadowDomId = displayable._shadowDomId || this.nextId++;
	  dom.setAttribute('id', 'zr' + this._zrId + '-shadow-' + displayable._shadowDomId);
	  this.updateDom(displayable, dom);
	  this.addDom(dom);
	  return dom;
	};
	/**
	 * Update shadow.
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 */
	
	
	ShadowManager.prototype.update = function (svgElement, displayable) {
	  var style = displayable.style;
	
	  if (hasShadow(style)) {
	    var that = this;
	    Definable.prototype.update.call(this, displayable, function () {
	      that.updateDom(displayable, displayable._shadowDom);
	    });
	  } else {
	    // Remove shadow
	    this.remove(svgElement, displayable);
	  }
	};
	/**
	 * Remove DOM and clear parent filter
	 */
	
	
	ShadowManager.prototype.remove = function (svgElement, displayable) {
	  if (displayable._shadowDomId != null) {
	    this.removeDom(svgElement);
	    svgElement.style.filter = '';
	  }
	};
	/**
	 * Update shadow dom
	 *
	 * @param {Displayable} displayable  zrender displayable element
	 * @param {SVGFilterElement} dom DOM to update
	 */
	
	
	ShadowManager.prototype.updateDom = function (displayable, dom) {
	  var domChild = dom.getElementsByTagName('feDropShadow');
	
	  if (domChild.length === 0) {
	    domChild = this.createElement('feDropShadow');
	  } else {
	    domChild = domChild[0];
	  }
	
	  var style = displayable.style;
	  var scaleX = displayable.scale ? displayable.scale[0] || 1 : 1;
	  var scaleY = displayable.scale ? displayable.scale[1] || 1 : 1; // TODO: textBoxShadowBlur is not supported yet
	
	  var offsetX;
	  var offsetY;
	  var blur;
	  var color;
	
	  if (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY) {
	    offsetX = style.shadowOffsetX || 0;
	    offsetY = style.shadowOffsetY || 0;
	    blur = style.shadowBlur;
	    color = style.shadowColor;
	  } else if (style.textShadowBlur) {
	    offsetX = style.textShadowOffsetX || 0;
	    offsetY = style.textShadowOffsetY || 0;
	    blur = style.textShadowBlur;
	    color = style.textShadowColor;
	  } else {
	    // Remove shadow
	    this.removeDom(dom, style);
	    return;
	  }
	
	  domChild.setAttribute('dx', offsetX / scaleX);
	  domChild.setAttribute('dy', offsetY / scaleY);
	  domChild.setAttribute('flood-color', color); // Divide by two here so that it looks the same as in canvas
	  // See: https://html.spec.whatwg.org/multipage/canvas.html#dom-context-2d-shadowblur
	
	  var stdDx = blur / 2 / scaleX;
	  var stdDy = blur / 2 / scaleY;
	  var stdDeviation = stdDx + ' ' + stdDy;
	  domChild.setAttribute('stdDeviation', stdDeviation); // Fix filter clipping problem
	
	  dom.setAttribute('x', '-100%');
	  dom.setAttribute('y', '-100%');
	  dom.setAttribute('width', Math.ceil(blur / 2 * 200) + '%');
	  dom.setAttribute('height', Math.ceil(blur / 2 * 200) + '%');
	  dom.appendChild(domChild); // Store dom element in shadow, to avoid creating multiple
	  // dom instances for the same shadow element
	
	  displayable._shadowDom = dom;
	};
	/**
	 * Mark a single shadow to be used
	 *
	 * @param {Displayable} displayable displayable element
	 */
	
	
	ShadowManager.prototype.markUsed = function (displayable) {
	  if (displayable._shadowDom) {
	    Definable.prototype.markUsed.call(this, displayable._shadowDom);
	  }
	};
	
	function hasShadow(style) {
	  // TODO: textBoxShadowBlur is not supported yet
	  return style && (style.shadowBlur || style.shadowOffsetX || style.shadowOffsetY || style.textShadowBlur || style.textShadowOffsetX || style.textShadowOffsetY);
	}
	
	var _default = ShadowManager;
	module.exports = _default;

/***/ },
/* 2999 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(608);
	
	var _zrender = __webpack_require__(397);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(2995);
	
	registerPainter('svg', Painter);

/***/ },
/* 3000 */
/***/ function(module, exports, __webpack_require__) {

	var PathProxy = __webpack_require__(266);
	
	var _vector = __webpack_require__(55);
	
	var v2ApplyTransform = _vector.applyTransform;
	var CMD = PathProxy.CMD;
	var points = [[], [], []];
	var mathSqrt = Math.sqrt;
	var mathAtan2 = Math.atan2;
	
	function _default(path, m) {
	  var data = path.data;
	  var cmd;
	  var nPoint;
	  var i;
	  var j;
	  var k;
	  var p;
	  var M = CMD.M;
	  var C = CMD.C;
	  var L = CMD.L;
	  var R = CMD.R;
	  var A = CMD.A;
	  var Q = CMD.Q;
	
	  for (i = 0, j = 0; i < data.length;) {
	    cmd = data[i++];
	    j = i;
	    nPoint = 0;
	
	    switch (cmd) {
	      case M:
	        nPoint = 1;
	        break;
	
	      case L:
	        nPoint = 1;
	        break;
	
	      case C:
	        nPoint = 3;
	        break;
	
	      case Q:
	        nPoint = 2;
	        break;
	
	      case A:
	        var x = m[4];
	        var y = m[5];
	        var sx = mathSqrt(m[0] * m[0] + m[1] * m[1]);
	        var sy = mathSqrt(m[2] * m[2] + m[3] * m[3]);
	        var angle = mathAtan2(-m[1] / sy, m[0] / sx); // cx
	
	        data[i] *= sx;
	        data[i++] += x; // cy
	
	        data[i] *= sy;
	        data[i++] += y; // Scale rx and ry
	        // FIXME Assume psi is 0 here
	
	        data[i++] *= sx;
	        data[i++] *= sy; // Start angle
	
	        data[i++] += angle; // end angle
	
	        data[i++] += angle; // FIXME psi
	
	        i += 2;
	        j = i;
	        break;
	
	      case R:
	        // x0, y0
	        p[0] = data[i++];
	        p[1] = data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1]; // x1, y1
	
	        p[0] += data[i++];
	        p[1] += data[i++];
	        v2ApplyTransform(p, p, m);
	        data[j++] = p[0];
	        data[j++] = p[1];
	    }
	
	    for (k = 0; k < nPoint; k++) {
	      var p = points[k];
	      p[0] = data[i++];
	      p[1] = data[i++];
	      v2ApplyTransform(p, p, m); // Write back
	
	      data[j++] = p[0];
	      data[j++] = p[1];
	    }
	  }
	}
	
	module.exports = _default;

/***/ },
/* 3001 */
/***/ function(module, exports, __webpack_require__) {

	var logError = __webpack_require__(315);
	
	var vmlCore = __webpack_require__(1210);
	
	var _util = __webpack_require__(4);
	
	var each = _util.each;
	
	/**
	 * VML Painter.
	 *
	 * @module zrender/vml/Painter
	 */
	function parseInt10(val) {
	  return parseInt(val, 10);
	}
	/**
	 * @alias module:zrender/vml/Painter
	 */
	
	
	function VMLPainter(root, storage) {
	  vmlCore.initVML();
	  this.root = root;
	  this.storage = storage;
	  var vmlViewport = document.createElement('div');
	  var vmlRoot = document.createElement('div');
	  vmlViewport.style.cssText = 'display:inline-block;overflow:hidden;position:relative;width:300px;height:150px;';
	  vmlRoot.style.cssText = 'position:absolute;left:0;top:0;';
	  root.appendChild(vmlViewport);
	  this._vmlRoot = vmlRoot;
	  this._vmlViewport = vmlViewport;
	  this.resize(); // Modify storage
	
	  var oldDelFromStorage = storage.delFromStorage;
	  var oldAddToStorage = storage.addToStorage;
	
	  storage.delFromStorage = function (el) {
	    oldDelFromStorage.call(storage, el);
	
	    if (el) {
	      el.onRemove && el.onRemove(vmlRoot);
	    }
	  };
	
	  storage.addToStorage = function (el) {
	    // Displayable already has a vml node
	    el.onAdd && el.onAdd(vmlRoot);
	    oldAddToStorage.call(storage, el);
	  };
	
	  this._firstPaint = true;
	}
	
	VMLPainter.prototype = {
	  constructor: VMLPainter,
	  getType: function () {
	    return 'vml';
	  },
	
	  /**
	   * @return {HTMLDivElement}
	   */
	  getViewportRoot: function () {
	    return this._vmlViewport;
	  },
	  getViewportRootOffset: function () {
	    var viewportRoot = this.getViewportRoot();
	
	    if (viewportRoot) {
	      return {
	        offsetLeft: viewportRoot.offsetLeft || 0,
	        offsetTop: viewportRoot.offsetTop || 0
	      };
	    }
	  },
	
	  /**
	   * 刷新
	   */
	  refresh: function () {
	    var list = this.storage.getDisplayList(true, true);
	
	    this._paintList(list);
	  },
	  _paintList: function (list) {
	    var vmlRoot = this._vmlRoot;
	
	    for (var i = 0; i < list.length; i++) {
	      var el = list[i];
	
	      if (el.invisible || el.ignore) {
	        if (!el.__alreadyNotVisible) {
	          el.onRemove(vmlRoot);
	        } // Set as already invisible
	
	
	        el.__alreadyNotVisible = true;
	      } else {
	        if (el.__alreadyNotVisible) {
	          el.onAdd(vmlRoot);
	        }
	
	        el.__alreadyNotVisible = false;
	
	        if (el.__dirty) {
	          el.beforeBrush && el.beforeBrush();
	          (el.brushVML || el.brush).call(el, vmlRoot);
	          el.afterBrush && el.afterBrush();
	        }
	      }
	
	      el.__dirty = false;
	    }
	
	    if (this._firstPaint) {
	      // Detached from document at first time
	      // to avoid page refreshing too many times
	      // FIXME 如果每次都先 removeChild 可能会导致一些填充和描边的效果改变
	      this._vmlViewport.appendChild(vmlRoot);
	
	      this._firstPaint = false;
	    }
	  },
	  resize: function (width, height) {
	    var width = width == null ? this._getWidth() : width;
	    var height = height == null ? this._getHeight() : height;
	
	    if (this._width !== width || this._height !== height) {
	      this._width = width;
	      this._height = height;
	      var vmlViewportStyle = this._vmlViewport.style;
	      vmlViewportStyle.width = width + 'px';
	      vmlViewportStyle.height = height + 'px';
	    }
	  },
	  dispose: function () {
	    this.root.innerHTML = '';
	    this._vmlRoot = this._vmlViewport = this.storage = null;
	  },
	  getWidth: function () {
	    return this._width;
	  },
	  getHeight: function () {
	    return this._height;
	  },
	  clear: function () {
	    if (this._vmlViewport) {
	      this.root.removeChild(this._vmlViewport);
	    }
	  },
	  _getWidth: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientWidth || parseInt10(stl.width)) - parseInt10(stl.paddingLeft) - parseInt10(stl.paddingRight) | 0;
	  },
	  _getHeight: function () {
	    var root = this.root;
	    var stl = root.currentStyle;
	    return (root.clientHeight || parseInt10(stl.height)) - parseInt10(stl.paddingTop) - parseInt10(stl.paddingBottom) | 0;
	  }
	}; // Not supported methods
	
	function createMethodNotSupport(method) {
	  return function () {
	    logError('In IE8.0 VML mode painter not support method "' + method + '"');
	  };
	} // Unsupported methods
	
	
	each(['getLayer', 'insertLayer', 'eachLayer', 'eachBuiltinLayer', 'eachOtherLayer', 'getLayers', 'modLayer', 'delLayer', 'clearLayer', 'toDataURL', 'pathToImage'], function (name) {
	  VMLPainter.prototype[name] = createMethodNotSupport(name);
	});
	var _default = VMLPainter;
	module.exports = _default;

/***/ },
/* 3002 */
/***/ function(module, exports, __webpack_require__) {

	var env = __webpack_require__(73);
	
	var _vector = __webpack_require__(55);
	
	var applyTransform = _vector.applyTransform;
	
	var BoundingRect = __webpack_require__(60);
	
	var colorTool = __webpack_require__(148);
	
	var textContain = __webpack_require__(102);
	
	var textHelper = __webpack_require__(395);
	
	var RectText = __webpack_require__(1203);
	
	var Displayable = __webpack_require__(316);
	
	var ZImage = __webpack_require__(267);
	
	var Text = __webpack_require__(224);
	
	var Path = __webpack_require__(67);
	
	var PathProxy = __webpack_require__(266);
	
	var Gradient = __webpack_require__(393);
	
	var vmlCore = __webpack_require__(1210);
	
	// http://www.w3.org/TR/NOTE-VML
	// TODO Use proxy like svg instead of overwrite brush methods
	var CMD = PathProxy.CMD;
	var round = Math.round;
	var sqrt = Math.sqrt;
	var abs = Math.abs;
	var cos = Math.cos;
	var sin = Math.sin;
	var mathMax = Math.max;
	
	if (!env.canvasSupported) {
	  var comma = ',';
	  var imageTransformPrefix = 'progid:DXImageTransform.Microsoft';
	  var Z = 21600;
	  var Z2 = Z / 2;
	  var ZLEVEL_BASE = 100000;
	  var Z_BASE = 1000;
	
	  var initRootElStyle = function (el) {
	    el.style.cssText = 'position:absolute;left:0;top:0;width:1px;height:1px;';
	    el.coordsize = Z + ',' + Z;
	    el.coordorigin = '0,0';
	  };
	
	  var encodeHtmlAttribute = function (s) {
	    return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;');
	  };
	
	  var rgb2Str = function (r, g, b) {
	    return 'rgb(' + [r, g, b].join(',') + ')';
	  };
	
	  var append = function (parent, child) {
	    if (child && parent && child.parentNode !== parent) {
	      parent.appendChild(child);
	    }
	  };
	
	  var remove = function (parent, child) {
	    if (child && parent && child.parentNode === parent) {
	      parent.removeChild(child);
	    }
	  };
	
	  var getZIndex = function (zlevel, z, z2) {
	    // z 的取值范围为 [0, 1000]
	    return (parseFloat(zlevel) || 0) * ZLEVEL_BASE + (parseFloat(z) || 0) * Z_BASE + z2;
	  };
	
	  var parsePercent = textHelper.parsePercent;
	  /***************************************************
	   * PATH
	   **************************************************/
	
	  var setColorAndOpacity = function (el, color, opacity) {
	    var colorArr = colorTool.parse(color);
	    opacity = +opacity;
	
	    if (isNaN(opacity)) {
	      opacity = 1;
	    }
	
	    if (colorArr) {
	      el.color = rgb2Str(colorArr[0], colorArr[1], colorArr[2]);
	      el.opacity = opacity * colorArr[3];
	    }
	  };
	
	  var getColorAndAlpha = function (color) {
	    var colorArr = colorTool.parse(color);
	    return [rgb2Str(colorArr[0], colorArr[1], colorArr[2]), colorArr[3]];
	  };
	
	  var updateFillNode = function (el, style, zrEl) {
	    // TODO pattern
	    var fill = style.fill;
	
	    if (fill != null) {
	      // Modified from excanvas
	      if (fill instanceof Gradient) {
	        var gradientType;
	        var angle = 0;
	        var focus = [0, 0]; // additional offset
	
	        var shift = 0; // scale factor for offset
	
	        var expansion = 1;
	        var rect = zrEl.getBoundingRect();
	        var rectWidth = rect.width;
	        var rectHeight = rect.height;
	
	        if (fill.type === 'linear') {
	          gradientType = 'gradient';
	          var transform = zrEl.transform;
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var p1 = [fill.x2 * rectWidth, fill.y2 * rectHeight];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	            applyTransform(p1, p1, transform);
	          }
	
	          var dx = p1[0] - p0[0];
	          var dy = p1[1] - p0[1];
	          angle = Math.atan2(dx, dy) * 180 / Math.PI; // The angle should be a non-negative number.
	
	          if (angle < 0) {
	            angle += 360;
	          } // Very small angles produce an unexpected result because they are
	          // converted to a scientific notation string.
	
	
	          if (angle < 1e-6) {
	            angle = 0;
	          }
	        } else {
	          gradientType = 'gradientradial';
	          var p0 = [fill.x * rectWidth, fill.y * rectHeight];
	          var transform = zrEl.transform;
	          var scale = zrEl.scale;
	          var width = rectWidth;
	          var height = rectHeight;
	          focus = [// Percent in bounding rect
	          (p0[0] - rect.x) / width, (p0[1] - rect.y) / height];
	
	          if (transform) {
	            applyTransform(p0, p0, transform);
	          }
	
	          width /= scale[0] * Z;
	          height /= scale[1] * Z;
	          var dimension = mathMax(width, height);
	          shift = 2 * 0 / dimension;
	          expansion = 2 * fill.r / dimension - shift;
	        } // We need to sort the color stops in ascending order by offset,
	        // otherwise IE won't interpret it correctly.
	
	
	        var stops = fill.colorStops.slice();
	        stops.sort(function (cs1, cs2) {
	          return cs1.offset - cs2.offset;
	        });
	        var length = stops.length; // Color and alpha list of first and last stop
	
	        var colorAndAlphaList = [];
	        var colors = [];
	
	        for (var i = 0; i < length; i++) {
	          var stop = stops[i];
	          var colorAndAlpha = getColorAndAlpha(stop.color);
	          colors.push(stop.offset * expansion + shift + ' ' + colorAndAlpha[0]);
	
	          if (i === 0 || i === length - 1) {
	            colorAndAlphaList.push(colorAndAlpha);
	          }
	        }
	
	        if (length >= 2) {
	          var color1 = colorAndAlphaList[0][0];
	          var color2 = colorAndAlphaList[1][0];
	          var opacity1 = colorAndAlphaList[0][1] * style.opacity;
	          var opacity2 = colorAndAlphaList[1][1] * style.opacity;
	          el.type = gradientType;
	          el.method = 'none';
	          el.focus = '100%';
	          el.angle = angle;
	          el.color = color1;
	          el.color2 = color2;
	          el.colors = colors.join(','); // When colors attribute is used, the meanings of opacity and o:opacity2
	          // are reversed.
	
	          el.opacity = opacity2; // FIXME g_o_:opacity ?
	
	          el.opacity2 = opacity1;
	        }
	
	        if (gradientType === 'radial') {
	          el.focusposition = focus.join(',');
	        }
	      } else {
	        // FIXME Change from Gradient fill to color fill
	        setColorAndOpacity(el, fill, style.opacity);
	      }
	    }
	  };
	
	  var updateStrokeNode = function (el, style) {
	    // if (style.lineJoin != null) {
	    //     el.joinstyle = style.lineJoin;
	    // }
	    // if (style.miterLimit != null) {
	    //     el.miterlimit = style.miterLimit * Z;
	    // }
	    // if (style.lineCap != null) {
	    //     el.endcap = style.lineCap;
	    // }
	    if (style.lineDash) {
	      el.dashstyle = style.lineDash.join(' ');
	    }
	
	    if (style.stroke != null && !(style.stroke instanceof Gradient)) {
	      setColorAndOpacity(el, style.stroke, style.opacity);
	    }
	  };
	
	  var updateFillAndStroke = function (vmlEl, type, style, zrEl) {
	    var isFill = type === 'fill';
	    var el = vmlEl.getElementsByTagName(type)[0]; // Stroke must have lineWidth
	
	    if (style[type] != null && style[type] !== 'none' && (isFill || !isFill && style.lineWidth)) {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'true'; // FIXME Remove before updating, or set `colors` will throw error
	
	      if (style[type] instanceof Gradient) {
	        remove(vmlEl, el);
	      }
	
	      if (!el) {
	        el = vmlCore.createNode(type);
	      }
	
	      isFill ? updateFillNode(el, style, zrEl) : updateStrokeNode(el, style);
	      append(vmlEl, el);
	    } else {
	      vmlEl[isFill ? 'filled' : 'stroked'] = 'false';
	      remove(vmlEl, el);
	    }
	  };
	
	  var points = [[], [], []];
	
	  var pathDataToString = function (path, m) {
	    var M = CMD.M;
	    var C = CMD.C;
	    var L = CMD.L;
	    var A = CMD.A;
	    var Q = CMD.Q;
	    var str = [];
	    var nPoint;
	    var cmdStr;
	    var cmd;
	    var i;
	    var xi;
	    var yi;
	    var data = path.data;
	    var dataLength = path.len();
	
	    for (i = 0; i < dataLength;) {
	      cmd = data[i++];
	      cmdStr = '';
	      nPoint = 0;
	
	      switch (cmd) {
	        case M:
	          cmdStr = ' m ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case L:
	          cmdStr = ' l ';
	          nPoint = 1;
	          xi = data[i++];
	          yi = data[i++];
	          points[0][0] = xi;
	          points[0][1] = yi;
	          break;
	
	        case Q:
	        case C:
	          cmdStr = ' c ';
	          nPoint = 3;
	          var x1 = data[i++];
	          var y1 = data[i++];
	          var x2 = data[i++];
	          var y2 = data[i++];
	          var x3;
	          var y3;
	
	          if (cmd === Q) {
	            // Convert quadratic to cubic using degree elevation
	            x3 = x2;
	            y3 = y2;
	            x2 = (x2 + 2 * x1) / 3;
	            y2 = (y2 + 2 * y1) / 3;
	            x1 = (xi + 2 * x1) / 3;
	            y1 = (yi + 2 * y1) / 3;
	          } else {
	            x3 = data[i++];
	            y3 = data[i++];
	          }
	
	          points[0][0] = x1;
	          points[0][1] = y1;
	          points[1][0] = x2;
	          points[1][1] = y2;
	          points[2][0] = x3;
	          points[2][1] = y3;
	          xi = x3;
	          yi = y3;
	          break;
	
	        case A:
	          var x = 0;
	          var y = 0;
	          var sx = 1;
	          var sy = 1;
	          var angle = 0;
	
	          if (m) {
	            // Extract SRT from matrix
	            x = m[4];
	            y = m[5];
	            sx = sqrt(m[0] * m[0] + m[1] * m[1]);
	            sy = sqrt(m[2] * m[2] + m[3] * m[3]);
	            angle = Math.atan2(-m[1] / sy, m[0] / sx);
	          }
	
	          var cx = data[i++];
	          var cy = data[i++];
	          var rx = data[i++];
	          var ry = data[i++];
	          var startAngle = data[i++] + angle;
	          var endAngle = data[i++] + startAngle + angle; // FIXME
	          // var psi = data[i++];
	
	          i++;
	          var clockwise = data[i++];
	          var x0 = cx + cos(startAngle) * rx;
	          var y0 = cy + sin(startAngle) * ry;
	          var x1 = cx + cos(endAngle) * rx;
	          var y1 = cy + sin(endAngle) * ry;
	          var type = clockwise ? ' wa ' : ' at ';
	
	          if (Math.abs(x0 - x1) < 1e-4) {
	            // IE won't render arches drawn counter clockwise if x0 == x1.
	            if (Math.abs(endAngle - startAngle) > 1e-2) {
	              // Offset x0 by 1/80 of a pixel. Use something
	              // that can be represented in binary
	              if (clockwise) {
	                x0 += 270 / Z;
	              }
	            } else {
	              // Avoid case draw full circle
	              if (Math.abs(y0 - cy) < 1e-4) {
	                if (clockwise && x0 < cx || !clockwise && x0 > cx) {
	                  y1 -= 270 / Z;
	                } else {
	                  y1 += 270 / Z;
	                }
	              } else if (clockwise && y0 < cy || !clockwise && y0 > cy) {
	                x1 += 270 / Z;
	              } else {
	                x1 -= 270 / Z;
	              }
	            }
	          }
	
	          str.push(type, round(((cx - rx) * sx + x) * Z - Z2), comma, round(((cy - ry) * sy + y) * Z - Z2), comma, round(((cx + rx) * sx + x) * Z - Z2), comma, round(((cy + ry) * sy + y) * Z - Z2), comma, round((x0 * sx + x) * Z - Z2), comma, round((y0 * sy + y) * Z - Z2), comma, round((x1 * sx + x) * Z - Z2), comma, round((y1 * sy + y) * Z - Z2));
	          xi = x1;
	          yi = y1;
	          break;
	
	        case CMD.R:
	          var p0 = points[0];
	          var p1 = points[1]; // x0, y0
	
	          p0[0] = data[i++];
	          p0[1] = data[i++]; // x1, y1
	
	          p1[0] = p0[0] + data[i++];
	          p1[1] = p0[1] + data[i++];
	
	          if (m) {
	            applyTransform(p0, p0, m);
	            applyTransform(p1, p1, m);
	          }
	
	          p0[0] = round(p0[0] * Z - Z2);
	          p1[0] = round(p1[0] * Z - Z2);
	          p0[1] = round(p0[1] * Z - Z2);
	          p1[1] = round(p1[1] * Z - Z2);
	          str.push( // x0, y0
	          ' m ', p0[0], comma, p0[1], // x1, y0
	          ' l ', p1[0], comma, p0[1], // x1, y1
	          ' l ', p1[0], comma, p1[1], // x0, y1
	          ' l ', p0[0], comma, p1[1]);
	          break;
	
	        case CMD.Z:
	          // FIXME Update xi, yi
	          str.push(' x ');
	      }
	
	      if (nPoint > 0) {
	        str.push(cmdStr);
	
	        for (var k = 0; k < nPoint; k++) {
	          var p = points[k];
	          m && applyTransform(p, p, m); // 不 round 会非常慢
	
	          str.push(round(p[0] * Z - Z2), comma, round(p[1] * Z - Z2), k < nPoint - 1 ? comma : '');
	        }
	      }
	    }
	
	    return str.join('');
	  }; // Rewrite the original path method
	
	
	  Path.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      vmlEl = vmlCore.createNode('shape');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    updateFillAndStroke(vmlEl, 'fill', style, this);
	    updateFillAndStroke(vmlEl, 'stroke', style, this);
	    var m = this.transform;
	    var needTransform = m != null;
	    var strokeEl = vmlEl.getElementsByTagName('stroke')[0];
	
	    if (strokeEl) {
	      var lineWidth = style.lineWidth; // Get the line scale.
	      // Determinant of this.m_ means how much the area is enlarged by the
	      // transformation. So its square root can be used as a scale factor
	      // for width.
	
	      if (needTransform && !style.strokeNoScale) {
	        var det = m[0] * m[3] - m[1] * m[2];
	        lineWidth *= sqrt(abs(det));
	      }
	
	      strokeEl.weight = lineWidth + 'px';
	    }
	
	    var path = this.path || (this.path = new PathProxy());
	
	    if (this.__dirtyPath) {
	      path.beginPath();
	      path.subPixelOptimize = false;
	      this.buildPath(path, this.shape);
	      path.toStatic();
	      this.__dirtyPath = false;
	    }
	
	    vmlEl.path = pathDataToString(path, this.transform);
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Path.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this.removeRectText(vmlRoot);
	  };
	
	  Path.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * IMAGE
	   **************************************************/
	
	
	  var isImage = function (img) {
	    // FIXME img instanceof Image 如果 img 是一个字符串的时候，IE8 下会报错
	    return typeof img === 'object' && img.tagName && img.tagName.toUpperCase() === 'IMG'; // return img instanceof Image;
	  }; // Rewrite the original path method
	
	
	  ZImage.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	    var image = style.image; // Image original width, height
	
	    var ow;
	    var oh;
	
	    if (isImage(image)) {
	      var src = image.src;
	
	      if (src === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      } else {
	        var imageRuntimeStyle = image.runtimeStyle;
	        var oldRuntimeWidth = imageRuntimeStyle.width;
	        var oldRuntimeHeight = imageRuntimeStyle.height;
	        imageRuntimeStyle.width = 'auto';
	        imageRuntimeStyle.height = 'auto'; // get the original size
	
	        ow = image.width;
	        oh = image.height; // and remove overides
	
	        imageRuntimeStyle.width = oldRuntimeWidth;
	        imageRuntimeStyle.height = oldRuntimeHeight; // Caching image original width, height and src
	
	        this._imageSrc = src;
	        this._imageWidth = ow;
	        this._imageHeight = oh;
	      }
	
	      image = src;
	    } else {
	      if (image === this._imageSrc) {
	        ow = this._imageWidth;
	        oh = this._imageHeight;
	      }
	    }
	
	    if (!image) {
	      return;
	    }
	
	    var x = style.x || 0;
	    var y = style.y || 0;
	    var dw = style.width;
	    var dh = style.height;
	    var sw = style.sWidth;
	    var sh = style.sHeight;
	    var sx = style.sx || 0;
	    var sy = style.sy || 0;
	    var hasCrop = sw && sh;
	    var vmlEl = this._vmlEl;
	
	    if (!vmlEl) {
	      // FIXME 使用 group 在 left, top 都不是 0 的时候就无法显示了。
	      // vmlEl = vmlCore.createNode('group');
	      vmlEl = vmlCore.doc.createElement('div');
	      initRootElStyle(vmlEl);
	      this._vmlEl = vmlEl;
	    }
	
	    var vmlElStyle = vmlEl.style;
	    var hasRotation = false;
	    var m;
	    var scaleX = 1;
	    var scaleY = 1;
	
	    if (this.transform) {
	      m = this.transform;
	      scaleX = sqrt(m[0] * m[0] + m[1] * m[1]);
	      scaleY = sqrt(m[2] * m[2] + m[3] * m[3]);
	      hasRotation = m[1] || m[2];
	    }
	
	    if (hasRotation) {
	      // If filters are necessary (rotation exists), create them
	      // filters are bog-slow, so only create them if abbsolutely necessary
	      // The following check doesn't account for skews (which don't exist
	      // in the canvas spec (yet) anyway.
	      // From excanvas
	      var p0 = [x, y];
	      var p1 = [x + dw, y];
	      var p2 = [x, y + dh];
	      var p3 = [x + dw, y + dh];
	      applyTransform(p0, p0, m);
	      applyTransform(p1, p1, m);
	      applyTransform(p2, p2, m);
	      applyTransform(p3, p3, m);
	      var maxX = mathMax(p0[0], p1[0], p2[0], p3[0]);
	      var maxY = mathMax(p0[1], p1[1], p2[1], p3[1]);
	      var transformFilter = [];
	      transformFilter.push('M11=', m[0] / scaleX, comma, 'M12=', m[2] / scaleY, comma, 'M21=', m[1] / scaleX, comma, 'M22=', m[3] / scaleY, comma, 'Dx=', round(x * scaleX + m[4]), comma, 'Dy=', round(y * scaleY + m[5]));
	      vmlElStyle.padding = '0 ' + round(maxX) + 'px ' + round(maxY) + 'px 0'; // FIXME DXImageTransform 在 IE11 的兼容模式下不起作用
	
	      vmlElStyle.filter = imageTransformPrefix + '.Matrix(' + transformFilter.join('') + ', SizingMethod=clip)';
	    } else {
	      if (m) {
	        x = x * scaleX + m[4];
	        y = y * scaleY + m[5];
	      }
	
	      vmlElStyle.filter = '';
	      vmlElStyle.left = round(x) + 'px';
	      vmlElStyle.top = round(y) + 'px';
	    }
	
	    var imageEl = this._imageEl;
	    var cropEl = this._cropEl;
	
	    if (!imageEl) {
	      imageEl = vmlCore.doc.createElement('div');
	      this._imageEl = imageEl;
	    }
	
	    var imageELStyle = imageEl.style;
	
	    if (hasCrop) {
	      // Needs know image original width and height
	      if (!(ow && oh)) {
	        var tmpImage = new Image();
	        var self = this;
	
	        tmpImage.onload = function () {
	          tmpImage.onload = null;
	          ow = tmpImage.width;
	          oh = tmpImage.height; // Adjust image width and height to fit the ratio destinationSize / sourceSize
	
	          imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	          imageELStyle.height = round(scaleY * oh * dh / sh) + 'px'; // Caching image original width, height and src
	
	          self._imageWidth = ow;
	          self._imageHeight = oh;
	          self._imageSrc = image;
	        };
	
	        tmpImage.src = image;
	      } else {
	        imageELStyle.width = round(scaleX * ow * dw / sw) + 'px';
	        imageELStyle.height = round(scaleY * oh * dh / sh) + 'px';
	      }
	
	      if (!cropEl) {
	        cropEl = vmlCore.doc.createElement('div');
	        cropEl.style.overflow = 'hidden';
	        this._cropEl = cropEl;
	      }
	
	      var cropElStyle = cropEl.style;
	      cropElStyle.width = round((dw + sx * dw / sw) * scaleX);
	      cropElStyle.height = round((dh + sy * dh / sh) * scaleY);
	      cropElStyle.filter = imageTransformPrefix + '.Matrix(Dx=' + -sx * dw / sw * scaleX + ',Dy=' + -sy * dh / sh * scaleY + ')';
	
	      if (!cropEl.parentNode) {
	        vmlEl.appendChild(cropEl);
	      }
	
	      if (imageEl.parentNode !== cropEl) {
	        cropEl.appendChild(imageEl);
	      }
	    } else {
	      imageELStyle.width = round(scaleX * dw) + 'px';
	      imageELStyle.height = round(scaleY * dh) + 'px';
	      vmlEl.appendChild(imageEl);
	
	      if (cropEl && cropEl.parentNode) {
	        vmlEl.removeChild(cropEl);
	        this._cropEl = null;
	      }
	    }
	
	    var filterStr = '';
	    var alpha = style.opacity;
	
	    if (alpha < 1) {
	      filterStr += '.Alpha(opacity=' + round(alpha * 100) + ') ';
	    }
	
	    filterStr += imageTransformPrefix + '.AlphaImageLoader(src=' + image + ', SizingMethod=scale)';
	    imageELStyle.filter = filterStr;
	    vmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Append to root
	
	    append(vmlRoot, vmlEl); // Text
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, this.getBoundingRect());
	    }
	  };
	
	  ZImage.prototype.onRemove = function (vmlRoot) {
	    remove(vmlRoot, this._vmlEl);
	    this._vmlEl = null;
	    this._cropEl = null;
	    this._imageEl = null;
	    this.removeRectText(vmlRoot);
	  };
	
	  ZImage.prototype.onAdd = function (vmlRoot) {
	    append(vmlRoot, this._vmlEl);
	    this.appendRectText(vmlRoot);
	  };
	  /***************************************************
	   * TEXT
	   **************************************************/
	
	
	  var DEFAULT_STYLE_NORMAL = 'normal';
	  var fontStyleCache = {};
	  var fontStyleCacheCount = 0;
	  var MAX_FONT_CACHE_SIZE = 100;
	  var fontEl = document.createElement('div');
	
	  var getFontStyle = function (fontString) {
	    var fontStyle = fontStyleCache[fontString];
	
	    if (!fontStyle) {
	      // Clear cache
	      if (fontStyleCacheCount > MAX_FONT_CACHE_SIZE) {
	        fontStyleCacheCount = 0;
	        fontStyleCache = {};
	      }
	
	      var style = fontEl.style;
	      var fontFamily;
	
	      try {
	        style.font = fontString;
	        fontFamily = style.fontFamily.split(',')[0];
	      } catch (e) {}
	
	      fontStyle = {
	        style: style.fontStyle || DEFAULT_STYLE_NORMAL,
	        variant: style.fontVariant || DEFAULT_STYLE_NORMAL,
	        weight: style.fontWeight || DEFAULT_STYLE_NORMAL,
	        size: parseFloat(style.fontSize || 12) | 0,
	        family: fontFamily || 'Microsoft YaHei'
	      };
	      fontStyleCache[fontString] = fontStyle;
	      fontStyleCacheCount++;
	    }
	
	    return fontStyle;
	  };
	
	  var textMeasureEl; // Overwrite measure text method
	
	  textContain.$override('measureText', function (text, textFont) {
	    var doc = vmlCore.doc;
	
	    if (!textMeasureEl) {
	      textMeasureEl = doc.createElement('div');
	      textMeasureEl.style.cssText = 'position:absolute;top:-20000px;left:0;' + 'padding:0;margin:0;border:none;white-space:pre;';
	      vmlCore.doc.body.appendChild(textMeasureEl);
	    }
	
	    try {
	      textMeasureEl.style.font = textFont;
	    } catch (ex) {// Ignore failures to set to invalid font.
	    }
	
	    textMeasureEl.innerHTML = ''; // Don't use innerHTML or innerText because they allow markup/whitespace.
	
	    textMeasureEl.appendChild(doc.createTextNode(text));
	    return {
	      width: textMeasureEl.offsetWidth
	    };
	  });
	  var tmpRect = new BoundingRect();
	
	  var drawRectText = function (vmlRoot, rect, textRect, fromTextEl) {
	    var style = this.style; // Optimize, avoid normalize every time.
	
	    this.__dirty && textHelper.normalizeTextStyle(style, true);
	    var text = style.text; // Convert to string
	
	    text != null && (text += '');
	
	    if (!text) {
	      return;
	    } // Convert rich text to plain text. Rich text is not supported in
	    // IE8-, but tags in rich text template will be removed.
	
	
	    if (style.rich) {
	      var contentBlock = textContain.parseRichText(text, style);
	      text = [];
	
	      for (var i = 0; i < contentBlock.lines.length; i++) {
	        var tokens = contentBlock.lines[i].tokens;
	        var textLine = [];
	
	        for (var j = 0; j < tokens.length; j++) {
	          textLine.push(tokens[j].text);
	        }
	
	        text.push(textLine.join(''));
	      }
	
	      text = text.join('\n');
	    }
	
	    var x;
	    var y;
	    var align = style.textAlign;
	    var verticalAlign = style.textVerticalAlign;
	    var fontStyle = getFontStyle(style.font); // FIXME encodeHtmlAttribute ?
	
	    var font = fontStyle.style + ' ' + fontStyle.variant + ' ' + fontStyle.weight + ' ' + fontStyle.size + 'px "' + fontStyle.family + '"';
	    textRect = textRect || textContain.getBoundingRect(text, font, align, verticalAlign, style.textPadding, style.textLineHeight); // Transform rect to view space
	
	    var m = this.transform; // Ignore transform for text in other element
	
	    if (m && !fromTextEl) {
	      tmpRect.copy(rect);
	      tmpRect.applyTransform(m);
	      rect = tmpRect;
	    }
	
	    if (!fromTextEl) {
	      var textPosition = style.textPosition; // Text position represented by coord
	
	      if (textPosition instanceof Array) {
	        x = rect.x + parsePercent(textPosition[0], rect.width);
	        y = rect.y + parsePercent(textPosition[1], rect.height);
	        align = align || 'left';
	      } else {
	        var res = this.calculateTextPosition ? this.calculateTextPosition({}, style, rect) : textContain.calculateTextPosition({}, style, rect);
	        x = res.x;
	        y = res.y; // Default align and baseline when has textPosition
	
	        align = align || res.textAlign;
	        verticalAlign = verticalAlign || res.textVerticalAlign;
	      }
	    } else {
	      x = rect.x;
	      y = rect.y;
	    }
	
	    x = textContain.adjustTextX(x, textRect.width, align);
	    y = textContain.adjustTextY(y, textRect.height, verticalAlign); // Force baseline 'middle'
	
	    y += textRect.height / 2; // var fontSize = fontStyle.size;
	    // 1.75 is an arbitrary number, as there is no info about the text baseline
	    // switch (baseline) {
	    // case 'hanging':
	    // case 'top':
	    //     y += fontSize / 1.75;
	    //     break;
	    //     case 'middle':
	    //         break;
	    //     default:
	    //     // case null:
	    //     // case 'alphabetic':
	    //     // case 'ideographic':
	    //     // case 'bottom':
	    //         y -= fontSize / 2.25;
	    //         break;
	    // }
	    // switch (align) {
	    //     case 'left':
	    //         break;
	    //     case 'center':
	    //         x -= textRect.width / 2;
	    //         break;
	    //     case 'right':
	    //         x -= textRect.width;
	    //         break;
	    // case 'end':
	    // align = elementStyle.direction == 'ltr' ? 'right' : 'left';
	    // break;
	    // case 'start':
	    // align = elementStyle.direction == 'rtl' ? 'right' : 'left';
	    // break;
	    // default:
	    //     align = 'left';
	    // }
	
	    var createNode = vmlCore.createNode;
	    var textVmlEl = this._textVmlEl;
	    var pathEl;
	    var textPathEl;
	    var skewEl;
	
	    if (!textVmlEl) {
	      textVmlEl = createNode('line');
	      pathEl = createNode('path');
	      textPathEl = createNode('textpath');
	      skewEl = createNode('skew'); // FIXME Why here is not cammel case
	      // Align 'center' seems wrong
	
	      textPathEl.style['v-text-align'] = 'left';
	      initRootElStyle(textVmlEl);
	      pathEl.textpathok = true;
	      textPathEl.on = true;
	      textVmlEl.from = '0 0';
	      textVmlEl.to = '1000 0.05';
	      append(textVmlEl, skewEl);
	      append(textVmlEl, pathEl);
	      append(textVmlEl, textPathEl);
	      this._textVmlEl = textVmlEl;
	    } else {
	      // 这里是在前面 appendChild 保证顺序的前提下
	      skewEl = textVmlEl.firstChild;
	      pathEl = skewEl.nextSibling;
	      textPathEl = pathEl.nextSibling;
	    }
	
	    var coords = [x, y];
	    var textVmlElStyle = textVmlEl.style; // Ignore transform for text in other element
	
	    if (m && fromTextEl) {
	      applyTransform(coords, coords, m);
	      skewEl.on = true;
	      skewEl.matrix = m[0].toFixed(3) + comma + m[2].toFixed(3) + comma + m[1].toFixed(3) + comma + m[3].toFixed(3) + ',0,0'; // Text position
	
	      skewEl.offset = (round(coords[0]) || 0) + ',' + (round(coords[1]) || 0); // Left top point as origin
	
	      skewEl.origin = '0 0';
	      textVmlElStyle.left = '0px';
	      textVmlElStyle.top = '0px';
	    } else {
	      skewEl.on = false;
	      textVmlElStyle.left = round(x) + 'px';
	      textVmlElStyle.top = round(y) + 'px';
	    }
	
	    textPathEl.string = encodeHtmlAttribute(text); // TODO
	
	    try {
	      textPathEl.style.font = font;
	    } // Error font format
	    catch (e) {}
	
	    updateFillAndStroke(textVmlEl, 'fill', {
	      fill: style.textFill,
	      opacity: style.opacity
	    }, this);
	    updateFillAndStroke(textVmlEl, 'stroke', {
	      stroke: style.textStroke,
	      opacity: style.opacity,
	      lineDash: style.lineDash || null // style.lineDash can be `false`.
	
	    }, this);
	    textVmlEl.style.zIndex = getZIndex(this.zlevel, this.z, this.z2); // Attached to root
	
	    append(vmlRoot, textVmlEl);
	  };
	
	  var removeRectText = function (vmlRoot) {
	    remove(vmlRoot, this._textVmlEl);
	    this._textVmlEl = null;
	  };
	
	  var appendRectText = function (vmlRoot) {
	    append(vmlRoot, this._textVmlEl);
	  };
	
	  var list = [RectText, Displayable, ZImage, Path, Text]; // In case Displayable has been mixed in RectText
	
	  for (var i = 0; i < list.length; i++) {
	    var proto = list[i].prototype;
	    proto.drawRectText = drawRectText;
	    proto.removeRectText = removeRectText;
	    proto.appendRectText = appendRectText;
	  }
	
	  Text.prototype.brushVML = function (vmlRoot) {
	    var style = this.style;
	
	    if (style.text != null) {
	      this.drawRectText(vmlRoot, {
	        x: style.x || 0,
	        y: style.y || 0,
	        width: 0,
	        height: 0
	      }, this.getBoundingRect(), true);
	    } else {
	      this.removeRectText(vmlRoot);
	    }
	  };
	
	  Text.prototype.onRemove = function (vmlRoot) {
	    this.removeRectText(vmlRoot);
	  };
	
	  Text.prototype.onAdd = function (vmlRoot) {
	    this.appendRectText(vmlRoot);
	  };
	}

/***/ },
/* 3003 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(3002);
	
	var _zrender = __webpack_require__(397);
	
	var registerPainter = _zrender.registerPainter;
	
	var Painter = __webpack_require__(3001);
	
	registerPainter('vml', Painter);

/***/ },
/* 3004 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 3005 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var toLength = __webpack_require__(__webpack_module_template_argument_1__);
	var toAbsoluteIndex = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 3006 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	var TAG = __webpack_require__(__webpack_module_template_argument_1__)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 3007 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $defineProperty = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 3008 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 3009 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(__webpack_module_template_argument_0__)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 3010 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var document = __webpack_require__(__webpack_module_template_argument_1__).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 3011 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_1__);
	var pIE = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 3012 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = __webpack_require__(__webpack_module_template_argument_2__) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 3013 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var document = __webpack_require__(__webpack_module_template_argument_0__).document;
	module.exports = document && document.documentElement;


/***/ },
/* 3014 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	module.exports = !__webpack_require__(__webpack_module_template_argument_0__) && !__webpack_require__(__webpack_module_template_argument_1__)(function () {
	  return Object.defineProperty(__webpack_require__(__webpack_module_template_argument_2__)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 3015 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 3016 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 3017 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 3018 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 20.1.2.3 Number.isInteger(number)
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var floor = Math.floor;
	module.exports = function isInteger(it) {
	  return !isObject(it) && isFinite(it) && floor(it) === it;
	};


/***/ },
/* 3019 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 3020 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var create = __webpack_require__(__webpack_module_template_argument_0__);
	var descriptor = __webpack_require__(__webpack_module_template_argument_1__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_2__);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_3__)(IteratorPrototype, __webpack_require__(__webpack_module_template_argument_4__)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 3021 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var redefine = __webpack_require__(__webpack_module_template_argument_2__);
	var hide = __webpack_require__(__webpack_module_template_argument_3__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_4__);
	var $iterCreate = __webpack_require__(__webpack_module_template_argument_5__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_6__);
	var getPrototypeOf = __webpack_require__(__webpack_module_template_argument_7__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_8__)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 3022 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var ITERATOR = __webpack_require__(__webpack_module_template_argument_0__)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 3023 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var META = __webpack_require__(__webpack_module_template_argument_0__)('meta');
	var isObject = __webpack_require__(__webpack_module_template_argument_1__);
	var has = __webpack_require__(__webpack_module_template_argument_2__);
	var setDesc = __webpack_require__(__webpack_module_template_argument_3__).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(__webpack_module_template_argument_4__)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 3024 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_0__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_1__);
	var gOPS = __webpack_require__(__webpack_module_template_argument_2__);
	var pIE = __webpack_require__(__webpack_module_template_argument_3__);
	var toObject = __webpack_require__(__webpack_module_template_argument_4__);
	var IObject = __webpack_require__(__webpack_module_template_argument_5__);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(__webpack_module_template_argument_6__)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;


/***/ },
/* 3025 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var dPs = __webpack_require__(__webpack_module_template_argument_1__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_2__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(__webpack_module_template_argument_4__)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(__webpack_module_template_argument_5__).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 3026 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var anObject = __webpack_require__(__webpack_module_template_argument_0__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_1__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_2__);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 3027 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var dP = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var getKeys = __webpack_require__(__webpack_module_template_argument_2__);
	
	module.exports = __webpack_require__(__webpack_module_template_argument_3__) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 3028 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__) {

	var pIE = __webpack_require__(__webpack_module_template_argument_0__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_1__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_2__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_3__);
	var has = __webpack_require__(__webpack_module_template_argument_4__);
	var IE8_DOM_DEFINE = __webpack_require__(__webpack_module_template_argument_5__);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(__webpack_module_template_argument_6__) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 3029 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var gOPN = __webpack_require__(__webpack_module_template_argument_1__).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 3030 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var hiddenKeys = __webpack_require__(__webpack_module_template_argument_1__).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 3031 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toObject = __webpack_require__(__webpack_module_template_argument_1__);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_2__)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 3032 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var has = __webpack_require__(__webpack_module_template_argument_0__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_1__);
	var arrayIndexOf = __webpack_require__(__webpack_module_template_argument_2__)(false);
	var IE_PROTO = __webpack_require__(__webpack_module_template_argument_3__)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 3033 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(__webpack_module_template_argument_0__);
	var enumBugKeys = __webpack_require__(__webpack_module_template_argument_1__);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 3034 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var fails = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 3035 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	var anObject = __webpack_require__(__webpack_module_template_argument_1__);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(__webpack_module_template_argument_2__)(Function.call, __webpack_require__(__webpack_module_template_argument_3__).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 3036 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var def = __webpack_require__(__webpack_module_template_argument_0__).f;
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var TAG = __webpack_require__(__webpack_module_template_argument_2__)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 3037 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var shared = __webpack_require__(__webpack_module_template_argument_0__)('keys');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 3038 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var core = __webpack_require__(__webpack_module_template_argument_0__);
	var global = __webpack_require__(__webpack_module_template_argument_1__);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	
	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: core.version,
	  mode: __webpack_require__(__webpack_module_template_argument_2__) ? 'pure' : 'global',
	  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
	});


/***/ },
/* 3039 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 3040 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 3041 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(__webpack_module_template_argument_0__);
	var defined = __webpack_require__(__webpack_module_template_argument_1__);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 3042 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(__webpack_module_template_argument_0__);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 3043 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(__webpack_module_template_argument_0__);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 3044 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(__webpack_module_template_argument_0__);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 3045 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var core = __webpack_require__(__webpack_module_template_argument_1__);
	var LIBRARY = __webpack_require__(__webpack_module_template_argument_2__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_3__);
	var defineProperty = __webpack_require__(__webpack_module_template_argument_4__).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 3046 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	exports.f = __webpack_require__(__webpack_module_template_argument_0__);


/***/ },
/* 3047 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var store = __webpack_require__(__webpack_module_template_argument_0__)('wks');
	var uid = __webpack_require__(__webpack_module_template_argument_1__);
	var Symbol = __webpack_require__(__webpack_module_template_argument_2__).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 3048 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__) {

	var classof = __webpack_require__(__webpack_module_template_argument_0__);
	var ITERATOR = __webpack_require__(__webpack_module_template_argument_1__)('iterator');
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	module.exports = __webpack_require__(__webpack_module_template_argument_3__).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 3049 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__) {

	'use strict';
	var ctx = __webpack_require__(__webpack_module_template_argument_0__);
	var $export = __webpack_require__(__webpack_module_template_argument_1__);
	var toObject = __webpack_require__(__webpack_module_template_argument_2__);
	var call = __webpack_require__(__webpack_module_template_argument_3__);
	var isArrayIter = __webpack_require__(__webpack_module_template_argument_4__);
	var toLength = __webpack_require__(__webpack_module_template_argument_5__);
	var createProperty = __webpack_require__(__webpack_module_template_argument_6__);
	var getIterFn = __webpack_require__(__webpack_module_template_argument_7__);
	
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_8__)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 3050 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__) {

	'use strict';
	var addToUnscopables = __webpack_require__(__webpack_module_template_argument_0__);
	var step = __webpack_require__(__webpack_module_template_argument_1__);
	var Iterators = __webpack_require__(__webpack_module_template_argument_2__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_3__);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(__webpack_module_template_argument_4__)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 3051 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 20.1.2.5 Number.isSafeInteger(number)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	var isInteger = __webpack_require__(__webpack_module_template_argument_1__);
	var abs = Math.abs;
	
	$export($export.S, 'Number', {
	  isSafeInteger: function isSafeInteger(number) {
	    return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	  }
	});


/***/ },
/* 3052 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 3053 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(__webpack_module_template_argument_1__) });


/***/ },
/* 3054 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(__webpack_module_template_argument_1__), 'Object', { defineProperty: __webpack_require__(__webpack_module_template_argument_2__).f });


/***/ },
/* 3055 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	var toIObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getOwnPropertyDescriptor = __webpack_require__(__webpack_module_template_argument_1__).f;
	
	__webpack_require__(__webpack_module_template_argument_2__)('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(toIObject(it), key);
	  };
	});


/***/ },
/* 3056 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.2.7 Object.getOwnPropertyNames(O)
	__webpack_require__(__webpack_module_template_argument_0__)('getOwnPropertyNames', function () {
	  return __webpack_require__(__webpack_module_template_argument_1__).f;
	});


/***/ },
/* 3057 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $getPrototypeOf = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 3058 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(__webpack_module_template_argument_0__);
	var $keys = __webpack_require__(__webpack_module_template_argument_1__);
	
	__webpack_require__(__webpack_module_template_argument_2__)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 3059 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(__webpack_module_template_argument_0__);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(__webpack_module_template_argument_1__).set });


/***/ },
/* 3060 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__) {

	'use strict';
	var $at = __webpack_require__(__webpack_module_template_argument_0__)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(__webpack_module_template_argument_1__)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 3061 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__, __webpack_module_template_argument_1__, __webpack_module_template_argument_2__, __webpack_module_template_argument_3__, __webpack_module_template_argument_4__, __webpack_module_template_argument_5__, __webpack_module_template_argument_6__, __webpack_module_template_argument_7__, __webpack_module_template_argument_8__, __webpack_module_template_argument_9__, __webpack_module_template_argument_10__, __webpack_module_template_argument_11__, __webpack_module_template_argument_12__, __webpack_module_template_argument_13__, __webpack_module_template_argument_14__, __webpack_module_template_argument_15__, __webpack_module_template_argument_16__, __webpack_module_template_argument_17__, __webpack_module_template_argument_18__, __webpack_module_template_argument_19__, __webpack_module_template_argument_20__, __webpack_module_template_argument_21__, __webpack_module_template_argument_22__, __webpack_module_template_argument_23__, __webpack_module_template_argument_24__, __webpack_module_template_argument_25__, __webpack_module_template_argument_26__, __webpack_module_template_argument_27__, __webpack_module_template_argument_28__, __webpack_module_template_argument_29__, __webpack_module_template_argument_30__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(__webpack_module_template_argument_0__);
	var has = __webpack_require__(__webpack_module_template_argument_1__);
	var DESCRIPTORS = __webpack_require__(__webpack_module_template_argument_2__);
	var $export = __webpack_require__(__webpack_module_template_argument_3__);
	var redefine = __webpack_require__(__webpack_module_template_argument_4__);
	var META = __webpack_require__(__webpack_module_template_argument_5__).KEY;
	var $fails = __webpack_require__(__webpack_module_template_argument_6__);
	var shared = __webpack_require__(__webpack_module_template_argument_7__);
	var setToStringTag = __webpack_require__(__webpack_module_template_argument_8__);
	var uid = __webpack_require__(__webpack_module_template_argument_9__);
	var wks = __webpack_require__(__webpack_module_template_argument_10__);
	var wksExt = __webpack_require__(__webpack_module_template_argument_11__);
	var wksDefine = __webpack_require__(__webpack_module_template_argument_12__);
	var enumKeys = __webpack_require__(__webpack_module_template_argument_13__);
	var isArray = __webpack_require__(__webpack_module_template_argument_14__);
	var anObject = __webpack_require__(__webpack_module_template_argument_15__);
	var isObject = __webpack_require__(__webpack_module_template_argument_16__);
	var toObject = __webpack_require__(__webpack_module_template_argument_17__);
	var toIObject = __webpack_require__(__webpack_module_template_argument_18__);
	var toPrimitive = __webpack_require__(__webpack_module_template_argument_19__);
	var createDesc = __webpack_require__(__webpack_module_template_argument_20__);
	var _create = __webpack_require__(__webpack_module_template_argument_21__);
	var gOPNExt = __webpack_require__(__webpack_module_template_argument_22__);
	var $GOPD = __webpack_require__(__webpack_module_template_argument_23__);
	var $GOPS = __webpack_require__(__webpack_module_template_argument_24__);
	var $DP = __webpack_require__(__webpack_module_template_argument_25__);
	var $keys = __webpack_require__(__webpack_module_template_argument_26__);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(__webpack_module_template_argument_27__).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(__webpack_module_template_argument_28__).f = $propertyIsEnumerable;
	  $GOPS.f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(__webpack_module_template_argument_29__)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });
	
	$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return $GOPS.f(toObject(it));
	  }
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(__webpack_module_template_argument_30__)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 3062 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('asyncIterator');


/***/ },
/* 3063 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	__webpack_require__(__webpack_module_template_argument_0__)('observable');


/***/ },
/* 3064 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(18);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.0fc41aa7.js